webpackJsonp([39],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4291);
	__webpack_require__(2888);
	module.exports = __webpack_require__(3916);


/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(5697)();
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 4 */
[6813, 571],
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function defineMessages(msgs) {
	    return msgs;
	}
	exports.defineMessages = defineMessages;
	var createFormattedComponent_1 = __webpack_require__(2789);
	var injectIntl_1 = __webpack_require__(383);
	exports.injectIntl = injectIntl_1.default;
	exports.RawIntlProvider = injectIntl_1.Provider;
	exports.IntlContext = injectIntl_1.Context;
	var useIntl_1 = __webpack_require__(6218);
	exports.useIntl = useIntl_1.default;
	var provider_1 = __webpack_require__(6216);
	exports.IntlProvider = provider_1.default;
	exports.createIntl = provider_1.createIntl;
	// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./types').CustomFormatConfig`
	exports.FormattedDate = createFormattedComponent_1.createFormattedComponent('formatDate');
	exports.FormattedTime = createFormattedComponent_1.createFormattedComponent('formatTime');
	exports.FormattedNumber = createFormattedComponent_1.createFormattedComponent('formatNumber');
	exports.FormattedList = createFormattedComponent_1.createFormattedComponent('formatList');
	exports.FormattedDisplayName = createFormattedComponent_1.createFormattedComponent('formatDisplayName');
	exports.FormattedDateParts = createFormattedComponent_1.createFormattedDateTimePartsComponent('formatDate');
	exports.FormattedTimeParts = createFormattedComponent_1.createFormattedDateTimePartsComponent('formatTime');
	var createFormattedComponent_2 = __webpack_require__(2789);
	exports.FormattedNumberParts = createFormattedComponent_2.FormattedNumberParts;
	var relative_1 = __webpack_require__(6217);
	exports.FormattedRelativeTime = relative_1.default;
	var plural_1 = __webpack_require__(6215);
	exports.FormattedPlural = plural_1.default;
	var message_1 = __webpack_require__(2790);
	exports.FormattedMessage = message_1.default;
	var html_message_1 = __webpack_require__(6214);
	exports.FormattedHTMLMessage = html_message_1.default;
	var utils_1 = __webpack_require__(180);
	exports.createIntlCache = utils_1.createIntlCache;


/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makePaginationReducer = exports.initialState = exports.locationReducer = exports.createReqWatcher = exports.createReqReducer = exports.createReducer = exports.createReqConsts = exports.createConsts = exports.createActions = undefined;
	
	var _actions = __webpack_require__(1933);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _reqConsts = __webpack_require__(4230);
	
	var _reqConsts2 = _interopRequireDefault(_reqConsts);
	
	var _reducer = __webpack_require__(1934);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reqReducer = __webpack_require__(1390);
	
	var _reqReducer2 = _interopRequireDefault(_reqReducer);
	
	var _reqWatcher = __webpack_require__(4231);
	
	var _reqWatcher2 = _interopRequireDefault(_reqWatcher);
	
	var _locationReducer = __webpack_require__(240);
	
	var _locationReducer2 = _interopRequireDefault(_locationReducer);
	
	var _makePaginationReducer = __webpack_require__(4228);
	
	var _makePaginationReducer2 = _interopRequireDefault(_makePaginationReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createActions = _actions2.default;
	exports.createConsts = _consts2.default;
	exports.createReqConsts = _reqConsts2.default;
	exports.createReducer = _reducer2.default;
	exports.createReqReducer = _reqReducer2.default;
	exports.createReqWatcher = _reqWatcher2.default;
	exports.locationReducer = _locationReducer2.default;
	exports.initialState = _reqReducer.initialState;
	exports.makePaginationReducer = _makePaginationReducer2.default;

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(551);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(4293);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(1395);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4303);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(5000);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint react/require-default-props: 0 */
	var Icon = function Icon(_ref) {
	  var name = _ref.name,
	      size = _ref.size,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 16 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 16 : _ref$width,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['name', 'size', 'height', 'width']);
	
	  // hack for cases when icon shoud be dynamic
	  // e.g. chat tabs icons
	  var useTag = '<use xlink:href="#icon-' + name + '" />';
	
	  return _react2.default.createElement('svg', (0, _extends3.default)({
	    height: size || height,
	    styleName: 'root',
	    width: size || width
	  }, other, {
	    dangerouslySetInnerHTML: { __html: useTag },
	    focusable: 'false'
	  }));
	};
	
	Icon.propTypes = {
	  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  name: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	exports.default = (0, _reactCssModules2.default)(Icon, _index2.default, { allowMultiple: true });

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var effects = __webpack_require__(1667);
	
	
	
	Object.keys(effects).forEach(function (key) { exports[key] = effects[key]; });


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_EMPTY_VALUE = exports.SUCCESS_SENT_DOCUMENT_TO_EMAIL = exports.TODO_ASSIGNMENT_TITLE = exports.SURVEYS_ASSIGNMENT_DESC = exports.SURVEYS_ASSIGNMENT_TITLE = exports.SUCCESS_JOIN_CIRCLE = exports.DIALOG_TITLE = exports.COMMUNITIES_COMMON = exports.COMMUNITY_AUTHOR_ROLE = exports.COMMUNITY_COMMENTS = exports.COMMUNITY_COMMENT_MENU = exports.COMMUNITY_POST_MENU = exports.COMMUNUNNITY_NEW_POST = exports.COMMUNITY_TYPE_STRINGS = exports.USER_STATUSES = exports.INTRO = exports.SCREEN_TITLES = exports.PROFILE_FIELDS = exports.GENERAL_SURVEYS = exports.CHAT = exports.PREVIEWABLE_BLOCK = exports.COMMON_ERROR_MESSAGES = exports.LEAVE_PROVIDER_CIRCLE_STRINGS = exports.LEAVE_FAMILY_CIRCLE_STRINGS = exports.MESSAGES = exports.VALIDATION_ERRORS = exports.CIRCLES = exports.PENDING_INVITATIONS = exports.CIRCLE_INVITE = exports.TEAM_PROFILE = exports.CIRCLE_DEPENDENTS = exports.CIRCLE_CAREGIVER = exports.CIRCLE_PROVIDER = exports.CIRCLE_FAMILY = exports.PROVIDER_PROFILE = exports.PATIENT_PROFILE = exports.ADD_PROVIDER_REASON_CODE = exports.ADD_PROVIDER_OPTION = exports.PARENT_OPTIONS = exports.FAMILY_MEMBERS_OPTIONS = exports.PASS_STRENGTH = exports.MAKE_INVITE_CAREGIVER_TEXT = exports.MAKE_INVITE_TO_PROVIDER_TEXT = exports.MAKE_INVITE_TO_FAMILY_TEXT = exports.MAKE_IBVITE_CAREGIVER = exports.INVITE_TEXT = exports.INVITE_MEMBER = exports.PROFILE = exports.AUTH = exports.PROGRAMS = exports.ACTIONS = exports.COMMON = exports.SUCCESS_LEAVE_FAMILY = exports.SUCCESS_REMOVE_FAMILY_MEMBER = exports.SUCCESS_LEAVE_PROVIDER_CIRCLE = exports.SUCCESS_REMOVE_PROVIDER = exports.DECLINE_CAREGIVER_INVITATION = exports.ACCEPT_CAREGIVER_INVITATION = exports.DECLINE_FAMILY_INVITATION = exports.ACCEPT_FAMILY_INVITATION = exports.ERROR_ASSIGN_CAREGIVER = exports.SUCCESS_INVITE_PROVIDER = exports.SUCCESS_INVITE_CAREGIVER = exports.SUCCESS_INVITE_FAMILY = undefined;
	exports.INVITED_CAREGIVER = exports.INVITE_SENT = exports.DECLINE_CANCEL = exports.CONFIRM_CANCEL = exports.CANCEL_INVITATION = exports.CANCEL_CAREGIVER_INVITE = exports.CANCEL_INVITE = exports.TITLE = exports.MESSAGES_NOT_JOINED = exports.MESSAGES_STATUS_FILTER_OPTIONS = exports.MESSAGES_FILTER_OPTIONS = exports.MENU = exports.NEW_CHAT = exports.ROLE_ADMIN = exports.REPORT = exports.SUCCESS_PAYMENT_METHOD_REMOVED = exports.POST_REPLY_PLACEHOLDER = exports.POST_REPLY_DESCRIPTION = exports.POST_REPLIES = exports.POST_COMMENT_DESCRIPTION = exports.POST_COMMENTS_ADD = exports.POST_COMMENTS = exports.POST_BACK = exports.POST_TITLE = exports.COMMUNITY_ACTIVITY_DECLINED_REQUEST = exports.COMMUNITY_ACTIVITY_ACCEPTED_REQUEST = exports.COMMUNITY_ACTIVITY_REQUEST = exports.COMMUNITY_ACTIVITY_COMMENTS = exports.COMMUNITY_ACTIVITY_POSTS = exports.COMMUNITY_ACTIVITY = exports.COMMUNITY_COMMENT_UPDATED = exports.COMMUNITY_POST_UPDATED = exports.COMMUNITY_MODERATORS_LIST = exports.COMMUNITY_MEMBERS_LIST = exports.COMMUNITY_MEMBERS = exports.COMMUNITY_POSTS_EMPTY_SUB = exports.COMMUNITY_POSTS_PRIVATE = exports.COMMUNITY_POSTS_EMPTY = exports.COMMUNITY_POSTS = exports.COMMUNITY_DESCRIPTION = exports.COMMUNITY_EMPTY = exports.COMMUNITY_ACCESS_READ_ONLY = exports.COMMUNITY_TYPE_PRIVATE = exports.COMMUNITY_TYPE_PUBLIC = exports.COMMUNITIES_TITLE_MODERATOR = exports.COMMUNITIES_TITLE_MEMBER = exports.COMMUNITIES_EMPTY_ACTIVITIES = exports.COMMUNITIES_EMPTY = exports.COMMUNITIES_EMPTY_NAVIGATION = exports.USERNAME_EXPLANATION = exports.USERNAME_EXAMPLE = exports.MEMBER_PROVIDER_CIRCLE = exports.MAIN_CARE_PROVIDER = exports.TOGGLE_TNC = exports.CARE_PROVIDER = exports.CARE_PROVIDERS_TITLE = exports.PROGRAM_PROVIDERS_TITLE = exports.FAMILY_TITLE = exports.CIRCLES_EMPTY_NAVIGATION = exports.CIRCLES_EMPTY = exports.PROFILE_STR = exports.MY_PROFILE = exports.YO = exports.OFFLINE_MESSAGE = exports.YOU = exports.SEARCH_SIDEBAR_USER = exports.SEARCH_SIDEBAR_PROVIDER = exports.CONFIRM_UNASSIGNED = exports.SUCCESS_ASSIGNED = exports.SUCCESS_UNASSIGNED = exports.SUCCESS_UPDATE_SETTINGS = exports.SUCCESS_PATIENT_ADDED = exports.SUCCESS_UPDATE_PROFILE = exports.SUCCESS_ANSWER_FORM = exports.SUCCESS_ANSWER_SURVEY = exports.SUCCESS_SEND_SURVEY = exports.SUCCESS_SURVEY_COMPLETION = exports.SURVEY_RESULTS = exports.PROGRAMS_TITLE = exports.SURVEYS_TITLE = exports.SURVEYS_ANSWERED_EMPTY = exports.SURVEYS_UPCOMING_EMPTY = exports.PROGRAM_INVITATION_TEXT = exports.PROFILE_FIELDSET_EMPTY = exports.PLACEHOLDER_SEARCH_MESSAGE = exports.PICK_ITEM_LEFT = exports.REMOVE_FROM_CHAT = exports.SUCCESS = exports.TO_TOP = exports.ERROR_404 = exports.CHAT_EMPTY_CHANNELS = exports.CHAT_EMPTY_NAVIGATION = exports.CHAT_EMPTY = exports.TIME_PATTERN = exports.FULL_SHORT_DATE_PATTERN = exports.SHORT_DATE_PATTERN = exports.DATE_PATTERN_UI = exports.DATE_PATTERN_API = exports.DAY_MONTH_FORMAT = exports.DAY_FORMATTING_PATTERN = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _SCREEN_TITLES, _SURVEYS_ASSIGNMENT_T, _SURVEYS_ASSIGNMENT_D, _TODO_ASSIGNMENT_TITL;
	
	var _routes = __webpack_require__(37);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _props = __webpack_require__(41);
	
	var _constants = __webpack_require__(1366);
	
	var _constants2 = __webpack_require__(4087);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Strings
	var DAY_FORMATTING_PATTERN = exports.DAY_FORMATTING_PATTERN = {
	  id: 'general.formats.dayFormattingPattern'
	};
	var DAY_MONTH_FORMAT = exports.DAY_MONTH_FORMAT = 'd MMM';
	var DATE_PATTERN_API = exports.DATE_PATTERN_API = { id: 'general.formats.datePatternAPI' };
	var DATE_PATTERN_UI = exports.DATE_PATTERN_UI = { id: 'general.formats.datePatternUI' };
	var SHORT_DATE_PATTERN = exports.SHORT_DATE_PATTERN = { id: 'general.formats.shortDatePattern' };
	var FULL_SHORT_DATE_PATTERN = exports.FULL_SHORT_DATE_PATTERN = {
	  id: 'general.formats.fullShortDatePattern'
	};
	var TIME_PATTERN = exports.TIME_PATTERN = { id: 'general.formats.timePattern' };
	var CHAT_EMPTY = exports.CHAT_EMPTY = { id: 'messages.chat.empty.messages' };
	var CHAT_EMPTY_NAVIGATION = exports.CHAT_EMPTY_NAVIGATION = { id: 'messages.chat.empty.users' };
	var CHAT_EMPTY_CHANNELS = exports.CHAT_EMPTY_CHANNELS = { id: 'messages.chat.empty.channels' };
	var ERROR_404 = exports.ERROR_404 = { id: 'general.errors.404' };
	var TO_TOP = exports.TO_TOP = { id: 'general.toTop' };
	var SUCCESS = exports.SUCCESS = { id: 'general.success' };
	var REMOVE_FROM_CHAT = exports.REMOVE_FROM_CHAT = { id: 'general.removedFromChat' };
	var PICK_ITEM_LEFT = exports.PICK_ITEM_LEFT = { id: 'general.labels.pickItemLeft' };
	
	var PLACEHOLDER_SEARCH_MESSAGE = exports.PLACEHOLDER_SEARCH_MESSAGE = { id: 'general.search.placeholder' };
	var PROFILE_FIELDSET_EMPTY = exports.PROFILE_FIELDSET_EMPTY = { id: 'profile.fieldSet.empty' };
	var PROGRAM_INVITATION_TEXT = exports.PROGRAM_INVITATION_TEXT = {
	  id: 'programs.invitation.invitationText'
	};
	var SURVEYS_UPCOMING_EMPTY = exports.SURVEYS_UPCOMING_EMPTY = { id: 'surveys.noUpcomingSurveys' };
	var SURVEYS_ANSWERED_EMPTY = exports.SURVEYS_ANSWERED_EMPTY = { id: 'surveys.noSurveysResults' };
	var SURVEYS_TITLE = exports.SURVEYS_TITLE = { id: 'surveys.title' };
	var PROGRAMS_TITLE = exports.PROGRAMS_TITLE = { id: 'programs.title' };
	var SURVEY_RESULTS = exports.SURVEY_RESULTS = { id: 'surveys.results' };
	
	var SUCCESS_SURVEY_COMPLETION = exports.SUCCESS_SURVEY_COMPLETION = { id: 'surveys.completion' };
	var SUCCESS_SEND_SURVEY = exports.SUCCESS_SEND_SURVEY = { id: 'surveys.sent' };
	var SUCCESS_ANSWER_SURVEY = exports.SUCCESS_ANSWER_SURVEY = { id: 'surveys.answer' };
	var SUCCESS_ANSWER_FORM = exports.SUCCESS_ANSWER_FORM = { id: 'surveys.answerForm' };
	var SUCCESS_UPDATE_PROFILE = exports.SUCCESS_UPDATE_PROFILE = { id: 'profiles.updated' };
	var SUCCESS_PATIENT_ADDED = exports.SUCCESS_PATIENT_ADDED = { id: 'dialog.common.patientWasAdded' };
	var SUCCESS_UPDATE_SETTINGS = exports.SUCCESS_UPDATE_SETTINGS = { id: 'settings.updated' };
	var SUCCESS_UNASSIGNED = exports.SUCCESS_UNASSIGNED = { id: 'circle.unassigned' };
	var SUCCESS_ASSIGNED = exports.SUCCESS_ASSIGNED = { id: 'circle.assigned' };
	
	var CONFIRM_UNASSIGNED = exports.CONFIRM_UNASSIGNED = { id: 'circle.confirmUnassigned' };
	
	var SEARCH_SIDEBAR_PROVIDER = exports.SEARCH_SIDEBAR_PROVIDER = { id: 'general.search.patients' };
	var SEARCH_SIDEBAR_USER = exports.SEARCH_SIDEBAR_USER = { id: 'general.search.placeholder' };
	var YOU = exports.YOU = { id: 'general.labels.you' };
	var OFFLINE_MESSAGE = exports.OFFLINE_MESSAGE = { id: 'general.labels.noInternet' };
	var YO = exports.YO = { id: 'general.labels.YO' };
	var MY_PROFILE = exports.MY_PROFILE = { id: 'general.labels.myProfile' };
	var PROFILE_STR = exports.PROFILE_STR = { id: 'general.labels.profile' };
	var CIRCLES_EMPTY = exports.CIRCLES_EMPTY = { id: 'circles.empty' };
	var CIRCLES_EMPTY_NAVIGATION = exports.CIRCLES_EMPTY_NAVIGATION = { id: 'circles.empty.navigation' };
	var FAMILY_TITLE = exports.FAMILY_TITLE = { id: 'messages.userProfile.familyMembers' };
	var PROGRAM_PROVIDERS_TITLE = exports.PROGRAM_PROVIDERS_TITLE = {
	  id: 'messages.userProfile.programServiceProviders'
	};
	var CARE_PROVIDERS_TITLE = exports.CARE_PROVIDERS_TITLE = { id: 'general.careProvidersTitle' };
	var CARE_PROVIDER = exports.CARE_PROVIDER = { id: 'messages.userProfile.singleProvider' };
	var TOGGLE_TNC = exports.TOGGLE_TNC = { id: 'general.labels.backToInvitation' };
	var MAIN_CARE_PROVIDER = exports.MAIN_CARE_PROVIDER = {
	  id: 'messages.userProfile.mainProvider'
	};
	var MEMBER_PROVIDER_CIRCLE = exports.MEMBER_PROVIDER_CIRCLE = {
	  id: 'messages.userProfile.memberProviderCircle'
	};
	var USERNAME_EXAMPLE = exports.USERNAME_EXAMPLE = { id: 'general.labels.userNameExample' };
	var USERNAME_EXPLANATION = exports.USERNAME_EXPLANATION = {
	  id: 'general.labels.userNameExplanation'
	};
	
	var COMMUNITIES_EMPTY_NAVIGATION = exports.COMMUNITIES_EMPTY_NAVIGATION = {
	  id: 'communities.empty.navigation'
	};
	var COMMUNITIES_EMPTY = exports.COMMUNITIES_EMPTY = { id: 'communities.empty' };
	var COMMUNITIES_EMPTY_ACTIVITIES = exports.COMMUNITIES_EMPTY_ACTIVITIES = {
	  id: 'communities.empty.activities'
	};
	var COMMUNITIES_TITLE_MEMBER = exports.COMMUNITIES_TITLE_MEMBER = { id: 'communities.title.member' };
	var COMMUNITIES_TITLE_MODERATOR = exports.COMMUNITIES_TITLE_MODERATOR = {
	  id: 'communities.title.moderator'
	};
	
	var COMMUNITY_TYPE_PUBLIC = exports.COMMUNITY_TYPE_PUBLIC = { id: 'community.type.public' };
	var COMMUNITY_TYPE_PRIVATE = exports.COMMUNITY_TYPE_PRIVATE = { id: 'community.type.private' };
	var COMMUNITY_ACCESS_READ_ONLY = exports.COMMUNITY_ACCESS_READ_ONLY = { id: 'community.access.readOnly' };
	
	var COMMUNITY_EMPTY = exports.COMMUNITY_EMPTY = { id: 'community.empty' };
	var COMMUNITY_DESCRIPTION = exports.COMMUNITY_DESCRIPTION = { id: 'community.description' };
	var COMMUNITY_POSTS = exports.COMMUNITY_POSTS = { id: 'community.posts' };
	var COMMUNITY_POSTS_EMPTY = exports.COMMUNITY_POSTS_EMPTY = { id: 'community.posts.empty' };
	var COMMUNITY_POSTS_PRIVATE = exports.COMMUNITY_POSTS_PRIVATE = { id: 'community.posts.private' };
	var COMMUNITY_POSTS_EMPTY_SUB = exports.COMMUNITY_POSTS_EMPTY_SUB = {
	  id: 'community.posts.privateSubtitle'
	};
	var COMMUNITY_MEMBERS = exports.COMMUNITY_MEMBERS = { id: 'community.members' };
	var COMMUNITY_MEMBERS_LIST = exports.COMMUNITY_MEMBERS_LIST = { id: 'community.membersList' };
	var COMMUNITY_MODERATORS_LIST = exports.COMMUNITY_MODERATORS_LIST = { id: 'community.moderatorsList' };
	var COMMUNITY_POST_UPDATED = exports.COMMUNITY_POST_UPDATED = { id: 'community.postUpdated' };
	var COMMUNITY_COMMENT_UPDATED = exports.COMMUNITY_COMMENT_UPDATED = { id: 'community.postUpdated' };
	
	var COMMUNITY_ACTIVITY = exports.COMMUNITY_ACTIVITY = { id: 'community.activity.total' };
	var COMMUNITY_ACTIVITY_POSTS = exports.COMMUNITY_ACTIVITY_POSTS = { id: 'community.activity.posts' };
	var COMMUNITY_ACTIVITY_COMMENTS = exports.COMMUNITY_ACTIVITY_COMMENTS = {
	  id: 'community.activity.comments'
	};
	var COMMUNITY_ACTIVITY_REQUEST = exports.COMMUNITY_ACTIVITY_REQUEST = {
	  id: 'community.activity.sentRequest'
	};
	var COMMUNITY_ACTIVITY_ACCEPTED_REQUEST = exports.COMMUNITY_ACTIVITY_ACCEPTED_REQUEST = {
	  id: 'community.activity.requestAccepted'
	};
	var COMMUNITY_ACTIVITY_DECLINED_REQUEST = exports.COMMUNITY_ACTIVITY_DECLINED_REQUEST = {
	  id: 'community.activity.requestDeclined'
	};
	
	var POST_TITLE = exports.POST_TITLE = { id: 'post.title' };
	var POST_BACK = exports.POST_BACK = { id: 'post.back' };
	var POST_COMMENTS = exports.POST_COMMENTS = { id: 'post.comments' };
	var POST_COMMENTS_ADD = exports.POST_COMMENTS_ADD = { id: 'post.comments.add' };
	var POST_COMMENT_DESCRIPTION = exports.POST_COMMENT_DESCRIPTION = { id: 'post.comment.description' };
	var POST_REPLIES = exports.POST_REPLIES = { id: 'post.replies' };
	var POST_REPLY_DESCRIPTION = exports.POST_REPLY_DESCRIPTION = { id: 'post.reply.description' };
	var POST_REPLY_PLACEHOLDER = exports.POST_REPLY_PLACEHOLDER = { id: 'post.reply.placeholder' };
	
	var SUCCESS_PAYMENT_METHOD_REMOVED = exports.SUCCESS_PAYMENT_METHOD_REMOVED = {
	  id: 'profile.payment.removeSuccessfullyMessage'
	};
	
	var REPORT = exports.REPORT = {
	  title: { id: 'report.title' },
	  danger: { id: 'report.danger' }
	};
	
	var ROLE_ADMIN = exports.ROLE_ADMIN = { id: 'role.admin' };
	
	var NEW_CHAT = exports.NEW_CHAT = {
	  addMorePeople: { id: 'dialog.common.invite' },
	  newChat: { id: 'messages.chat.newChat' },
	  startANewConversationInTheContextOf: {
	    id: 'messages.chat.startANewConversationInTheContextOf'
	  },
	  startANewConversationInTheContextOfDesc: {
	    id: 'messages.chat.startANewConversationInTheContextOfDesc'
	  },
	  startANewConversation: { id: 'messages.chat.startANewConversation' },
	  findAMember: { id: 'messages.chat.findAMember' },
	  youAddedMembers: { id: 'messages.chat.youAddedMembers' },
	  counterMembers: { id: 'messages.chat.counterMembers' },
	  start: { id: 'messages.chat.start' },
	  noOneFound: { id: 'messages.chat.noOneFound' },
	  enterUsernameOrName: { id: 'messages.chat.enterUsernameOrName' },
	  searchPeopleByUsername: { id: 'general.search.searchByPeopleUsername' },
	  searchAUser: { id: 'messages.chat.searchAUser' },
	  defaultUser: { id: 'messages.chat.defaultUser' },
	  accessLevel: { id: 'messages.titles.accessLevel' },
	  accessLevelTooltip: { id: 'messages.titles.accessLevelTooltip' },
	  reasonForAssignment: { id: 'messages.titles.reasonForAssignment' },
	  selectReasonForAssignment: {
	    id: 'messages.titles.selectReasonForAssignment'
	  }
	};
	
	var MENU = exports.MENU = {
	  healthboard: { id: 'menu.healthboard' },
	  messages: { id: 'menu.messages' },
	  myCircles: { id: 'menu.myCircles' },
	  dashboard: { id: 'menu.dashboard' },
	  communities: { id: 'menu.communities' },
	  home: { id: 'menu.home' }
	};
	
	var MESSAGES_FILTER_OPTIONS = exports.MESSAGES_FILTER_OPTIONS = {
	  allPatients: { id: 'messages.filterOptions.allPatients' },
	  myPatients: { id: 'messages.filterOptions.myPatients' }
	};
	
	var MESSAGES_STATUS_FILTER_OPTIONS = exports.MESSAGES_STATUS_FILTER_OPTIONS = {
	  all: { id: 'messages.statusFilterOptions.all' },
	  joined: { id: 'messages.statusFilterOptions.joined' },
	  notJoined: { id: 'messages.statusFilterOptions.notJoined' }
	};
	
	var MESSAGES_NOT_JOINED = exports.MESSAGES_NOT_JOINED = {
	  message: { id: 'messages.patientNotJoined.message' },
	  resend: { id: 'messages.patientNotJoined.resend' },
	  noAvailableSurveys: { id: 'surveys.sendSurvey.noSurveys' },
	  noAvailableForms: { id: 'surveys.noAvailableForms' },
	  invite: { id: 'messages.patientNotJoined.invite' },
	  inviteSent: { id: 'messages.patientNotJoined.inviteSent' },
	  checkContactInformationText: {
	    id: 'messages.patientNotJoined.checkContactInformationText'
	  },
	  inviteTitle: { id: 'messages.patientNotJoined.inviteTitle' },
	  errors: {
	    // phoneNumber: {
	    //   invalid: { id: 'messages.patientNotJoined.errors.invalid' },
	    //   already_taken: { id: 'messages.patientNotJoined.errors.phoneNumberAlreadyTaken' },
	    // },
	    // email: {
	    //   invalid: { id: 'messages.patientNotJoined.errors.invalid' },
	    //   already_taken: { id: 'messages.patientNotJoined.errors.emailAlreadyTaken' },
	    // },
	    // meta validation errors
	    phoneNumber_taken: {
	      id: 'messages.patientNotJoined.errors.phoneNumberAlreadyTaken'
	    },
	    phoneNumber_invalid: {
	      id: 'messages.patientNotJoined.errors.phoneNumberInvalid'
	    },
	    phoneNumber_blank: {
	      id: 'messages.patientNotJoined.errors.phoneNumberBlank'
	    },
	
	    email_taken: {
	      id: 'messages.patientNotJoined.errors.emailAlreadyTaken'
	    },
	    email_invalid: { id: 'messages.patientNotJoined.errors.emailInvalid' },
	    email_blank: { id: 'messages.patientNotJoined.errors.emailBlank' }
	    // // one code
	    // invalid: { id: 'messages.patientNotJoined.errors.invalid' },
	    // record_invalid: { id: 'messages.patientNotJoined.errors.invalid' },
	    // already_taken: { id: 'messages.patientNotJoined.errors.phoneNumberAlreadyTaken' },
	  }
	};
	
	var TITLE = exports.TITLE = { id: 'general.title' };
	
	// pending invitations
	var CANCEL_INVITE = exports.CANCEL_INVITE = {
	  title: { id: 'circles.family.cancelInvite.title' },
	  text: { id: 'circles.family.cancelInvite.text' }
	};
	
	var CANCEL_CAREGIVER_INVITE = exports.CANCEL_CAREGIVER_INVITE = {
	  title: { id: 'circles.caregiver.cancelInvite.title' },
	  text: { id: 'circles.caregiver.cancelInvite.text' }
	};
	
	var CANCEL_INVITATION = exports.CANCEL_INVITATION = { id: 'circles.invites.cancelInvite' };
	var CONFIRM_CANCEL = exports.CONFIRM_CANCEL = { id: 'circles.invites.confirmCancel' };
	var DECLINE_CANCEL = exports.DECLINE_CANCEL = { id: 'circles.invites.declineCancel' };
	var INVITE_SENT = exports.INVITE_SENT = { id: 'circles.invites.inviteSent' };
	var INVITED_CAREGIVER = exports.INVITED_CAREGIVER = { id: 'circles.invites.invitedCaregiver' };
	var SUCCESS_INVITE_FAMILY = exports.SUCCESS_INVITE_FAMILY = { id: 'circles.invites.family.success' };
	var SUCCESS_INVITE_CAREGIVER = exports.SUCCESS_INVITE_CAREGIVER = {
	  id: 'circles.invites.caregiver.success'
	};
	var SUCCESS_INVITE_PROVIDER = exports.SUCCESS_INVITE_PROVIDER = {
	  id: 'circles.invites.provider.success'
	};
	var ERROR_ASSIGN_CAREGIVER = exports.ERROR_ASSIGN_CAREGIVER = { id: 'circles.invites.caregiver.error' };
	
	var ACCEPT_FAMILY_INVITATION = exports.ACCEPT_FAMILY_INVITATION = { id: 'circles.invites.family.accept' };
	var DECLINE_FAMILY_INVITATION = exports.DECLINE_FAMILY_INVITATION = {
	  id: 'circles.invites.family.decline'
	};
	var ACCEPT_CAREGIVER_INVITATION = exports.ACCEPT_CAREGIVER_INVITATION = {
	  id: 'circles.invites.caregiver.accept'
	};
	var DECLINE_CAREGIVER_INVITATION = exports.DECLINE_CAREGIVER_INVITATION = {
	  id: 'circles.invites.caregiver.decline'
	};
	
	var SUCCESS_REMOVE_PROVIDER = exports.SUCCESS_REMOVE_PROVIDER = { id: 'circles.provider.remove' };
	var SUCCESS_LEAVE_PROVIDER_CIRCLE = exports.SUCCESS_LEAVE_PROVIDER_CIRCLE = { id: 'circles.provider.leave' };
	var SUCCESS_REMOVE_FAMILY_MEMBER = exports.SUCCESS_REMOVE_FAMILY_MEMBER = { id: 'circles.family.remove' };
	var SUCCESS_LEAVE_FAMILY = exports.SUCCESS_LEAVE_FAMILY = { id: 'circles.family.leave' };
	
	var COMMON = exports.COMMON = {
	  addPatient: { id: 'common.addPatient' },
	  remove: { id: 'common.remove' },
	  accept: { id: 'common.accept' },
	  decline: { id: 'common.decline' },
	  back: { id: 'common.back' },
	  cancel: { id: 'common.cancel' },
	  save: { id: 'common.save' },
	  invite: { id: 'common.invite' },
	  terms: { id: 'common.terms' },
	  termOfUse: { id: 'common.termOfUse' },
	  yes: { id: 'common.yes' },
	  no: { id: 'common.no' },
	  close: { id: 'common.close' },
	  clear: { id: 'common.clear' },
	  collapse: { id: 'common.collapse' },
	  myMessages: { id: 'common.myMessages' },
	  myHealthboard: { id: 'common.myHealthboard' },
	  myCommunities: { id: 'common.myCommunities' },
	  reports: { id: 'common.reports' },
	  discover: { id: 'common.discover' },
	  add: { id: 'common.add' },
	  unassign: { id: 'common.unassign' },
	  optional: { id: 'common.optional' },
	  privacy: { id: 'common.privacy' },
	  from: { id: 'common.from' },
	  notifications: { id: 'common.notifications' },
	  allow: { id: 'common.allow' },
	  copy: { id: 'common.copy' },
	  likes: { id: 'common.likes' },
	  comments: { id: 'common.comments' },
	  new: { id: 'common.new' },
	  send: { id: 'common.send' },
	  emptySection: { id: 'common.emptySection' },
	  next: { id: 'common.next' },
	  activities: { id: 'common.activities' }
	};
	
	// Text blocks
	var ACTIONS = exports.ACTIONS = {
	  circle: {
	    leave: { id: 'circles.actions.leave' }
	  },
	  survey: {
	    answer: { id: 'surveys.actions.answer' },
	    save: { id: 'surveys.actions.save' },
	    proceed: { id: 'surveys.actions.proceed' },
	    general: { id: 'surveys.actions.general' },
	    review: { id: 'surveys.actions.review' },
	    submit: { id: 'surveys.actions.submit' },
	    submitOne: { id: 'surveys.actions.submitOne' },
	    upcoming: { id: 'surveys.actions.upcoming' },
	    upcomingHeading: { id: 'surveys.actions.upcomingHeading' },
	    exportToPDF: { id: 'surveys.actions.exportToPDF' },
	    title: { id: 'surveys.title' },
	    countSurveys: { id: 'surveys.countSurveys' },
	    single: { id: 'surveys.single' },
	    totalScore: { id: 'surveys.totalScore' },
	    selectedChatDesc: { id: 'surveys.selectedChatDesc' },
	    answeredBy: { id: 'surveys.answeredBy' },
	    complete: { id: 'common.complete' },
	    optional: { id: 'common.optional' }
	  },
	  program: {
	    request: { id: 'programs.actions.request' },
	    title: { id: 'programs.actions.title' },
	    followup: { id: 'programs.actions.followup' },
	    subtitle: { id: 'programs.actions.subtitle' },
	    showMore: { id: 'programs.actions.showMore' },
	    showLess: { id: 'programs.actions.showLess' },
	    more: { id: 'programs.actions.more' },
	    leave: { id: 'programs.actions.leave' },
	    emptyState: { id: 'programs.emptyState' },
	    aboutProgram: { id: 'programs.actions.aboutProgram' }
	  },
	  profile: {
	    cancel: { id: 'profile.actions.cancel' },
	    details: { id: 'profile.actions.details' },
	    submit: { id: 'profile.actions.submit' },
	    provider: { id: 'profile.actions.provider' },
	    patient: { id: 'profile.actions.patient' },
	    back: { id: 'profile.actions.back' }
	  },
	  chat: {
	    downloadAttachment: { id: 'chat.actions.downloadAttachment' },
	    editMessage: { id: 'chat.actions.editMessage' },
	    deleteMessage: { id: 'chat.actions.deleteMessage' },
	    confirmDeleteMessage: { id: 'chat.actions.confirmDeleteMessage' },
	    reply: { id: 'chat.actions.reply' },
	    blockMessaging: { id: 'chat.actions.blockMessaging' },
	    unblockMessaging: { id: 'chat.actions.unblockMessaging' },
	    unblockUser: { id: 'chat.actions.unblockUser' },
	    leaveChat: { id: 'chat.actions.leaveChat' },
	    confirmLeaveChat: { id: 'chat.actions.confirmLeaveChat' },
	    sendMessage: { id: 'chat.actions.sendMessage' }
	  },
	  community: {
	    createPost: { id: 'community.actions.createPost' },
	    leave: { id: 'community.activity.leave' }
	  },
	  post: {
	    createComment: { id: 'post.actions.createComment' },
	    reply: { id: 'post.actions.reply' }
	  }
	};
	
	var PROGRAMS = exports.PROGRAMS = {
	  invitations: {
	    title: { id: 'programs.invitation.title' },
	    empty: { id: 'programs.invitation.empty' },
	    emptyState: { id: 'programs.invitation.emptyState' },
	    addPatient: { id: 'programs.invitation.addPatient' },
	    success: { id: 'programs.invitation.success' }
	  },
	  remove: {
	    confirmRemove: { id: 'programs.remove.confirmRemove' },
	    success: { id: 'programs.remove.success' },
	    title: { id: 'programs.remove.title' },
	    subtitle: { id: 'programs.remove.subtitle' }
	  }
	};
	
	var AUTH = exports.AUTH = {
	  actions: {
	    accessDenied: {
	      textTitle: { id: 'auth.accessDenied.text' }
	    },
	    createPassword: {
	      textTitle: { id: 'auth.createPassword.text' }
	    },
	    expiredToken: {
	      textTitle: { id: 'auth.expiredToken.text' }
	    },
	    expiredConfirmation: {
	      textTitle: { id: 'auth.expiredConfirmation.text' }
	    },
	    otp: {
	      textLink: { id: 'auth.sendOtp.title' }
	    },
	    recoverConfirm: {
	      email: {
	        textTitle: { id: 'auth.recoverConfirm.email.title' },
	        textConfirm: { id: 'auth.recoverConfirm.email.confirmText' }
	      },
	      phone: {
	        textTitle: { id: 'auth.recoverConfirm.phone.title' },
	        textConfirm: { id: 'auth.recoverConfirm.phone.confirmText' }
	      }
	    },
	    recoverPassword: {
	      textTitle: { id: 'auth.recoverPassword.textTitle' },
	      textTitlePrimaryContacts: {
	        id: 'auth.recoverPassword.primaryContacts.textTitle'
	      },
	      textLink: { id: 'auth.recoverPassword.textLink' }
	    },
	    userNotFound: {
	      textTitle: { id: 'auth.userNotFound.text' }
	    },
	    signup: {
	      textTitle: { id: 'auth.signup.title' },
	      textLink: { id: 'auth.signup.textLink' },
	      matchPassword: { id: 'auth.signup.matchPassword' },
	      confirmationPassword: { id: 'auth.signup.confirmationPassword' }
	    },
	    tnc: {
	      textTitle: { id: 'auth.tnc.title' },
	      textLink: { id: 'auth.tnc.textLink' }
	    },
	    logout: { id: 'auth.logout.text' }
	  },
	  errors: {
	    common: { id: 'errors.common' },
	    invalidDate: { id: 'errors.invalidDateOfBirth' },
	    login: {
	      unauthorized: { id: 'errors.login.unauthorized' },
	      authenticationLockout: { id: 'errors.login.authenticationLockout' }
	    },
	    namesLength: { id: 'errors.nameLength' },
	    requiredFields: { id: 'errors.requiredFields' },
	    tnc: { id: 'errors.tnc' },
	    cannotAcceptInvite: { id: 'errors.cannotAcceptInvite' },
	    containsCommercialAt: { id: 'errors.nicknameContainsCommercialAt' },
	    password: { id: 'errors.password' }
	  },
	  fields: {
	    dob: { id: 'fields.dob' },
	    email: { id: 'fields.email' },
	    firstname: { id: 'fields.firstname' },
	    gender: { id: 'fields.gender' },
	    lastname: { id: 'fields.lastname' },
	    password: { id: 'fields.password' },
	    username: { id: 'profile.fields.username' },
	    login: { id: 'fields.login' },
	    loginPlaceholder: { id: 'fields.login.placeholder' },
	    phoneNumber: { id: 'fields.phoneNumber' }
	  },
	  submit: {
	    signup: { id: 'submit.signup' },
	    login: { id: 'submit.login' },
	    signin: { id: 'submit.signin' },
	    loginAzure: { id: 'submit.login.azure' },
	    signUpAzure: { id: 'submit.signUp.azure' },
	    fillProfile: { id: 'submit.fillProfile' },
	    recoverPassword: { id: 'submit.recoverPassword' },
	    recoverConfirm: { id: 'submit.recoverConfirm' },
	    createPassword: { id: 'submit.createPassword' },
	    expiredToken: { id: 'submit.expiredToken' },
	    signUp: { id: 'submit.signUp' }
	  },
	  titles: {
	    accessDenied: { id: 'titles.accessDenied' },
	    createPassword: { id: 'titles.createPassword' },
	    expiredToken: { id: 'titles.expiredToken' },
	    expiredConfirmation: { id: 'titles.expiredConfirmation' },
	    fillProfile: { id: 'titles.fillProfile' },
	    login: { id: 'titles.login' },
	    recoverConfirm: { id: 'titles.recoverConfirm' },
	    recoverPassword: { id: 'titles.recoverPassword' },
	    signup: { id: 'titles.signup' },
	    confirmMyEmail: { id: 'titles.confirmMyEmail' },
	    confirmMyPhoneNumber: { id: 'titles.confirmMyPhoneNumber' },
	    invitationLinkDesc: { id: 'auth.signup.invitationLinkDesc' },
	    sentEmailVerification: { id: 'auth.signup.sentEmailVerification' },
	    sentPhoneVerification: { id: 'auth.signup.sentPhoneVerification' }
	  }
	};
	
	var PROFILE = exports.PROFILE = {
	  avatar: {
	    remove: { id: 'profile.avatar.remove' },
	    upload: { id: 'profile.avatar.upload' },
	    update: { id: 'profile.avatar.update' }
	  },
	  tabType: {
	    patient: { id: 'profile.tabType.patient' },
	    provider: { id: 'profile.tabType.provider' },
	    surveys: { id: 'profile.tabType.surveys' },
	    team: { id: 'profile.tabType.team' }
	  },
	  notificationSettings: {
	    title: { id: 'profile.section.notificationSettings' },
	    label: { id: 'profile.notificationSettings.label' },
	    labels: {
	      email: { id: 'profile.notificationSettings.labels.email' },
	      sms: { id: 'profile.notificationSettings.labels.sms' }
	    }
	  },
	  languageSettings: {
	    title: { id: 'profile.section.languageSettings' }
	  },
	  deviceSetup: {
	    title: { id: 'profile.section.deviceSetup' },
	    addDeviceAccount: { id: 'profile.section.deviceSetup.addDeviceAccount' },
	    noAccount: { id: 'profile.section.deviceSetup.noAccount' },
	    addAccountDescription: {
	      id: 'profile.section.deviceSetup.addAccountDescription'
	    },
	    removeAccount: { id: 'profile.section.deviceSetup.removeAccount' },
	    detailsAccount: { id: 'profile.section.deviceSetup.detailsAccount' },
	    noDevices: { id: 'profile.section.deviceSetup.noDevices' },
	    synced: { id: 'profile.section.deviceSetup.synced' },
	    noPermission: { id: 'profile.section.deviceSetup.noPermission' },
	    noPermissionAnnotation: {
	      id: 'profile.section.deviceSetup.noPermissionAnnotation'
	    },
	    error: { id: 'errors.common' },
	    appleHealth: { id: 'profile.section.deviceSetup.appleHealth' },
	    appleHealthDescription: {
	      id: 'profile.section.deviceSetup.manageDataFromMobile'
	    }
	  },
	  edit: {
	    emailConfirmationTitle: { id: 'profile.edit.emailConfirmationTitle' },
	    confirmCode: { id: 'profile.edit.confirmCode' },
	    invalidCode: { id: 'profile.edit.invalidCode' },
	    emailConfirmationText: { id: 'profile.edit.emailConfirmationText' },
	    phoneConfirmationText: { id: 'profile.edit.phoneConfirmationText' }
	  },
	  errors: {
	    email: {
	      taken: { id: 'messages.patientNotJoined.errors.emailAlreadyTaken' },
	      invalid: { id: 'messages.patientNotJoined.errors.emailInvalid' },
	      blank: { id: 'messages.patientNotJoined.errors.emailBlank' }
	    },
	    phoneNumber: {
	      taken: {
	        id: 'messages.patientNotJoined.errors.phoneNumberAlreadyTaken'
	      },
	      invalid: { id: 'messages.patientNotJoined.errors.phoneNumberInvalid' },
	      blank: { id: 'messages.patientNotJoined.errors.phoneNumberBlank' }
	    },
	    username: {
	      taken: { id: 'errors.username.alreadyTaken' },
	      conflicts_with_existing_phone_number: {
	        id: 'errors.username.conflictsWithExistingData'
	      },
	      conflicts_with_existing_email: { id: 'errors.username.alreadyTaken' },
	      required: { id: 'errors.username.required' }
	    },
	    aliasName: {
	      taken: { id: 'errors.aliasName.alreadyTaken' }
	    },
	    ssn: {
	      taken: { id: 'errors.ssn.alreadyTaken' }
	    }
	  }
	};
	
	/*
	 * TODO add real text for provider circle invitation
	 */
	
	var INVITE_MEMBER = exports.INVITE_MEMBER = {
	  title: { id: 'circles.invites.title' },
	  subtitle: { id: 'circles.invites.subtitle' }
	};
	
	var INVITE_TEXT = exports.INVITE_TEXT = {
	  role: { id: 'circles.invites.role' },
	  family: { id: 'circles.invites.text.family' },
	  provider: { id: 'circles.invites.text.provider' },
	  caregiver: { id: 'circles.invites.text.caregiver' },
	  guardian: { id: 'circles.invites.text.guardian' },
	  providerInvitesCaregiver: {
	    id: 'circles.invites.text.ProviderInvitesCaregiver'
	  }
	};
	
	var MAKE_IBVITE_CAREGIVER = exports.MAKE_IBVITE_CAREGIVER = { id: 'circles.invites.caregiver' };
	var MAKE_INVITE_TO_FAMILY_TEXT = exports.MAKE_INVITE_TO_FAMILY_TEXT = {
	  id: 'circles.invites.makeInviteToFamilyText'
	};
	var MAKE_INVITE_TO_PROVIDER_TEXT = exports.MAKE_INVITE_TO_PROVIDER_TEXT = {
	  id: 'circles.invites.makeInviteProviderText'
	};
	var MAKE_INVITE_CAREGIVER_TEXT = exports.MAKE_INVITE_CAREGIVER_TEXT = {
	  id: 'circles.invites.makeInviteCaregiverText'
	};
	
	var PASS_STRENGTH = exports.PASS_STRENGTH = ['Too weak!', 'Weak!', 'Medium', 'Good', 'Very good'];
	
	// method for localisation convertRelationsList
	// TODO use from data constants
	var FAMILY_MEMBERS_OPTIONS = exports.FAMILY_MEMBERS_OPTIONS = [{ value: 'spouse' }, { value: 'daughter' }, { value: 'son' }, { value: 'sister' }, { value: 'brother' }, { value: 'mother' }, { value: 'father' }, { value: 'granddaughter' }, { value: 'grandson' }, { value: 'grandmother' }, { value: 'grandfather' }, { value: 'partner' }, { value: 'relative' }, { value: 'friend' }];
	
	var PARENT_OPTIONS = exports.PARENT_OPTIONS = [{ value: 'mother' }, { value: 'father' }];
	
	var ADD_PROVIDER_OPTION = exports.ADD_PROVIDER_OPTION = [{ value: 'temporary', label: 'circles.addProviderReason.temporaryTitle' }, { value: 'permanent', label: 'circles.addProviderReason.permanentTitle' }];
	
	var ADD_PROVIDER_REASON_CODE = exports.ADD_PROVIDER_REASON_CODE = {
	  temporary: [{
	    value: 'emergency access',
	    label: 'circles.addProviderReason.temporary.emergencyAccess'
	  }, {
	    value: 'temporarily assigned to patient',
	    label: 'circles.addProviderReason.temporary.temporarilyAssigned'
	  }, {
	    value: 'patient consultation',
	    label: 'circles.addProviderReason.temporary.patientConsultation'
	  }],
	  permanent: [{
	    value: 'current patient under treatment',
	    label: 'circles.addProviderReason.permanent.underTreatment'
	  }, {
	    value: 'patient request',
	    label: 'circles.addProviderReason.permanent.patientRequest'
	  }]
	};
	
	// Don't touch, it is not really i18n strings
	var PATIENT_PROFILE = exports.PATIENT_PROFILE = 'primaryPatientProfile';
	var PROVIDER_PROFILE = exports.PROVIDER_PROFILE = 'primaryProviderProfile';
	var CIRCLE_FAMILY = exports.CIRCLE_FAMILY = 'family';
	var CIRCLE_PROVIDER = exports.CIRCLE_PROVIDER = 'provider';
	var CIRCLE_CAREGIVER = exports.CIRCLE_CAREGIVER = 'caregiver';
	var CIRCLE_DEPENDENTS = exports.CIRCLE_DEPENDENTS = 'guardian';
	var TEAM_PROFILE = exports.TEAM_PROFILE = 'team';
	var CIRCLE_INVITE = exports.CIRCLE_INVITE = 'invite';
	var PENDING_INVITATIONS = exports.PENDING_INVITATIONS = { id: 'circles.invites.pending' };
	
	var CIRCLES = exports.CIRCLES = {
	  notInCircle: { id: 'circle.notInCircle' },
	  circle: { id: 'circles.circle' },
	  titles: {
	    invitations: { id: 'circles.titles.invitations' },
	    listCaregiver: { id: 'circles.titles.listCaregiver' },
	    familyMemberingCircle: { id: 'circles.titles.familyMemberingCircle' },
	    listFamilyCircleMember: { id: 'circles.titles.listFamilyCircleMember' },
	    listProviderMember: { id: 'circles.titles.listProviderMember' },
	    guardianFor: { id: 'circles.titles.guardianFor' },
	    familyCircle: { id: 'circles.titles.familyCircle' },
	    providerCircle: { id: 'circles.titles.providerCircle' },
	    primaryProviderProfileTitle: {
	      id: 'circles.titles.primaryProviderProfileTitle'
	    },
	    primaryPatientProfileTitle: {
	      id: 'circles.titles.primaryPatientProfileTitle'
	    },
	    caregiverRole: { id: 'circles.titles.caregiverRole' },
	    careProvider: { id: 'circles.titles.careProvider' },
	    guardianRole: { id: 'circles.roles.guardian' },
	    proxyRole: { id: 'circles.roles.proxy' },
	    parentRole: { id: 'circles.roles.parent' }
	  },
	  leaveBtn: { id: 'circles.actions.leaveBtn' },
	  actionTitles: {
	    makeCaregiver: { id: 'circles.actions.makeCaregiver' },
	    removeFromCircle: { id: 'circles.actions.removeFromCircle' }
	  },
	  inviteProvider: { id: 'circles.actions.inviteProvider' },
	  inviteFamily: { id: 'circles.actions.inviteFamily' },
	  inviteCaregiver: { id: 'circles.actions.makeCaregiver' },
	  circleTitle: { id: 'circles.circle.typedCircle' },
	  removeCaregiver: { id: 'circles.actions.removeCaregiver' },
	  assignCaregiver: { id: 'circles.actions.makeCaregiver' },
	  assignGuardian: { id: 'circles.actions.assignGuardian' },
	  removeGuardian: { id: 'circles.actions.removeGuardian' }
	};
	
	var VALIDATION_ERRORS = exports.VALIDATION_ERRORS = {
	  profile: {
	    firstName: {
	      required: { id: 'errors.validation.profile.firstName.required' }
	    },
	    lastName: {
	      required: { id: 'errors.validation.profile.lastName.required' }
	    },
	    phone: {
	      format: { id: 'errors.validation.profile.phone.format' },
	      required: { id: 'errors.validation.profile.phone.required' },
	      short: { id: 'errors.validation.profile.phone.short' }
	    },
	    dob: {
	      format: { id: 'errors.validation.profile.dob.format' },
	      required: { id: 'errors.validation.profile.dob.required' }
	    },
	    email: {
	      format: { id: 'errors.validation.profile.email.format' },
	      required: { id: 'errors.validation.profile.email.required' }
	    },
	    username: {
	      required: { id: 'errors.validation.profile.username.required' },
	      format: { id: 'errors.validation.profile.username.format' },
	      minCharacters: { id: 'errors.validation.profile.username.minCharacters' }
	    },
	    aliasName: {
	      required: { id: 'errors.validation.profile.aliasName.required' },
	      format: { id: 'errors.validation.profile.aliasName.format' },
	      minCharacters: {
	        id: 'errors.validation.profile.aliasName.minCharacters'
	      }
	    },
	    postalCode: {
	      format: { id: 'errors.validation.profile.postalCode.format' }
	    },
	    ssn: {
	      format: { id: 'errors.validation.profile.ssn.format' }
	    },
	    phoneHome: {
	      required: {
	        id: 'errors.validation.profile.phoneHome.required'
	      },
	      format: { id: 'errors.validation.profile.phoneHome.format' }
	    },
	    workingHours: {
	      required: {
	        id: 'errors.validation.profile.workingHours.required'
	      }
	    }
	  }
	};
	
	var MESSAGES = exports.MESSAGES = {
	  familyTitleWithCounter: { id: 'messages.titles.familyTitleWithCounter' },
	  providerTitleWithCounter: {
	    id: 'messages.titles.providerTitleWithCounter'
	  }
	};
	
	var LEAVE_FAMILY_CIRCLE_STRINGS = exports.LEAVE_FAMILY_CIRCLE_STRINGS = {
	  title: { id: 'circles.leave.family.title' },
	  body: { id: 'circles.leave.family.body' }
	};
	
	var LEAVE_PROVIDER_CIRCLE_STRINGS = exports.LEAVE_PROVIDER_CIRCLE_STRINGS = {
	  title: { id: 'circles.leave.provider.title' },
	  body: { id: 'circles.leave.provider.body' }
	};
	
	var COMMON_ERROR_MESSAGES = exports.COMMON_ERROR_MESSAGES = {
	  error: { id: 'errors.commonErrorOccured' },
	  emailError: { id: 'errors.emailError' },
	  descr: { id: 'errors.emailErrorDesription' },
	  emailAndPhoneError: { id: 'errors.emailAndPhoneErrorDescription' },
	  alreadyUsed: { id: 'errors.alreadyUsed' }
	};
	
	var PREVIEWABLE_BLOCK = exports.PREVIEWABLE_BLOCK = {
	  viewMore: { id: 'previewableBlock.more' },
	  viewLess: { id: 'previewableBlock.less' }
	};
	
	var CHAT = exports.CHAT = {
	  uploadingFileInProgress: { id: 'chat.titles.uploadingFile' },
	  messageIsLong: { id: 'chat.errors.tooLong' },
	  attachmentMaxSizeExceeded: { id: 'chat.errors.maxAttachmentSize' },
	  attachmentMaxSizeNextPart: { id: 'chat.errors.maxAttachmentSizeNextPart' },
	  attachmentNotAllowedFormat: { id: 'chat.errors.notAllowedFormat' },
	  attachmentUploadError: { id: 'chat.errors.uploadError' },
	  attachmentMaxNumber: { id: 'chat.errors.maxAttachmentNumber' },
	  titles: {
	    generalChatTab: { id: 'chat.titles.generalChatTab' },
	    familyChatTab: { id: 'chat.titles.familyChatTab' },
	    providersChatTab: { id: 'chat.titles.providersChatTab' },
	    activitiesChatTab: { id: 'chat.titles.activitiesChatTab' },
	    notificationsChatTab: { id: 'chat.titles.notificationsChatTab' },
	    healthAlert: { id: 'chat.titles.healthAlert' },
	    providerAssigned: { id: 'chat.titles.providerAssignment' },
	    providerRemoved: { id: 'chat.titles.providerRemoved' },
	    memberAssigned: { id: 'chat.titles.memberAssignment' },
	    notification: { id: 'chat.titles.notification' },
	    upcomingSurveyReminder: { id: 'chat.titles.surveyReminder' },
	    addedAttachment: { id: 'chat.titles.addedAttachment' },
	    provider: { id: 'chat.titles.provider' },
	    providers: { id: 'chat.titles.providers' },
	    family: { id: 'chat.titles.family' },
	    chatName: { id: 'chat.title.chatName' },
	    userBlocked: { id: 'chat.title.userBlocked' },
	    newChatError: { id: 'chat.title.newChatError' },
	    disclaimerInforming: { id: 'chat.title.disclaimerInforming' }
	  },
	  placeholders: {
	    messageTo: { id: 'chat.placeholders.messageTo' },
	    default: { id: 'chat.placeholders.default' },
	    upcomingSurveyExpired: { id: 'chat.placeholders.surveyExpired' }
	  },
	  notifications: {
	    patientAssignedToProgram: {
	      id: 'chat.notifications.patientAssignedToProgram'
	    },
	    patientRemovedFromProgram: {
	      id: 'chat.notifications.patientRemovedFromProgram'
	    }
	  },
	  sorting: {
	    byUnread: { id: 'chat.sorting.byUnread' },
	    byLastMessage: { id: 'chat.sorting.byLastMessage' }
	  },
	  moreAttachments: {
	    sendSurvey: { id: 'chat.moreAttachments.sendSurvey' },
	    answerForm: { id: 'chat.moreAttachments.answerForm' },
	    attachFile: { id: 'chat.moreAttachments.attachFile' }
	  },
	  chatInContextOf: { id: 'chat.title.chatInContextOf' },
	  inContextOf: { id: 'chat.title.inContextOf' },
	  conversationInfo: { id: 'chat.title.conversationInfo' },
	  newMessage: { id: 'chat.notification.newMessage' },
	  removeFromChat: { id: 'chat.common.removeFromChat' }
	};
	
	var GENERAL_SURVEYS = exports.GENERAL_SURVEYS = {
	  noSurveys: { id: 'generalSurveys.noSurveys' }
	};
	
	var PROFILE_FIELDS = exports.PROFILE_FIELDS = {
	  listTitles: {
	    emergencyContact: { id: 'profile.section.emergencyContact' },
	    general: { id: 'profile.section.general' },
	    personal: { id: 'profile.section.personal' },
	    contacts: { id: 'profile.section.contacts' },
	    health: { id: 'profile.section.health' },
	    prof: { id: 'profile.section.prof' },
	    mrns: { id: 'profile.section.mrns' },
	    empinf: { id: 'profile.section.empinf' },
	    address: { id: 'profile.section.address' },
	    affiliations: { id: 'profile.section.affiliations' },
	    insurance: { id: 'profile.section.insurance' }
	  },
	  fieldHints: {
	    aliasName: { id: 'profile.fields.aliasName.hint' },
	    username: { id: 'profile.fields.username.hint' }
	  },
	  fieldNames: {
	    description: { id: 'profile.fields.description' },
	    relation: { id: 'profile.fields.relation' },
	    bio: { id: 'profile.fields.bio' },
	    location: { id: 'profile.fields.location' },
	    phones: { id: 'profile.fields.phones' },
	    healthInterests: { id: 'profile.fields.healthInterests' },
	    name: { id: 'profile.fields.name' },
	    firstName: { id: 'profile.fields.firstName' },
	    middleName: { id: 'profile.fields.middleName' },
	    nameSuffix: { id: 'profile.fields.nameSuffix' },
	    lastName: { id: 'profile.fields.lastName' },
	    gender: { id: 'profile.fields.gender' },
	    genderIdentity: { id: 'profile.fields.genderIdentity' },
	    dob: { id: 'profile.fields.dob' },
	    age: { id: 'profile.fields.age' },
	    educationLevel: { id: 'profile.fields.educationLevel' },
	    veteranStatus: { id: 'profile.fields.veteranStatus' },
	    citizenship: { id: 'profile.fields.citizenship' },
	    mStatus: { id: 'profile.fields.mStatus' },
	    ethnic: { id: 'profile.fields.ethnic' },
	    language: { id: 'profile.fields.language' },
	    languages: { id: 'profile.fields.languages' },
	    prefLanguage: { id: 'profile.fields.prefLanguage' },
	    religion: { id: 'profile.fields.religion' },
	    email: { id: 'profile.fields.email' },
	    homeAddress: { id: 'profile.fields.homeAddress' },
	    address1: { id: 'profile.fields.address1' },
	    address2: { id: 'profile.fields.address2' },
	    city: { id: 'profile.fields.city' },
	    state: { id: 'profile.fields.state' },
	    postalCode: { id: 'profile.fields.postalCode' },
	    isHomeLocationDifferent: { id: 'profile.fields.isHomeLocationDifferent' },
	    country: { id: 'profile.fields.country' },
	    homePhone: { id: 'profile.fields.homePhone' },
	    mobilePhone: { id: 'profile.fields.mobilePhone' },
	    phoneNumber: { id: 'profile.fields.phone' },
	    localUid: { id: 'profile.fields.localUid' },
	    allergies: { id: 'profile.fields.allergies' },
	    healthConditions: { id: 'profile.fields.healthConditions' },
	    medicationAllergies: { id: 'profile.fields.medicationAllergies' },
	    medicine: { id: 'profile.fields.medicine' },
	    healthGoals: { id: 'profile.fields.healthGoals' },
	    role: { id: 'profile.fields.role' },
	    mrns: { id: 'profile.fields.mrns' },
	    localUidProvider: { id: 'profile.fields.localUidProvider' },
	    npi: { id: 'profile.fields.npi' },
	    title: { id: 'profile.fields.title' },
	    specialty: { id: 'profile.fields.specialty' },
	    primaryPracticeAddress: { id: 'profile.fields.primaryPracticeAddress' },
	    primaryPracticeAddress1: { id: 'profile.fields.primaryPracticeAddress1' },
	    primaryPracticeAddress2: { id: 'profile.fields.primaryPracticeAddress2' },
	    primaryPracticeCity: { id: 'profile.fields.primaryPracticeCity' },
	    primaryPracticeState: { id: 'profile.fields.primaryPracticeState' },
	    primaryPracticeCountry: { id: 'profile.fields.primaryPracticeCountry' },
	    officePhone: { id: 'profile.fields.officePhone' },
	    username: { id: 'profile.fields.username' },
	    aliasName: { id: 'profile.fields.aliasName' },
	    day: { id: 'profile.fields.day' },
	    year: { id: 'profile.fields.year' },
	    month: { id: 'profile.fields.month' },
	    organizations: { id: 'profile.fields.organizations' },
	    employers: { id: 'profile.fields.employers' },
	    ssn: { id: 'profile.fields.ssn' },
	    ssnLong: { id: 'profile.fields.ssnLong' },
	    insuranceCard: { id: 'profile.fields.insuranceCard' },
	    driverLicense: { id: 'profile.fields.driverLicense' },
	    weight: { id: 'profile.fields.weight' },
	    height: { id: 'profile.fields.height' },
	    memberId: { id: 'fields.insurance.memberId' },
	    groupNumber: { id: 'fields.insurance.groupNumber' },
	    preferredPharmacy: { id: 'appointments.form.preferredPharmacy' },
	    healthPlan: { id: 'profile.section.insurance.healthPlan' },
	    verificationDate: { id: 'profile.section.insurance.verificationDate' },
	    race: { id: 'profile.fields.race' },
	    ethnicity: { id: 'profile.fields.ethnic' }
	  }
	};
	
	// TODO:
	var SCREEN_TITLES = exports.SCREEN_TITLES = (_SCREEN_TITLES = {}, (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PATIENT_VIEW_PROFILE, { id: 'routes.patientViewProfile' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PROVIDER_PROFILE, { id: 'routes.providerViewProfile' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PATIENT_PROFILE, { id: 'routes.userViewProfile' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.USER_PROFILE, { id: 'routes.userViewProfile' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PROVIDER_MEMBER_PROFILE, { id: 'routes.providerMemberProfile' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.FAMILY_MEMBER_PROFILE, { id: 'routes.familyMemberProfile' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.TEAM_MEMBER_PROFILE, { id: 'routes.familyMemberProfile' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.SURVEYS_GENERAL_SUB_PATH, { id: 'routes.generalSurveys' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PARENT_PROVIDER, { id: 'routes.parentProvider' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PATIENT_INFO, { id: 'routes.patientInfo' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PATIENT_HEALTHBOARD, { id: 'routes.patientHealthboard' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PROVIDER_INFO, { id: 'routes.providerInfo' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PROFILE_SETTINGS, { id: 'routes.settings' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PROFILE_PAYMENT_METHODS, { id: 'routes.paymentMethods' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.SUPPORT, { id: 'routes.support' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PROFILE_DOCUMENTATION, { id: 'routes.documentation' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.CIRCLE_OF_CARE, { id: 'routes.circleOfCare' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.SURVEYS_GENERAL_SUB_PATH, { id: 'routes.data' }), (0, _defineProperty3.default)(_SCREEN_TITLES, _routes2.default.PROGRAM, { id: 'routes.program' }), _SCREEN_TITLES);
	
	var INTRO = exports.INTRO = {
	  hints: {
	    common: {
	      logout: { id: 'intro.common.logout' },
	      circlesMenu: { id: 'intro.common.circlesMenu' }
	    },
	    circles: {
	      inviteFamilyMember: { id: 'intro.circles.inviteFamilyMember' },
	      assignCaregiver: { id: 'intro.circles.assignCaregiver' },
	      inviteProviderMember: { id: 'intro.circles.inviteProviderMember' },
	      removeProviderMember: { id: 'intro.circles.inviteFamilyMember' }
	    },
	    messages: {
	      searchChat: { id: 'intro.messages.searchChat' },
	      selectChat: { id: 'intro.messages.selectChat' },
	      selectChannel: { id: 'intro.messages.selectChannel' },
	      generalChannel: { id: 'intro.messages.generalChannel' },
	      familyChannel: { id: 'intro.messages.familyChannel' },
	      providerChannel: { id: 'intro.messages.providerChannel' },
	      typeFilter: { id: 'intro.messages.typeFilter' },
	
	      typeMessage: { id: 'intro.messages.typeMessage' },
	      answerSurvey: { id: 'intro.messages.answerSurvey' },
	      patientName: { id: 'intro.messages.patientName' },
	      patientContext: { id: 'intro.messages.patientContext' },
	      patientProgram: { id: 'intro.messages.patientProgram' },
	      programFilter: { id: 'intro.messages.programFilter' }
	    }
	  }
	};
	
	var USER_STATUSES = exports.USER_STATUSES = [{
	  status: _props.USER_STATUS_INVITED,
	  text: 'Invited'
	}, {
	  status: _props.USER_STATUS_CREATED,
	  text: 'Not invited'
	}, {
	  status: _props.USER_STATUS_JOINED,
	  text: 'Joined'
	}];
	
	var COMMUNITY_TYPE_STRINGS = exports.COMMUNITY_TYPE_STRINGS = [{
	  type: _props.COMMUNITY_TYPES.public,
	  text: { id: 'community.type.public' }
	}, {
	  type: _props.COMMUNITY_TYPES.private,
	  text: { id: 'community.type.private' }
	}, {
	  type: _props.COMMUNITY_TYPES.global,
	  text: { id: 'community.type.global' }
	}];
	
	var COMMUNUNNITY_NEW_POST = exports.COMMUNUNNITY_NEW_POST = {
	  title: { id: 'community.newPost.title' },
	  editTitle: { id: 'community.newPost.edit.title' },
	  caption: { id: 'community.newPost.caption' },
	  attachImage: { id: 'community.newPost.attachImage' },
	  attachURL: { id: 'community.newPost.attachURL' },
	  addPost: { id: 'community.newPost.addPost' },
	  editPost: { id: 'community.newPost.editPost' },
	  fileError: { id: 'community.newPost.fileError' },
	  noPreview: { id: 'community.newPost.noPreview' },
	  urlError: { id: 'community.newPost.urlError' },
	  enterUrl: { id: 'community.newPost.enterUrl' },
	  addPhoto: { id: 'community.newPost.addPhoto' },
	  maxAttachmentNumber: { id: 'community.newPost.maxAttachmentNumber' },
	  allowedFormatError: { id: 'community.newPost.allowedFormatError' },
	  sendForApproval: { id: 'community.newPost.sendForApproval' }
	};
	
	var COMMUNITY_POST_MENU = exports.COMMUNITY_POST_MENU = {
	  editPost: { id: 'community.postMenu.editPost' },
	  deletePost: { id: 'community.postMenu.deletePost' },
	  confirmDeleteMessage: { id: 'community.postMenu.confirmDeleteMessage' },
	  report: { id: 'community.postMenu.report' }
	};
	
	var COMMUNITY_COMMENT_MENU = exports.COMMUNITY_COMMENT_MENU = {
	  editComment: { id: 'community.commentMenu.editComment' },
	  deleteComment: { id: 'community.commentMenu.deleteComment' },
	  confirmDeleteComment: { id: 'community.commentMenu.confirmDeleteComment' },
	  report: { id: 'community.commentMenu.report' },
	  shareLink: { id: 'community.commentMenu.shareLink' }
	};
	
	var COMMUNITY_COMMENTS = exports.COMMUNITY_COMMENTS = {
	  commentWasDeleted: { id: 'community.comments.commentWasDeleted' },
	  commentWasDeletedByModerator: {
	    id: 'community.comments.commentWasDeletedByModerator'
	  }
	};
	
	var COMMUNITY_AUTHOR_ROLE = exports.COMMUNITY_AUTHOR_ROLE = {
	  moderator: { id: 'community.roles.moderator' },
	  member: { id: 'community.roles.member' }
	};
	
	var COMMUNITIES_COMMON = exports.COMMUNITIES_COMMON = {
	  fromOrganization: { id: 'communities.title.fromOrganization' },
	  otherCommunities: { id: 'communities.title.otherCommunities' },
	  seeAll: { id: 'communities.title.seeAll' },
	  posts: { id: 'communities.title.posts' },
	  joinRequests: { id: 'communities.title.joinRequests' },
	  invites: { id: 'communities.title.invites' },
	  share: { id: 'communities.title.share' },
	  join: { id: 'communities.title.join' },
	  signUpToJoin: { id: 'communities.title.signUpToJoin' },
	  requested: { id: 'communities.title.requested' },
	  seeNewPosts: { id: 'communities.title.seeNewPosts' }
	};
	
	var DIALOG_TITLE = exports.DIALOG_TITLE = {
	  joinCircle: { id: 'dialog.titles.joinCircle' },
	  noPatients: { id: 'dialog.common.noPatients' },
	  addDependent: { id: 'dialog.titles.addDependent' },
	  assign: { id: 'dialog.common.assign' },
	  addPatient: { id: 'dialog.common.addPatient' },
	  addNewPatient: { id: 'dialog.common.addNewPatient' },
	  defaultPatientAssign: { id: 'dialog.common.defaultPatient' },
	  assignProviderToPatient: { id: 'dialog.titles.assignProviderToPatient' },
	  assignProviderOrTeamToPatient: {
	    id: 'dialog.titles.assignProviderOrTeamToPatient'
	  },
	  defaultProviderAssign: { id: 'dialog.common.defaultProvider' },
	  assignProvider: { id: 'dialog.common.assignProvider' },
	  assignProviderOrTeam: { id: 'dialog.common.assignProviderOrTeam' },
	  searchProvider: { id: 'dialog.common.searchProvider' },
	  searchPatient: { id: 'dialog.common.searchPatient' },
	  inviteCaregiver: { id: 'dialog.common.inviteCaregiver' },
	  addPatientTitle: { id: 'dialog.titles.addPatient' },
	  emergencyContactTitle: { id: 'dialog.titles.emergencyContact' },
	  andOr: { id: 'dialog.titles.andOr' },
	  and: { id: 'dialog.titles.and' },
	  join: { id: 'dialog.titles.join' },
	  accessRequested: { id: 'dialog.titles.accessRequested' },
	  addAnotherPatient: { id: 'dialog.common.addAnotherPatient' },
	  copiedToClipboard: { id: 'dialog.titles.copiedToClipboard' },
	  shareableLink: { id: 'dialog.titles.shareableLink' },
	  alreadyMember: { id: 'dialog.common.alreadyMember' }
	};
	
	var SUCCESS_JOIN_CIRCLE = exports.SUCCESS_JOIN_CIRCLE = { id: 'dialog.success.joinCircle' };
	
	var SURVEYS_ASSIGNMENT_TITLE = exports.SURVEYS_ASSIGNMENT_TITLE = (_SURVEYS_ASSIGNMENT_T = {}, (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_T, _constants.ASSIGNMENT_METHOD.PROGRAM, { id: 'surveys.method.program' }), (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_T, _constants.ASSIGNMENT_METHOD.PROVIDER, { id: 'surveys.method.provider' }), (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_T, _constants.ASSIGNMENT_METHOD.BY_SYSTEM, { id: 'surveys.method.system' }), (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_T, _constants.ASSIGNMENT_METHOD.PRE_VISIT_FORM, { id: 'surveys.preVisit.preVisitForm' }), (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_T, _constants.ASSIGNMENT_METHOD.REFERRAL_FORM, { id: 'surveys.method.referralForm' }), _SURVEYS_ASSIGNMENT_T);
	
	var SURVEYS_ASSIGNMENT_DESC = exports.SURVEYS_ASSIGNMENT_DESC = (_SURVEYS_ASSIGNMENT_D = {}, (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_D, _constants.ASSIGNMENT_METHOD.PROGRAM, { id: 'surveys.desc.program' }), (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_D, _constants.ASSIGNMENT_METHOD.PROVIDER, { id: 'surveys.desc.provider' }), (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_D, _constants.ASSIGNMENT_METHOD.BY_SYSTEM, { id: 'surveys.desc.system' }), (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_D, _constants.ASSIGNMENT_METHOD.PRE_VISIT_FORM, { id: 'surveys.desc.system' }), (0, _defineProperty3.default)(_SURVEYS_ASSIGNMENT_D, _constants.ASSIGNMENT_METHOD.REFERRAL_FORM, { id: 'surveys.desc.provider' }), _SURVEYS_ASSIGNMENT_D);
	
	var TODO_ASSIGNMENT_TITLE = exports.TODO_ASSIGNMENT_TITLE = (_TODO_ASSIGNMENT_TITL = {}, (0, _defineProperty3.default)(_TODO_ASSIGNMENT_TITL, _constants2.TODO_ASSIGNMENT_METHOD.SYSTEM, { id: 'surveys.method.system' }), (0, _defineProperty3.default)(_TODO_ASSIGNMENT_TITL, _constants2.TODO_ASSIGNMENT_METHOD.PROVIDER, { id: 'surveys.method.provider' }), (0, _defineProperty3.default)(_TODO_ASSIGNMENT_TITL, _constants2.TODO_ASSIGNMENT_METHOD.EMPLOYER, { id: 'surveys.method.employer' }), _TODO_ASSIGNMENT_TITL);
	
	var SUCCESS_SENT_DOCUMENT_TO_EMAIL = exports.SUCCESS_SENT_DOCUMENT_TO_EMAIL = {
	  id: 'patient.portal.healthRecord.shareToEmailSuccess'
	};
	
	var DEFAULT_EMPTY_VALUE = exports.DEFAULT_EMPTY_VALUE = '-';

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable react/button-has-type,react/require-default-props */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(2241);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/*
	 * TODO: aria-attrs
	 * */
	
	var Button = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(Button, _PureComponent);
	
	  function Button() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Button);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).call.apply(_ref, [this].concat(args))), _this), _this.button = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'removeFocus',
	    value: function removeFocus() {
	      this.button.blur();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          color = _props.color,
	          disabled = _props.disabled,
	          raised = _props.raised,
	          border = _props.border,
	          icon = _props.icon,
	          ariaLabel = _props.ariaLabel,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'color', 'disabled', 'raised', 'border', 'icon', 'ariaLabel']);
	
	
	      return _react2.default.createElement('button', (0, _extends3.default)({}, (0, _extends3.default)({ children: children, className: className, disabled: disabled }, other), {
	        styleName: (0, _classnames2.default)('root', (0, _defineProperty3.default)({}, 'root--color--' + color, color), { 'root--disabled': disabled }, { 'root--raised': raised }, { 'root--icon': icon }, { 'root--border': border }),
	        ref: function ref(node) {
	          return _this2.button = node;
	        },
	        onMouseUp: function onMouseUp() {
	          return _this2.removeFocus();
	        },
	        'aria-label': ariaLabel || 'button'
	      }));
	    }
	  }]);
	  return Button;
	}(_react.PureComponent), _class3.propTypes = {
	  children: _propTypes2.default.any,
	  className: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  raised: _propTypes2.default.bool,
	  icon: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  ariaLabel: _propTypes2.default.string
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'removeFocus', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'removeFocus'), _class2.prototype)), _class2)) || _class);
	exports.default = Button;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEPENDENT_FORM_SUBMIT_REDIRECT = exports.EMPLOYER_NOT_LISTED_VALUE = exports.PATIENT_INSURANCE_STATUS = exports.USA_POSTAL_CODE_EXAMPLES = exports.FEATURE_TOGGLE_CONFIG = exports.VIRTUAL_VISIT_INVITE_TYPE = exports.SUBSCRIPTION_STATUS = exports.TRANSACTION_TYPE = exports.SUBSCRIBABLE_TYPE = exports.AUTH_AZURE_ERROR_CODE = exports.AUTH_AZURE_REDIRECT = exports.PATIENT_ATTACHMENTS_TYPE = exports.STATUS_DEPENDENT_VERIFIED = exports.TEMPERATURE_METRIC = exports.HEIGHT_METRIC = exports.WEIGHT_METRIC = exports.GLUCOSE_METRIC = exports.APPOINTMENT_REQUEST_STATUS = exports.PROVIDER_CALENDAR_SOURCE = exports.VISIT_TYPES = exports.SUPPORTED_BROWSERS = exports.REQUEST_HEADERS_OPTIONS = exports.TODO_TYPES = exports.INVITATION_TYPES = exports.VIRTUAL_VISIT_EVENTS = exports.EIR_APPOINTMENT_TYPES = exports.APPOINTMENT_HIDDEN_TYPES = exports.APPOINTMENT_ALLOWED_TYPES = exports.INLINE_TYPES = exports.SHOW_ADDITIONAL_INFO_AFTER_TIME_SLOTS = exports.FORBIDDEN_VISIT_TYPES_FOR_MAP = exports.WALK_IN_SOURCES = exports.SOURCE_OF_CREATION = exports.TELEMEDICINE_VISIT_TYPE_CODE = exports.HOLD_MY_SPOT_VISIT_TYPE_CODE = exports.PUBLIX_CODE = exports.TECH_CONNECT_CODE = exports.LAB_TYPE_CODE = exports.IMAGING_TYPE_CODE = exports.URGENT_CARE_TYPE_CODE = exports.KIOSK_TYPE_CODE = exports.AW_TYPE_CODE = exports.VIRTUAL_VISIT_TYPE_CODE = exports.URGENT_VISIT_TYPE_CODE = exports.OFFICE_VISIT_TYPE_CODE = exports.APPOINTMENT_MENU = exports.APPOINTMENT_CHANNEL_ID = exports.COMPLETED_STATUSES = exports.TODO_STATUSES = exports.FAILED_PAYMENT_STATUSES = exports.PAYMENT_STATUSES = exports.COMPLETED_APPOINTMENT_STATUSES = exports.APPOINTMENT_STATUSES = exports.APPOINTMENT_INSPECTION = exports.POPOVER_MENU_ITEMS = exports.CIRCLE_TYPES = exports.EMPTY_ROLE = exports.DEPENDENT_ROLES = exports.FIELDS_TYPE = exports.SURVEYS_STATUS_TYPE = exports.SURVEYS_LIST_TYPE = exports.OCR_CONTEXT = exports.RECORD_TYPE = exports.INSURANCE_CARD_SIDE = exports.DOCUMENTATION_TYPES = exports.DOCUMENT_ALLOWED_FORMATS = exports.MAX_TASK_ATTACHMENT_SIZE_ALLOWED = exports.TASK_FILE_EXTENSIONS = exports.TASK_DOCUMENTS_FORMATS = exports.IMAGE_ALLOWED_FORMATS = exports.PROFILE_SECTIONS = exports.ORGANIZATION_COMMUNITIES_NUMBER_MAX = exports.COMMUNITY_BTN_ACTIONS = exports.DISCOVERY_LIST_TYPES = exports.ACTIVITY_TYPES = exports.EDIT_COMMUNITY_VALIDATION_RULES = exports.COMPLAINT_TYPE = exports.COMMUNITIES_USER_ROLES = exports.COMMINITY_APPROVAL_STATUS_PENDING = exports.COMMUNITIES_ACCESS_LEVELS = exports.TITLE = exports.getTitle = exports.getNavConfig = exports.DEFAULT_COUNTRY = exports.SLOGAN_SECONDARY = exports.SLOGAN_PRIMARY = exports.DESCRIPTION = exports.LANG = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _routes = __webpack_require__(37);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _strings = __webpack_require__(15);
	
	var _ids = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LANG = exports.LANG = 'en';
	var DESCRIPTION = exports.DESCRIPTION = { id: 'general.description' };
	var SLOGAN_PRIMARY = exports.SLOGAN_PRIMARY = { id: 'general.slogan.primary' };
	var SLOGAN_SECONDARY = exports.SLOGAN_SECONDARY = { id: 'general.slogan.secondary' };
	
	var DEFAULT_COUNTRY = exports.DEFAULT_COUNTRY = 'USA';
	
	var getNavConfig = exports.getNavConfig = function getNavConfig(formatMessage, dashboardAccess, id, isProvider) {
	  var menu = [{
	    href: _routes2.default.HEALTHBOARD + '/' + id + '/' + _routes2.default.HEALTHBOARD_HOME,
	    id: isProvider ? _ids.IDS.NAV_BAR.HEALTH_BOARD : _ids.IDS.NAV_BAR.HOME,
	    title: isProvider ? formatMessage(_strings.MENU.healthboard) : formatMessage(_strings.MENU.home)
	  }].concat((0, _toConsumableArray3.default)(!isProvider && [{
	    href: _routes2.default.PATIENT_HEALTHBOARD,
	    id: _ids.IDS.NAV_BAR.HEALTH_BOARD,
	    title: formatMessage(_strings.MENU.healthboard)
	  }]), [{
	    href: _routes2.default.COMMUNITIES,
	    id: _ids.IDS.NAV_BAR.COMMUNITIES,
	    title: formatMessage(_strings.MENU.communities)
	  }, {
	    href: _routes2.default.MESSAGES,
	    id: _ids.IDS.NAV_BAR.MESSAGES,
	    title: formatMessage(_strings.MENU.messages)
	  }, {
	    href: _routes2.default.CIRCLES,
	    id: _ids.IDS.NAV_BAR.CIRCLES,
	    title: formatMessage(_strings.MENU.myCircles)
	  }]);
	
	  var dashboardOptions = {
	    href: _routes2.default.DASHBOARD.slice(1),
	    id: _ids.IDS.NAV_BAR.DASHBOARD,
	    title: formatMessage(_strings.MENU.dashboard)
	  };
	
	  return dashboardAccess ? [].concat((0, _toConsumableArray3.default)(menu), [dashboardOptions]) : [].concat((0, _toConsumableArray3.default)(menu));
	};
	
	var getTitle = exports.getTitle = function getTitle(formatMessage) {
	  return formatMessage(_strings.TITLE);
	};
	exports.TITLE = _strings.TITLE;
	var COMMUNITIES_ACCESS_LEVELS = exports.COMMUNITIES_ACCESS_LEVELS = {
	  READ_AND_POST: 'read_and_post',
	  READ_ONLY: 'read_only',
	  READ_AND_POST_WITH_APPROVAL: 'read_and_post_with_approval'
	};
	
	var COMMINITY_APPROVAL_STATUS_PENDING = exports.COMMINITY_APPROVAL_STATUS_PENDING = 'pending';
	
	var COMMUNITIES_USER_ROLES = exports.COMMUNITIES_USER_ROLES = {
	  MODERATOR: 'moderator',
	  MEMBER: 'member'
	};
	
	var COMPLAINT_TYPE = exports.COMPLAINT_TYPE = {
	  POST: 'post',
	  COMMENT: 'comment',
	  COMMUNITY: 'community'
	};
	
	var EDIT_COMMUNITY_VALIDATION_RULES = exports.EDIT_COMMUNITY_VALIDATION_RULES = {
	  NAME_MIN_LENGTH: 2,
	  NAME_MAX_LENGTH: 32,
	  DESCRIPTION_MAX_LENGTH: 2000
	};
	
	var ACTIVITY_TYPES = exports.ACTIVITY_TYPES = {
	  NOTIFICATIONS: 'notifications',
	  JOIN_REQUESTS: 'join_requests',
	  MEMBER_INVITATIONS: 'member_invitations'
	};
	
	var DISCOVERY_LIST_TYPES = exports.DISCOVERY_LIST_TYPES = {
	  ORGANIZATION: 'organization',
	  GLOBAL: 'global'
	};
	
	var COMMUNITY_BTN_ACTIONS = exports.COMMUNITY_BTN_ACTIONS = {
	  ACCEPT: 'accept',
	  JOIN: 'join',
	  DECLINE: 'decline'
	};
	
	var ORGANIZATION_COMMUNITIES_NUMBER_MAX = exports.ORGANIZATION_COMMUNITIES_NUMBER_MAX = 8;
	
	var PROFILE_SECTIONS = exports.PROFILE_SECTIONS = {
	  EMERGENCY_CONTACT: 'emergency_contact'
	};
	
	var IMAGE_ALLOWED_FORMATS = exports.IMAGE_ALLOWED_FORMATS = ['image/jpeg', 'image/jpg', 'image/png', '.jpeg', '.jpg', '.png'];
	
	var TASK_DOCUMENTS_FORMATS = exports.TASK_DOCUMENTS_FORMATS = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
	
	var TASK_FILE_EXTENSIONS = exports.TASK_FILE_EXTENSIONS = ['jpeg', 'jpg', 'png', 'pdf'];
	
	var MAX_TASK_ATTACHMENT_SIZE_ALLOWED = exports.MAX_TASK_ATTACHMENT_SIZE_ALLOWED = 32;
	
	var DOCUMENT_ALLOWED_FORMATS = exports.DOCUMENT_ALLOWED_FORMATS = ['application/pdf', 'text/xml'];
	
	var DOCUMENTATION_TYPES = exports.DOCUMENTATION_TYPES = {
	  CARD_1: 'insurance_card_1',
	  CARD_2: 'insurance_card_2',
	  DRIVER_LICENCE: 'driver_licensce'
	};
	
	var INSURANCE_CARD_SIDE = exports.INSURANCE_CARD_SIDE = {
	  FRONT: 'front_side',
	  BACK: 'back_side'
	};
	
	var RECORD_TYPE = exports.RECORD_TYPE = {
	  DOCUMENT: 'Document',
	  PATIENT_INSURANCE: 'PatientInsurance'
	};
	
	var OCR_CONTEXT = exports.OCR_CONTEXT = {
	  INSURANCE_CARD: 'insurance_card'
	};
	
	var SURVEYS_LIST_TYPE = exports.SURVEYS_LIST_TYPE = {
	  UPCOMING: 'upcoming',
	  RESULTS: 'results'
	};
	
	var SURVEYS_STATUS_TYPE = exports.SURVEYS_STATUS_TYPE = {
	  IN_PROGRESS: 'in_progress',
	  STARTED: 'started'
	};
	var FIELDS_TYPE = exports.FIELDS_TYPE = {
	  SELECT: 'select',
	  IMAGE: 'image',
	  DATE: 'date',
	  TEXTAREA: 'textarea',
	  PASSWORD: 'password',
	  TEXT: 'text',
	  CUSTOM_TIME_PICKER: 'customTimePicker',
	  MOBILE_PHONE: 'mobilePhone'
	};
	
	var DEPENDENT_ROLES = exports.DEPENDENT_ROLES = {
	  PARENT: 'parent',
	  GUARDIAN: 'guardian',
	  PROXY: 'proxy'
	};
	
	var EMPTY_ROLE = exports.EMPTY_ROLE = 'none';
	
	var CIRCLE_TYPES = exports.CIRCLE_TYPES = {
	  FAMILY_CIRCLE: 'family_circle',
	  PROVIDER_CIRCLE: 'provider_circle'
	};
	
	var POPOVER_MENU_ITEMS = exports.POPOVER_MENU_ITEMS = {
	  CHANGE_ROLE: 'changeRole',
	  UNASSIGN: 'unassign',
	  INVITE_MEMBER: 'inviteMember',
	  REMOVE_MEMBER: 'removeMember',
	  REMOVE_FROM_COMMUNITY: 'removeFromCommunity',
	  CANCEL_PENDING_INVITATION: 'cancelPendingInvitation',
	  INVITE_PATIENT: 'invitePatient',
	  REINVITE_PATIENT: 'reinvitePatient'
	};
	
	var APPOINTMENT_INSPECTION = exports.APPOINTMENT_INSPECTION = {
	  CONSENT: 'consent_form',
	  PROFILE: 'profile_form',
	  DOCUMENTS: 'documents_form',
	  LOCAL_PROFILE: 'local_appointment_profile_form'
	};
	
	var APPOINTMENT_STATUSES = exports.APPOINTMENT_STATUSES = {
	  DRAFT: 'Draft',
	  WAITING: 'Waiting',
	  PENDING: 'Pending',
	  IN_LINE: 'In Line',
	  ARRIVED: 'Arrived',
	  NO_SHOW: 'No show',
	  UPCOMING: 'Upcoming',
	  CANCELED: 'Canceled',
	  DECLINED: 'Declined',
	  COMPLETED: 'Completed',
	  TREATMENT: 'Treatment',
	  SCHEDULED: 'Scheduled',
	  CHECKED_IN: 'Checked-In',
	  IN_PROCESS: 'In Process',
	  DISCHARGED: 'Discharged',
	  REGISTERED_WAITING: 'Registered & Waiting'
	};
	
	var COMPLETED_APPOINTMENT_STATUSES = exports.COMPLETED_APPOINTMENT_STATUSES = [APPOINTMENT_STATUSES.NO_SHOW, APPOINTMENT_STATUSES.CANCELED, APPOINTMENT_STATUSES.DECLINED, APPOINTMENT_STATUSES.COMPLETED];
	
	var PAYMENT_STATUSES = exports.PAYMENT_STATUSES = {
	  UNPAID: 'unpaid',
	  PENDING: 'pending',
	  PAID: 'paid',
	  FAILED: 'failed',
	  VOIDED: 'voided'
	};
	
	var FAILED_PAYMENT_STATUSES = exports.FAILED_PAYMENT_STATUSES = [PAYMENT_STATUSES.FAILED, PAYMENT_STATUSES.VOIDED];
	
	var TODO_STATUSES = exports.TODO_STATUSES = {
	  CANCELED: 'canceled',
	  COMPLETED: 'completed'
	};
	
	var COMPLETED_STATUSES = exports.COMPLETED_STATUSES = [TODO_STATUSES.CANCELED, TODO_STATUSES.COMPLETED];
	
	var APPOINTMENT_CHANNEL_ID = exports.APPOINTMENT_CHANNEL_ID = 'appointment_channel';
	var APPOINTMENT_MENU = exports.APPOINTMENT_MENU = {
	  type: 'system',
	  channelName: 'apointments',
	  blocked: false,
	  lastMessage: {},
	  channelId: APPOINTMENT_CHANNEL_ID,
	  icon: 'icon-appointments',
	  title: { id: 'healthboard.title.appointments' }
	};
	
	var OFFICE_VISIT_TYPE_CODE = exports.OFFICE_VISIT_TYPE_CODE = 'O';
	var URGENT_VISIT_TYPE_CODE = exports.URGENT_VISIT_TYPE_CODE = 'E';
	var VIRTUAL_VISIT_TYPE_CODE = exports.VIRTUAL_VISIT_TYPE_CODE = 'W';
	var AW_TYPE_CODE = exports.AW_TYPE_CODE = 'V';
	var KIOSK_TYPE_CODE = exports.KIOSK_TYPE_CODE = 'K';
	var URGENT_CARE_TYPE_CODE = exports.URGENT_CARE_TYPE_CODE = 'U';
	var IMAGING_TYPE_CODE = exports.IMAGING_TYPE_CODE = 'R';
	var LAB_TYPE_CODE = exports.LAB_TYPE_CODE = 'L';
	var TECH_CONNECT_CODE = exports.TECH_CONNECT_CODE = 'T';
	var PUBLIX_CODE = exports.PUBLIX_CODE = 'P';
	var HOLD_MY_SPOT_VISIT_TYPE_CODE = exports.HOLD_MY_SPOT_VISIT_TYPE_CODE = 'EIR-HMS';
	var TELEMEDICINE_VISIT_TYPE_CODE = exports.TELEMEDICINE_VISIT_TYPE_CODE = 'EIR-TM';
	
	var SOURCE_OF_CREATION = exports.SOURCE_OF_CREATION = {
	  EIR: 'eir',
	  APP: 'app',
	  KIOSK: 'kiosk',
	  PWS: 'pws',
	  QR_KIOSK: 'qr-kiosk',
	  PWS_WALK_IN: 'pws-walk-in'
	};
	
	var WALK_IN_SOURCES = exports.WALK_IN_SOURCES = [SOURCE_OF_CREATION.KIOSK, SOURCE_OF_CREATION.QR_KIOSK, SOURCE_OF_CREATION.PWS_WALK_IN];
	
	var FORBIDDEN_VISIT_TYPES_FOR_MAP = exports.FORBIDDEN_VISIT_TYPES_FOR_MAP = [AW_TYPE_CODE, VIRTUAL_VISIT_TYPE_CODE, URGENT_VISIT_TYPE_CODE, TELEMEDICINE_VISIT_TYPE_CODE];
	
	var SHOW_ADDITIONAL_INFO_AFTER_TIME_SLOTS = exports.SHOW_ADDITIONAL_INFO_AFTER_TIME_SLOTS = [OFFICE_VISIT_TYPE_CODE, VIRTUAL_VISIT_TYPE_CODE];
	
	var INLINE_TYPES = exports.INLINE_TYPES = [URGENT_CARE_TYPE_CODE, IMAGING_TYPE_CODE, LAB_TYPE_CODE, TECH_CONNECT_CODE];
	
	var APPOINTMENT_ALLOWED_TYPES = exports.APPOINTMENT_ALLOWED_TYPES = [OFFICE_VISIT_TYPE_CODE, URGENT_VISIT_TYPE_CODE, VIRTUAL_VISIT_TYPE_CODE, URGENT_CARE_TYPE_CODE, IMAGING_TYPE_CODE, LAB_TYPE_CODE, TECH_CONNECT_CODE, PUBLIX_CODE, HOLD_MY_SPOT_VISIT_TYPE_CODE, TELEMEDICINE_VISIT_TYPE_CODE];
	
	var APPOINTMENT_HIDDEN_TYPES = exports.APPOINTMENT_HIDDEN_TYPES = [KIOSK_TYPE_CODE];
	
	var EIR_APPOINTMENT_TYPES = exports.EIR_APPOINTMENT_TYPES = [HOLD_MY_SPOT_VISIT_TYPE_CODE, TELEMEDICINE_VISIT_TYPE_CODE];
	
	var VIRTUAL_VISIT_EVENTS = exports.VIRTUAL_VISIT_EVENTS = {
	  START_VISIT: 'start_visit',
	  BREAK_VISIT: 'break_visit',
	  FINISH_VISIT: 'finish_visit',
	  DECLINE_VISIT: 'decline_visit'
	};
	
	var INVITATION_TYPES = exports.INVITATION_TYPES = {
	  FAMILY_MEMBER: 'FamilyMemberInvitation',
	  GUARDIAN_PROXY: 'GuardianProxyInvitation',
	  CAREGIVER: 'CaregiverInvitation'
	};
	
	var TODO_TYPES = exports.TODO_TYPES = {
	  INVITATION: 'invitation',
	  SURVEY: 'survey',
	  CONSENT: 'appointment_consents_assignment',
	  TASK: 'todo_task_assignment',
	  TASK_CUSTOM: 'todo_custom_task',
	  CARE_PLAN_TASK: 'care_plan_task',
	  PROGRAM: 'program_invitation',
	  CONSENT_USER_ASSIGNMENT: 'consent_user_assignment'
	};
	
	var REQUEST_HEADERS_OPTIONS = exports.REQUEST_HEADERS_OPTIONS = {
	  SELECTED_TEAM: 'Selected-Team',
	  ORGANIZATION_CODE: 'Organization-Code'
	};
	
	var SUPPORTED_BROWSERS = exports.SUPPORTED_BROWSERS = ['Chrome', 'Firefox', 'Microsoft Edge', 'Safari'];
	
	var VISIT_TYPES = exports.VISIT_TYPES = {
	  imagining: 7,
	  techConnect: 10
	};
	
	var PROVIDER_CALENDAR_SOURCE = exports.PROVIDER_CALENDAR_SOURCE = 'provider_calendar';
	
	var APPOINTMENT_REQUEST_STATUS = exports.APPOINTMENT_REQUEST_STATUS = {
	  DECLINED: 'declined',
	  CONFIRMED: 'confirmed',
	  PENDING: 'pending'
	};
	
	var GLUCOSE_METRIC = exports.GLUCOSE_METRIC = {
	  MG_PER_DECILITER: 'mg/dL',
	  MMOL_PER_LITER: 'mmol/L'
	};
	
	var WEIGHT_METRIC = exports.WEIGHT_METRIC = {
	  KG: 'kilograms',
	  POUNDS: 'pounds'
	};
	
	var HEIGHT_METRIC = exports.HEIGHT_METRIC = {
	  METERS: 'meters',
	  FEET_INCHES: 'feet_and_inches'
	};
	
	var TEMPERATURE_METRIC = exports.TEMPERATURE_METRIC = {
	  CELSIUS: 'celsius',
	  FAHRENHEIT: 'fahrenheit'
	};
	var STATUS_DEPENDENT_VERIFIED = exports.STATUS_DEPENDENT_VERIFIED = 'verified';
	
	var PATIENT_ATTACHMENTS_TYPE = exports.PATIENT_ATTACHMENTS_TYPE = {
	  DOCUMENTS: 'documents',
	  OUTCOME_ATTACHMENTS: 'outcomeAttachments'
	};
	
	var AUTH_AZURE_REDIRECT = exports.AUTH_AZURE_REDIRECT = {
	  SIGN_UP: 'authorize-azure-sign-up-flow',
	  SUCCESS: 'authorize-azure-success',
	  ERROR: 'authorize-azure-error'
	};
	
	var AUTH_AZURE_ERROR_CODE = exports.AUTH_AZURE_ERROR_CODE = {
	  NOT_FOUND: 'record_not_found',
	  NOT_CONFIRMED: 'login_email_not_confirmed',
	  USER_DISABLED: 'user_disabled'
	};
	
	var SUBSCRIBABLE_TYPE = exports.SUBSCRIBABLE_TYPE = {
	  PROGRAM: 'program',
	  LOCATION: 'location'
	};
	
	var TRANSACTION_TYPE = exports.TRANSACTION_TYPE = {
	  USER_SUBSCRIPTION: 'user_subscription'
	};
	
	var SUBSCRIPTION_STATUS = exports.SUBSCRIPTION_STATUS = {
	  ACTIVE: 'active',
	  DEACTIVATED: 'deactivated',
	  EXPIRED: 'expired',
	  PENDING: 'pending',
	  PREPAID: 'prepaid'
	};
	
	var VIRTUAL_VISIT_INVITE_TYPE = exports.VIRTUAL_VISIT_INVITE_TYPE = {
	  GUEST: 'guest',
	  PATIENT: 'patient',
	  IN_OFFICE: 'in-office',
	  CONNECTION_ROOM: 'connection'
	};
	
	var FEATURE_TOGGLE_CONFIG = exports.FEATURE_TOGGLE_CONFIG = {
	  MEDICATION_REFILL: 'userMedicationRefills'
	};
	
	var USA_POSTAL_CODE_EXAMPLES = exports.USA_POSTAL_CODE_EXAMPLES = '32909 or 32909-9125';
	
	var PATIENT_INSURANCE_STATUS = exports.PATIENT_INSURANCE_STATUS = {
	  DRAFT: 'draft',
	  COMPLETED: 'completed'
	};
	
	var EMPLOYER_NOT_LISTED_VALUE = exports.EMPLOYER_NOT_LISTED_VALUE = 'EMPLOYER_NOT_LISTED';
	
	var DEPENDENT_FORM_SUBMIT_REDIRECT = exports.DEPENDENT_FORM_SUBMIT_REDIRECT = {
	  PROFILE: 'PROFILE',
	  GET_CARE: 'GET_CARE'
	};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Consts
	var BORDER_RADIUS = exports.BORDER_RADIUS = '4px';
	var EXTRA_SPACE = exports.EXTRA_SPACE = '8px';
	var BREAKPOINT = exports.BREAKPOINT = 768;
	var BREAKPOINT_XGA = exports.BREAKPOINT_XGA = 1024;
	var BREAKPOINT_LG = exports.BREAKPOINT_LG = 1440;
	var BREAKPOINT_HD_PLUS = exports.BREAKPOINT_HD_PLUS = 1650;
	var BREAKPOINT_FULL_HD = exports.BREAKPOINT_FULL_HD = 1920;
	var MEDIA_QUERY = exports.MEDIA_QUERY = '(max-width: ' + BREAKPOINT + 'px)';
	var RETINA_RESOLUTION = exports.RETINA_RESOLUTION = '2dppx';
	var CAPTURE_MAX_HEIGHT = exports.CAPTURE_MAX_HEIGHT = 171;
	var DESCRIPTION_MAX_HEIGHT = exports.DESCRIPTION_MAX_HEIGHT = 142;
	var DESCRIPTION_MAX_SYMBOLS = exports.DESCRIPTION_MAX_SYMBOLS = 310;
	var LABEL_FONT = exports.LABEL_FONT = '12px';
	var INPUT_FONT = exports.INPUT_FONT = '14px';
	var INPUT_HEIGHT = exports.INPUT_HEIGHT = 35;
	var INPUT_PADDING = exports.INPUT_PADDING = '8px';
	var INPUT_BORDER = exports.INPUT_BORDER = {
	  width: '1px',
	  style: 'solid'
	};
	
	var COLORS = exports.COLORS = {
	  blueBrighten: '#0085ba',
	  bluePrimary: '#5476a4',
	  flaglerDarkBlue: '#0077A6',
	  sectionTitleFont: '#2a5690',
	  blueDark: '#3b557a',
	  blueMedium: '#316cba',
	  blueAccent: '#1eb7eb',
	  cloudyBlue: '#bcc3d0',
	  grayBluish: '#f4f6f9',
	  cyanBluishGray: '#b8bfc3',
	  lightGray: '#e5e5e5',
	  grayDark: '#26414a',
	  orange: '#ffa716',
	  peach: '#ffc37d',
	  orangeCoral: '#fef7f0',
	  orangeSquash: '#f6a623',
	  orangeRed: '#f87f5c',
	  white: '#ffffff',
	  sanMarino: 'rgba(84,118,164,0.1)', // bluePrimary 0.1
	  darkSlateBlue: 'rgba(28, 84, 102, 0.75)',
	  lightTurquoise: 'rgba(127,235,185,0.17)',
	  stormyBlue: 'rgba(84, 118, 164)',
	  fontLight: '#4a4a4a',
	  fontLighter: '#60757C',
	  fontPrimary: '#326cba',
	  fontRegular: '#264149',
	  orangePink: '#ff7159',
	  alert: '#fff8f1',
	  black: '#000',
	  greenLime: '#2ad69b',
	  blueGrayish: '#eef2f9',
	  blueAccentPlus: '#0fc0fc'
	};
	
	// Const Styles
	var NOTIFICATION_ICON = exports.NOTIFICATION_ICON = {
	  HEALTH_ALERT: 'health-alert',
	  UPCOMING_SURVEY: 'up-surveys',
	  ASSIGN_TO_PROGRAM: 'program',
	  REMOVE_FROM_PROGRAM: 'program',
	  AUTO_RESPONSE: 'survey-result',
	  ANSWERED_SURVEY: 'survey-result'
	};
	
	var PROFILE_MENU_ICON = exports.PROFILE_MENU_ICON = {
	  BACK: 'back-healthboard',
	  PROVIDER_INF0: 'provider-info',
	  DETAILED_PROFILE: 'member',
	  PATIENT_INFO: 'patient-info',
	  PATIENT_HEALTHBOARD: 'programs',
	  DATA: 'data',
	  CIRCLE_OF_CARE: 'circle-of-care',
	  PROGRAM: 'program-2',
	  PROFILE_SETTINGS: 'settings',
	  PROFILE_PAYMENT_METHODS: 'payment-methods',
	  PROFILE_DOCUMENTATION: 'doc',
	  SUPPORT: 'support'
	};
	
	var THEMES = exports.THEMES = {
	  FLAGLER: 'flagler'
	};
	
	var FONT_FAMILY = exports.FONT_FAMILY = {
	  primary: "'Nunito Sans', Helvetica, Arial, sans-serif",
	  secondary: 'NunitoSans-Regular'
	};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(551);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var _extends = _interopDefault(__webpack_require__(6418));
	var shallowEqual = _interopDefault(__webpack_require__(959));
	var _inheritsLoose = _interopDefault(__webpack_require__(6419));
	var reactLifecyclesCompat = __webpack_require__(1616);
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(6420));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(6421));
	var changeEmitter = __webpack_require__(1977);
	var $$observable = _interopDefault(__webpack_require__(1050));
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	
	    return BaseComponent;
	  };
	};
	
	var setDisplayName = function setDisplayName(displayName) {
	  return setStatic('displayName', displayName);
	};
	
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + "(" + getDisplayName(BaseComponent) + ")";
	};
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
	    }
	
	    return MapProps;
	  };
	};
	
	var withProps = function withProps(input) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var pick = function pick(obj, keys) {
	  var result = {};
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	
	  return result;
	};
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !shallowEqual(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          computedProps: propsMapper(_this.props),
	          prevProps: _this.props
	        };
	        return _this;
	      }
	
	      WithPropsOnChange.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	        if (shouldMap(prevState.prevProps, nextProps)) {
	          return {
	            computedProps: propsMapper(nextProps),
	            prevProps: nextProps
	          };
	        }
	
	        return {
	          prevProps: nextProps
	        };
	      };
	
	      var _proto = WithPropsOnChange.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(React.Component);
	
	    reactLifecyclesCompat.polyfill(WithPropsOnChange);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	
	    return WithPropsOnChange;
	  };
	};
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	
	
	  return result;
	};
	
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithHandlers =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _this;
	
	        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	          _args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
	        _this.handlers = mapValues(typeof handlers === 'function' ? handlers(_this.props) : handlers, function (createHandler) {
	          return function () {
	            var handler = createHandler(_this.props);
	
	            if (false) {
	              console.error( // eslint-disable-line no-console
	              'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	            }
	
	            return handler.apply(void 0, arguments);
	          };
	        });
	        return _this;
	      }
	
	      var _proto = WithHandlers.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	
	    return WithHandlers;
	  };
	};
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	
	    DefaultProps.defaultProps = props;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	
	    return DefaultProps;
	  };
	};
	
	var omit = function omit(obj, keys) {
	  var rest = _extends({}, obj);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	
	  return rest;
	};
	
	var renameProp = function renameProp(oldName, newName) {
	  var hoc = mapProps(function (props) {
	    var _extends2;
	
	    return _extends({}, omit(props, [oldName]), (_extends2 = {}, _extends2[newName] = props[oldName], _extends2));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var keys = Object.keys;
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var FlattenProp = function FlattenProp(props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
	    }
	
	    return FlattenProp;
	  };
	};
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithState =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithState, _Component);
	
	      function WithState() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        };
	
	        _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        };
	
	        return _this;
	      }
	
	      var _proto = WithState.prototype;
	
	      _proto.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return WithState;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
	    }
	
	    return WithState;
	  };
	};
	
	var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithStateHandlers =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithStateHandlers, _Component);
	
	      function WithStateHandlers() {
	        var _this;
	
	        for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	          _args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(_args)) || this;
	        _this.state = typeof initialState === 'function' ? initialState(_this.props) : initialState;
	        _this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
	          return function (mayBeEvent) {
	            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            // Having that functional form of setState can be called async
	            // we need to persist SyntheticEvent
	            if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
	              mayBeEvent.persist();
	            }
	
	            _this.setState(function (state, props) {
	              return handler(state, props).apply(void 0, [mayBeEvent].concat(args));
	            });
	          };
	        });
	        return _this;
	      }
	
	      var _proto = WithStateHandlers.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
	      };
	
	      return WithStateHandlers;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
	    }
	
	    return WithStateHandlers;
	  };
	};
	
	var noop = function noop() {};
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithReducer =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithReducer, _Component);
	
	      function WithReducer() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	        _this.state = {
	          stateValue: _this.initializeStateValue()
	        };
	
	        _this.dispatch = function (action, callback) {
	          if (callback === void 0) {
	            callback = noop;
	          }
	
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          }, function () {
	            return callback(_this.state.stateValue);
	          });
	        };
	
	        return _this;
	      }
	
	      var _proto = WithReducer.prototype;
	
	      _proto.initializeStateValue = function initializeStateValue() {
	        if (initialState !== undefined) {
	          return typeof initialState === 'function' ? initialState(this.props) : initialState;
	        }
	
	        return reducer(undefined, {
	          type: '@@recompose/INIT'
	        });
	      };
	
	      _proto.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[dispatchName] = this.dispatch, _extends2)));
	      };
	
	      return WithReducer;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
	    }
	
	    return WithReducer;
	  };
	};
	
	var identity = function identity(Component) {
	  return Component;
	};
	
	var branch = function branch(test, left, right) {
	  if (right === void 0) {
	    right = identity;
	  }
	
	  return function (BaseComponent) {
	    var leftFactory;
	    var rightFactory;
	
	    var Branch = function Branch(props) {
	      if (test(props)) {
	        leftFactory = leftFactory || React.createFactory(left(BaseComponent));
	        return leftFactory(props);
	      }
	
	      rightFactory = rightFactory || React.createFactory(right(BaseComponent));
	      return rightFactory(props);
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
	    }
	
	    return Branch;
	  };
	};
	
	var renderComponent = function renderComponent(Component) {
	  return function (_) {
	    var factory = React.createFactory(Component);
	
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	
	    if (false) {
	      RenderComponent.displayName = wrapDisplayName(Component, 'renderComponent');
	    }
	
	    return RenderComponent;
	  };
	};
	
	var Nothing =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(Nothing, _Component);
	
	  function Nothing() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = Nothing.prototype;
	
	  _proto.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(React.Component);
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var ShouldUpdate =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = ShouldUpdate.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _proto.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	
	    return ShouldUpdate;
	  };
	};
	
	var pure = function pure(BaseComponent) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(props, nextProps);
	  });
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(pick(nextProps, propKeys), pick(props, propKeys));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ("component with display name \"" + getDisplayName(BaseComponent) + "\"."));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = Object.keys(propTypes || {});
	  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
	  }
	
	  return OnlyUpdateForPropTypes;
	};
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithContext =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(WithContext, _Component);
	
	      function WithContext() {
	        var _this;
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	
	        _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        };
	
	        return _this;
	      }
	
	      var _proto = WithContext.prototype;
	
	      _proto.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(React.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
	    }
	
	    return WithContext;
	  };
	};
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
	    }
	
	    return GetContext;
	  };
	};
	
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    var Lifecycle =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(Lifecycle, _Component);
	
	      function Lifecycle() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      var _proto = Lifecycle.prototype;
	
	      _proto.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return Lifecycle;
	    }(React.Component);
	
	    Object.keys(spec).forEach(function (hook) {
	      return Lifecycle.prototype[hook] = spec[hook];
	    });
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
	    }
	
	    return Lifecycle;
	  };
	};
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.render === 'function');
	};
	
	var toClass = function toClass(baseComponent) {
	  var _class, _temp;
	
	  return isClassComponent(baseComponent) ? baseComponent : (_temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(ToClass, _Component);
	
	    function ToClass() {
	      return _Component.apply(this, arguments) || this;
	    }
	
	    var _proto = ToClass.prototype;
	
	    _proto.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return React__default.createElement(baseComponent, this.props);
	      }
	
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(React.Component), _class.displayName = getDisplayName(baseComponent), _class.propTypes = baseComponent.propTypes, _class.contextTypes = baseComponent.contextTypes, _class.defaultProps = baseComponent.defaultProps, _temp);
	};
	
	function toRenderProps(hoc) {
	  var RenderPropsComponent = function RenderPropsComponent(props) {
	    return props.children(props);
	  };
	
	  return hoc(RenderPropsComponent);
	}
	
	var fromRenderProps = function fromRenderProps(RenderPropsComponent, propsMapper, renderPropName) {
	  if (renderPropName === void 0) {
	    renderPropName = 'children';
	  }
	
	  return function (BaseComponent) {
	    var baseFactory = React__default.createFactory(BaseComponent);
	    var renderPropsFactory = React__default.createFactory(RenderPropsComponent);
	
	    var FromRenderProps = function FromRenderProps(ownerProps) {
	      var _renderPropsFactory;
	
	      return renderPropsFactory((_renderPropsFactory = {}, _renderPropsFactory[renderPropName] = function () {
	        return baseFactory(_extends({}, ownerProps, propsMapper.apply(void 0, arguments)));
	      }, _renderPropsFactory));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'fromRenderProps'))(FromRenderProps);
	    }
	
	    return FromRenderProps;
	  };
	};
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return setStatic('propTypes', propTypes);
	};
	
	var compose = function compose() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(void 0, arguments));
	    };
	  }, function (arg) {
	    return arg;
	  });
	};
	
	var createSink = function createSink(callback) {
	  var Sink =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Sink, _Component);
	
	    function Sink() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.state = {};
	      return _this;
	    }
	
	    Sink.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
	      callback(nextProps);
	      return null;
	    };
	
	    var _proto = Sink.prototype;
	
	    _proto.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(React.Component);
	
	  reactLifecyclesCompat.polyfill(Sink);
	  return Sink;
	};
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component = function Component(props) {
	    return React.createElement(props[propName], omit(props, [propName]));
	  };
	
	  Component.displayName = "componentFromProp(" + propName + ")";
	  return Component;
	};
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = new Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(React.createFactory);
	
	  var Nest = function Nest(_ref) {
	    var children = _ref.children,
	        props = _objectWithoutPropertiesLoose(_ref, ["children"]);
	
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(getDisplayName);
	    Nest.displayName = "nest(" + displayNames.join(', ') + ")";
	  }
	
	  return Nest;
	};
	
	var hoistStatics = function hoistStatics(higherOrderComponent, blacklist) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    hoistNonReactStatics(NewComponent, BaseComponent, blacklist);
	    return NewComponent;
	  };
	};
	
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
	  return function (propsToVdom) {
	    return (
	      /*#__PURE__*/
	      function (_Component) {
	        _inheritsLoose(ComponentFromStream, _Component);
	
	        function ComponentFromStream() {
	          var _config$fromESObserva;
	
	          var _this;
	
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	          _this.state = {
	            vdom: null
	          };
	          _this.propsEmitter = changeEmitter.createChangeEmitter();
	          _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
	            subscribe: function subscribe(observer) {
	              var unsubscribe = _this.propsEmitter.listen(function (props) {
	                if (props) {
	                  observer.next(props);
	                } else {
	                  observer.complete();
	                }
	              });
	
	              return {
	                unsubscribe: unsubscribe
	              };
	            }
	          }, _config$fromESObserva[$$observable] = function () {
	            return this;
	          }, _config$fromESObserva));
	          _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$));
	          return _this;
	        }
	
	        var _proto = ComponentFromStream.prototype;
	
	        _proto.componentWillMount = function componentWillMount() {
	          var _this2 = this;
	
	          // Subscribe to child prop changes so we know when to re-render
	          this.subscription = this.vdom$.subscribe({
	            next: function next(vdom) {
	              _this2.setState({
	                vdom: vdom
	              });
	            }
	          });
	          this.propsEmitter.emit(this.props);
	        };
	
	        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	          // Receive new props from the owner
	          this.propsEmitter.emit(nextProps);
	        };
	
	        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	          return nextState.vdom !== this.state.vdom;
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          // Call without arguments to complete stream
	          this.propsEmitter.emit(); // Clean-up subscription before un-mounting
	
	          this.subscription.unsubscribe();
	        };
	
	        _proto.render = function render() {
	          return this.state.vdom;
	        };
	
	        return ComponentFromStream;
	      }(React.Component)
	    );
	  };
	};
	
	var componentFromStream = function componentFromStream(propsToVdom) {
	  return componentFromStreamWithConfig(config)(propsToVdom);
	};
	
	var identity$1 = function identity(t) {
	  return t;
	};
	
	var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
	  var componentFromStream$$1 = componentFromStreamWithConfig({
	    fromESObservable: identity$1,
	    toESObservable: identity$1
	  });
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = React.createFactory(BaseComponent);
	      var fromESObservable = config$$1.fromESObservable,
	          toESObservable = config$$1.toESObservable;
	      return componentFromStream$$1(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[$$observable] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = function mapPropsStream(transform) {
	  var hoc = mapPropsStreamWithConfig(config)(transform);
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
	    };
	  }
	
	  return hoc;
	};
	
	var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = changeEmitter.createChangeEmitter();
	    var stream = config$$1.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _config$fromESObserva[$$observable] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	var createEventHandler = createEventHandlerWithConfig(config);
	
	// Higher-order component helpers
	
	exports.mapProps = mapProps;
	exports.withProps = withProps;
	exports.withPropsOnChange = withPropsOnChange;
	exports.withHandlers = withHandlers;
	exports.defaultProps = defaultProps;
	exports.renameProp = renameProp;
	exports.renameProps = renameProps;
	exports.flattenProp = flattenProp;
	exports.withState = withState;
	exports.withStateHandlers = withStateHandlers;
	exports.withReducer = withReducer;
	exports.branch = branch;
	exports.renderComponent = renderComponent;
	exports.renderNothing = renderNothing;
	exports.shouldUpdate = shouldUpdate;
	exports.pure = pure;
	exports.onlyUpdateForKeys = onlyUpdateForKeys;
	exports.onlyUpdateForPropTypes = onlyUpdateForPropTypes;
	exports.withContext = withContext;
	exports.getContext = getContext;
	exports.lifecycle = lifecycle;
	exports.toClass = toClass;
	exports.toRenderProps = toRenderProps;
	exports.fromRenderProps = fromRenderProps;
	exports.setStatic = setStatic;
	exports.setPropTypes = setPropTypes;
	exports.setDisplayName = setDisplayName;
	exports.compose = compose;
	exports.getDisplayName = getDisplayName;
	exports.wrapDisplayName = wrapDisplayName;
	exports.shallowEqual = shallowEqual;
	exports.isClassComponent = isClassComponent;
	exports.createSink = createSink;
	exports.componentFromProp = componentFromProp;
	exports.nest = nest;
	exports.hoistStatics = hoistStatics;
	exports.componentFromStream = componentFromStream;
	exports.componentFromStreamWithConfig = componentFromStreamWithConfig;
	exports.mapPropsStream = mapPropsStream;
	exports.mapPropsStreamWithConfig = mapPropsStreamWithConfig;
	exports.createEventHandler = createEventHandler;
	exports.createEventHandlerWithConfig = createEventHandlerWithConfig;
	exports.setObservableConfig = configureObservable;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectShowOwnProviderProfile = exports.selectIsLoggedTeam = exports.selectIdUserToShow = exports.selectUserToShow = exports.selectTeamId = exports.selectTeamUserId = exports.selectTeamUser = exports.selectIsTeamMemberProvider = exports.selectLoggedProviderTeamsList = exports.selectLoggedProviderOrganizationCode = exports.selectLoggedProviderProfile = exports.selectIsVerifiedGuardianRole = exports.supportInfoSelector = exports.selectTargetUserOrganizations = exports.selectTargetUserSkipInsurance = exports.selectIsVerifiedDependentRole = exports.selectVerifiedDependentsList = exports.targetUserPermissionsSelector = exports.targetUserIdSelector = exports.targetUserCountrySelector = exports.targetUserSelector = exports.isFamilyMemberUserSelector = exports.canEditPatient = exports.canEditNotJoinedPatient = exports.selectTargetProviderId = exports.selectSeenSocialChatAlert = exports.selectDashboardVisible = exports.selectDashboardAccessible = exports.editableForProvider = exports.isCaregiverSelector = exports.isLoggedUserSelector = exports.providerProfileIdSelector = exports.hasProviderProfileSelector = exports.hasPatientProfileSelector = exports.loggedUserStateSelector = exports.loggedUserCountrySelector = exports.targetUserEmployeeIdSelector = exports.loggedUserEmployeeIdSelector = exports.loggedUserIdSelector = exports.loggedUserSelector = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loggedUserSelector = exports.loggedUserSelector = function loggedUserSelector(state) {
	  return (0, _get2.default)(state, 'context.loggedUser');
	};
	
	var loggedUserIdSelector = exports.loggedUserIdSelector = function loggedUserIdSelector(state) {
	  return (0, _get2.default)(state, 'context.loggedUser.id');
	};
	var loggedUserEmployeeIdSelector = exports.loggedUserEmployeeIdSelector = function loggedUserEmployeeIdSelector(state) {
	  return (0, _get2.default)(state, 'context.loggedUser.employeeProfile.id');
	};
	var targetUserEmployeeIdSelector = exports.targetUserEmployeeIdSelector = function targetUserEmployeeIdSelector(state) {
	  return (0, _get2.default)(state, 'context.targetUser.employeeProfile.id');
	};
	var loggedUserCountrySelector = exports.loggedUserCountrySelector = function loggedUserCountrySelector(state) {
	  return (0, _get2.default)(state, 'context.loggedUser.country');
	};
	var loggedUserStateSelector = exports.loggedUserStateSelector = function loggedUserStateSelector(state) {
	  return (0, _get2.default)(state, 'context.loggedUser.state');
	};
	var hasPatientProfileSelector = exports.hasPatientProfileSelector = function hasPatientProfileSelector(state) {
	  return !!(0, _get2.default)(state, 'context.loggedUser.primaryPatientProfile');
	};
	// IS LOGGED USER PROVIDER
	var hasProviderProfileSelector = exports.hasProviderProfileSelector = function hasProviderProfileSelector(state) {
	  return !!(0, _get2.default)(state, 'context.loggedUser.primaryProviderProfile');
	};
	var providerProfileIdSelector = exports.providerProfileIdSelector = function providerProfileIdSelector(state) {
	  return (0, _get2.default)(state, 'context.loggedUser.primaryProviderProfile.id');
	};
	var isLoggedUserSelector = exports.isLoggedUserSelector = function isLoggedUserSelector(state) {
	  return (0, _get2.default)(state, 'context.permissions.isLoggedUser');
	};
	var isCaregiverSelector = exports.isCaregiverSelector = function isCaregiverSelector(state) {
	  return (0, _get2.default)(state, 'context.permissions.isCaregiver');
	};
	
	var editableForProvider = exports.editableForProvider = function editableForProvider(state) {
	  return (0, _get2.default)(state, 'context.targetUser.editableForProvider');
	};
	
	var selectDashboardAccessible = exports.selectDashboardAccessible = (0, _reselect.createSelector)(loggedUserSelector, function (state) {
	  return (0, _get2.default)(state, 'dashboardAccessible', false);
	});
	var selectDashboardVisible = exports.selectDashboardVisible = (0, _reselect.createSelector)(loggedUserSelector, function (state) {
	  return (0, _get2.default)(state, 'dashboardVisible', false);
	});
	var selectSeenSocialChatAlert = exports.selectSeenSocialChatAlert = (0, _reselect.createSelector)(loggedUserSelector, function (state) {
	  return (0, _get2.default)(state, 'settings.seenSocialChatAlert', false);
	});
	
	// Dublicated with targetUserSelector
	var selectTargeUserState = function selectTargeUserState(state) {
	  return (0, _get2.default)(state, 'context.targetUser');
	};
	
	var selectTargetProviderId = exports.selectTargetProviderId = (0, _reselect.createSelector)(selectTargeUserState, function (state) {
	  return (0, _get2.default)(state, 'primaryProviderProfile.id');
	});
	
	var canEditNotJoinedPatient = exports.canEditNotJoinedPatient = function canEditNotJoinedPatient(state) {
	  return editableForProvider(state);
	};
	
	var canEditPatient = exports.canEditPatient = function canEditPatient(state) {
	  return isCaregiverSelector(state) || isLoggedUserSelector(state) || selectIsVerifiedDependentRole(state);
	};
	
	var isFamilyMemberUserSelector = exports.isFamilyMemberUserSelector = function isFamilyMemberUserSelector(state) {
	  return (0, _get2.default)(state, 'context.permissions.isFamilyMemberOnly');
	};
	
	var targetUserSelector = exports.targetUserSelector = function targetUserSelector(state) {
	  return (0, _get2.default)(state, 'context.targetUser');
	};
	
	var targetUserCountrySelector = exports.targetUserCountrySelector = function targetUserCountrySelector(state) {
	  return (0, _get2.default)(state, 'context.targetUser.country');
	};
	
	var targetUserIdSelector = exports.targetUserIdSelector = function targetUserIdSelector(state) {
	  return parseInt((0, _get2.default)(state, 'context.targetUserId'), 10);
	};
	
	var targetUserPermissionsSelector = exports.targetUserPermissionsSelector = function targetUserPermissionsSelector(state) {
	  return (0, _get2.default)(state, 'context.permissions');
	};
	
	var selectVerifiedDependentsList = exports.selectVerifiedDependentsList = function selectVerifiedDependentsList(state) {
	  return (0, _get2.default)(state, 'context.permissions.dependentsList', []);
	};
	
	var selectIsVerifiedDependentRole = exports.selectIsVerifiedDependentRole = function selectIsVerifiedDependentRole(state) {
	  return (0, _get2.default)(state, 'context.permissions.isVerifiedDependent');
	};
	
	var selectTargetUserSkipInsurance = exports.selectTargetUserSkipInsurance = function selectTargetUserSkipInsurance(state) {
	  return (0, _get2.default)(state, 'context.targetUser.skipInsurance', false);
	};
	
	var selectTargetUserOrganizations = exports.selectTargetUserOrganizations = function selectTargetUserOrganizations(state) {
	  return (0, _get2.default)(state, 'context.targetUser.userOrganizations', []);
	};
	
	var supportInfoSelector = exports.supportInfoSelector = function supportInfoSelector(state) {
	  return (0, _get2.default)(state, 'data.constants.supportInfo', {});
	};
	
	var selectIsVerifiedGuardianRole = exports.selectIsVerifiedGuardianRole = (0, _reselect.createSelector)(selectVerifiedDependentsList, isLoggedUserSelector, function (list, isLoggedUser) {
	  return isLoggedUser && !(0, _isEmpty2.default)(list);
	});
	
	var selectLoggedProviderProfile = exports.selectLoggedProviderProfile = function selectLoggedProviderProfile(state) {
	  return (0, _get2.default)(state, 'context.loggedUser.primaryProviderProfile');
	};
	
	var selectLoggedProviderOrganizationCode = exports.selectLoggedProviderOrganizationCode = (0, _reselect.createSelector)(selectLoggedProviderProfile, function (state) {
	  return (0, _get2.default)(state, 'mrns[0].organization.code', null);
	});
	
	var selectLoggedProviderTeamsList = exports.selectLoggedProviderTeamsList = (0, _reselect.createSelector)(selectLoggedProviderProfile, function (profile) {
	  return (0, _get2.default)(profile, 'teams', []);
	});
	
	var selectIsTeamMemberProvider = exports.selectIsTeamMemberProvider = (0, _reselect.createSelector)(selectLoggedProviderTeamsList, function (list) {
	  return Boolean((0, _size2.default)(list));
	});
	
	var selectTeamUser = exports.selectTeamUser = function selectTeamUser(state) {
	  return (0, _get2.default)(state, 'context.teamUser.user');
	};
	
	var selectTeamUserId = exports.selectTeamUserId = (0, _reselect.createSelector)(selectTeamUser, function (user) {
	  return (0, _get2.default)(user, 'id');
	});
	
	var selectTeamId = exports.selectTeamId = function selectTeamId(state) {
	  return (0, _get2.default)(state, 'context.teamUser.selectedTeamId');
	};
	
	var selectUserToShow = exports.selectUserToShow = (0, _reselect.createSelector)(loggedUserSelector, selectTeamUser, function (loggedUser, teamUser) {
	  return teamUser || loggedUser;
	});
	
	var selectIdUserToShow = exports.selectIdUserToShow = (0, _reselect.createSelector)(selectUserToShow, function (user) {
	  return (0, _get2.default)(user, 'id');
	});
	
	var selectIsLoggedTeam = exports.selectIsLoggedTeam = (0, _reselect.createSelector)(selectTeamId, function (id) {
	  return Boolean(id);
	});
	
	var selectShowOwnProviderProfile = exports.selectShowOwnProviderProfile = (0, _reselect.createSelector)(loggedUserIdSelector, targetUserSelector, function (loggedUserId, targetUser) {
	  var id = targetUser.id,
	      primaryProviderProfile = targetUser.primaryProviderProfile;
	
	  return primaryProviderProfile && id === loggedUserId;
	});

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return isArray(this._weekdays) ? this._weekdays :
	                this._weekdays['standalone'];
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(5687)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.22.2';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)(module)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4347), __esModule: true };

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(4297);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1974);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(5686)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)(module)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key;
	                for (i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i;
	            for (i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
	                    matched,
	                    p1,
	                    p2,
	                    p3,
	                    p4
	                ) {
	                    return p1 || p2 || p3 || p4;
	                })
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
	            '_'
	        ),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(4309)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^)]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged and will be removed in an upcoming major release. Please refer to ' +
	            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
	        input,
	        array,
	        config,
	        token
	    ) {
	        var era = config._locale.erasParse(input, token, config._strict);
	        if (era) {
	            getParsingFlags(config).era = era;
	        } else {
	            getParsingFlags(config).invalidEra = input;
	        }
	    });
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
	        input,
	        week,
	        config,
	        token
	    ) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)(module)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _index = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument); // Clone the date
	
	  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
	
	      console.warn(new Error().stack);
	    }
	
	    return new Date(NaN);
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(89);
	var core = __webpack_require__(270);
	var hide = __webpack_require__(205);
	var redefine = __webpack_require__(206);
	var ctx = __webpack_require__(243);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap && typeof btoa === 'function') {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
		// eslint-disable-next-line no-undef
		var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
		var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
		return '/*# ' + data + ' */';
	}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(5212);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loader = function Loader(_ref) {
	  var white = _ref.white,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['white']);
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ styleName: 'root' }, other),
	    _react2.default.createElement('div', {
	      styleName: (0, _classnames2.default)('spinner', {
	        'spinner--white': white
	      })
	    })
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	Loader.propTypes = {
	  white: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(Loader, _index2.default, { allowMultiple: true });

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(550);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// TODO: check where slash is needed
	
	// site sections
	var ROOT = exports.ROOT = '/';
	var CIRCLES = exports.CIRCLES = 'circles';
	var COMMUNITIES = exports.COMMUNITIES = 'communities';
	var POST = exports.POST = 'post';
	var HEALTHBOARD = exports.HEALTHBOARD = 'healthboard';
	var HEALTHBOARD_HOME = exports.HEALTHBOARD_HOME = 'home';
	var HEALTHBOARD_APPOINTMENTS = exports.HEALTHBOARD_APPOINTMENTS = 'appointments';
	var HEALTHBOARD_APPOINTMENTS_HISTORY = exports.HEALTHBOARD_APPOINTMENTS_HISTORY = 'history-appointments';
	var HEALTHBOARD_EMPTY = exports.HEALTHBOARD_EMPTY = 'healthboard-empty';
	var HEALTHBOARD_TODO = exports.HEALTHBOARD_TODO = 'todo';
	var MESSAGES = exports.MESSAGES = 'messaging';
	var PROFILE = exports.PROFILE = 'profile';
	var PATIENT_PROFILE = exports.PATIENT_PROFILE = 'patient';
	var PROVIDER_PROFILE = exports.PROVIDER_PROFILE = 'provider';
	var USER_PROFILE = exports.USER_PROFILE = 'user';
	var PROFILE_SETTINGS = exports.PROFILE_SETTINGS = 'settings';
	var PROFILE_PAYMENT_METHODS = exports.PROFILE_PAYMENT_METHODS = 'payment-methods';
	var PROFILE_DOCUMENTATION = exports.PROFILE_DOCUMENTATION = 'documentation';
	var PATIENT_INFO = exports.PATIENT_INFO = 'patient-info';
	var PATIENT_HEALTHBOARD = exports.PATIENT_HEALTHBOARD = 'patient-healthboard';
	var PROVIDER_INFO = exports.PROVIDER_INFO = 'provider-info';
	var SUPPORT = exports.SUPPORT = 'support';
	var PROVIDER_MEMBER_PROFILE = exports.PROVIDER_MEMBER_PROFILE = 'provider-member';
	var PARENT_PROVIDER = exports.PARENT_PROVIDER = 'parent-provider';
	var FAMILY_MEMBER_PROFILE = exports.FAMILY_MEMBER_PROFILE = 'family-member';
	var TEAM_MEMBER_PROFILE = exports.TEAM_MEMBER_PROFILE = 'team-member';
	var PATIENT_VIEW_PROFILE = exports.PATIENT_VIEW_PROFILE = 'patient-view';
	var CONFIRMATION = exports.CONFIRMATION = 'confirmation_expired';
	var DISCOVER = exports.DISCOVER = 'discover';
	var MY_COMMUNITIES = exports.MY_COMMUNITIES = 'my-communities';
	var ORGANIZATION = exports.ORGANIZATION = 'organization';
	var ACTIVITIES = exports.ACTIVITIES = 'activities';
	var REPORTS = exports.REPORTS = 'reports';
	var COMMUNITY_PREVIEW = exports.COMMUNITY_PREVIEW = 'community-preview';
	var PUBLIC_PROFILE = exports.PUBLIC_PROFILE = 'public-profile';
	var PUBLIC_PROFILE_INFO = exports.PUBLIC_PROFILE_INFO = ':id/info';
	var PATIENT_REGISTRATION = exports.PATIENT_REGISTRATION = 'patient-registration';
	var CONTACT_INFO = exports.CONTACT_INFO = 'contact-info';
	var EMERGENCY_CONTACT = exports.EMERGENCY_CONTACT = 'emergency-contact';
	var ADDRESS = exports.ADDRESS = 'address';
	var CHOOSE_ADD_ACCOUNT = exports.CHOOSE_ADD_ACCOUNT = 'add-device-account';
	
	// auth flows
	var CREATE_PASSWORD = exports.CREATE_PASSWORD = 'reset-password/:token';
	var CHANGE_PASSWORD = exports.CHANGE_PASSWORD = 'change-password';
	var LOGIN = exports.LOGIN = '/login';
	var CREATE_PATIENT_PROFILE = exports.CREATE_PATIENT_PROFILE = 'personal-details/:organizationId';
	var RESET_PASSWORD = exports.RESET_PASSWORD = 'reset-password';
	var ACCEPT_INVITATION = exports.ACCEPT_INVITATION = 'invitations/:token';
	var SIGNUP = exports.SIGNUP = 'signup';
	var CIRCLE_OF_CARE = exports.CIRCLE_OF_CARE = 'circe-of-care';
	var PROGRAM = exports.PROGRAM = 'program';
	var PERSONAL_INFO = exports.PERSONAL_INFO = 'personal-info';
	var SIGN_UP_AZURE = exports.SIGN_UP_AZURE = 'signup-azure';
	var SIGNUP_INVITATION = exports.SIGNUP_INVITATION = 'signup-invitation';
	var EXPIRED_LINK = exports.EXPIRED_LINK = 'expired-link';
	var DEFAULT_EXPIRED_LINK = exports.DEFAULT_EXPIRED_LINK = 'default-expired-link';
	var BROWSER_SUPPORT = exports.BROWSER_SUPPORT = 'browser-support';
	
	// surveys
	var SURVEYS_GENERAL = exports.SURVEYS_GENERAL = ':id/surveys';
	var SURVEYS_GENERAL_SUB_PATH = exports.SURVEYS_GENERAL_SUB_PATH = 'surveys';
	
	// helpers
	var ACCESS_DENIED = exports.ACCESS_DENIED = '/access-denied';
	var ACCESS_DENIED_COMMUNITIES = exports.ACCESS_DENIED_COMMUNITIES = '/communities/access-denied';
	var EXPIRED_TOKEN = exports.EXPIRED_TOKEN = '/expired-token';
	var NOT_FOUND = exports.NOT_FOUND = '/not-found';
	
	// dependent form
	var DEPENDENT_FORM = exports.DEPENDENT_FORM = '/dependent-form';
	var DEPENDENT_FORM_COMPLETE = exports.DEPENDENT_FORM_COMPLETE = 'complete';
	var DEPENDENT_FORM_EXISTING = exports.DEPENDENT_FORM_EXISTING = 'existing-user';
	var DEPENDENT_FORM_ROLE = exports.DEPENDENT_FORM_ROLE = 'role';
	var DEPENDENT_FORM_PERSONAL = exports.DEPENDENT_FORM_PERSONAL = 'personal-info';
	var DEPENDENT_FORM_GENERAL = exports.DEPENDENT_FORM_GENERAL = ':id/general-info';
	var DEPENDENT_FORM_DOCUMENTS = exports.DEPENDENT_FORM_DOCUMENTS = ':id/documents';
	var DEPENDENT_FORM_RELATION = exports.DEPENDENT_FORM_RELATION = ':id/relationship';
	var APP_NOTIFICATIONS = exports.APP_NOTIFICATIONS = '/app-notifications';
	var DASHBOARD = exports.DASHBOARD = '/dashboard';
	var DASHBOARD_RECORD = exports.DASHBOARD_RECORD = '/dashboard-record';
	var DASHBOARD_VISIT_INFO = exports.DASHBOARD_VISIT_INFO = 'visit-info';
	
	// appointment-form
	var APPOINTMENT_FORM = exports.APPOINTMENT_FORM = '/appointment-form';
	var APPOINTMENT_FORM_USERS = exports.APPOINTMENT_FORM_USERS = 'users';
	var APPOINTMENT_FORM_ORGANIZATIONS = exports.APPOINTMENT_FORM_ORGANIZATIONS = 'organizations';
	var APPOINTMENT_FORM_PHARMACY = exports.APPOINTMENT_FORM_PHARMACY = 'pharmacy';
	var APPOINTMENT_FORM_VISIT_TYPE = exports.APPOINTMENT_FORM_VISIT_TYPE = 'visit-type';
	var APPOINTMENT_FORM_HEALTH_INFO = exports.APPOINTMENT_FORM_HEALTH_INFO = 'health-info';
	var APPOINTMENT_FORM_PAYMENT = exports.APPOINTMENT_FORM_PAYMENT = 'payment';
	var APPOINTMENT_FORM_SUMMARY = exports.APPOINTMENT_FORM_SUMMARY = 'summary';
	var APPOINTMENT_FORM_VISIT_SERVICES = exports.APPOINTMENT_FORM_VISIT_SERVICES = 'visit-services';
	var APPOINTMENT_FORM_VISIT_LOCATIONS = exports.APPOINTMENT_FORM_VISIT_LOCATIONS = 'visit-locations';
	var APPOINTMENT_FORM_PUBLIX_INFO = exports.APPOINTMENT_FORM_PUBLIX_INFO = 'publix-info';
	var APPOINTMENT_FORM_CONSENT_FORM = exports.APPOINTMENT_FORM_CONSENT_FORM = 'consent-form';
	var APPOINTMENT_FORM_PATIENT_INFO = exports.APPOINTMENT_FORM_PATIENT_INFO = 'patient-form';
	var APPOINTMENT_FORM_VISIT_DETAILS = exports.APPOINTMENT_FORM_VISIT_DETAILS = 'visit-details';
	var APPOINTMENT_FORM_PROVIDERS = exports.APPOINTMENT_FORM_PROVIDERS = 'providers';
	var APPOINTMENT_FORM_PROVIDER_DETAILS = exports.APPOINTMENT_FORM_PROVIDER_DETAILS = ':id/provider-details';
	var APPOINTMENT_FORM_OVERVIEW = exports.APPOINTMENT_FORM_OVERVIEW = 'overview';
	var APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS = exports.APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS = 'available-time-slots';
	var APPOINTMENT_FORM_MY_PROVIDERS = exports.APPOINTMENT_FORM_MY_PROVIDERS = 'my-providers';
	var APPOINTMENT_FORM_HEALTH_INFO_PROVIDER = exports.APPOINTMENT_FORM_HEALTH_INFO_PROVIDER = 'health-info-provider';
	var APPOINTMENT_FORM_EMERGENCY_CONTACT = exports.APPOINTMENT_FORM_EMERGENCY_CONTACT = 'emergency-contact';
	var APPOINTMENT_FORM_GUARANTOR_INFORMATION = exports.APPOINTMENT_FORM_GUARANTOR_INFORMATION = 'guarantor-information';
	var APPOINTMENT_ADDITIONAL_INFO = exports.APPOINTMENT_ADDITIONAL_INFO = 'additional-information';
	var APPOINTMENT_FORM_INSURANCE_FORM = exports.APPOINTMENT_FORM_INSURANCE_FORM = 'insurance-form';
	
	// paperwork
	var PAPERWORK = exports.PAPERWORK = '/paperwork';
	var PAPERWORK_VISIT_DETAILS = exports.PAPERWORK_VISIT_DETAILS = 'visit-details';
	var PAPERWORK_PRIMARY_CARE_PROVIDER = exports.PAPERWORK_PRIMARY_CARE_PROVIDER = 'primary-care-provider';
	var PAPERWORK_ADDITIONAL_INFORMATION = exports.PAPERWORK_ADDITIONAL_INFORMATION = 'additional-information';
	var PAPERWORK_COMPLETE_YOUR_PROFILE = exports.PAPERWORK_COMPLETE_YOUR_PROFILE = 'complete-your-profile';
	var PAPERWORK_SIGN_CONSENT = exports.PAPERWORK_SIGN_CONSENT = 'sign-consent';
	var PAPERWORK_SUBMIT = exports.PAPERWORK_SUBMIT = 'submit';
	var PAPERWORK_INSURANCE_DETAILS = exports.PAPERWORK_INSURANCE_DETAILS = 'insurance-details';
	var PAPERWORK_COMPLETE_VISIT_DETAILS = exports.PAPERWORK_COMPLETE_VISIT_DETAILS = 'complete-visit-details';
	var PAPERWORK_GUARANTOR_INFORMATION = exports.PAPERWORK_GUARANTOR_INFORMATION = 'guarantor-information';
	var PAPERWORK_PREFERRED_PHARMACY = exports.PAPERWORK_PREFERRED_PHARMACY = 'preferred-pharmacy';
	
	var PROVIDER_CALENDAR = exports.PROVIDER_CALENDAR = '/:id/:providerId/schedule';
	var CALENDAR_MOB = exports.CALENDAR_MOB = '/mobile-calenar';
	
	var VIRTUAL_ROOM = exports.VIRTUAL_ROOM = '/virtual_room';
	var CONNECTION_ROOM = exports.CONNECTION_ROOM = '/connection_room';
	var IN_OFFICE_VISIT = exports.IN_OFFICE_VISIT = '/in-office-visit';
	
	var VIRTUAL_VISIT = exports.VIRTUAL_VISIT = '/virtual-visit';
	var DETAILS = exports.DETAILS = 'details';
	var APPOINTMENTS = exports.APPOINTMENTS = '/appointments';
	
	exports.default = {
	  PATIENT_REGISTRATION: PATIENT_REGISTRATION,
	  ACCEPT_INVITATION: ACCEPT_INVITATION,
	  ACCESS_DENIED: ACCESS_DENIED,
	  ACCESS_DENIED_COMMUNITIES: ACCESS_DENIED_COMMUNITIES,
	  CIRCLES: CIRCLES,
	  COMMUNITIES: COMMUNITIES,
	  POST: POST,
	  CREATE_PASSWORD: CREATE_PASSWORD,
	  CREATE_PATIENT_PROFILE: CREATE_PATIENT_PROFILE,
	  EXPIRED_TOKEN: EXPIRED_TOKEN,
	  HEALTHBOARD: HEALTHBOARD,
	  HEALTHBOARD_HOME: HEALTHBOARD_HOME,
	  HEALTHBOARD_APPOINTMENTS: HEALTHBOARD_APPOINTMENTS,
	  HEALTHBOARD_APPOINTMENTS_HISTORY: HEALTHBOARD_APPOINTMENTS_HISTORY,
	  HEALTHBOARD_EMPTY: HEALTHBOARD_EMPTY,
	  HEALTHBOARD_TODO: HEALTHBOARD_TODO,
	  MESSAGES: MESSAGES,
	  LOGIN: LOGIN,
	  PERSONAL_INFO: PERSONAL_INFO,
	  PROFILE: PROFILE,
	  PATIENT_PROFILE: PATIENT_PROFILE,
	  PROVIDER_PROFILE: PROVIDER_PROFILE,
	  USER_PROFILE: USER_PROFILE,
	  FAMILY_MEMBER_PROFILE: FAMILY_MEMBER_PROFILE,
	  TEAM_MEMBER_PROFILE: TEAM_MEMBER_PROFILE,
	  RESET_PASSWORD: RESET_PASSWORD,
	  CHANGE_PASSWORD: CHANGE_PASSWORD,
	  ROOT: ROOT,
	  SIGNUP: SIGNUP,
	  SUPPORT: SUPPORT,
	  SIGN_UP_AZURE: SIGN_UP_AZURE,
	  SIGNUP_INVITATION: SIGNUP_INVITATION,
	  SURVEYS_GENERAL: SURVEYS_GENERAL,
	  SURVEYS_GENERAL_SUB_PATH: SURVEYS_GENERAL_SUB_PATH,
	  PATIENT_VIEW_PROFILE: PATIENT_VIEW_PROFILE,
	  PROVIDER_MEMBER_PROFILE: PROVIDER_MEMBER_PROFILE,
	  PARENT_PROVIDER: PARENT_PROVIDER,
	  CONFIRMATION: CONFIRMATION,
	  NOT_FOUND: NOT_FOUND,
	  CIRCLE_OF_CARE: CIRCLE_OF_CARE,
	  PROFILE_SETTINGS: PROFILE_SETTINGS,
	  PROFILE_PAYMENT_METHODS: PROFILE_PAYMENT_METHODS,
	  PROFILE_DOCUMENTATION: PROFILE_DOCUMENTATION,
	  PATIENT_INFO: PATIENT_INFO,
	  PATIENT_HEALTHBOARD: PATIENT_HEALTHBOARD,
	  PROVIDER_INFO: PROVIDER_INFO,
	  PROGRAM: PROGRAM,
	  DISCOVER: DISCOVER,
	  MY_COMMUNITIES: MY_COMMUNITIES,
	  ORGANIZATION: ORGANIZATION,
	  ACTIVITIES: ACTIVITIES,
	  REPORTS: REPORTS,
	  COMMUNITY_PREVIEW: COMMUNITY_PREVIEW,
	  PUBLIC_PROFILE: PUBLIC_PROFILE,
	  PUBLIC_PROFILE_INFO: PUBLIC_PROFILE_INFO,
	  DEPENDENT_FORM: DEPENDENT_FORM,
	  DEPENDENT_FORM_ROLE: DEPENDENT_FORM_ROLE,
	  DEPENDENT_FORM_PERSONAL: DEPENDENT_FORM_PERSONAL,
	  DEPENDENT_FORM_GENERAL: DEPENDENT_FORM_GENERAL,
	  DEPENDENT_FORM_DOCUMENTS: DEPENDENT_FORM_DOCUMENTS,
	  DEPENDENT_FORM_RELATION: DEPENDENT_FORM_RELATION,
	  DEPENDENT_FORM_COMPLETE: DEPENDENT_FORM_COMPLETE,
	  DEPENDENT_FORM_EXISTING: DEPENDENT_FORM_EXISTING,
	  APP_NOTIFICATIONS: APP_NOTIFICATIONS,
	  DASHBOARD: DASHBOARD,
	  APPOINTMENT_FORM: APPOINTMENT_FORM,
	  APPOINTMENT_FORM_USERS: APPOINTMENT_FORM_USERS,
	  APPOINTMENT_FORM_PAYMENT: APPOINTMENT_FORM_PAYMENT,
	  APPOINTMENT_FORM_SUMMARY: APPOINTMENT_FORM_SUMMARY,
	  APPOINTMENT_FORM_PHARMACY: APPOINTMENT_FORM_PHARMACY,
	  APPOINTMENT_FORM_HEALTH_INFO: APPOINTMENT_FORM_HEALTH_INFO,
	  APPOINTMENT_FORM_ORGANIZATIONS: APPOINTMENT_FORM_ORGANIZATIONS,
	  APPOINTMENT_FORM_VISIT_TYPE: APPOINTMENT_FORM_VISIT_TYPE,
	  APPOINTMENT_FORM_PUBLIX_INFO: APPOINTMENT_FORM_PUBLIX_INFO,
	  APPOINTMENT_FORM_VISIT_SERVICES: APPOINTMENT_FORM_VISIT_SERVICES,
	  APPOINTMENT_FORM_VISIT_LOCATIONS: APPOINTMENT_FORM_VISIT_LOCATIONS,
	  APPOINTMENT_FORM_CONSENT_FORM: APPOINTMENT_FORM_CONSENT_FORM,
	  APPOINTMENT_FORM_PATIENT_INFO: APPOINTMENT_FORM_PATIENT_INFO,
	  APPOINTMENT_FORM_VISIT_DETAILS: APPOINTMENT_FORM_VISIT_DETAILS,
	  DASHBOARD_RECORD: DASHBOARD_RECORD,
	  DASHBOARD_VISIT_INFO: DASHBOARD_VISIT_INFO,
	  APPOINTMENT_FORM_PROVIDERS: APPOINTMENT_FORM_PROVIDERS,
	  APPOINTMENT_FORM_MY_PROVIDERS: APPOINTMENT_FORM_MY_PROVIDERS,
	  APPOINTMENT_FORM_PROVIDER_DETAILS: APPOINTMENT_FORM_PROVIDER_DETAILS,
	  APPOINTMENT_FORM_OVERVIEW: APPOINTMENT_FORM_OVERVIEW,
	  VIRTUAL_ROOM: VIRTUAL_ROOM,
	  VIRTUAL_VISIT: VIRTUAL_VISIT,
	  DETAILS: DETAILS,
	  EXPIRED_LINK: EXPIRED_LINK,
	  DEFAULT_EXPIRED_LINK: DEFAULT_EXPIRED_LINK,
	  CONTACT_INFO: CONTACT_INFO,
	  EMERGENCY_CONTACT: EMERGENCY_CONTACT,
	  ADDRESS: ADDRESS,
	  BROWSER_SUPPORT: BROWSER_SUPPORT,
	  PROVIDER_CALENDAR: PROVIDER_CALENDAR,
	  CALENDAR_MOB: CALENDAR_MOB,
	  CHOOSE_ADD_ACCOUNT: CHOOSE_ADD_ACCOUNT,
	  APPOINTMENTS: APPOINTMENTS,
	  APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS: APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS,
	  CONNECTION_ROOM: CONNECTION_ROOM,
	  IN_OFFICE_VISIT: IN_OFFICE_VISIT,
	  APPOINTMENT_FORM_HEALTH_INFO_PROVIDER: APPOINTMENT_FORM_HEALTH_INFO_PROVIDER,
	  APPOINTMENT_FORM_EMERGENCY_CONTACT: APPOINTMENT_FORM_EMERGENCY_CONTACT,
	  APPOINTMENT_FORM_GUARANTOR_INFORMATION: APPOINTMENT_FORM_GUARANTOR_INFORMATION,
	  APPOINTMENT_ADDITIONAL_INFO: APPOINTMENT_ADDITIONAL_INFO,
	  APPOINTMENT_FORM_INSURANCE_FORM: APPOINTMENT_FORM_INSURANCE_FORM,
	
	  PAPERWORK: PAPERWORK,
	  PAPERWORK_INSURANCE_DETAILS: PAPERWORK_INSURANCE_DETAILS,
	  PAPERWORK_COMPLETE_YOUR_PROFILE: PAPERWORK_COMPLETE_YOUR_PROFILE,
	  PAPERWORK_PRIMARY_CARE_PROVIDER: PAPERWORK_PRIMARY_CARE_PROVIDER,
	  PAPERWORK_SIGN_CONSENT: PAPERWORK_SIGN_CONSENT,
	  PAPERWORK_SUBMIT: PAPERWORK_SUBMIT,
	  PAPERWORK_VISIT_DETAILS: PAPERWORK_VISIT_DETAILS,
	  PAPERWORK_GUARANTOR_INFORMATION: PAPERWORK_GUARANTOR_INFORMATION,
	  PAPERWORK_COMPLETE_VISIT_DETAILS: PAPERWORK_COMPLETE_VISIT_DETAILS,
	  PAPERWORK_PREFERRED_PHARMACY: PAPERWORK_PREFERRED_PHARMACY
	};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PROFILE_FIELDS_TYPES = exports.PROFILE_FIELDS_TYPES = {
	  EMAIL: 'email',
	  PHONE_NUMBER: 'phoneNumber',
	  HOME_PHONE: 'homePhone',
	  FIRST_NAME: 'firstName',
	  LAST_NAME: 'lastName',
	  MIDDLE_NAME: 'middleName',
	  GENDER: 'gender',
	  DOB: 'dob',
	  NAME_SUFFIX: 'nameSuffix',
	  MRNS: 'mrn',
	  LOCAL_UID: 'local_uid', // same as mrn
	  SSN: 'ssn',
	  ADDRESS_1: 'address1',
	  ADDRESS_2: 'address2',
	  CITY: 'city',
	  STATE: 'state',
	  COUNTRY: 'country',
	  POSTAL_CODE: 'postalCode',
	  RELATION: 'relation',
	  AVATAR: 'avatar',
	  AGE: 'age',
	  ETHNICITY: 'ethnicity',
	  RACE: 'race',
	  LANGUAGE: 'language',
	
	  ROLE: 'role',
	  RELATIONSHIP: 'relationship',
	  TERMS_AND_CONDITIONS: 'termsAndConditions',
	  LOGIN: 'login',
	  EMAIL_OR_PHONE: 'emailOrPhone',
	  PASSWORD: 'password',
	  USERNAME: 'username',
	  PASSWORD_CONFIRMATION: 'passwordConfirmation',
	  ACCEPTED_PRIVACY_POLICY: 'acceptedPrivacyPolicy',
	  ACCEPTED_TERMS_AND_CONDITIONS: 'termsAndConditionsAccepted',
	  CARE_ROLE: 'careRole',
	
	  REASON_TYPE: 'reasonType',
	  REASON_NOTE: 'reasonNote',
	  REASON_CODE: 'reason_code',
	  REASON_VISIT: 'reasonVisit',
	
	  LOCATION: 'locationId',
	  SERVICE: 'serviceId',
	  PROVIDER: 'providerId',
	  ROOM: 'room',
	  PAYMENT_STATUS: 'paymentStatus',
	  START_TIME: 'startTime',
	  REASON_TYPE_ID: 'reasonTypeId',
	  REASON_COMMENT: 'note',
	  COPAY: 'copay',
	
	  DATE: 'date',
	
	  CHAT_NAME: 'chatName',
	  RELATIONSHIP_PRIORITY: 'relationship_priority',
	
	  IS_HOME_LOCATION_DIFFERENT: 'isHomeLocationDifferent'
	};
	
	var INSURANCE_ELIGIBILITY_FIELDS_TYPES = exports.INSURANCE_ELIGIBILITY_FIELDS_TYPES = {
	  MEMBER_ID: 'memberId',
	  GROUP_NUMBER: 'groupNumber',
	  PRIMARY_SUBSCRIBER: 'primarySubscriber',
	  FIRST_NAME: 'firstName',
	  LAST_NAME: 'lastName',
	  DOB: 'dob',
	  PHONE_NUMBER: 'phoneNumber',
	  ADDRESS_1: 'address1',
	  ADDRESS_2: 'address2',
	  CITY: 'city',
	  STATE: 'state',
	  POSTAL_CODE: 'postalCode',
	  DO_NOT_HAVE_INSURANCE: 'doNotHaveInsurance',
	  HEALTH_PLAN: 'healthPlan',
	  GENDER: 'gender',
	  INSURANCE_RELATION_ID: 'insuranceRelationId'
	};
	
	var COMPLETE_YOUR_PROFILE_FIELD_TYPES = exports.COMPLETE_YOUR_PROFILE_FIELD_TYPES = {
	  RACE: 'race',
	  ETHNICITY: 'ethnicity',
	  EMAIL: 'email',
	  FIRST_NAME: 'firstName',
	  LAST_NAME: 'lastName',
	  PHONE_NUMBER: 'phoneNumber',
	  RELATION: 'relation',
	  ADDRESS1: 'address1',
	  ADDRESS2: 'address2',
	  CITY: 'city',
	  COUNTRY: 'country',
	  STATE: 'state',
	  POSTAL_CODE: 'postalCode',
	  LANGUAGE: 'language'
	};
	
	var GUARANTOR_FIELD_TYPES = exports.GUARANTOR_FIELD_TYPES = {
	  FIRST_NAME: 'firstName',
	  LAST_NAME: 'lastName',
	  DOB: 'dob',
	  PHONE_NUMBER: 'phoneNumber',
	  EMAIL: 'email',
	  GENDER: 'gender',
	  RELATIONSHIP: 'relationship',
	  ADDRESS1: 'address1',
	  ADDRESS2: 'address2',
	  CITY: 'city',
	  STATE: 'state',
	  POSTAL_CODE: 'postalCode'
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sheetsManager = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _map = __webpack_require__(160);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _minSafeInteger = __webpack_require__(4296);
	
	var _minSafeInteger2 = _interopRequireDefault(_minSafeInteger);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _hoistNonReactStatics = __webpack_require__(1569);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _getDisplayName = __webpack_require__(2395);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _wrapDisplayName = __webpack_require__(735);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _contextTypes = __webpack_require__(6227);
	
	var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	var _jss = __webpack_require__(2300);
	
	var _ns = __webpack_require__(2792);
	
	var ns = _interopRequireWildcard(_ns);
	
	var _jssPreset = __webpack_require__(2398);
	
	var _jssPreset2 = _interopRequireDefault(_jssPreset);
	
	var _createMuiTheme = __webpack_require__(1570);
	
	var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);
	
	var _themeListener = __webpack_require__(1571);
	
	var _themeListener2 = _interopRequireDefault(_themeListener);
	
	var _createGenerateClassName = __webpack_require__(2397);
	
	var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);
	
	var _getStylesCreator = __webpack_require__(5676);
	
	var _getStylesCreator2 = _interopRequireDefault(_getStylesCreator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// New JSS instance.
	var jss = (0, _jss.create)((0, _jssPreset2.default)());
	
	// Use a singleton or the provided one by the context.
	var generateClassName = (0, _createGenerateClassName2.default)();
	
	// Global index counter to preserve source order.
	// As we create the style sheet during componentWillMount lifecycle,
	// children are handled after the parents, so the order of style elements would
	// be parent->child. It is a problem though when a parent passes a className
	// which needs to override any childs styles. StyleSheet of the child has a higher
	// specificity, because of the source order.
	// So our solution is to render sheets them in the reverse order child->sheet, so
	// that parent has a higher specificity.
	var indexCounter = _minSafeInteger2.default;
	
	var sheetsManager = exports.sheetsManager = new _map2.default();
	
	// We use the same empty object to ref count the styles that don't need a theme object.
	var noopTheme = {};
	
	// In order to have self-supporting components, we rely on default theme when not provided.
	var defaultTheme = void 0;
	
	function getDefaultTheme() {
	  if (defaultTheme) {
	    return defaultTheme;
	  }
	
	  defaultTheme = (0, _createMuiTheme2.default)();
	  return defaultTheme;
	}
	
	// Link a style sheet with a component.
	// It does not modify the component passed to it;
	// instead, it returns a new component, with a `classes` property.
	var withStyles = function withStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (Component) {
	    var _options$withTheme = options.withTheme,
	        withTheme = _options$withTheme === undefined ? false : _options$withTheme,
	        _options$flip = options.flip,
	        flip = _options$flip === undefined ? null : _options$flip,
	        name = options.name,
	        styleSheetOptions = (0, _objectWithoutProperties3.default)(options, ['withTheme', 'flip', 'name']);
	
	    var stylesCreator = (0, _getStylesCreator2.default)(stylesOrCreator);
	    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';
	
	    indexCounter += 1;
	    stylesCreator.options.index = indexCounter;
	
	     false ? (0, _warning2.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;
	
	    var WithStyles = function (_React$Component) {
	      (0, _inherits3.default)(WithStyles, _React$Component);
	
	      function WithStyles(props, context) {
	        (0, _classCallCheck3.default)(this, WithStyles);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).call(this, props, context));
	
	        _this.state = {};
	        _this.disableStylesGeneration = false;
	        _this.jss = null;
	        _this.sheetOptions = null;
	        _this.sheetsManager = sheetsManager;
	        _this.stylesCreatorSaved = null;
	        _this.theme = null;
	        _this.unsubscribeId = null;
	
	
	        _this.jss = _this.context[ns.jss] || jss;
	
	        var muiThemeProviderOptions = _this.context.muiThemeProviderOptions;
	
	        if (muiThemeProviderOptions) {
	          if (muiThemeProviderOptions.sheetsManager) {
	            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
	          }
	
	          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
	        }
	
	        // Attach the stylesCreator to the instance of the component as in the context
	        // of react-hot-loader the hooks can be executed in a different closure context:
	        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107
	        _this.stylesCreatorSaved = stylesCreator;
	        _this.sheetOptions = (0, _extends3.default)({
	          generateClassName: generateClassName
	        }, _this.context[ns.sheetOptions]);
	        // We use || as the function call is lazy evaluated.
	        _this.theme = listenToTheme ? _themeListener2.default.initial(context) || getDefaultTheme() : noopTheme;
	        return _this;
	      }
	
	      (0, _createClass3.default)(WithStyles, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          this.attach(this.theme);
	        }
	      }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          var _this2 = this;
	
	          if (!listenToTheme) {
	            return;
	          }
	
	          this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
	            var oldTheme = _this2.theme;
	            _this2.theme = theme;
	            _this2.attach(_this2.theme);
	
	            // Rerender the component so the underlying component gets the theme update.
	            // By theme update we mean receiving and applying the new class names.
	            _this2.setState({}, function () {
	              _this2.detach(oldTheme);
	            });
	          });
	        }
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps() {
	          // react-hot-loader specific logic
	          if (this.stylesCreatorSaved === stylesCreator || ("production") === 'production') {
	            return;
	          }
	
	          this.detach(this.theme);
	          this.stylesCreatorSaved = stylesCreator;
	          this.attach(this.theme);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.detach(this.theme);
	
	          if (this.unsubscribeId !== null) {
	            _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
	          }
	        }
	      }, {
	        key: 'attach',
	        value: function attach(theme) {
	          if (this.disableStylesGeneration) {
	            return;
	          }
	
	          var stylesCreatorSaved = this.stylesCreatorSaved;
	          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
	
	          if (!sheetManager) {
	            sheetManager = new _map2.default();
	            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
	          }
	
	          var sheetManagerTheme = sheetManager.get(theme);
	
	          if (!sheetManagerTheme) {
	            sheetManagerTheme = {
	              refs: 0,
	              sheet: null
	            };
	            sheetManager.set(theme, sheetManagerTheme);
	          }
	
	          if (sheetManagerTheme.refs === 0) {
	            var styles = stylesCreatorSaved.create(theme, name);
	            var meta = name;
	
	            if (false) {
	              meta = (0, _getDisplayName2.default)(Component);
	            }
	
	            var sheet = this.jss.createStyleSheet(styles, (0, _extends3.default)({
	              meta: meta,
	              classNamePrefix: meta,
	              flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
	              link: false
	            }, this.sheetOptions, stylesCreatorSaved.options, {
	              name: name
	            }, styleSheetOptions));
	
	            sheetManagerTheme.sheet = sheet;
	            sheet.attach();
	
	            var sheetsRegistry = this.context[ns.sheetsRegistry];
	            if (sheetsRegistry) {
	              sheetsRegistry.add(sheet);
	            }
	          }
	
	          sheetManagerTheme.refs += 1;
	        }
	      }, {
	        key: 'detach',
	        value: function detach(theme) {
	          if (this.disableStylesGeneration) {
	            return;
	          }
	
	          var stylesCreatorSaved = this.stylesCreatorSaved;
	          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
	          var sheetManagerTheme = sheetManager.get(theme);
	
	          sheetManagerTheme.refs -= 1;
	
	          if (sheetManagerTheme.refs === 0) {
	            sheetManager.delete(theme);
	            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
	            var sheetsRegistry = this.context[ns.sheetsRegistry];
	            if (sheetsRegistry) {
	              sheetsRegistry.remove(sheetManagerTheme.sheet);
	            }
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this3 = this;
	
	          var _props = this.props,
	              classesProp = _props.classes,
	              innerRef = _props.innerRef,
	              other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'innerRef']);
	
	
	          var classes = void 0;
	          var renderedClasses = {};
	
	          if (!this.disableStylesGeneration) {
	            var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
	            var sheetsManagerTheme = sheetManager.get(this.theme);
	            renderedClasses = sheetsManagerTheme.sheet.classes;
	          }
	
	          if (classesProp) {
	            classes = (0, _extends3.default)({}, renderedClasses, (0, _keys2.default)(classesProp).reduce(function (accumulator, key) {
	               false ? (0, _warning2.default)(renderedClasses[key] || _this3.disableStylesGeneration, ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not implemented in ' + (0, _getDisplayName2.default)(Component) + '.'), 'You can only override one of the following: ' + (0, _keys2.default)(renderedClasses).join(',')].join('\n')) : void 0;
	
	               false ? (0, _warning2.default)(!classesProp[key] || typeof classesProp[key] === 'string', ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not valid for ' + (0, _getDisplayName2.default)(Component) + '.'), 'You need to provide a non empty string instead of: ' + classesProp[key] + '.'].join('\n')) : void 0;
	
	              if (classesProp[key]) {
	                accumulator[key] = renderedClasses[key] + ' ' + classesProp[key];
	              }
	
	              return accumulator;
	            }, {}));
	          } else {
	            classes = renderedClasses;
	          }
	
	          var more = {};
	
	          // Provide the theme to the wrapped component.
	          // So we don't have to use the `withTheme()` Higher-order Component.
	          if (withTheme) {
	            more.theme = this.theme;
	          }
	
	          return _react2.default.createElement(Component, (0, _extends3.default)({ classes: classes }, more, other, { ref: innerRef }));
	        }
	      }]);
	      return WithStyles;
	    }(_react2.default.Component);
	
	    WithStyles.propTypes =  false ? {
	      /**
	       * Useful to extend the style applied to components.
	       */
	      classes: _propTypes2.default.object,
	      /**
	       * Use that property to pass a ref callback to the decorated component.
	       */
	      innerRef: _propTypes2.default.func
	    } : {};
	
	    WithStyles.contextTypes = (0, _extends3.default)({
	      muiThemeProviderOptions: _propTypes2.default.object
	    }, _contextTypes2.default, listenToTheme ? _themeListener2.default.contextTypes : {});
	
	    if (false) {
	      WithStyles.displayName = (0, _wrapDisplayName2.default)(Component, 'WithStyles');
	    }
	
	    (0, _hoistNonReactStatics2.default)(WithStyles, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithStyles.Naked = Component;
	      WithStyles.options = options;
	    }
	
	    return WithStyles;
	  };
	};
	
	exports.default = withStyles;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp; /* eslint-disable react/require-default-props,react/destructuring-assignment */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Modal = __webpack_require__(1188);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Dialog = __webpack_require__(3850);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _LocalizationContextWrapper = __webpack_require__(3866);
	
	var _LocalizationContextWrapper2 = _interopRequireDefault(_LocalizationContextWrapper);
	
	var _popup = __webpack_require__(76);
	
	var _selectors = __webpack_require__(90);
	
	var _index = __webpack_require__(5217);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    secondaryContentVisible: (0, _selectors.popupSecondaryContentVisibilitySelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  toggleContent: _popup.actions.toggleContent
	};
	
	var Popup = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(Popup, _PureComponent);
	
	  function Popup() {
	    (0, _classCallCheck3.default)(this, Popup);
	    return (0, _possibleConstructorReturn3.default)(this, (Popup.__proto__ || (0, _getPrototypeOf2.default)(Popup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Popup, [{
	    key: 'render',
	    value: function render() {
	      if (!this.props.opened) return null;
	
	      var _props = this.props,
	          children = _props.children,
	          intl = _props.intl,
	          returnable = _props.returnable,
	          centered = _props.centered,
	          secondaryContentVisible = _props.secondaryContentVisible,
	          overflowVisible = _props.overflowVisible,
	          disableFillBackground = _props.disableFillBackground,
	          className = _props.className,
	          style = _props.style;
	
	
	      var onClose = returnable && secondaryContentVisible ? this.props.toggleContent : this.props.onClose;
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            style: style,
	            className: className,
	            styleName: (0, _classnames2.default)('root', {
	              'root--overflow-visible': overflowVisible,
	              'root--disableFillBackground': disableFillBackground,
	              'root--centered': centered
	            })
	          },
	          _react2.default.createElement(
	            _Dialog2.default,
	            (0, _extends3.default)({}, this.props, { onClose: onClose }),
	            _react2.default.createElement(
	              _LocalizationContextWrapper2.default,
	              { intl: intl },
	              children
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Popup;
	}(_react.PureComponent), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  mobileFullScreen: _propTypes2.default.bool,
	  extraContentClassName: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  onClose: _propTypes2.default.func,
	  opened: _propTypes2.default.bool,
	  returnable: _propTypes2.default.bool,
	  centered: _propTypes2.default.bool,
	  secondaryContentVisible: _propTypes2.default.bool,
	  toggleContent: _propTypes2.default.func,
	  isLayoutColumn: _propTypes2.default.bool,
	  overflowVisible: _propTypes2.default.bool,
	  dialogPadding: _propTypes2.default.string,
	  disableFillBackground: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	}, _temp)) || _class) || _class) || _class);
	exports.default = Popup;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ADD_PATIENT_STEPS = exports.ASSIGMENT_STATUS = exports.DEPENDENT_STATUSES = exports.DASHBOARD_TIME_VALIDATION_RULES = exports.PAYMENT_STATUS = exports.SEARCH_TABS = exports.PATIENT = exports.CARE_ROLE = exports.COMPLAINT_RESOLVED_TITLES = exports.COMPLAINT_RESOLVE_ACTIONS = exports.REPORT_ENDPOINT_BY_RESOURCE_TYPE = exports.REPORT_RESOURCES = exports.UI_POPUP_TYPES = exports.LAST_MESSAGE_SORTING = exports.UNREAD_COUNT_SORTING = exports.USER_STATUS_TYPES = exports.USER_STATUS_JOINED = exports.USER_STATUS_CREATED = exports.USER_STATUS_INVITED = exports.USER_TYPE_FAMILY_MEMBER = exports.USER_TYPE_CAREGIVER = exports.USER_TYPE_PROVIDER = exports.USER_TYPE_PATIENT = exports.USER_TYPES_PROPS = exports.USER_TYPES = exports.INVITATION_TYPES = exports.PROPS_LIST = exports.FILTER_BY = exports.SORT_TYPES = exports.PROGRAM_VALUE_TYPES = exports.STATUS_FILTER_TYPES = exports.COMMUNITY_TYPES = exports.WIDE_TYPES = exports.QUESTION_TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _REPORT_ENDPOINT_BY_R, _COMPLAINT_RESOLVED_T; /*
	                                                   * TODO: check api responses proptypes
	                                                   */
	
	
	var _chat = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QUESTION_TYPES = exports.QUESTION_TYPES = {
	  general: 'true-false',
	  multiSelect: 'multi-select',
	  singleSelect: 'single-select',
	  numeric: 'numeric',
	  scale: 'scale',
	  text: 'text',
	  comment: 'comment',
	  consent: 'consent',
	  appointmentConsent: 'appointment_consent'
	};
	
	var WIDE_TYPES = exports.WIDE_TYPES = [QUESTION_TYPES.scale, QUESTION_TYPES.multiSelect, QUESTION_TYPES.singleSelect];
	
	var COMMUNITY_TYPES = exports.COMMUNITY_TYPES = {
	  public: 'public',
	  private: 'private',
	  global: 'global'
	};
	
	var STATUS_FILTER_TYPES = exports.STATUS_FILTER_TYPES = {
	  all: 'all',
	  joined: 'joined',
	  notJoined: 'not_joined'
	};
	
	var PROGRAM_VALUE_TYPES = exports.PROGRAM_VALUE_TYPES = {
	  all: null,
	  none: 'none'
	};
	
	var SORT_TYPES = exports.SORT_TYPES = {
	  asc: 'asc',
	  desc: 'desc'
	};
	
	var FILTER_BY = exports.FILTER_BY = {
	  ACTIVE: 'active',
	  HISTORY: 'history'
	};
	
	var PROPS_LIST = exports.PROPS_LIST = {
	  appAlert: {
	    type: ['success', 'error', 'danger']
	  },
	  btn: {
	    color: ['accent', 'danger', 'primary'],
	    kind: ['flat', 'raised', 'link', 'icon', 'text']
	  },
	  circle: {
	    type: ['family', 'provider', 'invite', 'team']
	  },
	  drawer: {
	    position: ['left', 'right']
	  },
	  imgPreview: {
	    size: ['small', 'regular']
	  },
	  msg: {
	    type: [_chat.MESSAGE_TYPES.ATTACHMENT, _chat.MESSAGE_TYPES.TEXT, _chat.MESSAGE_TYPES.NOTIFICATION, _chat.MESSAGE_TYPES.REMINDER, _chat.MESSAGE_TYPES.LINK_PREVIEW, _chat.MESSAGE_TYPES.UPLOAD_ATTACHMENT],
	    notification: [_chat.NOTIFICATION_TYPES.PARTICIPANT_ADDED, _chat.NOTIFICATION_TYPES.PROVIDER_ASSIGNED, _chat.NOTIFICATION_TYPES.SYSTEM, _chat.NOTIFICATION_TYPES.HEALTH_ALERT, _chat.NOTIFICATION_TYPES.UPCOMING_SURVEY, _chat.NOTIFICATION_TYPES.ANSWERED_SURVEY, _chat.NOTIFICATION_TYPES.AUTO_RESPONSE, _chat.NOTIFICATION_TYPES.ASSIGN_TO_PROGRAM, _chat.NOTIFICATION_TYPES.REMOVE_FROM_PROGRAM, _chat.NOTIFICATION_TYPES.FAMILY_MEMBER, _chat.NOTIFICATION_TYPES.PROVIDER_REMOVED]
	  },
	  previewableBlock: {
	    toggler: {
	      align: ['left', 'right', 'center', 'stretch']
	    }
	  },
	  survey: {
	    questionType: [QUESTION_TYPES.general, QUESTION_TYPES.multiSelect, QUESTION_TYPES.singleSelect, QUESTION_TYPES.numeric, QUESTION_TYPES.scale, QUESTION_TYPES.text],
	    frequency: ['once', 'daily', 'weekly', 'monthly', 'annually'],
	    type: ['general', 'program']
	  },
	  textInput: {
	    color: ['default', 'primary', 'transparent']
	  },
	  community: {
	    type: [COMMUNITY_TYPES.public, COMMUNITY_TYPES.private, COMMUNITY_TYPES.global]
	  },
	  statusFilter: {
	    options: [STATUS_FILTER_TYPES.all, STATUS_FILTER_TYPES.joined, STATUS_FILTER_TYPES.notJoined]
	  }
	};
	
	var INVITATION_TYPES = exports.INVITATION_TYPES = {
	  FAMILY_MEMBER: 'family_member_invitation',
	  COMMUNITY_MEMBER: 'community_member_invitation',
	  PATIENT: 'patient_invitation',
	  PROVIDER: 'provider_invitation'
	};
	
	var USER_TYPES = exports.USER_TYPES = {
	  FAMILY_MEMBER: 'family-member',
	  PATIENT: 'patient',
	  PROVIDER: 'provider'
	};
	
	var USER_TYPES_PROPS = exports.USER_TYPES_PROPS = [USER_TYPES.FAMILY_MEMBER, USER_TYPES.PATIENT, USER_TYPES.PROVIDER];
	
	var USER_TYPE_PATIENT = exports.USER_TYPE_PATIENT = 'patient';
	var USER_TYPE_PROVIDER = exports.USER_TYPE_PROVIDER = 'provider';
	var USER_TYPE_CAREGIVER = exports.USER_TYPE_CAREGIVER = 'caregiver';
	var USER_TYPE_FAMILY_MEMBER = exports.USER_TYPE_FAMILY_MEMBER = 'familyMember';
	
	var USER_STATUS_INVITED = exports.USER_STATUS_INVITED = 'invited';
	var USER_STATUS_CREATED = exports.USER_STATUS_CREATED = 'created';
	var USER_STATUS_JOINED = exports.USER_STATUS_JOINED = 'joined';
	
	var USER_STATUS_TYPES = exports.USER_STATUS_TYPES = [USER_STATUS_INVITED, USER_STATUS_CREATED, USER_STATUS_JOINED];
	
	var UNREAD_COUNT_SORTING = exports.UNREAD_COUNT_SORTING = 'unreadCount';
	var LAST_MESSAGE_SORTING = exports.LAST_MESSAGE_SORTING = 'lastMessageAt';
	
	var UI_POPUP_TYPES = exports.UI_POPUP_TYPES = {
	  REPORT: 'report',
	  MESSAGE: 'message',
	  DASHBOARD_CHANGE_STATUS: 'dashboard_change_status',
	  PAYA_PAYMENT: 'paya_payment',
	  LOADER: 'loader',
	  MOBILE_APP: 'mobile_app',
	  MFA_NOTICE: 'mfa_notice',
	  PAYA_ACCOUNT_FORM: 'paya_account_form',
	  PAYA_PAYMENT_HANDLE_RESPONSE: 'paya_payment_handle-response',
	  MEDICATIONS_REFILLS: 'medications_refills'
	};
	
	var REPORT_RESOURCES = exports.REPORT_RESOURCES = {
	  COMMENT: 'comment',
	  POST: 'post',
	  COMMUNITY: 'community'
	};
	
	var REPORT_ENDPOINT_BY_RESOURCE_TYPE = exports.REPORT_ENDPOINT_BY_RESOURCE_TYPE = (_REPORT_ENDPOINT_BY_R = {}, (0, _defineProperty3.default)(_REPORT_ENDPOINT_BY_R, REPORT_RESOURCES.COMMENT, 'comments'), (0, _defineProperty3.default)(_REPORT_ENDPOINT_BY_R, REPORT_RESOURCES.POST, 'posts'), (0, _defineProperty3.default)(_REPORT_ENDPOINT_BY_R, REPORT_RESOURCES.COMMUNITY, 'communities'), _REPORT_ENDPOINT_BY_R);
	
	var COMPLAINT_RESOLVE_ACTIONS = exports.COMPLAINT_RESOLVE_ACTIONS = {
	  SEND_MESSAGE: 'send_chat_message',
	  REMOVE_AUTHOR: 'remove_author_from_community',
	  DESTROY_REPORTABLE: 'destroy_reportable'
	};
	
	var COMPLAINT_RESOLVED_TITLES = exports.COMPLAINT_RESOLVED_TITLES = (_COMPLAINT_RESOLVED_T = {}, (0, _defineProperty3.default)(_COMPLAINT_RESOLVED_T, COMPLAINT_RESOLVE_ACTIONS.SEND_MESSAGE, 'reports.history.messageSent'), (0, _defineProperty3.default)(_COMPLAINT_RESOLVED_T, COMPLAINT_RESOLVE_ACTIONS.REMOVE_AUTHOR, 'reports.history.originatorRemoved'), (0, _defineProperty3.default)(_COMPLAINT_RESOLVED_T, COMPLAINT_RESOLVE_ACTIONS.DESTROY_REPORTABLE, 'reports.history.wasDeleted'), _COMPLAINT_RESOLVED_T);
	
	// don't add another roles here
	var CARE_ROLE = exports.CARE_ROLE = {
	  PARENT: 'parent',
	  FAMILY_MEMBER: 'family_member',
	  CAREGIVER: 'caregiver',
	  GUARDIAN: 'guardian',
	  PROXY: 'proxy'
	};
	
	var PATIENT = exports.PATIENT = 'patient';
	
	var SEARCH_TABS = exports.SEARCH_TABS = {
	  PEOPLE: 'people',
	  TEAMS: 'teams',
	  PROVIDERS: 'providers'
	};
	
	var PAYMENT_STATUS = exports.PAYMENT_STATUS = {
	  paid: 'paid',
	  unpaid: 'unpaid'
	};
	
	var DASHBOARD_TIME_VALIDATION_RULES = exports.DASHBOARD_TIME_VALIDATION_RULES = {
	  format: 'HH:mm ZZ'
	};
	
	var DEPENDENT_STATUSES = exports.DEPENDENT_STATUSES = {
	  UNVERIFIED: 'unverified',
	  PENDING: 'pending'
	};
	
	var ASSIGMENT_STATUS = exports.ASSIGMENT_STATUS = {
	  PERMANENT: 'permanent',
	  TEMPORARY: 'temporary'
	};
	
	var ADD_PATIENT_STEPS = exports.ADD_PATIENT_STEPS = {
	  CONTACTS: 'contacts',
	  PERSONAL_INFO: 'personalInfo',
	  ADDRESS: 'address'
	};

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectAppointmentPaymentInfoModalProps = exports.selectAppointmentPaymentInfoModalOpened = exports.selectAppointmentPaymentInfoModal = exports.selectIsOrganizationEmployersLastPage = exports.selectFetchingOrganizationEmployersListSucceed = exports.selectOrganizationEmployersListLoading = exports.selectOrganizationEmployersList = exports.selectOrganizationEmployersListState = exports.selectIsOrganizationPrimaryCareProvidersLastPage = exports.selectFetchingOrganizationPrimaryCareProvidersListSucceed = exports.selectOrganizationPrimaryCareProvidersListLoading = exports.selectOrganizationPrimaryCareProvidersList = exports.selectOrganizationPrimaryCareProvidersListState = exports.selectPreferredLanguage = exports.selectCreateEirUrgentCareAppointmentPending = exports.selectPcpProviderAnswer = exports.selectInsuranceErrorModalEntity = exports.selectInsuranceErrorModalState = exports.selectOverlapModalEntity = exports.selectOverlapModalState = exports.selectCreateVirtualVisitError = exports.selectCreateVirtualVisitPending = exports.selectUrgentVisitPayload = exports.selectUrgentVisitConfirmPending = exports.selectSelfSchedulingConfirmPending = exports.selectVirtualVisitProvidersList = exports.selectVirtualVisitProvidersPending = exports.selectConfirmVisitPending = exports.selectConfirmVisitGWPending = exports.selectCopayPrice = exports.selectReasonForOverview = exports.selectFilterPayloadData = exports.selectScheduleListReqPayload = exports.selectSchedulePayloadData = exports.selectScheduleMetaDataFromProviderInfo = exports.selectScheduleMetaDataFromProviderList = exports.selectCurrentProviderAvailableTimeSlots = exports.selectCurrentProviderDetails = exports.makeProviderDetailsSelect = exports.selectProviderDetails = exports.selectProviderDetailsPending = exports.selectCurrentProviderGWAvailableTimeSlots = exports.makeProviderGWDetailsSelect = exports.selectProviderGWDetails = exports.selectProviderGWDetailsPending = exports.makeAppointmentProviderByIdSelect = exports.selectAppointmentProviderList = exports.selectAppointmentProviderListMeta = exports.selectAppointmentProviderListIds = exports.selectAppointmentProviderListPending = exports.selectAppointmentProviderListState = exports.selectCheckInsurancePlanConfigLoading = exports.selectCheckInsurancePlanConfigState = exports.selectAppointmentFilterList = exports.selectAppointmentFilterPending = exports.selectAppointmentLocationFilter = exports.selectAppointmentDateFilter = exports.selectProgressGlobalPending = exports.selectUpdateNecessaryDataPending = exports.selectReasonVisitPending = exports.selectReasonVisitList = exports.selectReasonTypesList = exports.selectReasonTypesPending = exports.selectAdditionalInfoFormData = exports.selectEirVisitTypePCPFormData = exports.selectAppointmentFormUserState = exports.selectAppointmentFormUserCountry = exports.selectUserPrimaryPatientProfileId = exports.selectUserPrimaryPatientProfileGuarantorId = exports.selectUserPrimaryPatientProfile = exports.selectUserEmergencyContactAttributes = exports.selectUserCountryDetails = exports.selectSSN = exports.makeUserSelect = exports.selectUserDetails = exports.selectUserDetailsPending = exports.selectConsentFormUrl = exports.makeConsentFormSelect = undefined;
	exports.selectConsentFormData = exports.selectConsentFormPending = exports.selectPatientFieldsListErrors = exports.selectInspectDocumentsPending = exports.selectInspectPatientList = exports.selectInspectPatientPending = exports.selectInspectConsentPending = exports.selectProfileFormInspectionFieldListErrorsKeys = exports.selectProfileFormInspectionFieldListErrors = exports.makeSelectInspectionById = exports.selectInspectionList = exports.selectInspectorEntities = exports.selectInspectorIds = exports.selectInspectorRequiredSteps = exports.selectInspectorPending = exports.selectVirtualServiceByLocationId = exports.selectVirtualVisitLocations = exports.selectVirtualVisitServicesList = exports.selectInsuranceEligibilityId = exports.selectCheckInsuranceEligibilitySucceed = exports.selectCheckInsuranceEligibilityLoading = exports.selectCheckInsuranceEligibilityError = exports.selectInsuranceLatestCheck = exports.selectInsuranceLatestCheckError = exports.selectInsuranceLatestCheckLoading = exports.selectInsuranceLatestCheckData = exports.selectInsurancePayersFetchingSucceed = exports.selectInsurancePayersIsLastPage = exports.selectInsurancePayersMetaMessage = exports.selectInsurancePayersLoading = exports.selectInsurancePayersList = exports.selectInsurancePayersState = exports.selectProgramBasedVisitsPending = exports.selectProgramBasedVisitsList = exports.selectSuccessConfirmInlineVisit = exports.selectInlineVisitTimeSlotsPending = exports.selectInlineVisitTimeSlots = exports.selectPublixInfoPending = exports.selectPublixInfo = exports.selectVisitTypesList = exports.selectVisitTypesPending = exports.selectOrganizationPending = exports.selectOrganizationList = exports.selectCareUsersPending = exports.selectCareUsersList = exports.selectSchedulingTreeOrganizations = exports.selectSchedulingTree = exports.selectAvailableEirLocationLoading = exports.selectAvailableEirLocationsData = exports.selectUrgentAppointmentId = exports.selectAvailableProvidersSelfSchedulingLoading = exports.selectAvailableProvidersSelfScheduling = exports.selectMyProvidersPaginationLoading = exports.selectMyProvidersVisitTypes = exports.selectMyProvidersList = exports.selectMyProvidersCount = exports.selectMyProvidersLoading = exports.selectFlowPages = exports.selectAppointmentFormPending = exports.selectIsEirTelemedicineVisitTypeCode = exports.selectIsEirVisitTypeCode = exports.selectProgressScheduleLocationId = exports.selectProgressLocationIdWithLocalVisit = exports.selectProgressLocationIdWithUVVFlow = exports.selectProgressInsuranceEligibilityId = exports.selectProgressScheduleProviderOrganizationName = exports.selectProgressIsUrgentVisitFlow = exports.selectProgressIsCreateFlowGW = exports.selectProgressScheduleProvider = exports.selectPrimaryProviderData = exports.selectProgressScheduleId = exports.selectProgressIsRescheduleData = exports.selectProgressRescheduleData = exports.selectProgressSchedule = exports.selectProgressError = exports.selectProgressReason = exports.selectProgressSSN = exports.selectHealthInfoForm = exports.selectProgressPatientForm = exports.selectProgressLocation = exports.selectProgressService = exports.selectProgressLocationsByVisit = exports.selectProgressServicesByVisit = exports.selectProgramBasedVisitId = exports.selectProgressVisitTypeCode = exports.selectProgressVisitType = exports.selectProgressOrganizationTenantSkipInsurance = exports.selectProgressOrganizationId = exports.selectProgressOrganization = exports.selectProgressCareUserHasPrimaryCareProvider = exports.selectProgressCareUserSkipInsurance = exports.selectProgressCareUserDisplayableName = exports.selectProgressCareUserId = exports.selectProgressCareUser = exports.selectProgressValidating = exports.selectPreferredPharmacy = exports.selectMedicationSearch = exports.selectMedicationSearchData = exports.selectPharmaciesList = exports.selectRootState = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _pick = __webpack_require__(466);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _uniqBy = __webpack_require__(989);
	
	var _uniqBy2 = _interopRequireDefault(_uniqBy);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _camelCase = __webpack_require__(322);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _ids = __webpack_require__(46);
	
	var _constants = __webpack_require__(17);
	
	var _selectAdapter = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OTHER_REASON_TYPE = _ids.IDS.APPOINTMENT_FORM.OTHER_REASON_TYPE;
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'appointmentForm');
	};
	var getSelectors = (0, _selectAdapter.makeSelectorFactory)(selectRootState);
	
	/**
	 *  PROGRESS
	 * */
	var selectProgressState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'progress', {});
	});
	
	var selectPharmaciesList = exports.selectPharmaciesList = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'pharmaciesList', null);
	});
	
	var selectMedicationSearchData = exports.selectMedicationSearchData = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'medicationsList.list', []);
	});
	
	var selectMedicationSearch = exports.selectMedicationSearch = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'medicationsList', {});
	});
	
	var selectPreferredPharmacy = exports.selectPreferredPharmacy = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'pharmacyId');
	});
	
	var selectProgressValidating = exports.selectProgressValidating = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'validating');
	});
	var selectProgressCareUser = exports.selectProgressCareUser = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'careUser');
	});
	var selectProgressCareUserId = exports.selectProgressCareUserId = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'careUser.id');
	});
	
	var selectProgressCareUserDisplayableName = exports.selectProgressCareUserDisplayableName = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'careUser.displayableName', '');
	});
	
	var selectProgressCareUserSkipInsurance = exports.selectProgressCareUserSkipInsurance = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'careUser.skipInsurance', false);
	});
	
	var selectProgressCareUserHasPrimaryCareProvider = exports.selectProgressCareUserHasPrimaryCareProvider = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'careUser.hasPrimaryCareProvider', false);
	});
	
	var selectProgressOrganization = exports.selectProgressOrganization = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'organization', {});
	});
	var selectProgressOrganizationId = exports.selectProgressOrganizationId = (0, _reselect.createSelector)(selectProgressOrganization, function (progress) {
	  return (0, _get2.default)(progress, 'id', null);
	});
	
	var selectProgressOrganizationTenantSkipInsurance = exports.selectProgressOrganizationTenantSkipInsurance = (0, _reselect.createSelector)(selectProgressOrganization, function (progress) {
	  return (0, _get2.default)(progress, 'tenant.skipInsurance', false);
	});
	
	var selectProgressVisitType = exports.selectProgressVisitType = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'visitType', {});
	});
	var selectProgressVisitTypeCode = exports.selectProgressVisitTypeCode = (0, _reselect.createSelector)(selectProgressVisitType, function (progress) {
	  return (0, _get2.default)(progress, 'code', '');
	});
	var selectProgramBasedVisitId = exports.selectProgramBasedVisitId = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'pbvConfigId');
	});
	var selectProgressServicesByVisit = exports.selectProgressServicesByVisit = (0, _reselect.createSelector)(selectProgressVisitType, function (visitType) {
	  return (0, _get2.default)(visitType, 'services', []);
	});
	var selectProgressLocationsByVisit = exports.selectProgressLocationsByVisit = (0, _reselect.createSelector)(selectProgressServicesByVisit, function (services) {
	  return (0, _get2.default)(services[0], 'locations', []);
	});
	var selectProgressService = exports.selectProgressService = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'service', {});
	});
	var selectProgressLocation = exports.selectProgressLocation = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'location', {});
	});
	var selectProgressPatientForm = exports.selectProgressPatientForm = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'patientForm', null);
	});
	var selectHealthInfoForm = exports.selectHealthInfoForm = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'healthInfo', null);
	});
	var selectProgressSSN = exports.selectProgressSSN = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'ssn', '');
	});
	var selectProgressReason = exports.selectProgressReason = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'reason', null);
	});
	var selectProgressError = exports.selectProgressError = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'error', null);
	});
	var selectProgressSchedule = exports.selectProgressSchedule = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'schedule', {});
	});
	var selectProgressRescheduleData = exports.selectProgressRescheduleData = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'rescheduleData', {});
	});
	var selectProgressIsRescheduleData = exports.selectProgressIsRescheduleData = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'rescheduleData.id', null);
	});
	var selectProgressScheduleId = exports.selectProgressScheduleId = (0, _reselect.createSelector)(selectRootState, function (progress) {
	  return (0, _get2.default)(progress, 'providerGWDetails.data.id', '');
	});
	var selectPrimaryProviderData = exports.selectPrimaryProviderData = (0, _reselect.createSelector)(selectRootState, function (progress) {
	  return (0, _get2.default)(progress, 'primaryProviderData.data', null);
	});
	var selectProgressScheduleProvider = exports.selectProgressScheduleProvider = (0, _reselect.createSelector)(selectProgressSchedule, function (schedule) {
	  return (0, _get2.default)(schedule, 'provider', {});
	});
	
	var selectProgressIsCreateFlowGW = exports.selectProgressIsCreateFlowGW = (0, _reselect.createSelector)(selectProgressState, function (data) {
	  return (0, _get2.default)(data, 'isGWFlow', false);
	});
	
	var selectProgressIsUrgentVisitFlow = exports.selectProgressIsUrgentVisitFlow = (0, _reselect.createSelector)(selectProgressState, function (data) {
	  return (0, _get2.default)(data, 'isUrgentVisitFlow', false);
	});
	
	var selectProgressScheduleProviderOrganizationName = exports.selectProgressScheduleProviderOrganizationName = (0, _reselect.createSelector)(selectProgressSchedule, function (schedule) {
	  return (0, _get2.default)(schedule, 'provider.organization.name', '');
	});
	
	var selectProgressInsuranceEligibilityId = exports.selectProgressInsuranceEligibilityId = (0, _reselect.createSelector)(selectProgressState, function (data) {
	  return (0, _get2.default)(data, 'insuranceEligibility.id', null);
	});
	
	var selectProgressLocationIdWithUVVFlow = exports.selectProgressLocationIdWithUVVFlow = (0, _reselect.createSelector)(selectProgressService, function (service) {
	  return (0, _get2.default)(service, 'locations[0].id');
	});
	
	var selectProgressLocationIdWithLocalVisit = exports.selectProgressLocationIdWithLocalVisit = (0, _reselect.createSelector)(selectProgressLocation, function (location) {
	  return (0, _get2.default)(location, 'id');
	});
	
	var selectProgressScheduleLocationId = exports.selectProgressScheduleLocationId = (0, _reselect.createSelector)(selectProgressLocationIdWithUVVFlow, selectProgressIsUrgentVisitFlow, selectProgressSchedule, selectProgressLocationIdWithLocalVisit, function (locationIdUVV, isUrgentVisitFlow, schedule, locationIdByLocalVisit) {
	  if (isUrgentVisitFlow) {
	    return locationIdUVV;
	  }
	  if (locationIdByLocalVisit) {
	    return locationIdByLocalVisit;
	  }
	  return (0, _get2.default)(schedule, 'location.id');
	});
	
	var selectIsEirVisitTypeCode = exports.selectIsEirVisitTypeCode = (0, _reselect.createSelector)(selectProgressVisitTypeCode, function (typeCode) {
	  return _constants.EIR_APPOINTMENT_TYPES.includes(typeCode) || false;
	});
	
	var selectIsEirTelemedicineVisitTypeCode = exports.selectIsEirTelemedicineVisitTypeCode = (0, _reselect.createSelector)(selectProgressVisitTypeCode, function (typeCode) {
	  return typeCode === _constants.TELEMEDICINE_VISIT_TYPE_CODE;
	});
	
	var selectAppointmentFormPending = exports.selectAppointmentFormPending = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'pending');
	});
	
	var selectFlowPages = exports.selectFlowPages = (0, _reselect.createSelector)(selectProgressState, function (progress) {
	  return (0, _get2.default)(progress, 'flowPages');
	});
	
	/**
	 *  MY PROVIDERS
	 * */
	
	var selectMyProvidersState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'myProviders', {});
	});
	
	var selectMyProvidersLoading = exports.selectMyProvidersLoading = (0, _reselect.createSelector)(selectMyProvidersState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectMyProvidersCount = exports.selectMyProvidersCount = (0, _reselect.createSelector)(selectMyProvidersState, function (state) {
	  return (0, _get2.default)(state, 'count', 0);
	});
	
	var selectMyProvidersList = exports.selectMyProvidersList = (0, _reselect.createSelector)(selectMyProvidersState, function (state) {
	  return (0, _get2.default)(state, 'data.appointments', []);
	});
	
	var selectMyProvidersVisitTypes = exports.selectMyProvidersVisitTypes = (0, _reselect.createSelector)(selectMyProvidersState, function (state) {
	  return (0, _get2.default)(state, 'data.visitTypes', []);
	});
	
	var selectMyProvidersPaginationLoading = exports.selectMyProvidersPaginationLoading = (0, _reselect.createSelector)(selectMyProvidersState, function (state) {
	  return (0, _get2.default)(state, 'paginationSending', false);
	});
	
	/**
	 *  AVAILABLE PROVIDERS SELF SCHEDULING
	 * */
	
	var selectAvailableProvidersSelfScheduling = exports.selectAvailableProvidersSelfScheduling = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'availableProvidersSelfScheduling.data', []);
	});
	
	var selectAvailableProvidersSelfSchedulingLoading = exports.selectAvailableProvidersSelfSchedulingLoading = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'availableProvidersSelfScheduling.sending', false);
	});
	
	var selectUrgentAppointmentId = exports.selectUrgentAppointmentId = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'confirmVisitUrgent.id', null);
	});
	
	/**
	 *  AVAILABLE EIR LOCATIONS
	 * */
	
	var selectAvailableEirLocationsData = exports.selectAvailableEirLocationsData = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'availableEirLocations.data', []);
	});
	
	var selectAvailableEirLocationLoading = exports.selectAvailableEirLocationLoading = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'availableEirLocations.sending', false);
	});
	
	/**
	 *  SCHEDULING TREE
	 * */
	
	var selectSchedulingTree = exports.selectSchedulingTree = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'schedulingTree', {});
	});
	
	var selectSchedulingTreeOrganizations = exports.selectSchedulingTreeOrganizations = (0, _reselect.createSelector)(selectSchedulingTree, function (data) {
	  return (0, _get2.default)(data, 'organizations', []);
	});
	
	/**
	 *  CARE USERS LIST
	 * */
	
	var _getSelectors = getSelectors('careUsers'),
	    selectCareUsersList = _getSelectors.selectStateList,
	    selectCareUsersPending = _getSelectors.selectStatePending;
	
	/**
	 *  ORGANIZATION LIST
	 * */
	
	
	exports.selectCareUsersList = selectCareUsersList;
	exports.selectCareUsersPending = selectCareUsersPending;
	
	var _getSelectors2 = getSelectors('organizations'),
	    selectOrganizationList = _getSelectors2.selectStateList,
	    selectOrganizationPending = _getSelectors2.selectStatePending;
	
	/**
	 *  VISIT TYPE LIST
	 * */
	
	
	exports.selectOrganizationList = selectOrganizationList;
	exports.selectOrganizationPending = selectOrganizationPending;
	
	var _getSelectors3 = getSelectors('visitTypes'),
	    selectVisitTypesPending = _getSelectors3.selectStatePending,
	    selectVisitTypesList = _getSelectors3.selectStateList;
	
	/**
	 *  PUBLIX INFO
	 * */
	
	
	exports.selectVisitTypesPending = selectVisitTypesPending;
	exports.selectVisitTypesList = selectVisitTypesList;
	var selectPublixInfo = exports.selectPublixInfo = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'publixInfo.guidePages', []);
	});
	
	var _getSelectors4 = getSelectors('publixInfo'),
	    selectPublixInfoPending = _getSelectors4.selectStatePending;
	
	/**
	 *  INLINE VISITS TIME SLOTS
	 * */
	
	
	exports.selectPublixInfoPending = selectPublixInfoPending;
	
	var _getSelectors5 = getSelectors('inlineVisitTimeSlots'),
	    selectInlineVisitTimeSlots = _getSelectors5.selectStateData,
	    selectInlineVisitTimeSlotsPending = _getSelectors5.selectStatePending;
	
	/**
	 *  CONFITM INLINE VISIT
	 * */
	
	
	exports.selectInlineVisitTimeSlots = selectInlineVisitTimeSlots;
	exports.selectInlineVisitTimeSlotsPending = selectInlineVisitTimeSlotsPending;
	
	var _getSelectors6 = getSelectors('confirmInlineVisit'),
	    selectSuccessConfirmInlineVisit = _getSelectors6.selectStateSucceed;
	
	/**
	 *  PROGRAM BASED VISITS LIST
	 * */
	
	
	exports.selectSuccessConfirmInlineVisit = selectSuccessConfirmInlineVisit;
	
	var _getSelectors7 = getSelectors('programBasedVisits'),
	    selectProgramBasedVisitsList = _getSelectors7.selectStateList,
	    selectProgramBasedVisitsPending = _getSelectors7.selectStatePending;
	
	/**
	 *  INSURANCE ELIGIBILITY PAYERS LIST
	 * */
	
	
	exports.selectProgramBasedVisitsList = selectProgramBasedVisitsList;
	exports.selectProgramBasedVisitsPending = selectProgramBasedVisitsPending;
	
	var _getSelectors8 = getSelectors('insurancePayers'),
	    selectInsurancePayersState = _getSelectors8.selectState,
	    selectInsurancePayersList = _getSelectors8.selectStateList,
	    selectInsurancePayersLoading = _getSelectors8.selectStatePending;
	
	exports.selectInsurancePayersState = selectInsurancePayersState;
	exports.selectInsurancePayersList = selectInsurancePayersList;
	exports.selectInsurancePayersLoading = selectInsurancePayersLoading;
	var selectInsurancePayersMetaMessage = exports.selectInsurancePayersMetaMessage = (0, _reselect.createSelector)(selectInsurancePayersState, function (state) {
	  return (0, _get2.default)(state, 'meta.message', '');
	});
	
	var selectInsurancePayersIsLastPage = exports.selectInsurancePayersIsLastPage = (0, _reselect.createSelector)(selectInsurancePayersState, function (state) {
	  return (0, _get2.default)(state, 'isLastPage', false);
	});
	
	var selectInsurancePayersFetchingSucceed = exports.selectInsurancePayersFetchingSucceed = (0, _reselect.createSelector)(selectInsurancePayersState, function (state) {
	  return (0, _get2.default)(state, 'succeed', null);
	});
	
	/**
	 *  LATEST CHECK INSURANCE
	 * */
	
	var _getSelectors9 = getSelectors('latestCheckInsuranceEligibility'),
	    selectInsuranceLatestCheckData = _getSelectors9.selectState,
	    selectInsuranceLatestCheckLoading = _getSelectors9.selectStatePending,
	    selectInsuranceLatestCheckError = _getSelectors9.selectStateError;
	
	exports.selectInsuranceLatestCheckData = selectInsuranceLatestCheckData;
	exports.selectInsuranceLatestCheckLoading = selectInsuranceLatestCheckLoading;
	exports.selectInsuranceLatestCheckError = selectInsuranceLatestCheckError;
	var selectInsuranceLatestCheck = exports.selectInsuranceLatestCheck = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'latestCheckInsuranceEligibility.userInputs', {});
	});
	
	/**
	 *  CHECK INSURANCE ELIGIBILITY
	 * */
	
	var _getSelectors10 = getSelectors('checkInsuranceEligibility'),
	    selectCheckInsuranceEligibilityError = _getSelectors10.selectStateError,
	    selectCheckInsuranceEligibilityLoading = _getSelectors10.selectStatePending,
	    selectCheckInsuranceEligibilitySucceed = _getSelectors10.selectStateSucceed;
	
	exports.selectCheckInsuranceEligibilityError = selectCheckInsuranceEligibilityError;
	exports.selectCheckInsuranceEligibilityLoading = selectCheckInsuranceEligibilityLoading;
	exports.selectCheckInsuranceEligibilitySucceed = selectCheckInsuranceEligibilitySucceed;
	var selectInsuranceEligibilityId = exports.selectInsuranceEligibilityId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'checkInsuranceEligibility.id');
	});
	
	/**
	 *  VIRTUAL VISIT SERVICES LIST
	 * */
	
	var selectVirtualVisitServicesList = exports.selectVirtualVisitServicesList = (0, _reselect.createSelector)(selectVisitTypesList, function (state) {
	  var visit = state.find(function (item) {
	    return item.code === 'W';
	  });
	  return (0, _get2.default)(visit, 'services', []);
	});
	
	var selectVirtualVisitLocations = exports.selectVirtualVisitLocations = (0, _reselect.createSelector)(selectVirtualVisitServicesList, function (list) {
	  var locations = list.reduce(function (prev, curr) {
	    return [].concat((0, _toConsumableArray3.default)(prev), (0, _toConsumableArray3.default)(curr.locations));
	  }, []);
	  return (0, _uniqBy2.default)(locations, 'id');
	});
	
	var selectVirtualServiceByLocationId = exports.selectVirtualServiceByLocationId = function selectVirtualServiceByLocationId(id) {
	  return (0, _reselect.createSelector)(selectVirtualVisitServicesList, function (list) {
	    return list.filter(function (service) {
	      var locations = (0, _get2.default)(service, 'locations', []);
	      return locations.some(function (item) {
	        return item.id === id;
	      });
	    });
	  });
	};
	
	/**
	 *  INSPECTOR
	 * */
	var selectInspectorState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'inspection', {});
	});
	var selectInspectorPending = exports.selectInspectorPending = (0, _reselect.createSelector)(selectInspectorState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	var selectInspectorRequiredSteps = exports.selectInspectorRequiredSteps = (0, _reselect.createSelector)(selectInspectorState, function (state) {
	  return (0, _get2.default)(state, 'requiredSteps', []);
	});
	var selectInspectorIds = exports.selectInspectorIds = (0, _reselect.createSelector)(selectInspectorState, function (state) {
	  return (0, _get2.default)(state, 'ids', []);
	});
	var selectInspectorEntities = exports.selectInspectorEntities = (0, _reselect.createSelector)(selectInspectorState, function (state) {
	  return (0, _get2.default)(state, 'entities', {});
	});
	var selectInspectionList = exports.selectInspectionList = (0, _reselect.createSelector)(selectInspectorIds, selectInspectorEntities, function (ids, entities) {
	  return ids.map(function (id) {
	    return entities[id];
	  });
	});
	var makeSelectInspectionById = exports.makeSelectInspectionById = function makeSelectInspectionById(id) {
	  return (0, _reselect.createSelector)(selectInspectorEntities, function (entities) {
	    return entities[id];
	  });
	};
	
	var selectProfileFormInspectionFieldListErrors = exports.selectProfileFormInspectionFieldListErrors = (0, _reselect.createSelector)(selectInspectorEntities, function (entity) {
	  return (0, _get2.default)(entity, _constants.APPOINTMENT_INSPECTION.PROFILE + '.fieldList', []);
	});
	
	var selectProfileFormInspectionFieldListErrorsKeys = exports.selectProfileFormInspectionFieldListErrorsKeys = (0, _reselect.createSelector)(selectProfileFormInspectionFieldListErrors, function (list) {
	  return list.map(function (item) {
	    return (0, _camelCase2.default)((0, _get2.default)(item, 'key'));
	  });
	});
	
	/**
	 *  INSPECTION
	 * */
	
	var _getSelectors11 = getSelectors('inspectConsent'),
	    selectInspectConsentPending = _getSelectors11.selectStatePending;
	
	exports.selectInspectConsentPending = selectInspectConsentPending;
	
	var _getSelectors12 = getSelectors('inspectPatient'),
	    selectInspectPatientPending = _getSelectors12.selectStatePending,
	    selectInspectPatientList = _getSelectors12.selectStateList;
	
	exports.selectInspectPatientPending = selectInspectPatientPending;
	exports.selectInspectPatientList = selectInspectPatientList;
	
	var _getSelectors13 = getSelectors('inspectDocuments'),
	    selectInspectDocumentsPending = _getSelectors13.selectStatePending;
	
	/**
	 *  PATIENT INSPECTION ERRORS
	 * */
	
	exports.selectInspectDocumentsPending = selectInspectDocumentsPending;
	var selectPatientFieldsListErrors = exports.selectPatientFieldsListErrors = (0, _reselect.createSelector)(selectInspectPatientList, function (list) {
	  return (0, _get2.default)(list[0], 'fieldList', []);
	});
	
	/**
	 *  CONSENT FORM
	 * */
	
	var _getSelectors14 = getSelectors('consent'),
	    selectConsentFormPending = _getSelectors14.selectStatePending,
	    selectConsentFormData = _getSelectors14.selectStateData,
	    makeConsentFormSelect = _getSelectors14.makeSelect;
	
	exports.selectConsentFormPending = selectConsentFormPending;
	exports.selectConsentFormData = selectConsentFormData;
	exports.makeConsentFormSelect = makeConsentFormSelect;
	var selectConsentFormUrl = exports.selectConsentFormUrl = makeConsentFormSelect('data.file', '');
	
	/**
	 *  USER DETAILS
	 * */
	
	var _getSelectors15 = getSelectors('userDetails'),
	    selectUserDetailsPending = _getSelectors15.selectStatePending,
	    selectUserDetails = _getSelectors15.selectStateData,
	    makeUserSelect = _getSelectors15.makeSelect;
	
	exports.selectUserDetailsPending = selectUserDetailsPending;
	exports.selectUserDetails = selectUserDetails;
	exports.makeUserSelect = makeUserSelect;
	var selectSSN = exports.selectSSN = makeUserSelect('data.ssn');
	
	var selectUserCountryDetails = exports.selectUserCountryDetails = makeUserSelect('data.country');
	
	var selectUserEmergencyContactAttributes = exports.selectUserEmergencyContactAttributes = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'userDetails.data.primaryPatientProfile.emergencyContactAttributes', {});
	});
	
	var selectUserPrimaryPatientProfile = exports.selectUserPrimaryPatientProfile = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'userDetails.data.primaryPatientProfile', {});
	});
	
	var selectUserPrimaryPatientProfileGuarantorId = exports.selectUserPrimaryPatientProfileGuarantorId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'userDetails.data.primaryPatientProfile.guarantorUser.id', null);
	});
	
	var selectUserPrimaryPatientProfileId = exports.selectUserPrimaryPatientProfileId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'userDetails.data.primaryPatientProfile.id', null);
	});
	
	var selectAppointmentFormUserCountry = exports.selectAppointmentFormUserCountry = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'userDetails.data.country', '');
	});
	
	var selectAppointmentFormUserState = exports.selectAppointmentFormUserState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'userDetails.data.state', '');
	});
	
	var selectEirVisitTypePCPFormData = exports.selectEirVisitTypePCPFormData = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'progress.pcpFormData');
	});
	
	var selectAdditionalInfoFormData = exports.selectAdditionalInfoFormData = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'progress.additionalInfoFormData');
	});
	
	/**
	 *  REASON TYPE LIST
	 * */
	
	var _getSelectors16 = getSelectors('reasonTypes'),
	    selectReasonTypesPending = _getSelectors16.selectStatePending,
	    selectReasonTypesList = _getSelectors16.selectStateList;
	
	/**
	 *  REASONS VISIT LIST
	 * */
	
	
	exports.selectReasonTypesPending = selectReasonTypesPending;
	exports.selectReasonTypesList = selectReasonTypesList;
	
	var _getSelectors17 = getSelectors('reasonVisit'),
	    selectReasonVisitList = _getSelectors17.selectStateList,
	    selectReasonVisitPending = _getSelectors17.selectStatePending;
	
	/**
	 *  UPDATE NECESSARY PROFILE
	 * */
	
	
	exports.selectReasonVisitList = selectReasonVisitList;
	exports.selectReasonVisitPending = selectReasonVisitPending;
	
	var _getSelectors18 = getSelectors('necessaryData'),
	    selectUpdateNecessaryDataPending = _getSelectors18.selectStatePending;
	
	exports.selectUpdateNecessaryDataPending = selectUpdateNecessaryDataPending;
	var selectProgressGlobalPending = exports.selectProgressGlobalPending = (0, _reselect.createSelector)(selectInspectorPending, selectInspectConsentPending, selectInspectPatientPending, selectInspectDocumentsPending, selectUpdateNecessaryDataPending, selectAppointmentFormPending, function () {
	  for (var _len = arguments.length, pendingList = Array(_len), _key = 0; _key < _len; _key++) {
	    pendingList[_key] = arguments[_key];
	  }
	
	  return pendingList.some(function (pending) {
	    return Boolean(pending);
	  });
	});
	
	/**
	 *  APP FILTERS
	 * */
	var selectFiltersState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'filters', {});
	});
	var selectAppointmentDateFilter = exports.selectAppointmentDateFilter = (0, _reselect.createSelector)(selectFiltersState, function (state) {
	  return (0, _get2.default)(state, 'date');
	});
	var selectAppointmentLocationFilter = exports.selectAppointmentLocationFilter = (0, _reselect.createSelector)(selectFiltersState, function (state) {
	  return (0, _get2.default)(state, 'location');
	});
	
	/**
	 *  FILTER LIST
	 * */
	var selectFilterListState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'filterList', {});
	});
	var selectAppointmentFilterPending = exports.selectAppointmentFilterPending = (0, _reselect.createSelector)(selectFilterListState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	var selectAppointmentFilterList = exports.selectAppointmentFilterList = (0, _reselect.createSelector)(selectFilterListState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	/**
	 *  CHECK INSURANCE PLAN CONFIG
	 * */
	var selectCheckInsurancePlanConfigState = exports.selectCheckInsurancePlanConfigState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'checkInsurancePlanConfig', {});
	});
	
	var selectCheckInsurancePlanConfigLoading = exports.selectCheckInsurancePlanConfigLoading = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'loading', false);
	});
	
	/**
	 *  SCHEDULE LIST PROVIDERS
	 * */
	var selectAppointmentProviderListState = exports.selectAppointmentProviderListState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'schedulings', {});
	});
	
	var selectAppointmentProviderListPending = exports.selectAppointmentProviderListPending = (0, _reselect.createSelector)(selectAppointmentProviderListState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectAppointmentProviderListIds = exports.selectAppointmentProviderListIds = (0, _reselect.createSelector)(selectAppointmentProviderListState, function (state) {
	  return (0, _get2.default)(state, 'ids', []);
	});
	
	var selectAppointmentProviderListEntities = (0, _reselect.createSelector)(selectAppointmentProviderListState, function (state) {
	  return (0, _get2.default)(state, 'entities', {});
	});
	
	var selectAppointmentProviderListMeta = exports.selectAppointmentProviderListMeta = (0, _reselect.createSelector)(selectAppointmentProviderListState, function (state) {
	  return (0, _get2.default)(state, 'meta', {});
	});
	
	var selectAppointmentProviderList = exports.selectAppointmentProviderList = (0, _reselect.createSelector)(selectAppointmentProviderListIds, selectAppointmentProviderListEntities, function (ids, entities) {
	  return ids.map(function (id) {
	    return entities[id];
	  });
	});
	
	var makeAppointmentProviderByIdSelect = exports.makeAppointmentProviderByIdSelect = function makeAppointmentProviderByIdSelect(id, locationId) {
	  return (0, _reselect.createSelector)(selectAvailableProvidersSelfScheduling, function (locations) {
	    var targetLocation = locations.find(function (location) {
	      return locationId === location.id.toString();
	    });
	    return targetLocation ? targetLocation.providers.find(function (provider) {
	      return provider.id.toString() === id;
	    }) || {} : {};
	  });
	};
	
	/**
	 *  PROVIDER GW DETAILS
	 * */
	
	var _getSelectors19 = getSelectors('providerGWDetails'),
	    selectProviderGWDetailsPending = _getSelectors19.selectStatePending,
	    selectProviderGWDetails = _getSelectors19.selectStateData,
	    makeProviderGWDetailsSelect = _getSelectors19.makeSelect;
	
	exports.selectProviderGWDetailsPending = selectProviderGWDetailsPending;
	exports.selectProviderGWDetails = selectProviderGWDetails;
	exports.makeProviderGWDetailsSelect = makeProviderGWDetailsSelect;
	var selectCurrentProviderGWAvailableTimeSlots = exports.selectCurrentProviderGWAvailableTimeSlots = makeProviderGWDetailsSelect('data.availableProviders[0].timeSlots', []);
	
	/**
	 *  PROVIDER DETAILS
	 * */
	
	var _getSelectors20 = getSelectors('providerDetails'),
	    selectProviderDetailsPending = _getSelectors20.selectStatePending,
	    selectProviderDetails = _getSelectors20.selectStateData,
	    makeProviderDetailsSelect = _getSelectors20.makeSelect;
	
	exports.selectProviderDetailsPending = selectProviderDetailsPending;
	exports.selectProviderDetails = selectProviderDetails;
	exports.makeProviderDetailsSelect = makeProviderDetailsSelect;
	var selectCurrentProviderDetails = exports.selectCurrentProviderDetails = makeProviderDetailsSelect('data[0].providers[0]');
	var selectCurrentProviderAvailableTimeSlots = exports.selectCurrentProviderAvailableTimeSlots = makeProviderDetailsSelect('data[0].providers[0].timeSlots', []);
	
	var selectScheduleMetaDataFromProviderList = exports.selectScheduleMetaDataFromProviderList = (0, _reselect.createSelector)(selectAppointmentProviderListMeta, function (meta) {
	  return (0, _pick2.default)(meta, ['id', 'forDate']);
	});
	var selectScheduleMetaDataFromProviderInfo = exports.selectScheduleMetaDataFromProviderInfo = (0, _reselect.createSelector)(selectProviderGWDetails, function (data) {
	  return (0, _pick2.default)(data, ['id', 'forDate']);
	});
	
	/**
	 *  SCHEDULE PAYLOAD GATHERING
	 * */
	var selectSchedulePayloadData = exports.selectSchedulePayloadData = (0, _reselect.createSelector)(selectProgressCareUser, selectProgressService, selectProgressReason, function (user, service, reason) {
	  return {
	    userId: user.id,
	    payload: {
	      serviceId: (0, _get2.default)(service, 'id'),
	      reasonTypeId: (0, _get2.default)(reason, 'reasonType.id'),
	      reasonNote: (0, _get2.default)(reason, 'reasonNote')
	    }
	  };
	});
	
	var selectScheduleListReqPayload = exports.selectScheduleListReqPayload = (0, _reselect.createSelector)(selectSchedulePayloadData, selectAppointmentDateFilter, selectAppointmentLocationFilter, function (payload, date, filterIds) {
	  return (0, _extends3.default)({}, payload, {
	    date: date,
	    filterIds: filterIds
	  });
	});
	
	var selectFilterPayloadData = exports.selectFilterPayloadData = (0, _reselect.createSelector)(selectProgressService, selectProgressVisitType, selectProgressOrganizationId, function (service, visitType, organizationId) {
	  return {
	    serviceId: (0, _get2.default)(service, 'id'),
	    visitTypeId: (0, _get2.default)(visitType, 'id'),
	    organizationId: organizationId
	  };
	});
	
	/**
	 *  APPOINTMENT OVERVIEW
	 * */
	var selectReasonForOverview = exports.selectReasonForOverview = (0, _reselect.createSelector)([selectProgressReason, selectProgressService], function (reason, service) {
	  var additionInformation = reason.isHomeLocationDifferent ? {
	    state: (0, _get2.default)(reason, 'state'),
	    country: (0, _get2.default)(reason, 'country'),
	    isHomeLocationDifferent: (0, _get2.default)(reason, 'isHomeLocationDifferent')
	  } : {};
	
	  if (service.reasonTypes) {
	    var result = service.reasonTypes.find(function (item) {
	      return item.id === reason.reasonType.id;
	    }) || {};
	
	    return (0, _extends3.default)({
	      id: result.id,
	      note: reason.reasonNote,
	      type: result.name
	    }, additionInformation);
	  }
	
	  return (0, _extends3.default)({
	    id: (0, _get2.default)(reason, 'reasonType.id'),
	    note: reason.reasonNote,
	    type: (0, _get2.default)(reason, 'reasonType.name')
	  }, additionInformation);
	});
	
	var selectCopayPrice = exports.selectCopayPrice = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'fetchCopay.copay', undefined);
	});
	
	/**
	 *  CONFIRM VISIT GW
	 * */
	
	var _getSelectors21 = getSelectors('confirmVisitGW'),
	    selectConfirmVisitGWPending = _getSelectors21.selectStatePending;
	
	/**
	 *  CONFIRM VISIT
	 * */
	
	
	exports.selectConfirmVisitGWPending = selectConfirmVisitGWPending;
	
	var _getSelectors22 = getSelectors('confirmVisit'),
	    selectConfirmVisitPending = _getSelectors22.selectStatePending;
	
	/**
	 *  VIRTUAL VISIT PROVIDERS
	 * */
	
	exports.selectConfirmVisitPending = selectConfirmVisitPending;
	
	var _getSelectors23 = getSelectors('virtualVisitProviders'),
	    selectVirtualVisitProvidersPending = _getSelectors23.selectStatePending,
	    selectVirtualVisitProvidersList = _getSelectors23.selectStateList;
	
	/**
	 *  CONFIRM SELFT SCHEDULINGS
	 * */
	
	
	exports.selectVirtualVisitProvidersPending = selectVirtualVisitProvidersPending;
	exports.selectVirtualVisitProvidersList = selectVirtualVisitProvidersList;
	
	var _getSelectors24 = getSelectors('confirmVisitSelfScheduling'),
	    selectSelfSchedulingConfirmPending = _getSelectors24.selectStatePending;
	
	/**
	 *  CONFIRM URGENT VISIT
	 * */
	
	
	exports.selectSelfSchedulingConfirmPending = selectSelfSchedulingConfirmPending;
	
	var _getSelectors25 = getSelectors('confirmVisitUrgent'),
	    selectUrgentVisitConfirmPending = _getSelectors25.selectStatePending;
	
	exports.selectUrgentVisitConfirmPending = selectUrgentVisitConfirmPending;
	var selectUrgentVisitPayload = exports.selectUrgentVisitPayload = (0, _reselect.createSelector)(selectProgressCareUserId, selectProgressOrganizationId, selectProgressLocationIdWithUVVFlow, selectProgressInsuranceEligibilityId, selectProgressVisitType, selectProgressService, selectProgressReason, selectPreferredPharmacy, selectHealthInfoForm, function (userId, organizationId, locationId, insuranceEligibilityResultId, visitType, service, reason, pharmacyId, healthInfo) {
	  var reasonNote = (0, _get2.default)(reason, 'reasonVisit', []).filter(function (_ref) {
	    var value = _ref.value;
	    return value !== OTHER_REASON_TYPE;
	  }).map(function (_ref2) {
	    var label = _ref2.label;
	    return label;
	  }).concat((0, _get2.default)(reason, 'reasonNote'));
	
	  var state = (0, _get2.default)(reason, 'state', null);
	  var country = (0, _get2.default)(reason, 'country', null);
	
	  return (0, _extends3.default)({
	    id: userId
	  }, state && { state: state }, country && { country: country }, {
	    locationId: locationId,
	    pharmacyId: pharmacyId,
	    organizationId: organizationId,
	    insuranceEligibilityResultId: insuranceEligibilityResultId,
	    serviceId: (0, _get2.default)(service, 'id'),
	    visitTypeId: (0, _get2.default)(visitType, 'id'),
	    reasonTypeId: (0, _get2.default)(reason, 'reasonType.id'),
	    reasonNote: (0, _compact2.default)(reasonNote).join(', ')
	  }, (0, _omit2.default)(healthInfo, ['patientProfile']), healthInfo.patientProfile, {
	    userAppPlatform: 'web'
	  });
	});
	
	/**
	 *  CREATE VIRTUAL VISIT
	 * */
	
	var _getSelectors26 = getSelectors('createVirtualVisit'),
	    selectCreateVirtualVisitPending = _getSelectors26.selectStatePending,
	    selectCreateVirtualVisitError = _getSelectors26.selectStateError;
	
	exports.selectCreateVirtualVisitPending = selectCreateVirtualVisitPending;
	exports.selectCreateVirtualVisitError = selectCreateVirtualVisitError;
	var selectOverlapModalState = exports.selectOverlapModalState = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'overlapModal.opened');
	});
	
	var selectOverlapModalEntity = exports.selectOverlapModalEntity = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'overlapModal.entity');
	});
	
	var selectInsuranceErrorModalState = exports.selectInsuranceErrorModalState = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'insuranceErrorModal.opened');
	});
	
	var selectInsuranceErrorModalEntity = exports.selectInsuranceErrorModalEntity = (0, _reselect.createSelector)(selectRootState, function (data) {
	  return (0, _get2.default)(data, 'insuranceErrorModal.entity');
	});
	
	var selectPcpProviderAnswer = exports.selectPcpProviderAnswer = (0, _reselect.createSelector)(selectHealthInfoForm, function (state) {
	  return (0, _get2.default)(state, 'pcpProviderAnswer', '');
	});
	
	/**
	 *  CREATE EIR URGENT CARE APPOINTMENT
	 * */
	
	var selectCreateEirUrgentCareAppointmentPending = exports.selectCreateEirUrgentCareAppointmentPending = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'createEirUrgentCareAppointment.sending');
	});
	
	/**
	 *  PREFERRED LANGUAGE
	 * */
	
	var selectPreferredLanguage = exports.selectPreferredLanguage = (0, _reselect.createSelector)(selectProgressState, function (state) {
	  return (0, _get2.default)(state, 'language');
	});
	
	/**
	 *  PRIMARY CARE PROVIDERS LIST
	 * */
	
	var selectOrganizationPrimaryCareProvidersListState = exports.selectOrganizationPrimaryCareProvidersListState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'primaryCareProvidersList');
	});
	
	var selectOrganizationPrimaryCareProvidersList = exports.selectOrganizationPrimaryCareProvidersList = (0, _reselect.createSelector)(selectOrganizationPrimaryCareProvidersListState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectOrganizationPrimaryCareProvidersListLoading = exports.selectOrganizationPrimaryCareProvidersListLoading = (0, _reselect.createSelector)(selectOrganizationPrimaryCareProvidersListState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectFetchingOrganizationPrimaryCareProvidersListSucceed = exports.selectFetchingOrganizationPrimaryCareProvidersListSucceed = (0, _reselect.createSelector)(selectOrganizationPrimaryCareProvidersListState, function (state) {
	  return (0, _get2.default)(state, 'succeed');
	});
	
	var selectIsOrganizationPrimaryCareProvidersLastPage = exports.selectIsOrganizationPrimaryCareProvidersLastPage = (0, _reselect.createSelector)(selectOrganizationPrimaryCareProvidersListState, function (state) {
	  return (0, _get2.default)(state, 'isLastPage', false);
	});
	
	/**
	 *  EMPLOYERS LIST
	 * */
	
	var selectOrganizationEmployersListState = exports.selectOrganizationEmployersListState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'employersList');
	});
	
	var selectOrganizationEmployersList = exports.selectOrganizationEmployersList = (0, _reselect.createSelector)(selectOrganizationEmployersListState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectOrganizationEmployersListLoading = exports.selectOrganizationEmployersListLoading = (0, _reselect.createSelector)(selectOrganizationEmployersListState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectFetchingOrganizationEmployersListSucceed = exports.selectFetchingOrganizationEmployersListSucceed = (0, _reselect.createSelector)(selectOrganizationEmployersListState, function (state) {
	  return (0, _get2.default)(state, 'succeed');
	});
	
	var selectIsOrganizationEmployersLastPage = exports.selectIsOrganizationEmployersLastPage = (0, _reselect.createSelector)(selectOrganizationEmployersListState, function (state) {
	  return (0, _get2.default)(state, 'isLastPage', false);
	});
	
	/**
	 *  APPOINTMENT PAYMENT INFO MODAL
	 * */
	
	var selectAppointmentPaymentInfoModal = exports.selectAppointmentPaymentInfoModal = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'appointmentPaymentInfoModal', {});
	});
	
	var selectAppointmentPaymentInfoModalOpened = exports.selectAppointmentPaymentInfoModalOpened = (0, _reselect.createSelector)(selectAppointmentPaymentInfoModal, function (state) {
	  return (0, _get2.default)(state, 'opened');
	});
	
	var selectAppointmentPaymentInfoModalProps = exports.selectAppointmentPaymentInfoModalProps = (0, _reselect.createSelector)(selectAppointmentPaymentInfoModal, function (state) {
	  return (0, _get2.default)(state, 'props');
	});

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4348), __esModule: true };

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _autosize = __webpack_require__(2984);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _props7 = __webpack_require__(41);
	
	var _styles = __webpack_require__(18);
	
	var _browserChecker = __webpack_require__(356);
	
	var _index = __webpack_require__(1508);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _utils = __webpack_require__(3748);
	
	var _phone = __webpack_require__(547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var TextInput = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
	  (0, _inherits3.default)(TextInput, _React$Component);
	
	  function TextInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextInput.__proto__ || (0, _getPrototypeOf2.default)(TextInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      focused: false,
	      value: ''
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextInput, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setValue(this.props.value);
	      var overflowed = this.props.maxheight && (0, _browserChecker.isIE)();
	      this.setState({ overflowed: overflowed });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      /*
	       * Setting up the autoresize for textarea
	       * */
	      var _props = this.props,
	          textarea = _props.textarea,
	          autoresize = _props.autoresize;
	
	      if (textarea && autoresize) {
	        (0, _autosize2.default)(this.node);
	        this.updateSize(this.props);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          autoresize = _props2.autoresize,
	          textarea = _props2.textarea;
	
	      if (autoresize && textarea) {
	        this.setState({
	          value: nextProps.value
	        }, function () {
	          _this2.updateSize(nextProps);
	        });
	      }
	
	      if (this.props.value !== nextProps.value) {
	        this.setValue(nextProps.value);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _autosize2.default.destroy(this.node);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(event) {
	      /*
	       * Do not let input more than `limit` prop
	       * */
	      var _props3 = this.props,
	          limit = _props3.limit,
	          onChange = _props3.onChange,
	          maxheight = _props3.maxheight,
	          min = _props3.min,
	          max = _props3.max,
	          type = _props3.type,
	          withTrimMode = _props3.withTrimMode,
	          shouldUpperCase = _props3.shouldUpperCase,
	          isPhoneNumberField = _props3.isPhoneNumberField;
	
	      var val = event.target.value;
	      var value = limit < Infinity && event.target.value.length > limit ? val.substr(0, limit) : val;
	
	      if (type === 'number' && (min || max)) {
	        var floatValue = parseFloat(val);
	        if (min && floatValue < min || max && floatValue > max) {
	          return;
	        }
	      }
	
	      if (withTrimMode) {
	        var trimmedValue = isPhoneNumberField ? (0, _phone.parseDigits)(value) : value.trim();
	        this.setState({ value: trimmedValue });
	        onChange && onChange(trimmedValue);
	      } else if (shouldUpperCase) {
	        var upperCasedValue = isPhoneNumberField ? (0, _phone.parseDigits)(value) : value.toUpperCase();
	        this.setState({ value: upperCasedValue });
	        onChange && onChange(isPhoneNumberField ? (0, _phone.parseDigits)(value) : upperCasedValue);
	      } else {
	        var fieldValue = isPhoneNumberField ? (0, _phone.parseDigits)(value) : value;
	        this.setState({ value: fieldValue });
	        onChange && onChange(fieldValue);
	      }
	
	      // avoid scroll bar overflow important message icon
	      var overflowed = maxheight && (this.node.clientHeight > maxheight || (0, _browserChecker.isIE)());
	      this.setState({ overflowed: overflowed });
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(event) {
	      var _this3 = this;
	
	      event.persist();
	      var _props4 = this.props,
	          onFocus = _props4.onFocus,
	          shouldClearWhenOnFocus = _props4.shouldClearWhenOnFocus;
	
	
	      this.setState(function (state) {
	        return (0, _extends3.default)({
	          focused: !state.focused
	        }, shouldClearWhenOnFocus && { value: '' });
	      }, function () {
	        if (onFocus) onFocus(_this3.state.focused, event);
	      });
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(e) {
	      var onBlur = this.props.onBlur;
	
	      var value = e.target.value;
	
	      this.setState({ focused: false });
	      if (onBlur) onBlur(value);
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      var existingValue = '';
	
	      if (value) {
	        existingValue = typeof value === 'string' ? value : value.join(', ');
	      }
	
	      this.setState({
	        value: existingValue
	      });
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(e) {
	      var _props5 = this.props,
	          type = _props5.type,
	          isFractionNumber = _props5.isFractionNumber,
	          onKeyPress = _props5.onKeyPress;
	
	      if (type === 'number' && !isFractionNumber) {
	        return this.filterAlphabetical(e);
	      }
	
	      onKeyPress && onKeyPress(e);
	    }
	  }, {
	    key: 'filterAlphabetical',
	    value: function filterAlphabetical(e) {
	      var charCode = e.nativeEvent.charCode;
	
	
	      if (charCode < 48 || charCode > 57) {
	        e.preventDefault();
	      }
	    }
	  }, {
	    key: 'updateSize',
	    value: function updateSize(props) {
	      if (props.value && props.value.length) {
	        _autosize2.default.update(this.node);
	      } else {
	        var initialHeight = _styles.INPUT_HEIGHT * (parseInt(this.props.rows, 10) || 1);
	        this.node.style.height = this.props.useNumberHeight ? initialHeight : initialHeight + 'px';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames,
	          _this4 = this;
	
	      var _props6 = this.props,
	          children = _props6.children,
	          className = _props6.className,
	          color = _props6.color,
	          disabled = _props6.disabled,
	          id = _props6.id,
	          invalid = _props6.invalid,
	          label = _props6.label,
	          placeholder = _props6.placeholder,
	          rounded = _props6.rounded,
	          src = _props6.src,
	          style = _props6.style,
	          wrapperStyle = _props6.wrapperStyle,
	          textarea = _props6.textarea,
	          type = _props6.type,
	          isPhoneNumberField = _props6.isPhoneNumberField,
	          autoresize = _props6.autoresize,
	          limit = _props6.limit,
	          value = _props6.value,
	          useNumberHeight = _props6.useNumberHeight,
	          isFractionNumber = _props6.isFractionNumber,
	          step = _props6.step,
	          setRef = _props6.setRef,
	          required = _props6.required,
	          shouldUpperCase = _props6.shouldUpperCase,
	          withTrimMode = _props6.withTrimMode,
	          other = (0, _objectWithoutProperties3.default)(_props6, ['children', 'className', 'color', 'disabled', 'id', 'invalid', 'label', 'placeholder', 'rounded', 'src', 'style', 'wrapperStyle', 'textarea', 'type', 'isPhoneNumberField', 'autoresize', 'limit', 'value', 'useNumberHeight', 'isFractionNumber', 'step', 'setRef', 'required', 'shouldUpperCase', 'withTrimMode']);
	
	
	      var ComponentTag = textarea ? 'textarea' : 'input';
	
	      var isNumberFieldType = type === 'number';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(className, {
	            'textarea--overflowed': textarea && this.state.overflowed
	          }),
	          styleName: (0, _classnames2.default)('root', (_classNames = {}, (0, _defineProperty3.default)(_classNames, 'root--color--' + color, color), (0, _defineProperty3.default)(_classNames, 'root--disabled', disabled), (0, _defineProperty3.default)(_classNames, 'root--invalid', invalid), (0, _defineProperty3.default)(_classNames, 'root--focused', this.state.focused), _classNames)),
	          style: wrapperStyle
	        },
	        label ? _react2.default.createElement('label', {
	          styleName: (0, _classnames2.default)('label', { required: required }),
	          className: 'dib mb1',
	          htmlFor: id,
	          children: label
	        }) : null,
	        _react2.default.createElement(
	          'div',
	          { className: 'relative' },
	          _react2.default.createElement(ComponentTag, (0, _extends3.default)({ disabled: disabled, id: id, placeholder: placeholder }, {
	            type: isPhoneNumberField ? 'text' : type
	          }, (0, _omit2.default)(other, ['inputHeight', 'shouldClearWhenOnFocus', 'min', 'max']), {
	            styleName: (0, _classnames2.default)('input', { 'input--icon': src }, { 'input--rounded': rounded }),
	            onChange: this.handleChange,
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onKeyPress: this.handleKeyPress,
	            style: (0, _assign2.default)({}, src && { backgroundImage: 'url(' + src + ')' }, style),
	            ref: setRef || function (node) {
	              _this4.node = node;
	            },
	            value: (0, _utils.formatValue)(this.state.value, isNumberFieldType, !!isPhoneNumberField),
	            step: step
	          })),
	          children ? children : null
	        )
	      );
	    }
	  }]);
	  return TextInput;
	}(_react2.default.Component), _class3.propTypes = {
	  autoresize: _propTypes2.default.bool,
	  children: _propTypes2.default.any,
	  className: _propTypes2.default.string,
	  color: _propTypes2.default.oneOf(_props7.PROPS_LIST.textInput.color),
	  disabled: _propTypes2.default.bool,
	  id: _propTypes2.default.string,
	  invalid: _propTypes2.default.bool,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	  limit: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyPress: _propTypes2.default.func,
	  placeholder: _propTypes2.default.string,
	  rounded: _propTypes2.default.bool,
	  isPhoneNumberField: _propTypes2.default.bool,
	  src: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  shouldUpperCase: _propTypes2.default.bool,
	  wrapperStyle: _propTypes2.default.object,
	  textarea: _propTypes2.default.bool,
	  type: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.array]),
	  maxheight: _propTypes2.default.number,
	  useNumberHeight: _propTypes2.default.bool,
	  isFractionNumber: _propTypes2.default.bool,
	  step: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shouldClearWhenOnFocus: _propTypes2.default.bool,
	  withTrimMode: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  color: 'default',
	  disabled: false,
	  invalid: false,
	  limit: Infinity,
	  type: 'text'
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleFocus', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleFocus'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleBlur', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleBlur'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setValue', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'setValue'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleKeyPress', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleKeyPress'), _class2.prototype)), _class2)) || _class);
	exports.default = TextInput;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var IDS = exports.IDS = {
	  COMMON: {
	    DIALOG_OK: 'oc-common__dialog-ok',
	    DIALOG_CLOSE: 'oc-common__dialog-close',
	    IMAGE_MANAGER_EDIT: 'oc-common__image-manager-edit',
	    IMAGE_MANAGER_UPDATE: 'oc-common__image-manager-update',
	    IMAGE_MANAGER_REMOVE: 'oc-common__image-manager-remove',
	    ACTION_CONFIRMATION_SUBMIT: 'oc-common__action-confirmation-submit',
	    ACTION_CONFIRMATION_CANCEL: 'oc-common__action-confirmation-cancel'
	  },
	  NAV_BAR: {
	    COMMUNITIES: 'oc-navbar__communities',
	    HEALTH_BOARD: 'oc-navbar__healthboard',
	    HOME: 'oc-navbar__home',
	    MESSAGES: 'oc-navbar__messages',
	    CIRCLES: 'oc-navbar__my-circles',
	    DASHBOARD: 'oc-navbar__dashboard',
	    PROFILE: 'oc-navbar__profile',
	    LOG_OUT: 'oc-navbar__logout',
	    APP_NOTIFICATIONS_LINK: 'oc-navbar__app-notifications-link',
	    OPEN_JOIN_POPUP: 'oc-navbar__open-join-popup',
	    JOIN_CIRCLE_MENU_ITEM: 'oc-navbar__join-circle-menu-item',
	    ADD_DEPENDENT_MENU_ITEM: 'oc-navbar__add-dependent-menu-item',
	    ADD_PATIENT_MENU_ITEM: 'oc-navbar__add-patient-menu-item'
	  },
	  COMMUNITIES_BAR: {
	    DISCOVER: 'oc-communities-bar__discover',
	    MY_COMMUNITIES: 'oc-communities-bar__my-communities',
	    ACTIVITIES: 'oc-communities-bar__activities',
	    REPORTS: 'oc-communities-bar__reports'
	  },
	  MY_COMMUNITIES_TABS: {
	    ALL: 'oc-my-communities-tab__all',
	    I_AM_MODERATOR: 'oc-my-communities-tab__iam-moderator',
	    REQUESTED: 'oc-my-communities-tab__requested'
	  },
	  ACTIVITIES_TABS: {
	    NOTIFICATIONS: 'oc-activities-tab__notifications',
	    JOIN_REQUESTS: 'oc-activities-tab__join-requests',
	    MEMBER_INVITATIONS: 'oc-activities-tab__invitations'
	  },
	  ACTIVITIES: {
	    INVITATION_ACCEPT_BTN: 'oc-activities__invitation-accept-btn',
	    INVITATION_DECLINE_BTN: 'oc-activities__invitation-decline-btn',
	    JOIN_REQUEST_ACCEPT_BTN: 'oc-activities__join-request-accept-btn',
	    JOIN_REQUEST_DECLINE_BTN: 'oc-activities__join-request-decline-btn'
	  },
	  REPORTS_TABS: {
	    UNRESOLVED: 'oc-reports-tab__unresolved',
	    RESOLVED: 'oc-reports-tab__resolved'
	  },
	  SEARCH_TABS: {
	    PEOPLE: 'oc-search-tab__people',
	    TEAMS: 'oc-search-tab__teams',
	    PROVIDER: 'oc-search-tab__provider'
	  },
	  REPORTS: {
	    SEE_DETAILS_BTN: 'oc-reports__see-details-btn',
	    RESOLVE_BTN: 'oc-reports__resolve-btn',
	    REMOVE_AUTHOR_OPTION: 'oc-reports__remove-author-option',
	    DESTROY_REPORTABLE_OPTION: 'oc-reports__destroy-reportable-option',
	    SEND_MESSAGE_OPTION: 'oc-reports__send-message-option'
	  },
	  COMMUNITY: {
	    MENU_TRIGGER: 'oc-community__menu-trigger',
	    ACCEPT_INVITATION_BTN: 'oc-community__accept-invite-btn',
	    DECLINE_INVITATION_BTN: 'oc-community__decline-invite-btn',
	    CREATE_POST_BTN: 'oc-community__create-post-btn',
	    JOIN_BTN: 'oc-community__join-btn',
	    SEE_ALL_MEMBERS: 'oc-community__see-all-members',
	    SEE_ALL_MODERATORS: 'oc-community__see-all-moderators',
	    MEMBER_MENU_TRIGGER: 'oc-community__member-menu-trigger',
	    MENU_EDIT: 'oc-community__menu-edit',
	    MENU_LEAVE: 'oc-community__menu-leave',
	    MENU_CANCEL: 'oc-community__menu-cancel',
	    EDIT_LOGO: 'oc-community__edit-logo',
	    EDIT_BANNER: 'oc-community__edit-banner'
	  },
	  MENU: {
	    EDIT_POST: 'oc-menu__edit-post',
	    REMOVE_POST: 'oc-menu__remove-post',
	    REMOVE_COMMENT: 'oc-menu__remove-comment',
	    EDIT_COMMENT: 'oc-menu__edit-comment',
	    SEND_MESSAGE: 'oc-menu__send-message',
	    REPORT: 'oc-menu__report',
	    INVITE_TO_COMMUNITY: 'oc-menu__invite-to-community',
	    SHARE_LINK: 'oc-menu__share-link',
	    LEAVE_COMMUNITY: 'oc-menu__leave-community',
	    REMOVE_MEMBER: 'oc-menu__remove-member',
	    EDIT_COMMUNITY: 'oc-menu__edit-community',
	    REMOVE_FROM_COMMUNITY: 'oc-menu__remove-from-community',
	    CHANGE_ROLE: 'oc-menu__change-role',
	    UNASSIGN: 'oc-menu__unassign'
	  },
	  POST: {
	    MENU_TRIGGER: 'oc-post__menu-trigger',
	    ADD_COMMENT: 'oc-post__add-comment-btn',
	    POST_COMMENT: 'oc-post__post-comment-btn',
	    POST_TEXT_AREA: 'oc-post__text-area',
	    COMMENT_ICON: 'oc-post__comment-icon',
	    LIKE_ICON: 'oc-post__like-icon',
	    REPLY_COMMENT_BTN: 'oc-post__reply-comment-btn',
	    REPLY_TEXT_AREA: 'oc-post__reply-text-area',
	    SEND_REPLY_COMMENT_BTN: 'oc-post__send-reply-comment-btn',
	    REPLY_COMMENT_MENU_TRIGGER: 'oc-post__reply-comment-menu-trigger'
	  },
	  CHAT_SEND_MESSAGE: {
	    IMPORTANT: 'oc-chat-send-message__important',
	    IMPORTANT_SELECTED: 'oc-chat-send-message__important-selected',
	    ATTACH_ICON_MENU: 'oc-chat-send-message__attach-icon-menu',
	    ATTACH_FILE: 'oc-chat-send-message__attach-file',
	    ATTACH_ANSWER_FORM: 'oc-chat-send-message__attach-answer-form',
	    ATTACH_SURVEY: 'oc-chat-send-message__attach-survey',
	    UNBLOCK_USER: 'oc-chat-send-message__unblock-user',
	    SEND_MESSAGE: 'oc-chat-send-message__send-message'
	  },
	  CHAT_FILTER: {
	    MENU: 'oc-chat-filter__menu',
	    ITEM: 'oc-chat-filter__item',
	    ITEM_ALL: 'oc-chat-filter__item-all',
	    ITEM_PATIENT: 'oc-chat-filter__item-patient',
	    ITEM_PROVIDER: 'oc-chat-filter__item-provider',
	    ITEM_SOCIAL: 'oc-chat-filter__item-social',
	    SUB_FILTER: 'oc-chat-filter__sub-filter'
	  },
	  CHAT_CONTEXT: {
	    MENU: 'oc-chat-context__menu',
	    CIRCLE_OF_CARE: 'oc-chat-context__circle-of-care',
	    SURVEYS: 'oc-chat-context__surveys',
	    PROGRAMS: 'oc-chat-context__programs',
	    HIDE_DRAWER: 'oc-chat-context__hide-drawer',
	    START_CONVERSATION: 'oc-chat-context__start-conversation'
	  },
	  APP_NOTIFICATIONS: {
	    TODO_TAB: 'oc-app-notifications__todo-tab',
	    COMPLETED_TAB: 'oc-app-notifications__completed-tab',
	    REQUEST_CONFIRM: 'oc-app-notifications__request-confirm',
	    REQUEST_DECLINE: 'oc-app-notifications__request-decline'
	  },
	  DASHBOARD: {
	    TABLE_MENU_TRIGGER: 'oc-dashboard__table-menu-trigger',
	    TABLE_MENU_MOVE_TO_FRONT: 'oc-dashboard__table-menu-move-to-front',
	    TABLE_MENU_CHANGE_STATUS: 'oc-dashboard__table-menu-change-status',
	    TABLE_MENU_ASSIGN_ROOM: 'oc-dashboard__table-menu-assign-room',
	    TABLE_MENU_CHANGE_PAYMENT_STATUS: 'oc-dashboard__table-menu-change-payment-status',
	    TABLE_MENU_EDIT_PAYMENT_AMOUNT: 'oc-dashboard__table-menu-edit-payment-amount'
	  },
	  DEPENDENT_ROLES: {
	    PROXY: 'oc-dependent-roles__proxy',
	    PARENT: 'oc-dependent-roles__parent',
	    GUARDIAN: 'oc-dependent-roles__guardian'
	  },
	  ADD_DEPENDENT: {
	    NEXT: 'oc-add-dependent__next'
	  },
	  FORM_FIELDS: {
	    EMAIL: 'oc-form-fields__email',
	    PHONE_NUMBER: 'oc-form-fields__phone-number',
	    HOME_PHONE: 'oc-form-fields__home-phone-number',
	    FIRST_NAME: 'oc-form-fields__first-name',
	    LAST_NAME: 'oc-form-fields__last-name',
	    MIDDLE_NAME: 'oc-form-fields__middle-name',
	    GENDER: 'oc-form-fields__gender',
	    DOB: {
	      DAY: 'oc-form-fields__dob-day',
	      MONTH: 'oc-form-fields__dob-month',
	      YEAR: 'oc-form-fields__dob-year'
	    },
	    NAME_SUFFIX: 'oc-form-fields__name-suffix',
	    REASON_TYPE: 'oc-form-fields__reason-type',
	    REASON_NOTE: 'oc-form-fields__reason-note',
	    REASON_VISIT: 'oc-form-fields__reason-visit',
	    MRNS: 'oc-form-fields__mrn',
	    SSN: 'oc-form-fields__ssn',
	    ADDRESS_1: 'oc-form-fields__address1',
	    ADDRESS_2: 'oc-form-fields__address2',
	    CITY: 'oc-form-fields__city',
	    STATE: 'oc-form-fields__state',
	    IS_HOME_LOCATION_DIFFERENT: 'oc-form-fields__is-home-location-different',
	    COUNTRY: 'oc-form-fields__country',
	    POSTAL_CODE: 'oc-form-fields__postal-code',
	    RELATION: 'oc-form-fields__relation',
	    AVATAR: 'oc-form-fields__avatar',
	    AGE: 'oc-form-fields__age',
	    ROLE: 'oc-form-fields__role',
	    CARE_ROLE: 'oc-form-fields__care-role',
	    RELATIONSHIP: 'oc-form-fields__relationship',
	    TERMS_AND_CONDITIONS: 'oc-form-fields__terms-and-conditions',
	    LOGIN: 'oc-form-fields__login',
	    LOCATION: 'oc-form-fields__location',
	    SERVICE: 'oc-form-fields__service',
	    PROVIDER: 'oc-form-fields__provider',
	    ROOM: 'oc-form-fields__room',
	    PAYMENT_STATUS: 'oc-form-fields__payment-status',
	    CATEGORY: 'oc-form-fields__category',
	    SUB_CATEGORY: 'oc-form-fields__sub-category',
	    DOCUMENTS: 'oc-form-fields__documents',
	    SURVEYS: 'oc-form-fields__surveys',
	    CONSENTS: 'oc-form-fields__consents',
	    NOTIFICATION_CONSENTS: 'oc-form-fields__notification-consents',
	    MEMBER_ID: 'oc-form-fields__member-id',
	    GROUP_NUMBER: 'oc-form-fields__group-number',
	    PRESCRIPTIONS: 'oc-form-fields__prescriptions'
	  },
	  APPOINTMENT_FORM: {
	    ROOT: 'oc-appointment-form__root',
	    SUBMIT_PATIENT_FORM: 'oc-appointment-form__submit-patient-form',
	    SUBMIT_DOCUMENTS_FORM: 'oc-appointment-form__submit-doc-form',
	    SUBMIT_REASON_TYPE: 'oc-appointment-form__submit-reason-type',
	    OTHER_REASON_TYPE: 'oc-appointment-form__other-reason-type'
	  },
	  APPOINTMENT_LIST: {
	    TAB_UPCOMING: 'oc-appointment-list__tab-upcoming',
	    TAB_HISTORY: 'oc-appointment-list__tab-history'
	  },
	  PATIENT_PORTAL: {
	    TAB_MEDICATIONS: 'oc-patient-portal__tab-medications',
	    TAB_IMMUNIZATIONS: 'oc-patient-portal__tab-immunizations',
	    TAB_LAB_TEST_RESULT: 'oc-patient-portal__tab-lab-test-results',
	    TAB_ALLERGIES: 'oc-patient-portal__tab-allergies',
	    TAB_CONDITIONS: 'oc-patient-portal__tab-conditions',
	    TAB_SOCIAL_HISTORY: 'oc-patient-portal__tab-social-history',
	    TAB_FAMILY_HISTORY: 'oc-patient-portal__tab-family-history',
	    ADD_WEIGHT_FORM: {
	      DATE: 'oc-patient-portal__add-weight-form-date',
	      TIME: 'oc-patient-portal__add-weight-form-time',
	      WEIGHT: 'oc-patient-portal__add-weight-form-weight',
	      ADD_BUTTON: 'oc-patient-portal__add-weight-form-add-button'
	    },
	    ADD_HEIGHT_FORM: {
	      DATE: 'oc-patient-portal__add-height-form-date',
	      TIME: 'oc-patient-portal__add-height-form-time',
	      FEET: 'oc-patient-portal__add-height-form-feet',
	      INCH: 'oc-patient-portal__add-height-form-inch',
	      ADD_BUTTON: 'oc-patient-portal__add-height-form-add-button'
	    },
	    ADD_BODY_INFO_FORM: {
	      DATE: 'oc-patient-portal__add-body-form-date',
	      TIME: 'oc-patient-portal__add-body-form-time',
	      FEET: 'oc-patient-portal__add-body-form-feet',
	      INCH: 'oc-patient-portal__add-body-form-inch',
	      WEIGHT: 'oc-patient-portal__add-body-form-weight',
	      ADD_BUTTON: 'oc-patient-portal__add-body-form-add-button'
	    },
	    TAB_HEALTH_RECORD: {
	      VIEW_RECORD: 'oc-patient-portal__health-record-view',
	      SHARE_RECORD: 'oc-patient-portal__health-record-share',
	      DOWNLOAD_RECORD: 'oc-patient-portal__health-record-download',
	      OPEN_AS_CCD: 'oc-patient-portal__health-record-open-as-ccd',
	      OPEN_AS_PDF: 'oc-patient-portal__health-record-open-as-pdf',
	      DOWNLOAD_AS_CCD: 'oc-patient-portal__health-record-download-as-ccd',
	      DOWNLOAD_AS_PDF: 'oc-patient-portal__health-record-download-as-pdf',
	      DOWNLOAD_AS_ZIP: 'oc-patient-portal__health-record-download-as-zip',
	      SHARE_TO_CHAT: 'oc-patient-portal__health-record-share-to-chat',
	      SHARE_TO_EMAIL: 'oc-patient-portal__health-record-share-to-email',
	      SHARE_TO_EMAIL_INPUT: 'oc-patient-portal__health-record-share-to-email-input'
	    }
	  },
	  PAPERWORK: {
	    ROOT: 'oc-paperwork__root'
	  },
	  ADDITIONAL_QUESTIONS_FORM: 'oc-additional-questions-form__root',
	  PCP_QUESTIONS_WITH_EXTRA_FIELDS_FORM: 'oc-pcp-questions-with-extra-field-form__root'
	};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + required > 1 ? 's' : '' + ' required, but only ' + args.length + ' present');
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _create = __webpack_require__(1974);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory();
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	})(undefined, function () {
	
		/*globals window, global, require*/
	
		/**
	  * CryptoJS core components.
	  */
		var CryptoJS = CryptoJS || function (Math, undefined) {
	
			var crypto;
	
			// Native crypto from window (Browser)
			if (typeof window !== 'undefined' && window.crypto) {
				crypto = window.crypto;
			}
	
			// Native crypto in web worker (Browser)
			if (typeof self !== 'undefined' && self.crypto) {
				crypto = self.crypto;
			}
	
			// Native crypto from worker
			if (typeof globalThis !== 'undefined' && globalThis.crypto) {
				crypto = globalThis.crypto;
			}
	
			// Native (experimental IE 11) crypto from window (Browser)
			if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
				crypto = window.msCrypto;
			}
	
			// Native crypto from global (NodeJS)
			if (!crypto && typeof global !== 'undefined' && global.crypto) {
				crypto = global.crypto;
			}
	
			// Native crypto import via require (NodeJS)
			if (!crypto && "function" === 'function') {
				try {
					crypto = __webpack_require__(6493);
				} catch (err) {}
			}
	
			/*
	   * Cryptographically secure pseudorandom number generator
	   *
	   * As Math.random() is cryptographically not safe to use
	   */
			var cryptoSecureRandomInt = function cryptoSecureRandomInt() {
				if (crypto) {
					// Use getRandomValues method (Browser)
					if (typeof crypto.getRandomValues === 'function') {
						try {
							return crypto.getRandomValues(new Uint32Array(1))[0];
						} catch (err) {}
					}
	
					// Use randomBytes method (NodeJS)
					if (typeof crypto.randomBytes === 'function') {
						try {
							return crypto.randomBytes(4).readInt32LE();
						} catch (err) {}
					}
				}
	
				throw new Error('Native crypto module could not be used to get secure random number.');
			};
	
			/*
	   * Local polyfill of Object.create
	    */
			var create = _create2.default || function () {
				function F() {}
	
				return function (obj) {
					var subtype;
	
					F.prototype = obj;
	
					subtype = new F();
	
					F.prototype = null;
	
					return subtype;
				};
			}();
	
			/**
	   * CryptoJS namespace.
	   */
			var C = {};
	
			/**
	   * Library namespace.
	   */
			var C_lib = C.lib = {};
	
			/**
	   * Base object for prototypal inheritance.
	   */
			var Base = C_lib.Base = function () {
	
				return {
					/**
	     * Creates a new object that inherits from this object.
	     *
	     * @param {Object} overrides Properties to copy into the new object.
	     *
	     * @return {Object} The new object.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var MyType = CryptoJS.lib.Base.extend({
	     *         field: 'value',
	     *
	     *         method: function () {
	     *         }
	     *     });
	     */
					extend: function extend(overrides) {
						// Spawn
						var subtype = create(this);
	
						// Augment
						if (overrides) {
							subtype.mixIn(overrides);
						}
	
						// Create default initializer
						if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
							subtype.init = function () {
								subtype.$super.init.apply(this, arguments);
							};
						}
	
						// Initializer's prototype is the subtype object
						subtype.init.prototype = subtype;
	
						// Reference supertype
						subtype.$super = this;
	
						return subtype;
					},
	
					/**
	     * Extends this object and runs the init method.
	     * Arguments to create() will be passed to init().
	     *
	     * @return {Object} The new object.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var instance = MyType.create();
	     */
					create: function create() {
						var instance = this.extend();
						instance.init.apply(instance, arguments);
	
						return instance;
					},
	
					/**
	     * Initializes a newly created object.
	     * Override this method to add some logic when your objects are created.
	     *
	     * @example
	     *
	     *     var MyType = CryptoJS.lib.Base.extend({
	     *         init: function () {
	     *             // ...
	     *         }
	     *     });
	     */
					init: function init() {},
	
					/**
	     * Copies properties into this object.
	     *
	     * @param {Object} properties The properties to mix in.
	     *
	     * @example
	     *
	     *     MyType.mixIn({
	     *         field: 'value'
	     *     });
	     */
					mixIn: function mixIn(properties) {
						for (var propertyName in properties) {
							if (properties.hasOwnProperty(propertyName)) {
								this[propertyName] = properties[propertyName];
							}
						}
	
						// IE won't copy toString using the loop above
						if (properties.hasOwnProperty('toString')) {
							this.toString = properties.toString;
						}
					},
	
					/**
	     * Creates a copy of this object.
	     *
	     * @return {Object} The clone.
	     *
	     * @example
	     *
	     *     var clone = instance.clone();
	     */
					clone: function clone() {
						return this.init.prototype.extend(this);
					}
				};
			}();
	
			/**
	   * An array of 32-bit words.
	   *
	   * @property {Array} words The array of 32-bit words.
	   * @property {number} sigBytes The number of significant bytes in this word array.
	   */
			var WordArray = C_lib.WordArray = Base.extend({
				/**
	    * Initializes a newly created word array.
	    *
	    * @param {Array} words (Optional) An array of 32-bit words.
	    * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.lib.WordArray.create();
	    *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	    *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	    */
				init: function init(words, sigBytes) {
					words = this.words = words || [];
	
					if (sigBytes != undefined) {
						this.sigBytes = sigBytes;
					} else {
						this.sigBytes = words.length * 4;
					}
				},
	
				/**
	    * Converts this word array to a string.
	    *
	    * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	    *
	    * @return {string} The stringified word array.
	    *
	    * @example
	    *
	    *     var string = wordArray + '';
	    *     var string = wordArray.toString();
	    *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	    */
				toString: function toString(encoder) {
					return (encoder || Hex).stringify(this);
				},
	
				/**
	    * Concatenates a word array to this word array.
	    *
	    * @param {WordArray} wordArray The word array to append.
	    *
	    * @return {WordArray} This word array.
	    *
	    * @example
	    *
	    *     wordArray1.concat(wordArray2);
	    */
				concat: function concat(wordArray) {
					// Shortcuts
					var thisWords = this.words;
					var thatWords = wordArray.words;
					var thisSigBytes = this.sigBytes;
					var thatSigBytes = wordArray.sigBytes;
	
					// Clamp excess bits
					this.clamp();
	
					// Concat
					if (thisSigBytes % 4) {
						// Copy one byte at a time
						for (var i = 0; i < thatSigBytes; i++) {
							var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
							thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
						}
					} else {
						// Copy one word at a time
						for (var j = 0; j < thatSigBytes; j += 4) {
							thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
						}
					}
					this.sigBytes += thatSigBytes;
	
					// Chainable
					return this;
				},
	
				/**
	    * Removes insignificant bits.
	    *
	    * @example
	    *
	    *     wordArray.clamp();
	    */
				clamp: function clamp() {
					// Shortcuts
					var words = this.words;
					var sigBytes = this.sigBytes;
	
					// Clamp
					words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
					words.length = Math.ceil(sigBytes / 4);
				},
	
				/**
	    * Creates a copy of this word array.
	    *
	    * @return {WordArray} The clone.
	    *
	    * @example
	    *
	    *     var clone = wordArray.clone();
	    */
				clone: function clone() {
					var clone = Base.clone.call(this);
					clone.words = this.words.slice(0);
	
					return clone;
				},
	
				/**
	    * Creates a word array filled with random bytes.
	    *
	    * @param {number} nBytes The number of random bytes to generate.
	    *
	    * @return {WordArray} The random word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.lib.WordArray.random(16);
	    */
				random: function random(nBytes) {
					var words = [];
	
					for (var i = 0; i < nBytes; i += 4) {
						words.push(cryptoSecureRandomInt());
					}
	
					return new WordArray.init(words, nBytes);
				}
			});
	
			/**
	   * Encoder namespace.
	   */
			var C_enc = C.enc = {};
	
			/**
	   * Hex encoding strategy.
	   */
			var Hex = C_enc.Hex = {
				/**
	    * Converts a word array to a hex string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The hex string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var hexChars = [];
					for (var i = 0; i < sigBytes; i++) {
						var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						hexChars.push((bite >>> 4).toString(16));
						hexChars.push((bite & 0x0f).toString(16));
					}
	
					return hexChars.join('');
				},
	
				/**
	    * Converts a hex string to a word array.
	    *
	    * @param {string} hexStr The hex string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	    */
				parse: function parse(hexStr) {
					// Shortcut
					var hexStrLength = hexStr.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < hexStrLength; i += 2) {
						words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
					}
	
					return new WordArray.init(words, hexStrLength / 2);
				}
			};
	
			/**
	   * Latin1 encoding strategy.
	   */
			var Latin1 = C_enc.Latin1 = {
				/**
	    * Converts a word array to a Latin1 string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The Latin1 string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var latin1Chars = [];
					for (var i = 0; i < sigBytes; i++) {
						var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						latin1Chars.push(String.fromCharCode(bite));
					}
	
					return latin1Chars.join('');
				},
	
				/**
	    * Converts a Latin1 string to a word array.
	    *
	    * @param {string} latin1Str The Latin1 string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	    */
				parse: function parse(latin1Str) {
					// Shortcut
					var latin1StrLength = latin1Str.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < latin1StrLength; i++) {
						words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
					}
	
					return new WordArray.init(words, latin1StrLength);
				}
			};
	
			/**
	   * UTF-8 encoding strategy.
	   */
			var Utf8 = C_enc.Utf8 = {
				/**
	    * Converts a word array to a UTF-8 string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The UTF-8 string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					try {
						return decodeURIComponent(escape(Latin1.stringify(wordArray)));
					} catch (e) {
						throw new Error('Malformed UTF-8 data');
					}
				},
	
				/**
	    * Converts a UTF-8 string to a word array.
	    *
	    * @param {string} utf8Str The UTF-8 string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	    */
				parse: function parse(utf8Str) {
					return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
				}
			};
	
			/**
	   * Abstract buffered block algorithm template.
	   *
	   * The property blockSize must be implemented in a concrete subtype.
	   *
	   * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	   */
			var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
				/**
	    * Resets this block algorithm's data buffer to its initial state.
	    *
	    * @example
	    *
	    *     bufferedBlockAlgorithm.reset();
	    */
				reset: function reset() {
					// Initial values
					this._data = new WordArray.init();
					this._nDataBytes = 0;
				},
	
				/**
	    * Adds new data to this block algorithm's buffer.
	    *
	    * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	    *
	    * @example
	    *
	    *     bufferedBlockAlgorithm._append('data');
	    *     bufferedBlockAlgorithm._append(wordArray);
	    */
				_append: function _append(data) {
					// Convert string to WordArray, else assume WordArray already
					if (typeof data == 'string') {
						data = Utf8.parse(data);
					}
	
					// Append
					this._data.concat(data);
					this._nDataBytes += data.sigBytes;
				},
	
				/**
	    * Processes available data blocks.
	    *
	    * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	    *
	    * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	    *
	    * @return {WordArray} The processed data.
	    *
	    * @example
	    *
	    *     var processedData = bufferedBlockAlgorithm._process();
	    *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	    */
				_process: function _process(doFlush) {
					var processedWords;
	
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
					var dataSigBytes = data.sigBytes;
					var blockSize = this.blockSize;
					var blockSizeBytes = blockSize * 4;
	
					// Count blocks ready
					var nBlocksReady = dataSigBytes / blockSizeBytes;
					if (doFlush) {
						// Round up to include partial blocks
						nBlocksReady = Math.ceil(nBlocksReady);
					} else {
						// Round down to include only full blocks,
						// less the number of blocks that must remain in the buffer
						nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
					}
	
					// Count words ready
					var nWordsReady = nBlocksReady * blockSize;
	
					// Count bytes ready
					var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
					// Process blocks
					if (nWordsReady) {
						for (var offset = 0; offset < nWordsReady; offset += blockSize) {
							// Perform concrete-algorithm logic
							this._doProcessBlock(dataWords, offset);
						}
	
						// Remove processed words
						processedWords = dataWords.splice(0, nWordsReady);
						data.sigBytes -= nBytesReady;
					}
	
					// Return processed words
					return new WordArray.init(processedWords, nBytesReady);
				},
	
				/**
	    * Creates a copy of this object.
	    *
	    * @return {Object} The clone.
	    *
	    * @example
	    *
	    *     var clone = bufferedBlockAlgorithm.clone();
	    */
				clone: function clone() {
					var clone = Base.clone.call(this);
					clone._data = this._data.clone();
	
					return clone;
				},
	
				_minBufferSize: 0
			});
	
			/**
	   * Abstract hasher template.
	   *
	   * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	   */
			var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
				/**
	    * Configuration options.
	    */
				cfg: Base.extend(),
	
				/**
	    * Initializes a newly created hasher.
	    *
	    * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	    *
	    * @example
	    *
	    *     var hasher = CryptoJS.algo.SHA256.create();
	    */
				init: function init(cfg) {
					// Apply config defaults
					this.cfg = this.cfg.extend(cfg);
	
					// Set initial values
					this.reset();
				},
	
				/**
	    * Resets this hasher to its initial state.
	    *
	    * @example
	    *
	    *     hasher.reset();
	    */
				reset: function reset() {
					// Reset data buffer
					BufferedBlockAlgorithm.reset.call(this);
	
					// Perform concrete-hasher logic
					this._doReset();
				},
	
				/**
	    * Updates this hasher with a message.
	    *
	    * @param {WordArray|string} messageUpdate The message to append.
	    *
	    * @return {Hasher} This hasher.
	    *
	    * @example
	    *
	    *     hasher.update('message');
	    *     hasher.update(wordArray);
	    */
				update: function update(messageUpdate) {
					// Append
					this._append(messageUpdate);
	
					// Update the hash
					this._process();
	
					// Chainable
					return this;
				},
	
				/**
	    * Finalizes the hash computation.
	    * Note that the finalize operation is effectively a destructive, read-once operation.
	    *
	    * @param {WordArray|string} messageUpdate (Optional) A final message update.
	    *
	    * @return {WordArray} The hash.
	    *
	    * @example
	    *
	    *     var hash = hasher.finalize();
	    *     var hash = hasher.finalize('message');
	    *     var hash = hasher.finalize(wordArray);
	    */
				finalize: function finalize(messageUpdate) {
					// Final message update
					if (messageUpdate) {
						this._append(messageUpdate);
					}
	
					// Perform concrete-hasher logic
					var hash = this._doFinalize();
	
					return hash;
				},
	
				blockSize: 512 / 32,
	
				/**
	    * Creates a shortcut function to a hasher's object interface.
	    *
	    * @param {Hasher} hasher The hasher to create a helper for.
	    *
	    * @return {Function} The shortcut function.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	    */
				_createHelper: function _createHelper(hasher) {
					return function (message, cfg) {
						return new hasher.init(cfg).finalize(message);
					};
				},
	
				/**
	    * Creates a shortcut function to the HMAC's object interface.
	    *
	    * @param {Hasher} hasher The hasher to use in this HMAC helper.
	    *
	    * @return {Function} The shortcut function.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	    */
				_createHmacHelper: function _createHmacHelper(hasher) {
					return function (message, key) {
						return new C_algo.HMAC.init(hasher, key).finalize(message);
					};
				}
			});
	
			/**
	   * Algorithm namespace.
	   */
			var C_algo = C.algo = {};
	
			return C;
		}(Math);
	
		return CryptoJS;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(1615);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MetaHelmet = function MetaHelmet(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      title = _ref.title;
	
	  return _react2.default.createElement(_reactHelmet2.default, { title: formatMessage({ id: title }) });
	};
	
	MetaHelmet.propTypes = {
	  intl: _propTypes2.default.object,
	  title: _propTypes2.default.string
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MetaHelmet);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectPublicConstantsSending = exports.selectPrimaryContactsEnabled = exports.selectIsOtpEnabled = exports.selectOtpCodeExpirationSeconds = exports.selectOptAuthCodesState = exports.selectCountryDetailsLegalDocuments = exports.selectCountryDetails = exports.selectCountryState = exports.selectCountryOptions = exports.selectCountryPhoneSettings = exports.selectCountryList = exports.selectCountriesState = exports.selectTimeZoneOptions = exports.selectAppRequestEmergencyContactInfo = exports.selectAppCustomButtons = exports.selectAppointmentSchedulingForSelfAllowed = exports.selectAppointmentSchedulingAllowed = exports.selectVisitTestCallPerformed = exports.selectLoggedUserHasRelations = exports.selectPendingDependentAssignmentsCounter = exports.selectAppState = exports.selectUsStates = exports.selectPaymentDelaySeconds = exports.selectInsuranceRelationList = exports.selectFamilyMemberRoleMinorRoles = exports.selectRelationList = exports.selectComplaintReasons = exports.selectHealthConditions = exports.selectMedicationAllergies = exports.selectEthnicTypes = exports.selectRaceTypes = exports.selectLanguageTypes = exports.selectSsnHidingEnabled = exports.selectPlatformVersion = exports.selectGenderIdentityList = exports.selectGenderTypes = exports.selectMaritalStatus = exports.selectCitizinship = exports.selectEducationLevelsList = exports.selectVeteranStatusesList = exports.selectNameSuffixesList = exports.selectHealthInterestsList = exports.privacyCountriesSelector = exports.sendingPrivacySelector = exports.privacyListSelector = exports.selectDataConfigurationsLoading = exports.selectDataConfigurationsList = exports.selectDataConfigurations = exports.selectProcessedConsts = exports.reqPrivacySelector = exports.selectDataConstants = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectDataConstants = exports.selectDataConstants = function selectDataConstants(state) {
	  return state.data.constants;
	};
	var reqPrivacySelector = exports.reqPrivacySelector = function reqPrivacySelector(state) {
	  return state.data.privacyPolicies;
	};
	var selectProcessedConsts = exports.selectProcessedConsts = function selectProcessedConsts(state) {
	  return state.data.processedConsts;
	};
	var selectDataConfigurations = exports.selectDataConfigurations = function selectDataConfigurations(state) {
	  return state.data.configurations;
	};
	
	var selectDataConfigurationsList = exports.selectDataConfigurationsList = (0, _reselect.createSelector)(selectDataConfigurations, function (request) {
	  return (0, _get2.default)(request, 'list', []);
	});
	
	var selectDataConfigurationsLoading = exports.selectDataConfigurationsLoading = (0, _reselect.createSelector)(selectDataConfigurations, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	var privacyListSelector = exports.privacyListSelector = (0, _reselect.createSelector)(reqPrivacySelector, function (request) {
	  return (0, _get2.default)(request, 'list', []);
	});
	
	var sendingPrivacySelector = exports.sendingPrivacySelector = (0, _reselect.createSelector)(reqPrivacySelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	var privacyCountriesSelector = exports.privacyCountriesSelector = (0, _reselect.createSelector)(privacyListSelector, function (list) {
	  return list.map(function (item) {
	    return (0, _get2.default)(item, 'country');
	  });
	});
	
	var selectHealthInterestsList = exports.selectHealthInterestsList = (0, _reselect.createSelector)(selectProcessedConsts, function (request) {
	  return (0, _get2.default)(request, 'healthInterests', []);
	});
	
	var selectNameSuffixesList = exports.selectNameSuffixesList = (0, _reselect.createSelector)(selectProcessedConsts, function (request) {
	  return (0, _get2.default)(request, 'nameSuffixes', []);
	});
	
	var selectVeteranStatusesList = exports.selectVeteranStatusesList = (0, _reselect.createSelector)(selectDataConstants, function (request) {
	  return (0, _get2.default)(request, 'veteranStatuses', []);
	});
	
	var selectEducationLevelsList = exports.selectEducationLevelsList = (0, _reselect.createSelector)(selectDataConstants, function (request) {
	  return (0, _get2.default)(request, 'educationLevels', []);
	});
	
	var selectCitizinship = exports.selectCitizinship = (0, _reselect.createSelector)(selectDataConstants, function (request) {
	  return (0, _get2.default)(request, 'citizenship', []);
	});
	
	var selectMaritalStatus = exports.selectMaritalStatus = (0, _reselect.createSelector)(selectProcessedConsts, function (request) {
	  return (0, _get2.default)(request, 'maritalStatus');
	});
	
	var selectGenderTypes = exports.selectGenderTypes = (0, _reselect.createSelector)(selectProcessedConsts, function (request) {
	  return (0, _get2.default)(request, 'genderTypes', []);
	});
	
	var selectGenderIdentityList = exports.selectGenderIdentityList = (0, _reselect.createSelector)(selectDataConstants, function (request) {
	  return (0, _get2.default)(request, 'genderIdentities', []);
	});
	
	var selectPlatformVersion = exports.selectPlatformVersion = (0, _reselect.createSelector)(selectDataConstants, function (request) {
	  return (0, _get2.default)(request, 'version', '-');
	});
	
	var selectSsnHidingEnabled = exports.selectSsnHidingEnabled = (0, _reselect.createSelector)(selectDataConstants, function (request) {
	  return (0, _get2.default)(request, 'ssnHidingEnabled', false);
	});
	
	var selectLanguageTypes = exports.selectLanguageTypes = (0, _reselect.createSelector)(selectProcessedConsts, function (request) {
	  return (0, _get2.default)(request, 'languageTypes');
	});
	
	var selectRaceTypes = exports.selectRaceTypes = (0, _reselect.createSelector)(selectProcessedConsts, function (request) {
	  return (0, _get2.default)(request, 'raceCodes', []);
	});
	
	var selectEthnicTypes = exports.selectEthnicTypes = (0, _reselect.createSelector)(selectProcessedConsts, function (request) {
	  return (0, _get2.default)(request, 'ethnicTypes', []);
	});
	
	var selectMedicationAllergies = exports.selectMedicationAllergies = (0, _reselect.createSelector)(selectProcessedConsts, function (state) {
	  return (0, _get2.default)(state, 'medicationAllergies', []);
	});
	
	var selectHealthConditions = exports.selectHealthConditions = (0, _reselect.createSelector)(selectProcessedConsts, function (state) {
	  return (0, _get2.default)(state, 'healthConditions', []);
	});
	
	var selectComplaintReasons = exports.selectComplaintReasons = (0, _reselect.createSelector)(selectDataConstants, function (constants) {
	  return (0, _get2.default)(constants, 'complaintReasons', []);
	});
	
	var selectRelationList = exports.selectRelationList = (0, _reselect.createSelector)(selectDataConstants, function (constants) {
	  return (0, _get2.default)(constants, 'relations', []);
	});
	
	var selectFamilyMemberRoleMinorRoles = exports.selectFamilyMemberRoleMinorRoles = (0, _reselect.createSelector)(selectDataConstants, function (constants) {
	  return (0, _get2.default)(constants, 'familyMemberRoleMinorRoles', []);
	});
	
	var selectInsuranceRelationList = exports.selectInsuranceRelationList = (0, _reselect.createSelector)(selectDataConstants, function (constants) {
	  return (0, _get2.default)(constants, 'insuranceRelations', []);
	});
	
	var selectPaymentDelaySeconds = exports.selectPaymentDelaySeconds = (0, _reselect.createSelector)(selectDataConstants, function (constants) {
	  return (0, _get2.default)(constants, 'paymentsVerificationJobDelaySeconds', 240);
	});
	
	var selectUsStates = exports.selectUsStates = (0, _reselect.createSelector)(selectProcessedConsts, function (request) {
	  return (0, _get2.default)(request, 'constantsStatesUs', []);
	});
	
	var selectAppState = exports.selectAppState = function selectAppState(state) {
	  return (0, _get2.default)(state, 'data.appState');
	};
	
	var selectPendingDependentAssignmentsCounter = exports.selectPendingDependentAssignmentsCounter = (0, _reselect.createSelector)(selectAppState, function (state) {
	  return (0, _get2.default)(state, 'providerPendingEventsFeedItems.totalFeedsCount', 0);
	});
	
	var selectLoggedUserHasRelations = exports.selectLoggedUserHasRelations = (0, _reselect.createSelector)(selectAppState, function (state) {
	  return (0, _get2.default)(state, 'caregiverOrGuardianOrProxyOrFamilyMember', false);
	});
	
	var selectVisitTestCallPerformed = exports.selectVisitTestCallPerformed = (0, _reselect.createSelector)(selectAppState, function (state) {
	  return (0, _get2.default)(state, 'virtualVisitNetworkTestPerformed', false);
	});
	
	var selectAppointmentSchedulingAllowed = exports.selectAppointmentSchedulingAllowed = (0, _reselect.createSelector)(selectAppState, function (state) {
	  return (0, _get2.default)(state, 'appointmentSchedulingAllowed', false);
	});
	
	var selectAppointmentSchedulingForSelfAllowed = exports.selectAppointmentSchedulingForSelfAllowed = (0, _reselect.createSelector)(selectAppState, function (state) {
	  return (0, _get2.default)(state, 'appointmentSchedulingForSelfAllowed', false);
	});
	
	var selectAppCustomButtons = exports.selectAppCustomButtons = (0, _reselect.createSelector)(selectAppState, function (state) {
	  return (0, _get2.default)(state, 'customButtons', []);
	});
	
	var selectAppRequestEmergencyContactInfo = exports.selectAppRequestEmergencyContactInfo = (0, _reselect.createSelector)(selectAppState, function (state) {
	  return (0, _get2.default)(state, 'requestEmergencyContactInfo', true);
	});
	
	var selectTimeZoneOptions = exports.selectTimeZoneOptions = (0, _reselect.createSelector)(selectDataConstants, function (state) {
	  var timeZones = (0, _get2.default)(state, 'timeZones', []);
	  return timeZones.map(function (_ref) {
	    var name = _ref.name;
	    return {
	      label: name,
	      value: name
	    };
	  });
	});
	
	var selectDataState = function selectDataState(state) {
	  return (0, _get2.default)(state, 'data');
	};
	
	/**
	 *  COUNTRIES STATE
	 * */
	var selectCountriesState = exports.selectCountriesState = (0, _reselect.createSelector)(selectDataState, function (state) {
	  return (0, _get2.default)(state, 'countries');
	});
	var selectCountryList = exports.selectCountryList = (0, _reselect.createSelector)(selectCountriesState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectCountryPhoneSettings = exports.selectCountryPhoneSettings = (0, _reselect.createSelector)(selectCountryList, function (list) {
	  return list.map(function (_ref2) {
	    var phone = _ref2.phone;
	    return phone;
	  });
	});
	
	var selectCountryOptions = exports.selectCountryOptions = (0, _reselect.createSelector)(selectCountryList, function (list) {
	  return list.map(function (_ref3) {
	    var name = _ref3.name,
	        isoCode = _ref3.isoCode;
	    return { value: isoCode, label: name };
	  });
	});
	
	/**
	 *  COUNTRY DETAILS
	 * */
	var selectCountryState = exports.selectCountryState = (0, _reselect.createSelector)(selectDataState, function (state) {
	  return (0, _get2.default)(state, 'countryDetails');
	});
	var selectCountryDetails = exports.selectCountryDetails = (0, _reselect.createSelector)(selectCountryState, function (state) {
	  return (0, _get2.default)(state, 'data', {});
	});
	
	var selectCountryDetailsLegalDocuments = exports.selectCountryDetailsLegalDocuments = (0, _reselect.createSelector)(selectCountryState, function (state) {
	  return (0, _get2.default)(state, 'data.legalDocuments', {});
	});
	
	/**
	 *  optAutCodes
	 * */
	var selectOptAuthCodesState = exports.selectOptAuthCodesState = (0, _reselect.createSelector)(selectDataState, function (state) {
	  return (0, _get2.default)(state, 'optAuthCodes');
	});
	
	/**
	 *  publicConstants
	 * */
	var selectOtpCodeExpirationSeconds = exports.selectOtpCodeExpirationSeconds = (0, _reselect.createSelector)(selectDataState, function (state) {
	  return (0, _get2.default)(state, 'publicConstants.otpCodeExpirationSeconds', 0);
	});
	
	var selectIsOtpEnabled = exports.selectIsOtpEnabled = (0, _reselect.createSelector)(selectDataState, function (state) {
	  return (0, _get2.default)(state, 'publicConstants.otpEnabled', undefined);
	});
	
	var selectPrimaryContactsEnabled = exports.selectPrimaryContactsEnabled = (0, _reselect.createSelector)(selectDataState, function (state) {
	  return (0, _get2.default)(state, 'publicConstants.primaryContactsEnabled', undefined);
	});
	
	var selectPublicConstantsSending = exports.selectPublicConstantsSending = (0, _reselect.createSelector)(selectDataState, function (state) {
	  return (0, _get2.default)(state, 'publicConstants.sending', false);
	});

/***/ }),
/* 51 */
[6841, 1536, 574, 729, 96, 247, 730, 976, 982],
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usePageView = usePageView;
	
	var _react = __webpack_require__(1);
	
	var _gtag = __webpack_require__(182);
	
	function usePageView(title) {
	  (0, _react.useEffect)(function () {
	    (0, _gtag.GATrackPageView)(title);
	  }, []);
	}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	
	  var number = Number(dirtyNumber);
	
	  if (isNaN(number)) {
	    return number;
	  }
	
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	
	module.exports = exports.default;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var VITALS_ACTIVITY_TYPE = exports.VITALS_ACTIVITY_TYPE = {
	  STEPS: 'steps',
	  DISTANCE: 'distance',
	  BMI: 'bmi',
	  WEIGHT: 'weight',
	  HEIGHT: 'height',
	  SATURATION: 'spo2',
	  HEART_RATE: 'heart_rate',
	  BLOOD_PRESSURE: 'blood_pressure',
	  RESPIRATORY_RATE: 'respiratory_rate',
	  BODY_SURFACE_AREA: 'bsa',
	  BODY_TEMPERATURE: 'body_temperature',
	  BLOOD_GLUCOSE: 'blood_glucose'
	};
	
	var CHART_FILTERS_TYPE = exports.CHART_FILTERS_TYPE = {
	  DAY: {
	    title: '1 D',
	    type: 'day'
	  },
	  WEEK: {
	    title: '1 W',
	    type: 'week'
	  },
	  MONTH: {
	    title: '1 M',
	    type: 'month'
	  },
	  QUARTER: {
	    title: '3 M',
	    type: 'quarter'
	  },
	  YEAR: {
	    title: '1 Y',
	    type: 'year'
	  }
	};
	
	var ORDER_MONTH_IN_YEAR = exports.ORDER_MONTH_IN_YEAR = ['SEP', 'OCT', 'NOV', 'DEC', 'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG'];
	
	var ORDER_TIME_DAY = exports.ORDER_TIME_DAY = ['12 AM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM', '9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM'];
	
	var ORDER_TIME_DAY_BMI_WEIGHT = exports.ORDER_TIME_DAY_BMI_WEIGHT = ['', '12 AM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM', '9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM', ''];
	
	var PREVIOUS_PERIOD = exports.PREVIOUS_PERIOD = 2;
	
	var ALLERGIE_TYPE = exports.ALLERGIE_TYPE = {
	  SEVERE: 'severe',
	  MODERATE: 'moderate',
	  MILD: 'mild'
	};
	
	var NORMAL_TYPE = exports.NORMAL_TYPE = ['N', 'n', 'normal'];
	
	var SCALE_BACKGROUND_COLOR = exports.SCALE_BACKGROUND_COLOR = ['#ffc37d', '#7febb9', '#ff887d'];
	
	var HISTORIC_ONE_DAY_CALENDAR_TYPE = exports.HISTORIC_ONE_DAY_CALENDAR_TYPE = {
	  sameDay: 'h:mm A',
	  lastDay: 'h:mm A',
	  lastWeek: 'h:mm A',
	  sameElse: 'h:mm A'
	};
	
	var DEVICE_CALENDAR_FORMATS = exports.DEVICE_CALENDAR_FORMATS = {
	  sameDay: '[today], h:mm A',
	  lastDay: '[yesterday], h:mm A',
	  lastWeek: 'MMM D, h:mm A',
	  sameElse: 'MMM D, h:mm A'
	};
	
	var HISTORIC_CALENDAR_TYPE = exports.HISTORIC_CALENDAR_TYPE = {
	  sameDay: '[Today]',
	  sameElse: 'MMM D, YYYY',
	  lastDay: 'MMM D, YYYY',
	  lastWeek: 'MMM D, YYYY'
	};
	
	var HISTORIC_SHORT_CALENDAR_TYPE = exports.HISTORIC_SHORT_CALENDAR_TYPE = {
	  sameDay: '[Today]',
	  lastDay: 'MMM D',
	  lastWeek: 'MMM D',
	  lastMonth: 'MMM D',
	  lastYear: 'MMM D, YYYY',
	  sameElse: 'MMM D, YYYY'
	};
	
	var HISTORIC_MONTHS_CALENDAR_TYPE = exports.HISTORIC_MONTHS_CALENDAR_TYPE = {
	  sameDay: '[Today], h:mm A',
	  sameElse: 'MMM D, YYYY, h:mm A',
	  lastDay: 'MMM D, YYYY, h:mm A',
	  lastWeek: 'MMM D, YYYY, h:mm A'
	};
	
	var FITNESS_ACCOUNT_TYPE = exports.FITNESS_ACCOUNT_TYPE = {
	  FITBIT: 'fitbit',
	  WITHINGS: 'withings',
	  GOOGLE_FIT: 'google_fit'
	};
	
	var ACCOUNT_REGISTER_REDIRECT = exports.ACCOUNT_REGISTER_REDIRECT = {
	  SUCCESS: 'register-device-account-success',
	  ERROR: 'register-device-account-error'
	};
	
	var MAX_ADDED_ACCOUNT = exports.MAX_ADDED_ACCOUNT = 4;
	
	var TABS_PATIENT_PORTAL = exports.TABS_PATIENT_PORTAL = {
	  VITALS_AND_ACTIVITY: 'vitals_and_activity',
	  ENCOUNTERS: 'encounters',
	  MEDICATIONS: 'medications',
	  IMMUNIZATIONS: 'immunizations',
	  LAB_TEST_RESULT: 'lab_and_test_results',
	  ALLERGIES: 'allergies',
	  CONDITIONS: 'conditions',
	  SOCIAL_HISTORY: 'social_histories',
	  FAMILY_HISTORY: 'family_histories',
	  HEALTH_RECORD: 'health_record',
	  ACTIVITY_LOG: 'activity_log',
	  PROCEDURES: 'procedures'
	};
	
	var CUSTOM_CHANNEL = exports.CUSTOM_CHANNEL = null;
	var ALL_MEMBERS_SUBCHANNEL = exports.ALL_MEMBERS_SUBCHANNEL = 'all_members';
	var CIRCLE_OF_CARE_SUBCHANNEL = exports.CIRCLE_OF_CARE_SUBCHANNEL = 'circles_of_care';
	var FAMILY_CIRCLE_SUBCHANNEL = exports.FAMILY_CIRCLE_SUBCHANNEL = 'family_circle';
	var NOTIFICATIONS_SUBCHANNEL = exports.NOTIFICATIONS_SUBCHANNEL = 'notifications';
	var ACTIVITIES_SUBCHANNEL = exports.ACTIVITIES_SUBCHANNEL = 'activities';
	
	var INVALID_DATE = exports.INVALID_DATE = 'Invalid date';
	
	var HEALTH_RECORD_DOC_TYPE = exports.HEALTH_RECORD_DOC_TYPE = {
	  XML: { fileType: 'xml', mimeType: 'text/xml' },
	  PDF: { fileType: 'pdf', mimeType: 'application/pdf' },
	  TXT: { fileType: 'txt', mimeType: 'text/plain' },
	  ZIP: { fileType: 'zip', mimeType: 'application/zip' }
	};
	
	var ACTIVITY_LOG_ROLE = exports.ACTIVITY_LOG_ROLE = {
	  CAREGIVER: 'caregiver',
	  PROVIDER: 'provider',
	  GUARDIAN_PROXY: 'guardian/proxy',
	  PATIENT: 'patient',
	  PROXY: 'proxy',
	  GUARDIAN: 'guardian',
	  PARENT: 'parent'
	};
	
	var ACTIVITY_LOG_ACTION_TYPE = exports.ACTIVITY_LOG_ACTION_TYPE = {
	  SHARE_CHAT: 'share_ccd_file_chat',
	  SHARE_EMAIL: 'share_ccd_file_email',
	  DOWNLOAD: 'download_ccd_file',
	  GET_ACCESS: 'get_ccd_info_access',
	  VIEW: 'view_ccd_file'
	};
	
	var ACTIVITY_LOG_USER_ACTION_TYPE = exports.ACTIVITY_LOG_USER_ACTION_TYPE = {
	  DOWNLOAD: 'download',
	  VIEW: 'view'
	};
	
	var THICKNESS_BY_Y_AXIS = exports.THICKNESS_BY_Y_AXIS = 1.05;
	
	var MAYO_CLINIC_URL = exports.MAYO_CLINIC_URL = 'https://www.mayoclinic.org/symptoms/hypoxemia/basics/definition/sym-20050930';
	
	var DATA_SOURCE_TYPE = exports.DATA_SOURCE_TYPE = {
	  CCD: 'ccd',
	  DEVICES: 'devices',
	  ALL_SOURCES: 'all_sources',
	  LOCAL: 'local',
	  APPLE: 'apple',
	  FITBIT: 'fitbit',
	  WITHINGS: 'withings',
	  GOOGLE_FIT: 'google_fit',
	  TENOVI: 'tenovi',
	  I_HEALTH: 'ihealth'
	};
	
	var COMPLETE_DATE_FORMAT = exports.COMPLETE_DATE_FORMAT = 'MMM DD, YYYY, h:mm A';

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appointmentProgressActions = exports.APPOINTMENT_PROGRESS_TYPES = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var actionsScope = 'appointment-form/progress';
	
	var APPOINTMENT_PROGRESS_TYPES = exports.APPOINTMENT_PROGRESS_TYPES = {
	  VALIDATE: actionsScope + '/validate',
	  VALIDATE_FINISH: actionsScope + '/validate-finish',
	  SET_CARE_USER: actionsScope + '/set-care-user',
	  SET_ORGANIZATION: actionsScope + '/set-organization',
	  SET_VISIT_TYPE: actionsScope + '/set-visit-type',
	  SELECT_VISIT_TYPE: actionsScope + '/select-visit-type',
	  SET_SERVICE: actionsScope + '/set-service',
	  SET_LOCATION: actionsScope + '/set-location',
	  SET_PATIENT_INFO: actionsScope + '/set-patient-info',
	  SET_SSN: actionsScope + '/set-ssn',
	  SET_REASON: actionsScope + '/set-reason',
	  INSPECT_CONSENT: actionsScope + '/inspect-consent',
	  INSPECT_PATIENT: actionsScope + '/inspect-patient',
	  UPDATE_NECESSARY_DATA: actionsScope + '/update-necessary-data',
	  SET_ERROR: actionsScope + '/set-error',
	  SET_SCHEDULE_DATA: actionsScope + '/set-schedule-data',
	  FETCH_PROVIDER_LIST: actionsScope + '/fetch-provider-list',
	  CLEAR: actionsScope + '/clear',
	  SET_CREATE_TYPE_FLOW_GW: actionsScope + '/set-create-type-flow',
	  SET_PROGRAM_BASED_VISIT_ID: actionsScope + '/set-program-based-visit-id',
	  CLEAR_PROGRAM_BASED_VISIT_ID: actionsScope + '/clear-program-based-visit-id',
	  SELECT_PROGRAM_BASED_VISIT: actionsScope + '/select-program-based-visit',
	  SET_INSURANCE_ELIGIBILITY: actionsScope + '/set-insurance-eligibility',
	  SET_HEALTH_INFO: actionsScope + '/set-health-info',
	  UPDATE_CARE_USER_PROFILE: actionsScope + '/update-care-user-profile',
	  SET_PREFERRED_PHARMACY: actionsScope + '/set-preferred-pharmacy',
	  SET_RESCHEDULE_DATA: actionsScope + '/set-reschedule-data',
	  CLEAR_INSURANCE_ELIGIBILITY: actionsScope + '/clear-insurance-eligibility',
	  SET_HAVE_CARE_PROVIDER_ANSWER: actionsScope + '/set-have-care-provider-answer',
	  SET_PENDING: actionsScope + '/set-pending',
	  SET_FLOW_PAGES: actionsScope + '/set-flow-pages',
	  REMOVE_FLOW_PAGE: actionsScope + '/remove-flow-page',
	  SET_PRIMARY_CARE_PROVIDER_FORM_DATA: actionsScope + '/set-primary-care-provider-form-data',
	  SET_ADDITIONAL_INFO_FORM_DATA: actionsScope + '/set-additional-info-form-data',
	  DETERMINE_NEXT_STEP_AFTER_EMERGENCY_CONTACT: actionsScope + '/determine-next-step-after-emergency-contact',
	  DETERMINE_NEXT_STEP_AFTER_GUARANTOR_INFORMATION: actionsScope + '/determine-next-step-after-guarantor-information',
	  DETERMINE_NEXT_STEP_AFTER_INSURANCE_FORM: actionsScope + '/determine-next-step-after-insurance-form',
	  DETERMINE_NEXT_STEP_AFTER_VISIT_DETAILS: actionsScope + '/determine-next-step-after-visit-details',
	  DETERMINE_NEXT_STEP_AFTER_PHARMACY: actionsScope + '/determine-next-step-after-pharmacy',
	  DETERMINE_NEXT_STEP_AFTER_HEALTH_INFO_PROVIDER_STEP: actionsScope + '/determine-next-step-after-health-info-provider-step',
	  DETERMINE_NEXT_STEP_AFTER_APPOINTMENT_PROVIDERS: actionsScope + '/determine-next-step-after-appointment-providers',
	  SET_PREFERRED_LANGUAGE: actionsScope + '/set-preferred-language'
	};
	
	var appointmentProgressActions = exports.appointmentProgressActions = {
	  validate: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.VALIDATE),
	  finishValidate: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.VALIDATE_FINISH),
	  setCareUser: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER),
	  setOrganization: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_ORGANIZATION),
	  setVisitType: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_VISIT_TYPE),
	  selectVisitType: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SELECT_VISIT_TYPE),
	  setService: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_SERVICE),
	  setLocation: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_LOCATION),
	  inspectConsent: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.INSPECT_CONSENT),
	  inspectPatient: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.INSPECT_PATIENT),
	  setPatientInfo: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_PATIENT_INFO),
	  setSSN: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_SSN),
	  setReason: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_REASON),
	  setError: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_ERROR),
	  setHealthInfo: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_HEALTH_INFO),
	  setHaveCareProviderAnswer: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_HAVE_CARE_PROVIDER_ANSWER),
	  setRescheduleData: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_RESCHEDULE_DATA),
	  updateCareUserProfile: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.UPDATE_CARE_USER_PROFILE),
	  setScheduleData: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_SCHEDULE_DATA),
	  setPreferredPharmacy: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_PREFERRED_PHARMACY),
	  setProgramBasedVisitId: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_PROGRAM_BASED_VISIT_ID),
	  clearProgramBasedVisitId: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.CLEAR_PROGRAM_BASED_VISIT_ID),
	  selectProgramBasedVisit: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SELECT_PROGRAM_BASED_VISIT),
	  fetchProviderList: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.FETCH_PROVIDER_LIST),
	  updateNecessaryData: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.UPDATE_NECESSARY_DATA),
	  clear: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.CLEAR),
	  setCreateTypeFlowGW: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_CREATE_TYPE_FLOW_GW),
	  setInsuranceEligibility: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_INSURANCE_ELIGIBILITY),
	  clearInsuranceEligibility: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.CLEAR_INSURANCE_ELIGIBILITY),
	  setPending: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_PENDING),
	  setFlowPages: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_FLOW_PAGES),
	  removeFlowPage: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.REMOVE_FLOW_PAGE),
	  setPrimaryCareProviderFormData: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_PRIMARY_CARE_PROVIDER_FORM_DATA),
	  setAdditionalInfoFormData: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_ADDITIONAL_INFO_FORM_DATA),
	  determineNextStepAfterEmergencyContact: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_EMERGENCY_CONTACT),
	  determineNextStepAfterGuarantorInformation: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_GUARANTOR_INFORMATION),
	  determineNextStepAfterInsuranceForm: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_INSURANCE_FORM),
	  determineNextStepAfterVisitDetails: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_VISIT_DETAILS),
	  determineNextStepAfterPharmacy: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_PHARMACY),
	  determineNextStepAfterHealthInfoProvider: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_HEALTH_INFO_PROVIDER_STEP),
	  determineNextStepAfterAppointmentProviders: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_APPOINTMENT_PROVIDERS),
	  setPreferredLanguage: (0, _createAction.createAction)(APPOINTMENT_PROGRESS_TYPES.SET_PREFERRED_LANGUAGE)
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectEditPatientEmergencyContactError = exports.selectEditPatientEmergencyContactPending = exports.selectEditPatientEmergencyContactSucceed = exports.selectManualActivateInsuranceEligibilitySucceed = exports.selectShowMfaAfterMobileAppPopup = exports.selectUser = exports.selectProviderCalendarManageAccess = exports.selectProviderProfile = exports.getEnableMfa = exports.getMfaConfirmationData = exports.selectSignupProcessPending = exports.selectUserMetricForWeight = exports.selectUserMetricForHeight = exports.selectUserPrimaryPatientProfile = exports.selectUserPhoneNumberCountryISOCode = exports.selectUserPhoneNumberCountryCode = exports.selectCurrentCountryCode = exports.selectAddedPatientsList = exports.selectSavedPatientAddress = exports.selectSavedPatientPersonalInfo = exports.selectSavedPatientContacts = exports.selectPatientPhoneNumberCountryIsoCode = exports.selectPatientContacts = exports.selectMainConsent = exports.selectIsSignedMainConsentSelector = exports.selectDependentStatusById = exports.selectGuardianDependentById = exports.selectVerifiedGuardianDependentsList = exports.selectGuardianDependentsList = exports.selectIsLoadingGuardianDependents = exports.selectDocumentsPageLoading = exports.selectDeleteUserOutcomeAttachmentLoading = exports.selectDeleteUserOutcomeAttachment = exports.selectDeleteUserAttachmentLoading = exports.selectDeleteUserAttachment = exports.selectUserAttachmentsLoading = exports.selectUserSignedConsents = exports.selectUserAttachmentsList = exports.selectUserPaperConsents = exports.selectUserAttachments = exports.selectGuardianDependents = exports.selectUploadUserDocumentsDataKey = exports.selectUploadUserDocumentsDataId = exports.selectUploadUserDocumentsSucceed = exports.selectUploadUserDocumentsLoading = exports.selectUpdateUserDocumentsLoading = exports.selectDeleteUserDocumentsLoading = exports.selectUpdateUserDocuments = exports.selectUploadUserDocuments = exports.selectDeleteUserDocuments = exports.selectUserDocumentsLoading = exports.selectUserDocumentsList = exports.selectUserDocuments = exports.selectPublicProfileRejected = exports.selectPublicProfileLoading = exports.selectPublicProfile = exports.selectPublicProfileState = exports.selectIsAccessLeverPracticeProvider = exports.selectIsAccessLeverProvider = exports.canAssignProviderSelector = exports.selectPatientProfileAlreadyExists = exports.addPatientSuccessSelector = exports.addPatientErrorSelector = exports.addPatientSendingSelector = exports.sendingSelector = exports.selectEditPatientPending = exports.selectEditPatientSuccess = exports.selectEditPatientErrors = exports.selectCreatedPatientProfileId = exports.selectCreatedPatientProfile = exports.selectCreatedPatient = exports.selectProfiles = exports.selectAccessLevelLoading = exports.selectAccessLevelResponse = exports.accessLevelSelector = exports.selectEditedUserSucceed = exports.selectEditedUserSending = exports.selectEditedUserErrors = exports.selectEditedUser = exports.selectProfileEditable = exports.selectCreatePatientPending = exports.addPatientByProviderSelector = exports.getUserSelector = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _props = __webpack_require__(41);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(93);
	
	var _selectors3 = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectProfileState = function selectProfileState(state) {
	  return (0, _get2.default)(state, 'profiles');
	};
	
	var getUserSelector = exports.getUserSelector = function getUserSelector(state) {
	  return state.profiles.getUser;
	};
	
	var addPatientByProviderSelector = exports.addPatientByProviderSelector = function addPatientByProviderSelector(state) {
	  return state.profiles.addPatientByProvider;
	};
	
	var selectCreatePatientPending = exports.selectCreatePatientPending = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'createPatient.sending');
	});
	
	/** *************************** PROFILE EDITABLE ************************** * */
	
	var selectProfileEditable = exports.selectProfileEditable = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'profileEditable.fieldsEditable');
	});
	
	/** *************************** EDIT USER ********************************** * */
	
	var selectEditedUser = exports.selectEditedUser = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'editUser');
	});
	
	var selectEditedUserErrors = exports.selectEditedUserErrors = (0, _reselect.createSelector)(selectEditedUser, function (state) {
	  return (0, _get2.default)(state, 'error');
	});
	
	var selectEditedUserSending = exports.selectEditedUserSending = (0, _reselect.createSelector)(selectEditedUser, function (state) {
	  return (0, _get2.default)(state, 'sending');
	});
	
	var selectEditedUserSucceed = exports.selectEditedUserSucceed = (0, _reselect.createSelector)(selectEditedUser, function (state) {
	  return (0, _get2.default)(state, 'succeed');
	});
	
	/** *************************** ACCESS LEVEL ******************************* * */
	
	var accessLevelSelector = exports.accessLevelSelector = function accessLevelSelector(state) {
	  return state.profiles.getAccessLevels.list;
	};
	
	var selectAccessLevelResponse = exports.selectAccessLevelResponse = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'getAccessLevels');
	});
	
	var selectAccessLevelLoading = exports.selectAccessLevelLoading = (0, _reselect.createSelector)(selectAccessLevelResponse, function (state) {
	  return (0, _get2.default)(state, 'loading', false);
	});
	
	/** ************************************************************************ * */
	
	var selectProfiles = exports.selectProfiles = function selectProfiles(state) {
	  return state.profiles;
	};
	
	var selectCreatedPatient = exports.selectCreatedPatient = (0, _reselect.createSelector)(selectProfiles, function (state) {
	  return (0, _get2.default)(state, 'addPatientByProvider', {});
	});
	
	var selectCreatedPatientProfile = exports.selectCreatedPatientProfile = (0, _reselect.createSelector)(selectCreatedPatient, function (state) {
	  return (0, _get2.default)(state, 'primaryPatientProfile', {});
	});
	
	var selectCreatedPatientProfileId = exports.selectCreatedPatientProfileId = (0, _reselect.createSelector)(selectCreatedPatientProfile, function (state) {
	  return (0, _get2.default)(state, 'id');
	});
	
	var selectEditPatientErrors = exports.selectEditPatientErrors = (0, _reselect.createSelector)(selectProfiles, function (state) {
	  return (0, _get2.default)(state, 'editPatient.error', false);
	});
	
	var selectEditPatientSuccess = exports.selectEditPatientSuccess = (0, _reselect.createSelector)(selectProfiles, function (state) {
	  return (0, _get2.default)(state, 'editPatient.succeed', false);
	});
	
	var selectEditPatientPending = exports.selectEditPatientPending = (0, _reselect.createSelector)(selectProfiles, function (state) {
	  return (0, _get2.default)(state, 'editPatient.sending', false);
	});
	
	var sendingSelector = exports.sendingSelector = (0, _reselect.createSelector)(getUserSelector, function (request) {
	  return (0, _get2.default)(request, 'sending') || false;
	});
	
	var addPatientSendingSelector = exports.addPatientSendingSelector = (0, _reselect.createSelector)(addPatientByProviderSelector, function (request) {
	  return (0, _get2.default)(request, 'sending') || false;
	});
	
	var addPatientErrorSelector = exports.addPatientErrorSelector = (0, _reselect.createSelector)(addPatientByProviderSelector, function (request) {
	  return (0, _get2.default)(request, 'error', null);
	});
	
	var addPatientSuccessSelector = exports.addPatientSuccessSelector = (0, _reselect.createSelector)(addPatientByProviderSelector, function (request) {
	  return (0, _get2.default)(request, 'succeed') || false;
	});
	
	var selectPatientProfileAlreadyExists = exports.selectPatientProfileAlreadyExists = (0, _reselect.createSelector)(addPatientByProviderSelector, function (request) {
	  return (0, _get2.default)(request, 'meta.patientProfileAlreadyExists') || true;
	});
	
	var canAssignProviderSelector = exports.canAssignProviderSelector = (0, _reselect.createSelector)(accessLevelSelector, _selectors.selectIsVerifiedDependentRole, function (levels, isVerifiedDependent) {
	  return levels && levels.some(function (item) {
	    return ['patient_caregiver', 'provider'].includes(item);
	  }) || isVerifiedDependent;
	});
	
	var selectIsAccessLeverProvider = exports.selectIsAccessLeverProvider = (0, _reselect.createSelector)(accessLevelSelector, function (levels) {
	  return levels && levels.some(function (item) {
	    return ['provider'].includes(item);
	  });
	});
	
	var selectIsAccessLeverPracticeProvider = exports.selectIsAccessLeverPracticeProvider = (0, _reselect.createSelector)(accessLevelSelector, function (levels) {
	  return levels && levels.some(function (item) {
	    return ['practice_provider'].includes(item);
	  });
	});
	
	var selectPublicProfileState = exports.selectPublicProfileState = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'publicProfile');
	});
	var selectPublicProfile = exports.selectPublicProfile = (0, _reselect.createSelector)(selectPublicProfileState, function (state) {
	  return (0, _get2.default)(state, 'data');
	});
	
	var selectPublicProfileLoading = exports.selectPublicProfileLoading = (0, _reselect.createSelector)(selectPublicProfileState, function (state) {
	  return (0, _get2.default)(state, 'sending');
	});
	
	var selectPublicProfileRejected = exports.selectPublicProfileRejected = (0, _reselect.createSelector)(selectPublicProfileState, function (state) {
	  return (0, _get2.default)(state, 'rejected');
	});
	
	var selectUserDocuments = exports.selectUserDocuments = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'getUserDocuments', {});
	});
	
	var selectUserDocumentsList = exports.selectUserDocumentsList = (0, _reselect.createSelector)(selectUserDocuments, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectUserDocumentsLoading = exports.selectUserDocumentsLoading = (0, _reselect.createSelector)(selectUserDocuments, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectDeleteUserDocuments = exports.selectDeleteUserDocuments = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'deleteUserDocuments', {});
	});
	
	var selectUploadUserDocuments = exports.selectUploadUserDocuments = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'uploadUserDocuments', {});
	});
	
	var selectUpdateUserDocuments = exports.selectUpdateUserDocuments = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'updateUserDocuments', {});
	});
	
	var selectDeleteUserDocumentsLoading = exports.selectDeleteUserDocumentsLoading = (0, _reselect.createSelector)(selectDeleteUserDocuments, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectUpdateUserDocumentsLoading = exports.selectUpdateUserDocumentsLoading = (0, _reselect.createSelector)(selectUpdateUserDocuments, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectUploadUserDocumentsLoading = exports.selectUploadUserDocumentsLoading = (0, _reselect.createSelector)(selectUploadUserDocuments, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectUploadUserDocumentsSucceed = exports.selectUploadUserDocumentsSucceed = (0, _reselect.createSelector)(selectUploadUserDocuments, function (state) {
	  return (0, _get2.default)(state, 'succeed', false);
	});
	var selectUploadUserDocumentsDataId = exports.selectUploadUserDocumentsDataId = (0, _reselect.createSelector)(selectUploadUserDocuments, function (state) {
	  return (0, _get2.default)(state, 'id', {});
	});
	var selectUploadUserDocumentsDataKey = exports.selectUploadUserDocumentsDataKey = (0, _reselect.createSelector)(selectUploadUserDocuments, function (state) {
	  return (0, _get2.default)(state, 'key', '');
	});
	
	var selectGuardianDependents = exports.selectGuardianDependents = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'getGuardianDependent', {});
	});
	
	/** *************************** USER ATTACHMENTS ********************************** * */
	
	var selectUserAttachments = exports.selectUserAttachments = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'getUserAttachments', {});
	});
	
	var selectUserPaperConsents = exports.selectUserPaperConsents = (0, _reselect.createSelector)(selectUserAttachments, function (state) {
	  return (0, _get2.default)(state, 'paperConsents', []);
	});
	
	var selectUserAttachmentsList = exports.selectUserAttachmentsList = (0, _reselect.createSelector)(selectUserAttachments, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectUserSignedConsents = exports.selectUserSignedConsents = (0, _reselect.createSelector)(selectUserAttachments, function (state) {
	  return (0, _get2.default)(state, 'consents', []);
	});
	
	var selectUserAttachmentsLoading = exports.selectUserAttachmentsLoading = (0, _reselect.createSelector)(selectUserAttachments, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectDeleteUserAttachment = exports.selectDeleteUserAttachment = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'deleteUserAttachment', {});
	});
	
	var selectDeleteUserAttachmentLoading = exports.selectDeleteUserAttachmentLoading = (0, _reselect.createSelector)(selectDeleteUserAttachment, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectDeleteUserOutcomeAttachment = exports.selectDeleteUserOutcomeAttachment = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'deleteUserOutcomeAttachment', {});
	});
	
	var selectDeleteUserOutcomeAttachmentLoading = exports.selectDeleteUserOutcomeAttachmentLoading = (0, _reselect.createSelector)(selectDeleteUserOutcomeAttachment, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	/** ****************************************************************************** * */
	
	var selectDocumentsPageLoading = exports.selectDocumentsPageLoading = (0, _reselect.createSelector)(selectUserDocumentsLoading, selectUploadUserDocumentsLoading, selectDeleteUserDocumentsLoading, selectUpdateUserDocumentsLoading, selectUserAttachmentsLoading, selectDeleteUserAttachmentLoading, selectDeleteUserOutcomeAttachmentLoading, function (documentsLoading, documentsUpload, documentDelete, documentUpdate, attachmentsLoading, attachmentDelete) {
	  return documentDelete || documentUpdate || documentsUpload || documentsLoading || attachmentsLoading || attachmentDelete;
	});
	
	var selectIsLoadingGuardianDependents = exports.selectIsLoadingGuardianDependents = (0, _reselect.createSelector)(selectGuardianDependents, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectGuardianDependentsList = exports.selectGuardianDependentsList = (0, _reselect.createSelector)(selectGuardianDependents, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectVerifiedGuardianDependentsList = exports.selectVerifiedGuardianDependentsList = (0, _reselect.createSelector)(selectGuardianDependentsList, function (list) {
	  return list.filter(function (item) {
	    return (0, _get2.default)(item, 'status') === 'verified';
	  });
	});
	
	var selectGuardianDependentById = exports.selectGuardianDependentById = function selectGuardianDependentById(id) {
	  return (0, _reselect.createSelector)(selectGuardianDependentsList, function (list) {
	    return list.find(function (item) {
	      return item.id === id;
	    });
	  });
	};
	
	var selectDependentStatusById = exports.selectDependentStatusById = function selectDependentStatusById(id) {
	  return (0, _reselect.createSelector)(selectGuardianDependentsList, function (list) {
	    var dependent = list.find(function (item) {
	      return item.dependent.id === id;
	    });
	    if (dependent) return (0, _get2.default)(dependent, 'status');
	  });
	};
	
	var selectIsSignedMainConsentSelector = exports.selectIsSignedMainConsentSelector = function selectIsSignedMainConsentSelector(state) {
	  return (0, _get2.default)(state, 'profiles.getLoggedUser.messagingConsentsAccepted');
	};
	
	var selectMainConsent = exports.selectMainConsent = function selectMainConsent(state) {
	  return (0, _get2.default)(state, 'profiles.getMainConsent.list', null);
	};
	
	var selectPatientContacts = exports.selectPatientContacts = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'addPatientData', {});
	});
	
	var selectPatientPhoneNumberCountryIsoCode = exports.selectPatientPhoneNumberCountryIsoCode = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'addPatientData.contacts.phoneNumberCountryIsoCode', '');
	});
	
	var selectSavedPatientContacts = exports.selectSavedPatientContacts = (0, _reselect.createSelector)(selectPatientContacts, function (state) {
	  return (0, _get2.default)(state, _props.ADD_PATIENT_STEPS.CONTACTS, null);
	});
	
	var selectSavedPatientPersonalInfo = exports.selectSavedPatientPersonalInfo = (0, _reselect.createSelector)(selectPatientContacts, function (state) {
	  return (0, _get2.default)(state, _props.ADD_PATIENT_STEPS.PERSONAL_INFO, null);
	});
	
	var selectSavedPatientAddress = exports.selectSavedPatientAddress = (0, _reselect.createSelector)(selectPatientContacts, function (state) {
	  return (0, _get2.default)(state, _props.ADD_PATIENT_STEPS.ADDRESS, null);
	});
	
	var selectAddedPatientsList = exports.selectAddedPatientsList = (0, _reselect.createSelector)(addPatientByProviderSelector, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectCurrentCountryCode = exports.selectCurrentCountryCode = function selectCurrentCountryCode(state) {
	  return (0, _get2.default)(state, 'profiles.countryCode.currentCountryCode', '+1');
	};
	
	var selectUserPhoneNumberCountryCode = exports.selectUserPhoneNumberCountryCode = function selectUserPhoneNumberCountryCode(state) {
	  return (0, _get2.default)(state, 'profiles.getUser.phoneNumberCountryCode', null);
	};
	
	var selectUserPhoneNumberCountryISOCode = exports.selectUserPhoneNumberCountryISOCode = function selectUserPhoneNumberCountryISOCode(state) {
	  return (0, _get2.default)(state, 'profiles.getUser.phoneNumberCountryIsoCode', null);
	};
	
	var selectUserPrimaryPatientProfile = exports.selectUserPrimaryPatientProfile = function selectUserPrimaryPatientProfile(state) {
	  return (0, _get2.default)(state, 'context.targetUser.primaryPatientProfile', null);
	};
	
	var selectUserMetricForHeight = exports.selectUserMetricForHeight = function selectUserMetricForHeight(state) {
	  return (0, _get2.default)(state, 'context.targetUser.settings.measurementUnitsSettings.height', 'feet_and_inches');
	};
	
	var selectUserMetricForWeight = exports.selectUserMetricForWeight = function selectUserMetricForWeight(state) {
	  return (0, _get2.default)(state, 'context.targetUser.settings.measurementUnitsSettings.weight', 'pounds');
	};
	
	var selectSignupProcessPending = exports.selectSignupProcessPending = (0, _reselect.createSelector)(selectCreatePatientPending, selectEditedUserSending, function (createPatient, editUser) {
	  return createPatient || editUser;
	});
	
	var getMfaConfirmationData = exports.getMfaConfirmationData = function getMfaConfirmationData(state) {
	  return (0, _get2.default)(state, 'profiles.mfaConfirmation', null);
	};
	
	var getEnableMfa = exports.getEnableMfa = function getEnableMfa(state) {
	  return (0, _get2.default)(state, 'profiles.enableMfa', null);
	};
	
	var selectProviderProfile = exports.selectProviderProfile = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'getParentMember');
	});
	
	var selectProviderCalendarManageAccess = exports.selectProviderCalendarManageAccess = (0, _reselect.createSelector)(selectProviderProfile, function (state) {
	  return (0, _get2.default)(state, 'calendarManageable', false);
	});
	
	var selectUser = exports.selectUser = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'getLoggedUser');
	});
	
	var selectShowMfaAfterMobileAppPopup = exports.selectShowMfaAfterMobileAppPopup = (0, _reselect.createSelector)(_selectors3.selectUiPopupContentType, _selectors2.selectRequestPasswordUpdate, selectUser, _selectors2.selectRegistrationCompleted, function (uiPopupContentType, isRequestPasswordUpdate, user, isRegistrationCompleted) {
	  var showMfaNotice = (0, _get2.default)(user, 'showMfaNotice', false);
	  var mfaEnabled = (0, _get2.default)(user, 'mfaEnabled', false);
	
	  return showMfaNotice && !mfaEnabled && !isRequestPasswordUpdate && isRegistrationCompleted && uiPopupContentType === _props.UI_POPUP_TYPES.MOBILE_APP;
	});
	
	var selectManualActivateInsuranceEligibilitySucceed = exports.selectManualActivateInsuranceEligibilitySucceed = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'manualActivateInsuranceEligibility.succeed');
	});
	
	var selectEditPatientEmergencyContactSucceed = exports.selectEditPatientEmergencyContactSucceed = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'editPatientEmergencyContact.succeed', false);
	});
	
	var selectEditPatientEmergencyContactPending = exports.selectEditPatientEmergencyContactPending = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'editPatientEmergencyContact.sending', false);
	});
	
	var selectEditPatientEmergencyContactError = exports.selectEditPatientEmergencyContactError = (0, _reselect.createSelector)(selectProfileState, function (state) {
	  return (0, _get2.default)(state, 'editPatientEmergencyContact.error', false);
	});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMobileTitle = exports.isDesktop = undefined;
	
	var _startCase = __webpack_require__(2353);
	
	var _startCase2 = _interopRequireDefault(_startCase);
	
	var _styles = __webpack_require__(18);
	
	var _pathToTitle = __webpack_require__(4203);
	
	var _pathToTitle2 = _interopRequireDefault(_pathToTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDesktop = exports.isDesktop = function isDesktop() {
	  return !window.matchMedia(_styles.MEDIA_QUERY).matches;
	};
	
	var getMobileTitle = exports.getMobileTitle = function getMobileTitle(userName, path, formatMessage) {
	  var messageDescriptor = path && (0, _pathToTitle2.default)(path);
	  var str = (0, _startCase2.default)(formatMessage(messageDescriptor));
	
	  if (userName && messageDescriptor) {
	    return userName + ': ' + str;
	  }
	
	  return str || userName;
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(140)(module)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(1536),
	    getTag = __webpack_require__(574),
	    isArrayLike = __webpack_require__(247),
	    isString = __webpack_require__(981),
	    stringSize = __webpack_require__(5491);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Gets the size of `collection` by returning its length for array-like
	 * values or the number of own enumerable string keyed properties for objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @returns {number} Returns the collection size.
	 * @example
	 *
	 * _.size([1, 2, 3]);
	 * // => 3
	 *
	 * _.size({ 'a': 1, 'b': 2 });
	 * // => 2
	 *
	 * _.size('pebbles');
	 * // => 7
	 */
	function size(collection) {
	  if (collection == null) {
	    return 0;
	  }
	  if (isArrayLike(collection)) {
	    return isString(collection) ? stringSize(collection) : collection.length;
	  }
	  var tag = getTag(collection);
	  if (tag == mapTag || tag == setTag) {
	    return collection.size;
	  }
	  return baseKeys(collection).length;
	}
	
	module.exports = size;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
	  if (prev === null || next === null || prev.length !== next.length) {
	    return false;
	  }
	
	  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
	  var length = prev.length;
	  for (var i = 0; i < length; i++) {
	    if (!equalityCheck(prev[i], next[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
	
	  var lastArgs = null;
	  var lastResult = null;
	  // we reference arguments instead of spreading them for performance reasons
	  return function () {
	    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
	      // apply arguments instead of spreading for performance.
	      lastResult = func.apply(null, arguments);
	    }
	
	    lastArgs = arguments;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    memoizeOptions[_key - 1] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      funcs[_key2] = arguments[_key2];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      // apply arguments instead of spreading for performance.
	      return resultFunc.apply(null, arguments);
	    }].concat(memoizeOptions));
	
	    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
	    var selector = defaultMemoize(function () {
	      var params = [];
	      var length = dependencies.length;
	
	      for (var i = 0; i < length; i++) {
	        // apply arguments instead of spreading and mutate a local list of params for performance.
	        params.push(dependencies[i].apply(null, arguments));
	      }
	
	      // apply arguments instead of spreading for performance.
	      return memoizedResultFunc.apply(null, params);
	    });
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      values[_key3] = arguments[_key3];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(4301);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(4300);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	
	var _index = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument); // Clone the date
	
	  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
	
	      console.warn(new Error().stack);
	    }
	
	    return new Date(NaN);
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(1626);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isNull = __webpack_require__(732);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _isUndefined = __webpack_require__(733);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _isPlainObject = __webpack_require__(248);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isArray = __webpack_require__(96);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _differenceBy = __webpack_require__(1554);
	
	var _differenceBy2 = _interopRequireDefault(_differenceBy);
	
	var _isEqual = __webpack_require__(325);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DiscardModal = __webpack_require__(1180);
	
	var _DiscardModal2 = _interopRequireDefault(_DiscardModal);
	
	var _overrideReactSelectStyles = __webpack_require__(1935);
	
	var _index = __webpack_require__(5139);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// allow true/false values to be passed
	var checkForPresence = function checkForPresence(value) {
	  return !(0, _isNull2.default)(value) && !(0, _isUndefined2.default)(value);
	};
	
	// TODO: need to check behavior for multi select with objects, adjust options to be {label, value} shape only
	// TODO: it should be one source of truth for selected value, which comes from props
	
	var SelectCustom = function SelectCustom(_ref) {
	  var className = _ref.className,
	      id = _ref.id,
	      label = _ref.label,
	      multi = _ref.multi,
	      required = _ref.required,
	      name = _ref.name,
	      options = _ref.options,
	      placeholder = _ref.placeholder,
	      value = _ref.value,
	      defaultValue = _ref.defaultValue,
	      onChange = _ref.onChange,
	      onBlur = _ref.onBlur,
	      searchable = _ref.searchable,
	      needUpdateDefaultValue = _ref.needUpdateDefaultValue,
	      backspaceRemoves = _ref.backspaceRemoves,
	      deleteRemoves = _ref.deleteRemoves,
	      onCheckBeforeDelete = _ref.onCheckBeforeDelete,
	      disabled = _ref.disabled,
	      readOnly = _ref.readOnly,
	      canSearch = _ref.canSearch,
	      onInputChange = _ref.onInputChange,
	      isLoading = _ref.isLoading,
	      virtualized = _ref.virtualized,
	      onMenuScrollToBottom = _ref.onMenuScrollToBottom,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['className', 'id', 'label', 'multi', 'required', 'name', 'options', 'placeholder', 'value', 'defaultValue', 'onChange', 'onBlur', 'searchable', 'needUpdateDefaultValue', 'backspaceRemoves', 'deleteRemoves', 'onCheckBeforeDelete', 'disabled', 'readOnly', 'canSearch', 'onInputChange', 'isLoading', 'virtualized', 'onMenuScrollToBottom']);
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      selected = _useState2[0],
	      setSelected = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      checkValue = _useState4[0],
	      setCheckValue = _useState4[1];
	
	  var getSelectedValue = (0, _react.useCallback)(function (propsValue, propsDefaultValue) {
	    // simple hack, that should be removed after fixing TODO above
	    if (!propsValue && !propsDefaultValue) {
	      setSelected(multi ? [] : null);
	      return;
	    }
	
	    var valueToUse = checkForPresence(propsDefaultValue) ? propsDefaultValue : propsValue;
	
	    if (needUpdateDefaultValue && (0, _isPlainObject2.default)(valueToUse)) {
	      setSelected(valueToUse);
	      return;
	    }
	
	    if (checkForPresence(valueToUse)) {
	      if (multi && (0, _isArray2.default)(valueToUse)) {
	        var selectedValue = valueToUse.map(function (item) {
	          if ((0, _isPlainObject2.default)(item)) {
	            if (Object.hasOwn(item, 'name')) {
	              return { value: item, label: item.name };
	            }
	
	            return item;
	          }
	          var labelText = (0, _get2.default)(options.filter(function (option) {
	            return option.value === item;
	          }), '[0].label');
	          return { value: item, label: labelText || item };
	        });
	        setSelected(selectedValue);
	      } else {
	        var labelText = (0, _get2.default)(options.filter(function (option) {
	          return option.value === valueToUse;
	        }), '[0].label');
	
	        setSelected({ value: valueToUse, label: labelText || valueToUse });
	      }
	    }
	  }, [multi, options, needUpdateDefaultValue]);
	
	  (0, _react.useEffect)(function () {
	    getSelectedValue(value, defaultValue);
	  }, [value, defaultValue]);
	
	  var getFilteredOptions = (0, _react.useCallback)(function () {
	    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    return opts.filter(function (optionsItem) {
	      if ((0, _isArray2.default)(val)) {
	        return !val.find(function (item) {
	          if ((0, _isPlainObject2.default)(optionsItem.value)) {
	            return optionsItem.value.id === item.value.id;
	          }
	          return optionsItem.value === item.value;
	        });
	      }
	      return true;
	    });
	  }, []);
	
	  var handleChange = (0, _react.useCallback)(function (newValue) {
	    if (onCheckBeforeDelete && (0, _size2.default)(selected) > (0, _size2.default)(newValue)) {
	      var difference = (0, _get2.default)((0, _differenceBy2.default)(selected, newValue), '0', null);
	      if (onCheckBeforeDelete(difference)) {
	        setCheckValue(difference);
	        return;
	      }
	    }
	
	    setSelected(newValue);
	
	    if (onChange) {
	      if (multi && !newValue) {
	        onChange([]);
	        return;
	      }
	
	      onChange(newValue);
	    }
	  }, [onChange, onCheckBeforeDelete, selected, multi]);
	
	  var handleModalSubmit = (0, _react.useCallback)(function () {
	    var updatedSelection = selected.filter(function (item) {
	      return !(0, _isEqual2.default)(checkValue, item);
	    });
	    setSelected(updatedSelection);
	    setCheckValue(null);
	    if (onChange) onChange(updatedSelection);
	  }, [selected, checkValue, onChange]);
	
	  var handleModalCancel = (0, _react.useCallback)(function () {
	    setCheckValue(null);
	  }, []);
	
	  var filteredOptions = (0, _react.useMemo)(function () {
	    var filterSelectOptions = function filterSelectOptions(selectData) {
	      return selectData.filter(function (el) {
	        return el.enabled;
	      });
	    };
	
	    var optionsHaveEnabledAttribute = options && options.some(function (item) {
	      return item.enabled;
	    });
	
	    var updatedOptions = optionsHaveEnabledAttribute ? filterSelectOptions(options) : options;
	
	    return getFilteredOptions(selected, updatedOptions).map(function (option) {
	      return option.label.length > 110 ? (0, _extends3.default)({}, option, { label: option.value.name.slice(0, 110) + '...' }) : option;
	    });
	  }, [options, selected]);
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({
	      id: id
	    }, other, {
	      className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default['root--readOnly'], readOnly), className)
	    }),
	    label && _react2.default.createElement(
	      'label',
	      { className: (0, _classnames2.default)(_index2.default.label, (0, _defineProperty3.default)({}, _index2.default.required, required)) },
	      label
	    ),
	    _react2.default.createElement(_reactSelect2.default, (0, _extends3.default)({}, other, {
	      menuPlacement: 'auto',
	      isMulti: multi,
	      options: filteredOptions,
	      placeholder: placeholder,
	      onBlur: onBlur,
	      searchable: searchable,
	      isDisabled: disabled,
	      clearable: false,
	      name: name || 'form-field-name',
	      onChange: handleChange,
	      value: selected,
	      autoBlur: true,
	      inputProps: { readOnly: !(canSearch || multi) },
	      defaultValue: defaultValue,
	      backspaceRemoves: backspaceRemoves,
	      deleteRemoves: deleteRemoves,
	      onInputChange: onInputChange,
	      isLoading: isLoading,
	      onMenuScrollToBottom: onMenuScrollToBottom,
	      styles: _overrideReactSelectStyles.OverrideReactSelectStyles
	    })),
	    multi && Boolean(checkValue) && _react2.default.createElement(_DiscardModal2.default, {
	      onSubmit: handleModalSubmit,
	      onCancel: handleModalCancel,
	      isOpened: Boolean(checkValue),
	      title: formatMessage({ id: 'profile.fields.removeItem' })
	    })
	  );
	};
	
	SelectCustom.propTypes = {
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  multi: _propTypes2.default.bool,
	  required: _propTypes2.default.bool,
	  name: _propTypes2.default.string,
	  options: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  placeholder: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
	  onChange: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  searchable: _propTypes2.default.bool,
	  needUpdateDefaultValue: _propTypes2.default.bool,
	  backspaceRemoves: _propTypes2.default.bool,
	  deleteRemoves: _propTypes2.default.bool,
	  onCheckBeforeDelete: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  readOnly: _propTypes2.default.bool,
	  canSearch: _propTypes2.default.bool,
	  onInputChange: _propTypes2.default.func,
	  isLoading: _propTypes2.default.bool,
	  virtualized: _propTypes2.default.bool,
	  onMenuScrollToBottom: _propTypes2.default.func
	};
	
	exports.default = SelectCustom;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectSignAppointmentConsentSucceed = exports.selectSignAppointmentConsentLoading = exports.selectCurrentAppointmentAssignment = exports.selectCurrentAppointmentSurveys = exports.selectTestCallModalProps = exports.selectTestCallModalOpened = exports.selectDevicePerissionModalProps = exports.selectDevicePerissionModalOpened = exports.selectCallInvitationsSendError = exports.selectCallInvitationsSendLoading = exports.selectCallInvitationsSendState = exports.selectCurrentAppointmentId = exports.selectCallInvitationsExisting = exports.selectStateInviteUserToVirtualRoom = exports.selectVirtualRoomByCodePending = exports.selectVirtualRoomByCodeError = exports.selectVirtualRoomByCodeData = exports.selectConnectionRoomJoinPending = exports.selectConnectionRoomJoinError = exports.selectConnectionRoomJoinData = exports.selectRoomInvitationRole = exports.selectRoomInvitationInvitee = exports.selectRoomInvitationPatientProfile = exports.selectRoomInvitationJoinStatus = exports.selectRoomInvitationJoinRoomName = exports.makeRoomInvitationSelector = exports.selectRoomInvitationJoinPending = exports.selectRoomInvitationJoinSucceed = exports.selectRoomInvitationJoinError = exports.selectRoomInvitationJoinData = exports.selectRoomInvitationInfoVisitTypeName = exports.selectRoomInvitationInfoCopay = exports.selectRoomInvitationInfoUserId = exports.selectRoomInvitationInfoAppointmentId = exports.selectRoomInvitationInfoPatientName = exports.selectRoomInvitationInfoPaymentRequired = exports.makeRoomInvitationInfoSelect = exports.selectRoomInvitationInfoError = exports.selectRoomInvitationInfoSucceed = exports.selectRoomInvitationInfoData = exports.selectRoomInvitationInfoPending = exports.selectNetworkTestCredentials = exports.selectNetworkTestCredentialsError = exports.selectNetworkTestCredentialsPending = exports.selectCompleteCarePlanTaskError = exports.selectCompleteCarePlanTaskSucceed = exports.selectCompleteCarePlanTaskPending = exports.selectCompleteTaskCustomError = exports.selectCompleteTaskCustomSucceed = exports.selectCompleteTaskCustomPending = undefined;
	exports.selectCompleteTaskError = exports.selectCompleteTaskSucceed = exports.selectCompleteTaskPending = exports.selectVirtualVisitActive = exports.selectShouldSignConsent = exports.selectInvitationTypeFromConfig = exports.selectAppointmentIdFromConfig = exports.selectVirtualVisitConfig = exports.selectVirtualVisitDragging = exports.selectVirtualVisitFullScreenView = exports.selectVirtualVisitCollapsed = exports.selectVirtualVisitMobSidebarOpened = exports.selectVirtualVisitOpened = exports.selectVirtualVisitState = exports.selectActiveTodoItemTaskGeoLocations = exports.selectActiveTodoItemTaskId = exports.selectActiveTodoItem = exports.selectActiveTodoState = exports.selectHealthboardValidation = exports.selectRootSubState = exports.selectManagePendingRequestSending = exports.selectPaymentGlobalLoader = exports.selectPatientUserInfoIdWithAppointmentState = exports.selectIsMainConsentViewState = exports.selectAppointmentAllConsentState = exports.selectAppointmentOrganizationName = exports.selectAppointmentConsentTime = exports.selectAppointmentServiceName = exports.selectAppointmentCurrentConsentState = exports.selectAppointmentConsentsModalOpenRescheduleFlow = exports.selectAppointmentConsentsModalOpenSelfScheduling = exports.selectAppointmentConsentsModalOpenUrgentVisit = exports.selectAppointmentConsentsModalOpen = exports.selectAppointmentConsentsModalState = exports.selectDeleteDocumentError = exports.selectDeleteDocumentPending = exports.selectUploadDocumentError = exports.selectUploadDocumentPending = exports.selectEditPaymentError = exports.selectEditPaymentPending = exports.selectPayaRedirectionPending = exports.selectPaymentOrderAmount = exports.selectPaymentOrderStateData = exports.selectPaymentOrderPending = exports.selectPaymentVerificationPending = exports.selectStatusChangesPending = exports.selectCouponCalculationError = exports.selectCouponCalculationData = exports.selectCouponCalculationPending = exports.selectCouponAvailability = exports.makeCouponVerificationSelect = exports.selectCouponVerificationData = exports.selectCouponVerificationPending = exports.selectProviderActiveAppointment = exports.selectActiveAppointment = exports.selectActiveAppointmentCoupon = exports.selectActiveAppointmentId = exports.selectCancelAppointmentPending = exports.selectCheckInAppointmentPending = exports.selectScheduledCompletedTasksPaginationSending = exports.selectScheduledCompletedTasksCount = exports.selectScheduledCompletedTasksPagination = exports.makeCompletedTasksSelect = exports.selectScheduledCompletedTasks = exports.selectScheduledCompletedTasksPending = exports.selectMetaAvailableScheduledTasks = exports.selectScheduledTasksPaginationSending = exports.selectScheduledTasksCount = exports.selectScheduledTasksPagination = exports.makeScheduledTasksSelect = exports.selectScheduledTasks = exports.selectScheduledTasksPending = exports.selectProviderHistoryCount = exports.selectProviderHistoryPaginationPending = exports.selectProviderHistoryPagination = exports.makeProviderHistoryListSelect = exports.selectProviderHistoryAppointmentList = exports.selectProviderHistoryAppointmentsPending = exports.selectProviderUpcomingCount = exports.selectProviderUpcomingPaginationPending = exports.selectProviderUpcomingPagination = exports.selectProviderUpcomingFilterByTypeVisit = exports.selectProviderUpcomingFilterToday = exports.makeProviderUpcomingListSelect = exports.selectProviderUpcomingAppointmentList = exports.selectProviderUpcomingAppointmentsPending = exports.selectHistoryCount = exports.selectHistoryPagination = exports.selectHistoryPaginationPending = exports.makeHistoryListSelect = exports.selectHistoryAppointmentList = exports.selectHistoryAppointmentsPending = exports.selectMetaAvailableUpcomingList = exports.selectUpcomingCount = exports.selectUpcomingPagination = exports.selectUpcomingPaginationPending = exports.makeUpcomingListSelect = exports.selectUpcomingAppointmentList = exports.selectUpcomingAppointmentsPending = exports.selectRootState = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _reselect = __webpack_require__(60);
	
	var _some = __webpack_require__(986);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectAdapter = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'healthboard');
	};
	var getSelectors = (0, _selectAdapter.makeSelectorFactory)(selectRootState);
	
	/**
	 *  PATIENT UPCOMING APPOINTMENTS
	 * */
	
	var _getSelectors = getSelectors('upcomingAppointments'),
	    selectUpcomingAppointmentsPending = _getSelectors.selectStatePending,
	    selectUpcomingAppointmentList = _getSelectors.selectStateList,
	    makeUpcomingListSelect = _getSelectors.makeSelect;
	
	exports.selectUpcomingAppointmentsPending = selectUpcomingAppointmentsPending;
	exports.selectUpcomingAppointmentList = selectUpcomingAppointmentList;
	exports.makeUpcomingListSelect = makeUpcomingListSelect;
	var selectUpcomingPaginationPending = exports.selectUpcomingPaginationPending = makeUpcomingListSelect('paginationSending');
	var selectUpcomingPagination = exports.selectUpcomingPagination = makeUpcomingListSelect('pagination');
	var selectUpcomingCount = exports.selectUpcomingCount = makeUpcomingListSelect('count', 0);
	var selectMetaAvailableUpcomingList = exports.selectMetaAvailableUpcomingList = makeUpcomingListSelect('meta.historyAvailable', false);
	
	/**
	 *  PATIENT HISTORY APPOINTMENTS
	 * */
	
	var _getSelectors2 = getSelectors('historyAppointments'),
	    selectHistoryAppointmentsPending = _getSelectors2.selectStatePending,
	    selectHistoryAppointmentList = _getSelectors2.selectStateList,
	    makeHistoryListSelect = _getSelectors2.makeSelect;
	
	exports.selectHistoryAppointmentsPending = selectHistoryAppointmentsPending;
	exports.selectHistoryAppointmentList = selectHistoryAppointmentList;
	exports.makeHistoryListSelect = makeHistoryListSelect;
	var selectHistoryPaginationPending = exports.selectHistoryPaginationPending = makeHistoryListSelect('paginationSending');
	var selectHistoryPagination = exports.selectHistoryPagination = makeHistoryListSelect('pagination');
	var selectHistoryCount = exports.selectHistoryCount = makeHistoryListSelect('count', 0);
	
	// =========================================================
	/**
	 *  PROVIDER UPCOMING APPOINTMENTS
	 * */
	
	var _getSelectors3 = getSelectors('providerUpcomingAppointments'),
	    selectProviderUpcomingAppointmentsPending = _getSelectors3.selectStatePending,
	    selectProviderUpcomingAppointmentList = _getSelectors3.selectStateList,
	    makeProviderUpcomingListSelect = _getSelectors3.makeSelect;
	
	/**
	 *  PROVIDER FILTERS UPCOMING APPOINTMENTS
	 * */
	
	
	exports.selectProviderUpcomingAppointmentsPending = selectProviderUpcomingAppointmentsPending;
	exports.selectProviderUpcomingAppointmentList = selectProviderUpcomingAppointmentList;
	exports.makeProviderUpcomingListSelect = makeProviderUpcomingListSelect;
	var selectProviderUpcomingFilterToday = exports.selectProviderUpcomingFilterToday = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'providerFilterUpcomingAppointments.isFilterToday');
	});
	
	var selectProviderUpcomingFilterByTypeVisit = exports.selectProviderUpcomingFilterByTypeVisit = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'providerFilterUpcomingAppointments.isFilterByTypeVisit');
	});
	
	var selectProviderUpcomingPagination = exports.selectProviderUpcomingPagination = makeProviderUpcomingListSelect('pagination');
	var selectProviderUpcomingPaginationPending = exports.selectProviderUpcomingPaginationPending = makeProviderUpcomingListSelect('paginationSending');
	var selectProviderUpcomingCount = exports.selectProviderUpcomingCount = makeProviderUpcomingListSelect('count', 0);
	
	/**
	 *  PROVIDER HISTORY APPOINTMENTS
	 * */
	
	var _getSelectors4 = getSelectors('providerHistoryAppointments'),
	    selectProviderHistoryAppointmentsPending = _getSelectors4.selectStatePending,
	    selectProviderHistoryAppointmentList = _getSelectors4.selectStateList,
	    makeProviderHistoryListSelect = _getSelectors4.makeSelect;
	
	exports.selectProviderHistoryAppointmentsPending = selectProviderHistoryAppointmentsPending;
	exports.selectProviderHistoryAppointmentList = selectProviderHistoryAppointmentList;
	exports.makeProviderHistoryListSelect = makeProviderHistoryListSelect;
	var selectProviderHistoryPagination = exports.selectProviderHistoryPagination = makeProviderHistoryListSelect('pagination');
	var selectProviderHistoryPaginationPending = exports.selectProviderHistoryPaginationPending = makeProviderHistoryListSelect('paginationSending');
	var selectProviderHistoryCount = exports.selectProviderHistoryCount = makeProviderHistoryListSelect('count', 0);
	// =========================================================
	
	/**
	 *  SCHEDULED TASKS LIST
	 * */
	
	var _getSelectors5 = getSelectors('scheduledTasks'),
	    selectScheduledTasksPending = _getSelectors5.selectStatePending,
	    selectScheduledTasks = _getSelectors5.selectStateList,
	    makeScheduledTasksSelect = _getSelectors5.makeSelect;
	
	exports.selectScheduledTasksPending = selectScheduledTasksPending;
	exports.selectScheduledTasks = selectScheduledTasks;
	exports.makeScheduledTasksSelect = makeScheduledTasksSelect;
	var selectScheduledTasksPagination = exports.selectScheduledTasksPagination = makeScheduledTasksSelect('pagination');
	var selectScheduledTasksCount = exports.selectScheduledTasksCount = makeScheduledTasksSelect('count', 0);
	var selectScheduledTasksPaginationSending = exports.selectScheduledTasksPaginationSending = makeScheduledTasksSelect('paginationSending');
	var selectMetaAvailableScheduledTasks = exports.selectMetaAvailableScheduledTasks = makeScheduledTasksSelect('meta.historyAvailable', false);
	
	// =========================================================
	
	/**
	 *  COMPLETED SCHEDULED TASKS LIST
	 * */
	
	var _getSelectors6 = getSelectors('completedTasks'),
	    selectScheduledCompletedTasksPending = _getSelectors6.selectStatePending,
	    selectScheduledCompletedTasks = _getSelectors6.selectStateList,
	    makeCompletedTasksSelect = _getSelectors6.makeSelect;
	
	exports.selectScheduledCompletedTasksPending = selectScheduledCompletedTasksPending;
	exports.selectScheduledCompletedTasks = selectScheduledCompletedTasks;
	exports.makeCompletedTasksSelect = makeCompletedTasksSelect;
	var selectScheduledCompletedTasksPagination = exports.selectScheduledCompletedTasksPagination = makeCompletedTasksSelect('pagination');
	var selectScheduledCompletedTasksCount = exports.selectScheduledCompletedTasksCount = makeCompletedTasksSelect('count', 0);
	var selectScheduledCompletedTasksPaginationSending = exports.selectScheduledCompletedTasksPaginationSending = makeCompletedTasksSelect('paginationSending');
	
	// =========================================================
	
	/**
	 *  CHECK-IN APPOINTMENT
	 * */
	
	var _getSelectors7 = getSelectors('checkinAppointment'),
	    selectCheckInAppointmentPending = _getSelectors7.selectStatePending;
	
	/**
	 *  CANCEL APPOINTMENT
	 * */
	
	exports.selectCheckInAppointmentPending = selectCheckInAppointmentPending;
	
	var _getSelectors8 = getSelectors('cancelAppointment'),
	    selectCancelAppointmentPending = _getSelectors8.selectStatePending;
	
	/**
	 *  APPOINTMENT DETAILS
	 * */
	
	
	exports.selectCancelAppointmentPending = selectCancelAppointmentPending;
	var selectActiveAppointmentState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'appointmentDetails', {});
	});
	var selectActiveAppointmentId = exports.selectActiveAppointmentId = (0, _reselect.createSelector)(selectActiveAppointmentState, function (state) {
	  return (0, _get2.default)(state, 'activeId');
	});
	var selectActiveAppointmentCoupon = exports.selectActiveAppointmentCoupon = (0, _reselect.createSelector)(selectActiveAppointmentState, function (state) {
	  return (0, _get2.default)(state, 'coupon');
	});
	
	var selectActiveAppointment = exports.selectActiveAppointment = (0, _reselect.createSelector)(selectHistoryAppointmentList, selectUpcomingAppointmentList, selectActiveAppointmentId, function (history, upcoming, appointmentId) {
	  if (!appointmentId) return undefined;
	
	  return [].concat((0, _toConsumableArray3.default)(history), (0, _toConsumableArray3.default)(upcoming)).find(function (_ref) {
	    var id = _ref.id;
	    return id === appointmentId;
	  });
	});
	
	var selectProviderActiveAppointment = exports.selectProviderActiveAppointment = (0, _reselect.createSelector)(selectProviderHistoryAppointmentList, selectProviderUpcomingAppointmentList, selectActiveAppointmentId, function (history, upcoming, appointmentId) {
	  if (!appointmentId) return undefined;
	
	  return [].concat((0, _toConsumableArray3.default)(history), (0, _toConsumableArray3.default)(upcoming)).find(function (_ref2) {
	    var id = _ref2.id;
	    return id === appointmentId;
	  });
	});
	
	/**
	 *  COUPON VERIFICATION
	 * */
	
	var _getSelectors9 = getSelectors('couponVerification'),
	    selectCouponVerificationPending = _getSelectors9.selectStatePending,
	    selectCouponVerificationData = _getSelectors9.selectStateData,
	    makeCouponVerificationSelect = _getSelectors9.makeSelect;
	
	exports.selectCouponVerificationPending = selectCouponVerificationPending;
	exports.selectCouponVerificationData = selectCouponVerificationData;
	exports.makeCouponVerificationSelect = makeCouponVerificationSelect;
	var selectCouponAvailability = exports.selectCouponAvailability = makeCouponVerificationSelect('data.couponsAvailable');
	
	/**
	 *  COUPON VERIFICATION
	 * */
	
	var _getSelectors10 = getSelectors('couponCalculation'),
	    selectCouponCalculationPending = _getSelectors10.selectStatePending,
	    selectCouponCalculationData = _getSelectors10.selectStateData,
	    selectCouponCalculationError = _getSelectors10.selectStateError;
	
	/**
	 *  STATUS CHANGES
	 * */
	
	
	exports.selectCouponCalculationPending = selectCouponCalculationPending;
	exports.selectCouponCalculationData = selectCouponCalculationData;
	exports.selectCouponCalculationError = selectCouponCalculationError;
	
	var _getSelectors11 = getSelectors('statusChanges'),
	    selectStatusChangesPending = _getSelectors11.selectStatePending;
	
	/**
	 *  PAYMENT VERIFICATION
	 * */
	
	
	exports.selectStatusChangesPending = selectStatusChangesPending;
	
	var _getSelectors12 = getSelectors('paymentVerifications'),
	    selectPaymentVerificationPending = _getSelectors12.selectStatePending;
	
	/**
	 *  PAYMENT ORDER
	 * */
	
	
	exports.selectPaymentVerificationPending = selectPaymentVerificationPending;
	
	var _getSelectors13 = getSelectors('paymentOrder'),
	    selectPaymentOrderPending = _getSelectors13.selectStatePending,
	    selectPaymentOrderStateData = _getSelectors13.selectStateData;
	
	exports.selectPaymentOrderPending = selectPaymentOrderPending;
	exports.selectPaymentOrderStateData = selectPaymentOrderStateData;
	var selectPaymentOrderAmount = exports.selectPaymentOrderAmount = (0, _reselect.createSelector)(selectPaymentOrderStateData, function (state) {
	  return (0, _get2.default)(state, 'amount', 0);
	});
	
	/**
	 *  PAYA REDIRECTION
	 * */
	
	var _getSelectors14 = getSelectors('payaRedirection'),
	    selectPayaRedirectionPending = _getSelectors14.selectStatePending;
	
	/**
	 *  EDIT PAYMENT
	 * */
	
	
	exports.selectPayaRedirectionPending = selectPayaRedirectionPending;
	
	var _getSelectors15 = getSelectors('editPayment'),
	    selectEditPaymentPending = _getSelectors15.selectStatePending,
	    selectEditPaymentError = _getSelectors15.selectStateError;
	
	/**
	 *  UPLOAD DOCUMENT
	 * */
	
	
	exports.selectEditPaymentPending = selectEditPaymentPending;
	exports.selectEditPaymentError = selectEditPaymentError;
	
	var _getSelectors16 = getSelectors('uploadDocument'),
	    selectUploadDocumentPending = _getSelectors16.selectStatePending,
	    selectUploadDocumentError = _getSelectors16.selectStateError;
	
	/**
	 *  DELETE DOCUMENT
	 * */
	
	
	exports.selectUploadDocumentPending = selectUploadDocumentPending;
	exports.selectUploadDocumentError = selectUploadDocumentError;
	
	var _getSelectors17 = getSelectors('deleteDocument'),
	    selectDeleteDocumentPending = _getSelectors17.selectStatePending,
	    selectDeleteDocumentError = _getSelectors17.selectStateError;
	
	/**
	 *  APPOINTMENT CONSENTS MODAL
	 * */
	
	
	exports.selectDeleteDocumentPending = selectDeleteDocumentPending;
	exports.selectDeleteDocumentError = selectDeleteDocumentError;
	var selectAppointmentConsentsModalState = exports.selectAppointmentConsentsModalState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'appointmentConsentsModal');
	});
	
	var selectAppointmentConsentsModalOpen = exports.selectAppointmentConsentsModalOpen = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'opened', false);
	});
	
	var selectAppointmentConsentsModalOpenUrgentVisit = exports.selectAppointmentConsentsModalOpenUrgentVisit = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'urgentVisitFlow', false);
	});
	
	var selectAppointmentConsentsModalOpenSelfScheduling = exports.selectAppointmentConsentsModalOpenSelfScheduling = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'selfSchedulingFlow', false);
	});
	
	var selectAppointmentConsentsModalOpenRescheduleFlow = exports.selectAppointmentConsentsModalOpenRescheduleFlow = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'rescheduleFlow', {});
	});
	
	var selectAppointmentCurrentConsentState = exports.selectAppointmentCurrentConsentState = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'consent', {});
	});
	
	var selectAppointmentServiceName = exports.selectAppointmentServiceName = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'serviceName', '');
	});
	
	var selectAppointmentConsentTime = exports.selectAppointmentConsentTime = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'startTime', '');
	});
	
	var selectAppointmentOrganizationName = exports.selectAppointmentOrganizationName = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'organizationName', '');
	});
	
	var selectAppointmentAllConsentState = exports.selectAppointmentAllConsentState = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'allConsents', []);
	});
	
	var selectIsMainConsentViewState = exports.selectIsMainConsentViewState = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'isMainConsentView', false);
	});
	
	var selectPatientUserInfoIdWithAppointmentState = exports.selectPatientUserInfoIdWithAppointmentState = (0, _reselect.createSelector)(selectAppointmentConsentsModalState, function (state) {
	  return (0, _get2.default)(state, 'patientUserInfoId', null);
	});
	
	var selectPaymentGlobalLoader = exports.selectPaymentGlobalLoader = (0, _reselect.createSelector)(selectPayaRedirectionPending, selectPaymentOrderPending, selectCouponVerificationPending, selectPaymentVerificationPending, selectCheckInAppointmentPending, selectCancelAppointmentPending, selectEditPaymentPending, selectUploadDocumentPending, selectDeleteDocumentPending, selectStatusChangesPending, function () {
	  for (var _len = arguments.length, pendings = Array(_len), _key = 0; _key < _len; _key++) {
	    pendings[_key] = arguments[_key];
	  }
	
	  return (0, _some2.default)(pendings, function (pending) {
	    return pending;
	  });
	});
	
	/**
	 *  MANAGE PENDING REQUEST
	 * */
	
	var selectManagePendingRequestSending = exports.selectManagePendingRequestSending = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'managePendingRequest.sending', false);
	});
	
	/**
	 *  ROOT
	 * */
	var selectRootSubState = exports.selectRootSubState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'root', {});
	});
	var selectHealthboardValidation = exports.selectHealthboardValidation = (0, _reselect.createSelector)(selectRootSubState, function (state) {
	  return (0, _get2.default)(state, 'validating');
	});
	
	/**
	 *  ACTIVE T0D0 item
	 * */
	var selectActiveTodoState = exports.selectActiveTodoState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'activeTodo', {});
	});
	var selectActiveTodoItem = exports.selectActiveTodoItem = (0, _reselect.createSelector)(selectActiveTodoState, function (state) {
	  return (0, _get2.default)(state, 'activeItem');
	});
	
	var selectActiveTodoItemTaskId = exports.selectActiveTodoItemTaskId = (0, _reselect.createSelector)(selectActiveTodoState, function (state) {
	  return (0, _get2.default)(state, 'activeItem.todoTask.id', null);
	});
	
	var selectActiveTodoItemTaskGeoLocations = exports.selectActiveTodoItemTaskGeoLocations = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'geoLocations.list', []);
	});
	
	// VIRTUAL VISIT UI
	var selectVirtualVisitState = exports.selectVirtualVisitState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'virtualVisit', {});
	});
	
	var selectVirtualVisitOpened = exports.selectVirtualVisitOpened = (0, _reselect.createSelector)(selectVirtualVisitState, function (state) {
	  return (0, _get2.default)(state, 'opened', false);
	});
	var selectVirtualVisitMobSidebarOpened = exports.selectVirtualVisitMobSidebarOpened = (0, _reselect.createSelector)(selectVirtualVisitState, function (state) {
	  return (0, _get2.default)(state, 'isOpenedMobSidebar', false);
	});
	var selectVirtualVisitCollapsed = exports.selectVirtualVisitCollapsed = (0, _reselect.createSelector)(selectVirtualVisitState, function (state) {
	  return (0, _get2.default)(state, 'collapsed', false);
	});
	
	var selectVirtualVisitFullScreenView = exports.selectVirtualVisitFullScreenView = (0, _reselect.createSelector)(selectVirtualVisitState, function (state) {
	  return (0, _get2.default)(state, 'fullScreenView', false);
	});
	
	var selectVirtualVisitDragging = exports.selectVirtualVisitDragging = (0, _reselect.createSelector)(selectVirtualVisitState, function (state) {
	  return (0, _get2.default)(state, 'dragging', false);
	});
	
	var selectVirtualVisitConfig = exports.selectVirtualVisitConfig = (0, _reselect.createSelector)(selectVirtualVisitState, function (state) {
	  return (0, _get2.default)(state, 'config');
	});
	var selectAppointmentIdFromConfig = exports.selectAppointmentIdFromConfig = (0, _reselect.createSelector)(selectVirtualVisitConfig, function (config) {
	  return (0, _get2.default)(config, 'appointmentId');
	});
	var selectInvitationTypeFromConfig = exports.selectInvitationTypeFromConfig = (0, _reselect.createSelector)(selectVirtualVisitConfig, function (config) {
	  return (0, _get2.default)(config, 'type');
	});
	
	var selectShouldSignConsent = exports.selectShouldSignConsent = (0, _reselect.createSelector)(selectVirtualVisitConfig, function (state) {
	  return (0, _get2.default)(state, 'shouldSignConsent');
	});
	
	var selectVirtualVisitActive = exports.selectVirtualVisitActive = (0, _reselect.createSelector)(selectVirtualVisitState, function (state) {
	  return (0, _get2.default)(state, 'active', false);
	});
	
	/**
	 *  COMPLETE TASK
	 * */
	
	var _getSelectors18 = getSelectors('completeTask'),
	    selectCompleteTaskPending = _getSelectors18.selectStatePending,
	    selectCompleteTaskSucceed = _getSelectors18.selectStateSucceed,
	    selectCompleteTaskError = _getSelectors18.selectStateError;
	
	exports.selectCompleteTaskPending = selectCompleteTaskPending;
	exports.selectCompleteTaskSucceed = selectCompleteTaskSucceed;
	exports.selectCompleteTaskError = selectCompleteTaskError;
	
	var _getSelectors19 = getSelectors('completeTaskCustom'),
	    selectCompleteTaskCustomPending = _getSelectors19.selectStatePending,
	    selectCompleteTaskCustomSucceed = _getSelectors19.selectStateSucceed,
	    selectCompleteTaskCustomError = _getSelectors19.selectStateError;
	
	exports.selectCompleteTaskCustomPending = selectCompleteTaskCustomPending;
	exports.selectCompleteTaskCustomSucceed = selectCompleteTaskCustomSucceed;
	exports.selectCompleteTaskCustomError = selectCompleteTaskCustomError;
	
	var _getSelectors20 = getSelectors('completeCarePlanTask'),
	    selectCompleteCarePlanTaskPending = _getSelectors20.selectStatePending,
	    selectCompleteCarePlanTaskSucceed = _getSelectors20.selectStateSucceed,
	    selectCompleteCarePlanTaskError = _getSelectors20.selectStateError;
	
	/**
	 *  TEST CALL CREDENTIALS
	 * */
	
	
	exports.selectCompleteCarePlanTaskPending = selectCompleteCarePlanTaskPending;
	exports.selectCompleteCarePlanTaskSucceed = selectCompleteCarePlanTaskSucceed;
	exports.selectCompleteCarePlanTaskError = selectCompleteCarePlanTaskError;
	
	var _getSelectors21 = getSelectors('networkTestCredentials'),
	    selectNetworkTestCredentialsPending = _getSelectors21.selectStatePending,
	    selectNetworkTestCredentialsError = _getSelectors21.selectStateError,
	    selectNetworkTestCredentials = _getSelectors21.selectStateData;
	
	/**
	 *  ROOM INVITATION INFO (pre-join payment check)
	 * */
	
	
	exports.selectNetworkTestCredentialsPending = selectNetworkTestCredentialsPending;
	exports.selectNetworkTestCredentialsError = selectNetworkTestCredentialsError;
	exports.selectNetworkTestCredentials = selectNetworkTestCredentials;
	
	var _getSelectors22 = getSelectors('roomInvitationInfo'),
	    selectRoomInvitationInfoPending = _getSelectors22.selectStatePending,
	    selectRoomInvitationInfoData = _getSelectors22.selectStateData,
	    selectRoomInvitationInfoSucceed = _getSelectors22.selectStateSucceed,
	    selectRoomInvitationInfoError = _getSelectors22.selectStateError,
	    makeRoomInvitationInfoSelect = _getSelectors22.makeSelect;
	
	exports.selectRoomInvitationInfoPending = selectRoomInvitationInfoPending;
	exports.selectRoomInvitationInfoData = selectRoomInvitationInfoData;
	exports.selectRoomInvitationInfoSucceed = selectRoomInvitationInfoSucceed;
	exports.selectRoomInvitationInfoError = selectRoomInvitationInfoError;
	exports.makeRoomInvitationInfoSelect = makeRoomInvitationInfoSelect;
	var selectRoomInvitationInfoPaymentRequired = exports.selectRoomInvitationInfoPaymentRequired = makeRoomInvitationInfoSelect('meta.isRequiredPayment', false);
	
	var selectRoomInvitationInfoPatientName = exports.selectRoomInvitationInfoPatientName = (0, _reselect.createSelector)(selectRoomInvitationInfoData, function (data) {
	  return (0, _get2.default)(data, 'patientUserInfo.displayableName', '');
	});
	
	var selectRoomInvitationInfoAppointmentId = exports.selectRoomInvitationInfoAppointmentId = (0, _reselect.createSelector)(selectRoomInvitationInfoData, function (data) {
	  return (0, _get2.default)(data, 'id', null);
	});
	
	var selectRoomInvitationInfoUserId = exports.selectRoomInvitationInfoUserId = (0, _reselect.createSelector)(selectRoomInvitationInfoData, function (data) {
	  return (0, _get2.default)(data, 'userId', null);
	});
	
	var selectRoomInvitationInfoCopay = exports.selectRoomInvitationInfoCopay = (0, _reselect.createSelector)(selectRoomInvitationInfoData, function (data) {
	  return (0, _get2.default)(data, 'copay', null);
	});
	
	var selectRoomInvitationInfoVisitTypeName = exports.selectRoomInvitationInfoVisitTypeName = (0, _reselect.createSelector)(selectRoomInvitationInfoData, function (data) {
	  return (0, _get2.default)(data, 'visitType.name', '');
	});
	
	/**
	 *  ROOM INVITATION JOIN
	 * */
	
	var _getSelectors23 = getSelectors('roomInvitationJoin'),
	    selectRoomInvitationJoinData = _getSelectors23.selectStateData,
	    selectRoomInvitationJoinError = _getSelectors23.selectStateError,
	    selectRoomInvitationJoinSucceed = _getSelectors23.selectStateSucceed,
	    selectRoomInvitationJoinPending = _getSelectors23.selectStatePending,
	    makeRoomInvitationSelector = _getSelectors23.makeSelect;
	
	exports.selectRoomInvitationJoinData = selectRoomInvitationJoinData;
	exports.selectRoomInvitationJoinError = selectRoomInvitationJoinError;
	exports.selectRoomInvitationJoinSucceed = selectRoomInvitationJoinSucceed;
	exports.selectRoomInvitationJoinPending = selectRoomInvitationJoinPending;
	exports.makeRoomInvitationSelector = makeRoomInvitationSelector;
	var selectRoomInvitationJoinRoomName = exports.selectRoomInvitationJoinRoomName = (0, _reselect.createSelector)(selectRoomInvitationJoinData, function (state) {
	  return (0, _get2.default)(state, 'patientUserInfo.displayableName', '');
	});
	
	var selectRoomInvitationJoinStatus = exports.selectRoomInvitationJoinStatus = (0, _reselect.createSelector)(selectRoomInvitationJoinData, function (state) {
	  return (0, _get2.default)(state, 'status.coreAppName');
	});
	
	var selectRoomInvitationPatientProfile = exports.selectRoomInvitationPatientProfile = makeRoomInvitationSelector('meta.patientProfile', null);
	
	var selectRoomInvitationInvitee = exports.selectRoomInvitationInvitee = makeRoomInvitationSelector('meta.roomInvitation.invitee', null);
	
	var selectRoomInvitationRole = exports.selectRoomInvitationRole = makeRoomInvitationSelector('meta.roomInvitation.role', null);
	
	/**
	 *   CONNECTION ROOM JOIN
	 * */
	
	var _getSelectors24 = getSelectors('connectionRoomJoin'),
	    selectConnectionRoomJoinData = _getSelectors24.selectStateData,
	    selectConnectionRoomJoinError = _getSelectors24.selectStateError,
	    selectConnectionRoomJoinPending = _getSelectors24.selectStatePending;
	
	/**
	 *   JOIN ROOM BY CODE
	 * */
	
	
	exports.selectConnectionRoomJoinData = selectConnectionRoomJoinData;
	exports.selectConnectionRoomJoinError = selectConnectionRoomJoinError;
	exports.selectConnectionRoomJoinPending = selectConnectionRoomJoinPending;
	
	var _getSelectors25 = getSelectors('joinByVisitCode'),
	    selectVirtualRoomByCodeData = _getSelectors25.selectStateData,
	    selectVirtualRoomByCodeError = _getSelectors25.selectStateError,
	    selectVirtualRoomByCodePending = _getSelectors25.selectStatePending;
	
	/**
	 *  INVITE GUEST TO VIRTUAL ROOM
	 * */
	
	
	exports.selectVirtualRoomByCodeData = selectVirtualRoomByCodeData;
	exports.selectVirtualRoomByCodeError = selectVirtualRoomByCodeError;
	exports.selectVirtualRoomByCodePending = selectVirtualRoomByCodePending;
	
	var _getSelectors26 = getSelectors('inviteUserToVirtualRoom'),
	    selectStateInviteUserToVirtualRoom = _getSelectors26.selectState;
	
	exports.selectStateInviteUserToVirtualRoom = selectStateInviteUserToVirtualRoom;
	var selectCallInvitationsExisting = exports.selectCallInvitationsExisting = (0, _reselect.createSelector)(selectStateInviteUserToVirtualRoom, function (data) {
	  return (0, _get2.default)(data, 'existing');
	});
	
	var selectCurrentAppointmentId = exports.selectCurrentAppointmentId = (0, _reselect.createSelector)(selectStateInviteUserToVirtualRoom, function (data) {
	  return (0, _get2.default)(data, 'appointmentId');
	});
	
	var selectCallInvitationsSendState = exports.selectCallInvitationsSendState = (0, _reselect.createSelector)(selectStateInviteUserToVirtualRoom, function (data) {
	  return (0, _get2.default)(data, 'send');
	});
	var selectCallInvitationsSendLoading = exports.selectCallInvitationsSendLoading = (0, _reselect.createSelector)(selectCallInvitationsSendState, function (data) {
	  return (0, _get2.default)(data, 'sending');
	});
	var selectCallInvitationsSendError = exports.selectCallInvitationsSendError = (0, _reselect.createSelector)(selectCallInvitationsSendState, function (data) {
	  return (0, _get2.default)(data, 'error');
	});
	
	/**
	 *  DEVICE PERMISSIONS
	 * */
	
	var selectDevicePermissionState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'devicePermissions', {});
	});
	var selectDevicePerissionModalOpened = exports.selectDevicePerissionModalOpened = (0, _reselect.createSelector)(selectDevicePermissionState, function (state) {
	  return (0, _get2.default)(state, 'opened');
	});
	var selectDevicePerissionModalProps = exports.selectDevicePerissionModalProps = (0, _reselect.createSelector)(selectDevicePermissionState, function (state) {
	  return (0, _get2.default)(state, 'props', {});
	});
	
	/**
	 *  TEST CALL
	 * */
	
	var selectTestCallState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'testCall', {});
	});
	var selectTestCallModalOpened = exports.selectTestCallModalOpened = (0, _reselect.createSelector)(selectTestCallState, function (state) {
	  return (0, _get2.default)(state, 'opened');
	});
	var selectTestCallModalProps = exports.selectTestCallModalProps = (0, _reselect.createSelector)(selectTestCallState, function (state) {
	  return (0, _get2.default)(state, 'props', {});
	});
	
	/**
	 *  APPOINTMENT SURVEY ASSIGNMENT
	 * */
	var selectCurrentAppointmentSurveys = exports.selectCurrentAppointmentSurveys = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'appointmentSurveyAssignment.surveys', []);
	});
	
	var selectCurrentAppointmentAssignment = exports.selectCurrentAppointmentAssignment = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'appointmentSurveyAssignment.assignmentId', null);
	});
	
	/**
	 *  SIGN APPOINTMENT CONSENT
	 * */
	
	var selectSignAppointmentConsentLoading = exports.selectSignAppointmentConsentLoading = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'signAppointmentConsent.sending', false);
	});
	
	var selectSignAppointmentConsentSucceed = exports.selectSignAppointmentConsentSucceed = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'signAppointmentConsent.succeed', false);
	});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	tslib_1.__exportStar(__webpack_require__(2965), exports);
	tslib_1.__exportStar(__webpack_require__(1679), exports);
	tslib_1.__exportStar(__webpack_require__(2966), exports);
	tslib_1.__exportStar(__webpack_require__(1078), exports);
	tslib_1.__exportStar(__webpack_require__(388), exports);
	tslib_1.__exportStar(__webpack_require__(2967), exports);
	tslib_1.__exportStar(__webpack_require__(487), exports);
	tslib_1.__exportStar(__webpack_require__(1079), exports);
	tslib_1.__exportStar(__webpack_require__(1680), exports);
	tslib_1.__exportStar(__webpack_require__(2968), exports);
	tslib_1.__exportStar(__webpack_require__(1080), exports);
	tslib_1.__exportStar(__webpack_require__(1681), exports);
	tslib_1.__exportStar(__webpack_require__(2969), exports);
	tslib_1.__exportStar(__webpack_require__(2971), exports);
	tslib_1.__exportStar(__webpack_require__(1081), exports);
	tslib_1.__exportStar(__webpack_require__(1082), exports);
	tslib_1.__exportStar(__webpack_require__(1682), exports);
	tslib_1.__exportStar(__webpack_require__(1683), exports);
	tslib_1.__exportStar(__webpack_require__(2972), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CALL_STATUS_TYPE = exports.CALL_INFORMATION_TYPE = exports.ALLOW_SOCIAL_CHAT_CREATION = exports.CHATS_FILTER_TYPES = exports.TEAM_ICON = exports.CONTEXT_CHAT_ICON = exports.ICON_BLOCK = exports.attachmentUrlResolver = exports.ICONS = exports.VALID_FILE_EXTENSIONS = exports.ALLOWED_ATTACHMENT_FORMATS = exports.MAX_ATTACHMENT_SIZE_ALLOWED = exports.NEW_MESSAGE_ERRORS = exports.NOTIFICATION_TYPES = exports.MESSAGE_TYPES = exports.PROVIDER_ROLE = exports.GENERAL_ROLE = exports.NOTIFICATIONS_CHANNEL = exports.ACTIVITIES_CHANNEL = exports.PRACTICE_CHANNEL = exports.SYSTEM_CHANNEL = exports.PRIVATE_CHANNEL = exports.GROUP_CHANNEL = exports.CHANNEL_NAME_SEPARATOR = exports.FAMILY_CHANNEL = exports.IMAGE_PREVIEW_WIDTH = exports.MESSAGE_MAX_LENGTH = exports.INFINITE_SCROLL_LOADER_HEIGHT = exports.INFINITE_SCROLL_LOAD_EDGE_OFFSET = undefined;
	
	var _env = __webpack_require__(103);
	
	var _styles = __webpack_require__(18);
	
	var INFINITE_SCROLL_LOAD_EDGE_OFFSET = exports.INFINITE_SCROLL_LOAD_EDGE_OFFSET = 150;
	var INFINITE_SCROLL_LOADER_HEIGHT = exports.INFINITE_SCROLL_LOADER_HEIGHT = 100;
	
	var MESSAGE_MAX_LENGTH = exports.MESSAGE_MAX_LENGTH = 2000;
	var IMAGE_PREVIEW_WIDTH = exports.IMAGE_PREVIEW_WIDTH = 300;
	
	var FAMILY_CHANNEL = exports.FAMILY_CHANNEL = 'familyCircle';
	var CHANNEL_NAME_SEPARATOR = exports.CHANNEL_NAME_SEPARATOR = ':user-';
	var GROUP_CHANNEL = exports.GROUP_CHANNEL = 'group';
	var PRIVATE_CHANNEL = exports.PRIVATE_CHANNEL = 'private';
	var SYSTEM_CHANNEL = exports.SYSTEM_CHANNEL = 'system';
	var PRACTICE_CHANNEL = exports.PRACTICE_CHANNEL = 'practice';
	var ACTIVITIES_CHANNEL = exports.ACTIVITIES_CHANNEL = 'activities';
	var NOTIFICATIONS_CHANNEL = exports.NOTIFICATIONS_CHANNEL = 'notifications';
	var GENERAL_ROLE = exports.GENERAL_ROLE = 'general';
	var PROVIDER_ROLE = exports.PROVIDER_ROLE = 'provider';
	
	var MESSAGE_TYPES = exports.MESSAGE_TYPES = {
	  TEXT: 'text_message',
	  NOTIFICATION: 'notification_message',
	  ATTACHMENT: 'attachment_message',
	  REMINDER: 'reminder',
	  UPLOAD_ATTACHMENT: 'upload_attachment',
	  LINK_PREVIEW: 'link_preview_message'
	};
	
	var NOTIFICATION_TYPES = exports.NOTIFICATION_TYPES = {
	  PARTICIPANT_ADDED: 'participant_added',
	  PARTICIPANT_REMOVED: 'participant_removed',
	  PROVIDER_ASSIGNED: 'provider_assigned_to_patient',
	  PROVIDER_REMOVED: 'provider_removed_from_patient',
	  SYSTEM: 'opening_message',
	  UPCOMING_SURVEY: 'upcoming_survey',
	  ANSWERED_SURVEY: 'competed_survey',
	  HEALTH_ALERT: 'health_alert',
	  ASSIGN_TO_PROGRAM: 'adding_patient_to_program',
	  REMOVE_FROM_PROGRAM: 'removing_patient_from_program',
	  AUTO_RESPONSE: 'automated_response',
	  FAMILY_MEMBER: 'family_member_assigned_to_patient',
	  PRACTICE_REMOVED: 'practice_removed'
	};
	
	var NEW_MESSAGE_ERRORS = exports.NEW_MESSAGE_ERRORS = {
	  MESSAGE_LONG: 'MESSAGE_LONG',
	  ATTACHMENT_MAX_SIZE: 'ATTACHMENT_MAX_SIZE',
	  ATTACHMENT_NOT_ALLOWED_FORMAT: 'ATTACHMENT_NOT_ALLOWED_FORMAT',
	  ATTACHMENT_MAX_NUMBER: 'ATTACHMENT_MAX_NUMBER'
	};
	
	var MAX_ATTACHMENT_SIZE_ALLOWED = exports.MAX_ATTACHMENT_SIZE_ALLOWED = 50;
	
	// not used right now.
	var ALLOWED_ATTACHMENT_FORMATS = exports.ALLOWED_ATTACHMENT_FORMATS = ['text/plain', 'text/rtf', 'text/xml', 'text/x-vcard', 'image/jpg', 'image/jpeg', 'image/png', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'video/quicktime', 'video/mp4'];
	
	var VALID_FILE_EXTENSIONS = exports.VALID_FILE_EXTENSIONS = ['jpg', 'png', 'pdf', 'docx', 'xlsx', 'pptx', 'rtf', 'txt', 'xml', 'mov', 'mp4', 'vcf'];
	
	var ICONS = exports.ICONS = {
	  generalChatTab: 'chat-general',
	  familyChatTab: 'chat-family',
	  providersChatTab: 'chat-provider',
	  activitiesChatTab: 'chat-activities',
	  notificationsChatTab: 'chat-notifications',
	  personalChatTab: 'chat-personal',
	  groupChatTab: 'chat-group'
	};
	
	var attachmentUrlResolver = exports.attachmentUrlResolver = function attachmentUrlResolver(token, id) {
	  return _env.CHAT_ATTACHMENTS_URI + '/show/' + token + '/' + id;
	};
	
	var ICON_BLOCK = exports.ICON_BLOCK = {
	  name: 'icon-lock',
	  width: 12,
	  height: 16,
	  fill: _styles.COLORS.orangeCoral
	};
	
	var CONTEXT_CHAT_ICON = exports.CONTEXT_CHAT_ICON = {
	  name: 'context-chat',
	  width: 11,
	  height: 15,
	  fill: _styles.COLORS.bluePrimary
	};
	
	var TEAM_ICON = exports.TEAM_ICON = {
	  name: 'team',
	  width: 16,
	  height: 16,
	  fill: _styles.COLORS.orangeCoral
	};
	
	var CHATS_FILTER_TYPES = exports.CHATS_FILTER_TYPES = {
	  PROVIDER: 'provider',
	  PATIENT: 'patient',
	  SOCIAL: 'social',
	  DEFAULT: 'all'
	};
	
	var ALLOW_SOCIAL_CHAT_CREATION = exports.ALLOW_SOCIAL_CHAT_CREATION = false;
	
	var CALL_INFORMATION_TYPE = exports.CALL_INFORMATION_TYPE = 'call_ended';
	
	var CALL_STATUS_TYPE = exports.CALL_STATUS_TYPE = {
	  END: 'end',
	  MISSED: 'missed',
	  REJECTED: 'rejected'
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createAction = undefined;
	
	var _merge = __webpack_require__(379);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createAction = exports.createAction = function createAction(type) {
	  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (payload) {
	    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    return (0, _merge2.default)({}, defaults, {
	      type: type,
	      payload: payload,
	      meta: meta
	    });
	  };
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _index = __webpack_require__(2277);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _getText = __webpack_require__(1939);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderErrors = function renderErrors(errors, formatMessage) {
	  if (Array.isArray(errors)) {
	    return errors.map(function (error, i, arr) {
	      var isLastItem = i < arr.length - 1;
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: (0, _classnames2.default)({ mb1: isLastItem }) },
	        (0, _getText.getText)(error, formatMessage)
	      );
	    });
	  }
	
	  return errors;
	}; /* eslint-disable react/require-default-props,react/no-array-index-key */
	
	
	var ErrorBlock = function ErrorBlock(_ref) {
	  var errors = _ref.errors,
	      style = _ref.style,
	      className = _ref.className,
	      intl = _ref.intl;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('ErrorBlock', className),
	      styleName: 'errorMsg',
	      style: style
	    },
	    renderErrors(errors, intl.formatMessage)
	  );
	};
	
	ErrorBlock.propTypes = {
	  errors: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string, _propTypes2.default.node]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(ErrorBlock, _index2.default, { allowMultiple: true }));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4346), __esModule: true };

/***/ }),
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * core-decorators.js
	 * (c) 2016 Jay Phelps and contributors
	 * MIT Licensed
	 * https://github.com/jayphelps/core-decorators.js
	 * @license
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _override = __webpack_require__(4327);
	
	exports.override = _interopRequire(_override);
	
	var _deprecate = __webpack_require__(4320);
	
	exports.deprecate = _interopRequire(_deprecate);
	exports.deprecated = _interopRequire(_deprecate);
	
	var _suppressWarnings = __webpack_require__(4329);
	
	exports.suppressWarnings = _interopRequire(_suppressWarnings);
	
	var _memoize = __webpack_require__(4323);
	
	exports.memoize = _interopRequire(_memoize);
	
	var _autobind = __webpack_require__(4317);
	
	exports.autobind = _interopRequire(_autobind);
	
	var _readonly = __webpack_require__(4328);
	
	exports.readonly = _interopRequire(_readonly);
	
	var _enumerable = __webpack_require__(4321);
	
	exports.enumerable = _interopRequire(_enumerable);
	
	var _nonenumerable = __webpack_require__(4326);
	
	exports.nonenumerable = _interopRequire(_nonenumerable);
	
	var _nonconfigurable = __webpack_require__(4325);
	
	exports.nonconfigurable = _interopRequire(_nonconfigurable);
	
	var _debounce = __webpack_require__(4318);
	
	exports.debounce = _interopRequire(_debounce);
	
	var _throttle = __webpack_require__(4330);
	
	exports.throttle = _interopRequire(_throttle);
	
	var _decorate = __webpack_require__(4319);
	
	exports.decorate = _interopRequire(_decorate);
	
	var _mixin = __webpack_require__(4324);
	
	exports.mixin = _interopRequire(_mixin);
	exports.mixins = _interopRequire(_mixin);
	
	var _lazyInitialize = __webpack_require__(2114);
	
	exports.lazyInitialize = _interopRequire(_lazyInitialize);
	
	var _time = __webpack_require__(4331);
	
	exports.time = _interopRequire(_time);
	
	var _extendDescriptor = __webpack_require__(4322);
	
	exports.extendDescriptor = _interopRequire(_extendDescriptor);
	
	// Helper to apply decorators to a class without transpiler support
	
	var _applyDecorators = __webpack_require__(4316);
	
	exports.applyDecorators = _interopRequire(_applyDecorators);

/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable react/require-default-props,react/destructuring-assignment */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(4928);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ClickableElement = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
	  (0, _inherits3.default)(ClickableElement, _Component);
	
	  function ClickableElement() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickableElement);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickableElement.__proto__ || (0, _getPrototypeOf2.default)(ClickableElement)).call.apply(_ref, [this].concat(args))), _this), _this.el = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickableElement, [{
	    key: 'handleMouseUp',
	    value: function handleMouseUp() {
	      this.el.blur();
	    }
	  }, {
	    key: 'handleKeyDown',
	    value: function handleKeyDown(e) {
	      var code = e.which;
	
	      // trigger return/space keys
	      if (code === 13 || code === 32) {
	        this.el.click();
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      if (!this.props.disabled && this.props.onClick) this.props.onClick(event);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          hoverable = _props.hoverable,
	          disabled = _props.disabled,
	          onClick = _props.onClick,
	          ariaLabel = _props.ariaLabel,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'hoverable', 'disabled', 'onClick', 'ariaLabel']);
	
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, (0, _extends3.default)({ children: children, className: className }, other), {
	        onClick: this.handleClick,
	        role: 'button',
	        styleName: (0, _classnames2.default)('root', {
	          'root--hoverable': hoverable,
	          disabled: disabled
	        }),
	        tabIndex: '0',
	        ref: function ref(node) {
	          return _this2.el = node;
	        },
	        onMouseUp: this.handleMouseUp,
	        onKeyDown: this.handleKeyDown,
	        'aria-label': ariaLabel || ''
	      }));
	    }
	  }]);
	  return ClickableElement;
	}(_react.Component), _class3.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]),
	  onClick: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  hoverable: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  ariaLabel: _propTypes2.default.string
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleMouseUp', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleMouseUp'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleKeyDown', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleKeyDown'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleClick', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class);
	exports.default = ClickableElement;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.showDependentCreateModal = exports.socialChatAlertAction = exports.unassignedAction = exports.reportActions = exports.hideMfaNoticePopup = exports.showMfaNoticePopup = exports.hideMobileAppPopup = exports.showMobileAppPopup = exports.hideLoaderInPopup = exports.showLoaderInPopup = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _camelCase = __webpack_require__(322);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _redux = __webpack_require__(7);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'popup', 'SHOW', 'HIDE', 'TOGGLE_CONTENT');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var getReportAction = function getReportAction(type) {
	  return function (id) {
	    return {
	      type: consts.SHOW,
	      payload: {
	        contentType: _props.UI_POPUP_TYPES.REPORT,
	        contentOptions: {
	          resource: type,
	          id: id
	        }
	      }
	    };
	  };
	};
	
	var createCustomActions = function createCustomActions(types, func) {
	  return (0, _keys2.default)(types).reduce(function (acc, action) {
	    var key = (0, _camelCase2.default)(action);
	    acc[key] = func(key);
	    return acc;
	  }, {});
	};
	
	var showLoaderInPopup = exports.showLoaderInPopup = function showLoaderInPopup() {
	  return {
	    type: consts.SHOW,
	    payload: { contentType: _props.UI_POPUP_TYPES.LOADER }
	  };
	};
	
	var hideLoaderInPopup = exports.hideLoaderInPopup = function hideLoaderInPopup() {
	  return {
	    type: consts.HIDE,
	    payload: { contentType: _props.UI_POPUP_TYPES.LOADER }
	  };
	};
	
	var showMobileAppPopup = exports.showMobileAppPopup = function showMobileAppPopup() {
	  return {
	    type: consts.SHOW,
	    payload: { contentType: _props.UI_POPUP_TYPES.MOBILE_APP }
	  };
	};
	
	var hideMobileAppPopup = exports.hideMobileAppPopup = function hideMobileAppPopup() {
	  return {
	    type: consts.HIDE,
	    payload: { contentType: _props.UI_POPUP_TYPES.MOBILE_APP }
	  };
	};
	
	var showMfaNoticePopup = exports.showMfaNoticePopup = function showMfaNoticePopup() {
	  return {
	    type: consts.SHOW,
	    payload: { contentType: _props.UI_POPUP_TYPES.MFA_NOTICE }
	  };
	};
	
	var hideMfaNoticePopup = exports.hideMfaNoticePopup = function hideMfaNoticePopup() {
	  return {
	    type: consts.HIDE,
	    payload: { contentType: _props.UI_POPUP_TYPES.MFA_NOTICE }
	  };
	};
	
	var reportActions = exports.reportActions = createCustomActions(_props.REPORT_RESOURCES, getReportAction);
	
	var unassignedAction = exports.unassignedAction = function unassignedAction() {
	  return {
	    type: consts.SHOW,
	    payload: {
	      contentType: _props.UI_POPUP_TYPES.MESSAGE,
	      contentOptions: {
	        message: { id: 'circle.confirmUnassigned' }
	      }
	    }
	  };
	};
	
	var socialChatAlertAction = exports.socialChatAlertAction = function socialChatAlertAction() {
	  return {
	    type: consts.SHOW,
	    payload: {
	      contentType: _props.UI_POPUP_TYPES.MESSAGE,
	      contentOptions: {
	        icon: 'information',
	        message: { id: 'intro.messages.socialChatArchived' }
	      }
	    }
	  };
	};
	
	var showDependentCreateModal = exports.showDependentCreateModal = function showDependentCreateModal() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$onClose = _ref.onClose,
	      onClose = _ref$onClose === undefined ? function () {} : _ref$onClose,
	      _ref$messageId = _ref.messageId,
	      messageId = _ref$messageId === undefined ? 'dependent.form.createComplete' : _ref$messageId;
	
	  return {
	    type: consts.SHOW,
	    payload: {
	      contentType: _props.UI_POPUP_TYPES.MESSAGE,
	      contentOptions: {
	        message: { id: messageId },
	        icon: 'icon-clock',
	        popupAction: onClose,
	        onSubmit: onClose
	      }
	    }
	  };
	};
	
	var initialState = {
	  visible: false,
	  contentType: '',
	  contentOptions: {},
	  secondaryContentVisible: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref2 = arguments[1];
	  var type = _ref2.type,
	      payload = _ref2.payload;
	
	  switch (type) {
	    case consts.SHOW:
	      return (0, _extends3.default)({}, state, {
	        visible: true,
	        contentType: payload.contentType,
	        contentOptions: payload.contentOptions
	      });
	    case consts.HIDE:
	      return (0, _extends3.default)({}, state, {
	        visible: false
	      });
	    case consts.TOGGLE_CONTENT:
	      return (0, _extends3.default)({}, state, {
	        secondaryContentVisible: !state.secondaryContentVisible
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rootAppointmentFormPath = undefined;
	exports.redirectToUsers = redirectToUsers;
	exports.redirectToPharmacy = redirectToPharmacy;
	exports.redirectToMyProviders = redirectToMyProviders;
	exports.redirectToLogIn = redirectToLogIn;
	exports.redirectToFullInsuranceForm = redirectToFullInsuranceForm;
	exports.redirectToHealthInfo = redirectToHealthInfo;
	exports.redirectToHealthInfoProvider = redirectToHealthInfoProvider;
	exports.redirectToPayment = redirectToPayment;
	exports.redirectToSummary = redirectToSummary;
	exports.redirectToOrganizations = redirectToOrganizations;
	exports.redirectToVisitType = redirectToVisitType;
	exports.redirectToEmergencyContact = redirectToEmergencyContact;
	exports.redirectToServices = redirectToServices;
	exports.redirectToLocations = redirectToLocations;
	exports.redirectToPublixInfo = redirectToPublixInfo;
	exports.redirectBackToServiceOrVisitType = redirectBackToServiceOrVisitType;
	exports.redirectToConsentForm = redirectToConsentForm;
	exports.redirectToPatientForm = redirectToPatientForm;
	exports.redirectToVisitDetails = redirectToVisitDetails;
	exports.redirectToGuarantorInformation = redirectToGuarantorInformation;
	exports.redirectToAdditionalInformation = redirectToAdditionalInformation;
	exports.redirectToProviders = redirectToProviders;
	exports.redirectToProviderDetails = redirectToProviderDetails;
	exports.redirectToAppointmentOverview = redirectToAppointmentOverview;
	exports.redirectToDependentForm = redirectToDependentForm;
	exports.redirectToHealthBoard = redirectToHealthBoard;
	exports.redirectToHealthBoardEmpty = redirectToHealthBoardEmpty;
	exports.redirectToSettings = redirectToSettings;
	exports.redirectToAddAccount = redirectToAddAccount;
	exports.redirectToStep = redirectToStep;
	exports.redirectToAvailableTimeSlots = redirectToAvailableTimeSlots;
	exports.redirectToRescheduleProviderDetails = redirectToRescheduleProviderDetails;
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _reactRouter = __webpack_require__(42);
	
	var _constants = __webpack_require__(17);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootAppointmentFormPath = exports.rootAppointmentFormPath = _routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_USERS;
	
	function redirectToUsers(id) {
	  var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var suffix = typeof id === 'number' ? '#' + id : '';
	  var path = _routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_USERS + suffix;
	  var redirect = replace ? _reactRouter.browserHistory.replace : _reactRouter.browserHistory.push;
	  redirect(path);
	}
	
	function redirectToPharmacy() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_PHARMACY);
	}
	
	function redirectToMyProviders() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_MY_PROVIDERS);
	}
	
	function redirectToLogIn() {
	  _reactRouter.browserHistory.replace('' + _routes.LOGIN);
	}
	
	function redirectToFullInsuranceForm() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_INSURANCE_FORM);
	}
	
	function redirectToHealthInfo() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_HEALTH_INFO);
	}
	
	function redirectToHealthInfoProvider() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_HEALTH_INFO_PROVIDER);
	}
	
	function redirectToPayment() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_PAYMENT);
	}
	
	function redirectToSummary() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_SUMMARY);
	}
	
	function redirectToOrganizations() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_ORGANIZATIONS);
	}
	
	function redirectToVisitType() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_VISIT_TYPE);
	}
	
	function redirectToEmergencyContact() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_EMERGENCY_CONTACT);
	}
	
	function redirectToServices() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_VISIT_SERVICES);
	}
	
	function redirectToLocations() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_VISIT_LOCATIONS);
	}
	
	function redirectToPublixInfo() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_PUBLIX_INFO);
	}
	function redirectBackToServiceOrVisitType(services) {
	  if ((0, _size2.default)(services) > 1) {
	    redirectToServices();
	  } else redirectToVisitType();
	}
	
	function redirectToConsentForm() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_CONSENT_FORM);
	}
	
	function redirectToPatientForm() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_PATIENT_INFO);
	}
	
	function redirectToVisitDetails() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_VISIT_DETAILS);
	}
	
	function redirectToGuarantorInformation() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_GUARANTOR_INFORMATION);
	}
	
	function redirectToAdditionalInformation() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_ADDITIONAL_INFO);
	}
	
	function redirectToProviders() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_PROVIDERS);
	}
	
	function redirectToProviderDetails() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_PROVIDER_DETAILS);
	}
	
	function redirectToAppointmentOverview() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_OVERVIEW);
	}
	
	function redirectToDependentForm() {
	  _reactRouter.browserHistory.replace(_routes.DEPENDENT_FORM + '/' + _routes.DEPENDENT_FORM_ROLE);
	}
	
	function redirectToHealthBoard(id) {
	  _reactRouter.browserHistory.replace(_routes.HEALTHBOARD + '/' + id + '/' + _routes.HEALTHBOARD_HOME);
	}
	
	function redirectToHealthBoardEmpty() {
	  _reactRouter.browserHistory.push('' + _routes.HEALTHBOARD_EMPTY);
	}
	
	function redirectToSettings(id) {
	  _reactRouter.browserHistory.push(_routes.PROFILE + '/' + id + '/' + _routes.PROFILE_SETTINGS);
	}
	
	function redirectToAddAccount() {
	  _reactRouter.browserHistory.push('' + _routes.CHOOSE_ADD_ACCOUNT);
	}
	
	function redirectToStep(step, services) {
	  switch (step) {
	    case _constants.APPOINTMENT_INSPECTION.PROFILE:
	      return redirectToPatientForm();
	    case _constants.APPOINTMENT_INSPECTION.DOCUMENTS:
	      return redirectToPatientDocuments();
	    default:
	      return redirectBackToServiceOrVisitType(services);
	  }
	}
	
	function redirectToAvailableTimeSlots() {
	  _reactRouter.browserHistory.replace(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS);
	}
	
	function redirectToRescheduleProviderDetails(_ref) {
	  var locationId = _ref.locationId,
	      providerId = _ref.providerId;
	
	  var redirectDetailsPath = _routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_PROVIDER_DETAILS.replace(':id', providerId) + '#' + locationId;
	  _reactRouter.browserHistory.replace(redirectDetailsPath);
	}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTooltipDate = exports.sourceDataCodeFilteredByDate = exports.getOriginalProviderCode = exports.getConvertedSafeData = exports.getCategoryPercentageWithOneSource = exports.calculateMinMaxRangeForRawValue = exports.calculateDeltaScale = exports.calculateAverageValue = exports.getLengthMonth = exports.adaptResponse = exports.adaptHistoricResponse = exports.createTooltips = exports.getSourceDataWithType = exports.checkForAvailableSourceData = exports.getSafeDescriptionDataHistoricList = exports.normalizeMinMaxValue = exports.getCategoryPercentageWithFilter = exports.makeValueForBothDataset = exports.makeSplitDataForSaturation = exports.getSafeSaturationHistoricValue = exports.chooseAvailableSourceData = exports.chooseProviderData = exports.getDataListByType = exports.getDateFieldValue = exports.getStartDayOfYear = exports.convertValueDistanceToMiles = exports.convertMollPreLToMgPerDl = exports.convertCelsiusToFahrenheit = exports.convertValueWeightToKg = exports.convertValueWeightToLbs = exports.convertValueToMeters = exports.formatGlucoseValueWithMetric = exports.formatTemperatureValueWithMetric = exports.formatHeightValueWithMetric = exports.formatValueWeightWithMetric = exports.convertValueToFeetInch = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _set = __webpack_require__(1975);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.makeTickForData = makeTickForData;
	exports.roundPrecision = roundPrecision;
	exports.numberWithCommas = numberWithCommas;
	exports.getLabelForQuarterAndYear = getLabelForQuarterAndYear;
	exports.calculateAveragePerMonth = calculateAveragePerMonth;
	exports.adaptInterpolationValue = adaptInterpolationValue;
	exports.makeValueForGraf = makeValueForGraf;
	exports.formatDate = formatDate;
	exports.getTimeFromDateUTC = getTimeFromDateUTC;
	exports.getMonthLabel = getMonthLabel;
	exports.makeDateForAverageOrTotal = makeDateForAverageOrTotal;
	exports.formatDateToTitleMonth = formatDateToTitleMonth;
	exports.makeAverageOrTotalValue = makeAverageOrTotalValue;
	exports.shouldHideAverageLine = shouldHideAverageLine;
	exports.concatDataHistoricValue = concatDataHistoricValue;
	exports.formatToCalendarTime = formatToCalendarTime;
	exports.getTitleAndDescriptionEmptyState = getTitleAndDescriptionEmptyState;
	exports.validateFutureTime = validateFutureTime;
	exports.getCurrentTime = getCurrentTime;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _range = __webpack_require__(985);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = __webpack_require__(114);
	
	var _dates = __webpack_require__(1852);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MONTH = _constants.CHART_FILTERS_TYPE.MONTH,
	    WEEK = _constants.CHART_FILTERS_TYPE.WEEK,
	    QUARTER = _constants.CHART_FILTERS_TYPE.QUARTER,
	    DAY = _constants.CHART_FILTERS_TYPE.DAY,
	    YEAR = _constants.CHART_FILTERS_TYPE.YEAR;
	
	
	var CALENDAR_FORMATS = {
	  sameDay: 'MMM D',
	  nextDay: 'MMM D',
	  nextWeek: 'MMM D',
	  lastDay: 'MMM D',
	  lastWeek: 'MMM D',
	  sameElse: 'MMM D'
	};
	
	function makeTickForData(value, type, forYAxis, isWeightInKg) {
	  if (value === 0) return '';
	
	  switch (type) {
	    case _constants.VITALS_ACTIVITY_TYPE.STEPS:
	      return function () {
	        if (value === 0) return value;
	        if (forYAxis) {
	          if (value.toFixed().toString().length < 4) return value.toFixed();
	          return (value / 1000).toFixed(1) + 'k';
	        }
	        return (value / 1000).toFixed() + 'k';
	      }();
	    case _constants.VITALS_ACTIVITY_TYPE.DISTANCE:
	      return function () {
	        if (value.toFixed().toString().length < 4) {
	          return convertValueDistanceToMiles(value, 2);
	        }
	        return convertValueDistanceToMiles(value);
	      }();
	    case _constants.VITALS_ACTIVITY_TYPE.BMI:
	      return function () {
	        return forYAxis ? value.toFixed(1) : value.toFixed(0);
	      }();
	    case _constants.VITALS_ACTIVITY_TYPE.WEIGHT:
	      return function () {
	        return formatValueWeightWithMetric(value, isWeightInKg);
	      }();
	    case _constants.VITALS_ACTIVITY_TYPE.HEIGHT:
	      return function () {
	        return convertValueToFeetInch(value);
	      }();
	  }
	}
	
	var convertValueToFeetInch = exports.convertValueToFeetInch = function convertValueToFeetInch(value, separate) {
	  if (value === 0) return value;
	  var length = 100 * value / 2.54;
	  var feet = Math.floor(length / 12);
	  var inch = Math.round(length - 12 * feet);
	  return separate ? { feet: feet, inch: inch } : feet + '\'' + inch + '"';
	};
	
	var formatValueWeightWithMetric = exports.formatValueWeightWithMetric = function formatValueWeightWithMetric(value, inKg) {
	  if (inKg) {
	    return roundPrecision(value, 1);
	  }
	  return convertValueWeightToLbs(value);
	};
	
	var formatHeightValueWithMetric = exports.formatHeightValueWithMetric = function formatHeightValueWithMetric(value, inMeters) {
	  if (inMeters) {
	    return roundPrecision(value * 100, 1);
	  }
	  return convertValueToFeetInch(value);
	};
	
	var formatTemperatureValueWithMetric = exports.formatTemperatureValueWithMetric = function formatTemperatureValueWithMetric(value, inCelsius) {
	  if (inCelsius) {
	    return roundPrecision(value, 1, true);
	  }
	  return roundPrecision(convertCelsiusToFahrenheit(value), 1, true);
	};
	
	var formatGlucoseValueWithMetric = exports.formatGlucoseValueWithMetric = function formatGlucoseValueWithMetric(value, isMilligramsPerDeciliter, forRound) {
	  if (isMilligramsPerDeciliter) {
	    return roundPrecision(forRound ? value : convertMollPreLToMgPerDl(value), 0);
	  }
	  return roundPrecision(value, 1, true);
	};
	
	var convertValueToMeters = exports.convertValueToMeters = function convertValueToMeters(feet, inches) {
	  var allFeet = parseFloat(feet) + parseFloat(inches) / 12;
	  return allFeet * 0.3048;
	};
	
	var convertValueWeightToLbs = exports.convertValueWeightToLbs = function convertValueWeightToLbs(value) {
	  var toFixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var fractions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  return toFixed ? (value / 0.45359237).toFixed(fractions) : value / 0.45359237;
	};
	
	var convertValueWeightToKg = exports.convertValueWeightToKg = function convertValueWeightToKg(value) {
	  return value * 0.45359237;
	};
	
	var convertCelsiusToFahrenheit = exports.convertCelsiusToFahrenheit = function convertCelsiusToFahrenheit(value) {
	  return value * (9 / 5) + 32;
	};
	
	var convertMollPreLToMgPerDl = exports.convertMollPreLToMgPerDl = function convertMollPreLToMgPerDl(value) {
	  return value * 18;
	};
	
	function roundPrecision(value, decimals, convertToFloat) {
	  if (convertToFloat) {
	    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
	  }
	  return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
	}
	
	var convertValueDistanceToMiles = exports.convertValueDistanceToMiles = function convertValueDistanceToMiles(value, fixedCount) {
	  return (value * 0.000621371192).toFixed(fixedCount || 1);
	};
	
	var getStartDayOfYear = exports.getStartDayOfYear = function getStartDayOfYear(subtractMonthNumber) {
	  return (0, _moment2.default)().subtract(subtractMonthNumber, 'month').format('YYYY-MM-DD');
	};
	
	function numberWithCommas(x) {
	  var safeValue = typeof x === 'number' ? x.toString() : x;
	  return safeValue ? safeValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
	}
	
	function getFormatterForDayType(dataType) {
	  var isHealthRecord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (isHealthRecord) {
	    return function (arrValue) {
	      return arrValue;
	    };
	  }
	  if ([_constants.VITALS_ACTIVITY_TYPE.BMI, _constants.VITALS_ACTIVITY_TYPE.WEIGHT, _constants.VITALS_ACTIVITY_TYPE.HEIGHT, _constants.VITALS_ACTIVITY_TYPE.SATURATION].includes(dataType)) {
	    return function (arrValue) {
	      var sum = arrValue.reduce(function (prevValue, nextValue) {
	        return prevValue + nextValue;
	      }, 0);
	      return arrValue.length > 0 ? sum / arrValue.length : null;
	    };
	  }
	  return function (arrValue) {
	    return arrValue.reduce(function (prevValue, nextValue) {
	      return prevValue + nextValue;
	    }, 0);
	  };
	}
	
	function formatDataGrafByDay(entity, type, withTime, dataType) {
	  var isHealthRecord = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  var dayEntityArr = [];
	  var dayEntityTimeArr = [];
	  if (type === 'value') {
	    var formatter = getFormatterForDayType(dataType, isHealthRecord);
	    var result = (0, _range2.default)(24).reduce(function (acc, _, index) {
	      var baseDate = (0, _moment2.default)(entity[0].measuredAt);
	      var matched = entity.filter(function (_ref) {
	        var measuredAt = _ref.measuredAt;
	
	        var baseTime = (0, _moment2.default)(baseDate).startOf('d').add(index, 'h').subtract(1, 'ms');
	        var endTime = (0, _moment2.default)(baseDate).startOf('d').add(index + 1, 'h').subtract(1, 'ms');
	        return (0, _moment2.default)(measuredAt).isBetween(baseTime, endTime);
	      }).map(function (item) {
	        if (isHealthRecord) {
	          return item;
	        }
	        return item.value;
	      });
	
	      return [].concat((0, _toConsumableArray3.default)(acc), [matched]);
	    }, []).map(formatter);
	
	    if (isHealthRecord) {
	      var draftRes = [];
	      result.forEach(function (item, index) {
	        if (item.length > 0) {
	          item.forEach(function (data) {
	            draftRes.push({
	              x: _constants.ORDER_TIME_DAY[index],
	              y: data.value,
	              timeStamp: getMonthLabel(data.measuredAt, 'MMM D, Y, h:mm A')
	            });
	          });
	        }
	      });
	      result = draftRes;
	    }
	
	    if (withTime) {
	      entity.forEach(function (item) {
	        _constants.ORDER_TIME_DAY.forEach(function (time, index) {
	          if (time === getTimeFromDateUTC(item.measuredAt, 'h a', false)) {
	            dayEntityTimeArr[index] = getMonthLabel(item.measuredAt, 'MMM D, Y, h:mm A');
	          }
	        });
	      });
	    }
	    return withTime ? dayEntityTimeArr : result;
	  }
	  if (type === 'labels') {
	    return _constants.ORDER_TIME_DAY;
	  }
	  if (type === 'points') {
	    return (0, _range2.default)(_constants.ORDER_TIME_DAY.length).fill(3);
	  }
	  if (type === 'tooltip') {
	    return _constants.ORDER_TIME_DAY.map(function () {
	      return { keepTooltipOpen: false };
	    });
	  }
	  if (type === 'background') {
	    _constants.ORDER_TIME_DAY.forEach(function () {
	      return dayEntityArr.push('rgba(50, 108, 186, 1)');
	    });
	    return dayEntityArr;
	  }
	}
	
	function formatDataGrafByWeek(entity, type, withTime, dataType) {
	  var isHealthRecord = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  var weekEntityArr = [];
	  var weekEntityTimeArr = [];
	
	  var baseArr = (0, _range2.default)(7);
	
	  if (type === 'value') {
	    var formatter = getFormatterForDayType(dataType, isHealthRecord);
	    var currentDate = (0, _moment2.default)();
	    var result = (0, _range2.default)(7).reduce(function (acc, _, index) {
	      var matched = entity.filter(function (_ref2) {
	        var measuredAt = _ref2.measuredAt;
	
	        var baseTime = (0, _moment2.default)(currentDate).subtract(index, 'd').startOf('d').subtract(1, 'ms');
	        var endTime = (0, _moment2.default)(baseTime).add(1, 'd').endOf('d');
	        return (0, _moment2.default)(measuredAt).isBetween(baseTime, endTime);
	      }).map(function (item) {
	        if (isHealthRecord) {
	          return item;
	        }
	        return item.value;
	      });
	
	      return [].concat((0, _toConsumableArray3.default)(acc), [matched]);
	    }, []).map(formatter);
	
	    if (isHealthRecord) {
	      var draftRes = [];
	      var currentLabelWeek = (0, _range2.default)(7).map(function (item, index) {
	        var dateWeek = (0, _moment2.default)().subtract(index, 'd').format('MMM D, Y');
	        return formatDate(dateWeek, 'ddd', true);
	      });
	      result.forEach(function (item, index) {
	        if (item.length > 0) {
	          item.forEach(function (data) {
	            draftRes.push({
	              x: currentLabelWeek[index],
	              y: data.value,
	              timeStamp: getMonthLabel(data.measuredAt, 'MMM D, Y, h:mm A')
	            });
	          });
	        }
	      });
	      result = draftRes;
	    }
	
	    if (withTime) {
	      var baseTimeStampArr = [];
	      (0, _range2.default)(7).forEach(function (_, index) {
	        var baseTime = _moment2.default.utc(currentDate).subtract(index, 'd');
	        var currentLabel = getMonthLabel(baseTime, 'MMM D, Y');
	        baseTimeStampArr.push(currentLabel);
	      });
	      return baseTimeStampArr.reverse();
	    }
	    return withTime ? weekEntityTimeArr : result.reverse();
	  }
	
	  if (type === 'labels') {
	    (0, _range2.default)(7).forEach(function (item, index) {
	      var currentDate = (0, _moment2.default)().subtract(index, 'd').format('MMM D, Y');
	      return weekEntityArr.push(formatDate(currentDate, 'ddd', true));
	    });
	
	    return [].concat((0, _toConsumableArray3.default)(weekEntityArr.reverse()));
	  }
	  if (type === 'background') {
	    (0, _range2.default)(baseArr.length).forEach(function () {
	      return weekEntityArr.push('rgba(50, 108, 186, 1)');
	    });
	    return weekEntityArr;
	  }
	  if (type === 'points') {
	    return (0, _range2.default)(baseArr.length).fill(3);
	  }
	  if (type === 'tooltip') {
	    return baseArr.map(function () {
	      return {
	        keepTooltipOpen: false
	      };
	    });
	  }
	}
	
	function formatDataGrafByMonth(entity, type, withTime, dataType) {
	  var isHealthRecord = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  var monthEntityArr = [];
	  var monthEntityTimeArr = [];
	  var baseArr = (0, _range2.default)(getLengthMonth());
	
	  if (type === 'value') {
	    var formatter = getFormatterForDayType(dataType, isHealthRecord);
	    var currentDate = (0, _moment2.default)();
	    var result = baseArr.reduce(function (acc, _, index) {
	      var matched = entity.filter(function (_ref3) {
	        var measuredAt = _ref3.measuredAt;
	
	        var baseTime = (0, _moment2.default)(currentDate).subtract(index, 'd').startOf('d').subtract(1, 'ms');
	        var endTime = (0, _moment2.default)(baseTime).add(1, 'd').endOf('d');
	        return (0, _moment2.default)(measuredAt).isBetween(baseTime, endTime);
	      }).map(function (item) {
	        if (isHealthRecord) {
	          return item;
	        }
	        return item.value;
	      });
	
	      return [].concat((0, _toConsumableArray3.default)(acc), [matched]);
	    }, []).map(formatter);
	
	    if (isHealthRecord) {
	      var draftRes = [];
	      var currentLabelMonth = [].concat((0, _toConsumableArray3.default)(baseArr)).map(function (item, index) {
	        var currentDateMonth = (0, _moment2.default)().subtract(index, 'd').format('MMM D, Y');
	        return formatDateToTitleMonth(currentDateMonth);
	      });
	      monthEntityArr.unshift('');
	      result.forEach(function (item, index) {
	        if (item.length > 0) {
	          item.forEach(function (data) {
	            draftRes.push({
	              x: currentLabelMonth[index],
	              y: data.value,
	              timeStamp: getMonthLabel(data.measuredAt, 'MMM D, Y, h:mm A')
	            });
	          });
	        }
	      });
	      result = draftRes;
	    }
	
	    if (withTime) {
	      var baseTimeStampArr = [];
	      baseArr.forEach(function (_, index) {
	        var baseTime = _moment2.default.utc().subtract(index, 'd').format('MMM D, Y');
	        baseTimeStampArr.push(baseTime);
	      });
	      return baseTimeStampArr.reverse();
	    }
	    return withTime ? monthEntityTimeArr : result.reverse();
	  }
	
	  if (type === 'labels') {
	    baseArr.forEach(function (item, index) {
	      var currentDate = (0, _moment2.default)().subtract(index, 'd').format('MMM D, Y');
	      return monthEntityArr.push(formatDateToTitleMonth(currentDate));
	    });
	
	    monthEntityArr.unshift('');
	
	    return [].concat((0, _toConsumableArray3.default)(monthEntityArr.reverse()));
	  }
	  if (type === 'background') {
	    baseArr.forEach(function () {
	      return monthEntityArr.push('rgba(50, 108, 186, 1)');
	    });
	    return monthEntityArr;
	  }
	  if (type === 'points') {
	    monthEntityArr.unshift('');
	    return (0, _range2.default)(monthEntityArr.length).fill(3);
	  }
	  if (type === 'tooltip') {
	    return [''].concat((0, _toConsumableArray3.default)(baseArr)).map(function () {
	      return { keepTooltipOpen: false };
	    });
	  }
	}
	
	function getPreviousMonth(currentMonthValue, array) {
	  var currentIndex = array.indexOf(currentMonthValue);
	  if (currentIndex > 0) return array[currentIndex - 1];
	  if (currentIndex === 0) return array[array.length - 1];
	}
	
	function getLabelForQuarterAndYear(forQuarter) {
	  var baseArr = forQuarter ? (0, _range2.default)(3) : _constants.ORDER_MONTH_IN_YEAR;
	  var currentMonthValue = (0, _moment2.default)();
	  var currentMonthLabel = formatDate(currentMonthValue, 'MMM', true);
	
	  var result = [];
	  var currentLabel = currentMonthLabel;
	
	  baseArr.forEach(function () {
	    result.push(currentLabel);
	    currentLabel = getPreviousMonth(currentLabel, _constants.ORDER_MONTH_IN_YEAR);
	  });
	
	  return { baseArr: result.reverse(), currentDate: currentMonthValue };
	}
	
	function calculateAveragePerMonth(arr) {
	  var result = [];
	  arr.forEach(function (item) {
	    result.push(item.reduce(function (a, b) {
	      return a + b;
	    }, 0) / item.length);
	  });
	  return result;
	}
	
	function formatDataGrafByQuarter(entity, type, withTime, dataType) {
	  var quarterEntityArr = [];
	
	  var _getLabelForQuarterAn = getLabelForQuarterAndYear(true),
	      baseArr = _getLabelForQuarterAn.baseArr,
	      currentDate = _getLabelForQuarterAn.currentDate;
	
	  if (type === 'value') {
	    var formatter = getFormatterForDayType(dataType);
	    return splitEntityByDate(baseArr, entity, currentDate, formatter, withTime);
	  }
	
	  if (type === 'labels') {
	    return [].concat((0, _toConsumableArray3.default)(baseArr));
	  }
	  if (type === 'background') {
	    (0, _range2.default)(3).forEach(function () {
	      return quarterEntityArr.push('rgba(50, 108, 186, 1)');
	    });
	    return quarterEntityArr;
	  }
	  if (type === 'points') {
	    return (0, _range2.default)(quarterEntityArr.length).fill(3);
	  }
	  if (type === 'tooltip') {
	    return (0, _range2.default)(3).map(function () {
	      return { keepTooltipOpen: false };
	    });
	  }
	}
	
	function splitEntityByDate(baseArr, entity, currentDate, formatter, withTime) {
	  var result = baseArr.reduce(function (acc, _, index) {
	    var matched = entity.filter(function (_ref4) {
	      var measuredAt = _ref4.measuredAt;
	
	      var baseTime = _moment2.default.utc(currentDate).subtract(index, 'month').startOf('month');
	      var endTime = _moment2.default.utc(baseTime).endOf('month');
	      return _moment2.default.utc(measuredAt).isBetween(baseTime, endTime);
	    }).map(function (_ref5) {
	      var value = _ref5.value;
	      return value;
	    });
	
	    return [].concat((0, _toConsumableArray3.default)(acc), [matched]);
	  }, []).map(formatter);
	  if (withTime) {
	    var baseTimeStampArr = [];
	    baseArr.forEach(function (_, index) {
	      var baseTime = _moment2.default.utc(currentDate).subtract(index, 'month');
	      var currentLabel = getMonthLabel(baseTime, 'MMMM, Y');
	      baseTimeStampArr.push(currentLabel);
	    });
	    return baseTimeStampArr.reverse();
	  }
	  return result.reverse();
	}
	
	function formatDataGrafByYear(entity, type, withTime, dataType) {
	  var yearEntityArr = [];
	
	  var _getLabelForQuarterAn2 = getLabelForQuarterAndYear(false),
	      baseArr = _getLabelForQuarterAn2.baseArr,
	      currentDate = _getLabelForQuarterAn2.currentDate;
	
	  if (type === 'value') {
	    var formatter = getFormatterForDayType(dataType);
	    return splitEntityByDate(baseArr, entity, currentDate, formatter, withTime);
	  }
	  if (type === 'labels') {
	    return [].concat((0, _toConsumableArray3.default)(baseArr));
	  }
	  if (type === 'background') {
	    _constants.ORDER_MONTH_IN_YEAR.forEach(function () {
	      return yearEntityArr.push('rgba(50, 108, 186, 1)');
	    });
	    return yearEntityArr;
	  }
	  if (type === 'points') {
	    return (0, _range2.default)(yearEntityArr.length).fill(3);
	  }
	  if (type === 'tooltip') {
	    return [].concat((0, _toConsumableArray3.default)(_constants.ORDER_MONTH_IN_YEAR)).map(function () {
	      return { keepTooltipOpen: false };
	    });
	  }
	}
	
	function adaptInterpolationValue(arr, type, dataType, singleDayMode) {
	  if ([_constants.VITALS_ACTIVITY_TYPE.BMI, _constants.VITALS_ACTIVITY_TYPE.WEIGHT].includes(dataType) && arr && ['value', 'points'].includes(type)) {
	    if (type === 'value') {
	      var tempArr = [].concat((0, _toConsumableArray3.default)(arr));
	      var targetLeft = tempArr.find(function (item) {
	        return item > 0;
	      });
	
	      arr.push(null);
	      arr.unshift(null);
	
	      // eslint-disable-next-line no-param-reassign
	      arr[0] = targetLeft;
	      if (singleDayMode) {
	        var targetRight = void 0;
	        for (var i = tempArr.length - 1; i >= 0; i--) {
	          if (tempArr[i]) {
	            targetRight = tempArr[i];
	            break;
	          }
	        }
	        // eslint-disable-next-line no-param-reassign
	        arr[arr.length - 1] = targetRight;
	      }
	      return arr;
	    }
	    // eslint-disable-next-line no-param-reassign
	    arr[0] = 0;
	    if (singleDayMode) {
	      // eslint-disable-next-line no-param-reassign
	      arr[arr.length - 1] = 0;
	    }
	    return arr;
	  }
	  return arr;
	}
	
	function makeAverageValue(rawArr, filterType, dataType) {
	  var safeArr = rawArr ? rawArr.filter(function (item) {
	    return item !== null && item > 0;
	  }) : [];
	  return makeAverageOrTotalValue(safeArr, filterType, dataType);
	}
	
	function makeValueForGraf(entity, type, filterType, withTime, dataType, singleDayMode, forAverageValue) {
	  var isHealthRecord = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
	
	  if (_constants.VITALS_ACTIVITY_TYPE.SATURATION === dataType && type === 'value' && !withTime) return [];
	  switch (filterType) {
	    case DAY.type:
	      {
	        var rawArr = formatDataGrafByDay(entity, type, withTime, dataType, isHealthRecord);
	        if (forAverageValue) {
	          var rowDataForAverageCalc = entity.map(function (item) {
	            return item.value;
	          });
	          return makeAverageValue(rowDataForAverageCalc, filterType, dataType);
	        }
	        return rawArr || [];
	      }
	    case WEEK.type:
	      {
	        var _rawArr = formatDataGrafByWeek(entity, type, withTime, dataType, isHealthRecord);
	        if (forAverageValue) {
	          var _rowDataForAverageCalc = entity.map(function (item) {
	            return item.value;
	          });
	          return makeAverageValue(_rowDataForAverageCalc, filterType, dataType);
	        }
	        return _rawArr || [];
	      }
	    case MONTH.type:
	      {
	        var _rawArr2 = formatDataGrafByMonth(entity, type, withTime, dataType, isHealthRecord);
	        if (forAverageValue) {
	          var _rowDataForAverageCalc2 = entity.map(function (item) {
	            return item.value;
	          });
	          return makeAverageValue(_rowDataForAverageCalc2, filterType, dataType);
	        }
	        return _rawArr2 || [];
	      }
	
	    case QUARTER.type:
	      {
	        var _rawArr3 = formatDataGrafByQuarter(entity, type, withTime, dataType);
	        if (forAverageValue) {
	          if ([_constants.VITALS_ACTIVITY_TYPE.DISTANCE, _constants.VITALS_ACTIVITY_TYPE.STEPS].includes(dataType)) {
	            return makeAverageValue(_rawArr3, filterType, dataType);
	          }
	          var _rowDataForAverageCalc3 = entity.map(function (item) {
	            return item.value;
	          });
	          return makeAverageValue(_rowDataForAverageCalc3, filterType, dataType);
	        }
	        return _rawArr3 || [];
	      }
	
	    case YEAR.type:
	      {
	        var _rawArr4 = formatDataGrafByYear(entity, type, withTime, dataType);
	        if (forAverageValue) {
	          if ([_constants.VITALS_ACTIVITY_TYPE.DISTANCE, _constants.VITALS_ACTIVITY_TYPE.STEPS].includes(dataType)) {
	            return makeAverageValue(_rawArr4, filterType, dataType);
	          }
	          var _rowDataForAverageCalc4 = entity.map(function (item) {
	            return item.value;
	          });
	          return makeAverageValue(_rowDataForAverageCalc4, filterType, dataType);
	        }
	        return _rawArr4 || [];
	      }
	  }
	}
	
	function formatDate(date, format, inUpperCase) {
	  return inUpperCase ? (0, _moment2.default)(date).format(format).toUpperCase() : (0, _moment2.default)(date).format(format);
	}
	
	// javascript
	function getTimeFromDateUTC(date, format, useUTC) {
	  if (!date) return 'INVALID DATE';
	
	  var inputFormats = [_dates.DATE_PICKER_DATE_FORMAT, _dates.DATE_PICKER_DATE_FORMAT_DD_MM_YYYY, _dates.DATE_PICKER_DATE_FORMAT_YYYY_MM_DD, _moment2.default.ISO_8601];
	  var parser = useUTC ? _moment2.default.utc : _moment2.default;
	
	  var m = void 0;
	  if (_moment2.default.isMoment(date)) {
	    m = date;
	  } else if (date instanceof Date) {
	    m = parser(date);
	  } else {
	    // try strict parsing against known formats (fixes Safari)
	    m = parser(date, inputFormats, true);
	    if (!m.isValid()) {
	      // fallback to permissive parsing (covers other valid inputs)
	      m = parser(date);
	    }
	  }
	
	  return m && m.isValid() ? m.format(format).toUpperCase() : 'INVALID DATE';
	}
	
	var getDateFieldValue = exports.getDateFieldValue = function getDateFieldValue(data) {
	  if (!data) return undefined;
	  var formats = [_dates.DATE_PICKER_DATE_FORMAT, _dates.DATE_PICKER_DATE_FORMAT_DD_MM_YYYY, _dates.DATE_PICKER_DATE_FORMAT_YYYY_MM_DD, _moment2.default.ISO_8601];
	  var m = (0, _moment2.default)(data, formats, true); // strict parse with known formats (fixes Safari)
	  if (!m.isValid()) m = (0, _moment2.default)(data); // fallback permissive parse
	  return m.isValid() ? m.toDate() : undefined;
	};
	
	function getMonthLabel(date, format) {
	  return (0, _moment2.default)(date).format(format);
	}
	
	function makeDateForAverageOrTotal(data, filterType, singleMode) {
	  var format = [YEAR.type, QUARTER.type].includes(filterType) ? 'MMM Y' : 'MMM D, Y';
	  var currentDate = (0, _moment2.default)().format(format);
	
	  if (singleMode && data) {
	    return (0, _moment2.default)(data[0].measuredAt).format(format);
	  }
	
	  if (filterType === DAY.type) {
	    return currentDate;
	  }
	
	  if (filterType === WEEK.type) {
	    var previousDate = (0, _moment2.default)(currentDate).subtract(1, 'w').add(1, 'd').format(format);
	    return previousDate + ' - ' + currentDate;
	  }
	
	  if (filterType === MONTH.type) {
	    var _previousDate = (0, _moment2.default)(currentDate).subtract(1, 'month').add(1, 'd').format(format);
	    return _previousDate + ' - ' + currentDate;
	  }
	
	  if (filterType === QUARTER.type) {
	    var _previousDate2 = (0, _moment2.default)().subtract(2, 'month').format(format);
	    return _previousDate2 + ' - ' + currentDate;
	  }
	
	  if (filterType === YEAR.type) {
	    var _previousDate3 = (0, _moment2.default)().subtract(11, 'month').format(format);
	    return _previousDate3 + ' - ' + currentDate;
	  }
	}
	
	function formatDateToTitleMonth(date) {
	  return (0, _moment2.default)(date).calendar(null, CALENDAR_FORMATS);
	}
	
	function makeAverageOrTotalValue(data, filterType, dataType) {
	  var shouldCalculateAverage = [_constants.VITALS_ACTIVITY_TYPE.BMI, _constants.VITALS_ACTIVITY_TYPE.WEIGHT, _constants.VITALS_ACTIVITY_TYPE.HEIGHT].includes(dataType);
	
	  if (filterType === DAY.type) {
	    if (shouldCalculateAverage) {
	      return data.reduce(function (prev, curr) {
	        return prev + curr;
	      }, 0) / data.length;
	    }
	    return data.reduce(function (prev, curr) {
	      return prev + curr;
	    }, 0);
	  }
	  var resultArr = [];
	  data.forEach(function (item) {
	    return resultArr.push(item);
	  });
	  if (filterType === WEEK.type) {
	    return resultArr.reduce(function (a, b) {
	      return a + b;
	    }, 0) / resultArr.length;
	  }
	  if (filterType === MONTH.type) {
	    return resultArr.reduce(function (a, b) {
	      return a + b;
	    }, 0) / resultArr.length;
	  }
	  if (filterType === QUARTER.type) {
	    return resultArr.reduce(function (a, b) {
	      return a + b;
	    }, 0) / resultArr.length;
	  }
	  if (filterType === YEAR.type) {
	    return resultArr.reduce(function (a, b) {
	      return a + b;
	    }, 0) / resultArr.length;
	  }
	}
	
	function shouldHideAverageLine(entity, isCandleDataType) {
	  if (isCandleDataType) return false;
	  var marker = entity.reduce(function (acc, cur) {
	    if (cur.value) {
	      return acc + 1;
	    }
	    return acc;
	  }, 0);
	  return marker > 1;
	}
	
	var getDataListByType = exports.getDataListByType = function getDataListByType(_ref6) {
	  var formatMessage = _ref6.formatMessage,
	      type = _ref6.type,
	      item = _ref6.item,
	      isWeightInKg = _ref6.isWeightInKg,
	      isHeightInMeters = _ref6.isHeightInMeters,
	      isMilligramsPerDeciliter = _ref6.isMilligramsPerDeciliter,
	      allValuesForOneDay = _ref6.allValuesForOneDay,
	      safeFormatCalendar = _ref6.safeFormatCalendar,
	      isConvertedData = _ref6.isConvertedData;
	
	  switch (type) {
	    case _constants.VITALS_ACTIVITY_TYPE.STEPS:
	      return {
	        metric: formatMessage({
	          id: 'patient.healthboard.steps.metric'
	        }),
	        measuredAt: formatToCalendarTime(item.measuredAt, false, _constants.HISTORIC_SHORT_CALENDAR_TYPE),
	        value: numberWithCommas(item.value),
	        rowDate: item.measuredAt,
	        dataSource: getOriginalProviderCode(item.originalProviderCodes)
	      };
	    case _constants.VITALS_ACTIVITY_TYPE.BMI:
	      return {
	        metric: '',
	        measuredAt: formatToCalendarTime(item.measuredAt, false, allValuesForOneDay ? safeFormatCalendar : _constants.HISTORIC_SHORT_CALENDAR_TYPE),
	        value: typeof item.value === 'string' ? parseFloat(item.value).toFixed(1) : item.value.toFixed(1),
	        rowDate: item.measuredAt,
	        dataSource: getOriginalProviderCode(item.originalProviderCodes)
	      };
	    case _constants.VITALS_ACTIVITY_TYPE.DISTANCE:
	      return {
	        metric: formatMessage({
	          id: 'patient.healthboard.distance.metric'
	        }),
	        measuredAt: formatToCalendarTime(item.measuredAt, false, _constants.HISTORIC_SHORT_CALENDAR_TYPE),
	        value: convertValueDistanceToMiles(item.value),
	        rowDate: item.measuredAt,
	        dataSource: getOriginalProviderCode(item.originalProviderCodes)
	      };
	    case _constants.VITALS_ACTIVITY_TYPE.WEIGHT:
	      return {
	        metric: isWeightInKg ? formatMessage({
	          id: 'patient.healthboard.weight.metric.kg'
	        }) : formatMessage({
	          id: 'patient.healthboard.weight.metric'
	        }),
	        measuredAt: formatToCalendarTime(item.measuredAt, false, allValuesForOneDay ? safeFormatCalendar : _constants.HISTORIC_SHORT_CALENDAR_TYPE),
	        value: formatValueWeightWithMetric(item.value, isWeightInKg),
	        rowDate: item.measuredAt,
	        dataSource: getOriginalProviderCode(item.originalProviderCodes)
	      };
	    case _constants.VITALS_ACTIVITY_TYPE.HEIGHT:
	      return {
	        metric: isHeightInMeters ? formatMessage({
	          id: 'patient.healthboard.height.metric.cm'
	        }) : '',
	        measuredAt: formatToCalendarTime(item.measuredAt, false, _constants.HISTORIC_CALENDAR_TYPE),
	        value: formatHeightValueWithMetric(item.value, isHeightInMeters),
	        rowDate: item.measuredAt,
	        dataSource: getOriginalProviderCode(item.originalProviderCodes)
	      };
	    case _constants.VITALS_ACTIVITY_TYPE.SATURATION:
	      return {
	        metric: formatMessage({
	          id: 'patient.healthboard.saturation.metric'
	        }),
	        measuredAt: formatToCalendarTime(item.measuredAt, false, allValuesForOneDay ? _constants.HISTORIC_ONE_DAY_CALENDAR_TYPE : _constants.HISTORIC_SHORT_CALENDAR_TYPE),
	        value: getSafeSaturationHistoricValue(item, allValuesForOneDay),
	        rowDate: item.measuredAt,
	        dataSource: getOriginalProviderCode(item.originalProviderCodes)
	      };
	    case _constants.VITALS_ACTIVITY_TYPE.HEART_RATE:
	      return {
	        metric: formatMessage({
	          id: 'patient.healthboard.heart_rate.metric'
	        }),
	        measuredAt: formatToCalendarTime(item.measuredAt, false, allValuesForOneDay ? _constants.HISTORIC_ONE_DAY_CALENDAR_TYPE : _constants.HISTORIC_SHORT_CALENDAR_TYPE),
	        value: getSafeSaturationHistoricValue(item, allValuesForOneDay),
	        rowDate: item.measuredAt,
	        dataSource: getOriginalProviderCode(item.originalProviderCodes)
	      };
	    case _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE:
	      return {
	        metric: isMilligramsPerDeciliter ? formatMessage({
	          id: 'patient.healthboard.blood_glucose.metric.milligrams_per_deciliter'
	        }) : formatMessage({
	          id: 'patient.healthboard.blood_glucose.metric.millimoles_per_liter'
	        }),
	        measuredAt: formatToCalendarTime(item.measuredAt, false, allValuesForOneDay ? _constants.HISTORIC_ONE_DAY_CALENDAR_TYPE : _constants.HISTORIC_SHORT_CALENDAR_TYPE),
	        value: getSafeBloodGlucoseHistoricValue(item, allValuesForOneDay, isMilligramsPerDeciliter, isConvertedData),
	        rowDate: item.measuredAt,
	        dataSource: getOriginalProviderCode(item.originalProviderCodes)
	      };
	    default:
	      return {};
	  }
	};
	
	var chooseProviderData = exports.chooseProviderData = function chooseProviderData(entity) {
	  return entity.find(function (_ref7) {
	    var isPriority = _ref7.isPriority;
	    return !!isPriority;
	  });
	};
	
	var chooseAvailableSourceData = exports.chooseAvailableSourceData = function chooseAvailableSourceData(entity) {
	  return entity && entity.length > 0 ? entity.find(function (_ref8) {
	    var measurements = _ref8.measurements;
	    return measurements.length > 0;
	  }) : [];
	};
	
	function concatDataHistoricValue(data, dataType) {
	  var isCandleType = [_constants.VITALS_ACTIVITY_TYPE.SATURATION, _constants.VITALS_ACTIVITY_TYPE.HEART_RATE, _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE].includes(dataType);
	  var isAccumulateDataType = [_constants.VITALS_ACTIVITY_TYPE.DISTANCE, _constants.VITALS_ACTIVITY_TYPE.WEIGHT, _constants.VITALS_ACTIVITY_TYPE.STEPS, _constants.VITALS_ACTIVITY_TYPE.HEIGHT, _constants.VITALS_ACTIVITY_TYPE.BMI].includes(dataType);
	
	  if (data.length > 0) {
	    var safeDate = [].concat((0, _toConsumableArray3.default)(data));
	    var baseArrDate = [];
	    var resultArr = [];
	    var concatValueArr = [];
	    var draftResultForSaturation = [];
	
	    safeDate.forEach(function (item) {
	      baseArrDate.push(getTimeFromDateUTC(item.measuredAt, 'YYYY-MM-DD', false));
	    });
	    var safeArrDate = [].concat((0, _toConsumableArray3.default)(new _set2.default(baseArrDate)));
	
	    safeArrDate.forEach(function (item, index) {
	      if (isCandleType) {
	        safeDate.forEach(function (entity) {
	          if ((0, _moment2.default)(item, 'YYYY-MM-DD').isSame(entity.measuredAt, 'day')) {
	            if (!draftResultForSaturation[index]) {
	              draftResultForSaturation.push({
	                originalProviderCodes: entity.originalProviderCodes[0],
	                measuredAt: entity.measuredAt,
	                value: [entity.value]
	              });
	            } else {
	              var previousProviderCode = draftResultForSaturation[index].originalProviderCodes;
	              var isSameProviderCode = previousProviderCode === entity.originalProviderCodes[0];
	              draftResultForSaturation[index].value.push(entity.value);
	              if (!isSameProviderCode) {
	                draftResultForSaturation[index].originalProviderCodes = _constants.DATA_SOURCE_TYPE.ALL_SOURCES;
	              }
	            }
	          }
	        });
	      }
	
	      if (isAccumulateDataType) {
	        safeDate.forEach(function (entity) {
	          if ((0, _moment2.default)(item, 'YYYY-MM-DD').isSame(entity.measuredAt, 'day')) {
	            if (!resultArr[index]) {
	              resultArr.push((0, _extends3.default)({}, entity, { counter: 1 }));
	            } else {
	              var previousProviderCode = resultArr[index].originalProviderCodes[0];
	              var isSameProviderCode = previousProviderCode === entity.originalProviderCodes[0];
	              var currentValue = resultArr[index].value + entity.value;
	              resultArr[index].value = currentValue;
	              var previousCounter = concatValueArr[index] ? concatValueArr[index].counter : 1;
	              concatValueArr[index] = {
	                measuredAt: entity.measuredAt,
	                value: currentValue,
	                counter: previousCounter + 1,
	                providerCode: isSameProviderCode ? resultArr[index].providerCode : _constants.DATA_SOURCE_TYPE.ALL_SOURCES,
	                originalProviderCodes: isSameProviderCode ? previousProviderCode : [_constants.DATA_SOURCE_TYPE.ALL_SOURCES]
	              };
	            }
	          }
	        });
	      }
	    });
	
	    if (isCandleType) {
	      draftResultForSaturation.forEach(function (_ref9) {
	        var measuredAt = _ref9.measuredAt,
	            value = _ref9.value,
	            originalProviderCodes = _ref9.originalProviderCodes;
	
	        resultArr.push({
	          measuredAt: measuredAt,
	          originalProviderCodes: [originalProviderCodes],
	          value: {
	            min: Math.min.apply(Math, (0, _toConsumableArray3.default)(value)),
	            max: Math.max.apply(Math, (0, _toConsumableArray3.default)(value))
	          }
	        });
	      });
	    }
	
	    if (isAccumulateDataType) {
	      concatValueArr.forEach(function (item, index) {
	        if (item) {
	          if (item.counter > 1) {
	            resultArr[index] = (0, _extends3.default)({}, item, { value: item.value / item.counter });
	          } else {
	            resultArr[index] = item;
	          }
	        }
	      });
	    }
	
	    return [].concat(resultArr);
	  }
	
	  return [];
	}
	
	function formatToCalendarTime(timestamp, useUTC, calendarFormat) {
	  return useUTC ? _moment2.default.utc(timestamp).calendar(null, calendarFormat || CALENDAR_FORMATS) : (0, _moment2.default)(timestamp).calendar(null, calendarFormat || CALENDAR_FORMATS);
	}
	
	function getTitleAndDescriptionEmptyState(_ref10) {
	  var formatMessage = _ref10.formatMessage,
	      type = _ref10.type,
	      isProvider = _ref10.isProvider;
	
	  if ([_constants.VITALS_ACTIVITY_TYPE.DISTANCE, _constants.VITALS_ACTIVITY_TYPE.STEPS, _constants.VITALS_ACTIVITY_TYPE.SATURATION, _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE].includes(type)) {
	    return {
	      titleButton: formatMessage({
	        id: 'patient.portal.emptyState.goToSettings'
	      }),
	      description: isProvider ? formatMessage({
	        id: 'patient.healthboard.graf.emptyState'
	      }) : formatMessage({
	        id: 'patient.portal.emptyState.stepsOrDistance.noData'
	      }),
	      descriptionForAccount: formatMessage({
	        id: 'patient.portal.emptyState.stepsOrDistance.addAccount'
	      }),
	      withOutCapitalize: true
	    };
	  }
	  if (_constants.VITALS_ACTIVITY_TYPE.BMI === type) {
	    return {
	      titleButton: formatMessage({ id: 'patient.portal.emptyState.addData' }, {
	        type: formatMessage({
	          id: 'patient.portal.emptyState.bodyInfo'
	        })
	      }),
	      description: formatMessage({ id: 'patient.healthboard.graf.emptyState' })
	    };
	  }
	  if ([_constants.VITALS_ACTIVITY_TYPE.HEART_RATE, _constants.VITALS_ACTIVITY_TYPE.BODY_SURFACE_AREA, _constants.VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE, _constants.VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE, _constants.VITALS_ACTIVITY_TYPE.BODY_TEMPERATURE].includes(type)) {
	    return {
	      description: formatMessage({ id: 'patient.healthboard.graf.emptyState' })
	    };
	  }
	
	  return {
	    titleButton: formatMessage({ id: 'patient.portal.emptyState.addData' }, {
	      type: type
	    }),
	    description: formatMessage({ id: 'patient.healthboard.graf.emptyState' })
	  };
	}
	
	function validateFutureTime(formatMessage, time, pickDate) {
	  if ((0, _moment2.default)(pickDate, 'YYYY-MM-DD').add(1, 'm').isBefore((0, _moment2.default)(new Date(), 'YYYY-MM-DD'))) {
	    return null;
	  }
	  var parseTime = (0, _moment2.default)(time, 'HH:mm a');
	  var isFutureTime = parseTime.isAfter((0, _moment2.default)(new Date(), 'HH:mm a'));
	
	  return isFutureTime ? formatMessage({ id: 'patient.portal.errorTime' }) : null;
	}
	
	function getCurrentTime() {
	  return (0, _moment2.default)().format('hh:mm a');
	}
	
	var getSafeSaturationHistoricValue = exports.getSafeSaturationHistoricValue = function getSafeSaturationHistoricValue(item, allValuesForOneDay) {
	  var dataMin = allValuesForOneDay ? item.value : item.value.min;
	  var dataMax = allValuesForOneDay ? item.value : item.value.max;
	
	  if (!dataMin && !dataMax) return '-';
	  var safeMin = Math.round(dataMin);
	  var safeMax = Math.round(dataMax);
	  return safeMin === safeMax ? safeMin : safeMin + ' - ' + safeMax;
	};
	
	var getSafeBloodGlucoseHistoricValue = function getSafeBloodGlucoseHistoricValue(item, allValuesForOneDay, isMilligramsPerDeciliter, isConvertedData) {
	  if (allValuesForOneDay) {
	    if (!item.value) return '-';
	
	    return isConvertedData ? item.value : formatGlucoseValueWithMetric(item.value, isMilligramsPerDeciliter);
	  }
	
	  var _item$value = (0, _extends3.default)({}, item.value),
	      min = _item$value.min,
	      max = _item$value.max;
	
	  if (!min && !max) return '-';
	
	  if (min === max) return isConvertedData ? min : formatGlucoseValueWithMetric(min, isMilligramsPerDeciliter);
	
	  var dataMin = isConvertedData ? min : formatGlucoseValueWithMetric(min, isMilligramsPerDeciliter);
	  var dataMax = isConvertedData ? max : formatGlucoseValueWithMetric(max, isMilligramsPerDeciliter);
	
	  return dataMin + ' - ' + dataMax;
	};
	
	var makeSplitDataForSaturation = exports.makeSplitDataForSaturation = function makeSplitDataForSaturation(data, filter, isCandleType, isWithoutLimit) {
	  var transparentDataEntity = [];
	  var valueDataEntity = [];
	  if (!isCandleType) return { transparentDataEntity: transparentDataEntity, valueDataEntity: valueDataEntity };
	  if (data && data.measurements && data.measurements.length > 0) {
	    var isQuarterFilter = filter === QUARTER.type;
	    var isDayFilter = filter === DAY.type;
	    var safeDate = [].concat((0, _toConsumableArray3.default)(data.measurements));
	    var baseArrDate = [];
	    var resultArr = [];
	    var draftResultForSaturation = [];
	    safeDate.forEach(function (item) {
	      baseArrDate.push(getTimeFromDateUTC(item.measuredAt, 'YYYY-MM-DD', false));
	    });
	    var safeArrDate = [].concat((0, _toConsumableArray3.default)(new _set2.default(baseArrDate)));
	
	    if (!isDayFilter) {
	      safeArrDate.forEach(function (item, index) {
	        var startTime = (0, _moment2.default)(item).startOf('d').subtract(1, 'm');
	        var endTime = (0, _moment2.default)(startTime).add(1, 'd').add(1, 'm');
	
	        safeDate.forEach(function (entity) {
	          if ((0, _moment2.default)(entity.measuredAt).isBetween(startTime, endTime)) {
	            if (!draftResultForSaturation[index]) {
	              draftResultForSaturation.push({
	                measuredAt: getTimeFromDateUTC(entity.measuredAt, 'YYYY-MM-DD', false),
	                value: [entity.value]
	              });
	            } else {
	              draftResultForSaturation[index].value.push(entity.value);
	            }
	          }
	        });
	      });
	      draftResultForSaturation.forEach(function (_ref11) {
	        var measuredAt = _ref11.measuredAt,
	            value = _ref11.value;
	
	        var baseTime = (0, _moment2.default)(measuredAt);
	        var currentLabel = getMonthLabel(baseTime, 'MMM D, Y');
	        resultArr.push({
	          currentLabel: currentLabel,
	          value: {
	            min: Math.min.apply(Math, (0, _toConsumableArray3.default)(value)),
	            max: Math.max.apply(Math, (0, _toConsumableArray3.default)(value))
	          }
	        });
	      });
	    }
	
	    if ([WEEK.type, MONTH.type].includes(filter)) {
	      var safeDeltaScale = calculateDeltaScale(resultArr, true);
	
	      resultArr.forEach(function (item) {
	        var safeMaxValue = item && item.value.max > 100 && !isWithoutLimit ? 100 : item.value.max;
	        var safeMinValue = item && item.value.min > 100 && !isWithoutLimit ? 100 : item.value.min;
	        transparentDataEntity.push({
	          date: item.currentLabel,
	          value: safeMinValue,
	          originMax: item.value.max,
	          originMin: item.value.min
	        });
	        var safeDeltaValue = safeMaxValue - safeMinValue < 1 ? safeMaxValue - safeMinValue + safeDeltaScale : safeMaxValue - safeMinValue;
	        valueDataEntity.push({
	          date: item.currentLabel,
	          value: safeDeltaValue,
	          originMax: item.value.max,
	          originMin: item.value.min
	        });
	      });
	    }
	
	    if ([QUARTER.type, YEAR.type].includes(filter)) {
	      var _getLabelForQuarterAn3 = getLabelForQuarterAndYear(isQuarterFilter),
	          baseArr = _getLabelForQuarterAn3.baseArr,
	          currentDate = _getLabelForQuarterAn3.currentDate;
	
	      var draftResult = baseArr.reduce(function (acc, _, index) {
	        var matched = resultArr.filter(function (_ref12) {
	          var currentLabel = _ref12.currentLabel;
	
	          var baseTime = (0, _moment2.default)(currentDate).subtract(index, 'month').startOf('month');
	          var endTime = (0, _moment2.default)(baseTime).endOf('month');
	          return (0, _moment2.default)(currentLabel).isBetween(baseTime.subtract(1, 'm'), endTime);
	        }).map(function (_ref13) {
	          var value = _ref13.value;
	          return value;
	        });
	        return [].concat((0, _toConsumableArray3.default)(acc), [matched]);
	      }, [])
	      // eslint-disable-next-line array-callback-return
	      .map(function (item) {
	        if (item.length !== 0) {
	          var minArr = [];
	          var maxArr = [];
	          item.forEach(function (_ref14) {
	            var min = _ref14.min,
	                max = _ref14.max;
	
	            minArr.push(min);
	            maxArr.push(max);
	          });
	          return { min: Math.min.apply(Math, minArr), max: Math.max.apply(Math, maxArr) };
	        }
	      });
	
	      var _safeDeltaScale = calculateDeltaScale(draftResult);
	
	      draftResult.reverse().forEach(function (item) {
	        var safeMaxValue = item && item.max > 100 && !isWithoutLimit ? (0, _extends3.default)({}, item, { max: 100 }) : item;
	        transparentDataEntity.push(item ? {
	          value: item.min,
	          originMin: item.min,
	          originMax: item.max
	        } : null);
	        valueDataEntity.push(item ? {
	          value: safeMaxValue.max - item.min < 1 ? safeMaxValue.max - item.min + _safeDeltaScale : safeMaxValue.max - item.min,
	          originMin: item.min,
	          originMax: item.max
	        } : null);
	      });
	    }
	
	    if (isDayFilter) {
	      var draftDayResult = (0, _range2.default)(24).reduce(function (acc, _, index) {
	        var baseDate = (0, _moment2.default)(data.measurements[0].measuredAt);
	        var matched = data.measurements.filter(function (_ref15) {
	          var measuredAt = _ref15.measuredAt;
	
	          var baseTime = (0, _moment2.default)(baseDate).startOf('d').add(index, 'h').subtract(1, 'ms');
	          var endTime = (0, _moment2.default)(baseDate).startOf('d').add(index + 1, 'h').subtract(1, 'ms');
	          return (0, _moment2.default)(measuredAt).isBetween(baseTime, endTime);
	        }).map(function (_ref16) {
	          var value = _ref16.value;
	          return value;
	        });
	        return [].concat((0, _toConsumableArray3.default)(acc), [matched]);
	      }, []).map(function (item) {
	        if (item.length > 0) {
	          var rawMax = Math.max.apply(Math, (0, _toConsumableArray3.default)(item));
	          var safeMax = rawMax > 100 && !isWithoutLimit ? 100 : rawMax;
	          var rawMin = Math.min.apply(Math, (0, _toConsumableArray3.default)(item));
	          var safeMin = rawMin > 100 && !isWithoutLimit ? 100 : rawMin;
	          var isSinglePoint = rawMax === rawMin || safeMax - rawMin <= 1;
	
	          return isSinglePoint ? {
	            min: safeMin,
	            max: safeMax,
	            originMin: rawMin,
	            originMax: rawMax,
	            singlePoint: true
	          } : {
	            min: safeMin,
	            max: safeMax,
	            originMin: rawMin,
	            originMax: rawMax
	          };
	        }
	        return null;
	      });
	
	      var _safeDeltaScale2 = calculateDeltaScale(draftDayResult);
	
	      draftDayResult.forEach(function (item) {
	        transparentDataEntity.push(item ? {
	          value: item.singlePoint ? item.min - _safeDeltaScale2 : item.min,
	          originMax: item.originMax,
	          originMin: item.originMin
	        } : null);
	        valueDataEntity.push(item ? {
	          value: item.singlePoint ? item.max - item.min + _safeDeltaScale2 : item.max - item.min,
	          originMax: item.originMax,
	          originMin: item.originMin
	        } : null);
	      });
	    }
	  }
	
	  return { transparentDataEntity: transparentDataEntity, valueDataEntity: valueDataEntity };
	};
	
	var makeValueForBothDataset = exports.makeValueForBothDataset = function makeValueForBothDataset(_ref17) {
	  var baseTimeArr = _ref17.baseTimeArr,
	      transparentEntity = _ref17.transparentEntity,
	      valueEntity = _ref17.valueEntity,
	      activeFilter = _ref17.activeFilter,
	      dataType = _ref17.dataType,
	      isWithoutLimit = _ref17.isWithoutLimit,
	      isMilligramsPerDeciliter = _ref17.isMilligramsPerDeciliter;
	
	  var valueData = [];
	  var transparentData = [];
	  var ranges = [];
	
	  var withoutRoundForGlucose = dataType === _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE && !isMilligramsPerDeciliter;
	
	  if ([QUARTER.type, YEAR.type, DAY.type].includes(activeFilter)) {
	    valueData = [].concat((0, _toConsumableArray3.default)(valueEntity.map(function (item) {
	      return item ? item.value : null;
	    })));
	    transparentData = [].concat((0, _toConsumableArray3.default)(transparentEntity.map(function (item) {
	      if (!item) return null;
	      return withoutRoundForGlucose ? item.value : Math.round(item.value);
	    })));
	    valueEntity.forEach(function (item, index) {
	      if (item) {
	        ranges[index] = {
	          min: withoutRoundForGlucose ? transparentEntity[index].originMin : Math.round(transparentEntity[index].originMin),
	          max: withoutRoundForGlucose ? transparentEntity[index].originMax : Math.round(transparentEntity[index].originMax)
	        };
	      }
	    });
	  } else {
	    baseTimeArr.forEach(function (baseDate, index) {
	      valueEntity.forEach(function (item, i) {
	        if (baseDate === item.date) {
	          valueData[index] = item.value;
	          ranges[index] = {
	            min: withoutRoundForGlucose ? transparentEntity[i].originMin : Math.round(transparentEntity[i].originMin),
	            max: withoutRoundForGlucose ? transparentEntity[i].originMax : Math.round(transparentEntity[i].originMax)
	          };
	        }
	      });
	      transparentEntity.forEach(function (item) {
	        if (baseDate === item.date) {
	          transparentData[index] = withoutRoundForGlucose ? item.value : Math.round(item.value);
	        }
	      });
	    });
	  }
	
	  var maxValueForRange = ranges.reduce(function (prev, current) {
	    return prev.max > current.max ? prev : current;
	  }, {}).max;
	
	  var minValueForRange = ranges.reduce(function (prev, current) {
	    return prev.min < current.min ? prev : current;
	  }, {}).min;
	
	  var safeMaxValueForRange = normalizeMinMaxValue(maxValueForRange, isWithoutLimit);
	  var safeMinValueForRange = normalizeMinMaxValue(minValueForRange, isWithoutLimit);
	
	  var minLimitForYAxis = withoutRoundForGlucose ? safeMinValueForRange - (safeMaxValueForRange - safeMinValueForRange) * 0.2 : Math.floor(safeMinValueForRange - (safeMaxValueForRange - safeMinValueForRange) * 0.2);
	
	  var maxLimitForYAxis = withoutRoundForGlucose ? safeMaxValueForRange + (safeMaxValueForRange - safeMinValueForRange) * 0.2 : Math.ceil(safeMaxValueForRange + (safeMaxValueForRange - safeMinValueForRange) * 0.2);
	
	  return {
	    valueData: valueData,
	    transparentData: transparentData,
	    ranges: ranges,
	    maxValueForRange: maxValueForRange,
	    minValueForRange: minValueForRange,
	    minLimitForYAxis: minLimitForYAxis,
	    maxLimitForYAxis: maxLimitForYAxis
	  };
	};
	
	var getCategoryPercentageWithFilter = exports.getCategoryPercentageWithFilter = function getCategoryPercentageWithFilter(filter, singleDayMode, isSinglePointAtFirstPosition, forOneSource) {
	  switch (filter) {
	    case DAY.type:
	      return singleDayMode ? getCategoryPercentageWithOneSource(0.7, forOneSource) : getCategoryPercentageWithOneSource(0.8, forOneSource);
	    case WEEK.type:
	      return isSinglePointAtFirstPosition ? getCategoryPercentageWithOneSource(0.03, forOneSource) : getCategoryPercentageWithOneSource(0.3, forOneSource);
	    case QUARTER.type:
	      return getCategoryPercentageWithOneSource(0.13, forOneSource);
	    case MONTH.type:
	      return isSinglePointAtFirstPosition ? getCategoryPercentageWithOneSource(0.03, forOneSource) : getCategoryPercentageWithOneSource(0.6, forOneSource);
	    case YEAR.type:
	      return getCategoryPercentageWithOneSource(0.45, forOneSource);
	  }
	};
	
	var normalizeMinMaxValue = exports.normalizeMinMaxValue = function normalizeMinMaxValue(value, isWithoutLimit) {
	  if (isWithoutLimit) return value;
	  if (value > 100) {
	    return 100;
	  }
	  if (value < 0) {
	    return 0;
	  }
	  return value;
	};
	
	var getSafeDescriptionDataHistoricList = exports.getSafeDescriptionDataHistoricList = function getSafeDescriptionDataHistoricList(type, formatMessage) {
	  var short = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  switch (type) {
	    case _constants.VITALS_ACTIVITY_TYPE.DISTANCE:
	    case _constants.VITALS_ACTIVITY_TYPE.STEPS:
	      {
	        return formatMessage({
	          id: 'patient.healthboard.total' + (!short ? 'Data' : '')
	        });
	      }
	    case _constants.VITALS_ACTIVITY_TYPE.BMI:
	    case _constants.VITALS_ACTIVITY_TYPE.WEIGHT:
	      {
	        return formatMessage({
	          id: 'patient.healthboard.average' + (!short ? 'Data' : '')
	        });
	      }
	    case _constants.VITALS_ACTIVITY_TYPE.HEART_RATE:
	    case _constants.VITALS_ACTIVITY_TYPE.SATURATION:
	    case _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE:
	      {
	        return formatMessage({
	          id: 'patient.healthboard.minMax' + (!short ? 'Data' : '')
	        });
	      }
	    default:
	      return '';
	  }
	};
	
	var checkForAvailableSourceData = exports.checkForAvailableSourceData = function checkForAvailableSourceData(rowData) {
	  return rowData && rowData.measurements && rowData.measurements.length !== 0;
	};
	
	var getSourceDataWithType = exports.getSourceDataWithType = function getSourceDataWithType(data, type) {
	  return data.find(function (_ref18) {
	    var provider = _ref18.provider;
	
	    return provider.code === type;
	  });
	};
	
	var createTooltips = exports.createTooltips = function createTooltips(data) {
	  if (data && data.length > 0) {
	    var tooltipsArr = (0, _range2.default)(data.length).map(function () {
	      return [];
	    });
	    data.forEach(function (dataset, index) {
	      tooltipsArr[index].push(dataset.data.map(function () {
	        return { keepTooltipOpen: false };
	      }));
	    });
	    return tooltipsArr;
	  }
	  return [];
	};
	
	var adaptHistoricResponse = exports.adaptHistoricResponse = function adaptHistoricResponse(rowData) {
	  return rowData && rowData.length > 0 ? rowData.map(function (item) {
	    return (0, _extends3.default)({}, item, {
	      value: item.value.baseValue
	    });
	  }) : [];
	};
	
	var adaptResponse = exports.adaptResponse = function adaptResponse(rowData, convertingOptionData) {
	  if (rowData && rowData.length > 0) {
	    return rowData.map(function (item) {
	      var isAvailableMeasurements = item.measurements && item.measurements.length > 0;
	      return (0, _extends3.default)({}, item, {
	        measurements: isAvailableMeasurements ? item.measurements.map(function (entity) {
	          return (0, _extends3.default)({}, entity, {
	            value: convertingOptionData ? getConvertedSafeData(entity.value.baseValue, convertingOptionData) : entity.value.baseValue
	          });
	        }) : []
	      });
	    });
	  }
	  return [];
	};
	
	var getLengthMonth = exports.getLengthMonth = function getLengthMonth() {
	  var now = (0, _moment2.default)();
	  var end = (0, _moment2.default)().subtract(1, 'month');
	  var duration = _moment2.default.duration(now.diff(end));
	  return duration.asDays();
	};
	
	var calculateAverageValue = exports.calculateAverageValue = function calculateAverageValue(data) {
	  var safeArr = (0, _compact2.default)(data);
	  return safeArr.reduce(function (accumulator, currentEntity) {
	    return accumulator + currentEntity;
	  }, 0) / safeArr.length;
	};
	
	var calculateDeltaScale = exports.calculateDeltaScale = function calculateDeltaScale(dataArr, weekOrMonth) {
	  var safeArr = weekOrMonth ? dataArr.map(function (item) {
	    return (0, _extends3.default)({}, item, {
	      min: item.value.min,
	      max: item.value.max
	    });
	  }) : dataArr;
	  var maxValueForRange = (0, _compact2.default)([].concat((0, _toConsumableArray3.default)(safeArr))).reduce(function (prev, current) {
	    return prev.max > current.max ? prev : current;
	  }, {}).max;
	
	  var minValueForRange = (0, _compact2.default)([].concat((0, _toConsumableArray3.default)(safeArr))).reduce(function (prev, current) {
	    return prev.min < current.min ? prev : current;
	  }, {}).min;
	
	  var deltaScale = (maxValueForRange - minValueForRange) * _constants.THICKNESS_BY_Y_AXIS / 15;
	  return deltaScale < 0.1 ? 0.1 : deltaScale;
	};
	
	var calculateMinMaxRangeForRawValue = exports.calculateMinMaxRangeForRawValue = function calculateMinMaxRangeForRawValue(rawData) {
	  if (rawData && rawData.length > 0) {
	    var allValues = [];
	    rawData.forEach(function (_ref19) {
	      var measurements = _ref19.measurements;
	
	      if (measurements && measurements.length > 0) {
	        measurements.forEach(function (_ref20) {
	          var value = _ref20.value;
	
	          if (value && value.baseValue) allValues.push(value.baseValue);
	          if (value && value.bpDiastolic) {
	            allValues.push(value.bpDiastolic);
	            allValues.push(value.bpSystolic);
	          }
	        });
	      }
	    });
	
	    var rawMin = Math.min.apply(Math, allValues);
	    var rawMax = Math.max.apply(Math, allValues);
	
	    var calculatedRawMin = rawMin - (rawMax - rawMin === 0 ? rawMax : rawMax - rawMin) * 0.2;
	    var calculatedRawMax = rawMax + (rawMax - rawMin === 0 ? rawMax : rawMax - rawMin) * 0.2;
	
	    return {
	      min: calculatedRawMin && calculatedRawMin > 0 ? calculatedRawMin : 0,
	      max: calculatedRawMax && calculatedRawMax > 0 ? calculatedRawMax : 0
	    };
	  }
	
	  return { min: 0, max: 0 };
	};
	
	var getCategoryPercentageWithOneSource = exports.getCategoryPercentageWithOneSource = function getCategoryPercentageWithOneSource(value, forOneSource) {
	  return forOneSource ? value / 2 : value;
	};
	
	var getConvertedSafeData = exports.getConvertedSafeData = function getConvertedSafeData(value, optionConverting) {
	  var type = optionConverting.type,
	      isMilligramsPerDeciliter = optionConverting.isMilligramsPerDeciliter,
	      forRound = optionConverting.forRound;
	
	  switch (type) {
	    case _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE:
	      return formatGlucoseValueWithMetric(value, isMilligramsPerDeciliter, forRound);
	    default:
	      return value;
	  }
	};
	
	var getOriginalProviderCode = exports.getOriginalProviderCode = function getOriginalProviderCode(originalProviderCodes) {
	  if (!originalProviderCodes) {
	    return '';
	  }
	  if (typeof originalProviderCodes === 'string') {
	    return originalProviderCodes;
	  }
	
	  return originalProviderCodes.length === 1 ? originalProviderCodes[0] : _constants.DATA_SOURCE_TYPE.ALL_SOURCES;
	};
	
	var getSourceCodeByPeriod = function getSourceCodeByPeriod(sourceDataCodes, tooltipDate, comparePeriod, getSafeDataSourceTitle, formatMessage) {
	  var filteredDataCodes = sourceDataCodes.filter(function (el) {
	    return (0, _moment2.default)(new Date(tooltipDate)).isSame(new Date(el.measuredAt), comparePeriod);
	  });
	  var providerCodes = filteredDataCodes.map(function (el) {
	    return el.providerCode;
	  });
	  var uniqProviderCodes = [].concat((0, _toConsumableArray3.default)(new _set2.default(providerCodes.flat(1))));
	  return getSafeDataSourceTitle(getOriginalProviderCode(uniqProviderCodes), formatMessage);
	};
	
	var sourceDataCodeFilteredByDate = exports.sourceDataCodeFilteredByDate = function sourceDataCodeFilteredByDate(sourceDataCodes, period, tooltipDate, formatMessage, getSafeDataSourceTitle) {
	  switch (period) {
	    case DAY.type:
	      {
	        var filteredDataCodes = sourceDataCodes.filter(function (el) {
	          var roundDown = (0, _moment2.default)(new Date(el.measuredAt)).startOf('minute').toString();
	          return (0, _moment2.default)(new Date(tooltipDate)).isSame(new Date(roundDown));
	        });
	        var providerCodes = filteredDataCodes.map(function (el) {
	          return el.providerCode;
	        });
	        var uniqProviderCodes = [].concat((0, _toConsumableArray3.default)(new _set2.default(providerCodes.flat(1))));
	        return getSafeDataSourceTitle(getOriginalProviderCode(uniqProviderCodes), formatMessage);
	      }
	    case WEEK.type:
	    case MONTH.type:
	      {
	        return getSourceCodeByPeriod(sourceDataCodes, tooltipDate, _constants2.PERIOD.DAY, getSafeDataSourceTitle, formatMessage);
	      }
	
	    case QUARTER.type:
	    case YEAR.type:
	      {
	        return getSourceCodeByPeriod(sourceDataCodes, tooltipDate, _constants2.PERIOD.MONTH, getSafeDataSourceTitle, formatMessage);
	      }
	  }
	};
	
	var getTooltipDate = exports.getTooltipDate = function getTooltipDate(sourceDataCode, data, tooltip, isCandleDataType, isGrafTypeLine, filterType) {
	  if (isCandleDataType) {
	    return sourceDataCode === _constants.DATA_SOURCE_TYPE.CCD ? data.timeSets.ccd[tooltip.index] : data.timeSets.devices[tooltip.index];
	  }
	  if (isGrafTypeLine) {
	    var forQuarterYear = [QUARTER.type, YEAR.type].includes(filterType);
	
	    if (sourceDataCode === _constants.DATA_SOURCE_TYPE.CCD) {
	      return forQuarterYear ? data.timeSets[tooltip.index] : data.datasets[tooltip.datasetIndex].data[tooltip.index].timeStamp;
	    }
	    return data.timeSets[tooltip.index] || '';
	  }
	  return data.timeSets[tooltip.index] || '';
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.channelBlockedStateSelector = exports.isSocialChannelSelector = exports.isDefaultChannelSelector = exports.isReadOnlyContextSelector = exports.channelTitleSelector = exports.activeSocialChatTitleSelector = exports.activeContextChannelSelector = exports.defaultChannelIdSelector = exports.lastActiveChannelIdSelector = exports.activeTargetUserChannelSelector = exports.activeSocialChannelSelector = exports.socialChatSelector = exports.socialChannelSelector = exports.nextActiveTargetUserChannelSelector = exports.availableTargetUserChannelsDataSelector = exports.availableSortedTargetUserChannelsSelector = exports.availableTargetUserChannelsSelector = exports.activeChannelSelector = exports.activeChannelIdSelector = exports.activeUnreadCountSelector = exports.allChatSelector = exports.lastActiveChannelsSelector = exports.downloadsSelector = exports.uploadsSelector = exports.joinedChannelsSelector = exports.availableChannelsSelector = exports.chatModuleInstanceSelector = exports.connectionReadySelector = exports.connectionOpenedSelector = exports.chatConnectionSelector = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _CHAT_TAB_CONSTANTS;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _camelCase = __webpack_require__(322);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _uniq = __webpack_require__(380);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _has = __webpack_require__(1555);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _sorting = __webpack_require__(1936);
	
	var _sorting2 = _interopRequireDefault(_sorting);
	
	var _props = __webpack_require__(41);
	
	var _settings = __webpack_require__(405);
	
	var _chat = __webpack_require__(67);
	
	var _strings = __webpack_require__(15);
	
	var _selectors = __webpack_require__(23);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ATTR = 'totalUnreadCount';
	var CHAT_ATTR = 'unreadCount';
	
	// helpers
	
	var getGroupChannels = function getGroupChannels(channels) {
	  var arrayOfChannels = (0, _keys2.default)(channels).map(function (key) {
	    return channels[key];
	  });
	
	  return (0, _sorting2.default)(arrayOfChannels, _props.LAST_MESSAGE_SORTING);
	};
	
	// selectors
	var chatConnectionSelector = exports.chatConnectionSelector = function chatConnectionSelector(state) {
	  return state.chatConnection;
	};
	var connectionOpenedSelector = exports.connectionOpenedSelector = function connectionOpenedSelector(state) {
	  return state.chatConnection.opened;
	};
	var connectionReadySelector = exports.connectionReadySelector = function connectionReadySelector(state) {
	  return state.chatConnection.ready;
	};
	var chatModuleInstanceSelector = exports.chatModuleInstanceSelector = function chatModuleInstanceSelector(state) {
	  return state.chatConnection.chatModuleInstance;
	};
	var availableChannelsSelector = exports.availableChannelsSelector = function availableChannelsSelector(state) {
	  return state.chatConnection.availableChannels;
	};
	var joinedChannelsSelector = exports.joinedChannelsSelector = function joinedChannelsSelector(state) {
	  return state.chatConnection.joinedChannels;
	};
	var uploadsSelector = exports.uploadsSelector = function uploadsSelector(state) {
	  return state.chatConnection.uploads;
	};
	var downloadsSelector = exports.downloadsSelector = function downloadsSelector(state) {
	  return state.chatConnection.downloads;
	};
	var lastActiveChannelsSelector = exports.lastActiveChannelsSelector = function lastActiveChannelsSelector(state) {
	  return state.chatConnection.lastActiveChannelIds;
	};
	var allChatSelector = exports.allChatSelector = function allChatSelector(state) {
	  return state.board.channels;
	};
	var activeUnreadCountSelector = exports.activeUnreadCountSelector = function activeUnreadCountSelector(state) {
	  return state.chatConnection.activeUnreadCount;
	};
	// active channel selectors
	var activeChannelIdSelector = exports.activeChannelIdSelector = (0, _reselect.createSelector)(chatConnectionSelector, function (chat) {
	  return (0, _get2.default)(chat, 'activeChannelId');
	});
	
	var activeChannelSelector = exports.activeChannelSelector = (0, _reselect.createSelector)(joinedChannelsSelector, activeChannelIdSelector, function (channels, id) {
	  return (0, _get2.default)(channels, id);
	});
	
	var CHAT_TAB_CONSTANTS = (_CHAT_TAB_CONSTANTS = {}, (0, _defineProperty3.default)(_CHAT_TAB_CONSTANTS, _chat.FAMILY_CHANNEL, {
	  title: _strings.CHAT.titles.familyChatTab,
	  icon: _chat.ICONS.generalChatTab
	}), (0, _defineProperty3.default)(_CHAT_TAB_CONSTANTS, _chat.ACTIVITIES_CHANNEL, {
	  title: _strings.CHAT.titles.activitiesChatTab,
	  icon: _chat.ICONS.activitiesChatTab
	}), (0, _defineProperty3.default)(_CHAT_TAB_CONSTANTS, _chat.NOTIFICATIONS_CHANNEL, {
	  title: _strings.CHAT.titles.notificationsChatTab,
	  icon: _chat.ICONS.notificationsChatTab
	}), (0, _defineProperty3.default)(_CHAT_TAB_CONSTANTS, _chat.PRIVATE_CHANNEL, {
	  icon: _chat.ICONS.generalChatTab
	}), (0, _defineProperty3.default)(_CHAT_TAB_CONSTANTS, _chat.GROUP_CHANNEL, {
	  icon: _chat.ICONS.generalChatTab
	}), _CHAT_TAB_CONSTANTS);
	
	var availableTargetUserChannelsSelector = exports.availableTargetUserChannelsSelector = (0, _reselect.createSelector)(availableChannelsSelector, _settings.lastUserIdSelector, joinedChannelsSelector, function (apiChannels, userId, chatChannels) {
	  var channels = (0, _get2.default)(apiChannels, [userId], {});
	
	  if (!channels || (0, _isEmpty2.default)(channels)) return null;
	
	  var connectedChannels = (0, _keys2.default)(channels).reduce(function (acc, key) {
	    var _extends2;
	
	    var apiChannel = (0, _get2.default)(channels, [key]);
	    var chatChannel = (0, _get2.default)(chatChannels, [key]);
	
	    var unreads = chatChannel ? (0, _get2.default)(chatChannel, [CHAT_ATTR]) : (0, _get2.default)(channels, [key, ATTR]);
	
	    var lastMessageAt = (0, _get2.default)(chatChannel, 'lastMessageAt') || (0, _get2.default)(apiChannel, 'lastMessageAt');
	    var inboxTaskId = (0, _get2.default)(chatChannel, 'inboxTaskId') || (0, _get2.default)(apiChannel, 'inboxTaskId');
	
	    acc[key] = (0, _extends4.default)({}, apiChannel, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, ATTR, unreads), (0, _defineProperty3.default)(_extends2, 'lastMessageAt', lastMessageAt), (0, _defineProperty3.default)(_extends2, 'inboxTaskId', inboxTaskId), _extends2));
	
	    return acc;
	  }, {});
	
	  return connectedChannels;
	});
	
	var availableSortedTargetUserChannelsSelector = exports.availableSortedTargetUserChannelsSelector = (0, _reselect.createSelector)(availableTargetUserChannelsSelector, function (channels) {
	  if ((0, _isEmpty2.default)(channels)) return [];
	
	  return (0, _uniq2.default)([].concat((0, _toConsumableArray3.default)(getGroupChannels(channels))).filter(Boolean));
	});
	
	var availableTargetUserChannelsDataSelector = exports.availableTargetUserChannelsDataSelector = (0, _reselect.createSelector)(availableSortedTargetUserChannelsSelector, _selectors.hasProviderProfileSelector, function (channels, isProvider) {
	  var defaultChannels = channels.map(function (channel) {
	    var channelName = (0, _camelCase2.default)(channel.channelName);
	
	    var icon = channel.type === 'system' ? (0, _get2.default)(CHAT_TAB_CONSTANTS, [channelName, 'icon'], 'community') : (0, _get2.default)(CHAT_TAB_CONSTANTS, [channel.type, 'icon'], 'community');
	
	    var title = channel.type === 'system' ? (0, _get2.default)(CHAT_TAB_CONSTANTS, [channelName, 'title'], channelName) : channel.channelName;
	
	    return (0, _extends4.default)({}, channel, {
	      icon: icon,
	      title: title
	    });
	  });
	
	  return isProvider ? [_constants.APPOINTMENT_MENU].concat((0, _toConsumableArray3.default)(defaultChannels)) : [].concat((0, _toConsumableArray3.default)(defaultChannels));
	});
	
	var nextActiveTargetUserChannelSelector = exports.nextActiveTargetUserChannelSelector = (0, _reselect.createSelector)(availableChannelsSelector, _settings.lastUserIdSelector, activeChannelIdSelector, function (channels, userId, channelId) {
	  if ((0, _isEmpty2.default)(channels)) {
	    return { channelId: channelId };
	  }
	
	  if ((0, _isEmpty2.default)(channels) || !userId || !channelId) return null;
	
	  return (0, _get2.default)(channels, [userId, channelId], null);
	});
	
	var socialChannelSelector = exports.socialChannelSelector = (0, _reselect.createSelector)(allChatSelector, function (channels) {
	  return channels.filter(function (item) {
	    return (0, _has2.default)(item, 'contextChannel');
	  });
	});
	
	var socialChatSelector = exports.socialChatSelector = (0, _reselect.createSelector)(socialChannelSelector, function (channels) {
	  return channels.map(function (item) {
	    return item.contextChannel;
	  });
	});
	
	var activeSocialChannelSelector = exports.activeSocialChannelSelector = (0, _reselect.createSelector)(socialChatSelector, activeChannelIdSelector, function (channels, channelId) {
	  if (channelId) {
	    return channels.find(function (item) {
	      return item.channelId === channelId;
	    });
	  }
	  return null;
	});
	
	var activeTargetUserChannelSelector = exports.activeTargetUserChannelSelector = (0, _reselect.createSelector)(joinedChannelsSelector, activeChannelIdSelector, function (channels, channelId) {
	  if ((0, _isEmpty2.default)(channels) || !channelId) return null;
	
	  return (0, _get2.default)(channels, channelId, null);
	});
	
	var lastActiveChannelIdSelector = exports.lastActiveChannelIdSelector = (0, _reselect.createSelector)(lastActiveChannelsSelector, _settings.lastUserIdSelector, function (channels, userId) {
	  return channels.find(function (item) {
	    return item.targetUserId === userId;
	  });
	});
	
	// todo: problem is here
	var defaultChannelIdSelector = exports.defaultChannelIdSelector = (0, _reselect.createSelector)(availableTargetUserChannelsDataSelector, activeChannelIdSelector, lastActiveChannelIdSelector, function (channels, activeChannelId, lastChannel) {
	  if (!channels || (0, _isEmpty2.default)(channels)) return null;
	
	  var arrayOfChannels = (0, _keys2.default)(channels).map(function (key) {
	    return channels[key];
	  });
	  if (arrayOfChannels.find(function (item) {
	    return item.channelId === activeChannelId;
	  })) {
	    return activeChannelId;
	  }
	
	  if (lastChannel) {
	    return lastChannel.id;
	  }
	
	  return (0, _get2.default)(arrayOfChannels[0], 'channelId');
	});
	
	var activeContextChannelSelector = exports.activeContextChannelSelector = (0, _reselect.createSelector)(availableTargetUserChannelsDataSelector, activeChannelIdSelector, function (channels, channelId) {
	  return channels.find(function (item) {
	    return item.channelId === channelId;
	  });
	});
	
	var activeSocialChatTitleSelector = exports.activeSocialChatTitleSelector = (0, _reselect.createSelector)(activeSocialChannelSelector, function (channel) {
	  return (0, _get2.default)(channel, 'channelName');
	});
	
	var channelTitleSelector = exports.channelTitleSelector = (0, _reselect.createSelector)(activeSocialChatTitleSelector, activeContextChannelSelector, function (social, context) {
	  return social || (0, _get2.default)(context, 'title');
	});
	
	var isReadOnlyContextSelector = exports.isReadOnlyContextSelector = (0, _reselect.createSelector)(activeContextChannelSelector, function (channel) {
	  var channelName = (0, _get2.default)(channel, 'channelName');
	  return [_chat.NOTIFICATIONS_CHANNEL, _chat.ACTIVITIES_CHANNEL].includes(channelName);
	});
	
	var isDefaultChannelSelector = exports.isDefaultChannelSelector = (0, _reselect.createSelector)(activeContextChannelSelector, function (channel) {
	  var channelName = (0, _get2.default)(channel, 'channelName');
	  return [_chat.NOTIFICATIONS_CHANNEL, _chat.ACTIVITIES_CHANNEL, 'family_circle'].includes(channelName);
	});
	
	var isSocialChannelSelector = exports.isSocialChannelSelector = (0, _reselect.createSelector)(activeSocialChannelSelector, function (channel) {
	  return !!channel;
	});
	
	var channelBlockedStateSelector = exports.channelBlockedStateSelector = (0, _reselect.createSelector)(activeSocialChannelSelector, activeContextChannelSelector, function (social, context) {
	  return (0, _get2.default)(social || context, 'blocked');
	});

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _strings = __webpack_require__(15);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _brandConfig = __webpack_require__(142);
	
	var _styles = __webpack_require__(18);
	
	var _selectors = __webpack_require__(93);
	
	var _index = __webpack_require__(5180);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackButton = function BackButton(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      onBack = _ref.onBack,
	      disabled = _ref.disabled,
	      minWidth = _ref.minWidth,
	      className = _ref.className,
	      title = _ref.title,
	      isLoggedIn = _ref.isLoggedIn,
	      _ref$hasTitle = _ref.hasTitle,
	      hasTitle = _ref$hasTitle === undefined ? true : _ref$hasTitle;
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { minWidth: minWidth },
	    _react2.default.createElement(
	      _ClickableElement2.default,
	      {
	        className: className,
	        styleName: (0, _classnames2.default)('back', { disabled: disabled }),
	        onClick: function onClick() {
	          return onBack();
	        }
	      },
	      _react2.default.createElement(_Icon2.default, {
	        name: _brandConfig.isFlagler && !isLoggedIn ? 'arrow-left' : 'back-healthboard',
	        size: 24,
	        style: {
	          fill: _styles.COLORS.darkSlateBlue
	        }
	      }),
	      _react2.default.createElement(
	        'span',
	        { styleName: 'back__title' },
	        hasTitle && formatMessage(title)
	      )
	    )
	  );
	};
	
	BackButton.propTypes = {
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  onBack: _propTypes2.default.func,
	  minWidth: _propTypes2.default.number,
	  title: _propTypes2.default.shape({ id: _propTypes2.default.string }),
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  isLoggedIn: _propTypes2.default.bool,
	  hasTitle: _propTypes2.default.bool
	};
	
	BackButton.defaultProps = {
	  className: '',
	  onBack: function onBack() {},
	  title: _strings.COMMON.back,
	  minWidth: _styles.BREAKPOINT
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoggedIn: (0, _selectors.isLoggedInSelector)(state)
	  };
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(BackButton);

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LENGTH_VALUES = exports.LENGTH_VALUES = {
	  SSN_LAST_4: 4,
	  SSN: 9,
	  MRNS: 10,
	  CITIZENSHIP: 30,
	  PHONE_NUMBER: { MAX: 14, MIN: 7 },
	  HOME_PHONE: { MAX: 14, MIN: 8 },
	  EMERGENCY_PHONE: { MAX: 11, MIN: 7 },
	  PASSWORD: { MAX: 256, MIN: 6 },
	  LAST_NAME: { MAX: 40, MIN: 1 },
	  FIRST_NAME: { MAX: 40, MIN: 1 },
	  MIDDLE_NAME: { MAX: 40, MIN: 1 },
	  USERNAME: { MAX: 70, MIN: 3 },
	  ALIAS: { MAX: 16, MIN: 1 },
	  ADDRESS_1: { MAX: 40, MIN: 1 },
	  ADDRESS_2: { MAX: 40, MIN: 1 },
	  CITY: { MAX: 30, MIN: 1 },
	  STATE: { MAX: 20, MIN: 1 },
	  POSTAL_CODE: { MAX: 10, MIN: 5 },
	  COUNTRY: { MAX: 20, MIN: 1 },
	  BIO: { MAX: 500, MIN: 1 },
	  ORGANIZATION: { MAX: 500, MIN: 1 },
	  REASON_NOTE: { MAX: 50 },
	  ROOM: { MAX: 10 },
	  COPAY: { MAX: 10 },
	  CHAT_NAME: { MAX: 64 },
	  MEMBER_ID: { MIN: 2, MAX: 80 },
	  GROUP_NUMBER: { MIN: 1, MAX: 50 }
	};
	
	var PATTERNS = exports.PATTERNS = {
	  USERNAME_CHARACTERS: /^[A-Za-z0-9 @._+-]+$/,
	  USERNAME_REPEATING: /^(?!.*@.*@)(?!.*\+.*\+)[A-Za-z0-9 @.+_-]{1,70}$/,
	  USERNAME_NO_SPACES: /^\S+$/,
	  USERNAME_SPACES_AND_REPEATING: /^(?!.*\s)(?!.*([;:,\\|/±!?#$%^&*(){}@._+-])\1)[A-Za-z0-9;:,\\|/±!?#$%^&*(){}@._+-]+$/,
	  USERNAME: /^(?!.*@.*@)(?!.*\+.*\+)[A-Za-z0-9@.+_-]{3,70}$/,
	  POSTAL_CODE: /^\d{5}$|^\d{5}-\d{4}$/,
	  PASSWORD: {
	    LOWER_CASE_CHARACTER: /(?=.*[a-z])/,
	    UPPER_CASE_CHARACTER: /(?=.*[A-Z])/,
	    NUMERIC_CHARACTER: /(?=.*\d)/,
	    SPECIAL_CHARACTER: /(?=.*[^a-zA-Z0-9\s ])/,
	    MIN_LENGTH: /(?=.{6,})/
	  },
	  AMOUNT: /^\d+(\.\d{0,2})?$/,
	  SSN: /^\d+$/,
	  PHONE_HOME: /^\d{8,14}$/,
	  // email rule from backend
	  EMAIL: /^[\w+\-.]+@[a-z\d\-]+(\.[a-z\d\-]+)*\.[a-z]+$/,
	  PHONE_NUMBER: /^\+?\d{10,14}$/,
	  HAS_ALPHABETICAL_CHARACTER: /(?=.*[a-zA-Z])/,
	  ONLY_NUMERIC: /\D/g,
	  YYYY_MM_DD_REGEX: /^\d{4}-\d{2}-\d{2}$/,
	  REGEXP_SPECIAL_CHARS: /[.*+?^${}()|[\]\\]/g,
	  URL: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&/=]*)/gim,
	  CHARACTERS: /[+\-_%@.]/g
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectPaperworkAppointmentTenantSkipInsurance = exports.selectPaperworkAppointmentPaperworkCompleted = exports.selectPaperworkAppointmentPcpData = exports.selectPaperworkAppointmentQuestionAnswers = exports.selectPaperworkAppointmentServiceId = exports.selectPaperworkAppointmentOrgId = exports.selectPaperworkAppointmentConsentsCount = exports.selectPaperworkAppointmentConsents = exports.selectPaperworkAppointmentIsAllConsentsSigned = exports.selectPaperworkAppointmentUserId = exports.selectPaperworkAppointmentVisitTypeCode = exports.selectPaperworkAppointmentId = exports.selectPaperworkAppointmentDataError = exports.selectPaperworkAppointmentDataSucceed = exports.selectPaperworkAppointmentDataPending = exports.selectPaperworkAppointmentData = exports.selectRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'paperwork.paperworkAppointmentDetails');
	};
	
	var selectPaperworkAppointmentData = exports.selectPaperworkAppointmentData = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _omit2.default)(state, 'sending', 'error', 'succeed', 'rejected');
	});
	
	var selectPaperworkAppointmentDataPending = exports.selectPaperworkAppointmentDataPending = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectPaperworkAppointmentDataSucceed = exports.selectPaperworkAppointmentDataSucceed = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'succeed');
	});
	
	var selectPaperworkAppointmentDataError = exports.selectPaperworkAppointmentDataError = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'error');
	});
	
	var selectPaperworkAppointmentId = exports.selectPaperworkAppointmentId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'id', null);
	});
	
	var selectPaperworkAppointmentVisitTypeCode = exports.selectPaperworkAppointmentVisitTypeCode = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'visitType.code');
	});
	
	var selectPaperworkAppointmentUserId = exports.selectPaperworkAppointmentUserId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'userId', null);
	});
	
	var selectPaperworkAppointmentIsAllConsentsSigned = exports.selectPaperworkAppointmentIsAllConsentsSigned = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'consentsAssignment.allSigned', false);
	});
	
	var selectPaperworkAppointmentConsents = exports.selectPaperworkAppointmentConsents = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'consentsAssignment.consents', []);
	});
	
	var selectPaperworkAppointmentConsentsCount = exports.selectPaperworkAppointmentConsentsCount = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'consentsAssignment.consentsCount', 0);
	});
	
	var selectPaperworkAppointmentOrgId = exports.selectPaperworkAppointmentOrgId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'organization.id', null);
	});
	
	var selectPaperworkAppointmentServiceId = exports.selectPaperworkAppointmentServiceId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'service.id', null);
	});
	
	var selectPaperworkAppointmentQuestionAnswers = exports.selectPaperworkAppointmentQuestionAnswers = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'questionAnswers', null);
	});
	
	var selectPaperworkAppointmentPcpData = exports.selectPaperworkAppointmentPcpData = (0, _reselect.createSelector)(selectRootState, function (state) {
	  var pcpProviderAnswer = state.pcpProviderAnswer,
	      pcpName = state.pcpName,
	      considerUsPcp = state.considerUsPcp,
	      primaryCareProvider = state.primaryCareProvider;
	
	  return { pcpProviderAnswer: pcpProviderAnswer, pcpName: pcpName, considerUsPcp: considerUsPcp, primaryCareProvider: primaryCareProvider };
	});
	
	var selectPaperworkAppointmentPaperworkCompleted = exports.selectPaperworkAppointmentPaperworkCompleted = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'paperworkCompleted', false);
	});
	
	var selectPaperworkAppointmentOrganization = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'organization', {});
	});
	
	var selectPaperworkAppointmentTenantSkipInsurance = exports.selectPaperworkAppointmentTenantSkipInsurance = (0, _reselect.createSelector)(selectPaperworkAppointmentOrganization, function (state) {
	  return (0, _get2.default)(state, 'tenant.skipInsurance', false);
	});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatShortTimeByLocale = exports.formatDayMonth = exports.formatDateToMonthDayYearShort = exports.formatToMonthDayYear = exports.isBeforeTime = exports.yesterday = exports.isBetweenTimeRange = exports.rangeLimitFactory = exports.formatWithTimezone = exports.formatFullDater = exports.formatDateByYear = exports.formatDate = exports.formatDateTime = exports.getLastMessageTime = exports.adaptDateToLocalTimezone = exports.convertDateToUIFormat = exports.convertDateToAPIFormat = undefined;
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.isNewDayInList = isNewDayInList;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _format = __webpack_require__(319);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _add_hours = __webpack_require__(4698);
	
	var _add_hours2 = _interopRequireDefault(_add_hours);
	
	var _is_same_day = __webpack_require__(937);
	
	var _is_same_day2 = _interopRequireDefault(_is_same_day);
	
	var _is_same_year = __webpack_require__(2177);
	
	var _is_same_year2 = _interopRequireDefault(_is_same_year);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _momentTimezone = __webpack_require__(2403);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	var _validateDate = __webpack_require__(1942);
	
	var _validateDate2 = _interopRequireDefault(_validateDate);
	
	var _i18n = __webpack_require__(1219);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function splitUIDate(string) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
	
	  var filterRegexIEBug = /[^ -~]/g;
	  var parts = string.split(separator).map(function (item) {
	    return item.replace(filterRegexIEBug, '');
	  });
	
	  var day = parseInt(parts[1], 10);
	  var month = parseInt(parts[0], 10);
	  var year = parseInt(parts[2], 10);
	
	  return { year: year, month: month, day: day };
	}
	
	function createDate(_ref) {
	  var year = _ref.year,
	      month = _ref.month,
	      day = _ref.day;
	
	  // validate text input [UI]
	  if (!(0, _validateDate2.default)(year, month, day)) return null;
	
	  var date = new Date();
	  // allow 0-99 year range
	  date.setFullYear(year);
	  date.setMonth(month - 1);
	  date.setDate(day);
	
	  return date;
	}
	
	// assume we have dateString mm-dd-yyyy. TODO: maybe switch to default timestamps
	function convertUIDateToPattern(inputDate, pattern) {
	  if (!inputDate) return inputDate;
	
	  var date = (typeof inputDate === 'undefined' ? 'undefined' : (0, _typeof3.default)(inputDate)) === 'object' ? inputDate : createDate(splitUIDate(inputDate));
	
	  if (date) return (0, _format2.default)(date, pattern);
	
	  return null;
	}
	
	function convertAPIDateToPattern(dateString, pattern) {
	  if (!dateString) return dateString;
	
	  var dateParts = dateString.split('-');
	  var day = parseInt(dateParts[2], 10);
	  var month = parseInt(dateParts[1], 10);
	  var year = parseInt(dateParts[0], 10);
	
	  if ((0, _validateDate2.default)(year, month, day)) {
	    return (0, _format2.default)(createDate({ year: year, month: month, day: day }), pattern);
	  }
	
	  return null;
	}
	
	var convertDateToAPIFormat = exports.convertDateToAPIFormat = function convertDateToAPIFormat(date, formatMessage) {
	  return convertUIDateToPattern(date, formatMessage(_strings.DATE_PATTERN_API));
	};
	
	var convertDateToUIFormat = exports.convertDateToUIFormat = function convertDateToUIFormat(date, formatMessage) {
	  return convertAPIDateToPattern(date, formatMessage(_strings.DATE_PATTERN_UI));
	};
	
	// for the future implementations - if we need to change timezone offset, now offset is 0
	var adaptDateToLocalTimezone = exports.adaptDateToLocalTimezone = function adaptDateToLocalTimezone(date) {
	  return (0, _add_hours2.default)(date, 0);
	};
	
	var getLastMessageTime = exports.getLastMessageTime = function getLastMessageTime(date, formatMessage) {
	  var adaptedDate = adaptDateToLocalTimezone(date);
	  var finalFormat = (0, _is_same_day2.default)(adaptedDate, new Date()) ? formatMessage(_strings.TIME_PATTERN) : formatMessage(_strings.SHORT_DATE_PATTERN) + ' ' + formatMessage(_strings.TIME_PATTERN);
	
	  return (0, _format2.default)(adaptedDate, finalFormat);
	};
	
	var formatDateTime = exports.formatDateTime = function formatDateTime(date, formatMessage) {
	  var adaptedDate = adaptDateToLocalTimezone(date);
	  var pattern = adaptedDate && (0, _is_same_day2.default)(adaptedDate, new Date()) ? formatMessage(_strings.TIME_PATTERN) : formatMessage(_strings.SHORT_DATE_PATTERN) + ' ' + formatMessage(_strings.TIME_PATTERN);
	
	  return adaptedDate && (0, _format2.default)(adaptedDate, pattern);
	};
	
	var formatDate = exports.formatDate = function formatDate(date, formatMessage) {
	  var pattern = formatMessage(_strings.SHORT_DATE_PATTERN);
	  return (0, _format2.default)(date, pattern);
	};
	
	var formatDateByYear = exports.formatDateByYear = function formatDateByYear(date, formatMessage) {
	  var finalFormat = (0, _is_same_year2.default)(date, new Date()) ? formatMessage(_strings.SHORT_DATE_PATTERN) : formatMessage(_strings.FULL_SHORT_DATE_PATTERN);
	
	  return date && (0, _format2.default)(date, finalFormat);
	};
	
	var formatFullDater = exports.formatFullDater = function formatFullDater(date, formatMessage) {
	  return date && (0, _format2.default)(date, formatMessage(_strings.FULL_SHORT_DATE_PATTERN));
	};
	
	var formatWithTimezone = exports.formatWithTimezone = function formatWithTimezone(date, timezone, formatMessage) {
	  var finalFormat = (0, _is_same_year2.default)(date, new Date()) ? formatMessage(_strings.SHORT_DATE_PATTERN) : formatMessage(_strings.FULL_SHORT_DATE_PATTERN);
	
	  return (0, _momentTimezone2.default)(date).tz(timezone).format(finalFormat);
	};
	
	function isNewDayInList(list, index, useDestruction) {
	  if (index === 0) return true;
	  var previousTime = useDestruction ? adaptDateToLocalTimezone(list[index - 1].payload.createdAt) : adaptDateToLocalTimezone(list[index - 1].createdAt);
	  var nextTime = useDestruction ? adaptDateToLocalTimezone(list[index].payload.createdAt) : adaptDateToLocalTimezone(list[index].createdAt);
	  return !(0, _is_same_day2.default)(previousTime, nextTime);
	}
	
	var rangeLimitFactory = exports.rangeLimitFactory = function rangeLimitFactory(pastLimit, futureLimit) {
	  var start = (0, _moment2.default)().add(pastLimit, 'd').startOf('day');
	  var end = (0, _moment2.default)().add(futureLimit, 'd').endOf('day');
	
	  return function isBetweenLimit(date) {
	    return date.isBetween(start, end, null, '[]');
	  };
	};
	
	var isBetweenTimeRange = exports.isBetweenTimeRange = function isBetweenTimeRange(_ref2) {
	  var time = _ref2.time,
	      startTime = _ref2.startTime,
	      endTime = _ref2.endTime,
	      formatType = _ref2.formatType;
	
	  var pickedTime = (0, _moment2.default)(time, formatType);
	  var beforeTime = (0, _moment2.default)(startTime, formatType);
	  var afterTime = (0, _moment2.default)(endTime, formatType);
	
	  return pickedTime.isBetween(beforeTime, afterTime);
	};
	
	var yesterday = exports.yesterday = function (d) {
	  return new Date(d.setDate(d.getDate() - 1));
	}(new Date());
	
	var isBeforeTime = exports.isBeforeTime = function isBeforeTime(start, end) {
	  var mStart = (0, _moment2.default)(start);
	  var mEnd = (0, _moment2.default)(end);
	  return mStart.isBefore(mEnd);
	};
	
	var formatToMonthDayYear = exports.formatToMonthDayYear = function formatToMonthDayYear(date) {
	  return date && (0, _moment2.default)(date).format('MMM DD, YYYY');
	};
	
	// example Aug 03, 2022
	var formatDateToMonthDayYearShort = exports.formatDateToMonthDayYearShort = function formatDateToMonthDayYearShort(_ref3) {
	  var date = _ref3.date,
	      _ref3$locale = _ref3.locale,
	      locale = _ref3$locale === undefined ? _i18n.DEFAULT_LOCALE : _ref3$locale;
	
	  var convertedDate = new Date(date);
	
	  return new Intl.DateTimeFormat(locale, {
	    month: 'short',
	    day: '2-digit',
	    year: 'numeric'
	  }).format(convertedDate);
	};
	
	var formatDayMonth = exports.formatDayMonth = function formatDayMonth(date) {
	  if (!date) return null;
	  try {
	    return (0, _format2.default)(new Date(date), _strings.DAY_MONTH_FORMAT);
	  } catch (e) {
	    return null;
	  }
	};
	
	var formatShortTimeByLocale = exports.formatShortTimeByLocale = function formatShortTimeByLocale(_ref4) {
	  var date = _ref4.date;
	
	  var convertedDate = new Date(date);
	
	  var locale = (0, _get2.default)(window, 'navigator.language', _i18n.DEFAULT_LOCALE);
	
	  return new Intl.DateTimeFormat(locale, {
	    timeStyle: 'short'
	  }).format(convertedDate);
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(159));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(159)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Cipher core components.
	  */
		CryptoJS.lib.Cipher || function (undefined) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var WordArray = C_lib.WordArray;
			var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
			var C_enc = C.enc;
			var Utf8 = C_enc.Utf8;
			var Base64 = C_enc.Base64;
			var C_algo = C.algo;
			var EvpKDF = C_algo.EvpKDF;
	
			/**
	   * Abstract base cipher template.
	   *
	   * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	   * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	   * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	   * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	   */
			var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
				/**
	    * Configuration options.
	    *
	    * @property {WordArray} iv The IV to use for this operation.
	    */
				cfg: Base.extend(),
	
				/**
	    * Creates this cipher in encryption mode.
	    *
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {Cipher} A cipher instance.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	    */
				createEncryptor: function createEncryptor(key, cfg) {
					return this.create(this._ENC_XFORM_MODE, key, cfg);
				},
	
				/**
	    * Creates this cipher in decryption mode.
	    *
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {Cipher} A cipher instance.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	    */
				createDecryptor: function createDecryptor(key, cfg) {
					return this.create(this._DEC_XFORM_MODE, key, cfg);
				},
	
				/**
	    * Initializes a newly created cipher.
	    *
	    * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @example
	    *
	    *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	    */
				init: function init(xformMode, key, cfg) {
					// Apply config defaults
					this.cfg = this.cfg.extend(cfg);
	
					// Store transform mode and key
					this._xformMode = xformMode;
					this._key = key;
	
					// Set initial values
					this.reset();
				},
	
				/**
	    * Resets this cipher to its initial state.
	    *
	    * @example
	    *
	    *     cipher.reset();
	    */
				reset: function reset() {
					// Reset data buffer
					BufferedBlockAlgorithm.reset.call(this);
	
					// Perform concrete-cipher logic
					this._doReset();
				},
	
				/**
	    * Adds data to be encrypted or decrypted.
	    *
	    * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	    *
	    * @return {WordArray} The data after processing.
	    *
	    * @example
	    *
	    *     var encrypted = cipher.process('data');
	    *     var encrypted = cipher.process(wordArray);
	    */
				process: function process(dataUpdate) {
					// Append
					this._append(dataUpdate);
	
					// Process available blocks
					return this._process();
				},
	
				/**
	    * Finalizes the encryption or decryption process.
	    * Note that the finalize operation is effectively a destructive, read-once operation.
	    *
	    * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	    *
	    * @return {WordArray} The data after final processing.
	    *
	    * @example
	    *
	    *     var encrypted = cipher.finalize();
	    *     var encrypted = cipher.finalize('data');
	    *     var encrypted = cipher.finalize(wordArray);
	    */
				finalize: function finalize(dataUpdate) {
					// Final data update
					if (dataUpdate) {
						this._append(dataUpdate);
					}
	
					// Perform concrete-cipher logic
					var finalProcessedData = this._doFinalize();
	
					return finalProcessedData;
				},
	
				keySize: 128 / 32,
	
				ivSize: 128 / 32,
	
				_ENC_XFORM_MODE: 1,
	
				_DEC_XFORM_MODE: 2,
	
				/**
	    * Creates shortcut functions to a cipher's object interface.
	    *
	    * @param {Cipher} cipher The cipher to create a helper for.
	    *
	    * @return {Object} An object with encrypt and decrypt shortcut functions.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	    */
				_createHelper: function () {
					function selectCipherStrategy(key) {
						if (typeof key == 'string') {
							return PasswordBasedCipher;
						} else {
							return SerializableCipher;
						}
					}
	
					return function (cipher) {
						return {
							encrypt: function encrypt(message, key, cfg) {
								return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
							},
	
							decrypt: function decrypt(ciphertext, key, cfg) {
								return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
							}
						};
					};
				}()
			});
	
			/**
	   * Abstract base stream cipher template.
	   *
	   * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	   */
			var StreamCipher = C_lib.StreamCipher = Cipher.extend({
				_doFinalize: function _doFinalize() {
					// Process partial blocks
					var finalProcessedBlocks = this._process(!!'flush');
	
					return finalProcessedBlocks;
				},
	
				blockSize: 1
			});
	
			/**
	   * Mode namespace.
	   */
			var C_mode = C.mode = {};
	
			/**
	   * Abstract base block cipher mode template.
	   */
			var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
				/**
	    * Creates this mode for encryption.
	    *
	    * @param {Cipher} cipher A block cipher instance.
	    * @param {Array} iv The IV words.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	    */
				createEncryptor: function createEncryptor(cipher, iv) {
					return this.Encryptor.create(cipher, iv);
				},
	
				/**
	    * Creates this mode for decryption.
	    *
	    * @param {Cipher} cipher A block cipher instance.
	    * @param {Array} iv The IV words.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	    */
				createDecryptor: function createDecryptor(cipher, iv) {
					return this.Decryptor.create(cipher, iv);
				},
	
				/**
	    * Initializes a newly created mode.
	    *
	    * @param {Cipher} cipher A block cipher instance.
	    * @param {Array} iv The IV words.
	    *
	    * @example
	    *
	    *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	    */
				init: function init(cipher, iv) {
					this._cipher = cipher;
					this._iv = iv;
				}
			});
	
			/**
	   * Cipher Block Chaining mode.
	   */
			var CBC = C_mode.CBC = function () {
				/**
	    * Abstract base CBC mode.
	    */
				var CBC = BlockCipherMode.extend();
	
				/**
	    * CBC encryptor.
	    */
				CBC.Encryptor = CBC.extend({
					/**
	     * Processes the data block at offset.
	     *
	     * @param {Array} words The data words to operate on.
	     * @param {number} offset The offset where the block starts.
	     *
	     * @example
	     *
	     *     mode.processBlock(data.words, offset);
	     */
					processBlock: function processBlock(words, offset) {
						// Shortcuts
						var cipher = this._cipher;
						var blockSize = cipher.blockSize;
	
						// XOR and encrypt
						xorBlock.call(this, words, offset, blockSize);
						cipher.encryptBlock(words, offset);
	
						// Remember this block to use with next block
						this._prevBlock = words.slice(offset, offset + blockSize);
					}
				});
	
				/**
	    * CBC decryptor.
	    */
				CBC.Decryptor = CBC.extend({
					/**
	     * Processes the data block at offset.
	     *
	     * @param {Array} words The data words to operate on.
	     * @param {number} offset The offset where the block starts.
	     *
	     * @example
	     *
	     *     mode.processBlock(data.words, offset);
	     */
					processBlock: function processBlock(words, offset) {
						// Shortcuts
						var cipher = this._cipher;
						var blockSize = cipher.blockSize;
	
						// Remember this block to use with next block
						var thisBlock = words.slice(offset, offset + blockSize);
	
						// Decrypt and XOR
						cipher.decryptBlock(words, offset);
						xorBlock.call(this, words, offset, blockSize);
	
						// This block becomes the previous block
						this._prevBlock = thisBlock;
					}
				});
	
				function xorBlock(words, offset, blockSize) {
					var block;
	
					// Shortcut
					var iv = this._iv;
	
					// Choose mixing block
					if (iv) {
						block = iv;
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					} else {
						block = this._prevBlock;
					}
	
					// XOR blocks
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= block[i];
					}
				}
	
				return CBC;
			}();
	
			/**
	   * Padding namespace.
	   */
			var C_pad = C.pad = {};
	
			/**
	   * PKCS #5/7 padding strategy.
	   */
			var Pkcs7 = C_pad.Pkcs7 = {
				/**
	    * Pads data using the algorithm defined in PKCS #5/7.
	    *
	    * @param {WordArray} data The data to pad.
	    * @param {number} blockSize The multiple that the data should be padded to.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	    */
				pad: function pad(data, blockSize) {
					// Shortcut
					var blockSizeBytes = blockSize * 4;
	
					// Count padding bytes
					var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
					// Create padding word
					var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
	
					// Create padding
					var paddingWords = [];
					for (var i = 0; i < nPaddingBytes; i += 4) {
						paddingWords.push(paddingWord);
					}
					var padding = WordArray.create(paddingWords, nPaddingBytes);
	
					// Add padding
					data.concat(padding);
				},
	
				/**
	    * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	    *
	    * @param {WordArray} data The data to unpad.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	    */
				unpad: function unpad(data) {
					// Get number of padding bytes from last byte
					var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
	
					// Remove padding
					data.sigBytes -= nPaddingBytes;
				}
			};
	
			/**
	   * Abstract base block cipher template.
	   *
	   * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	   */
			var BlockCipher = C_lib.BlockCipher = Cipher.extend({
				/**
	    * Configuration options.
	    *
	    * @property {Mode} mode The block mode to use. Default: CBC
	    * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	    */
				cfg: Cipher.cfg.extend({
					mode: CBC,
					padding: Pkcs7
				}),
	
				reset: function reset() {
					var modeCreator;
	
					// Reset cipher
					Cipher.reset.call(this);
	
					// Shortcuts
					var cfg = this.cfg;
					var iv = cfg.iv;
					var mode = cfg.mode;
	
					// Reset block mode
					if (this._xformMode == this._ENC_XFORM_MODE) {
						modeCreator = mode.createEncryptor;
					} else /* if (this._xformMode == this._DEC_XFORM_MODE) */{
							modeCreator = mode.createDecryptor;
							// Keep at least one block in the buffer for unpadding
							this._minBufferSize = 1;
						}
	
					if (this._mode && this._mode.__creator == modeCreator) {
						this._mode.init(this, iv && iv.words);
					} else {
						this._mode = modeCreator.call(mode, this, iv && iv.words);
						this._mode.__creator = modeCreator;
					}
				},
	
				_doProcessBlock: function _doProcessBlock(words, offset) {
					this._mode.processBlock(words, offset);
				},
	
				_doFinalize: function _doFinalize() {
					var finalProcessedBlocks;
	
					// Shortcut
					var padding = this.cfg.padding;
	
					// Finalize
					if (this._xformMode == this._ENC_XFORM_MODE) {
						// Pad data
						padding.pad(this._data, this.blockSize);
	
						// Process final blocks
						finalProcessedBlocks = this._process(!!'flush');
					} else /* if (this._xformMode == this._DEC_XFORM_MODE) */{
							// Process final blocks
							finalProcessedBlocks = this._process(!!'flush');
	
							// Unpad data
							padding.unpad(finalProcessedBlocks);
						}
	
					return finalProcessedBlocks;
				},
	
				blockSize: 128 / 32
			});
	
			/**
	   * A collection of cipher parameters.
	   *
	   * @property {WordArray} ciphertext The raw ciphertext.
	   * @property {WordArray} key The key to this ciphertext.
	   * @property {WordArray} iv The IV used in the ciphering operation.
	   * @property {WordArray} salt The salt used with a key derivation function.
	   * @property {Cipher} algorithm The cipher algorithm.
	   * @property {Mode} mode The block mode used in the ciphering operation.
	   * @property {Padding} padding The padding scheme used in the ciphering operation.
	   * @property {number} blockSize The block size of the cipher.
	   * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	   */
			var CipherParams = C_lib.CipherParams = Base.extend({
				/**
	    * Initializes a newly created cipher params object.
	    *
	    * @param {Object} cipherParams An object with any of the possible cipher parameters.
	    *
	    * @example
	    *
	    *     var cipherParams = CryptoJS.lib.CipherParams.create({
	    *         ciphertext: ciphertextWordArray,
	    *         key: keyWordArray,
	    *         iv: ivWordArray,
	    *         salt: saltWordArray,
	    *         algorithm: CryptoJS.algo.AES,
	    *         mode: CryptoJS.mode.CBC,
	    *         padding: CryptoJS.pad.PKCS7,
	    *         blockSize: 4,
	    *         formatter: CryptoJS.format.OpenSSL
	    *     });
	    */
				init: function init(cipherParams) {
					this.mixIn(cipherParams);
				},
	
				/**
	    * Converts this cipher params object to a string.
	    *
	    * @param {Format} formatter (Optional) The formatting strategy to use.
	    *
	    * @return {string} The stringified cipher params.
	    *
	    * @throws Error If neither the formatter nor the default formatter is set.
	    *
	    * @example
	    *
	    *     var string = cipherParams + '';
	    *     var string = cipherParams.toString();
	    *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	    */
				toString: function toString(formatter) {
					return (formatter || this.formatter).stringify(this);
				}
			});
	
			/**
	   * Format namespace.
	   */
			var C_format = C.format = {};
	
			/**
	   * OpenSSL formatting strategy.
	   */
			var OpenSSLFormatter = C_format.OpenSSL = {
				/**
	    * Converts a cipher params object to an OpenSSL-compatible string.
	    *
	    * @param {CipherParams} cipherParams The cipher params object.
	    *
	    * @return {string} The OpenSSL-compatible string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	    */
				stringify: function stringify(cipherParams) {
					var wordArray;
	
					// Shortcuts
					var ciphertext = cipherParams.ciphertext;
					var salt = cipherParams.salt;
	
					// Format
					if (salt) {
						wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
					} else {
						wordArray = ciphertext;
					}
	
					return wordArray.toString(Base64);
				},
	
				/**
	    * Converts an OpenSSL-compatible string to a cipher params object.
	    *
	    * @param {string} openSSLStr The OpenSSL-compatible string.
	    *
	    * @return {CipherParams} The cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	    */
				parse: function parse(openSSLStr) {
					var salt;
	
					// Parse base64
					var ciphertext = Base64.parse(openSSLStr);
	
					// Shortcut
					var ciphertextWords = ciphertext.words;
	
					// Test for salt
					if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
						// Extract salt
						salt = WordArray.create(ciphertextWords.slice(2, 4));
	
						// Remove salt from ciphertext
						ciphertextWords.splice(0, 4);
						ciphertext.sigBytes -= 16;
					}
	
					return CipherParams.create({ ciphertext: ciphertext, salt: salt });
				}
			};
	
			/**
	   * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	   */
			var SerializableCipher = C_lib.SerializableCipher = Base.extend({
				/**
	    * Configuration options.
	    *
	    * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	    */
				cfg: Base.extend({
					format: OpenSSLFormatter
				}),
	
				/**
	    * Encrypts a message.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {WordArray|string} message The message to encrypt.
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {CipherParams} A cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	    */
				encrypt: function encrypt(cipher, message, key, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Encrypt
					var encryptor = cipher.createEncryptor(key, cfg);
					var ciphertext = encryptor.finalize(message);
	
					// Shortcut
					var cipherCfg = encryptor.cfg;
	
					// Create and return serializable cipher params
					return CipherParams.create({
						ciphertext: ciphertext,
						key: key,
						iv: cipherCfg.iv,
						algorithm: cipher,
						mode: cipherCfg.mode,
						padding: cipherCfg.padding,
						blockSize: cipher.blockSize,
						formatter: cfg.format
					});
				},
	
				/**
	    * Decrypts serialized ciphertext.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	    * @param {WordArray} key The key.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {WordArray} The plaintext.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	    *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	    */
				decrypt: function decrypt(cipher, ciphertext, key, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Convert string to CipherParams
					ciphertext = this._parse(ciphertext, cfg.format);
	
					// Decrypt
					var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
	
					return plaintext;
				},
	
				/**
	    * Converts serialized ciphertext to CipherParams,
	    * else assumed CipherParams already and returns ciphertext unchanged.
	    *
	    * @param {CipherParams|string} ciphertext The ciphertext.
	    * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	    *
	    * @return {CipherParams} The unserialized ciphertext.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	    */
				_parse: function _parse(ciphertext, format) {
					if (typeof ciphertext == 'string') {
						return format.parse(ciphertext, this);
					} else {
						return ciphertext;
					}
				}
			});
	
			/**
	   * Key derivation function namespace.
	   */
			var C_kdf = C.kdf = {};
	
			/**
	   * OpenSSL key derivation function.
	   */
			var OpenSSLKdf = C_kdf.OpenSSL = {
				/**
	    * Derives a key and IV from a password.
	    *
	    * @param {string} password The password to derive from.
	    * @param {number} keySize The size in words of the key to generate.
	    * @param {number} ivSize The size in words of the IV to generate.
	    * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	    *
	    * @return {CipherParams} A cipher params object with the key, IV, and salt.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	    *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	    */
				execute: function execute(password, keySize, ivSize, salt, hasher) {
					// Generate random salt
					if (!salt) {
						salt = WordArray.random(64 / 8);
					}
	
					// Derive key and IV
					if (!hasher) {
						var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
					} else {
						var key = EvpKDF.create({ keySize: keySize + ivSize, hasher: hasher }).compute(password, salt);
					}
	
					// Separate key and IV
					var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
					key.sigBytes = keySize * 4;
	
					// Return params
					return CipherParams.create({ key: key, iv: iv, salt: salt });
				}
			};
	
			/**
	   * A serializable cipher wrapper that derives the key from a password,
	   * and returns ciphertext as a serializable cipher params object.
	   */
			var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
				/**
	    * Configuration options.
	    *
	    * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	    */
				cfg: SerializableCipher.cfg.extend({
					kdf: OpenSSLKdf
				}),
	
				/**
	    * Encrypts a message using a password.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {WordArray|string} message The message to encrypt.
	    * @param {string} password The password.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {CipherParams} A cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	    *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	    */
				encrypt: function encrypt(cipher, message, password, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Derive key and other params
					var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
	
					// Add IV to config
					cfg.iv = derivedParams.iv;
	
					// Encrypt
					var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
	
					// Mix in derived params
					ciphertext.mixIn(derivedParams);
	
					return ciphertext;
				},
	
				/**
	    * Decrypts serialized ciphertext using a password.
	    *
	    * @param {Cipher} cipher The cipher algorithm to use.
	    * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	    * @param {string} password The password.
	    * @param {Object} cfg (Optional) The configuration options to use for this operation.
	    *
	    * @return {WordArray} The plaintext.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	    *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	    */
				decrypt: function decrypt(cipher, ciphertext, password, cfg) {
					// Apply config defaults
					cfg = this.cfg.extend(cfg);
	
					// Convert string to CipherParams
					ciphertext = this._parse(ciphertext, cfg.format);
	
					// Derive key and other params
					var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
	
					// Add IV to config
					cfg.iv = derivedParams.iv;
	
					// Decrypt
					var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
	
					return plaintext;
				}
			});
		}();
	});

/***/ }),
/* 85 */
[6540, 99],
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contants = __webpack_require__(1948);
	
	var getBrandLogo = function getBrandLogo() {
	  try {
	    // eslint-disable-next-line import/no-dynamic-require, global-require
	    var logo = __webpack_require__(6491)("./" + _contants.LOWER_CASED_BRAND_NAME + '-logo.png');
	
	    return logo;
	  } catch (error) {
	    console.log('Failed to load logo image for ' + _contants.LOWER_CASED_BRAND_NAME + ' wl', error);
	  }
	};
	
	exports.default = getBrandLogo;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _nprogress = __webpack_require__(993);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _reactClickOutside = __webpack_require__(1001);
	
	var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _EditBtn = __webpack_require__(393);
	
	var _EditBtn2 = _interopRequireDefault(_EditBtn);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(4921);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Avatar = function (_PureComponent) {
	  (0, _inherits3.default)(Avatar, _PureComponent);
	
	  function Avatar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Avatar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isOpened: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Avatar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.handleError = this.handleError.bind(this);
	      this.handleRemoveAvatar = this.removeAvatar.bind(this);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var method = nextProps.loading ? _nprogress2.default.start : _nprogress2.default.done;
	
	      method();
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError() {
	      this.setState({
	        isOpened: false
	      });
	    }
	  }, {
	    key: 'getEditButton',
	    value: function getEditButton() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'edit-btn', styleName: (0, _classnames2.default)('edit-button') },
	        _react2.default.createElement(_EditBtn2.default, { accent: true, onClick: function onClick() {
	            return _this2.setState({ isOpened: true });
	          } })
	      );
	    }
	  }, {
	    key: 'getActions',
	    value: function getActions() {
	      var _this3 = this;
	
	      var _props = this.props,
	          src = _props.src,
	          formatMessage = _props.intl.formatMessage;
	
	      var updateLabel = src ? formatMessage(_strings.PROFILE.avatar.update) : formatMessage(_strings.PROFILE.avatar.upload);
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: (0, _classnames2.default)('actions'), className: 'bsw2-1', key: 'actions' },
	        _react2.default.createElement(
	          'label',
	          {
	            styleName: (0, _classnames2.default)(['avatar-input-label', 'action']),
	            htmlFor: 'avatar-file'
	          },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'image',
	            size: 16,
	            style: {
	              fill: _styles.COLORS.bluePrimary,
	              marginRight: 10
	            }
	          }),
	          updateLabel
	        ),
	        _react2.default.createElement('input', {
	          id: 'avatar-file',
	          type: 'file',
	          accept: 'image/jpg, image/jpeg, image/png',
	          style: { display: 'none' },
	          onChange: function onChange(e) {
	            return _this3.onFilesChanged(e);
	          }
	        }),
	        src ? _react2.default.createElement(
	          'div',
	          {
	            styleName: (0, _classnames2.default)('action'),
	            onClick: this.handleRemoveAvatar,
	            key: 'remove-action'
	          },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'remove',
	            size: 16,
	            style: {
	              fill: _styles.COLORS.bluePrimary,
	              marginRight: 10
	            }
	          }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.remove)
	        ) : null
	      );
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside() {
	      this.setState({ isOpened: false });
	    }
	  }, {
	    key: 'onFilesChanged',
	    value: function onFilesChanged(e) {
	      e.stopPropagation();
	      e.preventDefault();
	      this.setState({ isOpened: false });
	
	      var onChange = this.props.onChange;
	
	      var fileSource = e.target;
	      var file = fileSource.files[0];
	
	      if (!file.type.includes('image/') || file.type === 'image/gif') {
	        return;
	      }
	
	      var formData = new FormData();
	
	      formData.append('avatar', file);
	
	      onChange(formData);
	    }
	  }, {
	    key: 'removeAvatar',
	    value: function removeAvatar() {
	      var onRemove = this.props.onRemove;
	
	      this.setState({ isOpened: false });
	
	      onRemove();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          bordered = _props2.bordered,
	          size = _props2.size,
	          editable = _props2.editable,
	          sizePercent = _props2.sizePercent,
	          rootStyle = _props2.rootStyle,
	          noTransparent = _props2.noTransparent,
	          src = _props2.src,
	          children = _props2.children;
	      var isOpened = this.state.isOpened;
	
	      var emptyAvatar = children && children[0].toUpperCase();
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'root', styleName: (0, _classnames2.default)('root'), style: rootStyle },
	        editable ? [this.getEditButton(), isOpened ? this.getActions() : null] : null,
	        _react2.default.createElement(_SimpleAvatar2.default, {
	          size: size,
	          src: src,
	          text: emptyAvatar,
	          bordered: bordered,
	          opaque: noTransparent,
	          usePercent: sizePercent,
	          onError: this.handleError
	        })
	      );
	    }
	  }]);
	  return Avatar;
	}(_react.PureComponent); /* eslint-disable react/sort-comp,react/require-default-props */
	
	
	Avatar.propTypes = {
	  bordered: _propTypes2.default.bool,
	  children: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  icon: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  src: _propTypes2.default.string,
	  editable: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  onRemove: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  position: _propTypes2.default.string,
	  sizePercent: _propTypes2.default.bool,
	  rootStyle: _propTypes2.default.object,
	  noTransparent: _propTypes2.default.bool
	};
	
	Avatar.defaultProps = {
	  bordered: false,
	  size: 24
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactClickOutside2.default)((0, _reactCssModules2.default)(Avatar, _index2.default, { allowMultiple: true })));

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectInspectAppointmentPending = exports.selectCreateAppointmentPending = exports.selectPatientList = exports.selectPatientListPending = exports.selectVisitTypes = exports.selectVisitTypesPending = exports.selectScheduleDefaultsData = exports.selectScheduleDefaultsPending = exports.selectGlobalCalendarLoading = exports.selectAppointmentGuardCanCreate = exports.selectAppointmentGuardPending = exports.selectIsEditMode = exports.selectScheduleViewMode = exports.selectScheduleAdminAccess = exports.selectScheduleReursionModal = exports.selectScheduleReursionModalType = exports.selectScheduleReursionModalVisibility = exports.selectScheduleOverlapAppointmentVisibility = exports.selectScheduleOverlapModalVisibility = exports.selectScheduleTargerProviderUserId = exports.selectScheduleTargerProviderId = exports.selectScheduleValidating = exports.selectScheduleFilterDate = exports.selectScheduleDateRange = exports.selectSchedulePopoverColor = exports.selectSchedulePopoverDataId = exports.selectSchedulePopoverContentType = exports.selectSchedulePopoverData = exports.selectPopoverActiveAppointmentId = exports.selectScheduleAreaPosition = exports.selectSchedulePopoverPosition = exports.selectSchedulePopoverSelectable = exports.selectSchedulePopoverVisibility = exports.selectUTCOffsetSeconds = exports.selectScheduleAppointments = exports.selectScheduleBlockSlots = exports.selectScheduleWorkSlots = exports.selectScheduleListPending = exports.selectWorkSlotUpdatePending = exports.selectWorkSlotRemovePending = exports.selectBlockSlotUpdatePending = exports.selectBlockSlotRemovePending = exports.selectIntersectionsFindPending = exports.selectBlockScheduleInsertSucceed = exports.selectBlockScheduleInsertPending = exports.selectScheduleInsertSucceed = exports.selectScheduleInsertPending = exports.selectSchedulePatientTypes = exports.selectSchedulePatientTypesPending = exports.selectScheduleServices = exports.selectScheduleServicesPending = exports.selectScheduleLocations = exports.selectScheduleLocationPending = exports.selectPracticeProviders = exports.selectPracticeProvidersPending = exports.selectRootState = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectAdapter = __webpack_require__(359);
	
	var _constants = __webpack_require__(105);
	
	var _colorCodes = __webpack_require__(397);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'schedule');
	};
	var getSelectors = (0, _selectAdapter.makeSelectorFactory)(selectRootState);
	
	/**
	 *  PRACTICE PROVIDERS
	 * */
	
	var _getSelectors = getSelectors('practiceProviders'),
	    selectPracticeProvidersPending = _getSelectors.selectStatePending,
	    selectPracticeProviders = _getSelectors.selectStateList;
	
	/**
	 *  SCHEDULE PROVIDER LOCATIONS
	 * */
	
	
	exports.selectPracticeProvidersPending = selectPracticeProvidersPending;
	exports.selectPracticeProviders = selectPracticeProviders;
	
	var _getSelectors2 = getSelectors('providerLocations'),
	    selectScheduleLocationPending = _getSelectors2.selectStatePending,
	    selectScheduleLocations = _getSelectors2.selectStateList;
	
	/**
	 *  SCHEDULE PROVIDER SERVICES
	 * */
	
	
	exports.selectScheduleLocationPending = selectScheduleLocationPending;
	exports.selectScheduleLocations = selectScheduleLocations;
	
	var _getSelectors3 = getSelectors('providerServices'),
	    selectScheduleServicesPending = _getSelectors3.selectStatePending,
	    selectScheduleServices = _getSelectors3.selectStateList;
	
	/**
	 *  SCHEDULE PATIENT TYPES
	 * */
	
	
	exports.selectScheduleServicesPending = selectScheduleServicesPending;
	exports.selectScheduleServices = selectScheduleServices;
	
	var _getSelectors4 = getSelectors('patientTypes'),
	    selectSchedulePatientTypesPending = _getSelectors4.selectStatePending,
	    selectSchedulePatientTypes = _getSelectors4.selectStateList;
	
	/**
	 *  WORK SCHEDULE INSERT
	 * */
	
	
	exports.selectSchedulePatientTypesPending = selectSchedulePatientTypesPending;
	exports.selectSchedulePatientTypes = selectSchedulePatientTypes;
	
	var _getSelectors5 = getSelectors('workslotInsert'),
	    selectScheduleInsertPending = _getSelectors5.selectStatePending,
	    selectScheduleInsertSucceed = _getSelectors5.selectStateSucceed;
	
	/**
	 *  BLOCK SCHEDULE INSERT
	 * */
	
	
	exports.selectScheduleInsertPending = selectScheduleInsertPending;
	exports.selectScheduleInsertSucceed = selectScheduleInsertSucceed;
	
	var _getSelectors6 = getSelectors('blockslotInsert'),
	    selectBlockScheduleInsertPending = _getSelectors6.selectStatePending,
	    selectBlockScheduleInsertSucceed = _getSelectors6.selectStateSucceed;
	
	/**
	 *  BLOCK SCHEDULE INSERT
	 * */
	
	
	exports.selectBlockScheduleInsertPending = selectBlockScheduleInsertPending;
	exports.selectBlockScheduleInsertSucceed = selectBlockScheduleInsertSucceed;
	
	var _getSelectors7 = getSelectors('intersections'),
	    selectIntersectionsFindPending = _getSelectors7.selectStatePending;
	
	/**
	 *  BLOCK SCHEDULE REMOVE
	 * */
	
	
	exports.selectIntersectionsFindPending = selectIntersectionsFindPending;
	
	var _getSelectors8 = getSelectors('blockslotRemove'),
	    selectBlockSlotRemovePending = _getSelectors8.selectStatePending;
	/**
	 *  BLOCK SCHEDULE UPDATE
	 * */
	
	
	exports.selectBlockSlotRemovePending = selectBlockSlotRemovePending;
	
	var _getSelectors9 = getSelectors('blockslotUpdate'),
	    selectBlockSlotUpdatePending = _getSelectors9.selectStatePending;
	
	/**
	 *  WORK SCHEDULE REMOVE
	 * */
	
	
	exports.selectBlockSlotUpdatePending = selectBlockSlotUpdatePending;
	
	var _getSelectors10 = getSelectors('workslotRemove'),
	    selectWorkSlotRemovePending = _getSelectors10.selectStatePending;
	
	/**
	 *  WORK SCHEDULE UPDATE
	 * */
	
	
	exports.selectWorkSlotRemovePending = selectWorkSlotRemovePending;
	
	var _getSelectors11 = getSelectors('workslotUpdate'),
	    selectWorkSlotUpdatePending = _getSelectors11.selectStatePending;
	
	/**
	 *  SCHEDULE SEARCH
	 * */
	
	
	exports.selectWorkSlotUpdatePending = selectWorkSlotUpdatePending;
	var selectScheduleListState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'scheduleList');
	});
	var selectScheduleListPending = exports.selectScheduleListPending = (0, _reselect.createSelector)(selectScheduleListState, function (state) {
	  return (0, _get2.default)(state, 'sending');
	});
	var selectScheduleWorkSlots = exports.selectScheduleWorkSlots = (0, _reselect.createSelector)(selectScheduleListState, function (state) {
	  return (0, _get2.default)(state, 'workSlots', []);
	});
	var selectScheduleBlockSlots = exports.selectScheduleBlockSlots = (0, _reselect.createSelector)(selectScheduleListState, function (state) {
	  return (0, _get2.default)(state, 'blockedSlots', []);
	});
	var selectScheduleAppointments = exports.selectScheduleAppointments = (0, _reselect.createSelector)(selectScheduleListState, function (state) {
	  return (0, _get2.default)(state, 'appointments', []);
	});
	var selectUTCOffsetSeconds = exports.selectUTCOffsetSeconds = (0, _reselect.createSelector)(selectScheduleListState, function (state) {
	  return (0, _get2.default)(state, 'timeZone.utcOffsetSeconds', 0);
	});
	
	/**
	 *  SELECTED POPOVER
	 * */
	var selectPopoverState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'selectedPopover');
	});
	var selectSchedulePopoverVisibility = exports.selectSchedulePopoverVisibility = (0, _reselect.createSelector)(selectPopoverState, function (state) {
	  return (0, _get2.default)(state, 'visible');
	});
	var selectSchedulePopoverSelectable = exports.selectSchedulePopoverSelectable = (0, _reselect.createSelector)(selectPopoverState, function (state) {
	  return (0, _get2.default)(state, 'selectable');
	});
	var selectSchedulePopoverPosition = exports.selectSchedulePopoverPosition = (0, _reselect.createSelector)(selectPopoverState, function (state) {
	  return (0, _get2.default)(state, 'bounds');
	});
	var selectScheduleAreaPosition = exports.selectScheduleAreaPosition = (0, _reselect.createSelector)(selectPopoverState, function (state) {
	  return (0, _get2.default)(state, 'areaBounds', {});
	});
	var selectPopoverActiveAppointmentId = exports.selectPopoverActiveAppointmentId = (0, _reselect.createSelector)(selectPopoverState, function (state) {
	  return (0, _get2.default)(state, 'appointmentId');
	});
	
	var selectSchedulePopoverData = exports.selectSchedulePopoverData = (0, _reselect.createSelector)(selectPopoverState, function (state) {
	  return (0, _get2.default)(state, 'schedule');
	});
	var selectSchedulePopoverContentType = exports.selectSchedulePopoverContentType = (0, _reselect.createSelector)(selectPopoverState, function (state) {
	  return (0, _get2.default)(state, 'type');
	});
	var selectSchedulePopoverDataId = exports.selectSchedulePopoverDataId = (0, _reselect.createSelector)(selectSchedulePopoverData, function (schedule) {
	  return (0, _get2.default)(schedule, 'id');
	});
	var selectSchedulePopoverColor = exports.selectSchedulePopoverColor = (0, _reselect.createSelector)(selectSchedulePopoverData, function (schedule) {
	  var isBlocked = (0, _get2.default)(schedule, '__type') === _constants.SCHEDULE_TYPES.BLOCK;
	
	  return isBlocked ? _colorCodes.COLOR_MAP.SILVER : (0, _get2.default)(schedule, 'colorMarkerHex');
	});
	
	/**
	 *  SCHEDULE FILTER
	 * */
	var selectScheduleFilterState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'filter');
	});
	var selectScheduleDateRange = exports.selectScheduleDateRange = (0, _reselect.createSelector)(selectScheduleFilterState, function (state) {
	  return {
	    startOn: (0, _get2.default)(state, 'startOn'),
	    endOn: (0, _get2.default)(state, 'endOn')
	  };
	});
	var selectScheduleFilterDate = exports.selectScheduleFilterDate = (0, _reselect.createSelector)(selectScheduleFilterState, function (state) {
	  return (0, _get2.default)(state, 'date');
	});
	
	/**
	 *  SCHEDULE VALIDATION
	 * */
	var selectScheduleValidateState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'validate');
	});
	var selectScheduleValidating = exports.selectScheduleValidating = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'validating');
	});
	var selectScheduleTargerProviderId = exports.selectScheduleTargerProviderId = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'providerId');
	});
	var selectScheduleTargerProviderUserId = exports.selectScheduleTargerProviderUserId = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'userId');
	});
	var selectScheduleOverlapModalVisibility = exports.selectScheduleOverlapModalVisibility = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'overlapModal');
	});
	var selectScheduleOverlapAppointmentVisibility = exports.selectScheduleOverlapAppointmentVisibility = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'overlapAppointment');
	});
	var selectScheduleReursionModalVisibility = exports.selectScheduleReursionModalVisibility = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'recursionModal.opened', false);
	});
	var selectScheduleReursionModalType = exports.selectScheduleReursionModalType = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'recursionModal.type');
	});
	var selectScheduleReursionModal = exports.selectScheduleReursionModal = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'recursionModal', {});
	});
	var selectScheduleAdminAccess = exports.selectScheduleAdminAccess = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'scheduleAdmin');
	});
	var selectScheduleViewMode = exports.selectScheduleViewMode = (0, _reselect.createSelector)(selectScheduleValidateState, function (state) {
	  return (0, _get2.default)(state, 'viewMode');
	});
	var selectIsEditMode = exports.selectIsEditMode = (0, _reselect.createSelector)(selectScheduleViewMode, function (mode) {
	  return mode === _constants.SCHEDULE_VIEW_MODE.EDIT;
	});
	
	// appointmentGuard
	/**
	 *  APPOINTMENT GUARD
	 * */
	var selectAppointmentGuardState = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'appointmentGuard');
	});
	
	var selectAppointmentGuardPending = exports.selectAppointmentGuardPending = (0, _reselect.createSelector)(selectAppointmentGuardState, function (state) {
	  return (0, _get2.default)(state, 'pending');
	});
	var selectAppointmentGuardCanCreate = exports.selectAppointmentGuardCanCreate = (0, _reselect.createSelector)(selectAppointmentGuardState, function (state) {
	  return (0, _get2.default)(state, 'canCreate');
	});
	
	var selectGlobalCalendarLoading = exports.selectGlobalCalendarLoading = (0, _reselect.createSelector)(selectScheduleInsertPending, selectBlockScheduleInsertPending, selectIntersectionsFindPending, selectScheduleListPending, selectWorkSlotRemovePending, selectWorkSlotUpdatePending, selectBlockSlotRemovePending, selectBlockSlotUpdatePending, _selectors.selectManagePendingRequestSending, _selectors.selectStatusChangesPending, function () {
	  for (var _len = arguments.length, loading = Array(_len), _key = 0; _key < _len; _key++) {
	    loading[_key] = arguments[_key];
	  }
	
	  return loading.some(function (pending) {
	    return Boolean(pending);
	  });
	});
	
	/**
	 *  SCHEDULE DEFAULTS (predefined start, end time)
	 * */
	
	var _getSelectors12 = getSelectors('scheduleDefaults'),
	    selectScheduleDefaultsPending = _getSelectors12.selectStatePending,
	    selectScheduleDefaultsData = _getSelectors12.selectStateData;
	
	/**
	 *  VISIT TYPES BY LOCATION
	 * */
	
	
	exports.selectScheduleDefaultsPending = selectScheduleDefaultsPending;
	exports.selectScheduleDefaultsData = selectScheduleDefaultsData;
	
	var _getSelectors13 = getSelectors('visitTypes'),
	    selectVisitTypesPending = _getSelectors13.selectStatePending,
	    selectVisitTypes = _getSelectors13.selectStateList;
	
	/**
	 *  PATIENTS BY PROVIDER
	 * */
	
	
	exports.selectVisitTypesPending = selectVisitTypesPending;
	exports.selectVisitTypes = selectVisitTypes;
	
	var _getSelectors14 = getSelectors('patientList'),
	    selectPatientListPending = _getSelectors14.selectStatePending,
	    selectPatientList = _getSelectors14.selectStateList;
	
	/**
	 *  CREATE APPOINTMENT
	 * */
	
	
	exports.selectPatientListPending = selectPatientListPending;
	exports.selectPatientList = selectPatientList;
	
	var _getSelectors15 = getSelectors('createAppointment'),
	    selectCreateAppointmentPending = _getSelectors15.selectStatePending;
	/**
	 *  INSPECT APPOINTMENT
	 * */
	
	
	exports.selectCreateAppointmentPending = selectCreateAppointmentPending;
	
	var _getSelectors16 = getSelectors('inspectAppointment'),
	    selectInspectAppointmentPending = _getSelectors16.selectStatePending;
	
	exports.selectInspectAppointmentPending = selectInspectAppointmentPending;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectDefaultTabId = exports.createChatVisibilitySelector = exports.popupSecondaryContentVisibilitySelector = exports.contextbarVisibilitySelector = exports.overlayVisibleSelector = exports.drawerVisibleSelector = exports.uiOnlineSelector = exports.uiLocaleSelector = exports.uiPdfViewerSelector = exports.uiImageViewerSelector = exports.uiFormInProgressSelector = exports.selectUiPopupContentType = exports.selectUiPopupContentOptions = exports.selectUiPopupVisible = exports.selectVideoCallEndPopup = exports.selectDefaultTab = exports.selectTheme = exports.uiPopupSelector = exports.uiOverlaySelector = exports.uiSidebarSelector = exports.uiDrawerSelector = exports.contextbarSelector = exports.createChatSelector = exports.uiSelector = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _lodash = __webpack_require__(58);
	
	var uiSelector = exports.uiSelector = function uiSelector(state) {
	  return state.ui;
	};
	
	var createChatSelector = exports.createChatSelector = function createChatSelector(state) {
	  return state.ui.createChat;
	};
	var contextbarSelector = exports.contextbarSelector = function contextbarSelector(state) {
	  return state.ui.contextbar;
	};
	var uiDrawerSelector = exports.uiDrawerSelector = function uiDrawerSelector(state) {
	  return state.ui.drawer;
	};
	var uiSidebarSelector = exports.uiSidebarSelector = function uiSidebarSelector(state) {
	  return state.ui.sidebar;
	};
	var uiOverlaySelector = exports.uiOverlaySelector = function uiOverlaySelector(state) {
	  return state.ui.overlay;
	};
	var uiPopupSelector = exports.uiPopupSelector = function uiPopupSelector(state) {
	  return state.ui.popup;
	};
	var selectTheme = exports.selectTheme = function selectTheme(state) {
	  return state.ui.theme;
	};
	var selectDefaultTab = exports.selectDefaultTab = function selectDefaultTab(state) {
	  return state.ui.defaultTab;
	};
	var selectVideoCallEndPopup = exports.selectVideoCallEndPopup = function selectVideoCallEndPopup(state) {
	  return state.ui.videoCallEndPopup;
	};
	
	var selectUiPopupVisible = exports.selectUiPopupVisible = (0, _reselect.createSelector)(uiPopupSelector, function (popup) {
	  return (0, _lodash.get)(popup, 'visible', false);
	});
	var selectUiPopupContentOptions = exports.selectUiPopupContentOptions = (0, _reselect.createSelector)(uiPopupSelector, function (popup) {
	  return (0, _lodash.get)(popup, 'contentOptions', {});
	});
	var selectUiPopupContentType = exports.selectUiPopupContentType = (0, _reselect.createSelector)(uiPopupSelector, function (popup) {
	  return (0, _lodash.get)(popup, 'contentType');
	});
	
	var uiFormInProgressSelector = exports.uiFormInProgressSelector = function uiFormInProgressSelector(state) {
	  return state.ui.formInProgress;
	};
	
	var uiImageViewerSelector = exports.uiImageViewerSelector = function uiImageViewerSelector(state) {
	  return state.ui.imageViewer;
	};
	var uiPdfViewerSelector = exports.uiPdfViewerSelector = function uiPdfViewerSelector(state) {
	  return state.ui.pdfViewer;
	};
	
	var uiLocaleSelector = exports.uiLocaleSelector = function uiLocaleSelector(state) {
	  return state.ui.locale;
	};
	var uiOnlineSelector = exports.uiOnlineSelector = function uiOnlineSelector(state) {
	  return state.ui.online;
	};
	
	var drawerVisibleSelector = exports.drawerVisibleSelector = (0, _reselect.createSelector)(uiDrawerSelector, function (drawer) {
	  return (0, _lodash.get)(drawer, 'visible', false);
	});
	
	var overlayVisibleSelector = exports.overlayVisibleSelector = (0, _reselect.createSelector)(uiOverlaySelector, function (overlay) {
	  return (0, _lodash.get)(overlay, 'visible', false);
	});
	
	var contextbarVisibilitySelector = exports.contextbarVisibilitySelector = (0, _reselect.createSelector)(contextbarSelector, function (contextbar) {
	  return (0, _lodash.get)(contextbar, 'visible', false);
	});
	
	var popupSecondaryContentVisibilitySelector = exports.popupSecondaryContentVisibilitySelector = (0, _reselect.createSelector)(uiPopupSelector, function (popup) {
	  return (0, _lodash.get)(popup, 'secondaryContentVisible', false);
	});
	
	var createChatVisibilitySelector = exports.createChatVisibilitySelector = (0, _reselect.createSelector)(createChatSelector, function (createChat) {
	  return (0, _lodash.get)(createChat, 'visible', false);
	});
	
	var selectDefaultTabId = exports.selectDefaultTabId = (0, _reselect.createSelector)(selectDefaultTab, function (state) {
	  return (0, _lodash.get)(state, 'id', null);
	});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4342), __esModule: true };

/***/ }),
/* 92 */
53,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectAuthLoginData = exports.selectSendInvitationError = exports.selectSendInvitationPending = exports.selectSendInvitationSucceed = exports.selectLoggedUserId = exports.selectRegistrationCompleted = exports.selectRequestPasswordUpdate = exports.selectAuthLogoutError = exports.selectAuthLogout = exports.isLoggedInSelector = exports.authTokenSelector = exports.selectResetPasswordSucceed = exports.selectResetPasswordError = exports.selectResetPassword = exports.selectSuccessAuthAzureForSignUpFlow = exports.selectAuthLoggedInStatus = exports.selectAuthStatus = exports.selectAuthState = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectAdapter = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectAuthState = exports.selectAuthState = function selectAuthState(state) {
	  return (0, _get2.default)(state, 'auth');
	};
	
	var getSelectors = (0, _selectAdapter.makeSelectorFactory)(selectAuthState);
	
	var selectAuthStatus = exports.selectAuthStatus = (0, _reselect.createSelector)(selectAuthState, function (auth) {
	  return (0, _get2.default)(auth, 'status');
	});
	
	var selectAuthLoggedInStatus = exports.selectAuthLoggedInStatus = (0, _reselect.createSelector)(selectAuthStatus, function (status) {
	  return (0, _get2.default)(status, 'loggedIn', false);
	});
	
	var selectSuccessAuthAzureForSignUpFlow = exports.selectSuccessAuthAzureForSignUpFlow = (0, _reselect.createSelector)(selectAuthState, function (auth) {
	  return (0, _get2.default)(auth, 'loginAzure.successAuthForSignUpFlow', false);
	});
	
	var selectResetPassword = exports.selectResetPassword = (0, _reselect.createSelector)(selectAuthState, function (state) {
	  return (0, _get2.default)(state, 'resetPassword');
	});
	
	var selectResetPasswordError = exports.selectResetPasswordError = (0, _reselect.createSelector)(selectResetPassword, function (state) {
	  return (0, _get2.default)(state, 'error');
	});
	
	var selectResetPasswordSucceed = exports.selectResetPasswordSucceed = (0, _reselect.createSelector)(selectResetPassword, function (state) {
	  return (0, _get2.default)(state, 'succeed');
	});
	
	var authTokenSelector = exports.authTokenSelector = function authTokenSelector(state) {
	  return (0, _get2.default)(state, 'auth.status.authenticationToken');
	};
	
	var isLoggedInSelector = exports.isLoggedInSelector = function isLoggedInSelector(state) {
	  return !!(0, _get2.default)(state, 'auth.status.loggedIn');
	};
	
	var selectAuthLogout = exports.selectAuthLogout = (0, _reselect.createSelector)(selectAuthState, function (state) {
	  return (0, _get2.default)(state, 'logout');
	});
	
	var selectAuthLogoutError = exports.selectAuthLogoutError = (0, _reselect.createSelector)(selectAuthLogout, function (state) {
	  return (0, _get2.default)(state, 'error');
	});
	
	var selectRequestPasswordUpdate = exports.selectRequestPasswordUpdate = (0, _reselect.createSelector)(selectAuthStatus, function (state) {
	  return (0, _get2.default)(state, 'requestPasswordUpdate', false);
	});
	
	var selectRegistrationCompleted = exports.selectRegistrationCompleted = (0, _reselect.createSelector)(selectAuthStatus, function (state) {
	  return (0, _get2.default)(state, 'registrationCompleted', false);
	});
	
	var selectLoggedUserId = exports.selectLoggedUserId = (0, _reselect.createSelector)(selectAuthStatus, function (state) {
	  return (0, _get2.default)(state, 'loggedUserId', false);
	});
	
	var _getSelectors = getSelectors('sendInvitation'),
	    selectSendInvitationSucceed = _getSelectors.selectStateSucceed,
	    selectSendInvitationPending = _getSelectors.selectStatePending,
	    selectSendInvitationError = _getSelectors.selectStateError;
	
	exports.selectSendInvitationSucceed = selectSendInvitationSucceed;
	exports.selectSendInvitationPending = selectSendInvitationPending;
	exports.selectSendInvitationError = selectSendInvitationError;
	var selectAuthLoginData = exports.selectAuthLoginData = (0, _reselect.createSelector)(selectAuthState, function (auth) {
	  return (0, _get2.default)(auth, 'login');
	});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(7);
	
	var supportedActions = [
	// connection
	'CONNECTION_OPENED', 'CONNECTION_READY', 'SET_CONNECT_ERROR', 'SET_CHAT_MODULE_INSTANCE', 'DISCONNECT',
	// 'CLEAR',
	
	// chat api events
	'CONVERSATION_CHANGED', 'RELOAD_HISTORY',
	
	// selectors
	'SET_LAST_CHANNEL_ID', 'SET_AVAILABLE_CHANNELS', 'UPDATE_AVAILABLE_CHANNELS', 'SET_ACTIVE_CHANNEL_ID', 'ADD_NEW_SUBCHANNEL', 'UPDATE_CHANNEL_SUBCHANNELS', 'SELECT_SOCIAL_CHAT', 'SOCIAL_CHAT_INIT_SELECTION',
	
	// helpers
	'FETCH_MESSAGES', 'CHECK_NEW_NOTIFICATIONS', 'SET_CHANNEL_DATA',
	
	// actions
	'ADD_ACTIVE_UNREAD', 'REMOVE_ACTIVE_UNREAD', 'BUMP_ACTIVITY', 'LOAD_NEXT_HISTORY_PAGE', 'SEND_MESSAGE', 'SEND_MESSAGE_WITH_INBOX_TASK',
	// uploads
	'UPLOAD_ATTACHMENT', 'UPDATE_ATTACHMENT_UPLOAD_STATUS', 'REMOVE_UPLOAD_ATTACHMENT',
	// downloads
	'DOWNLOAD_ATTACHMENT', 'UPDATE_ATTACHMENT_DOWNLOAD_STATUS', 'REMOVE_DOWNLOAD_ATTACHMENT', 'NEW_CHANNEL_ACTIVITY', 'REMOVE_MESSAGES', 'ADD_SOCIAL_CHAT', 'UPDATE_CHAT_NAME', 'UPDATE_CONTEXT_CHAT_NAME', 'UPDATE_CHANNEL', 'UPDATE_CONTEXT_CHANNEL', 'REMOVE_CHANNEL', 'REMOVE_CONTEXT_CHANNEL', 'REMOVE_SOCIAL_CHANNEL', 'REMOVE_CHANNEL_MESSAGE', 'REMOVE_CONTEXT', 'REMOVE_CONTEXT_USER', 'TOGGLE_BLOCKED_CHAT', 'UPDATE_BLOCKED_STATUS', 'UPDATE_CHAT', 'COMPLETE_INBOX_TASK', 'UPDATE_CHANNEL_INBOX_TASK_ID',
	
	// communities
	'NEW_JOIN_REQUEST', 'JOIN_REQUEST_ACCEPTED', 'JOIN_REQUEST_DECLINED', 'NEW_POST', 'NEW_POST_COMMENT', 'NEW_COMMENT_REPLY', 'NEW_COMMUNITY_INVITE', 'COMMUNITY_INVITE_ACCEPT', 'COMMUNITY_INVITE_DECLINE', 'NEW_COMPLAINT', 'LOGOUT'];
	
	exports.default = _index.createConsts.apply(undefined, ['chatConnection', 'sync'].concat(supportedActions));

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 96 */
228,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.infoErrorIconSelector = exports.errorIsStaticFlowSelector = exports.errorMsgSelector = exports.errorSelector = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.updateErrorMsgSaga = updateErrorMsgSaga;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _leaveFamilyCircle = __webpack_require__(298);
	
	var leaveFamilyCircle = _interopRequireWildcard(_leaveFamilyCircle);
	
	var _inviteCaregiverFamily = __webpack_require__(646);
	
	var _removeAssignedProvider = __webpack_require__(515);
	
	var _reqSocialChannel = __webpack_require__(295);
	
	var _leaveCommunity = __webpack_require__(651);
	
	var _reqBlockUser = __webpack_require__(507);
	
	var _confirmVisitGWReq = __webpack_require__(503);
	
	var _confirmVisitSelfSchedulingReq = __webpack_require__(504);
	
	var _schedulingsReq = __webpack_require__(1236);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var _checkInAppointmentReq = __webpack_require__(533);
	
	var _reqAssignPatient = __webpack_require__(638);
	
	var _personalInfoReq = __webpack_require__(659);
	
	var _inlineVisitsTimeSlots = __webpack_require__(506);
	
	var _confirmInlineVisit = __webpack_require__(622);
	
	var _createEirUrgentCareAppointment = __webpack_require__(624);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var changeAppointmentStatus = _interopRequireWildcard(_statusChangeReq);
	
	var _addPatientByProvider = __webpack_require__(308);
	
	var addPatientByProvider = _interopRequireWildcard(_addPatientByProvider);
	
	var _deleteCardReq = __webpack_require__(677);
	
	var _redux = __webpack_require__(7);
	
	var _strings = __webpack_require__(15);
	
	var _errors = __webpack_require__(120);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateErrorMsgWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateErrorMsgSaga);
	
	var supportedActions = ['UPDATE'];
	
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['ui', 'error'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var errorSelector = exports.errorSelector = function errorSelector(state) {
	  return (0, _get2.default)(state, 'ui.error');
	};
	var errorMsgSelector = exports.errorMsgSelector = (0, _reselect.createSelector)(errorSelector, function (state) {
	  return (0, _get2.default)(state, 'message', null);
	});
	var errorIsStaticFlowSelector = exports.errorIsStaticFlowSelector = (0, _reselect.createSelector)(errorSelector, function (state) {
	  return (0, _get2.default)(state, 'isStaticFlow', false);
	});
	var infoErrorIconSelector = exports.infoErrorIconSelector = (0, _reselect.createSelector)(errorSelector, function (state) {
	  return (0, _get2.default)(state, 'infoErrorIcon', null);
	});
	
	var initialState = {
	  message: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.UPDATE:
	      return (0, _extends3.default)({}, state, {
	        message: action.payload,
	        isStaticFlow: action.isStaticFlow,
	        infoErrorIcon: action.infoErrorIcon
	      });
	    default:
	      return state;
	  }
	};
	
	var getErrorMsg = function getErrorMsg(actionType, message) {
	  var errorCode = (0, _get2.default)(message, 'error.code');
	
	  var accessDenied = errorCode === _errors.ERROR_CODES.ACCESS_DENIED;
	
	  if (_errors.CHANGE_APPOINTMENT_STATUS_ERROR_CODES.includes(errorCode)) {
	    var description = (0, _get2.default)(message, 'error.description');
	
	    return description;
	  }
	
	  if (actionType === _removeAssignedProvider.consts.REJECTED || actionType === leaveFamilyCircle.consts.REJECTED && accessDenied || actionType === _personalInfoReq.consts.REJECTED) {
	    return (0, _get2.default)(message, 'error.description');
	  }
	
	  if (actionType === _inviteCaregiverFamily.consts.REJECTED) {
	    return _strings.ERROR_ASSIGN_CAREGIVER;
	  }
	
	  if (actionType === changeAppointmentStatus.consts.REJECTED) {
	    var id = errorCode === _errors.ERROR_CODES.UNAVAILABLE_VIRTUAL_ROOM ? 'errors.appointment.unavailableVirtualRoom' : 'errors.common';
	    return { id: id };
	  }
	
	  if (actionType === _reqSocialChannel.consts.REJECTED) {
	    return _strings.CHAT.titles.newChatError;
	  }
	
	  if ([_confirmVisitGWReq.consts.SHOW_ERROR_ALERT, _confirmVisitSelfSchedulingReq.consts.SHOW_ERROR_ALERT, _inlineVisitsTimeSlots.consts.SHOW_ERROR_ALERT, _confirmInlineVisit.consts.SHOW_ERROR_ALERT, _createEirUrgentCareAppointment.consts.SHOW_ERROR_ALERT].includes(actionType)) {
	    return { id: message };
	  }
	
	  if (actionType === _cancelAppointmentReq.consts.REJECTED || actionType === _checkInAppointmentReq.consts.REJECTED) {
	    return { id: 'errors.commonErrorOccured' };
	  }
	
	  if ([_schedulingsReq.consts.REJECTED, _createEirUrgentCareAppointment.consts.REJECTED].includes(actionType)) {
	    var _id = errorCode === _errors.ERROR_CODES.APPOINTMENT_SCHEDULE_LIST_SERVICE_FAIL ? 'errors.appointment.thirdPartyError' : 'errors.common';
	    return { id: _id };
	  }
	
	  if (actionType === _leaveCommunity.consts.REJECTED && errorCode === _errors.ERROR_CODES.LAST_COMMUNITY_MODERATOR) {
	    return { id: 'community.menu.removeLastCommunityModerator' };
	  }
	  if (actionType === _reqBlockUser.consts.REJECTED && accessDenied) {
	    return { id: 'chat.title.blockedUserError' };
	  }
	
	  if (actionType === _reqAssignPatient.consts.REJECTED) {
	    var providerAlreadyAssigned = (0, _get2.default)(message, 'error.meta.validationErrors.base', []).some(function (_ref) {
	      var code = _ref.code;
	      return code === _errors.ERROR_CODES.PROVIDER_ALREADY_ASSIGNED;
	    });
	    var _id2 = providerAlreadyAssigned ? 'circles.provider.alreadyAssigned' : 'errors.common';
	    return { id: _id2 };
	  }
	
	  if (actionType === addPatientByProvider.consts.ERROR) {
	    return { id: 'errors.validation.alreadyExists' };
	  }
	
	  if ([_deleteCardReq.consts.REJECTED, _deleteCardReq.consts.ERROR_ENCOUNTERED].includes(actionType)) {
	    return { id: 'profile.payment.removeErrorMessage' };
	  }
	};
	
	function updateErrorMsgWorker(action) {
	  return _regenerator2.default.wrap(function updateErrorMsgWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)({
	            type: consts.UPDATE,
	            payload: getErrorMsg(action.type, action.payload)
	          });
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateErrorMsgSaga() {
	  return _regenerator2.default.wrap(function updateErrorMsgSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_removeAssignedProvider.consts.REJECTED, _inviteCaregiverFamily.consts.REJECTED, _reqSocialChannel.consts.REJECTED, _leaveCommunity.consts.REJECTED, _reqBlockUser.consts.REJECTED, _schedulingsReq.consts.REJECTED, _confirmVisitGWReq.consts.SHOW_ERROR_ALERT, _confirmVisitSelfSchedulingReq.consts.SHOW_ERROR_ALERT, _cancelAppointmentReq.consts.REJECTED, _checkInAppointmentReq.consts.REJECTED, leaveFamilyCircle.consts.REJECTED, changeAppointmentStatus.consts.REJECTED, _reqAssignPatient.consts.REJECTED, addPatientByProvider.consts.ERROR, _personalInfoReq.consts.REJECTED, _inlineVisitsTimeSlots.consts.SHOW_ERROR_ALERT, _confirmInlineVisit.consts.SHOW_ERROR_ALERT, _createEirUrgentCareAppointment.consts.REJECTED, _deleteCardReq.consts.REJECTED, _deleteCardReq.consts.ERROR_ENCOUNTERED], updateErrorMsgWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appointmentDetailsActions = exports.APPOINTMENT_DETAILS_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'health-board/appointment-details';
	
	var APPOINTMENT_DETAILS_TYPES = exports.APPOINTMENT_DETAILS_TYPES = {
	  SET_APPOINTMENT_ID: actionsScope + '/set-appointment-id',
	  SET_COUPON: actionsScope + '/set-coupon',
	  SET_ORDER_ID: actionsScope + '/set-order-id',
	  REPLACE_APPOINTMENT: actionsScope + '/replace-appointment',
	  START_PAYMENT_PROCESS: actionsScope + '/start-payment-process',
	  PAYMENT_SUCCESS: actionsScope + '/payment-success',
	  VISIT_CONFIRMED: actionsScope + '/visit-confirmed',
	  PAYMENT_TIMEOUT: actionsScope + '/payment-timeout',
	  PAYMENT_FAIL: actionsScope + '/payment-fail',
	  CLEAR_PAYMENT: actionsScope + '/clear-payment',
	  CHANGE_STATUS: actionsScope + '/change-status',
	  SLICE_UPCOMING_APPOINTMENT: actionsScope + '/slice-upcoming-appointment'
	};
	
	var appointmentDetailsActions = exports.appointmentDetailsActions = {
	  setAppointmentId: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.SET_APPOINTMENT_ID),
	  setCoupon: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.SET_COUPON),
	  setOrderId: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.SET_ORDER_ID),
	  clearPayment: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.CLEAR_PAYMENT),
	  replaceAppointment: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.REPLACE_APPOINTMENT),
	  paymentSuccess: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.PAYMENT_SUCCESS),
	  paymentFail: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.PAYMENT_FAIL),
	  paymentTimeout: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.PAYMENT_TIMEOUT),
	  confirmVisit: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.VISIT_CONFIRMED),
	  changeStatus: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.CHANGE_STATUS),
	  sliceUpcomingAppointment: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT),
	  startPaymentProcess: (0, _createAction.createAction)(APPOINTMENT_DETAILS_TYPES.START_PAYMENT_PROCESS)
	};
	
	var initialState = {
	  activeId: undefined,
	  coupon: null,
	  orderId: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case APPOINTMENT_DETAILS_TYPES.SET_APPOINTMENT_ID:
	      {
	        return (0, _extends3.default)({}, state, { activeId: payload });
	      }
	    case APPOINTMENT_DETAILS_TYPES.SET_COUPON:
	      {
	        return (0, _extends3.default)({}, state, { coupon: payload });
	      }
	    case APPOINTMENT_DETAILS_TYPES.SET_ORDER_ID:
	      {
	        return (0, _extends3.default)({}, state, { orderId: payload });
	      }
	    case APPOINTMENT_DETAILS_TYPES.CLEAR_PAYMENT:
	      {
	        return (0, _extends3.default)({}, state, { coupon: null, orderId: null });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable prefer-destructuring */
	var ENV = ("production");
	
	var PROD_ENV = ENV === 'production';
	var DEV_ENV = !PROD_ENV;
	var ENV_NAME = ("production");
	var APP_NAME = ("Flagler Health+");
	var API_URI = ("https://api.flaglerhealthanywhere.com/api/");
	var CHAT_ATTACHMENTS_URI = ("https://chat.flaglerhealthanywhere.com/chat/attachments");
	var CHAT_SOCKET_URI = ("wss://chat.flaglerhealthanywhere.com/socket");
	var BRAND_NAME = ("FLAGLER") || 'HEALTHFULLY';
	var PAYA_ORIGIN = ("https://api.payaconnect.com");
	var WEB_APP_URL = ("https://app.flaglerhealthanywhere.com/");
	var APP_STORE_APP_LINK = ("https://apps.apple.com/us/app/flagler-health-anywhere/id1451753522");
	var PLAY_MARKET_APP_LINK = ("https://play.google.com/store/apps/details?id=com.flagler.app");
	var REACT_APP_GOOGLE_MAPS_API_KEY = ("AIzaSyAi1BEBCRWDnNMHNW_0VPWY2AzWOKRDFpk");
	var REFRESH_SESSION_INTERVAL = ("300000");
	var WEB_PROVIDER_APP_URL = ("https://pws.flaglerhealthanywhere.com");
	var APP_VERSION = ("17.40.0");
	var CI_PIPELINE_IID = ("6220");
	
	var LOGENTRIES_TOKEN = ({"NODE_ENV":"production","PUBLIC_URL":"","APP_NAME":"Flagler Health+","WEB_APP_URL":"https://app.flaglerhealthanywhere.com/","ADMIN_URL":"https://api.flaglerhealthanywhere.com/admin/","API_URI":"https://api.flaglerhealthanywhere.com/api/","CHAT_ATTACHMENTS_URI":"https://chat.flaglerhealthanywhere.com/chat/attachments","CHAT_SOCKET_URI":"wss://chat.flaglerhealthanywhere.com/socket","GOOGLE_ANALYTICS_ID":undefined,"DISABLE_LOGS":undefined,"BRAND_NAME":"FLAGLER","PAYA_ORIGIN":"https://api.payaconnect.com","APP_STORE_APP_LINK":"https://apps.apple.com/us/app/flagler-health-anywhere/id1451753522","PLAY_MARKET_APP_LINK":"https://play.google.com/store/apps/details?id=com.flagler.app","REACT_APP_GOOGLE_MAPS_API_KEY":"AIzaSyAi1BEBCRWDnNMHNW_0VPWY2AzWOKRDFpk","REFRESH_SESSION_INTERVAL":"300000","WEB_PROVIDER_APP_URL":"https://pws.flaglerhealthanywhere.com","GA_MEASUREMENT_ID":"G-9ZNTYXZJF8","APP_VERSION":"17.40.0","CI_PIPELINE_IID":"6220","USE_INTERCOM_CHAT":"false","INTERCOM_CHAT_APP_ID":"","MOZZAZ_REDIRECT_URL":"","INTERCOM_SECRET_KEY":"","ENV_NAME":"production","SENTRY_SERVER_DNS":undefined,"SENTRY_CLIENT_DNS":"https://73d2990676b848199ad78305122f989d@tracker.ecuris.net/14","TOKBOX_EMBED_JS_URL":undefined,"TOKBOX_EMBED_ID":undefined,"APPLE_APP_ID":"7988NSSC3K.org.flaglerhospital.onlinecare.member","NODE_PORT":undefined}).LOGENTRIES_TOKEN;
	var SENTRY_DSN = ({"NODE_ENV":"production","PUBLIC_URL":"","APP_NAME":"Flagler Health+","WEB_APP_URL":"https://app.flaglerhealthanywhere.com/","ADMIN_URL":"https://api.flaglerhealthanywhere.com/admin/","API_URI":"https://api.flaglerhealthanywhere.com/api/","CHAT_ATTACHMENTS_URI":"https://chat.flaglerhealthanywhere.com/chat/attachments","CHAT_SOCKET_URI":"wss://chat.flaglerhealthanywhere.com/socket","GOOGLE_ANALYTICS_ID":undefined,"DISABLE_LOGS":undefined,"BRAND_NAME":"FLAGLER","PAYA_ORIGIN":"https://api.payaconnect.com","APP_STORE_APP_LINK":"https://apps.apple.com/us/app/flagler-health-anywhere/id1451753522","PLAY_MARKET_APP_LINK":"https://play.google.com/store/apps/details?id=com.flagler.app","REACT_APP_GOOGLE_MAPS_API_KEY":"AIzaSyAi1BEBCRWDnNMHNW_0VPWY2AzWOKRDFpk","REFRESH_SESSION_INTERVAL":"300000","WEB_PROVIDER_APP_URL":"https://pws.flaglerhealthanywhere.com","GA_MEASUREMENT_ID":"G-9ZNTYXZJF8","APP_VERSION":"17.40.0","CI_PIPELINE_IID":"6220","USE_INTERCOM_CHAT":"false","INTERCOM_CHAT_APP_ID":"","MOZZAZ_REDIRECT_URL":"","INTERCOM_SECRET_KEY":"","ENV_NAME":"production","SENTRY_SERVER_DNS":undefined,"SENTRY_CLIENT_DNS":"https://73d2990676b848199ad78305122f989d@tracker.ecuris.net/14","TOKBOX_EMBED_JS_URL":undefined,"TOKBOX_EMBED_ID":undefined,"APPLE_APP_ID":"7988NSSC3K.org.flaglerhospital.onlinecare.member","NODE_PORT":undefined}).SENTRY_DSN;
	var SENTRY_CLIENT_DNS = ("https://73d2990676b848199ad78305122f989d@tracker.ecuris.net/14");
	var NEWRELIC_TOKEN = ({"NODE_ENV":"production","PUBLIC_URL":"","APP_NAME":"Flagler Health+","WEB_APP_URL":"https://app.flaglerhealthanywhere.com/","ADMIN_URL":"https://api.flaglerhealthanywhere.com/admin/","API_URI":"https://api.flaglerhealthanywhere.com/api/","CHAT_ATTACHMENTS_URI":"https://chat.flaglerhealthanywhere.com/chat/attachments","CHAT_SOCKET_URI":"wss://chat.flaglerhealthanywhere.com/socket","GOOGLE_ANALYTICS_ID":undefined,"DISABLE_LOGS":undefined,"BRAND_NAME":"FLAGLER","PAYA_ORIGIN":"https://api.payaconnect.com","APP_STORE_APP_LINK":"https://apps.apple.com/us/app/flagler-health-anywhere/id1451753522","PLAY_MARKET_APP_LINK":"https://play.google.com/store/apps/details?id=com.flagler.app","REACT_APP_GOOGLE_MAPS_API_KEY":"AIzaSyAi1BEBCRWDnNMHNW_0VPWY2AzWOKRDFpk","REFRESH_SESSION_INTERVAL":"300000","WEB_PROVIDER_APP_URL":"https://pws.flaglerhealthanywhere.com","GA_MEASUREMENT_ID":"G-9ZNTYXZJF8","APP_VERSION":"17.40.0","CI_PIPELINE_IID":"6220","USE_INTERCOM_CHAT":"false","INTERCOM_CHAT_APP_ID":"","MOZZAZ_REDIRECT_URL":"","INTERCOM_SECRET_KEY":"","ENV_NAME":"production","SENTRY_SERVER_DNS":undefined,"SENTRY_CLIENT_DNS":"https://73d2990676b848199ad78305122f989d@tracker.ecuris.net/14","TOKBOX_EMBED_JS_URL":undefined,"TOKBOX_EMBED_ID":undefined,"APPLE_APP_ID":"7988NSSC3K.org.flaglerhospital.onlinecare.member","NODE_PORT":undefined}).NEWRELIC_TOKEN;
	var NEWRELIC_ENVIRONMENT = ({"NODE_ENV":"production","PUBLIC_URL":"","APP_NAME":"Flagler Health+","WEB_APP_URL":"https://app.flaglerhealthanywhere.com/","ADMIN_URL":"https://api.flaglerhealthanywhere.com/admin/","API_URI":"https://api.flaglerhealthanywhere.com/api/","CHAT_ATTACHMENTS_URI":"https://chat.flaglerhealthanywhere.com/chat/attachments","CHAT_SOCKET_URI":"wss://chat.flaglerhealthanywhere.com/socket","GOOGLE_ANALYTICS_ID":undefined,"DISABLE_LOGS":undefined,"BRAND_NAME":"FLAGLER","PAYA_ORIGIN":"https://api.payaconnect.com","APP_STORE_APP_LINK":"https://apps.apple.com/us/app/flagler-health-anywhere/id1451753522","PLAY_MARKET_APP_LINK":"https://play.google.com/store/apps/details?id=com.flagler.app","REACT_APP_GOOGLE_MAPS_API_KEY":"AIzaSyAi1BEBCRWDnNMHNW_0VPWY2AzWOKRDFpk","REFRESH_SESSION_INTERVAL":"300000","WEB_PROVIDER_APP_URL":"https://pws.flaglerhealthanywhere.com","GA_MEASUREMENT_ID":"G-9ZNTYXZJF8","APP_VERSION":"17.40.0","CI_PIPELINE_IID":"6220","USE_INTERCOM_CHAT":"false","INTERCOM_CHAT_APP_ID":"","MOZZAZ_REDIRECT_URL":"","INTERCOM_SECRET_KEY":"","ENV_NAME":"production","SENTRY_SERVER_DNS":undefined,"SENTRY_CLIENT_DNS":"https://73d2990676b848199ad78305122f989d@tracker.ecuris.net/14","TOKBOX_EMBED_JS_URL":undefined,"TOKBOX_EMBED_ID":undefined,"APPLE_APP_ID":"7988NSSC3K.org.flaglerhospital.onlinecare.member","NODE_PORT":undefined}).NEWRELIC_ENVIRONMENT;
	var AUTHENTICITY_TOKEN = ({"NODE_ENV":"production","PUBLIC_URL":"","APP_NAME":"Flagler Health+","WEB_APP_URL":"https://app.flaglerhealthanywhere.com/","ADMIN_URL":"https://api.flaglerhealthanywhere.com/admin/","API_URI":"https://api.flaglerhealthanywhere.com/api/","CHAT_ATTACHMENTS_URI":"https://chat.flaglerhealthanywhere.com/chat/attachments","CHAT_SOCKET_URI":"wss://chat.flaglerhealthanywhere.com/socket","GOOGLE_ANALYTICS_ID":undefined,"DISABLE_LOGS":undefined,"BRAND_NAME":"FLAGLER","PAYA_ORIGIN":"https://api.payaconnect.com","APP_STORE_APP_LINK":"https://apps.apple.com/us/app/flagler-health-anywhere/id1451753522","PLAY_MARKET_APP_LINK":"https://play.google.com/store/apps/details?id=com.flagler.app","REACT_APP_GOOGLE_MAPS_API_KEY":"AIzaSyAi1BEBCRWDnNMHNW_0VPWY2AzWOKRDFpk","REFRESH_SESSION_INTERVAL":"300000","WEB_PROVIDER_APP_URL":"https://pws.flaglerhealthanywhere.com","GA_MEASUREMENT_ID":"G-9ZNTYXZJF8","APP_VERSION":"17.40.0","CI_PIPELINE_IID":"6220","USE_INTERCOM_CHAT":"false","INTERCOM_CHAT_APP_ID":"","MOZZAZ_REDIRECT_URL":"","INTERCOM_SECRET_KEY":"","ENV_NAME":"production","SENTRY_SERVER_DNS":undefined,"SENTRY_CLIENT_DNS":"https://73d2990676b848199ad78305122f989d@tracker.ecuris.net/14","TOKBOX_EMBED_JS_URL":undefined,"TOKBOX_EMBED_ID":undefined,"APPLE_APP_ID":"7988NSSC3K.org.flaglerhospital.onlinecare.member","NODE_PORT":undefined}).AUTHENTICITY_TOKEN;
	var GOOGLE_ANALYTICS_ID = (undefined);
	var ADMIN_URL = ("https://api.flaglerhealthanywhere.com/admin/");
	var DISABLE_LOGS = (undefined);
	var GA_MEASUREMENT_ID = ("G-9ZNTYXZJF8");
	var USE_INTERCOM_CHAT = ("false");
	var INTERCOM_CHAT_APP_ID = ("");
	var MOZZAZ_REDIRECT_URL = ("");
	var INTERCOM_SECRET_KEY = ("");
	
	module.exports = {
	  ENV: ENV,
	  PROD_ENV: PROD_ENV,
	  DEV_ENV: DEV_ENV,
	  ENV_NAME: ENV_NAME,
	  APP_NAME: APP_NAME,
	  API_URI: API_URI,
	  CHAT_ATTACHMENTS_URI: CHAT_ATTACHMENTS_URI,
	  CHAT_SOCKET_URI: CHAT_SOCKET_URI,
	  BRAND_NAME: BRAND_NAME,
	  PAYA_ORIGIN: PAYA_ORIGIN,
	  WEB_APP_URL: WEB_APP_URL,
	  APP_STORE_APP_LINK: APP_STORE_APP_LINK,
	  PLAY_MARKET_APP_LINK: PLAY_MARKET_APP_LINK,
	  REACT_APP_GOOGLE_MAPS_API_KEY: REACT_APP_GOOGLE_MAPS_API_KEY,
	  REFRESH_SESSION_INTERVAL: REFRESH_SESSION_INTERVAL,
	  WEB_PROVIDER_APP_URL: WEB_PROVIDER_APP_URL,
	  APP_VERSION: APP_VERSION,
	  CI_PIPELINE_IID: CI_PIPELINE_IID,
	
	  LOGENTRIES_TOKEN: LOGENTRIES_TOKEN,
	  SENTRY_DSN: SENTRY_DSN,
	  SENTRY_CLIENT_DNS: SENTRY_CLIENT_DNS,
	  NEWRELIC_TOKEN: NEWRELIC_TOKEN,
	  NEWRELIC_ENVIRONMENT: NEWRELIC_ENVIRONMENT,
	  AUTHENTICITY_TOKEN: AUTHENTICITY_TOKEN,
	  GOOGLE_ANALYTICS_ID: GOOGLE_ANALYTICS_ID,
	  ADMIN_URL: ADMIN_URL,
	  DISABLE_LOGS: DISABLE_LOGS,
	  GA_MEASUREMENT_ID: GA_MEASUREMENT_ID,
	  USE_INTERCOM_CHAT: USE_INTERCOM_CHAT,
	  INTERCOM_CHAT_APP_ID: INTERCOM_CHAT_APP_ID,
	  MOZZAZ_REDIRECT_URL: MOZZAZ_REDIRECT_URL,
	  INTERCOM_SECRET_KEY: INTERCOM_SECRET_KEY
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.successAlertBoxTitleSelector = exports.succesTypeSelector = exports.successValuesForMsgSelector = exports.successMsgSelector = exports.successSelector = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.updateSuccessMsgSaga = updateSuccessMsgSaga;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _redux = __webpack_require__(7);
	
	var _acceptInviteToFamilyCircle = __webpack_require__(408);
	
	var _declineInviteToFamilyCircle = __webpack_require__(411);
	
	var _acceptCaregiverRole = __webpack_require__(407);
	
	var _caregiver = __webpack_require__(297);
	
	var _declineCaregiverRole = __webpack_require__(410);
	
	var _acceptGuardianRole = __webpack_require__(406);
	
	var _declineGuardianRole = __webpack_require__(409);
	
	var _myFamilyCircle = __webpack_require__(514);
	
	var _sendSurvey = __webpack_require__(901);
	
	var _submit = __webpack_require__(691);
	
	var _submitReferralForm = __webpack_require__(692);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _editUser = __webpack_require__(136);
	
	var _editProvider = __webpack_require__(424);
	
	var _editPatient = __webpack_require__(218);
	
	var _addPatientByProvider = __webpack_require__(308);
	
	var _editPatientByProvider = __webpack_require__(423);
	
	var _confirmMobilePhone = __webpack_require__(678);
	
	var _changeSettings = __webpack_require__(538);
	
	var _reqAssignPatient = __webpack_require__(638);
	
	var _inviteCaregiverFamily = __webpack_require__(646);
	
	var _assignPrograms = __webpack_require__(1356);
	
	var _confirmVisitGWReq = __webpack_require__(503);
	
	var _confirmVisitSelfSchedulingReq = __webpack_require__(504);
	
	var _shareToChatReq = __webpack_require__(664);
	
	var _shareToEmailReq = __webpack_require__(849);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _popup = __webpack_require__(76);
	
	var _actions = __webpack_require__(632);
	
	var _removeAssignedProvider = __webpack_require__(515);
	
	var _reqAssignProvider = __webpack_require__(639);
	
	var _checkIsAppStoreLinksAvailability = __webpack_require__(905);
	
	var _checkIsAppStoreLinksAvailability2 = _interopRequireDefault(_checkIsAppStoreLinksAvailability);
	
	var _strings = __webpack_require__(15);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _selectors = __webpack_require__(93);
	
	var _constants3 = __webpack_require__(17);
	
	var _routes = __webpack_require__(37);
	
	var _deleteCardReq = __webpack_require__(677);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateSuccessMsgWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateSuccessMsgSaga);
	// send invitation
	// accept / decline invitation
	
	// remove from / leave circle
	
	// send / answer / completion survey
	
	// edit profile
	
	
	// payment methods (delete card)
	
	
	var EDIT_USER_HIDDEN_PATHS = [_routes.PAPERWORK, _routes.APPOINTMENT_FORM, _routes.DEPENDENT_FORM, _routes.HEALTHBOARD];
	
	function shouldRenderSuccessMessage(pathname) {
	  return !EDIT_USER_HIDDEN_PATHS.some(function (hidden) {
	    return pathname.includes(hidden);
	  });
	}
	
	//= =================PROFILE_ACTIONS==================
	
	var EDIT_PROFILE_ACTIONS = [_editUser.consts.SUCCEED, _editProvider.consts.SUCCEED, _editPatient.consts.SUCCEED, _editPatientByProvider.consts.SUCCEED, _confirmMobilePhone.consts.SUCCEED];
	
	var PROFILE_ACTIONS = [_changeSettings.consts.SUCCEED, _reqAssignPatient.consts.SUCCEED, _inviteCaregiverFamily.consts.SUCCEED, _assignPrograms.consts.SUCCEED, _addPatientByProvider.consts.MESSAGE, _editUser.consts.SEND, _constants2.default.REMOVE_CHANNEL_MESSAGE, _removeAssignedProvider.consts.SUCCEED, _reqAssignProvider.consts.SUCCEED];
	
	var getProfileSuccessMsg = function getProfileSuccessMsg(actionType) {
	  if (actionType === _removeAssignedProvider.consts.SUCCEED) {
	    return _strings.SUCCESS_UNASSIGNED;
	  }
	
	  if (actionType === _reqAssignProvider.consts.SUCCEED) {
	    return _strings.SUCCESS_ASSIGNED;
	  }
	
	  if (actionType === _changeSettings.consts.SUCCEED) {
	    return _strings.SUCCESS_UPDATE_SETTINGS;
	  }
	
	  if (actionType === _inviteCaregiverFamily.consts.SUCCEED) {
	    return _strings.SUCCESS_INVITE_CAREGIVER;
	  }
	
	  if (actionType === _reqAssignPatient.consts.SUCCEED) {
	    return _strings.SUCCESS_JOIN_CIRCLE;
	  }
	
	  if (EDIT_PROFILE_ACTIONS.includes(actionType)) {
	    var pathname = window.location.pathname;
	
	
	    if (!shouldRenderSuccessMessage(pathname)) {
	      return null;
	    }
	
	    return _strings.SUCCESS_UPDATE_PROFILE;
	  }
	
	  if (actionType === _addPatientByProvider.consts.MESSAGE) {
	    return _strings.SUCCESS_PATIENT_ADDED;
	  }
	
	  if (actionType === _constants2.default.REMOVE_CHANNEL_MESSAGE) {
	    return _strings.REMOVE_FROM_CHAT;
	  }
	
	  if (actionType === _assignPrograms.consts.SUCCEED) {
	    return _strings.PROGRAMS.invitations.success;
	  }
	
	  return null;
	};
	
	//= ================================================
	//= =================SURVEY_ACTIONS==================
	
	var SURVEY_ACTIONS = [_sendSurvey.consts.SUCCEED, _upcomingSurveyCompletions.consts.MESSAGE, _submit.consts.MESSAGE, _submitReferralForm.consts.MESSAGE];
	
	var getSurveySuccessMsg = function getSurveySuccessMsg(actionType, message) {
	  if (actionType === _sendSurvey.consts.SUCCEED) {
	    return _strings.SUCCESS_SEND_SURVEY;
	  }
	
	  if (actionType === _submit.consts.MESSAGE) {
	    return message || _strings.SUCCESS_ANSWER_SURVEY;
	  }
	
	  if (actionType === _submitReferralForm.consts.MESSAGE) {
	    return message || _strings.SUCCESS_ANSWER_FORM;
	  }
	
	  if (actionType === _upcomingSurveyCompletions.consts.MESSAGE) {
	    return message || _strings.SUCCESS_SURVEY_COMPLETION;
	  }
	
	  return null;
	};
	
	//= ================================================
	
	var supportedActions = ['UPDATE', 'ASSIGN_CAREGIVER_ROLE', 'SIGN_UP'];
	
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['ui', 'success'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  message: null,
	  acceptCaregiverRole: false, // in progress flag
	  signUp: false, // in progress flag
	  values: null
	};
	
	// reducer
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  // Accept caregiver role handler
	  // Signup (password & T&C setting) handler
	  if ((state.acceptCaregiverRole || state.signUp) && action.type === consts.UPDATE) {
	    return state;
	  }
	  var _action$iconType = action.iconType,
	      iconType = _action$iconType === undefined ? 'success' : _action$iconType,
	      values = action.values;
	
	
	  switch (action.type) {
	    case consts.UPDATE:
	      return (0, _extends3.default)({}, state, {
	        values: values,
	        message: action.payload,
	        iconType: iconType,
	        title: (0, _get2.default)(action, 'payload.title', null)
	      });
	    case consts.ASSIGN_CAREGIVER_ROLE:
	      return (0, _extends3.default)({}, state, {
	        acceptCaregiverRole: action.payload
	      });
	    case consts.SIGN_UP:
	      return (0, _extends3.default)({}, state, {
	        signUp: action.payload
	      });
	    default:
	      return state;
	  }
	};
	
	// selectors
	
	
	var successSelector = exports.successSelector = function successSelector(state) {
	  return (0, _get2.default)(state, 'ui.success');
	};
	var successMsgSelector = exports.successMsgSelector = (0, _reselect.createSelector)(successSelector, function (state) {
	  return (0, _get2.default)(state, 'message', null);
	});
	
	var successValuesForMsgSelector = exports.successValuesForMsgSelector = (0, _reselect.createSelector)(successSelector, function (state) {
	  return (0, _get2.default)(state, 'values', {});
	});
	
	var succesTypeSelector = exports.succesTypeSelector = (0, _reselect.createSelector)(successSelector, function (state) {
	  return (0, _get2.default)(state, 'iconType', null);
	});
	
	var successAlertBoxTitleSelector = exports.successAlertBoxTitleSelector = (0, _reselect.createSelector)(successSelector, function (state) {
	  return (0, _get2.default)(state, 'title', null);
	});
	
	var getSuccessMsg = function getSuccessMsg(actionType, message) {
	  // accept / decline invitation
	  if (actionType === _acceptInviteToFamilyCircle.consts.SUCCEED) {
	    return _strings.ACCEPT_FAMILY_INVITATION;
	  }
	
	  if (actionType === _declineInviteToFamilyCircle.consts.SUCCEED) {
	    return _strings.DECLINE_FAMILY_INVITATION;
	  }
	
	  if (actionType === _acceptCaregiverRole.consts.SUCCEED) {
	    return _strings.ACCEPT_CAREGIVER_INVITATION;
	  }
	
	  if (actionType === _declineCaregiverRole.consts.SUCCEED) {
	    return _strings.DECLINE_CAREGIVER_INVITATION;
	  }
	
	  if (actionType === _acceptGuardianRole.consts.SUCCEED) {
	    return {
	      id: 'circles.invites.guardian.accept'
	    };
	  }
	
	  if (actionType === _declineGuardianRole.consts.SUCCEED) {
	    return {
	      id: 'circles.invites.guardian.decline'
	    };
	  }
	
	  if (actionType === _myFamilyCircle.consts.REMOVE_ITEM) {
	    return _strings.SUCCESS_REMOVE_FAMILY_MEMBER;
	  }
	
	  if (actionType === _confirmVisitSelfSchedulingReq.consts.SUCCEED) {
	    return {
	      id: message.status.coreAppName === _constants3.APPOINTMENT_STATUSES.PENDING ? 'appointments.successSchedulePendingMsg' : 'appointments.successScheduleMsg'
	    };
	  }
	
	  if (actionType === _confirmVisitGWReq.consts.SUCCEED) {
	    return {
	      id: 'appointments.successScheduleMsg'
	    };
	  }
	
	  if (actionType === _shareToChatReq.consts.SUCCEED) {
	    return {
	      id: 'patient.portal.healthRecord.shareToChatSuccess'
	    };
	  }
	
	  if (actionType === _appointmentDetails.APPOINTMENT_DETAILS_TYPES.PAYMENT_SUCCESS) {
	    return {
	      id: 'appointment.payment.charged',
	      title: 'appointment.payment.submitted'
	    };
	  }
	
	  if (actionType === _appointmentDetails.APPOINTMENT_DETAILS_TYPES.VISIT_CONFIRMED) {
	    return {
	      id: 'appointment.visitConfirmed'
	    };
	  }
	
	  if (actionType === _shareToEmailReq.consts.SUCCEED) {
	    return _strings.SUCCESS_SENT_DOCUMENT_TO_EMAIL;
	  }
	
	  if (actionType === _deleteCardReq.consts.SUCCEED) {
	    return _strings.SUCCESS_PAYMENT_METHOD_REMOVED;
	  }
	
	  //= =================SURVEY_ACTIONS==================
	  var surveySuccessMsg = getSurveySuccessMsg(actionType, message);
	  if (surveySuccessMsg) return surveySuccessMsg;
	
	  //= =================PROFILE_ACTIONS==================
	  var profileSuccessMsg = getProfileSuccessMsg(actionType);
	  if (profileSuccessMsg) return profileSuccessMsg;
	
	  return null;
	};
	
	// saga
	function updateSuccessMsgWorker(action) {
	  var isLoggedIn, isSuccessAzureSignUp, isEditUserAction, isRegistrationProcess, _ref, hasAtLeastOneStoreLink, iconType;
	
	  return _regenerator2.default.wrap(function updateSuccessMsgWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (!(action.type === _acceptCaregiverRole.consts.SUCCEED)) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.put)({ type: consts.ASSIGN_CAREGIVER_ROLE, payload: true });
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.take)(_caregiver.consts.SUCCEED);
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)({ type: consts.ASSIGN_CAREGIVER_ROLE, payload: false });
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.select)(_selectors.isLoggedInSelector);
	
	        case 9:
	          isLoggedIn = _context.sent;
	          _context.next = 12;
	          return (0, _effects.select)(_selectors.selectSuccessAuthAzureForSignUpFlow);
	
	        case 12:
	          isSuccessAzureSignUp = _context.sent;
	          isEditUserAction = action.type === _editUser.consts.SEND;
	          isRegistrationProcess = isEditUserAction && (0, _get2.default)(action, 'payload.password') || isSuccessAzureSignUp && isEditUserAction && !isLoggedIn;
	
	          if (!isRegistrationProcess) {
	            _context.next = 32;
	            break;
	          }
	
	          _context.next = 18;
	          return (0, _effects.put)({ type: consts.SIGN_UP, payload: true });
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.take)(_editUser.consts.SUCCEED);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.call)(_checkIsAppStoreLinksAvailability2.default);
	
	        case 22:
	          _ref = _context.sent;
	          hasAtLeastOneStoreLink = _ref.hasAtLeastOneStoreLink;
	
	          if (!hasAtLeastOneStoreLink) {
	            _context.next = 27;
	            break;
	          }
	
	          _context.next = 27;
	          return (0, _effects.put)((0, _popup.showMobileAppPopup)());
	
	        case 27:
	          _context.next = 29;
	          return (0, _effects.put)(_actions.signupActions.reset());
	
	        case 29:
	          _context.next = 31;
	          return (0, _effects.put)({ type: consts.SIGN_UP, payload: false });
	
	        case 31:
	          return _context.abrupt('return');
	
	        case 32:
	          iconType = void 0;
	
	          if (action.type === _constants2.default.REMOVE_CHANNEL_MESSAGE) {
	            iconType = 'deleted-chat';
	          }
	
	          if (action.type === _confirmVisitSelfSchedulingReq.consts.SUCCEED) {
	            iconType = action.payload.status.coreAppName === _constants3.APPOINTMENT_STATUSES.PENDING ? 'ico-48-clock' : 'success';
	          }
	
	          if ([_shareToChatReq.consts.SUCCEED, _shareToEmailReq.consts.SUCCEED].includes(action.type)) {
	            iconType = 'icon-48-share';
	          }
	
	          _context.next = 38;
	          return (0, _effects.put)({
	            type: consts.UPDATE,
	            payload: getSuccessMsg(action.type, action.payload),
	            values: action.values,
	            iconType: iconType
	          });
	
	        case 38:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateSuccessMsgSaga() {
	  return _regenerator2.default.wrap(function updateSuccessMsgSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_acceptInviteToFamilyCircle.consts.SUCCEED, _declineInviteToFamilyCircle.consts.SUCCEED, _acceptCaregiverRole.consts.SUCCEED, _declineCaregiverRole.consts.SUCCEED, _acceptGuardianRole.consts.SUCCEED, _declineGuardianRole.consts.SUCCEED, _myFamilyCircle.consts.REMOVE_ITEM, _confirmVisitSelfSchedulingReq.consts.SUCCEED, _confirmVisitGWReq.consts.SUCCEED, _shareToChatReq.consts.SUCCEED, _shareToEmailReq.consts.SUCCEED, _appointmentDetails.APPOINTMENT_DETAILS_TYPES.VISIT_CONFIRMED, _deleteCardReq.consts.SUCCEED].concat(SURVEY_ACTIONS, PROFILE_ACTIONS, EDIT_PROFILE_ACTIONS), updateSuccessMsgWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SCHEDULE_VIEW_MODE = exports.SCHEDULE_VIEW_MODE = {
	  READ: 'read',
	  EDIT: 'edit'
	};
	
	var SCHEDULE_TYPES = exports.SCHEDULE_TYPES = {
	  WORK: 'work',
	  BLOCK: 'block',
	  APPOINTMENT: 'appointment'
	};
	var POPOVER_WIDTH = exports.POPOVER_WIDTH = 320;
	var MINUTES_IN_CELL = exports.MINUTES_IN_CELL = 15;
	var CELL_HEIGHT = exports.CELL_HEIGHT = 22;
	var ONE_MIN_OFFSET = exports.ONE_MIN_OFFSET = MINUTES_IN_CELL / CELL_HEIGHT;
	
	var RECURSION_OPTIONS = exports.RECURSION_OPTIONS = {
	  CURRENT_DAY: 'current-day',
	  CURRENT_AND_NEXT: 'current-and-next',
	  ALL_DAYS: 'all-days',
	  UPDATE_CUSTOM_FOLOWING: 'update-repeat-folowing',
	  UPDATE_CUSTOM_ALL: 'update-repeat-all',
	  NO_REPEAT_FOLOWING: 'no-repeat-folowing',
	  NO_REPEAT_ALL: 'no-repeat-all'
	};
	
	var RECURSION_MODAL_TYPES = exports.RECURSION_MODAL_TYPES = {
	  EDIT_WORK_SLOT: 'edit-work-slot',
	  EDIT_BLOCK_SLOT: 'edit-block-slot',
	  REMOVE_WORK_SLOT: 'remove-work-slot',
	  REMOVE_BLOCK_SLOT: 'remove-block-slot'
	};
	
	var WEEK_DAYS = exports.WEEK_DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
	
	var REPEATABLE_VALUES = exports.REPEATABLE_VALUES = {
	  NO_REPEAT: '',
	  WEEKLY: 'weekly',
	  CUSTOM: 'custom'
	};
	
	var CHANGE_REPEAT_FLOW_TYPES = exports.CHANGE_REPEAT_FLOW_TYPES = {
	  DEFAULT: '',
	  NO_REPEAT: 'no-repet',
	  UPDATE_CUSTOM_REPEAT: 'update-custom-repeat'
	};
	
	// NO_REPEAT:::
	// following days ==> remove [next-date, endOn with repeat days];
	// all days ==> remove all (insert actual)

/***/ }),
/* 106 */
[6599, 933, 451, 89],
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateField = exports.clearValidationErrorsOnChange = exports.makeLocalFieldsValidation = exports.makeRequiredFieldsValidator = undefined;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _validationRules;
	
	exports.useInitialState = useInitialState;
	exports.useFormState = useFormState;
	exports.useFormValidation = useFormValidation;
	
	var _react = __webpack_require__(1);
	
	var _reduce = __webpack_require__(1560);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _set = __webpack_require__(1561);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _mapValues = __webpack_require__(1559);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _convertErrors = __webpack_require__(496);
	
	var _convertErrors2 = _interopRequireDefault(_convertErrors);
	
	var _formFields = __webpack_require__(38);
	
	var _homePhoneValidator = __webpack_require__(1945);
	
	var _homePhoneValidator2 = _interopRequireDefault(_homePhoneValidator);
	
	var _ruleForSSN = __webpack_require__(4251);
	
	var _ruleForSSN2 = _interopRequireDefault(_ruleForSSN);
	
	var _ruleForUserName = __webpack_require__(4252);
	
	var _ruleForUserName2 = _interopRequireDefault(_ruleForUserName);
	
	var _validations = __webpack_require__(81);
	
	var _useDidUpdate = __webpack_require__(3912);
	
	var _useDidUpdate2 = _interopRequireDefault(_useDidUpdate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validationRules = (_validationRules = {}, (0, _defineProperty3.default)(_validationRules, _formFields.PROFILE_FIELDS_TYPES.SSN, _ruleForSSN2.default), (0, _defineProperty3.default)(_validationRules, _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE, _homePhoneValidator2.default), (0, _defineProperty3.default)(_validationRules, _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, _ruleForUserName2.default), (0, _defineProperty3.default)(_validationRules, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, _ruleForUserName2.default), _validationRules);
	
	function useInitialState(initialFields) {
	  var _useState = (0, _react.useState)({}),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      initialState = _useState2[0],
	      setInitialState = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    setInitialState((0, _reduce2.default)(initialFields, function (result, value) {
	      return (0, _set2.default)(result, value, '');
	    }, {}));
	  }, []);
	
	  return initialState;
	}
	
	function useFormState() {
	  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _useState3 = (0, _react.useState)(initialState),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      formState = _useState4[0],
	      setPatientInfo = _useState4[1];
	
	  function handleFormChange(value) {
	    setPatientInfo((0, _extends4.default)({}, formState, value));
	  }
	
	  function clearForm() {
	    setPatientInfo((0, _mapValues2.default)(formState, function () {
	      return '';
	    }));
	  }
	
	  return { formState: formState, handleFormChange: handleFormChange, clearForm: clearForm };
	}
	
	function useFormValidation(serverErrors) {
	  var _useState5 = (0, _react.useState)({}),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      validateErrors = _useState6[0],
	      setValidateErrors = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    if (serverErrors) {
	      setValidateErrors((0, _convertErrors2.default)(serverErrors));
	    }
	  }, [serverErrors]);
	
	  var addLocalValidateErrors = function addLocalValidateErrors(name, errors) {
	    setValidateErrors((0, _extends4.default)({}, validateErrors, (0, _defineProperty3.default)({}, name, errors)));
	  };
	
	  function clearErrors() {
	    setValidateErrors({});
	  }
	
	  return { validateErrors: validateErrors, clearErrors: clearErrors, addLocalValidateErrors: addLocalValidateErrors };
	}
	
	var makeRequiredFieldsValidator = exports.makeRequiredFieldsValidator = function makeRequiredFieldsValidator(fieldList) {
	  return function (patientData) {
	    return fieldList.every(function (type) {
	      return Boolean(patientData[type]);
	    });
	  };
	};
	
	var makeLocalFieldsValidation = exports.makeLocalFieldsValidation = function makeLocalFieldsValidation(fieldList) {
	  return function (patientData) {
	    return fieldList.every(function (type) {
	      var required = Boolean(patientData[type]);
	
	      var rule = validationRules[type];
	      return rule ? rule(patientData[type]) : required;
	    });
	  };
	};
	
	var clearValidationErrorsOnChange = exports.clearValidationErrorsOnChange = function clearValidationErrorsOnChange(clear, formState) {
	  (0, _useDidUpdate2.default)(function () {
	    clear();
	  }, formState);
	};
	
	var validateField = exports.validateField = function validateField(fieldName, value) {
	  var rule = _validations.PATTERNS[fieldName];
	  if (!rule) return true;
	  return rule.test(value);
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useToggleFlag = useToggleFlag;
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useToggleFlag() {
	  var defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var _useState = (0, _react.useState)(defaultState),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      opened = _useState2[0],
	      setOpened = _useState2[1];
	
	  var close = (0, _react.useCallback)(function () {
	    return setOpened(false);
	  }, []);
	  var open = (0, _react.useCallback)(function () {
	    return setOpened(true);
	  }, []);
	
	  return [opened, open, close];
	}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combinedPendingDataModalRequest = exports.combinedPendingDataRequest = exports.selectProviderList = exports.selectProviderAuthentications = exports.selectConnectedDevicesError = exports.selectConnectedDevices = exports.selectCurrentMetrics = exports.selectCurrentMetricTemperatureType = exports.selectCurrentMetricGlucoseType = exports.selectCurrentMetricWeightType = exports.selectCurrentMetricHeightType = exports.selectCurrentMetricGlucose = exports.selectCurrentMetricHeight = exports.selectCurrentMetricWeight = exports.selectCurrentHealthboardOptionsChartPeriod = exports.selectCurrentHealthboardOptionsDataType = exports.selectAddHeightDataPending = exports.selectAddWeightDataPending = exports.selectOpenedGoogleFitModal = exports.selectOpenedAddDataModal = exports.selectTypeAddDataModal = exports.selectTypeSingleDayGrafModal = exports.selectBaseDateSingleDayGrafModal = exports.selectMetricSettingsSinglePointValuesModal = exports.selectValueSinglePointValuesModal = exports.selectMonthTitleSinglePointValuesModal = exports.selectEntitySinglePointValuesModal = exports.selectTypeSinglePointValuesModal = exports.selectOpenedSinglePointValuesModal = exports.selectOpenedSingleDayGrafModal = exports.selectHeightMeasurementEntityModalPending = exports.selectHeightMeasurementEntityPending = exports.selectHeightMeasurementModalEntity = exports.selectHeightMeasurementEntity = exports.selectWeightMeasurementEntityModalPending = exports.selectWeightMeasurementEntityPending = exports.selectWeightMeasurementModalEntity = exports.selectWeightMeasurementEntity = exports.selectBodySurfaceAreaMeasurementModalEntityPending = exports.selectBodyTemperatureMeasurementModalEntity = exports.selectBodyTemperatureMeasurementEntityPending = exports.selectBodyTemperatureMeasurementEntity = exports.selectBodyTemperatureMeasurementModalEntityPending = exports.selectBodySurfaceAreaMeasurementModalEntity = exports.selectBodySurfaceAreaMeasurementEntityPending = exports.selectBodySurfaceAreaMeasurementEntity = exports.selectRespiratoryRateMeasurementModalEntityPending = exports.selectRespiratoryRateMeasurementModalEntity = exports.selectRespiratoryRateMeasurementEntityPending = exports.selectRespiratoryRateMeasurementEntity = exports.selectBloodPressureMeasurementModalEntityPending = exports.selectBloodPressureMeasurementModalEntity = exports.selectBloodPressureMeasurementEntityPending = exports.selectBloodPressureMeasurementEntity = exports.selectBloodGlucoseMeasurementEntityModalPending = exports.selectBloodGlucoseMeasurementEntityPending = exports.selectBloodGlucoseMeasurementModalEntity = exports.selectBloodGlucoseMeasurementEntity = exports.selectBMIMeasurementEntityModalPending = exports.selectBMIMeasurementEntityPending = exports.selectBMIMeasurementModalEntity = exports.selectBMIMeasurementEntity = exports.selectDistanceMeasurementEntityModalPending = exports.selectDistanceMeasurementEntityPending = exports.selectDistanceMeasurementModalEntity = exports.selectDistanceMeasurementEntity = exports.selectHeartRateMeasurementEntityModalPending = exports.selectSaturationMeasurementEntityModalPending = exports.selectStepsMeasurementEntityModalPending = exports.selectHeartRateMeasurementEntityPending = exports.selectSaturationMeasurementEntityPending = exports.selectStepsMeasurementEntityPending = exports.selectStepsMeasurementModalEntity = exports.selectHeightMeasurementModalHistoricList = exports.selectWeightMeasurementModalHistoricList = exports.selectDistanceMeasurementModalHistoricList = exports.selectStepsMeasurementModalHistoricList = exports.selectBloodGlucoseMeasurementModalHistoricList = exports.selectBMIMeasurementModalHistoricList = exports.selectHeartRateMeasurementModalHistoricList = exports.selectHeartRateMeasurementEntity = exports.selectSaturationMeasurementModalHistoricList = exports.selectSaturationMeasurementEntity = exports.selectStepsMeasurementEntity = exports.selectHistoricMeasurementsPreviousDate = exports.selectHistoricMeasurementsListPending = exports.selectHistoricMeasurementsList = exports.selectVitalsActivityEntity = exports.selectPatientPortalRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectPatientPortalRootState = exports.selectPatientPortalRootState = function selectPatientPortalRootState(state) {
	  return (0, _get2.default)(state, 'profiles.patientHealthboard');
	};
	
	var selectVitalsActivityEntity = exports.selectVitalsActivityEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'vitalsActivity.list', []);
	});
	
	var selectHistoricMeasurementsList = exports.selectHistoricMeasurementsList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'historicMeasurements.list', []);
	});
	
	var selectHistoricMeasurementsListPending = exports.selectHistoricMeasurementsListPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'historicMeasurements.sending', false);
	});
	
	var selectHistoricMeasurementsPreviousDate = exports.selectHistoricMeasurementsPreviousDate = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'historicMeasurements.meta.previousPeriodStartDate', '');
	});
	
	var selectStepsMeasurementEntity = exports.selectStepsMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'stepsMeasurement.list', []);
	});
	
	var selectSaturationMeasurementEntity = exports.selectSaturationMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'saturationMeasurement.list', []);
	});
	
	var selectSaturationMeasurementModalHistoricList = exports.selectSaturationMeasurementModalHistoricList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'saturationMeasurementModal.list', []);
	});
	
	var selectHeartRateMeasurementEntity = exports.selectHeartRateMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'heartRateMeasurement.list', []);
	});
	
	var selectHeartRateMeasurementModalHistoricList = exports.selectHeartRateMeasurementModalHistoricList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'heartRateMeasurementModal.list', []);
	});
	
	var selectBMIMeasurementModalHistoricList = exports.selectBMIMeasurementModalHistoricList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bmiMeasurementModal.list', []);
	});
	
	var selectBloodGlucoseMeasurementModalHistoricList = exports.selectBloodGlucoseMeasurementModalHistoricList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bloodGlucoseMeasurementModal.list', []);
	});
	
	var selectStepsMeasurementModalHistoricList = exports.selectStepsMeasurementModalHistoricList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'stepsMeasurementModal.list', []);
	});
	
	var selectDistanceMeasurementModalHistoricList = exports.selectDistanceMeasurementModalHistoricList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'distanceMeasurementModal.list', []);
	});
	
	var selectWeightMeasurementModalHistoricList = exports.selectWeightMeasurementModalHistoricList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'weightMeasurementModal.list', []);
	});
	
	var selectHeightMeasurementModalHistoricList = exports.selectHeightMeasurementModalHistoricList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'heightMeasurementModal.list', []);
	});
	
	var selectStepsMeasurementModalEntity = exports.selectStepsMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'stepsMeasurementModal.list', []);
	});
	
	var selectStepsMeasurementEntityPending = exports.selectStepsMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'stepsMeasurement.sending', false);
	});
	
	var selectSaturationMeasurementEntityPending = exports.selectSaturationMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'saturationMeasurement.sending', false);
	});
	
	var selectHeartRateMeasurementEntityPending = exports.selectHeartRateMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'heartRateMeasurement.sending', false);
	});
	
	var selectStepsMeasurementEntityModalPending = exports.selectStepsMeasurementEntityModalPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'stepsMeasurementModal.sending', false);
	});
	
	var selectSaturationMeasurementEntityModalPending = exports.selectSaturationMeasurementEntityModalPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'saturationMeasurementModal.sending', false);
	});
	
	var selectHeartRateMeasurementEntityModalPending = exports.selectHeartRateMeasurementEntityModalPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'heartRateMeasurementModal.sending', false);
	});
	
	var selectDistanceMeasurementEntity = exports.selectDistanceMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'distanceMeasurement.list', []);
	});
	
	var selectDistanceMeasurementModalEntity = exports.selectDistanceMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'distanceMeasurementModal.list', []);
	});
	
	var selectDistanceMeasurementEntityPending = exports.selectDistanceMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'distanceMeasurement.sending', false);
	});
	
	var selectDistanceMeasurementEntityModalPending = exports.selectDistanceMeasurementEntityModalPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'distanceMeasurementModal.sending', false);
	});
	
	var selectBMIMeasurementEntity = exports.selectBMIMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bmiMeasurement.list', []);
	});
	
	var selectBMIMeasurementModalEntity = exports.selectBMIMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bmiMeasurementModal.list', []);
	});
	
	var selectBMIMeasurementEntityPending = exports.selectBMIMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bmiMeasurement.sending', false);
	});
	
	var selectBMIMeasurementEntityModalPending = exports.selectBMIMeasurementEntityModalPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bmiMeasurementModal.sending', false);
	});
	
	var selectBloodGlucoseMeasurementEntity = exports.selectBloodGlucoseMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bloodGlucoseMeasurement.list', []);
	});
	
	var selectBloodGlucoseMeasurementModalEntity = exports.selectBloodGlucoseMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bloodGlucoseMeasurementModal.list', []);
	});
	
	var selectBloodGlucoseMeasurementEntityPending = exports.selectBloodGlucoseMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bloodGlucoseMeasurement.sending', false);
	});
	
	var selectBloodGlucoseMeasurementEntityModalPending = exports.selectBloodGlucoseMeasurementEntityModalPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bloodGlucoseMeasurementModal.sending', false);
	});
	
	var selectBloodPressureMeasurementEntity = exports.selectBloodPressureMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bloodPressureMeasurement.list', []);
	});
	
	var selectBloodPressureMeasurementEntityPending = exports.selectBloodPressureMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bloodPressureMeasurement.sending', false);
	});
	
	var selectBloodPressureMeasurementModalEntity = exports.selectBloodPressureMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bloodPressureMeasurementModal.list', []);
	});
	
	var selectBloodPressureMeasurementModalEntityPending = exports.selectBloodPressureMeasurementModalEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bloodPressureMeasurementModal.sending', false);
	});
	
	var selectRespiratoryRateMeasurementEntity = exports.selectRespiratoryRateMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'respiratoryRateMeasurement.list', []);
	});
	
	var selectRespiratoryRateMeasurementEntityPending = exports.selectRespiratoryRateMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'respiratoryRateMeasurement.sending', false);
	});
	
	var selectRespiratoryRateMeasurementModalEntity = exports.selectRespiratoryRateMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'respiratoryRateMeasurementModal.list', []);
	});
	
	var selectRespiratoryRateMeasurementModalEntityPending = exports.selectRespiratoryRateMeasurementModalEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'respiratoryRateMeasurementModal.sending', false);
	});
	
	var selectBodySurfaceAreaMeasurementEntity = exports.selectBodySurfaceAreaMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bodySurfaceAreaMeasurement.list', []);
	});
	
	var selectBodySurfaceAreaMeasurementEntityPending = exports.selectBodySurfaceAreaMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bodySurfaceAreaMeasurement.sending', false);
	});
	
	var selectBodySurfaceAreaMeasurementModalEntity = exports.selectBodySurfaceAreaMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bodySurfaceAreaMeasurementModal.list', []);
	});
	
	var selectBodyTemperatureMeasurementModalEntityPending = exports.selectBodyTemperatureMeasurementModalEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bodyTemperatureMeasurementModal.sending', false);
	});
	
	var selectBodyTemperatureMeasurementEntity = exports.selectBodyTemperatureMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bodyTemperatureMeasurement.list', []);
	});
	
	var selectBodyTemperatureMeasurementEntityPending = exports.selectBodyTemperatureMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bodyTemperatureMeasurement.sending', false);
	});
	
	var selectBodyTemperatureMeasurementModalEntity = exports.selectBodyTemperatureMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bodyTemperatureMeasurementModal.list', []);
	});
	
	var selectBodySurfaceAreaMeasurementModalEntityPending = exports.selectBodySurfaceAreaMeasurementModalEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'bodySurfaceAreaMeasurementModal.sending', false);
	});
	
	var selectWeightMeasurementEntity = exports.selectWeightMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'weightMeasurement.list', []);
	});
	
	var selectWeightMeasurementModalEntity = exports.selectWeightMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'weightMeasurementModal.list', []);
	});
	
	var selectWeightMeasurementEntityPending = exports.selectWeightMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'weightMeasurement.sending', false);
	});
	
	var selectWeightMeasurementEntityModalPending = exports.selectWeightMeasurementEntityModalPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'weightMeasurementModal.sending', false);
	});
	
	var selectHeightMeasurementEntity = exports.selectHeightMeasurementEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'heightMeasurement.list', []);
	});
	
	var selectHeightMeasurementModalEntity = exports.selectHeightMeasurementModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'heightMeasurementModal.list', []);
	});
	
	var selectHeightMeasurementEntityPending = exports.selectHeightMeasurementEntityPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'heightMeasurement.sending', false);
	});
	
	var selectHeightMeasurementEntityModalPending = exports.selectHeightMeasurementEntityModalPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'heightMeasurementModal.sending', false);
	});
	
	var selectOpenedSingleDayGrafModal = exports.selectOpenedSingleDayGrafModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'singleDayGrafModal.opened', false);
	});
	
	var selectOpenedSinglePointValuesModal = exports.selectOpenedSinglePointValuesModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'singlePointValuesModal.opened', false);
	});
	
	var selectTypeSinglePointValuesModal = exports.selectTypeSinglePointValuesModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'singlePointValuesModal.type', '');
	});
	
	var selectEntitySinglePointValuesModal = exports.selectEntitySinglePointValuesModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'singlePointValuesModal.entity', []);
	});
	
	var selectMonthTitleSinglePointValuesModal = exports.selectMonthTitleSinglePointValuesModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'singlePointValuesModal.monthTitle', '');
	});
	
	var selectValueSinglePointValuesModal = exports.selectValueSinglePointValuesModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'singlePointValuesModal.value', '');
	});
	
	var selectMetricSettingsSinglePointValuesModal = exports.selectMetricSettingsSinglePointValuesModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'singlePointValuesModal.metricSettings', {});
	});
	
	var selectBaseDateSingleDayGrafModal = exports.selectBaseDateSingleDayGrafModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'singleDayGrafModal.baseDate');
	});
	
	var selectTypeSingleDayGrafModal = exports.selectTypeSingleDayGrafModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'singleDayGrafModal.type');
	});
	
	var selectTypeAddDataModal = exports.selectTypeAddDataModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'addDataModal.type');
	});
	
	var selectOpenedAddDataModal = exports.selectOpenedAddDataModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'addDataModal.opened');
	});
	
	var selectOpenedGoogleFitModal = exports.selectOpenedGoogleFitModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'googleFitModal.opened');
	});
	
	var selectAddWeightDataPending = exports.selectAddWeightDataPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'addWeightData.sending', false);
	});
	
	var selectAddHeightDataPending = exports.selectAddHeightDataPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'addHeightData.sending', false);
	});
	
	var selectCurrentHealthboardOptionsDataType = exports.selectCurrentHealthboardOptionsDataType = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'currentHealthboardOptions.dataType');
	});
	
	var selectCurrentHealthboardOptionsChartPeriod = exports.selectCurrentHealthboardOptionsChartPeriod = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'currentHealthboardOptions.chartPeriod');
	});
	
	var selectCurrentMetricWeight = exports.selectCurrentMetricWeight = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'currentHealthboardOptions.currentMetricWeight');
	});
	
	var selectCurrentMetricHeight = exports.selectCurrentMetricHeight = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'currentHealthboardOptions.currentMetricHeight');
	});
	
	var selectCurrentMetricGlucose = exports.selectCurrentMetricGlucose = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'currentHealthboardOptions.currentMetricGlucose');
	});
	
	var selectCurrentMetricHeightType = exports.selectCurrentMetricHeightType = (0, _reselect.createSelector)(selectCurrentMetricHeight, function (state) {
	  return (0, _get2.default)(state, 'type');
	});
	
	var selectCurrentMetricWeightType = exports.selectCurrentMetricWeightType = (0, _reselect.createSelector)(selectCurrentMetricWeight, function (state) {
	  return (0, _get2.default)(state, 'type');
	});
	
	var selectCurrentMetricGlucoseType = exports.selectCurrentMetricGlucoseType = (0, _reselect.createSelector)(selectCurrentMetricGlucose, function (state) {
	  return (0, _get2.default)(state, 'type');
	});
	
	var selectCurrentMetricTemperatureType = exports.selectCurrentMetricTemperatureType = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'currentHealthboardOptions.currentMetricTemperature.type', _constants.TEMPERATURE_METRIC.FAHRENHEIT);
	});
	
	var selectCurrentMetrics = exports.selectCurrentMetrics = (0, _reselect.createSelector)(selectCurrentMetricHeightType, selectCurrentMetricWeightType, selectCurrentMetricTemperatureType, selectCurrentMetricGlucoseType, function (height, weight, temperature, glucose) {
	  return {
	    currentMetricHeight: height,
	    currentMetricWeight: weight,
	    currentMetricTemperature: temperature,
	    currentMetricGlucose: glucose
	  };
	});
	
	var selectConnectedDevices = exports.selectConnectedDevices = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'connectedDevices.list', []);
	});
	
	var selectConnectedDevicesError = exports.selectConnectedDevicesError = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return !!(0, _get2.default)(state, 'connectedDevices.error');
	});
	
	var selectProviderAuthentications = exports.selectProviderAuthentications = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'providerAuthentications.list', []);
	});
	
	var selectProviderList = exports.selectProviderList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'providerList.list', []);
	});
	
	var combinedPendingDataRequest = exports.combinedPendingDataRequest = (0, _reselect.createSelector)(selectStepsMeasurementEntityPending, selectDistanceMeasurementEntityPending, selectBMIMeasurementEntityPending, selectBloodGlucoseMeasurementEntityPending, selectWeightMeasurementEntityPending, selectHeightMeasurementEntityPending, selectSaturationMeasurementEntityPending, selectHeartRateMeasurementEntityPending, function (stepsDataPending, distanceDataPending, bmiDataPending, weightDataPending, heightDataPending, saturationDataPending, heartRateDataPending, bloodGlucoseDataPending) {
	  return stepsDataPending || distanceDataPending || bmiDataPending || weightDataPending || heightDataPending || saturationDataPending || heartRateDataPending || bloodGlucoseDataPending;
	});
	
	var combinedPendingDataModalRequest = exports.combinedPendingDataModalRequest = (0, _reselect.createSelector)(selectStepsMeasurementEntityModalPending, selectDistanceMeasurementEntityModalPending, selectBMIMeasurementEntityModalPending, selectBloodGlucoseMeasurementEntityModalPending, selectWeightMeasurementEntityModalPending, selectHeightMeasurementEntityModalPending, selectSaturationMeasurementEntityModalPending, selectHeartRateMeasurementEntityModalPending, function (stepsDataPending, distanceDataPending, bmiDataPending, weightDataPending, heightDataPending, saturationDataPending, heartRateDataPending, bloodGlucoseDataPending) {
	  return stepsDataPending || distanceDataPending || bmiDataPending || weightDataPending || heightDataPending || saturationDataPending || heartRateDataPending || bloodGlucoseDataPending;
	});

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(169);
	var core = __webpack_require__(100);
	var ctx = __webpack_require__(315);
	var hide = __webpack_require__(365);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(1650);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var babelPluginFlowReactPropTypes_proptype_CellPosition =  true ? null : {
	  columnIndex: require('prop-types').number.isRequired,
	  rowIndex: require('prop-types').number.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellPosition', {
	  value: babelPluginFlowReactPropTypes_proptype_CellPosition,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_CellRendererParams =  true ? null : {
	  columnIndex: require('prop-types').number.isRequired,
	  isScrolling: require('prop-types').bool.isRequired,
	  isVisible: require('prop-types').bool.isRequired,
	  key: require('prop-types').string.isRequired,
	  parent: require('prop-types').object.isRequired,
	  rowIndex: require('prop-types').number.isRequired,
	  style: require('prop-types').object.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRendererParams', {
	  value: babelPluginFlowReactPropTypes_proptype_CellRendererParams,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_CellRenderer =  true ? null : require('prop-types').func;
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRenderer', {
	  value: babelPluginFlowReactPropTypes_proptype_CellRenderer,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams =  true ? null : {
	  cellCache: require('prop-types').object.isRequired,
	  cellRenderer: require('prop-types').func.isRequired,
	  columnSizeAndPositionManager: typeof _ScalingCellSizeAndPositionManager2.default === 'function' ? require('prop-types').instanceOf(_ScalingCellSizeAndPositionManager2.default).isRequired : require('prop-types').any.isRequired,
	  columnStartIndex: require('prop-types').number.isRequired,
	  columnStopIndex: require('prop-types').number.isRequired,
	  deferredMeasurementCache: require('prop-types').object,
	  horizontalOffsetAdjustment: require('prop-types').number.isRequired,
	  isScrolling: require('prop-types').bool.isRequired,
	  parent: require('prop-types').object.isRequired,
	  rowSizeAndPositionManager: typeof _ScalingCellSizeAndPositionManager2.default === 'function' ? require('prop-types').instanceOf(_ScalingCellSizeAndPositionManager2.default).isRequired : require('prop-types').any.isRequired,
	  rowStartIndex: require('prop-types').number.isRequired,
	  rowStopIndex: require('prop-types').number.isRequired,
	  scrollLeft: require('prop-types').number.isRequired,
	  scrollTop: require('prop-types').number.isRequired,
	  styleCache: require('prop-types').object.isRequired,
	  verticalOffsetAdjustment: require('prop-types').number.isRequired,
	  visibleColumnIndices: require('prop-types').object.isRequired,
	  visibleRowIndices: require('prop-types').object.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams', {
	  value: babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_CellRangeRenderer =  true ? null : require('prop-types').func;
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellRangeRenderer', {
	  value: babelPluginFlowReactPropTypes_proptype_CellRangeRenderer,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_CellSizeGetter =  true ? null : require('prop-types').func;
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellSizeGetter', {
	  value: babelPluginFlowReactPropTypes_proptype_CellSizeGetter,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_CellSize =  true ? null : require('prop-types').oneOfType([require('prop-types').func, require('prop-types').number]);
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellSize', {
	  value: babelPluginFlowReactPropTypes_proptype_CellSize,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_NoContentRenderer =  true ? null : require('prop-types').func;
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_NoContentRenderer', {
	  value: babelPluginFlowReactPropTypes_proptype_NoContentRenderer,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_Scroll =  true ? null : {
	  clientHeight: require('prop-types').number.isRequired,
	  clientWidth: require('prop-types').number.isRequired,
	  scrollHeight: require('prop-types').number.isRequired,
	  scrollLeft: require('prop-types').number.isRequired,
	  scrollTop: require('prop-types').number.isRequired,
	  scrollWidth: require('prop-types').number.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Scroll', {
	  value: babelPluginFlowReactPropTypes_proptype_Scroll,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange =  true ? null : {
	  horizontal: require('prop-types').bool.isRequired,
	  vertical: require('prop-types').bool.isRequired,
	  size: require('prop-types').number.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange', {
	  value: babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_RenderedSection =  true ? null : {
	  columnOverscanStartIndex: require('prop-types').number.isRequired,
	  columnOverscanStopIndex: require('prop-types').number.isRequired,
	  columnStartIndex: require('prop-types').number.isRequired,
	  columnStopIndex: require('prop-types').number.isRequired,
	  rowOverscanStartIndex: require('prop-types').number.isRequired,
	  rowOverscanStopIndex: require('prop-types').number.isRequired,
	  rowStartIndex: require('prop-types').number.isRequired,
	  rowStopIndex: require('prop-types').number.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RenderedSection', {
	  value: babelPluginFlowReactPropTypes_proptype_RenderedSection,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams =  true ? null : {
	  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
	  direction: require('prop-types').oneOf(['horizontal', 'vertical']).isRequired,
	
	
	  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
	  scrollDirection: require('prop-types').oneOf([-1, 1]).isRequired,
	
	
	  // Number of rows or columns in the current axis
	  cellCount: require('prop-types').number.isRequired,
	
	
	  // Maximum number of cells to over-render in either direction
	  overscanCellsCount: require('prop-types').number.isRequired,
	
	
	  // Begin of range of visible cells
	  startIndex: require('prop-types').number.isRequired,
	
	
	  // End of range of visible cells
	  stopIndex: require('prop-types').number.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams', {
	  value: babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_OverscanIndices =  true ? null : {
	  overscanStartIndex: require('prop-types').number.isRequired,
	  overscanStopIndex: require('prop-types').number.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_OverscanIndices', {
	  value: babelPluginFlowReactPropTypes_proptype_OverscanIndices,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter =  true ? null : require('prop-types').func;
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter', {
	  value: babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_Alignment =  true ? null : require('prop-types').oneOf(['auto', 'end', 'start', 'center']);
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Alignment', {
	  value: babelPluginFlowReactPropTypes_proptype_Alignment,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_VisibleCellRange =  true ? null : {
	  start: require('prop-types').number,
	  stop: require('prop-types').number
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_VisibleCellRange', {
	  value: babelPluginFlowReactPropTypes_proptype_VisibleCellRange,
	  configurable: true
	});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _strings = __webpack_require__(15);
	
	var _selectors = __webpack_require__(23);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(2242);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var Card = function Card(_ref) {
	  var additionalContent = _ref.additionalContent,
	      className = _ref.className,
	      text = _ref.text,
	      userId = _ref.userId,
	      providerId = _ref.providerId,
	      loggedUser = _ref.loggedUser,
	      style = _ref.style,
	      additionalIcons = _ref.additionalIcons,
	      handleClick = _ref.handleClick,
	      withGreyHover = _ref.withGreyHover;
	
	  var primaryText = text.primary;
	  var isLoggedUser = false;
	  var intro = text.intro ? _react2.default.createElement('span', { className: text.intro }) : null;
	
	  if ((userId || providerId) && loggedUser) {
	    // avoid comparison if card is used for any other reason then users list
	    var comparedId = userId ? (0, _get2.default)(loggedUser, 'id') : (0, _get2.default)(loggedUser, 'primaryProviderProfile.id');
	    isLoggedUser = userId ? userId === comparedId : providerId === comparedId;
	
	    if (isLoggedUser) {
	      primaryText = _react2.default.createElement(
	        'span',
	        { styleName: 'helperContainer' },
	        _react2.default.createElement(
	          'span',
	          null,
	          primaryText
	        ),
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.YOU),
	        intro
	      );
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: className, style: style }, { styleName: 'root', onClick: handleClick }),
	    additionalContent.left ? _react2.default.createElement('div', { styleName: 'icon icon--left', children: additionalContent.left }) : null,
	    _react2.default.createElement(
	      'div',
	      { styleName: 'textWrapper', className: 'text-block' },
	      primaryText ? _react2.default.createElement(
	        'div',
	        { styleName: 'chatWrapper' },
	        !(0, _isEmpty2.default)(additionalIcons) && additionalIcons.map(function (icon) {
	          return _react2.default.createElement(_Icon2.default, {
	            style: {
	              marginRight: '4px',
	              alignSelf: 'baseline',
	              fill: icon.fill
	            },
	            name: icon.name,
	            height: icon.height,
	            width: icon.width,
	            key: icon.name
	          });
	        }),
	        _react2.default.createElement(
	          'span',
	          {
	            // styleName="text text--primary"
	            styleName: (0, _classnames2.default)('text text--primary', {
	              bold: withGreyHover
	            })
	          },
	          primaryText,
	          !isLoggedUser ? intro : null
	        )
	      ) : null,
	      text.complementary ? _react2.default.createElement(
	        'span',
	        { styleName: 'text text--secondary' },
	        text.complementary
	      ) : null
	    ),
	    additionalContent.right ? _react2.default.createElement('div', { styleName: 'icon icon--right', children: additionalContent.right }) : null
	  );
	};
	
	Card.propTypes = {
	  withGreyHover: _propTypes2.default.bool,
	  additionalContent: _propTypes2.default.shape({
	    left: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.node, _propTypes2.default.element]),
	    right: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.node, _propTypes2.default.element])
	  }),
	  className: _propTypes2.default.string,
	  text: _propTypes2.default.shape({
	    primary: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.string]),
	    complementary: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.string]),
	    className: _propTypes2.default.string,
	    intro: _propTypes2.default.string
	  }).isRequired,
	  userId: _propTypes2.default.number,
	  providerId: _propTypes2.default.number,
	  handleClick: _propTypes2.default.func,
	  loggedUser: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  additionalIcons: _propTypes2.default.array
	};
	
	Card.defaultProps = {
	  handleClick: function handleClick() {}
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loggedUser: (0, _selectors.selectUserToShow)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactCssModules2.default)(Card, _index2.default, { allowMultiple: true }));

/***/ }),
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _interval = __webpack_require__(3828);
	
	Object.defineProperty(exports, 'INTERVAL', {
	  enumerable: true,
	  get: function get() {
	    return _interval.INTERVAL;
	  }
	});
	
	var _period = __webpack_require__(614);
	
	Object.defineProperty(exports, 'UNIT', {
	  enumerable: true,
	  get: function get() {
	    return _period.UNIT;
	  }
	});
	Object.defineProperty(exports, 'PERIOD', {
	  enumerable: true,
	  get: function get() {
	    return _period.PERIOD;
	  }
	});
	Object.defineProperty(exports, 'SYMBOL_BY_PERIOD', {
	  enumerable: true,
	  get: function get() {
	    return _period.SYMBOL_BY_PERIOD;
	  }
	});
	
	var _PROVIDERS = __webpack_require__(3826);
	
	Object.defineProperty(exports, 'PROVIDERS', {
	  enumerable: true,
	  get: function get() {
	    return _PROVIDERS.PROVIDERS;
	  }
	});
	Object.defineProperty(exports, 'PROVIDER_ALL', {
	  enumerable: true,
	  get: function get() {
	    return _PROVIDERS.PROVIDER_ALL;
	  }
	});
	Object.defineProperty(exports, 'PROVIDER_OPTION', {
	  enumerable: true,
	  get: function get() {
	    return _PROVIDERS.PROVIDER_OPTION;
	  }
	});
	
	var _formats = __webpack_require__(3827);
	
	Object.defineProperty(exports, 'TOOLTIP_DATE_FORMAT', {
	  enumerable: true,
	  get: function get() {
	    return _formats.TOOLTIP_DATE_FORMAT;
	  }
	});
	Object.defineProperty(exports, 'HISTORY_DATE_FORMAT', {
	  enumerable: true,
	  get: function get() {
	    return _formats.HISTORY_DATE_FORMAT;
	  }
	});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentLocationSelector = exports.isUrlPreview = exports.selectPrevLocation = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectPrevLocation = exports.selectPrevLocation = function selectPrevLocation(state) {
	  return (0, _get2.default)(state, 'common.locations.previousLocation');
	};
	var isUrlPreview = exports.isUrlPreview = function isUrlPreview(state) {
	  return (0, _get2.default)(state, 'common.urlPreview');
	};
	var currentLocationSelector = exports.currentLocationSelector = function currentLocationSelector(state) {
	  return (0, _get2.default)(state, 'common.locations.currentLocation');
	};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useInjectSaga = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(963);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _reactRedux = __webpack_require__(6);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _sagaInjectors2 = _interopRequireDefault(_sagaInjectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Dynamically injects a saga, passes component's props as saga arguments
	 *
	 * @param {string} key A key of the saga
	 * @param {function} saga A root saga that will be injected
	 * @param {string} [mode] By default (constants.DAEMON) the saga will be started
	 * on component mount and never canceled or started again. Another two options:
	 *   - constants.RESTART_ON_REMOUNT — the saga will be started on component mount and
	 *   cancelled with `task.cancel()` on component unmount for improved performance,
	 *   - constants.ONCE_TILL_UNMOUNT — behaves like 'RESTART_ON_REMOUNT' but never runs it again.
	 *
	 */
	/* eslint-disable react/require-optimization,immutable/no-mutation */
	exports.default = function (_ref) {
	  var key = _ref.key,
	      saga = _ref.saga,
	      mode = _ref.mode;
	  return function (WrappedComponent) {
	    var _class, _temp;
	
	    var InjectSaga = (_temp = _class = function (_React$Component) {
	      (0, _inherits3.default)(InjectSaga, _React$Component);
	
	      function InjectSaga(props, context) {
	        (0, _classCallCheck3.default)(this, InjectSaga);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (InjectSaga.__proto__ || (0, _getPrototypeOf2.default)(InjectSaga)).call(this, props, context));
	
	        _this.injectors = (0, _sagaInjectors2.default)(context.store);
	
	        _this.injectors.injectSaga(key, { saga: saga, mode: mode }, _this.props);
	        return _this;
	      }
	
	      (0, _createClass3.default)(InjectSaga, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.injectors.ejectSaga(key);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(WrappedComponent, this.props);
	        }
	      }]);
	      return InjectSaga;
	    }(_react2.default.Component), _class.WrappedComponent = WrappedComponent, _class.contextType = _reactRedux.ReactReduxContext, _class.displayName = 'withSaga(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp);
	
	
	    return (0, _hoistNonReactStatics2.default)(InjectSaga, WrappedComponent);
	  };
	};
	
	var useInjectSaga = function useInjectSaga(_ref2) {
	  var key = _ref2.key,
	      saga = _ref2.saga,
	      mode = _ref2.mode;
	
	  var context = _react2.default.useContext(_reactRedux.ReactReduxContext);
	  _react2.default.useEffect(function () {
	    var injectors = (0, _sagaInjectors2.default)(context.store);
	    injectors.injectSaga(key, { saga: saga, mode: mode });
	
	    return function () {
	      injectors.ejectSaga(key);
	    };
	  }, []);
	};
	
	exports.useInjectSaga = useInjectSaga;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFieldProps = exports.FIELD_FILLING_TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _strings = __webpack_require__(15);
	
	var _formFields = __webpack_require__(38);
	
	var _validations = __webpack_require__(81);
	
	var _amountValidator = __webpack_require__(911);
	
	var _amountValidator2 = _interopRequireDefault(_amountValidator);
	
	var _ids = __webpack_require__(46);
	
	var _constants = __webpack_require__(768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIELD_FILLING_TYPES = exports.FIELD_FILLING_TYPES = {
	  REQUIRED: 'required',
	  OPTIONAL: 'optional'
	};
	
	var commonProps = {
	  className: 'mt3'
	};
	
	var getLabelWithOptional = function getLabelWithOptional(formatMessage) {
	  return function (text, type) {
	    var optText = formatMessage(_strings.COMMON.optional);
	    var formattedText = formatMessage(text);
	
	    if (type === FIELD_FILLING_TYPES.OPTIONAL) return formattedText + ' ' + optText;
	
	    return formattedText;
	  };
	};
	// TODO use FIELD_FILLING_TYPES for required and optional fields
	function getFieldProps(formatMessage, _onChange) {
	  var labelWithOptional = getLabelWithOptional(formatMessage);
	
	  return function (field, type) {
	    switch (field) {
	      case _formFields.PROFILE_FIELDS_TYPES.EMAIL:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.EMAIL,
	            type: 'text',
	            label: labelWithOptional(_strings.PROFILE_FIELDS.fieldNames.email, type),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.email),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.PHONE_NUMBER,
	            type: 'number',
	            label: labelWithOptional(_strings.PROFILE_FIELDS.fieldNames.mobilePhone, type),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.mobilePhone),
	            onChange: function onChange(name, value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.HOME_PHONE,
	            type: 'number',
	            limit: _validations.LENGTH_VALUES.HOME_PHONE.MAX,
	            label: labelWithOptional(_strings.PROFILE_FIELDS.fieldNames.homePhone, type),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.homePhone),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.FIRST_NAME,
	            required: true,
	            type: 'text',
	            limit: _validations.LENGTH_VALUES.FIRST_NAME.MAX,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.firstName),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.firstName),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.MIDDLE_NAME:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.MIDDLE_NAME,
	            type: 'text',
	            limit: _validations.LENGTH_VALUES.MIDDLE_NAME.MAX,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.middleName),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.middleName),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.LAST_NAME:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.LAST_NAME,
	            required: true,
	            type: 'text',
	            limit: _validations.LENGTH_VALUES.LAST_NAME.MAX,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.lastName),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.lastName),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.NAME_SUFFIX:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.NAME_SUFFIX,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.nameSuffix),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.nameSuffix),
	            onChange: function onChange(_ref) {
	              var value = _ref.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.GENDER:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            required: true,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.gender),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.gender),
	            onChange: function onChange(_ref2) {
	              var value = _ref2.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.DOB:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            required: true,
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.LOCAL_UID:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            limit: _validations.LENGTH_VALUES.MRNS,
	            label: labelWithOptional(_strings.PROFILE_FIELDS.fieldNames.mrns, type),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.mrns),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value.trim()));
	            },
	            autoComplete: 'new-password',
	            name: 'mrns',
	            id: 'mrns'
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.SSN:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.SSN,
	            limit: _validations.LENGTH_VALUES.SSN,
	            label: labelWithOptional(_strings.PROFILE_FIELDS.fieldNames.ssnLong, type),
	            placeholder: formatMessage({ id: 'profile.fields.ssnPlaceHolder' }),
	            onChange: function onChange(name, value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            },
	            autoComplete: 'new-password',
	            name: 'ssn'
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.ADDRESS_1,
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            type: 'text',
	            limit: _validations.LENGTH_VALUES.ADDRESS_1.MAX,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.address1),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.address1),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.ADDRESS_2,
	            type: 'text',
	            limit: _validations.LENGTH_VALUES.ADDRESS_2.MAX,
	            label: labelWithOptional(_strings.PROFILE_FIELDS.fieldNames.address2, type),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.address2),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.CITY:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.CITY,
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            type: 'text',
	            limit: _validations.LENGTH_VALUES.CITY.MAX,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.city),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.city),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.STATE:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.STATE,
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.state),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.state),
	            onChange: function onChange(_ref3) {
	              var value = _ref3.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.POSTAL_CODE,
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            type: 'text',
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.postalCode),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.postalCode),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.IS_HOME_LOCATION_DIFFERENT:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.IS_HOME_LOCATION_DIFFERENT,
	            size: 16,
	            style: { display: 'flex', alignItems: 'center' },
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.isHomeLocationDifferent),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.COUNTRY:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.country),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.country),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.RELATION:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.relation),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.relation),
	            onChange: function onChange(_ref4) {
	              var value = _ref4.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.ROLE:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            multi: false,
	            needUpdateDefaultValue: true,
	            label: formatMessage({ id: 'profile.fields.role' }),
	            placeholder: formatMessage({
	              id: 'profile.fields.role.placeholder'
	            }),
	            onChange: function onChange(_ref5) {
	              var value = _ref5.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.RELATIONSHIP:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            needUpdateDefaultValue: true,
	            multi: false,
	            label: formatMessage({ id: 'profile.fields.relationship' }),
	            placeholder: formatMessage({
	              id: 'profile.fields.relationship.placeholder'
	            }),
	            onChange: function onChange(_ref6) {
	              var value = _ref6.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.LOGIN:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            type: 'text',
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            label: formatMessage({ id: 'fields.login' }),
	            placeholder: formatMessage({ id: 'fields.login.placeholder' }),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            type: 'text',
	            label: formatMessage({ id: 'profile.fields.emailOrPhone' }),
	            placeholder: formatMessage({ id: 'profile.fields.emailOrPhone' }),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.USERNAME:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            type: 'text',
	            label: formatMessage({
	              id: 'auth.recoverPassword.primaryContacts.username'
	            }),
	            placeholder: formatMessage({
	              id: 'auth.recoverPassword.primaryContacts.username'
	            }),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.TERMS_AND_CONDITIONS:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            acceptable: true,
	            onChange: function onChange(e) {
	              return _onChange((0, _defineProperty3.default)({}, field, e.target.checked ? 'true' : null));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.REASON_TYPE,
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            label: formatMessage({ id: 'fields.reasonType' }),
	            placeholder: formatMessage({ id: 'fields.reasonType.placeholder' }),
	            onChange: function onChange(_ref7) {
	              var value = _ref7.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.REASON_VISIT:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.REASON_VISIT,
	            label: formatMessage({ id: 'fields.reasonVisit' }),
	            placeholder: formatMessage({ id: 'fields.reasonVisit' }),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.REASON_NOTE:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.REASON_NOTE,
	            limit: _validations.LENGTH_VALUES.REASON_NOTE.MAX,
	            textarea: true,
	            label: labelWithOptional({ id: 'common.description' }, type),
	            placeholder: formatMessage({ id: 'common.description' }),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.LOCATION:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.LOCATION,
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            label: formatMessage({ id: 'dashboard.filter.location' }),
	            placeholder: formatMessage({
	              id: 'dashboard.record.locationExample'
	            }),
	            onChange: function onChange(_ref8) {
	              var value = _ref8.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.SERVICE:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.SERVICE,
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            label: formatMessage({ id: 'dashboard.filter.service' }),
	            placeholder: formatMessage({ id: 'dashboard.record.serviceExample' }),
	            onChange: function onChange(_ref9) {
	              var value = _ref9.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.PROVIDER:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.PROVIDER,
	            label: labelWithOptional({ id: 'profile.actions.provider' }, type),
	            placeholder: formatMessage({ id: 'common.searchByName' }),
	            onChange: function onChange(_ref10) {
	              var value = _ref10.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.ROOM:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.ROOM,
	            limit: _validations.LENGTH_VALUES.ROOM.MAX,
	            label: labelWithOptional({ id: 'dashboard.record.room' }, type),
	            placeholder: formatMessage({ id: 'dashboard.record.room' }),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.PAYMENT_STATUS:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.PAYMENT_STATUS,
	            label: labelWithOptional({ id: 'dashboard.record.paymentStatus' }, type),
	            placeholder: formatMessage({ id: 'dashboard.record.paymentStatus' }),
	            onChange: function onChange(_ref11) {
	              var value = _ref11.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.COPAY:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            type: 'text',
	            inputMode: 'decimal',
	            limit: _validations.LENGTH_VALUES.COPAY.MAX,
	            label: labelWithOptional({ id: 'virtualVisit.details.paymentAmountUsd' }, type),
	            placeholder: formatMessage({
	              id: 'virtualVisit.details.paymentAmount'
	            }),
	            errorText: formatMessage({ id: 'errors.appointment.copay' }),
	            validationRule: _amountValidator2.default,
	            onChange: function onChange(_ref12) {
	              var value = _ref12.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.CHAT_NAME:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.CHAT_NAME,
	            type: 'text',
	            limit: _validations.LENGTH_VALUES.CHAT_NAME.MAX,
	            label: formatMessage({ id: 'fields.chatName' }),
	            placeholder: formatMessage({
	              id: 'fields.chatName.placeholder'
	            }),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _constants.VISIT_DOCUMENTS_TYPES.CATEGORY:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.CATEGORY,
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            label: formatMessage({ id: 'common.category' }),
	            placeholder: formatMessage({ id: 'common.category' }),
	            onChange: function onChange(_ref13) {
	              var value = _ref13.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _constants.VISIT_DOCUMENTS_TYPES.SUB_CATEGORY:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.SUB_CATEGORY,
	            required: type === FIELD_FILLING_TYPES.REQUIRED,
	            label: formatMessage({ id: 'common.subCategory' }),
	            placeholder: formatMessage({ id: 'common.subCategory' }),
	            onChange: function onChange(_ref14) {
	              var value = _ref14.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.ACCEPTED_TERMS_AND_CONDITIONS:
	      case _formFields.PROFILE_FIELDS_TYPES.ACCEPTED_PRIVACY_POLICY:
	        {
	          return (0, _extends3.default)({}, commonProps, field, {
	            id: _ids.IDS.FORM_FIELDS.SUB_CATEGORY,
	            termsName: _formFields.PROFILE_FIELDS_TYPES.ACCEPTED_TERMS_AND_CONDITIONS,
	            privacyName: _formFields.PROFILE_FIELDS_TYPES.ACCEPTED_PRIVACY_POLICY,
	            onChange: _onChange
	          });
	        }
	
	      case _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.MEMBER_ID:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.MEMBER_ID,
	            required: true,
	            type: 'text',
	            limit: _validations.LENGTH_VALUES.MEMBER_ID.MAX,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.memberId),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.memberId),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GROUP_NUMBER:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            id: _ids.IDS.FORM_FIELDS.GROUP_NUMBER,
	            type: 'text',
	            limit: _validations.LENGTH_VALUES.GROUP_NUMBER.MAX,
	            label: labelWithOptional(_strings.PROFILE_FIELDS.fieldNames.groupNumber, type),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.groupNumber),
	            onChange: function onChange(value) {
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.RACE:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            required: false,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.race),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.race),
	            onChange: function onChange(_ref15) {
	              var value = _ref15.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      case _formFields.PROFILE_FIELDS_TYPES.ETHNICITY:
	        {
	          return (0, _extends3.default)({}, commonProps, {
	            required: false,
	            label: formatMessage(_strings.PROFILE_FIELDS.fieldNames.ethnicity),
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.ethnicity),
	            onChange: function onChange(_ref16) {
	              var value = _ref16.value;
	              return _onChange((0, _defineProperty3.default)({}, field, value));
	            }
	          });
	        }
	
	      default:
	        {
	          return {};
	        }
	    }
	  };
	}
	exports.getFieldProps = getFieldProps;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _isObject = __webpack_require__(139);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _enhance = __webpack_require__(3067);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentHeader(_ref) {
	  var globalPending = _ref.globalPending,
	      formatMessage = _ref.intl.formatMessage,
	      title = _ref.title,
	      subtitle = _ref.subtitle,
	      handleBack = _ref.handleBack,
	      children = _ref.children,
	      titleClassName = _ref.titleClassName,
	      type = _ref.type,
	      typeName = _ref.typeName;
	
	  var hasTitle = Boolean(title) || Boolean(subtitle) || Boolean(children);
	
	  var titleText = (0, _react.useMemo)(function () {
	    if (!title) return '';
	
	    if ((0, _isObject2.default)(title)) return title.text;
	    if (!(0, _isObject2.default)(title)) return type && typeName ? formatMessage({ id: title }, (0, _defineProperty3.default)({}, type, typeName)) : formatMessage({ id: title });
	  }, [title, type, typeName]);
	
	  var subTitleText = (0, _react.useMemo)(function () {
	    if (!subtitle) return '';
	
	    return (0, _isObject2.default)(subtitle) ? formatMessage({ id: subtitle.id }, (0, _extends3.default)({}, subtitle.state)) : formatMessage({ id: subtitle });
	  }, [subtitle]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { styleName: 'header' },
	      _react2.default.createElement(_BackButton2.default, {
	        styleName: 'backBtn',
	        disabled: globalPending,
	        onBack: handleBack,
	        minWidth: 0
	      })
	    ),
	    hasTitle && _react2.default.createElement(
	      'div',
	      { styleName: 'titleWrap', className: titleClassName },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h2',
	          { styleName: 'title' },
	          titleText
	        ),
	        subTitleText && _react2.default.createElement(
	          'h3',
	          { styleName: 'subTitle' },
	          subTitleText
	        )
	      ),
	      children && _react2.default.createElement(
	        'div',
	        null,
	        children
	      )
	    )
	  );
	}
	
	AppointmentHeader.propTypes = {
	  children: PropTypes.node,
	  globalPending: PropTypes.bool,
	  intl: PropTypes.object,
	  titleClassName: PropTypes.string,
	  subtitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	  handleBack: PropTypes.func.isRequired,
	  type: PropTypes.string,
	  typeName: PropTypes.string
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentHeader);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormErrorBlock = FormErrorBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(58);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormErrorBlock(_ref) {
	  var errors = _ref.errors,
	      type = _ref.type;
	
	  var error = (0, _lodash.get)(errors, type);
	
	  if (error) {
	    return _react2.default.createElement(_ErrorBlock2.default, { errors: error, className: 'mt3' });
	  }
	
	  return null;
	}
	
	FormErrorBlock.propTypes = {
	  type: _propTypes2.default.string,
	  errors: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CHANGE_APPOINTMENT_STATUS_ERROR_CODES = exports.INSURANCE_ERROR_CODES = exports.PROGRAM_ERRORS = exports.DASHBOARD_RECORD_CAPACITY_ERRORS = exports.LOGIN_INVITATION_ERRORS = exports.LOGIN_ERRORS = exports.LOGIN_ERROR_CODES = exports.APPOINTMENT_ERRORS = exports.DASHBOARD_RECORD_ERROR = exports.LOGOUT_NOTIFICATIONS_ERRORS = exports.ERROR_CODES = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _DASHBOARD_RECORD_ERR, _APPOINTMENT_ERRORS, _LOGIN_ERRORS;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ERROR_CODES = exports.ERROR_CODES = {
	  LAST_COMMUNITY_MODERATOR: 'at_least_one_community_moderator_required',
	  USER_ALREADY_HAS_GUARDIAN: 'dependents_user_has_guardian_proxy',
	  PROVIDER_ALREADY_IN_CIRCLE: 'provider_already_in_circle',
	  ACCESS_DENIED: 'access_denied',
	  ALREADY_ASSIGNED: 'already assigned',
	  DASHBOARD_SSN_TAKEN: 'dashboard_patient_ssn_taken_by_other_user',
	  DASHBOARD_LOGIN_TAKEN: 'dashboard_patient_login_taken_by_other_user',
	  RECORD_INVALID: 'record_invalid',
	  APPOINTMENT_SCHEDULE_TIME_NOT_AVAILABLE: 'time_slot_not_available',
	  APPOINTMENT_SCHEDULE_LIST_SERVICE_FAIL: 'third_party_error',
	  UNAVAILABLE_VIRTUAL_ROOM: 'room_not_yet_available',
	  LOGIN_NOT_FOUND: 'login_not_found',
	  INVALID_LOGIN: 'invalid_login',
	  INVALID_PHONE_NUMBER: 'invalid_phone_number',
	  // TODO fix word typing
	  PROVIDER_FROM_ANOTHER_ORGANIZATION: 'provider_from_another_orgazniation',
	  TASK_ALREADY_COMPLETED: 'transition_not_allowed_error',
	  REGISTRATION_NOT_FINISHED: 'registration_not_finished',
	  PROVIDER_ALREADY_ASSIGNED: 'provider_already_assigned',
	  LOCATION_SERVICE_CAPACITY: 'location_service_capacity_exceeded',
	  PROVIDER_IS_NOT_AVAILABLE_FOR_THIS_TIME: 'provider_is_not_available_for_this_time',
	  PROVIDER_IS_NOT_AVAILABLE_FOR_SELECTED_SERVICE: 'provider_is_not_available_for_selected_service_in_selected_location',
	  APPOINTMENT_IS_EXISTING_AT_THIS_TIME: 'there_is_already_an_existing_appointment_at_this_time_do_you_want_to_continue',
	  APPOINTMENT_OVERLAPPING: 'appointment_overlapping',
	  APPOINTMENT_PRICING_SCHEDULE_NOT_FOUND: 'pricing_schedule_not_found',
	  EHR_PROCESSING_ERROR: 'ehr_processing_error',
	  APPOINTMENT_CANCELLATION_TIME_IS_OVER: 'appointment_cancelation_time_is_out'
	};
	
	var LOGOUT_NOTIFICATIONS_ERRORS = exports.LOGOUT_NOTIFICATIONS_ERRORS = {
	  MULTIPLE_DEVICES: 'multiple_device_login',
	  ENTITY_EXCEPTION: 'find_entity_exception'
	};
	
	var DASHBOARD_RECORD_ERROR = exports.DASHBOARD_RECORD_ERROR = (_DASHBOARD_RECORD_ERR = {}, (0, _defineProperty3.default)(_DASHBOARD_RECORD_ERR, ERROR_CODES.DASHBOARD_SSN_TAKEN, 'errors.ssn.alreadyTakenBy'), (0, _defineProperty3.default)(_DASHBOARD_RECORD_ERR, ERROR_CODES.DASHBOARD_LOGIN_TAKEN, 'errors.fieldAlreadyTaken'), _DASHBOARD_RECORD_ERR);
	
	var APPOINTMENT_ERRORS = exports.APPOINTMENT_ERRORS = (_APPOINTMENT_ERRORS = {}, (0, _defineProperty3.default)(_APPOINTMENT_ERRORS, ERROR_CODES.APPOINTMENT_PRICING_SCHEDULE_NOT_FOUND, 'errors.appointment.pricingNotAvailable'), (0, _defineProperty3.default)(_APPOINTMENT_ERRORS, ERROR_CODES.APPOINTMENT_SCHEDULE_TIME_NOT_AVAILABLE, 'errors.appointment.timeSlotNotAvailable'), _APPOINTMENT_ERRORS);
	
	var LOGIN_ERROR_CODES = exports.LOGIN_ERROR_CODES = {
	  AUTHENTICATION_LOCKOUT: 'authentication_lockout',
	  UNAUTHORIZED: 'unauthorized',
	  INVITE_NOT_CONFIRMED: 'invite_not_confirmed',
	  INVITE_EXPIRED: 'invite_expired'
	};
	
	var LOGIN_ERRORS = exports.LOGIN_ERRORS = (_LOGIN_ERRORS = {}, (0, _defineProperty3.default)(_LOGIN_ERRORS, LOGIN_ERROR_CODES.AUTHENTICATION_LOCKOUT, 'errors.login.authenticationLockout'), (0, _defineProperty3.default)(_LOGIN_ERRORS, LOGIN_ERROR_CODES.UNAUTHORIZED, 'errors.login.unauthorized'), _LOGIN_ERRORS);
	
	var LOGIN_INVITATION_ERRORS = exports.LOGIN_INVITATION_ERRORS = [LOGIN_ERROR_CODES.INVITE_NOT_CONFIRMED, LOGIN_ERROR_CODES.INVITE_EXPIRED];
	
	var DASHBOARD_RECORD_CAPACITY_ERRORS = exports.DASHBOARD_RECORD_CAPACITY_ERRORS = [ERROR_CODES.LOCATION_SERVICE_CAPACITY];
	
	var PROGRAM_ERRORS = exports.PROGRAM_ERRORS = {
	  ALREADY_COMPLETED: 'already_completed',
	  INVITATION_REMOVED: 'invitation_removed'
	};
	
	var INSURANCE_ERROR_CODES = exports.INSURANCE_ERROR_CODES = {
	  COPAY_NOT_RECEIVED: 'copay_not_received',
	  INSURANCE_REQUEST_FAILED: 'insurance_eligibility_request_failed'
	};
	
	var CHANGE_APPOINTMENT_STATUS_ERROR_CODES = exports.CHANGE_APPOINTMENT_STATUS_ERROR_CODES = [ERROR_CODES.EHR_PROCESSING_ERROR, ERROR_CODES.APPOINTMENT_CANCELLATION_TIME_IS_OVER];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dependentFormActions = exports.DEPENDENT_FORM_STEPS = exports.DEPENDENT_FORM_PROGRESS_TYPES = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var actionsScope = 'dependentForm/progress';
	
	var DEPENDENT_FORM_PROGRESS_TYPES = exports.DEPENDENT_FORM_PROGRESS_TYPES = {
	  UPDATE_DEPENDENT: actionsScope + '/update-dependent',
	  VALIDATE: actionsScope + '/validate',
	  VALIDATE_FINISH: actionsScope + '/validate-finish',
	  SET_ROLE: actionsScope + '/set-role',
	  SET_STEP: actionsScope + '/set-step',
	  SET_SUBMIT_REDIRECT: actionsScope + '/set-submit-step',
	  GO_BACK: actionsScope + '/back',
	  GO_NEXT: actionsScope + '/next',
	  RESET: actionsScope + '/reset'
	};
	
	var DEPENDENT_FORM_STEPS = exports.DEPENDENT_FORM_STEPS = {
	  ROLE: 'ROLE',
	  PERSONAL: 'personalInformation',
	  GENERAL: 'generalInformation',
	  DOCUMENTS: 'documentation',
	  RELATION: 'relationship',
	  COMPLETE: 'complete',
	  USER_EXIST: 'userExist'
	};
	
	var dependentFormActions = exports.dependentFormActions = {
	  updateDependent: (0, _createAction.createAction)(DEPENDENT_FORM_PROGRESS_TYPES.UPDATE_DEPENDENT),
	  validate: (0, _createAction.createAction)(DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE),
	  finishValidate: (0, _createAction.createAction)(DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE_FINISH),
	  setRole: (0, _createAction.createAction)(DEPENDENT_FORM_PROGRESS_TYPES.SET_ROLE),
	  setStep: (0, _createAction.createAction)(DEPENDENT_FORM_PROGRESS_TYPES.SET_STEP),
	  setSubmitRedirect: (0, _createAction.createAction)(DEPENDENT_FORM_PROGRESS_TYPES.SET_SUBMIT_REDIRECT),
	  goBack: (0, _createAction.createAction)(DEPENDENT_FORM_PROGRESS_TYPES.GO_BACK),
	  goNext: (0, _createAction.createAction)(DEPENDENT_FORM_PROGRESS_TYPES.GO_NEXT),
	  reset: (0, _createAction.createAction)(DEPENDENT_FORM_PROGRESS_TYPES.RESET)
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectPaperworkHasProviderProfileSelector = exports.selectPaperworkUserPrimaryPatientProfile = exports.selectPaperworkUserEmergencyContactAttributes = exports.selectPaperworkGuarantor = exports.selectPaperworkGuarantorId = exports.selectPaperworkUserPrimaryPatientProfileId = exports.selectPaperworkUserSkipInsurance = exports.selectPaperworkUserCountryName = exports.selectPaperworkUserDisplayableName = exports.selectPaperworkUserId = exports.selectPaperworkUserDataPending = exports.selectRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'paperwork.paperworkUserDetails');
	};
	
	var selectPaperworkUserDataPending = exports.selectPaperworkUserDataPending = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	var selectPaperworkUserId = exports.selectPaperworkUserId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'id', false);
	});
	
	var selectPaperworkUserDisplayableName = exports.selectPaperworkUserDisplayableName = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'displayableName', '');
	});
	
	var selectPaperworkUserCountryName = exports.selectPaperworkUserCountryName = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'country', '');
	});
	
	var selectPaperworkUserSkipInsurance = exports.selectPaperworkUserSkipInsurance = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'skipInsurance', '');
	});
	
	var selectPaperworkUserPrimaryPatientProfileId = exports.selectPaperworkUserPrimaryPatientProfileId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'primaryPatientProfile.id', null);
	});
	
	var selectPaperworkGuarantorId = exports.selectPaperworkGuarantorId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'primaryPatientProfile.guarantorUser.id', null);
	});
	
	var selectPaperworkGuarantor = exports.selectPaperworkGuarantor = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'primaryPatientProfile.guarantorUser', null);
	});
	
	var selectPaperworkUserEmergencyContactAttributes = exports.selectPaperworkUserEmergencyContactAttributes = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'primaryPatientProfile.emergencyContactAttributes', {});
	});
	
	var selectPaperworkUserPrimaryPatientProfile = exports.selectPaperworkUserPrimaryPatientProfile = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'primaryPatientProfile', {});
	});
	
	var selectPaperworkHasProviderProfileSelector = exports.selectPaperworkHasProviderProfileSelector = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'primaryProviderProfile', {});
	});

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(551);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createConsts = function createConsts(module, submodule) {
	  for (var _len = arguments.length, actions = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    actions[_key - 2] = arguments[_key];
	  }
	
	  return actions.reduce(function (acc, c) {
	    (0, _defineProperty2.default)(acc, c, {
	      value: module + "/" + submodule + "/" + c,
	      enumerable: true
	    });
	    return acc;
	  }, {});
	};
	
	exports.default = createConsts;

/***/ }),
/* 124 */
[6551, 95],
/* 125 */
[6571, 85, 2145, 274, 124],
/* 126 */
[6593, 273],
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.capitalize = capitalize;
	exports.contains = contains;
	exports.findIndex = findIndex;
	exports.find = find;
	exports.createChainedFunction = createChainedFunction;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function capitalize(string) {
	  if (false) {
	    throw new Error('Material-UI: capitalize(string) expects a string argument.');
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	} //  weak
	
	function contains(obj, pred) {
	  return (0, _keys2.default)(pred).every(function (key) {
	    return obj.hasOwnProperty(key) && obj[key] === pred[key];
	  });
	}
	
	function findIndex(arr, pred) {
	  var predType = typeof pred === 'undefined' ? 'undefined' : (0, _typeof3.default)(pred);
	  for (var i = 0; i < arr.length; i += 1) {
	    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
	      return i;
	    }
	    if (predType === 'object' && contains(arr[i], pred)) {
	      return i;
	    }
	    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
	      return arr.indexOf(pred);
	    }
	  }
	  return -1;
	}
	
	function find(arr, pred) {
	  var index = findIndex(arr, pred);
	  return index > -1 ? arr[index] : undefined;
	}
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (func) {
	    return func != null;
	  }).reduce(function (acc, func) {
	     false ? (0, _warning2.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _inheritsLoose = _interopDefault(__webpack_require__(1053));
	var React = __webpack_require__(1);
	var createCache = _interopDefault(__webpack_require__(2894));
	var utils = __webpack_require__(1056);
	var serialize = __webpack_require__(755);
	var sheet = __webpack_require__(598);
	var css = _interopDefault(__webpack_require__(486));
	
	var EmotionCacheContext = React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache() : null);
	var ThemeContext = React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	exports.withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (typeof props.className === 'string') {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  } else if (props.className != null) {
	    className = props.className + " ";
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = React.createElement(type, newProps);
	
	  return ele;
	};
	
	var Emotion =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache, ref) {
	  // use Context.read for the theme when it's stable
	  if (typeof props.css === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	} // $FlowFixMe
	
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = Emotion;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type;
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/^.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  createElementArgArray[1] = newProps;
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global =
	/* #__PURE__ */
	exports.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return React.createElement(ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css.apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var ClassNames = exports.withEmotionCache(function (props, context) {
	  return React.createElement(ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	
	    return ele;
	  });
	});
	
	exports.css = css;
	exports.CacheProvider = CacheProvider;
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.ThemeContext = ThemeContext;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(2907)
	} else {
	  module.exports = require('./invariant.cjs.development.js')
	}


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _ids = __webpack_require__(46);
	
	var _strings = __webpack_require__(15);
	
	var _mobileHelpers = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionConfirmation = function ActionConfirmation(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      title = _ref.title,
	      body = _ref.body,
	      actionButtonText = _ref.actionButtonText,
	      cancelButtonText = _ref.cancelButtonText,
	      content = _ref.content,
	      danger = _ref.danger,
	      width = _ref.width,
	      disabled = _ref.disabled,
	      opened = _ref.opened,
	      onClose = _ref.onClose,
	      onSubmit = _ref.onSubmit,
	      withHeading = _ref.withHeading,
	      mobileFullScreen = _ref.mobileFullScreen;
	
	  var handleSubmit = (0, _react.useCallback)(function () {
	    onSubmit();
	    onClose();
	  }, [onSubmit]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Popup2.default,
	      {
	        opened: opened,
	        onClose: onClose,
	        width: (0, _mobileHelpers.isDesktop)() ? width || 'small' : 'medium',
	        title: title,
	        withHeading: withHeading,
	        mobileFullScreen: mobileFullScreen
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        body
	      ),
	      content,
	      _react2.default.createElement(
	        'div',
	        { className: 'mt3' },
	        _react2.default.createElement(_Button2.default, {
	          id: _ids.IDS.COMMON.ACTION_CONFIRMATION_SUBMIT,
	          color: danger ? 'danger' : 'primary',
	          onClick: handleSubmit,
	          children: actionButtonText,
	          disabled: disabled,
	          type: 'button',
	          className: 'mr3',
	          raised: true
	        }),
	        _react2.default.createElement(_Button2.default, {
	          id: _ids.IDS.COMMON.ACTION_CONFIRMATION_CANCEL,
	          color: 'accent',
	          raised: true,
	          type: 'button',
	          onClick: onClose,
	          children: formatMessage(cancelButtonText)
	        })
	      )
	    )
	  );
	};
	
	ActionConfirmation.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  title: _propTypes2.default.string,
	  body: _propTypes2.default.string,
	  actionButtonText: _propTypes2.default.string.isRequired,
	  cancelButtonText: _propTypes2.default.object,
	  content: _propTypes2.default.any,
	  danger: _propTypes2.default.bool,
	  width: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  withHeading: _propTypes2.default.bool,
	  opened: _propTypes2.default.bool.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func,
	  mobileFullScreen: _propTypes2.default.bool
	};
	
	ActionConfirmation.defaultProps = {
	  danger: true,
	  width: null,
	  disabled: false,
	  content: null,
	  body: null,
	  onSubmit: function onSubmit() {},
	  cancelButtonText: _strings.COMMON.cancel,
	  withHeading: true
	};
	
	exports.default = (0, _reactIntl.injectIntl)(ActionConfirmation);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyContent = function EmptyContent(_ref) {
	  var icon = _ref.icon,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 148 : _ref$size,
	      text = _ref.text,
	      iconFill = _ref.iconFill,
	      className = _ref.className,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['icon', 'size', 'text', 'iconFill', 'className']);
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)('tc', className) }, other),
	    _react2.default.createElement(_Icon2.default, { name: icon, size: size, className: 'pb4', style: { fill: iconFill } }),
	    _react2.default.createElement(
	      'p',
	      { className: 'ttu' },
	      text
	    )
	  );
	};
	
	EmptyContent.propTypes = {
	  icon: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  text: _propTypes2.default.string,
	  iconFill: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	exports.default = EmptyContent;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5229);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimpleAvatar = function SimpleAvatar(_ref) {
	  var src = _ref.src,
	      text = _ref.text,
	      size = _ref.size,
	      unverified = _ref.unverified,
	      iconRatio = _ref.iconRatio,
	      fontRatio = _ref.fontRatio,
	      disabled = _ref.disabled,
	      waiting = _ref.waiting,
	      bordered = _ref.bordered,
	      className = _ref.className,
	      usePercent = _ref.usePercent,
	      opaque = _ref.opaque,
	      white = _ref.white,
	      onClick = _ref.onClick,
	      onError = _ref.onError;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      error = _useState2[0],
	      setError = _useState2[1];
	
	  var hasIcon = waiting || unverified;
	  var additionalIcon = unverified ? 'error' : 'icon-time';
	
	  var handleError = function handleError() {
	    setError(true);
	    onError();
	  };
	
	  var avatarSize = usePercent ? size + '%' : size + 'px';
	  var fontSize = usePercent ? 'calc(20px + 2vw)' : size * fontRatio;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      styleName: (0, _classnames2.default)('root', {
	        'root--bordered': bordered,
	        'root--opaque': opaque,
	        'root--white': white
	      }),
	      style: {
	        width: avatarSize,
	        height: avatarSize,
	        fontSize: fontSize
	      },
	      className: className,
	      title: text,
	      onClick: onClick
	    },
	    src && !error ? _react2.default.createElement('div', {
	      styleName: (0, _classnames2.default)('image', {
	        'image--disabled': disabled || waiting
	      }),
	      style: {
	        backgroundImage: 'url(' + src + ')'
	      },
	      alt: 'avatar',
	      onError: handleError
	    }) : text ? _react2.default.createElement(
	      'span',
	      null,
	      text[0].toUpperCase()
	    ) : null,
	    hasIcon ? _react2.default.createElement(
	      'div',
	      { styleName: 'iconWaiting' },
	      _react2.default.createElement(_Icon2.default, { name: additionalIcon, size: iconRatio * size })
	    ) : null
	  );
	};
	
	SimpleAvatar.propTypes = {
	  src: _propTypes2.default.string,
	  text: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  disabled: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  waiting: _propTypes2.default.bool,
	  opaque: _propTypes2.default.bool,
	  white: _propTypes2.default.bool,
	  usePercent: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onError: _propTypes2.default.func,
	  iconRatio: _propTypes2.default.number,
	  fontRatio: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  unverified: _propTypes2.default.bool
	};
	
	SimpleAvatar.defaultProps = {
	  size: 24,
	  iconRatio: 0.4,
	  fontRatio: 0.6,
	  className: ''
	};
	
	exports.default = (0, _reactCssModules2.default)(SimpleAvatar, _index2.default, { allowMultiple: true });

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INSURANCE_FLOW_TYPE = exports.INSURANCE_FLOW_TYPE = {
	  PAPERWORK: 'PAPERWORK',
	  PROFILE: 'PROFILE',
	  GET_CARE_FLOW: 'GET_CARE_FLOW',
	  TO_DO: 'TO_DO'
	};
	
	var SHOW_ADDITIONAL_STYLES_FOR_ADDITIONAL_INSURANCES = exports.SHOW_ADDITIONAL_STYLES_FOR_ADDITIONAL_INSURANCES = [INSURANCE_FLOW_TYPE.TO_DO, INSURANCE_FLOW_TYPE.PROFILE];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectSendingValidatePatientInfo = exports.selectCreateAppointmentReqError = exports.selectRejectedCreateAppointmentReq = exports.selectSendingCreateAppointmentReq = exports.selectLoadingAppointmentsLocations = exports.selectAppointmentsRecordLocations = exports.selectAppointmentsLocationsState = exports.selectDashboardPatientRecord = exports.selectDashboardPatientCommonErrors = exports.selectDashboardPatientRecordValidationError = exports.selectDashboardRecord = exports.selectFilteredAppointmentList = exports.selectChangeStatusPending = exports.selectChangeStatusError = exports.selectUpdateAppointmentLoading = exports.selectDashboardChangeRoomLoading = exports.selectDashboardChangeRoomAppointment = exports.selectDashboardChangeRoomOpened = exports.selectDashboardChangeRoomState = exports.selectDashboardChangePaidStatusAppointment = exports.selectDashboardChangePaidStatusOpened = exports.selectDashboardChangePaidStatusState = exports.selectDashboardEditAmountAppointment = exports.selectDashboardEditAmountOpened = exports.selectDashboardEditPaymentAmountState = exports.selectStatusesByLocationAndService = exports.selectDashboardLocationsList = exports.selectStatusesByServiceId = exports.selectDashboardFilterStatuses = exports.selectDashboardFilterServices = exports.selectDashboardFilterLocations = exports.makeSelectDashboardFilterOptsEntity = exports.selectDashboardFilterLocationsKeys = exports.selectDashboardFilterOptionsState = exports.selectDashboardAppliedFilterCounter = exports.selectDashboardFilterLoadStatus = exports.selectDashboardDateFilter = exports.selectDashboardNotEmptyFilterState = exports.selectDashboardFilterState = exports.selectAppointmentDetailsPending = exports.selectAppointmentDetailsError = exports.selectCurrentAppointmentId = exports.selectCurrentAppointmentDetails = exports.selectCurrentAppointmentDetailsState = exports.selectActiveAppointment = exports.selectAppointmentListLoading = exports.selectAppointmentList = exports.selectAppointmentListState = exports.selectDashboardState = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _some = __webpack_require__(986);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _omitBy = __webpack_require__(983);
	
	var _omitBy2 = _interopRequireDefault(_omitBy);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _validateAppointmentByFilter = __webpack_require__(1382);
	
	var _selectAdapter = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectDashboardState = exports.selectDashboardState = function selectDashboardState(state) {
	  return (0, _get2.default)(state, 'dashboard');
	};
	
	var getSelectors = (0, _selectAdapter.makeSelectorFactory)(selectDashboardState);
	
	/**
	 *  APPOINTMENT LIST
	 * */
	var selectAppointmentListState = exports.selectAppointmentListState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'appointmentList');
	});
	
	var selectAppointmentList = exports.selectAppointmentList = (0, _reselect.createSelector)(selectAppointmentListState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectAppointmentListLoading = exports.selectAppointmentListLoading = (0, _reselect.createSelector)(selectAppointmentListState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectActiveAppointment = exports.selectActiveAppointment = (0, _reselect.createSelector)(selectAppointmentListState, function (state) {
	  return (0, _get2.default)(state, 'activeAppointment', undefined);
	});
	
	/**
	 *  APPOINTMENT DETAILS
	 * */
	var selectCurrentAppointmentDetailsState = exports.selectCurrentAppointmentDetailsState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'appointmentDetailsReq');
	});
	
	var selectCurrentAppointmentDetails = exports.selectCurrentAppointmentDetails = (0, _reselect.createSelector)(selectCurrentAppointmentDetailsState, function (state) {
	  return (0, _get2.default)(state, 'appointment', {});
	});
	
	var selectCurrentAppointmentId = exports.selectCurrentAppointmentId = (0, _reselect.createSelector)(selectCurrentAppointmentDetailsState, function (state) {
	  return (0, _get2.default)(state, 'appointmentId', null);
	});
	
	var _getSelectors = getSelectors('appointmentDetailsReq'),
	    selectAppointmentDetailsError = _getSelectors.selectStateError,
	    selectAppointmentDetailsPending = _getSelectors.selectStatePending;
	
	/**
	 *  FILTER
	 * */
	
	
	exports.selectAppointmentDetailsError = selectAppointmentDetailsError;
	exports.selectAppointmentDetailsPending = selectAppointmentDetailsPending;
	var selectDashboardFilterState = exports.selectDashboardFilterState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'filter');
	});
	
	var selectDashboardNotEmptyFilterState = exports.selectDashboardNotEmptyFilterState = (0, _reselect.createSelector)(selectDashboardFilterState, function (options) {
	  return (0, _omitBy2.default)(options, _isEmpty2.default);
	});
	
	var selectDashboardDateFilter = exports.selectDashboardDateFilter = (0, _reselect.createSelector)(selectDashboardFilterState, function (state) {
	  return (0, _get2.default)(state, 'date');
	});
	
	var selectDashboardFilterLoadStatus = exports.selectDashboardFilterLoadStatus = (0, _reselect.createSelector)(selectDashboardFilterState, function (state) {
	  return (0, _get2.default)(state, 'filterLoaded');
	});
	
	var selectDashboardAppliedFilterCounter = exports.selectDashboardAppliedFilterCounter = (0, _reselect.createSelector)(selectDashboardFilterState, function (_ref) {
	  var locations = _ref.locations,
	      services = _ref.services,
	      statuses = _ref.statuses;
	  return [locations, services, statuses].reduce(function (acc, list) {
	    return acc + list.length;
	  }, 0);
	});
	
	/**
	 *  FILTER OPTIONS
	 * */
	var selectDashboardFilterOptionsState = exports.selectDashboardFilterOptionsState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'locations');
	});
	
	var selectDashboardFilterLocationsKeys = exports.selectDashboardFilterLocationsKeys = (0, _reselect.createSelector)(selectDashboardFilterOptionsState, function (state) {
	  return (0, _get2.default)(state, 'result.locations', []);
	});
	
	var makeSelectDashboardFilterOptsEntity = exports.makeSelectDashboardFilterOptsEntity = function makeSelectDashboardFilterOptsEntity(entity) {
	  return (0, _reselect.createSelector)(selectDashboardFilterOptionsState, function (state) {
	    return (0, _get2.default)(state, ['entities', entity], {});
	  });
	};
	
	var selectDashboardFilterLocations = exports.selectDashboardFilterLocations = (0, _reselect.createSelector)(selectDashboardFilterLocationsKeys, makeSelectDashboardFilterOptsEntity('locations'), function (keys, entities) {
	  return keys.map(function (key) {
	    return entities[key];
	  });
	});
	
	var selectDashboardFilterServices = exports.selectDashboardFilterServices = (0, _reselect.createSelector)(makeSelectDashboardFilterOptsEntity('services'), function (entities) {
	  return (0, _keys2.default)(entities).map(function (key) {
	    return entities[key];
	  });
	});
	
	var selectDashboardFilterStatuses = exports.selectDashboardFilterStatuses = (0, _reselect.createSelector)(makeSelectDashboardFilterOptsEntity('statuses'), function (entities) {
	  return (0, _keys2.default)(entities).map(function (key) {
	    return entities[key];
	  });
	});
	
	var selectStatusesByServiceId = exports.selectStatusesByServiceId = function selectStatusesByServiceId(id) {
	  return (0, _reselect.createSelector)(makeSelectDashboardFilterOptsEntity('services'), makeSelectDashboardFilterOptsEntity('statuses'), function (services, statuses) {
	    var service = (0, _get2.default)(services, id);
	
	    if (service) {
	      return service.statuses.map(function (statusId) {
	        return statuses[statusId];
	      });
	    }
	    return [];
	  });
	};
	
	// Locations without filter
	
	var selectDashboardLocationsList = exports.selectDashboardLocationsList = (0, _reselect.createSelector)(selectDashboardFilterOptionsState, function (state) {
	  return (0, _get2.default)(state, 'locationsList');
	});
	
	var selectStatusesByLocationAndService = exports.selectStatusesByLocationAndService = function selectStatusesByLocationAndService(locationId, serviceId) {
	  return (0, _reselect.createSelector)(selectDashboardLocationsList, function (list) {
	    if ((0, _isEmpty2.default)(list)) return [];
	    var currentLocation = list.find(function (location) {
	      return location.id === locationId;
	    });
	    var service = (0, _get2.default)(currentLocation, 'services', []).find(function (item) {
	      return item.id === serviceId;
	    });
	    return (0, _get2.default)(service, 'statuses', []);
	  });
	};
	
	/**
	 *  CHANGE EDIT AMOUNT MODAL
	 * */
	
	var selectDashboardEditPaymentAmountState = exports.selectDashboardEditPaymentAmountState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'editPaymentAmountModal');
	});
	
	var selectDashboardEditAmountOpened = exports.selectDashboardEditAmountOpened = (0, _reselect.createSelector)(selectDashboardEditPaymentAmountState, function (state) {
	  return (0, _get2.default)(state, 'opened', false);
	});
	
	var selectDashboardEditAmountAppointment = exports.selectDashboardEditAmountAppointment = (0, _reselect.createSelector)(selectDashboardEditPaymentAmountState, function (state) {
	  return (0, _get2.default)(state, 'appointment', null);
	});
	
	/**
	 *  SET PAID STATUS MODAL
	 * */
	
	var selectDashboardChangePaidStatusState = exports.selectDashboardChangePaidStatusState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'changePaidStatusModal');
	});
	
	var selectDashboardChangePaidStatusOpened = exports.selectDashboardChangePaidStatusOpened = (0, _reselect.createSelector)(selectDashboardChangePaidStatusState, function (state) {
	  return (0, _get2.default)(state, 'opened', false);
	});
	
	var selectDashboardChangePaidStatusAppointment = exports.selectDashboardChangePaidStatusAppointment = (0, _reselect.createSelector)(selectDashboardChangePaidStatusState, function (state) {
	  return (0, _get2.default)(state, 'appointment', null);
	});
	
	/**
	 *  CHANGE ROOM MODAL
	 * */
	var selectDashboardChangeRoomState = exports.selectDashboardChangeRoomState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'changeRoomModal');
	});
	
	var selectDashboardChangeRoomOpened = exports.selectDashboardChangeRoomOpened = (0, _reselect.createSelector)(selectDashboardChangeRoomState, function (state) {
	  return (0, _get2.default)(state, 'opened', false);
	});
	
	var selectDashboardChangeRoomAppointment = exports.selectDashboardChangeRoomAppointment = (0, _reselect.createSelector)(selectDashboardChangeRoomState, function (state) {
	  return (0, _get2.default)(state, 'appointment', '');
	});
	
	var selectDashboardChangeRoomLoading = exports.selectDashboardChangeRoomLoading = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'updateRoom.sending', false);
	});
	
	var selectChangeAppointmentStatusState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'changeStatus');
	});
	var selectPinAppointmentPinState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'pinAppointment');
	});
	
	var selectUpdateAppointmentLoading = exports.selectUpdateAppointmentLoading = (0, _reselect.createSelector)(selectChangeAppointmentStatusState, selectPinAppointmentPinState, function () {
	  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _some2.default)(states, function (_ref2) {
	    var sending = _ref2.sending;
	    return sending;
	  });
	});
	
	var _getSelectors2 = getSelectors('changeStatus'),
	    selectChangeStatusError = _getSelectors2.selectStateError,
	    selectChangeStatusPending = _getSelectors2.selectStatePending;
	
	/**
	 *  FILTERED APPOINTMENT LIST
	 * */
	
	
	exports.selectChangeStatusError = selectChangeStatusError;
	exports.selectChangeStatusPending = selectChangeStatusPending;
	var selectFilteredAppointmentList = exports.selectFilteredAppointmentList = (0, _reselect.createSelector)(selectAppointmentList, selectDashboardNotEmptyFilterState, function (list, filterData) {
	  return list.filter(function (appointment) {
	    return (0, _validateAppointmentByFilter.validateAppointment)(appointment, filterData);
	  });
	});
	
	// Add record to the DASHBOARD
	
	var selectDashboardRecord = exports.selectDashboardRecord = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'record');
	});
	
	var selectDashboardPatientRecordValidationError = exports.selectDashboardPatientRecordValidationError = (0, _reselect.createSelector)(selectDashboardRecord, function (state) {
	  return (0, _get2.default)(state, 'patientValidationError');
	});
	
	var selectDashboardPatientCommonErrors = exports.selectDashboardPatientCommonErrors = (0, _reselect.createSelector)(selectDashboardRecord, function (state) {
	  return (0, _get2.default)(state, 'commonErrors');
	});
	
	var selectDashboardPatientRecord = exports.selectDashboardPatientRecord = (0, _reselect.createSelector)(selectDashboardRecord, function (state) {
	  return (0, _get2.default)(state, 'patient');
	});
	
	var selectAppointmentsLocationsState = exports.selectAppointmentsLocationsState = (0, _reselect.createSelector)(selectDashboardState, function (state) {
	  return (0, _get2.default)(state, 'appointmentLocations');
	});
	
	var selectAppointmentsRecordLocations = exports.selectAppointmentsRecordLocations = (0, _reselect.createSelector)(selectAppointmentsLocationsState, function (state) {
	  return (0, _get2.default)(state, 'locations', []);
	});
	
	var _getSelectors3 = getSelectors('appointmentLocations'),
	    selectLoadingAppointmentsLocations = _getSelectors3.selectStatePending;
	
	exports.selectLoadingAppointmentsLocations = selectLoadingAppointmentsLocations;
	
	var _getSelectors4 = getSelectors('createAppointmentReq'),
	    selectSendingCreateAppointmentReq = _getSelectors4.selectStatePending,
	    selectRejectedCreateAppointmentReq = _getSelectors4.selectStateRejected,
	    selectCreateAppointmentReqError = _getSelectors4.selectStateError;
	
	exports.selectSendingCreateAppointmentReq = selectSendingCreateAppointmentReq;
	exports.selectRejectedCreateAppointmentReq = selectRejectedCreateAppointmentReq;
	exports.selectCreateAppointmentReqError = selectCreateAppointmentReqError;
	
	var _getSelectors5 = getSelectors('validatePatientInfo'),
	    selectSendingValidatePatientInfo = _getSelectors5.selectStatePending;
	
	exports.selectSendingValidatePatientInfo = selectSendingValidatePatientInfo;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectPaperworkValidating = exports.selectPaperworkCameFromSubmitPage = exports.selectAdditionalInfoFormData = exports.selectPaperworkIsPlanNotListedSelected = exports.selectPaperworkEligibilityResultId = exports.selectPaperworkFlowFormStepNumber = exports.selectPaperworkFlowFirstFormStepPathname = exports.selectPaperworkFlowFormStepsCount = exports.selectPaperworkFlowPrevPagePathname = exports.selectPaperworkFlowNextPagePathname = exports.selectPaperworkGlobalPending = exports.selectRootState = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(82);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'paperwork.common');
	};
	
	var selectPaperworkGlobalPending = exports.selectPaperworkGlobalPending = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'pending');
	});
	
	var selectPaperworkFlowNextPagePathname = exports.selectPaperworkFlowNextPagePathname = function selectPaperworkFlowNextPagePathname(currentPathname) {
	  return (0, _reselect.createSelector)(selectRootState, _paperworkGetAppointmentDetails.selectPaperworkAppointmentIsAllConsentsSigned, function (state, isAllConsentsSigned) {
	    var pagesState = (0, _get2.default)(state, 'pages.allPages', []);
	    var currentPageIndex = pagesState.indexOf(currentPathname);
	    var nextPageIndex = currentPageIndex + 1;
	    var nextPathname = nextPageIndex < pagesState.length ? pagesState[nextPageIndex] : null;
	
	    if (nextPathname && nextPathname.includes(_routes.PAPERWORK_SIGN_CONSENT) && isAllConsentsSigned) {
	      var skipToNextPageIndex = nextPageIndex + 1;
	      return skipToNextPageIndex < pagesState.length ? pagesState[skipToNextPageIndex] : null;
	    }
	
	    return nextPathname;
	  });
	};
	
	var selectPaperworkFlowPrevPagePathname = exports.selectPaperworkFlowPrevPagePathname = function selectPaperworkFlowPrevPagePathname(currentPathname) {
	  return (0, _reselect.createSelector)(selectRootState, _paperworkGetAppointmentDetails.selectPaperworkAppointmentIsAllConsentsSigned, function (state, isAllConsentsSigned) {
	    var pagesState = (0, _get2.default)(state, 'pages.allPages', []);
	    var currentPageIndex = pagesState.indexOf(currentPathname);
	    var prevPageIndex = currentPageIndex - 1;
	    var prevPathname = prevPageIndex >= 0 ? pagesState[prevPageIndex] : null;
	
	    if (prevPathname && prevPathname.includes(_routes.PAPERWORK_SIGN_CONSENT) && isAllConsentsSigned) {
	      var skipToPrevPageIndex = prevPageIndex - 1;
	      return prevPageIndex >= 0 ? pagesState[skipToPrevPageIndex] : null;
	    }
	
	    return prevPathname;
	  });
	};
	
	var selectPaperworkFlowFormStepsCount = exports.selectPaperworkFlowFormStepsCount = (0, _reselect.createSelector)(selectRootState, function (state) {
	  var steps = (0, _get2.default)(state, 'pages.formSteps');
	  return steps.length;
	});
	
	var selectPaperworkFlowFirstFormStepPathname = exports.selectPaperworkFlowFirstFormStepPathname = (0, _reselect.createSelector)(selectRootState, function (state) {
	  var steps = (0, _get2.default)(state, 'pages.formSteps');
	  return steps.length > 0 ? steps[0] : null;
	});
	
	var selectPaperworkFlowFormStepNumber = exports.selectPaperworkFlowFormStepNumber = function selectPaperworkFlowFormStepNumber(currentPathname) {
	  return (0, _reselect.createSelector)(selectRootState, function (state) {
	    var steps = (0, _get2.default)(state, 'pages.formSteps');
	    return steps.indexOf(currentPathname) + 1;
	  });
	};
	
	var selectPaperworkEligibilityResultId = exports.selectPaperworkEligibilityResultId = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'data.insuranceEligibilityResultId');
	});
	
	var selectPaperworkIsPlanNotListedSelected = exports.selectPaperworkIsPlanNotListedSelected = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'data.isPlanNotListedSelected');
	});
	
	var selectAdditionalInfoFormData = exports.selectAdditionalInfoFormData = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'data.additionalInfoFormData');
	});
	
	var selectPaperworkCameFromSubmitPage = exports.selectPaperworkCameFromSubmitPage = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'isCameFromSubmitPage');
	});
	
	var selectPaperworkValidating = exports.selectPaperworkValidating = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'validating');
	});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'edit-user', ['CLEAR']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var clear = function clear(state) {
	  return (0, _extends3.default)({}, state, {
	    succeed: null,
	    error: null,
	    rejected: null
	  });
	};
	
	exports.default = function (state, action) {
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return clear(state);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ONCE_TILL_UNMOUNT = exports.DAEMON = exports.RESTART_ON_REMOUNT = undefined;
	
	var _has = __webpack_require__(4298);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.injectSagaFactory = injectSagaFactory;
	exports.ejectSagaFactory = ejectSagaFactory;
	exports.default = getInjectors;
	
	var _conformsTo = __webpack_require__(2348);
	
	var _conformsTo2 = _interopRequireDefault(_conformsTo);
	
	var _isFunction = __webpack_require__(731);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isString = __webpack_require__(981);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _invariant = __webpack_require__(724);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _checkStore = __webpack_require__(3997);
	
	var _checkStore2 = _interopRequireDefault(_checkStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable immutable/no-let,immutable/no-mutation */
	var RESTART_ON_REMOUNT = exports.RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
	var DAEMON = exports.DAEMON = '@@saga-injector/daemon';
	var ONCE_TILL_UNMOUNT = exports.ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
	
	var allowedModes = [RESTART_ON_REMOUNT, DAEMON, ONCE_TILL_UNMOUNT];
	
	var checkKey = function checkKey(key) {
	  return (0, _invariant2.default)((0, _isString2.default)(key) && !(0, _isEmpty2.default)(key), '(app/utils...) injectSaga: Expected `key` to be a non empty string');
	};
	
	var checkDescriptor = function checkDescriptor(descriptor) {
	  var shape = {
	    saga: _isFunction2.default,
	    mode: function mode(_mode) {
	      return (0, _isString2.default)(_mode) && allowedModes.includes(_mode);
	    }
	  };
	  (0, _invariant2.default)((0, _conformsTo2.default)(descriptor, shape), '(app/utils...) injectSaga: Expected a valid saga descriptor');
	};
	
	function injectSagaFactory(store, isValid) {
	  return function injectSaga(key) {
	    var descriptor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var args = arguments[2];
	
	    if (!isValid) (0, _checkStore2.default)(store);
	
	    var newDescriptor = (0, _extends3.default)({}, descriptor, {
	      mode: descriptor.mode || DAEMON
	    });
	    var saga = newDescriptor.saga,
	        mode = newDescriptor.mode;
	
	
	    checkKey(key);
	    checkDescriptor(newDescriptor);
	
	    var hasSaga = (0, _has2.default)(store.injectedSagas, key);
	
	    if (false) {
	      var oldDescriptor = store.injectedSagas[key];
	      // enable hot reloading of daemon and once-till-unmount sagas
	      if (hasSaga && oldDescriptor.saga !== saga) {
	        oldDescriptor.task.cancel();
	        hasSaga = false;
	      }
	    }
	
	    if (!hasSaga || hasSaga && mode !== DAEMON && mode !== ONCE_TILL_UNMOUNT) {
	      /* eslint-disable no-param-reassign */
	      store.injectedSagas[key] = (0, _extends3.default)({}, newDescriptor, {
	        task: store.runSaga(saga, args)
	      });
	      /* eslint-enable no-param-reassign */
	    }
	  };
	}
	
	function ejectSagaFactory(store, isValid) {
	  return function ejectSaga(key) {
	    if (!isValid) (0, _checkStore2.default)(store);
	
	    checkKey(key);
	
	    if ((0, _has2.default)(store.injectedSagas, key)) {
	      var descriptor = store.injectedSagas[key];
	      if (descriptor.mode && descriptor.mode !== DAEMON) {
	        descriptor.task.cancel();
	        // Clean up in production; in development we need `descriptor.saga` for hot reloading
	        if (true) {
	          // Need some value to be able to detect `ONCE_TILL_UNMOUNT` sagas in `injectSaga`
	          store.injectedSagas[key] = 'done'; // eslint-disable-line no-param-reassign
	        }
	      }
	    }
	  };
	}
	
	function getInjectors(store) {
	  (0, _checkStore2.default)(store);
	
	  return {
	    injectSaga: injectSagaFactory(store, true),
	    ejectSaga: ejectSagaFactory(store, true)
	  };
	}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a348b99a","outerContainer":"fb7d0034","secondaryToolbar":"_27886bdc","doorHangerRight":"e49230da","toolbarContainer":"c41da12f","toolbarViewerMiddle":"caca9969","progressBar":"edd769e4","back-to-application":"_92f96a56","root":"_7868c2a6","content":"_2a98b045","navigation":"_7452c215","navLink":"_2bf3f53e","navLink--active":"_74de5005","content--profile":"_8c6c1170","content--info":"_27b25193","info":"_18310853","info--docs":"c3585d76","info--settings":"_43753910","info--disabled":"d80d6ac2","user-profile-username":"a915a4fa","userAvatar":"_1678054b","userName":"_17ae1562","colored":"_5b2df151","userInfo":"_68ad5c4c","notification-settings":"_98319e45","language-settings":"_76d8c687","privacy-settings":"_921e9036","gray-text":"_6c715d83","fieldset":"_315aa0d2","fieldset--filled":"d898ce99","fieldsetTitleWrapper":"c3a6621c","sectionTitle":"_65bdab2c","sectionTitle--danger":"_73c02242","fieldsetAction":"e4f7e104","fieldsetContent":"_5d608cc2","fieldsetContent--withColumns":"_97add14b","fieldsetContent__empty":"ac121ce9","fieldWrapper":"_82a512b2","fieldWrapperFull":"_164ee004","field":"f749c915","field--separated":"_4cdb46d1","mfaField":"a06546bc","dialogTitle":"_3874e03b","backButton":"_685dc494","no-surveys-text":"_7e1a3835","notificationMethodLabel":"a743ebb1","mobile-phone-confirmation":"_5c6f33b0","phone-confirmation-flex-wrapper":"e8e44477","confirmation-popup-content":"a8d9e602","flexRow":"e172793d","mt0":"_55f692da","supportWrapper":"a6191791","supportTitle":"_786b7909","supportQuestion":"cc476d43","supportLable":"_5de2eb80","supportText":"_4843bedb","supportContacts":"c0fba73c","supportNav":"_22b6283b","supportNavDependent":"_50174817","supportBlock":"_64e6e8a7","termsAdditionalStyles":"_5a4e638d","user-profile-content":"_6ddb26bd","common":"b6556a07","fieldsetList":"_05a22959","profile-children":"_49c2a920","contact-info-section":"c294c65a","user-profile-common":"_8d1eda2b","fieldWrapperFull--separated":"abeeba6b"};

/***/ }),
/* 139 */
331,
/* 140 */,
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _styles = __webpack_require__(5227);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Shape(_ref) {
	  var className = _ref.className,
	      renderPrimary = _ref.renderPrimary,
	      renderSecondary = _ref.renderSecondary,
	      renderLeft = _ref.renderLeft,
	      renderRight = _ref.renderRight,
	      onClick = _ref.onClick,
	      active = _ref.active,
	      children = _ref.children,
	      withoutMargin = _ref.withoutMargin;
	
	  function renderBody() {
	    if (children) return children;
	
	    return _react2.default.createElement(
	      'div',
	      { styleName: 'ShapeRow' },
	      renderLeft && _react2.default.createElement(
	        'div',
	        { styleName: 'ShapeLeft' },
	        renderLeft()
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'ShapeRowDetails' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'ShapeContent' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'ShapeContent-primary' },
	            renderPrimary()
	          ),
	          renderSecondary && _react2.default.createElement(
	            'p',
	            { styleName: 'ShapeContent-secondary' },
	            renderSecondary()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          renderRight && _react2.default.createElement(
	            'p',
	            { styleName: 'ShapeContent-right ShapeContent-secondary' },
	            renderRight()
	          )
	        )
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      styleName: (0, _classnames2.default)('Shape', {
	        pointer: !!onClick,
	        active: active,
	        'Shape--withoutMargin': withoutMargin
	      }),
	      onClick: onClick
	    },
	    renderBody()
	  );
	}
	
	Shape.propTypes = {
	  className: PropTypes.string,
	  renderPrimary: PropTypes.func,
	  renderSecondary: PropTypes.func,
	  renderLeft: PropTypes.func,
	  renderRight: PropTypes.func,
	  active: PropTypes.bool,
	  onClick: PropTypes.func,
	  children: PropTypes.node,
	  withoutMargin: PropTypes.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true })(Shape);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _require = __webpack_require__(1948),
	    LOWER_CASED_BRAND_NAME = _require.LOWER_CASED_BRAND_NAME,
	    isFlagler = _require.isFlagler,
	    isHealthfully = _require.isHealthfully;
	
	var getBrandConfig = function getBrandConfig() {
	  try {
	    // eslint-disable-next-line import/no-dynamic-require, global-require
	    var config = __webpack_require__(6492)("./" + LOWER_CASED_BRAND_NAME + '/index.js');
	
	    return config.default;
	  } catch (error) {
	    console.log('Failed to load config for ' + LOWER_CASED_BRAND_NAME, error);
	  }
	};
	
	var brandConfig = getBrandConfig();
	
	exports.isFlagler = isFlagler;
	exports.isHealthfully = isHealthfully;
	exports.default = brandConfig;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheduleValidateActions = exports.SCHEDULE_VALIDATE_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = validate;
	
	var _constants = __webpack_require__(105);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'schedule/validate';
	
	var SCHEDULE_VALIDATE_TYPES = exports.SCHEDULE_VALIDATE_TYPES = {
	  VALIDATE: actionsScope + '/validate',
	  VALIDATE_FINISH: actionsScope + '/validate-finish',
	  TOGGLE_OVERLAP_MODAL: actionsScope + '/toggle-overlap-modal',
	  TOGGLE_OVERLAP_APPOINTMENT: actionsScope + '/toggle-overlap-appointment',
	  TOGGLE_RECURSION_MODAL: actionsScope + '/toggle-recursion-modal',
	  APPLY_RECURSION: actionsScope + '/apply-recursion',
	  FORCE_OVERLAP: actionsScope + '/force-overlap',
	  REMOVE_SCHEDULE: actionsScope + '/remove-schedule',
	  EDIT_WORK_RECURSION: actionsScope + '/edit-work-recursion',
	  EDIT_BLOCK_RECURSION: actionsScope + '/edit-block-recursion',
	  TOGGLE_VIEW_MODE: actionsScope + '/toggle-view-mode',
	  CLEAR: actionsScope + '/clear'
	};
	var scheduleValidateActions = exports.scheduleValidateActions = {
	  validate: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.VALIDATE),
	  finishValidate: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.VALIDATE_FINISH),
	  toggleOverlapModal: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.TOGGLE_OVERLAP_MODAL),
	  toggleOverlapAppointment: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.TOGGLE_OVERLAP_APPOINTMENT),
	  toggleRecursionModal: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.TOGGLE_RECURSION_MODAL),
	  applyRecursion: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION),
	  forceOverlap: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.FORCE_OVERLAP),
	  removeSchedule: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.REMOVE_SCHEDULE),
	  editWorkRecursion: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.EDIT_WORK_RECURSION),
	  editBlockRecursion: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.EDIT_BLOCK_RECURSION),
	  toggleViewMode: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.TOGGLE_VIEW_MODE),
	  clear: (0, _createAction.createAction)(SCHEDULE_VALIDATE_TYPES.CLEAR)
	};
	
	var initialState = {
	  validating: true,
	  viewMode: _constants.SCHEDULE_VIEW_MODE.READ,
	  userId: null,
	  providerId: null,
	  overlapModal: false,
	  overlapAppointment: false,
	  scheduleAdmin: false,
	  recursionModal: {}
	};
	
	function validate() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case SCHEDULE_VALIDATE_TYPES.VALIDATE:
	      {
	        return (0, _extends3.default)({}, state, { validating: true });
	      }
	
	    case SCHEDULE_VALIDATE_TYPES.VALIDATE_FINISH:
	      {
	        var id = payload.id,
	            providerId = payload.providerId,
	            scheduleAdmin = payload.scheduleAdmin;
	
	        return (0, _extends3.default)({}, state, {
	          userId: id,
	          providerId: providerId,
	          scheduleAdmin: scheduleAdmin,
	          validating: false
	        });
	      }
	
	    case SCHEDULE_VALIDATE_TYPES.TOGGLE_OVERLAP_MODAL:
	      {
	        return (0, _extends3.default)({}, state, { overlapModal: payload });
	      }
	
	    case SCHEDULE_VALIDATE_TYPES.TOGGLE_OVERLAP_APPOINTMENT:
	      {
	        return (0, _extends3.default)({}, state, { overlapAppointment: payload });
	      }
	
	    case SCHEDULE_VALIDATE_TYPES.TOGGLE_RECURSION_MODAL:
	      {
	        return (0, _extends3.default)({}, state, { recursionModal: payload });
	      }
	
	    case SCHEDULE_VALIDATE_TYPES.TOGGLE_VIEW_MODE:
	      {
	        return (0, _extends3.default)({}, state, { viewMode: payload });
	      }
	
	    case SCHEDULE_VALIDATE_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _useChartActions = __webpack_require__(3836);
	
	Object.defineProperty(exports, 'useChartActions', {
	  enumerable: true,
	  get: function get() {
	    return _useChartActions.useChartActions;
	  }
	});
	
	var _useChartContext = __webpack_require__(3837);
	
	Object.defineProperty(exports, 'useChartContext', {
	  enumerable: true,
	  get: function get() {
	    return _useChartContext.useChartContext;
	  }
	});
	
	var _useChartFormats = __webpack_require__(1824);
	
	Object.defineProperty(exports, 'useChartFormats', {
	  enumerable: true,
	  get: function get() {
	    return _useChartFormats.useChartFormats;
	  }
	});
	
	var _useHistoryActions = __webpack_require__(3838);
	
	Object.defineProperty(exports, 'useHistoryActions', {
	  enumerable: true,
	  get: function get() {
	    return _useHistoryActions.useHistoryActions;
	  }
	});
	
	var _useSafeDataSourceTitle = __webpack_require__(3839);
	
	Object.defineProperty(exports, 'useSafeDataSourceTitle', {
	  enumerable: true,
	  get: function get() {
	    return _useSafeDataSourceTitle.useSafeDataSourceTitle;
	  }
	});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useCountrySelect = useCountrySelect;
	
	var _reactRedux = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _countryDetails = __webpack_require__(527);
	
	var _selectors = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function normalizeStateList() {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return list.map(function (_ref) {
	    var label = _ref.name,
	        value = _ref.code;
	    return {
	      label: label,
	      value: value
	    };
	  });
	}
	
	function getFullExamplesError() {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
	
	  return list ? list.join(separator) : '';
	}
	
	function useCountrySelect(formatMessage) {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var countryDetails = (0, _reactRedux.useSelector)(_selectors.selectCountryDetails);
	
	  var separator = formatMessage({ id: 'errors.validation.separator' });
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return {
	      stateList: normalizeStateList(countryDetails.states),
	      zipLimit: (0, _get2.default)(countryDetails, 'zipCode.length'),
	      isZipApplicable: (0, _get2.default)(countryDetails, 'zipCode.applicable'),
	      zipExamples: getFullExamplesError((0, _get2.default)(countryDetails, 'zipCode.examples', ''), separator)
	    };
	  }, [countryDetails]),
	      stateList = _useMemo.stateList,
	      zipLimit = _useMemo.zipLimit,
	      isZipApplicable = _useMemo.isZipApplicable,
	      zipExamples = _useMemo.zipExamples;
	
	  var loadCountryDetails = function loadCountryDetails(code) {
	    dispatch(_countryDetails.actions.send({ code: code }));
	  };
	
	  return {
	    loadCountryDetails: loadCountryDetails,
	    stateList: stateList,
	    zipLimit: zipLimit,
	    isZipApplicable: isZipApplicable,
	    zipExamples: zipExamples
	  };
	}

/***/ }),
/* 146 */
[6594, 271],
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(5445);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ }),
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SVGCheckbox = __webpack_require__(1827);
	
	var _SVGCheckbox2 = _interopRequireDefault(_SVGCheckbox);
	
	var _brandConfig = __webpack_require__(142);
	
	var _selectors = __webpack_require__(93);
	
	var _index = __webpack_require__(2276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkbox = function Checkbox(_ref) {
	  var id = _ref.id,
	      label = _ref.label,
	      labelStyle = _ref.labelStyle,
	      name = _ref.name,
	      checked = _ref.checked,
	      disabled = _ref.disabled,
	      value = _ref.value,
	      children = _ref.children,
	      size = _ref.size,
	      style = _ref.style,
	      _onChange = _ref.onChange,
	      isLoggedIn = _ref.isLoggedIn,
	      className = _ref.className;
	
	  var isLoggedFlagler = _brandConfig.isFlagler && !isLoggedIn;
	
	  return _react2.default.createElement(
	    'label',
	    { htmlFor: id, styleName: 'input', style: style, className: className },
	    _react2.default.createElement('input', {
	      type: 'checkbox',
	      disabled: disabled,
	      checked: checked,
	      value: value,
	      id: id,
	      name: name,
	      onChange: function onChange(e) {
	        return _onChange(e.target.checked);
	      }
	    }),
	    !isLoggedFlagler && _react2.default.createElement(
	      'div',
	      { styleName: 'checker' },
	      _react2.default.createElement(_SVGCheckbox2.default, { size: size }),
	      _react2.default.createElement(_SVGCheckbox2.default, { size: size, checked: true })
	    ),
	    isLoggedFlagler && _react2.default.createElement(
	      'div',
	      { styleName: 'checker' },
	      checked && _react2.default.createElement(_Icon2.default, { name: 'blue_checkbox_checked', size: 16 }),
	      !checked && _react2.default.createElement(_Icon2.default, { name: 'blue_checkbox_unchecked', size: 16 })
	    ),
	    label ? _react2.default.createElement(
	      'span',
	      { styleName: 'label', style: labelStyle },
	      label
	    ) : null,
	    children
	  );
	};
	
	Checkbox.propTypes = {
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  checked: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  value: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  labelStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  size: _propTypes2.default.number,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]),
	  isLoggedIn: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	Checkbox.defaultProps = {
	  checked: false,
	  onChange: function onChange() {},
	  size: 12
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoggedIn: (0, _selectors.isLoggedInSelector)(state)
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(Checkbox);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectAcceptDeclinePending = exports.selectInviteDeclineState = exports.selectInviteAcceptState = exports.selectCommunityInvitationSearchSucceed = exports.selectCommunityInvitationSearchSending = exports.selectCommunityInvitationSearchUsers = exports.selectCommunityInvitationSearchState = exports.selectCommunityImageProcessing = exports.selectMemberInvitationTargetUser = exports.reqMemberInvitationErrorSelector = exports.makeDiscoverCommunitiesPaginationSelector = exports.makeDiscoverCommunitiesCounterSelector = exports.makeDiscoverCommunitiesListSelector = exports.sendingDiscoverCommunitiesSelector = exports.makeUserCommunitiesCounterSelector = exports.makeUserCommunitiesPaginationSelector = exports.communityUnreadCountSelector = exports.makeUserCommunitiesListSelector = exports.sendingUserCommunitiesSelector = exports.selectCreateCommunityPost = exports.moderatorsListLengthSelector = exports.membersListLengthSelector = exports.selectCommunityImageRemoveState = exports.selectCommunityImageUpdateState = exports.reqMemberInvitationSelector = exports.communityJoinPopupSelector = exports.currentCommunityIdSelector = exports.discoverCommunitiesSelector = exports.userCommunitiesSelector = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _index = __webpack_require__(60);
	
	var _lodash = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userCommunitiesSelector = exports.userCommunitiesSelector = function userCommunitiesSelector(state) {
	  return (0, _lodash.get)(state, 'communities.userCommunities');
	};
	var discoverCommunitiesSelector = exports.discoverCommunitiesSelector = function discoverCommunitiesSelector(state) {
	  return (0, _lodash.get)(state, 'communities.reqDiscoverCommunities');
	};
	var currentCommunityIdSelector = exports.currentCommunityIdSelector = function currentCommunityIdSelector(state) {
	  return (0, _lodash.get)(state, 'communities.currentCommunity');
	};
	var communityJoinPopupSelector = exports.communityJoinPopupSelector = function communityJoinPopupSelector(state) {
	  return (0, _lodash.get)(state, 'communities.joinPopup');
	};
	var reqMemberInvitationSelector = exports.reqMemberInvitationSelector = function reqMemberInvitationSelector(state) {
	  return (0, _lodash.get)(state, 'communities.reqMemberInvitation');
	};
	
	var selectCommunityImageUpdateState = exports.selectCommunityImageUpdateState = function selectCommunityImageUpdateState(state) {
	  return (0, _lodash.get)(state, 'communities.communityImageUpdate');
	};
	var selectCommunityImageRemoveState = exports.selectCommunityImageRemoveState = function selectCommunityImageRemoveState(state) {
	  return (0, _lodash.get)(state, 'communities.communityImageRemove');
	};
	
	var membersListLengthSelector = exports.membersListLengthSelector = function membersListLengthSelector(state) {
	  return (0, _lodash.get)(state, 'communities.membersList.length');
	};
	var moderatorsListLengthSelector = exports.moderatorsListLengthSelector = function moderatorsListLengthSelector(state) {
	  return (0, _lodash.get)(state, 'communities.moderatorsList.length');
	};
	var selectCreateCommunityPost = exports.selectCreateCommunityPost = function selectCreateCommunityPost(state) {
	  return (0, _lodash.get)(state, 'communities.createPost');
	};
	
	// user communities
	var sendingUserCommunitiesSelector = exports.sendingUserCommunitiesSelector = (0, _index.createSelector)(userCommunitiesSelector, function (request) {
	  return (0, _lodash.get)(request, 'sending', false);
	});
	
	var makeUserCommunitiesListSelector = exports.makeUserCommunitiesListSelector = function makeUserCommunitiesListSelector(userRole) {
	  return (0, _index.createSelector)(userCommunitiesSelector, function (request) {
	    return (0, _lodash.get)(request, [userRole], []);
	  });
	};
	
	var communityUnreadCountSelector = exports.communityUnreadCountSelector = function communityUnreadCountSelector(communityId) {
	  return (0, _index.createSelector)(makeUserCommunitiesListSelector('memberCommunities'), makeUserCommunitiesListSelector('moderatorCommunities'), function (memberList, moderatorList) {
	    var list = [].concat((0, _toConsumableArray3.default)(memberList), (0, _toConsumableArray3.default)(moderatorList));
	    var community = list.find(function (item) {
	      return (0, _lodash.get)(item, 'id') === communityId;
	    });
	    var counter = (0, _lodash.get)(community, 'communityMemberChatroom.totalUnreadCount', 0);
	    return counter;
	  });
	};
	
	var makeUserCommunitiesPaginationSelector = exports.makeUserCommunitiesPaginationSelector = function makeUserCommunitiesPaginationSelector(userRole) {
	  return (0, _index.createSelector)(userCommunitiesSelector, function (communitiesState) {
	    return (0, _lodash.get)(communitiesState, ['pagination', userRole]);
	  });
	};
	
	var makeUserCommunitiesCounterSelector = exports.makeUserCommunitiesCounterSelector = function makeUserCommunitiesCounterSelector(communityCount) {
	  return (0, _index.createSelector)(userCommunitiesSelector, function (request) {
	    return (0, _lodash.get)(request, communityCount, 0);
	  });
	};
	
	// discover communities
	var sendingDiscoverCommunitiesSelector = exports.sendingDiscoverCommunitiesSelector = (0, _index.createSelector)(discoverCommunitiesSelector, function (request) {
	  return (0, _lodash.get)(request, 'sending', false);
	});
	
	var makeDiscoverCommunitiesListSelector = exports.makeDiscoverCommunitiesListSelector = function makeDiscoverCommunitiesListSelector(communityType) {
	  return (0, _index.createSelector)(discoverCommunitiesSelector, function (request) {
	    return (0, _lodash.get)(request, [communityType], []);
	  });
	};
	
	var makeDiscoverCommunitiesCounterSelector = exports.makeDiscoverCommunitiesCounterSelector = function makeDiscoverCommunitiesCounterSelector(communityCount) {
	  return (0, _index.createSelector)(discoverCommunitiesSelector, function (request) {
	    var counterName = (0, _lodash.camelCase)(communityCount + '_count');
	
	    return (0, _lodash.get)(request, ['meta', counterName], 0);
	  });
	};
	
	var makeDiscoverCommunitiesPaginationSelector = exports.makeDiscoverCommunitiesPaginationSelector = function makeDiscoverCommunitiesPaginationSelector(communityType) {
	  return (0, _index.createSelector)(discoverCommunitiesSelector, function (communitiesState) {
	    return (0, _lodash.get)(communitiesState, ['pagination', communityType]);
	  });
	};
	
	var reqMemberInvitationErrorSelector = exports.reqMemberInvitationErrorSelector = (0, _index.createSelector)(reqMemberInvitationSelector, function (request) {
	  return (0, _lodash.get)(request, 'error', false);
	});
	
	var selectMemberInvitationTargetUser = exports.selectMemberInvitationTargetUser = (0, _index.createSelector)(reqMemberInvitationSelector, function (state) {
	  return (0, _lodash.get)(state, 'targetUser');
	});
	
	var selectCommunityImageProcessing = exports.selectCommunityImageProcessing = (0, _index.createSelector)(selectCommunityImageUpdateState, selectCommunityImageRemoveState, function (updateState, removeState) {
	  return (0, _lodash.get)(updateState, 'sending') || (0, _lodash.get)(removeState, 'sending');
	});
	
	// Invitation Search Selectors
	var selectCommunityInvitationSearchState = exports.selectCommunityInvitationSearchState = function selectCommunityInvitationSearchState(state) {
	  return (0, _lodash.get)(state, 'communities.invitationUserSearch');
	};
	
	var selectCommunityInvitationSearchUsers = exports.selectCommunityInvitationSearchUsers = (0, _index.createSelector)(selectCommunityInvitationSearchState, function (state) {
	  return (0, _lodash.get)(state, 'list', []);
	});
	var selectCommunityInvitationSearchSending = exports.selectCommunityInvitationSearchSending = (0, _index.createSelector)(selectCommunityInvitationSearchState, function (state) {
	  return (0, _lodash.get)(state, 'sending', false);
	});
	var selectCommunityInvitationSearchSucceed = exports.selectCommunityInvitationSearchSucceed = (0, _index.createSelector)(selectCommunityInvitationSearchState, function (state) {
	  return (0, _lodash.get)(state, 'succeed') || false;
	});
	
	// Invitation Accept/Decline selectors
	var selectInviteAcceptState = exports.selectInviteAcceptState = function selectInviteAcceptState(state) {
	  return (0, _lodash.get)(state, 'communities.acceptInvitation');
	};
	var selectInviteDeclineState = exports.selectInviteDeclineState = function selectInviteDeclineState(state) {
	  return (0, _lodash.get)(state, 'communities.declineInvitation');
	};
	
	var selectAcceptDeclinePending = exports.selectAcceptDeclinePending = (0, _index.createSelector)(selectInviteAcceptState, selectInviteDeclineState, function (_ref, _ref2) {
	  var acceptSending = _ref.sending;
	  var declineSending = _ref2.sending;
	  return acceptSending || declineSending;
	});

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.manageInsurancesActions = exports.MANAGE_INSURANCES_ACTION_TYPES = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var actionsScope = 'manage-insurances';
	
	var MANAGE_INSURANCES_ACTION_TYPES = exports.MANAGE_INSURANCES_ACTION_TYPES = {
	  SAVE_PATIENT_INSURANCES: actionsScope + '/save-patient-insurances',
	  DOWNLOAD_PATIENT_INSURANCES_DATA: actionsScope + '/download-patient-insurances-data',
	  SET_INSURANCE_RELATED_DATA_FETCHING: actionsScope + '/set-insurance-related-data-fetching',
	  UPLOAD_INSURANCE_CARD: actionsScope + '/upload-insurance-card',
	  SET_UPLOAD_INSURANCE_CARD_MODAL_DATA: actionsScope + '/set-upload-insurance-card-modal-data',
	  UPLOAD_MAIN_INSURANCE_CARD: actionsScope + '/upload-main-insurance-card',
	  RUN_MANUAL_ELIGIBILITY_ACTIVATION: actionsScope + '/run-manual-eligibility-activation',
	  CLEAR_MANAGE_INSURANCE_RELATED_DATA: actionsScope + '/clear-manage-insurance-related-data',
	  DOWNLOAD_TO_DO_TASK_INSURANCES_DATA: actionsScope + '/download-to-do-task-insurances-data',
	  SAVE_TO_DO_INSURANCES_DATA: actionsScope + '/save-to-do-insurances-data',
	  SET_INSURANCE_TO_DO_TASK_COMPLETING: actionsScope + '/set-insurance-to-do-task-completing'
	};
	
	var manageInsurancesActions = exports.manageInsurancesActions = {
	  savePatientInsurances: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.SAVE_PATIENT_INSURANCES),
	  downloadPatientInsurancesData: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.DOWNLOAD_PATIENT_INSURANCES_DATA),
	  setInsuranceRelatedDataFetching: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.SET_INSURANCE_RELATED_DATA_FETCHING),
	  uploadInsuranceCard: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.UPLOAD_INSURANCE_CARD),
	  setUploadInsuranceCardModalData: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.SET_UPLOAD_INSURANCE_CARD_MODAL_DATA),
	  uploadMainInsuranceCard: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.UPLOAD_MAIN_INSURANCE_CARD),
	  runManualEligibilityActivation: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.RUN_MANUAL_ELIGIBILITY_ACTIVATION),
	  clearManageInsuranceRelatedData: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.CLEAR_MANAGE_INSURANCE_RELATED_DATA),
	  downloadToDoTaskInsurancesData: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.DOWNLOAD_TO_DO_TASK_INSURANCES_DATA),
	  saveToDoInsurancesData: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.SAVE_TO_DO_INSURANCES_DATA),
	  setInsuranceToDoTaskCompleting: (0, _createAction.createAction)(MANAGE_INSURANCES_ACTION_TYPES.SET_INSURANCE_TO_DO_TASK_COMPLETING)
	};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateOrPush = exports.updateArrayItem = exports.removeArrayItem = undefined;
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.findAndReplace = findAndReplace;
	exports.toggleElementInList = toggleElementInList;
	
	var _find = __webpack_require__(462);
	
	var _find2 = _interopRequireDefault(_find);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removeArrayItem = exports.removeArrayItem = function removeArrayItem(arr, elementKey, elementValue) {
	  if (!Array.isArray(arr)) return arr;
	
	  var index = arr.findIndex(function (item) {
	    return item[elementKey] === elementValue;
	  });
	
	  if (index !== -1) {
	    return [].concat((0, _toConsumableArray3.default)(arr.slice(0, index)), (0, _toConsumableArray3.default)(arr.slice(index + 1)));
	  }
	
	  return arr;
	};
	
	// TODO: make it immutable
	var updateArrayItem = exports.updateArrayItem = function updateArrayItem(arr, findObject, newValues) {
	  if (!Array.isArray(arr)) return arr;
	
	  var elem = (0, _find2.default)(arr, findObject);
	
	  if (elem) (0, _assign2.default)(elem, newValues);
	
	  return arr;
	};
	
	var updateOrPush = exports.updateOrPush = function updateOrPush(arr, findObject, newElement) {
	  if (!Array.isArray(arr)) return arr;
	
	  var array = [].concat((0, _toConsumableArray3.default)(arr));
	
	  var elem = (0, _find2.default)(array, findObject);
	
	  if (!elem) {
	    array.push(newElement);
	  } else {
	    (0, _assign2.default)(elem, newElement);
	  }
	
	  return array;
	};
	
	function findAndReplace(list, item) {
	  var addIfEmpty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var result = [].concat((0, _toConsumableArray3.default)(list));
	
	  var index = list.findIndex(function (_ref) {
	    var id = _ref.id;
	    return id === item.id;
	  });
	
	  if (index >= 0) {
	    result[index] = item;
	  } else if (addIfEmpty) {
	    result.push(item);
	  }
	
	  return result;
	}
	
	function toggleElementInList(list, id) {
	  var index = list.findIndex(function (itemId) {
	    return itemId === id;
	  });
	  var result = [].concat((0, _toConsumableArray3.default)(list));
	  if (index === -1) {
	    result.push(id);
	  } else {
	    result.splice(index, 1);
	  }
	
	  return result;
	}

/***/ }),
/* 154 */
229,
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(956);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentArea = function ContentArea(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      style = _ref.style,
	      whiteScroll = _ref.whiteScroll;
	  return _react2.default.createElement('div', (0, _extends3.default)({ children: children, className: className, style: style }, {
	    styleName: (0, _classnames2.default)('root', {
	      'root--whiteScroll': whiteScroll
	    })
	  }));
	}; /* eslint-disable react/require-default-props */
	
	
	ContentArea.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  whiteScroll: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(ContentArea, _index2.default, { allowMultiple: true });

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5023);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var Paper = function Paper(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      disabled = _ref.disabled,
	      gray = _ref.gray,
	      onClick = _ref.onClick,
	      rounded = _ref.rounded,
	      style = _ref.style,
	      transparent = _ref.transparent,
	      unstyled = _ref.unstyled,
	      zDepth = _ref.zDepth,
	      inset = _ref.inset,
	      styleName = _ref.styleName,
	      isLayoutColumn = _ref.isLayoutColumn,
	      overflowVisible = _ref.overflowVisible;
	  return _react2.default.createElement('div', (0, _extends3.default)({ children: children, className: className, onClick: onClick }, {
	    style: (0, _assign2.default)({}, {
	      borderRadius: rounded ? _styles.BORDER_RADIUS : 0,
	      boxShadow: unstyled || disabled ? null : (inset ? 'inset' : '') + '0 2px ' + zDepth + 'px 0 rgba(0, 0, 0, .1)',
	      opacity: disabled ? '0.5' : null
	    }, style),
	    styleName: (0, _classnames2.default)('root', {
	      'root--unstyled': unstyled,
	      'root--transparent': transparent,
	      'root--gray': gray,
	      'root--column': isLayoutColumn,
	      'root--overflow-visible': overflowVisible,
	      styleName: styleName
	    })
	  }));
	};
	
	Paper.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  gray: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  rounded: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  transparent: _propTypes2.default.bool,
	  unstyled: _propTypes2.default.bool,
	  zDepth: _propTypes2.default.number,
	  inset: _propTypes2.default.bool,
	  isLayoutColumn: _propTypes2.default.bool,
	  overflowVisible: _propTypes2.default.bool
	};
	
	Paper.defaultProps = {
	  disabled: false,
	  rounded: true,
	  zDepth: 16,
	  inset: false
	};
	
	exports.default = (0, _reactCssModules2.default)(Paper, _index2.default, { allowMultiple: true });

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combinedPendingDataRequest = exports.selectAvailableCategoriesPending = exports.selectAvailableCategoriesEntity = exports.selectResultsDetailsPending = exports.selectResultsDocument = exports.selectResultsDetailsEntity = exports.selectResultsDetailsModalEntity = exports.selectIdResultsDetailsModal = exports.chatMembersModalDate = exports.chatMembersModalList = exports.chatMembersModalChannelName = exports.chatMembersModalOpened = exports.shareToEmailModalDocumentUid = exports.shareToEmailModal = exports.shareToChatModalDocumentUid = exports.shareToChatModal = exports.selectTestResultComponentName = exports.selectTestResultComponentCode = exports.selectLabResultHistoryError = exports.selectLabResultHistoryPending = exports.selectLabResultHistoryData = exports.selectOpenedLabResultHistoryModal = exports.selectOpenedResultsDetailsModal = exports.selectShareToChatPending = exports.selectSocialChannelsForSharePending = exports.selectSocialChannelsForShare = exports.selectPatientChannelsForSharePending = exports.selectPatientChannelsForShare = exports.selectLabTestResultsPending = exports.selectLabTestResultsEntity = exports.selectHealthRecordEntityTotal = exports.selectHealthRecordEntityOffset = exports.selectSetPreferredPharmacySuccess = exports.selectHealthRecordSucceed = exports.selectHealthRecordPaginationPending = exports.selectHealthRecordPending = exports.selectHealthRecordEntity = exports.selectActivityLogEntityIsLastPage = exports.selectActivityLogEntityOffset = exports.selectActivityLogPending = exports.selectActivityLogEntity = exports.selectProceduresPending = exports.selectProceduresEntity = exports.selectEncountersPending = exports.selectEncountersEntity = exports.selectSocialHistoryPending = exports.selectSocialHistoryEntity = exports.selectFamilyHistoryPending = exports.selectFamilyHistoryEntity = exports.selectConditionsPending = exports.selectConditionsEntity = exports.selectImmunizationPending = exports.selectImmunizationEntity = exports.selectAllergiesPending = exports.selectAllergiesEntity = exports.selectMedicationRefillsUnavailablePharmacyError = exports.selectMedicationRefillsRequestError = exports.selectMedicationRefillsRequestPending = exports.selectRefillsAvailableMedicationsPending = exports.selectRefillsAvailableMedicationsList = exports.selectMedicationsRefillsHistoryPending = exports.selectMedicationsRefillsHistoryList = exports.selectMedicationsPending = exports.selectMedicationsLoading = exports.selectMedicationsTotal = exports.selectMedicationsEntity = exports.selectPatientPortalRootState = exports.selectLocationBeforeTransitionsQuery = exports.selectLocationBeforeTransitions = exports.selectDeepLinkDependentId = exports.selectDeepLinkTab = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectDeepLinkTab = exports.selectDeepLinkTab = function selectDeepLinkTab(state) {
	  return (0, _get2.default)(state, 'routing.locationBeforeTransitions.query.tab', '');
	};
	
	var selectDeepLinkDependentId = exports.selectDeepLinkDependentId = function selectDeepLinkDependentId(state) {
	  return (0, _get2.default)(state, 'routing.locationBeforeTransitions.query.dependent_id', '');
	};
	
	var selectLocationBeforeTransitions = exports.selectLocationBeforeTransitions = function selectLocationBeforeTransitions(state) {
	  return (0, _get2.default)(state, 'routing.locationBeforeTransitions', {});
	};
	
	var selectLocationBeforeTransitionsQuery = exports.selectLocationBeforeTransitionsQuery = function selectLocationBeforeTransitionsQuery(state) {
	  return (0, _get2.default)(state, 'routing.locationBeforeTransitions.query', {});
	};
	
	var selectPatientPortalRootState = exports.selectPatientPortalRootState = function selectPatientPortalRootState(state) {
	  return (0, _get2.default)(state, 'healthboard.patientPortal');
	};
	
	var selectMedicationsEntity = exports.selectMedicationsEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'medications.list', []);
	});
	
	var selectMedicationsTotal = exports.selectMedicationsTotal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'medications.total', 0);
	});
	
	var selectMedicationsLoading = exports.selectMedicationsLoading = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'medications.sending', false);
	});
	
	var selectMedicationsPending = exports.selectMedicationsPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'medications.sending', false);
	});
	
	var selectMedicationsRefillsHistoryList = exports.selectMedicationsRefillsHistoryList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'refills.refillsHistory.list', []);
	});
	
	var selectMedicationsRefillsHistoryPending = exports.selectMedicationsRefillsHistoryPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'refills.refillsHistory.sending', false);
	});
	
	var selectRefillsAvailableMedicationsList = exports.selectRefillsAvailableMedicationsList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'refills.refillsAvailableMedications.list', []);
	});
	
	var selectRefillsAvailableMedicationsPending = exports.selectRefillsAvailableMedicationsPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'refills.refillsAvailableMedications.sending', false);
	});
	
	var selectMedicationRefillsRequestPending = exports.selectMedicationRefillsRequestPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'refills.medicationRefillRequest.sending', false);
	});
	
	var selectMedicationRefillsRequestError = exports.selectMedicationRefillsRequestError = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'refills.medicationRefillRequest.error');
	});
	
	var selectMedicationRefillsUnavailablePharmacyError = exports.selectMedicationRefillsUnavailablePharmacyError = (0, _reselect.createSelector)(selectMedicationRefillsRequestError, function (error) {
	  return (0, _get2.default)(error, 'code', '') === 'unprocessible_entity';
	});
	
	var selectAllergiesEntity = exports.selectAllergiesEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'allergies.list', []);
	});
	
	var selectAllergiesPending = exports.selectAllergiesPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'allergies.sending', false);
	});
	
	var selectImmunizationEntity = exports.selectImmunizationEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'immunizations.list', []);
	});
	
	var selectImmunizationPending = exports.selectImmunizationPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'immunizations.sending', false);
	});
	
	var selectConditionsEntity = exports.selectConditionsEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'conditions.list', []);
	});
	
	var selectConditionsPending = exports.selectConditionsPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'conditions.sending', false);
	});
	
	var selectFamilyHistoryEntity = exports.selectFamilyHistoryEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'familyHistory.list', []);
	});
	
	var selectFamilyHistoryPending = exports.selectFamilyHistoryPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'familyHistory.sending', false);
	});
	
	var selectSocialHistoryEntity = exports.selectSocialHistoryEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'socialHistory.list', []);
	});
	
	var selectSocialHistoryPending = exports.selectSocialHistoryPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'socialHistory.sending', false);
	});
	
	var selectEncountersEntity = exports.selectEncountersEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'encounters.list', []);
	});
	
	var selectEncountersPending = exports.selectEncountersPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'encounters.sending', false);
	});
	
	var selectProceduresEntity = exports.selectProceduresEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'procedures.list', []);
	});
	
	var selectProceduresPending = exports.selectProceduresPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'procedures.sending', false);
	});
	
	var selectActivityLogEntity = exports.selectActivityLogEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'activityLog.list', []);
	});
	
	var selectActivityLogPending = exports.selectActivityLogPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'activityLog.sending', false);
	});
	
	var selectActivityLogEntityOffset = exports.selectActivityLogEntityOffset = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'activityLog.offset', 0);
	});
	
	var selectActivityLogEntityIsLastPage = exports.selectActivityLogEntityIsLastPage = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'activityLog.isLastPage', false);
	});
	
	var selectHealthRecordEntity = exports.selectHealthRecordEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'healthRecord.list', []);
	});
	
	var selectHealthRecordPending = exports.selectHealthRecordPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  var sending = (0, _get2.default)(state, 'healthRecord.sending', false);
	  var isPagination = (0, _get2.default)(state, 'healthRecord.isPagination', false);
	  return !isPagination && sending;
	});
	
	var selectHealthRecordPaginationPending = exports.selectHealthRecordPaginationPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  var sending = (0, _get2.default)(state, 'healthRecord.sending', false);
	  var isPagination = (0, _get2.default)(state, 'healthRecord.isPagination', false);
	  return isPagination && sending;
	});
	
	var selectHealthRecordSucceed = exports.selectHealthRecordSucceed = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'healthRecord.succeed', false);
	});
	
	var selectSetPreferredPharmacySuccess = exports.selectSetPreferredPharmacySuccess = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'refills.setPreferredPharmacy.succeed', false);
	});
	
	var selectHealthRecordEntityOffset = exports.selectHealthRecordEntityOffset = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'healthRecord.offset', 0);
	});
	
	var selectHealthRecordEntityTotal = exports.selectHealthRecordEntityTotal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'healthRecord.total', false);
	});
	
	var selectLabTestResultsEntity = exports.selectLabTestResultsEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'labTestResults.list', []);
	});
	
	var selectLabTestResultsPending = exports.selectLabTestResultsPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'labTestResults.sending', false);
	});
	
	var selectPatientChannelsForShare = exports.selectPatientChannelsForShare = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'patientChannelsForShare.list', []);
	});
	
	var selectPatientChannelsForSharePending = exports.selectPatientChannelsForSharePending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'patientChannelsForShare.sending', false);
	});
	
	var selectSocialChannelsForShare = exports.selectSocialChannelsForShare = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'socialChannelsForShare.list', []);
	});
	
	var selectSocialChannelsForSharePending = exports.selectSocialChannelsForSharePending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'socialChannelsForShare.sending', false);
	});
	
	var selectShareToChatPending = exports.selectShareToChatPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'shareToChat.sending', false);
	});
	
	var selectOpenedResultsDetailsModal = exports.selectOpenedResultsDetailsModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'resultsDetailsModal.opened', false);
	});
	
	var selectOpenedLabResultHistoryModal = exports.selectOpenedLabResultHistoryModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'labResultHistoryModal.opened', false);
	});
	
	var selectLabResultHistoryData = exports.selectLabResultHistoryData = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'labResultHistoryRequest.list', []);
	});
	
	var selectLabResultHistoryPending = exports.selectLabResultHistoryPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'labResultHistoryRequest.sending', false);
	});
	
	var selectLabResultHistoryError = exports.selectLabResultHistoryError = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'labResultHistoryRequest.error', '');
	});
	
	var selectTestResultComponentCode = exports.selectTestResultComponentCode = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'labResultHistoryModal.componentCode', '');
	});
	
	var selectTestResultComponentName = exports.selectTestResultComponentName = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'labResultHistoryModal.name', '');
	});
	
	var shareToChatModal = exports.shareToChatModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'shareToChatModal.opened', false);
	});
	
	var shareToChatModalDocumentUid = exports.shareToChatModalDocumentUid = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'shareToChatModal.documentUid', '');
	});
	
	var shareToEmailModal = exports.shareToEmailModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'shareToEmailModal.opened', false);
	});
	
	var shareToEmailModalDocumentUid = exports.shareToEmailModalDocumentUid = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'shareToEmailModal.documentUid', '');
	});
	
	var chatMembersModalOpened = exports.chatMembersModalOpened = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'chatMembersModal.opened', false);
	});
	
	var chatMembersModalChannelName = exports.chatMembersModalChannelName = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'chatMembersModal.chatRoomName', '');
	});
	
	var chatMembersModalList = exports.chatMembersModalList = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'chatMembersModal.memberList', []);
	});
	
	var chatMembersModalDate = exports.chatMembersModalDate = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'chatMembersModal.date', '');
	});
	
	var selectIdResultsDetailsModal = exports.selectIdResultsDetailsModal = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'resultsDetailsModal.ccdLabTestId', '');
	});
	
	var selectResultsDetailsModalEntity = exports.selectResultsDetailsModalEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'resultsDetailsModal.entity', {});
	});
	
	var selectResultsDetailsEntity = exports.selectResultsDetailsEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'resultsDetails.ccdUserLabResults', []);
	});
	
	var selectResultsDocument = exports.selectResultsDocument = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'resultsDetails.ccdaUserDocuments');
	});
	
	var selectResultsDetailsPending = exports.selectResultsDetailsPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'resultsDetails.sending', false);
	});
	
	var selectAvailableCategoriesEntity = exports.selectAvailableCategoriesEntity = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'availableCategories.list', []);
	});
	
	var selectAvailableCategoriesPending = exports.selectAvailableCategoriesPending = (0, _reselect.createSelector)(selectPatientPortalRootState, function (state) {
	  return (0, _get2.default)(state, 'availableCategories.sending', false);
	});
	
	var combinedPendingDataRequest = exports.combinedPendingDataRequest = (0, _reselect.createSelector)(selectAllergiesPending, selectMedicationsPending, selectImmunizationPending, selectConditionsPending, selectLabTestResultsPending, selectFamilyHistoryPending, selectEncountersPending, selectSocialHistoryPending, selectHealthRecordPending, selectActivityLogPending, selectProceduresPending, function (allergiesPending, medicationsPending, immunizationPending, conditionsPending, labTestResultsPending, familyHistoryPending, encountersPending, socialHistoryPending, healthRecordPending, activityLogPending, proceduresPending) {
	  return allergiesPending || medicationsPending || immunizationPending || conditionsPending || labTestResultsPending || familyHistoryPending || encountersPending || socialHistoryPending || healthRecordPending || activityLogPending || proceduresPending;
	});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendingUpcomingSurveyCompletionsSucceed = exports.selectUpcomingSurveyCompletions = exports.sendingSubmitSurveySelector = exports.loadingFormResultSelector = exports.loadingReferralFormsSelector = exports.referralFormsListSelector = exports.selectAnsweredListSending = exports.answeredListSelector = exports.upcomingPaginationSelector = exports.selectUpcomingListCounter = exports.selectUpcomingSending = exports.selectUpcomingList = exports.upcomingSelector = exports.sendingUpcomingSurveySelector = exports.selectUpcomingSurveyAssignmentId = exports.selectUpcomingSurvey = exports.selectUpcomingSurveyProceedRejected = exports.selectUpcomingSurveyProceedPending = exports.selectUpcomingSurveyProceed = exports.selectAnsweredPagination = exports.selectAnsweredListCounter = exports.selectAnsweredList = exports.answeredSelector = exports.submitSurveySelector = exports.formResultSelector = exports.referralFormsSelector = exports.savedSelector = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var savedSelector = exports.savedSelector = function savedSelector(state) {
	  return state.surveys.saved;
	};
	var referralFormsSelector = exports.referralFormsSelector = function referralFormsSelector(state) {
	  return state.surveys.reqReferralForms;
	};
	var formResultSelector = exports.formResultSelector = function formResultSelector(state) {
	  return state.surveys.reqFormResult;
	};
	var submitSurveySelector = exports.submitSurveySelector = function submitSurveySelector(state) {
	  return state.surveys.submit;
	};
	
	//= =================ANSWERED SURVEY==============
	
	var answeredSelector = exports.answeredSelector = function answeredSelector(state) {
	  return state.surveys.answered;
	};
	var selectAnsweredList = exports.selectAnsweredList = (0, _reselect.createSelector)(answeredSelector, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectAnsweredListCounter = exports.selectAnsweredListCounter = (0, _reselect.createSelector)(answeredSelector, function (request) {
	  return (0, _get2.default)(request, ['meta', 'formsCount'], 0);
	});
	
	var selectAnsweredPagination = exports.selectAnsweredPagination = (0, _reselect.createSelector)(answeredSelector, function (state) {
	  return (0, _get2.default)(state, 'pagination');
	});
	//= ================================================
	//= =================UPCOMING SURVEY PROCEED========
	
	var selectUpcomingSurveyProceed = exports.selectUpcomingSurveyProceed = function selectUpcomingSurveyProceed(state) {
	  return state.surveys.upcomingSurveyProceed;
	};
	var selectUpcomingSurveyProceedPending = exports.selectUpcomingSurveyProceedPending = (0, _reselect.createSelector)(selectUpcomingSurveyProceed, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	var selectUpcomingSurveyProceedRejected = exports.selectUpcomingSurveyProceedRejected = (0, _reselect.createSelector)(selectUpcomingSurveyProceed, function (state) {
	  return (0, _get2.default)(state, 'rejected', null);
	});
	
	//= ================================================
	//= =================UPCOMING SURVEY================
	
	var selectUpcomingSurvey = exports.selectUpcomingSurvey = function selectUpcomingSurvey(state) {
	  return state.surveys.upcomingSurvey;
	};
	var selectUpcomingSurveyAssignmentId = exports.selectUpcomingSurveyAssignmentId = (0, _reselect.createSelector)(selectUpcomingSurvey, function (request) {
	  return (0, _get2.default)(request, 'assignmentId', 0);
	});
	
	var sendingUpcomingSurveySelector = exports.sendingUpcomingSurveySelector = (0, _reselect.createSelector)(selectUpcomingSurvey, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	//= ==================================================
	//= ========================UPCOMING==================
	
	var upcomingSelector = exports.upcomingSelector = function upcomingSelector(state) {
	  return state.surveys.upcoming;
	};
	var selectUpcomingList = exports.selectUpcomingList = (0, _reselect.createSelector)(upcomingSelector, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectUpcomingSending = exports.selectUpcomingSending = (0, _reselect.createSelector)(upcomingSelector, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectUpcomingListCounter = exports.selectUpcomingListCounter = (0, _reselect.createSelector)(upcomingSelector, function (request) {
	  return (0, _get2.default)(request, ['meta', 'totalCount'], 0);
	});
	
	var upcomingPaginationSelector = exports.upcomingPaginationSelector = (0, _reselect.createSelector)(upcomingSelector, function (state) {
	  return (0, _get2.default)(state, 'pagination');
	});
	
	//= ==================================================
	
	var answeredListSelector = exports.answeredListSelector = (0, _reselect.createSelector)(answeredSelector, function (answered) {
	  return (0, _get2.default)(answered, 'list', []);
	});
	
	var selectAnsweredListSending = exports.selectAnsweredListSending = (0, _reselect.createSelector)(answeredSelector, function (answered) {
	  return (0, _get2.default)(answered, 'sending', false);
	});
	
	var referralFormsListSelector = exports.referralFormsListSelector = (0, _reselect.createSelector)(referralFormsSelector, function (request) {
	  return (0, _get2.default)(request, 'list', []);
	});
	
	var loadingReferralFormsSelector = exports.loadingReferralFormsSelector = (0, _reselect.createSelector)(referralFormsSelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	var loadingFormResultSelector = exports.loadingFormResultSelector = (0, _reselect.createSelector)(formResultSelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	var sendingSubmitSurveySelector = exports.sendingSubmitSurveySelector = (0, _reselect.createSelector)(submitSurveySelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	//= =================UPCOMING SURVEY COMPLETIONS==============
	
	var selectUpcomingSurveyCompletions = exports.selectUpcomingSurveyCompletions = function selectUpcomingSurveyCompletions(state) {
	  return state.surveys.upcomingSurveyCompletions;
	};
	
	var sendingUpcomingSurveyCompletionsSucceed = exports.sendingUpcomingSurveyCompletionsSucceed = (0, _reselect.createSelector)(selectUpcomingSurveyCompletions, function (request) {
	  return (0, _get2.default)(request, 'succeed', false);
	});

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(912), __webpack_require__(548));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(912), __webpack_require__(548)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var WordArray = C_lib.WordArray;
			var C_algo = C.algo;
			var MD5 = C_algo.MD5;
	
			/**
	   * This key derivation function is meant to conform with EVP_BytesToKey.
	   * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	   */
			var EvpKDF = C_algo.EvpKDF = Base.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	    * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	    * @property {number} iterations The number of iterations to perform. Default: 1
	    */
				cfg: Base.extend({
					keySize: 128 / 32,
					hasher: MD5,
					iterations: 1
				}),
	
				/**
	    * Initializes a newly created key derivation function.
	    *
	    * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	    *
	    * @example
	    *
	    *     var kdf = CryptoJS.algo.EvpKDF.create();
	    *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	    *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	    */
				init: function init(cfg) {
					this.cfg = this.cfg.extend(cfg);
				},
	
				/**
	    * Derives a key from a password.
	    *
	    * @param {WordArray|string} password The password.
	    * @param {WordArray|string} salt A salt.
	    *
	    * @return {WordArray} The derived key.
	    *
	    * @example
	    *
	    *     var key = kdf.compute(password, salt);
	    */
				compute: function compute(password, salt) {
					var block;
	
					// Shortcut
					var cfg = this.cfg;
	
					// Init hasher
					var hasher = cfg.hasher.create();
	
					// Initial values
					var derivedKey = WordArray.create();
	
					// Shortcuts
					var derivedKeyWords = derivedKey.words;
					var keySize = cfg.keySize;
					var iterations = cfg.iterations;
	
					// Generate key
					while (derivedKeyWords.length < keySize) {
						if (block) {
							hasher.update(block);
						}
						block = hasher.update(password).finalize(salt);
						hasher.reset();
	
						// Iterations
						for (var i = 1; i < iterations; i++) {
							block = hasher.finalize(block);
							hasher.reset();
						}
	
						derivedKey.concat(block);
					}
					derivedKey.sigBytes = keySize * 4;
	
					return derivedKey;
				}
			});
	
			/**
	   * Derives a key from a password.
	   *
	   * @param {WordArray|string} password The password.
	   * @param {WordArray|string} salt A salt.
	   * @param {Object} cfg (Optional) The configuration options to use for this computation.
	   *
	   * @return {WordArray} The derived key.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var key = CryptoJS.EvpKDF(password, salt);
	   *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	   *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	   */
			C.EvpKDF = function (password, salt, cfg) {
				return EvpKDF.create(cfg).compute(password, salt);
			};
		})();
	
		return CryptoJS.EvpKDF;
	});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4337), __esModule: true };

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var _slice = Array.prototype.slice;
	
	var _createDecoratedClass = (function () { function defineProperties(target, descriptors, initializers) { for (var i = 0; i < descriptors.length; i++) { var descriptor = descriptors[i]; var decorators = descriptor.decorators; var key = descriptor.key; delete descriptor.key; delete descriptor.decorators; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor || descriptor.initializer) descriptor.writable = true; if (decorators) { for (var f = 0; f < decorators.length; f++) { var decorator = decorators[f]; if (typeof decorator === 'function') { descriptor = decorator(target, key, descriptor) || descriptor; } else { throw new TypeError('The decorator for method ' + descriptor.key + ' is of the invalid type ' + typeof decorator); } } if (descriptor.initializer !== undefined) { initializers[key] = descriptor; continue; } } Object.defineProperty(target, key, descriptor); } } return function (Constructor, protoProps, staticProps, protoInitializers, staticInitializers) { if (protoProps) defineProperties(Constructor.prototype, protoProps, protoInitializers); if (staticProps) defineProperties(Constructor, staticProps, staticInitializers); return Constructor; }; })();
	
	exports.isDescriptor = isDescriptor;
	exports.decorate = decorate;
	exports.metaFor = metaFor;
	exports.getOwnPropertyDescriptors = getOwnPropertyDescriptors;
	exports.createDefaultSetter = createDefaultSetter;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _defineDecoratedPropertyDescriptor(target, key, descriptors) { var _descriptor = descriptors[key]; if (!_descriptor) return; var descriptor = {}; for (var _key in _descriptor) descriptor[_key] = _descriptor[_key]; descriptor.value = descriptor.initializer ? descriptor.initializer.call(target) : undefined; Object.defineProperty(target, key, descriptor); }
	
	var _lazyInitialize = __webpack_require__(2114);
	
	var _lazyInitialize2 = _interopRequireDefault(_lazyInitialize);
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	function isDescriptor(desc) {
	  if (!desc || !desc.hasOwnProperty) {
	    return false;
	  }
	
	  var keys = ['value', 'initializer', 'get', 'set'];
	
	  for (var i = 0, l = keys.length; i < l; i++) {
	    if (desc.hasOwnProperty(keys[i])) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function decorate(handleDescriptor, entryArgs) {
	  if (isDescriptor(entryArgs[entryArgs.length - 1])) {
	    return handleDescriptor.apply(undefined, _toConsumableArray(entryArgs).concat([[]]));
	  } else {
	    return function () {
	      return handleDescriptor.apply(undefined, _slice.call(arguments).concat([entryArgs]));
	    };
	  }
	}
	
	var Meta = (function () {
	  var _instanceInitializers = {};
	
	  function Meta() {
	    _classCallCheck(this, Meta);
	
	    _defineDecoratedPropertyDescriptor(this, 'debounceTimeoutIds', _instanceInitializers);
	
	    _defineDecoratedPropertyDescriptor(this, 'throttleTimeoutIds', _instanceInitializers);
	
	    _defineDecoratedPropertyDescriptor(this, 'throttlePreviousTimestamps', _instanceInitializers);
	
	    _defineDecoratedPropertyDescriptor(this, 'throttleTrailingArgs', _instanceInitializers);
	  }
	
	  _createDecoratedClass(Meta, [{
	    key: 'debounceTimeoutIds',
	    decorators: [_lazyInitialize2['default']],
	    initializer: function initializer() {
	      return {};
	    },
	    enumerable: true
	  }, {
	    key: 'throttleTimeoutIds',
	    decorators: [_lazyInitialize2['default']],
	    initializer: function initializer() {
	      return {};
	    },
	    enumerable: true
	  }, {
	    key: 'throttlePreviousTimestamps',
	    decorators: [_lazyInitialize2['default']],
	    initializer: function initializer() {
	      return {};
	    },
	    enumerable: true
	  }, {
	    key: 'throttleTrailingArgs',
	    decorators: [_lazyInitialize2['default']],
	    initializer: function initializer() {
	      return null;
	    },
	    enumerable: true
	  }], null, _instanceInitializers);
	
	  return Meta;
	})();
	
	var META_KEY = typeof Symbol === 'function' ? Symbol('__core_decorators__') : '__core_decorators__';
	
	function metaFor(obj) {
	  if (obj.hasOwnProperty(META_KEY) === false) {
	    defineProperty(obj, META_KEY, {
	      // Defaults: NOT enumerable, configurable, or writable
	      value: new Meta()
	    });
	  }
	
	  return obj[META_KEY];
	}
	
	var getOwnKeys = getOwnPropertySymbols ? function (object) {
	  return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
	} : getOwnPropertyNames;
	
	exports.getOwnKeys = getOwnKeys;
	
	function getOwnPropertyDescriptors(obj) {
	  var descs = {};
	
	  getOwnKeys(obj).forEach(function (key) {
	    return descs[key] = getOwnPropertyDescriptor(obj, key);
	  });
	
	  return descs;
	}
	
	function createDefaultSetter(key) {
	  return function set(newValue) {
	    Object.defineProperty(this, key, {
	      configurable: true,
	      writable: true,
	      // IS enumerable when reassigned by the outside word
	      enumerable: true,
	      value: newValue
	    });
	
	    return newValue;
	  };
	}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var getTimezoneOffsetInMilliseconds = __webpack_require__(4697)
	var isDate = __webpack_require__(2176)
	
	var MILLISECONDS_IN_HOUR = 3600000
	var MILLISECONDS_IN_MINUTE = 60000
	var DEFAULT_ADDITIONAL_DIGITS = 2
	
	var parseTokenDateTimeDelimeter = /[T ]/
	var parseTokenPlainTime = /:/
	
	// year tokens
	var parseTokenYY = /^(\d{2})$/
	var parseTokensYYY = [
	  /^([+-]\d{2})$/, // 0 additional digits
	  /^([+-]\d{3})$/, // 1 additional digit
	  /^([+-]\d{4})$/ // 2 additional digits
	]
	
	var parseTokenYYYY = /^(\d{4})/
	var parseTokensYYYYY = [
	  /^([+-]\d{4})/, // 0 additional digits
	  /^([+-]\d{5})/, // 1 additional digit
	  /^([+-]\d{6})/ // 2 additional digits
	]
	
	// date tokens
	var parseTokenMM = /^-(\d{2})$/
	var parseTokenDDD = /^-?(\d{3})$/
	var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
	var parseTokenWww = /^-?W(\d{2})$/
	var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/
	
	// time tokens
	var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
	var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
	var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/
	
	// timezone tokens
	var parseTokenTimezone = /([Z+-].*)$/
	var parseTokenTimezoneZ = /^(Z)$/
	var parseTokenTimezoneHH = /^([+-])(\d{2})$/
	var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/
	
	/**
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If an argument is a string, the function tries to parse it.
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If all above fails, the function passes the given argument to Date constructor.
	 *
	 * @param {Date|String|Number} argument - the value to convert
	 * @param {Object} [options] - the object with options
	 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = parse('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Parse string '+02014101',
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = parse('+02014101', {additionalDigits: 1})
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parse (argument, dirtyOptions) {
	  if (isDate(argument)) {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime())
	  } else if (typeof argument !== 'string') {
	    return new Date(argument)
	  }
	
	  var options = dirtyOptions || {}
	  var additionalDigits = options.additionalDigits
	  if (additionalDigits == null) {
	    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
	  } else {
	    additionalDigits = Number(additionalDigits)
	  }
	
	  var dateStrings = splitDateString(argument)
	
	  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
	  var year = parseYearResult.year
	  var restDateString = parseYearResult.restDateString
	
	  var date = parseDate(restDateString, year)
	
	  if (date) {
	    var timestamp = date.getTime()
	    var time = 0
	    var offset
	
	    if (dateStrings.time) {
	      time = parseTime(dateStrings.time)
	    }
	
	    if (dateStrings.timezone) {
	      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
	    } else {
	      var fullTime = timestamp + time
	      var fullTimeDate = new Date(fullTime)
	
	      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)
	
	      // Adjust time when it's coming from DST
	      var fullTimeDateNextDay = new Date(fullTime)
	      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
	      var offsetDiff =
	        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
	        getTimezoneOffsetInMilliseconds(fullTimeDate)
	      if (offsetDiff > 0) {
	        offset += offsetDiff
	      }
	    }
	
	    return new Date(timestamp + time + offset)
	  } else {
	    return new Date(argument)
	  }
	}
	
	function splitDateString (dateString) {
	  var dateStrings = {}
	  var array = dateString.split(parseTokenDateTimeDelimeter)
	  var timeString
	
	  if (parseTokenPlainTime.test(array[0])) {
	    dateStrings.date = null
	    timeString = array[0]
	  } else {
	    dateStrings.date = array[0]
	    timeString = array[1]
	  }
	
	  if (timeString) {
	    var token = parseTokenTimezone.exec(timeString)
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '')
	      dateStrings.timezone = token[1]
	    } else {
	      dateStrings.time = timeString
	    }
	  }
	
	  return dateStrings
	}
	
	function parseYear (dateString, additionalDigits) {
	  var parseTokenYYY = parseTokensYYY[additionalDigits]
	  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]
	
	  var token
	
	  // YYYY or ±YYYYY
	  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
	  if (token) {
	    var yearString = token[1]
	    return {
	      year: parseInt(yearString, 10),
	      restDateString: dateString.slice(yearString.length)
	    }
	  }
	
	  // YY or ±YYY
	  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
	  if (token) {
	    var centuryString = token[1]
	    return {
	      year: parseInt(centuryString, 10) * 100,
	      restDateString: dateString.slice(centuryString.length)
	    }
	  }
	
	  // Invalid ISO-formatted year
	  return {
	    year: null
	  }
	}
	
	function parseDate (dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) {
	    return null
	  }
	
	  var token
	  var date
	  var month
	  var week
	
	  // YYYY
	  if (dateString.length === 0) {
	    date = new Date(0)
	    date.setUTCFullYear(year)
	    return date
	  }
	
	  // YYYY-MM
	  token = parseTokenMM.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    month = parseInt(token[1], 10) - 1
	    date.setUTCFullYear(year, month)
	    return date
	  }
	
	  // YYYY-DDD or YYYYDDD
	  token = parseTokenDDD.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    var dayOfYear = parseInt(token[1], 10)
	    date.setUTCFullYear(year, 0, dayOfYear)
	    return date
	  }
	
	  // YYYY-MM-DD or YYYYMMDD
	  token = parseTokenMMDD.exec(dateString)
	  if (token) {
	    date = new Date(0)
	    month = parseInt(token[1], 10) - 1
	    var day = parseInt(token[2], 10)
	    date.setUTCFullYear(year, month, day)
	    return date
	  }
	
	  // YYYY-Www or YYYYWww
	  token = parseTokenWww.exec(dateString)
	  if (token) {
	    week = parseInt(token[1], 10) - 1
	    return dayOfISOYear(year, week)
	  }
	
	  // YYYY-Www-D or YYYYWwwD
	  token = parseTokenWwwD.exec(dateString)
	  if (token) {
	    week = parseInt(token[1], 10) - 1
	    var dayOfWeek = parseInt(token[2], 10) - 1
	    return dayOfISOYear(year, week, dayOfWeek)
	  }
	
	  // Invalid ISO-formatted date
	  return null
	}
	
	function parseTime (timeString) {
	  var token
	  var hours
	  var minutes
	
	  // hh
	  token = parseTokenHH.exec(timeString)
	  if (token) {
	    hours = parseFloat(token[1].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR
	  }
	
	  // hh:mm or hhmm
	  token = parseTokenHHMM.exec(timeString)
	  if (token) {
	    hours = parseInt(token[1], 10)
	    minutes = parseFloat(token[2].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE
	  }
	
	  // hh:mm:ss or hhmmss
	  token = parseTokenHHMMSS.exec(timeString)
	  if (token) {
	    hours = parseInt(token[1], 10)
	    minutes = parseInt(token[2], 10)
	    var seconds = parseFloat(token[3].replace(',', '.'))
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE +
	      seconds * 1000
	  }
	
	  // Invalid ISO-formatted time
	  return null
	}
	
	function parseTimezone (timezoneString) {
	  var token
	  var absoluteOffset
	
	  // Z
	  token = parseTokenTimezoneZ.exec(timezoneString)
	  if (token) {
	    return 0
	  }
	
	  // ±hh
	  token = parseTokenTimezoneHH.exec(timezoneString)
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  // ±hh:mm or ±hhmm
	  token = parseTokenTimezoneHHMM.exec(timezoneString)
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  return 0
	}
	
	function dayOfISOYear (isoYear, week, day) {
	  week = week || 0
	  day = day || 0
	  var date = new Date(0)
	  date.setUTCFullYear(isoYear, 0, 4)
	  var fourthOfJanuaryDay = date.getUTCDay() || 7
	  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
	  date.setUTCDate(date.getUTCDate() + diff)
	  return date
	}
	
	module.exports = parse


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	var MAP = (exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;
	
	var MARKER = (exports.MARKER =
	  "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var MARKER_WITH_LABEL = (exports.MARKER_WITH_LABEL =
	  "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var RECTANGLE = (exports.RECTANGLE =
	  "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var POLYLINE = (exports.POLYLINE =
	  "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var POLYGON = (exports.POLYGON =
	  "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var CIRCLE = (exports.CIRCLE =
	  "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var KML_LAYER = (exports.KML_LAYER =
	  "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var DIRECTIONS_RENDERER = (exports.DIRECTIONS_RENDERER =
	  "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var HEATMAP_LAYER = (exports.HEATMAP_LAYER =
	  "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var FUSION_TABLES_LAYER = (exports.FUSION_TABLES_LAYER =
	  "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var ANCHOR = (exports.ANCHOR =
	  "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var INFO_WINDOW = (exports.INFO_WINDOW =
	  "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var OVERLAY_VIEW = (exports.OVERLAY_VIEW =
	  "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var GROUND_LAYER = (exports.GROUND_LAYER =
	  "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var DRAWING_MANAGER = (exports.DRAWING_MANAGER =
	  "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var SEARCH_BOX = (exports.SEARCH_BOX =
	  "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var MARKER_CLUSTERER = (exports.MARKER_CLUSTERER =
	  "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var INFO_BOX = (exports.INFO_BOX =
	  "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var TRAFFIC_LAYER = (exports.TRAFFIC_LAYER =
	  "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var STREET_VIEW_PANORAMA = (exports.STREET_VIEW_PANORAMA =
	  "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")
	
	var BICYCLING_LAYER = (exports.BICYCLING_LAYER =
	  "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED")


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var loglevel_1 = __webpack_require__(2959);
	exports.LogLevel = loglevel_1.LogLevel;
	var session_1 = __webpack_require__(2960);
	exports.SessionStatus = session_1.SessionStatus;
	exports.RequestSessionStatus = session_1.RequestSessionStatus;
	var severity_1 = __webpack_require__(2961);
	exports.Severity = severity_1.Severity;
	var status_1 = __webpack_require__(2962);
	exports.Status = status_1.Status;
	var transaction_1 = __webpack_require__(2963);
	exports.TransactionSamplingMethod = transaction_1.TransactionSamplingMethod;
	var transport_1 = __webpack_require__(2964);
	exports.Outcome = transport_1.Outcome;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['ADD_NEW_POST', 'LOAD_POSTS', 'LOAD_NEW_POSTS', 'LOAD_OLDER_POSTS', 'LOAD_POSTS_PREVIEW', 'LOAD_OLDER_POSTS_PREVIEW', 'DELETE_POST', 'RESTORE', 'EDIT_POST', 'POST_LIKE_CHANGED', 'POST_COMMENTS_CHANGED', 'REMOVE_NEW_POST_STATUS'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['communities', 'postsList'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var deletePost = function deletePost(state, payload) {
	  var index = state.findIndex(function (i) {
	    return i.id === parseInt(payload.id, 10);
	  });
	
	  return [].concat((0, _toConsumableArray3.default)(state.slice(0, index)), (0, _toConsumableArray3.default)(state.slice(index + 1)));
	};
	
	var editPost = function editPost(state, payload) {
	  var index = state.findIndex(function (i) {
	    return i.id === payload.id;
	  });
	  // eslint-disable-next-line no-param-reassign
	  payload.forceFetchImage = true;
	
	  return [].concat((0, _toConsumableArray3.default)(state.slice(0, index)), [payload], (0, _toConsumableArray3.default)(state.slice(index + 1)));
	};
	
	var changeLike = function changeLike(state, payload) {
	  var liked = payload.liked;
	
	  var change = liked ? 1 : -1;
	  var index = state.findIndex(function (i) {
	    return i.id === payload.postId;
	  });
	
	  if (index === -1) return state;
	
	  var post = (0, _assign2.default)({}, state[index], {
	    liked: liked,
	    totalLikes: state[index].totalLikes + change
	  });
	
	  return [].concat((0, _toConsumableArray3.default)(state.slice(0, index)), [post], (0, _toConsumableArray3.default)(state.slice(index + 1)));
	};
	
	var removeNewPostStatus = function removeNewPostStatus(state, payload) {
	  var id = payload;
	  var newState = state.map(function (item) {
	    if (item.id === id) {
	      return (0, _extends3.default)({}, item, {
	        isNewPost: false
	      });
	    }
	    return item;
	  });
	  return [].concat((0, _toConsumableArray3.default)(newState));
	};
	
	var changeComments = function changeComments(state, payload) {
	  var change = payload.change,
	      postId = payload.postId;
	
	  var index = state.findIndex(function (i) {
	    return i.id === postId;
	  });
	
	  if (index === -1) return state;
	
	  var post = (0, _assign2.default)({}, state[index], {
	    totalComments: state[index].totalComments + change
	  });
	
	  return [].concat((0, _toConsumableArray3.default)(state.slice(0, index)), [post], (0, _toConsumableArray3.default)(state.slice(index + 1)));
	};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	  switch (type) {
	    case consts.ADD_NEW_POST:
	      return [].concat((0, _toConsumableArray3.default)(payload), (0, _toConsumableArray3.default)(state));
	    case consts.LOAD_OLDER_POSTS:
	      return [].concat((0, _toConsumableArray3.default)(state), (0, _toConsumableArray3.default)(payload));
	    case consts.LOAD_NEW_POSTS:
	      return [].concat((0, _toConsumableArray3.default)(payload), (0, _toConsumableArray3.default)(state));
	    case consts.LOAD_POSTS:
	    case consts.LOAD_POSTS_PREVIEW:
	      return payload;
	    case consts.LOAD_OLDER_POSTS_PREVIEW:
	      return [].concat((0, _toConsumableArray3.default)(state), (0, _toConsumableArray3.default)(payload));
	    case consts.DELETE_POST:
	      return deletePost(state, payload);
	    case consts.EDIT_POST:
	      return editPost(state, payload);
	    case consts.RESTORE:
	      return [];
	    case consts.POST_LIKE_CHANGED:
	      return changeLike(state, payload);
	    case consts.POST_COMMENTS_CHANGED:
	      return changeComments(state, payload);
	    case consts.REMOVE_NEW_POST_STATUS:
	      return removeNewPostStatus(state, payload);
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectDependentFormGeneralInfoErrors = exports.selectDependentFormPersonalInfoErrors = exports.selectDependentFormCompleted = exports.selectDependentFormIsBackDisabled = exports.selectDependentFormIsCareUserCreator = exports.selectDependentFormAssigmentId = exports.selectDependentFormUserData = exports.selectDependentFormCurrentStep = exports.selectDependentFormRole = exports.selectDependentFormValidating = exports.selectDependentFormPending = exports.selectDependentFormSubmitRedirect = exports.selectDependentFormProgressMetadata = exports.selectDependentFormRegistrationSteps = exports.selectDependentPhoneNumberCountryIsoCode = exports.selectDependentPhoneNumberCountryCode = exports.selectDependentFormDependent = exports.selectDependentDocumentListLoading = exports.selectDependentDocumentList = exports.selectDependentGuardianListLoading = exports.selectDependentGuardianList = undefined;
	
	var _index = __webpack_require__(60);
	
	var _lodash = __webpack_require__(58);
	
	var _progress = __webpack_require__(121);
	
	var selectDependentFormState = function selectDependentFormState(state) {
	  return (0, _lodash.get)(state, 'dependentForm');
	};
	
	var selectPersonalInfoState = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'personalInfo');
	});
	
	var selectGeneralInfoState = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'generalInfo');
	});
	
	var selectDocumentsCompletionState = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'documentsCompletion');
	});
	
	var selectDocumentsUploadState = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'documentsUpload');
	});
	
	var selectDocumentsDeleteState = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'documentsDelete');
	});
	
	var selectDocumentsListState = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'documentsList');
	});
	
	var selectRelationState = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'relationship');
	});
	
	var selectProgressState = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'progress');
	});
	
	var selectGuardianListState = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'assignedGuardianList');
	});
	
	var selectDependentGuardianList = exports.selectDependentGuardianList = (0, _index.createSelector)(selectGuardianListState, function (state) {
	  return (0, _lodash.get)(state, 'list', []);
	});
	
	var selectDependentGuardianListLoading = exports.selectDependentGuardianListLoading = (0, _index.createSelector)(selectGuardianListState, function (state) {
	  return (0, _lodash.get)(state, 'sending', false);
	});
	
	var selectDependentDocumentList = exports.selectDependentDocumentList = (0, _index.createSelector)(selectDocumentsListState, function (state) {
	  return (0, _lodash.get)(state, 'list', []);
	});
	
	var selectDependentDocumentListLoading = exports.selectDependentDocumentListLoading = (0, _index.createSelector)(selectDocumentsListState, function (state) {
	  return (0, _lodash.get)(state, 'sending', false);
	});
	
	var selectDependentFormDependent = exports.selectDependentFormDependent = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'assignment.dependent', {});
	});
	
	var selectDependentPhoneNumberCountryCode = exports.selectDependentPhoneNumberCountryCode = (0, _index.createSelector)(selectDependentFormDependent, function (state) {
	  return (0, _lodash.get)(state, 'phoneNumberCountryCode');
	});
	
	var selectDependentPhoneNumberCountryIsoCode = exports.selectDependentPhoneNumberCountryIsoCode = (0, _index.createSelector)(selectDependentFormDependent, function (state) {
	  return (0, _lodash.get)(state, 'phoneNumberCountryIsoCode');
	});
	
	var selectDependentFormRegistrationSteps = exports.selectDependentFormRegistrationSteps = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'progress.registrationSteps');
	});
	var selectDependentFormProgressMetadata = exports.selectDependentFormProgressMetadata = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'progress.metadata');
	});
	
	var selectDependentFormSubmitRedirect = exports.selectDependentFormSubmitRedirect = (0, _index.createSelector)(selectDependentFormState, function (state) {
	  return (0, _lodash.get)(state, 'progress.submitRedirect');
	});
	
	var selectDependentFormPending = exports.selectDependentFormPending = (0, _index.createSelector)(selectPersonalInfoState, selectGeneralInfoState, selectDocumentsCompletionState, selectDocumentsUploadState, selectDocumentsDeleteState, selectDocumentsListState, selectRelationState, function () {
	  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return states.some(function (state) {
	    return state.sending;
	  });
	});
	
	var selectDependentFormValidating = exports.selectDependentFormValidating = (0, _index.createSelector)(selectProgressState, function (state) {
	  return (0, _lodash.get)(state, 'validating');
	});
	
	var selectDependentFormRole = exports.selectDependentFormRole = (0, _index.createSelector)(selectProgressState, function (state) {
	  return (0, _lodash.get)(state, 'role');
	});
	var selectDependentFormCurrentStep = exports.selectDependentFormCurrentStep = (0, _index.createSelector)(selectProgressState, function (state) {
	  return (0, _lodash.get)(state, 'currentStep');
	});
	
	var selectDependentFormUserData = exports.selectDependentFormUserData = (0, _index.createSelector)(selectProgressState, function (state) {
	  return (0, _lodash.get)(state, 'dependent');
	});
	
	var selectDependentFormAssigmentId = exports.selectDependentFormAssigmentId = (0, _index.createSelector)(selectProgressState, function (state) {
	  return (0, _lodash.get)(state, 'id');
	});
	
	var selectDependentFormIsCareUserCreator = exports.selectDependentFormIsCareUserCreator = (0, _index.createSelector)(selectProgressState, function (state) {
	  return (0, _lodash.get)(state, 'careUserCreator');
	});
	
	var selectDependentFormIsBackDisabled = exports.selectDependentFormIsBackDisabled = (0, _index.createSelector)(selectDependentFormIsCareUserCreator, selectDependentFormCurrentStep, function (isCareCreator, step) {
	  return isCareCreator === false || step === _progress.DEPENDENT_FORM_STEPS.GENERAL;
	});
	
	var selectDependentFormCompleted = exports.selectDependentFormCompleted = (0, _index.createSelector)(selectDependentFormCurrentStep, function (step) {
	  return [_progress.DEPENDENT_FORM_STEPS.COMPLETE, _progress.DEPENDENT_FORM_STEPS.USER_EXIST].includes(step);
	});
	
	var selectDependentFormPersonalInfoErrors = exports.selectDependentFormPersonalInfoErrors = (0, _index.createSelector)(selectPersonalInfoState, function (state) {
	  return (0, _lodash.get)(state, 'error');
	});
	
	var selectDependentFormGeneralInfoErrors = exports.selectDependentFormGeneralInfoErrors = (0, _index.createSelector)(selectGeneralInfoState, function (state) {
	  return (0, _lodash.get)(state, 'error');
	});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4350), __esModule: true };

/***/ }),
/* 169 */
89,
/* 170 */
[6599, 1411, 920, 169],
/* 171 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 172 */,
/* 173 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_87d8ddb2","outerContainer":"_630bb34b","secondaryToolbar":"_39664580","doorHangerRight":"_6a40cdc6","toolbarContainer":"_039ef1e0","toolbarViewerMiddle":"e12e3c7d","progressBar":"f1220b25","back-to-application":"_07c080f7","root":"_3657120a","loader":"_3ac457cf","header":"_2185906c","content":"fe7f0de1","validating":"_644a4d87","disabled":"_9567ae49","docContent":"_13cc4594","row":"bfe80281","title":"_60de9b92","title--dark":"_9f362660","section":"c9194a6b","avatar":"_9f641c6f","sub-title":"_62f2a4d4","form--label":"_73a3c8bb","btn-block":"b15be748","address-form":"_20da331b","column":"_2107ae8c","and-or":"_48fdd647","row--justify":"_28fb2eb7","input-icon":"bb9ac5b6"};

/***/ }),
/* 174 */,
/* 175 */
[6752, 5417, 5418, 323, 96, 5517],
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(139),
	    now = __webpack_require__(5515),
	    toNumber = __webpack_require__(2357);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(458),
	    baseClone = __webpack_require__(2313),
	    baseUnset = __webpack_require__(5430),
	    castPath = __webpack_require__(459),
	    copyObject = __webpack_require__(573),
	    customOmitClone = __webpack_require__(5449),
	    flatRest = __webpack_require__(2332),
	    getAllKeysIn = __webpack_require__(1546);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ThemeProvider = __webpack_require__(5925);
	
	Object.defineProperty(exports, 'ThemeProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ThemeProvider).default;
	  }
	});
	
	var _themr = __webpack_require__(5926);
	
	Object.defineProperty(exports, 'themr', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_themr).default;
	  }
	});
	Object.defineProperty(exports, 'themeable', {
	  enumerable: true,
	  get: function get() {
	    return _themr.themeable;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _bind2 = __webpack_require__(1030)
	
	var _bind3 = _interopRequireDefault(_bind2)
	
	var _isFunction2 = __webpack_require__(1033)
	
	var _isFunction3 = _interopRequireDefault(_isFunction2)
	
	var _reduce3 = __webpack_require__(6181)
	
	var _reduce4 = _interopRequireDefault(_reduce3)
	
	var _forEach2 = __webpack_require__(6173)
	
	var _forEach3 = _interopRequireDefault(_forEach2)
	
	var _lowerFirst2 = __webpack_require__(6177)
	
	var _lowerFirst3 = _interopRequireDefault(_lowerFirst2)
	
	var _has2 = __webpack_require__(6175)
	
	var _has3 = _interopRequireDefault(_has2)
	
	exports.construct = construct
	exports.componentDidMount = componentDidMount
	exports.componentDidUpdate = componentDidUpdate
	exports.componentWillUnmount = componentWillUnmount
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/* global google */
	/* eslint-disable no-param-reassign */
	function rdcUncontrolledAndControlledProps(acc, value, key) {
	  if ((0, _has3.default)(acc.prevProps, key)) {
	    var match = key.match(/^default(\S+)/)
	    if (match) {
	      var unprefixedKey = (0, _lowerFirst3.default)(match[1])
	      if (!(0, _has3.default)(acc.nextProps, unprefixedKey)) {
	        acc.nextProps[unprefixedKey] = acc.prevProps[key]
	      }
	    } else {
	      acc.nextProps[key] = acc.prevProps[key]
	    }
	  }
	  return acc
	}
	
	function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
	  ;(0, _forEach3.default)(updaterMap, function(fn, key) {
	    var nextValue = nextProps[key]
	    if (nextValue !== prevProps[key]) {
	      fn(instance, nextValue)
	    }
	  })
	}
	
	function construct(propTypes, updaterMap, prevProps, instance) {
	  var _reduce2 = (0, _reduce4.default)(
	      propTypes,
	      rdcUncontrolledAndControlledProps,
	      {
	        nextProps: {},
	        prevProps: prevProps,
	      }
	    ),
	    nextProps = _reduce2.nextProps
	
	  applyUpdaterToNextProps(
	    updaterMap,
	    {
	      /* empty prevProps for construct */
	    },
	    nextProps,
	    instance
	  )
	}
	
	function componentDidMount(component, instance, eventMap) {
	  registerEvents(component, instance, eventMap)
	}
	
	function componentDidUpdate(
	  component,
	  instance,
	  eventMap,
	  updaterMap,
	  prevProps
	) {
	  component.unregisterAllEvents()
	  applyUpdaterToNextProps(updaterMap, prevProps, component.props, instance)
	  registerEvents(component, instance, eventMap)
	}
	
	function componentWillUnmount(component) {
	  component.unregisterAllEvents()
	}
	
	function registerEvents(component, instance, eventMap) {
	  var registeredList = (0, _reduce4.default)(
	    eventMap,
	    function(acc, googleEventName, onEventName) {
	      if ((0, _isFunction3.default)(component.props[onEventName])) {
	        acc.push(
	          google.maps.event.addListener(
	            instance,
	            googleEventName,
	            component.props[onEventName]
	          )
	        )
	      }
	      return acc
	    },
	    []
	  )
	
	  component.unregisterAllEvents = (0, _bind3.default)(
	    _forEach3.default,
	    null,
	    registeredList,
	    unregisterEvent
	  )
	}
	
	function unregisterEvent(registered) {
	  google.maps.event.removeListener(registered)
	}


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	HTML escaping is the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var intl_messageformat_1 = __webpack_require__(2297);
	var intl_format_cache_1 = __webpack_require__(2293);
	var intl_utils_1 = __webpack_require__(1058);
	var ESCAPED_CHARS = {
	    38: '&amp;',
	    62: '&gt;',
	    60: '&lt;',
	    34: '&quot;',
	    39: '&#x27;',
	};
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	function escape(str) {
	    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) { return ESCAPED_CHARS[match.charCodeAt(0)]; });
	}
	exports.escape = escape;
	function filterProps(props, whitelist, defaults) {
	    if (defaults === void 0) { defaults = {}; }
	    return whitelist.reduce(function (filtered, name) {
	        if (name in props) {
	            filtered[name] = props[name];
	        }
	        else if (name in defaults) {
	            filtered[name] = defaults[name];
	        }
	        return filtered;
	    }, {});
	}
	exports.filterProps = filterProps;
	function invariantIntlContext(intl) {
	    intl_utils_1.invariant(intl, '[React Intl] Could not find required `intl` object. ' +
	        '<IntlProvider> needs to exist in the component ancestry.');
	}
	exports.invariantIntlContext = invariantIntlContext;
	function createError(message, exception) {
	    var eMsg = exception ? "\n" + exception.stack : '';
	    return "[React Intl] " + message + eMsg;
	}
	exports.createError = createError;
	function defaultErrorHandler(error) {
	    if (false) {
	        console.error(error);
	    }
	}
	exports.defaultErrorHandler = defaultErrorHandler;
	exports.DEFAULT_INTL_CONFIG = {
	    formats: {},
	    messages: {},
	    timeZone: undefined,
	    textComponent: React.Fragment,
	    defaultLocale: 'en',
	    defaultFormats: {},
	    onError: defaultErrorHandler,
	};
	function createIntlCache() {
	    return {
	        dateTime: {},
	        number: {},
	        message: {},
	        relativeTime: {},
	        pluralRules: {},
	        list: {},
	        displayNames: {},
	    };
	}
	exports.createIntlCache = createIntlCache;
	/**
	 * Create intl formatters and populate cache
	 * @param cache explicit cache to prevent leaking memory
	 */
	function createFormatters(cache) {
	    if (cache === void 0) { cache = createIntlCache(); }
	    var RelativeTimeFormat = Intl.RelativeTimeFormat;
	    var ListFormat = Intl.ListFormat;
	    var DisplayNames = Intl.DisplayNames;
	    return {
	        getDateTimeFormat: intl_format_cache_1.default(Intl.DateTimeFormat, cache.dateTime),
	        getNumberFormat: intl_format_cache_1.default(Intl.NumberFormat, cache.number),
	        getMessageFormat: intl_format_cache_1.default(intl_messageformat_1.default, cache.message),
	        getRelativeTimeFormat: intl_format_cache_1.default(RelativeTimeFormat, cache.relativeTime),
	        getPluralRules: intl_format_cache_1.default(Intl.PluralRules, cache.pluralRules),
	        getListFormat: intl_format_cache_1.default(ListFormat, cache.list),
	        getDisplayNames: intl_format_cache_1.default(DisplayNames, cache.displayNames),
	    };
	}
	exports.createFormatters = createFormatters;
	function getNamedFormat(formats, type, name, onError) {
	    var formatType = formats && formats[type];
	    var format;
	    if (formatType) {
	        format = formatType[name];
	    }
	    if (format) {
	        return format;
	    }
	    onError(createError("No " + type + " format named: " + name));
	}
	exports.getNamedFormat = getNamedFormat;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/******************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __spreadArray;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __classPrivateFieldIn;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (g && (g = 0, op[0] && (_ = 0)), _) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    };
	
	    __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        var desc = Object.getOwnPropertyDescriptor(m, k);
	        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	            desc = { enumerable: true, get: function() { return m[k]; } };
	        }
	        Object.defineProperty(o, k2, desc);
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    /** @deprecated */
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    /** @deprecated */
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __spreadArray = function (to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, state, kind, f) {
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, state, value, kind, f) {
	        if (kind === "m") throw new TypeError("Private method is not writable");
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	        return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
	    };
	
	    __classPrivateFieldIn = function (state, receiver) {
	        if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
	        return typeof state === "function" ? receiver === state : state.has(receiver);
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__spreadArray", __spreadArray);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	    exporter("__classPrivateFieldIn", __classPrivateFieldIn);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomEvents = undefined;
	exports.GATrackPageView = GATrackPageView;
	exports.GATrackCustomEvent = GATrackCustomEvent;
	
	var _env = __webpack_require__(103);
	
	var gtag = window.gtag || function () {};
	
	function GATrackPageView(title) {
	  if (_env.DEV_ENV) return;
	  console.log('[GA] track page  view:::: ', title);
	  gtag('event', 'page_view', {
	    page_title: title,
	    page_location: window.location.href,
	    page_path: window.location.pathname,
	    send_to: _env.GA_MEASUREMENT_ID
	  });
	}
	
	var CustomEvents = exports.CustomEvents = {
	  SUCCESS_LOGIN: 'success_login',
	  GET_CARE_START: 'get_care_start',
	  GET_CARE_LEAVE: 'get_care_leave',
	  GET_CARE_COMPLETE: 'get_care_complete'
	};
	
	function GATrackCustomEvent(event, options) {
	  if (_env.DEV_ENV) return;
	  console.log('[GA] track custom "' + event + '" action');
	  gtag('event', event, options);
	}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _actions = __webpack_require__(643);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actionsAsync = __webpack_require__(3974);
	
	var actionsAsync = _interopRequireWildcard(_actionsAsync);
	
	var _reducer = __webpack_require__(3979);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = _constants2.default;
	var actions = exports.actions = (0, _extends3.default)({}, _actions2.default, actionsAsync);
	exports.default = _reducer2.default;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _handleOverdueAppointments = __webpack_require__(4207);
	
	var _changeRoomReq = __webpack_require__(657);
	
	var changeRoom = _interopRequireWildcard(_changeRoomReq);
	
	var _changeStatusReq = __webpack_require__(525);
	
	var changeStatus = _interopRequireWildcard(_changeStatusReq);
	
	var _pinReq = __webpack_require__(837);
	
	var pinAppointment = _interopRequireWildcard(_pinReq);
	
	var _filterTypes = __webpack_require__(1272);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var _editPaymentReq = __webpack_require__(349);
	
	var _changePaidStatusReq = __webpack_require__(835);
	
	var _uploadDocumentReq = __webpack_require__(304);
	
	var _deleteDocumentReq = __webpack_require__(302);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _handleUpdateStatusSurveyInDetails = __webpack_require__(3228);
	
	var _appointmentDetails = __webpack_require__(102);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'appointment-list-req', ['INITIAL_LOAD', 'ADD_NEW_STATUS', 'REMOVE_NEW_STATUS', 'PAGE_LEAVE', 'MARK_OVERDUE', 'INSERT', 'UPDATE_VIA_WS', 'PIN_VIA_WS', 'REMOVE_ITEM', 'SET_ACTIVE_APPOINTMENT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dashboard',
	  type: 'get',
	  slug: ['appointments', {
	    type: 'payload.query',
	    queryParameter: 'date',
	    selector: 'date'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'status_ids',
	    selector: 'statuses'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'service_ids',
	    selector: 'services'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'location_ids',
	    selector: 'locations'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  list: []
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.INSERT:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: (0, _handleOverdueAppointments.formatAppointmentList)([payload].concat((0, _toConsumableArray3.default)(state.list)))
	        });
	      }
	
	    case _filterTypes.DASHBOARD_FILTER_TYPES.SET_FILTER:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: true
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true,
	          list: (0, _handleOverdueAppointments.formatAppointmentList)(payload)
	        });
	      }
	
	    case consts.MARK_OVERDUE:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: (0, _handleOverdueAppointments.markOverdueAppointmentList)(state.list)
	        });
	      }
	
	    case consts.ADD_NEW_STATUS:
	      {
	        var list = (0, _handleOverdueAppointments.toggleHighlightStatus)(state.list, payload.id, true);
	
	        return (0, _extends3.default)({}, state, { list: list });
	      }
	
	    case consts.REMOVE_NEW_STATUS:
	      {
	        var _list = (0, _handleOverdueAppointments.toggleHighlightStatus)(state.list, payload.id, false);
	
	        return (0, _extends3.default)({}, state, { list: _list });
	      }
	
	    case consts.PAGE_LEAVE:
	      {
	        return initialState;
	      }
	
	    case pinAppointment.consts.SUCCEED:
	    case consts.PIN_VIA_WS:
	      {
	        var _list2 = (0, _handleOverdueAppointments.findAndReplace)(state.list, payload);
	        return (0, _extends3.default)({}, state, {
	          list: (0, _handleOverdueAppointments.formatAppointmentList)(_list2)
	        });
	      }
	
	    case consts.UPDATE_VIA_WS:
	      {
	        var _list3 = (0, _handleOverdueAppointments.findAndReplace)(state.list, payload, true);
	        return (0, _extends3.default)({}, state, {
	          list: (0, _handleOverdueAppointments.formatAppointmentList)(_list3)
	        });
	      }
	
	    case consts.REMOVE_ITEM:
	      {
	        var _list4 = state.list.filter(function (item) {
	          return item.id !== payload.id;
	        });
	        return (0, _extends3.default)({}, state, {
	          list: _list4
	        });
	      }
	
	    case changeStatus.consts.SUCCEED:
	    case changeRoom.consts.SUCCEED:
	      {
	        var updatedAppointment = (0, _handleOverdueAppointments.transformTimeAdapter)(payload);
	        var _list5 = (0, _handleOverdueAppointments.findAndReplace)(state.list, updatedAppointment, true);
	
	        return (0, _extends3.default)({}, state, {
	          list: (0, _handleOverdueAppointments.markOverdueAppointmentList)(_list5)
	        });
	      }
	
	    case _editPaymentReq.consts.SUCCEED:
	      {
	        var target = state.list.find(function (_ref) {
	          var id = _ref.id;
	          return action.payload.id === id;
	        });
	        if (!target) return state;
	        var isFullEntity = !!state.activeAppointment;
	
	        return (0, _extends3.default)({}, state, isFullEntity && {
	          activeAppointment: (0, _extends3.default)({}, state.activeAppointment, {
	            copay: action.payload.copay
	          })
	        }, {
	          list: (0, _handleOverdueAppointments.findAndReplace)(state.list, (0, _extends3.default)({}, target, {
	            copay: action.payload.copay
	          }))
	        });
	      }
	
	    case _changePaidStatusReq.consts.SUCCEED:
	      {
	        var _target = state.list.find(function (_ref2) {
	          var id = _ref2.id;
	          return action.payload.id === id;
	        });
	        if (!_target) return state;
	
	        return (0, _extends3.default)({}, state, {
	          list: (0, _handleOverdueAppointments.findAndReplace)(state.list, (0, _extends3.default)({}, _target, {
	            paymentStatus: action.payload.paymentStatus
	          }))
	        });
	      }
	
	    case consts.SET_ACTIVE_APPOINTMENT:
	      {
	        return (0, _extends3.default)({}, state, {
	          activeAppointment: action.payload
	        });
	      }
	
	    case _uploadDocumentReq.consts.SUCCEED:
	      {
	        var _target2 = state.activeAppointment;
	        if (_target2) _target2.documents.push(action.payload);
	
	        return (0, _extends3.default)({}, state, {
	          activeAppointment: (0, _extends3.default)({}, _target2)
	        });
	      }
	
	    case _deleteDocumentReq.consts.UPDATE:
	      {
	        var _target3 = state.activeAppointment;
	
	        if (_target3) {
	          var targetDocument = _target3.documents.findIndex(function (_ref3) {
	            var id = _ref3.id;
	            return action.payload.documentId === id;
	          });
	          _target3.documents.splice(targetDocument, 1);
	
	          return (0, _extends3.default)({}, state, {
	            activeAppointment: (0, _extends3.default)({}, _target3)
	          });
	        }
	        return state;
	      }
	
	    case _upcomingSurveyCompletions.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStatusSurveyInDetails.handleUpdateStatusSurveyInDetails)(state, action);
	      }
	
	    case _statusChangeReq.consts.SUCCEED:
	      {
	        var _target4 = state.list.find(function (_ref4) {
	          var id = _ref4.id;
	          return action.payload.id === id;
	        });
	        if (!_target4) return state;
	
	        return (0, _extends3.default)({}, state, {
	          activeAppointment: (0, _extends3.default)({}, state.activeAppointment, {
	            status: action.payload.status
	          }),
	          list: (0, _handleOverdueAppointments.findAndReplace)(state.list, (0, _extends3.default)({}, _target4, {
	            status: action.payload.status
	          }))
	        });
	      }
	
	    case _cancelAppointmentReq.consts.SUCCEED:
	    case _appointmentDetails.APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT:
	      {
	        var newList = state.list.filter(function (_ref5) {
	          var id = _ref5.id;
	          return action.payload.id !== id;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          activeAppointment: undefined,
	          list: newList
	        });
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _locationReducer = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'drawer', 'TOGGLE_VISIBILITY', 'MOBILE_VISIBLE');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  visible: true,
	  desktopVisible: true,
	  route: null
	};
	
	// show drawer opened on page loading [mobile]
	var handleLocationChange = function handleLocationChange(state, payload) {
	  var pathname = payload.pathname;
	
	  var route = pathname && pathname.split('/')[1];
	  var newState = route !== state.route ? initialState : state;
	
	  return (0, _extends3.default)({}, newState, { route: route });
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.TOGGLE_VISIBILITY:
	      return (0, _extends3.default)({}, state, {
	        visible: !state.visible
	      });
	    case consts.MOBILE_VISIBLE:
	      return (0, _extends3.default)({}, state, {
	        visible: true
	      });
	    case _locationReducer.LOCATION_CHANGE:
	      return handleLocationChange(state, action.payload);
	    default:
	      return state;
	  }
	};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertListWithName = exports.convertGenderIdentitiesList = exports.convertMaritalList = exports.convertGenderList = exports.convertRelationsList = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var convertList = function convertList(list, namespace, formatMessage, hasDescription) {
	  if (!list) return false;
	
	  return list.map(function (item) {
	    var label = item.value;
	    var className = item.className;
	
	
	    if (formatMessage && namespace) {
	      var messageId = namespace + '.' + item.value;
	      var descriptionId = namespace + '.description.' + item.value;
	      if (hasDescription) {
	        label = _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            formatMessage({ id: messageId })
	          ),
	          hasDescription ? _react2.default.createElement(
	            'p',
	            { className: 'f-12 o-70' },
	            formatMessage({ id: descriptionId })
	          ) : null
	        );
	      } else {
	        label = formatMessage({ id: messageId });
	      }
	    }
	
	    return {
	      value: item.value,
	      label: label,
	      className: className
	    };
	  });
	};
	
	var convertRelationsList = exports.convertRelationsList = function convertRelationsList(list, formatMessage, hasDescription) {
	  return convertList(list, 'circles.roles', formatMessage, hasDescription);
	};
	
	var convertGenderList = exports.convertGenderList = function convertGenderList(list, formatMessage) {
	  return convertList(list, 'profile.list.gender', formatMessage);
	};
	
	var convertMaritalList = exports.convertMaritalList = function convertMaritalList(list, formatMessage) {
	  return convertList(list, 'profile.list.marital', formatMessage);
	};
	
	var convertGenderIdentitiesList = exports.convertGenderIdentitiesList = function convertGenderIdentitiesList(list) {
	  return list.map(function (_ref) {
	    var description = _ref.description,
	        id = _ref.id;
	    return {
	      label: description,
	      value: id
	    };
	  });
	};
	
	var convertListWithName = exports.convertListWithName = function convertListWithName(list) {
	  return list.map(function (_ref2) {
	    var name = _ref2.name,
	        id = _ref2.id,
	        enabled = _ref2.enabled;
	    return {
	      label: name,
	      value: id,
	      enabled: enabled
	    };
	  });
	};

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getPhoneWithoutUSCode = exports.getPhoneWithoutUSCode = function getPhoneWithoutUSCode(phone) {
	  return phone ? phone.replace('+1', '') : '';
	};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_enc = C.enc;
	
			/**
	   * Base64 encoding strategy.
	   */
			var Base64 = C_enc.Base64 = {
				/**
	    * Converts a word array to a Base64 string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The Base64 string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
					var map = this._map;
	
					// Clamp excess bits
					wordArray.clamp();
	
					// Convert
					var base64Chars = [];
					for (var i = 0; i < sigBytes; i += 3) {
						var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
						var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
	
						var triplet = byte1 << 16 | byte2 << 8 | byte3;
	
						for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
							base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
						}
					}
	
					// Add padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						while (base64Chars.length % 4) {
							base64Chars.push(paddingChar);
						}
					}
	
					return base64Chars.join('');
				},
	
				/**
	    * Converts a Base64 string to a word array.
	    *
	    * @param {string} base64Str The Base64 string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	    */
				parse: function parse(base64Str) {
					// Shortcuts
					var base64StrLength = base64Str.length;
					var map = this._map;
					var reverseMap = this._reverseMap;
	
					if (!reverseMap) {
						reverseMap = this._reverseMap = [];
						for (var j = 0; j < map.length; j++) {
							reverseMap[map.charCodeAt(j)] = j;
						}
					}
	
					// Ignore padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						var paddingIndex = base64Str.indexOf(paddingChar);
						if (paddingIndex !== -1) {
							base64StrLength = paddingIndex;
						}
					}
	
					// Convert
					return parseLoop(base64Str, base64StrLength, reverseMap);
				},
	
				_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
			};
	
			function parseLoop(base64Str, base64StrLength, reverseMap) {
				var words = [];
				var nBytes = 0;
				for (var i = 0; i < base64StrLength; i++) {
					if (i % 4) {
						var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
						var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
						var bitsCombined = bits1 | bits2;
						words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
						nBytes++;
					}
				}
				return WordArray.create(words, nBytes);
			}
		})();
	
		return CryptoJS.enc.Base64;
	});

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Constants table
			var T = [];
	
			// Compute constants
			(function () {
				for (var i = 0; i < 64; i++) {
					T[i] = Math.abs(Math.sin(i + 1)) * 0x100000000 | 0;
				}
			})();
	
			/**
	   * MD5 hash algorithm.
	   */
			var MD5 = C_algo.MD5 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Swap endian
					for (var i = 0; i < 16; i++) {
						// Shortcuts
						var offset_i = offset + i;
						var M_offset_i = M[offset_i];
	
						M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
					}
	
					// Shortcuts
					var H = this._hash.words;
	
					var M_offset_0 = M[offset + 0];
					var M_offset_1 = M[offset + 1];
					var M_offset_2 = M[offset + 2];
					var M_offset_3 = M[offset + 3];
					var M_offset_4 = M[offset + 4];
					var M_offset_5 = M[offset + 5];
					var M_offset_6 = M[offset + 6];
					var M_offset_7 = M[offset + 7];
					var M_offset_8 = M[offset + 8];
					var M_offset_9 = M[offset + 9];
					var M_offset_10 = M[offset + 10];
					var M_offset_11 = M[offset + 11];
					var M_offset_12 = M[offset + 12];
					var M_offset_13 = M[offset + 13];
					var M_offset_14 = M[offset + 14];
					var M_offset_15 = M[offset + 15];
	
					// Working variables
					var a = H[0];
					var b = H[1];
					var c = H[2];
					var d = H[3];
	
					// Computation
					a = FF(a, b, c, d, M_offset_0, 7, T[0]);
					d = FF(d, a, b, c, M_offset_1, 12, T[1]);
					c = FF(c, d, a, b, M_offset_2, 17, T[2]);
					b = FF(b, c, d, a, M_offset_3, 22, T[3]);
					a = FF(a, b, c, d, M_offset_4, 7, T[4]);
					d = FF(d, a, b, c, M_offset_5, 12, T[5]);
					c = FF(c, d, a, b, M_offset_6, 17, T[6]);
					b = FF(b, c, d, a, M_offset_7, 22, T[7]);
					a = FF(a, b, c, d, M_offset_8, 7, T[8]);
					d = FF(d, a, b, c, M_offset_9, 12, T[9]);
					c = FF(c, d, a, b, M_offset_10, 17, T[10]);
					b = FF(b, c, d, a, M_offset_11, 22, T[11]);
					a = FF(a, b, c, d, M_offset_12, 7, T[12]);
					d = FF(d, a, b, c, M_offset_13, 12, T[13]);
					c = FF(c, d, a, b, M_offset_14, 17, T[14]);
					b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
					a = GG(a, b, c, d, M_offset_1, 5, T[16]);
					d = GG(d, a, b, c, M_offset_6, 9, T[17]);
					c = GG(c, d, a, b, M_offset_11, 14, T[18]);
					b = GG(b, c, d, a, M_offset_0, 20, T[19]);
					a = GG(a, b, c, d, M_offset_5, 5, T[20]);
					d = GG(d, a, b, c, M_offset_10, 9, T[21]);
					c = GG(c, d, a, b, M_offset_15, 14, T[22]);
					b = GG(b, c, d, a, M_offset_4, 20, T[23]);
					a = GG(a, b, c, d, M_offset_9, 5, T[24]);
					d = GG(d, a, b, c, M_offset_14, 9, T[25]);
					c = GG(c, d, a, b, M_offset_3, 14, T[26]);
					b = GG(b, c, d, a, M_offset_8, 20, T[27]);
					a = GG(a, b, c, d, M_offset_13, 5, T[28]);
					d = GG(d, a, b, c, M_offset_2, 9, T[29]);
					c = GG(c, d, a, b, M_offset_7, 14, T[30]);
					b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
					a = HH(a, b, c, d, M_offset_5, 4, T[32]);
					d = HH(d, a, b, c, M_offset_8, 11, T[33]);
					c = HH(c, d, a, b, M_offset_11, 16, T[34]);
					b = HH(b, c, d, a, M_offset_14, 23, T[35]);
					a = HH(a, b, c, d, M_offset_1, 4, T[36]);
					d = HH(d, a, b, c, M_offset_4, 11, T[37]);
					c = HH(c, d, a, b, M_offset_7, 16, T[38]);
					b = HH(b, c, d, a, M_offset_10, 23, T[39]);
					a = HH(a, b, c, d, M_offset_13, 4, T[40]);
					d = HH(d, a, b, c, M_offset_0, 11, T[41]);
					c = HH(c, d, a, b, M_offset_3, 16, T[42]);
					b = HH(b, c, d, a, M_offset_6, 23, T[43]);
					a = HH(a, b, c, d, M_offset_9, 4, T[44]);
					d = HH(d, a, b, c, M_offset_12, 11, T[45]);
					c = HH(c, d, a, b, M_offset_15, 16, T[46]);
					b = HH(b, c, d, a, M_offset_2, 23, T[47]);
	
					a = II(a, b, c, d, M_offset_0, 6, T[48]);
					d = II(d, a, b, c, M_offset_7, 10, T[49]);
					c = II(c, d, a, b, M_offset_14, 15, T[50]);
					b = II(b, c, d, a, M_offset_5, 21, T[51]);
					a = II(a, b, c, d, M_offset_12, 6, T[52]);
					d = II(d, a, b, c, M_offset_3, 10, T[53]);
					c = II(c, d, a, b, M_offset_10, 15, T[54]);
					b = II(b, c, d, a, M_offset_1, 21, T[55]);
					a = II(a, b, c, d, M_offset_8, 6, T[56]);
					d = II(d, a, b, c, M_offset_15, 10, T[57]);
					c = II(c, d, a, b, M_offset_6, 15, T[58]);
					b = II(b, c, d, a, M_offset_13, 21, T[59]);
					a = II(a, b, c, d, M_offset_4, 6, T[60]);
					d = II(d, a, b, c, M_offset_11, 10, T[61]);
					c = II(c, d, a, b, M_offset_2, 15, T[62]);
					b = II(b, c, d, a, M_offset_9, 21, T[63]);
	
					// Intermediate hash value
					H[0] = H[0] + a | 0;
					H[1] = H[1] + b | 0;
					H[2] = H[2] + c | 0;
					H[3] = H[3] + d | 0;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
	
					var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
					var nBitsTotalL = nBitsTotal;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
	
					data.sigBytes = (dataWords.length + 1) * 4;
	
					// Hash final blocks
					this._process();
	
					// Shortcuts
					var hash = this._hash;
					var H = hash.words;
	
					// Swap endian
					for (var i = 0; i < 4; i++) {
						// Shortcut
						var H_i = H[i];
	
						H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
					}
	
					// Return final computed hash
					return hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			function FF(a, b, c, d, x, s, t) {
				var n = a + (b & c | ~b & d) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			function GG(a, b, c, d, x, s, t) {
				var n = a + (b & d | c & ~d) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			function HH(a, b, c, d, x, s, t) {
				var n = a + (b ^ c ^ d) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			function II(a, b, c, d, x, s, t) {
				var n = a + (c ^ (b | ~d)) + x + t;
				return (n << s | n >>> 32 - s) + b;
			}
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.MD5('message');
	   *     var hash = CryptoJS.MD5(wordArray);
	   */
			C.MD5 = Hasher._createHelper(MD5);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacMD5(message, key);
	   */
			C.HmacMD5 = Hasher._createHmacHelper(MD5);
		})(Math);
	
		return CryptoJS.MD5;
	});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SvgIcon = __webpack_require__(5612);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SvgIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Grid = __webpack_require__(6387);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	var _accessibilityOverscanIndicesGetter = __webpack_require__(6388);
	
	Object.defineProperty(exports, 'accessibilityOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_accessibilityOverscanIndicesGetter).default;
	  }
	});
	
	var _defaultCellRangeRenderer = __webpack_require__(2855);
	
	Object.defineProperty(exports, 'defaultCellRangeRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultCellRangeRenderer).default;
	  }
	});
	
	var _defaultOverscanIndicesGetter = __webpack_require__(2856);
	
	Object.defineProperty(exports, 'defaultOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultOverscanIndicesGetter).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var minimal_1 = __webpack_require__(1676);
	exports.addBreadcrumb = minimal_1.addBreadcrumb;
	exports.captureException = minimal_1.captureException;
	exports.captureEvent = minimal_1.captureEvent;
	exports.captureMessage = minimal_1.captureMessage;
	exports.configureScope = minimal_1.configureScope;
	exports.startTransaction = minimal_1.startTransaction;
	exports.setContext = minimal_1.setContext;
	exports.setExtra = minimal_1.setExtra;
	exports.setExtras = minimal_1.setExtras;
	exports.setTag = minimal_1.setTag;
	exports.setTags = minimal_1.setTags;
	exports.setUser = minimal_1.setUser;
	exports.withScope = minimal_1.withScope;
	var hub_1 = __webpack_require__(284);
	exports.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.Scope = hub_1.Scope;
	var api_1 = __webpack_require__(2926);
	exports.API = api_1.API;
	var baseclient_1 = __webpack_require__(2928);
	exports.BaseClient = baseclient_1.BaseClient;
	var basebackend_1 = __webpack_require__(2927);
	exports.BaseBackend = basebackend_1.BaseBackend;
	var request_1 = __webpack_require__(2933);
	exports.eventToSentryRequest = request_1.eventToSentryRequest;
	exports.sessionToSentryRequest = request_1.sessionToSentryRequest;
	var sdk_1 = __webpack_require__(2934);
	exports.initAndBind = sdk_1.initAndBind;
	var noop_1 = __webpack_require__(1672);
	exports.NoopTransport = noop_1.NoopTransport;
	var version_1 = __webpack_require__(2935);
	exports.SDK_VERSION = version_1.SDK_VERSION;
	var Integrations = __webpack_require__(2932);
	exports.Integrations = Integrations;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseFileAttribute = exports.getSafeAction = exports.getSafeRole = exports.getSafeUserId = exports.getSafeChannelName = undefined;
	exports.safePhoneNumber = safePhoneNumber;
	exports.getSafeAbnormalStatus = getSafeAbnormalStatus;
	exports.getSafeNormalRange = getSafeNormalRange;
	exports.getStartEndNormalRange = getStartEndNormalRange;
	exports.checkActiveRange = checkActiveRange;
	exports.normalizeData = normalizeData;
	exports.downloadFile = downloadFile;
	
	var _sum = __webpack_require__(5520);
	
	var _sum2 = _interopRequireDefault(_sum);
	
	var _constants = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PROXY = _constants.ACTIVITY_LOG_ROLE.PROXY,
	    PARENT = _constants.ACTIVITY_LOG_ROLE.PARENT,
	    PATIENT = _constants.ACTIVITY_LOG_ROLE.PATIENT,
	    GUARDIAN = _constants.ACTIVITY_LOG_ROLE.GUARDIAN,
	    PROVIDER = _constants.ACTIVITY_LOG_ROLE.PROVIDER,
	    CAREGIVER = _constants.ACTIVITY_LOG_ROLE.CAREGIVER,
	    GUARDIAN_PROXY = _constants.ACTIVITY_LOG_ROLE.GUARDIAN_PROXY;
	var DOWNLOAD = _constants.ACTIVITY_LOG_ACTION_TYPE.DOWNLOAD,
	    GET_ACCESS = _constants.ACTIVITY_LOG_ACTION_TYPE.GET_ACCESS,
	    SHARE_CHAT = _constants.ACTIVITY_LOG_ACTION_TYPE.SHARE_CHAT,
	    SHARE_EMAIL = _constants.ACTIVITY_LOG_ACTION_TYPE.SHARE_EMAIL,
	    VIEW = _constants.ACTIVITY_LOG_ACTION_TYPE.VIEW;
	function safePhoneNumber(phone) {
	  if (!phone) return '';
	  return phone.replace(/[^0-9+ ]/g, '');
	}
	
	function getSafeAbnormalStatus(value) {
	  if (!value) {
	    return '';
	  }
	
	  if (!_constants.NORMAL_TYPE.includes(value)) {
	    return '(' + value + ')';
	  }
	}
	
	function getSafeNormalRange(value, units) {
	  if (!value) {
	    return '';
	  }
	
	  if (value) {
	    if (/[0-9]/.test(value)) {
	      return value.replace(/[()]/g, '').replace(/[-]/g, ' - ') + ' ' + units;
	    }
	    return value.replace(/[()]/g, '');
	  }
	}
	
	function getStartEndNormalRange(value) {
	  if (value && /[-]/.test(value)) {
	    var rawRange = value.replace(/[()]/g, '');
	    var indexOfDivider = rawRange.indexOf('-');
	    var startPointNormal = parseFloat(rawRange.substring(0, indexOfDivider));
	
	    var endPointNormal = parseFloat(rawRange.substring(indexOfDivider + 1, rawRange.length));
	
	    var difference = parseFloat(endPointNormal, 10) - parseFloat(startPointNormal, 10);
	
	    var startPointLow = parseFloat(startPointNormal) - difference;
	    var endPointHigh = parseFloat(endPointNormal, 10) + difference;
	    return {
	      startPointNormal: startPointNormal,
	      endPointNormal: endPointNormal,
	      startPointLow: startPointLow,
	      endPointHigh: endPointHigh
	    };
	  }
	
	  return {
	    startPointNormal: '',
	    endPointNormal: '',
	    startPointLow: '',
	    endPointHigh: ''
	  };
	}
	
	function checkActiveRange(startPointNormal, endPointNormal, startPointLow, endPointHigh, value) {
	  var safeValue = value ? parseFloat(value.replace(/[^\d.]/g, '')) : '';
	  if (safeValue < startPointNormal) {
	    return { lowActive: true };
	  }
	
	  if (safeValue >= startPointNormal && safeValue <= endPointNormal) {
	    return { normalActive: true };
	  }
	
	  if (safeValue > endPointNormal) {
	    return { highActive: true };
	  }
	  return {};
	}
	
	function normalizeData(value, rangesPoints, sumWidth, calculatedRanges) {
	  if (value <= rangesPoints[0]) {
	    var _pointValue = calculatedRanges[0];
	    var _pointLeftPositionPercentage = _pointValue / sumWidth * 100 + 3;
	    return {
	      pointValue: _pointValue,
	      pointLeftPositionPercentage: _pointLeftPositionPercentage
	    };
	  }
	
	  if (value === parseFloat(rangesPoints[2])) {
	    var _pointValue2 = calculatedRanges[0] + calculatedRanges[1] + calculatedRanges[2];
	    var _pointLeftPositionPercentage2 = _pointValue2 / sumWidth * 100 - 0.5;
	    return {
	      pointValue: _pointValue2,
	      pointLeftPositionPercentage: _pointLeftPositionPercentage2
	    };
	  }
	
	  if (value >= rangesPoints[3]) {
	    var _pointValue3 = (0, _sum2.default)(calculatedRanges);
	    var _pointLeftPositionPercentage3 = _pointValue3 / sumWidth * 100 - 3;
	    return {
	      pointValue: _pointValue3,
	      pointLeftPositionPercentage: _pointLeftPositionPercentage3
	    };
	  }
	
	  var pointValue = value - rangesPoints[0];
	  var pointLeftPositionPercentage = pointValue / sumWidth * 100;
	  return {
	    pointValue: pointValue,
	    pointLeftPositionPercentage: pointLeftPositionPercentage
	  };
	}
	
	function downloadFile(url, fileType, title, mimeType, handleError) {
	  // eslint-disable-next-line compat/compat
	  fetch(url, {
	    method: 'GET'
	  }).then(function (resp) {
	    return resp.blob();
	  }).then(function (blob) {
	    var newBlob = new Blob([blob], {
	      type: mimeType,
	      charset: 'UTF-8'
	    });
	    // IE doesn't allow using a blob object directly as link href
	    // instead it is necessary to use msSaveOrOpenBlob
	    // eslint-disable-next-line promise/always-return
	    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	      window.navigator.msSaveOrOpenBlob(newBlob);
	      return;
	    }
	    var data = window.URL.createObjectURL(newBlob);
	    var link = document.createElement('a');
	    link.dataType = 'json';
	    link.href = data;
	    link.download = title + '.' + fileType;
	    link.dispatchEvent(new MouseEvent('click'));
	    setTimeout(function () {
	      // For Firefox it is necessary to delay revoking the ObjectURL
	      window.URL.revokeObjectURL(data);
	    }, 60);
	  }).catch(handleError);
	}
	
	var getSafeChannelName = exports.getSafeChannelName = function getSafeChannelName(name, formatMessage) {
	  switch (name) {
	    case _constants.CUSTOM_CHANNEL:
	      return formatMessage({ id: 'chat.titles.customChannel' });
	    case _constants.ALL_MEMBERS_SUBCHANNEL:
	      return formatMessage({ id: 'chat.titles.generalChatTab' });
	    case _constants.FAMILY_CIRCLE_SUBCHANNEL:
	      return formatMessage({ id: 'chat.titles.familyChatTab' });
	    default:
	      return name || '';
	  }
	};
	
	var getSafeUserId = exports.getSafeUserId = function getSafeUserId(targetUserId, mainUserId) {
	  var isMainUser = targetUserId === mainUserId || mainUserId && !targetUserId;
	  return { safeUserId: isMainUser ? mainUserId : targetUserId, isMainUser: isMainUser };
	};
	
	var getSafeRole = exports.getSafeRole = function getSafeRole(role, formatMessage) {
	  switch (role) {
	    case CAREGIVER:
	      {
	        return formatMessage({
	          id: 'circles.roles.caregiver'
	        });
	      }
	    case GUARDIAN_PROXY:
	      {
	        return formatMessage({
	          id: 'patient.portal.healthRecord.activityLog.guardianProxy'
	        });
	      }
	    case PROVIDER:
	      {
	        return formatMessage({
	          id: 'messages.nav.tabs.provider'
	        });
	      }
	    case PATIENT:
	      {
	        return formatMessage({
	          id: 'patient.portal.healthRecord.activityLog.patient'
	        });
	      }
	    case GUARDIAN:
	      {
	        return formatMessage({
	          id: 'dependent.form.guardianTitle'
	        });
	      }
	    case PROXY:
	      {
	        return formatMessage({
	          id: 'dependent.form.proxyTitle'
	        });
	      }
	    case PARENT:
	      {
	        return formatMessage({
	          id: 'dependent.form.parentTitle'
	        });
	      }
	    default:
	      return '';
	  }
	};
	
	var getSafeAction = exports.getSafeAction = function getSafeAction(action, type, title, fileName, chatRoomName, emailAddress, participantInChat, formatMessage) {
	  var transmitted = formatMessage({
	    id: 'patient.portal.healthRecord.activityLog.transmitted'
	  });
	  var to = formatMessage({
	    id: 'patient.portal.healthRecord.activityLog.to'
	  });
	  var downloaded = formatMessage({
	    id: 'patient.portal.healthRecord.activityLog.downloaded'
	  });
	  var viewed = formatMessage({
	    id: 'patient.portal.healthRecord.activityLog.viewed'
	  });
	  switch (action) {
	    case SHARE_CHAT:
	      {
	        var safeChannelName = getSafeChannelName(chatRoomName, formatMessage);
	        return transmitted + ' ' + fileName + ' ' + to + ' ' + safeChannelName;
	      }
	    case SHARE_EMAIL:
	      {
	        return transmitted + ' ' + fileName + ' ' + to + ' ' + emailAddress;
	      }
	    case DOWNLOAD:
	      {
	        return downloaded + ' ' + fileName;
	      }
	    case GET_ACCESS:
	      {
	        return viewed + ' ' + (title || type);
	      }
	    case VIEW:
	      {
	        return viewed + ' ' + fileName;
	      }
	    default:
	      return '';
	  }
	};
	
	var parseFileAttribute = exports.parseFileAttribute = function parseFileAttribute(data) {
	  var isPdfFormat = data.some(function (file) {
	    return file.extension === 'pdf';
	  });
	  var isXmlFormat = data.some(function (file) {
	    return file.extension === 'xml';
	  });
	  var isTxtFormat = data.some(function (file) {
	    return file.extension === 'txt';
	  });
	  var isZipFormat = data.some(function (file) {
	    return file.extension === 'zip';
	  });
	  var xmlFileData = isXmlFormat ? data.find(function (file) {
	    return file.extension === 'xml';
	  }) : {};
	  var pdfFileData = isPdfFormat ? data.find(function (file) {
	    return file.extension === 'pdf';
	  }) : {};
	  var txtFileData = isTxtFormat ? data.find(function (file) {
	    return file.extension === 'txt';
	  }) : {};
	  var zipFileData = isZipFormat ? data.find(function (file) {
	    return file.extension === 'zip';
	  }) : {};
	  var anyTypeFileData = data[0];
	
	  return {
	    zipFileData: zipFileData,
	    isXmlFormat: isXmlFormat,
	    isTxtFormat: isTxtFormat,
	    isPdfFormat: isPdfFormat,
	    xmlFileData: xmlFileData,
	    pdfFileData: pdfFileData,
	    txtFileData: txtFileData,
	    anyTypeFileData: anyTypeFileData
	  };
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyIcon = function PrivacyIcon(_ref) {
	  var show = _ref.show,
	      className = _ref.className,
	      intl = _ref.intl;
	  var formatMessage = intl.formatMessage;
	
	
	  return show ? _react2.default.createElement(
	    'span',
	    {
	      title: formatMessage({ id: 'common.onlyVisibleToYou' }),
	      className: (0, _classnames2.default)(className)
	    },
	    _react2.default.createElement(_Icon2.default, { size: 16, name: 'icon-hide-password' })
	  ) : null;
	};
	
	PrivacyIcon.propTypes = {
	  show: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, _react.memo)(PrivacyIcon);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INTRO_HINT_SELECTORS = undefined;
	
	var _chat = __webpack_require__(67);
	
	var INTRO_HINT_SELECTORS = exports.INTRO_HINT_SELECTORS = {
	  common: {
	    logout: 'intro-logout'
	  },
	  messages: {
	    searchChat: 'intro-searchChat',
	    selectChat: 'intro-selectChat',
	    selectChannel: 'intro-selectChannel',
	    generalChannel: 'intro-circleOfCareChannelName-tab',
	    providerChannel: 'intro-providersChannelName-tab',
	    familyChannel: 'intro-familyMembersChannelName-tab',
	    typeFilter: 'intro-typeFilter'
	  },
	
	  patient: {
	    circles: {
	      inviteMember: 'intro-inviteMember-' + _chat.GENERAL_ROLE,
	      cardActions: 'intro-cardActions-' + _chat.GENERAL_ROLE
	    },
	    messages: {
	      familyChat: 'intro-familyMembersChannelName-tab',
	      providerChat: 'intro-providersChannelName-tab',
	      generalChat: 'intro-circleOfCareChannelName-tab',
	      typeMessage: 'intro-typeMessage',
	      answerSurvey: 'intro-answerSurvey',
	      patientName: 'intro-patientName',
	      patientContext: 'intro-patientContext',
	      patientProgram: 'intro-patientProgram'
	    }
	  },
	  provider: {
	    messages: {
	      programFilter: 'intro-programFilter'
	    },
	    circles: {
	      inviteMember: 'intro-inviteMember-' + _chat.PROVIDER_ROLE,
	      cardActions: 'intro-cardActions-' + _chat.PROVIDER_ROLE
	    }
	  }
	};

/***/ }),
/* 196 */,
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.useLazyLoad = useLazyLoad;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _infiniteScroll = __webpack_require__(697);
	
	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useLazyLoad(_ref) {
	  var node = _ref.node,
	      loadMore = _ref.loadMore,
	      path = _ref.path;
	
	  var infinityInstance = (0, _react.useRef)(null);
	  var element = (0, _get2.default)(node, ['current'].concat((0, _toConsumableArray3.default)(path)));
	
	  (0, _react.useEffect)(function () {
	    infinityInstance.current = new _infiniteScroll2.default({
	      element: element,
	      type: 'lower',
	      onLoad: loadMore,
	      loadEdgeOffset: 50
	    });
	
	    return function () {
	      infinityInstance.current.unsubscribe();
	    };
	  }, [element]);
	
	  (0, _react.useEffect)(function () {
	    if (infinityInstance.current) {
	      infinityInstance.current.onLoad = loadMore;
	    }
	  }, [loadMore]);
	}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function (state, action) {
	  switch (action.type) {
	    case consts.EXPIRED_ERROR:
	      {
	        return (0, _extends3.default)({}, state, { error: action.payload });
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'logout', ['CLEAR', 'EXPIRED_ERROR']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users/sessions',
	  type: 'delete'
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = exports.actions = exports.consts = exports.DEFAULT_OFFSET = exports.DEFAULT_LIMIT = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _uniq = __webpack_require__(380);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_LIMIT = exports.DEFAULT_LIMIT = 20;
	var DEFAULT_OFFSET = exports.DEFAULT_OFFSET = 0;
	
	var supportedActions = ['SET_LAST_USER_ID', 'REMOVE_LAST_USER_ID', 'UPDATE_LAST_USER_ID', 'SET_LAST_SOCIAL_ID', 'REMOVE_LAST_SOCIAL_ID',
	// pagination
	'SET_OFFSET',
	
	// action handlers
	'ADD_EXCLUDED_ID', 'CLEAR_EXCLUDED_IDS', 'LOAD_NEXT_PAGE', 'CLEAR_CHAT_ID',
	
	// common
	'CLEAR'];
	
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['board', 'settings'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = exports.initialState = {
	  lastUserId: null,
	  limit: DEFAULT_LIMIT,
	  offset: DEFAULT_OFFSET,
	  excludedIds: []
	};
	
	var setLastSocialId = function setLastSocialId(state, action) {
	  var id = action.payload.id;
	
	
	  return (0, _extends3.default)({}, state, {
	    lastSocialId: id
	  });
	};
	
	var removeLastSocialId = function removeLastSocialId(state, action) {
	  return (0, _extends3.default)({}, state, {
	    lastSocialId: null
	  });
	};
	
	var setLastUserId = function setLastUserId(state, action) {
	  var id = action.payload.id;
	
	
	  return (0, _extends3.default)({}, state, {
	    lastUserId: id
	  });
	};
	
	var removeLastUserId = function removeLastUserId(state, action) {
	  return (0, _extends3.default)({}, state, {
	    lastUserId: null
	  });
	};
	
	var clearChatId = function clearChatId(state, action) {
	  return (0, _extends3.default)({}, state, {
	    lastSocialId: null,
	    lastUserId: null
	  });
	};
	
	var setOffset = function setOffset(state, action) {
	  return (0, _extends3.default)({}, state, {
	    offset: action.payload
	  });
	};
	
	var addExcludedId = function addExcludedId(state, action) {
	  var excludedIds = (0, _uniq2.default)([].concat((0, _toConsumableArray3.default)(state.excludedIds), [action.payload]));
	
	  return (0, _extends3.default)({}, state, {
	    excludedIds: excludedIds
	  });
	};
	
	var clearExcludedId = function clearExcludedId(state, action) {
	  return (0, _extends3.default)({}, state, {
	    excludedIds: []
	  });
	};
	
	var loadNextPage = function loadNextPage(state, action) {
	  var limit = state.limit,
	      offset = state.offset;
	
	
	  return (0, _extends3.default)({}, state, {
	    offset: offset + limit
	  });
	};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SET_LAST_USER_ID:
	      return setLastUserId(state, action);
	    case consts.REMOVE_LAST_USER_ID:
	      return removeLastUserId(state, action);
	    case consts.SET_LAST_SOCIAL_ID:
	      return setLastSocialId(state, action);
	    case consts.REMOVE_LAST_SOCIAL_ID:
	      return removeLastSocialId(state, action);
	    case consts.SET_OFFSET:
	      return setOffset(state, action);
	    case consts.ADD_EXCLUDED_ID:
	      return addExcludedId(state, action);
	    case consts.CLEAR_EXCLUDED_ID:
	      return clearExcludedId(state, action);
	    case consts.LOAD_NEXT_PAGE:
	      return loadNextPage(state, action);
	    case consts.CLEAR_CHAT_ID:
	      return clearChatId(state, action);
	    case consts.CLEAR:
	      return initialState;
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'cancel-appointment');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'cancel']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'sign-appointment-consent');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: ['consents', {
	    type: 'payload',
	    selector: ['consentId']
	  }, 'user_consent_info']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'getUser');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'upcoming-survey-completions', ['MESSAGE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'upcoming_assignments',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['assignmentId']
	  }, 'completions']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 205 */
[6555, 125, 447, 124],
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(89);
	var hide = __webpack_require__(205);
	var has = __webpack_require__(204);
	var SRC = __webpack_require__(451)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(270).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	var fails = __webpack_require__(95);
	var defined = __webpack_require__(271);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 208 */
[6672, 31, 20],
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(468),
	    upperFirst = __webpack_require__(147);
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	module.exports = capitalize;


/***/ }),
/* 210 */
[6804, 2762],
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFontSize = getFontSize;
	exports.getOuterNumberPosition = getOuterNumberPosition;
	exports.getClockHandLength = getClockHandLength;
	exports.getClockHandCirclePosition = getClockHandCirclePosition;
	exports.getClockHandCircleRadius = getClockHandCircleRadius;
	exports.INNER_NUMBER_POSITIONING = exports.INITIAL_MINUTE_TRANSFORM = exports.INITIAL_HOUR_TRANSFORM = exports.NUMBER_OUTER_POSITION = exports.NUMBER_RADIUS_REGULAR = exports.INNER_NUMBER_RADIUS = exports.CLOCK_SIZE = exports.CLOCK_RADIUS = exports.VISIBLE_NUMBERS_PER_CIRCLE = exports.CLOCK_VALUES = exports.MERIDIEM = exports.MODE = exports.MINUTES = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(1051));
	
	var _CLOCK_VALUES;
	
	var MINUTES = ['05', 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, '00'].map(function (a) {
	  return a.toString();
	});
	exports.MINUTES = MINUTES;
	var MINUTES_60 = Array.from(Array(60), function (_, i) {
	  return i.toString();
	});
	var HOURS_12 = Array.from(Array(12), function (_, i) {
	  return (i + 1).toString();
	});
	var HOURS_24 = Array.from(Array(23), function (_, i) {
	  return (i + 1).toString();
	}).concat('00');
	var MODE;
	exports.MODE = MODE;
	
	(function (MODE) {
	  MODE["MINUTES"] = "MINUTES";
	  MODE["HOURS_12"] = "HOURS_12";
	  MODE["HOURS_24"] = "HOURS_24";
	})(MODE || (exports.MODE = MODE = {}));
	
	var MERIDIEM;
	/*
		- increments is how many splits on clock, visible or invisible
	*/
	
	exports.MERIDIEM = MERIDIEM;
	
	(function (MERIDIEM) {
	  MERIDIEM["am"] = "am";
	  MERIDIEM["pm"] = "pm";
	})(MERIDIEM || (exports.MERIDIEM = MERIDIEM = {}));
	
	var CLOCK_VALUES = (_CLOCK_VALUES = {}, (0, _defineProperty2.default)(_CLOCK_VALUES, MODE.MINUTES, {
	  increments: 60,
	  numbers: MINUTES,
	  dropdown: MINUTES_60
	}), (0, _defineProperty2.default)(_CLOCK_VALUES, MODE.HOURS_12, {
	  increments: 12,
	  numbers: HOURS_12,
	  dropdown: HOURS_12
	}), (0, _defineProperty2.default)(_CLOCK_VALUES, MODE.HOURS_24, {
	  increments: 12,
	  numbers: HOURS_24.slice(12),
	  numbersInner: HOURS_24.slice(0, 12),
	  dropdown: HOURS_24
	}), _CLOCK_VALUES); // number of actual numbers to display
	
	exports.CLOCK_VALUES = CLOCK_VALUES;
	var VISIBLE_NUMBERS_PER_CIRCLE = 12; // radius of clock, in px
	
	exports.VISIBLE_NUMBERS_PER_CIRCLE = VISIBLE_NUMBERS_PER_CIRCLE;
	var CLOCK_RADIUS = 110;
	exports.CLOCK_RADIUS = CLOCK_RADIUS;
	var CLOCK_SIZE = CLOCK_RADIUS * 2;
	/*
		radius of invisible inner circle for 24 hour numbers
		- controls how far out the inner circle comes and
		how far in numbers come as well
	 */
	
	exports.CLOCK_SIZE = CLOCK_SIZE;
	var INNER_NUMBER_RADIUS = 77; // font sizes
	
	exports.INNER_NUMBER_RADIUS = INNER_NUMBER_RADIUS;
	var NUMBER_REGULAR_FONT_SIZE = 16;
	var HOUR_24_INNER_FONT_SIZE = 15;
	var HOUR_24_OUTER_FONT_SIZE = 13;
	
	function getFontSize(hour24Mode, inner) {
	  if (!hour24Mode) {
	    return NUMBER_REGULAR_FONT_SIZE;
	  }
	
	  return inner ? HOUR_24_INNER_FONT_SIZE : HOUR_24_OUTER_FONT_SIZE;
	} // size of circle surrounding individual numbers
	// loosely based on font sizes above
	
	
	var NUMBER_RADIUS_REGULAR = 34;
	exports.NUMBER_RADIUS_REGULAR = NUMBER_RADIUS_REGULAR;
	var NUMBER_RADIUS_HOUR_24_OUTER = 32;
	var NUMBER_RADIUS_HOUR_24_INNER = 28; // positioning of numbers
	
	var NUMBER_OUTER_POSITION = 22;
	exports.NUMBER_OUTER_POSITION = NUMBER_OUTER_POSITION;
	var NUMBER_OUTER_POSITION_24_HOUR = 18; // controls how far out to move numbers during 24h mode
	
	var NUMBER_INNER_POSITION_24_HOUR = CLOCK_RADIUS - INNER_NUMBER_RADIUS + NUMBER_RADIUS_HOUR_24_INNER / 2;
	
	function getOuterNumberPosition(mode) {
	  return mode === MODE.HOURS_24 ? NUMBER_OUTER_POSITION_24_HOUR : NUMBER_OUTER_POSITION;
	} // initial position of hours/minutes before animating to final position
	
	
	var INITIAL_HOUR_TRANSFORM = NUMBER_OUTER_POSITION - 32;
	exports.INITIAL_HOUR_TRANSFORM = INITIAL_HOUR_TRANSFORM;
	var INITIAL_MINUTE_TRANSFORM = NUMBER_OUTER_POSITION + 28; // clock hand stuff
	
	exports.INITIAL_MINUTE_TRANSFORM = INITIAL_MINUTE_TRANSFORM;
	
	function getClockHandLength(mode, inner) {
	  if (mode !== MODE.HOURS_24) {
	    return NUMBER_OUTER_POSITION;
	  }
	
	  return inner ? NUMBER_INNER_POSITION_24_HOUR : NUMBER_OUTER_POSITION_24_HOUR;
	}
	
	function getClockHandCirclePosition(mode, inner) {
	  if (mode !== MODE.HOURS_24) {
	    return NUMBER_OUTER_POSITION;
	  }
	
	  return inner ? NUMBER_INNER_POSITION_24_HOUR : NUMBER_OUTER_POSITION_24_HOUR;
	}
	
	function getClockHandCircleRadius(mode, inner) {
	  if (mode !== MODE.HOURS_24) {
	    return NUMBER_RADIUS_REGULAR / 2;
	  }
	
	  return inner ? NUMBER_RADIUS_HOUR_24_INNER / 2 : NUMBER_RADIUS_HOUR_24_OUTER / 2;
	}
	
	var animationChange = 22;
	var INNER_NUMBER_POSITIONING = {
	  exit: NUMBER_INNER_POSITION_24_HOUR + animationChange,
	  enter: NUMBER_INNER_POSITION_24_HOUR
	};
	exports.INNER_NUMBER_POSITIONING = INNER_NUMBER_POSITIONING;

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APP_BAR = exports.APP_BAR = 'RTAppBar';
	var AUTOCOMPLETE = exports.AUTOCOMPLETE = 'RTAutocomplete';
	var AVATAR = exports.AVATAR = 'RTAvatar';
	var BUTTON = exports.BUTTON = 'RTButton';
	var CARD = exports.CARD = 'RTCard';
	var CHIP = exports.CHIP = 'RTChip';
	var CHECKBOX = exports.CHECKBOX = 'RTCheckbox';
	var DATE_PICKER = exports.DATE_PICKER = 'RTDatePicker';
	var DIALOG = exports.DIALOG = 'RTDialog';
	var DRAWER = exports.DRAWER = 'RTDrawer';
	var DROPDOWN = exports.DROPDOWN = 'RTDropdown';
	var INPUT = exports.INPUT = 'RTInput';
	var LAYOUT = exports.LAYOUT = 'RTLayout';
	var LINK = exports.LINK = 'RTLink';
	var LIST = exports.LIST = 'RTList';
	var MENU = exports.MENU = 'RTMenu';
	var NAVIGATION = exports.NAVIGATION = 'RTNavigation';
	var OVERLAY = exports.OVERLAY = 'RTOverlay';
	var PROGRESS_BAR = exports.PROGRESS_BAR = 'RTProgressBar';
	var RADIO = exports.RADIO = 'RTRadio';
	var RIPPLE = exports.RIPPLE = 'RTRipple';
	var SLIDER = exports.SLIDER = 'RTSlider';
	var SNACKBAR = exports.SNACKBAR = 'RTSnackbar';
	var SWITCH = exports.SWITCH = 'RTSwitch';
	var TABLE = exports.TABLE = 'RTTable';
	var TABS = exports.TABS = 'RTTabs';
	var TOOLTIP = exports.TOOLTIP = 'RTTooltip';
	var TIME_PICKER = exports.TIME_PICKER = 'RTTimePicker';

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _brandConfig = __webpack_require__(142);
	
	var styles = _brandConfig.isFlagler ? __webpack_require__(4919) : __webpack_require__(373);
	
	exports.default = styles;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(956);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * The only reason making this comp stateful is that it's impossible to use refs with stateless one
	 * https://github.com/facebook/react/issues/4936
	 * */
	/* eslint-disable react/prefer-stateless-function */
	var Content = function (_Component) {
	  (0, _inherits3.default)(Content, _Component);
	
	  function Content() {
	    (0, _classCallCheck3.default)(this, Content);
	    return (0, _possibleConstructorReturn3.default)(this, (Content.__proto__ || (0, _getPrototypeOf2.default)(Content)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Content, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.children !== nextProps.children;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          empty = _props.empty,
	          fullHeight = _props.fullHeight,
	          style = _props.style,
	          refLink = _props.refLink,
	          onScroll = _props.onScroll;
	
	      return _react2.default.createElement('div', (0, _extends3.default)({ children: children, className: className, style: style, ref: refLink, onScroll: onScroll }, {
	        styleName: (0, _classnames2.default)('content', { 'content--empty': empty }, { 'content--fullHeight': fullHeight })
	        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
	        , tabIndex: '0'
	      }));
	    }
	  }]);
	  return Content;
	}(_react.Component); /* eslint-disable react/require-default-props,react/destructuring-assignment,react/prop-types */
	
	
	Content.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string,
	  empty: _propTypes2.default.bool,
	  fullHeight: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  onScroll: _propTypes2.default.func
	};
	
	exports.default = (0, _reactCssModules2.default)(Content, _index2.default, { allowMultiple: true });

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AUTHENTICATION_TOKEN = exports.AUTHENTICATION_TOKEN = 'authenticationToken';
	var LOGGED_IN = exports.LOGGED_IN = 'loggedIn';
	var ACTIVE_COMMUNITY_ID = exports.ACTIVE_COMMUNITY_ID = 'active-community-id';
	var REQUEST_PASSWORD_UPDATE = exports.REQUEST_PASSWORD_UPDATE = 'requestPasswordUpdate';
	var REGISTRATION_COMPLETED = exports.REGISTRATION_COMPLETED = 'registrationCompleted';
	var REDIRECT_TO_PAGE = exports.REDIRECT_TO_PAGE = 'redirectToPage';
	var ROOM_INVITATION_TOKEN = exports.ROOM_INVITATION_TOKEN = 'roomInvitationToken';
	var PAPERWORK_TOKEN = exports.PAPERWORK_TOKEN = 'paperworkToken';
	var KICKED_TO_LOGIN = exports.KICKED_TO_LOGIN = '_kicked_to_login';

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDefaultBehavior = exports.actions = exports.consts = undefined;
	
	var _isInteger = __webpack_require__(4295);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _redux = __webpack_require__(98);
	
	var _redux2 = __webpack_require__(7);
	
	var _loggedUser = __webpack_require__(523);
	
	var _loggedUser2 = _interopRequireDefault(_loggedUser);
	
	var _teamUser = __webpack_require__(1884);
	
	var _teamUser2 = _interopRequireDefault(_teamUser);
	
	var _targetUser = __webpack_require__(415);
	
	var _targetUser2 = _interopRequireDefault(_targetUser);
	
	var _permissions = __webpack_require__(832);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux2.createConsts)('context', 'targetUser', 'SET_TARGET_USER_ID', 'CLEAR');
	var actions = exports.actions = (0, _redux2.createActions)(consts);
	
	var isDefaultBehavior = exports.isDefaultBehavior = function isDefaultBehavior(payload) {
	  return (0, _isInteger2.default)(payload) || payload === null;
	};
	
	var targetUserId = function targetUserId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.SET_TARGET_USER_ID:
	      return isDefaultBehavior(action.payload) ? action.payload : action.payload.id;
	    case consts.CLEAR:
	      return null;
	    default:
	      return state;
	  }
	};
	
	exports.default = (0, _redux.combineReducers)({
	  loggedUser: _loggedUser2.default,
	  teamUser: _teamUser2.default,
	  targetUser: _targetUser2.default,
	  permissions: _permissions2.default,
	  targetUserId: targetUserId
	});

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'appointment-status-change');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'appointments', 'virtual_visits', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'status_changes']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'edit-patient');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'patient_profiles',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _locationReducer = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'sidebar', 'TOGGLE_VISIBILITY', 'SET_DESKTOP_VISIBILITY');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  visible: false,
	  desktopVisible: true
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.TOGGLE_VISIBILITY:
	      return (0, _extends3.default)({}, state, {
	        visible: !state.visible
	      });
	    case consts.SET_DESKTOP_VISIBILITY:
	      return (0, _extends3.default)({}, state, {
	        desktopVisible: action.payload
	      });
	    case _locationReducer.LOCATION_CHANGE:
	    default:
	      return state;
	  }
	};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4345), __esModule: true };

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4351), __esModule: true };

/***/ }),
/* 222 */
99,
/* 223 */
[6573, 711, 447, 225, 274, 204, 2145, 124],
/* 224 */
[6576, 204, 146, 1435],
/* 225 */
[6592, 710, 271],
/* 226 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 227 */
474,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(42);
	
	var _routes = __webpack_require__(37);
	
	var _progressTypes = __webpack_require__(55);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useNavigateToPreviousPage = function useNavigateToPreviousPage() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var pathname = window.location.pathname;
	
	
	  var flowPages = (0, _reactRedux.useSelector)(_selectors.selectFlowPages);
	
	  var consentData = (0, _reactRedux.useSelector)(_selectors.selectConsentFormData);
	
	  var isAllConsentsSigned = (0, _get2.default)(consentData, 'allSigned');
	
	  var navigateToPrevPage = (0, _react.useCallback)(function () {
	    var navigatingPagePathname = flowPages.reduce(function (acc, curr, currentIndex, array) {
	      if (curr === pathname) {
	        // eslint-disable-next-line no-param-reassign
	        acc = array[currentIndex - 1] || null;
	      }
	      return acc;
	    }, null);
	
	    _reactRouter.browserHistory.replace(navigatingPagePathname);
	  }, [pathname, flowPages]);
	
	  (0, _react.useEffect)(function () {
	    if (isAllConsentsSigned) {
	      dispatch(_progressTypes.appointmentProgressActions.removeFlowPage(_routes.APPOINTMENT_FORM + '/' + _routes.APPOINTMENT_FORM_CONSENT_FORM));
	    }
	  }, [isAllConsentsSigned]);
	
	  return {
	    navigateToPrevPage: navigateToPrevPage
	  };
	};
	
	exports.default = useNavigateToPreviousPage;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(5028);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfoSection = function InfoSection(_ref) {
	  var entries = _ref.entries;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.entries },
	    entries.map(function (_ref2) {
	      var value = _ref2.value,
	          label = _ref2.label;
	      return _react2.default.createElement(
	        'div',
	        { key: label },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.entryTitle },
	          label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.entryValue },
	          value || _strings.DEFAULT_EMPTY_VALUE
	        )
	      );
	    })
	  );
	};
	
	InfoSection.propTypes = {
	  entries: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
	};
	
	exports.default = InfoSection;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _common = __webpack_require__(239);
	
	var useHandleGlobalPaperworkPending = function useHandleGlobalPaperworkPending(isFetching) {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    dispatch(_common.paperworkCommonActions.setGlobalPaperworkPending(isFetching));
	  }, [isFetching]);
	};
	
	exports.default = useHandleGlobalPaperworkPending;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeInitialValue = exports.adaptInitialValue = exports.adaptInitialValueCountry = exports.adaptInitialValueState = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _isObject = __webpack_require__(139);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adaptInitialValueState = exports.adaptInitialValueState = function adaptInitialValueState(stateName, listStates) {
	  if ((0, _isObject2.default)(stateName)) return stateName;
	  var targetState = listStates.find(function (_ref) {
	    var label = _ref.label;
	    return label === stateName;
	  });
	  var safeStateValue = stateName ? {
	    label: stateName,
	    value: stateName
	  } : null;
	  return stateName && listStates && targetState ? {
	    label: targetState.label,
	    value: targetState.value
	  } : safeStateValue;
	};
	
	var adaptInitialValueCountry = exports.adaptInitialValueCountry = function adaptInitialValueCountry(countryName, listCountry) {
	  if ((0, _isObject2.default)(countryName)) return countryName;
	  var targetCountry = listCountry.find(function (_ref2) {
	    var label = _ref2.label;
	    return label === countryName;
	  });
	  return countryName && listCountry && targetCountry ? {
	    label: targetCountry.label,
	    value: targetCountry.value
	  } : null;
	};
	
	var adaptInitialValue = exports.adaptInitialValue = function adaptInitialValue(stateValue, list) {
	  if ((0, _isObject2.default)(stateValue)) return stateValue;
	  var target = list.find(function (_ref3) {
	    var value = _ref3.value;
	    return value === stateValue;
	  });
	
	  return stateValue && list && target ? {
	    label: target.label,
	    value: target.value
	  } : null;
	};
	
	var makeInitialValue = exports.makeInitialValue = function makeInitialValue(data, countryList, stateList, isEirVisitType) {
	  var _ref4, _ref5;
	
	  var onlyCountryState = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  return onlyCountryState ? (_ref4 = {}, (0, _defineProperty3.default)(_ref4, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, adaptInitialValueCountry(data.country, countryList)), (0, _defineProperty3.default)(_ref4, _formFields.PROFILE_FIELDS_TYPES.STATE, adaptInitialValueState(data.state, stateList)), _ref4) : (_ref5 = {}, (0, _defineProperty3.default)(_ref5, _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE, data.homePhone), (0, _defineProperty3.default)(_ref5, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1, data.address1), (0, _defineProperty3.default)(_ref5, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2, data.address2), (0, _defineProperty3.default)(_ref5, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, adaptInitialValueCountry(data.country, countryList)), (0, _defineProperty3.default)(_ref5, _formFields.PROFILE_FIELDS_TYPES.CITY, data.city), (0, _defineProperty3.default)(_ref5, _formFields.PROFILE_FIELDS_TYPES.STATE, adaptInitialValueState(data.state, stateList)), (0, _defineProperty3.default)(_ref5, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, data.postalCode), _ref5);
	};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _class2, _temp, _initialiseProps; /* eslint-disable react/require-default-props,react/destructuring-assignment */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _date_picker = __webpack_require__(2836);
	
	var _date_picker2 = _interopRequireDefault(_date_picker);
	
	var _format = __webpack_require__(319);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _formatStringByPattern = __webpack_require__(5314);
	
	var _formatStringByPattern2 = _interopRequireDefault(_formatStringByPattern);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _strings = __webpack_require__(15);
	
	var _dateConverters = __webpack_require__(83);
	
	var _browserChecker = __webpack_require__(356);
	
	var _theme = __webpack_require__(1829);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEXT_INPUT_CASE = (0, _browserChecker.isIE)();
	var MASK_PATTERN = '99-99-9999';
	
	var DatePickerCustom = (0, _reactIntl.injectIntl)(_class = (_temp = _class2 = function (_Component) {
	  (0, _inherits3.default)(DatePickerCustom, _Component);
	
	  function DatePickerCustom(props) {
	    (0, _classCallCheck3.default)(this, DatePickerCustom);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DatePickerCustom.__proto__ || (0, _getPrototypeOf2.default)(DatePickerCustom)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var value = props.value;
	
	
	    _this.state = {
	      date: _this.convertToDate(value),
	      isActiveCalendar: false,
	      manualDate: _this.convertToManualDate(value),
	      withManualInputDobPickerOpen: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DatePickerCustom, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var value = this.props.value;
	
	
	      if (value !== prevProps.value) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          date: value
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          disabled = _props.disabled,
	          id = _props.id,
	          label = _props.label,
	          name = _props.name,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          style = _props.style,
	          onBlur = _props.onBlur,
	          formatMessage = _props.intl.formatMessage,
	          formatDate = _props.formatDate,
	          withManualInputDob = _props.withManualInputDob,
	          iconClassName = _props.iconClassName;
	
	
	      if (TEXT_INPUT_CASE) {
	        return _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({ className: className, disabled: disabled, id: id, label: label, name: name, onBlur: onBlur }, {
	          placeholder: formatMessage(_strings.DATE_PATTERN_UI),
	          onChange: this.handleChange,
	          value: this.state.date,
	          type: 'text',
	          rounded: true
	        }));
	      }
	
	      if (withManualInputDob) {
	        var dateFieldValue = this.state.manualDate || this.state.date && this.convertToManualDate(this.state.date);
	
	        return _react2.default.createElement(
	          _reactCssThemr.ThemeProvider,
	          { theme: _theme2.default },
	          _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _theme2.default.RTDatePicker.mainDobInput },
	              _react2.default.createElement(_TextInput2.default, {
	                disabled: disabled,
	                value: dateFieldValue,
	                className: _theme2.default.RTDatePicker.mainDobInput,
	                placeholder: label,
	                label: label,
	                type: 'text',
	                onFocus: this.handleFocus,
	                onChange: this.handleManualDateChange,
	                limit: 10
	              }),
	              _react2.default.createElement(_Icon2.default, {
	                size: 18,
	                name: 'icon-date',
	                disabled: disabled,
	                onClick: this.handleIconClick,
	                className: (0, _classnames2.default)(_theme2.default.RTDatePicker.calendarIcon, iconClassName, (0, _defineProperty3.default)({}, _theme2.default.RTDatePicker.disabledIcon, disabled))
	              })
	            ),
	            this.state.withManualInputDobPickerOpen && _react2.default.createElement(_date_picker2.default, (0, _extends3.default)({ id: id, name: name, maxDate: maxDate, minDate: minDate }, {
	              sundayFirstDayOfWeek: true,
	              inputClassName: className + ' datePicker ' + _theme2.default.RTDatePicker.absoluteInput,
	              inputFormat: function inputFormat(value) {
	                return (0, _format2.default)(value, formatDate || formatMessage(_strings.DATE_PATTERN_UI));
	              },
	              onChange: this.handleChange,
	              value: this.state.date,
	              readonly: disabled,
	              placeholder: label,
	              active: this.state.isActiveCalendar,
	              onDismiss: this.toggleCalendar,
	              style: { visibility: disabled ? 'hidden' : 'visible' }
	            }))
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _reactCssThemr.ThemeProvider,
	        { theme: _theme2.default },
	        _react2.default.createElement(_date_picker2.default, (0, _extends3.default)({ id: id, label: label, name: name, maxDate: maxDate, minDate: minDate, style: style }, {
	          sundayFirstDayOfWeek: true,
	          inputClassName: className + ' datePicker',
	          inputFormat: function inputFormat(value) {
	            return (0, _format2.default)(value, formatDate || formatMessage(_strings.DATE_PATTERN_UI));
	          },
	          onChange: this.handleChange,
	          value: this.state.date,
	          readonly: disabled,
	          placeholder: label
	        }))
	      );
	    }
	  }]);
	  return DatePickerCustom;
	}(_react.Component), _class2.propTypes = {
	  withManualInputDob: _propTypes2.default.bool,
	  formatDate: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	  maxDate: _propTypes2.default.instanceOf(Date),
	  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)]),
	  disabled: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  iconClassName: _propTypes2.default.string
	}, _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.convertToManualDate = function (value) {
	    if (!value) return null;
	
	    return (0, _format2.default)(value, _this2.props.formatDate || _this2.props.intl.formatMessage(_strings.DATE_PATTERN_UI));
	  };
	
	  this.applyMask = function (value) {
	    return (0, _formatStringByPattern2.default)(MASK_PATTERN, value);
	  };
	
	  this.triggerOnChange = function (maskedValue) {
	    if (typeof _this2.props.onChange === 'function') {
	      _this2.props.onChange(maskedValue);
	    }
	  };
	
	  this.handleChange = function (value) {
	    _this2.setState({
	      date: _this2.convertToDate(value),
	      manualDate: _this2.convertToManualDate(value)
	    });
	    _this2.toggleCalendar();
	
	    _this2.triggerOnChange(value);
	
	    // Safari 10 placeholder bug fix
	    var input = document.querySelector('.datePicker input');
	    if (input) {
	      setTimeout(function () {
	        input.value = input.value;
	      }, 0);
	    }
	  };
	
	  this.handleFocus = function () {
	    _this2.setState({ visibility: 'visible' });
	  };
	
	  this.convertToDate = function (value) {
	    var formatMessage = _this2.props.intl.formatMessage;
	
	
	    if (TEXT_INPUT_CASE) return value;
	
	    return typeof value === 'string' ? new Date((0, _dateConverters.convertDateToAPIFormat)(value, formatMessage)) : value;
	  };
	
	  this.handleIconClick = function () {
	    _this2.setState({
	      isActiveCalendar: true,
	      withManualInputDobPickerOpen: true
	    });
	  };
	
	  this.toggleCalendar = function () {
	    _this2.setState({
	      isActiveCalendar: false,
	      withManualInputDobPickerOpen: false
	    });
	  };
	
	  this.handleManualDateChange = function (value) {
	    var _props2 = _this2.props,
	        formatMessage = _props2.intl.formatMessage,
	        formatDate = _props2.formatDate;
	
	
	    var stateData = (0, _format2.default)(_this2.state.date, formatDate || formatMessage(_strings.DATE_PATTERN_UI));
	
	    var onlyNumbers = value.replace(/[^\d-]/g, '');
	
	    var maskedValue = _this2.applyMask(onlyNumbers);
	
	    if (onlyNumbers.length < stateData.length) {
	      _this2.setState({
	        manualDate: maskedValue
	      });
	
	      _this2.triggerOnChange(maskedValue);
	
	      return;
	    }
	
	    if (onlyNumbers.length === 10) {
	      _this2.setState({
	        date: _this2.convertToDate(maskedValue)
	      });
	
	      _this2.triggerOnChange(maskedValue);
	    }
	  };
	}, _temp)) || _class;
	
	exports.default = DatePickerCustom;

/***/ }),
/* 235 */,
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.channelsCountSelector = exports.defaultFirstContextUser = exports.defaultFirstActiveChannel = exports.subChannelsSelector = exports.defaultPatientIdSelector = exports.selectedChannelUserSelector = exports.selectedChannelSelector = exports.channelsSelector = exports.sortedChannelsSelector = exports.loadedNextPageSelector = exports.loadedFirstPageSelector = exports.loadedStateSelector = exports.loadingNextPageSelector = exports.loadingFirstPageSelector = exports.loadingStateSelector = exports.succeedSelector = exports.sendingSelector = exports.hasChannelsSelector = exports.totalChannelsSelector = exports.channelsListSelector = exports.reqChannelsSelector = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _selectors = __webpack_require__(79);
	
	var _settings = __webpack_require__(405);
	
	var _sorting = __webpack_require__(1936);
	
	var _sorting2 = _interopRequireDefault(_sorting);
	
	var _connectToChatData = __webpack_require__(3956);
	
	var _connectToChatData2 = _interopRequireDefault(_connectToChatData);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reqChannelsSelector = exports.reqChannelsSelector = function reqChannelsSelector(state) {
	  return state.board.reqChannels;
	};
	var channelsListSelector = exports.channelsListSelector = function channelsListSelector(state) {
	  return state.board.channels;
	};
	
	var totalChannelsSelector = exports.totalChannelsSelector = (0, _reselect.createSelector)(reqChannelsSelector, function (request) {
	  return (0, _get2.default)(request, 'meta.totalUsers', 0);
	});
	
	var hasChannelsSelector = exports.hasChannelsSelector = (0, _reselect.createSelector)(channelsListSelector, function (channels) {
	  return !!(0, _get2.default)(channels, 'length', 0);
	});
	
	var sendingSelector = exports.sendingSelector = (0, _reselect.createSelector)(reqChannelsSelector, function (request) {
	  return (0, _get2.default)(request, 'sending') || false;
	});
	
	var succeedSelector = exports.succeedSelector = (0, _reselect.createSelector)(reqChannelsSelector, function (request) {
	  return (0, _get2.default)(request, 'succeed') || false;
	});
	
	// loading states
	var loadingStateSelector = exports.loadingStateSelector = (0, _reselect.createSelector)(sendingSelector, succeedSelector, function (sending, succeed) {
	  return sending && !succeed;
	});
	
	var loadingFirstPageSelector = exports.loadingFirstPageSelector = (0, _reselect.createSelector)(loadingStateSelector, hasChannelsSelector, function (loading, hasChannels) {
	  return loading && !hasChannels;
	});
	
	var loadingNextPageSelector = exports.loadingNextPageSelector = (0, _reselect.createSelector)(loadingStateSelector, hasChannelsSelector, function (loading, hasChannels) {
	  return loading && hasChannels;
	});
	
	// loaded states
	var loadedStateSelector = exports.loadedStateSelector = (0, _reselect.createSelector)(sendingSelector, succeedSelector, function (sending, succeed) {
	  return sending && !succeed;
	});
	
	var loadedFirstPageSelector = exports.loadedFirstPageSelector = (0, _reselect.createSelector)(loadedStateSelector, hasChannelsSelector, function (loading, hasChannels) {
	  return loading && !hasChannels;
	});
	
	var loadedNextPageSelector = exports.loadedNextPageSelector = (0, _reselect.createSelector)(loadedStateSelector, hasChannelsSelector, function (loading, hasChannels) {
	  return loading && hasChannels;
	});
	
	// channels
	// Returns sorted by lastMessageAt key array:
	// [
	//   {
	//     contextUser: {},
	//     lastMessageAt: '2018-05-01T11:00:41.488066',
	//     subchannels: [{}, {}],
	//     totalUnreadCount: 2, // api-chat-differences handling
	//     unreadCount: 2, // api-chat-differences handling
	//   },
	// ]
	// *Connect to chat data takes api array and returns initial data +:
	// - if channel had any activity - chat unread / lastMessage data
	// - else - api data about unreads and lastMessage
	var sortedChannelsSelector = exports.sortedChannelsSelector = (0, _reselect.createSelector)(channelsListSelector, _selectors.joinedChannelsSelector, function (channels, joinedChannels) {
	  var connectedChannels = joinedChannels ? (0, _connectToChatData2.default)(channels, joinedChannels) : channels;
	
	  return (0, _sorting2.default)(connectedChannels, _props.LAST_MESSAGE_SORTING);
	});
	
	// temp for context only channels available
	var channelsSelector = exports.channelsSelector = (0, _reselect.createSelector)(channelsListSelector, function (channelsList) {
	  return channelsList.reduce(function (acc, channel) {
	    var contextUser = channel.contextUser;
	
	    var _ref = contextUser || {},
	        id = _ref.id;
	
	    acc[id] = channel;
	
	    return acc;
	  }, {});
	});
	
	var selectedChannelSelector = exports.selectedChannelSelector = (0, _reselect.createSelector)(channelsSelector, _settings.lastUserIdSelector, function (channels, id) {
	  return (0, _get2.default)(channels, id) || {};
	});
	
	var selectedChannelUserSelector = exports.selectedChannelUserSelector = (0, _reselect.createSelector)(selectedChannelSelector, function (channel) {
	  return (0, _get2.default)(channel, 'contextUser') || {};
	});
	
	// Default chat to connect
	var defaultPatientIdSelector = exports.defaultPatientIdSelector = (0, _reselect.createSelector)(sortedChannelsSelector, function (sortedChannels) {
	  // todo: manage chat without context
	  return (0, _get2.default)(sortedChannels, [0, 'contextUser', 'id'], null);
	});
	
	// Returns object with keys === patientId and values = object with keys === subchannelId
	// {
	//   1: { // patientId
	//     123: { // channelId
	//       channelId: 123,
	//       channelName: 'provider_circle',
	//       lastMessageAt: '2018-03-19T14:24:10.064000',
	//       totalUnreadCount: 0,
	//       type: 'system',
	//     },
	//     456: {
	//       channelId: 456,
	//       channelName: 'circles_circle',
	//       lastMessageAt: '2018-03-19T14:24:10.064000',
	//       totalUnreadCount: 2,
	//       type: 'system',
	//     },
	//     ...
	//   },
	//   ...
	// }
	var subChannelsSelector = exports.subChannelsSelector = (0, _reselect.createSelector)(channelsListSelector, function (channels) {
	  return channels.reduce(function (acc, channel) {
	    var subchannels = channel.subchannels,
	        contextChannel = channel.contextChannel,
	        contextUser = channel.contextUser;
	
	    // TODO: manage contextChannels connection
	    // if (contextChannel) {
	    // acc.push(contextChannel);
	    // }
	
	    if (subchannels) {
	      var _ref2 = contextUser || {},
	          id = _ref2.id;
	
	      acc[id] = subchannels.reduce(function (result, subchannel) {
	        var channelId = subchannel.channelId;
	        // eslint-disable-next-line no-param-reassign
	
	        result[channelId] = subchannel;
	
	        return result;
	      }, {});
	    }
	
	    return acc;
	  }, {});
	});
	
	var defaultFirstActiveChannel = exports.defaultFirstActiveChannel = (0, _reselect.createSelector)(sortedChannelsSelector, function (channels) {
	  var firstItem = (0, _get2.default)(channels[0], 'contextChannel', null);
	  if (firstItem) {
	    return (0, _get2.default)(firstItem, 'channelId');
	  }
	  return null;
	});
	
	var defaultFirstContextUser = exports.defaultFirstContextUser = (0, _reselect.createSelector)(sortedChannelsSelector, function (channels) {
	  var firstItem = (0, _get2.default)(channels[0], 'contextUser', null);
	  if (firstItem) {
	    return (0, _get2.default)(firstItem, 'id');
	  }
	  return null;
	});
	
	var channelsCountSelector = exports.channelsCountSelector = (0, _reselect.createSelector)(channelsListSelector, function (channels) {
	  return (0, _size2.default)(channels);
	});

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectCircleLoadingState = exports.selectProviderCircleList = exports.selectProviderCircleListPending = exports.selectCancelPendingInvitationReqError = exports.selectCancelPendingInvitationSucceed = exports.selectCancelFGuardianInvitationSucceed = exports.selectCancelGuardianInvitationError = exports.selectCancelCaregiverInvitationSucceed = exports.selectCancelCaregiverInvitationError = exports.selectCancelFamilyMemberInvitationSucceed = exports.selectCancelFamilyMemberInvitationError = exports.selectGuardianInvitationPending = exports.selectCaregiverInvitationPending = exports.selectFamilyInvitationPending = exports.selectDecilentGuardianInvite = exports.selectDecilentCaregiverInvite = exports.selectDecilentFamilyInvite = exports.sendingInviteToGuardianRoleSelector = exports.sendingInviteToCaregiverRoleSelector = exports.sendingInviteToFamilyCircleSelector = exports.removedContextUserIdSelector = exports.selectSucceedRemoveGuardian = exports.selectSucceedInviteCaregiverFamily = exports.selectRemoveGuardianRole = exports.selectRejectedFamilyCircleReq = exports.selectSucceedFamilyCircleReq = exports.selectRejectedChangeMemberRole = exports.selectSucceedChangeMemberRole = exports.selectChangeMemberRole = exports.selectRejectedLeaveFamilyCircle = exports.selectSucceedLeaveFamilyCircle = exports.selectLeaveFamilyCircle = exports.selectErrorInviteGuardian = exports.selectSucceedInviteGuardian = exports.selectInviteGuardianRole = exports.selectErrorInviteCaregiver = exports.selectSucceedInviteCaregiver = exports.selectInviteCaregiverRole = exports.selectRejectedInviteToFamilyCircle = exports.selectSucceedInviteToFamilyCircle = exports.selectErrorInviteToFamilyCircle = exports.selectInviteToFamilyCircle = exports.selectInviteCaregiverFamily = exports.selectCaregiverCirclePending = exports.selectCaregiverCircleList = exports.selectGuardianCircle = exports.acceptGuardianRoleSelector = exports.acceptCaregiverRoleSelector = exports.acceptInviteToFamilyCircleSelector = exports.removeProviderSelector = exports.selectCirclesState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	var _selectAdapter = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectCirclesState = exports.selectCirclesState = function selectCirclesState(state) {
	  return (0, _get2.default)(state, 'circles');
	};
	var getSelectors = (0, _selectAdapter.makeSelectorFactory)(selectCirclesState);
	
	var removeProviderSelector = exports.removeProviderSelector = function removeProviderSelector(state) {
	  return state.circles.removeAssignedProvider;
	};
	var acceptInviteToFamilyCircleSelector = exports.acceptInviteToFamilyCircleSelector = function acceptInviteToFamilyCircleSelector(state) {
	  return state.circles.acceptInviteToFamilyCircle;
	};
	var acceptCaregiverRoleSelector = exports.acceptCaregiverRoleSelector = function acceptCaregiverRoleSelector(state) {
	  return state.circles.acceptCaregiverRole;
	};
	var acceptGuardianRoleSelector = exports.acceptGuardianRoleSelector = function acceptGuardianRoleSelector(state) {
	  return state.circles.acceptGuardianRole;
	};
	var selectGuardianCircle = exports.selectGuardianCircle = function selectGuardianCircle(state) {
	  return (0, _get2.default)(state, 'circles.guardianCircle');
	};
	
	var _getSelectors = getSelectors('caregiver'),
	    selectCaregiverCircleList = _getSelectors.selectStateList,
	    selectCaregiverCirclePending = _getSelectors.selectStatePending;
	
	exports.selectCaregiverCircleList = selectCaregiverCircleList;
	exports.selectCaregiverCirclePending = selectCaregiverCirclePending;
	var selectInviteCaregiverFamily = exports.selectInviteCaregiverFamily = function selectInviteCaregiverFamily(state) {
	  return (0, _get2.default)(state, 'circles.inviteCaregiverFamily', {});
	};
	
	//= =================INVITE FAMILY CIRCLE==================
	
	var selectInviteToFamilyCircle = exports.selectInviteToFamilyCircle = function selectInviteToFamilyCircle(state) {
	  return (0, _get2.default)(state, 'circles.inviteToFamilyCircle', {});
	};
	
	var selectErrorInviteToFamilyCircle = exports.selectErrorInviteToFamilyCircle = (0, _reselect.createSelector)(selectInviteToFamilyCircle, function (state) {
	  return (0, _get2.default)(state, 'error', false);
	});
	
	var selectSucceedInviteToFamilyCircle = exports.selectSucceedInviteToFamilyCircle = (0, _reselect.createSelector)(selectInviteToFamilyCircle, function (state) {
	  return (0, _get2.default)(state, 'succeed', false);
	});
	
	var selectRejectedInviteToFamilyCircle = exports.selectRejectedInviteToFamilyCircle = (0, _reselect.createSelector)(selectInviteToFamilyCircle, function (state) {
	  return (0, _get2.default)(state, 'rejected', false);
	});
	
	//= =================INVITE CAREGIVER ROLE==================
	
	var selectInviteCaregiverRole = exports.selectInviteCaregiverRole = function selectInviteCaregiverRole(state) {
	  return (0, _get2.default)(state, 'circles.inviteCaregiver', {});
	};
	
	var selectSucceedInviteCaregiver = exports.selectSucceedInviteCaregiver = (0, _reselect.createSelector)(selectInviteCaregiverRole, function (request) {
	  return (0, _get2.default)(request, 'succeed', false);
	});
	
	var selectErrorInviteCaregiver = exports.selectErrorInviteCaregiver = (0, _reselect.createSelector)(selectInviteCaregiverRole, function (request) {
	  return (0, _get2.default)(request, 'error', false);
	});
	//= =================INVITE GUARDIAN ROLE===================
	
	var selectInviteGuardianRole = exports.selectInviteGuardianRole = function selectInviteGuardianRole(state) {
	  return (0, _get2.default)(state, 'circles.inviteGuardian', {});
	};
	
	var selectSucceedInviteGuardian = exports.selectSucceedInviteGuardian = (0, _reselect.createSelector)(selectInviteGuardianRole, function (state) {
	  return (0, _get2.default)(state, 'succeed', false);
	});
	
	var selectErrorInviteGuardian = exports.selectErrorInviteGuardian = (0, _reselect.createSelector)(selectInviteGuardianRole, function (state) {
	  return (0, _get2.default)(state, 'error', false);
	});
	
	//= =================LEAVE FAMILY CIRCLE===================
	
	var selectLeaveFamilyCircle = exports.selectLeaveFamilyCircle = function selectLeaveFamilyCircle(state) {
	  return (0, _get2.default)(state, 'circles.leaveFamilyCircle', {});
	};
	
	var selectSucceedLeaveFamilyCircle = exports.selectSucceedLeaveFamilyCircle = (0, _reselect.createSelector)(selectLeaveFamilyCircle, function (state) {
	  return (0, _get2.default)(state, 'succeed', false);
	});
	
	var selectRejectedLeaveFamilyCircle = exports.selectRejectedLeaveFamilyCircle = (0, _reselect.createSelector)(selectLeaveFamilyCircle, function (state) {
	  return (0, _get2.default)(state, 'rejected', false);
	});
	
	//= =================CHANGE ROLE===================
	
	var selectChangeMemberRole = exports.selectChangeMemberRole = function selectChangeMemberRole(state) {
	  return (0, _get2.default)(state, 'circles.changeMemberRole', {});
	};
	
	var selectSucceedChangeMemberRole = exports.selectSucceedChangeMemberRole = (0, _reselect.createSelector)(selectChangeMemberRole, function (state) {
	  return (0, _get2.default)(state, 'succeed', false);
	});
	
	var selectRejectedChangeMemberRole = exports.selectRejectedChangeMemberRole = (0, _reselect.createSelector)(selectChangeMemberRole, function (state) {
	  return (0, _get2.default)(state, 'rejected', false);
	});
	
	//= ========================================================
	
	var selectSucceedFamilyCircleReq = exports.selectSucceedFamilyCircleReq = (0, _reselect.createSelector)(selectSucceedInviteToFamilyCircle, selectSucceedLeaveFamilyCircle, selectSucceedChangeMemberRole, function (req, req1, req2) {
	  return req || req1 || req2;
	});
	
	var selectRejectedFamilyCircleReq = exports.selectRejectedFamilyCircleReq = (0, _reselect.createSelector)(selectRejectedInviteToFamilyCircle, selectRejectedLeaveFamilyCircle, selectRejectedChangeMemberRole, function (req, req1, req2) {
	  return req || req1 || req2;
	});
	
	var selectRemoveGuardianRole = exports.selectRemoveGuardianRole = function selectRemoveGuardianRole(state) {
	  return (0, _get2.default)(state, 'circles.removeGuardianRole', {});
	};
	
	var selectSucceedInviteCaregiverFamily = exports.selectSucceedInviteCaregiverFamily = (0, _reselect.createSelector)(selectInviteCaregiverFamily, function (request) {
	  return (0, _get2.default)(request, 'succeed', false);
	});
	
	var selectSucceedRemoveGuardian = exports.selectSucceedRemoveGuardian = (0, _reselect.createSelector)(selectRemoveGuardianRole, function (request) {
	  return (0, _get2.default)(request, 'succeed', false);
	});
	
	var removedContextUserIdSelector = exports.removedContextUserIdSelector = (0, _reselect.createSelector)(removeProviderSelector, function (request) {
	  return (0, _get2.default)(request, 'removedContextUserId', null);
	});
	
	var sendingInviteToFamilyCircleSelector = exports.sendingInviteToFamilyCircleSelector = (0, _reselect.createSelector)(acceptInviteToFamilyCircleSelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	var sendingInviteToCaregiverRoleSelector = exports.sendingInviteToCaregiverRoleSelector = (0, _reselect.createSelector)(acceptCaregiverRoleSelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	var sendingInviteToGuardianRoleSelector = exports.sendingInviteToGuardianRoleSelector = (0, _reselect.createSelector)(acceptGuardianRoleSelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	// DECLINE INVITATIONS
	
	var _getSelectors2 = getSelectors('declineInviteToFamilyCircle'),
	    selectDecilentFamilyInvite = _getSelectors2.selectStatePending;
	
	exports.selectDecilentFamilyInvite = selectDecilentFamilyInvite;
	
	var _getSelectors3 = getSelectors('declineCaregiverRole'),
	    selectDecilentCaregiverInvite = _getSelectors3.selectStatePending;
	
	exports.selectDecilentCaregiverInvite = selectDecilentCaregiverInvite;
	
	var _getSelectors4 = getSelectors('declineGuardianRole'),
	    selectDecilentGuardianInvite = _getSelectors4.selectStatePending;
	
	exports.selectDecilentGuardianInvite = selectDecilentGuardianInvite;
	var selectFamilyInvitationPending = exports.selectFamilyInvitationPending = (0, _reselect.createSelector)(selectDecilentFamilyInvite, sendingInviteToFamilyCircleSelector, function (declinePending, acceptPending) {
	  return declinePending || acceptPending;
	});
	var selectCaregiverInvitationPending = exports.selectCaregiverInvitationPending = (0, _reselect.createSelector)(selectDecilentCaregiverInvite, sendingInviteToCaregiverRoleSelector, function (declinePending, acceptPending) {
	  return declinePending || acceptPending;
	});
	var selectGuardianInvitationPending = exports.selectGuardianInvitationPending = (0, _reselect.createSelector)(selectDecilentGuardianInvite, sendingInviteToGuardianRoleSelector, function (declinePending, acceptPending) {
	  return declinePending || acceptPending;
	});
	
	var _getSelectors5 = getSelectors('cancelFamilyMemberInvitation'),
	    selectCancelFamilyMemberInvitationError = _getSelectors5.selectStateError,
	    selectCancelFamilyMemberInvitationSucceed = _getSelectors5.selectStateSucceed;
	
	exports.selectCancelFamilyMemberInvitationError = selectCancelFamilyMemberInvitationError;
	exports.selectCancelFamilyMemberInvitationSucceed = selectCancelFamilyMemberInvitationSucceed;
	
	var _getSelectors6 = getSelectors('cancelCaregiverInvitation'),
	    selectCancelCaregiverInvitationError = _getSelectors6.selectStateError,
	    selectCancelCaregiverInvitationSucceed = _getSelectors6.selectStateSucceed;
	
	exports.selectCancelCaregiverInvitationError = selectCancelCaregiverInvitationError;
	exports.selectCancelCaregiverInvitationSucceed = selectCancelCaregiverInvitationSucceed;
	
	var _getSelectors7 = getSelectors('cancelGuardianInvitation'),
	    selectCancelGuardianInvitationError = _getSelectors7.selectStateError,
	    selectCancelFGuardianInvitationSucceed = _getSelectors7.selectStateSucceed;
	
	exports.selectCancelGuardianInvitationError = selectCancelGuardianInvitationError;
	exports.selectCancelFGuardianInvitationSucceed = selectCancelFGuardianInvitationSucceed;
	var selectCancelPendingInvitationSucceed = exports.selectCancelPendingInvitationSucceed = (0, _reselect.createSelector)(selectCancelFamilyMemberInvitationSucceed, selectCancelCaregiverInvitationSucceed, selectCancelFGuardianInvitationSucceed, function (req, req1, req2) {
	  return req || req1 || req2;
	});
	
	var selectCancelPendingInvitationReqError = exports.selectCancelPendingInvitationReqError = (0, _reselect.createSelector)(selectCancelFamilyMemberInvitationError, selectCancelCaregiverInvitationError, selectCancelGuardianInvitationError, function (req, req1, req2) {
	  return req || req1 || req2;
	});
	
	// TODO
	
	var _getSelectors8 = getSelectors('memberProviderCircle'),
	    selectProviderCircleListPending = _getSelectors8.selectStatePending,
	    selectProviderCircleList = _getSelectors8.selectStateList;
	
	exports.selectProviderCircleListPending = selectProviderCircleListPending;
	exports.selectProviderCircleList = selectProviderCircleList;
	var selectCircleLoadingState = exports.selectCircleLoadingState = (0, _reselect.createSelector)(selectInviteGuardianRole, selectInviteToFamilyCircle, selectInviteCaregiverRole, selectChangeMemberRole, function () {
	  for (var _len = arguments.length, state = Array(_len), _key = 0; _key < _len; _key++) {
	    state[_key] = arguments[_key];
	  }
	
	  return state.some(function (_ref) {
	    var sending = _ref.sending;
	    return Boolean(sending);
	  });
	});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _effects = __webpack_require__(14);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'postDetails', ['CLEAR', 'EDIT', 'LIKE', 'DISLIKE', 'ADD_COMMENT', 'ADD_COMMENTS', 'DELETE_COMMENT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'posts', {
	    type: 'payload',
	    selector: ['postId']
	  }]
	});
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return _redux.initialState;
	    case consts.EDIT:
	      return (0, _assign2.default)({}, state, payload);
	    case consts.LIKE:
	      return (0, _assign2.default)({}, state, {
	        liked: true,
	        totalLikes: state.totalLikes + 1
	      });
	    case consts.DISLIKE:
	      return (0, _assign2.default)({}, state, {
	        liked: false,
	        totalLikes: state.totalLikes - 1
	      });
	    case consts.ADD_COMMENT:
	      return (0, _assign2.default)({}, state, {
	        totalComments: state.totalComments + 1
	      });
	    case consts.ADD_COMMENTS:
	      return (0, _assign2.default)({}, state, {
	        totalComments: state.totalComments + action.payload
	      });
	    case consts.DELETE_COMMENT:
	      return (0, _assign2.default)({}, state, {
	        totalComments: state.totalComments - 1
	      });
	    default:
	      return reqReducer(state, action);
	  }
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paperworkCommonActions = exports.PAPERWORK_COMMON_ACTION_TYPES = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var actionsScope = 'paperwork/common';
	
	var PAPERWORK_COMMON_ACTION_TYPES = exports.PAPERWORK_COMMON_ACTION_TYPES = {
	  GLOBAL_PAPERWORK_PENDING: actionsScope + '/global-paperwork-pending',
	  PAPERWORK_PAGE_INFO: actionsScope + '/page-info',
	  SET_PAPERWORK_CAME_FROM_SUBMIT_PAGE: actionsScope + '/set-paperwork-came-from-submit-page',
	  SET_PAPERWORK_INSURANCE_IS_PLAN_NOT_LISTED_SELECTED: actionsScope + '/set-paperwork-insurance-is-plan-not-listed-selected',
	  SET_PAPERWORK_ADDITIONAL_INFO_FORM_DATA: actionsScope + '/set-paperwork-additional-info-form-data',
	  GLOBAL_PAPERWORK_VALIDATING: actionsScope + '/global-paperwork-validating',
	  VALIDATE: actionsScope + '/validate',
	  DETERMINE_PAPERWORK_FLOW_ROUTES: actionsScope + '/determine-paperwork-flow-routes'
	};
	
	var paperworkCommonActions = exports.paperworkCommonActions = {
	  setGlobalPaperworkPending: (0, _createAction.createAction)(PAPERWORK_COMMON_ACTION_TYPES.GLOBAL_PAPERWORK_PENDING),
	  setPaperworkPageInfo: (0, _createAction.createAction)(PAPERWORK_COMMON_ACTION_TYPES.PAPERWORK_PAGE_INFO),
	  setPaperworkCameFromSubmitPage: (0, _createAction.createAction)(PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_CAME_FROM_SUBMIT_PAGE),
	  setPaperworkInsuranceIsPlanNotListedSelected: (0, _createAction.createAction)(PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_INSURANCE_IS_PLAN_NOT_LISTED_SELECTED),
	  setPaperworkAdditionalInfoFormData: (0, _createAction.createAction)(PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_ADDITIONAL_INFO_FORM_DATA),
	
	  setGlobalPaperworkValidating: (0, _createAction.createAction)(PAPERWORK_COMMON_ACTION_TYPES.GLOBAL_PAPERWORK_VALIDATING),
	  validate: (0, _createAction.createAction)(PAPERWORK_COMMON_ACTION_TYPES.VALIDATE),
	  determinePaperworkFlowRoutes: (0, _createAction.createAction)(PAPERWORK_COMMON_ACTION_TYPES.DETERMINE_PAPERWORK_FLOW_ROUTES)
	};

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  sending: false,
	  succeed: null,
	  rejected: null,
	  error: null
	};
	
	var locationReducer = function locationReducer(reducer) {
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var type = action.type;
	
	    switch (type) {
	      case LOCATION_CHANGE:
	        {
	          return initialState;
	        }
	      default:
	        {
	          return reducer(state, action);
	        }
	    }
	  };
	};
	
	exports.default = locationReducer;

/***/ }),
/* 241 */
[6571, 267, 2119, 1414, 268],
/* 242 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 243 */
[6550, 171],
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(95);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"cdc725d9","outerContainer":"c8ad6116","secondaryToolbar":"_20c1f7cd","doorHangerRight":"_76152d60","toolbarContainer":"da824c26","toolbarViewerMiddle":"_59ff2de4","progressBar":"_3d3deba4","back-to-application":"d1e417ef","root":"cf25d065","preview":"ffee04d6","wrapper":"_0733b006","content":"_6e452f02","sidebar":"_7dce677a","sidebar__content":"_26ef4416","activity":"_5cb16f99","header":"_843af5a9","banner":"_896abe3b","banner--blurred":"_1c126787","logo":"f94fad1b","logo--offset":"bc00632f","heading":"_1ffc63ac","heading__image":"_72aa0e2e","heading__image-title":"bd879d13","heading__image-subtitle":"_650951d9","heading__content":"_4c152e27","heading__title":"_00bf9b60","title__name":"aa13d96a","title__sub":"_0a024b58","title__desc":"f26efcfd","section-title":"_7ef54530","posts":"_1028e1e1","posts--empty":"_92ba463c","subtitle":"_84ad8a97","posts__list":"f91971ad","heading--clipped":"_1de4f9f2","heading__action":"_7af2274a","newPostBtn":"_1c7c6570","popup":"_60aebccb","popup-title":"_25914717","popup-subtitle":"bb1e866d","popup-subtitle--primary":"e4230eba","imageProcessing":"_25c3bdf9","heading--offset":"_4846b28a","backToTopBtn":"_43c4a14a"};

/***/ }),
/* 246 */
[6804, 2333],
/* 247 */
[6817, 731, 1557],
/* 248 */
[6842, 321, 1547, 227],
/* 249 */
[6824, 2309, 1536, 247],
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Popover = __webpack_require__(5593);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Popover).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(5671);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(5670);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(2396);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(735);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ }),
/* 252 */
228,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _props = __webpack_require__(41);
	
	var _index = __webpack_require__(2246);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var defaultClassName = 'bsw2-1';
	var Drawer = function Drawer(_ref) {
	  var _classNames;
	
	  var children = _ref.children,
	      className = _ref.className,
	      opened = _ref.opened,
	      position = _ref.position,
	      scrollable = _ref.scrollable,
	      style = _ref.style,
	      width = _ref.width,
	      zIndex = _ref.zIndex;
	  return _react2.default.createElement('aside', (0, _extends3.default)({ children: children }, {
	    className: (0, _classnames2.default)(defaultClassName, className),
	    styleName: (0, _classnames2.default)('root', (_classNames = {}, (0, _defineProperty3.default)(_classNames, 'root--' + position, position), (0, _defineProperty3.default)(_classNames, 'root--closed', !opened), (0, _defineProperty3.default)(_classNames, 'root--fixed', !scrollable), _classNames)),
	    style: (0, _assign2.default)({}, { width: width, zIndex: zIndex }, style)
	    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
	    , tabIndex: '0'
	  }));
	};
	
	Drawer.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string,
	  opened: _propTypes2.default.bool,
	  position: _propTypes2.default.oneOf(_props.PROPS_LIST.drawer.position),
	  scrollable: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  width: _propTypes2.default.number,
	  zIndex: _propTypes2.default.number
	};
	
	Drawer.defaultProps = {
	  opened: true,
	  position: 'left',
	  scrollable: true,
	  width: 300,
	  zIndex: 1
	};
	
	exports.default = (0, _reactCssModules2.default)(Drawer, _index2.default, { allowMultiple: true });

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCompleted = undefined;
	exports.printListTitle = printListTitle;
	exports.getSurveyEmptyBlockData = getSurveyEmptyBlockData;
	exports.getFirstName = getFirstName;
	exports.getFullName = getFullName;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _head = __webpack_require__(378);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _props = __webpack_require__(41);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function printListTitle(_ref) {
	  var upcomingCounter = _ref.upcomingCounter,
	      formatMessage = _ref.formatMessage,
	      upcomingTab = _ref.upcomingTab,
	      completedTab = _ref.completedTab,
	      historyAvailable = _ref.historyAvailable;
	
	  if (upcomingCounter === 0 && historyAvailable) {
	    return {
	      text: formatMessage({ id: 'healthboard.action.seeCompleted' }),
	      tab: completedTab
	    };
	  }
	  if (upcomingCounter > 3 || historyAvailable) {
	    return {
	      text: formatMessage({ id: 'communities.title.seeAll' }),
	      tab: upcomingTab
	    };
	  }
	
	  return {};
	}
	
	function getSurveyEmptyBlockData(dependentStatus, upcomingCounter, completedCounter, formatMessage) {
	  if (dependentStatus === _props.DEPENDENT_STATUSES.PENDING) {
	    return {
	      title: formatMessage({ id: 'healthboard.title.dependentPending' }),
	      text: formatMessage({ id: 'healthboard.text.dependentPending' }),
	      icon: 'pending'
	    };
	  }
	  if (dependentStatus === _props.DEPENDENT_STATUSES.UNVERIFIED) {
	    return {
	      title: formatMessage({ id: 'healthboard.title.dependentUnverified' }),
	      text: formatMessage({ id: 'healthboard.text.dependentUnverified' }),
	      icon: 'unverified'
	    };
	  }
	  if (upcomingCounter === 0 && completedCounter === 0) {
	    return {
	      title: formatMessage({ id: 'healthboard.title.surveysEmpty' }),
	      text: formatMessage({ id: 'healthboard.text.surveysEmpty' }),
	      icon: 'up-surveys'
	    };
	  }
	
	  if (upcomingCounter === 0 && completedCounter > 0) {
	    return {
	      title: formatMessage({ id: 'healthboard.title.surveysCompleted' }),
	      text: formatMessage({ id: 'healthboard.text.surveysCompleted' }),
	      icon: 'up-surveys'
	    };
	  }
	}
	
	function getFirstName(targetUser) {
	  var displayableName = (0, _get2.default)(targetUser, 'displayableName') || '';
	  var firstName = (0, _head2.default)(displayableName.split(' '));
	
	  return firstName ? firstName + '\'s' : '';
	}
	
	function getFullName() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      username = _ref2.username,
	      firstName = _ref2.firstName,
	      lastName = _ref2.lastName;
	
	  if (!firstName && !lastName) {
	    return '' + username;
	  }
	
	  return firstName + ' ' + lastName;
	}
	
	var isCompleted = exports.isCompleted = function isCompleted(status) {
	  return status === _constants.TODO_STATUSES.COMPLETED;
	};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeCustomTabs = exports.CommonTabs = exports.TabsImpl = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _materialUi = __webpack_require__(5648);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppBar = __webpack_require__(2360);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _Tabs = __webpack_require__(2383);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Tab = __webpack_require__(992);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _styles = __webpack_require__(18);
	
	var _materialStyles = __webpack_require__(3844);
	
	var _materialStyles2 = _interopRequireDefault(_materialStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabsImpl = exports.TabsImpl = function TabsImpl(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      classes = _ref.classes,
	      activeTab = _ref.activeTab,
	      onTabSelect = _ref.onTabSelect,
	      tabList = _ref.tabList,
	      renderContent = _ref.renderContent,
	      renderHeader = _ref.renderHeader,
	      className = _ref.className,
	      scrollable = _ref.scrollable,
	      scrollButtons = _ref.scrollButtons;
	
	  var handleTabChange = function handleTabChange(e, value) {
	    if (value !== activeTab) {
	      onTabSelect(value);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      _AppBar2.default,
	      { position: 'static', color: 'default', className: classes.appBar },
	      _react2.default.createElement(
	        _Tabs2.default,
	        {
	          indicatorColor: _styles.COLORS.bluePrimary,
	          onChange: handleTabChange,
	          value: activeTab,
	          scrollable: scrollable,
	          scrollButtons: scrollButtons
	        },
	        tabList.map(function (_ref2) {
	          var id = _ref2.id,
	              counter = _ref2.counter,
	              tabLabel = _ref2.label,
	              tabValue = _ref2.tab;
	
	          var text = formatMessage({ id: tabLabel });
	          var label = typeof counter === 'number' ? text + ' (' + counter + ')' : text;
	
	          return _react2.default.createElement(_Tab2.default, {
	            id: id,
	            label: label,
	            key: id,
	            value: tabValue,
	            classes: {
	              root: classes.root,
	              label: classes.label,
	              rootInheritSelected: classes.tabSelected,
	              labelContainer: classes.labelContainer
	            }
	          });
	        })
	      ),
	      renderHeader()
	    ),
	    renderContent(activeTab)
	  );
	};
	
	var propTypes = {
	  activeTab: _propTypes2.default.string,
	  tabList: _propTypes2.default.array,
	  renderContent: _propTypes2.default.func,
	  renderHeader: _propTypes2.default.func,
	  onTabSelect: _propTypes2.default.func,
	  scrollable: _propTypes2.default.bool
	};
	
	var CommonTabs = exports.CommonTabs = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _materialUi.withStyles)(_materialStyles2.default))(TabsImpl);
	
	var makeCustomTabs = exports.makeCustomTabs = function makeCustomTabs(styles) {
	  return (0, _recompose.compose)(_reactIntl.injectIntl, (0, _materialUi.withStyles)(styles))(TabsImpl);
	};
	
	TabsImpl.propTypes = (0, _extends3.default)({}, propTypes);
	TabsImpl.defaultProps = {
	  tabList: [],
	  renderContent: function renderContent() {},
	  renderHeader: function renderHeader() {},
	  onTabSelect: function onTabSelect() {}
	};
	_Tabs2.default.propTypes = propTypes;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Controls = __webpack_require__(333);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _ControlsItem = __webpack_require__(394);
	
	var _ControlsItem2 = _interopRequireDefault(_ControlsItem);
	
	var _drawer = __webpack_require__(185);
	
	var _sidebar = __webpack_require__(219);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5213);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * TODO: replace icon transform with initialy rotated icon
	 */
	
	/* eslint-disable react/prop-types,react/require-default-props,no-unused-expressions */
	var MobileNavbar = function MobileNavbar(_ref) {
	  var children = _ref.children,
	      drawerToggler = _ref.drawerToggler,
	      sidebarToggler = _ref.sidebarToggler,
	      location = _ref.location,
	      toggleDrawerVisibility = _ref.toggleDrawerVisibility,
	      toggleSidebarVisibility = _ref.toggleSidebarVisibility,
	      openContext = _ref.openContext,
	      toggleContext = _ref.toggleContext,
	      handleChange = _ref.handleChange,
	      onClickInfo = _ref.onClickInfo,
	      onClickEdit = _ref.onClickEdit;
	
	  var iconStyle = {
	    fill: _styles.COLORS.white,
	    stroke: _styles.COLORS.white
	  };
	
	  var userStyle = {
	    display: 'flex',
	    justifyContent: 'space-between',
	    alignItems: 'center',
	    width: '100%',
	    paddingRight: '10px'
	  };
	
	  return _react2.default.createElement(
	    _Controls2.default,
	    { styleName: 'root', className: 'pa2' },
	    drawerToggler ? _react2.default.createElement(
	      _ControlsItem2.default,
	      { fixed: true },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          icon: true,
	          onClick: function onClick() {
	            return location ? _reactRouter.browserHistory.push(location) : toggleDrawerVisibility();
	          }
	        },
	        _react2.default.createElement(_Icon2.default, {
	          name: drawerToggler,
	          style: (0, _extends3.default)({}, iconStyle, { transform: 'rotate(90deg)' })
	        })
	      )
	    ) : null,
	    openContext ? _react2.default.createElement(
	      _ControlsItem2.default,
	      { fixed: true },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          icon: true,
	          onClick: function onClick() {
	            toggleContext ? toggleContext() : toggleDrawerVisibility();
	            handleChange && handleChange();
	          }
	        },
	        _react2.default.createElement(_Icon2.default, {
	          name: openContext,
	          style: (0, _extends3.default)({}, iconStyle, { transform: 'rotate(90deg)' })
	        })
	      )
	    ) : null,
	    children ? _react2.default.createElement(
	      _ControlsItem2.default,
	      null,
	      sidebarToggler ? _react2.default.createElement(
	        _ClickableElement2.default,
	        {
	          onClick: function onClick() {
	            return toggleSidebarVisibility();
	          },
	          style: userStyle
	        },
	        children
	      ) : children
	    ) : null,
	    _react2.default.createElement(
	      'div',
	      { className: 'flex' },
	      onClickEdit && _react2.default.createElement(_Icon2.default, {
	        name: 'edit',
	        style: { fill: _styles.COLORS.white },
	        size: 20,
	        onClick: onClickEdit
	      }),
	      onClickInfo && _react2.default.createElement(_Icon2.default, {
	        name: 'info',
	        style: (0, _extends3.default)({}, iconStyle),
	        size: 24,
	        onClick: onClickInfo,
	        className: 'ml2'
	      })
	    )
	  );
	};
	
	MobileNavbar.propTypes = {
	  children: _propTypes2.default.node,
	  drawerToggler: _propTypes2.default.string,
	  sidebarToggler: _propTypes2.default.bool,
	  toggleDrawerVisibility: _propTypes2.default.func,
	  toggleSidebarVisibility: _propTypes2.default.func,
	  openContext: _propTypes2.default.string,
	  toggleContext: _propTypes2.default.func,
	  handleChange: _propTypes2.default.func
	};
	
	var mapDispatchToProps = {
	  toggleDrawerVisibility: _drawer.actions.toggleVisibility,
	  toggleSidebarVisibility: _sidebar.actions.toggleVisibility
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactCssModules2.default)(MobileNavbar, _index2.default, { allowMultiple: true }));

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _RadioInput = __webpack_require__(1193);
	
	var _RadioInput2 = _interopRequireDefault(_RadioInput);
	
	var _index = __webpack_require__(5231);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SingleSelect = function SingleSelect(_ref) {
	  var name = _ref.name,
	      list = _ref.list,
	      _onChange = _ref.onChange,
	      selectClass = _ref.selectClass,
	      selectedValue = _ref.selectedValue,
	      radioInputClass = _ref.radioInputClass,
	      renderContentAfterItem = _ref.renderContentAfterItem;
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', className: selectClass },
	    list.map(function (item, index) {
	      return _react2.default.createElement(
	        'div',
	        {
	          styleName: 'item',
	          key: name + '-' + index,
	          className: radioInputClass
	        },
	        _react2.default.createElement(_RadioInput2.default, {
	          id: name + '-' + index,
	          label: item.label || item,
	          value: item.value || item,
	          name: name,
	          checked: item.value === selectedValue || item === selectedValue,
	          onChange: function onChange() {
	            return _onChange(item.value || item);
	          }
	        }),
	        renderContentAfterItem && renderContentAfterItem(item)
	      );
	    })
	  );
	}; /* eslint-disable react/require-default-props,react/no-array-index-key */
	
	
	SingleSelect.propTypes = {
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  list: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])).isRequired,
	  selectedValue: _propTypes2.default.string,
	  selectClass: _propTypes2.default.string,
	  radioInputClass: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  renderContentAfterItem: _propTypes2.default.func
	};
	
	SingleSelect.defaultProps = {
	  onChange: function onChange() {}
	};
	
	exports.default = (0, _reactCssModules2.default)(SingleSelect, _index2.default, { allowMultiple: true });

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var APOSTROPHE = exports.APOSTROPHE = '\x27';
	var COMMERCIAL_AT = exports.COMMERCIAL_AT = '\x40';
	var DASH = exports.DASH = '\u2013';
	var EXCLAMATION_MARK = exports.EXCLAMATION_MARK = '\x21';
	var NBSP = exports.NBSP = '\xa0';
	var SPACE = exports.SPACE = '\x20';
	var NBSPACE = exports.NBSPACE = ' ';
	var BULL = exports.BULL = '\u2022';

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _checkInAppointmentReq = __webpack_require__(533);
	
	var checkInReq = _interopRequireWildcard(_checkInAppointmentReq);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var statusChangesReq = _interopRequireWildcard(_statusChangeReq);
	
	var _paymentVerificationsReq = __webpack_require__(419);
	
	var paymentVerification = _interopRequireWildcard(_paymentVerificationsReq);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var cancelOfficeVisitReq = _interopRequireWildcard(_cancelAppointmentReq);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var _appointmentAccountFormPaymentReq = __webpack_require__(339);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointmnents', 'details');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts, true);
	
	exports.default = function (state, action) {
	  switch (action.type) {
	    case checkInReq.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: (0, _extends3.default)({}, state.data, {
	            status: action.payload.status,
	            allowedActions: action.payload.allowedActions
	          })
	        });
	      }
	
	    case paymentVerification.consts.SUCCEED:
	    case _appointmentAccountFormPaymentReq.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: action.payload.payable
	        });
	      }
	
	    case statusChangesReq.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: (0, _extends3.default)({}, state.data, {
	            status: action.payload.status,
	            allowedActions: action.payload.allowedActions
	          })
	        });
	      }
	
	    case _signAppointmentConsentReq.consts.SUCCEED:
	      {
	        if (state.data && state.data.consentsAssignment) {
	          var allConsents = state.data.consentsAssignment.consents || [];
	          var targetConsent = allConsents.length > 0 ? allConsents.filter(function (consent) {
	            return consent.id === action.payload.appointmentConsentId;
	          }) : [];
	          if (targetConsent && targetConsent[0]) {
	            targetConsent[0].accepted = true;
	          }
	          return (0, _extends3.default)({}, state, {
	            data: (0, _extends3.default)({}, state.data, {
	              consentsAssignment: (0, _extends3.default)({}, state.data.consentsAssignment, {
	                consents: (0, _arrayModify.findAndReplace)(allConsents, (0, _extends3.default)({}, targetConsent[0]))
	              })
	            })
	          });
	        }
	        return (0, _extends3.default)({}, state);
	      }
	
	    case cancelOfficeVisitReq.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: (0, _extends3.default)({}, state.data, {
	            status: action.payload.status,
	            allowedActions: action.payload.allowedActions
	          })
	        });
	      }
	
	    case _upcomingSurveyCompletions.consts.SUCCEED:
	      {
	        if (state.data) {
	          var userAppointmentId = action.payload.userAppointment ? action.payload.userAppointment.id : null;
	          var targetAppointment = userAppointmentId === state.data.id;
	
	          if (!targetAppointment) return state;
	
	          var handleReplaceItem = function handleReplaceItem(allItem, item) {
	            if (item) {
	              var index = allItem.findIndex(function (_ref) {
	                var assignmentId = _ref.assignmentId;
	
	                return item.assignmentId === assignmentId;
	              });
	              allItem.splice(index, 1, item);
	              return allItem;
	            }
	          };
	
	          return (0, _extends3.default)({}, state, {
	            data: (0, _extends3.default)({}, state.data, {
	              surveyAssignments: handleReplaceItem(state.data.surveyAssignments, action.payload)
	            })
	          });
	        }
	
	        return state;
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['SET_AVAILABLE_FILTERS', 'SET_TYPE', 'SET_PROGRAM_VALUE', 'SET_STATUS', 'SET_SEARCH_QUERY', 'CLEAR', 'RESTORE'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['board', 'filters'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	// init
	var initialState = exports.initialState = {
	  availableFilters: [],
	  type: null,
	  programValue: _props.PROGRAM_VALUE_TYPES.all,
	  status: _props.STATUS_FILTER_TYPES.all,
	  searchQuery: null
	};
	
	// persistence
	var getPersistedState = function getPersistedState() {
	  var storedUser = window.storage.getItem('user'); // eslint-disable-line jsx-control-statements/jsx-jcs-no-undef
	
	  var _ref = storedUser ? JSON.parse(storedUser) : {},
	      id = _ref.id;
	
	  if (id) {
	    var persistedState = window.storage.getItem('board-filters-' + id); // eslint-disable-line jsx-control-statements/jsx-jcs-no-undef
	    var state = persistedState ? JSON.parse(persistedState) : initialState;
	
	    return (0, _extends3.default)({}, initialState, state, {
	      availableFilters: [],
	      searchQuery: null
	    });
	  }
	
	  return initialState;
	};
	
	// reducer
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SET_AVAILABLE_FILTERS:
	      return (0, _extends3.default)({}, state, { availableFilters: payload });
	    case consts.SET_TYPE:
	      return (0, _extends3.default)({}, state, { type: payload });
	    case consts.SET_PROGRAM_VALUE:
	      return (0, _extends3.default)({}, state, { programValue: payload });
	    case consts.SET_STATUS:
	      return (0, _extends3.default)({}, state, { status: payload });
	    case consts.SET_SEARCH_QUERY:
	      return (0, _extends3.default)({}, state, { searchQuery: payload });
	    case consts.CLEAR:
	      return initialState;
	    case consts.RESTORE:
	      return getPersistedState();
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appointmentConsentsModalActions = exports.APPOINTMENT_CONSENTS_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'healthboard/appointment-consents-modal'; // ToDo Rollback!
	var APPOINTMENT_CONSENTS_MODAL = exports.APPOINTMENT_CONSENTS_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var appointmentConsentsModalActions = exports.appointmentConsentsModalActions = {
	  open: (0, _createAction.createAction)(APPOINTMENT_CONSENTS_MODAL.OPEN),
	  close: (0, _createAction.createAction)(APPOINTMENT_CONSENTS_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  organizationName: '',
	  serviceName: '',
	  startTime: '',
	  allConsents: [],
	  consent: {},
	  isMainConsentView: false,
	  urgentVisitFlow: false,
	  selfSchedulingFlow: false,
	  patientUserInfoId: null,
	  rescheduleFlow: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case APPOINTMENT_CONSENTS_MODAL.OPEN:
	      {
	        var consent = payload.consent,
	            allConsents = payload.allConsents,
	            organizationName = payload.organizationName,
	            serviceName = payload.serviceName,
	            startTime = payload.startTime,
	            isMainConsentView = payload.isMainConsentView,
	            patientUserInfoId = payload.patientUserInfoId,
	            urgentVisitFlow = payload.urgentVisitFlow,
	            selfSchedulingFlow = payload.selfSchedulingFlow,
	            rescheduleFlow = payload.rescheduleFlow;
	
	        return (0, _extends3.default)({}, state, {
	          consent: consent,
	          allConsents: allConsents,
	          organizationName: organizationName,
	          serviceName: serviceName,
	          startTime: startTime,
	          isMainConsentView: isMainConsentView,
	          patientUserInfoId: patientUserInfoId
	        }, urgentVisitFlow && { urgentVisitFlow: urgentVisitFlow }, selfSchedulingFlow && { selfSchedulingFlow: selfSchedulingFlow }, rescheduleFlow && { rescheduleFlow: rescheduleFlow }, {
	          opened: true
	        });
	      }
	
	    case APPOINTMENT_CONSENTS_MODAL.CLOSE:
	      {
	        return initialState;
	      }
	
	    case _signAppointmentConsentReq.consts.SUCCEED:
	      {
	        var targetConsent = state.allConsents.find(function (_ref2) {
	          var id = _ref2.id;
	          return payload.appointmentConsentId === id;
	        });
	        return (0, _extends3.default)({}, state, {
	          consent: (0, _extends3.default)({}, state.consent, {
	            accepted: true
	          }),
	          allConsents: (0, _arrayModify.findAndReplace)(state.allConsents, (0, _extends3.default)({}, targetConsent, {
	            accepted: true
	          }))
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'manage-pending-request');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'status_changes']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectAccountVaultsListLoading = exports.selectAccountVaultsList = exports.selectAccountVaultsState = exports.selectPaymentInfoModalPayaFormURL = exports.selectPaymentInfoModalFormLoading = exports.selectPaymentInfoModalMainUserId = exports.selectPaymentInfoModalUserId = exports.selectPaymentInfoModalToDoId = exports.selectPaymentInfoModalPrepayFlow = exports.selectPaymentInfoModalPurchaseAgain = exports.selectPaymentInfoModalInvitationId = exports.selectPaymentInfoModalWaitingPayaResponse = exports.selectPaymentInfoModalDuePaymentDate = exports.selectPaymentInfoModalProgramName = exports.selectPaymentInfoModalOrganizationId = exports.selectPaymentInfoModalProgramId = exports.selectPaymentInfoModalSubscriptionsSetting = exports.selectPaymentInfoModalOpen = exports.selectPaymentInfoModalState = exports.availableProgramsListSelector = exports.joinedProgramsSendingSelector = exports.joinedProgramsMetaSelector = exports.joinedProgramsListSelector = exports.availableProgramsSelector = exports.joinedProgramsSelector = exports.programsSelector = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var programsSelector = exports.programsSelector = function programsSelector(state) {
	  return state.programs;
	};
	var joinedProgramsSelector = exports.joinedProgramsSelector = function joinedProgramsSelector(state) {
	  return state.programs.joinedPrograms;
	};
	var availableProgramsSelector = exports.availableProgramsSelector = function availableProgramsSelector(state) {
	  return state.programs.availablePrograms;
	};
	
	var joinedProgramsListSelector = exports.joinedProgramsListSelector = (0, _reselect.createSelector)(joinedProgramsSelector, function (programs) {
	  return (0, _get2.default)(programs, 'list', []);
	});
	
	var joinedProgramsMetaSelector = exports.joinedProgramsMetaSelector = (0, _reselect.createSelector)(joinedProgramsSelector, function (programs) {
	  return (0, _get2.default)(programs, 'meta', {});
	});
	
	var joinedProgramsSendingSelector = exports.joinedProgramsSendingSelector = (0, _reselect.createSelector)(joinedProgramsSelector, function (programs) {
	  return (0, _get2.default)(programs, 'sending');
	});
	
	var availableProgramsListSelector = exports.availableProgramsListSelector = (0, _reselect.createSelector)(availableProgramsSelector, function (programs) {
	  return (0, _get2.default)(programs, 'list');
	});
	
	var selectPaymentInfoModalState = exports.selectPaymentInfoModalState = (0, _reselect.createSelector)(programsSelector, function (state) {
	  return (0, _get2.default)(state, 'paymentInfoModal');
	});
	
	var selectPaymentInfoModalOpen = exports.selectPaymentInfoModalOpen = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'opened', false);
	});
	
	var selectPaymentInfoModalSubscriptionsSetting = exports.selectPaymentInfoModalSubscriptionsSetting = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'subscriptionsSetting', {});
	});
	
	var selectPaymentInfoModalProgramId = exports.selectPaymentInfoModalProgramId = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'programId', null);
	});
	
	var selectPaymentInfoModalOrganizationId = exports.selectPaymentInfoModalOrganizationId = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'organizationId', null);
	});
	
	var selectPaymentInfoModalProgramName = exports.selectPaymentInfoModalProgramName = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'programName', '');
	});
	
	var selectPaymentInfoModalDuePaymentDate = exports.selectPaymentInfoModalDuePaymentDate = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'duePaymentDate', '');
	});
	
	var selectPaymentInfoModalWaitingPayaResponse = exports.selectPaymentInfoModalWaitingPayaResponse = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'waitingPayaPaymentResponse', false);
	});
	
	var selectPaymentInfoModalInvitationId = exports.selectPaymentInfoModalInvitationId = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'invitationId', null);
	});
	
	var selectPaymentInfoModalPurchaseAgain = exports.selectPaymentInfoModalPurchaseAgain = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'purchaseAgain', false);
	});
	
	var selectPaymentInfoModalPrepayFlow = exports.selectPaymentInfoModalPrepayFlow = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'prepayFlow', false);
	});
	
	var selectPaymentInfoModalToDoId = exports.selectPaymentInfoModalToDoId = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'todoId', null);
	});
	
	var selectPaymentInfoModalUserId = exports.selectPaymentInfoModalUserId = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'userId', null);
	});
	
	var selectPaymentInfoModalMainUserId = exports.selectPaymentInfoModalMainUserId = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'mainUserId', null);
	});
	
	var selectPaymentInfoModalFormLoading = exports.selectPaymentInfoModalFormLoading = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'payaFormLoading', false);
	});
	
	var selectPaymentInfoModalPayaFormURL = exports.selectPaymentInfoModalPayaFormURL = (0, _reselect.createSelector)(selectPaymentInfoModalState, function (state) {
	  return (0, _get2.default)(state, 'payaFormUrl', '');
	});
	
	var selectAccountVaultsState = exports.selectAccountVaultsState = (0, _reselect.createSelector)(programsSelector, function (state) {
	  return (0, _get2.default)(state, 'accountVaults');
	});
	
	var selectAccountVaultsList = exports.selectAccountVaultsList = (0, _reselect.createSelector)(selectAccountVaultsState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectAccountVaultsListLoading = exports.selectAccountVaultsListLoading = (0, _reselect.createSelector)(selectAccountVaultsState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAppointmentId = __webpack_require__(4224);
	
	Object.defineProperty(exports, 'getAppointmentId', {
	  enumerable: true,
	  get: function get() {
	    return _getAppointmentId.getAppointmentId;
	  }
	});
	
	var _getPaperworkRoutes = __webpack_require__(4225);
	
	Object.defineProperty(exports, 'getAllPaperworkSteps', {
	  enumerable: true,
	  get: function get() {
	    return _getPaperworkRoutes.getAllPaperworkSteps;
	  }
	});
	Object.defineProperty(exports, 'getPaperworkFormSteps', {
	  enumerable: true,
	  get: function get() {
	    return _getPaperworkRoutes.getPaperworkFormSteps;
	  }
	});
	
	var _checkIsPaperworkRoute = __webpack_require__(4223);
	
	Object.defineProperty(exports, 'checkIsPaperworkRoute', {
	  enumerable: true,
	  get: function get() {
	    return _checkIsPaperworkRoute.checkIsPaperworkRoute;
	  }
	});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};

/***/ }),
/* 267 */
[6540, 222],
/* 268 */
[6551, 438],
/* 269 */
[6543, 243, 710, 146, 126, 1420],
/* 270 */
100,
/* 271 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 272 */
[6579, 32, 270, 95],
/* 273 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 274 */
[6595, 99],
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  add: true,
	  addBusinessDays: true,
	  addDays: true,
	  addHours: true,
	  addISOWeekYears: true,
	  addMilliseconds: true,
	  addMinutes: true,
	  addMonths: true,
	  addQuarters: true,
	  addSeconds: true,
	  addWeeks: true,
	  addYears: true,
	  areIntervalsOverlapping: true,
	  closestIndexTo: true,
	  closestTo: true,
	  compareAsc: true,
	  compareDesc: true,
	  differenceInBusinessDays: true,
	  differenceInCalendarDays: true,
	  differenceInCalendarISOWeekYears: true,
	  differenceInCalendarISOWeeks: true,
	  differenceInCalendarMonths: true,
	  differenceInCalendarQuarters: true,
	  differenceInCalendarWeeks: true,
	  differenceInCalendarYears: true,
	  differenceInDays: true,
	  differenceInHours: true,
	  differenceInISOWeekYears: true,
	  differenceInMilliseconds: true,
	  differenceInMinutes: true,
	  differenceInMonths: true,
	  differenceInQuarters: true,
	  differenceInSeconds: true,
	  differenceInWeeks: true,
	  differenceInYears: true,
	  eachDayOfInterval: true,
	  eachHourOfInterval: true,
	  eachMonthOfInterval: true,
	  eachQuarterOfInterval: true,
	  eachWeekOfInterval: true,
	  eachWeekendOfInterval: true,
	  eachWeekendOfMonth: true,
	  eachWeekendOfYear: true,
	  eachYearOfInterval: true,
	  endOfDay: true,
	  endOfDecade: true,
	  endOfHour: true,
	  endOfISOWeek: true,
	  endOfISOWeekYear: true,
	  endOfMinute: true,
	  endOfMonth: true,
	  endOfQuarter: true,
	  endOfSecond: true,
	  endOfToday: true,
	  endOfTomorrow: true,
	  endOfWeek: true,
	  endOfYear: true,
	  endOfYesterday: true,
	  format: true,
	  formatDistance: true,
	  formatDistanceStrict: true,
	  formatDistanceToNow: true,
	  formatDistanceToNowStrict: true,
	  formatDuration: true,
	  formatISO: true,
	  formatISO9075: true,
	  formatISODuration: true,
	  formatRFC3339: true,
	  formatRFC7231: true,
	  formatRelative: true,
	  fromUnixTime: true,
	  getDate: true,
	  getDay: true,
	  getDayOfYear: true,
	  getDaysInMonth: true,
	  getDaysInYear: true,
	  getDecade: true,
	  getHours: true,
	  getISODay: true,
	  getISOWeek: true,
	  getISOWeekYear: true,
	  getISOWeeksInYear: true,
	  getMilliseconds: true,
	  getMinutes: true,
	  getMonth: true,
	  getOverlappingDaysInIntervals: true,
	  getQuarter: true,
	  getSeconds: true,
	  getTime: true,
	  getUnixTime: true,
	  getWeek: true,
	  getWeekOfMonth: true,
	  getWeekYear: true,
	  getWeeksInMonth: true,
	  getYear: true,
	  intervalToDuration: true,
	  isAfter: true,
	  isBefore: true,
	  isDate: true,
	  isEqual: true,
	  isExists: true,
	  isFirstDayOfMonth: true,
	  isFriday: true,
	  isFuture: true,
	  isLastDayOfMonth: true,
	  isLeapYear: true,
	  isMatch: true,
	  isMonday: true,
	  isPast: true,
	  isSameDay: true,
	  isSameHour: true,
	  isSameISOWeek: true,
	  isSameISOWeekYear: true,
	  isSameMinute: true,
	  isSameMonth: true,
	  isSameQuarter: true,
	  isSameSecond: true,
	  isSameWeek: true,
	  isSameYear: true,
	  isSaturday: true,
	  isSunday: true,
	  isThisHour: true,
	  isThisISOWeek: true,
	  isThisMinute: true,
	  isThisMonth: true,
	  isThisQuarter: true,
	  isThisSecond: true,
	  isThisWeek: true,
	  isThisYear: true,
	  isThursday: true,
	  isToday: true,
	  isTomorrow: true,
	  isTuesday: true,
	  isValid: true,
	  isWednesday: true,
	  isWeekend: true,
	  isWithinInterval: true,
	  isYesterday: true,
	  lastDayOfDecade: true,
	  lastDayOfISOWeek: true,
	  lastDayOfISOWeekYear: true,
	  lastDayOfMonth: true,
	  lastDayOfQuarter: true,
	  lastDayOfWeek: true,
	  lastDayOfYear: true,
	  lightFormat: true,
	  max: true,
	  min: true,
	  parse: true,
	  parseISO: true,
	  parseJSON: true,
	  roundToNearestMinutes: true,
	  set: true,
	  setDate: true,
	  setDay: true,
	  setDayOfYear: true,
	  setHours: true,
	  setISODay: true,
	  setISOWeek: true,
	  setISOWeekYear: true,
	  setMilliseconds: true,
	  setMinutes: true,
	  setMonth: true,
	  setQuarter: true,
	  setSeconds: true,
	  setWeek: true,
	  setWeekYear: true,
	  setYear: true,
	  startOfDay: true,
	  startOfDecade: true,
	  startOfHour: true,
	  startOfISOWeek: true,
	  startOfISOWeekYear: true,
	  startOfMinute: true,
	  startOfMonth: true,
	  startOfQuarter: true,
	  startOfSecond: true,
	  startOfToday: true,
	  startOfTomorrow: true,
	  startOfWeek: true,
	  startOfWeekYear: true,
	  startOfYear: true,
	  startOfYesterday: true,
	  sub: true,
	  subBusinessDays: true,
	  subDays: true,
	  subHours: true,
	  subISOWeekYears: true,
	  subMilliseconds: true,
	  subMinutes: true,
	  subMonths: true,
	  subQuarters: true,
	  subSeconds: true,
	  subWeeks: true,
	  subYears: true,
	  toDate: true
	};
	Object.defineProperty(exports, "add", {
	  enumerable: true,
	  get: function () {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "addBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index2.default;
	  }
	});
	Object.defineProperty(exports, "addDays", {
	  enumerable: true,
	  get: function () {
	    return _index3.default;
	  }
	});
	Object.defineProperty(exports, "addHours", {
	  enumerable: true,
	  get: function () {
	    return _index4.default;
	  }
	});
	Object.defineProperty(exports, "addISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index5.default;
	  }
	});
	Object.defineProperty(exports, "addMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index6.default;
	  }
	});
	Object.defineProperty(exports, "addMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index7.default;
	  }
	});
	Object.defineProperty(exports, "addMonths", {
	  enumerable: true,
	  get: function () {
	    return _index8.default;
	  }
	});
	Object.defineProperty(exports, "addQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index9.default;
	  }
	});
	Object.defineProperty(exports, "addSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index10.default;
	  }
	});
	Object.defineProperty(exports, "addWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index11.default;
	  }
	});
	Object.defineProperty(exports, "addYears", {
	  enumerable: true,
	  get: function () {
	    return _index12.default;
	  }
	});
	Object.defineProperty(exports, "areIntervalsOverlapping", {
	  enumerable: true,
	  get: function () {
	    return _index13.default;
	  }
	});
	Object.defineProperty(exports, "closestIndexTo", {
	  enumerable: true,
	  get: function () {
	    return _index14.default;
	  }
	});
	Object.defineProperty(exports, "closestTo", {
	  enumerable: true,
	  get: function () {
	    return _index15.default;
	  }
	});
	Object.defineProperty(exports, "compareAsc", {
	  enumerable: true,
	  get: function () {
	    return _index16.default;
	  }
	});
	Object.defineProperty(exports, "compareDesc", {
	  enumerable: true,
	  get: function () {
	    return _index17.default;
	  }
	});
	Object.defineProperty(exports, "differenceInBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index18.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarDays", {
	  enumerable: true,
	  get: function () {
	    return _index19.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index20.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index21.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarMonths", {
	  enumerable: true,
	  get: function () {
	    return _index22.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index23.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index24.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarYears", {
	  enumerable: true,
	  get: function () {
	    return _index25.default;
	  }
	});
	Object.defineProperty(exports, "differenceInDays", {
	  enumerable: true,
	  get: function () {
	    return _index26.default;
	  }
	});
	Object.defineProperty(exports, "differenceInHours", {
	  enumerable: true,
	  get: function () {
	    return _index27.default;
	  }
	});
	Object.defineProperty(exports, "differenceInISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index28.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index29.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index30.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMonths", {
	  enumerable: true,
	  get: function () {
	    return _index31.default;
	  }
	});
	Object.defineProperty(exports, "differenceInQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index32.default;
	  }
	});
	Object.defineProperty(exports, "differenceInSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index33.default;
	  }
	});
	Object.defineProperty(exports, "differenceInWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index34.default;
	  }
	});
	Object.defineProperty(exports, "differenceInYears", {
	  enumerable: true,
	  get: function () {
	    return _index35.default;
	  }
	});
	Object.defineProperty(exports, "eachDayOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index36.default;
	  }
	});
	Object.defineProperty(exports, "eachHourOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index37.default;
	  }
	});
	Object.defineProperty(exports, "eachMonthOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index38.default;
	  }
	});
	Object.defineProperty(exports, "eachQuarterOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index39.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index40.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index41.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index42.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index43.default;
	  }
	});
	Object.defineProperty(exports, "eachYearOfInterval", {
	  enumerable: true,
	  get: function () {
	    return _index44.default;
	  }
	});
	Object.defineProperty(exports, "endOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index45.default;
	  }
	});
	Object.defineProperty(exports, "endOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index46.default;
	  }
	});
	Object.defineProperty(exports, "endOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index47.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index48.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index49.default;
	  }
	});
	Object.defineProperty(exports, "endOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index50.default;
	  }
	});
	Object.defineProperty(exports, "endOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index51.default;
	  }
	});
	Object.defineProperty(exports, "endOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index52.default;
	  }
	});
	Object.defineProperty(exports, "endOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index53.default;
	  }
	});
	Object.defineProperty(exports, "endOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index54.default;
	  }
	});
	Object.defineProperty(exports, "endOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index55.default;
	  }
	});
	Object.defineProperty(exports, "endOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index56.default;
	  }
	});
	Object.defineProperty(exports, "endOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index57.default;
	  }
	});
	Object.defineProperty(exports, "endOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index58.default;
	  }
	});
	Object.defineProperty(exports, "format", {
	  enumerable: true,
	  get: function () {
	    return _index59.default;
	  }
	});
	Object.defineProperty(exports, "formatDistance", {
	  enumerable: true,
	  get: function () {
	    return _index60.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceStrict", {
	  enumerable: true,
	  get: function () {
	    return _index61.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNow", {
	  enumerable: true,
	  get: function () {
	    return _index62.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNowStrict", {
	  enumerable: true,
	  get: function () {
	    return _index63.default;
	  }
	});
	Object.defineProperty(exports, "formatDuration", {
	  enumerable: true,
	  get: function () {
	    return _index64.default;
	  }
	});
	Object.defineProperty(exports, "formatISO", {
	  enumerable: true,
	  get: function () {
	    return _index65.default;
	  }
	});
	Object.defineProperty(exports, "formatISO9075", {
	  enumerable: true,
	  get: function () {
	    return _index66.default;
	  }
	});
	Object.defineProperty(exports, "formatISODuration", {
	  enumerable: true,
	  get: function () {
	    return _index67.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC3339", {
	  enumerable: true,
	  get: function () {
	    return _index68.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC7231", {
	  enumerable: true,
	  get: function () {
	    return _index69.default;
	  }
	});
	Object.defineProperty(exports, "formatRelative", {
	  enumerable: true,
	  get: function () {
	    return _index70.default;
	  }
	});
	Object.defineProperty(exports, "fromUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index71.default;
	  }
	});
	Object.defineProperty(exports, "getDate", {
	  enumerable: true,
	  get: function () {
	    return _index72.default;
	  }
	});
	Object.defineProperty(exports, "getDay", {
	  enumerable: true,
	  get: function () {
	    return _index73.default;
	  }
	});
	Object.defineProperty(exports, "getDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index74.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index75.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInYear", {
	  enumerable: true,
	  get: function () {
	    return _index76.default;
	  }
	});
	Object.defineProperty(exports, "getDecade", {
	  enumerable: true,
	  get: function () {
	    return _index77.default;
	  }
	});
	Object.defineProperty(exports, "getHours", {
	  enumerable: true,
	  get: function () {
	    return _index78.default;
	  }
	});
	Object.defineProperty(exports, "getISODay", {
	  enumerable: true,
	  get: function () {
	    return _index79.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index80.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index81.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeeksInYear", {
	  enumerable: true,
	  get: function () {
	    return _index82.default;
	  }
	});
	Object.defineProperty(exports, "getMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index83.default;
	  }
	});
	Object.defineProperty(exports, "getMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index84.default;
	  }
	});
	Object.defineProperty(exports, "getMonth", {
	  enumerable: true,
	  get: function () {
	    return _index85.default;
	  }
	});
	Object.defineProperty(exports, "getOverlappingDaysInIntervals", {
	  enumerable: true,
	  get: function () {
	    return _index86.default;
	  }
	});
	Object.defineProperty(exports, "getQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index87.default;
	  }
	});
	Object.defineProperty(exports, "getSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index88.default;
	  }
	});
	Object.defineProperty(exports, "getTime", {
	  enumerable: true,
	  get: function () {
	    return _index89.default;
	  }
	});
	Object.defineProperty(exports, "getUnixTime", {
	  enumerable: true,
	  get: function () {
	    return _index90.default;
	  }
	});
	Object.defineProperty(exports, "getWeek", {
	  enumerable: true,
	  get: function () {
	    return _index91.default;
	  }
	});
	Object.defineProperty(exports, "getWeekOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index92.default;
	  }
	});
	Object.defineProperty(exports, "getWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index93.default;
	  }
	});
	Object.defineProperty(exports, "getWeeksInMonth", {
	  enumerable: true,
	  get: function () {
	    return _index94.default;
	  }
	});
	Object.defineProperty(exports, "getYear", {
	  enumerable: true,
	  get: function () {
	    return _index95.default;
	  }
	});
	Object.defineProperty(exports, "intervalToDuration", {
	  enumerable: true,
	  get: function () {
	    return _index96.default;
	  }
	});
	Object.defineProperty(exports, "isAfter", {
	  enumerable: true,
	  get: function () {
	    return _index97.default;
	  }
	});
	Object.defineProperty(exports, "isBefore", {
	  enumerable: true,
	  get: function () {
	    return _index98.default;
	  }
	});
	Object.defineProperty(exports, "isDate", {
	  enumerable: true,
	  get: function () {
	    return _index99.default;
	  }
	});
	Object.defineProperty(exports, "isEqual", {
	  enumerable: true,
	  get: function () {
	    return _index100.default;
	  }
	});
	Object.defineProperty(exports, "isExists", {
	  enumerable: true,
	  get: function () {
	    return _index101.default;
	  }
	});
	Object.defineProperty(exports, "isFirstDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index102.default;
	  }
	});
	Object.defineProperty(exports, "isFriday", {
	  enumerable: true,
	  get: function () {
	    return _index103.default;
	  }
	});
	Object.defineProperty(exports, "isFuture", {
	  enumerable: true,
	  get: function () {
	    return _index104.default;
	  }
	});
	Object.defineProperty(exports, "isLastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index105.default;
	  }
	});
	Object.defineProperty(exports, "isLeapYear", {
	  enumerable: true,
	  get: function () {
	    return _index106.default;
	  }
	});
	Object.defineProperty(exports, "isMatch", {
	  enumerable: true,
	  get: function () {
	    return _index107.default;
	  }
	});
	Object.defineProperty(exports, "isMonday", {
	  enumerable: true,
	  get: function () {
	    return _index108.default;
	  }
	});
	Object.defineProperty(exports, "isPast", {
	  enumerable: true,
	  get: function () {
	    return _index109.default;
	  }
	});
	Object.defineProperty(exports, "isSameDay", {
	  enumerable: true,
	  get: function () {
	    return _index110.default;
	  }
	});
	Object.defineProperty(exports, "isSameHour", {
	  enumerable: true,
	  get: function () {
	    return _index111.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index112.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index113.default;
	  }
	});
	Object.defineProperty(exports, "isSameMinute", {
	  enumerable: true,
	  get: function () {
	    return _index114.default;
	  }
	});
	Object.defineProperty(exports, "isSameMonth", {
	  enumerable: true,
	  get: function () {
	    return _index115.default;
	  }
	});
	Object.defineProperty(exports, "isSameQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index116.default;
	  }
	});
	Object.defineProperty(exports, "isSameSecond", {
	  enumerable: true,
	  get: function () {
	    return _index117.default;
	  }
	});
	Object.defineProperty(exports, "isSameWeek", {
	  enumerable: true,
	  get: function () {
	    return _index118.default;
	  }
	});
	Object.defineProperty(exports, "isSameYear", {
	  enumerable: true,
	  get: function () {
	    return _index119.default;
	  }
	});
	Object.defineProperty(exports, "isSaturday", {
	  enumerable: true,
	  get: function () {
	    return _index120.default;
	  }
	});
	Object.defineProperty(exports, "isSunday", {
	  enumerable: true,
	  get: function () {
	    return _index121.default;
	  }
	});
	Object.defineProperty(exports, "isThisHour", {
	  enumerable: true,
	  get: function () {
	    return _index122.default;
	  }
	});
	Object.defineProperty(exports, "isThisISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index123.default;
	  }
	});
	Object.defineProperty(exports, "isThisMinute", {
	  enumerable: true,
	  get: function () {
	    return _index124.default;
	  }
	});
	Object.defineProperty(exports, "isThisMonth", {
	  enumerable: true,
	  get: function () {
	    return _index125.default;
	  }
	});
	Object.defineProperty(exports, "isThisQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index126.default;
	  }
	});
	Object.defineProperty(exports, "isThisSecond", {
	  enumerable: true,
	  get: function () {
	    return _index127.default;
	  }
	});
	Object.defineProperty(exports, "isThisWeek", {
	  enumerable: true,
	  get: function () {
	    return _index128.default;
	  }
	});
	Object.defineProperty(exports, "isThisYear", {
	  enumerable: true,
	  get: function () {
	    return _index129.default;
	  }
	});
	Object.defineProperty(exports, "isThursday", {
	  enumerable: true,
	  get: function () {
	    return _index130.default;
	  }
	});
	Object.defineProperty(exports, "isToday", {
	  enumerable: true,
	  get: function () {
	    return _index131.default;
	  }
	});
	Object.defineProperty(exports, "isTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index132.default;
	  }
	});
	Object.defineProperty(exports, "isTuesday", {
	  enumerable: true,
	  get: function () {
	    return _index133.default;
	  }
	});
	Object.defineProperty(exports, "isValid", {
	  enumerable: true,
	  get: function () {
	    return _index134.default;
	  }
	});
	Object.defineProperty(exports, "isWednesday", {
	  enumerable: true,
	  get: function () {
	    return _index135.default;
	  }
	});
	Object.defineProperty(exports, "isWeekend", {
	  enumerable: true,
	  get: function () {
	    return _index136.default;
	  }
	});
	Object.defineProperty(exports, "isWithinInterval", {
	  enumerable: true,
	  get: function () {
	    return _index137.default;
	  }
	});
	Object.defineProperty(exports, "isYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index138.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index139.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index140.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index141.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index142.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index143.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index144.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index145.default;
	  }
	});
	Object.defineProperty(exports, "lightFormat", {
	  enumerable: true,
	  get: function () {
	    return _index146.default;
	  }
	});
	Object.defineProperty(exports, "max", {
	  enumerable: true,
	  get: function () {
	    return _index147.default;
	  }
	});
	Object.defineProperty(exports, "min", {
	  enumerable: true,
	  get: function () {
	    return _index148.default;
	  }
	});
	Object.defineProperty(exports, "parse", {
	  enumerable: true,
	  get: function () {
	    return _index149.default;
	  }
	});
	Object.defineProperty(exports, "parseISO", {
	  enumerable: true,
	  get: function () {
	    return _index150.default;
	  }
	});
	Object.defineProperty(exports, "parseJSON", {
	  enumerable: true,
	  get: function () {
	    return _index151.default;
	  }
	});
	Object.defineProperty(exports, "roundToNearestMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index152.default;
	  }
	});
	Object.defineProperty(exports, "set", {
	  enumerable: true,
	  get: function () {
	    return _index153.default;
	  }
	});
	Object.defineProperty(exports, "setDate", {
	  enumerable: true,
	  get: function () {
	    return _index154.default;
	  }
	});
	Object.defineProperty(exports, "setDay", {
	  enumerable: true,
	  get: function () {
	    return _index155.default;
	  }
	});
	Object.defineProperty(exports, "setDayOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index156.default;
	  }
	});
	Object.defineProperty(exports, "setHours", {
	  enumerable: true,
	  get: function () {
	    return _index157.default;
	  }
	});
	Object.defineProperty(exports, "setISODay", {
	  enumerable: true,
	  get: function () {
	    return _index158.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index159.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index160.default;
	  }
	});
	Object.defineProperty(exports, "setMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index161.default;
	  }
	});
	Object.defineProperty(exports, "setMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index162.default;
	  }
	});
	Object.defineProperty(exports, "setMonth", {
	  enumerable: true,
	  get: function () {
	    return _index163.default;
	  }
	});
	Object.defineProperty(exports, "setQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index164.default;
	  }
	});
	Object.defineProperty(exports, "setSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index165.default;
	  }
	});
	Object.defineProperty(exports, "setWeek", {
	  enumerable: true,
	  get: function () {
	    return _index166.default;
	  }
	});
	Object.defineProperty(exports, "setWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index167.default;
	  }
	});
	Object.defineProperty(exports, "setYear", {
	  enumerable: true,
	  get: function () {
	    return _index168.default;
	  }
	});
	Object.defineProperty(exports, "startOfDay", {
	  enumerable: true,
	  get: function () {
	    return _index169.default;
	  }
	});
	Object.defineProperty(exports, "startOfDecade", {
	  enumerable: true,
	  get: function () {
	    return _index170.default;
	  }
	});
	Object.defineProperty(exports, "startOfHour", {
	  enumerable: true,
	  get: function () {
	    return _index171.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeek", {
	  enumerable: true,
	  get: function () {
	    return _index172.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index173.default;
	  }
	});
	Object.defineProperty(exports, "startOfMinute", {
	  enumerable: true,
	  get: function () {
	    return _index174.default;
	  }
	});
	Object.defineProperty(exports, "startOfMonth", {
	  enumerable: true,
	  get: function () {
	    return _index175.default;
	  }
	});
	Object.defineProperty(exports, "startOfQuarter", {
	  enumerable: true,
	  get: function () {
	    return _index176.default;
	  }
	});
	Object.defineProperty(exports, "startOfSecond", {
	  enumerable: true,
	  get: function () {
	    return _index177.default;
	  }
	});
	Object.defineProperty(exports, "startOfToday", {
	  enumerable: true,
	  get: function () {
	    return _index178.default;
	  }
	});
	Object.defineProperty(exports, "startOfTomorrow", {
	  enumerable: true,
	  get: function () {
	    return _index179.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeek", {
	  enumerable: true,
	  get: function () {
	    return _index180.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeekYear", {
	  enumerable: true,
	  get: function () {
	    return _index181.default;
	  }
	});
	Object.defineProperty(exports, "startOfYear", {
	  enumerable: true,
	  get: function () {
	    return _index182.default;
	  }
	});
	Object.defineProperty(exports, "startOfYesterday", {
	  enumerable: true,
	  get: function () {
	    return _index183.default;
	  }
	});
	Object.defineProperty(exports, "sub", {
	  enumerable: true,
	  get: function () {
	    return _index184.default;
	  }
	});
	Object.defineProperty(exports, "subBusinessDays", {
	  enumerable: true,
	  get: function () {
	    return _index185.default;
	  }
	});
	Object.defineProperty(exports, "subDays", {
	  enumerable: true,
	  get: function () {
	    return _index186.default;
	  }
	});
	Object.defineProperty(exports, "subHours", {
	  enumerable: true,
	  get: function () {
	    return _index187.default;
	  }
	});
	Object.defineProperty(exports, "subISOWeekYears", {
	  enumerable: true,
	  get: function () {
	    return _index188.default;
	  }
	});
	Object.defineProperty(exports, "subMilliseconds", {
	  enumerable: true,
	  get: function () {
	    return _index189.default;
	  }
	});
	Object.defineProperty(exports, "subMinutes", {
	  enumerable: true,
	  get: function () {
	    return _index190.default;
	  }
	});
	Object.defineProperty(exports, "subMonths", {
	  enumerable: true,
	  get: function () {
	    return _index191.default;
	  }
	});
	Object.defineProperty(exports, "subQuarters", {
	  enumerable: true,
	  get: function () {
	    return _index192.default;
	  }
	});
	Object.defineProperty(exports, "subSeconds", {
	  enumerable: true,
	  get: function () {
	    return _index193.default;
	  }
	});
	Object.defineProperty(exports, "subWeeks", {
	  enumerable: true,
	  get: function () {
	    return _index194.default;
	  }
	});
	Object.defineProperty(exports, "subYears", {
	  enumerable: true,
	  get: function () {
	    return _index195.default;
	  }
	});
	Object.defineProperty(exports, "toDate", {
	  enumerable: true,
	  get: function () {
	    return _index196.default;
	  }
	});
	
	var _index = _interopRequireDefault(__webpack_require__(4724));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2187));
	
	var _index3 = _interopRequireDefault(__webpack_require__(369));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1469));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2188));
	
	var _index6 = _interopRequireDefault(__webpack_require__(712));
	
	var _index7 = _interopRequireDefault(__webpack_require__(2189));
	
	var _index8 = _interopRequireDefault(__webpack_require__(713));
	
	var _index9 = _interopRequireDefault(__webpack_require__(1470));
	
	var _index10 = _interopRequireDefault(__webpack_require__(2190));
	
	var _index11 = _interopRequireDefault(__webpack_require__(940));
	
	var _index12 = _interopRequireDefault(__webpack_require__(2191));
	
	var _index13 = _interopRequireDefault(__webpack_require__(4725));
	
	var _index14 = _interopRequireDefault(__webpack_require__(4726));
	
	var _index15 = _interopRequireDefault(__webpack_require__(4727));
	
	var _index16 = _interopRequireDefault(__webpack_require__(452));
	
	var _index17 = _interopRequireDefault(__webpack_require__(4728));
	
	var _index18 = _interopRequireDefault(__webpack_require__(4730));
	
	var _index19 = _interopRequireDefault(__webpack_require__(453));
	
	var _index20 = _interopRequireDefault(__webpack_require__(2192));
	
	var _index21 = _interopRequireDefault(__webpack_require__(4731));
	
	var _index22 = _interopRequireDefault(__webpack_require__(2193));
	
	var _index23 = _interopRequireDefault(__webpack_require__(4732));
	
	var _index24 = _interopRequireDefault(__webpack_require__(2194));
	
	var _index25 = _interopRequireDefault(__webpack_require__(2195));
	
	var _index26 = _interopRequireDefault(__webpack_require__(1471));
	
	var _index27 = _interopRequireDefault(__webpack_require__(2196));
	
	var _index28 = _interopRequireDefault(__webpack_require__(4733));
	
	var _index29 = _interopRequireDefault(__webpack_require__(941));
	
	var _index30 = _interopRequireDefault(__webpack_require__(2197));
	
	var _index31 = _interopRequireDefault(__webpack_require__(942));
	
	var _index32 = _interopRequireDefault(__webpack_require__(4734));
	
	var _index33 = _interopRequireDefault(__webpack_require__(943));
	
	var _index34 = _interopRequireDefault(__webpack_require__(4735));
	
	var _index35 = _interopRequireDefault(__webpack_require__(2198));
	
	var _index36 = _interopRequireDefault(__webpack_require__(2199));
	
	var _index37 = _interopRequireDefault(__webpack_require__(4736));
	
	var _index38 = _interopRequireDefault(__webpack_require__(4737));
	
	var _index39 = _interopRequireDefault(__webpack_require__(4738));
	
	var _index40 = _interopRequireDefault(__webpack_require__(4739));
	
	var _index41 = _interopRequireDefault(__webpack_require__(1472));
	
	var _index42 = _interopRequireDefault(__webpack_require__(4740));
	
	var _index43 = _interopRequireDefault(__webpack_require__(4741));
	
	var _index44 = _interopRequireDefault(__webpack_require__(4742));
	
	var _index45 = _interopRequireDefault(__webpack_require__(1473));
	
	var _index46 = _interopRequireDefault(__webpack_require__(4743));
	
	var _index47 = _interopRequireDefault(__webpack_require__(4744));
	
	var _index48 = _interopRequireDefault(__webpack_require__(4745));
	
	var _index49 = _interopRequireDefault(__webpack_require__(4746));
	
	var _index50 = _interopRequireDefault(__webpack_require__(4747));
	
	var _index51 = _interopRequireDefault(__webpack_require__(1474));
	
	var _index52 = _interopRequireDefault(__webpack_require__(4748));
	
	var _index53 = _interopRequireDefault(__webpack_require__(4749));
	
	var _index54 = _interopRequireDefault(__webpack_require__(4750));
	
	var _index55 = _interopRequireDefault(__webpack_require__(4751));
	
	var _index56 = _interopRequireDefault(__webpack_require__(2200));
	
	var _index57 = _interopRequireDefault(__webpack_require__(2201));
	
	var _index58 = _interopRequireDefault(__webpack_require__(4752));
	
	var _index59 = _interopRequireDefault(__webpack_require__(370));
	
	var _index60 = _interopRequireDefault(__webpack_require__(2202));
	
	var _index61 = _interopRequireDefault(__webpack_require__(2203));
	
	var _index62 = _interopRequireDefault(__webpack_require__(4753));
	
	var _index63 = _interopRequireDefault(__webpack_require__(4754));
	
	var _index64 = _interopRequireDefault(__webpack_require__(4755));
	
	var _index65 = _interopRequireDefault(__webpack_require__(4756));
	
	var _index66 = _interopRequireDefault(__webpack_require__(4757));
	
	var _index67 = _interopRequireDefault(__webpack_require__(4758));
	
	var _index68 = _interopRequireDefault(__webpack_require__(4759));
	
	var _index69 = _interopRequireDefault(__webpack_require__(4760));
	
	var _index70 = _interopRequireDefault(__webpack_require__(4761));
	
	var _index71 = _interopRequireDefault(__webpack_require__(4762));
	
	var _index72 = _interopRequireDefault(__webpack_require__(2204));
	
	var _index73 = _interopRequireDefault(__webpack_require__(2205));
	
	var _index74 = _interopRequireDefault(__webpack_require__(4763));
	
	var _index75 = _interopRequireDefault(__webpack_require__(2206));
	
	var _index76 = _interopRequireDefault(__webpack_require__(4764));
	
	var _index77 = _interopRequireDefault(__webpack_require__(4765));
	
	var _index78 = _interopRequireDefault(__webpack_require__(4766));
	
	var _index79 = _interopRequireDefault(__webpack_require__(2207));
	
	var _index80 = _interopRequireDefault(__webpack_require__(2208));
	
	var _index81 = _interopRequireDefault(__webpack_require__(561));
	
	var _index82 = _interopRequireDefault(__webpack_require__(4767));
	
	var _index83 = _interopRequireDefault(__webpack_require__(4768));
	
	var _index84 = _interopRequireDefault(__webpack_require__(4769));
	
	var _index85 = _interopRequireDefault(__webpack_require__(4770));
	
	var _index86 = _interopRequireDefault(__webpack_require__(4771));
	
	var _index87 = _interopRequireDefault(__webpack_require__(2209));
	
	var _index88 = _interopRequireDefault(__webpack_require__(4772));
	
	var _index89 = _interopRequireDefault(__webpack_require__(2210));
	
	var _index90 = _interopRequireDefault(__webpack_require__(4773));
	
	var _index91 = _interopRequireDefault(__webpack_require__(2211));
	
	var _index92 = _interopRequireDefault(__webpack_require__(4774));
	
	var _index93 = _interopRequireDefault(__webpack_require__(2212));
	
	var _index94 = _interopRequireDefault(__webpack_require__(4775));
	
	var _index95 = _interopRequireDefault(__webpack_require__(4776));
	
	var _index96 = _interopRequireDefault(__webpack_require__(4777));
	
	var _index97 = _interopRequireDefault(__webpack_require__(4778));
	
	var _index98 = _interopRequireDefault(__webpack_require__(2213));
	
	var _index99 = _interopRequireDefault(__webpack_require__(4779));
	
	var _index100 = _interopRequireDefault(__webpack_require__(4780));
	
	var _index101 = _interopRequireDefault(__webpack_require__(4781));
	
	var _index102 = _interopRequireDefault(__webpack_require__(4782));
	
	var _index103 = _interopRequireDefault(__webpack_require__(4783));
	
	var _index104 = _interopRequireDefault(__webpack_require__(4784));
	
	var _index105 = _interopRequireDefault(__webpack_require__(4785));
	
	var _index106 = _interopRequireDefault(__webpack_require__(2214));
	
	var _index107 = _interopRequireDefault(__webpack_require__(4786));
	
	var _index108 = _interopRequireDefault(__webpack_require__(4787));
	
	var _index109 = _interopRequireDefault(__webpack_require__(4788));
	
	var _index110 = _interopRequireDefault(__webpack_require__(714));
	
	var _index111 = _interopRequireDefault(__webpack_require__(2215));
	
	var _index112 = _interopRequireDefault(__webpack_require__(2216));
	
	var _index113 = _interopRequireDefault(__webpack_require__(4789));
	
	var _index114 = _interopRequireDefault(__webpack_require__(2217));
	
	var _index115 = _interopRequireDefault(__webpack_require__(2218));
	
	var _index116 = _interopRequireDefault(__webpack_require__(2219));
	
	var _index117 = _interopRequireDefault(__webpack_require__(2220));
	
	var _index118 = _interopRequireDefault(__webpack_require__(1475));
	
	var _index119 = _interopRequireDefault(__webpack_require__(2221));
	
	var _index120 = _interopRequireDefault(__webpack_require__(2222));
	
	var _index121 = _interopRequireDefault(__webpack_require__(1476));
	
	var _index122 = _interopRequireDefault(__webpack_require__(4790));
	
	var _index123 = _interopRequireDefault(__webpack_require__(4791));
	
	var _index124 = _interopRequireDefault(__webpack_require__(4792));
	
	var _index125 = _interopRequireDefault(__webpack_require__(4793));
	
	var _index126 = _interopRequireDefault(__webpack_require__(4794));
	
	var _index127 = _interopRequireDefault(__webpack_require__(4795));
	
	var _index128 = _interopRequireDefault(__webpack_require__(4796));
	
	var _index129 = _interopRequireDefault(__webpack_require__(4797));
	
	var _index130 = _interopRequireDefault(__webpack_require__(4798));
	
	var _index131 = _interopRequireDefault(__webpack_require__(4799));
	
	var _index132 = _interopRequireDefault(__webpack_require__(4800));
	
	var _index133 = _interopRequireDefault(__webpack_require__(4801));
	
	var _index134 = _interopRequireDefault(__webpack_require__(208));
	
	var _index135 = _interopRequireDefault(__webpack_require__(4802));
	
	var _index136 = _interopRequireDefault(__webpack_require__(944));
	
	var _index137 = _interopRequireDefault(__webpack_require__(4803));
	
	var _index138 = _interopRequireDefault(__webpack_require__(4804));
	
	var _index139 = _interopRequireDefault(__webpack_require__(4805));
	
	var _index140 = _interopRequireDefault(__webpack_require__(4806));
	
	var _index141 = _interopRequireDefault(__webpack_require__(4807));
	
	var _index142 = _interopRequireDefault(__webpack_require__(2223));
	
	var _index143 = _interopRequireDefault(__webpack_require__(4808));
	
	var _index144 = _interopRequireDefault(__webpack_require__(2224));
	
	var _index145 = _interopRequireDefault(__webpack_require__(4809));
	
	var _index146 = _interopRequireDefault(__webpack_require__(4810));
	
	var _index147 = _interopRequireDefault(__webpack_require__(4820));
	
	var _index148 = _interopRequireDefault(__webpack_require__(4821));
	
	var _index149 = _interopRequireDefault(__webpack_require__(715));
	
	var _index150 = _interopRequireDefault(__webpack_require__(1477));
	
	var _index151 = _interopRequireDefault(__webpack_require__(4823));
	
	var _index152 = _interopRequireDefault(__webpack_require__(4824));
	
	var _index153 = _interopRequireDefault(__webpack_require__(4825));
	
	var _index154 = _interopRequireDefault(__webpack_require__(4826));
	
	var _index155 = _interopRequireDefault(__webpack_require__(4827));
	
	var _index156 = _interopRequireDefault(__webpack_require__(4828));
	
	var _index157 = _interopRequireDefault(__webpack_require__(4829));
	
	var _index158 = _interopRequireDefault(__webpack_require__(4830));
	
	var _index159 = _interopRequireDefault(__webpack_require__(4831));
	
	var _index160 = _interopRequireDefault(__webpack_require__(2225));
	
	var _index161 = _interopRequireDefault(__webpack_require__(4832));
	
	var _index162 = _interopRequireDefault(__webpack_require__(4833));
	
	var _index163 = _interopRequireDefault(__webpack_require__(1478));
	
	var _index164 = _interopRequireDefault(__webpack_require__(4834));
	
	var _index165 = _interopRequireDefault(__webpack_require__(4835));
	
	var _index166 = _interopRequireDefault(__webpack_require__(4836));
	
	var _index167 = _interopRequireDefault(__webpack_require__(4837));
	
	var _index168 = _interopRequireDefault(__webpack_require__(4838));
	
	var _index169 = _interopRequireDefault(__webpack_require__(945));
	
	var _index170 = _interopRequireDefault(__webpack_require__(4839));
	
	var _index171 = _interopRequireDefault(__webpack_require__(2226));
	
	var _index172 = _interopRequireDefault(__webpack_require__(455));
	
	var _index173 = _interopRequireDefault(__webpack_require__(716));
	
	var _index174 = _interopRequireDefault(__webpack_require__(2227));
	
	var _index175 = _interopRequireDefault(__webpack_require__(946));
	
	var _index176 = _interopRequireDefault(__webpack_require__(1479));
	
	var _index177 = _interopRequireDefault(__webpack_require__(2228));
	
	var _index178 = _interopRequireDefault(__webpack_require__(4840));
	
	var _index179 = _interopRequireDefault(__webpack_require__(4841));
	
	var _index180 = _interopRequireDefault(__webpack_require__(371));
	
	var _index181 = _interopRequireDefault(__webpack_require__(1480));
	
	var _index182 = _interopRequireDefault(__webpack_require__(1481));
	
	var _index183 = _interopRequireDefault(__webpack_require__(4842));
	
	var _index184 = _interopRequireDefault(__webpack_require__(2229));
	
	var _index185 = _interopRequireDefault(__webpack_require__(4843));
	
	var _index186 = _interopRequireDefault(__webpack_require__(1482));
	
	var _index187 = _interopRequireDefault(__webpack_require__(4844));
	
	var _index188 = _interopRequireDefault(__webpack_require__(2230));
	
	var _index189 = _interopRequireDefault(__webpack_require__(717));
	
	var _index190 = _interopRequireDefault(__webpack_require__(4845));
	
	var _index191 = _interopRequireDefault(__webpack_require__(2231));
	
	var _index192 = _interopRequireDefault(__webpack_require__(4846));
	
	var _index193 = _interopRequireDefault(__webpack_require__(4847));
	
	var _index194 = _interopRequireDefault(__webpack_require__(4848));
	
	var _index195 = _interopRequireDefault(__webpack_require__(4849));
	
	var _index196 = _interopRequireDefault(__webpack_require__(31));
	
	var _index197 = __webpack_require__(4729);
	
	Object.keys(_index197).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _index197[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b4bfade7","outerContainer":"c478be85","secondaryToolbar":"_8b78530a","doorHangerRight":"fc8ef6ef","toolbarContainer":"_27fa2516","toolbarViewerMiddle":"_266dceb6","progressBar":"_1d7466a8","back-to-application":"_32c172bf","marker":"_1ad3e0e7","item":"_1d2c26ca","marker--desktop":"_9b36c024","root":"fbd75bfc","root--opened-mobile":"_1c144e4f","menu":"_738afa2f","marker--cover":"_4461e241","item--menu":"f4571c3e","nav":"_29c407c8","nav--grow":"_10c36149","item--title":"_44d539a5","item--withNewActivity":"_4ab58a86","link":"_437eb995","link--active":"_87b8d17e","separator":"f51f6ef7","overlay":"_1883c4c1","add-patient":"bc23bb60","patient-label":"ae376307","new-patient":"d123b163","label":"eb28d9a3","content":"_58e377c9","option":"_972b029a","auth":"_3c8afb5e","linkActiveAR":"_8d7815c7","unread-icon":"_3675f74e","home-link":"_9ecb8128","auth--active":"_5cdf6004"};

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_6fd3d75a","outerContainer":"_104dd820","secondaryToolbar":"bf76cec6","doorHangerRight":"d93387a0","toolbarContainer":"dda7c809","toolbarViewerMiddle":"d6fabca5","progressBar":"_0074356e","back-to-application":"cbcb1f9f","root":"_9e4cc3f9","activityLogRoot":"_52f55654","header":"_292d3073","activeCardRoot":"_8152a20b","leftSideWrapper":"d43e8818","icon":"_2eea5284","iconType":"_67971d3a","visibilityIcon":"_744b547d","contentWrapper":"d6cc946b","title":"d305b6c3","noTitle":"_03fdf612","titleWrapper":"d4d054c1","description":"f34cc47f","descriptionWrapper":"_5ae7e517","column":"_0d9160e6","columnWrapper":"_0a52ec4f","meta":"_554b759a","context":"_2b38c5f0","wrapWhiteSpace":"_47b6bba3","statusWrapper":"f01c37cc","labTestResult":"efdda1db","labTestResultDetails":"_21b0763b","severityPink":"e91336ca","severityModerate":"ad7eea79","severityGreen":"acde55ce","fullContent":"_64c643d4","cropContent":"_93a79ae3","cropConditionsTitle":"_3281a60a","privacyIcon":"a540d41b","medicationDescription":"_63304198","medicationHeader":"_27cb5f64","inactive":"_9e0a6a6a","rightBlock":"eb5b9966","medicaationRightBlock":"_066f89d4","medicationIcon":"ffafd3da","date":"_875ecf2d","selfReportedText":"e1f920b4"};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ButtonBase = __webpack_require__(5534);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonBase).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Paper = __webpack_require__(5592);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Paper).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(959);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(6042);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(_supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function off(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);
	
	
	  (0, _keys2.default)(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? (0, _warning2.default)(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_React$Component) {
	  (0, _inherits3.default)(EventListener, _React$Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react2.default.Component);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
	} : {};
	
	exports.default = EventListener;

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(1663);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var scope_1 = __webpack_require__(1674);
	exports.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
	exports.Scope = scope_1.Scope;
	var session_1 = __webpack_require__(1675);
	exports.Session = session_1.Session;
	var sessionflusher_1 = __webpack_require__(2936);
	exports.SessionFlusher = sessionflusher_1.SessionFlusher;
	var hub_1 = __webpack_require__(1673);
	// eslint-disable-next-line deprecation/deprecation
	exports.getActiveDomain = hub_1.getActiveDomain;
	exports.getCurrentHub = hub_1.getCurrentHub;
	exports.getHubFromCarrier = hub_1.getHubFromCarrier;
	exports.getMainCarrier = hub_1.getMainCarrier;
	exports.Hub = hub_1.Hub;
	exports.makeMain = hub_1.makeMain;
	exports.setHubOnCarrier = hub_1.setHubOnCarrier;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ExpandableBlock = __webpack_require__(1106);
	
	var _ExpandableBlock2 = _interopRequireDefault(_ExpandableBlock);
	
	var _Header = __webpack_require__(3280);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _index = __webpack_require__(2247);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandableListItem = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(ExpandableListItem, _Component);
	
	  function ExpandableListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ExpandableListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpandableListItem.__proto__ || (0, _getPrototypeOf2.default)(ExpandableListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showDescription: false
	    }, _this.handleOpenDescription = function (e) {
	      e.stopPropagation();
	      _this.setState({ showDescription: true });
	    }, _this.handleHideDescription = function (e) {
	      e.stopPropagation();
	      _this.setState(function (prevState) {
	        return {
	          showDescription: !prevState.showDescription
	        };
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ExpandableListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          header = _props.header,
	          opened = _props.opened,
	          locked = _props.locked,
	          hasCustomMarker = _props.hasCustomMarker,
	          progress = _props.progress,
	          expandableBlockClassName = _props.expandableBlockClassName,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'header', 'opened', 'locked', 'hasCustomMarker', 'progress', 'expandableBlockClassName']);
	      var icon = header.icon,
	          title = header.title,
	          subtitle = header.subtitle,
	          note = header.note,
	          description = header.description,
	          list = header.list,
	          reverseTitle = header.reverseTitle,
	          expirationStatus = header.expirationStatus;
	      var showDescription = this.state.showDescription;
	
	      var closeDescription = showDescription ? this.handleHideDescription : null;
	
	      var expandableHeader = _react2.default.createElement(_Header2.default, {
	        progress: progress,
	        icon: icon,
	        title: title,
	        subtitle: subtitle,
	        locked: locked,
	        note: note,
	        status: expirationStatus,
	        description: description,
	        reverseTitle: reverseTitle,
	        openPopover: this.handleOpenDescription,
	        closePopover: closeDescription,
	        showPopover: showDescription,
	        list: list
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ className: className, styleName: 'root' }, other),
	        _react2.default.createElement(
	          _Paper2.default,
	          { overflowVisible: !!description },
	          _react2.default.createElement(_ExpandableBlock2.default, {
	            opened: opened,
	            locked: locked,
	            hasCustomMarker: hasCustomMarker,
	            content: {
	              head: expandableHeader,
	              body: children
	            },
	            icon: 'arrow-down',
	            className: expandableBlockClassName
	          })
	        )
	      );
	    }
	  }]);
	  return ExpandableListItem;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  expandableBlockClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  header: _propTypes2.default.shape({
	    icon: _propTypes2.default.node,
	    title: _propTypes2.default.string,
	    subtitle: _propTypes2.default.string,
	    note: _propTypes2.default.any
	  }),
	  opened: _propTypes2.default.bool,
	  locked: _propTypes2.default.bool,
	  hasCustomMarker: _propTypes2.default.bool,
	  description: _propTypes2.default.string,
	  progress: _propTypes2.default.number
	}, _temp2)) || _class);
	exports.default = ExpandableListItem;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.formatPaymentInfo = formatPaymentInfo;
	exports.formatPaymentInfoProviderContext = formatPaymentInfoProviderContext;
	exports.visitOverviewAdapter = visitOverviewAdapter;
	exports.appointmentTargetUserAdapter = appointmentTargetUserAdapter;
	exports.getAppointmentTime = getAppointmentTime;
	exports.getPaymentDetails = getPaymentDetails;
	exports.getInlineCellData = getInlineCellData;
	exports.getTransactionInfo = getTransactionInfo;
	exports.checkMandatoryPaymentWarning = checkMandatoryPaymentWarning;
	exports.getMyProviderDetails = getMyProviderDetails;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _formatAmount = __webpack_require__(434);
	
	var _constants = __webpack_require__(17);
	
	var _dateFilter = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tScope = 'healthboard.appointments.paymentStatus';
	
	function formatPaymentInfo(_ref) {
	  var _ref$paymentStatus = _ref.paymentStatus,
	      paymentStatus = _ref$paymentStatus === undefined ? '' : _ref$paymentStatus,
	      _ref$status = _ref.status,
	      status = _ref$status === undefined ? {} : _ref$status,
	      paidAmount = _ref.paidAmount,
	      price = _ref.copay,
	      visitType = _ref.visitType;
	  var detailsView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var appointmentStatus = (0, _get2.default)(status, 'coreAppName');
	  var isUrgentVisit = (0, _get2.default)(visitType, 'code') === _constants.URGENT_VISIT_TYPE_CODE;
	
	  switch (paymentStatus) {
	    case _constants.PAYMENT_STATUSES.PAID:
	      return {
	        id: tScope + '.paidAmount',
	        scope: { paidAmount: (0, _formatAmount.formatAmount)(paidAmount || 0) }
	      };
	
	    case _constants.PAYMENT_STATUSES.VOIDED:
	      return (0, _extends3.default)({
	        id: tScope + '.refunded'
	      }, isUrgentVisit && !price && { id: tScope + '.tapToPay' }, {
	        scope: {
	          price: (0, _formatAmount.formatAmount)(price || 0),
	          paidAmount: (0, _formatAmount.formatAmount)(paidAmount || 0)
	        }
	      });
	
	    case _constants.PAYMENT_STATUSES.PENDING:
	      return { id: tScope + '.processingPayment' };
	
	    case _constants.PAYMENT_STATUSES.UNPAID:
	    case _constants.PAYMENT_STATUSES.FAILED:
	      switch (appointmentStatus) {
	        case _constants.APPOINTMENT_STATUSES.DRAFT:
	        case _constants.APPOINTMENT_STATUSES.WAITING:
	        case _constants.APPOINTMENT_STATUSES.UPCOMING:
	        case _constants.APPOINTMENT_STATUSES.IN_PROCESS:
	        case _constants.APPOINTMENT_STATUSES.CHECKED_IN:
	          {
	            var payI18n = detailsView ? 'totalToPay' : 'tapToPay';
	            var isZeroCopay = price === 0;
	
	            return price || isZeroCopay ? {
	              id: tScope + '.' + payI18n,
	              scope: { price: (0, _formatAmount.formatAmount)(isZeroCopay ? 0 : price) },
	              canPay: true
	            } : { id: tScope + '.amountPending' };
	          }
	
	        case _constants.APPOINTMENT_STATUSES.NO_SHOW:
	        case _constants.APPOINTMENT_STATUSES.CANCELED:
	        case _constants.APPOINTMENT_STATUSES.COMPLETED:
	          {
	            return (0, _extends3.default)({
	              id: tScope + '.amountPending'
	            }, isUrgentVisit && {
	              canPay: true,
	              scope: { price: (0, _formatAmount.formatAmount)(price || 0) }
	            });
	          }
	
	        default:
	          return { id: tScope + '.amountPending' };
	      }
	
	    default:
	      return { id: tScope + '.amountPending' };
	  }
	}
	
	function formatPaymentInfoProviderContext(_ref2) {
	  var _ref2$paymentStatus = _ref2.paymentStatus,
	      paymentStatus = _ref2$paymentStatus === undefined ? '' : _ref2$paymentStatus,
	      paidAmount = _ref2.paidAmount,
	      price = _ref2.copay;
	
	  switch (paymentStatus) {
	    case _constants.PAYMENT_STATUSES.PAID:
	      return {
	        id: tScope + '.paidAmount',
	        scope: { paidAmount: (0, _formatAmount.formatAmount)(paidAmount || 0) }
	      };
	
	    case _constants.PAYMENT_STATUSES.VOIDED:
	      return {
	        id: tScope + '.voided',
	        scope: { paidAmount: (0, _formatAmount.formatAmount)(paidAmount || 0) }
	      };
	
	    case _constants.PAYMENT_STATUSES.FAILED:
	    case _constants.PAYMENT_STATUSES.UNPAID:
	      return {
	        id: tScope + '.unpaidAmount',
	        scope: { price: (0, _formatAmount.formatAmount)(price || 0) }
	      };
	
	    default:
	      return { id: tScope + '.amountPending' };
	  }
	}
	
	function visitOverviewAdapter() {
	  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      providerInfo = _ref3.providerInfo,
	      dateTime = _ref3.dateTime,
	      location = _ref3.location,
	      note = _ref3.note,
	      reasonType = _ref3.reasonType;
	
	  var provider = (0, _extends3.default)({}, providerInfo, {
	    location: location
	  });
	  var schedule = { time: dateTime };
	  var reason = {
	    type: (0, _get2.default)(reasonType, 'name'),
	    note: note || ''
	  };
	
	  return { provider: provider, schedule: schedule, reason: reason };
	}
	
	function appointmentTargetUserAdapter(appointment, providerView) {
	  var provider = (0, _get2.default)(appointment, 'providerInfo');
	  var location = (0, _get2.default)(appointment, 'location');
	
	  if (providerView) {
	    var username = (0, _get2.default)(appointment, 'patientUserInfo.username');
	    var name = (0, _get2.default)(appointment, 'patientUserInfo.displayableName', username);
	    var avatar = (0, _get2.default)(appointment, 'patientUserInfo.avatar');
	
	    provider = { name: name, avatar: avatar };
	  }
	
	  return {
	    provider: (0, _extends3.default)({}, provider, { location: location })
	  };
	}
	var onlyDateFormat = (0, _dateFilter.momentFormat)('MMM D');
	
	function getAppointmentTime(_ref4) {
	  var appointment = _ref4.appointment,
	      isUpcoming = _ref4.isUpcoming;
	
	  var dateTime = (0, _get2.default)(appointment, 'dateTime');
	  return {
	    hours: (0, _dateFilter.formatHours)(dateTime),
	    date: isUpcoming ? (0, _dateFilter.formatToCalendarTime)(dateTime) : onlyDateFormat(dateTime)
	  };
	}
	
	function getPaymentDetails(_ref5) {
	  var appointment = _ref5.appointment,
	      providerContext = _ref5.providerContext,
	      formatMessage = _ref5.formatMessage;
	
	  var status = (0, _get2.default)(appointment, 'status.coreAppName');
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	
	  if (_constants.INLINE_TYPES.includes(code)) {
	    return status;
	  }
	
	  var _ref6 = providerContext ? formatPaymentInfoProviderContext(appointment) : formatPaymentInfo(appointment),
	      id = _ref6.id,
	      scope = _ref6.scope;
	
	  var translation = formatMessage({ id: id }, scope);
	  return '' + translation;
	}
	
	function getInlineCellData(appointment, formatMessage) {
	  var startTime = (0, _get2.default)(appointment, 'location.schedule.metadata.startTime', '');
	  var endTime = (0, _get2.default)(appointment, 'location.schedule.metadata.endTime', '');
	
	  return {
	    title: formatMessage({ id: 'common.hours' }),
	    text: (0, _dateFilter.formatHours)(startTime) + ' - ' + (0, _dateFilter.formatHours)(endTime)
	  };
	}
	
	function getTransactionInfo(formatMessage, appointment) {
	  if ((0, _isEmpty2.default)(appointment)) return null;
	  var externalTransaction = (0, _get2.default)(appointment, 'externalTransaction', {});
	
	  var _ref7 = externalTransaction || {},
	      id = _ref7.id,
	      createdAt = _ref7.createdAt;
	
	  return [[{
	    title: formatMessage({ id: 'appointment.info.transactionDate' }),
	    subtitle: createdAt ? (0, _dateFilter.momentFormat)('L')(createdAt) : ' - '
	  }, {
	    title: formatMessage({ id: 'appointment.info.transactionId' }),
	    subtitle: id || ' - '
	  }]];
	}
	
	function checkMandatoryPaymentWarning(appointment) {
	  if (!appointment) return false;
	  var isRequiredPayment = appointment.isRequiredPayment,
	      copay = appointment.copay,
	      paymentStatus = appointment.paymentStatus;
	
	  if (!isRequiredPayment) return false;
	  return copay > 0 && paymentStatus !== _constants.PAYMENT_STATUSES.PAID;
	}
	
	function getMyProviderDetails(formatMessage, provider, languageTypes) {
	  if ((0, _isEmpty2.default)(provider)) return null;
	
	  var getLanguageString = function getLanguageString(languages) {
	    return languages.map(function (key) {
	      var matched = languageTypes.find(function (_ref8) {
	        var value = _ref8.value;
	        return key === value;
	      });
	      return matched ? matched.label : key;
	    }).join(', ');
	  };
	
	  return [[{
	    title: formatMessage({ id: 'appointments.specialization' }),
	    subtitle: provider.specialization || ' - '
	  }, {
	    title: formatMessage({ id: 'profile.fields.language' }),
	    subtitle: provider.languages.length > 0 ? getLanguageString(provider.languages) : ' - '
	  }]];
	}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _common = __webpack_require__(135);
	
	var usePaperworkFlowFormSteps = function usePaperworkFlowFormSteps() {
	  var currentPathname = window.location.pathname;
	
	  var currentStepNumber = (0, _reactRedux.useSelector)((0, _common.selectPaperworkFlowFormStepNumber)(currentPathname));
	
	  var stepsCount = (0, _reactRedux.useSelector)(_common.selectPaperworkFlowFormStepsCount);
	
	  return {
	    currentStepNumber: currentStepNumber,
	    stepsCount: stepsCount
	  };
	};
	
	exports.default = usePaperworkFlowFormSteps;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPreVisitForm = undefined;
	exports.convertPreVisitFormData = convertPreVisitFormData;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getName(param) {
	  return (0, _get2.default)(param, 'name');
	}
	
	function convertPreVisitFormData(formatMessage, appointment) {
	  if ((0, _isEmpty2.default)(appointment)) return null;
	  var visitReason = appointment.visitReason,
	      visitType = appointment.visitType,
	      service = appointment.service,
	      providerInfo = appointment.providerInfo;
	
	
	  return [[{
	    title: formatMessage({ id: 'profile.actions.provider' }),
	    subtitle: getName(providerInfo)
	  }, {
	    title: formatMessage({ id: 'surveys.preVisit.serviceType' }),
	    subtitle: getName(service)
	  }], [{
	    title: formatMessage({ id: 'surveys.preVisit.visitType' }),
	    subtitle: getName(visitType)
	  }, {
	    title: formatMessage({ id: 'fields.reasonType' }),
	    subtitle: visitReason
	  }]];
	}
	
	var isPreVisitForm = exports.isPreVisitForm = function isPreVisitForm(type) {
	  return type === 'pre_visit';
	};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapChartData = __webpack_require__(3834);
	
	Object.defineProperty(exports, 'mapChartData', {
	  enumerable: true,
	  get: function get() {
	    return _mapChartData.mapChartData;
	  }
	});
	
	var _mapHistoryList = __webpack_require__(3835);
	
	Object.defineProperty(exports, 'mapHistoryList', {
	  enumerable: true,
	  get: function get() {
	    return _mapHistoryList.mapHistoryList;
	  }
	});
	
	var _getVisibleData = __webpack_require__(3832);
	
	Object.defineProperty(exports, 'getVisibleData', {
	  enumerable: true,
	  get: function get() {
	    return _getVisibleData.getVisibleData;
	  }
	});
	
	var _getVisibleDates = __webpack_require__(3833);
	
	Object.defineProperty(exports, 'getVisibleDates', {
	  enumerable: true,
	  get: function get() {
	    return _getVisibleDates.getVisibleDates;
	  }
	});
	
	var _converters = __webpack_require__(1823);
	
	Object.defineProperty(exports, 'dataConverter', {
	  enumerable: true,
	  get: function get() {
	    return _converters.dataConverter;
	  }
	});
	Object.defineProperty(exports, 'tooltipConverter', {
	  enumerable: true,
	  get: function get() {
	    return _converters.tooltipConverter;
	  }
	});
	
	var _getVisibleChartSources = __webpack_require__(3831);
	
	Object.defineProperty(exports, 'getVisibleChartSources', {
	  enumerable: true,
	  get: function get() {
	    return _getVisibleChartSources.getVisibleChartSources;
	  }
	});

/***/ }),
/* 290 */,
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PHARMACY_DATA_KEY = exports.EMERGENCY_CONTACT_DATA_KEY = exports.ROOT_META_DATA = exports.getAppMetadata = undefined;
	
	var _index = __webpack_require__(17);
	
	var _chars = __webpack_require__(258);
	
	var _styles = __webpack_require__(18);
	
	var APP_COLOR = _styles.COLORS.bluePrimary;
	
	var getAppMetadata = exports.getAppMetadata = function getAppMetadata(formatMessage) {
	  return {
	    htmlAttributes: { lang: '' + _index.LANG },
	    defaultTitle: formatMessage(_index.TITLE) + ' ' + _chars.DASH + ' ' + formatMessage(_index.DESCRIPTION),
	    title: '' + formatMessage(_index.DESCRIPTION),
	    titleTemplate: formatMessage(_index.TITLE) + ' ' + _chars.DASH + ' %s',
	    meta: [{ charset: 'utf-8' }, {
	      name: 'viewport',
	      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
	    }, { name: 'x-ua-compatible', content: 'ie=edge' }, { name: 'theme-color', content: '' + APP_COLOR }, { name: 'description', content: '' + formatMessage(_index.SLOGAN_PRIMARY) }, { name: 'description', content: '' + formatMessage(_index.SLOGAN_SECONDARY) }, { name: 'apple-mobile-web-app-status-bar-style', content: '' + APP_COLOR }],
	    link: [{ rel: 'shortcut icon', href: '/favicon.ico' }, { rel: 'apple-touch-icon', href: '/apple-icon-144x144.png' }, {
	      rel: 'apple-touch-icon',
	      sizes: '144x144',
	      href: '/apple-icon-144x144.png'
	    }],
	    base: { href: '#' }
	  };
	};
	
	var ROOT_META_DATA = exports.ROOT_META_DATA = {
	  title: 'Messaging'
	};
	
	var EMERGENCY_CONTACT_DATA_KEY = exports.EMERGENCY_CONTACT_DATA_KEY = 'emergency_contact_attributes';
	var PHARMACY_DATA_KEY = exports.PHARMACY_DATA_KEY = 'emergency_contact_attributes';

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'check-insurance-eligibility', ['INIT']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'insurance_eligibility',
	  type: 'post',
	  slug: ['results']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      {
	        var _normalize = (0, _inspectionNormalizer2.default)(payload),
	            ids = _normalize.result,
	            entities = _normalize.entities.inspections,
	            requiredSteps = _normalize.requiredSteps;
	
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true,
	          requiredSteps: requiredSteps,
	          ids: ids,
	          entities: entities
	        });
	      }
	
	    case consts.SET_ENTITY:
	      {
	        return (0, _extends3.default)({}, state, {
	          entities: (0, _extends3.default)({}, state.entities, payload)
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _inspectionNormalizer = __webpack_require__(1863);
	
	var _inspectionNormalizer2 = _interopRequireDefault(_inspectionNormalizer);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'inspection-req', ['SET_ENTITY']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: ['form_inspections']
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  ids: [],
	  entities: {},
	  requiredSteps: []
	});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectAppointmentAccountFormPaymentSending = exports.selectCurrentAppointmentId = exports.selectCurrentAppointment = exports.selectAppointmentsMainState = exports.selectAppointmentsState = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectAdapter = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectAppointmentsState = exports.selectAppointmentsState = function selectAppointmentsState(state) {
	  return (0, _get2.default)(state, 'appointments');
	};
	
	var selectAppointmentsMainState = exports.selectAppointmentsMainState = function selectAppointmentsMainState(state) {
	  return (0, _get2.default)(state, 'appointmentsState');
	};
	
	var selectCurrentAppointment = exports.selectCurrentAppointment = (0, _reselect.createSelector)(selectAppointmentsState, function (state) {
	  return (0, _get2.default)(state, 'data', null);
	});
	
	var selectCurrentAppointmentId = exports.selectCurrentAppointmentId = (0, _reselect.createSelector)(selectCurrentAppointment, function (state) {
	  return (0, _get2.default)(state, 'status.id', null);
	});
	
	/**
	 *  APPOINTMENT ACCOUNT FORM PAYMENT
	 * */
	
	var getAppointmentAccountFormPaymentSelectors = (0, _selectAdapter.makeSelectorFactory)(selectAppointmentsMainState);
	
	var _getAppointmentAccoun = getAppointmentAccountFormPaymentSelectors('appointmentAccountFormPayment'),
	    selectAppointmentAccountFormPaymentSending = _getAppointmentAccoun.selectStatePending;
	
	exports.selectAppointmentAccountFormPaymentSending = selectAppointmentAccountFormPaymentSending;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqSocialChannel');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'social_chat_rooms',
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.availableProgramsSelector = exports.hasSubFiltersSelector = exports.subFiltersSelector = exports.activeFilterSelector = exports.searchQuerySelector = exports.statusSelector = exports.programValueSelector = exports.typeSelector = exports.loadedStateSelector = exports.loadingStateSelector = exports.succeedSelector = exports.sendingSelector = exports.hasFiltersSelector = exports.availableFiltersSelector = exports.filtersSelector = exports.reqFiltersSelector = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reqFiltersSelector = exports.reqFiltersSelector = function reqFiltersSelector(state) {
	  return state.board.reqFilters;
	};
	var filtersSelector = exports.filtersSelector = function filtersSelector(state) {
	  return state.board.filters;
	};
	
	var availableFiltersSelector = exports.availableFiltersSelector = (0, _reselect.createSelector)(filtersSelector, function (filters) {
	  return (0, _get2.default)(filters, 'availableFilters', []);
	});
	
	var hasFiltersSelector = exports.hasFiltersSelector = (0, _reselect.createSelector)(availableFiltersSelector, function (filters) {
	  return !!(0, _get2.default)(filters, 'length', 0);
	});
	
	var sendingSelector = exports.sendingSelector = (0, _reselect.createSelector)(reqFiltersSelector, function (request) {
	  return (0, _get2.default)(request, 'sending') || false;
	});
	
	var succeedSelector = exports.succeedSelector = (0, _reselect.createSelector)(reqFiltersSelector, function (request) {
	  return (0, _get2.default)(request, 'succeed') || false;
	});
	
	// loading / loaded states
	var loadingStateSelector = exports.loadingStateSelector = (0, _reselect.createSelector)(sendingSelector, succeedSelector, function (sending, succeed) {
	  return sending && !succeed;
	});
	
	var loadedStateSelector = exports.loadedStateSelector = (0, _reselect.createSelector)(sendingSelector, succeedSelector, hasFiltersSelector, function (sending, succeed, hasFilters) {
	  return !sending && succeed && hasFilters;
	});
	
	// filters
	var typeSelector = exports.typeSelector = (0, _reselect.createSelector)(filtersSelector, function (filters) {
	  return (0, _get2.default)(filters, 'type');
	});
	
	var programValueSelector = exports.programValueSelector = (0, _reselect.createSelector)(filtersSelector, function (filters) {
	  return (0, _get2.default)(filters, 'programValue');
	});
	
	var statusSelector = exports.statusSelector = (0, _reselect.createSelector)(filtersSelector, function (filters) {
	  return (0, _get2.default)(filters, 'status');
	});
	
	var searchQuerySelector = exports.searchQuerySelector = (0, _reselect.createSelector)(filtersSelector, function (filters) {
	  return (0, _get2.default)(filters, 'searchQuery');
	});
	
	var activeFilterSelector = exports.activeFilterSelector = (0, _reselect.createSelector)(availableFiltersSelector, typeSelector, function (filters, type) {
	  return filters.find(function (option) {
	    return option.filterValue === type;
	  });
	});
	
	var subFiltersSelector = exports.subFiltersSelector = (0, _reselect.createSelector)(activeFilterSelector, function (option) {
	  return (0, _get2.default)(option, 'subfilters');
	});
	
	var hasSubFiltersSelector = exports.hasSubFiltersSelector = (0, _reselect.createSelector)(subFiltersSelector, function (subFilters) {
	  return !!subFilters;
	});
	
	var availableProgramsSelector = exports.availableProgramsSelector = (0, _reselect.createSelector)(subFiltersSelector, function (subFilters) {
	  if (!subFilters) return [];
	
	  var programs = subFilters.filter(function (filter) {
	    return filter.filterKey === 'program';
	  });
	
	  return programs.map(function (program) {
	    var icon = void 0;
	
	    switch (program.filterValue) {
	      case _props.PROGRAM_VALUE_TYPES.all:
	        {
	          icon = 'all-programs';
	          break;
	        }
	      case _props.PROGRAM_VALUE_TYPES.none:
	        {
	          icon = 'no-program';
	          break;
	        }
	      default:
	        {
	          icon = 'program-filter';
	          break;
	        }
	    }
	
	    return (0, _extends3.default)({}, program, { icon: icon });
	  });
	});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _circlesActions = __webpack_require__(1913);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'caregiver', ['REMOVE_ITEM', 'REMOVE_MEMBER', 'REMOVE_CAREGIVER', 'ADD_INVITATION', 'REMOVE_INVITATION']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'member_caregiver_circles',
	  type: 'get'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.REMOVE_ITEM:
	      return (0, _circlesActions.removeItem)(state, payload);
	    case consts.REMOVE_MEMBER:
	      return (0, _circlesActions.removeMember)(state, payload);
	    case consts.REMOVE_CAREGIVER:
	      return (0, _circlesActions.removeRole)(state, payload, { caregiver: false });
	    case consts.ADD_INVITATION:
	      return (0, _circlesActions.addInvitation)(state, payload);
	    case consts.REMOVE_INVITATION:
	      return (0, _circlesActions.removeInvitation)(state, payload);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = exports.CLEAR = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLEAR = exports.CLEAR = 'CLEAR';
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'leaveFamilyCircle', [CLEAR]);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'family_members', {
	    type: 'payload',
	    selector: ['memberId']
	  }]
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var clear = function clear(state) {
	  return (0, _extends3.default)({}, state, {
	    succeed: null,
	    error: null
	  });
	};
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return clear(state);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _sortBy = __webpack_require__(1562);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['ADD_COMMENT', 'LOAD_COMMENTS', 'LOAD_NEW_COMMENTS', 'LOAD_OLDER_COMMENTS', 'UPDATE_COMMENTS_LIST', 'DELETE_COMMENT', 'EDIT_COMMENT', 'CLEAR', 'EDIT_COMMENT_STATUS'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['communities', 'commentsList'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var addComment = function addComment(state, payload) {
	  var parentId = payload.parentId;
	
	
	  if (!parentId) return [payload].concat((0, _toConsumableArray3.default)(state));
	
	  // nested comment
	  var parentCommentIndex = state.findIndex(function (item) {
	    return item.id === parentId;
	  });
	  var parentComment = state[parentCommentIndex];
	
	  // eslint-disable-next-line no-param-reassign
	  delete payload.comments;
	
	  return [].concat((0, _toConsumableArray3.default)(state.slice(0, parentCommentIndex)), [(0, _assign2.default)({}, parentComment, {
	    comments: [].concat((0, _toConsumableArray3.default)(parentComment.comments), [payload])
	  })], (0, _toConsumableArray3.default)(state.slice(parentCommentIndex + 1)));
	};
	
	var doChangeInArray = function doChangeInArray(array, id, change) {
	  var index = array.findIndex(function (i) {
	    return i.id === parseInt(id, 10);
	  });
	
	  return [].concat((0, _toConsumableArray3.default)(array.slice(0, index)), [(0, _extends3.default)({}, array[index], change)], (0, _toConsumableArray3.default)(array.slice(index + 1)));
	};
	
	var deleteComment = function deleteComment(state, payload) {
	  var id = payload.id,
	      parentId = payload.parentId;
	
	
	  if (!parentId) {
	    return doChangeInArray(state, id, { deleted: true });
	  }
	  // Nested comment
	  var parentComment = state.find(function (i) {
	    return i.id === parentId;
	  });
	  var parentIndex = state.indexOf(parentComment);
	  parentComment.comments = doChangeInArray(parentComment.comments, id, {
	    deleted: true
	  });
	
	  return [].concat((0, _toConsumableArray3.default)(state.slice(0, parentIndex)), [(0, _extends3.default)({}, parentComment)], (0, _toConsumableArray3.default)(state.slice(parentIndex + 1)));
	};
	
	var editComment = function editComment(state, payload) {
	  var id = payload.id,
	      parentId = payload.parentId,
	      content = payload.content;
	
	  var change = { content: content, updated: true };
	
	  if (!parentId) {
	    return doChangeInArray(state, id, change);
	  }
	  // Nested comment
	  var parentComment = state.find(function (i) {
	    return i.id === parentId;
	  });
	  var parentIndex = state.indexOf(parentComment);
	  parentComment.comments = doChangeInArray(parentComment.comments, id, change);
	
	  return [].concat((0, _toConsumableArray3.default)(state.slice(0, parentIndex)), [(0, _extends3.default)({}, parentComment)], (0, _toConsumableArray3.default)(state.slice(parentIndex + 1)));
	};
	
	var editCommentStatus = function editCommentStatus(state, payload) {
	  var id = payload.id,
	      parentId = payload.parentId,
	      prop = payload.prop;
	
	  var change = prop;
	
	  if (!parentId) {
	    return doChangeInArray(state, id, change);
	  }
	  // Nested comment
	  var parentComment = state.find(function (i) {
	    return i.id === parentId;
	  });
	  var parentIndex = state.indexOf(parentComment);
	  parentComment.comments = doChangeInArray(parentComment.comments, id, change);
	
	  return [].concat((0, _toConsumableArray3.default)(state.slice(0, parentIndex)), [(0, _extends3.default)({}, parentComment)], (0, _toConsumableArray3.default)(state.slice(parentIndex + 1)));
	};
	
	var updateCommentsList = function updateCommentsList(state, payload) {
	  var notifications = [].concat((0, _toConsumableArray3.default)(payload.newComments));
	  var postId = payload.postId;
	
	  var newState = [].concat((0, _toConsumableArray3.default)(state));
	  notifications.forEach(function (item) {
	    var newComment = {
	      author: (0, _get2.default)(item, 'author'),
	      createdAt: new Date((0, _get2.default)(item, 'createdAt', Date.now())),
	      content: (0, _get2.default)(item, 'content'),
	      id: (0, _get2.default)(item, 'id'),
	      isNewComment: (0, _get2.default)(item, 'isNewComment'),
	      postId: postId
	    };
	
	    if (!item.parentId) {
	      newComment.comments = [];
	
	      return newState.push(newComment);
	    }
	
	    var updatedIndex = newState.findIndex(function (comment) {
	      return comment.id === item.parentId;
	    });
	    var replies = newState[updatedIndex].comments;
	
	    newState[updatedIndex].comments = (0, _sortBy2.default)([].concat((0, _toConsumableArray3.default)(replies), [newComment]), ['id']);
	  });
	
	  return (0, _sortBy2.default)(newState, ['id']).reverse();
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	  switch (type) {
	    case consts.ADD_COMMENT:
	      return addComment(state, payload);
	    case consts.DELETE_COMMENT:
	      return deleteComment(state, payload);
	    case consts.LOAD_OLDER_COMMENTS:
	      return [].concat((0, _toConsumableArray3.default)(state), (0, _toConsumableArray3.default)(payload));
	    case consts.LOAD_NEW_COMMENTS:
	      return [].concat((0, _toConsumableArray3.default)(payload), (0, _toConsumableArray3.default)(state));
	    case consts.LOAD_COMMENTS:
	      return payload;
	    case consts.UPDATE_COMMENTS_LIST:
	      return updateCommentsList(state, payload);
	    case consts.EDIT_COMMENT:
	      return editComment(state, payload);
	    case consts.EDIT_COMMENT_STATUS:
	      return editCommentStatus(state, payload);
	    case consts.CLEAR:
	      return [];
	    default:
	      return state;
	  }
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(58);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'notificationCounters', ['UPDATE_COMMUNITY_COUNT', 'UPDATE_ACTIVITY_COUNT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'notification_counters',
	  type: 'get'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	  var change = payload;
	  var getPrevCount = function getPrevCount(param) {
	    return (0, _lodash.get)(state, param);
	  };
	
	  switch (type) {
	    case consts.UPDATE_COMMUNITY_COUNT:
	      return (0, _extends3.default)({}, state, {
	        communityNotificationsCount: getPrevCount('communityNotificationsCount') + change
	      });
	    case consts.UPDATE_ACTIVITY_COUNT:
	      return (0, _extends3.default)({}, state, {
	        activityNotificationsCount: getPrevCount('activityNotificationsCount') + change
	      });
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectAcceptDeclineDisabledState = exports.currentCommunityTemporaryPostsSelector = exports.currentCommunityScrollSelector = exports.currentCommunityScrollStatusSelector = exports.currentCommunitySelector = exports.isCurrentCommunityMemberSelector = exports.isCurrentCommunityModeratorSelector = exports.selectCurrentCommunityDisabled = exports.sendingCurrentCommunityInfoSelector = exports.currentCommunityPostsListSelector = exports.currentCommunityInfoSelector = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _index = __webpack_require__(60);
	
	var _constants = __webpack_require__(17);
	
	var _selectors = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentCommunityInfoSelector = exports.currentCommunityInfoSelector = function currentCommunityInfoSelector(state) {
	  return (0, _get2.default)(state, 'communities.currentCommunityInfo');
	};
	var currentCommunityPostsListSelector = exports.currentCommunityPostsListSelector = function currentCommunityPostsListSelector(state) {
	  return (0, _get2.default)(state, 'communities.postsList');
	};
	
	var sendingCurrentCommunityInfoSelector = exports.sendingCurrentCommunityInfoSelector = (0, _index.createSelector)(currentCommunityInfoSelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	var selectCurrentCommunityDisabled = exports.selectCurrentCommunityDisabled = (0, _index.createSelector)(currentCommunityInfoSelector, function (request) {
	  return (0, _get2.default)(request, 'disabled', false);
	});
	
	var isCurrentCommunityModeratorSelector = exports.isCurrentCommunityModeratorSelector = (0, _index.createSelector)(currentCommunityInfoSelector, function (request) {
	  return (0, _get2.default)(request, 'currentUserRole', null) === _constants.COMMUNITIES_USER_ROLES.MODERATOR;
	});
	
	var isCurrentCommunityMemberSelector = exports.isCurrentCommunityMemberSelector = (0, _index.createSelector)(currentCommunityInfoSelector, function (request) {
	  return (0, _get2.default)(request, 'currentUserRole', null) === _constants.COMMUNITIES_USER_ROLES.MEMBER;
	});
	
	var currentCommunitySelector = exports.currentCommunitySelector = (0, _index.createSelector)(currentCommunityInfoSelector, function (request) {
	  return (0, _get2.default)(request, 'id', null);
	});
	
	var currentCommunityScrollStatusSelector = exports.currentCommunityScrollStatusSelector = function currentCommunityScrollStatusSelector(state) {
	  return (0, _get2.default)(state, 'communities.currentCommunityScrollStatus');
	};
	
	var currentCommunityScrollSelector = exports.currentCommunityScrollSelector = (0, _index.createSelector)(currentCommunityScrollStatusSelector, function (state) {
	  return (0, _get2.default)(state, 'scrolled', false);
	});
	
	var currentCommunityTemporaryPostsSelector = exports.currentCommunityTemporaryPostsSelector = (0, _index.createSelector)(currentCommunityScrollStatusSelector, function (state) {
	  return (0, _get2.default)(state, 'temporaryPostList', []);
	});
	
	var selectAcceptDeclineDisabledState = exports.selectAcceptDeclineDisabledState = (0, _index.createSelector)(selectCurrentCommunityDisabled, _selectors.selectAcceptDeclinePending, function (communityDisabled, inviteDisabled) {
	  return communityDisabled || inviteDisabled;
	});

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'delete-document', ['UPDATE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'documents', {
	    type: 'payload',
	    selector: ['documentId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isArray = __webpack_require__(96);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _redux = __webpack_require__(7);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestOptions = {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'healthboard', 'scheduled_tasks', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'scheduled-tasks-req', ['LOAD_MORE', 'TOGGLE_VISIBILITY', 'REMOVE_ENTITY', 'UPDATE_INSURANCE_CARD_FOR_TO_DO_TASK']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('health-board', 'scheduled-tasks-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions, true);
	
	var reducer = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'tasksCount'
	});
	
	exports.default = function (state, action) {
	  switch (action.type) {
	    case consts.TOGGLE_VISIBILITY:
	      {
	        var _action$payload = action.payload,
	            type = _action$payload.type,
	            id = _action$payload.id,
	            _action$payload$match = _action$payload.matchParam,
	            matchParam = _action$payload$match === undefined ? 'id' : _action$payload$match,
	            visible = _action$payload.visible;
	
	        var count = visible ? state.count + 1 : state.count - 1;
	        var list = state.list.map(function (item) {
	          if (item.type === type && item.payload[matchParam] === id) {
	            return (0, _extends3.default)({}, item, {
	              payload: (0, _extends3.default)({}, item.payload, {
	                hidden: !visible
	              })
	            });
	          }
	
	          return item;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          list: list,
	          count: count >= 0 ? count : 0
	        });
	      }
	
	    case _signAppointmentConsentReq.consts.SUCCEED:
	      {
	        var appointmentConsentId = action.payload.appointmentConsentId;
	        var _count = state.count;
	
	        var _list = state.list ? state.list.reduce(function (acc, task) {
	          if (task.type === _constants.TODO_TYPES.CONSENT) {
	            var consents = (0, _get2.default)(task, 'payload.consents');
	
	            if (!consents || !(0, _isArray2.default)(consents)) return task;
	
	            consents = consents.filter(function (_ref) {
	              var id = _ref.id;
	              return id !== appointmentConsentId;
	            });
	
	            if (consents.length === 0) {
	              _count -= 1;
	              return acc;
	            }
	
	            return [].concat((0, _toConsumableArray3.default)(acc), [(0, _extends3.default)({}, task, {
	              payload: (0, _extends3.default)({}, task.payload, {
	                consents: consents
	              })
	            })]);
	          }
	
	          return [].concat((0, _toConsumableArray3.default)(acc), [task]);
	        }, []) : [];
	
	        var filteredList = _list.filter(function (listItem) {
	          if (listItem.type === _constants.TODO_TYPES.CONSENT_USER_ASSIGNMENT) {
	            var removedConsentId = (0, _get2.default)(listItem, 'payload.consent.id');
	
	            if (appointmentConsentId === removedConsentId) {
	              _count -= 1;
	              return false;
	            }
	
	            return true;
	          }
	
	          return true;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          count: _count >= 0 ? _count : 0,
	          list: filteredList
	        });
	      }
	
	    case consts.REMOVE_ENTITY:
	      {
	        var _action$payload2 = action.payload,
	            _type = _action$payload2.type,
	            _id = _action$payload2.id,
	            _action$payload2$matc = _action$payload2.matchParam,
	            _matchParam = _action$payload2$matc === undefined ? 'id' : _action$payload2$matc,
	            keepCount = _action$payload2.keepCount;
	
	        var _count2 = keepCount ? state.count : state.count - 1;
	        var _list2 = state.list.filter(function (task) {
	          if (task.type === _type) {
	            return task.payload[_matchParam] !== _id;
	          }
	          return true;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          count: _count2 >= 0 ? _count2 : 0,
	          list: _list2
	        });
	      }
	
	    case consts.UPDATE_INSURANCE_CARD_FOR_TO_DO_TASK:
	      {
	        var payload = action.payload;
	
	
	        var _list3 = state.list.map(function (item) {
	          if ('patientInsurance' in item.payload && 'id' in item.payload.patientInsurance && item.payload.patientInsurance.id === payload.id) {
	            return (0, _extends3.default)({}, item, {
	              payload: (0, _extends3.default)({}, item.payload, {
	                patientInsurance: (0, _extends3.default)({}, item.payload.patientInsurance, payload)
	              })
	            });
	          }
	
	          return item;
	        });
	
	        return (0, _extends3.default)({}, state, { list: _list3 });
	      }
	
	    default:
	      return reducer(state, action);
	  }
	};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'upload-document', ['START_UPLOAD']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'documents']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.virtualVisitActions = exports.VIRTUAL_VISIT_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionScope = 'virtual-visit';
	
	var VIRTUAL_VISIT_TYPES = exports.VIRTUAL_VISIT_TYPES = {
	  SET_FULL_SCREEN_VIEW: actionScope + '/set-full-screen-view',
	  TOGGLE_MOB_SIDEBAR: actionScope + '/toggle-mob-sidebar',
	  SET_VISIBILITY: actionScope + '/set-visibility',
	  SET_COLLAPSING: actionScope + '/set-collapsing',
	  SET_DRAGGING: actionScope + '/set-draging',
	  SET_CONFIG: actionScope + '/set-config',
	  SET_ACTIVE: actionScope + '/set-active',
	  RESET: actionScope + '/reset'
	};
	
	var virtualVisitActions = exports.virtualVisitActions = {
	  setFullScreenView: (0, _createAction.createAction)(VIRTUAL_VISIT_TYPES.SET_FULL_SCREEN_VIEW),
	  toggleMobSidebar: (0, _createAction.createAction)(VIRTUAL_VISIT_TYPES.TOGGLE_MOB_SIDEBAR),
	  setVisibility: (0, _createAction.createAction)(VIRTUAL_VISIT_TYPES.SET_VISIBILITY),
	  setCollapsing: (0, _createAction.createAction)(VIRTUAL_VISIT_TYPES.SET_COLLAPSING),
	  setDragging: (0, _createAction.createAction)(VIRTUAL_VISIT_TYPES.SET_DRAGGING),
	  setConfig: (0, _createAction.createAction)(VIRTUAL_VISIT_TYPES.SET_CONFIG),
	  setActive: (0, _createAction.createAction)(VIRTUAL_VISIT_TYPES.SET_ACTIVE),
	  reset: (0, _createAction.createAction)(VIRTUAL_VISIT_TYPES.RESET)
	};
	
	var initialState = {
	  isOpenedMobSidebar: false,
	  fullScreenView: false,
	  opened: false,
	  collapsed: false,
	  dragging: false,
	  active: false,
	  config: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case VIRTUAL_VISIT_TYPES.SET_VISIBILITY:
	      {
	        return (0, _extends3.default)({}, state, { opened: payload });
	      }
	
	    case VIRTUAL_VISIT_TYPES.SET_COLLAPSING:
	      {
	        return (0, _extends3.default)({}, state, { collapsed: payload });
	      }
	
	    case VIRTUAL_VISIT_TYPES.SET_DRAGGING:
	      {
	        return (0, _extends3.default)({}, state, { dragging: payload });
	      }
	
	    case VIRTUAL_VISIT_TYPES.SET_CONFIG:
	      {
	        return (0, _extends3.default)({}, state, { config: payload });
	      }
	
	    case VIRTUAL_VISIT_TYPES.SET_ACTIVE:
	      {
	        return (0, _extends3.default)({}, state, { active: payload });
	      }
	
	    case VIRTUAL_VISIT_TYPES.RESET:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    case VIRTUAL_VISIT_TYPES.TOGGLE_MOB_SIDEBAR:
	      {
	        return (0, _extends3.default)({}, state, { isOpenedMobSidebar: !state.isOpenedMobSidebar });
	      }
	
	    case VIRTUAL_VISIT_TYPES.SET_FULL_SCREEN_VIEW:
	      {
	        return (0, _extends3.default)({}, state, { fullScreenView: payload });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OTContext = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(266);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.OTContextProvider = OTContextProvider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _core = __webpack_require__(4127);
	
	var _injectSaga = __webpack_require__(116);
	
	var _constants = __webpack_require__(420);
	
	var _reducer = __webpack_require__(4133);
	
	var _utils = __webpack_require__(307);
	
	var _actions = __webpack_require__(1318);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _useVirtualVisit2 = __webpack_require__(352);
	
	var _refreshSessionIntervalSaga = __webpack_require__(3951);
	
	var _refreshSessionIntervalSaga2 = _interopRequireDefault(_refreshSessionIntervalSaga);
	
	var _sentryMethods = __webpack_require__(437);
	
	var _signal = __webpack_require__(1893);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initOpenTokState(initialPendingInvitations) {
	  var invitations = Array.isArray(initialPendingInvitations) ? initialPendingInvitations : [];
	  return (0, _extends3.default)({}, _reducer.initialState, { invitations: invitations });
	} /* eslint-disable no-unused-expressions,compat/compat */
	var OTContext = exports.OTContext = (0, _react.createContext)({
	  state: _reducer.initialState,
	  startVisit: function startVisit() {},
	  endVisit: function endVisit() {},
	  openInviteModal: function openInviteModal() {},
	  PUBLISHER_KEY: _constants.PUB_KEY,
	  focusedId: null,
	  getUserMedia: function getUserMedia() {
	    return _promise2.default.resolve();
	  },
	  initialMediaDevices: null,
	  otPublisher: null,
	  setPin: function setPin() {},
	  isProvider: true
	});
	
	function OTContextProvider(_ref) {
	  var startVisit = function () {
	    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (config) {
	                _context.next = 2;
	                break;
	              }
	
	              throw new Error('No Config found');
	
	            case 2:
	              _context.next = 4;
	              return OTCORE_REF.current.startVideoCall();
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function startVisit() {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var children = _ref.children,
	      config = _ref.config,
	      isProvider = _ref.isProvider,
	      _ref$initialPendingIn = _ref.initialPendingInvitations,
	      initialPendingInvitations = _ref$initialPendingIn === undefined ? [] : _ref$initialPendingIn;
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'refreshSessionIntervalSaga',
	    saga: _refreshSessionIntervalSaga2.default,
	    mode: _sagaInjectors.RESTART_ON_REMOUNT
	  });
	
	  var _useVirtualVisit = (0, _useVirtualVisit2.useVirtualVisit)(),
	      callState = _useVirtualVisit.callState,
	      publisherUserData = _useVirtualVisit.publisherUserData,
	      handleGlobalError = _useVirtualVisit.handleGlobalError,
	      openConfirmationPopup = _useVirtualVisit.openConfirmationPopup,
	      updateAppointment = _useVirtualVisit.updateAppointment;
	
	  var _useReducer = (0, _react.useReducer)(_reducer.reducer, initialPendingInvitations, initOpenTokState),
	      _useReducer2 = (0, _slicedToArray3.default)(_useReducer, 2),
	      state = _useReducer2[0],
	      dispatch = _useReducer2[1];
	
	  var pinnedId = state.pinnedId,
	      activeId = state.activeId,
	      lastActiveSpeaker = state.lastActiveSpeaker;
	
	  var OTCORE_REF = (0, _react.useRef)(null);
	
	  var focusedId = (0, _react.useMemo)(function () {
	    return pinnedId || activeId;
	  }, [activeId, pinnedId]);
	
	  (0, _react.useEffect)(function () {
	    var OT_CORE = new _core.OTCore({
	      config: config,
	      dispatch: dispatch,
	      isOnline: true,
	      handleGlobalError: handleGlobalError,
	      user: publisherUserData
	    });
	
	    _signal.OTSignal.handleProviderJoin = function () {
	      return updateAppointment();
	    };
	    _signal.OTSignal.handleProviderFinishCall = function (status) {
	      endVisit();
	      openConfirmationPopup(status);
	      updateAppointment();
	    };
	    OTCORE_REF.current = OT_CORE;
	
	    startVisit();
	
	    return function () {
	      if (OTCORE_REF.current) {
	        OTCORE_REF.current.destroy();
	        callState.destroyVisit();
	      }
	    };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (lastActiveSpeaker !== null) {
	      dispatch(_actions.opentokActions.setActiveId(lastActiveSpeaker));
	    }
	  }, [lastActiveSpeaker]);
	
	  function endVisit() {
	    (0, _sentryMethods.trackAppAction)('[ot-context] end visit');
	    if (OTCORE_REF.current) {
	      (0, _sentryMethods.sentryCaptureMessage)('VISIT FINISHED');
	      OTCORE_REF.current.destroy();
	      OTCORE_REF.current = undefined;
	      callState.destroyVisit();
	    }
	  }
	
	  function sendSignal(_ref2) {
	    var data = _ref2.data,
	        type = _ref2.type;
	
	    if (OTCORE_REF.current) {
	      OTCORE_REF.current.otSession.session.signal({
	        data: data,
	        type: type
	      }, function (error) {
	        if (error) {
	          console.log('signal error (' + error.name + '): ' + error.message);
	        } else {
	          console.log('signal ' + type + ' sent.');
	        }
	      });
	    }
	  }
	
	  var setPin = function setPin(_ref4) {
	    var id = _ref4.id;
	    return dispatch(_actions.opentokActions.setPin(id));
	  };
	
	  var value = {
	    state: state,
	    sendSignal: sendSignal,
	    startVisit: startVisit,
	    endVisit: endVisit,
	    focusedId: focusedId,
	    setPin: setPin,
	    isProvider: isProvider,
	    PUBLISHER_KEY: _constants.PUB_KEY,
	    getUserMedia: _utils.getMediaDevices,
	    otPublisher: OTCORE_REF.current ? OTCORE_REF.current.otPublisher : null,
	    initialMediaDevices: OTCORE_REF.current ? OTCORE_REF.current.currentMediaDevices : null
	  };
	
	  return _react2.default.createElement(
	    OTContext.Provider,
	    { value: value },
	    children
	  );
	}
	
	OTContextProvider.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  config: _propTypes2.default.object.isRequired,
	  isProvider: _propTypes2.default.bool,
	  initialPendingInvitations: _propTypes2.default.array
	};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.SpeakerDetection = SpeakerDetection;
	exports.parseUserPayload = parseUserPayload;
	exports.getAllMediaDevices = getAllMediaDevices;
	exports.getMediaDevices = getMediaDevices;
	exports.formatName = formatName;
	exports.getOTErrorTranslationKey = getOTErrorTranslationKey;
	exports.normalizeDevices = normalizeDevices;
	
	var _camelize = __webpack_require__(364);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _bowser = __webpack_require__(1397);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _constants = __webpack_require__(420);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AUDIO_LEVEL_ACTIVITY = 0.12;
	var START_TIME_ACTIVITY = 100;
	var END_TIME_ACTIVITY = 800;
	
	function SpeakerDetection(subscriber, startTalking, stopTalking) {
	  var activity = null;
	
	  function handleAudioLevelUpdate(event) {
	    var now = Date.now();
	    if (event.audioLevel > AUDIO_LEVEL_ACTIVITY) {
	      if (!activity) {
	        activity = { timestamp: now, talking: false };
	      } else if (activity.talking) {
	        activity.timestamp = now;
	      } else if (now - activity.timestamp > START_TIME_ACTIVITY) {
	        activity.talking = true;
	        if (typeof startTalking === 'function') {
	          startTalking(event.target.stream);
	        }
	      }
	    } else if (activity && now - activity.timestamp > END_TIME_ACTIVITY) {
	      if (activity.talking) {
	        if (typeof stopTalking === 'function') {
	          stopTalking(event.target.stream);
	        }
	      }
	      activity = null;
	    }
	  }
	
	  subscriber.on('audioLevelUpdated', handleAudioLevelUpdate);
	
	  return function () {
	    subscriber.off('audioLevelUpdated', handleAudioLevelUpdate);
	  };
	}
	
	var parseJSONSafely = function parseJSONSafely(data) {
	  var value = void 0;
	
	  try {
	    value = JSON.parse(data);
	  } catch (e) {
	    value = null;
	  }
	
	  return value;
	};
	
	function parseUserPayload(data) {
	  var parsed = parseJSONSafely(data);
	  var result = !parsed ? {} : (0, _camelize2.default)(parsed);
	
	  var isProvider = (0, _get2.default)(result, 'isProvider', false);
	  var username = (0, _get2.default)(result, 'username');
	  var name = (0, _get2.default)(result, 'displayableName', username);
	  var id = (0, _get2.default)(result, 'id');
	  var avatar = (0, _get2.default)(result, 'avatar');
	
	  return { name: name, isProvider: isProvider, id: id, avatar: avatar };
	}
	
	function getAllMediaDevices() {
	  return new _promise2.default(function (resolve) {
	    OT.getDevices(function (err, devices) {
	      if (err || !devices) return resolve([]);
	      return resolve(devices);
	    });
	  });
	}
	
	function getMediaDevices() {
	  return new _promise2.default(function (resolve, reject) {
	    OT.getDevices(function (err, devices) {
	      if (err || !devices) {
	        return reject(err);
	      }
	
	      var audioSourceList = devices.filter(function (_ref) {
	        var kind = _ref.kind;
	        return kind === 'audioInput';
	      });
	      var videoSourceList = devices.filter(function (_ref2) {
	        var kind = _ref2.kind;
	        return kind === 'videoInput';
	      });
	
	      return resolve({ audioSourceList: audioSourceList, videoSourceList: videoSourceList });
	    });
	  });
	}
	
	function formatName(user, isMe, formatMessage, videoType) {
	  var you = formatMessage({ id: 'general.labels.you' });
	  return (0, _get2.default)(user, 'name') + ' ' + (isMe ? you : '') + '  ' + (videoType === _constants.SCREEN_SHARING_VIDEO_TYPE ? '(sharing screen)' : '');
	}
	
	function getOTErrorTranslationKey(name) {
	  var browser = _bowser2.default.parse(window.navigator.userAgent);
	  switch (name) {
	    case _constants.OT_ERROR_CODES.MEDIA_ACCESS_DENIED:
	      return {
	        title: 'virtualVisit.test.canAccessMicroCamera',
	        description: 'virtualVisit.test.giveAccessMicroCamera'
	      };
	
	    case _constants.OT_ERROR_CODES.HARDWARE_UNAVAILABLE:
	      return {
	        title: 'virtualVisit.error.cameraMicrophoneUnavailable.title',
	        description: 'virtualVisit.error.cameraMicrophoneUnavailable.description'
	      };
	
	    case _constants.OT_ERROR_CODES.NO_DEVICES_FOUND:
	      return {
	        title: 'virtualVisit.error.noDevicesFound.title',
	        description: 'virtualVisit.error.noDevicesFound'
	      };
	
	    case _constants.OT_ERROR_CODES.NO_VALID_CONSTRAINTS:
	      return {
	        title: 'virtualVisit.error.noValidConstraints.title',
	        description: 'virtualVisit.error.noValidConstraints'
	      };
	
	    case _constants.OT_ERROR_CODES.NOT_SUPPORTED:
	      return {
	        title: 'virtualVisit.error.notSupported.title',
	        description: 'virtualVisit.error.notSupported'
	      };
	
	    case _constants.OT_ERROR_CODES.SESSION_AUTH_ERROR:
	      return {
	        title: 'virtualVisit.error.expired.title',
	        description: 'virtualVisit.error.expired'
	      };
	
	    case _constants.OT_ERROR_CODES.SESSION_CONNECT_FAILED:
	    case _constants.OT_ERROR_CODES.SESSION_CONNECT_LIMIT:
	    case _constants.OT_ERROR_CODES.SESSION_INVALID_ID:
	    case _constants.OT_ERROR_CODES.NOT_CONNECTED:
	      return {
	        title: 'virtualVisit.error.sessionExpired.title',
	        description: 'virtualVisit.error.sessionExpired'
	      };
	
	    default:
	      return {
	        title: 'error.somethingWrong',
	        description: 'errors.appointment.unavailableVirtualRoom'
	      };
	  }
	}
	
	function normalizeDevices(list) {
	  return list.map(function (_ref3) {
	    var deviceId = _ref3.deviceId,
	        label = _ref3.label;
	    return { label: label, value: deviceId };
	  });
	}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'addPatientByProvider', ['CLEAR', 'ERROR', 'MESSAGE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider_patient_profiles',
	  type: 'post'
	});
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return _redux.initialState;
	    default:
	      return reqReducer(state, action);
	  }
	};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginatedWatcher = exports.watcher = exports.paginatedActions = exports.actions = exports.paginatedConsts = exports.consts = undefined;
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(58);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var request = {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'upcoming_assignments', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  pagination: {
	    offset: 0,
	    limit: 10
	  }
	});
	
	var supportedActions = ['REMOVE_ITEMS', 'CLEAR', 'DELETE_ANSWERED_ITEM', 'UPDATE_ITEM'];
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'upcoming', supportedActions);
	var paginatedConsts = exports.paginatedConsts = (0, _redux.createReqConsts)('surveys', 'upcomingPaginated', ['LOAD_NEXT_REQUESTS', 'UPDATE_PAGINATION_PARAMETERS']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var paginatedActions = exports.paginatedActions = (0, _redux.createActions)(paginatedConsts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, request);
	var paginatedWatcher = exports.paginatedWatcher = (0, _redux.createReqWatcher)(paginatedConsts, paginatedActions, request);
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	  switch (type) {
	    case consts.SUCCEED:
	      {
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true
	        }, { list: action.payload });
	      }
	    case paginatedConsts.SUCCEED:
	      {
	        var prevList = (0, _lodash.get)(state, 'list', []);
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true,
	          list: prevList.concat(action.payload)
	        });
	      }
	    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS:
	      {
	        var _action$payload = action.payload,
	            offset = _action$payload.offset,
	            limit = _action$payload.limit;
	
	        return (0, _lodash.merge)({}, state, {
	          pagination: {
	            offset: offset,
	            limit: limit
	          }
	        });
	      }
	    case consts.DELETE_ANSWERED_ITEM:
	      {
	        var id = action.payload;
	        var _prevList = (0, _lodash.get)(state, 'list', []);
	        var list = _prevList.filter(function (item) {
	          return id !== (0, _lodash.get)(item, 'assignmentId');
	        });
	        var prevCount = (0, _lodash.get)(state, ['meta', 'totalCount'], 0);
	
	        return (0, _extends3.default)({}, state, {
	          list: list,
	          meta: {
	            totalCount: prevCount - 1
	          }
	        });
	      }
	    case consts.REMOVE_ITEMS:
	      {
	        if (!state.list) return state;
	
	        var updatedList = state.list.filter(function (item) {
	          return !payload.includes(item.assignmentId);
	        });
	        var currentTotalCount = (0, _lodash.get)(state, 'meta.totalCount');
	        return (0, _extends3.default)({}, state, {
	          list: updatedList,
	          meta: { totalCount: currentTotalCount - 1 }
	        });
	      }
	
	    case consts.UPDATE_ITEM:
	      {
	        if (!state.list) return state;
	
	        var _updatedList = state.list.map(function (item) {
	          if (item.assignmentId === payload.assignmentId) {
	            return payload;
	          }
	          return item;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          list: _updatedList
	        });
	      }
	    case consts.CLEAR:
	      return initialState;
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.visitExpired = exports.nowLocalMoment = exports.nowMoment = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.getMinDate = getMinDate;
	exports.formatToCalendarTime = formatToCalendarTime;
	exports.formatToDate = formatToDate;
	exports.momentFormat = momentFormat;
	exports.formatHours = formatHours;
	exports.humanizeDate = humanizeDate;
	exports.humanizeLocalDate = humanizeLocalDate;
	exports.formatDuration = formatDuration;
	exports.makeDateList = makeDateList;
	exports.getISOString = getISOString;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _range = __webpack_require__(985);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _dateFns = __webpack_require__(275);
	
	var _format = __webpack_require__(370);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nowMoment = exports.nowMoment = _moment2.default.utc().startOf('day');
	var nowLocalMoment = exports.nowLocalMoment = (0, _moment2.default)().startOf('day');
	
	function getMinDate() {
	  return nowMoment.clone().add(-1, 'day');
	}
	
	var CALENDAR_FORMATS = {
	  sameDay: '[Today]',
	  nextDay: '[Tomorrow]',
	  nextWeek: 'dddd',
	  lastDay: 'MMM D',
	  lastWeek: 'MMM D',
	  sameElse: 'MMM D'
	};
	
	function formatToCalendarTime(timestamp) {
	  return (0, _moment2.default)(timestamp).calendar(null, CALENDAR_FORMATS);
	}
	
	function formatToDate(timestamp) {
	  return new Date(timestamp);
	}
	
	function momentFormat(format) {
	  return function (date) {
	    return (0, _moment2.default)(date).format(format);
	  };
	}
	
	function formatHours(timestamp) {
	  return (0, _moment2.default)(timestamp).format('h:mm A');
	}
	
	function humanizeDate(timestamp) {
	  return (0, _moment2.default)(timestamp).format('MMM D, YYYY');
	}
	function humanizeLocalDate(timestamp) {
	  return (0, _moment2.default)(timestamp).format('MMM D, YYYY');
	}
	
	function formatDuration(time) {
	  var duration = _moment2.default.duration(time);
	  return _moment2.default.utc(duration.as('milliseconds')).format('h:mm A');
	}
	
	function makeDateList(days) {
	  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var today = (0, _dateFns.startOfDay)(new Date());
	  var start = startDate ? (0, _dateFns.startOfDay)(new Date(startDate)) : today;
	  return (0, _range2.default)(days).reduce(function (acc, _, i) {
	    var date = (0, _dateFns.addDays)(start, i);
	    var dayText = (0, _format2.default)(date, 'EEE');
	    var dateText = (0, _format2.default)(date, 'MMM d');
	    var isToday = (0, _dateFns.isSameDay)(date, today);
	
	    return [].concat((0, _toConsumableArray3.default)(acc), [{
	      timestamp: (0, _format2.default)(date, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"),
	      dayText: dayText,
	      dateText: isToday ? 'Today' : dateText
	    }]);
	  }, []);
	}
	
	var visitExpired = exports.visitExpired = function visitExpired(time) {
	  return (0, _moment2.default)().isAfter((0, _moment2.default)(time), 'date');
	};
	
	function localOffset() {
	  var mins = -new Date().getTimezoneOffset();
	  var sign = mins >= 0 ? '+' : '-';
	  var abs = Math.abs(mins);
	  var h = String(Math.floor(abs / 60)).padStart(2, '0');
	  var m = String(abs % 60).padStart(2, '0');
	  return '' + sign + h + ':' + m;
	}
	
	function getISOString(date) {
	  if (date.getHours() === 0 && date.getMinutes() === 0) {
	    // this is a fix for Chrome (V8) issue (browsers with another engines work fine)
	    // when user selects some date with time 00:00:00
	    // Chrome considers it as a previous day
	    // in case using regular new Date(date).toISOString() function
	    var datePart = (0, _format2.default)(date, 'yyyy-MM-dd');
	    return datePart + 'T00:00:00.000' + localOffset();
	  }
	  return (0, _dateFns.startOfDay)(new Date(date)).toISOString();
	}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var makePharmacyTitle = exports.makePharmacyTitle = function makePharmacyTitle(pharmacy) {
	  var full = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (!pharmacy) {
	    return '—';
	  }
	
	  var zip = pharmacy.zip,
	      address = pharmacy.address,
	      pharmacyName = pharmacy.pharmacyName,
	      phone = pharmacy.phone;
	
	
	  return !full ? zip + ', ' + address + ', ' + pharmacyName : pharmacyName + ', ' + address + ', ' + zip + ', \n' + phone;
	};

/***/ }),
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _sanitizeHtml = __webpack_require__(2884);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (input, replace) {
	  var allowedTags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['br'];
	
	  var replaceSymbol = void 0;
	  if (replace) {
	    replaceSymbol = String(input).replace(/</g, '&#60;');
	  }
	  return (0, _sanitizeHtml2.default)(replace ? replaceSymbol : input, {
	    allowedAttributes: [],
	    allowedTags: [].concat((0, _toConsumableArray3.default)(allowedTags)),
	    selfClosing: [].concat((0, _toConsumableArray3.default)(allowedTags))
	  });
	};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UI_DATE_BASE = exports.API_DATE_BASE = exports.API_DATE_FORMAT = undefined;
	exports.getInitDateState = getInitDateState;
	exports.calculatePrevWeek = calculatePrevWeek;
	exports.calculateNextWeek = calculateNextWeek;
	exports.setNewDate = setNewDate;
	exports.formatToAPIDateFormat = formatToAPIDateFormat;
	exports.getNowAPIDateTime = getNowAPIDateTime;
	exports.isDateBetweenBounds = isDateBetweenBounds;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_DATE_FORMAT = exports.API_DATE_FORMAT = 'YYYY-MM-DD';
	var API_DATE_BASE = exports.API_DATE_BASE = 'yyyy-MM-dd';
	var UI_DATE_BASE = exports.UI_DATE_BASE = 'MM-dd-yyyy';
	
	function getInitDateState(date) {
	  var nowDate = (0, _moment2.default)(date);
	  var startOfWeek = nowDate.clone().startOf('week');
	  var endOfWeek = nowDate.clone().endOf('week');
	
	  return {
	    startOn: startOfWeek.format(API_DATE_FORMAT),
	    endOn: endOfWeek.format(API_DATE_FORMAT),
	    date: nowDate.format(API_DATE_FORMAT)
	  };
	}
	
	function calculatePrevWeek(startOn) {
	  var startOfWeek = _moment2.default.utc(startOn).subtract(7, 'd');
	  var endOfWeek = startOfWeek.clone().endOf('week');
	
	  return {
	    startOn: startOfWeek.format(API_DATE_FORMAT),
	    endOn: endOfWeek.format(API_DATE_FORMAT)
	  };
	}
	
	function calculateNextWeek(startOn) {
	  var startOfWeek = _moment2.default.utc(startOn).add(7, 'd');
	  var endOfWeek = startOfWeek.clone().endOf('week');
	
	  return {
	    startOn: startOfWeek.format(API_DATE_FORMAT),
	    endOn: endOfWeek.format(API_DATE_FORMAT)
	  };
	}
	
	function setNewDate(date) {
	  return {
	    date: _moment2.default.utc(date).format(API_DATE_FORMAT)
	  };
	}
	
	function formatToAPIDateFormat(date) {
	  return _moment2.default.utc(date).format(API_DATE_FORMAT);
	}
	
	function getNowAPIDateTime() {
	  return _moment2.default.utc().format(API_DATE_FORMAT);
	}
	
	function isDateBetweenBounds(_ref) {
	  var startOn = _ref.startOn,
	      endOn = _ref.endOn;
	
	  return (0, _moment2.default)().startOf('day').isBetween(startOn, endOn, undefined, '[]');
	}

/***/ }),
/* 315 */
[6550, 703],
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(2166);
	var $export = __webpack_require__(32);
	var shared = __webpack_require__(933)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(2169))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(124)) {
	  var LIBRARY = __webpack_require__(443);
	  var global = __webpack_require__(89);
	  var fails = __webpack_require__(95);
	  var $export = __webpack_require__(32);
	  var $typed = __webpack_require__(935);
	  var $buffer = __webpack_require__(1441);
	  var ctx = __webpack_require__(243);
	  var anInstance = __webpack_require__(441);
	  var propertyDesc = __webpack_require__(447);
	  var hide = __webpack_require__(205);
	  var redefineAll = __webpack_require__(448);
	  var toInteger = __webpack_require__(273);
	  var toLength = __webpack_require__(126);
	  var toIndex = __webpack_require__(2164);
	  var toAbsoluteIndex = __webpack_require__(450);
	  var toPrimitive = __webpack_require__(274);
	  var has = __webpack_require__(204);
	  var classof = __webpack_require__(709);
	  var isObject = __webpack_require__(99);
	  var toObject = __webpack_require__(146);
	  var isArrayIter = __webpack_require__(1427);
	  var create = __webpack_require__(444);
	  var getPrototypeOf = __webpack_require__(224);
	  var gOPN = __webpack_require__(445).f;
	  var getIterFn = __webpack_require__(1444);
	  var uid = __webpack_require__(451);
	  var wks = __webpack_require__(106);
	  var createArrayMethod = __webpack_require__(269);
	  var createArrayIncludes = __webpack_require__(922);
	  var speciesConstructor = __webpack_require__(934);
	  var ArrayIterators = __webpack_require__(1445);
	  var Iterators = __webpack_require__(556);
	  var $iterDetect = __webpack_require__(928);
	  var setSpecies = __webpack_require__(449);
	  var arrayFill = __webpack_require__(1419);
	  var arrayCopyWithin = __webpack_require__(2137);
	  var $DP = __webpack_require__(125);
	  var $GOPD = __webpack_require__(223);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 318 */,
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var getDayOfYear = __webpack_require__(4704)
	var getISOWeek = __webpack_require__(4705)
	var getISOYear = __webpack_require__(2175)
	var parse = __webpack_require__(162)
	var isValid = __webpack_require__(4708)
	var enLocale = __webpack_require__(4712)
	
	/**
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 *
	 * Accepted tokens:
	 * | Unit                    | Token | Result examples                  |
	 * |-------------------------|-------|----------------------------------|
	 * | Month                   | M     | 1, 2, ..., 12                    |
	 * |                         | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         | MM    | 01, 02, ..., 12                  |
	 * |                         | MMM   | Jan, Feb, ..., Dec               |
	 * |                         | MMMM  | January, February, ..., December |
	 * | Quarter                 | Q     | 1, 2, 3, 4                       |
	 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Day of month            | D     | 1, 2, ..., 31                    |
	 * |                         | Do    | 1st, 2nd, ..., 31st              |
	 * |                         | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | DDD   | 1, 2, ..., 366                   |
	 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         | DDDD  | 001, 002, ..., 366               |
	 * | Day of week             | d     | 0, 1, ..., 6                     |
	 * |                         | do    | 0th, 1st, ..., 6th               |
	 * |                         | dd    | Su, Mo, ..., Sa                  |
	 * |                         | ddd   | Sun, Mon, ..., Sat               |
	 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	 * | ISO week                | W     | 1, 2, ..., 53                    |
	 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         | WW    | 01, 02, ..., 53                  |
	 * | Year                    | YY    | 00, 01, ..., 99                  |
	 * |                         | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	 * |                         | GGGG  | 1900, 1901, ..., 2099            |
	 * | AM/PM                   | A     | AM, PM                           |
	 * |                         | a     | am, pm                           |
	 * |                         | aa    | a.m., p.m.                       |
	 * | Hour                    | H     | 0, 1, ... 23                     |
	 * |                         | HH    | 00, 01, ... 23                   |
	 * |                         | h     | 1, 2, ..., 12                    |
	 * |                         | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | m     | 0, 1, ..., 59                    |
	 * |                         | mm    | 00, 01, ..., 59                  |
	 * | Second                  | s     | 0, 1, ..., 59                    |
	 * |                         | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | X     | 512969520                        |
	 * | Milliseconds timestamp  | x     | 512969520900                     |
	 *
	 * The characters wrapped in square brackets are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
	 * @param {Object} [options] - the object with options
	 * @param {Object} [options.locale=enLocale] - the locale object
	 * @returns {String} the formatted date string
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(
	 *   new Date(2014, 1, 11),
	 *   'MM/DD/YYYY'
	 * )
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = format(
	 *   new Date(2014, 6, 2),
	 *   'Do [de] MMMM YYYY',
	 *   {locale: eoLocale}
	 * )
	 * //=> '2-a de julio 2014'
	 */
	function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
	  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
	  var options = dirtyOptions || {}
	
	  var locale = options.locale
	  var localeFormatters = enLocale.format.formatters
	  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
	  if (locale && locale.format && locale.format.formatters) {
	    localeFormatters = locale.format.formatters
	
	    if (locale.format.formattingTokensRegExp) {
	      formattingTokensRegExp = locale.format.formattingTokensRegExp
	    }
	  }
	
	  var date = parse(dirtyDate)
	
	  if (!isValid(date)) {
	    return 'Invalid Date'
	  }
	
	  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)
	
	  return formatFn(date)
	}
	
	var formatters = {
	  // Month: 1, 2, ..., 12
	  'M': function (date) {
	    return date.getMonth() + 1
	  },
	
	  // Month: 01, 02, ..., 12
	  'MM': function (date) {
	    return addLeadingZeros(date.getMonth() + 1, 2)
	  },
	
	  // Quarter: 1, 2, 3, 4
	  'Q': function (date) {
	    return Math.ceil((date.getMonth() + 1) / 3)
	  },
	
	  // Day of month: 1, 2, ..., 31
	  'D': function (date) {
	    return date.getDate()
	  },
	
	  // Day of month: 01, 02, ..., 31
	  'DD': function (date) {
	    return addLeadingZeros(date.getDate(), 2)
	  },
	
	  // Day of year: 1, 2, ..., 366
	  'DDD': function (date) {
	    return getDayOfYear(date)
	  },
	
	  // Day of year: 001, 002, ..., 366
	  'DDDD': function (date) {
	    return addLeadingZeros(getDayOfYear(date), 3)
	  },
	
	  // Day of week: 0, 1, ..., 6
	  'd': function (date) {
	    return date.getDay()
	  },
	
	  // Day of ISO week: 1, 2, ..., 7
	  'E': function (date) {
	    return date.getDay() || 7
	  },
	
	  // ISO week: 1, 2, ..., 53
	  'W': function (date) {
	    return getISOWeek(date)
	  },
	
	  // ISO week: 01, 02, ..., 53
	  'WW': function (date) {
	    return addLeadingZeros(getISOWeek(date), 2)
	  },
	
	  // Year: 00, 01, ..., 99
	  'YY': function (date) {
	    return addLeadingZeros(date.getFullYear(), 4).substr(2)
	  },
	
	  // Year: 1900, 1901, ..., 2099
	  'YYYY': function (date) {
	    return addLeadingZeros(date.getFullYear(), 4)
	  },
	
	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': function (date) {
	    return String(getISOYear(date)).substr(2)
	  },
	
	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': function (date) {
	    return getISOYear(date)
	  },
	
	  // Hour: 0, 1, ... 23
	  'H': function (date) {
	    return date.getHours()
	  },
	
	  // Hour: 00, 01, ..., 23
	  'HH': function (date) {
	    return addLeadingZeros(date.getHours(), 2)
	  },
	
	  // Hour: 1, 2, ..., 12
	  'h': function (date) {
	    var hours = date.getHours()
	    if (hours === 0) {
	      return 12
	    } else if (hours > 12) {
	      return hours % 12
	    } else {
	      return hours
	    }
	  },
	
	  // Hour: 01, 02, ..., 12
	  'hh': function (date) {
	    return addLeadingZeros(formatters['h'](date), 2)
	  },
	
	  // Minute: 0, 1, ..., 59
	  'm': function (date) {
	    return date.getMinutes()
	  },
	
	  // Minute: 00, 01, ..., 59
	  'mm': function (date) {
	    return addLeadingZeros(date.getMinutes(), 2)
	  },
	
	  // Second: 0, 1, ..., 59
	  's': function (date) {
	    return date.getSeconds()
	  },
	
	  // Second: 00, 01, ..., 59
	  'ss': function (date) {
	    return addLeadingZeros(date.getSeconds(), 2)
	  },
	
	  // 1/10 of second: 0, 1, ..., 9
	  'S': function (date) {
	    return Math.floor(date.getMilliseconds() / 100)
	  },
	
	  // 1/100 of second: 00, 01, ..., 99
	  'SS': function (date) {
	    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
	  },
	
	  // Millisecond: 000, 001, ..., 999
	  'SSS': function (date) {
	    return addLeadingZeros(date.getMilliseconds(), 3)
	  },
	
	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': function (date) {
	    return formatTimezone(date.getTimezoneOffset(), ':')
	  },
	
	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': function (date) {
	    return formatTimezone(date.getTimezoneOffset())
	  },
	
	  // Seconds timestamp: 512969520
	  'X': function (date) {
	    return Math.floor(date.getTime() / 1000)
	  },
	
	  // Milliseconds timestamp: 512969520900
	  'x': function (date) {
	    return date.getTime()
	  }
	}
	
	function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
	  var array = formatStr.match(formattingTokensRegExp)
	  var length = array.length
	
	  var i
	  var formatter
	  for (i = 0; i < length; i++) {
	    formatter = localeFormatters[array[i]] || formatters[array[i]]
	    if (formatter) {
	      array[i] = formatter
	    } else {
	      array[i] = removeFormattingTokens(array[i])
	    }
	  }
	
	  return function (date) {
	    var output = ''
	    for (var i = 0; i < length; i++) {
	      if (array[i] instanceof Function) {
	        output += array[i](date, formatters)
	      } else {
	        output += array[i]
	      }
	    }
	    return output
	  }
	}
	
	function removeFormattingTokens (input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '')
	  }
	  return input.replace(/\\/g, '')
	}
	
	function formatTimezone (offset, delimeter) {
	  delimeter = delimeter || ''
	  var sign = offset > 0 ? '-' : '+'
	  var absOffset = Math.abs(offset)
	  var hours = Math.floor(absOffset / 60)
	  var minutes = absOffset % 60
	  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
	}
	
	function addLeadingZeros (number, targetLength) {
	  var output = Math.abs(number).toString()
	  while (output.length < targetLength) {
	    output = '0' + output
	  }
	  return output
	}
	
	module.exports = format


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	var MILLISECONDS_IN_MINUTE = 60000;
	
	function getDateMillisecondsPart(date) {
	  return date.getTime() % MILLISECONDS_IN_MINUTE;
	}
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	
	
	function getTimezoneOffsetInMilliseconds(dirtyDate) {
	  var date = new Date(dirtyDate.getTime());
	  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
	  date.setSeconds(0, 0);
	  var hasNegativeUTCOffset = baseTimezoneOffset > 0;
	  var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? (MILLISECONDS_IN_MINUTE + getDateMillisecondsPart(date)) % MILLISECONDS_IN_MINUTE : getDateMillisecondsPart(date);
	  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
	}
	
	module.exports = exports.default;

/***/ }),
/* 321 */
[6744, 569, 5454, 5481],
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var capitalize = __webpack_require__(209),
	    createCompounder = __webpack_require__(973);
	
	/**
	 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the camel cased string.
	 * @example
	 *
	 * _.camelCase('Foo Bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('--foo-bar--');
	 * // => 'fooBar'
	 *
	 * _.camelCase('__FOO_BAR__');
	 * // => 'fooBar'
	 */
	var camelCase = createCompounder(function(result, word, index) {
	  word = word.toLowerCase();
	  return result + (index ? capitalize(word) : word);
	});
	
	module.exports = camelCase;


/***/ }),
/* 323 */
1009,
/* 324 */
[6815, 972, 247, 981, 987, 2359],
/* 325 */
[6717, 1535],
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Typography = __webpack_require__(5631);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Typography).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
	exports.isMuiElement = isMuiElement;
	exports.isMuiComponent = isMuiComponent;
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneChildrenWithClassName(children, className, props) {
	  return _react.Children.map(children, function (child) {
	    return (0, _react.isValidElement)(child) && (0, _react.cloneElement)(child, (0, _extends3.default)({
	      className: child.props.hasOwnProperty('className') ? child.props.className + ' ' + className : className
	    }, props));
	  });
	}
	/* eslint-disable import/prefer-default-export */
	
	function isMuiElement(element, muiNames) {
	  return (0, _react.isValidElement)(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}
	
	function isMuiComponent(element, muiNames) {
	  return muiNames.indexOf(element.muiName) !== -1;
	}

/***/ }),
/* 328 */
[6804, 2671],
/* 329 */
228,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(956);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var Controls = function Controls(_ref) {
	  var children = _ref.children,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? 'pa2' : _ref$className,
	      style = _ref.style;
	  return _react2.default.createElement('div', (0, _extends3.default)({ children: children, className: className, style: style }, { styleName: 'controls' }));
	};
	
	Controls.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	exports.default = (0, _reactCssModules2.default)(Controls, _index2.default, { allowMultiple: true });

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _constants = __webpack_require__(17);
	
	var _utils = __webpack_require__(797);
	
	var _getFieldValues = __webpack_require__(3649);
	
	var _getFieldValues2 = _interopRequireDefault(_getFieldValues);
	
	var _Fieldset = __webpack_require__(1788);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _enhance = __webpack_require__(3580);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldSetList = function FieldSetList(props) {
	  var employeeId = props.employeeId,
	      onSave = props.onSave,
	      fieldSetList = props.fieldSetList,
	      disabled = props.disabled,
	      onCancelCallback = props.onCancelCallback,
	      canEdit = props.canEdit,
	      editWorkingHoursActions = props.editWorkingHoursActions;
	
	
	  var handleSave = function handleSave(fields, title) {
	    onSave((0, _getFieldValues2.default)(fields), title);
	  };
	
	  var handleCustomAction = function handleCustomAction(fields) {
	    var workingHoursField = fields.find(function (_ref) {
	      var type = _ref.type;
	      return type === _constants.FIELDS_TYPE.CUSTOM_TIME_PICKER;
	    });
	    if (workingHoursField) {
	      var value = workingHoursField.value;
	
	
	      var data = {
	        workingHours: (0, _extends3.default)({}, value[2] && value[0] && value[1] && {
	          timeZone: value[2].label,
	          startTime: (0, _utils.convertTimeTo24HoursFormat)(value[0]),
	          endTime: (0, _utils.convertTimeTo24HoursFormat)(value[1])
	        })
	      };
	      editWorkingHoursActions((0, _extends3.default)({ id: employeeId }, data));
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'fieldsetList profile-children' },
	    fieldSetList.map(function (item, i) {
	      return _react2.default.createElement(_Fieldset2.default, {
	        key: 'block-' + i,
	        fieldset: item,
	        onSave: item.useCustomAction ? handleCustomAction : handleSave,
	        disabled: disabled || item.disabled,
	        onCancelCallback: onCancelCallback,
	        canEdit: canEdit
	      });
	    })
	  );
	};
	
	FieldSetList.propTypes = {
	  fieldSetList: PropTypes.array.isRequired,
	  onSave: PropTypes.func,
	  disabled: PropTypes.bool,
	  onCancelCallback: PropTypes.func,
	  canEdit: PropTypes.bool,
	  editWorkingHoursActions: PropTypes.func,
	  employeeId: PropTypes.number
	};
	
	exports.default = (0, _enhance.enhance)(FieldSetList);

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _throttle = __webpack_require__(2355);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _passwordRules = __webpack_require__(1210);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _CheckPasswordList = __webpack_require__(1094);
	
	var _CheckPasswordList2 = _interopRequireDefault(_CheckPasswordList);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ = __webpack_require__(45);
	
	var _2 = _interopRequireDefault(_);
	
	var _index = __webpack_require__(1508);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DELAY = 300;
	
	function PasswordInput(_ref) {
	  var name = _ref.name,
	      label = _ref.label,
	      onBlur = _ref.onBlur,
	      onChange = _ref.onChange,
	      className = _ref.className,
	      defaultType = _ref.defaultType,
	      withValidation = _ref.withValidation,
	      formatMessage = _ref.intl.formatMessage,
	      _ref$placeholder = _ref.placeholder,
	      placeholder = _ref$placeholder === undefined ? formatMessage(_strings.AUTH.fields.password) : _ref$placeholder,
	      shouldClearWhenOnFocus = _ref.shouldClearWhenOnFocus,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['name', 'label', 'onBlur', 'onChange', 'className', 'defaultType', 'withValidation', 'intl', 'placeholder', 'shouldClearWhenOnFocus']);
	  var DEFAULT = _passwordRules.PASSWORD_STATUS.DEFAULT,
	      DANGER = _passwordRules.PASSWORD_STATUS.DANGER,
	      DONE = _passwordRules.PASSWORD_STATUS.DONE;
	
	  var initialList = _passwordRules.PASSWORD_RULES.map(function (item) {
	    return (0, _extends3.default)({}, item, { status: DEFAULT });
	  });
	
	  var initialState = {
	    invalid: false,
	    list: initialList,
	    type: defaultType || _constants.FIELDS_TYPE.PASSWORD
	  };
	
	  var _useState = (0, _react.useState)(initialState),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      inputState = _useState2[0],
	      setInputState = _useState2[1];
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      openedChecker = _useToggleFlag2[0],
	      openChecker = _useToggleFlag2[1],
	      closeChecker = _useToggleFlag2[2];
	
	  var invalid = inputState.invalid,
	      list = inputState.list,
	      type = inputState.type;
	
	
	  var isPasswordInput = (0, _react.useMemo)(function () {
	    return type === _constants.FIELDS_TYPE.PASSWORD;
	  }, [type]);
	
	  var validate = function validate(value) {
	    var validatedList = list.map(function (item) {
	      var danger = !value.match(item.rule);
	      return (0, _extends3.default)({}, item, { status: danger ? DANGER : DONE });
	    });
	    var isInvalid = validatedList.some(function (item) {
	      return item.status === DANGER;
	    });
	    return { isInvalid: isInvalid, validatedList: validatedList };
	  };
	
	  var handleChange = function handleChange(value) {
	    var _ref2 = withValidation && value ? validate(value) : {},
	        isInvalid = _ref2.isInvalid,
	        _ref2$validatedList = _ref2.validatedList,
	        validatedList = _ref2$validatedList === undefined ? initialList : _ref2$validatedList;
	
	    setInputState((0, _extends3.default)({}, inputState, { list: validatedList, invalid: isInvalid }));
	    if (onChange) onChange(name, value, isInvalid);
	  };
	
	  var handleFocus = function handleFocus() {
	    if (shouldClearWhenOnFocus) handleChange('');
	    if (withValidation) {
	      openChecker();
	    }
	  };
	
	  var handleBlur = function handleBlur(value) {
	    if (withValidation) {
	      closeChecker();
	    }
	    if (onBlur) {
	      onBlur(value);
	    }
	  };
	
	  var togglePasswordVisibility = function togglePasswordVisibility() {
	    var inputType = isPasswordInput ? _constants.FIELDS_TYPE.TEXT : _constants.FIELDS_TYPE.PASSWORD;
	    setInputState((0, _extends3.default)({}, inputState, { type: inputType }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, styleName: 'passwordInput' },
	    _react2.default.createElement(
	      _2.default,
	      (0, _extends3.default)({
	        name: name,
	        type: type,
	        invalid: invalid,
	        placeholder: placeholder,
	        label: label || placeholder,
	        onChange: (0, _throttle2.default)(handleChange, DELAY),
	        onFocus: handleFocus,
	        onBlur: handleBlur,
	        shouldClearWhenOnFocus: shouldClearWhenOnFocus
	      }, other),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'toggler' },
	        _react2.default.createElement(
	          _ClickableElement2.default,
	          {
	            onClick: togglePasswordVisibility,
	            className: (0, _classnames2.default)({ dn: isPasswordInput })
	          },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'password-invisible',
	            style: { fill: _styles.COLORS.bluePrimary }
	          })
	        ),
	        _react2.default.createElement(
	          _ClickableElement2.default,
	          {
	            onClick: togglePasswordVisibility,
	            className: (0, _classnames2.default)({ dn: !isPasswordInput }),
	            ariaLabel: 'yey'
	          },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'password-visible',
	            style: { fill: _styles.COLORS.bluePrimary }
	          })
	        )
	      )
	    ),
	    openedChecker ? _react2.default.createElement(_CheckPasswordList2.default, { list: list }) : null
	  );
	}
	
	PasswordInput.defaultProps = {
	  name: _constants.FIELDS_TYPE.PASSWORD
	};
	
	PasswordInput.propTypes = {
	  className: _propTypes2.default.string,
	  withValidation: _propTypes2.default.bool,
	  name: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  defaultType: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  label: _propTypes2.default.string,
	  shouldClearWhenOnFocus: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(PasswordInput, _index2.default, { allowMultiple: true }));

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tooltip = __webpack_require__(1826);
	
	Object.defineProperty(exports, 'TOOLTIP', {
	  enumerable: true,
	  get: function get() {
	    return _tooltip.TOOLTIP;
	  }
	});
	
	var _defaults = __webpack_require__(3840);
	
	Object.defineProperty(exports, 'DEFAULTS', {
	  enumerable: true,
	  get: function get() {
	    return _defaults.DEFAULTS;
	  }
	});
	Object.defineProperty(exports, 'POINT_WITHOUT_HOVER', {
	  enumerable: true,
	  get: function get() {
	    return _defaults.POINT_WITHOUT_HOVER;
	  }
	});
	
	var _timeline = __webpack_require__(1825);
	
	Object.defineProperty(exports, 'TIMELINE', {
	  enumerable: true,
	  get: function get() {
	    return _timeline.TIMELINE;
	  }
	});

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _Popover = __webpack_require__(250);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Menu = __webpack_require__(790);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5203);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function IconMenu(_ref) {
	  var className = _ref.className,
	      icon = _ref.icon,
	      items = _ref.items,
	      position = _ref.position,
	      style = _ref.style,
	      btnStyle = _ref.btnStyle,
	      disabled = _ref.disabled,
	      allScreens = _ref.allScreens,
	      onMobilePopover = _ref.onMobilePopover,
	      onClick = _ref.onClick,
	      id = _ref.id,
	      iconActionMode = _ref.iconActionMode;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isPopoverOpened = _useState2[0],
	      togglePopover = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      anchorEl = _useState4[0],
	      setAnchorEl = _useState4[1];
	
	  var handleTouchTap = function handleTouchTap(event) {
	    if (onClick) onClick();
	    if (onMobilePopover) onMobilePopover();
	    if (!iconActionMode) {
	      togglePopover(true);
	      setAnchorEl(event.currentTarget);
	    }
	  };
	
	  var handleRequestClose = function handleRequestClose() {
	    togglePopover(false);
	  };
	
	  var handleSelect = function handleSelect() {
	    handleRequestClose();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', className: className, style: style },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        disabled: disabled,
	        icon: true,
	        id: id,
	        style: btnStyle,
	        onClick: handleTouchTap,
	        ariaLabel: (0, _get2.default)(icon, 'name', 'more')
	      },
	      _react2.default.createElement(_Icon2.default, {
	        name: (0, _get2.default)(icon, 'name', 'more'),
	        size: (0, _get2.default)(icon, 'size', null),
	        style: {
	          fill: (0, _get2.default)(icon, 'color', _styles.COLORS.bluePrimary),
	          opacity: disabled ? 0.3 : 1
	        },
	        className: 'db'
	      })
	    ),
	    _react2.default.createElement(
	      _reactResponsive2.default,
	      { minWidth: allScreens ? '0px' : _styles.BREAKPOINT },
	      _react2.default.createElement(
	        _Popover2.default,
	        {
	          className: 'popover',
	          open: isPopoverOpened,
	          anchorEl: anchorEl,
	          anchorOrigin: position,
	          onClose: handleRequestClose
	        },
	        _react2.default.createElement(_Menu2.default, { items: items, onSelect: handleSelect })
	      )
	    )
	  );
	};
	
	IconMenu.propTypes = {
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  icon: _propTypes2.default.shape({
	    color: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    size: _propTypes2.default.number
	  }),
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    element: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
	    onClick: _propTypes2.default.func
	  })),
	  onClick: _propTypes2.default.func,
	  position: _propTypes2.default.shape({
	    horizontal: _propTypes2.default.string,
	    vertical: _propTypes2.default.string
	  }),
	  style: _propTypes2.default.object,
	  btnStyle: _propTypes2.default.object,
	  onMobilePopover: _propTypes2.default.func,
	  allScreens: _propTypes2.default.bool,
	  iconActionMode: _propTypes2.default.bool
	};
	
	IconMenu.defaultProps = {
	  position: {
	    horizontal: 'left',
	    vertical: 'bottom'
	  }
	};
	
	exports.default = (0, _reactCssModules2.default)(IconMenu, _index2.default, { allowMultiple: true });

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, {
	          succeed: null,
	          rejected: null,
	          error: null,
	          count: action.payload.count || 0,
	          sending: !action.payload.silent
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          succeed: true,
	          sending: false,
	          data: action.payload
	        });
	      }
	
	    case paginationConsts.SEND:
	      {
	        return (0, _extends3.default)({}, state, {
	          paginationSending: true
	        });
	      }
	
	    case paginationConsts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          paginationSending: false,
	          data: (0, _extends3.default)({}, state.data, {
	            appointments: [].concat((0, _toConsumableArray3.default)(state.data.appointments), (0, _toConsumableArray3.default)(action.payload.appointments))
	          })
	        });
	      }
	
	    case paginationConsts.REJECTED:
	    case paginationConsts.ERROR_ENCOUNTERED:
	      {
	        return (0, _extends3.default)({}, state, {
	          paginationSending: false
	        });
	      }
	
	    case paginationConsts.ADD_META:
	    case consts.ADD_META:
	      {
	        return (0, _extends3.default)({}, state, {
	          count: (0, _get2.default)(action.payload, 'total', 0)
	        });
	      }
	
	    case consts.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _reqReducer = __webpack_require__(1390);
	
	var _reqReducer2 = _interopRequireDefault(_reqReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestOptions = {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['repeatable_appointments', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'my-providers-req', ['LOAD_MORE', 'SELECT_MY_PROVIDER', 'INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('appointment-form', 'my-providers-req-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions);
	
	var defaultRequestReducer = (0, _reqReducer2.default)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  count: 0,
	  data: { appointments: [], visitTypes: [] },
	  paginationSending: false,
	  pagination: { offset: 0, limit: 10 }
	});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointments', 'pay-for-account-form-appointment');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'payment_orders',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['paymentOrderId']
	  }, 'paya', 'accountvaults', {
	    type: 'payload',
	    selector: ['accountVaultId']
	  }, 'transactions']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _authAzure = __webpack_require__(631);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'azure-login');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'azure_authentication',
	  type: 'post',
	  slug: ['sessions']
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  loginMFA: '',
	  token: '',
	  successAuthForSignUpFlow: false
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case _authAzure.consts.SET_CREDENTIAL_FOR_MFA:
	      return (0, _extends3.default)({}, state, {
	        loginMFA: payload.login,
	        token: payload.token
	      });
	    case _authAzure.consts.SET_SUCCESS_SIGN_UP_FLOW:
	      return (0, _extends3.default)({}, state, {
	        successAuthForSignUpFlow: true
	      });
	    case consts.REJECTED:
	      return (0, _extends3.default)({}, initialState, payload, {
	        rejected: true,
	        loginMFA: state.loginMFA,
	        token: state.token
	      });
	    case consts.CLEAR:
	      return (0, _extends3.default)({}, initialState);
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'signup');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'invite_confirmations',
	  slug: [{
	    type: 'payload',
	    selector: ['token']
	  }],
	  type: 'get'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'accept-com-invite');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'member_invitations',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginatedWatcher = exports.watcher = exports.paginatedActions = exports.actions = exports.paginatedConsts = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends12 = __webpack_require__(3);
	
	var _extends13 = _interopRequireDefault(_extends12);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _metaInitialState, _extends2;
	
	var _lodash = __webpack_require__(58);
	
	var _redux = __webpack_require__(7);
	
	var _removeNotificationsCounters = __webpack_require__(345);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paginationInitialState = {
	  member: {
	    offset: 0,
	    limit: 10
	  },
	  moderator: {
	    offset: 0,
	    limit: 10
	  }
	};
	
	var metaInitialState = (_metaInitialState = {}, (0, _defineProperty3.default)(_metaInitialState, _constants.ACTIVITY_TYPES.NOTIFICATIONS, {
	  offset: 0,
	  limit: 10,
	  total: 0
	}), (0, _defineProperty3.default)(_metaInitialState, _constants.ACTIVITY_TYPES.JOIN_REQUESTS, {
	  offset: 0,
	  limit: 10,
	  total: 0
	}), (0, _defineProperty3.default)(_metaInitialState, _constants.ACTIVITY_TYPES.MEMBER_INVITATIONS, {
	  offset: 0,
	  limit: 10,
	  total: 0
	}), _metaInitialState);
	
	var initialState = (0, _extends13.default)({}, _redux.initialState, (_extends2 = {
	  pagination: paginationInitialState,
	  meta: metaInitialState
	}, (0, _defineProperty3.default)(_extends2, _constants.ACTIVITY_TYPES.NOTIFICATIONS, []), (0, _defineProperty3.default)(_extends2, _constants.ACTIVITY_TYPES.JOIN_REQUESTS, []), (0, _defineProperty3.default)(_extends2, _constants.ACTIVITY_TYPES.MEMBER_INVITATIONS, []), _extends2));
	
	var request = {
	  endpoint: 'activity_notifications',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'subject_type',
	    selector: 'type'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'communitiesJoinRequests', ['REMOVE_REQUEST', 'DISABLE_REQUEST', 'PAGE_LEAVE', 'RESET_IS_NEW_FLAG', 'REAL_TIME_INSERT']);
	var paginatedConsts = exports.paginatedConsts = (0, _redux.createReqConsts)('communities', 'communitiesPaginatedJoinRequests', ['LOAD_NEXT_REQUESTS', 'UPDATE_PAGINATION_PARAMETERS']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var paginatedActions = exports.paginatedActions = (0, _redux.createActions)(paginatedConsts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, request);
	var paginatedWatcher = exports.paginatedWatcher = (0, _redux.createReqWatcher)(paginatedConsts, paginatedActions, request);
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	function setNewStatus(list) {
	  return list.map(function (item) {
	    return (0, _extends13.default)({}, item, {
	      isNew: item.status === 'unread'
	    });
	  });
	}
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload;
	
	
	  switch (action.type) {
	    case consts.SUCCEED:
	      {
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true
	        }, (0, _lodash.groupBy)(setNewStatus(payload), 'type'));
	      }
	    case paginatedConsts.SUCCEED:
	      {
	        var group = (0, _lodash.groupBy)(payload, 'type');
	        var type = (0, _keys2.default)(group)[0] || _constants.ACTIVITY_TYPES.NOTIFICATIONS;
	        var list = (0, _lodash.get)(group, type, []);
	        var prevList = (0, _lodash.get)(state, type, []);
	
	        return (0, _assign2.default)({}, state, _redux.initialState, (0, _defineProperty3.default)({
	          succeed: true
	        }, type, prevList.concat(setNewStatus(list))));
	      }
	
	    case consts.ADD_META:
	      {
	        var _type = payload.subjectType;
	        var prevMetaByType = (0, _lodash.get)(state, ['meta', _type]);
	
	        return (0, _extends13.default)({}, state, {
	          meta: (0, _extends13.default)({}, state.meta, (0, _defineProperty3.default)({}, _type, (0, _extends13.default)({}, prevMetaByType, {
	            total: payload.count
	          })))
	        });
	      }
	
	    case consts.REAL_TIME_INSERT:
	      {
	        var _extends5;
	
	        var _type2 = payload.type,
	            _list = payload.list;
	
	
	        var _prevList = (0, _lodash.get)(state, _type2, []);
	        var _prevMetaByType = (0, _lodash.get)(state, ['meta', _type2]);
	
	        return (0, _extends13.default)({}, state, (_extends5 = {}, (0, _defineProperty3.default)(_extends5, _type2, [].concat((0, _toConsumableArray3.default)(setNewStatus(_list)), (0, _toConsumableArray3.default)(_prevList))), (0, _defineProperty3.default)(_extends5, 'meta', (0, _extends13.default)({}, state.meta, (0, _defineProperty3.default)({}, _type2, (0, _extends13.default)({}, _prevMetaByType, {
	          total: (0, _lodash.get)(_prevMetaByType, 'total', 0) + _list.length
	        })))), _extends5));
	      }
	
	    case _removeNotificationsCounters.consts.SEND:
	      {
	        var meta = payload.meta,
	            notificationIds = payload.notificationIds;
	
	        var _list2 = (0, _lodash.get)(state, meta, []).map(function (item) {
	          return notificationIds.includes(item.id) ? (0, _extends13.default)({}, item, { status: 'read' }) : (0, _extends13.default)({}, item);
	        });
	
	        return (0, _extends13.default)({}, state, (0, _defineProperty3.default)({}, meta, [].concat((0, _toConsumableArray3.default)(_list2))));
	      }
	
	    case consts.RESET_IS_NEW_FLAG:
	      {
	        var ids = payload.ids,
	            _type3 = payload.type;
	
	        var _list3 = (0, _lodash.get)(state, _type3, []).map(function (item) {
	          return ids.includes(item.id) ? (0, _extends13.default)({}, item, { isNew: false }) : (0, _extends13.default)({}, item);
	        });
	
	        return (0, _extends13.default)({}, state, (0, _defineProperty3.default)({}, _type3, [].concat((0, _toConsumableArray3.default)(_list3))));
	      }
	
	    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS:
	      {
	        var _type4 = payload.type,
	            offset = payload.offset,
	            limit = payload.limit;
	
	        var _prevMetaByType2 = (0, _lodash.get)(state, ['meta', _type4]);
	
	        return (0, _extends13.default)({}, state, {
	          meta: (0, _extends13.default)({}, state.meta, (0, _defineProperty3.default)({}, _type4, (0, _extends13.default)({}, _prevMetaByType2, {
	            offset: offset,
	            limit: limit
	          })))
	        });
	      }
	
	    case consts.REMOVE_REQUEST:
	      {
	        var _extends10;
	
	        var _action$payload = action.payload,
	            _type5 = _action$payload.type,
	            id = _action$payload.id;
	
	        var _prevList2 = (0, _lodash.get)(state, _type5, []);
	        var _list4 = _prevList2.filter(function (item) {
	          return (0, _lodash.get)(item, 'subject.id') !== id;
	        });
	        var _prevMetaByType3 = (0, _lodash.get)(state, ['meta', _type5]);
	
	        return (0, _extends13.default)({}, state, (_extends10 = {}, (0, _defineProperty3.default)(_extends10, _type5, _list4), (0, _defineProperty3.default)(_extends10, 'meta', (0, _extends13.default)({}, state.meta, (0, _defineProperty3.default)({}, _type5, (0, _extends13.default)({}, _prevMetaByType3, {
	          total: (0, _lodash.get)(_prevMetaByType3, 'total', 0) - 1
	        })))), _extends10));
	      }
	
	    case consts.DISABLE_REQUEST:
	      {
	        var _action$payload2 = action.payload,
	            _id = _action$payload2.id,
	            _type6 = _action$payload2.type;
	
	        var _prevList3 = (0, _lodash.get)(state, _type6, []);
	        var _list5 = _prevList3.map(function (item) {
	          return (0, _lodash.get)(item, 'subject.id') === _id ? (0, _extends13.default)({}, item, { disabled: true }) : item;
	        });
	
	        return (0, _extends13.default)({}, state, (0, _defineProperty3.default)({}, _type6, _list5));
	      }
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _communityImageUpdate = __webpack_require__(820);
	
	var _communityImageRemove = __webpack_require__(819);
	
	var _constants = __webpack_require__(17);
	
	var _communityInfoUpdate = __webpack_require__(821);
	
	var _constants2 = __webpack_require__(94);
	
	var _constants3 = _interopRequireDefault(_constants2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'currentCommunityInfo', ['UPDATE_CURRENT_COMMUNITY', 'UPDATE_POSTS_COUNTER', 'RESET_COMMUNITY', 'CLEAR_USER_ROLE']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	  var defaultState = reqReducer(state, action);
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          sending: !payload.disableLoading,
	          disabled: true
	        });
	      }
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, defaultState, {
	          disabled: false
	        });
	      }
	
	    case _communityInfoUpdate.consts.SUCCEED:
	    case consts.UPDATE_CURRENT_COMMUNITY:
	      return (0, _extends3.default)({}, defaultState, payload);
	    case consts.CLEAR_USER_ROLE:
	      return (0, _extends3.default)({}, defaultState, payload, {
	        currentUserRole: null,
	        accessLevel: _constants.COMMUNITIES_ACCESS_LEVELS.READ_ONLY
	      });
	    case consts.UPDATE_POSTS_COUNTER:
	      return (0, _extends3.default)({}, defaultState, {
	        totalPosts: defaultState.totalPosts + 1
	      });
	
	    case consts.RESET_COMMUNITY:
	      {
	        return _redux.initialState;
	      }
	
	    case _communityImageRemove.consts.SUCCEED:
	    case _communityImageUpdate.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, payload);
	      }
	
	    case _constants3.default.NEW_COMMUNITY_INVITE:
	      {
	        var data = (0, _get2.default)(payload, 'message.payload.data');
	        var communityId = (0, _get2.default)(data, 'communityId');
	        var memberInvitationId = (0, _get2.default)(data, 'notification.subject.id');
	
	        if (communityId === state.id) {
	          return (0, _extends3.default)({}, state, {
	            memberInvitationId: memberInvitationId
	          });
	        }
	
	        return state;
	      }
	
	    default:
	      return defaultState;
	  }
	};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'removeNotificationsCounters');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'notification_counters',
	  type: 'post',
	  slug: ['flush']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestOptions = {
	  endpoint: 'complaint_notifications',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'status',
	    selector: 'status'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('complaints', 'unresolved-list', ['LOAD_MORE', 'TOGGLE_MENU_VISIBILITY', 'REMOVE_COMPLAINT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('complaints', 'unresolved-list-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  reportsVisible: false,
	  pagination: { offset: 0, limit: 10 }
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          succeed: true,
	          list: action.payload
	        });
	      }
	
	    case consts.REJECTED:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          rejected: true
	        }, action.payload);
	      }
	
	    case consts.TOGGLE_MENU_VISIBILITY:
	      {
	        return (0, _extends3.default)({}, state, {
	          reportsVisible: action.payload
	        });
	      }
	
	    case paginationConsts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: [].concat((0, _toConsumableArray3.default)(state.list), (0, _toConsumableArray3.default)(action.payload))
	        });
	      }
	
	    case _constants2.default.NEW_COMPLAINT:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: [action.payload].concat((0, _toConsumableArray3.default)(state.list))
	        });
	      }
	
	    case consts.REMOVE_COMPLAINT:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: state.list.filter(function (_ref) {
	            var id = _ref.id;
	            return id !== (0, _get2.default)(action, 'payload.id');
	          })
	        });
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var _handleUpdateStateWithCompleteSurvey = __webpack_require__(770);
	
	var _handleUpdateStateWithAcceptedConsent = __webpack_require__(769);
	
	var _handleUpdateStateWithUploadDoc = __webpack_require__(772);
	
	var _handleUpdateStateWithDeleteDoc = __webpack_require__(771);
	
	var _appointmentReqConfig = __webpack_require__(850);
	
	var _uploadDocumentReq = __webpack_require__(304);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _deleteDocumentReq = __webpack_require__(302);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var requestOptions = (0, _appointmentReqConfig.makeAppointmentListReqConfig)([{
	  type: 'payload.query',
	  queryParameter: 'scope',
	  value: 'history_list'
	}]);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'history-appointment-list-req', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('health-board', 'history-appointment-list-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions);
	
	var reducer = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'appointmentsCount'
	});
	
	exports.default = function (state, action) {
	  switch (action.type) {
	    case _uploadDocumentReq.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithUploadDoc.handleUpdateStateWithUploadDoc)(state, action);
	      }
	
	    case _upcomingSurveyCompletions.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithCompleteSurvey.handleUpdateStatusSurveyInAppointmentDetails)(state, action);
	      }
	
	    case _deleteDocumentReq.consts.UPDATE:
	      {
	        return (0, _handleUpdateStateWithDeleteDoc.handleUpdateStateWithDeleteDoc)(state, action);
	      }
	
	    case _signAppointmentConsentReq.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithAcceptedConsent.handleUpdateStateWithAcceptedConsent)(state, action);
	      }
	
	    default:
	      return reducer(state, action);
	  }
	};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _handleUpdateStateWithCompleteSurvey = __webpack_require__(770);
	
	var _handleUpdateStateWithAcceptedConsent = __webpack_require__(769);
	
	var _handleUpdateStateWithUploadDoc = __webpack_require__(772);
	
	var _handleUpdateStateWithDeleteDoc = __webpack_require__(771);
	
	var _handleCheckin = __webpack_require__(3369);
	
	var _arrayModify = __webpack_require__(153);
	
	var _appointmentDetailsReq = __webpack_require__(259);
	
	var appointmentDetails = _interopRequireWildcard(_appointmentDetailsReq);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _appointmentReqConfig = __webpack_require__(850);
	
	var _uploadDocumentReq = __webpack_require__(304);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var _managePendingRequest = __webpack_require__(263);
	
	var _paymentVerificationsReq = __webpack_require__(419);
	
	var paymentVerification = _interopRequireWildcard(_paymentVerificationsReq);
	
	var _editPaymentReq = __webpack_require__(349);
	
	var _deleteDocumentReq = __webpack_require__(302);
	
	var _confirmVisitByPatientReq = __webpack_require__(666);
	
	var _checkInAppointmentReq = __webpack_require__(533);
	
	var checkInReq = _interopRequireWildcard(_checkInAppointmentReq);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var cancelReq = _interopRequireWildcard(_cancelAppointmentReq);
	
	var _appointmentAccountFormPaymentReq = __webpack_require__(339);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestOptions = (0, _appointmentReqConfig.makeAppointmentListReqConfig)([{
	  type: 'payload.query',
	  queryParameter: 'scope',
	  value: 'upcoming_list'
	}]);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'upcoming-appointment-list-req', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('health-board', 'upcoming-appointment-list-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions);
	
	var reducer = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'appointmentsCount'
	});
	
	exports.default = function (state, action) {
	  switch (action.type) {
	    case _editPaymentReq.consts.SUCCEED:
	      {
	        var target = state.list.find(function (_ref) {
	          var id = _ref.id;
	          return action.payload.id === id;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          list: (0, _arrayModify.findAndReplace)(state.list, (0, _extends3.default)({}, target, {
	            copay: action.payload.copay
	          }))
	        });
	      }
	
	    case checkInReq.consts.SUCCEED:
	      {
	        return (0, _handleCheckin.handleCheckin)(state, action.payload);
	      }
	
	    case _appointmentDetails.APPOINTMENT_DETAILS_TYPES.REPLACE_APPOINTMENT:
	    case appointmentDetails.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: (0, _arrayModify.findAndReplace)(state.list, action.payload)
	        });
	      }
	
	    case paymentVerification.consts.SUCCEED:
	    case _appointmentAccountFormPaymentReq.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: (0, _arrayModify.findAndReplace)(state.list, action.payload.payable)
	        });
	      }
	
	    case _appointmentDetails.APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT:
	    case cancelReq.consts.SUCCEED:
	      {
	        var count = state.count - 1;
	
	        return (0, _extends3.default)({}, state, {
	          count: count >= 0 ? count : 0,
	          list: state.list.filter(function (_ref2) {
	            var id = _ref2.id;
	            return id !== action.payload.id;
	          })
	        });
	      }
	
	    case _managePendingRequest.consts.SUCCEED:
	      {
	        var _target = state.list.find(function (_ref3) {
	          var id = _ref3.id;
	          return action.payload.id === id;
	        });
	        if (_target) {
	          return (0, _extends3.default)({}, state, {
	            list: (0, _arrayModify.findAndReplace)(state.list, (0, _extends3.default)({}, _target, {
	              status: action.payload.status
	            }))
	          });
	        }
	        return (0, _extends3.default)({}, state);
	      }
	
	    case _signAppointmentConsentReq.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithAcceptedConsent.handleUpdateStateWithAcceptedConsent)(state, action);
	      }
	
	    case _uploadDocumentReq.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithUploadDoc.handleUpdateStateWithUploadDoc)(state, action);
	      }
	
	    case _upcomingSurveyCompletions.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithCompleteSurvey.handleUpdateStatusSurveyInAppointmentDetails)(state, action);
	      }
	
	    case _deleteDocumentReq.consts.UPDATE:
	      {
	        return (0, _handleUpdateStateWithDeleteDoc.handleUpdateStateWithDeleteDoc)(state, action);
	      }
	
	    case _confirmVisitByPatientReq.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: (0, _arrayModify.findAndReplace)(state.list, action.payload)
	        });
	      }
	
	    default:
	      return reducer(state, action);
	  }
	};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'edit-payment-amount');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'copay']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('patient', 'update-patient-insurance', ['CLEAR_ERROR']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'patient_insurances', {
	    type: 'payload',
	    selector: ['patientInsuranceId']
	  }]
	});
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR_ERROR:
	      return (0, _extends3.default)({}, state, {
	        error: null
	      });
	    default:
	      return reqReducer(state, action);
	  }
	};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConnectionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConnectionShape = exports.ConnectionShape = _propTypes2.default.shape({
	  user: _propTypes2.default.object,
	  stream: _propTypes2.default.object,
	  ready: _propTypes2.default.bool,
	  video: _propTypes2.default.any,
	  id: _propTypes2.default.string
	});

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useVirtualVisit = useVirtualVisit;
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _error = __webpack_require__(101);
	
	var errorUI = _interopRequireWildcard(_error);
	
	var _utils = __webpack_require__(307);
	
	var _selectors = __webpack_require__(23);
	
	var _virtualVisit = __webpack_require__(305);
	
	var _videoCallEndPopup = __webpack_require__(1376);
	
	var _selectors2 = __webpack_require__(294);
	
	var _appointmentDetailsReq = __webpack_require__(259);
	
	var appointmentDetails = _interopRequireWildcard(_appointmentDetailsReq);
	
	var _constants = __webpack_require__(17);
	
	var _selectors3 = __webpack_require__(64);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NO_SHOW = _constants.APPOINTMENT_STATUSES.NO_SHOW,
	    CANCELED = _constants.APPOINTMENT_STATUSES.CANCELED,
	    COMPLETED = _constants.APPOINTMENT_STATUSES.COMPLETED,
	    WAITING = _constants.APPOINTMENT_STATUSES.WAITING;
	
	var endVisitStatuses = [NO_SHOW, CANCELED, COMPLETED];
	
	function useVirtualVisit() {
	  var patientProfile = (0, _reactRedux.useSelector)(_selectors3.selectRoomInvitationPatientProfile);
	  var roomInvitationInvitee = (0, _reactRedux.useSelector)(_selectors3.selectRoomInvitationInvitee);
	  var roomInvitationRole = (0, _reactRedux.useSelector)(_selectors3.selectRoomInvitationRole);
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var config = (0, _reactRedux.useSelector)(_selectors3.selectVirtualVisitConfig);
	  var opened = (0, _reactRedux.useSelector)(_selectors3.selectVirtualVisitOpened);
	  var isOpenedMobSidebar = (0, _reactRedux.useSelector)(_selectors3.selectVirtualVisitMobSidebarOpened);
	  var dragging = (0, _reactRedux.useSelector)(_selectors3.selectVirtualVisitDragging);
	  var appointment = (0, _reactRedux.useSelector)(_selectors2.selectCurrentAppointment);
	  var isLoggedUser = (0, _reactRedux.useSelector)(_selectors.isLoggedUserSelector);
	
	  var loading = false;
	  var userId = (0, _get2.default)(appointment, 'userId');
	  var appointmentId = (0, _get2.default)(appointment, 'id');
	
	  var collapsed = (0, _reactRedux.useSelector)(_selectors3.selectVirtualVisitCollapsed);
	  var fullScreenView = (0, _reactRedux.useSelector)(_selectors3.selectVirtualVisitFullScreenView);
	
	  var otConfig = (0, _react.useMemo)(function () {
	    if (!config) return null;
	    return {
	      sessionID: config.room,
	      token: config.token,
	      apiKey: config.apiKey
	    };
	  }, [config]);
	
	  var initialRoomPendingInvitations = (0, _react.useMemo)(function () {
	    var fromMeta = (0, _get2.default)(config, 'roomPendingInvitations');
	    return Array.isArray(fromMeta) ? fromMeta : [];
	  }, [config]);
	
	  var roomMeta = (0, _react.useMemo)(function () {
	    return {
	      name: (0, _get2.default)(config, 'roomName', ''),
	      number: (0, _get2.default)(config, 'roomNumber', '-'),
	      connectionRoom: (0, _get2.default)(config, 'connectionRoom', false),
	      type: (0, _get2.default)(config, 'type'),
	      visitType: (0, _get2.default)(config, 'visitTypeName', '')
	    };
	  }, [config]);
	
	  var cancelCallInvitation = (0, _react.useCallback)(function (email) {
	    console.log('cancel invite', email);
	  }, [appointmentId]);
	
	  var openCallSettings = (0, _react.useCallback)(function () {
	    console.log('open call settings');
	  }, []);
	
	  var expandView = (0, _react.useCallback)(function () {
	    return dispatch(_virtualVisit.virtualVisitActions.setCollapsing(false));
	  }, []);
	  var collapseView = (0, _react.useCallback)(function () {
	    dispatch(_virtualVisit.virtualVisitActions.setFullScreenView(false));
	    dispatch(_virtualVisit.virtualVisitActions.setCollapsing(true));
	  }, []);
	
	  var destroyVisit = (0, _react.useCallback)(function () {
	    return dispatch(_virtualVisit.virtualVisitActions.reset());
	  }, []);
	
	  var toggleFullScreenView = (0, _react.useCallback)(function () {
	    return dispatch(_virtualVisit.virtualVisitActions.setFullScreenView(!fullScreenView));
	  }, [fullScreenView]);
	
	  var publisherUserData = (0, _react.useMemo)(function () {
	    if (roomInvitationRole === _props.CARE_ROLE.GUARDIAN && roomInvitationInvitee) {
	      return {
	        avatar: {},
	        name: roomInvitationInvitee.firstName + ' ' + roomInvitationInvitee.lastName,
	        id: roomInvitationInvitee.id,
	        isProvider: false
	      };
	    }
	
	    if (patientProfile) {
	      return {
	        avatar: {},
	        name: patientProfile.firstName + ' ' + patientProfile.lastName,
	        id: patientProfile.id,
	        isProvider: false
	      };
	    }
	
	    return {
	      avatar: (0, _get2.default)(appointment, 'patientUserInfo.avatar.thumbMin', ''),
	      name: (0, _get2.default)(appointment, 'patientUserInfo.displayableName', ''),
	      id: (0, _get2.default)(appointment, 'patientUserInfo.id'),
	      isProvider: false
	    };
	  }, [appointment, patientProfile, roomInvitationInvitee, roomInvitationRole]);
	
	  var displayErrorModal = (0, _react.useCallback)(function (name) {
	    var _getOTErrorTranslatio = (0, _utils.getOTErrorTranslationKey)(name),
	        description = _getOTErrorTranslatio.description;
	
	    dispatch(errorUI.actions.update({ id: description }));
	  }, []);
	
	  var handleGlobalError = (0, _react.useCallback)(function (name) {
	    destroyVisit();
	    displayErrorModal(name);
	  }, []);
	
	  var toggleMobSidebar = (0, _react.useCallback)(function () {
	    dispatch(_virtualVisit.virtualVisitActions.toggleMobSidebar());
	  }, []);
	
	  var placeholder = (0, _react.useMemo)(function () {
	    var code = (0, _get2.default)(config, 'typeCode');
	    var status = (0, _get2.default)(appointment, 'status.coreAppName');
	
	    if (code === _constants.URGENT_VISIT_TYPE_CODE && status === WAITING) {
	      return (0, _extends3.default)({
	        title: 'virtualVisit.placeholder.title',
	        subtitle: 'virtualVisit.placeholder.subtitle'
	      }, (0, _get2.default)(appointment, 'copay') && {
	        extraSubtitle: 'appointment.payment.charged'
	      });
	    }
	
	    if (code === _constants.VIRTUAL_VISIT_TYPE_CODE) {
	      return {
	        title: 'virtualVisit.regural.placeholder.title',
	        subtitle: 'virtualVisit.regural.placeholder.subtitle'
	      };
	    }
	  }, [config, appointment]);
	
	  var openConfirmationPopup = function openConfirmationPopup(status) {
	    if (endVisitStatuses.includes(status)) {
	      dispatch(_videoCallEndPopup.videoCallEndPopupActions.open(status));
	    }
	  };
	
	  var updateAppointment = function updateAppointment() {
	    if (isLoggedUser) dispatch(appointmentDetails.actions.send({ userId: userId, appointmentId: appointmentId }));
	  };
	
	  return {
	    viewOptions: {
	      opened: opened,
	      dragging: dragging,
	      collapsed: collapsed,
	      expandView: expandView,
	      collapseView: collapseView,
	      fullScreenView: fullScreenView,
	      toggleMobSidebar: toggleMobSidebar,
	      toggleFullScreenView: toggleFullScreenView,
	      mobSidebarOpened: isOpenedMobSidebar
	    },
	    callState: {
	      otConfig: otConfig,
	      loading: loading,
	      roomMeta: roomMeta,
	      destroyVisit: destroyVisit,
	      initialRoomPendingInvitations: initialRoomPendingInvitations
	    },
	    appointment: appointment,
	    placeholder: placeholder,
	    publisherUserData: publisherUserData,
	    cancelCallInvitation: cancelCallInvitation,
	    openCallSettings: openCallSettings,
	    displayErrorModal: displayErrorModal,
	    handleGlobalError: handleGlobalError,
	    openConfirmationPopup: openConfirmationPopup,
	    updateAppointment: updateAppointment
	  };
	}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'guardian-dependents');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'care_user',
	  type: 'get',
	  slug: ['care_role_relation_assignments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'accountVaultsForm');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'accountvaults']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginatedWatcher = exports.watcher = exports.paginatedActions = exports.actions = exports.paginatedConsts = exports.consts = undefined;
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(58);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paginatedRequest = {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'assignment_results', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var request = {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'assignment_results', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  pagination: {
	    offset: 0,
	    limit: 10
	  }
	});
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'answered');
	var paginatedConsts = exports.paginatedConsts = (0, _redux.createReqConsts)('surveys', 'answeredPaginated', ['LOAD_NEXT_REQUESTS', 'UPDATE_PAGINATION_PARAMETERS']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var paginatedActions = exports.paginatedActions = (0, _redux.createActions)(paginatedConsts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, request);
	var paginatedWatcher = exports.paginatedWatcher = (0, _redux.createReqWatcher)(paginatedConsts, paginatedActions, paginatedRequest);
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      {
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true
	        }, { list: payload });
	      }
	    case paginatedConsts.SUCCEED:
	      {
	        var prevList = (0, _lodash.get)(state, 'list', []);
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true,
	          list: prevList.concat(payload)
	        });
	      }
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMS = exports.isIE = exports.isSafari = exports.browserChecker = undefined;
	exports.browserInfo = browserInfo;
	exports.isIOS = isIOS;
	exports.isMobileIOS = isMobileIOS;
	exports.isAndroid = isAndroid;
	exports.getBrowserName = getBrowserName;
	exports.isSupportedBrowser = isSupportedBrowser;
	
	var _bowser = __webpack_require__(1397);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// order matters
	var browserKeys = ['Edge', 'Trident', 'MSIE', 'Firefox', 'OPR', 'Chrome', 'Safari', 'Opera'];
	var ua = window.navigator.userAgent;
	
	var browserChecker = exports.browserChecker = function browserChecker() {
	  return browserKeys.find(function (key) {
	    return ua.indexOf(key) > -1;
	  });
	};
	
	var isSafari = exports.isSafari = function isSafari() {
	  return browserChecker() === 'Safari';
	};
	var isIE = exports.isIE = function isIE() {
	  return browserChecker() === 'MSIE' || browserChecker() === 'Trident';
	};
	var isMS = exports.isMS = isIE() || browserChecker() === 'Edge';
	
	function browserInfo() {
	  return _bowser2.default.getParser(window.navigator.userAgent);
	}
	
	function isIOS() {
	  return browserInfo().is('macOS');
	}
	
	function isMobileIOS() {
	  return browserInfo().is('iOS');
	}
	
	function isAndroid() {
	  return browserInfo().is('Android');
	}
	
	function getBrowserName() {
	  var parser = browserInfo();
	  return parser.getBrowserName();
	}
	
	function isSupportedBrowser() {
	  var browserName = getBrowserName();
	  var isSupported = _constants.SUPPORTED_BROWSERS.includes(browserName);
	  return isIOS() ? true : isSupported;
	}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deepTrim(object) {
	  if (typeof object === 'string') {
	    return object.trim();
	  }
	  if ((typeof object === 'undefined' ? 'undefined' : (0, _typeof3.default)(object)) === 'object') {
	    for (var key in object) {
	      object[key] = deepTrim(object[key]);
	    }
	  }
	
	  return object;
	}
	
	exports.default = deepTrim;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertPrimaryCareProviderDataToFormOption = exports.getPcpNotListedOption = exports.getInitialPcpFormConsiderUsPcpValue = exports.getConsiderUsAsYourPCPPayload = exports.getConsiderUsPcpUiAnswer = exports.getPCPDictionaries = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _pcpAnswer = __webpack_require__(617);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPCPDictionaries = exports.getPCPDictionaries = function getPCPDictionaries(_ref) {
	  var formatMessage = _ref.formatMessage;
	
	  var pcpAnswers = {
	    Y: formatMessage({ id: 'common.yes' }),
	    N: formatMessage({ id: 'common.no' }),
	    U: formatMessage({ id: 'common.preferNotToSay' })
	  };
	
	  var considerUsAsYourPCPAnswers = {
	    Y: formatMessage({ id: 'common.yes' }),
	    N: formatMessage({ id: 'common.no' })
	  };
	
	  return {
	    considerUsAsYourPCPAnswers: considerUsAsYourPCPAnswers,
	    pcpAnswers: pcpAnswers
	  };
	};
	
	var getConsiderUsPcpUiAnswer = exports.getConsiderUsPcpUiAnswer = function getConsiderUsPcpUiAnswer(_ref2) {
	  var considerUsAsYourPcp = _ref2.considerUsAsYourPcp,
	      formatMessage = _ref2.formatMessage;
	
	  switch (considerUsAsYourPcp) {
	    case _pcpAnswer.PCP_PROVIDER_ANSWER.Y:
	    case true:
	      return formatMessage({ id: 'common.yes' });
	    case false:
	    case _pcpAnswer.PCP_PROVIDER_ANSWER.N:
	      return formatMessage({ id: 'common.no' });
	    default:
	      return _strings.DEFAULT_EMPTY_VALUE;
	  }
	};
	
	var getConsiderUsAsYourPCPPayload = exports.getConsiderUsAsYourPCPPayload = function getConsiderUsAsYourPCPPayload(formData) {
	  var considerUsPcp = (0, _get2.default)(formData, 'considerUsPcp', null);
	
	  if (!considerUsPcp) {
	    return null;
	  }
	
	  return considerUsPcp === _pcpAnswer.PCP_PROVIDER_ANSWER.Y;
	};
	
	var getInitialPcpFormConsiderUsPcpValue = exports.getInitialPcpFormConsiderUsPcpValue = function getInitialPcpFormConsiderUsPcpValue(considerUsPcp) {
	  var considerUsPcpValue = null;
	
	  if (considerUsPcp === true) {
	    considerUsPcpValue = _pcpAnswer.PCP_PROVIDER_ANSWER.Y;
	  }
	
	  if (considerUsPcp === false) {
	    considerUsPcpValue = _pcpAnswer.PCP_PROVIDER_ANSWER.N;
	  }
	
	  return considerUsPcpValue;
	};
	
	var getPcpNotListedOption = exports.getPcpNotListedOption = function getPcpNotListedOption(formatMessage) {
	  return {
	    label: formatMessage({ id: 'common.myPcpNotListed' }),
	    value: _pcpAnswer.PCP_NOT_LISTED_VALUE
	  };
	};
	
	var convertPrimaryCareProviderDataToFormOption = exports.convertPrimaryCareProviderDataToFormOption = function convertPrimaryCareProviderDataToFormOption(provider, pcpName, formatMessage) {
	  if (pcpName) {
	    return getPcpNotListedOption(formatMessage);
	  }
	
	  if (!provider) return null;
	
	  var option = (0, _get2.default)(provider, 'label', '');
	
	  if (option) {
	    return provider;
	  }
	
	  var firstName = (0, _get2.default)(provider, 'firstName', '');
	  var lastName = (0, _get2.default)(provider, 'lastName', '');
	  var id = (0, _get2.default)(provider, 'id', '');
	
	  return {
	    label: firstName + ' ' + lastName,
	    value: id
	  };
	};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelectorFactory = makeSelectorFactory;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeSelectorFactory(rootState) {
	  return function getSelectors(innerKey) {
	    var selectState = (0, _reselect.createSelector)(rootState, function (state) {
	      return (0, _get2.default)(state, innerKey, {});
	    });
	    var selectStatePending = (0, _reselect.createSelector)(selectState, function (state) {
	      return (0, _get2.default)(state, 'sending', false);
	    });
	    var selectStateError = (0, _reselect.createSelector)(selectState, function (state) {
	      return (0, _get2.default)(state, 'error', null);
	    });
	    var selectStateSucceed = (0, _reselect.createSelector)(selectState, function (state) {
	      return (0, _get2.default)(state, 'succeed', false);
	    });
	    var selectStateRejected = (0, _reselect.createSelector)(selectState, function (state) {
	      return (0, _get2.default)(state, 'rejected', false);
	    });
	    var selectStateList = (0, _reselect.createSelector)(selectState, function (state) {
	      return (0, _get2.default)(state, 'list', []);
	    });
	
	    var selectStateData = (0, _reselect.createSelector)(selectState, function (state) {
	      return (0, _get2.default)(state, 'data', null);
	    });
	
	    var makeSelect = function makeSelect(key, defaultValue) {
	      return (0, _reselect.createSelector)(selectState, function (state) {
	        return (0, _get2.default)(state, key, defaultValue);
	      });
	    };
	
	    return {
	      selectState: selectState,
	      selectStatePending: selectStatePending,
	      selectStateRejected: selectStateRejected,
	      selectStateError: selectStateError,
	      selectStateSucceed: selectStateSucceed,
	      selectStateList: selectStateList,
	      selectStateData: selectStateData,
	      makeSelect: makeSelect
	    };
	  };
	}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.emitClearSelectionEvent = emitClearSelectionEvent;
	exports.subscribeToClearSelection = subscribeToClearSelection;
	exports.emitInitSceduleLoadEvent = emitInitSceduleLoadEvent;
	exports.subscribeToInitScheduleLoad = subscribeToInitScheduleLoad;
	exports.emitChangeSelectionEvent = emitChangeSelectionEvent;
	exports.subscribeToChangeSelection = subscribeToChangeSelection;
	
	var _pubsubJs = __webpack_require__(994);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLEAR_SELECTION_EVENT = 'clear-selection-event';
	
	function emitClearSelectionEvent() {
	  _pubsubJs2.default.publish(CLEAR_SELECTION_EVENT);
	}
	
	function subscribeToClearSelection(cb) {
	  var token = _pubsubJs2.default.subscribe(CLEAR_SELECTION_EVENT, cb);
	  return function () {
	    _pubsubJs2.default.unsubscribe(token);
	  };
	}
	
	var INIT_SCHEDULE_LOAD_EVENT = 'init-schedule-load-event';
	
	function emitInitSceduleLoadEvent(data) {
	  _pubsubJs2.default.publish(INIT_SCHEDULE_LOAD_EVENT, data);
	}
	
	function subscribeToInitScheduleLoad(cb) {
	  var token = _pubsubJs2.default.subscribe(INIT_SCHEDULE_LOAD_EVENT, cb);
	  return function () {
	    _pubsubJs2.default.unsubscribe(token);
	  };
	}
	
	var CHANGE_SELECTION_RANGE = 'change-selection-range';
	
	function emitChangeSelectionEvent(data) {
	  _pubsubJs2.default.publish(CHANGE_SELECTION_RANGE, data);
	}
	
	function subscribeToChangeSelection(cb) {
	  var token = _pubsubJs2.default.subscribe(CHANGE_SELECTION_RANGE, cb);
	  return function () {
	    _pubsubJs2.default.unsubscribe(token);
	  };
	}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSurveyHeaderSubtitle = getSurveyHeaderSubtitle;
	exports.getSurveyAssignmentMethod = getSurveyAssignmentMethod;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _capitalize = __webpack_require__(209);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _getDateStr = __webpack_require__(4239);
	
	var _getDateStr2 = _interopRequireDefault(_getDateStr);
	
	var _getStatus = __webpack_require__(4240);
	
	var _getStatus2 = _interopRequireDefault(_getStatus);
	
	var _getTaemOrUserName = __webpack_require__(1938);
	
	var _utils = __webpack_require__(254);
	
	var _preVisitForm = __webpack_require__(288);
	
	var _strings = __webpack_require__(15);
	
	var _dateConverters = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (survey, formatMessage) {
	  var showStatus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!(0, _get2.default)(survey, 'assignmentId')) return {};
	
	  var sentAt = survey.sentAt,
	      status = survey.status,
	      expiredAt = survey.expiredAt,
	      assignmentMethod = survey.assignmentMethod,
	      assigner = survey.assigner,
	      originalAssigner = survey.originalAssigner,
	      _survey$survey = survey.survey,
	      description = _survey$survey.description,
	      frequency = _survey$survey.frequency,
	      surveyType = _survey$survey.surveyType,
	      name = _survey$survey.name,
	      localCompletedAt = survey.localCompletedAt,
	      completedAtTimezone = survey.completedAtTimezone;
	
	
	  var surveyHeading = getSurveyHeaderSubtitle(surveyType, frequency, formatMessage, assignmentMethod, assigner, originalAssigner);
	
	  var heading = surveyHeading + ' ' + (!(0, _preVisitForm.isPreVisitForm)(surveyType) && !(0, _utils.isCompleted)(status) ? (0, _getDateStr2.default)(sentAt, formatMessage) : '');
	
	  return {
	    sentAt: sentAt,
	    expiredAt: expiredAt,
	    description: description,
	    frequency: frequency,
	    name: name,
	    heading: heading,
	    status: (0, _getStatus2.default)(survey, formatMessage, showStatus),
	    date: localCompletedAt ? (0, _dateConverters.formatWithTimezone)(localCompletedAt, completedAtTimezone, formatMessage) : null
	  };
	};
	
	function getSurveyHeaderSubtitle(surveyType, frequency, formatMessage, method, assigner, originalAssigner) {
	  var preVisitTitle = !method ? formatMessage({ id: 'surveys.preVisit.preVisitForm' }) : '';
	  var frequencyTitle = !(0, _preVisitForm.isPreVisitForm)(surveyType) ? (0, _capitalize2.default)(frequency) + ' ' + formatMessage(_strings.ACTIONS.survey.single) : preVisitTitle;
	  var typeTitle = getSurveyAssignmentMethod({
	    method: method,
	    assigner: assigner,
	    formatMessage: formatMessage,
	    originalAssigner: originalAssigner
	  });
	
	  return [frequencyTitle, typeTitle].filter(function (str) {
	    return Boolean(str);
	  }).join(', ');
	}
	
	function getSurveyAssignmentMethod(_ref) {
	  var method = _ref.method,
	      assigner = _ref.assigner,
	      formatMessage = _ref.formatMessage,
	      showDescription = _ref.showDescription,
	      originalAssigner = _ref.originalAssigner;
	
	  var assignerName = (0, _get2.default)(assigner, 'name');
	  var originalAssignerName = (0, _get2.default)(originalAssigner, 'displayableName');
	  var name = (0, _getTaemOrUserName.getTeamOrUserName)(assignerName, originalAssignerName);
	  var translationId = showDescription ? _strings.SURVEYS_ASSIGNMENT_DESC : _strings.SURVEYS_ASSIGNMENT_TITLE;
	
	  return method ? formatMessage(translationId[method], { name: name || '' }) : '';
	}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RULES = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _validators;
	
	exports.validateWithRule = validateWithRule;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _strings = __webpack_require__(15);
	
	var _requiredValidator = __webpack_require__(1394);
	
	var _requiredValidator2 = _interopRequireDefault(_requiredValidator);
	
	var _phoneValidator = __webpack_require__(4250);
	
	var _phoneValidator2 = _interopRequireDefault(_phoneValidator);
	
	var _emailValidator = __webpack_require__(701);
	
	var _emailValidator2 = _interopRequireDefault(_emailValidator);
	
	var _DOBValidator = __webpack_require__(1943);
	
	var _DOBValidator2 = _interopRequireDefault(_DOBValidator);
	
	var _aliasNameFormatValidator = __webpack_require__(4246);
	
	var _aliasNameFormatValidator2 = _interopRequireDefault(_aliasNameFormatValidator);
	
	var _maxLengthValidator = __webpack_require__(4248);
	
	var _maxLengthValidator2 = _interopRequireDefault(_maxLengthValidator);
	
	var _minLengthValidator = __webpack_require__(4249);
	
	var _minLengthValidator2 = _interopRequireDefault(_minLengthValidator);
	
	var _postalCodeValidator = __webpack_require__(1947);
	
	var _postalCodeValidator2 = _interopRequireDefault(_postalCodeValidator);
	
	var _SSNValidator = __webpack_require__(4245);
	
	var _SSNValidator2 = _interopRequireDefault(_SSNValidator);
	
	var _workingHoursValidator = __webpack_require__(4254);
	
	var _workingHoursValidator2 = _interopRequireDefault(_workingHoursValidator);
	
	var _usernameValidator = __webpack_require__(4253);
	
	var _usernameValidator2 = _interopRequireDefault(_usernameValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RULES = exports.RULES = {
	  REQUIRED: 'REQUIRED',
	  PHONE: 'PHONE',
	  EMAIL: 'EMAIL',
	  DOB: 'DOB',
	  ALIAS_FORMAT: 'ALIAS_FORMAT',
	  USERNAME_FORMAT: 'USERNAME_FORMAT',
	  MAX_LENGTH: 'MAX_LENGTH',
	  MIN_LENGTH: 'MIN_LENGTH',
	  POSTAL_CODE: 'POSTAL_CODE',
	  SSN: 'SSN',
	  WORKING_HOURS: 'WORKING_HOURS'
	};
	
	var validators = (_validators = {}, (0, _defineProperty3.default)(_validators, RULES.REQUIRED, _requiredValidator2.default), (0, _defineProperty3.default)(_validators, RULES.PHONE, _phoneValidator2.default), (0, _defineProperty3.default)(_validators, RULES.EMAIL, _emailValidator2.default), (0, _defineProperty3.default)(_validators, RULES.DOB, _DOBValidator2.default), (0, _defineProperty3.default)(_validators, RULES.ALIAS_FORMAT, _aliasNameFormatValidator2.default), (0, _defineProperty3.default)(_validators, RULES.USERNAME_FORMAT, _usernameValidator2.default), (0, _defineProperty3.default)(_validators, RULES.MAX_LENGTH, _maxLengthValidator2.default), (0, _defineProperty3.default)(_validators, RULES.MIN_LENGTH, _minLengthValidator2.default), (0, _defineProperty3.default)(_validators, RULES.POSTAL_CODE, _postalCodeValidator2.default), (0, _defineProperty3.default)(_validators, RULES.SSN, _SSNValidator2.default), (0, _defineProperty3.default)(_validators, RULES.WORKING_HOURS, _workingHoursValidator2.default), _validators);
	
	function validateWithRule(ruleName, rule, value, formatMessage) {
	  var message = rule.message;
	
	  return validators[ruleName](value, rule) ? null : formatMessage((0, _get2.default)(_strings.VALIDATION_ERRORS, message));
	}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (undefined) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var X32WordArray = C_lib.WordArray;
	
			/**
	   * x64 namespace.
	   */
			var C_x64 = C.x64 = {};
	
			/**
	   * A 64-bit word.
	   */
			var X64Word = C_x64.Word = Base.extend({
				/**
	    * Initializes a newly created 64-bit word.
	    *
	    * @param {number} high The high 32 bits.
	    * @param {number} low The low 32 bits.
	    *
	    * @example
	    *
	    *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	    */
				init: function init(high, low) {
					this.high = high;
					this.low = low;
				}
	
				/**
	    * Bitwise NOTs this word.
	    *
	    * @return {X64Word} A new x64-Word object after negating.
	    *
	    * @example
	    *
	    *     var negated = x64Word.not();
	    */
				// not: function () {
				// var high = ~this.high;
				// var low = ~this.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Bitwise ANDs this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to AND with this word.
	    *
	    * @return {X64Word} A new x64-Word object after ANDing.
	    *
	    * @example
	    *
	    *     var anded = x64Word.and(anotherX64Word);
	    */
				// and: function (word) {
				// var high = this.high & word.high;
				// var low = this.low & word.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Bitwise ORs this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to OR with this word.
	    *
	    * @return {X64Word} A new x64-Word object after ORing.
	    *
	    * @example
	    *
	    *     var ored = x64Word.or(anotherX64Word);
	    */
				// or: function (word) {
				// var high = this.high | word.high;
				// var low = this.low | word.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Bitwise XORs this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to XOR with this word.
	    *
	    * @return {X64Word} A new x64-Word object after XORing.
	    *
	    * @example
	    *
	    *     var xored = x64Word.xor(anotherX64Word);
	    */
				// xor: function (word) {
				// var high = this.high ^ word.high;
				// var low = this.low ^ word.low;
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Shifts this word n bits to the left.
	    *
	    * @param {number} n The number of bits to shift.
	    *
	    * @return {X64Word} A new x64-Word object after shifting.
	    *
	    * @example
	    *
	    *     var shifted = x64Word.shiftL(25);
	    */
				// shiftL: function (n) {
				// if (n < 32) {
				// var high = (this.high << n) | (this.low >>> (32 - n));
				// var low = this.low << n;
				// } else {
				// var high = this.low << (n - 32);
				// var low = 0;
				// }
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Shifts this word n bits to the right.
	    *
	    * @param {number} n The number of bits to shift.
	    *
	    * @return {X64Word} A new x64-Word object after shifting.
	    *
	    * @example
	    *
	    *     var shifted = x64Word.shiftR(7);
	    */
				// shiftR: function (n) {
				// if (n < 32) {
				// var low = (this.low >>> n) | (this.high << (32 - n));
				// var high = this.high >>> n;
				// } else {
				// var low = this.high >>> (n - 32);
				// var high = 0;
				// }
	
				// return X64Word.create(high, low);
				// },
	
				/**
	    * Rotates this word n bits to the left.
	    *
	    * @param {number} n The number of bits to rotate.
	    *
	    * @return {X64Word} A new x64-Word object after rotating.
	    *
	    * @example
	    *
	    *     var rotated = x64Word.rotL(25);
	    */
				// rotL: function (n) {
				// return this.shiftL(n).or(this.shiftR(64 - n));
				// },
	
				/**
	    * Rotates this word n bits to the right.
	    *
	    * @param {number} n The number of bits to rotate.
	    *
	    * @return {X64Word} A new x64-Word object after rotating.
	    *
	    * @example
	    *
	    *     var rotated = x64Word.rotR(7);
	    */
				// rotR: function (n) {
				// return this.shiftR(n).or(this.shiftL(64 - n));
				// },
	
				/**
	    * Adds this word with the passed word.
	    *
	    * @param {X64Word} word The x64-Word to add with this word.
	    *
	    * @return {X64Word} A new x64-Word object after adding.
	    *
	    * @example
	    *
	    *     var added = x64Word.add(anotherX64Word);
	    */
				// add: function (word) {
				// var low = (this.low + word.low) | 0;
				// var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
				// var high = (this.high + word.high + carry) | 0;
	
				// return X64Word.create(high, low);
				// }
			});
	
			/**
	   * An array of 64-bit words.
	   *
	   * @property {Array} words The array of CryptoJS.x64.Word objects.
	   * @property {number} sigBytes The number of significant bytes in this word array.
	   */
			var X64WordArray = C_x64.WordArray = Base.extend({
				/**
	    * Initializes a newly created word array.
	    *
	    * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	    * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.x64.WordArray.create();
	    *
	    *     var wordArray = CryptoJS.x64.WordArray.create([
	    *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	    *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	    *     ]);
	    *
	    *     var wordArray = CryptoJS.x64.WordArray.create([
	    *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	    *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	    *     ], 10);
	    */
				init: function init(words, sigBytes) {
					words = this.words = words || [];
	
					if (sigBytes != undefined) {
						this.sigBytes = sigBytes;
					} else {
						this.sigBytes = words.length * 8;
					}
				},
	
				/**
	    * Converts this 64-bit word array to a 32-bit word array.
	    *
	    * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	    *
	    * @example
	    *
	    *     var x32WordArray = x64WordArray.toX32();
	    */
				toX32: function toX32() {
					// Shortcuts
					var x64Words = this.words;
					var x64WordsLength = x64Words.length;
	
					// Convert
					var x32Words = [];
					for (var i = 0; i < x64WordsLength; i++) {
						var x64Word = x64Words[i];
						x32Words.push(x64Word.high);
						x32Words.push(x64Word.low);
					}
	
					return X32WordArray.create(x32Words, this.sigBytes);
				},
	
				/**
	    * Creates a copy of this word array.
	    *
	    * @return {X64WordArray} The clone.
	    *
	    * @example
	    *
	    *     var clone = x64WordArray.clone();
	    */
				clone: function clone() {
					var clone = Base.clone.call(this);
	
					// Clone "words" array
					var words = clone.words = this.words.slice(0);
	
					// Clone each X64Word object
					var wordsLength = words.length;
					for (var i = 0; i < wordsLength; i++) {
						words[i] = words[i].clone();
					}
	
					return clone;
				}
			});
		})();
	
		return CryptoJS;
	});

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	module.exports = function(obj) {
	    if (typeof obj === 'string') return camelCase(obj);
	    return walk(obj);
	};
	
	function walk (obj) {
	    if (!obj || typeof obj !== 'object') return obj;
	    if (isDate(obj) || isRegex(obj)) return obj;
	    if (isArray(obj)) return map(obj, walk);
	    return reduce(objectKeys(obj), function (acc, key) {
	        var camel = camelCase(key);
	        acc[camel] = walk(obj[key]);
	        return acc;
	    }, {});
	}
	
	function camelCase(str) {
	    return str.replace(/[_.-](\w|$)/g, function (_,x) {
	        return x.toUpperCase();
	    });
	}
	
	var isArray = Array.isArray || function (obj) {
	    return Object.prototype.toString.call(obj) === '[object Array]';
	};
	
	var isDate = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object Date]';
	};
	
	var isRegex = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var has = Object.prototype.hasOwnProperty;
	var objectKeys = Object.keys || function (obj) {
	    var keys = [];
	    for (var key in obj) {
	        if (has.call(obj, key)) keys.push(key);
	    }
	    return keys;
	};
	
	function map (xs, f) {
	    if (xs.map) return xs.map(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        res.push(f(xs[i], i));
	    }
	    return res;
	}
	
	function reduce (xs, f, acc) {
	    if (xs.reduce) return xs.reduce(f, acc);
	    for (var i = 0; i < xs.length; i++) {
	        acc = f(acc, xs[i], i);
	    }
	    return acc;
	}


/***/ }),
/* 365 */
[6555, 241, 707, 268],
/* 366 */
[6592, 1402, 1399],
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(106)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(205)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 368 */
[6566, 451, 99, 204, 125, 95],
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * var result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _index = _interopRequireDefault(__webpack_require__(208));
	
	var _index2 = _interopRequireDefault(__webpack_require__(454));
	
	var _index3 = _interopRequireDefault(__webpack_require__(717));
	
	var _index4 = _interopRequireDefault(__webpack_require__(31));
	
	var _index5 = _interopRequireDefault(__webpack_require__(4716));
	
	var _index6 = _interopRequireDefault(__webpack_require__(2182));
	
	var _index7 = _interopRequireDefault(__webpack_require__(320));
	
	var _index8 = __webpack_require__(2186);
	
	var _index9 = _interopRequireDefault(__webpack_require__(53));
	
	var _index10 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | AM, PM                          | a..aaa  | AM, PM                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 05/29/1453                        | 7     |
	 * |                                 | PP      | May 29, 1453                      | 7     |
	 * |                                 | PPP     | May 29th, 1453                    | 7     |
	 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
	 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The second argument is now required for the sake of explicitness.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   format(new Date(2016, 0, 1))
	 *
	 *   // v2.0.0 onward
	 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
	 *   ```
	 *
	 * - New format string API for `format` function
	 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
	 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
	 *
	 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  (0, _index10.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index2.default;
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  var originalDate = (0, _index4.default)(dirtyDate);
	
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index7.default)(originalDate);
	  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index6.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, formatterOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index5.default[firstCharacter];
	
	    if (formatter) {
	      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
	      }
	
	      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
	      }
	
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 371 */
[6689, 31, 53, 20],
/* 372 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	module.exports = exports["default"];

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_73a6315d","outerContainer":"_0aa6df90","secondaryToolbar":"b7cbc519","doorHangerRight":"_9a274bf5","toolbarContainer":"a83246de","toolbarViewerMiddle":"_0db2965c","progressBar":"_568ec3c4","back-to-application":"_4026209e","root":"b5c19a44","content":"b4287567","wrapper":"a30f2a4a","form":"_4dcf9f0d","form--wide":"a9b3bf92","form--squeeze":"_122d9e5e","formWrapper":"f35db844","withPadding":"e77b5dc4","formTitle":"_5ef22938","formStep":"_8de58c6e","formText":"_55416da5","formContent":"a3ea3ab2","formDescription":"_538cf58b","formHeading":"_12dbad21","links":"_4de7be6a","hidden":"aa878d6b","link":"_34fc9fb3","acceptBtn":"_603d1cd5","cancelBtn":"f13e0622","errorMsg":"_8a5478e6","actionBlock":"c5eb32c0","poweredText":"_4ee38209","btnBack":"e04ac180","appBtn":"_97c0d551","recoverLink":"f6f27544","signupLink":"_92ff41d4","forgotPassBtn":"_04fd35e9","loginAzureWrapper":"be2bdb63","dividerOr":"_3f691960","microsoftLogo":"_208b5de7","microsoftButton":"_98bae8e8","signUpAzureWrapper":"_71f6dc00","signUpAzureDescription":"d0783d24","signUpAzureProceed":"_34e6fd4d","poweredByHealthfully":"_5fedcf2e","popoverInfo":"_5e814477"};

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_35582a52","outerContainer":"_053a0447","secondaryToolbar":"_7f2dd4f3","doorHangerRight":"_70ef86e9","toolbarContainer":"_38940fa5","toolbarViewerMiddle":"_57457981","progressBar":"_37bfaac6","back-to-application":"_80992cd5","root":"_637e75c5","wrapper":"f7a4a3f3","empty-state":"_5ced6c40","listWrapper":"_3fb69bb2"};

/***/ }),
/* 375 */,
/* 376 */,
/* 377 */
[6738, 1534, 5443],
/* 378 */
/***/ (function(module, exports) {

	/**
	 * Gets the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias first
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the first element of `array`.
	 * @example
	 *
	 * _.head([1, 2, 3]);
	 * // => 1
	 *
	 * _.head([]);
	 * // => undefined
	 */
	function head(array) {
	  return (array && array.length) ? array[0] : undefined;
	}
	
	module.exports = head;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(2319),
	    createAssigner = __webpack_require__(2329);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(1540);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _isNan = __webpack_require__(1396);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
	// to learn the context in which each easing should be used.
	var easing = exports.easing = {
	  // This is the most common easing curve.
	  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	  // Objects enter the screen at full velocity from off-screen and
	  // slowly decelerate to a resting point.
	  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
	  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
	  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	  // The sharp curve is used by objects that may return to the screen at any time.
	  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
	};
	
	// Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
	// to learn when use what timing
	
	/* eslint-disable no-param-reassign */
	
	var duration = exports.duration = {
	  shortest: 150,
	  shorter: 200,
	  short: 250,
	  // most basic recommended timing
	  standard: 300,
	  // this is to be used in complex animations
	  complex: 375,
	  // recommended when something is entering screen
	  enteringScreen: 225,
	  // recommended when something is leaving screen
	  leavingScreen: 195
	};
	
	var formatMs = exports.formatMs = function formatMs(milliseconds) {
	  return Math.round(milliseconds) + 'ms';
	};
	var isString = exports.isString = function isString(value) {
	  return typeof value === 'string';
	};
	var isNumber = exports.isNumber = function isNumber(value) {
	  return !(0, _isNan2.default)(parseFloat(value));
	};
	
	/**
	 * @param {string|Array} props
	 * @param {object} param
	 * @param {string} param.prop
	 * @param {number} param.duration
	 * @param {string} param.easing
	 * @param {number} param.delay
	 */
	exports.default = {
	  easing: easing,
	  duration: duration,
	  create: function create() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$duration = options.duration,
	        durationOption = _options$duration === undefined ? duration.standard : _options$duration,
	        _options$easing = options.easing,
	        easingOption = _options$easing === undefined ? easing.easeInOut : _options$easing,
	        _options$delay = options.delay,
	        delay = _options$delay === undefined ? 0 : _options$delay,
	        other = (0, _objectWithoutProperties3.default)(options, ['duration', 'easing', 'delay']);
	
	
	     false ? (0, _warning2.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
	     false ? (0, _warning2.default)(isNumber(durationOption) || isString(durationOption), 'Material-UI: argument "duration" must be a number or a string but found ' + durationOption + '.') : void 0;
	     false ? (0, _warning2.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
	     false ? (0, _warning2.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a string or a string.') : void 0;
	     false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0, 'Material-UI: unrecognized argument(s) [' + (0, _keys2.default)(other).join(',') + ']') : void 0;
	
	    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
	      return animatedProp + ' ' + (typeof durationOption === 'string' ? durationOption : formatMs(durationOption)) + ' ' + easingOption + ' ' + (typeof delay === 'string' ? delay : formatMs(delay));
	    }).join(',');
	  },
	  getAutoHeightDuration: function getAutoHeightDuration(height) {
	    if (!height) {
	      return 0;
	    }
	
	    var constant = height / 36;
	
	    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
	    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
	  }
	};

/***/ }),
/* 382 */
[6836, 5935],
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var hoistNonReactStatics_ = __webpack_require__(6225);
	// Since rollup cannot deal with namespace being a function,
	// this is to interop with TypeScript since `invariant`
	// does not export a default
	// https://github.com/rollup/rollup/issues/1267
	var hoistNonReactStatics = hoistNonReactStatics_.default || hoistNonReactStatics_;
	var utils_1 = __webpack_require__(180);
	function getDisplayName(Component) {
	    return Component.displayName || Component.name || 'Component';
	}
	// TODO: We should provide initial value here
	var IntlContext = React.createContext(null);
	var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
	exports.Provider = IntlProvider;
	exports.Context = IntlContext;
	function injectIntl(WrappedComponent, options) {
	    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
	    var WithIntl = function (props) { return (React.createElement(IntlConsumer, null, function (intl) {
	        var _a;
	        if (enforceContext) {
	            utils_1.invariantIntlContext(intl);
	        }
	        return (React.createElement(WrappedComponent, __assign({}, props, (_a = {},
	            _a[intlPropName] = intl,
	            _a), { ref: forwardRef ? props.forwardedRef : null })));
	    })); };
	    WithIntl.displayName = "injectIntl(" + getDisplayName(WrappedComponent) + ")";
	    WithIntl.WrappedComponent = WrappedComponent;
	    if (forwardRef) {
	        return hoistNonReactStatics(React.forwardRef(function (props, ref) { return (React.createElement(WithIntl, __assign({}, props, { forwardedRef: ref }))); }), WrappedComponent);
	    }
	    return hoistNonReactStatics(WithIntl, WrappedComponent);
	}
	exports.default = injectIntl;


/***/ }),
/* 384 */,
/* 385 */,
/* 386 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an Span. */
	// eslint-disable-next-line import/export
	var SpanStatus;
	(function (SpanStatus) {
	    /** The operation completed successfully. */
	    SpanStatus["Ok"] = "ok";
	    /** Deadline expired before operation could complete. */
	    SpanStatus["DeadlineExceeded"] = "deadline_exceeded";
	    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
	    SpanStatus["Unauthenticated"] = "unauthenticated";
	    /** 403 Forbidden */
	    SpanStatus["PermissionDenied"] = "permission_denied";
	    /** 404 Not Found. Some requested entity (file or directory) was not found. */
	    SpanStatus["NotFound"] = "not_found";
	    /** 429 Too Many Requests */
	    SpanStatus["ResourceExhausted"] = "resource_exhausted";
	    /** Client specified an invalid argument. 4xx. */
	    SpanStatus["InvalidArgument"] = "invalid_argument";
	    /** 501 Not Implemented */
	    SpanStatus["Unimplemented"] = "unimplemented";
	    /** 503 Service Unavailable */
	    SpanStatus["Unavailable"] = "unavailable";
	    /** Other/generic 5xx. */
	    SpanStatus["InternalError"] = "internal_error";
	    /** Unknown. Any non-standard HTTP status code. */
	    SpanStatus["UnknownError"] = "unknown_error";
	    /** The operation was cancelled (typically by the user). */
	    SpanStatus["Cancelled"] = "cancelled";
	    /** Already exists (409) */
	    SpanStatus["AlreadyExists"] = "already_exists";
	    /** Operation was rejected because the system is not in a state required for the operation's */
	    SpanStatus["FailedPrecondition"] = "failed_precondition";
	    /** The operation was aborted, typically due to a concurrency issue. */
	    SpanStatus["Aborted"] = "aborted";
	    /** Operation was attempted past the valid range. */
	    SpanStatus["OutOfRange"] = "out_of_range";
	    /** Unrecoverable data loss or corruption */
	    SpanStatus["DataLoss"] = "data_loss";
	})(SpanStatus = exports.SpanStatus || (exports.SpanStatus = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (SpanStatus) {
	    /**
	     * Converts a HTTP status code into a {@link SpanStatus}.
	     *
	     * @param httpStatus The HTTP response status code.
	     * @returns The span status or {@link SpanStatus.UnknownError}.
	     */
	    function fromHttpCode(httpStatus) {
	        if (httpStatus < 400 && httpStatus >= 100) {
	            return SpanStatus.Ok;
	        }
	        if (httpStatus >= 400 && httpStatus < 500) {
	            switch (httpStatus) {
	                case 401:
	                    return SpanStatus.Unauthenticated;
	                case 403:
	                    return SpanStatus.PermissionDenied;
	                case 404:
	                    return SpanStatus.NotFound;
	                case 409:
	                    return SpanStatus.AlreadyExists;
	                case 413:
	                    return SpanStatus.FailedPrecondition;
	                case 429:
	                    return SpanStatus.ResourceExhausted;
	                default:
	                    return SpanStatus.InvalidArgument;
	            }
	        }
	        if (httpStatus >= 500 && httpStatus < 600) {
	            switch (httpStatus) {
	                case 501:
	                    return SpanStatus.Unimplemented;
	                case 503:
	                    return SpanStatus.Unavailable;
	                case 504:
	                    return SpanStatus.DeadlineExceeded;
	                default:
	                    return SpanStatus.InternalError;
	            }
	        }
	        return SpanStatus.UnknownError;
	    }
	    SpanStatus.fromHttpCode = fromHttpCode;
	})(SpanStatus = exports.SpanStatus || (exports.SpanStatus = {}));
	//# sourceMappingURL=spanstatus.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(284);
	exports.TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
	    '([0-9a-f]{32})?' + // trace_id
	    '-?([0-9a-f]{16})?' + // span_id
	    '-?([01])?' + // sampled
	    '[ \\t]*$');
	/**
	 * Determines if tracing is currently enabled.
	 *
	 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
	 */
	function hasTracingEnabled(options) {
	    if (options === void 0) { options = (_a = hub_1.getCurrentHub()
	        .getClient()) === null || _a === void 0 ? void 0 : _a.getOptions(); }
	    var _a;
	    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
	}
	exports.hasTracingEnabled = hasTracingEnabled;
	/**
	 * Extract transaction context data from a `sentry-trace` header.
	 *
	 * @param traceparent Traceparent string
	 *
	 * @returns Object containing data from the header, or undefined if traceparent string is malformed
	 */
	function extractTraceparentData(traceparent) {
	    var matches = traceparent.match(exports.TRACEPARENT_REGEXP);
	    if (matches) {
	        var parentSampled = void 0;
	        if (matches[3] === '1') {
	            parentSampled = true;
	        }
	        else if (matches[3] === '0') {
	            parentSampled = false;
	        }
	        return {
	            traceId: matches[1],
	            parentSampled: parentSampled,
	            parentSpanId: matches[2],
	        };
	    }
	    return undefined;
	}
	exports.extractTraceparentData = extractTraceparentData;
	/** Grabs active transaction off scope, if any */
	function getActiveTransaction(hub) {
	    if (hub === void 0) { hub = hub_1.getCurrentHub(); }
	    var _a, _b;
	    return (_b = (_a = hub) === null || _a === void 0 ? void 0 : _a.getScope()) === null || _b === void 0 ? void 0 : _b.getTransaction();
	}
	exports.getActiveTransaction = getActiveTransaction;
	/**
	 * Converts from milliseconds to seconds
	 * @param time time in ms
	 */
	function msToSec(time) {
	    return time / 1000;
	}
	exports.msToSec = msToSec;
	/**
	 * Converts from seconds to milliseconds
	 * @param time time in seconds
	 */
	function secToMs(time) {
	    return time * 1000;
	}
	exports.secToMs = secToMs;
	// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils
	var utils_1 = __webpack_require__(65);
	exports.stripUrlQueryAndFragment = utils_1.stripUrlQueryAndFragment;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
	 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var node_1 = __webpack_require__(1080);
	var fallbackGlobalObject = {};
	/**
	 * Safely get global scope object
	 *
	 * @returns Global scope object
	 */
	function getGlobalObject() {
	    return (node_1.isNodeEnv()
	        ? global
	        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
	            ? window // eslint-disable-line no-restricted-globals
	            : typeof self !== 'undefined'
	                ? self
	                : fallbackGlobalObject);
	}
	exports.getGlobalObject = getGlobalObject;
	//# sourceMappingURL=global.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2974);


/***/ }),
/* 390 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Match = void 0;
	/**
	 * @abstract
	 * @class Autolinker.match.Match
	 *
	 * Represents a match found in an input string which should be Autolinked. A Match object is what is provided in a
	 * {@link Autolinker#replaceFn replaceFn}, and may be used to query for details about the match.
	 *
	 * For example:
	 *
	 *     var input = "...";  // string with URLs, Email Addresses, and Mentions (Twitter, Instagram, Soundcloud)
	 *
	 *     var linkedText = Autolinker.link( input, {
	 *         replaceFn : function( match ) {
	 *             console.log( "href = ", match.getAnchorHref() );
	 *             console.log( "text = ", match.getAnchorText() );
	 *
	 *             switch( match.getType() ) {
	 *                 case 'url' :
	 *                     console.log( "url: ", match.getUrl() );
	 *
	 *                 case 'email' :
	 *                     console.log( "email: ", match.getEmail() );
	 *
	 *                 case 'mention' :
	 *                     console.log( "mention: ", match.getMention() );
	 *             }
	 *         }
	 *     } );
	 *
	 * See the {@link Autolinker} class for more details on using the {@link Autolinker#replaceFn replaceFn}.
	 */
	var Match = /** @class */ (function () {
	    /**
	     * @member Autolinker.match.Match
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Match
	     *   instance, specified in an Object (map).
	     */
	    function Match(cfg) {
	        /**
	         * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	         *
	         * Reference to the AnchorTagBuilder instance to use to generate an anchor
	         * tag for the Match.
	         */
	        // @ts-ignore
	        this.__jsduckDummyDocProp = null; // property used just to get the above doc comment into the ES5 output and documentation generator
	        /**
	         * @cfg {String} matchedText (required)
	         *
	         * The original text that was matched by the {@link Autolinker.matcher.Matcher}.
	         */
	        this.matchedText = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Number} offset (required)
	         *
	         * The offset of where the match was made in the input string.
	         */
	        this.offset = 0; // default value just to get the above doc comment in the ES5 output and documentation generator
	        this.tagBuilder = cfg.tagBuilder;
	        this.matchedText = cfg.matchedText;
	        this.offset = cfg.offset;
	    }
	    /**
	     * Returns the original text that was matched.
	     *
	     * @return {String}
	     */
	    Match.prototype.getMatchedText = function () {
	        return this.matchedText;
	    };
	    /**
	     * Sets the {@link #offset} of where the match was made in the input string.
	     *
	     * A {@link Autolinker.matcher.Matcher} will be fed only HTML text nodes,
	     * and will therefore set an original offset that is relative to the HTML
	     * text node itself. However, we want this offset to be relative to the full
	     * HTML input string, and thus if using {@link Autolinker#parse} (rather
	     * than calling a {@link Autolinker.matcher.Matcher} directly), then this
	     * offset is corrected after the Matcher itself has done its job.
	     *
	     * @param {Number} offset
	     */
	    Match.prototype.setOffset = function (offset) {
	        this.offset = offset;
	    };
	    /**
	     * Returns the offset of where the match was made in the input string. This
	     * is the 0-based index of the match.
	     *
	     * @return {Number}
	     */
	    Match.prototype.getOffset = function () {
	        return this.offset;
	    };
	    /**
	     * Returns the CSS class suffix(es) for this match.
	     *
	     * A CSS class suffix is appended to the {@link Autolinker#className} in
	     * the {@link Autolinker.AnchorTagBuilder} when a match is translated into
	     * an anchor tag.
	     *
	     * For example, if {@link Autolinker#className} was configured as 'myLink',
	     * and this method returns `[ 'url' ]`, the final class name of the element
	     * will become: 'myLink myLink-url'.
	     *
	     * The match may provide multiple CSS class suffixes to be appended to the
	     * {@link Autolinker#className} in order to facilitate better styling
	     * options for different match criteria. See {@link Autolinker.match.Mention}
	     * for an example.
	     *
	     * By default, this method returns a single array with the match's
	     * {@link #getType type} name, but may be overridden by subclasses.
	     *
	     * @return {String[]}
	     */
	    Match.prototype.getCssClassSuffixes = function () {
	        return [this.getType()];
	    };
	    /**
	     * Builds and returns an {@link Autolinker.HtmlTag} instance based on the
	     * Match.
	     *
	     * This can be used to easily generate anchor tags from matches, and either
	     * return their HTML string, or modify them before doing so.
	     *
	     * Example Usage:
	     *
	     *     var tag = match.buildTag();
	     *     tag.addClass( 'cordova-link' );
	     *     tag.setAttr( 'target', '_system' );
	     *
	     *     tag.toAnchorString();  // <a href="http://google.com" class="cordova-link" target="_system">Google</a>
	     *
	     * Example Usage in {@link Autolinker#replaceFn}:
	     *
	     *     var html = Autolinker.link( "Test google.com", {
	     *         replaceFn : function( match ) {
	     *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance
	     *             tag.setAttr( 'rel', 'nofollow' );
	     *
	     *             return tag;
	     *         }
	     *     } );
	     *
	     *     // generated html:
	     *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	     */
	    Match.prototype.buildTag = function () {
	        return this.tagBuilder.build(this);
	    };
	    return Match;
	}());
	exports.Match = Match;
	//# sourceMappingURL=match.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Matcher = void 0;
	/**
	 * @abstract
	 * @class Autolinker.matcher.Matcher
	 *
	 * An abstract class and interface for individual matchers to find matches in
	 * an input string with linkified versions of them.
	 *
	 * Note that Matchers do not take HTML into account - they must be fed the text
	 * nodes of any HTML string, which is handled by {@link Autolinker#parse}.
	 */
	var Matcher = /** @class */ (function () {
	    /**
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Matcher
	     *   instance, specified in an Object (map).
	     */
	    function Matcher(cfg) {
	        /**
	         * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	         *
	         * Reference to the AnchorTagBuilder instance to use to generate HTML tags
	         * for {@link Autolinker.match.Match Matches}.
	         */
	        // @ts-ignore
	        this.__jsduckDummyDocProp = null; // property used just to get the above doc comment into the ES5 output and documentation generator
	        this.tagBuilder = cfg.tagBuilder;
	    }
	    return Matcher;
	}());
	exports.Matcher = Matcher;
	//# sourceMappingURL=matcher.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	"use strict";
	/*
	 * This file builds and stores a library of the common regular expressions used
	 * by the Autolinker utility.
	 *
	 * Other regular expressions may exist ad-hoc, but these are generally the
	 * regular expressions that are shared between source files.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.domainNameCharRegex = exports.domainNameRegex = exports.getDomainNameStr = exports.alphaNumericAndMarksCharRe = exports.alphaNumericAndMarksCharsStr = exports.alphaNumericCharsStr = exports.decimalNumbersStr = exports.alphaCharsAndMarksStr = exports.marksStr = exports.emojiStr = exports.alphaCharsStr = exports.controlCharsRe = exports.quoteRe = exports.whitespaceRe = exports.nonDigitRe = exports.digitRe = exports.letterRe = void 0;
	/**
	 * Regular expression to match upper and lowercase ASCII letters
	 */
	exports.letterRe = /[A-Za-z]/;
	/**
	 * Regular expression to match ASCII digits
	 */
	exports.digitRe = /[\d]/;
	/**
	 * Regular expression to match everything *except* ASCII digits
	 */
	exports.nonDigitRe = /[\D]/;
	/**
	 * Regular expression to match whitespace
	 */
	exports.whitespaceRe = /\s/;
	/**
	 * Regular expression to match quote characters
	 */
	exports.quoteRe = /['"]/;
	/**
	 * Regular expression to match the range of ASCII control characters (0-31), and
	 * the backspace char (127)
	 */
	exports.controlCharsRe = /[\x00-\x1F\x7F]/;
	/**
	 * The string form of a regular expression that would match all of the
	 * alphabetic ("letter") chars in the unicode character set when placed in a
	 * RegExp character class (`[]`). This includes all international alphabetic
	 * characters.
	 *
	 * These would be the characters matched by unicode regex engines `\p{L}`
	 * escape ("all letters").
	 *
	 * Taken from the XRegExp library: http://xregexp.com/ (thanks @https://github.com/slevithan)
	 * Specifically: http://xregexp.com/v/3.2.0/xregexp-all.js, the 'Letter'
	 *   regex's bmp
	 *
	 * VERY IMPORTANT: This set of characters is defined inside of a Regular
	 *   Expression literal rather than a string literal to prevent UglifyJS from
	 *   compressing the unicode escape sequences into their actual unicode
	 *   characters. If Uglify compresses these into the unicode characters
	 *   themselves, this results in the error "Range out of order in character
	 *   class" when these characters are used inside of a Regular Expression
	 *   character class (`[]`). See usages of this const. Alternatively, we can set
	 *   the UglifyJS option `ascii_only` to true for the build, but that doesn't
	 *   help others who are pulling in Autolinker into their own build and running
	 *   UglifyJS themselves.
	 */
	// prettier-ignore
	exports.alphaCharsStr = /A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC/
	    .source; // see note in above variable description
	/**
	 * The string form of a regular expression that would match all emoji characters
	 * Based on the emoji regex defined in this article: https://thekevinscott.com/emojis-in-javascript/
	 */
	exports.emojiStr = /\u2700-\u27bf\udde6-\uddff\ud800-\udbff\udc00-\udfff\ufe0e\ufe0f\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0\ud83c\udffb-\udfff\u200d\u3299\u3297\u303d\u3030\u24c2\ud83c\udd70-\udd71\udd7e-\udd7f\udd8e\udd91-\udd9a\udde6-\uddff\ude01-\ude02\ude1a\ude2f\ude32-\ude3a\ude50-\ude51\u203c\u2049\u25aa-\u25ab\u25b6\u25c0\u25fb-\u25fe\u00a9\u00ae\u2122\u2139\udc04\u2600-\u26FF\u2b05\u2b06\u2b07\u2b1b\u2b1c\u2b50\u2b55\u231a\u231b\u2328\u23cf\u23e9-\u23f3\u23f8-\u23fa\udccf\u2935\u2934\u2190-\u21ff/
	    .source;
	/**
	 * The string form of a regular expression that would match all of the
	 * combining mark characters in the unicode character set when placed in a
	 * RegExp character class (`[]`).
	 *
	 * These would be the characters matched by unicode regex engines `\p{M}`
	 * escape ("all marks").
	 *
	 * Taken from the XRegExp library: http://xregexp.com/ (thanks @https://github.com/slevithan)
	 * Specifically: http://xregexp.com/v/3.2.0/xregexp-all.js, the 'Mark'
	 *   regex's bmp
	 *
	 * VERY IMPORTANT: This set of characters is defined inside of a Regular
	 *   Expression literal rather than a string literal to prevent UglifyJS from
	 *   compressing the unicode escape sequences into their actual unicode
	 *   characters. If Uglify compresses these into the unicode characters
	 *   themselves, this results in the error "Range out of order in character
	 *   class" when these characters are used inside of a Regular Expression
	 *   character class (`[]`). See usages of this const. Alternatively, we can set
	 *   the UglifyJS option `ascii_only` to true for the build, but that doesn't
	 *   help others who are pulling in Autolinker into their own build and running
	 *   UglifyJS themselves.
	 */
	// prettier-ignore
	exports.marksStr = /\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F/
	    .source; // see note in above variable description
	/**
	 * The string form of a regular expression that would match all of the
	 * alphabetic ("letter") chars, emoji, and combining marks in the unicode character set
	 * when placed in a RegExp character class (`[]`). This includes all
	 * international alphabetic characters.
	 *
	 * These would be the characters matched by unicode regex engines `\p{L}\p{M}`
	 * escapes and emoji characters.
	 */
	exports.alphaCharsAndMarksStr = exports.alphaCharsStr + exports.emojiStr + exports.marksStr;
	/**
	 * The string form of a regular expression that would match all of the
	 * decimal number chars in the unicode character set when placed in a RegExp
	 * character class (`[]`).
	 *
	 * These would be the characters matched by unicode regex engines `\p{Nd}`
	 * escape ("all decimal numbers")
	 *
	 * Taken from the XRegExp library: http://xregexp.com/ (thanks @https://github.com/slevithan)
	 * Specifically: http://xregexp.com/v/3.2.0/xregexp-all.js, the 'Decimal_Number'
	 *   regex's bmp
	 *
	 * VERY IMPORTANT: This set of characters is defined inside of a Regular
	 *   Expression literal rather than a string literal to prevent UglifyJS from
	 *   compressing the unicode escape sequences into their actual unicode
	 *   characters. If Uglify compresses these into the unicode characters
	 *   themselves, this results in the error "Range out of order in character
	 *   class" when these characters are used inside of a Regular Expression
	 *   character class (`[]`). See usages of this const. Alternatively, we can set
	 *   the UglifyJS option `ascii_only` to true for the build, but that doesn't
	 *   help others who are pulling in Autolinker into their own build and running
	 *   UglifyJS themselves.
	 */
	// prettier-ignore
	exports.decimalNumbersStr = /0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19/
	    .source; // see note in above variable description
	/**
	 * The string form of a regular expression that would match all of the
	 * letters and decimal number chars in the unicode character set when placed in
	 * a RegExp character class (`[]`).
	 *
	 * These would be the characters matched by unicode regex engines
	 * `[\p{L}\p{Nd}]` escape ("all letters and decimal numbers")
	 */
	exports.alphaNumericCharsStr = exports.alphaCharsAndMarksStr + exports.decimalNumbersStr;
	/**
	 * The string form of a regular expression that would match all of the
	 * letters, combining marks, and decimal number chars in the unicode character
	 * set when placed in a RegExp character class (`[]`).
	 *
	 * These would be the characters matched by unicode regex engines
	 * `[\p{L}\p{M}\p{Nd}]` escape ("all letters, combining marks, and decimal
	 * numbers")
	 */
	exports.alphaNumericAndMarksCharsStr = exports.alphaCharsAndMarksStr + exports.decimalNumbersStr;
	/**
	 * The regular expression that will match a single letter of the
	 * {@link #alphaNumericAndMarksCharsStr}.
	 */
	exports.alphaNumericAndMarksCharRe = new RegExp("[".concat(exports.alphaNumericAndMarksCharsStr, "]"));
	// Simplified IP regular expression
	var ipStr = '(?:[' + exports.decimalNumbersStr + ']{1,3}\\.){3}[' + exports.decimalNumbersStr + ']{1,3}';
	// Protected domain label which do not allow "-" or "_" character on the beginning and the end of a single label
	// prettier-ignore
	var domainLabelStr = '[' + exports.alphaNumericAndMarksCharsStr + '](?:[' + exports.alphaNumericAndMarksCharsStr + '\\-_]{0,61}[' + exports.alphaNumericAndMarksCharsStr + '])?';
	var getDomainLabelStr = function (group) {
	    return '(?=(' + domainLabelStr + '))\\' + group;
	};
	/**
	 * A function to match domain names of a URL or email address.
	 * Ex: 'google', 'yahoo', 'some-other-company', etc.
	 */
	// prettier-ignore
	var getDomainNameStr = function (group) {
	    return '(?:' + getDomainLabelStr(group) + '(?:\\.' + getDomainLabelStr(group + 1) + '){0,126}|' + ipStr + ')';
	};
	exports.getDomainNameStr = getDomainNameStr;
	/**
	 * A regular expression to match domain names of a URL or email address.
	 * Ex: 'google', 'yahoo', 'some-other-company', etc.
	 */
	exports.domainNameRegex = new RegExp('[' + exports.alphaNumericAndMarksCharsStr + '.\\-]*[' + exports.alphaNumericAndMarksCharsStr + '\\-]');
	/**
	 * A regular expression that is simply the character class of the characters
	 * that may be used in a domain name, minus the '-' or '.'
	 */
	exports.domainNameCharRegex = exports.alphaNumericAndMarksCharRe;
	//# sourceMappingURL=regex-lib.js.map

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(16);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _brandConfig = __webpack_require__(142);
	
	var _index3 = __webpack_require__(2241);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var EditBtn = function EditBtn(_ref) {
	  var type = _ref.type,
	      accent = _ref.accent,
	      className = _ref.className,
	      onClick = _ref.onClick,
	      disabled = _ref.disabled;
	
	  var color = accent && 'primary';
	  var flaglerColor = accent && 'flaglerPrimary';
	  var fill = accent ? _styles.COLORS.white : _styles.COLORS.sectionTitleFont;
	  var currentColor = _brandConfig.isFlagler ? flaglerColor : color;
	
	  return _react2.default.createElement(
	    _index2.default,
	    (0, _extends3.default)({
	      icon: true,
	      type: type,
	      disabled: disabled
	    }, { className: className, color: currentColor, onClick: onClick }),
	    _react2.default.createElement(_Icon2.default, { name: 'edit', style: { fill: fill } })
	  );
	};
	
	EditBtn.defaultProps = {
	  type: 'button'
	};
	
	EditBtn.propTypes = {
	  accent: _propTypes2.default.bool,
	  type: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(EditBtn, _index4.default, { allowMultiple: true });

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(956);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ControlsItem = function ControlsItem(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      fixed = _ref.fixed,
	      style = _ref.style;
	  return _react2.default.createElement('div', (0, _extends3.default)({ children: children, className: className, style: style }, {
	    styleName: (0, _classnames2.default)('controls--item', {
	      'controls--item--fixed': fixed
	    })
	  }));
	}; /* eslint-disable react/require-default-props */
	
	
	ControlsItem.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]),
	  className: _propTypes2.default.string,
	  fixed: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	};
	
	exports.default = (0, _reactCssModules2.default)(ControlsItem, _index2.default, { allowMultiple: true });

/***/ }),
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.APPOINTMENT_COLORS = exports.COLOR_LIST = exports.COLOR_MAP = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _BORDER_COLOR_MAP;
	
	exports.getBorderAreaColor = getBorderAreaColor;
	exports.getRGBA = getRGBA;
	exports.getBackgroundAreaStyle = getBackgroundAreaStyle;
	exports.getAppointmentColor = getAppointmentColor;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COLOR_MAP = exports.COLOR_MAP = {
	  PATTENS_BLUE: '#ddf6ff',
	  TITAN_WHITE: '#e9e6ff',
	  CHIFFON: '#e1ffbd',
	  SHALIMAR: '#fffebf',
	  PEACH: '#ffe9b2',
	  SILVER: '#afafaf'
	};
	
	var BORDER_COLOR_MAP = (_BORDER_COLOR_MAP = {}, (0, _defineProperty3.default)(_BORDER_COLOR_MAP, COLOR_MAP.PATTENS_BLUE, '#1eb7eb'), (0, _defineProperty3.default)(_BORDER_COLOR_MAP, COLOR_MAP.TITAN_WHITE, '#8e88d3'), (0, _defineProperty3.default)(_BORDER_COLOR_MAP, COLOR_MAP.CHIFFON, '#95ca56'), (0, _defineProperty3.default)(_BORDER_COLOR_MAP, COLOR_MAP.SHALIMAR, '#f2ef42'), (0, _defineProperty3.default)(_BORDER_COLOR_MAP, COLOR_MAP.PEACH, '#f8cc5f'), (0, _defineProperty3.default)(_BORDER_COLOR_MAP, COLOR_MAP.SILVER, '#afafaf'), _BORDER_COLOR_MAP);
	
	var COLOR_LIST = exports.COLOR_LIST = [COLOR_MAP.PATTENS_BLUE, COLOR_MAP.TITAN_WHITE, COLOR_MAP.CHIFFON, COLOR_MAP.SHALIMAR, COLOR_MAP.PEACH];
	
	function getBorderAreaColor(targetColor) {
	  return BORDER_COLOR_MAP[targetColor] || '#1eb7eb';
	}
	
	function hexToRgb(hex) {
	  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	  return result ? {
	    r: parseInt(result[1], 16),
	    g: parseInt(result[2], 16),
	    b: parseInt(result[3], 16)
	  } : null;
	}
	
	function getRGBA(hexColor, opacity) {
	  var rgb = hexToRgb(hexColor);
	
	  if (!rgb) return null;
	
	  return 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + opacity + ')';
	}
	
	function getBackgroundAreaStyle(targetColor) {
	  var color = BORDER_COLOR_MAP[targetColor];
	  if (!color) return {};
	
	  var rgb = hexToRgb(color);
	
	  if (!rgb) return {};
	
	  return { background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 0.1)' };
	}
	
	var APPOINTMENT_COLORS = exports.APPOINTMENT_COLORS = {
	  VIRTUAL: '#afecff',
	  OFFICE: '#93edce',
	  PENDING: '#ffd4cd',
	  BLOCKED: '#eeeeee'
	};
	
	function getAppointmentColor(appointment) {
	  var type = (0, _get2.default)(appointment, 'visitType.code');
	  var status = (0, _get2.default)(appointment, 'status.coreAppName');
	
	  if (status === 'Pending') {
	    return APPOINTMENT_COLORS.PENDING;
	  }
	
	  switch (type) {
	    case _constants.OFFICE_VISIT_TYPE_CODE:
	      return APPOINTMENT_COLORS.OFFICE;
	    case _constants.VIRTUAL_VISIT_TYPE_CODE:
	      return APPOINTMENT_COLORS.VIRTUAL;
	    default:
	      return 'lightgrey';
	  }
	}

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Popover = __webpack_require__(250);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Menu = __webpack_require__(790);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _index = __webpack_require__(5216);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopoverMenu = function PopoverMenu(_ref) {
	  var onClose = _ref.onClose,
	      isOpen = _ref.isOpen,
	      anchorEl = _ref.anchorEl,
	      items = _ref.items,
	      size = _ref.size,
	      style = _ref.style,
	      transformOrigin = _ref.transformOrigin,
	      anchorOrigin = _ref.anchorOrigin,
	      container = _ref.container;
	  return _react2.default.createElement(
	    _Popover2.default,
	    (0, _extends3.default)({
	      className: 'popover',
	      open: isOpen,
	      anchorEl: anchorEl,
	      anchorOrigin: anchorOrigin,
	      transformOrigin: transformOrigin,
	      container: container
	    }, { style: style }, { onClose: onClose }),
	    _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('menu', 'menu--' + size) },
	      _react2.default.createElement(_Menu2.default, { items: items })
	    )
	  );
	}; /* eslint-disable react/require-default-props,react/prop-types */
	
	
	PopoverMenu.propTypes = {
	  onClose: _propTypes2.default.func,
	  isOpen: _propTypes2.default.bool,
	  items: _propTypes2.default.array,
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  transformOrigin: _propTypes2.default.object,
	  anchorOrigin: _propTypes2.default.object
	};
	
	PopoverMenu.defaultProps = {
	  transformOrigin: { vertical: 'top', horizontal: 'right' },
	  anchorOrigin: { horizontal: 'center', vertical: 'bottom' }
	};
	
	exports.default = (0, _reactCssModules2.default)(PopoverMenu, _index2.default, { allowMultiple: true });

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimeShow = exports.TimeShowIml = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dateConverters = __webpack_require__(83);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(5240);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeShowIml = exports.TimeShowIml = function TimeShowIml(_ref) {
	  var timestamp = _ref.timestamp,
	      hideIcon = _ref.hideIcon;
	
	  var timeText = (0, _react.useMemo)(function () {
	    var adapted = (0, _dateConverters.adaptDateToLocalTimezone)(timestamp);
	    var time = (0, _moment2.default)(adapted);
	
	    var getFormat = function getFormat() {
	      if (time.isSame(new Date(), 'day')) {
	        return 'hh:mm a';
	      }
	      if (time.isSame(new Date(), 'week')) {
	        return 'hh:mm a dddd';
	      }
	      if (time.isSame(new Date(), 'year')) {
	        return 'MMM D, hh:mm A';
	      }
	      return 'MMM D Y, hh:mm A';
	    };
	
	    return time.format(getFormat());
	  }, [timestamp]);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    !hideIcon ? _react2.default.createElement(_Icon2.default, { name: 'icon-time-status', size: 12 }) : null,
	    _react2.default.createElement(
	      'span',
	      { styleName: 'text' },
	      timeText
	    )
	  );
	};
	
	var TimeShow = exports.TimeShow = (0, _recompose.compose)((0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }))(TimeShowIml);
	
	var propTypes = {
	  timestamp: _propTypes2.default.string.isRequired,
	  hideIcon: _propTypes2.default.bool
	};
	
	TimeShowIml.propTypes = propTypes;
	TimeShow.propTypes = propTypes;

/***/ }),
/* 400 */,
/* 401 */,
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reducer = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'login', ['UPDATE_PASSWORD']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users/sessions'
	});
	
	var reducer = exports.reducer = (0, _redux.createReqReducer)(consts);
	exports.default = (0, _redux.locationReducer)(reducer);

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectUsernameAvailabilityError = exports.selectSignUpAzureFlow = exports.selectIsSignupFormDataEmpty = exports.selectSignupPersonalInfoFormData = exports.selectSignupProcessFormData = exports.selectSignupProcess = exports.selectAuthStatusInvitationMethod = exports.selectUserRegistrationErrors = exports.selectUserRegistration = exports.selectAuthStatusInvitationType = exports.selectAuthStatusRedirectTo = exports.selectAuthStatus = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectAuthState = function selectAuthState(state) {
	  return (0, _get2.default)(state, 'auth');
	};
	
	var selectAuthStatus = exports.selectAuthStatus = (0, _reselect.createSelector)(selectAuthState, function (state) {
	  return (0, _get2.default)(state, 'status');
	});
	
	var selectAuthStatusRedirectTo = exports.selectAuthStatusRedirectTo = (0, _reselect.createSelector)(selectAuthStatus, function (state) {
	  return (0, _get2.default)(state, 'redirectTo');
	});
	
	var selectAuthStatusInvitationType = exports.selectAuthStatusInvitationType = (0, _reselect.createSelector)(selectAuthStatus, function (state) {
	  return (0, _get2.default)(state, 'invitationType');
	});
	
	var selectUserRegistration = exports.selectUserRegistration = (0, _reselect.createSelector)(selectAuthState, function (state) {
	  return (0, _get2.default)(state, 'generalUserRegistrations');
	});
	
	var selectUserRegistrationErrors = exports.selectUserRegistrationErrors = (0, _reselect.createSelector)(selectUserRegistration, function (state) {
	  return (0, _get2.default)(state, 'error');
	});
	
	var selectAuthStatusInvitationMethod = exports.selectAuthStatusInvitationMethod = (0, _reselect.createSelector)(selectAuthStatus, function (state) {
	  return (0, _get2.default)(state, 'invitationMethod');
	});
	
	var selectSignupProcess = exports.selectSignupProcess = (0, _reselect.createSelector)(selectAuthState, function (auth) {
	  return (0, _get2.default)(auth, 'signupProcess');
	});
	
	var selectSignupProcessFormData = exports.selectSignupProcessFormData = (0, _reselect.createSelector)(selectSignupProcess, function (state) {
	  return (0, _get2.default)(state, 'signupFormData');
	});
	
	var selectSignupPersonalInfoFormData = exports.selectSignupPersonalInfoFormData = (0, _reselect.createSelector)(selectSignupProcess, function (state) {
	  return (0, _get2.default)(state, 'personalInfoFormData') || {};
	});
	
	var selectIsSignupFormDataEmpty = exports.selectIsSignupFormDataEmpty = (0, _reselect.createSelector)(selectSignupProcessFormData, function (data) {
	  return !data;
	});
	
	var selectSignUpAzureFlow = exports.selectSignUpAzureFlow = (0, _reselect.createSelector)(selectAuthStatus, function (state) {
	  return (0, _get2.default)(state, 'isSignUpAzureFlow');
	});
	
	var selectUsernameAvailabilityError = exports.selectUsernameAvailabilityError = (0, _reselect.createSelector)(selectAuthState, function (state) {
	  return (0, _get2.default)(state, 'usernameAvailability.error', false);
	});

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqCircleOfCare');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'circle_of_care']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.excludedIdsSelector = exports.offsetSelector = exports.limitSelector = exports.lastSocialIdSelector = exports.lastUserIdSelector = exports.settingsSelector = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settingsSelector = exports.settingsSelector = function settingsSelector(state) {
	  return state.board.settings;
	};
	
	var lastUserIdSelector = exports.lastUserIdSelector = (0, _reselect.createSelector)(settingsSelector, function (settings) {
	  return (0, _get2.default)(settings, 'lastUserId', null);
	});
	
	var lastSocialIdSelector = exports.lastSocialIdSelector = (0, _reselect.createSelector)(settingsSelector, function (settings) {
	  return (0, _get2.default)(settings, 'lastSocialId', null);
	});
	
	var limitSelector = exports.limitSelector = (0, _reselect.createSelector)(settingsSelector, function (settings) {
	  return (0, _get2.default)(settings, 'limit', null);
	});
	
	var offsetSelector = exports.offsetSelector = (0, _reselect.createSelector)(settingsSelector, function (settings) {
	  return (0, _get2.default)(settings, 'offset', null);
	});
	
	var excludedIdsSelector = exports.excludedIdsSelector = (0, _reselect.createSelector)(settingsSelector, function (settings) {
	  return (0, _get2.default)(settings, 'excludedIds', []);
	});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'accept-guardian-role');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'guardian_proxy_invitations',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'acceptCaregiverRole');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'caregiver_invitations',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'acceptInviteToFamilyCircle');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'family_member_invitations',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'decline-guardian-role');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'guardian_proxy_invitations',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'declineCaregiverRole');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'caregiver_invitations',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'declineInviteToFamilyCircle');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'family_member_invitations',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'inviteToFamilyCircle');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'family_members']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var _locationReducer = __webpack_require__(240);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('common', 'urlPreview', ['CLEAR']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'url_previews',
	  type: 'post'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return _redux.initialState;
	    case _locationReducer.LOCATION_CHANGE:
	      return _redux.initialState;
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginatedWatcher = exports.watcher = exports.paginatedActions = exports.actions = exports.paginatedConsts = exports.consts = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(58);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paginationInitialState = {
	  member: {
	    offset: 0,
	    limit: 10
	  },
	  moderator: {
	    offset: 0,
	    limit: 10
	  }
	};
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  pagination: paginationInitialState
	});
	
	var request = {
	  endpoint: 'participated_communities',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'type',
	    selector: 'type'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'userCommunities', ['UPDATE_TOTAL_UNREAD_COUNT']);
	var paginatedConsts = exports.paginatedConsts = (0, _redux.createReqConsts)('communities', 'paginatedUserCommunities', ['LOAD_NEXT_COMMUNITIES', 'UPDATE_PAGINATION_PARAMETERS']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var paginatedActions = exports.paginatedActions = (0, _redux.createActions)(paginatedConsts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, request);
	var paginatedWatcher = exports.paginatedWatcher = (0, _redux.createReqWatcher)(paginatedConsts, paginatedActions, request);
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload;
	
	
	  switch (action.type) {
	    case consts.SUCCEED:
	      {
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true
	        }, payload);
	      }
	    case consts.UPDATE_TOTAL_UNREAD_COUNT:
	      {
	        var communityId = payload.communityId,
	            updatePostCounter = payload.updatePostCounter,
	            removeCounter = payload.removeCounter;
	
	        var prevMember = (0, _lodash.get)(state, 'memberCommunities', []);
	        var prevModerator = (0, _lodash.get)(state, 'moderatorCommunities', []);
	        var newList = function newList(currentList) {
	          return currentList.map(function (item) {
	            if ((0, _lodash.get)(item, 'id') === communityId) {
	              var counter = (0, _lodash.get)(item, 'communityMemberChatroom.totalUnreadCount');
	              var postsCounter = (0, _lodash.get)(item, 'totalPosts');
	              var totalPostsCounter = updatePostCounter ? postsCounter + 1 : postsCounter;
	              var totalUnreadCounter = removeCounter ? 0 : counter + 1;
	              return (0, _extends3.default)({}, item, {
	                totalPosts: totalPostsCounter,
	                communityMemberChatroom: (0, _extends3.default)({}, item.communityMemberChatroom, {
	                  totalUnreadCount: totalUnreadCounter
	                })
	              });
	            }
	            return item;
	          });
	        };
	        return (0, _extends3.default)({}, state, {
	          memberCommunities: newList(prevMember),
	          moderatorCommunities: newList(prevModerator)
	        });
	      }
	    case paginatedConsts.SUCCEED:
	      {
	        var _payload$memberCommun = payload.memberCommunities,
	            memberCommunities = _payload$memberCommun === undefined ? [] : _payload$memberCommun,
	            _payload$moderatorCom = payload.moderatorCommunities,
	            moderatorCommunities = _payload$moderatorCom === undefined ? [] : _payload$moderatorCom;
	
	
	        var _prevMember = (0, _lodash.get)(state, 'memberCommunities', []);
	        var _prevModerator = (0, _lodash.get)(state, 'moderatorCommunities', []);
	
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true,
	          memberCommunities: _prevMember.concat(memberCommunities),
	          moderatorCommunities: _prevModerator.concat(moderatorCommunities)
	        });
	      }
	    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS:
	      {
	        var type = payload.type,
	            offset = payload.offset,
	            limit = payload.limit;
	
	
	        return (0, _lodash.merge)({}, state, {
	          pagination: (0, _defineProperty3.default)({}, type, { offset: offset, limit: limit })
	        });
	      }
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * TODO: location change handling
	 */
	
	var supportedActions = ['SET', 'UPDATE', 'REMOVE'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['context', 'targetUser'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case consts.SET:
	    case consts.UPDATE:
	      return payload;
	    case consts.REMOVE:
	      return initialState;
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.redirectToPersonalInfo = redirectToPersonalInfo;
	exports.redirectToGeneralInfo = redirectToGeneralInfo;
	exports.redirectToDocuments = redirectToDocuments;
	exports.redirectToRelation = redirectToRelation;
	exports.redirectToRole = redirectToRole;
	exports.redirectToCompletePage = redirectToCompletePage;
	exports.redirectToDependentExistPage = redirectToDependentExistPage;
	exports.redirectHistoryBack = redirectHistoryBack;
	exports.checkAlreadyCreatedUserAndRedirect = checkAlreadyCreatedUserAndRedirect;
	
	var _effects = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(42);
	
	var _progress = __webpack_require__(121);
	
	var _routes = __webpack_require__(37);
	
	var _constants = __webpack_require__(17);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _selectors = __webpack_require__(23);
	
	var _myProfileRedirect = __webpack_require__(682);
	
	var _selectors2 = __webpack_require__(167);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(redirectToPersonalInfo),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(redirectToGeneralInfo),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(redirectToDocuments),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(redirectToRelation),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(redirectToRole),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(redirectToCompletePage),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(redirectToDependentExistPage),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(redirectHistoryBack),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(checkAlreadyCreatedUserAndRedirect);
	
	function redirectToPersonalInfo() {
	  return _regenerator2.default.wrap(function redirectToPersonalInfo$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_progress.dependentFormActions.setStep(_progress.DEPENDENT_FORM_STEPS.PERSONAL));
	
	        case 2:
	
	          _reactRouter.browserHistory.push(_routes.DEPENDENT_FORM + '/' + _routes.DEPENDENT_FORM_PERSONAL);
	
	        case 3:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function redirectToGeneralInfo(id) {
	  var formatUrl;
	  return _regenerator2.default.wrap(function redirectToGeneralInfo$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)(_progress.dependentFormActions.setStep(_progress.DEPENDENT_FORM_STEPS.GENERAL));
	
	        case 2:
	          formatUrl = _routes.DEPENDENT_FORM_GENERAL.replace(':id', id);
	
	
	          _reactRouter.browserHistory.push(_routes.DEPENDENT_FORM + '/' + formatUrl);
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function redirectToDocuments(id) {
	  var formatUrl;
	  return _regenerator2.default.wrap(function redirectToDocuments$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)(_progress.dependentFormActions.setStep(_progress.DEPENDENT_FORM_STEPS.DOCUMENTS));
	
	        case 2:
	          formatUrl = _routes.DEPENDENT_FORM_DOCUMENTS.replace(':id', id);
	
	
	          _reactRouter.browserHistory.push(_routes.DEPENDENT_FORM + '/' + formatUrl);
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function redirectToRelation(id) {
	  var formatUrl;
	  return _regenerator2.default.wrap(function redirectToRelation$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.put)(_progress.dependentFormActions.setStep(_progress.DEPENDENT_FORM_STEPS.RELATION));
	
	        case 2:
	          formatUrl = _routes.DEPENDENT_FORM_RELATION.replace(':id', id);
	
	
	          _reactRouter.browserHistory.push(_routes.DEPENDENT_FORM + '/' + formatUrl);
	
	        case 4:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function redirectToRole() {
	  return _regenerator2.default.wrap(function redirectToRole$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.put)(_progress.dependentFormActions.setStep(_progress.DEPENDENT_FORM_STEPS.ROLE));
	
	        case 2:
	          _context5.next = 4;
	          return _reactRouter.browserHistory.push(_routes.DEPENDENT_FORM + '/' + _routes.DEPENDENT_FORM_ROLE);
	
	        case 4:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function redirectToCompletePage(assigment) {
	  var careRole, careUserCreator, displayableName, id, submitRedirect, messageId;
	  return _regenerator2.default.wrap(function redirectToCompletePage$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          careRole = assigment.careRole, careUserCreator = assigment.careUserCreator, displayableName = assigment.dependent.displayableName;
	          _context6.next = 3;
	          return (0, _effects.put)(_progress.dependentFormActions.setStep(_progress.DEPENDENT_FORM_STEPS.COMPLETE));
	
	        case 3:
	          if (!(careRole === _constants.DEPENDENT_ROLES.PARENT)) {
	            _context6.next = 22;
	            break;
	          }
	
	          _context6.next = 6;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 6:
	          id = _context6.sent;
	          _context6.next = 9;
	          return (0, _effects.select)(_selectors2.selectDependentFormSubmitRedirect);
	
	        case 9:
	          submitRedirect = _context6.sent;
	          messageId = careUserCreator ? 'dependent.form.profileCreated' : 'dependent.form.becomeParent';
	
	          if (!(submitRedirect === _constants.DEPENDENT_FORM_SUBMIT_REDIRECT.GET_CARE)) {
	            _context6.next = 15;
	            break;
	          }
	
	          (0, _redirectUtils.redirectToUsers)(id, false);
	          _context6.next = 18;
	          break;
	
	        case 15:
	          if (!(submitRedirect === _constants.DEPENDENT_FORM_SUBMIT_REDIRECT.PROFILE)) {
	            _context6.next = 18;
	            break;
	          }
	
	          _context6.next = 18;
	          return (0, _effects.put)(_myProfileRedirect.myProfileRedirectActions.goToProfile());
	
	        case 18:
	          _context6.next = 20;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: messageId },
	            values: { name: displayableName }
	          });
	
	        case 20:
	          _context6.next = 24;
	          break;
	
	        case 22:
	          _context6.next = 24;
	          return _reactRouter.browserHistory.push(_routes.DEPENDENT_FORM + '/' + _routes.DEPENDENT_FORM_COMPLETE);
	
	        case 24:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function redirectToDependentExistPage() {
	  return _regenerator2.default.wrap(function redirectToDependentExistPage$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.put)(_progress.dependentFormActions.setStep(_progress.DEPENDENT_FORM_STEPS.USER_EXIST));
	
	        case 2:
	          _context7.next = 4;
	          return _reactRouter.browserHistory.push(_routes.DEPENDENT_FORM + '/' + _routes.DEPENDENT_FORM_EXISTING);
	
	        case 4:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function redirectHistoryBack() {
	  return _regenerator2.default.wrap(function redirectHistoryBack$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return _reactRouter.browserHistory.push('/' + _routes.MESSAGES);
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function checkAlreadyCreatedUserAndRedirect(assignment) {
	  var redirectToMethod;
	  return _regenerator2.default.wrap(function checkAlreadyCreatedUserAndRedirect$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          redirectToMethod = assignment.careUserCreator === false ? redirectToRelation : redirectToGeneralInfo;
	          _context9.next = 3;
	          return (0, _effects.call)(redirectToMethod, assignment.id);
	
	        case 3:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}

/***/ }),
/* 417 */,
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'coupon-verification');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'coupon_availability_checks']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'payment-verification');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'payment_orders',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['paymentOrderId']
	  }, 'payment_verifications']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PUB_KEY = exports.PUB_KEY = 'PUBLISHER';
	var SCREEN_SHARING_VIDEO_TYPE = exports.SCREEN_SHARING_VIDEO_TYPE = 'custom';
	
	var OT_EVENTS = exports.OT_EVENTS = {
	  STREAM_CREATED: 'streamCreated',
	  STREAM_DESTROYED: 'streamDestroyed',
	  STREAM_PROPERTY_CHANGE: 'streamPropertyChanged',
	  VIDEO_ELEMENT_CREATED: 'videoElementCreated',
	  AUDIO_LEVEL_UPDATED: 'audioLevelUpdated',
	  VIDEO_DISABLED_WARNING: 'videoDisableWarning',
	  VIDEO_DISABLED_WARNING_LIFTED: 'videoDisableWarningLifted',
	  SESSION_DISCONNECTED: 'sessionDisconnected'
	};
	
	var SIGNAL = exports.SIGNAL = {
	  VISIT_ENDED: 'signal:visit_ended',
	  VISIT_DURATION: 'signal:visit_duration',
	  VISIT_METADATA: 'signal:visit_metadata',
	  PROVIDER_CONNECTED: 'signal:provider_connected',
	  PENDING_INVITATIONS: 'signal:pending_invitations'
	};
	
	var OT_ERROR_CODES = exports.OT_ERROR_CODES = {
	  MEDIA_ACCESS_DENIED: 'OT_USER_MEDIA_ACCESS_DENIED',
	  HARDWARE_UNAVAILABLE: 'OT_HARDWARE_UNAVAILABLE',
	  NO_DEVICES_FOUND: 'OT_NO_DEVICES_FOUND',
	  NO_VALID_CONSTRAINTS: 'OT_NO_VALID_CONSTRAINTS',
	  NOT_SUPPORTED: 'OT_NOT_SUPPORTED',
	
	  SESSION_AUTH_ERROR: 'OT_AUTHENTICATION_ERROR',
	  SESSION_CONNECT_FAILED: 'OT_CONNECT_FAILED',
	  SESSION_CONNECT_LIMIT: 'OT_CONNECTION_LIMIT_EXCEEDED',
	  SESSION_INVALID_ID: 'OT_INVALID_SESSION_ID',
	  NOT_CONNECTED: 'OT_NOT_CONNECTED'
	};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectShowPaperworkAppointmentQuestionStep = exports.selectExtraQuestions = exports.selectRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @typedef {Object} ExtraQuestion
	 * @property {number} id
	 * @property {string} text
	 * @property {"boolean"|"select"|"text"} kind
	 * @property {{ id: number, text: string }[]|undefined} options
	 * @property {ExtraQuestion[]|undefined} childQuestions
	 * */
	
	/**
	 * @param {Object} state
	 * @param {[ExtraQuestion]} state.list
	 * */
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'paperwork.paperworkAdditionalInfo');
	};
	
	var selectExtraQuestions = exports.selectExtraQuestions = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectShowPaperworkAppointmentQuestionStep = exports.selectShowPaperworkAppointmentQuestionStep = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return !!(0, _get2.default)(state, 'list.length');
	});

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'delete-user-documents');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'documents', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'edit-patient-by-provider');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider_patient_profiles',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'edit-provider');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider_profiles',
	  type: 'put',
	  slug: [{
	    type: 'localStorage',
	    selector: ['providerId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var payload = action.payload;
	
	  switch (action.type) {
	    case consts.DELETE_ITEM:
	      {
	        var id = payload.id;
	
	        var updatedList = (0, _get2.default)(state, 'list').filter(function (item) {
	          return item.id !== id;
	        });
	        return (0, _extends3.default)({}, state, {
	          list: updatedList
	        });
	      }
	    case consts.UPDATE_LIST:
	      {
	        var key = payload.key;
	
	        var existingList = (0, _get2.default)(state, 'list');
	        var isExistingDocument = existingList.find(function (item) {
	          return item.key === key;
	        });
	        var _updatedList = void 0;
	        if (isExistingDocument) {
	          _updatedList = (0, _get2.default)(state, 'list').map(function (item) {
	            if (key === item.key) {
	              return payload;
	            }
	            return item;
	          });
	        } else {
	          _updatedList = [].concat((0, _toConsumableArray3.default)(existingList), [payload]);
	        }
	
	        return (0, _extends3.default)({}, state, {
	          list: _updatedList
	        });
	      }
	    default:
	      return defaultReducer(state, action);
	  }
	};
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'get-user-documents', ['DELETE_ITEM', 'UPDATE_LIST']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'documents']
	});
	
	var defaultReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'getAccessLevels');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'access_levels']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'insurance-eligibility-manual-activations');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'insurance_eligibility',
	  type: 'post',
	  slug: ['results', {
	    type: 'payload',
	    selector: ['insuranceEligibilityResultId']
	  }, 'manual_activations']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'historic-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['historic_measurements', {
	    type: 'payload.query',
	    queryParameter: 'type',
	    selector: 'typeMeasurements'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period_start_date',
	    selector: 'periodStartDate'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }]
	});
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  list: []
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          succeed: true,
	          sending: false,
	          list: state.list && state.list.length !== 0 ? state.list.concat(payload) : payload
	        });
	      }
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'upload-user-documents');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'documents']
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'block-insert', ['START']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'blocked_slots', 'insertions']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'worslot-insert', ['START']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'work_slots', 'insertions']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectedPopoverActions = exports.POPOVER_CONTENT_TYPES = exports.SELECTED_POPOVER_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	var _constants = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'schedule/selected-popover';
	
	var SELECTED_POPOVER_TYPES = exports.SELECTED_POPOVER_TYPES = {
	  SET_POSITION: actionsScope + '/set-position',
	  SET_OPTIMIZED_POSITION: actionsScope + '/set-optimized-position',
	  SET_SELECTABLE: actionsScope + '/set-selectable',
	  SET_TYPE: actionsScope + '/set-type',
	  SET_BLOCKED: actionsScope + '/set-blocked',
	  RESET: actionsScope + '/reset'
	};
	
	var POPOVER_CONTENT_TYPES = exports.POPOVER_CONTENT_TYPES = {
	  NEW: 'new',
	  SELECT_EXISTED: 'select-existed',
	  HOVER: 'hover',
	  EDIT: 'edit',
	  SET_NEW_BLOCKED: 'set-new-blocked',
	  APPOINTMENT_DETAILS: 'appointment-details',
	  APPOINTMENT_FORM: 'appointment-form'
	};
	
	var selectedPopoverActions = exports.selectedPopoverActions = {
	  setPosition: (0, _createAction.createAction)(SELECTED_POPOVER_TYPES.SET_POSITION),
	  setOptimizedPosition: (0, _createAction.createAction)(SELECTED_POPOVER_TYPES.SET_OPTIMIZED_POSITION),
	  setSelectable: (0, _createAction.createAction)(SELECTED_POPOVER_TYPES.SET_SELECTABLE),
	  setType: (0, _createAction.createAction)(SELECTED_POPOVER_TYPES.SET_TYPE),
	  setBlocked: (0, _createAction.createAction)(SELECTED_POPOVER_TYPES.SET_BLOCKED),
	  reset: (0, _createAction.createAction)(SELECTED_POPOVER_TYPES.RESET)
	};
	
	var initialState = {
	  visible: false,
	  schedule: null,
	  selectable: false,
	  appointmentId: null,
	  type: '',
	  areaBounds: {
	    width: 100,
	    top: 0,
	    left: 0
	  },
	  bounds: {
	    width: 100,
	    top: 0,
	    left: 0
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case SELECTED_POPOVER_TYPES.SET_OPTIMIZED_POSITION:
	      {
	        var schedule = payload.schedule,
	            bounds = payload.bounds,
	            popoverType = payload.type,
	            appointmentId = payload.appointmentId,
	            areaBounds = payload.areaBounds;
	
	
	        return (0, _extends3.default)({}, state, {
	          visible: true,
	          selectable: false,
	          type: popoverType,
	          schedule: schedule,
	          areaBounds: areaBounds,
	          bounds: bounds,
	          appointmentId: appointmentId
	        });
	      }
	
	    case SELECTED_POPOVER_TYPES.SET_SELECTABLE:
	      {
	        return (0, _extends3.default)({}, state, {
	          selectable: true,
	          visible: false
	        });
	      }
	
	    case SELECTED_POPOVER_TYPES.SET_BLOCKED:
	      {
	        return (0, _extends3.default)({}, state, {
	          type: POPOVER_CONTENT_TYPES.SET_NEW_BLOCKED,
	          schedule: (0, _extends3.default)({}, state.schedule, {
	            isRepeatable: false,
	            __type: _constants.SCHEDULE_TYPES.BLOCK
	          })
	        });
	      }
	
	    case SELECTED_POPOVER_TYPES.SET_TYPE:
	      {
	        return (0, _extends3.default)({}, state, { type: payload });
	      }
	
	    case SELECTED_POPOVER_TYPES.RESET:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'upcoming-survey', ['FINISH']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'upcoming_assignments', {
	    type: 'payload',
	    selector: ['assignmentId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var formatAmount = exports.formatAmount = function formatAmount(amount) {
	  return (amount || amount === 0) && amount.toFixed(2);
	};

/***/ }),
/* 435 */,
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(17);
	
	var getVisitTypeName = function getVisitTypeName(_ref) {
	  var sourceOfCreation = _ref.sourceOfCreation,
	      defaultValue = _ref.defaultValue,
	      formatMessage = _ref.formatMessage,
	      visitTypeCode = _ref.visitTypeCode;
	
	  var walkInLabel = formatMessage({ id: 'appointment.list.card.walkIn' });
	
	  if (_constants.WALK_IN_SOURCES.includes(sourceOfCreation) && visitTypeCode === _constants.HOLD_MY_SPOT_VISIT_TYPE_CODE) {
	    return walkInLabel;
	  }
	
	  return defaultValue;
	};
	
	exports.default = getVisitTypeName;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserActionSeverity = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.trackUserAction = trackUserAction;
	exports.trackAppAction = trackAppAction;
	exports.trackError = trackError;
	exports.sentryCaptureMessage = sentryCaptureMessage;
	exports.sentryCaptureError = sentryCaptureError;
	exports.sentryCaptureException = sentryCaptureException;
	exports.setupSentryScope = setupSentryScope;
	
	var _react = __webpack_require__(1067);
	
	var _env = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDevelopment = _env.DEV_ENV;
	// const isDevelopment = false;
	
	var UserActionSeverity = exports.UserActionSeverity = _react.Severity;
	
	function trackUserAction(message) {
	  var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ui.cta-click';
	  var severity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : UserActionSeverity.Info;
	
	  if (isDevelopment) return;
	
	  (0, _react.addBreadcrumb)({
	    category: category,
	    type: 'user',
	    message: message,
	    level: severity
	  });
	}
	
	function trackAppAction(message) {
	  var severity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UserActionSeverity.Info;
	
	  if (isDevelopment) return;
	
	  trackUserAction(message, 'ui.app-state', severity);
	}
	
	function trackError(error) {
	  if (isDevelopment) return;
	
	  (0, _react.addBreadcrumb)({
	    category: 'error',
	    type: 'error',
	    level: _react.Severity.Error,
	    data: error
	  });
	}
	
	function sentryCaptureMessage(message) {
	  var severity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UserActionSeverity.Info;
	
	  if (isDevelopment) return;
	
	  (0, _react.captureMessage)(message, severity);
	}
	
	function sentryCaptureError(errorTitle, context) {
	  if (isDevelopment) return;
	
	  (0, _react.captureMessage)(errorTitle, (0, _extends3.default)({
	    level: UserActionSeverity.Error
	  }, context));
	}
	
	function sentryCaptureException(exception, captureContext) {
	  if (isDevelopment) return;
	
	  (0, _react.captureException)(exception, captureContext);
	}
	
	function setupSentryScope(_ref) {
	  var id = _ref.id;
	
	  if (isDevelopment) return;
	
	  (0, _react.configureScope)(function (scope) {
	    scope.clear();
	    scope.setUser({ id: id });
	  });
	}

/***/ }),
/* 438 */
95,
/* 439 */
204,
/* 440 */
[6618, 4373, 1403],
/* 441 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 442 */
[6554, 243, 2148, 1427, 85, 126, 1444],
/* 443 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 444 */
[6570, 85, 2154, 1423, 1435, 1422, 1425],
/* 445 */
[6575, 2156, 1423],
/* 446 */
[6578, 2156, 1423],
/* 447 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(206);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(89);
	var dP = __webpack_require__(125);
	var DESCRIPTORS = __webpack_require__(124);
	var SPECIES = __webpack_require__(106)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 450 */
[6591, 273],
/* 451 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareAsc;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareAsc
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * var result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 453 */
[6648, 320, 945, 20],
/* 454 */
[6677, 4815, 4816, 4817, 4818, 4819],
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(371));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = exports.INIT_COORDS = void 0;
	var INIT_COORDS = 'dnd-core/INIT_COORDS';
	exports.INIT_COORDS = INIT_COORDS;
	var BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
	exports.BEGIN_DRAG = BEGIN_DRAG;
	var PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
	exports.PUBLISH_DRAG_SOURCE = PUBLISH_DRAG_SOURCE;
	var HOVER = 'dnd-core/HOVER';
	exports.HOVER = HOVER;
	var DROP = 'dnd-core/DROP';
	exports.DROP = DROP;
	var END_DRAG = 'dnd-core/END_DRAG';
	exports.END_DRAG = END_DRAG;

/***/ }),
/* 457 */,
/* 458 */
2686,
/* 459 */
[6762, 96, 1550, 5492, 468],
/* 460 */
[6777, 5412, 5455],
/* 461 */
[6810, 576],
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(5446),
	    findIndex = __webpack_require__(979);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(973);
	
	/**
	 * Converts `string`, as space separated words, to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the lower cased string.
	 * @example
	 *
	 * _.lowerCase('--Foo-Bar--');
	 * // => 'foo bar'
	 *
	 * _.lowerCase('fooBar');
	 * // => 'foo bar'
	 *
	 * _.lowerCase('__FOO_BAR__');
	 * // => 'foo bar'
	 */
	var lowerCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + word.toLowerCase();
	});
	
	module.exports = lowerCase;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(5422),
	    flatRest = __webpack_require__(2332);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(973);
	
	/**
	 * Converts `string` to
	 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the snake cased string.
	 * @example
	 *
	 * _.snakeCase('Foo Bar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('fooBar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('--FOO-BAR--');
	 * // => 'foo_bar'
	 */
	var snakeCase = createCompounder(function(result, word, index) {
	  return result + (index ? '_' : '') + word.toLowerCase();
	});
	
	module.exports = snakeCase;


/***/ }),
/* 468 */
[6830, 1539],
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(2394),
	    now = __webpack_require__(5664),
	    toNumber = __webpack_require__(5665);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.recomposeColor = recomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	   false ? (0, _warning2.default)(value >= min && value <= max, 'Material-UI: the value provided ' + value + ' is out of range [' + min + ', ' + max + '].') : void 0;
	
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	//  weak
	/* eslint-disable no-use-before-define */
	
	function convertHexToRGB(color) {
	  color = color.substr(1);
	
	  var re = new RegExp('.{1,' + color.length / 3 + '}', 'g');
	  var colors = color.match(re);
	
	  if (colors && colors[0].length === 1) {
	    colors = colors.map(function (n) {
	      return n + n;
	    });
	  }
	
	  return colors ? 'rgb(' + colors.map(function (n) {
	    return parseInt(n, 16);
	  }).join(', ') + ')' : '';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {object} - A MUI color object: {type: string, values: number[]}
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function recomposeColor(color) {
	  var type = color.type;
	  var values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    values = values.map(function (n, i) {
	      return i < 3 ? parseInt(n, 10) : n;
	    });
	  }
	
	  if (type.indexOf('hsl') > -1) {
	    values[1] = values[1] + '%';
	    values[2] = values[2] + '%';
	  }
	
	  return color.type + '(' + values.join(', ') + ')';
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  var decomposedColor = decomposeColor(color);
	
	  if (decomposedColor.type.indexOf('rgb') > -1) {
	    var rgb = decomposedColor.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    // Truncate at 3 digits
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
	  } else if (decomposedColor.type.indexOf('hsl') > -1) {
	    return decomposedColor.values[2] / 100;
	  }
	
	  throw new Error('Material-UI: unsupported `' + color + '` color.');
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in fade(' + color + ', ' + value + ').') : void 0;
	
	  if (!color) return color;
	
	  color = decomposeColor(color);
	  value = clamp(value);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return recomposeColor(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in darken(' + color + ', ' + coefficient + ').') : void 0;
	
	  if (!color) return color;
	
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return recomposeColor(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in lighten(' + color + ', ' + coefficient + ').') : void 0;
	
	  if (!color) return color;
	
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}

/***/ }),
/* 471 */
[6777, 5729, 5753],
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 476 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isFunction = isFunction;
	exports.noop = noop;
	exports.isPlainObject = isPlainObject;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	// cheap lodash replacements
	function isFunction(input) {
	  return typeof input === 'function';
	}
	
	function noop() {// noop
	}
	
	function isObjectLike(input) {
	  return _typeof(input) === 'object' && input !== null;
	}
	
	function isPlainObject(input) {
	  if (!isObjectLike(input)) {
	    return false;
	  }
	
	  if (Object.getPrototypeOf(input) === null) {
	    return true;
	  }
	
	  var proto = input;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(input) === proto;
	}

/***/ }),
/* 477 */
[6777, 6088, 6124],
/* 478 */
331,
/* 479 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// ==============================
	// THEME
	// ==============================
	
	var theme = {};
	
	// container
	theme.container = {
		background: 'rgba(0, 0, 0, 0.8)',
		gutter: {
			horizontal: 10,
			vertical: 10
		},
		zIndex: 2001
	};
	
	// header
	theme.header = {
		height: 40
	};
	theme.close = {
		fill: 'white'
	};
	
	// footer
	theme.footer = {
		color: 'white',
		count: {
			color: 'rgba(255, 255, 255, 0.75)',
			fontSize: '0.85em'
		},
		height: 40,
		gutter: {
			horizontal: 0,
			vertical: 5
		}
	};
	
	// thumbnails
	theme.thumbnail = {
		activeBorderColor: 'white',
		size: 50,
		gutter: 2
	};
	
	// arrow
	theme.arrow = {
		background: 'none',
		fill: 'white',
		height: 120
	};
	
	exports.default = theme;

/***/ }),
/* 480 */,
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTimeValue = getTimeValue;
	exports.isHourMode = isHourMode;
	exports.isMinuteMode = isMinuteMode;
	exports.isSameTime = isSameTime;
	
	var _constants = __webpack_require__(211);
	
	function modeToUnit(mode) {
	  return mode === _constants.MODE.MINUTES ? 'minute' : 'hour';
	}
	
	function getTimeValue(mode, time) {
	  var unit = modeToUnit(mode);
	  return time[unit];
	}
	
	function isHourMode(mode) {
	  return mode === _constants.MODE.HOURS_12 || mode === _constants.MODE.HOURS_24;
	}
	
	function isMinuteMode(mode) {
	  return mode === _constants.MODE.MINUTES;
	}
	
	function isSameTime(prev, next) {
	  return prev.hour === next.hour && prev.minute === next.minute;
	}

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(283);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConfigProvider = ConfigProvider;
	exports.default = useConfig;
	
	var _core = __webpack_require__(128);
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var configContext = (0, _react.createContext)({});
	
	function ConfigProvider(_ref) {
	  var children = _ref.children,
	      _ref$coarseMinutes = _ref.coarseMinutes,
	      coarseMinutes = _ref$coarseMinutes === void 0 ? 5 : _ref$coarseMinutes,
	      _ref$forceCoarseMinut = _ref.forceCoarseMinutes,
	      forceCoarseMinutes = _ref$forceCoarseMinut === void 0 ? false : _ref$forceCoarseMinut,
	      _ref$switchToMinuteOn = _ref.switchToMinuteOnHourSelect,
	      switchToMinuteOnHourSelect = _ref$switchToMinuteOn === void 0 ? false : _ref$switchToMinuteOn,
	      _ref$closeOnMinuteSel = _ref.closeOnMinuteSelect,
	      closeOnMinuteSelect = _ref$closeOnMinuteSel === void 0 ? false : _ref$closeOnMinuteSel,
	      _ref$hour24Mode = _ref.hour24Mode,
	      hour24Mode = _ref$hour24Mode === void 0 ? false : _ref$hour24Mode,
	      _ref$onDoneClick = _ref.onDoneClick,
	      onDoneClick = _ref$onDoneClick === void 0 ? null : _ref$onDoneClick,
	      _ref$doneButton = _ref.doneButton,
	      doneButton = _ref$doneButton === void 0 ? null : _ref$doneButton;
	  var config = (0, _react.useMemo)(function () {
	    if (coarseMinutes < 1) {
	      throw new Error('coarseMinutes must be at least 1');
	    }
	
	    return {
	      coarseMinutes: coarseMinutes,
	      forceCoarseMinutes: forceCoarseMinutes,
	      switchToMinuteOnHourSelect: switchToMinuteOnHourSelect,
	      closeOnMinuteSelect: closeOnMinuteSelect,
	      hour24Mode: hour24Mode,
	      onDoneClick: onDoneClick,
	      doneButton: doneButton
	    };
	  }, [coarseMinutes, forceCoarseMinutes, switchToMinuteOnHourSelect, closeOnMinuteSelect, onDoneClick, hour24Mode, doneButton]);
	  return (0, _core.jsx)(configContext.Provider, {
	    value: config
	  }, children);
	}
	
	function useConfig() {
	  return (0, _react.useContext)(configContext);
	}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(283);
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StateProvider = StateProvider;
	exports.default = useTimekeeperState;
	
	var _core = __webpack_require__(128);
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(1051));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1054));
	
	var _objectSpread3 = _interopRequireDefault(__webpack_require__(2893));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _lodash = _interopRequireDefault(__webpack_require__(5385));
	
	var _time = __webpack_require__(6317);
	
	var _configContext = _interopRequireDefault(__webpack_require__(482));
	
	var _utils = __webpack_require__(481);
	
	var _constants = __webpack_require__(211);
	
	var stateContext = (0, _react.createContext)({});
	
	function reducer(state, action) {
	  switch (action.type) {
	    case 'SET_TIME':
	      return (0, _objectSpread3.default)({}, state, {
	        time: action.time,
	        meridiem: action.meridiem || state.meridiem
	      });
	
	    case 'SET_MODE':
	      return (0, _objectSpread3.default)({}, state, {
	        mode: action.mode
	      });
	
	    case 'SET_MERIDIEM':
	      return (0, _objectSpread3.default)({}, state, {
	        meridiem: action.meridiem
	      });
	  }
	
	  return state;
	}
	
	function StateProvider(_ref) {
	  var onChange = _ref.onChange,
	      parentTime = _ref.time,
	      children = _ref.children;
	  var config = (0, _configContext.default)();
	
	  var _useReducer = (0, _react.useReducer)(reducer, null, function () {
	    return {
	      time: (0, _time.parseTime)(parentTime),
	      mode: config.hour24Mode ? _constants.MODE.HOURS_24 : _constants.MODE.HOURS_12,
	      // need meridiem for context when 12h mode, so can tell
	      // if user is changing hours before or after 12pm
	      meridiem: (0, _time.parseMeridiem)(parentTime)
	    };
	  }),
	      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
	      state = _useReducer2[0],
	      dispatch = _useReducer2[1];
	
	  var mode = state.mode,
	      time = state.time,
	      meridiem = state.meridiem;
	  var refTime = (0, _react.useRef)(time); // handle time update if parent changes
	
	  (0, _react.useEffect)(function () {
	    if (parentTime == null) {
	      return;
	    }
	
	    var newTime = (0, _time.parseTime)(parentTime);
	
	    if ((0, _utils.isSameTime)(newTime, refTime.current)) {
	      return;
	    }
	
	    var action = {
	      type: 'SET_TIME',
	      time: (0, _time.parseTime)(parentTime)
	    };
	
	    if (!config.hour24Mode) {
	      action.meridiem = (0, _time.parseMeridiem)(parentTime);
	    }
	
	    dispatch(action);
	  }, [config.hour24Mode, parentTime]);
	  var getComposedTime = (0, _react.useCallback)(function () {
	    var time = refTime.current;
	    return (0, _time.composeTime)(time.hour, time.minute);
	  }, []); // debounced onChange function from parent
	
	  var debounceUpdateParent = (0, _react.useMemo)(function () {
	    if (typeof onChange === 'function') {
	      return (0, _lodash.default)(function () {
	        onChange(getComposedTime());
	      }, 80);
	    }
	
	    return function () {};
	  }, [getComposedTime, onChange]); // update 24 hour time on meridiem change
	
	  function updateMeridiem(newMeridiem) {
	    if (meridiem === newMeridiem) {
	      return;
	    }
	
	    var newTime = {
	      minute: time.minute,
	      hour: 0
	    };
	
	    if (newMeridiem === 'am') {
	      newTime.hour = time.hour - 12;
	    } else if (newMeridiem === 'pm') {
	      newTime.hour = time.hour + 12;
	    }
	
	    _actuallySetTime(newTime, newMeridiem);
	  } // update time on component and then on parent
	
	
	  function _actuallySetTime(newTime, meridiem) {
	    // update component global state
	    dispatch({
	      type: 'SET_TIME',
	      time: newTime,
	      meridiem: meridiem
	    });
	    refTime.current = newTime; // update time on parent
	
	    debounceUpdateParent();
	  } // this method is called only due to changes in clock actions
	
	
	  function updateTime(val) {
	    // account if minutes is 60 (eg: 59 rounded to 60)
	    val = val % 60; // account for max number being 12 during 12h mode
	
	    if (mode === _constants.MODE.HOURS_12 && meridiem === 'pm') {
	      val += 12;
	    } // generate new time and update timekeeper state
	
	
	    var unit = (0, _utils.isHourMode)(mode) ? 'hour' : 'minute'; // useful for same value when dragging between degrees in hours
	
	    if (refTime.current[unit] === val) {
	      return;
	    }
	
	    var newTime = (0, _objectSpread3.default)({}, time, (0, _defineProperty2.default)({}, unit, val));
	
	    _actuallySetTime(newTime);
	  }
	
	  var setMode = (0, _react.useCallback)(function (mode) {
	    var m = mode;
	
	    if ((0, _utils.isHourMode)(mode)) {
	      m = config.hour24Mode ? _constants.MODE.HOURS_24 : _constants.MODE.HOURS_12;
	    }
	
	    dispatch({
	      type: 'SET_MODE',
	      mode: m
	    });
	  }, [config.hour24Mode]);
	  var value = {
	    time: time,
	    mode: mode,
	    updateTime: updateTime,
	    updateMeridiem: updateMeridiem,
	    setMode: setMode,
	    getComposedTime: getComposedTime
	  };
	  return (0, _core.jsx)(stateContext.Provider, {
	    value: value
	  }, children);
	}
	
	function useTimekeeperState() {
	  return (0, _react.useContext)(stateContext);
	}

/***/ }),
/* 484 */,
/* 485 */,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(755);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Checks whether given value's type is one of a few Error or Error-like
	 * {@link isError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isError(wat) {
	    switch (Object.prototype.toString.call(wat)) {
	        case '[object Error]':
	            return true;
	        case '[object Exception]':
	            return true;
	        case '[object DOMException]':
	            return true;
	        default:
	            return isInstanceOf(wat, Error);
	    }
	}
	exports.isError = isError;
	/**
	 * Checks whether given value's type is ErrorEvent
	 * {@link isErrorEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isErrorEvent(wat) {
	    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
	}
	exports.isErrorEvent = isErrorEvent;
	/**
	 * Checks whether given value's type is DOMError
	 * {@link isDOMError}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMError(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMError]';
	}
	exports.isDOMError = isDOMError;
	/**
	 * Checks whether given value's type is DOMException
	 * {@link isDOMException}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isDOMException(wat) {
	    return Object.prototype.toString.call(wat) === '[object DOMException]';
	}
	exports.isDOMException = isDOMException;
	/**
	 * Checks whether given value's type is a string
	 * {@link isString}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isString(wat) {
	    return Object.prototype.toString.call(wat) === '[object String]';
	}
	exports.isString = isString;
	/**
	 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
	 * {@link isPrimitive}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPrimitive(wat) {
	    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
	}
	exports.isPrimitive = isPrimitive;
	/**
	 * Checks whether given value's type is an object literal
	 * {@link isPlainObject}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isPlainObject(wat) {
	    return Object.prototype.toString.call(wat) === '[object Object]';
	}
	exports.isPlainObject = isPlainObject;
	/**
	 * Checks whether given value's type is an Event instance
	 * {@link isEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isEvent(wat) {
	    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
	}
	exports.isEvent = isEvent;
	/**
	 * Checks whether given value's type is an Element instance
	 * {@link isElement}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isElement(wat) {
	    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
	}
	exports.isElement = isElement;
	/**
	 * Checks whether given value's type is an regexp
	 * {@link isRegExp}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isRegExp(wat) {
	    return Object.prototype.toString.call(wat) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	/**
	 * Checks whether given value has a then function.
	 * @param wat A value to be checked.
	 */
	function isThenable(wat) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return Boolean(wat && wat.then && typeof wat.then === 'function');
	}
	exports.isThenable = isThenable;
	/**
	 * Checks whether given value's type is a SyntheticEvent
	 * {@link isSyntheticEvent}.
	 *
	 * @param wat A value to be checked.
	 * @returns A boolean representing the result.
	 */
	function isSyntheticEvent(wat) {
	    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
	}
	exports.isSyntheticEvent = isSyntheticEvent;
	/**
	 * Checks whether given value's type is an instance of provided constructor.
	 * {@link isInstanceOf}.
	 *
	 * @param wat A value to be checked.
	 * @param base A constructor to be used in a check.
	 * @returns A boolean representing the result.
	 */
	function isInstanceOf(wat, base) {
	    try {
	        return wat instanceof base;
	    }
	    catch (_e) {
	        return false;
	    }
	}
	exports.isInstanceOf = isInstanceOf;
	//# sourceMappingURL=is.js.map

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.throwUnhandledCaseError = exports.splitAndCapture = exports.remove = exports.indexOf = exports.ellipsis = exports.defaults = void 0;
	/**
	 * Assigns (shallow copies) the properties of `src` onto `dest`, if the
	 * corresponding property on `dest` === `undefined`.
	 *
	 * @param {Object} dest The destination object.
	 * @param {Object} src The source object.
	 * @return {Object} The destination object (`dest`)
	 */
	function defaults(dest, src) {
	    for (var prop in src) {
	        if (src.hasOwnProperty(prop) && dest[prop] === undefined) {
	            dest[prop] = src[prop];
	        }
	    }
	    return dest;
	}
	exports.defaults = defaults;
	/**
	 * Truncates the `str` at `len - ellipsisChars.length`, and adds the `ellipsisChars` to the
	 * end of the string (by default, two periods: '..'). If the `str` length does not exceed
	 * `len`, the string will be returned unchanged.
	 *
	 * @param {String} str The string to truncate and add an ellipsis to.
	 * @param {Number} truncateLen The length to truncate the string at.
	 * @param {String} [ellipsisChars=...] The ellipsis character(s) to add to the end of `str`
	 *   when truncated. Defaults to '...'
	 */
	function ellipsis(str, truncateLen, ellipsisChars) {
	    var ellipsisLength;
	    if (str.length > truncateLen) {
	        if (ellipsisChars == null) {
	            ellipsisChars = '&hellip;';
	            ellipsisLength = 3;
	        }
	        else {
	            ellipsisLength = ellipsisChars.length;
	        }
	        str = str.substring(0, truncateLen - ellipsisLength) + ellipsisChars;
	    }
	    return str;
	}
	exports.ellipsis = ellipsis;
	/**
	 * Supports `Array.prototype.indexOf()` functionality for old IE (IE8 and below).
	 *
	 * @param {Array} arr The array to find an element of.
	 * @param {*} element The element to find in the array, and return the index of.
	 * @return {Number} The index of the `element`, or -1 if it was not found.
	 */
	function indexOf(arr, element) {
	    // @ts-ignore - As far as TypeScript is concerned, this method will always
	    // exist (lowest "lib" in TS is "ES5"). Hence we need to ignore this error
	    // to support IE8 which only implements ES3 and doesn't have this method
	    if (Array.prototype.indexOf) {
	        return arr.indexOf(element);
	    }
	    else {
	        for (var i = 0, len = arr.length; i < len; i++) {
	            if (arr[i] === element)
	                return i;
	        }
	        return -1;
	    }
	}
	exports.indexOf = indexOf;
	/**
	 * Removes array elements based on a filtering function. Mutates the input
	 * array.
	 *
	 * Using this instead of the ES5 Array.prototype.filter() function, to allow
	 * Autolinker compatibility with IE8, and also to prevent creating many new
	 * arrays in memory for filtering.
	 *
	 * @param {Array} arr The array to remove elements from. This array is
	 *   mutated.
	 * @param {Function} fn A function which should return `true` to
	 *   remove an element.
	 * @return {Array} The mutated input `arr`.
	 */
	function remove(arr, fn) {
	    for (var i = arr.length - 1; i >= 0; i--) {
	        if (fn(arr[i]) === true) {
	            arr.splice(i, 1);
	        }
	    }
	}
	exports.remove = remove;
	/**
	 * Performs the functionality of what modern browsers do when `String.prototype.split()` is called
	 * with a regular expression that contains capturing parenthesis.
	 *
	 * For example:
	 *
	 *     // Modern browsers:
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', ',', 'b', ',', 'c' ]
	 *
	 *     // Old IE (including IE8):
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', 'b', 'c' ]
	 *
	 * This method emulates the functionality of modern browsers for the old IE case.
	 *
	 * @param {String} str The string to split.
	 * @param {RegExp} splitRegex The regular expression to split the input `str` on. The splitting
	 *   character(s) will be spliced into the array, as in the "modern browsers" example in the
	 *   description of this method.
	 *   Note #1: the supplied regular expression **must** have the 'g' flag specified.
	 *   Note #2: for simplicity's sake, the regular expression does not need
	 *   to contain capturing parenthesis - it will be assumed that any match has them.
	 * @return {String[]} The split array of strings, with the splitting character(s) included.
	 */
	function splitAndCapture(str, splitRegex) {
	    if (!splitRegex.global)
	        throw new Error("`splitRegex` must have the 'g' flag set");
	    var result = [], lastIdx = 0, match;
	    while ((match = splitRegex.exec(str))) {
	        result.push(str.substring(lastIdx, match.index));
	        result.push(match[0]); // push the splitting char(s)
	        lastIdx = match.index + match[0].length;
	    }
	    result.push(str.substring(lastIdx));
	    return result;
	}
	exports.splitAndCapture = splitAndCapture;
	/**
	 * Function that should never be called but is used to check that every
	 * enum value is handled using TypeScript's 'never' type.
	 */
	function throwUnhandledCaseError(theValue) {
	    throw new Error("Unhandled case for value: '".concat(theValue, "'"));
	}
	exports.throwUnhandledCaseError = throwUnhandledCaseError;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 489 */,
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _constants = __webpack_require__(17);
	
	var _getVisitTypeName = __webpack_require__(436);
	
	var _getVisitTypeName2 = _interopRequireDefault(_getVisitTypeName);
	
	var _VisitOverview = __webpack_require__(1706);
	
	var _VisitOverview2 = _interopRequireDefault(_VisitOverview);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmedIcon = __webpack_require__(3308);
	
	var _ConfirmedIcon2 = _interopRequireDefault(_ConfirmedIcon);
	
	var _appointment = __webpack_require__(286);
	
	var _useAppointmentTitle = __webpack_require__(3370);
	
	var _VideoVisitBtn = __webpack_require__(491);
	
	var _VideoVisitBtn2 = _interopRequireDefault(_VideoVisitBtn);
	
	var _ConfirmVisitByPatientBtn = __webpack_require__(1122);
	
	var _ConfirmVisitByPatientBtn2 = _interopRequireDefault(_ConfirmVisitByPatientBtn);
	
	var _NameWithAvatar = __webpack_require__(3323);
	
	var _NameWithAvatar2 = _interopRequireDefault(_NameWithAvatar);
	
	var _AppointmentPaymentForm = __webpack_require__(1121);
	
	var _AppointmentPaymentForm2 = _interopRequireDefault(_AppointmentPaymentForm);
	
	var _AppointmentHeader = __webpack_require__(3306);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _AppointmentFooter = __webpack_require__(3305);
	
	var _AppointmentFooter2 = _interopRequireDefault(_AppointmentFooter);
	
	var _EirVisitTypeHeaderTopSection = __webpack_require__(3310);
	
	var _EirVisitTypeHeaderTopSection2 = _interopRequireDefault(_EirVisitTypeHeaderTopSection);
	
	var _useDetailsRows2 = __webpack_require__(3312);
	
	var _enhance = __webpack_require__(3311);
	
	var _useVirtualVisitGuard = __webpack_require__(1763);
	
	var _checkForIsSignedAllConsents = __webpack_require__(767);
	
	var _selectors = __webpack_require__(23);
	
	var _useInfoConsentWithAppointments = __webpack_require__(1126);
	
	var _testCall = __webpack_require__(535);
	
	var _styles = __webpack_require__(2248);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _GoogleMaps = __webpack_require__(765);
	
	var _GoogleMaps2 = _interopRequireDefault(_GoogleMaps);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTIVE_STATUSES = [_constants.APPOINTMENT_STATUSES.DRAFT, _constants.APPOINTMENT_STATUSES.WAITING, _constants.APPOINTMENT_STATUSES.UPCOMING, _constants.APPOINTMENT_STATUSES.IN_PROCESS];
	
	var COMPLETED_STATUSES = [_constants.APPOINTMENT_STATUSES.NO_SHOW, _constants.APPOINTMENT_STATUSES.DECLINED, _constants.APPOINTMENT_STATUSES.CANCELED, _constants.APPOINTMENT_STATUSES.COMPLETED];
	
	function AppointmentDetailsPopup(_ref) {
	  var pendingManageReq = _ref.pendingManageReq,
	      managePendingRequest = _ref.managePendingRequest,
	      checkingPending = _ref.checkingPending,
	      providerContext = _ref.providerContext,
	      providerView = _ref.providerView,
	      onStartVideoVisit = _ref.onStartVideoVisit,
	      completeVisit = _ref.completeVisit,
	      noShowVisit = _ref.noShowVisit,
	      isCouponAvailable = _ref.isCouponAvailable,
	      paymentVerificationPending = _ref.paymentVerificationPending,
	      cancelVirtualVisit = _ref.cancelVirtualVisit,
	      globalPaymentPending = _ref.globalPaymentPending,
	      clearCouponVerification = _ref.clearCouponVerification,
	      testCallPerformed = _ref.testCallPerformed,
	      openConsentModal = _ref.openConsentModal,
	      cancelPending = _ref.cancelPending,
	      appointment = _ref.appointment,
	      isUpcoming = _ref.isUpcoming,
	      verifyCoupon = _ref.verifyCoupon,
	      opened = _ref.opened,
	      onClose = _ref.onClose,
	      checkIn = _ref.checkIn,
	      cancel = _ref.cancel,
	      userId = _ref.userId;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isShowOnLocation = _useState2[0],
	      setIsShowOnLocation = _useState2[1];
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var concentInfo = (0, _useInfoConsentWithAppointments.useInfoConsentWithAppointments)(providerContext, appointment || {});
	  var isProvider = (0, _reactRedux.useSelector)(_selectors.hasProviderProfileSelector);
	
	  var _ref2 = appointment || {},
	      copay = _ref2.copay,
	      visitType = _ref2.visitType,
	      paymentStatus = _ref2.paymentStatus,
	      appointmentId = _ref2.id;
	
	  var virtualVisitGuard = (0, _useVirtualVisitGuard.useVirtualVisitGuard)({
	    appointment: appointment,
	    isUpcoming: isUpcoming
	  });
	
	  var appointmentStatus = (0, _get2.default)(appointment, 'status.coreAppName', '');
	  var visitTypeCode = (0, _get2.default)(visitType, 'code');
	  var visitName = (0, _get2.default)(visitType, 'name');
	  var isConfirmedByPatient = (0, _get2.default)(appointment, 'confirmed');
	  var prohibitConfirmationForPatientByReasonType = (0, _get2.default)(appointment, 'reasonType.prohibitConfirmationForPatient', false);
	  var prescribedMedications = (0, _get2.default)(appointment, 'ccdMedications', []);
	  var isConfirmByPatientEnabled = (0, _get2.default)(appointment, 'canConfirmVisit');
	  var isJoinVirtualVisitByCode = (0, _get2.default)(appointment, 'service.joinVirtualVisitByCode');
	  var isPaid = paymentStatus === _constants.PAYMENT_STATUSES.PAID;
	  var isVoided = paymentStatus === _constants.PAYMENT_STATUSES.VOIDED;
	
	  var isUpcomingAppointmentStatus = appointmentStatus === _constants.APPOINTMENT_STATUSES.UPCOMING;
	  var isStatusAppointmentUpcomingOrInProcess = ACTIVE_STATUSES.includes(appointmentStatus);
	  var isPendingStatus = appointmentStatus === _constants.APPOINTMENT_STATUSES.PENDING;
	  var isInlineVisit = _constants.INLINE_TYPES.includes(visitTypeCode);
	  var isEirVisitType = _constants.EIR_APPOINTMENT_TYPES.includes(visitTypeCode);
	  var isSafeStatusAppointment = isStatusAppointmentUpcomingOrInProcess || isUpcoming;
	
	  var _appointmentTargetUse = (0, _appointment.appointmentTargetUserAdapter)(appointment, providerView),
	      provider = _appointmentTargetUse.provider;
	
	  var isVirtualVisit = visitTypeCode === _constants.VIRTUAL_VISIT_TYPE_CODE;
	  var isUrgentVisit = visitTypeCode === _constants.URGENT_VISIT_TYPE_CODE;
	  var isTelemedicineVisit = visitTypeCode === _constants.TELEMEDICINE_VISIT_TYPE_CODE;
	  var patientAllowedStart = (0, _get2.default)(appointment, 'allowedActions.patientStart');
	
	  var titleData = (0, _react.useMemo)(function () {
	    return (0, _useAppointmentTitle.useAppointmentTitle)({
	      appointment: appointment,
	      formatMessage: formatMessage,
	      providerView: providerView,
	      detailsView: true
	    });
	  }, [appointment, providerView]);
	
	  var joinVirtualVisitByCodeMessage = (0, _react.useMemo)(function () {
	    if (!isJoinVirtualVisitByCode) return '';
	
	    return _react2.default.createElement(
	      'div',
	      { className: _styles2.default.joinVirtualVisitText },
	      formatMessage({ id: 'virtualVisit.joinVirtualVisit' })
	    );
	  }, [isJoinVirtualVisitByCode]);
	
	  var appointmentStatusName = isInlineVisit && isUpcomingAppointmentStatus ? formatMessage({ id: 'appointment.list.tabs.inLine' }) : appointmentStatus;
	
	  var visitTypeName = (0, _getVisitTypeName2.default)({
	    sourceOfCreation: (0, _get2.default)(appointment, 'sourceOfCreation'),
	    defaultValue: visitName,
	    formatMessage: formatMessage,
	    visitTypeCode: visitTypeCode
	  });
	
	  // todo: check visitTypeCode !== TECH_CONNECT_CODE
	  var title = (0, _react.useMemo)(function () {
	    return formatMessage({ id: 'appointment.popup.title' }, { status: appointmentStatusName, visitType: visitTypeName });
	  }, [appointmentStatusName, visitTypeName]);
	
	  var _useDetailsRows = (0, _useDetailsRows2.useDetailsRows)({
	    provider: provider,
	    appointment: appointment,
	    formatMessage: formatMessage,
	    isUrgentVisit: isUrgentVisit,
	    providerContext: providerContext,
	    prescribedMedications: prescribedMedications,
	    isUpcoming: isSafeStatusAppointment || isPendingStatus
	  }),
	      rows = _useDetailsRows.rows;
	
	  var handleCheckIn = function handleCheckIn() {
	    var isSignedAllConsents = (0, _checkForIsSignedAllConsents.checkForIsSignedAllConsents)(appointment);
	
	    if (!isSignedAllConsents) {
	      openConsentModal({
	        patientUserInfoId: (0, _get2.default)(concentInfo, 'patientUserInfoId'),
	        organizationName: (0, _get2.default)(concentInfo, 'organizationName'),
	        consent: (0, _get2.default)(concentInfo, 'notSignedConsent'),
	        serviceName: (0, _get2.default)(concentInfo, 'serviceName'),
	        allConsents: (0, _get2.default)(concentInfo, 'allConsents'),
	        startTime: (0, _get2.default)(concentInfo, 'dateTime')
	      });
	    } else {
	      checkIn({ userId: userId, appointmentId: appointmentId });
	    }
	  };
	
	  var handleCancel = function handleCancel() {
	    if (isVirtualVisit || isUrgentVisit) {
	      cancelVirtualVisit(userId, appointment);
	    } else {
	      cancel({ userId: userId, appointmentId: appointmentId });
	    }
	  };
	
	  var handlePayment = function handlePayment() {
	    return verifyCoupon({ userId: userId, appointmentId: appointmentId });
	  };
	  var closeDiscount = function closeDiscount() {
	    return clearCouponVerification();
	  };
	  var handleVideoVisit = function handleVideoVisit() {
	    return onStartVideoVisit(appointment);
	  };
	  var handleNoShow = function handleNoShow() {
	    return noShowVisit(userId, appointment);
	  };
	  var handleComplete = function handleComplete() {
	    return completeVisit(userId, appointment);
	  };
	  var handleClose = function handleClose() {
	    closeDiscount();
	    onClose();
	  };
	
	  var handleStartVideoVisit = function handleStartVideoVisit() {
	    if (isUrgentVisit || testCallPerformed) {
	      return handleVideoVisit();
	    }
	
	    return handleOpenTestCall();
	  };
	
	  var handleOpenTestCall = function handleOpenTestCall() {
	    dispatch(_testCall.testCallActions.init({
	      onStartVideoVisit: handleVideoVisit,
	      virtualCallEnabled: patientAllowedStart
	    }));
	  };
	
	  var handleAcceptDeclineRequest = function handleAcceptDeclineRequest(type) {
	    var payload = type === _constants.APPOINTMENT_REQUEST_STATUS.DECLINED ? {
	      event: _constants.VIRTUAL_VISIT_EVENTS.DECLINE_VISIT,
	      reason: 'declined',
	      id: userId,
	      appointmentId: appointmentId
	    } : { id: userId, appointmentId: appointmentId, event: 'confirm_visit' };
	    managePendingRequest(payload);
	    onClose();
	  };
	
	  var renderTestButton = function renderTestButton() {
	    var checkCallBtn = isUpcomingAppointmentStatus && virtualVisitGuard.showVisitBtn && !isJoinVirtualVisitByCode && _react2.default.createElement(
	      _Button2.default,
	      {
	        onClick: handleOpenTestCall,
	        className: _styles2.default.visitDetails,
	        color: 'accent'
	      },
	      formatMessage({ id: 'virtualVisit.test.check' })
	    );
	
	    var confirmButton = isUpcomingAppointmentStatus && isConfirmByPatientEnabled && !prohibitConfirmationForPatientByReasonType && !isProvider && _react2.default.createElement(_ConfirmVisitByPatientBtn2.default, {
	      userId: appointment.userId,
	      appointmentId: appointment.id,
	      type: 'primary'
	    });
	
	    if (!checkCallBtn && !confirmButton && !isJoinVirtualVisitByCode && virtualVisitGuard.hasMandatoryPaymentWarning) {
	      return _react2.default.createElement(
	        'span',
	        { className: _styles2.default.confirmedStatusTitle },
	        formatMessage({ id: 'appointment.actions.startVisit.warning' })
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _styles2.default.btns },
	      checkCallBtn,
	      joinVirtualVisitByCodeMessage,
	      confirmButton
	    );
	  };
	
	  var renderHeader = (0, _react.useCallback)(function () {
	    if (isPendingStatus) {
	      return providerContext ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.pendingActionButtonWrapper },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: _styles2.default.declineButton,
	            raised: true,
	            disabled: pendingManageReq,
	            color: 'accent',
	            onClick: function onClick() {
	              return handleAcceptDeclineRequest(_constants.APPOINTMENT_REQUEST_STATUS.DECLINED);
	            }
	          },
	          formatMessage({ id: 'common.decline' })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: _styles2.default.confirmButton,
	            raised: true,
	            disabled: pendingManageReq,
	            color: 'primary',
	            onClick: function onClick() {
	              return handleAcceptDeclineRequest(_constants.APPOINTMENT_REQUEST_STATUS.CONFIRMED);
	            }
	          },
	          formatMessage({ id: 'submit.fillProfile' })
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { className: _styles2.default.pendingMessage },
	        formatMessage({
	          id: 'appointment.details.pendingMessage.visit.title'
	        })
	      );
	    }
	
	    if (isUrgentVisit && isStatusAppointmentUpcomingOrInProcess && (isPaid || !copay) || (isVirtualVisit || isTelemedicineVisit) && isSafeStatusAppointment && !providerContext) {
	      var visitReady = isUrgentVisit || isTelemedicineVisit || patientAllowedStart;
	
	      if (visitReady) {
	        if (virtualVisitGuard.hasMandatoryPaymentWarning) {
	          return _react2.default.createElement(
	            'span',
	            { className: _styles2.default.confirmedStatusTitle },
	            formatMessage({ id: 'appointment.actions.startVisit.warning' })
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          isJoinVirtualVisitByCode ? joinVirtualVisitByCodeMessage : _react2.default.createElement(_VideoVisitBtn2.default, {
	            type: 'primary',
	            onStartVideoVisit: handleStartVideoVisit,
	            title: isUrgentVisit ? 'common.joinVisit' : ''
	          })
	        );
	      }
	
	      return renderTestButton();
	    }
	
	    return _react2.default.createElement(_AppointmentHeader2.default, {
	      onComplete: handleComplete,
	      onNoShow: handleNoShow,
	      providerContext: providerContext,
	      formatMessage: formatMessage,
	      appointment: appointment,
	      disabled: checkingPending,
	      onCheckIn: handleCheckIn,
	      hasMandatoryPaymentWarning: virtualVisitGuard.hasMandatoryPaymentWarning
	    });
	  }, [appointment, checkingPending, providerContext, pendingManageReq, isSafeStatusAppointment, isJoinVirtualVisitByCode, joinVirtualVisitByCodeMessage]);
	
	  var renderFooter = (0, _react.useCallback)(function () {
	    if (!isUrgentVisit && appointmentStatus === _constants.APPOINTMENT_STATUSES.DECLINED) return null;
	
	    if (!isPaid && !isVoided && COMPLETED_STATUSES.includes(appointmentStatus)) return null;
	
	    if (paymentVerificationPending) return _react2.default.createElement(_Loader2.default, null);
	
	    return _react2.default.createElement(_AppointmentFooter2.default, {
	      providerContext: providerContext,
	      formatMessage: formatMessage,
	      appointment: appointment,
	      disabled: cancelPending,
	      handleVideoVisit: handleStartVideoVisit,
	      onCancel: handleCancel,
	      onPayNow: handlePayment,
	      handleOpenTestCall: handleOpenTestCall,
	      renderTestButton: renderTestButton,
	      isPendingStatus: isPendingStatus
	    });
	  }, [appointment, cancelPending, paymentVerificationPending, providerContext]);
	
	  var renderAvatar = (0, _react.useCallback)(function () {
	    if (isEirVisitType) {
	      return _react2.default.createElement(_EirVisitTypeHeaderTopSection2.default, { appointment: appointment });
	    }
	
	    return _react2.default.createElement(_NameWithAvatar2.default, (0, _extends3.default)({ avatarSize: 44 }, titleData));
	  }, [titleData, isEirVisitType, appointment]);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      contentNoPadding: true,
	      opened: opened,
	      onClose: handleClose,
	      withHeading: false,
	      disableFillBackground: true,
	      mobileFullScreen: false,
	      overflowVisible: true
	    },
	    appointment && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.root },
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_styles2.default.content, (0, _defineProperty3.default)({}, _styles2.default.eirVisitContent, isEirVisitType))
	        },
	        _react2.default.createElement('div', { className: _styles2.default.coverHeader, onClick: handleClose }),
	        _react2.default.createElement(_BackButton2.default, {
	          onBack: handleClose,
	          className: _styles2.default.backButton,
	          minWidth: 0
	        }),
	        !isEirVisitType && _react2.default.createElement(
	          'div',
	          { className: _styles2.default.title },
	          title,
	          isConfirmedByPatient && _react2.default.createElement(_ConfirmedIcon2.default, null)
	        ),
	        !isCouponAvailable && _react2.default.createElement(
	          'div',
	          { className: _styles2.default.visitDetails },
	          _react2.default.createElement(_VisitOverview2.default, {
	            openLocationModal: setIsShowOnLocation,
	            isInlineVisit: isInlineVisit,
	            loading: globalPaymentPending,
	            renderAvatar: renderAvatar,
	            renderHeader: renderHeader,
	            renderBtn: renderFooter,
	            withTopPositionDefault: true,
	            rows: rows
	          }),
	          _react2.default.createElement(
	            _Popup2.default,
	            {
	              strictClose: true,
	              opened: isShowOnLocation,
	              onClose: function onClose() {
	                return setIsShowOnLocation(false);
	              },
	              title: formatMessage({
	                id: 'googleMaps.popup.title.locations'
	              }),
	              mobileFullScreen: false,
	              overflowVisible: true,
	              withoutAdaptive: true
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.width },
	              _react2.default.createElement(_GoogleMaps2.default, { isAppointment: true, isUpcoming: isUpcoming })
	            )
	          )
	        ),
	        isCouponAvailable && _react2.default.createElement(_AppointmentPaymentForm2.default, {
	          paymentPending: globalPaymentPending,
	          formatMessage: formatMessage,
	          appointment: appointment,
	          onBack: closeDiscount
	        })
	      )
	    )
	  );
	}
	
	AppointmentDetailsPopup.propTypes = {
	  checkingPending: PropTypes.bool,
	  cancelPending: PropTypes.bool,
	  globalPaymentPending: PropTypes.bool,
	  paymentVerificationPending: PropTypes.bool,
	  isCouponAvailable: PropTypes.bool,
	  clearCouponVerification: PropTypes.func,
	  onStartVideoVisit: PropTypes.func,
	  cancelVirtualVisit: PropTypes.func,
	  verifyCoupon: PropTypes.func,
	  onClose: PropTypes.func,
	  checkIn: PropTypes.func,
	  cancel: PropTypes.func,
	  appointment: PropTypes.object,
	  providerContext: PropTypes.bool,
	  providerView: PropTypes.bool,
	  isUpcoming: PropTypes.bool,
	  opened: PropTypes.bool,
	  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  completeVisit: PropTypes.func,
	  noShowVisit: PropTypes.func,
	  testCallPerformed: PropTypes.bool,
	  pendingManageReq: PropTypes.bool,
	  managePendingRequest: PropTypes.func,
	  openConsentModal: PropTypes.func
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentDetailsPopup);

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styles = __webpack_require__(4984);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoVisitBtn(_ref) {
	  var onStartVideoVisit = _ref.onStartVideoVisit,
	      title = _ref.title,
	      type = _ref.type,
	      disabled = _ref.disabled;
	
	  var handleVideoStart = function handleVideoStart(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    onStartVideoVisit(e);
	  };
	
	  return _react2.default.createElement(
	    _Button2.default,
	    {
	      styleName: (0, _classnames2.default)('video-btn', type, { disabled: disabled }),
	      onClick: handleVideoStart,
	      color: type,
	      border: true
	    },
	    _react2.default.createElement(_Icon2.default, { name: 'icon-video', size: 24 }),
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: title || 'appointment.list.card.startVisit' })
	  );
	}
	
	VideoVisitBtn.propTypes = {
	  onStartVideoVisit: PropTypes.func,
	  type: PropTypes.string,
	  title: PropTypes.string,
	  disabled: PropTypes.bool
	};
	
	VideoVisitBtn.defaultProps = {
	  type: 'accent'
	};
	
	exports.default = (0, _reactCssModules2.default)(VideoVisitBtn, _styles2.default, { allowMultiple: true });

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MultipleOutcomesMenu = __webpack_require__(3340);
	
	var _MultipleOutcomesMenu2 = _interopRequireDefault(_MultipleOutcomesMenu);
	
	var _index = __webpack_require__(4986);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignConsentButton = function SignConsentButton(_ref) {
	  var buttonAccept = _ref.buttonAccept,
	      handleAcceptConsent = _ref.handleAcceptConsent,
	      isConsentHasMultipleOutcomes = _ref.isConsentHasMultipleOutcomes,
	      isSignConsentLoading = _ref.isSignConsentLoading,
	      titles = _ref.titles;
	
	  return _react2.default.createElement(
	    _MultipleOutcomesMenu2.default,
	    {
	      titles: titles,
	      isConsentHasMultipleOutcomes: isConsentHasMultipleOutcomes
	    },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: _index2.default.acceptButton,
	        onClick: handleAcceptConsent,
	        border: !isSignConsentLoading,
	        color: 'primary',
	        disabled: isSignConsentLoading
	      },
	      buttonAccept
	    )
	  );
	};
	
	SignConsentButton.propTypes = {
	  buttonAccept: _propTypes2.default.string,
	  handleAcceptConsent: _propTypes2.default.func,
	  isConsentHasMultipleOutcomes: _propTypes2.default.bool,
	  isSignConsentLoading: _propTypes2.default.bool,
	  titles: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	exports.default = SignConsentButton;

/***/ }),
/* 493 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STATUS_SURVEY = exports.STATUS_SURVEY = {
	  EXPIRED: 'expired',
	  COMPLETED: 'completed',
	  UPCOMING: 'upcoming'
	};
	
	var SURVEY_TYPES = exports.SURVEY_TYPES = {
	  PROGRAM: 'program',
	  PRE_VISIT: 'pre_visit',
	  PROVIDER_POST_VISIT: 'provider_post_visit',
	  APPOINTMENT_SATISFACTION: 'appointment_satisfaction'
	};

/***/ }),
/* 494 */,
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useLabTestHistoryContext = exports.LabTestHistoryContext = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabTestHistoryContext = exports.LabTestHistoryContext = (0, _react.createContext)();
	var useLabTestHistoryContext = exports.useLabTestHistoryContext = function useLabTestHistoryContext() {
	  return (0, _react.useContext)(LabTestHistoryContext);
	};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.getSystemError = getSystemError;
	
	var _lodash = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (errors) {
	  var errorMessage = (0, _lodash.get)(errors, 'description');
	  var dataErrors = (0, _lodash.get)(errors, 'meta.validationErrors', {});
	  return (0, _keys2.default)(dataErrors).reduce(function (acc, value) {
	    acc[value] = errorMessage;
	    return acc;
	  }, {});
	};
	
	function getSystemError(errors) {
	  return errors && (0, _lodash.isEmpty)(errors.meta) && errors.description;
	}

/***/ }),
/* 497 */,
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class; /* eslint-disable react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(58);
	
	var _handleDOB = __webpack_require__(909);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _strings = __webpack_require__(15);
	
	var _ids = __webpack_require__(46);
	
	var _index = __webpack_require__(5194);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DateDropdown = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = function (_Component) {
	  (0, _inherits3.default)(DateDropdown, _Component);
	
	  function DateDropdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DateDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDropdown.__proto__ || (0, _getPrototypeOf2.default)(DateDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      month: '01',
	      day: '01',
	      year: '1980'
	    }, _this.getDate = function () {
	      var _this$state = _this.state,
	          month = _this$state.month,
	          day = _this$state.day,
	          year = _this$state.year;
	      var onChange = _this.props.onChange;
	
	
	      var updateValue = year && month && day ? year + '-' + month + '-' + day : null;
	      onChange(updateValue);
	    }, _this.handleSelect = function (value, key) {
	      _this.setState((0, _defineProperty3.default)({}, key, value ? value.value : value), function () {
	        return _this.getDate();
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DateDropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var value = this.props.value;
	
	
	      if (value) {
	        var parts = value.split('-');
	        this.setState({ year: parts[0], month: parts[1], day: parts[2] });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = this.props.value;
	
	      if (nextProps.value !== value && nextProps.value === '') {
	        this.setState(function (state) {
	          return (0, _lodash.mapValues)(state, function () {
	            return null;
	          });
	        });
	      }
	      if (nextProps.value && nextProps.value !== value) {
	        var parts = nextProps.value.split('-');
	        this.setState({ year: parts[0], month: parts[1], day: parts[2] });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          year = _state.year,
	          month = _state.month,
	          day = _state.day;
	      var _props = this.props,
	          formatMessage = _props.intl.formatMessage,
	          required = _props.required,
	          className = _props.className,
	          disabled = _props.disabled,
	          endYear = _props.endYear,
	          labelMessageId = _props.labelMessageId;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'label',
	          { styleName: (0, _classnames2.default)('label', { required: required }) },
	          formatMessage(labelMessageId ? { id: labelMessageId } : _strings.PROFILE_FIELDS.fieldNames.dob)
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'picker-wrapper' },
	          _react2.default.createElement(_SelectCustom2.default, {
	            id: _ids.IDS.FORM_FIELDS.DOB.MONTH,
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.month),
	            name: 'month',
	            value: month,
	            options: (0, _handleDOB.getMonths)(year),
	            disabled: disabled,
	            onChange: function onChange(val) {
	              return _this2.handleSelect(val, 'month');
	            }
	          }),
	          _react2.default.createElement(_SelectCustom2.default, {
	            id: _ids.IDS.FORM_FIELDS.DOB.DAY,
	            disabled: !(year && month) || disabled,
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.day),
	            name: 'day',
	            value: day,
	            options: (0, _handleDOB.getDaysOfMonth)(year, month),
	            onChange: function onChange(val) {
	              return _this2.handleSelect(val, 'day');
	            }
	          }),
	          _react2.default.createElement(_SelectCustom2.default, {
	            id: _ids.IDS.FORM_FIELDS.DOB.YEAR,
	            placeholder: formatMessage(_strings.PROFILE_FIELDS.fieldNames.year),
	            name: 'year',
	            value: year,
	            options: (0, _handleDOB.getYearsInRange)(1900, endYear),
	            disabled: disabled,
	            onChange: function onChange(val) {
	              return _this2.handleSelect(val, 'year');
	            }
	          })
	        )
	      );
	    }
	  }]);
	  return DateDropdown;
	}(_react.Component)) || _class) || _class);
	exports.default = DateDropdown;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useSimpleForm = useSimpleForm;
	
	var _pick = __webpack_require__(466);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useSimpleForm(initialFields, validateFields, errors) {
	  var initialData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var initialState = (0, _useFormWithValidation.useInitialState)(initialFields);
	
	  var _useFormState = (0, _useFormWithValidation.useFormState)((0, _extends3.default)({}, initialState, (0, _pick2.default)(initialData, initialFields))),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var _useFormValidation = (0, _useFormWithValidation.useFormValidation)(errors),
	      validateErrors = _useFormValidation.validateErrors,
	      clearErrors = _useFormValidation.clearErrors;
	
	  var isValid = (0, _useFormWithValidation.makeRequiredFieldsValidator)(validateFields)(formState);
	
	  return {
	    formState: formState,
	    handleFormChange: handleFormChange,
	    validateErrors: validateErrors,
	    clearErrors: clearErrors,
	    isValid: isValid
	  };
	}

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(5242);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ValidationError = function ValidationError(_ref) {
	  var content = _ref.content,
	      style = _ref.style,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ styleName: 'error' }, { className: className, style: style }),
	    content
	  );
	};
	
	ValidationError.propTypes = {
	  content: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(ValidationError, _index2.default, { allowMultiple: true });

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _MENU_OPTIONS;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ids = __webpack_require__(46);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO use constants for object keys
	// TODO use common localisation for menu items
	var MENU_OPTIONS = (_MENU_OPTIONS = {
	  editPost: {
	    id: _ids.IDS.MENU.EDIT_POST,
	    text: { id: 'community.postMenu.editPost' },
	    icon: 'edit'
	  },
	  removePost: {
	    id: _ids.IDS.MENU.REMOVE_POST,
	    text: { id: 'community.postMenu.deletePost' },
	    icon: 'remove'
	  },
	  editComment: {
	    id: _ids.IDS.MENU.EDIT_COMMENT,
	    text: { id: 'community.commentMenu.editComment' },
	    icon: 'edit',
	    iconSize: '16px',
	    iconStyle: { top: '3px', width: '16px', height: '16px' }
	  },
	  removeComment: {
	    id: _ids.IDS.MENU.REMOVE_COMMENT,
	    text: { id: 'community.commentMenu.deleteComment' },
	    icon: 'remove',
	    iconSize: '16px',
	    iconStyle: { top: '3px', width: '16px', height: '16px' }
	  },
	  sendMessage: {
	    id: _ids.IDS.MENU.SEND_MESSAGE,
	    text: { id: 'chat.actions.sendMessage' },
	    icon: 'comment'
	  },
	  report: {
	    id: _ids.IDS.MENU.REPORT,
	    text: { id: 'community.menu.report' },
	    icon: 'report'
	  },
	  inviteToCommunity: {
	    id: _ids.IDS.MENU.INVITE_TO_COMMUNITY,
	    text: { id: 'community.menu.invitePeople' },
	    icon: 'report'
	  },
	  shareLink: {
	    id: _ids.IDS.MENU.SHARE_LINK,
	    text: { id: 'community.menu.shareLink' },
	    icon: 'attachment',
	    iconSize: 16,
	    iconStyle: { top: 3 }
	  },
	  leaveCommunity: {
	    id: _ids.IDS.MENU.LEAVE_COMMUNITY,
	    text: { id: 'community.menu.leaveCommunity' },
	    icon: 'leave',
	    iconSize: 16
	  }
	}, (0, _defineProperty3.default)(_MENU_OPTIONS, _constants.POPOVER_MENU_ITEMS.REMOVE_FROM_COMMUNITY, {
	  id: _ids.IDS.MENU.REMOVE_FROM_COMMUNITY,
	  text: { id: 'community.menu.removeMember' },
	  icon: 'remove-from-community'
	}), (0, _defineProperty3.default)(_MENU_OPTIONS, _constants.POPOVER_MENU_ITEMS.REMOVE_MEMBER, {
	  id: _ids.IDS.MENU.REMOVE_MEMBER,
	  text: { id: 'common.removeMember' },
	  icon: 'leave'
	}), (0, _defineProperty3.default)(_MENU_OPTIONS, 'editCommunity', {
	  id: _ids.IDS.MENU.EDIT_COMMUNITY,
	  text: { id: 'community.menu.editCommunity' },
	  icon: 'edit'
	}), (0, _defineProperty3.default)(_MENU_OPTIONS, _constants.POPOVER_MENU_ITEMS.CHANGE_ROLE, {
	  id: _ids.IDS.MENU.CHANGE_ROLE,
	  text: { id: 'common.changeRole' },
	  icon: 'change'
	}), (0, _defineProperty3.default)(_MENU_OPTIONS, _constants.POPOVER_MENU_ITEMS.UNASSIGN, {
	  id: _ids.IDS.MENU.UNASSIGN,
	  text: { id: 'common.unassign' },
	  icon: 'unassign'
	}), (0, _defineProperty3.default)(_MENU_OPTIONS, _constants.POPOVER_MENU_ITEMS.CANCEL_PENDING_INVITATION, {
	  text: { id: 'circles.invites.cancelInvite' },
	  icon: 'log-out'
	}), (0, _defineProperty3.default)(_MENU_OPTIONS, _constants.POPOVER_MENU_ITEMS.INVITE_PATIENT, {
	  text: { id: 'community.menu.invite' },
	  icon: 'add-member',
	  iconSize: 24
	}), (0, _defineProperty3.default)(_MENU_OPTIONS, _constants.POPOVER_MENU_ITEMS.REINVITE_PATIENT, {
	  text: { id: 'dialog.common.reinvite' },
	  icon: 'add-member',
	  iconSize: 24
	}), _MENU_OPTIONS);
	
	var withPopoverMenu = function withPopoverMenu(BaseComponent) {
	  return function (_ref) {
	    var formatMessage = _ref.intl.formatMessage,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['intl']);
	
	    var getMenuItems = function getMenuItems(options) {
	      var menu = [];
	
	      (0, _keys2.default)(options).forEach(function (key) {
	        var option = MENU_OPTIONS[key];
	        var item = options[key];
	
	        if (option && item) {
	          menu.push((0, _extends3.default)({}, option, {
	            text: formatMessage(option.text),
	            onClick: item
	          }));
	        }
	      });
	
	      return menu;
	    };
	
	    return _react2.default.createElement(BaseComponent, (0, _extends3.default)({}, props, { getMenuItems: getMenuItems }));
	  };
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, withPopoverMenu);

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.insuranceErrorModalActions = exports.INSURANCE_ERROR_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'appointment-form/insurance-error-modal';
	
	var INSURANCE_ERROR_MODAL = exports.INSURANCE_ERROR_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var insuranceErrorModalActions = exports.insuranceErrorModalActions = {
	  open: (0, _createAction.createAction)(INSURANCE_ERROR_MODAL.OPEN),
	  close: (0, _createAction.createAction)(INSURANCE_ERROR_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case INSURANCE_ERROR_MODAL.OPEN:
	      {
	        return {
	          opened: true,
	          entity: payload
	        };
	      }
	
	    case INSURANCE_ERROR_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, state, {
	          opened: false
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'visit-confirm-GW-req', ['SHOW_ERROR_ALERT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'appointments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'visit-confirm-selfScheduling-req', ['SHOW_ERROR_ALERT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'unscheduled', 'internal_appointments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          sending: true
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true,
	          data: payload
	        });
	      }
	
	    case consts.CLEAR:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    case _appointmentConsentModal.APPOINTMENT_CONSENTS_MODAL.CLOSE:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'consent-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['consents', {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'location_id',
	    selector: 'locationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'visit_type_code',
	    selector: 'visitTypeCode'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState);

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          sending: true
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: payload,
	          sending: false,
	          succeed: true
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'inline-visits-time-slots', ['SHOW_ERROR_ALERT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['capacity_available_time_slots', {
	    type: 'payload.query',
	    queryParameter: 'location_id',
	    selector: 'locationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'reason_type_id',
	    selector: 'reasonTypeId'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState);

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqBlockUser');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'chat',
	  type: 'post',
	  slug: ['blocked_users ']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqInvitePatient', ['CLEAR']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'patient_invitations',
	  type: 'post'
	});
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return _redux.initialState;
	
	    default:
	      return reqReducer(state, action);
	  }
	};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqUnblockUser');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'chat',
	  type: 'delete',
	  slug: ['blocked_users', { type: 'payload', selector: ['userId'] }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'cancelCaregiverInvitation');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'inverse_caregiver_invitations', {
	    type: 'payload',
	    selector: ['invitationId']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'cancelFamilyMemberInvitation'); /* eslint-disable */
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'inverse_family_member_invitations', {
	    type: 'payload',
	    selector: ['invitationId']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionsScope = 'CIRCLES/ACTIONS';
	
	var CIRCLE_ACTION_TYPES = exports.CIRCLE_ACTION_TYPES = {
	  INVITE_TO_FAMILY_CIRCLE: actionsScope + '/INVITE_TO_FAMILY_CIRCLE',
	  CHANGE_ROLE: actionsScope + '/CHANGE_ROLE',
	  REMOVE_MEMBER: actionsScope + '/REMOVE_MEMBER',
	  LEAVE_CIRCLE: actionsScope + '/LEAVE_CIRCLE',
	  ASSIGN_ROLE: actionsScope + '/ASSIGN_ROLE'
	};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'inviteCaregiver');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'caregivers', {
	    type: 'payload.query',
	    queryParameter: 'family_member_id',
	    selector: 'memberId'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'myFamilyCircle', ['REMOVE_ITEM', 'REMOVE_CAREGIVER_ROLE', 'ADD_INVITATION', 'REMOVE_INVITATION', 'ADD_CAREGIVER_INVITATION', 'REMOVE_CAREGIVER_INVITATION']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'family_circle',
	  type: 'get'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var removeCaregiverRole = function removeCaregiverRole(state, _ref) {
	  var id = _ref.id;
	
	  var list = (0, _get2.default)(state, 'familyMembers', []).map(function (item) {
	    if (item.id === id) {
	      return (0, _extends3.default)({}, item, { caregiver: false });
	    }
	    return item;
	  });
	
	  return (0, _extends3.default)({}, state, { familyMembers: [].concat((0, _toConsumableArray3.default)(list)) });
	};
	
	var removeFromCircle = function removeFromCircle(state, _ref2) {
	  var id = _ref2.id;
	
	  var familyMembers = (0, _arrayModify.removeArrayItem)((0, _get2.default)(state, 'familyMembers', []), 'id', id);
	
	  return (0, _extends3.default)({}, state, { familyMembers: familyMembers });
	};
	
	var addInvitation = function addInvitation(state, _ref3) {
	  var login = _ref3.login,
	      role = _ref3.role,
	      invitationId = _ref3.invitationId,
	      user = _ref3.user;
	
	  var pending = (0, _get2.default)(state, 'pendingInvitations', []);
	  var pendingInvitations = (0, _arrayModify.updateOrPush)(pending, { login: login }, { login: login, role: role, invitationId: invitationId, user: user });
	
	  return (0, _extends3.default)({}, state, { pendingInvitations: pendingInvitations });
	};
	
	var removeInvitation = function removeInvitation(state, _ref4) {
	  var invitationId = _ref4.invitationId;
	
	  var pendingInvitations = (0, _arrayModify.removeArrayItem)((0, _get2.default)(state, 'pendingInvitations', []), 'invitationId', invitationId);
	
	  return (0, _extends3.default)({}, state, { pendingInvitations: pendingInvitations });
	};
	
	var addCaregiverInvitation = function addCaregiverInvitation(state, _ref5) {
	  var userId = _ref5.userId,
	      invitationId = _ref5.invitationId;
	
	  var prevFamilyMembers = (0, _get2.default)(state, 'familyMembers', []);
	
	  var updateValues = {
	    pendingCaregiver: true,
	    invitationId: invitationId,
	    userId: userId
	  };
	
	  var familyMembers = (0, _arrayModify.updateArrayItem)(prevFamilyMembers, { id: userId }, updateValues);
	  var pendingCaregivers = (0, _get2.default)(state, 'pendingCaregivers', []);
	  pendingCaregivers.push({ userId: userId, invitationId: invitationId });
	
	  return (0, _extends3.default)({}, state, { pendingCaregivers: pendingCaregivers, familyMembers: familyMembers });
	};
	
	var removeCaregiverInvitation = function removeCaregiverInvitation(state, _ref6) {
	  var invitationId = _ref6.invitationId;
	
	  var updateValues = {
	    pendingCaregiver: false,
	    invitationId: undefined
	  };
	
	  var prevPending = (0, _get2.default)(state, 'pendingCaregivers', []);
	  var prevFamilyMembers = (0, _get2.default)(state, 'familyMembers', []);
	
	  var pendingCaregivers = (0, _arrayModify.removeArrayItem)(prevPending, 'invitationId', invitationId);
	  var familyMembers = (0, _arrayModify.updateArrayItem)(prevFamilyMembers, { invitationId: invitationId }, updateValues);
	
	  return (0, _extends3.default)({}, state, { pendingCaregivers: pendingCaregivers, familyMembers: familyMembers });
	};
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.REMOVE_ITEM:
	      return removeFromCircle(state, payload);
	    case consts.REMOVE_CAREGIVER_ROLE:
	      return removeCaregiverRole(state, payload);
	    case consts.ADD_INVITATION:
	      return addInvitation(state, payload);
	    case consts.REMOVE_INVITATION:
	      return removeInvitation(state, payload);
	    case consts.ADD_CAREGIVER_INVITATION:
	      return addCaregiverInvitation(state, payload);
	    case consts.REMOVE_CAREGIVER_INVITATION:
	      return removeCaregiverInvitation(state, payload);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'removeAssignedProvider', ['START_SAGA', 'STOP_SAGA']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    queryParameter: 'user_id',
	    selector: ['userId']
	  }, 'assigned_providers', {
	    type: 'payload',
	    queryParameter: 'provider_profile_id',
	    selector: ['providerId']
	  }]
	});
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	  var defaultState = reqReducer(state, action);
	
	  switch (type) {
	    case consts.SEND:
	      return (0, _extends3.default)({}, defaultState, {
	        removedContextUserId: action.payload.userId
	      });
	    default:
	      return defaultState;
	  }
	};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var supportedActions = ['GET_MEMBERS', 'GET_NEW_MEMBERS', 'GET_OLDER_MEMBERS', 'CLEAR_MEMBERS'];
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'communityMembers', supportedActions);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'members', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var supportedActions = ['GET_MODERATORS', 'GET_OLDER_MODERATORS', 'CLEAR_MODERATORS'];
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'communityModerators', supportedActions);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'moderators', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'decline-com-invite');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'member_invitations',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _locationReducer = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['HIDE', 'SHOW', 'SET_TIMER', 'STOP_TIMER'];
	
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['communities', 'joinPopup'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  visible: false,
	  secondaryContentVisible: false,
	  content: '',
	  timer: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    visible: false
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SHOW:
	      return (0, _extends3.default)({}, state, {
	        visible: true,
	        content: action.payload.content
	      });
	    case consts.HIDE:
	      return (0, _extends3.default)({}, state, {
	        visible: false,
	        content: ''
	      });
	    case consts.SET_TIMER:
	      return (0, _extends3.default)({}, state, {
	        timer: true
	      });
	    case consts.STOP_TIMER:
	      return (0, _extends3.default)({}, state, {
	        timer: false
	      });
	    case _locationReducer.LOCATION_CHANGE:
	      return initialState;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginatedWatcher = exports.watcher = exports.paginatedActions = exports.actions = exports.paginatedConsts = exports.consts = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(58);
	
	var _constants = __webpack_require__(17);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paginationInitialState = {
	  global: {
	    offset: 0,
	    limit: 4
	  },
	  organization: {
	    offset: 0,
	    limit: 4
	  }
	};
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  pagination: paginationInitialState
	});
	
	var request = {
	  endpoint: 'communities',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'type',
	    selector: 'type'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'reqDiscoverCommunities', ['UPDATE_COMMUNITY']);
	var paginatedConsts = exports.paginatedConsts = (0, _redux.createReqConsts)('communities', 'reqPaginatedDiscoverCommunities', ['LOAD_NEXT_COMMUNITIES', 'UPDATE_PAGINATION_PARAMETERS']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var paginatedActions = exports.paginatedActions = (0, _redux.createActions)(paginatedConsts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, request);
	
	var paginatedWatcher = exports.paginatedWatcher = (0, _redux.createReqWatcher)(paginatedConsts, paginatedActions, request);
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload;
	
	
	  switch (action.type) {
	    case consts.SUCCEED:
	      {
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true
	        }, (0, _lodash.groupBy)(payload, 'accessScope'));
	      }
	    case consts.UPDATE_COMMUNITY:
	      {
	        var _action$payload = action.payload,
	            id = _action$payload.id,
	            accessScope = _action$payload.accessScope;
	
	        var prevCommunitiesList = (0, _lodash.get)(state, accessScope, []);
	        var updatedCommunitiesList = prevCommunitiesList.map(function (community) {
	          if (id === community.id) {
	            return payload;
	          }
	          return community;
	        });
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true
	        }, (0, _defineProperty3.default)({}, accessScope, updatedCommunitiesList));
	      }
	    case paginatedConsts.SUCCEED:
	      {
	        var _groupBy = (0, _lodash.groupBy)(payload, 'accessScope'),
	            _groupBy$global = _groupBy.global,
	            global = _groupBy$global === undefined ? [] : _groupBy$global,
	            _groupBy$organization = _groupBy.organization,
	            organization = _groupBy$organization === undefined ? [] : _groupBy$organization;
	
	        var prevGlobal = (0, _lodash.get)(state, [_constants.DISCOVERY_LIST_TYPES.GLOBAL], []);
	        var prevOrganization = (0, _lodash.get)(state, [_constants.DISCOVERY_LIST_TYPES.ORGANIZATION], []);
	
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true,
	          global: prevGlobal.concat(global),
	          organization: prevOrganization.concat(organization)
	        });
	      }
	    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS:
	      {
	        var type = payload.type,
	            offset = payload.offset,
	            limit = payload.limit;
	
	
	        return (0, _lodash.merge)({}, state, {
	          pagination: (0, _defineProperty3.default)({}, type, { offset: offset, limit: limit })
	        });
	      }
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'reqJoinCommunity');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'join_requests',
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestOptions = {
	  endpoint: 'complaint_notifications',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'status',
	    selector: 'status'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('complaints', 'resolved-list', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('complaints', 'resolved-list-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  pagination: { offset: 0, limit: 10 }
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          sending: !action.payload.silent
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          succeed: true,
	          list: action.payload
	        });
	      }
	
	    case paginationConsts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: [].concat((0, _toConsumableArray3.default)(state.list), (0, _toConsumableArray3.default)(action.payload))
	        });
	      }
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _logout = __webpack_require__(198);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['ADD', 'UPDATE', 'REMOVE'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['context', 'loggedUser'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	// retrieved data
	var user = window.storage.getItem('user');
	var initialState = user ? JSON.parse(user) : {};
	
	var addUser = function addUser(state, payload) {
	  return (0, _get2.default)(payload, 'user') || (0, _get2.default)(payload, 'authentication.user') || payload || {};
	};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	  switch (type) {
	    case consts.ADD:
	      return addUser(state, payload);
	    case consts.UPDATE:
	      return payload;
	    case consts.REMOVE:
	    case _logout.consts.CLEAR:
	      return {};
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _editPaymentReq = __webpack_require__(349);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'appointment-details-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dashboard',
	  type: 'get',
	  slug: ['appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  appointment: {},
	  appointmentId: null
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: true,
	          appointmentId: payload.appointmentId
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          appointment: payload,
	          appointmentId: null
	        });
	      }
	
	    case _editPaymentReq.consts.SUCCEED:
	      {
	        var target = state.appointment.id === action.payload.id ? state.appointment : null;
	        if (target) target.copay = action.payload.copay;
	        return (0, _extends3.default)({}, state, {
	          appointment: (0, _extends3.default)({}, state.appointment)
	        });
	      }
	
	    case _appointmentDetails.APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT:
	    case consts.CLEAR:
	      {
	        return (0, _extends3.default)({}, state, {
	          appointment: {},
	          appointmentId: null
	        });
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'change-status-req', ['UPDATE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dashboard',
	  type: 'put',
	  slug: ['appointments', {
	    type: 'payload',
	    selector: ['id']
	  }, 'change_status']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _assignmentUpdateReq = __webpack_require__(530);
	
	var updateAssignment = _interopRequireWildcard(_assignmentUpdateReq);
	
	var _managePendingRequest = __webpack_require__(263);
	
	var manageAppointments = _interopRequireWildcard(_managePendingRequest);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('data', 'app-state', ['CHANGE_TEST_CALL_PERFORMED_STATUS']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'app_state',
	  type: 'get'
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case manageAppointments.consts.SUCCEED:
	    case updateAssignment.consts.SUCCEED:
	      {
	        var assignmentsCount = (0, _get2.default)(state, 'providerPendingEventsFeedItems.totalFeedsCount', 0) - 1;
	
	        return (0, _extends3.default)({}, state, {
	          providerPendingEventsFeedItems: (0, _extends3.default)({}, state.providerPendingEventsFeedItems, {
	            totalFeedsCount: assignmentsCount > 0 ? assignmentsCount : 0
	          })
	        });
	      }
	    case consts.CHANGE_TEST_CALL_PERFORMED_STATUS:
	      {
	        return (0, _extends3.default)({}, state, {
	          virtualVisitNetworkTestPerformed: true
	        });
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('data', 'countryDetails');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'countries',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['code']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _assignmentUpdateReq = __webpack_require__(530);
	
	var updateAssignment = _interopRequireWildcard(_assignmentUpdateReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestOptions = {
	  endpoint: 'providers',
	  type: 'get',
	  slug: ['events_feed_items', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'status',
	    value: 'pending'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentManagement', 'pending-req', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('dependentManagement', 'pending-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  count: 0,
	  pagination: { offset: 0, limit: 10 }
	});
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          sending: !action.payload.silent
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          succeed: true,
	          list: action.payload
	        });
	      }
	
	    case paginationConsts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: [].concat((0, _toConsumableArray3.default)(state.list), (0, _toConsumableArray3.default)(action.payload))
	        });
	      }
	
	    case paginationConsts.ADD_META:
	    case consts.ADD_META:
	      {
	        return (0, _extends3.default)({}, state, {
	          count: (0, _get2.default)(action.payload, 'feedsCount', 0)
	        });
	      }
	
	    case updateAssignment.consts.SUCCEED:
	      {
	        var count = state.count - 1;
	        return (0, _extends3.default)({}, state, {
	          count: count >= 0 ? count : 0,
	          list: state.list.filter(function (_ref) {
	            var id = _ref.payload.id;
	
	            return id !== (0, _get2.default)(action, 'payload.id');
	          })
	        });
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestOptions = {
	  endpoint: 'providers',
	  type: 'get',
	  slug: ['events_feed_items', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'status',
	    value: 'reviewed'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentManagement', 'reviewed-req', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('dependentManagement', 'reviewed-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  count: 0,
	  pagination: { offset: 0, limit: 10 }
	});
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          sending: !action.payload.silent
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          succeed: true,
	          list: action.payload
	        });
	      }
	
	    case paginationConsts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: [].concat((0, _toConsumableArray3.default)(state.list), (0, _toConsumableArray3.default)(action.payload))
	        });
	      }
	
	    case paginationConsts.ADD_META:
	    case consts.ADD_META:
	      {
	        return (0, _extends3.default)({}, state, {
	          count: (0, _get2.default)(action.payload, 'feedsCount', 0)
	        });
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentManagement', 'update-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'providers',
	  type: 'put',
	  slug: ['care_role_relation', 'assignments', {
	    type: 'payload',
	    selector: ['id']
	  }, 'status']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.guarantorInformationActions = exports.GUARANTORS_INFORMATION_TYPES = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var actionsScope = 'guarantorsInformation/guarantors';
	
	var GUARANTORS_INFORMATION_TYPES = exports.GUARANTORS_INFORMATION_TYPES = {
	  SET_IS_SELF_GUARANTOR: actionsScope + '/isSelfGuarantor',
	  UPDATE_GUARANTOR_FORM_VALUES: actionsScope + '/updateGuarantorFormValues',
	  RESET_GUARANTOR_FORM_VALUES: actionsScope + '/resetGuarantorFormValues'
	};
	
	var guarantorInformationActions = exports.guarantorInformationActions = {
	  setIsSelfGuarantor: (0, _createAction.createAction)(GUARANTORS_INFORMATION_TYPES.SET_IS_SELF_GUARANTOR),
	  updateGuarantorFormValues: (0, _createAction.createAction)(GUARANTORS_INFORMATION_TYPES.UPDATE_GUARANTOR_FORM_VALUES),
	  resetGuarantorFormValues: (0, _createAction.createAction)(GUARANTORS_INFORMATION_TYPES.RESET_GUARANTOR_FORM_VALUES)
	};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'set-preferred-pharmacy');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'patient_pharmacies']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'check-in-appointment');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'check_in']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var requestOptions = {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'healthboard', 'completed_tasks', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'completed-tasks-req', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('health-board', 'completed-tasks-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions, true);
	
	exports.default = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'tasksCount'
	});

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testCallActions = exports.TEST_CALL_ACTION_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionScope = 'test-call';
	
	var TEST_CALL_ACTION_TYPES = exports.TEST_CALL_ACTION_TYPES = {
	  INIT: actionScope + '/init',
	  OPEN: actionScope + '/open',
	  CLOSE: actionScope + '/close'
	};
	
	var testCallActions = exports.testCallActions = {
	  init: (0, _createAction.createAction)(TEST_CALL_ACTION_TYPES.INIT),
	  open: (0, _createAction.createAction)(TEST_CALL_ACTION_TYPES.OPEN),
	  close: (0, _createAction.createAction)(TEST_CALL_ACTION_TYPES.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  props: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case TEST_CALL_ACTION_TYPES.OPEN:
	      {
	        return (0, _extends3.default)({}, state, { opened: true, props: payload });
	      }
	    case TEST_CALL_ACTION_TYPES.CLOSE:
	      {
	        return (0, _extends3.default)({}, state, { opened: false, props: {} });
	      }
	    default:
	      return state;
	  }
	};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('patient', 'create-patient-insurance');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'patient_insurances']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _updatePatientInsurance.consts.SUCCEED:
	      {
	        var list = (0, _get2.default)(state, 'list', []);
	
	        var newList = list.map(function (item) {
	          return item.id === action.payload.id ? action.payload : item;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          list: newList
	        });
	      }
	
	    case _createPatientInsurance.consts.SUCCEED:
	      {
	        var _newList = [].concat((0, _toConsumableArray3.default)(state.list), [action.payload]);
	
	        return (0, _extends3.default)({}, state, {
	          list: _newList
	        });
	      }
	
	    case consts.REMOVE_PATIENT_INSURANCE_FROM_LIST:
	      {
	        var _newList2 = state.list.filter(function (item) {
	          return item.id !== action.payload.id;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          list: _newList2
	        });
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _updatePatientInsurance = __webpack_require__(350);
	
	var _createPatientInsurance = __webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('patient', 'get-patient-insurances-list', ['REMOVE_PATIENT_INSURANCE_FROM_LIST']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'patient_insurances', {
	    type: 'payload.query',
	    queryParameter: 'todo_task_assignment_id',
	    selector: 'todoTaskAssignmentId'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'change-settings');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	/* This is just copy of get-user request because we need to update logged user info on page reload
	 * and not to store it as a target user in context. Our target user saga is watching on success request for
	 * user profiles, so it's a separated request only for fetching user on page reload.
	 * */
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'getLoggedUser');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'update-user-documents');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'documents', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paymentInfoModalActions = exports.PAYMENT_INFO_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	var _locationReducer = __webpack_require__(240);
	
	var _accountVaultsForm = __webpack_require__(354);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'programs/payment-info-modal';
	
	var PAYMENT_INFO_MODAL = exports.PAYMENT_INFO_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close',
	  CLEAR_PAYA_FORM: actionsScope + '/clear-paya-form',
	  RECEIVE_PAYA_FORM: actionsScope + '/receive-paya-form',
	  RECEIVED_PAYA_PAYMENT_SUCCESS_RESPONSE: actionsScope + '/received-paya-payment-success-response',
	  RECEIVED_PAYA_PAYMENT_ERROR_RESPONSE: actionsScope + '/received-paya-payment-error-response',
	  WAITING_PAYA_PAYMENT_RESPONSE: actionsScope + '/waiting-paya-payment-response',
	  CLEAR_WAITING_PAYA_PAYMENT_RESPONSE: actionsScope + '/clear-waiting-paya-payment-response'
	};
	
	var paymentInfoModalActions = exports.paymentInfoModalActions = {
	  open: (0, _createAction.createAction)(PAYMENT_INFO_MODAL.OPEN),
	  close: (0, _createAction.createAction)(PAYMENT_INFO_MODAL.CLOSE),
	  clearPayaForm: (0, _createAction.createAction)(PAYMENT_INFO_MODAL.CLEAR_PAYA_FORM),
	  receivePayaForm: (0, _createAction.createAction)(PAYMENT_INFO_MODAL.RECEIVE_PAYA_FORM),
	  waitingPayaPaymentResponse: (0, _createAction.createAction)(PAYMENT_INFO_MODAL.WAITING_PAYA_PAYMENT_RESPONSE),
	  clearWaitingPayaPaymentResponse: (0, _createAction.createAction)(PAYMENT_INFO_MODAL.CLEAR_WAITING_PAYA_PAYMENT_RESPONSE),
	  receivedPayaPaymentSuccessResponse: (0, _createAction.createAction)(PAYMENT_INFO_MODAL.RECEIVED_PAYA_PAYMENT_SUCCESS_RESPONSE),
	  receivedPayaPaymentErrorResponse: (0, _createAction.createAction)(PAYMENT_INFO_MODAL.RECEIVED_PAYA_PAYMENT_ERROR_RESPONSE)
	};
	
	var initialState = {
	  opened: false,
	  subscriptionsSetting: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case PAYMENT_INFO_MODAL.OPEN:
	      {
	        var subscriptionsSetting = payload.subscriptionsSetting,
	            programId = payload.programId,
	            userId = payload.userId,
	            todoId = payload.todoId,
	            invitationId = payload.invitationId,
	            mainUserId = payload.mainUserId,
	            programName = payload.programName,
	            prepayFlow = payload.prepayFlow,
	            organizationId = payload.organizationId,
	            purchaseAgain = payload.purchaseAgain,
	            duePaymentDate = payload.duePaymentDate;
	
	        return (0, _extends3.default)({}, state, {
	          userId: userId,
	          todoId: todoId,
	          programId: programId,
	          mainUserId: mainUserId,
	          opened: true,
	          organizationId: organizationId,
	          invitationId: invitationId,
	          programName: programName,
	          purchaseAgain: purchaseAgain,
	          prepayFlow: prepayFlow,
	          duePaymentDate: duePaymentDate,
	          subscriptionsSetting: subscriptionsSetting
	        });
	      }
	
	    case PAYMENT_INFO_MODAL.CLOSE:
	    case _locationReducer.LOCATION_CHANGE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    case PAYMENT_INFO_MODAL.WAITING_PAYA_PAYMENT_RESPONSE:
	      {
	        return (0, _extends3.default)({}, state, {
	          waitingPayaPaymentResponse: true
	        });
	      }
	
	    case PAYMENT_INFO_MODAL.CLEAR_WAITING_PAYA_PAYMENT_RESPONSE:
	      {
	        return (0, _extends3.default)({}, state, {
	          waitingPayaPaymentResponse: false
	        });
	      }
	
	    case PAYMENT_INFO_MODAL.CLEAR_PAYA_FORM:
	      {
	        return (0, _extends3.default)({}, state, {
	          payaFormUrl: ''
	        });
	      }
	
	    case _accountVaultsForm.consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, {
	          payaFormLoading: true
	        });
	      }
	
	    case PAYMENT_INFO_MODAL.RECEIVE_PAYA_FORM:
	      {
	        return (0, _extends3.default)({}, state, {
	          payaFormLoading: false,
	          payaFormUrl: payload.formUrl
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'block-remove');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'blocked_slots', 'removals']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'block-update');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'blocked_slots', {
	    type: 'payload',
	    selector: ['slotId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'worslot-remove');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'work_slots', 'removals']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'worslot-update');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'work_slots', {
	    type: 'payload',
	    selector: ['slotId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'upcoming-survey-answers');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'upcoming_assignments',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['assignmentId']
	  }, 'new_answers']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 547 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var parseDigits = exports.parseDigits = function parseDigits() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  var digits = value.replace(/\D/g, '');
	  if (digits.length > 10 && digits.startsWith('1')) {
	    return digits.slice(1, 11);
	  }
	  return digits.slice(0, 10);
	};
	
	var formatVisiblePhoneNumber = exports.formatVisiblePhoneNumber = function formatVisiblePhoneNumber() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  if (!value) return '';
	
	  var digits = parseDigits(value);
	
	  if (!digits) return '';
	
	  var part1 = digits.slice(0, 3);
	  var part2 = digits.slice(3, 6);
	  var part3 = digits.slice(6, 10);
	
	  if (digits.length < 4) return '(' + part1;
	  if (digits.length < 7) return '(' + part1 + ') ' + part2;
	  return '(' + part1 + ') ' + part2 + '-' + part3;
	};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var C_enc = C.enc;
			var Utf8 = C_enc.Utf8;
			var C_algo = C.algo;
	
			/**
	   * HMAC algorithm.
	   */
			var HMAC = C_algo.HMAC = Base.extend({
				/**
	    * Initializes a newly created HMAC.
	    *
	    * @param {Hasher} hasher The hash algorithm to use.
	    * @param {WordArray|string} key The secret key.
	    *
	    * @example
	    *
	    *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	    */
				init: function init(hasher, key) {
					// Init hasher
					hasher = this._hasher = new hasher.init();
	
					// Convert string to WordArray, else assume WordArray already
					if (typeof key == 'string') {
						key = Utf8.parse(key);
					}
	
					// Shortcuts
					var hasherBlockSize = hasher.blockSize;
					var hasherBlockSizeBytes = hasherBlockSize * 4;
	
					// Allow arbitrary length keys
					if (key.sigBytes > hasherBlockSizeBytes) {
						key = hasher.finalize(key);
					}
	
					// Clamp excess bits
					key.clamp();
	
					// Clone key for inner and outer pads
					var oKey = this._oKey = key.clone();
					var iKey = this._iKey = key.clone();
	
					// Shortcuts
					var oKeyWords = oKey.words;
					var iKeyWords = iKey.words;
	
					// XOR keys with pad constants
					for (var i = 0; i < hasherBlockSize; i++) {
						oKeyWords[i] ^= 0x5c5c5c5c;
						iKeyWords[i] ^= 0x36363636;
					}
					oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
					// Set initial values
					this.reset();
				},
	
				/**
	    * Resets this HMAC to its initial state.
	    *
	    * @example
	    *
	    *     hmacHasher.reset();
	    */
				reset: function reset() {
					// Shortcut
					var hasher = this._hasher;
	
					// Reset
					hasher.reset();
					hasher.update(this._iKey);
				},
	
				/**
	    * Updates this HMAC with a message.
	    *
	    * @param {WordArray|string} messageUpdate The message to append.
	    *
	    * @return {HMAC} This HMAC instance.
	    *
	    * @example
	    *
	    *     hmacHasher.update('message');
	    *     hmacHasher.update(wordArray);
	    */
				update: function update(messageUpdate) {
					this._hasher.update(messageUpdate);
	
					// Chainable
					return this;
				},
	
				/**
	    * Finalizes the HMAC computation.
	    * Note that the finalize operation is effectively a destructive, read-once operation.
	    *
	    * @param {WordArray|string} messageUpdate (Optional) A final message update.
	    *
	    * @return {WordArray} The HMAC.
	    *
	    * @example
	    *
	    *     var hmac = hmacHasher.finalize();
	    *     var hmac = hmacHasher.finalize('message');
	    *     var hmac = hmacHasher.finalize(wordArray);
	    */
				finalize: function finalize(messageUpdate) {
					// Shortcut
					var hasher = this._hasher;
	
					// Compute HMAC
					var innerHash = hasher.finalize(messageUpdate);
					hasher.reset();
					var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
					return hmac;
				}
			});
		})();
	});

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Initialization and round constants tables
			var H = [];
			var K = [];
	
			// Compute constants
			(function () {
				function isPrime(n) {
					var sqrtN = Math.sqrt(n);
					for (var factor = 2; factor <= sqrtN; factor++) {
						if (!(n % factor)) {
							return false;
						}
					}
	
					return true;
				}
	
				function getFractionalBits(n) {
					return (n - (n | 0)) * 0x100000000 | 0;
				}
	
				var n = 2;
				var nPrime = 0;
				while (nPrime < 64) {
					if (isPrime(n)) {
						if (nPrime < 8) {
							H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
						}
						K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
						nPrime++;
					}
	
					n++;
				}
			})();
	
			// Reusable object
			var W = [];
	
			/**
	   * SHA-256 hash algorithm.
	   */
			var SHA256 = C_algo.SHA256 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init(H.slice(0));
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var H = this._hash.words;
	
					// Working variables
					var a = H[0];
					var b = H[1];
					var c = H[2];
					var d = H[3];
					var e = H[4];
					var f = H[5];
					var g = H[6];
					var h = H[7];
	
					// Computation
					for (var i = 0; i < 64; i++) {
						if (i < 16) {
							W[i] = M[offset + i] | 0;
						} else {
							var gamma0x = W[i - 15];
							var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
	
							var gamma1x = W[i - 2];
							var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
	
							W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
						}
	
						var ch = e & f ^ ~e & g;
						var maj = a & b ^ a & c ^ b & c;
	
						var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
						var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
	
						var t1 = h + sigma1 + ch + K[i] + W[i];
						var t2 = sigma0 + maj;
	
						h = g;
						g = f;
						f = e;
						e = d + t1 | 0;
						d = c;
						c = b;
						b = a;
						a = t1 + t2 | 0;
					}
	
					// Intermediate hash value
					H[0] = H[0] + a | 0;
					H[1] = H[1] + b | 0;
					H[2] = H[2] + c | 0;
					H[3] = H[3] + d | 0;
					H[4] = H[4] + e | 0;
					H[5] = H[5] + f | 0;
					H[6] = H[6] + g | 0;
					H[7] = H[7] + h | 0;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Return final computed hash
					return this._hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA256('message');
	   *     var hash = CryptoJS.SHA256(wordArray);
	   */
			C.SHA256 = Hasher._createHelper(SHA256);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA256(message, key);
	   */
			C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		})(Math);
	
		return CryptoJS.SHA256;
	});

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4333), __esModule: true };

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4344), __esModule: true };

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 553 */
[6578, 2127, 1401],
/* 554 */
[6594, 1399],
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4378);
	var global = __webpack_require__(169);
	var hide = __webpack_require__(365);
	var Iterators = __webpack_require__(552);
	var TO_STRING_TAG = __webpack_require__(170)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 556 */
552,
/* 557 */
[6585, 125, 204, 106],
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	var defined = __webpack_require__(271);
	var fails = __webpack_require__(95);
	var spaces = __webpack_require__(1439);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 559 */
[6596, 99],
/* 560 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	
	  return sign + output;
	}
	
	module.exports = exports.default;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(455));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getISOYear` to `getISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * var result = getISOWeekYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.without = without;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.xor = xor;
	exports.intersection = intersection;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	// cheap lodash replacements
	
	/**
	 * drop-in replacement for _.get
	 * @param obj
	 * @param path
	 * @param defaultValue
	 */
	function get(obj, path, defaultValue) {
	  return path.split('.').reduce(function (a, c) {
	    return a && a[c] ? a[c] : defaultValue || null;
	  }, obj);
	}
	/**
	 * drop-in replacement for _.without
	 */
	
	
	function without(items, item) {
	  return items.filter(function (i) {
	    return i !== item;
	  });
	}
	/**
	 * drop-in replacement for _.isString
	 * @param input
	 */
	
	
	function isString(input) {
	  return typeof input === 'string';
	}
	/**
	 * drop-in replacement for _.isString
	 * @param input
	 */
	
	
	function isObject(input) {
	  return _typeof(input) === 'object';
	}
	/**
	 * repalcement for _.xor
	 * @param itemsA
	 * @param itemsB
	 */
	
	
	function xor(itemsA, itemsB) {
	  var map = new Map();
	
	  var insertItem = function insertItem(item) {
	    return map.set(item, map.has(item) ? map.get(item) + 1 : 1);
	  };
	
	  itemsA.forEach(insertItem);
	  itemsB.forEach(insertItem);
	  var result = [];
	  map.forEach(function (count, key) {
	    if (count === 1) {
	      result.push(key);
	    }
	  });
	  return result;
	}
	/**
	 * replacement for _.intersection
	 * @param itemsA
	 * @param itemsB
	 */
	
	
	function intersection(itemsA, itemsB) {
	  return itemsA.filter(function (t) {
	    return itemsB.indexOf(t) > -1;
	  });
	}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_91697853","outerContainer":"e7124d09","secondaryToolbar":"_6e32ddb7","doorHangerRight":"f6d10886","toolbarContainer":"fb7e7b95","toolbarViewerMiddle":"_88104643","progressBar":"_64872bde","back-to-application":"_768cecbb","root":"_15507d29","content":"_5c2e2e49","profile":"_25eecfa1","userAvatar":"_76d90083","userData":"_1abc6b70","userCommon":"_5e9865d4","userAction":"_6e6c5684","userHeader":"_3099eedc","userHeader--primary":"e126d398","userHeader--secondary":"_178ab4e5","userHeader--label":"_06e7e7c2","description":"_7c208b08","fieldset":"_440b98e7","field":"_085552a4","field--wide":"a1de9143","invite":"_4e0a4696","invitator":"_4020defb","invite-input":"c31efc5a","checkboxWrapper":"_8f9b3a95","link--acceptable":"_088b51c2","text":"_066b811c","circles-popup-text":"_9f2b3e59"};

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a8aa3990","outerContainer":"_7ab22bf5","secondaryToolbar":"ab8ef392","doorHangerRight":"e3d2eb27","toolbarContainer":"e5274e8b","toolbarViewerMiddle":"_297942ef","progressBar":"fd2b4bfd","back-to-application":"_44a4d24f","root":"faa7343a","danger":"_1f36e7a0","overlay":"ad3c5f6b","grid":"_57474de9","image":"_9864a8c3","content":"_62a5905d","body":"_0b4fa2a0","body__content":"_45d9f53a","header":"_38b2e2b7","header__title":"bcf2c945","header__author":"_736e28c2","header__organization":"_0fba0795","header__author__secondary":"d9c52a39","header__time":"fd66584e","header__user":"fddf7036","header__pinnedStatus":"_44792d4c","status":"a7395ef6","image-wrapper":"fd9bcee0","footer":"db940402","footer__stats":"e2817dc4","footer__stats__action":"a3f15d55","footer__stats__text":"_92e1a3c9","lazy-image-wrapper":"_94698600","lazy-image":"d6e2b6f8","image--blurred":"_6d5bafae","image--relative":"de952541","image-grid":"_95cd92b8","square":"a259946f","image-grid__item":"a58a668e","portrait":"_72b52d14","grid-item":"ac9cd789","grid-item--first":"b3b6c1c4","grid-item--counter":"f277d86d","image-counter":"d0893ac5","urlPreviewContainer":"d2b9607c","videoPreviewContainer":"d580e77c","image-preview":"_452f4937"};

/***/ }),
/* 565 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_24b9ba8d","outerContainer":"_21b5c266","secondaryToolbar":"_7030c502","doorHangerRight":"_6660c20e","toolbarContainer":"be9b3641","toolbarViewerMiddle":"_5985debd","progressBar":"_63f90470","back-to-application":"_3372632d","root":"bd70121e","upcoming-surveys":"_6f0116cc","title":"_1c2279ee","subtitle":"d9238b5a","buttons-wrapper":"e57674a8","surveys-list-button":"_3f0c3e89","surveys-list-button--active":"_107bac99","surveys-list-button--disabled":"_545aeb94","empty-state":"_74e7fd99","empty-state__text":"_21d6ff20","positionRelative":"_10c0a87c"};

/***/ }),
/* 566 */,
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _toCss = __webpack_require__(1526);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	var _toCssValue = __webpack_require__(967);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StyleRule = function () {
	  function StyleRule(key, style, options) {
	    _classCallCheck(this, StyleRule);
	
	    this.type = 'style';
	    this.isProcessed = false;
	    var sheet = options.sheet,
	        Renderer = options.Renderer,
	        selector = options.selector;
	
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    if (selector) this.selectorText = selector;
	    this.renderer = sheet ? sheet.renderer : new Renderer();
	  }
	
	  /**
	   * Set selector string.
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  _createClass(StyleRule, [{
	    key: 'prop',
	
	
	    /**
	     * Get or set a style property.
	     */
	    value: function prop(name, value) {
	      // It's a getter.
	      if (value === undefined) return this.style[name];
	
	      // Don't do anything if the value has not changed.
	      if (this.style[name] === value) return this;
	
	      value = this.options.jss.plugins.onChangeValue(value, name, this);
	
	      var isEmpty = value == null || value === false;
	      var isDefined = name in this.style;
	
	      // Value is empty and wasn't defined before.
	      if (isEmpty && !isDefined) return this;
	
	      // We are going to remove this value.
	      var remove = isEmpty && isDefined;
	
	      if (remove) delete this.style[name];else this.style[name] = value;
	
	      // Renderable is defined if StyleSheet option `link` is true.
	      if (this.renderable) {
	        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
	        return this;
	      }
	
	      var sheet = this.options.sheet;
	
	      if (sheet && sheet.attached) {
	        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
	      }
	      return this;
	    }
	
	    /**
	     * Apply rule to an element inline.
	     */
	
	  }, {
	    key: 'applyTo',
	    value: function applyTo(renderable) {
	      var json = this.toJSON();
	      for (var prop in json) {
	        this.renderer.setProperty(renderable, prop, json[prop]);
	      }return this;
	    }
	
	    /**
	     * Returns JSON representation of the rule.
	     * Fallbacks are not supported.
	     * Useful for inline styles.
	     */
	
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      var json = {};
	      for (var prop in this.style) {
	        var value = this.style[prop];
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
	      }
	      return json;
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      var sheet = this.options.sheet;
	
	      var link = sheet ? sheet.options.link : false;
	      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
	      return (0, _toCss2['default'])(this.selector, this.style, opts);
	    }
	  }, {
	    key: 'selector',
	    set: function set(selector) {
	      if (selector === this.selectorText) return;
	
	      this.selectorText = selector;
	
	      if (!this.renderable) return;
	
	      var hasChanged = this.renderer.setSelector(this.renderable, selector);
	
	      // If selector setter is not implemented, rerender the rule.
	      if (!hasChanged && this.renderable) {
	        var renderable = this.renderer.replaceRule(this.renderable, this);
	        if (renderable) this.renderable = renderable;
	      }
	    }
	
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}();
	
	exports['default'] = StyleRule;

/***/ }),
/* 568 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 569 */
[6731, 246],
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(970),
	    isFlattenable = __webpack_require__(5464);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 571 */
[6742, 459, 461],
/* 572 */
[6757, 323, 2341, 2344],
/* 573 */
[6766, 1532, 726],
/* 574 */
[6780, 5386, 1527, 5388, 2304, 5389, 321, 2345],
/* 575 */
[6786, 728, 247, 975, 139],
/* 576 */
[6822, 321, 227],
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(2314),
	    baseGt = __webpack_require__(5403),
	    identity = __webpack_require__(323);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(5589);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Modal).default;
	  }
	});
	
	var _Backdrop = __webpack_require__(2373);
	
	Object.defineProperty(exports, 'Backdrop', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Backdrop).default;
	  }
	});
	
	var _ModalManager = __webpack_require__(2374);
	
	Object.defineProperty(exports, 'ModalManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ModalManager).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _colorManipulator = __webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TRANSITION_DURATION = 4; // 400ms
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 5
	    },
	    primaryColor: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
	    },
	    primaryColorBar: {
	      backgroundColor: theme.palette.primary.main
	    },
	    primaryDashed: {
	      background: 'radial-gradient(' + (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6) + ' 0%, ' + (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6) + ' 16%, transparent 42%)',
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    secondaryColor: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
	    },
	    secondaryColorBar: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    secondaryDashed: {
	      background: 'radial-gradient(' + (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4) + ' 0%, ' + (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6) + ' 16%, transparent 42%)',
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: 'buffer 3s infinite linear'
	    },
	    bufferBar2: {
	      transition: 'transform .' + TRANSITION_DURATION + 's linear'
	    },
	    rootBuffer: {
	      backgroundColor: 'transparent'
	    },
	    rootQuery: {
	      transform: 'rotate(180deg)'
	    },
	    indeterminateBar1: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	    indeterminateBar2: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
	      animationDelay: '1.15s'
	    },
	    determinateBar1: {
	      willChange: 'transform',
	      transition: 'transform .' + TRANSITION_DURATION + 's linear'
	    },
	    bufferBar1: {
	      zIndex: 1,
	      transition: 'transform .' + TRANSITION_DURATION + 's linear'
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes mui-indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes mui-indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0px -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0px -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	
	/**
	 * ## ARIA
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	function LinearProgress(props) {
	  var _classNames, _classNames2, _classNames3, _classNames4;
	
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'value', 'valueBuffer', 'variant']);
	
	
	  var dashedClass = (0, _classnames2.default)(classes.dashed, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.primaryDashed, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.secondaryDashed, color === 'secondary'), _classNames));
	
	  var rootClassName = (0, _classnames2.default)(classes.root, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.primaryColor, color === 'primary'), (0, _defineProperty3.default)(_classNames2, classes.secondaryColor, color === 'secondary'), (0, _defineProperty3.default)(_classNames2, classes.rootBuffer, variant === 'buffer'), (0, _defineProperty3.default)(_classNames2, classes.rootQuery, variant === 'query'), _classNames2), className);
	  var primaryClassName = (0, _classnames2.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.primaryColorBar, color === 'primary'), (0, _defineProperty3.default)(_classNames3, classes.secondaryColorBar, color === 'secondary'), (0, _defineProperty3.default)(_classNames3, classes.indeterminateBar1, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty3.default)(_classNames3, classes.determinateBar1, variant === 'determinate'), (0, _defineProperty3.default)(_classNames3, classes.bufferBar1, variant === 'buffer'), _classNames3));
	  var secondaryClassName = (0, _classnames2.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty3.default)(_classNames4, classes.bufferBar2, variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.primaryColorBar, color === 'primary' && variant !== 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.primaryColor, color === 'primary' && variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.secondaryColorBar, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.secondaryColor, color === 'secondary' && variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.indeterminateBar2, variant === 'indeterminate' || variant === 'query'), _classNames4));
	  var inlineStyles = { primary: {}, secondary: {} };
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      inlineStyles.primary.transform = 'scaleX(' + value / 100 + ')';
	      rootProps['aria-valuenow'] = Math.round(value);
	    } else {
	       false ? (0, _warning2.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
	    }
	  }
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      inlineStyles.secondary.transform = 'scaleX(' + (valueBuffer || 0) / 100 + ')';
	    } else {
	       false ? (0, _warning2.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: rootClassName, role: 'progressbar' }, rootProps, other),
	    variant === 'buffer' ? _react2.default.createElement('div', { className: dashedClass }) : null,
	    _react2.default.createElement('div', { className: primaryClassName, style: inlineStyles.primary }),
	    variant === 'determinate' ? null : _react2.default.createElement('div', { className: secondaryClassName, style: inlineStyles.secondary })
	  );
	}
	
	LinearProgress.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes2.default.oneOf(['primary', 'secondary']),
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes2.default.number,
	  /**
	   * The value for the buffer for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes2.default.number,
	  /**
	   * The variant of progress indicator. Use indeterminate or query
	   * when there is no progress value.
	   */
	  variant: _propTypes2.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
	} : {};
	
	LinearProgress.defaultProps = {
	  color: 'primary',
	  variant: 'indeterminate'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiLinearProgress' })(LinearProgress);

/***/ }),
/* 580 */
[6720, 5668],
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createGenerateClassName = __webpack_require__(2397);
	
	Object.defineProperty(exports, 'createGenerateClassName', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createGenerateClassName).default;
	  }
	});
	
	var _createMuiTheme = __webpack_require__(1570);
	
	Object.defineProperty(exports, 'createMuiTheme', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createMuiTheme).default;
	  }
	});
	
	var _jssPreset = __webpack_require__(2398);
	
	Object.defineProperty(exports, 'jssPreset', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_jssPreset).default;
	  }
	});
	
	var _MuiThemeProvider = __webpack_require__(5672);
	
	Object.defineProperty(exports, 'MuiThemeProvider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MuiThemeProvider).default;
	  }
	});
	
	var _withStyles = __webpack_require__(39);
	
	Object.defineProperty(exports, 'withStyles', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withStyles).default;
	  }
	});
	
	var _withTheme = __webpack_require__(582);
	
	Object.defineProperty(exports, 'withTheme', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withTheme).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(1569);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _wrapDisplayName = __webpack_require__(735);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createMuiTheme = __webpack_require__(1570);
	
	var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);
	
	var _themeListener = __webpack_require__(1571);
	
	var _themeListener2 = _interopRequireDefault(_themeListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultTheme = void 0;
	
	function getDefaultTheme() {
	  if (defaultTheme) {
	    return defaultTheme;
	  }
	
	  defaultTheme = (0, _createMuiTheme2.default)();
	  return defaultTheme;
	}
	
	// Provide the theme object as a property to the input component.
	var withTheme = function withTheme() {
	  return function (Component) {
	    var WithTheme = function (_React$Component) {
	      (0, _inherits3.default)(WithTheme, _React$Component);
	
	      function WithTheme(props, context) {
	        (0, _classCallCheck3.default)(this, WithTheme);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (WithTheme.__proto__ || (0, _getPrototypeOf2.default)(WithTheme)).call(this, props, context));
	
	        _this.state = {};
	        _this.unsubscribeId = null;
	
	        _this.state = {
	          // We use || as the function call is lazy evaluated.
	          theme: _themeListener2.default.initial(context) || getDefaultTheme()
	        };
	        return _this;
	      }
	
	      (0, _createClass3.default)(WithTheme, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          var _this2 = this;
	
	          this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
	            _this2.setState({ theme: theme });
	          });
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          if (this.unsubscribeId !== null) {
	            _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(Component, (0, _extends3.default)({ theme: this.state.theme }, this.props));
	        }
	      }]);
	      return WithTheme;
	    }(_react2.default.Component);
	
	    WithTheme.contextTypes = _themeListener2.default.contextTypes;
	
	    if (false) {
	      WithTheme.displayName = (0, _wrapDisplayName2.default)(Component, 'WithTheme');
	    }
	
	    (0, _hoistNonReactStatics2.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	};
	
	exports.default = withTheme;

/***/ }),
/* 583 */,
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDecoratedComponent = getDecoratedComponent;
	exports.isClassComponent = isClassComponent;
	exports.isRefForwardingComponent = isRefForwardingComponent;
	exports.isRefable = isRefable;
	exports.checkDecoratorArguments = checkDecoratorArguments;
	
	function getDecoratedComponent(instanceRef) {
	  var currentRef = instanceRef.current;
	
	  if (currentRef == null) {
	    return null;
	  } else if (currentRef.decoratedRef) {
	    // go through the private field in decorateHandler to avoid the invariant hit
	    return currentRef.decoratedRef.current;
	  } else {
	    return currentRef;
	  }
	}
	
	function isClassComponent(Component) {
	  return Component && Component.prototype && typeof Component.prototype.render === 'function';
	}
	
	function isRefForwardingComponent(C) {
	  return C && C.$$typeof && C.$$typeof.toString() === 'Symbol(react.forward_ref)';
	}
	
	function isRefable(C) {
	  return isClassComponent(C) || isRefForwardingComponent(C);
	}
	
	function checkDecoratorArguments(functionName, signature) {
	  if (false) {
	    for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i++) {
	      var arg = i + 2 < 2 || arguments.length <= i + 2 ? undefined : arguments[i + 2];
	
	      if (arg && arg.prototype && arg.prototype.render) {
	        // eslint-disable-next-line no-console
	        console.error('You seem to be applying the arguments in the wrong order. ' + "It should be ".concat(functionName, "(").concat(signature, ")(Component), not the other way around. ") + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
	        return;
	      }
	    }
	  }
	}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useIsomorphicLayoutEffect = void 0;
	
	var _react = __webpack_require__(1);
	
	// suppress the useLayoutEffect warning on server side.
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ }),
/* 586 */
281,
/* 587 */
474,
/* 588 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function deepMerge(target) {
		var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		var extended = _extends({}, target);
	
		Object.keys(source).forEach(function (key) {
			if (_typeof(source[key]) !== 'object' || !source[key]) {
				extended[key] = source[key];
			} else {
				if (!target[key]) {
					extended[key] = source[key];
				} else {
					extended[key] = deepMerge(target[key], source[key]);
				}
			}
		});
	
		return extended;
	}
	
	exports.default = deepMerge;

/***/ }),
/* 589 */,
/* 590 */,
/* 591 */
[6836, 6326],
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FontIcon = function FontIcon(_ref) {
	  var alt = _ref.alt,
	      children = _ref.children,
	      className = _ref.className,
	      theme = _ref.theme,
	      value = _ref.value,
	      other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'theme', 'value']);
	
	  return (// eslint-disable-line
	    _react2.default.createElement(
	      'span',
	      _extends({
	        'data-react-toolbox': 'font-icon',
	        'aria-label': alt,
	        className: (0, _classnames2.default)({ 'material-icons': typeof value === 'string' || typeof children === 'string' }, className)
	      }, other),
	      value,
	      children
	    )
	  );
	};
	
	FontIcon.propTypes = {
	  alt: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  theme: _propTypes2.default.object, // eslint-disable-line
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
	};
	
	FontIcon.defaultProps = {
	  alt: '',
	  className: ''
	};
	
	exports.default = FontIcon;
	exports.FontIcon = FontIcon;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	var _isPlaceholder = __webpack_require__(1647);
	
	
	/**
	 * Optimized internal one-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry1(fn) {
	  return function f1(a) {
	    if (arguments.length === 0 || _isPlaceholder(a)) {
	      return f1;
	    } else {
	      return fn.apply(this, arguments);
	    }
	  };
	};


/***/ }),
/* 594 */
[6836, 6371],
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var babelPluginFlowReactPropTypes_proptype_Index =  true ? null : {
	  index: require("prop-types").number.isRequired
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_Index", {
	  value: babelPluginFlowReactPropTypes_proptype_Index,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_PositionInfo =  true ? null : {
	  x: require("prop-types").number.isRequired,
	  y: require("prop-types").number.isRequired
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_PositionInfo", {
	  value: babelPluginFlowReactPropTypes_proptype_PositionInfo,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_ScrollPosition =  true ? null : {
	  scrollLeft: require("prop-types").number.isRequired,
	  scrollTop: require("prop-types").number.isRequired
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_ScrollPosition", {
	  value: babelPluginFlowReactPropTypes_proptype_ScrollPosition,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo =  true ? null : {
	  height: require("prop-types").number.isRequired,
	  width: require("prop-types").number.isRequired,
	  x: require("prop-types").number.isRequired,
	  y: require("prop-types").number.isRequired
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo", {
	  value: babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_SizeInfo =  true ? null : {
	  height: require("prop-types").number.isRequired,
	  width: require("prop-types").number.isRequired
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_SizeInfo", {
	  value: babelPluginFlowReactPropTypes_proptype_SizeInfo,
	  configurable: true
	});

/***/ }),
/* 596 */,
/* 597 */,
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(2908)
	} else {
	  module.exports = require('./shallowequal.cjs.development.js')
	}


/***/ }),
/* 600 */,
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var core_1 = __webpack_require__(192);
	var utils_1 = __webpack_require__(65);
	var global = utils_1.getGlobalObject();
	var ignoreOnError = 0;
	/**
	 * @hidden
	 */
	function shouldIgnoreOnError() {
	    return ignoreOnError > 0;
	}
	exports.shouldIgnoreOnError = shouldIgnoreOnError;
	/**
	 * @hidden
	 */
	function ignoreNextOnError() {
	    // onerror should trigger before setTimeout
	    ignoreOnError += 1;
	    setTimeout(function () {
	        ignoreOnError -= 1;
	    });
	}
	exports.ignoreNextOnError = ignoreNextOnError;
	/**
	 * Instruments the given function and sends an event to Sentry every time the
	 * function throws an exception.
	 *
	 * @param fn A function to wrap.
	 * @returns The wrapped function.
	 * @hidden
	 */
	function wrap(fn, options, before) {
	    if (options === void 0) { options = {}; }
	    if (typeof fn !== 'function') {
	        return fn;
	    }
	    try {
	        // We don't wanna wrap it twice
	        if (fn.__sentry__) {
	            return fn;
	        }
	        // If this has already been wrapped in the past, return that wrapped function
	        if (fn.__sentry_wrapped__) {
	            return fn.__sentry_wrapped__;
	        }
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return fn;
	    }
	    /* eslint-disable prefer-rest-params */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var sentryWrapped = function () {
	        var args = Array.prototype.slice.call(arguments);
	        try {
	            if (before && typeof before === 'function') {
	                before.apply(this, arguments);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
	            if (fn.handleEvent) {
	                // Attempt to invoke user-land function
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	                //       means the sentry.javascript SDK caught an error invoking your application code. This
	                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                return fn.handleEvent.apply(this, wrappedArguments);
	            }
	            // Attempt to invoke user-land function
	            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	            //       means the sentry.javascript SDK caught an error invoking your application code. This
	            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
	            return fn.apply(this, wrappedArguments);
	        }
	        catch (ex) {
	            ignoreNextOnError();
	            core_1.withScope(function (scope) {
	                scope.addEventProcessor(function (event) {
	                    var processedEvent = tslib_1.__assign({}, event);
	                    if (options.mechanism) {
	                        utils_1.addExceptionTypeValue(processedEvent, undefined, undefined);
	                        utils_1.addExceptionMechanism(processedEvent, options.mechanism);
	                    }
	                    processedEvent.extra = tslib_1.__assign(tslib_1.__assign({}, processedEvent.extra), { arguments: args });
	                    return processedEvent;
	                });
	                core_1.captureException(ex);
	            });
	            throw ex;
	        }
	    };
	    /* eslint-enable prefer-rest-params */
	    // Accessing some objects may throw
	    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
	    try {
	        for (var property in fn) {
	            if (Object.prototype.hasOwnProperty.call(fn, property)) {
	                sentryWrapped[property] = fn[property];
	            }
	        }
	    }
	    catch (_oO) { } // eslint-disable-line no-empty
	    fn.prototype = fn.prototype || {};
	    sentryWrapped.prototype = fn.prototype;
	    Object.defineProperty(fn, '__sentry_wrapped__', {
	        enumerable: false,
	        value: sentryWrapped,
	    });
	    // Signal that this function has been wrapped/filled already
	    // for both debugging and to prevent it to being wrapped/filled twice
	    Object.defineProperties(sentryWrapped, {
	        __sentry__: {
	            enumerable: false,
	            value: true,
	        },
	        __sentry_original__: {
	            enumerable: false,
	            value: fn,
	        },
	    });
	    // Restore original function name (not all browsers allow that)
	    try {
	        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
	        if (descriptor.configurable) {
	            Object.defineProperty(sentryWrapped, 'name', {
	                get: function () {
	                    return fn.name;
	                },
	            });
	        }
	        // eslint-disable-next-line no-empty
	    }
	    catch (_oO) { }
	    return sentryWrapped;
	}
	exports.wrap = wrap;
	/**
	 * Injects the Report Dialog script
	 * @hidden
	 */
	function injectReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    if (!global.document) {
	        return;
	    }
	    if (!options.eventId) {
	        utils_1.logger.error("Missing eventId option in showReportDialog call");
	        return;
	    }
	    if (!options.dsn) {
	        utils_1.logger.error("Missing dsn option in showReportDialog call");
	        return;
	    }
	    var script = global.document.createElement('script');
	    script.async = true;
	    script.src = new core_1.API(options.dsn).getReportDialogEndpoint(options);
	    if (options.onLoad) {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        script.onload = options.onLoad;
	    }
	    var injectionPoint = global.document.head || global.document.body;
	    if (injectionPoint) {
	        injectionPoint.appendChild(script);
	    }
	}
	exports.injectReportDialog = injectReportDialog;
	//# sourceMappingURL=helpers.js.map

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	tslib_1.__exportStar(__webpack_require__(2915), exports);
	var core_1 = __webpack_require__(192);
	var utils_1 = __webpack_require__(65);
	var BrowserIntegrations = __webpack_require__(1064);
	var Transports = __webpack_require__(1670);
	exports.Transports = Transports;
	var windowIntegrations = {};
	// This block is needed to add compatibility with the integrations packages when used with a CDN
	var _window = utils_1.getGlobalObject();
	if (_window.Sentry && _window.Sentry.Integrations) {
	    windowIntegrations = _window.Sentry.Integrations;
	}
	var INTEGRATIONS = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, windowIntegrations), core_1.Integrations), BrowserIntegrations);
	exports.Integrations = INTEGRATIONS;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    careUser: (0, _selectors.selectProgressCareUser)(state)
	  };
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps), (0, _recompose.withProps)(function (_ref) {
	  var careUser = _ref.careUser;
	  return {
	    subtitle: {
	      id: 'appointments.form.step2.subTitle',
	      state: { user: (0, _get2.default)(careUser, 'displayableName') }
	    }
	  };
	}));

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(4922);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Badge = function Badge(_ref) {
	  var className = _ref.className,
	      colored = _ref.colored,
	      large = _ref.large,
	      text = _ref.text;
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: className }, {
	      styleName: (0, _classnames2.default)('root', {
	        'root--colored': colored,
	        'root--large': large
	      })
	    }),
	    _react2.default.createElement('span', { styleName: 'text', children: text })
	  );
	};
	
	Badge.propTypes = {
	  className: _propTypes2.default.string,
	  colored: _propTypes2.default.bool,
	  large: _propTypes2.default.bool,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
	};
	
	Badge.defaultProps = {
	  colored: false,
	  large: false,
	  className: ''
	};
	
	exports.default = (0, _reactCssModules2.default)(Badge, _index2.default, { allowMultiple: true });

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconButton = exports.IconButton = function IconButton(_ref) {
	  var className = _ref.className,
	      onClick = _ref.onClick,
	      name = _ref.name,
	      size = _ref.size,
	      fill = _ref.fill;
	  return _react2.default.createElement(
	    _ClickableElement2.default,
	    { onClick: onClick, className: className, styleName: 'link' },
	    _react2.default.createElement(_Icon2.default, { name: name, size: size, style: { fill: fill } })
	  );
	};
	
	IconButton.propTypes = {
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  name: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  fill: _propTypes2.default.string
	};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CommunityCard = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _styles = __webpack_require__(4930);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunityCardImpl = function CommunityCardImpl(_ref) {
	  var _ref$avatar = _ref.avatar,
	      name = _ref$avatar.name,
	      src = _ref$avatar.src,
	      _ref$avatar$size = _ref$avatar.size,
	      size = _ref$avatar$size === undefined ? 100 : _ref$avatar$size,
	      renderSubTitle = _ref.renderSubTitle,
	      renderSubContent = _ref.renderSubContent,
	      renderContent = _ref.renderContent,
	      renderActions = _ref.renderActions,
	      renderTitle = _ref.renderTitle,
	      renderInfo = _ref.renderInfo;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'Card' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'CardWrapper' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'CardContent' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'CardLogo' },
	          _react2.default.createElement(_Avatar2.default, {
	            children: name,
	            src: src,
	            size: size,
	            bordered: true,
	            position: 'center'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'CardBody' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'CardTitle' },
	            renderTitle()
	          ),
	          renderSubTitle && _react2.default.createElement(
	            'div',
	            { styleName: 'CardSubTitle' },
	            renderSubTitle()
	          ),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'CardText' },
	            renderContent()
	          ),
	          renderSubContent && _react2.default.createElement(
	            'div',
	            { styleName: 'CardSubContent' },
	            renderSubContent()
	          ),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'CardInfo' },
	            renderInfo()
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'CardActions' },
	        renderActions()
	      )
	    )
	  );
	};
	
	var CommunityCard = exports.CommunityCard = (0, _recompose.compose)((0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }))(CommunityCardImpl);
	
	var propTypes = {
	  renderSubTitle: _propTypes2.default.func,
	  renderSubContent: _propTypes2.default.func,
	  renderContent: _propTypes2.default.func,
	  renderActions: _propTypes2.default.func,
	  renderTitle: _propTypes2.default.func,
	  renderInfo: _propTypes2.default.func,
	  avatar: _propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    src: _propTypes2.default.string,
	    size: _propTypes2.default.number
	  }).isRequired
	};
	var defaultProps = {
	  renderSubTitle: null,
	  renderSubContent: null,
	  renderContent: function renderContent() {},
	  renderActions: function renderActions() {},
	  renderTitle: function renderTitle() {},
	  renderInfo: function renderInfo() {}
	};
	
	CommunityCardImpl.propTypes = propTypes;
	CommunityCardImpl.defaultProps = defaultProps;
	CommunityCard.propTypes = propTypes;
	CommunityCard.defaultProps = defaultProps;

/***/ }),
/* 607 */,
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleElectronicConsentExpirationTime = exports.timeToShow = undefined;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _is_same_year = __webpack_require__(2177);
	
	var _is_same_year2 = _interopRequireDefault(_is_same_year);
	
	var _dateConverters = __webpack_require__(83);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleExpirationTime = function handleExpirationTime(date, dueDescription, formatMessage) {
	  var now = (0, _moment2.default)();
	  var expiredDate = (0, _moment2.default)(date);
	  var isExpired = expiredDate.isBefore(now);
	  if (isExpired) return formatMessage({ id: 'task.overdue' });
	  if (dueDescription) return dueDescription;
	
	  return (0, _moment2.default)(date).calendar(null, {
	    sameDay: '[' + formatMessage({ id: 'task.dueToday' }) + ']',
	    nextDay: '[' + formatMessage({ id: 'task.dueTomorrow' }) + ']',
	    nextWeek: formatMessage({ id: _strings.SHORT_DATE_PATTERN.id }),
	    sameElse: (0, _is_same_year2.default)(date, new Date()) ? formatMessage(_strings.SHORT_DATE_PATTERN) : formatMessage(_strings.FULL_SHORT_DATE_PATTERN)
	  });
	};
	
	var timeToShow = exports.timeToShow = function timeToShow(completedTime, expiredTime, dueDescription, formatMessage) {
	  var completedDate = completedTime ? (0, _dateConverters.formatDateByYear)(completedTime, formatMessage) : null;
	  var expiredDate = expiredTime ? handleExpirationTime(expiredTime, dueDescription, formatMessage) : null;
	  return completedDate || expiredDate;
	};
	
	var handleElectronicConsentExpirationTime = exports.handleElectronicConsentExpirationTime = function handleElectronicConsentExpirationTime(date, formatMessage, isTaskCompleted) {
	  if (isTaskCompleted) {
	    return (0, _dateConverters.formatDateByYear)(date, formatMessage);
	  }
	
	  var now = (0, _moment2.default)();
	  var expiredDate = (0, _moment2.default)(date);
	  var isExpired = expiredDate.isBefore(now);
	  if (isExpired) return formatMessage({ id: 'task.overdue' });
	
	  var parsedDate = (0, _moment2.default)(date);
	
	  var isToday = parsedDate.isSame((0, _moment2.default)(), 'day');
	
	  var isTomorrow = parsedDate.isSame((0, _moment2.default)().add(1, 'day'), 'day');
	
	  if (!isToday && !isTomorrow) {
	    return 'Due ' + (0, _dateConverters.formatDateByYear)(date, formatMessage);
	  }
	
	  return (0, _moment2.default)(date).calendar(null, {
	    sameDay: '[' + formatMessage({ id: 'task.dueToday' }) + ']',
	    nextDay: '[' + formatMessage({ id: 'task.dueTomorrow' }) + ']'
	  });
	};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useCalculatePaddingYAxis = useCalculatePaddingYAxis;
	
	var _react = __webpack_require__(1);
	
	var _styles = __webpack_require__(18);
	
	function useCalculatePaddingYAxis() {
	  var currentInnerWidth = window.innerWidth;
	  return (0, _react.useMemo)(function () {
	    if (currentInnerWidth < _styles.BREAKPOINT_XGA) {
	      return 10;
	    }
	    if (currentInnerWidth < _styles.BREAKPOINT_LG) {
	      return 25;
	    }
	    if (currentInnerWidth < _styles.BREAKPOINT_HD_PLUS) {
	      return 35;
	    }
	    if (currentInnerWidth < _styles.BREAKPOINT_FULL_HD) {
	      return 45;
	    }
	    if (currentInnerWidth >= _styles.BREAKPOINT_FULL_HD) {
	      return 50;
	    }
	  }, [currentInnerWidth]);
	}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactImages = __webpack_require__(2782);
	
	var _reactImages2 = _interopRequireDefault(_reactImages);
	
	var _useDocumentPreview2 = __webpack_require__(3913);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserDocumentsPreview = function UserDocumentsPreview(_ref) {
	  var documents = _ref.documents;
	
	  var _useDocumentPreview = (0, _useDocumentPreview2.useDocumentPreview)(documents),
	      activeImageIdx = _useDocumentPreview.activeImageIdx,
	      images = _useDocumentPreview.images,
	      nextImage = _useDocumentPreview.nextImage,
	      prevImage = _useDocumentPreview.prevImage,
	      resetImageIdx = _useDocumentPreview.resetImageIdx;
	
	  return _react2.default.createElement(_reactImages2.default, {
	    images: images,
	    isOpen: activeImageIdx !== null,
	    onClickPrev: prevImage,
	    onClickNext: nextImage,
	    onClose: resetImageIdx,
	    currentImage: activeImageIdx,
	    backdropClosesModal: true,
	    showImageCount: false,
	    preloadNextImage: false
	  });
	};
	
	UserDocumentsPreview.propTypes = {
	  documents: _propTypes2.default.array.isRequired
	};
	
	exports.default = UserDocumentsPreview;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDriverLicenseDocumentFieldset = exports.getDocumentFieldset = exports.getFieldsetDescriptor = exports.getPatientFieldsetList = exports.getProviderFieldsetList = exports.getProfileFieldsetList = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _capitalize = __webpack_require__(209);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _convertSsnKey = __webpack_require__(3645);
	
	var _convertSsnKey2 = _interopRequireDefault(_convertSsnKey);
	
	var _chars = __webpack_require__(258);
	
	var _validations = __webpack_require__(362);
	
	var _transformSsnValue = __webpack_require__(3651);
	
	var _transformSsnValue2 = _interopRequireDefault(_transformSsnValue);
	
	var _getPhone = __webpack_require__(187);
	
	var _validations2 = __webpack_require__(81);
	
	var _convertFieldsError = __webpack_require__(3607);
	
	var _convertFieldsError2 = _interopRequireDefault(_convertFieldsError);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _dateConverters = __webpack_require__(83);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_FILE_SIZE = 32;
	var getPersonalFields = function getPersonalFields(isComplex, config, formatMessage) {
	  var _validationRules4;
	
	  var dob = config.dob,
	      ssn = config.ssn,
	      race = config.race,
	      gender = config.gender,
	      errors = config.errors,
	      mStatus = config.mStatus,
	      lastName = config.lastName,
	      language = config.language,
	      firstName = config.firstName,
	      languages = config.languages,
	      ethnicity = config.ethnicity,
	      middleName = config.middleName,
	      genderList = config.genderList,
	      nameSuffix = config.nameSuffix,
	      rawRaceList = config.rawRaceList,
	      citizenship = config.citizenship,
	      languageList = config.languageList,
	      veteranStatus = config.veteranStatus,
	      nameSuffixList = config.nameSuffixList,
	      educationLevel = config.educationLevel,
	      genderIdentity = config.genderIdentity,
	      profileEditable = config.profileEditable,
	      rawEthnicityList = config.rawEthnicityList,
	      maritalStatusList = config.maritalStatusList,
	      genderIdentityList = config.genderIdentityList,
	      educationLevelsList = config.educationLevelsList,
	      veteranStatusesList = config.veteranStatusesList,
	      primaryPatientProfile = config.primaryPatientProfile,
	      ssnHidingEnabled = config.ssnHidingEnabled;
	
	
	  var raceFields = primaryPatientProfile ? [{
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.race),
	    value: race,
	    type: 'select',
	    options: rawRaceList,
	    fieldName: 'race'
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.ethnicity),
	    value: ethnicity,
	    type: 'select',
	    options: rawEthnicityList,
	    fieldName: 'ethnicity'
	  }] : [];
	
	  var ssnField = primaryPatientProfile && !ssnHidingEnabled ? [(0, _extends3.default)({
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.ssnLong),
	    placeholder: formatMessage({ id: 'profile.fields.ssnPlaceHolder' }),
	    value: (0, _convertSsnKey2.default)(ssn),
	    fieldName: 'ssn',
	    disabled: !profileEditable,
	    limit: _validations2.LENGTH_VALUES.SSN,
	    shouldClearWhenOnFocus: true,
	    validationRules: (0, _defineProperty3.default)({}, _validations.RULES.SSN, {
	      message: 'profile.ssn.format',
	      expectedLengthShort: _validations2.LENGTH_VALUES.SSN_LAST_4,
	      expectedLengthFull: _validations2.LENGTH_VALUES.SSN
	    })
	  }, profileEditable && {
	    type: _constants.FIELDS_TYPE.PASSWORD,
	    transformValue: _transformSsnValue2.default
	  })] : [];
	
	  var nameFields = [{
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.firstName),
	    value: firstName,
	    fieldName: 'firstName',
	    validationRules: (0, _defineProperty3.default)({}, _validations.RULES.REQUIRED, {
	      message: 'profile.firstName.required'
	    }),
	    limit: _validations2.LENGTH_VALUES.FIRST_NAME.MAX,
	    disabled: !profileEditable
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.middleName),
	    value: middleName,
	    fieldName: 'middleName',
	    limit: _validations2.LENGTH_VALUES.MIDDLE_NAME.MAX,
	    disabled: !profileEditable
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.lastName),
	    value: lastName,
	    fieldName: 'lastName',
	    validationRules: (0, _defineProperty3.default)({}, _validations.RULES.REQUIRED, {
	      message: 'profile.lastName.required'
	    }),
	    limit: _validations2.LENGTH_VALUES.LAST_NAME.MAX,
	    disabled: !profileEditable
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.nameSuffix),
	    value: nameSuffix,
	    type: 'select',
	    fieldName: 'nameSuffix',
	    options: nameSuffixList,
	    disabled: !profileEditable
	  }];
	
	  if (!isComplex) {
	    nameFields = [{
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.name),
	      separator: _chars.SPACE,
	      value: nameFields
	    }];
	  }
	
	  var genderIdentityValue = void 0;
	
	  if ((0, _get2.default)(genderIdentity, 'description')) {
	    genderIdentityValue = (0, _get2.default)(genderIdentity, 'id');
	  }
	
	  var fields = [].concat((0, _toConsumableArray3.default)(nameFields), [{
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.gender),
	    value: gender,
	    type: 'select',
	    options: genderList,
	    fieldName: 'gender'
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.genderIdentity),
	    value: genderIdentityValue,
	    type: 'select',
	    options: genderIdentityList,
	    fieldName: 'genderIdentityId'
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.dob),
	    value: (0, _dateConverters.convertDateToUIFormat)(dob, formatMessage),
	    fieldName: 'dob',
	    type: 'date',
	    validationRules: (_validationRules4 = {}, (0, _defineProperty3.default)(_validationRules4, _validations.RULES.DOB, {
	      message: 'profile.dob.format'
	    }), (0, _defineProperty3.default)(_validationRules4, _validations.RULES.REQUIRED, {
	      message: 'profile.dob.required'
	    }), _validationRules4),
	    converters: {
	      fromView: function fromView(value) {
	        return (0, _dateConverters.convertDateToAPIFormat)(value, formatMessage);
	      }
	    },
	    withManualInputDob: true,
	    disabled: !profileEditable
	  }], ssnField, [{
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.mStatus),
	    value: mStatus,
	    type: 'select',
	    options: maritalStatusList,
	    fieldName: 'mStatus'
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.prefLanguage),
	    value: language,
	    type: 'select',
	    options: languageList,
	    fieldName: 'language'
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.languages),
	    value: languages,
	    type: 'select',
	    multi: true,
	    options: languageList,
	    transformValueFromOptions: true,
	    fieldName: 'languages'
	  }], raceFields, [{
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.veteranStatus),
	    value: veteranStatus && veteranStatus.id,
	    type: 'select',
	    options: veteranStatusesList,
	    transformValueFromOptions: true,
	    fieldName: 'veteranStatusId'
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.educationLevel),
	    value: educationLevel && educationLevel.id,
	    type: 'select',
	    options: educationLevelsList,
	    transformValueFromOptions: true,
	    fieldName: 'educationLevelId'
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.citizenship),
	    value: citizenship,
	    fieldName: 'citizenship',
	    limit: _validations2.LENGTH_VALUES.CITIZENSHIP
	  }]);
	
	  return {
	    title: formatMessage(_strings.PROFILE_FIELDS.listTitles.personal),
	    errors: (0, _convertFieldsError2.default)(fields, errors),
	    fields: fields,
	    columns: true
	  };
	};
	
	var getGeneralProfileFields = function getGeneralProfileFields(_ref, formatMessage) {
	  var _validationRules5, _validationRules6;
	
	  var bio = _ref.bio,
	      healthInterests = _ref.healthInterests,
	      aliasName = _ref.aliasName,
	      username = _ref.username,
	      healthInterestsList = _ref.healthInterestsList,
	      userOrganizations = _ref.userOrganizations,
	      hasActiveProfile = _ref.hasActiveProfile,
	      canEditOwnPatient = _ref.canEditOwnPatient,
	      _ref$employeeProfile = _ref.employeeProfile,
	      employeeProfile = _ref$employeeProfile === undefined ? {} : _ref$employeeProfile;
	
	  return [{
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.username),
	    value: username,
	    fieldName: 'username',
	    validationRules: (_validationRules5 = {}, (0, _defineProperty3.default)(_validationRules5, _validations.RULES.REQUIRED, {
	      message: 'profile.username.required'
	    }), (0, _defineProperty3.default)(_validationRules5, _validations.RULES.USERNAME_FORMAT, {
	      message: 'profile.username.format'
	    }), (0, _defineProperty3.default)(_validationRules5, _validations.RULES.MIN_LENGTH, {
	      message: 'profile.username.minCharacters',
	      length: _validations2.LENGTH_VALUES.USERNAME.MIN
	    }), _validationRules5),
	    limit: _validations2.LENGTH_VALUES.USERNAME.MAX,
	    disabled: canEditOwnPatient,
	    hintText: formatMessage(_strings.PROFILE_FIELDS.fieldHints.username)
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.aliasName),
	    value: aliasName,
	    fieldName: 'aliasName',
	    validationRules: (_validationRules6 = {}, (0, _defineProperty3.default)(_validationRules6, _validations.RULES.REQUIRED, {
	      message: 'profile.aliasName.required'
	    }), (0, _defineProperty3.default)(_validationRules6, _validations.RULES.ALIAS_FORMAT, {
	      message: 'profile.aliasName.format'
	    }), (0, _defineProperty3.default)(_validationRules6, _validations.RULES.MIN_LENGTH, {
	      message: 'profile.aliasName.minCharacters',
	      length: _validations2.LENGTH_VALUES.ALIAS.MIN
	    }), _validationRules6),
	    limit: _validations2.LENGTH_VALUES.ALIAS.MAX,
	    disabled: canEditOwnPatient,
	    hintText: formatMessage(_strings.PROFILE_FIELDS.fieldHints.aliasName)
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.bio),
	    value: bio,
	    type: 'textarea',
	    fieldName: 'bio',
	    limit: _validations2.LENGTH_VALUES.BIO.MAX,
	    fullWidth: true
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.healthInterests),
	    value: healthInterests,
	    type: 'select',
	    multi: true,
	    options: healthInterestsList,
	    fieldName: 'healthInterests',
	    fullWidth: true
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.organizations),
	    value: userOrganizations && userOrganizations.join(', '),
	    type: 'textarea',
	    fieldName: 'userOrganizations',
	    limit: _validations2.LENGTH_VALUES.ORGANIZATION.MAX,
	    disabled: true,
	    fullWidth: true
	  }].concat((0, _toConsumableArray3.default)(!(0, _isEmpty2.default)(employeeProfile) && [{
	    name: formatMessage(_strings.PROFILE_FIELDS.listTitles.affiliations),
	    value: employeeProfile && employeeProfile.employeeEmployers.map(function (item) {
	      return item.employer.name;
	    }).join(', '),
	    type: 'textarea',
	    fieldName: 'employers',
	    disabled: true,
	    fullWidth: true
	  }]));
	};
	
	var getTeamProfileFields = function getTeamProfileFields(_ref2, formatMessage) {
	  var actingAsTeam = _ref2.actingAsTeam;
	
	  return [{
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.organizations),
	    value: (0, _get2.default)(actingAsTeam, 'organization.name'),
	    type: 'textarea',
	    fieldName: 'organizations',
	    fullWidth: true
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.description),
	    value: (0, _get2.default)(actingAsTeam, 'description'),
	    type: 'textarea',
	    fieldName: 'description',
	    fullWidth: true
	  }];
	};
	
	var getProfileFieldsetList = exports.getProfileFieldsetList = function getProfileFieldsetList(teamActingUser, options, formatMessage) {
	  var errors = options.errors;
	
	
	  var fields = teamActingUser ? getTeamProfileFields(options, formatMessage) : getGeneralProfileFields(options, formatMessage);
	
	  return [{
	    title: formatMessage(_strings.PROFILE_FIELDS.listTitles.general),
	    errors: (0, _convertFieldsError2.default)(fields, errors),
	    fields: fields,
	    columns: true
	  }];
	};
	
	var getProviderFieldsetList = exports.getProviderFieldsetList = function getProviderFieldsetList(_ref3) {
	  var profile = _ref3.profile,
	      rawGenderList = _ref3.rawGenderList,
	      rawMaritalStatusList = _ref3.rawMaritalStatusList,
	      languageList = _ref3.languageList,
	      canEdit = _ref3.canEdit,
	      nameSuffixList = _ref3.nameSuffixList,
	      formatMessage = _ref3.intl.formatMessage,
	      profileEditable = _ref3.profileEditable,
	      errors = _ref3.errors,
	      veteranStatusesList = _ref3.veteranStatusesList,
	      educationLevelsList = _ref3.educationLevelsList;
	  var mStatus = profile.mStatus;
	
	
	  var genderList = (0, _convertListWithLocalization.convertGenderList)(rawGenderList, formatMessage);
	  var maritalStatusList = (0, _convertListWithLocalization.convertMaritalList)(rawMaritalStatusList, formatMessage);
	  var updatedVeteranStatusesList = (0, _convertListWithLocalization.convertListWithName)(veteranStatusesList);
	  var updatedEducationLevelsList = (0, _convertListWithLocalization.convertListWithName)(educationLevelsList);
	
	  var personalConfig = (0, _extends3.default)({}, profile, {
	    mStatus: mStatus,
	    profileEditable: profileEditable,
	    genderList: genderList,
	    maritalStatusList: maritalStatusList,
	    nameSuffixList: nameSuffixList,
	    languageList: languageList,
	    errors: errors,
	    veteranStatusesList: updatedVeteranStatusesList,
	    educationLevelsList: updatedEducationLevelsList
	  });
	
	  var personalFields = getPersonalFields(canEdit, personalConfig, formatMessage);
	
	  return [personalFields];
	};
	
	var getPatientFieldsetList = exports.getPatientFieldsetList = function getPatientFieldsetList(_ref4) {
	  var profile = _ref4.profile,
	      rawGenderList = _ref4.rawGenderList,
	      rawMaritalStatusList = _ref4.rawMaritalStatusList,
	      languageList = _ref4.languageList,
	      nameSuffixList = _ref4.nameSuffixList,
	      formatMessage = _ref4.intl.formatMessage,
	      canEdit = _ref4.canEdit,
	      canEditPatient = _ref4.canEditPatient,
	      profileEditable = _ref4.profileEditable,
	      errors = _ref4.errors,
	      rawRaceList = _ref4.rawRaceList,
	      rawEthnicityList = _ref4.rawEthnicityList,
	      rawGenderIdentityList = _ref4.rawGenderIdentityList,
	      veteranStatusesList = _ref4.veteranStatusesList,
	      educationLevelsList = _ref4.educationLevelsList,
	      ssnHidingEnabled = _ref4.ssnHidingEnabled;
	
	  var genderList = (0, _convertListWithLocalization.convertGenderList)(rawGenderList, formatMessage);
	  var maritalStatusList = (0, _convertListWithLocalization.convertMaritalList)(rawMaritalStatusList, formatMessage);
	
	  var isEditable = canEdit || canEditPatient;
	
	  var genderIdentityList = (0, _convertListWithLocalization.convertGenderIdentitiesList)(rawGenderIdentityList);
	  var updatedVeteranStatusesList = (0, _convertListWithLocalization.convertListWithName)(veteranStatusesList);
	  var updatedEducationLevelsList = (0, _convertListWithLocalization.convertListWithName)(educationLevelsList);
	
	  var personalConfig = (0, _extends3.default)({}, profile, {
	    profileEditable: profileEditable,
	    genderList: genderList,
	    maritalStatusList: maritalStatusList,
	    languageList: languageList,
	    nameSuffixList: nameSuffixList,
	    isEditable: isEditable,
	    errors: errors,
	    rawRaceList: rawRaceList,
	    rawEthnicityList: rawEthnicityList,
	    genderIdentityList: genderIdentityList,
	    veteranStatusesList: updatedVeteranStatusesList,
	    educationLevelsList: updatedEducationLevelsList,
	    ssnHidingEnabled: ssnHidingEnabled
	  });
	
	  var personalFields = getPersonalFields(isEditable, personalConfig, formatMessage);
	
	  return [personalFields];
	};
	
	var getFieldsetDescriptor = exports.getFieldsetDescriptor = function getFieldsetDescriptor(_ref5) {
	  var _validationRules8;
	
	  var email = _ref5.email,
	      phoneNumber = _ref5.phoneNumber,
	      errors = _ref5.errors,
	      formatMessage = _ref5.intl.formatMessage;
	
	  return [{
	    title: formatMessage(_strings.PROFILE_FIELDS.listTitles.contacts),
	    columns: true,
	    errors: errors,
	    fields: [{
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.mobilePhone),
	      value: (0, _getPhone.getPhoneWithoutUSCode)(phoneNumber),
	      fieldName: 'phoneNumber',
	      type: 'mobilePhone',
	      validationRules: (0, _defineProperty3.default)({}, _validations.RULES.PHONE, {
	        message: 'profile.phone.format'
	      }),
	      limit: _validations2.LENGTH_VALUES.PHONE_NUMBER.MAX
	    }, {
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.email),
	      value: email,
	      fieldName: 'email',
	      type: 'email',
	      validationRules: (_validationRules8 = {}, (0, _defineProperty3.default)(_validationRules8, _validations.RULES.EMAIL, {
	        message: 'profile.email.format'
	      }), (0, _defineProperty3.default)(_validationRules8, _validations.RULES.REQUIRED, {
	        message: 'profile.email.required'
	      }), _validationRules8)
	    }]
	  }];
	};
	
	var getDocumentFieldset = exports.getDocumentFieldset = function getDocumentFieldset(formatMessage, userDocuments, canEdit, optional) {
	  var getDocumentUrl = function getDocumentUrl(key, param) {
	    var document = userDocuments.find(function (doc) {
	      return doc.key === key;
	    });
	    return (0, _get2.default)(document, param);
	  };
	  var extraTitle = optional ? formatMessage({ id: 'common.optional' }) : '';
	
	  var frontCardUrl = getDocumentUrl(_constants.DOCUMENTATION_TYPES.CARD_1, 'attachment.thumbMiddle');
	  var insuranceCardName = formatMessage(_strings.PROFILE_FIELDS.fieldNames.insuranceCard);
	  var backCardName = !frontCardUrl && !canEdit ? insuranceCardName : '\xA0';
	  return {
	    title: formatMessage({ id: 'documentation.common.title' }),
	    columns: true,
	    fields: [{
	      name: insuranceCardName + ' ' + extraTitle,
	      hideEllipsis: true,
	      type: 'image',
	      fieldName: _constants.DOCUMENTATION_TYPES.CARD_1,
	      id: getDocumentUrl(_constants.DOCUMENTATION_TYPES.CARD_1, 'id'),
	      limit: MAX_FILE_SIZE,
	      value: '',
	      src: frontCardUrl,
	      text: formatMessage({
	        id: 'community.newPost.addPhoto'
	      }) + ' (' + formatMessage({ id: 'documentation.common.frontSide' }) + ')',
	      disabledText: formatMessage({
	        id: 'documentation.common.addPhoto'
	      }) + ' ' + (0, _capitalize2.default)(formatMessage({
	        id: 'documentation.common.frontSide'
	      }))
	    }, {
	      name: backCardName,
	      type: 'image',
	      fieldName: _constants.DOCUMENTATION_TYPES.CARD_2,
	      id: getDocumentUrl(_constants.DOCUMENTATION_TYPES.CARD_2, 'id'),
	      limit: MAX_FILE_SIZE,
	      value: null,
	      src: getDocumentUrl(_constants.DOCUMENTATION_TYPES.CARD_2, 'attachment.thumbMiddle'),
	      text: formatMessage({
	        id: 'community.newPost.addPhoto'
	      }) + ' (' + formatMessage({ id: 'documentation.common.backSide' }) + ')',
	      disabledText: formatMessage({
	        id: 'documentation.common.addPhoto'
	      }) + ' ' + (0, _capitalize2.default)(formatMessage({
	        id: 'documentation.common.backSide'
	      }))
	    }, {
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.driverLicense) + ' ' + extraTitle,
	      hideEllipsis: true,
	      type: 'image',
	      fieldName: _constants.DOCUMENTATION_TYPES.DRIVER_LICENCE,
	      id: getDocumentUrl(_constants.DOCUMENTATION_TYPES.DRIVER_LICENCE, 'id'),
	      limit: MAX_FILE_SIZE,
	      value: null,
	      src: getDocumentUrl(_constants.DOCUMENTATION_TYPES.DRIVER_LICENCE, 'attachment.thumbMiddle'),
	      text: '' + formatMessage({
	        id: 'community.newPost.addPhoto'
	      }),
	      disabledText: formatMessage({
	        id: 'documentation.common.addPhoto'
	      }) + ' ' + formatMessage({ id: 'profile.fields.driverLicense' })
	    }]
	  };
	};
	
	var getDriverLicenseDocumentFieldset = exports.getDriverLicenseDocumentFieldset = function getDriverLicenseDocumentFieldset(formatMessage, userDocuments, isEditMode) {
	  var getDocumentUrl = function getDocumentUrl(key, param) {
	    var document = userDocuments.find(function (doc) {
	      return doc.key === key;
	    });
	    return (0, _get2.default)(document, param);
	  };
	  var extraTitle = isEditMode ? formatMessage({ id: 'common.optional' }) : '';
	
	  return {
	    title: formatMessage({ id: 'documentation.common.title' }),
	    columns: true,
	    fields: [{
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.driverLicense) + ' ' + extraTitle,
	      hideEllipsis: true,
	      type: 'image',
	      fieldName: _constants.DOCUMENTATION_TYPES.DRIVER_LICENCE,
	      id: getDocumentUrl(_constants.DOCUMENTATION_TYPES.DRIVER_LICENCE, 'id'),
	      limit: MAX_FILE_SIZE,
	      value: null,
	      src: getDocumentUrl(_constants.DOCUMENTATION_TYPES.DRIVER_LICENCE, 'attachment.thumbMiddle'),
	      text: '' + formatMessage({
	        id: 'community.newPost.addPhoto'
	      }),
	      disabledText: '' + formatMessage({
	        id: 'profile.fields.driverLicense'
	      })
	    }]
	  };
	};

/***/ }),
/* 612 */,
/* 613 */,
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYMBOL_BY_PERIOD = exports.UNIT = exports.PERIOD = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _UNIT, _SYMBOL_BY_PERIOD;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PERIOD = exports.PERIOD = {
	  DAY: 'day',
	  WEEK: 'week',
	  MONTH: 'month',
	  QUARTER: 'quarter',
	  YEAR: 'year',
	  HIGH: 'high'
	};
	
	var UNIT = exports.UNIT = (_UNIT = {}, (0, _defineProperty3.default)(_UNIT, PERIOD.DAY, 'hour'), (0, _defineProperty3.default)(_UNIT, PERIOD.WEEK, 'day'), (0, _defineProperty3.default)(_UNIT, PERIOD.MONTH, 'day'), (0, _defineProperty3.default)(_UNIT, PERIOD.QUARTER, 'month'), (0, _defineProperty3.default)(_UNIT, PERIOD.YEAR, 'month'), (0, _defineProperty3.default)(_UNIT, PERIOD.HIGH, 'year'), _UNIT);
	
	var SYMBOL_BY_PERIOD = exports.SYMBOL_BY_PERIOD = (_SYMBOL_BY_PERIOD = {}, (0, _defineProperty3.default)(_SYMBOL_BY_PERIOD, PERIOD.DAY, '1 D'), (0, _defineProperty3.default)(_SYMBOL_BY_PERIOD, PERIOD.WEEK, '1 W'), (0, _defineProperty3.default)(_SYMBOL_BY_PERIOD, PERIOD.MONTH, '1 M'), (0, _defineProperty3.default)(_SYMBOL_BY_PERIOD, PERIOD.QUARTER, '3 M'), (0, _defineProperty3.default)(_SYMBOL_BY_PERIOD, PERIOD.YEAR, '1 Y'), (0, _defineProperty3.default)(_SYMBOL_BY_PERIOD, PERIOD.YEAR, '1 Y'), _SYMBOL_BY_PERIOD);

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasCardSideValues = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _FormButtons = __webpack_require__(3895);
	
	var _FormButtons2 = _interopRequireDefault(_FormButtons);
	
	var _DocumentsSection = __webpack_require__(1848);
	
	var _DocumentsSection2 = _interopRequireDefault(_DocumentsSection);
	
	var _AdditionalInsurancesSection = __webpack_require__(3892);
	
	var _AdditionalInsurancesSection2 = _interopRequireDefault(_AdditionalInsurancesSection);
	
	var _MainInsuranceFormSection = __webpack_require__(1791);
	
	var _MainInsuranceFormSection2 = _interopRequireDefault(_MainInsuranceFormSection);
	
	var _UploadingInsuranceCardModal = __webpack_require__(3589);
	
	var _UploadingInsuranceCardModal2 = _interopRequireDefault(_UploadingInsuranceCardModal);
	
	var _PrimarySubscriberFormSection = __webpack_require__(1792);
	
	var _PrimarySubscriberFormSection2 = _interopRequireDefault(_PrimarySubscriberFormSection);
	
	var _HandleErrorCheckProfileInsuranceModal = __webpack_require__(3586);
	
	var _HandleErrorCheckProfileInsuranceModal2 = _interopRequireDefault(_HandleErrorCheckProfileInsuranceModal);
	
	var _useUserDocuments2 = __webpack_require__(1155);
	
	var _useUserDocuments3 = _interopRequireDefault(_useUserDocuments2);
	
	var _useHealthPlanList2 = __webpack_require__(3911);
	
	var _useHealthPlanList3 = _interopRequireDefault(_useHealthPlanList2);
	
	var _useInsuranceFormManager = __webpack_require__(3910);
	
	var _useInsuranceFormManager2 = _interopRequireDefault(_useInsuranceFormManager);
	
	var _useAdditionalInsurance = __webpack_require__(3906);
	
	var _useAdditionalInsurance2 = _interopRequireDefault(_useAdditionalInsurance);
	
	var _useIsAdditionalInsurancesEnabledAndMaxNumber = __webpack_require__(1216);
	
	var _useIsAdditionalInsurancesEnabledAndMaxNumber2 = _interopRequireDefault(_useIsAdditionalInsurancesEnabledAndMaxNumber);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _formFields = __webpack_require__(38);
	
	var _common = __webpack_require__(864);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _getDocumentsConfig = __webpack_require__(907);
	
	var _index = __webpack_require__(5250);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _common2 = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRIMARY_SUBSCRIBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PRIMARY_SUBSCRIBER,
	    DO_NOT_HAVE_INSURANCE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DO_NOT_HAVE_INSURANCE,
	    HEALTH_PLAN = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.HEALTH_PLAN,
	    MEMBER_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.MEMBER_ID;
	var hasCardSideValues = exports.hasCardSideValues = function hasCardSideValues(side) {
	  return (0, _values2.default)(side || {}).filter(Boolean).length > 0;
	};
	
	var InsuranceForm = function InsuranceForm(_ref) {
	  var cancel = _ref.cancel,
	      flowType = _ref.flowType,
	      insuranceData = _ref.insuranceData,
	      navigateToNextPage = _ref.navigateToNextPage,
	      taskAssignmentId = _ref.taskAssignmentId,
	      userId = _ref.userId,
	      userName = _ref.userName,
	      withSelfPayEnding = _ref.withSelfPayEnding,
	      _ref$withPlanNotListe = _ref.withPlanNotListedOption,
	      withPlanNotListedOption = _ref$withPlanNotListe === undefined ? true : _ref$withPlanNotListe,
	      allowToCompleteWithoutFileUpload = _ref.allowToCompleteWithoutFileUpload;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _useHealthPlanList = (0, _useHealthPlanList3.default)(withPlanNotListedOption),
	      entities = _useHealthPlanList.entities,
	      handleHealthPlanInputChange = _useHealthPlanList.handleInputChange,
	      handleHealthPlanMenuScrollToBottom = _useHealthPlanList.handleMenuScrollToBottom,
	      isHealthPlanLoading = _useHealthPlanList.isLoading;
	
	  var uploadInsuranceCardModalData = (0, _reactRedux.useSelector)(_common.selectUploadInsuranceCardModalData);
	
	  var _useIsAdditionalInsur = (0, _useIsAdditionalInsurancesEnabledAndMaxNumber2.default)(),
	      isAdditionalInsurancesEnabled = _useIsAdditionalInsur.isAdditionalInsurancesEnabled;
	
	  var _useUserDocuments = (0, _useUserDocuments3.default)({ isEditMode: true }),
	      driverLicenseDocuments = _useUserDocuments.driverLicenseDocuments,
	      driverLicenseDocumentsConfig = _useUserDocuments.driverLicenseDocumentsConfig,
	      insuranceDocuments = _useUserDocuments.insuranceDocuments,
	      insuranceDocumentsConfig = _useUserDocuments.insuranceDocumentsConfig;
	
	  var _useInsuranceFormMana = (0, _useInsuranceFormManager2.default)({
	    insuranceData: insuranceData,
	    userId: userId,
	    userName: userName,
	    withSelfPayEnding: withSelfPayEnding,
	    flowType: flowType
	  }),
	      formErrors = _useInsuranceFormMana.formErrors,
	      formState = _useInsuranceFormMana.formState,
	      handleChangeField = _useInsuranceFormMana.handleChangeField,
	      handleFormChange = _useInsuranceFormMana.handleFormChange,
	      handleHealthPlanChange = _useInsuranceFormMana.handleHealthPlanChange,
	      haveInsuranceCheckboxLabel = _useInsuranceFormMana.haveInsuranceCheckboxLabel,
	      isPrimarySubscriber = _useInsuranceFormMana.isPrimarySubscriber,
	      isValid = _useInsuranceFormMana.isValid,
	      onHaveInsuranceChange = _useInsuranceFormMana.onHaveInsuranceChange,
	      onPrimarySubscriberChange = _useInsuranceFormMana.onPrimarySubscriberChange,
	      primarySubscriberCheckboxLabel = _useInsuranceFormMana.primarySubscriberCheckboxLabel,
	      userHasNotInsurance = _useInsuranceFormMana.userHasNotInsurance,
	      validateFormFields = _useInsuranceFormMana.validateFormFields;
	
	  var frontSide = (0, _get2.default)(formState, 'frontSide', null);
	  var backSide = (0, _get2.default)(formState, 'backSide', null);
	  var healthPlan = (0, _get2.default)(formState, 'healthPlan', null);
	
	  var isMainInsuranceSideCardsUploaded = hasCardSideValues(frontSide) && hasCardSideValues(backSide);
	
	  var _useAdditionalInsuran = (0, _useAdditionalInsurance2.default)({
	    isPrimarySubscriberDefault: isPrimarySubscriber
	  }),
	      validateAdditionalInsurancesFormFields = _useAdditionalInsuran.validateAdditionalInsurancesFormFields,
	      isAdditionalInsurancesFormsValid = _useAdditionalInsuran.isAdditionalInsurancesFormsValid,
	      additionalInsurancesProps = (0, _objectWithoutProperties3.default)(_useAdditionalInsuran, ['validateAdditionalInsurancesFormFields', 'isAdditionalInsurancesFormsValid']);
	
	  var insuranceSectionTitle = formatMessage({ id: 'profile.insurance' });
	
	  var isPlanNotListedSelected = Boolean(healthPlan && !healthPlan.id);
	
	  var showInsuranceSectionTitle = !_insuranceFlowType.SHOW_ADDITIONAL_STYLES_FOR_ADDITIONAL_INSURANCES.includes(flowType);
	
	  var showDocumentsSection = !_insuranceFlowType.SHOW_ADDITIONAL_STYLES_FOR_ADDITIONAL_INSURANCES.includes(flowType);
	
	  var isProfileFlow = flowType === _insuranceFlowType.INSURANCE_FLOW_TYPE.PROFILE;
	
	  var isToDoFlow = flowType === _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO;
	
	  var additionalInsurancesState = additionalInsurancesProps.additionalInsurances;
	
	  var allowToSkipMainInsurance = (0, _react.useMemo)(function () {
	    return [MEMBER_ID, HEALTH_PLAN].every(function (key) {
	      return !formState[key];
	    }) && formState[PRIMARY_SUBSCRIBER];
	  }, [formState]);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    if (isToDoFlow) {
	      var fieldName = 'toDoInsuranceCard';
	
	      var documents = [{
	        key: fieldName + '_1',
	        attachment: frontSide
	      }, {
	        key: fieldName + '_2',
	        attachment: backSide
	      }];
	
	      var documentsConfig = (0, _getDocumentsConfig.getAdditionalInsuranceCardDocumentsConfig)({
	        formatMessage: formatMessage,
	        userDocuments: documents,
	        // used to add (optional) placeholder to section title
	        isEditMode: allowToCompleteWithoutFileUpload,
	        fieldName: fieldName
	      });
	
	      return {
	        mainInsuranceDocuments: documents,
	        mainInsuranceDocumentsConfig: documentsConfig
	      };
	    }
	
	    return {
	      mainInsuranceDocuments: insuranceDocuments,
	      mainInsuranceDocumentsConfig: insuranceDocumentsConfig
	    };
	  }, [insuranceDocuments, insuranceDocumentsConfig, frontSide, backSide, isToDoFlow, allowToCompleteWithoutFileUpload]),
	      mainInsuranceDocuments = _useMemo.mainInsuranceDocuments,
	      mainInsuranceDocumentsConfig = _useMemo.mainInsuranceDocumentsConfig;
	
	  var disableSubmitButton = (0, _react.useMemo)(function () {
	    if (userHasNotInsurance) return false;
	
	    var isMainFormValid = isPlanNotListedSelected ? true : isValid;
	
	    if (!isAdditionalInsurancesEnabled) {
	      return !isMainFormValid;
	    }
	
	    if (isToDoFlow) {
	      return !isMainFormValid || !isAdditionalInsurancesFormsValid || !isMainInsuranceSideCardsUploaded && !allowToCompleteWithoutFileUpload;
	    }
	
	    if (allowToSkipMainInsurance && additionalInsurancesState.length) {
	      return !isAdditionalInsurancesFormsValid;
	    }
	
	    return !isMainFormValid || !isAdditionalInsurancesFormsValid;
	  }, [additionalInsurancesState, allowToSkipMainInsurance, isAdditionalInsurancesEnabled, isAdditionalInsurancesFormsValid, isToDoFlow, isValid, userHasNotInsurance, isPlanNotListedSelected, isMainInsuranceSideCardsUploaded, allowToCompleteWithoutFileUpload]);
	
	  var finishAction = (0, _react.useMemo)(function () {
	    if (flowType === _insuranceFlowType.INSURANCE_FLOW_TYPE.PAPERWORK) {
	      dispatch(_common2.paperworkCommonActions.setPaperworkInsuranceIsPlanNotListedSelected(isPlanNotListedSelected));
	    }
	
	    switch (flowType) {
	      case _insuranceFlowType.INSURANCE_FLOW_TYPE.PROFILE:
	      case _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO:
	        {
	          return cancel;
	        }
	
	      case _insuranceFlowType.INSURANCE_FLOW_TYPE.PAPERWORK:
	      case _insuranceFlowType.INSURANCE_FLOW_TYPE.GET_CARE_FLOW:
	        {
	          return navigateToNextPage;
	        }
	
	      default:
	        {
	          return null;
	        }
	    }
	  }, [flowType, navigateToNextPage, cancel, isPlanNotListedSelected]);
	
	  var onImageChange = function onImageChange(fieldName, imgValue, imgId) {
	    var payload = {
	      fieldName: fieldName,
	      imgId: imgId,
	      imgValue: imgValue,
	      userId: userId
	    };
	
	    var patientInsuranceId = (0, _get2.default)(insuranceData, 'id', null);
	
	    if (isToDoFlow) {
	      dispatch(_manageInsurancesActions.manageInsurancesActions.uploadInsuranceCard((0, _extends3.default)({}, payload, {
	        patientInsuranceId: patientInsuranceId,
	        handleAdditionalInsuranceFormChange: handleFormChange,
	        taskAssignmentId: taskAssignmentId
	      })));
	    } else {
	      dispatch(_manageInsurancesActions.manageInsurancesActions.uploadMainInsuranceCard((0, _extends3.default)({}, payload, {
	        handleFormChange: handleFormChange
	      })));
	    }
	  };
	
	  var saveInsurancesData = function saveInsurancesData() {
	    var saveAnyway = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var areAdditionalInsurancesValid = true;
	
	    var additionalInsurances = additionalInsurancesProps.additionalInsurances;
	
	    var _ref2 = userHasNotInsurance ? { isValid: true } : validateFormFields(formState),
	        isMainFormValid = _ref2.isValid;
	
	    if (isAdditionalInsurancesEnabled) {
	      additionalInsurances.forEach(function (insurance, index) {
	        var _validateAdditionalIn = validateAdditionalInsurancesFormFields(insurance, index),
	            isFormValid = _validateAdditionalIn.isValid;
	
	        if (!isFormValid) {
	          areAdditionalInsurancesValid = false;
	        }
	      });
	    }
	
	    if (!areAdditionalInsurancesValid || !isMainFormValid) return;
	
	    var additionalInsurancesFormState = additionalInsurances.map(function (_ref3) {
	      var insurancesFormState = _ref3.formState;
	      return insurancesFormState;
	    });
	
	    if (isToDoFlow) {
	      dispatch(_manageInsurancesActions.manageInsurancesActions.saveToDoInsurancesData({
	        mainInsuranceFormState: formState,
	        additionalInsurancesFormState: additionalInsurancesFormState,
	        userId: userId,
	        taskAssignmentId: taskAssignmentId,
	        finishAction: finishAction,
	        saveAnyway: saveAnyway
	      }));
	    } else {
	      dispatch(_manageInsurancesActions.manageInsurancesActions.savePatientInsurances({
	        flowType: flowType,
	        mainInsuranceFormState: formState,
	        additionalInsurancesFormState: additionalInsurancesFormState,
	        userId: userId,
	        finishAction: finishAction
	      }));
	    }
	  };
	
	  var onFormSubmit = function onFormSubmit(e) {
	    e.preventDefault();
	
	    saveInsurancesData();
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    showDocumentsSection && _react2.default.createElement(
	      'section',
	      { className: _index2.default.driverLicenseSection },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.driverLicenseSectionTitle },
	        driverLicenseDocumentsConfig.title
	      ),
	      _react2.default.createElement(_DocumentsSection2.default, {
	        config: driverLicenseDocumentsConfig,
	        documents: driverLicenseDocuments,
	        onImageChange: onImageChange
	      })
	    ),
	    _react2.default.createElement(
	      'form',
	      { onSubmit: onFormSubmit },
	      showInsuranceSectionTitle && _react2.default.createElement(
	        'div',
	        { className: _index2.default.insuranceDocumentsSectionTitle },
	        insuranceSectionTitle
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.checkbox, _index2.default.patientInsuranceCheckbox, (0, _defineProperty3.default)({}, _index2.default.patientInsuranceCheckbox_profile, isProfileFlow))
	        },
	        _react2.default.createElement(_Checkbox2.default, {
	          size: 16,
	          label: haveInsuranceCheckboxLabel,
	          id: DO_NOT_HAVE_INSURANCE,
	          onChange: onHaveInsuranceChange,
	          checked: Boolean(userHasNotInsurance)
	        })
	      ),
	      !userHasNotInsurance && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'section',
	          {
	            className: (0, _classnames2.default)(_index2.default.insuranceFormSection, (0, _defineProperty3.default)({}, _index2.default.insuranceFormSection_additionalStyles, !showInsuranceSectionTitle))
	          },
	          _react2.default.createElement(_DocumentsSection2.default, {
	            config: mainInsuranceDocumentsConfig,
	            documents: mainInsuranceDocuments,
	            onImageChange: onImageChange
	          }),
	          _react2.default.createElement(_MainInsuranceFormSection2.default, {
	            formState: formState,
	            isPlanNotListedSelected: isPlanNotListedSelected,
	            handleHealthPlanChange: handleHealthPlanChange,
	            entities: entities,
	            handleInputChange: handleHealthPlanInputChange,
	            handleMenuScrollToBottom: handleHealthPlanMenuScrollToBottom,
	            isLoading: isHealthPlanLoading,
	            handleFormChange: handleFormChange
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.primarySubscriberCheckbox },
	            _react2.default.createElement(_Checkbox2.default, {
	              size: 16,
	              disabled: isPlanNotListedSelected,
	              label: primarySubscriberCheckboxLabel,
	              id: PRIMARY_SUBSCRIBER,
	              checked: Boolean(isPrimarySubscriber),
	              onChange: onPrimarySubscriberChange
	            })
	          ),
	          !isPrimarySubscriber && _react2.default.createElement(_PrimarySubscriberFormSection2.default, {
	            formErrors: formErrors,
	            formState: formState,
	            handleChangeField: handleChangeField,
	            handleFormChange: handleFormChange
	          })
	        ),
	        isAdditionalInsurancesEnabled && _react2.default.createElement(_AdditionalInsurancesSection2.default, (0, _extends3.default)({}, additionalInsurancesProps, {
	          flowType: flowType,
	          entities: entities,
	          handleInputChange: handleHealthPlanInputChange,
	          handleMenuScrollToBottom: handleHealthPlanMenuScrollToBottom,
	          isLoading: isHealthPlanLoading,
	          primarySubscriberCheckboxLabel: primarySubscriberCheckboxLabel,
	          taskAssignmentId: taskAssignmentId,
	          userId: userId,
	          userName: userName
	        }))
	      ),
	      _react2.default.createElement(_FormButtons2.default, {
	        flowType: flowType,
	        cancel: cancel,
	        disableSubmitButton: disableSubmitButton
	      })
	    ),
	    _react2.default.createElement(_UploadingInsuranceCardModal2.default, uploadInsuranceCardModalData),
	    _react2.default.createElement(_HandleErrorCheckProfileInsuranceModal2.default, {
	      userId: userId,
	      skipInsurance: userHasNotInsurance,
	      finishAction: finishAction,
	      flowType: flowType,
	      handleSave: saveInsurancesData
	    })
	  );
	};
	
	InsuranceForm.propTypes = {
	  allowToCompleteWithoutFileUpload: _propTypes2.default.bool,
	  cancel: _propTypes2.default.func,
	  flowType: _propTypes2.default.oneOf((0, _keys2.default)(_insuranceFlowType.INSURANCE_FLOW_TYPE)).isRequired,
	  insuranceData: _propTypes2.default.object,
	  navigateToNextPage: _propTypes2.default.func,
	  taskAssignmentId: _propTypes2.default.number,
	  userId: _propTypes2.default.number,
	  userName: _propTypes2.default.string,
	  withSelfPayEnding: _propTypes2.default.bool,
	  withPlanNotListedOption: _propTypes2.default.bool
	};
	
	exports.default = InsuranceForm;

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ESC_KEY_CODE = exports.ESC_KEY_CODE = 27;
	
	var ISO_CODES = exports.ISO_CODES = {
	  US: 'us'
	};

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PCP_PROVIDER_ANSWER = exports.PCP_PROVIDER_ANSWER = {
	  N: 'N',
	  Y: 'Y',
	  U: 'U',
	  S: 'S'
	};
	
	var PCP_NOT_LISTED_VALUE = exports.PCP_NOT_LISTED_VALUE = 'PCP_NOT_LISTED';

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MEMBERSHIP_TYPE = exports.PROGRAM_COUNTERS = exports.PROGRAM_TYPE = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _PROGRAM_COUNTERS;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PROGRAM_TYPE = exports.PROGRAM_TYPE = {
	  ACTIVE: 'active',
	  INVITES: 'invites',
	  HISTORY: 'history'
	};
	
	var PROGRAM_COUNTERS = exports.PROGRAM_COUNTERS = (_PROGRAM_COUNTERS = {}, (0, _defineProperty3.default)(_PROGRAM_COUNTERS, PROGRAM_TYPE.ACTIVE, 'activeCount'), (0, _defineProperty3.default)(_PROGRAM_COUNTERS, PROGRAM_TYPE.HISTORY, 'historyCount'), (0, _defineProperty3.default)(_PROGRAM_COUNTERS, PROGRAM_TYPE.INVITES, 'invitationCount'), _PROGRAM_COUNTERS);
	
	var MEMBERSHIP_TYPE = exports.MEMBERSHIP_TYPE = {
	  ONE_TIME_PURCHASE: 'one_time',
	  RECURRENT: 'recurrent'
	};

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withErrorBoundary = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _ErrorBoundary = __webpack_require__(3279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withErrorBoundary = exports.withErrorBoundary = function withErrorBoundary(WrappedComponent) {
	  var WrappedComponentWithErrorBoundary = function WrappedComponentWithErrorBoundary(props) {
	    return _react2.default.createElement(
	      _ErrorBoundary.ErrorBoundary,
	      null,
	      _react2.default.createElement(WrappedComponent, props)
	    );
	  };
	
	  (0, _recompose.wrapDisplayName)(WrappedComponentWithErrorBoundary, 'withErrorBoundary');
	
	  return WrappedComponentWithErrorBoundary;
	};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _infiniteScroll = __webpack_require__(697);
	
	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WithLazyLoad = (_temp2 = _class = function (_React$Component) {
	  (0, _inherits3.default)(WithLazyLoad, _React$Component);
	
	  function WithLazyLoad() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, WithLazyLoad);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithLazyLoad.__proto__ || (0, _getPrototypeOf2.default)(WithLazyLoad)).call.apply(_ref, [this].concat(args))), _this), _this.infiniteScroll = null, _this.unscribeInfiniteScroll = function () {
	      _this.infiniteScroll && _this.infiniteScroll.unsubscribe();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(WithLazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initInfiniteScroll();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unscribeInfiniteScroll();
	    }
	  }, {
	    key: 'initInfiniteScroll',
	    value: function initInfiniteScroll() {
	      var loadMore = this.props.loadMore;
	
	
	      this.infiniteScroll = new _infiniteScroll2.default({
	        element: (0, _get2.default)(this.listNode, 'parentNode'),
	        loadEdgeOffset: 50,
	        type: 'lower',
	        onLoad: loadMore
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var children = this.props.children;
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(node) {
	            return _this2.listNode = node;
	          }, className: 'flex flex-column' },
	        children
	      );
	    }
	  }]);
	  return WithLazyLoad;
	}(_react2.default.Component), _class.propTypes = {
	  loadMore: _propTypes2.default.func,
	  children: _propTypes2.default.node.isRequired
	}, _temp2);
	exports.default = WithLazyLoad;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useInsuranceRelationOptions = function useInsuranceRelationOptions() {
	  var insuranceRelationList = (0, _reactRedux.useSelector)(_selectors.selectInsuranceRelationList);
	
	  var insuranceRelationOptions = insuranceRelationList.reduce(function (acc, _ref) {
	    var id = _ref.id,
	        name = _ref.name,
	        enabled = _ref.enabled;
	
	    if (enabled) {
	      acc.push({
	        value: id,
	        label: name
	      });
	    }
	
	    return acc;
	  }, []);
	
	  var hideInsuranceRelationFieldOrInfo = !insuranceRelationOptions.length;
	
	  var getInsuranceRelationTitleById = (0, _react.useCallback)(function (id) {
	    var matchedInsuranceRelation = insuranceRelationOptions.find(function (item) {
	      return item.value === id || typeof id === 'string' && id && item.value === Number(id);
	    });
	
	    return (0, _get2.default)(matchedInsuranceRelation, 'label', null);
	  }, [insuranceRelationOptions]);
	
	  return {
	    hideInsuranceRelationFieldOrInfo: hideInsuranceRelationFieldOrInfo,
	    getInsuranceRelationTitleById: getInsuranceRelationTitleById,
	    insuranceRelationOptions: insuranceRelationOptions
	  };
	};
	
	exports.default = useInsuranceRelationOptions;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          sending: true
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'confirm-inline-visit', ['SHOW_ERROR_ALERT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'unscheduled', 'local_appointments']
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState);

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'confirm-visit-urgent-req', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'unscheduled', 'urgent_appointments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'create-eir-urgent-care-appointment', ['SHOW_ERROR_ALERT']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'appointments', 'eir_urgent_care', 'appointments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'create-virtual-visit', ['INIT', 'OVERLAP']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'virtual_visits', 'provider_appointments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _checkInsuranceEligibility = __webpack_require__(292);
	
	var _insuranceEligibilityManualActivations = __webpack_require__(427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'latest-check-insurance-eligibility');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'insurance_eligibility',
	  type: 'get',
	  slug: ['results', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }]
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case _checkInsuranceEligibility.consts.SUCCEED:
	    case _insuranceEligibilityManualActivations.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, payload, {
	          error: null
	        });
	      }
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeMedicationsReqConfig = function makeMedicationsReqConfig() {
	  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return {
	    endpoint: 'users',
	    type: 'get',
	    slug: [{
	      type: 'payload',
	      selector: ['userId']
	    }, 'appointments', 'available_medications', 'ndc_drugs', {
	      type: 'payload.query',
	      queryParameter: 'query',
	      selector: 'query'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'limit',
	      selector: 'limit'
	    }].concat((0, _toConsumableArray3.default)(slug))
	  };
	};
	
	var requestOptions = makeMedicationsReqConfig([{
	  type: 'payload.query',
	  queryParameter: 'offset',
	  selector: 'offset'
	}]);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'medications-req', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('appointment-form', 'medications-req-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions, true);
	
	var defaultRequestReducer = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'total'
	});
	
	var initialState = (0, _extends3.default)({}, _redux.initialState);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      var safeData = payload.map(function (medication) {
	        return {
	          value: {
	            id: medication.ndcDrugId,
	            name: medication.displayableName
	          },
	          label: medication.displayableName
	        };
	      });
	
	      return (0, _extends3.default)({}, state, {
	        succeed: true,
	        sending: false,
	        isLastPage: payload && !payload.length,
	        list: state.list && state.list.length !== 0 ? state.list.concat(safeData) : safeData
	      });
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makePharmacyReqConfig = function makePharmacyReqConfig() {
	  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return {
	    endpoint: 'pharmacies',
	    type: 'get',
	    slug: [{
	      type: 'payload.query',
	      queryParameter: 'mail_order',
	      selector: 'mailOrder'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'zip',
	      selector: 'zip'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'limit',
	      selector: 'limit'
	    }].concat((0, _toConsumableArray3.default)(slug))
	  };
	};
	
	var requestOptions = makePharmacyReqConfig([{
	  type: 'payload.query',
	  queryParameter: 'offset',
	  selector: 'offset'
	}]);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'pharmacy-req', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('appointment-form', 'pharmacy-req-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions, true);
	
	var defaultRequestReducer = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'total'
	});
	
	var initialState = (0, _extends3.default)({}, _redux.initialState);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      return (0, _extends3.default)({}, state, {
	        succeed: true,
	        sending: false,
	        isLastPage: payload && !payload.length,
	        list: state.list && state.list.length !== 0 ? state.list.concat(payload) : payload
	      });
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          sending: true,
	          data: null
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true,
	          data: payload
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	    case consts.CLEAR:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'user-details');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  data: null
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_ORGANIZATION:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: []
	        });
	      }
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'visit_types-req', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['visit_types', {
	    type: 'payload.query',
	    queryParameter: 'filter_visit_type_locations',
	    selector: 'filterVisitTypeLocations'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'impersonated_user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'pbv_config_id',
	    selector: 'pbvConfigId'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'login-azure', ['INIT', 'SET_CREDENTIAL_FOR_MFA', 'SET_SUCCESS_SIGN_UP_FLOW']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.signupActions = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var _constants = __webpack_require__(1243);
	
	var signupActions = exports.signupActions = {
	  personalInfoChange: (0, _createAction.createAction)(_constants.SIGN_UP_TYPES.PERSONAL_INFO_CHANGE),
	  proceed: (0, _createAction.createAction)(_constants.SIGN_UP_TYPES.PROCEED),
	  confirm: (0, _createAction.createAction)(_constants.SIGN_UP_TYPES.CONFIRM),
	  reset: (0, _createAction.createAction)(_constants.SIGN_UP_TYPES.RESET)
	};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'block-user-for-dependent');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'impersonated_users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['dependentId']
	  }, 'chat', 'blocked_users']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _uniqBy = __webpack_require__(989);
	
	var _uniqBy2 = _interopRequireDefault(_uniqBy);
	
	var _lodash = __webpack_require__(58);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	var _chatConnection = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['GET_ITEMS', 'ADD_ITEMS', 'CLEAR', 'CHANGE_STATUS']; /* eslint-disable */
	/*
	 * First level chats (with / without context of the patient),
	 * containing nested channels within the context of the patient
	 */
	var consts = exports.consts = _consts2.default.apply(undefined, ['board', 'channels'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = [];
	
	var formatChannels = function formatChannels(list) {
	  var contextUsers = (0, _uniqBy2.default)(list, 'contextUser.id').filter(function (item) {
	    return item.contextUser;
	  });
	  var contextChannels = (0, _uniqBy2.default)(list, 'contextChannel.channelId').filter(function (item) {
	    return item.contextChannel;
	  });
	  return [].concat((0, _toConsumableArray3.default)(contextUsers), (0, _toConsumableArray3.default)(contextChannels));
	};
	
	var addChannels = function addChannels(state, action) {
	  var updatedList = Array.isArray(action.payload) ? [].concat((0, _toConsumableArray3.default)(state), (0, _toConsumableArray3.default)(action.payload)) : [action.payload].concat((0, _toConsumableArray3.default)(state));
	  return formatChannels(updatedList);
	};
	
	var addSubChannel = function addSubChannel(state, action) {
	  return state.map(function (item) {
	    if ((0, _lodash.has)(item, 'contextUser') && item.contextUser.id === action.payload.id) {
	      return (0, _extends3.default)({}, item, {
	        subchannels: [].concat((0, _toConsumableArray3.default)(item.subchannels), [action.payload.subChannel])
	      });
	    }
	    return item;
	  });
	};
	
	var addSocialChat = function addSocialChat(state, payload) {
	  return [payload].concat((0, _toConsumableArray3.default)(state));
	};
	
	var updateChatName = function updateChatName(state, action) {
	  return state.map(function (item) {
	    if ((0, _lodash.has)(item, 'contextChannel') && (0, _lodash.get)(item, 'contextChannel.channelId') === action.payload.channelId) {
	      return (0, _extends3.default)({}, item, {
	        contextChannel: (0, _extends3.default)({}, item.contextChannel, {
	          channelName: action.payload.channelName
	        })
	      });
	    }
	    if ((0, _lodash.has)(item, 'subchannels')) {
	      var subChannels = item.subchannels.map(function (subChannel) {
	        if (subChannel.channelId === action.payload.channelId) {
	          return (0, _extends3.default)({}, subChannel, {
	            channelName: action.payload.channelName
	          });
	        }
	        return subChannel;
	      });
	      return (0, _extends3.default)({}, item, {
	        subchannels: subChannels
	      });
	    }
	    return item;
	  });
	};
	
	var updateChat = function updateChat(state, payload) {
	  if ((0, _lodash.has)(payload, 'contextChannel')) {
	    return state.map(function (item) {
	      if ((0, _lodash.get)(item, 'contextChannel.channelId') === (0, _lodash.get)(payload, 'contextChannel.channelId')) {
	        return payload;
	      }
	      return item;
	    });
	  }
	  if ((0, _lodash.has)(payload, 'contextUser')) {
	    return state.map(function (item) {
	      if ((0, _lodash.get)(item, 'contextUser.id') === (0, _lodash.get)(payload, 'contextUser.id')) {
	        return payload;
	      }
	      return item;
	    });
	  }
	  return state;
	};
	
	var removeChat = function removeChat(state, payload) {
	  var channelId = payload.channelId,
	      contextId = payload.contextId;
	
	  return state.filter(function (item) {
	    if ((0, _lodash.has)(item, 'contextChannel') && (0, _lodash.get)(item, 'contextChannel.channelId') !== channelId) {
	      return item;
	    }
	    if ((0, _lodash.has)(item, 'subchannels')) {
	      if ((0, _lodash.get)(item, 'contextUser.id') === contextId) {
	        return (0, _extends3.default)({}, item, {
	          subchannels: item.subchannels.filter(function (item) {
	            return item.channelId !== channelId;
	          })
	        });
	      }
	      return item;
	    }
	  });
	};
	
	var removeContext = function removeContext(state, payload) {
	  var contextId = payload.contextId;
	
	  var channel = state.find(function (item) {
	    return (0, _lodash.get)(item, 'contextUser.id') === contextId;
	  });
	  return (0, _lodash.omit)(state, channel);
	};
	
	var removeContextUser = function removeContextUser(state, payload) {
	  return state.filter(function (item) {
	    return payload.contextUserId !== (0, _lodash.get)(item, 'contextUser.id');
	  });
	};
	
	var updateBlockedStatus = function updateBlockedStatus(state, payload) {
	  var ids = payload.ids;
	
	  return state.map(function (item) {
	    if ((0, _lodash.has)(item, 'contextChannel') && ids.includes((0, _lodash.get)(item, 'contextChannel.channelId'))) {
	      return (0, _extends3.default)({}, item, {
	        contextChannel: (0, _extends3.default)({}, item.contextChannel, { blocked: payload.blocked })
	      });
	    }
	    if ((0, _lodash.has)(item, 'subchannels')) {
	      var subChannels = item.subchannels.map(function (subChannel) {
	        if (ids.includes(subChannel.channelId)) {
	          return (0, _extends3.default)({}, subChannel, {
	            blocked: payload.blocked
	          });
	        }
	        return subChannel;
	      });
	      return (0, _extends3.default)({}, item, {
	        subchannels: subChannels
	      });
	    }
	    return item;
	  });
	};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.ADD_ITEMS:
	      return addChannels(state, action);
	    case consts.CLEAR:
	      return initialState;
	    case _chatConnection.consts.UPDATE_CHANNEL_SUBCHANNELS:
	      return addSubChannel(state, action);
	    case _chatConnection.consts.ADD_SOCIAL_CHAT:
	      return addSocialChat(state, payload);
	    case _chatConnection.consts.UPDATE_CHAT_NAME:
	      return updateChatName(state, action);
	    case _chatConnection.consts.UPDATE_CHANNEL:
	      return updateChat(state, payload);
	    case _chatConnection.consts.REMOVE_SOCIAL_CHANNEL:
	      return removeChat(state, payload);
	    case _chatConnection.consts.REMOVE_CONTEXT:
	      return removeContext(state, payload);
	    case _chatConnection.consts.REMOVE_CONTEXT_USER:
	      return removeContextUser(state, payload);
	    case _chatConnection.consts.UPDATE_BLOCKED_STATUS:
	      return updateBlockedStatus(state, payload);
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _filter = __webpack_require__(978);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _isUndefined = __webpack_require__(733);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['SET_CIRCLE', 'CLEAR', 'REMOVE_FAMILY_CIRCLE_ITEM', 'REMOVE_INVITATION', 'ADD_PENDING_ITEM'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['board', 'circleOfCare'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	// init
	var initialState = {
	  familyCircle: [],
	  careProviders: [],
	  pendingFamilyMembers: []
	};
	
	var removeInvitation = function removeInvitation(state, _ref) {
	  var invitationId = _ref.invitationId;
	
	  var list = (0, _get2.default)(state, 'pendingFamilyMembers');
	  var pendingFamilyMembers = (0, _arrayModify.removeArrayItem)(list, 'invitationId', invitationId);
	
	  return (0, _extends3.default)({}, state, { pendingFamilyMembers: pendingFamilyMembers });
	};
	
	var addPendingItem = function addPendingItem(state, item) {
	  var list = [].concat((0, _toConsumableArray3.default)((0, _get2.default)(state, 'pendingFamilyMembers')), [(0, _extends3.default)({}, item, { pending: true })]);
	
	  var guardians = list.filter(function (el) {
	    return el.careRole === "guardian";
	  });
	  var proxys = list.filter(function (el) {
	    return el.careRole === "proxy";
	  });
	  var parents = list.filter(function (el) {
	    return el.careRole === "parent";
	  });
	  var caregivers = list.filter(function (el) {
	    return el.careRole === "caregiver";
	  });
	  var rest = list.filter(function (el) {
	    return (0, _isUndefined2.default)(el.careRole);
	  });
	
	  return (0, _extends3.default)({}, state, {
	    pendingFamilyMembers: [].concat((0, _toConsumableArray3.default)(guardians), (0, _toConsumableArray3.default)(proxys), (0, _toConsumableArray3.default)(parents), (0, _toConsumableArray3.default)(caregivers), (0, _toConsumableArray3.default)(rest))
	  });
	};
	
	// reducer
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.REMOVE_FAMILY_CIRCLE_ITEM:
	      return (0, _extends3.default)({}, state, {
	        familyCircle: (0, _filter2.default)((0, _get2.default)(state, 'familyCircle', []), function (item) {
	          return item.id !== payload;
	        })
	      });
	    case consts.REMOVE_INVITATION:
	      return removeInvitation(state, payload);
	    case consts.ADD_PENDING_ITEM:
	      return addPendingItem(state, payload);
	    case consts.SET_CIRCLE:
	      return payload;
	    case consts.CLEAR:
	      return initialState;
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['ADD_ITEM', 'REMOVE_ITEM', 'CLEAR'];
	
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['board', 'replies'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initState = {};
	
	var addItem = function addItem(state, action) {
	  var channelId = (0, _get2.default)(action.payload, 'channelId');
	
	  return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, channelId, action.payload));
	};
	
	var removeItem = function removeItem(state, action) {
	  var channelId = action.payload;
	  var updatedState = (0, _extends4.default)({}, state);
	
	  delete updatedState[channelId];
	
	  return updatedState;
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.ADD_ITEM:
	      return addItem(state, action);
	    case consts.REMOVE_ITEM:
	      return removeItem(state, action);
	    case consts.CLEAR:
	      return initState;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqAllUsers', ['CLEAR', 'CLEAR_STATUS']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'query',
	    selector: 'query'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'excluded_ids',
	    selector: 'ids'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'type',
	    selector: 'type'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'context_user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'practice_context_user_id',
	    selector: 'contextUserId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'excluded_chatroom_id',
	    selector: 'channelId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'team_search',
	    selector: 'teamSearch'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'dashboard_provider_search',
	    selector: 'dashboardProviderSearch'
	  }]
	});
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return _redux.initialState;
	    case consts.CLEAR_STATUS:
	      return (0, _extends3.default)({}, state, {
	        succeed: null,
	        sending: false
	      });
	    default:
	      return reqReducer(state, action);
	  }
	};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqAssignPatient');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'assigned_patients',
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqAssignProvider');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'assigned_providers']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _merge = __webpack_require__(379);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqChannelParticipants', ['UPDATE_LIST']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'chat_rooms',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'participants']
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.UPDATE_LIST:
	      {
	        var loggedUserParticipants = payload.loggedUserParticipants,
	            dependentParticipants = payload.dependentParticipants;
	
	        var modifiedDependentParticipants = dependentParticipants.map(function (item) {
	          var blockedStatusForDependent = item.blocked,
	              rest = (0, _objectWithoutProperties3.default)(item, ['blocked']);
	
	          return (0, _extends3.default)({ blockedStatusForDependent: blockedStatusForDependent }, rest);
	        });
	        var updatedList = [].concat((0, _toConsumableArray3.default)((0, _merge2.default)(loggedUserParticipants, modifiedDependentParticipants)));
	        return (0, _extends3.default)({}, state, { list: updatedList });
	      }
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectReqAssignPatientSucceed = exports.selectReqAssignPatientPending = exports.selectReqInvitePatientSucceed = exports.selectReqInvitePatientError = exports.selectReqInvitePatientPending = exports.selectSucceedRelatedUsers = exports.sendingSelector = exports.membersSelector = exports.relatedUsersSelector = exports.selectRootState = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectAdapter = __webpack_require__(359);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'board');
	};
	var getSelectors = (0, _selectAdapter.makeSelectorFactory)(selectRootState);
	
	var relatedUsersSelector = exports.relatedUsersSelector = function relatedUsersSelector(state) {
	  return state.board.reqRelatedUsers;
	};
	
	var membersSelector = exports.membersSelector = (0, _reselect.createSelector)(relatedUsersSelector, function (members) {
	  return (0, _get2.default)(members, 'list', []);
	});
	
	var sendingSelector = exports.sendingSelector = (0, _reselect.createSelector)(relatedUsersSelector, function (request) {
	  return (0, _get2.default)(request, 'sending') || false;
	});
	
	var selectSucceedRelatedUsers = exports.selectSucceedRelatedUsers = (0, _reselect.createSelector)(relatedUsersSelector, function (request) {
	  return (0, _get2.default)(request, 'succeed') || false;
	});
	
	var _getSelectors = getSelectors('reqInvitePatient'),
	    selectReqInvitePatientPending = _getSelectors.selectStatePending,
	    selectReqInvitePatientError = _getSelectors.selectStateError,
	    selectReqInvitePatientSucceed = _getSelectors.selectStateSucceed;
	
	exports.selectReqInvitePatientPending = selectReqInvitePatientPending;
	exports.selectReqInvitePatientError = selectReqInvitePatientError;
	exports.selectReqInvitePatientSucceed = selectReqInvitePatientSucceed;
	
	var _getSelectors2 = getSelectors('reqAssignPatient'),
	    selectReqAssignPatientPending = _getSelectors2.selectStatePending,
	    selectReqAssignPatientSucceed = _getSelectors2.selectStateSucceed;
	
	exports.selectReqAssignPatientPending = selectReqAssignPatientPending;
	exports.selectReqAssignPatientSucceed = selectReqAssignPatientSucceed;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'unblock-user-for-dependent');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'impersonated_users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['dependentId']
	  }, 'chat', 'blocked_users', { type: 'payload', selector: ['userId'] }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.consts = undefined;
	
	var _index = __webpack_require__(7);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.consts = _constants2.default;
	exports.default = (0, _index.createActions)(_constants2.default);

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _circlesActions = __webpack_require__(1913);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'get-guardian-circles', ['REMOVE_ITEM', 'ADD_INVITATION', 'REMOVE_INVITATION', 'REMOVE_CAREGIVER', 'REMOVE_GUARDIAN_ROLE', 'REMOVE_MEMBER']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'member_guardian_proxy_circles',
	  type: 'get'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.REMOVE_ITEM:
	      return (0, _circlesActions.removeItem)(state, payload);
	    case consts.ADD_INVITATION:
	      return (0, _circlesActions.addInvitation)(state, payload);
	    case consts.REMOVE_INVITATION:
	      return (0, _circlesActions.removeInvitation)(state, payload);
	    case consts.REMOVE_CAREGIVER:
	      return (0, _circlesActions.removeRole)(state, payload, { caregiver: false });
	    case consts.REMOVE_GUARDIAN_ROLE:
	      return (0, _circlesActions.removeRole)(state, payload, {
	        guardian: false,
	        proxy: false,
	        parent: false
	      });
	    case consts.REMOVE_MEMBER:
	      return (0, _circlesActions.removeMember)(state, payload);
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'invite-to-circle-by-guardian');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'guardians_proxies']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'inviteCaregiverFamily');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'caregivers']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'memberFamilyCircle', ['REMOVE_ITEM']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'member_family_circles',
	  type: 'get'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var removeItem = function removeItem(state, _ref) {
	  var id = _ref.id;
	
	  var list = (0, _arrayModify.removeArrayItem)((0, _get2.default)(state, 'list', []), 'id', id);
	
	  return (0, _extends3.default)({}, state, { list: list });
	};
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.REMOVE_ITEM:
	      return removeItem(state, payload);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'remove-guardian-role');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'guardians_proxies', {
	    type: 'payload',
	    selector: ['memberId']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'removeCaregiverRole');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'caregivers', {
	    type: 'payload',
	    selector: ['memberId']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var supportedActions = ['GET_POSTS', 'GET_NEW_POSTS', 'GET_OLDER_POSTS'];
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'communityPosts', supportedActions);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'posts', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'leaveCommunity');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'participations']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _createReducer;
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('communities', 'newPostForm', 'UPDATE_FORM', 'CLEAR_FORM');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {};
	
	exports.default = (0, _redux.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, consts.UPDATE_FORM, function (state, action) {
	  return (0, _assign2.default)({}, state, (0, _extends3.default)({}, action.payload));
	}), (0, _defineProperty3.default)(_createReducer, consts.CLEAR_FORM, function (state, action) {
	  return initialState;
	}), _createReducer));

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'removeUserCommunity');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'members', {
	    type: 'payload',
	    selector: ['memberId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'reqMemberInvitation', ['CLEAR']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'member_invitations']
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var clear = function clear(state) {
	  return (0, _extends3.default)({}, state, {
	    succeed: null,
	    error: null
	  });
	};
	
	exports.default = function (state, action) {
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return clear(state);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.RESET:
	      {
	        return initialState;
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};
	
	var _index = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _index.createReqConsts)('complaints', 'resolve', ['RESET']);
	var actions = exports.actions = (0, _index.createActions)(consts);
	var watcher = exports.watcher = (0, _index.createReqWatcher)(consts, actions, {
	  endpoint: 'complaints',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'resolutions']
	});
	
	var initialState = (0, _extends3.default)({}, _index.initialState, {
	  data: undefined
	});
	
	var defaultRequestReducer = (0, _index.createReqReducer)(consts);

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectResolveComplaintLoading = exports.selectResolveComplaintState = exports.selectComplaintDetailsLoading = exports.selectComplaintDetails = exports.selectComplaintDetailsState = exports.makeSelectComplaintsCounter = exports.selectComplaintsCountersState = exports.selectReportMenuItemVisible = exports.selectComplaintsLoading = exports.selectUnresolvedListPagination = exports.selectUnResolvedList = exports.selectUnResolvedListState = exports.selectResolvedListPagination = exports.selectResolvedList = exports.selectResolvedListState = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _resolveComplaint = __webpack_require__(655);
	
	var _resolveComplaint2 = _interopRequireDefault(_resolveComplaint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectComplaintsState = function selectComplaintsState(state) {
	  return (0, _get2.default)(state, 'complaints');
	};
	
	/**
	 *  RESOLVED LIST
	 * */
	
	var selectResolvedListState = exports.selectResolvedListState = (0, _reselect.createSelector)(selectComplaintsState, function (state) {
	  return (0, _get2.default)(state, 'resolvedList');
	});
	
	var selectResolvedList = exports.selectResolvedList = (0, _reselect.createSelector)(selectResolvedListState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectResolvedListPagination = exports.selectResolvedListPagination = (0, _reselect.createSelector)(selectResolvedListState, function (state) {
	  return (0, _get2.default)(state, 'pagination', {});
	});
	
	/**
	 *  UN-RESOLVED LIST
	 * */
	
	var selectUnResolvedListState = exports.selectUnResolvedListState = (0, _reselect.createSelector)(selectComplaintsState, function (state) {
	  return (0, _get2.default)(state, 'unresolvedList');
	});
	
	var selectUnResolvedList = exports.selectUnResolvedList = (0, _reselect.createSelector)(selectUnResolvedListState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectUnresolvedListPagination = exports.selectUnresolvedListPagination = (0, _reselect.createSelector)(selectUnResolvedListState, function (state) {
	  return (0, _get2.default)(state, 'pagination', {});
	});
	
	var selectComplaintsLoading = exports.selectComplaintsLoading = (0, _reselect.createSelector)(selectResolvedListState, selectUnResolvedListState, function (resolvedState, unresolvedState) {
	  return (0, _get2.default)(resolvedState, 'sending') || (0, _get2.default)(unresolvedState, 'sending');
	});
	
	var selectReportMenuItemVisible = exports.selectReportMenuItemVisible = (0, _reselect.createSelector)(selectUnResolvedListState, function (state) {
	  return (0, _get2.default)(state, 'reportsVisible');
	});
	
	/**
	 *  COUNTERS
	 * */
	var selectComplaintsCountersState = exports.selectComplaintsCountersState = (0, _reselect.createSelector)(selectComplaintsState, function (state) {
	  return (0, _get2.default)(state, 'counters');
	});
	
	var makeSelectComplaintsCounter = exports.makeSelectComplaintsCounter = function makeSelectComplaintsCounter(type) {
	  return (0, _reselect.createSelector)(selectComplaintsCountersState, function (state) {
	    return (0, _get2.default)(state, type);
	  });
	};
	
	/**
	 *  COMPLAINT DETAILS
	 * */
	var selectComplaintDetailsState = exports.selectComplaintDetailsState = (0, _reselect.createSelector)(selectComplaintsState, function (state) {
	  return (0, _get2.default)(state, 'details');
	});
	
	var selectComplaintDetails = exports.selectComplaintDetails = (0, _reselect.createSelector)(selectComplaintDetailsState, function (state) {
	  return (0, _get2.default)(state, 'data');
	});
	
	var selectComplaintDetailsLoading = exports.selectComplaintDetailsLoading = (0, _reselect.createSelector)(selectComplaintDetailsState, function (state) {
	  return (0, _get2.default)(state, 'sending');
	});
	
	var selectResolveComplaintState = exports.selectResolveComplaintState = (0, _reselect.createSelector)(selectComplaintsState, function (state) {
	  return (0, _get2.default)(state, 'resolveComplaint');
	});
	
	var selectResolveComplaintLoading = exports.selectResolveComplaintLoading = (0, _reselect.createSelector)(selectResolveComplaintState, function (state) {
	  return (0, _get2.default)(state, 'sending');
	});

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'change-room-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dashboard',
	  type: 'put',
	  slug: ['appointments', {
	    type: 'payload',
	    selector: ['id']
	  }, 'change_room']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentForm', 'documents-delete', ['DELETE_SUCCESS']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dependent_registration',
	  type: 'delete',
	  slug: ['assignments', {
	    type: 'payload',
	    selector: ['id']
	  }, 'documents', {
	    type: 'payload',
	    selector: ['docId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentForm', 'personal-info');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dependent_registration',
	  type: 'post',
	  slug: ['assignments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makeApplyGuarantorConfig = function makeApplyGuarantorConfig() {
	  return {
	    endpoint: 'users',
	    type: 'post',
	    slug: [{
	      type: 'payload',
	      selector: ['userId']
	    }, 'guarantors', {
	      type: 'payload',
	      selector: ['id']
	    }, 'current_relation']
	  };
	};
	
	var requestOptions = makeApplyGuarantorConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('apply-guarantor');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makeCreateGuarantorConfig = function makeCreateGuarantorConfig() {
	  return {
	    endpoint: 'users',
	    type: 'post',
	    slug: [{
	      type: 'payload',
	      selector: ['userId']
	    }, 'guarantors']
	  };
	};
	
	var requestOptions = makeCreateGuarantorConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('create-guarantor');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makeGuarantorsReqConfig = function makeGuarantorsReqConfig() {
	  return {
	    endpoint: 'users',
	    type: 'get',
	    slug: [{
	      type: 'payload',
	      selector: ['userId']
	    }, 'guarantors']
	  };
	};
	
	var requestOptions = makeGuarantorsReqConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('guarantors');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-logging-action');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccda', 'user_documents', {
	    type: 'payload',
	    selector: ['documentUid']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-share-to-chat', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccda', 'chat_sharing_user_documents']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'complete-task', ['START']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'todo',
	  type: 'put',
	  slug: ['tasks', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'confirm-visit-by-patient', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'patient_confirmations']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'coupon-calculation');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'price_calculations', {
	    type: 'payload.query',
	    queryParameter: 'coupon_identifier',
	    selector: 'coupon'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'join-by-visit-code-req', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: ['virtual_visits', 'join_by_visit_code']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'appointment-urgent-visit-status-change');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'appointments', 'urgent_visits', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'status_changes']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _handleUpdateStateWithCompleteSurvey = __webpack_require__(770);
	
	var _handleUpdateStateWithAcceptedConsent = __webpack_require__(769);
	
	var _handleUpdateStateWithUploadDoc = __webpack_require__(772);
	
	var _handleUpdateStateWithDeleteDoc = __webpack_require__(771);
	
	var _arrayModify = __webpack_require__(153);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _appointmentReqConfig = __webpack_require__(850);
	
	var _uploadDocumentReq = __webpack_require__(304);
	
	var _deleteDocumentReq = __webpack_require__(302);
	
	var _editPaymentReq = __webpack_require__(349);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var _managePendingRequest = __webpack_require__(263);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requestOptions = (0, _appointmentReqConfig.makeVirtualAppointmentListReqConfig)([{
	  type: 'payload.query',
	  queryParameter: 'scope',
	  value: 'upcoming_list'
	}]);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'upcoming-virtual-appointment-list-req', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('health-board', 'upcoming-virtual-appointment-list-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions, true);
	
	var reducer = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'appointmentsCount'
	});
	
	exports.default = function (state, action) {
	  switch (action.type) {
	    case _uploadDocumentReq.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithUploadDoc.handleUpdateStateWithUploadDoc)(state, action);
	      }
	
	    case _editPaymentReq.consts.SUCCEED:
	      {
	        var target = state.list.find(function (_ref) {
	          var id = _ref.id;
	          return action.payload.id === id;
	        });
	        return (0, _extends3.default)({}, state, {
	          list: (0, _arrayModify.findAndReplace)(state.list, (0, _extends3.default)({}, target, {
	            copay: action.payload.copay
	          }))
	        });
	      }
	
	    case _managePendingRequest.consts.SUCCEED:
	      {
	        var _target = state.list.find(function (_ref2) {
	          var id = _ref2.id;
	          return action.payload.id === id;
	        });
	        if (_target) {
	          return (0, _extends3.default)({}, state, {
	            list: (0, _arrayModify.findAndReplace)(state.list, (0, _extends3.default)({}, _target, {
	              status: action.payload.status
	            }))
	          });
	        }
	        return (0, _extends3.default)({}, state);
	      }
	
	    case _appointmentDetails.APPOINTMENT_DETAILS_TYPES.REPLACE_APPOINTMENT:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: (0, _arrayModify.findAndReplace)(state.list, action.payload)
	        });
	      }
	
	    case _signAppointmentConsentReq.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithAcceptedConsent.handleUpdateStateWithAcceptedConsent)(state, action);
	      }
	
	    case _appointmentDetails.APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT:
	    case _cancelAppointmentReq.consts.SUCCEED:
	      {
	        var count = state.count - 1;
	        return (0, _extends3.default)({}, state, {
	          count: count >= 0 ? count : 0,
	          list: state.list.filter(function (_ref3) {
	            var id = _ref3.id;
	            return id !== action.payload.id;
	          })
	        });
	      }
	
	    case _upcomingSurveyCompletions.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithCompleteSurvey.handleUpdateStatusSurveyInAppointmentDetails)(state, action);
	      }
	
	    case _deleteDocumentReq.consts.UPDATE:
	      {
	        return (0, _handleUpdateStateWithDeleteDoc.handleUpdateStateWithDeleteDoc)(state, action);
	      }
	
	    default:
	      return reducer(state, action);
	  }
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectAdditionalInsurancesMaxNumber = exports.selectIsAdditionalInsurancesEnabled = exports.selectPatientInsurancesListIds = exports.selectPatientInsurancesList = exports.selectRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'managePatientInsurances.getPatientInsurancesList');
	};
	
	var selectPatientInsurancesList = exports.selectPatientInsurancesList = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectPatientInsurancesListIds = exports.selectPatientInsurancesListIds = (0, _reselect.createSelector)(selectPatientInsurancesList, function (list) {
	  return list.map(function (item) {
	    return (0, _get2.default)(item, 'id');
	  });
	});
	
	var selectIsAdditionalInsurancesEnabled = exports.selectIsAdditionalInsurancesEnabled = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'meta.additionalInsurancesEnabled', false);
	});
	
	var selectAdditionalInsurancesMaxNumber = exports.selectAdditionalInsurancesMaxNumber = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'meta.additionalInsurancesMaxNumber', 0);
	});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subscribeToForceUpdate = exports.emitForceUpdate = exports.subscribeToNotification = exports.emitPersistenceMessage = exports.emitNotification = exports.NOTIFICATION_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.makeNotificationBuilder = makeNotificationBuilder;
	
	var _pubsubJs = __webpack_require__(994);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOTIFICATION_EVENT = 'notification-event';
	
	var NOTIFICATION_TYPES = exports.NOTIFICATION_TYPES = {
	  JOIN: 'join',
	  LEAVE: 'leave',
	  START_TALK: 'start_talk',
	  STOP_TALK: 'stop_talk'
	};
	
	/**
	 *  EVENT PUB-SUB SECTION
	 * */
	var emitNotification = exports.emitNotification = function emitNotification(data) {
	  _pubsubJs2.default.publish(NOTIFICATION_EVENT, data);
	};
	
	var emitPersistenceMessage = exports.emitPersistenceMessage = function emitPersistenceMessage(data) {
	  _pubsubJs2.default.publish(NOTIFICATION_EVENT, (0, _extends3.default)({}, data, { persistence: true }));
	};
	
	var subscribeToNotification = exports.subscribeToNotification = function subscribeToNotification(cb) {
	  var token = _pubsubJs2.default.subscribe(NOTIFICATION_EVENT, function (msg, data) {
	    return cb(data);
	  });
	
	  return function () {
	    _pubsubJs2.default.unsubscribe(token);
	  };
	};
	
	/**
	 *  NOTIFICATION MESSAGES TEXT BUILDER
	 * */
	function makeNotificationBuilder(formatMessage) {
	  return function (_ref) {
	    var type = _ref.type,
	        name = _ref.name;
	
	    switch (type) {
	      case NOTIFICATION_TYPES.JOIN:
	        {
	          var id = 'virtualVisit.room.join';
	          return formatMessage({ id: id }, { name: name });
	        }
	      case NOTIFICATION_TYPES.LEAVE:
	        {
	          var _id = 'virtualVisit.room.leave';
	          return formatMessage({ id: _id }, { name: name });
	        }
	      case NOTIFICATION_TYPES.START_TALK:
	        {
	          var _id2 = 'virtualVisit.room.isTalking';
	          return formatMessage({ id: _id2 }, { name: name });
	        }
	      case NOTIFICATION_TYPES.STOP_TALK:
	        {
	          return '';
	        }
	
	      default:
	        {
	          return '';
	        }
	    }
	  };
	}
	
	var FORCE_UPDATE_EVENT = 'force-update';
	
	var emitForceUpdate = exports.emitForceUpdate = function emitForceUpdate() {
	  _pubsubJs2.default.publish(FORCE_UPDATE_EVENT);
	};
	
	var subscribeToForceUpdate = exports.subscribeToForceUpdate = function subscribeToForceUpdate(cb) {
	  var token = _pubsubJs2.default.subscribe(FORCE_UPDATE_EVENT, cb);
	
	  return function () {
	    _pubsubJs2.default.unsubscribe(token);
	  };
	};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('paperwork', 'appointment-session');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'paperwork',
	  type: 'post',
	  slug: ['appointments', {
	    type: 'payload',
	    selector: ['appointmentUUID']
	  }, 'sessions']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('paperwork', 'get-additional-info');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['questions', {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'patient_user_id',
	    selector: 'patientUserId'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _cancelAppointmentReq.consts.SUCCEED:
	    case _statusChangeReq.consts.SUCCEED:
	    case _paperworkSubmitAppointment.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, action.payload);
	      }
	
	    case _signAppointmentConsentReq.consts.SUCCEED:
	      {
	        var consentsAssignment = (0, _get2.default)(state, 'consentsAssignment', {});
	
	        var _ref = consentsAssignment || {},
	            _ref$consents = _ref.consents,
	            consents = _ref$consents === undefined ? [] : _ref$consents;
	
	        var newConsents = consents.map(function (consent) {
	          if (consent.id === action.payload.appointmentConsentId) {
	            return (0, _extends3.default)({}, consent, {
	              accepted: true,
	              version: action.payload.version
	            });
	          }
	          return consent;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          consentsAssignment: (0, _extends3.default)({}, consentsAssignment, {
	            consents: newConsents,
	            allSigned: newConsents.every(function (consent) {
	              return consent.accepted;
	            })
	          })
	        });
	      }
	
	    case _upcomingSurveyAnswers.consts.SUCCEED:
	      {
	        var surveysAssignments = (0, _get2.default)(state, 'surveysAssignments', []);
	
	        var newSurveysAssignments = surveysAssignments.map(function (assignment) {
	          if (assignment.id === action.payload.assignmentId) {
	            return (0, _extends3.default)({}, assignment, action.payload);
	          }
	          return assignment;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          surveysAssignments: newSurveysAssignments
	        });
	      }
	
	    case consts.SET_PCP_FORM_DATA:
	      {
	        var payload = action.payload;
	
	
	        return (0, _extends3.default)({}, state, {
	          pcpProviderAnswer: payload.pcpProviderAnswer,
	          pcpName: payload.pcpName,
	          considerUsPcp: payload.considerUsPcp,
	          primaryCareProvider: payload.pcp
	        });
	      }
	
	    case _appointmentAccountFormPaymentReq.consts.SUCCEED:
	    case _paymentVerificationsReq.consts.SUCCEED:
	      {
	        var _payload = action.payload;
	
	
	        var appointmentId = (0, _get2.default)(state, 'id', null);
	
	        var payable = (0, _get2.default)(_payload, 'payable', null);
	
	        if (appointmentId && payable) {
	          return (0, _extends3.default)({}, state, payable);
	        }
	
	        return state;
	      }
	
	    case _upcomingSurveyCompletions.consts.SUCCEED:
	      {
	        var _payload2 = action.payload;
	
	        var _ref2 = _payload2 || {},
	            assignmentId = _ref2.assignmentId;
	
	        var _ref3 = state || {},
	            _ref3$surveyAssignmen = _ref3.surveyAssignments,
	            surveyAssignments = _ref3$surveyAssignmen === undefined ? [] : _ref3$surveyAssignmen;
	
	        if (assignmentId && surveyAssignments.length) {
	          var newSurveyAssignments = surveyAssignments.map(function (assignment) {
	            if (assignment.assignmentId === assignmentId) {
	              return _payload2;
	            }
	            return assignment;
	          });
	
	          return (0, _extends3.default)({}, state, {
	            surveyAssignments: newSurveyAssignments
	          });
	        }
	
	        return state;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _paperworkSubmitAppointment = __webpack_require__(867);
	
	var _upcomingSurveyAnswers = __webpack_require__(546);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var _paymentVerificationsReq = __webpack_require__(419);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var _appointmentAccountFormPaymentReq = __webpack_require__(339);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('paperwork', 'get-appointment-details', ['SET_PCP_FORM_DATA']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'paperwork',
	  type: 'get',
	  slug: ['appointments', {
	    type: 'payload',
	    selector: ['appointmentUUID']
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('paperwork', 'dob-verify');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'paperwork',
	  type: 'post',
	  slug: ['appointments', {
	    type: 'payload',
	    selector: ['appointmentUUID']
	  }, 'dob_verifications']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makeDeleteCardConfig = function makeDeleteCardConfig() {
	  return {
	    endpoint: 'users',
	    type: 'delete',
	    slug: [{
	      type: 'payload',
	      selector: ['userId']
	    }, 'accountvaults', {
	      type: 'payload',
	      selector: ['id']
	    }]
	  };
	};
	
	var requestOptions = makeDeleteCardConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('payment-methods', 'delete-card');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'confirm-phone-number', ['CLEAR']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'change_phone_number']
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var clear = function clear(state) {
	  return (0, _extends3.default)({}, state, {
	    succeed: null,
	    error: null
	  });
	};
	
	exports.default = function (state, action) {
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return clear(state);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'create-patient'); // Endpoint for creating patient profile, when user is family member
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'getParentProfile');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'provider_profile']
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'mfa-confirmation');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'mfa_confirmations',
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.myProfileRedirectActions = exports.MY_PROFILE_REDIRECT_TYPES = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.profileRedirectSaga = profileRedirectSaga;
	
	var _effects = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(42);
	
	var _createAction = __webpack_require__(68);
	
	var _selectors = __webpack_require__(23);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(redirectToCurrentProfile),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(profileRedirectSaga);
	
	var MY_PROFILE_REDIRECT_TYPES = exports.MY_PROFILE_REDIRECT_TYPES = {
	  GO_TO_PROFILE: 'my-profile-redirect/go-to-profile'
	};
	
	var myProfileRedirectActions = exports.myProfileRedirectActions = {
	  goToProfile: (0, _createAction.createAction)(MY_PROFILE_REDIRECT_TYPES.GO_TO_PROFILE)
	};
	
	function redirectToCurrentProfile() {
	  var user, _ref, id, primaryProviderProfile, role;
	
	  return _regenerator2.default.wrap(function redirectToCurrentProfile$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.loggedUserSelector);
	
	        case 2:
	          user = _context.sent;
	          _ref = user || {}, id = _ref.id, primaryProviderProfile = _ref.primaryProviderProfile;
	          role = primaryProviderProfile ? 'provider' : 'patient';
	
	          _reactRouter.browserHistory.push('/' + _routes.PROFILE + '/' + id + '/' + role);
	
	        case 6:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function profileRedirectSaga() {
	  return _regenerator2.default.wrap(function profileRedirectSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(MY_PROFILE_REDIRECT_TYPES.GO_TO_PROFILE, redirectToCurrentProfile);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'add-height-data');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'post',
	  slug: ['local_height_measurements']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'add-weight-data');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'post',
	  slug: ['local_weight_measurements']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'provider-authentications');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['provider_authentications']
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'editability_check');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'editability_check']
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'acceptInvitation', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  slug: [{ type: 'payload', selector: ['userId'] }, 'programs', 'invitations', { type: 'payload', selector: ['invitationId'] }],
	  type: 'put'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'accountVaults');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{ type: 'payload', selector: ['userId'] }, 'accountvaults', {
	    type: 'payload.query',
	    queryParameter: 'subject_id',
	    selector: 'subjectId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'subject_type',
	    selector: 'subjectType'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'declineInvitation', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  slug: [{ type: 'payload', selector: ['userId'] }, 'programs', 'invitations', { type: 'payload', selector: ['invitationId'] }],
	  type: 'delete'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _managePendingRequest = __webpack_require__(263);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var _constants = __webpack_require__(17);
	
	var _validate = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'search', ['INIT_LOAD']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'schedule', {
	    type: 'payload.query',
	    queryParameter: 'start_on',
	    selector: 'startOn'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'end_on',
	    selector: 'endOn'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  workSlots: [],
	  blockedSlots: [],
	  appointments: []
	});
	
	var cancelledStatuses = [_constants.APPOINTMENT_STATUSES.CANCELED, _constants.APPOINTMENT_STATUSES.DECLINED];
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case _statusChangeReq.consts.SUCCEED:
	    case _managePendingRequest.consts.SUCCEED:
	      {
	        var appointments = state.appointments.reduce(function (list, appointment) {
	          if (appointment.id === payload.id) {
	            var status = (0, _get2.default)(payload, 'status.coreAppName');
	            var isCancelled = cancelledStatuses.includes(status);
	
	            return isCancelled ? list : [].concat((0, _toConsumableArray3.default)(list), [(0, _extends3.default)({}, appointment, { status: payload.status })]);
	          }
	          return [].concat((0, _toConsumableArray3.default)(list), [appointment]);
	        }, []);
	
	        return (0, _extends3.default)({}, state, {
	          appointments: appointments
	        });
	      }
	
	    case _cancelAppointmentReq.consts.SUCCEED:
	      {
	        var _appointments = state.appointments.filter(function (_ref) {
	          var id = _ref.id;
	          return id !== payload.id;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          appointments: _appointments
	        });
	      }
	
	    case _validate.SCHEDULE_VALIDATE_TYPES.CLEAR:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'submit', ['CLEAR', 'MESSAGE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'upcoming_assignments', {
	    type: 'payload',
	    selector: ['surveyId']
	  }]
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function (state, action) {
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return _redux.initialState;
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'submitReferralForm', ['MESSAGE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'refferal_forms']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'upcoming-survey-cancel-filling');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['targetUserId']
	  }, 'upcoming_assignments', {
	    type: 'payload',
	    selector: ['assignmentId']
	  }, 'cancel_filling']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'upcoming-survey-proceed');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['targetUserId']
	  }, 'upcoming_assignments', {
	    type: 'payload',
	    selector: ['assignmentId']
	  }, 'proceed']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'contextbar', 'TOGGLE_VISIBILITY', 'RESET');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  visible: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.TOGGLE_VISIBILITY:
	      return (0, _extends3.default)({}, state, {
	        visible: !state.visible
	      });
	    case consts.RESET:
	      return initialState;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _adaptRelationValue = __webpack_require__(4210);
	
	Object.defineProperty(exports, 'adaptRelationValue', {
	  enumerable: true,
	  get: function get() {
	    return _adaptRelationValue.adaptRelationValue;
	  }
	});
	
	var _normalizeRelationList = __webpack_require__(4211);
	
	Object.defineProperty(exports, 'normalizeRelationList', {
	  enumerable: true,
	  get: function get() {
	    return _normalizeRelationList.normalizeRelationList;
	  }
	});

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable immutable/no-mutation,no-unused-expressions */
	var InfiniteScroll = function () {
	  function InfiniteScroll(_ref) {
	    var _this = this;
	
	    var totalPages = _ref.totalPages,
	        currentPage = _ref.currentPage,
	        element = _ref.element,
	        onLoad = _ref.onLoad,
	        _ref$loadEdgeOffset = _ref.loadEdgeOffset,
	        loadEdgeOffset = _ref$loadEdgeOffset === undefined ? 100 : _ref$loadEdgeOffset,
	        _ref$loaderHeight = _ref.loaderHeight,
	        loaderHeight = _ref$loaderHeight === undefined ? 0 : _ref$loaderHeight,
	        _ref$useWindowAsScrol = _ref.useWindowAsScrollContainer,
	        useWindowAsScrollContainer = _ref$useWindowAsScrol === undefined ? false : _ref$useWindowAsScrol,
	        _ref$type = _ref.type,
	        type = _ref$type === undefined ? 'upper' : _ref$type,
	        _ref$isLoadAtStart = _ref.isLoadAtStart,
	        isLoadAtStart = _ref$isLoadAtStart === undefined ? false : _ref$isLoadAtStart;
	    (0, _classCallCheck3.default)(this, InfiniteScroll);
	
	    this.scrollToTop = function () {
	      if (_this.useWindowAsScrollContainer) {
	        window.scrollTo(0, 0);
	      } else if (_this.element) {
	        _this.element.scrollTop = 0;
	      }
	    };
	
	    this.scrollToDown = function () {
	      if (_this.useWindowAsScrollContainer) {
	        window.scrollTo(0, window.innerHeight);
	      } else {
	        _this.element.scrollTop = _this.element.scrollHeight;
	      }
	    };
	
	    this.subscribe = function () {
	      if (_this.useWindowAsScrollContainer) {
	        window.addEventListener('scroll', _this.handleScroll);
	      } else {
	        _this.element && _this.element.addEventListener('scroll', _this.handleScroll);
	      }
	    };
	
	    this.unsubscribe = function () {
	      if (_this.useWindowAsScrollContainer) {
	        window.removeEventListener('scroll', _this.handleScroll);
	      } else {
	        _this.element && _this.element.removeEventListener('scroll', _this.handleScroll);
	      }
	    };
	
	    this.handleScroll = function () {
	      if (_this.currentPage < _this.totalPages) {
	        if (_this._getScrollOffset() === 0) {
	          _this.element.scrollTop = _this._getClientHeight() + _this._getScrollOffset();
	        }
	      }
	      if (_this.type === 'lower') {
	        _this._calculateLowerScroll();
	      } else if (_this.type === 'upper') {
	        _this._calculateUpperScroll();
	      }
	    };
	
	    this.setCurrentPage = function (value) {
	      _this.currentPage = value;
	    };
	
	    this.setTotalPages = function (value) {
	      _this.totalPages = value;
	    };
	
	    this.element = element;
	    this.loadEdgeOffset = loadEdgeOffset;
	    this.loaderHeight = loaderHeight;
	    this.onLoad = onLoad;
	    this.useWindowAsScrollContainer = useWindowAsScrollContainer;
	
	    // can be 'upper' or 'lower'
	    this.type = type;
	    this.isCanCallLoad = isLoadAtStart;
	
	    this.subscribe();
	    this.scrollToTop();
	    this.totalPages = totalPages;
	    this.currentPage = currentPage;
	  }
	
	  (0, _createClass3.default)(InfiniteScroll, [{
	    key: '_calculateUpperScroll',
	    value: function _calculateUpperScroll() {
	      if (this._getScrollOffset() > 0 && this._getScrollOffset() < this.loadEdgeOffset) {
	        if (this.isCanCallLoad) {
	          if (this.onLoad) this.onLoad();
	        }
	        this.isCanCallLoad = false;
	      }
	      if (this._getScrollOffset() > this.loadEdgeOffset + this.loaderHeight) {
	        this.isCanCallLoad = true;
	      }
	    }
	  }, {
	    key: '_calculateLowerScroll',
	    value: function _calculateLowerScroll() {
	      if (this._getContainerHeight() < this._getClientHeight() + this._getScrollOffset() + this.loadEdgeOffset) {
	        if (this.isCanCallLoad) {
	          if (this.onLoad) this.onLoad();
	        }
	        this.isCanCallLoad = false;
	      }
	      if (this._getContainerHeight() > this._getClientHeight() + this._getScrollOffset() + this.loadEdgeOffset + this.loaderHeight) {
	        this.isCanCallLoad = true;
	      }
	    }
	  }, {
	    key: '_getContainerHeight',
	    value: function _getContainerHeight() {
	      if (this.useWindowAsScrollContainer) {
	        return document.body.scrollHeight;
	      }
	      return this.element.scrollHeight;
	    }
	  }, {
	    key: '_getClientHeight',
	    value: function _getClientHeight() {
	      if (this.useWindowAsScrollContainer) {
	        return window.innerHeight;
	      }
	      return this.element.clientHeight;
	    }
	  }, {
	    key: '_getScrollOffset',
	    value: function _getScrollOffset() {
	      if (this.useWindowAsScrollContainer) {
	        return window.pageYOffset;
	      }
	      return this.element.scrollTop;
	    }
	  }]);
	  return InfiniteScroll;
	}();
	
	exports.default = InfiniteScroll;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.repeatScheduleAdapter = repeatScheduleAdapter;
	exports.removeRepeatScheduleAdapter = removeRepeatScheduleAdapter;
	exports.noRepeatScheduleAdapter = noRepeatScheduleAdapter;
	exports.getPrevDayRepeatableAdapter = getPrevDayRepeatableAdapter;
	exports.getRepeatFlow = getRepeatFlow;
	exports.scheduleFormAdapter = scheduleFormAdapter;
	exports.scheduleCurrentDaySettingsAttrsAdapter = scheduleCurrentDaySettingsAttrsAdapter;
	exports.scheduleOriginDaySettingsAttrsAdapter = scheduleOriginDaySettingsAttrsAdapter;
	exports.isLastDayOfRepeat = isLastDayOfRepeat;
	exports.isOnlyEndRepeatDateChange = isOnlyEndRepeatDateChange;
	exports.isFirstDayOfCustomRepeatChange = isFirstDayOfCustomRepeatChange;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _pick = __webpack_require__(466);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _omitBy = __webpack_require__(983);
	
	var _omitBy2 = _interopRequireDefault(_omitBy);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(105);
	
	var _dateFormatter = __webpack_require__(314);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function repeatScheduleAdapter(option, schedule, formData) {
	  var scheduleSettingAttributes = formData.scheduleSettingAttributes,
	      restFormData = (0, _objectWithoutProperties3.default)(formData, ['scheduleSettingAttributes']);
	
	
	  switch (option) {
	    case _constants.RECURSION_OPTIONS.CURRENT_DAY:
	      {
	        return (0, _extends3.default)({}, restFormData, {
	          scheduleSettingAttributes: (0, _extends3.default)({}, scheduleSettingAttributes, {
	            endOn: (0, _dateFormatter.formatToAPIDateFormat)((0, _get2.default)(scheduleSettingAttributes, 'startOn'))
	          })
	        });
	      }
	    case _constants.RECURSION_OPTIONS.CURRENT_AND_NEXT:
	      {
	        return formData;
	      }
	    case _constants.RECURSION_OPTIONS.ALL_DAYS:
	      {
	        return (0, _extends3.default)({}, restFormData, {
	          scheduleSettingAttributes: (0, _extends3.default)({}, scheduleSettingAttributes, {
	            startOn: (0, _dateFormatter.formatToAPIDateFormat)((0, _get2.default)(schedule, 'scheduleSetting.startOn'))
	          })
	        });
	      }
	    default:
	      return null;
	  }
	}
	
	function removeRepeatScheduleAdapter(option, schedule) {
	  var scheduleSetting = schedule.scheduleSetting,
	      activeDate = schedule.activeDate;
	  var startTimeSlot = scheduleSetting.startTimeSlot,
	      endTimeSlot = scheduleSetting.endTimeSlot,
	      endOn = scheduleSetting.endOn,
	      startOn = scheduleSetting.startOn;
	
	  var weeks = (0, _pick2.default)(scheduleSetting, _constants.WEEK_DAYS);
	  var selectedDate = (0, _dateFormatter.formatToAPIDateFormat)(activeDate);
	
	  switch (option) {
	    case _constants.RECURSION_OPTIONS.CURRENT_DAY:
	      {
	        return {
	          scheduleSettingAttributes: (0, _extends3.default)({}, weeks, {
	            startOn: selectedDate,
	            endOn: selectedDate,
	            startTime: startTimeSlot,
	            endTime: endTimeSlot
	          })
	        };
	      }
	
	    case _constants.RECURSION_OPTIONS.CURRENT_AND_NEXT:
	      {
	        return {
	          scheduleSettingAttributes: (0, _extends3.default)({}, weeks, {
	            startOn: selectedDate,
	            startTime: startTimeSlot,
	            endTime: endTimeSlot,
	            endOn: endOn ? (0, _dateFormatter.formatToAPIDateFormat)(endOn) : endOn
	          })
	        };
	      }
	
	    case _constants.RECURSION_OPTIONS.ALL_DAYS:
	      {
	        return {
	          scheduleSettingAttributes: (0, _extends3.default)({}, weeks, {
	            startTime: startTimeSlot,
	            endTime: endTimeSlot,
	            startOn: (0, _dateFormatter.formatToAPIDateFormat)(startOn),
	            endOn: endOn ? (0, _dateFormatter.formatToAPIDateFormat)(endOn) : endOn
	          })
	        };
	      }
	
	    default:
	      return null;
	  }
	}
	
	function noRepeatScheduleAdapter(schedule) {
	  var scheduleSetting = schedule.scheduleSetting,
	      activeDate = schedule.activeDate;
	  var startTimeSlot = scheduleSetting.startTimeSlot,
	      endTimeSlot = scheduleSetting.endTimeSlot,
	      endOn = scheduleSetting.endOn;
	
	  var weeks = (0, _pick2.default)(scheduleSetting, _constants.WEEK_DAYS);
	
	  var startOn = _moment2.default.utc(activeDate).add(1, 'd').format(_dateFormatter.API_DATE_FORMAT);
	
	  return {
	    scheduleSettingAttributes: (0, _extends3.default)({}, weeks, {
	      startTime: startTimeSlot,
	      endTime: endTimeSlot,
	      startOn: startOn,
	      endOn: endOn ? (0, _dateFormatter.formatToAPIDateFormat)(endOn) : endOn
	    })
	  };
	}
	
	function getPrevDayRepeatableAdapter(schedule) {
	  var scheduleSetting = schedule.scheduleSetting,
	      activeDate = schedule.activeDate;
	  var startTimeSlot = scheduleSetting.startTimeSlot,
	      endTimeSlot = scheduleSetting.endTimeSlot,
	      startOn = scheduleSetting.startOn;
	
	  var weeks = (0, _pick2.default)(scheduleSetting, _constants.WEEK_DAYS);
	
	  var endOn = _moment2.default.utc(activeDate).subtract(1, 'd').format(_dateFormatter.API_DATE_FORMAT);
	
	  return {
	    scheduleSettingAttributes: (0, _extends3.default)({}, weeks, {
	      startTime: startTimeSlot,
	      endTime: endTimeSlot,
	      startOn: (0, _dateFormatter.formatToAPIDateFormat)(startOn),
	      endOn: endOn
	    })
	  };
	}
	
	function getRepeatFlow(repeatValue) {
	  switch (repeatValue) {
	    case _constants.REPEATABLE_VALUES.NO_REPEAT:
	      return _constants.CHANGE_REPEAT_FLOW_TYPES.NO_REPEAT;
	
	    case _constants.REPEATABLE_VALUES.CUSTOM:
	      return _constants.CHANGE_REPEAT_FLOW_TYPES.UPDATE_CUSTOM_REPEAT;
	
	    default:
	      return _constants.CHANGE_REPEAT_FLOW_TYPES.DEFAULT;
	  }
	}
	
	function scheduleFormAdapter() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      patientType = _ref.patientType,
	      colorMarkerHex = _ref.colorMarkerHex,
	      location = _ref.location,
	      service = _ref.service;
	
	  return {
	    patientType: patientType,
	    colorMarkerHex: colorMarkerHex,
	    locationId: (0, _get2.default)(location, 'id'),
	    serviceId: (0, _get2.default)(service, 'id'),
	    scheduleSettingAttributes: {}
	  };
	}
	
	function scheduleCurrentDaySettingsAttrsAdapter(_ref2) {
	  var scheduleSetting = _ref2.scheduleSetting,
	      activeDate = _ref2.activeDate;
	  var startTimeSlot = scheduleSetting.startTimeSlot,
	      endTimeSlot = scheduleSetting.endTimeSlot;
	
	  var selectedDate = (0, _dateFormatter.formatToAPIDateFormat)(activeDate);
	
	  return {
	    startOn: selectedDate,
	    startTime: startTimeSlot,
	    endTime: endTimeSlot
	  };
	}
	
	function scheduleOriginDaySettingsAttrsAdapter(_ref3) {
	  var scheduleSetting = _ref3.scheduleSetting;
	  var startTimeSlot = scheduleSetting.startTimeSlot,
	      endTimeSlot = scheduleSetting.endTimeSlot,
	      startOn = scheduleSetting.startOn,
	      endOn = scheduleSetting.endOn;
	
	
	  return {
	    startOn: (0, _dateFormatter.formatToAPIDateFormat)(startOn),
	    endOn: endOn,
	    startTime: startTimeSlot,
	    endTime: endTimeSlot
	  };
	}
	
	function isLastDayOfRepeat() {
	  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref4$scheduleSetting = _ref4.scheduleSetting;
	
	  _ref4$scheduleSetting = _ref4$scheduleSetting === undefined ? {} : _ref4$scheduleSetting;
	  var endOn = _ref4$scheduleSetting.endOn,
	      activeDate = _ref4.activeDate;
	
	  return _moment2.default.utc(endOn).isSame(activeDate, 'date');
	}
	
	function isOnlyEndRepeatDateChange(selectedSchedule, repeat) {
	  var isRepeatable = selectedSchedule.isRepeatable,
	      isStrictWeeklyRepeat = selectedSchedule.isStrictWeeklyRepeat,
	      scheduleSetting = selectedSchedule.scheduleSetting;
	  var repeatValue = repeat.repeatValue,
	      repeatData = repeat.repeatData;
	
	
	  var scheduleWeeks = (0, _pick2.default)(scheduleSetting, _constants.WEEK_DAYS);
	  var activeWeeks = (0, _keys2.default)((0, _omitBy2.default)(scheduleWeeks, function (value) {
	    return !value;
	  }));
	  var repeateWeeks = (0, _keys2.default)((0, _pick2.default)(repeatData, _constants.WEEK_DAYS));
	
	  if (isRepeatable && !isStrictWeeklyRepeat && repeatValue === _constants.REPEATABLE_VALUES.CUSTOM) {
	    return activeWeeks.join('_') === repeateWeeks.join('_');
	  }
	
	  return false;
	}
	
	function isFirstDayOfCustomRepeatChange(selectedSchedule, recursionFlow) {
	  var activeDate = selectedSchedule.activeDate,
	      scheduleSetting = selectedSchedule.scheduleSetting;
	  var startOn = scheduleSetting.startOn;
	
	  var isFirstDate = _moment2.default.utc(activeDate).isSame(startOn, 'date');
	  var isCustomChange = recursionFlow === _constants.CHANGE_REPEAT_FLOW_TYPES.UPDATE_CUSTOM_REPEAT;
	
	  return isCustomChange && isFirstDate;
	}

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(58);
	
	exports.default = function (object) {
	  return (0, _lodash.mapKeys)(object, function (value, key) {
	    return (0, _lodash.snakeCase)(key);
	  });
	};

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultValidator = defaultValidator;
	function defaultValidator(pattern, value) {
	  return pattern.test(value);
	}

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable no-useless-escape */
	var emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	exports.default = function (email) {
	  return !email || emailPattern.test(String(email).toLowerCase());
	};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Chart.js v2.9.3
	 * https://www.chartjs.org
	 * (c) 2019 Chart.js Contributors
	 * Released under the MIT License
	 */
	(function (global, factory) {
	 true ? module.exports = factory(function() { try { return __webpack_require__(30); } catch(e) { } }()) :
	typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
	(global = global || self, global.Chart = factory(global.moment));
	}(this, (function (moment) { 'use strict';
	
	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}
	
	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	var conversions = createCommonjsModule(function (module) {
	/* MIT license */
	
	
	// NOTE: conversions should only return primitive values (i.e. arrays, or
	//       values that give correct `typeof` results).
	//       do not use box values types (i.e. Number(), String(), etc.)
	
	var reverseKeywords = {};
	for (var key in colorName) {
		if (colorName.hasOwnProperty(key)) {
			reverseKeywords[colorName[key]] = key;
		}
	}
	
	var convert = module.exports = {
		rgb: {channels: 3, labels: 'rgb'},
		hsl: {channels: 3, labels: 'hsl'},
		hsv: {channels: 3, labels: 'hsv'},
		hwb: {channels: 3, labels: 'hwb'},
		cmyk: {channels: 4, labels: 'cmyk'},
		xyz: {channels: 3, labels: 'xyz'},
		lab: {channels: 3, labels: 'lab'},
		lch: {channels: 3, labels: 'lch'},
		hex: {channels: 1, labels: ['hex']},
		keyword: {channels: 1, labels: ['keyword']},
		ansi16: {channels: 1, labels: ['ansi16']},
		ansi256: {channels: 1, labels: ['ansi256']},
		hcg: {channels: 3, labels: ['h', 'c', 'g']},
		apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
		gray: {channels: 1, labels: ['gray']}
	};
	
	// hide .channels and .labels properties
	for (var model in convert) {
		if (convert.hasOwnProperty(model)) {
			if (!('channels' in convert[model])) {
				throw new Error('missing channels property: ' + model);
			}
	
			if (!('labels' in convert[model])) {
				throw new Error('missing channel labels property: ' + model);
			}
	
			if (convert[model].labels.length !== convert[model].channels) {
				throw new Error('channel and label counts mismatch: ' + model);
			}
	
			var channels = convert[model].channels;
			var labels = convert[model].labels;
			delete convert[model].channels;
			delete convert[model].labels;
			Object.defineProperty(convert[model], 'channels', {value: channels});
			Object.defineProperty(convert[model], 'labels', {value: labels});
		}
	}
	
	convert.rgb.hsl = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var min = Math.min(r, g, b);
		var max = Math.max(r, g, b);
		var delta = max - min;
		var h;
		var s;
		var l;
	
		if (max === min) {
			h = 0;
		} else if (r === max) {
			h = (g - b) / delta;
		} else if (g === max) {
			h = 2 + (b - r) / delta;
		} else if (b === max) {
			h = 4 + (r - g) / delta;
		}
	
		h = Math.min(h * 60, 360);
	
		if (h < 0) {
			h += 360;
		}
	
		l = (min + max) / 2;
	
		if (max === min) {
			s = 0;
		} else if (l <= 0.5) {
			s = delta / (max + min);
		} else {
			s = delta / (2 - max - min);
		}
	
		return [h, s * 100, l * 100];
	};
	
	convert.rgb.hsv = function (rgb) {
		var rdif;
		var gdif;
		var bdif;
		var h;
		var s;
	
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var v = Math.max(r, g, b);
		var diff = v - Math.min(r, g, b);
		var diffc = function (c) {
			return (v - c) / 6 / diff + 1 / 2;
		};
	
		if (diff === 0) {
			h = s = 0;
		} else {
			s = diff / v;
			rdif = diffc(r);
			gdif = diffc(g);
			bdif = diffc(b);
	
			if (r === v) {
				h = bdif - gdif;
			} else if (g === v) {
				h = (1 / 3) + rdif - bdif;
			} else if (b === v) {
				h = (2 / 3) + gdif - rdif;
			}
			if (h < 0) {
				h += 1;
			} else if (h > 1) {
				h -= 1;
			}
		}
	
		return [
			h * 360,
			s * 100,
			v * 100
		];
	};
	
	convert.rgb.hwb = function (rgb) {
		var r = rgb[0];
		var g = rgb[1];
		var b = rgb[2];
		var h = convert.rgb.hsl(rgb)[0];
		var w = 1 / 255 * Math.min(r, Math.min(g, b));
	
		b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
	
		return [h, w * 100, b * 100];
	};
	
	convert.rgb.cmyk = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var c;
		var m;
		var y;
		var k;
	
		k = Math.min(1 - r, 1 - g, 1 - b);
		c = (1 - r - k) / (1 - k) || 0;
		m = (1 - g - k) / (1 - k) || 0;
		y = (1 - b - k) / (1 - k) || 0;
	
		return [c * 100, m * 100, y * 100, k * 100];
	};
	
	/**
	 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	 * */
	function comparativeDistance(x, y) {
		return (
			Math.pow(x[0] - y[0], 2) +
			Math.pow(x[1] - y[1], 2) +
			Math.pow(x[2] - y[2], 2)
		);
	}
	
	convert.rgb.keyword = function (rgb) {
		var reversed = reverseKeywords[rgb];
		if (reversed) {
			return reversed;
		}
	
		var currentClosestDistance = Infinity;
		var currentClosestKeyword;
	
		for (var keyword in colorName) {
			if (colorName.hasOwnProperty(keyword)) {
				var value = colorName[keyword];
	
				// Compute comparative distance
				var distance = comparativeDistance(rgb, value);
	
				// Check if its less, if so set as closest
				if (distance < currentClosestDistance) {
					currentClosestDistance = distance;
					currentClosestKeyword = keyword;
				}
			}
		}
	
		return currentClosestKeyword;
	};
	
	convert.keyword.rgb = function (keyword) {
		return colorName[keyword];
	};
	
	convert.rgb.xyz = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
	
		// assume sRGB
		r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
		g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
		b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
		var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
		var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
		var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
		return [x * 100, y * 100, z * 100];
	};
	
	convert.rgb.lab = function (rgb) {
		var xyz = convert.rgb.xyz(rgb);
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.hsl.rgb = function (hsl) {
		var h = hsl[0] / 360;
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var t1;
		var t2;
		var t3;
		var rgb;
		var val;
	
		if (s === 0) {
			val = l * 255;
			return [val, val, val];
		}
	
		if (l < 0.5) {
			t2 = l * (1 + s);
		} else {
			t2 = l + s - l * s;
		}
	
		t1 = 2 * l - t2;
	
		rgb = [0, 0, 0];
		for (var i = 0; i < 3; i++) {
			t3 = h + 1 / 3 * -(i - 1);
			if (t3 < 0) {
				t3++;
			}
			if (t3 > 1) {
				t3--;
			}
	
			if (6 * t3 < 1) {
				val = t1 + (t2 - t1) * 6 * t3;
			} else if (2 * t3 < 1) {
				val = t2;
			} else if (3 * t3 < 2) {
				val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
			} else {
				val = t1;
			}
	
			rgb[i] = val * 255;
		}
	
		return rgb;
	};
	
	convert.hsl.hsv = function (hsl) {
		var h = hsl[0];
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var smin = s;
		var lmin = Math.max(l, 0.01);
		var sv;
		var v;
	
		l *= 2;
		s *= (l <= 1) ? l : 2 - l;
		smin *= lmin <= 1 ? lmin : 2 - lmin;
		v = (l + s) / 2;
		sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);
	
		return [h, sv * 100, v * 100];
	};
	
	convert.hsv.rgb = function (hsv) {
		var h = hsv[0] / 60;
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var hi = Math.floor(h) % 6;
	
		var f = h - Math.floor(h);
		var p = 255 * v * (1 - s);
		var q = 255 * v * (1 - (s * f));
		var t = 255 * v * (1 - (s * (1 - f)));
		v *= 255;
	
		switch (hi) {
			case 0:
				return [v, t, p];
			case 1:
				return [q, v, p];
			case 2:
				return [p, v, t];
			case 3:
				return [p, q, v];
			case 4:
				return [t, p, v];
			case 5:
				return [v, p, q];
		}
	};
	
	convert.hsv.hsl = function (hsv) {
		var h = hsv[0];
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
		var vmin = Math.max(v, 0.01);
		var lmin;
		var sl;
		var l;
	
		l = (2 - s) * v;
		lmin = (2 - s) * vmin;
		sl = s * vmin;
		sl /= (lmin <= 1) ? lmin : 2 - lmin;
		sl = sl || 0;
		l /= 2;
	
		return [h, sl * 100, l * 100];
	};
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	convert.hwb.rgb = function (hwb) {
		var h = hwb[0] / 360;
		var wh = hwb[1] / 100;
		var bl = hwb[2] / 100;
		var ratio = wh + bl;
		var i;
		var v;
		var f;
		var n;
	
		// wh + bl cant be > 1
		if (ratio > 1) {
			wh /= ratio;
			bl /= ratio;
		}
	
		i = Math.floor(6 * h);
		v = 1 - bl;
		f = 6 * h - i;
	
		if ((i & 0x01) !== 0) {
			f = 1 - f;
		}
	
		n = wh + f * (v - wh); // linear interpolation
	
		var r;
		var g;
		var b;
		switch (i) {
			default:
			case 6:
			case 0: r = v; g = n; b = wh; break;
			case 1: r = n; g = v; b = wh; break;
			case 2: r = wh; g = v; b = n; break;
			case 3: r = wh; g = n; b = v; break;
			case 4: r = n; g = wh; b = v; break;
			case 5: r = v; g = wh; b = n; break;
		}
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.cmyk.rgb = function (cmyk) {
		var c = cmyk[0] / 100;
		var m = cmyk[1] / 100;
		var y = cmyk[2] / 100;
		var k = cmyk[3] / 100;
		var r;
		var g;
		var b;
	
		r = 1 - Math.min(1, c * (1 - k) + k);
		g = 1 - Math.min(1, m * (1 - k) + k);
		b = 1 - Math.min(1, y * (1 - k) + k);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.rgb = function (xyz) {
		var x = xyz[0] / 100;
		var y = xyz[1] / 100;
		var z = xyz[2] / 100;
		var r;
		var g;
		var b;
	
		r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
		g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
		b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
		// assume sRGB
		r = r > 0.0031308
			? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
			: r * 12.92;
	
		g = g > 0.0031308
			? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
			: g * 12.92;
	
		b = b > 0.0031308
			? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
			: b * 12.92;
	
		r = Math.min(Math.max(0, r), 1);
		g = Math.min(Math.max(0, g), 1);
		b = Math.min(Math.max(0, b), 1);
	
		return [r * 255, g * 255, b * 255];
	};
	
	convert.xyz.lab = function (xyz) {
		var x = xyz[0];
		var y = xyz[1];
		var z = xyz[2];
		var l;
		var a;
		var b;
	
		x /= 95.047;
		y /= 100;
		z /= 108.883;
	
		x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
		y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
		z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);
	
		l = (116 * y) - 16;
		a = 500 * (x - y);
		b = 200 * (y - z);
	
		return [l, a, b];
	};
	
	convert.lab.xyz = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var x;
		var y;
		var z;
	
		y = (l + 16) / 116;
		x = a / 500 + y;
		z = y - b / 200;
	
		var y2 = Math.pow(y, 3);
		var x2 = Math.pow(x, 3);
		var z2 = Math.pow(z, 3);
		y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
		x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
		z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
	
		x *= 95.047;
		y *= 100;
		z *= 108.883;
	
		return [x, y, z];
	};
	
	convert.lab.lch = function (lab) {
		var l = lab[0];
		var a = lab[1];
		var b = lab[2];
		var hr;
		var h;
		var c;
	
		hr = Math.atan2(b, a);
		h = hr * 360 / 2 / Math.PI;
	
		if (h < 0) {
			h += 360;
		}
	
		c = Math.sqrt(a * a + b * b);
	
		return [l, c, h];
	};
	
	convert.lch.lab = function (lch) {
		var l = lch[0];
		var c = lch[1];
		var h = lch[2];
		var a;
		var b;
		var hr;
	
		hr = h / 360 * 2 * Math.PI;
		a = c * Math.cos(hr);
		b = c * Math.sin(hr);
	
		return [l, a, b];
	};
	
	convert.rgb.ansi16 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
		var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
	
		value = Math.round(value / 50);
	
		if (value === 0) {
			return 30;
		}
	
		var ansi = 30
			+ ((Math.round(b / 255) << 2)
			| (Math.round(g / 255) << 1)
			| Math.round(r / 255));
	
		if (value === 2) {
			ansi += 60;
		}
	
		return ansi;
	};
	
	convert.hsv.ansi16 = function (args) {
		// optimization here; we already know the value and don't need to get
		// it converted for us.
		return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
	};
	
	convert.rgb.ansi256 = function (args) {
		var r = args[0];
		var g = args[1];
		var b = args[2];
	
		// we use the extended greyscale palette here, with the exception of
		// black and white. normal palette only has 4 greyscale shades.
		if (r === g && g === b) {
			if (r < 8) {
				return 16;
			}
	
			if (r > 248) {
				return 231;
			}
	
			return Math.round(((r - 8) / 247) * 24) + 232;
		}
	
		var ansi = 16
			+ (36 * Math.round(r / 255 * 5))
			+ (6 * Math.round(g / 255 * 5))
			+ Math.round(b / 255 * 5);
	
		return ansi;
	};
	
	convert.ansi16.rgb = function (args) {
		var color = args % 10;
	
		// handle greyscale
		if (color === 0 || color === 7) {
			if (args > 50) {
				color += 3.5;
			}
	
			color = color / 10.5 * 255;
	
			return [color, color, color];
		}
	
		var mult = (~~(args > 50) + 1) * 0.5;
		var r = ((color & 1) * mult) * 255;
		var g = (((color >> 1) & 1) * mult) * 255;
		var b = (((color >> 2) & 1) * mult) * 255;
	
		return [r, g, b];
	};
	
	convert.ansi256.rgb = function (args) {
		// handle greyscale
		if (args >= 232) {
			var c = (args - 232) * 10 + 8;
			return [c, c, c];
		}
	
		args -= 16;
	
		var rem;
		var r = Math.floor(args / 36) / 5 * 255;
		var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
		var b = (rem % 6) / 5 * 255;
	
		return [r, g, b];
	};
	
	convert.rgb.hex = function (args) {
		var integer = ((Math.round(args[0]) & 0xFF) << 16)
			+ ((Math.round(args[1]) & 0xFF) << 8)
			+ (Math.round(args[2]) & 0xFF);
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.hex.rgb = function (args) {
		var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
		if (!match) {
			return [0, 0, 0];
		}
	
		var colorString = match[0];
	
		if (match[0].length === 3) {
			colorString = colorString.split('').map(function (char) {
				return char + char;
			}).join('');
		}
	
		var integer = parseInt(colorString, 16);
		var r = (integer >> 16) & 0xFF;
		var g = (integer >> 8) & 0xFF;
		var b = integer & 0xFF;
	
		return [r, g, b];
	};
	
	convert.rgb.hcg = function (rgb) {
		var r = rgb[0] / 255;
		var g = rgb[1] / 255;
		var b = rgb[2] / 255;
		var max = Math.max(Math.max(r, g), b);
		var min = Math.min(Math.min(r, g), b);
		var chroma = (max - min);
		var grayscale;
		var hue;
	
		if (chroma < 1) {
			grayscale = min / (1 - chroma);
		} else {
			grayscale = 0;
		}
	
		if (chroma <= 0) {
			hue = 0;
		} else
		if (max === r) {
			hue = ((g - b) / chroma) % 6;
		} else
		if (max === g) {
			hue = 2 + (b - r) / chroma;
		} else {
			hue = 4 + (r - g) / chroma + 4;
		}
	
		hue /= 6;
		hue %= 1;
	
		return [hue * 360, chroma * 100, grayscale * 100];
	};
	
	convert.hsl.hcg = function (hsl) {
		var s = hsl[1] / 100;
		var l = hsl[2] / 100;
		var c = 1;
		var f = 0;
	
		if (l < 0.5) {
			c = 2.0 * s * l;
		} else {
			c = 2.0 * s * (1.0 - l);
		}
	
		if (c < 1.0) {
			f = (l - 0.5 * c) / (1.0 - c);
		}
	
		return [hsl[0], c * 100, f * 100];
	};
	
	convert.hsv.hcg = function (hsv) {
		var s = hsv[1] / 100;
		var v = hsv[2] / 100;
	
		var c = s * v;
		var f = 0;
	
		if (c < 1.0) {
			f = (v - c) / (1 - c);
		}
	
		return [hsv[0], c * 100, f * 100];
	};
	
	convert.hcg.rgb = function (hcg) {
		var h = hcg[0] / 360;
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		if (c === 0.0) {
			return [g * 255, g * 255, g * 255];
		}
	
		var pure = [0, 0, 0];
		var hi = (h % 1) * 6;
		var v = hi % 1;
		var w = 1 - v;
		var mg = 0;
	
		switch (Math.floor(hi)) {
			case 0:
				pure[0] = 1; pure[1] = v; pure[2] = 0; break;
			case 1:
				pure[0] = w; pure[1] = 1; pure[2] = 0; break;
			case 2:
				pure[0] = 0; pure[1] = 1; pure[2] = v; break;
			case 3:
				pure[0] = 0; pure[1] = w; pure[2] = 1; break;
			case 4:
				pure[0] = v; pure[1] = 0; pure[2] = 1; break;
			default:
				pure[0] = 1; pure[1] = 0; pure[2] = w;
		}
	
		mg = (1.0 - c) * g;
	
		return [
			(c * pure[0] + mg) * 255,
			(c * pure[1] + mg) * 255,
			(c * pure[2] + mg) * 255
		];
	};
	
	convert.hcg.hsv = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var v = c + g * (1.0 - c);
		var f = 0;
	
		if (v > 0.0) {
			f = c / v;
		}
	
		return [hcg[0], f * 100, v * 100];
	};
	
	convert.hcg.hsl = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
	
		var l = g * (1.0 - c) + 0.5 * c;
		var s = 0;
	
		if (l > 0.0 && l < 0.5) {
			s = c / (2 * l);
		} else
		if (l >= 0.5 && l < 1.0) {
			s = c / (2 * (1 - l));
		}
	
		return [hcg[0], s * 100, l * 100];
	};
	
	convert.hcg.hwb = function (hcg) {
		var c = hcg[1] / 100;
		var g = hcg[2] / 100;
		var v = c + g * (1.0 - c);
		return [hcg[0], (v - c) * 100, (1 - v) * 100];
	};
	
	convert.hwb.hcg = function (hwb) {
		var w = hwb[1] / 100;
		var b = hwb[2] / 100;
		var v = 1 - b;
		var c = v - w;
		var g = 0;
	
		if (c < 1) {
			g = (v - c) / (1 - c);
		}
	
		return [hwb[0], c * 100, g * 100];
	};
	
	convert.apple.rgb = function (apple) {
		return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
	};
	
	convert.rgb.apple = function (rgb) {
		return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
	};
	
	convert.gray.rgb = function (args) {
		return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
	};
	
	convert.gray.hsl = convert.gray.hsv = function (args) {
		return [0, 0, args[0]];
	};
	
	convert.gray.hwb = function (gray) {
		return [0, 100, gray[0]];
	};
	
	convert.gray.cmyk = function (gray) {
		return [0, 0, 0, gray[0]];
	};
	
	convert.gray.lab = function (gray) {
		return [gray[0], 0, 0];
	};
	
	convert.gray.hex = function (gray) {
		var val = Math.round(gray[0] / 100 * 255) & 0xFF;
		var integer = (val << 16) + (val << 8) + val;
	
		var string = integer.toString(16).toUpperCase();
		return '000000'.substring(string.length) + string;
	};
	
	convert.rgb.gray = function (rgb) {
		var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
		return [val / 255 * 100];
	};
	});
	var conversions_1 = conversions.rgb;
	var conversions_2 = conversions.hsl;
	var conversions_3 = conversions.hsv;
	var conversions_4 = conversions.hwb;
	var conversions_5 = conversions.cmyk;
	var conversions_6 = conversions.xyz;
	var conversions_7 = conversions.lab;
	var conversions_8 = conversions.lch;
	var conversions_9 = conversions.hex;
	var conversions_10 = conversions.keyword;
	var conversions_11 = conversions.ansi16;
	var conversions_12 = conversions.ansi256;
	var conversions_13 = conversions.hcg;
	var conversions_14 = conversions.apple;
	var conversions_15 = conversions.gray;
	
	/*
		this function routes a model to all other models.
	
		all functions that are routed have a property `.conversion` attached
		to the returned synthetic function. This property is an array
		of strings, each with the steps in between the 'from' and 'to'
		color models (inclusive).
	
		conversions that are not possible simply are not included.
	*/
	
	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);
	
		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}
	
		return graph;
	}
	
	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop
	
		graph[fromModel].distance = 0;
	
		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);
	
			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];
	
				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}
	
		return graph;
	}
	
	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}
	
	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];
	
		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}
	
		fn.conversion = path;
		return fn;
	}
	
	var route = function (fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};
	
		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];
	
			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}
	
			conversion[toModel] = wrapConversion(toModel, graph);
		}
	
		return conversion;
	};
	
	var convert = {};
	
	var models = Object.keys(conversions);
	
	function wrapRaw(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			return fn(args);
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	function wrapRounded(fn) {
		var wrappedFn = function (args) {
			if (args === undefined || args === null) {
				return args;
			}
	
			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}
	
			var result = fn(args);
	
			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if (typeof result === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}
	
			return result;
		};
	
		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}
	
		return wrappedFn;
	}
	
	models.forEach(function (fromModel) {
		convert[fromModel] = {};
	
		Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
		Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});
	
		var routes = route(fromModel);
		var routeModels = Object.keys(routes);
	
		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];
	
			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});
	
	var colorConvert = convert;
	
	var colorName$1 = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};
	
	/* MIT license */
	
	
	var colorString = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	};
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorName$1[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName$1) {
	   reverseNames[colorName$1[name]] = name;
	}
	
	/* MIT license */
	
	
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function () {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	var chartjsColor = Color;
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array (including typed arrays), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @function
		 */
		isArray: function(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns true if `value` is a finite number, else returns false
		 * @param {*} value  - The value to test.
		 * @returns {boolean}
		 */
		isFinite: function(value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {object|Array} loopable - The object or array to be iterated.
		 * @param {function} fn - The function to call for each item.
		 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see https://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = {};
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @param {object} [options] - Merging options:
		 * @param {function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {object} target - The target object in which all sources are merged into.
		 * @param {object|object[]} source - Object(s) to merge into `target`.
		 * @returns {object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {object} target - The target object in which all objects are merged into.
		 * @param {object} arg1 - Object containing additional properties to merge in target.
		 * @param {object} argN - Additional objects containing properties to merge in target.
		 * @returns {object} The `target` object.
		 */
		extend: Object.assign || function(target) {
			return helpers.merge(target, [].slice.call(arguments, 1), {
				merger: function(key, dst, src) {
					dst[key] = src[key];
				}
			});
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		},
	
		_deprecated: function(scope, value, previous, current) {
			if (value !== undefined) {
				console.warn(scope + ': "' + previous +
					'" is deprecated. Please use "' + current + '" instead');
			}
		}
	};
	
	var helpers_core = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	var helpers_easing = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.easingEffects = effects;
	
	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports$1 = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {number} width - The rectangle's width.
		 * @param {number} height - The rectangle's height.
		 * @param {number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;
	
				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.save();
					ctx.translate(x, y);
					ctx.rotate(rad);
					ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
					ctx.restore();
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			ctx.beginPath();
	
			switch (style) {
			// Default includes circle
			default:
				ctx.arc(x, y, radius, 0, DOUBLE_PI);
				ctx.closePath();
				break;
			case 'triangle':
				ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				rad += TWO_THIRDS_PI;
				ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
				ctx.closePath();
				break;
			case 'rectRounded':
				// NOTE: the rounded rect implementation changed to use `arc` instead of
				// `quadraticCurveTo` since it generates better results when rect is
				// almost a circle. 0.516 (instead of 0.5) produces results with visually
				// closer proportion to the previous impl and it is inscribed in the
				// circle with `radius`. For more details, see the following PRs:
				// https://github.com/chartjs/Chart.js/issues/5597
				// https://github.com/chartjs/Chart.js/issues/5858
				cornerRadius = radius * 0.516;
				size = radius - cornerRadius;
				xOffset = Math.cos(rad + QUARTER_PI) * size;
				yOffset = Math.sin(rad + QUARTER_PI) * size;
				ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
				ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
				ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
				ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
				ctx.closePath();
				break;
			case 'rect':
				if (!rotation) {
					size = Math.SQRT1_2 * radius;
					ctx.rect(x - size, y - size, 2 * size, 2 * size);
					break;
				}
				rad += QUARTER_PI;
				/* falls through */
			case 'rectRot':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + yOffset, y - xOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				ctx.closePath();
				break;
			case 'crossRot':
				rad += QUARTER_PI;
				/* falls through */
			case 'cross':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'star':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				rad += QUARTER_PI;
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x + yOffset, y - xOffset);
				ctx.lineTo(x - yOffset, y + xOffset);
				break;
			case 'line':
				xOffset = Math.cos(rad) * radius;
				yOffset = Math.sin(rad) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				break;
			case 'dash':
				ctx.moveTo(x, y);
				ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
				break;
			}
	
			ctx.fill();
			ctx.stroke();
		},
	
		/**
		 * Returns true if the point is inside the rectangle
		 * @param {object} point - The point to test
		 * @param {object} area - The rectangle
		 * @returns {boolean}
		 * @private
		 */
		_isPointInArea: function(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	
			return point.x > area.left - epsilon && point.x < area.right + epsilon &&
				point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	var helpers_canvas = exports$1;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.clear = exports$1.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};
	
	var defaults = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};
	
	// TODO(v3): remove 'global' from namespace.  all default are global and
	// there's inconsistency around which options are under 'global'
	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});
	
	var core_defaults = defaults;
	
	var valueOrDefault = helpers_core.valueOrDefault;
	
	/**
	 * Converts the given font object into a CSS font string.
	 * @param {object} font - A font object.
	 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
	 * @private
	 */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}
	
		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	}
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	var helpers_options = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {number|object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Parses font options and returns the font object.
		 * @param {object} options - A object that contains font options to be parsed.
		 * @return {object} The font object.
		 * @todo Support font.* options and renamed to toFont().
		 * @private
		 */
		_parseFont: function(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};
	
			font.string = toFontString(font);
			return font;
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array} inputs - An array of values, falling back to the last value.
		 * @param {object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @param {object} [info] - object to return information about resolution in
		 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index, info) {
			var cacheable = true;
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
					cacheable = false;
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
					cacheable = false;
				}
				if (value !== undefined) {
					if (info && !cacheable) {
						info.cacheable = false;
					}
					return value;
				}
			}
		}
	};
	
	/**
	 * @alias Chart.helpers.math
	 * @namespace
	 */
	var exports$2 = {
		/**
		 * Returns an array of factors sorted from 1 to sqrt(value)
		 * @private
		 */
		_factorize: function(value) {
			var result = [];
			var sqrt = Math.sqrt(value);
			var i;
	
			for (i = 1; i < sqrt; i++) {
				if (value % i === 0) {
					result.push(i);
					result.push(value / i);
				}
			}
			if (sqrt === (sqrt | 0)) { // if value is a square number
				result.push(sqrt);
			}
	
			result.sort(function(a, b) {
				return a - b;
			}).pop();
			return result;
		},
	
		log10: Math.log10 || function(x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);
	
			return isPowerOf10 ? powerOf10 : exponent;
		}
	};
	
	var helpers_math = exports$2;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
	 * @namespace Chart.helpers.log10
	 * @deprecated since version 2.9.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers_core.log10 = exports$2.log10;
	
	var getRtlAdapter = function(rectX, width) {
		return {
			x: function(x) {
				return rectX + rectX + width - x;
			},
			setWidth: function(w) {
				width = w;
			},
			textAlign: function(align) {
				if (align === 'center') {
					return align;
				}
				return align === 'right' ? 'left' : 'right';
			},
			xPlus: function(x, value) {
				return x - value;
			},
			leftForLtr: function(x, itemWidth) {
				return x - itemWidth;
			},
		};
	};
	
	var getLtrAdapter = function() {
		return {
			x: function(x) {
				return x;
			},
			setWidth: function(w) { // eslint-disable-line no-unused-vars
			},
			textAlign: function(align) {
				return align;
			},
			xPlus: function(x, value) {
				return x + value;
			},
			leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
				return x;
			},
		};
	};
	
	var getAdapter = function(rtl, rectX, width) {
		return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
	};
	
	var overrideTextDirection = function(ctx, direction) {
		var style, original;
		if (direction === 'ltr' || direction === 'rtl') {
			style = ctx.canvas.style;
			original = [
				style.getPropertyValue('direction'),
				style.getPropertyPriority('direction'),
			];
	
			style.setProperty('direction', direction, 'important');
			ctx.prevTextDirection = original;
		}
	};
	
	var restoreTextDirection = function(ctx) {
		var original = ctx.prevTextDirection;
		if (original !== undefined) {
			delete ctx.prevTextDirection;
			ctx.canvas.style.setProperty('direction', original[0], original[1]);
		}
	};
	
	var helpers_rtl = {
		getRtlAdapter: getAdapter,
		overrideTextDirection: overrideTextDirection,
		restoreTextDirection: restoreTextDirection,
	};
	
	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	var math = helpers_math;
	var rtl = helpers_rtl;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;
	helpers$1.math = math;
	helpers$1.rtl = rtl;
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers$1.extend(Element.prototype, {
		_type: undefined,
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.extend({}, me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = helpers$1.extend({}, model);
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers$1.inherits;
	
	var core_element = Element;
	
	var exports$3 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service
	
		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});
	
	var core_animation = exports$3;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});
	
	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(exports$3.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});
	
	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});
	
	var core_animations = {
		animations: [],
		request: null,
	
		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {number} duration - The animation duration in ms.
		 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;
	
			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;
	
			if (!lazy) {
				chart.animating = true;
			}
	
			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}
	
			animations.push(animation);
	
			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},
	
		cancelAnimation: function(chart) {
			var index = helpers$1.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});
	
			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},
	
		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},
	
		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
	
			me.advance();
	
			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},
	
		/**
		 * @private
		 */
		advance: function() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;
	
			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;
	
				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);
	
				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);
	
				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};
	
	var resolve = helpers$1.options.resolve;
	
	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}
	
		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});
	
		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];
	
			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);
	
					helpers$1.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});
	
					return res;
				}
			});
		});
	}
	
	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}
	
		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}
	
		if (listeners.length > 0) {
			return;
		}
	
		arrayEvents.forEach(function(key) {
			delete array[key];
		});
	
		delete array._chartjs;
	}
	
	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};
	
	helpers$1.extend(DatasetController.prototype, {
	
		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,
	
		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,
	
		/**
		 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth'
		],
	
		/**
		 * Data element option keys to be resolved in _resolveDataElementOptions.
		 * A derived controller may override this to resolve controller-specific options.
		 * The keys defined here are for backward compatibility for legend styles.
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'pointStyle'
		],
	
		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
			me._type = me.getMeta().type;
		},
	
		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},
	
		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var chart = me.chart;
			var scales = chart.scales;
			var dataset = me.getDataset();
			var scalesOpts = chart.options.scales;
	
			if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
				meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
				meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
			}
		},
	
		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},
	
		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},
	
		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getValueScale: function() {
			return this.getScaleForId(this._getValueScaleId());
		},
	
		/**
		 * @private
		 */
		_getIndexScale: function() {
			return this.getScaleForId(this._getIndexScaleId());
		},
	
		reset: function() {
			this._update(true);
		},
	
		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},
	
		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},
	
		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},
	
		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;
	
			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}
	
			meta.dataset = meta.dataset || me.createMetaDataset();
		},
	
		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},
	
		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);
	
			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}
	
				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}
	
			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},
	
		/**
		 * Returns the merged user-supplied and default dataset-level options
		 * @private
		 */
		_configure: function() {
			var me = this;
			me._config = helpers$1.merge({}, [
				me.chart.options.datasets[me._type],
				me.getDataset(),
			], {
				merger: function(key, target, source) {
					if (key !== '_meta' && key !== 'data') {
						helpers$1._merger(key, target, source);
					}
				}
			});
		},
	
		_update: function(reset) {
			var me = this;
			me._configure();
			me._cachedDataOpts = null;
			me.update(reset);
		},
	
		update: helpers$1.noop,
	
		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}
	
			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},
	
		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;
	
			if (meta.dataset) {
				meta.dataset.draw();
			}
	
			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},
	
		/**
		 * Returns a set of predefined style properties that should be used to represent the dataset
		 * or the data if the index is specified
		 * @param {number} index - data index
		 * @return {IStyleInterface} style object
		 */
		getStyle: function(index) {
			var me = this;
			var meta = me.getMeta();
			var dataset = meta.dataset;
			var style;
	
			me._configure();
			if (dataset && index === undefined) {
				style = me._resolveDatasetElementOptions(dataset || {});
			} else {
				index = index || 0;
				style = me._resolveDataElementOptions(meta.data[index] || {}, index);
			}
	
			if (style.fill === false || style.fill === null) {
				style.backgroundColor = style.borderColor;
			}
	
			return style;
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element, hover) {
			var me = this;
			var chart = me.chart;
			var datasetOpts = me._config;
			var custom = element.custom || {};
			var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
			var elementOptions = me._datasetElementOptions;
			var values = {};
			var i, ilen, key, readKey;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataset: me.getDataset(),
				datasetIndex: me.index,
				hover: hover
			};
	
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
				values[key] = resolve([
					custom[readKey],
					datasetOpts[readKey],
					options[readKey]
				], context);
			}
	
			return values;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(element, index) {
			var me = this;
			var custom = element && element.custom;
			var cached = me._cachedDataOpts;
			if (cached && !custom) {
				return cached;
			}
			var chart = me.chart;
			var datasetOpts = me._config;
			var options = chart.options.elements[me.dataElementType.prototype._type] || {};
			var elementOptions = me._dataElementOptions;
			var values = {};
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: me.getDataset(),
				datasetIndex: me.index
			};
	
			// `resolve` sets cacheable to `false` if any option is indexed or scripted
			var info = {cacheable: !custom};
	
			var keys, i, ilen, key;
	
			custom = custom || {};
	
			if (helpers$1.isArray(elementOptions)) {
				for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
					key = elementOptions[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			} else {
				keys = Object.keys(elementOptions);
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						datasetOpts[elementOptions[key]],
						datasetOpts[key],
						options[key]
					], context, index, info);
				}
			}
	
			if (info.cacheable) {
				me._cachedDataOpts = Object.freeze(values);
			}
	
			return values;
		},
	
		removeHoverStyle: function(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},
	
		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;
	
			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};
	
			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},
	
		/**
		 * @private
		 */
		_removeDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
	
			if (element) {
				this.removeHoverStyle(element);
			}
		},
	
		/**
		 * @private
		 */
		_setDatasetHoverStyle: function() {
			var element = this.getMeta().dataset;
			var prev = {};
			var i, ilen, key, keys, hoverOptions, model;
	
			if (!element) {
				return;
			}
	
			model = element._model;
			hoverOptions = this._resolveDatasetElementOptions(element, true);
	
			keys = Object.keys(hoverOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				prev[key] = model[key];
				model[key] = hoverOptions[key];
			}
	
			element.$previousStyle = prev;
		},
	
		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;
	
			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},
	
		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},
	
		/**
		 * @private
		 */
		onDataPush: function() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},
	
		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},
	
		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},
	
		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},
	
		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});
	
	DatasetController.extend = helpers$1.inherits;
	
	var core_datasetController = DatasetController;
	
	var TAU = Math.PI * 2;
	
	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});
	
	function clipArc(ctx, arc) {
		var startAngle = arc.startAngle;
		var endAngle = arc.endAngle;
		var pixelMargin = arc.pixelMargin;
		var angleMargin = pixelMargin / arc.outerRadius;
		var x = arc.x;
		var y = arc.y;
	
		// Draw an inner border by cliping the arc and drawing a double-width border
		// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
		ctx.beginPath();
		ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
		if (arc.innerRadius > pixelMargin) {
			angleMargin = pixelMargin / arc.innerRadius;
			ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
		} else {
			ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
		}
		ctx.closePath();
		ctx.clip();
	}
	
	function drawFullCircleBorders(ctx, vm, arc, inner) {
		var endAngle = arc.endAngle;
		var i;
	
		if (inner) {
			arc.endAngle = arc.startAngle + TAU;
			clipArc(ctx, arc);
			arc.endAngle = endAngle;
			if (arc.endAngle === arc.startAngle && arc.fullCircles) {
				arc.endAngle += TAU;
				arc.fullCircles--;
			}
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	}
	
	function drawBorder(ctx, vm, arc) {
		var inner = vm.borderAlign === 'inner';
	
		if (inner) {
			ctx.lineWidth = vm.borderWidth * 2;
			ctx.lineJoin = 'round';
		} else {
			ctx.lineWidth = vm.borderWidth;
			ctx.lineJoin = 'bevel';
		}
	
		if (arc.fullCircles) {
			drawFullCircleBorders(ctx, vm, arc, inner);
		}
	
		if (inner) {
			clipArc(ctx, arc);
		}
	
		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.stroke();
	}
	
	var element_arc = core_element.extend({
		_type: 'arc',
	
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += TAU;
				}
				while (angle > endAngle) {
					angle -= TAU;
				}
				while (angle < startAngle) {
					angle += TAU;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
			var arc = {
				x: vm.x,
				y: vm.y,
				innerRadius: vm.innerRadius,
				outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
				pixelMargin: pixelMargin,
				startAngle: vm.startAngle,
				endAngle: vm.endAngle,
				fullCircles: Math.floor(vm.circumference / TAU)
			};
			var i;
	
			ctx.save();
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
	
			if (arc.fullCircles) {
				arc.endAngle = arc.startAngle + TAU;
				ctx.beginPath();
				ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
				ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
				ctx.closePath();
				for (i = 0; i < arc.fullCircles; ++i) {
					ctx.fill();
				}
				arc.endAngle = arc.startAngle + vm.circumference % TAU;
			}
	
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			ctx.fill();
	
			if (vm.borderWidth) {
				drawBorder(ctx, vm, arc);
			}
	
			ctx.restore();
		}
	});
	
	var valueOrDefault$1 = helpers$1.valueOrDefault;
	
	var defaultColor = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	var element_line = core_element.extend({
		_type: 'line',
	
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var closePath = me._loop;
			var index, previous, currentVM;
	
			if (!points.length) {
				return;
			}
	
			if (me._loop) {
				for (index = 0; index < points.length; ++index) {
					previous = helpers$1.previousItem(points, index);
					// If the line has an open path, shift the point array
					if (!points[index]._view.skip && previous._view.skip) {
						points = points.slice(index).concat(points.slice(0, index));
						closePath = spanGaps;
						break;
					}
				}
				// If the line has a close path, add the first point again
				if (closePath) {
					points.push(points[0]);
				}
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
	
			// First point moves to it's starting position no matter what
			currentVM = points[0]._view;
			if (!currentVM.skip) {
				ctx.moveTo(currentVM.x, currentVM.y);
				lastDrawnIndex = 0;
			}
	
			for (index = 1; index < points.length; ++index) {
				currentVM = points[index]._view;
				previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
	
				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
					}
					lastDrawnIndex = index;
				}
			}
	
			if (closePath) {
				ctx.closePath();
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});
	
	var valueOrDefault$2 = helpers$1.valueOrDefault;
	
	var defaultColor$1 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
	}
	
	var element_point = core_element.extend({
		_type: 'point',
	
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
	
			if (vm.skip) {
				return;
			}
	
			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});
	
	var defaultColor$2 = core_defaults.global.defaultColor;
	
	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;
	
		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}
	
	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};
	
		if (!edge) {
			return res;
		}
	
		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}
	
		res[edge] = true;
		return res;
	}
	
	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}
	
		return {
			t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}
	
	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);
	
		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}
	
	function inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);
	
		return bounds
			&& (skipX || x >= bounds.left && x <= bounds.right)
			&& (skipY || y >= bounds.top && y <= bounds.bottom);
	}
	
	var element_rectangle = core_element.extend({
		_type: 'rectangle',
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;
	
			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
	
			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}
	
			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			return inRange(this._view, mouseX, mouseY);
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm)
				? inRange(vm, mouseX, null)
				: inRange(vm, null, mouseY);
		},
	
		inXRange: function(mouseX) {
			return inRange(this._view, mouseX, null);
		},
	
		inYRange: function(mouseY) {
			return inRange(this._view, null, mouseY);
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
	
			return isVertical(vm)
				? vm.width * Math.abs(vm.y - vm.base)
				: vm.height * Math.abs(vm.x - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});
	
	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;
	
	var deprecated = helpers$1._deprecated;
	var valueOrDefault$3 = helpers$1.valueOrDefault;
	
	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			bar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	/**
	 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
	 * @private
	 */
	function computeMinSampleSize(scale, pixels) {
		var min = scale._length;
		var prev, curr, i, ilen;
	
		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}
	
		for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
			prev = curr;
		}
	
		return min;
	}
	
	/**
	 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
	 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
	 * mode currently always generates bars equally sized (until we introduce scriptable options?).
	 * @private
	 */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var min = helpers$1.isNullOrUndef(thickness)
			? computeMinSampleSize(ruler.scale, ruler.pixels)
			: -1;
		var size, ratio;
	
		if (helpers$1.isNullOrUndef(thickness)) {
			size = min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}
	
		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - (size / 2)
		};
	}
	
	/**
	 * Computes an "optimal" category that globally arranges bars side by side (no gap when
	 * percentage options are 1), based on the previous and following categories. This mode
	 * generates bars with different widths when data are not evenly spaced.
	 * @private
	 */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;
	
		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}
	
		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}
	
		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;
	
		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}
	
	var controller_bar = core_datasetController.extend({
	
		dataElementType: elements.Rectangle,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderSkipped',
			'borderWidth',
			'barPercentage',
			'barThickness',
			'categoryPercentage',
			'maxBarThickness',
			'minBarLength'
		],
	
		initialize: function() {
			var me = this;
			var meta, scaleOpts;
	
			core_datasetController.prototype.initialize.apply(me, arguments);
	
			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
	
			scaleOpts = me._getIndexScale().options;
			deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
			deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
			deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
			deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
			deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
		},
	
		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;
	
			me._ruler = me.getRuler();
	
			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},
	
		updateElement: function(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveDataElementOptions(rectangle, index);
	
			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};
	
			if (helpers$1.isArray(dataset.data[index])) {
				rectangle._model.borderSkipped = null;
			}
	
			me._updateElementGeometry(rectangle, index, reset, options);
	
			rectangle.pivot();
		},
	
		/**
		 * @private
		 */
		_updateElementGeometry: function(rectangle, index, reset, options) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index, options);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
	
			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},
	
		/**
		 * Returns the stacks based on groups and bar visibility.
		 * @param {number} [last] - The dataset index
		 * @returns {string[]} The list of stack IDs
		 * @private
		 */
		_getStacks: function(last) {
			var me = this;
			var scale = me._getIndexScale();
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var stacked = scale.options.stacked;
			var ilen = metasets.length;
			var stacks = [];
			var i, meta;
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				// stacked   | meta.stack
				//           | found | not found | undefined
				// false     |   x   |     x     |     x
				// true      |       |     x     |
				// undefined |       |     x     |     x
				if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
					(stacked === undefined && meta.stack === undefined)) {
					stacks.push(meta.stack);
				}
				if (meta.index === last) {
					break;
				}
			}
	
			return stacks;
		},
	
		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function() {
			return this._getStacks().length;
		},
	
		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @param {number} [datasetIndex] - The dataset index
		 * @param {string} [name] - The stack name to find
		 * @returns {number} The stack index
		 * @private
		 */
		getStackIndex: function(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = (name !== undefined)
				? stacks.indexOf(name)
				: -1; // indexOf returns -1 if element is not present
	
			return (index === -1)
				? stacks.length - 1
				: index;
		},
	
		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me._getIndexScale();
			var pixels = [];
			var i, ilen;
	
			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, me.index));
			}
	
			return {
				pixels: pixels,
				start: scale._startPixel,
				end: scale._endPixel,
				stackCount: me.getStackCount(),
				scale: scale
			};
		},
	
		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index, options) {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var value = scale._parseValue(datasets[datasetIndex].data[index]);
			var minBarLength = options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = me.getMeta().stack;
			var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
			var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
			var ilen = metasets.length;
			var i, imeta, ivalue, base, head, size, stackLength;
	
			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < ilen; ++i) {
					imeta = metasets[i];
	
					if (imeta.index === datasetIndex) {
						break;
					}
	
					if (imeta.stack === stack) {
						stackLength = scale._parseValue(datasets[imeta.index].data[index]);
						ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
	
						if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}
	
			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + length);
			size = head - base;
	
			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}
	
			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},
	
		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
			var me = this;
			var range = options.barThickness === 'flex'
				? computeFlexCategoryTraits(index, ruler, options)
				: computeFitCategoryTraits(index, ruler, options);
	
			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
			var size = Math.min(
				valueOrDefault$3(options.maxBarThickness, Infinity),
				range.chunk * range.ratio);
	
			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;
	
			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
	
			for (; i < ilen; ++i) {
				var val = scale._parseValue(dataset.data[i]);
				if (!isNaN(val.min) && !isNaN(val.max)) {
					rects[i].draw();
				}
			}
	
			helpers$1.canvas.unclipArea(chart.ctx);
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function() {
			var me = this;
			var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
			var indexOpts = me._getIndexScale().options;
			var valueOpts = me._getValueScale().options;
	
			values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
			values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
			values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
			values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
			values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
	
			return values;
		}
	
	});
	
	var valueOrDefault$4 = helpers$1.valueOrDefault;
	var resolve$1 = helpers$1.options.resolve;
	
	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	var controller_bubble = core_datasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
			'hoverRadius',
			'hitRadius',
			'pointStyle',
			'rotation'
		],
	
		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;
	
			// Update Points
			helpers$1.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},
	
		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveDataElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;
	
			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};
	
			point.pivot();
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},
	
		/**
		 * @private
		 */
		_resolveDataElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = point.custom || {};
			var data = dataset.data[index] || {};
			var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			// In case values were cached (and thus frozen), we need to clone the values
			if (me._cachedDataOpts === values) {
				values = helpers$1.extend({}, values);
			}
	
			// Custom radius resolution
			values.radius = resolve$1([
				custom.radius,
				data.r,
				me._config.radius,
				chart.options.elements.point.radius
			], context, index);
	
			return values;
		}
	});
	
	var valueOrDefault$5 = helpers$1.valueOrDefault;
	
	var PI$1 = Math.PI;
	var DOUBLE_PI$1 = PI$1 * 2;
	var HALF_PI$1 = PI$1 / 2;
	
	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: -HALF_PI$1,
	
		// The total circumference of the chart.
		circumference: DOUBLE_PI$1,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	var controller_doughnut = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;
	
			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}
	
			return ringIndex;
		},
	
		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var ratioX = 1;
			var ratioY = 1;
			var offsetX = 0;
			var offsetY = 0;
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutout = opts.cutoutPercentage / 100 || 0;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var maxWidth, maxHeight, i, ilen;
	
			// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
			if (circumference < DOUBLE_PI$1) {
				var startAngle = opts.rotation % DOUBLE_PI$1;
				startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
				var endAngle = startAngle + circumference;
				var startX = Math.cos(startAngle);
				var startY = Math.sin(startAngle);
				var endX = Math.cos(endAngle);
				var endY = Math.sin(endAngle);
				var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
				var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
				var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
				var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
				var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
				var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
				var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
				var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
				ratioX = (maxX - minX) / 2;
				ratioY = (maxY - minY) / 2;
				offsetX = -(maxX + minX) / 2;
				offsetY = -(maxY + minY) / 2;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			}
	
			chart.borderWidth = me.getMaxBorderWidth();
			maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
			maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
			chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
			chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offsetX * chart.outerRadius;
			chart.offsetY = offsetY * chart.outerRadius;
	
			meta.total = me.calculateTotal();
	
			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});
	
			var model = arc._model;
	
			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}
	
				model.endAngle = model.startAngle + model.circumference;
			}
	
			arc.pivot();
		},
	
		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;
	
			helpers$1.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});
	
			/* if (total === 0) {
				total = NaN;
			}*/
	
			return total;
		},
	
		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return DOUBLE_PI$1 * (Math.abs(value) / total);
			}
			return 0;
		},
	
		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
	
			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}
	
			if (!arcs) {
				return 0;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				if (controller) {
					controller._configure();
					options = controller._resolveDataElementOptions(arc, i);
				} else {
					options = arc._options;
				}
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
		 * @private
		 */
		_getRingWeightOffset: function(datasetIndex) {
			var ringWeightOffset = 0;
	
			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}
	
			return ringWeightOffset;
		},
	
		/**
		 * @private
		 */
		_getRingWeight: function(dataSetIndex) {
			return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},
	
		/**
		 * Returns the sum of all visibile data set weights.  This value can be 0.
		 * @private
		 */
		_getVisibleDatasetWeightTotal: function() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});
	
	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				type: 'category',
				position: 'left',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			horizontalBar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});
	
	var controller_horizontalBar = controller_bar.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
	
	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;
	
	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	function scaleClip(scale, halfBorderWidth) {
		var tickOpts = scale && scale.options.ticks || {};
		var reverse = tickOpts.reverse;
		var min = tickOpts.min === undefined ? halfBorderWidth : 0;
		var max = tickOpts.max === undefined ? halfBorderWidth : 0;
		return {
			start: reverse ? max : min,
			end: reverse ? min : max
		};
	}
	
	function defaultClip(xScale, yScale, borderWidth) {
		var halfBorderWidth = borderWidth / 2;
		var x = scaleClip(xScale, halfBorderWidth);
		var y = scaleClip(yScale, halfBorderWidth);
	
		return {
			top: y.end,
			right: x.end,
			bottom: y.start,
			left: x.start
		};
	}
	
	function toClip(value) {
		var t, r, b, l;
	
		if (helpers$1.isObject(value)) {
			t = value.top;
			r = value.right;
			b = value.bottom;
			l = value.left;
		} else {
			t = r = b = l = value;
		}
	
		return {
			top: t,
			right: r,
			bottom: b,
			left: l
		};
	}
	
	
	var controller_line = core_datasetController.extend({
	
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderCapStyle',
			'borderColor',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'borderWidth',
			'cubicInterpolationMode',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var config = me._config;
			var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
			var i, ilen;
	
			me._xScale = me.getScaleForId(meta.xAxisID);
			me._yScale = me.getScaleForId(meta.yAxisID);
	
			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if (config.tension !== undefined && config.lineTension === undefined) {
					config.lineTension = config.tension;
				}
	
				// Utility
				line._scale = me._yScale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveDatasetElementOptions(line);
	
				line.pivot();
			}
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var xScale = me._xScale;
			var yScale = me._yScale;
			var lineModel = meta.dataset._model;
			var x, y;
	
			var options = me._resolveDataElementOptions(point, index);
	
			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function(element) {
			var me = this;
			var config = me._config;
			var custom = element.custom || {};
			var options = me.chart.options;
			var lineOptions = options.elements.line;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
			values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
			values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
	
			return values;
		},
	
		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var yScale = me._yScale;
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
	
			if (yScale.options.stacked) {
				rightValue = +yScale.getRightValue(value);
				metasets = chart._getSortedVisibleDatasetMetas();
				ilen = metasets.length;
	
				for (i = 0; i < ilen; ++i) {
					dsMeta = metasets[i];
					if (dsMeta.index === datasetIndex) {
						break;
					}
	
					ds = chart.data.datasets[dsMeta.index];
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
						stackedRightValue = +yScale.getRightValue(ds.data[index]);
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}
	
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}
			return yScale.getPixelForValue(value);
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(
						helpers$1.previousItem(points, i)._model,
						model,
						helpers$1.nextItem(points, i)._model,
						lineModel.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}
	
			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var canvas = chart.canvas;
			var i = 0;
			var ilen = points.length;
			var clip;
	
			if (me._showLine) {
				clip = meta.dataset._model.clip;
	
				helpers$1.canvas.clipArea(chart.ctx, {
					left: clip.left === false ? 0 : area.left - clip.left,
					right: clip.right === false ? canvas.width : area.right + clip.right,
					top: clip.top === false ? 0 : area.top - clip.top,
					bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
				});
	
				meta.dataset.draw();
	
				helpers$1.canvas.unclipArea(chart.ctx);
			}
	
			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		},
	});
	
	var resolve$3 = helpers$1.options.resolve;
	
	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}
	
			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);
	
							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	var controller_polarArea = core_datasetController.extend({
	
		dataElementType: elements.Arc,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_dataElementOptions: [
			'backgroundColor',
			'borderColor',
			'borderWidth',
			'borderAlign',
			'hoverBackgroundColor',
			'hoverBorderColor',
			'hoverBorderWidth',
		],
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;
	
			me._updateRadius();
	
			meta.count = me.countVisibleElements();
	
			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}
	
			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},
	
		/**
		 * @private
		 */
		_updateRadius: function() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
	
			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},
	
		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;
	
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;
	
			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
	
			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};
	
			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,
	
				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});
	
			arc.pivot();
		},
	
		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;
	
			helpers$1.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});
	
			return count;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;
	
			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
			};
	
			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},
	
		/**
		 * @private
		 */
		_computeAngle: function(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();
	
			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}
	
			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};
	
			return resolve$3([
				me.chart.options.elements.arc.angle,
				(2 * Math.PI) / count
			], context, index);
		}
	});
	
	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;
	
	var valueOrDefault$7 = helpers$1.valueOrDefault;
	
	core_defaults._set('radar', {
		spanGaps: false,
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				fill: 'start',
				tension: 0 // no bezier in radar
			}
		}
	});
	
	var controller_radar = core_datasetController.extend({
		datasetElementType: elements.Line,
	
		dataElementType: elements.Point,
	
		linkScales: helpers$1.noop,
	
		/**
		 * @private
		 */
		_datasetElementOptions: [
			'backgroundColor',
			'borderWidth',
			'borderColor',
			'borderCapStyle',
			'borderDash',
			'borderDashOffset',
			'borderJoinStyle',
			'fill'
		],
	
		/**
		 * @private
		 */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.chart.scale.id;
		},
	
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.chart.scale.id;
		},
	
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var config = me._config;
			var i, ilen;
	
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}
	
			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveDatasetElementOptions(line);
	
			line.pivot();
	
			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}
	
			// Update bezier control points
			me.updateBezierControlPoints();
	
			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},
	
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolveDataElementOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;
	
			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;
	
			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
	
				// Tooltip
				hitRadius: options.hitRadius
			};
		},
	
		/**
		 * @private
		 */
		_resolveDatasetElementOptions: function() {
			var me = this;
			var config = me._config;
			var options = me.chart.options;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
	
			values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
	
			return values;
		},
	
		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;
	
			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}
	
			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}
	
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i, true)._model,
					model,
					helpers$1.nextItem(points, i, true)._model,
					model.tension
				);
	
				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},
	
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;
	
			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};
	
			model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
		}
	});
	
	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	core_defaults._set('global', {
		datasets: {
			scatter: {
				showLine: false
			}
		}
	});
	
	// Scatter charts use line controllers
	var controller_scatter = controller_line;
	
	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).
	
	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {object} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers$1.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param {Chart} chart - the chart
	 * @param {function} handler - the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var metadata, i, j, ilen, jlen, element;
	
		for (i = 0, ilen = metasets.length; i < ilen; ++i) {
			metadata = metasets[i].data;
			for (j = 0, jlen = metadata.length; j < jlen; ++j) {
				element = metadata[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param {ChartElement[]} items - elements to filter
	 * @param {object} position - the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param {Chart} chart - the chart to look at elements from
	 * @param {object} position - the point to be nearest to
	 * @param {boolean} intersect - if true, only consider items that intersect the position
	 * @param {function} distanceMetric - function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {string} axis - the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
			var element = meta.data[items[0]._index];
	
			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param {Chart} chart - the chart we are returning items from
			 * @param {Event} e - the event we are find things at
			 * @param {IInteractionOptions} options - options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};
	
	var extend = helpers$1.extend;
	
	function filterByPosition(array, position) {
		return helpers$1.where(array, function(v) {
			return v.pos === position;
		});
	}
	
	function sortByWeight(array, reverse) {
		return array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0.index - v1.index :
				v0.weight - v1.weight;
		});
	}
	
	function wrapBoxes(boxes) {
		var layoutBoxes = [];
		var i, ilen, box;
	
		for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
			box = boxes[i];
			layoutBoxes.push({
				index: i,
				box: box,
				pos: box.position,
				horizontal: box.isHorizontal(),
				weight: box.weight
			});
		}
		return layoutBoxes;
	}
	
	function setLayoutDims(layouts, params) {
		var i, ilen, layout;
		for (i = 0, ilen = layouts.length; i < ilen; ++i) {
			layout = layouts[i];
			// store width used instead of chartArea.w in fitBoxes
			layout.width = layout.horizontal
				? layout.box.fullWidth && params.availableWidth
				: params.vBoxMaxWidth;
			// store height used instead of chartArea.h in fitBoxes
			layout.height = layout.horizontal && params.hBoxMaxHeight;
		}
	}
	
	function buildLayoutBoxes(boxes) {
		var layoutBoxes = wrapBoxes(boxes);
		var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
		var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
		var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
		var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
	
		return {
			leftAndTop: left.concat(top),
			rightAndBottom: right.concat(bottom),
			chartArea: filterByPosition(layoutBoxes, 'chartArea'),
			vertical: left.concat(right),
			horizontal: top.concat(bottom)
		};
	}
	
	function getCombinedMax(maxPadding, chartArea, a, b) {
		return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
	}
	
	function updateDims(chartArea, params, layout) {
		var box = layout.box;
		var maxPadding = chartArea.maxPadding;
		var newWidth, newHeight;
	
		if (layout.size) {
			// this layout was already counted for, lets first reduce old size
			chartArea[layout.pos] -= layout.size;
		}
		layout.size = layout.horizontal ? box.height : box.width;
		chartArea[layout.pos] += layout.size;
	
		if (box.getPadding) {
			var boxPadding = box.getPadding();
			maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
			maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
			maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
			maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
		}
	
		newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
		newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
	
		if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
			chartArea.w = newWidth;
			chartArea.h = newHeight;
	
			// return true if chart area changed in layout's direction
			return layout.horizontal ? newWidth !== chartArea.w : newHeight !== chartArea.h;
		}
	}
	
	function handleMaxPadding(chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function updatePos(pos) {
			var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
			chartArea[pos] += change;
			return change;
		}
		chartArea.y += updatePos('top');
		chartArea.x += updatePos('left');
		updatePos('right');
		updatePos('bottom');
	}
	
	function getMargins(horizontal, chartArea) {
		var maxPadding = chartArea.maxPadding;
	
		function marginForPositions(positions) {
			var margin = {left: 0, top: 0, right: 0, bottom: 0};
			positions.forEach(function(pos) {
				margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
			});
			return margin;
		}
	
		return horizontal
			? marginForPositions(['left', 'right'])
			: marginForPositions(['top', 'bottom']);
	}
	
	function fitBoxes(boxes, chartArea, params) {
		var refitBoxes = [];
		var i, ilen, layout, box, refit, changed;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
	
			box.update(
				layout.width || chartArea.w,
				layout.height || chartArea.h,
				getMargins(layout.horizontal, chartArea)
			);
			if (updateDims(chartArea, params, layout)) {
				changed = true;
				if (refitBoxes.length) {
					// Dimensions changed and there were non full width boxes before this
					// -> we have to refit those
					refit = true;
				}
			}
			if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
				refitBoxes.push(layout);
			}
		}
	
		return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
	}
	
	function placeBoxes(boxes, chartArea, params) {
		var userPadding = params.padding;
		var x = chartArea.x;
		var y = chartArea.y;
		var i, ilen, layout, box;
	
		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
			if (layout.horizontal) {
				box.left = box.fullWidth ? userPadding.left : chartArea.left;
				box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
				box.top = y;
				box.bottom = y + box.height;
				box.width = box.right - box.left;
				y = box.bottom;
			} else {
				box.left = x;
				box.right = x + box.width;
				box.top = chartArea.top;
				box.bottom = chartArea.top + chartArea.h;
				box.height = box.bottom - box.top;
				x = box.right;
			}
		}
	
		chartArea.x = x;
		chartArea.y = y;
	}
	
	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	/**
	 * @interface ILayoutItem
	 * @prop {string} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {function} getPadding -  Returns an object with padding on the edges
	 * @prop {number} width - Width of item. Must be valid after update()
	 * @prop {number} height - Height of item. Must be valid after update()
	 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */
	
	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},
	
		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}
	
			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
			item._layers = item._layers || function() {
				return [{
					z: 0,
					draw: function() {
						item.draw.apply(item, arguments);
					}
				}];
			};
	
			chart.boxes.push(item);
		},
	
		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {ILayoutItem} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},
	
		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {ILayoutItem} item - the item to configure with the given options
		 * @param {object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;
	
			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},
	
		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {number} width - the width to fit into
		 * @param {number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}
	
			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);
	
			var availableWidth = width - padding.width;
			var availableHeight = height - padding.height;
			var boxes = buildLayoutBoxes(chart.boxes);
			var verticalBoxes = boxes.vertical;
			var horizontalBoxes = boxes.horizontal;
	
			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
	
			var params = Object.freeze({
				outerWidth: width,
				outerHeight: height,
				padding: padding,
				availableWidth: availableWidth,
				vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
				hBoxMaxHeight: availableHeight / 2
			});
			var chartArea = extend({
				maxPadding: extend({}, padding),
				w: availableWidth,
				h: availableHeight,
				x: padding.left,
				y: padding.top
			}, padding);
	
			setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
	
			// First fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
	
			// Then fit horizontal boxes
			if (fitBoxes(horizontalBoxes, chartArea, params)) {
				// if the area changed, re-fit vertical boxes
				fitBoxes(verticalBoxes, chartArea, params);
			}
	
			handleMaxPadding(chartArea);
	
			// Finally place the boxes to correct coordinates
			placeBoxes(boxes.leftAndTop, chartArea, params);
	
			// Move to opposite side of chart
			chartArea.x += chartArea.w;
			chartArea.y += chartArea.h;
	
			placeBoxes(boxes.rightAndBottom, chartArea, params);
	
			chart.chartArea = {
				left: chartArea.left,
				top: chartArea.top,
				right: chartArea.left + chartArea.w,
				bottom: chartArea.top + chartArea.h
			};
	
			// Finally update boxes in chartArea (radial scale for example)
			helpers$1.each(boxes.chartArea, function(layout) {
				var box = layout.box;
				extend(box, chart.chartArea);
				box.update(chartArea.w, chartArea.h);
			});
		}
	};
	
	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	var platform_basic = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};
	
	var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";
	
	var platform_dom$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': platform_dom
	});
	
	var stylesheet = getCjsExportFromNamespace(platform_dom$1);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;
	
		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
	
		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());
	
		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
	
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			addListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function(type) {
				removeListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	/**
	 * Injects CSS styles inline if the styles are not already present.
	 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
	 * @param {string} css - the CSS to be injected.
	 */
	function injectCSS(rootNode, css) {
		// https://stackoverflow.com/q/3922139
		var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
		if (!expando.containsStyles) {
			expando.containsStyles = true;
			css = '/* Chart.js */\n' + css;
			var style = document.createElement('style');
			style.setAttribute('type', 'text/css');
			style.appendChild(document.createTextNode(css));
			rootNode.appendChild(style);
		}
	}
	
	var platform_dom$2 = {
		/**
		 * When `true`, prevents the automatic injection of the stylesheet required to
		 * correctly detect when the chart is added to the DOM and then resized. This
		 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
		 * to be manually imported to make this library compatible with any CSP.
		 * See https://github.com/chartjs/Chart.js/issues/5208
		 */
		disableCSSInjection: false,
	
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		/**
		 * Initializes resources that depend on platform options.
		 * @param {HTMLCanvasElement} canvas - The Canvas element.
		 * @private
		 */
		_ensureLoaded: function(canvas) {
			if (!this.disableCSSInjection) {
				// If the canvas is in a shadow DOM, then the styles must also be inserted
				// into the same shadow DOM.
				// https://github.com/chartjs/Chart.js/issues/5763
				var root = canvas.getRootNode ? canvas.getRootNode() : document;
				var targetNode = root.host ? root : document.head;
				injectCSS(targetNode, stylesheet);
			}
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				// Load platform resources on first chart creation, to make it possible to
				// import the library before setting platform options.
				this._ensureLoaded(item);
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers$1.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.addEvent = addListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.removeEvent = removeListener;
	
	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	var platform = helpers$1.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {string} type - The ({@link IEvent}) type to listen for
		 * @param {function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart - Chart from which to remove the listener
		 * @param {string} type - The ({@link IEvent}) type to remove
		 * @param {function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	core_defaults._set('global', {
		plugins: {}
	});
	
	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	var core_plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],
	
		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,
	
		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});
	
			this._cacheId++;
		},
	
		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},
	
		/**
		 * Returns the number of registered plugins?
		 * @returns {number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},
	
		/**
		 * Returns all registered plugin instances.
		 * @returns {IPlugin[]} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},
	
		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Chart} chart - The chart instance for which plugins should be called.
		 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;
	
			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}
	
			return true;
		},
	
		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {object[]} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};
	
			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}
	
				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}
	
				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}
	
				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});
	
			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},
	
		/**
		 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
		 * but in some cases, this reference can be changed by the user when updating options.
		 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		 * @private
		 */
		_invalidate: function(chart) {
			delete chart.$plugins;
		}
	};
	
	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers
	
		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};
	
	var valueOrDefault$8 = helpers$1.valueOrDefault;
	var getRtlHelper = helpers$1.rtl.getRtlAdapter;
	
	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});
	
	var positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {object} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}
	
			return {
				x: x / count,
				y: y / count
			};
		},
	
		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {object} the position of the event in canvas coordinates
		 * @returns {object} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);
	
					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}
	
			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}
	
			return {
				x: x,
				y: y
			};
		}
	};
	
	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}
	
		return base;
	}
	
	/**
	 * Returns array of strings split by newline
	 * @param {string} value - The value to split by newline.
	 * @returns {string[]} value if newline present - Returned from String split() method
	 * @function
	 */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}
	
	
	/**
	 * Private helper to create a tooltip item model
	 * @param element - the chart element (point, arc, bar) to create the tooltip item for
	 * @return new tooltip item
	 */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();
	
		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}
	
	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;
	
		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,
	
			// Drawing direction and text direction
			rtl: tooltipOpts.rtl,
			textDirection: tooltipOpts.textDirection,
	
			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,
	
			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,
	
			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,
	
			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}
	
	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;
	
		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;
	
		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;
	
		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};
	
		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);
	
		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers$1.each(body, function(bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});
	
		// Reset back to 0
		widthPadding = 0;
	
		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);
	
		// Add padding
		width += 2 * model.xPadding;
	
		return {
			width: width,
			height: height
		};
	}
	
	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';
	
		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}
	
		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;
	
		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}
	
		olf = function(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};
	
		if (lf(model.x)) {
			xAlign = 'left';
	
			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';
	
			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}
	
		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}
	
	/**
	 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;
	
		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;
	
		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}
	
		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}
	
		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}
	
		return {
			x: x,
			y: y
		};
	}
	
	function getAlignedX(vm, align) {
		return align === 'center'
			? vm.x + vm.width / 2
			: align === 'right'
				? vm.x + vm.width - vm.xPadding
				: vm.x + vm.xPadding;
	}
	
	/**
	 * Helper to build before and after body lines
	 */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}
	
	var exports$4 = core_element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},
	
		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;
	
			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));
	
			return lines;
		},
	
		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},
	
		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];
	
			helpers$1.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
	
				bodyItems.push(bodyItem);
			});
	
			return bodyItems;
		},
	
		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},
	
		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;
	
			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));
	
			return lines;
		},
	
		update: function(changed) {
			var me = this;
			var opts = me._options;
	
			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;
	
			var data = me._data;
	
			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};
	
			var i, len;
	
			if (active.length) {
				model.opacity = 1;
	
				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
	
				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}
	
				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}
	
				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}
	
				// Determine colors for boxes
				helpers$1.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});
	
	
				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);
	
				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;
	
				// data points
				model.dataPoints = tooltipItems;
	
				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}
	
			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;
	
			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;
	
			me._model = model;
	
			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}
	
			return me;
		},
	
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;
	
			if (yAlign === 'center') {
				y2 = ptY + (height / 2);
	
				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;
	
					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;
	
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
	
		drawTitle: function(pt, vm, ctx) {
			var title = vm.title;
			var length = title.length;
			var titleFontSize, titleSpacing, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._titleAlign);
	
				ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
				ctx.textBaseline = 'middle';
	
				titleFontSize = vm.titleFontSize;
				titleSpacing = vm.titleSpacing;
	
				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
					if (i + 1 === length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
	
		drawBody: function(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
	
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
			var fillLineOfText = function(line) {
				ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
				pt.y += bodyFontSize + bodySpacing;
			};
	
			var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
			var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
	
			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'middle';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
			pt.x = getAlignedX(vm, bodyAlignForCalculation);
	
			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);
	
			xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
				? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
				: 0;
	
			// Draw body lines now
			for (i = 0, ilen = body.length; i < ilen; ++i) {
				bodyItem = body[i];
				textColor = vm.labelTextColors[i];
				labelColors = vm.labelColors[i];
	
				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);
	
				lines = bodyItem.lines;
				for (j = 0, jlen = lines.length; j < jlen; ++j) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						var rtlColorX = rtlHelper.x(colorX);
	
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors.borderColor;
						ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
	
						// Inner square
						ctx.fillStyle = labelColors.backgroundColor;
						ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}
	
					fillLineOfText(lines[j]);
				}
	
				helpers$1.each(bodyItem.after, fillLineOfText);
			}
	
			// Reset back to 0 for after body
			xLinePadding = 0;
	
			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
	
		drawFooter: function(pt, vm, ctx) {
			var footer = vm.footer;
			var length = footer.length;
			var footerFontSize, i;
	
			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
	
				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;
	
				ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
				ctx.textBaseline = 'middle';
	
				footerFontSize = vm.footerFontSize;
	
				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
				for (i = 0; i < length; ++i) {
					ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
					pt.y += footerFontSize + vm.footerSpacing;
				}
			}
		},
	
		drawBackground: function(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;
	
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
	
			ctx.fill();
	
			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
	
			if (vm.opacity === 0) {
				return;
			}
	
			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};
	
			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;
	
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);
	
				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;
	
				helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
	
				// Titles
				this.drawTitle(pt, vm, ctx);
	
				// Body
				this.drawBody(pt, vm, ctx);
	
				// Footer
				this.drawFooter(pt, vm, ctx);
	
				helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
	
				ctx.restore();
			}
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;
	
			me._lastActive = me._lastActive || [];
	
			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				if (options.reverse) {
					me._active.reverse();
				}
			}
	
			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);
	
			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					me.update(true);
					me.pivot();
				}
			}
	
			return changed;
		}
	});
	
	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	var positioners_1 = positioners;
	
	var core_tooltip = exports$4;
	core_tooltip.positioners = positioners_1;
	
	var valueOrDefault$9 = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		elements: {},
		events: [
			'mousemove',
			'mouseout',
			'click',
			'touchstart',
			'touchmove'
		],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});
	
	/**
	 * Recursively merge the given config objects representing the `scales` option
	 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
	 * returns a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeScaleConfig(/* config objects ... */) {
		return helpers$1.merge({}, [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;
	
					if (!target[key]) {
						target[key] = [];
					}
	
					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
						if (i >= target[key].length) {
							target[key].push({});
						}
	
						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	/**
	 * Recursively merge the given config objects as the root options by handling
	 * default scale options for the `scales` and `scale` properties, then returns
	 * a deep copy of the result, thus doesn't alter inputs.
	 */
	function mergeConfig(/* config objects ... */) {
		return helpers$1.merge({}, [].slice.call(arguments), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];
	
				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}
	
	function initConfig(config) {
		config = config || {};
	
		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];
	
		config.options = mergeConfig(
			core_defaults.global,
			core_defaults[config.type],
			config.options || {});
	
		return config;
	}
	
	function updateConfig(chart) {
		var newOptions = chart.options;
	
		helpers$1.each(chart.scales, function(scale) {
			core_layouts.removeBox(chart, scale);
		});
	
		newOptions = mergeConfig(
			core_defaults.global,
			core_defaults[chart.config.type],
			newOptions);
	
		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();
	
		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}
	
	function nextAvailableScaleId(axesOpts, prefix, index) {
		var id;
		var hasId = function(obj) {
			return obj.id === id;
		};
	
		do {
			id = prefix + index++;
		} while (helpers$1.findIndex(axesOpts, hasId) >= 0);
	
		return id;
	}
	
	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}
	
	function compare2Level(l1, l2) {
		return function(a, b) {
			return a[l1] === b[l1]
				? a[l2] - b[l2]
				: a[l1] - b[l1];
		};
	}
	
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};
	
	helpers$1.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;
	
			config = initConfig(config);
	
			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;
	
			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;
			me._layers = [];
	
			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception
	
			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;
	
			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});
	
			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}
	
			me.initialize();
			me.update();
		},
	
		/**
		 * @private
		 */
		initialize: function() {
			var me = this;
	
			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');
	
			helpers$1.retinaScale(me, me.options.devicePixelRatio);
	
			me.bindEvents();
	
			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}
	
			me.initToolTip();
	
			// After init plugin notification
			core_plugins.notify(me, 'afterInit');
	
			return me;
		},
	
		clear: function() {
			helpers$1.canvas.clear(this);
			return this;
		},
	
		stop: function() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},
	
		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.
	
			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
	
			if (me.width === newWidth && me.height === newHeight) {
				return;
			}
	
			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';
	
			helpers$1.retinaScale(me, options.devicePixelRatio);
	
			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				core_plugins.notify(me, 'resize', [newSize]);
	
				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}
	
				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},
	
		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;
	
			helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				if (!xAxisOptions.id) {
					xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
				}
			});
	
			helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				if (!yAxisOptions.id) {
					yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
				}
			});
	
			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},
	
		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildOrUpdateScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function(obj, id) {
				obj[id] = false;
				return obj;
			}, {});
	
			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}
	
			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}
	
			helpers$1.each(items, function(item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
	
				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}
	
				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}
	
				scale.mergeTicksOptions();
	
				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function(hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});
	
			me.scales = scales;
	
			core_scaleService.addScalesToLayout(this);
		},
	
		buildOrUpdateControllers: function() {
			var me = this;
			var newControllers = [];
			var datasets = me.data.datasets;
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				var dataset = datasets[i];
				var meta = me.getDatasetMeta(i);
				var type = dataset.type || me.config.type;
	
				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(i);
					meta = me.getDatasetMeta(i);
				}
				meta.type = type;
				meta.order = dataset.order || 0;
				meta.index = i;
	
				if (meta.controller) {
					meta.controller.updateIndex(i);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}
	
					meta.controller = new ControllerClass(me, i);
					newControllers.push(meta.controller);
				}
			}
	
			return newControllers;
		},
	
		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},
	
		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},
	
		update: function(config) {
			var me = this;
			var i, ilen;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			updateConfig(me);
	
			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);
	
			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}
	
			// In case the entire data object changed
			me.tooltip._data = me.data;
	
			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();
	
			// Make sure all dataset controllers have correct meta data counts
			for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
				me.getDatasetMeta(i).controller.buildOrUpdateElements();
			}
	
			me.updateLayout();
	
			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function(controller) {
					controller.reset();
				});
			}
	
			me.updateDatasets();
	
			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();
	
			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];
	
			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');
	
			me._layers.sort(compare2Level('z', '_idx'));
	
			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},
	
		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}
	
			core_layouts.update(this, this.width, this.height);
	
			me._layers = [];
			helpers$1.each(me.boxes, function(box) {
				// _configure is called twice, once in core.scale.update and once here.
				// Here the boxes are fully updated and at their final positions.
				if (box._configure) {
					box._configure();
				}
				me._layers.push.apply(me._layers, box._layers());
			}, me);
	
			me._layers.forEach(function(item, index) {
				item._idx = index;
			});
	
			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},
	
		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;
	
			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}
	
			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}
	
			core_plugins.notify(me, 'afterDatasetsUpdate');
		},
	
		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};
	
			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}
	
			meta.controller._update();
	
			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},
	
		render: function(config) {
			var me = this;
	
			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}
	
			var animationOptions = me.options.animation;
			var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;
	
			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}
	
			var onComplete = function(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};
	
			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,
	
					render: function(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;
	
						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},
	
					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});
	
				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();
	
				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({numSteps: 0, chart: me}));
			}
	
			return me;
		},
	
		draw: function(easingValue) {
			var me = this;
			var i, layers;
	
			me.clear();
	
			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}
	
			me.transition(easingValue);
	
			if (me.width <= 0 || me.height <= 0) {
				return;
			}
	
			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}
	
			// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
			// currently be part of layers. Instead, we draw
			// layers <= 0 before(default, backward compat), and the rest after
			layers = me._layers;
			for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me.drawDatasets(easingValue);
	
			// Rest of layers
			for (; i < layers.length; ++i) {
				layers[i].draw(me.chartArea);
			}
	
			me._drawTooltip(easingValue);
	
			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},
	
		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;
	
			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}
	
			me.tooltip.transition(easingValue);
		},
	
		/**
		 * @private
		 */
		_getSortedDatasetMetas: function(filterVisible) {
			var me = this;
			var datasets = me.data.datasets || [];
			var result = [];
			var i, ilen;
	
			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!filterVisible || me.isDatasetVisible(i)) {
					result.push(me.getDatasetMeta(i));
				}
			}
	
			result.sort(compare2Level('order', 'index'));
	
			return result;
		},
	
		/**
		 * @private
		 */
		_getSortedVisibleDatasetMetas: function() {
			return this._getSortedDatasetMetas(true);
		},
	
		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;
			var metasets, i;
	
			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}
	
			metasets = me._getSortedVisibleDatasetMetas();
			for (i = metasets.length - 1; i >= 0; --i) {
				me.drawDataset(metasets[i], easingValue);
			}
	
			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},
	
		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(meta, easingValue) {
			var me = this;
			var args = {
				meta: meta,
				index: meta.index,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}
	
			meta.controller.draw(easingValue);
	
			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},
	
		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};
	
			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}
	
			tooltip.draw();
	
			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},
	
		/**
		 * Get the single element that was clicked on
		 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		 */
		getElementAtEvent: function(e) {
			return core_interaction.modes.single(this, e);
		},
	
		getElementsAtEvent: function(e) {
			return core_interaction.modes.label(this, e, {intersect: true});
		},
	
		getElementsAtXAxis: function(e) {
			return core_interaction.modes['x-axis'](this, e, {intersect: true});
		},
	
		getElementsAtEventForMode: function(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}
	
			return [];
		},
	
		getDatasetAtEvent: function(e) {
			return core_interaction.modes.dataset(this, e, {intersect: true});
		},
	
		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}
	
			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null,
					order: dataset.order || 0,
					index: datasetIndex
				};
			}
	
			return meta;
		},
	
		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},
	
		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);
	
			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},
	
		generateLegend: function() {
			return this.options.legendCallback(this);
		},
	
		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];
	
			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},
	
		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;
	
			me.stop();
	
			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}
	
			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}
	
			core_plugins.notify(me, 'destroy');
	
			delete Chart.instances[me.id];
		},
	
		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},
	
		initToolTip: function() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},
	
		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};
	
			helpers$1.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});
	
			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};
	
				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},
	
		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}
	
			delete me._listeners;
			helpers$1.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},
	
		updateHoverStyle: function(elements, mode, enabled) {
			var prefix = enabled ? 'set' : 'remove';
			var element, i, ilen;
	
			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
				}
			}
	
			if (mode === 'dataset') {
				this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
			}
		},
	
		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;
	
			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}
	
			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;
	
			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start
					? tooltip.handleEvent(e)
					: changed | tooltip.handleEvent(e);
			}
	
			core_plugins.notify(me, 'afterEvent', [e]);
	
			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();
	
				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}
	
			me._bufferedRender = false;
			me._bufferedRequest = null;
	
			return me;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;
	
			me.lastActive = me.lastActive || [];
	
			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}
	
			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}
	
			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}
	
			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}
	
			changed = !helpers$1.arrayEquals(me.active, me.lastActive);
	
			// Remember Last Actives
			me.lastActive = me.active;
	
			return changed;
		}
	});
	
	/**
	 * NOTE(SB) We actually don't use this container anymore but we need to keep it
	 * for backward compatibility. Though, it can still be useful for plugins that
	 * would need to work on multiple charts?!
	 */
	Chart.instances = {};
	
	var core_controller = Chart;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	Chart.types = {};
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.configMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.configMerge = mergeConfig;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.helpers.scaleMerge
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers$1.scaleMerge = mergeScaleConfig;
	
	var core_helpers = function() {
	
		// -- Basic js utility methods
	
		helpers$1.where = function(collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers$1.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers$1.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
		};
		helpers$1.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers$1.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
	
		/**
		 * Returns the number of decimal places
		 * i.e. the number of digits after the decimal point, of the value of this Number.
		 * @param {number} x - A number.
		 * @returns {number} The number of decimal places.
		 * @private
		 */
		helpers$1._decimalPlaces = function(x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};
	
		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.helpers.aliasPixel
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		helpers$1.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
	
		/**
		 * Returns the aligned pixel value to avoid anti-aliasing blur
		 * @param {Chart} chart - The chart instance.
		 * @param {number} pixel - A pixel value.
		 * @param {number} width - The width of the element.
		 * @returns {number} The aligned pixel value.
		 * @private
		 */
		helpers$1._alignPixel = function(chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};
	
		helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function(range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers$1.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		/**
		 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
		 * @param {HTMLElement} domNode - the node to check the constraint on
		 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
		 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
		 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
		 */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
		 * @private
	 	 */
		helpers$1._calculatePadding = function(container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);
	
			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
		 * @private
		 */
		helpers$1._getParentNode = function(domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}
	
			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
	
			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function(domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}
	
			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
	
			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			var ilen = arrayOfThings.length;
			var i, j, jlen, thing, nestedThing;
			for (i = 0; i < ilen; i++) {
				thing = arrayOfThings[i];
	
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					for (j = 0, jlen = thing.length; j < jlen; j++) {
						nestedThing = thing[j];
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					}
				}
			}
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
	
		/**
		 * @deprecated
		 */
		helpers$1.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function(thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers$1.color = !chartjsColor ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = core_defaults.global.defaultColor;
				}
	
				return chartjsColor(value);
			};
	
		helpers$1.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
				colorValue :
				helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};
	
	function abstract() {
		throw new Error(
			'This method is not implemented: either no adapter can ' +
			'be found or an incomplete integration was provided.'
		);
	}
	
	/**
	 * Date adapter (current used by the time scale)
	 * @namespace Chart._adapters._date
	 * @memberof Chart._adapters
	 * @private
	 */
	
	/**
	 * Currently supported unit string values.
	 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
	 * @memberof Chart._adapters._date
	 * @name Unit
	 */
	
	/**
	 * @class
	 */
	function DateAdapter(options) {
		this.options = options || {};
	}
	
	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
		/**
		 * Returns a map of time formats for the supported formatting units defined
		 * in Unit as well as 'datetime' representing a detailed date/time string.
		 * @returns {{string: string}}
		 */
		formats: abstract,
	
		/**
		 * Parses the given `value` and return the associated timestamp.
		 * @param {any} value - the value to parse (usually comes from the data)
		 * @param {string} [format] - the expected data format
		 * @returns {(number|null)}
		 * @function
		 */
		parse: abstract,
	
		/**
		 * Returns the formatted date in the specified `format` for a given `timestamp`.
		 * @param {number} timestamp - the timestamp to format
		 * @param {string} format - the date/time token
		 * @return {string}
		 * @function
		 */
		format: abstract,
	
		/**
		 * Adds the specified `amount` of `unit` to the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {number} amount - the amount to add
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		add: abstract,
	
		/**
		 * Returns the number of `unit` between the given timestamps.
		 * @param {number} max - the input timestamp (reference)
		 * @param {number} min - the timestamp to substract
		 * @param {Unit} unit - the unit as string
		 * @return {number}
		 * @function
		 */
		diff: abstract,
	
		/**
		 * Returns start of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
		 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
		 * @function
		 */
		startOf: abstract,
	
		/**
		 * Returns end of `unit` for the given `timestamp`.
		 * @param {number} timestamp - the input timestamp
		 * @param {Unit} unit - the unit as string
		 * @function
		 */
		endOf: abstract,
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility for scale.getValueForPixel(),
		 * this method should be overridden only by the moment adapter.
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(value) {
			return value;
		}
	});
	
	DateAdapter.override = function(members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};
	
	var _date = DateAdapter;
	
	var core_adapters = {
		_date: _date
	};
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	var core_ticks = {
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {string|string[]} the label to display
			 */
			values: function(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {number} the value to be formatted
			 * @param index {number} the position of the tickValue parameter in the ticks array
			 * @param ticks {number[]} the list of ticks being converted
			 * @return {string} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						var numExponential = Math.floor(logTick) - Math.floor(logDelta);
						numExponential = Math.max(Math.min(numExponential, 20), 0);
						tickString = tickValue.toExponential(numExponential);
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};
	
	var isArray = helpers$1.isArray;
	var isNullOrUndef = helpers$1.isNullOrUndef;
	var valueOrDefault$a = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
	
	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	/** Returns a new array containing numItems from arr */
	function sample(arr, numItems) {
		var result = [];
		var increment = arr.length / numItems;
		var i = 0;
		var len = arr.length;
	
		for (; i < len; i += increment) {
			result.push(arr[Math.floor(i)]);
		}
		return result;
	}
	
	function getPixelForGridLine(scale, index, offsetGridLines) {
		var length = scale.getTicks().length;
		var validIndex = Math.min(index, length - 1);
		var lineValue = scale.getPixelForTick(validIndex);
		var start = scale._startPixel;
		var end = scale._endPixel;
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
		var offset;
	
		if (offsetGridLines) {
			if (length === 1) {
				offset = Math.max(lineValue - start, end - lineValue);
			} else if (index === 0) {
				offset = (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
			}
			lineValue += validIndex < index ? offset : -offset;
	
			// Return undefined if the pixel is out of the range
			if (lineValue < start - epsilon || lineValue > end + epsilon) {
				return;
			}
		}
		return lineValue;
	}
	
	function garbageCollect(caches, length) {
		helpers$1.each(caches, function(cache) {
			var gc = cache.gc;
			var gcLen = gc.length / 2;
			var i;
			if (gcLen > length) {
				for (i = 0; i < gcLen; ++i) {
					delete cache.data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
		});
	}
	
	/**
	 * Returns {width, height, offset} objects for the first, last, widest, highest tick
	 * labels where offset indicates the anchor point offset from the top in pixels.
	 */
	function computeLabelSizes(ctx, tickFonts, ticks, caches) {
		var length = ticks.length;
		var widths = [];
		var heights = [];
		var offsets = [];
		var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
	
		for (i = 0; i < length; ++i) {
			label = ticks[i].label;
			tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
			ctx.font = fontString = tickFont.string;
			cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
			lineHeight = tickFont.lineHeight;
			width = height = 0;
			// Undefined labels and arrays should not be measured
			if (!isNullOrUndef(label) && !isArray(label)) {
				width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
				height = lineHeight;
			} else if (isArray(label)) {
				// if it is an array let's measure each element
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					nestedLabel = label[j];
					// Undefined labels and arrays should not be measured
					if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
						width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
						height += lineHeight;
					}
				}
			}
			widths.push(width);
			heights.push(height);
			offsets.push(lineHeight / 2);
		}
		garbageCollect(caches, length);
	
		widest = widths.indexOf(Math.max.apply(null, widths));
		highest = heights.indexOf(Math.max.apply(null, heights));
	
		function valueAt(idx) {
			return {
				width: widths[idx] || 0,
				height: heights[idx] || 0,
				offset: offsets[idx] || 0
			};
		}
	
		return {
			first: valueAt(0),
			last: valueAt(length - 1),
			widest: valueAt(widest),
			highest: valueAt(highest)
		};
	}
	
	function getTickMarkLength(options) {
		return options.drawTicks ? options.tickMarkLength : 0;
	}
	
	function getScaleLabelHeight(options) {
		var font, padding;
	
		if (!options.display) {
			return 0;
		}
	
		font = helpers$1.options._parseFont(options);
		padding = helpers$1.options.toPadding(options.padding);
	
		return font.lineHeight + padding.height;
	}
	
	function parseFontOptions(options, nestedOpts) {
		return helpers$1.extend(helpers$1.options._parseFont({
			fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
			fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
			fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
			lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
		}), {
			color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
		});
	}
	
	function parseTickFontOptions(options) {
		var minor = parseFontOptions(options, options.minor);
		var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
	
		return {minor: minor, major: major};
	}
	
	function nonSkipped(ticksToFilter) {
		var filtered = [];
		var item, index, len;
		for (index = 0, len = ticksToFilter.length; index < len; ++index) {
			item = ticksToFilter[index];
			if (typeof item._index !== 'undefined') {
				filtered.push(item);
			}
		}
		return filtered;
	}
	
	function getEvenSpacing(arr) {
		var len = arr.length;
		var i, diff;
	
		if (len < 2) {
			return false;
		}
	
		for (diff = arr[0], i = 1; i < len; ++i) {
			if (arr[i] - arr[i - 1] !== diff) {
				return false;
			}
		}
		return diff;
	}
	
	function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
		var evenMajorSpacing = getEvenSpacing(majorIndices);
		var spacing = (ticks.length - 1) / ticksLimit;
		var factors, factor, i, ilen;
	
		// If the major ticks are evenly spaced apart, place the minor ticks
		// so that they divide the major ticks into even chunks
		if (!evenMajorSpacing) {
			return Math.max(spacing, 1);
		}
	
		factors = helpers$1.math._factorize(evenMajorSpacing);
		for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
			factor = factors[i];
			if (factor > spacing) {
				return factor;
			}
		}
		return Math.max(spacing, 1);
	}
	
	function getMajorIndices(ticks) {
		var result = [];
		var i, ilen;
		for (i = 0, ilen = ticks.length; i < ilen; i++) {
			if (ticks[i].major) {
				result.push(i);
			}
		}
		return result;
	}
	
	function skipMajors(ticks, majorIndices, spacing) {
		var count = 0;
		var next = majorIndices[0];
		var i, tick;
	
		spacing = Math.ceil(spacing);
		for (i = 0; i < ticks.length; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = majorIndices[count * spacing];
			} else {
				delete tick.label;
			}
		}
	}
	
	function skip(ticks, spacing, majorStart, majorEnd) {
		var start = valueOrDefault$a(majorStart, 0);
		var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
		var count = 0;
		var length, i, tick, next;
	
		spacing = Math.ceil(spacing);
		if (majorEnd) {
			length = majorEnd - majorStart;
			spacing = length / Math.floor(length / spacing);
		}
	
		next = start;
	
		while (next < 0) {
			count++;
			next = Math.round(start + count * spacing);
		}
	
		for (i = Math.max(start, 0); i < end; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = Math.round(start + count * spacing);
			} else {
				delete tick.label;
			}
		}
	}
	
	var Scale = core_element.extend({
	
		zeroLineIndex: 0,
	
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},
	
		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},
	
		/**
		* @private
		*/
		_getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
		},
	
		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type
	
		/**
		 * Provided for backward compatibility, not available anymore
		 * @function Chart.Scale.mergeTicksOptions
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 */
		mergeTicksOptions: function() {
			// noop
		},
	
		beforeUpdate: function() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},
	
		/**
		 * @param {number} maxWidth - the max width in pixels
		 * @param {number} maxHeight - the max height in pixels
		 * @param {object} margins - the space between the edge of the other scales and edge of the chart
		 *   This space comes from two sources:
		 *     - padding - space that's required to show the labels at the edges of the scale
		 *     - thickness of scales or legends in another orientation
		 */
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var tickOpts = me.options.ticks;
			var sampleSize = tickOpts.sampleSize;
			var i, ilen, labels, ticks, samplingEnabled;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
	
			me._ticks = null;
			me.ticks = null;
			me._labelSizes = null;
			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};
			me._gridLineItems = null;
			me._labelItems = null;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
	
			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();
	
			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.
	
			me.beforeBuildTicks();
	
			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];
	
			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;
	
			// Ensure ticks contains ticks in new tick format
			if ((!ticks || !ticks.length) && me.ticks) {
				ticks = [];
				for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
					ticks.push({
						value: me.ticks[i],
						major: false
					});
				}
			}
	
			me._ticks = ticks;
	
			// Compute tick rotation and fit using a sampled subset of labels
			// We generally don't need to compute the size of every single label for determining scale size
			samplingEnabled = sampleSize < ticks.length;
			labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
	
			// _configure is called twice, once here, once from core.controller.updateLayout.
			// Here we haven't been positioned yet, but dimensions are correct.
			// Variables set in _configure are needed for calculateTickRotation, and
			// it's ok that coordinates are not correct there, only dimensions matter.
			me._configure();
	
			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
	
			me.beforeFit();
			me.fit();
			me.afterFit();
	
			// Auto-skip
			me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
	
			if (samplingEnabled) {
				// Generate labels using all non-skipped ticks
				labels = me._convertTicksToLabels(me._ticksToDraw);
			}
	
			me.ticks = labels;   // BACKWARD COMPATIBILITY
	
			// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
	
			me.afterUpdate();
	
			// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
			// make maxWidth and maxHeight private
			return me.minSize;
		},
	
		/**
		 * @private
		 */
		_configure: function() {
			var me = this;
			var reversePixels = me.options.ticks.reverse;
			var startPixel, endPixel;
	
			if (me.isHorizontal()) {
				startPixel = me.left;
				endPixel = me.right;
			} else {
				startPixel = me.top;
				endPixel = me.bottom;
				// by default vertical scales are from bottom to top, so pixels are reversed
				reversePixels = !reversePixels;
			}
			me._startPixel = startPixel;
			me._endPixel = endPixel;
			me._reversePixels = reversePixels;
			me._length = endPixel - startPixel;
		},
	
		afterUpdate: function() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},
	
		//
	
		beforeSetDimensions: function() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},
	
		// Data limits
		beforeDataLimits: function() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},
	
		//
		beforeBuildTicks: function() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},
	
		beforeTickToLabelConversion: function() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},
	
		//
	
		beforeCalculateTickRotation: function() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var options = me.options;
			var tickOpts = options.ticks;
			var numTicks = me.getTicks().length;
			var minRotation = tickOpts.minRotation || 0;
			var maxRotation = tickOpts.maxRotation;
			var labelRotation = minRotation;
			var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
	
			if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
				me.labelRotation = minRotation;
				return;
			}
	
			labelSizes = me._getLabelSizes();
			maxLabelWidth = labelSizes.widest.width;
			maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
	
			// Estimate the width of each grid based on the canvas width, the maximum
			// label width and the number of tick intervals
			maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
			tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
	
			// Allow 3 pixels x2 padding either side for label readability
			if (maxLabelWidth + 6 > tickWidth) {
				tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
				maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
					- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
				maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
				labelRotation = helpers$1.toDegrees(Math.min(
					Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
					Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
				));
				labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
			}
	
			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},
	
		//
	
		beforeFit: function() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};
	
			var chart = me.chart;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var isBottom = opts.position === 'bottom';
			var isHorizontal = me.isHorizontal();
	
			// Width
			if (isHorizontal) {
				minSize.width = me.maxWidth;
			} else if (display) {
				minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// height
			if (!isHorizontal) {
				minSize.height = me.maxHeight; // fill all the height
			} else if (display) {
				minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}
	
			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var tickFonts = parseTickFontOptions(tickOpts);
				var labelSizes = me._getLabelSizes();
				var firstLabelSize = labelSizes.first;
				var lastLabelSize = labelSizes.last;
				var widestLabelSize = labelSizes.widest;
				var highestLabelSize = labelSizes.highest;
				var lineSpace = tickFonts.minor.lineHeight * 0.4;
				var tickPadding = tickOpts.padding;
	
				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					var isRotated = me.labelRotation !== 0;
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);
	
					var labelHeight = sinRotation * widestLabelSize.width
						+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
						+ (isRotated ? 0 : lineSpace); // padding
	
					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
					var paddingLeft, paddingRight;
	
					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (isRotated) {
						paddingLeft = isBottom ?
							cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
							sinRotation * (firstLabelSize.height - firstLabelSize.offset);
						paddingRight = isBottom ?
							sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
							cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
					} else {
						paddingLeft = firstLabelSize.width / 2;
						paddingRight = lastLabelSize.width / 2;
					}
	
					// Adjust padding taking into account changes in offsets
					// and add 3 px to move away from canvas edges
					me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
					me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					var labelWidth = tickOpts.mirror ? 0 :
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						widestLabelSize.width + tickPadding + lineSpace;
	
					minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
	
					me.paddingTop = firstLabelSize.height / 2;
					me.paddingBottom = lastLabelSize.height / 2;
				}
			}
	
			me.handleMargins();
	
			if (isHorizontal) {
				me.width = me._length = chart.width - me.margins.left - me.margins.right;
				me.height = minSize.height;
			} else {
				me.width = minSize.width;
				me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
			}
		},
	
		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.margins.left = Math.max(me.paddingLeft, me.margins.left);
				me.margins.top = Math.max(me.paddingTop, me.margins.top);
				me.margins.right = Math.max(me.paddingRight, me.margins.right);
				me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
			}
		},
	
		afterFit: function() {
			helpers$1.callback(this.options.afterFit, [this]);
		},
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
		isFullWidth: function() {
			return this.options.fullWidth;
		},
	
		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}
	
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}
	
			// Value is good, return it
			return rawValue;
		},
	
		_convertTicksToLabels: function(ticks) {
			var me = this;
			var labels, i, ilen;
	
			me.ticks = ticks.map(function(tick) {
				return tick.value;
			});
	
			me.beforeTickToLabelConversion();
	
			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;
	
			me.afterTickToLabelConversion();
	
			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				ticks[i].label = labels[i];
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		_getLabelSizes: function() {
			var me = this;
			var labelSizes = me._labelSizes;
	
			if (!labelSizes) {
				me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
				me.longestLabelWidth = labelSizes.widest.width;
			}
	
			return labelSizes;
		},
	
		/**
		 * @private
		 */
		_parseValue: function(value) {
			var start, end, min, max;
	
			if (isArray(value)) {
				start = +this.getRightValue(value[0]);
				end = +this.getRightValue(value[1]);
				min = Math.min(start, end);
				max = Math.max(start, end);
			} else {
				value = +this.getRightValue(value);
				start = undefined;
				end = value;
				min = value;
				max = value;
			}
	
			return {
				min: min,
				max: max,
				start: start,
				end: end
			};
		},
	
		/**
		* @private
		*/
		_getScaleLabel: function(rawValue) {
			var v = this._parseValue(rawValue);
			if (v.start !== undefined) {
				return '[' + v.start + ', ' + v.end + ']';
			}
	
			return +this.getRightValue(rawValue);
		},
	
		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers$1.noop,
	
		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers$1.noop,
	
		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers$1.noop,
	
		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			var numTicks = me._ticks.length;
			var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
	
			return index < 0 || index > numTicks - 1
				? null
				: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
		},
	
		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
	
			if (me._reversePixels) {
				decimal = 1 - decimal;
			}
	
			return me._startPixel + decimal * me._length;
		},
	
		getDecimalForPixel: function(pixel) {
			var decimal = (pixel - this._startPixel) / this._length;
			return this._reversePixels ? 1 - decimal : decimal;
		},
	
		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},
	
		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},
	
		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var me = this;
			var tickOpts = me.options.ticks;
			var axisLength = me._length;
			var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
			var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
			var numMajorIndices = majorIndices.length;
			var first = majorIndices[0];
			var last = majorIndices[numMajorIndices - 1];
			var i, ilen, spacing, avgMajorSpacing;
	
			// If there are too many major ticks to display them all
			if (numMajorIndices > ticksLimit) {
				skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
				return nonSkipped(ticks);
			}
	
			spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
	
			if (numMajorIndices > 0) {
				for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
					skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
				}
				avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
				skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
				skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
				return nonSkipped(ticks);
			}
			skip(ticks, spacing);
			return nonSkipped(ticks);
		},
	
		/**
		 * @private
		 */
		_tickSize: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));
	
			var labelSizes = me._getLabelSizes();
			var padding = optionTicks.autoSkipPadding || 0;
			var w = labelSizes ? labelSizes.widest.width + padding : 0;
			var h = labelSizes ? labelSizes.highest.height + padding : 0;
	
			// Calculate space needed for 1 tick in axis direction.
			return me.isHorizontal()
				? h * cos > w * sin ? w / cos : h / sin
				: h * sin < w * cos ? h / cos : w / sin;
		},
	
		/**
		 * @private
		 */
		_isVisible: function() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;
	
			if (display !== 'auto') {
				return !!display;
			}
	
			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}
	
			return false;
		},
	
		/**
		 * @private
		 */
		_computeGridLineItems: function(chartArea) {
			var me = this;
			var chart = me.chart;
			var options = me.options;
			var gridLines = options.gridLines;
			var position = options.position;
			var offsetGridLines = gridLines.offsetGridLines;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
	
			var tl = getTickMarkLength(gridLines);
			var items = [];
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var axisHalfWidth = axisWidth / 2;
			var alignPixel = helpers$1._alignPixel;
			var alignBorderValue = function(pixel) {
				return alignPixel(chart, pixel, axisWidth);
			};
			var borderValue, i, tick, lineValue, alignedLineValue;
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
	
			if (position === 'top') {
				borderValue = alignBorderValue(me.bottom);
				ty1 = me.bottom - tl;
				ty2 = borderValue - axisHalfWidth;
				y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
				y2 = chartArea.bottom;
			} else if (position === 'bottom') {
				borderValue = alignBorderValue(me.top);
				y1 = chartArea.top;
				y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
				ty1 = borderValue + axisHalfWidth;
				ty2 = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignBorderValue(me.right);
				tx1 = me.right - tl;
				tx2 = borderValue - axisHalfWidth;
				x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
				x2 = chartArea.right;
			} else {
				borderValue = alignBorderValue(me.left);
				x1 = chartArea.left;
				x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
				tx1 = borderValue + axisHalfWidth;
				tx2 = me.left + tl;
			}
	
			for (i = 0; i < ticksLength; ++i) {
				tick = ticks[i] || {};
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(tick.label) && i < ticks.length) {
					continue;
				}
	
				if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
					lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}
	
				lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
	
				// Skip if the pixel is out of the range
				if (lineValue === undefined) {
					continue;
				}
	
				alignedLineValue = alignPixel(chart, lineValue, lineWidth);
	
				if (isHorizontal) {
					tx1 = tx2 = x1 = x2 = alignedLineValue;
				} else {
					ty1 = ty2 = y1 = y2 = alignedLineValue;
				}
	
				items.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					width: lineWidth,
					color: lineColor,
					borderDash: borderDash,
					borderDashOffset: borderDashOffset,
				});
			}
	
			items.ticksLength = ticksLength;
			items.borderValue = borderValue;
	
			return items;
		},
	
		/**
		 * @private
		 */
		_computeLabelItems: function() {
			var me = this;
			var options = me.options;
			var optionTicks = options.ticks;
			var position = options.position;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var fonts = parseTickFontOptions(optionTicks);
			var tickPadding = optionTicks.padding;
			var tl = getTickMarkLength(options.gridLines);
			var rotation = -helpers$1.toRadians(me.labelRotation);
			var items = [];
			var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
	
			if (position === 'top') {
				y = me.bottom - tl - tickPadding;
				textAlign = !rotation ? 'center' : 'left';
			} else if (position === 'bottom') {
				y = me.top + tl + tickPadding;
				textAlign = !rotation ? 'center' : 'right';
			} else if (position === 'left') {
				x = me.right - (isMirrored ? 0 : tl) - tickPadding;
				textAlign = isMirrored ? 'left' : 'right';
			} else {
				x = me.left + (isMirrored ? 0 : tl) + tickPadding;
				textAlign = isMirrored ? 'right' : 'left';
			}
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				tick = ticks[i];
				label = tick.label;
	
				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(label)) {
					continue;
				}
	
				pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
				font = tick.major ? fonts.major : fonts.minor;
				lineHeight = font.lineHeight;
				lineCount = isArray(label) ? label.length : 1;
	
				if (isHorizontal) {
					x = pixel;
					textOffset = position === 'top'
						? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
						: (!rotation ? 0.5 : 0) * lineHeight;
				} else {
					y = pixel;
					textOffset = (1 - lineCount) * lineHeight / 2;
				}
	
				items.push({
					x: x,
					y: y,
					rotation: rotation,
					label: label,
					font: font,
					textOffset: textOffset,
					textAlign: textAlign
				});
			}
	
			return items;
		},
	
		/**
		 * @private
		 */
		_drawGrid: function(chartArea) {
			var me = this;
			var gridLines = me.options.gridLines;
	
			if (!gridLines.display) {
				return;
			}
	
			var ctx = me.ctx;
			var chart = me.chart;
			var alignPixel = helpers$1._alignPixel;
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
			var width, color, i, ilen, item;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				width = item.width;
				color = item.color;
	
				if (width && color) {
					ctx.save();
					ctx.lineWidth = width;
					ctx.strokeStyle = color;
					if (ctx.setLineDash) {
						ctx.setLineDash(item.borderDash);
						ctx.lineDashOffset = item.borderDashOffset;
					}
	
					ctx.beginPath();
	
					if (gridLines.drawTicks) {
						ctx.moveTo(item.tx1, item.ty1);
						ctx.lineTo(item.tx2, item.ty2);
					}
	
					if (gridLines.drawOnChartArea) {
						ctx.moveTo(item.x1, item.y1);
						ctx.lineTo(item.x2, item.y2);
					}
	
					ctx.stroke();
					ctx.restore();
				}
			}
	
			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
				var borderValue = items.borderValue;
				var x1, x2, y1, y2;
	
				if (me.isHorizontal()) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}
	
				ctx.lineWidth = axisWidth;
				ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var optionTicks = me.options.ticks;
	
			if (!optionTicks.display) {
				return;
			}
	
			var ctx = me.ctx;
			var items = me._labelItems || (me._labelItems = me._computeLabelItems());
			var i, j, ilen, jlen, item, tickFont, label, y;
	
			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				tickFont = item.font;
	
				// Make sure we draw text in the correct color and font
				ctx.save();
				ctx.translate(item.x, item.y);
				ctx.rotate(item.rotation);
				ctx.font = tickFont.string;
				ctx.fillStyle = tickFont.color;
				ctx.textBaseline = 'middle';
				ctx.textAlign = item.textAlign;
	
				label = item.label;
				y = item.textOffset;
				if (isArray(label)) {
					for (j = 0, jlen = label.length; j < jlen; ++j) {
						// We just make sure the multiline element is a string here..
						ctx.fillText('' + label[j], 0, y);
						y += tickFont.lineHeight;
					}
				} else {
					ctx.fillText(label, 0, y);
				}
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawTitle: function() {
			var me = this;
			var ctx = me.ctx;
			var options = me.options;
			var scaleLabel = options.scaleLabel;
	
			if (!scaleLabel.display) {
				return;
			}
	
			var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
			var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var halfLineHeight = scaleLabelFont.lineHeight / 2;
			var position = options.position;
			var rotation = 0;
			var scaleLabelX, scaleLabelY;
	
			if (me.isHorizontal()) {
				scaleLabelX = me.left + me.width / 2; // midpoint of the width
				scaleLabelY = position === 'bottom'
					? me.bottom - halfLineHeight - scaleLabelPadding.bottom
					: me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft
					? me.left + halfLineHeight + scaleLabelPadding.top
					: me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + me.height / 2;
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}
	
			ctx.save();
			ctx.translate(scaleLabelX, scaleLabelY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.fillStyle = scaleLabelFontColor; // render in correct colour
			ctx.font = scaleLabelFont.string;
			ctx.fillText(scaleLabel.labelString, 0, 0);
			ctx.restore();
		},
	
		draw: function(chartArea) {
			var me = this;
	
			if (!me._isVisible()) {
				return;
			}
	
			me._drawGrid(chartArea);
			me._drawTitle();
			me._drawLabels();
		},
	
		/**
		 * @private
		 */
		_layers: function() {
			var me = this;
			var opts = me.options;
			var tz = opts.ticks && opts.ticks.z || 0;
			var gz = opts.gridLines && opts.gridLines.z || 0;
	
			if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
				// backward compatibility: draw has been overridden by custom scale
				return [{
					z: tz,
					draw: function() {
						me.draw.apply(me, arguments);
					}
				}];
			}
	
			return [{
				z: gz,
				draw: function() {
					me._drawGrid.apply(me, arguments);
					me._drawTitle.apply(me, arguments);
				}
			}, {
				z: tz,
				draw: function() {
					me._drawLabels.apply(me, arguments);
				}
			}];
		},
	
		/**
		 * @private
		 */
		_getMatchingVisibleMetas: function(type) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			return me.chart._getSortedVisibleDatasetMetas()
				.filter(function(meta) {
					return (!type || meta.type === type)
						&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
				});
		}
	});
	
	Scale.prototype._draw = Scale.prototype.draw;
	
	var core_scale = Scale;
	
	var isNullOrUndef$1 = helpers$1.isNullOrUndef;
	
	var defaultConfig = {
		position: 'bottom'
	};
	
	var scale_category = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var labels = me._getLabels();
			var ticksOpts = me.options.ticks;
			var min = ticksOpts.min;
			var max = ticksOpts.max;
			var minIndex = 0;
			var maxIndex = labels.length - 1;
			var findIndex;
	
			if (min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(min);
				if (findIndex >= 0) {
					minIndex = findIndex;
				}
			}
	
			if (max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(max);
				if (findIndex >= 0) {
					maxIndex = findIndex;
				}
			}
	
			me.minIndex = minIndex;
			me.maxIndex = maxIndex;
			me.min = labels[minIndex];
			me.max = labels[maxIndex];
		},
	
		buildTicks: function() {
			var me = this;
			var labels = me._getLabels();
			var minIndex = me.minIndex;
			var maxIndex = me.maxIndex;
	
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var chart = me.chart;
	
			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}
	
			return me._getLabels()[index];
		},
	
		_configure: function() {
			var me = this;
			var offset = me.options.offset;
			var ticks = me.ticks;
	
			core_scale.prototype._configure.call(me);
	
			if (!me.isHorizontal()) {
				// For backward compatibility, vertical category scale reverse is inverted.
				me._reversePixels = !me._reversePixels;
			}
	
			if (!ticks) {
				return;
			}
	
			me._startValue = me.minIndex - (offset ? 0.5 : 0);
			me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
		},
	
		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var valueCategory, labels, idx;
	
			if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
				value = me.chart.data.datasets[datasetIndex].data[index];
			}
	
			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			if (!isNullOrUndef$1(value)) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				labels = me._getLabels();
				value = helpers$1.valueOrDefault(valueCategory, value);
				idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
				if (isNaN(index)) {
					index = value;
				}
			}
			return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticks;
			return index < 0 || index > ticks.length - 1
				? null
				: this.getPixelForValue(ticks[index], index + this.minIndex);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
			return Math.min(Math.max(value, 0), me.ticks.length - 1);
		},
	
		getBasePixel: function() {
			return this.bottom;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;
	
	var noop = helpers$1.noop;
	var isNullOrUndef$2 = helpers$1.isNullOrUndef;
	
	/**
	 * Generate a set of linear ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.
	
		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;
	
		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
			return [rmin, rmax];
		}
	
		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}
	
		if (stepSize || isNullOrUndef$2(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}
	
		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;
	
		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}
	
		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}
	
		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef$2(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef$2(max) ? niceMax : max);
	
		return ticks;
	}
	
	var scale_linearbase = core_scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);
	
				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}
	
			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}
	
			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}
	
			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}
	
			if (me.min === me.max) {
				me.max++;
	
				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
	
		getTickLimit: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;
	
			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}
	
			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}
	
			return maxTicks;
		},
	
		_computeTickLimit: function() {
			return Number.POSITIVE_INFINITY;
		},
	
		handleDirectionalChanges: noop,
	
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);
	
			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
	
			me.handleDirectionalChanges();
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				ticks.reverse();
	
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
	
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);
	
			core_scale.prototype.convertTicksToLabels.call(me);
		},
	
		_configure: function() {
			var me = this;
			var ticks = me.getTicks();
			var start = me.min;
			var end = me.max;
			var offset;
	
			core_scale.prototype._configure.call(me);
	
			if (me.options.offset && ticks.length) {
				offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
				start -= offset;
				end += offset;
			}
			me._startValue = start;
			me._endValue = end;
			me._valueRange = end - start;
		}
	});
	
	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};
	
	var DEFAULT_MIN = 0;
	var DEFAULT_MAX = 1;
	
	function getOrCreateStack(stacks, stacked, meta) {
		var key = [
			meta.type,
			// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
			stacked === undefined && meta.stack === undefined ? meta.index : '',
			meta.stack
		].join('.');
	
		if (stacks[key] === undefined) {
			stacks[key] = {
				pos: [],
				neg: []
			};
		}
	
		return stacks[key];
	}
	
	function stackData(scale, stacks, meta, data) {
		var opts = scale.options;
		var stacked = opts.stacked;
		var stack = getOrCreateStack(stacks, stacked, meta);
		var pos = stack.pos;
		var neg = stack.neg;
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			pos[i] = pos[i] || 0;
			neg[i] = neg[i] || 0;
	
			if (opts.relativePoints) {
				pos[i] = 100;
			} else if (value.min < 0 || value.max < 0) {
				neg[i] += value.min;
			} else {
				pos[i] += value.max;
			}
		}
	}
	
	function updateMinMax(scale, meta, data) {
		var ilen = data.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}
	
			scale.min = Math.min(scale.min, value.min);
			scale.max = Math.max(scale.max, value.max);
		}
	}
	
	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var metasets = me._getMatchingVisibleMetas();
			var hasStacks = opts.stacked;
			var stacks = {};
			var ilen = metasets.length;
			var i, meta, data, values;
	
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
	
			if (hasStacks === undefined) {
				for (i = 0; !hasStacks && i < ilen; ++i) {
					meta = metasets[i];
					hasStacks = meta.stack !== undefined;
				}
			}
	
			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				data = datasets[meta.index].data;
				if (hasStacks) {
					stackData(me, stacks, meta, data);
				} else {
					updateMinMax(me, meta, data);
				}
			}
	
			helpers$1.each(stacks, function(stackValues) {
				values = stackValues.pos.concat(stackValues.neg);
				me.min = Math.min(me.min, helpers$1.min(values));
				me.max = Math.max(me.max, helpers$1.max(values));
			});
	
			me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			var me = this;
			var tickFont;
	
			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},
	
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		// Utils
		getPixelForValue: function(value) {
			var me = this;
			return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
		},
	
		getValueForPixel: function(pixel) {
			return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
		},
	
		getPixelForTick: function(index) {
			var ticks = this.ticksAsNumbers;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;
	
	var valueOrDefault$b = helpers$1.valueOrDefault;
	var log10 = helpers$1.math.log10;
	
	/**
	 * Generate a set of logarithmic ticks
	 * @param generationOptions the options used to generate the ticks
	 * @param dataRange the range of the data
	 * @returns {number[]} array of tick values
	 */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];
	
		var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
	
		var endExp = Math.floor(log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;
	
		if (tickVal === 0) {
			exp = Math.floor(log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
	
		do {
			ticks.push(tickVal);
	
			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}
	
			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
		var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
		ticks.push(lastTick);
	
		return ticks;
	}
	
	var defaultConfig$2 = {
		position: 'left',
	
		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};
	
	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}
	
	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
			var datasetIndex, meta, value, data, i, ilen;
	
			// Calculate Range
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
			me.minNotZero = Number.POSITIVE_INFINITY;
	
			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
						break;
					}
				}
			}
	
			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};
	
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');
	
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}
	
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							var values = valuesPerStack[key];
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
							values[i] = values[i] || 0;
							values[i] += value.max;
						}
					}
				}
	
				helpers$1.each(valuesPerStack, function(valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = Math.min(me.min, minVal);
						me.max = Math.max(me.max, maxVal);
					}
				});
	
			} else {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
	
							me.min = Math.min(value.min, me.min);
							me.max = Math.max(value.max, me.max);
	
							if (value.min !== 0) {
								me.minNotZero = Math.min(value.min, me.minNotZero);
							}
						}
					}
				}
			}
	
			me.min = helpers$1.isFinite(me.min) ? me.min : null;
			me.max = helpers$1.isFinite(me.max) ? me.max : null;
			me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
	
			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},
	
		handleTickRangeOptions: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;
	
			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);
	
			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0
					? Math.pow(10, Math.floor(log10(me.min)) + 1)
					: DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},
	
		buildTicks: function() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();
	
			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);
	
			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);
	
			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},
	
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();
	
			core_scale.prototype.convertTicksToLabels.call(this);
		},
	
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		getPixelForTick: function(index) {
			var ticks = this.tickValues;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		},
	
		/**
		 * Returns the value of the first tick.
		 * @param {number} value - The minimum not zero value.
		 * @return {number} The first tick value.
		 * @private
		 */
		_getFirstTickValue: function(value) {
			var exp = Math.floor(log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));
	
			return significand * Math.pow(10, exp);
		},
	
		_configure: function() {
			var me = this;
			var start = me.min;
			var offset = 0;
	
			core_scale.prototype._configure.call(me);
	
			if (start === 0) {
				start = me._getFirstTickValue(me.minNotZero);
				offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
			}
	
			me._startValue = log10(start);
			me._valueOffset = offset;
			me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
		},
	
		getPixelForValue: function(value) {
			var me = this;
			var decimal = 0;
	
			value = +me.getRightValue(value);
	
			if (value > me.min && value > 0) {
				decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
			}
			return me.getPixelForDecimal(decimal);
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var decimal = me.getDecimalForPixel(pixel);
			return decimal === 0 && me.min === 0
				? 0
				: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;
	
	var valueOrDefault$c = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$4 = helpers$1.options.resolve;
	
	var defaultConfig$3 = {
		display: true,
	
		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',
	
		angleLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		gridLines: {
			circular: false
		},
	
		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,
	
			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',
	
			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,
	
			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,
	
			callback: core_ticks.formatters.linear
		},
	
		pointLabels: {
			// Boolean - if true, show point labels
			display: true,
	
			// Number - Point label font size in pixels
			fontSize: 10,
	
			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};
	
	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;
	
		if (tickOpts.display && opts.display) {
			return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}
	
	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}
	
		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}
	
	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}
	
		return {
			start: pos,
			end: pos + size
		};
	}
	
	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
	
		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
	
		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
	
		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;
	
		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];
	
		var valueCount = scale.chart.data.labels.length;
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
			scale._pointLabelSizes[i] = textSize;
	
			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}
	
			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}
	
			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}
	
			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}
	
		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}
	
	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}
	
		return 'right';
	}
	
	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;
	
		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}
	
	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}
	
	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var pointLabelOpts = opts.pointLabels;
		var tickBackdropHeight = getTickBackdropHeight(opts);
		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
		var plFont = helpers$1.options._parseFont(pointLabelOpts);
	
		ctx.save();
	
		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';
	
		for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
			// Extra pixels out for some label spacing
			var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
	
			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;
	
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
		}
		ctx.restore();
	}
	
	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = scale.chart.data.labels.length;
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;
	
		if ((!circular && !valueCount) || !lineColor || !lineWidth) {
			return;
		}
	
		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}
	
		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);
	
			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}
	
	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}
	
	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function() {
			var me = this;
	
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;
	
			helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);
	
					helpers$1.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}
	
						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});
	
			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
	
		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},
	
		convertTicksToLabels: function() {
			var me = this;
	
			scale_linearbase.prototype.convertTicksToLabels.call(me);
	
			// Point labels
			me.pointLabels = me.chart.data.labels.map(function() {
				var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
				return label || label === 0 ? label : '';
			});
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
	
		fit: function() {
			var me = this;
			var opts = me.options;
	
			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},
	
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
	
			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
			me.drawingArea = Math.min(
				Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
	
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;
	
			me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
		},
	
		getIndexAngle: function(index) {
			var chart = this.chart;
			var angleMultiplier = 360 / chart.data.labels.length;
			var options = chart.options || {};
			var startAngle = options.startAngle || 0;
	
			// Start from the top instead of right, so remove a quarter of the circle
			var angle = (index * angleMultiplier + startAngle) % 360;
	
			return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
		},
	
		getDistanceFromCenterForValue: function(value) {
			var me = this;
	
			if (helpers$1.isNullOrUndef(value)) {
				return NaN;
			}
	
			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
	
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},
	
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},
	
		getBasePosition: function(index) {
			var me = this;
			var min = me.min;
			var max = me.max;
	
			return me.getPointPositionForValue(index || 0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},
	
		/**
		 * @private
		 */
		_drawGrid: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var angleLineOpts = opts.angleLines;
			var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
			var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
			var i, offset, position;
	
			if (opts.pointLabels.display) {
				drawPointLabels(me);
			}
	
			if (gridLineOpts.display) {
				helpers$1.each(me.ticks, function(label, index) {
					if (index !== 0) {
						offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						drawRadiusLine(me, gridLineOpts, offset, index);
					}
				});
			}
	
			if (angleLineOpts.display && lineWidth && lineColor) {
				ctx.save();
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = lineColor;
				if (ctx.setLineDash) {
					ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
					ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
				}
	
				for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
					offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
					position = me.getPointPosition(i, offset);
					ctx.beginPath();
					ctx.moveTo(me.xCenter, me.yCenter);
					ctx.lineTo(position.x, position.y);
					ctx.stroke();
				}
	
				ctx.restore();
			}
		},
	
		/**
		 * @private
		 */
		_drawLabels: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var tickOpts = opts.ticks;
	
			if (!tickOpts.display) {
				return;
			}
	
			var startAngle = me.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);
			var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
			var offset, width;
	
			ctx.save();
			ctx.font = tickFont.string;
			ctx.translate(me.xCenter, me.yCenter);
			ctx.rotate(startAngle);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			helpers$1.each(me.ticks, function(label, index) {
				if (index === 0 && !tickOpts.reverse) {
					return;
				}
	
				offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
				if (tickOpts.showLabelBackdrop) {
					width = ctx.measureText(label).width;
					ctx.fillStyle = tickOpts.backdropColor;
	
					ctx.fillRect(
						-width / 2 - tickOpts.backdropPaddingX,
						-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
						width + tickOpts.backdropPaddingX * 2,
						tickFont.size + tickOpts.backdropPaddingY * 2
					);
				}
	
				ctx.fillStyle = tickFontColor;
				ctx.fillText(label, 0, -offset);
			});
	
			ctx.restore();
		},
	
		/**
		 * @private
		 */
		_drawTitle: helpers$1.noop
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;
	
	var deprecated$1 = helpers$1._deprecated;
	var resolve$5 = helpers$1.options.resolve;
	var valueOrDefault$d = helpers$1.valueOrDefault;
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: 1000
		},
		second: {
			common: true,
			size: 1000,
			steps: 60
		},
		minute: {
			common: true,
			size: 60000,
			steps: 60
		},
		hour: {
			common: true,
			size: 3600000,
			steps: 24
		},
		day: {
			common: true,
			size: 86400000,
			steps: 30
		},
		week: {
			common: false,
			size: 604800000,
			steps: 4
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: 12
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: 4
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	function getMin(options) {
		return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
	}
	
	function getMax(options) {
		return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;
	
		if (typeof parser === 'function') {
			value = parser(value);
		}
	
		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string'
				? adapter.parse(value, format)
				: adapter.parse(value);
		}
	
		if (value !== null) {
			return +value;
		}
	
		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);
	
			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}
	
		return value;
	}
	
	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}
	
		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}
	
		return value;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
		var i, unit;
	
		for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var first = min;
		var ticks = [];
		var time;
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
		}
	
		// Align first ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);
	
		// Prevent browser from freezing in case user options request millions of milliseconds
		if (adapter.diff(max, min, minor) > 100000 * stepSize) {
			throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
		}
	
		for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(time);
		}
	
		if (time === max || options.bounds === 'ticks') {
			ticks.push(time);
		}
	
		return ticks;
	}
	
	/**
	 * Returns the start and end offsets from edges in the form of {start, end}
	 * where each value is a relative width to the scale and ranges between 0 and 1.
	 * They add extra margins on the both sides by scaling down the original scale.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;
	
		if (options.offset && ticks.length) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}
	
		return {start: start, end: end, factor: 1 / (start + 1 + end)};
	}
	
	function setMajorTicks(scale, ticks, map, majorUnit) {
		var adapter = scale._adapter;
		var first = +adapter.startOf(ticks[0].value, majorUnit);
		var last = ticks[ticks.length - 1].value;
		var major, index;
	
		for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
			index = map[major];
			if (index >= 0) {
				ticks[index].major = true;
			}
		}
		return ticks;
	}
	
	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var map = {};
		var ilen = values.length;
		var i, value;
	
		for (i = 0; i < ilen; ++i) {
			value = values[i];
			map[value] = i;
	
			ticks.push({
				value: value,
				major: false
			});
		}
	
		// We set the major ticks separately from the above loop because calling startOf for every tick
		// is expensive when there is a large number of ticks
		return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
	}
	
	var defaultConfig$4 = {
		position: 'bottom',
	
		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',
	
		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',
	
		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,
	
			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',
	
			major: {
				enabled: false
			}
		}
	};
	
	var scale_time = core_scale.extend({
		initialize: function() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},
	
		update: function() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);
	
			// DEPRECATIONS: output a message only one time per update
			deprecated$1('time scale', time.format, 'time.format', 'time.parser');
			deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
			deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
	
			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());
	
			return core_scale.prototype.update.apply(me, arguments);
		},
	
		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},
	
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var options = me.options;
			var unit = options.time.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp, labelsAdded;
			var dataLabels = me._getLabels();
	
			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}
	
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;
	
					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];
	
						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						datasets[i] = labels.slice(0);
						if (!labelsAdded) {
							timestamps = timestamps.concat(labels);
							labelsAdded = true;
						}
					}
				} else {
					datasets[i] = [];
				}
			}
	
			if (labels.length) {
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}
	
			if (timestamps.length) {
				timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}
	
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
	
			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);
	
			// PRIVATE
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},
	
		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var tickOpts = options.ticks;
			var timeOpts = options.time;
			var timestamps = me._timestamps;
			var ticks = [];
			var capacity = me.getLabelCapacity(min);
			var source = tickOpts.source;
			var distribution = options.distribution;
			var i, ilen, timestamp;
	
			if (source === 'data' || (source === 'auto' && distribution === 'series')) {
				timestamps = timestamps.data;
			} else if (source === 'labels') {
				timestamps = timestamps.labels;
			} else {
				timestamps = generate(me, min, max, capacity);
			}
	
			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}
	
			// Enforce limits with user min/max options
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;
	
			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}
	
			me.min = min;
			me.max = max;
	
			// PRIVATE
			// determineUnitForFormatting relies on the number of ticks so we don't use it when
			// autoSkip is enabled because we don't yet know what the final number of ticks will be
			me._unit = timeOpts.unit || (tickOpts.autoSkip
				? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
				: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
			me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
				: determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
			if (tickOpts.reverse) {
				ticks.reverse();
			}
	
			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},
	
		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];
	
			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},
	
		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var tick = ticks[index];
			var tickOpts = options.ticks;
			var major = majorUnit && majorFormat && tick && tick.major;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
			var formatter = resolve$5([
				nestedTickOpts.callback,
				nestedTickOpts.userCallback,
				tickOpts.callback,
				tickOpts.userCallback
			]);
	
			return formatter ? formatter(label, index, ticks) : label;
		},
	
		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;
	
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}
	
			return labels;
		},
	
		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var offsets = me._offsets;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
		},
	
		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;
	
			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}
	
			if (time === null) {
				time = parse(me, value);
			}
	
			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},
	
		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},
	
		getValueForPixel: function(pixel) {
			var me = this;
			var offsets = me._offsets;
			var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');
	
			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},
	
		/**
		 * @private
		 */
		_getLabelSize: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
	
			return {
				w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
				h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
			};
		},
	
		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			return this._getLabelSize(label).w;
		},
	
		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;
			var timeOpts = me.options.time;
			var displayFormats = timeOpts.displayFormats;
	
			// pick the longest format (milliseconds) for guestimation
			var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
			var size = me._getLabelSize(exampleLabel);
			var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
	
			if (me.options.offset) {
				capacity--;
			}
	
			return capacity > 0 ? capacity : 1;
		}
	});
	
	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;
	
	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};
	
	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};
	
	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY
	
		formats: function() {
			return FORMATS;
		},
	
		parse: function(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},
	
		format: function(time, format) {
			return moment(time).format(format);
		},
	
		add: function(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},
	
		diff: function(max, min, unit) {
			return moment(max).diff(moment(min), unit);
		},
	
		startOf: function(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},
	
		endOf: function(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},
	
		// DEPRECATIONS
	
		/**
		 * Provided for backward compatibility with scale.getValueForPixel().
		 * @deprecated since version 2.8.0
		 * @todo remove at version 3
		 * @private
		 */
		_create: function(time) {
			return moment(time);
		},
	} : {});
	
	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;
	
			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},
	
		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;
	
			if (helpers$1.isArray(boundary)) {
				return function(point, i) {
					return boundary[i];
				};
			}
	
			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};
	
	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;
	
		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}
	
		if (fill === false || fill === null) {
			return false;
		}
	
		if (fill === true) {
			return 'origin';
		}
	
		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}
	
			if (target === index || target < 0 || target >= count) {
				return false;
			}
	
			return target;
		}
	
		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}
	
	function computeLinearBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;
	
		if (isFinite(fill)) {
			return null;
		}
	
		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).
	
		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}
	
		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}
	
			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}
	
		return null;
	}
	
	function computeCircularBoundary(source) {
		var scale = source.el._scale;
		var options = scale.options;
		var length = scale.chart.data.labels.length;
		var fill = source.fill;
		var target = [];
		var start, end, center, i, point;
	
		if (!length) {
			return null;
		}
	
		start = options.ticks.reverse ? scale.max : scale.min;
		end = options.ticks.reverse ? scale.min : scale.max;
		center = scale.getPointPositionForValue(0, start);
		for (i = 0; i < length; ++i) {
			point = fill === 'start' || fill === 'end'
				? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
				: scale.getBasePosition(i);
			if (options.gridLines.circular) {
				point.cx = center.x;
				point.cy = center.y;
				point.angle = scale.getIndexAngle(i) - Math.PI / 2;
			}
			target.push(point);
		}
		return target;
	}
	
	function computeBoundary(source) {
		var scale = source.el._scale || {};
	
		if (scale.getPointPositionForValue) {
			return computeCircularBoundary(source);
		}
		return computeLinearBoundary(source);
	}
	
	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;
	
		if (!propagate) {
			return fill;
		}
	
		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}
	
			target = sources[fill];
			if (!target) {
				return false;
			}
	
			if (target.visible) {
				return fill;
			}
	
			visited.push(fill);
			fill = target.fill;
		}
	
		return false;
	}
	
	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';
	
		if (fill === false) {
			return null;
		}
	
		if (!isFinite(fill)) {
			type = 'boundary';
		}
	
		return mappers[type](source);
	}
	
	function isDrawable(point) {
		return point && !point.skip;
	}
	
	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i, cx, cy, r;
	
		if (!len0 || !len1) {
			return;
		}
	
		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}
	
		if (curve1[0].angle !== undefined) {
			cx = curve1[0].cx;
			cy = curve1[0].cy;
			r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
			for (i = len1 - 1; i > 0; --i) {
				ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
			}
			return;
		}
	
		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}
	
	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1, loopOffset;
	
		ctx.beginPath();
	
		for (i = 0, ilen = count; i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);
	
			if (loop && loopOffset === undefined && d0) {
				loopOffset = i + 1;
				ilen = count + loopOffset;
			}
	
			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}
	
		drawArea(ctx, curve0, curve1, len0, len1);
	
		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}
	
	var plugin_filler = {
		id: 'filler',
	
		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;
	
			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;
	
				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}
	
				meta.$filler = source;
				sources.push(source);
			}
	
			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}
	
				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},
	
		beforeDatasetsDraw: function(chart) {
			var metasets = chart._getSortedVisibleDatasetMetas();
			var ctx = chart.ctx;
			var meta, i, el, view, points, mapper, color;
	
			for (i = metasets.length - 1; i >= 0; --i) {
				meta = metasets[i].$filler;
	
				if (!meta || !meta.visible) {
					continue;
				}
	
				el = meta.el;
				view = el._view;
				points = el._children || [];
				mapper = meta.mapper;
				color = view.backgroundColor || core_defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers$1.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers$1.canvas.unclipArea(ctx);
				}
			}
		}
	};
	
	var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
	var noop$1 = helpers$1.noop;
	var valueOrDefault$e = helpers$1.valueOrDefault;
	
	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			align: 'center',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
			onLeave: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var datasets = chart.data.datasets;
					var options = chart.options.legend || {};
					var usePointStyle = options.labels && options.labels.usePointStyle;
	
					return chart._getSortedDatasetMetas().map(function(meta) {
						var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
	
						return {
							text: datasets[meta.index].label,
							fillStyle: style.backgroundColor,
							hidden: !chart.isDatasetVisible(meta.index),
							lineCap: style.borderCapStyle,
							lineDash: style.borderDash,
							lineDashOffset: style.borderDashOffset,
							lineJoin: style.borderJoinStyle,
							lineWidth: style.borderWidth,
							strokeStyle: style.borderColor,
							pointStyle: style.pointStyle,
							rotation: style.rotation,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: meta.index
						};
					}, this);
				}
			}
		},
	
		legendCallback: function(chart) {
			var list = document.createElement('ul');
			var datasets = chart.data.datasets;
			var i, ilen, listItem, listItemSpan;
	
			list.setAttribute('class', chart.id + '-legend');
	
			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
				if (datasets[i].label) {
					listItem.appendChild(document.createTextNode(datasets[i].label));
				}
			}
	
			return list.outerHTML;
		}
	});
	
	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param {object} labelopts - the label options on the legend
	 * @param {number} fontSize - the label font size
	 * @return {number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
			fontSize :
			labelOpts.boxWidth;
	}
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Legend = core_element.extend({
	
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
	
			/**
	 		 * @private
	 		 */
			me._hoveredItem = null;
	
			// Are we in doughnut mode which has a different data type
			me.doughnutMode = false;
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type
	
		beforeUpdate: noop$1,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
		},
		afterUpdate: noop$1,
	
		//
	
		beforeSetDimensions: noop$1,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,
	
		//
	
		beforeBuildLabels: noop$1,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}
	
			if (me.options.reverse) {
				legendItems.reverse();
			}
	
			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,
	
		//
	
		beforeFit: noop$1,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;
	
			var ctx = me.ctx;
	
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
	
			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];
	
			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();
	
			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}
	
			// Increase sizes here
			if (!display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
			ctx.font = labelFont.string;
	
			if (isHorizontal) {
				// Labels
	
				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;
	
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
					}
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};
	
					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});
	
				minSize.height += totalHeight;
	
			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var columnHeights = me.columnHeights = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;
	
				helpers$1.each(me.legendItems, function(legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
					// If too tall, go to new column
					if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width
						columnHeights.push(currentColHeight);
						currentColWidth = 0;
						currentColHeight = 0;
					}
	
					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += fontSize + vPadding;
	
					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});
	
				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				columnHeights.push(currentColHeight);
				minSize.width += totalWidth;
			}
	
			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,
	
		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
	
		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendHeight = me.height;
			var columnHeights = me.columnHeights;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;
	
			if (!opts.display) {
				return;
			}
	
			var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
			var ctx = me.ctx;
			var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;
	
			// Canvas setup
			ctx.textAlign = rtlHelper.textAlign('left');
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;
	
			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;
	
			// current position
			var drawLegendBox = function(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}
	
				// Set the ctx for the box
				ctx.save();
	
				var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
	
				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
				}
	
				if (labelOpts && labelOpts.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = rtlHelper.xPlus(x, boxWidth / 2);
					var centerY = y + fontSize / 2;
	
					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
				} else {
					// Draw box as legend symbol
					ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					if (lineWidth !== 0) {
						ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					}
				}
	
				ctx.restore();
			};
	
			var fillText = function(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
				var yMiddle = y + halfFontSize;
	
				ctx.fillText(legendItem.text, xLeft, yMiddle);
	
				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
					ctx.stroke();
				}
			};
	
			var alignmentOffset = function(dimension, blockSize) {
				switch (opts.align) {
				case 'start':
					return labelOpts.padding;
				case 'end':
					return dimension - blockSize;
				default: // center
					return (dimension - blockSize + labelOpts.padding) / 2;
				}
			};
	
			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
					line: 0
				};
			}
	
			helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
	
			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function(legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + (fontSize / 2) + textWidth;
				var x = cursor.x;
				var y = cursor.y;
	
				rtlHelper.setWidth(me.minSize.width);
	
				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					cursor.line++;
					y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
				}
	
				var realX = rtlHelper.x(x);
	
				drawLegendBox(realX, y, legendItem);
	
				hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
				hitboxes[i].top = y;
	
				// Fill the actual label
				fillText(realX, y, legendItem, textWidth);
	
				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}
			});
	
			helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
		},
	
		/**
		 * @private
		 */
		_getLegendItemAt: function(x, y) {
			var me = this;
			var i, hitBox, lh;
	
			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];
	
					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}
	
			return null;
		},
	
		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;
	
			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}
	
			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);
	
			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}
	
				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});
	
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	var plugin_legend = {
		id: 'legend',
	
		/**
		 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
		 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Legend,
	
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
	
				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	
	var noop$2 = helpers$1.noop;
	
	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	/**
	 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
	 */
	var Title = core_element.extend({
		initialize: function(config) {
			var me = this;
			helpers$1.extend(me, config);
	
			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},
	
		// These methods are ordered by lifecycle. Utilities then follow.
	
		beforeUpdate: noop$2,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
	
			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();
	
			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;
	
			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();
	
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();
	
			return me.minSize;
	
		},
		afterUpdate: noop$2,
	
		//
	
		beforeSetDimensions: noop$2,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;
	
				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}
	
			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
	
			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,
	
		//
	
		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,
	
		//
	
		beforeFit: noop$2,
		fit: function() {
			var me = this;
			var opts = me.options;
			var minSize = me.minSize = {};
			var isHorizontal = me.isHorizontal();
			var lineCount, textSize;
	
			if (!opts.display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
	
			lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
	
			me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
			me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
		},
		afterFit: noop$2,
	
		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
	
		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
	
			if (!opts.display) {
				return;
			}
	
			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;
	
			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;
	
			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + ((right - left) / 2); // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + ((bottom - top) / 2);
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}
	
			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
	
			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}
	
			ctx.restore();
		}
	});
	
	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});
	
		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}
	
	var plugin_title = {
		id: 'title',
	
		/**
		 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
		 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
		 * the plugin, which one will be re-exposed in the chart.js file.
		 * https://github.com/chartjs/Chart.js/pull/2640
		 * @private
		 */
		_element: Title,
	
		beforeInit: function(chart) {
			var titleOpts = chart.options.title;
	
			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},
	
		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;
	
			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);
	
				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
	
	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;
	
	/**
	 * @namespace Chart
	 */
	
	
	core_controller.helpers = helpers$1;
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers();
	
	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;
	
	// Register built-in scales
	
	core_controller.helpers.each(scales, function(scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});
	
	// Load to register built-in adapters (as side effects)
	
	
	// Loading built-in plugins
	
	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}
	
	core_controller.platform.initialize();
	
	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Chart
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Chart = core_controller;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Legend
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Legend = plugins.legend._element;
	
	/**
	 * Provided for backward compatibility, not available anymore
	 * @namespace Chart.Title
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.Title = plugins.title._element;
	
	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.pluginService = core_controller.plugins;
	
	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.PluginBase = core_controller.Element.extend({});
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.canvasHelpers = core_controller.helpers.canvas;
	
	/**
	 * Provided for backward compatibility, use Chart.layouts instead.
	 * @namespace Chart.layoutService
	 * @deprecated since version 2.7.3
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.layoutService = core_controller.layouts;
	
	/**
	 * Provided for backward compatibility, not available anymore.
	 * @namespace Chart.LinearScaleBase
	 * @deprecated since version 2.8
	 * @todo remove at version 3
	 * @private
	 */
	core_controller.LinearScaleBase = scale_linearbase;
	
	/**
	 * Provided for backward compatibility, instead we should create a new Chart
	 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	core_controller.helpers.each(
		[
			'Bar',
			'Bubble',
			'Doughnut',
			'Line',
			'PolarArea',
			'Radar',
			'Scatter'
		],
		function(klass) {
			core_controller[klass] = function(ctx, cfg) {
				return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
					type: klass.charAt(0).toLowerCase() + klass.slice(1)
				}));
			};
		}
	);
	
	return src;
	
	})));


/***/ }),
/* 703 */
171,
/* 704 */
242,
/* 705 */
[6554, 315, 2122, 2120, 267, 919, 1418],
/* 706 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 707 */
447,
/* 708 */
[6585, 241, 439, 170],
/* 709 */
[6546, 242, 106],
/* 710 */
[6558, 242],
/* 711 */
706,
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * var result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	
	  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 1, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 714 */
[6668, 945, 20],
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	
	var _index = _interopRequireDefault(__webpack_require__(454));
	
	var _index2 = _interopRequireDefault(__webpack_require__(717));
	
	var _index3 = _interopRequireDefault(__webpack_require__(31));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2179));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2182));
	
	var _index6 = _interopRequireDefault(__webpack_require__(320));
	
	var _index7 = __webpack_require__(2186);
	
	var _index8 = _interopRequireDefault(__webpack_require__(53));
	
	var _index9 = _interopRequireDefault(__webpack_require__(4822));
	
	var _index10 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Old `parse` was renamed to `toDate`.
	 *   Now `parse` is a new function which parses a string using a provided format.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   toDate('2016-01-01')
	 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
	 *   ```
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
	  (0, _index10.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index.default;
	
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index8.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index8.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index8.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index8.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale // If timezone isn't specified, it will be set to the system timezone
	
	  };
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    subPriority: -1,
	    set: dateToSystemTimezone,
	    index: 0
	  }];
	  var i;
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, subFnOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	
	  for (i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (!options.useAdditionalWeekYearTokens && (0, _index7.isProtectedWeekYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	    }
	
	    if (!options.useAdditionalDayOfYearTokens && (0, _index7.isProtectedDayOfYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	    }
	
	    var firstCharacter = token[0];
	    var parser = _index9.default[firstCharacter];
	
	    if (parser) {
	      var incompatibleTokens = parser.incompatibleTokens;
	
	      if (Array.isArray(incompatibleTokens)) {
	        var incompatibleToken = void 0;
	
	        for (var _i = 0; _i < usedTokens.length; _i++) {
	          var usedToken = usedTokens[_i].token;
	
	          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
	            incompatibleToken = usedTokens[_i];
	            break;
	          }
	        }
	
	        if (incompatibleToken) {
	          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	        }
	      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
	        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	      }
	
	      usedTokens.push({
	        token: firstCharacter,
	        fullToken: token
	      });
	      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
	
	      if (!parseResult) {
	        return new Date(NaN);
	      }
	
	      setters.push({
	        priority: parser.priority,
	        subPriority: parser.subPriority || 0,
	        set: parser.set,
	        validate: parser.validate,
	        value: parseResult.value,
	        index: setters.length
	      });
	      dateString = parseResult.rest;
	    } else {
	      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	      } // Replace two single quote characters with one single quote character
	
	
	      if (token === "''") {
	        token = "'";
	      } else if (firstCharacter === "'") {
	        token = cleanEscapedString(token);
	      } // Cut token from string, or, if string doesn't match the token, return Invalid Date
	
	
	      if (dateString.indexOf(token) === 0) {
	        dateString = dateString.slice(token.length);
	      } else {
	        return new Date(NaN);
	      }
	    }
	  } // Check if the remaining input contains something other than whitespace
	
	
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).sort(function (a, b) {
	      return b.subPriority - a.subPriority;
	    });
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	
	
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	
	  for (i = 0; i < uniquePrioritySetters.length; i++) {
	    var setter = uniquePrioritySetters[i];
	
	    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
	      return new Date(NaN);
	    }
	
	    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
	
	    if (result[0]) {
	      utcDate = result[0];
	      (0, _index4.default)(flags, result[1]); // Result is date
	    } else {
	      utcDate = result;
	    }
	  }
	
	  return utcDate;
	}
	
	function dateToSystemTimezone(date, flags) {
	  if (flags.timestampIsSet) {
	    return date;
	  }
	
	  var convertedDate = new Date(0);
	  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	  return convertedDate;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(561));
	
	var _index2 = _interopRequireDefault(__webpack_require__(455));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * var result = startOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(712));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"af180bb6","outerContainer":"e5160196","secondaryToolbar":"_1084abbc","doorHangerRight":"f68ec5bc","toolbarContainer":"_751c86cf","toolbarViewerMiddle":"ba80f0a1","progressBar":"a72ab1c6","back-to-application":"_2ea1af4c","about":"_47aefc4e","about__moderators":"_4e2163cf","description":"_4464a12d","description__text":"_97e47c1b","description__button":"cf306b7d","list":"_6b0a08b8","list-item":"cd076332","list__header":"cf3569fc","list-item__icon":"d5116caf","full-list":"_3606b45b","full-list__item":"b573527f","full-list__item-mobile":"_54b71a46","full-list-mobile":"_500c290f"};

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"post-form":"f675e203","fieldName":"d9c0f502","input-wrapper":"_7ff0f657","post-input":"_04eea4e5","post-attachments":"ee5043a4","attach-item":"e6516cab","info":"_0c797654","info--disabled":"_396d2cba","info--errored":"_44df0d12","url-input":"fdad3dee","input":"_7274ae92","icon-close":"_212e4f2a","url-preview":"abc64163","disabled":"d79edbd8","videoPlayer":"eaae5c8d","actionButtonWrapper":"_83e6208c","preview-image":"eb881d77","no-preview":"ef5f1398","description-pane":"_45408ae6","link":"eb8a52f5","attach-image":"_1376cb31","approvalText":"adb4860a","notification":"_1a28993c","wrapper__action":"e59644c0","full-width":"_9eb266b5"};

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_77002999","outerContainer":"_910a611c","secondaryToolbar":"c49cbddd","doorHangerRight":"_36a674b7","toolbarContainer":"_781e05ba","toolbarViewerMiddle":"f864adc7","progressBar":"a8a25011","back-to-application":"b8b2062b","root":"_91d167a0","row":"_410604f4","column":"_86f1b052","columnWrapper":"_9d84f52c","right":"df9ec192","separator":"adad6584","name":"_96c00a75","disabled":"fdaeb5ac","strong":"_3835b034","meta":"_345b5ec3","content":"_9c0bdd19","status":"fcbdf284","pendingStatus":"d7549ed2","notManagable":"_44b4236d","videoVisitAW":"_511e9b8e","provider":"_673b4cf8","paymentInfo":"_6aa92c24","video-btn":"bf31b4de","paymentInfo--offset":"_4f19b343"};

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"af735bff","outerContainer":"cf8d3933","secondaryToolbar":"_8c36a91c","doorHangerRight":"ff2a081d","toolbarContainer":"_794f2c6d","toolbarViewerMiddle":"cf879066","progressBar":"_5489e2ea","back-to-application":"_12dd0388","root":"_662fab6a","header":"f900c740","headerLeftSide":"_8ae9a609","dateConsent":"_792b37a0","content":"bf807e66","contentHeader":"_64589c09","mainTitle":"_1503bfbc","consentTitle":"f993b27b","consentMainTitle":"_987108d9","consentSubTitle":"_9eecf2e0","counter":"_2e96cdab","currentIndex":"_3b0ad577","text":"f6593e34","consentDetails":"_689d694d","icon":"_6ae60484","consentType":"f2aeee94","consentService":"_0aa5e791","mainConsentBtnWrapper":"_46c935af","declineButton":"aa90f128","mainConsentContent":"_1a8fcf92"};

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_48fb9921","outerContainer":"_9c455241","secondaryToolbar":"_9e8f8e87","doorHangerRight":"_4c475402","toolbarContainer":"_6a5f6638","toolbarViewerMiddle":"_0b86597e","progressBar":"a3267f11","back-to-application":"_4bf114e7","modal":"fb327cdd","popup":"_71bff2b7","row":"f266985a","rowMb":"a37aeb3d","applyBtn":"_5160feaf","select":"_6082c22e","title":"_1281eea9","titleDanger":"_82c5c77b","text":"_14276e5b","btns":"_5eedd7f2","video":"e3c99598"};

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	// get successful control from form and assemble into object
	// http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2
	
	// types which indicate a submit action and are not successful controls
	// these will be ignored
	var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;
	
	// node names which could be successful controls
	var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;
	
	// Matches bracket notation.
	var brackets = /(\[[^\[\]]*\])/g;
	
	// serializes form fields
	// @param form MUST be an HTMLForm element
	// @param options is an optional argument to configure the serialization. Default output
	// with no options specified is a url encoded string
	//    - hash: [true | false] Configure the output type. If true, the output will
	//    be a js object.
	//    - serializer: [function] Optional serializer function to override the default one.
	//    The function takes 3 arguments (result, key, value) and should return new result
	//    hash and url encoded str serializers are provided with this module
	//    - disabled: [true | false]. If true serialize disabled fields.
	//    - empty: [true | false]. If true serialize empty fields
	function serialize(form, options) {
	    if (typeof options != 'object') {
	        options = { hash: !!options };
	    }
	    else if (options.hash === undefined) {
	        options.hash = true;
	    }
	
	    var result = (options.hash) ? {} : '';
	    var serializer = options.serializer || ((options.hash) ? hash_serializer : str_serialize);
	
	    var elements = form && form.elements ? form.elements : [];
	
	    //Object store each radio and set if it's empty or not
	    var radio_store = Object.create(null);
	
	    for (var i=0 ; i<elements.length ; ++i) {
	        var element = elements[i];
	
	        // ingore disabled fields
	        if ((!options.disabled && element.disabled) || !element.name) {
	            continue;
	        }
	        // ignore anyhting that is not considered a success field
	        if (!k_r_success_contrls.test(element.nodeName) ||
	            k_r_submitter.test(element.type)) {
	            continue;
	        }
	
	        var key = element.name;
	        var val = element.value;
	
	        // we can't just use element.value for checkboxes cause some browsers lie to us
	        // they say "on" for value when the box isn't checked
	        if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
	            val = undefined;
	        }
	
	        // If we want empty elements
	        if (options.empty) {
	            // for checkbox
	            if (element.type === 'checkbox' && !element.checked) {
	                val = '';
	            }
	
	            // for radio
	            if (element.type === 'radio') {
	                if (!radio_store[element.name] && !element.checked) {
	                    radio_store[element.name] = false;
	                }
	                else if (element.checked) {
	                    radio_store[element.name] = true;
	                }
	            }
	
	            // if options empty is true, continue only if its radio
	            if (val == undefined && element.type == 'radio') {
	                continue;
	            }
	        }
	        else {
	            // value-less fields are ignored unless options.empty is true
	            if (!val) {
	                continue;
	            }
	        }
	
	        // multi select boxes
	        if (element.type === 'select-multiple') {
	            val = [];
	
	            var selectOptions = element.options;
	            var isSelectedOptions = false;
	            for (var j=0 ; j<selectOptions.length ; ++j) {
	                var option = selectOptions[j];
	                var allowedEmpty = options.empty && !option.value;
	                var hasValue = (option.value || allowedEmpty);
	                if (option.selected && hasValue) {
	                    isSelectedOptions = true;
	
	                    // If using a hash serializer be sure to add the
	                    // correct notation for an array in the multi-select
	                    // context. Here the name attribute on the select element
	                    // might be missing the trailing bracket pair. Both names
	                    // "foo" and "foo[]" should be arrays.
	                    if (options.hash && key.slice(key.length - 2) !== '[]') {
	                        result = serializer(result, key + '[]', option.value);
	                    }
	                    else {
	                        result = serializer(result, key, option.value);
	                    }
	                }
	            }
	
	            // Serialize if no selected options and options.empty is true
	            if (!isSelectedOptions && options.empty) {
	                result = serializer(result, key, '');
	            }
	
	            continue;
	        }
	
	        result = serializer(result, key, val);
	    }
	
	    // Check for all empty radio buttons and serialize them with key=""
	    if (options.empty) {
	        for (var key in radio_store) {
	            if (!radio_store[key]) {
	                result = serializer(result, key, '');
	            }
	        }
	    }
	
	    return result;
	}
	
	function parse_keys(string) {
	    var keys = [];
	    var prefix = /^([^\[\]]*)/;
	    var children = new RegExp(brackets);
	    var match = prefix.exec(string);
	
	    if (match[1]) {
	        keys.push(match[1]);
	    }
	
	    while ((match = children.exec(string)) !== null) {
	        keys.push(match[1]);
	    }
	
	    return keys;
	}
	
	function hash_assign(result, keys, value) {
	    if (keys.length === 0) {
	        result = value;
	        return result;
	    }
	
	    var key = keys.shift();
	    var between = key.match(/^\[(.+?)\]$/);
	
	    if (key === '[]') {
	        result = result || [];
	
	        if (Array.isArray(result)) {
	            result.push(hash_assign(null, keys, value));
	        }
	        else {
	            // This might be the result of bad name attributes like "[][foo]",
	            // in this case the original `result` object will already be
	            // assigned to an object literal. Rather than coerce the object to
	            // an array, or cause an exception the attribute "_values" is
	            // assigned as an array.
	            result._values = result._values || [];
	            result._values.push(hash_assign(null, keys, value));
	        }
	
	        return result;
	    }
	
	    // Key is an attribute name and can be assigned directly.
	    if (!between) {
	        result[key] = hash_assign(result[key], keys, value);
	    }
	    else {
	        var string = between[1];
	        // +var converts the variable into a number
	        // better than parseInt because it doesn't truncate away trailing
	        // letters and actually fails if whole thing is not a number
	        var index = +string;
	
	        // If the characters between the brackets is not a number it is an
	        // attribute name and can be assigned directly.
	        if (isNaN(index)) {
	            result = result || {};
	            result[string] = hash_assign(result[string], keys, value);
	        }
	        else {
	            result = result || [];
	            result[index] = hash_assign(result[index], keys, value);
	        }
	    }
	
	    return result;
	}
	
	// Object/hash encoding serializer.
	function hash_serializer(result, key, value) {
	    var matches = key.match(brackets);
	
	    // Has brackets? Use the recursive assignment function to walk the keys,
	    // construct any missing objects in the result tree and make the assignment
	    // at the end of the chain.
	    if (matches) {
	        var keys = parse_keys(key);
	        hash_assign(result, keys, value);
	    }
	    else {
	        // Non bracket notation can make assignments directly.
	        var existing = result[key];
	
	        // If the value has been assigned already (for instance when a radio and
	        // a checkbox have the same name attribute) convert the previous value
	        // into an array before pushing into it.
	        //
	        // NOTE: If this requirement were removed all hash creation and
	        // assignment could go through `hash_assign`.
	        if (existing) {
	            if (!Array.isArray(existing)) {
	                result[key] = [ existing ];
	            }
	
	            result[key].push(value);
	        }
	        else {
	            result[key] = value;
	        }
	    }
	
	    return result;
	}
	
	// urlform encoding serializer
	function str_serialize(result, key, value) {
	    // encode newlines as \r\n cause the html spec says so
	    value = value.replace(/(\r)?\n/g, '\r\n');
	    value = encodeURIComponent(value);
	
	    // spaces should be '+' rather than '%20'.
	    value = value.replace(/%20/g, '+');
	    return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
	}
	
	module.exports = serialize;


/***/ }),
/* 724 */,
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createRule = __webpack_require__(966);
	
	var _createRule2 = _interopRequireDefault(_createRule);
	
	var _linkRule = __webpack_require__(2303);
	
	var _linkRule2 = _interopRequireDefault(_linkRule);
	
	var _StyleRule = __webpack_require__(567);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _escape = __webpack_require__(5381);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Contains rules objects and allows adding/removing etc.
	 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	 */
	var RuleList = function () {
	
	  // Original styles object.
	  function RuleList(options) {
	    _classCallCheck(this, RuleList);
	
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	
	    this.options = options;
	    this.classes = options.classes;
	  }
	
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  // Used to ensure correct rules order.
	
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	
	
	  _createClass(RuleList, [{
	    key: 'add',
	    value: function add(name, decl, options) {
	      var _options = this.options,
	          parent = _options.parent,
	          sheet = _options.sheet,
	          jss = _options.jss,
	          Renderer = _options.Renderer,
	          generateClassName = _options.generateClassName;
	
	
	      options = _extends({
	        classes: this.classes,
	        parent: parent,
	        sheet: sheet,
	        jss: jss,
	        Renderer: Renderer,
	        generateClassName: generateClassName
	      }, options);
	
	      if (!options.selector && this.classes[name]) {
	        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
	      }
	
	      this.raw[name] = decl;
	
	      var rule = (0, _createRule2['default'])(name, decl, options);
	
	      var className = void 0;
	
	      if (!options.selector && rule instanceof _StyleRule2['default']) {
	        className = generateClassName(rule, sheet);
	        rule.selector = '.' + (0, _escape2['default'])(className);
	      }
	
	      this.register(rule, className);
	
	      var index = options.index === undefined ? this.index.length : options.index;
	      this.index.splice(index, 0, rule);
	
	      return rule;
	    }
	
	    /**
	     * Get a rule.
	     */
	
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return this.map[name];
	    }
	
	    /**
	     * Delete a rule.
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(rule) {
	      this.unregister(rule);
	      this.index.splice(this.indexOf(rule), 1);
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.index.indexOf(rule);
	    }
	
	    /**
	     * Run `onProcessRule()` plugins on every rule.
	     */
	
	  }, {
	    key: 'process',
	    value: function process() {
	      var plugins = this.options.jss.plugins;
	      // We need to clone array because if we modify the index somewhere else during a loop
	      // we end up with very hard-to-track-down side effects.
	
	      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
	    }
	
	    /**
	     * Register a rule in `.map` and `.classes` maps.
	     */
	
	  }, {
	    key: 'register',
	    value: function register(rule, className) {
	      this.map[rule.key] = rule;
	      if (rule instanceof _StyleRule2['default']) {
	        this.map[rule.selector] = rule;
	        if (className) this.classes[rule.key] = className;
	      }
	    }
	
	    /**
	     * Unregister a rule.
	     */
	
	  }, {
	    key: 'unregister',
	    value: function unregister(rule) {
	      delete this.map[rule.key];
	      if (rule instanceof _StyleRule2['default']) {
	        delete this.map[rule.selector];
	        delete this.classes[rule.key];
	      }
	    }
	
	    /**
	     * Update the function values with a new data.
	     */
	
	  }, {
	    key: 'update',
	    value: function update(name, data) {
	      var _options2 = this.options,
	          plugins = _options2.jss.plugins,
	          sheet = _options2.sheet;
	
	      if (typeof name === 'string') {
	        plugins.onUpdate(data, this.get(name), sheet);
	        return;
	      }
	
	      for (var index = 0; index < this.index.length; index++) {
	        plugins.onUpdate(name, this.index[index], sheet);
	      }
	    }
	
	    /**
	     * Link renderable rules with CSSRuleList.
	     */
	
	  }, {
	    key: 'link',
	    value: function link(cssRules) {
	      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);
	
	      for (var i = 0; i < cssRules.length; i++) {
	        var cssRule = cssRules[i];
	        var _key = this.options.sheet.renderer.getKey(cssRule);
	        if (map[_key]) _key = map[_key];
	        var rule = this.map[_key];
	        if (rule) (0, _linkRule2['default'])(rule, cssRule);
	      }
	    }
	
	    /**
	     * Convert rules to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      var str = '';
	      var sheet = this.options.sheet;
	
	      var link = sheet ? sheet.options.link : false;
	
	      for (var index = 0; index < this.index.length; index++) {
	        var rule = this.index[index];
	        var css = rule.toString(options);
	
	        // No need to render an empty rule.
	        if (!css && !link) continue;
	
	        if (str) str += '\n';
	        str += css;
	      }
	
	      return str;
	    }
	  }]);
	
	  return RuleList;
	}();
	
	exports['default'] = RuleList;

/***/ }),
/* 726 */
[6737, 2330],
/* 727 */
5846,
/* 728 */
1008,
/* 729 */
[6816, 5407, 227],
/* 730 */
[6819, 246, 5519],
/* 731 */
[6820, 321, 139],
/* 732 */
6457,
/* 733 */
2880,
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(2309),
	    baseKeysIn = __webpack_require__(5415),
	    isArrayLike = __webpack_require__(247);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(2395);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.keys = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = createBreakpoints;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Sorted ASC by size. That's important.
	// It can't be configured as it's used statically for propTypes.
	var keys = exports.keys = ['xs', 'sm', 'md', 'lg', 'xl'];
	
	// Keep in mind that @media is inclusive by the CSS specification.
	function createBreakpoints(breakpoints) {
	  var _breakpoints$values = breakpoints.values,
	      values = _breakpoints$values === undefined ? {
	    xs: 0,
	    sm: 600,
	    md: 960,
	    lg: 1280,
	    xl: 1920
	  } : _breakpoints$values,
	      _breakpoints$unit = breakpoints.unit,
	      unit = _breakpoints$unit === undefined ? 'px' : _breakpoints$unit,
	      _breakpoints$step = breakpoints.step,
	      step = _breakpoints$step === undefined ? 5 : _breakpoints$step,
	      other = (0, _objectWithoutProperties3.default)(breakpoints, ['values', 'unit', 'step']);
	
	
	  function up(key) {
	    var value = typeof values[key] === 'number' ? values[key] : key;
	    return '@media (min-width:' + value + unit + ')';
	  }
	
	  function down(key) {
	    var endIndex = keys.indexOf(key) + 1;
	    var upperbound = values[keys[endIndex]];
	
	    if (endIndex === keys.length) {
	      // xl down applies to all sizes
	      return up('xs');
	    }
	
	    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
	    return '@media (max-width:' + (value - step / 100) + unit + ')';
	  }
	
	  function between(start, end) {
	    var endIndex = keys.indexOf(end) + 1;
	
	    if (endIndex === keys.length) {
	      return up(start);
	    }
	
	    return '@media (min-width:' + values[start] + unit + ') and ' + ('(max-width:' + (values[keys[endIndex]] - step / 100) + unit + ')');
	  }
	
	  function only(key) {
	    return between(key, key);
	  }
	
	  function width(key) {
	    return values[key];
	  }
	
	  return (0, _extends3.default)({
	    keys: keys,
	    values: values,
	    up: up,
	    down: down,
	    between: between,
	    only: only,
	    width: width
	  }, other);
	}

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	var reflow = exports.reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === undefined ? {} : _props$style;
	
	
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
	    delay: style.transitionDelay
	  };
	}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.specialProperty = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	exports.default = exactProp;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	
	var specialProperty = exports.specialProperty = 'exact-prop: \u200B';
	
	function exactProp(propTypes, componentNameInError) {
	  return (0, _extends4.default)({}, propTypes, (0, _defineProperty3.default)({}, specialProperty, function (props) {
	    var unknownProps = (0, _keys2.default)(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	    if (unknownProps.length > 0) {
	      return new TypeError(componentNameInError + ': unknown props found: ' + unknownProps.join(', ') + '. Please remove the unknown properties.');
	    }
	    return null;
	  }));
	}

/***/ }),
/* 739 */
[6744, 996, 5750, 5777],
/* 740 */
474,
/* 741 */,
/* 742 */,
/* 743 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	
	function getTimezoneOffsetInMilliseconds(dirtyDate) {
	  var date = new Date(dirtyDate.getTime());
	  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
	  date.setSeconds(0, 0);
	  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;
	  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
	}
	
	module.exports = exports.default;

/***/ }),
/* 744 */
[6744, 1022, 6121, 6151],
/* 745 */
1009,
/* 746 */
[6836, 6209],
/* 747 */,
/* 748 */,
/* 749 */
/***/ (function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasOwnProperty = __webpack_require__(6343);
	
	var _hasOwnProperty2 = _interopRequireDefault(_hasOwnProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateLocales = {
	  de: {
	    months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sept_Okt_Nov_Dez'.split('_'),
	    weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysLetter: 'S_M_D_M_D_F_S'.split('_')
	  },
	  no: {
	    months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort: 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysLetter: []
	  },
	  en: {
	    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysLetter: []
	  },
	  es: {
	    months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort: 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysLetter: 'D_L_M_X_J_V_S'.split('_')
	  },
	  af: {
	    months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysLetter: []
	  },
	  ar: {
	    months: ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'],
	    monthsShort: ['كانون الثاني يناير', 'شباط فبراير', 'آذار مارس', 'نيسان أبريل', 'أيار مايو', 'حزيران يونيو', 'تموز يوليو', 'آب أغسطس', 'أيلول سبتمبر', 'تشرين الأول أكتوبر', 'تشرين الثاني نوفمبر', 'كانون الأول ديسمبر'],
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysLetter: []
	  },
	  be: {
	    months: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_'),
	    monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	    weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysLetter: []
	  },
	  bg: {
	    months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort: 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysLetter: []
	  },
	  bn: {
	    months: 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort: 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	    weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
	    weekdaysLetter: []
	  },
	  bo: {
	    months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysLetter: []
	  },
	  br: {
	    months: 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort: 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays: 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysLetter: []
	  },
	  bs: {
	    months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysLetter: []
	  },
	  ca: {
	    months: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort: 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysLetter: 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_')
	  },
	  gl: {
	    months: 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	    monthsShort: 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	    weekdays: 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	    weekdaysShort: 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	    weekdaysLetter: 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_')
	  },
	  eu: {
	    months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysLetter: 'ig_al_ar_az_og_ol_lr'.split('_')
	  },
	  pt: {
	    months: 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays: 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysLetter: []
	  },
	  it: {
	    months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays: 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort: 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysLetter: []
	  },
	  fr: {
	    months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysLetter: []
	  },
	  ru: {
	    months: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
	    monthsShort: 'Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек'.split('_'),
	    weekdays: 'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
	    weekdaysShort: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
	    weekdaysLetter: []
	  },
	  ua: {
	    months: 'Січень_Лютий_Березень_Квітень_Травень_Червень_Липень_Серпень_Вересень_Жовтень_Листопад_Грудень'.split('_'),
	    monthsShort: 'Січ_Лют_Берез_Квіт_Трав_Черв_Лип_Серп_Верес_Жовт_Листоп_Груд'.split('_'),
	    weekdays: 'Неділя_Понеділок_Вівторок_Середа_Четвер_П’ятниця_Субота'.split('_'),
	    weekdaysShort: 'Нд_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
	    weekdaysLetter: []
	  },
	  'zh-cn': {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
	  },
	  'zh-hk': {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
	  },
	  'zh-tw': {
	    months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysLetter: '日_一_二_三_四_五_六'.split('_')
	  }
	};
	
	var time = {
	  getDaysInMonth: function getDaysInMonth(d) {
	    var resultDate = this.getFirstDayOfMonth(d);
	    resultDate.setMonth(resultDate.getMonth() + 1);
	    resultDate.setDate(resultDate.getDate() - 1);
	    return resultDate.getDate();
	  },
	  getFirstDayOfMonth: function getFirstDayOfMonth(d) {
	    return new Date(d.getFullYear(), d.getMonth(), 1);
	  },
	  getFirstWeekDay: function getFirstWeekDay(d) {
	    return this.getFirstDayOfMonth(d).getDay();
	  },
	  getTimeMode: function getTimeMode(d) {
	    return d.getHours() >= 12 ? 'pm' : 'am';
	  },
	  getFullMonth: function getFullMonth(d) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var month = d.getMonth();
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'months') ? l.months[month] || 'Unknown' : 'Unknown';
	  },
	  getShortMonth: function getShortMonth(d) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var month = d.getMonth();
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'monthsShort') ? l.monthsShort[month] || 'Unknown' : 'Unknown';
	  },
	  getFullDayOfWeek: function getFullDayOfWeek(day) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'weekdays') ? l.weekdays[day] || 'Unknown' : 'Unknown';
	  },
	  getShortDayOfWeek: function getShortDayOfWeek(day) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'weekdaysShort') ? l.weekdaysShort[day] || 'Unknown' : 'Unknown';
	  },
	  getDayOfWeekLetter: function getDayOfWeekLetter(day) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    var l = (typeof locale === 'string' ? dateLocales[locale] : locale) || dateLocales.en;
	    return (0, _hasOwnProperty2.default)(l, 'weekdaysLetter') ? l.weekdaysLetter[day] || this.getFullDayOfWeek(day, locale).charAt(0) : 'Unknown';
	  },
	  clone: function clone(d) {
	    return new Date(d.getTime());
	  },
	  cloneAsDate: function cloneAsDate(d) {
	    var clonedDate = this.clone(d);
	    clonedDate.setHours(0, 0, 0, 0);
	    return clonedDate;
	  },
	  isDateObject: function isDateObject(d) {
	    return d instanceof Date;
	  },
	  addDays: function addDays(d, days) {
	    var newDate = this.clone(d);
	    newDate.setDate(d.getDate() + days);
	    return newDate;
	  },
	  addMonths: function addMonths(d, months) {
	    var newDate = this.clone(d);
	    newDate.setMonth(d.getMonth() + months, 1);
	    return newDate;
	  },
	  addYears: function addYears(d, years) {
	    var newDate = this.clone(d);
	    newDate.setFullYear(d.getFullYear() + years);
	    return newDate;
	  },
	  setDay: function setDay(d, day) {
	    var newDate = this.clone(d);
	    newDate.setDate(day);
	    return newDate;
	  },
	  setMonth: function setMonth(d, month) {
	    var newDate = this.clone(d);
	    newDate.setMonth(month);
	    return newDate;
	  },
	  setYear: function setYear(d, year) {
	    var newDate = this.clone(d);
	    newDate.setFullYear(year);
	    return newDate;
	  },
	  setHours: function setHours(d, hours) {
	    var newDate = this.clone(d);
	    newDate.setHours(hours);
	    return newDate;
	  },
	  setMinutes: function setMinutes(d, minutes) {
	    var newDate = this.clone(d);
	    newDate.setMinutes(minutes);
	    return newDate;
	  },
	  toggleTimeMode: function toggleTimeMode(d) {
	    var newDate = this.clone(d);
	    var hours = newDate.getHours();
	
	    newDate.setHours(hours - (hours > 12 ? -12 : 12));
	    return newDate;
	  },
	  formatTime: function formatTime(date, format) {
	    var hours = date.getHours();
	    var mins = date.getMinutes().toString();
	
	    if (format === 'ampm') {
	      var isAM = hours < 12;
	      var additional = isAM ? ' am' : ' pm';
	
	      hours %= 12;
	      hours = (hours || 12).toString();
	      if (mins.length < 2) mins = '0' + mins;
	
	      return hours + (mins === '00' ? '' : ':' + mins) + additional;
	    }
	
	    hours = hours.toString();
	    if (hours.length < 2) hours = '0' + hours;
	    if (mins.length < 2) mins = '0' + mins;
	    return hours + ':' + mins;
	  },
	  dateOutOfRange: function dateOutOfRange(date, minDate, maxDate) {
	    return minDate && !(date >= minDate) || maxDate && !(date <= maxDate);
	  },
	  closestDate: function closestDate(to, date1, date2) {
	    var toTime = to.getTime();
	
	    var diff1 = Math.abs(toTime - date1.getTime());
	    var diff2 = Math.abs(toTime - date2.getTime());
	
	    return diff1 < diff2 ? date1 : date2;
	  },
	  formatDate: function formatDate(date) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	    if (locale === 'en') {
	      return date.getDate() + ' ' + time.getFullMonth(date, locale) + ' ' + date.getFullYear();
	    }
	    return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
	  }
	};
	
	exports.default = time;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var babelPluginFlowReactPropTypes_proptype_CellDataGetterParams =  true ? null : {
	  columnData: require("prop-types").any,
	  dataKey: require("prop-types").string.isRequired,
	  rowData: function rowData(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  }
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_CellDataGetterParams", {
	  value: babelPluginFlowReactPropTypes_proptype_CellDataGetterParams,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_CellRendererParams =  true ? null : {
	  cellData: require("prop-types").any,
	  columnData: require("prop-types").any,
	  dataKey: require("prop-types").string.isRequired,
	  rowData: function rowData(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  },
	  rowIndex: require("prop-types").number.isRequired
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_CellRendererParams", {
	  value: babelPluginFlowReactPropTypes_proptype_CellRendererParams,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams =  true ? null : {
	  className: require("prop-types").string.isRequired,
	  columns: require("prop-types").arrayOf(require("prop-types").any).isRequired,
	  style: function style(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  }
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams", {
	  value: babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_HeaderRendererParams =  true ? null : {
	  columnData: require("prop-types").any,
	  dataKey: require("prop-types").string.isRequired,
	  disableSort: require("prop-types").bool,
	  label: require("prop-types").any,
	  sortBy: require("prop-types").string,
	  sortDirection: require("prop-types").string
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_HeaderRendererParams", {
	  value: babelPluginFlowReactPropTypes_proptype_HeaderRendererParams,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_RowRendererParams =  true ? null : {
	  className: require("prop-types").string.isRequired,
	  columns: require("prop-types").arrayOf(require("prop-types").any).isRequired,
	  index: require("prop-types").number.isRequired,
	  isScrolling: require("prop-types").bool.isRequired,
	  onRowClick: require("prop-types").func,
	  onRowDoubleClick: require("prop-types").func,
	  onRowMouseOver: require("prop-types").func,
	  onRowMouseOut: require("prop-types").func,
	  rowData: function rowData(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  },
	  style: function style(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
	    }
	  }
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_RowRendererParams", {
	  value: babelPluginFlowReactPropTypes_proptype_RowRendererParams,
	  configurable: true
	});

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestAnimationTimeout = exports.cancelAnimationTimeout = undefined;
	
	var _animationFrame = __webpack_require__(6412);
	
	var babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId =  true ? null : {
	  id: require('prop-types').number.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId', {
	  value: babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId,
	  configurable: true
	});
	var cancelAnimationTimeout = exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
	  return (0, _animationFrame.caf)(frame.id);
	};
	
	/**
	 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
	 * When the delay time has been reached the function you're timing out will be called.
	 *
	 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
	 */
	var requestAnimationTimeout = exports.requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
	  var start = Date.now();
	
	  var timeout = function timeout() {
	    if (Date.now() - start >= delay) {
	      callback.call();
	    } else {
	      frame.id = (0, _animationFrame.raf)(timeout);
	    }
	  };
	
	  var frame = {
	    id: (0, _animationFrame.raf)(timeout)
	  };
	
	  return frame;
	};

/***/ }),
/* 753 */,
/* 754 */,
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(2895));
	var unitless = _interopDefault(__webpack_require__(2897));
	var memoize = _interopDefault(__webpack_require__(2896));
	
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var isProcessableValue = function isProcessableValue(value) {
	  return value != null && typeof value !== 'boolean';
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          return value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
	        return _char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles + ";";
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        break;
	      }
	
	    case 'string':
	      if (false) {
	        var matched = [];
	        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
	          var fakeVarName = "animation" + matched.length;
	          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
	          return "${" + fakeVarName + "}";
	        });
	
	        if (matched.length) {
	          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
	        }
	      }
	
	      break;
	  } // finalize string values (regular strings and functions interpolated into css calls)
	
	
	  if (registered == null) {
	    return interpolation;
	  }
	
	  var cached = registered[interpolation];
	
	  if (false) {
	    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	    shouldWarnAboutInterpolatingClassNameFromCss = false;
	  }
	
	  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else if (isProcessableValue(value)) {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            if (isProcessableValue(value[_i])) {
	              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	            }
	          }
	        } else {
	          var interpolated = handleInterpolation(mergedProps, registered, value, false);
	
	          switch (_key) {
	            case 'animation':
	            case 'animationName':
	              {
	                string += processStyleName(_key) + ":" + interpolated + ";";
	                break;
	              }
	
	            default:
	              {
	                if (false) {
	                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
	                }
	
	                string += _key + "{" + interpolated + "}";
	              }
	          }
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    if (false) {
	      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	    }
	
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor,
	      toString: function toString() {
	        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
	      }
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	exports.onHidden = function (cb, once) {
	    var onHiddenOrPageHide = function (event) {
	        if (event.type === 'pagehide' || utils_1.getGlobalObject().document.visibilityState === 'hidden') {
	            cb(event);
	            if (once) {
	                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
	                removeEventListener('pagehide', onHiddenOrPageHide, true);
	            }
	        }
	    };
	    addEventListener('visibilitychange', onHiddenOrPageHide, true);
	    // Some browsers have buggy implementations of visibilitychange,
	    // so we use pagehide in addition, just to be safe.
	    addEventListener('pagehide', onHiddenOrPageHide, true);
	};
	//# sourceMappingURL=onHidden.js.map

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// Note: the following line is added by scripts/fix-common-js-output.ts to allow require('autolinker') to work correctly
	exports = module.exports = __webpack_require__(1084).default;  // redefine 'exports' object as the Autolinker class itself
	// WARNING: This file is modified a bit when it is compiled into index.js in
	// order to support nodejs interoperability with require('autolinker') directly.
	// This is done by the buildSrcFixCommonJsIndexTask() function in the gulpfile.
	// See that function for more details.
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Autolinker = void 0;
	var tslib_1 = __webpack_require__(181);
	var autolinker_1 = (0, tslib_1.__importDefault)(__webpack_require__(1084));
	exports.Autolinker = autolinker_1.default;
	exports.default = autolinker_1.default;
	(0, tslib_1.__exportStar)(__webpack_require__(1084), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1687), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1085), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(2977), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(2978), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 758 */,
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _debounce = __webpack_require__(176);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _enhance = __webpack_require__(760);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _PharmacyForm = __webpack_require__(3039);
	
	var _PharmacyForm2 = _interopRequireDefault(_PharmacyForm);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _makePharmacyTitle = __webpack_require__(311);
	
	var _styles = __webpack_require__(4900);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PharmacyPopup(_ref) {
	  var isOpen = _ref.isOpen,
	      onClose = _ref.onClose,
	      setPharmacy = _ref.setPharmacy,
	      pharmaciesList = _ref.pharmaciesList,
	      getPharmaciesList = _ref.getPharmaciesList,
	      clearPharmacyList = _ref.clearPharmacyList,
	      loadMorePharmacies = _ref.loadMorePharmacies,
	      setPreferredPharmacy = _ref.setPreferredPharmacy,
	      formatMessage = _ref.intl.formatMessage,
	      _ref$withMailOrder = _ref.withMailOrder,
	      withMailOrder = _ref$withMailOrder === undefined ? true : _ref$withMailOrder;
	
	  var rootRef = (0, _react.useRef)();
	  var offsetRef = (0, _react.useRef)(0);
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      picked = _useState2[0],
	      setPicked = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      formData = _useState4[0],
	      setFormData = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      activeMailOrder = _useState6[0],
	      setActiveMailOrder = _useState6[1];
	
	  var loadMore = (0, _react.useCallback)(function () {
	    loadMorePharmacies({
	      zip: formData,
	      offset: offsetRef.current,
	      activeMailOrder: activeMailOrder
	    });
	    offsetRef.current += 20;
	  }, [formData, activeMailOrder]);
	
	  (0, _useLazyLoad.useLazyLoad)({ node: rootRef, loadMore: loadMore, path: [] });
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    setPreferredPharmacy(picked);
	    setPharmacy(picked);
	    onClose();
	  };
	
	  var fetchPharmacies = function fetchPharmacies(value, order) {
	    if (!value.trim()) {
	      return;
	    }
	
	    offsetRef.current = 0;
	    clearPharmacyList();
	
	    getPharmaciesList((0, _extends3.default)({
	      zip: value,
	      limit: 20,
	      offset: offsetRef.current
	    }, order && {
	      mailOrder: order
	    }));
	  };
	
	  var handleFormChange = (0, _debounce2.default)(function (text) {
	    if (text.length > 9) return;
	    setFormData(text);
	    if (text.length < 3) {
	      clearPharmacyList();
	      return;
	    }
	
	    fetchPharmacies(text, activeMailOrder);
	  }, 1000);
	
	  var handleCheck = function handleCheck() {
	    fetchPharmacies(formData, !activeMailOrder);
	    setActiveMailOrder(!activeMailOrder);
	  };
	
	  var emptyContentText = formData && formData.length > 2 ? 'patient.portal.healthRecord.emptyState.nothingFound' : 'appointments.form.emptyPharmacyList';
	
	  var renderDialogHeader = _react2.default.createElement(_PharmacyForm2.default, {
	    id: picked.id,
	    formData: formData,
	    handleSubmit: handleSubmit,
	    withMailOrder: withMailOrder,
	    activeMailOrder: activeMailOrder,
	    handleCheckboxToggle: handleCheck,
	    handleChange: function handleChange(value) {
	      return handleFormChange(value);
	    }
	  });
	  var pharmaciesCount = pharmaciesList.count > 1 ? pharmaciesList.count + ' ' + formatMessage({
	    id: 'appointments.pharmacies'
	  }) : pharmaciesList.count + ' ' + formatMessage({
	    id: 'patient.portal.medications.pharmacy'
	  }).toLowerCase();
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      contentWhite: true,
	      overflowVisible: true,
	      opened: isOpen,
	      contentNoPadding: true,
	      onClose: onClose,
	      paperClassName: _styles2.default.popupRoot,
	      width: (0, _mobileHelpers.isDesktop)() ? 'medium' : 'small',
	      dialogHeaderContent: renderDialogHeader,
	      extraContentClassName: _styles2.default.extraContent,
	      title: formatMessage({ id: 'appointments.form.searchForPharmacy' })
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.popupContent, ref: rootRef },
	      !pharmaciesList.count && !pharmaciesList.sending || !formData ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.emptyContent },
	        _react2.default.createElement(_Content2.default, {
	          text: formatMessage({
	            id: emptyContentText
	          }),
	          icon: 'search-list',
	          className: 'absolute-center'
	        })
	      ) : _react2.default.createElement(
	        _react.Fragment,
	        null,
	        !pharmaciesList.sending && _react2.default.createElement(
	          'div',
	          { className: _styles2.default.pharmacyCount },
	          pharmaciesCount
	        ),
	        pharmaciesList.sending && !pharmaciesList.succeed && _react2.default.createElement(_Loader2.default, null),
	        _react2.default.createElement(
	          _react.Fragment,
	          null,
	          pharmaciesList.list.map(function (el) {
	            return _react2.default.createElement(
	              'div',
	              {
	                key: el.id,
	                className: _styles2.default.pharmacyItem,
	                onClick: function onClick() {
	                  return setPicked(el);
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _makePharmacyTitle.makePharmacyTitle)(el)
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: picked.id === el.id ? _styles2.default.showIcon : _styles2.default.hideIcon
	                },
	                _react2.default.createElement(_Icon2.default, { name: 'check', fill: '#3b557a', width: '16' })
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	}
	
	PharmacyPopup.propTypes = {
	  intl: _propTypes2.default.object,
	  isOpen: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  setPharmacy: _propTypes2.default.func,
	  withMailOrder: _propTypes2.default.bool,
	  pharmaciesList: _propTypes2.default.object,
	  getPharmaciesList: _propTypes2.default.func,
	  clearPharmacyList: _propTypes2.default.func,
	  loadMorePharmacies: _propTypes2.default.func,
	  setPreferredPharmacy: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(PharmacyPopup);

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _getUser = __webpack_require__(202);
	
	var getUser = _interopRequireWildcard(_getUser);
	
	var _pharmacyReq = __webpack_require__(628);
	
	var _progressTypes = __webpack_require__(55);
	
	var _selectors = __webpack_require__(43);
	
	var _selectors2 = __webpack_require__(56);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: (0, _selectors2.getUserSelector)(state),
	    careUser: (0, _selectors.selectProgressCareUser)(state),
	    pharmaciesList: (0, _selectors.selectPharmaciesList)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  getUser: getUser.actions.send,
	  getPharmaciesList: _pharmacyReq.actions.send,
	  clearPharmacyList: _pharmacyReq.actions.clear,
	  loadMorePharmacies: _pharmacyReq.actions.loadMore,
	  updateData: _progressTypes.appointmentProgressActions.updateNecessaryData,
	  updateCareUser: _progressTypes.appointmentProgressActions.updateCareUserProfile,
	  setPreferredPharmacy: _progressTypes.appointmentProgressActions.setPreferredPharmacy
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _uniq = __webpack_require__(380);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _dateFilter = __webpack_require__(310);
	
	var _styles = __webpack_require__(4917);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimeSlots(_ref) {
	  var list = _ref.list,
	      variant = _ref.variant,
	      onSelect = _ref.onSelect,
	      activeSlot = _ref.activeSlot;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: (0, _classnames2.default)('root', variant) },
	    (0, _uniq2.default)(list).map(function (slot) {
	      return _react2.default.createElement(
	        'div',
	        {
	          key: slot,
	          styleName: (0, _classnames2.default)('slot', { 'active-slot': slot === activeSlot }),
	          onClick: function onClick() {
	            return onSelect(slot);
	          }
	        },
	        (0, _dateFilter.formatHours)(slot)
	      );
	    }),
	    !(0, _size2.default)(list) && _react2.default.createElement(
	      'div',
	      { styleName: 'emptyList' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appointments.form.noAvailableProviders' })
	    )
	  );
	}
	
	TimeSlots.propTypes = {
	  list: PropTypes.array,
	  onSelect: PropTypes.func,
	  variant: PropTypes.oneOf(['sm', 'md']),
	  activeSlot: PropTypes.string
	};
	
	TimeSlots.defaultProps = {
	  variant: 'md'
	};
	
	exports.default = (0, _reactCssModules2.default)(TimeSlots, _styles2.default, { allowMultiple: true });

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _from = __webpack_require__(550);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _desc, _value, _class; /* eslint-disable consistent-return,react/require-default-props */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _chat = __webpack_require__(67);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var FilePicker = (_class = function (_PureComponent) {
	  (0, _inherits3.default)(FilePicker, _PureComponent);
	
	  function FilePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FilePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FilePicker.__proto__ || (0, _getPrototypeOf2.default)(FilePicker)).call.apply(_ref, [this].concat(args))), _this), _this.input = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FilePicker, [{
	    key: 'handleFilePick',
	    value: function handleFilePick(e) {
	      var _props = this.props,
	          onError = _props.onError,
	          onFilePick = _props.onFilePick;
	
	
	      e.stopPropagation();
	      e.preventDefault();
	
	      var fileSource = e.target;
	      var multiple = fileSource.multiple;
	
	
	      var files = [];
	
	      (0, _from2.default)(fileSource.files).forEach(function (file) {
	        files.push(file);
	      });
	
	      if (!files) return;
	
	      var errors = this.validateFile(files);
	      if (errors) return onError(errors);
	
	      if (!multiple) {
	        var file = files[0];
	        onFilePick(file);
	      } else {
	        onFilePick(files);
	      }
	      // Prevent not firing change event for the same file twice
	      e.target.value = '';
	    }
	  }, {
	    key: 'validateFile',
	    value: function validateFile(files) {
	      var errors = [];
	      var errorFiles = [];
	      var _props2 = this.props,
	          maxSize = _props2.maxSize,
	          allowedFormats = _props2.allowedFormats,
	          validFileExtensions = _props2.validFileExtensions,
	          maxAttachmentNumber = _props2.maxAttachmentNumber;
	
	
	      if (files.length > maxAttachmentNumber) {
	        errors.push(_chat.NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_NUMBER);
	      }
	
	      if (!maxSize && !allowedFormats) return false;
	      files.forEach(function (file) {
	        var size = file.size / 1024 / 1024;
	        var exceedMaxSize = Math.ceil(size) > maxSize;
	
	        if (maxSize && exceedMaxSize) {
	          errors.push(_chat.NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_SIZE);
	          errorFiles.push(file.name);
	        }
	        if (file.type) {
	          if (allowedFormats && !allowedFormats.includes(file.type)) {
	            errors.push(_chat.NEW_MESSAGE_ERRORS.ATTACHMENT_NOT_ALLOWED_FORMAT);
	          }
	        } else {
	          var fileExtension = file.name.split('.').pop();
	          if (validFileExtensions && !validFileExtensions.includes(fileExtension)) {
	            errors.push(_chat.NEW_MESSAGE_ERRORS.ATTACHMENT_NOT_ALLOWED_FORMAT);
	          }
	        }
	      });
	
	      return errors.length ? { errors: errors, errorFiles: errorFiles } : false;
	    }
	
	    // Used from outside
	
	  }, {
	    key: 'forcePick',
	    value: function forcePick() {
	      this.input.click();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          inputFileLabel = _props3.inputFileLabel,
	          disabled = _props3.disabled,
	          children = _props3.children,
	          multiple = _props3.multiple,
	          allowedFormats = _props3.allowedFormats;
	
	      var acceptFormats = allowedFormats.join(' ,');
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          { htmlFor: inputFileLabel },
	          _react2.default.createElement(
	            _ClickableElement2.default,
	            null,
	            children
	          )
	        ),
	        _react2.default.createElement('input', {
	          ref: function ref(node) {
	            return _this2.input = node;
	          },
	          id: inputFileLabel,
	          type: 'file',
	          style: { display: 'none' },
	          onChange: this.handleFilePick,
	          disabled: disabled,
	          multiple: multiple,
	          accept: acceptFormats
	        })
	      );
	    }
	  }]);
	  return FilePicker;
	}(_react.PureComponent), (_applyDecoratedDescriptor(_class.prototype, 'handleFilePick', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleFilePick'), _class.prototype)), _class);
	exports.default = FilePicker;
	
	
	FilePicker.propTypes = {
	  onFilePick: _propTypes2.default.func,
	  onError: _propTypes2.default.func,
	  inputFileLabel: _propTypes2.default.string,
	  maxSize: _propTypes2.default.number,
	  disabled: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  allowedFormats: _propTypes2.default.array,
	  multiple: _propTypes2.default.bool,
	  validFileExtensions: _propTypes2.default.array,
	  maxAttachmentNumber: _propTypes2.default.number
	};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _format = __webpack_require__(319);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(1485);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props,react/default-props-match-prop-types */
	var MessageSeparatorView = function MessageSeparatorView(_ref) {
	  var date = _ref.date,
	      formatMessage = _ref.intl.formatMessage,
	      left = _ref.left,
	      hasBorder = _ref.hasBorder;
	  return _react2.default.createElement(
	    'p',
	    {
	      key: date,
	      styleName: (0, _classnames2.default)('date', {
	        'date--left': left,
	        'date--has-border': hasBorder
	      })
	    },
	    _react2.default.createElement(
	      'time',
	      { dateTime: date },
	      (0, _format2.default)(date, formatMessage(_strings.DAY_FORMATTING_PATTERN))
	    )
	  );
	};
	
	MessageSeparatorView.propTypes = {
	  date: _propTypes2.default.object.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  left: _propTypes2.default.bool,
	  hasBorder: _propTypes2.default.bool
	};
	
	MessageSeparatorView.defaultProps = {
	  date: ''
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(MessageSeparatorView, _index2.default, { allowMultiple: true }));

/***/ }),
/* 764 */,
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactGoogleMaps = __webpack_require__(2743);
	
	var _utils = __webpack_require__(766);
	
	var _blue = __webpack_require__(5262);
	
	var _blue2 = _interopRequireDefault(_blue);
	
	var _black = __webpack_require__(5261);
	
	var _black2 = _interopRequireDefault(_black);
	
	var _my_location_icon = __webpack_require__(5265);
	
	var _my_location_icon2 = _interopRequireDefault(_my_location_icon);
	
	var _LocationDetailsPopUp = __webpack_require__(3283);
	
	var _useGoogleMapsData2 = __webpack_require__(3285);
	
	var _enhance = __webpack_require__(3284);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _styles = __webpack_require__(4956);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _GoogleMaps(props) {
	  var isUpcoming = props.isUpcoming,
	      appointmentsList = props.appointmentsList,
	      currentAppointment = props.currentAppointment,
	      historyAppointmentsList = props.historyAppointmentsList,
	      currentAppointmentId = props.currentAppointmentId,
	      getLocationsDetails = props.getLocationsDetails,
	      activeTodoItemTaskId = props.activeTodoItemTaskId,
	      geolocations = props.geolocations,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus,
	      formatMessage = props.intl.formatMessage,
	      isAppointment = props.isAppointment,
	      _props$isPaperworkFlo = props.isPaperworkFlow,
	      isPaperworkFlow = _props$isPaperworkFlo === undefined ? false : _props$isPaperworkFlo,
	      paperworkFlowAppointment = props.paperworkFlowAppointment;
	
	
	  var activeAppointment = (0, _react.useMemo)(function () {
	    if (currentAppointment) {
	      return currentAppointment;
	    }
	    if (isUpcoming) {
	      return appointmentsList.find(function (appointment) {
	        return appointment.id === currentAppointmentId;
	      });
	    }
	
	    if (isPaperworkFlow) {
	      return paperworkFlowAppointment;
	    }
	
	    return historyAppointmentsList.find(function (appointment) {
	      return appointment.id === currentAppointmentId;
	    });
	  }, [currentAppointmentId, appointmentsList, currentAppointment]);
	
	  var appointmentLocation = (0, _get2.default)(activeAppointment, 'location', {});
	  var startTime = (0, _get2.default)(activeAppointment, 'dateTime', '');
	
	  var _useGoogleMapsData = (0, _useGoogleMapsData2.useGoogleMapsData)(),
	      mapRef = _useGoogleMapsData.mapRef,
	      currentPosition = _useGoogleMapsData.currentPosition,
	      zoom = _useGoogleMapsData.zoom,
	      isMyPosition = _useGoogleMapsData.isMyPosition,
	      handleMapDragEnd = _useGoogleMapsData.handleMapDragEnd,
	      myGeoLocation = _useGoogleMapsData.myGeoLocation;
	
	  (0, _react.useEffect)(function () {
	    if (!isAppointment) {
	      getLocationsDetails({ id: activeTodoItemTaskId });
	    }
	  }, []);
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      showInfoWindowId = _useState2[0],
	      setShowInfoWindowId = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      activeLocation = _useState4[0],
	      setActiveLocation = _useState4[1];
	
	  var viewMarker = (0, _react.useMemo)(function () {
	    return function (marker) {
	      var id = marker.id,
	          lat = marker.lat,
	          lng = marker.lng,
	          schedule = marker.schedule,
	          name = marker.name,
	          geofenceLat = marker.geofenceLat,
	          geofenceLng = marker.geofenceLng;
	
	      var delta = isMyPosition ? '' + (0, _utils.computeDistanceBetweenLocations)(myGeoLocation, {
	        lat: lat || geofenceLat,
	        lng: lng || geofenceLng
	      }) + formatMessage({ id: 'googleMaps.miAway' }) : '';
	      var workingHours = (0, _utils.currentWorkingHours)(formatMessage, schedule, true, false);
	      return _react2.default.createElement(
	        _reactGoogleMaps.Marker,
	        {
	          onFocus: onFocus,
	          onBlur: onBlur,
	          onMouseOver: function onMouseOver() {
	            setShowInfoWindowId(id);
	          },
	          onMouseOut: function onMouseOut() {
	            setShowInfoWindowId(null);
	          },
	          icon: activeLocation && activeLocation.id === id ? _black2.default : _blue2.default,
	          onClick: function onClick() {
	            return setActiveLocation(marker);
	          },
	          position: { lat: lat || geofenceLat, lng: lng || geofenceLng },
	          key: id
	        },
	        showInfoWindowId === id && _react2.default.createElement(
	          _reactGoogleMaps.InfoWindow,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.wrapper },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.titleLocation },
	              name
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.description },
	              delta,
	              !isAppointment && workingHours
	            )
	          )
	        )
	      );
	    };
	  }, [myGeoLocation, activeLocation, showInfoWindowId]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactGoogleMaps.GoogleMap,
	      {
	        zoom: zoom,
	        center: isAppointment ? {
	          lat: appointmentLocation.geofenceLat,
	          lng: appointmentLocation.geofenceLng
	        } : currentPosition,
	        ref: mapRef,
	        options: {
	          streetViewControl: false,
	          scrollwheel: true,
	          fullscreenControl: false,
	          disableDefaultUI: true,
	          scaleControl: true,
	          zoomControl: true,
	          styles: _utils.mapStylesCustom
	        },
	        onDragEnd: handleMapDragEnd
	      },
	      !isAppointment && geolocations.map(function (marker) {
	        return viewMarker(marker);
	      }),
	      isAppointment && viewMarker(appointmentLocation),
	      isMyPosition && _react2.default.createElement(_reactGoogleMaps.Marker, { position: myGeoLocation, icon: _my_location_icon2.default })
	    ),
	    _react2.default.createElement(_LocationDetailsPopUp.LocationDetailsView, {
	      startTime: startTime,
	      isAppointment: isAppointment,
	      formatMessage: formatMessage,
	      myGeoLocation: myGeoLocation,
	      location: activeLocation,
	      opened: !!activeLocation,
	      isMyPosition: isMyPosition,
	      onClose: function onClose() {
	        return setActiveLocation(null);
	      }
	    })
	  );
	}
	
	_GoogleMaps.propTypes = {
	  isUpcoming: PropTypes.bool,
	  getLocationsDetails: PropTypes.func,
	  activeTodoItemTaskId: PropTypes.number,
	  geolocations: PropTypes.array,
	  onFocus: PropTypes.func,
	  onBlur: PropTypes.func,
	  isAppointment: PropTypes.bool,
	  isPaperworkFlow: PropTypes.bool,
	  paperworkFlowAppointment: PropTypes.object,
	  intl: PropTypes.shape({
	    formatMessage: PropTypes.func
	  })
	};
	
	_GoogleMaps.defaultProps = {
	  isAppointment: false,
	  onFocus: function onFocus() {},
	  onBlur: function onBlur() {}
	};
	
	var GoogleMaps = (0, _enhance2.default)(_GoogleMaps);
	
	exports.default = GoogleMaps;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getWorkingHoursByDay = exports.currentWorkingHours = exports.getCurrentDay = exports.computeDistanceBetweenLocations = exports.getMiles = exports.DAY_OF_WEEK = exports.FALLBACK_LOCATION = exports.mapStylesCustom = exports.DEFAULT_ZOOM_WITHOUT_PERMISSION = exports.DEFAULT_ZOOM_WITH_PERMISSION = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.getKeyByValue = getKeyByValue;
	exports.CenterControl = CenterControl;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _upperFirst = __webpack_require__(147);
	
	var _upperFirst2 = _interopRequireDefault(_upperFirst);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _utils = __webpack_require__(797);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_ZOOM_WITH_PERMISSION = exports.DEFAULT_ZOOM_WITH_PERMISSION = 14;
	var DEFAULT_ZOOM_WITHOUT_PERMISSION = exports.DEFAULT_ZOOM_WITHOUT_PERMISSION = 3;
	
	var mapStylesCustom = exports.mapStylesCustom = [{
	  featureType: 'poi',
	  stylers: [{
	    visibility: 'off'
	  }]
	}, {
	  featureType: 'poi.park',
	  stylers: [{
	    visibility: 'on'
	  }]
	}];
	
	var FALLBACK_LOCATION = exports.FALLBACK_LOCATION = {
	  latitude: 24.78276,
	  longitude: 3.084639
	};
	
	var DAY_OF_WEEK = exports.DAY_OF_WEEK = {
	  friday: 'Fri',
	  monday: 'Mon',
	  saturday: 'Sat',
	  sunday: 'Sun',
	  thursday: 'Thu',
	  tuesday: 'Tue',
	  wednesday: 'Wed'
	};
	
	var getMiles = exports.getMiles = function getMiles(i) {
	  return i * 0.000621371192;
	};
	
	function getKeyByValue(object, value) {
	  return (0, _keys2.default)(object).find(function (key) {
	    return object[key] === value;
	  });
	}
	
	var computeDistanceBetweenLocations = exports.computeDistanceBetweenLocations = function computeDistanceBetweenLocations(myLocation, place) {
	  if (myLocation && place) {
	    return getMiles(google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(myLocation), new google.maps.LatLng({
	      lat: place.lat || place.geofenceLat,
	      lng: place.lng || place.geofenceLng
	    }))).toFixed(1);
	  }
	};
	
	var getCurrentDay = exports.getCurrentDay = function getCurrentDay(full) {
	  return (0, _moment2.default)().format(full ? 'dddd' : 'ddd');
	};
	
	var currentWorkingHours = exports.currentWorkingHours = function currentWorkingHours(formatMessage, schedule, withDivider, details) {
	  var closed = formatMessage({ id: 'googleMaps.closed' });
	
	  if (schedule && !(0, _isEmpty2.default)(schedule)) {
	    var divider = withDivider ? ' • ' : '';
	    var currentDay = (0, _upperFirst2.default)(getCurrentDay(false).toLowerCase());
	    var target = schedule[getCurrentDay(true).toLowerCase()];
	    if (details) {
	      if (target && target.startTime) {
	        return {
	          currentDay: currentDay,
	          workingHours: (0, _utils.convertTimeTo12HoursFormat)(target.startTime) + '-' + (0, _utils.convertTimeTo12HoursFormat)(target.endTime)
	        };
	      }
	      return {
	        currentDay: currentDay,
	        workingHours: closed
	      };
	    }
	    return target && target.startTime ? divider + '\u200E' + currentDay + ' ' + (0, _utils.convertTimeTo12HoursFormat)(target.startTime) + '-' + (0, _utils.convertTimeTo12HoursFormat)(target.endTime) : '' + divider + currentDay + ' ' + closed;
	  }
	  return '-';
	};
	
	var getWorkingHoursByDay = exports.getWorkingHoursByDay = function getWorkingHoursByDay(dayEntity, dayName, closed) {
	  var currentDay = (0, _upperFirst2.default)(getCurrentDay(false).toLowerCase());
	  var day = DAY_OF_WEEK[dayName];
	  var isCurrentDay = day === currentDay;
	  if (dayEntity) {
	    return {
	      day: day,
	      workingHours: (0, _utils.convertTimeTo12HoursFormat)(dayEntity.startTime) + '-' + (0, _utils.convertTimeTo12HoursFormat)(dayEntity.endTime),
	      isCurrentDay: !!isCurrentDay
	    };
	  }
	  return {
	    day: day,
	    workingHours: closed,
	    isCurrentDay: !!isCurrentDay
	  };
	};
	
	function CenterControl(controlDiv, map) {
	  var controlUI = document.createElement('div');
	  controlUI.style.backgroundColor = '#fff';
	  controlUI.style.border = '2px solid #fff';
	  controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
	  controlUI.style.borderRadius = '3px';
	  controlUI.style.cursor = 'pointer';
	  controlUI.style.marginBottom = '8px';
	  controlUI.style.textAlign = 'center';
	  controlUI.style.display = 'flex';
	  controlUI.style.alignItems = 'center';
	  controlUI.style.justifyContent = 'center';
	  controlUI.style.width = '40px';
	  controlUI.style.height = '40px';
	  controlUI.style.marginRight = '10px';
	  controlDiv.appendChild(controlUI);
	  var controlIcon = document.createElement('div');
	  controlIcon.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="4 4 24 24"> <defs> <filter id="2h7mbtj58a" width="181.2%" height="181.2%" x="-40.6%" y="-34.4%" filterUnits="objectBoundingBox"> <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/> <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4"/> <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/> </filter> <rect id="aueko8y73b" width="32" height="32" x="0" y="0" rx="4"/> </defs> <g fill="none" fill-rule="evenodd"> <use fill="#000" filter="url(#2h7mbtj58a)" xlink:href="#aueko8y73b"/> <use fill="#FFF" xlink:href="#aueko8y73b"/> <path fill="#000" fill-rule="nonzero" d="M15.999 6c.352-.015.651.311.651.652v2.016c.628.055 1.248.19 1.835.405 1.432.526 2.65 1.46 3.536 2.7.746 1.045 1.19 2.297 1.305 3.575h2.022c.365 0 .636.297.651.65.016.353-.31.652-.651.652h-2.023c-.017.184-.04.367-.068.55-.224 1.46-.934 2.84-1.955 3.905-1.01 1.05-2.354 1.806-3.785 2.097-.286.059-.575.102-.867.128v2.018c0 .365-.297.636-.651.651-.352.016-.652-.31-.652-.651v-2.021l-.134-.012c-.689-.08-1.343-.244-1.98-.499l-.318-.135c-1.331-.601-2.467-1.637-3.22-2.884-.576-.949-.929-2.038-1.027-3.146H6.652c-.365 0-.636-.298-.651-.652-.016-.352.31-.652.651-.652h2.02c.14-1.5.725-2.9 1.683-4.065.931-1.134 2.23-1.965 3.64-2.365.44-.125.894-.207 1.352-.248V6.652c0-.365.298-.636.652-.651zm.546 3.964c-.483-.038-.968-.025-1.45.039l.094-.011-.267.044c-.345.066-.685.158-1.016.277l-.252.096-.183.083c-.173.082-.342.171-.508.267l-.245.15c-.137.086-.27.178-.4.275l.038-.028-.04.03.007-.006-.005.004-.002.002.007-.006.028-.02-.018.014-.03.022.008-.007-.022.018.007-.006-.018.014.007-.005-.014.012-.044.036-.196.165c-.25.22-.482.456-.697.71l-.091.111-.017.017-.005.006-.003.004.001-.002-.03.034-.018.03-.018.026-.034.046c-.1.139-.195.282-.284.428-.176.286-.328.586-.459.894l.033-.074-.094.246c-.119.33-.21.67-.277 1.016l-.042.254-.03.282c-.028.362-.028.725 0 1.088l.03.28.042.255c.066.345.158.684.277 1.016l.092.241-.029-.065.031.074.033.078-.031-.079.083.185c.082.174.171.343.267.509l.15.245c.087.137.178.27.275.4l-.023-.033-.003-.003.008.01.01.014.006.009-.01-.015c.009.01.017.021.027.035l.01.012-.005-.005.007.009.01.014-.01-.015.011.014.036.045.165.195c.22.25.456.483.71.698l.111.09.017.017.003.002.004.003.005.004-.006-.004c.015.014.025.024.036.032l.03.018-.006-.005.032.024.046.034c.139.1.282.195.428.284.286.176.586.328.895.458l-.074-.033.245.095c.33.118.67.21 1.016.276l.253.041.283.031c.362.03.726.03 1.088 0l.28-.03.255-.042c.345-.065.685-.158 1.016-.276l.245-.095.19-.084c.173-.082.342-.171.508-.268l.245-.149c.137-.087.27-.178.4-.276l-.037.026.054-.04.014-.012-.003.003.005-.004.014-.01.044-.037c.065-.054.13-.108.196-.165.25-.219.482-.456.697-.71l.09-.11.023-.024c.023-.024.044-.047.05-.066l-.003.002.021-.028.034-.045c.1-.14.195-.283.284-.428.176-.287.328-.586.458-.895l-.036.08-.027.072.03-.074.033-.078-.032.07.094-.241c.118-.331.21-.671.277-1.017l.041-.257.025-.217c.009-.101.016-.202.02-.303l.007-.298.008.088c.047.305.324.573.644.56-.363-.001-.634-.298-.65-.652v-.05l-.001.05c0-.302-.02-.606-.061-.906l.009.089-.042-.262c-.066-.346-.159-.685-.277-1.016l-.097-.251-.082-.184c-.082-.173-.171-.343-.267-.508l-.15-.246c-.087-.136-.178-.269-.276-.4l.029.04-.03-.041.026.036-.04-.051-.006-.009.02.024-.025-.031-.005-.007.004.006-.01-.013-.036-.044-.166-.196c-.219-.25-.456-.482-.71-.697l-.11-.091c-.024-.02-.061-.063-.09-.072l.008.006-.08-.058c-.069-.05-.14-.099-.21-.146l-.217-.139c-.287-.175-.586-.327-.895-.458l.071.032-.242-.093c-.33-.119-.67-.211-1.017-.277l-.268-.044zm-2.574 4.308c.668-.827 1.902-1.16 2.899-.792.547.202.988.54 1.329 1.014.31.43.462.977.469 1.507-.009 1.223-.886 2.367-2.107 2.606-.595.117-1.172.044-1.722-.206-.469-.213-.87-.6-1.133-1.038-.267-.445-.409-.995-.37-1.514.046-.593.261-1.116.635-1.577z"/> </g></svg>';
	  controlUI.appendChild(controlIcon);
	
	  var successCurrentLocation = function successCurrentLocation(position) {
	    var currentPositionEntity = {
	      lat: position.coords.latitude,
	      lng: position.coords.longitude
	    };
	
	    controlUI.addEventListener('click', function () {
	      map.current.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.panTo(currentPositionEntity);
	    });
	  };
	
	  var errorHandlerLocation = function errorHandlerLocation() {
	    controlUI.style.display = 'none';
	  };
	
	  navigator.geolocation.getCurrentPosition(successCurrentLocation, errorHandlerLocation);
	}

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkForIsSignedAllConsents = checkForIsSignedAllConsents;
	function checkForIsSignedAllConsents(appointment) {
	  var allAppointmentConsentEntity = appointment ? appointment.consentsAssignment : null;
	
	  var allConsents = allAppointmentConsentEntity ? allAppointmentConsentEntity.consents : [];
	  return allConsents.every(function (_ref) {
	    var accepted = _ref.accepted;
	    return !!accepted;
	  });
	}

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var VISIT_DOCUMENTS_TYPES = exports.VISIT_DOCUMENTS_TYPES = {
	  CATEGORY: 'category',
	  SUB_CATEGORY: 'subCategory',
	  DOCUMENTS: 'documents'
	};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.handleUpdateStateWithAcceptedConsent = handleUpdateStateWithAcceptedConsent;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleUpdateStateWithAcceptedConsent(state, action) {
	  var _action$payload = action.payload,
	      appointmentConsentId = _action$payload.appointmentConsentId,
	      affectedAppointmentIds = _action$payload.affectedAppointmentIds;
	
	
	  var newArr = [].concat((0, _toConsumableArray3.default)(state.list));
	
	  if (appointmentConsentId && affectedAppointmentIds) newArr.forEach(function (item) {
	    if (affectedAppointmentIds.includes(item.id)) {
	      var targetConsent = item.consentsAssignment.consents.filter(function (consent) {
	        return consent.id === appointmentConsentId;
	      });
	      if (targetConsent && targetConsent[0]) {
	        targetConsent[0].accepted = true;
	      }
	    }
	  });
	
	  return (0, _extends3.default)({}, state, {
	    list: newArr
	  });
	}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleUpdateStatusSurveyInAppointmentDetails = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleUpdateStatusSurveyInAppointmentDetails = exports.handleUpdateStatusSurveyInAppointmentDetails = function handleUpdateStatusSurveyInAppointmentDetails(state, _ref) {
	  var payload = _ref.payload;
	
	  var userAppointmentId = payload.userAppointment ? payload.userAppointment.id : null;
	  var targetAppointment = state.list.find(function (_ref2) {
	    var id = _ref2.id;
	    return userAppointmentId === id;
	  });
	
	  if (!targetAppointment) return state;
	
	  var handleReplaceItem = function handleReplaceItem(allItem, item) {
	    if (item) {
	      var index = allItem.findIndex(function (_ref3) {
	        var assignmentId = _ref3.assignmentId;
	
	        return item.assignmentId === assignmentId;
	      });
	      allItem.splice(index, 1, item);
	      return allItem;
	    }
	  };
	
	  return (0, _extends3.default)({}, state, {
	    list: (0, _arrayModify.findAndReplace)(state.list, (0, _extends3.default)({}, targetAppointment, {
	      surveyAssignments: handleReplaceItem(targetAppointment.surveyAssignments, payload)
	    }))
	  });
	};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.handleUpdateStateWithDeleteDoc = handleUpdateStateWithDeleteDoc;
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleUpdateStateWithDeleteDoc(state, action) {
	  var targetAppointment = state.list.find(function (_ref) {
	    var id = _ref.id;
	    return action.payload.appointmentId === id;
	  });
	
	  if (targetAppointment) {
	    var targetDocument = targetAppointment.documents.findIndex(function (_ref2) {
	      var id = _ref2.id;
	      return action.payload.documentId === id;
	    });
	    targetAppointment.documents.splice(targetDocument, 1);
	
	    return (0, _extends3.default)({}, state, {
	      list: (0, _arrayModify.findAndReplace)(state.list, (0, _extends3.default)({}, targetAppointment))
	    });
	  }
	
	  return state;
	}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.handleUpdateStateWithUploadDoc = handleUpdateStateWithUploadDoc;
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleUpdateStateWithUploadDoc(state, action) {
	  var target = state.list.find(function (_ref) {
	    var id = _ref.id;
	    return action.payload.userAppointmentId === id;
	  });
	
	  if (target) {
	    target.documents.push(action.payload);
	    return (0, _extends3.default)({}, state, {
	      list: (0, _arrayModify.findAndReplace)(state.list, (0, _extends3.default)({}, target))
	    });
	  }
	
	  return state;
	}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Popover = __webpack_require__(250);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _PopoverContent = __webpack_require__(3374);
	
	var _PopoverContent2 = _interopRequireDefault(_PopoverContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InfoPopover(_ref) {
	  var list = _ref.list,
	      description = _ref.description,
	      anchorEl = _ref.anchorEl,
	      isOpen = _ref.isOpen,
	      onClose = _ref.onClose,
	      anchorOrigin = _ref.anchorOrigin;
	
	  return _react2.default.createElement(
	    _Popover2.default,
	    {
	      open: isOpen,
	      anchorEl: anchorEl,
	      anchorOrigin: anchorOrigin,
	      classes: { paper: (0, _mobileHelpers.isDesktop)() ? 'auto' : 'w-100' }
	    },
	    _react2.default.createElement(_PopoverContent2.default, { description: description, list: list, onClose: onClose })
	  );
	}
	
	InfoPopover.propTypes = {
	  list: _propTypes2.default.array,
	  anchorEl: _propTypes2.default.object,
	  isOpen: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  description: _propTypes2.default.string,
	  anchorOrigin: _propTypes2.default.object
	};
	
	InfoPopover.defaultProps = {
	  anchorOrigin: { horizontal: 'left', vertical: 'bottom' }
	};
	
	exports.default = InfoPopover;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _map = __webpack_require__(160);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _constants = __webpack_require__(17);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _initialInsuranceCardState = __webpack_require__(1208);
	
	var _selectors = __webpack_require__(43);
	
	var _selectors2 = __webpack_require__(56);
	
	var _selectors3 = __webpack_require__(23);
	
	var _selectors4 = __webpack_require__(64);
	
	var _paperworkGetUserDetails = __webpack_require__(122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useGetPatientMainInsuranceInfo = function useGetPatientMainInsuranceInfo(_ref) {
	  var flowType = _ref.flowType,
	      toDoTaskData = _ref.toDoTaskData;
	
	  var latestInsuranceCheckedData = (0, _reactRedux.useSelector)(_selectors.selectInsuranceLatestCheckData);
	
	  var skipInsuranceProfileFlow = (0, _reactRedux.useSelector)(_selectors3.selectTargetUserSkipInsurance);
	
	  var scheduledCompletedTasks = (0, _reactRedux.useSelector)(_selectors4.selectScheduledCompletedTasks);
	
	  var userDocuments = (0, _reactRedux.useSelector)(_selectors2.selectUserDocumentsList);
	
	  var skipInsurancePaperworkFlow = (0, _reactRedux.useSelector)(_paperworkGetUserDetails.selectPaperworkUserSkipInsurance);
	
	  var skipInsuranceGetCareFlow = (0, _reactRedux.useSelector)(_selectors.selectProgressCareUserSkipInsurance);
	
	  var insuranceDataSource = (0, _react.useMemo)(function () {
	    if (flowType === _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO) {
	      var _ref2 = toDoTaskData || {},
	          itemId = _ref2.itemId,
	          isCompleted = _ref2.isCompleted;
	
	      if (isCompleted) {
	        var scheduledCompletedTask = scheduledCompletedTasks.find(function (task) {
	          return task.id === itemId;
	        });
	
	        var patientInsurance = (0, _get2.default)(scheduledCompletedTask, 'payload.patientInsurance', {});
	
	        return patientInsurance;
	      }
	    }
	
	    return latestInsuranceCheckedData;
	  }, [flowType, scheduledCompletedTasks, toDoTaskData, latestInsuranceCheckedData]);
	
	  var skipInsurance = (0, _react.useMemo)(function () {
	    if (flowType === _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO) {
	      return (0, _get2.default)(insuranceDataSource, 'skipInsurance');
	    }
	
	    var map = new _map2.default([[_insuranceFlowType.INSURANCE_FLOW_TYPE.PAPERWORK, skipInsurancePaperworkFlow], [_insuranceFlowType.INSURANCE_FLOW_TYPE.PROFILE, skipInsuranceProfileFlow], [_insuranceFlowType.INSURANCE_FLOW_TYPE.GET_CARE_FLOW, skipInsuranceGetCareFlow]]);
	
	    return map.get(flowType);
	  }, [flowType, skipInsurancePaperworkFlow, skipInsuranceProfileFlow, insuranceDataSource, skipInsuranceGetCareFlow]);
	
	  var isInsuranceToDoFlowType = flowType === _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO;
	
	  var _insuranceDataSource = (0, _extends3.default)({}, insuranceDataSource),
	      backSide = _insuranceDataSource.backSide,
	      createdAt = _insuranceDataSource.createdAt,
	      createdDate = _insuranceDataSource.createdDate,
	      frontSide = _insuranceDataSource.frontSide,
	      groupNumber = _insuranceDataSource.groupNumber,
	      id = _insuranceDataSource.id,
	      isVerified = _insuranceDataSource.isVerified,
	      memberId = _insuranceDataSource.memberId,
	      payer = _insuranceDataSource.payer,
	      primarySubscriber = _insuranceDataSource.primarySubscriber,
	      userInputs = _insuranceDataSource.userInputs;
	
	  var getInsuranceCard = (0, _react.useCallback)(function (cardType) {
	    var card = userDocuments.find(function (doc) {
	      return doc.key === cardType;
	    });
	
	    var attachment = (0, _get2.default)(card, 'attachment');
	
	    return attachment || _initialInsuranceCardState.INITIAL_INSURANCE_CARD_STATE;
	  }, [userDocuments]);
	
	  var frontSideValue = (0, _react.useMemo)(function () {
	    if (!isInsuranceToDoFlowType) {
	      return getInsuranceCard(_constants.DOCUMENTATION_TYPES.CARD_1);
	    }
	
	    return frontSide;
	  }, [getInsuranceCard, frontSide, isInsuranceToDoFlowType]);
	
	  var backSideValue = (0, _react.useMemo)(function () {
	    if (!isInsuranceToDoFlowType) {
	      return getInsuranceCard(_constants.DOCUMENTATION_TYPES.CARD_2);
	    }
	
	    return backSide;
	  }, [getInsuranceCard, backSide, isInsuranceToDoFlowType]);
	
	  var primarySubscriberValue = isInsuranceToDoFlowType ? primarySubscriber : (0, _get2.default)(userInputs, 'primarySubscriber', null);
	
	  var groupNumberValue = isInsuranceToDoFlowType ? groupNumber : (0, _get2.default)(userInputs, 'groupNumber', '');
	
	  var memberIdValue = isInsuranceToDoFlowType ? memberId : (0, _get2.default)(userInputs, 'memberId', '');
	
	  var insuranceData = (0, _react.useMemo)(function () {
	    return {
	      backSide: backSideValue,
	      createdAt: createdAt,
	      createdDate: createdDate,
	      frontSide: frontSideValue,
	      groupNumber: groupNumberValue,
	      id: id,
	      isVerified: isVerified,
	      memberId: memberIdValue,
	      payer: payer,
	      primarySubscriber: primarySubscriberValue,
	      skipInsurance: skipInsurance
	    };
	  }, [backSideValue, createdAt, createdDate, frontSideValue, groupNumberValue, id, isVerified, memberIdValue, payer, primarySubscriberValue, skipInsurance]);
	
	  return insuranceData;
	};
	
	exports.default = useGetPatientMainInsuranceInfo;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InfoSection = __webpack_require__(231);
	
	var _InfoSection2 = _interopRequireDefault(_InfoSection);
	
	var _InsuranceCardsSection = __webpack_require__(1130);
	
	var _InsuranceCardsSection2 = _interopRequireDefault(_InsuranceCardsSection);
	
	var _UserDocumentsPreview = __webpack_require__(610);
	
	var _UserDocumentsPreview2 = _interopRequireDefault(_UserDocumentsPreview);
	
	var _styles = __webpack_require__(18);
	
	var _errorCodes = __webpack_require__(3900);
	
	var _strings = __webpack_require__(15);
	
	var _utils = __webpack_require__(1131);
	
	var _getDocumentsConfig = __webpack_require__(907);
	
	var _useInsuranceInfo2 = __webpack_require__(3375);
	
	var _useInsuranceInfo3 = _interopRequireDefault(_useInsuranceInfo2);
	
	var _useInsuranceCards = __webpack_require__(3908);
	
	var _useInsuranceCards2 = _interopRequireDefault(_useInsuranceCards);
	
	var _useGetPatientMainInsuranceInfo = __webpack_require__(774);
	
	var _useGetPatientMainInsuranceInfo2 = _interopRequireDefault(_useGetPatientMainInsuranceInfo);
	
	var _useGetHaveInsuranceLabel = __webpack_require__(1856);
	
	var _useGetHaveInsuranceLabel2 = _interopRequireDefault(_useGetHaveInsuranceLabel);
	
	var _useIsAdditionalInsurancesEnabledAndMaxNumber = __webpack_require__(1216);
	
	var _useIsAdditionalInsurancesEnabledAndMaxNumber2 = _interopRequireDefault(_useIsAdditionalInsurancesEnabledAndMaxNumber);
	
	var _selectors = __webpack_require__(43);
	
	var _getPatientInsurancesList = __webpack_require__(671);
	
	var _index = __webpack_require__(5006);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _common = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ICON_STYLES = { fill: _styles.COLORS.bluePrimary };
	
	var InsuranceSection = (0, _react.memo)(function (_ref) {
	  var insurance = _ref.insurance,
	      flowType = _ref.flowType,
	      isAdditionalInsurance = _ref.isAdditionalInsurance,
	      additionalInsuranceKey = _ref.additionalInsuranceKey,
	      skipInsurance = _ref.skipInsurance;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var frontSide = insurance.frontSide,
	      backSide = insurance.backSide;
	
	
	  var insuranceCardsHookArgs = (0, _react.useMemo)(function () {
	    return {
	      frontSide: frontSide,
	      backSide: backSide,
	      frontSideKey: isAdditionalInsurance ? additionalInsuranceKey + '_1' : undefined,
	      backSideKey: isAdditionalInsurance ? additionalInsuranceKey + '_2' : undefined
	    };
	  }, [frontSide, backSide, isAdditionalInsurance, additionalInsuranceKey]);
	
	  var insuranceCards = (0, _useInsuranceCards2.default)(insuranceCardsHookArgs);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    if (isAdditionalInsurance) {
	      return (0, _getDocumentsConfig.getAdditionalInsuranceCardDocumentsConfig)({
	        formatMessage: formatMessage,
	        userDocuments: insuranceCards,
	        isEditMode: false,
	        fieldName: additionalInsuranceKey
	      });
	    }
	
	    return (0, _getDocumentsConfig.getInsuranceCardDocumentsConfig)({
	      formatMessage: formatMessage,
	      userDocuments: insuranceCards,
	      isEditMode: false
	    });
	  }, [insuranceCards, additionalInsuranceKey, isAdditionalInsurance]),
	      sectionTitle = _useMemo.sectionTitle,
	      fields = _useMemo.fields;
	
	  var filteredDocuments = insuranceCards.filter(function (doc) {
	    return doc.attachment && doc.attachment.url;
	  });
	
	  var primarySubscriber = insurance.primarySubscriber;
	
	
	  var showPrimarySubscriberSection = (0, _utils.hasPrimarySubscriberData)(primarySubscriber);
	
	  var primarySubscriberTitle = formatMessage({
	    id: 'fields.insurance.primarySubscriber.title'
	  });
	
	  var _useInsuranceInfo = (0, _useInsuranceInfo3.default)(),
	      getPayerAndVerificationDate = _useInsuranceInfo.getPayerAndVerificationDate,
	      getMemberIdAndGroupNumber = _useInsuranceInfo.getMemberIdAndGroupNumber,
	      getPrimarySubscriberAddressData = _useInsuranceInfo.getPrimarySubscriberAddressData,
	      getPrimarySubscriberMainData = _useInsuranceInfo.getPrimarySubscriberMainData;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_InsuranceCardsSection2.default, {
	      fields: fields,
	      flowType: flowType,
	      isAdditionalInsurance: isAdditionalInsurance,
	      skipInsurance: skipInsurance,
	      title: sectionTitle
	    }),
	    _react2.default.createElement(_InfoSection2.default, {
	      entries: getPayerAndVerificationDate(insurance, flowType, isAdditionalInsurance, skipInsurance)
	    }),
	    _react2.default.createElement(_InfoSection2.default, {
	      entries: getMemberIdAndGroupNumber(insurance, flowType, isAdditionalInsurance, skipInsurance)
	    }),
	    !skipInsurance && showPrimarySubscriberSection && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.primarySubscriberTitle },
	        primarySubscriberTitle
	      ),
	      _react2.default.createElement(_InfoSection2.default, { entries: getPrimarySubscriberMainData(insurance) }),
	      _react2.default.createElement(_InfoSection2.default, { entries: getPrimarySubscriberAddressData(insurance) })
	    ),
	    _react2.default.createElement(_UserDocumentsPreview2.default, { documents: filteredDocuments })
	  );
	});
	
	InsuranceSection.propTypes = {
	  flowType: _propTypes2.default.string,
	  isAdditionalInsurance: _propTypes2.default.bool,
	  insurance: _propTypes2.default.object,
	  additionalInsuranceKey: _propTypes2.default.string,
	  skipInsurance: _propTypes2.default.bool
	};
	
	var InsurancesInfo = function InsurancesInfo(_ref2) {
	  var flowType = _ref2.flowType,
	      toDoTaskData = _ref2.toDoTaskData,
	      userId = _ref2.userId,
	      userName = _ref2.userName,
	      withSelfPayEnding = _ref2.withSelfPayEnding;
	
	  var _useIntl2 = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl2.formatMessage;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      openIds = _useState2[0],
	      setOpenIds = _useState2[1];
	
	  var additionalInsurances = (0, _reactRedux.useSelector)(_getPatientInsurancesList.selectPatientInsurancesList);
	
	  var error = (0, _reactRedux.useSelector)(_selectors.selectInsuranceLatestCheckError);
	
	  var isPlanNotListedSelected = (0, _reactRedux.useSelector)(_common.selectPaperworkIsPlanNotListedSelected);
	
	  var errorCode = (0, _get2.default)(error, 'code');
	
	  var notFoundErrorCode = errorCode === _errorCodes.ERROR_CODES.RECORD_NOT_FOUND;
	
	  var patientInsurance = (0, _useGetPatientMainInsuranceInfo2.default)({
	    flowType: flowType,
	    toDoTaskData: toDoTaskData
	  });
	
	  var _useIsAdditionalInsur = (0, _useIsAdditionalInsurancesEnabledAndMaxNumber2.default)(),
	      isAdditionalInsurancesEnabled = _useIsAdditionalInsur.isAdditionalInsurancesEnabled;
	
	  var isPaperworkFlowType = (0, _utils.checkIsPaperworkFlow)(flowType);
	
	  var skipInsurance = patientInsurance.skipInsurance;
	
	
	  var showNoInsuranceTitle = !skipInsurance && notFoundErrorCode && !isPaperworkFlowType;
	
	  var showInsuranceInfo = !skipInsurance && !notFoundErrorCode || isPaperworkFlowType && isPlanNotListedSelected;
	
	  var showSkipInsuranceTitle = skipInsurance && !isPlanNotListedSelected;
	
	  var showAdditionalInsuranceSection = !skipInsurance && isAdditionalInsurancesEnabled;
	
	  var haveInsuranceCheckboxLabel = (0, _useGetHaveInsuranceLabel2.default)({
	    formatMessage: formatMessage,
	    targetUserName: userName,
	    targetUserId: userId,
	    withSelfPayEnding: withSelfPayEnding
	  });
	
	  var additionalInsuranceTitle = formatMessage({
	    id: 'profile.insurance.additional'
	  });
	
	  var noInsuranceTitle = formatMessage({
	    id: 'profile.section.insurance.empty'
	  });
	
	  var hasAdditionalInsurances = Boolean(additionalInsurances.length);
	
	  var toggleSection = function toggleSection(id) {
	    setOpenIds(function (prev) {
	      return prev.includes(id) ? prev.filter(function (openId) {
	        return openId !== id;
	      }) : [].concat((0, _toConsumableArray3.default)(prev), [id]);
	    });
	  };
	
	  return _react2.default.createElement(
	    'section',
	    { className: _index2.default.section },
	    showNoInsuranceTitle && _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      noInsuranceTitle
	    ),
	    showSkipInsuranceTitle && _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      haveInsuranceCheckboxLabel
	    ),
	    showInsuranceInfo && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(InsuranceSection, {
	        insurance: patientInsurance,
	        flowType: flowType,
	        isAdditionalInsurance: false,
	        skipInsurance: skipInsurance || isPlanNotListedSelected
	      }),
	      showAdditionalInsuranceSection && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.additionalInsurancesTitle },
	          additionalInsuranceTitle
	        ),
	        !hasAdditionalInsurances && _react2.default.createElement(
	          'div',
	          { className: _index2.default.withoutAdditionalInsurances },
	          _strings.DEFAULT_EMPTY_VALUE
	        ),
	        additionalInsurances.map(function (insurance) {
	          var isOpen = openIds.includes(insurance.id);
	
	          return _react2.default.createElement(
	            _react.Fragment,
	            { key: insurance.id },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: _index2.default.toggleBtn,
	                onClick: function onClick() {
	                  return toggleSection(insurance.id);
	                },
	                'aria-expanded': isOpen,
	                'aria-controls': 'insurance-section-' + insurance.id
	              },
	              additionalInsuranceTitle,
	              _react2.default.createElement(_Icon2.default, {
	                size: 12,
	                name: 'arrow-down-forms',
	                className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _index2.default.icon, isOpen)),
	                style: ICON_STYLES
	              })
	            ),
	            isOpen && _react2.default.createElement(InsuranceSection, {
	              insurance: insurance,
	              flowType: flowType,
	              isAdditionalInsurance: true,
	              additionalInsuranceKey: 'insurance-section-' + insurance.id
	            }),
	            _react2.default.createElement('div', { className: _index2.default.divider })
	          );
	        })
	      )
	    )
	  );
	};
	
	InsurancesInfo.propTypes = {
	  flowType: _propTypes2.default.string.isRequired,
	  toDoTaskData: _propTypes2.default.object,
	  userId: _propTypes2.default.number,
	  userName: _propTypes2.default.string,
	  withSelfPayEnding: _propTypes2.default.bool
	};
	
	exports.default = (0, _react.memo)(InsurancesInfo);

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MobilePhone = MobilePhone;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _countryCode = __webpack_require__(1322);
	
	var _constants = __webpack_require__(17);
	
	var _index = __webpack_require__(45);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _useMobileInput2 = __webpack_require__(3412);
	
	var _index3 = __webpack_require__(5020);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MobilePhone(_ref) {
	  var name = _ref.name,
	      label = _ref.label,
	      onChange = _ref.onChange,
	      placeholder = _ref.placeholder,
	      disabled = _ref.disabled,
	      value = _ref.value,
	      phoneCode = _ref.phoneCode,
	      onBlur = _ref.onBlur,
	      className = _ref.className,
	      dirty = _ref.dirty,
	      formatMessage = _ref.formatMessage;
	
	  var _useMobileInput = (0, _useMobileInput2.useMobileInput)(value, formatMessage, phoneCode),
	      codeControl = _useMobileInput.codeControl,
	      phoneControl = _useMobileInput.phoneControl,
	      validation = _useMobileInput.validation;
	
	  var options = codeControl.options,
	      code = codeControl.code,
	      handleCodeChange = codeControl.handleCodeChange,
	      handleSetCountryIsoCode = codeControl.handleSetCountryIsoCode;
	  var handlePhoneChange = phoneControl.handlePhoneChange,
	      phone = phoneControl.phone;
	  var limit = validation.limit,
	      validate = validation.validate;
	
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  (0, _react.useEffect)(function () {
	    dispatch(_countryCode.actions.set(handleSetCountryIsoCode(code)));
	  }, []);
	
	  var onPhoneChange = function onPhoneChange(phoneValue) {
	    handlePhoneChange(phoneValue);
	    var errors = validate(phoneValue);
	    var fullPhone = code + phoneValue;
	    onChange(fullPhone, dirty, errors);
	  };
	
	  var onCodeChange = function onCodeChange(option) {
	    if (option.value === code) return;
	    dispatch(_countryCode.actions.set(handleSetCountryIsoCode(option.value)));
	    handleCodeChange(option);
	    onPhoneChange('');
	  };
	
	  var handleBlur = function handleBlur() {
	    if (!onBlur) return;
	
	    var errors = validate(phone);
	    onBlur(phone, true, errors);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_index4.default.root, className) },
	    _react2.default.createElement(
	      'span',
	      { className: _index4.default.label },
	      label || placeholder
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index4.default.wrapper },
	      _react2.default.createElement(_SelectCustom2.default, {
	        className: _index4.default.select,
	        onChange: onCodeChange,
	        options: options,
	        value: code
	      }),
	      _react2.default.createElement(_index2.default, {
	        className: _index4.default.input,
	        name: name,
	        type: 'number',
	        placeholder: placeholder,
	        onChange: onPhoneChange,
	        disabled: disabled,
	        limit: limit,
	        onBlur: handleBlur,
	        value: phone
	      })
	    )
	  );
	}
	
	MobilePhone.defaultProps = {
	  name: _constants.FIELDS_TYPE.MOBILE_PHONE
	};
	
	MobilePhone.propTypes = {
	  name: PropTypes.string,
	  placeholder: PropTypes.string,
	  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  formatMessage: PropTypes.func,
	  onChange: PropTypes.func,
	  label: PropTypes.string,
	  disabled: PropTypes.bool,
	  dirty: PropTypes.bool,
	  onBlur: PropTypes.func,
	  className: PropTypes.string,
	  phoneCode: PropTypes.string
	};

/***/ }),
/* 777 */,
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _recompose = __webpack_require__(22);
	
	var _includes = __webpack_require__(324);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _isPlainObject = __webpack_require__(248);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isArray = __webpack_require__(96);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _DefinitionList = __webpack_require__(1739);
	
	var _DefinitionList2 = _interopRequireDefault(_DefinitionList);
	
	var _ImageUploader = __webpack_require__(1185);
	
	var _ImageUploader2 = _interopRequireDefault(_ImageUploader);
	
	var _PasswordInput = __webpack_require__(335);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _DatePickerCustom = __webpack_require__(234);
	
	var _DatePickerCustom2 = _interopRequireDefault(_DatePickerCustom);
	
	var _constants = __webpack_require__(17);
	
	var _handleDOB = __webpack_require__(909);
	
	var _handleDOB2 = _interopRequireDefault(_handleDOB);
	
	var _getPhone = __webpack_require__(187);
	
	var _strings = __webpack_require__(15);
	
	var _formFields = __webpack_require__(38);
	
	var _TimePickerRange = __webpack_require__(3887);
	
	var _phoneFormatter = __webpack_require__(4204);
	
	var _utils = __webpack_require__(797);
	
	var _MobilePhone = __webpack_require__(776);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MedicationSelect = __webpack_require__(3595);
	
	var _MedicationSelect2 = _interopRequireDefault(_MedicationSelect);
	
	var _PreferredPharmacy = __webpack_require__(3605);
	
	var _PreferredPharmacy2 = _interopRequireDefault(_PreferredPharmacy);
	
	var _makePharmacyTitle = __webpack_require__(311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOCAL_FIELDS_TYPES = (0, _extends3.default)({}, _constants.FIELDS_TYPE, {
	  MEDICATION_SELECT: 'medication',
	  PHARMACY: 'pharmacy'
	});
	
	var Field = function (_PureComponent) {
	  (0, _inherits3.default)(Field, _PureComponent);
	
	  function Field() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Field);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Field.__proto__ || (0, _getPrototypeOf2.default)(Field)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      dirty: false
	    }, _this.getValueFromItem = function (item) {
	      return item && (0, _isPlainObject2.default)(item) ? item.value : item;
	    }, _this.notLastItemInComplexValue = function (values, currentIndex) {
	      return values.slice(currentIndex + 1).map(_this.getValueFromItem).some(function (i) {
	        return i;
	      });
	    }, _this.getValue = function (value, type, fieldName) {
	      var separator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ', ';
	      var src = arguments[4];
	      var _this$props = _this.props,
	          children = _this$props.children,
	          formatMessage = _this$props.intl.formatMessage,
	          defaultEmptyValue = _this$props.defaultEmptyValue,
	          editMode = _this$props.editMode;
	      var options = children.options,
	          disabledText = children.disabledText,
	          transformValueFromOptions = children.transformValueFromOptions;
	
	      var shownValue = [];
	      var emptyState = defaultEmptyValue || _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE_FIELDSET_EMPTY);
	
	      if (type !== _constants.FIELDS_TYPE.IMAGE && !value) return emptyState;
	
	      if (type === _constants.FIELDS_TYPE.CUSTOM_TIME_PICKER) return (0, _utils.formatTimeRangeView)(value);
	
	      if (type === LOCAL_FIELDS_TYPES.PHARMACY) {
	        if (typeof value === 'string') return value;
	        return (0, _makePharmacyTitle.makePharmacyTitle)(value, true);
	      }
	
	      if ((0, _isArray2.default)(value)) {
	        if (!(0, _size2.default)(value)) return emptyState;
	
	        value.forEach(function (item, i, array) {
	          var currentValue = _this.getValueFromItem(item);
	
	          if (transformValueFromOptions && options) {
	            var matchedOption = options.find(function (opt) {
	              return opt.value === currentValue;
	            });
	
	            currentValue = matchedOption ? matchedOption.label : currentValue;
	          }
	
	          if (currentValue) {
	            shownValue.push(currentValue);
	
	            if (_this.notLastItemInComplexValue(array, i)) {
	              shownValue.push(separator || item.separator);
	            }
	          }
	        });
	      } else if (fieldName === _formFields.PROFILE_FIELDS_TYPES.DOB) {
	        return (0, _handleDOB2.default)(value, formatMessage);
	      } else if (fieldName === _formFields.PROFILE_FIELDS_TYPES.AGE) {
	        return (0, _handleDOB.handleAge)(value, formatMessage);
	      } else if (type === _constants.FIELDS_TYPE.SELECT && (0, _size2.default)(options)) {
	        // show label instead of value
	        var rawVal = options.find(function (item) {
	          return item.value === value;
	        });
	        return rawVal && rawVal.label ? rawVal.label : value;
	      } else if (fieldName === _formFields.PROFILE_FIELDS_TYPES.EMAIL) {
	        return value || emptyState;
	      } else if (fieldName === _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER) {
	        return value ? (0, _getPhone.getPhoneWithoutUSCode)((0, _phoneFormatter.formatPhone)(value)) : emptyState;
	      } else if (type === _constants.FIELDS_TYPE.IMAGE) {
	        return _react2.default.createElement(_ImageUploader2.default, {
	          disabled: !editMode,
	          label: disabledText,
	          src: src,
	          name: fieldName
	        });
	      } else {
	        return value;
	      }
	
	      return shownValue.join('');
	    }, _this.handleBlur = function () {
	      var onBlur = _this.props.onBlur;
	
	
	      if (onBlur) onBlur.apply(undefined, arguments);
	      _this.setState({ dirty: true });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Field, [{
	    key: 'render',
	    value: function render() {
	      var dirty = this.state.dirty;
	      var _props = this.props,
	          children = _props.children,
	          editMode = _props.editMode,
	          _onChange = _props.onChange,
	          fieldStyle = _props.fieldStyle,
	          className = _props.className,
	          defaultEmptyValue = _props.defaultEmptyValue,
	          formatMessage = _props.intl.formatMessage;
	      var name = children.name,
	          src = children.src,
	          value = children.value,
	          disabled = children.disabled,
	          separated = children.separated,
	          type = children.type,
	          multi = children.multi,
	          options = children.options,
	          fullWidth = children.fullWidth,
	          hintText = children.hintText,
	          fieldName = children.fieldName,
	          separator = children.separator,
	          text = children.text,
	          limit = children.limit,
	          onCheckBeforeDelete = children.onCheckBeforeDelete,
	          id = children.id,
	          placeholder = children.placeholder,
	          shouldClearWhenOnFocus = children.shouldClearWhenOnFocus,
	          transformValue = children.transformValue,
	          hideEllipsis = children.hideEllipsis,
	          withManualInputDob = children.withManualInputDob;
	
	      var isImageField = type === _constants.FIELDS_TYPE.IMAGE;
	      var fieldValue = isImageField ? src : value;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          styleName: (0, _classnames2.default)(fullWidth ? 'fieldWrapperFull' : 'fieldWrapper', {
	            'fieldWrapper--separated': editMode && separated,
	            mt0: className === 'pharmacy-phone'
	          }),
	          className: 'user-profile-field-' + className
	        },
	        !editMode ? Boolean(defaultEmptyValue) || Boolean(fieldValue) ? _react2.default.createElement(_DefinitionList2.default, {
	          styleName: 'field',
	          definition: name,
	          hintText: hintText,
	          hideEllipsis: hideEllipsis,
	          description: this.getValue(value, type, fieldName, separator, src),
	          multiline: true,
	          hasOpacity: !isImageField,
	          descriptionRenderer: transformValue
	        }) : null : _react2.default.createElement(
	          'div',
	          {
	            styleName: (0, _classnames2.default)('field', { 'field--separated': separated }),
	            style: fieldStyle
	          },
	          type === LOCAL_FIELDS_TYPES.SELECT ? _react2.default.createElement(_SelectCustom2.default, {
	            multi: multi,
	            options: options,
	            placeholder: name,
	            label: name,
	            value: value,
	            onCheckBeforeDelete: onCheckBeforeDelete,
	            onChange: function onChange(val) {
	              return _onChange(val, dirty);
	            },
	            onBlur: this.handleBlur,
	            disabled: disabled
	          }) : type === LOCAL_FIELDS_TYPES.MEDICATION_SELECT ? _react2.default.createElement(_MedicationSelect2.default, {
	            multi: multi,
	            placeholder: name,
	            label: name,
	            value: value,
	            onCheckBeforeDelete: onCheckBeforeDelete,
	            onChange: function onChange(val) {
	              return _onChange(val, dirty);
	            },
	            onBlur: this.handleBlur
	          }) : type === LOCAL_FIELDS_TYPES.DATE ? _react2.default.createElement(_DatePickerCustom2.default, {
	            label: name,
	            value: this.dobValue,
	            onChange: _onChange,
	            maxDate: new Date(),
	            onBlur: this.handleBlur,
	            disabled: disabled,
	            withManualInputDob: withManualInputDob
	          }) : type === LOCAL_FIELDS_TYPES.IMAGE ? _react2.default.createElement(_ImageUploader2.default, {
	            label: text,
	            title: name,
	            src: src,
	            name: fieldName,
	            onChange: function onChange(val) {
	              return _onChange(val);
	            },
	            id: id,
	            maxFileSize: limit
	          }) : type === LOCAL_FIELDS_TYPES.PASSWORD ? _react2.default.createElement(_PasswordInput2.default, {
	            disabled: disabled,
	            autoresize: true,
	            value: value,
	            placeholder: placeholder || name,
	            label: name,
	            onChange: function onChange(num, val) {
	              return _onChange(val, dirty);
	            },
	            onBlur: this.handleBlur,
	            shouldClearWhenOnFocus: shouldClearWhenOnFocus,
	            limit: limit
	          }) : type === LOCAL_FIELDS_TYPES.MOBILE_PHONE ? _react2.default.createElement(_MobilePhone.MobilePhone, {
	            disabled: disabled,
	            value: value,
	            placeholder: name,
	            dirty: dirty,
	            label: name,
	            formatMessage: formatMessage,
	            onBlur: this.handleBlur,
	            onChange: _onChange
	          }) : type === LOCAL_FIELDS_TYPES.CUSTOM_TIME_PICKER ? _react2.default.createElement(_TimePickerRange.TimePickerRange, {
	            value: value || '',
	            name: name,
	            onChange: function onChange(val) {
	              return _onChange(val, dirty);
	            },
	            label: name,
	            formatMessage: formatMessage
	          }) : type === LOCAL_FIELDS_TYPES.PHARMACY ? _react2.default.createElement(_PreferredPharmacy2.default, {
	            value: value,
	            placeholder: name,
	            label: name,
	            onChange: function onChange(val) {
	              return _onChange(val, dirty);
	            },
	            onHandleBlur: this.handleBlur
	          }) : _react2.default.createElement(_TextInput2.default, {
	            disabled: disabled,
	            autoresize: true,
	            value: value,
	            placeholder: name,
	            label: name,
	            type: (0, _includes2.default)(['date', 'email', 'number'], type) ? type : 'text',
	            textarea: type === LOCAL_FIELDS_TYPES.TEXTAREA,
	            onChange: function onChange(val) {
	              return _onChange(val, dirty);
	            },
	            onBlur: this.handleBlur,
	            limit: limit
	          })
	        )
	      );
	    }
	  }, {
	    key: 'dobValue',
	    get: function get() {
	      var value = this.props.children.value;
	
	
	      return (0, _moment2.default)(value, 'MM-DD-YYYY').toDate();
	    }
	
	    // helper for displaying correct text in view mode
	
	  }]);
	  return Field;
	}(_react.PureComponent);
	
	Field.propTypes = {
	  children: _propTypes2.default.object,
	  editMode: _propTypes2.default.bool,
	  onChange: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  fieldStyle: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  defaultEmptyValue: _propTypes2.default.string
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(Field);

/***/ }),
/* 779 */,
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _strings = __webpack_require__(15);
	
	var _SequentialSurvey = __webpack_require__(1800);
	
	var _SequentialSurvey2 = _interopRequireDefault(_SequentialSurvey);
	
	var _constants = __webpack_require__(17);
	
	var _ExpandableListItem = __webpack_require__(285);
	
	var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);
	
	var _getSpecification2 = __webpack_require__(361);
	
	var _getSpecification3 = _interopRequireDefault(_getSpecification2);
	
	var _preVisitForm = __webpack_require__(288);
	
	var _enhance = __webpack_require__(3723);
	
	var _index = __webpack_require__(2267);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SequentialSurveyPopup = function SequentialSurveyPopup(_ref) {
	  var onClose = _ref.onClose,
	      targetUserId = _ref.targetUserId,
	      assignmentId = _ref.assignmentId,
	      upcomingSurvey = _ref.upcomingSurvey,
	      formatMessage = _ref.formatMessage,
	      clearUpcomingSurvey = _ref.clearUpcomingSurvey,
	      isUpcomingSurveyRejected = _ref.isUpcomingSurveyRejected,
	      sendUpcomingSurveyAnswers = _ref.sendUpcomingSurveyAnswers,
	      sendUpcomingSurveyProceed = _ref.sendUpcomingSurveyProceed,
	      sendUpcomingSurveyCancelFilling = _ref.sendUpcomingSurveyCancelFilling;
	
	  var status = (0, _get2.default)(upcomingSurvey, 'status');
	  var surveyAssignmentId = (0, _get2.default)(upcomingSurvey, 'assignmentId');
	  var intervieweeName = (0, _get2.default)(upcomingSurvey, 'interviewee.displayableName');
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      progress = _useState2[0],
	      setProgress = _useState2[1];
	
	  var _getSpecification = (0, _getSpecification3.default)(upcomingSurvey, formatMessage, false),
	      expirationStatus = _getSpecification.status,
	      description = _getSpecification.description,
	      heading = _getSpecification.heading,
	      name = _getSpecification.name;
	
	  var userAppointment = (0, _get2.default)(upcomingSurvey, 'userAppointment', null);
	  var list = (0, _preVisitForm.convertPreVisitFormData)(formatMessage, userAppointment);
	
	  var succeed = (0, _get2.default)(upcomingSurvey, 'succeed');
	
	  (0, _react.useEffect)(function () {
	    if (isUpcomingSurveyRejected && onClose) onClose();
	    if (assignmentId) {
	      sendUpcomingSurveyProceed({
	        targetUserId: targetUserId,
	        assignmentId: assignmentId
	      });
	    }
	  }, [assignmentId, isUpcomingSurveyRejected]);
	
	  var handleSubmit = function handleSubmit(_ref2) {
	    var id = _ref2.id,
	        value = _ref2.value;
	
	    var body = {
	      assignmentId: surveyAssignmentId,
	      status: _constants.SURVEYS_STATUS_TYPE.IN_PROGRESS,
	      token: (0, _get2.default)(upcomingSurvey, 'meta.token')
	    };
	
	    if (value) {
	      sendUpcomingSurveyAnswers((0, _extends3.default)({}, body, {
	        answers: {
	          question_id: id,
	          value: value
	        }
	      }));
	    }
	  };
	
	  var handleClose = function handleClose() {
	    if (status === _constants.SURVEYS_STATUS_TYPE.STARTED) {
	      sendUpcomingSurveyCancelFilling({
	        targetUserId: targetUserId,
	        assignmentId: assignmentId,
	        token: (0, _get2.default)(upcomingSurvey, 'meta.token')
	      });
	    }
	    clearUpcomingSurvey();
	    if (onClose) onClose();
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      width: 'medium',
	      overflowVisible: true,
	      onClose: handleClose,
	      dialogClassName: _index2.default.popup,
	      opened: Boolean(surveyAssignmentId),
	      paperClassName: _index2.default.paperClassName,
	      title: formatMessage(_strings.ACTIONS.survey.upcomingHeading, {
	        user: intervieweeName
	      })
	    },
	    succeed && surveyAssignmentId ? _react2.default.createElement(
	      _ExpandableListItem2.default,
	      {
	        locked: true,
	        key: assignmentId,
	        progress: progress,
	        'data-id': assignmentId,
	        header: {
	          expirationStatus: expirationStatus,
	          icon: 'up-surveys',
	          subtitle: heading,
	          title: name,
	          description: description,
	          list: list
	        }
	      },
	      _react2.default.createElement(_SequentialSurvey2.default, {
	        survey: upcomingSurvey,
	        onSubmit: handleSubmit,
	        setProgress: setProgress
	      })
	    ) : _react2.default.createElement(_Loader2.default, null)
	  );
	};
	
	SequentialSurveyPopup.propTypes = {
	  onClose: _propTypes2.default.func,
	  assignmentId: _propTypes2.default.number,
	  upcomingSurvey: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func.isRequired,
	  isUpcomingSurveyRejected: _propTypes2.default.bool,
	  targetUserId: _propTypes2.default.number.isRequired,
	  clearUpcomingSurvey: _propTypes2.default.func.isRequired,
	  sendUpcomingSurveyProceed: _propTypes2.default.func.isRequired,
	  sendUpcomingSurveyAnswers: _propTypes2.default.func.isRequired,
	  sendUpcomingSurveyCancelFilling: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(SequentialSurveyPopup);

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp2; /* eslint react/require-default-props: 0 */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(58);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _TermsContent = __webpack_require__(1807);
	
	var _TermsContent2 = _interopRequireDefault(_TermsContent);
	
	var _strings = __webpack_require__(15);
	
	var _chars = __webpack_require__(258);
	
	var _selectors = __webpack_require__(50);
	
	var _popup = __webpack_require__(76);
	
	var _index = __webpack_require__(2269);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    privacyList: (0, _selectors.privacyListSelector)(state),
	    sending: (0, _selectors.sendingPrivacySelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  toggleContent: _popup.actions.toggleContent
	};
	
	var TermsAndConditions = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(TermsAndConditions, _PureComponent);
	
	  function TermsAndConditions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TermsAndConditions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TermsAndConditions.__proto__ || (0, _getPrototypeOf2.default)(TermsAndConditions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      termsAndConditionsIsVisible: false,
	      type: ''
	    }, _this.handlePrivacyText = function (country) {
	      var _this$props = _this.props,
	          sending = _this$props.sending,
	          privacyList = _this$props.privacyList;
	
	      return !sending && privacyList.find(function (item) {
	        return (0, _lodash.get)(item, 'country') === country;
	      });
	    }, _this.handleClosePopup = function (e) {
	      var _this$props2 = _this.props,
	          toggleContent = _this$props2.toggleContent,
	          secondaryContent = _this$props2.secondaryContent;
	
	
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (secondaryContent) toggleContent();
	      _this.handleCloseBounded(false);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TermsAndConditions, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.handleCloseBounded = this.handleClose.bind(this);
	      this.handleTermsAndConditionsBtnClickBounded = this.handleTermsAndConditionsBtnClick.bind(this);
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose(termsAndConditionsIsVisible) {
	      this.setState({ termsAndConditionsIsVisible: termsAndConditionsIsVisible });
	    }
	  }, {
	    key: 'handleTermsAndConditionsBtnClick',
	    value: function handleTermsAndConditionsBtnClick(e, type) {
	      var _props = this.props,
	          toggleContent = _props.toggleContent,
	          secondaryContent = _props.secondaryContent;
	
	
	      e.preventDefault();
	      e.stopPropagation();
	
	      this.setState(function (prevState) {
	        if (secondaryContent) toggleContent();
	        return {
	          termsAndConditionsIsVisible: !prevState.termsAndConditionsIsVisible,
	          type: type
	        };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          acceptable = _props2.acceptable,
	          className = _props2.className,
	          formatMessage = _props2.intl.formatMessage,
	          country = _props2.country,
	          hasSeparator = _props2.hasSeparator,
	          _props2$onSelect = _props2.onSelect,
	          onSelect = _props2$onSelect === undefined ? function () {} : _props2$onSelect,
	          toggleContent = _props2.toggleContent,
	          secondaryContent = _props2.secondaryContent,
	          additionalStyles = _props2.additionalStyles,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['acceptable', 'className', 'intl', 'country', 'hasSeparator', 'onSelect', 'toggleContent', 'secondaryContent', 'additionalStyles']);
	      var _state = this.state,
	          type = _state.type,
	          termsAndConditionsIsVisible = _state.termsAndConditionsIsVisible;
	
	      var defaultPrivacy = this.handlePrivacyText('USA');
	      // TODO temporary privacyList contain only USA
	      var privacyText = defaultPrivacy;
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ className: className }, (0, _lodash.omit)(other, ['dispatch', 'privacyList', 'sending'])),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'checkboxWrapper' },
	          acceptable ? _react2.default.createElement('input', {
	            className: 'mr2',
	            id: 'acceptedPrivacyPolicy',
	            name: 'acceptedPrivacyPolicy',
	            value: true,
	            type: 'checkbox',
	            key: country,
	            onChange: function onChange(e) {
	              return onSelect(e.target.checked);
	            }
	          }) : null,
	          _react2.default.createElement(
	            'div',
	            { className: additionalStyles },
	            acceptable && _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.actions.tnc.textTitle),
	            _chars.SPACE,
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                children: _strings.AUTH.actions.tnc.textLink,
	                onClick: function onClick(e) {
	                  return _this2.handleTermsAndConditionsBtnClickBounded(e, 'privacy');
	                },
	                className: ' ml1 mr2 dib',
	                styleName: (0, _classnames2.default)('link', {
	                  'link--acceptable': acceptable
	                })
	              },
	              _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.privacy)
	            ),
	            hasSeparator && _react2.default.createElement(
	              'span',
	              { styleName: 'text', className: 'mr2 dib' },
	              formatMessage(_strings.DIALOG_TITLE.and)
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                children: _strings.AUTH.actions.tnc.textLink,
	                onClick: function onClick(e) {
	                  return _this2.handleTermsAndConditionsBtnClickBounded(e, 'terms');
	                },
	                styleName: (0, _classnames2.default)('link', {
	                  'link--acceptable': acceptable
	                })
	              },
	              _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.actions.tnc.textLink)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Popup2.default,
	          {
	            opened: termsAndConditionsIsVisible,
	            onClose: this.handleClosePopup,
	            title: type === 'terms' ? formatMessage(_strings.COMMON.terms) : formatMessage(_strings.COMMON.privacy),
	            width: 'medium'
	          },
	          _react2.default.createElement(_TermsContent2.default, {
	            content: type === 'terms' ? privacyText.terms : privacyText.privacyPolicy
	          })
	        )
	      );
	    }
	  }]);
	  return TermsAndConditions;
	}(_react.PureComponent), _class2.propTypes = {
	  acceptable: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  privacyList: _propTypes2.default.array,
	  country: _propTypes2.default.string,
	  sending: _propTypes2.default.bool,
	  hasSeparator: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func,
	  toggleContent: _propTypes2.default.func,
	  secondaryContent: _propTypes2.default.bool,
	  additionalStyles: _propTypes2.default.string
	}, _temp2)) || _class) || _class) || _class);
	exports.default = TermsAndConditions;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(2273);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProgressBar(_ref) {
	  var progress = _ref.progress,
	      height = _ref.height,
	      withTransition = _ref.withTransition,
	      transitionDuration = _ref.transitionDuration;
	
	  var style = (0, _extends3.default)({
	    width: progress + '%'
	  }, transitionDuration && { transitionDuration: transitionDuration });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.bar, style: { height: height } },
	    _react2.default.createElement('div', {
	      className: (0, _classnames2.default)(_styles2.default.line, (0, _defineProperty3.default)({}, _styles2.default.lineWithTransition, withTransition)),
	      style: style
	    })
	  );
	}
	
	ProgressBar.propTypes = {
	  height: PropTypes.number,
	  progress: PropTypes.number,
	  withTransition: PropTypes.bool,
	  transitionDuration: PropTypes.string
	};
	
	exports.default = ProgressBar;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(1626);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _overrideReactSelectStyles = __webpack_require__(1935);
	
	var _MenuList = __webpack_require__(1819);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _OptionLabel = __webpack_require__(1820);
	
	var _OptionLabel2 = _interopRequireDefault(_OptionLabel);
	
	var _stylesModule = __webpack_require__(5178);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadingMessage = function LoadingMessage() {
	  return null;
	};
	
	/**
	 * @typedef {Object} SelectOption
	 * @property {string|number} value
	 * @property {string} label
	 */
	
	/**
	 * @typedef {'input-change'|'menu-close'|'set-value'|'clear'} InputAction
	 */
	
	/**
	 * @typedef {(inputValue: string, meta: { action: InputAction }) => void} OnInputChange
	 */
	
	/**
	 * @typedef {(option: SelectOption|null) => void} OnChange
	 */
	
	/**
	 * @typedef {Object} AsyncPaginatedSelectProps
	 * @property {OnInputChange=} handleInputChange
	 * @property {OnChange=} onChange
	 * @property {SelectOption[]=} options
	 * @property {SelectOption|null=} value
	 * @property {()=>void=} onMenuScrollToBottom
	 * @property {boolean=} isLoading
	 * @property {string=} label
	 * @property {string=} placeholder
	 */
	
	/**
	 * @param {AsyncPaginatedSelectProps} props
	 */
	var AsyncPaginatedSelect = function AsyncPaginatedSelect(_ref) {
	  var handleInputChange = _ref.handleInputChange,
	      isLoading = _ref.isLoading,
	      label = _ref.label,
	      onChange = _ref.onChange,
	      onMenuScrollToBottom = _ref.onMenuScrollToBottom,
	      _ref$options = _ref.options,
	      options = _ref$options === undefined ? [] : _ref$options,
	      placeholder = _ref.placeholder,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['handleInputChange', 'isLoading', 'label', 'onChange', 'onMenuScrollToBottom', 'options', 'placeholder']);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    label && _react2.default.createElement(
	      'label',
	      { className: _stylesModule2.default.label },
	      label
	    ),
	    _react2.default.createElement(_reactSelect2.default, (0, _extends3.default)({
	      components: { MenuList: _MenuList2.default, LoadingMessage: LoadingMessage },
	      filterOption: null,
	      isLoading: isLoading,
	      menuPlacement: 'auto',
	      onChange: onChange,
	      onInputChange: handleInputChange,
	      onMenuScrollToBottom: onMenuScrollToBottom,
	      options: options,
	      placeholder: placeholder,
	      styles: _overrideReactSelectStyles.OverrideReactSelectStyles,
	      formatOptionLabel: _OptionLabel2.default
	    }, other))
	  );
	};
	
	AsyncPaginatedSelect.propTypes = {
	  handleInputChange: _propTypes2.default.func,
	  isLoading: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  onMenuScrollToBottom: _propTypes2.default.func,
	  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    label: _propTypes2.default.string
	  })),
	  placeholder: _propTypes2.default.string,
	  value: _propTypes2.default.shape({
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    label: _propTypes2.default.string
	  })
	};
	
	exports.default = AsyncPaginatedSelect;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(114);
	
	var _context = __webpack_require__(1822);
	
	var _helpers = __webpack_require__(289);
	
	var _useChartFormats = __webpack_require__(1824);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Provider = _context.ChartContext.Provider;
	
	
	var ChartProvider = function ChartProvider(_ref) {
	  var extend = _ref.extend,
	      children = _ref.children,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      chart = _useState2[0],
	      setChart = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(extend.isModal ? _constants.PERIOD.DAY : _constants.PERIOD.MONTH),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      period = _useState4[0],
	      setPeriod = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      activeSource = _useState6[0],
	      setActiveSource = _useState6[1];
	
	  var formats = (0, _useChartFormats.useChartFormats)({ formatMessage: formatMessage });
	
	  var sources = (0, _react.useMemo)(function () {
	    return (0, _helpers.getVisibleChartSources)(chart);
	  }, [chart]);
	
	  return _react2.default.createElement(
	    Provider,
	    {
	      value: (0, _extends3.default)({}, extend, {
	        chart: chart,
	        period: period,
	        formats: formats,
	        sources: sources,
	        setChart: setChart,
	        setPeriod: setPeriod,
	        activeSource: activeSource,
	        setActiveSource: setActiveSource
	      })
	    },
	    children
	  );
	};
	
	ChartProvider.propTypes = {
	  extend: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(ChartProvider);

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _noop = __webpack_require__(465);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _hooks = __webpack_require__(144);
	
	var _ChartHeader = __webpack_require__(3823);
	
	var _ChartHeader2 = _interopRequireDefault(_ChartHeader);
	
	var _ChartCanvas = __webpack_require__(3821);
	
	var _ChartCanvas2 = _interopRequireDefault(_ChartCanvas);
	
	var _ChartLegend = __webpack_require__(3825);
	
	var _ChartLegend2 = _interopRequireDefault(_ChartLegend);
	
	var _styles = __webpack_require__(5188);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _ChartHeaderFixed = __webpack_require__(3824);
	
	var _ChartHeaderFixed2 = _interopRequireDefault(_ChartHeaderFixed);
	
	var _period = __webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartWrapper = function ChartWrapper(_ref) {
	  var footer = _ref.footer,
	      loading = _ref.loading,
	      setConfig = _ref.setConfig,
	      isModal = _ref.isModal,
	      _ref$onLoad = _ref.onLoad,
	      onLoad = _ref$onLoad === undefined ? _noop2.default : _ref$onLoad,
	      _ref$hasExternalHeade = _ref.hasExternalHeader,
	      hasExternalHeader = _ref$hasExternalHeade === undefined ? false : _ref$hasExternalHeade;
	
	  var _useChartContext = (0, _hooks.useChartContext)(),
	      period = _useChartContext.period,
	      activeSource = _useChartContext.activeSource;
	
	  (0, _react.useEffect)(function () {
	    onLoad({ period: period });
	  }, [period]);
	
	  var config = (0, _react.useMemo)(function () {
	    return setConfig({ period: period });
	  }, [loading]);
	  var nothing = (0, _isEmpty2.default)((0, _get2.default)(config, 'data.datasets', [])) || loading;
	  var isQuarterOrYear = [_period.PERIOD.QUARTER, _period.PERIOD.YEAR].includes(period);
	
	  var props = {
	    config: config,
	    loading: loading,
	    nothing: nothing,
	    activeSource: activeSource,
	    isQuarterOrYear: isQuarterOrYear
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.container },
	    !hasExternalHeader && isModal && _react2.default.createElement(_ChartHeaderFixed2.default, props),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.wrapper },
	      !hasExternalHeader && !isModal && _react2.default.createElement(_ChartHeader2.default, props),
	      _react2.default.createElement(_ChartCanvas2.default, props),
	      _react2.default.createElement(_ChartLegend2.default, props)
	    ),
	    footer && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.footer },
	      footer
	    )
	  );
	};
	
	ChartWrapper.propTypes = {
	  noTabs: _propTypes2.default.bool,
	  onLoad: _propTypes2.default.func,
	  footer: _propTypes2.default.node,
	  loading: _propTypes2.default.bool,
	  isModal: _propTypes2.default.bool,
	  setConfig: _propTypes2.default.func,
	  hasExternalHeader: _propTypes2.default.bool
	};
	
	exports.default = ChartWrapper;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _noop = __webpack_require__(465);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _hooks = __webpack_require__(144);
	
	var _helpers = __webpack_require__(289);
	
	var _constants = __webpack_require__(114);
	
	var _styles = __webpack_require__(5189);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HistoryWrapper = function HistoryWrapper(_ref) {
	  var unit = _ref.unit,
	      onLoad = _ref.onLoad,
	      loading = _ref.loading,
	      onClick = _ref.onClick,
	      isModal = _ref.isModal,
	      _ref$data = _ref.data,
	      data = _ref$data === undefined ? [] : _ref$data,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useChartContext = (0, _hooks.useChartContext)(),
	      mark = _useChartContext.mark,
	      formats = _useChartContext.formats,
	      _useChartContext$conv = _useChartContext.converter,
	      converter = _useChartContext$conv === undefined ? _noop2.default : _useChartContext$conv,
	      shouldConvertToFahrenheit = _useChartContext.shouldConvertToFahrenheit;
	
	  var list = (0, _react.useMemo)(function () {
	    return (0, _helpers.mapHistoryList)(data, { unit: unit }, isModal);
	  }, [data, unit, isModal]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'ul',
	      { className: (0, _classnames2.default)(_styles2.default.history, (0, _defineProperty3.default)({}, _styles2.default.modal, isModal)) },
	      list.map(function (_ref2) {
	        var date = _ref2.date,
	            source = _ref2.source,
	            values = _ref2.values;
	
	        var handleClick = function handleClick() {
	          if (onClick) onClick({ date: date });
	        };
	
	        var clickable = onClick && {
	          onClick: handleClick,
	          'aria-hidden': true
	        };
	
	        return _react2.default.createElement(
	          'li',
	          (0, _extends3.default)({}, clickable, {
	            key: source + date,
	            className: (0, _classnames2.default)(_styles2.default.item, (0, _defineProperty3.default)({}, _styles2.default.pure, isModal))
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              converter.func(values, shouldConvertToFahrenheit)
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: (0, _classnames2.default)(_styles2.default.sub, _styles2.default.light) },
	              mark
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.info },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.sub },
	              ['day'].includes(unit) ? (0, _moment2.default)(date).calendar(null, _constants.HISTORY_DATE_FORMAT) : (0, _moment2.default)(date).format('LT')
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: (0, _classnames2.default)(_styles2.default.sub, _styles2.default.light) },
	              formats[source]
	            )
	          )
	        );
	      })
	    ),
	    onLoad && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.load },
	      loading && _react2.default.createElement(_Loader2.default, { className: _styles2.default.loader }),
	      !loading && _react2.default.createElement(
	        'div',
	        { 'aria-hidden': true, onClick: onLoad },
	        formatMessage({ id: 'patient.healthboard.list.loadMore' })
	      )
	    )
	  );
	};
	
	HistoryWrapper.propTypes = {
	  data: _propTypes2.default.array,
	  unit: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  loading: _propTypes2.default.bool,
	  isModal: _propTypes2.default.bool,
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(HistoryWrapper);

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(5190);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfoWrapper = function InfoWrapper(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.header },
	      _react2.default.createElement(
	        'h3',
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.subtitle },
	        subtitle
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.content },
	      children
	    )
	  );
	};
	
	InfoWrapper.propTypes = {
	  title: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  subtitle: _propTypes2.default.string
	};
	
	exports.default = InfoWrapper;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noop = __webpack_require__(465);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _styles = __webpack_require__(5191);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ModalWrapper = function ModalWrapper(_ref) {
	  var open = _ref.open,
	      title = _ref.title,
	      children = _ref.children,
	      _ref$onClose = _ref.onClose,
	      onClose = _ref$onClose === undefined ? _noop2.default : _ref$onClose;
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      title: title,
	      opened: open,
	      overflowVisible: true,
	      withoutAdaptive: true,
	      onClose: onClose,
	      mobileFullScreen: false
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.modal },
	      children
	    )
	  );
	};
	
	ModalWrapper.propTypes = {
	  open: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  onClose: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	exports.default = ModalWrapper;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tooltip = __webpack_require__(3841);
	
	Object.defineProperty(exports, 'TOOLTIP_VERTICAL_LINE', {
	  enumerable: true,
	  get: function get() {
	    return _tooltip.TOOLTIP_VERTICAL_LINE;
	  }
	});

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MenuItem = __webpack_require__(3856);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(_ref) {
	  var className = _ref.className,
	      items = _ref.items,
	      onSelect = _ref.onSelect;
	
	  var handleSelect = function handleSelect(e, clickHandler) {
	    e.preventDefault();
	    e.stopPropagation();
	
	    if (onSelect) onSelect();
	    if (clickHandler) clickHandler();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    items.map(function (_ref2, i) {
	      var active = _ref2.active,
	          icon = _ref2.icon,
	          iconSize = _ref2.iconSize,
	          _onClick = _ref2.onClick,
	          text = _ref2.text,
	          danger = _ref2.danger,
	          borderTop = _ref2.borderTop,
	          id = _ref2.id,
	          submenu = _ref2.submenu;
	      return _react2.default.createElement(_MenuItem2.default, {
	        id: id,
	        key: id || i,
	        submenu: submenu,
	        active: active,
	        icon: icon,
	        iconSize: iconSize,
	        text: text,
	        danger: danger,
	        borderTop: borderTop,
	        onClick: function onClick(e) {
	          return handleSelect(e, _onClick);
	        }
	      });
	    })
	  );
	};
	
	Menu.propTypes = {
	  className: _propTypes2.default.string,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    active: _propTypes2.default.bool,
	    icon: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
	  })),
	  onSelect: _propTypes2.default.func
	};
	
	exports.default = Menu;

/***/ }),
/* 791 */,
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Badge = __webpack_require__(604);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _drawer = __webpack_require__(185);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5214);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavItem = function NavItem(_ref) {
	  var avatar = _ref.avatar,
	      avatarUrl = _ref.avatarUrl,
	      className = _ref.className,
	      href = _ref.href,
	      icon = _ref.icon,
	      onClick = _ref.onClick,
	      title = _ref.title,
	      subtitle = _ref.subtitle,
	      toggleDrawerVisibility = _ref.toggleDrawerVisibility,
	      active = _ref.active,
	      waiting = _ref.waiting,
	      counter = _ref.counter,
	      unverified = _ref.unverified,
	      withGreyHover = _ref.withGreyHover,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['avatar', 'avatarUrl', 'className', 'href', 'icon', 'onClick', 'title', 'subtitle', 'toggleDrawerVisibility', 'active', 'waiting', 'counter', 'unverified', 'withGreyHover']);
	
	  var clickHandler = function clickHandler() {
	    if (onClick) {
	      onClick();
	      return false;
	    }
	    if (!(0, _mobileHelpers.isDesktop)()) {
	      toggleDrawerVisibility();
	    }
	
	    return false;
	  };
	
	  var asset = avatar ? _react2.default.createElement(_SimpleAvatar2.default, {
	    src: avatarUrl,
	    text: title,
	    size: 40,
	    waiting: waiting,
	    disabled: unverified,
	    unverified: unverified
	  }) : _react2.default.createElement(_Icon2.default, { name: icon, size: 24, style: { fill: _styles.COLORS.white } });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Link2.default,
	      (0, _extends3.default)({
	        to: href && '/' + href,
	        styleName: (0, _classnames2.default)('navLink', {
	          'navLink--active': active,
	          grey: withGreyHover
	        }),
	        activeClassName: _index2.default['navLink--active'],
	        onClick: clickHandler
	      }, other),
	      _react2.default.createElement(_Card2.default, {
	        withGreyHover: true,
	        additionalContent: {
	          left: asset,
	          right: counter && _react2.default.createElement(_Badge2.default, { text: counter })
	        },
	        className: (0, _classnames2.default)('pa2', className),
	        text: {
	          primary: title,
	          complementary: subtitle
	        }
	      })
	    )
	  );
	};
	
	NavItem.propTypes = {
	  avatar: _propTypes2.default.bool,
	  avatarUrl: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  icon: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  title: _propTypes2.default.string.isRequired,
	  subtitle: _propTypes2.default.string,
	  toggleDrawerVisibility: _propTypes2.default.func,
	  active: _propTypes2.default.bool,
	  waiting: _propTypes2.default.bool,
	  unverified: _propTypes2.default.bool,
	  counter: _propTypes2.default.number,
	  withGreyHover: _propTypes2.default.bool
	};
	
	var mapDispatchToProps = {
	  toggleDrawerVisibility: _drawer.actions.toggleVisibility
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactCssModules2.default)(NavItem, _index2.default, { allowMultiple: true }));

/***/ }),
/* 793 */,
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FieldsList = __webpack_require__(1182);
	
	var _FieldsList2 = _interopRequireDefault(_FieldsList);
	
	var _styles = __webpack_require__(18);
	
	var _useSimpleForm2 = __webpack_require__(499);
	
	var _enhance = __webpack_require__(3879);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimpleFormPopup = function SimpleFormPopup(_ref) {
	  var loading = _ref.loading,
	      onClose = _ref.onClose,
	      onSubmit = _ref.onSubmit,
	      title = _ref.title,
	      onChange = _ref.onChange,
	      description = _ref.description,
	      submitBtnText = _ref.submitBtnText,
	      errors = _ref.errors,
	      fields = _ref.fields,
	      initialData = _ref.initialData,
	      validateFields = _ref.validateFields,
	      customRoleOptions = _ref.customRoleOptions,
	      formatMessage = _ref.intl.formatMessage,
	      secondaryContentVisible = _ref.secondaryContentVisible,
	      strictClose = _ref.strictClose,
	      handleFieldOptions = _ref.handleFieldOptions,
	      mobileFullScreen = _ref.mobileFullScreen,
	      popupWidthType = _ref.popupWidthType;
	
	  var _useSimpleForm = (0, _useSimpleForm2.useSimpleForm)(fields, validateFields || fields, errors, initialData),
	      handleFormChange = _useSimpleForm.handleFormChange,
	      validateErrors = _useSimpleForm.validateErrors,
	      clearErrors = _useSimpleForm.clearErrors,
	      formState = _useSimpleForm.formState,
	      isValid = _useSimpleForm.isValid;
	
	  (0, _react.useEffect)(function () {
	    onChange(formState);
	  }, [formState]);
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    clearErrors();
	    onSubmit(formState);
	  };
	
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { maxWidth: _styles.BREAKPOINT },
	    function (isMobile) {
	      return _react2.default.createElement(
	        _Popup2.default,
	        {
	          mobileFullScreen: mobileFullScreen,
	          opened: true,
	          onClose: onClose,
	          title: title,
	          width: popupWidthType || (isMobile ? 'medium' : 'small'),
	          overflowVisible: true,
	          strictClose: strictClose || secondaryContentVisible
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'pt2' },
	          description ? _react2.default.createElement(
	            'span',
	            {
	              className: 'lh-copy normal',
	              style: { color: _styles.COLORS.grayDark }
	            },
	            description
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: handleSubmit },
	              _react2.default.createElement(_FieldsList2.default, {
	                fields: fields,
	                formState: formState,
	                validateErrors: validateErrors,
	                onChange: handleFormChange,
	                initialData: initialData,
	                handleFieldOptions: handleFieldOptions,
	                customRoleOptions: customRoleOptions
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'flex pt4' },
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    type: 'submit',
	                    raised: true,
	                    color: 'primary',
	                    disabled: !isValid || loading
	                  },
	                  submitBtnText || formatMessage({ id: 'common.save' })
	                ),
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    className: 'ml3',
	                    color: 'accent',
	                    onClick: onClose,
	                    type: 'button'
	                  },
	                  formatMessage({ id: 'common.cancel' })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  );
	};
	
	SimpleFormPopup.defaultProps = {
	  onSubmit: function onSubmit() {},
	  onChange: function onChange() {}
	};
	
	SimpleFormPopup.propTypes = {
	  loading: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  errors: _propTypes2.default.object,
	  fields: _propTypes2.default.array,
	  validateFields: _propTypes2.default.array,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  submitBtnText: _propTypes2.default.string,
	  initialData: _propTypes2.default.object,
	  secondaryContentVisible: _propTypes2.default.bool,
	  handleFieldOptions: _propTypes2.default.object,
	  mobileFullScreen: _propTypes2.default.bool,
	  popupWidthType: _propTypes2.default.string,
	  strictClose: _propTypes2.default.bool,
	  customRoleOptions: _propTypes2.default.array
	};
	
	exports.default = (0, _enhance.enhance)(SimpleFormPopup);

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _TextMessage = __webpack_require__(1809);
	
	var _TextMessage2 = _interopRequireDefault(_TextMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLocalizationData = function getLocalizationData(string) {
	  if (!string) return null;
	  return { id: string };
	};
	
	var SimpleInfoPopup = function SimpleInfoPopup(_ref) {
	  var icon = _ref.icon,
	      width = _ref.width,
	      opened = _ref.opened,
	      onClick = _ref.onClick,
	      titleId = _ref.titleId,
	      messageId = _ref.messageId,
	      buttonTitleId = _ref.buttonTitleId,
	      iconClassName = _ref.iconClassName,
	      buttonClassName = _ref.buttonClassName,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['icon', 'width', 'opened', 'onClick', 'titleId', 'messageId', 'buttonTitleId', 'iconClassName', 'buttonClassName', 'children']);
	  return _react2.default.createElement(
	    _Popup2.default,
	    (0, _extends3.default)({ opened: opened, width: width }, other),
	    _react2.default.createElement(_TextMessage2.default, {
	      icon: icon,
	      iconClassName: iconClassName,
	      buttonClassName: buttonClassName,
	      title: getLocalizationData(titleId),
	      message: getLocalizationData(messageId),
	      buttonTitle: getLocalizationData(buttonTitleId),
	      onClick: onClick
	    }),
	    children
	  );
	};
	
	SimpleInfoPopup.propTypes = {
	  icon: _propTypes2.default.string,
	  width: _propTypes2.default.string,
	  titleId: _propTypes2.default.string,
	  opened: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  messageId: _propTypes2.default.string,
	  buttonTitleId: _propTypes2.default.string,
	  buttonClassName: _propTypes2.default.string,
	  iconClassName: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string])
	};
	
	exports.default = SimpleInfoPopup;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.getTime = getTime;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TimePicker = __webpack_require__(1198);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _ValidationError = __webpack_require__(500);
	
	var _ValidationError2 = _interopRequireDefault(_ValidationError);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5238);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTime() {
	  return (0, _moment2.default)().add(5, 'minute').format('hh:mm a');
	}
	
	function TimePickerInput(_ref) {
	  var name = _ref.name,
	      label = _ref.label,
	      time = _ref.time,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      className = _ref.className,
	      placeholder = _ref.placeholder,
	      validateTime = _ref.validateTime,
	      formatMessage = _ref.intl.formatMessage,
	      withCurrentTime = _ref.withCurrentTime,
	      disabled = _ref.disabled,
	      _ref$saveButtonTitle = _ref.saveButtonTitle,
	      saveButtonTitle = _ref$saveButtonTitle === undefined ? formatMessage({ id: 'common.ok' }) : _ref$saveButtonTitle,
	      _ref$cancelButtonTitl = _ref.cancelButtonTitle,
	      cancelButtonTitle = _ref$cancelButtonTitl === undefined ? formatMessage({ id: 'common.cancel' }) : _ref$cancelButtonTitl;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isPopupVisible = _useState2[0],
	      toggleVisibility = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(withCurrentTime ? getTime() : time),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      pickerTime = _useState4[0],
	      setTime = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      error = _useState6[0],
	      showError = _useState6[1];
	
	  var togglePopup = (0, _react.useCallback)(function () {
	    toggleVisibility(!isPopupVisible);
	    showError(null);
	  }, [isPopupVisible, toggleVisibility]);
	
	  var handleSave = function handleSave() {
	    var errorMessage = validateTime && validateTime(pickerTime);
	
	    if (!errorMessage) {
	      onChange(pickerTime);
	      toggleVisibility(false);
	    } else {
	      showError(errorMessage);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', className: className },
	    _react2.default.createElement(
	      _TextInput2.default,
	      {
	        rounded: true,
	        name: name,
	        type: 'text',
	        value: value,
	        onFocus: togglePopup,
	        label: label,
	        placeholder: placeholder,
	        disabled: disabled,
	        readOnly: true
	      },
	      _react2.default.createElement(_Icon2.default, {
	        styleName: 'icon',
	        name: 'time',
	        style: { fill: _styles.COLORS.bluePrimary }
	      })
	    ),
	    _react2.default.createElement(
	      _Popup2.default,
	      {
	        opened: isPopupVisible,
	        white: true,
	        width: 'rubber',
	        enabled: true,
	        withHeading: false,
	        contentNoPadding: true,
	        mobileFullScreen: false
	      },
	      _react2.default.createElement(_TimePicker2.default, { time: pickerTime, onChange: function onChange(val) {
	          return setTime(val);
	        } }),
	      error ? _react2.default.createElement(_ValidationError2.default, { content: error, className: 'f-14 tc' }) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'pt3 pb1 flex justify-end' },
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'transparent', onClick: togglePopup },
	          cancelButtonTitle
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'transparent', onClick: handleSave },
	          saveButtonTitle
	        )
	      )
	    )
	  );
	}
	
	TimePickerInput.propTypes = {
	  name: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  time: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  cancelButtonTitle: _propTypes2.default.string,
	  saveButtonTitle: _propTypes2.default.string,
	  validateTime: _propTypes2.default.func,
	  intl: _propTypes2.default.object,
	  value: _propTypes2.default.string,
	  withCurrentTime: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool
	};
	
	TimePickerInput.defaultProps = {
	  time: '12:00',
	  withCurrentTime: false
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(TimePickerInput, _index2.default, { allowMultiple: true }));

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertTimeTo12HoursFormat = exports.convertTimeTo24HoursFormat = exports.parseValueToField = exports.parseValueToSelectTimeZone = undefined;
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.handleInitialTime = handleInitialTime;
	exports.formatTimeRangeView = formatTimeRangeView;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Structure for TimePickerRange state:
	// value[0]: string - startTime
	// value[1]: string - endTime
	// value[2]: Object { label: string, value: string } - TimeZone
	
	function handleInitialTime() {
	  var interval = 30 * 60 * 1000;
	  return (0, _moment2.default)(Math.ceil((0, _moment2.default)() / interval) * interval).format('hh:mm A');
	}
	
	var parseValueToSelectTimeZone = exports.parseValueToSelectTimeZone = function parseValueToSelectTimeZone(data) {
	  if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
	    return data[2] && data[2].label ? data[2] : null;
	  }
	  return data || null;
	};
	
	var parseValueToField = exports.parseValueToField = function parseValueToField(data, isStartTime) {
	  if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object') {
	    return data[0] || data[1] ? convertTimeTo12HoursFormat(isStartTime ? data[0] : data[1]) : null;
	  }
	  return data || null;
	};
	
	var convertTimeTo24HoursFormat = exports.convertTimeTo24HoursFormat = function convertTimeTo24HoursFormat(time) {
	  return (0, _moment2.default)(time, ['h:mm A']).format('HH:mm');
	};
	
	var convertTimeTo12HoursFormat = exports.convertTimeTo12HoursFormat = function convertTimeTo12HoursFormat(time) {
	  if (time && time.length > 5) return time;
	  return (0, _moment2.default)(time, ['HH:mm']).format('h:mm A');
	};
	
	function formatTimeRangeView(item) {
	  if (!item[0] || !item[1]) return '-';
	  return convertTimeTo12HoursFormat(item[0]) + ' - ' + convertTimeTo12HoursFormat(item[1]) + ', ' + item[2].value;
	}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useConsentOutcomesInfo = function useConsentOutcomesInfo(consent) {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var buttonAccept = formatMessage({
	    id: 'common.accept'
	  });
	
	  var buttonSelectOption = formatMessage({
	    id: 'common.selectOption'
	  });
	
	  var isConsentHasMultipleOutcomes = (0, _get2.default)(consent, 'multipleOutcomes', false);
	
	  var consentOutcomeTitles = (0, _get2.default)(consent, 'outcomeTitles', []);
	
	  return {
	    buttonAccept: isConsentHasMultipleOutcomes ? buttonSelectOption : buttonAccept,
	    consentOutcomeTitles: consentOutcomeTitles,
	    isConsentHasMultipleOutcomes: isConsentHasMultipleOutcomes
	  };
	};
	
	exports.default = useConsentOutcomesInfo;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _useGetPatientMainInsuranceInfo = __webpack_require__(774);
	
	var _useGetPatientMainInsuranceInfo2 = _interopRequireDefault(_useGetPatientMainInsuranceInfo);
	
	var _common = __webpack_require__(864);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useGetPatientInsuranceData = function useGetPatientInsuranceData(_ref) {
	  var userId = _ref.userId,
	      flowType = _ref.flowType,
	      isInsuranceEditOpen = _ref.isInsuranceEditOpen;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var isInsuranceRelatedDataFetching = (0, _reactRedux.useSelector)(_common.selectInsuranceRelatedDataFetching);
	
	  var insuranceData = (0, _useGetPatientMainInsuranceInfo2.default)({ flowType: flowType });
	
	  (0, _react.useEffect)(function () {
	    dispatch(_manageInsurancesActions.manageInsurancesActions.downloadPatientInsurancesData({
	      userId: userId
	    }));
	  }, [userId, isInsuranceEditOpen]);
	
	  return {
	    insuranceData: insuranceData,
	    isInsuranceRelatedDataFetching: isInsuranceRelatedDataFetching
	  };
	};
	
	exports.default = useGetPatientInsuranceData;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'insurance-eligibility-payers');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'insurance_eligibility',
	  type: 'get',
	  slug: ['payers', {
	    type: 'payload.query',
	    queryParameter: 'query',
	    selector: 'query'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'provider_id',
	    selector: 'providerId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }]
	}, true);
	
	var initialState = {
	  sending: false,
	  succeed: null,
	  rejected: null,
	  error: null,
	  list: [],
	  count: 0,
	  isLastPage: false,
	  meta: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SEND:
	      return (0, _extends3.default)({}, state, {
	        sending: true,
	        succeed: null,
	        rejected: null,
	        error: null
	      });
	
	    case consts.SUCCEED:
	      return (0, _extends3.default)({}, state, {
	        succeed: true,
	        sending: false,
	        list: state.list.length ? state.list.concat(payload) : payload
	      });
	
	    case consts.REJECTED:
	      return (0, _extends3.default)({}, state, {
	        sending: false,
	        rejected: true
	      });
	
	    case consts.ERROR_ENCOUNTERED:
	      return (0, _extends3.default)({}, state, {
	        sending: false,
	        error: payload
	      });
	
	    case consts.ADD_META:
	      {
	        var total = (0, _get2.default)(action.payload, 'total', 0);
	
	        return (0, _extends3.default)({}, state, {
	          meta: action.payload,
	          count: total,
	          isLastPage: state.list.length === total
	        });
	      }
	
	    case consts.CLEAR:
	      return initialState;
	
	    default:
	      return state;
	  }
	};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeRequestConfig = function makeRequestConfig() {
	  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return {
	    endpoint: 'appointments',
	    type: 'get',
	    slug: ['questions', 'employers', {
	      type: 'payload.query',
	      queryParameter: 'organization_id',
	      selector: 'id'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'query',
	      selector: 'query'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'limit',
	      selector: 'limit'
	    }].concat((0, _toConsumableArray3.default)(slug))
	  };
	};
	
	var requestOptions = makeRequestConfig([{
	  type: 'payload.query',
	  queryParameter: 'offset',
	  selector: 'offset'
	}]);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'employers-list-request', ['LOAD_MORE']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('appointment-form', 'employers-list-lazy-load-request');
	
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions, true);
	
	var defaultRequestReducer = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'total'
	});
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  count: 0,
	  isLastPage: false
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      return (0, _extends3.default)({}, state, {
	        succeed: true,
	        sending: false,
	        list: state.list && state.list.length !== 0 ? state.list.concat(payload) : payload
	      });
	
	    case consts.ADD_META:
	      {
	        var total = (0, _get2.default)(action.payload, 'total', 0);
	
	        return (0, _extends3.default)({}, state, {
	          count: total,
	          isLastPage: state.list.length === total
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          sending: true,
	          data: null
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true,
	          data: payload
	        });
	      }
	
	    case consts.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'provider-GW-details');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'schedulings']
	});
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  data: null
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'reason_types-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['reason_types', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'visit_type_id',
	    selector: 'visitTypeId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'location_id',
	    selector: 'locationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'pbv_config_id',
	    selector: 'pbvConfigId'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'schedulable-tree-req', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['schedulable_tree', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'scheduling_by',
	    selector: 'schedulingBy'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handleShowEmergencyContactStep = handleShowEmergencyContactStep;
	exports.verifyInspection = verifyInspection;
	exports.determineNextStepAfterGuarantorInformation = determineNextStepAfterGuarantorInformation;
	exports.handleShowAdditionalInformationStep = handleShowAdditionalInformationStep;
	exports.default = inspectAllSaga;
	
	var _effects = __webpack_require__(14);
	
	var _inspectionReq = __webpack_require__(293);
	
	var inspectReq = _interopRequireWildcard(_inspectionReq);
	
	var _selectors = __webpack_require__(50);
	
	var _progressTypes = __webpack_require__(55);
	
	var _constants = __webpack_require__(17);
	
	var _selectors2 = __webpack_require__(43);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _paperworkAdditionalInfo = __webpack_require__(421);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(82);
	
	var _userDetailsReq = __webpack_require__(629);
	
	var userDetails = _interopRequireWildcard(_userDetailsReq);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleShowEmergencyContactStep),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(verifyInspection),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleShowInsuranceFormStep),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleShowPrimaryCareProviderStep),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(determineNextStepAfterEmergencyContact),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(determineNextStepAfterGuarantorInformation),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(determineNextStepAfterInsuranceForm),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(determineNextStepAfterVisitDetails),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(determineNextStepAfterPharmacy),
	    _marked10 = /*#__PURE__*/_regenerator2.default.mark(determineNextStepAfterHealthInfoProvider),
	    _marked11 = /*#__PURE__*/_regenerator2.default.mark(handleShowAdditionalInformationStep),
	    _marked12 = /*#__PURE__*/_regenerator2.default.mark(determineNextStepAfterAppointmentProviders),
	    _marked13 = /*#__PURE__*/_regenerator2.default.mark(inspectAllSaga);
	
	var PROFILE = _constants.APPOINTMENT_INSPECTION.PROFILE,
	    LOCAL_PROFILE = _constants.APPOINTMENT_INSPECTION.LOCAL_PROFILE;
	function handleShowEmergencyContactStep() {
	  var conditionForShowingEmergencyContact;
	  return _regenerator2.default.wrap(function handleShowEmergencyContactStep$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectAppRequestEmergencyContactInfo);
	
	        case 2:
	          conditionForShowingEmergencyContact = _context.sent;
	
	          if (!conditionForShowingEmergencyContact) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.call)(_redirectUtils.redirectToEmergencyContact);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.cancel)();
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.call)(determineNextStepAfterEmergencyContact);
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function verifyInspection() {
	  var profileForm, localProfileForm;
	  return _regenerator2.default.wrap(function verifyInspection$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)((0, _selectors2.makeSelectInspectionById)(PROFILE));
	
	        case 2:
	          profileForm = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)((0, _selectors2.makeSelectInspectionById)(LOCAL_PROFILE));
	
	        case 5:
	          localProfileForm = _context2.sent;
	
	          if (!(profileForm && !profileForm.completed)) {
	            _context2.next = 11;
	            break;
	          }
	
	          _context2.next = 9;
	          return (0, _effects.call)(_redirectUtils.redirectToPatientForm);
	
	        case 9:
	          _context2.next = 11;
	          return (0, _effects.cancel)();
	
	        case 11:
	          if (!(localProfileForm && !localProfileForm.completed)) {
	            _context2.next = 16;
	            break;
	          }
	
	          _context2.next = 14;
	          return (0, _effects.call)(_redirectUtils.redirectToPatientForm);
	
	        case 14:
	          _context2.next = 16;
	          return (0, _effects.cancel)();
	
	        case 16:
	          _context2.next = 18;
	          return (0, _effects.call)(handleShowEmergencyContactStep);
	
	        case 18:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleShowInsuranceFormStep() {
	  var selectedOrganizationTenantSkipInsurance, careUserSkipInsurance, shouldCheckInsurance;
	  return _regenerator2.default.wrap(function handleShowInsuranceFormStep$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors2.selectProgressOrganizationTenantSkipInsurance);
	
	        case 2:
	          selectedOrganizationTenantSkipInsurance = _context3.sent;
	          _context3.next = 5;
	          return (0, _effects.select)(_selectors2.selectProgressCareUserSkipInsurance);
	
	        case 5:
	          careUserSkipInsurance = _context3.sent;
	          shouldCheckInsurance = careUserSkipInsurance === false && selectedOrganizationTenantSkipInsurance === false;
	
	          if (!shouldCheckInsurance) {
	            _context3.next = 12;
	            break;
	          }
	
	          _context3.next = 10;
	          return (0, _effects.call)(_redirectUtils.redirectToFullInsuranceForm);
	
	        case 10:
	          _context3.next = 14;
	          break;
	
	        case 12:
	          _context3.next = 14;
	          return (0, _effects.call)(determineNextStepAfterInsuranceForm);
	
	        case 14:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	// primary care provider (pcp/health-info-provider) step is shown only for urgent virtual visit
	// and eir visit types (but has different UI)
	function handleShowPrimaryCareProviderStep() {
	  var visitTypeCode, isUrgentVirtualVisit, careUserHasPrimaryCareProvider;
	  return _regenerator2.default.wrap(function handleShowPrimaryCareProviderStep$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.select)(_selectors2.selectProgressVisitTypeCode);
	
	        case 2:
	          visitTypeCode = _context4.sent;
	          isUrgentVirtualVisit = visitTypeCode === _constants.URGENT_VISIT_TYPE_CODE;
	          _context4.next = 6;
	          return (0, _effects.select)(_selectors2.selectProgressCareUserHasPrimaryCareProvider);
	
	        case 6:
	          careUserHasPrimaryCareProvider = _context4.sent;
	
	          if (!(isUrgentVirtualVisit && careUserHasPrimaryCareProvider)) {
	            _context4.next = 12;
	            break;
	          }
	
	          _context4.next = 10;
	          return (0, _effects.call)(handleShowAdditionalInformationStep);
	
	        case 10:
	          _context4.next = 14;
	          break;
	
	        case 12:
	          _context4.next = 14;
	          return (0, _effects.call)(_redirectUtils.redirectToHealthInfoProvider);
	
	        case 14:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function determineNextStepAfterEmergencyContact() {
	  var visitTypeCode, isInlineVisitType, isEirVisit, isUrgentVirtualVisit;
	  return _regenerator2.default.wrap(function determineNextStepAfterEmergencyContact$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(_selectors2.selectProgressVisitTypeCode);
	
	        case 2:
	          visitTypeCode = _context5.sent;
	          isInlineVisitType = _constants.INLINE_TYPES.includes(visitTypeCode);
	          isEirVisit = _constants.EIR_APPOINTMENT_TYPES.includes(visitTypeCode);
	          isUrgentVirtualVisit = visitTypeCode === _constants.URGENT_VISIT_TYPE_CODE;
	
	          if (!isEirVisit) {
	            _context5.next = 11;
	            break;
	          }
	
	          _context5.next = 9;
	          return (0, _effects.call)(_redirectUtils.redirectToGuarantorInformation);
	
	        case 9:
	          _context5.next = 11;
	          return (0, _effects.cancel)();
	
	        case 11:
	          if (!(isInlineVisitType || isUrgentVirtualVisit)) {
	            _context5.next = 16;
	            break;
	          }
	
	          _context5.next = 14;
	          return (0, _effects.call)(handleShowInsuranceFormStep);
	
	        case 14:
	          _context5.next = 16;
	          return (0, _effects.cancel)();
	
	        case 16:
	          _context5.next = 18;
	          return (0, _effects.call)(_redirectUtils.redirectToVisitDetails);
	
	        case 18:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function determineNextStepAfterGuarantorInformation() {
	  var getCareUserId, paperworkUserId, pathname, isPaperwork, userId;
	  return _regenerator2.default.wrap(function determineNextStepAfterGuarantorInformation$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.select)(_selectors2.selectProgressCareUserId);
	
	        case 2:
	          getCareUserId = _context6.sent;
	          _context6.next = 5;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails.selectPaperworkAppointmentUserId);
	
	        case 5:
	          paperworkUserId = _context6.sent;
	          pathname = window.location.pathname;
	          isPaperwork = pathname.includes(_routes.PAPERWORK);
	          userId = isPaperwork ? paperworkUserId : getCareUserId;
	
	          if (!userId) {
	            _context6.next = 12;
	            break;
	          }
	
	          _context6.next = 12;
	          return (0, _effects.put)(userDetails.actions.send({ id: userId }));
	
	        case 12:
	          if (isPaperwork) {
	            _context6.next = 15;
	            break;
	          }
	
	          _context6.next = 15;
	          return (0, _effects.call)(_redirectUtils.redirectToVisitDetails);
	
	        case 15:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function determineNextStepAfterInsuranceForm() {
	  var visitTypeCode, isEirVisitType, isInlineVisitType, isUrgentVirtualVisit;
	  return _regenerator2.default.wrap(function determineNextStepAfterInsuranceForm$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)(_selectors2.selectProgressVisitTypeCode);
	
	        case 2:
	          visitTypeCode = _context7.sent;
	          _context7.next = 5;
	          return (0, _effects.select)(_selectors2.selectIsEirVisitTypeCode);
	
	        case 5:
	          isEirVisitType = _context7.sent;
	          isInlineVisitType = _constants.INLINE_TYPES.includes(visitTypeCode);
	          isUrgentVirtualVisit = visitTypeCode === _constants.URGENT_VISIT_TYPE_CODE;
	
	          if (!isInlineVisitType) {
	            _context7.next = 13;
	            break;
	          }
	
	          _context7.next = 11;
	          return (0, _effects.call)(_redirectUtils.redirectToVisitDetails);
	
	        case 11:
	          _context7.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          if (!isUrgentVirtualVisit) {
	            _context7.next = 18;
	            break;
	          }
	
	          _context7.next = 16;
	          return (0, _effects.call)(_redirectUtils.redirectToVisitDetails);
	
	        case 16:
	          _context7.next = 18;
	          return (0, _effects.cancel)();
	
	        case 18:
	          if (!isEirVisitType) {
	            _context7.next = 23;
	            break;
	          }
	
	          _context7.next = 21;
	          return (0, _effects.call)(_redirectUtils.redirectToPharmacy);
	
	        case 21:
	          _context7.next = 23;
	          return (0, _effects.cancel)();
	
	        case 23:
	          _context7.next = 25;
	          return (0, _effects.call)(handleShowAdditionalInformationStep);
	
	        case 25:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function determineNextStepAfterVisitDetails() {
	  var visitTypeCode, isInlineVisitType, isUrgentVirtualVisit;
	  return _regenerator2.default.wrap(function determineNextStepAfterVisitDetails$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.select)(_selectors2.selectProgressVisitTypeCode);
	
	        case 2:
	          visitTypeCode = _context8.sent;
	          isInlineVisitType = _constants.INLINE_TYPES.includes(visitTypeCode);
	          isUrgentVirtualVisit = visitTypeCode === _constants.URGENT_VISIT_TYPE_CODE;
	
	          if (!isInlineVisitType) {
	            _context8.next = 10;
	            break;
	          }
	
	          _context8.next = 8;
	          return (0, _effects.call)(handleShowAdditionalInformationStep);
	
	        case 8:
	          _context8.next = 10;
	          return (0, _effects.cancel)();
	
	        case 10:
	          if (!isUrgentVirtualVisit) {
	            _context8.next = 15;
	            break;
	          }
	
	          _context8.next = 13;
	          return (0, _effects.call)(_redirectUtils.redirectToConsentForm);
	
	        case 13:
	          _context8.next = 15;
	          return (0, _effects.cancel)();
	
	        case 15:
	          _context8.next = 17;
	          return (0, _effects.call)(_redirectUtils.redirectToProviders);
	
	        case 17:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	// pharmacy step showed only for urgent virtual visit and eir visit types
	function determineNextStepAfterPharmacy() {
	  return _regenerator2.default.wrap(function determineNextStepAfterPharmacy$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _effects.call)(handleShowPrimaryCareProviderStep);
	
	        case 2:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}
	
	// health info provider step showed only for urgent virtual visit and eir visit types
	function determineNextStepAfterHealthInfoProvider() {
	  return _regenerator2.default.wrap(function determineNextStepAfterHealthInfoProvider$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return (0, _effects.call)(handleShowAdditionalInformationStep);
	
	        case 2:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this);
	}
	
	function handleShowAdditionalInformationStep() {
	  var showPaperworkAppointmentQuestionStep, visitTypeCode, isInlineVisitType, isUrgentVirtualVisit;
	  return _regenerator2.default.wrap(function handleShowAdditionalInformationStep$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          _context11.next = 2;
	          return (0, _effects.select)(_paperworkAdditionalInfo.selectShowPaperworkAppointmentQuestionStep);
	
	        case 2:
	          showPaperworkAppointmentQuestionStep = _context11.sent;
	          _context11.next = 5;
	          return (0, _effects.select)(_selectors2.selectProgressVisitTypeCode);
	
	        case 5:
	          visitTypeCode = _context11.sent;
	          isInlineVisitType = _constants.INLINE_TYPES.includes(visitTypeCode);
	          isUrgentVirtualVisit = visitTypeCode === _constants.URGENT_VISIT_TYPE_CODE;
	
	          if (!showPaperworkAppointmentQuestionStep) {
	            _context11.next = 13;
	            break;
	          }
	
	          _context11.next = 11;
	          return (0, _effects.call)(_redirectUtils.redirectToAdditionalInformation);
	
	        case 11:
	          _context11.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          if (!isUrgentVirtualVisit) {
	            _context11.next = 18;
	            break;
	          }
	
	          _context11.next = 16;
	          return (0, _effects.call)(_redirectUtils.redirectToHealthInfo);
	
	        case 16:
	          _context11.next = 18;
	          return (0, _effects.cancel)();
	
	        case 18:
	          if (!isInlineVisitType) {
	            _context11.next = 23;
	            break;
	          }
	
	          _context11.next = 21;
	          return (0, _effects.call)(_redirectUtils.redirectToAppointmentOverview);
	
	        case 21:
	          _context11.next = 23;
	          return (0, _effects.cancel)();
	
	        case 23:
	          _context11.next = 25;
	          return (0, _effects.call)(_redirectUtils.redirectToConsentForm);
	
	        case 25:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked11, this);
	}
	
	function determineNextStepAfterAppointmentProviders() {
	  return _regenerator2.default.wrap(function determineNextStepAfterAppointmentProviders$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          _context12.next = 2;
	          return (0, _effects.call)(handleShowInsuranceFormStep);
	
	        case 2:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked12, this);
	}
	
	function inspectAllSaga() {
	  return _regenerator2.default.wrap(function inspectAllSaga$(_context13) {
	    while (1) {
	      switch (_context13.prev = _context13.next) {
	        case 0:
	          _context13.next = 2;
	          return (0, _effects.takeLatest)(inspectReq.consts.SUCCEED, verifyInspection);
	
	        case 2:
	          _context13.next = 4;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_EMERGENCY_CONTACT, determineNextStepAfterEmergencyContact);
	
	        case 4:
	          _context13.next = 6;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_GUARANTOR_INFORMATION, determineNextStepAfterGuarantorInformation);
	
	        case 6:
	          _context13.next = 8;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_INSURANCE_FORM, determineNextStepAfterInsuranceForm);
	
	        case 8:
	          _context13.next = 10;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_VISIT_DETAILS, determineNextStepAfterVisitDetails);
	
	        case 10:
	          _context13.next = 12;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_PHARMACY, determineNextStepAfterPharmacy);
	
	        case 12:
	          _context13.next = 14;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_HEALTH_INFO_PROVIDER_STEP, determineNextStepAfterHealthInfoProvider);
	
	        case 14:
	          _context13.next = 16;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_APPOINTMENT_PROVIDERS, determineNextStepAfterAppointmentProviders);
	
	        case 16:
	        case 'end':
	          return _context13.stop();
	      }
	    }
	  }, _marked13, this);
	}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'send-invitation');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'send_invitation',
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('signup', 'general-user-registrations');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'general_user_registrations',
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makeUsernameAvailabilityReqConfig = function makeUsernameAvailabilityReqConfig() {
	  return {
	    endpoint: 'profiles',
	    type: 'get',
	    slug: ['username_availability', {
	      type: 'payload.query',
	      queryParameter: 'username',
	      selector: 'username'
	    }]
	  };
	};
	
	var requestOptions = makeUsernameAvailabilityReqConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'username-availability');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqChangeChatName');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'channels',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqChannel');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'channels',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqFilters');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'channel_filters',
	  type: 'get'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqNewChannel');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'context_chat_rooms',
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqRelatedUsers');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'related_users', {
	    type: 'payload.query',
	    queryParameter: 'excluded_chatroom_id',
	    selector: 'channelId'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'relationshipPriority');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'relationship_priorities',
	  type: 'get'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectPendingFamilyMembers = exports.sendingReqCircleOfCareSelector = exports.familyCircleSelector = exports.careProvidersSelector = exports.reqCircleOfCareSelector = exports.circleSelector = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var circleSelector = exports.circleSelector = function circleSelector(state) {
	  return state.board.circleOfCare;
	};
	var reqCircleOfCareSelector = exports.reqCircleOfCareSelector = function reqCircleOfCareSelector(state) {
	  return state.board.reqCircleOfCare;
	};
	
	var careProvidersSelector = exports.careProvidersSelector = (0, _reselect.createSelector)(circleSelector, function (circle) {
	  return (0, _get2.default)(circle, 'careProviders', []);
	});
	
	var familyCircleSelector = exports.familyCircleSelector = (0, _reselect.createSelector)(circleSelector, function (circle) {
	  return (0, _get2.default)(circle, 'familyCircle', []);
	});
	
	var sendingReqCircleOfCareSelector = exports.sendingReqCircleOfCareSelector = (0, _reselect.createSelector)(reqCircleOfCareSelector, function (request) {
	  return (0, _get2.default)(request, 'sending');
	});
	
	var selectPendingFamilyMembers = exports.selectPendingFamilyMembers = (0, _reselect.createSelector)(circleSelector, function (state) {
	  return (0, _get2.default)(state, 'pendingFamilyMembers', []);
	});

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'cancel-guardian-invitation-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'guardian_proxy_invitations', {
	    type: 'payload',
	    selector: ['invitationId']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('circles', 'change-member-role-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'roles', {
	    type: 'payload',
	    selector: ['memberId']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'acceptJoinRequest');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'join_requests',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'imagesRemove');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'images']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'imagesUpdate');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'images']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'infoUpdate');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var supportedActions = ['GET_POSTS_PREVIEW', 'GET_OLDER_POSTS_PREVIEW'];
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'communityPostsPreview', supportedActions);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'posts', 'preview', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'createPost');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'posts']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('communities', 'currentCommunity', 'SET');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	exports.default = (0, _redux.createReducer)(null, (0, _defineProperty3.default)({}, consts.SET, function (state, action) {
	  return action.payload;
	}));

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'declineJoinRequest');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'join_requests',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.deletedPostSaga = deletedPostSaga;
	
	var _effects = __webpack_require__(14);
	
	var _redux = __webpack_require__(7);
	
	var _postsList = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(deletedPostWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(deletedPostSaga);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'deletePost');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'posts', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	
	function deletedPostWorker(action) {
	  return _regenerator2.default.wrap(function deletedPostWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.take)(consts.SUCCEED);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)({
	            type: _postsList.consts.DELETE_POST,
	            payload: action.payload
	          });
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function deletedPostSaga() {
	  return _regenerator2.default.wrap(function deletedPostSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(consts.SEND, deletedPostWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.editedPostSaga = editedPostSaga;
	
	var _effects = __webpack_require__(14);
	
	var _redux = __webpack_require__(7);
	
	var _postsList = __webpack_require__(166);
	
	var _newPostForm = __webpack_require__(652);
	
	var _postDetails = __webpack_require__(238);
	
	var _urlPreview = __webpack_require__(413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(editedPostWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(editedPostSaga);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'editPost');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'posts', {
	    type: 'payload',
	    selector: ['postId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	
	function editedPostWorker(action) {
	  return _regenerator2.default.wrap(function editedPostWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)({
	            type: _newPostForm.consts.CLEAR_FORM
	          });
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)({
	            type: _urlPreview.consts.CLEAR
	          });
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.put)({
	            type: _postsList.consts.EDIT_POST,
	            payload: action.payload
	          });
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)({
	            type: _postDetails.consts.EDIT,
	            payload: action.payload
	          });
	
	        case 8:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function editedPostSaga() {
	  return _regenerator2.default.wrap(function editedPostSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(consts.SUCCEED, editedPostWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'getUserProfile');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'join_requests',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'user']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectIsActivitiesNotEmpty = exports.selectActivityMetaByType = exports.selectActivityCounterByType = exports.selectActivitiesMetaState = exports.selectActivityListByType = exports.selectActivitiesList = exports.selectJoinReqState = exports.selectActivitiesActiveTab = exports.selectActivitiesState = undefined;
	
	var _index = __webpack_require__(60);
	
	var _lodash = __webpack_require__(58);
	
	var _constants = __webpack_require__(17);
	
	var selectActivitiesState = exports.selectActivitiesState = function selectActivitiesState(state) {
	  return (0, _lodash.get)(state, 'communities.activities');
	};
	
	var selectActivitiesActiveTab = exports.selectActivitiesActiveTab = (0, _index.createSelector)(selectActivitiesState, function (state) {
	  return (0, _lodash.get)(state, 'activeTab');
	});
	
	var selectJoinReqState = exports.selectJoinReqState = function selectJoinReqState(state) {
	  return (0, _lodash.get)(state, 'communities.communitiesJoinRequests');
	};
	
	var selectActivitiesList = exports.selectActivitiesList = (0, _index.createSelector)(selectActivitiesActiveTab, selectJoinReqState, function (tab, state) {
	  return (0, _lodash.get)(state, tab, []);
	});
	
	var selectActivityListByType = exports.selectActivityListByType = function selectActivityListByType(type) {
	  return (0, _index.createSelector)(selectJoinReqState, function (state) {
	    return (0, _lodash.get)(state, type, []);
	  });
	};
	
	var selectActivitiesMetaState = exports.selectActivitiesMetaState = (0, _index.createSelector)(selectJoinReqState, function (state) {
	  return (0, _lodash.get)(state, 'meta', {});
	});
	
	var selectActivityCounterByType = exports.selectActivityCounterByType = function selectActivityCounterByType(type) {
	  return (0, _index.createSelector)(selectActivitiesMetaState, function (meta) {
	    return (0, _lodash.get)(meta, [type, 'total']);
	  });
	};
	
	var selectActivityMetaByType = exports.selectActivityMetaByType = function selectActivityMetaByType(type) {
	  return (0, _index.createSelector)(selectActivitiesMetaState, function (meta) {
	    return (0, _lodash.get)(meta, type);
	  });
	};
	
	var selectIsActivitiesNotEmpty = exports.selectIsActivitiesNotEmpty = (0, _index.createSelector)(selectActivityCounterByType(_constants.ACTIVITY_TYPES.JOIN_REQUESTS), selectActivityCounterByType(_constants.ACTIVITY_TYPES.MEMBER_INVITATIONS), selectActivityCounterByType(_constants.ACTIVITY_TYPES.NOTIFICATIONS), function (requestsCounter, notificationCounter, invitationCounter) {
	  return Boolean(requestsCounter || notificationCounter || invitationCounter);
	});

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginatedWatcher = exports.watcher = exports.paginatedActions = exports.actions = exports.paginatedConsts = exports.consts = undefined;
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(58);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var request = {
	  endpoint: 'join_requests',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	};
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  pagination: {
	    offset: 0,
	    limit: 10
	  }
	});
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'usersJoinRequests');
	var paginatedConsts = exports.paginatedConsts = (0, _redux.createReqConsts)('communities', 'usersPaginatedJoinRequests', ['LOAD_NEXT_REQUESTS', 'UPDATE_PAGINATION_PARAMETERS']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var paginatedActions = exports.paginatedActions = (0, _redux.createActions)(paginatedConsts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, request);
	var paginatedWatcher = exports.paginatedWatcher = (0, _redux.createReqWatcher)(paginatedConsts, paginatedActions, request);
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SUCCEED:
	      {
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true
	        }, { list: action.payload });
	      }
	    case paginatedConsts.SUCCEED:
	      {
	        var prevState = (0, _lodash.get)(state, 'list', []);
	        return (0, _assign2.default)({}, state, _redux.initialState, {
	          succeed: true,
	          list: prevState.concat(action.payload)
	        });
	      }
	    case consts.UPDATE_REQUESTS:
	      {
	        var id = action.payload;
	        var _prevState = (0, _lodash.get)(state, 'list');
	        var list = _prevState.filter(function (item) {
	          return item.id !== id;
	        });
	        return (0, _extends3.default)({}, state, {
	          list: list
	        });
	      }
	    case paginatedConsts.UPDATE_PAGINATION_PARAMETERS:
	      {
	        var _action$payload = action.payload,
	            offset = _action$payload.offset,
	            limit = _action$payload.limit;
	
	        return (0, _lodash.merge)({}, state, {
	          pagination: {
	            offset: offset,
	            limit: limit
	          }
	        });
	      }
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, _index.initialState, {
	          succeed: true,
	          data: action.payload
	        });
	      }
	
	    case consts.UPDATE:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: action.payload
	        });
	      }
	
	    case consts.RESET:
	      {
	        return initialState;
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};
	
	var _index = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _index.createReqConsts)('complaints', 'details', ['RESET', 'UPDATE']);
	var actions = exports.actions = (0, _index.createActions)(consts);
	
	var watcher = exports.watcher = (0, _index.createReqWatcher)(consts, actions, {
	  endpoint: 'complaint_notifications',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	var initialState = (0, _extends3.default)({}, _index.initialState, {
	  data: undefined
	});
	
	var defaultRequestReducer = (0, _index.createReqReducer)(consts);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['UPDATE', 'REMOVE']; /* eslint-disable */
	var consts = exports.consts = _consts2.default.apply(undefined, ['context', 'permissions'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	// retrieved data
	var user = window.storage.getItem('user');
	var initialLoggedUser = user ? JSON.parse(user) : null;
	
	var initialState = {
	  loggedUserId: (0, _get2.default)(initialLoggedUser, 'id', null),
	  targetUserId: null,
	  caregiverCircles: null,
	  isLoggedUser: false,
	  isCaregiver: false,
	  isVerifiedDependent: false,
	  isFamilyMemberOnly: null,
	  dependentsList: []
	};
	
	var updatePermissions = function updatePermissions(state, payload) {
	  var prevLoggedId = state.loggedUserId,
	      prevTargetId = state.targetUserId,
	      prevCaregiverCircles = state.caregiverCircles,
	      prevDependentsList = state.dependentsList;
	  var loggedUserId = payload.loggedUserId,
	      targetUserId = payload.targetUserId,
	      caregiverCircles = payload.caregiverCircles,
	      targetUser = payload.targetUser,
	      dependentsList = payload.dependentsList;
	
	
	  var newLoggedUserId = loggedUserId || prevLoggedId;
	  var newTargetUserId = targetUserId || prevTargetId;
	  var newCaregiverCircles = caregiverCircles || prevCaregiverCircles;
	  var newDependentsList = dependentsList || prevDependentsList;
	  var isLoggedUser = newTargetUserId === newLoggedUserId;
	  var isCaregiver = newCaregiverCircles && newCaregiverCircles.includes(newTargetUserId);
	  var isVerifiedDependent = newDependentsList && newDependentsList.includes(newTargetUserId);
	  var isFamilyMemberOnly = targetUser ? targetUser.actualFamilyMember : state.isFamilyMemberOnly;
	
	  return {
	    isFamilyMemberOnly: isFamilyMemberOnly,
	    loggedUserId: newLoggedUserId,
	    targetUserId: newTargetUserId,
	    caregiverCircles: newCaregiverCircles,
	    dependentsList: newDependentsList,
	    isLoggedUser: isLoggedUser,
	    isCaregiver: isCaregiver,
	    isVerifiedDependent: isVerifiedDependent
	  };
	};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	  switch (type) {
	    case consts.UPDATE:
	      return updatePermissions(state, payload);
	    case consts.REMOVE:
	      return (0, _extends3.default)({}, initialState, { loggedUserId: null });
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dashboardFilterActions = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _dateFilterFormat = __webpack_require__(1919);
	
	var _createAction = __webpack_require__(68);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var appointmentList = _interopRequireWildcard(_appointmentListReq);
	
	var _filterTypes = __webpack_require__(1272);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardFilterActions = exports.dashboardFilterActions = {
	  setFilter: (0, _createAction.createAction)(_filterTypes.DASHBOARD_FILTER_TYPES.SET_FILTER),
	  addDisplayableByDefault: (0, _createAction.createAction)(_filterTypes.DASHBOARD_FILTER_TYPES.ADD_DISPLAYABLE_BY_DEFAULT)
	};
	
	var initialState = {
	  date: (0, _dateFilterFormat.formatDashboardFilterDate)(new Date()),
	  locations: [],
	  services: [],
	  statuses: [],
	  filterLoaded: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _filterTypes.DASHBOARD_FILTER_TYPES.ADD_DISPLAYABLE_BY_DEFAULT:
	      {
	        return (0, _extends3.default)({}, state, payload, {
	          filterLoaded: true
	        });
	      }
	    case _filterTypes.DASHBOARD_FILTER_TYPES.SET_FILTER:
	      {
	        return (0, _extends3.default)({}, state, payload);
	      }
	    case appointmentList.consts.PAGE_LEAVE:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['VALIDATE_PATIENT_INFO', 'SAVE_PATIENT_INFO_ERROR', 'SAVE_COMMON_ERRORS', 'SAVE_PATIENT_INFO', 'CLEAR_ERRORS', 'CLEAR'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['dashboard', 'record'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  patient: {},
	  patientValidationError: null,
	  commonErrors: null
	};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	  switch (type) {
	    case consts.SAVE_PATIENT_INFO_ERROR:
	      return (0, _extends3.default)({}, state, {
	        patientValidationError: payload
	      });
	    case consts.SAVE_COMMON_ERRORS:
	      return (0, _extends3.default)({}, state, {
	        commonErrors: payload
	      });
	    case consts.SAVE_PATIENT_INFO:
	      return (0, _extends3.default)({}, state, {
	        patient: payload,
	        patientValidationError: null
	      });
	    case consts.CLEAR_ERRORS:
	      return (0, _extends3.default)({}, state, {
	        commonErrors: null,
	        patientValidationError: null
	      });
	    case consts.CLEAR:
	      return initialState;
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'change-paid-status-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'virtual_visits', {
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'payment_status_changes']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'create-appointment-req', []);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dashboard',
	  type: 'post',
	  slug: ['appointments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'appointment-pin-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dashboard',
	  type: 'put',
	  slug: ['appointments', {
	    type: 'payload',
	    selector: ['id']
	  }, 'pin']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('data', 'publicConstants');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'public_constants',
	  type: 'get'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentForm', 'documents-upload');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dependent_registration',
	  type: 'post',
	  slug: ['assignments', {
	    type: 'payload',
	    selector: ['id']
	  }, 'documents']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectUpdateAssignmentLoading = exports.selectUpdateAssignmentState = exports.selectAssignmentListLoading = exports.selectReviewedAssignmentListCount = exports.selectReviewedAssignmentListPagination = exports.selectReviewedAssignmentList = exports.selectReviewedAssignmentState = exports.selectPendingAssignmentListCount = exports.selectPendingAssignmentListPagination = exports.selectPendingAssignmentList = exports.selectPendingAssignmentState = exports.selectDependentManagementState = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _some = __webpack_require__(986);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectDependentManagementState = exports.selectDependentManagementState = function selectDependentManagementState(state) {
	  return (0, _get2.default)(state, 'dependentManagement');
	};
	
	/**
	 *  PENDING ASSIGNMENTS
	 * */
	var selectPendingAssignmentState = exports.selectPendingAssignmentState = (0, _reselect.createSelector)(selectDependentManagementState, function (state) {
	  return (0, _get2.default)(state, 'assignmentPending');
	});
	
	var selectPendingAssignmentList = exports.selectPendingAssignmentList = (0, _reselect.createSelector)(selectPendingAssignmentState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectPendingAssignmentListPagination = exports.selectPendingAssignmentListPagination = (0, _reselect.createSelector)(selectPendingAssignmentState, function (state) {
	  return (0, _get2.default)(state, 'pagination', {});
	});
	
	var selectPendingAssignmentListCount = exports.selectPendingAssignmentListCount = (0, _reselect.createSelector)(selectPendingAssignmentState, function (state) {
	  return (0, _get2.default)(state, 'count');
	});
	
	/**
	 *  REVIEWED ASSIGNMENTS
	 * */
	
	var selectReviewedAssignmentState = exports.selectReviewedAssignmentState = (0, _reselect.createSelector)(selectDependentManagementState, function (state) {
	  return (0, _get2.default)(state, 'assignmentReviewed');
	});
	
	var selectReviewedAssignmentList = exports.selectReviewedAssignmentList = (0, _reselect.createSelector)(selectReviewedAssignmentState, function (state) {
	  return (0, _get2.default)(state, 'list', []);
	});
	
	var selectReviewedAssignmentListPagination = exports.selectReviewedAssignmentListPagination = (0, _reselect.createSelector)(selectReviewedAssignmentState, function (state) {
	  return (0, _get2.default)(state, 'pagination', {});
	});
	
	var selectReviewedAssignmentListCount = exports.selectReviewedAssignmentListCount = (0, _reselect.createSelector)(selectReviewedAssignmentState, function (state) {
	  return (0, _get2.default)(state, 'count');
	});
	
	var selectAssignmentListLoading = exports.selectAssignmentListLoading = (0, _reselect.createSelector)(selectReviewedAssignmentState, selectPendingAssignmentState, function () {
	  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
	    states[_key] = arguments[_key];
	  }
	
	  return (0, _some2.default)(states, function (_ref) {
	    var sending = _ref.sending;
	    return sending;
	  });
	});
	
	/**
	 *  UPDATE ASSIGNMENT
	 * */
	
	var selectUpdateAssignmentState = exports.selectUpdateAssignmentState = (0, _reselect.createSelector)(selectDependentManagementState, function (state) {
	  return (0, _get2.default)(state, 'assignmentUpdate');
	});
	
	var selectUpdateAssignmentLoading = exports.selectUpdateAssignmentLoading = (0, _reselect.createSelector)(selectUpdateAssignmentState, function (state) {
	  return (0, _get2.default)(state, 'sending');
	});

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makeDeleteGuarantorConfig = function makeDeleteGuarantorConfig() {
	  return {
	    endpoint: 'users',
	    type: 'delete',
	    slug: [{
	      type: 'payload',
	      selector: ['userId']
	    }, 'guarantors', {
	      type: 'payload',
	      selector: ['id']
	    }]
	  };
	};
	
	var requestOptions = makeDeleteGuarantorConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('remove-guarantor');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makeUpdateGuarantorConfig = function makeUpdateGuarantorConfig() {
	  return {
	    endpoint: 'users',
	    type: 'put',
	    slug: [{
	      type: 'payload',
	      selector: ['userId']
	    }, 'guarantors', {
	      type: 'payload',
	      selector: ['id']
	    }]
	  };
	};
	
	var requestOptions = makeUpdateGuarantorConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('update-guarantor');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.activeTodoActions = exports.ACTIVE_TODO_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'healthboard/active-todo';
	
	var ACTIVE_TODO_TYPES = exports.ACTIVE_TODO_TYPES = {
	  SET_ACTIVE_ITEM: actionsScope + '/set-active-item'
	};
	
	var activeTodoActions = exports.activeTodoActions = {
	  setActiveItem: (0, _createAction.createAction)(ACTIVE_TODO_TYPES.SET_ACTIVE_ITEM)
	};
	
	var initialState = {
	  activeItem: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case ACTIVE_TODO_TYPES.SET_ACTIVE_ITEM:
	      {
	        return (0, _extends3.default)({}, state, {
	          activeItem: payload
	        });
	      }
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preVisitConsentsModalActions = exports.APPOINTMENT_SURVEY_ASSIGNMENTS = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	var _upcomingSurvey = __webpack_require__(433);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'healthboard/appointment-survey-assignment';
	
	var APPOINTMENT_SURVEY_ASSIGNMENTS = exports.APPOINTMENT_SURVEY_ASSIGNMENTS = {
	  SET_SURVEYS: actionsScope + '/set-surveys',
	  SET_ASSIGNMENT_ID: actionsScope + '/set-assignment-id'
	};
	
	var preVisitConsentsModalActions = exports.preVisitConsentsModalActions = {
	  setSurveys: (0, _createAction.createAction)(APPOINTMENT_SURVEY_ASSIGNMENTS.SET_SURVEYS),
	  setAssignmentId: (0, _createAction.createAction)(APPOINTMENT_SURVEY_ASSIGNMENTS.SET_ASSIGNMENT_ID)
	};
	
	var initialState = {
	  surveys: [],
	  assignmentId: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case APPOINTMENT_SURVEY_ASSIGNMENTS.SET_SURVEYS:
	      {
	        return (0, _extends3.default)({}, state, {
	          surveys: payload
	        });
	      }
	
	    case APPOINTMENT_SURVEY_ASSIGNMENTS.SET_ASSIGNMENT_ID:
	      {
	        return (0, _extends3.default)({}, state, {
	          assignmentId: payload
	        });
	      }
	
	    case _upcomingSurvey.consts.CLEAR:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          surveys: state.surveys
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-activity-log', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'activity_logs', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  list: [],
	  offset: 0,
	  isLastPage: false
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SEND:
	      return (0, _extends3.default)({}, state, {
	        succeed: false,
	        sending: true,
	        offset: payload && payload.offset
	      });
	    case consts.SUCCEED:
	      return (0, _extends3.default)({}, state, {
	        succeed: true,
	        sending: false,
	        isLastPage: payload && !payload.length,
	        list: state.list && state.list.length !== 0 ? state.list.concat(payload) : payload
	      });
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'medication-refill', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'medication_refills', 'refills']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-medications-refills-history');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'medication_refills', 'histories']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shareToChatModalActions = exports.SHARE_TO_CHAT_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'patient-portal/share-to-chat-modal';
	
	var SHARE_TO_CHAT_MODAL = exports.SHARE_TO_CHAT_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var shareToChatModalActions = exports.shareToChatModalActions = {
	  open: (0, _createAction.createAction)(SHARE_TO_CHAT_MODAL.OPEN),
	  close: (0, _createAction.createAction)(SHARE_TO_CHAT_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  documentUid: ''
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case SHARE_TO_CHAT_MODAL.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          documentUid: payload.documentUid,
	          opened: true
	        });
	      }
	
	    case SHARE_TO_CHAT_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-share-to-email');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccda', 'email_sharing_user_documents']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeVirtualAppointmentListReqConfig = exports.makeAppointmentListReqConfig = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeAppointmentListReqConfig = exports.makeAppointmentListReqConfig = function makeAppointmentListReqConfig() {
	  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return {
	    endpoint: 'users',
	    type: 'get',
	    slug: [{
	      type: 'payload',
	      selector: ['id']
	    }, 'appointments', {
	      type: 'payload.query',
	      queryParameter: 'limit',
	      selector: 'limit'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'offset',
	      selector: 'offset'
	    }].concat((0, _toConsumableArray3.default)(slug))
	  };
	};
	
	var makeVirtualAppointmentListReqConfig = exports.makeVirtualAppointmentListReqConfig = function makeVirtualAppointmentListReqConfig() {
	  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return {
	    endpoint: 'users',
	    type: 'get',
	    slug: [{
	      type: 'payload',
	      selector: ['id']
	    }, 'appointments', 'virtual_visits', 'provider_appointments', {
	      type: 'payload.query',
	      queryParameter: 'limit',
	      selector: 'limit'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'offset',
	      selector: 'offset'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'visit_type_code',
	      selector: 'visit_type_code'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'date',
	      selector: 'date'
	    }].concat((0, _toConsumableArray3.default)(slug))
	  };
	};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'cancel-invite-quest');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'delete',
	  slug: ['virtual_visits', 'room_invitation']
	});

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'complete-care-plan-task', ['START']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'todo',
	  type: 'put',
	  slug: ['care_plan_tasks', {
	    type: 'payload',
	    selector: ['task_id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'complete-task-custom', ['START']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'todo',
	  type: 'put',
	  slug: ['users', {
	    type: 'payload',
	    selector: ['user_id']
	  }, 'custom_tasks', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'connection-room-join-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'p2p',
	  type: 'post',
	  slug: ['room_connection', 'join']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case statusChange.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          appointmentId: payload.id
	        });
	      }
	
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, {
	          temp: payload.guests.map(function (el) {
	            return el.email || el.phoneNumber;
	          }) || [],
	          send: (0, _extends3.default)({}, state.send, {
	            error: null,
	            sending: true
	          })
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          temp: [],
	          existing: (0, _concat2.default)(state.existing, state.temp),
	          send: (0, _extends3.default)({}, state.send, {
	            succeed: true,
	            sending: false
	          })
	        });
	      }
	
	    case consts.REJECTED:
	    case consts.ERROR_ENCOUNTERED:
	      {
	        return (0, _extends3.default)({}, state, {
	          send: (0, _extends3.default)({}, state.send, {
	            sending: false,
	            error: payload
	          })
	        });
	      }
	
	    case consts.CLEAR:
	      {
	        return (0, _extends3.default)({
	          appointmentId: state.appointmentId
	        }, initialState);
	      }
	
	    case cancelInvitation.consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, {
	          cancel: (0, _extends3.default)({}, state.cancel, {
	            sending: true
	          })
	        });
	      }
	
	    case cancelInvitation.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          cancel: (0, _extends3.default)({}, state.cancel, {
	            succeed: true,
	            sending: false
	          })
	        });
	      }
	
	    case cancelInvitation.consts.REJECTED:
	    case cancelInvitation.consts.ERROR_ENCOUNTERED:
	      {
	        return (0, _extends3.default)({}, state, {
	          cancel: (0, _extends3.default)({}, state.cancel, {
	            sending: false,
	            error: payload
	          })
	        });
	      }
	
	    case _virtualVisit.VIRTUAL_VISIT_TYPES.RESET:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _concat = __webpack_require__(2347);
	
	var _concat2 = _interopRequireDefault(_concat);
	
	var _redux = __webpack_require__(7);
	
	var _virtualVisit = __webpack_require__(305);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var statusChange = _interopRequireWildcard(_statusChangeReq);
	
	var _cancelInvitationToVirtualRoomReq = __webpack_require__(851);
	
	var cancelInvitation = _interopRequireWildcard(_cancelInvitationToVirtualRoomReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'invite-quest', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: ['virtual_visits', 'room_invitation']
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = {
	  temp: [],
	  existing: [],
	  appointmentId: null,
	  send: {
	    sending: false,
	    succeed: null,
	    error: null
	  },
	  cancel: {
	    sending: false,
	    succeed: null,
	    error: null
	  }
	};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'network-test-credentials-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'appointments', 'virtual_visits', 'network_test_credentials']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'payment-orders');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['appointmentId']
	  }, 'payment_orders', {
	    type: 'payload.query',
	    queryParameter: 'coupon_identifier',
	    selector: 'coupon'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'room-invitation-info');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['virtual_visits', 'room_invitation', {
	    type: 'payload.query',
	    selector: 'inviteCode',
	    queryParameter: 'invite_code'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var _handleUpdateStateWithCompleteSurvey = __webpack_require__(770);
	
	var _handleUpdateStateWithAcceptedConsent = __webpack_require__(769);
	
	var _handleUpdateStateWithUploadDoc = __webpack_require__(772);
	
	var _handleUpdateStateWithDeleteDoc = __webpack_require__(771);
	
	var _appointmentReqConfig = __webpack_require__(850);
	
	var _uploadDocumentReq = __webpack_require__(304);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _deleteDocumentReq = __webpack_require__(302);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var requestOptions = (0, _appointmentReqConfig.makeVirtualAppointmentListReqConfig)([{
	  type: 'payload.query',
	  queryParameter: 'scope',
	  value: 'history_list'
	}]);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'history-virtual-appointment-list-req', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('health-board', 'history-virtual-appointment-list-lazy-load');
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions, true);
	
	var reducer = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'appointmentsCount'
	});
	
	exports.default = function (state, action) {
	  switch (action.type) {
	    case _uploadDocumentReq.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithUploadDoc.handleUpdateStateWithUploadDoc)(state, action);
	      }
	
	    case _upcomingSurveyCompletions.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithCompleteSurvey.handleUpdateStatusSurveyInAppointmentDetails)(state, action);
	      }
	
	    case _deleteDocumentReq.consts.UPDATE:
	      {
	        return (0, _handleUpdateStateWithDeleteDoc.handleUpdateStateWithDeleteDoc)(state, action);
	      }
	
	    case _signAppointmentConsentReq.consts.SUCCEED:
	      {
	        return (0, _handleUpdateStateWithAcceptedConsent.handleUpdateStateWithAcceptedConsent)(state, action);
	      }
	
	    default:
	      return reducer(state, action);
	  }
	};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handleInvitationsSaga = handleInvitationsSaga;
	exports.handleAppoiintmnetStatusChangeSaga = handleAppoiintmnetStatusChangeSaga;
	exports.handleHealthBoardCancelAppoinntmentSaga = handleHealthBoardCancelAppoinntmentSaga;
	exports.handleMessagesCancelAppointmentSaga = handleMessagesCancelAppointmentSaga;
	exports.default = healthboardRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _refillsAvailableMedicationsReq = __webpack_require__(1302);
	
	var refillsAvailableMedications = _interopRequireWildcard(_refillsAvailableMedicationsReq);
	
	var _medicationRefillsHistory = __webpack_require__(847);
	
	var medicationRefillsHistory = _interopRequireWildcard(_medicationRefillsHistory);
	
	var _patientChannelsForShare = __webpack_require__(1300);
	
	var patientChannelsForShare = _interopRequireWildcard(_patientChannelsForShare);
	
	var _socialChannelsForShare = __webpack_require__(1306);
	
	var socialChannelsForShare = _interopRequireWildcard(_socialChannelsForShare);
	
	var _setPreferredPharmacyReq = __webpack_require__(532);
	
	var setPreferredPharmacy = _interopRequireWildcard(_setPreferredPharmacyReq);
	
	var _availableCategories = __webpack_require__(1289);
	
	var availableCategories = _interopRequireWildcard(_availableCategories);
	
	var _labResultHistoryReq = __webpack_require__(1297);
	
	var labResultHistory = _interopRequireWildcard(_labResultHistoryReq);
	
	var _medicationRefillReq = __webpack_require__(846);
	
	var medicationRefill = _interopRequireWildcard(_medicationRefillReq);
	
	var _labTestResultsReq = __webpack_require__(1298);
	
	var labTestResults = _interopRequireWildcard(_labTestResultsReq);
	
	var _resultsDetailsReq = __webpack_require__(1304);
	
	var resultsDetails = _interopRequireWildcard(_resultsDetailsReq);
	
	var _socialHistoryReq = __webpack_require__(1307);
	
	var socialHistory = _interopRequireWildcard(_socialHistoryReq);
	
	var _loggingActionReq = __webpack_require__(663);
	
	var loggingAction = _interopRequireWildcard(_loggingActionReq);
	
	var _immunizationsReq = __webpack_require__(1295);
	
	var immunizations = _interopRequireWildcard(_immunizationsReq);
	
	var _shareToEmailReq = __webpack_require__(849);
	
	var shareToEmail = _interopRequireWildcard(_shareToEmailReq);
	
	var _healthRecordReq = __webpack_require__(1294);
	
	var healthRecord = _interopRequireWildcard(_healthRecordReq);
	
	var _shareToChatReq = __webpack_require__(664);
	
	var shareToChat = _interopRequireWildcard(_shareToChatReq);
	
	var _familyHistory = __webpack_require__(1293);
	
	var familyHistory = _interopRequireWildcard(_familyHistory);
	
	var _activityLogReq = __webpack_require__(845);
	
	var activityLog = _interopRequireWildcard(_activityLogReq);
	
	var _medicationsReq = __webpack_require__(1299);
	
	var medications = _interopRequireWildcard(_medicationsReq);
	
	var _encountersReq = __webpack_require__(1292);
	
	var encounters = _interopRequireWildcard(_encountersReq);
	
	var _proceduresReq = __webpack_require__(1301);
	
	var procedures = _interopRequireWildcard(_proceduresReq);
	
	var _conditionsReq = __webpack_require__(1291);
	
	var conditions = _interopRequireWildcard(_conditionsReq);
	
	var _allergiesReq = __webpack_require__(1288);
	
	var allergies = _interopRequireWildcard(_allergiesReq);
	
	var _medicationRefillSaga = __webpack_require__(4104);
	
	var _medicationRefillSaga2 = _interopRequireDefault(_medicationRefillSaga);
	
	var _shareToChatSaga = __webpack_require__(4089);
	
	var _shareToChatSaga2 = _interopRequireDefault(_shareToChatSaga);
	
	var _confirmVisitByPatientReq = __webpack_require__(666);
	
	var confirmVisitByPatient = _interopRequireWildcard(_confirmVisitByPatientReq);
	
	var _inviteGuestToVirtualRoomReq = __webpack_require__(855);
	
	var inviteGuest = _interopRequireWildcard(_inviteGuestToVirtualRoomReq);
	
	var _cancelInvitationToVirtualRoomReq = __webpack_require__(851);
	
	var cancelInviteGuest = _interopRequireWildcard(_cancelInvitationToVirtualRoomReq);
	
	var _completeCarePlanTaskReq = __webpack_require__(852);
	
	var completeCarePlanTask = _interopRequireWildcard(_completeCarePlanTaskReq);
	
	var _appointmentsHistoryReq = __webpack_require__(347);
	
	var historyAppointments = _interopRequireWildcard(_appointmentsHistoryReq);
	
	var _appointmentsUpcommingReq = __webpack_require__(348);
	
	var upcomingAppointments = _interopRequireWildcard(_appointmentsUpcommingReq);
	
	var _virtualAppointmentsHistoryReq = __webpack_require__(859);
	
	var providerHistoryAppointments = _interopRequireWildcard(_virtualAppointmentsHistoryReq);
	
	var _virtualAppointmentsUpcommingReq = __webpack_require__(670);
	
	var providerUpcomingAppointments = _interopRequireWildcard(_virtualAppointmentsUpcommingReq);
	
	var _checkInAppointmentReq = __webpack_require__(533);
	
	var checkinAppointment = _interopRequireWildcard(_checkInAppointmentReq);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var cancelAppointment = _interopRequireWildcard(_cancelAppointmentReq);
	
	var _couponVerificationReq = __webpack_require__(418);
	
	var couponVerification = _interopRequireWildcard(_couponVerificationReq);
	
	var _couponPriceCalculationReq = __webpack_require__(667);
	
	var couponCalculation = _interopRequireWildcard(_couponPriceCalculationReq);
	
	var _paymentOrderReq = __webpack_require__(857);
	
	var paymentOrder = _interopRequireWildcard(_paymentOrderReq);
	
	var _paymentVerificationsReq = __webpack_require__(419);
	
	var paymentVerifications = _interopRequireWildcard(_paymentVerificationsReq);
	
	var _payaRedirectionReq = __webpack_require__(1309);
	
	var payaRedirection = _interopRequireWildcard(_payaRedirectionReq);
	
	var _editPaymentReq = __webpack_require__(349);
	
	var editPayment = _interopRequireWildcard(_editPaymentReq);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var statusChanges = _interopRequireWildcard(_statusChangeReq);
	
	var _statusUrgentVisitChangeReq = __webpack_require__(669);
	
	var statusUrgentVisitChanges = _interopRequireWildcard(_statusUrgentVisitChangeReq);
	
	var _networkTestCredentialsReq = __webpack_require__(856);
	
	var networkTestCredentials = _interopRequireWildcard(_networkTestCredentialsReq);
	
	var _roomInvitationJoinReq = __webpack_require__(1310);
	
	var roomInvitationJoin = _interopRequireWildcard(_roomInvitationJoinReq);
	
	var _roomInvitationInfoReq = __webpack_require__(858);
	
	var roomInvitationInfo = _interopRequireWildcard(_roomInvitationInfoReq);
	
	var _joinByVisitCodeReq = __webpack_require__(668);
	
	var joinByVisitCode = _interopRequireWildcard(_joinByVisitCodeReq);
	
	var _connectionRoomJoinReq = __webpack_require__(854);
	
	var connectionRoomJoin = _interopRequireWildcard(_connectionRoomJoinReq);
	
	var _uploadDocumentReq = __webpack_require__(304);
	
	var uploadDocument = _interopRequireWildcard(_uploadDocumentReq);
	
	var _deleteDocumentReq = __webpack_require__(302);
	
	var deleteDocument = _interopRequireWildcard(_deleteDocumentReq);
	
	var _scheduledTasksUpcomingReq = __webpack_require__(303);
	
	var scheduledTasks = _interopRequireWildcard(_scheduledTasksUpcomingReq);
	
	var _scheduledTasksCompletedReq = __webpack_require__(534);
	
	var completedTasks = _interopRequireWildcard(_scheduledTasksCompletedReq);
	
	var _completeTaskReq = __webpack_require__(665);
	
	var completeTask = _interopRequireWildcard(_completeTaskReq);
	
	var _completeTaskCustomReq = __webpack_require__(853);
	
	var completeTaskCustom = _interopRequireWildcard(_completeTaskCustomReq);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var signAppointmentConsent = _interopRequireWildcard(_signAppointmentConsentReq);
	
	var _getGeoLocationsReq = __webpack_require__(1308);
	
	var geoLocations = _interopRequireWildcard(_getGeoLocationsReq);
	
	var _managePendingRequest = __webpack_require__(263);
	
	var managePendingRequest = _interopRequireWildcard(_managePendingRequest);
	
	var _providerAppointmentListPagination = __webpack_require__(4107);
	
	var _providerAppointmentListPagination2 = _interopRequireDefault(_providerAppointmentListPagination);
	
	var _changeStatusSaga = __webpack_require__(4095);
	
	var _changeStatusSaga2 = _interopRequireDefault(_changeStatusSaga);
	
	var _roomInvitationJoinSaga = __webpack_require__(4108);
	
	var _roomInvitationJoinSaga2 = _interopRequireDefault(_roomInvitationJoinSaga);
	
	var _appointmentListPagination = __webpack_require__(4092);
	
	var _appointmentListPagination2 = _interopRequireDefault(_appointmentListPagination);
	
	var _scheduledTasksPagination = __webpack_require__(4109);
	
	var _scheduledTasksPagination2 = _interopRequireDefault(_scheduledTasksPagination);
	
	var _completedTasksPagination = __webpack_require__(4096);
	
	var _completedTasksPagination2 = _interopRequireDefault(_completedTasksPagination);
	
	var _cancelAppointmentSaga = __webpack_require__(4093);
	
	var _manageTodoSaga = __webpack_require__(4103);
	
	var _manageTodoSaga2 = _interopRequireDefault(_manageTodoSaga);
	
	var _validateHealthboardSaga = __webpack_require__(4113);
	
	var _validateHealthboardSaga2 = _interopRequireDefault(_validateHealthboardSaga);
	
	var _uploadDocumentSaga = __webpack_require__(4112);
	
	var _uploadDocumentSaga2 = _interopRequireDefault(_uploadDocumentSaga);
	
	var _deleteDocumentSaga = __webpack_require__(4099);
	
	var _deleteDocumentSaga2 = _interopRequireDefault(_deleteDocumentSaga);
	
	var _acceptedConsent = __webpack_require__(4090);
	
	var _acceptedConsent2 = _interopRequireDefault(_acceptedConsent);
	
	var _paymentSaga = __webpack_require__(4106);
	
	var _paymentSaga2 = _interopRequireDefault(_paymentSaga);
	
	var _managePending = __webpack_require__(4102);
	
	var _managePending2 = _interopRequireDefault(_managePending);
	
	var _inviteQuestToVirtualRoomSaga = __webpack_require__(4101);
	
	var _inviteQuestToVirtualRoomSaga2 = _interopRequireDefault(_inviteQuestToVirtualRoomSaga);
	
	var _cancelInvitationToVirtualVisitSaga = __webpack_require__(4094);
	
	var _cancelInvitationToVirtualVisitSaga2 = _interopRequireDefault(_cancelInvitationToVirtualVisitSaga);
	
	var _activityLogLoadMore = __webpack_require__(4091);
	
	var _activityLogLoadMore2 = _interopRequireDefault(_activityLogLoadMore);
	
	var _confirmVisitByPatient = __webpack_require__(4097);
	
	var _confirmVisitByPatient2 = _interopRequireDefault(_confirmVisitByPatient);
	
	var _testCallInPopupSaga = __webpack_require__(4111);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleInvitationsSaga),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleAppoiintmnetStatusChangeSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleHealthBoardCancelAppoinntmentSaga),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleMessagesCancelAppointmentSaga),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(healthboardRootSaga);
	
	/** Patient Portal */
	
	
	function handleInvitationsSaga() {
	  return _regenerator2.default.wrap(function handleInvitationsSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_manageTodoSaga2.default);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.call)(_validateHealthboardSaga2.default);
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleAppoiintmnetStatusChangeSaga() {
	  return _regenerator2.default.wrap(function handleAppoiintmnetStatusChangeSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.fork)(_managePending2.default);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleHealthBoardCancelAppoinntmentSaga() {
	  return _regenerator2.default.wrap(function handleHealthBoardCancelAppoinntmentSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.fork)(_cancelAppointmentSaga.healthboardCancelSaga);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function handleMessagesCancelAppointmentSaga() {
	  return _regenerator2.default.wrap(function handleMessagesCancelAppointmentSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.fork)(_cancelAppointmentSaga.messagesAppointmentCancelSaga);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function healthboardRootSaga() {
	  return _regenerator2.default.wrap(function healthboardRootSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.fork)(historyAppointments.watcher);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.fork)(historyAppointments.paginationWatcher);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.fork)(upcomingAppointments.watcher);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.fork)(upcomingAppointments.paginationWatcher);
	
	        case 8:
	          _context5.next = 10;
	          return (0, _effects.fork)(providerHistoryAppointments.watcher);
	
	        case 10:
	          _context5.next = 12;
	          return (0, _effects.fork)(providerHistoryAppointments.paginationWatcher);
	
	        case 12:
	          _context5.next = 14;
	          return (0, _effects.fork)(providerUpcomingAppointments.watcher);
	
	        case 14:
	          _context5.next = 16;
	          return (0, _effects.fork)(providerUpcomingAppointments.paginationWatcher);
	
	        case 16:
	          _context5.next = 18;
	          return (0, _effects.fork)(completeCarePlanTask.watcher);
	
	        case 18:
	          _context5.next = 20;
	          return (0, _effects.fork)(scheduledTasks.watcher);
	
	        case 20:
	          _context5.next = 22;
	          return (0, _effects.fork)(scheduledTasks.paginationWatcher);
	
	        case 22:
	          _context5.next = 24;
	          return (0, _effects.fork)(completedTasks.watcher);
	
	        case 24:
	          _context5.next = 26;
	          return (0, _effects.fork)(completedTasks.paginationWatcher);
	
	        case 26:
	          _context5.next = 28;
	          return (0, _effects.fork)(checkinAppointment.watcher);
	
	        case 28:
	          _context5.next = 30;
	          return (0, _effects.fork)(cancelAppointment.watcher);
	
	        case 30:
	          _context5.next = 32;
	          return (0, _effects.fork)(couponVerification.watcher);
	
	        case 32:
	          _context5.next = 34;
	          return (0, _effects.fork)(couponCalculation.watcher);
	
	        case 34:
	          _context5.next = 36;
	          return (0, _effects.fork)(paymentOrder.watcher);
	
	        case 36:
	          _context5.next = 38;
	          return (0, _effects.fork)(paymentVerifications.watcher);
	
	        case 38:
	          _context5.next = 40;
	          return (0, _effects.fork)(payaRedirection.watcher);
	
	        case 40:
	          _context5.next = 42;
	          return (0, _effects.fork)(statusChanges.watcher);
	
	        case 42:
	          _context5.next = 44;
	          return (0, _effects.fork)(statusUrgentVisitChanges.watcher);
	
	        case 44:
	          _context5.next = 46;
	          return (0, _effects.fork)(editPayment.watcher);
	
	        case 46:
	          _context5.next = 48;
	          return (0, _effects.fork)(uploadDocument.watcher);
	
	        case 48:
	          _context5.next = 50;
	          return (0, _effects.fork)(deleteDocument.watcher);
	
	        case 50:
	          _context5.next = 52;
	          return (0, _effects.fork)(signAppointmentConsent.watcher);
	
	        case 52:
	          _context5.next = 54;
	          return (0, _effects.fork)(completeTaskCustom.watcher);
	
	        case 54:
	          _context5.next = 56;
	          return (0, _effects.fork)(completeTask.watcher);
	
	        case 56:
	          _context5.next = 58;
	          return (0, _effects.fork)(geoLocations.watcher);
	
	        case 58:
	          _context5.next = 60;
	          return (0, _effects.fork)(roomInvitationInfo.watcher);
	
	        case 60:
	          _context5.next = 62;
	          return (0, _effects.fork)(roomInvitationJoin.watcher);
	
	        case 62:
	          _context5.next = 64;
	          return (0, _effects.fork)(joinByVisitCode.watcher);
	
	        case 64:
	          _context5.next = 66;
	          return (0, _effects.fork)(connectionRoomJoin.watcher);
	
	        case 66:
	          _context5.next = 68;
	          return (0, _effects.fork)(networkTestCredentials.watcher);
	
	        case 68:
	          _context5.next = 70;
	          return (0, _effects.fork)(managePendingRequest.watcher);
	
	        case 70:
	          _context5.next = 72;
	          return (0, _effects.fork)(_providerAppointmentListPagination2.default);
	
	        case 72:
	          _context5.next = 74;
	          return (0, _effects.fork)(_changeStatusSaga2.default);
	
	        case 74:
	          _context5.next = 76;
	          return (0, _effects.fork)(_appointmentListPagination2.default);
	
	        case 76:
	          _context5.next = 78;
	          return (0, _effects.fork)(_scheduledTasksPagination2.default);
	
	        case 78:
	          _context5.next = 80;
	          return (0, _effects.fork)(_completedTasksPagination2.default);
	
	        case 80:
	          _context5.next = 82;
	          return (0, _effects.fork)(_roomInvitationJoinSaga2.default);
	
	        case 82:
	          _context5.next = 84;
	          return (0, _effects.fork)(_uploadDocumentSaga2.default);
	
	        case 84:
	          _context5.next = 86;
	          return (0, _effects.fork)(_deleteDocumentSaga2.default);
	
	        case 86:
	          _context5.next = 88;
	          return (0, _effects.fork)(_acceptedConsent2.default);
	
	        case 88:
	          _context5.next = 90;
	          return (0, _effects.fork)(_paymentSaga2.default);
	
	        case 90:
	          _context5.next = 92;
	          return (0, _effects.fork)(_activityLogLoadMore2.default);
	
	        case 92:
	          _context5.next = 94;
	          return (0, _effects.fork)(_medicationRefillSaga2.default);
	
	        case 94:
	          _context5.next = 96;
	          return (0, _effects.fork)(_shareToChatSaga2.default);
	
	        case 96:
	          _context5.next = 98;
	          return (0, _effects.fork)(refillsAvailableMedications.watcher);
	
	        case 98:
	          _context5.next = 100;
	          return (0, _effects.fork)(medicationRefillsHistory.watcher);
	
	        case 100:
	          _context5.next = 102;
	          return (0, _effects.fork)(patientChannelsForShare.watcher);
	
	        case 102:
	          _context5.next = 104;
	          return (0, _effects.fork)(socialChannelsForShare.watcher);
	
	        case 104:
	          _context5.next = 106;
	          return (0, _effects.fork)(setPreferredPharmacy.watcher);
	
	        case 106:
	          _context5.next = 108;
	          return (0, _effects.fork)(availableCategories.watcher);
	
	        case 108:
	          _context5.next = 110;
	          return (0, _effects.fork)(labResultHistory.watcher);
	
	        case 110:
	          _context5.next = 112;
	          return (0, _effects.fork)(medicationRefill.watcher);
	
	        case 112:
	          _context5.next = 114;
	          return (0, _effects.fork)(labTestResults.watcher);
	
	        case 114:
	          _context5.next = 116;
	          return (0, _effects.fork)(resultsDetails.watcher);
	
	        case 116:
	          _context5.next = 118;
	          return (0, _effects.fork)(immunizations.watcher);
	
	        case 118:
	          _context5.next = 120;
	          return (0, _effects.fork)(socialHistory.watcher);
	
	        case 120:
	          _context5.next = 122;
	          return (0, _effects.fork)(familyHistory.watcher);
	
	        case 122:
	          _context5.next = 124;
	          return (0, _effects.fork)(loggingAction.watcher);
	
	        case 124:
	          _context5.next = 126;
	          return (0, _effects.fork)(healthRecord.watcher);
	
	        case 126:
	          _context5.next = 128;
	          return (0, _effects.fork)(shareToEmail.watcher);
	
	        case 128:
	          _context5.next = 130;
	          return (0, _effects.fork)(medications.watcher);
	
	        case 130:
	          _context5.next = 132;
	          return (0, _effects.fork)(shareToChat.watcher);
	
	        case 132:
	          _context5.next = 134;
	          return (0, _effects.fork)(activityLog.watcher);
	
	        case 134:
	          _context5.next = 136;
	          return (0, _effects.fork)(encounters.watcher);
	
	        case 136:
	          _context5.next = 138;
	          return (0, _effects.fork)(procedures.watcher);
	
	        case 138:
	          _context5.next = 140;
	          return (0, _effects.fork)(conditions.watcher);
	
	        case 140:
	          _context5.next = 142;
	          return (0, _effects.fork)(allergies.watcher);
	
	        case 142:
	          _context5.next = 144;
	          return (0, _effects.fork)(inviteGuest.watcher);
	
	        case 144:
	          _context5.next = 146;
	          return (0, _effects.fork)(_inviteQuestToVirtualRoomSaga2.default);
	
	        case 146:
	          _context5.next = 148;
	          return (0, _effects.fork)(cancelInviteGuest.watcher);
	
	        case 148:
	          _context5.next = 150;
	          return (0, _effects.fork)(_cancelInvitationToVirtualVisitSaga2.default);
	
	        case 150:
	          _context5.next = 152;
	          return (0, _effects.fork)(confirmVisitByPatient.watcher);
	
	        case 152:
	          _context5.next = 154;
	          return (0, _effects.fork)(_confirmVisitByPatient2.default);
	
	        case 154:
	          _context5.next = 156;
	          return (0, _effects.fork)(_testCallInPopupSaga.watchTestCallModalOpen);
	
	        case 156:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('invitations', 'caregiver', ['REMOVE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'caregiver_invitations',
	  type: 'get'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var removeItem = function removeItem(state, _ref) {
	  var id = _ref.id;
	
	  var list = (0, _arrayModify.removeArrayItem)((0, _get2.default)(state, 'list', []), 'id', id);
	
	  return (0, _extends3.default)({}, state, { list: list });
	};
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.REMOVE:
	      return removeItem(state, payload);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('invitations', 'familyCircle', ['REMOVE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'family_member_invitations',
	  type: 'get'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var removeItem = function removeItem(state, _ref) {
	  var id = _ref.id;
	
	  var list = (0, _arrayModify.removeArrayItem)((0, _get2.default)(state, 'list', []), 'id', id);
	
	  return (0, _extends3.default)({}, state, { list: list });
	};
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.REMOVE:
	      return removeItem(state, payload);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('invitations', 'guardian', ['REMOVE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'guardian_proxy_invitations',
	  type: 'get'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var removeItem = function removeItem(state, _ref) {
	  var id = _ref.id;
	
	  var list = (0, _arrayModify.removeArrayItem)((0, _get2.default)(state, 'list', []), 'id', id);
	
	  return (0, _extends3.default)({}, state, { list: list });
	};
	
	exports.default = function (state, action) {
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.REMOVE:
	      return removeItem(state, payload);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectInsuranceToDoTaskCompleting = exports.selectUploadInsuranceCardModalData = exports.selectInsuranceRelatedDataFetching = exports.selectRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'managePatientInsurances.common');
	};
	
	var selectInsuranceRelatedDataFetching = exports.selectInsuranceRelatedDataFetching = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'pending', false);
	});
	
	var selectUploadInsuranceCardModalData = exports.selectUploadInsuranceCardModalData = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'uploadInsuranceCardModal');
	});
	
	var selectInsuranceToDoTaskCompleting = exports.selectInsuranceToDoTaskCompleting = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'isInsuranceToDoTaskCompleting', false);
	});

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReduxEmitter = undefined;
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _actions = __webpack_require__(1318);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReduxEmitter = exports.ReduxEmitter = function () {
	  function ReduxEmitter(dispatch) {
	    (0, _classCallCheck3.default)(this, ReduxEmitter);
	
	    this.dispatch = dispatch;
	  }
	
	  (0, _createClass3.default)(ReduxEmitter, [{
	    key: 'dispatchAddConnection',
	    value: function dispatchAddConnection(payload) {
	      this.dispatch(_actions.opentokActions.addConnection(payload));
	    }
	  }, {
	    key: 'dispatchRemoveConnection',
	    value: function dispatchRemoveConnection(payload) {
	      this.dispatch(_actions.opentokActions.removeConnection(payload));
	    }
	  }, {
	    key: 'dispatchUpdateConnection',
	    value: function dispatchUpdateConnection(payload) {
	      this.dispatch(_actions.opentokActions.updateConnection(payload));
	    }
	  }, {
	    key: 'dispatchAddActiveSpeaker',
	    value: function dispatchAddActiveSpeaker(payload) {
	      this.dispatch(_actions.opentokActions.addSpeaker(payload));
	    }
	  }, {
	    key: 'dispatchRemoveActiveSpeaker',
	    value: function dispatchRemoveActiveSpeaker(payload) {
	      this.dispatch(_actions.opentokActions.removeSpeaker(payload));
	    }
	  }, {
	    key: 'dispatchSetConnectionTime',
	    value: function dispatchSetConnectionTime(payload) {
	      this.dispatch(_actions.opentokActions.setStartCallTime(payload));
	    }
	  }, {
	    key: 'dispatchSetDurationData',
	    value: function dispatchSetDurationData(payload) {
	      this.dispatch(_actions.opentokActions.setDurationData(payload));
	    }
	  }, {
	    key: 'dispatchAddVideoWarningId',
	    value: function dispatchAddVideoWarningId(payload) {
	      this.dispatch(_actions.opentokActions.addVideoWarningId(payload));
	    }
	  }, {
	    key: 'dispatchRemoveVideoWarningId',
	    value: function dispatchRemoveVideoWarningId(payload) {
	      this.dispatch(_actions.opentokActions.removeVideoWarningId(payload));
	    }
	  }, {
	    key: 'dispatchFindScreenSharing',
	    value: function dispatchFindScreenSharing() {
	      this.dispatch(_actions.opentokActions.findScreenSharing());
	    }
	  }, {
	    key: 'dispatchUpdateInvitations',
	    value: function dispatchUpdateInvitations(payload) {
	      this.dispatch(_actions.opentokActions.updateInvitations(payload));
	    }
	  }, {
	    key: 'dispatchReset',
	    value: function dispatchReset() {
	      this.dispatch(_actions.opentokActions.reset());
	    }
	  }, {
	    key: 'dispatchToggleLoading',
	    value: function dispatchToggleLoading(flag) {
	      this.dispatch(_actions.opentokActions.toggleLoading(flag));
	    }
	  }, {
	    key: 'dispatchSetActiveId',
	    value: function dispatchSetActiveId(id) {
	      this.dispatch(_actions.opentokActions.setActiveId(id));
	    }
	  }]);
	  return ReduxEmitter;
	}();

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SET_USER_DETAILS:
	      {
	        return (0, _extends3.default)({}, state, action.payload);
	      }
	
	    case _applyGuarantorReq.consts.SUCCEED:
	      {
	        var pathname = window.location.pathname;
	
	
	        if (pathname.includes(_routes.PAPERWORK)) {
	          return (0, _extends3.default)({}, state, {
	            primaryPatientProfile: (0, _extends3.default)({}, state.primaryPatientProfile, {
	              guarantorUser: (0, _extends3.default)({}, state.primaryPatientProfile.guarantorUser, action.payload)
	            })
	          });
	        }
	      }
	
	    case _editPatientEmergencyContact.consts.SUCCEED:
	    case _editPatient.consts.SUCCEED:
	    case _editUser.consts.SUCCEED:
	      {
	        var payloadUserId = (0, _get2.default)(action, 'payload.id', null);
	
	        var userId = (0, _get2.default)(state, 'id', null);
	
	        if (userId && payloadUserId === userId) {
	          return (0, _extends3.default)({}, state, action.payload);
	        }
	
	        return state;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _editUser = __webpack_require__(136);
	
	var _editPatient = __webpack_require__(218);
	
	var _applyGuarantorReq = __webpack_require__(660);
	
	var _editPatientEmergencyContact = __webpack_require__(1325);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('paperwork', 'user-details', ['SET_USER_DETAILS']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('paperwork', 'submit-appointment');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'paperwork',
	  type: 'put',
	  slug: ['appointments', {
	    type: 'payload',
	    selector: ['appointmentUUID']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makePaymentsReqConfig = function makePaymentsReqConfig() {
	  return {
	    endpoint: 'paya',
	    type: 'get',
	    slug: ['users', {
	      type: 'payload',
	      selector: ['userId']
	    }, 'organizations']
	  };
	};
	
	var requestOptions = makePaymentsReqConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('payment-methods', 'payments');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectAccountVaultsLocationsByAccountVaultId = exports.selectIsPaymentListFetching = exports.selectPaymentList = exports.selectLocationListIsFetching = exports.selectLocationList = exports.selectOrganizationList = exports.selectRootState = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'paymentMethods');
	};
	
	var selectOrganizationList = exports.selectOrganizationList = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'organizationList.list', []);
	});
	
	var selectLocationList = exports.selectLocationList = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'locationList.list', []);
	});
	
	var selectLocationListIsFetching = exports.selectLocationListIsFetching = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'locationList.sending', false);
	});
	
	var selectPaymentList = exports.selectPaymentList = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'paymentList.list', []);
	});
	
	var selectIsPaymentListFetching = exports.selectIsPaymentListFetching = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'paymentList.sending', false);
	});
	
	var selectAccountVaultsLocationsByAccountVaultId = exports.selectAccountVaultsLocationsByAccountVaultId = function selectAccountVaultsLocationsByAccountVaultId(accountVaultId) {
	  return (0, _reselect.createSelector)(selectPaymentList, function (paymentList) {
	    var accountVaultItem = paymentList.flatMap(function (x) {
	      return x.accountvaults;
	    }).find(function (_ref) {
	      var accountvault = _ref.accountvault;
	      return accountvault.id === accountVaultId;
	    });
	
	    return (0, _get2.default)(accountVaultItem, 'associatedLocations', []);
	  });
	};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'change-profile-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'delete-user-attachment');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'attachments', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'delete-user-outcome-attachment');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'todo',
	  type: 'delete',
	  slug: ['outcome_attachments', {
	    type: 'payload.query',
	    queryParameter: 'id',
	    selector: 'id'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'edit-avatar');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'put',
	  slug: [{
	    type: 'localStorage',
	    selector: ['edit-avatar-user-id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'getFamilyMember');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'family_members', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('context', 'fetch-main-consent');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['messaging_consents']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	/* This is just copy of get-user request because we need get TEAM user info on page reload
	 * and not to store it as a target user in context. Our target user saga is watching on success request for
	 * user profiles, so it's a separated request only for fetching user on page reload.
	 * */
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'get-team-user');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'profiles',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPatientAttachmentsData = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var payload = action.payload;
	
	  switch (action.type) {
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          succeed: true,
	          sending: false,
	          consents: payload.consents,
	          paperConsents: payload.paperConsents,
	          list: getPatientAttachmentsData(payload)
	        });
	      }
	    case consts.DELETE_ITEM:
	      {
	        var uniqId = payload.uniqId;
	
	        var updatedList = (0, _get2.default)(state, 'list').filter(function (item) {
	          return item.uniqId !== uniqId;
	        });
	        return (0, _extends3.default)({}, state, {
	          list: updatedList
	        });
	      }
	    default:
	      return defaultReducer(state, action);
	  }
	};
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _index = __webpack_require__(17);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOCUMENTS = _index.PATIENT_ATTACHMENTS_TYPE.DOCUMENTS,
	    OUTCOME_ATTACHMENTS = _index.PATIENT_ATTACHMENTS_TYPE.OUTCOME_ATTACHMENTS;
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'get-user-attachments', ['DELETE_ITEM']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'providers',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'patients', {
	    type: 'payload',
	    selector: ['userId']
	  }, 'documents']
	});
	
	var getPatientAttachmentsData = exports.getPatientAttachmentsData = function getPatientAttachmentsData(data) {
	  var _ref = data || {},
	      _ref$documents = _ref.documents,
	      documents = _ref$documents === undefined ? [] : _ref$documents,
	      _ref$outcomeAttachmen = _ref.outcomeAttachments,
	      outcomeAttachments = _ref$outcomeAttachmen === undefined ? [] : _ref$outcomeAttachmen;
	
	  var modifiedDocuments = documents.map(function (attachment, index) {
	    return (0, _extends3.default)({}, attachment, {
	      uniqId: DOCUMENTS + '-' + index,
	      type: DOCUMENTS
	    });
	  });
	
	  var modifiedOutcomeAttachments = outcomeAttachments.map(function (attachment, index) {
	    return (0, _extends3.default)({}, attachment, {
	      uniqId: OUTCOME_ATTACHMENTS + '-' + index,
	      type: OUTCOME_ATTACHMENTS
	    });
	  });
	
	  return [].concat((0, _toConsumableArray3.default)(modifiedDocuments), (0, _toConsumableArray3.default)(modifiedOutcomeAttachments)).sort(function (first, second) {
	    return (0, _get2.default)(first, 'category.name') > (0, _get2.default)(second, 'category.name') ? 1 : -1;
	  });
	};
	
	var defaultReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'disable-mfa');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'mfa_settings',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'enable-mfa', ['RESET']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'mfa_settings',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addDataModalActions = exports.ADD_DATA_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'profile/add-data-modal';
	
	var ADD_DATA_MODAL = exports.ADD_DATA_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var addDataModalActions = exports.addDataModalActions = {
	  open: (0, _createAction.createAction)(ADD_DATA_MODAL.OPEN),
	  close: (0, _createAction.createAction)(ADD_DATA_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  type: 'weight'
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case ADD_DATA_MODAL.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          opened: true,
	          type: payload.type
	        });
	      }
	
	    case ADD_DATA_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'bloodPressure-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['blood_pressure_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'bmi-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['bmi_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'connected-devices');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['devices']
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.googleFitModalActions = exports.GOOGLE_FIT_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'profile/google-fit-modal';
	
	var GOOGLE_FIT_MODAL = exports.GOOGLE_FIT_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var googleFitModalActions = exports.googleFitModalActions = {
	  open: (0, _createAction.createAction)(GOOGLE_FIT_MODAL.OPEN),
	  close: (0, _createAction.createAction)(GOOGLE_FIT_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type;
	
	  switch (type) {
	    case GOOGLE_FIT_MODAL.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          opened: true
	        });
	      }
	
	    case GOOGLE_FIT_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'remove-account');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'delete',
	  slug: ['provider_authentications', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'respiratoryRate-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['respiratory_rate_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'vitals-activity');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['vitals', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'weight-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['weight_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          sending: true
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, _redux.initialState, {
	          succeed: true,
	          data: action.payload
	        });
	      }
	
	    case consts.RESET:
	      {
	        return _redux.initialState;
	      }
	
	    default:
	      return defaultReducer(state, action);
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'public-user', ['RESET']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'public_data',
	  type: 'get',
	  slug: ['users', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	var defaultReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'acceptConsent', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  slug: [{ type: 'payload', selector: ['userId'] }, 'programs', { type: 'payload', selector: ['programId'] }, 'consents', { type: 'payload', selector: ['consentId'] }, 'assignments'],
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'joinedPrograms');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'patient_programs', {
	    type: 'payload.query',
	    queryParameter: 'filter_by',
	    selector: 'filterBy'
	  }]
	}, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'leave', ['INIT']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  slug: [{ type: 'payload', selector: ['userId'] }, 'patient_programs', { type: 'payload', selector: ['programId'] }],
	  type: 'delete'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'submitPaymentProgram');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'paya',
	  slug: ['transactions'],
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scheduleFilterActions = exports.SCHEDULE_FILTER_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	var _dateFormatter = __webpack_require__(314);
	
	var _validate = __webpack_require__(143);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'schedule/filter';
	
	var SCHEDULE_FILTER_TYPES = exports.SCHEDULE_FILTER_TYPES = {
	  NEXT_WEEK: actionsScope + '/next-week',
	  PREV_WEEK: actionsScope + '/prev-week',
	  SET_DATE: actionsScope + '/set-date',
	  RESET: actionsScope + '/reset'
	};
	
	var scheduleFilterActions = exports.scheduleFilterActions = {
	  nextWeek: (0, _createAction.createAction)(SCHEDULE_FILTER_TYPES.NEXT_WEEK),
	  prevWeek: (0, _createAction.createAction)(SCHEDULE_FILTER_TYPES.PREV_WEEK),
	  setDate: (0, _createAction.createAction)(SCHEDULE_FILTER_TYPES.SET_DATE),
	  reset: (0, _createAction.createAction)(SCHEDULE_FILTER_TYPES.RESET)
	};
	
	var initialState = (0, _extends3.default)({}, (0, _dateFormatter.getInitDateState)());
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case SCHEDULE_FILTER_TYPES.PREV_WEEK:
	      {
	        return (0, _extends3.default)({}, state, (0, _dateFormatter.calculatePrevWeek)(state.startOn));
	      }
	    case SCHEDULE_FILTER_TYPES.NEXT_WEEK:
	      {
	        return (0, _extends3.default)({}, state, (0, _dateFormatter.calculateNextWeek)(state.startOn));
	      }
	    case SCHEDULE_FILTER_TYPES.SET_DATE:
	      {
	        return (0, _extends3.default)({}, state, (0, _dateFormatter.getInitDateState)(payload));
	      }
	
	    case _validate.SCHEDULE_VALIDATE_TYPES.CLEAR:
	    case scheduleFilterActions.RESET:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'create-appointment', ['START']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'providers',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['providerUserId']
	  }, 'patients', {
	    type: 'payload',
	    selector: ['patientUserId']
	  }, 'appointments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	// POST /api/providers/:provider_user_id/patients/:patient_user_id/appointments

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'intercection-count');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var daysParams = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(function (day) {
	  return {
	    type: 'payload.query',
	    queryParameter: day,
	    selector: day
	  };
	});
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'schedule', 'intersection_ids', {
	    type: 'payload.query',
	    queryParameter: 'start_on',
	    selector: 'startOn'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'end_on',
	    selector: 'endOn'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'start_time',
	    selector: 'startTime'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'end_time',
	    selector: 'endTime'
	  }].concat((0, _toConsumableArray3.default)(daysParams))
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'services');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'appointments', 'locations', {
	    type: 'payload',
	    selector: ['locationId']
	  }, 'services']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'appointment-consent');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'survey_assignments', {
	    type: 'payload',
	    selector: ['assignmentId']
	  }, 'appointment_consent.json', {
	    type: 'payload.query',
	    queryParameter: 'appointment_consent_id',
	    selector: ['appointmentConsentId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'exportToPDF');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'pdf_results', {
	    type: 'payload',
	    selector: ['assignmentId']
	  }],
	  options: { responseType: 'blob' }
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _createReducer;
	
	var _camelize = __webpack_require__(364);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['ADD_SURVEY', 'REMOVE_SURVEY', 'CLEAR', 'RESTORE'];
	
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['surveys', 'saved'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {};
	
	// persistence
	var getPersistedState = function getPersistedState() {
	  var storedUser = window.storage.getItem('user'); // eslint-disable-line jsx-control-statements/jsx-jcs-no-undef
	
	  var _ref = storedUser ? JSON.parse(storedUser) : {},
	      id = _ref.id;
	
	  if (id) {
	    var persistedState = window.storage.getItem('saved-surveys-' + id); // eslint-disable-line jsx-control-statements/jsx-jcs-no-undef
	
	    return persistedState ? JSON.parse(persistedState) : initialState;
	  }
	
	  return initialState;
	};
	
	var addSurvey = function addSurvey(state, action) {
	  var _action$payload = action.payload,
	      userId = _action$payload.userId,
	      surveyId = _action$payload.surveyId,
	      answers = _action$payload.answers;
	
	
	  return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, userId, (0, _assign2.default)({}, (0, _get2.default)(state, [userId]), (0, _defineProperty3.default)({}, surveyId, (0, _camelize2.default)(answers)))));
	};
	
	var removeSurvey = function removeSurvey(state, action) {
	  var _action$payload2 = action.payload,
	      userId = _action$payload2.userId,
	      surveyId = _action$payload2.surveyId;
	
	
	  if ((0, _get2.default)(state, [userId, surveyId])) {
	    var updatedState = state;
	    delete updatedState[userId][surveyId];
	
	    return updatedState;
	  }
	
	  return state;
	};
	
	exports.default = (0, _redux.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, consts.ADD_SURVEY, addSurvey), (0, _defineProperty3.default)(_createReducer, consts.REMOVE_SURVEY, removeSurvey), (0, _defineProperty3.default)(_createReducer, consts.CLEAR, function () {
	  return initialState;
	}), (0, _defineProperty3.default)(_createReducer, consts.RESTORE, getPersistedState), _createReducer));

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'send');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'upcoming_assignments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'createChat', 'TOGGLE_VISIBILITY');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  visible: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.TOGGLE_VISIBILITY:
	      return (0, _extends3.default)({}, state, {
	        visible: !state.visible
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var supportedActions = ['OPEN_VIEWER', 'CLOSE'];
	
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['ui', 'imageViewer'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  opened: false,
	  src: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.OPEN_VIEWER:
	      return { opened: true, src: action.payload.src };
	    case consts.CLOSE:
	      return initialState;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.fullProviderSubtitle = fullProviderSubtitle;
	exports.shortProviderSubtitle = shortProviderSubtitle;
	exports.transformProviderNameWithTitle = transformProviderNameWithTitle;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fullProviderSubtitle(provider) {
	  return [(0, _get2.default)(provider, 'specialization'), (0, _get2.default)(provider, 'organization.name')].filter(function (str) {
	    return !!str;
	  }).join(', ');
	}
	
	function shortProviderSubtitle(provider) {
	  return (0, _get2.default)(provider, 'organization.name');
	}
	
	function transformProviderNameWithTitle(provider) {
	  return (0, _extends3.default)({}, provider, {
	    name: [(0, _get2.default)(provider, 'name'), (0, _get2.default)(provider, 'title')].filter(function (str) {
	      return !!str;
	    }).join(', ')
	  });
	}

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _env = __webpack_require__(103);
	
	var _isValidUrlByRegex = __webpack_require__(4220);
	
	var checkIsAppStoreLinksAvailability = function checkIsAppStoreLinksAvailability() {
	  var showPlayMarketLink = (0, _isValidUrlByRegex.isValidUrlByRegex)(_env.PLAY_MARKET_APP_LINK);
	
	  var showAppStoreLink = (0, _isValidUrlByRegex.isValidUrlByRegex)(_env.APP_STORE_APP_LINK);
	
	  var hasAtLeastOneStoreLink = showPlayMarketLink || showAppStoreLink;
	
	  return { hasAtLeastOneStoreLink: hasAtLeastOneStoreLink, showAppStoreLink: showAppStoreLink, showPlayMarketLink: showPlayMarketLink };
	};
	
	exports.default = checkIsAppStoreLinksAvailability;

/***/ }),
/* 906 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref, formatMessage, additionalRole) {
	  var roleDescriptor = _ref.role,
	      caregiver = _ref.caregiver,
	      guardian = _ref.guardian,
	      proxy = _ref.proxy,
	      parent = _ref.parent;
	
	  if (!roleDescriptor) return null;
	
	  var roles = [formatMessage({ id: 'circles.roles.' + roleDescriptor })];
	
	  if (caregiver) {
	    roles.push(formatMessage({ id: 'circles.roles.caregiver' }));
	  }
	
	  if (guardian) {
	    roles.push(formatMessage({ id: 'circles.roles.guardian' }));
	  }
	
	  if (proxy) {
	    roles.push(formatMessage({ id: 'circles.roles.proxy' }));
	  }
	
	  if (parent) {
	    roles.push(formatMessage({ id: 'circles.roles.parent' }));
	  }
	  if (additionalRole) {
	    roles.push(additionalRole);
	  }
	
	  return roles.join(', ');
	};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAdditionalInsuranceCardDocumentsConfig = exports.getDriverLicenseDocumentConfig = exports.getInsuranceCardDocumentsConfig = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _capitalize = __webpack_require__(209);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_FILE_SIZE = 32;
	
	var getDocumentFrontSideText = function getDocumentFrontSideText(_ref) {
	  var formatMessage = _ref.formatMessage,
	      isEditMode = _ref.isEditMode;
	
	  return isEditMode ? formatMessage({
	    id: 'community.newPost.addPhoto'
	  }) + ' \n(' + formatMessage({ id: 'documentation.common.frontSide' }) + ')' : '' + (0, _capitalize2.default)(formatMessage({
	    id: 'documentation.common.frontSide'
	  }));
	};
	
	var getDocumentBackSideText = function getDocumentBackSideText(_ref2) {
	  var formatMessage = _ref2.formatMessage,
	      isEditMode = _ref2.isEditMode;
	
	  return isEditMode ? formatMessage({
	    id: 'community.newPost.addPhoto'
	  }) + ' \n(' + formatMessage({ id: 'documentation.common.backSide' }) + ')' : '' + (0, _capitalize2.default)(formatMessage({
	    id: 'documentation.common.backSide'
	  }));
	};
	
	var getInsuranceCardDocumentsConfig = exports.getInsuranceCardDocumentsConfig = function getInsuranceCardDocumentsConfig(_ref3) {
	  var formatMessage = _ref3.formatMessage,
	      userDocuments = _ref3.userDocuments,
	      isEditMode = _ref3.isEditMode;
	
	  var getDocumentDataByKey = function getDocumentDataByKey(key, param) {
	    var document = userDocuments.find(function (doc) {
	      return doc.key === key;
	    });
	
	    return (0, _get2.default)(document, param);
	  };
	
	  var frontCardUrl = getDocumentDataByKey(_constants.DOCUMENTATION_TYPES.CARD_1, 'attachment.thumbMiddle');
	
	  var backCardUrl = getDocumentDataByKey(_constants.DOCUMENTATION_TYPES.CARD_2, 'attachment.thumbMiddle');
	
	  var sectionTitle = formatMessage({
	    id: 'profile.fields.insuranceCard'
	  }) + '  ' + (isEditMode ? formatMessage({ id: 'common.optional' }) : '');
	
	  return {
	    sectionTitle: sectionTitle,
	    fields: [{
	      key: _constants.DOCUMENTATION_TYPES.CARD_1,
	      hideEllipsis: true,
	      type: 'image',
	      fieldName: _constants.DOCUMENTATION_TYPES.CARD_1,
	      id: getDocumentDataByKey(_constants.DOCUMENTATION_TYPES.CARD_1, 'id'),
	      maxFileSize: MAX_FILE_SIZE,
	      value: '',
	      src: frontCardUrl,
	      label: getDocumentFrontSideText({ formatMessage: formatMessage, isEditMode: isEditMode })
	    }, {
	      key: _constants.DOCUMENTATION_TYPES.CARD_2,
	      hideEllipsis: true,
	      type: 'image',
	      fieldName: _constants.DOCUMENTATION_TYPES.CARD_2,
	      id: getDocumentDataByKey(_constants.DOCUMENTATION_TYPES.CARD_2, 'id'),
	      maxFileSize: MAX_FILE_SIZE,
	      value: '',
	      src: backCardUrl,
	      label: getDocumentBackSideText({ formatMessage: formatMessage, isEditMode: isEditMode })
	    }]
	  };
	};
	
	var getDriverLicenseDocumentConfig = exports.getDriverLicenseDocumentConfig = function getDriverLicenseDocumentConfig(_ref4) {
	  var formatMessage = _ref4.formatMessage,
	      userDocuments = _ref4.userDocuments,
	      isEditMode = _ref4.isEditMode;
	
	  var getDocumentDataByKey = function getDocumentDataByKey(key, param) {
	    var document = userDocuments.find(function (doc) {
	      return doc.key === key;
	    });
	    return (0, _get2.default)(document, param);
	  };
	
	  var extraTitle = isEditMode ? formatMessage({ id: 'common.optional' }) : '';
	
	  var src = getDocumentDataByKey(_constants.DOCUMENTATION_TYPES.DRIVER_LICENCE, 'attachment.thumbMiddle');
	
	  var id = getDocumentDataByKey(_constants.DOCUMENTATION_TYPES.DRIVER_LICENCE, 'id');
	
	  var text = formatMessage({
	    id: 'community.newPost.addPhoto'
	  });
	
	  var disabledText = formatMessage({
	    id: 'profile.fields.driverLicense'
	  });
	
	  var name = formatMessage({
	    id: 'profile.fields.driverLicense'
	  }) + ' ' + extraTitle;
	
	  var title = formatMessage({ id: 'documentation.common.title' });
	
	  var sectionTitle = disabledText + '  ' + (isEditMode ? formatMessage({ id: 'common.optional' }) : '');
	
	  var label = formatMessage({
	    id: 'community.newPost.addPhoto'
	  });
	
	  return {
	    title: title,
	    sectionTitle: sectionTitle,
	    fields: [{
	      name: name,
	      label: label,
	      hideEllipsis: true,
	      type: 'image',
	      fieldName: _constants.DOCUMENTATION_TYPES.DRIVER_LICENCE,
	      id: id,
	      limit: MAX_FILE_SIZE,
	      value: '',
	      src: src,
	      text: text,
	      disabledText: disabledText
	    }]
	  };
	};
	
	var getAdditionalInsuranceCardDocumentsConfig = exports.getAdditionalInsuranceCardDocumentsConfig = function getAdditionalInsuranceCardDocumentsConfig(_ref5) {
	  var formatMessage = _ref5.formatMessage,
	      userDocuments = _ref5.userDocuments,
	      isEditMode = _ref5.isEditMode,
	      fieldName = _ref5.fieldName;
	
	  var frontSideFieldName = fieldName + '_1';
	  var backSideFieldName = fieldName + '_2';
	
	  var getDocumentDataByKey = function getDocumentDataByKey(key, param) {
	    var document = userDocuments.find(function (doc) {
	      return doc.key === key;
	    });
	
	    return (0, _get2.default)(document, param);
	  };
	
	  var frontCardUrl = getDocumentDataByKey(frontSideFieldName, 'attachment.thumbMiddle');
	
	  var backCardUrl = getDocumentDataByKey(backSideFieldName, 'attachment.thumbMiddle');
	
	  var sectionTitle = formatMessage({
	    id: 'profile.fields.insuranceCard'
	  }) + '  ' + (isEditMode ? formatMessage({ id: 'common.optional' }) : '');
	
	  return {
	    sectionTitle: sectionTitle,
	    fields: [{
	      key: frontSideFieldName,
	      hideEllipsis: true,
	      type: 'image',
	      fieldName: frontSideFieldName,
	      id: getDocumentDataByKey(frontSideFieldName, 'id'),
	      maxFileSize: MAX_FILE_SIZE,
	      value: '',
	      src: frontCardUrl,
	      label: getDocumentFrontSideText({ formatMessage: formatMessage, isEditMode: isEditMode })
	    }, {
	      key: backSideFieldName,
	      hideEllipsis: true,
	      type: 'image',
	      fieldName: backSideFieldName,
	      id: getDocumentDataByKey(backSideFieldName, 'id'),
	      maxFileSize: MAX_FILE_SIZE,
	      value: '',
	      src: backCardUrl,
	      label: getDocumentBackSideText({ formatMessage: formatMessage, isEditMode: isEditMode })
	    }]
	  };
	};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _pick = __webpack_require__(466);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _join = __webpack_require__(2352);
	
	var _join2 = _interopRequireDefault(_join);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _getUserDescription = __webpack_require__(1923);
	
	var _getUserDescription2 = _interopRequireDefault(_getUserDescription);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPreparedProfileData = function getPreparedProfileData(profile, genderTypesList, formatMessage) {
	  var _detailsData;
	
	  var dob = profile.dob,
	      gender = profile.gender,
	      employeeProfile = profile.employeeProfile;
	
	
	  var ageString = dob && (0, _moment2.default)(dob).format('M/D/YYYY');
	  var genderString = (0, _getUserDescription2.default)({ gender: gender }, genderTypesList, formatMessage);
	
	  var shortDescription = (0, _getUserDescription2.default)(profile, genderTypesList, formatMessage);
	
	  var advancedDob = (0, _join2.default)((0, _compact2.default)([genderString, ageString]), ', ');
	
	  var initData = {
	    allergies: null,
	    medicine: null,
	    healthGoals: null,
	    mrns: []
	  };
	
	  var payload = profile.primaryPatientProfile ? (0, _pick2.default)(profile.primaryPatientProfile, (0, _keys2.default)(initData)) : initData;
	
	  var allergies = payload.allergies,
	      medicine = payload.medicine,
	      healthGoals = payload.healthGoals,
	      _payload$mrns = payload.mrns,
	      mrns = _payload$mrns === undefined ? [] : _payload$mrns;
	
	
	  var detailsData = (_detailsData = {}, (0, _defineProperty3.default)(_detailsData, formatMessage(_strings.PROFILE_FIELDS.fieldNames.allergies), allergies), (0, _defineProperty3.default)(_detailsData, formatMessage(_strings.PROFILE_FIELDS.fieldNames.medicine), medicine), (0, _defineProperty3.default)(_detailsData, formatMessage(_strings.PROFILE_FIELDS.fieldNames.healthGoals), healthGoals), _detailsData);
	
	  return {
	    avatar: profile.avatar && profile.avatar.thumbMin,
	    name: (0, _get2.default)(profile, 'displayableName'),
	    shortDescription: shortDescription,
	    advancedDob: advancedDob,
	    details: (0, _keys2.default)(detailsData).reduce(function (acc, key) {
	      if (detailsData[key]) {
	        acc.push({
	          definition: key,
	          description: detailsData[key]
	        });
	      }
	
	      return acc;
	    }, []),
	    mrns: mrns.map(function (mrn) {
	      return {
	        mrn: (0, _get2.default)(mrn, 'localUid'),
	        organization: (0, _get2.default)(mrn, 'organization.name')
	      };
	    }),
	    employers: employeeProfile && employeeProfile.employeeEmployers.map(function (item) {
	      var employeeType = (0, _get2.default)(item, 'employersEmployeeType.name', '');
	      return {
	        id: item.externalId,
	        name: item.employer.name,
	        type: employeeType
	      };
	    })
	  };
	};
	
	exports.default = getPreparedProfileData;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(550);
	
	var _from2 = _interopRequireDefault(_from);
	
	exports.handleAge = handleAge;
	exports.getYearsInRange = getYearsInRange;
	exports.getDaysOfMonth = getDaysOfMonth;
	exports.getMonths = getMonths;
	
	var _format = __webpack_require__(319);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _slice = __webpack_require__(5518);
	
	var _slice2 = _interopRequireDefault(_slice);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _difference_in_years = __webpack_require__(2174);
	
	var _difference_in_years2 = _interopRequireDefault(_difference_in_years);
	
	var _strings = __webpack_require__(15);
	
	var _dateConverters = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CURRENT_YEAR = (0, _moment2.default)().format('YYYY');
	var CURRENT_MONTH = (0, _moment2.default)().format('MM');
	
	var handleDOB = function handleDOB(date, formatMessage) {
	  // Safari bug - new Date does not work with UI format
	  var apiDate = (0, _dateConverters.convertDateToAPIFormat)(date, formatMessage);
	  var age = handleAge(date, formatMessage);
	  var dob = (0, _format2.default)(apiDate, formatMessage(_strings.DAY_FORMATTING_PATTERN));
	
	  return dob + ' (' + age + ')';
	};
	
	function handleAge(date, formatMessage) {
	  var apiDate = (0, _dateConverters.convertDateToAPIFormat)(date, formatMessage);
	  var age = (0, _difference_in_years2.default)(new Date(), apiDate);
	
	  return age + ' ' + formatMessage({ id: 'general.labels.YO' });
	}
	
	exports.default = handleDOB;
	function getYearsInRange(start, end) {
	  var currentYear = end || (0, _moment2.default)().get('year');
	  var years = Array(currentYear - start + 1).fill().map(function (_, idx) {
	    return start + idx;
	  });
	  return years.map(function (item) {
	    return {
	      value: (0, _moment2.default)().year(item).format('YYYY'),
	      label: (0, _moment2.default)().year(item).format('YYYY')
	    };
	  });
	}
	
	function getDaysOfMonth(year, month) {
	  var dayCount = (0, _moment2.default)(year + '-' + month, 'YYYY-MM').daysInMonth();
	
	  var days = [];
	  (0, _from2.default)({ length: dayCount }, function (index, value) {
	    return days.push({
	      value: (0, _moment2.default)(year + '-' + month + '-' + (value + 1), 'YYYY-MM-DD').format('DD'),
	      label: (0, _moment2.default)(year + '-' + month + '-' + (value + 1), 'YYYY-MM-DD').format('DD')
	    });
	  });
	
	  if (year === CURRENT_YEAR && month === CURRENT_MONTH) {
	    return (0, _slice2.default)(days, 0, (0, _moment2.default)().get('date'));
	  }
	
	  return days;
	}
	
	function getMonths(year) {
	  var months = _moment2.default.months();
	
	  var formattedMonths = months.map(function (item) {
	    return {
	      value: (0, _moment2.default)().month(item).format('MM'),
	      label: item
	    };
	  });
	
	  if (year === CURRENT_YEAR) {
	    return (0, _slice2.default)(formattedMonths, 0, (0, _moment2.default)().get('month') + 1);
	  }
	
	  return formattedMonths;
	}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (data) {
	  var value = null;
	
	  try {
	    value = JSON.parse(data);
	  } catch (e) {}
	
	  return value;
	};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return _validations.PATTERNS.AMOUNT.test(value);
	};
	
	var _validations = __webpack_require__(81);

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Reusable object
			var W = [];
	
			/**
	   * SHA-1 hash algorithm.
	   */
			var SHA1 = C_algo.SHA1 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init([0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var H = this._hash.words;
	
					// Working variables
					var a = H[0];
					var b = H[1];
					var c = H[2];
					var d = H[3];
					var e = H[4];
	
					// Computation
					for (var i = 0; i < 80; i++) {
						if (i < 16) {
							W[i] = M[offset + i] | 0;
						} else {
							var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
							W[i] = n << 1 | n >>> 31;
						}
	
						var t = (a << 5 | a >>> 27) + e + W[i];
						if (i < 20) {
							t += (b & c | ~b & d) + 0x5a827999;
						} else if (i < 40) {
							t += (b ^ c ^ d) + 0x6ed9eba1;
						} else if (i < 60) {
							t += (b & c | b & d | c & d) - 0x70e44324;
						} else /* if (i < 80) */{
								t += (b ^ c ^ d) - 0x359d3e2a;
							}
	
						e = d;
						d = c;
						c = b << 30 | b >>> 2;
						b = a;
						a = t;
					}
	
					// Intermediate hash value
					H[0] = H[0] + a | 0;
					H[1] = H[1] + b | 0;
					H[2] = H[2] + c | 0;
					H[3] = H[3] + d | 0;
					H[4] = H[4] + e | 0;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Return final computed hash
					return this._hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA1('message');
	   *     var hash = CryptoJS.SHA1(wordArray);
	   */
			C.SHA1 = Hasher._createHelper(SHA1);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA1(message, key);
	   */
			C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
		})();
	
		return CryptoJS.SHA1;
	});

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(363));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(363)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Hasher = C_lib.Hasher;
			var C_x64 = C.x64;
			var X64Word = C_x64.Word;
			var X64WordArray = C_x64.WordArray;
			var C_algo = C.algo;
	
			function X64Word_create() {
				return X64Word.create.apply(X64Word, arguments);
			}
	
			// Constants
			var K = [X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd), X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc), X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019), X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118), X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe), X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2), X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1), X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694), X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3), X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65), X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483), X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5), X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210), X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4), X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725), X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70), X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926), X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df), X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8), X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b), X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001), X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30), X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910), X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8), X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53), X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8), X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb), X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3), X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60), X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec), X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9), X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b), X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207), X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178), X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6), X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b), X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493), X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c), X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a), X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)];
	
			// Reusable objects
			var W = [];
			(function () {
				for (var i = 0; i < 80; i++) {
					W[i] = X64Word_create();
				}
			})();
	
			/**
	   * SHA-512 hash algorithm.
	   */
			var SHA512 = C_algo.SHA512 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = new X64WordArray.init([new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b), new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1), new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f), new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcuts
					var H = this._hash.words;
	
					var H0 = H[0];
					var H1 = H[1];
					var H2 = H[2];
					var H3 = H[3];
					var H4 = H[4];
					var H5 = H[5];
					var H6 = H[6];
					var H7 = H[7];
	
					var H0h = H0.high;
					var H0l = H0.low;
					var H1h = H1.high;
					var H1l = H1.low;
					var H2h = H2.high;
					var H2l = H2.low;
					var H3h = H3.high;
					var H3l = H3.low;
					var H4h = H4.high;
					var H4l = H4.low;
					var H5h = H5.high;
					var H5l = H5.low;
					var H6h = H6.high;
					var H6l = H6.low;
					var H7h = H7.high;
					var H7l = H7.low;
	
					// Working variables
					var ah = H0h;
					var al = H0l;
					var bh = H1h;
					var bl = H1l;
					var ch = H2h;
					var cl = H2l;
					var dh = H3h;
					var dl = H3l;
					var eh = H4h;
					var el = H4l;
					var fh = H5h;
					var fl = H5l;
					var gh = H6h;
					var gl = H6l;
					var hh = H7h;
					var hl = H7l;
	
					// Rounds
					for (var i = 0; i < 80; i++) {
						var Wil;
						var Wih;
	
						// Shortcut
						var Wi = W[i];
	
						// Extend message
						if (i < 16) {
							Wih = Wi.high = M[offset + i * 2] | 0;
							Wil = Wi.low = M[offset + i * 2 + 1] | 0;
						} else {
							// Gamma0
							var gamma0x = W[i - 15];
							var gamma0xh = gamma0x.high;
							var gamma0xl = gamma0x.low;
							var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
							var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
	
							// Gamma1
							var gamma1x = W[i - 2];
							var gamma1xh = gamma1x.high;
							var gamma1xl = gamma1x.low;
							var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
							var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
	
							// W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
							var Wi7 = W[i - 7];
							var Wi7h = Wi7.high;
							var Wi7l = Wi7.low;
	
							var Wi16 = W[i - 16];
							var Wi16h = Wi16.high;
							var Wi16l = Wi16.low;
	
							Wil = gamma0l + Wi7l;
							Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
							Wil = Wil + gamma1l;
							Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
							Wil = Wil + Wi16l;
							Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
	
							Wi.high = Wih;
							Wi.low = Wil;
						}
	
						var chh = eh & fh ^ ~eh & gh;
						var chl = el & fl ^ ~el & gl;
						var majh = ah & bh ^ ah & ch ^ bh & ch;
						var majl = al & bl ^ al & cl ^ bl & cl;
	
						var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
						var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
						var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
						var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
	
						// t1 = h + sigma1 + ch + K[i] + W[i]
						var Ki = K[i];
						var Kih = Ki.high;
						var Kil = Ki.low;
	
						var t1l = hl + sigma1l;
						var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
						var t1l = t1l + chl;
						var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
						var t1l = t1l + Kil;
						var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
						var t1l = t1l + Wil;
						var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
	
						// t2 = sigma0 + maj
						var t2l = sigma0l + majl;
						var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
	
						// Update working variables
						hh = gh;
						hl = gl;
						gh = fh;
						gl = fl;
						fh = eh;
						fl = el;
						el = dl + t1l | 0;
						eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
						dh = ch;
						dl = cl;
						ch = bh;
						cl = bl;
						bh = ah;
						bl = al;
						al = t1l + t2l | 0;
						ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
					}
	
					// Intermediate hash value
					H0l = H0.low = H0l + al;
					H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
					H1l = H1.low = H1l + bl;
					H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
					H2l = H2.low = H2l + cl;
					H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
					H3l = H3.low = H3l + dl;
					H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
					H4l = H4.low = H4l + el;
					H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
					H5l = H5.low = H5l + fl;
					H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
					H6l = H6.low = H6l + gl;
					H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
					H7l = H7.low = H7l + hl;
					H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
					dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Convert hash to 32-bit word array before returning
					var hash = this._hash.toX32();
	
					// Return final computed hash
					return hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				},
	
				blockSize: 1024 / 32
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA512('message');
	   *     var hash = CryptoJS.SHA512(wordArray);
	   */
			C.SHA512 = Hasher._createHelper(SHA512);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA512(message, key);
	   */
			C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
		})();
	
		return CryptoJS.SHA512;
	});

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4336), __esModule: true };

/***/ }),
/* 915 */
/***/ (function(module, exports) {

	function noop() {}
	
	function elements(chartInstance) {
		// Turn the elements object into an array of elements
		var elements = chartInstance.annotation.elements;
		return Object.keys(elements).map(function(id) {
			return elements[id];
		});
	}
	
	function objectId() {
		return Math.random().toString(36).substr(2, 6);
	}
	
	function isValid(rawValue) {
		if (rawValue === null || typeof rawValue === 'undefined') {
			return false;
		} else if (typeof rawValue === 'number') {
			return isFinite(rawValue);
		} else {
			return !!rawValue;
		}
	}
	
	function decorate(obj, prop, func) {
		var prefix = '$';
		if (!obj[prefix + prop]) {
			if (obj[prop]) {
				obj[prefix + prop] = obj[prop].bind(obj);
				obj[prop] = function() {
					var args = [ obj[prefix + prop] ].concat(Array.prototype.slice.call(arguments));
					return func.apply(obj, args);
				};
			} else {
				obj[prop] = function() {
					var args = [ undefined ].concat(Array.prototype.slice.call(arguments));
					return func.apply(obj, args);
				};
			}
		}
	}
	
	function callEach(fns, method) {
		fns.forEach(function(fn) {
			(method ? fn[method] : fn)();
		});
	}
	
	function getEventHandlerName(eventName) {
		return 'on' + eventName[0].toUpperCase() + eventName.substring(1);
	}
	
	function createMouseEvent(type, previousEvent) {
		try {
			return new MouseEvent(type, previousEvent);
		} catch (exception) {
			try {
				var m = document.createEvent('MouseEvent');
				m.initMouseEvent(
					type,
					previousEvent.canBubble,
					previousEvent.cancelable,
					previousEvent.view,
					previousEvent.detail,
					previousEvent.screenX,
					previousEvent.screenY,
					previousEvent.clientX,
					previousEvent.clientY,
					previousEvent.ctrlKey,
					previousEvent.altKey,
					previousEvent.shiftKey,
					previousEvent.metaKey,
					previousEvent.button,
					previousEvent.relatedTarget
				);
				return m;
			} catch (exception2) {
				var e = document.createEvent('Event');
				e.initEvent(
					type,
					previousEvent.canBubble,
					previousEvent.cancelable
				);
				return e;
			}
		}
	}
	
	module.exports = function(Chart) {
		var chartHelpers = Chart.helpers;
	
		function initConfig(config) {
			config = chartHelpers.configMerge(Chart.Annotation.defaults, config);
			if (chartHelpers.isArray(config.annotations)) {
				config.annotations.forEach(function(annotation) {
					annotation.label = chartHelpers.configMerge(Chart.Annotation.labelDefaults, annotation.label);
				});
			}
			return config;
		}
	
		function getScaleLimits(scaleId, annotations, scaleMin, scaleMax) {
			var ranges = annotations.filter(function(annotation) {
				return !!annotation._model.ranges[scaleId];
			}).map(function(annotation) {
				return annotation._model.ranges[scaleId];
			});
	
			var min = ranges.map(function(range) {
				return Number(range.min);
			}).reduce(function(a, b) {
				return isFinite(b) && !isNaN(b) && b < a ? b : a;
			}, scaleMin);
	
			var max = ranges.map(function(range) {
				return Number(range.max);
			}).reduce(function(a, b) {
				return isFinite(b) && !isNaN(b) && b > a ? b : a;
			}, scaleMax);
	
			return {
				min: min,
				max: max
			};
		}
	
		function adjustScaleRange(scale) {
			// Adjust the scale range to include annotation values
			var range = getScaleLimits(scale.id, elements(scale.chart), scale.min, scale.max);
			if (typeof scale.options.ticks.min === 'undefined' && typeof scale.options.ticks.suggestedMin === 'undefined') {
				scale.min = range.min;
			}
			if (typeof scale.options.ticks.max === 'undefined' && typeof scale.options.ticks.suggestedMax === 'undefined') {
				scale.max = range.max;
			}
			if (scale.handleTickRangeOptions) {
				scale.handleTickRangeOptions();
			}
		}
	
		function getNearestItems(annotations, position) {
			var minDistance = Number.POSITIVE_INFINITY;
	
			return annotations
				.filter(function(element) {
					return element.inRange(position.x, position.y);
				})
				.reduce(function(nearestItems, element) {
					var center = element.getCenterPoint();
					var distance = chartHelpers.distanceBetweenPoints(position, center);
	
					if (distance < minDistance) {
						nearestItems = [element];
						minDistance = distance;
					} else if (distance === minDistance) {
						// Can have multiple items at the same distance in which case we sort by size
						nearestItems.push(element);
					}
	
					return nearestItems;
				}, [])
				.sort(function(a, b) {
					// If there are multiple elements equally close,
					// sort them by size, then by index
					var sizeA = a.getArea(), sizeB = b.getArea();
					return (sizeA > sizeB || sizeA < sizeB) ? sizeA - sizeB : a._index - b._index;
				})
				.slice(0, 1)[0]; // return only the top item
		}
	
		return {
			initConfig: initConfig,
			elements: elements,
			callEach: callEach,
			noop: noop,
			objectId: objectId,
			isValid: isValid,
			decorate: decorate,
			adjustScaleRange: adjustScaleRange,
			getNearestItems: getNearestItems,
			getEventHandlerName: getEventHandlerName,
			createMouseEvent: createMouseEvent
		};
	};
	


/***/ }),
/* 916 */
[6546, 704, 170],
/* 917 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 918 */
[6570, 267, 4370, 1401, 1410, 1400, 2118],
/* 919 */
[6593, 1413],
/* 920 */
451,
/* 921 */
/***/ (function(module, exports) {



/***/ }),
/* 922 */
[6542, 225, 126, 450],
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(89);
	var $export = __webpack_require__(32);
	var redefine = __webpack_require__(206);
	var redefineAll = __webpack_require__(448);
	var meta = __webpack_require__(368);
	var forOf = __webpack_require__(442);
	var anInstance = __webpack_require__(441);
	var isObject = __webpack_require__(99);
	var fails = __webpack_require__(95);
	var $iterDetect = __webpack_require__(928);
	var setToStringTag = __webpack_require__(557);
	var inheritIfRequired = __webpack_require__(1426);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(205);
	var redefine = __webpack_require__(206);
	var fails = __webpack_require__(95);
	var defined = __webpack_require__(271);
	var wks = __webpack_require__(106);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(85);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 926 */
[6560, 242],
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(99);
	var cof = __webpack_require__(242);
	var MATCH = __webpack_require__(106)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 928 */
[6565, 106],
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(443) || !__webpack_require__(95)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(89)[K];
	});


/***/ }),
/* 930 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 931 */
[6582, 32, 171, 243, 442],
/* 932 */
[6583, 32],
/* 933 */
[6587, 89],
/* 934 */
[6588, 85, 171, 106],
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(89);
	var hide = __webpack_require__(205);
	var uid = __webpack_require__(451);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * cuid.js
	 * Collision-resistant UID generator for browsers and node.
	 * Sequential for fast db lookups and recency sorting.
	 * Safe for element IDs and server-side lookups.
	 *
	 * Extracted from CLCTR
	 *
	 * Copyright (c) Eric Elliott 2012
	 * MIT License
	 */
	
	/*global window, navigator, document, require, process, module */
	(function (app) {
	  'use strict';
	  var namespace = 'cuid',
	    c = 0,
	    blockSize = 4,
	    base = 36,
	    discreteValues = Math.pow(base, blockSize),
	
	    pad = function pad(num, size) {
	      var s = "000000000" + num;
	      return s.substr(s.length-size);
	    },
	
	    randomBlock = function randomBlock() {
	      return pad((Math.random() *
	            discreteValues << 0)
	            .toString(base), blockSize);
	    },
	
	    safeCounter = function () {
	      c = (c < discreteValues) ? c : 0;
	      c++; // this is not subliminal
	      return c - 1;
	    },
	
	    api = function cuid() {
	      // Starting with a lowercase letter makes
	      // it HTML element ID friendly.
	      var letter = 'c', // hard-coded allows for sequential access
	
	        // timestamp
	        // warning: this exposes the exact date and time
	        // that the uid was created.
	        timestamp = (new Date().getTime()).toString(base),
	
	        // Prevent same-machine collisions.
	        counter,
	
	        // A few chars to generate distinct ids for different
	        // clients (so different computers are far less
	        // likely to generate the same id)
	        fingerprint = api.fingerprint(),
	
	        // Grab some more chars from Math.random()
	        random = randomBlock() + randomBlock();
	
	        counter = pad(safeCounter().toString(base), blockSize);
	
	      return  (letter + timestamp + counter + fingerprint + random);
	    };
	
	  api.slug = function slug() {
	    var date = new Date().getTime().toString(36),
	      counter,
	      print = api.fingerprint().slice(0,1) +
	        api.fingerprint().slice(-1),
	      random = randomBlock().slice(-2);
	
	      counter = safeCounter().toString(36).slice(-4);
	
	    return date.slice(-2) +
	      counter + print + random;
	  };
	
	  api.globalCount = function globalCount() {
	    // We want to cache the results of this
	    var cache = (function calc() {
	        var i,
	          count = 0;
	
	        for (i in window) {
	          count++;
	        }
	
	        return count;
	      }());
	
	    api.globalCount = function () { return cache; };
	    return cache;
	  };
	
	  api.fingerprint = function browserPrint() {
	    return pad((navigator.mimeTypes.length +
	      navigator.userAgent.length).toString(36) +
	      api.globalCount().toString(36), 4);
	  };
	
	  // don't change anything from here down.
	  if (app.register) {
	    app.register(namespace, api);
	  } else if (true) {
	    module.exports = api;
	  } else {
	    app[namespace] = api;
	  }
	
	}(this.applitude || this));


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(2178)
	
	/**
	 * @category Day Helpers
	 * @summary Are the given dates in the same day?
	 *
	 * @description
	 * Are the given dates in the same day?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(
	 *   new Date(2014, 8, 4, 6, 0),
	 *   new Date(2014, 8, 4, 18, 0)
	 * )
	 * //=> true
	 */
	function isSameDay (dirtyDateLeft, dirtyDateRight) {
	  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
	  var dateRightStartOfDay = startOfDay(dirtyDateRight)
	
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
	}
	
	module.exports = isSameDay


/***/ }),
/* 938 */
[6644, 31, 20],
/* 939 */
[6646, 53, 31, 20],
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(369));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * var result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	
	module.exports = exports.default;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * var result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getTime() - dateRight.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2193));
	
	var _index3 = _interopRequireDefault(__webpack_require__(452));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInMonths
	 * @category Month Helpers
	 * @summary Get the number of full months between the given dates.
	 *
	 * @description
	 * Get the number of full months between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
	 * //=> 7
	 */
	function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastMonthNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - isLastMonthNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(941));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInSeconds
	 * @category Second Helpers
	 * @summary Get the number of seconds between the given dates.
	 *
	 * @description
	 * Get the number of seconds between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of seconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many seconds are between
	 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
	 * var result = differenceInSeconds(
	 *   new Date(2014, 6, 2, 12, 30, 20, 0),
	 *   new Date(2014, 6, 2, 12, 30, 7, 999)
	 * )
	 * //=> 12
	 */
	function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / 1000;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWeekend;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWeekend
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date falls on a weekend
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * var result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day === 0 || day === 6;
	}
	
	module.exports = exports.default;

/***/ }),
/* 945 */
[6686, 31, 20],
/* 946 */
[6687, 31, 20],
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.deepmerge = factory());
	}(this, (function () { 'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, optionsArgument) {
		var clone = !optionsArgument || optionsArgument.clone !== false;
	
		return (clone && isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, optionsArgument)
			: value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, optionsArgument)
		})
	}
	
	function mergeObject(target, source, optionsArgument) {
		var destination = {};
		if (isMergeableObject(target)) {
			Object.keys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], optionsArgument);
			});
		}
		Object.keys(source).forEach(function(key) {
			if (!isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], optionsArgument);
			} else {
				destination[key] = deepmerge(target[key], source[key], optionsArgument);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var options = optionsArgument || { arrayMerge: defaultArrayMerge };
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, optionsArgument)
		} else if (sourceIsArray) {
			var arrayMerge = options.arrayMerge || defaultArrayMerge;
			return arrayMerge(target, source, optionsArgument)
		} else {
			return mergeObject(target, source, optionsArgument)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, optionsArgument)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	return deepmerge_1;
	
	})));


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	exports.default = createDragDropActions;
	
	var _beginDrag = _interopRequireDefault(__webpack_require__(4857));
	
	var _publishDragSource = _interopRequireDefault(__webpack_require__(4862));
	
	var _hover = _interopRequireDefault(__webpack_require__(4860));
	
	var _drop = _interopRequireDefault(__webpack_require__(4858));
	
	var _endDrag = _interopRequireDefault(__webpack_require__(4859));
	
	var _types = __webpack_require__(456);
	
	Object.keys(_types).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _types[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDragDropActions(manager) {
	  return {
	    beginDrag: (0, _beginDrag.default)(manager),
	    publishDragSource: (0, _publishDragSource.default)(manager),
	    hover: (0, _hover.default)(manager),
	    drop: (0, _drop.default)(manager),
	    endDrag: (0, _endDrag.default)(manager)
	  };
	}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addSource = addSource;
	exports.addTarget = addTarget;
	exports.removeSource = removeSource;
	exports.removeTarget = removeTarget;
	exports.REMOVE_TARGET = exports.REMOVE_SOURCE = exports.ADD_TARGET = exports.ADD_SOURCE = void 0;
	var ADD_SOURCE = 'dnd-core/ADD_SOURCE';
	exports.ADD_SOURCE = ADD_SOURCE;
	var ADD_TARGET = 'dnd-core/ADD_TARGET';
	exports.ADD_TARGET = ADD_TARGET;
	var REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
	exports.REMOVE_SOURCE = REMOVE_SOURCE;
	var REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
	exports.REMOVE_TARGET = REMOVE_TARGET;
	
	function addSource(sourceId) {
	  return {
	    type: ADD_SOURCE,
	    payload: {
	      sourceId: sourceId
	    }
	  };
	}
	
	function addTarget(targetId) {
	  return {
	    type: ADD_TARGET,
	    payload: {
	      targetId: targetId
	    }
	  };
	}
	
	function removeSource(sourceId) {
	  return {
	    type: REMOVE_SOURCE,
	    payload: {
	      sourceId: sourceId
	    }
	  };
	}
	
	function removeTarget(targetId) {
	  return {
	    type: REMOVE_TARGET,
	    payload: {
	      targetId: targetId
	    }
	  };
	}

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(951);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM2.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 951 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM2.default) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};
	
	var _inDOM = __webpack_require__(951);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = void 0;
	
	module.exports = exports['default'];

/***/ }),
/* 953 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_693c6856","outerContainer":"_65243076","secondaryToolbar":"_2f55f729","doorHangerRight":"e149dce4","toolbarContainer":"_597dd0ac","toolbarViewerMiddle":"_36fbf222","progressBar":"_1eb1b94f","back-to-application":"_8bdacc31","listTitle":"_9eca42f1","list":"_3c72d4a1","item":"_87a58ccb","title":"_16e256c9","subtitle":"_80fd69b7","note":"_3796c967","circle-member-wrap":"_39643869","menu-circle-member":"abfa2a99","clickable":"_2788daf6"};

/***/ }),
/* 954 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_77a5a14f","outerContainer":"_0b48ab6c","secondaryToolbar":"_08a4cc4e","doorHangerRight":"_0d66cec5","toolbarContainer":"f347d8b3","toolbarViewerMiddle":"_8b9c9efb","progressBar":"_241f7e93","back-to-application":"_8e7f7656","root":"eea7ad1f","header":"_2b623392","back":"_2d0bde75","back--title":"_114d9989","content":"_7cb7d7e3","card-wrapper":"cf2b7ef2","card":"c1e72a29","circle":"c89041bb","circle--fixed":"f601272f","label":"b44bf504","note":"_760ddc83","note--withPadding":"e726ad40","family":"_045b3416","provider":"de3677bc","family-header":"_1673bb29","provider-header":"_727cafe4","provider-row":"b2db7ff0","provider-column":"_0df8a7d4","vl":"d45209e6","assign-label":"d70a9bf7","provider-label":"_02d48924","assign-wrapper":"d0f5609a","options":"_70450e2b","user":"_5be9aea2","invite-input":"_64320879"};

/***/ }),
/* 955 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_539381b0","outerContainer":"cc99fd14","secondaryToolbar":"c84b0430","doorHangerRight":"b06e824c","toolbarContainer":"a03b8717","toolbarViewerMiddle":"_7a4e2ba6","progressBar":"_082a062e","back-to-application":"f912d4e2","list":"_3ce5e2c8"};

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_132060e3","outerContainer":"e8d9c0cf","secondaryToolbar":"_4b52a1e6","doorHangerRight":"_89a3159c","toolbarContainer":"_50d31f96","toolbarViewerMiddle":"_76d54f4a","progressBar":"_59788eff","back-to-application":"b0ec54dd","root":"d62ddb1a","content":"_2096a77c","root--whiteScroll":"bc1fc07f","content--fullHeight":"_39204084","content--empty":"_122046c3","controls":"b6bb53a1","controls--item":"_6a3dcf0c","controls--item--fixed":"fa50d242"};

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4e1c6f18","outerContainer":"_8a8a0718","secondaryToolbar":"_16693a4e","doorHangerRight":"_811f722a","toolbarContainer":"a92cada1","toolbarViewerMiddle":"_31a5aa5f","progressBar":"ef9040db","back-to-application":"_93532686","root":"cab622b5","rootModalMode":"a7a85b2f","title":"_2cfd520d","content":"de0b179c","dateWrapper":"_65b6cf82","datePickerWrapper":"_399887bd","datePickerIcon":"ad039ee3","weightInput":"_5fce5ee8","addButton":"_7b8a5270","heightInputWrapper":"c85675a1","timePickerWrapper":"_3085e27a","marginFirstChild":"c3ebe3b8","modalMode":"_4cb17ecc","loader":"_1d865429","loaderHeight":"d20848cd","description":"f943e813","clinicDescriptionWrapper":"_87ff5554","clinicDescription":"_9b802d0d","redirectLink":"_94648db9"};

/***/ }),
/* 958 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b7ee910e","outerContainer":"_4d0d8883","secondaryToolbar":"_6e88771f","doorHangerRight":"_4a3b5757","toolbarContainer":"f05a935e","toolbarViewerMiddle":"d374fa56","progressBar":"_915896ac","back-to-application":"be4b1df0","root":"_208f5ddc","header":"c822d730","content":"e9d99d36","option":"_2bf83cc9","form":"de7f471c","form--label":"_116f27af","form--subtitle":"_4874fe23","form--text":"cdacdbdb","form--fields":"_50c0bc82","form--btn":"_5a0662ac","disabled":"e549fa53"};

/***/ }),
/* 959 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = createRule;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _StyleRule = __webpack_require__(567);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _cloneStyle = __webpack_require__(5380);
	
	var _cloneStyle2 = _interopRequireDefault(_cloneStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Create a rule instance.
	 */
	function createRule() {
	  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
	  var decl = arguments[1];
	  var options = arguments[2];
	  var jss = options.jss;
	
	  var declCopy = (0, _cloneStyle2['default'])(decl);
	
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule;
	
	  // It is an at-rule and it has no instance.
	  if (name[0] === '@') {
	    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
	  }
	
	  return new _StyleRule2['default'](name, declCopy, options);
	}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toCssValue;
	var join = function join(value, by) {
	  var result = '';
	  for (var i = 0; i < value.length; i++) {
	    // Remove !important from the value, it will be readded later.
	    if (value[i] === '!important') break;
	    if (result) result += by;
	    result += value[i];
	  }
	  return result;
	};
	
	/**
	 * Converts array values to string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
	 * `color: ['red', !important]` > `color: red !important;`
	 */
	function toCssValue(value) {
	  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (!Array.isArray(value)) return value;
	
	  var cssValue = '';
	
	  // Support space separated values via `[['5px', '10px']]`.
	  if (Array.isArray(value[0])) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === '!important') break;
	      if (cssValue) cssValue += ', ';
	      cssValue += join(value[i], ' ');
	    }
	  } else cssValue = join(value, ', ');
	
	  // Add !important, because it was ignored.
	  if (!ignoreImportant && value[value.length - 1] === '!important') {
	    cssValue += ' !important';
	  }
	
	  return cssValue;
	}

/***/ }),
/* 968 */
[6724, 5467, 5468, 5469, 5470, 5471],
/* 969 */
[6730, 968, 5485, 5486, 5487, 5488, 5489],
/* 970 */
5821,
/* 971 */
[6736, 728],
/* 972 */
[6745, 2315, 5411, 5490],
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(2310),
	    deburr = __webpack_require__(5498),
	    words = __webpack_require__(5524);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),
/* 974 */
[6775, 5465],
/* 975 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 976 */
2697,
/* 977 */
[6800, 460],
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1531),
	    baseFilter = __webpack_require__(5401),
	    baseIteratee = __webpack_require__(175),
	    isArray = __webpack_require__(96);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(2315),
	    baseIteratee = __webpack_require__(175),
	    toInteger = __webpack_require__(987);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(247),
	    isObjectLike = __webpack_require__(227);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 981 */
[6821, 321, 96, 227],
/* 982 */
[6823, 5414, 727, 1551],
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(175),
	    negate = __webpack_require__(5514),
	    pickBy = __webpack_require__(984);
	
	/**
	 * The opposite of `_.pickBy`; this method creates an object composed of
	 * the own and inherited enumerable string keyed properties of `object` that
	 * `predicate` doesn't return truthy for. The predicate is invoked with two
	 * arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omitBy(object, _.isNumber);
	 * // => { 'b': '2' }
	 */
	function omitBy(object, predicate) {
	  return pickBy(object, negate(baseIteratee(predicate)));
	}
	
	module.exports = omitBy;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(458),
	    baseIteratee = __webpack_require__(175),
	    basePickBy = __webpack_require__(2320),
	    getAllKeysIn = __webpack_require__(1546);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(5447);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(2311),
	    baseIteratee = __webpack_require__(175),
	    baseSome = __webpack_require__(5428),
	    isArray = __webpack_require__(96),
	    isIterateeCall = __webpack_require__(575);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ }),
/* 987 */
[6828, 2356],
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1539),
	    baseTrim = __webpack_require__(2324),
	    castSlice = __webpack_require__(1543),
	    charsEndIndex = __webpack_require__(5434),
	    charsStartIndex = __webpack_require__(2325),
	    stringToArray = __webpack_require__(1553),
	    toString = __webpack_require__(468);
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return baseTrim(string);
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(175),
	    baseUniq = __webpack_require__(1540);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _IconButton = __webpack_require__(5576);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconButton).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Input = __webpack_require__(1564);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Input).default;
	  }
	});
	
	var _InputAdornment = __webpack_require__(5577);
	
	Object.defineProperty(exports, 'InputAdornment', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InputAdornment).default;
	  }
	});
	
	var _InputLabel = __webpack_require__(5578);
	
	Object.defineProperty(exports, 'InputLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InputLabel).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ButtonBase = __webpack_require__(278);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	var _helpers = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent ButtonBase
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: (0, _extends4.default)({}, theme.typography.button, (0, _defineProperty3.default)({
	      maxWidth: 264,
	      position: 'relative',
	      minWidth: 72,
	      padding: 0,
	      height: 48,
	      flex: 'none',
	      overflow: 'hidden'
	    }, theme.breakpoints.up('md'), {
	      minWidth: 160
	    })),
	    rootLabelIcon: {
	      height: 72
	    },
	    rootInherit: {
	      color: 'inherit',
	      opacity: 0.7
	    },
	    rootPrimary: {
	      color: theme.palette.text.secondary
	    },
	    rootPrimarySelected: {
	      color: theme.palette.primary.main
	    },
	    rootPrimaryDisabled: {
	      color: theme.palette.text.disabled
	    },
	    rootSecondary: {
	      color: theme.palette.text.secondary
	    },
	    rootSecondarySelected: {
	      color: theme.palette.secondary.main
	    },
	    rootSecondaryDisabled: {
	      color: theme.palette.text.disabled
	    },
	    rootInheritSelected: {
	      opacity: 1
	    },
	    rootInheritDisabled: {
	      opacity: 0.4
	    },
	    fullWidth: {
	      flexGrow: 1
	    },
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    },
	    labelContainer: (0, _defineProperty3.default)({
	      paddingTop: 6,
	      paddingBottom: 6,
	      paddingLeft: 12,
	      paddingRight: 12
	    }, theme.breakpoints.up('md'), {
	      paddingLeft: theme.spacing.unit * 3,
	      paddingRight: theme.spacing.unit * 3
	    }),
	    label: (0, _defineProperty3.default)({
	      fontSize: theme.typography.pxToRem(theme.typography.fontSize),
	      whiteSpace: 'normal'
	    }, theme.breakpoints.up('md'), {
	      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 1)
	    }),
	    labelWrapped: (0, _defineProperty3.default)({}, theme.breakpoints.down('sm'), {
	      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 2)
	    })
	  };
	};
	
	var Tab = function (_React$Component) {
	  (0, _inherits3.default)(Tab, _React$Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      wrappedText: false
	    }, _this.handleChange = function (event) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          value = _this$props.value,
	          onClick = _this$props.onClick;
	
	
	      if (onChange) {
	        onChange(event, value);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }, _this.label = undefined, _this.checkTextWrap = function () {
	      if (_this.label) {
	        var wrappedText = _this.label.getClientRects().length > 1;
	        if (_this.state.wrappedText !== wrappedText) {
	          _this.setState({ wrappedText: wrappedText });
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkTextWrap();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.wrappedText === prevState.wrappedText) {
	        /**
	         * At certain text and tab lengths, a larger font size may wrap to two lines while the smaller
	         * font size still only requires one line.  This check will prevent an infinite render loop
	         * fron occurring in that scenario.
	         */
	        this.checkTextWrap();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this,
	          _classNames2;
	
	      var _props = this.props,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          indicator = _props.indicator,
	          labelProp = _props.label,
	          onChange = _props.onChange,
	          selected = _props.selected,
	          styleProp = _props.style,
	          textColor = _props.textColor,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'disabled', 'fullWidth', 'icon', 'indicator', 'label', 'onChange', 'selected', 'style', 'textColor', 'value']);
	
	
	      var label = void 0;
	
	      if (labelProp !== undefined) {
	        label = _react2.default.createElement(
	          'span',
	          { className: classes.labelContainer },
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)(classes.label, (0, _defineProperty3.default)({}, classes.labelWrapped, this.state.wrappedText)),
	              ref: function ref(node) {
	                _this2.label = node;
	              }
	            },
	            labelProp
	          )
	        );
	      }
	
	      var className = (0, _classnames2.default)(classes.root, classes['root' + (0, _helpers.capitalize)(textColor)], (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes['root' + (0, _helpers.capitalize)(textColor) + 'Disabled'], disabled), (0, _defineProperty3.default)(_classNames2, classes['root' + (0, _helpers.capitalize)(textColor) + 'Selected'], selected), (0, _defineProperty3.default)(_classNames2, classes.rootLabelIcon, icon && label), (0, _defineProperty3.default)(_classNames2, classes.fullWidth, fullWidth), _classNames2), classNameProp);
	
	      var style = {};
	
	      if (textColor !== 'secondary' && textColor !== 'inherit') {
	        style.color = textColor;
	      }
	
	      style = (0, _keys2.default)(style).length > 0 ? (0, _extends4.default)({}, style, styleProp) : styleProp;
	
	      return _react2.default.createElement(
	        _ButtonBase2.default,
	        (0, _extends4.default)({
	          focusRipple: true,
	          className: className,
	          style: style,
	          role: 'tab',
	          'aria-selected': selected,
	          disabled: disabled
	        }, other, {
	          onClick: this.handleChange
	        }),
	        _react2.default.createElement(
	          'span',
	          { className: classes.wrapper },
	          icon,
	          label
	        ),
	        indicator
	      );
	    }
	  }]);
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the tab will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The icon element.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * @ignore
	   * For server side rendering consideration, we let the selected tab
	   * render the indicator.
	   */
	  indicator: _propTypes2.default.node,
	  /**
	   * The label element.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  textColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(['secondary', 'primary', 'inherit'])]),
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes2.default.any
	} : {};
	
	Tab.defaultProps = {
	  disabled: false,
	  textColor: 'inherit'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTab' })(Tab);

/***/ }),
/* 993 */,
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/**
	 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
	 * License: MIT - http://mrgnrdrck.mit-license.org
	 *
	 * https://github.com/mroderick/PubSubJS
	 */
	
	(function (root, factory){
	    'use strict';
	
	    var PubSub = {};
	    root.PubSub = PubSub;
	
	    var define = root.define;
	
	    factory(PubSub);
	
	    // AMD support
	    if (typeof define === 'function' && define.amd){
	        define(function() { return PubSub; });
	
	        // CommonJS and Node.js module support
	    } else if (true){
	        if (module !== undefined && module.exports) {
	            exports = module.exports = PubSub; // Node.js specific `module.exports`
	        }
	        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
	        module.exports = exports = PubSub; // CommonJS
	    }
	
	}(( typeof window === 'object' && window ) || this, function (PubSub){
	    'use strict';
	
	    var messages = {},
	        lastUid = -1;
	
	    function hasKeys(obj){
	        var key;
	
	        for (key in obj){
	            if ( obj.hasOwnProperty(key) ){
	                return true;
	            }
	        }
	        return false;
	    }
	
	    /**
	     * Returns a function that throws the passed exception, for use as argument for setTimeout
	     * @alias throwException
	     * @function
	     * @param { Object } ex An Error object
	     */
	    function throwException( ex ){
	        return function reThrowException(){
	            throw ex;
	        };
	    }
	
	    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
	        try {
	            subscriber( message, data );
	        } catch( ex ){
	            setTimeout( throwException( ex ), 0);
	        }
	    }
	
	    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
	        subscriber( message, data );
	    }
	
	    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
	        var subscribers = messages[matchedMessage],
	            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
	            s;
	
	        if ( !messages.hasOwnProperty( matchedMessage ) ) {
	            return;
	        }
	
	        for (s in subscribers){
	            if ( subscribers.hasOwnProperty(s)){
	                callSubscriber( subscribers[s], originalMessage, data );
	            }
	        }
	    }
	
	    function createDeliveryFunction( message, data, immediateExceptions ){
	        return function deliverNamespaced(){
	            var topic = String( message ),
	                position = topic.lastIndexOf( '.' );
	
	            // deliver the message as it is now
	            deliverMessage(message, message, data, immediateExceptions);
	
	            // trim the hierarchy and deliver message to each level
	            while( position !== -1 ){
	                topic = topic.substr( 0, position );
	                position = topic.lastIndexOf('.');
	                deliverMessage( message, topic, data, immediateExceptions );
	            }
	        };
	    }
	
	    function messageHasSubscribers( message ){
	        var topic = String( message ),
	            found = Boolean(messages.hasOwnProperty( topic ) && hasKeys(messages[topic])),
	            position = topic.lastIndexOf( '.' );
	
	        while ( !found && position !== -1 ){
	            topic = topic.substr( 0, position );
	            position = topic.lastIndexOf( '.' );
	            found = Boolean(messages.hasOwnProperty( topic ) && hasKeys(messages[topic]));
	        }
	
	        return found;
	    }
	
	    function publish( message, data, sync, immediateExceptions ){
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
	            hasSubscribers = messageHasSubscribers( message );
	
	        if ( !hasSubscribers ){
	            return false;
	        }
	
	        if ( sync === true ){
	            deliver();
	        } else {
	            setTimeout( deliver, 0 );
	        }
	        return true;
	    }
	
	    /**
	     * Publishes the message, passing the data to it's subscribers
	     * @function
	     * @alias publish
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publish = function( message, data ){
	        return publish( message, data, false, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Publishes the the message synchronously, passing the data to it's subscribers
	     * @function
	     * @alias publishSync
	     * @param { String } message The message to publish
	     * @param {} data The data to pass to subscribers
	     * @return { Boolean }
	     */
	    PubSub.publishSync = function( message, data ){
	        return publish( message, data, true, PubSub.immediateExceptions );
	    };
	
	    /**
	     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
	     * @function
	     * @alias subscribe
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { String }
	     */
	    PubSub.subscribe = function( message, func ){
	        if ( typeof func !== 'function'){
	            return false;
	        }
	
	        message = (typeof message === 'symbol') ? message.toString() : message;
	
	        // message is not registered yet
	        if ( !messages.hasOwnProperty( message ) ){
	            messages[message] = {};
	        }
	
	        // forcing token as String, to allow for future expansions without breaking usage
	        // and allow for easy use as key names for the 'messages' object
	        var token = 'uid_' + String(++lastUid);
	        messages[message][token] = func;
	        
	        // return token for unsubscribing
	        return token;
	    };
	
	    /**
	     * Subscribes the passed function to the passed message once
	     * @function
	     * @alias subscribeOnce
	     * @param { String } message The message to subscribe to
	     * @param { Function } func The function to call when a new message is published
	     * @return { PubSub }
	     */
	    PubSub.subscribeOnce = function( message, func ){
	        var token = PubSub.subscribe( message, function(){
	            // before func apply, unsubscribe message
	            PubSub.unsubscribe( token );
	            func.apply( this, arguments );
	        });
	        return PubSub;
	    };
	
	    /**
	     * Clears all subscriptions
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     */
	    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
	        messages = {};
	    };
	
	    /**
	     * Clear subscriptions by the topic
	     * @function
	     * @public
	     * @alias clearAllSubscriptions
	     */
	    PubSub.clearSubscriptions = function clearSubscriptions(topic){
	        var m;
	        for (m in messages){
	            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0){
	                delete messages[m];
	            }
	        }
	    };
	
	    /**
	     * Removes subscriptions
	     *
	     * - When passed a token, removes a specific subscription.
	     *
		 * - When passed a function, removes all subscriptions for that function
	     *
		 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
	     * @function
	     * @public
	     * @alias subscribeOnce
	     * @param { String | Function } value A token, function or topic to unsubscribe from
	     * @example // Unsubscribing with a token
	     * var token = PubSub.subscribe('mytopic', myFunc);
	     * PubSub.unsubscribe(token);
	     * @example // Unsubscribing with a function
	     * PubSub.unsubscribe(myFunc);
	     * @example // Unsubscribing from a topic
	     * PubSub.unsubscribe('mytopic');
	     */
	    PubSub.unsubscribe = function(value){
	        var descendantTopicExists = function(topic) {
	                var m;
	                for ( m in messages ){
	                    if ( messages.hasOwnProperty(m) && m.indexOf(topic) === 0 ){
	                        // a descendant of the topic exists:
	                        return true;
	                    }
	                }
	
	                return false;
	            },
	            isTopic    = typeof value === 'string' && ( messages.hasOwnProperty(value) || descendantTopicExists(value) ),
	            isToken    = !isTopic && typeof value === 'string',
	            isFunction = typeof value === 'function',
	            result = false,
	            m, message, t;
	
	        if (isTopic){
	            PubSub.clearSubscriptions(value);
	            return;
	        }
	
	        for ( m in messages ){
	            if ( messages.hasOwnProperty( m ) ){
	                message = messages[m];
	
	                if ( isToken && message[value] ){
	                    delete message[value];
	                    result = value;
	                    // tokens are unique, so we can just stop here
	                    break;
	                }
	
	                if (isFunction) {
	                    for ( t in message ){
	                        if (message.hasOwnProperty(t) && message[t] === value){
	                            delete message[t];
	                            result = true;
	                        }
	                    }
	                }
	            }
	        }
	
	        return result;
	    };
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)(module)))

/***/ }),
/* 995 */
[6724, 5763, 5764, 5765, 5766, 5767],
/* 996 */
[6731, 328],
/* 997 */
[6736, 2676],
/* 998 */
[6775, 5760],
/* 999 */
[6800, 471],
/* 1000 */
[6810, 1585],
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hoistNonReactStatic = __webpack_require__(5801);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(71);
	
	module.exports = function enhanceWithClickOutside(WrappedComponent) {
	  var componentName = WrappedComponent.displayName || WrappedComponent.name;
	
	  var EnhancedComponent = function (_React$Component) {
	    _inherits(EnhancedComponent, _React$Component);
	
	    function EnhancedComponent(props) {
	      _classCallCheck(this, EnhancedComponent);
	
	      var _this = _possibleConstructorReturn(this, (EnhancedComponent.__proto__ || Object.getPrototypeOf(EnhancedComponent)).call(this, props));
	
	      _this.handleClickOutside = _this.handleClickOutside.bind(_this);
	      return _this;
	    }
	
	    _createClass(EnhancedComponent, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        document.addEventListener('click', this.handleClickOutside, true);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        document.removeEventListener('click', this.handleClickOutside, true);
	      }
	    }, {
	      key: 'handleClickOutside',
	      value: function handleClickOutside(e) {
	        var domNode = this.__domNode;
	        if ((!domNode || !domNode.contains(e.target)) && typeof this.__wrappedComponent.handleClickOutside === 'function') {
	          this.__wrappedComponent.handleClickOutside(e);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return React.createElement(WrappedComponent, _extends({}, this.props, {
	          ref: function ref(c) {
	            _this2.__wrappedComponent = c;
	            _this2.__domNode = ReactDOM.findDOMNode(c);
	          }
	        }));
	      }
	    }]);
	
	    return EnhancedComponent;
	  }(React.Component);
	
	  EnhancedComponent.displayName = 'Wrapped' + componentName;
	
	  return hoistNonReactStatic(EnhancedComponent, WrappedComponent);
	};

/***/ }),
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.rangeShape = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(382));
	
	var _classnames4 = _interopRequireDefault(__webpack_require__(475));
	
	var _dateFns = __webpack_require__(275);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DayCell =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DayCell, _Component);
	
	  function DayCell(props, context) {
	    var _this;
	
	    _classCallCheck(this, DayCell);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DayCell).call(this, props, context));
	
	    _defineProperty(_assertThisInitialized(_this), "handleKeyEvent", function (event) {
	      var _this$props = _this.props,
	          day = _this$props.day,
	          onMouseDown = _this$props.onMouseDown,
	          onMouseUp = _this$props.onMouseUp;
	
	      if ([13
	      /* space */
	      , 32
	      /* enter */
	      ].includes(event.keyCode)) {
	        if (event.type === 'keydown') onMouseDown(day);else onMouseUp(day);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleMouseEvent", function (event) {
	      var _this$props2 = _this.props,
	          day = _this$props2.day,
	          disabled = _this$props2.disabled,
	          onPreviewChange = _this$props2.onPreviewChange,
	          onMouseEnter = _this$props2.onMouseEnter,
	          onMouseDown = _this$props2.onMouseDown,
	          onMouseUp = _this$props2.onMouseUp;
	      var stateChanges = {};
	
	      if (disabled) {
	        onPreviewChange();
	        return;
	      }
	
	      switch (event.type) {
	        case 'mouseenter':
	          onMouseEnter(day);
	          onPreviewChange(day);
	          stateChanges.hover = true;
	          break;
	
	        case 'blur':
	        case 'mouseleave':
	          stateChanges.hover = false;
	          break;
	
	        case 'mousedown':
	          stateChanges.active = true;
	          onMouseDown(day);
	          break;
	
	        case 'mouseup':
	          event.stopPropagation();
	          stateChanges.active = false;
	          onMouseUp(day);
	          break;
	
	        case 'focus':
	          onPreviewChange(day);
	          break;
	      }
	
	      if (Object.keys(stateChanges).length) {
	        _this.setState(stateChanges);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getClassNames", function () {
	      var _classnames;
	
	      var _this$props3 = _this.props,
	          isPassive = _this$props3.isPassive,
	          isToday = _this$props3.isToday,
	          isWeekend = _this$props3.isWeekend,
	          isStartOfWeek = _this$props3.isStartOfWeek,
	          isEndOfWeek = _this$props3.isEndOfWeek,
	          isStartOfMonth = _this$props3.isStartOfMonth,
	          isEndOfMonth = _this$props3.isEndOfMonth,
	          disabled = _this$props3.disabled,
	          styles = _this$props3.styles;
	      return (0, _classnames4["default"])(styles.day, (_classnames = {}, _defineProperty(_classnames, styles.dayPassive, isPassive), _defineProperty(_classnames, styles.dayDisabled, disabled), _defineProperty(_classnames, styles.dayToday, isToday), _defineProperty(_classnames, styles.dayWeekend, isWeekend), _defineProperty(_classnames, styles.dayStartOfWeek, isStartOfWeek), _defineProperty(_classnames, styles.dayEndOfWeek, isEndOfWeek), _defineProperty(_classnames, styles.dayStartOfMonth, isStartOfMonth), _defineProperty(_classnames, styles.dayEndOfMonth, isEndOfMonth), _defineProperty(_classnames, styles.dayHovered, _this.state.hover), _defineProperty(_classnames, styles.dayActive, _this.state.active), _classnames));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderPreviewPlaceholder", function () {
	      var _classnames2;
	
	      var _this$props4 = _this.props,
	          preview = _this$props4.preview,
	          day = _this$props4.day,
	          styles = _this$props4.styles;
	      if (!preview) return null;
	      var startDate = preview.startDate ? (0, _dateFns.endOfDay)(preview.startDate) : null;
	      var endDate = preview.endDate ? (0, _dateFns.startOfDay)(preview.endDate) : null;
	      var isInRange = (!startDate || (0, _dateFns.isAfter)(day, startDate)) && (!endDate || (0, _dateFns.isBefore)(day, endDate));
	      var isStartEdge = !isInRange && (0, _dateFns.isSameDay)(day, startDate);
	      var isEndEdge = !isInRange && (0, _dateFns.isSameDay)(day, endDate);
	      return _react["default"].createElement("span", {
	        className: (0, _classnames4["default"])((_classnames2 = {}, _defineProperty(_classnames2, styles.dayStartPreview, isStartEdge), _defineProperty(_classnames2, styles.dayInPreview, isInRange), _defineProperty(_classnames2, styles.dayEndPreview, isEndEdge), _classnames2)),
	        style: {
	          color: preview.color
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderSelectionPlaceholders", function () {
	      var _this$props5 = _this.props,
	          styles = _this$props5.styles,
	          ranges = _this$props5.ranges,
	          day = _this$props5.day;
	
	      if (_this.props.displayMode === 'date') {
	        var isSelected = (0, _dateFns.isSameDay)(_this.props.day, _this.props.date);
	        return isSelected ? _react["default"].createElement("span", {
	          className: styles.selected,
	          style: {
	            color: _this.props.color
	          }
	        }) : null;
	      }
	
	      var inRanges = ranges.reduce(function (result, range) {
	        var startDate = range.startDate;
	        var endDate = range.endDate;
	
	        if (startDate && endDate && (0, _dateFns.isBefore)(endDate, startDate)) {
	          var _ref = [endDate, startDate];
	          startDate = _ref[0];
	          endDate = _ref[1];
	        }
	
	        startDate = startDate ? (0, _dateFns.endOfDay)(startDate) : null;
	        endDate = endDate ? (0, _dateFns.startOfDay)(endDate) : null;
	        var isInRange = (!startDate || (0, _dateFns.isAfter)(day, startDate)) && (!endDate || (0, _dateFns.isBefore)(day, endDate));
	        var isStartEdge = !isInRange && (0, _dateFns.isSameDay)(day, startDate);
	        var isEndEdge = !isInRange && (0, _dateFns.isSameDay)(day, endDate);
	
	        if (isInRange || isStartEdge || isEndEdge) {
	          return [].concat(_toConsumableArray(result), [_objectSpread({
	            isStartEdge: isStartEdge,
	            isEndEdge: isEndEdge,
	            isInRange: isInRange
	          }, range)]);
	        }
	
	        return result;
	      }, []);
	      return inRanges.map(function (range, i) {
	        var _classnames3;
	
	        return _react["default"].createElement("span", {
	          key: i,
	          className: (0, _classnames4["default"])((_classnames3 = {}, _defineProperty(_classnames3, styles.startEdge, range.isStartEdge), _defineProperty(_classnames3, styles.endEdge, range.isEndEdge), _defineProperty(_classnames3, styles.inRange, range.isInRange), _classnames3)),
	          style: {
	            color: range.color || _this.props.color
	          }
	        });
	      });
	    });
	
	    _this.state = {
	      hover: false,
	      active: false
	    };
	    return _this;
	  }
	
	  _createClass(DayCell, [{
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement("button", _extends({
	        type: "button",
	        onMouseEnter: this.handleMouseEvent,
	        onMouseLeave: this.handleMouseEvent,
	        onFocus: this.handleMouseEvent,
	        onMouseDown: this.handleMouseEvent,
	        onMouseUp: this.handleMouseEvent,
	        onBlur: this.handleMouseEvent,
	        onPauseCapture: this.handleMouseEvent,
	        onKeyDown: this.handleKeyEvent,
	        onKeyUp: this.handleKeyEvent,
	        className: this.getClassNames(this.props.styles)
	      }, this.props.disabled || this.props.isPassive ? {
	        tabIndex: -1
	      } : {}, {
	        style: {
	          color: this.props.color
	        }
	      }), this.renderSelectionPlaceholders(), this.renderPreviewPlaceholder(), _react["default"].createElement("span", {
	        className: this.props.styles.dayNumber
	      }, _react["default"].createElement("span", null, (0, _dateFns.format)(this.props.day, this.props.dayDisplayFormat))));
	    }
	  }]);
	
	  return DayCell;
	}(_react.Component);
	
	DayCell.defaultProps = {};
	
	var rangeShape = _propTypes["default"].shape({
	  startDate: _propTypes["default"].object,
	  endDate: _propTypes["default"].object,
	  color: _propTypes["default"].string,
	  key: _propTypes["default"].string,
	  autoFocus: _propTypes["default"].bool,
	  disabled: _propTypes["default"].bool,
	  showDateDisplay: _propTypes["default"].bool
	});
	
	exports.rangeShape = rangeShape;
	DayCell.propTypes = {
	  day: _propTypes["default"].object.isRequired,
	  dayDisplayFormat: _propTypes["default"].string,
	  date: _propTypes["default"].object,
	  ranges: _propTypes["default"].arrayOf(rangeShape),
	  preview: _propTypes["default"].shape({
	    startDate: _propTypes["default"].object,
	    endDate: _propTypes["default"].object,
	    color: _propTypes["default"].string
	  }),
	  onPreviewChange: _propTypes["default"].func,
	  previewColor: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  isPassive: _propTypes["default"].bool,
	  isToday: _propTypes["default"].bool,
	  isWeekend: _propTypes["default"].bool,
	  isStartOfWeek: _propTypes["default"].bool,
	  isEndOfWeek: _propTypes["default"].bool,
	  isStartOfMonth: _propTypes["default"].bool,
	  isEndOfMonth: _propTypes["default"].bool,
	  color: _propTypes["default"].string,
	  displayMode: _propTypes["default"].oneOf(['dateRange', 'date']),
	  styles: _propTypes["default"].object,
	  onMouseDown: _propTypes["default"].func,
	  onMouseUp: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func
	};
	var _default = DayCell;
	exports["default"] = _default;

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var _default = {
	  dateRangeWrapper: 'rdrDateRangeWrapper',
	  calendarWrapper: 'rdrCalendarWrapper',
	  dateDisplay: 'rdrDateDisplay',
	  dateDisplayItem: 'rdrDateDisplayItem',
	  dateDisplayItemActive: 'rdrDateDisplayItemActive',
	  monthAndYearWrapper: 'rdrMonthAndYearWrapper',
	  monthAndYearPickers: 'rdrMonthAndYearPickers',
	  nextPrevButton: 'rdrNextPrevButton',
	  month: 'rdrMonth',
	  weekDays: 'rdrWeekDays',
	  weekDay: 'rdrWeekDay',
	  days: 'rdrDays',
	  day: 'rdrDay',
	  dayNumber: 'rdrDayNumber',
	  dayPassive: 'rdrDayPassive',
	  dayToday: 'rdrDayToday',
	  dayStartOfWeek: 'rdrDayStartOfWeek',
	  dayEndOfWeek: 'rdrDayEndOfWeek',
	  daySelected: 'rdrDaySelected',
	  dayDisabled: 'rdrDayDisabled',
	  dayStartOfMonth: 'rdrDayStartOfMonth',
	  dayEndOfMonth: 'rdrDayEndOfMonth',
	  dayWeekend: 'rdrDayWeekend',
	  dayStartPreview: 'rdrDayStartPreview',
	  dayInPreview: 'rdrDayInPreview',
	  dayEndPreview: 'rdrDayEndPreview',
	  dayHovered: 'rdrDayHovered',
	  dayActive: 'rdrDayActive',
	  inRange: 'rdrInRange',
	  endEdge: 'rdrEndEdge',
	  startEdge: 'rdrStartEdge',
	  prevButton: 'rdrPprevButton',
	  nextButton: 'rdrNextButton',
	  selected: 'rdrSelected',
	  months: 'rdrMonths',
	  monthPicker: 'rdrMonthPicker',
	  yearPicker: 'rdrYearPicker',
	  dateDisplayWrapper: 'rdrDateDisplayWrapper',
	  definedRangesWrapper: 'rdrDefinedRangesWrapper',
	  staticRanges: 'rdrStaticRanges',
	  staticRange: 'rdrStaticRange',
	  inputRanges: 'rdrInputRanges',
	  inputRange: 'rdrInputRange',
	  inputRangeInput: 'rdrInputRangeInput',
	  dateRangePickerWrapper: 'rdrDateRangePickerWrapper',
	  staticRangeLabel: 'rdrStaticRangeLabel',
	  staticRangeSelected: 'rdrStaticRangeSelected',
	  monthName: 'rdrMonthName',
	  infiniteMonths: 'rdrInfiniteMonths',
	  monthsVertical: 'rdrMonthsVertical',
	  monthsHorizontal: 'rdrMonthsHorizontal'
	};
	exports["default"] = _default;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calcFocusDate = calcFocusDate;
	exports.findNextRangeIndex = findNextRangeIndex;
	exports.getMonthDisplayRange = getMonthDisplayRange;
	exports.generateStyles = generateStyles;
	
	var _classnames = _interopRequireDefault(__webpack_require__(475));
	
	var _dateFns = __webpack_require__(275);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function calcFocusDate(currentFocusedDate, props) {
	  var shownDate = props.shownDate,
	      date = props.date,
	      months = props.months,
	      ranges = props.ranges,
	      focusedRange = props.focusedRange,
	      displayMode = props.displayMode; // find primary date according the props
	
	  var targetInterval;
	
	  if (displayMode === 'dateRange') {
	    var range = ranges[focusedRange[0]] || {};
	    targetInterval = {
	      start: range.startDate,
	      end: range.endDate
	    };
	  } else {
	    targetInterval = {
	      start: date,
	      end: date
	    };
	  }
	
	  targetInterval.start = (0, _dateFns.startOfMonth)(targetInterval.start || new Date());
	  targetInterval.end = (0, _dateFns.endOfMonth)(targetInterval.end || targetInterval.start);
	  var targetDate = targetInterval.start || targetInterval.end || shownDate || new Date(); // initial focus
	
	  if (!currentFocusedDate) return shownDate || targetDate; // // just return targetDate for native scrolled calendars
	  // if (props.scroll.enabled) return targetDate;
	
	  if ((0, _dateFns.differenceInCalendarMonths)(targetInterval.start, targetInterval.end) > months) {
	    // don't change focused if new selection in view area
	    return currentFocusedDate;
	  }
	
	  return targetDate;
	}
	
	function findNextRangeIndex(ranges) {
	  var currentRangeIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	  var nextIndex = ranges.findIndex(function (range, i) {
	    return i > currentRangeIndex && range.autoFocus !== false && !range.disabled;
	  });
	  if (nextIndex !== -1) return nextIndex;
	  return ranges.findIndex(function (range) {
	    return range.autoFocus !== false && !range.disabled;
	  });
	}
	
	function getMonthDisplayRange(date, dateOptions, fixedHeight) {
	  var startDateOfMonth = (0, _dateFns.startOfMonth)(date, dateOptions);
	  var endDateOfMonth = (0, _dateFns.endOfMonth)(date, dateOptions);
	  var startDateOfCalendar = (0, _dateFns.startOfWeek)(startDateOfMonth, dateOptions);
	  var endDateOfCalendar = (0, _dateFns.endOfWeek)(endDateOfMonth, dateOptions);
	
	  if (fixedHeight && (0, _dateFns.differenceInCalendarDays)(endDateOfCalendar, startDateOfCalendar) <= 34) {
	    endDateOfCalendar = (0, _dateFns.addDays)(endDateOfCalendar, 7);
	  }
	
	  return {
	    start: startDateOfCalendar,
	    end: endDateOfCalendar,
	    startDateOfMonth: startDateOfMonth,
	    endDateOfMonth: endDateOfMonth
	  };
	}
	
	function generateStyles(sources) {
	  if (!sources.length) return {};
	  var generatedStyles = sources.filter(function (source) {
	    return Boolean(source);
	  }).reduce(function (styles, styleSource) {
	    Object.keys(styleSource).forEach(function (key) {
	      styles[key] = (0, _classnames["default"])(styles[key], styleSource[key]);
	    });
	    return styles;
	  }, {});
	  return generatedStyles;
	}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
	
	          if (desc.get || desc.set) {
	            Object.defineProperty(newObj, key, desc);
	          } else {
	            newObj[key] = obj[key];
	          }
	        }
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	}
	
	module.exports = _interopRequireWildcard;

/***/ }),
/* 1017 */
[6644, 62, 47],
/* 1018 */
[6646, 92, 62, 47],
/* 1019 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerTarget = registerTarget;
	exports.registerSource = registerSource;
	
	function registerTarget(type, target, manager) {
	  var registry = manager.getRegistry();
	  var targetId = registry.addTarget(type, target);
	  return [targetId, function () {
	    return registry.removeTarget(targetId);
	  }];
	}
	
	function registerSource(type, source, manager) {
	  var registry = manager.getRegistry();
	  var sourceId = registry.addSource(type, source);
	  return [sourceId, function () {
	    return registry.removeSource(sourceId);
	  }];
	}

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(6025);
	
	Object.keys(_common).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _common[key];
	    }
	  });
	});
	
	var _hooks = __webpack_require__(6033);
	
	Object.keys(_hooks).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _hooks[key];
	    }
	  });
	});
	
	var _decorators = __webpack_require__(6032);
	
	Object.keys(_decorators).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _decorators[key];
	    }
	  });
	});

/***/ }),
/* 1021 */
[6724, 6136, 6137, 6138, 6139, 6140],
/* 1022 */
[6731, 210],
/* 1023 */
[6736, 1031],
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1609),
	    isObject = __webpack_require__(478);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ }),
/* 1025 */
[6775, 6133],
/* 1026 */
1590,
/* 1027 */
[6800, 477],
/* 1028 */
/***/ (function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ }),
/* 1029 */
[6810, 1034],
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(1611),
	    createWrap = __webpack_require__(6115),
	    getHolder = __webpack_require__(1612),
	    replaceHolders = __webpack_require__(1028);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and `partials` prepended to the arguments it receives.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * function greet(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * }
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = baseRest(function(func, thisArg, partials) {
	  var bitmask = WRAP_BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bind));
	    bitmask |= WRAP_PARTIAL_FLAG;
	  }
	  return createWrap(func, bitmask, thisArg, partials, holders);
	});
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;


/***/ }),
/* 1031 */
1008,
/* 1032 */
[6817, 1033, 1614],
/* 1033 */
[6820, 744, 478],
/* 1034 */
[6822, 744, 587],
/* 1035 */
[6824, 6070, 6091, 1032],
/* 1036 */,
/* 1037 */,
/* 1038 */
/***/ (function(module, exports) {

	function _classCallCheck(a, n) {
	  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(2822);
	function _defineProperties(e, r) {
	  for (var t = 0; t < r.length; t++) {
	    var o = r[t];
	    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
	  }
	}
	function _createClass(e, r, t) {
	  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
	    writable: !1
	  }), e;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

	function _extends() {
	  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
	    for (var e = 1; e < arguments.length; e++) {
	      var t = arguments[e];
	      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
	    }
	    return n;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	function _getPrototypeOf(t) {
	  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
	    return t.__proto__ || Object.getPrototypeOf(t);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(6291);
	function _inherits(t, e) {
	  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	  t.prototype = Object.create(e && e.prototype, {
	    constructor: {
	      value: t,
	      writable: !0,
	      configurable: !0
	    }
	  }), Object.defineProperty(t, "prototype", {
	    writable: !1
	  }), e && setPrototypeOf(t, e);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(6290);
	function _objectWithoutProperties(e, t) {
	  if (null == e) return {};
	  var o,
	    r,
	    i = objectWithoutPropertiesLoose(e, t);
	  if (Object.getOwnPropertySymbols) {
	    var n = Object.getOwnPropertySymbols(e);
	    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
	  }
	  return i;
	}
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(749)["default"];
	var assertThisInitialized = __webpack_require__(1627);
	function _possibleConstructorReturn(t, e) {
	  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
	  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
	  return assertThisInitialized(t);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1045 */,
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames2 = __webpack_require__(8);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _dissoc = __webpack_require__(6348);
	
	var _dissoc2 = _interopRequireDefault(_dissoc);
	
	var _identifiers = __webpack_require__(212);
	
	var _events = __webpack_require__(2840);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _prefixer = __webpack_require__(6344);
	
	var _prefixer2 = _interopRequireDefault(_prefixer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defaults = {
	  centered: false,
	  className: '',
	  multiple: true,
	  passthrough: true,
	  spread: 2,
	  theme: {}
	};
	
	var rippleFactory = function rippleFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _defaults$options = _extends({}, defaults, options),
	      defaultCentered = _defaults$options.centered,
	      defaultClassName = _defaults$options.className,
	      defaultMultiple = _defaults$options.multiple,
	      defaultPassthrough = _defaults$options.passthrough,
	      defaultSpread = _defaults$options.spread,
	      defaultTheme = _defaults$options.theme,
	      props = _objectWithoutProperties(_defaults$options, ['centered', 'className', 'multiple', 'passthrough', 'spread', 'theme']);
	
	  return function (ComposedComponent) {
	    var RippledComponent = function (_Component) {
	      _inherits(RippledComponent, _Component);
	
	      function RippledComponent() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, RippledComponent);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RippledComponent.__proto__ || Object.getPrototypeOf(RippledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          ripples: {}
	        }, _this.rippleNodes = {}, _this.doRipple = function () {
	          return !_this.props.disabled && _this.props.ripple;
	        }, _this.handleMouseDown = function (event) {
	          if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	          if (_this.doRipple()) {
	            var _events$getMousePosit = _events2.default.getMousePosition(event),
	                x = _events$getMousePosit.x,
	                y = _events$getMousePosit.y;
	
	            _this.animateRipple(x, y, false);
	          }
	        }, _this.handleTouchStart = function (event) {
	          if (_this.props.onTouchStart) _this.props.onTouchStart(event);
	          if (_this.doRipple()) {
	            var _events$getTouchPosit = _events2.default.getTouchPosition(event),
	                x = _events$getTouchPosit.x,
	                y = _events$getTouchPosit.y;
	
	            _this.animateRipple(x, y, true);
	          }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(RippledComponent, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	          // If a new ripple was just added, add a remove event listener to its animation
	          if (Object.keys(prevState.ripples).length < Object.keys(this.state.ripples).length) {
	            this.addRippleRemoveEventListener(this.getLastKey());
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          var _this2 = this;
	
	          // Remove document event listeners for ripple if they still exists
	          Object.keys(this.state.ripples).forEach(function (key) {
	            _this2.state.ripples[key].endRipple();
	          });
	        }
	
	        /**
	         * Find out a descriptor object for the ripple element being created depending on
	         * the position where the it was triggered and the component's dimensions.
	         *
	         * @param {Number} x Coordinate x in the viewport where ripple was triggered
	         * @param {Number} y Coordinate y in the viewport where ripple was triggered
	         * @return {Object} Descriptor element including position and size of the element
	         */
	
	      }, {
	        key: 'getDescriptor',
	        value: function getDescriptor(x, y) {
	          var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this).getBoundingClientRect(),
	              left = _ReactDOM$findDOMNode.left,
	              top = _ReactDOM$findDOMNode.top,
	              height = _ReactDOM$findDOMNode.height,
	              width = _ReactDOM$findDOMNode.width;
	
	          var _props = this.props,
	              centered = _props.rippleCentered,
	              spread = _props.rippleSpread;
	
	          return {
	            left: centered ? 0 : x - left - width / 2,
	            top: centered ? 0 : y - top - height / 2,
	            width: width * spread
	          };
	        }
	
	        /**
	         * Increments and internal counter and returns the next value as a string. It
	         * is used to assign key references to new ripple elements.
	         *
	         * @return {String} Key to be assigned to a ripple.
	         */
	
	      }, {
	        key: 'getNextKey',
	        value: function getNextKey() {
	          this.currentCount = this.currentCount ? this.currentCount + 1 : 1;
	          return 'ripple' + this.currentCount;
	        }
	
	        /**
	         * Return the last generated key for a ripple element. When there is only one ripple
	         * and to get the reference when a ripple was just created.
	         *
	         * @return {String} The last generated ripple key.
	         */
	
	      }, {
	        key: 'getLastKey',
	        value: function getLastKey() {
	          return 'ripple' + this.currentCount;
	        }
	
	        /**
	         * Variable to store the ripple references
	         */
	
	      }, {
	        key: 'rippleShouldTrigger',
	
	
	        /**
	         * Determine if a ripple should start depending if its a touch event. For mobile both
	         * touchStart and mouseDown are launched so in case is touch we should always trigger
	         * but if its not we should check if a touch was already triggered to decide.
	         *
	         * @param {Boolean} isTouch True in case a touch event triggered the ripple false otherwise.
	         * @return {Boolean} True in case the ripple should trigger or false if it shouldn't.
	         */
	        value: function rippleShouldTrigger(isTouch) {
	          var shouldStart = isTouch ? true : !this.touchCache;
	          this.touchCache = isTouch;
	          return shouldStart;
	        }
	
	        /**
	         * Start a ripple animation on an specific point with touch or mouse events. First
	         * decides if the animation should trigger. If the ripple is multiple or there is no
	         * ripple present, it creates a new key. If it's a simple ripple and already exists,
	         * it just restarts the current ripple. The animation happens in two state changes
	         * to allow triggering via css.
	         *
	         * @param {Number} x Coordinate X on the screen where animation should start
	         * @param {Number} y Coordinate Y on the screen where animation should start
	         * @param {Boolean} isTouch Use events from touch or mouse.
	         */
	
	      }, {
	        key: 'animateRipple',
	        value: function animateRipple(x, y, isTouch) {
	          var _this3 = this;
	
	          if (this.rippleShouldTrigger(isTouch)) {
	            var _getDescriptor = this.getDescriptor(x, y),
	                top = _getDescriptor.top,
	                left = _getDescriptor.left,
	                width = _getDescriptor.width;
	
	            var noRipplesActive = Object.keys(this.state.ripples).length === 0;
	            var key = this.props.rippleMultiple || noRipplesActive ? this.getNextKey() : this.getLastKey();
	            var endRipple = this.addRippleDeactivateEventListener(isTouch, key);
	            var initialState = { active: false, restarting: true, top: top, left: left, width: width, endRipple: endRipple };
	            var runningState = { active: true, restarting: false };
	            var ripples = _extends({}, this.state.ripples, _defineProperty({}, key, initialState));
	            this.setState({ ripples: ripples }, function () {
	              if (_this3.rippleNodes[key]) _this3.rippleNodes[key].offsetWidth; // eslint-disable-line
	              _this3.setState({ ripples: _extends({}, _this3.state.ripples, _defineProperty({}, key, Object.assign({}, _this3.state.ripples[key], runningState))) });
	            });
	          }
	        }
	
	        /**
	         * Add an event listener to the reference with given key so when the animation transition
	         * ends we can be sure that it finished and it can be safely removed from the state.
	         * This function is called whenever a new ripple is added to the component.
	         *
	         * @param {String} rippleKey Is the key of the ripple to add the event.
	         */
	
	      }, {
	        key: 'addRippleRemoveEventListener',
	        value: function addRippleRemoveEventListener(rippleKey) {
	          var self = this;
	          var rippleNode = this.rippleNodes[rippleKey];
	          _events2.default.addEventListenerOnTransitionEnded(rippleNode, function onOpacityEnd(e) {
	            if (e.propertyName === 'opacity') {
	              if (self.props.onRippleEnded) self.props.onRippleEnded(e);
	              _events2.default.removeEventListenerOnTransitionEnded(self.rippleNodes[rippleKey], onOpacityEnd);
	              // self.rippleNodes = dissoc(rippleKey, self.rippleNodes);
	              delete self.rippleNodes[rippleKey];
	              self.setState({ ripples: (0, _dissoc2.default)(rippleKey, self.state.ripples) });
	            }
	          });
	        }
	
	        /**
	         * Add an event listener to the document needed to deactivate a ripple and make it dissappear.
	         * Deactivation can happen with a touchend or mouseup depending on the trigger type. The
	         * ending function is created from a factory function and returned.
	         *
	         * @param {Boolean} isTouch True in case the trigger was a touch event false otherwise.
	         * @param {String} rippleKey It's a key to identify the ripple that should be deactivated.
	         * @return {Function} Callback function that deactivates the ripple and removes the listener
	         */
	
	      }, {
	        key: 'addRippleDeactivateEventListener',
	        value: function addRippleDeactivateEventListener(isTouch, rippleKey) {
	          var eventType = isTouch ? 'touchend' : 'mouseup';
	          var endRipple = this.createRippleDeactivateCallback(eventType, rippleKey);
	          document.addEventListener(eventType, endRipple);
	          return endRipple;
	        }
	
	        /**
	         * Generates a function that can be called to deactivate a ripple and remove its finishing
	         * event listener. If is generated because we need to store it to be called on unmount in case
	         * the ripple is still running.
	         *
	         * @param {String} eventType Is the event type that can be touchend or mouseup
	         * @param {String} rippleKey Is the key representing the ripple
	         * @return {Function} Callback function that deactivates the ripple and removes the listener
	         */
	
	      }, {
	        key: 'createRippleDeactivateCallback',
	        value: function createRippleDeactivateCallback(eventType, rippleKey) {
	          var self = this;
	          return function endRipple() {
	            document.removeEventListener(eventType, endRipple);
	            self.setState({ ripples: _extends({}, self.state.ripples, _defineProperty({}, rippleKey, Object.assign({}, self.state.ripples[rippleKey], { active: false }))) });
	          };
	        }
	      }, {
	        key: 'renderRipple',
	        value: function renderRipple(key, className, _ref2) {
	          var _classnames,
	              _this4 = this;
	
	          var active = _ref2.active,
	              left = _ref2.left,
	              restarting = _ref2.restarting,
	              top = _ref2.top,
	              width = _ref2.width;
	
	          var scale = restarting ? 0 : 1;
	          var transform = 'translate3d(' + (-width / 2 + left) + 'px, ' + (-width / 2 + top) + 'px, 0) scale(' + scale + ')';
	          var _className = (0, _classnames3.default)(this.props.theme.ripple, (_classnames = {}, _defineProperty(_classnames, this.props.theme.rippleActive, active), _defineProperty(_classnames, this.props.theme.rippleRestarting, restarting), _classnames), className);
	          return _react2.default.createElement(
	            'span',
	            _extends({ key: key, 'data-react-toolbox': 'ripple', className: this.props.theme.rippleWrapper }, props),
	            _react2.default.createElement('span', {
	              className: _className,
	              ref: function ref(node) {
	                if (node) _this4.rippleNodes[key] = node;
	              },
	              style: (0, _prefixer2.default)({ transform: transform }, { width: width, height: width })
	            })
	          );
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this5 = this;
	
	          var _props2 = this.props,
	              children = _props2.children,
	              disabled = _props2.disabled,
	              ripple = _props2.ripple,
	              onRippleEnded = _props2.onRippleEnded,
	              rippleCentered = _props2.rippleCentered,
	              rippleClassName = _props2.rippleClassName,
	              rippleMultiple = _props2.rippleMultiple,
	              rippleSpread = _props2.rippleSpread,
	              theme = _props2.theme,
	              other = _objectWithoutProperties(_props2, ['children', 'disabled', 'ripple', 'onRippleEnded', 'rippleCentered', 'rippleClassName', 'rippleMultiple', 'rippleSpread', 'theme']);
	
	          var ripples = this.state.ripples;
	
	          var childRipples = Object.keys(ripples).map(function (key) {
	            return _this5.renderRipple(key, rippleClassName, ripples[key]);
	          });
	          var childProps = _extends({
	            onMouseDown: this.handleMouseDown,
	            onTouchStart: this.handleTouchStart
	          }, other);
	          var finalProps = defaultPassthrough ? _extends({}, childProps, { theme: theme, disabled: disabled }) : childProps;
	
	          return !ripple ? _react2.default.createElement(ComposedComponent, finalProps, children) : _react2.default.createElement(ComposedComponent, finalProps, [children, childRipples]);
	        }
	      }]);
	
	      return RippledComponent;
	    }(_react.Component);
	
	    RippledComponent.propTypes = {
	      children: _propTypes2.default.node,
	      disabled: _propTypes2.default.bool,
	      onMouseDown: _propTypes2.default.func,
	      onRippleEnded: _propTypes2.default.func,
	      onTouchStart: _propTypes2.default.func,
	      ripple: _propTypes2.default.bool,
	      rippleCentered: _propTypes2.default.bool,
	      rippleClassName: _propTypes2.default.string,
	      rippleMultiple: _propTypes2.default.bool,
	      rippleSpread: _propTypes2.default.number,
	      theme: _propTypes2.default.shape({
	        ripple: _propTypes2.default.string,
	        rippleActive: _propTypes2.default.string,
	        rippleRestarting: _propTypes2.default.string,
	        rippleWrapper: _propTypes2.default.string
	      })
	    };
	    RippledComponent.defaultProps = {
	      disabled: false,
	      ripple: true,
	      rippleCentered: defaultCentered,
	      rippleClassName: defaultClassName,
	      rippleMultiple: defaultMultiple,
	      rippleSpread: defaultSpread
	    };
	
	
	    return (0, _reactCssThemr.themr)(_identifiers.RIPPLE, defaultTheme)(RippledComponent);
	  };
	};
	
	exports.default = rippleFactory;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(593);
	var _isPlaceholder = __webpack_require__(1647);
	
	
	/**
	 * Optimized internal two-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry2(fn) {
	  return function f2(a, b) {
	    switch (arguments.length) {
	      case 0:
	        return f2;
	      case 1:
	        return _isPlaceholder(a) ? f2
	             : _curry1(function(_b) { return fn(a, _b); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
	             : fn(a, b);
	    }
	  };
	};


/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SortDirection = {
	  /**
	   * Sort items in ascending order.
	   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
	   */
	  ASC: 'ASC',
	
	  /**
	   * Sort items in descending order.
	   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
	   */
	  DESC: 'DESC'
	};
	
	exports.default = SortDirection;

/***/ }),
/* 1049 */,
/* 1050 */,
/* 1051 */
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ }),
/* 1052 */
1060,
/* 1053 */
6258,
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(2889);
	
	var iterableToArrayLimit = __webpack_require__(2891);
	
	var nonIterableRest = __webpack_require__(2892);
	
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
	}
	
	module.exports = _slicedToArray;

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var diff_1 = __webpack_require__(2899);
	exports.selectUnit = diff_1.selectUnit;
	var polyfill_utils_1 = __webpack_require__(1665);
	exports.defaultNumberOption = polyfill_utils_1.defaultNumberOption;
	exports.getAliasesByLang = polyfill_utils_1.getAliasesByLang;
	exports.getInternalSlot = polyfill_utils_1.getInternalSlot;
	exports.getMultiInternalSlots = polyfill_utils_1.getMultiInternalSlots;
	exports.getNumberOption = polyfill_utils_1.getNumberOption;
	exports.getOption = polyfill_utils_1.getOption;
	exports.getParentLocalesByLang = polyfill_utils_1.getParentLocalesByLang;
	exports.isLiteralPart = polyfill_utils_1.isLiteralPart;
	exports.partitionPattern = polyfill_utils_1.partitionPattern;
	exports.setInternalSlot = polyfill_utils_1.setInternalSlot;
	exports.setMultiInternalSlots = polyfill_utils_1.setMultiInternalSlots;
	exports.setNumberFormatDigitOptions = polyfill_utils_1.setNumberFormatDigitOptions;
	exports.toObject = polyfill_utils_1.toObject;
	exports.objectIs = polyfill_utils_1.objectIs;
	exports.isWellFormedCurrencyCode = polyfill_utils_1.isWellFormedCurrencyCode;
	exports.toString = polyfill_utils_1.toString;
	var resolve_locale_1 = __webpack_require__(2902);
	exports.createResolveLocale = resolve_locale_1.createResolveLocale;
	exports.getLocaleHierarchy = resolve_locale_1.getLocaleHierarchy;
	exports.supportedLocales = resolve_locale_1.supportedLocales;
	exports.unpackData = resolve_locale_1.unpackData;
	exports.isMissingLocaleDataError = resolve_locale_1.isMissingLocaleDataError;
	__export(__webpack_require__(2903));
	__export(__webpack_require__(2900));
	var get_canonical_locales_1 = __webpack_require__(1664);
	exports.getCanonicalLocales = get_canonical_locales_1.getCanonicalLocales;
	var invariant_1 = __webpack_require__(1059);
	exports.invariant = invariant_1.invariant;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function invariant(condition, message, Err) {
	    if (Err === void 0) { Err = Error; }
	    if (!condition) {
	        throw new Err(message);
	    }
	}
	exports.invariant = invariant;
	//# sourceMappingURL=invariant.js.map

/***/ }),
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var parsers_1 = __webpack_require__(1669);
	var tracekit_1 = __webpack_require__(1065);
	/**
	 * Builds and Event from a Exception
	 * @hidden
	 */
	function eventFromException(options, exception, hint) {
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromUnknownInput(exception, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    utils_1.addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
	    event.level = types_1.Severity.Error;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromException = eventFromException;
	/**
	 * Builds and Event from a Message
	 * @hidden
	 */
	function eventFromMessage(options, message, level, hint) {
	    if (level === void 0) { level = types_1.Severity.Info; }
	    var syntheticException = (hint && hint.syntheticException) || undefined;
	    var event = eventFromString(message, syntheticException, {
	        attachStacktrace: options.attachStacktrace,
	    });
	    event.level = level;
	    if (hint && hint.event_id) {
	        event.event_id = hint.event_id;
	    }
	    return utils_1.SyncPromise.resolve(event);
	}
	exports.eventFromMessage = eventFromMessage;
	/**
	 * @hidden
	 */
	function eventFromUnknownInput(exception, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event;
	    if (utils_1.isErrorEvent(exception) && exception.error) {
	        // If it is an ErrorEvent with `error` property, extract it to get actual Error
	        var errorEvent = exception;
	        // eslint-disable-next-line no-param-reassign
	        exception = errorEvent.error;
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
	    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
	    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
	    //
	    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
	    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
	    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
	    if (utils_1.isDOMError(exception) || utils_1.isDOMException(exception)) {
	        var domException = exception;
	        if ('stack' in exception) {
	            event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        }
	        else {
	            var name_1 = domException.name || (utils_1.isDOMError(domException) ? 'DOMError' : 'DOMException');
	            var message = domException.message ? name_1 + ": " + domException.message : name_1;
	            event = eventFromString(message, syntheticException, options);
	            utils_1.addExceptionTypeValue(event, message);
	        }
	        if ('code' in domException) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { 'DOMException.code': "" + domException.code });
	        }
	        return event;
	    }
	    if (utils_1.isError(exception)) {
	        // we have a real Error object, do nothing
	        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
	        return event;
	    }
	    if (utils_1.isPlainObject(exception) || utils_1.isEvent(exception)) {
	        // If it is plain Object or Event, serialize it manually and extract options
	        // This will allow us to group events based on top-level keys
	        // which is much better than creating new group when any key/value change
	        var objectException = exception;
	        event = parsers_1.eventFromPlainObject(objectException, syntheticException, options.rejection);
	        utils_1.addExceptionMechanism(event, {
	            synthetic: true,
	        });
	        return event;
	    }
	    // If none of previous checks were valid, then it means that it's not:
	    // - an instance of DOMError
	    // - an instance of DOMException
	    // - an instance of Event
	    // - an instance of Error
	    // - a valid ErrorEvent (one with an error property)
	    // - a plain Object
	    //
	    // So bail out and capture it as a simple message:
	    event = eventFromString(exception, syntheticException, options);
	    utils_1.addExceptionTypeValue(event, "" + exception, undefined);
	    utils_1.addExceptionMechanism(event, {
	        synthetic: true,
	    });
	    return event;
	}
	exports.eventFromUnknownInput = eventFromUnknownInput;
	/**
	 * @hidden
	 */
	function eventFromString(input, syntheticException, options) {
	    if (options === void 0) { options = {}; }
	    var event = {
	        message: input,
	    };
	    if (options.attachStacktrace && syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = parsers_1.prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromString = eventFromString;
	//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var globalhandlers_1 = __webpack_require__(2918);
	exports.GlobalHandlers = globalhandlers_1.GlobalHandlers;
	var trycatch_1 = __webpack_require__(2920);
	exports.TryCatch = trycatch_1.TryCatch;
	var breadcrumbs_1 = __webpack_require__(2916);
	exports.Breadcrumbs = breadcrumbs_1.Breadcrumbs;
	var linkederrors_1 = __webpack_require__(2919);
	exports.LinkedErrors = linkederrors_1.LinkedErrors;
	var useragent_1 = __webpack_require__(2921);
	exports.UserAgent = useragent_1.UserAgent;
	var dedupe_1 = __webpack_require__(2917);
	exports.Dedupe = dedupe_1.Dedupe;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * This was originally forked from https://github.com/occ/TraceKit, but has since been
	 * largely modified and is now maintained as part of Sentry JS SDK.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	// global reference to slice
	var UNKNOWN_FUNCTION = '?';
	// Chromium based browsers: Chrome, Brave, new Opera, new Edge
	var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
	// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
	// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
	// We need this specific case for now because we want no other regex to match.
	var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
	var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
	var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
	var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
	// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
	var reactMinifiedRegexp = /Minified React error #\d+;/i;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function computeStackTrace(ex) {
	    var stack = null;
	    var popSize = 0;
	    if (ex) {
	        if (typeof ex.framesToPop === 'number') {
	            popSize = ex.framesToPop;
	        }
	        else if (reactMinifiedRegexp.test(ex.message)) {
	            popSize = 1;
	        }
	    }
	    try {
	        // This must be tried first because Opera 10 *destroys*
	        // its stacktrace property if you try to access the stack
	        // property first!!
	        stack = computeStackTraceFromStacktraceProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    try {
	        stack = computeStackTraceFromStackProp(ex);
	        if (stack) {
	            return popFrames(stack, popSize);
	        }
	    }
	    catch (e) {
	        // no-empty
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex && ex.name,
	        stack: [],
	        failed: true,
	    };
	}
	exports.computeStackTrace = computeStackTrace;
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
	function computeStackTraceFromStackProp(ex) {
	    var _a, _b;
	    if (!ex || !ex.stack) {
	        return null;
	    }
	    var stack = [];
	    var lines = ex.stack.split('\n');
	    var isEval;
	    var submatch;
	    var parts;
	    var element;
	    for (var i = 0; i < lines.length; ++i) {
	        if ((parts = chrome.exec(lines[i]))) {
	            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
	            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
	            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
	                // throw out eval line/column and use top-most line/column number
	                parts[2] = submatch[1]; // url
	                parts[3] = submatch[2]; // line
	                parts[4] = submatch[3]; // column
	            }
	            // Arpad: Working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
	            // prefix here seems like the quickest solution for now.
	            var url = parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2];
	            // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
	            // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
	            var func = parts[1] || UNKNOWN_FUNCTION;
	            _a = tslib_1.__read(extractSafariExtensionDetails(func, url), 2), func = _a[0], url = _a[1];
	            element = {
	                url: url,
	                func: func,
	                args: isNative ? [parts[2]] : [],
	                line: parts[3] ? +parts[3] : null,
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = winjs.exec(lines[i]))) {
	            element = {
	                url: parts[2],
	                func: parts[1] || UNKNOWN_FUNCTION,
	                args: [],
	                line: +parts[3],
	                column: parts[4] ? +parts[4] : null,
	            };
	        }
	        else if ((parts = gecko.exec(lines[i]))) {
	            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
	            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
	                // throw out eval line/column and use top-most line number
	                parts[1] = parts[1] || "eval";
	                parts[3] = submatch[1];
	                parts[4] = submatch[2];
	                parts[5] = ''; // no column when eval
	            }
	            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
	                // FireFox uses this awesome columnNumber property for its top frame
	                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	                // so adding 1
	                // NOTE: this hack doesn't work if top-most frame is eval
	                stack[0].column = ex.columnNumber + 1;
	            }
	            var url = parts[3];
	            var func = parts[1] || UNKNOWN_FUNCTION;
	            _b = tslib_1.__read(extractSafariExtensionDetails(func, url), 2), func = _b[0], url = _b[1];
	            element = {
	                url: url,
	                func: func,
	                args: parts[2] ? parts[2].split(',') : [],
	                line: parts[4] ? +parts[4] : null,
	                column: parts[5] ? +parts[5] : null,
	            };
	        }
	        else {
	            continue;
	        }
	        if (!element.func && element.line) {
	            element.func = UNKNOWN_FUNCTION;
	        }
	        stack.push(element);
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/** JSDoc */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function computeStackTraceFromStacktraceProp(ex) {
	    if (!ex || !ex.stacktrace) {
	        return null;
	    }
	    // Access and store the stacktrace property before doing ANYTHING
	    // else to it because Opera is not very good at providing it
	    // reliably in other circumstances.
	    var stacktrace = ex.stacktrace;
	    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
	    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
	    var lines = stacktrace.split('\n');
	    var stack = [];
	    var parts;
	    for (var line = 0; line < lines.length; line += 2) {
	        var element = null;
	        if ((parts = opera10Regex.exec(lines[line]))) {
	            element = {
	                url: parts[2],
	                func: parts[3],
	                args: [],
	                line: +parts[1],
	                column: null,
	            };
	        }
	        else if ((parts = opera11Regex.exec(lines[line]))) {
	            element = {
	                url: parts[6],
	                func: parts[3] || parts[4],
	                args: parts[5] ? parts[5].split(',') : [],
	                line: +parts[1],
	                column: +parts[2],
	            };
	        }
	        if (element) {
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	            stack.push(element);
	        }
	    }
	    if (!stack.length) {
	        return null;
	    }
	    return {
	        message: extractMessage(ex),
	        name: ex.name,
	        stack: stack,
	    };
	}
	/**
	 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
	 * What it means, is that instead of format like:
	 *
	 * Error: wat
	 *   at function@url:row:col
	 *   at function@url:row:col
	 *   at function@url:row:col
	 *
	 * it produces something like:
	 *
	 *   function@url:row:col
	 *   function@url:row:col
	 *   function@url:row:col
	 *
	 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
	 * This function is extracted so that we can use it in both places without duplicating the logic.
	 * Unfortunatelly "just" changing RegExp is too complicated now and making it pass all tests
	 * and fix this case seems like an impossible, or at least way too time-consuming task.
	 */
	var extractSafariExtensionDetails = function (func, url) {
	    var isSafariExtension = func.indexOf('safari-extension') !== -1;
	    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
	    return isSafariExtension || isSafariWebExtension
	        ? [
	            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
	            isSafariExtension ? "safari-extension:" + url : "safari-web-extension:" + url,
	        ]
	        : [func, url];
	};
	/** Remove N number of frames from the stack */
	function popFrames(stacktrace, popSize) {
	    try {
	        return tslib_1.__assign(tslib_1.__assign({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
	    }
	    catch (e) {
	        return stacktrace;
	    }
	}
	/**
	 * There are cases where stacktrace.message is an Event object
	 * https://github.com/getsentry/sentry-javascript/issues/1949
	 * In this specific case we try to extract stacktrace.message.error.message
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function extractMessage(ex) {
	    var message = ex && ex.message;
	    if (!message) {
	        return 'No error message';
	    }
	    if (message.error && typeof message.error.message === 'string') {
	        return message.error.message;
	    }
	    return message;
	}
	//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var core_1 = __webpack_require__(192);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var utils_2 = __webpack_require__(1671);
	var CATEGORY_MAPPING = {
	    event: 'error',
	    transaction: 'transaction',
	    session: 'session',
	    attachment: 'attachment',
	};
	var global = utils_1.getGlobalObject();
	/** Base Transport class implementation */
	var BaseTransport = /** @class */ (function () {
	    function BaseTransport(options) {
	        var _this = this;
	        this.options = options;
	        /** A simple buffer holding all requests. */
	        this._buffer = new utils_1.PromiseBuffer(30);
	        /** Locks transport after receiving rate limits in a response */
	        this._rateLimits = {};
	        this._outcomes = {};
	        this._api = new core_1.API(options.dsn, options._metadata, options.tunnel);
	        // eslint-disable-next-line deprecation/deprecation
	        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
	        if (this.options.sendClientReports && global.document) {
	            global.document.addEventListener('visibilitychange', function () {
	                if (global.document.visibilityState === 'hidden') {
	                    _this._flushOutcomes();
	                }
	            });
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.sendEvent = function (_) {
	        throw new utils_1.SentryError('Transport Class has to implement `sendEvent` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.close = function (timeout) {
	        return this._buffer.drain(timeout);
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseTransport.prototype.recordLostEvent = function (reason, category) {
	        var _a;
	        if (!this.options.sendClientReports) {
	            return;
	        }
	        // We want to track each category (event, transaction, session) separately
	        // but still keep the distinction between different type of outcomes.
	        // We could use nested maps, but it's much easier to read and type this way.
	        // A correct type for map-based implementation if we want to go that route
	        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
	        var key = CATEGORY_MAPPING[category] + ":" + reason;
	        utils_1.logger.log("Adding outcome: " + key);
	        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
	    };
	    /**
	     * Send outcomes as an envelope
	     */
	    BaseTransport.prototype._flushOutcomes = function () {
	        if (!this.options.sendClientReports) {
	            return;
	        }
	        var outcomes = this._outcomes;
	        this._outcomes = {};
	        // Nothing to send
	        if (!Object.keys(outcomes).length) {
	            utils_1.logger.log('No outcomes to flush');
	            return;
	        }
	        utils_1.logger.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
	        var url = this._api.getEnvelopeEndpointWithUrlEncodedAuth();
	        // Envelope header is required to be at least an empty object
	        var envelopeHeader = JSON.stringify(tslib_1.__assign({}, (this.options.tunnel && { dsn: this._api.getDsn().toString() })));
	        var itemHeaders = JSON.stringify({
	            type: 'client_report',
	        });
	        var item = JSON.stringify({
	            timestamp: utils_1.dateTimestampInSeconds(),
	            discarded_events: Object.keys(outcomes).map(function (key) {
	                var _a = tslib_1.__read(key.split(':'), 2), category = _a[0], reason = _a[1];
	                return {
	                    reason: reason,
	                    category: category,
	                    quantity: outcomes[key],
	                };
	            }),
	        });
	        var envelope = envelopeHeader + "\n" + itemHeaders + "\n" + item;
	        try {
	            utils_2.sendReport(url, envelope);
	        }
	        catch (e) {
	            utils_1.logger.error(e);
	        }
	    };
	    /**
	     * Handle Sentry repsonse for promise-based transports.
	     */
	    BaseTransport.prototype._handleResponse = function (_a) {
	        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
	        var status = types_1.Status.fromHttpCode(response.status);
	        /**
	         * "The name is case-insensitive."
	         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
	         */
	        var limited = this._handleRateLimit(headers);
	        if (limited)
	            utils_1.logger.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
	        if (status === types_1.Status.Success) {
	            resolve({ status: status });
	            return;
	        }
	        reject(response);
	    };
	    /**
	     * Gets the time that given category is disabled until for rate limiting
	     */
	    BaseTransport.prototype._disabledUntil = function (requestType) {
	        var category = CATEGORY_MAPPING[requestType];
	        return this._rateLimits[category] || this._rateLimits.all;
	    };
	    /**
	     * Checks if a category is rate limited
	     */
	    BaseTransport.prototype._isRateLimited = function (requestType) {
	        return this._disabledUntil(requestType) > new Date(Date.now());
	    };
	    /**
	     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
	     */
	    BaseTransport.prototype._handleRateLimit = function (headers) {
	        var e_1, _a, e_2, _b;
	        var now = Date.now();
	        var rlHeader = headers['x-sentry-rate-limits'];
	        var raHeader = headers['retry-after'];
	        if (rlHeader) {
	            try {
	                // rate limit headers are of the form
	                //     <header>,<header>,..
	                // where each <header> is of the form
	                //     <retry_after>: <categories>: <scope>: <reason_code>
	                // where
	                //     <retry_after> is a delay in ms
	                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
	                //         <category>;<category>;...
	                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
	                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
	                for (var _c = tslib_1.__values(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
	                    var limit = _d.value;
	                    var parameters = limit.split(':', 2);
	                    var headerDelay = parseInt(parameters[0], 10);
	                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
	                    try {
	                        for (var _e = (e_2 = void 0, tslib_1.__values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                            var category = _f.value;
	                            this._rateLimits[category || 'all'] = new Date(now + delay);
	                        }
	                    }
	                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                    finally {
	                        try {
	                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                        }
	                        finally { if (e_2) throw e_2.error; }
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            return true;
	        }
	        else if (raHeader) {
	            this._rateLimits.all = new Date(now + utils_1.parseRetryAfterHeader(now, raHeader));
	            return true;
	        }
	        return false;
	    };
	    return BaseTransport;
	}());
	exports.BaseTransport = BaseTransport;
	//# sourceMappingURL=base.js.map

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	tslib_1.__exportStar(__webpack_require__(602), exports);
	var sdk_1 = __webpack_require__(2943);
	exports.init = sdk_1.init;
	var profiler_1 = __webpack_require__(2939);
	exports.Profiler = profiler_1.Profiler;
	exports.withProfiler = profiler_1.withProfiler;
	exports.useProfiler = profiler_1.useProfiler;
	var errorboundary_1 = __webpack_require__(2938);
	exports.ErrorBoundary = errorboundary_1.ErrorBoundary;
	exports.withErrorBoundary = errorboundary_1.withErrorBoundary;
	var redux_1 = __webpack_require__(2942);
	exports.createReduxEnhancer = redux_1.createReduxEnhancer;
	var reactrouterv3_1 = __webpack_require__(2941);
	exports.reactRouterV3Instrumentation = reactrouterv3_1.reactRouterV3Instrumentation;
	var reactrouter_1 = __webpack_require__(2940);
	exports.reactRouterV4Instrumentation = reactrouter_1.reactRouterV4Instrumentation;
	exports.reactRouterV5Instrumentation = reactrouter_1.reactRouterV5Instrumentation;
	exports.withSentryRouting = reactrouter_1.withSentryRouting;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(747);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var browsertracing_1 = __webpack_require__(2945);
	exports.BrowserTracing = browsertracing_1.BrowserTracing;
	var request_1 = __webpack_require__(1677);
	exports.instrumentOutgoingRequests = request_1.instrumentOutgoingRequests;
	exports.defaultRequestInstrumentationOptions = request_1.defaultRequestInstrumentationOptions;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.bindReporter = function (callback, metric, reportAllChanges) {
	    var prevValue;
	    return function (forceReport) {
	        if (metric.value >= 0) {
	            if (forceReport || reportAllChanges) {
	                metric.delta = metric.value - (prevValue || 0);
	                // Report the metric if there's a non-zero delta or if no previous
	                // value exists (which can happen in the case of the document becoming
	                // hidden when the metric value is 0).
	                // See: https://github.com/GoogleChrome/web-vitals/issues/14
	                if (metric.delta || prevValue === undefined) {
	                    prevValue = metric.value;
	                    callback(metric);
	                }
	            }
	        }
	    };
	};
	//# sourceMappingURL=bindReporter.js.map

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	var onHidden_1 = __webpack_require__(756);
	var firstHiddenTime = -1;
	var initHiddenTime = function () {
	    return utils_1.getGlobalObject().document.visibilityState === 'hidden' ? 0 : Infinity;
	};
	var trackChanges = function () {
	    // Update the time if/when the document becomes hidden.
	    onHidden_1.onHidden(function (_a) {
	        var timeStamp = _a.timeStamp;
	        firstHiddenTime = timeStamp;
	    }, true);
	};
	exports.getVisibilityWatcher = function () {
	    if (firstHiddenTime < 0) {
	        // If the document is hidden when this code runs, assume it was hidden
	        // since navigation start. This isn't a perfect heuristic, but it's the
	        // best we can do until an API is available to support querying past
	        // visibilityState.
	        firstHiddenTime = initHiddenTime();
	        trackChanges();
	    }
	    return {
	        get firstHiddenTime() {
	            return firstHiddenTime;
	        },
	    };
	};
	//# sourceMappingURL=getVisibilityWatcher.js.map

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var generateUniqueID_1 = __webpack_require__(2951);
	exports.initMetric = function (name, value) {
	    return {
	        name: name,
	        value: (value !== null && value !== void 0 ? value : -1),
	        delta: 0,
	        entries: [],
	        id: generateUniqueID_1.generateUniqueID(),
	    };
	};
	//# sourceMappingURL=initMetric.js.map

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Takes a performance entry type and a callback function, and creates a
	 * `PerformanceObserver` instance that will observe the specified entry type
	 * with buffering enabled and call the callback _for each entry_.
	 *
	 * This function also feature-detects entry support and wraps the logic in a
	 * try/catch to avoid errors in unsupporting browsers.
	 */
	exports.observe = function (type, callback) {
	    try {
	        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
	            // More extensive feature detect needed for Firefox due to:
	            // https://github.com/GoogleChrome/web-vitals/issues/142
	            if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
	                return;
	            }
	            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
	            po.observe({ type: type, buffered: true });
	            return po;
	        }
	    }
	    catch (e) {
	        // Do nothing.
	    }
	    return;
	};
	//# sourceMappingURL=observe.js.map

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var hub_1 = __webpack_require__(284);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var errors_1 = __webpack_require__(2952);
	var idletransaction_1 = __webpack_require__(1075);
	var transaction_1 = __webpack_require__(1077);
	var utils_2 = __webpack_require__(387);
	/** Returns all trace headers that are currently on the top scope. */
	function traceHeaders() {
	    var scope = this.getScope();
	    if (scope) {
	        var span = scope.getSpan();
	        if (span) {
	            return {
	                'sentry-trace': span.toTraceparent(),
	            };
	        }
	    }
	    return {};
	}
	/**
	 * Makes a sampling decision for the given transaction and stores it on the transaction.
	 *
	 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
	 * sent to Sentry.
	 *
	 * @param hub: The hub off of which to read config options
	 * @param transaction: The transaction needing a sampling decision
	 * @param samplingContext: Default and user-provided data which may be used to help make the decision
	 *
	 * @returns The given transaction with its `sampled` value set
	 */
	function sample(transaction, options, samplingContext) {
	    // nothing to do if tracing is not enabled
	    if (!utils_2.hasTracingEnabled(options)) {
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
	    if (transaction.sampled !== undefined) {
	        transaction.setMetadata({
	            transactionSampling: { method: types_1.TransactionSamplingMethod.Explicit },
	        });
	        return transaction;
	    }
	    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
	    // work; prefer the hook if so
	    var sampleRate;
	    if (typeof options.tracesSampler === 'function') {
	        sampleRate = options.tracesSampler(samplingContext);
	        transaction.setMetadata({
	            transactionSampling: {
	                method: types_1.TransactionSamplingMethod.Sampler,
	                // cast to number in case it's a boolean
	                rate: Number(sampleRate),
	            },
	        });
	    }
	    else if (samplingContext.parentSampled !== undefined) {
	        sampleRate = samplingContext.parentSampled;
	        transaction.setMetadata({
	            transactionSampling: { method: types_1.TransactionSamplingMethod.Inheritance },
	        });
	    }
	    else {
	        sampleRate = options.tracesSampleRate;
	        transaction.setMetadata({
	            transactionSampling: {
	                method: types_1.TransactionSamplingMethod.Rate,
	                // cast to number in case it's a boolean
	                rate: Number(sampleRate),
	            },
	        });
	    }
	    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
	    // only valid values are booleans or numbers between 0 and 1.)
	    if (!isValidSampleRate(sampleRate)) {
	        utils_1.logger.warn("[Tracing] Discarding transaction because of invalid sample rate.");
	        transaction.sampled = false;
	        return transaction;
	    }
	    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
	    if (!sampleRate) {
	        utils_1.logger.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
	            ? 'tracesSampler returned 0 or false'
	            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
	        transaction.sampled = false;
	        return transaction;
	    }
	    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
	    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
	    transaction.sampled = Math.random() < sampleRate;
	    // if we're not going to keep it, we're done
	    if (!transaction.sampled) {
	        utils_1.logger.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
	        return transaction;
	    }
	    utils_1.logger.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
	    return transaction;
	}
	/**
	 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
	 */
	function isValidSampleRate(rate) {
	    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    if (isNaN(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
	        utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
	        return false;
	    }
	    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
	    if (rate < 0 || rate > 1) {
	        utils_1.logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
	        return false;
	    }
	    return true;
	}
	/**
	 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
	 *
	 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
	 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
	 * "extension method."
	 *
	 * @param this: The Hub starting the transaction
	 * @param transactionContext: Data used to configure the transaction
	 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
	 *
	 * @returns The new transaction
	 *
	 * @see {@link Hub.startTransaction}
	 */
	function _startTransaction(transactionContext, customSamplingContext) {
	    var _a, _b;
	    var options = ((_a = this.getClient()) === null || _a === void 0 ? void 0 : _a.getOptions()) || {};
	    var transaction = new transaction_1.Transaction(transactionContext, this);
	    transaction = sample(transaction, options, tslib_1.__assign({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
	    if (transaction.sampled) {
	        transaction.initSpanRecorder((_b = options._experiments) === null || _b === void 0 ? void 0 : _b.maxSpans);
	    }
	    return transaction;
	}
	/**
	 * Create new idle transaction.
	 */
	function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
	    var _a, _b;
	    var options = ((_a = hub.getClient()) === null || _a === void 0 ? void 0 : _a.getOptions()) || {};
	    var transaction = new idletransaction_1.IdleTransaction(transactionContext, hub, idleTimeout, onScope);
	    transaction = sample(transaction, options, tslib_1.__assign({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
	    if (transaction.sampled) {
	        transaction.initSpanRecorder((_b = options._experiments) === null || _b === void 0 ? void 0 : _b.maxSpans);
	    }
	    return transaction;
	}
	exports.startIdleTransaction = startIdleTransaction;
	/**
	 * @private
	 */
	function _addTracingExtensions() {
	    var carrier = hub_1.getMainCarrier();
	    if (!carrier.__SENTRY__) {
	        return;
	    }
	    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
	    if (!carrier.__SENTRY__.extensions.startTransaction) {
	        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
	    }
	    if (!carrier.__SENTRY__.extensions.traceHeaders) {
	        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
	    }
	}
	exports._addTracingExtensions = _addTracingExtensions;
	/**
	 * @private
	 */
	function _autoloadDatabaseIntegrations() {
	    var carrier = hub_1.getMainCarrier();
	    if (!carrier.__SENTRY__) {
	        return;
	    }
	    var packageToIntegrationMapping = {
	        mongodb: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/mongo');
	            return new integration.Mongo();
	        },
	        mongoose: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/mongo');
	            return new integration.Mongo({ mongoose: true });
	        },
	        mysql: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/mysql');
	            return new integration.Mysql();
	        },
	        pg: function () {
	            var integration = utils_1.dynamicRequire(module, './integrations/node/postgres');
	            return new integration.Postgres();
	        },
	    };
	    var mappedPackages = Object.keys(packageToIntegrationMapping)
	        .filter(function (moduleName) { return !!utils_1.loadModule(moduleName); })
	        .map(function (pkg) {
	        try {
	            return packageToIntegrationMapping[pkg]();
	        }
	        catch (e) {
	            return undefined;
	        }
	    })
	        .filter(function (p) { return p; });
	    if (mappedPackages.length > 0) {
	        carrier.__SENTRY__.integrations = tslib_1.__spread((carrier.__SENTRY__.integrations || []), mappedPackages);
	    }
	}
	/**
	 * This patches the global object and injects the Tracing extensions methods
	 */
	function addExtensionMethods() {
	    _addTracingExtensions();
	    // Detect and automatically load specified integrations.
	    if (utils_1.isNodeEnv()) {
	        _autoloadDatabaseIntegrations();
	    }
	    // If an error happens globally, we should make sure transaction status is set to error.
	    errors_1.registerErrorInstrumentation();
	}
	exports.addExtensionMethods = addExtensionMethods;
	//# sourceMappingURL=hubextensions.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)(module)))

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	var constants_1 = __webpack_require__(1678);
	var span_1 = __webpack_require__(1076);
	var spanstatus_1 = __webpack_require__(386);
	var transaction_1 = __webpack_require__(1077);
	exports.DEFAULT_IDLE_TIMEOUT = 1000;
	exports.HEARTBEAT_INTERVAL = 5000;
	/**
	 * @inheritDoc
	 */
	var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransactionSpanRecorder, _super);
	    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
	        if (transactionSpanId === void 0) { transactionSpanId = ''; }
	        var _this = _super.call(this, maxlen) || this;
	        _this._pushActivity = _pushActivity;
	        _this._popActivity = _popActivity;
	        _this.transactionSpanId = transactionSpanId;
	        return _this;
	    }
	    /**
	     * @inheritDoc
	     */
	    IdleTransactionSpanRecorder.prototype.add = function (span) {
	        var _this = this;
	        // We should make sure we do not push and pop activities for
	        // the transaction that this span recorder belongs to.
	        if (span.spanId !== this.transactionSpanId) {
	            // We patch span.finish() to pop an activity after setting an endTimestamp.
	            span.finish = function (endTimestamp) {
	                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	                _this._popActivity(span.spanId);
	            };
	            // We should only push new activities if the span does not have an end timestamp.
	            if (span.endTimestamp === undefined) {
	                this._pushActivity(span.spanId);
	            }
	        }
	        _super.prototype.add.call(this, span);
	    };
	    return IdleTransactionSpanRecorder;
	}(span_1.SpanRecorder));
	exports.IdleTransactionSpanRecorder = IdleTransactionSpanRecorder;
	/**
	 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
	 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
	 * put itself on the scope on creation.
	 */
	var IdleTransaction = /** @class */ (function (_super) {
	    tslib_1.__extends(IdleTransaction, _super);
	    function IdleTransaction(transactionContext, _idleHub, 
	    /**
	     * The time to wait in ms until the idle transaction will be finished.
	     * @default 1000
	     */
	    _idleTimeout, 
	    // If an idle transaction should be put itself on and off the scope automatically.
	    _onScope) {
	        if (_idleTimeout === void 0) { _idleTimeout = exports.DEFAULT_IDLE_TIMEOUT; }
	        if (_onScope === void 0) { _onScope = false; }
	        var _this = _super.call(this, transactionContext, _idleHub) || this;
	        _this._idleHub = _idleHub;
	        _this._idleTimeout = _idleTimeout;
	        _this._onScope = _onScope;
	        // Activities store a list of active spans
	        _this.activities = {};
	        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
	        _this._heartbeatCounter = 0;
	        // We should not use heartbeat if we finished a transaction
	        _this._finished = false;
	        _this._beforeFinishCallbacks = [];
	        if (_idleHub && _onScope) {
	            // There should only be one active transaction on the scope
	            clearActiveTransaction(_idleHub);
	            // We set the transaction here on the scope so error events pick up the trace
	            // context and attach it to the error.
	            utils_1.logger.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
	            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
	        }
	        _this._initTimeout = setTimeout(function () {
	            if (!_this._finished) {
	                _this.finish();
	            }
	        }, _this._idleTimeout);
	        return _this;
	    }
	    /** {@inheritDoc} */
	    IdleTransaction.prototype.finish = function (endTimestamp) {
	        var e_1, _a;
	        var _this = this;
	        if (endTimestamp === void 0) { endTimestamp = utils_1.timestampWithMs(); }
	        this._finished = true;
	        this.activities = {};
	        if (this.spanRecorder) {
	            utils_1.logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
	            try {
	                for (var _b = tslib_1.__values(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var callback = _c.value;
	                    callback(this, endTimestamp);
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
	                // If we are dealing with the transaction itself, we just return it
	                if (span.spanId === _this.spanId) {
	                    return true;
	                }
	                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
	                if (!span.endTimestamp) {
	                    span.endTimestamp = endTimestamp;
	                    span.setStatus(spanstatus_1.SpanStatus.Cancelled);
	                    utils_1.logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
	                }
	                var keepSpan = span.startTimestamp < endTimestamp;
	                if (!keepSpan) {
	                    utils_1.logger.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
	                }
	                return keepSpan;
	            });
	            utils_1.logger.log('[Tracing] flushing IdleTransaction');
	        }
	        else {
	            utils_1.logger.log('[Tracing] No active IdleTransaction');
	        }
	        // this._onScope is true if the transaction was previously on the scope.
	        if (this._onScope) {
	            clearActiveTransaction(this._idleHub);
	        }
	        return _super.prototype.finish.call(this, endTimestamp);
	    };
	    /**
	     * Register a callback function that gets excecuted before the transaction finishes.
	     * Useful for cleanup or if you want to add any additional spans based on current context.
	     *
	     * This is exposed because users have no other way of running something before an idle transaction
	     * finishes.
	     */
	    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
	        this._beforeFinishCallbacks.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
	        var _this = this;
	        if (!this.spanRecorder) {
	            var pushActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._pushActivity(id);
	            };
	            var popActivity = function (id) {
	                if (_this._finished) {
	                    return;
	                }
	                _this._popActivity(id);
	            };
	            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
	            // Start heartbeat so that transactions do not run forever.
	            utils_1.logger.log('Starting heartbeat');
	            this._pingHeartbeat();
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Start tracking a specific activity.
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._pushActivity = function (spanId) {
	        if (this._initTimeout) {
	            clearTimeout(this._initTimeout);
	            this._initTimeout = undefined;
	        }
	        utils_1.logger.log("[Tracing] pushActivity: " + spanId);
	        this.activities[spanId] = true;
	        utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	    };
	    /**
	     * Remove an activity from usage
	     * @param spanId The span id that represents the activity
	     */
	    IdleTransaction.prototype._popActivity = function (spanId) {
	        var _this = this;
	        if (this.activities[spanId]) {
	            utils_1.logger.log("[Tracing] popActivity " + spanId);
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this.activities[spanId];
	            utils_1.logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
	        }
	        if (Object.keys(this.activities).length === 0) {
	            var timeout = this._idleTimeout;
	            // We need to add the timeout here to have the real endtimestamp of the transaction
	            // Remember timestampWithMs is in seconds, timeout is in ms
	            var end_1 = utils_1.timestampWithMs() + timeout / 1000;
	            setTimeout(function () {
	                if (!_this._finished) {
	                    _this.setTag(constants_1.FINISH_REASON_TAG, constants_1.IDLE_TRANSACTION_FINISH_REASONS[1]);
	                    _this.finish(end_1);
	                }
	            }, timeout);
	        }
	    };
	    /**
	     * Checks when entries of this.activities are not changing for 3 beats.
	     * If this occurs we finish the transaction.
	     */
	    IdleTransaction.prototype._beat = function () {
	        // We should not be running heartbeat if the idle transaction is finished.
	        if (this._finished) {
	            return;
	        }
	        var heartbeatString = Object.keys(this.activities).join('');
	        if (heartbeatString === this._prevHeartbeatString) {
	            this._heartbeatCounter += 1;
	        }
	        else {
	            this._heartbeatCounter = 1;
	        }
	        this._prevHeartbeatString = heartbeatString;
	        if (this._heartbeatCounter >= 3) {
	            utils_1.logger.log("[Tracing] Transaction finished because of no change for 3 heart beats");
	            this.setStatus(spanstatus_1.SpanStatus.DeadlineExceeded);
	            this.setTag(constants_1.FINISH_REASON_TAG, constants_1.IDLE_TRANSACTION_FINISH_REASONS[0]);
	            this.finish();
	        }
	        else {
	            this._pingHeartbeat();
	        }
	    };
	    /**
	     * Pings the heartbeat
	     */
	    IdleTransaction.prototype._pingHeartbeat = function () {
	        var _this = this;
	        utils_1.logger.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
	        setTimeout(function () {
	            _this._beat();
	        }, exports.HEARTBEAT_INTERVAL);
	    };
	    return IdleTransaction;
	}(transaction_1.Transaction));
	exports.IdleTransaction = IdleTransaction;
	/**
	 * Reset active transaction on scope
	 */
	function clearActiveTransaction(hub) {
	    if (hub) {
	        var scope = hub.getScope();
	        if (scope) {
	            var transaction = scope.getTransaction();
	            if (transaction) {
	                scope.setSpan(undefined);
	            }
	        }
	    }
	}
	//# sourceMappingURL=idletransaction.js.map

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	var spanstatus_1 = __webpack_require__(386);
	/**
	 * Keeps track of finished spans for a given transaction
	 * @internal
	 * @hideconstructor
	 * @hidden
	 */
	var SpanRecorder = /** @class */ (function () {
	    function SpanRecorder(maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        this.spans = [];
	        this._maxlen = maxlen;
	    }
	    /**
	     * This is just so that we don't run out of memory while recording a lot
	     * of spans. At some point we just stop and flush out the start of the
	     * trace tree (i.e.the first n spans with the smallest
	     * start_timestamp).
	     */
	    SpanRecorder.prototype.add = function (span) {
	        if (this.spans.length > this._maxlen) {
	            span.spanRecorder = undefined;
	        }
	        else {
	            this.spans.push(span);
	        }
	    };
	    return SpanRecorder;
	}());
	exports.SpanRecorder = SpanRecorder;
	/**
	 * Span contains all data about a span
	 */
	var Span = /** @class */ (function () {
	    /**
	     * You should never call the constructor manually, always use `Sentry.startTransaction()`
	     * or call `startChild()` on an existing span.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Span(spanContext) {
	        /**
	         * @inheritDoc
	         */
	        this.traceId = utils_1.uuid4();
	        /**
	         * @inheritDoc
	         */
	        this.spanId = utils_1.uuid4().substring(16);
	        /**
	         * Timestamp in seconds when the span was created.
	         */
	        this.startTimestamp = utils_1.timestampWithMs();
	        /**
	         * @inheritDoc
	         */
	        this.tags = {};
	        /**
	         * @inheritDoc
	         */
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.data = {};
	        if (!spanContext) {
	            return this;
	        }
	        if (spanContext.traceId) {
	            this.traceId = spanContext.traceId;
	        }
	        if (spanContext.spanId) {
	            this.spanId = spanContext.spanId;
	        }
	        if (spanContext.parentSpanId) {
	            this.parentSpanId = spanContext.parentSpanId;
	        }
	        // We want to include booleans as well here
	        if ('sampled' in spanContext) {
	            this.sampled = spanContext.sampled;
	        }
	        if (spanContext.op) {
	            this.op = spanContext.op;
	        }
	        if (spanContext.description) {
	            this.description = spanContext.description;
	        }
	        if (spanContext.data) {
	            this.data = spanContext.data;
	        }
	        if (spanContext.tags) {
	            this.tags = spanContext.tags;
	        }
	        if (spanContext.status) {
	            this.status = spanContext.status;
	        }
	        if (spanContext.startTimestamp) {
	            this.startTimestamp = spanContext.startTimestamp;
	        }
	        if (spanContext.endTimestamp) {
	            this.endTimestamp = spanContext.endTimestamp;
	        }
	    }
	    /**
	     * @inheritDoc
	     * @deprecated
	     */
	    Span.prototype.child = function (spanContext) {
	        return this.startChild(spanContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.startChild = function (spanContext) {
	        var childSpan = new Span(tslib_1.__assign(tslib_1.__assign({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
	        childSpan.spanRecorder = this.spanRecorder;
	        if (childSpan.spanRecorder) {
	            childSpan.spanRecorder.add(childSpan);
	        }
	        childSpan.transaction = this.transaction;
	        return childSpan;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setTag = function (key, value) {
	        var _a;
	        this.tags = tslib_1.__assign(tslib_1.__assign({}, this.tags), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Span.prototype.setData = function (key, value) {
	        var _a;
	        this.data = tslib_1.__assign(tslib_1.__assign({}, this.data), (_a = {}, _a[key] = value, _a));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setStatus = function (value) {
	        this.status = value;
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.setHttpStatus = function (httpStatus) {
	        this.setTag('http.status_code', String(httpStatus));
	        var spanStatus = spanstatus_1.SpanStatus.fromHttpCode(httpStatus);
	        if (spanStatus !== spanstatus_1.SpanStatus.UnknownError) {
	            this.setStatus(spanStatus);
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.isSuccess = function () {
	        return this.status === spanstatus_1.SpanStatus.Ok;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.finish = function (endTimestamp) {
	        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : utils_1.timestampWithMs();
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toTraceparent = function () {
	        var sampledString = '';
	        if (this.sampled !== undefined) {
	            sampledString = this.sampled ? '-1' : '-0';
	        }
	        return this.traceId + "-" + this.spanId + sampledString;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toContext = function () {
	        return utils_1.dropUndefinedKeys({
	            data: this.data,
	            description: this.description,
	            endTimestamp: this.endTimestamp,
	            op: this.op,
	            parentSpanId: this.parentSpanId,
	            sampled: this.sampled,
	            spanId: this.spanId,
	            startTimestamp: this.startTimestamp,
	            status: this.status,
	            tags: this.tags,
	            traceId: this.traceId,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.updateWithContext = function (spanContext) {
	        var _a, _b, _c, _d, _e;
	        this.data = (_a = spanContext.data, (_a !== null && _a !== void 0 ? _a : {}));
	        this.description = spanContext.description;
	        this.endTimestamp = spanContext.endTimestamp;
	        this.op = spanContext.op;
	        this.parentSpanId = spanContext.parentSpanId;
	        this.sampled = spanContext.sampled;
	        this.spanId = (_b = spanContext.spanId, (_b !== null && _b !== void 0 ? _b : this.spanId));
	        this.startTimestamp = (_c = spanContext.startTimestamp, (_c !== null && _c !== void 0 ? _c : this.startTimestamp));
	        this.status = spanContext.status;
	        this.tags = (_d = spanContext.tags, (_d !== null && _d !== void 0 ? _d : {}));
	        this.traceId = (_e = spanContext.traceId, (_e !== null && _e !== void 0 ? _e : this.traceId));
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.getTraceContext = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            trace_id: this.traceId,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Span.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            data: Object.keys(this.data).length > 0 ? this.data : undefined,
	            description: this.description,
	            op: this.op,
	            parent_span_id: this.parentSpanId,
	            span_id: this.spanId,
	            start_timestamp: this.startTimestamp,
	            status: this.status,
	            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
	            timestamp: this.endTimestamp,
	            trace_id: this.traceId,
	        });
	    };
	    return Span;
	}());
	exports.Span = Span;
	//# sourceMappingURL=span.js.map

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var hub_1 = __webpack_require__(284);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var span_1 = __webpack_require__(1076);
	/** JSDoc */
	var Transaction = /** @class */ (function (_super) {
	    tslib_1.__extends(Transaction, _super);
	    /**
	     * This constructor should never be called manually. Those instrumenting tracing should use
	     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
	     * @internal
	     * @hideconstructor
	     * @hidden
	     */
	    function Transaction(transactionContext, hub) {
	        var _this = _super.call(this, transactionContext) || this;
	        _this._measurements = {};
	        /**
	         * The reference to the current hub.
	         */
	        _this._hub = hub_1.getCurrentHub();
	        if (utils_1.isInstanceOf(hub, hub_1.Hub)) {
	            _this._hub = hub;
	        }
	        _this.name = transactionContext.name || '';
	        _this.metadata = transactionContext.metadata || {};
	        _this._trimEnd = transactionContext.trimEnd;
	        // this is because transactions are also spans, and spans have a transaction pointer
	        _this.transaction = _this;
	        return _this;
	    }
	    /**
	     * JSDoc
	     */
	    Transaction.prototype.setName = function (name) {
	        this.name = name;
	    };
	    /**
	     * Attaches SpanRecorder to the span itself
	     * @param maxlen maximum number of spans that can be recorded
	     */
	    Transaction.prototype.initSpanRecorder = function (maxlen) {
	        if (maxlen === void 0) { maxlen = 1000; }
	        if (!this.spanRecorder) {
	            this.spanRecorder = new span_1.SpanRecorder(maxlen);
	        }
	        this.spanRecorder.add(this);
	    };
	    /**
	     * Set observed measurements for this transaction.
	     * @hidden
	     */
	    Transaction.prototype.setMeasurements = function (measurements) {
	        this._measurements = tslib_1.__assign({}, measurements);
	    };
	    /**
	     * Set metadata for this transaction.
	     * @hidden
	     */
	    Transaction.prototype.setMetadata = function (newMetadata) {
	        this.metadata = tslib_1.__assign(tslib_1.__assign({}, this.metadata), newMetadata);
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.finish = function (endTimestamp) {
	        var _this = this;
	        var _a, _b, _c, _d, _e;
	        // This transaction is already finished, so we should not flush it again.
	        if (this.endTimestamp !== undefined) {
	            return undefined;
	        }
	        if (!this.name) {
	            utils_1.logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
	            this.name = '<unlabeled transaction>';
	        }
	        // just sets the end timestamp
	        _super.prototype.finish.call(this, endTimestamp);
	        if (this.sampled !== true) {
	            // At this point if `sampled !== true` we want to discard the transaction.
	            utils_1.logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
	            (_e = (_c = (_a = this._hub
	                .getClient()) === null || _a === void 0 ? void 0 : (_b = _a).getTransport) === null || _c === void 0 ? void 0 : (_d = _c.call(_b)).recordLostEvent) === null || _e === void 0 ? void 0 : _e.call(_d, types_1.Outcome.SampleRate, 'transaction');
	            return undefined;
	        }
	        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
	        if (this._trimEnd && finishedSpans.length > 0) {
	            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
	                if (prev.endTimestamp && current.endTimestamp) {
	                    return prev.endTimestamp > current.endTimestamp ? prev : current;
	                }
	                return prev;
	            }).endTimestamp;
	        }
	        var transaction = {
	            contexts: {
	                trace: this.getTraceContext(),
	            },
	            spans: finishedSpans,
	            start_timestamp: this.startTimestamp,
	            tags: this.tags,
	            timestamp: this.endTimestamp,
	            transaction: this.name,
	            type: 'transaction',
	            debug_meta: this.metadata,
	        };
	        var hasMeasurements = Object.keys(this._measurements).length > 0;
	        if (hasMeasurements) {
	            utils_1.logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
	            transaction.measurements = this._measurements;
	        }
	        utils_1.logger.log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
	        return this._hub.captureEvent(transaction);
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.toContext = function () {
	        var spanContext = _super.prototype.toContext.call(this);
	        return utils_1.dropUndefinedKeys(tslib_1.__assign(tslib_1.__assign({}, spanContext), { name: this.name, trimEnd: this._trimEnd }));
	    };
	    /**
	     * @inheritDoc
	     */
	    Transaction.prototype.updateWithContext = function (transactionContext) {
	        var _a;
	        _super.prototype.updateWithContext.call(this, transactionContext);
	        this.name = (_a = transactionContext.name, (_a !== null && _a !== void 0 ? _a : ''));
	        this._trimEnd = transactionContext.trimEnd;
	        return this;
	    };
	    return Transaction;
	}(span_1.Span));
	exports.Transaction = Transaction;
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var polyfill_1 = __webpack_require__(2970);
	/** An error emitted by Sentry SDKs and related utilities. */
	var SentryError = /** @class */ (function (_super) {
	    tslib_1.__extends(SentryError, _super);
	    function SentryError(message) {
	        var _newTarget = this.constructor;
	        var _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _newTarget.prototype.constructor.name;
	        polyfill_1.setPrototypeOf(_this, _newTarget.prototype);
	        return _this;
	    }
	    return SentryError;
	}(Error));
	exports.SentryError = SentryError;
	//# sourceMappingURL=error.js.map

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var global_1 = __webpack_require__(388);
	// TODO: Implement different loggers for different environments
	var global = global_1.getGlobalObject();
	/** Prefix for logging strings */
	var PREFIX = 'Sentry Logger ';
	/**
	 * Temporarily unwrap `console.log` and friends in order to perform the given callback using the original methods.
	 * Restores wrapping after the callback completes.
	 *
	 * @param callback The function to run against the original `console` messages
	 * @returns The results of the callback
	 */
	function consoleSandbox(callback) {
	    var global = global_1.getGlobalObject();
	    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
	    if (!('console' in global)) {
	        return callback();
	    }
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    var originalConsole = global.console;
	    var wrappedLevels = {};
	    // Restore all wrapped console methods
	    levels.forEach(function (level) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        if (level in global.console && originalConsole[level].__sentry_original__) {
	            wrappedLevels[level] = originalConsole[level];
	            originalConsole[level] = originalConsole[level].__sentry_original__;
	        }
	    });
	    // Perform callback manipulations
	    var result = callback();
	    // Revert restoration to wrapped state
	    Object.keys(wrappedLevels).forEach(function (level) {
	        originalConsole[level] = wrappedLevels[level];
	    });
	    return result;
	}
	exports.consoleSandbox = consoleSandbox;
	/** JSDoc */
	var Logger = /** @class */ (function () {
	    /** JSDoc */
	    function Logger() {
	        this._enabled = false;
	    }
	    /** JSDoc */
	    Logger.prototype.disable = function () {
	        this._enabled = false;
	    };
	    /** JSDoc */
	    Logger.prototype.enable = function () {
	        this._enabled = true;
	    };
	    /** JSDoc */
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        consoleSandbox(function () {
	            global.console.log(PREFIX + "[Log]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        consoleSandbox(function () {
	            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
	        });
	    };
	    /** JSDoc */
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!this._enabled) {
	            return;
	        }
	        consoleSandbox(function () {
	            global.console.error(PREFIX + "[Error]: " + args.join(' '));
	        });
	    };
	    return Logger;
	}());
	// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
	global.__SENTRY__ = global.__SENTRY__ || {};
	var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());
	exports.logger = logger;
	//# sourceMappingURL=logger.js.map

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {/**
	 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
	 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Checks whether we're in the Node.js or Browser environment
	 *
	 * @returns Answer to given question
	 */
	function isNodeEnv() {
	    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
	}
	exports.isNodeEnv = isNodeEnv;
	/**
	 * Requires a module which is protected against bundler minification.
	 *
	 * @param request The module path to resolve
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
	function dynamicRequire(mod, request) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    return mod.require(request);
	}
	exports.dynamicRequire = dynamicRequire;
	/**
	 * Helper for dynamically loading module that should work with linked dependencies.
	 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
	 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
	 * build time. `require.resolve` is also not available in any other way, so we cannot create,
	 * a fake helper like we do with `dynamicRequire`.
	 *
	 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
	 * That is to mimic the behavior of `require.resolve` exactly.
	 *
	 * @param moduleName module name to require
	 * @returns possibly required module
	 */
	function loadModule(moduleName) {
	    var mod;
	    try {
	        mod = dynamicRequire(module, moduleName);
	    }
	    catch (e) {
	        // no-empty
	    }
	    try {
	        var cwd = dynamicRequire(module, 'process').cwd;
	        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
	    }
	    catch (e) {
	        // no-empty
	    }
	    return mod;
	}
	exports.loadModule = loadModule;
	//# sourceMappingURL=node.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(583), __webpack_require__(140)(module)))

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var defaultFunctionName = '<anonymous>';
	/**
	 * Safely extract function name from itself
	 */
	function getFunctionName(fn) {
	    try {
	        if (!fn || typeof fn !== 'function') {
	            return defaultFunctionName;
	        }
	        return fn.name || defaultFunctionName;
	    }
	    catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        return defaultFunctionName;
	    }
	}
	exports.getFunctionName = getFunctionName;
	//# sourceMappingURL=stacktrace.js.map

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var is_1 = __webpack_require__(487);
	/**
	 * Truncates given string to the maximum characters count
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string (0 = unlimited)
	 * @returns string Encoded
	 */
	function truncate(str, max) {
	    if (max === void 0) { max = 0; }
	    if (typeof str !== 'string' || max === 0) {
	        return str;
	    }
	    return str.length <= max ? str : str.substr(0, max) + "...";
	}
	exports.truncate = truncate;
	/**
	 * This is basically just `trim_line` from
	 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
	 *
	 * @param str An object that contains serializable values
	 * @param max Maximum number of characters in truncated string
	 * @returns string Encoded
	 */
	function snipLine(line, colno) {
	    var newLine = line;
	    var ll = newLine.length;
	    if (ll <= 150) {
	        return newLine;
	    }
	    if (colno > ll) {
	        // eslint-disable-next-line no-param-reassign
	        colno = ll;
	    }
	    var start = Math.max(colno - 60, 0);
	    if (start < 5) {
	        start = 0;
	    }
	    var end = Math.min(start + 140, ll);
	    if (end > ll - 5) {
	        end = ll;
	    }
	    if (end === ll) {
	        start = Math.max(end - 140, 0);
	    }
	    newLine = newLine.slice(start, end);
	    if (start > 0) {
	        newLine = "'{snip} " + newLine;
	    }
	    if (end < ll) {
	        newLine += ' {snip}';
	    }
	    return newLine;
	}
	exports.snipLine = snipLine;
	/**
	 * Join values in array
	 * @param input array of values to be joined together
	 * @param delimiter string to be placed in-between values
	 * @returns Joined values
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function safeJoin(input, delimiter) {
	    if (!Array.isArray(input)) {
	        return '';
	    }
	    var output = [];
	    // eslint-disable-next-line @typescript-eslint/prefer-for-of
	    for (var i = 0; i < input.length; i++) {
	        var value = input[i];
	        try {
	            output.push(String(value));
	        }
	        catch (e) {
	            output.push('[value cannot be serialized]');
	        }
	    }
	    return output.join(delimiter);
	}
	exports.safeJoin = safeJoin;
	/**
	 * Checks if the value matches a regex or includes the string
	 * @param value The string value to be checked against
	 * @param pattern Either a regex or a string that must be contained in value
	 */
	function isMatchingPattern(value, pattern) {
	    if (!is_1.isString(value)) {
	        return false;
	    }
	    if (is_1.isRegExp(pattern)) {
	        return pattern.test(value);
	    }
	    if (typeof pattern === 'string') {
	        return value.indexOf(pattern) !== -1;
	    }
	    return false;
	}
	exports.isMatchingPattern = isMatchingPattern;
	/**
	 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
	 * `new RegExp()`.
	 *
	 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
	 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
	 * 12+).
	 *
	 * @param regexString The string to escape
	 * @returns An version of the string with all special regex characters escaped
	 */
	function escapeStringForRegex(regexString) {
	    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
	    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
	    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
	}
	exports.escapeStringForRegex = escapeStringForRegex;
	//# sourceMappingURL=string.js.map

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	// {K1: V1, K2: V2, ...} -> [[K1, V1], [K2, V2]]
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var objectToPairs = function objectToPairs(obj) {
	    return Object.keys(obj).map(function (key) {
	        return [key, obj[key]];
	    });
	};
	
	exports.objectToPairs = objectToPairs;
	// [[K1, V1], [K2, V2]] -> {K1: V1, K2: V2, ...}
	var pairsToObject = function pairsToObject(pairs) {
	    var result = {};
	    pairs.forEach(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var key = _ref2[0];
	        var val = _ref2[1];
	
	        result[key] = val;
	    });
	    return result;
	};
	
	var mapObj = function mapObj(obj, fn) {
	    return pairsToObject(objectToPairs(obj).map(fn));
	};
	
	exports.mapObj = mapObj;
	// Flattens an array one level
	// [[A], [B, C, [D]]] -> [A, B, C, [D]]
	var flatten = function flatten(list) {
	    return list.reduce(function (memo, x) {
	        return memo.concat(x);
	    }, []);
	};
	
	exports.flatten = flatten;
	var UPPERCASE_RE = /([A-Z])/g;
	var MS_RE = /^ms-/;
	
	var kebabify = function kebabify(string) {
	    return string.replace(UPPERCASE_RE, '-$1').toLowerCase();
	};
	var kebabifyStyleName = function kebabifyStyleName(string) {
	    return kebabify(string).replace(MS_RE, '-ms-');
	};
	
	exports.kebabifyStyleName = kebabifyStyleName;
	var recursiveMerge = function recursiveMerge(a, b) {
	    // TODO(jlfwong): Handle malformed input where a and b are not the same
	    // type.
	
	    if (typeof a !== 'object') {
	        return b;
	    }
	
	    var ret = _extends({}, a);
	
	    Object.keys(b).forEach(function (key) {
	        if (ret.hasOwnProperty(key)) {
	            ret[key] = recursiveMerge(a[key], b[key]);
	        } else {
	            ret[key] = b[key];
	        }
	    });
	
	    return ret;
	};
	
	exports.recursiveMerge = recursiveMerge;
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 * Taken from React's CSSProperty.js
	 */
	var isUnitlessNumber = {
	    animationIterationCount: true,
	    borderImageOutset: true,
	    borderImageSlice: true,
	    borderImageWidth: true,
	    boxFlex: true,
	    boxFlexGroup: true,
	    boxOrdinalGroup: true,
	    columnCount: true,
	    flex: true,
	    flexGrow: true,
	    flexPositive: true,
	    flexShrink: true,
	    flexNegative: true,
	    flexOrder: true,
	    gridRow: true,
	    gridColumn: true,
	    fontWeight: true,
	    lineClamp: true,
	    lineHeight: true,
	    opacity: true,
	    order: true,
	    orphans: true,
	    tabSize: true,
	    widows: true,
	    zIndex: true,
	    zoom: true,
	
	    // SVG-related properties
	    fillOpacity: true,
	    floodOpacity: true,
	    stopOpacity: true,
	    strokeDasharray: true,
	    strokeDashoffset: true,
	    strokeMiterlimit: true,
	    strokeOpacity: true,
	    strokeWidth: true
	};
	
	/**
	 * Taken from React's CSSProperty.js
	 *
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 * Taken from React's CSSProperty.js
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	// Taken from React's CSSProperty.js
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	    prefixes.forEach(function (prefix) {
	        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	    });
	});
	
	var stringifyValue = function stringifyValue(key, prop) {
	    if (typeof prop === "number") {
	        if (isUnitlessNumber[key]) {
	            return "" + prop;
	        } else {
	            return prop + "px";
	        }
	    } else {
	        return prop;
	    }
	};
	
	exports.stringifyValue = stringifyValue;
	/**
	 * JS Implementation of MurmurHash2
	 *
	 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
	 * @see http://github.com/garycourt/murmurhash-js
	 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
	 * @see http://sites.google.com/site/murmurhash/
	 *
	 * @param {string} str ASCII only
	 * @return {string} Base 36 encoded hash result
	 */
	function murmurhash2_32_gc(str) {
	    var l = str.length;
	    var h = l;
	    var i = 0;
	    var k = undefined;
	
	    while (l >= 4) {
	        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	
	        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	        k ^= k >>> 24;
	        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	
	        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	
	        l -= 4;
	        ++i;
	    }
	
	    switch (l) {
	        case 3:
	            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	        case 2:
	            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	        case 1:
	            h ^= str.charCodeAt(i) & 0xff;
	            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    }
	
	    h ^= h >>> 13;
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h ^= h >>> 15;
	
	    return (h >>> 0).toString(36);
	}
	
	// Hash a javascript object using JSON.stringify. This is very fast, about 3
	// microseconds on my computer for a sample object:
	// http://jsperf.com/test-hashfnv32a-hash/5
	//
	// Note that this uses JSON.stringify to stringify the objects so in order for
	// this to produce consistent hashes browsers need to have a consistent
	// ordering of objects. Ben Alpert says that Facebook depends on this, so we
	// can probably depend on this too.
	var hashObject = function hashObject(object) {
	    return murmurhash2_32_gc(JSON.stringify(object));
	};
	
	exports.hashObject = hashObject;
	var IMPORTANT_RE = /^([^:]+:.*?)( !important)?;$/;
	
	// Given a single style rule string like "a: b;", adds !important to generate
	// "a: b !important;".
	var importantify = function importantify(string) {
	    return string.replace(IMPORTANT_RE, function (_, base, important) {
	        return base + " !important;";
	    });
	};
	exports.importantify = importantify;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var version_1 = __webpack_require__(2983);
	var utils_1 = __webpack_require__(488);
	var anchor_tag_builder_1 = __webpack_require__(1687);
	var match_1 = __webpack_require__(390);
	var email_match_1 = __webpack_require__(1086);
	var hashtag_match_1 = __webpack_require__(1087);
	var mention_match_1 = __webpack_require__(1088);
	var phone_match_1 = __webpack_require__(1089);
	var url_match_1 = __webpack_require__(1090);
	var matcher_1 = __webpack_require__(391);
	var html_tag_1 = __webpack_require__(1085);
	var email_matcher_1 = __webpack_require__(1688);
	var url_matcher_1 = __webpack_require__(1693);
	var hashtag_matcher_1 = __webpack_require__(1689);
	var phone_matcher_1 = __webpack_require__(1691);
	var mention_matcher_1 = __webpack_require__(1690);
	var parse_html_1 = __webpack_require__(2976);
	/**
	 * @class Autolinker
	 * @extends Object
	 *
	 * Utility class used to process a given string of text, and wrap the matches in
	 * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
	 *
	 * Any of the configuration options may be provided in an Object provided
	 * to the Autolinker constructor, which will configure how the {@link #link link()}
	 * method will process the links.
	 *
	 * For example:
	 *
	 *     var autolinker = new Autolinker( {
	 *         newWindow : false,
	 *         truncate  : 30
	 *     } );
	 *
	 *     var html = autolinker.link( "Joe went to www.yahoo.com" );
	 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
	 *
	 *
	 * The {@link #static-link static link()} method may also be used to inline
	 * options into a single call, which may be more convenient for one-off uses.
	 * For example:
	 *
	 *     var html = Autolinker.link( "Joe went to www.yahoo.com", {
	 *         newWindow : false,
	 *         truncate  : 30
	 *     } );
	 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
	 *
	 *
	 * ## Custom Replacements of Links
	 *
	 * If the configuration options do not provide enough flexibility, a {@link #replaceFn}
	 * may be provided to fully customize the output of Autolinker. This function is
	 * called once for each URL/Email/Phone#/Hashtag/Mention (Twitter, Instagram, Soundcloud)
	 * match that is encountered.
	 *
	 * For example:
	 *
	 *     var input = "...";  // string with URLs, Email Addresses, Phone #s, Hashtags, and Mentions (Twitter, Instagram, Soundcloud)
	 *
	 *     var linkedText = Autolinker.link( input, {
	 *         replaceFn : function( match ) {
	 *             console.log( "href = ", match.getAnchorHref() );
	 *             console.log( "text = ", match.getAnchorText() );
	 *
	 *             switch( match.getType() ) {
	 *                 case 'url' :
	 *                     console.log( "url: ", match.getUrl() );
	 *
	 *                     if( match.getUrl().indexOf( 'mysite.com' ) === -1 ) {
	 *                         var tag = match.buildTag();  // returns an `Autolinker.HtmlTag` instance, which provides mutator methods for easy changes
	 *                         tag.setAttr( 'rel', 'nofollow' );
	 *                         tag.addClass( 'external-link' );
	 *
	 *                         return tag;
	 *
	 *                     } else {
	 *                         return true;  // let Autolinker perform its normal anchor tag replacement
	 *                     }
	 *
	 *                 case 'email' :
	 *                     var email = match.getEmail();
	 *                     console.log( "email: ", email );
	 *
	 *                     if( email === "my@own.address" ) {
	 *                         return false;  // don't auto-link this particular email address; leave as-is
	 *                     } else {
	 *                         return;  // no return value will have Autolinker perform its normal anchor tag replacement (same as returning `true`)
	 *                     }
	 *
	 *                 case 'phone' :
	 *                     var phoneNumber = match.getPhoneNumber();
	 *                     console.log( phoneNumber );
	 *
	 *                     return '<a href="http://newplace.to.link.phone.numbers.to/">' + phoneNumber + '</a>';
	 *
	 *                 case 'hashtag' :
	 *                     var hashtag = match.getHashtag();
	 *                     console.log( hashtag );
	 *
	 *                     return '<a href="http://newplace.to.link.hashtag.handles.to/">' + hashtag + '</a>';
	 *
	 *                 case 'mention' :
	 *                     var mention = match.getMention();
	 *                     console.log( mention );
	 *
	 *                     return '<a href="http://newplace.to.link.mention.to/">' + mention + '</a>';
	 *             }
	 *         }
	 *     } );
	 *
	 *
	 * The function may return the following values:
	 *
	 * - `true` (Boolean): Allow Autolinker to replace the match as it normally
	 *   would.
	 * - `false` (Boolean): Do not replace the current match at all - leave as-is.
	 * - Any String: If a string is returned from the function, the string will be
	 *   used directly as the replacement HTML for the match.
	 * - An {@link Autolinker.HtmlTag} instance, which can be used to build/modify
	 *   an HTML tag before writing out its HTML text.
	 */
	var Autolinker = /** @class */ (function () {
	    /**
	     * @method constructor
	     * @param {Object} [cfg] The configuration options for the Autolinker instance,
	     *   specified in an Object (map).
	     */
	    function Autolinker(cfg) {
	        if (cfg === void 0) { cfg = {}; }
	        /**
	         * The Autolinker version number exposed on the instance itself.
	         *
	         * Ex: 0.25.1
	         */
	        this.version = Autolinker.version;
	        /**
	         * @cfg {Boolean/Object} [urls]
	         *
	         * `true` if URLs should be automatically linked, `false` if they should not
	         * be. Defaults to `true`.
	         *
	         * Examples:
	         *
	         *     urls: true
	         *
	         *     // or
	         *
	         *     urls: {
	         *         schemeMatches : true,
	         *         wwwMatches    : true,
	         *         tldMatches    : true
	         *     }
	         *
	         * As shown above, this option also accepts an Object form with 3 properties
	         * to allow for more customization of what exactly gets linked. All default
	         * to `true`:
	         *
	         * @cfg {Boolean} [urls.schemeMatches] `true` to match URLs found prefixed
	         *   with a scheme, i.e. `http://google.com`, or `other+scheme://google.com`,
	         *   `false` to prevent these types of matches.
	         * @cfg {Boolean} [urls.wwwMatches] `true` to match urls found prefixed with
	         *   `'www.'`, i.e. `www.google.com`. `false` to prevent these types of
	         *   matches. Note that if the URL had a prefixed scheme, and
	         *   `schemeMatches` is true, it will still be linked.
	         * @cfg {Boolean} [urls.tldMatches] `true` to match URLs with known top
	         *   level domains (.com, .net, etc.) that are not prefixed with a scheme or
	         *   `'www.'`. This option attempts to match anything that looks like a URL
	         *   in the given text. Ex: `google.com`, `asdf.org/?page=1`, etc. `false`
	         *   to prevent these types of matches.
	         */
	        this.urls = {}; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} [email=true]
	         *
	         * `true` if email addresses should be automatically linked, `false` if they
	         * should not be.
	         */
	        this.email = true; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} [phone=true]
	         *
	         * `true` if Phone numbers ("(555)555-5555") should be automatically linked,
	         * `false` if they should not be.
	         */
	        this.phone = true; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean/String} [hashtag=false]
	         *
	         * A string for the service name to have hashtags (ex: "#myHashtag")
	         * auto-linked to. The currently-supported values are:
	         *
	         * - 'twitter'
	         * - 'facebook'
	         * - 'instagram'
	         *
	         * Pass `false` to skip auto-linking of hashtags.
	         */
	        this.hashtag = false; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {String/Boolean} [mention=false]
	         *
	         * A string for the service name to have mentions (ex: "@myuser")
	         * auto-linked to. The currently supported values are:
	         *
	         * - 'twitter'
	         * - 'instagram'
	         * - 'soundcloud'
	         *
	         * Defaults to `false` to skip auto-linking of mentions.
	         */
	        this.mention = false; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} [newWindow=true]
	         *
	         * `true` if the links should open in a new window, `false` otherwise.
	         */
	        this.newWindow = true; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean/Object} [stripPrefix=true]
	         *
	         * `true` if 'http://' (or 'https://') and/or the 'www.' should be stripped
	         * from the beginning of URL links' text, `false` otherwise. Defaults to
	         * `true`.
	         *
	         * Examples:
	         *
	         *     stripPrefix: true
	         *
	         *     // or
	         *
	         *     stripPrefix: {
	         *         scheme : true,
	         *         www    : true
	         *     }
	         *
	         * As shown above, this option also accepts an Object form with 2 properties
	         * to allow for more customization of what exactly is prevented from being
	         * displayed. Both default to `true`:
	         *
	         * @cfg {Boolean} [stripPrefix.scheme] `true` to prevent the scheme part of
	         *   a URL match from being displayed to the user. Example:
	         *   `'http://google.com'` will be displayed as `'google.com'`. `false` to
	         *   not strip the scheme. NOTE: Only an `'http://'` or `'https://'` scheme
	         *   will be removed, so as not to remove a potentially dangerous scheme
	         *   (such as `'file://'` or `'javascript:'`)
	         * @cfg {Boolean} [stripPrefix.www] www (Boolean): `true` to prevent the
	         *   `'www.'` part of a URL match from being displayed to the user. Ex:
	         *   `'www.google.com'` will be displayed as `'google.com'`. `false` to not
	         *   strip the `'www'`.
	         */
	        this.stripPrefix = {
	            scheme: true,
	            www: true,
	        }; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} [stripTrailingSlash=true]
	         *
	         * `true` to remove the trailing slash from URL matches, `false` to keep
	         *  the trailing slash.
	         *
	         *  Example when `true`: `http://google.com/` will be displayed as
	         *  `http://google.com`.
	         */
	        this.stripTrailingSlash = true; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} [decodePercentEncoding=true]
	         *
	         * `true` to decode percent-encoded characters in URL matches, `false` to keep
	         *  the percent-encoded characters.
	         *
	         *  Example when `true`: `https://en.wikipedia.org/wiki/San_Jos%C3%A9` will
	         *  be displayed as `https://en.wikipedia.org/wiki/San_José`.
	         */
	        this.decodePercentEncoding = true; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Number/Object} [truncate=0]
	         *
	         * ## Number Form
	         *
	         * A number for how many characters matched text should be truncated to
	         * inside the text of a link. If the matched text is over this number of
	         * characters, it will be truncated to this length by adding a two period
	         * ellipsis ('..') to the end of the string.
	         *
	         * For example: A url like 'http://www.yahoo.com/some/long/path/to/a/file'
	         * truncated to 25 characters might look something like this:
	         * 'yahoo.com/some/long/pat..'
	         *
	         * Example Usage:
	         *
	         *     truncate: 25
	         *
	         *
	         *  Defaults to `0` for "no truncation."
	         *
	         *
	         * ## Object Form
	         *
	         * An Object may also be provided with two properties: `length` (Number) and
	         * `location` (String). `location` may be one of the following: 'end'
	         * (default), 'middle', or 'smart'.
	         *
	         * Example Usage:
	         *
	         *     truncate: { length: 25, location: 'middle' }
	         *
	         * @cfg {Number} [truncate.length=0] How many characters to allow before
	         *   truncation will occur. Defaults to `0` for "no truncation."
	         * @cfg {"end"/"middle"/"smart"} [truncate.location="end"]
	         *
	         * - 'end' (default): will truncate up to the number of characters, and then
	         *   add an ellipsis at the end. Ex: 'yahoo.com/some/long/pat..'
	         * - 'middle': will truncate and add the ellipsis in the middle. Ex:
	         *   'yahoo.com/s..th/to/a/file'
	         * - 'smart': for URLs where the algorithm attempts to strip out unnecessary
	         *   parts first (such as the 'www.', then URL scheme, hash, etc.),
	         *   attempting to make the URL human-readable before looking for a good
	         *   point to insert the ellipsis if it is still too long. Ex:
	         *   'yahoo.com/some..to/a/file'. For more details, see
	         *   {@link Autolinker.truncate.TruncateSmart}.
	         */
	        this.truncate = {
	            length: 0,
	            location: 'end',
	        }; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {String} className
	         *
	         * A CSS class name to add to the generated links. This class will be added
	         * to all links, as well as this class plus match suffixes for styling
	         * url/email/phone/hashtag/mention links differently.
	         *
	         * For example, if this config is provided as "myLink", then:
	         *
	         * - URL links will have the CSS classes: "myLink myLink-url"
	         * - Email links will have the CSS classes: "myLink myLink-email", and
	         * - Phone links will have the CSS classes: "myLink myLink-phone"
	         * - Hashtag links will have the CSS classes: "myLink myLink-hashtag"
	         * - Mention links will have the CSS classes: "myLink myLink-mention myLink-[type]"
	         *   where [type] is either "instagram", "twitter" or "soundcloud"
	         */
	        this.className = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Function} replaceFn
	         *
	         * A function to individually process each match found in the input string.
	         *
	         * See the class's description for usage.
	         *
	         * The `replaceFn` can be called with a different context object (`this`
	         * reference) using the {@link #context} cfg.
	         *
	         * This function is called with the following parameter:
	         *
	         * @cfg {Autolinker.match.Match} replaceFn.match The Match instance which
	         *   can be used to retrieve information about the match that the `replaceFn`
	         *   is currently processing. See {@link Autolinker.match.Match} subclasses
	         *   for details.
	         */
	        this.replaceFn = null; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Object} context
	         *
	         * The context object (`this` reference) to call the `replaceFn` with.
	         *
	         * Defaults to this Autolinker instance.
	         */
	        this.context = undefined; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} [sanitizeHtml=false]
	         *
	         * `true` to HTML-encode the start and end brackets of existing HTML tags found
	         * in the input string. This will escape `<` and `>` characters to `&lt;` and
	         * `&gt;`, respectively.
	         *
	         * Setting this to `true` will prevent XSS (Cross-site Scripting) attacks,
	         * but will remove the significance of existing HTML tags in the input string. If
	         * you would like to maintain the significance of existing HTML tags while also
	         * making the output HTML string safe, leave this option as `false` and use a
	         * tool like https://github.com/cure53/DOMPurify (or others) on the input string
	         * before running Autolinker.
	         */
	        this.sanitizeHtml = false; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @private
	         * @property {Autolinker.matcher.Matcher[]} matchers
	         *
	         * The {@link Autolinker.matcher.Matcher} instances for this Autolinker
	         * instance.
	         *
	         * This is lazily created in {@link #getMatchers}.
	         */
	        this.matchers = null;
	        /**
	         * @private
	         * @property {Autolinker.AnchorTagBuilder} tagBuilder
	         *
	         * The AnchorTagBuilder instance used to build match replacement anchor tags.
	         * Note: this is lazily instantiated in the {@link #getTagBuilder} method.
	         */
	        this.tagBuilder = null;
	        // Note: when `this.something` is used in the rhs of these assignments,
	        //       it refers to the default values set above the constructor
	        this.urls = this.normalizeUrlsCfg(cfg.urls);
	        this.email = typeof cfg.email === 'boolean' ? cfg.email : this.email;
	        this.phone = typeof cfg.phone === 'boolean' ? cfg.phone : this.phone;
	        this.hashtag = cfg.hashtag || this.hashtag;
	        this.mention = cfg.mention || this.mention;
	        this.newWindow = typeof cfg.newWindow === 'boolean' ? cfg.newWindow : this.newWindow;
	        this.stripPrefix = this.normalizeStripPrefixCfg(cfg.stripPrefix);
	        this.stripTrailingSlash =
	            typeof cfg.stripTrailingSlash === 'boolean'
	                ? cfg.stripTrailingSlash
	                : this.stripTrailingSlash;
	        this.decodePercentEncoding =
	            typeof cfg.decodePercentEncoding === 'boolean'
	                ? cfg.decodePercentEncoding
	                : this.decodePercentEncoding;
	        this.sanitizeHtml = cfg.sanitizeHtml || false;
	        // Validate the value of the `mention` cfg
	        var mention = this.mention;
	        if (mention !== false &&
	            ['twitter', 'instagram', 'soundcloud', 'tiktok'].indexOf(mention) === -1) {
	            throw new Error("invalid `mention` cfg '".concat(mention, "' - see docs"));
	        }
	        // Validate the value of the `hashtag` cfg
	        var hashtag = this.hashtag;
	        if (hashtag !== false && hashtag_matcher_1.hashtagServices.indexOf(hashtag) === -1) {
	            throw new Error("invalid `hashtag` cfg '".concat(hashtag, "' - see docs"));
	        }
	        this.truncate = this.normalizeTruncateCfg(cfg.truncate);
	        this.className = cfg.className || this.className;
	        this.replaceFn = cfg.replaceFn || this.replaceFn;
	        this.context = cfg.context || this;
	    }
	    /**
	     * Automatically links URLs, Email addresses, Phone Numbers, Twitter handles,
	     * Hashtags, and Mentions found in the given chunk of HTML. Does not link URLs
	     * found within HTML tags.
	     *
	     * For instance, if given the text: `You should go to http://www.yahoo.com`,
	     * then the result will be `You should go to &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
	     *
	     * Example:
	     *
	     *     var linkedText = Autolinker.link( "Go to google.com", { newWindow: false } );
	     *     // Produces: "Go to <a href="http://google.com">google.com</a>"
	     *
	     * @static
	     * @param {String} textOrHtml The HTML or text to find matches within (depending
	     *   on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #mention},
	     *   {@link #hashtag}, and {@link #mention} options are enabled).
	     * @param {Object} [options] Any of the configuration options for the Autolinker
	     *   class, specified in an Object (map). See the class description for an
	     *   example call.
	     * @return {String} The HTML text, with matches automatically linked.
	     */
	    Autolinker.link = function (textOrHtml, options) {
	        var autolinker = new Autolinker(options);
	        return autolinker.link(textOrHtml);
	    };
	    /**
	     * Parses the input `textOrHtml` looking for URLs, email addresses, phone
	     * numbers, username handles, and hashtags (depending on the configuration
	     * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	     * objects describing those matches (without making any replacements).
	     *
	     * Note that if parsing multiple pieces of text, it is slightly more efficient
	     * to create an Autolinker instance, and use the instance-level {@link #parse}
	     * method.
	     *
	     * Example:
	     *
	     *     var matches = Autolinker.parse( "Hello google.com, I am asdf@asdf.com", {
	     *         urls: true,
	     *         email: true
	     *     } );
	     *
	     *     console.log( matches.length );           // 2
	     *     console.log( matches[ 0 ].getType() );   // 'url'
	     *     console.log( matches[ 0 ].getUrl() );    // 'google.com'
	     *     console.log( matches[ 1 ].getType() );   // 'email'
	     *     console.log( matches[ 1 ].getEmail() );  // 'asdf@asdf.com'
	     *
	     * @static
	     * @param {String} textOrHtml The HTML or text to find matches within
	     *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
	     *   {@link #hashtag}, and {@link #mention} options are enabled).
	     * @param {Object} [options] Any of the configuration options for the Autolinker
	     *   class, specified in an Object (map). See the class description for an
	     *   example call.
	     * @return {Autolinker.match.Match[]} The array of Matches found in the
	     *   given input `textOrHtml`.
	     */
	    Autolinker.parse = function (textOrHtml, options) {
	        var autolinker = new Autolinker(options);
	        return autolinker.parse(textOrHtml);
	    };
	    /**
	     * Normalizes the {@link #urls} config into an Object with 3 properties:
	     * `schemeMatches`, `wwwMatches`, and `tldMatches`, all Booleans.
	     *
	     * See {@link #urls} config for details.
	     *
	     * @private
	     * @param {Boolean/Object} urls
	     * @return {Object}
	     */
	    Autolinker.prototype.normalizeUrlsCfg = function (urls) {
	        if (urls == null)
	            urls = true; // default to `true`
	        if (typeof urls === 'boolean') {
	            return { schemeMatches: urls, wwwMatches: urls, tldMatches: urls };
	        }
	        else {
	            // object form
	            return {
	                schemeMatches: typeof urls.schemeMatches === 'boolean' ? urls.schemeMatches : true,
	                wwwMatches: typeof urls.wwwMatches === 'boolean' ? urls.wwwMatches : true,
	                tldMatches: typeof urls.tldMatches === 'boolean' ? urls.tldMatches : true,
	            };
	        }
	    };
	    /**
	     * Normalizes the {@link #stripPrefix} config into an Object with 2
	     * properties: `scheme`, and `www` - both Booleans.
	     *
	     * See {@link #stripPrefix} config for details.
	     *
	     * @private
	     * @param {Boolean/Object} stripPrefix
	     * @return {Object}
	     */
	    Autolinker.prototype.normalizeStripPrefixCfg = function (stripPrefix) {
	        if (stripPrefix == null)
	            stripPrefix = true; // default to `true`
	        if (typeof stripPrefix === 'boolean') {
	            return { scheme: stripPrefix, www: stripPrefix };
	        }
	        else {
	            // object form
	            return {
	                scheme: typeof stripPrefix.scheme === 'boolean' ? stripPrefix.scheme : true,
	                www: typeof stripPrefix.www === 'boolean' ? stripPrefix.www : true,
	            };
	        }
	    };
	    /**
	     * Normalizes the {@link #truncate} config into an Object with 2 properties:
	     * `length` (Number), and `location` (String).
	     *
	     * See {@link #truncate} config for details.
	     *
	     * @private
	     * @param {Number/Object} truncate
	     * @return {Object}
	     */
	    Autolinker.prototype.normalizeTruncateCfg = function (truncate) {
	        if (typeof truncate === 'number') {
	            return { length: truncate, location: 'end' };
	        }
	        else {
	            // object, or undefined/null
	            return (0, utils_1.defaults)(truncate || {}, {
	                length: Number.POSITIVE_INFINITY,
	                location: 'end',
	            });
	        }
	    };
	    /**
	     * Parses the input `textOrHtml` looking for URLs, email addresses, phone
	     * numbers, username handles, and hashtags (depending on the configuration
	     * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	     * objects describing those matches (without making any replacements).
	     *
	     * This method is used by the {@link #link} method, but can also be used to
	     * simply do parsing of the input in order to discover what kinds of links
	     * there are and how many.
	     *
	     * Example usage:
	     *
	     *     var autolinker = new Autolinker( {
	     *         urls: true,
	     *         email: true
	     *     } );
	     *
	     *     var matches = autolinker.parse( "Hello google.com, I am asdf@asdf.com" );
	     *
	     *     console.log( matches.length );           // 2
	     *     console.log( matches[ 0 ].getType() );   // 'url'
	     *     console.log( matches[ 0 ].getUrl() );    // 'google.com'
	     *     console.log( matches[ 1 ].getType() );   // 'email'
	     *     console.log( matches[ 1 ].getEmail() );  // 'asdf@asdf.com'
	     *
	     * @param {String} textOrHtml The HTML or text to find matches within
	     *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
	     *   {@link #hashtag}, and {@link #mention} options are enabled).
	     * @return {Autolinker.match.Match[]} The array of Matches found in the
	     *   given input `textOrHtml`.
	     */
	    Autolinker.prototype.parse = function (textOrHtml) {
	        var _this = this;
	        var skipTagNames = ['a', 'style', 'script'], skipTagsStackCount = 0, // used to only Autolink text outside of anchor/script/style tags. We don't want to autolink something that is already linked inside of an <a> tag, for instance
	        matches = [];
	        // Find all matches within the `textOrHtml` (but not matches that are
	        // already nested within <a>, <style> and <script> tags)
	        (0, parse_html_1.parseHtml)(textOrHtml, {
	            onOpenTag: function (tagName) {
	                if (skipTagNames.indexOf(tagName) >= 0) {
	                    skipTagsStackCount++;
	                }
	            },
	            onText: function (text, offset) {
	                // Only process text nodes that are not within an <a>, <style> or <script> tag
	                if (skipTagsStackCount === 0) {
	                    // "Walk around" common HTML entities. An '&nbsp;' (for example)
	                    // could be at the end of a URL, but we don't want to
	                    // include the trailing '&' in the URL. See issue #76
	                    // TODO: Handle HTML entities separately in parseHtml() and
	                    // don't emit them as "text" except for &amp; entities
	                    var htmlCharacterEntitiesRegex = /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi;
	                    var textSplit = (0, utils_1.splitAndCapture)(text, htmlCharacterEntitiesRegex);
	                    var currentOffset_1 = offset;
	                    textSplit.forEach(function (splitText, i) {
	                        // even number matches are text, odd numbers are html entities
	                        if (i % 2 === 0) {
	                            var textNodeMatches = _this.parseText(splitText, currentOffset_1);
	                            matches.push.apply(matches, textNodeMatches);
	                        }
	                        currentOffset_1 += splitText.length;
	                    });
	                }
	            },
	            onCloseTag: function (tagName) {
	                if (skipTagNames.indexOf(tagName) >= 0) {
	                    skipTagsStackCount = Math.max(skipTagsStackCount - 1, 0); // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
	                }
	            },
	            onComment: function (offset) { },
	            onDoctype: function (offset) { }, // no need to process doctype nodes
	        });
	        // After we have found all matches, remove subsequent matches that
	        // overlap with a previous match. This can happen for instance with URLs,
	        // where the url 'google.com/#link' would match '#link' as a hashtag.
	        matches = this.compactMatches(matches);
	        // And finally, remove matches for match types that have been turned
	        // off. We needed to have all match types turned on initially so that
	        // things like hashtags could be filtered out if they were really just
	        // part of a URL match (for instance, as a named anchor).
	        matches = this.removeUnwantedMatches(matches);
	        return matches;
	    };
	    /**
	     * After we have found all matches, we need to remove matches that overlap
	     * with a previous match. This can happen for instance with URLs, where the
	     * url 'google.com/#link' would match '#link' as a hashtag. Because the
	     * '#link' part is contained in a larger match that comes before the HashTag
	     * match, we'll remove the HashTag match.
	     *
	     * @private
	     * @param {Autolinker.match.Match[]} matches
	     * @return {Autolinker.match.Match[]}
	     */
	    Autolinker.prototype.compactMatches = function (matches) {
	        // First, the matches need to be sorted in order of offset
	        matches.sort(function (a, b) {
	            return a.getOffset() - b.getOffset();
	        });
	        var i = 0;
	        while (i < matches.length - 1) {
	            var match = matches[i], offset = match.getOffset(), matchedTextLength = match.getMatchedText().length, endIdx = offset + matchedTextLength;
	            if (i + 1 < matches.length) {
	                // Remove subsequent matches that equal offset with current match
	                if (matches[i + 1].getOffset() === offset) {
	                    var removeIdx = matches[i + 1].getMatchedText().length > matchedTextLength ? i : i + 1;
	                    matches.splice(removeIdx, 1);
	                    continue;
	                }
	                // Remove subsequent matches that overlap with the current match
	                if (matches[i + 1].getOffset() < endIdx) {
	                    matches.splice(i + 1, 1);
	                    continue;
	                }
	            }
	            i++;
	        }
	        return matches;
	    };
	    /**
	     * Removes matches for matchers that were turned off in the options. For
	     * example, if {@link #hashtag hashtags} were not to be matched, we'll
	     * remove them from the `matches` array here.
	     *
	     * Note: we *must* use all Matchers on the input string, and then filter
	     * them out later. For example, if the options were `{ url: false, hashtag: true }`,
	     * we wouldn't want to match the text '#link' as a HashTag inside of the text
	     * 'google.com/#link'. The way the algorithm works is that we match the full
	     * URL first (which prevents the accidental HashTag match), and then we'll
	     * simply throw away the URL match.
	     *
	     * @private
	     * @param {Autolinker.match.Match[]} matches The array of matches to remove
	     *   the unwanted matches from. Note: this array is mutated for the
	     *   removals.
	     * @return {Autolinker.match.Match[]} The mutated input `matches` array.
	     */
	    Autolinker.prototype.removeUnwantedMatches = function (matches) {
	        if (!this.hashtag)
	            (0, utils_1.remove)(matches, function (match) {
	                return match.getType() === 'hashtag';
	            });
	        if (!this.email)
	            (0, utils_1.remove)(matches, function (match) {
	                return match.getType() === 'email';
	            });
	        if (!this.phone)
	            (0, utils_1.remove)(matches, function (match) {
	                return match.getType() === 'phone';
	            });
	        if (!this.mention)
	            (0, utils_1.remove)(matches, function (match) {
	                return match.getType() === 'mention';
	            });
	        if (!this.urls.schemeMatches) {
	            (0, utils_1.remove)(matches, function (m) {
	                return m.getType() === 'url' && m.getUrlMatchType() === 'scheme';
	            });
	        }
	        if (!this.urls.wwwMatches) {
	            (0, utils_1.remove)(matches, function (m) { return m.getType() === 'url' && m.getUrlMatchType() === 'www'; });
	        }
	        if (!this.urls.tldMatches) {
	            (0, utils_1.remove)(matches, function (m) { return m.getType() === 'url' && m.getUrlMatchType() === 'tld'; });
	        }
	        return matches;
	    };
	    /**
	     * Parses the input `text` looking for URLs, email addresses, phone
	     * numbers, username handles, and hashtags (depending on the configuration
	     * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	     * objects describing those matches.
	     *
	     * This method processes a **non-HTML string**, and is used to parse and
	     * match within the text nodes of an HTML string. This method is used
	     * internally by {@link #parse}.
	     *
	     * @private
	     * @param {String} text The text to find matches within (depending on if the
	     *   {@link #urls}, {@link #email}, {@link #phone},
	     *   {@link #hashtag}, and {@link #mention} options are enabled). This must be a non-HTML string.
	     * @param {Number} [offset=0] The offset of the text node within the
	     *   original string. This is used when parsing with the {@link #parse}
	     *   method to generate correct offsets within the {@link Autolinker.match.Match}
	     *   instances, but may be omitted if calling this method publicly.
	     * @return {Autolinker.match.Match[]} The array of Matches found in the
	     *   given input `text`.
	     */
	    Autolinker.prototype.parseText = function (text, offset) {
	        if (offset === void 0) { offset = 0; }
	        offset = offset || 0;
	        var matchers = this.getMatchers(), matches = [];
	        for (var i = 0, numMatchers = matchers.length; i < numMatchers; i++) {
	            var textMatches = matchers[i].parseMatches(text);
	            // Correct the offset of each of the matches. They are originally
	            // the offset of the match within the provided text node, but we
	            // need to correct them to be relative to the original HTML input
	            // string (i.e. the one provided to #parse).
	            for (var j = 0, numTextMatches = textMatches.length; j < numTextMatches; j++) {
	                textMatches[j].setOffset(offset + textMatches[j].getOffset());
	            }
	            matches.push.apply(matches, textMatches);
	        }
	        return matches;
	    };
	    /**
	     * Automatically links URLs, Email addresses, Phone numbers, Hashtags,
	     * and Mentions (Twitter, Instagram, Soundcloud) found in the given chunk of HTML. Does not link
	     * URLs found within HTML tags.
	     *
	     * For instance, if given the text: `You should go to http://www.yahoo.com`,
	     * then the result will be `You should go to
	     * &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
	     *
	     * This method finds the text around any HTML elements in the input
	     * `textOrHtml`, which will be the text that is processed. Any original HTML
	     * elements will be left as-is, as well as the text that is already wrapped
	     * in anchor (&lt;a&gt;) tags.
	     *
	     * @param {String} textOrHtml The HTML or text to autolink matches within
	     *   (depending on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #hashtag}, and {@link #mention} options are enabled).
	     * @return {String} The HTML, with matches automatically linked.
	     */
	    Autolinker.prototype.link = function (textOrHtml) {
	        if (!textOrHtml) {
	            return '';
	        } // handle `null` and `undefined` (for JavaScript users that don't have TypeScript support)
	        /* We would want to sanitize the start and end characters of a tag
	         * before processing the string in order to avoid an XSS scenario.
	         * This behaviour can be changed by toggling the sanitizeHtml option.
	         */
	        if (this.sanitizeHtml) {
	            textOrHtml = textOrHtml.replace(/</g, '&lt;').replace(/>/g, '&gt;');
	        }
	        var matches = this.parse(textOrHtml), newHtml = [], lastIndex = 0;
	        for (var i = 0, len = matches.length; i < len; i++) {
	            var match = matches[i];
	            newHtml.push(textOrHtml.substring(lastIndex, match.getOffset()));
	            newHtml.push(this.createMatchReturnVal(match));
	            lastIndex = match.getOffset() + match.getMatchedText().length;
	        }
	        newHtml.push(textOrHtml.substring(lastIndex)); // handle the text after the last match
	        return newHtml.join('');
	    };
	    /**
	     * Creates the return string value for a given match in the input string.
	     *
	     * This method handles the {@link #replaceFn}, if one was provided.
	     *
	     * @private
	     * @param {Autolinker.match.Match} match The Match object that represents
	     *   the match.
	     * @return {String} The string that the `match` should be replaced with.
	     *   This is usually the anchor tag string, but may be the `matchStr` itself
	     *   if the match is not to be replaced.
	     */
	    Autolinker.prototype.createMatchReturnVal = function (match) {
	        // Handle a custom `replaceFn` being provided
	        var replaceFnResult;
	        if (this.replaceFn) {
	            replaceFnResult = this.replaceFn.call(this.context, match); // Autolinker instance is the context
	        }
	        if (typeof replaceFnResult === 'string') {
	            return replaceFnResult; // `replaceFn` returned a string, use that
	        }
	        else if (replaceFnResult === false) {
	            return match.getMatchedText(); // no replacement for the match
	        }
	        else if (replaceFnResult instanceof html_tag_1.HtmlTag) {
	            return replaceFnResult.toAnchorString();
	        }
	        else {
	            // replaceFnResult === true, or no/unknown return value from function
	            // Perform Autolinker's default anchor tag generation
	            var anchorTag = match.buildTag(); // returns an Autolinker.HtmlTag instance
	            return anchorTag.toAnchorString();
	        }
	    };
	    /**
	     * Lazily instantiates and returns the {@link Autolinker.matcher.Matcher}
	     * instances for this Autolinker instance.
	     *
	     * @private
	     * @return {Autolinker.matcher.Matcher[]}
	     */
	    Autolinker.prototype.getMatchers = function () {
	        if (!this.matchers) {
	            var tagBuilder = this.getTagBuilder();
	            var matchers = [
	                new hashtag_matcher_1.HashtagMatcher({
	                    tagBuilder: tagBuilder,
	                    serviceName: this.hashtag,
	                }),
	                new email_matcher_1.EmailMatcher({ tagBuilder: tagBuilder }),
	                new phone_matcher_1.PhoneMatcher({ tagBuilder: tagBuilder }),
	                new mention_matcher_1.MentionMatcher({
	                    tagBuilder: tagBuilder,
	                    serviceName: this.mention,
	                }),
	                new url_matcher_1.UrlMatcher({
	                    tagBuilder: tagBuilder,
	                    stripPrefix: this.stripPrefix,
	                    stripTrailingSlash: this.stripTrailingSlash,
	                    decodePercentEncoding: this.decodePercentEncoding,
	                }),
	            ];
	            return (this.matchers = matchers);
	        }
	        else {
	            return this.matchers;
	        }
	    };
	    /**
	     * Returns the {@link #tagBuilder} instance for this Autolinker instance,
	     * lazily instantiating it if it does not yet exist.
	     *
	     * @private
	     * @return {Autolinker.AnchorTagBuilder}
	     */
	    Autolinker.prototype.getTagBuilder = function () {
	        var tagBuilder = this.tagBuilder;
	        if (!tagBuilder) {
	            tagBuilder = this.tagBuilder = new anchor_tag_builder_1.AnchorTagBuilder({
	                newWindow: this.newWindow,
	                truncate: this.truncate,
	                className: this.className,
	            });
	        }
	        return tagBuilder;
	    };
	    // NOTE: must be 'export default' here for UMD module
	    /**
	     * @static
	     * @property {String} version
	     *
	     * The Autolinker version number in the form major.minor.patch
	     *
	     * Ex: 3.15.0
	     */
	    Autolinker.version = version_1.version;
	    /**
	     * For backwards compatibility with Autolinker 1.x, the AnchorTagBuilder
	     * class is provided as a static on the Autolinker class.
	     */
	    Autolinker.AnchorTagBuilder = anchor_tag_builder_1.AnchorTagBuilder;
	    /**
	     * For backwards compatibility with Autolinker 1.x, the HtmlTag class is
	     * provided as a static on the Autolinker class.
	     */
	    Autolinker.HtmlTag = html_tag_1.HtmlTag;
	    /**
	     * For backwards compatibility with Autolinker 1.x, the Matcher classes are
	     * provided as statics on the Autolinker class.
	     */
	    Autolinker.matcher = {
	        Email: email_matcher_1.EmailMatcher,
	        Hashtag: hashtag_matcher_1.HashtagMatcher,
	        Matcher: matcher_1.Matcher,
	        Mention: mention_matcher_1.MentionMatcher,
	        Phone: phone_matcher_1.PhoneMatcher,
	        Url: url_matcher_1.UrlMatcher,
	    };
	    /**
	     * For backwards compatibility with Autolinker 1.x, the Match classes are
	     * provided as statics on the Autolinker class.
	     */
	    Autolinker.match = {
	        Email: email_match_1.EmailMatch,
	        Hashtag: hashtag_match_1.HashtagMatch,
	        Match: match_1.Match,
	        Mention: mention_match_1.MentionMatch,
	        Phone: phone_match_1.PhoneMatch,
	        Url: url_match_1.UrlMatch,
	    };
	    return Autolinker;
	}());
	exports.default = Autolinker;
	//# sourceMappingURL=autolinker.js.map

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HtmlTag = void 0;
	var utils_1 = __webpack_require__(488);
	/**
	 * @class Autolinker.HtmlTag
	 * @extends Object
	 *
	 * Represents an HTML tag, which can be used to easily build/modify HTML tags programmatically.
	 *
	 * Autolinker uses this abstraction to create HTML tags, and then write them out as strings. You may also use
	 * this class in your code, especially within a {@link Autolinker#replaceFn replaceFn}.
	 *
	 * ## Examples
	 *
	 * Example instantiation:
	 *
	 *     var tag = new Autolinker.HtmlTag( {
	 *         tagName : 'a',
	 *         attrs   : { 'href': 'http://google.com', 'class': 'external-link' },
	 *         innerHtml : 'Google'
	 *     } );
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
	 *
	 *     // Individual accessor methods
	 *     tag.getTagName();                 // 'a'
	 *     tag.getAttr( 'href' );            // 'http://google.com'
	 *     tag.hasClass( 'external-link' );  // true
	 *
	 *
	 * Using mutator methods (which may be used in combination with instantiation config properties):
	 *
	 *     var tag = new Autolinker.HtmlTag();
	 *     tag.setTagName( 'a' );
	 *     tag.setAttr( 'href', 'http://google.com' );
	 *     tag.addClass( 'external-link' );
	 *     tag.setInnerHtml( 'Google' );
	 *
	 *     tag.getTagName();                 // 'a'
	 *     tag.getAttr( 'href' );            // 'http://google.com'
	 *     tag.hasClass( 'external-link' );  // true
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
	 *
	 *
	 * ## Example use within a {@link Autolinker#replaceFn replaceFn}
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( match ) {
	 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance, configured with the Match's href and anchor text
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 *
	 *
	 * ## Example use with a new tag for the replacement
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( match ) {
	 *             var tag = new Autolinker.HtmlTag( {
	 *                 tagName : 'button',
	 *                 attrs   : { 'title': 'Load URL: ' + match.getAnchorHref() },
	 *                 innerHtml : 'Load URL: ' + match.getAnchorText()
	 *             } );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <button title="Load URL: http://google.com">Load URL: google.com</button>
	 */
	var HtmlTag = /** @class */ (function () {
	    /**
	     * @method constructor
	     * @param {Object} [cfg] The configuration properties for this class, in an Object (map)
	     */
	    function HtmlTag(cfg) {
	        if (cfg === void 0) { cfg = {}; }
	        /**
	         * @cfg {String} tagName
	         *
	         * The tag name. Ex: 'a', 'button', etc.
	         *
	         * Not required at instantiation time, but should be set using {@link #setTagName} before {@link #toAnchorString}
	         * is executed.
	         */
	        this.tagName = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Object.<String, String>} attrs
	         *
	         * An key/value Object (map) of attributes to create the tag with. The keys are the attribute names, and the
	         * values are the attribute values.
	         */
	        this.attrs = {}; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {String} innerHTML
	         *
	         * The inner HTML for the tag.
	         */
	        this.innerHTML = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @protected
	         * @property {RegExp} whitespaceRegex
	         *
	         * Regular expression used to match whitespace in a string of CSS classes.
	         */
	        this.whitespaceRegex = /\s+/; // default value just to get the above doc comment in the ES5 output and documentation generator
	        this.tagName = cfg.tagName || '';
	        this.attrs = cfg.attrs || {};
	        this.innerHTML = cfg.innerHtml || cfg.innerHTML || ''; // accept either the camelCased form or the fully capitalized acronym as in the DOM
	    }
	    /**
	     * Sets the tag name that will be used to generate the tag with.
	     *
	     * @param {String} tagName
	     * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	     */
	    HtmlTag.prototype.setTagName = function (tagName) {
	        this.tagName = tagName;
	        return this;
	    };
	    /**
	     * Retrieves the tag name.
	     *
	     * @return {String}
	     */
	    HtmlTag.prototype.getTagName = function () {
	        return this.tagName || '';
	    };
	    /**
	     * Sets an attribute on the HtmlTag.
	     *
	     * @param {String} attrName The attribute name to set.
	     * @param {String} attrValue The attribute value to set.
	     * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	     */
	    HtmlTag.prototype.setAttr = function (attrName, attrValue) {
	        var tagAttrs = this.getAttrs();
	        tagAttrs[attrName] = attrValue;
	        return this;
	    };
	    /**
	     * Retrieves an attribute from the HtmlTag. If the attribute does not exist, returns `undefined`.
	     *
	     * @param {String} attrName The attribute name to retrieve.
	     * @return {String} The attribute's value, or `undefined` if it does not exist on the HtmlTag.
	     */
	    HtmlTag.prototype.getAttr = function (attrName) {
	        return this.getAttrs()[attrName];
	    };
	    /**
	     * Sets one or more attributes on the HtmlTag.
	     *
	     * @param {Object.<String, String>} attrs A key/value Object (map) of the attributes to set.
	     * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	     */
	    HtmlTag.prototype.setAttrs = function (attrs) {
	        Object.assign(this.getAttrs(), attrs);
	        return this;
	    };
	    /**
	     * Retrieves the attributes Object (map) for the HtmlTag.
	     *
	     * @return {Object.<String, String>} A key/value object of the attributes for the HtmlTag.
	     */
	    HtmlTag.prototype.getAttrs = function () {
	        return this.attrs || (this.attrs = {});
	    };
	    /**
	     * Sets the provided `cssClass`, overwriting any current CSS classes on the HtmlTag.
	     *
	     * @param {String} cssClass One or more space-separated CSS classes to set (overwrite).
	     * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	     */
	    HtmlTag.prototype.setClass = function (cssClass) {
	        return this.setAttr('class', cssClass);
	    };
	    /**
	     * Convenience method to add one or more CSS classes to the HtmlTag. Will not add duplicate CSS classes.
	     *
	     * @param {String} cssClass One or more space-separated CSS classes to add.
	     * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	     */
	    HtmlTag.prototype.addClass = function (cssClass) {
	        var classAttr = this.getClass(), whitespaceRegex = this.whitespaceRegex, classes = !classAttr ? [] : classAttr.split(whitespaceRegex), newClasses = cssClass.split(whitespaceRegex), newClass;
	        while ((newClass = newClasses.shift())) {
	            if ((0, utils_1.indexOf)(classes, newClass) === -1) {
	                classes.push(newClass);
	            }
	        }
	        this.getAttrs()['class'] = classes.join(' ');
	        return this;
	    };
	    /**
	     * Convenience method to remove one or more CSS classes from the HtmlTag.
	     *
	     * @param {String} cssClass One or more space-separated CSS classes to remove.
	     * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	     */
	    HtmlTag.prototype.removeClass = function (cssClass) {
	        var classAttr = this.getClass(), whitespaceRegex = this.whitespaceRegex, classes = !classAttr ? [] : classAttr.split(whitespaceRegex), removeClasses = cssClass.split(whitespaceRegex), removeClass;
	        while (classes.length && (removeClass = removeClasses.shift())) {
	            var idx = (0, utils_1.indexOf)(classes, removeClass);
	            if (idx !== -1) {
	                classes.splice(idx, 1);
	            }
	        }
	        this.getAttrs()['class'] = classes.join(' ');
	        return this;
	    };
	    /**
	     * Convenience method to retrieve the CSS class(es) for the HtmlTag, which will each be separated by spaces when
	     * there are multiple.
	     *
	     * @return {String}
	     */
	    HtmlTag.prototype.getClass = function () {
	        return this.getAttrs()['class'] || '';
	    };
	    /**
	     * Convenience method to check if the tag has a CSS class or not.
	     *
	     * @param {String} cssClass The CSS class to check for.
	     * @return {Boolean} `true` if the HtmlTag has the CSS class, `false` otherwise.
	     */
	    HtmlTag.prototype.hasClass = function (cssClass) {
	        return (' ' + this.getClass() + ' ').indexOf(' ' + cssClass + ' ') !== -1;
	    };
	    /**
	     * Sets the inner HTML for the tag.
	     *
	     * @param {String} html The inner HTML to set.
	     * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	     */
	    HtmlTag.prototype.setInnerHTML = function (html) {
	        this.innerHTML = html;
	        return this;
	    };
	    /**
	     * Backwards compatibility method name.
	     *
	     * @param {String} html The inner HTML to set.
	     * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	     */
	    HtmlTag.prototype.setInnerHtml = function (html) {
	        return this.setInnerHTML(html);
	    };
	    /**
	     * Retrieves the inner HTML for the tag.
	     *
	     * @return {String}
	     */
	    HtmlTag.prototype.getInnerHTML = function () {
	        return this.innerHTML || '';
	    };
	    /**
	     * Backward compatibility method name.
	     *
	     * @return {String}
	     */
	    HtmlTag.prototype.getInnerHtml = function () {
	        return this.getInnerHTML();
	    };
	    /**
	     * Override of superclass method used to generate the HTML string for the tag.
	     *
	     * @return {String}
	     */
	    HtmlTag.prototype.toAnchorString = function () {
	        var tagName = this.getTagName(), attrsStr = this.buildAttrsStr();
	        attrsStr = attrsStr ? ' ' + attrsStr : ''; // prepend a space if there are actually attributes
	        return ['<', tagName, attrsStr, '>', this.getInnerHtml(), '</', tagName, '>'].join('');
	    };
	    /**
	     * Support method for {@link #toAnchorString}, returns the string space-separated key="value" pairs, used to populate
	     * the stringified HtmlTag.
	     *
	     * @protected
	     * @return {String} Example return: `attr1="value1" attr2="value2"`
	     */
	    HtmlTag.prototype.buildAttrsStr = function () {
	        if (!this.attrs)
	            return ''; // no `attrs` Object (map) has been set, return empty string
	        var attrs = this.getAttrs(), attrsArr = [];
	        for (var prop in attrs) {
	            if (attrs.hasOwnProperty(prop)) {
	                attrsArr.push(prop + '="' + attrs[prop] + '"');
	            }
	        }
	        return attrsArr.join(' ');
	    };
	    return HtmlTag;
	}());
	exports.HtmlTag = HtmlTag;
	//# sourceMappingURL=html-tag.js.map

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EmailMatch = void 0;
	var tslib_1 = __webpack_require__(181);
	var match_1 = __webpack_require__(390);
	/**
	 * @class Autolinker.match.Email
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Email match found in an input string which should be Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	var EmailMatch = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(EmailMatch, _super);
	    /**
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Match
	     *   instance, specified in an Object (map).
	     */
	    function EmailMatch(cfg) {
	        var _this = _super.call(this, cfg) || this;
	        /**
	         * @cfg {String} email (required)
	         *
	         * The email address that was matched.
	         */
	        _this.email = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        _this.email = cfg.email;
	        return _this;
	    }
	    /**
	     * Returns a string name for the type of match that this class represents.
	     * For the case of EmailMatch, returns 'email'.
	     *
	     * @return {String}
	     */
	    EmailMatch.prototype.getType = function () {
	        return 'email';
	    };
	    /**
	     * Returns the email address that was matched.
	     *
	     * @return {String}
	     */
	    EmailMatch.prototype.getEmail = function () {
	        return this.email;
	    };
	    /**
	     * Returns the anchor href that should be generated for the match.
	     *
	     * @return {String}
	     */
	    EmailMatch.prototype.getAnchorHref = function () {
	        return 'mailto:' + this.email;
	    };
	    /**
	     * Returns the anchor text that should be generated for the match.
	     *
	     * @return {String}
	     */
	    EmailMatch.prototype.getAnchorText = function () {
	        return this.email;
	    };
	    return EmailMatch;
	}(match_1.Match));
	exports.EmailMatch = EmailMatch;
	//# sourceMappingURL=email-match.js.map

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.HashtagMatch = void 0;
	var tslib_1 = __webpack_require__(181);
	var match_1 = __webpack_require__(390);
	/**
	 * @class Autolinker.match.Hashtag
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Hashtag match found in an input string which should be
	 * Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more
	 * details.
	 */
	var HashtagMatch = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(HashtagMatch, _super);
	    /**
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Match
	     *   instance, specified in an Object (map).
	     */
	    function HashtagMatch(cfg) {
	        var _this = _super.call(this, cfg) || this;
	        /**
	         * @cfg {String} serviceName
	         *
	         * The service to point hashtag matches to. See {@link Autolinker#hashtag}
	         * for available values.
	         */
	        _this.serviceName = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {String} hashtag (required)
	         *
	         * The HashtagMatch that was matched, without the '#'.
	         */
	        _this.hashtag = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        _this.serviceName = cfg.serviceName;
	        _this.hashtag = cfg.hashtag;
	        return _this;
	    }
	    /**
	     * Returns a string name for the type of match that this class represents.
	     * For the case of HashtagMatch, returns 'hashtag'.
	     *
	     * @return {String}
	     */
	    HashtagMatch.prototype.getType = function () {
	        return 'hashtag';
	    };
	    /**
	     * Returns the configured {@link #serviceName} to point the HashtagMatch to.
	     * Ex: 'facebook', 'twitter'.
	     *
	     * @return {String}
	     */
	    HashtagMatch.prototype.getServiceName = function () {
	        return this.serviceName;
	    };
	    /**
	     * Returns the matched hashtag, without the '#' character.
	     *
	     * @return {String}
	     */
	    HashtagMatch.prototype.getHashtag = function () {
	        return this.hashtag;
	    };
	    /**
	     * Returns the anchor href that should be generated for the match.
	     *
	     * @return {String}
	     */
	    HashtagMatch.prototype.getAnchorHref = function () {
	        var serviceName = this.serviceName, hashtag = this.hashtag;
	        switch (serviceName) {
	            case 'twitter':
	                return 'https://twitter.com/hashtag/' + hashtag;
	            case 'facebook':
	                return 'https://www.facebook.com/hashtag/' + hashtag;
	            case 'instagram':
	                return 'https://instagram.com/explore/tags/' + hashtag;
	            case 'tiktok':
	                return 'https://www.tiktok.com/tag/' + hashtag;
	            default:
	                // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
	                throw new Error('Unknown service name to point hashtag to: ' + serviceName);
	        }
	    };
	    /**
	     * Returns the anchor text that should be generated for the match.
	     *
	     * @return {String}
	     */
	    HashtagMatch.prototype.getAnchorText = function () {
	        return '#' + this.hashtag;
	    };
	    return HashtagMatch;
	}(match_1.Match));
	exports.HashtagMatch = HashtagMatch;
	//# sourceMappingURL=hashtag-match.js.map

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MentionMatch = void 0;
	var tslib_1 = __webpack_require__(181);
	var match_1 = __webpack_require__(390);
	/**
	 * @class Autolinker.match.Mention
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Mention match found in an input string which should be Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	var MentionMatch = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(MentionMatch, _super);
	    /**
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Match
	     *   instance, specified in an Object (map).
	     */
	    function MentionMatch(cfg) {
	        var _this = _super.call(this, cfg) || this;
	        /**
	         * @cfg {String} serviceName
	         *
	         * The service to point mention matches to. See {@link Autolinker#mention}
	         * for available values.
	         */
	        _this.serviceName = 'twitter'; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {String} mention (required)
	         *
	         * The Mention that was matched, without the '@' character.
	         */
	        _this.mention = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        _this.mention = cfg.mention;
	        _this.serviceName = cfg.serviceName;
	        return _this;
	    }
	    /**
	     * Returns a string name for the type of match that this class represents.
	     * For the case of MentionMatch, returns 'mention'.
	     *
	     * @return {String}
	     */
	    MentionMatch.prototype.getType = function () {
	        return 'mention';
	    };
	    /**
	     * Returns the mention, without the '@' character.
	     *
	     * @return {String}
	     */
	    MentionMatch.prototype.getMention = function () {
	        return this.mention;
	    };
	    /**
	     * Returns the configured {@link #serviceName} to point the mention to.
	     * Ex: 'instagram', 'twitter', 'soundcloud'.
	     *
	     * @return {String}
	     */
	    MentionMatch.prototype.getServiceName = function () {
	        return this.serviceName;
	    };
	    /**
	     * Returns the anchor href that should be generated for the match.
	     *
	     * @return {String}
	     */
	    MentionMatch.prototype.getAnchorHref = function () {
	        switch (this.serviceName) {
	            case 'twitter':
	                return 'https://twitter.com/' + this.mention;
	            case 'instagram':
	                return 'https://instagram.com/' + this.mention;
	            case 'soundcloud':
	                return 'https://soundcloud.com/' + this.mention;
	            case 'tiktok':
	                return 'https://www.tiktok.com/@' + this.mention;
	            default:
	                // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
	                throw new Error('Unknown service name to point mention to: ' + this.serviceName);
	        }
	    };
	    /**
	     * Returns the anchor text that should be generated for the match.
	     *
	     * @return {String}
	     */
	    MentionMatch.prototype.getAnchorText = function () {
	        return '@' + this.mention;
	    };
	    /**
	     * Returns the CSS class suffixes that should be used on a tag built with
	     * the match. See {@link Autolinker.match.Match#getCssClassSuffixes} for
	     * details.
	     *
	     * @return {String[]}
	     */
	    MentionMatch.prototype.getCssClassSuffixes = function () {
	        var cssClassSuffixes = _super.prototype.getCssClassSuffixes.call(this), serviceName = this.getServiceName();
	        if (serviceName) {
	            cssClassSuffixes.push(serviceName);
	        }
	        return cssClassSuffixes;
	    };
	    return MentionMatch;
	}(match_1.Match));
	exports.MentionMatch = MentionMatch;
	//# sourceMappingURL=mention-match.js.map

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PhoneMatch = void 0;
	var tslib_1 = __webpack_require__(181);
	var match_1 = __webpack_require__(390);
	/**
	 * @class Autolinker.match.Phone
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Phone number match found in an input string which should be
	 * Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more
	 * details.
	 */
	var PhoneMatch = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(PhoneMatch, _super);
	    /**
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Match
	     *   instance, specified in an Object (map).
	     */
	    function PhoneMatch(cfg) {
	        var _this = _super.call(this, cfg) || this;
	        /**
	         * @protected
	         * @property {String} number (required)
	         *
	         * The phone number that was matched, without any delimiter characters.
	         *
	         * Note: This is a string to allow for prefixed 0's.
	         */
	        _this.number = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @protected
	         * @property  {Boolean} plusSign (required)
	         *
	         * `true` if the matched phone number started with a '+' sign. We'll include
	         * it in the `tel:` URL if so, as this is needed for international numbers.
	         *
	         * Ex: '+1 (123) 456 7879'
	         */
	        _this.plusSign = false; // default value just to get the above doc comment in the ES5 output and documentation generator
	        _this.number = cfg.number;
	        _this.plusSign = cfg.plusSign;
	        return _this;
	    }
	    /**
	     * Returns a string name for the type of match that this class represents.
	     * For the case of PhoneMatch, returns 'phone'.
	     *
	     * @return {String}
	     */
	    PhoneMatch.prototype.getType = function () {
	        return 'phone';
	    };
	    /**
	     * Returns the phone number that was matched as a string, without any
	     * delimiter characters.
	     *
	     * Note: This is a string to allow for prefixed 0's.
	     *
	     * @return {String}
	     */
	    PhoneMatch.prototype.getPhoneNumber = function () {
	        return this.number;
	    };
	    /**
	     * Alias of {@link #getPhoneNumber}, returns the phone number that was
	     * matched as a string, without any delimiter characters.
	     *
	     * Note: This is a string to allow for prefixed 0's.
	     *
	     * @return {String}
	     */
	    PhoneMatch.prototype.getNumber = function () {
	        return this.getPhoneNumber();
	    };
	    /**
	     * Returns the anchor href that should be generated for the match.
	     *
	     * @return {String}
	     */
	    PhoneMatch.prototype.getAnchorHref = function () {
	        return 'tel:' + (this.plusSign ? '+' : '') + this.number;
	    };
	    /**
	     * Returns the anchor text that should be generated for the match.
	     *
	     * @return {String}
	     */
	    PhoneMatch.prototype.getAnchorText = function () {
	        return this.matchedText;
	    };
	    return PhoneMatch;
	}(match_1.Match));
	exports.PhoneMatch = PhoneMatch;
	//# sourceMappingURL=phone-match.js.map

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatch = void 0;
	var tslib_1 = __webpack_require__(181);
	var match_1 = __webpack_require__(390);
	/**
	 * @class Autolinker.match.Url
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Url match found in an input string which should be Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	var UrlMatch = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(UrlMatch, _super);
	    /**
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Match
	     *   instance, specified in an Object (map).
	     */
	    function UrlMatch(cfg) {
	        var _this = _super.call(this, cfg) || this;
	        /**
	         * @cfg {String} url (required)
	         *
	         * The url that was matched.
	         */
	        _this.url = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {"scheme"/"www"/"tld"} urlMatchType (required)
	         *
	         * The type of URL match that this class represents. This helps to determine
	         * if the match was made in the original text with a prefixed scheme (ex:
	         * 'http://www.google.com'), a prefixed 'www' (ex: 'www.google.com'), or
	         * was matched by a known top-level domain (ex: 'google.com').
	         */
	        _this.urlMatchType = 'scheme'; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} protocolUrlMatch (required)
	         *
	         * `true` if the URL is a match which already has a protocol (i.e.
	         * 'http://'), `false` if the match was from a 'www' or known TLD match.
	         */
	        _this.protocolUrlMatch = false; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} protocolRelativeMatch (required)
	         *
	         * `true` if the URL is a protocol-relative match. A protocol-relative match
	         * is a URL that starts with '//', and will be either http:// or https://
	         * based on the protocol that the site is loaded under.
	         */
	        _this.protocolRelativeMatch = false; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Object} stripPrefix (required)
	         *
	         * The Object form of {@link Autolinker#cfg-stripPrefix}.
	         */
	        _this.stripPrefix = {
	            scheme: true,
	            www: true,
	        }; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} stripTrailingSlash (required)
	         * @inheritdoc Autolinker#cfg-stripTrailingSlash
	         */
	        _this.stripTrailingSlash = true; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} decodePercentEncoding (required)
	         * @inheritdoc Autolinker#cfg-decodePercentEncoding
	         */
	        _this.decodePercentEncoding = true; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @private
	         * @property {RegExp} schemePrefixRegex
	         *
	         * A regular expression used to remove the 'http://' or 'https://' from
	         * URLs.
	         */
	        _this.schemePrefixRegex = /^(https?:\/\/)?/i;
	        /**
	         * @private
	         * @property {RegExp} wwwPrefixRegex
	         *
	         * A regular expression used to remove the 'www.' from URLs.
	         */
	        _this.wwwPrefixRegex = /^(https?:\/\/)?(www\.)?/i;
	        /**
	         * @private
	         * @property {RegExp} protocolRelativeRegex
	         *
	         * The regular expression used to remove the protocol-relative '//' from the {@link #url} string, for purposes
	         * of {@link #getAnchorText}. A protocol-relative URL is, for example, "//yahoo.com"
	         */
	        _this.protocolRelativeRegex = /^\/\//;
	        /**
	         * @private
	         * @property {Boolean} protocolPrepended
	         *
	         * Will be set to `true` if the 'http://' protocol has been prepended to the {@link #url} (because the
	         * {@link #url} did not have a protocol)
	         */
	        _this.protocolPrepended = false;
	        _this.urlMatchType = cfg.urlMatchType;
	        _this.url = cfg.url;
	        _this.protocolUrlMatch = cfg.protocolUrlMatch;
	        _this.protocolRelativeMatch = cfg.protocolRelativeMatch;
	        _this.stripPrefix = cfg.stripPrefix;
	        _this.stripTrailingSlash = cfg.stripTrailingSlash;
	        _this.decodePercentEncoding = cfg.decodePercentEncoding;
	        return _this;
	    }
	    /**
	     * Returns a string name for the type of match that this class represents.
	     * For the case of UrlMatch, returns 'url'.
	     *
	     * @return {String}
	     */
	    UrlMatch.prototype.getType = function () {
	        return 'url';
	    };
	    /**
	     * Returns a string name for the type of URL match that this class
	     * represents.
	     *
	     * This helps to determine if the match was made in the original text with a
	     * prefixed scheme (ex: 'http://www.google.com'), a prefixed 'www' (ex:
	     * 'www.google.com'), or was matched by a known top-level domain (ex:
	     * 'google.com').
	     *
	     * @return {"scheme"/"www"/"tld"}
	     */
	    UrlMatch.prototype.getUrlMatchType = function () {
	        return this.urlMatchType;
	    };
	    /**
	     * Returns the url that was matched, assuming the protocol to be 'http://' if the original
	     * match was missing a protocol.
	     *
	     * @return {String}
	     */
	    UrlMatch.prototype.getUrl = function () {
	        var url = this.url;
	        // if the url string doesn't begin with a protocol, assume 'http://'
	        if (!this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended) {
	            url = this.url = 'http://' + url;
	            this.protocolPrepended = true;
	        }
	        return url;
	    };
	    /**
	     * Returns the anchor href that should be generated for the match.
	     *
	     * @return {String}
	     */
	    UrlMatch.prototype.getAnchorHref = function () {
	        var url = this.getUrl();
	        return url.replace(/&amp;/g, '&'); // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html
	    };
	    /**
	     * Returns the anchor text that should be generated for the match.
	     *
	     * @return {String}
	     */
	    UrlMatch.prototype.getAnchorText = function () {
	        var anchorText = this.getMatchedText();
	        if (this.protocolRelativeMatch) {
	            // Strip off any protocol-relative '//' from the anchor text
	            anchorText = this.stripProtocolRelativePrefix(anchorText);
	        }
	        if (this.stripPrefix.scheme) {
	            anchorText = this.stripSchemePrefix(anchorText);
	        }
	        if (this.stripPrefix.www) {
	            anchorText = this.stripWwwPrefix(anchorText);
	        }
	        if (this.stripTrailingSlash) {
	            anchorText = this.removeTrailingSlash(anchorText); // remove trailing slash, if there is one
	        }
	        if (this.decodePercentEncoding) {
	            anchorText = this.removePercentEncoding(anchorText);
	        }
	        return anchorText;
	    };
	    // ---------------------------------------
	    // Utility Functionality
	    /**
	     * Strips the scheme prefix (such as "http://" or "https://") from the given
	     * `url`.
	     *
	     * @private
	     * @param {String} url The text of the anchor that is being generated, for
	     *   which to strip off the url scheme.
	     * @return {String} The `url`, with the scheme stripped.
	     */
	    UrlMatch.prototype.stripSchemePrefix = function (url) {
	        return url.replace(this.schemePrefixRegex, '');
	    };
	    /**
	     * Strips the 'www' prefix from the given `url`.
	     *
	     * @private
	     * @param {String} url The text of the anchor that is being generated, for
	     *   which to strip off the 'www' if it exists.
	     * @return {String} The `url`, with the 'www' stripped.
	     */
	    UrlMatch.prototype.stripWwwPrefix = function (url) {
	        return url.replace(this.wwwPrefixRegex, '$1'); // leave any scheme ($1), it one exists
	    };
	    /**
	     * Strips any protocol-relative '//' from the anchor text.
	     *
	     * @private
	     * @param {String} text The text of the anchor that is being generated, for which to strip off the
	     *   protocol-relative prefix (such as stripping off "//")
	     * @return {String} The `anchorText`, with the protocol-relative prefix stripped.
	     */
	    UrlMatch.prototype.stripProtocolRelativePrefix = function (text) {
	        return text.replace(this.protocolRelativeRegex, '');
	    };
	    /**
	     * Removes any trailing slash from the given `anchorText`, in preparation for the text to be displayed.
	     *
	     * @private
	     * @param {String} anchorText The text of the anchor that is being generated, for which to remove any trailing
	     *   slash ('/') that may exist.
	     * @return {String} The `anchorText`, with the trailing slash removed.
	     */
	    UrlMatch.prototype.removeTrailingSlash = function (anchorText) {
	        if (anchorText.charAt(anchorText.length - 1) === '/') {
	            anchorText = anchorText.slice(0, -1);
	        }
	        return anchorText;
	    };
	    /**
	     * Decodes percent-encoded characters from the given `anchorText`, in
	     * preparation for the text to be displayed.
	     *
	     * @private
	     * @param {String} anchorText The text of the anchor that is being
	     *   generated, for which to decode any percent-encoded characters.
	     * @return {String} The `anchorText`, with the percent-encoded characters
	     *   decoded.
	     */
	    UrlMatch.prototype.removePercentEncoding = function (anchorText) {
	        // First, convert a few of the known % encodings to the corresponding
	        // HTML entities that could accidentally be interpretted as special
	        // HTML characters
	        var preProcessedEntityAnchorText = anchorText
	            .replace(/%22/gi, '&quot;') // " char
	            .replace(/%26/gi, '&amp;') // & char
	            .replace(/%27/gi, '&#39;') // ' char
	            .replace(/%3C/gi, '&lt;') // < char
	            .replace(/%3E/gi, '&gt;'); // > char
	        try {
	            // Now attempt to decode the rest of the anchor text
	            return decodeURIComponent(preProcessedEntityAnchorText);
	        }
	        catch (e) {
	            // Invalid % escape sequence in the anchor text
	            return preProcessedEntityAnchorText;
	        }
	    };
	    return UrlMatch;
	}(match_1.Match));
	exports.UrlMatch = UrlMatch;
	//# sourceMappingURL=url-match.js.map

/***/ }),
/* 1091 */,
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _styles = __webpack_require__(4916);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProviderNameAvatar(_ref) {
	  var provider = _ref.provider,
	      avatarSize = _ref.avatarSize,
	      renderMeta = _ref.renderMeta,
	      withoutLocation = _ref.withoutLocation;
	
	  var _ref2 = provider || {},
	      providerName = _ref2.name,
	      avatar = _ref2.avatar,
	      location = _ref2.location;
	
	  var _ref3 = location || {},
	      locationName = _ref3.name;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(_SimpleAvatar2.default, {
	      src: (0, _get2.default)(avatar, 'thumbMin'),
	      text: providerName,
	      size: avatarSize,
	      bordered: true
	    }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'name' },
	      _react2.default.createElement(
	        'span',
	        { styleName: 'strong' },
	        providerName
	      ),
	      _react2.default.createElement(
	        'span',
	        { styleName: 'meta' },
	        renderMeta(provider)
	      ),
	      locationName && !withoutLocation && _react2.default.createElement(
	        'span',
	        { styleName: 'meta', className: 'mt1' },
	        locationName
	      )
	    )
	  );
	}
	
	ProviderNameAvatar.propTypes = {
	  renderMeta: PropTypes.func,
	  provider: PropTypes.object,
	  avatarSize: PropTypes.number,
	  withoutLocation: PropTypes.bool
	};
	
	ProviderNameAvatar.defaultProps = {
	  avatarSize: 68,
	  renderMeta: function renderMeta() {},
	  withoutLocation: false
	};
	
	exports.default = (0, _reactCssModules2.default)(ProviderNameAvatar, _styles2.default, { allowMultiple: true });

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderAddress = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderAddress = exports.renderAddress = function renderAddress(entity) {
	  return [(0, _get2.default)(entity, 'address'), (0, _get2.default)(entity, 'city'), (0, _get2.default)(entity, 'FL'), (0, _get2.default)(entity, 'state') + ' ' + (0, _get2.default)(entity, 'zip')].filter(function (str) {
	    return !!str;
	  }).join(', ');
	};

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _passwordRules = __webpack_require__(1210);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(4927);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CheckingListTooltip(_ref) {
	  var list = _ref.list,
	      _ref$title = _ref.title,
	      tooltipTitle = _ref$title === undefined ? 'password.validation.title' : _ref$title,
	      _ref$children = _ref.children,
	      children = _ref$children === undefined ? null : _ref$children;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(
	      'p',
	      { styleName: 'title' },
	      formatMessage({ id: tooltipTitle })
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      list.map(function (_ref2) {
	        var status = _ref2.status,
	            title = _ref2.title;
	        var _VALIDATION_ICONS$sta = _passwordRules.VALIDATION_ICONS[status],
	            name = _VALIDATION_ICONS$sta.name,
	            color = _VALIDATION_ICONS$sta.color;
	
	        var danger = status === _passwordRules.PASSWORD_STATUS.DANGER;
	        return _react2.default.createElement(
	          'li',
	          {
	            styleName: (0, _classnames2.default)('item', {
	              'item--danger': danger
	            }),
	            key: title
	          },
	          _react2.default.createElement(_Icon2.default, {
	            name: name,
	            size: 12,
	            style: color,
	            key: name,
	            className: 'mr2'
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            formatMessage({ id: title })
	          )
	        );
	      })
	    ),
	    children
	  );
	}
	
	exports.default = (0, _reactCssModules2.default)(CheckingListTooltip, _index2.default, { allowMultiple: true });
	
	
	CheckingListTooltip.propTypes = {
	  list: _propTypes2.default.array,
	  title: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var CancelForm = function CancelForm(_ref) {
	  var getAction = _ref.getAction,
	      getOptions = _ref.getOptions,
	      onClose = _ref.onClose,
	      onSubmit = _ref.onSubmit,
	      invitationId = _ref.invitationId,
	      userId = _ref.userId,
	      text = _ref.text,
	      rejected = _ref.rejected,
	      formatMessage = _ref.intl.formatMessage;
	
	  getAction(onSubmit);
	  getOptions({ userId: userId, invitationId: invitationId });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      text
	    ),
	    rejected ? _react2.default.createElement(_ErrorBlock2.default, {
	      className: 'mv2',
	      errors: formatMessage(_strings.AUTH.errors.common)
	    }) : null,
	    _react2.default.createElement(
	      _Button2.default,
	      { className: 'mt3 mr2', raised: true, color: 'primary', type: 'submit' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.CONFIRM_CANCEL)
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'mt3',
	        raised: true,
	        color: 'accent',
	        onClick: onClose,
	        type: 'button'
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.DECLINE_CANCEL)
	    )
	  );
	};
	
	CancelForm.propTypes = {
	  getAction: _propTypes2.default.func,
	  getOptions: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  invitationId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool] // temp
	  ),
	  userId: _propTypes2.default.number,
	  text: _propTypes2.default.string,
	  rejected: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _reactIntl.injectIntl)(CancelForm);

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Form = __webpack_require__(1709);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var CancelPopup = function CancelPopup(_ref) {
	  var children = _ref.children,
	      isOpened = _ref.isOpened,
	      onClose = _ref.onClose,
	      title = _ref.title;
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { maxWidth: _styles.BREAKPOINT },
	    function (isMobile) {
	      return _react2.default.createElement(
	        _Popup2.default,
	        (0, _extends3.default)({ onClose: onClose, title: title }, {
	          opened: isOpened,
	          width: isMobile ? 'medium' : 'small'
	        }),
	        _react2.default.createElement(
	          _Form2.default,
	          null,
	          children
	        )
	      );
	    }
	  );
	};
	
	CancelPopup.propTypes = {
	  children: _propTypes2.default.node,
	  isOpened: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  title: _propTypes2.default.string,
	  intl: _propTypes2.default.object
	};
	
	exports.default = CancelPopup;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _ActionItem = __webpack_require__(1716);
	
	var _ActionItem2 = _interopRequireDefault(_ActionItem);
	
	var _getMenu = __webpack_require__(4197);
	
	var _getMenu2 = _interopRequireDefault(_getMenu);
	
	var _routes = __webpack_require__(37);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _resolveFamilyMemberOption = __webpack_require__(906);
	
	var _resolveFamilyMemberOption2 = _interopRequireDefault(_resolveFamilyMemberOption);
	
	var _getFamilyMemberRole = __webpack_require__(4202);
	
	var _props = __webpack_require__(41);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(953);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var providerCircleTypes = [_strings.PROVIDER_PROFILE, _strings.CIRCLE_PROVIDER]; /* eslint-disable react/require-default-props, react/no-array-index-key, no-nested-ternary */
	
	
	var onItemClick = function onItemClick(_ref) {
	  var type = _ref.type,
	      teamActingUser = _ref.teamActingUser,
	      targetUserId = _ref.targetUserId,
	      id = _ref.id,
	      loggedUserId = _ref.loggedUserId;
	
	  var types = {
	    family: 'patient',
	    provider: 'provider'
	  };
	  var subpath = '';
	
	  switch (type) {
	    case _strings.CIRCLE_FAMILY:
	      subpath = _routes2.default.FAMILY_MEMBER_PROFILE;
	      break;
	    case _strings.CIRCLE_PROVIDER:
	      if (teamActingUser) {
	        subpath = _routes2.default.TEAM_MEMBER_PROFILE;
	      } else {
	        subpath = _routes2.default.PROVIDER_MEMBER_PROFILE;
	      }
	      break;
	    default:
	      subpath = '';
	  }
	
	  var path = loggedUserId === id ? '/profile/' + id + '/' + types[type] : '/profile/' + targetUserId + '/' + subpath + '/' + id;
	
	  _browserHistory2.default.push(path);
	};
	
	var checkLastGuardianRole = function checkLastGuardianRole(list, id, guardian, loggedUserId) {
	  var guardiansList = list.filter(function (member) {
	    return (0, _get2.default)(member, [_props.CARE_ROLE.GUARDIAN]) || (0, _get2.default)(member, [_props.CARE_ROLE.PROXY]);
	  });
	
	  return (0, _size2.default)(guardiansList) === 1 && id === loggedUserId && guardian;
	};
	
	var getSubtitle = function getSubtitle(type, _ref2, formatMessage) {
	  var role = _ref2.role,
	      teamActingUser = _ref2.teamActingUser,
	      organizationName = _ref2.organizationName;
	
	  var isProviderCircleType = providerCircleTypes.some(function (circleType) {
	    return circleType === type;
	  });
	
	  if (teamActingUser) return organizationName;
	  return isProviderCircleType || type === _strings.TEAM_PROFILE ? role : role && (0, _resolveFamilyMemberOption2.default)({ role: role }, formatMessage);
	};
	
	var CircleList = function CircleList(_ref3) {
	  var targetUserId = _ref3.targetUserId,
	      loggedUserId = _ref3.loggedUserId,
	      isLoggedUser = _ref3.isLoggedUser,
	      isCaregiver = _ref3.isCaregiver,
	      isVerifiedDependent = _ref3.isVerifiedDependent,
	      list = _ref3.list,
	      type = _ref3.type,
	      children = _ref3.children,
	      removeFromCircle = _ref3.removeFromCircle,
	      removeCaregiverRole = _ref3.removeCaregiverRole,
	      openInvitePopup = _ref3.openInvitePopup,
	      openCancelCaregiverInvitePopup = _ref3.openCancelCaregiverInvitePopup,
	      intro = _ref3.intro,
	      formatMessage = _ref3.intl.formatMessage,
	      allowNavigation = _ref3.allowNavigation,
	      removeGuardianRole = _ref3.removeGuardianRole,
	      openLeaveCirclePopup = _ref3.openLeaveCirclePopup,
	      title = _ref3.title,
	      onOpenSimpleFormPopup = _ref3.onOpenSimpleFormPopup;
	  return _react2.default.createElement(
	    'div',
	    null,
	    list.length || !!children ? [_react2.default.createElement(
	      'p',
	      { styleName: 'listTitle', key: '0'
	      },
	      Boolean(title) ? title : _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _strings.CIRCLES.circleTitle, { values: { type: type } }))
	    ), _react2.default.createElement(
	      'div',
	      { styleName: 'list', key: '1'
	      },
	      children,
	      list.map(function (item, i) {
	        var id = item.id,
	            displayableName = item.displayableName,
	            guardian = item.guardian,
	            proxy = item.proxy,
	            avatar = item.avatar,
	            parent = item.parent,
	            teamActingUser = item.teamActingUser;
	
	
	        var isGuardian = guardian || proxy || parent;
	        var isLastGuardian = checkLastGuardianRole(list, id, isGuardian, loggedUserId);
	
	        var note = (0, _getFamilyMemberRole.getFamilyMemberRole)(item, formatMessage);
	
	        var menu = (0, _getMenu2.default)({
	          formatMessage: formatMessage,
	          targetUserId: targetUserId,
	          isLoggedUser: isLoggedUser,
	          isCaregiver: isCaregiver,
	          isVerifiedDependent: isVerifiedDependent,
	          loggedUserId: loggedUserId,
	          item: item,
	          type: type,
	          removeFromCircle: removeFromCircle,
	          openInvitePopup: openInvitePopup,
	          openCancelCaregiverInvitePopup: openCancelCaregiverInvitePopup,
	          removeCaregiverRole: removeCaregiverRole,
	          removeGuardianRole: removeGuardianRole,
	          onOpenSimpleFormPopup: onOpenSimpleFormPopup,
	          openLeaveCirclePopup: openLeaveCirclePopup,
	          isLastGuardian: isLastGuardian
	        });
	
	        var listItem = {
	          image: (0, _get2.default)(avatar, 'thumbMiddle'),
	          title: displayableName,
	          subtitle: getSubtitle(type, item, formatMessage),
	          note: note,
	          titleIcon: teamActingUser ? 'team' : null
	        };
	
	        return _react2.default.createElement(_ActionItem2.default, {
	          key: i,
	          index: i,
	          intro: (0, _get2.default)(intro, 'assignCaregiver'),
	          item: listItem,
	          menu: menu,
	          onClick: allowNavigation ? function () {
	            return onItemClick({
	              type: type,
	              teamActingUser: teamActingUser,
	              targetUserId: targetUserId,
	              id: id,
	              loggedUserId: loggedUserId
	            });
	          } : null
	        });
	      })
	    )] : null
	  );
	};
	
	CircleList.propTypes = {
	  isLoggedUser: _propTypes2.default.bool,
	  removeFromCircle: _propTypes2.default.func,
	  removeCaregiverRole: _propTypes2.default.func,
	  openInvitePopup: _propTypes2.default.func,
	  list: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  type: _propTypes2.default.oneOf(_props.PROPS_LIST.circle.type).isRequired,
	  targetUserId: _propTypes2.default.number,
	  loggedUserId: _propTypes2.default.number,
	  isCaregiver: _propTypes2.default.bool,
	  intro: _propTypes2.default.shape({
	    assignCaregiver: _propTypes2.default.string
	  }),
	  children: _propTypes2.default.node,
	  openCancelCaregiverInvitePopup: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  allowNavigation: _propTypes2.default.bool,
	  isVerifiedDependent: _propTypes2.default.bool,
	  removeGuardianRole: _propTypes2.default.func,
	  openLeaveCirclePopup: _propTypes2.default.func,
	  title: _propTypes2.default.string,
	  onOpenSimpleFormPopup: _propTypes2.default.func
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(CircleList, _index2.default, { allowMultiple: true }));

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(4929);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunitiesList = function CommunitiesList(_ref) {
	  var title = _ref.title,
	      counter = _ref.counter,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'list-wrapper' },
	    !!title ? _react2.default.createElement(
	      'h3',
	      { styleName: 'title' },
	      title,
	      ' (',
	      counter,
	      ')'
	    ) : null,
	    _react2.default.createElement(
	      'ul',
	      { styleName: 'list' },
	      children
	    )
	  );
	};
	
	CommunitiesList.propTypes = {
	  title: _propTypes2.default.string,
	  counter: _propTypes2.default.number,
	  children: _propTypes2.default.node.isRequired
	};
	
	CommunitiesList.defaultProps = {
	  title: '',
	  counter: null
	};
	
	exports.default = (0, _reactCssModules2.default)(CommunitiesList, _index2.default, { allowMultiple: true });

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _ActionButton = __webpack_require__(1178);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(719);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLocation = function getLocation(href) {
	  var link = document.createElement('a');
	  link.href = href;
	
	  return link.hostname;
	}; /* eslint-disable */
	
	
	var TITLE_LIMIT = (0, _mobileHelpers.isDesktop)() ? 100 : 60;
	var DESCRIPTION_LIMIT = (0, _mobileHelpers.isDesktop)() ? 130 : 80;
	
	var getEllipsisText = function getEllipsisText(text, limit) {
	  return text.length < limit ? text : text.slice(0, limit) + '...';
	};
	
	var getValidVideoUrl = function getValidVideoUrl(src) {
	  return src.replace('autoplay=1', 'autoplay=0');
	};
	
	var UrlPreview = function UrlPreview(_ref) {
	  var readonly = _ref.readonly,
	      className = _ref.className,
	      description = _ref.description,
	      title = _ref.title,
	      preview = _ref.preview,
	      video = _ref.video,
	      url = _ref.url,
	      onCancel = _ref.onCancel,
	      intl = _ref.intl;
	  return _react2.default.createElement(
	    _Paper2.default,
	    { zDepth: 8, styleName: 'url-preview', className: className },
	    _react2.default.createElement(
	      'div',
	      { className: 'df' },
	      video && video !== 'null' ? [_react2.default.createElement('iframe', {
	        styleName: 'videoPlayer',
	        src: getValidVideoUrl(video),
	        frameBorder: '0',
	        gesture: 'media',
	        allow: 'encrypted-media',
	        allowFullScreen: true,
	        key: '0'
	      }), !readonly ? _react2.default.createElement(
	        'div',
	        { styleName: 'actionButtonWrapper', key: '1'
	        },
	        _react2.default.createElement(
	          _ActionButton2.default,
	          {
	            onClick: onCancel,
	            style: (0, _extends3.default)({}, !(0, _mobileHelpers.isDesktop)() && {
	              width: '30px',
	              height: '30px',
	              borderRadius: '4px'
	            })
	          },
	          _react2.default.createElement(_Icon2.default, { name: 'close', size: 20, style: { fill: _styles.COLORS.white } })
	        )
	      ) : null] : [_react2.default.createElement(
	        'div',
	        { styleName: 'preview-image', key: '0'
	        },
	        preview && preview !== 'null' ? _react2.default.createElement('img', { src: preview }) : _react2.default.createElement(
	          'div',
	          { styleName: 'no-preview' },
	          intl.formatMessage(_strings.COMMUNUNNITY_NEW_POST.noPreview)
	        )
	      ), _react2.default.createElement(
	        'div',
	        { styleName: 'description-pane', className: 'pl3', key: '1'
	        },
	        _react2.default.createElement(
	          'h3',
	          { className: 'flex items-center justify-between pr1' },
	          _react2.default.createElement(
	            'div',
	            { style: { flexGrow: 1 } },
	            title && title !== 'null' ? getEllipsisText(title, TITLE_LIMIT) : null,
	            '\xA0'
	          ),
	          !readonly ? _react2.default.createElement(
	            _ActionButton2.default,
	            { onClick: onCancel },
	            _react2.default.createElement(_Icon2.default, { name: 'close', size: 24, style: { fill: _styles.COLORS.white } })
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          description && description !== 'null' ? getEllipsisText(description, DESCRIPTION_LIMIT) : null,
	          '\xA0'
	        ),
	        _react2.default.createElement(
	          'p',
	          { styleName: 'link' },
	          getLocation(url)
	        )
	      )]
	    )
	  );
	};
	
	UrlPreview.propTypes = {
	  description: _propTypes2.default.string,
	  preview: _propTypes2.default.string,
	  video: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(UrlPreview, _index2.default));

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var SectionTitle = function SectionTitle(_ref) {
	  var text = _ref.text;
	  return _react2.default.createElement('p', { styleName: 'section-title', children: text });
	};
	
	SectionTitle.propTypes = {
	  text: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(SectionTitle, _index2.default, { allowMultiple: true });

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _sanitizeHtml = __webpack_require__(313);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _index = __webpack_require__(4937);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConsentInfo = function ConsentInfo(_ref) {
	  var consent = _ref.consent,
	      counter = _ref.counter,
	      skipSanitize = _ref.skipSanitize;
	  var name = consent.name,
	      typeName = consent.typeName,
	      versionTitle = consent.versionTitle,
	      version = consent.version,
	      content = consent.content;
	
	
	  var subtitle = typeName + ', ' + versionTitle + ' ' + version;
	
	  var contentProps = (0, _react.useMemo)(function () {
	    if (!skipSanitize) {
	      return {
	        className: _index2.default.text,
	        dangerouslySetInnerHTML: {
	          __html: (0, _sanitizeHtml2.default)(content)
	        }
	      };
	    }
	
	    return {
	      className: _index2.default.nonSanitizedContent,
	      dangerouslySetInnerHTML: {
	        __html: content
	      }
	    };
	  }, [content, skipSanitize]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.contentHeader },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.mainTitle },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.consentTitle },
	            name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.consentSubTitle },
	            subtitle
	          )
	        ),
	        counter && _react2.default.createElement(
	          'div',
	          { className: _index2.default.counter },
	          counter
	        )
	      ),
	      _react2.default.createElement('div', contentProps)
	    )
	  );
	};
	
	ConsentInfo.propTypes = {
	  consent: PropTypes.object.isRequired,
	  counter: PropTypes.node,
	  skipSanitize: PropTypes.bool
	};
	
	exports.default = ConsentInfo;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Controls = __webpack_require__(333);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _ControlsItem = __webpack_require__(394);
	
	var _ControlsItem2 = _interopRequireDefault(_ControlsItem);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(4939);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContextBar = function ContextBar(_ref) {
	  var contextSubtitle = _ref.contextSubtitle,
	      contextTitle = _ref.contextTitle,
	      transparent = _ref.transparent,
	      onClick = _ref.onClick,
	      expanded = _ref.expanded,
	      title = _ref.title;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    !expanded ? title && _react2.default.createElement(
	      'div',
	      { styleName: 'barTitle' },
	      title
	    ) : _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('bar', { transparent: transparent }) },
	      _react2.default.createElement(
	        _Controls2.default,
	        null,
	        _react2.default.createElement(
	          _ControlsItem2.default,
	          { fixed: true },
	          _react2.default.createElement(
	            _ClickableElement2.default,
	            { onClick: onClick, ariaLabel: 'back arrow' },
	            _react2.default.createElement(
	              _reactResponsive2.default,
	              { maxWidth: _styles.BREAKPOINT },
	              function (isMobile) {
	                return _react2.default.createElement(_Icon2.default, {
	                  name: isMobile ? 'arrow-down' : 'back-arrow',
	                  size: 16,
	                  style: {
	                    transform: isMobile ? 'rotate(90deg)' : null,
	                    fill: _styles.COLORS.white
	                  }
	                });
	              }
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'text-wrapper' },
	        _react2.default.createElement(
	          'span',
	          { className: 'f-12 pr2', styleName: 'subtitle' },
	          contextSubtitle
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'f-14', styleName: 'title' },
	          contextTitle
	        )
	      )
	    )
	  );
	};
	
	ContextBar.propTypes = {
	  contextSubtitle: _propTypes2.default.string,
	  contextTitle: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  expanded: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  transparent: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(ContextBar, _index2.default, { allowMultiple: true });

/***/ }),
/* 1103 */,
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useLoggedUserCountry = useLoggedUserCountry;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(50);
	
	function useLoggedUserCountry() {
	  var loggedUserCountryName = (0, _reactRedux.useSelector)(_selectors.loggedUserCountrySelector);
	  var targetUserCountryName = (0, _reactRedux.useSelector)(_selectors.targetUserCountrySelector);
	
	  var safeUserCountryName = targetUserCountryName || loggedUserCountryName;
	
	  var targetCountry = (0, _reactRedux.useSelector)(_selectors2.selectCountryList).find(function (_ref) {
	    var name = _ref.name;
	    return name === safeUserCountryName;
	  });
	
	  if (!targetCountry) return null;
	
	  var targetCountryEntity = {
	    label: targetCountry.name,
	    value: targetCountry.isoCode
	  };
	
	  return (0, _react.useMemo)(function () {
	    return targetCountryEntity;
	  }, [safeUserCountryName, targetCountry]);
	}

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(2246);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = function Title(_ref) {
	  var className = _ref.className,
	      colored = _ref.colored,
	      text = _ref.text;
	  return _react2.default.createElement('p', {
	    className: (0, _classnames2.default)('ma0', className),
	    styleName: (0, _classnames2.default)('title', {
	      'title--colored': colored
	    }),
	    children: text
	  });
	}; /* eslint-disable react/require-default-props */
	
	
	Title.propTypes = {
	  className: _propTypes2.default.string,
	  colored: _propTypes2.default.bool,
	  text: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactCssModules2.default)(Title, _index2.default, { allowMultiple: true });

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(4952);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ExpandableBlock = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(ExpandableBlock, _PureComponent);
	
	  function ExpandableBlock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ExpandableBlock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpandableBlock.__proto__ || (0, _getPrototypeOf2.default)(ExpandableBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      opened: true
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ExpandableBlock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ opened: this.props.opened });
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(e) {
	      e.stopPropagation();
	      if (!this.props.locked) {
	        this.setState({ opened: !this.state.opened });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          content = _props.content,
	          icon = _props.icon,
	          locked = _props.locked,
	          large = _props.large,
	          headStyle = _props.headStyle,
	          hasCustomMarker = _props.hasCustomMarker;
	
	
	      var customMarker = !locked && _react2.default.createElement(
	        'div',
	        { styleName: 'marker', className: 'o-50 pa3', onClick: this.toggle },
	        icon ? _react2.default.createElement(_Icon2.default, {
	          name: icon,
	          style: {
	            transform: 'rotate(180deg)',
	            stroke: _styles.COLORS.bluePrimary
	          }
	        }) : null
	      );
	
	      var clickableElements = locked ? [content.head] : [content.head, customMarker];
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ styleName: 'root' }, { className: className }),
	        _react2.default.createElement(_ClickableElement2.default, {
	          children: clickableElements.map(function (item, i) {
	            return (0, _react.cloneElement)(item, { key: i });
	          }),
	          onClick: !hasCustomMarker ? this.toggle : null,
	          styleName: (0, _classnames2.default)('head', { 'head--closed': !this.state.opened }, { 'head--default': !icon }, { 'head--locked': locked }, { 'head--large': large }),
	          style: headStyle
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)({ dn: !this.state.opened }) },
	          content.body
	        )
	      );
	    }
	  }]);
	  return ExpandableBlock;
	}(_react.PureComponent), _class3.propTypes = {
	  className: _propTypes2.default.string,
	  content: _propTypes2.default.shape({
	    head: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string]).isRequired,
	    body: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string])
	  }),
	  icon: _propTypes2.default.string,
	  opened: _propTypes2.default.bool,
	  locked: _propTypes2.default.bool,
	  large: _propTypes2.default.bool,
	  hasCustomMarker: _propTypes2.default.bool,
	  headStyle: _propTypes2.default.object
	}, _class3.defaultProps = {
	  opened: true
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'toggle', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggle'), _class2.prototype)), _class2)) || _class);
	exports.default = ExpandableBlock;

/***/ }),
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formatAmount = __webpack_require__(434);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _DicountForm = __webpack_require__(3309);
	
	var _DicountForm2 = _interopRequireDefault(_DicountForm);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3307);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tScope = 'appointment.payment';
	
	function AppointmentPaymentForm(_ref) {
	  var couponPending = _ref.couponPending,
	      discount = _ref.discount,
	      couponErrors = _ref.couponErrors,
	      calculateDiscount = _ref.calculateDiscount,
	      startPayment = _ref.startPayment,
	      clear = _ref.clear,
	      onBack = _ref.onBack,
	      formatMessage = _ref.formatMessage,
	      paymentPending = _ref.paymentPending,
	      couponVerification = _ref.couponVerification,
	      couponVerificationPending = _ref.couponVerificationPending,
	      _ref$appointment = _ref.appointment,
	      copay = _ref$appointment.copay,
	      id = _ref$appointment.id;
	
	  var loading = paymentPending || couponPending;
	
	  var handlePayment = function handlePayment() {
	    return startPayment({ id: id });
	  };
	
	  var isNotCouponAllowed = couponVerification && !couponVerification.couponsAvailable && !couponVerification.automaticCouponAvailable;
	
	  (0, _react.useEffect)(function () {
	    return clear;
	  }, []);
	
	  var freePayment = (0, _react.useMemo)(function () {
	    return discount && discount.discountAmountPercent === 100;
	  }, [discount]);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    if (!discount) {
	      return {
	        basePrice: copay,
	        discountPrice: (0, _formatAmount.formatAmount)(0),
	        totalPrice: copay
	      };
	    }
	
	    var initialAmount = discount.initialAmount,
	        amount = discount.amount,
	        discountAmountPercent = discount.discountAmountPercent;
	
	    var discountAmount = (0, _formatAmount.formatAmount)(initialAmount - amount);
	    var roundDiscountPercent = Math.round(discountAmountPercent);
	
	    return {
	      basePrice: copay,
	      discountPrice: discountAmount + ' (' + roundDiscountPercent + '%)',
	      totalPrice: amount
	    };
	  }, [copay, discount]),
	      basePrice = _useMemo.basePrice,
	      discountPrice = _useMemo.discountPrice,
	      totalPrice = _useMemo.totalPrice;
	
	  var handleDiscountApply = function handleDiscountApply(coupon) {
	    calculateDiscount({ coupon: coupon, appointmentId: id });
	  };
	
	  var paymentBtnText = freePayment ? 'common.next' : 'appointment.actions.payForVisit';
	
	  if (couponVerificationPending) {
	    return _react2.default.createElement(_Loader2.default, null);
	  }
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    onBack && _react2.default.createElement(
	      _Shape2.default,
	      { styleName: 'PaymentHeader' },
	      _react2.default.createElement(_BackButton2.default, {
	        title: { id: tScope + '.title' },
	        minWidth: 0,
	        onBack: onBack
	      })
	    ),
	    _react2.default.createElement(
	      _Shape2.default,
	      { styleName: 'Payment' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'fadeout' },
	        _react2.default.createElement(
	          'div',
	          {
	            styleName: isNotCouponAllowed ? 'PaymentContentFullWidth' : 'PaymentContent'
	          },
	          isNotCouponAllowed ? '' : _react2.default.createElement(_DicountForm2.default, {
	            formatMessage: formatMessage,
	            onApply: handleDiscountApply,
	            serverErrors: couponErrors,
	            loading: loading
	          }),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'PaymentInfo' },
	            _react2.default.createElement(
	              'div',
	              { styleName: 'PaymentRow' },
	              _react2.default.createElement(
	                'span',
	                null,
	                formatMessage({
	                  id: isNotCouponAllowed ? tScope + '.copay' : tScope + '.basePrice'
	                })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                '$',
	                (0, _formatAmount.formatAmount)(basePrice)
	              )
	            ),
	            isNotCouponAllowed ? '' : _react2.default.createElement(
	              'div',
	              { styleName: 'PaymentRow' },
	              _react2.default.createElement(
	                'span',
	                null,
	                formatMessage({ id: tScope + '.discount' })
	              ),
	              _react2.default.createElement(
	                'span',
	                { styleName: (0, _classnames2.default)({ bold: !!discountPrice }) },
	                '$',
	                discountPrice
	              )
	            ),
	            _react2.default.createElement('div', { styleName: 'PaymentSeparator' }),
	            _react2.default.createElement(
	              'div',
	              { styleName: 'PaymentRow blue bold' },
	              _react2.default.createElement(
	                'span',
	                null,
	                formatMessage({ id: tScope + '.total' })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                '$',
	                (0, _formatAmount.formatAmount)(totalPrice)
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'PaymentBtn' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              onClick: handlePayment,
	              disabled: loading,
	              color: 'primary',
	              raised: true
	            },
	            formatMessage({ id: paymentBtnText })
	          )
	        )
	      )
	    )
	  );
	}
	
	AppointmentPaymentForm.propTypes = {
	  onBack: PropTypes.func,
	  appointment: PropTypes.object,
	  formatMessage: PropTypes.func,
	  startPayment: PropTypes.func,
	  couponPending: PropTypes.bool,
	  paymentPending: PropTypes.bool,
	  discount: PropTypes.object,
	  couponErrors: PropTypes.object,
	  clear: PropTypes.func,
	  calculateDiscount: PropTypes.func,
	  couponVerification: PropTypes.object,
	  couponVerificationPending: PropTypes.bool
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentPaymentForm);

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _confirmVisitByPatientReq = __webpack_require__(666);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConfirmVisitByPatientBtn(_ref) {
	  var userId = _ref.userId,
	      appointmentId = _ref.appointmentId,
	      type = _ref.type,
	      disabled = _ref.disabled;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handleConfirmVisitByPatient = function handleConfirmVisitByPatient(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    dispatch(_confirmVisitByPatientReq.actions.init({
	      userId: userId,
	      appointmentId: appointmentId
	    }));
	  };
	
	  return _react2.default.createElement(
	    _Button2.default,
	    {
	      styleName: (0, _classnames2.default)('video-btn', type, { disabled: disabled }),
	      onClick: handleConfirmVisitByPatient,
	      color: type,
	      border: true
	    },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appointment.list.card.confirm' })
	  );
	}
	
	ConfirmVisitByPatientBtn.propTypes = {
	  userId: PropTypes.number,
	  appointmentId: PropTypes.number,
	  type: PropTypes.string,
	  disabled: PropTypes.bool
	};
	
	ConfirmVisitByPatientBtn.defaultProps = {
	  type: 'accent'
	};
	
	exports.default = ConfirmVisitByPatientBtn;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _appointment = __webpack_require__(286);
	
	var _IconButton = __webpack_require__(605);
	
	var _styles = __webpack_require__(18);
	
	var _InfoPopover = __webpack_require__(773);
	
	var _InfoPopover2 = _interopRequireDefault(_InfoPopover);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TransactionInfo(_ref) {
	  var appointment = _ref.appointment,
	      formatMessage = _ref.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isOpened = _useState2[0],
	      toggleTooltip = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      anchor = _useState4[0],
	      setAnchor = _useState4[1];
	
	  var handleOpenTransactionInfo = function handleOpenTransactionInfo(e) {
	    setAnchor(e.currentTarget);
	    toggleTooltip(true);
	  };
	
	  var list = (0, _react.useMemo)(function () {
	    return (0, _appointment.getTransactionInfo)(formatMessage, appointment);
	  }, [appointment]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_IconButton.IconButton, {
	      size: 20,
	      className: 'ml2 dib',
	      name: 'info-default',
	      fill: _styles.COLORS.blueDark,
	      onClick: handleOpenTransactionInfo
	    }),
	    _react2.default.createElement(_InfoPopover2.default, {
	      onClose: function onClose() {
	        return toggleTooltip(false);
	      },
	      isOpen: isOpened,
	      anchorEl: anchor,
	      list: list
	    })
	  );
	}
	
	TransactionInfo.propTypes = {
	  appointment: PropTypes.object,
	  formatMessage: PropTypes.func
	};
	
	exports.default = TransactionInfo;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ConsentRenderView = __webpack_require__(3344);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConsentFormsList = function ConsentFormsList(_ref) {
	  var allConsents = _ref.allConsents,
	      dateTime = _ref.dateTime,
	      organizationName = _ref.organizationName,
	      patientUserInfoId = _ref.patientUserInfoId,
	      serviceName = _ref.serviceName,
	      title = _ref.title;
	
	  var isConsentListEmpty = !allConsents.length;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var consentVersion = formatMessage({
	    id: 'appointment.consent.consentVersion'
	  });
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    title,
	    isConsentListEmpty ? _react2.default.createElement(
	      'div',
	      null,
	      _strings.DEFAULT_EMPTY_VALUE
	    ) : allConsents.map(function (consent) {
	      var id = consent.id,
	          name = consent.name,
	          fileUrl = consent.fileUrl,
	          accepted = consent.accepted,
	          version = consent.version,
	          consentType = consent.consentType;
	
	
	      return _react2.default.createElement(_ConsentRenderView.ConsentRenderView, {
	        id: id,
	        accepted: accepted,
	        fileUrl: fileUrl,
	        allConsents: allConsents,
	        currentConsent: consent,
	        name: name,
	        version: version,
	        key: id,
	        consentType: consentType,
	        formatMessage: formatMessage,
	        organizationName: organizationName,
	        serviceName: serviceName,
	        startTime: dateTime,
	        consentVersionTitle: consentVersion,
	        patientUserInfoId: patientUserInfoId
	      });
	    })
	  );
	};
	
	ConsentFormsList.propTypes = {
	  allConsents: _propTypes2.default.array.isRequired,
	  dateTime: _propTypes2.default.string,
	  organizationName: _propTypes2.default.string,
	  patientUserInfoId: _propTypes2.default.number,
	  serviceName: _propTypes2.default.string,
	  title: _propTypes2.default.node
	};
	
	exports.default = (0, _react.memo)(ConsentFormsList);

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VisitConsents = VisitConsents;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _ConsentFormsList = __webpack_require__(1124);
	
	var _ConsentFormsList2 = _interopRequireDefault(_ConsentFormsList);
	
	var _useInfoConsentWithAppointments = __webpack_require__(1126);
	
	var _index = __webpack_require__(2249);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VisitConsents(_ref) {
	  var noTitle = _ref.noTitle,
	      appointment = _ref.appointment,
	      formatMessage = _ref.formatMessage,
	      providerContext = _ref.providerContext;
	
	  var titleConsentForms = formatMessage({
	    id: 'appointment.consent.title'
	  });
	
	  var _useInfoConsentWithAp = (0, _useInfoConsentWithAppointments.useInfoConsentWithAppointments)(providerContext, appointment),
	      serviceName = _useInfoConsentWithAp.serviceName,
	      organizationName = _useInfoConsentWithAp.organizationName,
	      dateTime = _useInfoConsentWithAp.dateTime,
	      allConsents = _useInfoConsentWithAp.allConsents,
	      patientUserInfoId = _useInfoConsentWithAp.patientUserInfoId;
	
	  var title = (0, _react.useMemo)(function () {
	    if (noTitle) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: _index2.default.visitConsentsHeader },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.visitConsentsTitle },
	        titleConsentForms
	      )
	    );
	  }, [noTitle, titleConsentForms]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(_ConsentFormsList2.default, {
	      title: title,
	      serviceName: serviceName,
	      organizationName: organizationName,
	      dateTime: dateTime,
	      allConsents: allConsents,
	      patientUserInfoId: patientUserInfoId
	    })
	  );
	}
	
	VisitConsents.propTypes = {
	  formatMessage: PropTypes.func,
	  appointment: PropTypes.object,
	  providerContext: PropTypes.bool,
	  noTitle: PropTypes.bool
	};

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useInfoConsentWithAppointments = useInfoConsentWithAppointments;
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(493);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useInfoConsentWithAppointments(isProviderContext, appointment) {
	  var userId = appointment.userId,
	      service = appointment.service,
	      dateTime = appointment.dateTime,
	      providerInfo = appointment.providerInfo,
	      requiredSurveys = appointment.requiredSurveys,
	      consentsAssignment = appointment.consentsAssignment,
	      _appointment$surveyAs = appointment.surveyAssignments,
	      surveyAssignments = _appointment$surveyAs === undefined ? [] : _appointment$surveyAs;
	
	
	  var serviceName = service ? service.name : '';
	
	  var isAllSignedConsents = consentsAssignment ? consentsAssignment.allSigned : true;
	
	  var allConsents = consentsAssignment && consentsAssignment.consents ? consentsAssignment.consents : [];
	  var notSignedConsent = allConsents.filter(function (item) {
	    return !item.accepted;
	  });
	
	  var notSignedPreVisits = surveyAssignments.filter(function (form) {
	    return ![_constants.STATUS_SURVEY.COMPLETED, _constants.STATUS_SURVEY.EXPIRED].includes(form.status) && !!form.survey.required;
	  });
	
	  var organizationName = isProviderContext ? '' : (0, _get2.default)(providerInfo, 'organization.name', '');
	
	  return (0, _react.useMemo)(function () {
	    return {
	      dateTime: dateTime,
	      allConsents: allConsents,
	      serviceName: serviceName,
	      organizationName: organizationName,
	      notSignedPreVisits: notSignedPreVisits,
	      isAllSignedConsents: isAllSignedConsents,
	      patientUserInfoId: userId,
	      notSignedConsent: notSignedConsent[0],
	      isRequiredPreVisitForms: requiredSurveys
	    };
	  }, [userId, dateTime, allConsents, serviceName, requiredSurveys, notSignedConsent, organizationName, notSignedPreVisits, isAllSignedConsents]);
	}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleNumberOfCount = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleNumberOfCount = exports.handleNumberOfCount = function handleNumberOfCount(allConsents, id) {
	  var allAppointmentConsentLength = allConsents.length;
	  var currentIndexConsent = allConsents.findIndex(function (item) {
	    return item.id === id;
	  });
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'span',
	      null,
	      currentIndexConsent + 1
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      '/',
	      allAppointmentConsentLength
	    )
	  );
	};

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderConsentHeader = renderConsentHeader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(721);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderConsentHeader(formatMessage, titleTypeConsent, organizationName, serviceName, dateConsent, mainConsent, mainTitle) {
	  var fullTitleService = formatMessage({
	    id: 'appointment.consent.consentFor'
	  }, { organizationName: organizationName, serviceName: serviceName });
	  return mainConsent ? _react2.default.createElement(
	    'div',
	    { className: _index2.default.consentMainTitle },
	    mainTitle
	  ) : _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.headerLeftSide },
	      _react2.default.createElement(_Icon2.default, { name: 'icon-consent', size: 36, className: _index2.default.icon }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.consentDetails },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.consentType },
	          titleTypeConsent
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.consentService },
	          fullTitleService
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.dateConsent },
	          dateConsent
	        )
	      )
	    )
	  );
	}

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useCareUsers = useCareUsers;
	
	var _reactRedux = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(237);
	
	var _selectors3 = __webpack_require__(56);
	
	var _selectors4 = __webpack_require__(88);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function userFormatter() {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return list.map(function (item) {
	    return (0, _extends3.default)({}, item.dependent, {
	      status: item.status
	    });
	  });
	}
	
	function useCareUsers(withVerifiedUser) {
	  var isProvider = (0, _reactRedux.useSelector)(_selectors.hasProviderProfileSelector);
	  var isTeam = (0, _reactRedux.useSelector)(_selectors.selectIsLoggedTeam);
	  var loggedUser = (0, _reactRedux.useSelector)(_selectors.loggedUserSelector);
	  var caregiverCircle = (0, _reactRedux.useSelector)(_selectors2.selectCaregiverCircleList);
	  var practiceProviders = (0, _reactRedux.useSelector)(_selectors4.selectPracticeProviders);
	  var guardianCircle = userFormatter((0, _reactRedux.useSelector)(_selectors3.selectGuardianDependentsList));
	
	  var safeCaregiverCircle = withVerifiedUser ? caregiverCircle.filter(function (_ref) {
	    var status = _ref.status;
	    return status === _constants.STATUS_DEPENDENT_VERIFIED;
	  }) : caregiverCircle;
	
	  var safeGuardianCircle = withVerifiedUser ? guardianCircle.filter(function (_ref2) {
	    var status = _ref2.status;
	    return status === _constants.STATUS_DEPENDENT_VERIFIED;
	  }) : guardianCircle;
	
	  var makeNavList = (0, _react.useCallback)(function (formatMessage) {
	    var list = isTeam ? [] : [{ title: '', list: [loggedUser], key: 'loggedUser' }];
	
	    if (isProvider) {
	      var providerList = practiceProviders.map(function (item) {
	        return (0, _extends3.default)({}, item, {
	          calendarManageable: true
	        });
	      });
	
	      if (!(0, _isEmpty2.default)(providerList)) {
	        list.push({
	          title: formatMessage({ id: 'healthboard.providersNavTitle' }),
	          list: providerList,
	          key: 'providerCircle'
	        });
	      }
	
	      return list;
	    }
	
	    if (!(0, _isEmpty2.default)(safeGuardianCircle)) {
	      list.push({
	        title: formatMessage({ id: 'circles.titles.guardianFor' }),
	        list: safeGuardianCircle,
	        key: 'guardianCircle'
	      });
	    }
	
	    if (!(0, _isEmpty2.default)(safeCaregiverCircle)) {
	      list.push({
	        title: formatMessage({ id: 'circles.titles.listCaregiver' }),
	        list: safeCaregiverCircle,
	        key: 'caregiverCircle'
	      });
	    }
	
	    return list;
	  }, [loggedUser, caregiverCircle, guardianCircle, isProvider, practiceProviders, isTeam, withVerifiedUser]);
	
	  var getTargetUser = (0, _react.useCallback)(function (userId) {
	    return [loggedUser].concat((0, _toConsumableArray3.default)(caregiverCircle), (0, _toConsumableArray3.default)(guardianCircle)).find(function (_ref3) {
	      var id = _ref3.id;
	      return userId === id;
	    });
	  }, [loggedUser, caregiverCircle, guardianCircle]);
	
	  return {
	    getTargetUser: getTargetUser,
	    makeNavList: makeNavList,
	    isTeam: isTeam
	  };
	}

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ImageUploader = __webpack_require__(1185);
	
	var _ImageUploader2 = _interopRequireDefault(_ImageUploader);
	
	var _strings = __webpack_require__(15);
	
	var _utils = __webpack_require__(1131);
	
	var _constants = __webpack_require__(17);
	
	var _index = __webpack_require__(5005);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InsuranceCardsSection = function InsuranceCardsSection(_ref) {
	  var fields = _ref.fields,
	      flowType = _ref.flowType,
	      isAdditionalInsurance = _ref.isAdditionalInsurance,
	      skipInsurance = _ref.skipInsurance,
	      title = _ref.title;
	
	  var isPaperworkFlowType = (0, _utils.checkIsPaperworkFlow)(flowType);
	
	  var showEmptyDefaultValue = (0, _react.useMemo)(function () {
	    if (fields.some(function (item) {
	      return item.fieldName === _constants.DOCUMENTATION_TYPES.DRIVER_LICENCE;
	    })) {
	      return !fields.some(function (item) {
	        return item.src;
	      });
	    }
	
	    return isPaperworkFlowType && skipInsurance && !isAdditionalInsurance;
	  }, [isPaperworkFlowType, skipInsurance, isAdditionalInsurance, fields]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        title
	      ),
	      showEmptyDefaultValue && _react2.default.createElement(
	        'div',
	        { className: _index2.default.empty },
	        _strings.DEFAULT_EMPTY_VALUE
	      ),
	      !showEmptyDefaultValue && _react2.default.createElement(
	        'div',
	        { className: _index2.default.images },
	        fields.map(function (field) {
	          return _react2.default.createElement(_ImageUploader2.default, (0, _extends3.default)({}, field, {
	            name: field.fieldName,
	            disabled: true,
	            key: field.fieldName
	          }));
	        })
	      )
	    )
	  );
	};
	
	InsuranceCardsSection.propTypes = {
	  fields: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  flowType: _propTypes2.default.string,
	  isAdditionalInsurance: _propTypes2.default.bool,
	  skipInsurance: _propTypes2.default.bool,
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _react.memo)(InsuranceCardsSection);

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasPrimarySubscriberData = exports.checkIsPaperworkFlow = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkIsPaperworkFlow = exports.checkIsPaperworkFlow = function checkIsPaperworkFlow(flowType) {
	  return _insuranceFlowType.INSURANCE_FLOW_TYPE.PAPERWORK === flowType;
	};
	
	var hasPrimarySubscriberData = exports.hasPrimarySubscriberData = function hasPrimarySubscriberData(primarySubscriber) {
	  return primarySubscriber && Boolean((0, _keys2.default)(primarySubscriber).length);
	};

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ResendButton = __webpack_require__(3410);
	
	var _ResendButton2 = _interopRequireDefault(_ResendButton);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _index = __webpack_require__(5017);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CODE_MAX_LENGTH = 6;
	
	var MfaDialog = function MfaDialog(_ref) {
	  var counterValue = _ref.counterValue,
	      error = _ref.error,
	      errorText = _ref.errorText,
	      intl = _ref.intl,
	      loading = _ref.loading,
	      mfaData = _ref.mfaData,
	      onClose = _ref.onClose,
	      onResend = _ref.onResend,
	      onSubmit = _ref.onSubmit,
	      open = _ref.open,
	      title = _ref.title,
	      withContentText = _ref.withContentText;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      code = _useState2[0],
	      setCode = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      prevSubmittedCode = _useState4[0],
	      setPrevSubmittedCode = _useState4[1];
	
	  var formatMessage = intl.formatMessage;
	
	
	  var contentText = (0, _react.useMemo)(function () {
	    if (!mfaData) return '';
	
	    var email = mfaData.email,
	        phoneNumber = mfaData.phoneNumber;
	
	    if (email && phoneNumber) {
	      return formatMessage({ id: 'mfa.dialog.phoneAndEmailConfirmation' }, { phone: phoneNumber, email: email });
	    } else if (email) {
	      return formatMessage({ id: 'mfa.dialog.emailConfirmation' }, { email: email });
	    } else if (phoneNumber) {
	      return formatMessage({ id: 'mfa.dialog.phoneConfirmation' }, { phone: phoneNumber });
	    }
	  }, [mfaData]);
	
	  var handleSubmit = function handleSubmit() {
	    setPrevSubmittedCode(code);
	    onSubmit(code);
	  };
	
	  var handleResend = function handleResend() {
	    if (onResend) {
	      onResend();
	    }
	  };
	
	  var disableVerifyButton = prevSubmittedCode && prevSubmittedCode === code;
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    { opened: open, withHeading: false, mobileFullScreen: false },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.modalWrapper },
	      _react2.default.createElement(
	        'h1',
	        { className: _index2.default.title },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.contentText },
	        withContentText || contentText
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _index2.default.marginZero, error)) },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.label },
	          formatMessage({ id: 'mfa.dialog.input.label' })
	        ),
	        _react2.default.createElement(_TextInput2.default, {
	          type: 'number',
	          placeholder: formatMessage({ id: 'mfa.dialog.input.label' }),
	          value: code,
	          onChange: setCode,
	          limit: CODE_MAX_LENGTH,
	          disabled: loading
	        })
	      ),
	      error ? _react2.default.createElement(_ErrorBlock2.default, {
	        className: _index2.default.errorBlock,
	        errors: formatMessage({
	          id: errorText || 'mfa.dialog.error.message'
	        })
	      }) : null,
	      _react2.default.createElement(_ResendButton2.default, { onResend: handleResend, counterValue: counterValue }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.actions },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            onClick: handleSubmit,
	            disabled: code.length !== CODE_MAX_LENGTH || loading || disableVerifyButton,
	            className: _index2.default.submitButton,
	            color: 'primary',
	            raised: true
	          },
	          formatMessage({ id: 'mfa.dialog.button.verify' })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'accent', raised: true, onClick: onClose, disabled: loading },
	          formatMessage({ id: 'common.cancel' })
	        )
	      )
	    )
	  );
	};
	
	MfaDialog.propTypes = {
	  counterValue: _propTypes2.default.number,
	  error: _propTypes2.default.bool,
	  errorText: _propTypes2.default.string,
	  intl: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  mfaData: _propTypes2.default.object,
	  onClose: _propTypes2.default.func,
	  onResend: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  withContentText: _propTypes2.default.string
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MfaDialog);

/***/ }),
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _constants = __webpack_require__(17);
	
	var _selectors = __webpack_require__(56);
	
	var _getDocumentsConfig = __webpack_require__(907);
	
	var DRIVER_LICENSE_CARD_KEYS = [_constants.DOCUMENTATION_TYPES.DRIVER_LICENCE];
	
	var INSURANCE_CARD_KEYS = [_constants.DOCUMENTATION_TYPES.CARD_1, _constants.DOCUMENTATION_TYPES.CARD_2];
	
	var useUserDocuments = function useUserDocuments(_ref) {
	  var _ref$isEditMode = _ref.isEditMode,
	      isEditMode = _ref$isEditMode === undefined ? true : _ref$isEditMode;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var documents = (0, _reactRedux.useSelector)(_selectors.selectUserDocumentsList);
	
	  var isDocumentsFetching = (0, _reactRedux.useSelector)(_selectors.selectUserDocumentsLoading);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return documents.reduce(function (acc, doc) {
	      var _ref2 = doc || {},
	          key = _ref2.key;
	
	      if (INSURANCE_CARD_KEYS.includes(key)) {
	        acc.insuranceDocuments.push(doc);
	      }
	
	      if (DRIVER_LICENSE_CARD_KEYS.includes(key)) {
	        acc.driverLicenseDocuments.push(doc);
	      }
	
	      return acc;
	    }, { insuranceDocuments: [], driverLicenseDocuments: [] });
	  }, [documents]),
	      insuranceDocuments = _useMemo.insuranceDocuments,
	      driverLicenseDocuments = _useMemo.driverLicenseDocuments;
	
	  var configParams = (0, _react.useMemo)(function () {
	    return {
	      isEditMode: isEditMode,
	      userDocuments: documents,
	      formatMessage: formatMessage
	    };
	  }, [documents, formatMessage, isEditMode]);
	
	  var insuranceDocumentsConfig = (0, _react.useMemo)(function () {
	    return (0, _getDocumentsConfig.getInsuranceCardDocumentsConfig)(configParams);
	  }, [configParams]);
	
	  var driverLicenseDocumentsConfig = (0, _react.useMemo)(function () {
	    return (0, _getDocumentsConfig.getDriverLicenseDocumentConfig)(configParams);
	  }, [configParams]);
	
	  return {
	    documents: documents,
	    driverLicenseDocuments: driverLicenseDocuments,
	    driverLicenseDocumentsConfig: driverLicenseDocumentsConfig,
	    insuranceDocuments: insuranceDocuments,
	    insuranceDocumentsConfig: insuranceDocumentsConfig,
	    isDocumentsFetching: isDocumentsFetching
	  };
	};
	
	exports.default = useUserDocuments;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useActionFilters = useActionFilters;
	
	var _react = __webpack_require__(1);
	
	var _stepsMeasurementsReq = __webpack_require__(1353);
	
	var stepsMeasurement = _interopRequireWildcard(_stepsMeasurementsReq);
	
	var _stepsMeasurementsModalReq = __webpack_require__(1352);
	
	var stepsMeasurementModal = _interopRequireWildcard(_stepsMeasurementsModalReq);
	
	var _distanceMeasurementsReq = __webpack_require__(1340);
	
	var distanceMeasurement = _interopRequireWildcard(_distanceMeasurementsReq);
	
	var _distanceMeasurementsModalReq = __webpack_require__(1339);
	
	var distanceMeasurementModal = _interopRequireWildcard(_distanceMeasurementsModalReq);
	
	var _bmiMeasurementsReq = __webpack_require__(882);
	
	var bmiMeasurement = _interopRequireWildcard(_bmiMeasurementsReq);
	
	var _bmiMeasurementsModalReq = __webpack_require__(1333);
	
	var bmiMeasurementSingleDayModal = _interopRequireWildcard(_bmiMeasurementsModalReq);
	
	var _weightMeasurementsReq = __webpack_require__(888);
	
	var weightMeasurement = _interopRequireWildcard(_weightMeasurementsReq);
	
	var _weightMeasurementsModalReq = __webpack_require__(1354);
	
	var weightMeasurementModal = _interopRequireWildcard(_weightMeasurementsModalReq);
	
	var _heightMeasurementsReq = __webpack_require__(1344);
	
	var heightMeasurement = _interopRequireWildcard(_heightMeasurementsReq);
	
	var _heightMeasurementsModalReq = __webpack_require__(1343);
	
	var heightMeasurementModal = _interopRequireWildcard(_heightMeasurementsModalReq);
	
	var _saturationMeasurementsReq = __webpack_require__(1349);
	
	var saturationMeasurement = _interopRequireWildcard(_saturationMeasurementsReq);
	
	var _saturationMeasurementsModalReq = __webpack_require__(1348);
	
	var saturationMeasurementModal = _interopRequireWildcard(_saturationMeasurementsModalReq);
	
	var _heartRateMeasurementsReq = __webpack_require__(1342);
	
	var heartRateMeasurement = _interopRequireWildcard(_heartRateMeasurementsReq);
	
	var _heartRateMeasurementsModalReq = __webpack_require__(1341);
	
	var heartRateMeasurementModal = _interopRequireWildcard(_heartRateMeasurementsModalReq);
	
	var _bloodPressureMeasurementsReq = __webpack_require__(881);
	
	var bloodPressureMeasurement = _interopRequireWildcard(_bloodPressureMeasurementsReq);
	
	var _respiratoryRateMeasurementsReq = __webpack_require__(886);
	
	var respiratoryRateMeasurement = _interopRequireWildcard(_respiratoryRateMeasurementsReq);
	
	var _bloodGlucoseMeasurementsModalReq = __webpack_require__(1330);
	
	var bloodGlucoseMeasurementModal = _interopRequireWildcard(_bloodGlucoseMeasurementsModalReq);
	
	var _bloodGlucoseMeasurementsReq = __webpack_require__(1331);
	
	var bloodGlucoseMeasurement = _interopRequireWildcard(_bloodGlucoseMeasurementsReq);
	
	var _constants = __webpack_require__(54);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var HEART_RATE = _constants.VITALS_ACTIVITY_TYPE.HEART_RATE,
	    DISTANCE = _constants.VITALS_ACTIVITY_TYPE.DISTANCE,
	    STEPS = _constants.VITALS_ACTIVITY_TYPE.STEPS,
	    SATURATION = _constants.VITALS_ACTIVITY_TYPE.SATURATION,
	    BMI = _constants.VITALS_ACTIVITY_TYPE.BMI,
	    WEIGHT = _constants.VITALS_ACTIVITY_TYPE.WEIGHT,
	    HEIGHT = _constants.VITALS_ACTIVITY_TYPE.HEIGHT,
	    BLOOD_PRESSURE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE,
	    RESPIRATORY_RATE = _constants.VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE,
	    BLOOD_GLUCOSE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE;
	function useActionFilters(type) {
	  var singleDayMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var getDataByType = (0, _react.useMemo)(function () {
	    return function () {
	      switch (type) {
	        case STEPS:
	          return {
	            clear: singleDayMode ? stepsMeasurementModal.actions.clear : stepsMeasurement.actions.clear,
	            action: singleDayMode ? stepsMeasurementModal.actions.send : stepsMeasurement.actions.send
	          };
	        case DISTANCE:
	          return {
	            clear: singleDayMode ? distanceMeasurementModal.actions.clear : distanceMeasurement.actions.clear,
	            action: singleDayMode ? distanceMeasurementModal.actions.send : distanceMeasurement.actions.send
	          };
	        case BMI:
	          return {
	            clear: singleDayMode ? bmiMeasurementSingleDayModal.actions.clear : bmiMeasurement.actions.clear,
	            action: singleDayMode ? bmiMeasurementSingleDayModal.actions.send : bmiMeasurement.actions.send
	          };
	        case WEIGHT:
	          return {
	            clear: singleDayMode ? weightMeasurementModal.actions.clear : weightMeasurement.actions.clear,
	            action: singleDayMode ? weightMeasurementModal.actions.send : weightMeasurement.actions.send
	          };
	        case HEIGHT:
	          return {
	            clear: singleDayMode ? heightMeasurementModal.actions.clear : heightMeasurement.actions.clear,
	            action: singleDayMode ? heightMeasurementModal.actions.send : heightMeasurement.actions.send
	          };
	        case SATURATION:
	          return {
	            clear: singleDayMode ? saturationMeasurementModal.actions.clear : saturationMeasurement.actions.clear,
	            action: singleDayMode ? saturationMeasurementModal.actions.send : saturationMeasurement.actions.send
	          };
	        case HEART_RATE:
	          return {
	            clear: singleDayMode ? heartRateMeasurementModal.actions.clear : heartRateMeasurement.actions.clear,
	            action: singleDayMode ? heartRateMeasurementModal.actions.send : heartRateMeasurement.actions.send
	          };
	        case BLOOD_PRESSURE:
	          return {
	            clear: bloodPressureMeasurement.actions.clear,
	            action: bloodPressureMeasurement.actions.send
	          };
	        case RESPIRATORY_RATE:
	          return {
	            clear: respiratoryRateMeasurement.actions.clear,
	            action: respiratoryRateMeasurement.actions.send
	          };
	        case BLOOD_GLUCOSE:
	          return {
	            clear: singleDayMode ? bloodGlucoseMeasurementModal.actions.clear : bloodGlucoseMeasurement.actions.clear,
	            action: singleDayMode ? bloodGlucoseMeasurementModal.actions.send : bloodGlucoseMeasurement.actions.send
	          };
	        default:
	          return {
	            clear: stepsMeasurement.actions.clear,
	            action: stepsMeasurement.actions.send
	          };
	      }
	    };
	  }, [type, singleDayMode]);
	
	  return getDataByType();
	}

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _selectors = __webpack_require__(23);
	
	var _historicMeasurementsReq = __webpack_require__(428);
	
	var historicMeasurements = _interopRequireWildcard(_historicMeasurementsReq);
	
	var _singleDayGrafModal = __webpack_require__(1350);
	
	var _constants = __webpack_require__(54);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(5042);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _selectors2 = __webpack_require__(109);
	
	var _hooks = __webpack_require__(144);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DataHistoricList(_ref) {
	  var formatMessage = _ref.formatMessage,
	      data = _ref.data,
	      type = _ref.type,
	      pending = _ref.pending,
	      userId = _ref.userId,
	      isWeightInKg = _ref.isWeightInKg,
	      isHeightInMeters = _ref.isHeightInMeters,
	      _ref$allValuesForOneD = _ref.allValuesForOneDay,
	      allValuesForOneDay = _ref$allValuesForOneD === undefined ? false : _ref$allValuesForOneD,
	      calendarFormatTime = _ref.calendarFormatTime,
	      mainUSer = _ref.mainUSer,
	      isMilligramsPerDeciliter = _ref.isMilligramsPerDeciliter;
	
	  var historicData = (0, _utils.adaptHistoricResponse)((0, _reactRedux.useSelector)(_selectors2.selectHistoricMeasurementsList));
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  var previousDate = (0, _reactRedux.useSelector)(_selectors2.selectHistoricMeasurementsPreviousDate);
	
	  var historicPending = (0, _reactRedux.useSelector)(_selectors2.selectHistoricMeasurementsListPending);
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var targetUserFirstName = (0, _get2.default)((0, _reactRedux.useSelector)(_selectors.targetUserSelector), 'firstName', '');
	
	  var safeData = data || (0, _utils.concatDataHistoricValue)(historicData, type);
	  var safePending = pending || historicPending;
	
	  var safeFormatCalendar = calendarFormatTime || _constants.HISTORIC_ONE_DAY_CALENDAR_TYPE;
	
	  var isNotHeightData = type !== _constants.VITALS_ACTIVITY_TYPE.HEIGHT;
	
	  var handleLoadMoreClick = function handleLoadMoreClick() {
	    dispatch(historicMeasurements.actions.send({
	      typeMeasurements: type,
	      periodStartDate: previousDate,
	      userId: userId
	    }));
	  };
	
	  var handleClickCard = function handleClickCard(date) {
	    if (isNotHeightData) {
	      dispatch(_singleDayGrafModal.singleDayGrafModalActions.open({
	        type: type,
	        baseDate: date,
	        dataList: [],
	        singleDayMode: true
	      }));
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.rootWrapperForOneDay, allValuesForOneDay))
	    },
	    !allValuesForOneDay && type && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        formatMessage({
	          id: 'patient.healthboard.titleHistoric.' + type
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.dataDescription },
	        (0, _utils.getSafeDescriptionDataHistoricList)(type, formatMessage)
	      )
	    ),
	    safePending && safeData.length === 0 && _react2.default.createElement(_Loader2.default, null),
	    safeData.length !== 0 && type && safeData.map(function (item) {
	      var _cn2;
	
	      var _getDataListByType = (0, _utils.getDataListByType)({
	        formatMessage: formatMessage,
	        type: type,
	        item: item,
	        isWeightInKg: isWeightInKg,
	        isHeightInMeters: isHeightInMeters,
	        isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	        allValuesForOneDay: allValuesForOneDay,
	        safeFormatCalendar: safeFormatCalendar
	      }),
	          value = _getDataListByType.value,
	          metric = _getDataListByType.metric,
	          measuredAt = _getDataListByType.measuredAt,
	          rowDate = _getDataListByType.rowDate,
	          dataSource = _getDataListByType.dataSource;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.cardWrapper, (_cn2 = {}, (0, _defineProperty3.default)(_cn2, _index2.default.heightDataCard, !isNotHeightData), (0, _defineProperty3.default)(_cn2, _index2.default.cardForOneDay, allValuesForOneDay), _cn2)),
	          key: item.measuredAt,
	          onClick: function onClick() {
	            return handleClickCard(rowDate);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.valueWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.value },
	            value
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.metric },
	            metric
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.rightSideWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.date },
	            measuredAt
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.dataSource },
	            getSafeDataSourceTitle(dataSource, formatMessage, mainUSer, targetUserFirstName)
	          )
	        )
	      );
	    }),
	    safePending && safeData.length !== 0 && _react2.default.createElement(_Loader2.default, null),
	    !allValuesForOneDay && _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_index2.default.loadMore, (0, _defineProperty3.default)({}, _index2.default.disableLoadMore, safePending)),
	        onClick: function onClick() {
	          return handleLoadMoreClick();
	        }
	      },
	      formatMessage({ id: 'patient.healthboard.list.loadMore' })
	    )
	  );
	}
	
	DataHistoricList.propTypes = {
	  formatMessage: PropTypes.func,
	  data: PropTypes.array,
	  type: PropTypes.string,
	  pending: PropTypes.bool,
	  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  isWeightInKg: PropTypes.bool,
	  isMilligramsPerDeciliter: PropTypes.bool,
	  isHeightInMeters: PropTypes.bool,
	  allValuesForOneDay: PropTypes.bool,
	  calendarFormatTime: PropTypes.object,
	  mainUSer: PropTypes.bool
	};
	
	exports.default = (0, _react.memo)(DataHistoricList);

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(54);
	
	var _LabTestResultCard = __webpack_require__(1775);
	
	var _LabTestResultCard2 = _interopRequireDefault(_LabTestResultCard);
	
	var _FamilyHistoryCard = __webpack_require__(3479);
	
	var _FamilyHistoryCard2 = _interopRequireDefault(_FamilyHistoryCard);
	
	var _SocialHistoryCard = __webpack_require__(3493);
	
	var _SocialHistoryCard2 = _interopRequireDefault(_SocialHistoryCard);
	
	var _HealthRecordCard = __webpack_require__(3480);
	
	var _HealthRecordCard2 = _interopRequireDefault(_HealthRecordCard);
	
	var _ImmunizationCard = __webpack_require__(3482);
	
	var _ImmunizationCard2 = _interopRequireDefault(_ImmunizationCard);
	
	var _MedicationCard = __webpack_require__(3490);
	
	var _MedicationCard2 = _interopRequireDefault(_MedicationCard);
	
	var _ConditionCard = __webpack_require__(3477);
	
	var _ConditionCard2 = _interopRequireDefault(_ConditionCard);
	
	var _EncounterCard = __webpack_require__(3478);
	
	var _EncounterCard2 = _interopRequireDefault(_EncounterCard);
	
	var _ProcedureCard = __webpack_require__(3491);
	
	var _ProcedureCard2 = _interopRequireDefault(_ProcedureCard);
	
	var _AllergieCard = __webpack_require__(3476);
	
	var _AllergieCard2 = _interopRequireDefault(_AllergieCard);
	
	var _ActivityLog = __webpack_require__(3475);
	
	var _ActivityLog2 = _interopRequireDefault(_ActivityLog);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MEDICATIONS = _constants.TABS_PATIENT_PORTAL.MEDICATIONS,
	    ALLERGIES = _constants.TABS_PATIENT_PORTAL.ALLERGIES,
	    CONDITIONS = _constants.TABS_PATIENT_PORTAL.CONDITIONS,
	    IMMUNIZATIONS = _constants.TABS_PATIENT_PORTAL.IMMUNIZATIONS,
	    LAB_TEST_RESULT = _constants.TABS_PATIENT_PORTAL.LAB_TEST_RESULT,
	    FAMILY_HISTORY = _constants.TABS_PATIENT_PORTAL.FAMILY_HISTORY,
	    ENCOUNTERS = _constants.TABS_PATIENT_PORTAL.ENCOUNTERS,
	    SOCIAL_HISTORY = _constants.TABS_PATIENT_PORTAL.SOCIAL_HISTORY,
	    HEALTH_RECORD = _constants.TABS_PATIENT_PORTAL.HEALTH_RECORD,
	    ACTIVITY_LOG = _constants.TABS_PATIENT_PORTAL.ACTIVITY_LOG,
	    PROCEDURES = _constants.TABS_PATIENT_PORTAL.PROCEDURES;
	
	
	var Card = function Card(_ref) {
	  var entity = _ref.entity,
	      activeTab = _ref.activeTab,
	      formatMessage = _ref.formatMessage,
	      isInactive = _ref.isInactive;
	
	  var isActivityLogTab = ACTIVITY_LOG === activeTab;
	  var handleCardView = (0, _react.useMemo)(function () {
	    return function () {
	      switch (activeTab) {
	        case MEDICATIONS:
	          return _react2.default.createElement(_MedicationCard2.default, {
	            entity: entity,
	            isInactive: isInactive,
	            formatMessage: formatMessage
	          });
	        case ACTIVITY_LOG:
	          return _react2.default.createElement(_ActivityLog2.default, { entity: entity, formatMessage: formatMessage });
	        case ALLERGIES:
	          return _react2.default.createElement(_AllergieCard2.default, { entity: entity, formatMessage: formatMessage });
	        case IMMUNIZATIONS:
	          return _react2.default.createElement(_ImmunizationCard2.default, { entity: entity });
	        case CONDITIONS:
	          return _react2.default.createElement(_ConditionCard2.default, { entity: entity });
	        case LAB_TEST_RESULT:
	          return _react2.default.createElement(_LabTestResultCard2.default, { entity: entity });
	        case FAMILY_HISTORY:
	          return _react2.default.createElement(_FamilyHistoryCard2.default, { entity: entity });
	        case ENCOUNTERS:
	          return _react2.default.createElement(_EncounterCard2.default, { entity: entity, formatMessage: formatMessage });
	        case SOCIAL_HISTORY:
	          return _react2.default.createElement(_SocialHistoryCard2.default, { entity: entity });
	        case HEALTH_RECORD:
	          return _react2.default.createElement(_HealthRecordCard2.default, { entity: entity, formatMessage: formatMessage });
	        case PROCEDURES:
	          return _react2.default.createElement(_ProcedureCard2.default, { entity: entity, formatMessage: formatMessage });
	      }
	    };
	  }, [activeTab, entity]);
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.activityLogRoot, isActivityLogTab))
	    },
	    handleCardView()
	  );
	};
	
	Card.propTypes = {
	  entity: _propTypes2.default.object,
	  isInactive: _propTypes2.default.bool,
	  activeTab: _propTypes2.default.string,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = Card;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(54);
	
	var _index = __webpack_require__(1504);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyState = function EmptyState(_ref) {
	  var activeTab = _ref.activeTab,
	      withInfo = _ref.withInfo,
	      category = _ref.category,
	      formatMessage = _ref.formatMessage;
	  var HEALTH_RECORD = _constants.TABS_PATIENT_PORTAL.HEALTH_RECORD,
	      MEDICATIONS = _constants.TABS_PATIENT_PORTAL.MEDICATIONS;
	
	  var messageByType = (0, _react.useCallback)(function (type) {
	    switch (type) {
	      case HEALTH_RECORD:
	        return _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            formatMessage({
	              id: 'patient.portal.healthRecord.emptyState.nothingFound'
	            })
	          ),
	          withInfo && _react2.default.createElement(
	            'div',
	            null,
	            formatMessage({
	              id: 'patient.portal.healthRecord.emptyState.tryToChoose'
	            })
	          )
	        );
	      case MEDICATIONS:
	        {
	          if (withInfo) {
	            return _react2.default.createElement(
	              _react.Fragment,
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                formatMessage({
	                  id: 'patient.portal.data.noActiveMedications'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                formatMessage({
	                  id: 'patient.portal.data.noActiveMedications.tap'
	                })
	              )
	            );
	          }
	          return formatMessage({ id: 'patient.portal.data.emptyState' }, { type: category });
	        }
	      default:
	        return formatMessage({ id: 'patient.portal.data.emptyState' }, { type: category });
	    }
	  }, [category]);
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.emptyStateRoot },
	    _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_Icon2.default, { size: 60, name: 'search-list' }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.noDataMessage },
	        messageByType(activeTab)
	      )
	    )
	  );
	};
	
	EmptyState.propTypes = {
	  withInfo: _propTypes2.default.bool,
	  category: _propTypes2.default.string,
	  activeTab: _propTypes2.default.string,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = EmptyState;

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var optionsValues = exports.optionsValues = {
	  FIVE: '5',
	  TEN: '10',
	  ALL: 'all',
	  CUSTOM: 'custom'
	};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TYPE_CARDS = exports.EMPTY_VITALS_CARD = undefined;
	
	var _constants = __webpack_require__(54);
	
	var EMPTY_VITALS_CARD = exports.EMPTY_VITALS_CARD = 'empty_vitals_card';
	
	var TYPE_CARDS = exports.TYPE_CARDS = [{ type: _constants.VITALS_ACTIVITY_TYPE.STEPS }, { type: _constants.VITALS_ACTIVITY_TYPE.DISTANCE }, { type: _constants.VITALS_ACTIVITY_TYPE.BMI }, { type: _constants.VITALS_ACTIVITY_TYPE.WEIGHT }, { type: _constants.VITALS_ACTIVITY_TYPE.HEIGHT }, { type: _constants.VITALS_ACTIVITY_TYPE.SATURATION }, { type: _constants.VITALS_ACTIVITY_TYPE.HEART_RATE }, { type: _constants.VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE }, { type: _constants.VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE }, { type: _constants.VITALS_ACTIVITY_TYPE.BODY_SURFACE_AREA }, { type: _constants.VITALS_ACTIVITY_TYPE.BODY_TEMPERATURE }, { type: _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE }];

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usePageRedirect = usePageRedirect;
	
	var _react = __webpack_require__(1);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactRouter = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function usePageRedirect(path, data) {
	  (0, _react.useEffect)(function () {
	    var needRedirect = data.some(function (item) {
	      return (0, _isEmpty2.default)(item);
	    });
	    if (needRedirect) _reactRouter.browserHistory.push(path);
	  }, data);
	}

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getSelectOptions = exports.getSelectOptions = function getSelectOptions(list) {
	  return list.map(function (item) {
	    return {
	      label: item,
	      value: item
	    };
	  });
	};

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _useProgramTabs = __webpack_require__(3657);
	
	Object.defineProperty(exports, 'useProgramTabs', {
	  enumerable: true,
	  get: function get() {
	    return _useProgramTabs.useProgramTabs;
	  }
	});
	
	var _useProgramConsents = __webpack_require__(3656);
	
	Object.defineProperty(exports, 'useProgramConsents', {
	  enumerable: true,
	  get: function get() {
	    return _useProgramConsents.useProgramConsents;
	  }
	});

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.viewProgramCost = viewProgramCost;
	
	var _formatAmount = __webpack_require__(434);
	
	var _programs = __webpack_require__(618);
	
	function viewProgramCost(_ref) {
	  var price = _ref.price,
	      period = _ref.period,
	      quantity = _ref.quantity,
	      recurrenceType = _ref.recurrenceType,
	      formatMessage = _ref.formatMessage;
	
	  var safePrice = parseFloat(price) || '';
	
	  switch (recurrenceType) {
	    case _programs.MEMBERSHIP_TYPE.ONE_TIME_PURCHASE:
	      {
	        // Never expires program
	        if (!quantity && period && safePrice) {
	          return '$' + (0, _formatAmount.formatAmount)(safePrice);
	        }
	        // if there is 1 period then use singular form of period word
	        if (quantity && period && safePrice) {
	          return '$' + (0, _formatAmount.formatAmount)(safePrice) + ' ' + formatMessage({
	            id: 'common.for'
	          }) + (quantity === 1 ? ' ' : ' ' + quantity + ' ') + period;
	        }
	        return '';
	      }
	    case _programs.MEMBERSHIP_TYPE.RECURRENT:
	      {
	        // if there is 1 period then use singular form of period word
	        if (quantity && period && safePrice) {
	          return '$' + (0, _formatAmount.formatAmount)(safePrice) + '/' + (quantity === 1 ? '' : quantity + ' ') + period;
	        }
	        return '';
	      }
	    default:
	      return '';
	  }
	}

/***/ }),
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenderTemporary = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(RenderTemporary, _Component);
	
	  function RenderTemporary(props) {
	    (0, _classCallCheck3.default)(this, RenderTemporary);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (RenderTemporary.__proto__ || (0, _getPrototypeOf2.default)(RenderTemporary)).call(this, props));
	
	    _this.state = {
	      rendered: _this.props.rendered || false
	    };
	
	
	    _this.timeoutId = null;
	    return _this;
	  }
	
	  (0, _createClass3.default)(RenderTemporary, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.rendered) {
	        this.setState({ rendered: true }, function () {
	          _this2.timeoutId = setTimeout(function () {
	            _this2.setState({ rendered: false }, nextProps.callback);
	          }, _this2.props.timeout);
	        });
	      } else {
	        this.setState({ rendered: false });
	        clearTimeout(this.timeoutId);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.state.rendered ? this.props.children : null;
	    }
	  }]);
	  return RenderTemporary;
	}(_react.Component), _class.propTypes = {
	  callback: _propTypes2.default.func,
	  children: _propTypes2.default.any,
	  rendered: _propTypes2.default.bool,
	  timeout: _propTypes2.default.number
	}, _class.defaultProps = {
	  timeout: 1000
	}, _temp);
	exports.default = RenderTemporary;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SSNField = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(5138);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SSNField = exports.SSNField = function SSNField(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      extraClass = _ref.extraClass,
	      formatMessage = _ref.formatMessage,
	      noMarginBottom = _ref.noMarginBottom;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    children,
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(className, _styles2.default.ssnDescription, (0, _defineProperty3.default)({}, _styles2.default.noMarginBottom, noMarginBottom), extraClass)
	      },
	      formatMessage({ id: 'profile.fields.ssnDescription' })
	    )
	  );
	};
	
	SSNField.propTypes = {
	  className: PropTypes.string,
	  extraClass: PropTypes.string,
	  formatMessage: PropTypes.func,
	  noMarginBottom: PropTypes.bool,
	  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
	};

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (question) {
	  return (0, _get2.default)(question, 'settings.name');
	}; // displayableName could be used instead

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRespondentData = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRespondentData = exports.getRespondentData = function getRespondentData(data, message) {
	  var respondent = (0, _get2.default)(data, 'respondent', null);
	  if (!respondent) return null;
	  var teamOriginalRespondent = (0, _get2.default)(data, 'originalRespondent', null);
	  var isTeamUser = !(0, _isEmpty2.default)(teamOriginalRespondent);
	  var respondentToShow = isTeamUser ? teamOriginalRespondent : respondent;
	
	  var displayableName = respondentToShow.displayableName,
	      name = respondentToShow.name,
	      _respondentToShow$ava = respondentToShow.avatar;
	  _respondentToShow$ava = _respondentToShow$ava === undefined ? {} : _respondentToShow$ava;
	  var respondentAvatar = _respondentToShow$ava.thumbMiddle,
	      role = respondentToShow.role;
	
	  var respondentName = name || displayableName;
	  var teamName = isTeamUser ? (0, _get2.default)(respondent, 'displayableName') : '';
	  var teamOrganization = isTeamUser ? (0, _get2.default)(respondent, 'organizationName') : '';
	
	  if (message) {
	    return '' + respondentName + (role ? ', ' + role : '') + ' ' + (teamName ? '(' + teamName + ')' : '');
	  }
	
	  return {
	    respondentName: respondentName,
	    respondentAvatar: respondentAvatar,
	    role: role,
	    teamName: teamName,
	    teamOrganization: teamOrganization
	  };
	};

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSortedColumns = exports.sortColumns = exports.sortByNewest = exports.getFilteredColumns = exports.makeString = exports.isTitleColumn = exports.getDate = exports.TITLE_COLUMN = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isPlainObject = __webpack_require__(248);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isNull = __webpack_require__(732);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TITLE_COLUMN = exports.TITLE_COLUMN = '';
	
	// helpers
	var getDate = exports.getDate = function getDate(answer) {
	  return new Date((0, _get2.default)(answer, 'answerDate'));
	};
	var isTitleColumn = exports.isTitleColumn = function isTitleColumn(colName) {
	  return colName === TITLE_COLUMN;
	};
	var makeString = exports.makeString = function makeString(len) {
	  var str = TITLE_COLUMN;
	
	  for (var i = 0; i < len; i++) {
	    str += ' ';
	  }
	
	  return str;
	};
	
	// filters
	var getFilteredColumns = exports.getFilteredColumns = function getFilteredColumns(cols, id) {
	  return (0, _isNull2.default)(id) ? cols : cols.filter(function (col) {
	    return isTitleColumn(col) || col.id === id;
	  });
	};
	
	// sorters
	var sortByNewest = exports.sortByNewest = function sortByNewest(a, b) {
	  return getDate(a) - getDate(b);
	};
	
	var sortColumns = exports.sortColumns = function sortColumns(a, b) {
	  if (!(0, _isPlainObject2.default)(a)) return 1;
	  if (!(0, _isPlainObject2.default)(b)) return -1;
	
	  return (0, _isPlainObject2.default)(a) && (0, _isPlainObject2.default)(b) ? sortByNewest(a, b) : 0;
	};
	
	var getSortedColumns = exports.getSortedColumns = function getSortedColumns(columns) {
	  var sortedByDate = (0, _keys2.default)(columns).map(function (key) {
	    var column = columns[key];
	
	    return column.value ? (0, _extends3.default)({}, column, { id: key }) : key;
	  }).sort(sortColumns);
	
	  var firstColIndex = sortedByDate.findIndex(function (item) {
	    return isTitleColumn(item);
	  });
	
	  if (firstColIndex > -1) {
	    var firslCol = sortedByDate[firstColIndex];
	    sortedByDate.splice(firstColIndex, 1);
	    sortedByDate.unshift(firslCol);
	  }
	
	  return sortedByDate;
	};

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _InfoPopover = __webpack_require__(773);
	
	var _InfoPopover2 = _interopRequireDefault(_InfoPopover);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5142);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveyListItem = function SurveyListItem(_ref) {
	  var list = _ref.list,
	      heading = _ref.heading,
	      title = _ref.title,
	      active = _ref.active,
	      status = _ref.status,
	      onClick = _ref.onClick,
	      subtitle = _ref.subtitle,
	      description = _ref.description,
	      date = _ref.date;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isShownTooltip = _useState2[0],
	      toggleTooltip = _useState2[1];
	
	  var anchor = (0, _react.useRef)(null);
	
	  var handleTooltipClick = function handleTooltipClick(e) {
	    e.stopPropagation();
	    toggleTooltip(true);
	  };
	
	  var handleTooltipClose = function handleTooltipClose(e) {
	    e.stopPropagation();
	    toggleTooltip(false);
	  };
	
	  var handleTooltipCloseAndOpenDetails = function handleTooltipCloseAndOpenDetails() {
	    toggleTooltip(false);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      styleName: (0, _classnames2.default)('survey-card', 'header', {
	        'survey-card--active': active
	      }),
	      className: 'relative',
	      onClick: onClick,
	      onMouseDown: handleTooltipCloseAndOpenDetails
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.container },
	      _react2.default.createElement(_Icon2.default, { styleName: 'icon', name: 'up-surveys', size: 32 }),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'content' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'heading' },
	          _react2.default.createElement(
	            'span',
	            { styleName: 'text--heading' },
	            heading
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex items-center', ref: anchor },
	            _react2.default.createElement(
	              'span',
	              { styleName: 'text--title' },
	              title
	            ),
	            Boolean(description || list) && _react2.default.createElement(
	              _ClickableElement2.default,
	              {
	                onClick: handleTooltipClick,
	                className: 'ml1',
	                ariaLabel: 'info-default'
	              },
	              _react2.default.createElement(_Icon2.default, {
	                name: 'info-default',
	                size: 16,
	                style: { fill: _styles.COLORS.bluePrimary }
	              })
	            )
	          ),
	          subtitle && _react2.default.createElement(
	            'div',
	            { styleName: 'text--subtitle' },
	            subtitle
	          ),
	          date && _react2.default.createElement(
	            'div',
	            { styleName: 'text--date' },
	            date
	          )
	        ),
	        status && _react2.default.createElement(
	          'div',
	          { styleName: 'text--subtitle' },
	          status
	        )
	      )
	    ),
	    _react2.default.createElement(_InfoPopover2.default, {
	      onClose: handleTooltipClose,
	      isOpen: isShownTooltip,
	      description: description,
	      anchorEl: anchor.current,
	      list: list
	    })
	  );
	};
	
	SurveyListItem.propTypes = {
	  heading: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  status: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.string]),
	  active: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  list: _propTypes2.default.array,
	  date: _propTypes.string
	};
	
	exports.default = (0, _reactCssModules2.default)(SurveyListItem, _index2.default, { allowMultiple: true });

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(5166);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _CallDuration = __webpack_require__(3767);
	
	var _CallDuration2 = _interopRequireDefault(_CallDuration);
	
	var _styles3 = __webpack_require__(18);
	
	var _IconButton = __webpack_require__(605);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _context = __webpack_require__(306);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _useVirtualVisit2 = __webpack_require__(352);
	
	var _MediaSettings = __webpack_require__(3779);
	
	var _MediaSettings2 = _interopRequireDefault(_MediaSettings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VisitHeader(_ref) {
	  var _cn;
	
	  var full = _ref.full,
	      noInfo = _ref.noInfo,
	      collapsed = _ref.collapsed,
	      noDescription = _ref.noDescription,
	      formatMessage = _ref.intl.formatMessage,
	      _ref$roomDetails = _ref.roomDetails;
	  _ref$roomDetails = _ref$roomDetails === undefined ? {} : _ref$roomDetails;
	  var name = _ref$roomDetails.name,
	      number = _ref$roomDetails.number,
	      connectionRoom = _ref$roomDetails.connectionRoom,
	      visitType = _ref$roomDetails.visitType;
	
	  var _useVirtualVisit = (0, _useVirtualVisit2.useVirtualVisit)(),
	      viewOptions = _useVirtualVisit.viewOptions;
	
	  var _useContext = (0, _react.useContext)(_context.OTContext),
	      state = _useContext.state;
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(false),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      opened = _useToggleFlag2[0],
	      open = _useToggleFlag2[1],
	      close = _useToggleFlag2[2];
	
	  var _useState = (0, _react.useState)(!noDescription),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      visible = _useState2[0],
	      showDescription = _useState2[1];
	
	  var _state = (0, _extends3.default)({}, state),
	      durationData = _state.durationData,
	      connectionTime = _state.connectionTime,
	      connections = _state.connections;
	
	  var duration = durationData.duration,
	      timerActive = durationData.timerActive,
	      currentTimestamp = durationData.currentTimestamp,
	      currentSessionStartedAt = durationData.currentSessionStartedAt;
	
	
	  var providerJoinedAt = (0, _react.useRef)(null);
	
	  var hasProviderConnected = !connectionRoom && (0, _values2.default)(connections || {}).some(function (conn) {
	    return conn.user && conn.user.isProvider;
	  });
	
	  if (hasProviderConnected && !providerJoinedAt.current) {
	    providerJoinedAt.current = new Date().toISOString();
	  } else if (!hasProviderConnected) {
	    providerJoinedAt.current = null;
	  }
	
	  var effectiveTimerActive = timerActive || hasProviderConnected;
	  var effectiveStartedAt = currentSessionStartedAt || providerJoinedAt.current;
	
	  var title = (0, _react.useMemo)(function () {
	    if (name) {
	      var resolvedVisitType = visitType || formatMessage({ id: 'virtualVisit.virtualVisit' });
	      return formatMessage({ id: 'virtualVisit.title' }, { name: name, visitType: resolvedVisitType });
	    }
	    if (connectionRoom) {
	      return formatMessage({ id: 'common.call' });
	    }
	    return formatMessage({ id: 'virtualVisit.virtualVisit' });
	  }, [name, connectionRoom, visitType]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_styles2.default.root, (_cn = {}, (0, _defineProperty3.default)(_cn, _styles2.default.full, full), (0, _defineProperty3.default)(_cn, _styles2.default.collapsed, collapsed || viewOptions.fullScreenView), _cn))
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.main },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.logo },
	        _react2.default.createElement(_Icon2.default, {
	          name: _brandConfig2.default.logo,
	          size: _brandConfig2.default.logoSize,
	          style: (0, _extends3.default)({}, _brandConfig.isFlagler && { fill: _brandConfig2.default.fillColor })
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.title },
	        title
	      )
	    ),
	    !noInfo && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.info },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.text },
	        formatMessage({ id: 'virtualVisit.room' }),
	        ':\xA0',
	        number
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.text },
	        formatMessage({ id: 'virtualVisit.duration' }),
	        ':\xA0',
	        _react2.default.createElement(_CallDuration2.default, {
	          time: connectionTime,
	          timerActive: effectiveTimerActive,
	          previousDuration: duration,
	          isConnectionRoom: connectionRoom,
	          currentTimestamp: currentTimestamp,
	          currentSessionStartedAt: effectiveStartedAt
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ClickableElement2.default,
	          {
	            onClick: viewOptions.toggleMobSidebar,
	            className: _styles2.default.infoBtn
	          },
	          _react2.default.createElement(_Icon2.default, { name: 'info-default', size: 24 })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.deviceSettings },
	          _react2.default.createElement(
	            _ClickableElement2.default,
	            { onClick: open, className: _styles2.default.btn },
	            _react2.default.createElement(_Icon2.default, { name: 'settings', size: 24 })
	          )
	        ),
	        _react2.default.createElement(_MediaSettings2.default, { opened: opened, close: close })
	      )
	    ),
	    visible && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.desc },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.descText },
	          formatMessage({ id: 'virtualVisit.test.description' })
	        ),
	        _react2.default.createElement(
	          _ClickableElement2.default,
	          {
	            className: _styles2.default.descLink,
	            onClick: function onClick() {
	              return open();
	            }
	          },
	          formatMessage({ id: 'virtualVisit.test.openSettings' })
	        )
	      ),
	      _react2.default.createElement(_IconButton.IconButton, {
	        name: 'ico-24-close',
	        size: 16,
	        fill: _styles3.COLORS.white,
	        onClick: function onClick() {
	          return showDescription(false);
	        }
	      })
	    )
	  );
	} /* eslint-disable react/jsx-handler-names */
	
	
	VisitHeader.propTypes = {
	  full: PropTypes.bool,
	  intl: PropTypes.object,
	  noInfo: PropTypes.bool,
	  collapsed: PropTypes.bool,
	  noDescription: PropTypes.bool,
	  roomDetails: PropTypes.object
	};
	
	exports.default = (0, _reactIntl.injectIntl)(VisitHeader);

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TEST_STEPS = exports.TEST_STEPS = {
	  INTRO: 'intro',
	  PROGRESS: 'progress',
	  RESULTS: 'results'
	};
	
	var PROGRESS_STEPS = exports.PROGRESS_STEPS = {
	  INIT: 0,
	  START: 5,
	  CONNECTION_TEST_PASSED: 10,
	  QUALITY_LIMIT: 95,
	  DONE: 100
	};
	
	var TEST_RESULT_QUALITY = exports.TEST_RESULT_QUALITY = {
	  EXCELLENT: {
	    min: 3.8,
	    max: 4.5,
	    id: 'virtualVisit.test.result.excellent',
	    danger: false,
	    icon: 'mic'
	  },
	  GOOD: {
	    min: 3.1,
	    max: 3.79,
	    id: 'virtualVisit.test.result.good',
	    danger: false,
	    icon: 'mic'
	  },
	  FAIR: {
	    min: 2.4,
	    max: 3.09,
	    id: 'virtualVisit.test.result.fair',
	    danger: true,
	    icon: 'mic'
	  },
	  POOR: {
	    min: 1.7,
	    max: 2.39,
	    id: 'virtualVisit.test.result.poor',
	    danger: true,
	    icon: 'mic'
	  },
	  BAD: {
	    min: 1.0,
	    max: 1.69,
	    id: 'virtualVisit.test.result.bad',
	    danger: true,
	    icon: 'mic'
	  },
	  NOT_FOUND: {
	    id: 'virtualVisit.test.deviceNotFound',
	    titleId: 'virtualVisit.test.result.failure',
	    danger: true,
	    icon: 'sound-on-error',
	    videoIcon: 'video-on-error'
	  }
	};

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _index = __webpack_require__(5175);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionButton = function ActionButton(_ref) {
	  var onClick = _ref.onClick,
	      children = _ref.children,
	      style = _ref.style,
	      _ref$ariaLabel = _ref.ariaLabel,
	      ariaLabel = _ref$ariaLabel === undefined ? '' : _ref$ariaLabel;
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', style: style },
	    _react2.default.createElement(
	      _ClickableElement2.default,
	      {
	        onClick: onClick,
	        style: { padding: 12 },
	        ariaLabel: ariaLabel
	      },
	      children
	    )
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	ActionButton.propTypes = {
	  onClick: _propTypes2.default.func,
	  children: _propTypes2.default.node,
	  style: _propTypes2.default.object,
	  ariaLabel: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(ActionButton, _index2.default);

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AmountInput(_ref) {
	  var type = _ref.type,
	      name = _ref.name,
	      label = _ref.label,
	      limit = _ref.limit,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      showError = _ref.showError,
	      inputMode = _ref.inputMode,
	      className = _ref.className,
	      placeholder = _ref.placeholder,
	      validationRule = _ref.validationRule,
	      errorText = _ref.errorText;
	
	  var _useState = (0, _react.useState)(showError),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isError = _useState2[0],
	      setError = _useState2[1];
	
	  var handleChange = function handleChange(val) {
	    var error = val ? !validationRule(val) : false;
	    setError(error);
	    onChange(val, error);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_TextInput2.default, {
	      rounded: true,
	      name: name,
	      type: type,
	      value: value,
	      limit: limit,
	      label: label,
	      inputMode: inputMode,
	      placeholder: placeholder,
	      className: className,
	      onChange: handleChange
	    }),
	    Boolean(isError) ? _react2.default.createElement(_ErrorBlock2.default, { errors: errorText, className: 'mt3' }) : null
	  );
	}
	
	AmountInput.propTypes = {
	  type: PropTypes.string,
	  validationRule: PropTypes.func,
	  onChange: PropTypes.func,
	  limit: PropTypes.number,
	  value: PropTypes.string,
	  name: PropTypes.string,
	  label: PropTypes.string,
	  inputMode: PropTypes.string,
	  placeholder: PropTypes.string,
	  errorText: PropTypes.string,
	  className: PropTypes.string,
	  showError: PropTypes.bool
	};
	
	exports.default = AmountInput;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DiscardModal = function DiscardModal(_ref) {
	  var title = _ref.title,
	      isOpened = _ref.isOpened,
	      onSubmit = _ref.onSubmit,
	      submitText = _ref.submitText,
	      cancelText = _ref.cancelText,
	      onCancel = _ref.onCancel,
	      formatMessage = _ref.intl.formatMessage;
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: isOpened,
	      width: 'xsmall',
	      mobileFullScreen: false,
	      customControls: true,
	      onSubmit: onSubmit,
	      submitText: submitText || formatMessage({ id: 'common.remove' }),
	      submitBtnColor: 'danger',
	      onClose: onCancel,
	      cancelText: cancelText || formatMessage({ id: 'common.cancel' }),
	      enabled: true,
	      withHeading: false
	    },
	    _react2.default.createElement(
	      'p',
	      { className: 'fw6 f-16 g-color--primary mt3' },
	      title
	    )
	  );
	};
	
	DiscardModal.propTypes = {
	  title: _propTypes2.default.string,
	  isOpened: _propTypes2.default.bool,
	  onSubmit: _propTypes2.default.func,
	  submitText: _propTypes2.default.string,
	  cancelText: _propTypes2.default.string,
	  onCancel: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(DiscardModal);

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ContentArea = __webpack_require__(155);
	
	var _ContentArea2 = _interopRequireDefault(_ContentArea);
	
	var _Content = __webpack_require__(214);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var EmptyNavigation = function EmptyNavigation(_ref) {
	  var text = _ref.text;
	  return _react2.default.createElement(
	    _ContentArea2.default,
	    null,
	    _react2.default.createElement(
	      _Content2.default,
	      { empty: true },
	      _react2.default.createElement(
	        'p',
	        { className: 'tc ttu white' },
	        text
	      )
	    )
	  );
	};
	
	EmptyNavigation.propTypes = {
	  text: _propTypes2.default.string
	};
	
	exports.default = EmptyNavigation;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _includes = __webpack_require__(324);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _TermsAndConditions = __webpack_require__(781);
	
	var _TermsAndConditions2 = _interopRequireDefault(_TermsAndConditions);
	
	var _formFields = __webpack_require__(38);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _MobilePhone = __webpack_require__(776);
	
	var _enhance = __webpack_require__(3853);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FieldsList = function FieldsList(_ref) {
	  var fields = _ref.fields,
	      formState = _ref.formState,
	      relationshipOptions = _ref.relationshipOptions,
	      roleOptions = _ref.roleOptions,
	      loggedUserCountry = _ref.loggedUserCountry,
	      validateErrors = _ref.validateErrors,
	      formatMessage = _ref.formatMessage,
	      onChange = _ref.onChange,
	      handleFieldOptions = _ref.handleFieldOptions,
	      initialData = _ref.initialData,
	      customRoleOptions = _ref.customRoleOptions,
	      className = _ref.className;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, onChange);
	
	  var checkOptionHandler = function checkOptionHandler(field, options) {
	    var handler = handleFieldOptions[field];
	
	    if (handler) {
	      return handler(options, initialData);
	    }
	
	    return options;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    (0, _includes2.default)(fields, _formFields.PROFILE_FIELDS_TYPES.ROLE) ? _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(_formFields.PROFILE_FIELDS_TYPES.ROLE), {
	      options: checkOptionHandler(_formFields.PROFILE_FIELDS_TYPES.ROLE, customRoleOptions || roleOptions),
	      value: formState[_formFields.PROFILE_FIELDS_TYPES.ROLE]
	    })) : null,
	    (0, _includes2.default)(fields, _formFields.PROFILE_FIELDS_TYPES.RELATIONSHIP) ? _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(_formFields.PROFILE_FIELDS_TYPES.RELATIONSHIP), {
	      options: relationshipOptions,
	      value: formState[_formFields.PROFILE_FIELDS_TYPES.RELATIONSHIP]
	    })) : null,
	    (0, _includes2.default)(fields, _formFields.PROFILE_FIELDS_TYPES.LOGIN) ? [_react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(_formFields.PROFILE_FIELDS_TYPES.LOGIN), {
	      value: formState[_formFields.PROFILE_FIELDS_TYPES.LOGIN],
	      key: '0'
	    })), _react2.default.createElement(_FormErrorBlock.FormErrorBlock, {
	      type: _formFields.PROFILE_FIELDS_TYPES.LOGIN,
	      errors: validateErrors,
	      key: '1'
	    })] : null,
	    (0, _includes2.default)(fields, _formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE) ? [_react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(_formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE), {
	      value: formState[_formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE],
	      key: '0'
	    })), _react2.default.createElement(_FormErrorBlock.FormErrorBlock, {
	      type: _formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE,
	      errors: validateErrors,
	      key: '1'
	    })] : null,
	    (0, _includes2.default)(fields, _formFields.PROFILE_FIELDS_TYPES.USERNAME) ? [_react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(_formFields.PROFILE_FIELDS_TYPES.USERNAME), {
	      value: formState[_formFields.PROFILE_FIELDS_TYPES.USERNAME],
	      key: '0'
	    })), _react2.default.createElement(_FormErrorBlock.FormErrorBlock, {
	      type: _formFields.PROFILE_FIELDS_TYPES.USERNAME,
	      errors: validateErrors,
	      key: '1'
	    })] : null,
	    (0, _includes2.default)(fields, _formFields.PROFILE_FIELDS_TYPES.CHAT_NAME) ? [_react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(_formFields.PROFILE_FIELDS_TYPES.CHAT_NAME), {
	      value: formState[_formFields.PROFILE_FIELDS_TYPES.CHAT_NAME],
	      key: '0'
	    })), _react2.default.createElement(_FormErrorBlock.FormErrorBlock, {
	      type: _formFields.PROFILE_FIELDS_TYPES.CHAT_NAME,
	      errors: validateErrors,
	      key: '1'
	    })] : null,
	    (0, _includes2.default)(fields, _formFields.PROFILE_FIELDS_TYPES.TERMS_AND_CONDITIONS) ? [_react2.default.createElement(_TermsAndConditions2.default, (0, _extends3.default)({}, makeProfileField(_formFields.PROFILE_FIELDS_TYPES.TERMS_AND_CONDITIONS), {
	      country: loggedUserCountry,
	      acceptable: true,
	      secondaryContent: true,
	      key: '0'
	    })), _react2.default.createElement(_FormErrorBlock.FormErrorBlock, {
	      type: _formFields.PROFILE_FIELDS_TYPES.TERMS_AND_CONDITIONS,
	      errors: validateErrors,
	      key: '1'
	    })] : null,
	    (0, _includes2.default)(fields, _formFields.PROFILE_FIELDS_TYPES.EMAIL) ? [_react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(_formFields.PROFILE_FIELDS_TYPES.EMAIL), {
	      value: formState[_formFields.PROFILE_FIELDS_TYPES.EMAIL],
	      key: '0'
	    })), _react2.default.createElement(_FormErrorBlock.FormErrorBlock, {
	      type: _formFields.PROFILE_FIELDS_TYPES.EMAIL,
	      errors: validateErrors,
	      key: '1'
	    })] : null,
	    (0, _includes2.default)(fields, _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER) ? [_react2.default.createElement(_MobilePhone.MobilePhone, (0, _extends3.default)({}, makeProfileField(_formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      formatMessage: formatMessage,
	      withValidation: true,
	      key: '0'
	    })), _react2.default.createElement(_FormErrorBlock.FormErrorBlock, {
	      type: _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER,
	      errors: validateErrors,
	      key: '1'
	    })] : null
	  );
	};
	
	FieldsList.defaultProps = {
	  formState: {},
	  fields: [],
	  handleFieldOptions: {}
	};
	
	FieldsList.propTypes = {
	  customFieldStyles: _propTypes2.default.object,
	  fields: _propTypes2.default.array,
	  formState: _propTypes2.default.object,
	  handleFieldOptions: _propTypes2.default.object,
	  initialData: _propTypes2.default.object,
	  relationshipOptions: _propTypes2.default.array.isRequired,
	  loggedUserCountry: _propTypes2.default.string,
	  roleOptions: _propTypes2.default.array.isRequired,
	  validateErrors: _propTypes2.default.object.isRequired,
	  formatMessage: _propTypes2.default.func.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  customRoleOptions: _propTypes2.default.array,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _enhance.enhance)(FieldsList);

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (formatMessage) {
	  var rolesOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _props.CARE_ROLE;
	  var hasDescription = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var careRoleOptions = (0, _values2.default)(rolesOptions).map(function (item) {
	    return { value: item, className: 'bb b--light-gray' };
	  });
	  return (0, _convertListWithLocalization.convertRelationsList)(careRoleOptions, formatMessage, hasDescription);
	};
	
	var _values = __webpack_require__(2359);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ImageManager = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _PopoverMenu = __webpack_require__(398);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	var _CropModal = __webpack_require__(3846);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ids = __webpack_require__(46);
	
	var _utils = __webpack_require__(3857);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _styles = __webpack_require__(5204);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageManagerImpl = function ImageManagerImpl(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      onImageRemove = _ref.onImageRemove,
	      onImageCrop = _ref.onImageCrop,
	      aspectRatio = _ref.aspectRatio,
	      removeTitle = _ref.removeTitle,
	      cropTitle = _ref.cropTitle,
	      cropTip = _ref.cropTip,
	      rounded = _ref.rounded,
	      style = _ref.style;
	
	  var _useFileManagement = (0, _utils.useFileManagement)(),
	      _useFileManagement2 = (0, _slicedToArray3.default)(_useFileManagement, 3),
	      file = _useFileManagement2[0],
	      setFile = _useFileManagement2[1],
	      handleFileChange = _useFileManagement2[2];
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(false),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      confirmOpened = _useToggleFlag2[0],
	      openConfirm = _useToggleFlag2[1],
	      closeConfirm = _useToggleFlag2[2];
	
	  var _useToggleFlag3 = (0, _useToogleFlag.useToggleFlag)(false),
	      _useToggleFlag4 = (0, _slicedToArray3.default)(_useToggleFlag3, 3),
	      menuOpened = _useToggleFlag4[0],
	      openMenu = _useToggleFlag4[1],
	      closeMenu = _useToggleFlag4[2];
	
	  var handleCloseCrop = (0, _react.useCallback)(function () {
	    return setFile(undefined);
	  }, []);
	  var anchorEl = (0, _react.useRef)();
	  var fileRef = (0, _react.useRef)();
	
	  var menuItems = [{
	    id: _ids.IDS.COMMON.IMAGE_MANAGER_UPDATE,
	    text: formatMessage({ id: 'profile.avatar.update' }),
	    icon: 'image',
	    onClick: function onClick() {
	      closeMenu();
	      fileRef.current.click();
	    }
	  }, {
	    id: _ids.IDS.COMMON.IMAGE_MANAGER_REMOVE,
	    text: formatMessage({ id: 'profile.avatar.remove' }),
	    icon: 'remove',
	    onClick: function onClick() {
	      closeMenu();
	      openConfirm();
	    }
	  }];
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: (0, _classnames2.default)('root'), className: 'img-manager', style: style },
	    _react2.default.createElement(
	      'button',
	      {
	        id: _ids.IDS.COMMON.IMAGE_MANAGER_EDIT,
	        styleName: 'button',
	        ref: anchorEl,
	        onClick: openMenu,
	        type: 'button'
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'edit' })
	    ),
	    _react2.default.createElement(_PopoverMenu2.default, {
	      size: 'small',
	      isOpen: menuOpened,
	      anchorEl: anchorEl.current,
	      onClose: closeMenu,
	      items: menuItems,
	      transformOrigin: { vertical: 'top', horizontal: 'center' }
	    }),
	    _react2.default.createElement(_CropModal.CropModal, {
	      onImageCrop: onImageCrop,
	      aspectRatio: aspectRatio,
	      onClose: handleCloseCrop,
	      rounded: rounded,
	      title: cropTitle,
	      tip: cropTip,
	      image: file
	    }),
	    _react2.default.createElement(_ActionConfirmation2.default, {
	      opened: confirmOpened,
	      onSubmit: onImageRemove,
	      onClose: closeConfirm,
	      actionButtonText: formatMessage({ id: 'common.remove' }),
	      intl: { formatMessage: formatMessage },
	      title: removeTitle,
	      width: 'auto'
	    }),
	    _react2.default.createElement('input', {
	      type: 'file',
	      accept: _utils.ALLOWED_FORMAT.join(', '),
	      ref: fileRef,
	      style: { display: 'none' },
	      onChange: handleFileChange
	    })
	  );
	};
	
	var ImageManager = exports.ImageManager = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _recompose.branch)(function (_ref2) {
	  var hidden = _ref2.hidden;
	  return hidden;
	}, _recompose.renderNothing), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }))(ImageManagerImpl);
	
	var propsTypes = {
	  onImageCrop: _propTypes2.default.func.isRequired,
	  onImageRemove: _propTypes2.default.func.isRequired,
	  cropTitle: _propTypes2.default.string.isRequired,
	  removeTitle: _propTypes2.default.string,
	  rounded: _propTypes2.default.bool,
	  hidden: _propTypes2.default.bool,
	  cropTip: _propTypes2.default.string,
	  aspectRatio: _propTypes2.default.number
	};
	
	var defaultProps = {
	  removeTitle: '',
	  cropTip: '',
	  hidden: false,
	  rounded: false,
	  aspectRatio: 1
	};
	
	ImageManagerImpl.propTypes = (0, _extends3.default)({
	  intl: _propTypes2.default.object.isRequired,
	  style: _propTypes2.default.object.isRequired
	}, propsTypes);
	
	ImageManagerImpl.defaultProps = (0, _extends3.default)({}, defaultProps);
	
	ImageManager.propTypes = propsTypes;
	ImageManager.defaultProps = defaultProps;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(266);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ValidationError = __webpack_require__(500);
	
	var _ValidationError2 = _interopRequireDefault(_ValidationError);
	
	var _styles = __webpack_require__(18);
	
	var _FilePicker = __webpack_require__(762);
	
	var _FilePicker2 = _interopRequireDefault(_FilePicker);
	
	var _SimpleImagePreview = __webpack_require__(1845);
	
	var _SimpleImagePreview2 = _interopRequireDefault(_SimpleImagePreview);
	
	var _index = __webpack_require__(17);
	
	var _generateImagePreview = __webpack_require__(1385);
	
	var _generateImagePreview2 = _interopRequireDefault(_generateImagePreview);
	
	var _imagePreview = __webpack_require__(1921);
	
	var _index2 = __webpack_require__(5205);
	
	var _index3 = _interopRequireDefault(_index2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageUploader = function ImageUploader(_ref) {
	  var handleAttachmentPick = function () {
	    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(file) {
	      var previewBlob, url;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return (0, _generateImagePreview2.default)(file, false, 120);
	
	            case 2:
	              previewBlob = _context.sent;
	              url = window.URL.createObjectURL(previewBlob);
	              return _context.abrupt('return', {
	                file: file,
	                previewImage: url
	              });
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function handleAttachmentPick(_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var title = _ref.title,
	      label = _ref.label,
	      disabled = _ref.disabled,
	      src = _ref.src,
	      name = _ref.name,
	      onChange = _ref.onChange,
	      formatMessage = _ref.intl.formatMessage,
	      maxFileSize = _ref.maxFileSize,
	      errorTextClassName = _ref.errorTextClassName;
	
	  var defaultState = {
	    previewImage: src,
	    fileError: false,
	    file: null,
	    loading: false,
	    deleted: false,
	    errors: null
	  };
	
	  var _useState = (0, _react.useState)(defaultState),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      attachment = _useState2[0],
	      setAttachment = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    setAttachment((0, _extends3.default)({}, attachment, { previewImage: src }));
	  }, [src]);
	
	  var handleAttachments = function handleAttachments(file) {
	    setAttachment((0, _extends3.default)({}, attachment, {
	      loading: true,
	      fileError: false
	    }));
	    handleAttachmentPick(file)
	    // eslint-disable-next-line promise/always-return
	    .then(function (result) {
	      var data = (0, _extends3.default)({}, attachment, result, {
	        loading: false,
	        deleted: false,
	        fileError: false
	      });
	      setAttachment(data);
	      onChange(data);
	    }).catch(function (err) {
	      var errorData = (0, _extends3.default)({}, attachment, {
	        fileError: true,
	        errors: null,
	        loading: false,
	        deleted: false
	      });
	      setAttachment(errorData);
	      onChange(errorData);
	    });
	  };
	
	  var removeAttachedFile = function removeAttachedFile() {
	    var removeInfo = (0, _extends3.default)({}, defaultState, { previewImage: null, deleted: true });
	    setAttachment(removeInfo);
	    onChange(removeInfo);
	  };
	
	  var handleError = function handleError(err) {
	    var errorData = (0, _extends3.default)({}, attachment, {
	      errors: (0, _get2.default)(err, 'errors'),
	      fileError: true
	    });
	    setAttachment(errorData);
	    onChange(errorData);
	  };
	
	  var imageSrc = (0, _get2.default)(attachment, 'previewImage');
	  var fileError = (0, _get2.default)(attachment, 'fileError');
	  var errors = (0, _get2.default)(attachment, 'errors');
	  var errorText = (0, _size2.default)(errors) ? formatMessage({ id: 'community.newPost.fileError' }, { size: maxFileSize }) : formatMessage({ id: 'errors.common' });
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    Boolean(title) ? _react2.default.createElement(
	      'p',
	      { styleName: 'title' },
	      title
	    ) : null,
	    Boolean(!imageSrc) ? _react2.default.createElement(
	      'div',
	      {
	        styleName: (0, _classnames2.default)('placeholder', {
	          'placeholder--disabled': disabled
	        })
	      },
	      _react2.default.createElement(
	        _FilePicker2.default,
	        {
	          maxSize: maxFileSize,
	          allowedFormats: _index.IMAGE_ALLOWED_FORMATS,
	          inputFileLabel: name,
	          onError: handleError,
	          onFilePick: handleAttachments
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex flex-column items-center' },
	          !disabled ? _react2.default.createElement(_Icon2.default, {
	            name: 'icon-plus',
	            className: 'mb2',
	            style: { fill: _styles.COLORS.blueGray },
	            size: 24
	          }) : null,
	          _react2.default.createElement(
	            'span',
	            { styleName: 'label' },
	            label
	          )
	        )
	      )
	    ) : _react2.default.createElement(_SimpleImagePreview2.default, {
	      handleClick: function handleClick() {
	        return (0, _imagePreview.emitImagePreview)(imageSrc);
	      },
	      key: name,
	      src: imageSrc,
	      onCancel: removeAttachedFile,
	      small: true,
	      className: 'ma0',
	      imageClassName: 'fit-contain bg-white',
	      showCloseBtn: !disabled
	    }),
	    fileError ? _react2.default.createElement(_ValidationError2.default, { content: errorText, className: errorTextClassName }) : null
	  );
	};
	
	ImageUploader.propTypes = {
	  title: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  src: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  maxFileSize: _propTypes2.default.number,
	  errorTextClassName: _propTypes2.default.string
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(ImageUploader, _index3.default, { allowMultiple: true }));

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.imagePreviewClass = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable react/require-default-props,react/destructuring-assignment */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Modal = __webpack_require__(1188);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _index = __webpack_require__(5206);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var imagePreviewClass = exports.imagePreviewClass = 'image-viewer-img';
	
	var ImageViewer = (_dec = (0, _reactCssModules2.default)(_index2.default), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
	  (0, _inherits3.default)(ImageViewer, _Component);
	
	  function ImageViewer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ImageViewer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImageViewer.__proto__ || (0, _getPrototypeOf2.default)(ImageViewer)).call.apply(_ref, [this].concat(args))), _this), _this.image = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ImageViewer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.config.opened && !prevProps.config.opened) {
	        if (this.image) {
	          this.image.addEventListener('load', function (e) {
	            return e.target.classList.remove('o-0');
	          });
	        }
	      }
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      this.image.classList.add('o-0');
	      setTimeout(this.props.onClose, 100);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$config = this.props.config,
	          src = _props$config.src,
	          opened = _props$config.opened;
	
	
	      if (!opened) return null;
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            styleName: 'root',
	            className: 'df al-c justify-center',
	            onClick: this.handleClose
	          },
	          _react2.default.createElement('img', {
	            alt: 'preview viewer',
	            ref: function ref(node) {
	              return _this2.image = node;
	            },
	            className: (0, _classnames2.default)(imagePreviewClass, 'o-0'),
	            src: src,
	            onContextMenu: function onContextMenu(e) {
	              return e.preventDefault();
	            }
	          }),
	          _react2.default.createElement('div', { styleName: 'backdrop' })
	        )
	      );
	    }
	  }]);
	  return ImageViewer;
	}(_react.Component), _class3.propTypes = {
	  config: _propTypes2.default.shape({
	    src: _propTypes2.default.string,
	    opened: _propTypes2.default.bool
	  }),
	  onClose: _propTypes2.default.func
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleClose', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleClose'), _class2.prototype)), _class2)) || _class);
	exports.default = ImageViewer;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(5207);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Label = function Label(_ref) {
	  var text = _ref.text,
	      additionalClass = _ref.additionalClass,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['text', 'additionalClass']);
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, {
	      styleName: (0, _classnames2.default)('root', (0, _defineProperty3.default)({}, 'root--' + additionalClass, additionalClass))
	    }),
	    _react2.default.createElement(
	      'span',
	      null,
	      text
	    )
	  );
	};
	
	Label.propTypes = {
	  text: _propTypes2.default.string.isRequired,
	  additionalClass: _propTypes2.default.string
	};
	
	Label.defaultProps = {
	  additionalClass: ''
	};
	
	exports.default = (0, _reactCssModules2.default)(Label, _index2.default, { allowMultiple: true });

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /* eslint-disable react/require-optimization,react/require-default-props,react/destructuring-assignment */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalRoot = document.getElementById('modal');
	
	var Modal = (_temp = _class = function (_Component) {
	  (0, _inherits3.default)(Modal, _Component);
	
	  function Modal(props) {
	    (0, _classCallCheck3.default)(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props));
	
	    _this.el = document.createElement('div');
	    return _this;
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      modalRoot.appendChild(this.el);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      modalRoot.removeChild(this.el);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _reactDom2.default.createPortal(this.props.children, this.el);
	    }
	  }]);
	  return Modal;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.any // eslint-disable-line react/forbid-prop-types
	}, _temp);
	exports.default = Modal;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLottie = __webpack_require__(1617);
	
	var _reactLottie2 = _interopRequireDefault(_reactLottie);
	
	var _PaymentAccountFormLoader = __webpack_require__(5355);
	
	var _PaymentAccountFormLoader2 = _interopRequireDefault(_PaymentAccountFormLoader);
	
	var _stylesModule = __webpack_require__(5215);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var animationOptions = {
	  loop: true,
	  autoplay: true,
	  animationData: _PaymentAccountFormLoader2.default,
	  rendererSettings: {
	    preserveAspectRatio: 'xMidYMid slice'
	  }
	};
	
	var PaymentAccountFormLoader = function PaymentAccountFormLoader() {
	  return _react2.default.createElement(
	    'section',
	    { className: _stylesModule2.default.section },
	    _react2.default.createElement(_reactLottie2.default, { options: animationOptions, height: 100, width: 100 })
	  );
	};
	
	exports.default = PaymentAccountFormLoader;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable react/require-default-props,react/destructuring-assignment,react/sort-comp,react/prop-types,jsx-control-statements/jsx-use-if-tag */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactRedux = __webpack_require__(6);
	
	var _format = __webpack_require__(319);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _head = __webpack_require__(378);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _fileSaver = __webpack_require__(1516);
	
	var _exportToPDF = __webpack_require__(899);
	
	var _reqFormResult = __webpack_require__(1368);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(158);
	
	var _selectors3 = __webpack_require__(79);
	
	var _index = __webpack_require__(75);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(285);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _Review = __webpack_require__(1801);
	
	var _Review2 = _interopRequireDefault(_Review);
	
	var _ExportBtn = __webpack_require__(1836);
	
	var _ExportBtn2 = _interopRequireDefault(_ExportBtn);
	
	var _EmptyState = __webpack_require__(1835);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _strings = __webpack_require__(15);
	
	var _createSurveyPdfName = __webpack_require__(1917);
	
	var _createSurveyPdfName2 = _interopRequireDefault(_createSurveyPdfName);
	
	var _getRespondentData = __webpack_require__(1173);
	
	var _preVisitForm = __webpack_require__(288);
	
	var _getSpecification = __webpack_require__(361);
	
	var _ProgramPopupContent = __webpack_require__(3868);
	
	var _ProgramPopupContent2 = _interopRequireDefault(_ProgramPopupContent);
	
	var _constants = __webpack_require__(493);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/*
	 * TODO: move answered surveys prop validation into constants
	 * as it's common validation for several components
	 */
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	  var targetUserId = _ref.targetUserId,
	      activeChannelId = _ref.activeChannelId;
	  return {
	    targetUserId: targetUserId || (0, _selectors.targetUserIdSelector)(state),
	    targetUser: (0, _selectors.targetUserSelector)(state),
	    surveys: (0, _get2.default)(state, 'surveys.answered.list'),
	    surveysLoading: (0, _get2.default)(state, 'surveys.answered.sending'),
	    export: (0, _get2.default)(state, 'surveys.pdfExport'),
	    targetForm: (0, _selectors2.formResultSelector)(state),
	    targetFormLoading: (0, _selectors2.loadingFormResultSelector)(state),
	    activeChannelId: activeChannelId || (0, _selectors3.activeContextChannelSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  exportToPDF: _exportToPDF.actions.send,
	  fetchAnsweredSurvey: _reqFormResult.actions.send,
	  clearExportToPDF: _exportToPDF.actions.clear
	};
	
	var ProgramPopup = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactIntl.injectIntl)(_class = _dec(_class = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(ProgramPopup, _PureComponent);
	
	  function ProgramPopup() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ProgramPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ProgramPopup.__proto__ || (0, _getPrototypeOf2.default)(ProgramPopup)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      exportInProgress: false,
	      exportName: null,
	      isOpened: false
	    }, _this.node = null, _this.getRespondentHeading = function (assignments) {
	      var formatMessage = _this.props.intl.formatMessage;
	
	      var assigment = (0, _head2.default)(assignments);
	      var text = (0, _getRespondentData.getRespondentData)(assigment, true);
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        formatMessage(_strings.ACTIONS.survey.answeredBy),
	        ' ',
	        text
	      );
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ProgramPopup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        intl: this.props.intl
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var openedSurveyId = nextProps.openedSurveyId;
	      var clearExportToPDF = this.props.clearExportToPDF;
	
	
	      if (openedSurveyId) {
	        setTimeout(function () {
	          return _this2.scrollToItem(openedSurveyId);
	        }, 0);
	      }
	
	      if (this.state.exportInProgress) {
	        var pdfLoaded = this.props.export.sending && !nextProps.export.sending && nextProps.export.succeed;
	
	        if (pdfLoaded) {
	          var blob = nextProps.export.blob;
	
	
	          blob && (0, _fileSaver.saveAs)(blob, this.state.exportName); // eslint-disable-line no-unused-expressions
	          this.setState({ exportInProgress: false });
	          clearExportToPDF();
	        }
	      }
	    }
	  }, {
	    key: 'handleOpenPopup',
	    value: function handleOpenPopup(e) {
	      var _props = this.props,
	          forceFetch = _props.forceFetch,
	          targetUserId = _props.targetUserId,
	          openedAssignmentId = _props.openedAssignmentId,
	          activeChannelId = _props.activeChannelId;
	
	
	      e.preventDefault();
	      this.setState({ isOpened: true });
	
	      if (forceFetch) {
	        this.props.fetchAnsweredSurvey({
	          userId: targetUserId,
	          assignmentId: openedAssignmentId,
	          channelId: activeChannelId
	        });
	      }
	    }
	  }, {
	    key: 'handleClosePopup',
	    value: function handleClosePopup() {
	      this.setState({ isOpened: false });
	    }
	  }, {
	    key: 'scrollToItem',
	    value: function scrollToItem(id) {
	      var targetElement = this.node && this.node.querySelector('[data-id="' + id + '"]');
	
	      if (targetElement) {
	        targetElement.scrollIntoView();
	      }
	    }
	  }, {
	    key: 'getSurveyPopup',
	    value: function getSurveyPopup() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          date = _props2.date,
	          exportToPDF = _props2.exportToPDF,
	          openedAssignmentId = _props2.openedAssignmentId,
	          openedSurveyId = _props2.openedSurveyId,
	          pdfExportable = _props2.pdfExportable,
	          program = _props2.program,
	          targetUserId = _props2.targetUserId,
	          targetForm = _props2.targetForm,
	          formatMessage = _props2.intl.formatMessage;
	
	
	      if (!targetForm && !program) return _react2.default.createElement(_EmptyState2.default, { centered: !!openedSurveyId });
	
	      if ((0, _isEmpty2.default)(targetForm) && !program) return _react2.default.createElement(_EmptyState2.default, { centered: !!openedSurveyId });
	
	      var frequency = targetForm.frequency,
	          id = targetForm.id,
	          name = targetForm.name,
	          questions = targetForm.questions,
	          assignments = targetForm.assignments,
	          scorecard = targetForm.scorecard,
	          description = targetForm.description,
	          surveyType = targetForm.surveyType;
	
	
	      var assigment = (0, _head2.default)(assignments);
	
	      var _ref3 = assigment || {},
	          userAppointment = _ref3.userAppointment,
	          assignmentMethod = _ref3.assignmentMethod,
	          assigner = _ref3.assigner;
	
	      var list = (0, _preVisitForm.convertPreVisitFormData)(formatMessage, userAppointment);
	      var subtitle = (0, _getSpecification.getSurveyHeaderSubtitle)(surveyType, frequency, formatMessage, assignmentMethod, assigner);
	
	      var surveyTitle = program ? program.name + ' program: ' + name : 'program: ' + name;
	
	      if (this.isProviderPostVisitForm) {
	        subtitle = formatMessage({ id: 'appointment.postVisitForm' });
	        surveyTitle = name;
	      }
	
	      var note = void 0;
	      var reviewOptions = {
	        questions: questions,
	        assignments: assignments,
	        date: date,
	        scorecard: scorecard,
	        assignmentId: openedAssignmentId,
	        isProviderPostVisitForm: this.isProviderPostVisitForm
	      };
	
	      if (pdfExportable && !this.isProviderPostVisitForm) {
	        var API_FORMAT = 'YYYY-MM-DD';
	        var action = function action() {
	          var params = {
	            userId: targetUserId,
	            assignmentId: openedAssignmentId,
	            date: (0, _format2.default)(date, API_FORMAT)
	          };
	
	          var userName = (0, _get2.default)(_this3.props.targetUser, 'displayableName');
	
	          _this3.setState({
	            exportInProgress: true,
	            exportName: (0, _createSurveyPdfName2.default)(name, userName, date)
	          }, function () {
	            return exportToPDF(params);
	          });
	        };
	        note = _react2.default.createElement(_ExportBtn2.default, { onClick: action });
	      }
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'p',
	          { className: 'mb3 o-70 f-12' },
	          this.getRespondentHeading(assignments)
	        ),
	        _react2.default.createElement(
	          _index4.default,
	          {
	            'data-id': id,
	            key: id,
	            opened: true,
	            header: {
	              icon: 'surveys',
	              title: surveyTitle,
	              subtitle: subtitle,
	              note: note,
	              description: description,
	              list: list
	            },
	            locked: !!date
	          },
	          _react2.default.createElement(_Review2.default, reviewOptions)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          date = _props3.date,
	          program = _props3.program,
	          surveysLoading = _props3.surveysLoading,
	          displayableName = _props3.targetUser.displayableName,
	          intl = _props3.intl,
	          isProgram = _props3.isProgram,
	          targetFormLoading = _props3.targetFormLoading,
	          isButton = _props3.isButton;
	      var formatMessage = intl.formatMessage;
	
	      var titleRef = date ? 'followup' : 'title';
	      var titleWithUser = formatMessage(_strings.ACTIONS.program[titleRef], {
	        user: displayableName
	      });
	
	      return (
	        // If the child is a button and its parent is a div with role ="button"
	        // it causes accessibility problems that reason why I add condition isButton
	        _react2.default.createElement(
	          'div',
	          null,
	          isProgram || isButton ? _react2.default.createElement(
	            'div',
	            {
	              className: 'di',
	              onClick: isButton ? this.handleOpenPopup : function () {}
	            },
	            this.props.children
	          ) : _react2.default.createElement(
	            _index2.default,
	            {
	              onClick: this.handleOpenPopup,
	              className: 'di',
	              hoverable: true,
	              ariaLabel: 'review'
	            },
	            this.props.children
	          ),
	          this.state.isOpened ? _react2.default.createElement(_ProgramPopupContent2.default, {
	            title: titleWithUser,
	            onClose: this.handleClosePopup,
	            date: date,
	            surveyPopup: this.getSurveyPopup(),
	            surveysLoading: surveysLoading,
	            targetFormLoading: targetFormLoading,
	            program: program,
	            contextStore: this.context.store,
	            children: _react2.default.createElement(
	              'div',
	              { ref: function ref(node) {
	                  return _this4.node = node;
	                } },
	              this.getSurveyPopup()
	            )
	          }) : null
	        )
	      );
	    }
	  }, {
	    key: 'isProviderPostVisitForm',
	    get: function get() {
	      var targetForm = this.props.targetForm;
	
	      return targetForm.surveyType === _constants.SURVEY_TYPES.PROVIDER_POST_VISIT;
	    }
	  }]);
	  return ProgramPopup;
	}(_react.PureComponent), _class3.contextTypes = {
	  store: _propTypes2.default.object
	}, _class3.propTypes = {
	  date: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  program: _propTypes2.default.object,
	  surveys: _propTypes2.default.array,
	  openedSurveyId: _propTypes2.default.number,
	  openedAssignmentId: _propTypes2.default.number,
	  forceFetch: _propTypes2.default.bool,
	  targetUserId: _propTypes2.default.number,
	  surveysLoading: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  targetUser: _propTypes2.default.shape({
	    displayableName: _propTypes2.default.string
	  }),
	  pdfExportable: _propTypes2.default.bool,
	  exportToPDF: _propTypes2.default.func,
	  clearExportToPDF: _propTypes2.default.func,
	  export: _propTypes2.default.shape({
	    sending: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool,
	    blob: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
	  }),
	  children: _propTypes2.default.any,
	  targetForm: _propTypes2.default.object,
	  targetFormLoading: _propTypes2.default.bool,
	  activeChannelId: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  isButton: _propTypes2.default.bool
	}, _class3.childContextTypes = {
	  intl: _propTypes2.default.object
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleOpenPopup', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleOpenPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleClosePopup', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleClosePopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getSurveyPopup', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getSurveyPopup'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = ProgramPopup;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RadioMark = __webpack_require__(1192);
	
	var _RadioMark2 = _interopRequireDefault(_RadioMark);
	
	var _browserChecker = __webpack_require__(356);
	
	var _index = __webpack_require__(1511);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IS_IE = (0, _browserChecker.isIE)();
	
	var Input = function Input(_ref) {
	  var size = _ref.size,
	      color = _ref.color,
	      onChange = _ref.onChange,
	      rest = (0, _objectWithoutProperties3.default)(_ref, ['size', 'color', 'onChange']);
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('input', (0, _extends3.default)({
	      type: 'radio'
	    }, rest, {
	      styleName: (0, _classnames2.default)({ input: !IS_IE }),
	      onChange: onChange
	    })),
	    !IS_IE ? _react2.default.createElement(
	      'div',
	      { styleName: 'checker' },
	      _react2.default.createElement(_RadioMark2.default, (0, _extends3.default)({ size: size, color: color }, { checked: true })),
	      _react2.default.createElement(_RadioMark2.default, { size: size, color: color })
	    ) : null
	  );
	};
	
	Input.propTypes = {
	  onChange: _propTypes2.default.func,
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.number
	};
	
	exports.default = (0, _reactCssModules2.default)(Input, _index2.default, { allowMultiple: true });

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(1511);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioMark = function RadioMark(_ref) {
	  var checked = _ref.checked,
	      size = _ref.size,
	      color = _ref.color;
	
	  var width = size;
	  var height = size;
	  var cx = size / 2;
	  var cy = size / 2;
	  var strokeWidth = 1;
	  var outerRadius = size / 2 - strokeWidth;
	  var innerRadius = outerRadius / 1.6;
	
	  return _react2.default.createElement(
	    'svg',
	    (0, _extends3.default)({ width: width, height: height }, { styleName: checked ? 'checked' : 'unchecked' }),
	    _react2.default.createElement('circle', (0, _extends3.default)({ cx: cx, cy: cy, strokeWidth: strokeWidth }, {
	      r: outerRadius,
	      stroke: checked ? color : _styles.COLORS.fontLighter,
	      fill: 'white'
	    })),
	    checked ? _react2.default.createElement('circle', (0, _extends3.default)({ cx: cx, cy: cy }, { r: innerRadius, fill: color })) : null
	  );
	};
	
	RadioMark.propTypes = {
	  checked: _propTypes2.default.bool,
	  size: _propTypes2.default.number,
	  color: _propTypes2.default.string
	};
	
	RadioMark.defaultProps = {
	  checked: null,
	  size: 12,
	  color: _styles.COLORS.blueMedium
	};
	
	exports.default = (0, _reactCssModules2.default)(RadioMark, _index2.default, { allowMultiple: true });

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isUndefined = __webpack_require__(733);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _Input = __webpack_require__(1191);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _index = __webpack_require__(1511);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioInput = function RadioInput(_ref) {
	  var vertical = _ref.vertical,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['vertical']);
	  return _react2.default.createElement(
	    'label',
	    {
	      htmlFor: other.id,
	      styleName: (0, _classnames2.default)('label', {
	        labelVertical: vertical
	      })
	    },
	    !(0, _isUndefined2.default)(other.label) ? _react2.default.createElement(
	      'span',
	      { styleName: 'labelText' },
	      other.label
	    ) : null,
	    _react2.default.createElement(_Input2.default, other)
	  );
	};
	
	RadioInput.propTypes = {
	  vertical: _propTypes2.default.bool
	};
	
	RadioInput.defaultProps = {
	  vertical: null
	};
	
	exports.default = (0, _reactCssModules2.default)(RadioInput, _index2.default, { allowMultiple: true });

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(5222);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/button-has-type,react/require-default-props */
	var ReadMoreBtn = function ReadMoreBtn(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      onClick = _ref.onClick,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['intl', 'onClick']);
	  var showMore = _strings.ACTIONS.program.showMore;
	
	  var children = formatMessage(showMore) + '...';
	
	  return _react2.default.createElement('button', (0, _extends3.default)({ styleName: 'root' }, { onClick: onClick, children: children }, other));
	};
	
	ReadMoreBtn.propTypes = {
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(ReadMoreBtn, _index2.default, { allowMultiple: true }));

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectedSizeInfo = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _index = __webpack_require__(2282);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectedSizeInfo = exports.SelectedSizeInfo = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _recompose.branch)(function (_ref) {
	  var size = _ref.size;
	  return !size;
	}, _recompose.renderNothing), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(function (_ref2) {
	  var formatMessage = _ref2.intl.formatMessage,
	      textId = _ref2.textId,
	      size = _ref2.size;
	  return _react2.default.createElement(
	    'span',
	    { styleName: 'label label--selected' },
	    formatMessage(textId, {
	      counter: size
	    })
	  );
	});

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchDialog = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SearchDialogImpl = __webpack_require__(1841);
	
	var _SearchDialogImpl2 = _interopRequireDefault(_SearchDialogImpl);
	
	var _enhance = __webpack_require__(3875);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchDialog = exports.SearchDialog = (0, _enhance.enhance)(_SearchDialogImpl2.default);

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(58);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _strings = __webpack_require__(15);
	
	var _useForm2 = __webpack_require__(3903);
	
	var _sanitizeHtml = __webpack_require__(313);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _chat = __webpack_require__(67);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ValidationError = __webpack_require__(500);
	
	var _ValidationError2 = _interopRequireDefault(_ValidationError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextMessageForm = function TextMessageForm(_ref) {
	  var formatMessage = _ref.formatMessage,
	      onSendMessage = _ref.onSendMessage,
	      onClose = _ref.onClose,
	      className = _ref.className;
	
	  var initialValues = {
	    message: ''
	  };
	
	  var onSubmit = function onSubmit(values) {
	    var modifiedValue = (0, _sanitizeHtml2.default)(values.message, true);
	    onClose();
	    onSendMessage(modifiedValue);
	  };
	
	  var validate = function validate(fieldName, value) {
	    var error = void 0;
	    if (value.length > _chat.MESSAGE_MAX_LENGTH) {
	      error = formatMessage({ id: 'chat.errors.tooLong' }, { length: _chat.MESSAGE_MAX_LENGTH });
	    }
	    return error;
	  };
	
	  var _useForm = (0, _useForm2.useForm)({
	    initialValues: initialValues,
	    onSubmit: onSubmit,
	    validate: validate
	  }),
	      values = _useForm.values,
	      errors = _useForm.errors,
	      handleChange = _useForm.handleChange,
	      handleSubmit = _useForm.handleSubmit;
	
	  var disabled = Boolean(errors.message) || !(0, _lodash.trim)(values.message);
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit, className: (0, _classnames2.default)(className, 'w-100') },
	    _react2.default.createElement(_TextInput2.default, {
	      placeholder: formatMessage(_strings.CHAT.placeholders.default),
	      rows: 4,
	      textarea: true,
	      name: 'message',
	      value: values.message,
	      onChange: function onChange(text) {
	        return handleChange('message', text);
	      },
	      rounded: true
	    }),
	    _react2.default.createElement(_ValidationError2.default, { content: errors.message }),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt3' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'mr3',
	          raised: true,
	          color: 'primary',
	          type: 'submit',
	          disabled: disabled
	        },
	        formatMessage(_strings.COMMON.send)
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { raised: true, color: 'accent', onClick: onClose },
	        formatMessage(_strings.COMMON.cancel)
	      )
	    )
	  );
	};
	
	TextMessageForm.propTypes = {
	  formatMessage: _propTypes2.default.func,
	  onSendMessage: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  className: _propTypes2.default.string
	};
	
	TextMessageForm.defaultProps = {
	  className: 'mb3'
	};
	
	exports.default = TextMessageForm;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTimekeeper = __webpack_require__(6320);
	
	var _reactTimekeeper2 = _interopRequireDefault(_reactTimekeeper);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(5236);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimePicker(_ref) {
	  var time = _ref.time,
	      _onChange = _ref.onChange,
	      format = _ref.format;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(_reactTimekeeper2.default, {
	      time: time,
	      onChange: function onChange(data) {
	        return _onChange(data[format]);
	      },
	      coarseMinutes: true
	    })
	  );
	}
	
	TimePicker.propTypes = {
	  time: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  format: _propTypes2.default.string
	};
	
	TimePicker.defaultProps = {
	  format: 'formatted12'
	};
	
	exports.default = (0, _reactCssModules2.default)(TimePicker, _index2.default, { allowMultiple: true });

/***/ }),
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var INITIAL_INSURANCE_CARD_STATE = exports.INITIAL_INSURANCE_CARD_STATE = {
	  url: null,
	  thumbMin: null,
	  thumbMiddle: null,
	  thumbLarge: null
	};

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INITIAL_INSURANCE_FORM_STATE = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _INITIAL_INSURANCE_FO;
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADDRESS_1 = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.ADDRESS_1,
	    ADDRESS_2 = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.ADDRESS_2,
	    CITY = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.CITY,
	    DOB = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DOB,
	    DO_NOT_HAVE_INSURANCE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DO_NOT_HAVE_INSURANCE,
	    FIRST_NAME = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.FIRST_NAME,
	    GENDER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GENDER,
	    GROUP_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GROUP_NUMBER,
	    HEALTH_PLAN = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.HEALTH_PLAN,
	    INSURANCE_RELATION_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.INSURANCE_RELATION_ID,
	    LAST_NAME = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.LAST_NAME,
	    MEMBER_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.MEMBER_ID,
	    PHONE_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PHONE_NUMBER,
	    POSTAL_CODE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.POSTAL_CODE,
	    PRIMARY_SUBSCRIBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PRIMARY_SUBSCRIBER,
	    STATE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.STATE;
	var INITIAL_INSURANCE_FORM_STATE = exports.INITIAL_INSURANCE_FORM_STATE = (_INITIAL_INSURANCE_FO = {}, (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, ADDRESS_1, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, ADDRESS_2, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, CITY, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, DOB, null), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, DO_NOT_HAVE_INSURANCE, false), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, FIRST_NAME, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, GENDER, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, GROUP_NUMBER, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, HEALTH_PLAN, null), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, INSURANCE_RELATION_ID, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, LAST_NAME, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, MEMBER_ID, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, PHONE_NUMBER, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, POSTAL_CODE, ''), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, PRIMARY_SUBSCRIBER, true), (0, _defineProperty3.default)(_INITIAL_INSURANCE_FO, STATE, ''), _INITIAL_INSURANCE_FO);

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VALIDATION_ICONS = exports.PASSWORD_STATUS = exports.PASSWORD_RULES = undefined;
	
	var _validations = __webpack_require__(81);
	
	var _styles = __webpack_require__(18);
	
	var PASSWORD_RULES = exports.PASSWORD_RULES = [{
	  rule: _validations.PATTERNS.PASSWORD.LOWER_CASE_CHARACTER,
	  title: 'password.validation.lowerCase'
	}, {
	  rule: _validations.PATTERNS.PASSWORD.UPPER_CASE_CHARACTER,
	  title: 'password.validation.upperCase'
	}, {
	  rule: _validations.PATTERNS.PASSWORD.NUMERIC_CHARACTER,
	  title: 'password.validation.number'
	}, {
	  rule: _validations.PATTERNS.PASSWORD.SPECIAL_CHARACTER,
	  title: 'password.validation.specCharacter'
	}, {
	  rule: _validations.PATTERNS.PASSWORD.MIN_LENGTH,
	  title: 'password.validation.charactersNumber'
	}];
	
	var PASSWORD_STATUS = exports.PASSWORD_STATUS = {
	  DEFAULT: 'default',
	  DANGER: 'danger',
	  DONE: 'done'
	};
	
	var VALIDATION_ICONS = exports.VALIDATION_ICONS = {
	  danger: {
	    name: 'close-bold',
	    color: { fill: _styles.COLORS.orangePink }
	  },
	  done: {
	    name: 'check-b',
	    color: { fill: _styles.COLORS.greenLime }
	  },
	  default: {
	    name: 'bullet',
	    color: { fill: _styles.COLORS.black }
	  }
	};

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var VAULT_ACCOUNT_TYPES = exports.VAULT_ACCOUNT_TYPES = {
	  mc: 'MasterCard',
	  visa: 'Visa',
	  amex: 'American Express',
	  disc: 'Discover',
	  jcb: 'JCB (Japan Credit Bureau)',
	  diners: 'Diners Club'
	};
	
	var UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE = exports.UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE = 'Unknown';

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useSignAppointmentConsent = function useSignAppointmentConsent(_ref) {
	  var consentId = _ref.consentId,
	      userId = _ref.userId,
	      consentVersion = _ref.consentVersion;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  return (0, _react.useCallback)(function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        outcomeTitle = _ref2.outcomeTitle;
	
	    var consentPayload = (0, _extends3.default)({}, outcomeTitle ? { outcome_title: outcomeTitle } : {});
	
	    dispatch(_signAppointmentConsentReq.actions.send({
	      consentId: consentId,
	      user_consent_info: (0, _extends3.default)({
	        accepted: true,
	        user_id: userId,
	        version: consentVersion
	      }, consentPayload)
	    }));
	  }, [dispatch, consentId, userId, consentVersion]);
	};
	
	exports.default = useSignAppointmentConsent;

/***/ }),
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRedux = __webpack_require__(6);
	
	var _getPatientInsurancesList = __webpack_require__(671);
	
	var useIsAdditionalInsurancesEnabledAndMaxNumber = function useIsAdditionalInsurancesEnabledAndMaxNumber() {
	  var isAdditionalInsurancesEnabled = (0, _reactRedux.useSelector)(_getPatientInsurancesList.selectIsAdditionalInsurancesEnabled);
	
	  var maxAdditionalInsurancesNumber = (0, _reactRedux.useSelector)(_getPatientInsurancesList.selectAdditionalInsurancesMaxNumber);
	
	  return { isAdditionalInsurancesEnabled: isAdditionalInsurancesEnabled, maxAdditionalInsurancesNumber: maxAdditionalInsurancesNumber };
	};
	
	exports.default = useIsAdditionalInsurancesEnabledAndMaxNumber;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _debounce = __webpack_require__(176);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _reactRedux = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INITIAL_PARAMS = { limit: 50, offset: 0, query: '' };
	
	var useAsyncPaginatedSelect = function useAsyncPaginatedSelect(_ref) {
	  var additionalRequestParams = _ref.additionalRequestParams,
	      clearEntitiesAction = _ref.clearEntitiesAction,
	      defaultOption = _ref.defaultOption,
	      entitiesFetchingSucceedSelector = _ref.entitiesFetchingSucceedSelector,
	      entitiesIsLastPageSelector = _ref.entitiesIsLastPageSelector,
	      entitiesLoadingSelector = _ref.entitiesLoadingSelector,
	      entitiesSelector = _ref.entitiesSelector,
	      mapToOptionsFn = _ref.mapToOptionsFn,
	      sendAction = _ref.sendAction;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(INITIAL_PARAMS),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      searchParams = _useState2[0],
	      setSearchParams = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      hasEntities = _useState4[0],
	      setHasEntities = _useState4[1];
	
	  var entities = (0, _reactRedux.useSelector)(entitiesSelector);
	
	  var isLoading = (0, _reactRedux.useSelector)(entitiesLoadingSelector);
	
	  var isLastPage = (0, _reactRedux.useSelector)(entitiesIsLastPageSelector);
	
	  var isFetchingSucceed = (0, _reactRedux.useSelector)(entitiesFetchingSucceedSelector);
	
	  (0, _react.useEffect)(function () {
	    if (entities.length) {
	      setHasEntities(true);
	    }
	  }, [entities]);
	
	  var shouldPreselectDefaultOption = (0, _react.useMemo)(function () {
	    return Boolean(!hasEntities && entities.length === 0 && searchParams.query === INITIAL_PARAMS.query && !isLoading && isFetchingSucceed);
	  }, [searchParams, entities, isLoading, isFetchingSucceed, hasEntities]);
	
	  var fetchEntities = (0, _react.useCallback)(function (params) {
	    if (params.offset === 0) {
	      dispatch(clearEntitiesAction());
	    }
	
	    dispatch(sendAction((0, _extends3.default)({}, params, additionalRequestParams)));
	  }, [dispatch, sendAction, clearEntitiesAction, additionalRequestParams]);
	
	  var convertedEntities = entities.map(mapToOptionsFn);
	
	  var debouncedFetchEntities = (0, _react.useMemo)(function () {
	    return (0, _debounce2.default)(fetchEntities, 500);
	  }, [fetchEntities]);
	
	  var handleInputChange = function handleInputChange(value) {
	    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        action = _ref2.action;
	
	    if (action !== 'input-change') return;
	
	    var params = (0, _extends3.default)({}, searchParams, { query: value, offset: 0 });
	
	    setSearchParams(params);
	
	    debouncedFetchEntities.cancel();
	    debouncedFetchEntities(params);
	  };
	
	  var handleMenuScrollToBottom = function handleMenuScrollToBottom() {
	    if (isLastPage || isLoading) return;
	
	    var params = (0, _extends3.default)({}, searchParams, {
	      offset: searchParams.offset + searchParams.limit
	    });
	
	    setSearchParams(params);
	
	    debouncedFetchEntities(params);
	  };
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      debouncedFetchEntities.cancel();
	    };
	  }, [debouncedFetchEntities]);
	
	  (0, _react.useEffect)(function () {
	    fetchEntities(INITIAL_PARAMS);
	
	    return function () {
	      dispatch(clearEntitiesAction());
	    };
	  }, []);
	
	  return {
	    isLoading: isLoading,
	    handleMenuScrollToBottom: handleMenuScrollToBottom,
	    handleInputChange: handleInputChange,
	    entities: defaultOption != null ? [defaultOption].concat((0, _toConsumableArray3.default)(convertedEntities)) : convertedEntities,
	    shouldPreselectDefaultOption: shouldPreselectDefaultOption
	  };
	};
	
	exports.default = useAsyncPaginatedSelect;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(23);
	
	var useIsLoggedInUser = function useIsLoggedInUser() {
	  var targetUserId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	
	  var loggedInUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	
	  return (0, _react.useMemo)(function () {
	    return targetUserId === loggedInUserId;
	  }, [targetUserId, loggedInUserId]);
	};
	
	exports.default = useIsLoggedInUser;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTranslationMessages = exports.appLocales = exports.DEFAULT_LOCALE = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _en = __webpack_require__(5357);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _es = __webpack_require__(5358);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _zh = __webpack_require__(5359);
	
	var _zh2 = _interopRequireDefault(_zh);
	
	var _env = __webpack_require__(103);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_LOCALE = exports.DEFAULT_LOCALE = 'en';
	var appLocales = exports.appLocales = ['en', 'es', 'zh'];
	
	var insertAppConsts = function insertAppConsts(string) {
	  var consts = {
	    appName: _env.APP_NAME,
	    brandName: _brandConfig2.default.name
	  };
	
	  return (0, _keys2.default)(consts).reduce(function (updatedString, name) {
	    var re = new RegExp('{' + name + '}', 'g');
	
	    return updatedString.replace(re, consts[name]);
	  }, string);
	};
	
	var formatTranslationMessages = function formatTranslationMessages(locale, messages) {
	  var defaultFormattedMessages = locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, _en2.default) : {};
	
	  return (0, _keys2.default)(messages).reduce(function (formattedMessages, key) {
	    var formattedMessage = !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];
	
	    return (0, _assign2.default)(formattedMessages, (0, _defineProperty3.default)({}, key, insertAppConsts(formattedMessage)));
	  }, {});
	};
	
	var getTranslationMessages = exports.getTranslationMessages = function getTranslationMessages() {
	  return {
	    en: formatTranslationMessages('en', _en2.default),
	    es: formatTranslationMessages('es', _es2.default),
	    zh: formatTranslationMessages('zh', _zh2.default)
	  };
	};

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appointmentPaymentInfoModalActions = exports.APPOINTMENT_PAYMENT_INFO_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'appointment/payment-info-modal';
	
	var APPOINTMENT_PAYMENT_INFO_MODAL = exports.APPOINTMENT_PAYMENT_INFO_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close',
	  UPDATE_PAYMENT_ORDER_ID: actionsScope + '/update-payment-order-id'
	};
	
	var appointmentPaymentInfoModalActions = exports.appointmentPaymentInfoModalActions = {
	  open: (0, _createAction.createAction)(APPOINTMENT_PAYMENT_INFO_MODAL.OPEN),
	  close: (0, _createAction.createAction)(APPOINTMENT_PAYMENT_INFO_MODAL.CLOSE),
	  updatePaymentOrderId: (0, _createAction.createAction)(APPOINTMENT_PAYMENT_INFO_MODAL.UPDATE_PAYMENT_ORDER_ID)
	};
	
	var initialState = {
	  opened: false,
	  props: {}
	};
	
	// used for account_form payment method
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case APPOINTMENT_PAYMENT_INFO_MODAL.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          opened: true,
	          props: payload
	        });
	      }
	
	    case APPOINTMENT_PAYMENT_INFO_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    case APPOINTMENT_PAYMENT_INFO_MODAL.UPDATE_PAYMENT_ORDER_ID:
	      {
	        return (0, _extends3.default)({}, state, {
	          props: (0, _extends3.default)({}, state.props, {
	            paymentOrderId: payload
	          })
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.overlapModalActions = exports.OVERLAP_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'appointment-form/overlap-modal';
	
	var OVERLAP_MODAL = exports.OVERLAP_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var overlapModalActions = exports.overlapModalActions = {
	  open: (0, _createAction.createAction)(OVERLAP_MODAL.OPEN),
	  close: (0, _createAction.createAction)(OVERLAP_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case OVERLAP_MODAL.OPEN:
	      {
	        return {
	          opened: true,
	          entity: payload
	        };
	      }
	
	    case OVERLAP_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, state, {
	          opened: false
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'accept-consent');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: ['consents', {
	    type: 'payload',
	    selector: ['concentId']
	  }, 'user_consent_info']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          sending: true
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: payload,
	          sending: false,
	          succeed: true
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'available-eir-slots-request');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'eir_urgent_care', 'slots', {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'visit_type_id',
	    selector: 'visitTypeId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'reason_type_id',
	    selector: 'reasonTypeId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'location_ids',
	    selector: 'locationIds'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'date',
	    selector: 'date'
	  }]
	});

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          sending: true
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: payload,
	          sending: false,
	          succeed: true
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'available-providers-self-scheduling-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'available_providers', 'slots', {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'visit_type_id',
	    selector: 'visitTypeId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'reason_type_id',
	    selector: 'reasonTypeId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'location_ids',
	    selector: 'locationIds'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'provider_profile_id',
	    selector: 'providerProfileId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'date',
	    selector: 'date'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'pbv_config_id',
	    selector: 'pbvConfigId'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState);

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'care_users-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'healthboard', 'under_care_users']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'get-copay');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'unscheduled', 'cost']
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_SERVICE:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      return _redux.initialState;
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'filters-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['locations', {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'visit_type_id',
	    selector: 'visitTypeId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'inspect-patient');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: ['form_inspections']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true
	        });
	      }
	
	    case consts.CLEAR:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _inspectionNormalizer = __webpack_require__(1863);
	
	var _inspectionNormalizer2 = _interopRequireDefault(_inspectionNormalizer);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'inspection-virtual-visit-form');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'virtual_visits', 'inspection']
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState);

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'necessary-data-preparing-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'necessary_data_preparing']
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeRequestConfig = function makeRequestConfig() {
	  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return {
	    endpoint: 'patients',
	    type: 'get',
	    slug: [{
	      type: 'payload',
	      selector: ['patientUserId']
	    }, 'primary_care_provider', {
	      type: 'payload.query',
	      queryParameter: 'organization_id',
	      selector: 'organizationId'
	    }].concat((0, _toConsumableArray3.default)(slug))
	  };
	};
	
	var requestOptions = makeRequestConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'primary-provider-data');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  data: {
	    answer: null,
	    considerUs: null,
	    pcpName: null,
	    primaryCareProvider: null
	  }
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      return (0, _extends3.default)({}, state, {
	        succeed: true,
	        sending: false,
	        data: payload
	      });
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.paginationWatcher = exports.paginationActions = exports.paginationConsts = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeRequestConfig = function makeRequestConfig() {
	  var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return {
	    endpoint: 'organizations',
	    type: 'get',
	    slug: [{
	      type: 'payload',
	      selector: ['id']
	    }, 'primary_care_providers', {
	      type: 'payload.query',
	      queryParameter: 'query',
	      selector: 'query'
	    }, {
	      type: 'payload.query',
	      queryParameter: 'limit',
	      selector: 'limit'
	    }].concat((0, _toConsumableArray3.default)(slug))
	  };
	};
	
	var requestOptions = makeRequestConfig([{
	  type: 'payload.query',
	  queryParameter: 'offset',
	  selector: 'offset'
	}]);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'primary-providers-list-request', ['LOAD_MORE']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	var paginationConsts = exports.paginationConsts = (0, _redux.createReqConsts)('appointment-form', 'primary-providers-list-lazy-load-request');
	
	var paginationActions = exports.paginationActions = (0, _redux.createActions)(paginationConsts);
	
	var paginationWatcher = exports.paginationWatcher = (0, _redux.createReqWatcher)(paginationConsts, paginationActions, requestOptions, true);
	
	var defaultRequestReducer = (0, _redux.makePaginationReducer)({
	  consts: consts,
	  paginationConsts: paginationConsts,
	  counterKey: 'total'
	});
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  count: 0,
	  isLastPage: false
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      return (0, _extends3.default)({}, state, {
	        succeed: true,
	        sending: false,
	        list: state.list && state.list.length !== 0 ? state.list.concat(payload) : payload
	      });
	
	    case consts.ADD_META:
	      {
	        var total = (0, _get2.default)(action.payload, 'total', 0);
	
	        return (0, _extends3.default)({}, state, {
	          count: total,
	          isLastPage: state.list.length === total
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      return defaultRequestReducer(state, action);
	  }
	};

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          sending: true
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: payload,
	          sending: false,
	          succeed: true
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'providers-details-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'available_providers', 'slots', {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'visit_type_id',
	    selector: 'visitTypeId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'reason_type_id',
	    selector: 'reasonTypeId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'location_ids',
	    selector: 'locationIds'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'provider_profile_id',
	    selector: 'providerProfileId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'date',
	    selector: 'date'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'priority_location_id',
	    selector: 'priorityLocationId'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState);

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'publix-info');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'guides',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['visitCode']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'reason_visit-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['reasons_for_visits', {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SEND:
	      {
	        return (0, _extends3.default)({}, initialState, {
	          sending: true
	        });
	      }
	
	    case consts.SUCCEED:
	      {
	        var availableProviders = payload.availableProviders,
	            meta = (0, _objectWithoutProperties3.default)(payload, ['availableProviders']);
	
	        var _normalize = (0, _schedulingsNormalizer2.default)(availableProviders),
	            ids = _normalize.result,
	            entities = _normalize.entities.availableProviders;
	
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true,
	          ids: ids,
	          entities: entities,
	          meta: meta
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};
	
	var _redux = __webpack_require__(7);
	
	var _schedulingsNormalizer = __webpack_require__(3919);
	
	var _schedulingsNormalizer2 = _interopRequireDefault(_schedulingsNormalizer);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'schedulings-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'schedulings']
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  meta: {},
	  ids: [],
	  entities: {}
	});

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'virtual-visit-providers');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'appointments', 'virtual_visits', 'providers']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionsScope = 'AUTH/CHANGE_PASSWORD';
	
	var CHANGE_PASSWORD_TYPES = exports.CHANGE_PASSWORD_TYPES = {
	  PROCEED: actionsScope + '/PROCEED',
	  CONFIRM: actionsScope + '/CONFIRM'
	};

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectChangePasswordProcessFormData = exports.selectChangePasswordProcess = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectAuthState = function selectAuthState(state) {
	  return (0, _get2.default)(state, 'auth');
	};
	
	var selectChangePasswordProcess = exports.selectChangePasswordProcess = (0, _reselect.createSelector)(selectAuthState, function (auth) {
	  return (0, _get2.default)(auth, 'changePasswordProcess');
	});
	
	var selectChangePasswordProcessFormData = exports.selectChangePasswordProcessFormData = (0, _reselect.createSelector)(selectChangePasswordProcess, function (state) {
	  return (0, _get2.default)(state, 'changePasswordFormData');
	});

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reducer = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'create-password');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users/reset_password',
	  slug: [{
	    type: 'payload',
	    selector: ['token']
	  }],
	  type: 'put'
	});
	
	var reducer = exports.reducer = (0, _redux.createReqReducer)(consts);
	exports.default = (0, _redux.locationReducer)(reducer);

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reducer = exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'reset-password');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users/reset_password'
	});
	
	var reducer = exports.reducer = (0, _redux.createReqReducer)(consts);
	exports.default = (0, _redux.locationReducer)(reducer);

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'session-refresh');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users/sessions',
	  type: 'put'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	// PUT /api/users/sessions

/***/ }),
/* 1243 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionsScope = 'AUTH/REGISTRATION';
	
	var SIGN_UP_TYPES = exports.SIGN_UP_TYPES = {
	  PERSONAL_INFO_CHANGE: actionsScope + '/PERSONAL_INFO_CHANGE',
	  PROCEED: actionsScope + '/PROCEED',
	  CONFIRM: actionsScope + '/CONFIRM',
	  RESET: actionsScope + '/RESET'
	};

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.invitationMethods = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _snakeCase = __webpack_require__(467);
	
	var _snakeCase2 = _interopRequireDefault(_snakeCase);
	
	var _login = __webpack_require__(402);
	
	var _loginAzure = __webpack_require__(340);
	
	var _logout = __webpack_require__(198);
	
	var _signupReq = __webpack_require__(341);
	
	var _editUser = __webpack_require__(136);
	
	var _editPatient = __webpack_require__(218);
	
	var _editProvider = __webpack_require__(424);
	
	var _createPatient = __webpack_require__(679);
	
	var _paperworkVerifyDob = __webpack_require__(676);
	
	var _paperworkAppointmentSession = __webpack_require__(673);
	
	var _props = __webpack_require__(41);
	
	var _storageKeys = __webpack_require__(215);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var invitationMethods = exports.invitationMethods = {
	  phoneNumber: 'phone_number',
	  email: 'email'
	};
	
	// actions
	/* eslint-disable */
	
	var LOGIN = _login.consts.SUCCEED;
	var LOGIN_AZURE = _loginAzure.consts.SUCCEED;
	var LOGOUT = _logout.consts.SUCCEED;
	var ACCEPT_INVITATION = _signupReq.consts.SUCCEED;
	var EDIT_USER = _editUser.consts.SUCCEED;
	var CREATE_PATIENT = _createPatient.consts.SUCCEED;
	var EDIT_PATIENT = _editPatient.consts.SUCCEED;
	var EDIT_PROVIDER = _editProvider.consts.SUCCEED;
	var LOGOUT_CLEAR = _logout.consts.CLEAR;
	var UPDATE_PASSWORD = _login.consts.UPDATE_PASSWORD;
	var PAPERWORK_FLOW_DOB_VERIFIED = _paperworkVerifyDob.consts.SUCCEED;
	var PAPERWORK_FLOW_AUTHORIZED_VERIFIED = _paperworkAppointmentSession.consts.SUCCEED;
	
	// retrieved data
	var authenticationToken = window.storage.getItem('authenticationToken');
	var loggedIn = window.storage.getItem('loggedIn');
	var organizationId = window.storage.getItem('organizationId');
	var communityId = window.storage.getItem('communityId');
	var isFamilyMemberInvitation = window.storage.getItem('isFamilyMemberInvitation');
	var isCommunityMemberInvitation = window.storage.getItem('isCommunityMemberInvitation');
	var invitationType = window.storage.getItem('invitationType');
	var isRegistrationCompleted = window.storage.getItem(_storageKeys.REGISTRATION_COMPLETED);
	var isRequestPasswordUpdate = window.storage.getItem(_storageKeys.REQUEST_PASSWORD_UPDATE);
	
	var initialState = {
	  authenticationToken: authenticationToken ? JSON.parse(authenticationToken) : null,
	  requestPasswordUpdate: isRequestPasswordUpdate ? JSON.parse(isRequestPasswordUpdate) : true,
	  registrationCompleted: isRegistrationCompleted ? JSON.parse(isRegistrationCompleted) : false,
	  loggedIn: loggedIn ? JSON.parse(loggedIn) : false,
	  organizationId: organizationId ? JSON.parse(organizationId) : null,
	  communityId: communityId ? JSON.parse(communityId) : null,
	  isFamilyMemberInvitation: isFamilyMemberInvitation ? JSON.parse(isFamilyMemberInvitation) : false,
	  invitationType: invitationType ? JSON.parse(invitationType) : false,
	  isCommunityMemberInvitation: isCommunityMemberInvitation ? JSON.parse(isCommunityMemberInvitation) : false
	};
	
	var logoutState = {
	  authenticationToken: null,
	  loggedIn: false,
	  organizationId: null,
	  communityId: null,
	  loggedUserId: null,
	  isFamilyMemberInvitation: false,
	  invitationType: null,
	  isCommunityMemberInvitation: false,
	  requestPasswordUpdate: false,
	  registrationCompleted: false
	};
	
	var handleLogin = function handleLogin(state, payload) {
	  var user = payload.user,
	      authenticationToken = payload.authenticationToken,
	      requestPasswordUpdate = payload.requestPasswordUpdate,
	      registrationCompleted = payload.registrationCompleted;
	  var id = user.id;
	
	  return (0, _extends3.default)({}, state, {
	    authenticationToken: authenticationToken,
	    registrationCompleted: registrationCompleted,
	    requestPasswordUpdate: requestPasswordUpdate,
	    loggedIn: !requestPasswordUpdate && registrationCompleted,
	    loggedUserId: id
	  });
	};
	
	var handleAccept = function handleAccept(state, payload) {
	  var context = payload.context,
	      authentication = payload.authentication,
	      organizationId = payload.organizationId,
	      communityId = payload.communityId,
	      invitationMethod = payload.type;
	
	  var authenticationToken = (0, _get2.default)(authentication, 'authenticationToken', null);
	  var isFamilyMemberInvitation = context === (0, _snakeCase2.default)('familyMemberInvitation');
	  var isCommunityMemberInvitation = context === (0, _snakeCase2.default)('communityMemberInvitation');
	  var invitationType = context;
	
	  var loggedIn = false;
	  var redirectTo = _routes.SIGNUP;
	
	  if ([_props.INVITATION_TYPES.PATIENT, _props.INVITATION_TYPES.PROVIDER].includes(invitationType) && authentication.registrationCompleted) {
	    loggedIn = true;
	    redirectTo = _routes.HEALTHBOARD;
	  }
	
	  var newState = (0, _extends3.default)({}, state, {
	    authenticationToken: authenticationToken,
	    organizationId: organizationId,
	    communityId: communityId,
	    isFamilyMemberInvitation: isFamilyMemberInvitation,
	    redirectTo: redirectTo,
	    loggedIn: loggedIn,
	    invitationType: invitationType,
	    invitationMethod: invitationMethod,
	    isCommunityMemberInvitation: isCommunityMemberInvitation,
	    registrationCompleted: true
	  });
	
	  return newState;
	};
	
	var handleUser = function handleUser(state, payload) {
	  var isFamilyMemberInvitation = state.isFamilyMemberInvitation,
	      loggedIn = state.loggedIn,
	      redirectTo = state.redirectTo,
	      isCommunityMemberInvitation = state.isCommunityMemberInvitation;
	
	  // avoid updating user profile in logged mode
	
	  if (!loggedIn) {
	    var primaryPatientProfile = (0, _get2.default)(payload, 'primaryPatientProfile', null);
	    var needToCreatePatient = (isFamilyMemberInvitation || isCommunityMemberInvitation) && !primaryPatientProfile;
	    loggedIn = !needToCreatePatient;
	    redirectTo = _routes.HEALTHBOARD;
	  }
	
	  var newState = (0, _extends3.default)({}, state, {
	    loggedIn: loggedIn,
	    redirectTo: redirectTo
	  });
	
	  return newState;
	};
	
	var handlePatientProfile = function handlePatientProfile(state) {
	  var loggedIn = state.loggedIn;
	
	  // avoid updating patient profile in logged mode
	
	  if (!loggedIn) {
	    loggedIn = true;
	  }
	
	  var newState = (0, _extends3.default)({}, state, {
	    loggedIn: loggedIn,
	    redirectTo: _routes.CIRCLES,
	    organizationId: null,
	    communityId: null,
	    registrationCompleted: true,
	    isFamilyMemberInvitation: null,
	    isCommunityMemberInvitation: null
	  });
	
	  return newState;
	};
	
	var handleProviderProfile = function handleProviderProfile(state) {
	  var newState = (0, _extends3.default)({}, state, {
	    loggedIn: true,
	    redirectTo: _routes.HEALTHBOARD
	  });
	
	  return newState;
	};
	
	var updatePassword = function updatePassword(state) {
	  return (0, _extends3.default)({}, state, {
	    registrationCompleted: true,
	    requestPasswordUpdate: false
	  });
	};
	
	var handlePaperworkFlowLogin = function handlePaperworkFlowLogin(state, payload) {
	  var authenticationToken = payload.authenticationToken,
	      user = payload.user;
	  var id = user.id;
	
	
	  return (0, _extends3.default)({}, state, {
	    authenticationToken: authenticationToken,
	    loggedIn: true,
	    loggedUserId: id,
	    registrationCompleted: true,
	    requestPasswordUpdate: false
	  });
	};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case LOGIN_AZURE:
	    case LOGIN:
	      return handleLogin(state, payload);
	    case UPDATE_PASSWORD:
	      return updatePassword(state);
	    case LOGOUT:
	    case LOGOUT_CLEAR:
	      return logoutState;
	    case ACCEPT_INVITATION:
	      return handleAccept(state, payload);
	    case EDIT_USER:
	      return handleUser(state, payload);
	    case CREATE_PATIENT:
	    case EDIT_PATIENT:
	      return handlePatientProfile(state);
	    case EDIT_PROVIDER:
	      return handleProviderProfile(state);
	    case PAPERWORK_FLOW_AUTHORIZED_VERIFIED:
	    case PAPERWORK_FLOW_DOB_VERIFIED:
	      return handlePaperworkFlowLogin(state, payload);
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'create-chat-inbox-task');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'providers',
	  type: 'post',
	  slug: ['inbox_tasks', 'chats']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'dependent-channel-participants');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'impersonated_users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['dependentId']
	  }, 'chat_rooms', {
	    type: 'payload',
	    selector: ['id']
	  }, 'participants']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['GET_CHANNEL_METADATA', 'ADD_CHANNEL_METADATA', 'CLEAR'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['board', 'metadata'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	// init
	var initialState = {};
	
	var addChannelMetadata = function addChannelMetadata(state, action) {
	  var _action$payload = action.payload,
	      channelId = _action$payload.channelId,
	      meta = _action$payload.meta;
	
	
	  if ((0, _isEmpty2.default)(meta)) return state;
	
	  var newUsers = meta.reduce(function (acc, user) {
	    acc[user.id] = user;
	
	    return acc;
	  }, {});
	
	  var newChannelMeta = (0, _assign2.default)({}, state[channelId], newUsers);
	
	  return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, channelId, newChannelMeta));
	};
	
	// reducer
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.ADD_CHANNEL_METADATA:
	      return addChannelMetadata(state, action);
	    case consts.CLEAR:
	      return initialState;
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqAddParticipants');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'chat_rooms',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['channelId']
	  }, 'participants']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqChannels');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'channels',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'type',
	    selector: 'type'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'program',
	    selector: 'program'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'string_query',
	    selector: 'query'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'status',
	    selector: 'statuses'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'excluded_ids',
	    selector: 'excludedIds'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqMetadata');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'chat',
	  type: 'get',
	  slug: ['participant_meta', {
	    type: 'payload.query',
	    queryParameter: 'channel_id',
	    selector: 'channelId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'ids',
	    selector: 'ids'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('board', 'reqRemoveParticipant');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'chat_rooms',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['channelId']
	  }, 'participants', {
	    type: 'payload',
	    selector: ['memberId']
	  }]
	});
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	  var defaultState = reqReducer(state, action);
	
	  switch (type) {
	    case consts.SEND:
	      return (0, _extends3.default)({}, defaultState, {
	        removedMemberId: action.payload.memberId
	      });
	    default:
	      return defaultState;
	  }
	};

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.notInCircleMemberSelector = exports.succeedSelector = exports.sendingSelector = exports.usersSelector = exports.reqAllUsersSelector = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reqAllUsersSelector = exports.reqAllUsersSelector = function reqAllUsersSelector(state) {
	  return state.board.reqAllUsers;
	};
	
	var usersSelector = exports.usersSelector = (0, _reselect.createSelector)(reqAllUsersSelector, function (users) {
	  return (0, _get2.default)(users, 'list', []);
	});
	
	var sendingSelector = exports.sendingSelector = (0, _reselect.createSelector)(reqAllUsersSelector, function (request) {
	  return (0, _get2.default)(request, 'sending') || false;
	});
	
	var succeedSelector = exports.succeedSelector = (0, _reselect.createSelector)(reqAllUsersSelector, function (request) {
	  return (0, _get2.default)(request, 'succeed') || false;
	});
	
	var notInCircleMemberSelector = exports.notInCircleMemberSelector = (0, _reselect.createSelector)(usersSelector, function (users) {
	  return users.map(function (user) {
	    return (0, _extends3.default)({}, user, {
	      provider: true
	    });
	  });
	});

/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var metadataSelector = exports.metadataSelector = function metadataSelector(state) {
	  return state.board.metadata;
	};

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('chat', 'send-message');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'chat',
	  type: 'post',
	  slug: ['messages']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.circleActions = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var _constants = __webpack_require__(512);
	
	var circleActions = exports.circleActions = {
	  inviteToFamilyCircle: (0, _createAction.createAction)(_constants.CIRCLE_ACTION_TYPES.INVITE_TO_FAMILY_CIRCLE),
	  changeRole: (0, _createAction.createAction)(_constants.CIRCLE_ACTION_TYPES.CHANGE_ROLE),
	  removeMember: (0, _createAction.createAction)(_constants.CIRCLE_ACTION_TYPES.REMOVE_MEMBER),
	  leaveCircle: (0, _createAction.createAction)(_constants.CIRCLE_ACTION_TYPES.LEAVE_CIRCLE),
	  assignRole: (0, _createAction.createAction)(_constants.CIRCLE_ACTION_TYPES.ASSIGN_ROLE)
	};

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.activitiesActions = exports.ACTIVITIES_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'communities/activities';
	
	var ACTIVITIES_TYPES = exports.ACTIVITIES_TYPES = {
	  CHANGE_TAB: actionsScope + '/change-tab'
	};
	
	var activitiesActions = exports.activitiesActions = {
	  changeTab: (0, _createAction.createAction)(ACTIVITIES_TYPES.CHANGE_TAB)
	};
	
	var initialState = {
	  activeTab: _constants.ACTIVITY_TYPES.NOTIFICATIONS
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ACTIVITIES_TYPES.CHANGE_TAB:
	      {
	        return (0, _extends3.default)({}, state, {
	          activeTab: action.payload
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var supportedActions = ['GET_COMMENTS', 'GET_NEW_COMMENTS', 'GET_OLDER_COMMENTS'];
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'commentsListFetch', supportedActions);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'posts',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['postId']
	  }, 'comments', {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'communityPreview', ['RESET_COMMUNITY']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'preview']
	});
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  var defaultState = reqReducer(state, action);
	
	  switch (type) {
	    case consts.RESET_COMMUNITY:
	      {
	        return _redux.initialState;
	      }
	    default:
	      return defaultState;
	  }
	};

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(58);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('community', 'currentCommunityScrollStatus', 'SET_SCROLL', 'RESET', 'ADD_TEMPORARY_POST_LIST');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  scrolled: false,
	  temporaryPostList: []
	};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload;
	
	  switch (action.type) {
	    case consts.SET_SCROLL:
	      return (0, _extends3.default)({}, state, {
	        scrolled: payload.scrolled
	      });
	    case consts.RESET:
	      return initialState;
	    case consts.ADD_TEMPORARY_POST_LIST:
	      {
	        var prevList = (0, _lodash.get)(state, 'temporaryPostList');
	        return (0, _extends3.default)({}, state, {
	          temporaryPostList: [].concat((0, _toConsumableArray3.default)(payload), (0, _toConsumableArray3.default)(prevList))
	        });
	      }
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.postDislikedSaga = postDislikedSaga;
	
	var _effects = __webpack_require__(14);
	
	var _redux = __webpack_require__(7);
	
	var _postsList = __webpack_require__(166);
	
	var _postDetails = __webpack_require__(238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(postDislikedWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(postDislikedSaga);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'dislikePost');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'posts',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['postId']
	  }, 'like']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	
	function postDislikedWorker(action) {
	  var payload, currentPostDetailsId;
	  return _regenerator2.default.wrap(function postDislikedWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          _context.next = 3;
	          return (0, _effects.select)(function (state) {
	            return state.communities.postDetails.id;
	          });
	
	        case 3:
	          currentPostDetailsId = _context.sent;
	          _context.next = 6;
	          return (0, _effects.take)(consts.SUCCEED);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)({
	            type: _postsList.consts.POST_LIKE_CHANGED,
	            payload: {
	              liked: false,
	              postId: payload.postId
	            }
	          });
	
	        case 8:
	          if (!(payload.postId === currentPostDetailsId)) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: _postDetails.consts.DISLIKE
	          });
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function postDislikedSaga() {
	  return _regenerator2.default.wrap(function postDislikedSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(consts.SEND, postDislikedWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'user-search', ['CLEAR']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'mass_invitations', 'candidate_users', {
	    type: 'payload.query',
	    queryParameter: 'query',
	    selector: 'query'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'excluded_ids',
	    selector: 'ids'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }]
	}, true);
	
	var reqReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return _redux.initialState;
	
	    default:
	      return reqReducer(state, action);
	  }
	};

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'invite-users');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'communities',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['communityId']
	  }, 'mass_invitations']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.postLikedSaga = postLikedSaga;
	
	var _effects = __webpack_require__(14);
	
	var _redux = __webpack_require__(7);
	
	var _postsList = __webpack_require__(166);
	
	var _postDetails = __webpack_require__(238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(postLikedWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(postLikedSaga);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'likePost');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'posts',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['postId']
	  }, 'like']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	
	function postLikedWorker(action) {
	  var payload, currentPostDetailsId;
	  return _regenerator2.default.wrap(function postLikedWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          _context.next = 3;
	          return (0, _effects.select)(function (state) {
	            return state.communities.postDetails.id;
	          });
	
	        case 3:
	          currentPostDetailsId = _context.sent;
	          _context.next = 6;
	          return (0, _effects.take)(consts.SUCCEED);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)({
	            type: _postsList.consts.POST_LIKE_CHANGED,
	            payload: {
	              liked: true,
	              postId: payload.postId
	            }
	          });
	
	        case 8:
	          if (!(payload.postId === currentPostDetailsId)) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: _postDetails.consts.LIKE
	          });
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function postLikedSaga() {
	  return _regenerator2.default.wrap(function postLikedSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(consts.SEND, postLikedWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.postCommentSaga = postCommentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _redux = __webpack_require__(7);
	
	var _commentsList = __webpack_require__(299);
	
	var _postDetails = __webpack_require__(238);
	
	var _postsList = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(postCommentWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(postCommentSaga);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'postComment');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'posts',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['postId']
	  }, 'comments']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	
	function postCommentWorker(action) {
	  var _action$payload, parentId, postId, succeedAction;
	
	  return _regenerator2.default.wrap(function postCommentWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _action$payload = action.payload, parentId = _action$payload.parentId, postId = _action$payload.postId;
	          _context.next = 3;
	          return (0, _effects.take)(consts.SUCCEED);
	
	        case 3:
	          succeedAction = _context.sent;
	          _context.next = 6;
	          return (0, _effects.put)({
	            type: _commentsList.consts.ADD_COMMENT,
	            payload: (0, _extends3.default)({}, succeedAction.payload, {
	              parentId: parentId
	            })
	          });
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)({
	            type: _postDetails.consts.ADD_COMMENT
	          });
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)({
	            type: _postsList.consts.POST_COMMENTS_CHANGED,
	            payload: {
	              postId: postId,
	              change: 1
	            }
	          });
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function postCommentSaga() {
	  return _regenerator2.default.wrap(function postCommentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(consts.SEND, postCommentWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = updateCurrentCommunitySaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _declineInvitation = __webpack_require__(518);
	
	var _acceptInvitation = __webpack_require__(342);
	
	var _currentCommunityInfo = __webpack_require__(344);
	
	var _reqDiscoverCommunities = __webpack_require__(520);
	
	var _reqJoinCommunity = __webpack_require__(521);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateCurrentCommunityWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateCurrentCommunitySaga);
	
	function updateCurrentCommunityWorker(_ref) {
	  var payload = _ref.payload;
	  var community;
	  return _regenerator2.default.wrap(function updateCurrentCommunityWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          community = (0, _get2.default)(payload, 'community') || payload;
	          _context.next = 3;
	          return (0, _effects.put)({
	            type: _reqDiscoverCommunities.consts.UPDATE_COMMUNITY,
	            payload: community
	          });
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.put)({
	            type: _currentCommunityInfo.consts.UPDATE_CURRENT_COMMUNITY,
	            payload: community
	          });
	
	        case 5:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateCurrentCommunitySaga() {
	  return _regenerator2.default.wrap(function updateCurrentCommunitySaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_declineInvitation.consts.SUCCEED, _acceptInvitation.consts.SUCCEED, _reqJoinCommunity.consts.SUCCEED], updateCurrentCommunityWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendingCommunityPreviewSelector = exports.communityPostsPreviewListSelector = exports.communityPostsListSizeSelector = exports.communityPostsPreviewSelector = exports.communityPreviewSelector = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _index = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var communityPreviewSelector = exports.communityPreviewSelector = function communityPreviewSelector(state) {
	  return (0, _get2.default)(state, 'communities.communityPreview');
	};
	
	var communityPostsPreviewSelector = exports.communityPostsPreviewSelector = function communityPostsPreviewSelector(state) {
	  return (0, _get2.default)(state, 'communities.communityPostsPreview');
	};
	
	var communityPostsListSizeSelector = exports.communityPostsListSizeSelector = function communityPostsListSizeSelector(state) {
	  return (0, _get2.default)(state, 'communities.postsList.length');
	};
	
	var communityPostsPreviewListSelector = exports.communityPostsPreviewListSelector = (0, _index.createSelector)(communityPostsPreviewSelector, function (request) {
	  return (0, _get2.default)(request, 'list', []);
	});
	
	var sendingCommunityPreviewSelector = exports.sendingCommunityPreviewSelector = (0, _index.createSelector)(communityPreviewSelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _index = __webpack_require__(7);
	
	var consts = exports.consts = (0, _index.createReqConsts)('ui', 'reqSendReport');
	var actions = exports.actions = (0, _index.createActions)(consts);
	
	var watcher = exports.watcher = (0, _index.createReqWatcher)(consts, actions, {
	  endpoint: '',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['reportType']
	  }, {
	    type: 'payload',
	    selector: ['reportableId']
	  }, 'complaints']
	});
	
	exports.default = (0, _index.createReqReducer)(consts);

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dashboardChangePaidStatusActions = exports.DASHBOARD_CHANGE_PAID_STATUS = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'dashboard/change-paid-status-modal';
	
	var DASHBOARD_CHANGE_PAID_STATUS = exports.DASHBOARD_CHANGE_PAID_STATUS = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var dashboardChangePaidStatusActions = exports.dashboardChangePaidStatusActions = {
	  open: (0, _createAction.createAction)(DASHBOARD_CHANGE_PAID_STATUS.OPEN),
	  close: (0, _createAction.createAction)(DASHBOARD_CHANGE_PAID_STATUS.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  appointment: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case DASHBOARD_CHANGE_PAID_STATUS.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          opened: true,
	          appointment: payload
	        });
	      }
	
	    case DASHBOARD_CHANGE_PAID_STATUS.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dashboardChangeRoomActions = exports.DASHBOARD_CHANGE_ROOM = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	var _changeRoomReq = __webpack_require__(657);
	
	var changeRoom = _interopRequireWildcard(_changeRoomReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'dashboard/change-room-modal';
	
	var DASHBOARD_CHANGE_ROOM = exports.DASHBOARD_CHANGE_ROOM = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var dashboardChangeRoomActions = exports.dashboardChangeRoomActions = {
	  open: (0, _createAction.createAction)(DASHBOARD_CHANGE_ROOM.OPEN),
	  close: (0, _createAction.createAction)(DASHBOARD_CHANGE_ROOM.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  appointment: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case DASHBOARD_CHANGE_ROOM.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          opened: true,
	          appointment: payload
	        });
	      }
	
	    case changeRoom.consts.SUCCEED:
	    case DASHBOARD_CHANGE_ROOM.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1270 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILTER_APPLY_DEBOUNCE_TIME = exports.FILTER_APPLY_DEBOUNCE_TIME = 400;
	var CHECK_OVERDUE_INTERVAL_TIME = exports.CHECK_OVERDUE_INTERVAL_TIME = 30 * 1000;
	var NEW_APPOINTMENT_HIGHLIGHT_TIME = exports.NEW_APPOINTMENT_HIGHLIGHT_TIME = 3 * 60 * 1000;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dashboardEditPaymentAmountActions = exports.DASHBOARD_EDIT_PAYMEN_AMOUNT = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	var _editPaymentReq = __webpack_require__(349);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'dashboard/edit-payment-amount-modal';
	
	var DASHBOARD_EDIT_PAYMEN_AMOUNT = exports.DASHBOARD_EDIT_PAYMEN_AMOUNT = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var dashboardEditPaymentAmountActions = exports.dashboardEditPaymentAmountActions = {
	  open: (0, _createAction.createAction)(DASHBOARD_EDIT_PAYMEN_AMOUNT.OPEN),
	  close: (0, _createAction.createAction)(DASHBOARD_EDIT_PAYMEN_AMOUNT.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  appointment: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case DASHBOARD_EDIT_PAYMEN_AMOUNT.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          opened: true,
	          appointment: payload
	        });
	      }
	
	    case _editPaymentReq.consts.SUCCEED:
	    case DASHBOARD_EDIT_PAYMEN_AMOUNT.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionsScope = 'dashboard/filter';
	
	var DASHBOARD_FILTER_TYPES = exports.DASHBOARD_FILTER_TYPES = {
	  SET_FILTER: actionsScope + '/set-filter',
	  ADD_DISPLAYABLE_BY_DEFAULT: actionsScope + '/add-displayable-by-default'
	};

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var types = ['CREATED', 'UPDATED', 'PIN', 'CHANGE_ROOM', 'CHANGE_STATUS', 'CHANGE_PAYMENT_STATUS', 'UPDATE_COPAY', 'REMOVE_FROM_DASHBOARD'];
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['dashboard', 'real-time-updates'].concat(types));
	var actions = exports.actions = (0, _redux.createActions)(consts);

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'appointment-locations-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dashboard',
	  type: 'get',
	  slug: ['locations', {
	    type: 'payload.query',
	    queryParameter: 'creatable_on_dashboard',
	    selector: 'creatableOnDashboard'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true,
	          locations: payload
	        });
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _filterOptionsNormalizer = __webpack_require__(4050);
	
	var _filterOptionsNormalizer2 = _interopRequireDefault(_filterOptionsNormalizer);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'locations-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dashboard',
	  type: 'get',
	  slug: ['locations', {
	    type: 'payload.query',
	    queryParameter: 'assigned_to_user',
	    selector: 'assignedToUser'
	  }]
	});
	
	var defaultRequestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.SUCCEED:
	      {
	        var data = (0, _filterOptionsNormalizer2.default)({ locations: payload });
	        return (0, _extends3.default)({}, state, {
	          sending: false,
	          succeed: true
	        }, data, {
	          locationsList: payload
	        });
	      }
	
	    default:
	      {
	        return defaultRequestReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dashboard', 'validate-patient-info-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dashboard',
	  type: 'post',
	  slug: ['patient_validations']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('data', 'configurations');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'configurations',
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('data', 'constants');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'constants',
	  type: 'get'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('data', 'countries');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'countries',
	  type: 'get',
	  slug: []
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('data', 'otpAuthCodes');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'otp_auth',
	  type: 'post',
	  slug: ['codes']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('data', 'privacyPolicies');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'privacy_policies',
	  type: 'get'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentForm', 'assigned-guardians');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dependent_registration',
	  type: 'get',
	  slug: ['guardian_proxies', {
	    type: 'payload.query',
	    queryParameter: 'first_name',
	    selector: ['firstName']
	  }, {
	    type: 'payload.query',
	    queryParameter: 'last_name',
	    selector: ['lastName']
	  }, {
	    type: 'payload.query',
	    queryParameter: 'dob',
	    selector: ['dob']
	  }, {
	    type: 'payload.query',
	    queryParameter: 'ssn',
	    selector: ['ssn']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentForm', 'assignment-fetch');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dependent_registration',
	  type: 'get',
	  slug: ['assignments', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentForm', 'documents-complete');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dependent_registration',
	  type: 'put',
	  slug: ['assignments', {
	    type: 'payload',
	    selector: ['id']
	  }, 'documentation_completion']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentForm', 'general-info');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dependent_registration',
	  type: 'put',
	  slug: ['assignments', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentForm', 'relation');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dependent_registration',
	  type: 'post',
	  slug: ['assignments', {
	    type: 'payload',
	    selector: ['id']
	  }, 'relationships']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.devicePermissionActions = exports.DEVICE_PERMISSION_ACTION_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionScope = 'device-permission';
	
	var DEVICE_PERMISSION_ACTION_TYPES = exports.DEVICE_PERMISSION_ACTION_TYPES = {
	  OPEN: actionScope + '/open',
	  CLOSE: actionScope + '/close',
	  RETRY: actionScope + '/retry',
	  GRAND_PERMISSION: actionScope + '/grand-permission'
	};
	
	var devicePermissionActions = exports.devicePermissionActions = {
	  open: (0, _createAction.createAction)(DEVICE_PERMISSION_ACTION_TYPES.OPEN),
	  close: (0, _createAction.createAction)(DEVICE_PERMISSION_ACTION_TYPES.CLOSE),
	  retry: (0, _createAction.createAction)(DEVICE_PERMISSION_ACTION_TYPES.RETRY),
	  mediaPermissionsGranted: (0, _createAction.createAction)(DEVICE_PERMISSION_ACTION_TYPES.GRAND_PERMISSION)
	};
	
	var initialState = {
	  opened: false,
	  props: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case DEVICE_PERMISSION_ACTION_TYPES.OPEN:
	      {
	        return (0, _extends3.default)({}, state, { opened: true, props: payload });
	      }
	    case DEVICE_PERMISSION_ACTION_TYPES.CLOSE:
	      {
	        return (0, _extends3.default)({}, state, { opened: false, props: {} });
	      }
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-allergies');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'allergies']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-available-categories');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'patient_portal', 'categories']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.chatMembersModalActions = exports.CHAT_MEMBERS_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'patient-portal/chat-members-modal';
	
	var CHAT_MEMBERS_MODAL = exports.CHAT_MEMBERS_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var chatMembersModalActions = exports.chatMembersModalActions = {
	  open: (0, _createAction.createAction)(CHAT_MEMBERS_MODAL.OPEN),
	  close: (0, _createAction.createAction)(CHAT_MEMBERS_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  memberList: [],
	  chatRoomName: '',
	  date: ''
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case CHAT_MEMBERS_MODAL.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          memberList: payload.memberList,
	          chatRoomName: payload.chatRoomName,
	          date: payload.date,
	          opened: true
	        });
	      }
	
	    case CHAT_MEMBERS_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-conditions');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'conditions']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-encounters');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'encounters']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-family-history');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'family_histories']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-health-record', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccda', 'user_documents', {
	    type: 'payload.query',
	    queryParameter: 'start_date',
	    selector: 'startDate'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'end_date',
	    selector: 'endDate'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  list: [],
	  total: 0,
	  isPagination: false
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SEND:
	      return (0, _extends3.default)({}, state, {
	        succeed: false,
	        sending: true,
	        isPagination: payload.withPagination
	      });
	    case consts.SUCCEED:
	      return (0, _extends3.default)({}, state, {
	        succeed: true,
	        sending: false,
	        isLastPage: true,
	        list: state.isPagination ? state.list.concat(payload) : payload
	      });
	    case consts.ADD_META:
	      return (0, _extends3.default)({}, state, { total: payload.total });
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-immunizations');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'vaccines']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.labResultHistoryModalActions = exports.LAB_RESULT_HISTORY_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'patient-portal/lab-result-history-modal';
	
	var LAB_RESULT_HISTORY_MODAL = exports.LAB_RESULT_HISTORY_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var labResultHistoryModalActions = exports.labResultHistoryModalActions = {
	  open: (0, _createAction.createAction)(LAB_RESULT_HISTORY_MODAL.OPEN),
	  close: (0, _createAction.createAction)(LAB_RESULT_HISTORY_MODAL.CLOSE)
	};
	
	var initialState = {
	  list: [],
	  name: '',
	  opened: false,
	  componentCode: ''
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case LAB_RESULT_HISTORY_MODAL.OPEN:
	      {
	        var componentCode = payload.componentCode,
	            name = payload.name;
	
	
	        return (0, _extends3.default)({}, state, {
	          name: name,
	          opened: true,
	          componentCode: componentCode
	        });
	      }
	
	    case LAB_RESULT_HISTORY_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-lab-result-history');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'historic_lab_results', {
	    type: 'payload.query',
	    selector: ['componentCode'],
	    queryParameter: 'component_code'
	  }, {
	    type: 'payload.query',
	    selector: ['limit'],
	    queryParameter: 'limit'
	  }, {
	    type: 'payload.query',
	    selector: ['startTime'],
	    queryParameter: 'start_time'
	  }, {
	    type: 'payload.query',
	    selector: ['endTime'],
	    queryParameter: 'end_time'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-lab-test-results');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'lab_results']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _medicationStatuses = __webpack_require__(1854);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-medications', ['LOAD_MORE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'medications', {
	    type: 'payload.query',
	    queryParameter: 'status',
	    selector: 'status'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	var ACTIVE = _medicationStatuses.MEDICATION_STATUSES.ACTIVE;
	
	
	var initialState = (0, _extends3.default)({}, _redux.initialState, {
	  total: 0,
	  list: { active: [], discontinued: [] }
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.SEND:
	      return (0, _extends3.default)({}, state, {
	        succeed: false,
	        sending: true
	      });
	    case consts.SUCCEED:
	      {
	        var status = payload.length && payload[0].status.toLowerCase();
	        return (0, _extends3.default)({}, state, {
	          succeed: true,
	          sending: false,
	          list: status === ACTIVE ? (0, _extends3.default)({}, state.list, { active: payload }) : (0, _extends3.default)({}, state.list, {
	            discontinued: state.list.discontinued.concat(payload)
	          })
	        });
	      }
	    case consts.ADD_META:
	      return (0, _extends3.default)({}, state, { total: payload.total });
	    case consts.CLEAR:
	      return (0, _extends3.default)({}, initialState);
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('patient-portal', 'patient-channels-for-share');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'channels',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'type',
	    selector: 'type'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-procedures');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'procedures']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'refills-available-medications');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'medication_refills', 'medications']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resultsDetailsModalActions = exports.RESULTS_DETAILS_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'patient-portal/results-details-modal';
	
	var RESULTS_DETAILS_MODAL = exports.RESULTS_DETAILS_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var resultsDetailsModalActions = exports.resultsDetailsModalActions = {
	  open: (0, _createAction.createAction)(RESULTS_DETAILS_MODAL.OPEN),
	  close: (0, _createAction.createAction)(RESULTS_DETAILS_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  entity: {},
	  ccdLabTestId: ''
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case RESULTS_DETAILS_MODAL.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          entity: payload.entity,
	          ccdLabTestId: payload.ccdLabTestId,
	          opened: true
	        });
	      }
	
	    case RESULTS_DETAILS_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-lab-test-results-by-id');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'lab_results', {
	    type: 'payload',
	    selector: ['ccdLabTestId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shareToEmailModalActions = exports.SHARE_TO_EMAIL_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'patient-portal/share-to-email-modal';
	
	var SHARE_TO_EMAIL_MODAL = exports.SHARE_TO_EMAIL_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var shareToEmailModalActions = exports.shareToEmailModalActions = {
	  open: (0, _createAction.createAction)(SHARE_TO_EMAIL_MODAL.OPEN),
	  close: (0, _createAction.createAction)(SHARE_TO_EMAIL_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  documentUid: ''
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case SHARE_TO_EMAIL_MODAL.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          documentUid: payload.documentUid,
	          opened: true
	        });
	      }
	
	    case SHARE_TO_EMAIL_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('patient-portal', 'social-channels-for-share');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'channels',
	  type: 'get',
	  slug: [{
	    type: 'payload.query',
	    queryParameter: 'type',
	    selector: 'type'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'limit',
	    selector: 'limit'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'offset',
	    selector: 'offset'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'patient-portal-social-history');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ccd', 'social_histories']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'get-geoLocations-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'todo',
	  type: 'get',
	  slug: ['tasks', {
	    type: 'payload',
	    selector: ['id']
	  }, 'geolocations']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'paya-redirection');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'payment_orders',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['paymentOrderId']
	  }, 'paya', 'hosted_payment_pages', {
	    type: 'payload.query',
	    queryParameter: 'client_type',
	    value: 'web'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'room-invitation-join-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: ['virtual_visits', 'room_invitation', 'join']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.healthBoardActions = exports.HEALTH_BOARD_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'health-board/validaiton';
	
	var HEALTH_BOARD_TYPES = exports.HEALTH_BOARD_TYPES = {
	  TOGGLE_VALIDATE: actionsScope + '/toogle-validation'
	};
	
	var healthBoardActions = exports.healthBoardActions = {
	  toggleValidation: (0, _createAction.createAction)(HEALTH_BOARD_TYPES.TOGGLE_VALIDATE)
	};
	
	var initalState = {
	  validating: true
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case HEALTH_BOARD_TYPES.TOGGLE_VALIDATE:
	      {
	        return (0, _extends3.default)({}, state, {
	          validating: payload
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.checkPermission = checkPermission;
	
	var _effects = __webpack_require__(14);
	
	var _utils = __webpack_require__(307);
	
	var _devicePermissionHelper = __webpack_require__(1894);
	
	var _devicePermissions = __webpack_require__(1287);
	
	var _useOTScriptLoad = __webpack_require__(1317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(checkPermission);
	
	var REQUEST = _devicePermissionHelper.DEVICE_PERMISSION_TYPES.REQUEST,
	    DENIED = _devicePermissionHelper.DEVICE_PERMISSION_TYPES.DENIED;
	
	
	function loadScripts() {
	  return new _promise2.default(function (resolve) {
	    return (0, _useOTScriptLoad.asyncOpentokLoader)(function () {
	      return resolve();
	    });
	  });
	}
	
	function checkPermission(invitable) {
	  var devices, hasPermission, audio, video, stream;
	  return _regenerator2.default.wrap(function checkPermission$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(loadScripts);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.call)(_utils.getAllMediaDevices);
	
	        case 4:
	          devices = _context.sent;
	          hasPermission = (0, _devicePermissionHelper.hasDevicePermissions)(devices);
	          audio = devices.some(function (device) {
	            return device.kind === 'audioInput';
	          });
	          video = devices.some(function (device) {
	            return device.kind === 'videoInput';
	          });
	
	          if (!hasPermission) {
	            _context.next = 10;
	            break;
	          }
	
	          return _context.abrupt('return', true);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.put)(_devicePermissions.devicePermissionActions.open({ type: REQUEST, invitable: invitable }));
	
	        case 12:
	          _context.prev = 12;
	          _context.next = 15;
	          return (0, _effects.call)(function () {
	            return navigator.mediaDevices.getUserMedia({ audio: audio, video: video });
	          });
	
	        case 15:
	          stream = _context.sent;
	
	          if (stream.getTracks) {
	            stream.getTracks().forEach(function (track) {
	              return track.stop();
	            });
	          }
	          _context.next = 19;
	          return (0, _effects.put)(_devicePermissions.devicePermissionActions.close());
	
	        case 19:
	          return _context.abrupt('return', true);
	
	        case 22:
	          _context.prev = 22;
	          _context.t0 = _context['catch'](12);
	          _context.next = 26;
	          return (0, _effects.put)(_devicePermissions.devicePermissionActions.open({ type: DENIED, invitable: invitable }));
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.take)(_devicePermissions.DEVICE_PERMISSION_ACTION_TYPES.GRAND_PERMISSION);
	
	        case 28:
	          _context.next = 30;
	          return (0, _effects.put)(_devicePermissions.devicePermissionActions.close());
	
	        case 30:
	          return _context.abrupt('return', true);
	
	        case 31:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[12, 22]]);
	}

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('patient', 'check-uploaded-insurance-card-ocr');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'ocr_results']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('patient', 'delete-patient-insurance');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'patient_insurances', {
	    type: 'payload',
	    selector: ['patientInsuranceId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('patient', 'export-patient-insurance-ehr-documents');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'patient_insurances', 'ehr', 'document_exports']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.otEventManager = undefined;
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _class, _temp;
	
	var _pubsubJs = __webpack_require__(994);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OTEventManager = (_temp = _class = function () {
	  function OTEventManager() {
	    (0, _classCallCheck3.default)(this, OTEventManager);
	
	    this.observer = _pubsubJs2.default;
	    this.reconnectTokens = [];
	    this.restartTokens = [];
	  }
	
	  /** Reconnect methods */
	
	
	  (0, _createClass3.default)(OTEventManager, [{
	    key: 'emitReconnect',
	    value: function emitReconnect() {
	      this.observer.publish(OTEventManager.RECONNECT_EVENT);
	    }
	  }, {
	    key: 'onReconnect',
	    value: function onReconnect(cb) {
	      var _this = this;
	
	      var token = this.observer.subscribe(OTEventManager.RECONNECT_EVENT, function () {
	        return cb();
	      });
	      this.reconnectTokens.push(token);
	      return function () {
	        _this.reconnectTokens = _this.reconnectTokens.filter(function (t) {
	          return t !== token;
	        });
	        return _this.observer.unsubscribe(token);
	      };
	    }
	  }, {
	    key: 'offReconnect',
	    value: function offReconnect() {
	      var _this2 = this;
	
	      this.reconnectTokens.forEach(function (token) {
	        return _this2.observer.unsubscribe(token);
	      });
	      this.reconnectTokens = [];
	    }
	
	    /** Restart methods */
	
	  }, {
	    key: 'emitRestart',
	    value: function emitRestart() {
	      this.observer.publish(OTEventManager.RESTART_EVENT);
	    }
	  }, {
	    key: 'onRestart',
	    value: function onRestart(cb) {
	      var _this3 = this;
	
	      var token = this.observer.subscribe(OTEventManager.RESTART_EVENT, function () {
	        return cb();
	      });
	      this.restartTokens.push(token);
	      return function () {
	        _this3.restartTokens = _this3.restartTokens.filter(function (t) {
	          return t !== token;
	        });
	        return _this3.observer.unsubscribe(token);
	      };
	    }
	  }, {
	    key: 'offRestart',
	    value: function offRestart() {
	      var _this4 = this;
	
	      this.restartTokens.forEach(function (token) {
	        return _this4.observer.unsubscribe(token);
	      });
	      this.restartTokens = [];
	    }
	  }]);
	  return OTEventManager;
	}(), _class.RECONNECT_EVENT = 'reconnect', _class.RESTART_EVENT = 'restart', _temp);
	var otEventManager = exports.otEventManager = new OTEventManager();

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asyncOpentokLoader = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useOTScriptLoad = useOTScriptLoad;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _loadScriptAsync = __webpack_require__(4221);
	
	var _popup = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OPENTOK_JS_SRC = 'https://static.opentok.com/v2/js/opentok.min.js';
	var OPENTOK_TEST_JS_SRC = 'https://cdn.jsdelivr.net/npm/opentok-network-test-js@2.4.0/dist/NetworkTest/index.js';
	
	var asyncOpentokLoader = exports.asyncOpentokLoader = (0, _loadScriptAsync.makeAsyncScriptLoader)([OPENTOK_JS_SRC, OPENTOK_TEST_JS_SRC], 'ot_lib');
	
	function useOTScriptLoad(opened) {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      loaded = _useState2[0],
	      setLoaded = _useState2[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var loadScript = function loadScript() {
	    if (loaded) {
	      dispatch((0, _popup.hideLoaderInPopup)());
	      return;
	    }
	
	    asyncOpentokLoader(function () {
	      dispatch((0, _popup.hideLoaderInPopup)());
	      setLoaded(true);
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    if (opened) {
	      loadScript();
	    }
	  }, [opened]);
	
	  return {
	    loaded: loaded,
	    loadScript: loadScript
	  };
	}

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.opentokActions = exports.OPENTOK_TYPES = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var actionsScope = 'opentok-v2';
	
	var OPENTOK_TYPES = exports.OPENTOK_TYPES = {
	  TOGGLE_LOADING: actionsScope + '/toggle-loading',
	  ADD_CONNECTION: actionsScope + '/add-connection',
	  UPDATE_CONNECTION: actionsScope + '/update-connection',
	  REMOVE_CONNECTION: actionsScope + '/remove-connection',
	  UPDATE_INVITATIONS: actionsScope + '/update-invitations',
	  SET_ACTIVE_ID: actionsScope + '/set-active-id',
	  ADD_SPEAKER: actionsScope + '/add-speaker',
	  REMOVE_SPEAKER: actionsScope + '/remove-speaker',
	  SET_CONNECTED: actionsScope + '/set-connected',
	  SET_START_CALL_TIME: actionsScope + '/set-start-call-time',
	  SET_DURATION_DATA: actionsScope + '/set-duration-data',
	  ADD_VIDEO_WARNING_ID: actionsScope + '/add-video-warning',
	  REMOVE_VIDEO_WARNING_ID: actionsScope + '/remove-video-warning',
	  FIND_SCREEN_SHARING: actionsScope + '/find-screen-sharing',
	  SET_PIN: actionsScope + '/set-pin',
	  RESET: actionsScope + '/reset'
	};
	
	var opentokActions = exports.opentokActions = {
	  toggleLoading: (0, _createAction.createAction)(OPENTOK_TYPES.TOGGLE_LOADING),
	  addConnection: (0, _createAction.createAction)(OPENTOK_TYPES.ADD_CONNECTION),
	  updateConnection: (0, _createAction.createAction)(OPENTOK_TYPES.UPDATE_CONNECTION),
	  removeConnection: (0, _createAction.createAction)(OPENTOK_TYPES.REMOVE_CONNECTION),
	  updateInvitations: (0, _createAction.createAction)(OPENTOK_TYPES.UPDATE_INVITATIONS),
	  setActiveId: (0, _createAction.createAction)(OPENTOK_TYPES.SET_ACTIVE_ID),
	  addSpeaker: (0, _createAction.createAction)(OPENTOK_TYPES.ADD_SPEAKER),
	  removeSpeaker: (0, _createAction.createAction)(OPENTOK_TYPES.REMOVE_SPEAKER),
	  setConnected: (0, _createAction.createAction)(OPENTOK_TYPES.SET_CONNECTED),
	  setStartCallTime: (0, _createAction.createAction)(OPENTOK_TYPES.SET_START_CALL_TIME),
	  setDurationData: (0, _createAction.createAction)(OPENTOK_TYPES.SET_DURATION_DATA),
	  addVideoWarningId: (0, _createAction.createAction)(OPENTOK_TYPES.ADD_VIDEO_WARNING_ID),
	  removeVideoWarningId: (0, _createAction.createAction)(OPENTOK_TYPES.REMOVE_VIDEO_WARNING_ID),
	  findScreenSharing: (0, _createAction.createAction)(OPENTOK_TYPES.FIND_SCREEN_SHARING),
	  setPin: (0, _createAction.createAction)(OPENTOK_TYPES.SET_PIN),
	  reset: (0, _createAction.createAction)(OPENTOK_TYPES.RESET)
	};

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makeLocationsReqConfig = function makeLocationsReqConfig() {
	  return {
	    endpoint: 'paya',
	    type: 'get',
	    slug: ['organizations', {
	      type: 'payload',
	      selector: ['organizationId']
	    }, 'locations', {
	      type: 'payload.query',
	      queryParameter: 'query',
	      selector: 'query'
	    }]
	  };
	};
	
	var requestOptions = makeLocationsReqConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('payment-methods', 'locations');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var makeOrganizationsReqConfig = function makeOrganizationsReqConfig() {
	  return {
	    endpoint: 'paya',
	    type: 'get',
	    slug: ['organizations']
	  };
	};
	
	var requestOptions = makeOrganizationsReqConfig();
	
	var consts = exports.consts = (0, _redux.createReqConsts)('payment-methods', 'organizations');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, requestOptions, true);
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['SAVE', 'CLEAR', 'CLEAR_BY_KEY'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['profile', 'add-patient-data'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {};
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	  switch (type) {
	    case consts.SAVE:
	      return (0, _extends3.default)({}, state, payload);
	    case consts.CLEAR:
	      return initialState;
	    case consts.CLEAR_BY_KEY:
	      return (0, _omit2.default)(state, '' + payload.key);
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'country-code', ['SET']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = {
	  succeed: null,
	  error: null,
	  rejected: null,
	  currentCountryCode: '+1'
	};
	
	var clear = function clear(state) {
	  return (0, _extends3.default)({}, state, initialState);
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return clear(state);
	
	    case consts.SET:
	      return (0, _extends3.default)({}, state, {
	        currentCountryCode: action.payload || 'us'
	      });
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'change-email', ['CLEAR']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'change_email']
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var clear = function clear(state) {
	  return (0, _extends3.default)({}, state, {
	    succeed: null,
	    error: null,
	    rejected: null
	  });
	};
	
	exports.default = function (state, action) {
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return clear(state);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'change-phone-number', ['CLEAR']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'change_phone_number']
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var clear = function clear(state) {
	  return (0, _extends3.default)({}, state, {
	    succeed: null,
	    error: null,
	    rejected: null
	  });
	};
	
	exports.default = function (state, action) {
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return clear(state);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profiles', 'edit-patient-emergency-contact');
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'patient_profiles',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'edit-working-hours');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'employee_profiles',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'getProviderMember');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'provider_members', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'getProvider');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'circle_of_care_providers', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'mfa-notice');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'mfa_settings',
	  type: 'post'
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'blood-glucose-measurements-single-day-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['blood_glucose_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'blood-glucose-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['blood_glucose_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'bloodPressure-measurements-modals');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['blood_pressure_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'bmi-measurements-single-day-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['bmi_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'body-surface-area-measurements-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['bsa_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'body-surface-area-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['bsa_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'body-temperature-measurements-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['body_temperature_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'body-temperature-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['body_temperature_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentHealthboardOptionsActions = exports.CURRENT_HEALTHBOARD_OPTIONS = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _createAction = __webpack_require__(68);
	
	var _constants = __webpack_require__(17);
	
	var _constants2 = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'profile/current-healthboard-options';
	
	var CURRENT_HEALTHBOARD_OPTIONS = exports.CURRENT_HEALTHBOARD_OPTIONS = {
	  SET_DATA_TYPE: actionsScope + '/setDataType',
	  SET_CHART_PERIOD: actionsScope + '/setChartPeriod',
	  SET_CURRENT_METRIC_WEIGHT: actionsScope + '/setCurrentMetricWeight',
	  SET_CURRENT_METRIC_HEIGHT: actionsScope + '/setCurrentMetricHeight',
	  SET_CURRENT_METRIC_TEMPERATURE: actionsScope + '/setCurrentMetricTemperature',
	  SET_CURRENT_METRIC_GLUCOSE: actionsScope + '/setCurrentMetricGlucose',
	  SET_CURRENT_METRIC: actionsScope + '/setCurrentMetric',
	  CLEAR: actionsScope + '/clear'
	};
	
	var currentHealthboardOptionsActions = exports.currentHealthboardOptionsActions = {
	  setDataType: (0, _createAction.createAction)(CURRENT_HEALTHBOARD_OPTIONS.SET_DATA_TYPE),
	  setChartPeriod: (0, _createAction.createAction)(CURRENT_HEALTHBOARD_OPTIONS.SET_CHART_PERIOD),
	  setCurrentMetricWeight: (0, _createAction.createAction)(CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_WEIGHT),
	  setCurrentMetricHeight: (0, _createAction.createAction)(CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_HEIGHT),
	  setCurrentMetricTemperature: (0, _createAction.createAction)(CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_HEIGHT),
	  setCurrentMetricGlucose: (0, _createAction.createAction)(CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_GLUCOSE),
	  setCurrentMetric: (0, _createAction.createAction)(CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC),
	  clear: (0, _createAction.createAction)(CURRENT_HEALTHBOARD_OPTIONS.CLEAR)
	};
	
	var initialState = {
	  dataType: _constants2.VITALS_ACTIVITY_TYPE.STEPS,
	  chartPeriod: _constants2.CHART_FILTERS_TYPE.DAY.type,
	  previousCounter: 1,
	  currentMetricWeight: { type: _constants.WEIGHT_METRIC.POUNDS, valueToAPI: null },
	  currentMetricHeight: { type: _constants.HEIGHT_METRIC.FEET_INCHES, valueToAPI: null },
	  currentMetricGlucose: {
	    type: _constants.GLUCOSE_METRIC.MMOL_PER_LITER,
	    valueToAPI: null
	  },
	  currentMetricTemperature: {
	    type: _constants.TEMPERATURE_METRIC.FAHRENHEIT,
	    valueToAPI: null
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case CURRENT_HEALTHBOARD_OPTIONS.SET_DATA_TYPE:
	      {
	        return (0, _extends4.default)({}, state, {
	          dataType: payload
	        });
	      }
	
	    case CURRENT_HEALTHBOARD_OPTIONS.SET_CHART_PERIOD:
	      {
	        return (0, _extends4.default)({}, state, {
	          chartPeriod: payload
	        });
	      }
	
	    case CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_WEIGHT:
	      {
	        return (0, _extends4.default)({}, state, {
	          currentMetricWeight: (0, _extends4.default)({}, state.currentMetricWeight, payload.type && { type: payload.type }, {
	            valueToAPI: payload.valueToAPI || state.currentMetricWeight.valueToAPI
	          })
	        });
	      }
	
	    case CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_HEIGHT:
	      {
	        return (0, _extends4.default)({}, state, {
	          currentMetricHeight: (0, _extends4.default)({}, state.currentMetricHeight, payload.type && { type: payload.type }, {
	            valueToAPI: payload.valueToAPI || state.currentMetricHeight.valueToAPI
	          })
	        });
	      }
	
	    case CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC_GLUCOSE:
	      {
	        return (0, _extends4.default)({}, state, {
	          currentMetricGlucose: (0, _extends4.default)({}, state.currentMetricGlucose, payload.type && { type: payload.type }, {
	            valueToAPI: payload.valueToAPI || state.currentMetricGlucose.valueToAPI
	          })
	        });
	      }
	
	    case CURRENT_HEALTHBOARD_OPTIONS.SET_CURRENT_METRIC:
	      {
	        return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, payload.type, {
	          type: payload.value
	        }));
	      }
	
	    case CURRENT_HEALTHBOARD_OPTIONS.CLEAR:
	      {
	        return (0, _extends4.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'distance-measurements-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['distance_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'distance-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['distance_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'heart-rate-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['heart_rate_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'heart-rate');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['heart_rate_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'height-measurements-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['height_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'height-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['height_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'provider-list');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['providers']
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1346 */,
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'respiratoryRate-measurements-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['respiratory_rate_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'saturation-measurements-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['spo2_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'saturation-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['spo2_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.singleDayGrafModalActions = exports.SINGLE_DAY_GRAF_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'profile/single-day-graf-modal';
	
	var SINGLE_DAY_GRAF_MODAL = exports.SINGLE_DAY_GRAF_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var singleDayGrafModalActions = exports.singleDayGrafModalActions = {
	  open: (0, _createAction.createAction)(SINGLE_DAY_GRAF_MODAL.OPEN),
	  close: (0, _createAction.createAction)(SINGLE_DAY_GRAF_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  type: 'steps',
	  baseDate: '',
	  entity: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case SINGLE_DAY_GRAF_MODAL.OPEN:
	      {
	        return (0, _extends3.default)({}, state, {
	          opened: true,
	          baseDate: payload.baseDate,
	          type: payload.type,
	          entity: payload.entity
	        });
	      }
	
	    case SINGLE_DAY_GRAF_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.singlePointValuesModalActions = exports.SINGLE_POINT_VALUES_MODAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	var _constants = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'profile/single-point-values-modal';
	
	var SINGLE_POINT_VALUES_MODAL = exports.SINGLE_POINT_VALUES_MODAL = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var singlePointValuesModalActions = exports.singlePointValuesModalActions = {
	  open: (0, _createAction.createAction)(SINGLE_POINT_VALUES_MODAL.OPEN),
	  close: (0, _createAction.createAction)(SINGLE_POINT_VALUES_MODAL.CLOSE)
	};
	
	var initialState = {
	  opened: false,
	  monthTitle: '',
	  entity: [],
	  type: _constants.VITALS_ACTIVITY_TYPE.BMI,
	  metricSettings: {}
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case SINGLE_POINT_VALUES_MODAL.OPEN:
	      {
	        return (0, _extends3.default)({}, state, payload, {
	          opened: true
	        });
	      }
	
	    case SINGLE_POINT_VALUES_MODAL.CLOSE:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'steps-measurements-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['steps_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'steps-measurements');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['steps_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('profile', 'weight-measurements-modal');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'fitness_tracking',
	  type: 'get',
	  slug: ['weight_measurements', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'period',
	    selector: 'period'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'base_date',
	    selector: 'baseDate'
	  }]
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PATIENT_ACCESS_LEVEL = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.publicProfileRedirectSaga = publicProfileRedirectSaga;
	
	var _effects = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(42);
	
	var _getUser = __webpack_require__(202);
	
	var getUser = _interopRequireWildcard(_getUser);
	
	var _redux = __webpack_require__(7);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _getAccessLevels = __webpack_require__(426);
	
	var getAccessLevel = _interopRequireWildcard(_getAccessLevels);
	
	var _getFamilyMember = __webpack_require__(874);
	
	var getFamilyMember = _interopRequireWildcard(_getFamilyMember);
	
	var _selectors = __webpack_require__(23);
	
	var _myProfileRedirect = __webpack_require__(682);
	
	var _publicProfile = __webpack_require__(889);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(redirectToProfile),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(publicProfileRedirectSaga);
	
	var consts = exports.consts = (0, _consts2.default)('profile', 'public-profile', 'GO_TO_PROFILE');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	// all user's relations for access to the patient profile
	var PATIENT_ACCESS_LEVEL = exports.PATIENT_ACCESS_LEVEL = ['provider', 'patient_caregiver', 'family_member'];
	
	var canSeePatientProfile = function canSeePatientProfile(payload) {
	  return payload.some(function (role) {
	    return PATIENT_ACCESS_LEVEL.includes(role);
	  });
	};
	
	function redirectToProfile(_ref) {
	  var payload = _ref.payload;
	
	  var id, isLoggedInUser, _ref2, accessPayload, _ref3, deniedMainProfile, loggedUserId, _ref4, deniedFamilyProfile;
	
	  return _regenerator2.default.wrap(function redirectToProfile$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          id = payload.id, isLoggedInUser = payload.isLoggedInUser;
	
	          if (!isLoggedInUser) {
	            _context.next = 6;
	            break;
	          }
	
	          _context.next = 4;
	          return (0, _effects.put)(_myProfileRedirect.myProfileRedirectActions.goToProfile());
	
	        case 4:
	          _context.next = 39;
	          break;
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)(getAccessLevel.actions.send({ id: id }));
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.take)([getAccessLevel.consts.SUCCEED, getAccessLevel.consts.REJECTED]);
	
	        case 10:
	          _ref2 = _context.sent;
	          accessPayload = _ref2.payload;
	
	          if (!(Array.isArray(accessPayload) && canSeePatientProfile(accessPayload))) {
	            _context.next = 37;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)(getUser.actions.send({ id: id }));
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.race)({
	            successMainProfile: (0, _effects.take)(getUser.consts.SUCCEED),
	            deniedMainProfile: (0, _effects.take)(getUser.consts.REJECTED)
	          });
	
	        case 17:
	          _ref3 = _context.sent;
	          deniedMainProfile = _ref3.deniedMainProfile;
	
	          if (!deniedMainProfile) {
	            _context.next = 34;
	            break;
	          }
	
	          _context.next = 22;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 22:
	          loggedUserId = _context.sent;
	          _context.next = 25;
	          return (0, _effects.put)(getFamilyMember.actions.send({ id: id, userId: loggedUserId }));
	
	        case 25:
	          _context.next = 27;
	          return (0, _effects.race)({
	            successFamilyProfile: (0, _effects.take)(getFamilyMember.consts.SUCCEED),
	            deniedFamilyProfile: (0, _effects.take)(getFamilyMember.consts.REJECTED)
	          });
	
	        case 27:
	          _ref4 = _context.sent;
	          deniedFamilyProfile = _ref4.deniedFamilyProfile;
	
	          if (!deniedFamilyProfile) {
	            _context.next = 32;
	            break;
	          }
	
	          _context.next = 32;
	          return (0, _effects.put)(_publicProfile.actions.send({ id: id }));
	
	        case 32:
	          _context.next = 35;
	          break;
	
	        case 34:
	          _reactRouter.browserHistory.push('/' + _routes.PROFILE + '/' + id + '/' + _routes.PATIENT_VIEW_PROFILE);
	
	        case 35:
	          _context.next = 39;
	          break;
	
	        case 37:
	          _context.next = 39;
	          return (0, _effects.put)(_publicProfile.actions.send({ id: id }));
	
	        case 39:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function publicProfileRedirectSaga() {
	  return _regenerator2.default.wrap(function publicProfileRedirectSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(consts.GO_TO_PROFILE, redirectToProfile);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'assignPrograms');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'patient_programs']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loginReferrerActions = exports.loginReferrerConsts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = createReducer;
	
	var _redux = __webpack_require__(98);
	
	var _reactRouterRedux = __webpack_require__(1037);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _auth = __webpack_require__(3948);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _board = __webpack_require__(3957);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _chatConnection = __webpack_require__(183);
	
	var _chatConnection2 = _interopRequireDefault(_chatConnection);
	
	var _circles = __webpack_require__(3999);
	
	var _circles2 = _interopRequireDefault(_circles);
	
	var _context = __webpack_require__(216);
	
	var _context2 = _interopRequireDefault(_context);
	
	var _data = __webpack_require__(4061);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _invitations = __webpack_require__(4114);
	
	var _invitations2 = _interopRequireDefault(_invitations);
	
	var _profiles = __webpack_require__(4145);
	
	var _profiles2 = _interopRequireDefault(_profiles);
	
	var _programs = __webpack_require__(4156);
	
	var _programs2 = _interopRequireDefault(_programs);
	
	var _surveys = __webpack_require__(4174);
	
	var _surveys2 = _interopRequireDefault(_surveys);
	
	var _ui = __webpack_require__(4183);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	var _communities = __webpack_require__(4019);
	
	var _communities2 = _interopRequireDefault(_communities);
	
	var _common = __webpack_require__(4014);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _complaints = __webpack_require__(4040);
	
	var _complaints2 = _interopRequireDefault(_complaints);
	
	var _dependentForm = __webpack_require__(4064);
	
	var _dependentForm2 = _interopRequireDefault(_dependentForm);
	
	var _teams = __webpack_require__(4180);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	var _dependentManagement = __webpack_require__(4078);
	
	var _dependentManagement2 = _interopRequireDefault(_dependentManagement);
	
	var _appointmentForm = __webpack_require__(3918);
	
	var _appointmentForm2 = _interopRequireDefault(_appointmentForm);
	
	var _paymentMethods = __webpack_require__(4142);
	
	var _paymentMethods2 = _interopRequireDefault(_paymentMethods);
	
	var _guarantorInformation = __webpack_require__(4082);
	
	var _guarantorInformation2 = _interopRequireDefault(_guarantorInformation);
	
	var _dashboard = __webpack_require__(4049);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _healthboard = __webpack_require__(4088);
	
	var _healthboard2 = _interopRequireDefault(_healthboard);
	
	var _schedule = __webpack_require__(4159);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _appointmentDetailsReq = __webpack_require__(259);
	
	var _appointmentDetailsReq2 = _interopRequireDefault(_appointmentDetailsReq);
	
	var _paperwork = __webpack_require__(4134);
	
	var _paperwork2 = _interopRequireDefault(_paperwork);
	
	var _manageInsurances = __webpack_require__(4115);
	
	var _manageInsurances2 = _interopRequireDefault(_manageInsurances);
	
	var _appointmnents = __webpack_require__(3941);
	
	var _appointmnents2 = _interopRequireDefault(_appointmnents);
	
	var _redux2 = __webpack_require__(7);
	
	var _logout = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-param-reassign */
	var loginReferrerConsts = exports.loginReferrerConsts = (0, _redux2.createConsts)('auth', 'routing', 'SET_LOGIN_REFERRER', 'CLEAR_LOGIN_REFERRER');
	var loginReferrerActions = exports.loginReferrerActions = (0, _redux2.createActions)(loginReferrerConsts);
	
	/*
	 As we use third party router reducer, we need to have an
	 ability to pass there previous routing substate
	 even if we cleen up all our store due to logout.
	 */
	var __state = void 0; // Entire state
	var _routerReducer = function _routerReducer(state, action) {
	  if (action.type === _logout.consts.CLEAR) {
	    state = __state.routing;
	  }
	
	  // Return back to referrer page after login.s
	  switch (action.type) {
	    case loginReferrerConsts.SET_LOGIN_REFERRER:
	      return (0, _extends3.default)({}, state, {
	        loginReferrer: action.payload.referrer
	      });
	    case loginReferrerConsts.CLEAR_LOGIN_REFERRER:
	      return (0, _extends3.default)({}, state, {
	        loginReferrer: null
	      });
	    default:
	      return (0, _reactRouterRedux.routerReducer)(state, action);
	  }
	};
	
	function createReducer() {
	  var injectedReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var rootReducer = (0, _redux.combineReducers)((0, _extends3.default)({
	    appointmentForm: _appointmentForm2.default,
	    paymentMethods: _paymentMethods2.default,
	    guarantorsInformation: _guarantorInformation2.default,
	    appointments: _appointmentDetailsReq2.default,
	    appointmentsState: _appointmnents2.default,
	    auth: _auth2.default,
	    board: _board2.default,
	    chatConnection: _chatConnection2.default,
	    circles: _circles2.default,
	    common: _common2.default,
	    communities: _communities2.default,
	    complaints: _complaints2.default,
	    context: _context2.default,
	    dashboard: _dashboard2.default,
	    data: _data2.default,
	    dependentForm: _dependentForm2.default,
	    dependentManagement: _dependentManagement2.default,
	    healthboard: _healthboard2.default,
	    invitations: _invitations2.default,
	    profiles: _profiles2.default,
	    programs: _programs2.default,
	    routing: _routerReducer,
	    schedule: _schedule2.default,
	    surveys: _surveys2.default,
	    teams: _teams2.default,
	    ui: _ui2.default,
	    paperwork: _paperwork2.default,
	    managePatientInsurances: _manageInsurances2.default
	  }, injectedReducers));
	
	  return function (state, action) {
	    if ((0, _get2.default)(action, 'type') === _logout.consts.CLEAR) {
	      __state = state;
	      state = undefined;
	    }
	
	    return rootReducer(state, action);
	  };
	}

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calendarAppointmentGuardActions = exports.CALENDAR_APPOINTMENT_GUARD = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'schedule/appointment-guard';
	
	var CALENDAR_APPOINTMENT_GUARD = exports.CALENDAR_APPOINTMENT_GUARD = {
	  START: actionsScope + '/START',
	  FINISH: actionsScope + '/FINISH',
	  CLEAR: actionsScope + '/CLEAR'
	};
	
	var calendarAppointmentGuardActions = exports.calendarAppointmentGuardActions = {
	  start: (0, _createAction.createAction)(CALENDAR_APPOINTMENT_GUARD.START),
	  finish: (0, _createAction.createAction)(CALENDAR_APPOINTMENT_GUARD.FINISH),
	  clear: (0, _createAction.createAction)(CALENDAR_APPOINTMENT_GUARD.CLEAR)
	};
	
	var initialState = {
	  pending: true,
	  canCreate: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case CALENDAR_APPOINTMENT_GUARD.START:
	      {
	        return (0, _extends3.default)({}, state, {
	          pending: true,
	          canCreate: false
	        });
	      }
	
	    case CALENDAR_APPOINTMENT_GUARD.FINISH:
	      {
	        return (0, _extends3.default)({}, state, {
	          pending: false,
	          canCreate: payload
	        });
	      }
	
	    case CALENDAR_APPOINTMENT_GUARD.CLEAR:
	      {
	        return (0, _extends3.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'inspect-appointment');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'providers',
	  type: 'post',
	  slug: [{
	    type: 'payload',
	    selector: ['providerUserId']
	  }, 'patients', {
	    type: 'payload',
	    selector: ['patientUserId']
	  }, 'appointments', 'form_inspections']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	// POST /api/providers/:provider_user_id/patients/:patient_user_id/appointments/form_inspections

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'patient-type');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['services', {
	    type: 'payload',
	    selector: ['serviceId']
	  }, 'patient_types', {
	    type: 'payload.query',
	    queryParameter: 'available_at_provider_calendar',
	    value: 'yes'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'patients');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'providers',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['providerUserId']
	  }, 'patients', {
	    type: 'payload.query',
	    queryParameter: 'query',
	    selector: 'query'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	// GET /api/providers/:provider_user_id/patients
	// query

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('calendar', 'managed_practice_providers');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'managed_practice_providers']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'locations');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'appointments', 'locations']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'defaults');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'provider',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'calendar', 'schedule', 'defaults', {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'location_id',
	    selector: 'locationId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'date',
	    selector: 'date'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts, true);
	
	// /api/provider/:provider_profile_id/calendar/schedule/defaults?service_id=2&location_id=1&date=2020-11-16T00:00:00.000Z

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('schedule', 'visit-types');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'get',
	  slug: ['locations', {
	    type: 'payload',
	    selector: ['locationId']
	  }, 'visit_types']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionsScope = 'SURVEYS';
	
	var SURVEYS_TYPES = exports.SURVEYS_TYPES = {
	  LINK_CONSENT: actionsScope + '/LINK_CONSENT'
	};
	
	var ASSIGNMENT_METHOD = exports.ASSIGNMENT_METHOD = {
	  PROGRAM: 'program',
	  PROVIDER: 'provider',
	  BY_SYSTEM: 'admin',
	  PRE_VISIT_FORM: 'pre_visit_form',
	  REFERRAL_FORM: 'referral_form'
	};

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'forms');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'assigned_forms']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'reqFormResult');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'assignment_results', {
	    type: 'payload',
	    selector: ['assignmentId']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('surveys', 'reqReferralForms');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'refferal_forms']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = consentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(1366);
	
	var _props = __webpack_require__(41);
	
	var _appointmentConsentReq = __webpack_require__(898);
	
	var appointmentConsent = _interopRequireWildcard(_appointmentConsentReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(consentSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(consentSaga);
	
	function consentSagaWorker(_ref) {
	  var payload = _ref.payload;
	
	  var _ref2, settings, assignmentId, targetUserId, name, url, appointmentConsentId, response;
	
	  return _regenerator2.default.wrap(function consentSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _ref2 = payload || {}, settings = _ref2.settings, assignmentId = _ref2.assignmentId, targetUserId = _ref2.targetUserId;
	          name = (0, _get2.default)(settings, 'name');
	          url = null;
	
	          if (!(name === _props.QUESTION_TYPES.appointmentConsent)) {
	            _context.next = 11;
	            break;
	          }
	
	          appointmentConsentId = (0, _get2.default)(settings, 'meta.consentDescription.id');
	          _context.next = 7;
	          return (0, _effects.put)(appointmentConsent.actions.send({
	            assignmentId: assignmentId,
	            userId: targetUserId,
	            appointmentConsentId: appointmentConsentId
	          }));
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.take)(appointmentConsent.consts.SUCCEED);
	
	        case 9:
	          response = _context.sent;
	
	          url = (0, _get2.default)(response, 'payload.pdfFileUrl');
	
	        case 11:
	          if (name === _props.QUESTION_TYPES.consent) {
	            url = (0, _get2.default)(settings, 'meta.consentDescription.fileUrl', null);
	          }
	
	          if (url) window.open(url, '_blank');
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function consentSaga() {
	  return _regenerator2.default.wrap(function consentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_constants.SURVEYS_TYPES.LINK_CONSENT, consentSagaWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('teams', 'get-team-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'teams',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'default-tab', 'SET_TAB', 'RESET');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  id: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	  switch (type) {
	    case consts.SET_TAB:
	      return (0, _extends3.default)({}, state, {
	        id: payload
	      });
	    case consts.RESET:
	      return initialState;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var supportedActions = ['ADD', 'DELETE'];
	
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['ui', 'formInProgress'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.ADD:
	      return action.payload;
	    case consts.DELETE:
	      return initialState;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var _i18n = __webpack_require__(1219);
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'locale', ['SET_LOCALE']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _i18n.DEFAULT_LOCALE;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SET_LOCALE:
	      return action.payload;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var _brandConfig = __webpack_require__(142);
	
	var _styles = __webpack_require__(18);
	
	var _browserChecker = __webpack_require__(356);
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'theme', 'SET_THEME', 'CLEAR', 'SET_DEFAULT');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var loggedIn = window.localStorage.getItem('loggedIn');
	var communityPreview = window.localStorage.getItem('active-community-id');
	var IS_BROWSER_SUPPORTABLE = (0, _browserChecker.isSupportedBrowser)();
	
	var initialState = _brandConfig.isFlagler && !communityPreview && (!loggedIn || !IS_BROWSER_SUPPORTABLE) ? _styles.THEMES.FLAGLER : null;
	var defaultState = _brandConfig.isFlagler ? _styles.THEMES.FLAGLER : null;
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SET_THEME:
	      return action.payload;
	    case consts.SET_DEFAULT:
	      return defaultState;
	    case consts.CLEAR:
	      return null;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.videoCallEndPopupActions = exports.VIDEO_CALL_END_POPUP = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _createAction = __webpack_require__(68);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'ui/videoCallEndPopup';
	
	var VIDEO_CALL_END_POPUP = exports.VIDEO_CALL_END_POPUP = {
	  OPEN: actionsScope + '/open',
	  CLOSE: actionsScope + '/close'
	};
	
	var videoCallEndPopupActions = exports.videoCallEndPopupActions = {
	  open: (0, _createAction.createAction)(VIDEO_CALL_END_POPUP.OPEN),
	  close: (0, _createAction.createAction)(VIDEO_CALL_END_POPUP.CLOSE)
	};
	
	var initialState = {
	  visible: false,
	  status: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case VIDEO_CALL_END_POPUP.OPEN:
	      {
	        return {
	          visible: true,
	          status: payload
	        };
	      }
	
	    case VIDEO_CALL_END_POPUP.CLOSE:
	      {
	        return (0, _extends3.default)({}, state, {
	          visible: false
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 1377 */,
/* 1378 */,
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _ids = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (community, formatMessage, isCommunityPage) {
	  var isCommunityMember = (0, _get2.default)(community, 'currentUserRole');
	  var joinRequest = (0, _get2.default)(community, 'joinRequest');
	  var memberInvitationId = (0, _get2.default)(community, 'memberInvitationId');
	
	  if (memberInvitationId) {
	    return {
	      type: _constants.COMMUNITY_BTN_ACTIONS.ACCEPT,
	      id: _ids.IDS.COMMUNITY.ACCEPT_INVITATION_BTN,
	      buttonText: formatMessage({ id: 'common.accept' }),
	      disabled: false
	    };
	  }
	
	  if (isCommunityMember) {
	    return {
	      buttonText: formatMessage(isCommunityPage ? _strings.ACTIONS.community.createPost : _strings.MESSAGES_STATUS_FILTER_OPTIONS.joined),
	      id: isCommunityPage ? _ids.IDS.COMMUNITY.CREATE_POST_BTN : null,
	      disabled: !isCommunityPage
	    };
	  }
	
	  return joinRequest ? {
	    buttonText: formatMessage(_strings.DIALOG_TITLE.accessRequested),
	    id: null,
	    disabled: true
	  } : {
	    buttonText: formatMessage(_strings.DIALOG_TITLE.join),
	    id: _ids.IDS.COMMUNITY.JOIN_BTN,
	    disabled: false
	  };
	};

/***/ }),
/* 1380 */,
/* 1381 */,
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.validateAppointment = validateAppointment;
	exports.validateAppointmentByDate = validateAppointmentByDate;
	
	var _lodash = __webpack_require__(58);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function includesInList(path) {
	  return function (option, appointment) {
	    var id = (0, _lodash.get)(appointment, path);
	    return option.includes(id);
	  };
	}
	
	var validators = {
	  date: function date(option, appointment) {
	    var time = (0, _lodash.get)(appointment, 'startTime');
	    var localTime = (0, _moment2.default)(time).toISOString(true);
	    return localTime.includes(option);
	  },
	
	  locations: includesInList('location.id'),
	  services: includesInList('service.id'),
	  statuses: includesInList('status.id')
	};
	
	function validateAppointment(data, filterOptions) {
	  var validateResults = (0, _keys2.default)(filterOptions).reduce(function (acc, key) {
	    var option = filterOptions[key];
	    var validate = validators[key];
	    acc.push(validate(option, data));
	    return acc;
	  }, []);
	
	  return validateResults.every(function (value) {
	    return value === true;
	  });
	}
	
	function validateAppointmentByDate(data, _ref) {
	  var date = _ref.date;
	
	  return validators.date(date, data);
	}

/***/ }),
/* 1383 */,
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _autolinker = __webpack_require__(757);
	
	var _autolinker2 = _interopRequireDefault(_autolinker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (html) {
	  return _autolinker2.default.link(html, { className: 'clickable' });
	};

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _exifJs = __webpack_require__(4888);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (file, fullPreview) {
	  var defaultWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	  return new _promise2.default(function (resolve) {
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	
	    var image = new Image();
	
	    image.onload = function () {
	      var width = image.width,
	          height = image.height;
	
	      var ratio = width / height;
	
	      var PREVIEW_WIDTH = fullPreview ? width : defaultWidth;
	      var PREVIEW_HEIGHT = fullPreview ? height : PREVIEW_WIDTH / ratio;
	
	      canvas.width = PREVIEW_WIDTH;
	      canvas.height = PREVIEW_HEIGHT;
	
	      ctx.drawImage(image, 0, 0, PREVIEW_WIDTH, PREVIEW_HEIGHT);
	
	      var isExif = _exifJs.EXIF.getData(image, function () {
	        var orientation = _exifJs.EXIF.getTag(image, 'Orientation');
	
	        ctx.save();
	
	        if (orientation) {
	          if (orientation > 4) {
	            canvas.width = PREVIEW_HEIGHT;
	            canvas.height = PREVIEW_WIDTH;
	            canvas.style.width = PREVIEW_HEIGHT;
	            canvas.style.height = PREVIEW_WIDTH;
	          }
	
	          switch (orientation) {
	            case 2:
	              // horizontal flip
	              ctx.translate(canvas.width, 0);
	              ctx.scale(-1, 1);
	              break;
	            case 3:
	              // 180° rotate left
	              ctx.translate(canvas.width, canvas.height);
	              ctx.rotate(Math.PI);
	              break;
	            case 4:
	              // vertical flip
	              ctx.translate(0, canvas.height);
	              ctx.scale(1, -1);
	              break;
	            case 5:
	              // vertical flip + 90 rotate right
	              ctx.rotate(0.5 * Math.PI);
	              ctx.scale(1, -1);
	              break;
	            case 6:
	              // 90° rotate right
	              ctx.rotate(0.5 * Math.PI);
	              ctx.translate(0, -PREVIEW_HEIGHT);
	              break;
	            case 7:
	              // horizontal flip + 90 rotate right
	              ctx.rotate(0.5 * Math.PI);
	              ctx.translate(canvas.width, -canvas.height);
	              ctx.scale(-1, 1);
	              break;
	            case 8:
	              // 90° rotate left
	              ctx.rotate(-0.5 * Math.PI);
	              ctx.translate(-PREVIEW_WIDTH, 0);
	              break;
	
	            default:
	          }
	          ctx.drawImage(image, 0, 0, PREVIEW_WIDTH, PREVIEW_HEIGHT);
	          ctx.restore();
	        }
	
	        canvas.toBlob(function (blob) {
	          return resolve(blob);
	        }, file.type);
	      });
	
	      if (!isExif) canvas.toBlob(function (blob) {
	        return resolve(blob);
	      }, file.type);
	    };
	
	    image.src = window.URL.createObjectURL(file);
	  });
	};

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _getTaemOrUserName = __webpack_require__(1938);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var methods = (0, _keys2.default)(_strings.TODO_ASSIGNMENT_TITLE);
	
	exports.default = function (todo, formatMessage) {
	  var assignmentMethod = todo.assignmentMethod,
	      assignerName = todo.assignerName,
	      assigner = todo.assigner,
	      originalAssigner = todo.originalAssigner;
	
	  var _ref = assigner || {},
	      lastName = _ref.lastName,
	      firstName = _ref.firstName,
	      namePrefix = _ref.namePrefix,
	      nameSuffix = _ref.nameSuffix,
	      credential = _ref.credential;
	
	  var method = (assignmentMethod || '').toLowerCase();
	
	  var name = (assignerName || [namePrefix, firstName, lastName, nameSuffix, credential].join(' ') || '').trim();
	
	  var originalAssignerName = (0, _get2.default)(originalAssigner, 'displayableName');
	  var fullAssignerName = (0, _getTaemOrUserName.getTeamOrUserName)(name, originalAssignerName);
	
	  var task = formatMessage({ id: 'task.assigned' });
	  var assignment = methods.includes(method) ? ', ' + formatMessage(_strings.TODO_ASSIGNMENT_TITLE[method], {
	    name: fullAssignerName
	  }) : '';
	
	  return task + assignment;
	};

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateInsuranceFormFields = exports.getInitialInsuranceFormValues = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _validations = __webpack_require__(81);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _formFields = __webpack_require__(38);
	
	var _initialInsuranceFormState = __webpack_require__(1209);
	
	var _removeNonNumeric = __webpack_require__(4232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADDRESS_1 = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.ADDRESS_1,
	    ADDRESS_2 = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.ADDRESS_2,
	    CITY = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.CITY,
	    DOB = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DOB,
	    DO_NOT_HAVE_INSURANCE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DO_NOT_HAVE_INSURANCE,
	    FIRST_NAME = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.FIRST_NAME,
	    GENDER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GENDER,
	    GROUP_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GROUP_NUMBER,
	    HEALTH_PLAN = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.HEALTH_PLAN,
	    INSURANCE_RELATION_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.INSURANCE_RELATION_ID,
	    LAST_NAME = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.LAST_NAME,
	    MEMBER_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.MEMBER_ID,
	    PHONE_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PHONE_NUMBER,
	    POSTAL_CODE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.POSTAL_CODE,
	    PRIMARY_SUBSCRIBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PRIMARY_SUBSCRIBER,
	    STATE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.STATE;
	
	
	var convertFromBEDateFormatToDatePickerFormat = function convertFromBEDateFormatToDatePickerFormat(dateStr) {
	  if (!_validations.PATTERNS.YYYY_MM_DD_REGEX.test(dateStr)) return null;
	
	  var _dateStr$split = dateStr.split('-'),
	      _dateStr$split2 = (0, _slicedToArray3.default)(_dateStr$split, 3),
	      year = _dateStr$split2[0],
	      month = _dateStr$split2[1],
	      day = _dateStr$split2[2];
	
	  return month + '-' + day + '-' + year;
	};
	
	var getInitialInsuranceFormValues = exports.getInitialInsuranceFormValues = function getInitialInsuranceFormValues(_ref) {
	  var _extends2;
	
	  var insurance = _ref.insurance,
	      isAdditionalInsurance = _ref.isAdditionalInsurance,
	      flowType = _ref.flowType;
	  var payer = insurance.payer,
	      memberId = insurance.memberId,
	      groupNumber = insurance.groupNumber,
	      primarySubscriber = insurance.primarySubscriber,
	      insuranceId = insurance.id,
	      frontSide = insurance.frontSide,
	      backSide = insurance.backSide,
	      isPrimarySubscriber = insurance.isPrimarySubscriber;
	
	  var _payer = (0, _extends4.default)({}, payer),
	      id = _payer.id,
	      name = _payer.name;
	
	  var _primarySubscriber = (0, _extends4.default)({}, primarySubscriber),
	      address1 = _primarySubscriber.address1,
	      address2 = _primarySubscriber.address2,
	      city = _primarySubscriber.city,
	      dob = _primarySubscriber.dob,
	      firstName = _primarySubscriber.firstName,
	      gender = _primarySubscriber.gender,
	      insuranceRelationId = _primarySubscriber.insuranceRelationId,
	      lastName = _primarySubscriber.lastName,
	      phoneNumber = _primarySubscriber.phoneNumber,
	      postalCode = _primarySubscriber.postalCode,
	      state = _primarySubscriber.state;
	
	  var isToDoFlowType = flowType === _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO;
	
	  var healthPlanValue = id && name ? { id: id, label: name, value: name } : _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[HEALTH_PLAN];
	
	  var phoneNumberValue = phoneNumber && (0, _removeNonNumeric.removeNonNumeric)(phoneNumber) || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[PHONE_NUMBER];
	
	  var dobValue = dob && convertFromBEDateFormatToDatePickerFormat(dob) || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[DOB];
	
	  var hasInsuranceValue = !isAdditionalInsurance ? (0, _defineProperty3.default)({}, DO_NOT_HAVE_INSURANCE, insurance.skipInsurance) : null;
	
	  var primarySubscriberValue = isAdditionalInsurance || isToDoFlowType ? isPrimarySubscriber : !(primarySubscriber && (0, _values2.default)(primarySubscriber).length > 0);
	
	  var additionalInsuranceProps = { id: insuranceId, frontSide: frontSide, backSide: backSide };
	
	  return (0, _extends4.default)({}, hasInsuranceValue, additionalInsuranceProps, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, HEALTH_PLAN, healthPlanValue), (0, _defineProperty3.default)(_extends2, MEMBER_ID, memberId || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[MEMBER_ID]), (0, _defineProperty3.default)(_extends2, GROUP_NUMBER, groupNumber || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[GROUP_NUMBER]), (0, _defineProperty3.default)(_extends2, PRIMARY_SUBSCRIBER, primarySubscriberValue), (0, _defineProperty3.default)(_extends2, FIRST_NAME, firstName || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[FIRST_NAME]), (0, _defineProperty3.default)(_extends2, LAST_NAME, lastName || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[LAST_NAME]), (0, _defineProperty3.default)(_extends2, DOB, dobValue), (0, _defineProperty3.default)(_extends2, PHONE_NUMBER, phoneNumberValue), (0, _defineProperty3.default)(_extends2, ADDRESS_1, address1 || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[ADDRESS_1]), (0, _defineProperty3.default)(_extends2, ADDRESS_2, address2 || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[ADDRESS_2]), (0, _defineProperty3.default)(_extends2, CITY, city || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[CITY]), (0, _defineProperty3.default)(_extends2, STATE, state || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[STATE]), (0, _defineProperty3.default)(_extends2, POSTAL_CODE, postalCode || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[POSTAL_CODE]), (0, _defineProperty3.default)(_extends2, GENDER, gender || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[GENDER]), (0, _defineProperty3.default)(_extends2, INSURANCE_RELATION_ID, insuranceRelationId || _initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE[INSURANCE_RELATION_ID]), _extends2));
	};
	
	var validateInsuranceFormFields = exports.validateInsuranceFormFields = function validateInsuranceFormFields(_ref3) {
	  var formState = _ref3.formState,
	      _ref3$hideInsuranceRe = _ref3.hideInsuranceRelationFieldOrInfo,
	      hideInsuranceRelationFieldOrInfo = _ref3$hideInsuranceRe === undefined ? false : _ref3$hideInsuranceRe;
	
	  var healthPlan = (0, _get2.default)(formState, 'healthPlan', null);
	  var isPlanNotListedSelected = Boolean(healthPlan && !healthPlan.id);
	
	  if (formState[PRIMARY_SUBSCRIBER]) {
	    if (isPlanNotListedSelected) {
	      return true;
	    }
	    return [formState[MEMBER_ID], formState[HEALTH_PLAN]].every(Boolean);
	  }
	
	  var checkIsInsuranceRelationFieldFilled = function checkIsInsuranceRelationFieldFilled() {
	    // Empty array used to ensure the field is considered filled
	    if (hideInsuranceRelationFieldOrInfo) return [];
	
	    return formState[INSURANCE_RELATION_ID];
	  };
	
	  return [].concat((0, _toConsumableArray3.default)(isPlanNotListedSelected ? [] : [formState[MEMBER_ID]]), (0, _toConsumableArray3.default)(isPlanNotListedSelected ? [] : [formState[HEALTH_PLAN]]), [formState[FIRST_NAME], formState[LAST_NAME], formState[DOB], formState[ADDRESS_1], formState[CITY], formState[STATE], formState[PHONE_NUMBER], formState[POSTAL_CODE], formState[GENDER], checkIsInsuranceRelationFieldFilled()]).every(Boolean);
	};

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getReadOnlyChannelData = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _chat = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getReadOnlyChannelData = exports.getReadOnlyChannelData = function getReadOnlyChannelData(_ref) {
	  var socialChannel = _ref.socialChannel,
	      contextChannel = _ref.contextChannel;
	
	  var channel = contextChannel || socialChannel;
	
	  var _channel = (0, _extends3.default)({}, channel),
	      type = _channel.type,
	      blocked = _channel.blocked,
	      archived = _channel.archived,
	      practiceExists = _channel.practiceExists,
	      practiceProviders = _channel.practiceProviders,
	      hasPatientPractice = _channel.hasPatientPractice;
	
	  var isPracticeChannel = type === _chat.PRACTICE_CHANNEL;
	
	  var isNotExistingPractice = isPracticeChannel && !practiceExists;
	  var isEmptyPractice = isPracticeChannel && !practiceProviders;
	  var isNotInPractice = isPracticeChannel && !hasPatientPractice;
	
	  var isReadOnly = isNotExistingPractice || isEmptyPractice || archived || isNotInPractice;
	
	  var textId = 'errors.common';
	  if (isEmptyPractice) {
	    textId = 'messages.titles.practiceEmpty';
	  }
	  if (isNotExistingPractice) {
	    textId = 'messages.titles.practiceRemoved';
	  }
	  if (archived) {
	    textId = 'messages.titles.archivedChat';
	  }
	  if (isNotInPractice) {
	    textId = 'messages.titles.hasPractice';
	  }
	
	  return { isReadOnly: isReadOnly, blocked: blocked, textId: textId };
	};

/***/ }),
/* 1389 */,
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  sending: false,
	  succeed: null,
	  rejected: null,
	  error: null
	};
	var createReqReducer = function createReqReducer(consts) {
	  var wrapData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	    var SEND = consts.SEND,
	        SUCCEED = consts.SUCCEED,
	        REJECTED = consts.REJECTED,
	        ERROR_ENCOUNTERED = consts.ERROR_ENCOUNTERED,
	        ADD_META = consts.ADD_META,
	        CLEAR = consts.CLEAR;
	    var payload = action.payload,
	        type = action.type;
	
	
	    switch (type) {
	      case SEND:
	        return (0, _extends3.default)({}, state, initialState, {
	          sending: true
	        });
	      case SUCCEED:
	        {
	          var objectResponse = wrapData ? { data: payload } : payload;
	
	          return (0, _assign2.default)({}, initialState, {
	            succeed: true
	          }, Array.isArray(payload) ? { list: payload } : objectResponse);
	        }
	      case REJECTED:
	        return (0, _extends3.default)({}, initialState, payload, {
	          rejected: true
	        });
	      case ERROR_ENCOUNTERED:
	        return (0, _extends3.default)({}, initialState, {
	          error: payload
	        });
	      case ADD_META:
	        return (0, _extends3.default)({}, state, {
	          meta: payload
	        });
	      case CLEAR:
	        return initialState;
	      default:
	        return state;
	    }
	  };
	};
	
	exports.default = createReqReducer;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _snakeCase = __webpack_require__(467);
	
	var _snakeCase2 = _interopRequireDefault(_snakeCase);
	
	var _isObject = __webpack_require__(139);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isArray = __webpack_require__(96);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toSnakeCase(object) {
	  return (0, _keys2.default)(object).reduce(function (newObj, key) {
	    var value = object[key];
	    var isPureObject = (0, _isObject2.default)(value) && !(0, _isArray2.default)(value);
	
	    return (0, _extends4.default)({}, newObj, (0, _defineProperty3.default)({}, (0, _snakeCase2.default)(key), isPureObject ? toSnakeCase(value) : value));
	  }, {});
	}
	
	exports.default = toSnakeCase;

/***/ }),
/* 1392 */,
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validations = __webpack_require__(81);
	
	var _defaultValidator = __webpack_require__(700);
	
	exports.default = function (value) {
	  if (value) {
	    var isValidEmail = (0, _defaultValidator.defaultValidator)(_validations.PATTERNS.EMAIL, value);
	    var isValidPhone = (0, _defaultValidator.defaultValidator)(_validations.PATTERNS.PHONE_NUMBER, value);
	    return isValidEmail || isValidPhone;
	  }
	};

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (value) {
	    return Array.isArray(value) ? value.length : value.replace(/\s+/g, '').length;
	  }
	
	  return value;
	};

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4334), __esModule: true };

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4340), __esModule: true };

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t]}))};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e){return this.isBrowser(e)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})}));

/***/ }),
/* 1398 */
441,
/* 1399 */
271,
/* 1400 */
[6552, 222, 169],
/* 1401 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 1402 */
[6558, 704],
/* 1403 */
[6564, 917, 110, 2131, 365, 439, 552, 4367, 708, 2126, 170],
/* 1404 */
[6566, 920, 222, 439, 241, 438],
/* 1405 */
[6568, 703],
/* 1406 */
[6573, 706, 707, 366, 1414, 439, 2119, 268],
/* 1407 */
930,
/* 1408 */
[6579, 110, 100, 438],
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(365);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 1410 */
[6586, 1411, 920],
/* 1411 */
[6587, 169],
/* 1412 */
[6590, 315, 4365, 2118, 1400, 169, 704],
/* 1413 */
273,
/* 1414 */
[6595, 222],
/* 1415 */
[6596, 222],
/* 1416 */
[6597, 169, 100, 917, 1417, 241],
/* 1417 */
[6598, 170],
/* 1418 */
[6600, 916, 170, 552, 100],
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(146);
	var toAbsoluteIndex = __webpack_require__(450);
	var toLength = __webpack_require__(126);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 1420 */
[6545, 4408],
/* 1421 */
[6549, 125, 447],
/* 1422 */
[6552, 99, 89],
/* 1423 */
1401,
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(106)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 1425 */
[6556, 89],
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(99);
	var setPrototypeOf = __webpack_require__(1434).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 1427 */
[6559, 556, 106],
/* 1428 */
[6563, 444, 447, 557, 205, 106],
/* 1429 */
[6564, 443, 32, 206, 205, 204, 556, 1428, 557, 224, 106],
/* 1430 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 1432 */
[6567, 89, 1440, 242],
/* 1433 */
[6568, 171],
/* 1434 */
[6584, 99, 85, 243, 223],
/* 1435 */
[6586, 933, 451],
/* 1436 */
[6589, 273, 271],
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(927);
	var defined = __webpack_require__(271);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(273);
	var defined = __webpack_require__(271);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 1440 */
[6590, 243, 2146, 1425, 1422, 89, 242],
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(89);
	var DESCRIPTORS = __webpack_require__(124);
	var LIBRARY = __webpack_require__(443);
	var $typed = __webpack_require__(935);
	var hide = __webpack_require__(205);
	var redefineAll = __webpack_require__(448);
	var fails = __webpack_require__(95);
	var anInstance = __webpack_require__(441);
	var toInteger = __webpack_require__(273);
	var toLength = __webpack_require__(126);
	var toIndex = __webpack_require__(2164);
	var gOPN = __webpack_require__(445).f;
	var dP = __webpack_require__(125).f;
	var arrayFill = __webpack_require__(1419);
	var setToStringTag = __webpack_require__(557);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(89);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1443 */
[6597, 89, 270, 443, 2165, 125],
/* 1444 */
[6600, 709, 106, 556, 270],
/* 1445 */
[6602, 367, 2149, 556, 225, 1429],
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInBrowser = __webpack_require__(965);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var js = ''; /**
	              * Export javascript style and css style vendor prefixes.
	              * Based on "transform" support test.
	              */
	
	var css = '';
	
	// We should not do anything if required serverside.
	if (_isInBrowser2['default']) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    // IE did it wrong again ...
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  }
	}
	
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String}}
	 * @api public
	 */
	exports['default'] = { js: js, css: css };

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	var startOfWeek = __webpack_require__(4714)
	
	/**
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek (dirtyDate) {
	  return startOfWeek(dirtyDate, {weekStartsOn: 1})
	}
	
	module.exports = startOfISOWeek


/***/ }),
/* 1468 */
[6639, 53, 31, 939, 20],
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(712));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(713));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addQuarters
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * var result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var months = amount * 3;
	  return (0, _index2.default)(dirtyDate, months);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInDays;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(453));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Like `compareAsc` but uses local time not UTC, which is needed
	// for accurate equality comparisons of UTC timestamps that end up
	// having the same representation in local time, e.g. one hour before
	// DST ends vs. the instant that DST ends.
	function compareLocalAsc(dateLeft, dateRight) {
	  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
	
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	/**
	 * @name differenceInDays
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full day periods between two dates. Fractional days are
	 * truncated towards zero.
	 *
	 * One "full day" is the distance between a local time in one day to the same
	 * local time on the next or previous day. A full day can sometimes be less than
	 * or more than 24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days according to the local timezone
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 * // How many full days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * var result = differenceInDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 0
	 * // How many full days are between
	 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 92 days, even in
	 * // time zones where DST starts and the
	 * // period has only 92*24-1 hours.
	 * var result = differenceInDays(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 1)
	 * )
	//=> 92
	 */
	
	
	function differenceInDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = compareLocalAsc(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastDayNotFull = compareLocalAsc(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(2199));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1476));
	
	var _index3 = _interopRequireDefault(__webpack_require__(944));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfInterval
	 * @category Interval Helpers
	 * @summary List all the Saturdays and Sundays in the given date interval.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given date interval.
	 *
	 * @param {Interval} interval - the given interval. See [Interval]{@link docs/types/Interval}
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given date interval
	 * var result = eachWeekendOfInterval({
	 *   start: new Date(2018, 8, 17),
	 *   end: new Date(2018, 8, 30)
	 * })
	 * //=> [
	 * //   Sat Sep 22 2018 00:00:00,
	 * //   Sun Sep 23 2018 00:00:00,
	 * //   Sat Sep 29 2018 00:00:00,
	 * //   Sun Sep 30 2018 00:00:00
	 * // ]
	 */
	function eachWeekendOfInterval(interval) {
	  (0, _index4.default)(1, arguments);
	  var dateInterval = (0, _index.default)(interval);
	  var weekends = [];
	  var index = 0;
	
	  while (index < dateInterval.length) {
	    var date = dateInterval[index++];
	
	    if ((0, _index3.default)(date)) {
	      weekends.push(date);
	      if ((0, _index2.default)(date)) index = index + 5;
	    }
	  }
	
	  return weekends;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1473 */
[6652, 31, 20],
/* 1474 */
[6653, 31, 20],
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(371));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameWeek
	 * @category Week Helpers
	 * @summary Are the given dates in the same week?
	 *
	 * @description
	 * Are the given dates in the same week?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the dates are in the same week
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
	 * //=> true
	 *
	 * @example
	 * // If week starts with Monday,
	 * // are 31 August 2014 and 4 September 2014 in the same week?
	 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
	 *   weekStartsOn: 1
	 * })
	 * //=> false
	 */
	function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfWeek = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var dateRightStartOfWeek = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSunday;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSunday
	 * @category Weekday Helpers
	 * @summary Is the given date Sunday?
	 *
	 * @description
	 * Is the given date Sunday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 21 September 2014 Sunday?
	 * var result = isSunday(new Date(2014, 8, 21))
	 * //=> true
	 */
	function isSunday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 0;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The previous `parse` implementation was renamed to `parseISO`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   parseISO('2016-01-01')
	 *   ```
	 *
	 * - `parseISO` now validates separate date and time values in ISO-8601 strings
	 *   and returns `Invalid Date` if the date is invalid.
	 *
	 *   ```javascript
	 *   parseISO('2018-13-32')
	 *   //=> Invalid Date
	 *   ```
	 *
	 * - `parseISO` now doesn't fall back to `new Date` constructor
	 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	
	function parseISO(argument, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);
	
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	
	  var dateStrings = splitDateString(argument);
	  var date;
	
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	
	  if (isNaN(date) || !date) {
	    return new Date(NaN);
	  }
	
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	
	    if (isNaN(time) || time === null) {
	      return new Date(NaN);
	    }
	  }
	
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	
	    var result = new Date(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate(), dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    result.setFullYear(dirtyDate.getUTCFullYear());
	    return result;
	  }
	
	  return new Date(timestamp + time + offset);
	}
	
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString; // The regex match should only return at maximum two array elements.
	  // [date], [time], or [date, time].
	
	  if (array.length > 2) {
	    return dateStrings;
	  }
	
	  if (/:/.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings;
	}
	
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex); // Invalid ISO-formatted year
	
	  if (!captures) return {
	    year: null
	  };
	  var year = captures[1] && parseInt(captures[1]);
	  var century = captures[2] && parseInt(captures[2]);
	  return {
	    year: century == null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return null;
	  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string
	
	  if (!captures) return null;
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return null; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	
	  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
	}
	
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	
	  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
	}
	
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	} // Validation functions
	// February is null to handle the leap year (using ||)
	
	
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100;
	}
	
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1478 */
[6682, 53, 31, 2206, 20],
/* 1479 */
[6688, 31, 20],
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(2212));
	
	var _index2 = _interopRequireDefault(__webpack_require__(371));
	
	var _index3 = _interopRequireDefault(__webpack_require__(53));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Return the start of a local week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of a local week-numbering year.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the start of a week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // The start of an a week-numbering year for 2 July 2005 with default settings:
	 * var result = startOfWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // The start of a week-numbering year for 2 July 2005
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * var result = startOfWeekYear(new Date(2005, 6, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate);
	  var year = (0, _index.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1481 */
[6690, 31, 20],
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(369));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * var result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(2662);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b4feeee4","outerContainer":"_18723ff6","secondaryToolbar":"_46dc4e0d","doorHangerRight":"_0a0c0039","toolbarContainer":"_0e3f10a3","toolbarViewerMiddle":"_8ea08029","progressBar":"_3c250735","back-to-application":"efc346c4","date":"_62d90b98","date--left":"_26d02b45","date--has-border":"_39bc276d","send-message-container":"_14dc086f","send-message-container--has-reply":"_80f7ff95","send-message-container__cover":"_4a35d8e3","send-message-container__btn":"_2eb58f99","long-message":"b8e6eacb","important-icon-wrapper":"_586e87bb","newMessages-wrapper":"_9487cd0b","newMessages":"_4c406f6c","newMessages-label":"da4fdff7","title":"_92e1e065","send-button":"_1007cf47","text-input":"e27b82d7"};

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ad191676","outerContainer":"_6ede829d","secondaryToolbar":"c3efa2f1","doorHangerRight":"a3def979","toolbarContainer":"_5a227ad6","toolbarViewerMiddle":"_80334c6c","progressBar":"_5aaaee89","back-to-application":"_2c3037e1","root":"fa6d0cd0","danger":"af94f1f0","image":"b542490c","content":"_1e913ec2","heading":"_807d23e6","heading__title":"af8c79a0","heading__subtitle":"e7f1a9e3","heading__time":"_46b92fec","body":"e0eff1c4","deleted":"d562ee4a","action":"bc02641b","replies":"_1526aec8","previousLink":"_6c0f1dd4"};

/***/ }),
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"fb8baca6","outerContainer":"_5f2e6105","secondaryToolbar":"f29414c5","doorHangerRight":"b139a1f7","toolbarContainer":"b78e6d6a","toolbarViewerMiddle":"c019e683","progressBar":"_1483bc28","back-to-application":"_026dbd73","root":"e72772d5","rootHealthRecords":"e246f314","paginationRoot":"_46121842","paginationHealthRecords":"e93ffdc1","emptyStateRoot":"_0e63869a","noDataMessage":"bdcf09e6","paginationLoader":"_30255e26"};

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"fcc57026","outerContainer":"_26b5d962","secondaryToolbar":"_345c21d8","doorHangerRight":"_3487d589","toolbarContainer":"bf37c45b","toolbarViewerMiddle":"c731ea47","progressBar":"_27116e21","back-to-application":"_35288173","root":"c9103cda","error":"b0a67af8","content":"_097d0f2a","navigation":"_7e0a816b","content--profile":"_9d939384","content--info":"d0cc345a","userAvatar":"fb7aac69","info":"_1273b14c","user-profile-username":"f5ac277d","userName":"ab23c594","colored":"d0c75f46","common":"fa4d0336"};

/***/ }),
/* 1506 */,
/* 1507 */,
/* 1508 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_366995c7","outerContainer":"_859412eb","secondaryToolbar":"_66047271","doorHangerRight":"ef8cca9b","toolbarContainer":"_03c630be","toolbarViewerMiddle":"_1dc88c5e","progressBar":"_7cdea829","back-to-application":"_708797f5","root":"_66348db2","root--color--default":"_9dc27284","input":"d3cd2070","label":"_6abdfb0d","required":"_5b7d9dc8","root--invalid":"_997469ed","root--disabled":"fe0c4453","root--focused":"_1ea2f7ca","root--color--primary":"_446116e9","root--color--transparent":"d51f1b5d","passwordInput":"_4d369cb9","toggler":"e14f2f36","input--icon":"_5a3c7486","input--rounded":"cb02897e"};

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bffc4aa8","outerContainer":"_7150e206","secondaryToolbar":"bf3f3d4e","doorHangerRight":"_71fe1362","toolbarContainer":"de055380","toolbarViewerMiddle":"_9eefa7e2","progressBar":"_521830c0","back-to-application":"_9c315775","description":"a0cfa11e","description__text":"_70b408c6","list-btn":"_9e3d8bc8","list-item":"_9433cc43"};

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_994fcfd8","outerContainer":"e911c98c","secondaryToolbar":"_2bae47aa","doorHangerRight":"_54963646","toolbarContainer":"a682d800","toolbarViewerMiddle":"b32e779d","progressBar":"d38f74b9","back-to-application":"_7f7e3482","root":"_3c34ae78","overlay":"_37018d4f","actions":"_41c2ea6f","patient":"c3376136","pinned":"_60c20ffc","btn":"_259ea573","controls":"_47afa31f","btnClose":"a995e62d"};

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0dfdc4da","outerContainer":"_47b100a0","secondaryToolbar":"_7f7aa942","doorHangerRight":"_1ff9e1a8","toolbarContainer":"_0991db92","toolbarViewerMiddle":"f91e288f","progressBar":"_57d4f4e9","back-to-application":"_8c54d6f6","label":"_6d08bc98","labelText":"_24e0cfe8","labelVertical":"a2b78b7a","input":"c5d4e41d","checked":"_76a9ad60","unchecked":"_340aac7a","checker":"_45a03ab1"};

/***/ }),
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(2886) !== null) && (__webpack_require__(2887) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(5315);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// tslint:disable:only-arrow-functions
	// tslint:disable:object-literal-shorthand
	// tslint:disable:trailing-comma
	// tslint:disable:object-literal-sort-keys
	// tslint:disable:one-variable-per-declaration
	// tslint:disable:max-line-length
	// tslint:disable:no-consecutive-blank-lines
	// tslint:disable:align
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// Generated by PEG.js v. 0.10.0 (ts-pegjs plugin v. 0.2.6 )
	//
	// https://pegjs.org/   https://github.com/metadevpro/ts-pegjs
	var types_1 = __webpack_require__(1524);
	var SyntaxError = /** @class */ (function (_super) {
	    __extends(SyntaxError, _super);
	    function SyntaxError(message, expected, found, location) {
	        var _this = _super.call(this) || this;
	        _this.message = message;
	        _this.expected = expected;
	        _this.found = found;
	        _this.location = location;
	        _this.name = "SyntaxError";
	        if (typeof Error.captureStackTrace === "function") {
	            Error.captureStackTrace(_this, SyntaxError);
	        }
	        return _this;
	    }
	    SyntaxError.buildMessage = function (expected, found) {
	        function hex(ch) {
	            return ch.charCodeAt(0).toString(16).toUpperCase();
	        }
	        function literalEscape(s) {
	            return s
	                .replace(/\\/g, "\\\\")
	                .replace(/"/g, "\\\"")
	                .replace(/\0/g, "\\0")
	                .replace(/\t/g, "\\t")
	                .replace(/\n/g, "\\n")
	                .replace(/\r/g, "\\r")
	                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
	                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
	        }
	        function classEscape(s) {
	            return s
	                .replace(/\\/g, "\\\\")
	                .replace(/\]/g, "\\]")
	                .replace(/\^/g, "\\^")
	                .replace(/-/g, "\\-")
	                .replace(/\0/g, "\\0")
	                .replace(/\t/g, "\\t")
	                .replace(/\n/g, "\\n")
	                .replace(/\r/g, "\\r")
	                .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
	                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
	        }
	        function describeExpectation(expectation) {
	            switch (expectation.type) {
	                case "literal":
	                    return "\"" + literalEscape(expectation.text) + "\"";
	                case "class":
	                    var escapedParts = expectation.parts.map(function (part) {
	                        return Array.isArray(part)
	                            ? classEscape(part[0]) + "-" + classEscape(part[1])
	                            : classEscape(part);
	                    });
	                    return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
	                case "any":
	                    return "any character";
	                case "end":
	                    return "end of input";
	                case "other":
	                    return expectation.description;
	            }
	        }
	        function describeExpected(expected1) {
	            var descriptions = expected1.map(describeExpectation);
	            var i;
	            var j;
	            descriptions.sort();
	            if (descriptions.length > 0) {
	                for (i = 1, j = 1; i < descriptions.length; i++) {
	                    if (descriptions[i - 1] !== descriptions[i]) {
	                        descriptions[j] = descriptions[i];
	                        j++;
	                    }
	                }
	                descriptions.length = j;
	            }
	            switch (descriptions.length) {
	                case 1:
	                    return descriptions[0];
	                case 2:
	                    return descriptions[0] + " or " + descriptions[1];
	                default:
	                    return descriptions.slice(0, -1).join(", ")
	                        + ", or "
	                        + descriptions[descriptions.length - 1];
	            }
	        }
	        function describeFound(found1) {
	            return found1 ? "\"" + literalEscape(found1) + "\"" : "end of input";
	        }
	        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
	    };
	    return SyntaxError;
	}(Error));
	exports.SyntaxError = SyntaxError;
	function peg$parse(input, options) {
	    options = options !== undefined ? options : {};
	    var peg$FAILED = {};
	    var peg$startRuleFunctions = { start: peg$parsestart };
	    var peg$startRuleFunction = peg$parsestart;
	    var peg$c0 = function (parts) {
	        return parts.join('');
	    };
	    var peg$c1 = function (messageText) {
	        return __assign({ type: types_1.TYPE.literal, value: messageText }, insertLocation());
	    };
	    var peg$c2 = "#";
	    var peg$c3 = peg$literalExpectation("#", false);
	    var peg$c4 = function () {
	        return __assign({ type: types_1.TYPE.pound }, insertLocation());
	    };
	    var peg$c5 = peg$otherExpectation("argumentElement");
	    var peg$c6 = "{";
	    var peg$c7 = peg$literalExpectation("{", false);
	    var peg$c8 = "}";
	    var peg$c9 = peg$literalExpectation("}", false);
	    var peg$c10 = function (value) {
	        return __assign({ type: types_1.TYPE.argument, value: value }, insertLocation());
	    };
	    var peg$c11 = peg$otherExpectation("numberSkeletonId");
	    var peg$c12 = /^['\/{}]/;
	    var peg$c13 = peg$classExpectation(["'", "/", "{", "}"], false, false);
	    var peg$c14 = peg$anyExpectation();
	    var peg$c15 = peg$otherExpectation("numberSkeletonTokenOption");
	    var peg$c16 = "/";
	    var peg$c17 = peg$literalExpectation("/", false);
	    var peg$c18 = function (option) { return option; };
	    var peg$c19 = peg$otherExpectation("numberSkeletonToken");
	    var peg$c20 = function (stem, options) {
	        return { stem: stem, options: options };
	    };
	    var peg$c21 = function (tokens) {
	        return __assign({ type: 0 /* number */, tokens: tokens }, insertLocation());
	    };
	    var peg$c22 = "::";
	    var peg$c23 = peg$literalExpectation("::", false);
	    var peg$c24 = function (skeleton) { return skeleton; };
	    var peg$c25 = function () { messageCtx.push('numberArgStyle'); return true; };
	    var peg$c26 = function (style) {
	        messageCtx.pop();
	        return style.replace(/\s*$/, '');
	    };
	    var peg$c27 = ",";
	    var peg$c28 = peg$literalExpectation(",", false);
	    var peg$c29 = "number";
	    var peg$c30 = peg$literalExpectation("number", false);
	    var peg$c31 = function (value, type, style) {
	        return __assign({ type: type === 'number' ? types_1.TYPE.number : type === 'date' ? types_1.TYPE.date : types_1.TYPE.time, style: style && style[2], value: value }, insertLocation());
	    };
	    var peg$c32 = "'";
	    var peg$c33 = peg$literalExpectation("'", false);
	    var peg$c34 = /^[^']/;
	    var peg$c35 = peg$classExpectation(["'"], true, false);
	    var peg$c36 = /^[^a-zA-Z'{}]/;
	    var peg$c37 = peg$classExpectation([["a", "z"], ["A", "Z"], "'", "{", "}"], true, false);
	    var peg$c38 = /^[a-zA-Z]/;
	    var peg$c39 = peg$classExpectation([["a", "z"], ["A", "Z"]], false, false);
	    var peg$c40 = function (pattern) {
	        return __assign({ type: 1 /* dateTime */, pattern: pattern }, insertLocation());
	    };
	    var peg$c41 = function () { messageCtx.push('dateOrTimeArgStyle'); return true; };
	    var peg$c42 = "date";
	    var peg$c43 = peg$literalExpectation("date", false);
	    var peg$c44 = "time";
	    var peg$c45 = peg$literalExpectation("time", false);
	    var peg$c46 = "plural";
	    var peg$c47 = peg$literalExpectation("plural", false);
	    var peg$c48 = "selectordinal";
	    var peg$c49 = peg$literalExpectation("selectordinal", false);
	    var peg$c50 = "offset:";
	    var peg$c51 = peg$literalExpectation("offset:", false);
	    var peg$c52 = function (value, pluralType, offset, options) {
	        return __assign({ type: types_1.TYPE.plural, pluralType: pluralType === 'plural' ? 'cardinal' : 'ordinal', value: value, offset: offset ? offset[2] : 0, options: options.reduce(function (all, _a) {
	                var id = _a.id, value = _a.value, optionLocation = _a.location;
	                if (id in all) {
	                    error("Duplicate option \"" + id + "\" in plural element: \"" + text() + "\"", location());
	                }
	                all[id] = {
	                    value: value,
	                    location: optionLocation
	                };
	                return all;
	            }, {}) }, insertLocation());
	    };
	    var peg$c53 = "select";
	    var peg$c54 = peg$literalExpectation("select", false);
	    var peg$c55 = function (value, options) {
	        return __assign({ type: types_1.TYPE.select, value: value, options: options.reduce(function (all, _a) {
	                var id = _a.id, value = _a.value, optionLocation = _a.location;
	                if (id in all) {
	                    error("Duplicate option \"" + id + "\" in select element: \"" + text() + "\"", location());
	                }
	                all[id] = {
	                    value: value,
	                    location: optionLocation
	                };
	                return all;
	            }, {}) }, insertLocation());
	    };
	    var peg$c56 = "=";
	    var peg$c57 = peg$literalExpectation("=", false);
	    var peg$c58 = function (id) { messageCtx.push('select'); return true; };
	    var peg$c59 = function (id, value) {
	        messageCtx.pop();
	        return __assign({ id: id,
	            value: value }, insertLocation());
	    };
	    var peg$c60 = function (id) { messageCtx.push('plural'); return true; };
	    var peg$c61 = function (id, value) {
	        messageCtx.pop();
	        return __assign({ id: id,
	            value: value }, insertLocation());
	    };
	    var peg$c62 = peg$otherExpectation("whitespace");
	    var peg$c63 = /^[\t-\r \x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
	    var peg$c64 = peg$classExpectation([["\t", "\r"], " ", "\x85", "\xA0", "\u1680", ["\u2000", "\u200A"], "\u2028", "\u2029", "\u202F", "\u205F", "\u3000"], false, false);
	    var peg$c65 = peg$otherExpectation("syntax pattern");
	    var peg$c66 = /^[!-\/:-@[-\^`{-~\xA1-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u2010-\u2027\u2030-\u203E\u2041-\u2053\u2055-\u205E\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3001-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46]/;
	    var peg$c67 = peg$classExpectation([["!", "/"], [":", "@"], ["[", "^"], "`", ["{", "~"], ["\xA1", "\xA7"], "\xA9", "\xAB", "\xAC", "\xAE", "\xB0", "\xB1", "\xB6", "\xBB", "\xBF", "\xD7", "\xF7", ["\u2010", "\u2027"], ["\u2030", "\u203E"], ["\u2041", "\u2053"], ["\u2055", "\u205E"], ["\u2190", "\u245F"], ["\u2500", "\u2775"], ["\u2794", "\u2BFF"], ["\u2E00", "\u2E7F"], ["\u3001", "\u3003"], ["\u3008", "\u3020"], "\u3030", "\uFD3E", "\uFD3F", "\uFE45", "\uFE46"], false, false);
	    var peg$c68 = peg$otherExpectation("optional whitespace");
	    var peg$c69 = peg$otherExpectation("number");
	    var peg$c70 = "-";
	    var peg$c71 = peg$literalExpectation("-", false);
	    var peg$c72 = function (negative, num) {
	        return num
	            ? negative
	                ? -num
	                : num
	            : 0;
	    };
	    var peg$c73 = peg$otherExpectation("apostrophe");
	    var peg$c74 = peg$otherExpectation("double apostrophes");
	    var peg$c75 = "''";
	    var peg$c76 = peg$literalExpectation("''", false);
	    var peg$c77 = function () { return "'"; };
	    var peg$c78 = function (escapedChar, quotedChars) {
	        return escapedChar + quotedChars.replace("''", "'");
	    };
	    var peg$c79 = function (x) {
	        return (x !== '{' &&
	            !(isInPluralOption() && x === '#') &&
	            !(isNestedMessageText() && x === '}'));
	    };
	    var peg$c80 = "\n";
	    var peg$c81 = peg$literalExpectation("\n", false);
	    var peg$c82 = function (x) {
	        return x === '{' || x === '}' || (isInPluralOption() && x === '#');
	    };
	    var peg$c83 = peg$otherExpectation("argNameOrNumber");
	    var peg$c84 = peg$otherExpectation("argNumber");
	    var peg$c85 = "0";
	    var peg$c86 = peg$literalExpectation("0", false);
	    var peg$c87 = function () { return 0; };
	    var peg$c88 = /^[1-9]/;
	    var peg$c89 = peg$classExpectation([["1", "9"]], false, false);
	    var peg$c90 = /^[0-9]/;
	    var peg$c91 = peg$classExpectation([["0", "9"]], false, false);
	    var peg$c92 = function (digits) {
	        return parseInt(digits.join(''), 10);
	    };
	    var peg$c93 = peg$otherExpectation("argName");
	    var peg$currPos = 0;
	    var peg$savedPos = 0;
	    var peg$posDetailsCache = [{ line: 1, column: 1 }];
	    var peg$maxFailPos = 0;
	    var peg$maxFailExpected = [];
	    var peg$silentFails = 0;
	    var peg$result;
	    if (options.startRule !== undefined) {
	        if (!(options.startRule in peg$startRuleFunctions)) {
	            throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	        }
	        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	    function text() {
	        return input.substring(peg$savedPos, peg$currPos);
	    }
	    function location() {
	        return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	    function expected(description, location1) {
	        location1 = location1 !== undefined
	            ? location1
	            : peg$computeLocation(peg$savedPos, peg$currPos);
	        throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location1);
	    }
	    function error(message, location1) {
	        location1 = location1 !== undefined
	            ? location1
	            : peg$computeLocation(peg$savedPos, peg$currPos);
	        throw peg$buildSimpleError(message, location1);
	    }
	    function peg$literalExpectation(text1, ignoreCase) {
	        return { type: "literal", text: text1, ignoreCase: ignoreCase };
	    }
	    function peg$classExpectation(parts, inverted, ignoreCase) {
	        return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
	    }
	    function peg$anyExpectation() {
	        return { type: "any" };
	    }
	    function peg$endExpectation() {
	        return { type: "end" };
	    }
	    function peg$otherExpectation(description) {
	        return { type: "other", description: description };
	    }
	    function peg$computePosDetails(pos) {
	        var details = peg$posDetailsCache[pos];
	        var p;
	        if (details) {
	            return details;
	        }
	        else {
	            p = pos - 1;
	            while (!peg$posDetailsCache[p]) {
	                p--;
	            }
	            details = peg$posDetailsCache[p];
	            details = {
	                line: details.line,
	                column: details.column
	            };
	            while (p < pos) {
	                if (input.charCodeAt(p) === 10) {
	                    details.line++;
	                    details.column = 1;
	                }
	                else {
	                    details.column++;
	                }
	                p++;
	            }
	            peg$posDetailsCache[pos] = details;
	            return details;
	        }
	    }
	    function peg$computeLocation(startPos, endPos) {
	        var startPosDetails = peg$computePosDetails(startPos);
	        var endPosDetails = peg$computePosDetails(endPos);
	        return {
	            start: {
	                offset: startPos,
	                line: startPosDetails.line,
	                column: startPosDetails.column
	            },
	            end: {
	                offset: endPos,
	                line: endPosDetails.line,
	                column: endPosDetails.column
	            }
	        };
	    }
	    function peg$fail(expected1) {
	        if (peg$currPos < peg$maxFailPos) {
	            return;
	        }
	        if (peg$currPos > peg$maxFailPos) {
	            peg$maxFailPos = peg$currPos;
	            peg$maxFailExpected = [];
	        }
	        peg$maxFailExpected.push(expected1);
	    }
	    function peg$buildSimpleError(message, location1) {
	        return new SyntaxError(message, [], "", location1);
	    }
	    function peg$buildStructuredError(expected1, found, location1) {
	        return new SyntaxError(SyntaxError.buildMessage(expected1, found), expected1, found, location1);
	    }
	    function peg$parsestart() {
	        var s0;
	        s0 = peg$parsemessage();
	        return s0;
	    }
	    function peg$parsemessage() {
	        var s0, s1;
	        s0 = [];
	        s1 = peg$parsemessageElement();
	        while (s1 !== peg$FAILED) {
	            s0.push(s1);
	            s1 = peg$parsemessageElement();
	        }
	        return s0;
	    }
	    function peg$parsemessageElement() {
	        var s0;
	        s0 = peg$parseliteralElement();
	        if (s0 === peg$FAILED) {
	            s0 = peg$parseargumentElement();
	            if (s0 === peg$FAILED) {
	                s0 = peg$parsesimpleFormatElement();
	                if (s0 === peg$FAILED) {
	                    s0 = peg$parsepluralElement();
	                    if (s0 === peg$FAILED) {
	                        s0 = peg$parseselectElement();
	                        if (s0 === peg$FAILED) {
	                            s0 = peg$parsepoundElement();
	                        }
	                    }
	                }
	            }
	        }
	        return s0;
	    }
	    function peg$parsemessageText() {
	        var s0, s1, s2;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$parsedoubleApostrophes();
	        if (s2 === peg$FAILED) {
	            s2 = peg$parsequotedString();
	            if (s2 === peg$FAILED) {
	                s2 = peg$parseunquotedString();
	            }
	        }
	        if (s2 !== peg$FAILED) {
	            while (s2 !== peg$FAILED) {
	                s1.push(s2);
	                s2 = peg$parsedoubleApostrophes();
	                if (s2 === peg$FAILED) {
	                    s2 = peg$parsequotedString();
	                    if (s2 === peg$FAILED) {
	                        s2 = peg$parseunquotedString();
	                    }
	                }
	            }
	        }
	        else {
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c0(s1);
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parseliteralElement() {
	        var s0, s1;
	        s0 = peg$currPos;
	        s1 = peg$parsemessageText();
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c1(s1);
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parsepoundElement() {
	        var s0, s1;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 35) {
	            s1 = peg$c2;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c3);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c4();
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parseargumentElement() {
	        var s0, s1, s2, s3, s4, s5;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 125) {
	                            s5 = peg$c8;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c9);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            peg$savedPos = s0;
	                            s1 = peg$c10(s3);
	                            s0 = s1;
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c5);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberSkeletonId() {
	        var s0, s1, s2, s3, s4;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$currPos;
	        s3 = peg$currPos;
	        peg$silentFails++;
	        s4 = peg$parsewhiteSpace();
	        if (s4 === peg$FAILED) {
	            if (peg$c12.test(input.charAt(peg$currPos))) {
	                s4 = input.charAt(peg$currPos);
	                peg$currPos++;
	            }
	            else {
	                s4 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c13);
	                }
	            }
	        }
	        peg$silentFails--;
	        if (s4 === peg$FAILED) {
	            s3 = undefined;
	        }
	        else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	        }
	        if (s3 !== peg$FAILED) {
	            if (input.length > peg$currPos) {
	                s4 = input.charAt(peg$currPos);
	                peg$currPos++;
	            }
	            else {
	                s4 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c14);
	                }
	            }
	            if (s4 !== peg$FAILED) {
	                s3 = [s3, s4];
	                s2 = s3;
	            }
	            else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	            while (s2 !== peg$FAILED) {
	                s1.push(s2);
	                s2 = peg$currPos;
	                s3 = peg$currPos;
	                peg$silentFails++;
	                s4 = peg$parsewhiteSpace();
	                if (s4 === peg$FAILED) {
	                    if (peg$c12.test(input.charAt(peg$currPos))) {
	                        s4 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c13);
	                        }
	                    }
	                }
	                peg$silentFails--;
	                if (s4 === peg$FAILED) {
	                    s3 = undefined;
	                }
	                else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                }
	                if (s3 !== peg$FAILED) {
	                    if (input.length > peg$currPos) {
	                        s4 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c14);
	                        }
	                    }
	                    if (s4 !== peg$FAILED) {
	                        s3 = [s3, s4];
	                        s2 = s3;
	                    }
	                    else {
	                        peg$currPos = s2;
	                        s2 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s2;
	                    s2 = peg$FAILED;
	                }
	            }
	        }
	        else {
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c11);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberSkeletonTokenOption() {
	        var s0, s1, s2;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 47) {
	            s1 = peg$c16;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c17);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsenumberSkeletonId();
	            if (s2 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c18(s2);
	                s0 = s1;
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c15);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberSkeletonToken() {
	        var s0, s1, s2, s3, s4;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = peg$parse_();
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsenumberSkeletonId();
	            if (s2 !== peg$FAILED) {
	                s3 = [];
	                s4 = peg$parsenumberSkeletonTokenOption();
	                while (s4 !== peg$FAILED) {
	                    s3.push(s4);
	                    s4 = peg$parsenumberSkeletonTokenOption();
	                }
	                if (s3 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c20(s2, s3);
	                    s0 = s1;
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c19);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberSkeleton() {
	        var s0, s1, s2;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$parsenumberSkeletonToken();
	        if (s2 !== peg$FAILED) {
	            while (s2 !== peg$FAILED) {
	                s1.push(s2);
	                s2 = peg$parsenumberSkeletonToken();
	            }
	        }
	        else {
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c21(s1);
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parsenumberArgStyle() {
	        var s0, s1, s2;
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c22) {
	            s1 = peg$c22;
	            peg$currPos += 2;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c23);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsenumberSkeleton();
	            if (s2 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s2);
	                s0 = s1;
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            peg$savedPos = peg$currPos;
	            s1 = peg$c25();
	            if (s1) {
	                s1 = undefined;
	            }
	            else {
	                s1 = peg$FAILED;
	            }
	            if (s1 !== peg$FAILED) {
	                s2 = peg$parsemessageText();
	                if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c26(s2);
	                    s0 = s1;
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumberFormatElement() {
	        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 44) {
	                            s5 = peg$c27;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c28);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parse_();
	                            if (s6 !== peg$FAILED) {
	                                if (input.substr(peg$currPos, 6) === peg$c29) {
	                                    s7 = peg$c29;
	                                    peg$currPos += 6;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c30);
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    s8 = peg$parse_();
	                                    if (s8 !== peg$FAILED) {
	                                        s9 = peg$currPos;
	                                        if (input.charCodeAt(peg$currPos) === 44) {
	                                            s10 = peg$c27;
	                                            peg$currPos++;
	                                        }
	                                        else {
	                                            s10 = peg$FAILED;
	                                            if (peg$silentFails === 0) {
	                                                peg$fail(peg$c28);
	                                            }
	                                        }
	                                        if (s10 !== peg$FAILED) {
	                                            s11 = peg$parse_();
	                                            if (s11 !== peg$FAILED) {
	                                                s12 = peg$parsenumberArgStyle();
	                                                if (s12 !== peg$FAILED) {
	                                                    s10 = [s10, s11, s12];
	                                                    s9 = s10;
	                                                }
	                                                else {
	                                                    peg$currPos = s9;
	                                                    s9 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s9;
	                                                s9 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s9;
	                                            s9 = peg$FAILED;
	                                        }
	                                        if (s9 === peg$FAILED) {
	                                            s9 = null;
	                                        }
	                                        if (s9 !== peg$FAILED) {
	                                            s10 = peg$parse_();
	                                            if (s10 !== peg$FAILED) {
	                                                if (input.charCodeAt(peg$currPos) === 125) {
	                                                    s11 = peg$c8;
	                                                    peg$currPos++;
	                                                }
	                                                else {
	                                                    s11 = peg$FAILED;
	                                                    if (peg$silentFails === 0) {
	                                                        peg$fail(peg$c9);
	                                                    }
	                                                }
	                                                if (s11 !== peg$FAILED) {
	                                                    peg$savedPos = s0;
	                                                    s1 = peg$c31(s3, s7, s9);
	                                                    s0 = s1;
	                                                }
	                                                else {
	                                                    peg$currPos = s0;
	                                                    s0 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s0;
	                                                s0 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s0;
	                                            s0 = peg$FAILED;
	                                        }
	                                    }
	                                    else {
	                                        peg$currPos = s0;
	                                        s0 = peg$FAILED;
	                                    }
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsedateTimeSkeletonLiteral() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 39) {
	            s1 = peg$c32;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c33);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = [];
	            s3 = peg$parsedoubleApostrophes();
	            if (s3 === peg$FAILED) {
	                if (peg$c34.test(input.charAt(peg$currPos))) {
	                    s3 = input.charAt(peg$currPos);
	                    peg$currPos++;
	                }
	                else {
	                    s3 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c35);
	                    }
	                }
	            }
	            if (s3 !== peg$FAILED) {
	                while (s3 !== peg$FAILED) {
	                    s2.push(s3);
	                    s3 = peg$parsedoubleApostrophes();
	                    if (s3 === peg$FAILED) {
	                        if (peg$c34.test(input.charAt(peg$currPos))) {
	                            s3 = input.charAt(peg$currPos);
	                            peg$currPos++;
	                        }
	                        else {
	                            s3 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c35);
	                            }
	                        }
	                    }
	                }
	            }
	            else {
	                s2 = peg$FAILED;
	            }
	            if (s2 !== peg$FAILED) {
	                if (input.charCodeAt(peg$currPos) === 39) {
	                    s3 = peg$c32;
	                    peg$currPos++;
	                }
	                else {
	                    s3 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c33);
	                    }
	                }
	                if (s3 !== peg$FAILED) {
	                    s1 = [s1, s2, s3];
	                    s0 = s1;
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        if (s0 === peg$FAILED) {
	            s0 = [];
	            s1 = peg$parsedoubleApostrophes();
	            if (s1 === peg$FAILED) {
	                if (peg$c36.test(input.charAt(peg$currPos))) {
	                    s1 = input.charAt(peg$currPos);
	                    peg$currPos++;
	                }
	                else {
	                    s1 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c37);
	                    }
	                }
	            }
	            if (s1 !== peg$FAILED) {
	                while (s1 !== peg$FAILED) {
	                    s0.push(s1);
	                    s1 = peg$parsedoubleApostrophes();
	                    if (s1 === peg$FAILED) {
	                        if (peg$c36.test(input.charAt(peg$currPos))) {
	                            s1 = input.charAt(peg$currPos);
	                            peg$currPos++;
	                        }
	                        else {
	                            s1 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c37);
	                            }
	                        }
	                    }
	                }
	            }
	            else {
	                s0 = peg$FAILED;
	            }
	        }
	        return s0;
	    }
	    function peg$parsedateTimeSkeletonPattern() {
	        var s0, s1;
	        s0 = [];
	        if (peg$c38.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c39);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            while (s1 !== peg$FAILED) {
	                s0.push(s1);
	                if (peg$c38.test(input.charAt(peg$currPos))) {
	                    s1 = input.charAt(peg$currPos);
	                    peg$currPos++;
	                }
	                else {
	                    s1 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c39);
	                    }
	                }
	            }
	        }
	        else {
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsedateTimeSkeleton() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        s1 = peg$currPos;
	        s2 = [];
	        s3 = peg$parsedateTimeSkeletonLiteral();
	        if (s3 === peg$FAILED) {
	            s3 = peg$parsedateTimeSkeletonPattern();
	        }
	        if (s3 !== peg$FAILED) {
	            while (s3 !== peg$FAILED) {
	                s2.push(s3);
	                s3 = peg$parsedateTimeSkeletonLiteral();
	                if (s3 === peg$FAILED) {
	                    s3 = peg$parsedateTimeSkeletonPattern();
	                }
	            }
	        }
	        else {
	            s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	            s1 = input.substring(s1, peg$currPos);
	        }
	        else {
	            s1 = s2;
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c40(s1);
	        }
	        s0 = s1;
	        return s0;
	    }
	    function peg$parsedateOrTimeArgStyle() {
	        var s0, s1, s2;
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c22) {
	            s1 = peg$c22;
	            peg$currPos += 2;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c23);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsedateTimeSkeleton();
	            if (s2 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s2);
	                s0 = s1;
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            peg$savedPos = peg$currPos;
	            s1 = peg$c41();
	            if (s1) {
	                s1 = undefined;
	            }
	            else {
	                s1 = peg$FAILED;
	            }
	            if (s1 !== peg$FAILED) {
	                s2 = peg$parsemessageText();
	                if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c26(s2);
	                    s0 = s1;
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        return s0;
	    }
	    function peg$parsedateOrTimeFormatElement() {
	        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 44) {
	                            s5 = peg$c27;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c28);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parse_();
	                            if (s6 !== peg$FAILED) {
	                                if (input.substr(peg$currPos, 4) === peg$c42) {
	                                    s7 = peg$c42;
	                                    peg$currPos += 4;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c43);
	                                    }
	                                }
	                                if (s7 === peg$FAILED) {
	                                    if (input.substr(peg$currPos, 4) === peg$c44) {
	                                        s7 = peg$c44;
	                                        peg$currPos += 4;
	                                    }
	                                    else {
	                                        s7 = peg$FAILED;
	                                        if (peg$silentFails === 0) {
	                                            peg$fail(peg$c45);
	                                        }
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    s8 = peg$parse_();
	                                    if (s8 !== peg$FAILED) {
	                                        s9 = peg$currPos;
	                                        if (input.charCodeAt(peg$currPos) === 44) {
	                                            s10 = peg$c27;
	                                            peg$currPos++;
	                                        }
	                                        else {
	                                            s10 = peg$FAILED;
	                                            if (peg$silentFails === 0) {
	                                                peg$fail(peg$c28);
	                                            }
	                                        }
	                                        if (s10 !== peg$FAILED) {
	                                            s11 = peg$parse_();
	                                            if (s11 !== peg$FAILED) {
	                                                s12 = peg$parsedateOrTimeArgStyle();
	                                                if (s12 !== peg$FAILED) {
	                                                    s10 = [s10, s11, s12];
	                                                    s9 = s10;
	                                                }
	                                                else {
	                                                    peg$currPos = s9;
	                                                    s9 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s9;
	                                                s9 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s9;
	                                            s9 = peg$FAILED;
	                                        }
	                                        if (s9 === peg$FAILED) {
	                                            s9 = null;
	                                        }
	                                        if (s9 !== peg$FAILED) {
	                                            s10 = peg$parse_();
	                                            if (s10 !== peg$FAILED) {
	                                                if (input.charCodeAt(peg$currPos) === 125) {
	                                                    s11 = peg$c8;
	                                                    peg$currPos++;
	                                                }
	                                                else {
	                                                    s11 = peg$FAILED;
	                                                    if (peg$silentFails === 0) {
	                                                        peg$fail(peg$c9);
	                                                    }
	                                                }
	                                                if (s11 !== peg$FAILED) {
	                                                    peg$savedPos = s0;
	                                                    s1 = peg$c31(s3, s7, s9);
	                                                    s0 = s1;
	                                                }
	                                                else {
	                                                    peg$currPos = s0;
	                                                    s0 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s0;
	                                                s0 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s0;
	                                            s0 = peg$FAILED;
	                                        }
	                                    }
	                                    else {
	                                        peg$currPos = s0;
	                                        s0 = peg$FAILED;
	                                    }
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsesimpleFormatElement() {
	        var s0;
	        s0 = peg$parsenumberFormatElement();
	        if (s0 === peg$FAILED) {
	            s0 = peg$parsedateOrTimeFormatElement();
	        }
	        return s0;
	    }
	    function peg$parsepluralElement() {
	        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 44) {
	                            s5 = peg$c27;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c28);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parse_();
	                            if (s6 !== peg$FAILED) {
	                                if (input.substr(peg$currPos, 6) === peg$c46) {
	                                    s7 = peg$c46;
	                                    peg$currPos += 6;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c47);
	                                    }
	                                }
	                                if (s7 === peg$FAILED) {
	                                    if (input.substr(peg$currPos, 13) === peg$c48) {
	                                        s7 = peg$c48;
	                                        peg$currPos += 13;
	                                    }
	                                    else {
	                                        s7 = peg$FAILED;
	                                        if (peg$silentFails === 0) {
	                                            peg$fail(peg$c49);
	                                        }
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    s8 = peg$parse_();
	                                    if (s8 !== peg$FAILED) {
	                                        if (input.charCodeAt(peg$currPos) === 44) {
	                                            s9 = peg$c27;
	                                            peg$currPos++;
	                                        }
	                                        else {
	                                            s9 = peg$FAILED;
	                                            if (peg$silentFails === 0) {
	                                                peg$fail(peg$c28);
	                                            }
	                                        }
	                                        if (s9 !== peg$FAILED) {
	                                            s10 = peg$parse_();
	                                            if (s10 !== peg$FAILED) {
	                                                s11 = peg$currPos;
	                                                if (input.substr(peg$currPos, 7) === peg$c50) {
	                                                    s12 = peg$c50;
	                                                    peg$currPos += 7;
	                                                }
	                                                else {
	                                                    s12 = peg$FAILED;
	                                                    if (peg$silentFails === 0) {
	                                                        peg$fail(peg$c51);
	                                                    }
	                                                }
	                                                if (s12 !== peg$FAILED) {
	                                                    s13 = peg$parse_();
	                                                    if (s13 !== peg$FAILED) {
	                                                        s14 = peg$parsenumber();
	                                                        if (s14 !== peg$FAILED) {
	                                                            s12 = [s12, s13, s14];
	                                                            s11 = s12;
	                                                        }
	                                                        else {
	                                                            peg$currPos = s11;
	                                                            s11 = peg$FAILED;
	                                                        }
	                                                    }
	                                                    else {
	                                                        peg$currPos = s11;
	                                                        s11 = peg$FAILED;
	                                                    }
	                                                }
	                                                else {
	                                                    peg$currPos = s11;
	                                                    s11 = peg$FAILED;
	                                                }
	                                                if (s11 === peg$FAILED) {
	                                                    s11 = null;
	                                                }
	                                                if (s11 !== peg$FAILED) {
	                                                    s12 = peg$parse_();
	                                                    if (s12 !== peg$FAILED) {
	                                                        s13 = [];
	                                                        s14 = peg$parsepluralOption();
	                                                        if (s14 !== peg$FAILED) {
	                                                            while (s14 !== peg$FAILED) {
	                                                                s13.push(s14);
	                                                                s14 = peg$parsepluralOption();
	                                                            }
	                                                        }
	                                                        else {
	                                                            s13 = peg$FAILED;
	                                                        }
	                                                        if (s13 !== peg$FAILED) {
	                                                            s14 = peg$parse_();
	                                                            if (s14 !== peg$FAILED) {
	                                                                if (input.charCodeAt(peg$currPos) === 125) {
	                                                                    s15 = peg$c8;
	                                                                    peg$currPos++;
	                                                                }
	                                                                else {
	                                                                    s15 = peg$FAILED;
	                                                                    if (peg$silentFails === 0) {
	                                                                        peg$fail(peg$c9);
	                                                                    }
	                                                                }
	                                                                if (s15 !== peg$FAILED) {
	                                                                    peg$savedPos = s0;
	                                                                    s1 = peg$c52(s3, s7, s11, s13);
	                                                                    s0 = s1;
	                                                                }
	                                                                else {
	                                                                    peg$currPos = s0;
	                                                                    s0 = peg$FAILED;
	                                                                }
	                                                            }
	                                                            else {
	                                                                peg$currPos = s0;
	                                                                s0 = peg$FAILED;
	                                                            }
	                                                        }
	                                                        else {
	                                                            peg$currPos = s0;
	                                                            s0 = peg$FAILED;
	                                                        }
	                                                    }
	                                                    else {
	                                                        peg$currPos = s0;
	                                                        s0 = peg$FAILED;
	                                                    }
	                                                }
	                                                else {
	                                                    peg$currPos = s0;
	                                                    s0 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s0;
	                                                s0 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s0;
	                                            s0 = peg$FAILED;
	                                        }
	                                    }
	                                    else {
	                                        peg$currPos = s0;
	                                        s0 = peg$FAILED;
	                                    }
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parseselectElement() {
	        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 123) {
	            s1 = peg$c6;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c7);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parse_();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parseargNameOrNumber();
	                if (s3 !== peg$FAILED) {
	                    s4 = peg$parse_();
	                    if (s4 !== peg$FAILED) {
	                        if (input.charCodeAt(peg$currPos) === 44) {
	                            s5 = peg$c27;
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c28);
	                            }
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parse_();
	                            if (s6 !== peg$FAILED) {
	                                if (input.substr(peg$currPos, 6) === peg$c53) {
	                                    s7 = peg$c53;
	                                    peg$currPos += 6;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c54);
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    s8 = peg$parse_();
	                                    if (s8 !== peg$FAILED) {
	                                        if (input.charCodeAt(peg$currPos) === 44) {
	                                            s9 = peg$c27;
	                                            peg$currPos++;
	                                        }
	                                        else {
	                                            s9 = peg$FAILED;
	                                            if (peg$silentFails === 0) {
	                                                peg$fail(peg$c28);
	                                            }
	                                        }
	                                        if (s9 !== peg$FAILED) {
	                                            s10 = peg$parse_();
	                                            if (s10 !== peg$FAILED) {
	                                                s11 = [];
	                                                s12 = peg$parseselectOption();
	                                                if (s12 !== peg$FAILED) {
	                                                    while (s12 !== peg$FAILED) {
	                                                        s11.push(s12);
	                                                        s12 = peg$parseselectOption();
	                                                    }
	                                                }
	                                                else {
	                                                    s11 = peg$FAILED;
	                                                }
	                                                if (s11 !== peg$FAILED) {
	                                                    s12 = peg$parse_();
	                                                    if (s12 !== peg$FAILED) {
	                                                        if (input.charCodeAt(peg$currPos) === 125) {
	                                                            s13 = peg$c8;
	                                                            peg$currPos++;
	                                                        }
	                                                        else {
	                                                            s13 = peg$FAILED;
	                                                            if (peg$silentFails === 0) {
	                                                                peg$fail(peg$c9);
	                                                            }
	                                                        }
	                                                        if (s13 !== peg$FAILED) {
	                                                            peg$savedPos = s0;
	                                                            s1 = peg$c55(s3, s11);
	                                                            s0 = s1;
	                                                        }
	                                                        else {
	                                                            peg$currPos = s0;
	                                                            s0 = peg$FAILED;
	                                                        }
	                                                    }
	                                                    else {
	                                                        peg$currPos = s0;
	                                                        s0 = peg$FAILED;
	                                                    }
	                                                }
	                                                else {
	                                                    peg$currPos = s0;
	                                                    s0 = peg$FAILED;
	                                                }
	                                            }
	                                            else {
	                                                peg$currPos = s0;
	                                                s0 = peg$FAILED;
	                                            }
	                                        }
	                                        else {
	                                            peg$currPos = s0;
	                                            s0 = peg$FAILED;
	                                        }
	                                    }
	                                    else {
	                                        peg$currPos = s0;
	                                        s0 = peg$FAILED;
	                                    }
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsepluralRuleSelectValue() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        s1 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 61) {
	            s2 = peg$c56;
	            peg$currPos++;
	        }
	        else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c57);
	            }
	        }
	        if (s2 !== peg$FAILED) {
	            s3 = peg$parsenumber();
	            if (s3 !== peg$FAILED) {
	                s2 = [s2, s3];
	                s1 = s2;
	            }
	            else {
	                peg$currPos = s1;
	                s1 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s1;
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        if (s0 === peg$FAILED) {
	            s0 = peg$parseargName();
	        }
	        return s0;
	    }
	    function peg$parseselectOption() {
	        var s0, s1, s2, s3, s4, s5, s6, s7;
	        s0 = peg$currPos;
	        s1 = peg$parse_();
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parseargName();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parse_();
	                if (s3 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 123) {
	                        s4 = peg$c6;
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c7);
	                        }
	                    }
	                    if (s4 !== peg$FAILED) {
	                        peg$savedPos = peg$currPos;
	                        s5 = peg$c58(s2);
	                        if (s5) {
	                            s5 = undefined;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parsemessage();
	                            if (s6 !== peg$FAILED) {
	                                if (input.charCodeAt(peg$currPos) === 125) {
	                                    s7 = peg$c8;
	                                    peg$currPos++;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c9);
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    peg$savedPos = s0;
	                                    s1 = peg$c59(s2, s6);
	                                    s0 = s1;
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsepluralOption() {
	        var s0, s1, s2, s3, s4, s5, s6, s7;
	        s0 = peg$currPos;
	        s1 = peg$parse_();
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parsepluralRuleSelectValue();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$parse_();
	                if (s3 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 123) {
	                        s4 = peg$c6;
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c7);
	                        }
	                    }
	                    if (s4 !== peg$FAILED) {
	                        peg$savedPos = peg$currPos;
	                        s5 = peg$c60(s2);
	                        if (s5) {
	                            s5 = undefined;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                        }
	                        if (s5 !== peg$FAILED) {
	                            s6 = peg$parsemessage();
	                            if (s6 !== peg$FAILED) {
	                                if (input.charCodeAt(peg$currPos) === 125) {
	                                    s7 = peg$c8;
	                                    peg$currPos++;
	                                }
	                                else {
	                                    s7 = peg$FAILED;
	                                    if (peg$silentFails === 0) {
	                                        peg$fail(peg$c9);
	                                    }
	                                }
	                                if (s7 !== peg$FAILED) {
	                                    peg$savedPos = s0;
	                                    s1 = peg$c61(s2, s6);
	                                    s0 = s1;
	                                }
	                                else {
	                                    peg$currPos = s0;
	                                    s0 = peg$FAILED;
	                                }
	                            }
	                            else {
	                                peg$currPos = s0;
	                                s0 = peg$FAILED;
	                            }
	                        }
	                        else {
	                            peg$currPos = s0;
	                            s0 = peg$FAILED;
	                        }
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parsewhiteSpace() {
	        var s0, s1;
	        peg$silentFails++;
	        if (peg$c63.test(input.charAt(peg$currPos))) {
	            s0 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s0 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c64);
	            }
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c62);
	            }
	        }
	        return s0;
	    }
	    function peg$parsepatternSyntax() {
	        var s0, s1;
	        peg$silentFails++;
	        if (peg$c66.test(input.charAt(peg$currPos))) {
	            s0 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s0 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c67);
	            }
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c65);
	            }
	        }
	        return s0;
	    }
	    function peg$parse_() {
	        var s0, s1, s2;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$parsewhiteSpace();
	        while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            s2 = peg$parsewhiteSpace();
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c68);
	            }
	        }
	        return s0;
	    }
	    function peg$parsenumber() {
	        var s0, s1, s2;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 45) {
	            s1 = peg$c70;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c71);
	            }
	        }
	        if (s1 === peg$FAILED) {
	            s1 = null;
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parseargNumber();
	            if (s2 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c72(s1, s2);
	                s0 = s1;
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c69);
	            }
	        }
	        return s0;
	    }
	    function peg$parseapostrophe() {
	        var s0, s1;
	        peg$silentFails++;
	        if (input.charCodeAt(peg$currPos) === 39) {
	            s0 = peg$c32;
	            peg$currPos++;
	        }
	        else {
	            s0 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c33);
	            }
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c73);
	            }
	        }
	        return s0;
	    }
	    function peg$parsedoubleApostrophes() {
	        var s0, s1;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c75) {
	            s1 = peg$c75;
	            peg$currPos += 2;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c76);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c77();
	        }
	        s0 = s1;
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c74);
	            }
	        }
	        return s0;
	    }
	    function peg$parsequotedString() {
	        var s0, s1, s2, s3, s4, s5;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 39) {
	            s1 = peg$c32;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c33);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s2 = peg$parseescapedChar();
	            if (s2 !== peg$FAILED) {
	                s3 = peg$currPos;
	                s4 = [];
	                if (input.substr(peg$currPos, 2) === peg$c75) {
	                    s5 = peg$c75;
	                    peg$currPos += 2;
	                }
	                else {
	                    s5 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c76);
	                    }
	                }
	                if (s5 === peg$FAILED) {
	                    if (peg$c34.test(input.charAt(peg$currPos))) {
	                        s5 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s5 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c35);
	                        }
	                    }
	                }
	                while (s5 !== peg$FAILED) {
	                    s4.push(s5);
	                    if (input.substr(peg$currPos, 2) === peg$c75) {
	                        s5 = peg$c75;
	                        peg$currPos += 2;
	                    }
	                    else {
	                        s5 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c76);
	                        }
	                    }
	                    if (s5 === peg$FAILED) {
	                        if (peg$c34.test(input.charAt(peg$currPos))) {
	                            s5 = input.charAt(peg$currPos);
	                            peg$currPos++;
	                        }
	                        else {
	                            s5 = peg$FAILED;
	                            if (peg$silentFails === 0) {
	                                peg$fail(peg$c35);
	                            }
	                        }
	                    }
	                }
	                if (s4 !== peg$FAILED) {
	                    s3 = input.substring(s3, peg$currPos);
	                }
	                else {
	                    s3 = s4;
	                }
	                if (s3 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 39) {
	                        s4 = peg$c32;
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c33);
	                        }
	                    }
	                    if (s4 === peg$FAILED) {
	                        s4 = null;
	                    }
	                    if (s4 !== peg$FAILED) {
	                        peg$savedPos = s0;
	                        s1 = peg$c78(s2, s3);
	                        s0 = s1;
	                    }
	                    else {
	                        peg$currPos = s0;
	                        s0 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	        }
	        return s0;
	    }
	    function peg$parseunquotedString() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        s1 = peg$currPos;
	        if (input.length > peg$currPos) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c14);
	            }
	        }
	        if (s2 !== peg$FAILED) {
	            peg$savedPos = peg$currPos;
	            s3 = peg$c79(s2);
	            if (s3) {
	                s3 = undefined;
	            }
	            else {
	                s3 = peg$FAILED;
	            }
	            if (s3 !== peg$FAILED) {
	                s2 = [s2, s3];
	                s1 = s2;
	            }
	            else {
	                peg$currPos = s1;
	                s1 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s1;
	            s1 = peg$FAILED;
	        }
	        if (s1 === peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 10) {
	                s1 = peg$c80;
	                peg$currPos++;
	            }
	            else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c81);
	                }
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        return s0;
	    }
	    function peg$parseescapedChar() {
	        var s0, s1, s2, s3;
	        s0 = peg$currPos;
	        s1 = peg$currPos;
	        if (input.length > peg$currPos) {
	            s2 = input.charAt(peg$currPos);
	            peg$currPos++;
	        }
	        else {
	            s2 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c14);
	            }
	        }
	        if (s2 !== peg$FAILED) {
	            peg$savedPos = peg$currPos;
	            s3 = peg$c82(s2);
	            if (s3) {
	                s3 = undefined;
	            }
	            else {
	                s3 = peg$FAILED;
	            }
	            if (s3 !== peg$FAILED) {
	                s2 = [s2, s3];
	                s1 = s2;
	            }
	            else {
	                peg$currPos = s1;
	                s1 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s1;
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        return s0;
	    }
	    function peg$parseargNameOrNumber() {
	        var s0, s1;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = peg$parseargNumber();
	        if (s1 === peg$FAILED) {
	            s1 = peg$parseargName();
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c83);
	            }
	        }
	        return s0;
	    }
	    function peg$parseargNumber() {
	        var s0, s1, s2, s3, s4;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        if (input.charCodeAt(peg$currPos) === 48) {
	            s1 = peg$c85;
	            peg$currPos++;
	        }
	        else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c86);
	            }
	        }
	        if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c87();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            s1 = peg$currPos;
	            if (peg$c88.test(input.charAt(peg$currPos))) {
	                s2 = input.charAt(peg$currPos);
	                peg$currPos++;
	            }
	            else {
	                s2 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c89);
	                }
	            }
	            if (s2 !== peg$FAILED) {
	                s3 = [];
	                if (peg$c90.test(input.charAt(peg$currPos))) {
	                    s4 = input.charAt(peg$currPos);
	                    peg$currPos++;
	                }
	                else {
	                    s4 = peg$FAILED;
	                    if (peg$silentFails === 0) {
	                        peg$fail(peg$c91);
	                    }
	                }
	                while (s4 !== peg$FAILED) {
	                    s3.push(s4);
	                    if (peg$c90.test(input.charAt(peg$currPos))) {
	                        s4 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c91);
	                        }
	                    }
	                }
	                if (s3 !== peg$FAILED) {
	                    s2 = [s2, s3];
	                    s1 = s2;
	                }
	                else {
	                    peg$currPos = s1;
	                    s1 = peg$FAILED;
	                }
	            }
	            else {
	                peg$currPos = s1;
	                s1 = peg$FAILED;
	            }
	            if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c92(s1);
	            }
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c84);
	            }
	        }
	        return s0;
	    }
	    function peg$parseargName() {
	        var s0, s1, s2, s3, s4;
	        peg$silentFails++;
	        s0 = peg$currPos;
	        s1 = [];
	        s2 = peg$currPos;
	        s3 = peg$currPos;
	        peg$silentFails++;
	        s4 = peg$parsewhiteSpace();
	        if (s4 === peg$FAILED) {
	            s4 = peg$parsepatternSyntax();
	        }
	        peg$silentFails--;
	        if (s4 === peg$FAILED) {
	            s3 = undefined;
	        }
	        else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	        }
	        if (s3 !== peg$FAILED) {
	            if (input.length > peg$currPos) {
	                s4 = input.charAt(peg$currPos);
	                peg$currPos++;
	            }
	            else {
	                s4 = peg$FAILED;
	                if (peg$silentFails === 0) {
	                    peg$fail(peg$c14);
	                }
	            }
	            if (s4 !== peg$FAILED) {
	                s3 = [s3, s4];
	                s2 = s3;
	            }
	            else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	            }
	        }
	        else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	            while (s2 !== peg$FAILED) {
	                s1.push(s2);
	                s2 = peg$currPos;
	                s3 = peg$currPos;
	                peg$silentFails++;
	                s4 = peg$parsewhiteSpace();
	                if (s4 === peg$FAILED) {
	                    s4 = peg$parsepatternSyntax();
	                }
	                peg$silentFails--;
	                if (s4 === peg$FAILED) {
	                    s3 = undefined;
	                }
	                else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                }
	                if (s3 !== peg$FAILED) {
	                    if (input.length > peg$currPos) {
	                        s4 = input.charAt(peg$currPos);
	                        peg$currPos++;
	                    }
	                    else {
	                        s4 = peg$FAILED;
	                        if (peg$silentFails === 0) {
	                            peg$fail(peg$c14);
	                        }
	                    }
	                    if (s4 !== peg$FAILED) {
	                        s3 = [s3, s4];
	                        s2 = s3;
	                    }
	                    else {
	                        peg$currPos = s2;
	                        s2 = peg$FAILED;
	                    }
	                }
	                else {
	                    peg$currPos = s2;
	                    s2 = peg$FAILED;
	                }
	            }
	        }
	        else {
	            s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	            s0 = input.substring(s0, peg$currPos);
	        }
	        else {
	            s0 = s1;
	        }
	        peg$silentFails--;
	        if (s0 === peg$FAILED) {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) {
	                peg$fail(peg$c93);
	            }
	        }
	        return s0;
	    }
	    var messageCtx = ['root'];
	    function isNestedMessageText() {
	        return messageCtx.length > 1;
	    }
	    function isInPluralOption() {
	        return messageCtx[messageCtx.length - 1] === 'plural';
	    }
	    function insertLocation() {
	        return options && options.captureLocation ? {
	            location: location()
	        } : {};
	    }
	    peg$result = peg$startRuleFunction();
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	        return peg$result;
	    }
	    else {
	        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	            peg$fail(peg$endExpectation());
	        }
	        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length
	            ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	            : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
	    }
	}
	exports.pegParse = peg$parse;


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var TYPE;
	(function (TYPE) {
	    /**
	     * Raw text
	     */
	    TYPE[TYPE["literal"] = 0] = "literal";
	    /**
	     * Variable w/o any format, e.g `var` in `this is a {var}`
	     */
	    TYPE[TYPE["argument"] = 1] = "argument";
	    /**
	     * Variable w/ number format
	     */
	    TYPE[TYPE["number"] = 2] = "number";
	    /**
	     * Variable w/ date format
	     */
	    TYPE[TYPE["date"] = 3] = "date";
	    /**
	     * Variable w/ time format
	     */
	    TYPE[TYPE["time"] = 4] = "time";
	    /**
	     * Variable w/ select format
	     */
	    TYPE[TYPE["select"] = 5] = "select";
	    /**
	     * Variable w/ plural format
	     */
	    TYPE[TYPE["plural"] = 6] = "plural";
	    /**
	     * Only possible within plural argument.
	     * This is the `#` symbol that will be substituted with the count.
	     */
	    TYPE[TYPE["pound"] = 7] = "pound";
	})(TYPE = exports.TYPE || (exports.TYPE = {}));
	/**
	 * Type Guards
	 */
	function isLiteralElement(el) {
	    return el.type === TYPE.literal;
	}
	exports.isLiteralElement = isLiteralElement;
	function isArgumentElement(el) {
	    return el.type === TYPE.argument;
	}
	exports.isArgumentElement = isArgumentElement;
	function isNumberElement(el) {
	    return el.type === TYPE.number;
	}
	exports.isNumberElement = isNumberElement;
	function isDateElement(el) {
	    return el.type === TYPE.date;
	}
	exports.isDateElement = isDateElement;
	function isTimeElement(el) {
	    return el.type === TYPE.time;
	}
	exports.isTimeElement = isTimeElement;
	function isSelectElement(el) {
	    return el.type === TYPE.select;
	}
	exports.isSelectElement = isSelectElement;
	function isPluralElement(el) {
	    return el.type === TYPE.plural;
	}
	exports.isPluralElement = isPluralElement;
	function isPoundElement(el) {
	    return el.type === TYPE.pound;
	}
	exports.isPoundElement = isPoundElement;
	function isNumberSkeleton(el) {
	    return !!(el && typeof el === 'object' && el.type === 0 /* number */);
	}
	exports.isNumberSkeleton = isNumberSkeleton;
	function isDateTimeSkeleton(el) {
	    return !!(el && typeof el === 'object' && el.type === 1 /* dateTime */);
	}
	exports.isDateTimeSkeleton = isDateTimeSkeleton;
	function createLiteralElement(value) {
	    return {
	        type: TYPE.literal,
	        value: value,
	    };
	}
	exports.createLiteralElement = createLiteralElement;
	function createNumberElement(value, style) {
	    return {
	        type: TYPE.number,
	        value: value,
	        style: style,
	    };
	}
	exports.createNumberElement = createNumberElement;


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SheetsRegistry = __webpack_require__(2298);
	
	var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toCss;
	
	var _toCssValue = __webpack_require__(967);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	function indentStr(str, indent) {
	  var result = '';
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }return result + str;
	}
	
	/**
	 * Converts a Rule to CSS string.
	 */
	
	function toCss(selector, style) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var result = '';
	
	  if (!style) return result;
	
	  var _options$indent = options.indent,
	      indent = _options$indent === undefined ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	
	
	  indent++;
	
	  // Apply fallbacks first.
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	        for (var prop in fallback) {
	          var value = fallback[prop];
	          if (value != null) {
	            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
	          }
	        }
	      }
	    } else {
	      // Object syntax {fallbacks: {prop: value}}
	      for (var _prop in fallbacks) {
	        var _value = fallbacks[_prop];
	        if (_value != null) {
	          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
	        }
	      }
	    }
	  }
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
	    }
	  }
	
	  // Allow empty style in this case, because properties will be added dynamically.
	  if (!result && !options.allowEmpty) return result;
	
	  indent--;
	  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);
	
	  return result;
	}

/***/ }),
/* 1527 */
[6725, 460, 246],
/* 1528 */
[6726, 5472, 5473, 5474, 5475, 5476],
/* 1529 */
[6729, 1528, 5482, 5483],
/* 1530 */
5818,
/* 1531 */
2685,
/* 1532 */
[6735, 726, 728],
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1529),
	    arrayIncludes = __webpack_require__(2307),
	    arrayIncludesWith = __webpack_require__(2308),
	    arrayMap = __webpack_require__(458),
	    baseUnary = __webpack_require__(727),
	    cacheHas = __webpack_require__(1541);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 1534 */
[6741, 2316, 249],
/* 1535 */
[6747, 5408, 227],
/* 1536 */
[6753, 976, 5479],
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(1532),
	    castPath = __webpack_require__(459),
	    isIndex = __webpack_require__(975),
	    isObject = __webpack_require__(139),
	    toKey = __webpack_require__(461);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	      return object;
	    }
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 1538 */
5844,
/* 1539 */
[6759, 569, 458, 96, 576],
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1529),
	    arrayIncludes = __webpack_require__(2307),
	    arrayIncludesWith = __webpack_require__(2308),
	    cacheHas = __webpack_require__(1541),
	    createSet = __webpack_require__(5448),
	    setToArray = __webpack_require__(1552);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 1541 */
5848,
/* 1542 */
[6761, 323],
/* 1543 */
[6763, 1538],
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(2305);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(2317),
	    getSymbolsIn = __webpack_require__(2335),
	    keysIn = __webpack_require__(734);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 1547 */
[6840, 2340],
/* 1548 */
[6779, 1531, 2354],
/* 1549 */
5867,
/* 1550 */
[6787, 96, 576],
/* 1551 */
[6714, 2333],
/* 1552 */
5895,
/* 1553 */
[6808, 5393, 1549, 5495],
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(1533),
	    baseFlatten = __webpack_require__(570),
	    baseIteratee = __webpack_require__(175),
	    baseRest = __webpack_require__(572),
	    isArrayLikeObject = __webpack_require__(980),
	    last = __webpack_require__(463);
	
	/**
	 * This method is like `_.difference` except that it accepts `iteratee` which
	 * is invoked for each element of `array` and `values` to generate the criterion
	 * by which they're compared. The order and references of result values are
	 * determined by the first array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	 * // => [1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	 * // => [{ 'x': 2 }]
	 */
	var differenceBy = baseRest(function(array, values) {
	  var iteratee = last(values);
	  if (isArrayLikeObject(iteratee)) {
	    iteratee = undefined;
	  }
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2))
	    : [];
	});
	
	module.exports = differenceBy;


/***/ }),
/* 1555 */
[6716, 5404, 2336],
/* 1556 */
[6814, 5405, 2336],
/* 1557 */
1592,
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(321),
	    isObjectLike = __webpack_require__(227);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(726),
	    baseForOwn = __webpack_require__(1534),
	    baseIteratee = __webpack_require__(175);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 1560 */
[6719, 2310, 377, 175, 5426, 96],
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(1537);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(570),
	    baseOrderBy = __webpack_require__(5421),
	    baseRest = __webpack_require__(572),
	    isIterateeCall = __webpack_require__(575);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AppBar = __webpack_require__(2360);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AppBar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.hasValue = hasValue;
	exports.isDirty = isDirty;
	exports.isAdornedStart = isAdornedStart;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Textarea = __webpack_require__(5579);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Supports determination of isControlled().
	// Controlled input accepts its current value as a prop.
	//
	// @see https://facebook.github.io/react/docs/forms.html#controlled-components
	// @param value
	// @returns {boolean} true if string (including '') or number (including zero)
	function hasValue(value) {
	  return value != null && !(Array.isArray(value) && value.length === 0);
	}
	
	// Determine if field is dirty (a.k.a. filled).
	//
	// Response determines if label is presented above field or as placeholder.
	//
	// @param obj
	// @param SSR
	// @returns {boolean} False when not present or empty string.
	//                    True when any number or string with length.
	function isDirty(obj) {
	  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
	}
	
	// Determine if an Input is adorned on start.
	// It's corresponding to the left with LTR.
	//
	// @param obj
	// @returns {boolean} False when no adornments.
	//                    True when adorned at the start.
	function isAdornedStart(obj) {
	  return obj.startAdornment;
	}
	
	var styles = exports.styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var placeholder = {
	    color: 'currentColor',
	    opacity: light ? 0.42 : 0.5,
	    transition: theme.transitions.create('opacity', {
	      duration: theme.transitions.duration.shorter,
	      easing: theme.transitions.easing.ease
	    })
	  };
	  var placeholderHidden = {
	    opacity: 0
	  };
	  var placeholderVisible = {
	    opacity: light ? 0.42 : 0.5
	  };
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	
	  return {
	    root: {
	      // Mimics the default input display property used by browsers for an input.
	      display: 'inline-flex',
	      position: 'relative',
	      fontFamily: theme.typography.fontFamily,
	      color: light ? 'rgba(0, 0, 0, 0.87)' : theme.palette.common.white,
	      fontSize: theme.typography.pxToRem(16)
	    },
	    formControl: {
	      'label + &': {
	        marginTop: theme.spacing.unit * 2
	      }
	    },
	    inkbar: {
	      '&:after': {
	        backgroundColor: theme.palette.primary[light ? 'dark' : 'light'],
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        height: 2,
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      }
	    },
	    error: {
	      '&:after': {
	        backgroundColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	      }
	    },
	    focused: {},
	    disabled: {
	      color: theme.palette.text.disabled
	    },
	    underline: {
	      '&:before': {
	        backgroundColor: bottomLineColor,
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        height: 1,
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('background-color', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.ease
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	      },
	      '&:hover:not($disabled):before': {
	        backgroundColor: theme.palette.text.primary,
	        height: 2
	      },
	      '&$disabled:before': {
	        background: 'transparent',
	        backgroundImage: 'linear-gradient(to right, ' + bottomLineColor + ' 33%, transparent 0%)',
	        backgroundPosition: 'left top',
	        backgroundRepeat: 'repeat-x',
	        backgroundSize: '5px 1px'
	      }
	    },
	    multiline: {
	      padding: theme.spacing.unit - 2 + 'px 0 ' + (theme.spacing.unit - 1) + 'px'
	    },
	    fullWidth: {
	      width: '100%'
	    },
	    input: {
	      font: 'inherit',
	      color: 'currentColor',
	      padding: theme.spacing.unit - 2 + 'px 0 ' + (theme.spacing.unit - 1) + 'px',
	      border: 0,
	      boxSizing: 'content-box',
	      verticalAlign: 'middle',
	      background: 'none',
	      margin: 0, // Reset for Safari
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      display: 'block',
	      // Make the flex item shrink with Firefox
	      minWidth: 0,
	      width: '100%',
	      '&::-webkit-input-placeholder': placeholder,
	      '&::-moz-placeholder': placeholder, // Firefox 19+
	      '&:-ms-input-placeholder': placeholder, // IE 11
	      '&::-ms-input-placeholder': placeholder, // Edge
	      '&:focus': {
	        outline: 0
	      },
	      // Reset Firefox invalid required input style
	      '&:invalid': {
	        boxShadow: 'none'
	      },
	      '&::-webkit-search-decoration': {
	        // Remove the padding when type=search.
	        '-webkit-appearance': 'none'
	      },
	      // Show and hide the placeholder logic
	      'label[data-shrink=false] + $formControl &': {
	        '&::-webkit-input-placeholder': placeholderHidden,
	        '&::-moz-placeholder': placeholderHidden, // Firefox 19+
	        '&:-ms-input-placeholder': placeholderHidden, // IE 11
	        '&::-ms-input-placeholder': placeholderHidden, // Edge
	        '&:focus::-webkit-input-placeholder': placeholderVisible,
	        '&:focus::-moz-placeholder': placeholderVisible, // Firefox 19+
	        '&:focus:-ms-input-placeholder': placeholderVisible, // IE 11
	        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
	      }
	    },
	    inputDense: {
	      paddingTop: theme.spacing.unit / 2 - 1
	    },
	    inputDisabled: {
	      opacity: 1 // Reset iOS opacity
	    },
	    inputType: {
	      // type="date" or type="time", etc. have specific styles we need to reset.
	      height: '1.1875em' // Reset (19px), match the native input line-height
	    },
	    inputMultiline: {
	      resize: 'none',
	      padding: 0
	    },
	    inputSearch: {
	      // Improve type search style.
	      '-moz-appearance': 'textfield',
	      '-webkit-appearance': 'textfield'
	    }
	  };
	};
	
	function formControlState(props, context) {
	  var disabled = props.disabled;
	  var error = props.error;
	  var margin = props.margin;
	
	  if (context && context.muiFormControl) {
	    if (typeof disabled === 'undefined') {
	      disabled = context.muiFormControl.disabled;
	    }
	
	    if (typeof error === 'undefined') {
	      error = context.muiFormControl.error;
	    }
	
	    if (typeof margin === 'undefined') {
	      margin = context.muiFormControl.margin;
	    }
	  }
	
	  return {
	    disabled: disabled,
	    error: error,
	    margin: margin
	  };
	}
	
	var Input = function (_React$Component) {
	  (0, _inherits3.default)(Input, _React$Component);
	
	  function Input() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      focused: false
	    }, _this.input = null, _this.handleFocus = function (event) {
	      // Fix an bug with IE11 where the focus/blur events are triggered
	      // while the input is disabled.
	      if (formControlState(_this.props, _this.context).disabled) {
	        event.stopPropagation();
	        return;
	      }
	
	      _this.setState({ focused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({ focused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleChange = function (event) {
	      if (!_this.isControlled) {
	        _this.checkDirty(_this.input);
	      }
	
	      // Perform in the willUpdate
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _this.handleRefInput = function (node) {
	      _this.input = node;
	
	      if (_this.props.inputRef) {
	        _this.props.inputRef(node);
	      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
	        _this.props.inputProps.ref(node);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Input, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.isControlled = this.props.value != null;
	
	      if (this.isControlled) {
	        this.checkDirty(this.props);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.isControlled) {
	        this.checkDirty(this.input);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      // The blur won't fire when the disabled state is set on a focused input.
	      // We need to book keep the focused state manually.
	      if (!formControlState(this.props, this.context).disabled && formControlState(nextProps, nextContext).disabled) {
	        this.setState({
	          focused: false
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState, nextContext) {
	      if (this.isControlled) {
	        this.checkDirty(nextProps);
	      } // else performed in the onChange
	
	      // Book keep the focused state.
	      if (!formControlState(this.props, this.context).disabled && formControlState(nextProps, nextContext).disabled) {
	        var muiFormControl = this.context.muiFormControl;
	
	        if (muiFormControl && muiFormControl.onBlur) {
	          muiFormControl.onBlur();
	        }
	      }
	    }
	
	    // Holds the input reference
	
	  }, {
	    key: 'checkDirty',
	    value: function checkDirty(obj) {
	      var muiFormControl = this.context.muiFormControl;
	
	
	      if (isDirty(obj)) {
	        if (muiFormControl && muiFormControl.onDirty) {
	          muiFormControl.onDirty();
	        }
	        if (this.props.onDirty) {
	          this.props.onDirty();
	        }
	        return;
	      }
	
	      if (muiFormControl && muiFormControl.onClean) {
	        muiFormControl.onClean();
	      }
	      if (this.props.onClean) {
	        this.props.onClean();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _props = this.props,
	          autoComplete = _props.autoComplete,
	          autoFocus = _props.autoFocus,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          defaultValue = _props.defaultValue,
	          disabledProp = _props.disabled,
	          disableUnderline = _props.disableUnderline,
	          endAdornment = _props.endAdornment,
	          errorProp = _props.error,
	          fullWidth = _props.fullWidth,
	          id = _props.id,
	          inputComponent = _props.inputComponent,
	          _props$inputProps = _props.inputProps;
	      _props$inputProps = _props$inputProps === undefined ? {} : _props$inputProps;
	      var inputPropsClassName = _props$inputProps.className,
	          inputPropsProp = (0, _objectWithoutProperties3.default)(_props$inputProps, ['className']),
	          inputRef = _props.inputRef,
	          marginProp = _props.margin,
	          multiline = _props.multiline,
	          name = _props.name,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          onClean = _props.onClean,
	          onDirty = _props.onDirty,
	          onFocus = _props.onFocus,
	          onKeyDown = _props.onKeyDown,
	          onKeyUp = _props.onKeyUp,
	          placeholder = _props.placeholder,
	          readOnly = _props.readOnly,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          startAdornment = _props.startAdornment,
	          type = _props.type,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoComplete', 'autoFocus', 'classes', 'className', 'defaultValue', 'disabled', 'disableUnderline', 'endAdornment', 'error', 'fullWidth', 'id', 'inputComponent', 'inputProps', 'inputRef', 'margin', 'multiline', 'name', 'onBlur', 'onChange', 'onClean', 'onDirty', 'onFocus', 'onKeyDown', 'onKeyUp', 'placeholder', 'readOnly', 'rows', 'rowsMax', 'startAdornment', 'type', 'value']);
	      var muiFormControl = this.context.muiFormControl;
	
	      var _formControlState = formControlState(this.props, this.context),
	          disabled = _formControlState.disabled,
	          error = _formControlState.error,
	          margin = _formControlState.margin;
	
	      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty3.default)(_classNames, classes.focused, this.state.focused), (0, _defineProperty3.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty3.default)(_classNames, classes.inkbar, !disableUnderline), (0, _defineProperty3.default)(_classNames, classes.multiline, multiline), (0, _defineProperty3.default)(_classNames, classes.underline, !disableUnderline), _classNames), classNameProp);
	
	      var inputClassName = (0, _classnames2.default)(classes.input, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.inputDisabled, disabled), (0, _defineProperty3.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty3.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty3.default)(_classNames2, classes.inputSearch, type === 'search'), (0, _defineProperty3.default)(_classNames2, classes.inputDense, margin === 'dense'), _classNames2), inputPropsClassName);
	
	      var required = muiFormControl && muiFormControl.required === true;
	
	      var InputComponent = 'input';
	      var inputProps = (0, _extends3.default)({}, inputPropsProp, {
	        ref: this.handleRefInput
	      });
	
	      if (inputComponent) {
	        InputComponent = inputComponent;
	        inputProps = (0, _extends3.default)({
	          // Rename ref to inputRef as we don't know the
	          // provided `inputComponent` structure.
	          inputRef: this.handleRefInput
	        }, inputProps, {
	          ref: null
	        });
	      } else if (multiline) {
	        if (rows && !rowsMax) {
	          InputComponent = 'textarea';
	        } else {
	          inputProps = (0, _extends3.default)({
	            rowsMax: rowsMax,
	            textareaRef: this.handleRefInput
	          }, inputProps, {
	            ref: null
	          });
	          InputComponent = _Textarea2.default;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ onBlur: this.handleBlur, onFocus: this.handleFocus, className: className }, other),
	        startAdornment,
	        _react2.default.createElement(InputComponent, (0, _extends3.default)({
	          autoComplete: autoComplete,
	          autoFocus: autoFocus,
	          className: inputClassName,
	          onChange: this.handleChange,
	          onKeyUp: onKeyUp,
	          onKeyDown: onKeyDown,
	          disabled: disabled,
	          required: required ? true : undefined,
	          value: value,
	          id: id,
	          name: name,
	          defaultValue: defaultValue,
	          placeholder: placeholder,
	          type: type,
	          readOnly: readOnly,
	          rows: rows,
	          'aria-required': required,
	          'aria-invalid': error
	        }, inputProps)),
	        endAdornment
	      );
	    }
	  }]);
	  return Input;
	}(_react2.default.Component);
	
	Input.propTypes =  false ? {
	  /**
	   * This property helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it here:
	   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
	   */
	  autoComplete: _propTypes2.default.string,
	  /**
	   * If `true`, the input will be focused during the first mount.
	   */
	  autoFocus: _propTypes2.default.bool,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * The CSS class name of the wrapper element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The default input value, useful when not controlling the component.
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * If `true`, the input will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes2.default.bool,
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes2.default.node,
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * The component used for the native input.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes2.default.object,
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes2.default.func,
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes2.default.oneOf(['dense', 'none']),
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes2.default.bool,
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * TODO
	   */
	  onClean: _propTypes2.default.func,
	  /**
	   * TODO
	   */
	  onDirty: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes2.default.func,
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  readOnly: _propTypes2.default.bool,
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes2.default.node,
	  /**
	   * Type of the input element. It should be a valid HTML5 input type.
	   */
	  type: _propTypes2.default.string,
	  /**
	   * The input value, required for a controlled component.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
	} : {};
	
	Input.muiName = 'Input';
	
	Input.defaultProps = {
	  disableUnderline: false,
	  fullWidth: false,
	  multiline: false,
	  type: 'text'
	};
	
	Input.contextTypes = {
	  muiFormControl: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInput' })(Input);

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Menu = __webpack_require__(2371);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Menu).default;
	  }
	});
	
	var _MenuList = __webpack_require__(2372);
	
	Object.defineProperty(exports, 'MenuList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuList).default;
	  }
	});
	
	var _MenuItem = __webpack_require__(5586);
	
	Object.defineProperty(exports, 'MenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MenuItem).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tabs = __webpack_require__(2383);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tabs).default;
	  }
	});
	
	var _Tab = __webpack_require__(992);
	
	Object.defineProperty(exports, 'Tab', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tab).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var common = {
	  black: '#000',
	  white: '#fff'
	};
	
	exports.default = common;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CheckBoxOutlineBlank = __webpack_require__(5653);
	
	var _CheckBoxOutlineBlank2 = _interopRequireDefault(_CheckBoxOutlineBlank);
	
	var _CheckBox = __webpack_require__(5652);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _IconButton = __webpack_require__(990);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    transition: 'none'
	  },
	  input: {
	    cursor: 'inherit',
	    position: 'absolute',
	    opacity: 0,
	    width: '100%',
	    height: '100%',
	    top: 0,
	    left: 0,
	    margin: 0,
	    padding: 0
	  },
	  default: {},
	  checked: {},
	  disabled: {}
	};
	
	/**
	 * @ignore - internal component.
	 */
	
	var SwitchBase = function (_React$Component) {
	  (0, _inherits3.default)(SwitchBase, _React$Component);
	
	  function SwitchBase() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SwitchBase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwitchBase.__proto__ || (0, _getPrototypeOf2.default)(SwitchBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.input = null, _this.isControlled = null, _this.handleInputChange = function (event) {
	      var checked = event.target.checked;
	
	      if (!_this.isControlled) {
	        _this.setState({ checked: checked });
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event, checked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SwitchBase, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var props = this.props;
	
	
	      this.isControlled = props.checked != null;
	
	      if (!this.isControlled) {
	        // not controlled, use internal state
	        this.setState({
	          checked: props.defaultChecked !== undefined ? props.defaultChecked : false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          checkedProp = _props.checked,
	          checkedIcon = _props.checkedIcon,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          disabledProp = _props.disabled,
	          iconProp = _props.icon,
	          inputProps = _props.inputProps,
	          inputRef = _props.inputRef,
	          inputType = _props.inputType,
	          name = _props.name,
	          onChange = _props.onChange,
	          tabIndex = _props.tabIndex,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'checkedIcon', 'classes', 'className', 'disabled', 'icon', 'inputProps', 'inputRef', 'inputType', 'name', 'onChange', 'tabIndex', 'value']);
	      var muiFormControl = this.context.muiFormControl;
	
	      var disabled = disabledProp;
	
	      if (muiFormControl) {
	        if (typeof disabled === 'undefined') {
	          disabled = muiFormControl.disabled;
	        }
	      }
	
	      var checked = this.isControlled ? checkedProp : this.state.checked;
	      var className = (0, _classnames2.default)(classes.root, classes.default, classNameProp, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checked, checked), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames));
	
	      var icon = checked ? checkedIcon : iconProp;
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        (0, _extends3.default)({
	          component: 'span',
	          className: className,
	          disabled: disabled,
	          tabIndex: null,
	          role: undefined
	        }, other),
	        icon,
	        _react2.default.createElement('input', (0, _extends3.default)({
	          type: inputType,
	          name: name,
	          checked: checkedProp,
	          onChange: this.handleInputChange,
	          className: classes.input,
	          disabled: disabled,
	          tabIndex: tabIndex,
	          value: value,
	          ref: inputRef
	        }, inputProps))
	      );
	    }
	  }]);
	  return SwitchBase;
	}(_react2.default.Component);
	
	// NB: If changed, please update Checkbox, Switch and Radio
	// so that the API documentation is updated.
	
	
	SwitchBase.propTypes =  false ? {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes2.default.bool,
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * If `true`, the component appears indeterminate.
	   */
	  indeterminate: _propTypes2.default.bool,
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes2.default.node,
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes2.default.object,
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes2.default.func,
	  /**
	   * The input component property `type`.
	   */
	  inputType: _propTypes2.default.string,
	  /*
	   * @ignore
	   */
	  name: _propTypes2.default.string,
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The value of the component.
	   */
	  value: _propTypes2.default.string
	} : {};
	
	SwitchBase.defaultProps = {
	  checkedIcon: _react2.default.createElement(_CheckBox2.default, null),
	  disableRipple: false,
	  icon: _react2.default.createElement(_CheckBoxOutlineBlank2.default, null),
	  inputType: 'checkbox'
	};
	
	SwitchBase.contextTypes = {
	  muiFormControl: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSwitchBase' })(SwitchBase);

/***/ }),
/* 1569 */
6274,
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _deepmerge = __webpack_require__(947);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _createTypography = __webpack_require__(5675);
	
	var _createTypography2 = _interopRequireDefault(_createTypography);
	
	var _createBreakpoints = __webpack_require__(736);
	
	var _createBreakpoints2 = _interopRequireDefault(_createBreakpoints);
	
	var _createPalette = __webpack_require__(5674);
	
	var _createPalette2 = _interopRequireDefault(_createPalette);
	
	var _createMixins = __webpack_require__(5673);
	
	var _createMixins2 = _interopRequireDefault(_createMixins);
	
	var _shadows = __webpack_require__(5677);
	
	var _shadows2 = _interopRequireDefault(_shadows);
	
	var _transitions = __webpack_require__(381);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _zIndex = __webpack_require__(5679);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _spacing = __webpack_require__(5678);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMuiTheme() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$palette = options.palette,
	      paletteInput = _options$palette === undefined ? {} : _options$palette,
	      _options$breakpoints = options.breakpoints,
	      breakpointsInput = _options$breakpoints === undefined ? {} : _options$breakpoints,
	      _options$mixins = options.mixins,
	      mixinsInput = _options$mixins === undefined ? {} : _options$mixins,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === undefined ? {} : _options$typography,
	      shadowsInput = options.shadows,
	      other = (0, _objectWithoutProperties3.default)(options, ['palette', 'breakpoints', 'mixins', 'typography', 'shadows']);
	
	
	  var palette = (0, _createPalette2.default)(paletteInput);
	  var breakpoints = (0, _createBreakpoints2.default)(breakpointsInput);
	
	  var muiTheme = (0, _extends3.default)({
	    direction: 'ltr',
	    palette: palette,
	    typography: (0, _createTypography2.default)(palette, typographyInput),
	    mixins: (0, _createMixins2.default)(breakpoints, _spacing2.default, mixinsInput),
	    breakpoints: breakpoints,
	    shadows: shadowsInput || _shadows2.default
	  }, (0, _deepmerge2.default)({
	    transitions: _transitions2.default,
	    spacing: _spacing2.default,
	    zIndex: _zIndex2.default
	  }, other));
	
	   false ? (0, _warning2.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
	
	  return muiTheme;
	} // < 1kb payload overhead when lodash/merge is > 3kb.
	exports.default = createMuiTheme;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CHANNEL = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Same value used by react-jss
	var CHANNEL = exports.CHANNEL = '__THEMING__';
	
	var themeListener = {
	  contextTypes: (0, _defineProperty3.default)({}, CHANNEL, _propTypes2.default.object),
	  initial: function initial(context) {
	    if (!context[CHANNEL]) {
	      return null;
	    }
	
	    return context[CHANNEL].getState();
	  },
	  subscribe: function subscribe(context, cb) {
	    if (!context[CHANNEL]) {
	      return null;
	    }
	
	    return context[CHANNEL].subscribe(cb);
	  },
	  unsubscribe: function unsubscribe(context, subscriptionId) {
	    if (context[CHANNEL]) {
	      context[CHANNEL].unsubscribe(subscriptionId);
	    }
	  }
	};
	
	exports.default = themeListener;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(580);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _transitions = __webpack_require__(381);
	
	var _utils = __webpack_require__(737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    container: {
	      height: 0,
	      overflow: 'hidden',
	      transition: theme.transitions.create('height')
	    },
	    entered: {
	      height: 'auto'
	    },
	    wrapper: {
	      // Hack to get children with a negative margin to not falsify the height computation.
	      display: 'flex'
	    },
	    wrapperInner: {
	      width: '100%'
	    }
	  };
	}; // @inheritedComponent Transition
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3.default)(Collapse, _React$Component);
	
	  function Collapse() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Collapse);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Collapse.__proto__ || (0, _getPrototypeOf2.default)(Collapse)).call.apply(_ref, [this].concat(args))), _this), _this.wrapper = null, _this.autoTransitionDuration = undefined, _this.handleEnter = function (node) {
	      node.style.height = _this.props.collapsedHeight;
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.handleEntering = function (node) {
	      var _this$props = _this.props,
	          timeout = _this$props.timeout,
	          theme = _this$props.theme;
	
	      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	
	      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      }),
	          transitionDuration = _getTransitionProps.duration;
	
	      if (timeout === 'auto') {
	        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	        node.style.transitionDuration = duration2 + 'ms';
	        _this.autoTransitionDuration = duration2;
	      } else {
	        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + 'ms';
	      }
	
	      node.style.height = wrapperHeight + 'px';
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.handleEntered = function (node) {
	      node.style.height = 'auto';
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.handleExit = function (node) {
	      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	      node.style.height = wrapperHeight + 'px';
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.handleExiting = function (node) {
	      var _this$props2 = _this.props,
	          timeout = _this$props2.timeout,
	          theme = _this$props2.theme;
	
	      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
	
	      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      }),
	          transitionDuration = _getTransitionProps2.duration;
	
	      if (timeout === 'auto') {
	        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	        node.style.transitionDuration = duration2 + 'ms';
	        _this.autoTransitionDuration = duration2;
	      } else {
	        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + 'ms';
	      }
	
	      node.style.height = _this.props.collapsedHeight;
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.addEndListener = function (node, next) {
	      if (_this.props.timeout === 'auto') {
	        setTimeout(next, _this.autoTransitionDuration || 0);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Collapse, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          collapsedHeight = _props.collapsedHeight,
	          Component = _props.component,
	          onEnter = _props.onEnter,
	          onEntered = _props.onEntered,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExiting = _props.onExiting,
	          style = _props.style,
	          theme = _props.theme,
	          timeout = _props.timeout,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'collapsedHeight', 'component', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExiting', 'style', 'theme', 'timeout']);
	
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        (0, _extends3.default)({
	          onEntering: this.handleEntering,
	          onEnter: this.handleEnter,
	          onEntered: this.handleEntered,
	          onExiting: this.handleExiting,
	          onExit: this.handleExit,
	          addEndListener: this.addEndListener,
	          timeout: timeout === 'auto' ? null : timeout
	        }, other),
	        function (state, childProps) {
	          return _react2.default.createElement(
	            Component,
	            (0, _extends3.default)({
	              className: (0, _classnames2.default)(classes.container, (0, _defineProperty3.default)({}, classes.entered, state === 'entered'), className),
	              style: (0, _extends3.default)({}, style, {
	                minHeight: collapsedHeight
	              })
	            }, childProps),
	            _react2.default.createElement(
	              'div',
	              {
	                className: classes.wrapper,
	                ref: function ref(node) {
	                  _this2.wrapper = node;
	                }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: classes.wrapperInner },
	                children
	              )
	            )
	          );
	        }
	      );
	    }
	  }]);
	  return Collapse;
	}(_react2.default.Component);
	
	Collapse.propTypes =  false ? {
	  /**
	   * The content node to be collapsed.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The height of the container when collapsed.
	   */
	  collapsedHeight: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
	} : {};
	
	Collapse.defaultProps = {
	  collapsedHeight: '0px',
	  component: 'div',
	  timeout: _transitions.duration.standard
	};
	
	exports.default = (0, _withStyles2.default)(styles, {
	  withTheme: true,
	  name: 'MuiCollapse'
	})(Collapse);

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(580);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _transitions = __webpack_require__(381);
	
	var _withTheme = __webpack_require__(582);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	var _utils = __webpack_require__(737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent Transition
	
	var styles = {
	  entering: {
	    opacity: 1
	  },
	  entered: {
	    opacity: 1
	  }
	};
	
	/**
	 * The Fade transition is used by the Modal component.
	 * It's using [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Fade = function (_React$Component) {
	  (0, _inherits3.default)(Fade, _React$Component);
	
	  function Fade() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Fade);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Fade.__proto__ || (0, _getPrototypeOf2.default)(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = function (node) {
	      var theme = _this.props.theme;
	
	      (0, _utils.reflow)(node); // So the animation always start from the start.
	
	      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      }),
	          transitionDuration = _getTransitionProps.duration,
	          delay = _getTransitionProps.delay;
	
	      node.style.transition = theme.transitions.create('opacity', {
	        duration: transitionDuration,
	        delay: delay
	      });
	      node.style.webkitTransition = theme.transitions.create('opacity', {
	        duration: transitionDuration,
	        delay: delay
	      });
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.handleExit = function (node) {
	      var theme = _this.props.theme;
	
	      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      }),
	          transitionDuration = _getTransitionProps2.duration,
	          delay = _getTransitionProps2.delay;
	
	      node.style.transition = theme.transitions.create('opacity', {
	        duration: transitionDuration,
	        delay: delay
	      });
	      node.style.webkitTransition = theme.transitions.create('opacity', {
	        duration: transitionDuration,
	        delay: delay
	      });
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Fade, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          onEnter = _props.onEnter,
	          onExit = _props.onExit,
	          styleProp = _props.style,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onExit', 'style', 'theme']);
	
	
	      var style = (0, _extends3.default)({}, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        (0, _extends3.default)({ appear: true, onEnter: this.handleEnter, onExit: this.handleExit }, other),
	        function (state, childProps) {
	          return _react2.default.cloneElement(children, (0, _extends3.default)({
	            style: (0, _extends3.default)({
	              opacity: 0
	            }, styles[state], style)
	          }, childProps));
	        }
	      );
	    }
	  }]);
	  return Fade;
	}(_react2.default.Component);
	
	Fade.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
	} : {};
	
	Fade.defaultProps = {
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	exports.default = (0, _withTheme2.default)()(Fade);

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.setTranslateValue = setTranslateValue;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _debounce = __webpack_require__(469);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _Transition = __webpack_require__(580);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _withTheme = __webpack_require__(582);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	var _transitions = __webpack_require__(381);
	
	var _utils = __webpack_require__(737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GUTTER = 24;
	
	// Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `translate3d(0, 0, 0)`.`
	// @inheritedComponent Transition
	
	function getTranslateValue(props, node) {
	  var direction = props.direction;
	
	  var rect = node.getBoundingClientRect();
	
	  var transform = void 0;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = window.getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return 'translateX(100vw) translateX(-' + (rect.left - offsetX) + 'px)';
	  } else if (direction === 'right') {
	    return 'translateX(-' + (rect.left + rect.width + GUTTER - offsetX) + 'px)';
	  } else if (direction === 'up') {
	    return 'translateY(100vh) translateY(-' + (rect.top - offsetY) + 'px)';
	  }
	
	  // direction === 'down
	  return 'translate3d(0, ' + (0 - (rect.top + rect.height)) + 'px, 0)';
	}
	
	function setTranslateValue(props, node) {
	  var transform = getTranslateValue(props, node);
	
	  if (transform) {
	    node.style.transform = transform;
	    node.style.webkitTransform = transform;
	  }
	}
	
	var Slide = function (_React$Component) {
	  (0, _inherits3.default)(Slide, _React$Component);
	
	  function Slide() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slide);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slide.__proto__ || (0, _getPrototypeOf2.default)(Slide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      mounted: false
	    }, _this.transition = null, _this.handleResize = (0, _debounce2.default)(function () {
	      // Skip configuration where the position is screen size invariant.
	      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
	        return;
	      }
	
	      var node = (0, _reactDom.findDOMNode)(_this.transition);
	      if (node instanceof HTMLElement) {
	        setTranslateValue(_this.props, node);
	      }
	    }, 166), _this.handleEnter = function (node) {
	      setTranslateValue(_this.props, node);
	      (0, _utils.reflow)(node);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.handleEntering = function (node) {
	      var theme = _this.props.theme;
	
	      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      }),
	          transitionDuration = _getTransitionProps.duration,
	          delay = _getTransitionProps.delay;
	
	      node.style.transition = theme.transitions.create('transform', {
	        duration: transitionDuration,
	        easing: theme.transitions.easing.easeOut,
	        delay: delay
	      });
	      node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
	        duration: transitionDuration,
	        easing: theme.transitions.easing.easeOut,
	        delay: delay
	      });
	      node.style.transform = 'translate3d(0, 0, 0)';
	      node.style.webkitTransform = 'translate3d(0, 0, 0)';
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.handleExit = function (node) {
	      var theme = _this.props.theme;
	
	      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      }),
	          transitionDuration = _getTransitionProps2.duration,
	          delay = _getTransitionProps2.delay;
	
	      node.style.transition = theme.transitions.create('transform', {
	        duration: transitionDuration,
	        easing: theme.transitions.easing.sharp,
	        delay: delay
	      });
	      node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
	        duration: transitionDuration,
	        easing: theme.transitions.easing.sharp,
	        delay: delay
	      });
	      setTranslateValue(_this.props, node);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.handleExited = function (node) {
	      // No need for transitions when the component is hidden
	      node.style.transition = '';
	      node.style.webkitTransition = '';
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slide, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // state.mounted handle SSR, once the component is mounted, we need
	      // to properly hide it.
	      if (!this.props.in) {
	        // We need to set initial translate values of transition element
	        // otherwise component will be shown when in=false.
	        this.updatePosition();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setState({
	        mounted: true
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.direction !== this.props.direction && !this.props.in) {
	        // We need to update the position of the drawer when the direction change and
	        // when it's hidden.
	        this.updatePosition();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	    }
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var element = (0, _reactDom.findDOMNode)(this.transition);
	      if (element instanceof HTMLElement) {
	        element.style.visibility = 'inherit';
	        setTranslateValue(this.props, element);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          onEnter = _props.onEnter,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExited = _props.onExited,
	          styleProp = _props.style,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onEntering', 'onExit', 'onExited', 'style', 'theme']);
	
	
	      var style = {};
	
	      // We use this state to handle the server-side rendering.
	      // We don't know the width of the children ahead of time.
	      // We need to render it.
	      if (!this.props.in && !this.state.mounted) {
	        style.visibility = 'hidden';
	      }
	
	      style = (0, _extends3.default)({}, style, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});
	
	      return _react2.default.createElement(
	        _reactEventListener2.default,
	        { target: 'window', onResize: this.handleResize },
	        _react2.default.createElement(
	          _Transition2.default,
	          (0, _extends3.default)({
	            onEnter: this.handleEnter,
	            onEntering: this.handleEntering,
	            onExit: this.handleExit,
	            onExited: this.handleExited,
	            appear: true,
	            style: style,
	            ref: function ref(node) {
	              _this2.transition = node;
	            }
	          }, other),
	          children
	        )
	      );
	    }
	  }]);
	  return Slide;
	}(_react2.default.Component);
	
	Slide.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onExited: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
	} : {};
	
	Slide.defaultProps = {
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	exports.default = (0, _withTheme2.default)()(Slide);

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isWidthDown = exports.isWidthUp = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _debounce = __webpack_require__(469);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _wrapDisplayName = __webpack_require__(735);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _hoistNonReactStatics = __webpack_require__(1569);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _withTheme = __webpack_require__(582);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	var _createBreakpoints = __webpack_require__(736);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// By default, returns true if screen width is the same or greater than the given breakpoint.
	var isWidthUp = exports.isWidthUp = function isWidthUp(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
	  }
	  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
	};
	
	// By default, returns true if screen width is the same or less than the given breakpoint.
	var isWidthDown = exports.isWidthDown = function isWidthDown(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
	  }
	  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
	};
	
	var withWidth = function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$resizeInterv = options.resizeInterval,
	        resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv,
	        _options$withTheme = options.withTheme,
	        withThemeOption = _options$withTheme === undefined ? false : _options$withTheme;
	
	    var WithWidth = function (_React$Component) {
	      (0, _inherits3.default)(WithWidth, _React$Component);
	
	      function WithWidth() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, WithWidth);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: undefined
	        }, _this.handleResize = (0, _debounce2.default)(function () {
	          _this.updateWidth(window.innerWidth);
	        }, resizeInterval), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(WithWidth, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth(window.innerWidth);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.handleResize.cancel();
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth(innerWidth) {
	          var breakpoints = this.props.theme.breakpoints;
	          var width = null;
	
	          /**
	           * Start with the slowest value as low end devices often have a small screen.
	           *
	           * innerWidth |xs      sm      md      lg      xl
	           *            |-------|-------|-------|-------|------>
	           * width      |  xs   |  sm   |  md   |  lg   |  xl
	           */
	          var index = 1;
	          while (width === null && index < _createBreakpoints.keys.length) {
	            var currentWidth = _createBreakpoints.keys[index];
	
	            // @media are inclusive, so reproduce the behavior here.
	            if (innerWidth < breakpoints.values[currentWidth]) {
	              width = _createBreakpoints.keys[index - 1];
	              break;
	            }
	
	            index += 1;
	          }
	
	          width = width || 'xl';
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              initialWidth = _props.initialWidth,
	              theme = _props.theme,
	              width = _props.width,
	              other = (0, _objectWithoutProperties3.default)(_props, ['initialWidth', 'theme', 'width']);
	
	          var props = (0, _extends3.default)({
	            width: width || this.state.width || initialWidth
	          }, other);
	          var more = {};
	
	          if (withThemeOption) {
	            more.theme = theme;
	          }
	
	          // When rendering the component on the server,
	          // we have no idea about the client browser screen width.
	          // In order to prevent blinks and help the reconciliation of the React tree
	          // we are not rendering the child component.
	          //
	          // An alternative is to use the `initialWidth` property.
	          if (props.width === undefined) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            _react2.default.createElement(Component, (0, _extends3.default)({}, more, props))
	          );
	        }
	      }]);
	      return WithWidth;
	    }(_react2.default.Component);
	
	    WithWidth.propTypes =  false ? {
	      /**
	       * As `window.innerWidth` is unavailable on the server,
	       * we default to rendering an empty componenent during the first mount.
	       * In some situation you might want to use an heristic to approximate
	       * the screen width of the client browser screen width.
	       *
	       * For instance, you could be using the user-agent or the client-hints.
	       * http://caniuse.com/#search=client%20hint
	       */
	      initialWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	      /**
	       * @ignore
	       */
	      theme: _propTypes2.default.object.isRequired,
	      /**
	       * Bypass the width calculation logic.
	       */
	      width: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
	    } : {};
	
	    if (false) {
	      WithWidth.displayName = (0, _wrapDisplayName2.default)(Component, 'WithWidth');
	    }
	
	    (0, _hoistNonReactStatics2.default)(WithWidth, Component);
	
	    return (0, _withTheme2.default)()(WithWidth);
	  };
	};
	
	exports.default = withWidth;

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      _defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	/**
	 * Helpers to enable Immutable compatibility *without* bringing in
	 * the 'immutable' package as a dependency.
	 */
	
	/**
	 * Check if an object is immutable by checking if it has a key specific
	 * to the immutable library.
	 *
	 * @param  {any} object
	 * @return {bool}
	 */
	function isImmutable(object) {
	  return !!(object && typeof object.hasOwnProperty === 'function' && (object.hasOwnProperty('__ownerID') || // Immutable.Map
	  object._map && object._map.hasOwnProperty('__ownerID'))); // Immutable.Record
	}
	/**
	 * Denormalize an immutable entity.
	 *
	 * @param  {Schema} schema
	 * @param  {Immutable.Map|Immutable.Record} input
	 * @param  {function} unvisit
	 * @param  {function} getDenormalizedEntity
	 * @return {Immutable.Map|Immutable.Record}
	 */
	
	function denormalizeImmutable(schema, input, unvisit) {
	  return Object.keys(schema).reduce(function (object, key) {
	    // Immutable maps cast keys to strings on write so we need to ensure
	    // we're accessing them using string keys.
	    var stringKey = "" + key;
	
	    if (object.has(stringKey)) {
	      return object.set(stringKey, unvisit(object.get(stringKey), schema[stringKey]));
	    } else {
	      return object;
	    }
	  }, input);
	}
	
	var getDefaultGetId = function getDefaultGetId(idAttribute) {
	  return function (input) {
	    return isImmutable(input) ? input.get(idAttribute) : input[idAttribute];
	  };
	};
	
	var EntitySchema =
	/*#__PURE__*/
	function () {
	  function EntitySchema(key, definition, options) {
	    if (definition === void 0) {
	      definition = {};
	    }
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (!key || typeof key !== 'string') {
	      throw new Error("Expected a string key for Entity, but found " + key + ".");
	    }
	
	    var _options = options,
	        _options$idAttribute = _options.idAttribute,
	        idAttribute = _options$idAttribute === void 0 ? 'id' : _options$idAttribute,
	        _options$mergeStrateg = _options.mergeStrategy,
	        mergeStrategy = _options$mergeStrateg === void 0 ? function (entityA, entityB) {
	      return _objectSpread({}, entityA, entityB);
	    } : _options$mergeStrateg,
	        _options$processStrat = _options.processStrategy,
	        processStrategy = _options$processStrat === void 0 ? function (input) {
	      return _objectSpread({}, input);
	    } : _options$processStrat;
	    this._key = key;
	    this._getId = typeof idAttribute === 'function' ? idAttribute : getDefaultGetId(idAttribute);
	    this._idAttribute = idAttribute;
	    this._mergeStrategy = mergeStrategy;
	    this._processStrategy = processStrategy;
	    this.define(definition);
	  }
	
	  var _proto = EntitySchema.prototype;
	
	  _proto.define = function define(definition) {
	    this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
	      var _objectSpread2;
	
	      var schema = definition[key];
	      return _objectSpread({}, entitySchema, (_objectSpread2 = {}, _objectSpread2[key] = schema, _objectSpread2));
	    }, this.schema || {});
	  };
	
	  _proto.getId = function getId(input, parent, key) {
	    return this._getId(input, parent, key);
	  };
	
	  _proto.merge = function merge(entityA, entityB) {
	    return this._mergeStrategy(entityA, entityB);
	  };
	
	  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
	    var _this = this;
	
	    if (visitedEntities.some(function (entity) {
	      return entity === input;
	    })) {
	      return this.getId(input, parent, key);
	    }
	
	    visitedEntities.push(input);
	
	    var processedEntity = this._processStrategy(input, parent, key);
	
	    Object.keys(this.schema).forEach(function (key) {
	      if (processedEntity.hasOwnProperty(key) && typeof processedEntity[key] === 'object') {
	        var schema = _this.schema[key];
	        processedEntity[key] = visit(processedEntity[key], processedEntity, key, schema, addEntity, visitedEntities);
	      }
	    });
	    addEntity(this, processedEntity, input, parent, key);
	    return this.getId(input, parent, key);
	  };
	
	  _proto.denormalize = function denormalize(entity, unvisit) {
	    var _this2 = this;
	
	    if (isImmutable(entity)) {
	      return denormalizeImmutable(this.schema, entity, unvisit);
	    }
	
	    Object.keys(this.schema).forEach(function (key) {
	      if (entity.hasOwnProperty(key)) {
	        var schema = _this2.schema[key];
	        entity[key] = unvisit(entity[key], schema);
	      }
	    });
	    return entity;
	  };
	
	  _createClass(EntitySchema, [{
	    key: "key",
	    get: function get() {
	      return this._key;
	    }
	  }, {
	    key: "idAttribute",
	    get: function get() {
	      return this._idAttribute;
	    }
	  }]);
	
	  return EntitySchema;
	}();
	
	var PolymorphicSchema =
	/*#__PURE__*/
	function () {
	  function PolymorphicSchema(definition, schemaAttribute) {
	    if (schemaAttribute) {
	      this._schemaAttribute = typeof schemaAttribute === 'string' ? function (input) {
	        return input[schemaAttribute];
	      } : schemaAttribute;
	    }
	
	    this.define(definition);
	  }
	
	  var _proto = PolymorphicSchema.prototype;
	
	  _proto.define = function define(definition) {
	    this.schema = definition;
	  };
	
	  _proto.getSchemaAttribute = function getSchemaAttribute(input, parent, key) {
	    return !this.isSingleSchema && this._schemaAttribute(input, parent, key);
	  };
	
	  _proto.inferSchema = function inferSchema(input, parent, key) {
	    if (this.isSingleSchema) {
	      return this.schema;
	    }
	
	    var attr = this.getSchemaAttribute(input, parent, key);
	    return this.schema[attr];
	  };
	
	  _proto.normalizeValue = function normalizeValue(value, parent, key, visit, addEntity, visitedEntities) {
	    var schema = this.inferSchema(value, parent, key);
	
	    if (!schema) {
	      return value;
	    }
	
	    var normalizedValue = visit(value, parent, key, schema, addEntity, visitedEntities);
	    return this.isSingleSchema || normalizedValue === undefined || normalizedValue === null ? normalizedValue : {
	      id: normalizedValue,
	      schema: this.getSchemaAttribute(value, parent, key)
	    };
	  };
	
	  _proto.denormalizeValue = function denormalizeValue(value, unvisit) {
	    var schemaKey = isImmutable(value) ? value.get('schema') : value.schema;
	
	    if (!this.isSingleSchema && !schemaKey) {
	      return value;
	    }
	
	    var id = isImmutable(value) ? value.get('id') : value.id;
	    var schema = this.isSingleSchema ? this.schema : this.schema[schemaKey];
	    return unvisit(id || value, schema);
	  };
	
	  _createClass(PolymorphicSchema, [{
	    key: "isSingleSchema",
	    get: function get() {
	      return !this._schemaAttribute;
	    }
	  }]);
	
	  return PolymorphicSchema;
	}();
	
	var UnionSchema =
	/*#__PURE__*/
	function (_PolymorphicSchema) {
	  _inheritsLoose(UnionSchema, _PolymorphicSchema);
	
	  function UnionSchema(definition, schemaAttribute) {
	    if (!schemaAttribute) {
	      throw new Error('Expected option "schemaAttribute" not found on UnionSchema.');
	    }
	
	    return _PolymorphicSchema.call(this, definition, schemaAttribute) || this;
	  }
	
	  var _proto = UnionSchema.prototype;
	
	  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
	    return this.normalizeValue(input, parent, key, visit, addEntity, visitedEntities);
	  };
	
	  _proto.denormalize = function denormalize(input, unvisit) {
	    return this.denormalizeValue(input, unvisit);
	  };
	
	  return UnionSchema;
	}(PolymorphicSchema);
	
	var ValuesSchema =
	/*#__PURE__*/
	function (_PolymorphicSchema) {
	  _inheritsLoose(ValuesSchema, _PolymorphicSchema);
	
	  function ValuesSchema() {
	    return _PolymorphicSchema.apply(this, arguments) || this;
	  }
	
	  var _proto = ValuesSchema.prototype;
	
	  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
	    var _this = this;
	
	    return Object.keys(input).reduce(function (output, key, index) {
	      var _objectSpread2;
	
	      var value = input[key];
	      return value !== undefined && value !== null ? _objectSpread({}, output, (_objectSpread2 = {}, _objectSpread2[key] = _this.normalizeValue(value, input, key, visit, addEntity, visitedEntities), _objectSpread2)) : output;
	    }, {});
	  };
	
	  _proto.denormalize = function denormalize(input, unvisit) {
	    var _this2 = this;
	
	    return Object.keys(input).reduce(function (output, key) {
	      var _objectSpread3;
	
	      var entityOrId = input[key];
	      return _objectSpread({}, output, (_objectSpread3 = {}, _objectSpread3[key] = _this2.denormalizeValue(entityOrId, unvisit), _objectSpread3));
	    }, {});
	  };
	
	  return ValuesSchema;
	}(PolymorphicSchema);
	
	var validateSchema = function validateSchema(definition) {
	  var isArray = Array.isArray(definition);
	
	  if (isArray && definition.length > 1) {
	    throw new Error("Expected schema definition to be a single schema, but found " + definition.length + ".");
	  }
	
	  return definition[0];
	};
	
	var getValues = function getValues(input) {
	  return Array.isArray(input) ? input : Object.keys(input).map(function (key) {
	    return input[key];
	  });
	};
	
	var normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
	  schema = validateSchema(schema);
	  var values = getValues(input); // Special case: Arrays pass *their* parent on to their children, since there
	  // is not any special information that can be gathered from themselves directly
	
	  return values.map(function (value, index) {
	    return visit(value, parent, key, schema, addEntity, visitedEntities);
	  });
	};
	var denormalize = function denormalize(schema, input, unvisit) {
	  schema = validateSchema(schema);
	  return input && input.map ? input.map(function (entityOrId) {
	    return unvisit(entityOrId, schema);
	  }) : input;
	};
	
	var ArraySchema =
	/*#__PURE__*/
	function (_PolymorphicSchema) {
	  _inheritsLoose(ArraySchema, _PolymorphicSchema);
	
	  function ArraySchema() {
	    return _PolymorphicSchema.apply(this, arguments) || this;
	  }
	
	  var _proto = ArraySchema.prototype;
	
	  _proto.normalize = function normalize(input, parent, key, visit, addEntity, visitedEntities) {
	    var _this = this;
	
	    var values = getValues(input);
	    return values.map(function (value, index) {
	      return _this.normalizeValue(value, parent, key, visit, addEntity, visitedEntities);
	    }).filter(function (value) {
	      return value !== undefined && value !== null;
	    });
	  };
	
	  _proto.denormalize = function denormalize(input, unvisit) {
	    var _this2 = this;
	
	    return input && input.map ? input.map(function (value) {
	      return _this2.denormalizeValue(value, unvisit);
	    }) : input;
	  };
	
	  return ArraySchema;
	}(PolymorphicSchema);
	
	var _normalize = function normalize(schema, input, parent, key, visit, addEntity, visitedEntities) {
	  var object = _objectSpread({}, input);
	
	  Object.keys(schema).forEach(function (key) {
	    var localSchema = schema[key];
	    var value = visit(input[key], input, key, localSchema, addEntity, visitedEntities);
	
	    if (value === undefined || value === null) {
	      delete object[key];
	    } else {
	      object[key] = value;
	    }
	  });
	  return object;
	};
	
	var _denormalize = function denormalize(schema, input, unvisit) {
	  if (isImmutable(input)) {
	    return denormalizeImmutable(schema, input, unvisit);
	  }
	
	  var object = _objectSpread({}, input);
	
	  Object.keys(schema).forEach(function (key) {
	    if (object[key] != null) {
	      object[key] = unvisit(object[key], schema[key]);
	    }
	  });
	  return object;
	};
	
	var ObjectSchema =
	/*#__PURE__*/
	function () {
	  function ObjectSchema(definition) {
	    this.define(definition);
	  }
	
	  var _proto = ObjectSchema.prototype;
	
	  _proto.define = function define(definition) {
	    this.schema = Object.keys(definition).reduce(function (entitySchema, key) {
	      var _objectSpread2;
	
	      var schema = definition[key];
	      return _objectSpread({}, entitySchema, (_objectSpread2 = {}, _objectSpread2[key] = schema, _objectSpread2));
	    }, this.schema || {});
	  };
	
	  _proto.normalize = function normalize() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _normalize.apply(void 0, [this.schema].concat(args));
	  };
	
	  _proto.denormalize = function denormalize() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _denormalize.apply(void 0, [this.schema].concat(args));
	  };
	
	  return ObjectSchema;
	}();
	
	var visit = function visit(value, parent, key, schema, addEntity, visitedEntities) {
	  if (typeof value !== 'object' || !value) {
	    return value;
	  }
	
	  if (typeof schema === 'object' && (!schema.normalize || typeof schema.normalize !== 'function')) {
	    var method = Array.isArray(schema) ? normalize : _normalize;
	    return method(schema, value, parent, key, visit, addEntity, visitedEntities);
	  }
	
	  return schema.normalize(value, parent, key, visit, addEntity, visitedEntities);
	};
	
	var addEntities = function addEntities(entities) {
	  return function (schema, processedEntity, value, parent, key) {
	    var schemaKey = schema.key;
	    var id = schema.getId(value, parent, key);
	
	    if (!(schemaKey in entities)) {
	      entities[schemaKey] = {};
	    }
	
	    var existingEntity = entities[schemaKey][id];
	
	    if (existingEntity) {
	      entities[schemaKey][id] = schema.merge(existingEntity, processedEntity);
	    } else {
	      entities[schemaKey][id] = processedEntity;
	    }
	  };
	};
	
	var schema = {
	  Array: ArraySchema,
	  Entity: EntitySchema,
	  Object: ObjectSchema,
	  Union: UnionSchema,
	  Values: ValuesSchema
	};
	var normalize$1 = function normalize(input, schema) {
	  if (!input || typeof input !== 'object') {
	    throw new Error("Unexpected input given to normalize. Expected type to be \"object\", found \"" + typeof input + "\".");
	  }
	
	  var entities = {};
	  var addEntity = addEntities(entities);
	  var visitedEntities = [];
	  var result = visit(input, input, null, schema, addEntity, visitedEntities);
	  return {
	    entities: entities,
	    result: result
	  };
	};
	
	var unvisitEntity = function unvisitEntity(id, schema, unvisit, getEntity, cache) {
	  var entity = getEntity(id, schema);
	
	  if (typeof entity !== 'object' || entity === null) {
	    return entity;
	  }
	
	  if (!cache[schema.key]) {
	    cache[schema.key] = {};
	  }
	
	  if (!cache[schema.key][id]) {
	    // Ensure we don't mutate it non-immutable objects
	    var entityCopy = isImmutable(entity) ? entity : _objectSpread({}, entity); // Need to set this first so that if it is referenced further within the
	    // denormalization the reference will already exist.
	
	    cache[schema.key][id] = entityCopy;
	    cache[schema.key][id] = schema.denormalize(entityCopy, unvisit);
	  }
	
	  return cache[schema.key][id];
	};
	
	var getUnvisit = function getUnvisit(entities) {
	  var cache = {};
	  var getEntity = getEntities(entities);
	  return function unvisit(input, schema) {
	    if (typeof schema === 'object' && (!schema.denormalize || typeof schema.denormalize !== 'function')) {
	      var method = Array.isArray(schema) ? denormalize : _denormalize;
	      return method(schema, input, unvisit);
	    }
	
	    if (input === undefined || input === null) {
	      return input;
	    }
	
	    if (schema instanceof EntitySchema) {
	      return unvisitEntity(input, schema, unvisit, getEntity, cache);
	    }
	
	    return schema.denormalize(input, unvisit);
	  };
	};
	
	var getEntities = function getEntities(entities) {
	  var isImmutable$1 = isImmutable(entities);
	  return function (entityOrId, schema) {
	    var schemaKey = schema.key;
	
	    if (typeof entityOrId === 'object') {
	      return entityOrId;
	    }
	
	    if (isImmutable$1) {
	      return entities.getIn([schemaKey, entityOrId.toString()]);
	    }
	
	    return entities[schemaKey] && entities[schemaKey][entityOrId];
	  };
	};
	
	var denormalize$1 = function denormalize(input, schema, entities) {
	  if (typeof input !== 'undefined') {
	    return getUnvisit(entities)(input, schema);
	  }
	};
	
	exports.denormalize = denormalize$1;
	exports.normalize = normalize$1;
	exports.schema = schema;


/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    /* eslint no-param-reassign: 0 */
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (isArray(target) && !isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (isArray(target) && isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str, decoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var encode = function encode(str, defaultEncoder, charset) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(str);
	    }
	
	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};
	
	var maybeMap = function maybeMap(val, fn) {
	    if (isArray(val)) {
	        var mapped = [];
	        for (var i = 0; i < val.length; i += 1) {
	            mapped.push(fn(val[i]));
	        }
	        return mapped;
	    }
	    return fn(val);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    maybeMap: maybeMap,
	    merge: merge
	};


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Chart", {
	  enumerable: true,
	  get: function get() {
	    return _chart["default"];
	  }
	});
	exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(5799));
	
	var _chart = _interopRequireDefault(__webpack_require__(702));
	
	var _isEqual = _interopRequireDefault(__webpack_require__(5791));
	
	var _keyBy = _interopRequireDefault(__webpack_require__(5792));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NODE_ENV = typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","APP_NAME":"Flagler Health+","WEB_APP_URL":"https://app.flaglerhealthanywhere.com/","ADMIN_URL":"https://api.flaglerhealthanywhere.com/admin/","API_URI":"https://api.flaglerhealthanywhere.com/api/","CHAT_ATTACHMENTS_URI":"https://chat.flaglerhealthanywhere.com/chat/attachments","CHAT_SOCKET_URI":"wss://chat.flaglerhealthanywhere.com/socket","GOOGLE_ANALYTICS_ID":undefined,"DISABLE_LOGS":undefined,"BRAND_NAME":"FLAGLER","PAYA_ORIGIN":"https://api.payaconnect.com","APP_STORE_APP_LINK":"https://apps.apple.com/us/app/flagler-health-anywhere/id1451753522","PLAY_MARKET_APP_LINK":"https://play.google.com/store/apps/details?id=com.flagler.app","REACT_APP_GOOGLE_MAPS_API_KEY":"AIzaSyAi1BEBCRWDnNMHNW_0VPWY2AzWOKRDFpk","REFRESH_SESSION_INTERVAL":"300000","WEB_PROVIDER_APP_URL":"https://pws.flaglerhealthanywhere.com","GA_MEASUREMENT_ID":"G-9ZNTYXZJF8","APP_VERSION":"17.40.0","CI_PIPELINE_IID":"6220","USE_INTERCOM_CHAT":"false","INTERCOM_CHAT_APP_ID":"","MOZZAZ_REDIRECT_URL":"","INTERCOM_SECRET_KEY":"","ENV_NAME":"production","SENTRY_SERVER_DNS":undefined,"SENTRY_CLIENT_DNS":"https://73d2990676b848199ad78305122f989d@tracker.ecuris.net/14","TOKBOX_EMBED_JS_URL":undefined,"TOKBOX_EMBED_ID":undefined,"APPLE_APP_ID":"7988NSSC3K.org.flaglerhospital.onlinecare.member","NODE_PORT":undefined}) && ("production");
	
	var ChartComponent = /*#__PURE__*/function (_React$Component) {
	  _inherits(ChartComponent, _React$Component);
	
	  var _super = _createSuper(ChartComponent);
	
	  function ChartComponent() {
	    var _this;
	
	    _classCallCheck(this, ChartComponent);
	
	    _this = _super.call(this);
	
	    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
	      var instance = _this.chartInstance;
	      var _this$props = _this.props,
	          getDatasetAtEvent = _this$props.getDatasetAtEvent,
	          getElementAtEvent = _this$props.getElementAtEvent,
	          getElementsAtEvent = _this$props.getElementsAtEvent,
	          onElementsClick = _this$props.onElementsClick;
	      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
	      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
	      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
	      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
	      _this.element = element;
	    });
	
	    _this.chartInstance = undefined;
	    return _this;
	  }
	
	  _createClass(ChartComponent, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.renderChart();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.redraw) {
	        this.destroyChart();
	        this.renderChart();
	        return;
	      }
	
	      this.updateChart();
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _this$props2 = this.props,
	          redraw = _this$props2.redraw,
	          type = _this$props2.type,
	          options = _this$props2.options,
	          plugins = _this$props2.plugins,
	          legend = _this$props2.legend,
	          height = _this$props2.height,
	          width = _this$props2.width;
	
	      if (nextProps.redraw === true) {
	        return true;
	      }
	
	      if (height !== nextProps.height || width !== nextProps.width) {
	        return true;
	      }
	
	      if (type !== nextProps.type) {
	        return true;
	      }
	
	      if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
	        return true;
	      }
	
	      if (!(0, _isEqual["default"])(options, nextProps.options)) {
	        return true;
	      }
	
	      var nextData = this.transformDataProp(nextProps);
	
	      if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
	        return true;
	      }
	
	      return !(0, _isEqual["default"])(plugins, nextProps.plugins);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyChart();
	    }
	  }, {
	    key: "transformDataProp",
	    value: function transformDataProp(props) {
	      var data = props.data;
	
	      if (typeof data == 'function') {
	        var node = this.element;
	        return data(node);
	      } else {
	        return data;
	      }
	    } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
	    // this makes impossible to compare the current and next data changes
	    // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
	    // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617
	
	  }, {
	    key: "memoizeDataProps",
	    value: function memoizeDataProps() {
	      if (!this.props.data) {
	        return;
	      }
	
	      var data = this.transformDataProp(this.props);
	      this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
	        datasets: data.datasets && data.datasets.map(function (set) {
	          return _objectSpread({}, set);
	        })
	      });
	      this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
	
	      return data;
	    }
	  }, {
	    key: "checkDatasets",
	    value: function checkDatasets(datasets) {
	      var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
	      var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
	      var multipleDatasets = datasets.length > 1;
	
	      if (isDev && multipleDatasets && !usingCustomKeyProvider) {
	        var shouldWarn = false;
	        datasets.forEach(function (dataset) {
	          if (!dataset.label) {
	            shouldWarn = true;
	          }
	        });
	
	        if (shouldWarn) {
	          console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
	        }
	      }
	    }
	  }, {
	    key: "getCurrentDatasets",
	    value: function getCurrentDatasets() {
	      return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
	    }
	  }, {
	    key: "saveCurrentDatasets",
	    value: function saveCurrentDatasets() {
	      var _this2 = this;
	
	      this.datasets = this.datasets || {};
	      var currentDatasets = this.getCurrentDatasets();
	      currentDatasets.forEach(function (d) {
	        _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
	      });
	    }
	  }, {
	    key: "updateChart",
	    value: function updateChart() {
	      var _this3 = this;
	
	      var options = this.props.options;
	      var data = this.memoizeDataProps(this.props);
	      if (!this.chartInstance) return;
	
	      if (options) {
	        this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
	      } // Pipe datasets to chart instance datasets enabling
	      // seamless transitions
	
	
	      var currentDatasets = this.getCurrentDatasets();
	      var nextDatasets = data.datasets || [];
	      this.checkDatasets(currentDatasets);
	      var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
	      // on each dataset.
	
	      this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
	        var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
	
	        if (current && current.type === next.type && next.data) {
	          // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
	          // The data array must be edited in place. As chart.js adds listeners to it.
	          current.data.splice(next.data.length);
	          next.data.forEach(function (point, pid) {
	            current.data[pid] = next.data[pid];
	          });
	
	          var _data = next.data,
	              otherProps = _objectWithoutProperties(next, ["data"]); // Merge properties. Notice a weakness here. If a property is removed
	          // from next, it will be retained by current and never disappears.
	          // Workaround is to set value to null or undefined in next.
	
	
	          return _objectSpread(_objectSpread({}, current), otherProps);
	        } else {
	          return next;
	        }
	      });
	
	      var datasets = data.datasets,
	          rest = _objectWithoutProperties(data, ["datasets"]);
	
	      this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
	      this.chartInstance.update();
	    }
	  }, {
	    key: "renderChart",
	    value: function renderChart() {
	      var _this$props3 = this.props,
	          options = _this$props3.options,
	          legend = _this$props3.legend,
	          type = _this$props3.type,
	          plugins = _this$props3.plugins;
	      var node = this.element;
	      var data = this.memoizeDataProps();
	
	      if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
	        options.legend = legend;
	      }
	
	      this.chartInstance = new _chart["default"](node, {
	        type: type,
	        data: data,
	        options: options,
	        plugins: plugins
	      });
	    }
	  }, {
	    key: "destroyChart",
	    value: function destroyChart() {
	      if (!this.chartInstance) {
	        return;
	      } // Put all of the datasets that have existed in the chart back on the chart
	      // so that the metadata associated with this chart get destroyed.
	      // This allows the datasets to be used in another chart. This can happen,
	      // for example, in a tabbed UI where the chart gets created each time the
	      // tab gets switched to the chart and uses the same data).
	
	
	      this.saveCurrentDatasets();
	      var datasets = Object.values(this.datasets);
	      this.chartInstance.config.data.datasets = datasets;
	      this.chartInstance.destroy();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          height = _this$props4.height,
	          width = _this$props4.width,
	          id = _this$props4.id;
	      return /*#__PURE__*/_react["default"].createElement("canvas", {
	        ref: this.ref,
	        height: height,
	        width: width,
	        id: id,
	        onClick: this.handleOnClick
	      });
	    }
	  }]);
	
	  return ChartComponent;
	}(_react["default"].Component);
	
	_defineProperty(ChartComponent, "getLabelAsKey", function (d) {
	  return d.label;
	});
	
	_defineProperty(ChartComponent, "propTypes", {
	  data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
	  getDatasetAtEvent: _propTypes["default"].func,
	  getElementAtEvent: _propTypes["default"].func,
	  getElementsAtEvent: _propTypes["default"].func,
	  height: _propTypes["default"].number,
	  legend: _propTypes["default"].object,
	  onElementsClick: _propTypes["default"].func,
	  options: _propTypes["default"].object,
	  plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  redraw: _propTypes["default"].bool,
	  type: function type(props, propName, componentName) {
	    if (!_chart["default"].controllers[props[propName]]) {
	      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
	    }
	  },
	  width: _propTypes["default"].number,
	  datasetKeyProvider: _propTypes["default"].func
	});
	
	_defineProperty(ChartComponent, "defaultProps", {
	  legend: {
	    display: true,
	    position: 'bottom'
	  },
	  type: 'doughnut',
	  height: 150,
	  width: 300,
	  redraw: false,
	  options: {},
	  datasetKeyProvider: ChartComponent.getLabelAsKey
	});
	
	var _default = ChartComponent;
	exports["default"] = _default;
	
	var Doughnut = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Doughnut, _React$Component2);
	
	  var _super2 = _createSuper(Doughnut);
	
	  function Doughnut() {
	    _classCallCheck(this, Doughnut);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Doughnut, [{
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref) {
	          return _this4.chartInstance = _ref && _ref.chartInstance;
	        },
	        type: "doughnut"
	      }));
	    }
	  }]);
	
	  return Doughnut;
	}(_react["default"].Component);
	
	exports.Doughnut = Doughnut;
	
	var Pie = /*#__PURE__*/function (_React$Component3) {
	  _inherits(Pie, _React$Component3);
	
	  var _super3 = _createSuper(Pie);
	
	  function Pie() {
	    _classCallCheck(this, Pie);
	
	    return _super3.apply(this, arguments);
	  }
	
	  _createClass(Pie, [{
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref2) {
	          return _this5.chartInstance = _ref2 && _ref2.chartInstance;
	        },
	        type: "pie"
	      }));
	    }
	  }]);
	
	  return Pie;
	}(_react["default"].Component);
	
	exports.Pie = Pie;
	
	var Line = /*#__PURE__*/function (_React$Component4) {
	  _inherits(Line, _React$Component4);
	
	  var _super4 = _createSuper(Line);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _super4.apply(this, arguments);
	  }
	
	  _createClass(Line, [{
	    key: "render",
	    value: function render() {
	      var _this6 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref3) {
	          return _this6.chartInstance = _ref3 && _ref3.chartInstance;
	        },
	        type: "line"
	      }));
	    }
	  }]);
	
	  return Line;
	}(_react["default"].Component);
	
	exports.Line = Line;
	
	var Bar = /*#__PURE__*/function (_React$Component5) {
	  _inherits(Bar, _React$Component5);
	
	  var _super5 = _createSuper(Bar);
	
	  function Bar() {
	    _classCallCheck(this, Bar);
	
	    return _super5.apply(this, arguments);
	  }
	
	  _createClass(Bar, [{
	    key: "render",
	    value: function render() {
	      var _this7 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref4) {
	          return _this7.chartInstance = _ref4 && _ref4.chartInstance;
	        },
	        type: "bar"
	      }));
	    }
	  }]);
	
	  return Bar;
	}(_react["default"].Component);
	
	exports.Bar = Bar;
	
	var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
	  _inherits(HorizontalBar, _React$Component6);
	
	  var _super6 = _createSuper(HorizontalBar);
	
	  function HorizontalBar() {
	    _classCallCheck(this, HorizontalBar);
	
	    return _super6.apply(this, arguments);
	  }
	
	  _createClass(HorizontalBar, [{
	    key: "render",
	    value: function render() {
	      var _this8 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref5) {
	          return _this8.chartInstance = _ref5 && _ref5.chartInstance;
	        },
	        type: "horizontalBar"
	      }));
	    }
	  }]);
	
	  return HorizontalBar;
	}(_react["default"].Component);
	
	exports.HorizontalBar = HorizontalBar;
	
	var Radar = /*#__PURE__*/function (_React$Component7) {
	  _inherits(Radar, _React$Component7);
	
	  var _super7 = _createSuper(Radar);
	
	  function Radar() {
	    _classCallCheck(this, Radar);
	
	    return _super7.apply(this, arguments);
	  }
	
	  _createClass(Radar, [{
	    key: "render",
	    value: function render() {
	      var _this9 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref6) {
	          return _this9.chartInstance = _ref6 && _ref6.chartInstance;
	        },
	        type: "radar"
	      }));
	    }
	  }]);
	
	  return Radar;
	}(_react["default"].Component);
	
	exports.Radar = Radar;
	
	var Polar = /*#__PURE__*/function (_React$Component8) {
	  _inherits(Polar, _React$Component8);
	
	  var _super8 = _createSuper(Polar);
	
	  function Polar() {
	    _classCallCheck(this, Polar);
	
	    return _super8.apply(this, arguments);
	  }
	
	  _createClass(Polar, [{
	    key: "render",
	    value: function render() {
	      var _this10 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref7) {
	          return _this10.chartInstance = _ref7 && _ref7.chartInstance;
	        },
	        type: "polarArea"
	      }));
	    }
	  }]);
	
	  return Polar;
	}(_react["default"].Component);
	
	exports.Polar = Polar;
	
	var Bubble = /*#__PURE__*/function (_React$Component9) {
	  _inherits(Bubble, _React$Component9);
	
	  var _super9 = _createSuper(Bubble);
	
	  function Bubble() {
	    _classCallCheck(this, Bubble);
	
	    return _super9.apply(this, arguments);
	  }
	
	  _createClass(Bubble, [{
	    key: "render",
	    value: function render() {
	      var _this11 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref8) {
	          return _this11.chartInstance = _ref8 && _ref8.chartInstance;
	        },
	        type: "bubble"
	      }));
	    }
	  }]);
	
	  return Bubble;
	}(_react["default"].Component);
	
	exports.Bubble = Bubble;
	
	var Scatter = /*#__PURE__*/function (_React$Component10) {
	  _inherits(Scatter, _React$Component10);
	
	  var _super10 = _createSuper(Scatter);
	
	  function Scatter() {
	    _classCallCheck(this, Scatter);
	
	    return _super10.apply(this, arguments);
	  }
	
	  _createClass(Scatter, [{
	    key: "render",
	    value: function render() {
	      var _this12 = this;
	
	      return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
	        ref: function ref(_ref9) {
	          return _this12.chartInstance = _ref9 && _ref9.chartInstance;
	        },
	        type: "scatter"
	      }));
	    }
	  }]);
	
	  return Scatter;
	}(_react["default"].Component);
	
	exports.Scatter = Scatter;
	var defaults = _chart["default"].defaults;
	exports.defaults = defaults;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(583)))

/***/ }),
/* 1579 */
[6725, 471, 328],
/* 1580 */
[6726, 5768, 5769, 5770, 5771, 5772],
/* 1581 */
[6747, 5727, 740],
/* 1582 */
[6787, 329, 1585],
/* 1583 */
1592,
/* 1584 */
331,
/* 1585 */
[6822, 739, 740],
/* 1586 */
[6824, 5715, 5732, 2678],
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */
6257,
/* 1594 */
1051,
/* 1595 */
6258,
/* 1596 */
[6639, 92, 62, 1018, 47],
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(62));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added
	 * @returns {Date} the new date with the days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * var result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(62));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(62));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2721));
	
	var _index4 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * var result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  var desiredMonth = date.getMonth() + amount;
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
	  // if the original date was the last day of the longer month
	
	  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 1600 */
[6686, 62, 47],
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(1016);
	
	var _interopRequireDefault = __webpack_require__(1015);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(1593));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(1595));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(1594));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(5941));
	
	var ManagerReferenceNodeContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "referenceNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setReferenceNode", function (newReferenceNode) {
	      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
	        _this.referenceNode = newReferenceNode;
	
	        _this.forceUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.referenceNode = null;
	  };
	
	  _proto.render = function render() {
	    return React.createElement(ManagerReferenceNodeContext.Provider, {
	      value: this.referenceNode
	    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	      value: this.setReferenceNode
	    }, this.props.children));
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TEXT = exports.URL = exports.FILE = void 0;
	var FILE = '__NATIVE_FILE__';
	exports.FILE = FILE;
	var URL = '__NATIVE_URL__';
	exports.URL = URL;
	var TEXT = '__NATIVE_TEXT__';
	exports.TEXT = TEXT;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createDndContext = createDndContext;
	exports.DndContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _dndCore = __webpack_require__(4865);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	/**
	 * Create the React Context
	 */
	var DndContext = React.createContext({
	  dragDropManager: undefined
	});
	/**
	 * Creates the context object we're providing
	 * @param backend
	 * @param context
	 */
	
	exports.DndContext = DndContext;
	
	function createDndContext(backend, context, options, debugMode) {
	  return {
	    dragDropManager: (0, _dndCore.createDragDropManager)(backend, context, options, debugMode)
	  };
	}

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useDragDropManager = useDragDropManager;
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(129);
	
	var _DndContext = __webpack_require__(1603);
	
	/**
	 * A hook to retrieve the DragDropManager from Context
	 */
	function useDragDropManager() {
	  var _useContext = (0, _react.useContext)(_DndContext.DndContext),
	      dragDropManager = _useContext.dragDropManager;
	
	  (0, _invariant.invariant)(dragDropManager != null, 'Expected drag drop context');
	  return dragDropManager;
	}

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1609),
	    baseLodash = __webpack_require__(1610);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 1606 */
[6725, 477, 210],
/* 1607 */
[6726, 6141, 6142, 6143, 6144, 6145],
/* 1608 */
5818,
/* 1609 */
[6709, 478],
/* 1610 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 1611 */
[6757, 745, 6153, 2771],
/* 1612 */
/***/ (function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ }),
/* 1613 */
[6787, 252, 1034],
/* 1614 */
1592,
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(6295);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(4851);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(6187);
	
	var _HelmetConstants = __webpack_require__(2781);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6234);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lottieWeb = __webpack_require__(5526);
	
	var _lottieWeb2 = _interopRequireDefault(_lottieWeb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lottie = function (_React$Component) {
	  (0, _inherits3.default)(Lottie, _React$Component);
	
	  function Lottie() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Lottie);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, _getPrototypeOf2.default)(Lottie)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickToPause = function () {
	      // The pause() method is for handling pausing by passing a prop isPaused
	      // This method is for handling the ability to pause by clicking on the animation
	      if (_this.anim.isPaused) {
	        _this.anim.play();
	      } else {
	        _this.anim.pause();
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Lottie, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          options = _props.options,
	          eventListeners = _props.eventListeners;
	      var loop = options.loop,
	          autoplay = options.autoplay,
	          animationData = options.animationData,
	          rendererSettings = options.rendererSettings,
	          segments = options.segments;
	
	
	      this.options = {
	        container: this.el,
	        renderer: 'svg',
	        loop: loop !== false,
	        autoplay: autoplay !== false,
	        segments: segments !== false,
	        animationData: animationData,
	        rendererSettings: rendererSettings
	      };
	
	      this.options = (0, _extends3.default)({}, this.options, options);
	
	      this.anim = _lottieWeb2.default.loadAnimation(this.options);
	      this.registerEvents(eventListeners);
	
	      this.setSpeed();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps /* , nextState */) {
	      /* Recreate the animation handle if the data is changed */
	      if (this.options.animationData !== nextProps.options.animationData) {
	        this.deRegisterEvents(this.props.eventListeners);
	        this.destroy();
	        this.options = (0, _extends3.default)({}, this.options, nextProps.options);
	        this.anim = _lottieWeb2.default.loadAnimation(this.options);
	        this.registerEvents(nextProps.eventListeners);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.isStopped) {
	        this.stop();
	      } else if (this.props.segments) {
	        this.playSegments();
	      } else {
	        this.play();
	      }
	
	      this.pause();
	      this.setSpeed();
	      this.setDirection();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.deRegisterEvents(this.props.eventListeners);
	      this.destroy();
	      this.options.animationData = null;
	      this.anim = null;
	    }
	  }, {
	    key: 'setSpeed',
	    value: function setSpeed() {
	      this.anim.setSpeed(this.props.speed);
	    }
	  }, {
	    key: 'setDirection',
	    value: function setDirection() {
	      this.anim.setDirection(this.props.direction);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.anim.play();
	    }
	  }, {
	    key: 'playSegments',
	    value: function playSegments() {
	      this.anim.playSegments(this.props.segments);
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.anim.stop();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (this.props.isPaused && !this.anim.isPaused) {
	        this.anim.pause();
	      } else if (!this.props.isPaused && this.anim.isPaused) {
	        this.anim.pause();
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.anim.destroy();
	    }
	  }, {
	    key: 'registerEvents',
	    value: function registerEvents(eventListeners) {
	      var _this2 = this;
	
	      eventListeners.forEach(function (eventListener) {
	        _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
	      });
	    }
	  }, {
	    key: 'deRegisterEvents',
	    value: function deRegisterEvents(eventListeners) {
	      var _this3 = this;
	
	      eventListeners.forEach(function (eventListener) {
	        _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height,
	          ariaRole = _props2.ariaRole,
	          ariaLabel = _props2.ariaLabel,
	          isClickToPauseDisabled = _props2.isClickToPauseDisabled,
	          title = _props2.title;
	
	
	      var getSize = function getSize(initial) {
	        var size = void 0;
	
	        if (typeof initial === 'number') {
	          size = initial + 'px';
	        } else {
	          size = initial || '100%';
	        }
	
	        return size;
	      };
	
	      var lottieStyles = (0, _extends3.default)({
	        width: getSize(width),
	        height: getSize(height),
	        overflow: 'hidden',
	        margin: '0 auto',
	        outline: 'none'
	      }, this.props.style);
	
	      var onClickHandler = isClickToPauseDisabled ? function () {
	        return null;
	      } : this.handleClickToPause;
	
	      return (
	        // Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
	        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
	        _react2.default.createElement('div', {
	          ref: function ref(c) {
	            _this4.el = c;
	          },
	          style: lottieStyles,
	          onClick: onClickHandler,
	          title: title,
	          role: ariaRole,
	          'aria-label': ariaLabel,
	          tabIndex: '0'
	        })
	      );
	    }
	  }]);
	  return Lottie;
	}(_react2.default.Component);
	
	exports.default = Lottie;
	
	
	Lottie.propTypes = {
	  eventListeners: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  options: _propTypes2.default.object.isRequired,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  isStopped: _propTypes2.default.bool,
	  isPaused: _propTypes2.default.bool,
	  speed: _propTypes2.default.number,
	  segments: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  direction: _propTypes2.default.number,
	  ariaRole: _propTypes2.default.string,
	  ariaLabel: _propTypes2.default.string,
	  isClickToPauseDisabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	Lottie.defaultProps = {
	  eventListeners: [],
	  isStopped: false,
	  isPaused: false,
	  speed: 1,
	  ariaRole: 'button',
	  ariaLabel: 'animation',
	  isClickToPauseDisabled: false,
	  title: ''
	};

/***/ }),
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	__webpack_require__(1043);
	__webpack_require__(1040);
	__webpack_require__(2819);
	__webpack_require__(2821);
	__webpack_require__(1628);
	var _classCallCheck = _interopDefault(__webpack_require__(1038));
	var _createClass = _interopDefault(__webpack_require__(1039));
	__webpack_require__(1627);
	var _inherits = _interopDefault(__webpack_require__(1042));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(1044));
	var _getPrototypeOf = _interopDefault(__webpack_require__(1041));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var memoizeOne = _interopDefault(__webpack_require__(2402));
	var core = __webpack_require__(1629);
	__webpack_require__(71);
	__webpack_require__(749);
	var index$1 = __webpack_require__(2817);
	var reactSelect = __webpack_require__(6282);
	__webpack_require__(486);
	__webpack_require__(2820);
	__webpack_require__(2788);
	var stateManager = __webpack_require__(6283);
	var createCache = _interopDefault(__webpack_require__(6293));
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	var NonceProvider = /*#__PURE__*/function (_Component) {
	  _inherits(NonceProvider, _Component);
	
	  var _super = _createSuper(NonceProvider);
	
	  function NonceProvider(props) {
	    var _this;
	
	    _classCallCheck(this, NonceProvider);
	
	    _this = _super.call(this, props);
	
	    _this.createEmotionCache = function (nonce) {
	      return createCache({
	        nonce: nonce
	      });
	    };
	
	    _this.createEmotionCache = memoizeOne(_this.createEmotionCache);
	    return _this;
	  }
	
	  _createClass(NonceProvider, [{
	    key: "render",
	    value: function render() {
	      var emotionCache = this.createEmotionCache(this.props.nonce);
	      return /*#__PURE__*/React__default.createElement(core.CacheProvider, {
	        value: emotionCache
	      }, this.props.children);
	    }
	  }]);
	
	  return NonceProvider;
	}(React.Component);
	
	var index = stateManager.manageState(reactSelect.Select);
	
	exports.components = index$1.components;
	exports.createFilter = reactSelect.createFilter;
	exports.defaultTheme = reactSelect.defaultTheme;
	exports.mergeStyles = reactSelect.mergeStyles;
	exports.NonceProvider = NonceProvider;
	exports.default = index;


/***/ }),
/* 1627 */
/***/ (function(module, exports) {

	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(2822);
	function _defineProperty(e, r, t) {
	  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
	    value: t,
	    enumerable: !0,
	    configurable: !0,
	    writable: !0
	  }) : e[r] = t, e;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _inheritsLoose = __webpack_require__(2824);
	var React = __webpack_require__(1);
	__webpack_require__(2825);
	var emotionElement = __webpack_require__(6294);
	var utils = __webpack_require__(1056);
	var serialize = __webpack_require__(755);
	var sheet = __webpack_require__(598);
	var css = __webpack_require__(486);
	
	function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }
	
	var _inheritsLoose__default = /*#__PURE__*/_interopDefault(_inheritsLoose);
	var css__default = /*#__PURE__*/_interopDefault(css);
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !emotionElement.hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = emotionElement.Emotion;
	  createElementArgArray[1] = emotionElement.createEmotionProps(type, props);
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global = /* #__PURE__ */emotionElement.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return /*#__PURE__*/React.createElement(emotionElement.ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return /*#__PURE__*/React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return /*#__PURE__*/React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose__default['default'](InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css__default['default'].apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var Noop = function Noop() {
	  return null;
	};
	
	var ClassNames = emotionElement.withEmotionCache(function (props, context) {
	  return /*#__PURE__*/React.createElement(emotionElement.ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	    var possiblyStyleElement = /*#__PURE__*/React.createElement(Noop, null);
	
	
	    return /*#__PURE__*/React.createElement(React.Fragment, null, possiblyStyleElement, ele);
	  });
	});
	
	exports.CacheProvider = emotionElement.CacheProvider;
	exports.ThemeContext = emotionElement.ThemeContext;
	exports.withEmotionCache = emotionElement.withEmotionCache;
	Object.defineProperty(exports, 'css', {
	  enumerable: true,
	  get: function () {
	    return css__default['default'];
	  }
	});
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.createElement = jsx;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ }),
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(1052));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(1661));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var _inheritsLoose = _interopDefault(__webpack_require__(1053));
	var _assertThisInitialized = _interopDefault(__webpack_require__(2890));
	
	var is = {
	  arr: Array.isArray,
	  obj: function obj(a) {
	    return Object.prototype.toString.call(a) === '[object Object]';
	  },
	  fun: function fun(a) {
	    return typeof a === 'function';
	  },
	  str: function str(a) {
	    return typeof a === 'string';
	  },
	  num: function num(a) {
	    return typeof a === 'number';
	  },
	  und: function und(a) {
	    return a === void 0;
	  },
	  nul: function nul(a) {
	    return a === null;
	  },
	  set: function set(a) {
	    return a instanceof Set;
	  },
	  map: function map(a) {
	    return a instanceof Map;
	  },
	  equ: function equ(a, b) {
	    if (typeof a !== typeof b) return false;
	    if (is.str(a) || is.num(a)) return a === b;
	    if (is.obj(a) && is.obj(b) && Object.keys(a).length + Object.keys(b).length === 0) return true;
	    var i;
	
	    for (i in a) {
	      if (!(i in b)) return false;
	    }
	
	    for (i in b) {
	      if (a[i] !== b[i]) return false;
	    }
	
	    return is.und(i) ? a === b : true;
	  }
	};
	function merge(target, lowercase) {
	  if (lowercase === void 0) {
	    lowercase = true;
	  }
	
	  return function (object) {
	    return (is.arr(object) ? object : Object.keys(object)).reduce(function (acc, element) {
	      var key = lowercase ? element[0].toLowerCase() + element.substring(1) : element;
	      acc[key] = target(key);
	      return acc;
	    }, target);
	  };
	}
	function useForceUpdate() {
	  var _useState = React.useState(false),
	      f = _useState[1];
	
	  var forceUpdate = React.useCallback(function () {
	    return f(function (v) {
	      return !v;
	    });
	  }, []);
	  return forceUpdate;
	}
	function withDefault(value, defaultValue) {
	  return is.und(value) || is.nul(value) ? defaultValue : value;
	}
	function toArray(a) {
	  return !is.und(a) ? is.arr(a) ? a : [a] : [];
	}
	function callProp(obj) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return is.fun(obj) ? obj.apply(void 0, args) : obj;
	}
	
	function getForwardProps(props) {
	  var to = props.to,
	      from = props.from,
	      config = props.config,
	      onStart = props.onStart,
	      onRest = props.onRest,
	      onFrame = props.onFrame,
	      children = props.children,
	      reset = props.reset,
	      reverse = props.reverse,
	      force = props.force,
	      immediate = props.immediate,
	      delay = props.delay,
	      attach = props.attach,
	      destroyed = props.destroyed,
	      interpolateTo = props.interpolateTo,
	      ref = props.ref,
	      lazy = props.lazy,
	      forward = _objectWithoutPropertiesLoose(props, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);
	
	  return forward;
	}
	
	function interpolateTo(props) {
	  var forward = getForwardProps(props);
	  if (is.und(forward)) return _extends({
	    to: forward
	  }, props);
	  var rest = Object.keys(props).reduce(function (a, k) {
	    var _extends2;
	
	    return !is.und(forward[k]) ? a : _extends({}, a, (_extends2 = {}, _extends2[k] = props[k], _extends2));
	  }, {});
	  return _extends({
	    to: forward
	  }, rest);
	}
	function handleRef(ref, forward) {
	  if (forward) {
	    // If it's a function, assume it's a ref callback
	    if (is.fun(forward)) forward(ref);else if (is.obj(forward)) {
	      forward.current = ref;
	    }
	  }
	
	  return ref;
	}
	
	var Animated =
	/*#__PURE__*/
	function () {
	  function Animated() {
	    this.payload = void 0;
	    this.children = [];
	  }
	
	  var _proto = Animated.prototype;
	
	  _proto.getAnimatedValue = function getAnimatedValue() {
	    return this.getValue();
	  };
	
	  _proto.getPayload = function getPayload() {
	    return this.payload || this;
	  };
	
	  _proto.attach = function attach() {};
	
	  _proto.detach = function detach() {};
	
	  _proto.getChildren = function getChildren() {
	    return this.children;
	  };
	
	  _proto.addChild = function addChild(child) {
	    if (this.children.length === 0) this.attach();
	    this.children.push(child);
	  };
	
	  _proto.removeChild = function removeChild(child) {
	    var index = this.children.indexOf(child);
	    this.children.splice(index, 1);
	    if (this.children.length === 0) this.detach();
	  };
	
	  return Animated;
	}();
	var AnimatedArray =
	/*#__PURE__*/
	function (_Animated) {
	  _inheritsLoose(AnimatedArray, _Animated);
	
	  function AnimatedArray() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _Animated.call.apply(_Animated, [this].concat(args)) || this;
	    _this.payload = [];
	
	    _this.attach = function () {
	      return _this.payload.forEach(function (p) {
	        return p instanceof Animated && p.addChild(_assertThisInitialized(_this));
	      });
	    };
	
	    _this.detach = function () {
	      return _this.payload.forEach(function (p) {
	        return p instanceof Animated && p.removeChild(_assertThisInitialized(_this));
	      });
	    };
	
	    return _this;
	  }
	
	  return AnimatedArray;
	}(Animated);
	var AnimatedObject =
	/*#__PURE__*/
	function (_Animated2) {
	  _inheritsLoose(AnimatedObject, _Animated2);
	
	  function AnimatedObject() {
	    var _this2;
	
	    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    _this2 = _Animated2.call.apply(_Animated2, [this].concat(args)) || this;
	    _this2.payload = {};
	
	    _this2.attach = function () {
	      return Object.values(_this2.payload).forEach(function (s) {
	        return s instanceof Animated && s.addChild(_assertThisInitialized(_this2));
	      });
	    };
	
	    _this2.detach = function () {
	      return Object.values(_this2.payload).forEach(function (s) {
	        return s instanceof Animated && s.removeChild(_assertThisInitialized(_this2));
	      });
	    };
	
	    return _this2;
	  }
	
	  var _proto2 = AnimatedObject.prototype;
	
	  _proto2.getValue = function getValue(animated) {
	    if (animated === void 0) {
	      animated = false;
	    }
	
	    var payload = {};
	
	    for (var _key4 in this.payload) {
	      var value = this.payload[_key4];
	      if (animated && !(value instanceof Animated)) continue;
	      payload[_key4] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
	    }
	
	    return payload;
	  };
	
	  _proto2.getAnimatedValue = function getAnimatedValue() {
	    return this.getValue(true);
	  };
	
	  return AnimatedObject;
	}(Animated);
	
	var applyAnimatedValues;
	function injectApplyAnimatedValues(fn, transform) {
	  applyAnimatedValues = {
	    fn: fn,
	    transform: transform
	  };
	}
	var colorNames;
	function injectColorNames(names) {
	  colorNames = names;
	}
	var requestFrame = function requestFrame(cb) {
	  return typeof window !== 'undefined' ? window.requestAnimationFrame(cb) : -1;
	};
	var cancelFrame = function cancelFrame(id) {
	  typeof window !== 'undefined' && window.cancelAnimationFrame(id);
	};
	function injectFrame(raf, caf) {
	  requestFrame = raf;
	  cancelFrame = caf;
	}
	var interpolation;
	function injectStringInterpolator(fn) {
	  interpolation = fn;
	}
	var now = function now() {
	  return Date.now();
	};
	function injectNow(nowFn) {
	  now = nowFn;
	}
	var defaultElement;
	function injectDefaultElement(el) {
	  defaultElement = el;
	}
	var animatedApi = function animatedApi(node) {
	  return node.current;
	};
	function injectAnimatedApi(fn) {
	  animatedApi = fn;
	}
	var createAnimatedStyle;
	function injectCreateAnimatedStyle(factory) {
	  createAnimatedStyle = factory;
	}
	var manualFrameloop;
	function injectManualFrameloop(callback) {
	  manualFrameloop = callback;
	}
	
	var Globals = /*#__PURE__*/Object.freeze({
	  get applyAnimatedValues () { return applyAnimatedValues; },
	  injectApplyAnimatedValues: injectApplyAnimatedValues,
	  get colorNames () { return colorNames; },
	  injectColorNames: injectColorNames,
	  get requestFrame () { return requestFrame; },
	  get cancelFrame () { return cancelFrame; },
	  injectFrame: injectFrame,
	  get interpolation () { return interpolation; },
	  injectStringInterpolator: injectStringInterpolator,
	  get now () { return now; },
	  injectNow: injectNow,
	  get defaultElement () { return defaultElement; },
	  injectDefaultElement: injectDefaultElement,
	  get animatedApi () { return animatedApi; },
	  injectAnimatedApi: injectAnimatedApi,
	  get createAnimatedStyle () { return createAnimatedStyle; },
	  injectCreateAnimatedStyle: injectCreateAnimatedStyle,
	  get manualFrameloop () { return manualFrameloop; },
	  injectManualFrameloop: injectManualFrameloop
	});
	
	/**
	 * Wraps the `style` property with `AnimatedStyle`.
	 */
	
	var AnimatedProps =
	/*#__PURE__*/
	function (_AnimatedObject) {
	  _inheritsLoose(AnimatedProps, _AnimatedObject);
	
	  function AnimatedProps(props, callback) {
	    var _this;
	
	    _this = _AnimatedObject.call(this) || this;
	    _this.update = void 0;
	    _this.payload = !props.style ? props : _extends({}, props, {
	      style: createAnimatedStyle(props.style)
	    });
	    _this.update = callback;
	
	    _this.attach();
	
	    return _this;
	  }
	
	  return AnimatedProps;
	}(AnimatedObject);
	
	var isFunctionComponent = function isFunctionComponent(val) {
	  return is.fun(val) && !(val.prototype instanceof React__default.Component);
	};
	
	var createAnimatedComponent = function createAnimatedComponent(Component) {
	  var AnimatedComponent = React.forwardRef(function (props, ref) {
	    var forceUpdate = useForceUpdate();
	    var mounted = React.useRef(true);
	    var propsAnimated = React.useRef(null);
	    var node = React.useRef(null);
	    var attachProps = React.useCallback(function (props) {
	      var oldPropsAnimated = propsAnimated.current;
	
	      var callback = function callback() {
	        var didUpdate = false;
	
	        if (node.current) {
	          didUpdate = applyAnimatedValues.fn(node.current, propsAnimated.current.getAnimatedValue());
	        }
	
	        if (!node.current || didUpdate === false) {
	          // If no referenced node has been found, or the update target didn't have a
	          // native-responder, then forceUpdate the animation ...
	          forceUpdate();
	        }
	      };
	
	      propsAnimated.current = new AnimatedProps(props, callback);
	      oldPropsAnimated && oldPropsAnimated.detach();
	    }, []);
	    React.useEffect(function () {
	      return function () {
	        mounted.current = false;
	        propsAnimated.current && propsAnimated.current.detach();
	      };
	    }, []);
	    React.useImperativeHandle(ref, function () {
	      return animatedApi(node, mounted, forceUpdate);
	    });
	    attachProps(props);
	
	    var _getValue = propsAnimated.current.getValue(),
	        scrollTop = _getValue.scrollTop,
	        scrollLeft = _getValue.scrollLeft,
	        animatedProps = _objectWithoutPropertiesLoose(_getValue, ["scrollTop", "scrollLeft"]); // Functions cannot have refs, see:
	    // See: https://github.com/react-spring/react-spring/issues/569
	
	
	    var refFn = isFunctionComponent(Component) ? undefined : function (childRef) {
	      return node.current = handleRef(childRef, ref);
	    };
	    return React__default.createElement(Component, _extends({}, animatedProps, {
	      ref: refFn
	    }));
	  });
	  return AnimatedComponent;
	};
	
	var active = false;
	var controllers = new Set();
	
	var update = function update() {
	  if (!active) return false;
	  var time = now();
	
	  for (var _iterator = controllers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref;
	
	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }
	
	    var controller = _ref;
	    var isActive = false;
	
	    for (var configIdx = 0; configIdx < controller.configs.length; configIdx++) {
	      var config = controller.configs[configIdx];
	      var endOfAnimation = void 0,
	          lastTime = void 0;
	
	      for (var valIdx = 0; valIdx < config.animatedValues.length; valIdx++) {
	        var animation = config.animatedValues[valIdx]; // If an animation is done, skip, until all of them conclude
	
	        if (animation.done) continue;
	        var from = config.fromValues[valIdx];
	        var to = config.toValues[valIdx];
	        var position = animation.lastPosition;
	        var isAnimated = to instanceof Animated;
	        var velocity = Array.isArray(config.initialVelocity) ? config.initialVelocity[valIdx] : config.initialVelocity;
	        if (isAnimated) to = to.getValue(); // Conclude animation if it's either immediate, or from-values match end-state
	
	        if (config.immediate) {
	          animation.setValue(to);
	          animation.done = true;
	          continue;
	        } // Break animation when string values are involved
	
	
	        if (typeof from === 'string' || typeof to === 'string') {
	          animation.setValue(to);
	          animation.done = true;
	          continue;
	        }
	
	        if (config.duration !== void 0) {
	          /** Duration easing */
	          position = from + config.easing((time - animation.startTime) / config.duration) * (to - from);
	          endOfAnimation = time >= animation.startTime + config.duration;
	        } else if (config.decay) {
	          /** Decay easing */
	          position = from + velocity / (1 - 0.998) * (1 - Math.exp(-(1 - 0.998) * (time - animation.startTime)));
	          endOfAnimation = Math.abs(animation.lastPosition - position) < 0.1;
	          if (endOfAnimation) to = position;
	        } else {
	          /** Spring easing */
	          lastTime = animation.lastTime !== void 0 ? animation.lastTime : time;
	          velocity = animation.lastVelocity !== void 0 ? animation.lastVelocity : config.initialVelocity; // If we lost a lot of frames just jump to the end.
	
	          if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/
	
	          var numSteps = Math.floor(time - lastTime);
	
	          for (var i = 0; i < numSteps; ++i) {
	            var force = -config.tension * (position - to);
	            var damping = -config.friction * velocity;
	            var acceleration = (force + damping) / config.mass;
	            velocity = velocity + acceleration * 1 / 1000;
	            position = position + velocity * 1 / 1000;
	          } // Conditions for stopping the spring animation
	
	
	          var isOvershooting = config.clamp && config.tension !== 0 ? from < to ? position > to : position < to : false;
	          var isVelocity = Math.abs(velocity) <= config.precision;
	          var isDisplacement = config.tension !== 0 ? Math.abs(to - position) <= config.precision : true;
	          endOfAnimation = isOvershooting || isVelocity && isDisplacement;
	          animation.lastVelocity = velocity;
	          animation.lastTime = time;
	        } // Trails aren't done until their parents conclude
	
	
	        if (isAnimated && !config.toValues[valIdx].done) endOfAnimation = false;
	
	        if (endOfAnimation) {
	          // Ensure that we end up with a round value
	          if (animation.value !== to) position = to;
	          animation.done = true;
	        } else isActive = true;
	
	        animation.setValue(position);
	        animation.lastPosition = position;
	      } // Keep track of updated values only when necessary
	
	
	      if (controller.props.onFrame) controller.values[config.name] = config.interpolation.getValue();
	    } // Update callbacks in the end of the frame
	
	
	    if (controller.props.onFrame) controller.props.onFrame(controller.values); // Either call onEnd or next frame
	
	    if (!isActive) {
	      controllers.delete(controller);
	      controller.stop(true);
	    }
	  } // Loop over as long as there are controllers ...
	
	
	  if (controllers.size) {
	    if (manualFrameloop) manualFrameloop();else requestFrame(update);
	  } else {
	    active = false;
	  }
	
	  return active;
	};
	
	var start = function start(controller) {
	  if (!controllers.has(controller)) controllers.add(controller);
	
	  if (!active) {
	    active = true;
	    if (manualFrameloop) requestFrame(manualFrameloop);else requestFrame(update);
	  }
	};
	
	var stop = function stop(controller) {
	  if (controllers.has(controller)) controllers.delete(controller);
	};
	
	function createInterpolator(range, output, extrapolate) {
	  if (typeof range === 'function') {
	    return range;
	  }
	
	  if (Array.isArray(range)) {
	    return createInterpolator({
	      range: range,
	      output: output,
	      extrapolate: extrapolate
	    });
	  }
	
	  if (interpolation && typeof range.output[0] === 'string') {
	    return interpolation(range);
	  }
	
	  var config = range;
	  var outputRange = config.output;
	  var inputRange = config.range || [0, 1];
	  var extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
	  var extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';
	
	  var easing = config.easing || function (t) {
	    return t;
	  };
	
	  return function (input) {
	    var range = findRange(input, inputRange);
	    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
	  };
	}
	
	function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
	  var result = map ? map(input) : input; // Extrapolate
	
	  if (result < inputMin) {
	    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
	  }
	
	  if (result > inputMax) {
	    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
	  }
	
	  if (outputMin === outputMax) return outputMin;
	  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range
	
	  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin); // Easing
	
	  result = easing(result); // Output Range
	
	  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
	  return result;
	}
	
	function findRange(input, inputRange) {
	  for (var i = 1; i < inputRange.length - 1; ++i) {
	    if (inputRange[i] >= input) break;
	  }
	
	  return i - 1;
	}
	
	var AnimatedInterpolation =
	/*#__PURE__*/
	function (_AnimatedArray) {
	  _inheritsLoose(AnimatedInterpolation, _AnimatedArray);
	
	  function AnimatedInterpolation(parents, range, output, extrapolate) {
	    var _this;
	
	    _this = _AnimatedArray.call(this) || this;
	    _this.calc = void 0;
	    _this.payload = parents instanceof AnimatedArray && !(parents instanceof AnimatedInterpolation) ? parents.getPayload() : Array.isArray(parents) ? parents : [parents];
	    _this.calc = createInterpolator(range, output, extrapolate);
	    return _this;
	  }
	
	  var _proto = AnimatedInterpolation.prototype;
	
	  _proto.getValue = function getValue() {
	    return this.calc.apply(this, this.payload.map(function (value) {
	      return value.getValue();
	    }));
	  };
	
	  _proto.updateConfig = function updateConfig(range, output, extrapolate) {
	    this.calc = createInterpolator(range, output, extrapolate);
	  };
	
	  _proto.interpolate = function interpolate(range, output, extrapolate) {
	    return new AnimatedInterpolation(this, range, output, extrapolate);
	  };
	
	  return AnimatedInterpolation;
	}(AnimatedArray);
	
	var interpolate$1 = function interpolate(parents, range, output) {
	  return parents && new AnimatedInterpolation(parents, range, output);
	};
	
	var config = {
	  default: {
	    tension: 170,
	    friction: 26
	  },
	  gentle: {
	    tension: 120,
	    friction: 14
	  },
	  wobbly: {
	    tension: 180,
	    friction: 12
	  },
	  stiff: {
	    tension: 210,
	    friction: 20
	  },
	  slow: {
	    tension: 280,
	    friction: 60
	  },
	  molasses: {
	    tension: 280,
	    friction: 120
	  }
	};
	
	/** API
	 *  useChain(references, timeSteps, timeFrame)
	 */
	
	function useChain(refs, timeSteps, timeFrame) {
	  if (timeFrame === void 0) {
	    timeFrame = 1000;
	  }
	
	  var previous = React.useRef();
	  React.useEffect(function () {
	    if (is.equ(refs, previous.current)) refs.forEach(function (_ref) {
	      var current = _ref.current;
	      return current && current.start();
	    });else if (timeSteps) {
	      refs.forEach(function (_ref2, index) {
	        var current = _ref2.current;
	
	        if (current) {
	          var ctrls = current.controllers;
	
	          if (ctrls.length) {
	            var t = timeFrame * timeSteps[index];
	            ctrls.forEach(function (ctrl) {
	              ctrl.queue = ctrl.queue.map(function (e) {
	                return _extends({}, e, {
	                  delay: e.delay + t
	                });
	              });
	              ctrl.start();
	            });
	          }
	        }
	      });
	    } else refs.reduce(function (q, _ref3, rI) {
	      var current = _ref3.current;
	      return q = q.then(function () {
	        return current.start();
	      });
	    }, Promise.resolve());
	    previous.current = refs;
	  });
	}
	
	/**
	 * Animated works by building a directed acyclic graph of dependencies
	 * transparently when you render your Animated components.
	 *
	 *               new Animated.Value(0)
	 *     .interpolate()        .interpolate()    new Animated.Value(1)
	 *         opacity               translateY      scale
	 *          style                         transform
	 *         View#234                         style
	 *                                         View#123
	 *
	 * A) Top Down phase
	 * When an AnimatedValue is updated, we recursively go down through this
	 * graph in order to find leaf nodes: the views that we flag as needing
	 * an update.
	 *
	 * B) Bottom Up phase
	 * When a view is flagged as needing an update, we recursively go back up
	 * in order to build the new value that it needs. The reason why we need
	 * this two-phases process is to deal with composite props such as
	 * transform which can receive values from multiple parents.
	 */
	function addAnimatedStyles(node, styles) {
	  if ('update' in node) {
	    styles.add(node);
	  } else {
	    node.getChildren().forEach(function (child) {
	      return addAnimatedStyles(child, styles);
	    });
	  }
	}
	
	var AnimatedValue =
	/*#__PURE__*/
	function (_Animated) {
	  _inheritsLoose(AnimatedValue, _Animated);
	
	  function AnimatedValue(_value) {
	    var _this;
	
	    _this = _Animated.call(this) || this;
	    _this.animatedStyles = new Set();
	    _this.value = void 0;
	    _this.startPosition = void 0;
	    _this.lastPosition = void 0;
	    _this.lastVelocity = void 0;
	    _this.startTime = void 0;
	    _this.lastTime = void 0;
	    _this.done = false;
	
	    _this.setValue = function (value, flush) {
	      if (flush === void 0) {
	        flush = true;
	      }
	
	      _this.value = value;
	      if (flush) _this.flush();
	    };
	
	    _this.value = _value;
	    _this.startPosition = _value;
	    _this.lastPosition = _value;
	    return _this;
	  }
	
	  var _proto = AnimatedValue.prototype;
	
	  _proto.flush = function flush() {
	    if (this.animatedStyles.size === 0) {
	      addAnimatedStyles(this, this.animatedStyles);
	    }
	
	    this.animatedStyles.forEach(function (animatedStyle) {
	      return animatedStyle.update();
	    });
	  };
	
	  _proto.clearStyles = function clearStyles() {
	    this.animatedStyles.clear();
	  };
	
	  _proto.getValue = function getValue() {
	    return this.value;
	  };
	
	  _proto.interpolate = function interpolate(range, output, extrapolate) {
	    return new AnimatedInterpolation(this, range, output, extrapolate);
	  };
	
	  return AnimatedValue;
	}(Animated);
	
	var AnimatedValueArray =
	/*#__PURE__*/
	function (_AnimatedArray) {
	  _inheritsLoose(AnimatedValueArray, _AnimatedArray);
	
	  function AnimatedValueArray(values) {
	    var _this;
	
	    _this = _AnimatedArray.call(this) || this;
	    _this.payload = values.map(function (n) {
	      return new AnimatedValue(n);
	    });
	    return _this;
	  }
	
	  var _proto = AnimatedValueArray.prototype;
	
	  _proto.setValue = function setValue(value, flush) {
	    var _this2 = this;
	
	    if (flush === void 0) {
	      flush = true;
	    }
	
	    if (Array.isArray(value)) {
	      if (value.length === this.payload.length) {
	        value.forEach(function (v, i) {
	          return _this2.payload[i].setValue(v, flush);
	        });
	      }
	    } else {
	      this.payload.forEach(function (p) {
	        return p.setValue(value, flush);
	      });
	    }
	  };
	
	  _proto.getValue = function getValue() {
	    return this.payload.map(function (v) {
	      return v.getValue();
	    });
	  };
	
	  _proto.interpolate = function interpolate(range, output) {
	    return new AnimatedInterpolation(this, range, output);
	  };
	
	  return AnimatedValueArray;
	}(AnimatedArray);
	
	var G = 0;
	
	var Controller =
	/*#__PURE__*/
	function () {
	  function Controller() {
	    var _this = this;
	
	    this.id = void 0;
	    this.idle = true;
	    this.hasChanged = false;
	    this.guid = 0;
	    this.local = 0;
	    this.props = {};
	    this.merged = {};
	    this.animations = {};
	    this.interpolations = {};
	    this.values = {};
	    this.configs = [];
	    this.listeners = [];
	    this.queue = [];
	    this.localQueue = void 0;
	
	    this.getValues = function () {
	      return _this.interpolations;
	    };
	
	    this.id = G++;
	  }
	  /** update(props)
	   *  This function filters input props and creates an array of tasks which are executed in .start()
	   *  Each task is allowed to carry a delay, which means it can execute asnychroneously */
	
	
	  var _proto = Controller.prototype;
	
	  _proto.update = function update$$1(args) {
	    //this._id = n + this.id
	    if (!args) return this; // Extract delay and the to-prop from props
	
	    var _ref = interpolateTo(args),
	        _ref$delay = _ref.delay,
	        delay = _ref$delay === void 0 ? 0 : _ref$delay,
	        to = _ref.to,
	        props = _objectWithoutPropertiesLoose(_ref, ["delay", "to"]);
	
	    if (is.arr(to) || is.fun(to)) {
	      // If config is either a function or an array queue it up as is
	      this.queue.push(_extends({}, props, {
	        delay: delay,
	        to: to
	      }));
	    } else if (to) {
	      // Otherwise go through each key since it could be delayed individually
	      var ops = {};
	      Object.entries(to).forEach(function (_ref2) {
	        var _to;
	
	        var k = _ref2[0],
	            v = _ref2[1];
	
	        // Fetch delay and create an entry, consisting of the to-props, the delay, and basic props
	        var entry = _extends({
	          to: (_to = {}, _to[k] = v, _to),
	          delay: callProp(delay, k)
	        }, props);
	
	        var previous = ops[entry.delay] && ops[entry.delay].to;
	        ops[entry.delay] = _extends({}, ops[entry.delay], entry, {
	          to: _extends({}, previous, entry.to)
	        });
	      });
	      this.queue = Object.values(ops);
	    } // Sort queue, so that async calls go last
	
	
	    this.queue = this.queue.sort(function (a, b) {
	      return a.delay - b.delay;
	    }); // Diff the reduced props immediately (they'll contain the from-prop and some config)
	
	    this.diff(props);
	    return this;
	  }
	  /** start(onEnd)
	   *  This function either executes a queue, if present, or starts the frameloop, which animates */
	  ;
	
	  _proto.start = function start$$1(onEnd) {
	    var _this2 = this;
	
	    // If a queue is present we must excecute it
	    if (this.queue.length) {
	      this.idle = false; // Updates can interrupt trailing queues, in that case we just merge values
	
	      if (this.localQueue) {
	        this.localQueue.forEach(function (_ref3) {
	          var _ref3$from = _ref3.from,
	              from = _ref3$from === void 0 ? {} : _ref3$from,
	              _ref3$to = _ref3.to,
	              to = _ref3$to === void 0 ? {} : _ref3$to;
	          if (is.obj(from)) _this2.merged = _extends({}, from, _this2.merged);
	          if (is.obj(to)) _this2.merged = _extends({}, _this2.merged, to);
	        });
	      } // The guid helps us tracking frames, a new queue over an old one means an override
	      // We discard async calls in that caseÍ
	
	
	      var local = this.local = ++this.guid;
	      var queue = this.localQueue = this.queue;
	      this.queue = []; // Go through each entry and execute it
	
	      queue.forEach(function (_ref4, index) {
	        var delay = _ref4.delay,
	            props = _objectWithoutPropertiesLoose(_ref4, ["delay"]);
	
	        var cb = function cb(finished) {
	          if (index === queue.length - 1 && local === _this2.guid && finished) {
	            _this2.idle = true;
	            if (_this2.props.onRest) _this2.props.onRest(_this2.merged);
	          }
	
	          if (onEnd) onEnd();
	        }; // Entries can be delayed, ansyc or immediate
	
	
	        var async = is.arr(props.to) || is.fun(props.to);
	
	        if (delay) {
	          setTimeout(function () {
	            if (local === _this2.guid) {
	              if (async) _this2.runAsync(props, cb);else _this2.diff(props).start(cb);
	            }
	          }, delay);
	        } else if (async) _this2.runAsync(props, cb);else _this2.diff(props).start(cb);
	      });
	    } // Otherwise we kick of the frameloop
	    else {
	        if (is.fun(onEnd)) this.listeners.push(onEnd);
	        if (this.props.onStart) this.props.onStart();
	
	        start(this);
	      }
	
	    return this;
	  };
	
	  _proto.stop = function stop$$1(finished) {
	    this.listeners.forEach(function (onEnd) {
	      return onEnd(finished);
	    });
	    this.listeners = [];
	    return this;
	  }
	  /** Pause sets onEnd listeners free, but also removes the controller from the frameloop */
	  ;
	
	  _proto.pause = function pause(finished) {
	    this.stop(true);
	    if (finished) stop(this);
	    return this;
	  };
	
	  _proto.runAsync = function runAsync(_ref5, onEnd) {
	    var _this3 = this;
	
	    var delay = _ref5.delay,
	        props = _objectWithoutPropertiesLoose(_ref5, ["delay"]);
	
	    var local = this.local; // If "to" is either a function or an array it will be processed async, therefor "to" should be empty right now
	    // If the view relies on certain values "from" has to be present
	
	    var queue = Promise.resolve(undefined);
	
	    if (is.arr(props.to)) {
	      var _loop = function _loop(i) {
	        var index = i;
	
	        var fresh = _extends({}, props, interpolateTo(props.to[index]));
	
	        if (is.arr(fresh.config)) fresh.config = fresh.config[index];
	        queue = queue.then(function () {
	          //this.stop()
	          if (local === _this3.guid) return new Promise(function (r) {
	            return _this3.diff(fresh).start(r);
	          });
	        });
	      };
	
	      for (var i = 0; i < props.to.length; i++) {
	        _loop(i);
	      }
	    } else if (is.fun(props.to)) {
	      var index = 0;
	      var last;
	      queue = queue.then(function () {
	        return props.to( // next(props)
	        function (p) {
	          var fresh = _extends({}, props, interpolateTo(p));
	
	          if (is.arr(fresh.config)) fresh.config = fresh.config[index];
	          index++; //this.stop()
	
	          if (local === _this3.guid) return last = new Promise(function (r) {
	            return _this3.diff(fresh).start(r);
	          });
	          return;
	        }, // cancel()
	        function (finished) {
	          if (finished === void 0) {
	            finished = true;
	          }
	
	          return _this3.stop(finished);
	        }).then(function () {
	          return last;
	        });
	      });
	    }
	
	    queue.then(onEnd);
	  };
	
	  _proto.diff = function diff(props) {
	    var _this4 = this;
	
	    this.props = _extends({}, this.props, props);
	    var _this$props = this.props,
	        _this$props$from = _this$props.from,
	        from = _this$props$from === void 0 ? {} : _this$props$from,
	        _this$props$to = _this$props.to,
	        to = _this$props$to === void 0 ? {} : _this$props$to,
	        _this$props$config = _this$props.config,
	        config = _this$props$config === void 0 ? {} : _this$props$config,
	        reverse = _this$props.reverse,
	        attach = _this$props.attach,
	        reset = _this$props.reset,
	        immediate = _this$props.immediate; // Reverse values when requested
	
	    if (reverse) {
	      var _ref6 = [to, from];
	      from = _ref6[0];
	      to = _ref6[1];
	    } // This will collect all props that were ever set, reset merged props when necessary
	
	
	    this.merged = _extends({}, from, this.merged, to);
	    this.hasChanged = false; // Attachment handling, trailed springs can "attach" themselves to a previous spring
	
	    var target = attach && attach(this); // Reduces input { name: value } pairs into animated values
	
	    this.animations = Object.entries(this.merged).reduce(function (acc, _ref7) {
	      var name = _ref7[0],
	          value = _ref7[1];
	      // Issue cached entries, except on reset
	      var entry = acc[name] || {}; // Figure out what the value is supposed to be
	
	      var isNumber = is.num(value);
	      var isString = is.str(value) && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
	      var isArray = is.arr(value);
	      var isInterpolation = !isNumber && !isArray && !isString;
	      var fromValue = !is.und(from[name]) ? from[name] : value;
	      var toValue = isNumber || isArray ? value : isString ? value : 1;
	      var toConfig = callProp(config, name);
	      if (target) toValue = target.animations[name].parent;
	      var parent = entry.parent,
	          interpolation$$1 = entry.interpolation,
	          toValues = toArray(target ? toValue.getPayload() : toValue),
	          animatedValues;
	      var newValue = value;
	      if (isInterpolation) newValue = interpolation({
	        range: [0, 1],
	        output: [value, value]
	      })(1);
	      var currentValue = interpolation$$1 && interpolation$$1.getValue(); // Change detection flags
	
	      var isFirst = is.und(parent);
	      var isActive = !isFirst && entry.animatedValues.some(function (v) {
	        return !v.done;
	      });
	      var currentValueDiffersFromGoal = !is.equ(newValue, currentValue);
	      var hasNewGoal = !is.equ(newValue, entry.previous);
	      var hasNewConfig = !is.equ(toConfig, entry.config); // Change animation props when props indicate a new goal (new value differs from previous one)
	      // and current values differ from it. Config changes trigger a new update as well (though probably shouldn't?)
	
	      if (reset || hasNewGoal && currentValueDiffersFromGoal || hasNewConfig) {
	        var _extends2;
	
	        // Convert regular values into animated values, ALWAYS re-use if possible
	        if (isNumber || isString) parent = interpolation$$1 = entry.parent || new AnimatedValue(fromValue);else if (isArray) parent = interpolation$$1 = entry.parent || new AnimatedValueArray(fromValue);else if (isInterpolation) {
	          var prev = entry.interpolation && entry.interpolation.calc(entry.parent.value);
	          prev = prev !== void 0 && !reset ? prev : fromValue;
	
	          if (entry.parent) {
	            parent = entry.parent;
	            parent.setValue(0, false);
	          } else parent = new AnimatedValue(0);
	
	          var range = {
	            output: [prev, value]
	          };
	
	          if (entry.interpolation) {
	            interpolation$$1 = entry.interpolation;
	            entry.interpolation.updateConfig(range);
	          } else interpolation$$1 = parent.interpolate(range);
	        }
	        toValues = toArray(target ? toValue.getPayload() : toValue);
	        animatedValues = toArray(parent.getPayload());
	        if (reset && !isInterpolation) parent.setValue(fromValue, false);
	        _this4.hasChanged = true; // Reset animated values
	
	        animatedValues.forEach(function (value) {
	          value.startPosition = value.value;
	          value.lastPosition = value.value;
	          value.lastVelocity = isActive ? value.lastVelocity : undefined;
	          value.lastTime = isActive ? value.lastTime : undefined;
	          value.startTime = now();
	          value.done = false;
	          value.animatedStyles.clear();
	        }); // Set immediate values
	
	        if (callProp(immediate, name)) {
	          parent.setValue(isInterpolation ? toValue : value, false);
	        }
	
	        return _extends({}, acc, (_extends2 = {}, _extends2[name] = _extends({}, entry, {
	          name: name,
	          parent: parent,
	          interpolation: interpolation$$1,
	          animatedValues: animatedValues,
	          toValues: toValues,
	          previous: newValue,
	          config: toConfig,
	          fromValues: toArray(parent.getValue()),
	          immediate: callProp(immediate, name),
	          initialVelocity: withDefault(toConfig.velocity, 0),
	          clamp: withDefault(toConfig.clamp, false),
	          precision: withDefault(toConfig.precision, 0.01),
	          tension: withDefault(toConfig.tension, 170),
	          friction: withDefault(toConfig.friction, 26),
	          mass: withDefault(toConfig.mass, 1),
	          duration: toConfig.duration,
	          easing: withDefault(toConfig.easing, function (t) {
	            return t;
	          }),
	          decay: toConfig.decay
	        }), _extends2));
	      } else {
	        if (!currentValueDiffersFromGoal) {
	          var _extends3;
	
	          // So ... the current target value (newValue) appears to be different from the previous value,
	          // which normally constitutes an update, but the actual value (currentValue) matches the target!
	          // In order to resolve this without causing an animation update we silently flag the animation as done,
	          // which it technically is. Interpolations also needs a config update with their target set to 1.
	          if (isInterpolation) {
	            parent.setValue(1, false);
	            interpolation$$1.updateConfig({
	              output: [newValue, newValue]
	            });
	          }
	
	          parent.done = true;
	          _this4.hasChanged = true;
	          return _extends({}, acc, (_extends3 = {}, _extends3[name] = _extends({}, acc[name], {
	            previous: newValue
	          }), _extends3));
	        }
	
	        return acc;
	      }
	    }, this.animations);
	
	    if (this.hasChanged) {
	      // Make animations available to frameloop
	      this.configs = Object.values(this.animations);
	      this.values = {};
	      this.interpolations = {};
	
	      for (var key in this.animations) {
	        this.interpolations[key] = this.animations[key].interpolation;
	        this.values[key] = this.animations[key].interpolation.getValue();
	      }
	    }
	
	    return this;
	  };
	
	  _proto.destroy = function destroy() {
	    this.stop();
	    this.props = {};
	    this.merged = {};
	    this.animations = {};
	    this.interpolations = {};
	    this.values = {};
	    this.configs = [];
	    this.local = 0;
	  };
	
	  return Controller;
	}();
	
	/** API
	 * const props = useSprings(number, [{ ... }, { ... }, ...])
	 * const [props, set] = useSprings(number, (i, controller) => ({ ... }))
	 */
	
	var useSprings = function useSprings(length, props) {
	  var mounted = React.useRef(false);
	  var ctrl = React.useRef();
	  var isFn = is.fun(props); // The controller maintains the animation values, starts and stops animations
	
	  var _useMemo = React.useMemo(function () {
	    // Remove old controllers
	    if (ctrl.current) {
	      ctrl.current.map(function (c) {
	        return c.destroy();
	      });
	      ctrl.current = undefined;
	    }
	
	    var ref;
	    return [new Array(length).fill().map(function (_, i) {
	      var ctrl = new Controller();
	      var newProps = isFn ? callProp(props, i, ctrl) : props[i];
	      if (i === 0) ref = newProps.ref;
	      ctrl.update(newProps);
	      if (!ref) ctrl.start();
	      return ctrl;
	    }), ref];
	  }, [length]),
	      controllers = _useMemo[0],
	      ref = _useMemo[1];
	
	  ctrl.current = controllers; // The hooks reference api gets defined here ...
	
	  var api = React.useImperativeHandle(ref, function () {
	    return {
	      start: function start() {
	        return Promise.all(ctrl.current.map(function (c) {
	          return new Promise(function (r) {
	            return c.start(r);
	          });
	        }));
	      },
	      stop: function stop(finished) {
	        return ctrl.current.forEach(function (c) {
	          return c.stop(finished);
	        });
	      },
	
	      get controllers() {
	        return ctrl.current;
	      }
	
	    };
	  }); // This function updates the controllers
	
	  var updateCtrl = React.useMemo(function () {
	    return function (updateProps) {
	      return ctrl.current.map(function (c, i) {
	        c.update(isFn ? callProp(updateProps, i, c) : updateProps[i]);
	        if (!ref) c.start();
	      });
	    };
	  }, [length]); // Update controller if props aren't functional
	
	  React.useEffect(function () {
	    if (mounted.current) {
	      if (!isFn) updateCtrl(props);
	    } else if (!ref) ctrl.current.forEach(function (c) {
	      return c.start();
	    });
	  }); // Update mounted flag and destroy controller on unmount
	
	  React.useEffect(function () {
	    return mounted.current = true, function () {
	      return ctrl.current.forEach(function (c) {
	        return c.destroy();
	      });
	    };
	  }, []); // Return animated props, or, anim-props + the update-setter above
	
	  var propValues = ctrl.current.map(function (c) {
	    return c.getValues();
	  });
	  return isFn ? [propValues, updateCtrl, function (finished) {
	    return ctrl.current.forEach(function (c) {
	      return c.pause(finished);
	    });
	  }] : propValues;
	};
	
	/** API
	 * const props = useSpring({ ... })
	 * const [props, set] = useSpring(() => ({ ... }))
	 */
	
	var useSpring = function useSpring(props) {
	  var isFn = is.fun(props);
	
	  var _useSprings = useSprings(1, isFn ? props : [props]),
	      result = _useSprings[0],
	      set = _useSprings[1],
	      pause = _useSprings[2];
	
	  return isFn ? [result[0], set, pause] : result;
	};
	
	/** API
	 * const trails = useTrail(number, { ... })
	 * const [trails, set] = useTrail(number, () => ({ ... }))
	 */
	
	var useTrail = function useTrail(length, props) {
	  var mounted = React.useRef(false);
	  var isFn = is.fun(props);
	  var updateProps = callProp(props);
	  var instances = React.useRef();
	
	  var _useSprings = useSprings(length, function (i, ctrl) {
	    if (i === 0) instances.current = [];
	    instances.current.push(ctrl);
	    return _extends({}, updateProps, {
	      config: callProp(updateProps.config, i),
	      attach: i > 0 && function () {
	        return instances.current[i - 1];
	      }
	    });
	  }),
	      result = _useSprings[0],
	      set = _useSprings[1],
	      pause = _useSprings[2]; // Set up function to update controller
	
	
	  var updateCtrl = React.useMemo(function () {
	    return function (props) {
	      return set(function (i, ctrl) {
	        var last = props.reverse ? i === 0 : length - 1 === i;
	        var attachIdx = props.reverse ? i + 1 : i - 1;
	        var attachController = instances.current[attachIdx];
	        return _extends({}, props, {
	          config: callProp(props.config || updateProps.config, i),
	          attach: attachController && function () {
	            return attachController;
	          }
	        });
	      });
	    };
	  }, [length, updateProps.reverse]); // Update controller if props aren't functional
	
	  React.useEffect(function () {
	    return void (mounted.current && !isFn && updateCtrl(props));
	  }); // Update mounted flag and destroy controller on unmount
	
	  React.useEffect(function () {
	    return void (mounted.current = true);
	  }, []);
	  return isFn ? [result, updateCtrl, pause] : result;
	};
	
	/** API
	 * const transitions = useTransition(items, itemKeys, { ... })
	 * const [transitions, update] = useTransition(items, itemKeys, () => ({ ... }))
	 */
	
	var guid = 0;
	var ENTER = 'enter';
	var LEAVE = 'leave';
	var UPDATE = 'update';
	
	var mapKeys = function mapKeys(items, keys) {
	  return (typeof keys === 'function' ? items.map(keys) : toArray(keys)).map(String);
	};
	
	var get = function get(props) {
	  var items = props.items,
	      _props$keys = props.keys,
	      keys = _props$keys === void 0 ? function (item) {
	    return item;
	  } : _props$keys,
	      rest = _objectWithoutPropertiesLoose(props, ["items", "keys"]);
	
	  items = toArray(items !== void 0 ? items : null);
	  return _extends({
	    items: items,
	    keys: mapKeys(items, keys)
	  }, rest);
	};
	
	function useTransition(input, keyTransform, config) {
	  var props = _extends({
	    items: input,
	    keys: keyTransform || function (i) {
	      return i;
	    }
	  }, config);
	
	  var _get = get(props),
	      _get$lazy = _get.lazy,
	      lazy = _get$lazy === void 0 ? false : _get$lazy,
	      _get$unique = _get.unique,
	      _get$reset = _get.reset,
	      reset = _get$reset === void 0 ? false : _get$reset,
	      enter = _get.enter,
	      leave = _get.leave,
	      update = _get.update,
	      onDestroyed = _get.onDestroyed,
	      keys = _get.keys,
	      items = _get.items,
	      onFrame = _get.onFrame,
	      _onRest = _get.onRest,
	      onStart = _get.onStart,
	      ref = _get.ref,
	      extra = _objectWithoutPropertiesLoose(_get, ["lazy", "unique", "reset", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "ref"]);
	
	  var forceUpdate = useForceUpdate();
	  var mounted = React.useRef(false);
	  var state = React.useRef({
	    mounted: false,
	    first: true,
	    deleted: [],
	    current: {},
	    transitions: [],
	    prevProps: {},
	    paused: !!props.ref,
	    instances: !mounted.current && new Map(),
	    forceUpdate: forceUpdate
	  });
	  React.useImperativeHandle(props.ref, function () {
	    return {
	      start: function start() {
	        return Promise.all(Array.from(state.current.instances).map(function (_ref) {
	          var c = _ref[1];
	          return new Promise(function (r) {
	            return c.start(r);
	          });
	        }));
	      },
	      stop: function stop(finished) {
	        return Array.from(state.current.instances).forEach(function (_ref2) {
	          var c = _ref2[1];
	          return c.stop(finished);
	        });
	      },
	
	      get controllers() {
	        return Array.from(state.current.instances).map(function (_ref3) {
	          var c = _ref3[1];
	          return c;
	        });
	      }
	
	    };
	  }); // Update state
	
	  state.current = diffItems(state.current, props);
	
	  if (state.current.changed) {
	    // Update state
	    state.current.transitions.forEach(function (transition) {
	      var slot = transition.slot,
	          from = transition.from,
	          to = transition.to,
	          config = transition.config,
	          trail = transition.trail,
	          key = transition.key,
	          item = transition.item;
	      if (!state.current.instances.has(key)) state.current.instances.set(key, new Controller()); // update the map object
	
	      var ctrl = state.current.instances.get(key);
	
	      var newProps = _extends({}, extra, {
	        to: to,
	        from: from,
	        config: config,
	        ref: ref,
	        onRest: function onRest(values) {
	          if (state.current.mounted) {
	            if (transition.destroyed) {
	              // If no ref is given delete destroyed items immediately
	              if (!ref && !lazy) cleanUp(state, key);
	              if (onDestroyed) onDestroyed(item);
	            } // A transition comes to rest once all its springs conclude
	
	
	            var curInstances = Array.from(state.current.instances);
	            var active = curInstances.some(function (_ref4) {
	              var c = _ref4[1];
	              return !c.idle;
	            });
	            if (!active && (ref || lazy) && state.current.deleted.length > 0) cleanUp(state);
	            if (_onRest) _onRest(item, slot, values);
	          }
	        },
	        onStart: onStart && function () {
	          return onStart(item, slot);
	        },
	        onFrame: onFrame && function (values) {
	          return onFrame(item, slot, values);
	        },
	        delay: trail,
	        reset: reset && slot === ENTER // Update controller
	
	      });
	
	      ctrl.update(newProps);
	      if (!state.current.paused) ctrl.start();
	    });
	  }
	
	  React.useEffect(function () {
	    state.current.mounted = mounted.current = true;
	    return function () {
	      state.current.mounted = mounted.current = false;
	      Array.from(state.current.instances).map(function (_ref5) {
	        var c = _ref5[1];
	        return c.destroy();
	      });
	      state.current.instances.clear();
	    };
	  }, []);
	  return state.current.transitions.map(function (_ref6) {
	    var item = _ref6.item,
	        slot = _ref6.slot,
	        key = _ref6.key;
	    return {
	      item: item,
	      key: key,
	      state: slot,
	      props: state.current.instances.get(key).getValues()
	    };
	  });
	}
	
	function cleanUp(state, filterKey) {
	  var deleted = state.current.deleted;
	
	  var _loop = function _loop() {
	    if (_isArray) {
	      if (_i >= _iterator.length) return "break";
	      _ref8 = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) return "break";
	      _ref8 = _i.value;
	    }
	
	    var _ref7 = _ref8;
	    var key = _ref7.key;
	
	    var filter = function filter(t) {
	      return t.key !== key;
	    };
	
	    if (is.und(filterKey) || filterKey === key) {
	      state.current.instances.delete(key);
	      state.current.transitions = state.current.transitions.filter(filter);
	      state.current.deleted = state.current.deleted.filter(filter);
	    }
	  };
	
	  for (var _iterator = deleted, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	    var _ref8;
	
	    var _ret = _loop();
	
	    if (_ret === "break") break;
	  }
	
	  state.current.forceUpdate();
	}
	
	function diffItems(_ref9, props) {
	  var first = _ref9.first,
	      prevProps = _ref9.prevProps,
	      state = _objectWithoutPropertiesLoose(_ref9, ["first", "prevProps"]);
	
	  var _get2 = get(props),
	      items = _get2.items,
	      keys = _get2.keys,
	      initial = _get2.initial,
	      from = _get2.from,
	      enter = _get2.enter,
	      leave = _get2.leave,
	      update = _get2.update,
	      _get2$trail = _get2.trail,
	      trail = _get2$trail === void 0 ? 0 : _get2$trail,
	      unique = _get2.unique,
	      config = _get2.config,
	      _get2$order = _get2.order,
	      order = _get2$order === void 0 ? [ENTER, LEAVE, UPDATE] : _get2$order;
	
	  var _get3 = get(prevProps),
	      _keys = _get3.keys,
	      _items = _get3.items;
	
	  var current = _extends({}, state.current);
	
	  var deleted = [].concat(state.deleted); // Compare next keys with current keys
	
	  var currentKeys = Object.keys(current);
	  var currentSet = new Set(currentKeys);
	  var nextSet = new Set(keys);
	  var added = keys.filter(function (item) {
	    return !currentSet.has(item);
	  });
	  var removed = state.transitions.filter(function (item) {
	    return !item.destroyed && !nextSet.has(item.originalKey);
	  }).map(function (i) {
	    return i.originalKey;
	  });
	  var updated = keys.filter(function (item) {
	    return currentSet.has(item);
	  });
	  var delay = -trail;
	
	  while (order.length) {
	    var changeType = order.shift();
	
	    switch (changeType) {
	      case ENTER:
	        {
	          added.forEach(function (key, index) {
	            // In unique mode, remove fading out transitions if their key comes in again
	            if (unique && deleted.find(function (d) {
	              return d.originalKey === key;
	            })) deleted = deleted.filter(function (t) {
	              return t.originalKey !== key;
	            });
	            var keyIndex = keys.indexOf(key);
	            var item = items[keyIndex];
	            var slot = first && initial !== void 0 ? 'initial' : ENTER;
	            current[key] = {
	              slot: slot,
	              originalKey: key,
	              key: unique ? String(key) : guid++,
	              item: item,
	              trail: delay = delay + trail,
	              config: callProp(config, item, slot),
	              from: callProp(first ? initial !== void 0 ? initial || {} : from : from, item),
	              to: callProp(enter, item)
	            };
	          });
	          break;
	        }
	
	      case LEAVE:
	        {
	          removed.forEach(function (key) {
	            var keyIndex = _keys.indexOf(key);
	
	            var item = _items[keyIndex];
	            var slot = LEAVE;
	            deleted.unshift(_extends({}, current[key], {
	              slot: slot,
	              destroyed: true,
	              left: _keys[Math.max(0, keyIndex - 1)],
	              right: _keys[Math.min(_keys.length, keyIndex + 1)],
	              trail: delay = delay + trail,
	              config: callProp(config, item, slot),
	              to: callProp(leave, item)
	            }));
	            delete current[key];
	          });
	          break;
	        }
	
	      case UPDATE:
	        {
	          updated.forEach(function (key) {
	            var keyIndex = keys.indexOf(key);
	            var item = items[keyIndex];
	            var slot = UPDATE;
	            current[key] = _extends({}, current[key], {
	              item: item,
	              slot: slot,
	              trail: delay = delay + trail,
	              config: callProp(config, item, slot),
	              to: callProp(update, item)
	            });
	          });
	          break;
	        }
	    }
	  }
	
	  var out = keys.map(function (key) {
	    return current[key];
	  }); // This tries to restore order for deleted items by finding their last known siblings
	  // only using the left sibling to keep order placement consistent for all deleted items
	
	  deleted.forEach(function (_ref10) {
	    var left = _ref10.left,
	        right = _ref10.right,
	        item = _objectWithoutPropertiesLoose(_ref10, ["left", "right"]);
	
	    var pos; // Was it the element on the left, if yes, move there ...
	
	    if ((pos = out.findIndex(function (t) {
	      return t.originalKey === left;
	    })) !== -1) pos += 1; // And if nothing else helps, move it to the start ¯\_(ツ)_/¯
	
	    pos = Math.max(0, pos);
	    out = [].concat(out.slice(0, pos), [item], out.slice(pos));
	  });
	  return _extends({}, state, {
	    changed: added.length || removed.length || updated.length,
	    first: first && added.length === 0,
	    transitions: out,
	    current: current,
	    deleted: deleted,
	    prevProps: props
	  });
	}
	
	var AnimatedStyle =
	/*#__PURE__*/
	function (_AnimatedObject) {
	  _inheritsLoose(AnimatedStyle, _AnimatedObject);
	
	  function AnimatedStyle(style) {
	    var _this;
	
	    if (style === void 0) {
	      style = {};
	    }
	
	    _this = _AnimatedObject.call(this) || this;
	
	    if (style.transform && !(style.transform instanceof Animated)) {
	      style = applyAnimatedValues.transform(style);
	    }
	
	    _this.payload = style;
	    return _this;
	  }
	
	  return AnimatedStyle;
	}(AnimatedObject);
	
	// http://www.w3.org/TR/css3-color/#svg-color
	var colors = {
	  transparent: 0x00000000,
	  aliceblue: 0xf0f8ffff,
	  antiquewhite: 0xfaebd7ff,
	  aqua: 0x00ffffff,
	  aquamarine: 0x7fffd4ff,
	  azure: 0xf0ffffff,
	  beige: 0xf5f5dcff,
	  bisque: 0xffe4c4ff,
	  black: 0x000000ff,
	  blanchedalmond: 0xffebcdff,
	  blue: 0x0000ffff,
	  blueviolet: 0x8a2be2ff,
	  brown: 0xa52a2aff,
	  burlywood: 0xdeb887ff,
	  burntsienna: 0xea7e5dff,
	  cadetblue: 0x5f9ea0ff,
	  chartreuse: 0x7fff00ff,
	  chocolate: 0xd2691eff,
	  coral: 0xff7f50ff,
	  cornflowerblue: 0x6495edff,
	  cornsilk: 0xfff8dcff,
	  crimson: 0xdc143cff,
	  cyan: 0x00ffffff,
	  darkblue: 0x00008bff,
	  darkcyan: 0x008b8bff,
	  darkgoldenrod: 0xb8860bff,
	  darkgray: 0xa9a9a9ff,
	  darkgreen: 0x006400ff,
	  darkgrey: 0xa9a9a9ff,
	  darkkhaki: 0xbdb76bff,
	  darkmagenta: 0x8b008bff,
	  darkolivegreen: 0x556b2fff,
	  darkorange: 0xff8c00ff,
	  darkorchid: 0x9932ccff,
	  darkred: 0x8b0000ff,
	  darksalmon: 0xe9967aff,
	  darkseagreen: 0x8fbc8fff,
	  darkslateblue: 0x483d8bff,
	  darkslategray: 0x2f4f4fff,
	  darkslategrey: 0x2f4f4fff,
	  darkturquoise: 0x00ced1ff,
	  darkviolet: 0x9400d3ff,
	  deeppink: 0xff1493ff,
	  deepskyblue: 0x00bfffff,
	  dimgray: 0x696969ff,
	  dimgrey: 0x696969ff,
	  dodgerblue: 0x1e90ffff,
	  firebrick: 0xb22222ff,
	  floralwhite: 0xfffaf0ff,
	  forestgreen: 0x228b22ff,
	  fuchsia: 0xff00ffff,
	  gainsboro: 0xdcdcdcff,
	  ghostwhite: 0xf8f8ffff,
	  gold: 0xffd700ff,
	  goldenrod: 0xdaa520ff,
	  gray: 0x808080ff,
	  green: 0x008000ff,
	  greenyellow: 0xadff2fff,
	  grey: 0x808080ff,
	  honeydew: 0xf0fff0ff,
	  hotpink: 0xff69b4ff,
	  indianred: 0xcd5c5cff,
	  indigo: 0x4b0082ff,
	  ivory: 0xfffff0ff,
	  khaki: 0xf0e68cff,
	  lavender: 0xe6e6faff,
	  lavenderblush: 0xfff0f5ff,
	  lawngreen: 0x7cfc00ff,
	  lemonchiffon: 0xfffacdff,
	  lightblue: 0xadd8e6ff,
	  lightcoral: 0xf08080ff,
	  lightcyan: 0xe0ffffff,
	  lightgoldenrodyellow: 0xfafad2ff,
	  lightgray: 0xd3d3d3ff,
	  lightgreen: 0x90ee90ff,
	  lightgrey: 0xd3d3d3ff,
	  lightpink: 0xffb6c1ff,
	  lightsalmon: 0xffa07aff,
	  lightseagreen: 0x20b2aaff,
	  lightskyblue: 0x87cefaff,
	  lightslategray: 0x778899ff,
	  lightslategrey: 0x778899ff,
	  lightsteelblue: 0xb0c4deff,
	  lightyellow: 0xffffe0ff,
	  lime: 0x00ff00ff,
	  limegreen: 0x32cd32ff,
	  linen: 0xfaf0e6ff,
	  magenta: 0xff00ffff,
	  maroon: 0x800000ff,
	  mediumaquamarine: 0x66cdaaff,
	  mediumblue: 0x0000cdff,
	  mediumorchid: 0xba55d3ff,
	  mediumpurple: 0x9370dbff,
	  mediumseagreen: 0x3cb371ff,
	  mediumslateblue: 0x7b68eeff,
	  mediumspringgreen: 0x00fa9aff,
	  mediumturquoise: 0x48d1ccff,
	  mediumvioletred: 0xc71585ff,
	  midnightblue: 0x191970ff,
	  mintcream: 0xf5fffaff,
	  mistyrose: 0xffe4e1ff,
	  moccasin: 0xffe4b5ff,
	  navajowhite: 0xffdeadff,
	  navy: 0x000080ff,
	  oldlace: 0xfdf5e6ff,
	  olive: 0x808000ff,
	  olivedrab: 0x6b8e23ff,
	  orange: 0xffa500ff,
	  orangered: 0xff4500ff,
	  orchid: 0xda70d6ff,
	  palegoldenrod: 0xeee8aaff,
	  palegreen: 0x98fb98ff,
	  paleturquoise: 0xafeeeeff,
	  palevioletred: 0xdb7093ff,
	  papayawhip: 0xffefd5ff,
	  peachpuff: 0xffdab9ff,
	  peru: 0xcd853fff,
	  pink: 0xffc0cbff,
	  plum: 0xdda0ddff,
	  powderblue: 0xb0e0e6ff,
	  purple: 0x800080ff,
	  rebeccapurple: 0x663399ff,
	  red: 0xff0000ff,
	  rosybrown: 0xbc8f8fff,
	  royalblue: 0x4169e1ff,
	  saddlebrown: 0x8b4513ff,
	  salmon: 0xfa8072ff,
	  sandybrown: 0xf4a460ff,
	  seagreen: 0x2e8b57ff,
	  seashell: 0xfff5eeff,
	  sienna: 0xa0522dff,
	  silver: 0xc0c0c0ff,
	  skyblue: 0x87ceebff,
	  slateblue: 0x6a5acdff,
	  slategray: 0x708090ff,
	  slategrey: 0x708090ff,
	  snow: 0xfffafaff,
	  springgreen: 0x00ff7fff,
	  steelblue: 0x4682b4ff,
	  tan: 0xd2b48cff,
	  teal: 0x008080ff,
	  thistle: 0xd8bfd8ff,
	  tomato: 0xff6347ff,
	  turquoise: 0x40e0d0ff,
	  violet: 0xee82eeff,
	  wheat: 0xf5deb3ff,
	  white: 0xffffffff,
	  whitesmoke: 0xf5f5f5ff,
	  yellow: 0xffff00ff,
	  yellowgreen: 0x9acd32ff
	};
	
	// const INTEGER = '[-+]?\\d+';
	var NUMBER = '[-+]?\\d*\\.?\\d+';
	var PERCENTAGE = NUMBER + '%';
	
	function call() {
	  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
	    parts[_key] = arguments[_key];
	  }
	
	  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
	}
	
	var rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
	var rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
	var hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
	var hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
	var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
	var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
	var hex6 = /^#([0-9a-fA-F]{6})$/;
	var hex8 = /^#([0-9a-fA-F]{8})$/;
	
	/*
	https://github.com/react-community/normalize-css-color
	
	BSD 3-Clause License
	
	Copyright (c) 2016, React Community
	All rights reserved.
	
	Redistribution and use in source and binary forms, with or without
	modification, are permitted provided that the following conditions are met:
	
	* Redistributions of source code must retain the above copyright notice, this
	  list of conditions and the following disclaimer.
	
	* Redistributions in binary form must reproduce the above copyright notice,
	  this list of conditions and the following disclaimer in the documentation
	  and/or other materials provided with the distribution.
	
	* Neither the name of the copyright holder nor the names of its
	  contributors may be used to endorse or promote products derived from
	  this software without specific prior written permission.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
	FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
	DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
	SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
	CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
	OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	function normalizeColor(color) {
	  var match;
	
	  if (typeof color === 'number') {
	    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
	  } // Ordered based on occurrences on Facebook codebase
	
	
	  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
	  if (colors.hasOwnProperty(color)) return colors[color];
	
	  if (match = rgb.exec(color)) {
	    return (parse255(match[1]) << 24 | // r
	    parse255(match[2]) << 16 | // g
	    parse255(match[3]) << 8 | // b
	    0x000000ff) >>> // a
	    0;
	  }
	
	  if (match = rgba.exec(color)) {
	    return (parse255(match[1]) << 24 | // r
	    parse255(match[2]) << 16 | // g
	    parse255(match[3]) << 8 | // b
	    parse1(match[4])) >>> // a
	    0;
	  }
	
	  if (match = hex3.exec(color)) {
	    return parseInt(match[1] + match[1] + // r
	    match[2] + match[2] + // g
	    match[3] + match[3] + // b
	    'ff', // a
	    16) >>> 0;
	  } // https://drafts.csswg.org/css-color-4/#hex-notation
	
	
	  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;
	
	  if (match = hex4.exec(color)) {
	    return parseInt(match[1] + match[1] + // r
	    match[2] + match[2] + // g
	    match[3] + match[3] + // b
	    match[4] + match[4], // a
	    16) >>> 0;
	  }
	
	  if (match = hsl.exec(color)) {
	    return (hslToRgb(parse360(match[1]), // h
	    parsePercentage(match[2]), // s
	    parsePercentage(match[3]) // l
	    ) | 0x000000ff) >>> // a
	    0;
	  }
	
	  if (match = hsla.exec(color)) {
	    return (hslToRgb(parse360(match[1]), // h
	    parsePercentage(match[2]), // s
	    parsePercentage(match[3]) // l
	    ) | parse1(match[4])) >>> // a
	    0;
	  }
	
	  return null;
	}
	
	function hue2rgb(p, q, t) {
	  if (t < 0) t += 1;
	  if (t > 1) t -= 1;
	  if (t < 1 / 6) return p + (q - p) * 6 * t;
	  if (t < 1 / 2) return q;
	  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	  return p;
	}
	
	function hslToRgb(h, s, l) {
	  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	  var p = 2 * l - q;
	  var r = hue2rgb(p, q, h + 1 / 3);
	  var g = hue2rgb(p, q, h);
	  var b = hue2rgb(p, q, h - 1 / 3);
	  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
	}
	
	function parse255(str) {
	  var int = parseInt(str, 10);
	  if (int < 0) return 0;
	  if (int > 255) return 255;
	  return int;
	}
	
	function parse360(str) {
	  var int = parseFloat(str);
	  return (int % 360 + 360) % 360 / 360;
	}
	
	function parse1(str) {
	  var num = parseFloat(str);
	  if (num < 0) return 0;
	  if (num > 1) return 255;
	  return Math.round(num * 255);
	}
	
	function parsePercentage(str) {
	  // parseFloat conveniently ignores the final %
	  var int = parseFloat(str);
	  if (int < 0) return 0;
	  if (int > 100) return 1;
	  return int / 100;
	}
	
	function colorToRgba(input) {
	  var int32Color = normalizeColor(input);
	  if (int32Color === null) return input;
	  int32Color = int32Color || 0;
	  var r = (int32Color & 0xff000000) >>> 24;
	  var g = (int32Color & 0x00ff0000) >>> 16;
	  var b = (int32Color & 0x0000ff00) >>> 8;
	  var a = (int32Color & 0x000000ff) / 255;
	  return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
	} // Problem: https://github.com/animatedjs/animated/pull/102
	// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662
	
	
	var stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
	// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e
	
	var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)
	
	var colorNamesRegex = new RegExp("(" + Object.keys(colors).join('|') + ")", 'g');
	/**
	 * Supports string shapes by extracting numbers so new values can be computed,
	 * and recombines those values into new strings of the same shape.  Supports
	 * things like:
	 *
	 *   rgba(123, 42, 99, 0.36)           // colors
	 *   -45deg                            // values with units
	 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
	 */
	
	var createStringInterpolator = function createStringInterpolator(config) {
	  // Replace colors with rgba
	  var outputRange = config.output.map(function (rangeValue) {
	    return rangeValue.replace(colorRegex, colorToRgba);
	  }).map(function (rangeValue) {
	    return rangeValue.replace(colorNamesRegex, colorToRgba);
	  });
	  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
	    return [];
	  });
	  outputRange.forEach(function (value) {
	    value.match(stringShapeRegex).forEach(function (number, i) {
	      return outputRanges[i].push(+number);
	    });
	  });
	  var interpolations = outputRange[0].match(stringShapeRegex).map(function (_value, i) {
	    return createInterpolator(_extends({}, config, {
	      output: outputRanges[i]
	    }));
	  });
	  return function (input) {
	    var i = 0;
	    return outputRange[0] // 'rgba(0, 100, 200, 0)'
	    // ->
	    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
	    .replace(stringShapeRegex, function () {
	      return interpolations[i++](input);
	    }) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
	    // round the opacity (4th column).
	    .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, function (_, p1, p2, p3, p4) {
	      return "rgba(" + Math.round(p1) + ", " + Math.round(p2) + ", " + Math.round(p3) + ", " + p4 + ")";
	    });
	  };
	};
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	var prefixKey = function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	};
	
	var prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
	isUnitlessNumber = Object.keys(isUnitlessNumber).reduce(function (acc, prop) {
	  prefixes.forEach(function (prefix) {
	    return acc[prefixKey(prefix, prop)] = acc[prop];
	  });
	  return acc;
	}, isUnitlessNumber);
	
	function dangerousStyleValue(name, value, isCustomProperty) {
	  if (value == null || typeof value === 'boolean' || value === '') return '';
	  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	
	  return ('' + value).trim();
	}
	
	var attributeCache = {};
	injectCreateAnimatedStyle(function (style) {
	  return new AnimatedStyle(style);
	});
	injectDefaultElement('div');
	injectStringInterpolator(createStringInterpolator);
	injectColorNames(colors);
	injectApplyAnimatedValues(function (instance, props) {
	  if (instance.nodeType && instance.setAttribute !== undefined) {
	    var style = props.style,
	        children = props.children,
	        scrollTop = props.scrollTop,
	        scrollLeft = props.scrollLeft,
	        attributes = _objectWithoutPropertiesLoose(props, ["style", "children", "scrollTop", "scrollLeft"]);
	
	    var filter = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';
	    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
	    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value
	
	    if (children !== void 0) instance.textContent = children; // Set styles ...
	
	    for (var styleName in style) {
	      if (!style.hasOwnProperty(styleName)) continue;
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
	      if (styleName === 'float') styleName = 'cssFloat';
	      if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
	    } // Set attributes ...
	
	
	    for (var name in attributes) {
	      // Attributes are written in dash case
	      var dashCase = filter ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, function (n) {
	        return '-' + n.toLowerCase();
	      }));
	      if (typeof instance.getAttribute(dashCase) !== 'undefined') instance.setAttribute(dashCase, attributes[name]);
	    }
	
	    return;
	  } else return false;
	}, function (style) {
	  return style;
	});
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	// Extend animated with all the available THREE elements
	var apply = merge(createAnimatedComponent, false);
	var extendedAnimated = apply(domElements);
	
	exports.apply = apply;
	exports.config = config;
	exports.update = update;
	exports.animated = extendedAnimated;
	exports.a = extendedAnimated;
	exports.interpolate = interpolate$1;
	exports.Globals = Globals;
	exports.useSpring = useSpring;
	exports.useTrail = useTrail;
	exports.useTransition = useTransition;
	exports.useChain = useChain;
	exports.useSprings = useSprings;


/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND = exports.CLOCK_HAND_CIRCLE_BACKGROUND = exports.CLOCK_HAND_ARM = exports.CLOCK_WRAPPER_BACKGROUND = void 0;
	// clock wrapper
	var CLOCK_WRAPPER_BACKGROUND = '#f4f4f4'; // clock
	
	exports.CLOCK_WRAPPER_BACKGROUND = CLOCK_WRAPPER_BACKGROUND;
	var CLOCK_HAND_ARM = '#bceaff';
	exports.CLOCK_HAND_ARM = CLOCK_HAND_ARM;
	var CLOCK_HAND_CIRCLE_BACKGROUND = '#e6f7ff';
	exports.CLOCK_HAND_CIRCLE_BACKGROUND = CLOCK_HAND_CIRCLE_BACKGROUND;
	var CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND = '#ade2fb';
	exports.CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND = CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deg = deg;
	exports.transform = transform;
	exports.isWithinRadius = isWithinRadius;
	exports.calcAnimationAngle = calcAnimationAngle;
	
	var _constants = __webpack_require__(211);
	
	var cos = Math.cos,
	    sin = Math.sin;
	var pi = Math.PI;
	var ANGLE_PER_INCREMENT = 360 / _constants.VISIBLE_NUMBERS_PER_CIRCLE;
	
	function rad(deg) {
	  return deg / (180 / pi);
	}
	
	function deg(rad) {
	  return rad * (180 / pi);
	} // translate number position
	
	
	function translateX(index, transform) {
	  return sin(rad(index * -ANGLE_PER_INCREMENT - 180)) * (_constants.CLOCK_RADIUS - transform) + _constants.CLOCK_RADIUS - _constants.NUMBER_RADIUS_REGULAR / 2;
	}
	
	function translateY(index, transform) {
	  return cos(rad(index * -ANGLE_PER_INCREMENT - 180)) * (_constants.CLOCK_RADIUS - transform) + _constants.CLOCK_RADIUS - _constants.NUMBER_RADIUS_REGULAR / 2;
	} // calculate number position for animation
	
	
	function transform(index, t) {
	  var x = translateX(index, t);
	  var y = translateY(index, t);
	  return "translate(".concat(x, "px, ").concat(y, "px)");
	}
	
	function isWithinRadius(x, y, radius) {
	  return Math.sqrt(x * x + y * y) < radius;
	}
	
	// normalize any angles to 0-360 deg
	function normalize(angle) {
	  return (angle % 360 + 360) % 360;
	}
	/*
		calculates the shortest angle between the prev and next angle
		to animate to - positive spins clockwise, negative is ccw
	
		- prev is the previous angle - can literally be almost any value,
		eg: 480 is valid, -480 is valid
		- next is the angle to rotate to - is always between 0-360
		- must return an angle relative to the previous, so once again
		this value can be any negative or positive value (like prev)
	
		function normalizes each angle, creates an upper and lower bound
		based on previous angle and figures out which direction is shorter
		for next - then diff and add/subtract to previous angle
	*/
	
	
	function calcAnimationAngle(prev, next) {
	  var p = normalize(prev);
	  var n = normalize(next);
	  var lower = p;
	  var upper = p; // TODO - implement without while loops
	
	  while (n < lower) {
	    lower -= 360;
	  }
	
	  while (n >= upper) {
	    upper += 360;
	  }
	
	  if (upper - n < n - lower) {
	    return prev - (upper - n);
	  } else {
	    return prev + (n - lower);
	  }
	}

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(591));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(71));
	
	var _config = _interopRequireDefault(__webpack_require__(2829));
	
	var _PropTypes = __webpack_require__(2830);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(1644));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      // allows for nested Transitions
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, children(status, childProps));
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return (// allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, _react.default.cloneElement(child, childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the
	   * `<Transition>` component mounts. If you want to transition on the first
	   * mount set `appear` to `true`, and the component will transition in as soon
	   * as the `<Transition>` mounts.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	var _default = Transition;
	exports.default = _default;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValuePresent = exports.getAnimationModule = exports.removeNamespace = exports.transformKeys = exports.prepareValueForInput = exports.inputTypeForPrototype = exports.cloneObject = exports.getViewport = exports.round = exports.range = exports.angle360FromPositions = exports.angleFromPositions = undefined;
	
	var _assoc = __webpack_require__(6345);
	
	var _assoc2 = _interopRequireDefault(_assoc);
	
	var _compose = __webpack_require__(6347);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _keys = __webpack_require__(2846);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _reduce = __webpack_require__(2847);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _pickBy = __webpack_require__(6354);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var angleFromPositions = exports.angleFromPositions = function angleFromPositions(cx, cy, ex, ey) {
	  var theta = Math.atan2(ey - cy, ex - cx) + Math.PI / 2;
	  return theta * 180 / Math.PI;
	};
	
	var angle360FromPositions = exports.angle360FromPositions = function angle360FromPositions(cx, cy, ex, ey) {
	  var angle = angleFromPositions(cx, cy, ex, ey);
	  return angle < 0 ? 360 + angle : angle;
	};
	
	var range = exports.range = function range() {
	  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  var _start = 0,
	      _stop = start;
	
	  if (stop !== null) {
	    _start = start;
	    _stop = stop;
	  }
	  var length = Math.max(Math.ceil((_stop - _start) / step), 0);
	  var _range = Array(length);
	
	  for (var idx = 0; idx < length; idx += 1, _start += step) {
	    _range[idx] = _start;
	  }
	
	  return _range;
	};
	
	var round = exports.round = function round(number, decimals) {
	  if (!isNaN(parseFloat(number)) && isFinite(number)) {
	    var decimalPower = Math.pow(10, decimals);
	    return Math.round(parseFloat(number) * decimalPower) / decimalPower;
	  }
	  return NaN;
	};
	
	var getViewport = exports.getViewport = function getViewport() {
	  return {
	    height: window.innerHeight || document.documentElement.offsetHeight,
	    width: window.innerWidth || document.documentElement.offsetWidth
	  };
	};
	
	var cloneObject = exports.cloneObject = function cloneObject(object) {
	  return JSON.parse(JSON.stringify(object));
	};
	
	var inputTypeForPrototype = exports.inputTypeForPrototype = function inputTypeForPrototype(prototype) {
	  if (prototype === Date) return 'date';
	  if (prototype === Number) return 'number';
	  if (prototype === Boolean) return 'checkbox';
	  return 'text';
	};
	
	var prepareValueForInput = exports.prepareValueForInput = function prepareValueForInput(value, type) {
	  if (type === 'date') return new Date(value).toISOString().slice(0, 10);
	  if (type === 'checkbox') {
	    return value ? 'on' : '';
	  }
	  return value;
	};
	
	var transformKeys = exports.transformKeys = function transformKeys(fn) {
	  return function (obj) {
	    var addTransformedKey = function addTransformedKey(result, key) {
	      return (0, _assoc2.default)(fn(key), obj[key], result);
	    };
	    return (0, _reduce2.default)(addTransformedKey, {}, (0, _keys2.default)(obj));
	  };
	};
	
	var removeNamespace = exports.removeNamespace = function removeNamespace(namespace) {
	  return function (key) {
	    var capitalized = key.substr(namespace.length);
	    return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
	  };
	};
	
	var getAnimationModule = exports.getAnimationModule = function getAnimationModule(animation, theme) {
	  return (0, _compose2.default)(transformKeys(removeNamespace(animation)), (0, _pickBy2.default)(function (v, k) {
	    return k.startsWith(animation);
	  }))(theme);
	};
	
	var isValuePresent = exports.isValuePresent = function isValuePresent(value) {
	  return value !== null && value !== undefined && value !== '' && !(typeof value === 'number' && isNaN(value));
	};

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(593);
	var _curry2 = __webpack_require__(1047);
	var _isPlaceholder = __webpack_require__(1647);
	
	
	/**
	 * Optimized internal three-arity curry function.
	 *
	 * @private
	 * @category Function
	 * @param {Function} fn The function to curry.
	 * @return {Function} The curried function.
	 */
	module.exports = function _curry3(fn) {
	  return function f3(a, b, c) {
	    switch (arguments.length) {
	      case 0:
	        return f3;
	      case 1:
	        return _isPlaceholder(a) ? f3
	             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
	      case 2:
	        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
	             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _curry1(function(_c) { return fn(a, b, _c); });
	      default:
	        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
	             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
	             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
	             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
	             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
	             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
	             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
	             : fn(a, b, c);
	    }
	  };
	};


/***/ }),
/* 1647 */
/***/ (function(module, exports) {

	module.exports = function _isPlaceholder(a) {
	  return a != null &&
	         typeof a === 'object' &&
	         a['@@functional/placeholder'] === true;
	};


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(594));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(71));
	
	var _config = _interopRequireDefault(__webpack_require__(2850));
	
	var _PropTypes = __webpack_require__(2852);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(1649));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      // allows for nested Transitions
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, children(status, childProps));
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return (// allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, _react.default.cloneElement(child, childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	var _default = Transition;
	exports.default = _default;

/***/ }),
/* 1649 */
1644,
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _CellSizeAndPositionManager = __webpack_require__(6389);
	
	var _CellSizeAndPositionManager2 = _interopRequireDefault(_CellSizeAndPositionManager);
	
	var _maxElementSize = __webpack_require__(6391);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_VisibleCellRange = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_VisibleCellRange || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellSizeGetter = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_CellSizeGetter || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(2).any;
	
	/**
	 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
	 */
	
	
	/**
	 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
	 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
	 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
	 */
	
	var ScalingCellSizeAndPositionManager = function () {
	  function ScalingCellSizeAndPositionManager(_ref) {
	    var _ref$maxScrollSize = _ref.maxScrollSize,
	        maxScrollSize = _ref$maxScrollSize === undefined ? (0, _maxElementSize.getMaxElementSize)() : _ref$maxScrollSize,
	        params = (0, _objectWithoutProperties3.default)(_ref, ['maxScrollSize']);
	    (0, _classCallCheck3.default)(this, ScalingCellSizeAndPositionManager);
	
	    // Favor composition over inheritance to simplify IE10 support
	    this._cellSizeAndPositionManager = new _CellSizeAndPositionManager2.default(params);
	    this._maxScrollSize = maxScrollSize;
	  }
	
	  (0, _createClass3.default)(ScalingCellSizeAndPositionManager, [{
	    key: 'areOffsetsAdjusted',
	    value: function areOffsetsAdjusted() {
	      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
	    }
	  }, {
	    key: 'configure',
	    value: function configure(params) {
	      this._cellSizeAndPositionManager.configure(params);
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellSizeAndPositionManager.getCellCount();
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._cellSizeAndPositionManager.getEstimatedCellSize();
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
	    }
	
	    /**
	     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
	     * The offset passed to this function is scaled (safe) as well.
	     */
	
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment(_ref2) {
	      var containerSize = _ref2.containerSize,
	          offset = _ref2.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	      var offsetPercentage = this._getOffsetPercentage({
	        containerSize: containerSize,
	        offset: offset,
	        totalSize: safeTotalSize
	      });
	
	      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
	    }
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
	    }
	
	    /** See CellSizeAndPositionManager#getTotalSize */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
	    }
	
	    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align,
	          align = _ref3$align === undefined ? 'auto' : _ref3$align,
	          containerSize = _ref3.containerSize,
	          currentOffset = _ref3.currentOffset,
	          targetIndex = _ref3.targetIndex;
	
	      currentOffset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: currentOffset
	      });
	
	      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
	        align: align,
	        containerSize: containerSize,
	        currentOffset: currentOffset,
	        targetIndex: targetIndex
	      });
	
	      return this._offsetToSafeOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	
	    /** See CellSizeAndPositionManager#getVisibleCellRange */
	
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(_ref4) {
	      var containerSize = _ref4.containerSize,
	          offset = _ref4.offset;
	
	      offset = this._safeOffsetToOffset({
	        containerSize: containerSize,
	        offset: offset
	      });
	
	      return this._cellSizeAndPositionManager.getVisibleCellRange({
	        containerSize: containerSize,
	        offset: offset
	      });
	    }
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._cellSizeAndPositionManager.resetCell(index);
	    }
	  }, {
	    key: '_getOffsetPercentage',
	    value: function _getOffsetPercentage(_ref5) {
	      var containerSize = _ref5.containerSize,
	          offset = _ref5.offset,
	          totalSize = _ref5.totalSize;
	
	      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
	    }
	  }, {
	    key: '_offsetToSafeOffset',
	    value: function _offsetToSafeOffset(_ref6) {
	      var containerSize = _ref6.containerSize,
	          offset = _ref6.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: totalSize
	        });
	
	        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
	      }
	    }
	  }, {
	    key: '_safeOffsetToOffset',
	    value: function _safeOffsetToOffset(_ref7) {
	      var containerSize = _ref7.containerSize,
	          offset = _ref7.offset;
	
	      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
	      var safeTotalSize = this.getTotalSize();
	
	      if (totalSize === safeTotalSize) {
	        return offset;
	      } else {
	        var offsetPercentage = this._getOffsetPercentage({
	          containerSize: containerSize,
	          offset: offset,
	          totalSize: safeTotalSize
	        });
	
	        return Math.round(offsetPercentage * (totalSize - containerSize));
	      }
	    }
	  }]);
	  return ScalingCellSizeAndPositionManager;
	}();
	
	exports.default = ScalingCellSizeAndPositionManager;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var babelPluginFlowReactPropTypes_proptype_RowRendererParams =  true ? null : {
	  index: require('prop-types').number.isRequired,
	  isScrolling: require('prop-types').bool.isRequired,
	  isVisible: require('prop-types').bool.isRequired,
	  key: require('prop-types').string.isRequired,
	  parent: require('prop-types').object.isRequired,
	  style: require('prop-types').object.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RowRendererParams', {
	  value: babelPluginFlowReactPropTypes_proptype_RowRendererParams,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_RowRenderer =  true ? null : require('prop-types').func;
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RowRenderer', {
	  value: babelPluginFlowReactPropTypes_proptype_RowRenderer,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_RenderedRows =  true ? null : {
	  overscanStartIndex: require('prop-types').number.isRequired,
	  overscanStopIndex: require('prop-types').number.isRequired,
	  startIndex: require('prop-types').number.isRequired,
	  stopIndex: require('prop-types').number.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_RenderedRows', {
	  value: babelPluginFlowReactPropTypes_proptype_RenderedRows,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_Scroll =  true ? null : {
	  clientHeight: require('prop-types').number.isRequired,
	  scrollHeight: require('prop-types').number.isRequired,
	  scrollTop: require('prop-types').number.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Scroll', {
	  value: babelPluginFlowReactPropTypes_proptype_Scroll,
	  configurable: true
	});

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PositionCache = __webpack_require__(6397);
	
	var _PositionCache2 = _interopRequireDefault(_PositionCache);
	
	var _requestAnimationTimeout = __webpack_require__(752);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId = __webpack_require__(752).babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId || __webpack_require__(2).any;
	
	var emptyObject = {};
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
	 * Cell position is determined by an injected `cellPositioner` property.
	 * Windowing is vertical; this component does not support horizontal scrolling.
	 *
	 * Rendering occurs in two phases:
	 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
	 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
	 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
	 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
	 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
	 * 2) Second pass uses the external `cellPositioner` to layout cells.
	 *    At this time the positioner has access to cached size measurements for all cells.
	 *    The positions it returns are cached by Masonry for fast access later.
	 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
	 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
	 *
	 * Animation constraints:
	 *   Simple animations are supported (eg translate/slide into place on initial reveal).
	 *   More complex animations are not (eg flying from one position to another on resize).
	 *
	 * Layout constraints:
	 *   This component supports multi-column layout.
	 *   The height of each item may vary.
	 *   The width of each item must not exceed the width of the column it is "in".
	 *   The left position of all items within a column must align.
	 *   (Items may not span multiple columns.)
	 */
	
	var Masonry = function (_PureComponent) {
	  (0, _inherits3.default)(Masonry, _PureComponent);
	
	  function Masonry(props, context) {
	    (0, _classCallCheck3.default)(this, Masonry);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Masonry.__proto__ || (0, _getPrototypeOf2.default)(Masonry)).call(this, props, context));
	
	    _this._invalidateOnUpdateStartIndex = null;
	    _this._invalidateOnUpdateStopIndex = null;
	    _this._positionCache = new _PositionCache2.default();
	    _this._startIndex = null;
	    _this._startIndexMemoized = null;
	    _this._stopIndex = null;
	    _this._stopIndexMemoized = null;
	
	
	    _this.state = {
	      isScrolling: false,
	      scrollTop: 0
	    };
	
	    _this._debounceResetIsScrollingCallback = _this._debounceResetIsScrollingCallback.bind(_this);
	    _this._setScrollingContainerRef = _this._setScrollingContainerRef.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Masonry, [{
	    key: 'clearCellPositions',
	    value: function clearCellPositions() {
	      this._positionCache = new _PositionCache2.default();
	      this.forceUpdate();
	    }
	
	    // HACK This method signature was intended for Grid
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref) {
	      var index = _ref.rowIndex;
	
	      if (this._invalidateOnUpdateStartIndex === null) {
	        this._invalidateOnUpdateStartIndex = index;
	        this._invalidateOnUpdateStopIndex = index;
	      } else {
	        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
	        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
	      }
	    }
	  }, {
	    key: 'recomputeCellPositions',
	    value: function recomputeCellPositions() {
	      var stopIndex = this._positionCache.count - 1;
	
	      this._positionCache = new _PositionCache2.default();
	      this._populatePositionCache(0, stopIndex);
	
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._checkInvalidateOnUpdate();
	      this._invokeOnScrollCallback();
	      this._invokeOnCellsRenderedCallback();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._checkInvalidateOnUpdate();
	      this._invokeOnScrollCallback();
	      this._invokeOnCellsRenderedCallback();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._debounceResetIsScrollingId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._debounceResetIsScrollingId);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var scrollTop = this.props.scrollTop;
	
	
	      if (scrollTop !== nextProps.scrollTop) {
	        this._debounceResetIsScrolling();
	
	        this.setState({
	          isScrolling: true,
	          scrollTop: nextProps.scrollTop
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          autoHeight = _props.autoHeight,
	          cellCount = _props.cellCount,
	          cellMeasurerCache = _props.cellMeasurerCache,
	          cellRenderer = _props.cellRenderer,
	          className = _props.className,
	          height = _props.height,
	          id = _props.id,
	          keyMapper = _props.keyMapper,
	          overscanByPixels = _props.overscanByPixels,
	          role = _props.role,
	          style = _props.style,
	          tabIndex = _props.tabIndex,
	          width = _props.width;
	      var _state = this.state,
	          isScrolling = _state.isScrolling,
	          scrollTop = _state.scrollTop;
	
	
	      var children = [];
	
	      var estimateTotalHeight = this._getEstimatedTotalHeight();
	
	      var shortestColumnSize = this._positionCache.shortestColumnSize;
	      var measuredCellCount = this._positionCache.count;
	
	      var startIndex = 0;
	      var stopIndex = void 0;
	
	      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
	        if (typeof stopIndex === 'undefined') {
	          startIndex = index;
	          stopIndex = index;
	        } else {
	          startIndex = Math.min(startIndex, index);
	          stopIndex = Math.max(stopIndex, index);
	        }
	
	        children.push(cellRenderer({
	          index: index,
	          isScrolling: isScrolling,
	          key: keyMapper(index),
	          parent: _this2,
	          style: {
	            height: cellMeasurerCache.getHeight(index),
	            left: left,
	            position: 'absolute',
	            top: top,
	            width: cellMeasurerCache.getWidth(index)
	          }
	        }));
	      });
	
	      // We need to measure additional cells for this layout
	      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
	        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));
	
	        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
	          stopIndex = _index;
	
	          children.push(cellRenderer({
	            index: _index,
	            isScrolling: isScrolling,
	            key: keyMapper(_index),
	            parent: this,
	            style: {
	              width: cellMeasurerCache.getWidth(_index)
	            }
	          }));
	        }
	      }
	
	      this._startIndex = startIndex;
	      this._stopIndex = stopIndex;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setScrollingContainerRef,
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Masonry', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: role,
	          style: (0, _extends3.default)({
	            boxSizing: 'border-box',
	            direction: 'ltr',
	            height: autoHeight ? 'auto' : height,
	            overflowX: 'hidden',
	            overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
	            position: 'relative',
	            width: width,
	            WebkitOverflowScrolling: 'touch',
	            willChange: 'transform'
	          }, style),
	          tabIndex: tabIndex },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Masonry__innerScrollContainer',
	            style: {
	              width: '100%',
	              height: estimateTotalHeight,
	              maxWidth: '100%',
	              maxHeight: estimateTotalHeight,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              position: 'relative'
	            } },
	          children
	        )
	      );
	    }
	  }, {
	    key: '_checkInvalidateOnUpdate',
	    value: function _checkInvalidateOnUpdate() {
	      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
	        var _startIndex = this._invalidateOnUpdateStartIndex;
	        var _stopIndex = this._invalidateOnUpdateStopIndex;
	
	        this._invalidateOnUpdateStartIndex = null;
	        this._invalidateOnUpdateStopIndex = null;
	
	        // Query external layout logic for position of newly-measured cells
	        this._populatePositionCache(_startIndex, _stopIndex);
	
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: '_debounceResetIsScrolling',
	    value: function _debounceResetIsScrolling() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._debounceResetIsScrollingId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._debounceResetIsScrollingId);
	      }
	
	      this._debounceResetIsScrollingId = (0, _requestAnimationTimeout.requestAnimationTimeout)(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_debounceResetIsScrollingCallback',
	    value: function _debounceResetIsScrollingCallback() {
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: '_getEstimatedTotalHeight',
	    value: function _getEstimatedTotalHeight() {
	      var _props2 = this.props,
	          cellCount = _props2.cellCount,
	          cellMeasurerCache = _props2.cellMeasurerCache,
	          width = _props2.width;
	
	
	      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));
	
	      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
	    }
	  }, {
	    key: '_invokeOnScrollCallback',
	    value: function _invokeOnScrollCallback() {
	      var _props3 = this.props,
	          height = _props3.height,
	          onScroll = _props3.onScroll;
	      var scrollTop = this.state.scrollTop;
	
	
	      if (this._onScrollMemoized !== scrollTop) {
	        onScroll({
	          clientHeight: height,
	          scrollHeight: this._getEstimatedTotalHeight(),
	          scrollTop: scrollTop
	        });
	
	        this._onScrollMemoized = scrollTop;
	      }
	    }
	  }, {
	    key: '_invokeOnCellsRenderedCallback',
	    value: function _invokeOnCellsRenderedCallback() {
	      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
	        var _onCellsRendered = this.props.onCellsRendered;
	
	
	        _onCellsRendered({
	          startIndex: this._startIndex,
	          stopIndex: this._stopIndex
	        });
	
	        this._startIndexMemoized = this._startIndex;
	        this._stopIndexMemoized = this._stopIndex;
	      }
	    }
	  }, {
	    key: '_populatePositionCache',
	    value: function _populatePositionCache(startIndex, stopIndex) {
	      var _props4 = this.props,
	          cellMeasurerCache = _props4.cellMeasurerCache,
	          cellPositioner = _props4.cellPositioner;
	
	
	      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
	        var _cellPositioner = cellPositioner(_index2),
	            _left = _cellPositioner.left,
	            _top = _cellPositioner.top;
	
	        this._positionCache.setPosition(_index2, _left, _top, cellMeasurerCache.getHeight(_index2));
	      }
	    }
	  }, {
	    key: '_setScrollingContainerRef',
	    value: function _setScrollingContainerRef(ref) {
	      this._scrollingContainer = ref;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      var height = this.props.height;
	
	
	      var eventScrollTop = event.target.scrollTop;
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
	      var scrollTop = Math.min(Math.max(0, this._getEstimatedTotalHeight() - height), eventScrollTop);
	
	      // On iOS, we can arrive at negative offsets by swiping past the start or end.
	      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
	      if (eventScrollTop !== scrollTop) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._debounceResetIsScrolling();
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollTop !== scrollTop) {
	        this.setState({
	          isScrolling: true,
	          scrollTop: scrollTop
	        });
	      }
	    }
	  }]);
	  return Masonry;
	}(_react.PureComponent);
	
	Masonry.defaultProps = {
	  autoHeight: false,
	  keyMapper: identity,
	  onCellsRendered: noop,
	  onScroll: noop,
	  overscanByPixels: 20,
	  role: 'grid',
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  style: emptyObject,
	  tabIndex: 0
	};
	Masonry.propTypes =  true ? null : {
	  autoHeight: require('prop-types').bool.isRequired,
	  cellCount: require('prop-types').number.isRequired,
	  cellMeasurerCache: typeof CellMeasurerCache === 'function' ? require('prop-types').instanceOf(CellMeasurerCache).isRequired : require('prop-types').any.isRequired,
	  cellPositioner: typeof Positioner === 'function' ? require('prop-types').instanceOf(Positioner).isRequired : require('prop-types').any.isRequired,
	  cellRenderer: typeof CellRenderer === 'function' ? require('prop-types').instanceOf(CellRenderer).isRequired : require('prop-types').any.isRequired,
	  className: require('prop-types').string,
	  height: require('prop-types').number.isRequired,
	  id: require('prop-types').string,
	  keyMapper: typeof KeyMapper === 'function' ? require('prop-types').instanceOf(KeyMapper).isRequired : require('prop-types').any.isRequired,
	  onCellsRendered: typeof OnCellsRenderedCallback === 'function' ? require('prop-types').instanceOf(OnCellsRenderedCallback) : require('prop-types').any,
	  onScroll: typeof OnScrollCallback === 'function' ? require('prop-types').instanceOf(OnScrollCallback) : require('prop-types').any,
	  overscanByPixels: require('prop-types').number.isRequired,
	  role: require('prop-types').string.isRequired,
	  scrollingResetTimeInterval: require('prop-types').number.isRequired,
	  style: function style(props, propName, componentName) {
	    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
	      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
	    }
	  },
	  tabIndex: require('prop-types').number.isRequired,
	  width: require('prop-types').number.isRequired
	};
	exports.default = Masonry;
	
	
	function identity(value) {
	  return value;
	}
	
	function noop() {}
	
	var babelPluginFlowReactPropTypes_proptype_CellMeasurerCache =  true ? null : {
	  defaultHeight: require('prop-types').number.isRequired,
	  defaultWidth: require('prop-types').number.isRequired,
	  getHeight: require('prop-types').func.isRequired,
	  getWidth: require('prop-types').func.isRequired
	};
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_CellMeasurerCache', {
	  value: babelPluginFlowReactPropTypes_proptype_CellMeasurerCache,
	  configurable: true
	});
	var babelPluginFlowReactPropTypes_proptype_Positioner =  true ? null : require('prop-types').func;
	if (false) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Positioner', {
	  value: babelPluginFlowReactPropTypes_proptype_Positioner,
	  configurable: true
	});

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = createCallbackMemoizer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
	 */
	function createCallbackMemoizer() {
	  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  var cachedIndices = {};
	
	  return function (_ref) {
	    var callback = _ref.callback,
	        indices = _ref.indices;
	
	    var keys = (0, _keys2.default)(indices);
	    var allInitialized = !requireAllKeys || keys.every(function (key) {
	      var value = indices[key];
	      return Array.isArray(value) ? value.length > 0 : value >= 0;
	    });
	    var indexChanged = keys.length !== (0, _keys2.default)(cachedIndices).length || keys.some(function (key) {
	      var cachedValue = cachedIndices[key];
	      var value = indices[key];
	
	      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
	    });
	
	    cachedIndices = indices;
	
	    if (allInitialized && indexChanged) {
	      callback(indices);
	    }
	  };
	}

/***/ }),
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */
1620,
/* 1662 */
/***/ (function(module, exports) {

	function _taggedTemplateLiteral(strings, raw) {
	  if (!raw) {
	    raw = strings.slice(0);
	  }
	
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	}
	
	module.exports = _taggedTemplateLiteral;

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * IE11-safe version of getCanonicalLocales since it's ES2016
	 * @param locales locales
	 */
	function getCanonicalLocales(locales) {
	    // IE11
	    var getCanonicalLocales = Intl.getCanonicalLocales;
	    if (typeof getCanonicalLocales === 'function') {
	        return getCanonicalLocales(locales);
	    }
	    // NOTE: we must NOT call `supportedLocalesOf` of a formatjs polyfill, or their implementation
	    // will even eventually call this method recursively. Here we use `Intl.DateTimeFormat` since it
	    // is not polyfilled by `@formatjs`.
	    // TODO: Fix TypeScript type def for this bc undefined is just fine
	    return Intl.DateTimeFormat.supportedLocalesOf(locales);
	}
	exports.getCanonicalLocales = getCanonicalLocales;
	//# sourceMappingURL=get-canonical-locales.js.map

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var aliases_1 = __webpack_require__(2898);
	var parentLocales_1 = __webpack_require__(2901);
	var invariant_1 = __webpack_require__(1059);
	/**
	 * https://tc39.es/ecma262/#sec-toobject
	 * @param arg
	 */
	function toObject(arg) {
	    if (arg == null) {
	        throw new TypeError('undefined/null cannot be converted to object');
	    }
	    return Object(arg);
	}
	exports.toObject = toObject;
	/**
	 * https://tc39.es/ecma262/#sec-tostring
	 */
	function toString(o) {
	    // Only symbol is irregular...
	    if (typeof o === 'symbol') {
	        throw TypeError('Cannot convert a Symbol value to a string');
	    }
	    return String(o);
	}
	exports.toString = toString;
	/**
	 * https://tc39.es/ecma402/#sec-getoption
	 * @param opts
	 * @param prop
	 * @param type
	 * @param values
	 * @param fallback
	 */
	function getOption(opts, prop, type, values, fallback) {
	    // const descriptor = Object.getOwnPropertyDescriptor(opts, prop);
	    var value = opts[prop];
	    if (value !== undefined) {
	        if (type !== 'boolean' && type !== 'string') {
	            throw new TypeError('invalid type');
	        }
	        if (type === 'boolean') {
	            value = Boolean(value);
	        }
	        if (type === 'string') {
	            value = toString(value);
	        }
	        if (values !== undefined && !values.filter(function (val) { return val == value; }).length) {
	            throw new RangeError(value + " is not within " + values.join(', '));
	        }
	        return value;
	    }
	    return fallback;
	}
	exports.getOption = getOption;
	/**
	 * https://tc39.es/ecma402/#sec-defaultnumberoption
	 * @param val
	 * @param min
	 * @param max
	 * @param fallback
	 */
	function defaultNumberOption(val, min, max, fallback) {
	    if (val !== undefined) {
	        val = Number(val);
	        if (isNaN(val) || val < min || val > max) {
	            throw new RangeError(val + " is outside of range [" + min + ", " + max + "]");
	        }
	        return Math.floor(val);
	    }
	    return fallback;
	}
	exports.defaultNumberOption = defaultNumberOption;
	/**
	 * https://tc39.es/ecma402/#sec-getnumberoption
	 * @param options
	 * @param property
	 * @param min
	 * @param max
	 * @param fallback
	 */
	function getNumberOption(options, property, minimum, maximum, fallback) {
	    var val = options[property];
	    return defaultNumberOption(val, minimum, maximum, fallback);
	}
	exports.getNumberOption = getNumberOption;
	function getAliasesByLang(lang) {
	    return Object.keys(aliases_1.default).reduce(function (all, locale) {
	        if (locale.split('-')[0] === lang) {
	            all[locale] = aliases_1.default[locale];
	        }
	        return all;
	    }, {});
	}
	exports.getAliasesByLang = getAliasesByLang;
	function getParentLocalesByLang(lang) {
	    return Object.keys(parentLocales_1.default).reduce(function (all, locale) {
	        if (locale.split('-')[0] === lang) {
	            all[locale] = parentLocales_1.default[locale];
	        }
	        return all;
	    }, {});
	}
	exports.getParentLocalesByLang = getParentLocalesByLang;
	function setInternalSlot(map, pl, field, value) {
	    if (!map.get(pl)) {
	        map.set(pl, Object.create(null));
	    }
	    var slots = map.get(pl);
	    slots[field] = value;
	}
	exports.setInternalSlot = setInternalSlot;
	function setMultiInternalSlots(map, pl, props) {
	    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	        var k = _a[_i];
	        setInternalSlot(map, pl, k, props[k]);
	    }
	}
	exports.setMultiInternalSlots = setMultiInternalSlots;
	function getInternalSlot(map, pl, field) {
	    return getMultiInternalSlots(map, pl, field)[field];
	}
	exports.getInternalSlot = getInternalSlot;
	function getMultiInternalSlots(map, pl) {
	    var fields = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        fields[_i - 2] = arguments[_i];
	    }
	    var slots = map.get(pl);
	    if (!slots) {
	        throw new TypeError(pl + " InternalSlot has not been initialized");
	    }
	    return fields.reduce(function (all, f) {
	        all[f] = slots[f];
	        return all;
	    }, Object.create(null));
	}
	exports.getMultiInternalSlots = getMultiInternalSlots;
	function isLiteralPart(patternPart) {
	    return patternPart.type === 'literal';
	}
	exports.isLiteralPart = isLiteralPart;
	function partitionPattern(pattern) {
	    var result = [];
	    var beginIndex = pattern.indexOf('{');
	    var endIndex = 0;
	    var nextIndex = 0;
	    var length = pattern.length;
	    while (beginIndex < pattern.length && beginIndex > -1) {
	        endIndex = pattern.indexOf('}', beginIndex);
	        invariant_1.invariant(endIndex > beginIndex, "Invalid pattern " + pattern);
	        if (beginIndex > nextIndex) {
	            result.push({
	                type: 'literal',
	                value: pattern.substring(nextIndex, beginIndex),
	            });
	        }
	        result.push({
	            type: pattern.substring(beginIndex + 1, endIndex),
	            value: undefined,
	        });
	        nextIndex = endIndex + 1;
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    if (nextIndex < length) {
	        result.push({
	            type: 'literal',
	            value: pattern.substring(nextIndex, length),
	        });
	    }
	    return result;
	}
	exports.partitionPattern = partitionPattern;
	/**
	 * https://tc39.es/ecma402/#sec-setnfdigitoptions
	 * https://tc39.es/proposal-unified-intl-numberformat/section11/numberformat_diff_out.html#sec-setnfdigitoptions
	 * @param intlObj
	 * @param opts
	 * @param mnfdDefault
	 * @param mxfdDefault
	 */
	function setNumberFormatDigitOptions(internalSlotMap, intlObj, opts, mnfdDefault, mxfdDefault) {
	    var mnid = getNumberOption(opts, 'minimumIntegerDigits', 1, 21, 1);
	    var mnfd = opts.minimumFractionDigits;
	    var mxfd = opts.maximumFractionDigits;
	    var mnsd = opts.minimumSignificantDigits;
	    var mxsd = opts.maximumSignificantDigits;
	    setInternalSlot(internalSlotMap, intlObj, 'minimumIntegerDigits', mnid);
	    if (mnsd !== undefined || mxsd !== undefined) {
	        setInternalSlot(internalSlotMap, intlObj, 'roundingType', 'significantDigits');
	        mnsd = defaultNumberOption(mnsd, 1, 21, 1);
	        mxsd = defaultNumberOption(mxsd, mnsd, 21, 21);
	        setInternalSlot(internalSlotMap, intlObj, 'minimumSignificantDigits', mnsd);
	        setInternalSlot(internalSlotMap, intlObj, 'maximumSignificantDigits', mxsd);
	    }
	    else if (mnfd !== undefined || mxfd !== undefined) {
	        setInternalSlot(internalSlotMap, intlObj, 'roundingType', 'fractionDigits');
	        mnfd = defaultNumberOption(mnfd, 0, 20, mnfdDefault);
	        var mxfdActualDefault = Math.max(mnfd, mxfdDefault);
	        mxfd = defaultNumberOption(mxfd, mnfd, 20, mxfdActualDefault);
	        setInternalSlot(internalSlotMap, intlObj, 'minimumFractionDigits', mnfd);
	        setInternalSlot(internalSlotMap, intlObj, 'maximumFractionDigits', mxfd);
	    }
	    else if (getInternalSlot(internalSlotMap, intlObj, 'notation') === 'compact') {
	        setInternalSlot(internalSlotMap, intlObj, 'roundingType', 'compactRounding');
	    }
	    else {
	        setInternalSlot(internalSlotMap, intlObj, 'roundingType', 'fractionDigits');
	        setInternalSlot(internalSlotMap, intlObj, 'minimumFractionDigits', mnfdDefault);
	        setInternalSlot(internalSlotMap, intlObj, 'maximumFractionDigits', mxfdDefault);
	    }
	}
	exports.setNumberFormatDigitOptions = setNumberFormatDigitOptions;
	function objectIs(x, y) {
	    if (Object.is) {
	        return Object.is(x, y);
	    }
	    // SameValue algorithm
	    if (x === y) {
	        // Steps 1-5, 7-10
	        // Steps 6.b-6.e: +0 != -0
	        return x !== 0 || 1 / x === 1 / y;
	    }
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	}
	exports.objectIs = objectIs;
	var NOT_A_Z_REGEX = /[^A-Z]/;
	/**
	 * This follows https://tc39.es/ecma402/#sec-case-sensitivity-and-case-mapping
	 * @param str string to convert
	 */
	function toUpperCase(str) {
	    return str.replace(/([a-z])/g, function (_, c) { return c.toUpperCase(); });
	}
	/**
	 * https://tc39.es/proposal-unified-intl-numberformat/section6/locales-currencies-tz_proposed_out.html#sec-iswellformedcurrencycode
	 * @param currency
	 */
	function isWellFormedCurrencyCode(currency) {
	    currency = toUpperCase(currency);
	    if (currency.length !== 3) {
	        return false;
	    }
	    if (NOT_A_Z_REGEX.test(currency)) {
	        return false;
	    }
	    return true;
	}
	exports.isWellFormedCurrencyCode = isWellFormedCurrencyCode;
	//# sourceMappingURL=polyfill-utils.js.map

/***/ }),
/* 1666 */,
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(2911)
	} else {
	  module.exports = require('./redux-saga-effects.dev.cjs.js')
	}


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var core_1 = __webpack_require__(192);
	var utils_1 = __webpack_require__(65);
	var backend_1 = __webpack_require__(2914);
	var helpers_1 = __webpack_require__(601);
	var integrations_1 = __webpack_require__(1064);
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * @see BrowserOptions for documentation on configuration options.
	 * @see SentryClient for usage documentation.
	 */
	var BrowserClient = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserClient, _super);
	    /**
	     * Creates a new Browser SDK instance.
	     *
	     * @param options Configuration options for this SDK.
	     */
	    function BrowserClient(options) {
	        if (options === void 0) { options = {}; }
	        var _this = this;
	        options._metadata = options._metadata || {};
	        options._metadata.sdk = options._metadata.sdk || {
	            name: 'sentry.javascript.browser',
	            packages: [
	                {
	                    name: 'npm:@sentry/browser',
	                    version: core_1.SDK_VERSION,
	                },
	            ],
	            version: core_1.SDK_VERSION,
	        };
	        _this = _super.call(this, backend_1.BrowserBackend, options) || this;
	        return _this;
	    }
	    /**
	     * Show a report dialog to the user to send feedback to a specific event.
	     *
	     * @param options Set individual options for the dialog
	     */
	    BrowserClient.prototype.showReportDialog = function (options) {
	        if (options === void 0) { options = {}; }
	        // doesn't work without a document (React Native)
	        var document = utils_1.getGlobalObject().document;
	        if (!document) {
	            return;
	        }
	        if (!this._isEnabled()) {
	            utils_1.logger.error('Trying to call showReportDialog with Sentry Client disabled');
	            return;
	        }
	        helpers_1.injectReportDialog(tslib_1.__assign(tslib_1.__assign({}, options), { dsn: options.dsn || this.getDsn() }));
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
	        event.platform = event.platform || 'javascript';
	        return _super.prototype._prepareEvent.call(this, event, scope, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserClient.prototype._sendEvent = function (event) {
	        var integration = this.getIntegration(integrations_1.Breadcrumbs);
	        if (integration) {
	            integration.addSentryBreadcrumb(event);
	        }
	        _super.prototype._sendEvent.call(this, event);
	    };
	    return BrowserClient;
	}(core_1.BaseClient));
	exports.BrowserClient = BrowserClient;
	//# sourceMappingURL=client.js.map

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	var tracekit_1 = __webpack_require__(1065);
	var STACKTRACE_LIMIT = 50;
	/**
	 * This function creates an exception from an TraceKitStackTrace
	 * @param stacktrace TraceKitStackTrace that will be converted to an exception
	 * @hidden
	 */
	function exceptionFromStacktrace(stacktrace) {
	    var frames = prepareFramesForEvent(stacktrace.stack);
	    var exception = {
	        type: stacktrace.name,
	        value: stacktrace.message,
	    };
	    if (frames && frames.length) {
	        exception.stacktrace = { frames: frames };
	    }
	    if (exception.type === undefined && exception.value === '') {
	        exception.value = 'Unrecoverable error caught';
	    }
	    return exception;
	}
	exports.exceptionFromStacktrace = exceptionFromStacktrace;
	/**
	 * @hidden
	 */
	function eventFromPlainObject(exception, syntheticException, rejection) {
	    var event = {
	        exception: {
	            values: [
	                {
	                    type: utils_1.isEvent(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
	                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + utils_1.extractExceptionKeysForMessage(exception),
	                },
	            ],
	        },
	        extra: {
	            __serialized__: utils_1.normalizeToSize(exception),
	        },
	    };
	    if (syntheticException) {
	        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
	        var frames_1 = prepareFramesForEvent(stacktrace.stack);
	        event.stacktrace = {
	            frames: frames_1,
	        };
	    }
	    return event;
	}
	exports.eventFromPlainObject = eventFromPlainObject;
	/**
	 * @hidden
	 */
	function eventFromStacktrace(stacktrace) {
	    var exception = exceptionFromStacktrace(stacktrace);
	    return {
	        exception: {
	            values: [exception],
	        },
	    };
	}
	exports.eventFromStacktrace = eventFromStacktrace;
	/**
	 * @hidden
	 */
	function prepareFramesForEvent(stack) {
	    if (!stack || !stack.length) {
	        return [];
	    }
	    var localStack = stack;
	    var firstFrameFunction = localStack[0].func || '';
	    var lastFrameFunction = localStack[localStack.length - 1].func || '';
	    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
	    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
	        localStack = localStack.slice(1);
	    }
	    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
	    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
	        localStack = localStack.slice(0, -1);
	    }
	    // The frame where the crash happened, should be the last entry in the array
	    return localStack
	        .slice(0, STACKTRACE_LIMIT)
	        .map(function (frame) { return ({
	        colno: frame.column === null ? undefined : frame.column,
	        filename: frame.url || localStack[0].url,
	        function: frame.func || '?',
	        in_app: true,
	        lineno: frame.line === null ? undefined : frame.line,
	    }); })
	        .reverse();
	}
	exports.prepareFramesForEvent = prepareFramesForEvent;
	//# sourceMappingURL=parsers.js.map

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var base_1 = __webpack_require__(1066);
	exports.BaseTransport = base_1.BaseTransport;
	var fetch_1 = __webpack_require__(2923);
	exports.FetchTransport = fetch_1.FetchTransport;
	var xhr_1 = __webpack_require__(2924);
	exports.XHRTransport = xhr_1.XHRTransport;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	var global = utils_1.getGlobalObject();
	var cachedFetchImpl;
	/**
	 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
	 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
	 * this chain becomes orphaned and there is no possible way to capture it's rejections
	 * other than allowing it bubble up to this very handler. eg.
	 *
	 * const f = window.fetch;
	 * window.fetch = function () {
	 *   const p = f.apply(this, arguments);
	 *
	 *   p.then(function() {
	 *     console.log('hi.');
	 *   });
	 *
	 *   return p;
	 * }
	 *
	 * `p.then(function () { ... })` is producing a completely separate promise chain,
	 * however, what's returned is `p` - the result of original `fetch` call.
	 *
	 * This mean, that whenever we use the Fetch API to send our own requests, _and_
	 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
	 * effectively causing another event to be captured.
	 * This makes a whole process become an infinite loop, which we need to somehow
	 * deal with, and break it in one way or another.
	 *
	 * To deal with this issue, we are making sure that we _always_ use the real
	 * browser Fetch API, instead of relying on what `window.fetch` exposes.
	 * The only downside to this would be missing our own requests as breadcrumbs,
	 * but because we are already not doing this, it should be just fine.
	 *
	 * Possible failed fetch error messages per-browser:
	 *
	 * Chrome:  Failed to fetch
	 * Edge:    Failed to Fetch
	 * Firefox: NetworkError when attempting to fetch resource
	 * Safari:  resource blocked by content blocker
	 */
	function getNativeFetchImplementation() {
	    var _a, _b;
	    if (cachedFetchImpl) {
	        return cachedFetchImpl;
	    }
	    /* eslint-disable @typescript-eslint/unbound-method */
	    // Fast path to avoid DOM I/O
	    if (utils_1.isNativeFetch(global.fetch)) {
	        return (cachedFetchImpl = global.fetch.bind(global));
	    }
	    var document = global.document;
	    var fetchImpl = global.fetch;
	    // eslint-disable-next-line deprecation/deprecation
	    if (typeof ((_a = document) === null || _a === void 0 ? void 0 : _a.createElement) === "function") {
	        try {
	            var sandbox = document.createElement('iframe');
	            sandbox.hidden = true;
	            document.head.appendChild(sandbox);
	            if ((_b = sandbox.contentWindow) === null || _b === void 0 ? void 0 : _b.fetch) {
	                fetchImpl = sandbox.contentWindow.fetch;
	            }
	            document.head.removeChild(sandbox);
	        }
	        catch (e) {
	            utils_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
	        }
	    }
	    return (cachedFetchImpl = fetchImpl.bind(global));
	    /* eslint-enable @typescript-eslint/unbound-method */
	}
	exports.getNativeFetchImplementation = getNativeFetchImplementation;
	/**
	 * Sends sdk client report using sendBeacon or fetch as a fallback if available
	 *
	 * @param url report endpoint
	 * @param body report payload
	 */
	function sendReport(url, body) {
	    var isRealNavigator = Object.prototype.toString.call(global && global.navigator) === '[object Navigator]';
	    var hasSendBeacon = isRealNavigator && typeof global.navigator.sendBeacon === 'function';
	    if (hasSendBeacon) {
	        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
	        var sendBeacon = global.navigator.sendBeacon.bind(global.navigator);
	        return sendBeacon(url, body);
	    }
	    if (utils_1.supportsFetch()) {
	        var fetch_1 = getNativeFetchImplementation();
	        return utils_1.forget(fetch_1(url, {
	            body: body,
	            method: 'POST',
	            credentials: 'omit',
	            keepalive: true,
	        }));
	    }
	}
	exports.sendReport = sendReport;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	/** Noop transport */
	var NoopTransport = /** @class */ (function () {
	    function NoopTransport() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.sendEvent = function (_) {
	        return utils_1.SyncPromise.resolve({
	            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
	            status: types_1.Status.Skipped,
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    NoopTransport.prototype.close = function (_) {
	        return utils_1.SyncPromise.resolve(true);
	    };
	    return NoopTransport;
	}());
	exports.NoopTransport = NoopTransport;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	/* eslint-disable max-lines */
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var scope_1 = __webpack_require__(1674);
	var session_1 = __webpack_require__(1675);
	/**
	 * API compatibility version of this hub.
	 *
	 * WARNING: This number should only be increased when the global interface
	 * changes and new methods are introduced.
	 *
	 * @hidden
	 */
	exports.API_VERSION = 4;
	/**
	 * Default maximum number of breadcrumbs added to an event. Can be overwritten
	 * with {@link Options.maxBreadcrumbs}.
	 */
	var DEFAULT_BREADCRUMBS = 100;
	/**
	 * @inheritDoc
	 */
	var Hub = /** @class */ (function () {
	    /**
	     * Creates a new instance of the hub, will push one {@link Layer} into the
	     * internal stack on creation.
	     *
	     * @param client bound to the hub.
	     * @param scope bound to the hub.
	     * @param version number, higher number means higher priority.
	     */
	    function Hub(client, scope, _version) {
	        if (scope === void 0) { scope = new scope_1.Scope(); }
	        if (_version === void 0) { _version = exports.API_VERSION; }
	        this._version = _version;
	        /** Is a {@link Layer}[] containing the client and scope */
	        this._stack = [{}];
	        this.getStackTop().scope = scope;
	        if (client) {
	            this.bindClient(client);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.isOlderThan = function (version) {
	        return this._version < version;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.bindClient = function (client) {
	        var top = this.getStackTop();
	        top.client = client;
	        if (client && client.setupIntegrations) {
	            client.setupIntegrations();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.pushScope = function () {
	        // We want to clone the content of prev scope
	        var scope = scope_1.Scope.clone(this.getScope());
	        this.getStack().push({
	            client: this.getClient(),
	            scope: scope,
	        });
	        return scope;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.popScope = function () {
	        if (this.getStack().length <= 1)
	            return false;
	        return !!this.getStack().pop();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.withScope = function (callback) {
	        var scope = this.pushScope();
	        try {
	            callback(scope);
	        }
	        finally {
	            this.popScope();
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getClient = function () {
	        return this.getStackTop().client;
	    };
	    /** Returns the scope of the top stack. */
	    Hub.prototype.getScope = function () {
	        return this.getStackTop().scope;
	    };
	    /** Returns the scope stack for domains or the process. */
	    Hub.prototype.getStack = function () {
	        return this._stack;
	    };
	    /** Returns the topmost scope layer in the order domain > local > process. */
	    Hub.prototype.getStackTop = function () {
	        return this._stack[this._stack.length - 1];
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    Hub.prototype.captureException = function (exception, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimic the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error('Sentry syntheticException');
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: exception,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureException', exception, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureMessage = function (message, level, hint) {
	        var eventId = (this._lastEventId = utils_1.uuid4());
	        var finalHint = hint;
	        // If there's no explicit hint provided, mimic the same thing that would happen
	        // in the minimal itself to create a consistent behavior.
	        // We don't do this in the client, as it's the lowest level API, and doing this,
	        // would prevent user from having full control over direct calls.
	        if (!hint) {
	            var syntheticException = void 0;
	            try {
	                throw new Error(message);
	            }
	            catch (exception) {
	                syntheticException = exception;
	            }
	            finalHint = {
	                originalException: message,
	                syntheticException: syntheticException,
	            };
	        }
	        this._invokeClient('captureMessage', message, level, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureEvent = function (event, hint) {
	        var eventId = utils_1.uuid4();
	        if (event.type !== 'transaction') {
	            this._lastEventId = eventId;
	        }
	        this._invokeClient('captureEvent', event, tslib_1.__assign(tslib_1.__assign({}, hint), { event_id: eventId }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.lastEventId = function () {
	        return this._lastEventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope || !client)
	            return;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
	        if (maxBreadcrumbs <= 0)
	            return;
	        var timestamp = utils_1.dateTimestampInSeconds();
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
	        var finalBreadcrumb = beforeBreadcrumb
	            ? utils_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
	            : mergedBreadcrumb;
	        if (finalBreadcrumb === null)
	            return;
	        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setUser = function (user) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setUser(user);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTags = function (tags) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTags(tags);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtras = function (extras) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtras(extras);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setTag = function (key, value) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setTag(key, value);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.setExtra = function (key, extra) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setExtra(key, extra);
	    };
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype.setContext = function (name, context) {
	        var scope = this.getScope();
	        if (scope)
	            scope.setContext(name, context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.configureScope = function (callback) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (scope && client) {
	            callback(scope);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.run = function (callback) {
	        var oldHub = makeMain(this);
	        try {
	            callback(this);
	        }
	        finally {
	            makeMain(oldHub);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.getIntegration = function (integration) {
	        var client = this.getClient();
	        if (!client)
	            return null;
	        try {
	            return client.getIntegration(integration);
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSpan = function (context) {
	        return this._callExtensionMethod('startSpan', context);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startTransaction = function (context, customSamplingContext) {
	        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.traceHeaders = function () {
	        return this._callExtensionMethod('traceHeaders');
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.captureSession = function (endSession) {
	        if (endSession === void 0) { endSession = false; }
	        // both send the update and pull the session from the scope
	        if (endSession) {
	            return this.endSession();
	        }
	        // only send the update
	        this._sendSessionUpdate();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.endSession = function () {
	        var _a, _b, _c, _d, _e;
	        (_c = (_b = (_a = this.getStackTop()) === null || _a === void 0 ? void 0 : _a.scope) === null || _b === void 0 ? void 0 : _b.getSession()) === null || _c === void 0 ? void 0 : _c.close();
	        this._sendSessionUpdate();
	        // the session is over; take it off of the scope
	        (_e = (_d = this.getStackTop()) === null || _d === void 0 ? void 0 : _d.scope) === null || _e === void 0 ? void 0 : _e.setSession();
	    };
	    /**
	     * @inheritDoc
	     */
	    Hub.prototype.startSession = function (context) {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
	        // Will fetch userAgent if called from browser sdk
	        var global = utils_1.getGlobalObject();
	        var userAgent = (global.navigator || {}).userAgent;
	        var session = new session_1.Session(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ release: release,
	            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
	        if (scope) {
	            // End existing session if there's one
	            var currentSession = scope.getSession && scope.getSession();
	            if (currentSession && currentSession.status === types_1.SessionStatus.Ok) {
	                currentSession.update({ status: types_1.SessionStatus.Exited });
	            }
	            this.endSession();
	            // Afterwards we set the new session on the scope
	            scope.setSession(session);
	        }
	        return session;
	    };
	    /**
	     * Sends the current Session on the scope
	     */
	    Hub.prototype._sendSessionUpdate = function () {
	        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
	        if (!scope)
	            return;
	        var session = scope.getSession && scope.getSession();
	        if (session) {
	            if (client && client.captureSession) {
	                client.captureSession(session);
	            }
	        }
	    };
	    /**
	     * Internal helper function to call a method on the top client if it exists.
	     *
	     * @param method The method to call on the client.
	     * @param args Arguments to pass to the client function.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._invokeClient = function (method) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
	        if (client && client[method]) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	            (_a = client)[method].apply(_a, tslib_1.__spread(args, [scope]));
	        }
	    };
	    /**
	     * Calls global extension method and binding current instance to the function call
	     */
	    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Hub.prototype._callExtensionMethod = function (method) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var carrier = getMainCarrier();
	        var sentry = carrier.__SENTRY__;
	        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
	            return sentry.extensions[method].apply(this, args);
	        }
	        utils_1.logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
	    };
	    return Hub;
	}());
	exports.Hub = Hub;
	/**
	 * Returns the global shim registry.
	 *
	 * FIXME: This function is problematic, because despite always returning a valid Carrier,
	 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
	 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
	 **/
	function getMainCarrier() {
	    var carrier = utils_1.getGlobalObject();
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {
	        extensions: {},
	        hub: undefined,
	    };
	    return carrier;
	}
	exports.getMainCarrier = getMainCarrier;
	/**
	 * Replaces the current main hub with the passed one on the global object
	 *
	 * @returns The old replaced hub
	 */
	function makeMain(hub) {
	    var registry = getMainCarrier();
	    var oldHub = getHubFromCarrier(registry);
	    setHubOnCarrier(registry, hub);
	    return oldHub;
	}
	exports.makeMain = makeMain;
	/**
	 * Returns the default hub instance.
	 *
	 * If a hub is already registered in the global carrier but this module
	 * contains a more recent version, it replaces the registered version.
	 * Otherwise, the currently registered hub will be returned.
	 */
	function getCurrentHub() {
	    // Get main carrier (global for every environment)
	    var registry = getMainCarrier();
	    // If there's no hub, or its an old API, assign a new one
	    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
	        setHubOnCarrier(registry, new Hub());
	    }
	    // Prefer domains over global if they are there (applicable only to Node environment)
	    if (utils_1.isNodeEnv()) {
	        return getHubFromActiveDomain(registry);
	    }
	    // Return hub that lives on a global object
	    return getHubFromCarrier(registry);
	}
	exports.getCurrentHub = getCurrentHub;
	/**
	 * Returns the active domain, if one exists
	 * @deprecated No longer used; remove in v7
	 * @returns The domain, or undefined if there is no active domain
	 */
	// eslint-disable-next-line deprecation/deprecation
	function getActiveDomain() {
	    utils_1.logger.warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
	    var sentry = getMainCarrier().__SENTRY__;
	    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
	}
	exports.getActiveDomain = getActiveDomain;
	/**
	 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
	 * @returns discovered hub
	 */
	function getHubFromActiveDomain(registry) {
	    var _a, _b, _c;
	    try {
	        var activeDomain = (_c = (_b = (_a = getMainCarrier().__SENTRY__) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.domain) === null || _c === void 0 ? void 0 : _c.active;
	        // If there's no active domain, just return global hub
	        if (!activeDomain) {
	            return getHubFromCarrier(registry);
	        }
	        // If there's no hub on current domain, or it's an old API, assign a new one
	        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
	            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
	            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
	        }
	        // Return hub that lives on a domain
	        return getHubFromCarrier(activeDomain);
	    }
	    catch (_Oo) {
	        // Return hub that lives on a global object
	        return getHubFromCarrier(registry);
	    }
	}
	/**
	 * This will tell whether a carrier has a hub on it or not
	 * @param carrier object
	 */
	function hasHubOnCarrier(carrier) {
	    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
	}
	/**
	 * This will create a new {@link Hub} and add to the passed object on
	 * __SENTRY__.hub.
	 * @param carrier object
	 * @hidden
	 */
	function getHubFromCarrier(carrier) {
	    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
	        return carrier.__SENTRY__.hub;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = new Hub();
	    return carrier.__SENTRY__.hub;
	}
	exports.getHubFromCarrier = getHubFromCarrier;
	/**
	 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
	 * @param carrier object
	 * @param hub Hub
	 * @returns A boolean indicating success or failure
	 */
	function setHubOnCarrier(carrier, hub) {
	    if (!carrier)
	        return false;
	    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
	    carrier.__SENTRY__.hub = hub;
	    return true;
	}
	exports.setHubOnCarrier = setHubOnCarrier;
	//# sourceMappingURL=hub.js.map

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	/**
	 * Absolute maximum number of breadcrumbs added to an event.
	 * The `maxBreadcrumbs` option cannot be higher than this value.
	 */
	var MAX_BREADCRUMBS = 100;
	/**
	 * Holds additional event information. {@link Scope.applyToEvent} will be
	 * called by the client before an event will be sent.
	 */
	var Scope = /** @class */ (function () {
	    function Scope() {
	        /** Flag if notifying is happening. */
	        this._notifyingListeners = false;
	        /** Callback for client to receive scope changes. */
	        this._scopeListeners = [];
	        /** Callback list that will be called after {@link applyToEvent}. */
	        this._eventProcessors = [];
	        /** Array of breadcrumbs. */
	        this._breadcrumbs = [];
	        /** User */
	        this._user = {};
	        /** Tags */
	        this._tags = {};
	        /** Extra */
	        this._extra = {};
	        /** Contexts */
	        this._contexts = {};
	    }
	    /**
	     * Inherit values from the parent scope.
	     * @param scope to clone.
	     */
	    Scope.clone = function (scope) {
	        var newScope = new Scope();
	        if (scope) {
	            newScope._breadcrumbs = tslib_1.__spread(scope._breadcrumbs);
	            newScope._tags = tslib_1.__assign({}, scope._tags);
	            newScope._extra = tslib_1.__assign({}, scope._extra);
	            newScope._contexts = tslib_1.__assign({}, scope._contexts);
	            newScope._user = scope._user;
	            newScope._level = scope._level;
	            newScope._span = scope._span;
	            newScope._session = scope._session;
	            newScope._transactionName = scope._transactionName;
	            newScope._fingerprint = scope._fingerprint;
	            newScope._eventProcessors = tslib_1.__spread(scope._eventProcessors);
	            newScope._requestSession = scope._requestSession;
	        }
	        return newScope;
	    };
	    /**
	     * Add internal on change listener. Used for sub SDKs that need to store the scope.
	     * @hidden
	     */
	    Scope.prototype.addScopeListener = function (callback) {
	        this._scopeListeners.push(callback);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addEventProcessor = function (callback) {
	        this._eventProcessors.push(callback);
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setUser = function (user) {
	        this._user = user || {};
	        if (this._session) {
	            this._session.update({ user: user });
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getUser = function () {
	        return this._user;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getRequestSession = function () {
	        return this._requestSession;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setRequestSession = function (requestSession) {
	        this._requestSession = requestSession;
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTags = function (tags) {
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), tags);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTag = function (key, value) {
	        var _a;
	        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtras = function (extras) {
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), extras);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setExtra = function (key, extra) {
	        var _a;
	        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setFingerprint = function (fingerprint) {
	        this._fingerprint = fingerprint;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setLevel = function (level) {
	        this._level = level;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setTransactionName = function (name) {
	        this._transactionName = name;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Can be removed in major version.
	     * @deprecated in favor of {@link this.setTransactionName}
	     */
	    Scope.prototype.setTransaction = function (name) {
	        return this.setTransactionName(name);
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setContext = function (key, context) {
	        var _a;
	        if (context === null) {
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete this._contexts[key];
	        }
	        else {
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSpan = function (span) {
	        this._span = span;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSpan = function () {
	        return this._span;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getTransaction = function () {
	        var _a, _b, _c, _d;
	        // often, this span will be a transaction, but it's not guaranteed to be
	        var span = this.getSpan();
	        // try it the new way first
	        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
	            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
	        }
	        // fallback to the old way (known bug: this only finds transactions with sampled = true)
	        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
	            return span.spanRecorder.spans[0];
	        }
	        // neither way found a transaction
	        return undefined;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.setSession = function (session) {
	        if (!session) {
	            delete this._session;
	        }
	        else {
	            this._session = session;
	        }
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.getSession = function () {
	        return this._session;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.update = function (captureContext) {
	        if (!captureContext) {
	            return this;
	        }
	        if (typeof captureContext === 'function') {
	            var updatedScope = captureContext(this);
	            return updatedScope instanceof Scope ? updatedScope : this;
	        }
	        if (captureContext instanceof Scope) {
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext._tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext._extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext._contexts);
	            if (captureContext._user && Object.keys(captureContext._user).length) {
	                this._user = captureContext._user;
	            }
	            if (captureContext._level) {
	                this._level = captureContext._level;
	            }
	            if (captureContext._fingerprint) {
	                this._fingerprint = captureContext._fingerprint;
	            }
	            if (captureContext._requestSession) {
	                this._requestSession = captureContext._requestSession;
	            }
	        }
	        else if (utils_1.isPlainObject(captureContext)) {
	            // eslint-disable-next-line no-param-reassign
	            captureContext = captureContext;
	            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext.tags);
	            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext.extra);
	            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext.contexts);
	            if (captureContext.user) {
	                this._user = captureContext.user;
	            }
	            if (captureContext.level) {
	                this._level = captureContext.level;
	            }
	            if (captureContext.fingerprint) {
	                this._fingerprint = captureContext.fingerprint;
	            }
	            if (captureContext.requestSession) {
	                this._requestSession = captureContext.requestSession;
	            }
	        }
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clear = function () {
	        this._breadcrumbs = [];
	        this._tags = {};
	        this._extra = {};
	        this._user = {};
	        this._contexts = {};
	        this._level = undefined;
	        this._transactionName = undefined;
	        this._fingerprint = undefined;
	        this._requestSession = undefined;
	        this._span = undefined;
	        this._session = undefined;
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
	        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
	        // No data has been changed, so don't notify scope listeners
	        if (maxCrumbs <= 0) {
	            return this;
	        }
	        var mergedBreadcrumb = tslib_1.__assign({ timestamp: utils_1.dateTimestampInSeconds() }, breadcrumb);
	        this._breadcrumbs = tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    Scope.prototype.clearBreadcrumbs = function () {
	        this._breadcrumbs = [];
	        this._notifyScopeListeners();
	        return this;
	    };
	    /**
	     * Applies the current context and fingerprint to the event.
	     * Note that breadcrumbs will be added by the client.
	     * Also if the event has already breadcrumbs on it, we do not merge them.
	     * @param event Event
	     * @param hint May contain additional information about the original exception.
	     * @hidden
	     */
	    Scope.prototype.applyToEvent = function (event, hint) {
	        var _a;
	        if (this._extra && Object.keys(this._extra).length) {
	            event.extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), event.extra);
	        }
	        if (this._tags && Object.keys(this._tags).length) {
	            event.tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), event.tags);
	        }
	        if (this._user && Object.keys(this._user).length) {
	            event.user = tslib_1.__assign(tslib_1.__assign({}, this._user), event.user);
	        }
	        if (this._contexts && Object.keys(this._contexts).length) {
	            event.contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), event.contexts);
	        }
	        if (this._level) {
	            event.level = this._level;
	        }
	        if (this._transactionName) {
	            event.transaction = this._transactionName;
	        }
	        // We want to set the trace context for normal events only if there isn't already
	        // a trace context on the event. There is a product feature in place where we link
	        // errors with transaction and it relies on that.
	        if (this._span) {
	            event.contexts = tslib_1.__assign({ trace: this._span.getTraceContext() }, event.contexts);
	            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
	            if (transactionName) {
	                event.tags = tslib_1.__assign({ transaction: transactionName }, event.tags);
	            }
	        }
	        this._applyFingerprint(event);
	        event.breadcrumbs = tslib_1.__spread((event.breadcrumbs || []), this._breadcrumbs);
	        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
	        return this._notifyEventProcessors(tslib_1.__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
	    };
	    /**
	     * This will be called after {@link applyToEvent} is finished.
	     */
	    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
	        var _this = this;
	        if (index === void 0) { index = 0; }
	        return new utils_1.SyncPromise(function (resolve, reject) {
	            var processor = processors[index];
	            if (event === null || typeof processor !== 'function') {
	                resolve(event);
	            }
	            else {
	                var result = processor(tslib_1.__assign({}, event), hint);
	                if (utils_1.isThenable(result)) {
	                    void result
	                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
	                        .then(null, reject);
	                }
	                else {
	                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
	                        .then(resolve)
	                        .then(null, reject);
	                }
	            }
	        });
	    };
	    /**
	     * This will be called on every set call.
	     */
	    Scope.prototype._notifyScopeListeners = function () {
	        var _this = this;
	        // We need this check for this._notifyingListeners to be able to work on scope during updates
	        // If this check is not here we'll produce endless recursion when something is done with the scope
	        // during the callback.
	        if (!this._notifyingListeners) {
	            this._notifyingListeners = true;
	            this._scopeListeners.forEach(function (callback) {
	                callback(_this);
	            });
	            this._notifyingListeners = false;
	        }
	    };
	    /**
	     * Applies fingerprint from the scope to the event if there's one,
	     * uses message if there's one instead or get rid of empty fingerprint
	     */
	    Scope.prototype._applyFingerprint = function (event) {
	        // Make sure it's an array first and we actually have something in place
	        event.fingerprint = event.fingerprint
	            ? Array.isArray(event.fingerprint)
	                ? event.fingerprint
	                : [event.fingerprint]
	            : [];
	        // If we have something on the scope, then merge it with event
	        if (this._fingerprint) {
	            event.fingerprint = event.fingerprint.concat(this._fingerprint);
	        }
	        // If we have no data at all, remove empty array default
	        if (event.fingerprint && !event.fingerprint.length) {
	            delete event.fingerprint;
	        }
	    };
	    return Scope;
	}());
	exports.Scope = Scope;
	/**
	 * Returns the global event processors.
	 */
	function getGlobalEventProcessors() {
	    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
	    var global = utils_1.getGlobalObject();
	    global.__SENTRY__ = global.__SENTRY__ || {};
	    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
	    return global.__SENTRY__.globalEventProcessors;
	    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
	}
	/**
	 * Add a EventProcessor to be kept globally.
	 * @param callback EventProcessor to add
	 */
	function addGlobalEventProcessor(callback) {
	    getGlobalEventProcessors().push(callback);
	}
	exports.addGlobalEventProcessor = addGlobalEventProcessor;
	//# sourceMappingURL=scope.js.map

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	/**
	 * @inheritdoc
	 */
	var Session = /** @class */ (function () {
	    function Session(context) {
	        this.errors = 0;
	        this.sid = utils_1.uuid4();
	        this.duration = 0;
	        this.status = types_1.SessionStatus.Ok;
	        this.init = true;
	        this.ignoreDuration = false;
	        // Both timestamp and started are in seconds since the UNIX epoch.
	        var startingTime = utils_1.timestampInSeconds();
	        this.timestamp = startingTime;
	        this.started = startingTime;
	        if (context) {
	            this.update(context);
	        }
	    }
	    /** JSDoc */
	    // eslint-disable-next-line complexity
	    Session.prototype.update = function (context) {
	        if (context === void 0) { context = {}; }
	        if (context.user) {
	            if (!this.ipAddress && context.user.ip_address) {
	                this.ipAddress = context.user.ip_address;
	            }
	            if (!this.did && !context.did) {
	                this.did = context.user.id || context.user.email || context.user.username;
	            }
	        }
	        this.timestamp = context.timestamp || utils_1.timestampInSeconds();
	        if (context.ignoreDuration) {
	            this.ignoreDuration = context.ignoreDuration;
	        }
	        if (context.sid) {
	            // Good enough uuid validation. — Kamil
	            this.sid = context.sid.length === 32 ? context.sid : utils_1.uuid4();
	        }
	        if (context.init !== undefined) {
	            this.init = context.init;
	        }
	        if (!this.did && context.did) {
	            this.did = "" + context.did;
	        }
	        if (typeof context.started === 'number') {
	            this.started = context.started;
	        }
	        if (this.ignoreDuration) {
	            this.duration = undefined;
	        }
	        else if (typeof context.duration === 'number') {
	            this.duration = context.duration;
	        }
	        else {
	            var duration = this.timestamp - this.started;
	            this.duration = duration >= 0 ? duration : 0;
	        }
	        if (context.release) {
	            this.release = context.release;
	        }
	        if (context.environment) {
	            this.environment = context.environment;
	        }
	        if (!this.ipAddress && context.ipAddress) {
	            this.ipAddress = context.ipAddress;
	        }
	        if (!this.userAgent && context.userAgent) {
	            this.userAgent = context.userAgent;
	        }
	        if (typeof context.errors === 'number') {
	            this.errors = context.errors;
	        }
	        if (context.status) {
	            this.status = context.status;
	        }
	    };
	    /** JSDoc */
	    Session.prototype.close = function (status) {
	        if (status) {
	            this.update({ status: status });
	        }
	        else if (this.status === types_1.SessionStatus.Ok) {
	            this.update({ status: types_1.SessionStatus.Exited });
	        }
	        else {
	            this.update();
	        }
	    };
	    /** JSDoc */
	    Session.prototype.toJSON = function () {
	        return utils_1.dropUndefinedKeys({
	            sid: "" + this.sid,
	            init: this.init,
	            // Make sure that sec is converted to ms for date constructor
	            started: new Date(this.started * 1000).toISOString(),
	            timestamp: new Date(this.timestamp * 1000).toISOString(),
	            status: this.status,
	            errors: this.errors,
	            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
	            duration: this.duration,
	            attrs: utils_1.dropUndefinedKeys({
	                release: this.release,
	                environment: this.environment,
	                ip_address: this.ipAddress,
	                user_agent: this.userAgent,
	            }),
	        });
	    };
	    return Session;
	}());
	exports.Session = Session;
	//# sourceMappingURL=session.js.map

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var hub_1 = __webpack_require__(284);
	/**
	 * This calls a function on the current hub.
	 * @param method function to call on hub.
	 * @param args to pass to function.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function callOnHub(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    var hub = hub_1.getCurrentHub();
	    if (hub && hub[method]) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return hub[method].apply(hub, tslib_1.__spread(args));
	    }
	    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
	}
	/**
	 * Captures an exception event and sends it to Sentry.
	 *
	 * @param exception An exception-like object.
	 * @returns The generated eventId.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	function captureException(exception, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error('Sentry syntheticException');
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    return callOnHub('captureException', exception, {
	        captureContext: captureContext,
	        originalException: exception,
	        syntheticException: syntheticException,
	    });
	}
	exports.captureException = captureException;
	/**
	 * Captures a message event and sends it to Sentry.
	 *
	 * @param message The message to send to Sentry.
	 * @param level Define the level of the message.
	 * @returns The generated eventId.
	 */
	function captureMessage(message, captureContext) {
	    var syntheticException;
	    try {
	        throw new Error(message);
	    }
	    catch (exception) {
	        syntheticException = exception;
	    }
	    // This is necessary to provide explicit scopes upgrade, without changing the original
	    // arity of the `captureMessage(message, level)` method.
	    var level = typeof captureContext === 'string' ? captureContext : undefined;
	    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
	    return callOnHub('captureMessage', message, level, tslib_1.__assign({ originalException: message, syntheticException: syntheticException }, context));
	}
	exports.captureMessage = captureMessage;
	/**
	 * Captures a manually created event and sends it to Sentry.
	 *
	 * @param event The event to send to Sentry.
	 * @returns The generated eventId.
	 */
	function captureEvent(event) {
	    return callOnHub('captureEvent', event);
	}
	exports.captureEvent = captureEvent;
	/**
	 * Callback to set context information onto the scope.
	 * @param callback Callback function that receives Scope.
	 */
	function configureScope(callback) {
	    callOnHub('configureScope', callback);
	}
	exports.configureScope = configureScope;
	/**
	 * Records a new breadcrumb which will be attached to future events.
	 *
	 * Breadcrumbs will be added to subsequent events to provide more context on
	 * user's actions prior to an error or crash.
	 *
	 * @param breadcrumb The breadcrumb to record.
	 */
	function addBreadcrumb(breadcrumb) {
	    callOnHub('addBreadcrumb', breadcrumb);
	}
	exports.addBreadcrumb = addBreadcrumb;
	/**
	 * Sets context data with the given name.
	 * @param name of the context
	 * @param context Any kind of data. This data will be normalized.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function setContext(name, context) {
	    callOnHub('setContext', name, context);
	}
	exports.setContext = setContext;
	/**
	 * Set an object that will be merged sent as extra data with the event.
	 * @param extras Extras object to merge into current context.
	 */
	function setExtras(extras) {
	    callOnHub('setExtras', extras);
	}
	exports.setExtras = setExtras;
	/**
	 * Set an object that will be merged sent as tags data with the event.
	 * @param tags Tags context object to merge into current context.
	 */
	function setTags(tags) {
	    callOnHub('setTags', tags);
	}
	exports.setTags = setTags;
	/**
	 * Set key:value that will be sent as extra data with the event.
	 * @param key String of extra
	 * @param extra Any kind of data. This data will be normalized.
	 */
	function setExtra(key, extra) {
	    callOnHub('setExtra', key, extra);
	}
	exports.setExtra = setExtra;
	/**
	 * Set key:value that will be sent as tags data with the event.
	 *
	 * Can also be used to unset a tag, by passing `undefined`.
	 *
	 * @param key String key of tag
	 * @param value Value of tag
	 */
	function setTag(key, value) {
	    callOnHub('setTag', key, value);
	}
	exports.setTag = setTag;
	/**
	 * Updates user context information for future events.
	 *
	 * @param user User context object to be set in the current context. Pass `null` to unset the user.
	 */
	function setUser(user) {
	    callOnHub('setUser', user);
	}
	exports.setUser = setUser;
	/**
	 * Creates a new scope with and executes the given operation within.
	 * The scope is automatically removed once the operation
	 * finishes or throws.
	 *
	 * This is essentially a convenience function for:
	 *
	 *     pushScope();
	 *     callback();
	 *     popScope();
	 *
	 * @param callback that will be enclosed into push/popScope.
	 */
	function withScope(callback) {
	    callOnHub('withScope', callback);
	}
	exports.withScope = withScope;
	/**
	 * Calls a function on the latest client. Use this with caution, it's meant as
	 * in "internal" helper so we don't need to expose every possible function in
	 * the shim. It is not guaranteed that the client actually implements the
	 * function.
	 *
	 * @param method The method to call on the client/client.
	 * @param args Arguments to pass to the client/fontend.
	 * @hidden
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function _callOnClient(method) {
	    var args = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        args[_i - 1] = arguments[_i];
	    }
	    callOnHub.apply(void 0, tslib_1.__spread(['_invokeClient', method], args));
	}
	exports._callOnClient = _callOnClient;
	/**
	 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
	 *
	 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
	 * new child span within the transaction or any span, call the respective `.startChild()` method.
	 *
	 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
	 *
	 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
	 * finished child spans will be sent to Sentry.
	 *
	 * @param context Properties of the new `Transaction`.
	 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
	 * default values). See {@link Options.tracesSampler}.
	 *
	 * @returns The transaction which was just started
	 */
	function startTransaction(context, customSamplingContext) {
	    return callOnHub('startTransaction', tslib_1.__assign({}, context), customSamplingContext);
	}
	exports.startTransaction = startTransaction;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	var spanstatus_1 = __webpack_require__(386);
	var utils_2 = __webpack_require__(387);
	exports.DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
	exports.defaultRequestInstrumentationOptions = {
	    traceFetch: true,
	    traceXHR: true,
	    tracingOrigins: exports.DEFAULT_TRACING_ORIGINS,
	};
	/** Registers span creators for xhr and fetch requests  */
	function instrumentOutgoingRequests(_options) {
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    var _a = tslib_1.__assign(tslib_1.__assign({}, exports.defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	    // We should cache url -> decision so that we don't have to compute
	    // regexp everytime we create a request.
	    var urlMap = {};
	    var defaultShouldCreateSpan = function (url) {
	        if (urlMap[url]) {
	            return urlMap[url];
	        }
	        var origins = tracingOrigins;
	        urlMap[url] =
	            origins.some(function (origin) { return utils_1.isMatchingPattern(url, origin); }) &&
	                !utils_1.isMatchingPattern(url, 'sentry_key');
	        return urlMap[url];
	    };
	    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
	    // That's why we filter out already unwanted Spans from tracingOrigins
	    var shouldCreateSpan = defaultShouldCreateSpan;
	    if (typeof shouldCreateSpanForRequest === 'function') {
	        shouldCreateSpan = function (url) {
	            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
	        };
	    }
	    var spans = {};
	    if (traceFetch) {
	        utils_1.addInstrumentationHandler({
	            callback: function (handlerData) {
	                fetchCallback(handlerData, shouldCreateSpan, spans);
	            },
	            type: 'fetch',
	        });
	    }
	    if (traceXHR) {
	        utils_1.addInstrumentationHandler({
	            callback: function (handlerData) {
	                xhrCallback(handlerData, shouldCreateSpan, spans);
	            },
	            type: 'xhr',
	        });
	    }
	}
	exports.instrumentOutgoingRequests = instrumentOutgoingRequests;
	/**
	 * Create and track fetch request spans
	 */
	function fetchCallback(handlerData, shouldCreateSpan, spans) {
	    if (!utils_2.hasTracingEnabled() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
	        return;
	    }
	    if (handlerData.endTimestamp && handlerData.fetchData.__span) {
	        var span = spans[handlerData.fetchData.__span];
	        if (span) {
	            if (handlerData.response) {
	                // TODO (kmclb) remove this once types PR goes through
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                span.setHttpStatus(handlerData.response.status);
	            }
	            else if (handlerData.error) {
	                span.setStatus(spanstatus_1.SpanStatus.InternalError);
	            }
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[handlerData.fetchData.__span];
	        }
	        return;
	    }
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { type: 'fetch' }),
	            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
	            op: 'http.client',
	        });
	        handlerData.fetchData.__span = span.spanId;
	        spans[span.spanId] = span;
	        var request = (handlerData.args[0] = handlerData.args[0]);
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var options = (handlerData.args[1] = handlerData.args[1] || {});
	        var headers = options.headers;
	        if (utils_1.isInstanceOf(request, Request)) {
	            headers = request.headers;
	        }
	        if (headers) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (typeof headers.append === 'function') {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                headers.append('sentry-trace', span.toTraceparent());
	            }
	            else if (Array.isArray(headers)) {
	                headers = tslib_1.__spread(headers, [['sentry-trace', span.toTraceparent()]]);
	            }
	            else {
	                headers = tslib_1.__assign(tslib_1.__assign({}, headers), { 'sentry-trace': span.toTraceparent() });
	            }
	        }
	        else {
	            headers = { 'sentry-trace': span.toTraceparent() };
	        }
	        options.headers = headers;
	    }
	}
	exports.fetchCallback = fetchCallback;
	/**
	 * Create and track xhr request spans
	 */
	function xhrCallback(handlerData, shouldCreateSpan, spans) {
	    var _a, _b;
	    if (!utils_2.hasTracingEnabled() || ((_a = handlerData.xhr) === null || _a === void 0 ? void 0 : _a.__sentry_own_request__) ||
	        !(((_b = handlerData.xhr) === null || _b === void 0 ? void 0 : _b.__sentry_xhr__) && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
	        return;
	    }
	    var xhr = handlerData.xhr.__sentry_xhr__;
	    // check first if the request has finished and is tracked by an existing span which should now end
	    if (handlerData.endTimestamp && handlerData.xhr.__sentry_xhr_span_id__) {
	        var span = spans[handlerData.xhr.__sentry_xhr_span_id__];
	        if (span) {
	            span.setHttpStatus(xhr.status_code);
	            span.finish();
	            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
	            delete spans[handlerData.xhr.__sentry_xhr_span_id__];
	        }
	        return;
	    }
	    // if not, create a new span to track it
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        var span = activeTransaction.startChild({
	            data: tslib_1.__assign(tslib_1.__assign({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
	            description: xhr.method + " " + xhr.url,
	            op: 'http.client',
	        });
	        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
	        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
	        if (handlerData.xhr.setRequestHeader) {
	            try {
	                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
	            }
	            catch (_) {
	                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
	            }
	        }
	    }
	}
	exports.xhrCallback = xhrCallback;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	// Store finish reasons in tuple to save on bundle size
	// Readonly type should enforce that this is not mutated.
	exports.FINISH_REASON_TAG = 'finishReason';
	exports.IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];
	//# sourceMappingURL=constants.js.map

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var global_1 = __webpack_require__(388);
	var is_1 = __webpack_require__(487);
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function htmlTreeAsString(elem, keyAttrs) {
	    // try/catch both:
	    // - accessing event.target (see getsentry/raven-js#838, #768)
	    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	    // - can throw an exception in some circumstances.
	    try {
	        var currentElem = elem;
	        var MAX_TRAVERSE_HEIGHT = 5;
	        var MAX_OUTPUT_LEN = 80;
	        var out = [];
	        var height = 0;
	        var len = 0;
	        var separator = ' > ';
	        var sepLength = separator.length;
	        var nextStr = void 0;
	        // eslint-disable-next-line no-plusplus
	        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
	            nextStr = _htmlElementAsString(currentElem, keyAttrs);
	            // bail out if
	            // - nextStr is the 'html' element
	            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	            //   (ignore this limit if we are on the first iteration)
	            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
	                break;
	            }
	            out.push(nextStr);
	            len += nextStr.length;
	            currentElem = currentElem.parentNode;
	        }
	        return out.reverse().join(separator);
	    }
	    catch (_oO) {
	        return '<unknown>';
	    }
	}
	exports.htmlTreeAsString = htmlTreeAsString;
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @returns generated DOM path
	 */
	function _htmlElementAsString(el, keyAttrs) {
	    var _a, _b;
	    var elem = el;
	    var out = [];
	    var className;
	    var classes;
	    var key;
	    var attr;
	    var i;
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	    out.push(elem.tagName.toLowerCase());
	    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
	    var keyAttrPairs = ((_a = keyAttrs) === null || _a === void 0 ? void 0 : _a.length) ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
	        : null;
	    if ((_b = keyAttrPairs) === null || _b === void 0 ? void 0 : _b.length) {
	        keyAttrPairs.forEach(function (keyAttrPair) {
	            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
	        });
	    }
	    else {
	        if (elem.id) {
	            out.push("#" + elem.id);
	        }
	        // eslint-disable-next-line prefer-const
	        className = elem.className;
	        if (className && is_1.isString(className)) {
	            classes = className.split(/\s+/);
	            for (i = 0; i < classes.length; i++) {
	                out.push("." + classes[i]);
	            }
	        }
	    }
	    var allowedAttrs = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < allowedAttrs.length; i++) {
	        key = allowedAttrs[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push("[" + key + "=\"" + attr + "\"]");
	        }
	    }
	    return out.join('');
	}
	/**
	 * A safe form of location.href
	 */
	function getLocationHref() {
	    var global = global_1.getGlobalObject();
	    try {
	        return global.document.location.href;
	    }
	    catch (oO) {
	        return '';
	    }
	}
	exports.getLocationHref = getLocationHref;
	//# sourceMappingURL=browser.js.map

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/**
	 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
	 */
	var Memo = /** @class */ (function () {
	    function Memo() {
	        this._hasWeakSet = typeof WeakSet === 'function';
	        this._inner = this._hasWeakSet ? new WeakSet() : [];
	    }
	    /**
	     * Sets obj to remember.
	     * @param obj Object to remember
	     */
	    Memo.prototype.memoize = function (obj) {
	        if (this._hasWeakSet) {
	            if (this._inner.has(obj)) {
	                return true;
	            }
	            this._inner.add(obj);
	            return false;
	        }
	        // eslint-disable-next-line @typescript-eslint/prefer-for-of
	        for (var i = 0; i < this._inner.length; i++) {
	            var value = this._inner[i];
	            if (value === obj) {
	                return true;
	            }
	        }
	        this._inner.push(obj);
	        return false;
	    };
	    /**
	     * Removes object from internal storage.
	     * @param obj Object to forget
	     */
	    Memo.prototype.unmemoize = function (obj) {
	        if (this._hasWeakSet) {
	            this._inner.delete(obj);
	        }
	        else {
	            for (var i = 0; i < this._inner.length; i++) {
	                if (this._inner[i] === obj) {
	                    this._inner.splice(i, 1);
	                    break;
	                }
	            }
	        }
	    };
	    return Memo;
	}());
	exports.Memo = Memo;
	//# sourceMappingURL=memo.js.map

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var browser_1 = __webpack_require__(1679);
	var is_1 = __webpack_require__(487);
	var memo_1 = __webpack_require__(1680);
	var stacktrace_1 = __webpack_require__(1081);
	var string_1 = __webpack_require__(1082);
	/**
	 * Replace a method in an object with a wrapped version of itself.
	 *
	 * @param source An object that contains a method to be wrapped.
	 * @param name The name of the method to be wrapped.
	 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
	 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
	 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
	 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
	 * @returns void
	 */
	function fill(source, name, replacementFactory) {
	    if (!(name in source)) {
	        return;
	    }
	    var original = source[name];
	    var wrapped = replacementFactory(original);
	    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
	    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
	    if (typeof wrapped === 'function') {
	        try {
	            wrapped.prototype = wrapped.prototype || {};
	            Object.defineProperties(wrapped, {
	                __sentry_original__: {
	                    enumerable: false,
	                    value: original,
	                },
	            });
	        }
	        catch (_Oo) {
	            // This can throw if multiple fill happens on a global object like XMLHttpRequest
	            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
	        }
	    }
	    source[name] = wrapped;
	}
	exports.fill = fill;
	/**
	 * Encodes given object into url-friendly format
	 *
	 * @param object An object that contains serializable values
	 * @returns string Encoded
	 */
	function urlEncode(object) {
	    return Object.keys(object)
	        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
	        .join('&');
	}
	exports.urlEncode = urlEncode;
	/**
	 * Transforms any object into an object literal with all its attributes
	 * attached to it.
	 *
	 * @param value Initial source that we have to transform in order for it to be usable by the serializer
	 */
	function getWalkSource(value) {
	    if (is_1.isError(value)) {
	        var error = value;
	        var err = {
	            message: error.message,
	            name: error.name,
	            stack: error.stack,
	        };
	        for (var i in error) {
	            if (Object.prototype.hasOwnProperty.call(error, i)) {
	                err[i] = error[i];
	            }
	        }
	        return err;
	    }
	    if (is_1.isEvent(value)) {
	        var event_1 = value;
	        var source = {};
	        // Accessing event attributes can throw (see https://github.com/getsentry/sentry-javascript/issues/768 and
	        // https://github.com/getsentry/sentry-javascript/issues/838), but accessing `type` hasn't been wrapped in a
	        // try-catch in at least two years and no one's complained, so that's likely not an issue anymore
	        source.type = event_1.type;
	        try {
	            source.target = is_1.isElement(event_1.target)
	                ? browser_1.htmlTreeAsString(event_1.target)
	                : Object.prototype.toString.call(event_1.target);
	        }
	        catch (_oO) {
	            source.target = '<unknown>';
	        }
	        try {
	            source.currentTarget = is_1.isElement(event_1.currentTarget)
	                ? browser_1.htmlTreeAsString(event_1.currentTarget)
	                : Object.prototype.toString.call(event_1.currentTarget);
	        }
	        catch (_oO) {
	            source.currentTarget = '<unknown>';
	        }
	        if (typeof CustomEvent !== 'undefined' && is_1.isInstanceOf(value, CustomEvent)) {
	            source.detail = event_1.detail;
	        }
	        for (var attr in event_1) {
	            if (Object.prototype.hasOwnProperty.call(event_1, attr)) {
	                source[attr] = event_1[attr];
	            }
	        }
	        return source;
	    }
	    return value;
	}
	/** Calculates bytes size of input string */
	function utf8Length(value) {
	    // eslint-disable-next-line no-bitwise
	    return ~-encodeURI(value).split(/%..|./).length;
	}
	/** Calculates bytes size of input object */
	function jsonSize(value) {
	    return utf8Length(JSON.stringify(value));
	}
	/** JSDoc */
	function normalizeToSize(object, 
	// Default Node.js REPL depth
	depth, 
	// 100kB, as 200kB is max payload size, so half sounds reasonable
	maxSize) {
	    if (depth === void 0) { depth = 3; }
	    if (maxSize === void 0) { maxSize = 100 * 1024; }
	    var serialized = normalize(object, depth);
	    if (jsonSize(serialized) > maxSize) {
	        return normalizeToSize(object, depth - 1, maxSize);
	    }
	    return serialized;
	}
	exports.normalizeToSize = normalizeToSize;
	/**
	 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
	 * booleans, null, and undefined.
	 *
	 * @param value The value to stringify
	 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
	 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
	 *  unchanged.
	 */
	function serializeValue(value) {
	    var type = Object.prototype.toString.call(value);
	    // Node.js REPL notation
	    if (typeof value === 'string') {
	        return value;
	    }
	    if (type === '[object Object]') {
	        return '[Object]';
	    }
	    if (type === '[object Array]') {
	        return '[Array]';
	    }
	    var normalized = normalizeValue(value);
	    return is_1.isPrimitive(normalized) ? normalized : type;
	}
	/**
	 * normalizeValue()
	 *
	 * Takes unserializable input and make it serializable friendly
	 *
	 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
	 * - serializes Error objects
	 * - filter global objects
	 */
	function normalizeValue(value, key) {
	    if (key === 'domain' && value && typeof value === 'object' && value._events) {
	        return '[Domain]';
	    }
	    if (key === 'domainEmitter') {
	        return '[DomainEmitter]';
	    }
	    if (typeof global !== 'undefined' && value === global) {
	        return '[Global]';
	    }
	    // It's safe to use `window` and `document` here in this manner, as we are asserting using `typeof` first
	    // which won't throw if they are not present.
	    // eslint-disable-next-line no-restricted-globals
	    if (typeof window !== 'undefined' && value === window) {
	        return '[Window]';
	    }
	    // eslint-disable-next-line no-restricted-globals
	    if (typeof document !== 'undefined' && value === document) {
	        return '[Document]';
	    }
	    // React's SyntheticEvent thingy
	    if (is_1.isSyntheticEvent(value)) {
	        return '[SyntheticEvent]';
	    }
	    if (typeof value === 'number' && value !== value) {
	        return '[NaN]';
	    }
	    if (value === void 0) {
	        return '[undefined]';
	    }
	    if (typeof value === 'function') {
	        return "[Function: " + stacktrace_1.getFunctionName(value) + "]";
	    }
	    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
	    if (typeof value === 'symbol') {
	        return "[" + String(value) + "]";
	    }
	    if (typeof value === 'bigint') {
	        return "[BigInt: " + String(value) + "]";
	    }
	    return value;
	}
	/**
	 * Walks an object to perform a normalization on it
	 *
	 * @param key of object that's walked in current iteration
	 * @param value object to be walked
	 * @param depth Optional number indicating how deep should walking be performed
	 * @param memo Optional Memo class handling decycling
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function walk(key, value, depth, memo) {
	    if (depth === void 0) { depth = +Infinity; }
	    if (memo === void 0) { memo = new memo_1.Memo(); }
	    // If we reach the maximum depth, serialize whatever has left
	    if (depth === 0) {
	        return serializeValue(value);
	    }
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // If value implements `toJSON` method, call it and return early
	    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
	        return value.toJSON();
	    }
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
	    var normalized = normalizeValue(value, key);
	    if (is_1.isPrimitive(normalized)) {
	        return normalized;
	    }
	    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
	    var source = getWalkSource(value);
	    // Create an accumulator that will act as a parent for all future itterations of that branch
	    var acc = Array.isArray(value) ? [] : {};
	    // If we already walked that branch, bail out, as it's circular reference
	    if (memo.memoize(value)) {
	        return '[Circular ~]';
	    }
	    // Walk all keys of the source
	    for (var innerKey in source) {
	        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
	        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
	            continue;
	        }
	        // Recursively walk through all the child nodes
	        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
	    }
	    // Once walked through all the branches, remove the parent from memo storage
	    memo.unmemoize(value);
	    // Return accumulated values
	    return acc;
	}
	exports.walk = walk;
	/**
	 * normalize()
	 *
	 * - Creates a copy to prevent original input mutation
	 * - Skip non-enumerablers
	 * - Calls `toJSON` if implemented
	 * - Removes circular references
	 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
	 * - Translates known global objects/Classes to a string representations
	 * - Takes care of Error objects serialization
	 * - Optionally limit depth of final output
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function normalize(input, depth) {
	    try {
	        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
	    }
	    catch (_oO) {
	        return '**non-serializable**';
	    }
	}
	exports.normalize = normalize;
	/**
	 * Given any captured exception, extract its keys and create a sorted
	 * and truncated list that will be used inside the event message.
	 * eg. `Non-error exception captured with keys: foo, bar, baz`
	 */
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	function extractExceptionKeysForMessage(exception, maxLength) {
	    if (maxLength === void 0) { maxLength = 40; }
	    var keys = Object.keys(getWalkSource(exception));
	    keys.sort();
	    if (!keys.length) {
	        return '[object has no keys]';
	    }
	    if (keys[0].length >= maxLength) {
	        return string_1.truncate(keys[0], maxLength);
	    }
	    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
	        var serialized = keys.slice(0, includedKeys).join(', ');
	        if (serialized.length > maxLength) {
	            continue;
	        }
	        if (includedKeys === keys.length) {
	            return serialized;
	        }
	        return string_1.truncate(serialized, maxLength);
	    }
	    return '';
	}
	exports.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
	/**
	 * Given any object, return the new object with removed keys that value was `undefined`.
	 * Works recursively on objects and arrays.
	 */
	function dropUndefinedKeys(val) {
	    var e_1, _a;
	    if (is_1.isPlainObject(val)) {
	        var obj = val;
	        var rv = {};
	        try {
	            for (var _b = tslib_1.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var key = _c.value;
	                if (typeof obj[key] !== 'undefined') {
	                    rv[key] = dropUndefinedKeys(obj[key]);
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return rv;
	    }
	    if (Array.isArray(val)) {
	        return val.map(dropUndefinedKeys);
	    }
	    return val;
	}
	exports.dropUndefinedKeys = dropUndefinedKeys;
	/**
	 * Ensure that something is an object.
	 *
	 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
	 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
	 *
	 * @param wat The subject of the objectification
	 * @returns A version of `wat` which can safely be used with `Object` class methods
	 */
	function objectify(wat) {
	    var objectified;
	    switch (true) {
	        case wat === undefined || wat === null:
	            objectified = new String(wat);
	            break;
	        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
	        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
	        // an object in order to wrap it.
	        case typeof wat === 'symbol' || typeof wat === 'bigint':
	            objectified = Object(wat);
	            break;
	        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
	        case is_1.isPrimitive(wat):
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            objectified = new wat.constructor(wat);
	            break;
	        // by process of elimination, at this point we know that `wat` must already be an object
	        default:
	            objectified = wat;
	            break;
	    }
	    return objectified;
	}
	exports.objectify = objectify;
	//# sourceMappingURL=object.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var global_1 = __webpack_require__(388);
	var logger_1 = __webpack_require__(1079);
	/**
	 * Tells whether current environment supports ErrorEvent objects
	 * {@link supportsErrorEvent}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsErrorEvent() {
	    try {
	        new ErrorEvent('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsErrorEvent = supportsErrorEvent;
	/**
	 * Tells whether current environment supports DOMError objects
	 * {@link supportsDOMError}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMError() {
	    try {
	        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
	        // 1 argument required, but only 0 present.
	        // @ts-ignore It really needs 1 argument, not 0.
	        new DOMError('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMError = supportsDOMError;
	/**
	 * Tells whether current environment supports DOMException objects
	 * {@link supportsDOMException}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsDOMException() {
	    try {
	        new DOMException('');
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsDOMException = supportsDOMException;
	/**
	 * Tells whether current environment supports Fetch API
	 * {@link supportsFetch}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsFetch() {
	    if (!('fetch' in global_1.getGlobalObject())) {
	        return false;
	    }
	    try {
	        new Headers();
	        new Request('');
	        new Response();
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsFetch = supportsFetch;
	/**
	 * isNativeFetch checks if the given function is a native implementation of fetch()
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function isNativeFetch(func) {
	    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
	}
	exports.isNativeFetch = isNativeFetch;
	/**
	 * Tells whether current environment supports Fetch API natively
	 * {@link supportsNativeFetch}.
	 *
	 * @returns true if `window.fetch` is natively implemented, false otherwise
	 */
	function supportsNativeFetch() {
	    if (!supportsFetch()) {
	        return false;
	    }
	    var global = global_1.getGlobalObject();
	    // Fast path to avoid DOM I/O
	    // eslint-disable-next-line @typescript-eslint/unbound-method
	    if (isNativeFetch(global.fetch)) {
	        return true;
	    }
	    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
	    // so create a "pure" iframe to see if that has native fetch
	    var result = false;
	    var doc = global.document;
	    // eslint-disable-next-line deprecation/deprecation
	    if (doc && typeof doc.createElement === "function") {
	        try {
	            var sandbox = doc.createElement('iframe');
	            sandbox.hidden = true;
	            doc.head.appendChild(sandbox);
	            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                result = isNativeFetch(sandbox.contentWindow.fetch);
	            }
	            doc.head.removeChild(sandbox);
	        }
	        catch (err) {
	            logger_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
	        }
	    }
	    return result;
	}
	exports.supportsNativeFetch = supportsNativeFetch;
	/**
	 * Tells whether current environment supports ReportingObserver API
	 * {@link supportsReportingObserver}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReportingObserver() {
	    return 'ReportingObserver' in global_1.getGlobalObject();
	}
	exports.supportsReportingObserver = supportsReportingObserver;
	/**
	 * Tells whether current environment supports Referrer Policy API
	 * {@link supportsReferrerPolicy}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsReferrerPolicy() {
	    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	    // https://caniuse.com/#feat=referrer-policy
	    // It doesn't. And it throw exception instead of ignoring this parameter...
	    // REF: https://github.com/getsentry/raven-js/issues/1233
	    if (!supportsFetch()) {
	        return false;
	    }
	    try {
	        new Request('_', {
	            referrerPolicy: 'origin',
	        });
	        return true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	exports.supportsReferrerPolicy = supportsReferrerPolicy;
	/**
	 * Tells whether current environment supports History API
	 * {@link supportsHistory}.
	 *
	 * @returns Answer to the given question.
	 */
	function supportsHistory() {
	    // NOTE: in Chrome App environment, touching history.pushState, *even inside
	    //       a try/catch block*, will cause Chrome to output an error to console.error
	    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	    var global = global_1.getGlobalObject();
	    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var chrome = global.chrome;
	    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
	    return !isChromePackagedApp && hasHistoryApi;
	}
	exports.supportsHistory = supportsHistory;
	//# sourceMappingURL=supports.js.map

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
	/* eslint-disable @typescript-eslint/typedef */
	/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var is_1 = __webpack_require__(487);
	/**
	 * Thenable class that behaves like a Promise and follows it's interface
	 * but is not async internally
	 */
	var SyncPromise = /** @class */ (function () {
	    function SyncPromise(executor) {
	        var _this = this;
	        this._state = "PENDING" /* PENDING */;
	        this._handlers = [];
	        /** JSDoc */
	        this._resolve = function (value) {
	            _this._setResult("RESOLVED" /* RESOLVED */, value);
	        };
	        /** JSDoc */
	        this._reject = function (reason) {
	            _this._setResult("REJECTED" /* REJECTED */, reason);
	        };
	        /** JSDoc */
	        this._setResult = function (state, value) {
	            if (_this._state !== "PENDING" /* PENDING */) {
	                return;
	            }
	            if (is_1.isThenable(value)) {
	                void value.then(_this._resolve, _this._reject);
	                return;
	            }
	            _this._state = state;
	            _this._value = value;
	            _this._executeHandlers();
	        };
	        // TODO: FIXME
	        /** JSDoc */
	        this._attachHandler = function (handler) {
	            _this._handlers = _this._handlers.concat(handler);
	            _this._executeHandlers();
	        };
	        /** JSDoc */
	        this._executeHandlers = function () {
	            if (_this._state === "PENDING" /* PENDING */) {
	                return;
	            }
	            var cachedHandlers = _this._handlers.slice();
	            _this._handlers = [];
	            cachedHandlers.forEach(function (handler) {
	                if (handler.done) {
	                    return;
	                }
	                if (_this._state === "RESOLVED" /* RESOLVED */) {
	                    if (handler.onfulfilled) {
	                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	                        handler.onfulfilled(_this._value);
	                    }
	                }
	                if (_this._state === "REJECTED" /* REJECTED */) {
	                    if (handler.onrejected) {
	                        handler.onrejected(_this._value);
	                    }
	                }
	                handler.done = true;
	            });
	        };
	        try {
	            executor(this._resolve, this._reject);
	        }
	        catch (e) {
	            this._reject(e);
	        }
	    }
	    /** JSDoc */
	    SyncPromise.resolve = function (value) {
	        return new SyncPromise(function (resolve) {
	            resolve(value);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.reject = function (reason) {
	        return new SyncPromise(function (_, reject) {
	            reject(reason);
	        });
	    };
	    /** JSDoc */
	    SyncPromise.all = function (collection) {
	        return new SyncPromise(function (resolve, reject) {
	            if (!Array.isArray(collection)) {
	                reject(new TypeError("Promise.all requires an array as input."));
	                return;
	            }
	            if (collection.length === 0) {
	                resolve([]);
	                return;
	            }
	            var counter = collection.length;
	            var resolvedCollection = [];
	            collection.forEach(function (item, index) {
	                void SyncPromise.resolve(item)
	                    .then(function (value) {
	                    resolvedCollection[index] = value;
	                    counter -= 1;
	                    if (counter !== 0) {
	                        return;
	                    }
	                    resolve(resolvedCollection);
	                })
	                    .then(null, reject);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            _this._attachHandler({
	                done: false,
	                onfulfilled: function (result) {
	                    if (!onfulfilled) {
	                        // TODO: ¯\_(ツ)_/¯
	                        // TODO: FIXME
	                        resolve(result);
	                        return;
	                    }
	                    try {
	                        resolve(onfulfilled(result));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	                onrejected: function (reason) {
	                    if (!onrejected) {
	                        reject(reason);
	                        return;
	                    }
	                    try {
	                        resolve(onrejected(reason));
	                        return;
	                    }
	                    catch (e) {
	                        reject(e);
	                        return;
	                    }
	                },
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.catch = function (onrejected) {
	        return this.then(function (val) { return val; }, onrejected);
	    };
	    /** JSDoc */
	    SyncPromise.prototype.finally = function (onfinally) {
	        var _this = this;
	        return new SyncPromise(function (resolve, reject) {
	            var val;
	            var isRejected;
	            return _this.then(function (value) {
	                isRejected = false;
	                val = value;
	                if (onfinally) {
	                    onfinally();
	                }
	            }, function (reason) {
	                isRejected = true;
	                val = reason;
	                if (onfinally) {
	                    onfinally();
	                }
	            }).then(function () {
	                if (isRejected) {
	                    reject(val);
	                    return;
	                }
	                resolve(val);
	            });
	        });
	    };
	    /** JSDoc */
	    SyncPromise.prototype.toString = function () {
	        return '[object SyncPromise]';
	    };
	    return SyncPromise;
	}());
	exports.SyncPromise = SyncPromise;
	//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _util = __webpack_require__(1083);
	
	var _inject = __webpack_require__(1685);
	
	var StyleSheet = {
	    create: function create(sheetDefinition) {
	        return (0, _util.mapObj)(sheetDefinition, function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2);
	
	            var key = _ref2[0];
	            var val = _ref2[1];
	
	            return [key, {
	                // TODO(emily): Make a 'production' mode which doesn't prepend
	                // the class name here, to make the generated CSS smaller.
	                _name: key + '_' + (0, _util.hashObject)(val),
	                _definition: val
	            }];
	        });
	    },
	
	    rehydrate: function rehydrate() {
	        var renderedClassNames = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	
	        (0, _inject.addRenderedClassNames)(renderedClassNames);
	    }
	};
	
	/**
	 * Utilities for using Aphrodite server-side.
	 */
	var StyleSheetServer = {
	    renderStatic: function renderStatic(renderFunc) {
	        (0, _inject.reset)();
	        (0, _inject.startBuffering)();
	        var html = renderFunc();
	        var cssContent = (0, _inject.flushToString)();
	
	        return {
	            html: html,
	            css: {
	                content: cssContent,
	                renderedClassNames: (0, _inject.getRenderedClassNames)()
	            }
	        };
	    }
	};
	
	/**
	 * Utilities for using Aphrodite in tests.
	 *
	 * Not meant to be used in production.
	 */
	var StyleSheetTestUtils = {
	    /**
	     * Prevent styles from being injected into the DOM.
	     *
	     * This is useful in situations where you'd like to test rendering UI
	     * components which use Aphrodite without any of the side-effects of
	     * Aphrodite happening. Particularly useful for testing the output of
	     * components when you have no DOM, e.g. testing in Node without a fake DOM.
	     *
	     * Should be paired with a subsequent call to
	     * clearBufferAndResumeStyleInjection.
	     */
	    suppressStyleInjection: function suppressStyleInjection() {
	        (0, _inject.reset)();
	        (0, _inject.startBuffering)();
	    },
	
	    /**
	     * Opposite method of preventStyleInject.
	     */
	    clearBufferAndResumeStyleInjection: function clearBufferAndResumeStyleInjection() {
	        (0, _inject.reset)();
	    }
	};
	
	var css = function css() {
	    for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
	        styleDefinitions[_key] = arguments[_key];
	    }
	
	    var useImportant = true; // Append !important to all style definitions
	    return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions);
	};
	
	exports['default'] = {
	    StyleSheet: StyleSheet,
	    StyleSheetServer: StyleSheetServer,
	    StyleSheetTestUtils: StyleSheetTestUtils,
	    css: css
	};
	module.exports = exports['default'];

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _asap = __webpack_require__(2975);
	
	var _asap2 = _interopRequireDefault(_asap);
	
	var _generate = __webpack_require__(2973);
	
	var _util = __webpack_require__(1083);
	
	// The current <style> tag we are inserting into, or null if we haven't
	// inserted anything yet. We could find this each time using
	// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
	// faster.
	var styleTag = null;
	
	// Inject a string of styles into a <style> tag in the head of the document. This
	// will automatically create a style tag and then continue to use it for
	// multiple injections. It will also use a style tag with the `data-aphrodite`
	// tag on it if that exists in the DOM. This could be used for e.g. reusing the
	// same style tag that server-side rendering inserts.
	var injectStyleTag = function injectStyleTag(cssContents) {
	    if (styleTag == null) {
	        // Try to find a style tag with the `data-aphrodite` attribute first.
	        styleTag = document.querySelector("style[data-aphrodite]");
	
	        // If that doesn't work, generate a new style tag.
	        if (styleTag == null) {
	            // Taken from
	            // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
	            var head = document.head || document.getElementsByTagName('head')[0];
	            styleTag = document.createElement('style');
	
	            styleTag.type = 'text/css';
	            styleTag.setAttribute("data-aphrodite", "");
	            head.appendChild(styleTag);
	        }
	    }
	
	    if (styleTag.styleSheet) {
	        styleTag.styleSheet.cssText += cssContents;
	    } else {
	        styleTag.appendChild(document.createTextNode(cssContents));
	    }
	};
	
	// Custom handlers for stringifying CSS values that have side effects
	// (such as fontFamily, which can cause @font-face rules to be injected)
	var stringHandlers = {
	    // With fontFamily we look for objects that are passed in and interpret
	    // them as @font-face rules that we need to inject. The value of fontFamily
	    // can either be a string (as normal), an object (a single font face), or
	    // an array of objects and strings.
	    fontFamily: function fontFamily(val) {
	        if (Array.isArray(val)) {
	            return val.map(fontFamily).join(",");
	        } else if (typeof val === "object") {
	            injectStyleOnce(val.fontFamily, "@font-face", [val], false);
	            return '"' + val.fontFamily + '"';
	        } else {
	            return val;
	        }
	    },
	
	    // With animationName we look for an object that contains keyframes and
	    // inject them as an `@keyframes` block, returning a uniquely generated
	    // name. The keyframes object should look like
	    //  animationName: {
	    //    from: {
	    //      left: 0,
	    //      top: 0,
	    //    },
	    //    '50%': {
	    //      left: 15,
	    //      top: 5,
	    //    },
	    //    to: {
	    //      left: 20,
	    //      top: 20,
	    //    }
	    //  }
	    // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
	    // to use `animationName` here. Improve that so we can call this
	    // `animation` instead of `animationName`.
	    animationName: function animationName(val) {
	        if (typeof val !== "object") {
	            return val;
	        }
	
	        // Generate a unique name based on the hash of the object. We can't
	        // just use the hash because the name can't start with a number.
	        // TODO(emily): this probably makes debugging hard, allow a custom
	        // name?
	        var name = 'keyframe_' + (0, _util.hashObject)(val);
	
	        // Since keyframes need 3 layers of nesting, we use `generateCSS` to
	        // build the inner layers and wrap it in `@keyframes` ourselves.
	        var finalVal = '@keyframes ' + name + '{';
	        Object.keys(val).forEach(function (key) {
	            finalVal += (0, _generate.generateCSS)(key, [val[key]], stringHandlers, false);
	        });
	        finalVal += '}';
	
	        injectGeneratedCSSOnce(name, finalVal);
	
	        return name;
	    }
	};
	
	// This is a map from Aphrodite's generated class names to `true` (acting as a
	// set of class names)
	var alreadyInjected = {};
	
	// This is the buffer of styles which have not yet been flushed.
	var injectionBuffer = "";
	
	// A flag to tell if we are already buffering styles. This could happen either
	// because we scheduled a flush call already, so newly added styles will
	// already be flushed, or because we are statically buffering on the server.
	var isBuffering = false;
	
	var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
	    if (!alreadyInjected[key]) {
	        if (!isBuffering) {
	            // We should never be automatically buffering on the server (or any
	            // place without a document), so guard against that.
	            if (typeof document === "undefined") {
	                throw new Error("Cannot automatically buffer without a document");
	            }
	
	            // If we're not already buffering, schedule a call to flush the
	            // current styles.
	            isBuffering = true;
	            (0, _asap2['default'])(flushToStyleTag);
	        }
	
	        injectionBuffer += generatedCSS;
	        alreadyInjected[key] = true;
	    }
	};
	
	var injectStyleOnce = function injectStyleOnce(key, selector, definitions, useImportant) {
	    if (!alreadyInjected[key]) {
	        var generated = (0, _generate.generateCSS)(selector, definitions, stringHandlers, useImportant);
	
	        injectGeneratedCSSOnce(key, generated);
	    }
	};
	
	exports.injectStyleOnce = injectStyleOnce;
	var reset = function reset() {
	    injectionBuffer = "";
	    alreadyInjected = {};
	    isBuffering = false;
	    styleTag = null;
	};
	
	exports.reset = reset;
	var startBuffering = function startBuffering() {
	    if (isBuffering) {
	        throw new Error("Cannot buffer while already buffering");
	    }
	    isBuffering = true;
	};
	
	exports.startBuffering = startBuffering;
	var flushToString = function flushToString() {
	    isBuffering = false;
	    var ret = injectionBuffer;
	    injectionBuffer = "";
	    return ret;
	};
	
	exports.flushToString = flushToString;
	var flushToStyleTag = function flushToStyleTag() {
	    var cssContent = flushToString();
	    if (cssContent.length > 0) {
	        injectStyleTag(cssContent);
	    }
	};
	
	exports.flushToStyleTag = flushToStyleTag;
	var getRenderedClassNames = function getRenderedClassNames() {
	    return Object.keys(alreadyInjected);
	};
	
	exports.getRenderedClassNames = getRenderedClassNames;
	var addRenderedClassNames = function addRenderedClassNames(classNames) {
	    classNames.forEach(function (className) {
	        alreadyInjected[className] = true;
	    });
	};
	
	exports.addRenderedClassNames = addRenderedClassNames;
	/**
	 * Inject styles associated with the passed style definition objects, and return
	 * an associated CSS class name.
	 *
	 * @param {boolean} useImportant If true, will append !important to generated
	 *     CSS output. e.g. {color: red} -> "color: red !important".
	 * @param {Object[]} styleDefinitions style definition objects as returned as
	 *     properties of the return value of StyleSheet.create().
	 */
	var injectAndGetClassName = function injectAndGetClassName(useImportant, styleDefinitions) {
	    // Filter out falsy values from the input, to allow for
	    // `css(a, test && c)`
	    var validDefinitions = styleDefinitions.filter(function (def) {
	        return def;
	    });
	
	    // Break if there aren't any valid styles.
	    if (validDefinitions.length === 0) {
	        return "";
	    }
	
	    var className = validDefinitions.map(function (s) {
	        return s._name;
	    }).join("-o_O-");
	    injectStyleOnce(className, '.' + className, validDefinitions.map(function (d) {
	        return d._definition;
	    }), useImportant);
	
	    return className;
	};
	exports.injectAndGetClassName = injectAndGetClassName;

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AnchorTagBuilder = void 0;
	var html_tag_1 = __webpack_require__(1085);
	var truncate_smart_1 = __webpack_require__(2982);
	var truncate_middle_1 = __webpack_require__(2981);
	var truncate_end_1 = __webpack_require__(2980);
	/**
	 * @protected
	 * @class Autolinker.AnchorTagBuilder
	 * @extends Object
	 *
	 * Builds anchor (&lt;a&gt;) tags for the Autolinker utility when a match is
	 * found.
	 *
	 * Normally this class is instantiated, configured, and used internally by an
	 * {@link Autolinker} instance, but may actually be used indirectly in a
	 * {@link Autolinker#replaceFn replaceFn} to create {@link Autolinker.HtmlTag HtmlTag}
	 * instances which may be modified before returning from the
	 * {@link Autolinker#replaceFn replaceFn}. For example:
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( match ) {
	 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 */
	var AnchorTagBuilder = /** @class */ (function () {
	    /**
	     * @method constructor
	     * @param {Object} [cfg] The configuration options for the AnchorTagBuilder instance, specified in an Object (map).
	     */
	    function AnchorTagBuilder(cfg) {
	        if (cfg === void 0) { cfg = {}; }
	        /**
	         * @cfg {Boolean} newWindow
	         * @inheritdoc Autolinker#newWindow
	         */
	        this.newWindow = false; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Object} truncate
	         * @inheritdoc Autolinker#truncate
	         */
	        this.truncate = {}; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {String} className
	         * @inheritdoc Autolinker#className
	         */
	        this.className = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
	        this.newWindow = cfg.newWindow || false;
	        this.truncate = cfg.truncate || {};
	        this.className = cfg.className || '';
	    }
	    /**
	     * Generates the actual anchor (&lt;a&gt;) tag to use in place of the
	     * matched text, via its `match` object.
	     *
	     * @param {Autolinker.match.Match} match The Match instance to generate an
	     *   anchor tag from.
	     * @return {Autolinker.HtmlTag} The HtmlTag instance for the anchor tag.
	     */
	    AnchorTagBuilder.prototype.build = function (match) {
	        return new html_tag_1.HtmlTag({
	            tagName: 'a',
	            attrs: this.createAttrs(match),
	            innerHtml: this.processAnchorText(match.getAnchorText()),
	        });
	    };
	    /**
	     * Creates the Object (map) of the HTML attributes for the anchor (&lt;a&gt;)
	     *   tag being generated.
	     *
	     * @protected
	     * @param {Autolinker.match.Match} match The Match instance to generate an
	     *   anchor tag from.
	     * @return {Object} A key/value Object (map) of the anchor tag's attributes.
	     */
	    AnchorTagBuilder.prototype.createAttrs = function (match) {
	        var attrs = {
	            href: match.getAnchorHref(), // we'll always have the `href` attribute
	        };
	        var cssClass = this.createCssClass(match);
	        if (cssClass) {
	            attrs['class'] = cssClass;
	        }
	        if (this.newWindow) {
	            attrs['target'] = '_blank';
	            attrs['rel'] = 'noopener noreferrer'; // Issue #149. See https://mathiasbynens.github.io/rel-noopener/
	        }
	        if (this.truncate) {
	            if (this.truncate.length && this.truncate.length < match.getAnchorText().length) {
	                attrs['title'] = match.getAnchorHref();
	            }
	        }
	        return attrs;
	    };
	    /**
	     * Creates the CSS class that will be used for a given anchor tag, based on
	     * the `matchType` and the {@link #className} config.
	     *
	     * Example returns:
	     *
	     * - ""                                      // no {@link #className}
	     * - "myLink myLink-url"                     // url match
	     * - "myLink myLink-email"                   // email match
	     * - "myLink myLink-phone"                   // phone match
	     * - "myLink myLink-hashtag"                 // hashtag match
	     * - "myLink myLink-mention myLink-twitter"  // mention match with Twitter service
	     *
	     * @protected
	     * @param {Autolinker.match.Match} match The Match instance to generate an
	     *   anchor tag from.
	     * @return {String} The CSS class string for the link. Example return:
	     *   "myLink myLink-url". If no {@link #className} was configured, returns
	     *   an empty string.
	     */
	    AnchorTagBuilder.prototype.createCssClass = function (match) {
	        var className = this.className;
	        if (!className) {
	            return '';
	        }
	        else {
	            var returnClasses = [className], cssClassSuffixes = match.getCssClassSuffixes();
	            for (var i = 0, len = cssClassSuffixes.length; i < len; i++) {
	                returnClasses.push(className + '-' + cssClassSuffixes[i]);
	            }
	            return returnClasses.join(' ');
	        }
	    };
	    /**
	     * Processes the `anchorText` by truncating the text according to the
	     * {@link #truncate} config.
	     *
	     * @private
	     * @param {String} anchorText The anchor tag's text (i.e. what will be
	     *   displayed).
	     * @return {String} The processed `anchorText`.
	     */
	    AnchorTagBuilder.prototype.processAnchorText = function (anchorText) {
	        anchorText = this.doTruncate(anchorText);
	        return anchorText;
	    };
	    /**
	     * Performs the truncation of the `anchorText` based on the {@link #truncate}
	     * option. If the `anchorText` is longer than the length specified by the
	     * {@link #truncate} option, the truncation is performed based on the
	     * `location` property. See {@link #truncate} for details.
	     *
	     * @private
	     * @param {String} anchorText The anchor tag's text (i.e. what will be
	     *   displayed).
	     * @return {String} The truncated anchor text.
	     */
	    AnchorTagBuilder.prototype.doTruncate = function (anchorText) {
	        var truncate = this.truncate;
	        if (!truncate || !truncate.length)
	            return anchorText;
	        var truncateLength = truncate.length, truncateLocation = truncate.location;
	        if (truncateLocation === 'smart') {
	            return (0, truncate_smart_1.truncateSmart)(anchorText, truncateLength);
	        }
	        else if (truncateLocation === 'middle') {
	            return (0, truncate_middle_1.truncateMiddle)(anchorText, truncateLength);
	        }
	        else {
	            return (0, truncate_end_1.truncateEnd)(anchorText, truncateLength);
	        }
	    };
	    return AnchorTagBuilder;
	}());
	exports.AnchorTagBuilder = AnchorTagBuilder;
	//# sourceMappingURL=anchor-tag-builder.js.map

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EmailMatcher = void 0;
	var tslib_1 = __webpack_require__(181);
	var matcher_1 = __webpack_require__(391);
	var regex_lib_1 = __webpack_require__(392);
	var email_match_1 = __webpack_require__(1086);
	var utils_1 = __webpack_require__(488);
	var tld_regex_1 = __webpack_require__(1692);
	// For debugging: search for other "For debugging" lines
	// import CliTable from 'cli-table';
	// RegExp objects which are shared by all instances of EmailMatcher. These are
	// here to avoid re-instantiating the RegExp objects if `Autolinker.link()` is
	// called multiple times, thus instantiating EmailMatcher and its RegExp
	// objects each time (which is very expensive - see https://github.com/gregjacobs/Autolinker.js/issues/314).
	// See descriptions of the properties where they are used for details about them
	var localPartCharRegex = new RegExp("[".concat(regex_lib_1.alphaNumericAndMarksCharsStr, "!#$%&'*+/=?^_`{|}~-]"));
	var strictTldRegex = new RegExp("^".concat(tld_regex_1.tldRegex.source, "$"));
	/**
	 * @class Autolinker.matcher.Email
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find email matches in an input string.
	 *
	 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
	 */
	var EmailMatcher = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(EmailMatcher, _super);
	    function EmailMatcher() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * Valid characters that can be used in the "local" part of an email address,
	         * i.e. the "name" part of "name@site.com"
	         */
	        _this.localPartCharRegex = localPartCharRegex;
	        /**
	         * Stricter TLD regex which adds a beginning and end check to ensure
	         * the string is a valid TLD
	         */
	        _this.strictTldRegex = strictTldRegex;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    EmailMatcher.prototype.parseMatches = function (text) {
	        var tagBuilder = this.tagBuilder, localPartCharRegex = this.localPartCharRegex, strictTldRegex = this.strictTldRegex, matches = [], len = text.length, noCurrentEmailMatch = new CurrentEmailMatch();
	        // for matching a 'mailto:' prefix
	        var mailtoTransitions = {
	            m: 'a',
	            a: 'i',
	            i: 'l',
	            l: 't',
	            t: 'o',
	            o: ':',
	        };
	        var charIdx = 0, state = 0 /* NonEmailMatch */, currentEmailMatch = noCurrentEmailMatch;
	        // For debugging: search for other "For debugging" lines
	        // const table = new CliTable( {
	        // 	head: [ 'charIdx', 'char', 'state', 'charIdx', 'currentEmailAddress.idx', 'hasDomainDot' ]
	        // } );
	        while (charIdx < len) {
	            var char = text.charAt(charIdx);
	            // For debugging: search for other "For debugging" lines
	            // table.push(
	            // 	[ charIdx, char, State[ state ], charIdx, currentEmailAddress.idx, currentEmailAddress.hasDomainDot ]
	            // );
	            switch (state) {
	                case 0 /* NonEmailMatch */:
	                    stateNonEmailAddress(char);
	                    break;
	                case 1 /* Mailto */:
	                    stateMailTo(text.charAt(charIdx - 1), char);
	                    break;
	                case 2 /* LocalPart */:
	                    stateLocalPart(char);
	                    break;
	                case 3 /* LocalPartDot */:
	                    stateLocalPartDot(char);
	                    break;
	                case 4 /* AtSign */:
	                    stateAtSign(char);
	                    break;
	                case 5 /* DomainChar */:
	                    stateDomainChar(char);
	                    break;
	                case 6 /* DomainHyphen */:
	                    stateDomainHyphen(char);
	                    break;
	                case 7 /* DomainDot */:
	                    stateDomainDot(char);
	                    break;
	                default:
	                    (0, utils_1.throwUnhandledCaseError)(state);
	            }
	            // For debugging: search for other "For debugging" lines
	            // table.push(
	            // 	[ charIdx, char, State[ state ], charIdx, currentEmailAddress.idx, currentEmailAddress.hasDomainDot ]
	            // );
	            charIdx++;
	        }
	        // Capture any valid match at the end of the string
	        captureMatchIfValidAndReset();
	        // For debugging: search for other "For debugging" lines
	        //console.log( '\n' + table.toString() );
	        return matches;
	        // Handles the state when we're not in an email address
	        function stateNonEmailAddress(char) {
	            if (char === 'm') {
	                beginEmailMatch(1 /* Mailto */);
	            }
	            else if (localPartCharRegex.test(char)) {
	                beginEmailMatch();
	            }
	            else {
	                // not an email address character, continue
	            }
	        }
	        // Handles if we're reading a 'mailto:' prefix on the string
	        function stateMailTo(prevChar, char) {
	            if (prevChar === ':') {
	                // We've reached the end of the 'mailto:' prefix
	                if (localPartCharRegex.test(char)) {
	                    state = 2 /* LocalPart */;
	                    currentEmailMatch = new CurrentEmailMatch((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentEmailMatch), { hasMailtoPrefix: true }));
	                }
	                else {
	                    // we've matched 'mailto:' but didn't get anything meaningful
	                    // immediately afterwards (for example, we encountered a
	                    // space character, or an '@' character which formed 'mailto:@'
	                    resetToNonEmailMatchState();
	                }
	            }
	            else if (mailtoTransitions[prevChar] === char) {
	                // We're currently reading the 'mailto:' prefix, stay in
	                // Mailto state
	            }
	            else if (localPartCharRegex.test(char)) {
	                // We we're reading a prefix of 'mailto:', but encountered a
	                // different character that didn't continue the prefix
	                state = 2 /* LocalPart */;
	            }
	            else if (char === '.') {
	                // We we're reading a prefix of 'mailto:', but encountered a
	                // dot character
	                state = 3 /* LocalPartDot */;
	            }
	            else if (char === '@') {
	                // We we're reading a prefix of 'mailto:', but encountered a
	                // an @ character
	                state = 4 /* AtSign */;
	            }
	            else {
	                // not an email address character, return to "NonEmailAddress" state
	                resetToNonEmailMatchState();
	            }
	        }
	        // Handles the state when we're currently in the "local part" of an
	        // email address (as opposed to the "domain part")
	        function stateLocalPart(char) {
	            if (char === '.') {
	                state = 3 /* LocalPartDot */;
	            }
	            else if (char === '@') {
	                state = 4 /* AtSign */;
	            }
	            else if (localPartCharRegex.test(char)) {
	                // stay in the "local part" of the email address
	            }
	            else {
	                // not an email address character, return to "NonEmailAddress" state
	                resetToNonEmailMatchState();
	            }
	        }
	        // Handles the state where we've read
	        function stateLocalPartDot(char) {
	            if (char === '.') {
	                // We read a second '.' in a row, not a valid email address
	                // local part
	                resetToNonEmailMatchState();
	            }
	            else if (char === '@') {
	                // We read the '@' character immediately after a dot ('.'), not
	                // an email address
	                resetToNonEmailMatchState();
	            }
	            else if (localPartCharRegex.test(char)) {
	                state = 2 /* LocalPart */;
	            }
	            else {
	                // Anything else, not an email address
	                resetToNonEmailMatchState();
	            }
	        }
	        function stateAtSign(char) {
	            if (regex_lib_1.domainNameCharRegex.test(char)) {
	                state = 5 /* DomainChar */;
	            }
	            else {
	                // Anything else, not an email address
	                resetToNonEmailMatchState();
	            }
	        }
	        function stateDomainChar(char) {
	            if (char === '.') {
	                state = 7 /* DomainDot */;
	            }
	            else if (char === '-') {
	                state = 6 /* DomainHyphen */;
	            }
	            else if (regex_lib_1.domainNameCharRegex.test(char)) {
	                // Stay in the DomainChar state
	            }
	            else {
	                // Anything else, we potentially matched if the criteria has
	                // been met
	                captureMatchIfValidAndReset();
	            }
	        }
	        function stateDomainHyphen(char) {
	            if (char === '-' || char === '.') {
	                // Not valid to have two hyphens ("--") or hypen+dot ("-.")
	                captureMatchIfValidAndReset();
	            }
	            else if (regex_lib_1.domainNameCharRegex.test(char)) {
	                state = 5 /* DomainChar */;
	            }
	            else {
	                // Anything else
	                captureMatchIfValidAndReset();
	            }
	        }
	        function stateDomainDot(char) {
	            if (char === '.' || char === '-') {
	                // not valid to have two dots ("..") or dot+hypen (".-")
	                captureMatchIfValidAndReset();
	            }
	            else if (regex_lib_1.domainNameCharRegex.test(char)) {
	                state = 5 /* DomainChar */;
	                // After having read a '.' and then a valid domain character,
	                // we now know that the domain part of the email is valid, and
	                // we have found at least a partial EmailMatch (however, the
	                // email address may have additional characters from this point)
	                currentEmailMatch = new CurrentEmailMatch((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentEmailMatch), { hasDomainDot: true }));
	            }
	            else {
	                // Anything else
	                captureMatchIfValidAndReset();
	            }
	        }
	        function beginEmailMatch(newState) {
	            if (newState === void 0) { newState = 2 /* LocalPart */; }
	            state = newState;
	            currentEmailMatch = new CurrentEmailMatch({ idx: charIdx });
	        }
	        function resetToNonEmailMatchState() {
	            state = 0 /* NonEmailMatch */;
	            currentEmailMatch = noCurrentEmailMatch;
	        }
	        /*
	         * Captures the current email address as an EmailMatch if it's valid,
	         * and resets the state to read another email address.
	         */
	        function captureMatchIfValidAndReset() {
	            if (currentEmailMatch.hasDomainDot) {
	                // we need at least one dot in the domain to be considered a valid email address
	                var matchedText = text.slice(currentEmailMatch.idx, charIdx);
	                // If we read a '.' or '-' char that ended the email address
	                // (valid domain name characters, but only valid email address
	                // characters if they are followed by something else), strip
	                // it off now
	                if (/[-.]$/.test(matchedText)) {
	                    matchedText = matchedText.slice(0, -1);
	                }
	                var emailAddress = currentEmailMatch.hasMailtoPrefix
	                    ? matchedText.slice('mailto:'.length)
	                    : matchedText;
	                // if the email address has a valid TLD, add it to the list of matches
	                if (doesEmailHaveValidTld(emailAddress)) {
	                    matches.push(new email_match_1.EmailMatch({
	                        tagBuilder: tagBuilder,
	                        matchedText: matchedText,
	                        offset: currentEmailMatch.idx,
	                        email: emailAddress,
	                    }));
	                }
	            }
	            resetToNonEmailMatchState();
	            /**
	             * Determines if the given email address has a valid TLD or not
	             * @param {string} emailAddress - email address
	             * @return {Boolean} - true is email have valid TLD, false otherwise
	             */
	            function doesEmailHaveValidTld(emailAddress) {
	                var emailAddressTld = emailAddress.split('.').pop() || '';
	                var emailAddressNormalized = emailAddressTld.toLowerCase();
	                var isValidTld = strictTldRegex.test(emailAddressNormalized);
	                return isValidTld;
	            }
	        }
	    };
	    return EmailMatcher;
	}(matcher_1.Matcher));
	exports.EmailMatcher = EmailMatcher;
	var CurrentEmailMatch = /** @class */ (function () {
	    function CurrentEmailMatch(cfg) {
	        if (cfg === void 0) { cfg = {}; }
	        this.idx = cfg.idx !== undefined ? cfg.idx : -1;
	        this.hasMailtoPrefix = !!cfg.hasMailtoPrefix;
	        this.hasDomainDot = !!cfg.hasDomainDot;
	    }
	    return CurrentEmailMatch;
	}());
	//# sourceMappingURL=email-matcher.js.map

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.hashtagServices = exports.HashtagMatcher = void 0;
	var tslib_1 = __webpack_require__(181);
	var matcher_1 = __webpack_require__(391);
	var regex_lib_1 = __webpack_require__(392);
	var hashtag_match_1 = __webpack_require__(1087);
	var utils_1 = __webpack_require__(488);
	// For debugging: search for other "For debugging" lines
	// import CliTable from 'cli-table';
	var hashtagTextCharRe = new RegExp("[_".concat(regex_lib_1.alphaNumericAndMarksCharsStr, "]"));
	/**
	 * @class Autolinker.matcher.Hashtag
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find HashtagMatch matches in an input string.
	 */
	var HashtagMatcher = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(HashtagMatcher, _super);
	    /**
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Match instance,
	     *   specified in an Object (map).
	     */
	    function HashtagMatcher(cfg) {
	        var _this = _super.call(this, cfg) || this;
	        /**
	         * @cfg {String} service
	         *
	         * A string for the service name to have hashtags (ex: "#myHashtag")
	         * auto-linked to. The currently-supported values are:
	         *
	         * - 'twitter'
	         * - 'facebook'
	         * - 'instagram'
	         * - 'tiktok'
	         */
	        _this.serviceName = 'twitter'; // default value just to get the above doc comment in the ES5 output and documentation generator
	        _this.serviceName = cfg.serviceName;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    HashtagMatcher.prototype.parseMatches = function (text) {
	        var tagBuilder = this.tagBuilder;
	        var serviceName = this.serviceName;
	        var matches = [];
	        var len = text.length;
	        var charIdx = 0, hashCharIdx = -1, state = 0 /* None */;
	        // For debugging: search for other "For debugging" lines
	        // const table = new CliTable( {
	        // 	head: [ 'charIdx', 'char', 'state', 'charIdx', 'currentEmailAddress.idx', 'hasDomainDot' ]
	        // } );
	        while (charIdx < len) {
	            var char = text.charAt(charIdx);
	            // For debugging: search for other "For debugging" lines
	            // table.push(
	            // 	[ charIdx, char, State[ state ], charIdx, currentEmailAddress.idx, currentEmailAddress.hasDomainDot ]
	            // );
	            switch (state) {
	                case 0 /* None */:
	                    stateNone(char);
	                    break;
	                case 1 /* NonHashtagWordChar */:
	                    stateNonHashtagWordChar(char);
	                    break;
	                case 2 /* HashtagHashChar */:
	                    stateHashtagHashChar(char);
	                    break;
	                case 3 /* HashtagTextChar */:
	                    stateHashtagTextChar(char);
	                    break;
	                default:
	                    (0, utils_1.throwUnhandledCaseError)(state);
	            }
	            // For debugging: search for other "For debugging" lines
	            // table.push(
	            // 	[ charIdx, char, State[ state ], charIdx, currentEmailAddress.idx, currentEmailAddress.hasDomainDot ]
	            // );
	            charIdx++;
	        }
	        // Capture any valid match at the end of the string
	        captureMatchIfValid();
	        // For debugging: search for other "For debugging" lines
	        //console.log( '\n' + table.toString() );
	        return matches;
	        // Handles the state when we're not in a hashtag or any word
	        function stateNone(char) {
	            if (char === '#') {
	                state = 2 /* HashtagHashChar */;
	                hashCharIdx = charIdx;
	            }
	            else if (regex_lib_1.alphaNumericAndMarksCharRe.test(char)) {
	                state = 1 /* NonHashtagWordChar */;
	            }
	            else {
	                // not a hashtag character ('#') or word char, stay in State.None
	            }
	        }
	        // Handles the state when we've encountered a word character but are not
	        // in a hashtag. This is used to distinguish between a standalone
	        // hashtag such as '#Stuff' vs a hash char that is part of a word like
	        // 'asdf#stuff' (the latter of which would not be a match)
	        function stateNonHashtagWordChar(char) {
	            if (regex_lib_1.alphaNumericAndMarksCharRe.test(char)) {
	                // continue in NonHashtagWordChar state
	            }
	            else {
	                state = 0 /* None */;
	            }
	        }
	        // Handles the state when we've just encountered a '#' character
	        function stateHashtagHashChar(char) {
	            if (hashtagTextCharRe.test(char)) {
	                // '#' char with valid hash text char following
	                state = 3 /* HashtagTextChar */;
	            }
	            else if (regex_lib_1.alphaNumericAndMarksCharRe.test(char)) {
	                state = 1 /* NonHashtagWordChar */;
	            }
	            else {
	                state = 0 /* None */;
	            }
	        }
	        // Handles the state when we're currently in the hash tag's text chars
	        function stateHashtagTextChar(char) {
	            if (hashtagTextCharRe.test(char)) {
	                // Continue reading characters in the HashtagText state
	            }
	            else {
	                captureMatchIfValid();
	                hashCharIdx = -1;
	                if (regex_lib_1.alphaNumericAndMarksCharRe.test(char)) {
	                    state = 1 /* NonHashtagWordChar */;
	                }
	                else {
	                    state = 0 /* None */;
	                }
	            }
	        }
	        /*
	         * Captures the current hashtag as a HashtagMatch if it's valid.
	         */
	        function captureMatchIfValid() {
	            if (hashCharIdx > -1 && charIdx - hashCharIdx <= 140) {
	                // Max length of 140 for a hashtag ('#' char + 139 word chars)
	                var matchedText = text.slice(hashCharIdx, charIdx);
	                var match = new hashtag_match_1.HashtagMatch({
	                    tagBuilder: tagBuilder,
	                    matchedText: matchedText,
	                    offset: hashCharIdx,
	                    serviceName: serviceName,
	                    hashtag: matchedText.slice(1),
	                });
	                matches.push(match);
	            }
	        }
	    };
	    return HashtagMatcher;
	}(matcher_1.Matcher));
	exports.HashtagMatcher = HashtagMatcher;
	exports.hashtagServices = ['twitter', 'facebook', 'instagram', 'tiktok'];
	//# sourceMappingURL=hashtag-matcher.js.map

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MentionMatcher = void 0;
	var tslib_1 = __webpack_require__(181);
	var matcher_1 = __webpack_require__(391);
	var regex_lib_1 = __webpack_require__(392);
	var mention_match_1 = __webpack_require__(1088);
	// RegExp objects which are shared by all instances of MentionMatcher. These are
	// here to avoid re-instantiating the RegExp objects if `Autolinker.link()` is
	// called multiple times, thus instantiating MentionMatcher and its RegExp
	// objects each time (which is very expensive - see https://github.com/gregjacobs/Autolinker.js/issues/314).
	// See descriptions of the properties where they are used for details about them
	var twitterRegex = new RegExp("@[_".concat(regex_lib_1.alphaNumericAndMarksCharsStr, "]{1,50}(?![_").concat(regex_lib_1.alphaNumericAndMarksCharsStr, "])"), 'g'); // lookahead used to make sure we don't match something above 50 characters
	var instagramRegex = new RegExp("@[_.".concat(regex_lib_1.alphaNumericAndMarksCharsStr, "]{1,30}(?![_").concat(regex_lib_1.alphaNumericAndMarksCharsStr, "])"), 'g'); // lookahead used to make sure we don't match something above 30 characters
	var soundcloudRegex = new RegExp("@[-_.".concat(regex_lib_1.alphaNumericAndMarksCharsStr, "]{1,50}(?![-_").concat(regex_lib_1.alphaNumericAndMarksCharsStr, "])"), 'g'); // lookahead used to make sure we don't match something above 50 characters
	// TikTok usernames are 1-24 characters containing letters, numbers, underscores
	// and periods, but cannot end in a period: https://support.tiktok.com/en/getting-started/setting-up-your-profile/changing-your-username
	var tiktokRegex = new RegExp("@[_.".concat(regex_lib_1.alphaNumericAndMarksCharsStr, "]{1,23}[_").concat(regex_lib_1.alphaNumericAndMarksCharsStr, "](?![_").concat(regex_lib_1.alphaNumericAndMarksCharsStr, "])"), 'g'); // lookahead used to make sure we don't match something above 24 characters
	var nonWordCharRegex = new RegExp('[^' + regex_lib_1.alphaNumericAndMarksCharsStr + ']');
	/**
	 * @class Autolinker.matcher.Mention
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find/replace username matches in an input string.
	 */
	var MentionMatcher = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(MentionMatcher, _super);
	    /**
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Match instance,
	     *   specified in an Object (map).
	     */
	    function MentionMatcher(cfg) {
	        var _this = _super.call(this, cfg) || this;
	        /**
	         * @cfg {'twitter'/'instagram'/'soundcloud'} protected
	         *
	         * The name of service to link @mentions to.
	         *
	         * Valid values are: 'twitter', 'instagram', 'soundcloud', or 'tiktok'
	         */
	        _this.serviceName = 'twitter'; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * Hash of regular expression to match username handles. Example match:
	         *
	         *     @asdf
	         *
	         * @private
	         * @property {Object} matcherRegexes
	         */
	        _this.matcherRegexes = {
	            twitter: twitterRegex,
	            instagram: instagramRegex,
	            soundcloud: soundcloudRegex,
	            tiktok: tiktokRegex,
	        };
	        /**
	         * The regular expression to use to check the character before a username match to
	         * make sure we didn't accidentally match an email address.
	         *
	         * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
	         *
	         * @private
	         * @property {RegExp} nonWordCharRegex
	         */
	        _this.nonWordCharRegex = nonWordCharRegex;
	        _this.serviceName = cfg.serviceName;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    MentionMatcher.prototype.parseMatches = function (text) {
	        var serviceName = this.serviceName, matcherRegex = this.matcherRegexes[this.serviceName], nonWordCharRegex = this.nonWordCharRegex, tagBuilder = this.tagBuilder, matches = [], match;
	        if (!matcherRegex) {
	            return matches;
	        }
	        while ((match = matcherRegex.exec(text)) !== null) {
	            var offset = match.index, prevChar = text.charAt(offset - 1);
	            // If we found the match at the beginning of the string, or we found the match
	            // and there is a whitespace char in front of it (meaning it is not an email
	            // address), then it is a username match.
	            if (offset === 0 || nonWordCharRegex.test(prevChar)) {
	                var matchedText = match[0].replace(/\.+$/g, ''), // strip off trailing .
	                mention = matchedText.slice(1); // strip off the '@' character at the beginning
	                matches.push(new mention_match_1.MentionMatch({
	                    tagBuilder: tagBuilder,
	                    matchedText: matchedText,
	                    offset: offset,
	                    serviceName: serviceName,
	                    mention: mention,
	                }));
	            }
	        }
	        return matches;
	    };
	    return MentionMatcher;
	}(matcher_1.Matcher));
	exports.MentionMatcher = MentionMatcher;
	//# sourceMappingURL=mention-matcher.js.map

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PhoneMatcher = void 0;
	var tslib_1 = __webpack_require__(181);
	var matcher_1 = __webpack_require__(391);
	var phone_match_1 = __webpack_require__(1089);
	var regex_lib_1 = __webpack_require__(392);
	// RegExp objects which are shared by all instances of PhoneMatcher. These are
	// here to avoid re-instantiating the RegExp objects if `Autolinker.link()` is
	// called multiple times, thus instantiating PhoneMatcher and its RegExp
	// objects each time (which is very expensive - see https://github.com/gregjacobs/Autolinker.js/issues/314).
	// See descriptions of the properties where they are used for details about them
	// Over the years, many people have added to this regex, but it should have been
	// split up by country. Maybe one day we can break this down.
	var mostPhoneNumbers = /(?:(?:(?:(\+)?\d{1,3}[-\040.]?)?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]?\d{4})|(?:(\+)(?:9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)[-\040.]?(?:\d[-\040.]?){6,12}\d+))([,;]+[0-9]+#?)*/;
	// Regex for Japanese phone numbers
	var japanesePhoneRe = /(0([1-9]{1}-?[1-9]\d{3}|[1-9]{2}-?\d{3}|[1-9]{2}\d{1}-?\d{2}|[1-9]{2}\d{2}-?\d{1})-?\d{4}|0[789]0-?\d{4}-?\d{4}|050-?\d{4}-?\d{4})/;
	// Combined regex
	var phoneMatcherRegex = new RegExp("".concat(mostPhoneNumbers.source, "|").concat(japanesePhoneRe.source), 'g');
	/**
	 * @class Autolinker.matcher.Phone
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find Phone number matches in an input string.
	 *
	 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more
	 * details.
	 */
	var PhoneMatcher = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(PhoneMatcher, _super);
	    function PhoneMatcher() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        /**
	         * The regular expression to match Phone numbers. Example matches:
	         *
	         *     (123) 456-7890
	         *     123 456 7890
	         *     123-456-7890
	         *     +18004441234,,;,10226420346#
	         *     +1 (800) 444 1234
	         *     10226420346#
	         *     1-800-444-1234,1022,64,20346#
	         *
	         * This regular expression has the following capturing groups:
	         *
	         * 1 or 2. The prefixed '+' sign, if there is one.
	         *
	         * @protected
	         * @property {RegExp} matcherRegex
	         */
	        _this.matcherRegex = phoneMatcherRegex;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    PhoneMatcher.prototype.parseMatches = function (text) {
	        var matcherRegex = this.matcherRegex, tagBuilder = this.tagBuilder, matches = [], match;
	        while ((match = matcherRegex.exec(text)) !== null) {
	            // Remove non-numeric values from phone number string
	            var matchedText = match[0], cleanNumber = matchedText.replace(/[^0-9,;#]/g, ''), // strip out non-digit characters exclude comma semicolon and #
	            plusSign = !!(match[1] || match[2]), // match[ 1 ] or match[ 2 ] is the prefixed plus sign, if there is one
	            before = match.index == 0 ? '' : text.substr(match.index - 1, 1), after = text.substr(match.index + matchedText.length, 1), contextClear = !before.match(/\d/) && !after.match(/\d/);
	            if (this.testMatch(match[3]) && this.testMatch(matchedText) && contextClear) {
	                matches.push(new phone_match_1.PhoneMatch({
	                    tagBuilder: tagBuilder,
	                    matchedText: matchedText,
	                    offset: match.index,
	                    number: cleanNumber,
	                    plusSign: plusSign,
	                }));
	            }
	        }
	        return matches;
	    };
	    PhoneMatcher.prototype.testMatch = function (text) {
	        return regex_lib_1.nonDigitRe.test(text);
	    };
	    return PhoneMatcher;
	}(matcher_1.Matcher));
	exports.PhoneMatcher = PhoneMatcher;
	//# sourceMappingURL=phone-matcher.js.map

/***/ }),
/* 1692 */
/***/ (function(module, exports) {

	"use strict";
	// NOTE: THIS IS A GENERATED FILE
	// To update with the latest TLD list, run `npm run update-tld-regex`
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.tldRegex = void 0;
	exports.tldRegex = /(?:xn--vermgensberatung-pwb|xn--vermgensberater-ctb|xn--clchc0ea0b2g2a9gcd|xn--w4r85el8fhu5dnra|northwesternmutual|travelersinsurance|vermögensberatung|xn--5su34j936bgsg|xn--bck1b9a5dre4c|xn--mgbah1a3hjkrd|xn--mgbai9azgqp6j|xn--mgberp4a5d4ar|xn--xkc2dl3a5ee0h|vermögensberater|xn--fzys8d69uvgm|xn--mgba7c0bbn0a|xn--mgbcpq6gpa1a|xn--xkc2al3hye2a|americanexpress|kerryproperties|sandvikcoromant|xn--i1b6b1a6a2e|xn--kcrx77d1x4a|xn--lgbbat1ad8j|xn--mgba3a4f16a|xn--mgbaakc7dvf|xn--mgbc0a9azcg|xn--nqv7fs00ema|americanfamily|bananarepublic|cancerresearch|cookingchannel|kerrylogistics|weatherchannel|xn--54b7fta0cc|xn--6qq986b3xl|xn--80aqecdr1a|xn--b4w605ferd|xn--fiq228c5hs|xn--h2breg3eve|xn--jlq480n2rg|xn--jlq61u9w7b|xn--mgba3a3ejt|xn--mgbaam7a8h|xn--mgbayh7gpa|xn--mgbbh1a71e|xn--mgbca7dzdo|xn--mgbi4ecexp|xn--mgbx4cd0ab|xn--rvc1e0am3e|international|lifeinsurance|travelchannel|wolterskluwer|xn--cckwcxetd|xn--eckvdtc9d|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--h2brj9c8c|xn--tiq49xqyj|xn--yfro4i67o|xn--ygbi2ammx|construction|lplfinancial|scholarships|versicherung|xn--3e0b707e|xn--45br5cyl|xn--4dbrk0ce|xn--80adxhks|xn--80asehdb|xn--8y0a063a|xn--gckr3f0f|xn--mgb9awbf|xn--mgbab2bd|xn--mgbgu82a|xn--mgbpl2fh|xn--mgbt3dhd|xn--mk1bu44c|xn--ngbc5azd|xn--ngbe9e0a|xn--ogbpf8fl|xn--qcka1pmc|accountants|barclaycard|blackfriday|blockbuster|bridgestone|calvinklein|contractors|creditunion|engineering|enterprises|foodnetwork|investments|kerryhotels|lamborghini|motorcycles|olayangroup|photography|playstation|productions|progressive|redumbrella|williamhill|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--2scrj9c|xn--3bst00m|xn--3ds443g|xn--3hcrj9c|xn--42c2d9a|xn--45brj9c|xn--55qw42g|xn--6frz82g|xn--80ao21a|xn--9krt00a|xn--cck2b3b|xn--czr694b|xn--d1acj3b|xn--efvy88h|xn--fct429k|xn--fjq720a|xn--flw351e|xn--g2xx48c|xn--gecrj9c|xn--gk3at1e|xn--h2brj9c|xn--hxt814e|xn--imr513n|xn--j6w193g|xn--jvr189m|xn--kprw13d|xn--kpry57d|xn--mgbbh1a|xn--mgbtx2b|xn--mix891f|xn--nyqy26a|xn--otu796d|xn--pgbs0dh|xn--q9jyb4c|xn--rhqv96g|xn--rovu88b|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--vuq861b|xn--w4rs40l|xn--xhq521b|xn--zfr164b|சிங்கப்பூர்|accountant|apartments|associates|basketball|bnpparibas|boehringer|capitalone|consulting|creditcard|cuisinella|eurovision|extraspace|foundation|healthcare|immobilien|industries|management|mitsubishi|nextdirect|properties|protection|prudential|realestate|republican|restaurant|schaeffler|tatamotors|technology|university|vlaanderen|volkswagen|xn--30rr7y|xn--3pxu8k|xn--45q11c|xn--4gbrim|xn--55qx5d|xn--5tzm5g|xn--80aswg|xn--90a3ac|xn--9dbq2a|xn--9et52u|xn--c2br7g|xn--cg4bki|xn--czrs0t|xn--czru2d|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--io0a7i|xn--kput3i|xn--mxtq1m|xn--o3cw4h|xn--pssy2u|xn--q7ce6a|xn--unup4y|xn--wgbh1c|xn--wgbl6a|xn--y9a3aq|accenture|alfaromeo|allfinanz|amsterdam|analytics|aquarelle|barcelona|bloomberg|christmas|community|directory|education|equipment|fairwinds|financial|firestone|fresenius|frontdoor|furniture|goldpoint|hisamitsu|homedepot|homegoods|homesense|institute|insurance|kuokgroup|lancaster|landrover|lifestyle|marketing|marshalls|melbourne|microsoft|panasonic|passagens|pramerica|richardli|shangrila|solutions|statebank|statefarm|stockholm|travelers|vacations|xn--90ais|xn--c1avg|xn--d1alf|xn--e1a4c|xn--fhbei|xn--j1aef|xn--j1amh|xn--l1acc|xn--ngbrx|xn--nqv7f|xn--p1acf|xn--qxa6a|xn--tckwe|xn--vhquv|yodobashi|موريتانيا|abudhabi|airforce|allstate|attorney|barclays|barefoot|bargains|baseball|boutique|bradesco|broadway|brussels|builders|business|capetown|catering|catholic|cipriani|cityeats|cleaning|clinique|clothing|commbank|computer|delivery|deloitte|democrat|diamonds|discount|discover|download|engineer|ericsson|etisalat|exchange|feedback|fidelity|firmdale|football|frontier|goodyear|grainger|graphics|guardian|hdfcbank|helsinki|holdings|hospital|infiniti|ipiranga|istanbul|jpmorgan|lighting|lundbeck|marriott|maserati|mckinsey|memorial|merckmsd|mortgage|observer|partners|pharmacy|pictures|plumbing|property|redstone|reliance|saarland|samsclub|security|services|shopping|showtime|softbank|software|stcgroup|supplies|training|vanguard|ventures|verisign|woodside|xn--90ae|xn--node|xn--p1ai|xn--qxam|yokohama|السعودية|abogado|academy|agakhan|alibaba|android|athleta|auction|audible|auspost|avianca|banamex|bauhaus|bentley|bestbuy|booking|brother|bugatti|capital|caravan|careers|channel|charity|chintai|citadel|clubmed|college|cologne|comcast|company|compare|contact|cooking|corsica|country|coupons|courses|cricket|cruises|dentist|digital|domains|exposed|express|farmers|fashion|ferrari|ferrero|finance|fishing|fitness|flights|florist|flowers|forsale|frogans|fujitsu|gallery|genting|godaddy|grocery|guitars|hamburg|hangout|hitachi|holiday|hosting|hoteles|hotmail|hyundai|ismaili|jewelry|juniper|kitchen|komatsu|lacaixa|lanxess|lasalle|latrobe|leclerc|limited|lincoln|markets|monster|netbank|netflix|network|neustar|okinawa|oldnavy|organic|origins|philips|pioneer|politie|realtor|recipes|rentals|reviews|rexroth|samsung|sandvik|schmidt|schwarz|science|shiksha|singles|staples|storage|support|surgery|systems|temasek|theater|theatre|tickets|tiffany|toshiba|trading|walmart|wanggou|watches|weather|website|wedding|whoswho|windows|winners|xfinity|yamaxun|youtube|zuerich|католик|اتصالات|البحرين|الجزائر|العليان|پاکستان|كاثوليك|இந்தியா|abarth|abbott|abbvie|africa|agency|airbus|airtel|alipay|alsace|alstom|amazon|anquan|aramco|author|bayern|beauty|berlin|bharti|bostik|boston|broker|camera|career|casino|center|chanel|chrome|church|circle|claims|clinic|coffee|comsec|condos|coupon|credit|cruise|dating|datsun|dealer|degree|dental|design|direct|doctor|dunlop|dupont|durban|emerck|energy|estate|events|expert|family|flickr|futbol|gallup|garden|george|giving|global|google|gratis|health|hermes|hiphop|hockey|hotels|hughes|imamat|insure|intuit|jaguar|joburg|juegos|kaufen|kinder|kindle|kosher|lancia|latino|lawyer|lefrak|living|locker|london|luxury|madrid|maison|makeup|market|mattel|mobile|monash|mormon|moscow|museum|mutual|nagoya|natura|nissan|nissay|norton|nowruz|office|olayan|online|oracle|orange|otsuka|pfizer|photos|physio|pictet|quebec|racing|realty|reisen|repair|report|review|rocher|rogers|ryukyu|safety|sakura|sanofi|school|schule|search|secure|select|shouji|soccer|social|stream|studio|supply|suzuki|swatch|sydney|taipei|taobao|target|tattoo|tennis|tienda|tjmaxx|tkmaxx|toyota|travel|unicom|viajes|viking|villas|virgin|vision|voting|voyage|vuelos|walter|webcam|xihuan|yachts|yandex|zappos|москва|онлайн|ابوظبي|ارامكو|الاردن|المغرب|امارات|فلسطين|مليسيا|भारतम्|இலங்கை|ファッション|actor|adult|aetna|amfam|amica|apple|archi|audio|autos|azure|baidu|beats|bible|bingo|black|boats|bosch|build|canon|cards|chase|cheap|cisco|citic|click|cloud|coach|codes|crown|cymru|dabur|dance|deals|delta|drive|dubai|earth|edeka|email|epson|faith|fedex|final|forex|forum|gallo|games|gifts|gives|glass|globo|gmail|green|gripe|group|gucci|guide|homes|honda|horse|house|hyatt|ikano|irish|jetzt|koeln|kyoto|lamer|lease|legal|lexus|lilly|linde|lipsy|loans|locus|lotte|lotto|macys|mango|media|miami|money|movie|music|nexus|nikon|ninja|nokia|nowtv|omega|osaka|paris|parts|party|phone|photo|pizza|place|poker|praxi|press|prime|promo|quest|radio|rehab|reise|ricoh|rocks|rodeo|rugby|salon|sener|seven|sharp|shell|shoes|skype|sling|smart|smile|solar|space|sport|stada|store|study|style|sucks|swiss|tatar|tires|tirol|tmall|today|tokyo|tools|toray|total|tours|trade|trust|tunes|tushu|ubank|vegas|video|vodka|volvo|wales|watch|weber|weibo|works|world|xerox|yahoo|ישראל|ایران|بازار|بھارت|سودان|سورية|همراه|भारोत|संगठन|বাংলা|భారత్|ഭാരതം|嘉里大酒店|aarp|able|adac|aero|akdn|ally|amex|arab|army|arpa|arte|asda|asia|audi|auto|baby|band|bank|bbva|beer|best|bike|bing|blog|blue|bofa|bond|book|buzz|cafe|call|camp|care|cars|casa|case|cash|cbre|cern|chat|citi|city|club|cool|coop|cyou|data|date|dclk|deal|dell|desi|diet|dish|docs|dvag|erni|fage|fail|fans|farm|fast|fiat|fido|film|fire|fish|flir|food|ford|free|fund|game|gbiz|gent|ggee|gift|gmbh|gold|golf|goog|guge|guru|hair|haus|hdfc|help|here|hgtv|host|hsbc|icbc|ieee|imdb|immo|info|itau|java|jeep|jobs|jprs|kddi|kids|kiwi|kpmg|kred|land|lego|lgbt|lidl|life|like|limo|link|live|loan|loft|love|ltda|luxe|maif|meet|meme|menu|mini|mint|mobi|moda|moto|name|navy|news|next|nico|nike|ollo|open|page|pars|pccw|pics|ping|pink|play|plus|pohl|porn|post|prod|prof|qpon|read|reit|rent|rest|rich|room|rsvp|ruhr|safe|sale|sarl|save|saxo|scot|seat|seek|sexy|shaw|shia|shop|show|silk|sina|site|skin|sncf|sohu|song|sony|spot|star|surf|talk|taxi|team|tech|teva|tiaa|tips|town|toys|tube|vana|visa|viva|vivo|vote|voto|wang|weir|wien|wiki|wine|work|xbox|yoga|zara|zero|zone|дети|сайт|بارت|بيتك|ڀارت|تونس|شبكة|عراق|عمان|موقع|भारत|ভারত|ভাৰত|ਭਾਰਤ|ભારત|ଭାରତ|ಭಾರತ|ලංකා|アマゾン|グーグル|クラウド|ポイント|组织机构|電訊盈科|香格里拉|aaa|abb|abc|aco|ads|aeg|afl|aig|anz|aol|app|art|aws|axa|bar|bbc|bbt|bcg|bcn|bet|bid|bio|biz|bms|bmw|bom|boo|bot|box|buy|bzh|cab|cal|cam|car|cat|cba|cbn|cbs|ceo|cfa|cfd|com|cpa|crs|dad|day|dds|dev|dhl|diy|dnp|dog|dot|dtv|dvr|eat|eco|edu|esq|eus|fan|fit|fly|foo|fox|frl|ftr|fun|fyi|gal|gap|gay|gdn|gea|gle|gmo|gmx|goo|gop|got|gov|hbo|hiv|hkt|hot|how|ibm|ice|icu|ifm|inc|ing|ink|int|ist|itv|jcb|jio|jll|jmp|jnj|jot|joy|kfh|kia|kim|kpn|krd|lat|law|lds|llc|llp|lol|lpl|ltd|man|map|mba|med|men|mil|mit|mlb|mls|mma|moe|moi|mom|mov|msd|mtn|mtr|nab|nba|nec|net|new|nfl|ngo|nhk|now|nra|nrw|ntt|nyc|obi|one|ong|onl|ooo|org|ott|ovh|pay|pet|phd|pid|pin|pnc|pro|pru|pub|pwc|red|ren|ril|rio|rip|run|rwe|sap|sas|sbi|sbs|sca|scb|ses|sew|sex|sfr|ski|sky|soy|spa|srl|stc|tab|tax|tci|tdk|tel|thd|tjx|top|trv|tui|tvs|ubs|uno|uol|ups|vet|vig|vin|vip|wed|win|wme|wow|wtc|wtf|xin|xxx|xyz|you|yun|zip|бел|ком|қаз|мкд|мон|орг|рус|срб|укр|հայ|קום|عرب|قطر|كوم|مصر|कॉम|नेट|คอม|ไทย|ລາວ|ストア|セール|みんな|中文网|亚马逊|天主教|我爱你|新加坡|淡马锡|诺基亚|飞利浦|ac|ad|ae|af|ag|ai|al|am|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw|ελ|ευ|бг|ею|рф|გე|닷넷|닷컴|삼성|한국|コム|世界|中信|中国|中國|企业|佛山|信息|健康|八卦|公司|公益|台湾|台灣|商城|商店|商标|嘉里|在线|大拿|娱乐|家電|广东|微博|慈善|手机|招聘|政务|政府|新闻|时尚|書籍|机构|游戏|澳門|点看|移动|网址|网店|网站|网络|联通|谷歌|购物|通販|集团|食品|餐厅|香港)/;
	//# sourceMappingURL=tld-regex.js.map

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatcher = void 0;
	var tslib_1 = __webpack_require__(181);
	var matcher_1 = __webpack_require__(391);
	var regex_lib_1 = __webpack_require__(392);
	var tld_regex_1 = __webpack_require__(1692);
	var url_match_1 = __webpack_require__(1090);
	var url_match_validator_1 = __webpack_require__(2979);
	// RegExp objects which are shared by all instances of UrlMatcher. These are
	// here to avoid re-instantiating the RegExp objects if `Autolinker.link()` is
	// called multiple times, thus instantiating UrlMatcher and its RegExp
	// objects each time (which is very expensive - see https://github.com/gregjacobs/Autolinker.js/issues/314).
	// See descriptions of the properties where they are used for details about them
	// prettier-ignore
	var matcherRegex = (function () {
	    var schemeRegex = /(?:[A-Za-z][-.+A-Za-z0-9]{0,63}:(?![A-Za-z][-.+A-Za-z0-9]{0,63}:\/\/)(?!\d+\/?)(?:\/\/)?)/, // match protocol, allow in format "http://" or "mailto:". However, do not match the first part of something like 'link:http://www.google.com' (i.e. don't match "link:"). Also, make sure we don't interpret 'google.com:8000' as if 'google.com' was a protocol here (i.e. ignore a trailing port number in this regex)
	    wwwRegex = /(?:www\.)/, // starting with 'www.'
	    // Allow optional path, query string, and hash anchor, not ending in the following characters: "?!:,.;"
	    // http://blog.codinghorror.com/the-problem-with-urls/
	    urlSuffixRegex = new RegExp('[/?#](?:[' + regex_lib_1.alphaNumericAndMarksCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]{}?!:,.;^\u2713]*[' + regex_lib_1.alphaNumericAndMarksCharsStr + '\\-+&@#/%=~_()|\'$*\\[\\]{}\u2713])?');
	    return new RegExp([
	        '(?:',
	        '(',
	        schemeRegex.source,
	        (0, regex_lib_1.getDomainNameStr)(2),
	        ')',
	        '|',
	        '(',
	        '(//)?',
	        wwwRegex.source,
	        (0, regex_lib_1.getDomainNameStr)(6),
	        ')',
	        '|',
	        '(',
	        '(//)?',
	        (0, regex_lib_1.getDomainNameStr)(10) + '\\.',
	        tld_regex_1.tldRegex.source,
	        '(?![-' + regex_lib_1.alphaNumericCharsStr + '])',
	        ')',
	        ')',
	        '(?::[0-9]+)?',
	        '(?:' + urlSuffixRegex.source + ')?' // match for path, query string, and/or hash anchor - optional
	    ].join(""), 'gi');
	})();
	var wordCharRegExp = new RegExp('[' + regex_lib_1.alphaNumericAndMarksCharsStr + ']');
	/**
	 * @class Autolinker.matcher.Url
	 * @extends Autolinker.matcher.Matcher
	 *
	 * Matcher to find URL matches in an input string.
	 *
	 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
	 */
	var UrlMatcher = /** @class */ (function (_super) {
	    (0, tslib_1.__extends)(UrlMatcher, _super);
	    /**
	     * @method constructor
	     * @param {Object} cfg The configuration properties for the Match instance,
	     *   specified in an Object (map).
	     */
	    function UrlMatcher(cfg) {
	        var _this = _super.call(this, cfg) || this;
	        /**
	         * @cfg {Object} stripPrefix (required)
	         *
	         * The Object form of {@link Autolinker#cfg-stripPrefix}.
	         */
	        _this.stripPrefix = {
	            scheme: true,
	            www: true,
	        }; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} stripTrailingSlash (required)
	         * @inheritdoc Autolinker#stripTrailingSlash
	         */
	        _this.stripTrailingSlash = true; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @cfg {Boolean} decodePercentEncoding (required)
	         * @inheritdoc Autolinker#decodePercentEncoding
	         */
	        _this.decodePercentEncoding = true; // default value just to get the above doc comment in the ES5 output and documentation generator
	        /**
	         * @protected
	         * @property {RegExp} matcherRegex
	         *
	         * The regular expression to match URLs with an optional scheme, port
	         * number, path, query string, and hash anchor.
	         *
	         * Example matches:
	         *
	         *     http://google.com
	         *     www.google.com
	         *     google.com/path/to/file?q1=1&q2=2#myAnchor
	         *
	         *
	         * This regular expression will have the following capturing groups:
	         *
	         * 1.  Group that matches a scheme-prefixed URL (i.e. 'http://google.com').
	         *     This is used to match scheme URLs with just a single word, such as
	         *     'http://localhost', where we won't double check that the domain name
	         *     has at least one dot ('.') in it.
	         * 2.  Group that matches a 'www.' prefixed URL. This is only matched if the
	         *     'www.' text was not prefixed by a scheme (i.e.: not prefixed by
	         *     'http://', 'ftp:', etc.)
	         * 3.  A protocol-relative ('//') match for the case of a 'www.' prefixed
	         *     URL. Will be an empty string if it is not a protocol-relative match.
	         *     We need to know the character before the '//' in order to determine
	         *     if it is a valid match or the // was in a string we don't want to
	         *     auto-link.
	         * 4.  Group that matches a known TLD (top level domain), when a scheme
	         *     or 'www.'-prefixed domain is not matched.
	         * 5.  A protocol-relative ('//') match for the case of a known TLD prefixed
	         *     URL. Will be an empty string if it is not a protocol-relative match.
	         *     See #3 for more info.
	         */
	        _this.matcherRegex = matcherRegex;
	        /**
	         * A regular expression to use to check the character before a protocol-relative
	         * URL match. We don't want to match a protocol-relative URL if it is part
	         * of another word.
	         *
	         * For example, we want to match something like "Go to: //google.com",
	         * but we don't want to match something like "abc//google.com"
	         *
	         * This regular expression is used to test the character before the '//'.
	         *
	         * @protected
	         * @type {RegExp} wordCharRegExp
	         */
	        _this.wordCharRegExp = wordCharRegExp;
	        _this.stripPrefix = cfg.stripPrefix;
	        _this.stripTrailingSlash = cfg.stripTrailingSlash;
	        _this.decodePercentEncoding = cfg.decodePercentEncoding;
	        return _this;
	    }
	    /**
	     * @inheritdoc
	     */
	    UrlMatcher.prototype.parseMatches = function (text) {
	        var matcherRegex = this.matcherRegex, stripPrefix = this.stripPrefix, stripTrailingSlash = this.stripTrailingSlash, decodePercentEncoding = this.decodePercentEncoding, tagBuilder = this.tagBuilder, matches = [], match;
	        var _loop_1 = function () {
	            var matchStr = match[0], schemeUrlMatch = match[1], wwwUrlMatch = match[4], wwwProtocolRelativeMatch = match[5], 
	            //tldUrlMatch = match[ 8 ],  -- not needed at the moment
	            tldProtocolRelativeMatch = match[9], offset = match.index, protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch, prevChar = text.charAt(offset - 1);
	            if (!url_match_validator_1.UrlMatchValidator.isValid(matchStr, schemeUrlMatch)) {
	                return "continue";
	            }
	            // If the match is preceded by an '@' character, then it is either
	            // an email address or a username. Skip these types of matches.
	            if (offset > 0 && prevChar === '@') {
	                return "continue";
	            }
	            // If it's a protocol-relative '//' match, but the character before the '//'
	            // was a word character (i.e. a letter/number), then we found the '//' in the
	            // middle of another word (such as "asdf//asdf.com"). In this case, skip the
	            // match.
	            if (offset > 0 && protocolRelativeMatch && this_1.wordCharRegExp.test(prevChar)) {
	                return "continue";
	            }
	            // If the URL ends with a question mark, don't include the question
	            // mark as part of the URL. We'll assume the question mark was the
	            // end of a sentence, such as: "Going to google.com?"
	            if (/\?$/.test(matchStr)) {
	                matchStr = matchStr.substr(0, matchStr.length - 1);
	            }
	            // Handle a closing parenthesis or square bracket at the end of the
	            // match, and exclude it if there is not a matching open parenthesis
	            // or square bracket in the match itself.
	            if (this_1.matchHasUnbalancedClosingParen(matchStr)) {
	                matchStr = matchStr.substr(0, matchStr.length - 1); // remove the trailing ")"
	            }
	            else {
	                // Handle an invalid character after the TLD
	                var pos = this_1.matchHasInvalidCharAfterTld(matchStr, schemeUrlMatch);
	                if (pos > -1) {
	                    matchStr = matchStr.substr(0, pos); // remove the trailing invalid chars
	                }
	            }
	            // The autolinker accepts many characters in a url's scheme (like `fake://test.com`).
	            // However, in cases where a URL is missing whitespace before an obvious link,
	            // (for example: `nowhitespacehttp://www.test.com`), we only want the match to start
	            // at the http:// part. We will check if the match contains a common scheme and then
	            // shift the match to start from there.
	            var foundCommonScheme = ['http://', 'https://'].find(function (commonScheme) { return !!schemeUrlMatch && schemeUrlMatch.indexOf(commonScheme) !== -1; });
	            if (foundCommonScheme) {
	                // If we found an overmatched URL, we want to find the index
	                // of where the match should start and shift the match to
	                // start from the beginning of the common scheme
	                var indexOfSchemeStart = matchStr.indexOf(foundCommonScheme);
	                matchStr = matchStr.substr(indexOfSchemeStart);
	                schemeUrlMatch = schemeUrlMatch.substr(indexOfSchemeStart);
	                offset = offset + indexOfSchemeStart;
	            }
	            var urlMatchType = schemeUrlMatch
	                ? 'scheme'
	                : wwwUrlMatch
	                    ? 'www'
	                    : 'tld', protocolUrlMatch = !!schemeUrlMatch;
	            matches.push(new url_match_1.UrlMatch({
	                tagBuilder: tagBuilder,
	                matchedText: matchStr,
	                offset: offset,
	                urlMatchType: urlMatchType,
	                url: matchStr,
	                protocolUrlMatch: protocolUrlMatch,
	                protocolRelativeMatch: !!protocolRelativeMatch,
	                stripPrefix: stripPrefix,
	                stripTrailingSlash: stripTrailingSlash,
	                decodePercentEncoding: decodePercentEncoding,
	            }));
	        };
	        var this_1 = this;
	        while ((match = matcherRegex.exec(text)) !== null) {
	            _loop_1();
	        }
	        return matches;
	    };
	    /**
	     * Determines if a match found has an unmatched closing parenthesis,
	     * square bracket or curly bracket. If so, the symbol will be removed
	     * from the match itself, and appended after the generated anchor tag.
	     *
	     * A match may have an extra closing parenthesis at the end of the match
	     * because the regular expression must include parenthesis for URLs such as
	     * "wikipedia.com/something_(disambiguation)", which should be auto-linked.
	     *
	     * However, an extra parenthesis *will* be included when the URL itself is
	     * wrapped in parenthesis, such as in the case of:
	     *     "(wikipedia.com/something_(disambiguation))"
	     * In this case, the last closing parenthesis should *not* be part of the
	     * URL itself, and this method will return `true`.
	     *
	     * For square brackets in URLs such as in PHP arrays, the same behavior as
	     * parenthesis discussed above should happen:
	     *     "[http://www.example.com/foo.php?bar[]=1&bar[]=2&bar[]=3]"
	     * The closing square bracket should not be part of the URL itself, and this
	     * method will return `true`.
	     *
	     * @protected
	     * @param {String} matchStr The full match string from the {@link #matcherRegex}.
	     * @return {Boolean} `true` if there is an unbalanced closing parenthesis or
	     *   square bracket at the end of the `matchStr`, `false` otherwise.
	     */
	    UrlMatcher.prototype.matchHasUnbalancedClosingParen = function (matchStr) {
	        var endChar = matchStr.charAt(matchStr.length - 1);
	        var startChar;
	        if (endChar === ')') {
	            startChar = '(';
	        }
	        else if (endChar === ']') {
	            startChar = '[';
	        }
	        else if (endChar === '}') {
	            startChar = '{';
	        }
	        else {
	            return false; // not a close parenthesis or square bracket
	        }
	        // Find if there are the same number of open braces as close braces in
	        // the URL string, minus the last character (which we have already
	        // determined to be either ')', ']' or '}'
	        var numOpenBraces = 0;
	        for (var i = 0, len = matchStr.length - 1; i < len; i++) {
	            var char = matchStr.charAt(i);
	            if (char === startChar) {
	                numOpenBraces++;
	            }
	            else if (char === endChar) {
	                numOpenBraces = Math.max(numOpenBraces - 1, 0);
	            }
	        }
	        // If the number of open braces matches the number of close braces in
	        // the URL minus the last character, then the match has *unbalanced*
	        // braces because of the last character. Example of unbalanced braces
	        // from the regex match:
	        //     "http://example.com?a[]=1]"
	        if (numOpenBraces === 0) {
	            return true;
	        }
	        return false;
	    };
	    /**
	     * Determine if there's an invalid character after the TLD in a URL. Valid
	     * characters after TLD are ':/?#'. Exclude scheme matched URLs from this
	     * check.
	     *
	     * @protected
	     * @param {String} urlMatch The matched URL, if there was one. Will be an
	     *   empty string if the match is not a URL match.
	     * @param {String} schemeUrlMatch The match URL string for a scheme
	     *   match. Ex: 'http://yahoo.com'. This is used to match something like
	     *   'http://localhost', where we won't double check that the domain name
	     *   has at least one '.' in it.
	     * @return {Number} the position where the invalid character was found. If
	     *   no such character was found, returns -1
	     */
	    UrlMatcher.prototype.matchHasInvalidCharAfterTld = function (urlMatch, schemeUrlMatch) {
	        if (!urlMatch) {
	            return -1;
	        }
	        var offset = 0;
	        if (schemeUrlMatch) {
	            offset = urlMatch.indexOf(':');
	            urlMatch = urlMatch.slice(offset);
	        }
	        // prettier-ignore
	        var re = new RegExp("^((.?\/\/)?[-." + regex_lib_1.alphaNumericAndMarksCharsStr + "]*[-" + regex_lib_1.alphaNumericAndMarksCharsStr + "]\\.[-" + regex_lib_1.alphaNumericAndMarksCharsStr + "]+)");
	        var res = re.exec(urlMatch);
	        if (res === null) {
	            return -1;
	        }
	        offset += res[1].length;
	        urlMatch = urlMatch.slice(res[1].length);
	        if (/^[^-.A-Za-z0-9:\/?#]/.test(urlMatch)) {
	            return offset;
	        }
	        return -1;
	    };
	    return UrlMatcher;
	}(matcher_1.Matcher));
	exports.UrlMatcher = UrlMatcher;
	//# sourceMappingURL=url-matcher.js.map

/***/ }),
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ProviderDetails = __webpack_require__(3023);
	
	var _ProviderDetails2 = _interopRequireDefault(_ProviderDetails);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _strings = __webpack_require__(15);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _enhance = __webpack_require__(3024);
	
	var _styles = __webpack_require__(4894);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentMyProviders(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      loadMoreMyProviders = _ref.loadMoreMyProviders,
	      initRescheduleFlow = _ref.initRescheduleFlow,
	      paginationLoading = _ref.paginationLoading,
	      fetchMyProviders = _ref.fetchMyProviders,
	      organizationId = _ref.organizationId,
	      providersCount = _ref.providersCount,
	      languageTypes = _ref.languageTypes,
	      providers = _ref.providers,
	      fullView = _ref.fullView,
	      loading = _ref.loading,
	      userId = _ref.userId;
	
	  var rootRef = (0, _react.useRef)();
	
	  var safeProviderList = (0, _react.useMemo)(function () {
	    if (!fullView) {
	      return providers.slice(0, 3);
	    }
	    return providers;
	  }, [fullView, providers]);
	
	  (0, _react.useEffect)(function () {
	    if (fullView) {
	      fetchMyProviders({ userId: userId, organizationId: organizationId, limit: 10, offset: 0 });
	    }
	  }, [fullView]);
	
	  var loadMore = (0, _react.useCallback)(function () {
	    if (paginationLoading || !fullView) return;
	    loadMoreMyProviders({ userId: userId, organizationId: organizationId });
	  }, [paginationLoading, userId, organizationId, fullView]);
	
	  (0, _useLazyLoad.useLazyLoad)({ node: rootRef, loadMore: loadMore, path: ['parentNode', 'parentNode'] });
	
	  var handleViewAllProviders = function handleViewAllProviders() {
	    (0, _redirectUtils.redirectToMyProviders)();
	  };
	
	  var handleBack = function handleBack() {
	    (0, _redirectUtils.redirectToVisitType)();
	  };
	
	  function renderAvatar(provider) {
	    return function () {
	      return _react2.default.createElement(_SimpleAvatar2.default, {
	        src: (0, _get2.default)(provider, 'avatar.thumbMin'),
	        text: provider.displayableName,
	        size: 44,
	        bordered: true
	      });
	    };
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_styles2.default.root, (0, _defineProperty3.default)({}, _styles2.default.hidden, !loading && !providers.length)),
	      ref: rootRef
	    },
	    fullView && _react2.default.createElement(_BackButton2.default, {
	      className: _styles2.default.backButton,
	      onBack: handleBack,
	      minWidth: 0
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.title },
	        formatMessage({ id: 'appointments.myProviders' })
	      ),
	      !fullView && providersCount > 3 && _react2.default.createElement(
	        _ClickableElement2.default,
	        { onClick: handleViewAllProviders },
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.actionButton },
	          formatMessage(_strings.COMMUNITIES_COMMON.seeAll)
	        )
	      )
	    ),
	    loading && _react2.default.createElement(_Loader2.default, { className: _styles2.default.loader }),
	    paginationLoading && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.paginationLoader },
	      _react2.default.createElement(_Loader2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.providerList },
	      !loading && safeProviderList.length > 0 && safeProviderList.map(function (provider) {
	        var id = provider.id,
	            providerInfo = provider.providerInfo,
	            locationName = provider.location.name,
	            serviceName = provider.service.name;
	
	        return _react2.default.createElement(_Shape2.default, {
	          key: id,
	          onClick: function onClick() {
	            return initRescheduleFlow((0, _extends3.default)({}, provider, { userId: userId }));
	          },
	          renderSecondary: function renderSecondary() {
	            return serviceName + ', ' + locationName;
	          },
	          renderPrimary: function renderPrimary() {
	            return _react2.default.createElement(
	              'div',
	              { className: _styles2.default.providerName },
	              _react2.default.createElement(
	                'div',
	                null,
	                providerInfo.displayableName
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.providerInfo },
	                _react2.default.createElement(_ProviderDetails2.default, {
	                  provider: providerInfo,
	                  formatMessage: formatMessage,
	                  languageTypes: languageTypes
	                })
	              )
	            );
	          },
	          renderLeft: renderAvatar(providerInfo)
	        });
	      })
	    )
	  );
	}
	
	AppointmentMyProviders.propTypes = {
	  intl: PropTypes.object,
	  loading: PropTypes.bool,
	  fullView: PropTypes.bool,
	  userId: PropTypes.number,
	  providers: PropTypes.array,
	  languageTypes: PropTypes.array,
	  organizationId: PropTypes.number,
	  providersCount: PropTypes.number,
	  fetchMyProviders: PropTypes.func,
	  paginationLoading: PropTypes.bool,
	  initRescheduleFlow: PropTypes.func,
	  loadMoreMyProviders: PropTypes.func
	};
	
	exports.default = (0, _react.memo)((0, _enhance.enhance)(AppointmentMyProviders));

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _styles = __webpack_require__(4913);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LeaveFlowModal(_ref, ref) {
	  var formatMessage = _ref.formatMessage,
	      clearProgressConsents = _ref.clearProgressConsents;
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      opened = _useToggleFlag2[0],
	      openConfirm = _useToggleFlag2[1],
	      closeConfirm = _useToggleFlag2[2];
	
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {
	      open: openConfirm
	    };
	  });
	
	  var handleSubmit = function handleSubmit() {
	    clearProgressConsents();
	    (0, _redirectUtils.redirectToUsers)();
	  };
	
	  return _react2.default.createElement(_ActionConfirmation2.default, {
	    danger: false,
	    opened: opened,
	    onClose: closeConfirm,
	    onSubmit: handleSubmit,
	    title: formatMessage({ id: 'appointments.confirmModalTitle' }),
	    content: _react2.default.createElement(
	      'div',
	      { styleName: 'modal-body' },
	      formatMessage({ id: 'appointments.confirmModalText' })
	    ),
	    actionButtonText: formatMessage({
	      id: 'appointments.confirmLeaveMessage'
	    })
	  });
	}
	
	LeaveFlowModal.propTypes = {
	  formatMessage: PropTypes.func,
	  clearProgressConsents: PropTypes.func
	};
	
	var LeaveFlowModalWithStyles = (0, _reactCssModules2.default)(LeaveFlowModal, _styles2.default, {
	  allowMultiple: true
	});
	
	var LeaveFlowModalWithRef = (0, _react.forwardRef)(LeaveFlowModalWithStyles);
	
	LeaveFlowModalWithRef.propTypes = {
	  formatMessage: PropTypes.func,
	  clearProgressConsents: PropTypes.func
	};
	
	exports.default = LeaveFlowModalWithRef;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ProviderNameAvatar = __webpack_require__(1092);
	
	var _ProviderNameAvatar2 = _interopRequireDefault(_ProviderNameAvatar);
	
	var _stringManipulations = __webpack_require__(3074);
	
	var _providerDetailsFormatter = __webpack_require__(904);
	
	var _styles = __webpack_require__(4918);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VisitOverview(_ref) {
	  var isEirVisitType = _ref.isEirVisitType,
	      isInlineVisit = _ref.isInlineVisit,
	      loading = _ref.loading,
	      openLocationModal = _ref.openLocationModal,
	      organization = _ref.organization,
	      provider = _ref.provider,
	      renderAvatar = _ref.renderAvatar,
	      renderBtn = _ref.renderBtn,
	      renderHeader = _ref.renderHeader,
	      rows = _ref.rows,
	      visitName = _ref.visitName,
	      withTopPositionDefault = _ref.withTopPositionDefault;
	
	  var renderProviderSubTitle = (0, _react.useCallback)(_providerDetailsFormatter.fullProviderSubtitle, []);
	
	  var providerDetails = (0, _react.useMemo)(function () {
	    return (0, _providerDetailsFormatter.transformProviderNameWithTitle)(provider);
	  }, [provider]);
	
	  function renderAvatarSection() {
	    if (typeof renderAvatar === 'function') {
	      return renderAvatar();
	    }
	
	    if (isInlineVisit || isEirVisitType) {
	      if ((0, _isEmpty2.default)(provider)) {
	        return _react2.default.createElement(
	          'div',
	          { className: _styles2.default.inlineVisit },
	          _react2.default.createElement('img', {
	            style: { width: 40 },
	            src: organization.logo.thumbMin,
	            alt: 'organization-logo'
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              organization.name
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              visitName
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _styles2.default.inlineVisit },
	        _react2.default.createElement('img', {
	          style: { width: 40 },
	          src: provider.avatar.thumbMin,
	          alt: 'provider-logo'
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            provider.pwbDisplayableName
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            (0, _stringManipulations.sequenceWords)([provider.specialization, organization.name])
	          )
	        )
	      );
	    }
	
	    return _react2.default.createElement(_ProviderNameAvatar2.default, {
	      renderMeta: renderProviderSubTitle,
	      provider: providerDetails,
	      avatarSize: 44
	    });
	  }
	
	  var openModalHandle = function openModalHandle() {
	    openLocationModal(true);
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _Shape2.default,
	      { styleName: 'OverviewHeader', withoutMargin: true },
	      renderAvatarSection(),
	      renderHeader()
	    ),
	    _react2.default.createElement(
	      _Shape2.default,
	      {
	        styleName: (0, _classnames2.default)('Overview', {
	          'Overview--topPosition': withTopPositionDefault
	        })
	      },
	      _react2.default.createElement(
	        'div',
	        { styleName: (0, _classnames2.default)({ loading: loading }) },
	        loading && _react2.default.createElement(_Loader2.default, { styleName: 'loader' }),
	        rows.map(function (_ref2) {
	          var row = _ref2.row,
	              id = _ref2.id;
	          return _react2.default.createElement(
	            'div',
	            { styleName: 'OverviewRow', key: id },
	            row.map(function (_ref3, index) {
	              var title = _ref3.title,
	                  text = _ref3.text,
	                  extra = _ref3.extra,
	                  location = _ref3.location,
	                  icsUrl = _ref3.icsUrl,
	                  icsUrlTitle = _ref3.icsUrlTitle,
	                  component = _ref3.component,
	                  fullWidthRow = _ref3.fullWidthRow,
	                  style = _ref3.style;
	
	              return fullWidthRow &&
	              // eslint-disable-next-line react/no-array-index-key
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.fullWidthRow, key: index },
	                component
	              ) || _react2.default.createElement(
	                'div',
	                { styleName: 'OverviewCell', key: title },
	                component || _react2.default.createElement(
	                  _react.Fragment,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { styleName: 'OverviewCell-title' },
	                    title
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { styleName: 'OverviewCell-text', style: style },
	                    text
	                  ),
	                  extra && _react2.default.createElement(
	                    'div',
	                    { styleName: 'OverviewCell-extra' },
	                    extra
	                  ),
	                  location && _react2.default.createElement(
	                    'div',
	                    {
	                      styleName: 'OverviewCell-location',
	                      onClick: openModalHandle
	                    },
	                    location
	                  ),
	                  icsUrl && _react2.default.createElement(
	                    'a',
	                    {
	                      href: icsUrl,
	                      download: true,
	                      styleName: 'OverviewCell-location'
	                    },
	                    icsUrlTitle
	                  )
	                )
	              );
	            })
	          );
	        })
	      ),
	      renderBtn()
	    )
	  );
	}
	
	VisitOverview.propTypes = {
	  isEirVisitType: PropTypes.bool,
	  isInlineVisit: PropTypes.bool,
	  loading: PropTypes.bool,
	  openLocationModal: PropTypes.func,
	  organization: PropTypes.object,
	  provider: PropTypes.object,
	  renderAvatar: PropTypes.func,
	  renderBtn: PropTypes.func,
	  renderHeader: PropTypes.func,
	  rows: PropTypes.array,
	  visitName: PropTypes.string,
	  withTopPositionDefault: PropTypes.bool
	};
	
	VisitOverview.defaultProps = {
	  isEirVisitType: false,
	  openLocationModal: function openLocationModal() {},
	  renderBtn: function renderBtn() {},
	  renderHeader: function renderHeader() {},
	  rows: []
	};
	
	exports.default = (0, _reactCssModules2.default)(VisitOverview, _styles2.default, { allowMultiple: true });

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFullAdress = undefined;
	
	var _updateDeep = __webpack_require__(1941);
	
	var getFullAdress = exports.getFullAdress = function getFullAdress(location) {
	  return (0, _updateDeep.joinString)([location.address, location.city, (0, _updateDeep.joinString)([location.state, location.zip], ' ')], ', ');
	};

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _formFields = __webpack_require__(38);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _TermsAndPoliciesBox = __webpack_require__(3746);
	
	var _TermsAndPoliciesBox2 = _interopRequireDefault(_TermsAndPoliciesBox);
	
	var _DateDropdown = __webpack_require__(498);
	
	var _DateDropdown2 = _interopRequireDefault(_DateDropdown);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LAST_NAME = _formFields.PROFILE_FIELDS_TYPES.LAST_NAME,
	    FIRST_NAME = _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME,
	    DOB = _formFields.PROFILE_FIELDS_TYPES.DOB,
	    NAME_SUFFIX = _formFields.PROFILE_FIELDS_TYPES.NAME_SUFFIX,
	    COUNTRY = _formFields.PROFILE_FIELDS_TYPES.COUNTRY,
	    ACCEPTED_TERMS_AND_CONDITIONS = _formFields.PROFILE_FIELDS_TYPES.ACCEPTED_TERMS_AND_CONDITIONS,
	    ACCEPTED_PRIVACY_POLICY = _formFields.PROFILE_FIELDS_TYPES.ACCEPTED_PRIVACY_POLICY,
	    GENDER = _formFields.PROFILE_FIELDS_TYPES.GENDER;
	
	
	var AuthPersonalInfoForm = function AuthPersonalInfoForm(_ref) {
	  var firstName = _ref.firstName,
	      lastName = _ref.lastName,
	      validateErrors = _ref.validateErrors,
	      nameSuffixList = _ref.nameSuffixList,
	      nameSuffix = _ref.nameSuffix,
	      dob = _ref.dob,
	      formatMessage = _ref.formatMessage,
	      _onChange2 = _ref.onChange,
	      profileEditable = _ref.profileEditable,
	      acceptedPrivacyPolicy = _ref.acceptedPrivacyPolicy,
	      termsAndConditionsAccepted = _ref.termsAndConditionsAccepted,
	      showPrivacy = _ref.showPrivacy,
	      countries = _ref.countries,
	      country = _ref.country,
	      gender = _ref.gender,
	      genderList = _ref.genderList,
	      countryForOrganization = _ref.countryForOrganization;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, _onChange2);
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(FIRST_NAME), {
	      value: firstName,
	      disabled: !profileEditable,
	      className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb3')
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: FIRST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(LAST_NAME), {
	      value: lastName,
	      disabled: !profileEditable,
	      className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb3')
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: LAST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(NAME_SUFFIX), {
	      options: nameSuffixList,
	      value: nameSuffix,
	      needUpdateDefaultValue: true,
	      className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.selectField, 'mb3')
	    })),
	    _react2.default.createElement(_DateDropdown2.default, (0, _extends3.default)({}, makeProfileField(DOB), {
	      value: dob,
	      disabled: !profileEditable,
	      className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.selectField, 'mb3')
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(GENDER), {
	      value: gender,
	      options: genderList,
	      needUpdateDefaultValue: true,
	      className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.selectField, 'mb3')
	    })),
	    showPrivacy && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(COUNTRY, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	        options: countries,
	        value: country,
	        readOnly: Boolean(countryForOrganization),
	        needUpdateDefaultValue: true,
	        className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.selectField, 'mb3'),
	        required: true,
	        onChange: function onChange(value) {
	          var _onChange;
	
	          _onChange2((_onChange = {}, (0, _defineProperty3.default)(_onChange, ACCEPTED_TERMS_AND_CONDITIONS, false), (0, _defineProperty3.default)(_onChange, ACCEPTED_PRIVACY_POLICY, false), (0, _defineProperty3.default)(_onChange, COUNTRY, value.value), _onChange));
	        }
	      })),
	      _react2.default.createElement(_TermsAndPoliciesBox2.default, (0, _extends3.default)({}, makeProfileField(ACCEPTED_TERMS_AND_CONDITIONS, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	        termsValue: termsAndConditionsAccepted,
	        privacyValue: acceptedPrivacyPolicy
	      }))
	    )
	  );
	};
	
	AuthPersonalInfoForm.propTypes = {
	  validateErrors: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({ description: PropTypes.string })]),
	  nameSuffixList: PropTypes.array,
	  nameSuffix: PropTypes.string,
	  formatMessage: PropTypes.func,
	  firstName: PropTypes.string,
	  lastName: PropTypes.string,
	  onChange: PropTypes.func,
	  dob: PropTypes.string,
	  profileEditable: PropTypes.bool,
	  primaryPatientProfile: PropTypes.object,
	  acceptedPrivacyPolicy: PropTypes.bool,
	  termsAndConditionsAccepted: PropTypes.bool,
	  showPrivacy: PropTypes.bool,
	  countries: PropTypes.array.isRequired,
	  country: PropTypes.string,
	  gender: PropTypes.string,
	  genderList: PropTypes.array,
	  race: PropTypes.string,
	  races: PropTypes.array,
	  ethnicity: PropTypes.string,
	  ethnicitys: PropTypes.array,
	  countryForOrganization: PropTypes.string
	};
	
	exports.default = AuthPersonalInfoForm;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formSerialize = __webpack_require__(723);
	
	var _formSerialize2 = _interopRequireDefault(_formSerialize);
	
	var _env = __webpack_require__(103);
	
	var _customSerializer = __webpack_require__(1918);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * That `cloneElement` thing a little bit hacky, because it won't work if there'll be more
	 * than one children. But we also shouldn't put an array of form into this, so everything will be OK
	 * Did it to provide more clean code without using loops
	 * */
	
	var DEFAULT_ACTION = function DEFAULT_ACTION() {}; /* eslint-disable react/destructuring-assignment,lines-between-class-members */
	
	var Form = function (_Component) {
	  (0, _inherits3.default)(Form, _Component);
	
	  function Form() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Form.__proto__ || (0, _getPrototypeOf2.default)(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      serializedForm: {}
	    }, _this.options = {}, _this.intl = {}, _this.form = null, _this.action = DEFAULT_ACTION, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Form, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.handleSubmit = this.handleSubmit.bind(this);
	      this.getAction = this.getAction.bind(this);
	      this.getOptions = this.getOptions.bind(this);
	      this.getIntl = this.getIntl.bind(this);
	    }
	  }, {
	    key: 'getAction',
	    value: function getAction(action) {
	      this.action = action || DEFAULT_ACTION;
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions(options) {
	      this.options = options;
	    }
	  }, {
	    key: 'getIntl',
	    value: function getIntl(intl) {
	      this.intl = intl;
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var formatMessage = this.intl.formatMessage;
	
	
	      var serializer = function serializer(result, key, value) {
	        return (0, _customSerializer.customSerializer)(result, key, value, formatMessage);
	      };
	      var serializedForm = (0, _formSerialize2.default)(this.form, { hash: true, serializer: serializer });
	      this.setState({ serializedForm: serializedForm }, function () {
	        _this2.action((0, _extends3.default)({}, _this2.state.serializedForm, _this2.options));
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var children = this.props.children;
	
	      return _react2.default.createElement(
	        'form',
	        {
	          action: 'POST',
	          onSubmit: this.handleSubmit,
	          ref: function ref(node) {
	            return _this3.form = node;
	          }
	        },
	        (0, _react.cloneElement)(children, {
	          serializedForm: this.state.serializedForm,
	          getAction: this.getAction,
	          getOptions: this.getOptions,
	          getIntl: this.getIntl
	        }),
	        _react2.default.createElement('input', {
	          type: 'hidden',
	          name: 'authenticity_token',
	          value: _env.AUTHENTICITY_TOKEN
	        })
	      );
	    }
	  }]);
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  children: _propTypes2.default.node
	};
	
	Form.defaultProps = {
	  children: {}
	};
	
	exports.default = Form;

/***/ }),
/* 1710 */,
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.decodeQueryParams = decodeQueryParams;
	
	var _validations = __webpack_require__(81);
	
	function decodeQueryParams(value) {
	  if (value === null || value === undefined) return value;
	  var map = {
	    '+': '%2B',
	    '-': '%2D',
	    _: '%5F',
	    '@': '%40',
	    '.': '%2E'
	  };
	  return String(value).replace(_validations.PATTERNS.CHARACTERS, function (ch) {
	    return map[ch];
	  });
	}

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useAuthPersonalInfoForm = useAuthPersonalInfoForm;
	
	var _react = __webpack_require__(1);
	
	var _pick = __webpack_require__(466);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _useFields2 = __webpack_require__(3104);
	
	var _useFields3 = _interopRequireDefault(_useFields2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useAuthPersonalInfoForm(profile, errors, options) {
	  var _useFields = (0, _useFields3.default)(options),
	      initialState = _useFields.initialState,
	      initialFields = _useFields.initialFields,
	      validationFields = _useFields.validationFields;
	
	  var _useFormState = (0, _useFormWithValidation.useFormState)((0, _extends3.default)({}, initialState, (0, _pick2.default)(profile, initialFields))),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var _useFormValidation = (0, _useFormWithValidation.useFormValidation)(errors),
	      validateErrors = _useFormValidation.validateErrors,
	      clearErrors = _useFormValidation.clearErrors;
	
	  var validateRequiredFields = (0, _react.useMemo)(function () {
	    return (0, _useFormWithValidation.makeLocalFieldsValidation)(validationFields);
	  }, []);
	
	  var isValid = validateRequiredFields(formState);
	
	  return {
	    formState: formState,
	    handleFormChange: handleFormChange,
	    validateErrors: validateErrors,
	    clearErrors: clearErrors,
	    isValid: isValid
	  };
	}

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateUsernameLength = validateUsernameLength;
	exports.validateUsernameCharacters = validateUsernameCharacters;
	exports.validateUsernameRepeating = validateUsernameRepeating;
	exports.validateUsernameSpaces = validateUsernameSpaces;
	exports.getUsernameTooltipOptions = getUsernameTooltipOptions;
	
	var _validations = __webpack_require__(81);
	
	var _passwordRules = __webpack_require__(1210);
	
	function validateUsernameLength(value) {
	  return value && value.length >= 3 && value.length <= 40;
	}
	
	function validateUsernameCharacters(value) {
	  return _validations.PATTERNS.USERNAME_CHARACTERS.test(value);
	}
	
	function validateUsernameRepeating(value) {
	  return _validations.PATTERNS.USERNAME_REPEATING.test(value);
	}
	
	function validateUsernameSpaces(value) {
	  return _validations.PATTERNS.USERNAME_NO_SPACES.test(value);
	}
	
	function getUsernameTooltipOptions(value) {
	  var liStatus1 = _passwordRules.PASSWORD_STATUS.DEFAULT;
	  var liStatus2 = _passwordRules.PASSWORD_STATUS.DEFAULT;
	  var liStatus3 = _passwordRules.PASSWORD_STATUS.DEFAULT;
	
	  if (value) {
	    if (validateUsernameCharacters(value)) {
	      liStatus1 = _passwordRules.PASSWORD_STATUS.DONE;
	    } else {
	      liStatus1 = _passwordRules.PASSWORD_STATUS.DANGER;
	    }
	
	    if (validateUsernameRepeating(value)) {
	      liStatus2 = _passwordRules.PASSWORD_STATUS.DONE;
	    } else {
	      liStatus2 = _passwordRules.PASSWORD_STATUS.DANGER;
	    }
	
	    if (validateUsernameSpaces(value)) {
	      liStatus3 = _passwordRules.PASSWORD_STATUS.DONE;
	    } else {
	      liStatus3 = _passwordRules.PASSWORD_STATUS.DANGER;
	    }
	  }
	
	  return [{
	    rule: _validations.PATTERNS.USERNAME_CHARACTERS,
	    title: 'auth.signup.popover.li1',
	    status: liStatus1
	  }, {
	    rule: _validations.PATTERNS.USERNAME_REPEATING,
	    title: 'auth.signup.popover.li2',
	    status: liStatus2
	  }, {
	    rule: _validations.PATTERNS.USERNAME_NO_SPACES,
	    title: 'auth.signup.popover.li3',
	    status: liStatus3
	  }];
	}

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(23);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _index = __webpack_require__(112);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _props = __webpack_require__(41);
	
	var _index3 = __webpack_require__(2242);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserCard = function UserCard(_ref) {
	  var className = _ref.className,
	      _ref$user = _ref.user,
	      id = _ref$user.id,
	      avatar = _ref$user.avatar,
	      displayableName = _ref$user.displayableName,
	      note = _ref.note,
	      size = _ref.size,
	      linkType = _ref.linkType,
	      relatedPatientId = _ref.relatedPatientId,
	      loggedUser = _ref.loggedUser,
	      disabled = _ref.disabled,
	      intro = _ref.intro,
	      additionalIcons = _ref.additionalIcons,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['className', 'user', 'note', 'size', 'linkType', 'relatedPatientId', 'loggedUser', 'disabled', 'intro', 'additionalIcons']);
	
	  var userAvatar = _react2.default.createElement(_Avatar2.default, (0, _extends3.default)({ size: size }, {
	    children: displayableName,
	    src: (0, _get2.default)(avatar, 'thumbMin')
	  }));
	
	  var userData = {
	    primary: displayableName,
	    complementary: note
	  };
	
	  var isOwnProfile = loggedUser.id === id;
	  var adaptedLinkTypeForFamilyMembersOwnProfiles = linkType === _props.USER_TYPES.FAMILY_MEMBER ? _props.USER_TYPES.PATIENT : linkType;
	
	  var link = relatedPatientId && !isOwnProfile ? '/profile/' + relatedPatientId + '/' + linkType + '/' + id : '/profile/' + id + '/' + adaptedLinkTypeForFamilyMembersOwnProfiles;
	
	  var cardItem = _react2.default.createElement(_index2.default, (0, _extends3.default)({ className: className }, other, {
	    additionalContent: { left: userAvatar },
	    text: userData,
	    additionalIcons: additionalIcons
	  }));
	
	  var introItem = intro && intro.patientName ? _react2.default.createElement('span', { className: intro.patientName }) : null;
	
	  if (disabled) return _react2.default.createElement(
	    'div',
	    { className: 'intro-flexWrapper' },
	    cardItem,
	    introItem
	  );
	
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: link, className: 'g-hoverable' },
	    cardItem,
	    introItem
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	UserCard.propTypes = {
	  className: _propTypes2.default.string,
	  user: _propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    avatar: _propTypes2.default.objectOf(_propTypes2.default.string),
	    displayableName: _propTypes2.default.string
	  }),
	  note: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  linkType: _propTypes2.default.oneOf(_props.USER_TYPES_PROPS),
	  relatedPatientId: _propTypes2.default.number,
	  loggedUser: _propTypes2.default.shape({
	    id: _propTypes2.default.number
	  }),
	  disabled: _propTypes2.default.bool,
	  intro: _propTypes2.default.shape({
	    patientName: _propTypes2.default.string
	  }),
	  additionalIcons: _propTypes2.default.array
	};
	
	UserCard.defaultProps = {
	  size: 32
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loggedUser: (0, _selectors.loggedUserSelector)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactCssModules2.default)(UserCard, _index4.default, { allowMultiple: true }));

/***/ }),
/* 1715 */,
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ListItem = __webpack_require__(1717);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _IconMenu = __webpack_require__(337);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(953);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionItem = function ActionItem(_ref) {
	  var index = _ref.index,
	      intro = _ref.intro,
	      item = _ref.item,
	      menu = _ref.menu,
	      onClick = _ref.onClick;
	  return _react2.default.createElement(
	    'div',
	    { className: 'circle-action-item-card', styleName: 'circle-member-wrap' },
	    menu && menu.length ? [_react2.default.createElement(_IconMenu2.default, {
	      position: { vertical: 'bottom', horizontal: 'left' },
	      items: menu,
	      icon: { color: _styles.COLORS.bluePrimary },
	      style: {
	        position: 'absolute',
	        top: '2px',
	        right: '10px'
	      },
	      allScreens: true,
	      key: '0'
	    }), index === 0 && intro ? _react2.default.createElement('span', { styleName: 'menu-circle-member', className: intro, key: '1'
	    }) : null] : null,
	    _react2.default.createElement(_ListItem2.default, (0, _extends3.default)({}, item, { onClick: onClick }))
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	ActionItem.propTypes = {
	  index: _propTypes2.default.number,
	  intro: _propTypes2.default.string,
	  item: _propTypes2.default.shape({
	    icon: _propTypes2.default.string,
	    image: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    subtitle: _propTypes2.default.string,
	    note: _propTypes2.default.string
	  }),
	  menu: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    text: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    icon: _propTypes2.default.string
	  })).isRequired,
	  onClick: _propTypes2.default.func
	};
	
	ActionItem.defaultProps = {
	  onClick: function onClick() {}
	};
	
	exports.default = (0, _reactCssModules2.default)(ActionItem, _index2.default, { allowMultiple: true });

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _getPhone = __webpack_require__(187);
	
	var _index = __webpack_require__(953);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var ASSET_SIZE = 64;
	var STRING_MAX_LENGTH = 57;
	
	var ListItem = function ListItem(_ref) {
	  var icon = _ref.icon,
	      image = _ref.image,
	      title = _ref.title,
	      subtitle = _ref.subtitle,
	      note = _ref.note,
	      onClick = _ref.onClick,
	      intro = _ref.intro,
	      className = _ref.className,
	      titleIcon = _ref.titleIcon;
	  return _react2.default.createElement(
	    _Paper2.default,
	    (0, _extends3.default)({ onClick: onClick }, {
	      styleName: 'item',
	      className: (0, _classnames2.default)(className, { pointer: onClick }),
	      rounded: true
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt2 mb3' },
	      icon ? _react2.default.createElement(_Icon2.default, { name: icon, size: ASSET_SIZE }) : _react2.default.createElement(_Avatar2.default, { size: ASSET_SIZE, src: image, children: title })
	    ),
	    _react2.default.createElement(
	      'p',
	      { styleName: 'title', title: title },
	      titleIcon && _react2.default.createElement(_Icon2.default, { name: titleIcon, size: 12, className: 'mb1 mr1' }),
	      (0, _getPhone.getPhoneWithoutUSCode)(title)
	    ),
	    subtitle ? _react2.default.createElement(
	      'p',
	      { styleName: 'subtitle', title: subtitle, className: 'relative' },
	      subtitle.substring(0, STRING_MAX_LENGTH),
	      subtitle.length > STRING_MAX_LENGTH && '...',
	      (0, _get2.default)(intro, 'invite') ? _react2.default.createElement('span', { className: intro.invite }) : null
	    ) : null,
	    note ? _react2.default.createElement(
	      'p',
	      { styleName: 'note' },
	      note
	    ) : null
	  );
	};
	
	ListItem.propTypes = {
	  icon: _propTypes2.default.string,
	  image: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  note: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  intro: _propTypes2.default.shape({
	    invite: _propTypes2.default.string
	  }),
	  className: _propTypes2.default.string,
	  titleIcon: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(ListItem, _index2.default, { allowMultiple: true });

/***/ }),
/* 1718 */,
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _handleRolesOptions = __webpack_require__(1183);
	
	var _handleRolesOptions2 = _interopRequireDefault(_handleRolesOptions);
	
	var _CancelPendingInvitationsPopup = __webpack_require__(3122);
	
	var _CancelPendingInvitationsPopup2 = _interopRequireDefault(_CancelPendingInvitationsPopup);
	
	var _InviteButton = __webpack_require__(3376);
	
	var _InviteButton2 = _interopRequireDefault(_InviteButton);
	
	var _props = __webpack_require__(41);
	
	var _getSimpleFormProps = __webpack_require__(3130);
	
	var _getSimpleFormProps2 = _interopRequireDefault(_getSimpleFormProps);
	
	var _SimpleFormPopup = __webpack_require__(794);
	
	var _SimpleFormPopup2 = _interopRequireDefault(_SimpleFormPopup);
	
	var _useFamilySircle = __webpack_require__(3134);
	
	var _useSimpleForm2 = __webpack_require__(3135);
	
	var _DiscardModal = __webpack_require__(1180);
	
	var _DiscardModal2 = _interopRequireDefault(_DiscardModal);
	
	var _PopoverMenu = __webpack_require__(398);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	var _strings = __webpack_require__(15);
	
	var _FamilyCircle = __webpack_require__(3124);
	
	var _FamilyCircle2 = _interopRequireDefault(_FamilyCircle);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _enhance = __webpack_require__(3125);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FamilyCircleWrapper(_ref) {
	  var isProvider = _ref.isProvider,
	      changeRole = _ref.changeRole,
	      hideHeader = _ref.hideHeader,
	      shouldClear = _ref.shouldClear,
	      targetUser = _ref.targetUser,
	      createdUser = _ref.createdUser,
	      targetUserId = _ref.targetUserId,
	      familyCircle = _ref.familyCircle,
	      getMenuItems = _ref.getMenuItems,
	      loadingCircle = _ref.loadingCircle,
	      circleLoading = _ref.circleLoading,
	      clearRequests = _ref.clearRequests,
	      showTargetUser = _ref.showTargetUser,
	      hasFixedHeight = _ref.hasFixedHeight,
	      sendPatientInvite = _ref.sendPatientInvite,
	      inviteMemberErrors = _ref.inviteMemberErrors,
	      removeFamilyMember = _ref.removeFamilyMember,
	      inviteFamilyMember = _ref.inviteFamilyMember,
	      invitePatientError = _ref.invitePatientError,
	      showInvitationButton = _ref.showInvitationButton,
	      pendingFamilyMembers = _ref.pendingFamilyMembers,
	      handleTargetUserInvite = _ref.handleTargetUserInvite,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useFamilyCircle = (0, _useFamilySircle.useFamilyCircle)({
	    getMenuItems: getMenuItems,
	    createdUser: createdUser,
	    clearRequests: clearRequests,
	    handleTargetUserInvite: handleTargetUserInvite
	  }),
	      getItems = _useFamilyCircle.getItems,
	      circleState = _useFamilyCircle.circleState,
	      handleClearState = _useFamilyCircle.handleClearState,
	      handleOpenPopover = _useFamilyCircle.handleOpenPopover,
	      handleOpenSimpleFormPopup = _useFamilyCircle.handleOpenSimpleFormPopup;
	
	  var user = circleState.user,
	      anchorEl = circleState.anchorEl,
	      actionType = circleState.actionType,
	      isModalOpen = circleState.isModalOpen,
	      isPopoverOpen = circleState.isPopoverOpen,
	      isSimpleFormOpen = circleState.isSimpleFormOpen,
	      isCancelPopupOpen = circleState.isCancelPopupOpen;
	
	
	  var memberId = (0, _react.useMemo)(function () {
	    return (0, _get2.default)(user, 'id');
	  }, [user]);
	
	  var _useSimpleForm = (0, _useSimpleForm2.useSimpleForm)({
	    memberId: memberId,
	    targetUser: targetUser,
	    changeRole: changeRole,
	    sendPatientInvite: sendPatientInvite,
	    inviteFamilyMember: inviteFamilyMember
	  }),
	      setFormFields = _useSimpleForm.setFormFields,
	      useCustomFields = _useSimpleForm.useCustomFields,
	      simpleFormHandlers = _useSimpleForm.simpleFormHandlers,
	      simpleFormInitState = _useSimpleForm.simpleFormInitState;
	
	  (0, _react.useEffect)(function () {
	    if (shouldClear) handleClearState();
	  }, [shouldClear]);
	
	  var list = (0, _react.useMemo)(function () {
	    var circleList = [].concat((0, _toConsumableArray3.default)(familyCircle), (0, _toConsumableArray3.default)(pendingFamilyMembers));
	    if (showTargetUser) {
	      var targetUserItem = (0, _extends3.default)({}, targetUser, {
	        isTargetUser: true,
	        pending: !createdUser,
	        role: _props.PATIENT
	      });
	      return [targetUserItem].concat((0, _toConsumableArray3.default)(circleList));
	    }
	    return circleList;
	  }, [showTargetUser, targetUser, familyCircle, pendingFamilyMembers, createdUser]);
	
	  var customRoleOptions = showTargetUser && createdUser ? (0, _handleRolesOptions2.default)(formatMessage, (0, _extends3.default)({
	    PATIENT: _props.PATIENT
	  }, _props.CARE_ROLE)) : null;
	
	  var simpleFormProps = (0, _getSimpleFormProps2.default)(simpleFormHandlers(), actionType, user, formatMessage, {
	    patientInvite: showTargetUser && createdUser,
	    usePatientFields: useCustomFields
	  });
	
	  if (loadingCircle) return _react2.default.createElement(_Loader2.default, null);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_FamilyCircle2.default, {
	      isProvider: isProvider,
	      onInvite: handleOpenSimpleFormPopup,
	      onOpen: handleOpenPopover,
	      formatMessage: formatMessage,
	      relatedPatientId: targetUserId,
	      list: list,
	      title: formatMessage(_strings.CHAT.titles.familyChatTab),
	      type: 'family-member',
	      hideHeader: hideHeader,
	      hasFixedHeight: hasFixedHeight
	    }),
	    isPopoverOpen ? _react2.default.createElement(_PopoverMenu2.default, {
	      size: 'small',
	      isOpen: true,
	      anchorEl: anchorEl,
	      items: getItems,
	      key: anchorEl,
	      onClose: handleClearState
	    }) : null,
	    isModalOpen ? _react2.default.createElement(_DiscardModal2.default, {
	      isOpened: true,
	      onSubmit: function onSubmit() {
	        return removeFamilyMember(memberId);
	      },
	      onCancel: handleClearState,
	      title: formatMessage({ id: 'circles.family.removeQuestion' })
	    }) : null,
	    isSimpleFormOpen ? _react2.default.createElement(_SimpleFormPopup2.default, (0, _extends3.default)({}, simpleFormProps, {
	      loading: circleLoading,
	      errors: useCustomFields ? invitePatientError : inviteMemberErrors,
	      onClose: handleClearState,
	      customRoleOptions: customRoleOptions,
	      onChange: function onChange(state) {
	        return setFormFields(state);
	      },
	      initialData: simpleFormInitState,
	      key: useCustomFields
	    })) : null,
	    isCancelPopupOpen ? _react2.default.createElement(_CancelPendingInvitationsPopup2.default, {
	      targetUserId: targetUserId,
	      user: user,
	      onClose: handleClearState,
	      formatMessage: formatMessage
	    }) : null,
	    showInvitationButton ? _react2.default.createElement(_InviteButton2.default, {
	      formatMessage: formatMessage,
	      onClick: handleOpenSimpleFormPopup
	    }) : null
	  );
	}
	
	FamilyCircleWrapper.propTypes = {
	  circleLoading: _propTypes2.default.bool,
	  isProvider: _propTypes2.default.bool,
	  changeRole: _propTypes2.default.func,
	  hideHeader: _propTypes2.default.bool,
	  createdUser: _propTypes2.default.bool,
	  shouldClear: _propTypes2.default.bool,
	  loadingCircle: _propTypes2.default.bool,
	  targetUser: _propTypes2.default.object,
	  targetUserId: _propTypes2.default.number,
	  familyCircle: _propTypes2.default.array,
	  getMenuItems: _propTypes2.default.func,
	  clearRequests: _propTypes2.default.func,
	  getCircleOfCare: _propTypes2.default.func,
	  removeFamilyMember: _propTypes2.default.func,
	  inviteFamilyMember: _propTypes2.default.func,
	  showInvitationButton: _propTypes2.default.bool,
	  pendingFamilyMembers: _propTypes2.default.array,
	  handleTargetUserInvite: _propTypes2.default.func,
	  showTargetUser: _propTypes2.default.bool,
	  hasFixedHeight: _propTypes2.default.bool,
	  intl: _propTypes2.default.object,
	  inviteMemberErrors: _propTypes2.default.object,
	  invitePatientError: _propTypes2.default.object,
	  sendPatientInvite: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(FamilyCircleWrapper);

/***/ }),
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formSerialize = __webpack_require__(723);
	
	var _formSerialize2 = _interopRequireDefault(_formSerialize);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _TermsContent = __webpack_require__(1807);
	
	var _TermsContent2 = _interopRequireDefault(_TermsContent);
	
	var _popup = __webpack_require__(76);
	
	var _formInProgress = __webpack_require__(1373);
	
	var _selectors = __webpack_require__(90);
	
	var _selectors2 = __webpack_require__(23);
	
	var _selectors3 = __webpack_require__(50);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(563);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    termsVisible: (0, _selectors.popupSecondaryContentVisibilitySelector)(state),
	    formInProgress: (0, _selectors.uiFormInProgressSelector)(state),
	    privacyList: (0, _selectors3.privacyListSelector)(state),
	    loggedUserCountry: (0, _selectors2.loggedUserCountrySelector)(state),
	    sending: (0, _selectors3.sendingPrivacySelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  toggleTerms: _popup.actions.toggleContent,
	  addForm: _formInProgress.actions.add,
	  clearForm: _formInProgress.actions.delete
	};
	
	var Form = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
	  (0, _inherits3.default)(Form, _Component);
	
	  function Form() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Form.__proto__ || (0, _getPrototypeOf2.default)(Form)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      accepted: !!_this.props.formInProgress.termsAndConditionsAccepted,
	      serializedForm: {},
	      disabled: true,
	      contentType: ''
	    }, _this.handlePrivacyText = function (country) {
	      var _this$props = _this.props,
	          sending = _this$props.sending,
	          privacyList = _this$props.privacyList;
	
	      return !sending && privacyList.find(function (item) {
	        return (0, _get2.default)(item, 'country') === country;
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Form, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          isFormValid = _props.isFormValid,
	          formInProgress = _props.formInProgress;
	
	      this.setState({ disabled: !isFormValid(formInProgress) });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props2 = this.props,
	          error = _props2.error,
	          invitePopupVisible = _props2.invitePopupVisible,
	          clearErrors = _props2.clearErrors,
	          clearForm = _props2.clearForm;
	
	
	      if (error && !invitePopupVisible && typeof clearErrors === 'function') {
	        clearErrors();
	      }
	
	      clearForm && clearForm(); // eslint-disable-line no-unused-expressions
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var _this2 = this;
	
	      e.preventDefault();
	      this.setState({
	        serializedForm: (0, _formSerialize2.default)(this.form, { hash: true })
	      }, function () {
	        _this2.props.onSubmit(_this2.state.serializedForm);
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange() {
	      var formData = (0, _formSerialize2.default)(this.form, { hash: true });
	
	      this.setState({ disabled: !this.props.isFormValid(formData) });
	    }
	  }, {
	    key: 'changeTermsAccepted',
	    value: function changeTermsAccepted() {
	      this.setState({ accepted: !this.state.accepted });
	    }
	  }, {
	    key: 'closePopup',
	    value: function closePopup(e) {
	      e.preventDefault();
	      this.props.closeInvitePopup();
	    }
	  }, {
	    key: 'handlePopupChange',
	    value: function handlePopupChange(type) {
	      this.setState({
	        contentType: type
	      });
	      var form = (0, _formSerialize2.default)(this.form, { hash: true });
	      this.props.addForm(form);
	      this.props.toggleTerms();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          disabled = _state.disabled,
	          contentType = _state.contentType;
	      var _props3 = this.props,
	          inviteMessage = _props3.inviteMessage,
	          children = _props3.children,
	          onError = _props3.onError,
	          termsVisible = _props3.termsVisible,
	          toggleTerms = _props3.toggleTerms,
	          formatMessage = _props3.formatMessage,
	          loggedUserCountry = _props3.loggedUserCountry,
	          hideTerms = _props3.hideTerms;
	
	      var errorMessage = onError();
	      var defaultPrivacy = this.handlePrivacyText('USA');
	      // TODO temporary privacyList contain only USA
	      var privacyText = defaultPrivacy;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'form',
	          {
	            onSubmit: this.handleSubmit,
	            onChange: this.handleChange,
	            onMouseUp: this.handleChange,
	            ref: function ref(node) {
	              return _this3.form = node;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('pb4', { dn: termsVisible }) },
	            _react2.default.createElement(
	              'p',
	              { styleName: 'circles-popup-text' },
	              inviteMessage
	            ),
	            children,
	            errorMessage ? _react2.default.createElement(_ErrorBlock2.default, { className: 'mb4', errors: errorMessage }) : null,
	            !hideTerms && _react2.default.createElement(
	              'div',
	              { styleName: 'checkboxWrapper' },
	              _react2.default.createElement('input', {
	                id: 'terms-input',
	                className: 'mr2',
	                name: 'termsAndConditionsAccepted',
	                checked: this.state.accepted,
	                type: 'checkbox',
	                value: true,
	                onChange: this.changeTermsAccepted
	              }),
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'terms-input' },
	                formatMessage(_strings.AUTH.actions.tnc.textTitle)
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  styleName: 'link--acceptable',
	                  onClick: function onClick() {
	                    return _this3.handlePopupChange('privacy');
	                  },
	                  className: 'mr2'
	                },
	                formatMessage(_strings.COMMON.privacy)
	              ),
	              _react2.default.createElement(
	                'span',
	                { styleName: 'text' },
	                formatMessage(_strings.DIALOG_TITLE.and)
	              ),
	              _react2.default.createElement(
	                'a',
	                {
	                  styleName: 'link--acceptable',
	                  onClick: function onClick() {
	                    return _this3.handlePopupChange('terms');
	                  }
	                },
	                formatMessage(_strings.AUTH.actions.tnc.textLink)
	              )
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                type: 'submit',
	                className: 'mt3 mr2',
	                raised: true,
	                color: 'primary',
	                disabled: disabled
	              },
	              formatMessage(_strings.COMMON.invite)
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'mt3',
	                raised: true,
	                color: 'accent',
	                type: 'button',
	                onClick: this.closePopup
	              },
	              formatMessage(_strings.COMMON.cancel)
	            )
	          ),
	          termsVisible ? [_react2.default.createElement(_TermsContent2.default, {
	            content: contentType === 'terms' ? privacyText.terms : privacyText.privacyPolicy,
	            key: '0'
	          }), _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'mt3',
	              raised: true,
	              color: 'primary',
	              onClick: function onClick() {
	                return toggleTerms();
	              },
	              key: '1'
	            },
	            formatMessage(_strings.TOGGLE_TNC)
	          )] : null
	        )
	      );
	    }
	  }]);
	  return Form;
	}(_react.Component), _class3.propTypes = {
	  error: _propTypes2.default.object,
	  inviteMessage: _propTypes2.default.string.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onError: _propTypes2.default.func.isRequired,
	  isFormValid: _propTypes2.default.func.isRequired,
	  closeInvitePopup: _propTypes2.default.func.isRequired,
	  clearErrors: _propTypes2.default.func,
	  invitePopupVisible: _propTypes2.default.bool,
	  children: _propTypes2.default.any,
	  termsAnchor: _propTypes2.default.string,
	  toggleTerms: _propTypes2.default.func,
	  termsVisible: _propTypes2.default.bool,
	  addForm: _propTypes2.default.func,
	  formInProgress: _propTypes2.default.object,
	  clearForm: _propTypes2.default.func,
	  formatMessage: _propTypes2.default.func,
	  privacyList: _propTypes2.default.array,
	  loggedUserCountry: _propTypes2.default.string,
	  sending: _propTypes2.default.bool,
	  hideTerms: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  onError: function onError() {}
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleSubmit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeTermsAccepted', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changeTermsAccepted'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'closePopup', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'closePopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handlePopupChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handlePopupChange'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = Form;

/***/ }),
/* 1724 */,
/* 1725 */,
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Label = __webpack_require__(1187);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _dateConverters = __webpack_require__(83);
	
	var _chars = __webpack_require__(258);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(1486);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var composeSubtitle = function composeSubtitle(comments, replyTo, formatMessage) {
	  if (comments) {
	    var commentsText = comments && comments.length > 0 && _chars.BULL + ' ' + comments.length + ' ' + formatMessage(_strings.POST_REPLIES);
	
	    var staticText = formatMessage(_strings.POST_COMMENT_DESCRIPTION);
	
	    return commentsText ? staticText + ' ' + commentsText : staticText;
	  }
	
	  return replyTo ? formatMessage(_strings.POST_REPLY_DESCRIPTION, { name: replyTo }) : '';
	}; /* eslint-disable react/require-default-props */
	
	
	var Heading = function Heading(_ref) {
	  var userName = _ref.userName,
	      comments = _ref.comments,
	      createdAt = _ref.createdAt,
	      replyTo = _ref.replyTo,
	      updated = _ref.updated,
	      formatMessage = _ref.intl.formatMessage,
	      isNewComment = _ref.isNewComment,
	      onTitleClick = _ref.onTitleClick;
	
	  var subtitle = composeSubtitle(comments, replyTo, formatMessage);
	  var time = createdAt && (0, _dateConverters.formatDateTime)(createdAt, formatMessage);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'heading' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'heading__title' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { onClick: onTitleClick, className: 'pointer' },
	          userName
	        ),
	        _react2.default.createElement(
	          'span',
	          { styleName: 'heading__subtitle' },
	          subtitle
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'heading__time' },
	      _react2.default.createElement(
	        'span',
	        { className: 'mr2' },
	        time
	      ),
	      updated ? _react2.default.createElement(
	        'span',
	        null,
	        ' ',
	        '(',
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMUNITY_COMMENT_UPDATED),
	        ')'
	      ) : null,
	      isNewComment ? _react2.default.createElement(_Label2.default, { text: formatMessage(_strings.COMMON.new), additionalClass: 'uppercase' }) : null
	    )
	  );
	};
	
	Heading.propTypes = {
	  userName: _propTypes2.default.string,
	  comments: _propTypes2.default.array, // todo
	  createdAt: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  replyTo: _propTypes2.default.string,
	  updated: _propTypes2.default.bool,
	  isNewComment: _propTypes2.default.bool,
	  onTitleClick: _propTypes2.default.func
	};
	
	Heading.defaultProps = {
	  isNewComment: false,
	  onTitleClick: null
	};
	
	var StyledHeading = (0, _reactCssModules2.default)(Heading, _index2.default, { allowMultiple: true });
	exports.default = (0, _reactIntl.injectIntl)(StyledHeading);

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable react/require-default-props,react/destructuring-assignment */
	/* eslint-disable react/no-access-state-in-setstate,no-nested-ternary,react/jsx-handler-names */
	/* eslint-disable no-shadow,react/sort-comp  */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _autolinker = __webpack_require__(757);
	
	var _autolinker2 = _interopRequireDefault(_autolinker);
	
	var _lodash = __webpack_require__(58);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _strings = __webpack_require__(15);
	
	var _sanitizeHtml = __webpack_require__(313);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _commentsList = __webpack_require__(299);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _IconMenu = __webpack_require__(337);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _Heading = __webpack_require__(1726);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Replies = __webpack_require__(3150);
	
	var _Replies2 = _interopRequireDefault(_Replies);
	
	var _Reply = __webpack_require__(3151);
	
	var _Reply2 = _interopRequireDefault(_Reply);
	
	var _generateHtmlText = __webpack_require__(1384);
	
	var _generateHtmlText2 = _interopRequireDefault(_generateHtmlText);
	
	var _withPopoverMenu = __webpack_require__(501);
	
	var _withPopoverMenu2 = _interopRequireDefault(_withPopoverMenu);
	
	var _popup = __webpack_require__(76);
	
	var _routes = __webpack_require__(37);
	
	var _chat = __webpack_require__(67);
	
	var _ids = __webpack_require__(46);
	
	var _index = __webpack_require__(1486);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var mapDispatchToProps = {
	  updateComment: _commentsList.actions.editCommentStatus,
	  showCommentReport: _popup.reportActions.comment
	};
	
	var Comment = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (0, _withPopoverMenu2.default)(_class = (0, _reactIntl.injectIntl)(_class = _dec2(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
	  (0, _inherits3.default)(Comment, _Component);
	
	  function Comment() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Comment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Comment.__proto__ || (0, _getPrototypeOf2.default)(Comment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      onDeleteRequested: false,
	      editing: false,
	      confirmOpened: false
	    }, _this.debouncedOnDispatch = (0, _lodash.debounce)(function () {
	      var _this$props = _this.props,
	          id = _this$props.id,
	          updateComment = _this$props.updateComment,
	          parentId = _this$props.parentId;
	
	      updateComment({ id: id, parentId: parentId, prop: { isNewComment: false } });
	    }, 10000), _this.gotoProfile = function () {
	      return _browserHistory2.default.push(_routes.PUBLIC_PROFILE + '/' + _this.authorId);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Comment, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var isNewComment = this.props.isNewComment;
	
	      if (isNewComment) {
	        this.debouncedOnDispatch();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // duplicate logic for comments, for replies works componentDidMount
	      var isNewComment = this.props.isNewComment;
	
	      if (prevProps.isNewComment !== isNewComment && isNewComment) {
	        this.debouncedOnDispatch();
	      }
	    }
	  }, {
	    key: 'toggleReplyForm',
	    value: function toggleReplyForm() {
	      this.setState({ active: !this.state.active });
	    }
	  }, {
	    key: 'addReply',
	    value: function addReply(content) {
	      this.props.onReply(content);
	      this.setState({ active: false });
	    }
	  }, {
	    key: 'onEdit',
	    value: function onEdit(content, _onEdit) {
	      _onEdit(content);
	      this.setState({ editing: false });
	    }
	  }, {
	    key: 'onRequestDelete',
	    value: function onRequestDelete() {
	      this.setState({
	        onDeleteRequested: true,
	        confirmOpened: true
	      });
	    }
	  }, {
	    key: 'closeConfirmPopup',
	    value: function closeConfirmPopup() {
	      this.setState({
	        confirmOpened: false,
	        onDeleteRequested: false
	      });
	    }
	  }, {
	    key: 'onRequestEdit',
	    value: function onRequestEdit() {
	      this.setState({ editing: true });
	    }
	  }, {
	    key: 'onRequestSendMessage',
	    value: function onRequestSendMessage() {
	      var onRequestConversation = this.props.onRequestConversation;
	
	      onRequestConversation(this.authorId);
	    }
	  }, {
	    key: 'onRequestReport',
	    value: function onRequestReport() {
	      var _props = this.props,
	          showCommentReport = _props.showCommentReport,
	          id = _props.id;
	
	      showCommentReport(id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          active = _state.active,
	          onDeleteRequested = _state.onDeleteRequested,
	          editing = _state.editing,
	          confirmOpened = _state.confirmOpened;
	      var _props2 = this.props,
	          id = _props2.id,
	          content = _props2.content,
	          author = _props2.author,
	          comments = _props2.comments,
	          createdAt = _props2.createdAt,
	          replyTo = _props2.replyTo,
	          getCommentDeleteHandler = _props2.getCommentDeleteHandler,
	          getCommentEditHandler = _props2.getCommentEditHandler,
	          deleted = _props2.deleted,
	          deletedBy = _props2.deletedBy,
	          updated = _props2.updated,
	          parentId = _props2.parentId,
	          intl = _props2.intl,
	          canComment = _props2.canComment,
	          loggedUserId = _props2.loggedUserId,
	          isNewComment = _props2.isNewComment,
	          getMenuItems = _props2.getMenuItems,
	          onRequestConversation = _props2.onRequestConversation;
	      var formatMessage = intl.formatMessage;
	
	      var isFirstLevelComment = comments;
	      var hasReplies = comments && comments.length;
	      var onDelete = getCommentDeleteHandler({
	        id: id,
	        author: author,
	        parentId: parentId
	      });
	
	      var onEdit = getCommentEditHandler({
	        id: id,
	        author: author,
	        parentId: parentId
	      });
	
	      var body = deleted && deletedBy === 'moderator' ? formatMessage(_strings.COMMUNITY_COMMENTS.commentWasDeletedByModerator) : deleted ? formatMessage(_strings.COMMUNITY_COMMENTS.commentWasDeleted) : (0, _generateHtmlText2.default)(content);
	
	      var isLoggedUserComment = loggedUserId === this.authorId;
	
	      var getMenuOptions = function getMenuOptions() {
	        var options = {
	          editComment: onEdit && canComment && _this2.onRequestEdit,
	          removeComment: onDelete && canComment && _this2.onRequestDelete,
	          report: !isLoggedUserComment && _this2.onRequestReport
	        };
	        if (_chat.ALLOW_SOCIAL_CHAT_CREATION) {
	          var sendMessageMenuItem = {
	            sendMessage: !isLoggedUserComment && _this2.onRequestSendMessage
	          };
	          options = (0, _extends3.default)({}, options, sendMessageMenuItem);
	        }
	        return options;
	      };
	
	      var menu = !deleted && !editing ? getMenuItems(getMenuOptions()) : null;
	
	      var alistName = (0, _get3.default)(author, 'user.aliasName');
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: (0, _classnames2.default)('root', { danger: onDeleteRequested }) },
	        menu ? _react2.default.createElement(_IconMenu2.default, {
	          id: _ids.IDS.POST.REPLY_COMMENT_MENU_TRIGGER,
	          position: { horizontal: 'right', vertical: 'bottom' },
	          style: {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            transform: 'translate(-25%, -25%)'
	          },
	          items: menu,
	          allScreens: true
	        }) : null,
	        _react2.default.createElement(
	          'div',
	          { styleName: 'image', className: 'pointer', onClick: this.gotoProfile },
	          _react2.default.createElement(_Avatar2.default, {
	            children: alistName,
	            size: 40,
	            src: (0, _get3.default)(author, 'user.avatar.thumbMin')
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'content' },
	          _react2.default.createElement(_Heading2.default, (0, _extends3.default)({
	            userName: alistName,
	            onTitleClick: this.gotoProfile
	          }, { comments: comments, createdAt: createdAt, replyTo: replyTo, updated: updated, isNewComment: isNewComment })),
	          editing ? _react2.default.createElement(_Reply2.default, {
	            initialContent: content,
	            onSubmit: function onSubmit(content) {
	              return _this2.onEdit(content, onEdit);
	            }
	          }) : _react2.default.createElement('div', {
	            styleName: (0, _classnames2.default)('body', { deleted: deleted }),
	            dangerouslySetInnerHTML: {
	              __html: _autolinker2.default.link((0, _sanitizeHtml2.default)(body), {
	                className: 'clickable'
	              })
	            }
	          }),
	          onDelete ? _react2.default.createElement(_ActionConfirmation2.default, {
	            intl: intl,
	            onClose: this.closeConfirmPopup,
	            onSubmit: onDelete,
	            opened: confirmOpened,
	            title: formatMessage(_strings.COMMUNITY_COMMENT_MENU.deleteComment),
	            body: formatMessage(_strings.COMMUNITY_COMMENT_MENU.confirmDeleteComment),
	            actionButtonText: formatMessage(_strings.COMMUNITY_COMMENT_MENU.deleteComment)
	          }) : null,
	          isFirstLevelComment ? [hasReplies ? _react2.default.createElement(_Replies2.default, {
	            list: comments,
	            parentId: id,
	            getCommentDeleteHandler: getCommentDeleteHandler,
	            getCommentEditHandler: getCommentEditHandler,
	            commentAuthor: alistName,
	            onRequestConversation: onRequestConversation,
	            canComment: canComment,
	            loggedUserId: loggedUserId,
	            key: '0'
	          }) : null, (!deleted || hasReplies) && !editing && canComment ? _react2.default.createElement(
	            'div',
	            { styleName: 'action', key: '1'
	            },
	            active ? _react2.default.createElement(_Reply2.default, { onSubmit: this.addReply }) : _react2.default.createElement(
	              _Button2.default,
	              {
	                id: _ids.IDS.POST.REPLY_COMMENT_BTN,
	                color: 'accent',
	                raised: true,
	                type: 'button',
	                onClick: this.toggleReplyForm
	              },
	              _react2.default.createElement(_reactIntl.FormattedMessage, _strings.ACTIONS.post.reply)
	            )
	          ) : null] : null
	        )
	      );
	    }
	  }, {
	    key: 'authorId',
	    get: function get() {
	      var author = this.props.author;
	
	      return (0, _get3.default)(author, 'user.id');
	    }
	  }]);
	  return Comment;
	}(_react.Component), _class3.propTypes = {
	  id: _propTypes2.default.number,
	  content: _propTypes2.default.string,
	  author: _propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    user: _propTypes2.default.shape({
	      id: _propTypes2.default.number,
	      avatar: _propTypes2.default.objectOf(_propTypes2.default.string),
	      username: _propTypes2.default.string
	    }),
	    role: _propTypes2.default.string
	  }),
	  comments: _propTypes2.default.array,
	  createdAt: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
	  replyTo: _propTypes2.default.string,
	  onReply: _propTypes2.default.func,
	  getCommentDeleteHandler: _propTypes2.default.func,
	  getCommentEditHandler: _propTypes2.default.func,
	  updated: _propTypes2.default.bool,
	  deleted: _propTypes2.default.bool,
	  deletedBy: _propTypes2.default.string,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  parentId: _propTypes2.default.number,
	  onRequestConversation: _propTypes2.default.func,
	  loggedUserId: _propTypes2.default.number,
	  canComment: _propTypes2.default.bool,
	  isNewComment: _propTypes2.default.bool,
	  updateComment: _propTypes2.default.func.isRequired,
	  getMenuItems: _propTypes2.default.func.isRequired,
	  showCommentReport: _propTypes2.default.func
	}, _class3.defaultProps = {
	  isNewComment: false
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'toggleReplyForm', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleReplyForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addReply', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addReply'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onEdit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onEdit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRequestDelete', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRequestDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'closeConfirmPopup', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'closeConfirmPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRequestEdit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRequestEdit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRequestSendMessage', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRequestSendMessage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRequestReport', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRequestReport'), _class2.prototype)), _class2)) || _class) || _class) || _class) || _class);
	exports.default = Comment;

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(4931);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HorizontalCard = function HorizontalCard(_ref) {
	  var logo = _ref.logo,
	      name = _ref.name,
	      organization = _ref.organization,
	      totalPosts = _ref.totalPosts,
	      totalUsers = _ref.totalUsers,
	      onClick = _ref.onClick,
	      joinCommunity = _ref.joinCommunity,
	      buttonInfo = _ref.buttonInfo,
	      counter = _ref.counter;
	  return _react2.default.createElement(
	    'li',
	    { styleName: 'card' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'wrapper' },
	      _react2.default.createElement(
	        'div',
	        { role: 'presentation', styleName: 'avatar', onClick: onClick },
	        _react2.default.createElement(_Avatar2.default, {
	          children: name,
	          src: logo,
	          size: 100,
	          bordered: true,
	          position: 'center',
	          sizePercent: true,
	          rootStyle: {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            right: 0,
	            bottom: 0
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'content', onClick: onClick, role: 'presentation' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'title' },
	          name
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'subtitle', className: 'mb2' },
	          organization
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'subtitle' },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'icon-members',
	            height: '15%',
	            width: '4%',
	            className: 'mr1',
	            style: { minWidth: 12, minHeight: 12 }
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            totalUsers
	          ),
	          _react2.default.createElement(_Icon2.default, {
	            name: 'icon-posts',
	            height: '15%',
	            width: '4%',
	            className: 'mr1',
	            style: { minWidth: 12, minHeight: 12 }
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            totalPosts
	          )
	        )
	      ),
	      !!buttonInfo ? _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'primary',
	          disabled: buttonInfo.disabled,
	          className: 'w-35 flex-grow-1 flex-shrink-0',
	          onClick: joinCommunity
	        },
	        buttonInfo.buttonText
	      ) : null,
	      !!counter ? _react2.default.createElement(
	        'div',
	        { styleName: 'badge' },
	        _react2.default.createElement(
	          'span',
	          { styleName: 'badge-text' },
	          counter
	        )
	      ) : null
	    )
	  );
	};
	
	HorizontalCard.propTypes = {
	  logo: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  organization: _propTypes2.default.string,
	  totalPosts: _propTypes2.default.number,
	  totalUsers: _propTypes2.default.number,
	  onClick: _propTypes2.default.func.isRequired,
	  joinCommunity: _propTypes2.default.func,
	  buttonInfo: _propTypes2.default.object,
	  counter: _propTypes2.default.number
	};
	
	HorizontalCard.defaultProps = {
	  logo: '',
	  joinCommunity: null,
	  buttonInfo: null,
	  name: null,
	  totalUsers: null,
	  totalPosts: null,
	  organization: null,
	  counter: 0
	};
	
	exports.default = (0, _reactCssModules2.default)(HorizontalCard, _index2.default, { allowMultiple: true });

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _communityWallpaper = __webpack_require__(2286);
	
	var _communityWallpaper2 = _interopRequireDefault(_communityWallpaper);
	
	var _index = __webpack_require__(2243);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VerticalCard = function VerticalCard(_ref) {
	  var banner = _ref.banner,
	      logo = _ref.logo,
	      name = _ref.name,
	      organization = _ref.organization,
	      totalPosts = _ref.totalPosts,
	      totalUsers = _ref.totalUsers,
	      onClick = _ref.onClick,
	      joinCommunity = _ref.joinCommunity,
	      buttonInfo = _ref.buttonInfo;
	  return _react2.default.createElement(
	    'li',
	    { styleName: 'card' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'wrapper' },
	      _react2.default.createElement(
	        'div',
	        {
	          styleName: 'header',
	          onClick: onClick,
	          style: {
	            backgroundImage: 'url(' + (banner || _communityWallpaper2.default) + ')'
	          },
	          role: 'presentation'
	        },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'avatar' },
	          _react2.default.createElement(_Avatar2.default, {
	            children: name,
	            src: logo,
	            size: 100,
	            bordered: true,
	            position: 'center',
	            sizePercent: true,
	            noTransparent: true,
	            rootStyle: {
	              position: 'absolute',
	              top: 0,
	              left: 0,
	              right: 0,
	              bottom: 0
	            }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'content', onClick: onClick, role: 'presentation' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'title' },
	          name
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'subtitle' },
	          organization
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'footer' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'subtitle' },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'icon-members',
	            height: '7%',
	            width: '5%',
	            className: 'mr1',
	            style: { minWidth: 12, minHeight: 12 }
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'mr1' },
	            totalUsers
	          ),
	          _react2.default.createElement(_Icon2.default, {
	            name: 'icon-posts',
	            height: '5%',
	            width: '5%',
	            className: 'mr1',
	            style: { minWidth: 12, minHeight: 12 }
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            totalPosts
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'primary',
	            disabled: buttonInfo.disabled,
	            className: 'min-w-60 mt2',
	            raised: true,
	            onClick: joinCommunity
	          },
	          buttonInfo.buttonText
	        )
	      )
	    )
	  );
	};
	
	VerticalCard.propTypes = {
	  banner: _propTypes2.default.string,
	  logo: _propTypes2.default.string,
	  name: _propTypes2.default.string.isRequired,
	  organization: _propTypes2.default.string.isRequired,
	  totalPosts: _propTypes2.default.number.isRequired,
	  totalUsers: _propTypes2.default.number.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  joinCommunity: _propTypes2.default.func.isRequired,
	  buttonInfo: _propTypes2.default.object.isRequired
	};
	
	VerticalCard.defaultProps = {
	  banner: '',
	  logo: ''
	};
	
	exports.default = (0, _reactCssModules2.default)(VerticalCard, _index2.default, { allowMultiple: true });

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _MobileNavbar = __webpack_require__(256);
	
	var _MobileNavbar2 = _interopRequireDefault(_MobileNavbar);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _currentCommunity = __webpack_require__(301);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobileNavigation = function MobileNavigation(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      postId = _ref.params.postId,
	      currentCommunityInfo = _ref.currentCommunityInfo,
	      toggleContext = _ref.toggleContext,
	      showHeader = _ref.showHeader;
	
	  var communityTitle = (0, _get2.default)(currentCommunityInfo, 'name');
	  var communityUrl = (0, _get2.default)(currentCommunityInfo, 'logo[url]');
	  var postTitle = postId && formatMessage(_strings.POST_TITLE);
	
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { maxWidth: _styles.BREAKPOINT },
	    _react2.default.createElement(
	      _MobileNavbar2.default,
	      { openContext: 'arrow-down', toggleContext: toggleContext },
	      showHeader && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(_Avatar2.default, {
	          children: communityTitle,
	          src: communityUrl,
	          bordered: true,
	          position: 'center',
	          size: 30
	        }),
	        _react2.default.createElement('p', { className: 'ml2 f-14', children: postTitle || communityTitle })
	      )
	    )
	  );
	};
	
	MobileNavigation.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  params: _propTypes2.default.shape({
	    communityId: _propTypes2.default.string,
	    postId: _propTypes2.default.string
	  }).isRequired,
	  currentCommunityInfo: _propTypes2.default.object,
	  showHeader: _propTypes2.default.bool,
	  toggleContext: _propTypes2.default.func
	};
	
	MobileNavigation.defaultProps = {
	  currentCommunityInfo: null,
	  showHeader: false,
	  toggleContext: null
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentCommunityInfo: (0, _currentCommunity.currentCommunityInfoSelector)(state)
	  };
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(MobileNavigation)));

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReportInfo = exports.ReportInfoImpl = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _translationsByType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(4932);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _TimeShow = __webpack_require__(399);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var translationsByType = (_translationsByType = {}, (0, _defineProperty3.default)(_translationsByType, _constants.COMPLAINT_TYPE.COMMUNITY, 'reports.community.type'), (0, _defineProperty3.default)(_translationsByType, _constants.COMPLAINT_TYPE.COMMENT, 'reports.comment.type'), (0, _defineProperty3.default)(_translationsByType, _constants.COMPLAINT_TYPE.POST, 'reports.post.type'), _translationsByType);
	
	var translationsByStatus = {
	  unresolved: 'community.reports.unresolved',
	  resolved: 'community.reports.resolved'
	};
	
	var ReportInfoImpl = exports.ReportInfoImpl = function ReportInfoImpl(_ref) {
	  var formatMessage = _ref.formatMessage,
	      createdAt = _ref.createdAt,
	      status = _ref.status,
	      type = _ref.type,
	      reason = _ref.reason,
	      column = _ref.column,
	      showDangerTitle = _ref.showDangerTitle,
	      showTimerTitle = _ref.showTimerTitle;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: (0, _classnames2.default)('root', { 'root--column': column }) },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'item' },
	      showTimerTitle ? _react2.default.createElement(
	        'p',
	        null,
	        formatMessage({ id: 'reports.time' }),
	        ':'
	      ) : null,
	      _react2.default.createElement(_TimeShow.TimeShow, { timestamp: createdAt })
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'item' },
	      _react2.default.createElement(
	        'p',
	        null,
	        formatMessage({ id: 'reports.status' }),
	        ':'
	      ),
	      _react2.default.createElement(
	        'span',
	        { styleName: 'item-text' },
	        formatMessage({ id: translationsByStatus[status] })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'item' },
	      _react2.default.createElement(
	        'p',
	        null,
	        formatMessage({ id: 'reports.type' }),
	        ':'
	      ),
	      _react2.default.createElement(
	        'span',
	        { styleName: 'item-text' },
	        'to the ',
	        formatMessage({ id: translationsByType[type] })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'item' },
	      _react2.default.createElement(
	        'p',
	        null,
	        formatMessage({ id: 'reports.reason' }),
	        ':'
	      ),
	      _react2.default.createElement(
	        'span',
	        {
	          styleName: (0, _classnames2.default)('item-text', { 'item-text--danger': showDangerTitle })
	        },
	        reason.name
	      )
	    )
	  );
	};
	
	var ReportInfo = exports.ReportInfo = (0, _recompose.compose)((0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }))(ReportInfoImpl);
	
	var propTypes = {
	  formatMessage: _propTypes2.default.func.isRequired,
	  createdAt: _propTypes2.default.string,
	  status: _propTypes2.default.string.isRequired,
	  type: _propTypes2.default.string.isRequired,
	  reason: _propTypes2.default.object.isRequired,
	  column: _propTypes2.default.bool,
	  showDangerTitle: _propTypes2.default.bool,
	  showTimerTitle: _propTypes2.default.bool
	};
	
	ReportInfoImpl.defaultProps = {
	  column: false,
	  createdAt: '',
	  showDangerTitle: false,
	  showTimerTitle: false
	};
	
	ReportInfoImpl.propTypes = propTypes;
	ReportInfo.propTypes = propTypes;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _routes = __webpack_require__(37);
	
	var _chat = __webpack_require__(67);
	
	var _styles = __webpack_require__(18);
	
	var _ids = __webpack_require__(46);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(718);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ListItem(_ref) {
	  var item = _ref.item,
	      showMenu = _ref.showMenu,
	      loggedUserId = _ref.loggedUserId,
	      avatarSize = _ref.avatarSize,
	      _onClick = _ref.onClick,
	      type = _ref.type;
	  var id = item.id,
	      avatar = item.avatar,
	      providerRole = item.providerRole,
	      aliasName = item.aliasName,
	      blocked = item.blocked;
	
	  var _ref2 = avatar || {},
	      url = _ref2.url;
	
	  var redirectToProfile = function redirectToProfile() {
	    _reactRouter.browserHistory.push(_routes.PUBLIC_PROFILE + '/' + id);
	  };
	
	  var memberAvatar = _react2.default.createElement(_Avatar2.default, {
	    className: blocked ? 'o-50' : '',
	    children: aliasName,
	    size: avatarSize,
	    src: url
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'list-item' },
	    _react2.default.createElement(_Card2.default, {
	      userId: id,
	      className: 'fw6 pointer',
	      text: {
	        primary: aliasName,
	        complementary: providerRole
	      },
	      additionalContent: {
	        left: memberAvatar
	      },
	      additionalIcons: blocked ? [_chat.ICON_BLOCK] : null,
	      handleClick: redirectToProfile
	    }),
	    item.id !== loggedUserId && showMenu ? _react2.default.createElement(
	      'div',
	      {
	        styleName: 'list-item__icon',
	        onClick: function onClick(e) {
	          return _onClick(e, item, type);
	        },
	        id: _ids.IDS.COMMUNITY.MEMBER_MENU_TRIGGER
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'more', size: 12, style: { fill: _styles.COLORS.cloudyBlue } })
	    ) : null
	  );
	}
	
	ListItem.propTypes = {
	  showMenu: _propTypes2.default.bool,
	  item: _propTypes2.default.object.isRequired,
	  loggedUserId: _propTypes2.default.number.isRequired,
	  avatarSize: _propTypes2.default.number,
	  onClick: _propTypes2.default.func.isRequired,
	  type: _propTypes2.default.string.isRequired
	};
	
	ListItem.defaultProps = {
	  avatarSize: 24
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(ListItem);

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.moderatorsCountSelector = exports.membersCountSelector = exports.moderatorsListSelector = exports.membersListSelector = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var membersListSelector = exports.membersListSelector = function membersListSelector(state) {
	  return (0, _get2.default)(state, 'communities.membersList', []);
	};
	
	var moderatorsListSelector = exports.moderatorsListSelector = function moderatorsListSelector(state) {
	  return (0, _get2.default)(state, 'communities.moderatorsList', []);
	};
	
	var membersCountSelector = exports.membersCountSelector = function membersCountSelector(state) {
	  return (0, _get2.default)(state, 'communities.communityMembers.meta.membersCount', 0);
	};
	
	var moderatorsCountSelector = exports.moderatorsCountSelector = function moderatorsCountSelector(state) {
	  return (0, _get2.default)(state, 'communities.communityModerators.meta.moderatorsCount', 0);
	};

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(42);
	
	var _recompose = __webpack_require__(22);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Logo = __webpack_require__(3192);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Title = __webpack_require__(3200);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _NewPost = __webpack_require__(3197);
	
	var _NewPost2 = _interopRequireDefault(_NewPost);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _styles = __webpack_require__(18);
	
	var _currentCommunity = __webpack_require__(301);
	
	var _communityPreview = __webpack_require__(1266);
	
	var _selectors = __webpack_require__(93);
	
	var _sidebar = __webpack_require__(219);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Heading = function Heading(_ref) {
	  var clipped = _ref.clipped,
	      offset = _ref.offset,
	      params = _ref.params,
	      currentCommunityInfo = _ref.currentCommunityInfo,
	      toggleSidebarVisibility = _ref.toggleSidebarVisibility,
	      communityPreview = _ref.communityPreview,
	      isLoggedIn = _ref.isLoggedIn,
	      isModerator = _ref.isModerator,
	      updateImage = _ref.updateImage,
	      removeImage = _ref.removeImage,
	      formatMessage = _ref.intl.formatMessage;
	
	  var community = isLoggedIn ? currentCommunityInfo : communityPreview;
	
	  if (!community) return null;
	
	  var handleLogoCrop = (0, _react.useCallback)(function (data) {
	    updateImage({ logo: data });
	  }, []);
	  var handleImageRemove = (0, _react.useCallback)(function () {
	    removeImage({ data: { logo: true } });
	  }, []);
	
	  var logo = community.logo,
	      totalUsers = community.totalUsers,
	      name = community.name,
	      organization = community.organization,
	      type = community.type,
	      accessLevel = community.accessLevel,
	      totalPosts = community.totalPosts;
	
	
	  var getLogoSize = function getLogoSize() {
	    if (clipped) return 40;
	    if ((0, _mobileHelpers.isDesktop)()) return 120;
	    return 60;
	  };
	
	  var isCommunityPage = params.communityId && !params.postId;
	  var organizationName = (0, _get2.default)(organization, 'name');
	
	  return _react2.default.createElement(
	    'div',
	    {
	      styleName: (0, _classnames2.default)('heading', {
	        'heading--clipped': clipped,
	        'heading--offset': offset
	      })
	    },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'heading__image' },
	      _react2.default.createElement(
	        'div',
	        { className: 'flex items-center' },
	        _react2.default.createElement(_Logo2.default, {
	          size: getLogoSize(),
	          onImageRemove: handleImageRemove,
	          onImageCrop: handleLogoCrop,
	          isModerator: isModerator,
	          formatMessage: formatMessage,
	          image: logo,
	          offset: offset,
	          name: name
	        }),
	        !(0, _mobileHelpers.isDesktop)() && _react2.default.createElement(
	          'div',
	          { className: 'ml1' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'heading__image-title' },
	            name
	          ),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'heading__image-subtitle' },
	            organizationName
	          )
	        )
	      ),
	      !(0, _mobileHelpers.isDesktop)() && _react2.default.createElement(
	        _ClickableElement2.default,
	        { onClick: function onClick() {
	            return toggleSidebarVisibility();
	          } },
	        _react2.default.createElement(_Icon2.default, {
	          name: 'arrow-down',
	          width: 16,
	          height: 16,
	          style: {
	            fill: _styles.COLORS.white,
	            stroke: _styles.COLORS.white,
	            transform: 'rotate(-90deg)'
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'heading__content' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'heading__title' },
	        _react2.default.createElement(_Title2.default, {
	          totalUsers: totalUsers,
	          name: name,
	          organizationName: organizationName,
	          type: type,
	          accessLevel: accessLevel,
	          totalPosts: totalPosts
	        })
	      ),
	      isCommunityPage ? _react2.default.createElement(_NewPost2.default, {
	        community: community,
	        accessLevel: accessLevel,
	        isModerator: isModerator
	      }) : null
	    )
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	Heading.propTypes = {
	  clipped: _propTypes2.default.bool,
	  offset: _propTypes2.default.bool,
	  params: _propTypes2.default.shape({
	    communityId: _propTypes2.default.string,
	    postId: _propTypes2.default.string
	  }),
	  userCommunities: _propTypes2.default.shape({
	    list: _propTypes2.default.array
	  }),
	  currentCommunityInfo: _propTypes2.default.object,
	  toggleSidebarVisibility: _propTypes2.default.func,
	  communityPreview: _propTypes2.default.object,
	  isLoggedIn: _propTypes2.default.bool,
	  isModerator: _propTypes2.default.bool.isRequired,
	  intl: _propTypes2.default.object.isRequired,
	  updateImage: _propTypes2.default.func,
	  removeImage: _propTypes2.default.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentCommunityInfo: (0, _currentCommunity.currentCommunityInfoSelector)(state),
	    communityPreview: (0, _communityPreview.communityPreviewSelector)(state),
	    isLoggedIn: (0, _selectors.isLoggedInSelector)(state),
	    isModerator: (0, _currentCommunity.isCurrentCommunityModeratorSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  toggleSidebarVisibility: _sidebar.actions.toggleVisibility
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, _reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(Heading);

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(266);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _trim = __webpack_require__(988);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _isEqual = __webpack_require__(325);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _differenceBy = __webpack_require__(1554);
	
	var _differenceBy2 = _interopRequireDefault(_differenceBy);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _UrlInput = __webpack_require__(3195);
	
	var _UrlInput2 = _interopRequireDefault(_UrlInput);
	
	var _UrlPreview = __webpack_require__(1099);
	
	var _UrlPreview2 = _interopRequireDefault(_UrlPreview);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _SimpleImagePreview = __webpack_require__(1845);
	
	var _SimpleImagePreview2 = _interopRequireDefault(_SimpleImagePreview);
	
	var _FilePicker = __webpack_require__(762);
	
	var _FilePicker2 = _interopRequireDefault(_FilePicker);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _DiscardModal = __webpack_require__(1180);
	
	var _DiscardModal2 = _interopRequireDefault(_DiscardModal);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ContentArea = __webpack_require__(155);
	
	var _ContentArea2 = _interopRequireDefault(_ContentArea);
	
	var _Content = __webpack_require__(214);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Controls = __webpack_require__(333);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _ControlsItem = __webpack_require__(394);
	
	var _ControlsItem2 = _interopRequireDefault(_ControlsItem);
	
	var _preloaderImage = __webpack_require__(4227);
	
	var _sanitizeHtml = __webpack_require__(313);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _prettifyText = __webpack_require__(1932);
	
	var _prettifyText2 = _interopRequireDefault(_prettifyText);
	
	var _newPostForm = __webpack_require__(652);
	
	var _urlPreview = __webpack_require__(413);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _convertXMLtoString = __webpack_require__(1914);
	
	var _convertXMLtoString2 = _interopRequireDefault(_convertXMLtoString);
	
	var _chat = __webpack_require__(67);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _constants = __webpack_require__(17);
	
	var _index = __webpack_require__(719);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var POST_LIMIT_SIZE = 4000;
	var POST_IMAGE_LIMIT_MB = 10;
	var MAX_POST_IMAGES_NUMBER = 10;
	
	var READ_AND_POST_WITH_APPROVAL = _constants.COMMUNITIES_ACCESS_LEVELS.READ_AND_POST_WITH_APPROVAL;
	var allowedFormatError = _strings.COMMUNUNNITY_NEW_POST.allowedFormatError,
	    fileError = _strings.COMMUNUNNITY_NEW_POST.fileError,
	    maxAttachmentNumber = _strings.COMMUNUNNITY_NEW_POST.maxAttachmentNumber,
	    sendForApproval = _strings.COMMUNUNNITY_NEW_POST.sendForApproval,
	    addPost = _strings.COMMUNUNNITY_NEW_POST.addPost,
	    editPost = _strings.COMMUNUNNITY_NEW_POST.editPost,
	    caption = _strings.COMMUNUNNITY_NEW_POST.caption,
	    attachURL = _strings.COMMUNUNNITY_NEW_POST.attachURL,
	    addPhoto = _strings.COMMUNUNNITY_NEW_POST.addPhoto,
	    urlError = _strings.COMMUNUNNITY_NEW_POST.urlError;
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    form: state.communities.newPostForm,
	    urlPreviewRequest: state.common.urlPreview
	  };
	};
	
	var mapDispatchToProps = {
	  clearForm: _newPostForm.actions.clearForm,
	  updateForm: _newPostForm.actions.updateForm,
	  urlPreview: _urlPreview.actions.send,
	  clearUrlPreview: _urlPreview.actions.clear
	};
	
	var PostForm = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (0, _reactIntl.injectIntl)(_class = _dec2(_class = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(PostForm, _PureComponent);
	
	  function PostForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PostForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PostForm.__proto__ || (0, _getPrototypeOf2.default)(PostForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      attachUrl: false,
	      attachImage: false,
	      previewImage: null,
	      attachKind: null,
	      content: '',
	      fileError: false,
	      attachUrlLink: '',
	      files: [],
	      attachedFiles: [],
	      loading: false,
	      isDiscardModalOpened: false,
	      editedPostData: null
	    }, _this.submitPostWithApproval = function () {
	      _this.props.openNotification();
	      _this.props.onCancel();
	      _this.submitPost();
	      _this.props.clearForm();
	      _this.props.clearUrlPreview();
	    }, _this.handleAttachments = function (files) {
	      _this.setState({
	        loading: true,
	        fileError: false
	      });
	      _promise2.default.all(files.map(function (file) {
	        return _this.handleAttachmentPick(file);
	      })).then(function (result) {
	        _this.setState(function (prevState) {
	          return {
	            files: [].concat((0, _toConsumableArray3.default)(prevState.files), (0, _toConsumableArray3.default)(result)),
	            loading: false,
	            attachImage: true
	          };
	        });
	      }).catch(function (err) {
	        _this.setState({ loading: false });
	      });
	    }, _this.removeAttachedFile = function (file) {
	      var files = _this.state.files;
	
	      var filteredFiles = files.filter(function (item) {
	        return item !== file;
	      });
	      _this.setState({
	        files: filteredFiles,
	        attachImage: !!(0, _size2.default)(filteredFiles)
	      });
	    }, _this.getEmptyInputStatus = function (content) {
	      return !(0, _trim2.default)(content).length;
	    }, _this.getPostLengthError = function (content) {
	      return (0, _get2.default)(content, 'length') > POST_LIMIT_SIZE;
	    }, _this.getEmptyPostStatus = function (content, urlPreview, attachImage) {
	      return typeof content === 'string' && _this.getEmptyInputStatus(content) && !urlPreview && !attachImage;
	    }, _this.handleToggleDiscardModal = function () {
	      var isDiscardModalOpened = _this.state.isDiscardModalOpened;
	
	      _this.setState({ isDiscardModalOpened: !isDiscardModalOpened });
	    }, _this.handleCloseForm = function () {
	      var _this$state = _this.state,
	          editedPostData = _this$state.editedPostData,
	          content = _this$state.content,
	          files = _this$state.files,
	          urlPreview = _this$state.urlPreview,
	          attachImage = _this$state.attachImage;
	      var edit = _this.props.edit;
	
	      var isEmptyPost = _this.getEmptyPostStatus(content, urlPreview, attachImage);
	      if (edit) {
	        var currentData = {
	          content: content,
	          urlPreview: urlPreview,
	          files: files
	        };
	        if ((0, _isEqual2.default)(editedPostData, currentData)) {
	          return _this.cancel();
	        }
	        return _this.handleToggleDiscardModal();
	      }
	      return isEmptyPost ? _this.cancel() : _this.handleToggleDiscardModal();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PostForm, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        intl: this.props.intl
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var edit = this.props.edit;
	
	      var existingAttachments = (0, _get2.default)(this.props.form, 'attachment.files', []);
	      var attachedContent = (0, _get2.default)(this.props.form, 'content');
	      var content = attachedContent && (0, _prettifyText2.default)(attachedContent);
	      var urlPreview = this.props.urlPreviewRequest.succeed ? this.props.urlPreviewRequest : (0, _get2.default)(this.props.form, 'attachment.urlPreview');
	
	      if (content || !!(0, _size2.default)(existingAttachments) || urlPreview) {
	        var postFiles = existingAttachments.map(function (item) {
	          return (0, _extends3.default)({}, item, {
	            type: 'ATTACHMENT'
	          });
	        });
	        var data = {
	          content: content && (0, _convertXMLtoString2.default)(content),
	          attachImage: !!(0, _size2.default)(existingAttachments),
	          files: [].concat((0, _toConsumableArray3.default)(postFiles)),
	          urlPreview: urlPreview || null,
	          attachedFiles: [].concat((0, _toConsumableArray3.default)(postFiles)),
	          attachUrl: !!urlPreview,
	          editedPostData: edit && {
	            content: content && (0, _convertXMLtoString2.default)(content),
	            urlPreview: urlPreview || null,
	            files: [].concat((0, _toConsumableArray3.default)(postFiles))
	          }
	        };
	        this.setState((0, _extends3.default)({}, data));
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.urlPreviewRequest.succeed && nextProps.urlPreviewRequest.succeed) {
	        this.setState({
	          urlPreview: nextProps.urlPreviewRequest
	        });
	      }
	    }
	  }, {
	    key: 'attachUrl',
	    value: function attachUrl() {
	      this.setState({
	        attachUrl: true,
	        attachKind: 'link'
	      });
	    }
	  }, {
	    key: 'arrayToFormData',
	    value: function arrayToFormData(arr, formData) {
	      arr.forEach(function (object) {
	        formData.append('attachment_attributes[files][]', object);
	      });
	    }
	  }, {
	    key: 'filterByType',
	    value: function filterByType(type) {
	      var files = this.state.files;
	
	      return files.filter(function (file) {
	        return file.type === type;
	      });
	    }
	  }, {
	    key: 'submitPost',
	    value: function submitPost() {
	      var attachment = this.props.attachment;
	      var _state = this.state,
	          rawContent = _state.content,
	          urlPreview = _state.urlPreview,
	          attachedFiles = _state.attachedFiles,
	          attachImage = _state.attachImage;
	
	      var content = (0, _sanitizeHtml2.default)(rawContent.trim(), true, []);
	      var post = new FormData();
	
	      var uploadedFiles = this.filterByType('UPLOAD_TYPE').map(function (file) {
	        return file.attachImage;
	      });
	      var existedFiles = this.filterByType('ATTACHMENT');
	
	      if (urlPreview) {
	        post.append('attachment_attributes[url_preview][title]', urlPreview.title);
	        post.append('attachment_attributes[url_preview][description]', urlPreview.description);
	        post.append('attachment_attributes[url_preview][preview]', urlPreview.preview);
	        post.append('attachment_attributes[url_preview][url]', urlPreview.url);
	
	        urlPreview.video = urlPreview.video && urlPreview.video.includes('?autoplay=1') ? urlPreview.video.slice(0, urlPreview.video.indexOf('?autoplay=1')) : urlPreview.video;
	
	        urlPreview.video && post.append('attachment_attributes[url_preview][video]', urlPreview.video);
	      }
	
	      if ((0, _size2.default)(uploadedFiles)) {
	        this.arrayToFormData(uploadedFiles, post);
	      }
	
	      if (content) {
	        post.append('content', content);
	      }
	
	      if (attachment && attachment.id) {
	        post.append('attachment_attributes[id]', attachment.id);
	        if (!urlPreview && !attachImage) {
	          post.append('attachment_attributes[_destroy]', true);
	        }
	        (0, _differenceBy2.default)(attachedFiles, existedFiles, 'index').forEach(function (object) {
	          post.append('attachment_attributes[removed_files_indexes][]', object.index);
	        });
	      }
	
	      this.props.onSubmit(post);
	      this.props.updateForm({
	        content: content
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.props.onCancel();
	      this.props.clearForm();
	      this.props.clearUrlPreview();
	    }
	  }, {
	    key: 'handleErrors',
	    value: function handleErrors(errorKeys) {
	      var formatMessage = this.props.intl.formatMessage;
	
	      var errorReasons = (0, _get2.default)(errorKeys, 'errors');
	      var errorText = [];
	      if (errorReasons.includes(_chat.NEW_MESSAGE_ERRORS.ATTACHMENT_NOT_ALLOWED_FORMAT)) {
	        errorText.push(formatMessage(allowedFormatError));
	      }
	      if (errorReasons.includes(_chat.NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_SIZE)) {
	        errorText.push(formatMessage(fileError, {
	          size: POST_IMAGE_LIMIT_MB
	        }));
	      }
	      if (errorReasons.includes(_chat.NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_NUMBER)) {
	        errorText.push(formatMessage(maxAttachmentNumber));
	      }
	      this.setState({
	        fileError: true,
	        filesErrorText: errorText
	      });
	    }
	  }, {
	    key: 'cancelPreview',
	    value: function cancelPreview() {
	      this.setState({ attachUrl: false, urlPreview: null });
	      this.props.clearUrlPreview();
	    }
	  }, {
	    key: 'handleAttachmentPick',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(file) {
	        var url, postFile;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _preloaderImage.preloaderImage)(file);
	
	              case 2:
	                url = _context.sent;
	                postFile = {
	                  previewImage: url,
	                  attachImage: file,
	                  fileError: false,
	                  type: 'UPLOAD_TYPE'
	                };
	                return _context.abrupt('return', postFile);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function handleAttachmentPick(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return handleAttachmentPick;
	    }()
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          formatMessage = _props.intl.formatMessage,
	          error = _props.error,
	          submitting = _props.submitting,
	          edit = _props.edit,
	          urlPreviewRequest = _props.urlPreviewRequest,
	          isModalOpen = _props.isModalOpen,
	          modalTitle = _props.modalTitle,
	          discardModalTitle = _props.discardModalTitle,
	          discardBtnText = _props.discardBtnText,
	          accessLevel = _props.accessLevel,
	          isNotificationOpen = _props.isNotificationOpen,
	          closeNotification = _props.closeNotification,
	          isModerator = _props.isModerator;
	      var _state2 = this.state,
	          attachUrl = _state2.attachUrl,
	          attachImage = _state2.attachImage,
	          value = _state2.content,
	          fileError = _state2.fileError,
	          urlPreview = _state2.urlPreview,
	          files = _state2.files,
	          loading = _state2.loading,
	          filesErrorText = _state2.filesErrorText,
	          isDiscardModalOpened = _state2.isDiscardModalOpened;
	
	      var isEmptyInput = this.getEmptyInputStatus(value);
	      var isPostLengthError = this.getPostLengthError(value);
	      var isEmptyPost = this.getEmptyPostStatus(value, urlPreview, attachImage);
	      var isFilesLengthError = (0, _size2.default)(files) > MAX_POST_IMAGES_NUMBER;
	      var disabled = isEmptyPost || isFilesLengthError || isPostLengthError;
	      var isErrored = error || fileError || isFilesLengthError;
	      var errorMessage = fileError ? filesErrorText.map(function (err) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          err
	        );
	      }) : formatMessage(maxAttachmentNumber);
	      var needsApproval = !isModerator && accessLevel === READ_AND_POST_WITH_APPROVAL;
	      var sendPost = needsApproval ? sendForApproval : addPost;
	      var submitBtnText = edit ? editPost : sendPost;
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _Popup2.default,
	          {
	            title: modalTitle,
	            strictClose: true,
	            width: (0, _mobileHelpers.isDesktop)() ? 'postCommunity' : 'medium',
	            mobileFullScreen: true,
	            onClose: this.handleCloseForm,
	            opened: isModalOpen
	          },
	          _react2.default.createElement(
	            _ContentArea2.default,
	            null,
	            submitting ? _react2.default.createElement(_Loader2.default, null) : [_react2.default.createElement(
	              _Content2.default,
	              {
	                fullHeight: true,
	                empty: false,
	                style: { maxHeight: 'calc(100% - 50px)', flexGrow: 'unset' },
	                key: '0'
	              },
	              _react2.default.createElement(
	                'div',
	                { styleName: 'post-form' },
	                _react2.default.createElement(
	                  'div',
	                  { styleName: 'input-wrapper', className: 'mt1 pb1 pl1 pr2' },
	                  _react2.default.createElement(_TextInput2.default, {
	                    autoresize: true,
	                    autoFocus: true,
	                    textarea: true,
	                    className: 'ma1',
	                    rows: '4',
	                    color: 'primary',
	                    label: formatMessage(caption),
	                    inputHeight: 22,
	                    style: {
	                      lineHeight: '21px',
	                      maxHeight: '210px',
	                      backgroundColor: 'white',
	                      borderRadius: '2px 2px 0 0',
	                      border: 'none'
	                    },
	                    wrapperStyle: { margin: 0 },
	                    value: value,
	                    onChange: function onChange(content) {
	                      return _this2.setState({ content: content });
	                    },
	                    useNumberHeight: true
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { styleName: 'post-attachments' },
	                    !attachUrl && !urlPreview && !attachImage && !loading ? _react2.default.createElement(
	                      'div',
	                      {
	                        styleName: 'attach-item',
	                        className: 'pa2',
	                        onClick: this.attachUrl
	                      },
	                      _react2.default.createElement(_Icon2.default, {
	                        name: 'link',
	                        className: 'mr2',
	                        style: { fill: _styles.COLORS.bluePrimary }
	                      }),
	                      _react2.default.createElement(_reactIntl.FormattedMessage, attachURL)
	                    ) : null,
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        styleName: (0, _classnames2.default)('info', {
	                          'info--errored': isPostLengthError
	                        })
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        {
	                          styleName: isEmptyInput ? 'info--disabled' : null
	                        },
	                        '' + (0, _size2.default)(value),
	                        '/'
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        {
	                          styleName: !isPostLengthError ? 'info--disabled' : null
	                        },
	                        POST_LIMIT_SIZE
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'mt3 flex flex-wrap' },
	                    (0, _size2.default)(files) ? files.map(function (file, i) {
	                      return _react2.default.createElement(_SimpleImagePreview2.default, {
	                        key: (file.previewImage || file.url) + i,
	                        src: file.previewImage || file.url,
	                        onCancel: function onCancel() {
	                          return _this2.removeAttachedFile(file);
	                        },
	                        small: true,
	                        showCloseBtn: true
	                      });
	                    }) : null,
	                    loading ? _react2.default.createElement(_Loader2.default, null) : null,
	                    !loading && (0, _size2.default)(files) < MAX_POST_IMAGES_NUMBER && !attachUrl ? _react2.default.createElement(
	                      'div',
	                      { styleName: 'attach-image' },
	                      _react2.default.createElement(
	                        _FilePicker2.default,
	                        {
	                          maxSize: POST_IMAGE_LIMIT_MB,
	                          allowedFormats: _constants.IMAGE_ALLOWED_FORMATS,
	                          inputFileLabel: 'post-image-attachment',
	                          onError: this.handleErrors,
	                          onFilePick: this.handleAttachments,
	                          multiple: true
	                        },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'flex flex-column items-center' },
	                          _react2.default.createElement(_Icon2.default, {
	                            name: 'icon-plus',
	                            className: 'mr2 mb2',
	                            style: { fill: _styles.COLORS.blueGray },
	                            size: 24
	                          }),
	                          _react2.default.createElement(_reactIntl.FormattedMessage, addPhoto)
	                        )
	                      )
	                    ) : null
	                  ),
	                  attachUrl || urlPreview ? [attachUrl && !urlPreview ? [_react2.default.createElement(_UrlInput2.default, {
	                    onCancel: this.cancelPreview,
	                    onUrl: function onUrl(url) {
	                      return _this2.props.urlPreview({ url: url });
	                    },
	                    formatMessage: formatMessage,
	                    key: '0-0'
	                  }), urlPreviewRequest.sending ? _react2.default.createElement(_Loader2.default, {
	                    key: '0-1'
	                  }) : null, urlPreviewRequest.rejected ? _react2.default.createElement(_ErrorBlock2.default, {
	                    className: 'mt3',
	                    errors: formatMessage(urlError),
	                    key: '0-2'
	                  }) : null] : null, urlPreview ? _react2.default.createElement(_UrlPreview2.default, (0, _extends3.default)({
	                    className: 'mt2'
	                  }, urlPreview, {
	                    onCancel: this.cancelPreview,
	                    key: '1'
	                  })) : null] : null,
	                  needsApproval ? _react2.default.createElement(
	                    'div',
	                    { styleName: 'approvalText' },
	                    formatMessage({
	                      id: 'community.newPost.needsApproval'
	                    })
	                  ) : null
	                ),
	                isErrored ? _react2.default.createElement(_ErrorBlock2.default, {
	                  className: 'mt3',
	                  errors: error || errorMessage
	                }) : null
	              )
	            ), _react2.default.createElement(
	              _Controls2.default,
	              {
	                key: '1'
	              },
	              _react2.default.createElement(
	                _ControlsItem2.default,
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mt3' },
	                  _react2.default.createElement(
	                    _Button2.default,
	                    {
	                      color: 'primary',
	                      raised: true,
	                      type: 'button',
	                      className: 'mr3',
	                      onClick: needsApproval ? this.submitPostWithApproval : this.submitPost,
	                      disabled: disabled
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, submitBtnText)
	                  ),
	                  _react2.default.createElement(
	                    _Button2.default,
	                    {
	                      color: 'accent',
	                      raised: true,
	                      type: 'button',
	                      onClick: this.handleCloseForm
	                    },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.cancel)
	                  )
	                )
	              )
	            )]
	          )
	        ),
	        _react2.default.createElement(_DiscardModal2.default, {
	          title: discardModalTitle,
	          isOpened: isDiscardModalOpened,
	          onSubmit: this.cancel,
	          submitText: discardBtnText,
	          cancelText: formatMessage({ id: 'common.goBack' }),
	          onCancel: this.handleToggleDiscardModal
	        }),
	        _react2.default.createElement(
	          _Popup2.default,
	          {
	            opened: isNotificationOpen,
	            withHeading: false,
	            width: 'rubber',
	            mobileFullScreen: false
	          },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'notification' },
	            _react2.default.createElement(
	              'p',
	              null,
	              formatMessage({ id: 'community.newPost.notification' })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { color: 'primary', type: 'button', onClick: closeNotification },
	              formatMessage({ id: 'common.ok' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return PostForm;
	}(_react.PureComponent), _class3.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  onCancel: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  urlPreview: _propTypes2.default.func,
	  clearUrlPreview: _propTypes2.default.func,
	  form: _propTypes2.default.shape({
	    content: _propTypes2.default.string
	  }),
	  clearForm: _propTypes2.default.func,
	  updateForm: _propTypes2.default.func,
	  error: _propTypes2.default.string,
	  submitting: _propTypes2.default.bool,
	  urlPreviewRequest: _propTypes2.default.shape({
	    description: _propTypes2.default.string,
	    url: _propTypes2.default.string,
	    preview: _propTypes2.default.string,
	    video: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    sending: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }),
	  edit: _propTypes2.default.bool,
	  attachment: _propTypes2.default.shape({
	    id: _propTypes2.default.number
	  }),
	  isModalOpen: _propTypes2.default.bool,
	  modalTitle: _propTypes2.default.string,
	  discardModalTitle: _propTypes2.default.string,
	  discardBtnText: _propTypes2.default.string,
	  accessLevel: _propTypes2.default.string,
	  isNotificationOpen: _propTypes2.default.bool,
	  openNotification: _propTypes2.default.func,
	  closeNotification: _propTypes2.default.func,
	  isModerator: _propTypes2.default.bool
	}, _class3.childContextTypes = {
	  intl: _propTypes2.default.object
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'attachUrl', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'attachUrl'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submitPost', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submitPost'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancel', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleErrors', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleErrors'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancelPreview', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancelPreview'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleAttachmentPick', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleAttachmentPick'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = PostForm;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNan = __webpack_require__(1396);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(58);
	
	var _updateCurrentCommunity = __webpack_require__(1265);
	
	var _updateCurrentCommunity2 = _interopRequireDefault(_updateCurrentCommunity);
	
	var _routes = __webpack_require__(37);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _injectSaga = __webpack_require__(116);
	
	var _strings = __webpack_require__(15);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _styles = __webpack_require__(18);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Drawer = __webpack_require__(253);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _About = __webpack_require__(3183);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _SectionTitle = __webpack_require__(1100);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _enhance = __webpack_require__(3201);
	
	var _Banner = __webpack_require__(3185);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Heading = __webpack_require__(1734);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Posts = __webpack_require__(3199);
	
	var _Posts2 = _interopRequireDefault(_Posts);
	
	var _NewPostsBtn = __webpack_require__(3198);
	
	var _NewPostsBtn2 = _interopRequireDefault(_NewPostsBtn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Community = function Community(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      postsList = _ref.postsList,
	      visible = _ref.isDrawerVisible.visible,
	      community = _ref.community,
	      communityLoading = _ref.communityLoading,
	      fetchCommunity = _ref.fetchCommunity,
	      fetchPosts = _ref.fetchPosts,
	      resetCommunity = _ref.resetCommunity,
	      updateImage = _ref.updateImage,
	      removeImage = _ref.removeImage,
	      imageProcessing = _ref.imageProcessing,
	      fetchMorePosts = _ref.fetchMorePosts,
	      setScrollStatus = _ref.setScrollStatus,
	      communityId = _ref.communityId,
	      shouldLoadMore = _ref.shouldLoadMore,
	      isModerator = _ref.isModerator,
	      parentRef = _ref.parentRef,
	      temporaryPostList = _ref.temporaryPostList,
	      addPostsList = _ref.addPostsList,
	      resetScrollStatus = _ref.resetScrollStatus;
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'updateCurrentCommunity',
	    saga: _updateCurrentCommunity2.default,
	    mode: _sagaInjectors.RESTART_ON_REMOUNT
	  });
	
	  var currentUserRole = community.currentUserRole,
	      banner = community.banner,
	      error = community.error,
	      type = community.type,
	      name = community.name;
	
	
	  var rootRef = (0, _react.useRef)();
	
	  var _useDrawer = useDrawer(visible),
	      _useDrawer2 = (0, _slicedToArray3.default)(_useDrawer, 2),
	      isMobileDrawerOpen = _useDrawer2[0],
	      showDrawer = _useDrawer2[1];
	
	  var loadMore = (0, _react.useCallback)(function () {
	    return shouldLoadMore && fetchMorePosts();
	  }, [shouldLoadMore]);
	  var handleBannerCrop = (0, _react.useCallback)(function (data) {
	    updateImage({ banner: data });
	  }, []);
	  var handleBannerRemove = (0, _react.useCallback)(function () {
	    removeImage({ data: { banner: true } });
	  }, []);
	  var drawerClassNames = isMobileDrawerOpen ? 'absolute absolute--fill bg-washed-blue pt3 overflow-y' : '';
	
	  useNotFoundRedirect(communityId);
	  useErrorHandling(error);
	  (0, _useLazyLoad.useLazyLoad)({ node: rootRef, path: ['parentNode'], loadMore: loadMore });
	  (0, _react.useEffect)(function () {
	    fetchCommunity();
	    fetchPosts();
	
	    return function () {
	      resetCommunity();
	    };
	  }, []);
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      scrollTop = _useState2[0],
	      setScrollTop = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      checkScroll = _useState4[0],
	      setScrollChecker = _useState4[1];
	
	  var hasNewPosts = (0, _lodash.size)(temporaryPostList);
	
	  (0, _react.useEffect)(function () {
	    if (currentUserRole) {
	      var handleScroll = (0, _lodash.debounce)(function () {
	        setScrollTop(parentRef.scrollTop);
	      }, 20);
	      if (parentRef) {
	        parentRef.addEventListener('scroll', handleScroll);
	
	        return function () {
	          parentRef.removeEventListener('scroll', handleScroll);
	          resetScrollStatus();
	        };
	      }
	    }
	  }, [parentRef, currentUserRole]);
	
	  (0, _react.useEffect)(function () {
	    if (currentUserRole) {
	      if (scrollTop > 300 && checkScroll) {
	        setScrollChecker(false);
	        setScrollStatus({ scrolled: true });
	      } else if (scrollTop < 300) {
	        setScrollChecker(true);
	        setScrollStatus({ scrolled: false });
	        if (hasNewPosts) {
	          addPostsList(temporaryPostList);
	          resetScrollStatus();
	        }
	      }
	    }
	  }, [scrollTop, temporaryPostList]);
	
	  var handleScrollTop = function handleScrollTop() {
	    parentRef.scrollTo({
	      top: 0,
	      behavior: 'smooth'
	    });
	  };
	
	  if (communityLoading) {
	    return _react2.default.createElement(_Loader2.default, null);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', ref: rootRef },
	    hasNewPosts ? _react2.default.createElement(_NewPostsBtn2.default, {
	      title: formatMessage(_strings.COMMUNITIES_COMMON.seeNewPosts),
	      handleClick: function handleClick() {
	        return handleScrollTop();
	      }
	    }) : null,
	    _react2.default.createElement(_Banner2.default, {
	      onImageRemove: handleBannerRemove,
	      onImageCrop: handleBannerCrop,
	      isModerator: isModerator,
	      image: banner
	    }),
	    imageProcessing && _react2.default.createElement(_Loader2.default, { styleName: 'imageProcessing' }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'wrapper' },
	      !communityLoading ? _react2.default.createElement(_Heading2.default, {
	        offset: (0, _mobileHelpers.isDesktop)(),
	        updateImage: updateImage,
	        removeImage: removeImage
	      }) : _react2.default.createElement(_Loader2.default, null),
	      !communityLoading ? _react2.default.createElement(
	        'div',
	        { styleName: 'content' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'posts' },
	          _react2.default.createElement(_Posts2.default, {
	            isModerator: isModerator,
	            list: postsList,
	            communityId: communityId,
	            currentUserRole: currentUserRole,
	            type: type,
	            communityName: name
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'sidebar' },
	          showDrawer ? _react2.default.createElement(
	            _Drawer2.default,
	            {
	              opened: showDrawer,
	              position: 'right',
	              style: {
	                background: !isMobileDrawerOpen && 'transparent',
	                color: _styles.COLORS.grayDark,
	                float: 'none',
	                minHeight: 200,
	                boxShadow: 'none',
	                zIndex: 100
	              },
	              className: drawerClassNames,
	              width: 300,
	              scrollable: false
	            },
	            _react2.default.createElement(
	              'div',
	              { styleName: isMobileDrawerOpen && 'sidebar__content' },
	              _react2.default.createElement(_SectionTitle2.default, {
	                text: formatMessage(_strings.COMMUNITY_DESCRIPTION)
	              }),
	              _react2.default.createElement(_About2.default, { community: community })
	            )
	          ) : null
	        )
	      ) : _react2.default.createElement(_Loader2.default, null)
	    )
	  );
	};
	
	Community.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  postsList: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  isDrawerVisible: _propTypes2.default.object.isRequired,
	  community: _propTypes2.default.object.isRequired,
	  communityLoading: _propTypes2.default.bool.isRequired,
	  shouldLoadMore: _propTypes2.default.bool.isRequired,
	  fetchCommunity: _propTypes2.default.func.isRequired,
	  fetchPosts: _propTypes2.default.func.isRequired,
	  resetCommunity: _propTypes2.default.func.isRequired,
	  fetchMorePosts: _propTypes2.default.func.isRequired,
	  updateImage: _propTypes2.default.func.isRequired,
	  removeImage: _propTypes2.default.func.isRequired,
	  communityId: _propTypes2.default.number.isRequired,
	  imageProcessing: _propTypes2.default.bool.isRequired,
	  isModerator: _propTypes2.default.bool.isRequired,
	  parentRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({ current: _propTypes2.default.instanceOf(Element) })]),
	  setScrollStatus: _propTypes2.default.func,
	  temporaryPostList: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  resetScrollStatus: _propTypes2.default.func,
	  addPostsList: _propTypes2.default.func
	};
	
	Community.defaultProps = {
	  parentRef: null,
	  temporaryPostList: [],
	  addPostsList: null,
	  resetScrollStatus: null,
	  setScrollStatus: null
	};
	
	exports.default = (0, _enhance.enhance)(Community);
	
	/** C U S T O M   H O O K S */
	
	function useErrorHandling(error) {
	  (0, _react.useEffect)(function () {
	    if (!error) {
	      return;
	    }
	
	    switch (error.status) {
	      case 404:
	        return _reactRouter.browserHistory.push(_routes.NOT_FOUND);
	      case 403:
	        return _reactRouter.browserHistory.push(_routes.ACCESS_DENIED_COMMUNITIES);
	    }
	  }, [error]);
	}
	
	function useNotFoundRedirect(communityId) {
	  (0, _react.useEffect)(function () {
	    if ((0, _isNan2.default)(communityId)) {
	      _reactRouter.browserHistory.push(_routes.NOT_FOUND);
	    }
	  }, [communityId]);
	}
	
	function useDrawer(visible) {
	  return (0, _react.useMemo)(function () {
	    var isMobileOpen = !(0, _mobileHelpers.isDesktop)() && visible;
	    var showDrawer = (0, _mobileHelpers.isDesktop)() || isMobileOpen;
	
	    return [isMobileOpen, showDrawer];
	  }, [visible]);
	}

/***/ }),
/* 1737 */,
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVisitFormOptions = getVisitFormOptions;
	exports.getSelectableList = getSelectableList;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getVisitFormOptions(list) {
	  var valueKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
	  var labelKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
	
	  return list.map(function (item) {
	    return {
	      label: (0, _get2.default)(item, labelKey),
	      value: (0, _get2.default)(item, valueKey)
	    };
	  });
	}
	
	function getSelectableList(list, id, key) {
	  var selectedItem = list.find(function (item) {
	    return item.id === id;
	  });
	  return (0, _get2.default)(selectedItem, key, []);
	}

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isArray = __webpack_require__(96);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _index = __webpack_require__(4945);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Hint = __webpack_require__(3854);
	
	var _Hint2 = _interopRequireDefault(_Hint);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultDescriptionRenderer = function defaultDescriptionRenderer(description) {
	  return (0, _isArray2.default)(description) ? description.join(', ') : description;
	}; /* eslint-disable react/require-default-props */
	
	
	var DefinitionList = function DefinitionList(_ref) {
	  var className = _ref.className,
	      definition = _ref.definition,
	      description = _ref.description,
	      hideEllipsis = _ref.hideEllipsis,
	      multiline = _ref.multiline,
	      hintText = _ref.hintText,
	      _ref$descriptionRende = _ref.descriptionRenderer,
	      descriptionRenderer = _ref$descriptionRende === undefined ? defaultDescriptionRenderer : _ref$descriptionRende,
	      hasOpacity = _ref.hasOpacity,
	      formatMessage = _ref.formatMessage;
	  return _react2.default.createElement(
	    'dl',
	    (0, _extends3.default)({ className: className }, {
	      styleName: (0, _classnames2.default)('root', {
	        'root--multiline': multiline,
	        hideEllipsis: hideEllipsis
	      })
	    }),
	    _react2.default.createElement('dt', {
	      children: _react2.default.createElement(
	        'div',
	        null,
	        definition,
	        ' ',
	        hintText && _react2.default.createElement(_Hint2.default, { hintText: hintText })
	      ),
	      styleName: 'definition'
	    }),
	    _react2.default.createElement('dd', {
	      children: descriptionRenderer(description, formatMessage),
	      styleName: 'description'
	    })
	  );
	};
	
	DefinitionList.propTypes = {
	  className: _propTypes2.default.string,
	  definition: _propTypes2.default.string,
	  hintText: _propTypes2.default.string,
	  description: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.arrayOf(_propTypes2.default.object), _propTypes2.default.string, _propTypes2.default.object]),
	  multiline: _propTypes2.default.bool,
	  descriptionRenderer: _propTypes2.default.func,
	  hasOpacity: _propTypes2.default.bool,
	  hideEllipsis: _propTypes2.default.bool,
	  formatMessage: _propTypes2.default.func
	};
	
	DefinitionList.defaultProps = { multiline: false, hasOpacity: true };
	
	exports.default = (0, _reactCssModules2.default)(DefinitionList, _index2.default, { allowMultiple: true });

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _selectors = __webpack_require__(50);
	
	var _routes = __webpack_require__(37);
	
	var _ids = __webpack_require__(46);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppNotificationsBtn = function AppNotificationsBtn(_ref) {
	  var isProvider = _ref.isProvider;
	
	  var count = (0, _reactRedux.useSelector)(_selectors.selectPendingDependentAssignmentsCounter);
	
	  if (!isProvider) return null;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'item' },
	    _react2.default.createElement(
	      _Link2.default,
	      {
	        id: _ids.IDS.NAV_BAR.APP_NOTIFICATIONS_LINK,
	        to: _routes.APP_NOTIFICATIONS,
	        className: 'ph3',
	        styleName: 'link'
	      },
	      _react2.default.createElement(
	        'div',
	        { styleName: (0, _classnames2.default)({ 'unread-icon': count > 0 }) },
	        _react2.default.createElement(_Icon2.default, { name: 'notification-ring', size: 36 })
	      )
	    )
	  );
	};
	
	AppNotificationsBtn.propTypes = {
	  isProvider: PropTypes.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(AppNotificationsBtn, _index2.default, {
	  allowMultiple: true
	});

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(42);
	
	var _addPatientByProvider = __webpack_require__(308);
	
	var _routes = __webpack_require__(37);
	
	var _selectors = __webpack_require__(23);
	
	var _strings = __webpack_require__(15);
	
	var _ids = __webpack_require__(46);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _constants = __webpack_require__(17);
	
	var _progress = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = {
	  clearRequest: _addPatientByProvider.actions.clear,
	  setDependentSubmitRedirect: _progress.dependentFormActions.setSubmitRedirect
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoggedTeam: (0, _selectors.selectIsLoggedTeam)(state)
	  };
	};
	
	var AssignMenuList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(AssignMenuList, _Component);
	
	  function AssignMenuList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AssignMenuList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AssignMenuList.__proto__ || (0, _getPrototypeOf2.default)(AssignMenuList)).call.apply(_ref, [this].concat(args))), _this), _this.handleOpenAddPatient = function () {
	      _reactRouter.browserHistory.push('/' + _routes.PATIENT_REGISTRATION);
	      _this.props.selectItem();
	      _this.props.clearRequest();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AssignMenuList, [{
	    key: 'handleDependentRedirect',
	    value: function handleDependentRedirect() {
	      this.props.setDependentSubmitRedirect(_constants.DEPENDENT_FORM_SUBMIT_REDIRECT.PROFILE);
	      _reactRouter.browserHistory.push(_routes.DEPENDENT_FORM);
	      this.props.selectItem();
	    }
	  }, {
	    key: 'getMenuItems',
	    value: function getMenuItems() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isProvider = _props.isProvider,
	          formatMessage = _props.intl.formatMessage,
	          isLoggedTeam = _props.isLoggedTeam;
	
	
	      var menuItems = [];
	
	      var createDependentItem = {
	        text: formatMessage(_strings.DIALOG_TITLE.addDependent),
	        id: _ids.IDS.NAV_BAR.ADD_DEPENDENT_MENU_ITEM,
	        onClick: function onClick() {
	          return _this2.handleDependentRedirect();
	        }
	      };
	
	      var providerItems = [{
	        text: formatMessage(_strings.DIALOG_TITLE.addPatient),
	        id: _ids.IDS.NAV_BAR.ADD_PATIENT_MENU_ITEM,
	        onClick: function onClick() {
	          return _this2.handleOpenAddPatient();
	        }
	      }];
	
	      if (isProvider) {
	        menuItems = providerItems;
	      }
	
	      if (!isLoggedTeam) {
	        menuItems.push(createDependentItem);
	      }
	
	      return menuItems;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderItems = this.props.renderItems;
	
	
	      var items = this.getMenuItems();
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        renderItems(items)
	      );
	    }
	  }]);
	  return AssignMenuList;
	}(_react.Component), _class2.propTypes = {
	  isProvider: _propTypes2.default.bool,
	  renderItems: _propTypes2.default.func,
	  selectItem: _propTypes2.default.func
	}, _class2.defaultProps = {
	  renderItems: function renderItems() {},
	  selectItem: function selectItem() {}
	}, _temp2)) || _class) || _class) || _class);
	exports.default = AssignMenuList;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppointmentTabs = __webpack_require__(1744);
	
	var _AppointmentTabs2 = _interopRequireDefault(_AppointmentTabs);
	
	var _enhance = __webpack_require__(3296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _enhance.enhance)(_AppointmentTabs2.default);

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _EmptyBlock = __webpack_require__(1745);
	
	var _EmptyBlock2 = _interopRequireDefault(_EmptyBlock);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SurveysPopup = __webpack_require__(1806);
	
	var _SurveysPopup2 = _interopRequireDefault(_SurveysPopup);
	
	var _AppointmentCard = __webpack_require__(3304);
	
	var _AppointmentCard2 = _interopRequireDefault(_AppointmentCard);
	
	var _constants = __webpack_require__(17);
	
	var _AppointmentDetailsPopup = __webpack_require__(490);
	
	var _AppointmentDetailsPopup2 = _interopRequireDefault(_AppointmentDetailsPopup);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _selectors = __webpack_require__(64);
	
	var _styles = __webpack_require__(4965);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentList(_ref) {
	  var id = _ref.id,
	      list = _ref.list,
	      onClick = _ref.onClick,
	      loading = _ref.loading,
	      isUpcoming = _ref.isUpcoming,
	      providerView = _ref.providerView,
	      providerContext = _ref.providerContext,
	      paginationSending = _ref.paginationSending,
	      formatMessage = _ref.intl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var listSelector = providerView ? _selectors.selectProviderActiveAppointment : _selectors.selectActiveAppointment;
	
	  var selected = (0, _reactRedux.useSelector)(listSelector);
	
	  var surveys = (0, _reactRedux.useSelector)(_selectors.selectCurrentAppointmentSurveys);
	
	  var translationKey = (0, _react.useMemo)(function () {
	    return isUpcoming ? 'upcomingAppointmentsEmpty' : 'historyAppointmentsEmpty';
	  }, [isUpcoming]);
	
	  var emptyTextI18n = (0, _react.useMemo)(function () {
	    if (providerContext && providerView) {
	      return 'forProvider';
	    }
	
	    if (providerContext) {
	      return 'forProviderInContext';
	    }
	
	    return 'forPatient';
	  }, [providerView, providerContext]);
	
	  var handleAppointmentSelect = function handleAppointmentSelect(item) {
	    dispatch(_appointmentDetails.appointmentDetailsActions.setAppointmentId(item.id));
	    onClick(item);
	  };
	
	  var handleStartVideoVisit = function handleStartVideoVisit(appointment) {
	    dispatch(_appointmentDetails.appointmentDetailsActions.changeStatus({
	      event: _constants.VIRTUAL_VISIT_EVENTS.START_VISIT,
	      appointment: appointment,
	      id: id
	    }));
	  };
	
	  var closeModal = function closeModal() {
	    dispatch(_appointmentDetails.appointmentDetailsActions.setAppointmentId(undefined));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)('mt3', _styles2.default.root, (0, _defineProperty3.default)({}, _styles2.default.noMargin, providerView))
	    },
	    loading && _react2.default.createElement(_Loader2.default, null),
	    paginationSending && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.paginationLoader },
	      _react2.default.createElement(_Loader2.default, null)
	    ),
	    !loading && list.map(function (item) {
	      return _react2.default.createElement(_AppointmentCard2.default, {
	        providerContext: providerContext,
	        providerView: providerView,
	        onStartVideoVisit: function onStartVideoVisit() {
	          return handleStartVideoVisit(item);
	        },
	        onClick: function onClick() {
	          return handleAppointmentSelect(item);
	        },
	        formatMessage: formatMessage,
	        isUpcoming: isUpcoming,
	        key: item.id,
	        data: item
	      });
	    }),
	    !loading && !list.length && _react2.default.createElement(_EmptyBlock2.default, {
	      icon: 'search-list',
	      title: formatMessage({ id: 'healthboard.title.' + translationKey }),
	      text: formatMessage({ id: 'healthboard.empty.' + emptyTextI18n })
	    }),
	    _react2.default.createElement(_AppointmentDetailsPopup2.default, {
	      onStartVideoVisit: handleStartVideoVisit,
	      providerContext: providerContext,
	      providerView: providerView,
	      isUpcoming: isUpcoming,
	      opened: !!selected,
	      appointment: selected,
	      onClose: closeModal,
	      userId: id
	    }),
	    !!surveys.length && _react2.default.createElement(_SurveysPopup2.default, { surveys: surveys })
	  );
	}
	
	AppointmentList.propTypes = {
	  list: PropTypes.array,
	  providerContext: PropTypes.bool,
	  providerView: PropTypes.bool,
	  isUpcoming: PropTypes.bool,
	  loading: PropTypes.bool,
	  onClick: PropTypes.func,
	  intl: PropTypes.object,
	  paginationSending: PropTypes.bool,
	  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	};
	
	AppointmentList.defaultProps = {
	  list: [],
	  onClick: function onClick() {}
	};
	
	exports.default = (0, _reactIntl.injectIntl)(AppointmentList);

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _routes = __webpack_require__(37);
	
	var _constants = __webpack_require__(17);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _CommonTabs = __webpack_require__(255);
	
	var _ids = __webpack_require__(46);
	
	var _AppointmentFilter = __webpack_require__(3313);
	
	var _ScheduleButton = __webpack_require__(3331);
	
	var _ScheduleButton2 = _interopRequireDefault(_ScheduleButton);
	
	var _AppointmentList = __webpack_require__(1743);
	
	var _AppointmentList2 = _interopRequireDefault(_AppointmentList);
	
	var _ListWrapper = __webpack_require__(1750);
	
	var _ListWrapper2 = _interopRequireDefault(_ListWrapper);
	
	var _styles = __webpack_require__(4966);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB_KEYS = {
	  UPCOMING: 'upcoming',
	  HISTORY: 'history'
	};
	
	function AppointmentTabs(_ref) {
	  var fetchUpcomingList = _ref.fetchUpcomingList,
	      loadMoreUpcomingList = _ref.loadMoreUpcomingList,
	      fetchHistoryList = _ref.fetchHistoryList,
	      loadMoreHistoryList = _ref.loadMoreHistoryList,
	      upcomingList = _ref.upcomingList,
	      upcomingCount = _ref.upcomingCount,
	      upcomingLoading = _ref.upcomingLoading,
	      historyLoading = _ref.historyLoading,
	      historyList = _ref.historyList,
	      historyCount = _ref.historyCount,
	      renderTabHeader = _ref.renderTabHeader,
	      providerContext = _ref.providerContext,
	      providerView = _ref.providerView,
	      formatMessage = _ref.intl.formatMessage,
	      providerContextHistory = _ref.providerContextHistory,
	      setAppointmentFiltersOption = _ref.setAppointmentFiltersOption,
	      isFilterByTypeVisit = _ref.isFilterByTypeVisit,
	      isFilterToday = _ref.isFilterToday,
	      paginationSending = _ref.paginationSending,
	      id = _ref.id;
	
	  var _useState = (0, _react.useState)(TAB_KEYS.UPCOMING),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  (0, _usePageView.usePageView)('Home | Appointment List');
	
	  var todayDate = (0, _moment2.default)().format('YYYY-MM-DD');
	
	  var tabs = useTabs(upcomingCount, historyCount);
	  var rootRef = (0, _react.useRef)();
	  var loadMore = (0, _react.useCallback)(function () {
	    if (paginationSending) return;
	    if (activeTab === TAB_KEYS.UPCOMING) loadMoreUpcomingList((0, _extends3.default)({
	      id: id
	    }, isFilterToday && { date: todayDate }, isFilterByTypeVisit && {
	      visit_type_code: _constants.VIRTUAL_VISIT_TYPE_CODE
	    }));
	    if (activeTab === TAB_KEYS.HISTORY) loadMoreHistoryList({ id: id });
	  }, [activeTab, id, isFilterToday, isFilterByTypeVisit, paginationSending]);
	  var isActiveTabUpcoming = activeTab === TAB_KEYS.UPCOMING;
	
	  var mainTitle = formatMessage({
	    id: 'healthboard.appointments.' + (isActiveTabUpcoming ? TAB_KEYS.UPCOMING : TAB_KEYS.HISTORY)
	  });
	
	  var actionText = isActiveTabUpcoming ? formatMessage({ id: 'healthboard.action.seeCompleted' }) : '';
	
	  (0, _useLazyLoad.useLazyLoad)({ node: rootRef, loadMore: loadMore, path: [] });
	  (0, _react.useEffect)(function () {
	    if (!providerContextHistory) fetchUpcomingList((0, _extends3.default)({
	      limit: 10,
	      offset: 0
	    }, isFilterToday && { date: todayDate }, isFilterByTypeVisit && {
	      visit_type_code: _constants.VIRTUAL_VISIT_TYPE_CODE
	    }, {
	      id: id
	    }));
	    if (providerContextHistory || !providerView) fetchHistoryList({ limit: 10, offset: 0, id: id });
	  }, [id, providerContextHistory, isFilterToday, isFilterByTypeVisit, providerView]);
	
	  (0, _react.useEffect)(function () {
	    if (providerContextHistory) {
	      setActiveTab(TAB_KEYS.HISTORY);
	    }
	  }, [providerContextHistory]);
	
	  var getContentData = function getContentData(tab) {
	    switch (tab) {
	      case TAB_KEYS.UPCOMING:
	        return {
	          list: upcomingList,
	          loading: upcomingLoading,
	          paginationSending: paginationSending,
	          providerContext: providerContext,
	          providerView: providerView,
	          id: id,
	          isUpcoming: true
	        };
	      case TAB_KEYS.HISTORY:
	        return {
	          list: historyList,
	          loading: historyLoading,
	          paginationSending: paginationSending,
	          providerContext: providerContext,
	          providerView: providerView,
	          id: id,
	          isUpcoming: false
	        };
	      default:
	        return { list: [], loading: false };
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (setAppointmentFiltersOption) setAppointmentFiltersOption({
	      isFilterToday: true,
	      isFilterByTypeVisit: false
	    });
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', ref: rootRef },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.homeAppointments' }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'content' },
	      providerView || providerContextHistory ? _react2.default.createElement(
	        _ListWrapper2.default,
	        {
	          title: mainTitle,
	          counter: isActiveTabUpcoming ? upcomingCount : historyCount,
	          actionText: actionText,
	          renderHeaderButton: function renderHeaderButton() {
	            return _react2.default.createElement(_ScheduleButton2.default, { userId: id });
	          },
	          redirectTo: _routes.HEALTHBOARD + '/' + id + '/' + _routes.HEALTHBOARD_APPOINTMENTS_HISTORY
	        },
	        isActiveTabUpcoming && _react2.default.createElement(_AppointmentFilter.AppointmentFilter, {
	          formatMessage: formatMessage,
	          isFilterByTypeVisit: isFilterByTypeVisit,
	          isFilterToday: isFilterToday,
	          setAppointmentFiltersOption: setAppointmentFiltersOption
	        }),
	        _react2.default.createElement(_AppointmentList2.default, getContentData(isActiveTabUpcoming ? TAB_KEYS.UPCOMING : TAB_KEYS.HISTORY))
	      ) : _react2.default.createElement(_CommonTabs.CommonTabs, {
	        onTabSelect: setActiveTab,
	        activeTab: activeTab,
	        tabList: tabs,
	        renderHeader: renderTabHeader,
	        renderContent: function renderContent(tab) {
	          return _react2.default.createElement(_AppointmentList2.default, getContentData(tab));
	        }
	      })
	    )
	  );
	}
	
	AppointmentTabs.propTypes = {
	  fetchUpcomingList: PropTypes.func,
	  loadMoreUpcomingList: PropTypes.func,
	  fetchHistoryList: PropTypes.func,
	  loadMoreHistoryList: PropTypes.func,
	  upcomingList: PropTypes.array,
	  upcomingCount: PropTypes.number,
	  upcomingLoading: PropTypes.bool,
	  historyLoading: PropTypes.bool,
	  historyList: PropTypes.array,
	  historyCount: PropTypes.number,
	  renderTabHeader: PropTypes.func,
	  providerContext: PropTypes.bool,
	  providerView: PropTypes.bool,
	  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  providerContextHistory: PropTypes.bool,
	  intl: PropTypes.object,
	  setAppointmentFiltersOption: PropTypes.func,
	  isFilterByTypeVisit: PropTypes.bool,
	  isFilterToday: PropTypes.bool,
	  paginationSending: PropTypes.bool
	};
	
	AppointmentTabs.defaultProps = {
	  providerContext: false,
	  providerView: false
	};
	
	exports.default = (0, _reactCssModules2.default)(AppointmentTabs, _styles2.default, { allowMultiple: true });
	
	
	function useTabs(upcomingCounter, completedCounter) {
	  return (0, _react.useMemo)(function () {
	    return [{
	      label: 'appointment.list.tabs.upcoming',
	      tab: TAB_KEYS.UPCOMING,
	      id: _ids.IDS.APPOINTMENT_LIST.TAB_UPCOMING,
	      counter: upcomingCounter
	    }, {
	      label: 'appointment.list.tabs.history',
	      tab: TAB_KEYS.HISTORY,
	      id: _ids.IDS.APPOINTMENT_LIST.TAB_HISTORY,
	      counter: completedCounter
	    }];
	  }, [upcomingCounter, completedCounter]);
	}

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Title = __webpack_require__(1105);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(4968);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmptyBlock(_ref) {
	  var title = _ref.title,
	      text = _ref.text,
	      icon = _ref.icon,
	      size = _ref.size,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', className: className },
	    _react2.default.createElement(_Icon2.default, { name: icon, size: size, className: 'flex-shrink-0' }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'content' },
	      _react2.default.createElement(_Title2.default, {
	        text: title,
	        styleName: 'title',
	        className: 'f-12 g-color--accent'
	      }),
	      _react2.default.createElement(
	        'p',
	        { styleName: 'text' },
	        text
	      )
	    )
	  );
	}
	
	EmptyBlock.propTypes = {
	  title: PropTypes.string,
	  text: PropTypes.string,
	  icon: PropTypes.string,
	  size: PropTypes.number,
	  className: PropTypes.string
	};
	
	EmptyBlock.defaultProps = {
	  size: 60
	};
	
	exports.default = (0, _reactCssModules2.default)(EmptyBlock, _index2.default, { allowMultiple: true });

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _index = __webpack_require__(4971);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DescriptionSection = function DescriptionSection(_ref) {
	  var description = _ref.description,
	      links = _ref.links;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.section },
	    _react2.default.createElement(
	      'p',
	      { className: 'mb2' },
	      description
	    ),
	    !(0, _isEmpty2.default)(links) ? links.map(function (link) {
	      return _react2.default.createElement(
	        'a',
	        {
	          href: (0, _get2.default)(link, 'urlLink'),
	          target: '_blank',
	          rel: 'noopener noreferrer',
	          className: _index2.default.link,
	          key: (0, _get2.default)(link, 'id')
	        },
	        (0, _get2.default)(link, 'urlDescription')
	      );
	    }) : null
	  );
	};
	
	DescriptionSection.propTypes = {
	  description: _propTypes2.default.string,
	  links: _propTypes2.default.array
	};
	
	exports.default = DescriptionSection;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _InfoCardPopup = __webpack_require__(1764);
	
	var _InfoCardPopup2 = _interopRequireDefault(_InfoCardPopup);
	
	var _handleTaskTime = __webpack_require__(608);
	
	var _getToDoAssigmentText = __webpack_require__(1386);
	
	var _getToDoAssigmentText2 = _interopRequireDefault(_getToDoAssigmentText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopupWrapper = function PopupWrapper(_ref) {
	  var children = _ref.children,
	      handleClose = _ref.handleClose,
	      task = _ref.task,
	      taskId = _ref.taskId,
	      title = _ref.title,
	      rest = (0, _objectWithoutProperties3.default)(_ref, ['children', 'handleClose', 'task', 'taskId', 'title']);
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _ref2 = task || {},
	      todoTask = _ref2.todoTask,
	      completedTime = _ref2.completedTime,
	      expiredTime = _ref2.expiredTime;
	
	  var _ref3 = todoTask || {},
	      name = _ref3.name,
	      dueDescription = _ref3.dueDescription;
	
	  var headerInfo = (0, _handleTaskTime.timeToShow)(completedTime, expiredTime, dueDescription, formatMessage);
	
	  return _react2.default.createElement(
	    _InfoCardPopup2.default,
	    (0, _extends3.default)({
	      title: title,
	      onClose: handleClose,
	      icon: 'assigned-task',
	      headerTitle: name,
	      headerInfo: headerInfo,
	      headerSubtitle: (0, _getToDoAssigmentText2.default)(task, formatMessage),
	      isOpened: Boolean(taskId),
	      style: { zIndex: 1000 }
	    }, rest),
	    children
	  );
	};
	
	PopupWrapper.propTypes = {
	  children: _propTypes2.default.node,
	  handleClose: _propTypes2.default.func,
	  task: _propTypes2.default.object,
	  taskId: _propTypes2.default.number,
	  title: _propTypes2.default.string
	};
	
	exports.default = PopupWrapper;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _common = __webpack_require__(864);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var useFetchToDoTaskInsurancesData = function useFetchToDoTaskInsurancesData(_ref) {
	  var hasAdditionalPatientInsurances = _ref.hasAdditionalPatientInsurances,
	      todoTaskAssignmentId = _ref.todoTaskAssignmentId,
	      userId = _ref.userId,
	      isCompleted = _ref.isCompleted;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var isInsuranceRelatedDataFetching = (0, _reactRedux.useSelector)(_common.selectInsuranceRelatedDataFetching);
	
	  (0, _react.useEffect)(function () {
	    dispatch(_manageInsurancesActions.manageInsurancesActions.downloadToDoTaskInsurancesData({
	      hasAdditionalPatientInsurances: hasAdditionalPatientInsurances,
	      todoTaskAssignmentId: todoTaskAssignmentId,
	      userId: userId,
	      isCompleted: isCompleted
	    }));
	  }, [userId, todoTaskAssignmentId, hasAdditionalPatientInsurances]);
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      dispatch(_manageInsurancesActions.manageInsurancesActions.clearManageInsuranceRelatedData());
	    };
	  }, []);
	
	  return { isInsuranceRelatedDataFetching: isInsuranceRelatedDataFetching };
	};
	
	exports.default = useFetchToDoTaskInsurancesData;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(17);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _utils = __webpack_require__(254);
	
	var _styles = __webpack_require__(4973);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRole() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      type = _ref.type,
	      careRole = _ref.careRole;
	
	  var formatMessage = arguments[1];
	
	  switch (type) {
	    case _constants.INVITATION_TYPES.FAMILY_MEMBER:
	      return formatMessage({ id: 'circles.roles.family_member' });
	    case _constants.INVITATION_TYPES.CAREGIVER:
	      return formatMessage({ id: 'circles.roles.caregiver' });
	    case _constants.INVITATION_TYPES.GUARDIAN_PROXY:
	      {
	        var i18n = careRole ? 'circles.roles.' + careRole : 'circles.roles.guardianProxyShort';
	
	        return formatMessage({ id: i18n });
	      }
	    default:
	      return '';
	  }
	}
	
	function InvitationListItem(_ref2) {
	  var invitation = _ref2.invitation,
	      formatMessage = _ref2.formatMessage,
	      onClick = _ref2.onClick,
	      className = _ref2.className;
	
	  var name = (0, _utils.getFullName)((0, _get2.default)(invitation, 'targetUser'));
	  var avatar = (0, _get2.default)(invitation, 'targetUser.avatar.thumbMin');
	  var role = getRole(invitation, formatMessage);
	
	  var subTitle = (0, _react.useMemo)(function () {
	    return formatMessage({ id: 'healthboard.invitations.card.subTtitle' }, { role: role, name: name });
	  }, [role, name]);
	
	  var title = (0, _react.useMemo)(function () {
	    return formatMessage({ id: 'healthboard.invitations.card.title' }, { name: name });
	  }, [name]);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', className: className, onClick: onClick },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'left' },
	      _react2.default.createElement(_SimpleAvatar2.default, { src: avatar, text: name, size: 36, bordered: true })
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'right' },
	      _react2.default.createElement(
	        'p',
	        { styleName: 'meta' },
	        subTitle
	      ),
	      _react2.default.createElement(
	        'p',
	        { styleName: 'strong' },
	        title
	      )
	    )
	  );
	}
	
	InvitationListItem.propTypes = {
	  invitation: PropTypes.object,
	  formatMessage: PropTypes.func,
	  className: PropTypes.string,
	  onClick: PropTypes.func
	};
	
	exports.default = (0, _reactCssModules2.default)(InvitationListItem, _styles2.default, { allowMultiple: true });

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _isNull = __webpack_require__(732);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _index = __webpack_require__(4974);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ListWrapper(_ref) {
	  var title = _ref.title,
	      counter = _ref.counter,
	      onClick = _ref.onClick,
	      children = _ref.children,
	      actionText = _ref.actionText,
	      buttonText = _ref.buttonText,
	      redirectTo = _ref.redirectTo,
	      renderHeaderButton = _ref.renderHeaderButton,
	      onClickButton = _ref.onClickButton,
	      additionalAction = _ref.additionalAction,
	      renderAdditionalButton = _ref.renderAdditionalButton;
	
	  var counterText = !(0, _isNull2.default)(counter) ? '(' + counter + ')' : '';
	  var handleClick = function handleClick() {
	    additionalAction();
	    _browserHistory2.default.push(redirectTo);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'header' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'title' },
	        _react2.default.createElement(
	          'h3',
	          { styleName: 'text' },
	          title + ' ' + counterText
	        ),
	        onClickButton ? _react2.default.createElement(
	          _Link2.default,
	          { to: redirectTo, onClick: onClickButton, styleName: 'link' },
	          actionText
	        ) : _react2.default.createElement(
	          'div',
	          { onClick: handleClick, styleName: 'link' },
	          actionText
	        )
	      ),
	      Boolean(buttonText) ? _react2.default.createElement(
	        _Button2.default,
	        { raised: true, color: 'primary', onClick: onClick },
	        buttonText
	      ) : null,
	      Boolean(renderHeaderButton) && !buttonText ? renderHeaderButton() : null
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'content' },
	      children
	    )
	  );
	}
	
	ListWrapper.defaultProps = {
	  additionalAction: function additionalAction() {}
	};
	
	ListWrapper.propTypes = {
	  title: PropTypes.string,
	  counter: PropTypes.number,
	  onClick: PropTypes.func,
	  children: PropTypes.node,
	  redirectTo: PropTypes.string,
	  actionText: PropTypes.string,
	  buttonText: PropTypes.string,
	  additionalAction: PropTypes.func,
	  onClickButton: PropTypes.func,
	  renderHeaderButton: PropTypes.func,
	  renderAdditionalButton: PropTypes.node
	};
	
	exports.default = (0, _reactCssModules2.default)(ListWrapper, _index2.default, { allowMultiple: true });

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.PaymentAmountField = PaymentAmountField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _editPaymentReq = __webpack_require__(349);
	
	var _selectors = __webpack_require__(23);
	
	var _AmountInput = __webpack_require__(1179);
	
	var _AmountInput2 = _interopRequireDefault(_AmountInput);
	
	var _EditBtn = __webpack_require__(393);
	
	var _EditBtn2 = _interopRequireDefault(_EditBtn);
	
	var _TransactionInfo = __webpack_require__(1123);
	
	var _TransactionInfo2 = _interopRequireDefault(_TransactionInfo);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _usePaymentAmountData2 = __webpack_require__(3328);
	
	var _field = __webpack_require__(3327);
	
	var _index = __webpack_require__(4979);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PaymentAmountField(_ref) {
	  var formatMessage = _ref.formatMessage,
	      value = _ref.value,
	      isPaid = _ref.isPaid,
	      isUpcoming = _ref.isUpcoming,
	      appointmentId = _ref.appointmentId,
	      _ref$onlyEditMode = _ref.onlyEditMode,
	      onlyEditMode = _ref$onlyEditMode === undefined ? false : _ref$onlyEditMode,
	      onClose = _ref.onClose,
	      appointment = _ref.appointment;
	
	  var titleAmount = formatMessage({
	    id: 'appointment.details.paymentAmount.title'
	  });
	
	  var labelPaymentAmount = formatMessage({
	    id: 'virtualVisit.details.paymentAmount'
	  });
	
	  var canEditCopay = (0, _get2.default)(appointment, 'canEditCopay', false);
	
	  var loggedUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _usePaymentAmountData = (0, _usePaymentAmountData2.usePaymentAmountData)(formatMessage, value, appointmentId),
	      editMode = _usePaymentAmountData.editMode,
	      errorState = _usePaymentAmountData.errorState,
	      handleCopayChange = _usePaymentAmountData.handleCopayChange,
	      handleToInitialState = _usePaymentAmountData.handleToInitialState,
	      handleToggleEditState = _usePaymentAmountData.handleToggleEditState,
	      safeValue = _usePaymentAmountData.safeValue,
	      isPristine = _usePaymentAmountData.isPristine,
	      currentValue = _usePaymentAmountData.currentValue;
	
	  var handleSubmit = function handleSubmit() {
	    dispatch(_editPaymentReq.actions.send({
	      userId: loggedUserId,
	      appointmentId: appointmentId,
	      copay: currentValue
	    }));
	    handleToInitialState();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    !onlyEditMode && _react2.default.createElement(
	      'div',
	      { className: _index2.default.paymentTitleWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.paymentTitle },
	        titleAmount
	      ),
	      !isPaid && isUpcoming && canEditCopay && _react2.default.createElement(
	        'div',
	        { className: _index2.default.paymentEditButton },
	        _react2.default.createElement(_EditBtn2.default, { onClick: handleToggleEditState })
	      ),
	      isPaid && _react2.default.createElement(
	        'div',
	        { className: _index2.default.paymentInfo },
	        _react2.default.createElement(_TransactionInfo2.default, {
	          appointment: appointment,
	          formatMessage: formatMessage
	        })
	      )
	    ),
	    editMode || onlyEditMode ? _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_AmountInput2.default, (0, _extends3.default)({}, (0, _field.amountFieldProps)(formatMessage), {
	        name: 'paymentAmountInput',
	        value: safeValue,
	        onChange: handleCopayChange,
	        label: onlyEditMode && labelPaymentAmount
	      })),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)(_index2.default.paymentButton, (0, _defineProperty3.default)({}, _index2.default.paymentButtonInDashboard, onlyEditMode)),
	          raised: true,
	          color: 'primary',
	          onClick: handleSubmit,
	          disabled: errorState || isPristine
	        },
	        formatMessage({ id: 'common.save' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)(_index2.default.paymentButton, (0, _defineProperty3.default)({}, _index2.default.paymentButtonInDashboard, onlyEditMode)),
	          raised: true,
	          color: 'accent',
	          onClick: onClose || handleToInitialState
	        },
	        formatMessage({ id: 'common.cancel' })
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { className: _index2.default.paymentAmountInput },
	      safeValue
	    )
	  );
	}
	
	PaymentAmountField.propTypes = {
	  formatMessage: PropTypes.func,
	  value: PropTypes.number,
	  isPaid: PropTypes.bool,
	  isUpcoming: PropTypes.bool,
	  appointmentId: PropTypes.number,
	  onlyEditMode: PropTypes.bool,
	  onClose: PropTypes.func,
	  appointment: PropTypes.object
	};

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TASK_DOCUMENTATION_E;
	
	exports.TaskDocuments = TaskDocuments;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _cuid = __webpack_require__(936);
	
	var _cuid2 = _interopRequireDefault(_cuid);
	
	var _constants = __webpack_require__(17);
	
	var _DocumentView = __webpack_require__(3851);
	
	var _UploadDocument = __webpack_require__(1756);
	
	var _chat = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TASK_DOCUMENTATION_ERRORS = (_TASK_DOCUMENTATION_E = {}, (0, _defineProperty3.default)(_TASK_DOCUMENTATION_E, _chat.NEW_MESSAGE_ERRORS.ATTACHMENT_NOT_ALLOWED_FORMAT, 'task.error.acceptedFileType'), (0, _defineProperty3.default)(_TASK_DOCUMENTATION_E, _chat.NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_SIZE, 'task.error.acceptedFileSize'), _TASK_DOCUMENTATION_E);
	
	function TaskDocuments(_ref) {
	  var disabled = _ref.disabled,
	      completed = _ref.completed,
	      attachments = _ref.attachments,
	      addAttachment = _ref.addAttachment,
	      formatMessage = _ref.formatMessage;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      error = _useState2[0],
	      setError = _useState2[1];
	
	  var handleFileAdd = function handleFileAdd(data) {
	    var fileError = (0, _get2.default)(data, 'fileError');
	    if (fileError) {
	      var errors = (0, _get2.default)(data, 'errors');
	      setError(TASK_DOCUMENTATION_ERRORS[errors[0]]);
	    } else {
	      var file = (0, _get2.default)(data, 'file');
	      if (file) {
	        setError(null);
	        var id = (0, _cuid2.default)();
	        var addedFile = (0, _extends3.default)({}, data, { id: id });
	        addAttachment([].concat((0, _toConsumableArray3.default)(attachments), [addedFile]));
	      }
	    }
	  };
	
	  var handleFileDelete = function handleFileDelete(fileId) {
	    setError(null);
	    var filtered = attachments.filter(function (_ref2) {
	      var id = _ref2.id;
	      return id !== fileId;
	    });
	    addAttachment(filtered);
	  };
	
	  var handleOpenDocument = function handleOpenDocument(fileUrl) {
	    window.open(fileUrl);
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    !completed ? [_react2.default.createElement(_UploadDocument.UploadDocument, {
	      iconSize: 20,
	      setAttachment: handleFileAdd,
	      handleAddDocument: function handleAddDocument() {},
	      titleAddButton: formatMessage({
	        id: 'appointment.documents.addDocument.title'
	      }),
	      allowedFormats: _constants.TASK_DOCUMENTS_FORMATS,
	      textStyle: 'f-14 o-100 mb0',
	      disabled: disabled,
	      maxSize: _constants.MAX_TASK_ATTACHMENT_SIZE_ALLOWED,
	      validFileExtensions: _constants.TASK_FILE_EXTENSIONS,
	      key: '0'
	    }), _react2.default.createElement(
	      'div',
	      { className: 'f-12 o-70 mb3', key: '1'
	      },
	      formatMessage({ id: 'task.acceptedFileTypes' })
	    ), error && _react2.default.createElement(
	      'div',
	      { className: 'g-color--error mb3' },
	      formatMessage({ id: error })
	    )] : null,
	    attachments && attachments.map(function (item) {
	      var _ref3 = item || {},
	          file = _ref3.file,
	          id = _ref3.id,
	          name = _ref3.name,
	          link = _ref3.link;
	
	      var fileName = (0, _get2.default)(file, 'name');
	      return _react2.default.createElement(_DocumentView.DocumentView, {
	        key: id || link,
	        className: 'f-14',
	        accent: completed,
	        pointer: completed,
	        showButton: !completed,
	        title: completed ? name : fileName,
	        onDelete: function onDelete() {
	          return handleFileDelete(id);
	        },
	        onClick: function onClick() {
	          return completed ? handleOpenDocument(link) : {};
	        }
	      });
	    })
	  );
	}
	
	TaskDocuments.propTypes = {
	  completed: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  attachments: _propTypes2.default.array,
	  addAttachment: _propTypes2.default.func,
	  formatMessage: _propTypes2.default.func
	};

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(64);
	
	var _activeTodo = __webpack_require__(843);
	
	var _SequentialSurveyPopup = __webpack_require__(780);
	
	var _SequentialSurveyPopup2 = _interopRequireDefault(_SequentialSurveyPopup);
	
	var _CompletedConsentPopup = __webpack_require__(3314);
	
	var _CompletedConsentPopup2 = _interopRequireDefault(_CompletedConsentPopup);
	
	var _ProgramDetailsPopup = __webpack_require__(3329);
	
	var _ProgramDetailsPopup2 = _interopRequireDefault(_ProgramDetailsPopup);
	
	var _CarePlanDetailsPopup = __webpack_require__(3107);
	
	var _CarePlanDetailsPopup2 = _interopRequireDefault(_CarePlanDetailsPopup);
	
	var _InvitationDetailsPopup = __webpack_require__(3322);
	
	var _InvitationDetailsPopup2 = _interopRequireDefault(_InvitationDetailsPopup);
	
	var _InsuranceToDoTaskPopup = __webpack_require__(3320);
	
	var _InsuranceToDoTaskPopup2 = _interopRequireDefault(_InsuranceToDoTaskPopup);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _useTodoRender = __webpack_require__(3335);
	
	var _TaskDetailsPopup = __webpack_require__(3333);
	
	var _TaskDetailsPopup2 = _interopRequireDefault(_TaskDetailsPopup);
	
	var _constants = __webpack_require__(17);
	
	var _enhance = __webpack_require__(3334);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ElectronicConsentPopup = __webpack_require__(3317);
	
	var _ElectronicConsentPopup2 = _interopRequireDefault(_ElectronicConsentPopup);
	
	var _CompletedElectronicConsentPopup = __webpack_require__(3315);
	
	var _CompletedElectronicConsentPopup2 = _interopRequireDefault(_CompletedElectronicConsentPopup);
	
	var _utils = __webpack_require__(254);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TodoList(_ref) {
	  var list = _ref.list,
	      loading = _ref.loading,
	      isUpcoming = _ref.isUpcoming,
	      targetUser = _ref.targetUser,
	      surveyProceeding = _ref.surveyProceeding,
	      formatMessage = _ref.intl.formatMessage;
	
	  var activeItem = (0, _reactRedux.useSelector)(_selectors.selectActiveTodoItem);
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var setActiveItem = function setActiveItem(item) {
	    return dispatch(_activeTodo.activeTodoActions.setActiveItem(item));
	  };
	
	  var _useTodoRenderItem = (0, _useTodoRender.useTodoRenderItem)(formatMessage, setActiveItem),
	      getRenderByType = _useTodoRenderItem.getRenderByType;
	
	  var renderedList = (0, _react.useMemo)(function () {
	    return list.map(function (_ref2) {
	      var id = _ref2.id,
	          payload = _ref2.payload,
	          todoType = _ref2.type,
	          todoStatus = _ref2.status,
	          expiredTime = _ref2.expiredAt,
	          completedTime = _ref2.completedAt;
	
	      var renderFn = getRenderByType(todoType);
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        { key: id },
	        renderFn((0, _extends3.default)({}, payload, {
	          todoType: todoType,
	          todoStatus: todoStatus,
	          itemId: id,
	          expiredTime: expiredTime,
	          completedTime: completedTime
	        }))
	      );
	    });
	  }, [list]);
	
	  var renderPopupByType = (0, _react.useMemo)(function () {
	    var type = (0, _get2.default)(activeItem, 'todoType');
	
	    var isInsuranceToDoTask = (0, _get2.default)(activeItem, 'patientInsurance', null);
	
	    var todoStatus = (0, _get2.default)(activeItem, 'todoStatus');
	
	    var userId = (0, _get2.default)(targetUser, 'id');
	
	    var isTaskCompleted = (0, _utils.isCompleted)(todoStatus);
	
	    var opened = Boolean((0, _get2.default)(activeItem, 'id', null));
	
	    var closeModal = function closeModal() {
	      return setActiveItem(null);
	    };
	
	    switch (type) {
	      case _constants.TODO_TYPES.INVITATION:
	        return _react2.default.createElement(_InvitationDetailsPopup2.default, {
	          key: (0, _get2.default)(activeItem, 'id'),
	          invitationId: (0, _get2.default)(activeItem, 'id'),
	          onClose: closeModal
	        });
	      case _constants.TODO_TYPES.SURVEY:
	        return _react2.default.createElement(_SequentialSurveyPopup2.default, {
	          key: (0, _get2.default)(activeItem, 'assignmentId'),
	          assignmentId: (0, _get2.default)(activeItem, 'assignmentId'),
	          onClose: closeModal
	        });
	      case _constants.TODO_TYPES.CARE_PLAN_TASK:
	        return _react2.default.createElement(_CarePlanDetailsPopup2.default, {
	          id: (0, _get2.default)(activeItem, 'id'),
	          key: (0, _get2.default)(activeItem, 'id'),
	          itemId: (0, _get2.default)(activeItem, 'itemId'),
	          onClose: closeModal
	        });
	      case _constants.TODO_TYPES.CONSENT:
	        return _react2.default.createElement(_CompletedConsentPopup2.default, {
	          item: activeItem,
	          opened: opened,
	          onClose: closeModal,
	          formatMessage: formatMessage,
	          targetUser: targetUser
	        });
	      case _constants.TODO_TYPES.TASK:
	        {
	          var sharedProps = {
	            key: (0, _get2.default)(activeItem, 'taskAssignmentId'),
	            taskId: (0, _get2.default)(activeItem, 'taskAssignmentId'),
	            task: activeItem,
	            onClose: closeModal
	          };
	
	          if (isInsuranceToDoTask) {
	            return _react2.default.createElement(_InsuranceToDoTaskPopup2.default, (0, _extends3.default)({}, sharedProps, {
	              isCompleted: isTaskCompleted,
	              userId: userId
	            }));
	          }
	
	          return _react2.default.createElement(_TaskDetailsPopup2.default, sharedProps);
	        }
	      case _constants.TODO_TYPES.TASK_CUSTOM:
	        {
	          var id = activeItem.id,
	              name = activeItem.name,
	              description = activeItem.description,
	              task = (0, _objectWithoutProperties3.default)(activeItem, ['id', 'name', 'description']);
	
	          return _react2.default.createElement(_TaskDetailsPopup2.default, {
	            key: id,
	            taskId: id,
	            onClose: closeModal,
	            task: (0, _extends3.default)({}, task, {
	              taskAssignmentId: id,
	              todoTask: { name: name, description: description }
	            })
	          });
	        }
	      case _constants.TODO_TYPES.PROGRAM:
	        return _react2.default.createElement(_ProgramDetailsPopup2.default, {
	          item: activeItem,
	          targetUser: targetUser,
	          key: (0, _get2.default)(activeItem, 'id'),
	          formatMessage: formatMessage,
	          onClose: closeModal,
	          opened: opened
	        });
	      case _constants.TODO_TYPES.CONSENT_USER_ASSIGNMENT:
	        {
	          return isTaskCompleted ? _react2.default.createElement(_CompletedElectronicConsentPopup2.default, {
	            formatMessage: formatMessage,
	            item: activeItem,
	            onClose: closeModal,
	            opened: opened,
	            targetUser: targetUser
	          }) : _react2.default.createElement(_ElectronicConsentPopup2.default, {
	            item: activeItem,
	            key: (0, _get2.default)(activeItem, 'id'),
	            onClose: closeModal,
	            opened: opened
	          });
	        }
	
	      default:
	        return null;
	    }
	  }, [activeItem]);
	
	  var translationId = (0, _react.useMemo)(function () {
	    return isUpcoming ? 'healthboard.title.todoEmpty' : 'healthboard.title.todoCompleted';
	  }, [isUpcoming]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('pt3', { disabled: surveyProceeding }) },
	    loading ? _react2.default.createElement(_Loader2.default, null) : null,
	    !loading && list.length ? [renderedList, renderPopupByType] : null,
	    !loading && !list.length ? _react2.default.createElement(_Content2.default, {
	      icon: 'no-surveys',
	      text: formatMessage({ id: translationId }),
	      className: 'absolute-center g-color--primary'
	    }) : null
	  );
	}
	
	TodoList.propTypes = {
	  surveyProceeding: PropTypes.bool,
	  loading: PropTypes.bool,
	  list: PropTypes.array,
	  intl: PropTypes.object,
	  targetUser: PropTypes.object,
	  isUpcoming: PropTypes.bool
	};
	
	exports.default = (0, _enhance.enhance)(TodoList);

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotificationConsentView = NotificationConsentView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(17);
	
	var _useInfoConsentWithAppointments = __webpack_require__(1126);
	
	var _checkForIsSignedAllConsents = __webpack_require__(767);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	var _appointmentSurveyAssignment = __webpack_require__(844);
	
	var _index = __webpack_require__(4989);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NotificationConsentView(_ref) {
	  var appointment = _ref.appointment,
	      formatMessage = _ref.formatMessage,
	      isProviderContext = _ref.isProviderContext,
	      _ref$defaultMessages = _ref.defaultMessages,
	      defaultMessages = _ref$defaultMessages === undefined ? {} : _ref$defaultMessages;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	
	  var isSignedAllConsents = (0, _checkForIsSignedAllConsents.checkForIsSignedAllConsents)(appointment);
	
	  var _useInfoConsentWithAp = (0, _useInfoConsentWithAppointments.useInfoConsentWithAppointments)(isProviderContext, appointment),
	      dateTime = _useInfoConsentWithAp.dateTime,
	      allConsents = _useInfoConsentWithAp.allConsents,
	      serviceName = _useInfoConsentWithAp.serviceName,
	      organizationName = _useInfoConsentWithAp.organizationName,
	      notSignedConsent = _useInfoConsentWithAp.notSignedConsent,
	      patientUserInfoId = _useInfoConsentWithAp.patientUserInfoId,
	      notSignedPreVisits = _useInfoConsentWithAp.notSignedPreVisits,
	      isRequiredPreVisitForms = _useInfoConsentWithAp.isRequiredPreVisitForms;
	
	  var providerMessage = formatMessage({
	    id: 'appointment.consent.notificationProvider'
	  });
	
	  var patientMessage = (0, _react.useMemo)(function () {
	    if (_constants.INLINE_TYPES.includes(code)) {
	      return formatMessage({ id: 'appointment.consent.inLineNotification' });
	    }
	
	    if (!isSignedAllConsents && isRequiredPreVisitForms) {
	      return formatMessage({
	        id: 'appointment.surveysAndConsent.notificationProvider'
	      });
	    }
	
	    if (isRequiredPreVisitForms) {
	      return formatMessage({
	        id: 'appointment.surveys.notificationProvider'
	      });
	    }
	
	    if (Object.hasOwn(defaultMessages, 'patient')) {
	      return (0, _get2.default)(defaultMessages, 'patient');
	    }
	
	    return formatMessage({
	      id: 'appointment.consent.notificationProvider'
	    });
	  }, [code, isRequiredPreVisitForms, isSignedAllConsents, defaultMessages]);
	
	  var patientMessageLink = (0, _react.useMemo)(function () {
	    if (_constants.INLINE_TYPES.includes(code)) {
	      return null;
	    }
	
	    if (isSignedAllConsents && notSignedPreVisits.length === 0 && isRequiredPreVisitForms) {
	      return null;
	    }
	
	    if (!isSignedAllConsents && isRequiredPreVisitForms && notSignedPreVisits.length > 0) {
	      return formatMessage({
	        id: 'appointment.consentAndSurvey.notificationPatientLink'
	      });
	    }
	
	    if (isRequiredPreVisitForms && notSignedPreVisits.length > 0) {
	      return formatMessage({
	        id: 'appointment.postVisitForm.notificationPatientLink'
	      });
	    }
	
	    if (Object.hasOwn(defaultMessages, 'patientLink')) {
	      return (0, _get2.default)(defaultMessages, 'patientLink');
	    }
	
	    return formatMessage({
	      id: 'appointment.consent.notificationPatientLink'
	    });
	  }, [code, isRequiredPreVisitForms, notSignedPreVisits, isSignedAllConsents, defaultMessages]);
	
	  var skipNotification = !isProviderContext && !patientMessage;
	
	  var handleGuardForSigningConsentOrForms = (0, _react.useCallback)(function () {
	    if (notSignedConsent) {
	      dispatch(_appointmentConsentModal.appointmentConsentsModalActions.open({
	        serviceName: serviceName,
	        allConsents: allConsents,
	        organizationName: organizationName,
	        patientUserInfoId: patientUserInfoId,
	        startTime: dateTime,
	        consent: notSignedConsent
	      }));
	      return;
	    }
	
	    if (isRequiredPreVisitForms && notSignedPreVisits.length > 0) {
	      dispatch(_appointmentSurveyAssignment.preVisitConsentsModalActions.setSurveys(notSignedPreVisits));
	    }
	  }, [dateTime, serviceName, allConsents, organizationName, notSignedConsent, patientUserInfoId, notSignedPreVisits, isRequiredPreVisitForms]);
	
	  if (skipNotification) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    isProviderContext ? providerMessage : _react2.default.createElement(
	      'div',
	      { className: _index2.default.patientMessage },
	      patientMessage,
	      patientMessageLink && _react2.default.createElement(
	        'p',
	        {
	          className: _index2.default.patientMessageLink,
	          onClick: handleGuardForSigningConsentOrForms
	        },
	        patientMessageLink
	      )
	    )
	  );
	}
	
	NotificationConsentView.propTypes = {
	  formatMessage: PropTypes.func,
	  appointment: PropTypes.object,
	  isProviderContext: PropTypes.bool,
	  defaultMessages: PropTypes.object
	};

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderElectronicConsentHeader = renderElectronicConsentHeader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(721);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function renderElectronicConsentHeader(formatMessage, assignedBy, consentName, organizationName, dateConsent) {
	  var mainHeaderTitle = formatMessage({
	    id: 'appointment.electronicConsent.mainTitle'
	  }, { name: assignedBy });
	
	  var mainHeaderSubtitle = consentName + '/' + organizationName;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.headerLeftSide },
	      _react2.default.createElement(_Icon2.default, { name: 'icon-consent', size: 36, className: _index2.default.icon }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.consentDetails },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.consentType },
	          mainHeaderTitle
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.consentService },
	          mainHeaderSubtitle
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.dateConsent },
	      dateConsent
	    )
	  );
	}

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.UploadDocument = UploadDocument;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FilePicker = __webpack_require__(762);
	
	var _FilePicker2 = _interopRequireDefault(_FilePicker);
	
	var _styles = __webpack_require__(18);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(4991);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UploadDocument(_ref) {
	  var maxSize = _ref.maxSize,
	      disabled = _ref.disabled,
	      iconSize = _ref.iconSize,
	      textStyle = _ref.textStyle,
	      attachment = _ref.attachment,
	      setAttachment = _ref.setAttachment,
	      handleAddDocument = _ref.handleAddDocument,
	      titleAddButton = _ref.titleAddButton,
	      allowedFormats = _ref.allowedFormats,
	      validFileExtensions = _ref.validFileExtensions;
	
	  var handleError = function handleError(err) {
	    var errorData = (0, _extends3.default)({}, attachment, {
	      errors: (0, _get2.default)(err, 'errors'),
	      fileError: true
	    });
	    setAttachment(errorData);
	  };
	
	  var handleAttachments = function handleAttachments(file) {
	    setAttachment((0, _extends3.default)({}, attachment, {
	      file: file
	    }));
	    handleAddDocument();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _index2.default.disabled, disabled))
	    },
	    _react2.default.createElement(
	      _FilePicker2.default,
	      {
	        allowedFormats: allowedFormats,
	        inputFileLabel: 'visit-documents',
	        onError: handleError,
	        onFilePick: handleAttachments,
	        maxSize: maxSize,
	        validFileExtensions: validFileExtensions
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.addActionWrapper },
	        _react2.default.createElement(_Icon2.default, {
	          name: 'add-text',
	          size: iconSize,
	          style: { fill: _styles.COLORS.bluePrimary }
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(_index2.default.addButtonTitle, textStyle) },
	          titleAddButton
	        )
	      )
	    )
	  );
	}
	
	UploadDocument.defaultProps = {
	  iconSize: 16
	};
	
	UploadDocument.propTypes = {
	  maxSize: PropTypes.number,
	  disabled: PropTypes.bool,
	  iconSize: PropTypes.number,
	  textStyle: PropTypes.string,
	  attachment: PropTypes.object,
	  setAttachment: PropTypes.func,
	  handleAddDocument: PropTypes.func,
	  titleAddButton: PropTypes.string,
	  allowedFormats: PropTypes.array,
	  validFileExtensions: PropTypes.array
	};

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.ViewDocuments = ViewDocuments;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _deleteDocumentReq = __webpack_require__(302);
	
	var _selectors = __webpack_require__(23);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(4992);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ViewDocuments(_ref) {
	  var singleView = _ref.singleView,
	      attachment = _ref.attachment,
	      appointment = _ref.appointment,
	      providerContext = _ref.providerContext,
	      formatMessage = _ref.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isOpenDeleteModal = _useState2[0],
	      togleOpenDeleteModal = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      targetDocument = _useState4[0],
	      setTargetDocument = _useState4[1];
	
	  var loggedUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var appointmentId = appointment ? appointment.id : null;
	  var document = attachment ? attachment.file : null;
	  var allDocuments = appointment ? appointment.documents : [];
	
	  var handleOpenDocument = function handleOpenDocument(fileUrl) {
	    window.open(fileUrl);
	  };
	
	  var handleDeleteDocument = function handleDeleteDocument(documentId) {
	    dispatch(_deleteDocumentReq.actions.send({
	      userId: loggedUserId,
	      documentId: documentId,
	      appointmentId: appointmentId
	    }));
	  };
	
	  var handleOpenDeleteModal = function handleOpenDeleteModal(id) {
	    setTargetDocument(id);
	    togleOpenDeleteModal(true);
	  };
	
	  var viewAllDocuments = function viewAllDocuments() {
	    if (allDocuments.length === 0) return _react2.default.createElement(
	      'div',
	      null,
	      '-'
	    );
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      allDocuments.map(function (_ref2) {
	        var id = _ref2.id,
	            name = _ref2.name,
	            fileUrl = _ref2.fileUrl,
	            categoryName = _ref2.documentCategory.name,
	            subcategoryName = _ref2.documentSubcategory.name;
	
	        return _react2.default.createElement(
	          'div',
	          { key: id },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.viewAttachmentWrapper },
	            _react2.default.createElement(
	              'div',
	              {
	                className: _index2.default.documentWrapper,
	                onClick: function onClick() {
	                  return handleOpenDocument(fileUrl);
	                }
	              },
	              _react2.default.createElement(_Icon2.default, {
	                name: 'icon-document-black',
	                size: 32,
	                className: _index2.default.icon
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: _index2.default.fileInfoWrapper },
	                _react2.default.createElement(
	                  'div',
	                  { className: _index2.default.fileTitle },
	                  name
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _index2.default.fileCategory },
	                  categoryName + ', ' + subcategoryName
	                )
	              )
	            ),
	            providerContext && _react2.default.createElement(_Icon2.default, {
	              name: 'remove-member',
	              size: 16,
	              className: _index2.default.removeIcon,
	              onClick: function onClick() {
	                return handleOpenDeleteModal(id);
	              }
	            })
	          )
	        );
	      }),
	      providerContext && _react2.default.createElement(_ActionConfirmation2.default, {
	        onClose: function onClose() {
	          togleOpenDeleteModal(false);
	          setTargetDocument(null);
	        },
	        onSubmit: function onSubmit() {
	          return handleDeleteDocument(targetDocument);
	        },
	        opened: isOpenDeleteModal,
	        title: formatMessage({
	          id: 'appointment.documents.deleteMessage'
	        }),
	        actionButtonText: formatMessage({
	          id: 'common.delete'
	        }),
	        width: 'xsmall',
	        mobileFullScreen: false
	      })
	    );
	  };
	
	  return singleView ? _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.viewAttachmentWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.documentWrapper },
	        _react2.default.createElement(_Icon2.default, { name: 'icon-document-black', size: 32, className: _index2.default.icon }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.uploadFileTitle },
	          document.name
	        )
	      )
	    )
	  ) : viewAllDocuments();
	}
	
	ViewDocuments.propTypes = {
	  attachment: PropTypes.object,
	  singleView: PropTypes.bool.isRequired,
	  appointment: PropTypes.object,
	  providerContext: PropTypes.bool,
	  formatMessage: PropTypes.func
	};

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.VisitSurveyList = VisitSurveyList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _constants = __webpack_require__(17);
	
	var _SequentialSurveyPopup = __webpack_require__(780);
	
	var _SequentialSurveyPopup2 = _interopRequireDefault(_SequentialSurveyPopup);
	
	var _ProgramPopup = __webpack_require__(1190);
	
	var _ProgramPopup2 = _interopRequireDefault(_ProgramPopup);
	
	var _constants2 = __webpack_require__(493);
	
	var _ViewSurvey = __webpack_require__(3354);
	
	var _index = __webpack_require__(2251);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VisitSurveyList(_ref) {
	  var formatMessage = _ref.formatMessage,
	      appointment = _ref.appointment;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      assignmentId = _useState2[0],
	      setAssignmentId = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      targetUserId = _useState4[0],
	      setTargetUserId = _useState4[1];
	
	  var titleSurveys = formatMessage({
	    id: 'appointment.surveys.title'
	  });
	
	  var allSurveys = appointment ? appointment.surveyAssignments : [];
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.visitSurveyHeader },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.visitSurveyTitle },
	        titleSurveys
	      )
	    ),
	    allSurveys.length === 0 ? _react2.default.createElement(
	      'div',
	      null,
	      '-'
	    ) : _react2.default.createElement(
	      _react.Fragment,
	      null,
	      allSurveys.map(function (surveyEntity) {
	        var id = surveyEntity.assignmentId,
	            status = surveyEntity.status,
	            _surveyEntity$survey = surveyEntity.survey,
	            name = _surveyEntity$survey.name,
	            surveyId = _surveyEntity$survey.id,
	            surveyType = _surveyEntity$survey.surveyType,
	            intervieweeId = surveyEntity.interviewee.id;
	
	
	        switch (status) {
	          case _constants2.STATUS_SURVEY.COMPLETED:
	            return _react2.default.createElement(
	              _ProgramPopup2.default,
	              {
	                date: appointment.dateTime,
	                openedAssignmentId: id,
	                openedSurveyId: surveyId,
	                targetUserId: intervieweeId,
	                activeChannelId: _constants.APPOINTMENT_CHANNEL_ID,
	                forceFetch: true,
	                pdfExportable: true,
	                key: id
	              },
	              _react2.default.createElement(_ViewSurvey.ViewSurvey, {
	                formatMessage: formatMessage,
	                status: status,
	                id: id,
	                name: name,
	                surveyType: surveyType,
	                setAssignmentId: setAssignmentId,
	                isCompletedSurvey: true,
	                targetUserId: intervieweeId,
	                setIntervieweeId: setTargetUserId
	              })
	            );
	
	          case _constants2.STATUS_SURVEY.UPCOMING:
	            return _react2.default.createElement(_ViewSurvey.ViewSurvey, {
	              formatMessage: formatMessage,
	              status: status,
	              id: id,
	              name: name,
	              surveyType: surveyType,
	              setAssignmentId: setAssignmentId,
	              targetUserId: intervieweeId,
	              setIntervieweeId: setTargetUserId,
	              isCompletedSurvey: false,
	              key: id
	            });
	
	          default:
	            return _react2.default.createElement(_ViewSurvey.ViewSurvey, {
	              formatMessage: formatMessage,
	              status: status,
	              id: id,
	              name: name,
	              surveyType: surveyType,
	              setAssignmentId: setAssignmentId,
	              isCompletedSurvey: false,
	              isExpired: true,
	              targetUserId: intervieweeId,
	              setIntervieweeId: setTargetUserId,
	              key: id
	            });
	        }
	      }),
	      assignmentId && _react2.default.createElement(_SequentialSurveyPopup2.default, {
	        assignmentId: assignmentId,
	        onClose: function onClose() {
	          return setAssignmentId(null);
	        },
	        targetUserId: targetUserId
	      })
	    )
	  );
	}
	
	VisitSurveyList.propTypes = {
	  formatMessage: PropTypes.func,
	  appointment: PropTypes.object
	};

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _env = __webpack_require__(103);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RedirectToMozzazButton = function RedirectToMozzazButton(_ref) {
	  var btnTitle = _ref.btnTitle;
	
	  var onGoToMozzaz = function onGoToMozzaz() {
	    if (_env.MOZZAZ_REDIRECT_URL) {
	      window.open(_env.MOZZAZ_REDIRECT_URL, '_blank', 'noopener', 'noreferrer');
	    }
	  };
	
	  if (!_env.MOZZAZ_REDIRECT_URL) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _Button2.default,
	    { raised: true, color: 'primary', onClick: onGoToMozzaz },
	    btnTitle
	  );
	};
	
	RedirectToMozzazButton.propTypes = {
	  btnTitle: PropTypes.string
	};
	
	exports.default = RedirectToMozzazButton;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _styles = __webpack_require__(4997);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Title = __webpack_require__(1105);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _NavItem = __webpack_require__(792);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NavList(_ref) {
	  var list = _ref.list,
	      title = _ref.title,
	      activeUserId = _ref.activeUserId,
	      _onClick = _ref.onClick,
	      loggedUserId = _ref.loggedUserId,
	      subtitleContext = _ref.subtitleContext;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    title && _react2.default.createElement(_Title2.default, { text: title, className: 'f-12 pa3' }),
	    list.map(function (item) {
	      var _cn;
	
	      var isMainUser = loggedUserId === item.id;
	      return _react2.default.createElement(_NavItem2.default, {
	        title: item.displayableName,
	        className: (0, _classnames2.default)((_cn = {}, (0, _defineProperty3.default)(_cn, _styles2.default.calendar, item.calendarManageable), (0, _defineProperty3.default)(_cn, _styles2.default.calendarActive, item.calendarManageable && activeUserId === item.id), _cn)),
	        avatar: true,
	        avatarUrl: (0, _get2.default)(item, 'avatar.thumbMin', null),
	        waiting: item.status === _props.DEPENDENT_STATUSES.PENDING,
	        unverified: item.status === _props.DEPENDENT_STATUSES.UNVERIFIED,
	        key: item.id,
	        active: activeUserId === item.id,
	        onClick: function onClick() {
	          return _onClick(item.id);
	        },
	        subtitle: isMainUser ? subtitleContext : ''
	      });
	    })
	  );
	}
	
	NavList.propTypes = {
	  list: PropTypes.array,
	  title: PropTypes.string,
	  activeUserId: PropTypes.number,
	  onClick: PropTypes.func,
	  loggedUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  subtitleContext: PropTypes.string
	};
	
	exports.default = NavList;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _AppointmentTabs = __webpack_require__(1744);
	
	var _AppointmentTabs2 = _interopRequireDefault(_AppointmentTabs);
	
	var _virtualAppointmentsUpcommingReq = __webpack_require__(670);
	
	var providerUpcomingAppointmentList = _interopRequireWildcard(_virtualAppointmentsUpcommingReq);
	
	var _virtualAppointmentsHistoryReq = __webpack_require__(859);
	
	var providerHistoryAppointmentList = _interopRequireWildcard(_virtualAppointmentsHistoryReq);
	
	var _appointmentUpcomingFilters = __webpack_require__(1887);
	
	var providerUpcomingFilter = _interopRequireWildcard(_appointmentUpcomingFilters);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    upcomingList: (0, _selectors.selectProviderUpcomingAppointmentList)(state),
	    upcomingCount: (0, _selectors.selectProviderUpcomingCount)(state),
	    upcomingLoading: (0, _selectors.selectProviderUpcomingAppointmentsPending)(state),
	    upcommingPaginationLoading: (0, _selectors.selectProviderUpcomingPaginationPending)(state),
	    historyLoading: (0, _selectors.selectProviderHistoryAppointmentsPending)(state),
	    historyPaginationLoading: (0, _selectors.selectProviderHistoryPaginationPending)(state),
	    historyList: (0, _selectors.selectProviderHistoryAppointmentList)(state),
	    historyCount: (0, _selectors.selectProviderHistoryCount)(state),
	    isFilterToday: (0, _selectors.selectProviderUpcomingFilterToday)(state),
	    isFilterByTypeVisit: (0, _selectors.selectProviderUpcomingFilterByTypeVisit)(state)
	  };
	};
	var mapDispatchToProps = {
	  fetchUpcomingList: providerUpcomingAppointmentList.actions.send,
	  loadMoreUpcomingList: providerUpcomingAppointmentList.actions.loadMore,
	  fetchHistoryList: providerHistoryAppointmentList.actions.send,
	  loadMoreHistoryList: providerHistoryAppointmentList.actions.loadMore,
	  setAppointmentFiltersOption: providerUpcomingFilter.actions.set
	};
	
	var enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var userId = _ref.userId,
	      historyPaginationLoading = _ref.historyPaginationLoading,
	      upcommingPaginationLoading = _ref.upcommingPaginationLoading;
	  return {
	    id: userId,
	    providerContext: true,
	    providerView: true,
	    paginationSending: upcommingPaginationLoading || historyPaginationLoading
	  };
	}));
	
	var ProviderAppointmentList = enhance(_AppointmentTabs2.default);
	exports.default = ProviderAppointmentList;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _index = __webpack_require__(254);
	
	var _handleTaskTime = __webpack_require__(608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getElectronicConsentHeaderRenderData = function getElectronicConsentHeaderRenderData(entity, formatMessage) {
	  var completedTime = entity.completedTime,
	      expiredTime = entity.expiredTime,
	      todoStatus = entity.todoStatus,
	      userId = entity.assigneeUser.id,
	      assignerUser = entity.assignerUser,
	      _entity$consent = entity.consent,
	      consentTypeName = _entity$consent.consentType.name,
	      content = _entity$consent.content,
	      consentId = _entity$consent.id,
	      multipleOutcomes = _entity$consent.multipleOutcomes,
	      consentName = _entity$consent.name,
	      organizationName = _entity$consent.organization.name,
	      outcomeTitles = _entity$consent.outcomeTitles,
	      id = entity.id,
	      version = entity.version;
	
	  var _assignerUser = (0, _extends3.default)({}, assignerUser),
	      assignedBy = _assignerUser.displayableName;
	
	  var time = (0, _index.isCompleted)(todoStatus) ? completedTime : expiredTime;
	
	  var formatTime = (0, _handleTaskTime.handleElectronicConsentExpirationTime)(time, formatMessage, (0, _index.isCompleted)(todoStatus));
	
	  return {
	    assignedBy: assignedBy,
	    consentId: consentId,
	    consentName: consentName,
	    consentTypeName: consentTypeName,
	    consentVersionTitle: formatMessage({ id: 'common.version' }),
	    content: content,
	    formatTime: formatTime,
	    id: id,
	    organizationName: organizationName,
	    userId: userId,
	    version: version,
	    multipleOutcomes: multipleOutcomes,
	    outcomeTitles: outcomeTitles
	  };
	};
	
	exports.default = getElectronicConsentHeaderRenderData;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useVirtualVisitGuard = useVirtualVisitGuard;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(17);
	
	var _dateFilter = __webpack_require__(310);
	
	var _appointment = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAID = _constants.PAYMENT_STATUSES.PAID;
	var DRAFT = _constants.APPOINTMENT_STATUSES.DRAFT,
	    WAITING = _constants.APPOINTMENT_STATUSES.WAITING,
	    UPCOMING = _constants.APPOINTMENT_STATUSES.UPCOMING,
	    PENDING = _constants.APPOINTMENT_STATUSES.PENDING,
	    IN_PROCESS = _constants.APPOINTMENT_STATUSES.IN_PROCESS;
	function useVirtualVisitGuard(_ref) {
	  var appointment = _ref.appointment,
	      isUpcoming = _ref.isUpcoming;
	
	  var hasMandatoryPaymentWarning = (0, _appointment.checkMandatoryPaymentWarning)(appointment);
	
	  var dateTime = (0, _get2.default)(appointment, 'dateTime');
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	  var appointmentStatus = (0, _get2.default)(appointment, 'status.coreAppName', '');
	  var paymentStatus = (0, _get2.default)(appointment, 'paymentStatus');
	  var copay = (0, _get2.default)(appointment, 'copay');
	  var isPaid = paymentStatus === PAID || !copay;
	  var patientAllowedStart = (0, _get2.default)(appointment, 'allowedActions.patientStart');
	
	  var isPendingStatus = appointmentStatus === PENDING;
	  var isUpcomingAppointmentStatus = appointmentStatus === UPCOMING;
	  var isWaiting = appointmentStatus === WAITING;
	  var isInProcess = appointmentStatus === IN_PROCESS;
	
	  var isUrgentVisit = code === _constants.URGENT_VISIT_TYPE_CODE;
	  var isVirtualVisit = code === _constants.VIRTUAL_VISIT_TYPE_CODE;
	  var isTelemedicineVisit = code === _constants.TELEMEDICINE_VISIT_TYPE_CODE;
	
	  var forUrgentVisit = isUrgentVisit && isPaid && isUpcoming;
	  var forVirtualVisit = isVirtualVisit && isUpcoming && !isPendingStatus;
	  var forTelemedicineVisit = isTelemedicineVisit && isPaid && isUpcoming;
	
	  var callIsEnabled = isUrgentVisit ? isWaiting || isInProcess : patientAllowedStart;
	
	  var isExpired = callIsEnabled ? false : (0, _dateFilter.visitExpired)(dateTime);
	
	  var showVisitBtn = (forVirtualVisit || forUrgentVisit || forTelemedicineVisit) && !isExpired && !hasMandatoryPaymentWarning;
	
	  return (0, _extends3.default)({
	    isUpcomingAppointmentStatus: isUpcomingAppointmentStatus,
	    hasMandatoryPaymentWarning: hasMandatoryPaymentWarning,
	    showVisitBtn: showVisitBtn,
	    virtualCallEnabled: callIsEnabled
	  }, isUrgentVisit && {
	    isUpcomingAppointmentStatus: [DRAFT, WAITING, IN_PROCESS].includes(appointmentStatus)
	  });
	}

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _CardIcon = __webpack_require__(1821);
	
	var _CardIcon2 = _interopRequireDefault(_CardIcon);
	
	var _styles = __webpack_require__(5003);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InfoCardPopup(_ref) {
	  var icon = _ref.icon,
	      title = _ref.title,
	      onClose = _ref.onClose,
	      isOpened = _ref.isOpened,
	      children = _ref.children,
	      headerInfo = _ref.headerInfo,
	      headerTitle = _ref.headerTitle,
	      headerSubtitle = _ref.headerSubtitle,
	      rest = (0, _objectWithoutProperties3.default)(_ref, ['icon', 'title', 'onClose', 'isOpened', 'children', 'headerInfo', 'headerTitle', 'headerSubtitle']);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    (0, _extends3.default)({
	      strictClose: true,
	      opened: isOpened,
	      onClose: onClose,
	      title: title
	    }, rest),
	    _react2.default.createElement(
	      _Paper2.default,
	      { isLayoutColumn: true, className: 'flex-grow-1' },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.header },
	        _react2.default.createElement(_CardIcon2.default, {
	          icon: icon,
	          info: headerInfo,
	          title: headerTitle,
	          subtitle: headerSubtitle
	        })
	      ),
	      children
	    )
	  );
	}
	
	InfoCardPopup.propTypes = {
	  icon: PropTypes.string,
	  title: PropTypes.string,
	  onClose: PropTypes.func,
	  isOpened: PropTypes.bool,
	  children: PropTypes.node,
	  headerInfo: PropTypes.string,
	  headerTitle: PropTypes.string,
	  headerSubtitle: PropTypes.string,
	  intl: PropTypes.shape({
	    formatMessage: PropTypes.func
	  })
	};
	
	exports.default = InfoCardPopup;

/***/ }),
/* 1765 */,
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2; /* eslint-disable */
	/*
	 * First level chats, includes:
	 * - chats with context of the patient (eg. patients itself)
	 * - private one-to-one and group chats (eg. social)
	 *
	 * Component uses virtual list component for large lists handling
	 */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactVirtualized = __webpack_require__(6411);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _ListItem = __webpack_require__(3392);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Navigation = __webpack_require__(1181);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _strings = __webpack_require__(15);
	
	var _Intro = __webpack_require__(195);
	
	var _settings = __webpack_require__(199);
	
	var _channels = __webpack_require__(236);
	
	var _selectors = __webpack_require__(79);
	
	var _selectors2 = __webpack_require__(23);
	
	var _chatConnection = __webpack_require__(183);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _infiniteScroll = __webpack_require__(697);
	
	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);
	
	var _isElementVisible = __webpack_require__(4219);
	
	var _isElementVisible2 = _interopRequireDefault(_isElementVisible);
	
	var _popup = __webpack_require__(76);
	
	var _dependentStatusCheck = __webpack_require__(1920);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PAGE_SIZE = 20;
	var SIDEBAR_WIDTH = 300;
	var SCROLLBAR_WIDTH = 8;
	var ITEM_HEIGHT = 50;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    list: (0, _channels.sortedChannelsSelector)(state),
	    sending: (0, _channels.loadingStateSelector)(state),
	    targetUserId: (0, _selectors2.targetUserIdSelector)(state),
	    targetUser: (0, _selectors2.targetUserSelector)(state),
	    totalUsers: (0, _channels.totalChannelsSelector)(state),
	    activeChannelId: (0, _selectors.activeChannelIdSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  loadNextPage: _settings.actions.loadNextPage,
	  setTargetUserId: _settings.actions.setLastUserId,
	  showDependentCreatedModal: _popup.showDependentCreateModal,
	  removeLastSocialId: _settings.actions.removeLastSocialId,
	  setActiveChannelId: _chatConnection.actions.setActiveChannelId,
	  selectSocialChat: _chatConnection.actions.selectSocialChat
	};
	
	/* eslint-disable no-unused-expressions */
	var ChatsList = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactIntl.injectIntl)(_class = _dec(_class = (_temp2 = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ChatsList, _PureComponent);
	
	  function ChatsList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ChatsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChatsList.__proto__ || (0, _getPrototypeOf2.default)(ChatsList)).call.apply(_ref, [this].concat(args))), _this), _this.checkActive = function (item) {
	      var _this$props = _this.props,
	          activeChannelId = _this$props.activeChannelId,
	          targetUserId = _this$props.targetUserId;
	
	
	      if ((0, _get3.default)(item, 'contextUser')) {
	        return targetUserId === (0, _get3.default)(item, 'contextUser.id', null);
	      }
	      if ((0, _get3.default)(item, 'contextChannel')) {
	        return (0, _get3.default)(item, 'contextChannel.channelId', null) === activeChannelId;
	      }
	    }, _this.loadMore = function () {
	      if (_this.hasNextPage) {
	        var loadNextPage = _this.props.loadNextPage;
	
	
	        loadNextPage && loadNextPage();
	      }
	    }, _this.unscribeInfiniteScroll = function () {
	      _this.infiniteScroll.unsubscribe();
	      _this.infiniteScroll = null;
	    }, _this.rowRenderer = function (_ref2) {
	      var index = _ref2.index,
	          isScrolling = _ref2.isScrolling,
	          key = _ref2.key,
	          style = _ref2.style;
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: style },
	        isScrolling ? _react2.default.createElement('span', null) : _this.listItems[index]
	      );
	    }, _this.infiniteScroll = null, _this.listNode = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ChatsList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // initialize scroll on non empty container
	      if (!this.infiniteScroll && this.listNode) {
	        this.initInfiniteScroll();
	      }
	
	      // handle selected item visibility on pages switching
	      this.scrollItemIntoView(this.props.targetUserId);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // initialize scroll on non empty container
	      if (!this.infiniteScroll && this.listNode) {
	        this.initInfiniteScroll();
	      }
	
	      // uninitialize scroll on filters changing
	      if (this.infiniteScroll && (0, _isEmpty2.default)(this.props.list) && !(0, _isEmpty2.default)(prevProps.list)) {
	        this.unscribeInfiniteScroll();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.activeChannelId !== this.props.activeChannelId) {
	        this.scrollItemIntoView(nextProps.activeChannelId);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.infiniteScroll && this.unscribeInfiniteScroll();
	    }
	  }, {
	    key: 'checkActiveAndDefault',
	    value: function checkActiveAndDefault(items, item, i) {
	      var _this2 = this;
	
	      if (i > 0) return this.checkActive(item);
	
	      return items.filter(function (item) {
	        return _this2.checkActive(item);
	      }).length ? this.checkActive(item) : i === 0;
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(id, type) {
	      var _props = this.props,
	          onSelect = _props.onSelect,
	          setTargetUserId = _props.setTargetUserId,
	          setActiveChannelId = _props.setActiveChannelId,
	          onClose = _props.onClose,
	          targetUserId = _props.targetUserId,
	          removeLastSocialId = _props.removeLastSocialId,
	          selectSocialChat = _props.selectSocialChat,
	          patientPortalARList = _props.patientPortalARList,
	          showDependentCreatedModal = _props.showDependentCreatedModal;
	
	
	      var guardianDependentsList = patientPortalARList && patientPortalARList.map(function (dependent) {
	        return dependent.contextUser;
	      });
	
	      var isVerified = (0, _dependentStatusCheck.dependentStatusCheck)({
	        id: id,
	        guardianDependentsList: guardianDependentsList,
	        showDependentCreatedModal: showDependentCreatedModal
	      });
	
	      if (!isVerified) return;
	
	      if (type) {
	        selectSocialChat(id);
	        onClose && onClose();
	      } else {
	        onSelect && onSelect();
	        if (targetUserId === id) return;
	        setActiveChannelId(null);
	        removeLastSocialId();
	        setTargetUserId({ id: id });
	      }
	      // this.scrollItemIntoView(id);
	    }
	  }, {
	    key: 'scrollItemIntoView',
	    value: function scrollItemIntoView(id) {
	      var targetElement = this.listNode && this.listNode.querySelector('li[data-id="' + id + '"]');
	
	      if (targetElement && !(0, _isElementVisible2.default)(targetElement, (0, _get3.default)(this.listNode, 'parentNode'))) {
	        targetElement.scrollIntoView();
	      }
	    }
	  }, {
	    key: 'initInfiniteScroll',
	    value: function initInfiniteScroll() {
	      this.infiniteScroll = new _infiniteScroll2.default({
	        element: (0, _get3.default)(this.listNode, 'parentNode'),
	        loadEdgeOffset: 100,
	        type: 'lower',
	        onLoad: this.loadMore
	      });
	    }
	  }, {
	    key: 'checkScrollBarPresence',
	    value: function checkScrollBarPresence(listElem) {
	      // handle pages switching scenario
	      if (!listElem) return true;
	
	      var listHeight = (0, _get3.default)(listElem, 'offsetHeight', 0);
	      var wrapperHeight = (0, _get3.default)(listElem, 'parentNode.offsetHeight', 0);
	
	      return listHeight > wrapperHeight;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          sending = _props2.sending,
	          formatMessage = _props2.intl.formatMessage;
	
	
	      if ((0, _isEmpty2.default)(this.safeList) && !sending) {
	        return _react2.default.createElement(_Navigation2.default, { text: formatMessage(_strings.CHAT_EMPTY_NAVIGATION) });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(node) {
	            return _this3.listNode = node;
	          } },
	        this.content,
	        sending ? _react2.default.createElement(_Loader2.default, { white: true }) : null
	      );
	    }
	  }, {
	    key: 'listItems',
	    get: function get() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          minimized = _props3.minimized,
	          patientPortalContext = _props3.patientPortalContext;
	
	
	      return this.safeList.map(function (item, i) {
	        return _react2.default.createElement(_ListItem2.default, (0, _extends3.default)({
	          key: i
	        }, { minimized: minimized }, {
	          active: _this4.checkActiveAndDefault(_this4.safeList, item, i),
	          onClick: function onClick(id, type) {
	            return _this4.handleSelect(id, type);
	          },
	          intro: i === 0 ? _Intro.INTRO_HINT_SELECTORS.messages.selectChat : null,
	          patientPortalContext: patientPortalContext
	        }, item));
	      });
	    }
	  }, {
	    key: 'content',
	    get: function get() {
	      if ((0, _isEmpty2.default)(this.safeList)) return null;
	
	      if (this.safeList.length < PAGE_SIZE) return this.listItems;
	
	      var sidebarWidth = (0, _mobileHelpers.isDesktop)() ? SIDEBAR_WIDTH : window.innerWidth;
	      var hasScrollBar = this.checkScrollBarPresence(this.listNode);
	
	      return _react2.default.createElement(_reactVirtualized.List, {
	        width: hasScrollBar ? sidebarWidth - SCROLLBAR_WIDTH : sidebarWidth,
	        height: this.safeList ? ITEM_HEIGHT * this.safeList.length : 0,
	        rowCount: this.safeList.length,
	        rowHeight: ITEM_HEIGHT,
	        rowRenderer: this.rowRenderer,
	        style: { outline: 'none' }
	      });
	    }
	  }, {
	    key: 'hasNextPage',
	    get: function get() {
	      var _props4 = this.props,
	          list = _props4.list,
	          totalUsers = _props4.totalUsers;
	
	
	      return !totalUsers || totalUsers > (0, _get3.default)(list, 'length', 0);
	    }
	  }, {
	    key: 'safeList',
	    get: function get() {
	      var _props5 = this.props,
	          patientPortalARList = _props5.patientPortalARList,
	          list = _props5.list,
	          patientPortalContext = _props5.patientPortalContext;
	
	
	      return patientPortalContext ? patientPortalARList : list;
	    }
	  }]);
	  return ChatsList;
	}(_react.PureComponent), _class2.propTypes = {
	  list: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.number
	  })),
	  sending: _propTypes2.default.bool,
	  loadNextPage: _propTypes2.default.func,
	  minimized: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func,
	  setTargetUserId: _propTypes2.default.func,
	  showDependentCreatedModal: _propTypes2.default.func,
	  targetUserId: _propTypes2.default.number,
	  totalUsers: _propTypes2.default.number,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  patientPortalContext: _propTypes2.default.bool,
	  patientPortalARList: _propTypes2.default.array
	}, _temp2)) || _class) || _class);
	/* eslint-enable no-unused-expressions */
	
	exports.default = ChatsList;

/***/ }),
/* 1767 */,
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _env = __webpack_require__(103);
	
	var _checkIsAppStoreLinksAvailability = __webpack_require__(905);
	
	var _checkIsAppStoreLinksAvailability2 = _interopRequireDefault(_checkIsAppStoreLinksAvailability);
	
	var _styles = __webpack_require__(5019);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logoSize = {
	  width: 150,
	  height: 45
	};
	
	function MobileAppLogo(_ref) {
	  var className = _ref.className;
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return (0, _checkIsAppStoreLinksAvailability2.default)();
	  }, []),
	      showAppStoreLink = _useMemo.showAppStoreLink,
	      showPlayMarketLink = _useMemo.showPlayMarketLink;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_styles2.default.root, className) },
	    showPlayMarketLink && _react2.default.createElement(
	      'a',
	      {
	        href: _env.PLAY_MARKET_APP_LINK,
	        rel: 'noopener noreferrer',
	        target: '_blank'
	      },
	      _react2.default.createElement(_Icon2.default, (0, _extends3.default)({ name: 'googlePlayLogo' }, logoSize))
	    ),
	    showAppStoreLink && _react2.default.createElement(
	      'a',
	      { href: _env.APP_STORE_APP_LINK, rel: 'noopener noreferrer', target: '_blank' },
	      _react2.default.createElement(_Icon2.default, (0, _extends3.default)({ name: 'appStoreLogo' }, logoSize))
	    )
	  );
	}
	
	MobileAppLogo.propTypes = {
	  className: PropTypes.string
	};
	
	exports.default = MobileAppLogo;

/***/ }),
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PAPERWORK_QUERY_PARAMS = exports.PAPERWORK_QUERY_PARAMS = {
	  AUTH_TOKEN: 'auth_token'
	};

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactChartjs = __webpack_require__(1578);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	__webpack_require__(2113);
	
	__webpack_require__(4315);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectors = __webpack_require__(23);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(78);
	
	var _constants = __webpack_require__(54);
	
	var _useCCDSourceWeightBMI = __webpack_require__(3463);
	
	var _useSaturationDataGraf = __webpack_require__(3466);
	
	var _selectors2 = __webpack_require__(109);
	
	var _useActionFilters = __webpack_require__(1156);
	
	var _customDrawRectangle = __webpack_require__(3462);
	
	var _usePluginForChart = __webpack_require__(3465);
	
	var _useAverageData2 = __webpack_require__(1774);
	
	var _useDataGraf2 = __webpack_require__(3464);
	
	var _Filters = __webpack_require__(3457);
	
	var _Legend = __webpack_require__(3459);
	
	var _index = __webpack_require__(5041);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _hooks = __webpack_require__(144);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SATURATION = _constants.VITALS_ACTIVITY_TYPE.SATURATION,
	    HEIGHT = _constants.VITALS_ACTIVITY_TYPE.HEIGHT,
	    WEIGHT = _constants.VITALS_ACTIVITY_TYPE.WEIGHT,
	    BMI = _constants.VITALS_ACTIVITY_TYPE.BMI,
	    STEPS = _constants.VITALS_ACTIVITY_TYPE.STEPS,
	    DISTANCE = _constants.VITALS_ACTIVITY_TYPE.DISTANCE,
	    HEART_RATE = _constants.VITALS_ACTIVITY_TYPE.HEART_RATE,
	    BLOOD_GLUCOSE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE;
	var MONTH = _constants.CHART_FILTERS_TYPE.MONTH,
	    DAY = _constants.CHART_FILTERS_TYPE.DAY;
	var ALL_SOURCES = _constants.DATA_SOURCE_TYPE.ALL_SOURCES;
	
	
	function Chart(_ref) {
	  var formatMessage = _ref.formatMessage,
	      type = _ref.type,
	      setActiveFilter = _ref.setActiveFilter,
	      activeFilter = _ref.activeFilter,
	      baseDate = _ref.baseDate,
	      singleDayMode = _ref.singleDayMode,
	      isWeightInKg = _ref.isWeightInKg,
	      isHeightInMeters = _ref.isHeightInMeters,
	      setHistoricSourceType = _ref.setHistoricSourceType,
	      isMilligramsPerDeciliter = _ref.isMilligramsPerDeciliter,
	      mainUser = _ref.mainUser;
	
	  (0, _react.useEffect)(function () {
	    if (_reactChartjs.Chart) {
	      _reactChartjs.Chart.elements.Rectangle.prototype.draw = _customDrawRectangle.customDrawRectangle;
	    }
	  }, []);
	
	  var stepsOrDistance = [STEPS, DISTANCE].includes(type);
	  var isCandleType = [SATURATION, HEART_RATE, BLOOD_GLUCOSE].includes(type);
	
	  var _useState = (0, _react.useState)(ALL_SOURCES),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      sourceType = _useState2[0],
	      setSourceType = _useState2[1];
	
	  var targetUserId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	  var loggedUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	
	  var targetUserFirstName = (0, _get2.default)((0, _reactRedux.useSelector)(_selectors.targetUserSelector), 'firstName', '');
	
	  var safeUserId = targetUserId || loggedUserId;
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var pendingChart = (0, _reactRedux.useSelector)(_selectors2.combinedPendingDataRequest);
	  var pendingChartModal = (0, _reactRedux.useSelector)(_selectors2.combinedPendingDataModalRequest);
	  var getDataAction = (0, _useActionFilters.useActionFilters)(type, singleDayMode);
	
	  var safePending = singleDayMode ? pendingChartModal : pendingChart;
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      if (setActiveFilter) {
	        setActiveFilter(MONTH.type);
	      }
	    };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (getDataAction && type && type !== HEIGHT) dispatch(getDataAction.action((0, _extends3.default)({
	      userId: safeUserId,
	      period: singleDayMode ? DAY.type : MONTH.type
	    }, baseDate && { baseDate: (0, _moment2.default)(baseDate).format('YYYY-MM-DD') })));
	  }, [type, baseDate, safeUserId]);
	
	  (0, _react.useEffect)(function () {
	    setSourceType(ALL_SOURCES);
	  }, [activeFilter]);
	
	  var handleClick = function handleClick(filterType) {
	    dispatch(getDataAction.clear());
	    setActiveFilter(filterType);
	    dispatch(getDataAction.action({ userId: safeUserId, period: filterType }));
	  };
	
	  var currentChartInstance = (0, _react.useRef)();
	
	  var _useDataGraf = (0, _useDataGraf2.useDataGraf)({
	    formatMessage: formatMessage,
	    dataType: type,
	    filterType: activeFilter,
	    chartInstanceRef: currentChartInstance,
	    singleDayMode: singleDayMode,
	    isWeightInKg: isWeightInKg,
	    mainUser: mainUser,
	    targetUserFirstName: targetUserFirstName,
	    isMilligramsPerDeciliter: isMilligramsPerDeciliter
	  }),
	      data = _useDataGraf.data,
	      options = _useDataGraf.options,
	      isGrafTypeLine = _useDataGraf.isGrafTypeLine;
	
	  var _useCCDSourceWeightBM = (0, _useCCDSourceWeightBMI.useCCDSourceWeightBMI)({
	    rowData: data,
	    activeFilter: activeFilter,
	    singleDayMode: singleDayMode,
	    options: options,
	    dataType: type,
	    sourceType: sourceType,
	    currentChartInstance: currentChartInstance,
	    formatMessage: formatMessage,
	    mainUser: mainUser,
	    targetUserFirstName: targetUserFirstName,
	    isWeightInKg: isWeightInKg
	  }),
	      bmiWeightData = _useCCDSourceWeightBM.bmiWeightData,
	      bmiWeightOptions = _useCCDSourceWeightBM.bmiWeightOptions;
	
	  var _useSaturationDataGra = (0, _useSaturationDataGraf.useSaturationDataGraf)({
	    rowData: data,
	    activeFilter: activeFilter,
	    singleDayMode: singleDayMode,
	    options: options,
	    isCandleType: isCandleType,
	    sourceType: sourceType,
	    currentChartInstance: currentChartInstance.current,
	    formatMessage: formatMessage,
	    mainUser: mainUser,
	    targetUserFirstName: targetUserFirstName,
	    type: type,
	    isMilligramsPerDeciliter: isMilligramsPerDeciliter
	  }),
	      saturationData = _useSaturationDataGra.saturationData,
	      saturationOptions = _useSaturationDataGra.saturationOptions;
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    switch (type) {
	      case DISTANCE:
	      case STEPS:
	      case HEIGHT:
	        return { safeData: data, safeOptions: options };
	      case BMI:
	      case WEIGHT:
	        return { safeData: bmiWeightData, safeOptions: bmiWeightOptions };
	      case HEART_RATE:
	      case SATURATION:
	      case BLOOD_GLUCOSE:
	        return { safeData: saturationData, safeOptions: saturationOptions };
	    }
	  }, [type, data, options, saturationOptions, saturationData]),
	      safeData = _useMemo.safeData,
	      safeOptions = _useMemo.safeOptions;
	
	  var _useAverageData = (0, _useAverageData2.useAverageData)(formatMessage, safeData, type, activeFilter, singleDayMode, isWeightInKg, isHeightInMeters, isMilligramsPerDeciliter),
	      formatValue = _useAverageData.formatValue,
	      title = _useAverageData.title,
	      metric = _useAverageData.metric,
	      rangeDate = _useAverageData.date,
	      averageLine = _useAverageData.averageLine;
	
	  var plugins = (0, _usePluginForChart.usePluginForChart)(isGrafTypeLine, isCandleType);
	
	  var isEmptyState = !safeData.averageOrTotal.value;
	  var safeRangeTitle = isCandleType ? rangeDate : title + ' ' + rangeDate;
	  var safeRangeTitleForOneDay = (0, _utils.getSafeDescriptionDataHistoricList)(type, formatMessage, true) + ' ' + rangeDate;
	
	  var sourceTypeTitle = getSafeDataSourceTitle(sourceType, formatMessage, mainUser, targetUserFirstName, stepsOrDistance);
	
	  var deviceTypeTitle = getSafeDataSourceTitle(_constants.DATA_SOURCE_TYPE.DEVICES, formatMessage, mainUser, targetUserFirstName, stepsOrDistance);
	
	  var handleChooseDataSource = function handleChooseDataSource(currentType) {
	    if (currentType === sourceType) {
	      if (setHistoricSourceType) {
	        setHistoricSourceType(ALL_SOURCES);
	      }
	      setSourceType(ALL_SOURCES);
	    } else {
	      if (setHistoricSourceType) {
	        setHistoricSourceType(currentType);
	      }
	      setSourceType(currentType);
	    }
	  };
	
	  return type !== HEIGHT ? _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.singleDayPadding, singleDayMode))
	    },
	    singleDayMode ? _react2.default.createElement(
	      'div',
	      { className: _index2.default.singleDayRoot },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.valueWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.value },
	          formatValue || ''
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.metric },
	          metric
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.rightSideWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.date },
	          safeRangeTitleForOneDay
	        ),
	        stepsOrDistance && _react2.default.createElement(
	          'div',
	          { className: _index2.default.dataSourceTitle },
	          deviceTypeTitle
	        ),
	        !stepsOrDistance && _react2.default.createElement(
	          'div',
	          { className: _index2.default.dataSourceTitle },
	          sourceTypeTitle
	        )
	      )
	    ) : _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.header },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.averageValueWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.averageValue },
	            safePending || isEmptyState ? '-' : formatValue
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.averageMetric },
	            metric
	          )
	        ),
	        _react2.default.createElement(_Filters.Filters, { activeFilter: activeFilter, handleClick: handleClick })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.averageDate },
	        safeRangeTitle
	      ),
	      stepsOrDistance && _react2.default.createElement(
	        'div',
	        { className: _index2.default.dataSourceTitle },
	        deviceTypeTitle
	      ),
	      !stepsOrDistance && _react2.default.createElement(
	        'div',
	        { className: _index2.default.dataSourceTitle },
	        sourceTypeTitle
	      )
	    ),
	    safePending && _react2.default.createElement(_Loader2.default, null),
	    isEmptyState && !safePending && _react2.default.createElement(
	      'div',
	      { className: _index2.default.emptyStateWrapper },
	      _react2.default.createElement(_Icon2.default, { name: 'ico-1000-graph', size: 60 }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.emptyStateDescription },
	        formatMessage({ id: 'patient.healthboard.graf.emptyState' })
	      )
	    ),
	    !isEmptyState && !safePending && type !== HEIGHT && _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_index2.default.grafWrapper, (0, _defineProperty3.default)({}, _index2.default.grafWrapperPadding, singleDayMode))
	      },
	      isGrafTypeLine ? _react2.default.createElement(_reactChartjs.Line, {
	        data: safeData,
	        height: 80,
	        plugins: plugins,
	        options: (0, _extends3.default)({}, safeOptions, averageLine),
	        ref: currentChartInstance
	      }) : _react2.default.createElement(_reactChartjs.Bar, {
	        data: safeData,
	        height: 80,
	        options: (0, _extends3.default)({}, safeOptions, averageLine),
	        ref: currentChartInstance,
	        plugins: plugins,
	        redraw: true
	      }),
	      !stepsOrDistance && _react2.default.createElement(_Legend.Legend, {
	        formatMessage: formatMessage,
	        sourceType: sourceType,
	        handleClick: function handleClick(dataSourceType) {
	          return handleChooseDataSource(dataSourceType);
	        },
	        availableDataSource: safeData.availableDataSource,
	        targetUserFirstName: targetUserFirstName,
	        dataType: type,
	        mainUser: mainUser,
	        activeFilter: activeFilter,
	        setSourceType: setSourceType
	      })
	    )
	  ) : null;
	}
	
	Chart.propTypes = {
	  formatMessage: PropTypes.func,
	  type: PropTypes.string,
	  setActiveFilter: PropTypes.func,
	  activeFilter: PropTypes.string,
	  baseDate: PropTypes.string,
	  singleDayMode: PropTypes.bool,
	  isWeightInKg: PropTypes.bool,
	  isHeightInMeters: PropTypes.bool,
	  isMilligramsPerDeciliter: PropTypes.bool,
	  setHistoricSourceType: PropTypes.func,
	  mainUser: PropTypes.bool
	};
	
	exports.default = (0, _react.memo)(Chart);

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.useAverageData = useAverageData;
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(54);
	
	var _utils = __webpack_require__(78);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DAY = _constants.CHART_FILTERS_TYPE.DAY;
	var HEART_RATE = _constants.VITALS_ACTIVITY_TYPE.HEART_RATE,
	    SATURATION = _constants.VITALS_ACTIVITY_TYPE.SATURATION,
	    WEIGHT = _constants.VITALS_ACTIVITY_TYPE.WEIGHT,
	    BMI = _constants.VITALS_ACTIVITY_TYPE.BMI,
	    STEPS = _constants.VITALS_ACTIVITY_TYPE.STEPS,
	    DISTANCE = _constants.VITALS_ACTIVITY_TYPE.DISTANCE,
	    HEIGHT = _constants.VITALS_ACTIVITY_TYPE.HEIGHT,
	    BLOOD_GLUCOSE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE;
	function useAverageData(formatMessage, data, dataType, filterType, singleDayMode, isWeightInKg, isHeightInMeters, isMilligramsPerDeciliter) {
	  var _data$averageOrTotal = data.averageOrTotal,
	      value = _data$averageOrTotal.value,
	      showAverageLine = _data$averageOrTotal.showAverageLine,
	      dateForSingleMode = _data$averageOrTotal.dateForSingleMode;
	
	  var isDayTypeFilter = filterType === DAY.type;
	  var isBarTypeChart = [STEPS, DISTANCE].includes(dataType);
	  var getMetricFromDataType = function getMetricFromDataType() {
	    switch (dataType) {
	      case HEIGHT:
	        return {
	          metric: isHeightInMeters ? formatMessage({
	            id: 'patient.healthboard.height.metric.cm'
	          }) : '',
	          formatValue: (0, _utils.formatHeightValueWithMetric)(value, isHeightInMeters)
	        };
	      case WEIGHT:
	        return {
	          metric: isWeightInKg ? formatMessage({
	            id: 'patient.healthboard.weight.metric.kg'
	          }) : formatMessage({
	            id: 'patient.healthboard.weight.metric'
	          }),
	          formatValue: (0, _utils.formatValueWeightWithMetric)(value, isWeightInKg)
	        };
	      case BMI:
	        return {
	          metric: '',
	          formatValue: value && value.toFixed(1)
	        };
	      case DISTANCE:
	        return {
	          metric: formatMessage({ id: 'patient.healthboard.distance.metric' }),
	          formatValue: (0, _utils.convertValueDistanceToMiles)(value)
	        };
	      case STEPS:
	        return {
	          metric: formatMessage({ id: 'patient.healthboard.steps.metric' }),
	          formatValue: value && (0, _utils.numberWithCommas)(value.toFixed())
	        };
	      case SATURATION:
	        return {
	          metric: formatMessage({
	            id: 'patient.healthboard.saturation.metric'
	          }),
	          formatValue: value
	        };
	      case HEART_RATE:
	        return {
	          metric: formatMessage({
	            id: 'patient.healthboard.heart_rate.metric'
	          }),
	          formatValue: value
	        };
	      case BLOOD_GLUCOSE:
	        return {
	          metric: isMilligramsPerDeciliter ? formatMessage({
	            id: 'patient.healthboard.blood_glucose.metric.milligrams_per_deciliter'
	          }) : formatMessage({
	            id: 'patient.healthboard.blood_glucose.metric.millimoles_per_liter'
	          }),
	          formatValue: value
	        };
	    }
	  };
	
	  var makeAverageLineEntity = (0, _react.useMemo)(function () {
	    return function () {
	      if (!value) return {};
	      return {
	        annotation: {
	          events: ['click'],
	          annotations: [].concat((0, _toConsumableArray3.default)(filterType !== DAY.type && showAverageLine && [{
	            drawTime: 'afterDatasetsDraw',
	            id: 'hline',
	            type: 'line',
	            mode: 'horizontal',
	            scaleID: 'right-y-axis',
	            value: value,
	            borderColor: '#00b1e1',
	            borderWidth: 1,
	            label: {
	              backgroundColor: 'white',
	              position: 'right',
	              content: (0, _utils.makeTickForData)(value, dataType, true, isWeightInKg),
	              fontColor: _styles.COLORS.grayDark,
	              fontSize: 11,
	              fontFamily: 'Helvetica',
	              fontStyle: 'bold',
	              yAdjust: -8,
	              cornerRadius: 1,
	              xPadding: 2,
	              yPadding: 1,
	              enabled: true
	            }
	          }]), (0, _toConsumableArray3.default)(isBarTypeChart && [{
	            drawTime: 'afterDatasetsDraw',
	            id: 'baseline',
	            type: 'line',
	            mode: 'horizontal',
	            scaleID: 'right-y-axis',
	            value: 0,
	            borderColor: '#e5e5e5',
	            borderWidth: 1
	          }]))
	        }
	      };
	    };
	  }, [data, dataType, filterType, showAverageLine, isWeightInKg, isHeightInMeters, isBarTypeChart]);
	
	  return (0, _extends3.default)({}, getMetricFromDataType(), {
	    title: isDayTypeFilter && ![BMI, WEIGHT, HEIGHT].includes(dataType) ? formatMessage({ id: 'patient.healthboard.total' }) : formatMessage({ id: 'patient.healthboard.average' }),
	    date: singleDayMode ? dateForSingleMode : (0, _utils.makeDateForAverageOrTotal)(data, filterType),
	    averageLine: makeAverageLineEntity()
	  });
	}

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _resultsDetailsModal = __webpack_require__(1303);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabTestResultCard = function LabTestResultCard(_ref) {
	  var entity = _ref.entity,
	      detailsMode = _ref.detailsMode;
	  var name = entity.name,
	      specimenCollectionDate = entity.specimenCollectionDate,
	      orderedBy = entity.orderedBy,
	      isPrivate = entity.isPrivate;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var handleOpenDetails = function handleOpenDetails() {
	    dispatch(_resultsDetailsModal.resultsDetailsModalActions.open({ ccdLabTestId: entity.id, entity: entity }));
	  };
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_index2.default.root, _index2.default.labTestResult, (0, _defineProperty3.default)({}, _index2.default.labTestResultDetails, detailsMode)),
	      onClick: handleOpenDetails
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        !detailsMode && _react2.default.createElement(_Icon2.default, { size: 28, name: 'icon-lab-black', className: _index2.default.iconType }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_index2.default.title, _index2.default.cropConditionsTitle) },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.titleWrapper, (0, _defineProperty3.default)({}, _index2.default.noTitle, !name))
	              },
	              name
	            ),
	            _react2.default.createElement(_PrivacyIcon2.default, {
	              show: isPrivate && !detailsMode,
	              className: _index2.default.visibilityIcon
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_index2.default.description, _index2.default.cropConditionsTitle) },
	            orderedBy || ''
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.statusWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.description },
	          specimenCollectionDate ? (0, _utils.formatDate)(specimenCollectionDate, 'MMM D, Y') : ''
	        )
	      )
	    )
	  );
	};
	
	LabTestResultCard.propTypes = {
	  entity: _propTypes2.default.object,
	  detailsMode: _propTypes2.default.bool
	};
	
	exports.default = LabTestResultCard;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _utils = __webpack_require__(78);
	
	var _constants = __webpack_require__(54);
	
	var _styles = __webpack_require__(18);
	
	var _DatePickerRange = __webpack_require__(3849);
	
	var _index = __webpack_require__(5053);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HealthRecordSearch = function HealthRecordSearch(_ref) {
	  var pending = _ref.pending,
	      endDate = _ref.endDate,
	      onClear = _ref.onClear,
	      onSearch = _ref.onSearch,
	      startDate = _ref.startDate,
	      setEndDate = _ref.setEndDate,
	      setStartDate = _ref.setStartDate,
	      formatMessage = _ref.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isNewDate = _useState2[0],
	      setIsNewDate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('horizontal'),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      direction = _useState4[0],
	      setDirection = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      openDatePickerRange = _useState6[0],
	      setOpenDatePickerRange = _useState6[1];
	
	  var hasData = startDate && endDate;
	  var safeToTitle = formatMessage({ id: 'common.to' });
	  var safeFromTitle = formatMessage({ id: 'common.from' });
	
	  var formattedDate = (0, _react.useCallback)(function () {
	    var fromDate = (0, _utils.formatDate)(startDate, 'MMM D, Y');
	    var toDate = (0, _utils.formatDate)(endDate, 'MMM D, Y');
	
	    var safeStartDate = fromDate === _constants.INVALID_DATE ? safeFromTitle : fromDate;
	    var safeEndDate = toDate === _constants.INVALID_DATE ? safeToTitle : toDate;
	    var rangeOneDay = safeStartDate === safeEndDate;
	    return rangeOneDay ? safeStartDate : safeStartDate + ' - ' + safeEndDate;
	  }, [startDate, endDate]);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return {
	      disableClearButton: !hasData || pending,
	      disableSearchButton: Boolean(hasData) && !isNewDate || !hasData || pending
	    };
	  }, [hasData, isNewDate, pending]),
	      disableClearButton = _useMemo.disableClearButton,
	      disableSearchButton = _useMemo.disableSearchButton;
	
	  var defineViewDate = (0, _moment2.default)().subtract(1, 'month').toDate();
	
	  var onSearchHandler = function onSearchHandler() {
	    setOpenDatePickerRange(false);
	    setIsNewDate(false);
	    onSearch();
	  };
	
	  (0, _react.useEffect)(function () {
	    setDirection(window.innerWidth <= _styles.BREAKPOINT ? 'vertical' : 'horizontal');
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    setIsNewDate(true);
	  }, [startDate, endDate]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      formatMessage({ id: 'patient.portal.healthRecord.dateRange' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.searchWrapper },
	      _react2.default.createElement(
	        'div',
	        {
	          className: _index2.default.searchBox,
	          onClick: function onClick() {
	            return setOpenDatePickerRange(!openDatePickerRange);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.date },
	          formattedDate()
	        ),
	        _react2.default.createElement(_Icon2.default, {
	          size: 16,
	          name: 'icon-date',
	          style: { fill: _styles.COLORS.stormyBlue }
	        })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          icon: true,
	          onClick: onClear,
	          className: _index2.default.clearDate,
	          disabled: disableClearButton,
	          'aria-label': 'close'
	        },
	        _react2.default.createElement(_Icon2.default, { size: 16, name: 'close', style: { fill: _styles.COLORS.stormyBlue } })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          raised: true,
	          color: 'primary',
	          onClick: onSearchHandler,
	          disabled: disableSearchButton,
	          className: _index2.default.searchButton
	        },
	        formatMessage({ id: 'patient.portal.healthRecord.search' })
	      )
	    ),
	    openDatePickerRange && _react2.default.createElement(_DatePickerRange.DatePickerRange, {
	      months: 2,
	      direction: direction,
	      endDateRange: endDate,
	      rangeColors: ['#5476a4'],
	      shownDate: defineViewDate,
	      startDateRange: startDate,
	      disabledMaxDate: new Date(),
	      setEndDateRange: setEndDate,
	      setStartDateRange: setStartDate,
	      className: _index2.default.wrapperCalendar
	    })
	  );
	};
	
	HealthRecordSearch.propTypes = {
	  onSearch: _propTypes2.default.func,
	  pending: _propTypes2.default.bool,
	  onClear: _propTypes2.default.func,
	  setEndDate: _propTypes2.default.func,
	  setStartDate: _propTypes2.default.func,
	  formatMessage: _propTypes2.default.func,
	  endDate: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.string]),
	  startDate: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.string])
	};
	
	exports.default = HealthRecordSearch;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setConfig = exports.setOptions = exports.shouldShowGraph = exports.shouldShowRange = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _sortBy = __webpack_require__(1562);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _isNumber = __webpack_require__(1558);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _pipe = __webpack_require__(4226);
	
	var _graphSettings = __webpack_require__(3510);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = __webpack_require__(114);
	
	var _timeline = __webpack_require__(1825);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calculatePeriod = function calculatePeriod(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	
	  return Math.abs(to.diff(from, 'days'));
	};
	
	var getSafeValue = function getSafeValue(value) {
	  return value && Number(value.replace('<', '').replace('>', '').replace('(', '').replace(')', ''));
	};
	
	var makeDataForGraph = function makeDataForGraph(graphData) {
	  var _getNormalRange = getNormalRange(graphData),
	      rawNormalRange = _getNormalRange.rawNormalRange,
	      minYAxisValue = _getNormalRange.yMin,
	      maxYAxisValue = _getNormalRange.yMax;
	
	  return graphData.reduce(function (a, c) {
	    return (0, _extends3.default)({}, a, {
	      datasetsObjects: [].concat((0, _toConsumableArray3.default)((0, _get2.default)(a, 'datasetsObjects', {})), [{
	        value: getSafeValue(c.componentResultValue),
	        date: (0, _moment2.default)(c.specimenCollectionDate),
	        valueUnit: c.componentResultUnits || '',
	        abnormalStatus: c.componentAbnormalStatus || ''
	      }])
	    });
	  }, {
	    maxYAxisValue: maxYAxisValue,
	    minYAxisValue: minYAxisValue,
	    rawNormalRange: rawNormalRange
	  });
	};
	
	var sortDataSets = function sortDataSets(dataSets) {
	  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'date';
	  return (0, _sortBy2.default)(dataSets, function (ds) {
	    return (0, _get2.default)(ds, selector);
	  });
	};
	
	var sortGraphData = function sortGraphData(graphData) {
	  var datasets = (0, _get2.default)(graphData, 'datasetsObjects', {});
	
	  return (0, _extends3.default)({}, graphData, {
	    datasetsObjects: sortDataSets(datasets)
	  });
	};
	
	var setColorDependOnCtx = function setColorDependOnCtx(_ref2) {
	  var ctx = _ref2.ctx,
	      yMin = _ref2.yMin,
	      yMax = _ref2.yMax,
	      rawNormalRange = _ref2.rawNormalRange,
	      _ref2$normalColor = _ref2.normalColor,
	      normalColor = _ref2$normalColor === undefined ? _styles.COLORS.black : _ref2$normalColor,
	      _ref2$lowAbnormalColo = _ref2.lowAbnormalColor,
	      lowAbnormalColor = _ref2$lowAbnormalColo === undefined ? _styles.COLORS.peach : _ref2$lowAbnormalColo,
	      _ref2$highAbnormalCol = _ref2.highAbnormalColor,
	      highAbnormalColor = _ref2$highAbnormalCol === undefined ? _styles.COLORS.orangePink : _ref2$highAbnormalCol;
	
	  var index = ctx.dataIndex;
	  var value = ctx.dataset.data[index].y;
	
	  var isLessThan = rawNormalRange && rawNormalRange.includes('<');
	  var isGreaterThan = rawNormalRange && rawNormalRange.includes('>');
	  var isLessOrEqual = rawNormalRange && rawNormalRange.includes('<OR=');
	  var isGreaterOrEqual = rawNormalRange && rawNormalRange.includes('>OR=');
	
	  if (isGreaterOrEqual && isGreaterThan) {
	    return value >= yMin ? normalColor : lowAbnormalColor;
	  }
	
	  if (isGreaterThan && !isGreaterOrEqual) {
	    return value > yMin ? normalColor : lowAbnormalColor;
	  }
	
	  if (isLessOrEqual && isLessThan) {
	    return value <= yMax ? normalColor : highAbnormalColor;
	  }
	
	  if (isLessThan && !isLessOrEqual) {
	    return value < yMax ? normalColor : highAbnormalColor;
	  }
	
	  if (yMin || yMax) {
	    if (value < yMin) return lowAbnormalColor;
	    if (value > yMax) return highAbnormalColor;
	  }
	
	  return normalColor;
	};
	
	var makeDataSets = function makeDataSets(graphData) {
	  var collectedData = (0, _get2.default)(graphData, 'datasetsObjects', []);
	  var rawNormalRange = (0, _get2.default)(graphData, 'rawNormalRange', '');
	  var yMax = (0, _get2.default)(graphData, 'maxYAxisValue', 0);
	  var yMin = (0, _get2.default)(graphData, 'minYAxisValue', 0);
	
	  var _collectedData$reduce = collectedData.reduce(function (a, c) {
	    return {
	      datasets: [(0, _extends3.default)({
	        data: [].concat((0, _toConsumableArray3.default)(a.datasets[0].data), [{ y: (0, _get2.default)(c, 'value'), x: (0, _get2.default)(c, 'date') }]),
	        pointBackgroundColor: function pointBackgroundColor(ctx) {
	          return setColorDependOnCtx({ ctx: ctx, yMin: yMin, yMax: yMax, rawNormalRange: rawNormalRange });
	        },
	        pointBorderColor: function pointBorderColor(ctx) {
	          return setColorDependOnCtx({ ctx: ctx, yMin: yMin, yMax: yMax, rawNormalRange: rawNormalRange });
	        },
	        pointHoverBackgroundColor: _styles.COLORS.white,
	        pointHoverBorderColor: function pointHoverBorderColor(ctx) {
	          return setColorDependOnCtx({
	            ctx: ctx,
	            yMin: yMin,
	            yMax: yMax,
	            normalColor: _styles.COLORS.black,
	            lowAbnormalColor: _styles.COLORS.peach,
	            highAbnormalColor: _styles.COLORS.orangePink
	          });
	        },
	        pointHoverBorderWidth: 1,
	        pointHoverRadius: 4
	      }, _graphSettings.dataSetsProps)]
	    };
	  }, { datasets: [{ data: [] }] }),
	      datasets = _collectedData$reduce.datasets;
	
	  return (0, _extends3.default)({}, graphData, {
	    datasets: datasets
	  });
	};
	
	var setGraphData = function setGraphData(localData) {
	  return function (makeDataForGraph) {
	    return function (sortData) {
	      return function (makeDataSets) {
	        return (0, _pipe.pipe)(makeDataForGraph, sortData, makeDataSets)(localData);
	      };
	    };
	  };
	};
	
	var getMinMaxYAxis = function getMinMaxYAxis(input) {
	  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'componentResultValue';
	  return input.length && input.reduce(function (a, c) {
	    return {
	      yMin: getSafeValue((0, _get2.default)(c, selector)) < a.yMin ? getSafeValue((0, _get2.default)(c, selector)) : a.yMin,
	      yMax: getSafeValue((0, _get2.default)(c, selector)) > a.yMax ? getSafeValue((0, _get2.default)(c, selector)) : a.yMax
	    };
	  }, { yMin: Number.POSITIVE_INFINITY, yMax: Number.NEGATIVE_INFINITY });
	};
	
	var getNormalRange = function getNormalRange(data) {
	  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '[0].componentResultNormalRange';
	
	  var normalRange = (0, _get2.default)(data, selector, '');
	
	  var _getMinMaxYAxis = getMinMaxYAxis(data),
	      minYAxisValue = _getMinMaxYAxis.yMin,
	      maxYAxisValue = _getMinMaxYAxis.yMax;
	
	  if (normalRange) {
	    if (normalRange.includes('<')) {
	      return {
	        yMax: Number(normalRange.replace('<', '').replace('=', '').replace('OR', '').replace('(', '').replace(')', '')),
	        yMin: minYAxisValue,
	        rawNormalRange: normalRange
	      };
	    }
	
	    if (normalRange.includes('>')) {
	      return {
	        yMin: Number(normalRange.replace('>', '').replace('=', '').replace('OR', '').replace('(', '').replace(')', '')),
	        yMax: maxYAxisValue,
	        rawNormalRange: normalRange
	      };
	    }
	  }
	
	  return normalRange && normalRange.replace('(', '').replace(')', '').replaceAll(',', '.').split('-').sort(function (a, b) {
	    return a - b;
	  }).reduce(function (a, c, i) {
	    return i === 0 ? (0, _extends3.default)({}, a, { yMin: Number(c) }) : (0, _extends3.default)({}, a, { yMax: Number(c) });
	  }, {
	    yMin: 0,
	    yMax: 0,
	    rawNormalRange: normalRange
	  }) || { yMin: 0, ymax: 0, rawNormalRange: normalRange };
	};
	
	var shouldShowRange = exports.shouldShowRange = function shouldShowRange(graphData) {
	  var _getNormalRange2 = getNormalRange(graphData),
	      yMin = _getNormalRange2.yMin,
	      yMax = _getNormalRange2.yMax;
	
	  return (0, _isNumber2.default)(yMin) && (0, _isNumber2.default)(yMax) && yMax !== 0;
	};
	
	var shouldShowGraph = exports.shouldShowGraph = function shouldShowGraph(graphData) {
	  return graphData && graphData.length === 0 ? true : graphData.map(function (gd) {
	    return getSafeValue(gd.componentResultValue);
	  }).find(function (crv) {
	    return !!crv;
	  });
	};
	
	var getDateRangeFromGraphData = function getDateRangeFromGraphData(graphData) {
	  return (0, _sortBy2.default)(graphData.map(function (gd) {
	    return gd.specimenCollectionDate;
	  }).filter(function (scd) {
	    return !!scd;
	  })).reduce(function (a, c) {
	    return (0, _extends3.default)({}, a, {
	      from: (0, _moment2.default)(c).isBefore((0, _moment2.default)(a.from)) ? (0, _moment2.default)(c) : (0, _moment2.default)(a.from),
	      to: (0, _moment2.default)(c).isAfter((0, _moment2.default)(a.to)) ? (0, _moment2.default)(c) : (0, _moment2.default)(a.to)
	    });
	  }, {
	    from: (0, _moment2.default)(new Date(8640000000000000)),
	    to: (0, _moment2.default)(new Date(-8640000000000000))
	  });
	};
	
	var setOptions = exports.setOptions = function setOptions(graphData) {
	  var _getNormalRange3 = getNormalRange(graphData),
	      yMin = _getNormalRange3.yMin,
	      yMax = _getNormalRange3.yMax;
	
	  var _getDateRangeFromGrap = getDateRangeFromGraphData(graphData),
	      from = _getDateRangeFromGrap.from,
	      to = _getDateRangeFromGrap.to;
	
	  var days = calculatePeriod({ from: from, to: to });
	  var period = function (periodDays) {
	    if (periodDays <= 1) {
	      return _constants2.PERIOD.DAY;
	    }
	
	    if (periodDays <= 30) {
	      return _constants2.PERIOD.MONTH;
	    }
	
	    if (periodDays <= 120) {
	      return _constants2.PERIOD.QUARTER;
	    }
	
	    if (periodDays <= 120) {
	      return _constants2.PERIOD.MONTH;
	    }
	
	    if (periodDays <= 365) {
	      return _constants2.PERIOD.YEAR;
	    }
	
	    return _constants2.PERIOD.HIGH;
	  }(days);
	
	  var timeConfig = (0, _get2.default)(_timeline.TIMELINE, period);
	
	  return {
	    legend: {
	      display: false
	    },
	    annotation: yMax !== 0 && yMax !== undefined ? {
	      annotations: [{
	        yMin: yMin,
	        yMax: yMax,
	        type: 'box',
	        borderWidth: 0,
	        borderColor: _styles.COLORS.lightTurquoise,
	        yScaleID: 'y-axis-0',
	        drawTime: 'beforeDatasetsDraw',
	        backgroundColor: _styles.COLORS.lightTurquoise
	      }]
	    } : null,
	    scales: {
	      xAxes: [(0, _extends3.default)({}, (0, _get2.default)(timeConfig, 'scales.xAxes[0]', {}), [_constants2.PERIOD.YEAR, _constants2.PERIOD.QUARTER].includes(period) && {
	        type: 'time',
	        bounds: 'ticks',
	        time: (0, _extends3.default)({}, (0, _get2.default)(timeConfig, 'scales.xAxes[0].time', {}), {
	          round: 'day'
	        })
	      }, _constants2.PERIOD.DAY === period && graphData.length === 1 && {
	        time: (0, _extends3.default)({}, (0, _get2.default)(timeConfig, 'scales.xAxes[0].time', {}), {
	          unit: 'minute'
	        })
	      }, {
	        ticks: {
	          padding: 5,
	          stepSize: 1,
	          fontSize: 13,
	          maxTicksLimit: 7,
	          fontColor: _styles.COLORS.bluePrimary,
	          fontFamily: _styles.FONT_FAMILY.primary,
	          callback: function callback(tick, i, m) {
	            if (i === m.length - 1 && [_constants2.PERIOD.YEAR, _constants2.PERIOD.QUARTER].includes(period)) return '';
	            return tick.toUpperCase();
	          }
	        },
	        gridLines: {
	          display: false
	        },
	        offset: true
	      })],
	      yAxes: [{
	        gridLines: {
	          borderDash: [1, 2],
	          drawBorder: false
	        },
	        position: 'right',
	        ticks: {
	          fontColor: _styles.COLORS.cyanBluishGray,
	          fontFamily: _styles.FONT_FAMILY.primary
	        }
	      }]
	    },
	    tooltips: {
	      displayColors: false,
	      bodyFontColor: _styles.COLORS.black,
	      titleFontStyle: 'bold',
	      titleFontColor: _styles.COLORS.black,
	      backgroundColor: _styles.COLORS.white,
	      callbacks: {
	        label: function label(tooltipItem, data) {
	          return data.datasetsObjects[tooltipItem.index].date.format(_constants.COMPLETE_DATE_FORMAT);
	        },
	
	        labelTextColor: function labelTextColor() {
	          return 'rgba(' + _styles.COLORS.grayDark + ', .75)';
	        },
	        title: function title(tooltipItem, data) {
	          var value = data.datasetsObjects[tooltipItem[0].index].value;
	          var valueUnit = data.datasetsObjects[tooltipItem[0].index].valueUnit;
	
	          var abnormality = data.datasetsObjects[tooltipItem[0].index].abnormalStatus;
	          var surroundedAbnormality = abnormality ? '(' + abnormality + ')' : '';
	          return value + ' ' + valueUnit + ' ' + surroundedAbnormality;
	        }
	      }
	    }
	  };
	};
	
	var setConfig = exports.setConfig = function setConfig(_ref3) {
	  var localData = _ref3.localData,
	      _ref3$shouldRender = _ref3.shouldRender,
	      shouldRender = _ref3$shouldRender === undefined ? false : _ref3$shouldRender;
	  return shouldRender ? {
	    data: setGraphData(localData)(makeDataForGraph)(sortGraphData)(makeDataSets),
	    options: setOptions(localData)
	  } : null;
	};

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _reactRedux = __webpack_require__(6);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(17);
	
	var _styles = __webpack_require__(18);
	
	var _MobileNavbar = __webpack_require__(256);
	
	var _MobileNavbar2 = _interopRequireDefault(_MobileNavbar);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _ContentArea = __webpack_require__(155);
	
	var _ContentArea2 = _interopRequireDefault(_ContentArea);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Drawer = __webpack_require__(253);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _constants2 = __webpack_require__(54);
	
	var _useDataListEntity2 = __webpack_require__(3519);
	
	var _useCheckForAvailableData = __webpack_require__(3537);
	
	var _useActionFilters = __webpack_require__(1156);
	
	var _SinglePointValueModal = __webpack_require__(3461);
	
	var _SinglePointValueModal2 = _interopRequireDefault(_SinglePointValueModal);
	
	var _useFeatureToggleConfig = __webpack_require__(3538);
	
	var _SaturationInfoForm = __webpack_require__(3471);
	
	var _DataListWrapper = __webpack_require__(3503);
	
	var _DataListWrapper2 = _interopRequireDefault(_DataListWrapper);
	
	var _popup = __webpack_require__(76);
	
	var _AddBodyInfoForm = __webpack_require__(3468);
	
	var _props = __webpack_require__(41);
	
	var _AddWeightForm = __webpack_require__(3470);
	
	var _AddHeightForm = __webpack_require__(3469);
	
	var _useTabsData = __webpack_require__(3520);
	
	var _SingleDayGrafModal = __webpack_require__(3522);
	
	var _SingleDayGrafModal2 = _interopRequireDefault(_SingleDayGrafModal);
	
	var _usePageView = __webpack_require__(52);
	
	var _TimeScalableChart = __webpack_require__(3532);
	
	var _TimeScalableChart2 = _interopRequireDefault(_TimeScalableChart);
	
	var _DataHistoricList = __webpack_require__(1157);
	
	var _DataHistoricList2 = _interopRequireDefault(_DataHistoricList);
	
	var _VitalsActivity = __webpack_require__(3535);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _EmptyState = __webpack_require__(3467);
	
	var _AddDataModal = __webpack_require__(3455);
	
	var _AddDataModal2 = _interopRequireDefault(_AddDataModal);
	
	var _Navigation = __webpack_require__(3474);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Chart = __webpack_require__(1773);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3536);
	
	var _index = __webpack_require__(2260);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WEIGHT = _constants2.VITALS_ACTIVITY_TYPE.WEIGHT,
	    SATURATION = _constants2.VITALS_ACTIVITY_TYPE.SATURATION,
	    HEIGHT = _constants2.VITALS_ACTIVITY_TYPE.HEIGHT,
	    BMI = _constants2.VITALS_ACTIVITY_TYPE.BMI,
	    BLOOD_PRESSURE = _constants2.VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE,
	    RESPIRATORY_RATE = _constants2.VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE,
	    BODY_SURFACE_AREA = _constants2.VITALS_ACTIVITY_TYPE.BODY_SURFACE_AREA,
	    BODY_TEMPERATURE = _constants2.VITALS_ACTIVITY_TYPE.BODY_TEMPERATURE;
	var VITALS_AND_ACTIVITY = _constants2.TABS_PATIENT_PORTAL.VITALS_AND_ACTIVITY,
	    MEDICATIONS = _constants2.TABS_PATIENT_PORTAL.MEDICATIONS;
	
	
	function PatientHealthboard(_ref) {
	  var profileTargetUser = _ref.profileTargetUser,
	      profile = _ref.profile,
	      formatMessage = _ref.intl.formatMessage,
	      isProvider = _ref.isProvider,
	      vitalsActivityData = _ref.vitalsActivityData,
	      activeCardType = _ref.activeCardType,
	      setActiveCardType = _ref.setActiveCardType,
	      activeFilter = _ref.activeFilter,
	      setActiveFilter = _ref.setActiveFilter,
	      _ref$drawerVisibility = _ref.drawerVisibility,
	      visible = _ref$drawerVisibility.visible,
	      desktopVisible = _ref$drawerVisibility.desktopVisible,
	      setTargetUserId = _ref.setTargetUserId,
	      deepLinkTab = _ref.deepLinkTab,
	      deepLinkDependentId = _ref.deepLinkDependentId,
	      clearHistoricData = _ref.clearHistoricData,
	      availableCategoriesPending = _ref.availableCategoriesPending,
	      refillsHistory = _ref.refillsHistory;
	
	  (0, _usePageView.usePageView)('Healthboard');
	  (0, _react.useEffect)(function () {
	    if (deepLinkTab && deepLinkDependentId) {
	      setTargetUserId(parseInt(deepLinkDependentId, 10));
	    }
	  }, []);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return (0, _isEmpty2.default)(profileTargetUser) ? profile : profileTargetUser;
	  }, [profileTargetUser, profile]),
	      displayableName = _useMemo.displayableName,
	      id = _useMemo.id,
	      settings = _useMemo.settings;
	
	  var mainUser = id === profile.id;
	
	  var _get = (0, _get3.default)(settings, 'measurementUnitsSettings', {}),
	      height = _get.height,
	      weight = _get.weight,
	      temperature = _get.temperature,
	      glucose = _get.glucose;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isDetailsView = _useState2[0],
	      toggleDetailsView = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      opened = _useState4[0],
	      toggleOpenModal = _useState4[1];
	
	  var isWeightType = WEIGHT === activeCardType;
	  var isHeightType = HEIGHT === activeCardType;
	  var isSaturationType = SATURATION === activeCardType;
	  var isHeightInMeters = height === _constants.HEIGHT_METRIC.METERS;
	  var isWeightInKg = weight === _constants.WEIGHT_METRIC.KG;
	  var isMilligramsPerDeciliter = glucose === _constants.GLUCOSE_METRIC.MG_PER_DECILITER;
	  var isTemperatureInCelsius = temperature === _constants.TEMPERATURE_METRIC.CELSIUS;
	  var isTimeScalableChart = (0, _react.useMemo)(function () {
	    return [BLOOD_PRESSURE, RESPIRATORY_RATE, BODY_SURFACE_AREA, BODY_TEMPERATURE].includes(activeCardType);
	  }, [activeCardType]);
	
	  var _useFeatureToggleConf = (0, _useFeatureToggleConfig.useFeatureToggleConfig)({
	    feature: _constants.FEATURE_TOGGLE_CONFIG.MEDICATION_REFILL,
	    options: { userId: id }
	  }),
	      getFeatureConfig = _useFeatureToggleConf.getFeatureConfig,
	      isFeatureToggleOn = _useFeatureToggleConf.isFeatureToggleOn;
	
	  var isAvailableData = (0, _useCheckForAvailableData.useCheckForAvailableData)(vitalsActivityData, activeCardType);
	
	  var _useTabs = (0, _useTabsData.useTabs)({
	    userId: deepLinkDependentId || id,
	    withVitals: true,
	    isProvider: isProvider,
	    deepLinkTab: deepLinkTab
	  }),
	      tabs = _useTabs.tabs,
	      activeTab = _useTabs.activeTab,
	      setActiveTab = _useTabs.setActiveTab,
	      firstCategory = _useTabs.firstCategory,
	      activeCategory = _useTabs.activeCategory,
	      availableCategories = _useTabs.availableCategories;
	
	  var activeCategoryTitle = (0, _get3.default)(activeCategory, 'title', '');
	
	  var _useDataListEntity = (0, _useDataListEntity2.useDataListEntity)({
	    activeTab: activeTab,
	    setActiveTab: setActiveTab,
	    userId: deepLinkDependentId || id,
	    firstCategoryType: firstCategory.categoryType
	  }),
	      data = _useDataListEntity.data,
	      pending = _useDataListEntity.pending,
	      loadMore = _useDataListEntity.loadMore,
	      withPagination = _useDataListEntity.withPagination,
	      handleSelectTab = _useDataListEntity.handleSelectTab,
	      _useDataListEntity$su = _useDataListEntity.succeed,
	      succeed = _useDataListEntity$su === undefined ? false : _useDataListEntity$su;
	
	  var getDataAction = (0, _useActionFilters.useActionFilters)(activeCardType, false);
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handleBackLogic = function handleBackLogic() {
	    clearHistoricData();
	    toggleDetailsView(false);
	    dispatch(getDataAction.clear());
	  };
	
	  (0, _react.useEffect)(function () {
	    getFeatureConfig();
	  }, [id]);
	
	  var typeWithAddForm = isWeightType || isHeightType || isSaturationType;
	
	  var handleOpenRefillsModal = (0, _react.useCallback)(function (params) {
	    dispatch({
	      type: _popup.consts.SHOW,
	      payload: {
	        contentType: _props.UI_POPUP_TYPES.MEDICATIONS_REFILLS,
	        contentOptions: params
	      }
	    });
	  }, []);
	
	  var mainTitle = (0, _react.useMemo)(function () {
	    switch (activeTab) {
	      case MEDICATIONS:
	        {
	          return _react2.default.createElement(
	            'div',
	            { className: _index2.default.contentTitle },
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.titleLeft },
	              _react2.default.createElement(
	                'div',
	                null,
	                activeCategoryTitle
	              ),
	              refillsHistory.length > 0 && _react2.default.createElement(
	                'div',
	                {
	                  className: _index2.default.refillHistory,
	                  onClick: function onClick() {
	                    return handleOpenRefillsModal({ viewHistory: true });
	                  }
	                },
	                formatMessage({
	                  id: 'patient.portal.refillHistory'
	                })
	              )
	            ),
	            isFeatureToggleOn && _react2.default.createElement(
	              _Button2.default,
	              {
	                color: 'primary',
	                onClick: function onClick() {
	                  return handleOpenRefillsModal({ viewHistory: false });
	                }
	              },
	              formatMessage({ id: 'patient.portal.requestRefills' })
	            )
	          );
	        }
	      default:
	        {
	          return _react2.default.createElement(
	            'div',
	            { className: _index2.default.contentTitle },
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.titleLeft },
	              _react2.default.createElement(
	                'div',
	                null,
	                activeCategoryTitle
	              )
	            )
	          );
	        }
	    }
	  }, [activeCategoryTitle, activeTab, refillsHistory]);
	
	  var handleViewAddDataForm = function handleViewAddDataForm(type, contextMainUser, modalMode) {
	    if (isSaturationType) return _react2.default.createElement(_SaturationInfoForm.SaturationInfoForm, { formatMessage: formatMessage });
	
	    if (contextMainUser) {
	      switch (type) {
	        case WEIGHT:
	          return _react2.default.createElement(_AddWeightForm.AddWeightForm, {
	            formatMessage: formatMessage,
	            modalMode: modalMode,
	            isWeightInKg: isWeightInKg
	          });
	        case HEIGHT:
	          return _react2.default.createElement(_AddHeightForm.AddHeightForm, {
	            formatMessage: formatMessage,
	            handleRedirect: handleBackLogic,
	            isHeightInMeters: isHeightInMeters,
	            modalMode: modalMode
	          });
	        case BMI:
	          return _react2.default.createElement(_AddBodyInfoForm.AddBodyInfoForm, {
	            formatMessage: formatMessage,
	            modalMode: modalMode,
	            isWeightInKg: isWeightInKg,
	            isHeightInMeters: isHeightInMeters
	          });
	      }
	    }
	  };
	
	  if (!availableCategories.length && !availableCategoriesPending) {
	    return _react2.default.createElement(
	      'div',
	      { className: _index2.default.notAvailable },
	      _react2.default.createElement(_Icon2.default, {
	        size: 60,
	        name: 'search-list',
	        className: _index2.default.notAvailableIcon
	      }),
	      _react2.default.createElement(
	        'div',
	        null,
	        formatMessage({ id: 'healthboard.notAvailable' })
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.rootUserContext, !isProvider)) },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.healthboard' }),
	    isDetailsView && _react2.default.createElement(
	      _Popup2.default,
	      {
	        strictClose: true,
	        contentNoPadding: true,
	        opened: opened,
	        onClose: toggleOpenModal,
	        withHeading: false,
	        disableFillBackground: true,
	        mobileFullScreen: false,
	        overflowVisible: true
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.modalRoot },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.modalContent },
	          _react2.default.createElement('div', { className: _index2.default.coverHeader, onClick: handleBackLogic }),
	          _react2.default.createElement(_BackButton2.default, {
	            onBack: handleBackLogic,
	            className: _index2.default.backButton,
	            minWidth: 0
	          }),
	          _react2.default.createElement(_VitalsActivity.VitalsActivity, {
	            formatMessage: formatMessage,
	            isDetailsView: isDetailsView,
	            toggleDetailsView: toggleDetailsView,
	            toggleOpenModal: toggleOpenModal,
	            contextOf: displayableName,
	            activeCardType: activeCardType,
	            setActiveCardType: setActiveCardType,
	            isWeightInKg: isWeightInKg,
	            isHeightInMeters: isHeightInMeters,
	            isTemperatureInCelsius: isTemperatureInCelsius,
	            isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	            mainUser: mainUser,
	            userId: id,
	            hideTitle: false
	          }),
	          isTimeScalableChart && isAvailableData ? _react2.default.createElement(_TimeScalableChart2.default, {
	            activeCardType: activeCardType,
	            isTemperatureInCelsius: isTemperatureInCelsius
	          }) : _react2.default.createElement(
	            _react.Fragment,
	            null,
	            isAvailableData ? _react2.default.createElement(_Chart2.default, {
	              formatMessage: formatMessage,
	              type: activeCardType,
	              activeFilter: activeFilter,
	              setActiveFilter: setActiveFilter,
	              isWeightInKg: isWeightInKg,
	              isHeightInMeters: isHeightInMeters,
	              isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	              mainUser: mainUser
	            }) : _react2.default.createElement(_EmptyState.EmptyState, {
	              formatMessage: formatMessage,
	              type: activeCardType,
	              isProvider: isProvider,
	              mainUser: mainUser,
	              userId: id
	            }),
	            isAvailableData && _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.dataHistoricContentWrapper, (0, _defineProperty3.default)({}, _index2.default.isHeightType, isHeightType))
	              },
	              !isHeightType && _react2.default.createElement(_DataHistoricList2.default, {
	                formatMessage: formatMessage,
	                type: activeCardType,
	                isWeightInKg: isWeightInKg,
	                isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	                userId: id,
	                mainUSer: mainUser
	              }),
	              typeWithAddForm ? handleViewAddDataForm(activeCardType, mainUser) : _react2.default.createElement('div', { className: _index2.default.withOutAddForm })
	            ),
	            _react2.default.createElement(_AddDataModal2.default, {
	              component: handleViewAddDataForm(activeCardType, mainUser, true)
	            })
	          )
	        )
	      )
	    ),
	    !isDetailsView && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_index2.default.navigation) },
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { maxWidth: _styles.BREAKPOINT },
	          function (isMobile) {
	            return _react2.default.createElement(
	              _Drawer2.default,
	              { opened: isMobile ? visible : desktopVisible },
	              _react2.default.createElement(_Navigation2.default, {
	                userId: Number(id),
	                tabs: tabs,
	                handleSelectTab: handleSelectTab,
	                activeTab: activeTab,
	                setTargetUserId: setTargetUserId
	              })
	            );
	          }
	        ),
	        _react2.default.createElement(
	          _ContentArea2.default,
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	              _reactResponsive2.default,
	              { maxWidth: _styles.BREAKPOINT },
	              _react2.default.createElement(_MobileNavbar2.default, { openContext: 'arrow-down' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.patientContent },
	              mainTitle,
	              activeTab === VITALS_AND_ACTIVITY ? _react2.default.createElement(_VitalsActivity.VitalsActivity, {
	                formatMessage: formatMessage,
	                isDetailsView: isDetailsView,
	                toggleOpenModal: toggleOpenModal,
	                toggleDetailsView: toggleDetailsView,
	                contextOf: displayableName,
	                activeCardType: activeCardType,
	                setActiveCardType: setActiveCardType,
	                isWeightInKg: isWeightInKg,
	                isHeightInMeters: isHeightInMeters,
	                isTemperatureInCelsius: isTemperatureInCelsius,
	                isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	                mainUser: mainUser,
	                userId: id,
	                hideTitle: true
	              }) : _react2.default.createElement(_DataListWrapper2.default, {
	                userId: id,
	                data: data,
	                pending: pending,
	                succeed: succeed,
	                loadMore: loadMore,
	                activeTab: activeTab,
	                formatMessage: formatMessage,
	                category: activeCategoryTitle,
	                withPagination: withPagination
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_SingleDayGrafModal2.default, null),
	    _react2.default.createElement(_SinglePointValueModal2.default, null)
	  );
	}
	
	PatientHealthboard.propTypes = {
	  profile: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  isProvider: _propTypes2.default.bool,
	  vitalsActivityData: _propTypes2.default.array,
	  activeCardType: _propTypes2.default.string,
	  setActiveCardType: _propTypes2.default.func,
	  activeFilter: _propTypes2.default.string,
	  setActiveFilter: _propTypes2.default.func,
	  clearHistoricData: _propTypes2.default.func,
	  drawerVisibility: _propTypes2.default.object,
	  setTargetUserId: _propTypes2.default.func,
	  profileTargetUser: _propTypes2.default.object,
	  deepLinkTab: _propTypes2.default.string,
	  deepLinkDependentId: _propTypes2.default.string,
	  availableCategoriesPending: _propTypes2.default.bool,
	  refillsHistory: _propTypes2.default.array
	};
	
	exports.default = (0, _react.memo)((0, _enhance.enhance)(PatientHealthboard));

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PATIENT_INFO_FIELDS = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _patientForm;
	
	exports.usePatientFormState = usePatientFormState;
	exports.usePatientValidation = usePatientValidation;
	exports.validateRequiredFields = validateRequiredFields;
	
	var _react = __webpack_require__(1);
	
	var _lodash = __webpack_require__(58);
	
	var _formFields = __webpack_require__(38);
	
	var _convertErrors = __webpack_require__(496);
	
	var _convertErrors2 = _interopRequireDefault(_convertErrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patientForm = (_patientForm = {}, (0, _defineProperty3.default)(_patientForm, _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, ''), (0, _defineProperty3.default)(_patientForm, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, ''), (0, _defineProperty3.default)(_patientForm, _formFields.PROFILE_FIELDS_TYPES.NAME_SUFFIX, ''), (0, _defineProperty3.default)(_patientForm, _formFields.PROFILE_FIELDS_TYPES.DOB, ''), (0, _defineProperty3.default)(_patientForm, _formFields.PROFILE_FIELDS_TYPES.SSN, ''), (0, _defineProperty3.default)(_patientForm, _formFields.PROFILE_FIELDS_TYPES.LOCAL_UID, ''), _patientForm);
	
	function usePatientFormState() {
	  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : patientForm;
	
	  var _useState = (0, _react.useState)(initialState),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      patientState = _useState2[0],
	      setPatientInfo = _useState2[1];
	
	  function handlePatientFormChange(value) {
	    setPatientInfo((0, _extends3.default)({}, patientState, value));
	  }
	
	  function clearPatientForm() {
	    setPatientInfo((0, _lodash.mapValues)(patientState, function () {
	      return '';
	    }));
	  }
	
	  return { patientState: patientState, handlePatientFormChange: handlePatientFormChange, clearPatientForm: clearPatientForm };
	}
	
	function usePatientValidation(dataValidationErrors) {
	  var _useState3 = (0, _react.useState)({}),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      validateErrors = _useState4[0],
	      setValidateErrors = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    if (dataValidationErrors) {
	      setValidateErrors((0, _convertErrors2.default)(dataValidationErrors));
	    }
	  }, [dataValidationErrors]);
	
	  function clearErrors() {
	    setValidateErrors({});
	  }
	
	  return { validateErrors: validateErrors, clearErrors: clearErrors };
	}
	
	var patientRequiredFields = [_formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, _formFields.PROFILE_FIELDS_TYPES.DOB];
	
	function validateRequiredFields(patientData) {
	  return patientRequiredFields.every(function (type) {
	    return !(0, _lodash.isEmpty)(patientData[type]);
	  });
	}
	
	// use for page validation
	
	var PATIENT_INFO_FIELDS = exports.PATIENT_INFO_FIELDS = [].concat(patientRequiredFields, [_formFields.PROFILE_FIELDS_TYPES.NAME_SUFFIX, _formFields.PROFILE_FIELDS_TYPES.SSN, _formFields.PROFILE_FIELDS_TYPES.LOCAL_UID]);

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.checkErrors = checkErrors;
	
	var _lodash = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkErrors(errors, fields) {
	  var dataErrors = (0, _lodash.get)(errors, 'meta.validationErrors', {});
	  return (0, _keys2.default)(dataErrors).some(function (r) {
	    return fields.includes(r);
	  });
	}

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _autolinker = __webpack_require__(757);
	
	var _autolinker2 = _interopRequireDefault(_autolinker);
	
	var _styles = __webpack_require__(18);
	
	var _ReadMoreBtn = __webpack_require__(1194);
	
	var _ReadMoreBtn2 = _interopRequireDefault(_ReadMoreBtn);
	
	var _sanitizeHtml = __webpack_require__(313);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _index = __webpack_require__(564);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Body = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(Body, _Component);
	
	  function Body() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Body);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Body.__proto__ || (0, _getPrototypeOf2.default)(Body)).call.apply(_ref, [this].concat(args))), _this), _this.capture = null, _this.state = {
	      shortened: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Body, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleCaptureView();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.content !== this.props.content) {
	        this.handleCaptureView();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeoutId);
	    }
	  }, {
	    key: 'handleCaptureView',
	    value: function handleCaptureView() {
	      // hack for mobile layout repainting
	      var self = this;
	
	      this.timeoutId = setTimeout(function () {
	        var capture = self.capture;
	
	        var shortened = capture && capture.offsetHeight > _styles.CAPTURE_MAX_HEIGHT;
	
	        self.setState({ shortened: shortened });
	      }, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var shortened = this.state.shortened;
	      var _props = this.props,
	          content = _props.content,
	          redirect = _props.redirect,
	          disabled = _props.disabled,
	          className = _props.className;
	
	
	      var validContent = content && content !== 'null' ? content : '';
	
	      var style = {
	        maxHeight: redirect && _styles.CAPTURE_MAX_HEIGHT,
	        overflow: 'hidden'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'body', className: className },
	        _react2.default.createElement(
	          'div',
	          { style: style },
	          _react2.default.createElement('div', {
	            styleName: 'body__content',
	            ref: function ref(node) {
	              return _this2.capture = node;
	            },
	            dangerouslySetInnerHTML: {
	              // eslint-disable-line react/no-danger
	              __html: _autolinker2.default.link((0, _sanitizeHtml2.default)(validContent), {
	                className: 'clickable'
	              })
	            }
	          })
	        ),
	        redirect && shortened ? _react2.default.createElement(_ReadMoreBtn2.default, { onClick: redirect, className: 'mt2', disabled: disabled }) : null
	      );
	    }
	  }]);
	  return Body;
	}(_react.Component), _class2.propTypes = {
	  content: _propTypes2.default.string,
	  redirect: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	}, _temp2)) || _class);
	exports.default = Body;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Label = __webpack_require__(1187);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _getModeratorTitle = __webpack_require__(4201);
	
	var _getModeratorTitle2 = _interopRequireDefault(_getModeratorTitle);
	
	var _dateConverters = __webpack_require__(83);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(564);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var author = _ref.author,
	      organization = _ref.organization,
	      publishedAt = _ref.publishedAt,
	      formatMessage = _ref.intl.formatMessage,
	      updated = _ref.updated,
	      isNewPost = _ref.isNewPost,
	      onTitleClick = _ref.onTitleClick;
	
	  var time = publishedAt && (0, _dateConverters.formatDateTime)(publishedAt, formatMessage);
	
	  var moderator = (0, _getModeratorTitle2.default)(author, formatMessage);
	  var provider = (0, _get2.default)(author, 'user.providerRole');
	  var updatedLabel = formatMessage(_strings.COMMUNITY_POST_UPDATED);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'header', className: 'relative' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'header__title' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header__user' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'header__author' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)({ pointer: Boolean(onTitleClick) }),
	              onClick: onTitleClick
	            },
	            (0, _get2.default)(author, 'user.aliasName')
	          ),
	          provider ? _react2.default.createElement(
	            'div',
	            { styleName: 'header__author__secondary' },
	            provider
	          ) : null,
	          moderator ? _react2.default.createElement(
	            'div',
	            { styleName: 'header__author__secondary' },
	            moderator
	          ) : null
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'header__organization' },
	          organization
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'header__time' },
	        _react2.default.createElement(
	          'span',
	          { className: 'mr2' },
	          time
	        ),
	        updated ? ['(', updatedLabel, ')'] : null,
	        isNewPost ? _react2.default.createElement(_Label2.default, {
	          text: formatMessage(_strings.COMMON.new),
	          additionalClass: 'uppercase'
	        }) : null
	      )
	    )
	  );
	};
	
	Header.propTypes = {
	  author: _propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    user: _propTypes2.default.shape({
	      id: _propTypes2.default.number,
	      avatar: _propTypes2.default.objectOf(_propTypes2.default.string),
	      aliasName: _propTypes2.default.string
	    }),
	    role: _propTypes2.default.string
	  }),
	  publishedAt: _propTypes2.default.string,
	  organization: _propTypes2.default.string,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  onTitleClick: _propTypes2.default.func,
	  updated: _propTypes2.default.bool,
	  isNewPost: _propTypes2.default.bool
	};
	
	Header.defaultProps = {
	  author: {},
	  publishedAt: '',
	  organization: '',
	  updated: false,
	  isNewPost: false,
	  onTitleClick: null
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(Header, _index2.default, { allowMultiple: true }));

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntersectionObserver = __webpack_require__(6212);
	
	var _reactIntersectionObserver2 = _interopRequireDefault(_reactIntersectionObserver);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEqual = __webpack_require__(325);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _browserChecker = __webpack_require__(356);
	
	var _index = __webpack_require__(564);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageComponent = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (_temp2 = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ImageComponent, _PureComponent);
	
	  function ImageComponent() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ImageComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ImageComponent.__proto__ || (0, _getPrototypeOf2.default)(ImageComponent)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.state = {
	      image: null,
	      loaded: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ImageComponent, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.mounted = true;
	      this.preloadImage();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var newImageValid = nextProps.image && !(0, _isEqual2.default)((0, _get2.default)(this.props.image, 'url'), (0, _get2.default)(nextProps.image, 'url'));
	
	      if (newImageValid) {
	        this.preloadImage(nextProps);
	      }
	    }
	  }, {
	    key: 'preloadImage',
	    value: function preloadImage(props) {
	      var _ref2 = props || this.props,
	          image = _ref2.image,
	          forceFetch = _ref2.forceFetch;
	
	      var notUseObserver = (0, _browserChecker.isSafari)() && !(0, _mobileHelpers.isDesktop)();
	
	      this.setState({
	        image: null,
	        loaded: false,
	        notUseObserver: notUseObserver
	      });
	
	      var urlImage = (0, _get2.default)(image, 'url');
	      var urlThumb = (0, _get2.default)(image, 'thumbMin');
	      var cb = notUseObserver || forceFetch ? this.loadFullImage : function () {};
	
	      this.preloadUrl(urlThumb, cb);
	    }
	  }, {
	    key: 'preloadUrl',
	    value: function preloadUrl(url, callback) {
	      var _this2 = this;
	
	      var img = new Image();
	
	      img.onload = function () {
	        if (!_this2.mounted) {
	          return;
	        }
	
	        var isNeededImage = _this2.isAppropriateImage(url);
	
	        isNeededImage && _this2.setState({
	          image: url,
	          loaded: !callback
	        }, callback);
	      };
	      img.src = url;
	    }
	  }, {
	    key: 'isAppropriateImage',
	    value: function isAppropriateImage(url) {
	      var image = this.props.image;
	
	
	      var oUrl = (0, _get2.default)(image, 'url');
	      var sUrl = (0, _get2.default)(image, 'thumbMin');
	
	      return [oUrl, sUrl].includes(url);
	    }
	  }, {
	    key: 'loadFullImage',
	    value: function loadFullImage() {
	      this.preloadUrl(this.props.image.url);
	    }
	  }, {
	    key: 'getImage',
	    value: function getImage() {
	      var _state = this.state,
	          image = _state.image,
	          loaded = _state.loaded;
	      var _props = this.props,
	          counter = _props.counter,
	          relative = _props.relative;
	
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement('img', {
	          styleName: (0, _classnames2.default)('lazy-image', {
	            'image--blurred': !loaded,
	            'image--relative': relative
	          }),
	          src: image
	        }),
	        counter && _react2.default.createElement(
	          'div',
	          { styleName: 'image-counter' },
	          '+',
	          counter
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var notUseObserver = this.state.notUseObserver;
	      var _props2 = this.props,
	          forceFetch = _props2.forceFetch,
	          className = _props2.className,
	          onOpen = _props2.onOpen;
	
	      var image = this.getImage();
	
	      if (notUseObserver || forceFetch) return _react2.default.createElement(
	        'div',
	        { styleName: className, onClick: onOpen },
	        image
	      );
	
	      return _react2.default.createElement(
	        _reactIntersectionObserver2.default,
	        {
	          styleName: className,
	          onClick: onOpen,
	          threshold: 0.1,
	          onChange: function onChange(visible) {
	            return visible ? _this3.loadFullImage() : null;
	          }
	        },
	        image
	      );
	    }
	  }]);
	  return ImageComponent;
	}(_react.PureComponent), _class2.propTypes = {
	  image: _propTypes2.default.shape({
	    url: _propTypes2.default.string,
	    thumbMin: _propTypes2.default.string
	  }),
	  dimensions: _propTypes2.default.array,
	  forceFetch: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  onOpen: _propTypes2.default.func,
	  counter: _propTypes2.default.number,
	  relative: _propTypes2.default.bool
	}, _temp2)) || _class);
	exports.default = ImageComponent;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var src = _ref.src;
	
	  var validSrc = src.replace('autoplay=1', 'autoplay=0');
	
	  return _react2.default.createElement('iframe', {
	    width: '100%',
	    height: '100%',
	    src: validSrc,
	    frameBorder: '0',
	    gesture: 'media',
	    allow: 'encrypted-media',
	    allowFullScreen: true
	  });
	}; /* eslint-disable */

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _lodash = __webpack_require__(58);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactImages = __webpack_require__(2782);
	
	var _reactImages2 = _interopRequireDefault(_reactImages);
	
	var _routes = __webpack_require__(37);
	
	var _strings = __webpack_require__(15);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Header = __webpack_require__(1782);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Body = __webpack_require__(1781);
	
	var _Body2 = _interopRequireDefault(_Body);
	
	var _Footer = __webpack_require__(3559);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Image = __webpack_require__(1783);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Video = __webpack_require__(1784);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _UrlPreview = __webpack_require__(1099);
	
	var _UrlPreview2 = _interopRequireDefault(_UrlPreview);
	
	var _IconMenu = __webpack_require__(337);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _EditPost = __webpack_require__(3193);
	
	var _EditPost2 = _interopRequireDefault(_EditPost);
	
	var _chat = __webpack_require__(67);
	
	var _likePost = __webpack_require__(1263);
	
	var _dislikePost = __webpack_require__(1260);
	
	var _reqSocialChannel = __webpack_require__(295);
	
	var _joinPopup = __webpack_require__(519);
	
	var _postsList = __webpack_require__(166);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(93);
	
	var _currentCommunity = __webpack_require__(301);
	
	var _constants = __webpack_require__(17);
	
	var _withPopoverMenu = __webpack_require__(501);
	
	var _withPopoverMenu2 = _interopRequireDefault(_withPopoverMenu);
	
	var _popup = __webpack_require__(76);
	
	var _ids = __webpack_require__(46);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(564);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var READ_AND_POST_WITH_APPROVAL = _constants.COMMUNITIES_ACCESS_LEVELS.READ_AND_POST_WITH_APPROVAL,
	    READ_AND_POST = _constants.COMMUNITIES_ACCESS_LEVELS.READ_AND_POST,
	    READ_ONLY = _constants.COMMUNITIES_ACCESS_LEVELS.READ_ONLY;
	
	
	var createRoute = function createRoute(communityId, postId) {
	  return communityId && postId ? '/' + _routes.COMMUNITIES + '/' + communityId + '/' + _routes.POST + '/' + postId : '';
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    likeRequestPending: state.communities.likePost.sending || state.communities.dislikePost.sending,
	    loggedUserId: (0, _selectors.loggedUserIdSelector)(state),
	    currentCommunityInfo: (0, _currentCommunity.currentCommunityInfoSelector)(state),
	    isLoggedIn: (0, _selectors2.isLoggedInSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  likePost: _likePost.actions.send,
	  dislikePost: _dislikePost.actions.send,
	  createSocialChat: _reqSocialChannel.actions.send,
	  openJoinPopup: _joinPopup.actions.show,
	  removePostNewStatus: _postsList.actions.removeNewPostStatus,
	  showPostReport: _popup.reportActions.post
	};
	
	var PostPreview = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _withPopoverMenu2.default)(_class = (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(PostPreview, _PureComponent);
	
	  function PostPreview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PostPreview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PostPreview.__proto__ || (0, _getPrototypeOf2.default)(PostPreview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      onDeleteRequested: false,
	      lightboxIsOpen: false,
	      currentImageIndex: 0,
	      isForceOpenDeletePopup: false
	    }, _this.debouncedOnDispatch = (0, _lodash.debounce)(function () {
	      var _this$props = _this.props,
	          removePostNewStatus = _this$props.removePostNewStatus,
	          id = _this$props.id;
	
	      removePostNewStatus(id);
	    }, 10000), _this.editPost = null, _this.handleOpenLightbox = function (index) {
	      _this.setState({
	        lightboxIsOpen: true,
	        currentImageIndex: index
	      });
	    }, _this.handleCloseLightbox = function () {
	      _this.setState(function (prevState) {
	        return {
	          lightboxIsOpen: !prevState.lightboxIsOpen
	        };
	      });
	    }, _this.gotoPreviousImage = function (galleryImages) {
	      var currentImageIndex = _this.state.currentImageIndex;
	
	      _this.setState({
	        currentImageIndex: (currentImageIndex + (0, _lodash.size)(galleryImages) - 1) % (0, _lodash.size)(galleryImages)
	      });
	    }, _this.gotoNextImage = function (galleryImages) {
	      var currentImageIndex = _this.state.currentImageIndex;
	
	      _this.setState({
	        currentImageIndex: (currentImageIndex + 1) % (0, _lodash.size)(galleryImages)
	      });
	    }, _this.gotoProfile = function () {
	      return _browserHistory2.default.push(_routes.PUBLIC_PROFILE + '/' + _this.authorId);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PostPreview, [{
	    key: 'componentDidMount',
	    value: function componentDidMount(prevProps) {
	      var isNewPost = this.props.isNewPost;
	
	      if (isNewPost) {
	        this.debouncedOnDispatch();
	      }
	    }
	  }, {
	    key: 'toggleRequestDelete',
	    value: function toggleRequestDelete(flag) {
	      this.setState({
	        onDeleteRequested: flag,
	        isForceOpenDeletePopup: flag
	      });
	    }
	  }, {
	    key: 'onRequestEdit',
	    value: function onRequestEdit() {
	      this.editPost.forceOpen();
	      this.setState({
	        onEditRequested: true
	      });
	    }
	  }, {
	    key: 'handleLike',
	    value: function handleLike() {
	      var _props = this.props,
	          id = _props.id,
	          liked = _props.liked,
	          likePost = _props.likePost,
	          dislikePost = _props.dislikePost,
	          likeRequestPending = _props.likeRequestPending;
	
	      var action = liked ? dislikePost : likePost;
	
	      if (!likeRequestPending) {
	        action({ postId: id });
	      }
	    }
	  }, {
	    key: 'onRequestSendMessage',
	    value: function onRequestSendMessage() {
	      var createSocialChat = this.props.createSocialChat;
	
	      createSocialChat({ participants: [this.authorId] });
	    }
	  }, {
	    key: 'onRequestReport',
	    value: function onRequestReport() {
	      var _props2 = this.props,
	          showPostReport = _props2.showPostReport,
	          id = _props2.id;
	
	      showPostReport(id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          content = _props3.content,
	          author = _props3.author,
	          totalComments = _props3.totalComments,
	          totalLikes = _props3.totalLikes,
	          attachment = _props3.attachment,
	          publishedAt = _props3.publishedAt,
	          organization = _props3.organization,
	          communityId = _props3.communityId,
	          isLink = _props3.isLink,
	          onDelete = _props3.onDelete,
	          onEdit = _props3.onEdit,
	          intl = _props3.intl,
	          updated = _props3.updated,
	          liked = _props3.liked,
	          formatMessage = _props3.intl.formatMessage,
	          loggedUserId = _props3.loggedUserId,
	          isModerator = _props3.isModerator,
	          currentUserRole = _props3.currentUserRole,
	          currentCommunityInfo = _props3.currentCommunityInfo,
	          openJoinPopup = _props3.openJoinPopup,
	          isLoggedIn = _props3.isLoggedIn,
	          isNewPost = _props3.isNewPost,
	          getMenuItems = _props3.getMenuItems,
	          pinned = _props3.pinned;
	      var _state = this.state,
	          onDeleteRequested = _state.onDeleteRequested,
	          currentImageIndex = _state.currentImageIndex,
	          lightboxIsOpen = _state.lightboxIsOpen,
	          isForceOpenDeletePopup = _state.isForceOpenDeletePopup;
	
	      var route = createRoute(communityId, id);
	      var redirect = function redirect() {
	        return _browserHistory2.default.push(route);
	      };
	      var images = (0, _lodash.get)(attachment, 'files');
	      var link = (0, _lodash.get)(attachment, 'urlPreview');
	      var accessLevel = (0, _lodash.get)(currentCommunityInfo, 'accessLevel');
	
	      var isLoggedUserComment = loggedUserId === this.authorId;
	
	      var getMenuOptions = function getMenuOptions() {
	        var options = {
	          removePost: !!currentUserRole && onDelete && _this2.toggleRequestDelete.bind(_this2, true),
	          editPost: !!currentUserRole && accessLevel !== READ_AND_POST_WITH_APPROVAL && onEdit && _this2.onRequestEdit,
	          report: !isLoggedUserComment && _this2.onRequestReport
	        };
	
	        if (_chat.ALLOW_SOCIAL_CHAT_CREATION) {
	          var sendMessageMenuItem = { sendMessage: !!currentUserRole && !isLoggedUserComment && _this2.onRequestSendMessage };
	
	          options = (0, _extends3.default)({}, options, sendMessageMenuItem);
	        }
	
	        return options;
	      };
	
	      var menu = getMenuItems(getMenuOptions());
	
	      var galleryImages = images && images.map(function (image) {
	        return { src: image.url };
	      });
	
	      var previewImages = images && images.slice(0, 4);
	      var fullWidthImg = (0, _lodash.size)(previewImages) !== 2;
	      var counter = (0, _lodash.size)(images) - (0, _lodash.size)(previewImages);
	      var canComment = isModerator || accessLevel !== READ_ONLY;
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: (0, _classnames2.default)('root', { danger: onDeleteRequested }) },
	        !isLoggedIn ? _react2.default.createElement('div', {
	          styleName: 'overlay',
	          onClick: function onClick() {
	            return openJoinPopup({ content: 'join' });
	          }
	        }) : null,
	        menu.length ? _react2.default.createElement(_IconMenu2.default, {
	          id: _ids.IDS.POST.MENU_TRIGGER,
	          position: { horizontal: 'right', vertical: 'bottom' },
	          items: menu,
	          style: {
	            position: 'absolute',
	            top: '8px',
	            right: '16px'
	          },
	          allScreens: true
	        }) : null,
	        pinned && _react2.default.createElement(
	          'div',
	          { styleName: 'header__pinnedStatus' },
	          _react2.default.createElement(_Icon2.default, { name: 'pin', size: 16, style: { fill: _styles.COLORS.blueAccentPlus } }),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'status' },
	            formatMessage({ id: 'community.pinnedPost' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'grid' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'image', className: 'pointer', onClick: this.gotoProfile },
	            _react2.default.createElement(_Avatar2.default, {
	              children: (0, _lodash.get)(author, 'user.aliasName'),
	              size: 40,
	              src: (0, _lodash.get)(author, 'user.avatar.thumbMin')
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'content' },
	            _react2.default.createElement(_Header2.default, (0, _extends3.default)({ author: author, organization: organization, publishedAt: publishedAt, updated: updated, isNewPost: isNewPost }, {
	              onTitleClick: this.gotoProfile
	            }))
	          )
	        ),
	        _react2.default.createElement(_Body2.default, (0, _extends3.default)({ content: content }, {
	          redirect: isLink && redirect,
	          disabled: !currentUserRole
	        })),
	        (0, _lodash.size)(images) ? _react2.default.createElement(
	          'div',
	          { styleName: 'image-grid square portrait' },
	          previewImages.map(function (image, index) {
	            return _react2.default.createElement(_Image2.default, {
	              className: (0, _classnames2.default)('grid-item', {
	                'grid-item--first': fullWidthImg,
	                'grid-item--counter': !!counter
	              }),
	              image: image,
	              counter: index === 3 && counter !== 0 ? counter : null,
	              onOpen: function onOpen() {
	                return _this2.handleOpenLightbox(index);
	              },
	              key: image.index
	            });
	          })
	        ) : null,
	        _react2.default.createElement(_reactImages2.default, {
	          images: galleryImages || [],
	          isOpen: lightboxIsOpen,
	          onClickPrev: function onClickPrev() {
	            return _this2.gotoPreviousImage(galleryImages);
	          },
	          onClickNext: function onClickNext() {
	            return _this2.gotoNextImage(galleryImages);
	          },
	          onClose: this.handleCloseLightbox,
	          currentImage: currentImageIndex,
	          backdropClosesModal: true,
	          showImageCount: false
	        }),
	        (0, _lodash.get)(link, 'url') ? link.video && link.video !== 'null' ? _react2.default.createElement(
	          'div',
	          { styleName: 'videoPreviewContainer' },
	          _react2.default.createElement(_Video2.default, { src: link.video })
	        ) : _react2.default.createElement(
	          'a',
	          {
	            href: link.url,
	            target: 'blank',
	            styleName: 'urlPreviewContainer',
	            className: 'flex mt3 mb3'
	          },
	          _react2.default.createElement(_UrlPreview2.default, (0, _extends3.default)({}, link, { readonly: true }))
	        ) : null,
	        _react2.default.createElement(_Footer2.default, (0, _extends3.default)({ totalComments: totalComments, totalLikes: totalLikes, liked: liked }, {
	          redirect: isLink && redirect,
	          likeAction: this.handleLike,
	          canComment: canComment,
	          currentUserRole: currentUserRole,
	          isLoggedIn: isLoggedIn
	        })),
	        _react2.default.createElement(_ActionConfirmation2.default, {
	          intl: intl,
	          onClose: this.toggleRequestDelete.bind(this, false),
	          onSubmit: onDelete,
	          opened: isForceOpenDeletePopup,
	          title: formatMessage(_strings.COMMUNITY_POST_MENU.deletePost),
	          body: formatMessage(_strings.COMMUNITY_POST_MENU.confirmDeleteMessage),
	          actionButtonText: formatMessage(_strings.COMMUNITY_POST_MENU.deletePost)
	        }),
	        _react2.default.createElement(_EditPost2.default, {
	          intl: intl,
	          onCancel: function onCancel() {
	            return _this2.setState({ onEditRequested: false });
	          },
	          editPost: onEdit,
	          ref: function ref(node) {
	            return _this2.editPost = node;
	          },
	          communityId: communityId,
	          postId: id,
	          content: content,
	          attachment: attachment
	        })
	      );
	    }
	  }, {
	    key: 'authorId',
	    get: function get() {
	      var author = this.props.author;
	
	      return (0, _lodash.get)(author, 'user.id');
	    }
	  }]);
	  return PostPreview;
	}(_react.PureComponent), _class3.propTypes = {
	  id: _propTypes2.default.number,
	  content: _propTypes2.default.string,
	  author: _propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    user: _propTypes2.default.shape({
	      id: _propTypes2.default.number,
	      avatar: _propTypes2.default.objectOf(_propTypes2.default.string),
	      aliasName: _propTypes2.default.string
	    }),
	    role: _propTypes2.default.string
	  }),
	  totalComments: _propTypes2.default.number,
	  totalLikes: _propTypes2.default.number,
	  attachment: _propTypes2.default.shape({
	    file: _propTypes2.default.shape({
	      url: _propTypes2.default.string
	    }),
	    urlPreview: _propTypes2.default.object
	  }),
	  publishedAt: _propTypes2.default.string,
	  organization: _propTypes2.default.string,
	  communityId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  isLink: _propTypes2.default.bool,
	  onDelete: _propTypes2.default.func,
	  onEdit: _propTypes2.default.func,
	  intl: _propTypes2.default.object,
	  updated: _propTypes2.default.bool,
	  likePost: _propTypes2.default.func,
	  dislikePost: _propTypes2.default.func,
	  liked: _propTypes2.default.bool,
	  likeRequestPending: _propTypes2.default.bool,
	  loggedUserId: _propTypes2.default.number,
	  createSocialChat: _propTypes2.default.func,
	  isModerator: _propTypes2.default.bool,
	  currentUserRole: _propTypes2.default.string,
	  currentCommunityInfo: _propTypes2.default.object,
	  isLoggedIn: _propTypes2.default.bool,
	  openJoinPopup: _propTypes2.default.func,
	  getMenuItems: _propTypes2.default.func.isRequired,
	  showPostReport: _propTypes2.default.func,
	  pinned: _propTypes2.default.bool
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'toggleRequestDelete', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleRequestDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRequestEdit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRequestEdit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleLike', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleLike'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRequestSendMessage', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRequestSendMessage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRequestReport', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onRequestReport'), _class2.prototype)), _class2)) || _class) || _class) || _class) || _class);
	exports.default = PostPreview;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get4 = __webpack_require__(4);
	
	var _get5 = _interopRequireDefault(_get4);
	
	var _FieldSetList = __webpack_require__(334);
	
	var _FieldSetList2 = _interopRequireDefault(_FieldSetList);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _EmailConfirmation = __webpack_require__(3572);
	
	var _EmailConfirmation2 = _interopRequireDefault(_EmailConfirmation);
	
	var _MobilePhoneConfirmation = __webpack_require__(3597);
	
	var _MobilePhoneConfirmation2 = _interopRequireDefault(_MobilePhoneConfirmation);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _strings = __webpack_require__(15);
	
	var _styles = __webpack_require__(18);
	
	var _getFieldset = __webpack_require__(611);
	
	var _enhance = __webpack_require__(3565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactInfoSection = function (_PureComponent) {
	  (0, _inherits3.default)(ContactInfoSection, _PureComponent);
	
	  function ContactInfoSection() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ContactInfoSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ContactInfoSection.__proto__ || (0, _getPrototypeOf2.default)(ContactInfoSection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isConfirmationPopupOpened: false,
	      error: null
	    }, _this.getEmailConfirmationStyle = function () {
	      var _this$state$targets = _this.state.targets,
	          email = _this$state$targets.email,
	          phoneNumber = _this$state$targets.phoneNumber;
	
	      if (!email || !phoneNumber || !_this.state.succeedTargets.phone) return {};
	
	      return {
	        borderBottom: '1px solid ' + _styles.COLORS.grayBluish,
	        paddingBottom: 15,
	        marginBottom: 15
	      };
	    }, _this.onCancel = function () {
	      _this.props.clearEmailRequest();
	      _this.props.clearPhoneRequest();
	    }, _this.openPopupConfirmation = function (isOpened) {
	      _this.setState({
	        isConfirmationPopupOpened: isOpened
	      });
	
	      if (!isOpened) _this.props.clearMobilePhoneConfirmation();
	    }, _this.handleConfirmPhone = function (confirmationCode) {
	      var id = _this.props.profile.id;
	
	      _this.props.confirmMobilePhone({ confirmationCode: confirmationCode, id: id });
	    }, _this.handleSave = function (fields) {
	      var previousPhone = _this.state.phoneNumber || _this.props.phoneNumber;
	      var targets = {
	        email: fields.email !== _this.props.email ? fields.email : null,
	        phoneNumber: fields.phoneNumber !== previousPhone ? fields.phoneNumber : null
	      };
	
	      var hasChanges = [targets.email, targets.phoneNumber].some(function (i) {
	        return i;
	      });
	
	      if (hasChanges && _this.props.canEditPatient) {
	        var id = (0, _get5.default)(_this.props.profile, 'primaryPatientProfile.id');
	        var data = (0, _keys2.default)(targets).reduce(function (acc, key) {
	          targets[key] && (acc[key] = targets[key]);
	
	          return acc;
	        }, {});
	
	        _this.props.savePatientByProvider((0, _extends3.default)({}, data, { id: id }));
	      } else if (hasChanges) {
	        var targetUserId = (0, _get5.default)(_this.props.profile, 'id');
	        if (targets.email) {
	          _this.props.updateEmail({
	            email: targets.email,
	            returnUrl: location.href,
	            id: targetUserId
	          });
	        }
	        if (targets.phoneNumber) {
	          _this.props.updateMobilePhone({
	            phoneNumberCountryIsoCode: _this.props.currentCountryCode,
	            phoneNumber: targets.phoneNumber,
	            id: targetUserId
	          });
	        }
	
	        _this.setState({
	          targets: targets
	        });
	      } else {
	        _this.onCancel();
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ContactInfoSection, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var prevConfirmPhoneRequestSending = this.props.confirmMobilePhoneRequest.sending;
	      var _nextProps$confirmMob = nextProps.confirmMobilePhoneRequest,
	          confirmPhoneRequestSending = _nextProps$confirmMob.sending,
	          confirmPhoneRequestSucceed = _nextProps$confirmMob.succeed;
	      var _props = this.props,
	          prevEditMobilePhoneRequest = _props.editMobilePhoneRequest,
	          prevEditEmailRequest = _props.editEmailRequest,
	          profile = _props.profile,
	          clearEmailRequest = _props.clearEmailRequest,
	          clearPhoneRequest = _props.clearPhoneRequest;
	      var editMobilePhoneRequest = nextProps.editMobilePhoneRequest,
	          editEmailRequest = nextProps.editEmailRequest,
	          nextProfile = nextProps.profile;
	
	
	      var emailSuccess = prevEditEmailRequest.sending && !editEmailRequest.sending && editEmailRequest.succeed;
	      var phoneSuccess = prevEditMobilePhoneRequest.sending && !editMobilePhoneRequest.sending && editMobilePhoneRequest.succeed;
	
	      var newState = {};
	
	      if (emailSuccess || phoneSuccess) {
	        newState = {
	          isConfirmationPopupOpened: true,
	          succeedTargets: {
	            email: (0, _get5.default)(this.state, 'succeedTargets.email') || emailSuccess,
	            phone: (0, _get5.default)(this.state, 'succeedTargets.phone') || phoneSuccess
	          }
	        };
	      }
	
	      if (prevConfirmPhoneRequestSending && !confirmPhoneRequestSending && confirmPhoneRequestSucceed) {
	        (0, _assign2.default)(newState, {
	          isConfirmationPopupOpened: false,
	          phoneNumber: this.state.targets.phoneNumber
	        });
	      }
	
	      if ((0, _get5.default)(profile, 'id') !== (0, _get5.default)(nextProfile, 'id')) {
	        clearPhoneRequest();
	        clearEmailRequest();
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          intl = _props2.intl,
	          confirmMobilePhoneRequest = _props2.confirmMobilePhoneRequest,
	          canEdit = _props2.canEdit,
	          canEditPatient = _props2.canEditPatient,
	          formatMessage = _props2.intl.formatMessage;
	      var _state = this.state,
	          isConfirmationPopupOpened = _state.isConfirmationPopupOpened,
	          targets = _state.targets,
	          succeedTargets = _state.succeedTargets;
	      var props = this.props,
	          errors = this.errors;
	
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'contact-info-section' },
	        _react2.default.createElement(_FieldSetList2.default, {
	          disabled: !(canEdit || canEditPatient),
	          fieldSetList: (0, _getFieldset.getFieldsetDescriptor)((0, _extends3.default)({}, props, {
	            errors: errors
	          })),
	          onSave: this.handleSave,
	          onCancelCallback: this.onCancel,
	          canEdit: canEdit
	        }),
	        _react2.default.createElement(
	          _Popup2.default,
	          {
	            opened: isConfirmationPopupOpened,
	            onClose: function onClose() {
	              return _this2.openPopupConfirmation(false);
	            },
	            width: (0, _mobileHelpers.isDesktop)() ? 'small' : 'medium',
	            title: formatMessage(_strings.PROFILE.edit.emailConfirmationTitle)
	          },
	          isConfirmationPopupOpened ? _react2.default.createElement(
	            'section',
	            { styleName: 'confirmation-popup-content' },
	            targets.email && succeedTargets.email ? _react2.default.createElement(_EmailConfirmation2.default, {
	              email: targets.email,
	              showClose: !targets.phoneNumber || !succeedTargets.phone,
	              onClose: function onClose() {
	                return _this2.openPopupConfirmation(false);
	              },
	              style: this.getEmailConfirmationStyle(),
	              formatMessage: formatMessage
	            }) : null,
	            targets.phoneNumber && succeedTargets.phone ? _react2.default.createElement(_MobilePhoneConfirmation2.default, {
	              phone: targets.phoneNumber,
	              onConfirm: this.handleConfirmPhone,
	              onCancel: function onCancel() {
	                return _this2.openPopupConfirmation(false);
	              },
	              error: confirmMobilePhoneRequest.error,
	              intl: intl
	            }) : null
	          ) : null
	        )
	      );
	    }
	  }, {
	    key: 'errors',
	    get: function get() {
	      var _props3 = this.props,
	          editMobilePhoneRequest = _props3.editMobilePhoneRequest,
	          editEmailRequest = _props3.editEmailRequest,
	          formatMessage = _props3.intl.formatMessage;
	
	      var errors = [];
	
	      if (editEmailRequest.rejected) {
	        var _get2 = (0, _get5.default)(editEmailRequest, 'error.meta.validationErrors.email[0]', {}),
	            code = _get2.code;
	
	        var emailErrorMsgId = code ? _strings.PROFILE.errors.email[code] : _strings.COMMON_ERROR_MESSAGES.error;
	        errors.push(formatMessage(emailErrorMsgId));
	      }
	
	      if (editMobilePhoneRequest.rejected) {
	        var _get3 = (0, _get5.default)(editMobilePhoneRequest, 'error.meta.validationErrors.phoneNumber[0]', {}),
	            _code = _get3.code;
	
	        var phoneErrorMsgId = _code ? _strings.PROFILE.errors.phoneNumber[_code] : _strings.COMMON_ERROR_MESSAGES.error;
	        errors.push(formatMessage(phoneErrorMsgId));
	      }
	
	      return errors;
	    }
	  }]);
	  return ContactInfoSection;
	}(_react.PureComponent);
	
	var ReqType = _propTypes2.default.shape({
	  error: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  sending: _propTypes2.default.bool,
	  succeed: _propTypes2.default.bool,
	  rejected: _propTypes2.default.bool
	});
	
	ContactInfoSection.propTypes = {
	  email: _propTypes2.default.string,
	  phoneNumber: _propTypes2.default.string,
	  updateEmail: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  updateMobilePhone: _propTypes2.default.func,
	  confirmMobilePhone: _propTypes2.default.func,
	  clearMobilePhoneConfirmation: _propTypes2.default.func,
	  confirmMobilePhoneRequest: ReqType,
	  editMobilePhoneRequest: ReqType,
	  editEmailRequest: ReqType,
	  clearEmailRequest: _propTypes2.default.func,
	  clearPhoneRequest: _propTypes2.default.func,
	  canEdit: _propTypes2.default.bool,
	  canEditPatient: _propTypes2.default.bool,
	  savePatientByProvider: _propTypes2.default.func,
	  currentCountryCode: _propTypes2.default.string,
	  profile: _propTypes2.default.shape({
	    primaryProviderProfile: _propTypes2.default.shape({
	      id: _propTypes2.default.number
	    })
	  })
	};
	
	ContactInfoSection.contextTypes = {
	  intl: _propTypes2.default.object
	};
	
	exports.default = (0, _enhance.enhance)(ContactInfoSection);

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConversationBtn = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reqSocialChannel = __webpack_require__(295);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _strings = __webpack_require__(15);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConversationBtnImpl = function ConversationBtnImpl(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      userId = _ref.userId;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var handleStartConversation = (0, _react.useCallback)(function () {
	    dispatch(_reqSocialChannel.actions.send({ participants: [userId] }));
	  }, [userId]);
	
	  return _react2.default.createElement(
	    _Button2.default,
	    {
	      raised: true,
	      type: 'button',
	      onClick: handleStartConversation,
	      color: 'primary',
	      className: !(0, _mobileHelpers.isDesktop)() ? 'mt3' : null
	    },
	    formatMessage(_strings.ACTIONS.chat.sendMessage)
	  );
	};
	
	var propTypes = {
	  userId: _propTypes2.default.number.isRequired
	};
	
	var ConversationBtn = exports.ConversationBtn = (0, _recompose.compose)(_reactIntl.injectIntl)(ConversationBtnImpl);
	
	ConversationBtnImpl.propTypes = (0, _extends3.default)({}, propTypes);
	ConversationBtn.propTypes = propTypes;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _isPlainObject = __webpack_require__(248);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _snakeCase = __webpack_require__(467);
	
	var _snakeCase2 = _interopRequireDefault(_snakeCase);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _cloneDeep = __webpack_require__(2346);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	var _includes = __webpack_require__(324);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _isArray = __webpack_require__(96);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isEqual = __webpack_require__(325);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _differenceWith = __webpack_require__(5499);
	
	var _differenceWith2 = _interopRequireDefault(_differenceWith);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EditBtn = __webpack_require__(393);
	
	var _EditBtn2 = _interopRequireDefault(_EditBtn);
	
	var _Field = __webpack_require__(778);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _strings = __webpack_require__(15);
	
	var _validations = __webpack_require__(362);
	
	var _constants = __webpack_require__(17);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_EMPTY_VALUE = '-';
	
	var Fieldset = function (_PureComponent) {
	  (0, _inherits3.default)(Fieldset, _PureComponent);
	
	  function Fieldset(props) {
	    (0, _classCallCheck3.default)(this, Fieldset);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Fieldset.__proto__ || (0, _getPrototypeOf2.default)(Fieldset)).call(this, props));
	
	    _this.toggleEditMode = function () {
	      var edit = _this.state.edit;
	      var _this$props = _this.props,
	          onEditModeChange = _this$props.onEditModeChange,
	          onCancelCallback = _this$props.onCancelCallback;
	
	
	      if (edit && onCancelCallback) {
	        // toggle to read mode
	        onCancelCallback();
	      }
	      _this.setState({ edit: !edit });
	
	      if (onEditModeChange) {
	        onEditModeChange(!edit);
	      }
	    };
	
	    _this.isComplexValue = function (type, value) {
	      if ((0, _includes2.default)((0, _extends3.default)({}, _constants.FIELDS_TYPE, { MEDICATION_SELECT: 'medication' }), type)) {
	        return false;
	      }
	
	      return (0, _isArray2.default)(value) && (0, _isPlainObject2.default)(value[0]);
	    };
	
	    _this.hasValue = function (value) {
	      return value && value.length > 0;
	    };
	
	    _this.handleFields = function (prev, id, index, array) {
	      var _this$props2 = _this.props,
	          fieldSetDisabled = _this$props2.disabled,
	          canEdit = _this$props2.canEdit;
	      var edit = _this.state.edit;
	      var _array$index = array[index],
	          fieldValue = _array$index.value,
	          src = _array$index.src,
	          fieldName = _array$index.fieldName,
	          mode = _array$index.mode,
	          hidden = _array$index.hidden,
	          type = _array$index.type;
	
	
	      var isViewMode = fieldSetDisabled ? true : !edit;
	      var currentMode = !edit ? 'view' : 'edit';
	
	      var isComplexField = _this.isComplexValue(type, fieldValue);
	      var isMultipleFields = (0, _isArray2.default)(array[index]);
	
	      var empty = canEdit ? false : !_this.hasValue(fieldValue || src);
	
	      var simpleEmptyField = !isComplexField && empty;
	      var complexEmptyField = isComplexField && !_this.isNotEmpty(fieldValue);
	
	      // Support only view or edit mode. Use mode: 'view' or 'edit in field config
	      if (mode && mode !== currentMode || hidden) {
	        return prev;
	      }
	      // skip field in view mode if it hasn't any value
	      // and isn't required for view
	
	      if (isMultipleFields) {
	        prev.push(_react2.default.createElement(
	          'div',
	          { key: 'multiple-' + index, styleName: 'flexRow' },
	          array[index].map(function (item) {
	            return _react2.default.createElement(_Field2.default, {
	              className: item.name,
	              key: item.name,
	              children: item,
	              editMode: edit,
	              defaultEmptyValue: canEdit ? DEFAULT_EMPTY_VALUE : null
	            });
	          })
	        ));
	      } else if (!(isViewMode && (simpleEmptyField || complexEmptyField))) {
	        // for one complex item in view mode (eg User Name)
	        // there should be several items in edit mode (eg First/Last/Middle Name)
	        if (edit && isComplexField) {
	          // field's value-object to view is represented with array of values-objects to edit
	          fieldValue.forEach(function (item, i) {
	            prev.push(_react2.default.createElement(_Field2.default, {
	              fullWidth: item.fullWidth,
	              className: item.fieldName,
	              key: 'field-complex-' + i,
	              children: item,
	              editMode: edit,
	              onChange: function onChange(value, isDirty) {
	                for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	                  rest[_key - 2] = arguments[_key];
	                }
	
	                return _this.handleChange.apply(_this, [item.fieldName, value, isDirty].concat(rest));
	              },
	              onBlur: function onBlur() {
	                return _this.handleChange(item.fieldName, null, true);
	              },
	              defaultEmptyValue: canEdit ? DEFAULT_EMPTY_VALUE : null
	            }));
	          });
	        } else {
	          // in all other cases (view and edit mode for non complex values)
	          // there should be only one item
	          prev.push(_react2.default.createElement(_Field2.default, {
	            className: fieldName,
	            key: 'field-' + index,
	            children: array[index],
	            editMode: edit,
	            onChange: function onChange(value, isDirty, localErrors) {
	              return _this.handleChange(fieldName, value, isDirty, localErrors);
	            },
	            onBlur: function onBlur(value, isDirty, localErrors) {
	              _this.handleChange(fieldName, null, true, localErrors);
	            },
	            defaultEmptyValue: canEdit ? DEFAULT_EMPTY_VALUE : null
	          }));
	        }
	      }
	
	      return prev;
	    };
	
	    _this.handleChange = function (key, val, isDirty, localErrors) {
	      var _this$state = _this.state,
	          fields = _this$state.fields,
	          validationErrors = _this$state.validationErrors;
	
	      var state = (0, _extends3.default)({}, _this.state);
	      var value = _this.getValue(val);
	      var field = _this.getField(fields, key);
	
	      if (validationErrors) {
	        state.validationErrors = null;
	      }
	
	      if (field) {
	        // We pass on blur value=null, so we can do validation but don't need to change value again
	        if (value !== null) {
	          field.value = value;
	        }
	
	        if (field.validationRules && isDirty || field.type === _constants.FIELDS_TYPE.CUSTOM_TIME_PICKER || field.type === _constants.FIELDS_TYPE.DATE) {
	          var errors = _this.validateField(field);
	
	          if (errors) {
	            state.errors = (0, _assign2.default)({}, state.errors, (0, _defineProperty3.default)({}, field.fieldName, errors));
	          } else if (localErrors) {
	            state.errors = (0, _assign2.default)({}, state.errors, (0, _defineProperty3.default)({}, field.fieldName, localErrors));
	          } else {
	            delete state.errors[field.fieldName];
	            state.errors = (0, _extends3.default)({}, state.errors);
	          }
	        }
	
	        _this.setState(state);
	      }
	    };
	
	    _this.getField = function (fields, key) {
	      var field = void 0;
	
	      fields.forEach(function (item) {
	        if (item && (0, _isArray2.default)(item.value)) {
	          var nestedField = _this.getField(item.value, key);
	          if (nestedField) {
	            field = nestedField;
	          }
	        }
	
	        if (item && item.fieldName === key) {
	          field = item;
	        }
	      });
	
	      return field;
	    };
	
	    _this.getValue = function (val) {
	      if ((0, _isArray2.default)(val)) {
	        return val.map(function (item) {
	          return item.value;
	        });
	      }
	
	      if (val instanceof Object) {
	        if (val.nativeEvent instanceof Event) {
	          return null;
	        }
	
	        return val.value || val;
	      }
	      return val;
	    };
	
	    _this.isNotEmpty = function (nextFields) {
	      var fieldset = _this.props.fieldset;
	
	
	      var fields = nextFields || fieldset.fields;
	
	      return fields.some(function (member) {
	        var fieldValue = member.value || member.src;
	
	        // check if complex value's fields are empty too
	        // value = [ {value: '' || null || undefined}, ...] => false
	
	        if (_this.isComplexValue(member)) {
	          return member.some(function (item) {
	            return Boolean(item.value);
	          });
	        }
	
	        if (_this.isComplexValue(fieldValue)) {
	          return fieldValue.some(function (item) {
	            return Boolean(item.value);
	          }) && !member.hidden;
	        }
	        return Boolean(fieldValue) && !member.hidden;
	      });
	    };
	
	    _this.updateSaveValues = function (fields) {
	      return fields.map(function (item) {
	        var fieldName = item.fieldName,
	            value = item.value;
	        // if backend needed only ids
	
	        if (fieldName && fieldName.includes('Ids')) {
	          var updatedValues = value.map(function (valueItem) {
	            return valueItem.id;
	          });
	          return (0, _extends3.default)({}, item, { value: updatedValues });
	        }
	        return item;
	      });
	    };
	
	    _this.handleSaveButtonClick = function () {
	      var _this$state2 = _this.state,
	          fields = _this$state2.fields,
	          edit = _this$state2.edit;
	      var _this$props3 = _this.props,
	          onSave = _this$props3.onSave,
	          fieldset = _this$props3.fieldset,
	          onEditModeChange = _this$props3.onEditModeChange;
	
	
	      _this.setState({
	        initialFields: (0, _cloneDeep2.default)(fields),
	        edit: !edit
	      });
	
	      onSave(_this.updateSaveValues(fields), fieldset.type);
	
	      if (onEditModeChange) {
	        onEditModeChange(false);
	      }
	    };
	
	    _this.handleCancelButtonClick = function () {
	      var _this$state3 = _this.state,
	          initialFields = _this$state3.initialFields,
	          edit = _this$state3.edit;
	      var onCancelCallback = _this.props.onCancelCallback;
	
	
	      _this.setState({
	        errors: [],
	        fields: (0, _cloneDeep2.default)(initialFields),
	        edit: !edit
	      });
	
	      if (onCancelCallback) onCancelCallback();
	    };
	
	    _this.validateField = function (field) {
	      var formatMessage = _this.props.intl.formatMessage;
	      var validationRules = field.validationRules,
	          value = field.value;
	
	      var validationRulesKeys = (0, _keys2.default)(validationRules);
	
	      if (!validationRulesKeys.length) return null;
	
	      var errorMessages = validationRulesKeys.reduce(function (errors, rule) {
	        var error = (0, _validations.validateWithRule)(rule, validationRules[rule], value, formatMessage);
	
	        if (error) errors.push(error);
	
	        return errors;
	      }, []);
	
	      return errorMessages.length ? errorMessages : null;
	    };
	
	    _this.getErrors = function () {
	      var errors = _this.state.errors;
	
	
	      var errorKeys = (0, _keys2.default)(errors);
	
	      return errorKeys.length && errorKeys.reduce(function (error, item) {
	        return error.concat(errors[item]);
	      }, []);
	    };
	
	    _this.isErrored = function () {
	      var errors = _this.state.errors;
	
	
	      return !!(0, _keys2.default)(errors).length;
	    };
	
	    _this.state = {
	      edit: false,
	      empty: !_this.isNotEmpty(props.fieldset.fields),
	      fields: props.fieldset.fields,
	      initialFields: (0, _cloneDeep2.default)(props.fieldset.fields),
	      errors: {},
	      validationErrors: props.fieldset.errors || null
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Fieldset, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _nextProps$fieldset = nextProps.fieldset,
	          fields = _nextProps$fieldset.fields,
	          validationErrors = _nextProps$fieldset.errors;
	      var initialFields = this.state.initialFields;
	
	
	      if (validationErrors) {
	        this.setState({ validationErrors: validationErrors });
	      }
	
	      if ((0, _isEmpty2.default)((0, _differenceWith2.default)(fields, initialFields, _isEqual2.default))) return;
	
	      var empty = !this.isNotEmpty(fields);
	
	      var state = {
	        empty: empty,
	        fields: fields,
	        initialFields: (0, _cloneDeep2.default)(fields)
	      };
	
	      this.setState(state);
	    }
	
	    // helper for edit view - defines whether value is described with multiple data objects
	
	
	    // helper for correct layout items number shown in view/edit mode
	
	
	    // check if all of the fields inside current fieldset has no values
	    // if at least one field has value => true
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          fieldset = _props.fieldset,
	          disabled = _props.disabled;
	      var _state = this.state,
	          fields = _state.fields,
	          edit = _state.edit,
	          empty = _state.empty,
	          validationErrors = _state.validationErrors;
	
	
	      var fieldSetClass = 'user-profile-fieldset-' + (0, _snakeCase2.default)(fieldset.title);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          styleName: (0, _classnames2.default)('fieldset', {
	            'fieldset--filled': fieldset.fill
	          }),
	          className: (0, _classnames2.default)(fieldSetClass, {
	            tl: edit
	          })
	        },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'fieldsetTitleWrapper' },
	          _react2.default.createElement(
	            'h3',
	            {
	              styleName: (0, _classnames2.default)('sectionTitle', {
	                'sectionTitle--danger': fieldset.dangered
	              }),
	              className: 'user-profile-fieldset-title'
	            },
	            fieldset.title
	          ),
	          !disabled && _react2.default.createElement(
	            'div',
	            {
	              styleName: 'fieldsetAction',
	              className: 'user-profile-edit-button'
	            },
	            _react2.default.createElement(_EditBtn2.default, { onClick: function onClick() {
	                return _this2.toggleEditMode();
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            styleName: (0, _classnames2.default)('fieldsetContent', {
	              'fieldsetContent--withColumns': fieldset.columns
	            })
	          },
	          empty && disabled ? _react2.default.createElement(
	            'p',
	            { styleName: 'fieldsetContent__empty', className: 'o-70' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.emptySection)
	          ) : fields && fields.reduce(this.handleFields, [])
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'user-profile-errors' },
	          edit && this.isErrored() && _react2.default.createElement(_ErrorBlock2.default, {
	            errors: this.getErrors(),
	            className: 'mt3',
	            style: { marginRight: 16 }
	          }),
	          validationErrors && validationErrors.length > 0 && _react2.default.createElement(_ErrorBlock2.default, {
	            errors: validationErrors,
	            className: 'mt3',
	            style: { marginRight: 16 }
	          })
	        ),
	        edit && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'mt3 mr2 user-profile-save-button',
	              raised: true,
	              color: 'primary',
	              onClick: function onClick() {
	                return _this2.handleSaveButtonClick();
	              },
	              disabled: this.isErrored()
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.save)
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'mt3 user-profile-cancel-button',
	              raised: true,
	              color: 'accent',
	              onClick: function onClick() {
	                return _this2.handleCancelButtonClick();
	              }
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.cancel)
	          )
	        )
	      );
	    }
	  }]);
	  return Fieldset;
	}(_react.PureComponent);
	
	Fieldset.propTypes = {
	  fieldset: _propTypes2.default.object,
	  onSave: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  onCancelCallback: _propTypes2.default.func,
	  intl: _propTypes2.default.object,
	  canEdit: _propTypes2.default.bool,
	  onEditModeChange: _propTypes2.default.func
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(Fieldset);

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HomeAddressFormSection = HomeAddressFormSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _HomeAddressRowModeView = __webpack_require__(3582);
	
	var _HomeAddressColumnModeView = __webpack_require__(3581);
	
	var _getPhone = __webpack_require__(187);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HomeAddressFormSection(_ref) {
	  var targetCountryEntity = _ref.targetCountryEntity,
	      formatMessage = _ref.formatMessage,
	      postalCode = _ref.postalCode,
	      address1 = _ref.address1,
	      address2 = _ref.address2,
	      city = _ref.city,
	      state = _ref.state,
	      country = _ref.country,
	      homePhone = _ref.homePhone,
	      onChange = _ref.onChange,
	      onCountryChange = _ref.onCountryChange,
	      countryList = _ref.countryList,
	      validateErrors = _ref.validateErrors,
	      isZipApplicable = _ref.isZipApplicable,
	      statesList = _ref.statesList,
	      zipLimit = _ref.zipLimit,
	      _ref$rowMode = _ref.rowMode,
	      rowMode = _ref$rowMode === undefined ? false : _ref$rowMode,
	      isDisabled = _ref.isDisabled,
	      zipExamples = _ref.zipExamples,
	      homePhoneRequired = _ref.homePhoneRequired,
	      cityRequired = _ref.cityRequired,
	      address1Required = _ref.address1Required,
	      isAppointmentPatientForm = _ref.isAppointmentPatientForm,
	      isFormSubmitted = _ref.isFormSubmitted;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, onChange);
	  var handleCountryChange = (0, _react.useMemo)(function () {
	    return function (data) {
	      if (!data) return;
	      if (country === data || country === data.label) {
	        onCountryChange(data);
	        return;
	      }
	      onCountryChange(data);
	    };
	  }, [country, targetCountryEntity, address1, address2, city, homePhone]);
	
	  var upperCasedPostalCode = postalCode ? postalCode.toUpperCase() : postalCode;
	
	  return rowMode ? _react2.default.createElement(_HomeAddressRowModeView.HomeAddressRowModeView, {
	    zipLimit: zipLimit,
	    validateErrors: validateErrors,
	    statesList: statesList,
	    onCountryChange: onCountryChange,
	    countryList: countryList,
	    onChange: onChange,
	    makeProfileField: makeProfileField,
	    address1: address1,
	    address2: address2,
	    city: city,
	    country: country,
	    handleCountryChange: handleCountryChange,
	    homePhone: (0, _getPhone.getPhoneWithoutUSCode)(homePhone),
	    isZipApplicable: isZipApplicable,
	    postalCode: upperCasedPostalCode,
	    state: state,
	    targetCountryEntity: targetCountryEntity,
	    isDisabled: isDisabled,
	    formatMessage: formatMessage,
	    zipExamples: zipExamples,
	    homePhoneRequired: homePhoneRequired,
	    cityRequired: cityRequired,
	    address1Required: address1Required,
	    isAppointmentPatientForm: isAppointmentPatientForm,
	    isFormSubmitted: isFormSubmitted
	  }) : _react2.default.createElement(_HomeAddressColumnModeView.HomeAddressColumnModeView, {
	    zipLimit: zipLimit,
	    validateErrors: validateErrors,
	    statesList: statesList,
	    onCountryChange: onCountryChange,
	    countryList: countryList,
	    onChange: onChange,
	    makeProfileField: makeProfileField,
	    address1: address1,
	    address2: address2,
	    city: city,
	    country: country,
	    handleCountryChange: handleCountryChange,
	    homePhone: homePhone,
	    isZipApplicable: isZipApplicable,
	    postalCode: upperCasedPostalCode,
	    state: state,
	    targetCountryEntity: targetCountryEntity,
	    isDisabled: isDisabled,
	    formatMessage: formatMessage,
	    zipExamples: zipExamples,
	    isAppointmentPatientForm: isAppointmentPatientForm
	  });
	}
	
	HomeAddressFormSection.propTypes = {
	  formatMessage: PropTypes.func,
	  postalCode: PropTypes.string,
	  address1: PropTypes.string,
	  address2: PropTypes.string,
	  city: PropTypes.string,
	  state: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	  country: PropTypes.object,
	  homePhone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  onChange: PropTypes.func,
	  statesList: PropTypes.array,
	  countryList: PropTypes.array,
	  zipLimit: PropTypes.number,
	  onCountryChange: PropTypes.func,
	  isZipApplicable: PropTypes.bool,
	  validateErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	  targetCountryEntity: PropTypes.object,
	  rowMode: PropTypes.bool,
	  isDisabled: PropTypes.func,
	  zipExamples: PropTypes.string,
	  homePhoneRequired: PropTypes.bool,
	  cityRequired: PropTypes.bool,
	  address1Required: PropTypes.bool,
	  isAppointmentPatientForm: PropTypes.bool,
	  isFormSubmitted: PropTypes.bool
	};

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.HomeAddress = HomeAddress;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _countryDetails = __webpack_require__(527);
	
	var _selectors = __webpack_require__(56);
	
	var _useCountrySelect2 = __webpack_require__(145);
	
	var _strings = __webpack_require__(15);
	
	var _useLoggedUserCountry = __webpack_require__(1104);
	
	var _EditBtn = __webpack_require__(393);
	
	var _EditBtn2 = _interopRequireDefault(_EditBtn);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _getFieldsHomeAddressSection = __webpack_require__(3583);
	
	var _HomeAddressFormSection = __webpack_require__(1789);
	
	var _useHomeAddressFormState = __webpack_require__(3584);
	
	var _utils = __webpack_require__(233);
	
	var _styles = __webpack_require__(5078);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HomeAddress(_ref) {
	  var formatMessage = _ref.formatMessage,
	      canEdit = _ref.canEdit,
	      profile = _ref.profile,
	      countryList = _ref.countryList,
	      saveUser = _ref.saveUser,
	      isSucceedUpdate = _ref.isSucceedUpdate;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isEdit = _useState2[0],
	      toggleEdit = _useState2[1];
	
	  var _useCountrySelect = (0, _useCountrySelect2.useCountrySelect)(formatMessage),
	      stateList = _useCountrySelect.stateList,
	      zipLimit = _useCountrySelect.zipLimit,
	      isZipApplicable = _useCountrySelect.isZipApplicable,
	      zipExamples = _useCountrySelect.zipExamples;
	
	  var errors = (0, _reactRedux.useSelector)(_selectors.selectEditedUserErrors);
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var fields = (0, _getFieldsHomeAddressSection.getFieldsHomeAddressSection)(formatMessage, profile);
	
	  var targetCountryEntity = (0, _useLoggedUserCountry.useLoggedUserCountry)();
	
	  (0, _react.useEffect)(function () {
	    if (targetCountryEntity) dispatch(_countryDetails.actions.send({ code: targetCountryEntity.value }));
	  }, [targetCountryEntity]);
	
	  (0, _react.useEffect)(function () {
	    if (isEdit) toggleEdit(!isSucceedUpdate);
	  }, [isSucceedUpdate]);
	
	  var _useHomeAddressFormSt = (0, _useHomeAddressFormState.useHomeAddressFormState)((0, _utils.makeInitialValue)(profile, countryList, stateList), errors),
	      handleFormChange = _useHomeAddressFormSt.handleFormChange,
	      validateErrors = _useHomeAddressFormSt.validateErrors,
	      setCountryValue = _useHomeAddressFormSt.setCountryValue,
	      clearErrors = _useHomeAddressFormSt.clearErrors,
	      formState = _useHomeAddressFormSt.formState,
	      isValid = _useHomeAddressFormSt.isValid;
	
	  var homePhoneValue = formState[_formFields.PROFILE_FIELDS_TYPES.HOME_PHONE];
	
	  var onCountryChange = function onCountryChange(data) {
	    clearErrors();
	    dispatch(_countryDetails.actions.send({ code: data.value }));
	    setCountryValue(data);
	  };
	
	  var isHomePhoneValid = homePhoneValue ? homePhoneValue.length >= 8 : true;
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	
	    var fullCountryName = (0, _get2.default)(formState, 'country.label', '');
	    var fullStateName = (0, _get2.default)(formState, 'state.label', '');
	
	    clearErrors();
	
	    saveUser((0, _extends3.default)({}, formState, {
	      country: fullCountryName,
	      state: fullStateName,
	      id: profile.id
	    }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.titleWrapper },
	      _react2.default.createElement(
	        'h3',
	        { className: _styles2.default.title },
	        formatMessage({ id: 'profile.section.address' })
	      ),
	      canEdit && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.editButton },
	        _react2.default.createElement(_EditBtn2.default, {
	          onClick: function onClick() {
	            handleFormChange((0, _utils.makeInitialValue)(profile, countryList, stateList));
	            toggleEdit(!isEdit);
	          }
	        })
	      )
	    ),
	    isEdit && _react2.default.createElement(_HomeAddressFormSection.HomeAddressFormSection, (0, _extends3.default)({}, formState, {
	      formatMessage: formatMessage,
	      profile: profile,
	      onChange: handleFormChange,
	      isZipApplicable: isZipApplicable,
	      onCountryChange: onCountryChange,
	      statesList: stateList,
	      countryList: countryList,
	      validateErrors: validateErrors,
	      zipLimit: zipLimit,
	      zipExamples: zipExamples,
	      targetCountryEntity: targetCountryEntity
	    })),
	    !isEdit && _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_styles2.default.fieldsetContent, _styles2.default.withColumns) },
	      fields && fields.map(function (_ref2) {
	        var id = _ref2.id,
	            value = _ref2.value,
	            name = _ref2.name;
	        return _react2.default.createElement(
	          'div',
	          { className: _styles2.default.fieldWrapper, key: id },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.titleEntity },
	            name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.contentEntity },
	            value || '-'
	          )
	        );
	      })
	    ),
	    isEdit && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'mt3 mr2 user-profile-save-button',
	          raised: true,
	          color: 'primary',
	          onClick: handleSubmit,
	          disabled: !isValid || !isHomePhoneValid
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.save)
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'mt3 user-profile-cancel-button',
	          raised: true,
	          color: 'accent',
	          onClick: function onClick() {
	            clearErrors();
	            handleFormChange((0, _utils.makeInitialValue)(profile, countryList, stateList));
	            toggleEdit(false);
	          }
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.cancel)
	      )
	    )
	  );
	}
	
	HomeAddress.propTypes = {
	  formatMessage: PropTypes.func,
	  canEdit: PropTypes.bool,
	  profile: PropTypes.object,
	  countryList: PropTypes.array,
	  saveUser: PropTypes.func,
	  isSucceedUpdate: PropTypes.bool
	};

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _AsyncPaginatedSelect = __webpack_require__(783);
	
	var _AsyncPaginatedSelect2 = _interopRequireDefault(_AsyncPaginatedSelect);
	
	var _formFields = __webpack_require__(38);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _index = __webpack_require__(5080);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MEMBER_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.MEMBER_ID,
	    GROUP_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GROUP_NUMBER,
	    HEALTH_PLAN = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.HEALTH_PLAN;
	
	
	var MainInsuranceFormSection = function MainInsuranceFormSection(_ref) {
	  var formState = _ref.formState,
	      handleFormChange = _ref.handleFormChange,
	      handleHealthPlanChange = _ref.handleHealthPlanChange,
	      entities = _ref.entities,
	      handleInputChange = _ref.handleInputChange,
	      handleMenuScrollToBottom = _ref.handleMenuScrollToBottom,
	      isLoading = _ref.isLoading,
	      isPlanNotListedSelected = _ref.isPlanNotListedSelected;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var placeholderHealthPlan = formatMessage({
	    id: 'profile.section.insurance.healthPlan'
	  });
	
	  var makeField = (0, _getFieldProps.getFieldProps)(formatMessage, handleFormChange);
	
	  return _react2.default.createElement(
	    'section',
	    { className: _index2.default.section },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.healthPlanSelect },
	      _react2.default.createElement(_AsyncPaginatedSelect2.default, {
	        handleInputChange: handleInputChange,
	        isLoading: isLoading,
	        label: placeholderHealthPlan,
	        onChange: handleHealthPlanChange,
	        onMenuScrollToBottom: handleMenuScrollToBottom,
	        options: entities,
	        placeholder: placeholderHealthPlan,
	        value: formState[HEALTH_PLAN]
	      })
	    ),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(MEMBER_ID), {
	      disabled: isPlanNotListedSelected,
	      withTrimMode: true,
	      required: false,
	      value: formState[MEMBER_ID]
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(GROUP_NUMBER, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      disabled: isPlanNotListedSelected,
	      value: formState[GROUP_NUMBER]
	    }))
	  );
	};
	
	MainInsuranceFormSection.propTypes = {
	  formState: _propTypes2.default.object.isRequired,
	  isPlanNotListedSelected: _propTypes2.default.bool,
	  handleFormChange: _propTypes2.default.func.isRequired,
	  handleHealthPlanChange: _propTypes2.default.func.isRequired,
	  entities: _propTypes2.default.array.isRequired,
	  handleInputChange: _propTypes2.default.func.isRequired,
	  handleMenuScrollToBottom: _propTypes2.default.func.isRequired,
	  isLoading: _propTypes2.default.bool
	};
	
	exports.default = MainInsuranceFormSection;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _DatePickerCustom = __webpack_require__(234);
	
	var _DatePickerCustom2 = _interopRequireDefault(_DatePickerCustom);
	
	var _useCountryData2 = __webpack_require__(3588);
	
	var _useCountryData3 = _interopRequireDefault(_useCountryData2);
	
	var _utils = __webpack_require__(233);
	
	var _useGenderOptions2 = __webpack_require__(1860);
	
	var _useGenderOptions3 = _interopRequireDefault(_useGenderOptions2);
	
	var _useInsuranceRelationOptions = __webpack_require__(621);
	
	var _useInsuranceRelationOptions2 = _interopRequireDefault(_useInsuranceRelationOptions);
	
	var _validations = __webpack_require__(81);
	
	var _formFields = __webpack_require__(38);
	
	var _dates = __webpack_require__(1852);
	
	var _utils2 = __webpack_require__(78);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _index = __webpack_require__(5081);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOB = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DOB,
	    LAST_NAME = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.LAST_NAME,
	    FIRST_NAME = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.FIRST_NAME,
	    PHONE_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PHONE_NUMBER,
	    ADDRESS_1 = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.ADDRESS_1,
	    ADDRESS_2 = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.ADDRESS_2,
	    CITY = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.CITY,
	    STATE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.STATE,
	    POSTAL_CODE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.POSTAL_CODE,
	    GENDER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GENDER,
	    INSURANCE_RELATION_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.INSURANCE_RELATION_ID;
	
	
	var resetCommonFieldProps = {
	  className: ''
	};
	
	var PrimarySubscriberFormSection = function PrimarySubscriberFormSection(_ref) {
	  var handleFormChange = _ref.handleFormChange,
	      formState = _ref.formState,
	      formErrors = _ref.formErrors,
	      handleChangeField = _ref.handleChangeField;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var datePickerLabel = formatMessage({ id: 'profile.fields.dob' });
	  var phoneNumberLabel = formatMessage({ id: 'profile.fields.phone' });
	  var insuranceRelationFieldLabel = formatMessage({
	    id: 'profile.fields.relationship'
	  });
	
	  var makeField = (0, _getFieldProps.getFieldProps)(formatMessage, handleFormChange);
	
	  var _useGenderOptions = (0, _useGenderOptions3.default)(formatMessage),
	      genderOptions = _useGenderOptions.genderOptions;
	
	  var _useInsuranceRelation = (0, _useInsuranceRelationOptions2.default)(),
	      insuranceRelationOptions = _useInsuranceRelation.insuranceRelationOptions,
	      hideInsuranceRelationFieldOrInfo = _useInsuranceRelation.hideInsuranceRelationFieldOrInfo;
	
	  var _useCountryData = (0, _useCountryData3.default)(),
	      stateList = _useCountryData.stateList,
	      zipLimit = _useCountryData.zipLimit,
	      isZipApplicable = _useCountryData.isZipApplicable;
	
	  var dateFieldValue = formState[DOB] ? (0, _utils2.getDateFieldValue)(formState[DOB]) : undefined;
	
	  var safeState = (0, _utils.adaptInitialValueState)(formState[STATE], stateList);
	  var safeGender = (0, _utils.adaptInitialValue)(formState[GENDER], genderOptions);
	  var safeRelation = (0, _utils.adaptInitialValue)(formState[INSURANCE_RELATION_ID], insuranceRelationOptions);
	
	  var handleChangeState = function handleChangeState(data) {
	    handleFormChange({ state: data });
	  };
	
	  var handleRelationChange = function handleRelationChange(data) {
	    handleFormChange({ insuranceRelationId: data.value });
	  };
	
	  var handleDobChange = function handleDobChange(value) {
	    var date = value;
	
	    if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object' && value !== null) {
	      date = (0, _utils2.getTimeFromDateUTC)(value, _dates.DATE_PICKER_DATE_FORMAT, false);
	    }
	
	    handleChangeField(DOB)(date);
	  };
	
	  return _react2.default.createElement(
	    'section',
	    { className: _index2.default.section },
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(FIRST_NAME), resetCommonFieldProps, {
	      withTrimMode: true,
	      required: false,
	      value: formState[FIRST_NAME]
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(LAST_NAME), resetCommonFieldProps, {
	      withTrimMode: true,
	      required: false,
	      value: formState[LAST_NAME]
	    })),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_DatePickerCustom2.default, (0, _extends3.default)({}, makeField(DOB), resetCommonFieldProps, {
	        iconClassName: _index2.default.datePickerIcon,
	        name: DOB,
	        maxDate: _dates.DATE_PICKER_TODAY_MAX_DATE,
	        formatDate: _dates.DATE_PICKER_DATE_FORMAT,
	        value: dateFieldValue,
	        label: datePickerLabel,
	        onChange: handleDobChange,
	        withManualInputDob: true
	      })),
	      formErrors.dob && _react2.default.createElement(_ErrorBlock2.default, { errors: formErrors.dob, className: _index2.default.error })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, resetCommonFieldProps, {
	        label: phoneNumberLabel,
	        onChange: handleChangeField(PHONE_NUMBER),
	        placeholder: phoneNumberLabel,
	        type: 'number',
	        name: PHONE_NUMBER,
	        value: formState[PHONE_NUMBER],
	        required: false,
	        limit: _validations.LENGTH_VALUES.HOME_PHONE.MAX
	      })),
	      formErrors.phoneNumber && _react2.default.createElement(_ErrorBlock2.default, {
	        errors: formErrors.phoneNumber,
	        className: _index2.default.error
	      })
	    ),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(GENDER), {
	      className: _index2.default.selectField,
	      options: genderOptions,
	      needUpdateDefaultValue: true,
	      required: false,
	      value: safeGender
	    })),
	    !hideInsuranceRelationFieldOrInfo && _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(INSURANCE_RELATION_ID), {
	      className: _index2.default.selectField,
	      onChange: handleRelationChange,
	      options: insuranceRelationOptions,
	      placeholder: insuranceRelationFieldLabel,
	      label: insuranceRelationFieldLabel,
	      needUpdateDefaultValue: true,
	      required: false,
	      value: safeRelation
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(ADDRESS_1), resetCommonFieldProps, {
	      value: formState[ADDRESS_1],
	      required: false
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(ADDRESS_2, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), resetCommonFieldProps, {
	      value: formState[ADDRESS_2],
	      required: false
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(CITY), resetCommonFieldProps, {
	      value: formState[CITY],
	      required: false
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(STATE), {
	      className: _index2.default.selectField,
	      onChange: handleChangeState,
	      value: safeState,
	      options: stateList,
	      needUpdateDefaultValue: true,
	      required: false
	    })),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(POSTAL_CODE), resetCommonFieldProps, {
	        limit: zipLimit,
	        value: formState[POSTAL_CODE],
	        disabled: !isZipApplicable,
	        required: false,
	        onChange: handleChangeField(POSTAL_CODE)
	      })),
	      formErrors.postalCode && _react2.default.createElement(_ErrorBlock2.default, {
	        errors: [formErrors.postalCode],
	        className: _index2.default.error
	      })
	    )
	  );
	};
	
	PrimarySubscriberFormSection.propTypes = {
	  handleFormChange: _propTypes2.default.func.isRequired,
	  formState: _propTypes2.default.object.isRequired,
	  formErrors: _propTypes2.default.object.isRequired,
	  handleChangeField: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _react.memo)(PrimarySubscriberFormSection);

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ViewConsent = __webpack_require__(3615);
	
	var _ViewConsent2 = _interopRequireDefault(_ViewConsent);
	
	var _index = __webpack_require__(5090);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenderViewConsents = function RenderViewConsents(_ref) {
	  var consentsList = _ref.consentsList,
	      formatMessage = _ref.formatMessage;
	
	  var renderViewConsents = (0, _react.useCallback)(function (consents, params) {
	    var rulesMap = function rulesMap(index) {
	      return params === 'even' ? index % 2 === 0 : index % 2 !== 0;
	    };
	
	    return consents.length > 0 && consents.map(function (_ref2, index) {
	      var id = _ref2.id,
	          name = _ref2.name,
	          status = _ref2.status,
	          fileUrl = _ref2.fileUrl,
	          version = _ref2.version,
	          program = _ref2.program,
	          expiresAt = _ref2.expiresAt,
	          consentType = _ref2.consentType,
	          statusChangedAt = _ref2.statusChangedAt,
	          consentAssignmentId = _ref2.consentAssignmentId,
	          consentAssignmentType = _ref2.consentAssignmentType;
	
	      var _program = (0, _extends3.default)({}, program),
	          programName = _program.programName;
	
	      var _consentType = (0, _extends3.default)({}, consentType),
	          _consentType$name = _consentType.name,
	          consentTypeTitle = _consentType$name === undefined ? 'Uncategorized' : _consentType$name;
	
	      return rulesMap(index) && _react2.default.createElement(
	        _react.Fragment,
	        { key: consentAssignmentId },
	        _react2.default.createElement(_ViewConsent2.default, {
	          key: id,
	          name: name,
	          status: status,
	          fileUrl: fileUrl,
	          version: version,
	          expiresAt: expiresAt,
	          programName: programName,
	          formatMessage: formatMessage,
	          statusChangedAt: statusChangedAt,
	          consentTypeTitle: consentTypeTitle,
	          consentAssignmentType: consentAssignmentType
	        })
	      );
	    });
	  }, [consentsList]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.consentsWrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.column },
	      renderViewConsents(consentsList, 'even')
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.column },
	      renderViewConsents(consentsList, 'odd')
	    )
	  );
	};
	
	RenderViewConsents.propTypes = {
	  consentsList: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = (0, _react.memo)(RenderViewConsents);

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getContactsConditions = exports.getContactsConditions = function getContactsConditions(profile, canEditPatient) {
	  var email = profile.email,
	      emailFake = profile.emailFake,
	      phoneNumber = profile.phoneNumber,
	      primaryContactsEnabled = profile.primaryContactsEnabled;
	
	
	  if (primaryContactsEnabled) {
	    return {
	      showEmail: true,
	      showPhoneNumber: true
	    };
	  }
	
	  var showEmail = (profile.emailConfirmed || canEditPatient) && !emailFake && email;
	  var showPhoneNumber = (profile.phoneNumberConfirmed || canEditPatient) && phoneNumber;
	
	  return {
	    showEmail: showEmail,
	    showPhoneNumber: showPhoneNumber
	  };
	};

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPatientInfoFieldsetList = exports.getProviderInfoFieldsetList = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.formatExternalList = formatExternalList;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _strings = __webpack_require__(15);
	
	var _chars = __webpack_require__(258);
	
	var _validations = __webpack_require__(362);
	
	var _generateMrnDescriptors = __webpack_require__(3647);
	
	var _generateMrnDescriptors2 = _interopRequireDefault(_generateMrnDescriptors);
	
	var _generateEmployersDescriptors = __webpack_require__(3646);
	
	var _generateEmployersDescriptors2 = _interopRequireDefault(_generateEmployersDescriptors);
	
	var _generatePharmacyDescription = __webpack_require__(3648);
	
	var _generatePharmacyDescription2 = _interopRequireDefault(_generatePharmacyDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPrimaryPracticeAddressFields = function getPrimaryPracticeAddressFields(options, formatMessage) {
	  var practiceAddress1 = options.practiceAddress1,
	      practiceAddress2 = options.practiceAddress2,
	      practiceCity = options.practiceCity,
	      practiceState = options.practiceState,
	      practiceZip = options.practiceZip,
	      practiceCountry = options.practiceCountry;
	
	  return [{
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeAddress1),
	    value: practiceAddress1,
	    fieldName: 'practiceAddress1',
	    maxLength: 50
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeAddress2),
	    value: practiceAddress2,
	    fieldName: 'practiceAddress2',
	    maxLength: 50
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeCity),
	    value: practiceCity,
	    fieldName: 'practiceCity',
	    maxLength: 50
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeState),
	    value: practiceState,
	    fieldName: 'practiceState',
	    separator: _chars.SPACE,
	    maxLength: 20
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.postalCode),
	    value: practiceZip,
	    fieldName: 'practiceZip',
	    maxLength: 20
	  }, {
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeCountry),
	    value: practiceCountry,
	    fieldName: 'practiceCountry',
	    maxLength: 50,
	    disabled: true
	  }];
	};
	
	var getProviderInfoFieldsetList = exports.getProviderInfoFieldsetList = function getProviderInfoFieldsetList(_ref) {
	  var canEdit = _ref.canEdit,
	      profile = _ref.profile,
	      formatMessage = _ref.intl.formatMessage;
	  var primaryProviderProfile = profile.primaryProviderProfile;
	
	  var _ref2 = primaryProviderProfile || {},
	      npi = _ref2.npi,
	      officePhone = _ref2.officePhone,
	      localUid = _ref2.localUid,
	      role = _ref2.role;
	
	  var primaryPracticeAddressFields = getPrimaryPracticeAddressFields(primaryProviderProfile, formatMessage);
	
	  var primaryPracticeAddressFieldsList = primaryPracticeAddressFields;
	  if (!canEdit) {
	    primaryPracticeAddressFieldsList = [{
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeAddress),
	      separator: ', ',
	      value: primaryPracticeAddressFields
	    }];
	  }
	
	  return [{
	    title: formatMessage(_strings.PROFILE_FIELDS.listTitles.prof),
	    fields: [{
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.localUidProvider),
	      value: localUid,
	      disabled: true,
	      mode: 'view'
	    }, {
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.npi),
	      value: npi,
	      disabled: true,
	      mode: 'view'
	    }, {
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.role),
	      value: role,
	      fieldName: 'role',
	      maxLength: 50
	    }].concat((0, _toConsumableArray3.default)(primaryPracticeAddressFieldsList), [{
	      name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.officePhone),
	      value: officePhone,
	      fieldName: 'officePhone',
	      validationRules: (0, _defineProperty3.default)({}, _validations.RULES.PHONE, {
	        message: 'profile.phone.format'
	      }),
	      maxLength: 50
	    }]),
	    columns: true
	  }];
	};
	// TODO too many transformations
	function formatExternalList(list) {
	  if (!list) return list;
	  var filteredList = list.filter(function (item) {
	    return item.value.enabled;
	  });
	  return filteredList.map(function (item) {
	    return (0, _extends3.default)({}, item, {
	      value: formatItem(item.value)
	    });
	  });
	}
	// TODO too many transformations
	function formatInternalList(list) {
	  if (!list) return list;
	
	  return list.map(formatItem);
	}
	
	function formatItem(item) {
	  return (0, _extends3.default)({}, item, {
	    value: item.name
	  });
	}
	
	var getPatientInfoFieldsetList = exports.getPatientInfoFieldsetList = function getPatientInfoFieldsetList(_ref3) {
	  var profile = _ref3.profile,
	      location = _ref3.location,
	      medicationAllergiesList = _ref3.medicationAllergiesList,
	      healthConditionsList = _ref3.healthConditionsList,
	      formatMessage = _ref3.intl.formatMessage;
	  var primaryPatientProfile = profile.primaryPatientProfile,
	      actualFamilyMember = profile.actualFamilyMember,
	      employeeProfile = profile.employeeProfile;
	
	  var _ref4 = primaryPatientProfile || {},
	      medicationAllergies = _ref4.medicationAllergies,
	      healthConditions = _ref4.healthConditions,
	      healthGoals = _ref4.healthGoals,
	      mrns = _ref4.mrns,
	      patientProfileNdcDrugs = _ref4.patientProfileNdcDrugs,
	      pharmacy = _ref4.pharmacy;
	
	  var isFamilyMember = location.pathname.includes('family-member');
	  var list = [];
	  var getSafeMedicineNames = patientProfileNdcDrugs.map(function (drug) {
	    return {
	      id: drug.ndcDrugId,
	      name: drug.displayableName,
	      value: drug.displayableName
	    };
	  });
	
	  if (!isFamilyMember && !actualFamilyMember) {
	    list.push({
	      title: formatMessage(_strings.PROFILE_FIELDS.listTitles.health),
	      columns: true,
	      fields: [{
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.healthConditions),
	        value: formatInternalList(healthConditions),
	        multi: true,
	        type: 'select',
	        fieldName: 'healthConditionIds',
	        options: formatExternalList(healthConditionsList),
	        onCheckBeforeDelete: function onCheckBeforeDelete(checkedValue) {
	          var id = (0, _get2.default)(checkedValue, 'value.id');
	          var condition = healthConditionsList.find(function (item) {
	            return item.value.id === id;
	          });
	          return !condition;
	        }
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.medicationAllergies),
	        value: formatInternalList(medicationAllergies),
	        multi: true,
	        type: 'select',
	        fieldName: 'medicationAllergyIds',
	        options: formatExternalList(medicationAllergiesList),
	        onCheckBeforeDelete: function onCheckBeforeDelete(checkedValue) {
	          var id = (0, _get2.default)(checkedValue, 'value.id');
	          var allergy = medicationAllergiesList.find(function (item) {
	            return item.value.id === id;
	          });
	          return !allergy;
	        }
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.medicine),
	        value: getSafeMedicineNames,
	        fieldName: 'ndcDrugIds',
	        type: 'medication'
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.healthGoals),
	        value: healthGoals,
	        fieldName: 'healthGoals'
	      }]
	    });
	
	    list.push({
	      title: formatMessage(_strings.PROFILE_FIELDS.fieldNames.preferredPharmacy),
	      columns: false,
	      fields: (0, _generatePharmacyDescription2.default)(pharmacy, formatMessage),
	      disabled: false
	    });
	
	    if (mrns && mrns.length) {
	      list.push({
	        title: formatMessage(_strings.PROFILE_FIELDS.fieldNames.organizations),
	        columns: true,
	        fields: (0, _generateMrnDescriptors2.default)(mrns),
	        disabled: true
	      });
	    }
	
	    if (employeeProfile && employeeProfile.employeeEmployers.length) {
	      list.push({
	        title: formatMessage(_strings.PROFILE_FIELDS.listTitles.affiliations),
	        columns: true,
	        fields: (0, _generateEmployersDescriptors2.default)(employeeProfile, formatMessage),
	        useCustomAction: true
	      });
	    }
	  }
	
	  return list;
	};

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _viewProgramCost = __webpack_require__(1165);
	
	var _styles = __webpack_require__(5106);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgramSubscription = function ProgramSubscription(_ref) {
	  var formatMessage = _ref.formatMessage,
	      handleChangeMembershipDuration = _ref.handleChangeMembershipDuration,
	      isSubscriptionStatusPending = _ref.isSubscriptionStatusPending,
	      prepaidByProvider = _ref.prepaidByProvider,
	      program = _ref.program,
	      selectedMembershipId = _ref.selectedMembershipId,
	      subscriptionsSetting = _ref.subscriptionsSetting;
	
	  var _program = (0, _extends3.default)({}, program),
	      withSubscription = _program.withSubscription,
	      _program$subscription = _program.subscriptionsSettings,
	      subscriptionsSettings = _program$subscription === undefined ? [] : _program$subscription;
	
	  var onlyOneSubscriptionOption = subscriptionsSettings.length === 1 || prepaidByProvider;
	
	  var moreThanOneSubscriptionOption = subscriptionsSettings.length > 1;
	
	  var _subscriptionsSetting = (0, _extends3.default)({}, subscriptionsSetting),
	      price = _subscriptionsSetting.price,
	      period = _subscriptionsSetting.period,
	      periodQuantity = _subscriptionsSetting.periodQuantity,
	      recurrenceType = _subscriptionsSetting.recurrenceType,
	      _subscriptionsSetting2 = _subscriptionsSetting.description,
	      subscriptionSettingsDescription = _subscriptionsSetting2 === undefined ? '' : _subscriptionsSetting2;
	
	  var programCostTitle = (0, _react.useMemo)(function () {
	    return _react2.default.createElement(
	      'div',
	      { className: _styles2.default.programCost },
	      formatMessage({ id: 'program.invite.programCost' })
	    );
	  }, []);
	
	  return Boolean(withSubscription) ? [onlyOneSubscriptionOption ? _react2.default.createElement(
	    'div',
	    { className: _styles2.default.section, key: '0'
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.wrapper },
	      programCostTitle,
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.costValue },
	        (0, _viewProgramCost.viewProgramCost)({
	          price: price,
	          period: period,
	          formatMessage: formatMessage,
	          recurrenceType: recurrenceType,
	          quantity: periodQuantity
	        }) + ' ' + (prepaidByProvider ? formatMessage({ id: 'program.membership.prepaid' }) : ''),
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.costDescription },
	          subscriptionSettingsDescription
	        )
	      )
	    )
	  ) : null, moreThanOneSubscriptionOption && isSubscriptionStatusPending ? _react2.default.createElement(
	    'div',
	    { className: _styles2.default.section, key: '1'
	    },
	    programCostTitle,
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.radioButtonWrapper },
	      subscriptionsSettings.map(function (subscription) {
	        return _react2.default.createElement(
	          'div',
	          { key: subscription.id, className: _styles2.default.radioItem },
	          _react2.default.createElement('input', {
	            type: 'radio',
	            id: subscription.id,
	            name: 'membershipDuration_' + program.id,
	            value: subscription.id,
	            checked: selectedMembershipId === subscription.id,
	            onChange: function onChange() {
	              return handleChangeMembershipDuration(subscription.id);
	            }
	          }),
	          _react2.default.createElement(
	            'label',
	            {
	              htmlFor: subscription.id,
	              className: _styles2.default.radioItemLabel
	            },
	            _react2.default.createElement(
	              'span',
	              { className: _styles2.default.costValue },
	              '' + (0, _viewProgramCost.viewProgramCost)({
	                price: subscription.price,
	                period: subscription.period,
	                formatMessage: formatMessage,
	                recurrenceType: subscription.recurrenceType,
	                quantity: subscription.periodQuantity
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              subscription.description || ''
	            )
	          )
	        );
	      })
	    )
	  ) : null] : null;
	};
	
	ProgramSubscription.propTypes = {
	  formatMessage: _propTypes2.default.func,
	  handleChangeMembershipDuration: _propTypes2.default.func,
	  isSubscriptionStatusPending: _propTypes2.default.bool,
	  prepaidByProvider: _propTypes2.default.bool,
	  program: _propTypes2.default.object,
	  selectedMembershipId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  subscriptionsSetting: _propTypes2.default.object
	};
	
	exports.default = ProgramSubscription;

/***/ }),
/* 1797 */,
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.getGeneralInfoFields = getGeneralInfoFields;
	exports.getPersonalInfoFields = getPersonalInfoFields;
	exports.getAddressInfoFields = getAddressInfoFields;
	exports.getPatientFieldSet = getPatientFieldSet;
	exports.getProviderFieldSet = getProviderFieldSet;
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	var _strings = __webpack_require__(15);
	
	var _chars = __webpack_require__(258);
	
	var _dateConverters = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getGeneralInfoFields(_ref) {
	  var username = _ref.username,
	      aliasName = _ref.aliasName,
	      _ref$userOrganization = _ref.userOrganizations,
	      userOrganizations = _ref$userOrganization === undefined ? [] : _ref$userOrganization,
	      providerRole = _ref.providerRole;
	
	  return function (formatMessage) {
	    return [{
	      title: formatMessage(_strings.PROFILE_FIELDS.listTitles.general),
	      fields: [{
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.username),
	        value: username,
	        fieldName: 'username'
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.aliasName),
	        value: aliasName,
	        fieldName: 'aliasName'
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.organizations),
	        value: userOrganizations.join(', ')
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.role),
	        value: providerRole
	      }]
	    }];
	  };
	}
	
	function getPersonalInfoFields(_ref2, rawGenderList, languagesList) {
	  var bio = _ref2.bio,
	      _ref2$healthInterests = _ref2.healthInterests,
	      healthInterests = _ref2$healthInterests === undefined ? [] : _ref2$healthInterests,
	      firstName = _ref2.firstName,
	      lastName = _ref2.lastName,
	      gender = _ref2.gender,
	      dob = _ref2.dob,
	      language = _ref2.language,
	      languages = _ref2.languages;
	
	  return function (formatMessage) {
	    return [{
	      title: formatMessage(_strings.PROFILE_FIELDS.listTitles.personal),
	      fields: [{
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.bio),
	        value: bio
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.healthInterests),
	        value: healthInterests.join(', ')
	      }, [{
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.firstName),
	        value: firstName
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.lastName),
	        value: lastName
	      }], [{
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.gender),
	        value: gender,
	        type: 'select',
	        options: (0, _convertListWithLocalization.convertGenderList)(rawGenderList, formatMessage)
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.age),
	        value: (0, _dateConverters.convertDateToUIFormat)(dob, formatMessage),
	        fieldName: 'age',
	        type: 'date',
	        converters: {
	          fromView: function fromView(value) {
	            return (0, _dateConverters.convertDateToAPIFormat)(value, formatMessage);
	          }
	        }
	      }].filter(function (_ref3) {
	        var value = _ref3.value;
	        return Boolean(value);
	      }), {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.prefLanguage),
	        value: language,
	        type: 'select',
	        options: languagesList,
	        fieldName: 'language'
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.languages),
	        value: languages,
	        type: 'select',
	        multi: true,
	        options: languagesList,
	        transformValueFromOptions: true,
	        fieldName: 'languages'
	      }]
	    }];
	  };
	}
	
	function getAddressInfoFields(_ref4) {
	  var city = _ref4.city,
	      state = _ref4.state,
	      postalCode = _ref4.postalCode,
	      country = _ref4.country;
	
	  return function (formatMessage) {
	    return [{
	      title: formatMessage(_strings.PROFILE_FIELDS.listTitles.address),
	      fields: [{
	        name: formatMessage(_strings.PROFILE_FIELDS.listTitles.address),
	        value: [city, state, postalCode, country].filter(Boolean).join(', ')
	      }]
	    }];
	  };
	}
	
	function getPatientFieldSet(_ref5) {
	  var allergies = _ref5.allergies,
	      medicine = _ref5.medicine,
	      healthGoals = _ref5.healthGoals,
	      mrns = _ref5.mrns;
	
	  return function (formatMessage) {
	    return [{
	      columns: true,
	      title: formatMessage(_strings.PROFILE_FIELDS.listTitles.health),
	      fields: [{
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.allergies),
	        value: allergies,
	        fieldName: 'allergies'
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.medicine),
	        value: medicine,
	        fieldName: 'medicine'
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.healthGoals),
	        value: healthGoals,
	        fieldName: 'healthGoals'
	      }].concat((0, _toConsumableArray3.default)(mrns ? {
	        name: formatMessage(_strings.PROFILE_FIELDS.listTitles.mrns),
	        value: mrns.map(function (_ref6) {
	          var localUid = _ref6.localUid;
	          return localUid;
	        }).filter(function (localUid) {
	          return Boolean(localUid);
	        }).join(', ')
	      } : []))
	    }];
	  };
	}
	
	function getProviderFieldSet(_ref7) {
	  var practiceAddress1 = _ref7.practiceAddress1,
	      practiceAddress2 = _ref7.practiceAddress2,
	      practiceCity = _ref7.practiceCity,
	      practiceState = _ref7.practiceState,
	      practiceZip = _ref7.practiceZip,
	      officePhone = _ref7.officePhone,
	      country = _ref7.country;
	
	  return function (formatMessage) {
	    return [{
	      columns: true,
	      title: formatMessage(_strings.PROFILE_FIELDS.listTitles.prof),
	      fields: [{
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeAddress1),
	        value: practiceAddress1,
	        fieldName: 'practiceAddress1',
	        maxLength: 50
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeAddress2),
	        value: practiceAddress2,
	        fieldName: 'practiceAddress2',
	        maxLength: 50
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeCity),
	        value: practiceCity,
	        fieldName: 'practiceCity',
	        maxLength: 50
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeState),
	        value: practiceState,
	        fieldName: 'practiceState',
	        separator: _chars.SPACE,
	        maxLength: 20
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.postalCode),
	        value: practiceZip,
	        fieldName: 'practiceZip',
	        maxLength: 20
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.primaryPracticeCountry),
	        value: country,
	        fieldName: 'practiceCountry',
	        maxLength: 50
	      }, {
	        name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.officePhone),
	        value: officePhone,
	        fieldName: 'officePhone',
	        maxLength: 50
	      }]
	    }];
	  };
	}

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _getQuestionDescription = __webpack_require__(3720);
	
	var _getQuestionDescription2 = _interopRequireDefault(_getQuestionDescription);
	
	var _getQuestionStyleName = __webpack_require__(3721);
	
	var _getQuestionStyleName2 = _interopRequireDefault(_getQuestionStyleName);
	
	var _getQuestionText = __webpack_require__(3722);
	
	var _getQuestionText2 = _interopRequireDefault(_getQuestionText);
	
	var _enhance = __webpack_require__(3717);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Question = function Question(_ref) {
	  var text = _ref.text,
	      settings = _ref.settings,
	      onLink = _ref.onLink,
	      markOptional = _ref.markOptional,
	      viewPosition = _ref.viewPosition;
	
	  var description = (0, _getQuestionDescription2.default)((0, _extends3.default)({}, settings, {
	    text: text,
	    onLink: onLink
	  }));
	
	  var styleName = (0, _getQuestionStyleName2.default)((0, _get2.default)(settings, 'name'));
	  var isRequired = (0, _get2.default)(settings, 'isRequired', true);
	  var questionText = (0, _getQuestionText2.default)((0, _extends3.default)({ text: text }, settings));
	  var questionName = (0, _get2.default)(settings, 'name');
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'text ' + styleName },
	    questionText && _react2.default.createElement(
	      'p',
	      null,
	      '' + (viewPosition ? viewPosition + ' ' + questionText + ' ' : questionText + ' '),
	      _react2.default.createElement(
	        'span',
	        { styleName: 'optional' },
	        isRequired || questionName === 'comment' ? '' : markOptional()
	      )
	    ),
	    description && _react2.default.createElement(
	      'div',
	      { styleName: 'description' },
	      description
	    )
	  );
	};
	
	Question.propTypes = {
	  text: _propTypes2.default.string,
	  onLink: _propTypes2.default.func,
	  markOptional: _propTypes2.default.func,
	  viewPosition: _propTypes2.default.string,
	  settings: _propTypes2.default.shape({
	    meta: _propTypes2.default.object
	  })
	};
	
	exports.default = (0, _enhance.enhance)(Question);

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Answers = __webpack_require__(3716);
	
	var _Answers2 = _interopRequireDefault(_Answers);
	
	var _Question = __webpack_require__(1799);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _strings = __webpack_require__(15);
	
	var _useDynamicQuestionsTree = __webpack_require__(3719);
	
	var _enhance = __webpack_require__(3718);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SequentialSurvey = function SequentialSurvey(_ref) {
	  var survey = _ref.survey,
	      onSubmit = _ref.onSubmit,
	      setProgress = _ref.setProgress;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      selectedValue = _useState2[0],
	      setSelectedValue = _useState2[1];
	
	  var answers = (0, _get2.default)(survey, 'answers');
	  var token = (0, _get2.default)(survey, 'meta.token');
	  var statusSurvey = (0, _get2.default)(survey, 'meta.status');
	  var assignmentId = (0, _get2.default)(survey, 'assignmentId');
	  var questions = (0, _get2.default)(survey, 'survey.questions');
	  var intervieweeId = (0, _get2.default)(survey, 'interviewee.id');
	  var citationVisibleOnQuestions = (0, _get2.default)(survey, 'survey.citationVisibleOnQuestions');
	  var citationLink = (0, _get2.default)(survey, 'survey.citationLink');
	  var citationDescription = (0, _get2.default)(survey, 'survey.citationDescription');
	
	  var _useDynamicQuestionsT = (0, _useDynamicQuestionsTree.useDynamicQuestionsTree)({
	    answers: answers,
	    onSubmit: onSubmit,
	    questions: questions,
	    setProgress: setProgress,
	    selectedValue: selectedValue,
	    config: {
	      token: token,
	      statusSurvey: statusSurvey,
	      assignmentId: assignmentId
	    }
	  }),
	      question = _useDynamicQuestionsT.question,
	      isComment = _useDynamicQuestionsT.isComment,
	      isRequired = _useDynamicQuestionsT.isRequired,
	      handleBack = _useDynamicQuestionsT.handleBack,
	      isLastStep = _useDynamicQuestionsT.isLastStep,
	      isFirstStep = _useDynamicQuestionsT.isFirstStep,
	      handleSubmit = _useDynamicQuestionsT.handleSubmit;
	
	  var showCitationLink = citationVisibleOnQuestions && citationDescription;
	
	  var handleSubmitting = function handleSubmitting() {
	    handleSubmit({
	      id: question.id,
	      value: selectedValue || question.answerValue
	    });
	    setSelectedValue(null);
	  };
	
	  var onBack = (0, _react.useCallback)(function () {
	    handleBack(!!question.parentQuestionId);
	  }, [question]);
	
	  var getBtnText = function getBtnText() {
	    if (isLastStep) return _react2.default.createElement(_reactIntl.FormattedMessage, _strings.ACTIONS.survey.complete);
	    if (isComment) return _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.next);
	    return _react2.default.createElement(_reactIntl.FormattedMessage, _strings.ACTIONS.survey.submitOne);
	  };
	
	  var markOptional = function markOptional() {
	    return _react2.default.createElement(_reactIntl.FormattedMessage, _strings.ACTIONS.survey.optional);
	  };
	
	  var currentAnswer = (0, _get2.default)(question, 'settings.meta.availableAnswers', []).includes(selectedValue) ? selectedValue : question.answerValue;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', key: question.id },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'wrapper' },
	      _react2.default.createElement(_Question2.default, (0, _extends3.default)({
	        assignmentId: assignmentId,
	        intervieweeId: intervieweeId,
	        markOptional: markOptional
	      }, question)),
	      showCitationLink && _react2.default.createElement(
	        'a',
	        { href: citationLink, target: 'blank', styleName: 'link' },
	        citationDescription
	      ),
	      !isComment && _react2.default.createElement(
	        'div',
	        { styleName: 'answer' },
	        _react2.default.createElement(_Answers2.default, {
	          question: question,
	          surveyId: assignmentId,
	          onChange: setSelectedValue,
	          answer: currentAnswer
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'btnGroup' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            raised: true,
	            type: 'button',
	            color: 'accent',
	            className: 'mr2',
	            onClick: onBack,
	            disabled: isFirstStep
	          },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.back)
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            raised: true,
	            color: 'primary',
	            onClick: handleSubmitting,
	            disabled: !(isComment || selectedValue || !isRequired)
	          },
	          getBtnText()
	        )
	      )
	    )
	  );
	};
	
	SequentialSurvey.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  survey: _propTypes2.default.object,
	  setProgress: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(SequentialSurvey);

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Table = __webpack_require__(3745);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _getRows = __webpack_require__(3730);
	
	var _getRows2 = _interopRequireDefault(_getRows);
	
	var _getColumns = __webpack_require__(3728);
	
	var _getColumns2 = _interopRequireDefault(_getColumns);
	
	var _getSingleRow = __webpack_require__(3732);
	
	var _getSingleRow2 = _interopRequireDefault(_getSingleRow);
	
	var _strings = __webpack_require__(15);
	
	var _getFlatQuestionsWithPosition = __webpack_require__(1802);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Review = function Review(_ref) {
	  var date = _ref.date,
	      questions = _ref.questions,
	      scorecard = _ref.scorecard,
	      exportPDF = _ref.exportPDF,
	      assignments = _ref.assignments,
	      assignmentId = _ref.assignmentId,
	      formatMessage = _ref.intl.formatMessage,
	      isProviderPostVisitForm = _ref.isProviderPostVisitForm;
	
	  var flatQuestions = (0, _getFlatQuestionsWithPosition.getFlatQuestionsWithPosition)(questions);
	
	  var isSingleViewResult = assignments && assignments.length === 1;
	
	  var triggeredDaysMap = {};
	  var cols = (0, _getColumns2.default)(assignments, triggeredDaysMap);
	  var rows = (0, _getRows2.default)(flatQuestions, assignments, isSingleViewResult);
	  var totalRow = scorecard ? (0, _getSingleRow2.default)(assignments, ['totalScore', 'totalScoreTriggered'], formatMessage(_strings.ACTIONS.survey.totalScore)) : null;
	  var userRow = (0, _getSingleRow2.default)(assignments, ['respondent', 'originalRespondent'], 'Respondent:');
	  var assignmentRow = (0, _getSingleRow2.default)(assignments, ['assignmentMethod', 'assigner'], formatMessage({ id: 'surveys.assignedBy' }) + ':');
	
	  var options = {
	    cols: cols,
	    rows: rows,
	    userRow: userRow,
	    totalRow: totalRow,
	    exportPDF: exportPDF,
	    assignmentRow: assignmentRow,
	    assignmentId: assignmentId
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Table2.default, (0, _extends3.default)({}, options, {
	      singleData: !!date,
	      isProviderPostVisitForm: isProviderPostVisitForm
	    }))
	  );
	}; /* eslint react/require-default-props: 0 */
	
	
	Review.propTypes = {
	  exportPDF: _propTypes2.default.func,
	  scorecard: _propTypes2.default.bool,
	  assignmentId: _propTypes2.default.number,
	  isProviderPostVisitForm: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({ formatMessage: _propTypes2.default.func }),
	  date: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  questions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    text: _propTypes2.default.string
	  })),
	  assignments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    answers: _propTypes2.default.array,
	    sentAt: _propTypes2.default.string,
	    assignmentId: _propTypes2.default.number
	  }))
	};
	
	exports.default = (0, _reactIntl.injectIntl)(Review);

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFlatQuestionsWithPosition = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFlatQuestionsWithPosition = exports.getFlatQuestionsWithPosition = function getFlatQuestionsWithPosition(data) {
	  var withPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var flatQuestions = [];
	
	  var makeFlatQuestions = function makeFlatQuestions(arr, levelIteration, indexBlock) {
	    var nestedNumber = 0;
	    var number = 0;
	    return arr.forEach(function (item, iteration) {
	      var hasNestedQuestions = !(0, _isEmpty2.default)(item.questions);
	      var fieldType = item.settings.name;
	      nestedNumber += Number(fieldType !== _props.QUESTION_TYPES.comment);
	      number += Number(fieldType !== _props.QUESTION_TYPES.comment);
	      flatQuestions.push((0, _extends3.default)({
	        indexBlock: indexBlock || iteration + 1
	      }, withPosition && {
	        viewPosition: levelIteration ? '' + levelIteration + nestedNumber : number + '.'
	      }, item));
	      if (hasNestedQuestions) {
	        makeFlatQuestions(item.questions, levelIteration ? '' + levelIteration + nestedNumber + '.' : number + '.', indexBlock || iteration + 1);
	      }
	    });
	  };
	
	  makeFlatQuestions(data, false);
	
	  return flatQuestions;
	};

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QUESTION = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Question = __webpack_require__(1799);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _InfoBtn = __webpack_require__(3862);
	
	var _InfoBtn2 = _interopRequireDefault(_InfoBtn);
	
	var _Range = __webpack_require__(3870);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	var _Info = __webpack_require__(1833);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	var _strings = __webpack_require__(15);
	
	var _props = __webpack_require__(41);
	
	var _mobileHelpers = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Modify default api response value representation
	 * according to mockups
	 */
	/* eslint-disable */
	
	var QUESTION = exports.QUESTION = 'question';
	
	var getQuestion = function getQuestion(question, assignmentId) {
	  var markOptional = function markOptional() {
	    return _react2.default.createElement(_reactIntl.FormattedMessage, _strings.ACTIONS.survey.optional);
	  };
	  var questionPlaceholder = _react2.default.createElement(_Question2.default, (0, _extends3.default)({}, question, {
	    assignmentId: assignmentId,
	    markOptional: markOptional
	  }));
	
	  return { value: questionPlaceholder, triggered: false };
	};
	
	var getGeneral = function getGeneral(_ref) {
	  var value = _ref.value,
	      triggered = _ref.triggered;
	
	  if (value && value === '—') return value;
	  var textRef = value === 'true' ? 'yes' : 'no';
	  var text = _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON[textRef]);
	  var newValue = _react2.default.createElement(
	    'span',
	    { className: 'ttu' },
	    text
	  );
	
	  return { value: newValue, triggered: triggered };
	};
	
	var getText = function getText(_ref2, expanded) {
	  var value = _ref2.value,
	      triggered = _ref2.triggered;
	
	  if (value && value === '—') return value;
	  var newValue = expanded ? _react2.default.createElement(
	    'p',
	    { className: 'dib tl word-wrap' },
	    value
	  ) : _react2.default.createElement(_InfoBtn2.default, { value: value });
	
	  return { value: newValue, triggered: triggered };
	};
	
	var getSelect = function getSelect(_ref3, expanded) {
	  var value = _ref3.value,
	      triggered = _ref3.triggered;
	
	  if (value && value === '—') return value;
	  var newValue = expanded ? _react2.default.createElement(_Info2.default, { value: value }) : _react2.default.createElement(_InfoBtn2.default, { iconName: 'list', value: value });
	
	  return { value: newValue, triggered: triggered };
	};
	
	var getScale = function getScale(_ref4, expanded) {
	  var value = _ref4.value,
	      description = _ref4.description,
	      triggered = _ref4.triggered;
	
	  var newValue = expanded && (0, _mobileHelpers.isDesktop)() ? _react2.default.createElement(_Range2.default, { scale: description, selected: value }) : expanded ? value + ' out of ' + description.maxValue : value;
	
	  return { value: newValue, triggered: triggered };
	};
	
	exports.default = function (answer, expanded, assignmentId) {
	  var type = (0, _get2.default)(answer, 'type');
	
	  switch (type) {
	    case QUESTION:
	      return getQuestion(answer, assignmentId);
	    case _props.QUESTION_TYPES.general:
	      return getGeneral(answer);
	    case _props.QUESTION_TYPES.text:
	      return getText(answer, expanded);
	    case _props.QUESTION_TYPES.multiSelect:
	    case _props.QUESTION_TYPES.singleSelect:
	      return getSelect(answer, expanded);
	    case _props.QUESTION_TYPES.scale:
	      return getScale(answer, expanded);
	    default:
	      return answer;
	  }
	};

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _preVisitForm = __webpack_require__(288);
	
	var _SurveyListItem = __webpack_require__(1175);
	
	var _SurveyListItem2 = _interopRequireDefault(_SurveyListItem);
	
	var _SequentialSurveyPopup = __webpack_require__(780);
	
	var _SequentialSurveyPopup2 = _interopRequireDefault(_SequentialSurveyPopup);
	
	var _getSpecification2 = __webpack_require__(361);
	
	var _getSpecification3 = _interopRequireDefault(_getSpecification2);
	
	var _withLazyLoad = __webpack_require__(620);
	
	var _withLazyLoad2 = _interopRequireDefault(_withLazyLoad);
	
	var _strings = __webpack_require__(15);
	
	var _enhance = __webpack_require__(3734);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveyList = function SurveyList(_ref) {
	  var formatMessage = _ref.formatMessage,
	      surveys = _ref.surveys,
	      loadMore = _ref.loadMore,
	      listTitle = _ref.listTitle,
	      upcomingListCounter = _ref.upcomingListCounter,
	      className = _ref.className;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      assignmentId = _useState2[0],
	      setAssignmentId = _useState2[1];
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _withLazyLoad2.default,
	      { loadMore: loadMore },
	      _react2.default.createElement(
	        'div',
	        { className: className },
	        Boolean(listTitle) ? [_react2.default.createElement(
	          'span',
	          { styleName: 'title', key: '0'
	          },
	          listTitle
	        ), _react2.default.createElement(
	          'span',
	          { styleName: 'subtitle', key: '1'
	          },
	          formatMessage(_strings.ACTIONS.survey.countSurveys, {
	            count: upcomingListCounter
	          })
	        )] : null,
	        surveys.map(function (item) {
	          var _getSpecification = (0, _getSpecification3.default)(item, formatMessage),
	              description = _getSpecification.description,
	              name = _getSpecification.name,
	              status = _getSpecification.status,
	              heading = _getSpecification.heading;
	
	          var itemAssignmentId = (0, _get2.default)(item, 'assignmentId');
	          var userAppointment = (0, _get2.default)(item, 'userAppointment');
	          var list = (0, _preVisitForm.convertPreVisitFormData)(formatMessage, userAppointment);
	
	          return _react2.default.createElement(_SurveyListItem2.default, {
	            key: itemAssignmentId,
	            heading: heading,
	            title: name,
	            status: status,
	            description: description,
	            list: list,
	            onClick: function onClick() {
	              return setAssignmentId(itemAssignmentId);
	            }
	          });
	        })
	      )
	    ),
	    _react2.default.createElement(_SequentialSurveyPopup2.default, {
	      assignmentId: assignmentId,
	      onClose: function onClose() {
	        return setAssignmentId(null);
	      }
	    })
	  );
	};
	
	SurveyList.defaultProps = {
	  surveys: []
	};
	
	SurveyList.propTypes = {
	  formatMessage: _propTypes2.default.func.isRequired,
	  surveys: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  loadMore: _propTypes2.default.func,
	  listTitle: _propTypes2.default.string,
	  upcomingListCounter: _propTypes2.default.number,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _enhance.enhance)(SurveyList);

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fileSaver = __webpack_require__(1516);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _format = __webpack_require__(319);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _Review = __webpack_require__(1801);
	
	var _Review2 = _interopRequireDefault(_Review);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ExpandableListItem = __webpack_require__(285);
	
	var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);
	
	var _strings = __webpack_require__(15);
	
	var _EmptyState = __webpack_require__(1835);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _preVisitForm = __webpack_require__(288);
	
	var _createSurveyPdfName = __webpack_require__(1917);
	
	var _createSurveyPdfName2 = _interopRequireDefault(_createSurveyPdfName);
	
	var _dateFormatter = __webpack_require__(314);
	
	var _getSpecification = __webpack_require__(361);
	
	var _enhance = __webpack_require__(3739);
	
	var _index = __webpack_require__(565);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveysResults = function SurveysResults(_ref) {
	  var date = _ref.date,
	      hideTitle = _ref.hideTitle,
	      className = _ref.className,
	      targetUser = _ref.targetUser,
	      exportToPDF = _ref.exportToPDF,
	      targetUserId = _ref.targetUserId,
	      _ref$locked = _ref.locked,
	      locked = _ref$locked === undefined ? true : _ref$locked,
	      openedSurveyId = _ref.openedSurveyId,
	      surveysLoading = _ref.surveysLoading,
	      exportPDFState = _ref.exportPDFState,
	      clearExportToPDF = _ref.clearExportToPDF,
	      programSurveys = _ref.surveys,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _ref2 = exportPDFState || {},
	      sending = _ref2.sending,
	      succeed = _ref2.succeed,
	      blob = _ref2.blob;
	
	  var getTargetSurveyAnswers = function getTargetSurveyAnswers(surveys, surveyId) {
	    if (!surveyId) return surveys;
	
	    var filteredSurveys = surveys.filter(function (survey) {
	      return survey.id === surveyId;
	    });
	
	    var hasNoAnswers = (0, _isEmpty2.default)(filteredSurveys) || filteredSurveys.every(function (survey) {
	      return (0, _isEmpty2.default)(survey.assignments);
	    });
	
	    return hasNoAnswers ? [] : filteredSurveys;
	  };
	
	  if (surveysLoading) return _react2.default.createElement(_Loader2.default, null);
	  if (!programSurveys) return _react2.default.createElement(_EmptyState2.default, { centered: !!openedSurveyId });
	
	  var answersToDisplay = getTargetSurveyAnswers(programSurveys, openedSurveyId);
	
	  if ((0, _isEmpty2.default)(answersToDisplay)) return _react2.default.createElement(_EmptyState2.default, { centered: !!openedSurveyId });
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      exportName = _useState2[0],
	      setExportName = _useState2[1];
	
	  var exportPDFJob = (0, _react.useCallback)(function (_ref3) {
	    var openedAssignmentId = _ref3.openedAssignmentId,
	        assignments = _ref3.assignments,
	        name = _ref3.name;
	
	    var _getPDFData = getPDFData(openedAssignmentId, assignments),
	        datePDF = _getPDFData.datePDF;
	
	    var params = {
	      userId: targetUserId,
	      assignmentId: openedAssignmentId,
	      date: (0, _format2.default)(datePDF, _dateFormatter.API_DATE_FORMAT)
	    };
	
	    setExportName((0, _createSurveyPdfName2.default)(name, targetUser.displayableName, params.date));
	
	    exportToPDF(params);
	  }, [targetUserId]);
	
	  var getPDFData = (0, _react.useCallback)(function (openedAssignmentId, assignmentsPDF) {
	    var _ref4 = assignmentsPDF.find(function (assignmentPDF) {
	      return assignmentPDF.assignmentId.toString() === openedAssignmentId;
	    }) || {},
	        datePDF = _ref4.completedAt;
	
	    return { datePDF: datePDF };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var pdfLoaded = !sending && succeed;
	
	    if (pdfLoaded && blob) {
	      (0, _fileSaver.saveAs)(blob, exportName);
	      clearExportToPDF();
	    }
	  }, [exportPDFState, exportName]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    answersToDisplay.map(function (survey, i) {
	      var id = survey.id,
	          name = survey.name,
	          assigner = survey.assigner,
	          frequency = survey.frequency,
	          questions = survey.questions,
	          scorecard = survey.scorecard,
	          surveyType = survey.surveyType,
	          assignments = survey.assignments,
	          description = survey.description,
	          assignmentMethod = survey.assignmentMethod;
	
	
	      var userAppointment = (0, _get2.default)(assignments, '[0].userAppointment');
	      var assignmentId = (0, _get2.default)(assignments, '[0].assignmentId');
	      var list = (0, _preVisitForm.convertPreVisitFormData)(formatMessage, userAppointment);
	      var subtitle = (0, _getSpecification.getSurveyHeaderSubtitle)(surveyType, frequency, formatMessage, assignmentMethod, assigner);
	
	      var reviewOptions = {
	        date: date,
	        questions: questions,
	        scorecard: scorecard,
	        assignments: assignments,
	        assignmentId: assignmentId,
	        exportPDF: function exportPDF(_ref5) {
	          var openedAssignmentId = _ref5.openedAssignmentId;
	          return exportPDFJob({ openedAssignmentId: openedAssignmentId, assignments: assignments, name: name });
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { key: i + '-' + id },
	        !hideTitle ? _react2.default.createElement(
	          'p',
	          { className: 'fw6 f4 mb4' },
	          formatMessage(_strings.SURVEY_RESULTS)
	        ) : null,
	        _react2.default.createElement(
	          _ExpandableListItem2.default,
	          {
	            'data-id': id,
	            locked: locked,
	            opened: i === 0,
	            expandableBlockClassName: _index2.default.positionRelative,
	            header: {
	              list: list,
	              subtitle: subtitle,
	              description: description,
	              title: name,
	              icon: 'surveys'
	            }
	          },
	          _react2.default.createElement(_Review2.default, reviewOptions)
	        )
	      );
	    })
	  );
	};
	
	SurveysResults.propTypes = {
	  date: _propTypes2.default.string,
	  locked: _propTypes2.default.bool,
	  surveys: _propTypes2.default.array,
	  hideTitle: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  exportToPDF: _propTypes2.default.func,
	  targetUser: _propTypes2.default.object,
	  targetUserId: _propTypes2.default.number,
	  surveysLoading: _propTypes2.default.bool,
	  openedSurveyId: _propTypes2.default.number,
	  exportPDFState: _propTypes2.default.object,
	  clearExportToPDF: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _enhance.enhance)(SurveysResults);

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _enhance = __webpack_require__(3743);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _strings = __webpack_require__(15);
	
	var _SequentialSurvey = __webpack_require__(1800);
	
	var _SequentialSurvey2 = _interopRequireDefault(_SequentialSurvey);
	
	var _constants = __webpack_require__(17);
	
	var _ExpandableListItem = __webpack_require__(285);
	
	var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);
	
	var _getSpecification2 = __webpack_require__(361);
	
	var _getSpecification3 = _interopRequireDefault(_getSpecification2);
	
	var _preVisitForm = __webpack_require__(288);
	
	var _index = __webpack_require__(2268);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveysPopup = function SurveysPopup(_ref) {
	  var surveys = _ref.surveys,
	      clearData = _ref.clearData,
	      targetUserId = _ref.targetUserId,
	      assignmentId = _ref.assignmentId,
	      formatMessage = _ref.formatMessage,
	      currentSurvey = _ref.currentSurvey,
	      isUpcomingSurveyRejected = _ref.isUpcomingSurveyRejected,
	      sendUpcomingSurveyAnswers = _ref.sendUpcomingSurveyAnswers,
	      sendUpcomingSurveyProceed = _ref.sendUpcomingSurveyProceed,
	      clearUpcomingSurveyCompletions = _ref.clearUpcomingSurveyCompletions,
	      sendUpcomingSurveyCancelFilling = _ref.sendUpcomingSurveyCancelFilling,
	      isSendingUpcomingSurveyCompletionsSucceed = _ref.isSendingUpcomingSurveyCompletionsSucceed;
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      progress = _useState2[0],
	      setProgress = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      surveyIndex = _useState4[0],
	      setSurveyIndex = _useState4[1];
	
	  var stepper = (0, _react.useMemo)(function () {
	    return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: _index2.default.stepper },
	        '' + (surveyIndex + 1)
	      ),
	      '/' + surveys.length
	    );
	  }, [surveyIndex, surveys]);
	
	  var status = (0, _get2.default)(currentSurvey, 'status');
	  var surveyAssignmentId = (0, _get2.default)(surveys[surveyIndex], 'assignmentId');
	  var intervieweeName = (0, _get2.default)(currentSurvey, 'interviewee.displayableName');
	
	  var _getSpecification = (0, _getSpecification3.default)(currentSurvey, formatMessage, false),
	      name = _getSpecification.name,
	      heading = _getSpecification.heading,
	      description = _getSpecification.description,
	      expirationStatus = _getSpecification.status;
	
	  var userAppointment = (0, _get2.default)(currentSurvey, 'userAppointment', null);
	  var list = (0, _preVisitForm.convertPreVisitFormData)(formatMessage, userAppointment);
	
	  var succeed = (0, _get2.default)(currentSurvey, 'succeed');
	
	  (0, _react.useEffect)(function () {
	    if (isUpcomingSurveyRejected) {
	      clearData();
	    }
	  }, [isUpcomingSurveyRejected]);
	
	  (0, _react.useEffect)(function () {
	    setSurveyIndex(0);
	  }, [surveys]);
	
	  (0, _react.useEffect)(function () {
	    if (surveyIndex === surveys.length) {
	      clearData();
	    }
	  }, [surveyIndex, surveys]);
	
	  (0, _react.useEffect)(function () {
	    if (surveyAssignmentId) {
	      sendUpcomingSurveyProceed({
	        targetUserId: targetUserId,
	        assignmentId: surveyAssignmentId
	      });
	    }
	  }, [surveyIndex, surveyAssignmentId]);
	
	  (0, _react.useEffect)(function () {
	    if (isSendingUpcomingSurveyCompletionsSucceed && surveyIndex < surveys.length) {
	      clearUpcomingSurveyCompletions();
	      setSurveyIndex(surveyIndex + 1);
	    }
	  }, [isSendingUpcomingSurveyCompletionsSucceed]);
	
	  var handleSubmit = function handleSubmit(_ref2) {
	    var id = _ref2.id,
	        value = _ref2.value;
	
	    var body = {
	      assignmentId: surveyAssignmentId,
	      status: _constants.SURVEYS_STATUS_TYPE.IN_PROGRESS,
	      token: (0, _get2.default)(currentSurvey, 'meta.token')
	    };
	
	    if (value) {
	      sendUpcomingSurveyAnswers((0, _extends3.default)({}, body, {
	        answers: {
	          value: value,
	          question_id: id
	        }
	      }));
	    }
	  };
	
	  var handleClose = function handleClose() {
	    if (status === _constants.SURVEYS_STATUS_TYPE.STARTED) {
	      sendUpcomingSurveyCancelFilling({
	        targetUserId: targetUserId,
	        assignmentId: assignmentId,
	        token: (0, _get2.default)(currentSurvey, 'meta.token')
	      });
	    }
	    clearData();
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      width: 'medium',
	      overflowVisible: true,
	      onClose: handleClose,
	      dialogClassName: _index2.default.popup,
	      opened: Boolean(surveyAssignmentId),
	      paperClassName: _index2.default.paperClassName,
	      dialogContetnClassName: _index2.default.dialogContetnClassName,
	      title: formatMessage(_strings.ACTIONS.survey.upcomingHeading, {
	        user: intervieweeName
	      })
	    },
	    surveyAssignmentId && succeed ? _react2.default.createElement(
	      _ExpandableListItem2.default,
	      {
	        locked: true,
	        key: assignmentId,
	        progress: progress,
	        'data-id': assignmentId,
	        header: {
	          list: list,
	          title: name,
	          description: description,
	          subtitle: heading,
	          icon: 'up-surveys',
	          note: expirationStatus,
	          expirationStatus: stepper
	        }
	      },
	      _react2.default.createElement(_SequentialSurvey2.default, {
	        survey: currentSurvey,
	        onSubmit: handleSubmit,
	        setProgress: setProgress
	      })
	    ) : _react2.default.createElement(_Loader2.default, null)
	  );
	};
	
	exports.default = (0, _enhance.enhance)(SurveysPopup);
	
	
	SurveysPopup.propTypes = {
	  surveys: _propTypes2.default.array,
	  assignmentId: _propTypes2.default.number,
	  currentSurvey: _propTypes2.default.object,
	  clearData: _propTypes2.default.func.isRequired,
	  formatMessage: _propTypes2.default.func.isRequired,
	  isUpcomingSurveyRejected: _propTypes2.default.bool,
	  targetUserId: _propTypes2.default.number.isRequired,
	  sendUpcomingSurveyProceed: _propTypes2.default.func.isRequired,
	  sendUpcomingSurveyAnswers: _propTypes2.default.func.isRequired,
	  clearUpcomingSurveyCompletions: _propTypes2.default.func.isRequired,
	  isSendingUpcomingSurveyCompletionsSucceed: _propTypes2.default.bool,
	  sendUpcomingSurveyCancelFilling: _propTypes2.default.func.isRequired
	};

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(2269);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsContent = function TermsContent(_ref) {
	  var content = _ref.content;
	  return _react2.default.createElement('div', { styleName: 'rootText', dangerouslySetInnerHTML: { __html: content } });
	};
	
	TermsContent.propTypes = {
	  content: _propTypes2.default.node
	};
	
	TermsContent.defaultProps = {
	  content: ''
	};
	
	exports.default = (0, _reactCssModules2.default)(TermsContent, _index2.default, { allowMultiple: true });

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _styles = __webpack_require__(5146);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LoaderInPopup() {
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(_Loader2.default, null)
	  );
	}
	
	exports.default = LoaderInPopup;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _getText = __webpack_require__(1939);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _index = __webpack_require__(5148);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextMessage = function TextMessage(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      message = _ref.message,
	      title = _ref.title,
	      icon = _ref.icon,
	      onClick = _ref.onClick,
	      buttonTitle = _ref.buttonTitle,
	      _ref$iconClassName = _ref.iconClassName,
	      iconClassName = _ref$iconClassName === undefined ? "mb4" : _ref$iconClassName,
	      buttonClassName = _ref.buttonClassName;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    icon ? _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)("tc dib", iconClassName) },
	      _react2.default.createElement(_Icon2.default, { name: icon, size: 48 })
	    ) : null,
	    title ? _react2.default.createElement(
	      'p',
	      { styleName: 'title' },
	      (0, _getText.getText)(title, formatMessage)
	    ) : null,
	    _react2.default.createElement(
	      'span',
	      { styleName: 'message' },
	      (0, _getText.getText)(message, formatMessage)
	    ),
	    buttonTitle ? _react2.default.createElement(
	      _Button2.default,
	      { onClick: onClick, color: 'primary', styleName: 'button', raised: true, className: buttonClassName },
	      (0, _getText.getText)(buttonTitle, formatMessage)
	    ) : null
	  );
	};
	
	TextMessage.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  title: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  icon: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  iconClassName: _propTypes2.default.string,
	  buttonClassName: _propTypes2.default.string,
	  buttonTitle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string])
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(TextMessage, _index2.default, { allowMultiple: true }));

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConsentInfo = __webpack_require__(1101);
	
	var _ConsentInfo2 = _interopRequireDefault(_ConsentInfo);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SingConsentButton = __webpack_require__(492);
	
	var _SingConsentButton2 = _interopRequireDefault(_SingConsentButton);
	
	var _useConsentOutcomesInfo = __webpack_require__(798);
	
	var _useConsentOutcomesInfo2 = _interopRequireDefault(_useConsentOutcomesInfo);
	
	var _dateConverters = __webpack_require__(83);
	
	var _virtualVisit = __webpack_require__(305);
	
	var _styles = __webpack_require__(5150);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignConsent = function SignConsent(_ref) {
	  var appointment = _ref.appointment,
	      onDecline = _ref.onDecline,
	      loading = _ref.loading,
	      onSign = _ref.onSign;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var userId = (0, _get2.default)(appointment, 'userId');
	  var consents = (0, _get2.default)(appointment, 'consentsAssignment.consents') || [];
	  var total = (0, _get2.default)(appointment, 'consentsAssignment.consentsCount') || 0;
	  var startTime = (0, _get2.default)(appointment, 'startTime');
	
	  var _useState = (0, _react.useState)(function () {
	    return consents.findIndex(function (c) {
	      return !c.accepted;
	    });
	  }),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      consentIndex = _useState2[0],
	      setConsentIndex = _useState2[1];
	
	  var rawConsent = (0, _react.useMemo)(function () {
	    return consents[consentIndex];
	  }, [consentIndex, consents]);
	
	  var consent = (0, _react.useMemo)(function () {
	    return {
	      name: (0, _get2.default)(rawConsent, 'name'),
	      typeName: (0, _get2.default)(rawConsent, 'consentType.name'),
	      versionTitle: formatMessage({ id: 'common.version' }),
	      version: (0, _get2.default)(rawConsent, 'version'),
	      content: (0, _get2.default)(rawConsent, 'content'),
	      multipleOutcomes: (0, _get2.default)(rawConsent, 'multipleOutcomes', false),
	      outcomeTitles: (0, _get2.default)(rawConsent, 'outcomeTitles', [])
	    };
	  }, [rawConsent]);
	
	  var _useConsentOutcomesIn = (0, _useConsentOutcomesInfo2.default)(consent),
	      buttonAccept = _useConsentOutcomesIn.buttonAccept,
	      consentOutcomeTitles = _useConsentOutcomesIn.consentOutcomeTitles,
	      isConsentHasMultipleOutcomes = _useConsentOutcomesIn.isConsentHasMultipleOutcomes;
	
	  var formattedDate = (0, _react.useMemo)(function () {
	    return (0, _dateConverters.formatDayMonth)(startTime);
	  }, [startTime]);
	
	  var counter = consentIndex + 1 + '/' + total;
	
	  var handleConfirm = (0, _react.useCallback)(function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        outcomeTitle = _ref2.outcomeTitle;
	
	    // eslint-disable-next-line promise/catch-or-return
	    onSign(rawConsent, userId, outcomeTitle).then(function (res) {
	      var index = consentIndex + 1;
	      if (consents[index]) {
	        setConsentIndex(index);
	      } else {
	        dispatch(_virtualVisit.virtualVisitActions.setVisibility(true));
	      }
	      return res;
	    });
	  }, [rawConsent, consentIndex, userId]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.info },
	        formatMessage({ id: 'appointment.consent.titleMsg' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.consent },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.header },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.headerLeft },
	            _react2.default.createElement(_Icon2.default, {
	              name: 'icon-consent',
	              size: 36,
	              className: _styles2.default.headerIcon
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.consentTypeName },
	              consent.typeName
	            )
	          ),
	          formattedDate && _react2.default.createElement(
	            'div',
	            { className: _styles2.default.headerDate },
	            formattedDate
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.consentBody },
	          _react2.default.createElement(_ConsentInfo2.default, { consent: consent, counter: counter })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.footer },
	          onDecline && _react2.default.createElement(
	            _Button2.default,
	            {
	              raised: true,
	              type: 'button',
	              color: 'accent',
	              onClick: onDecline,
	              className: _styles2.default.button
	            },
	            formatMessage({ id: 'common.decline' })
	          ),
	          _react2.default.createElement(_SingConsentButton2.default, {
	            buttonAccept: buttonAccept,
	            handleAcceptConsent: handleConfirm,
	            isConsentHasMultipleOutcomes: isConsentHasMultipleOutcomes,
	            isSignConsentLoading: loading,
	            titles: consentOutcomeTitles
	          })
	        )
	      )
	    )
	  );
	}; /* eslint-disable react/no-danger */
	
	
	SignConsent.propTypes = {
	  appointment: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  onSign: _propTypes2.default.func,
	  onDecline: _propTypes2.default.func
	};
	
	exports.default = SignConsent;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useSignConsentAPI = useSignConsentAPI;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _api = __webpack_require__(1906);
	
	var _error = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useSignConsentAPI(_ref) {
	  var makeUrl = _ref.makeUrl,
	      payload = _ref.payload;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      loading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var signConsent = (0, _react.useCallback)(function () {
	    var consent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var userId = arguments[1];
	    var outcomeTitle = arguments[2];
	    var id = consent.id,
	        version = consent.version;
	
	    setLoading(true);
	
	    return (0, _api.makeAPI)({
	      url: makeUrl(id),
	      method: 'post',
	      headers: {
	        platform: 'P_WEB'
	      },
	      data: (0, _extends3.default)({
	        user_consent_info: (0, _extends3.default)({
	          id: id,
	          version: version,
	          accepted: true,
	          user_id: userId
	        }, outcomeTitle ? { outcome_title: outcomeTitle } : {})
	      }, payload)
	    }).then(function (res) {
	      setLoading(false);
	      return res;
	    }).catch(function (err) {
	      setLoading(false);
	      dispatch(_error.actions.update({ id: 'errors.common' }));
	      throw err;
	    });
	  }, []);
	
	  return {
	    loading: loading,
	    signConsent: signConsent
	  };
	}

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _styles = __webpack_require__(5152);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Placeholder(_ref) {
	  var icon = _ref.icon,
	      title = _ref.title,
	      subtitle = _ref.subtitle,
	      extraSubtitle = _ref.extraSubtitle,
	      subtitleClassName = _ref.subtitleClassName,
	      formatMessage = _ref.intl.formatMessage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.placeholder },
	    icon || _react2.default.createElement(_Icon2.default, {
	      size: 64,
	      name: _brandConfig2.default.logo,
	      style: (0, _extends3.default)({}, _brandConfig.isFlagler && { fill: _brandConfig2.default.fillColor })
	    }),
	    _react2.default.createElement(
	      'span',
	      { className: (0, _classnames2.default)(_styles2.default.title, subtitleClassName) },
	      formatMessage({ id: title })
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: (0, _classnames2.default)(_styles2.default.subtitle, subtitleClassName) },
	      formatMessage({ id: subtitle })
	    ),
	    extraSubtitle && _react2.default.createElement(
	      'span',
	      { className: _styles2.default.subtitle },
	      formatMessage({ id: extraSubtitle })
	    )
	  );
	}
	
	Placeholder.propTypes = {
	  icon: _propTypes2.default.node,
	  intl: _propTypes2.default.object,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  extraSubtitle: _propTypes2.default.string,
	  subtitleClassName: _propTypes2.default.string
	};
	
	exports.default = (0, _reactIntl.injectIntl)(Placeholder);

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _styles2 = __webpack_require__(5157);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MediaIndicator(_ref) {
	  var noVideo = _ref.noVideo,
	      noAudio = _ref.noAudio,
	      pinned = _ref.pinned,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_styles3.default.root, className) },
	    pinned && _react2.default.createElement(_Icon2.default, { name: 'pin', size: 12, style: { fill: _styles.COLORS.white } }),
	    noVideo && _react2.default.createElement(_Icon2.default, { name: 'video-off', size: 12 }),
	    noAudio && _react2.default.createElement(_Icon2.default, { name: 'mute', size: 12 })
	  );
	}
	
	MediaIndicator.propTypes = {
	  noVideo: PropTypes.bool,
	  noAudio: PropTypes.bool,
	  pinned: PropTypes.bool,
	  className: PropTypes.string
	};
	
	exports.default = MediaIndicator;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(2851);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _cuid = __webpack_require__(936);
	
	var _cuid2 = _interopRequireDefault(_cuid);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Message = __webpack_require__(3783);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _context = __webpack_require__(306);
	
	var _notifications = __webpack_require__(672);
	
	var _styles = __webpack_require__(5162);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOTIFICATION_TIME = 5e3;
	
	function VideoNotifications(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      _ref$fullScreenView = _ref.fullScreenView,
	      fullScreenView = _ref$fullScreenView === undefined ? false : _ref$fullScreenView;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      notifications = _useState2[0],
	      setNotifications = _useState2[1];
	
	  var _useContext = (0, _react.useContext)(_context.OTContext),
	      state = _useContext.state;
	
	  var connections = state.connections,
	      speakers = state.speakers,
	      videoWarningIds = state.videoWarningIds;
	
	
	  (0, _react.useEffect)(function () {
	    return (0, _notifications.subscribeToNotification)(handleNewNotification);
	  }, [notifications]);
	
	  var notificationBuilder = (0, _react.useMemo)(function () {
	    return (0, _notifications.makeNotificationBuilder)(formatMessage);
	  }, [formatMessage]);
	
	  var hasSlowConnection = (0, _react.useMemo)(function () {
	    return videoWarningIds.some(function (id) {
	      return speakers.includes(id);
	    });
	  }, [videoWarningIds, speakers]);
	
	  var activeSpeakersNames = (0, _react.useMemo)(function () {
	    var speakersCount = speakers.length;
	    if (speakersCount === 0) return '';
	    if (speakersCount > 2) {
	      return formatMessage({ id: 'virtualVisit.room.multipleTalking' }, { speakersCount: speakersCount });
	    }
	
	    return speakers.map(function (id) {
	      return (0, _get2.default)(connections[id], 'user.name');
	    }).join(', ') + ' ' + formatMessage({ id: 'virtualVisit.room.talking' });
	  }, [connections, speakers]);
	
	  function handleNewNotification(event) {
	    var message = notificationBuilder(event);
	    setNotifications([].concat((0, _toConsumableArray3.default)(notifications), [{ message: message, id: (0, _cuid2.default)() }]));
	  }
	
	  var removeMessage = (0, _react.useCallback)(function (removeId) {
	    return setNotifications(notifications.filter(function (_ref2) {
	      var id = _ref2.id;
	      return id !== removeId;
	    }));
	  }, [notifications]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_styles2.default.root, (0, _defineProperty3.default)({}, _styles2.default.fullScreenMode, fullScreenView))
	    },
	    _react2.default.createElement(
	      _reactTransitionGroup.TransitionGroup,
	      null,
	      notifications.map(function (_ref3) {
	        var message = _ref3.message,
	            id = _ref3.id;
	        return _react2.default.createElement(
	          _reactTransitionGroup.CSSTransition,
	          { key: id, timeout: 500, classNames: 'vv-message' },
	          _react2.default.createElement(_Message2.default, {
	            message: message,
	            timeout: NOTIFICATION_TIME,
	            onClose: function onClose() {
	              return removeMessage(id);
	            },
	            autoClose: true
	          })
	        );
	      }),
	      activeSpeakersNames && _react2.default.createElement(
	        _reactTransitionGroup.CSSTransition,
	        { timeout: 500, classNames: 'vv-message' },
	        _react2.default.createElement(_Message2.default, {
	          message: activeSpeakersNames,
	          slowConnection: hasSlowConnection,
	          formatMessage: formatMessage
	        })
	      )
	    )
	  );
	}
	
	VideoNotifications.propTypes = {
	  intl: PropTypes.object,
	  fullScreenView: PropTypes.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(VideoNotifications);

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _isUndefined = __webpack_require__(733);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InviteGuestPopup = __webpack_require__(3771);
	
	var _InviteGuestPopup2 = _interopRequireDefault(_InviteGuestPopup);
	
	var _context = __webpack_require__(306);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _constants = __webpack_require__(17);
	
	var _routes = __webpack_require__(37);
	
	var _sentryMethods = __webpack_require__(437);
	
	var _shapes = __webpack_require__(351);
	
	var _selectors = __webpack_require__(115);
	
	var _useVirtualVisit2 = __webpack_require__(352);
	
	var _selectors2 = __webpack_require__(64);
	
	var _styles = __webpack_require__(5163);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PublisherBtns(_ref) {
	  var publisher = _ref.publisher,
	      disabled = _ref.disabled;
	  var entity = publisher.entity;
	
	  var _useContext = (0, _react.useContext)(_context.OTContext),
	      endVisit = _useContext.endVisit;
	
	  var inviteType = (0, _reactRedux.useSelector)(_selectors2.selectInvitationTypeFromConfig);
	
	  var _useVirtualVisit = (0, _useVirtualVisit2.useVirtualVisit)(),
	      viewOptions = _useVirtualVisit.viewOptions;
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      opened = _useToggleFlag2[0],
	      open = _useToggleFlag2[1],
	      close = _useToggleFlag2[2];
	
	  var location = (0, _reactRedux.useSelector)(_selectors.currentLocationSelector);
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      hasAudio = _useState2[0],
	      setHasAudio = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      hasVideo = _useState4[0],
	      setHasVideo = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    if (!(0, _isUndefined2.default)((0, _get2.default)(entity, 'stream.hasAudio'))) {
	      setHasAudio((0, _get2.default)(entity, 'stream.hasAudio'));
	    }
	    if (!(0, _isUndefined2.default)((0, _get2.default)(entity, 'stream.hasVideo'))) {
	      setHasVideo((0, _get2.default)(entity, 'stream.hasVideo'));
	    }
	  }, [publisher]);
	
	  var audioIcon = hasAudio ? 'sound-on' : 'mute';
	  var videoIcon = hasVideo ? 'video-on' : 'video-off';
	
	  var handleAudioToggle = function handleAudioToggle() {
	    var newValue = !hasAudio;
	    (0, _sentryMethods.trackUserAction)('[vv/publisher] audio button (' + (newValue ? 'ON' : 'OFF') + ')');
	    entity.publishAudio(newValue);
	    setHasAudio(newValue);
	  };
	  var handleVideoToggle = function handleVideoToggle() {
	    var newValue = !hasVideo;
	    (0, _sentryMethods.trackUserAction)('[vv/publisher] video button (' + (newValue ? 'ON' : 'OFF') + ')');
	    entity.publishVideo(newValue);
	    setHasVideo(newValue);
	  };
	
	  var isVirtualRoom = location === _routes.VIRTUAL_ROOM;
	  var hideCollapseBtn = [_constants.VIRTUAL_VISIT_INVITE_TYPE.IN_OFFICE, _constants.VIRTUAL_VISIT_INVITE_TYPE.GUEST, _constants.VIRTUAL_VISIT_INVITE_TYPE.PATIENT, _constants.VIRTUAL_VISIT_INVITE_TYPE.CONNECTION_ROOM].includes(inviteType);
	
	  var hideInviteButton = [_constants.VIRTUAL_VISIT_INVITE_TYPE.CONNECTION_ROOM, _constants.VIRTUAL_VISIT_INVITE_TYPE.GUEST].includes(inviteType) || viewOptions.fullScreenView;
	
	  var handleEndCall = function handleEndCall() {
	    endVisit();
	    if (isVirtualRoom) _reactRouter.browserHistory.push(_routes.LOGIN);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_styles2.default.root, (0, _defineProperty3.default)({}, _styles2.default.disabled, disabled)) },
	    _react2.default.createElement(
	      'button',
	      { onClick: handleAudioToggle, className: _styles2.default.btn, type: 'button' },
	      _react2.default.createElement(_Icon2.default, { name: audioIcon, size: 32 })
	    ),
	    _react2.default.createElement(
	      'button',
	      { onClick: handleVideoToggle, className: _styles2.default.btn, type: 'button' },
	      _react2.default.createElement(_Icon2.default, { name: videoIcon, size: 32 })
	    ),
	    _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        className: (0, _classnames2.default)(_styles2.default.btn, _styles2.default.hideOnMobView),
	        onClick: viewOptions.toggleFullScreenView
	      },
	      _react2.default.createElement(_Icon2.default, {
	        size: 32,
	        name: viewOptions.fullScreenView ? 'exit-full-screen' : 'full-screen'
	      })
	    ),
	    !hideCollapseBtn && _react2.default.createElement(
	      'button',
	      {
	        onClick: viewOptions.collapseView,
	        className: (0, _classnames2.default)(_styles2.default.btn, _styles2.default.collapseBtn),
	        type: 'button'
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'detach', size: 32 })
	    ),
	    !hideInviteButton && _react2.default.createElement(
	      'button',
	      { onClick: open, className: _styles2.default.btn, type: 'button' },
	      _react2.default.createElement(_Icon2.default, { name: 'invite-user', size: 32 })
	    ),
	    opened ? _react2.default.createElement(_InviteGuestPopup2.default, { opened: opened, onClose: close }) : null,
	    _react2.default.createElement(
	      'button',
	      {
	        className: (0, _classnames2.default)(_styles2.default.btn, _styles2.default.endCall),
	        onClick: handleEndCall,
	        type: 'button'
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'end-call', size: 32 })
	    )
	  );
	} /* eslint-disable react/jsx-handler-names */
	
	
	PublisherBtns.propTypes = {
	  disabled: _propTypes2.default.bool,
	  publisher: _shapes.ConnectionShape
	};
	
	exports.default = PublisherBtns;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(1510);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _shapes = __webpack_require__(351);
	
	var _styles3 = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PatientControls(_ref) {
	  var onPin = _ref.onPin,
	      pinnedId = _ref.pinnedId,
	      _ref$connection = _ref.connection;
	  _ref$connection = _ref$connection === undefined ? {} : _ref$connection;
	  var id = _ref$connection.id;
	
	  var pinned = pinnedId === id;
	  var pinIcon = !pinned ? 'pin' : 'unpin';
	
	  var handlePinToggle = function handlePinToggle(e) {
	    e.stopPropagation();
	    onPin({ id: id });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement('div', { className: _styles2.default.overlay }),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_styles2.default.actions, _styles2.default.patient, (0, _defineProperty3.default)({}, _styles2.default.pinned, pinned))
	      },
	      _react2.default.createElement(
	        'button',
	        { onClick: handlePinToggle, className: _styles2.default.btn, type: 'button' },
	        _react2.default.createElement(_Icon2.default, { name: pinIcon, size: 24, style: { fill: _styles3.COLORS.white } })
	      )
	    )
	  );
	}
	
	PatientControls.propTypes = {
	  connection: _shapes.ConnectionShape,
	  pinnedId: PropTypes.string,
	  onPin: PropTypes.func
	};
	
	exports.default = PatientControls;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useSubscriberControls = useSubscriberControls;
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useSubscriberControls(_ref) {
	  var pinned = _ref.pinned,
	      entity = _ref.entity,
	      onPin = _ref.onPin,
	      id = _ref.id;
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      hasAudio = _useState2[0],
	      setAudio = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      hasVideo = _useState4[0],
	      setVideo = _useState4[1];
	
	  var audioIcon = hasAudio ? 'sound-on' : 'mute';
	  var videoIcon = hasVideo ? 'video-on' : 'video-off';
	  var pinIcon = !pinned ? 'pin' : 'unpin';
	
	  var handleAudioToggle = function handleAudioToggle(e) {
	    e.stopPropagation();
	    if (entity) {
	      entity.subscribeToAudio(!hasAudio);
	      setAudio(!hasAudio);
	    }
	  };
	
	  var handleVideoToggle = function handleVideoToggle(e) {
	    e.stopPropagation();
	    if (entity) {
	      entity.subscribeToVideo(!hasVideo);
	      setVideo(!hasVideo);
	    }
	  };
	
	  var handlePinToggle = function handlePinToggle(e) {
	    e.stopPropagation();
	    onPin({ id: id });
	  };
	
	  return {
	    handleVideoToggle: handleVideoToggle,
	    handleAudioToggle: handleAudioToggle,
	    handlePinToggle: handlePinToggle,
	    audioIcon: audioIcon,
	    videoIcon: videoIcon,
	    pinIcon: pinIcon,
	    hasAudio: hasAudio,
	    hasVideo: hasVideo
	  };
	}

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getTestResults = getTestResults;
	exports.getTestQuality = getTestQuality;
	exports.getNotFoundSelectState = getNotFoundSelectState;
	exports.getCommonResult = getCommonResult;
	exports.getConnectionResult = getConnectionResult;
	
	var _constants = __webpack_require__(1177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXCELLENT = _constants.TEST_RESULT_QUALITY.EXCELLENT,
	    GOOD = _constants.TEST_RESULT_QUALITY.GOOD,
	    FAIR = _constants.TEST_RESULT_QUALITY.FAIR,
	    POOR = _constants.TEST_RESULT_QUALITY.POOR,
	    BAD = _constants.TEST_RESULT_QUALITY.BAD,
	    NOT_FOUND = _constants.TEST_RESULT_QUALITY.NOT_FOUND;
	
	
	function isBetween(quality, res) {
	  return quality.min < res && res < quality.max;
	}
	
	function getSupportedStatus(res, audio) {
	  return audio ? res.audio.supported : res.video.supported;
	}
	
	function getTestResults(res, errors) {
	  var audio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var supported = res ? getSupportedStatus(res, audio) : false;
	  if (!supported || errors) {
	    return {
	      common: audio ? 'virtualVisit.test.audio' : 'virtualVisit.test.video',
	      results: NOT_FOUND
	    };
	  }
	  var result = audio ? res.audio.mos : res.video.mos;
	  var quality = getTestQuality(result);
	  return {
	    common: audio ? 'virtualVisit.test.audioQuality' : 'virtualVisit.test.videoQuality',
	    results: quality
	  };
	}
	
	function getTestQuality(res) {
	  switch (true) {
	    case isBetween(EXCELLENT, res):
	      return EXCELLENT;
	    case isBetween(GOOD, res):
	      return GOOD;
	    case isBetween(FAIR, res):
	      return FAIR;
	    case isBetween(POOR, res):
	      return POOR;
	    default:
	      return BAD;
	  }
	}
	
	function getNotFoundSelectState(formatMessage) {
	  return {
	    audio: {
	      value: 'mic',
	      label: formatMessage({ id: 'virtualVisit.test.noAudio' })
	    },
	    video: {
	      value: 'video',
	      label: formatMessage({ id: 'virtualVisit.test.noVideo' })
	    }
	  };
	}
	
	var getMinMos = function getMinMos(results) {
	  var audioMos = results.audio.mos;
	  var videoMos = results.video.mos;
	  switch (true) {
	    case audioMos < videoMos:
	      return audioMos;
	    case audioMos > videoMos:
	      return videoMos;
	    default:
	      return audioMos;
	  }
	};
	
	function getCommonResult(formatMessage, results, error) {
	  var audioSupported = results && results.audio.supported;
	  var videoSupported = results && results.video.supported;
	  var notFound = error || !audioSupported || !videoSupported;
	  var mos = !notFound ? getMinMos(results) : 0;
	
	  var audioIcon = !audioSupported || error ? NOT_FOUND.icon : '';
	  var videoIcon = !videoSupported || error ? NOT_FOUND.videoIcon : '';
	  var quality = !notFound ? getTestQuality(mos) : (0, _extends3.default)({}, NOT_FOUND, { id: NOT_FOUND.titleId });
	
	  var title = formatMessage({
	    id: 'virtualVisit.test.completed'
	  }) + ': ' + formatMessage({ id: quality.id }) + ' ' + formatMessage({
	    id: 'virtualVisit.test.connectivity'
	  });
	
	  return {
	    title: title,
	    danger: quality.danger,
	    videoIcon: videoIcon,
	    audioIcon: audioIcon
	  };
	}
	
	function getConnectionResult(results) {
	  if (!results) {
	    return {
	      qualityId: 'virtualVisit.test.deviceNotFound',
	      danger: true,
	      videoResultId: 'virtualVisit.test.deviceNotFound',
	      audioResultId: 'virtualVisit.test.deviceNotFound'
	    };
	  }
	
	  var quality = getTestQuality(getMinMos(results));
	  var audio = getTestResults(results, false, true);
	  var video = getTestResults(results, false, false);
	
	  return {
	    qualityId: quality.id,
	    danger: quality.danger,
	    videoResultId: video.results.id,
	    audioResultId: audio.results.id
	  };
	}

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSelect = __webpack_require__(1626);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(5176);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuList = function MenuList(_ref) {
	  var children = _ref.children,
	      isLoading = _ref.isLoading,
	      props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'isLoading']);
	
	  return _react2.default.createElement(
	    _reactSelect.components.MenuList,
	    props,
	    children,
	    isLoading && _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.loaderWrapper },
	      _react2.default.createElement(_Icon2.default, { name: 'loader', size: 24, className: _stylesModule2.default.loader })
	    )
	  );
	};
	
	MenuList.propTypes = {
	  children: _propTypes2.default.node,
	  isLoading: _propTypes2.default.bool
	};
	exports.default = (0, _react.memo)(MenuList);

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _validations = __webpack_require__(81);
	
	var _stylesModule = __webpack_require__(5177);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var escapeRegExp = function escapeRegExp(str) {
	  return str.replace(_validations.PATTERNS.REGEXP_SPECIAL_CHARS, '\\$&');
	};
	
	var OptionLabel = function OptionLabel(option, props) {
	  var inputValue = props.inputValue;
	
	
	  if (!inputValue) return option.label;
	
	  var pattern = escapeRegExp(inputValue);
	  var regex = new RegExp('(' + pattern + ')', 'ig');
	
	  var parts = option.label.split(regex);
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    parts.map(function (part, index) {
	      var key = part + '-' + option.value + '-' + index;
	
	      if (part.toLowerCase() === inputValue.toLowerCase()) {
	        return _react2.default.createElement(
	          'span',
	          { key: key, className: _stylesModule2.default.highlighted },
	          part
	        );
	      }
	      return _react2.default.createElement(
	        'span',
	        { key: key },
	        part
	      );
	    })
	  );
	};
	
	OptionLabel.propTypes = {
	  inputValue: _propTypes2.default.string
	};
	
	exports.default = OptionLabel;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5182);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CardIcon(_ref) {
	  var icon = _ref.icon,
	      size = _ref.size,
	      title = _ref.title,
	      subtitle = _ref.subtitle,
	      info = _ref.info,
	      withBg = _ref.withBg,
	      onClick = _ref.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.withBg, withBg)),
	      onClick: onClick
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.container },
	      _react2.default.createElement(_Icon2.default, { name: icon, size: size, className: 'mr2 flex-shrink-0' }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.desc },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.heading },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.subtitle },
	            subtitle
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.info },
	          info
	        )
	      )
	    )
	  );
	}
	
	CardIcon.defaultProps = {
	  size: 36
	};
	
	CardIcon.propTypes = {
	  icon: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  info: _propTypes2.default.string,
	  withBg: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	};
	
	exports.default = CardIcon;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChartContext = undefined;
	
	var _react = __webpack_require__(1);
	
	var ChartContext = exports.ChartContext = (0, _react.createContext)(null);

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dataConverter = exports.tooltipConverter = undefined;
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _min = __webpack_require__(5513);
	
	var _min2 = _interopRequireDefault(_min);
	
	var _max = __webpack_require__(577);
	
	var _max2 = _interopRequireDefault(_max);
	
	var _mean = __webpack_require__(5510);
	
	var _mean2 = _interopRequireDefault(_mean);
	
	var _uniq = __webpack_require__(380);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _constants = __webpack_require__(114);
	
	var _constants2 = __webpack_require__(54);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BLOOD_PRESSURE = _constants2.VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE,
	    RESPIRATORY_RATE = _constants2.VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE,
	    BODY_SURFACE_AREA = _constants2.VITALS_ACTIVITY_TYPE.BODY_SURFACE_AREA,
	    BODY_TEMPERATURE = _constants2.VITALS_ACTIVITY_TYPE.BODY_TEMPERATURE;
	var tooltipConverter = exports.tooltipConverter = {
	  getDate: function getDate(_ref) {
	    var period = _ref.period,
	        datePoint = _ref.datePoint;
	
	    var dateFormat = _constants.TOOLTIP_DATE_FORMAT[period];
	    return (0, _moment2.default)(datePoint).format(dateFormat);
	  },
	  getDateBy: function getDateBy(_ref2) {
	    var period = _ref2.period,
	        datePoint = _ref2.datePoint;
	
	    var dateFormat = _constants.TOOLTIP_DATE_FORMAT[period];
	    return (0, _moment2.default)(datePoint).format(dateFormat);
	  },
	  getValue: function getValue(_ref3) {
	    var type = _ref3.type,
	        metric = _ref3.metric,
	        shortMetric = _ref3.shortMetric,
	        datasets = _ref3.datasets,
	        _ref3$points = (0, _slicedToArray3.default)(_ref3.points, 1),
	        f = _ref3$points[0];
	
	    switch (type) {
	      case BLOOD_PRESSURE:
	        {
	          var index = f.index,
	              datasetIndex = f.datasetIndex;
	
	          var dataset = datasets[datasetIndex];
	          var code = dataset.label.split('.')[0];
	          var codesDataSet = datasets.filter(function (item) {
	            return item.label.includes(code);
	          });
	
	          if (codesDataSet.length > 1) {
	            var _codesDataSet = (0, _slicedToArray3.default)(codesDataSet, 2),
	                first = _codesDataSet[0],
	                second = _codesDataSet[1];
	
	            return first.data[index] + ' / ' + second.data[index] + ' ' + metric;
	          }
	
	          return '';
	        }
	      case RESPIRATORY_RATE:
	        return f.value + ' ' + metric;
	      case BODY_SURFACE_AREA:
	        return (0, _utils.roundPrecision)(f.value, 1, true) + ' ' + shortMetric + String.fromCharCode(178);
	      case BODY_TEMPERATURE:
	        return (0, _utils.roundPrecision)(f.value, 1, true) + ' ' + metric;
	      default:
	        return '';
	    }
	  }
	};
	
	var dataConverter = exports.dataConverter = {
	  average: {
	    func: function func(vals) {
	      return (0, _values2.default)(vals).map(function (v) {
	        return Math.round((0, _mean2.default)(v.filter(function (e) {
	          return e;
	        })));
	      }).join('/');
	    },
	    label: 'Average'
	  },
	  float: {
	    func: function func(vals, shouldConvertToFahrenheit) {
	      return (0, _values2.default)(vals).map(function (v) {
	        return (0, _mean2.default)(v.filter(function (e) {
	          return e;
	        }));
	      }, 1).map(function (v) {
	        var safeValue = shouldConvertToFahrenheit ? (0, _utils.convertCelsiusToFahrenheit)(v) : v;
	        return (0, _utils.roundPrecision)(safeValue, 1, true);
	      }).join('/');
	    },
	    label: 'Average'
	  },
	  minmax: {
	    func: function func(vals) {
	      return (0, _values2.default)(vals).map(function (v) {
	        return (0, _uniq2.default)([(0, _min2.default)(v), (0, _max2.default)(v)]).join('-');
	      }).join('/');
	    },
	    label: ''
	  }
	};

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useChartFormats = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _constants = __webpack_require__(114);
	
	var _selectors = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CCD = _constants.PROVIDERS.CCD,
	    DEVICES = _constants.PROVIDERS.DEVICES,
	    LOCAL = _constants.PROVIDERS.LOCAL,
	    APPLE = _constants.PROVIDERS.APPLE,
	    FITBIT = _constants.PROVIDERS.FITBIT,
	    WITHINGS = _constants.PROVIDERS.WITHINGS,
	    GOOGLE_FIT = _constants.PROVIDERS.GOOGLE_FIT,
	    TENOVI = _constants.PROVIDERS.TENOVI,
	    I_HEALTH = _constants.PROVIDERS.I_HEALTH;
	var useChartFormats = exports.useChartFormats = function useChartFormats(_ref) {
	  var _ref2;
	
	  var formatMessage = _ref.formatMessage;
	
	  var loggedUser = (0, _reactRedux.useSelector)(_selectors.loggedUserSelector);
	  var targetUser = (0, _reactRedux.useSelector)(_selectors.targetUserSelector);
	  var isMeNotTargetUser = loggedUser.id !== targetUser.id && !(0, _isEmpty2.default)(targetUser);
	  var name = (0, _get2.default)(targetUser, 'firstName', '');
	
	  var concatWithName = function concatWithName(device) {
	    if (isMeNotTargetUser) {
	      return name + '\'s ' + device;
	    }
	    return device;
	  };
	
	  return _ref2 = {}, (0, _defineProperty3.default)(_ref2, _constants.PROVIDER_ALL, formatMessage({ id: 'patient.healthboard.allSources' })), (0, _defineProperty3.default)(_ref2, CCD, formatMessage({ id: 'patient.healthboard.ccd' })), (0, _defineProperty3.default)(_ref2, DEVICES, isMeNotTargetUser ? formatMessage({ id: 'patient.healthboard.userDevices' }, { name: name }) : formatMessage({ id: 'patient.healthboard.myDevices' })), (0, _defineProperty3.default)(_ref2, LOCAL, concatWithName(formatMessage({ id: 'patient.healthboard.local' }))), (0, _defineProperty3.default)(_ref2, APPLE, concatWithName(formatMessage({ id: 'patient.healthboard.apple' }))), (0, _defineProperty3.default)(_ref2, FITBIT, concatWithName(formatMessage({ id: 'patient.healthboard.fitbit' }))), (0, _defineProperty3.default)(_ref2, WITHINGS, concatWithName(formatMessage({ id: 'patient.healthboard.withings' }))), (0, _defineProperty3.default)(_ref2, GOOGLE_FIT, concatWithName(formatMessage({ id: 'patient.healthboard.googleFit' }))), (0, _defineProperty3.default)(_ref2, TENOVI, concatWithName(formatMessage({ id: 'patient.healthboard.tenovi' }))), (0, _defineProperty3.default)(_ref2, I_HEALTH, concatWithName(formatMessage({ id: 'patient.healthboard.iHealth' }))), _ref2;
	};

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TIMELINE = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TIMELINE;
	
	var _constants = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TIMELINE = exports.TIMELINE = (_TIMELINE = {}, (0, _defineProperty3.default)(_TIMELINE, _constants.PERIOD.DAY, {
	  scales: {
	    xAxes: [{
	      type: 'time',
	      time: {
	        unit: 'hour',
	        unitStepSize: 1,
	        displayFormats: { hour: 'h A' }
	      }
	    }]
	  }
	}), (0, _defineProperty3.default)(_TIMELINE, _constants.PERIOD.WEEK, {
	  scales: {
	    xAxes: [{
	      type: 'timecenter',
	      time: {
	        unit: 'day',
	        unitStepSize: 1,
	        displayFormats: { day: 'ddd' }
	      }
	    }]
	  }
	}), (0, _defineProperty3.default)(_TIMELINE, _constants.PERIOD.MONTH, {
	  scales: {
	    xAxes: [{
	      type: 'timecenter',
	      time: {
	        unit: 'day',
	        unitStepSize: 1,
	        displayFormats: { day: 'MMM D' }
	      }
	    }]
	  }
	}), (0, _defineProperty3.default)(_TIMELINE, _constants.PERIOD.QUARTER, {
	  scales: {
	    xAxes: [{
	      type: 'timecenter',
	      time: {
	        unit: 'month',
	        unitStepSize: 1,
	        displayFormats: { month: 'MMM' }
	      }
	    }]
	  }
	}), (0, _defineProperty3.default)(_TIMELINE, _constants.PERIOD.YEAR, {
	  scales: {
	    xAxes: [{
	      type: 'timecenter',
	      time: {
	        unit: 'month',
	        unitStepSize: 1,
	        displayFormats: { month: 'MMM' }
	      }
	    }]
	  }
	}), (0, _defineProperty3.default)(_TIMELINE, _constants.PERIOD.HIGH, {
	  scales: {
	    xAxes: [{
	      type: 'time',
	      time: {
	        unit: _constants.UNIT[_constants.PERIOD.HIGH],
	        unitStepSize: 1,
	        displayFormats: { year: 'YYYY' }
	      }
	    }]
	  }
	}), _TIMELINE);

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TOOLTIP = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _helpers = __webpack_require__(289);
	
	var _constants = __webpack_require__(114);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NAME = _constants.PROVIDER_OPTION.NAME;
	var TOOLTIP = exports.TOOLTIP = {
	  backgroundColor: _styles.COLORS.white,
	  displayColors: false,
	  titleFontColor: _styles.COLORS.grayDark,
	  footerFontColor: _styles.COLORS.grayDark,
	  bodyFontColor: _styles.COLORS.grayDark,
	  titleFontSize: 16,
	  footerFontSize: 11,
	  bodyFontSize: 11,
	  bodyFontFamily: _styles.FONT_FAMILY.primary,
	  titleFontFamily: _styles.FONT_FAMILY.primary,
	  footerFontFamily: _styles.FONT_FAMILY.primary,
	  titleFontStyle: 'bold',
	  labelFontStyle: 'normal',
	  footerFontStyle: 'normal',
	  titleMarginBottom: 6,
	  footerMarginTop: 6,
	  xPadding: 12,
	  yPadding: 12,
	  borderColor: 'rgba(39, 45, 57, 0.05)',
	  cornerRadius: 5,
	  borderWidth: 1,
	  shadowOffsetX: 0,
	  shadowOffsetY: 2,
	  shadowBlur: 10,
	  shadowColor: 'rgba(39, 45, 57, 0.15)',
	  xAlign: 'center',
	  yAlign: 'bottom',
	  callbacks: {
	    title: function title(points, _ref) {
	      var customOptions = _ref.customOptions,
	          datasets = _ref.datasets;
	      var type = customOptions.type,
	          metric = customOptions.metric,
	          shortMetric = customOptions.shortMetric,
	          shouldConvertToFahrenheit = customOptions.shouldConvertToFahrenheit;
	
	      return _helpers.tooltipConverter.getValue({
	        points: points,
	        type: type,
	        metric: metric,
	        datasets: datasets,
	        shortMetric: shortMetric,
	        shouldConvertToFahrenheit: shouldConvertToFahrenheit
	      });
	    },
	    label: function label() {
	      return null;
	    },
	    afterBody: function afterBody(point, _ref2) {
	      var customOptions = _ref2.customOptions;
	      var period = customOptions.period;
	
	      return _helpers.tooltipConverter.getDate({
	        datePoint: point[0] && point[0].label,
	        period: period
	      });
	    },
	    footer: function footer(points, _ref3) {
	      var datasets = _ref3.datasets,
	          customOptions = _ref3.customOptions;
	      var providers = customOptions.providers;
	      var datasetIndex = points[0].datasetIndex;
	
	      var dataset = datasetIndex ? datasets[datasetIndex] : datasets[0];
	      var providerCode = dataset.label.split('.')[0];
	
	      return providers[providerCode][NAME];
	    }
	  },
	  custom: function custom(tooltip) {
	    if (!tooltip.dataPoints) return;
	    var y = Math.min.apply(Math, (0, _toConsumableArray3.default)(tooltip.dataPoints.map(function (point) {
	      return point.y;
	    })));
	    var height = tooltip.height,
	        yPadding = tooltip.yPadding;
	    // eslint-disable-next-line no-param-reassign
	
	    tooltip.y = y - height - yPadding - 5;
	  }
	};

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(2276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SVGCheckbox = function SVGCheckbox(_ref) {
	  var checked = _ref.checked,
	      size = _ref.size;
	
	  var borderRadius = 2;
	  var strokeWidth = 1;
	  var innerSize = size - strokeWidth * 2;
	
	  var width = innerSize;
	  var height = innerSize;
	
	  var rx = borderRadius;
	  var ry = borderRadius;
	  var x = strokeWidth;
	  var y = strokeWidth;
	
	  var startPoint = width * 0.3 + ',' + height * 0.6;
	  var midPoint = width * 0.55 + ',' + height * 0.8;
	  var stopPoint = width * 0.9 + ',' + height * 0.4;
	
	  var checkPath = startPoint + ' ' + midPoint + ' ' + stopPoint;
	
	  return _react2.default.createElement(
	    'svg',
	    {
	      width: size,
	      height: size,
	      styleName: checked ? 'checked' : 'unchecked',
	      className: 'db'
	    },
	    _react2.default.createElement('rect', (0, _extends3.default)({ x: x, y: y, rx: rx, ry: ry, width: width, height: height, strokeWidth: strokeWidth }, {
	      stroke: checked ? _styles.COLORS.blueMedium : _styles.COLORS.fontLighter,
	      fill: 'white'
	    })),
	    checked ? _react2.default.createElement('polyline', {
	      fill: 'none',
	      stroke: _styles.COLORS.blueMedium,
	      strokeWidth: strokeWidth * 2,
	      strokeLinecap: 'round',
	      strokeMiterlimit: '10',
	      points: checkPath
	    }) : null
	  );
	};
	
	SVGCheckbox.propTypes = {
	  checked: _propTypes2.default.bool,
	  size: _propTypes2.default.number
	};
	
	SVGCheckbox.defaultProps = {
	  checked: false,
	  size: 0
	};
	
	exports.default = (0, _reactCssModules2.default)(SVGCheckbox, _index2.default, { allowMultiple: true });

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _date_picker = __webpack_require__(2836);
	
	var _date_picker2 = _interopRequireDefault(_date_picker);
	
	var _theme = __webpack_require__(1829);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DatePickerRoot(props) {
	  return _react2.default.createElement(
	    _reactCssThemr.ThemeProvider,
	    { theme: _theme2.default },
	    _react2.default.createElement(_date_picker2.default, props)
	  );
	}
	
	exports.default = DatePickerRoot;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(5195);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _index = __webpack_require__(5197);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _dialog = __webpack_require__(5196);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { RTButton: _button2.default, RTDatePicker: _index2.default, RTDialog: _dialog2.default };

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(2277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderErrors = function renderErrors(errors) {
	  if (Array.isArray(errors)) {
	    return errors.map(function (error, i, arr) {
	      var isLastItem = i < arr.length - 1;
	      return _react2.default.createElement(
	        'div',
	        { key: i, className: (0, _classnames2.default)({ mb1: isLastItem }) },
	        error
	      );
	    });
	  }
	
	  return errors;
	}; /* eslint-disable react/no-array-index-key,react/require-default-props */
	
	
	var PlainTextErrorBlock = function PlainTextErrorBlock(_ref) {
	  var errors = _ref.errors,
	      style = _ref.style,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ styleName: 'errorMsg' }, { className: className, style: style }),
	    renderErrors(errors)
	  );
	};
	
	PlainTextErrorBlock.propTypes = {
	  errors: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(PlainTextErrorBlock, _index2.default, { allowMultiple: true });

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _props = __webpack_require__(41);
	
	var _strings = __webpack_require__(15);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	exports.default = function (value, formatMessage) {
	  var roleOptions = (0, _react.useMemo)(function () {
	    if (value === _props.CARE_ROLE.PARENT) return _strings.PARENT_OPTIONS;
	    return _strings.FAMILY_MEMBERS_OPTIONS;
	  }, [value]);
	
	  return (0, _convertListWithLocalization.convertRelationsList)(roleOptions, formatMessage);
	};

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _styles = __webpack_require__(18);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _index = __webpack_require__(5202);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var insertActiveMarker = function insertActiveMarker() {
	  var style = {
	    width: 8,
	    height: 8,
	    borderRadius: '50%',
	    backgroundColor: _styles.COLORS.bluePrimary,
	    marginBottom: '4px'
	  };
	
	  return _react2.default.createElement('div', { style: style });
	};
	
	function SimpleMenuItem(_ref) {
	  var active = _ref.active,
	      icon = _ref.icon,
	      onClick = _ref.onClick,
	      text = _ref.text,
	      danger = _ref.danger,
	      borderTop = _ref.borderTop,
	      id = _ref.id,
	      iconSize = _ref.iconSize;
	
	  var iconElement = icon ? _react2.default.createElement(_Icon2.default, {
	    className: 'db mb1',
	    name: icon,
	    size: iconSize,
	    style: { fill: _styles.COLORS.bluePrimary }
	  }) : null;
	
	  var element = _react2.default.createElement(_Card2.default, {
	    text: { primary: text },
	    additionalContent: {
	      left: iconElement,
	      right: active ? insertActiveMarker() : null
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: id,
	      styleName: (0, _classnames2.default)('menu-item', {
	        'menu-item--danger': danger,
	        'menu-item--border-top': borderTop
	      }),
	      onClick: onClick
	    },
	    element
	  );
	}
	
	SimpleMenuItem.propTypes = {
	  active: PropTypes.bool,
	  icon: PropTypes.string,
	  onClick: PropTypes.func,
	  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	  danger: PropTypes.bool,
	  borderTop: PropTypes.bool,
	  iconSize: PropTypes.number,
	  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	
	exports.default = (0, _reactCssModules2.default)(SimpleMenuItem, _index2.default, { allowMultiple: true });

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _InfoContent = __webpack_require__(3861);
	
	var _InfoContent2 = _interopRequireDefault(_InfoContent);
	
	var _index = __webpack_require__(2279);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Info = function Info(_ref) {
	  var value = _ref.value;
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'info' },
	    _react2.default.createElement(_InfoContent2.default, { value: value })
	  );
	};
	
	Info.propTypes = {
	  value: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]).isRequired
	};
	
	exports.default = (0, _reactCssModules2.default)(Info, _index2.default, { allowMultiple: true });

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _findIndex = __webpack_require__(979);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _PickInput = __webpack_require__(3867);
	
	var _PickInput2 = _interopRequireDefault(_PickInput);
	
	var _index = __webpack_require__(2280);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PickList = function PickList(_ref) {
	  var list = _ref.list,
	      name = _ref.name,
	      selectedItems = _ref.selectedItems,
	      onChange = _ref.onChange;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      values = _useState2[0],
	      setValue = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    setValue(selectedItems);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (onChange) onChange(values);
	  }, [values]);
	
	  var handleSelect = function handleSelect(value, isChecked) {
	    var changedValues = values ? [].concat((0, _toConsumableArray3.default)(values)) : [];
	    if (isChecked) {
	      changedValues.push(value);
	    } else {
	      changedValues.splice((0, _findIndex2.default)(values, function (item) {
	        return item === value;
	      }), 1);
	    }
	    setValue(!(0, _isEmpty2.default)(changedValues) ? changedValues : null);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    list && list.map(function (item, index) {
	      return _react2.default.createElement(_PickInput2.default, {
	        key: name + '-' + index,
	        id: name + '-' + index,
	        label: item,
	        name: name,
	        value: item,
	        defaultChecked: selectedItems ? selectedItems.includes(item) : null,
	        onClick: function onClick(e) {
	          return handleSelect(item, e.target.checked);
	        }
	      });
	    })
	  );
	}; /* eslint-disable react/require-default-props,react/no-array-index-key */
	
	
	PickList.propTypes = {
	  list: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  selectedItems: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  onChange: _propTypes2.default.func
	};
	
	exports.default = (0, _reactCssModules2.default)(PickList, _index2.default, { allowMultiple: true });

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(5218);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var EmptyState = function EmptyState(_ref) {
	  var centered = _ref.centered,
	      formatMessage = _ref.intl.formatMessage;
	  return _react2.default.createElement(
	    'div',
	    {
	      styleName: (0, _classnames2.default)({ placeholder: centered }),
	      className: (0, _classnames2.default)({ pt3: !centered })
	    },
	    _react2.default.createElement(_Content2.default, {
	      icon: 'no-invitations',
	      text: formatMessage(_strings.SURVEYS_ANSWERED_EMPTY)
	    })
	  );
	};
	
	EmptyState.propTypes = {
	  centered: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(EmptyState, _index2.default, { allowMultiple: true }));

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _strings = __webpack_require__(15);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExportBtn = function ExportBtn(_ref) {
	  var onClick = _ref.onClick;
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { maxWidth: _styles.BREAKPOINT },
	    function (isMobile) {
	      var additionalClass = isMobile ? 'ph2' : 'ph3';
	      var btnClassName = (0, _classnames2.default)('pv1', additionalClass);
	      var color = isMobile ? 'accent' : 'primary';
	      var iconClassName = (0, _classnames2.default)({ 'mr2 v-btm': !isMobile });
	      var name = isMobile ? 'pdf-mobile' : 'pdf';
	      var width = isMobile ? 24 : 18;
	      var height = isMobile ? 24 : 20;
	
	      return _react2.default.createElement(
	        _Button2.default,
	        (0, _extends3.default)({ color: color, onClick: onClick }, { className: btnClassName, raised: true }),
	        _react2.default.createElement(_Icon2.default, (0, _extends3.default)({ height: height, width: width, name: name }, { className: iconClassName })),
	        !isMobile && _react2.default.createElement(_reactIntl.FormattedMessage, _strings.ACTIONS.survey.exportToPDF)
	      );
	    }
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	ExportBtn.propTypes = {
	  onClick: _propTypes2.default.func
	};
	
	exports.default = ExportBtn;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _vaultAccountTypes = __webpack_require__(1211);
	
	var _styles = __webpack_require__(5220);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioGroup = function RadioGroup(_ref) {
	  var label = _ref.label,
	      name = _ref.name,
	      _onChange = _ref.onChange,
	      radios = _ref.radios,
	      value = _ref.value;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    label && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.label },
	      label
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.wrapper },
	      radios.map(function (radio) {
	        return _react2.default.createElement(
	          'label',
	          { className: _styles2.default.radio, key: radio.value },
	          _react2.default.createElement('input', {
	            type: 'radio',
	            name: name,
	            value: radio.value,
	            onChange: function onChange() {
	              return _onChange(radio.value);
	            },
	            checked: radio.value === value,
	            disabled: radio.isExpired
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_styles2.default.radioLabelWrapper, (0, _defineProperty3.default)({}, _styles2.default.expired, radio.isExpired))
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.radioLabelWrapperHeader },
	              _react2.default.createElement(
	                'div',
	                null,
	                radio.label
	              ),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: (0, _classnames2.default)(_styles2.default.radioAccountType, (0, _defineProperty3.default)({}, _styles2.default.unknownAccountType, radio.accountType === _vaultAccountTypes.UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE))
	                },
	                radio.accountType
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_styles2.default.expDate, (0, _defineProperty3.default)({}, _styles2.default.expDateExpired, radio.isExpired))
	              },
	              formatMessage({ id: 'common.expDate' }) + ': ' + radio.expDate
	            ),
	            radio.isExpired && _react2.default.createElement(
	              'div',
	              { className: _styles2.default.expiredLabel },
	              formatMessage({ id: 'common.expired' })
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	RadioGroup.propTypes = {
	  label: PropTypes.object,
	  name: PropTypes.string,
	  onChange: PropTypes.func,
	  radios: PropTypes.array,
	  value: PropTypes.number
	};
	
	exports.default = (0, _react.memo)(RadioGroup);

/***/ }),
/* 1838 */,
/* 1839 */,
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ScaleInput = __webpack_require__(3873);
	
	var _ScaleInput2 = _interopRequireDefault(_ScaleInput);
	
	var _index = __webpack_require__(2281);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleRange = function ScaleRange(_ref) {
	  var name = _ref.name,
	      list = _ref.list,
	      selectedItem = _ref.selectedItem,
	      _onChange = _ref.onChange;
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    list && list.map(function (item, index) {
	      return _react2.default.createElement(_ScaleInput2.default, {
	        key: name + '-' + index,
	        id: name + '-' + index,
	        label: item,
	        name: name,
	        value: item,
	        opacity: index / list.length,
	        defaultChecked: String(item) === String(selectedItem),
	        onChange: function onChange() {
	          return _onChange(String(item));
	        }
	      });
	    })
	  );
	}; /* eslint-disable react/require-default-props,react/no-array-index-key */
	
	
	ScaleRange.propTypes = {
	  list: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  selectedItem: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	};
	
	ScaleRange.propTypes = {
	  onChange: function onChange() {}
	};
	
	exports.default = (0, _reactCssModules2.default)(ScaleRange, _index2.default, { allowMultiple: true });

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SearchDialogPropTypes = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _isBoolean = __webpack_require__(5505);
	
	var _isBoolean2 = _interopRequireDefault(_isBoolean);
	
	var _debounce = __webpack_require__(176);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _index = __webpack_require__(40);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(16);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _ChipInput = __webpack_require__(1843);
	
	var _ChipInput2 = _interopRequireDefault(_ChipInput);
	
	var _SelectableListWithTabs = __webpack_require__(1842);
	
	var _SelectableListWithTabs2 = _interopRequireDefault(_SelectableListWithTabs);
	
	var _SelectedSizeInfo = __webpack_require__(1195);
	
	var _props = __webpack_require__(41);
	
	var _strings = __webpack_require__(15);
	
	var _index5 = __webpack_require__(2282);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchDialogImpl = function SearchDialogImpl(_ref) {
	  var isOpen = _ref.isOpen,
	      title = _ref.title,
	      buttonTitle = _ref.buttonTitle,
	      searchPlaceholder = _ref.searchPlaceholder,
	      defaultState = _ref.defaultState,
	      onClose = _ref.onClose,
	      onCreate = _ref.onCreate,
	      type = _ref.type,
	      activeChannelId = _ref.activeChannelId,
	      contextUserId = _ref.contextUserId,
	      extraValidation = _ref.extraValidation,
	      defaultIcon = _ref.defaultIcon,
	      children = _ref.children,
	      users = _ref.users,
	      loading = _ref.loading,
	      succeed = _ref.succeed,
	      getUsers = _ref.getUsers,
	      clear = _ref.clear,
	      withTabs = _ref.withTabs,
	      emptyState = _ref.emptyState;
	
	  var _useState = (0, _react.useState)(withTabs ? withTabs[0] : null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  var _useSearchQuery = useSearchQuery(clear),
	      _useSearchQuery2 = (0, _slicedToArray3.default)(_useSearchQuery, 3),
	      query = _useSearchQuery2[0],
	      setQuery = _useSearchQuery2[1],
	      resetSearch = _useSearchQuery2[2];
	
	  var _useSelectedList = useSelectedList(resetSearch),
	      _useSelectedList2 = (0, _slicedToArray3.default)(_useSelectedList, 4),
	      selected = _useSelectedList2[0],
	      deleteSelected = _useSelectedList2[1],
	      addSelected = _useSelectedList2[2],
	      resetSelected = _useSelectedList2[3];
	
	  var debouncedFetch = (0, _react.useCallback)((0, _debounce2.default)(function (search) {
	    var ids = selected.map(function (_ref2) {
	      var id = _ref2.id;
	      return id;
	    });
	
	    if (!search) {
	      return clear();
	    }
	    getUsers({
	      channelId: activeChannelId,
	      userId: contextUserId,
	      query: search,
	      limit: 20,
	      teamSearch: activeTab === _props.SEARCH_TABS.TEAMS,
	      ids: ids,
	      type: type
	    });
	  }, 200), [selected, activeTab]);
	
	  var handleClose = (0, _react.useCallback)(function () {
	    onClose();
	    resetSearch();
	    resetSelected();
	    if (withTabs) setActiveTab(withTabs[0]);
	  }, []);
	
	  var handleChangeInput = function handleChangeInput(value) {
	    setQuery(value);
	    debouncedFetch(value);
	  };
	
	  var handleTabSelect = function handleTabSelect(value) {
	    setActiveTab(value);
	    resetSearch();
	  };
	
	  var handleSubmit = (0, _react.useCallback)(function () {
	    var ids = selected.map(function (_ref3) {
	      var id = _ref3.id;
	      return id;
	    });
	
	    onCreate(ids);
	    handleClose();
	  }, [selected, onCreate]);
	
	  var isFormDisabled = (0, _react.useMemo)(function () {
	    var isExtraInvalid = (0, _isBoolean2.default)(extraValidation) ? !extraValidation : false;
	
	    return (0, _size2.default)(selected) < 1 || isExtraInvalid;
	  }, [selected, extraValidation]);
	
	  return _react2.default.createElement(
	    _index2.default,
	    {
	      opened: isOpen,
	      onClose: handleClose,
	      title: title,
	      width: 'medium',
	      strictClose: true
	    },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'content' },
	      children,
	      _react2.default.createElement(
	        'div',
	        { styleName: 'content-input' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'input-wrapper' },
	          _react2.default.createElement(_ChipInput2.default, {
	            placeholder: searchPlaceholder,
	            onChange: handleChangeInput,
	            onDelete: deleteSelected,
	            selected: selected,
	            value: query,
	            autoFocus: true
	          })
	        ),
	        _react2.default.createElement(
	          _index4.default,
	          {
	            styleName: 'input-button',
	            disabled: isFormDisabled,
	            onClick: handleSubmit,
	            color: 'primary',
	            type: 'button'
	          },
	          buttonTitle
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'list-wrapper' },
	        _react2.default.createElement(_SelectedSizeInfo.SelectedSizeInfo, {
	          size: (0, _size2.default)(selected),
	          textId: _strings.NEW_CHAT.youAddedMembers
	        }),
	        _react2.default.createElement(_SelectableListWithTabs2.default, {
	          withTabs: withTabs,
	          users: users,
	          onTabSelect: handleTabSelect,
	          onSelect: addSelected,
	          loading: loading,
	          succeed: succeed,
	          defaultIcon: defaultIcon,
	          defaultState: defaultState,
	          emptyState: emptyState
	        })
	      )
	    )
	  );
	};
	
	var SearchDialogPropTypes = exports.SearchDialogPropTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  buttonTitle: _propTypes2.default.string.isRequired,
	  searchPlaceholder: _propTypes2.default.string.isRequired,
	  defaultState: _propTypes2.default.string.isRequired,
	  emptyState: _propTypes2.default.string.isRequired,
	  onClose: _propTypes2.default.func.isRequired,
	  onCreate: _propTypes2.default.func.isRequired,
	  type: _propTypes2.default.string,
	  activeChannelId: _propTypes2.default.number,
	  contextUserId: _propTypes2.default.number,
	  withTabs: _propTypes2.default.array
	};
	
	SearchDialogImpl.propTypes = (0, _extends3.default)({}, SearchDialogPropTypes, {
	  users: _propTypes2.default.array.isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  succeed: _propTypes2.default.bool.isRequired,
	  getUsers: _propTypes2.default.func.isRequired,
	  clear: _propTypes2.default.func.isRequired
	});
	
	exports.default = (0, _recompose.compose)((0, _reactCssModules2.default)(_index6.default, { allowMultiple: true }))(SearchDialogImpl);
	
	
	function useSelectedList(clear) {
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      selected = _useState4[0],
	      setSelected = _useState4[1];
	
	  var deleteSelected = (0, _react.useCallback)(function (item) {
	    setSelected(selected.filter(function (_ref4) {
	      var id = _ref4.id;
	      return item.id !== id;
	    }));
	  }, [selected]);
	
	  var addSelected = (0, _react.useCallback)(function (item) {
	    setSelected([].concat((0, _toConsumableArray3.default)(selected), [item]));
	    clear();
	  }, [selected]);
	
	  var resetSelected = (0, _react.useCallback)(function () {
	    setSelected([]);
	  }, []);
	
	  return [selected, deleteSelected, addSelected, resetSelected];
	}
	
	function useSearchQuery(clear) {
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      query = _useState6[0],
	      setQuery = _useState6[1];
	
	  var handleClear = (0, _react.useCallback)(function () {
	    setQuery('');
	    clear();
	  }, []);
	
	  return [query, setQuery, handleClear];
	}

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _filter = __webpack_require__(978);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _find = __webpack_require__(462);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _CommonTabs = __webpack_require__(255);
	
	var _ids = __webpack_require__(46);
	
	var _SelectableList = __webpack_require__(3865);
	
	var _SelectableList2 = _interopRequireDefault(_SelectableList);
	
	var _props = __webpack_require__(41);
	
	var _EmptySearchResults = __webpack_require__(3874);
	
	var _EmptySearchResults2 = _interopRequireDefault(_EmptySearchResults);
	
	var _index = __webpack_require__(5224);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TABS = [{
	  label: 'general.search.tabs.providers',
	  id: _ids.IDS.SEARCH_TABS.PROVIDER,
	  tab: _props.SEARCH_TABS.PROVIDERS
	}, {
	  label: 'general.search.tabs.people',
	  id: _ids.IDS.SEARCH_TABS.PEOPLE,
	  tab: _props.SEARCH_TABS.PEOPLE
	}, {
	  label: 'general.search.tabs.teams',
	  id: _ids.IDS.SEARCH_TABS.TEAMS,
	  tab: _props.SEARCH_TABS.TEAMS,
	  query: 'team_search'
	}];
	
	var SelectableListWithTabs = function SelectableListWithTabs(_ref) {
	  var withTabs = _ref.withTabs,
	      users = _ref.users,
	      onTabSelect = _ref.onTabSelect,
	      onSelect = _ref.onSelect,
	      loading = _ref.loading,
	      succeed = _ref.succeed,
	      defaultIcon = _ref.defaultIcon,
	      defaultState = _ref.defaultState,
	      emptyState = _ref.emptyState;
	
	  var _useState = (0, _react.useState)(withTabs ? withTabs[0] : null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  var tabsOptions = useTabs(withTabs);
	
	  var handleTabSelect = function handleTabSelect(tab) {
	    setActiveTab(tab);
	    onTabSelect(tab);
	  };
	
	  var getContent = function getContent() {
	    return (0, _size2.default)(users) ? _react2.default.createElement(_SelectableList2.default, {
	      white: Boolean(withTabs),
	      items: users,
	      onSelect: onSelect,
	      className: 'overflow-auto h-100',
	      withCounter: true
	    }) : _react2.default.createElement(_EmptySearchResults2.default, {
	      withTabs: Boolean(withTabs),
	      succeed: succeed,
	      loading: loading,
	      defaultState: defaultState,
	      defaultIcon: defaultIcon,
	      emptyState: emptyState
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    withTabs ? _react2.default.createElement(_CommonTabs.CommonTabs, {
	      onTabSelect: handleTabSelect,
	      activeTab: activeTab,
	      tabList: tabsOptions,
	      renderContent: getContent,
	      className: 'w-100 h-100 flex flex-column'
	    }) : getContent()
	  );
	};
	
	SelectableListWithTabs.propTypes = {
	  withTabs: _propTypes2.default.array,
	  users: _propTypes2.default.array,
	  onTabSelect: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  loading: _propTypes2.default.bool,
	  succeed: _propTypes2.default.bool,
	  defaultIcon: _propTypes2.default.string,
	  defaultState: _propTypes2.default.string.isRequired,
	  emptyState: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactCssModules2.default)(SelectableListWithTabs, _index2.default, {
	  allowMultiple: true
	});
	
	
	function useTabs(tabs) {
	  return (0, _react.useMemo)(function () {
	    return (0, _filter2.default)(TABS, function (item) {
	      return !!(0, _find2.default)(tabs, function (tab) {
	        return tab === item.tab;
	      });
	    });
	  }, [tabs]);
	}

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2; /* eslint-disable react/require-default-props,react/prop-types,jsx-a11y/no-autofocus */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5226);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChipInput = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(ChipInput, _Component);
	
	  function ChipInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ChipInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChipInput.__proto__ || (0, _getPrototypeOf2.default)(ChipInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleDelete = function (data) {
	      return function () {
	        var onDelete = _this.props.onDelete;
	
	        onDelete(data);
	      };
	    }, _this.handleChange = function (e) {
	      var onChange = _this.props.onChange;
	
	      onChange(e.target.value);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ChipInput, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          selected = _props.selected,
	          value = _props.value,
	          placeholder = _props.placeholder;
	
	      var showInputComponents = selected.length < 1 && value === '';
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'root' },
	        selected.map(function (item) {
	          var name = item.displayableName || item.username;
	          var additionalClass = (0, _get2.default)(item, 'teamActingUser') ? 'chip--primary' : '';
	
	          return _react2.default.createElement(
	            'div',
	            { styleName: (0, _classnames2.default)('chip', additionalClass), key: item.id },
	            _react2.default.createElement(_Avatar2.default, {
	              children: name && name.charAt(0).toUpperCase(),
	              size: 20,
	              src: (0, _get2.default)(item, 'avatar.thumbMin')
	            }),
	            _react2.default.createElement(
	              'div',
	              { styleName: 'text-wrapper' },
	              _react2.default.createElement(
	                'span',
	                { styleName: 'text', className: 'f-14' },
	                name
	              )
	            ),
	            _react2.default.createElement(
	              _ClickableElement2.default,
	              {
	                styleName: 'icon',
	                onClick: _this2.handleDelete(item)
	              },
	              _react2.default.createElement(_Icon2.default, {
	                name: 'close',
	                size: 10,
	                style: {
	                  fill: _styles.COLORS.white,
	                  stroke: _styles.COLORS.white
	                }
	              })
	            )
	          );
	        }),
	        showInputComponents && _react2.default.createElement(
	          'label',
	          { styleName: 'search-icon' },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'search',
	            style: {
	              fill: _styles.COLORS.cloudyBlue
	            }
	          })
	        ),
	        _react2.default.createElement('input', {
	          autoFocus: true,
	          value: value,
	          onChange: function onChange(e) {
	            return _this2.handleChange(e);
	          },
	          styleName: 'text-field',
	          placeholder: showInputComponents ? placeholder : ''
	        })
	      );
	    }
	  }]);
	  return ChipInput;
	}(_react.Component), _class2.propTypes = {
	  selected: _propTypes2.default.array,
	  onDelete: _propTypes2.default.func,
	  onChange: _propTypes2.default.func
	}, _temp2)) || _class);
	exports.default = ChipInput;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = ShowMore;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(5228);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShowMore(_ref) {
	  var more = _ref.more,
	      less = _ref.less,
	      children = _ref.children,
	      minHeight = _ref.minHeight;
	
	  var contentRef = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(minHeight),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      maxHeight = _useState4[0],
	      setMaxHeight = _useState4[1];
	
	  (0, _react.useLayoutEffect)(function () {
	    if (contentRef.current) setMaxHeight(contentRef.current.offsetHeight);
	  }, [children, contentRef]);
	
	  var safeHeight = maxHeight > minHeight ? minHeight : 'auto';
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        ref: contentRef,
	        className: _styles2.default.content,
	        style: { height: open ? 'auto' : safeHeight }
	      },
	      children
	    ),
	    maxHeight > minHeight && _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        className: _styles2.default.button,
	        onClick: function onClick() {
	          return setOpen(!open);
	        }
	      },
	      open ? less : more
	    )
	  );
	}
	
	ShowMore.propTypes = {
	  more: _propTypes2.default.string,
	  less: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  minHeight: _propTypes2.default.number
	};

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ActionButton = __webpack_require__(1178);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5230);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimpleImagePreview = function SimpleImagePreview(_ref) {
	  var src = _ref.src,
	      onCancel = _ref.onCancel,
	      handleClick = _ref.handleClick,
	      small = _ref.small,
	      className = _ref.className,
	      showCloseBtn = _ref.showCloseBtn,
	      imageClassName = _ref.imageClassName;
	  return _react2.default.createElement(
	    'div',
	    {
	      styleName: (0, _classnames2.default)('root', {
	        'root--small': small
	      }),
	      className: className
	    },
	    _react2.default.createElement('img', {
	      src: src,
	      alt: 'preview',
	      className: imageClassName,
	      onClick: handleClick
	    }),
	    showCloseBtn ? _react2.default.createElement(
	      'div',
	      { styleName: 'icon-close' },
	      _react2.default.createElement(
	        _ActionButton2.default,
	        { onClick: onCancel, ariaLabel: 'close' },
	        _react2.default.createElement(_Icon2.default, { name: 'close', size: 24, style: { fill: _styles.COLORS.white } })
	      )
	    ) : null
	  );
	};
	
	SimpleImagePreview.propTypes = {
	  onCancel: _propTypes2.default.func,
	  handleClick: _propTypes2.default.func,
	  src: _propTypes2.default.string,
	  small: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  imageClassName: _propTypes2.default.string,
	  showCloseBtn: _propTypes2.default.bool
	};
	
	SimpleImagePreview.defaultProps = {
	  className: '',
	  imageClassName: 'fit-cover',
	  handleClick: function handleClick() {}
	};
	
	exports.default = (0, _reactCssModules2.default)(SimpleImagePreview, _index2.default, { allowMultiple: true });

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TermsAndPoliciesContent = __webpack_require__(3884);
	
	var _TermsAndPoliciesContent2 = _interopRequireDefault(_TermsAndPoliciesContent);
	
	var _enhance = __webpack_require__(3885);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsAndPolicies = function TermsAndPolicies(_ref) {
	  var className = _ref.className,
	      text = _ref.text,
	      textLink = _ref.textLink,
	      document = _ref.document;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      showDocument = _useState2[0],
	      toggleDocument = _useState2[1];
	
	  var handleClickDocument = function handleClickDocument(e) {
	    e.preventDefault();
	    toggleDocument(true);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', className: className },
	    text && _react2.default.createElement(
	      'span',
	      { styleName: 'text' },
	      text
	    ),
	    _react2.default.createElement(
	      'span',
	      { styleName: 'textLink', onClick: handleClickDocument },
	      textLink
	    ),
	    showDocument && _react2.default.createElement(_TermsAndPoliciesContent2.default, {
	      title: textLink,
	      document: document,
	      onClose: function onClose() {
	        return toggleDocument(false);
	      }
	    })
	  );
	};
	
	TermsAndPolicies.propTypes = {
	  className: _propTypes2.default.string,
	  text: _propTypes2.default.string,
	  textLink: _propTypes2.default.string,
	  document: _propTypes2.default.node
	};
	
	exports.default = (0, _enhance.enhance)(TermsAndPolicies);

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5241);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tooltip = function Tooltip(_ref) {
	  var content = _ref.content,
	      open = _ref.open,
	      close = _ref.close,
	      top = _ref.top,
	      left = _ref.left,
	      right = _ref.right,
	      bottom = _ref.bottom,
	      width = _ref.width,
	      onClose = _ref.onClose;
	  return _react2.default.createElement(
	    'div',
	    {
	      styleName: (0, _classnames2.default)('tooltip', {
	        'tooltip--open': open,
	        'tooltip--close': close
	      }),
	      style: {
	        top: top,
	        left: left,
	        right: right,
	        bottom: bottom,
	        width: width
	      },
	      onClick: function onClick(e) {
	        return e.stopPropagation();
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      content
	    ),
	    onClose ? _react2.default.createElement(
	      _ClickableElement2.default,
	      {
	        onClick: onClose,
	        className: 'absolute top-0 right-0 pa3 br-100',
	        hoverable: true
	      },
	      _react2.default.createElement(_Icon2.default, {
	        name: 'close',
	        width: 16,
	        style: {
	          transform: 'rotate(180deg)',
	          stroke: _styles.COLORS.cloudyBlue
	        }
	      })
	    ) : null
	  );
	};
	
	Tooltip.propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  open: _propTypes2.default.bool,
	  close: _propTypes2.default.func,
	  top: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  left: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  right: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  bottom: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onClose: _propTypes2.default.func
	};
	
	exports.default = (0, _reactCssModules2.default)(Tooltip, _index2.default, { allowMultiple: true });

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ImageUploader = __webpack_require__(1185);
	
	var _ImageUploader2 = _interopRequireDefault(_ImageUploader);
	
	var _UserDocumentsPreview = __webpack_require__(610);
	
	var _UserDocumentsPreview2 = _interopRequireDefault(_UserDocumentsPreview);
	
	var _index = __webpack_require__(5247);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DocumentsSection = function DocumentsSection(_ref) {
	  var config = _ref.config,
	      documents = _ref.documents,
	      onImageChange = _ref.onImageChange;
	
	  var _ref2 = config || {},
	      sectionTitle = _ref2.sectionTitle,
	      fields = _ref2.fields;
	
	  var filteredDocuments = documents.filter(function (doc) {
	    return doc.attachment && doc.attachment.url;
	  });
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      sectionTitle
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.images },
	      fields.map(function (field) {
	        return _react2.default.createElement(_ImageUploader2.default, (0, _extends3.default)({}, field, {
	          key: field.fieldName,
	          name: field.fieldName,
	          maxFileSize: field.limit,
	          onChange: function onChange(val) {
	            onImageChange(field.fieldName, val, field.id);
	          },
	          errorTextClassName: _index2.default.error
	        }));
	      })
	    ),
	    _react2.default.createElement(_UserDocumentsPreview2.default, { documents: filteredDocuments })
	  );
	};
	
	DocumentsSection.propTypes = {
	  config: _propTypes2.default.object.isRequired,
	  documents: _propTypes2.default.array.isRequired,
	  onImageChange: _propTypes2.default.func.isRequired
	};
	
	exports.default = DocumentsSection;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usePrimaryCareProviderData = undefined;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	var _primaryProviderData = __webpack_require__(1231);
	
	var _selectors = __webpack_require__(43);
	
	var _getPCPDictionaries = __webpack_require__(358);
	
	var _paperworkGetUserDetails = __webpack_require__(122);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(82);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usePrimaryCareProviderData = exports.usePrimaryCareProviderData = function usePrimaryCareProviderData(_ref) {
	  var _ref$isPaperworkFlow = _ref.isPaperworkFlow,
	      isPaperworkFlow = _ref$isPaperworkFlow === undefined ? false : _ref$isPaperworkFlow;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var organizationId = (0, _reactRedux.useSelector)(_selectors.selectProgressOrganizationId);
	  var careUserId = (0, _reactRedux.useSelector)(_selectors.selectProgressCareUserId);
	
	  var patientProfileId = (0, _reactRedux.useSelector)(_paperworkGetUserDetails.selectPaperworkUserId);
	  var paperworkAppointmentOrgId = (0, _reactRedux.useSelector)(_paperworkGetAppointmentDetails.selectPaperworkAppointmentOrgId);
	
	  var primaryProviderData = (0, _reactRedux.useSelector)(_selectors.selectPrimaryProviderData);
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  (0, _react.useEffect)(function () {
	    dispatch(_primaryProviderData.actions.clear());
	
	    dispatch(_primaryProviderData.actions.send({
	      patientUserId: isPaperworkFlow ? patientProfileId : careUserId,
	      organizationId: isPaperworkFlow ? paperworkAppointmentOrgId : organizationId
	    }));
	  }, []);
	
	  var primaryProviderPreloadedData = (0, _react.useMemo)(function () {
	    if (!primaryProviderData) return null;
	
	    return {
	      pcpProviderAnswer: (0, _get2.default)(primaryProviderData, 'answer', null),
	      pcpName: (0, _get2.default)(primaryProviderData, 'pcpName', null),
	      considerUsPcp: (0, _getPCPDictionaries.getInitialPcpFormConsiderUsPcpValue)((0, _get2.default)(primaryProviderData, 'considerUs', null)),
	      pcp: (0, _getPCPDictionaries.convertPrimaryCareProviderDataToFormOption)((0, _get2.default)(primaryProviderData, 'primaryCareProvider', null), (0, _get2.default)(primaryProviderData, 'pcpName', null), formatMessage)
	    };
	  }, [primaryProviderData]);
	
	  return {
	    primaryProviderPreloadedData: primaryProviderPreloadedData
	  };
	};

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _RadioInput = __webpack_require__(1193);
	
	var _RadioInput2 = _interopRequireDefault(_RadioInput);
	
	var _AsyncPaginatedSelect = __webpack_require__(783);
	
	var _AsyncPaginatedSelect2 = _interopRequireDefault(_AsyncPaginatedSelect);
	
	var _primaryProvidersList = __webpack_require__(1232);
	
	var _usePCPWithExtraFieldsForm = __webpack_require__(3899);
	
	var _usePCPWithExtraFieldsForm2 = _interopRequireDefault(_usePCPWithExtraFieldsForm);
	
	var _useAsyncPaginatedSelect = __webpack_require__(1217);
	
	var _useAsyncPaginatedSelect2 = _interopRequireDefault(_useAsyncPaginatedSelect);
	
	var _getPCPDictionaries = __webpack_require__(358);
	
	var _selectors = __webpack_require__(43);
	
	var _index = __webpack_require__(5252);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ids = __webpack_require__(46);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RADIO_BUTTON_GROUP_NAME = 'isUserHasPCP';
	
	var asyncPaginatedSelectConfig = {
	  clearEntitiesAction: _primaryProvidersList.actions.clear,
	  entitiesIsLastPageSelector: _selectors.selectIsOrganizationPrimaryCareProvidersLastPage,
	  entitiesLoadingSelector: _selectors.selectOrganizationPrimaryCareProvidersListLoading,
	  entitiesSelector: _selectors.selectOrganizationPrimaryCareProvidersList,
	  entitiesFetchingSucceedSelector: _selectors.selectFetchingOrganizationPrimaryCareProvidersListSucceed,
	  sendAction: _primaryProvidersList.actions.send
	};
	
	var mapPcpListItemToOption = function mapPcpListItemToOption(entity) {
	  return {
	    label: entity.firstName + ' ' + entity.lastName,
	    value: entity.id
	  };
	};
	
	var PrimaryCareProviderWithExtraFieldsForm = function PrimaryCareProviderWithExtraFieldsForm(_ref) {
	  var handleNext = _ref.handleNext,
	      initialValues = _ref.initialValues,
	      organizationId = _ref.organizationId;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _usePCPWithExtraField = (0, _usePCPWithExtraFieldsForm2.default)(initialValues),
	      considerUsAsYourPCPOptions = _usePCPWithExtraField.considerUsAsYourPCPOptions,
	      formData = _usePCPWithExtraField.formData,
	      handleConsiderUsAsYourPCPChange = _usePCPWithExtraField.handleConsiderUsAsYourPCPChange,
	      handleOptionChange = _usePCPWithExtraField.handleOptionChange,
	      handlePcpNameChange = _usePCPWithExtraField.handlePcpNameChange,
	      handlePcpChange = _usePCPWithExtraField.handlePcpChange,
	      isNextButtonDisabled = _usePCPWithExtraField.isNextButtonDisabled,
	      optionsList = _usePCPWithExtraField.optionsList,
	      pcpNo = _usePCPWithExtraField.pcpNo,
	      pcpYes = _usePCPWithExtraField.pcpYes,
	      setPcpNameFieldRef = _usePCPWithExtraField.setPcpNameFieldRef,
	      showPcpNameField = _usePCPWithExtraField.showPcpNameField;
	
	  var textfieldLabel = formatMessage({ id: 'fields.pcpName' });
	  var selectLabel = formatMessage({ id: 'fields.doYouConsiderUsAsYourPCP' });
	  var selectPcpNameLabel = formatMessage({
	    id: 'fields.pcpName.selectPcpName'
	  });
	  var selectPcpNamePlaceholder = formatMessage({ id: 'common.startTyping' });
	
	  var asyncSelectHookProps = (0, _react.useMemo)(function () {
	    return (0, _extends3.default)({
	      defaultOption: (0, _getPCPDictionaries.getPcpNotListedOption)(formatMessage)
	    }, asyncPaginatedSelectConfig, {
	      additionalRequestParams: { id: organizationId },
	      mapToOptionsFn: mapPcpListItemToOption
	    });
	  }, [formatMessage, organizationId]);
	
	  var _useAsyncPaginatedSel = (0, _useAsyncPaginatedSelect2.default)(asyncSelectHookProps),
	      handleInputChange = _useAsyncPaginatedSel.handleInputChange,
	      entities = _useAsyncPaginatedSel.entities,
	      handleMenuScrollToBottom = _useAsyncPaginatedSel.handleMenuScrollToBottom,
	      isLoading = _useAsyncPaginatedSel.isLoading,
	      shouldPreselectDefaultOption = _useAsyncPaginatedSel.shouldPreselectDefaultOption;
	
	  var onSubmit = function onSubmit(e) {
	    e.preventDefault();
	    handleNext(formData);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (shouldPreselectDefaultOption && pcpYes) {
	      handlePcpChange(asyncSelectHookProps.defaultOption);
	    }
	  }, [shouldPreselectDefaultOption, pcpYes]);
	
	  return _react2.default.createElement(
	    'form',
	    {
	      onSubmit: onSubmit,
	      className: _index2.default.root,
	      id: _ids.IDS.PCP_QUESTIONS_WITH_EXTRA_FIELDS_FORM
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.radioButtonItem },
	      _react2.default.createElement(_RadioInput2.default, {
	        label: optionsList[0].label,
	        value: optionsList[0].value,
	        name: RADIO_BUTTON_GROUP_NAME,
	        checked: pcpYes,
	        onChange: handleOptionChange(optionsList[0].value)
	      })
	    ),
	    pcpYes && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.textField },
	        _react2.default.createElement(_AsyncPaginatedSelect2.default, {
	          handleInputChange: handleInputChange,
	          isLoading: isLoading,
	          label: selectPcpNameLabel,
	          onChange: handlePcpChange,
	          onMenuScrollToBottom: handleMenuScrollToBottom,
	          options: entities,
	          placeholder: selectPcpNamePlaceholder,
	          value: formData.pcp
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.textField, (0, _defineProperty3.default)({}, _index2.default.hideTextField, !showPcpNameField))
	        },
	        _react2.default.createElement(_TextInput2.default, {
	          label: textfieldLabel,
	          onChange: handlePcpNameChange,
	          placeholder: textfieldLabel,
	          setRef: setPcpNameFieldRef,
	          type: 'text',
	          value: formData.pcpName
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.radioButtonItem },
	      _react2.default.createElement(_RadioInput2.default, {
	        label: optionsList[1].label,
	        value: optionsList[1].value,
	        name: RADIO_BUTTON_GROUP_NAME,
	        checked: pcpNo,
	        onChange: handleOptionChange(optionsList[1].value)
	      })
	    ),
	    pcpNo && _react2.default.createElement(
	      'div',
	      { className: _index2.default.selectField },
	      _react2.default.createElement(_SelectCustom2.default, {
	        label: selectLabel,
	        placeholder: selectLabel,
	        options: considerUsAsYourPCPOptions,
	        onChange: handleConsiderUsAsYourPCPChange,
	        value: formData.considerUsPcp
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.radioButtonItem },
	      _react2.default.createElement(_RadioInput2.default, {
	        label: optionsList[2].label,
	        value: optionsList[2].value,
	        name: RADIO_BUTTON_GROUP_NAME,
	        checked: formData.pcpProviderAnswer === optionsList[2].value,
	        onChange: handleOptionChange(optionsList[2].value)
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt4 tr' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          type: 'submit',
	          raised: true,
	          color: 'primary',
	          disabled: isNextButtonDisabled
	        },
	        formatMessage({ id: 'common.next' })
	      )
	    )
	  );
	};
	
	PrimaryCareProviderWithExtraFieldsForm.propTypes = {
	  handleNext: PropTypes.func.isRequired,
	  initialValues: PropTypes.object,
	  organizationId: PropTypes.number
	};
	
	exports.default = (0, _react.memo)(PrimaryCareProviderWithExtraFieldsForm);

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CONSENT_ASSIGNMENT_TYPE = exports.CONSENT_STATUS_MAPPER = exports.CONSENT_STATUS = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _CONSENT_STATUS_MAPPE;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONSENT_STATUS = exports.CONSENT_STATUS = {
	  ACTIVE: 'active',
	  EXPIRED: 'expired',
	  REVOKED: 'revoked'
	};
	
	var CONSENT_STATUS_MAPPER = exports.CONSENT_STATUS_MAPPER = (_CONSENT_STATUS_MAPPE = {}, (0, _defineProperty3.default)(_CONSENT_STATUS_MAPPE, CONSENT_STATUS.ACTIVE, 'documentation.consent.active'), (0, _defineProperty3.default)(_CONSENT_STATUS_MAPPE, CONSENT_STATUS.EXPIRED, 'documentation.consent.expired'), (0, _defineProperty3.default)(_CONSENT_STATUS_MAPPE, CONSENT_STATUS.REVOKED, 'documentation.consent.revoked'), _CONSENT_STATUS_MAPPE);
	
	var CONSENT_ASSIGNMENT_TYPE = exports.CONSENT_ASSIGNMENT_TYPE = {
	  PAPER_CONSENT: 'PaperConsent'
	};

/***/ }),
/* 1852 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DATE_PICKER_DATE_FORMAT = exports.DATE_PICKER_DATE_FORMAT = 'MM-DD-YYYY';
	var DATE_PICKER_DATE_FORMAT_DD_MM_YYYY = exports.DATE_PICKER_DATE_FORMAT_DD_MM_YYYY = 'DD-MM-YYYY';
	var DATE_PICKER_DATE_FORMAT_YYYY_MM_DD = exports.DATE_PICKER_DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD';
	var DATE_PICKER_TODAY_MAX_DATE = exports.DATE_PICKER_TODAY_MAX_DATE = new Date();

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INSURANCES_CARD_KEYS_MAPPER = undefined;
	
	var _map = __webpack_require__(160);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _index = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INSURANCES_CARD_KEYS_MAPPER = exports.INSURANCES_CARD_KEYS_MAPPER = new _map2.default([[_index.INSURANCE_CARD_SIDE.FRONT, _index.DOCUMENTATION_TYPES.CARD_1], [_index.INSURANCE_CARD_SIDE.BACK, _index.DOCUMENTATION_TYPES.CARD_2]]);

/***/ }),
/* 1854 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MEDICATION_STATUSES = exports.MEDICATION_STATUSES = {
	  ACTIVE: 'active',
	  DISCONTINUED: 'discontinued',
	  INACTIVE: 'inactive'
	};

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// this hook is used only for patient form during get care flow
	var useGetIsFieldDisabled = function useGetIsFieldDisabled() {
	  var invalidFieldKeys = (0, _reactRedux.useSelector)(_selectors.selectProfileFormInspectionFieldListErrorsKeys);
	
	  var checkIsFieldDisabled = (0, _react.useCallback)(function (fieldName, validateErrors) {
	    var isFieldErrorExists = (0, _get2.default)(validateErrors, fieldName);
	
	    return !isFieldErrorExists && !invalidFieldKeys.includes(fieldName);
	  }, [invalidFieldKeys]);
	
	  return { checkIsFieldDisabled: checkIsFieldDisabled };
	};
	
	exports.default = useGetIsFieldDisabled;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(23);
	
	var useGetHaveInsuranceLabel = function useGetHaveInsuranceLabel(_ref) {
	  var formatMessage = _ref.formatMessage,
	      targetUserName = _ref.targetUserName,
	      targetUserId = _ref.targetUserId,
	      _ref$withSelfPayEndin = _ref.withSelfPayEnding,
	      withSelfPayEnding = _ref$withSelfPayEndin === undefined ? true : _ref$withSelfPayEndin;
	
	  var loggedUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	
	  var isLoggedUser = loggedUserId === targetUserId;
	
	  var label = (0, _react.useMemo)(function () {
	    if (isLoggedUser) {
	      return formatMessage({ id: 'fields.insurance.haveNotInsurance' });
	    }
	    return formatMessage({ id: 'fields.insurance.patientHaveNotInsurance' }, { name: targetUserName });
	  }, [isLoggedUser, targetUserName]);
	
	  return withSelfPayEnding ? label + ' ' + formatMessage({ id: 'general.labels.or' }) + ' ' + formatMessage({
	    id: 'common.selfPay'
	  }) : label;
	};
	
	exports.default = useGetHaveInsuranceLabel;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _reactIntl = __webpack_require__(5);
	
	var _constants = __webpack_require__(17);
	
	var _formFields = __webpack_require__(38);
	
	var _DOBValidator = __webpack_require__(1943);
	
	var _DOBValidator2 = _interopRequireDefault(_DOBValidator);
	
	var _homePhoneValidator = __webpack_require__(1945);
	
	var _homePhoneValidator2 = _interopRequireDefault(_homePhoneValidator);
	
	var _postalCodeValidator = __webpack_require__(1947);
	
	var _postalCodeValidator2 = _interopRequireDefault(_postalCodeValidator);
	
	var _isDateNotBeforeMinValidator = __webpack_require__(4247);
	
	var _isDateNotBeforeMinValidator2 = _interopRequireDefault(_isDateNotBeforeMinValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRIMARY_SUBSCRIBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PRIMARY_SUBSCRIBER,
	    PHONE_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PHONE_NUMBER,
	    POSTAL_CODE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.POSTAL_CODE,
	    DOB = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DOB;
	
	
	var useValidatePatientInsuranceForm = function useValidatePatientInsuranceForm() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      formErrors = _useState2[0],
	      setFormErrors = _useState2[1];
	
	  var validateFormFields = function validateFormFields(formState) {
	    var errors = {};
	
	    if (!formState[PRIMARY_SUBSCRIBER]) {
	      if (!(0, _postalCodeValidator2.default)(formState[POSTAL_CODE])) {
	        errors.postalCode = formatMessage({
	          id: 'errors.validation.profile.postalCode.format'
	        }, { example: _constants.USA_POSTAL_CODE_EXAMPLES });
	      }
	
	      if (!(0, _homePhoneValidator2.default)(formState[PHONE_NUMBER])) {
	        errors.phoneNumber = formatMessage({
	          id: 'errors.validation.profile.phoneHome.format'
	        });
	      }
	
	      if (!(0, _DOBValidator2.default)(formState[DOB])) {
	        errors.dob = formatMessage({
	          id: 'errors.validation.profile.dob.format'
	        });
	      }
	
	      if (!(0, _isDateNotBeforeMinValidator2.default)(formState[DOB])) {
	        errors.dob = formatMessage({
	          id: 'errors.validation.profile.dob.minDate'
	        });
	      }
	    }
	
	    setFormErrors(errors);
	
	    return { isValid: !((0, _keys2.default)(errors).length > 0), errors: errors };
	  };
	
	  return { formErrors: formErrors, setFormErrors: setFormErrors, validateFormFields: validateFormFields };
	};
	
	exports.default = useValidatePatientInsuranceForm;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(264);
	
	var _mapAccountVaultCardsToItems = __webpack_require__(1916);
	
	var _mapAccountVaultCardsToItems2 = _interopRequireDefault(_mapAccountVaultCardsToItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useDefaultCard = function useDefaultCard() {
	  var cards = (0, _reactRedux.useSelector)(_selectors.selectAccountVaultsList);
	
	  var mappedCards = (0, _react.useMemo)(function () {
	    return cards.map(_mapAccountVaultCardsToItems2.default);
	  }, [cards]);
	
	  var defaultCard = (0, _react.useMemo)(function () {
	    if (mappedCards && mappedCards.length > 0) {
	      return mappedCards.find(function (_ref) {
	        var usedByDefault = _ref.usedByDefault,
	            isExpired = _ref.isExpired;
	        return !!usedByDefault && !isExpired;
	      });
	    }
	    return null;
	  }, [mappedCards]);
	
	  return {
	    defaultCard: defaultCard,
	    mappedCards: mappedCards
	  };
	};
	
	exports.default = useDefaultCard;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useProgramSubscription = function useProgramSubscription(_ref) {
	  var program = _ref.program;
	
	  var _program = (0, _extends3.default)({}, program),
	      _program$subscription = _program.subscriptionOption,
	      subscriptionOption = _program$subscription === undefined ? {} : _program$subscription,
	      _program$subscription2 = _program.subscriptionsSettings,
	      subscriptionsSettings = _program$subscription2 === undefined ? [] : _program$subscription2;
	
	  var subscriptionOptionStatus = (0, _get2.default)(subscriptionOption, 'status');
	
	  var isSubscriptionStatusPending = subscriptionOptionStatus === _constants.SUBSCRIPTION_STATUS.PENDING;
	
	  var prepaidByProvider = subscriptionOptionStatus === _constants.SUBSCRIPTION_STATUS.PREPAID;
	
	  var subscriptionsSettingId = (0, _get2.default)(subscriptionOption, 'subscriptionsSettingId', null);
	
	  var initSubscriptionsSettingId = (0, _react.useMemo)(function () {
	    if (!isSubscriptionStatusPending && subscriptionsSettingId) {
	      return subscriptionsSettingId;
	    }
	
	    return '';
	  }, [subscriptionsSettingId, isSubscriptionStatusPending]);
	
	  var _useState = (0, _react.useState)(initSubscriptionsSettingId),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      selectedMembershipId = _useState2[0],
	      setSelectedMembershipId = _useState2[1];
	
	  var onlyOneSubscriptionOption = subscriptionsSettings.length === 1;
	
	  var moreThanOneSubscriptionOption = subscriptionsSettings.length > 1;
	
	  var subscriptionsSetting = (0, _react.useMemo)(function () {
	    if (onlyOneSubscriptionOption) {
	      return subscriptionsSettings[0];
	    }
	
	    return subscriptionsSettings.find(function (_ref2) {
	      var subscriptionId = _ref2.id;
	      return subscriptionId === selectedMembershipId;
	    });
	  }, [subscriptionsSettings, selectedMembershipId, onlyOneSubscriptionOption]);
	
	  var handleChangeMembershipDuration = function handleChangeMembershipDuration(membershipId) {
	    setSelectedMembershipId(membershipId);
	  };
	
	  return {
	    handleChangeMembershipDuration: handleChangeMembershipDuration,
	    isSubscriptionStatusPending: isSubscriptionStatusPending,
	    moreThanOneSubscriptionOption: moreThanOneSubscriptionOption,
	    prepaidByProvider: prepaidByProvider,
	    selectedMembershipId: selectedMembershipId,
	    subscriptionsSetting: subscriptionsSetting
	  };
	};
	
	exports.default = useProgramSubscription;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(50);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useGenderOptions = function useGenderOptions(formatMessage) {
	  var genderList = (0, _reactRedux.useSelector)(_selectors.selectGenderTypes);
	
	  var genderOptions = (0, _convertListWithLocalization.convertGenderList)(genderList, formatMessage) || [];
	
	  var getGenderTitleByValue = function getGenderTitleByValue(value) {
	    var matchedGenderListItem = genderOptions.find(function (item) {
	      return item.value === value;
	    });
	
	    return (0, _get2.default)(matchedGenderListItem, 'label', null);
	  };
	
	  return { getGenderTitleByValue: getGenderTitleByValue, genderOptions: genderOptions };
	};
	
	exports.default = useGenderOptions;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useScrollTopByElementId = undefined;
	
	var _react = __webpack_require__(1);
	
	var useScrollTopByElementId = exports.useScrollTopByElementId = function useScrollTopByElementId(id) {
	  for (var _len = arguments.length, deps = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    deps[_key - 1] = arguments[_key];
	  }
	
	  (0, _react.useEffect)(function () {
	    var el = document.getElementById(id);
	
	    if (el) {
	      el.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
	    }
	  }, deps);
	};

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appointmentFilterActions = exports.APPOINTMENT_FILTER_TYPES = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = filters;
	
	var _dateFilter = __webpack_require__(310);
	
	var _createAction = __webpack_require__(68);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionsScope = 'appointment-form/filters';
	
	var APPOINTMENT_FILTER_TYPES = exports.APPOINTMENT_FILTER_TYPES = {
	  SET_DATE: actionsScope + '/set-date',
	  SET_LOCATION: actionsScope + '/set-location'
	};
	
	var appointmentFilterActions = exports.appointmentFilterActions = {
	  setDate: (0, _createAction.createAction)(APPOINTMENT_FILTER_TYPES.SET_DATE),
	  setLocation: (0, _createAction.createAction)(APPOINTMENT_FILTER_TYPES.SET_LOCATION)
	};
	
	var initialState = {
	  date: _dateFilter.nowLocalMoment.toISOString(true),
	  location: []
	};
	
	function filters() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case APPOINTMENT_FILTER_TYPES.SET_DATE:
	      {
	        return (0, _extends3.default)({}, state, { date: payload });
	      }
	
	    case APPOINTMENT_FILTER_TYPES.SET_LOCATION:
	      {
	        return (0, _extends3.default)({}, state, { location: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _normalizr = __webpack_require__(1576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inspection = new _normalizr.schema.Entity('inspections', {}, { idAttribute: 'inspectionFor' });
	
	var inspectionListSchema = new _normalizr.schema.Array(inspection);
	
	exports.default = function (data) {
	  return (0, _extends3.default)({}, (0, _normalizr.normalize)(data, inspectionListSchema), {
	    requiredSteps: data.filter(function (_ref) {
	      var completed = _ref.completed;
	      return !completed;
	    }).map(function (item) {
	      return item.inspectionFor;
	    })
	  });
	};

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'check-config-insurance-plan');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'insurance_eligibility',
	  type: 'get',
	  slug: ['configs', {
	    type: 'payload.query',
	    queryParameter: 'user_id',
	    selector: 'userId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'service_id',
	    selector: 'serviceId'
	  }, {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'inspect-consent');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'appointments',
	  type: 'post',
	  slug: ['form_inspections']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'organizations-req', ['FETCH_BY_USER_ID']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'organizations']
	});
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('appointment-form', 'program-based-visits-req');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['userId']
	  }, 'pbv', 'configs', {
	    type: 'payload.query',
	    queryParameter: 'organization_id',
	    selector: 'organizationId'
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handlePriceCalculations = handlePriceCalculations;
	exports.couponUrgentVisit = couponUrgentVisit;
	
	var _effects = __webpack_require__(14);
	
	var _confirmVisitUrgentReq = __webpack_require__(623);
	
	var confirmUrgentVisit = _interopRequireWildcard(_confirmVisitUrgentReq);
	
	var _couponVerificationReq = __webpack_require__(418);
	
	var verifyCouponAvailable = _interopRequireWildcard(_couponVerificationReq);
	
	var _couponPriceCalculationReq = __webpack_require__(667);
	
	var couponPriceCalculation = _interopRequireWildcard(_couponPriceCalculationReq);
	
	var _paymentOrderReq = __webpack_require__(857);
	
	var paymentOrder = _interopRequireWildcard(_paymentOrderReq);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _selectors = __webpack_require__(43);
	
	var _success = __webpack_require__(104);
	
	var successUI = _interopRequireWildcard(_success);
	
	var _error = __webpack_require__(101);
	
	var errorUI = _interopRequireWildcard(_error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handlePriceCalculations),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleRedirectFreePayment),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleProceedStepUrgentVisit),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(verifyCouponUrgentVisit),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(couponUrgentVisit);
	
	function handlePriceCalculations() {
	  var _ref, success;
	
	  return _regenerator2.default.wrap(function handlePriceCalculations$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.race)({
	            success: (0, _effects.take)(couponPriceCalculation.actions.succeed),
	            error: (0, _effects.take)([couponPriceCalculation.actions.rejected, couponPriceCalculation.actions.errorEncountered])
	          });
	
	        case 2:
	          _ref = _context.sent;
	          success = _ref.success;
	
	          if (!success) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)(successUI.actions.update({
	            id: 'appointment.payment.couponCodeAutomatic'
	          }));
	
	        case 7:
	          _context.next = 11;
	          break;
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)(errorUI.actions.update({ id: 'errors.common' }));
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleRedirectFreePayment(_ref2) {
	  var payload = _ref2.payload;
	
	  var _payload, amount;
	
	  return _regenerator2.default.wrap(function handleRedirectFreePayment$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _payload = (0, _extends3.default)({}, payload), amount = _payload.amount;
	
	          if (amount) {
	            _context2.next = 4;
	            break;
	          }
	
	          _context2.next = 4;
	          return (0, _effects.call)(_redirectUtils.redirectToSummary);
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleProceedStepUrgentVisit(_ref3) {
	  var payload = _ref3.payload;
	
	  var _payload2, copay, id, userId;
	
	  return _regenerator2.default.wrap(function handleProceedStepUrgentVisit$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _payload2 = (0, _extends3.default)({}, payload), copay = _payload2.copay, id = _payload2.id;
	          _context3.next = 3;
	          return (0, _effects.select)(_selectors.selectProgressCareUserId);
	
	        case 3:
	          userId = _context3.sent;
	
	          if (copay) {
	            _context3.next = 9;
	            break;
	          }
	
	          _context3.next = 7;
	          return (0, _effects.call)(_redirectUtils.redirectToSummary);
	
	        case 7:
	          _context3.next = 11;
	          break;
	
	        case 9:
	          _context3.next = 11;
	          return (0, _effects.put)(verifyCouponAvailable.actions.send({
	            userId: userId,
	            appointmentId: id
	          }));
	
	        case 11:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function verifyCouponUrgentVisit(_ref4) {
	  var payload = _ref4.payload;
	
	  var _payload3, automaticCouponAvailable, appointmentId;
	
	  return _regenerator2.default.wrap(function verifyCouponUrgentVisit$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _payload3 = (0, _extends3.default)({}, payload), automaticCouponAvailable = _payload3.automaticCouponAvailable;
	          _context4.next = 3;
	          return (0, _effects.select)(_selectors.selectUrgentAppointmentId);
	
	        case 3:
	          appointmentId = _context4.sent;
	
	          if (!automaticCouponAvailable) {
	            _context4.next = 9;
	            break;
	          }
	
	          _context4.next = 7;
	          return (0, _effects.put)(couponPriceCalculation.actions.send({ appointmentId: appointmentId }));
	
	        case 7:
	          _context4.next = 9;
	          return (0, _effects.fork)(handlePriceCalculations);
	
	        case 9:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function couponUrgentVisit() {
	  return _regenerator2.default.wrap(function couponUrgentVisit$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeEvery)([verifyCouponAvailable.actions.succeed], verifyCouponUrgentVisit);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.takeEvery)([confirmUrgentVisit.actions.succeed], handleProceedStepUrgentVisit);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.takeEvery)([paymentOrder.actions.succeed], handleRedirectFreePayment);
	
	        case 6:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('auth', 'login-azure-external-redirect', ['INIT']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.redirect = redirect;
	exports.default = authSaga;
	
	var _effects = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(42);
	
	var _login = __webpack_require__(402);
	
	var login = _interopRequireWildcard(_login);
	
	var _loginAzure = __webpack_require__(340);
	
	var loginAzure = _interopRequireWildcard(_loginAzure);
	
	var _editUser = __webpack_require__(136);
	
	var editUser = _interopRequireWildcard(_editUser);
	
	var _signupReq = __webpack_require__(341);
	
	var _filters = __webpack_require__(260);
	
	var _saved = __webpack_require__(900);
	
	var _selectors = __webpack_require__(93);
	
	var _routes = __webpack_require__(37);
	
	var _storageKeys = __webpack_require__(215);
	
	var _profileEditableReq = __webpack_require__(686);
	
	var profileEditable = _interopRequireWildcard(_profileEditableReq);
	
	var _gtag = __webpack_require__(182);
	
	var _selectors2 = __webpack_require__(403);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(authSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(authSaga);
	
	function replaceIdInHealthBoardRoute(route, id) {
	  if (route.startsWith('' + _routes.HEALTHBOARD)) {
	    var regex = new RegExp('^' + _routes.HEALTHBOARD + '/(\\d+)(/.*)?$');
	
	    return route.replace(regex, _routes.HEALTHBOARD + '/' + id + '$2');
	  }
	
	  return route;
	}
	
	function redirect(loggedUserId) {
	  var communityId = window.storage.getItem(_storageKeys.ACTIVE_COMMUNITY_ID);
	  var redirectToPage = window.storage.getItem(_storageKeys.REDIRECT_TO_PAGE);
	
	  if (redirectToPage) {
	    var redirectRoute = replaceIdInHealthBoardRoute(redirectToPage, loggedUserId);
	
	    _reactRouter.browserHistory.push(redirectRoute);
	    window.storage.removeItem(_storageKeys.REDIRECT_TO_PAGE);
	
	    return;
	  }
	
	  var redirectUrl = communityId ? '/' + _routes.COMMUNITIES + '/' + communityId : '/' + _routes.HEALTHBOARD;
	
	  _reactRouter.browserHistory.push(redirectUrl);
	}
	
	function authSagaWorker() {
	  var loggedUserId, inviteType, isRequestPasswordUpdate, isRegistrationCompleted, isLoggedIn;
	  return _regenerator2.default.wrap(function authSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectLoggedUserId);
	
	        case 2:
	          loggedUserId = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors2.selectAuthStatusInvitationType);
	
	        case 5:
	          inviteType = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectRequestPasswordUpdate);
	
	        case 8:
	          isRequestPasswordUpdate = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors.selectRegistrationCompleted);
	
	        case 11:
	          isRegistrationCompleted = _context.sent;
	
	          if (!(isRequestPasswordUpdate || !isRegistrationCompleted && !inviteType)) {
	            _context.next = 21;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)(profileEditable.actions.send({ userId: loggedUserId }));
	
	        case 15:
	
	          _reactRouter.browserHistory.push(_routes.CHANGE_PASSWORD);
	          _context.next = 18;
	          return (0, _effects.take)(editUser.consts.SUCCEED);
	
	        case 18:
	
	          window.storage.setItem(_storageKeys.REQUEST_PASSWORD_UPDATE, 'false');
	          _context.next = 21;
	          return (0, _effects.put)(login.actions.updatePassword());
	
	        case 21:
	          _context.next = 23;
	          return (0, _effects.select)(_selectors.isLoggedInSelector);
	
	        case 23:
	          isLoggedIn = _context.sent;
	          _context.next = 26;
	          return (0, _effects.put)({ type: _filters.consts.RESTORE });
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.put)({ type: _saved.consts.RESTORE });
	
	        case 28:
	          if (!isLoggedIn) {
	            _context.next = 32;
	            break;
	          }
	
	          _context.next = 31;
	          return (0, _effects.call)(function () {
	            return (0, _gtag.GATrackCustomEvent)(_gtag.CustomEvents.SUCCESS_LOGIN);
	          });
	
	        case 31:
	          redirect(loggedUserId);
	
	        case 32:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function authSaga() {
	  return _regenerator2.default.wrap(function authSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([login.consts.SUCCEED, _signupReq.consts.SUCCEED, loginAzure.consts.SUCCEED], authSagaWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changePasswordActions = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var _constants = __webpack_require__(1238);
	
	var changePasswordActions = exports.changePasswordActions = {
	  proceed: (0, _createAction.createAction)(_constants.CHANGE_PASSWORD_TYPES.PROCEED),
	  confirm: (0, _createAction.createAction)(_constants.CHANGE_PASSWORD_TYPES.CONFIRM)
	};

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _createReducer;
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('board', 'inviteForm', 'UPDATE_FORM', 'CLEAR_FORM');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {};
	
	exports.default = (0, _redux.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, consts.UPDATE_FORM, function (state, action) {
	  return (0, _assign2.default)({}, state, (0, _extends3.default)({}, action.payload));
	}), (0, _defineProperty3.default)(_createReducer, consts.CLEAR_FORM, function (state, action) {
	  return initialState;
	}), _createReducer));

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectRelationshipPriority = exports.selectRootState = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'board');
	};
	
	var selectRelationshipPriority = exports.selectRelationshipPriority = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'relationshipPriority.list', []);
	});

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removedMemberIdSelector = exports.removeParticipantSelector = undefined;
	
	var _reselect = __webpack_require__(60);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removeParticipantSelector = exports.removeParticipantSelector = function removeParticipantSelector(state) {
	  return state.board.reqRemoveParticipant;
	};
	
	var removedMemberIdSelector = exports.removedMemberIdSelector = (0, _reselect.createSelector)(removeParticipantSelector, function (request) {
	  return (0, _get2.default)(request, 'removedMemberId', null);
	});

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.isHealthBoardPage = isHealthBoardPage;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(115);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(isHealthBoardPage);
	
	function isHealthBoardPage() {
	  var location;
	  return _regenerator2.default.wrap(function isHealthBoardPage$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.currentLocationSelector);
	
	        case 2:
	          location = _context.sent;
	          return _context.abrupt('return', location.includes(_routes.HEALTHBOARD));
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.showSocialChatSelectionAlert = showSocialChatSelectionAlert;
	exports.default = socialChatSelectionSaga;
	
	var _effects = __webpack_require__(14);
	
	var _index = __webpack_require__(183);
	
	var _selectors = __webpack_require__(23);
	
	var _context4 = __webpack_require__(216);
	
	var _settings = __webpack_require__(199);
	
	var _popup = __webpack_require__(76);
	
	var _changeProfileReq = __webpack_require__(870);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(showSocialChatSelectionAlert),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(socialChatSelectionWorker),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(socialChatSelectionSaga);
	
	function showSocialChatSelectionAlert() {
	  var socialChatAlert, loggedUserId;
	  return _regenerator2.default.wrap(function showSocialChatSelectionAlert$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectSeenSocialChatAlert);
	
	        case 2:
	          socialChatAlert = _context.sent;
	
	          if (socialChatAlert) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 6:
	          loggedUserId = _context.sent;
	          _context.next = 9;
	          return (0, _effects.put)((0, _popup.socialChatAlertAction)());
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.take)(_popup.actions.hide);
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.put)(_changeProfileReq.actions.send({
	            id: loggedUserId,
	            seenSocialChatAlert: true
	          }));
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function socialChatSelectionWorker(_ref) {
	  var id = _ref.payload;
	  return _regenerator2.default.wrap(function socialChatSelectionWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.call)(showSocialChatSelectionAlert);
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.put)(_context4.actions.clear());
	
	        case 4:
	          _context2.next = 6;
	          return (0, _effects.put)(_settings.actions.removeLastUserId());
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.put)(_settings.actions.setLastSocialId({ id: id }));
	
	        case 8:
	          _context2.next = 10;
	          return (0, _effects.put)(_index.actions.setActiveChannelId(id));
	
	        case 10:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function socialChatSelectionSaga() {
	  return _regenerator2.default.wrap(function socialChatSelectionSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeEvery)([_index.actions.selectSocialChat], socialChatSelectionWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.deletedCommentSaga = deletedCommentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _redux = __webpack_require__(7);
	
	var _commentsList = __webpack_require__(299);
	
	var _postDetails = __webpack_require__(238);
	
	var _postsList = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(deletedCommentWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(deletedCommentSaga);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'deleteComment');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'posts',
	  type: 'delete',
	  slug: [{
	    type: 'payload',
	    selector: ['postId']
	  }, 'comments', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	
	function deletedCommentWorker(action) {
	  var postId;
	  return _regenerator2.default.wrap(function deletedCommentWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          postId = action.payload.postId;
	          _context.next = 3;
	          return (0, _effects.take)(consts.SUCCEED);
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.put)({
	            type: _commentsList.consts.DELETE_COMMENT,
	            payload: action.payload
	          });
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)({
	            type: _postDetails.consts.DELETE_COMMENT
	          });
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)({
	            type: _postsList.consts.POST_COMMENTS_CHANGED,
	            payload: {
	              postId: postId,
	              change: -1
	            }
	          });
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function deletedCommentSaga() {
	  return _regenerator2.default.wrap(function deletedCommentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(consts.SEND, deletedCommentWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.editedCommentSaga = editedCommentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _redux = __webpack_require__(7);
	
	var _commentsList = __webpack_require__(299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(editedCommentWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(editedCommentSaga);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('communities', 'editComment');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'posts',
	  type: 'put',
	  slug: [{
	    type: 'payload',
	    selector: ['postId']
	  }, 'comments', {
	    type: 'payload',
	    selector: ['id']
	  }]
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);
	
	
	function editedCommentWorker(action) {
	  var _action$payload, id, content, parentId;
	
	  return _regenerator2.default.wrap(function editedCommentWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _action$payload = action.payload, id = _action$payload.id, content = _action$payload.content, parentId = _action$payload.parentId;
	          _context.next = 3;
	          return (0, _effects.put)({
	            type: _commentsList.consts.EDIT_COMMENT,
	            payload: {
	              id: id,
	              content: content,
	              parentId: parentId
	            }
	          });
	
	        case 3:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function editedCommentSaga() {
	  return _regenerator2.default.wrap(function editedCommentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(consts.SEND, editedCommentWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	var _removeUserCommunity = __webpack_require__(653);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['LOAD_MEMBERS', 'LOAD_OLDER_MEMBERS', 'CLEAR'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['communities', 'membersList'].concat(supportedActions));
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.LOAD_OLDER_MEMBERS:
	      return [].concat((0, _toConsumableArray3.default)(state), (0, _toConsumableArray3.default)(payload));
	    case consts.LOAD_MEMBERS:
	      return payload;
	    case consts.CLEAR:
	      return [];
	    case _removeUserCommunity.consts.SEND:
	      if (payload.userType === _constants.COMMUNITIES_USER_ROLES.MEMBER) {
	        return state.filter(function (item) {
	          return item.id !== payload.memberId;
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _redux = __webpack_require__(7);
	
	var _removeUserCommunity = __webpack_require__(653);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportedActions = ['LOAD_MODERATORS', 'LOAD_OLDER_MODERATORS', 'CLEAR'];
	
	var consts = exports.consts = _consts2.default.apply(undefined, ['communities', 'moderatorsList'].concat(supportedActions));
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	
	  switch (type) {
	    case consts.LOAD_OLDER_MODERATORS:
	      return [].concat((0, _toConsumableArray3.default)(state), (0, _toConsumableArray3.default)(payload));
	    case consts.LOAD_MODERATORS:
	      return payload;
	    case consts.CLEAR:
	      return [];
	    case _removeUserCommunity.consts.SEND:
	      if (payload.userType === _constants.COMMUNITIES_USER_ROLES.MODERATOR) {
	        return state.filter(function (item) {
	          return item.id !== payload.memberId;
	        });
	      }
	      return state;
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _createReducer;
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('communities', 'postsCreated', 'UPDATE', 'CLEAR');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	exports.default = (0, _redux.createReducer)(0, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, consts.UPDATE, function (state, action) {
	  var newState = state + action.payload;
	
	  return Math.max(newState, 0);
	}), (0, _defineProperty3.default)(_createReducer, consts.CLEAR, function (state, action) {
	  return 0;
	}), _createReducer));

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usersJoinRequestsPaginationSelector = exports.usersJoinRequestsCounterSelector = exports.usersJoinRequestsListSelector = exports.usersJoinRequestsSelector = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _index = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersJoinRequestsSelector = exports.usersJoinRequestsSelector = function usersJoinRequestsSelector(state) {
	  return (0, _get2.default)(state, 'communities.usersJoinRequests');
	};
	
	var usersJoinRequestsListSelector = exports.usersJoinRequestsListSelector = (0, _index.createSelector)(usersJoinRequestsSelector, function (request) {
	  return (0, _get2.default)(request, 'list', []);
	});
	
	var usersJoinRequestsCounterSelector = exports.usersJoinRequestsCounterSelector = (0, _index.createSelector)(usersJoinRequestsSelector, function (request) {
	  return (0, _get2.default)(request, ['meta', 'requestsCount'], 0);
	});
	
	var usersJoinRequestsPaginationSelector = exports.usersJoinRequestsPaginationSelector = (0, _index.createSelector)(usersJoinRequestsSelector, function (state) {
	  return (0, _get2.default)(state, 'pagination', {});
	});

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = complaintCounters;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _actions = __webpack_require__(1933);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _complaintUnResolvedList = __webpack_require__(346);
	
	var unresolvedList = _interopRequireWildcard(_complaintUnResolvedList);
	
	var _complaintResolvedList = __webpack_require__(522);
	
	var resolvedList = _interopRequireWildcard(_complaintResolvedList);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _consts2.default)('complaints', 'counters', 'UPDATE_UNRESOLVED');
	var actions = exports.actions = (0, _actions2.default)(consts);
	
	var initialState = {
	  unresolved: 0,
	  resolved: 0
	};
	
	function complaintCounters() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case unresolvedList.paginationConsts.ADD_META:
	    case resolvedList.paginationConsts.ADD_META:
	    case unresolvedList.consts.ADD_META:
	    case resolvedList.consts.ADD_META:
	      {
	        var unresolved = (0, _get2.default)(action.payload, 'unresolvedComplaintsCount', 0);
	        var resolved = (0, _get2.default)(action.payload, 'resolvedComplaintsCount', 0);
	
	        return (0, _extends3.default)({}, state, {
	          unresolved: unresolved,
	          resolved: resolved
	        });
	      }
	
	    case _constants2.default.NEW_COMPLAINT:
	      {
	        return (0, _extends3.default)({}, state, {
	          unresolved: state.unresolved + 1
	        });
	      }
	
	    case consts.UPDATE_UNRESOLVED:
	      {
	        return (0, _extends3.default)({}, state, {
	          unresolved: state.unresolved - 1
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _logout = __webpack_require__(198);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _consts2.default)('context', 'teamUser', 'ADD', 'ADD_TEAM_ID');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = { user: null, selectedTeamId: null };
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var payload = action.payload,
	      type = action.type;
	
	  switch (type) {
	    case consts.ADD:
	      return (0, _extends3.default)({}, state, {
	        user: payload
	      });
	    case consts.ADD_TEAM_ID:
	      return (0, _extends3.default)({}, state, {
	        selectedTeamId: payload
	      });
	    case _logout.consts.CLEAR:
	      return initialState;
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dashboardSaga = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = dependentManagementRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var appointmentList = _interopRequireWildcard(_appointmentListReq);
	
	var _changeRoomReq = __webpack_require__(657);
	
	var changeRoom = _interopRequireWildcard(_changeRoomReq);
	
	var _locationsReq = __webpack_require__(1275);
	
	var locations = _interopRequireWildcard(_locationsReq);
	
	var _changeStatusReq = __webpack_require__(525);
	
	var changeStatus = _interopRequireWildcard(_changeStatusReq);
	
	var _changePaidStatusReq = __webpack_require__(835);
	
	var changePaidStatus = _interopRequireWildcard(_changePaidStatusReq);
	
	var _pinReq = __webpack_require__(837);
	
	var pinAppointment = _interopRequireWildcard(_pinReq);
	
	var _validatePatientInfoReq = __webpack_require__(1276);
	
	var validatePatientInfo = _interopRequireWildcard(_validatePatientInfoReq);
	
	var _appointmentLocationsReq = __webpack_require__(1274);
	
	var appointmentLocations = _interopRequireWildcard(_appointmentLocationsReq);
	
	var _createAppointmentReq = __webpack_require__(836);
	
	var createAppointmentReq = _interopRequireWildcard(_createAppointmentReq);
	
	var _appointmentDetailsReq = __webpack_require__(524);
	
	var currentAppointmentDetailsReq = _interopRequireWildcard(_appointmentDetailsReq);
	
	var _reloadOnFilterChange = __webpack_require__(4058);
	
	var _reloadOnFilterChange2 = _interopRequireDefault(_reloadOnFilterChange);
	
	var _realTimeCreate = __webpack_require__(4056);
	
	var _realTimeCreate2 = _interopRequireDefault(_realTimeCreate);
	
	var _realTimeUpdate = __webpack_require__(4057);
	
	var _realTimeUpdate2 = _interopRequireDefault(_realTimeUpdate);
	
	var _intervalSaga = __webpack_require__(4055);
	
	var _intervalSaga2 = _interopRequireDefault(_intervalSaga);
	
	var _savePatientInfoSaga = __webpack_require__(4059);
	
	var _savePatientInfoSaga2 = _interopRequireDefault(_savePatientInfoSaga);
	
	var _changeStatusSaga = __webpack_require__(4053);
	
	var _changeStatusSaga2 = _interopRequireDefault(_changeStatusSaga);
	
	var _appointmentDetailsSaga = __webpack_require__(4052);
	
	var _appointmentDetailsSaga2 = _interopRequireDefault(_appointmentDetailsSaga);
	
	var _fetchFilteredAppointmentsSaga = __webpack_require__(4054);
	
	var _fetchFilteredAppointmentsSaga2 = _interopRequireDefault(_fetchFilteredAppointmentsSaga);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(dependentManagementRootSaga);
	
	function dependentManagementRootSaga() {
	  return _regenerator2.default.wrap(function dependentManagementRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(changePaidStatus.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(appointmentList.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(pinAppointment.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(changeStatus.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(changeRoom.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(locations.watcher);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_reloadOnFilterChange2.default);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(_changeStatusSaga2.default);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(_realTimeCreate2.default);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(_realTimeUpdate2.default);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.fork)(_intervalSaga2.default);
	
	        case 22:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	var dashboardSaga = /*#__PURE__*/exports.dashboardSaga = _regenerator2.default.mark(function dashboardSaga() {
	  return _regenerator2.default.wrap(function dashboardSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.fork)(validatePatientInfo.watcher);
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.fork)(appointmentLocations.watcher);
	
	        case 4:
	          _context2.next = 6;
	          return (0, _effects.fork)(createAppointmentReq.watcher);
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.fork)(currentAppointmentDetailsReq.watcher);
	
	        case 8:
	          _context2.next = 10;
	          return (0, _effects.fork)(_appointmentDetailsSaga2.default);
	
	        case 10:
	          _context2.next = 12;
	          return (0, _effects.fork)(_savePatientInfoSaga2.default);
	
	        case 12:
	          _context2.next = 14;
	          return (0, _effects.fork)(_fetchFilteredAppointmentsSaga2.default);
	
	        case 14:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, dashboardSaga, this);
	});

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _documentsUploadReq = __webpack_require__(839);
	
	var documentsUploadReq = _interopRequireWildcard(_documentsUploadReq);
	
	var _documentsDeleteReq = __webpack_require__(658);
	
	var documentsDeleteReq = _interopRequireWildcard(_documentsDeleteReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('dependentForm', 'documents-fetch-list', ['RESET']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'dependent_registration',
	  type: 'get',
	  slug: ['assignments', {
	    type: 'payload',
	    selector: ['id']
	  }, 'documents']
	});
	
	var defaultReqReducer = (0, _redux.createReqReducer)(consts);
	
	var rootState = (0, _extends3.default)({}, _redux.initialState, { list: [] });
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rootState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case documentsUploadReq.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: [].concat((0, _toConsumableArray3.default)(state.list), [action.payload])
	        });
	      }
	
	    case documentsDeleteReq.consts.DELETE_SUCCESS:
	      {
	        return (0, _extends3.default)({}, state, {
	          list: state.list.filter(function (_ref) {
	            var id = _ref.id;
	            return id !== action.payload;
	          })
	        });
	      }
	
	    case consts.RESET:
	      {
	        return rootState;
	      }
	    default:
	      {
	        return defaultReqReducer(state, action);
	      }
	  }
	};

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('health-board', 'appointment-filters', ['SET']);
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var initialState = {
	  isFilterToday: true,
	  isFilterByTypeVisit: false
	};
	
	var clear = function clear(state) {
	  return (0, _extends3.default)({}, state, initialState);
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	  var type = action.type;
	
	
	  switch (type) {
	    case consts.CLEAR:
	      return clear(state);
	
	    case consts.SET:
	      return (0, _extends3.default)({}, state, action.payload);
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handlePostMessage = handlePostMessage;
	exports.default = payaPaymentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _reduxSaga = __webpack_require__(485);
	
	var _popup = __webpack_require__(76);
	
	var popup = _interopRequireWildcard(_popup);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _selectors = __webpack_require__(50);
	
	var _env = __webpack_require__(103);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(payaPaymentSaga);
	
	function handlePostMessage() {
	  return (0, _reduxSaga.eventChannel)(function (emitter) {
	    window.addEventListener('message', receiveMessage, false);
	    function receiveMessage(event) {
	      if (event.origin !== _env.PAYA_ORIGIN) return;
	      var payload = JSON.parse(event.data);
	      emitter(payload);
	      emitter(_reduxSaga.END);
	    }
	
	    return function () {
	      window.removeEventListener('message', receiveMessage, false);
	    };
	  });
	}
	
	function payaPaymentSaga() {
	  var delaySeconds, postMessageChannel, result;
	  return _regenerator2.default.wrap(function payaPaymentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors.selectPaymentDelaySeconds);
	
	        case 2:
	          delaySeconds = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.call)(handlePostMessage);
	
	        case 5:
	          postMessageChannel = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.fork)( /*#__PURE__*/_regenerator2.default.mark(function paymentTimeout() {
	            return _regenerator2.default.wrap(function paymentTimeout$(_context) {
	              while (1) {
	                switch (_context.prev = _context.next) {
	                  case 0:
	                    _context.next = 2;
	                    return (0, _effects.delay)(delaySeconds * 1000);
	
	                  case 2:
	                    _context.next = 4;
	                    return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.paymentTimeout());
	
	                  case 4:
	                    _context.next = 6;
	                    return (0, _effects.put)(popup.actions.hide());
	
	                  case 6:
	                  case 'end':
	                    return _context.stop();
	                }
	              }
	            }, paymentTimeout, this);
	          }));
	
	        case 8:
	          _context2.prev = 8;
	
	        case 9:
	          if (false) {
	            _context2.next = 23;
	            break;
	          }
	
	          _context2.next = 12;
	          return (0, _effects.take)(postMessageChannel);
	
	        case 12:
	          result = _context2.sent;
	
	          if (!(result.status_id === 301)) {
	            _context2.next = 16;
	            break;
	          }
	
	          _context2.next = 16;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.paymentFail());
	
	        case 16:
	          if (!(result.status_id === 102)) {
	            _context2.next = 19;
	            break;
	          }
	
	          _context2.next = 19;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.paymentSuccess());
	
	        case 19:
	          _context2.next = 21;
	          return (0, _effects.put)(popup.actions.hide());
	
	        case 21:
	          _context2.next = 9;
	          break;
	
	        case 23:
	          _context2.prev = 23;
	          _context2.next = 26;
	          return (0, _effects.cancelled)();
	
	        case 26:
	          if (!_context2.sent) {
	            _context2.next = 28;
	            break;
	          }
	
	          postMessageChannel.close();
	
	        case 28:
	          return _context2.finish(23);
	
	        case 29:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked, this, [[8,, 23, 29]]);
	}

/***/ }),
/* 1889 */,
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.checkInsuranceCardOcr = checkInsuranceCardOcr;
	
	var _effects = __webpack_require__(14);
	
	var _constants = __webpack_require__(17);
	
	var _formFields = __webpack_require__(38);
	
	var _checkUploadedInsuranceCardOcr = __webpack_require__(1313);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(checkInsuranceCardOcr);
	
	var MEMBER_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.MEMBER_ID,
	    GROUP_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GROUP_NUMBER,
	    HEALTH_PLAN = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.HEALTH_PLAN;
	
	
	var mapCheckOcrResultToFormValues = function mapCheckOcrResultToFormValues(result) {
	  var data = {};
	
	  if (!result) return data;
	
	  var fields = result.fields;
	
	  var _fields = (0, _extends3.default)({}, fields),
	      payer = _fields.payer,
	      memberId = _fields.memberId,
	      groupNumber = _fields.groupNumber;
	
	  var _payer = (0, _extends3.default)({}, payer),
	      id = _payer.id,
	      name = _payer.name;
	
	  if (memberId) {
	    data[MEMBER_ID] = memberId;
	  }
	
	  if (groupNumber) {
	    data[GROUP_NUMBER] = groupNumber;
	  }
	
	  if (id && name) {
	    data[HEALTH_PLAN] = {
	      id: id,
	      value: name,
	      label: name
	    };
	  } else {
	    data[HEALTH_PLAN] = null;
	  }
	
	  return data;
	};
	
	function checkInsuranceCardOcr(payload) {
	  var userId, handleFormChange, recordType, recordId, _payload$additionalDa, additionalDataToUpdate, checkOcrResult, checkOcrPayload, formValues;
	
	  return _regenerator2.default.wrap(function checkInsuranceCardOcr$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          userId = payload.userId, handleFormChange = payload.handleFormChange, recordType = payload.recordType, recordId = payload.recordId, _payload$additionalDa = payload.additionalDataToUpdate, additionalDataToUpdate = _payload$additionalDa === undefined ? {} : _payload$additionalDa;
	          _context.next = 3;
	          return (0, _effects.put)(_checkUploadedInsuranceCardOcr.actions.send({
	            record_type: recordType,
	            record_id: recordId,
	            ocr_context: _constants.OCR_CONTEXT.INSURANCE_CARD,
	            userId: userId
	          }));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.take)(_checkUploadedInsuranceCardOcr.consts.SUCCEED);
	
	        case 5:
	          checkOcrResult = _context.sent;
	          checkOcrPayload = checkOcrResult.payload;
	          _context.next = 9;
	          return (0, _effects.call)(mapCheckOcrResultToFormValues, checkOcrPayload);
	
	        case 9:
	          formValues = _context.sent;
	
	
	          handleFormChange((0, _extends3.default)({}, formValues, additionalDataToUpdate));
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.editUserAfterInsuranceUpdate = editUserAfterInsuranceUpdate;
	
	var _effects = __webpack_require__(14);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _editUser = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(editUserAfterInsuranceUpdate);
	
	function editUserAfterInsuranceUpdate(payload) {
	  var userId, skipInsurance, finishAction, flowType;
	  return _regenerator2.default.wrap(function editUserAfterInsuranceUpdate$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          userId = payload.userId, skipInsurance = payload.skipInsurance, finishAction = payload.finishAction, flowType = payload.flowType;
	          _context.next = 3;
	          return (0, _effects.put)(_editUser.actions.send({
	            id: userId,
	            skipInsurance: skipInsurance
	          }));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.take)(_editUser.consts.SUCCEED);
	
	        case 5:
	          if (![_insuranceFlowType.INSURANCE_FLOW_TYPE.PAPERWORK].includes(flowType)) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 8;
	          return (0, _effects.put)(_editUser.actions.clear());
	
	        case 8:
	          if (!finishAction) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.call)(finishAction);
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectIsInsuranceDeleteSucceeded = exports.selectInsuranceIsDeleting = exports.selectRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'managePatientInsurances.deletePatientInsurance');
	};
	
	var selectInsuranceIsDeleting = exports.selectInsuranceIsDeleting = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectIsInsuranceDeleteSucceeded = exports.selectIsInsuranceDeleteSucceeded = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'succeed', false);
	});

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OTSignal = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(420);
	
	var _reduxEmitter = __webpack_require__(865);
	
	var _sentryMethods = __webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OTSignal = exports.OTSignal = (_temp = _class = function (_ReduxEmitter) {
	  (0, _inherits3.default)(OTSignal, _ReduxEmitter);
	
	  function OTSignal(_ref) {
	    var dispatch = _ref.dispatch,
	        otSession = _ref.otSession;
	    (0, _classCallCheck3.default)(this, OTSignal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (OTSignal.__proto__ || (0, _getPrototypeOf2.default)(OTSignal)).call(this, dispatch));
	
	    _this.handleVisitDuration = function (data) {
	      if (!data) return;
	      _this.dispatchSetConnectionTime(data);
	    };
	
	    _this.handleSetDurationData = function (data) {
	      if (!data) return;
	      _this.dispatchSetDurationData(data);
	    };
	
	    _this.handlePendingInvitations = function (data) {
	      if (!data) return;
	      _this.dispatchUpdateInvitations(data);
	    };
	
	    _this.handleSignal = function (event) {
	      switch (event.type) {
	        case _constants.SIGNAL.VISIT_DURATION:
	          {
	            console.log('[ot-signal] p2p visit duration', event.data);
	            _this.handleVisitDuration(event.data);
	            break;
	          }
	        case _constants.SIGNAL.VISIT_METADATA:
	          {
	            var data = event.data;
	
	            console.log('[ot-signal] visit metadata', data);
	            _this.handleSetDurationData(data);
	            break;
	          }
	        case _constants.SIGNAL.PENDING_INVITATIONS:
	          {
	            console.log('[ot-signal] invitation signal', event.data);
	            _this.handlePendingInvitations(event.data);
	            break;
	          }
	        case _constants.SIGNAL.PROVIDER_CONNECTED:
	          {
	            console.info('[ot-signal] =============PROVIDER CONNECTED===========');
	            (0, _sentryMethods.trackAppAction)('[ot-signal] provider connected');
	            OTSignal.handleProviderJoin();
	            break;
	          }
	        case _constants.SIGNAL.VISIT_ENDED:
	          {
	            var _data = event.data;
	
	            console.info('[ot-signal] =============END VISIT ===========', _data);
	            (0, _sentryMethods.trackAppAction)('[ot-signal] end visit: ' + (0, _get2.default)(_data, 'status'));
	            OTSignal.handleProviderFinishCall((0, _get2.default)(_data, 'status'));
	            break;
	          }
	        default:
	          break;
	      }
	    };
	
	    _this.otSession = otSession;
	    return _this;
	  }
	
	  (0, _createClass3.default)(OTSignal, [{
	    key: 'setupListeners',
	    value: function setupListeners() {
	      if (!this.session) return;
	      console.log('[ot-signal] setup listeners');
	
	      this.session.on('signal', this.handleSignal);
	    }
	  }, {
	    key: 'clearListeners',
	    value: function clearListeners() {
	      if (!this.session) return;
	      console.log('[ot-signal] clear listeners');
	      this.session.off('signal', this.handleSignal);
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      this.setupListeners();
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.clearListeners();
	      console.info('[ot-signal] destroyed signal');
	    }
	  }, {
	    key: 'session',
	    get: function get() {
	      if (!this.otSession || !this.otSession.session) {
	        console.warn('[ot-signal] no session');
	        return null;
	      }
	
	      return this.otSession.session;
	    }
	
	    // Use for connectionRoom p2p
	
	
	    // Use for Virtual and Urgent Visit
	
	  }]);
	  return OTSignal;
	}(_reduxEmitter.ReduxEmitter), _class.handleProviderJoin = function () {}, _class.handleProviderFinishCall = function () {}, _temp);

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEVICE_PERMISSION_TYPES = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _RequestGif, _DeniedGif, _DeniedDescription, _MobDescriptionMap;
	
	exports.getRequestPermissionData = getRequestPermissionData;
	exports.getDeniedPermissionData = getDeniedPermissionData;
	exports.hasDevicePermissions = hasDevicePermissions;
	
	var _bowser = __webpack_require__(1397);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _hEdge = __webpack_require__(5271);
	
	var _hEdge2 = _interopRequireDefault(_hEdge);
	
	var _hEdge3 = __webpack_require__(5270);
	
	var _hEdge4 = _interopRequireDefault(_hEdge3);
	
	var _hChrome = __webpack_require__(5269);
	
	var _hChrome2 = _interopRequireDefault(_hChrome);
	
	var _hChrome3 = __webpack_require__(5268);
	
	var _hChrome4 = _interopRequireDefault(_hChrome3);
	
	var _hSafati = __webpack_require__(5273);
	
	var _hSafati2 = _interopRequireDefault(_hSafati);
	
	var _hSafari = __webpack_require__(5272);
	
	var _hSafari2 = _interopRequireDefault(_hSafari);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var browser = _bowser2.default.parse(window.navigator.userAgent);
	var os = browser.os.name;
	var browserName = browser.browser.name;
	var details = navigator.userAgent;
	
	/* Creating a regular expression
	      containing some mobile devices keywords
	      to search it in details string */
	
	/* Using test() method to search regexp in details
	      it returns boolean value */
	var regexp = /android|iphone|kindle|ipad/i;
	var isMobileDevice = regexp.test(details);
	
	var isMobile = browser.platform.type === _bowser2.default.PLATFORMS_MAP.mobile || browser.platform.type === _bowser2.default.PLATFORMS_MAP.tablet || isMobileDevice;
	
	var RequestGif = (_RequestGif = {}, (0, _defineProperty3.default)(_RequestGif, _bowser2.default.BROWSER_MAP.edge, _hEdge4.default), (0, _defineProperty3.default)(_RequestGif, _bowser2.default.BROWSER_MAP.opera, _hChrome4.default), (0, _defineProperty3.default)(_RequestGif, _bowser2.default.BROWSER_MAP.chrome, _hChrome4.default), (0, _defineProperty3.default)(_RequestGif, _bowser2.default.BROWSER_MAP.safari, _hSafari2.default), (0, _defineProperty3.default)(_RequestGif, _bowser2.default.BROWSER_MAP.firefox, _hChrome4.default), _RequestGif);
	
	var DeniedGif = (_DeniedGif = {}, (0, _defineProperty3.default)(_DeniedGif, _bowser2.default.BROWSER_MAP.edge, _hEdge2.default), (0, _defineProperty3.default)(_DeniedGif, _bowser2.default.BROWSER_MAP.opera, _hChrome2.default), (0, _defineProperty3.default)(_DeniedGif, _bowser2.default.BROWSER_MAP.chrome, _hChrome2.default), (0, _defineProperty3.default)(_DeniedGif, _bowser2.default.BROWSER_MAP.safari, _hSafati2.default), (0, _defineProperty3.default)(_DeniedGif, _bowser2.default.BROWSER_MAP.firefox, _hChrome2.default), _DeniedGif);
	
	var DeniedDescription = (_DeniedDescription = {}, (0, _defineProperty3.default)(_DeniedDescription, _bowser2.default.BROWSER_MAP.edge, 'media.permissions.denied.chrome'), (0, _defineProperty3.default)(_DeniedDescription, _bowser2.default.BROWSER_MAP.opera, 'media.permissions.denied.chrome'), (0, _defineProperty3.default)(_DeniedDescription, _bowser2.default.BROWSER_MAP.chrome, 'media.permissions.denied.chrome'), (0, _defineProperty3.default)(_DeniedDescription, _bowser2.default.BROWSER_MAP.safari, 'media.permissions.denied.safari'), (0, _defineProperty3.default)(_DeniedDescription, _bowser2.default.BROWSER_MAP.firefox, 'media.permissions.denied.chrome'), _DeniedDescription);
	
	var MobDescriptionMap = (_MobDescriptionMap = {}, (0, _defineProperty3.default)(_MobDescriptionMap, _bowser2.default.OS_MAP.iOS + '_' + _bowser2.default.BROWSER_MAP.safari, 'media.permissions.mob.safari'), (0, _defineProperty3.default)(_MobDescriptionMap, _bowser2.default.OS_MAP.iOS + '_' + _bowser2.default.BROWSER_MAP.chrome, 'media.permissions.mob.chrome_ios'), (0, _defineProperty3.default)(_MobDescriptionMap, _bowser2.default.OS_MAP.Android + '_' + _bowser2.default.BROWSER_MAP.chrome, 'media.permissions.mob.chrome_android'), _MobDescriptionMap);
	
	var mobileData = {
	  title: 'media.permissions.request.title',
	  description: MobDescriptionMap[os + '_' + browserName] || 'media.permissions.denied.default',
	  src: null
	};
	
	function getRequestPermissionData() {
	  if (isMobile) return mobileData;
	
	  return {
	    src: RequestGif[browserName],
	    title: 'media.permissions.request.title',
	    description: 'media.permissions.request.description'
	  };
	}
	
	function getDeniedPermissionData() {
	  if (isMobile) return mobileData;
	
	  return {
	    src: DeniedGif[browserName],
	    title: 'media.permissions.denied.title',
	    description: DeniedDescription[browserName] || 'media.permissions.denied.default'
	  };
	}
	
	function hasDevicePermissions() {
	  var devices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (isMobile) {
	    return !devices.some(function (device) {
	      return device.label === '';
	    });
	  }
	
	  return !devices.some(function (device) {
	    return device.deviceId === undefined;
	  });
	}
	
	var DEVICE_PERMISSION_TYPES = exports.DEVICE_PERMISSION_TYPES = {
	  REQUEST: 'request',
	  DENIED: 'denied'
	};

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useDropVideo = useDropVideo;
	exports.useDragVideo = useDragVideo;
	
	var _react = __webpack_require__(1);
	
	var _reactDnd = __webpack_require__(1020);
	
	var _reactRedux = __webpack_require__(6);
	
	var _debounce = __webpack_require__(176);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _virtualVisit = __webpack_require__(305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DRAG_TYPE = 'VV_TYPE';
	var VIDEO_WIDTH = 244 + 16;
	var VIDEO_HEIGHT = 196 + 16;
	
	function getDefaultCoords() {
	  var left = window.innerWidth - VIDEO_WIDTH;
	  var top = 64 + 16;
	  return { left: left, top: top };
	}
	
	function useDropVideo() {
	  var _useState = (0, _react.useState)({ left: 0, top: 64 }),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      coords = _useState2[0],
	      setCoords = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var defaultCoords = getDefaultCoords();
	    setCoords(defaultCoords);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var onResize = (0, _debounce2.default)(function () {
	      var ww = window.innerWidth;
	      var wh = window.innerHeight;
	      var left = coords.left,
	          top = coords.top;
	
	
	      left = ww < left + VIDEO_WIDTH ? ww - VIDEO_WIDTH : left;
	      top = wh < top + VIDEO_HEIGHT ? wh - VIDEO_HEIGHT : top;
	
	      if (left !== coords.left || top !== coords.top) {
	        setCoords({ top: top, left: left });
	      }
	    }, 500);
	
	    window.addEventListener('resize', onResize);
	
	    return function () {
	      window.removeEventListener('resize', onResize);
	    };
	  }, [coords]);
	
	  var _useDrop = (0, _reactDnd.useDrop)({
	    accept: DRAG_TYPE,
	    drop: function drop(item, monitor) {
	      var delta = monitor.getDifferenceFromInitialOffset();
	      var left = Math.round(item.left + delta.x);
	      var top = Math.round(item.top + delta.y);
	      setCoords({ left: left, top: top });
	      return undefined;
	    }
	  }),
	      _useDrop2 = (0, _slicedToArray3.default)(_useDrop, 2),
	      drop = _useDrop2[1];
	
	  return {
	    coords: coords,
	    drop: drop
	  };
	}
	
	function useDragVideo(coords, collapsed) {
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var setDragging = function setDragging(flag) {
	    return dispatch(_virtualVisit.virtualVisitActions.setDragging(flag));
	  };
	
	  var _useDrag = (0, _reactDnd.useDrag)({
	    item: { id: 'VV', type: DRAG_TYPE, left: coords.left, top: coords.top },
	    canDrag: function canDrag() {
	      return collapsed;
	    },
	    begin: function begin() {
	      setDragging(true);
	    },
	    end: function end() {
	      setDragging(false);
	    },
	
	    collect: function collect(monitor) {
	      return {
	        isDragging: monitor.isDragging()
	      };
	    }
	  }),
	      _useDrag2 = (0, _slicedToArray3.default)(_useDrag, 2),
	      isDragging = _useDrag2[0].isDragging,
	      drag = _useDrag2[1];
	
	  return {
	    isDragging: isDragging,
	    drag: drag
	  };
	}

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectPaperworkAppointmentSessionError = exports.selectPaperworkAppointmentSessionSending = exports.selectRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'paperwork.paperworkAppointmentSession');
	};
	
	var selectPaperworkAppointmentSessionSending = exports.selectPaperworkAppointmentSessionSending = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectPaperworkAppointmentSessionError = exports.selectPaperworkAppointmentSessionError = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'error', false);
	});

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handleRefetchPaymentMethods = handleRefetchPaymentMethods;
	exports.refetchPaymentMethods = refetchPaymentMethods;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(23);
	
	var _deleteCardReq = __webpack_require__(677);
	
	var _paymentsReq = __webpack_require__(868);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleRefetchPaymentMethods),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(refetchPaymentMethods);
	
	function handleRefetchPaymentMethods() {
	  var userId;
	  return _regenerator2.default.wrap(function handleRefetchPaymentMethods$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 2:
	          userId = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)(_paymentsReq.actions.send({ userId: userId }));
	
	        case 5:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function refetchPaymentMethods() {
	  return _regenerator2.default.wrap(function refetchPaymentMethods$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_deleteCardReq.consts.SUCCEED], handleRefetchPaymentMethods);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearLocalStorage = exports.initializePersistingState = exports.getPersistentState = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(914);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _isEqual = __webpack_require__(325);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _handleBgTabState = __webpack_require__(4216);
	
	var _handleBgTabState2 = _interopRequireDefault(_handleBgTabState);
	
	var _filters = __webpack_require__(260);
	
	var _storageKeys = __webpack_require__(215);
	
	var _disclaimerInformingStorage = __webpack_require__(1927);
	
	var _paperwork = __webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-shadow,no-unused-expressions,immutable/no-mutation */
	var getPersistentState = exports.getPersistentState = function getPersistentState() {
	  // On the paperwork route, only restore session state from a paperwork-scoped
	  // token. If paperworkToken is absent the tab has no active paperwork session
	  // and must start as logged-out, so it never inherits — and then corrupts —
	  // a regular-app session that belongs to another tab.
	  var _checkIsPaperworkRout = (0, _paperwork.checkIsPaperworkRoute)(),
	      isPaperworkRoute = _checkIsPaperworkRout.isPaperworkRoute;
	
	  var hasPaperworkToken = !!window.storage.getItem(_storageKeys.PAPERWORK_TOKEN);
	  var isPaperworkTabWithoutSession = isPaperworkRoute && !hasPaperworkToken;
	
	  var authenticationToken = isPaperworkTabWithoutSession ? null : window.storage.getItem(_storageKeys.AUTHENTICATION_TOKEN);
	  var loggedIn = isPaperworkTabWithoutSession ? null : window.storage.getItem(_storageKeys.LOGGED_IN);
	  var storedUser = window.storage.getItem('user');
	  var organizationId = window.storage.getItem(_storageKeys.ORGANIZATION_ID);
	  var communityId = window.storage.getItem(_storageKeys.COMMUNITY_ID);
	  var isFamilyMemberInvitation = window.storage.getItem('isFamilyMemberInvitation');
	  var isCommunityMemberInvitation = window.storage.getItem('isCommunityMemberInvitation');
	  var invitationType = window.storage.getItem('invitationType');
	  var invitationMethod = window.storage.getItem('invitationMethod');
	  var user = storedUser ? JSON.parse(storedUser) : {};
	  var id = user.id;
	
	  var boardFilters = id && window.storage.getItem('board-filters-' + id);
	  var savedSurveys = id && window.storage.getItem('saved-surveys-' + id);
	  var teamId = window.storage.getItem('selectedTeamId');
	  var teamUserId = window.storage.getItem('actingUserId');
	  var teamUser = teamUserId ? { id: JSON.parse(teamUserId) } : null;
	  var requestPasswordUpdate = window.storage.getItem(_storageKeys.REQUEST_PASSWORD_UPDATE);
	  var registrationCompleted = window.storage.getItem(_storageKeys.REGISTRATION_COMPLETED);
	
	  var state = {
	    auth: {
	      status: {
	        authenticationToken: authenticationToken ? JSON.parse(authenticationToken) : null,
	        loggedIn: loggedIn ? JSON.parse(loggedIn) : null,
	        organizationId: organizationId ? JSON.parse(organizationId) : null,
	        communityId: communityId ? JSON.parse(communityId) : null,
	        isFamilyMemberInvitation: isFamilyMemberInvitation ? JSON.parse(isFamilyMemberInvitation) : null,
	        isCommunityMemberInvitation: isCommunityMemberInvitation ? JSON.parse(isCommunityMemberInvitation) : null,
	        invitationType: invitationType ? JSON.parse(invitationType) : null,
	        invitationMethod: invitationMethod ? JSON.parse(invitationMethod) : null,
	        requestPasswordUpdate: requestPasswordUpdate ? JSON.parse(requestPasswordUpdate) : false,
	        registrationCompleted: registrationCompleted ? JSON.parse(registrationCompleted) : false
	      }
	    },
	    board: {},
	    context: {
	      loggedUser: user,
	      teamUser: {
	        selectedTeamId: teamId ? JSON.parse(teamId) : null,
	        user: teamUser
	      }
	    },
	    surveys: {
	      saved: savedSurveys ? JSON.parse(savedSurveys) : null
	    }
	  };
	
	  if (boardFilters) {
	    var filters = JSON.parse(boardFilters);
	
	    state.board.filters = (0, _extends3.default)({}, _filters.initialState, filters, {
	      searchQuery: _filters.initialState.searchQuery
	    });
	  }
	
	  return state;
	};
	
	var initializePersistingState = exports.initializePersistingState = function initializePersistingState(store, persistentState) {
	  // add handling two tabs activity flow
	  var focused = true;
	  /* eslint-disable prettier/prettier */
	  window.addEventListener('focus', function () {
	    focused = true;
	  }, false);
	  window.addEventListener('blur', function () {
	    focused = false;
	  }, false);
	  window.addEventListener('storage', function (e) {
	    return (0, _handleBgTabState2.default)(e, focused, store);
	  }, false);
	  /* eslint-enable prettier/prettier */
	  var _persistentState$auth = persistentState.auth.status,
	      authenticationToken = _persistentState$auth.authenticationToken,
	      loggedIn = _persistentState$auth.loggedIn,
	      organizationId = _persistentState$auth.organizationId,
	      communityId = _persistentState$auth.communityId,
	      isFamilyMemberInvitation = _persistentState$auth.isFamilyMemberInvitation,
	      isCommunityMemberInvitation = _persistentState$auth.isCommunityMemberInvitation,
	      invitationType = _persistentState$auth.invitationType,
	      invitationMethod = _persistentState$auth.invitationMethod,
	      requestPasswordUpdate = _persistentState$auth.requestPasswordUpdate,
	      registrationCompleted = _persistentState$auth.registrationCompleted,
	      loggedUser = persistentState.context.loggedUser,
	      board = persistentState.board,
	      surveys = persistentState.surveys,
	      profiles = persistentState.profiles;
	
	  var previousAuthToken = authenticationToken;
	  var previousLoggedIn = loggedIn;
	  var previousUser = loggedUser;
	  var previousOrgId = organizationId;
	  var previousCommunityId = communityId;
	  var previousIsFamilyMemberInvitation = isFamilyMemberInvitation;
	  var previousIsCommunityMemberInvitation = isCommunityMemberInvitation;
	  var previousInvitationType = invitationType;
	  var previousInvitationMethod = invitationMethod;
	  var previousBoardFilters = board && board.filters;
	  var previousSavedSurveys = surveys && surveys.saved;
	  var previousRequestPasswordUpdate = requestPasswordUpdate;
	  var previousRegistrationCompleted = registrationCompleted;
	  var previousFieldsEditable = (0, _get2.default)(profiles, 'profileEditable.fieldsEditable');
	
	  store.subscribe(function () {
	    var _store$getState = store.getState(),
	        _store$getState$auth$ = _store$getState.auth.status,
	        authenticationToken = _store$getState$auth$.authenticationToken,
	        loggedIn = _store$getState$auth$.loggedIn,
	        organizationId = _store$getState$auth$.organizationId,
	        communityId = _store$getState$auth$.communityId,
	        isFamilyMemberInvitation = _store$getState$auth$.isFamilyMemberInvitation,
	        isCommunityMemberInvitation = _store$getState$auth$.isCommunityMemberInvitation,
	        invitationType = _store$getState$auth$.invitationType,
	        invitationMethod = _store$getState$auth$.invitationMethod,
	        requestPasswordUpdate = _store$getState$auth$.requestPasswordUpdate,
	        registrationCompleted = _store$getState$auth$.registrationCompleted,
	        loggedUser = _store$getState.context.loggedUser,
	        board = _store$getState.board,
	        surveys = _store$getState.surveys,
	        profiles = _store$getState.profiles;
	
	    var boardFilters = board ? board.filters : null;
	    var savedSurveys = surveys ? surveys.saved : null;
	    var fieldsEditable = (0, _get2.default)(profiles, 'profileEditable.fieldsEditable');
	
	    // update localstorage if some needed data has changed
	
	    // Paperwork tabs use a dedicated paperworkToken and must not overwrite the
	    // shared authenticationToken / loggedIn keys — doing so would corrupt the
	    // regular-app session running in another tab.
	
	    var _checkIsPaperworkRout2 = (0, _paperwork.checkIsPaperworkRoute)(),
	        isPaperworkRoute = _checkIsPaperworkRout2.isPaperworkRoute;
	
	    if (!isPaperworkRoute && authenticationToken && authenticationToken !== previousAuthToken) {
	      window.storage.setItem(_storageKeys.AUTHENTICATION_TOKEN, (0, _stringify2.default)(authenticationToken));
	    }
	    if (!isPaperworkRoute && loggedIn !== previousLoggedIn) {
	      window.storage.setItem(_storageKeys.LOGGED_IN, (0, _stringify2.default)(loggedIn));
	    }
	    if (organizationId && !previousOrgId) {
	      window.storage.setItem(_storageKeys.ORGANIZATION_ID, (0, _stringify2.default)(organizationId));
	    }
	    if (communityId && !previousCommunityId) {
	      window.storage.setItem(_storageKeys.COMMUNITY_ID, (0, _stringify2.default)(communityId));
	    }
	    if (isFamilyMemberInvitation && !previousIsFamilyMemberInvitation) {
	      window.storage.setItem('isFamilyMemberInvitation', (0, _stringify2.default)(isFamilyMemberInvitation));
	    }
	    if (isCommunityMemberInvitation && !previousIsCommunityMemberInvitation) {
	      window.storage.setItem('isCommunityMemberInvitation', (0, _stringify2.default)(isCommunityMemberInvitation));
	    }
	    if (invitationType && !previousInvitationType) {
	      window.storage.setItem('invitationType', (0, _stringify2.default)(invitationType));
	    }
	    if (invitationMethod && !previousInvitationMethod) {
	      window.storage.setItem('invitationMethod', (0, _stringify2.default)(invitationMethod));
	    }
	    if (requestPasswordUpdate !== previousRequestPasswordUpdate) {
	      window.storage.setItem(_storageKeys.REQUEST_PASSWORD_UPDATE, (0, _stringify2.default)(requestPasswordUpdate));
	    }
	
	    if (registrationCompleted !== previousRegistrationCompleted) {
	      window.storage.setItem(_storageKeys.REGISTRATION_COMPLETED, (0, _stringify2.default)(registrationCompleted));
	    }
	
	    if (!(0, _isEmpty2.default)(loggedUser) && loggedUser !== previousUser) {
	      window.storage.setItem('user', (0, _stringify2.default)(loggedUser));
	
	      var id = (0, _get2.default)(loggedUser, 'id');
	      var patientId = (0, _get2.default)(loggedUser, 'primaryPatientProfile.id');
	      var providerId = (0, _get2.default)(loggedUser, 'primaryProviderProfile.id');
	
	      id && window.storage.setItem('id', (0, _stringify2.default)(id));
	      patientId && window.storage.setItem('patientId', (0, _stringify2.default)(patientId));
	      providerId && window.storage.setItem('providerId', (0, _stringify2.default)(providerId));
	    }
	
	    if (loggedIn && !(0, _isEqual2.default)(boardFilters, previousBoardFilters)) {
	      var _id = (0, _get2.default)(loggedUser, 'id');
	      _id && window.storage.setItem('board-filters-' + _id, (0, _stringify2.default)(boardFilters));
	    }
	
	    if (!(0, _isEqual2.default)(savedSurveys, previousSavedSurveys)) {
	      var _id2 = (0, _get2.default)(loggedUser, 'id');
	      _id2 && window.storage.setItem('saved-surveys-' + _id2, (0, _stringify2.default)(savedSurveys));
	    }
	
	    if (fieldsEditable !== previousFieldsEditable) {
	      window.storage.setItem('fieldsEditable', fieldsEditable);
	    }
	
	    previousAuthToken = authenticationToken;
	    previousLoggedIn = loggedIn;
	    previousUser = loggedUser;
	    previousOrgId = organizationId;
	    previousCommunityId = communityId;
	    previousIsFamilyMemberInvitation = isFamilyMemberInvitation;
	    previousIsCommunityMemberInvitation = isCommunityMemberInvitation;
	    previousInvitationType = invitationType;
	    previousInvitationMethod = invitationMethod;
	    previousBoardFilters = boardFilters;
	    previousSavedSurveys = savedSurveys;
	    previousRequestPasswordUpdate = requestPasswordUpdate;
	    previousFieldsEditable = fieldsEditable;
	    previousRegistrationCompleted = registrationCompleted;
	  });
	};
	
	var clearLocalStorage = exports.clearLocalStorage = function clearLocalStorage() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$preservePaperwor = _ref.preservePaperwork,
	      preservePaperwork = _ref$preservePaperwor === undefined ? false : _ref$preservePaperwor;
	
	  (0, _keys2.default)(window.storage).forEach(function (i) {
	    var fontItem = i.includes('x-font');
	    var boardFilters = i.includes('board-filters-');
	    var savedSurveys = i.includes('saved-surveys-');
	    var redirectToPage = i.includes(_storageKeys.REDIRECT_TO_PAGE);
	    // Preserve the paperwork session token when a regular-app tab logs out so
	    // that an open paperwork tab in another window is not disrupted.
	    var paperworkToken = preservePaperwork && i === _storageKeys.PAPERWORK_TOKEN;
	
	    !(fontItem || boardFilters || savedSurveys || redirectToPage || paperworkToken) && window.storage.removeItem(i);
	  });
	
	  (0, _disclaimerInformingStorage.clearDisclaimerInformingIds)();
	};

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = handleDocumentsErrorsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _uploadUserDocuments = __webpack_require__(429);
	
	var _updateUserDocuments = __webpack_require__(540);
	
	var _deleteUserDocuments = __webpack_require__(422);
	
	var _handleServerErrorsWithToast = __webpack_require__(1940);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleDocumentsErrorsSaga);
	
	function handleDocumentsErrorsSaga() {
	  return _regenerator2.default.wrap(function handleDocumentsErrorsSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeEvery)([_uploadUserDocuments.consts.REJECTED, _uploadUserDocuments.consts.ERROR_ENCOUNTERED, _updateUserDocuments.consts.REJECTED, _updateUserDocuments.consts.ERROR_ENCOUNTERED, _deleteUserDocuments.consts.REJECTED, _deleteUserDocuments.consts.ERROR_ENCOUNTERED], _handleServerErrorsWithToast.handleServerErrorWithToast);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'availablePrograms');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  type: 'get',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'provider_patient_programs']
	});
	
	exports.default = (0, _redux.createReqReducer)(consts);

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watcher = exports.actions = exports.consts = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createReqConsts)('programs', 'invitations', ['REMOVE_INVITATION', 'ACCEPT', 'DECLINE', 'CLEAR']);
	
	var actions = exports.actions = (0, _redux.createActions)(consts);
	var watcher = exports.watcher = (0, _redux.createReqWatcher)(consts, actions, {
	  endpoint: 'users',
	  slug: [{
	    type: 'payload',
	    selector: ['id']
	  }, 'program_invitations'],
	  type: 'get'
	});
	
	var requestReducer = (0, _redux.createReqReducer)(consts);
	
	var removeInvitation = function removeInvitation(state, _ref) {
	  var id = _ref.id;
	
	  state.list.splice(state.list.findIndex(function (item) {
	    return item.id === id;
	  }), 1);
	
	  return (0, _extends3.default)({}, state, {
	    list: [].concat((0, _toConsumableArray3.default)(state.list))
	  });
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _redux.initialState;
	  var action = arguments[1];
	  var type = action.type,
	      payload = action.payload;
	
	
	  switch (type) {
	    case consts.ACCEPT:
	    case consts.DECLINE:
	      return state; // Do nothing. Saga is watching these action
	    case consts.REMOVE_INVITATION:
	      return removeInvitation(state, payload);
	    case consts.CLEAR:
	      return _redux.initialState;
	
	    default:
	      return requestReducer(state, action);
	  }
	};

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _payloadType;
	
	exports.loadScheduleSearchSlots = loadScheduleSearchSlots;
	exports.default = fetchScheduleSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _scheduleSearchReq = __webpack_require__(690);
	
	var scheduleSearch = _interopRequireWildcard(_scheduleSearchReq);
	
	var _workslotInsertReq = __webpack_require__(431);
	
	var workslotInsert = _interopRequireWildcard(_workslotInsertReq);
	
	var _workslotRemoveReq = __webpack_require__(544);
	
	var workslotRemove = _interopRequireWildcard(_workslotRemoveReq);
	
	var _workslotUpdateReq = __webpack_require__(545);
	
	var workslotUpdate = _interopRequireWildcard(_workslotUpdateReq);
	
	var _blockslotInsertReq = __webpack_require__(430);
	
	var blockslotInsert = _interopRequireWildcard(_blockslotInsertReq);
	
	var _blockslotRemoveReq = __webpack_require__(542);
	
	var blockslotRemove = _interopRequireWildcard(_blockslotRemoveReq);
	
	var _blockslotUpdateReq = __webpack_require__(543);
	
	var blockslotUpdate = _interopRequireWildcard(_blockslotUpdateReq);
	
	var _filter = __webpack_require__(894);
	
	var _selectors = __webpack_require__(88);
	
	var _offsetCalculation = __webpack_require__(4234);
	
	var _events = __webpack_require__(360);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleInitScheduleLoad),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(loadScheduleSearchSlots),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleRemoveInsertion),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(clearSelection),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(handleNewInsertion),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(fetchScheduleSaga);
	
	function handleInitScheduleLoad() {
	  var _ref, payload, data;
	
	  return _regenerator2.default.wrap(function handleInitScheduleLoad$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(loadScheduleSearchSlots);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.take)(scheduleSearch.consts.SUCCEED);
	
	        case 4:
	          _ref = _context.sent;
	          payload = _ref.payload;
	          data = (0, _offsetCalculation.calculateOffsetTop)(payload.workSlots);
	          _context.next = 9;
	          return (0, _effects.call)(_events.emitInitSceduleLoadEvent, data);
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function loadScheduleSearchSlots() {
	  var id, dateRange;
	  return _regenerator2.default.wrap(function loadScheduleSearchSlots$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors.selectScheduleTargerProviderId);
	
	        case 2:
	          id = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_selectors.selectScheduleDateRange);
	
	        case 5:
	          dateRange = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.put)(scheduleSearch.actions.send((0, _extends3.default)({ id: id }, dateRange)));
	
	        case 8:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleRemoveInsertion() {
	  return _regenerator2.default.wrap(function handleRemoveInsertion$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.call)(_events.emitClearSelectionEvent);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.call)(loadScheduleSearchSlots);
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function clearSelection() {
	  return _regenerator2.default.wrap(function clearSelection$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.call)(_events.emitClearSelectionEvent);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	var payloadType = (_payloadType = {}, (0, _defineProperty3.default)(_payloadType, workslotInsert.consts.SEND, {
	  key: 'workSlot',
	  succeed: workslotInsert.consts.SUCCEED
	}), (0, _defineProperty3.default)(_payloadType, blockslotInsert.consts.SEND, {
	  key: 'blockedSlot',
	  succeed: blockslotInsert.consts.SUCCEED
	}), _payloadType);
	
	function handleNewInsertion(_ref2) {
	  var type = _ref2.type,
	      payload = _ref2.payload;
	
	  var selectedSchedule, _payloadType$type, key, succeed, scheduleSettingAttributes, isRepeatable, activeDate, startOn;
	
	  return _regenerator2.default.wrap(function handleNewInsertion$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 2:
	          selectedSchedule = _context5.sent;
	          _payloadType$type = payloadType[type], key = _payloadType$type.key, succeed = _payloadType$type.succeed;
	          scheduleSettingAttributes = payload[key].scheduleSettingAttributes;
	          isRepeatable = (0, _get2.default)(selectedSchedule, 'isRepeatable');
	          activeDate = (0, _get2.default)(selectedSchedule, 'activeDate');
	          startOn = scheduleSettingAttributes.startOn;
	
	
	          if (isRepeatable) {
	            startOn = activeDate;
	          }
	
	          _context5.next = 11;
	          return (0, _effects.take)(succeed);
	
	        case 11:
	          _context5.next = 13;
	          return (0, _effects.put)(_filter.scheduleFilterActions.setDate(startOn));
	
	        case 13:
	          _context5.next = 15;
	          return (0, _effects.call)(_events.emitClearSelectionEvent);
	
	        case 15:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function fetchScheduleSaga() {
	  return _regenerator2.default.wrap(function fetchScheduleSaga$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.takeLatest)([scheduleSearch.consts.SUCCEED], clearSelection);
	
	        case 2:
	          _context6.next = 4;
	          return (0, _effects.takeLatest)([scheduleSearch.consts.INIT_LOAD], handleInitScheduleLoad);
	
	        case 4:
	          _context6.next = 6;
	          return (0, _effects.takeLatest)([_filter.SCHEDULE_FILTER_TYPES.NEXT_WEEK, _filter.SCHEDULE_FILTER_TYPES.PREV_WEEK, _filter.SCHEDULE_FILTER_TYPES.SET_DATE], loadScheduleSearchSlots);
	
	        case 6:
	          _context6.next = 8;
	          return (0, _effects.takeLatest)([workslotInsert.consts.SEND, blockslotInsert.consts.SEND], handleNewInsertion);
	
	        case 8:
	          _context6.next = 10;
	          return (0, _effects.takeLatest)([workslotRemove.consts.SUCCEED, blockslotRemove.consts.SUCCEED, workslotUpdate.consts.SUCCEED, blockslotUpdate.consts.SUCCEED], handleRemoveInsertion);
	
	        case 10:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.findIntersections = findIntersections;
	
	var _effects = __webpack_require__(14);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _intersectionCountsReq = __webpack_require__(896);
	
	var intersections = _interopRequireWildcard(_intersectionCountsReq);
	
	var _selectors = __webpack_require__(88);
	
	var _validate = __webpack_require__(143);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(findIntersections);
	
	function findIntersections(_ref) {
	  var workSlot = _ref.workSlot,
	      id = _ref.id;
	
	  var scheduleSettingAttributes, _ref2, succeed, failed, workSlots, selectedScheduleId;
	
	  return _regenerator2.default.wrap(function findIntersections$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          scheduleSettingAttributes = workSlot.scheduleSettingAttributes;
	          _context.next = 3;
	          return (0, _effects.put)(intersections.actions.send((0, _extends3.default)({ id: id }, scheduleSettingAttributes)));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(intersections.actions.succeed),
	            failed: (0, _effects.take)([intersections.actions.rejected, intersections.actions.errorEncountered])
	          });
	
	        case 5:
	          _ref2 = _context.sent;
	          succeed = _ref2.succeed;
	          failed = _ref2.failed;
	
	          if (!failed) {
	            _context.next = 10;
	            break;
	          }
	
	          return _context.abrupt('return', false);
	
	        case 10:
	          workSlots = succeed.payload.ids.workSlots;
	          _context.next = 13;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverDataId);
	
	        case 13:
	          selectedScheduleId = _context.sent;
	
	          if (!(selectedScheduleId && workSlots.length === 1 && workSlots[0] === selectedScheduleId)) {
	            _context.next = 16;
	            break;
	          }
	
	          return _context.abrupt('return', true);
	
	        case 16:
	          if ((0, _isEmpty2.default)(workSlots)) {
	            _context.next = 22;
	            break;
	          }
	
	          _context.next = 19;
	          return (0, _effects.put)(_validate.scheduleValidateActions.toggleOverlapModal(true));
	
	        case 19:
	          _context.next = 21;
	          return (0, _effects.take)(_validate.SCHEDULE_VALIDATE_TYPES.FORCE_OVERLAP);
	
	        case 21:
	          return _context.abrupt('return', true);
	
	        case 22:
	          return _context.abrupt('return', true);
	
	        case 23:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'online', 'SET_ONLINE');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SET_ONLINE:
	      return action.payload;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _locationReducer = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('ui', 'overlay', 'SHOW', 'HIDE', 'TOGGLE_VISIBILITY');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    visible: false
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.SHOW:
	      return (0, _extends3.default)({}, state, {
	        visible: true
	      });
	    case consts.HIDE:
	    case _locationReducer.LOCATION_CHANGE:
	      return (0, _extends3.default)({}, state, {
	        visible: false
	      });
	    case consts.TOGGLE_VISIBILITY:
	      return (0, _extends3.default)({}, state, {
	        visible: !state.visible
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeAPI = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _axios = __webpack_require__(1694);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _camelize = __webpack_require__(364);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	var _snakecaseKeys = __webpack_require__(1391);
	
	var _snakecaseKeys2 = _interopRequireDefault(_snakecaseKeys);
	
	var _env = __webpack_require__(103);
	
	var _httpError = __webpack_require__(4218);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiInit = function apiInit(options) {
	  return _axios2.default.create((0, _extends3.default)({
	    baseURL: _env.API_URI
	  }, options));
	}; /* eslint-disable no-restricted-globals,no-console */
	/* location */
	
	
	var api = function api(endpoint, options) {
	  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
	  return {
	    send: function send(payload) {
	      if (_env.DEV_ENV && !_env.DISABLE_LOGS) {
	        console.group('API Request');
	        console.info('Endpoint: ' + location.protocol + _env.API_URI + '/' + endpoint);
	        console.info('Options:', options || 'No');
	        console.info('Type: ' + type.toUpperCase());
	        console.groupEnd();
	      }
	
	      var shouldSnakeCase = payload && !(payload instanceof FormData);
	      var method = apiInit(options)[type];
	
	      return method(endpoint, shouldSnakeCase ? (0, _snakecaseKeys2.default)(payload) : payload).then(function (response) {
	        if (response.data instanceof Blob) return response;
	        return (0, _camelize2.default)(response);
	      }).catch(function (err) {
	        (0, _httpError.trackHttpError)(err);
	        return (0, _camelize2.default)(err.response);
	      });
	    }
	  };
	};
	
	var makeAPI = exports.makeAPI = function makeAPI(options) {
	  var instance = apiInit({});
	  return instance.request(options);
	};
	
	exports.default = api;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// childAnswers should be sent only if answer is present
	// if false they just saved in redux store for prefill additional questions form
	var convertAdditionalInfoDataToRequestPayload = function convertAdditionalInfoDataToRequestPayload(additionalInfoFormData) {
	  if ((0, _isEmpty2.default)(additionalInfoFormData)) {
	    return additionalInfoFormData;
	  }
	
	  var childQuestions = (0, _get2.default)(additionalInfoFormData, 'questionAnswers.childQuestions', []);
	
	  var childAnswers = (0, _get2.default)(additionalInfoFormData, 'questionAnswers.childAnswers', []);
	
	  var answer = (0, _get2.default)(additionalInfoFormData, 'questionAnswers.answer');
	
	  var question = (0, _get2.default)(additionalInfoFormData, 'questionAnswers.question');
	
	  var result = [childQuestions, childAnswers].find(function (arr) {
	    return arr.length > 0;
	  }) || [];
	
	  return {
	    questionAnswers: (0, _extends3.default)({
	      answer: answer,
	      question: question
	    }, answer ? { childAnswers: result } : {})
	  };
	};
	
	exports.default = convertAdditionalInfoDataToRequestPayload;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gerPCPData = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _pcpAnswer = __webpack_require__(617);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var gerPCPData = exports.gerPCPData = function gerPCPData(pcpFormData) {
	  if (pcpFormData.pcpProviderAnswer === _pcpAnswer.PCP_PROVIDER_ANSWER.U) {
	    return {
	      pcp_provider_answer: pcpFormData.pcpProviderAnswer,
	      pcp_id: null,
	      pcp_name: '',
	      consider_us_pcp: false
	    };
	  }
	
	  if (pcpFormData.pcpProviderAnswer === _pcpAnswer.PCP_PROVIDER_ANSWER.N) {
	    return {
	      pcp_provider_answer: pcpFormData.pcpProviderAnswer,
	      consider_us_pcp: pcpFormData.considerUsPcp,
	      pcp_id: null,
	      pcp_name: ''
	    };
	  }
	
	  return {
	    pcp_provider_answer: pcpFormData.pcpProviderAnswer,
	    pcp_id: pcpFormData.pcpName ? null : (0, _get2.default)(pcpFormData, 'primaryCareProvider.value', null),
	    pcp_name: pcpFormData.pcpName,
	    consider_us_pcp: pcpFormData.considerUsPcp
	  };
	};

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ROWS = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useOverviewRowsBuilder = useOverviewRowsBuilder;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _PaymentAmountField = __webpack_require__(1751);
	
	var _VisitDocuments = __webpack_require__(3351);
	
	var _VisitSurveyListView = __webpack_require__(1758);
	
	var _dateFilter = __webpack_require__(310);
	
	var _formatAmount = __webpack_require__(434);
	
	var _constants = __webpack_require__(17);
	
	var _ids = __webpack_require__(46);
	
	var _NotificationConsentView = __webpack_require__(1754);
	
	var _VisitConsents = __webpack_require__(1125);
	
	var _getFullLocationAdress = __webpack_require__(1707);
	
	var _VisitPrescriptions = __webpack_require__(3353);
	
	var _VisitPrescriptions2 = _interopRequireDefault(_VisitPrescriptions);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROWS = exports.ROWS = {
	  DATE: 'date',
	  PROVIDER: 'provider',
	  REASON: 'reason',
	  PRIVACY: 'privacy',
	  PAYMENT: 'payment',
	  EDITABLE_PAYMENT: 'editable-payment',
	  DOCUMENTS: 'documents',
	  SURVEYS: 'surveys',
	  CONSENTS: 'consents',
	  NOTIFICATION_CONSENT: 'notification-consent',
	  LOCATION: 'location',
	  DATE_AND_TIME: 'date-and-time',
	  PRESCRIPTIONS: 'prescriptions',
	  ADDITIONAL_INFO: 'additional-info'
	};
	
	function shouldShowAdditionalDuration(_ref) {
	  var additionalDuration = _ref.additionalDuration,
	      status = _ref.status,
	      visitTypeCode = _ref.visitTypeCode;
	
	  var isEirType = _constants.EIR_APPOINTMENT_TYPES.includes(visitTypeCode);
	  return additionalDuration && (!isEirType && status !== _constants.APPOINTMENT_STATUSES.COMPLETED || isEirType && status === _constants.APPOINTMENT_STATUSES.COMPLETED);
	}
	
	function useOverviewRowsBuilder(_ref2) {
	  var formatMessage = _ref2.formatMessage,
	      isInlineVisit = _ref2.isInlineVisit;
	
	  var makeLocationRow = void 0;
	  var makeDateAndTimeRow = void 0;
	
	  var makeDateRow = (0, _react.useCallback)(function (_ref3) {
	    var time = _ref3.time,
	        additionalDuration = _ref3.additionalDuration,
	        status = _ref3.status,
	        icsUrl = _ref3.icsUrl,
	        icsAllowed = _ref3.icsAllowed,
	        visitTypeCode = _ref3.visitTypeCode;
	
	    var formattedTime = (0, _dateFilter.formatHours)(time);
	
	    var timeText = shouldShowAdditionalDuration({
	      additionalDuration: additionalDuration,
	      status: status,
	      visitTypeCode: visitTypeCode
	    }) ? formattedTime + ' (' + additionalDuration + ')' : formattedTime;
	
	    return {
	      id: ROWS.DATE,
	      row: [(0, _extends3.default)({
	        title: formatMessage({ id: 'common.date' }),
	        text: (0, _dateFilter.humanizeLocalDate)(time)
	      }, icsAllowed && icsUrl && {
	        icsUrlTitle: formatMessage({ id: 'general.addToCalendar' }),
	        icsUrl: icsUrl
	      }), {
	        title: formatMessage({ id: 'dashboard.table.time' }),
	        text: timeText
	      }]
	    };
	  }, []);
	
	  var makeProviderRow = (0, _react.useCallback)(function (_ref4) {
	    var provider = _ref4.provider,
	        service = _ref4.service,
	        renderCell = _ref4.renderCell,
	        hasLocation = _ref4.hasLocation,
	        isVirtualVisit = _ref4.isVirtualVisit,
	        isForbiddenMap = _ref4.isForbiddenMap;
	
	    var secondCell = service ? {
	      title: formatMessage({ id: 'dashboard.filter.service' }),
	      text: (0, _get2.default)(service, 'name') || '-'
	    } : {
	      title: formatMessage({ id: 'common.phone' }),
	      text: (0, _get2.default)(provider, 'location.phone') || '-'
	    };
	
	    if (typeof renderCell === 'function') {
	      secondCell = renderCell();
	    }
	
	    return {
	      id: ROWS.PROVIDER,
	      row: (0, _compact2.default)([hasLocation && (0, _extends3.default)({
	        title: formatMessage({ id: 'dashboard.filter.location' }),
	        text: [(0, _get2.default)(provider, 'location.name'), '' + (!isVirtualVisit ? (0, _get2.default)(provider, 'location.address') + ', ' + (0, _get2.default)(provider, 'location.city') : '')].join('\n')
	      }, !isForbiddenMap && {
	        location: formatMessage({ id: 'general.viewOnMap' })
	      }), secondCell])
	    };
	  }, []);
	
	  var makeReasonRow = (0, _react.useCallback)(function (reason) {
	    return {
	      id: ROWS.REASON,
	      row: [{
	        title: formatMessage({ id: 'fields.reasonType' }),
	        text: (0, _get2.default)(reason, 'type') || '-'
	      }, {
	        title: formatMessage({ id: 'fields.reasonNote' }),
	        text: (0, _get2.default)(reason, 'note') || '-'
	      }]
	    };
	  }, []);
	
	  var makePrivacyRow = (0, _react.useCallback)(function (consentInfo) {
	    return {
	      id: ROWS.PRIVACY,
	      row: [{
	        title: formatMessage({ id: 'common.documents' }),
	        text: formatMessage({ id: 'appointment.form.patientDoc' }),
	        extra: formatMessage({ id: 'common.complete' })
	      }, {
	        title: '',
	        text: (0, _get2.default)(consentInfo, 'title') || '-',
	        extra: (0, _get2.default)(consentInfo, 'active') ? formatMessage({ id: 'common.complete' }) : '-'
	      }]
	    };
	  }, []);
	
	  var makePaymentRow = (0, _react.useCallback)(function (price) {
	    var text = price === null ? formatMessage({
	      id: 'healthboard.appointments.paymentStatus.pendingPaymentInfo'
	    }) : formatMessage({ id: 'healthboard.appointments.paymentStatus.tapToPay' }, { price: Number(price).toFixed(2) });
	
	    var style = price !== null ? {
	      fontWeight: '600',
	      color: _styles.COLORS.bluePrimary
	    } : {};
	
	    return {
	      id: ROWS.PAYMENT,
	      row: [{
	        title: formatMessage({ id: 'appointment.form.costTitle' }),
	        text: text,
	        style: style
	      }]
	    };
	  }, []);
	
	  var makeDocRow = (0, _react.useCallback)(function (_ref5) {
	    var providerContext = _ref5.providerContext,
	        appointment = _ref5.appointment;
	    return {
	      id: ROWS.DOCUMENTS,
	      row: [{
	        component: _react2.default.createElement(_VisitDocuments.VisitDocuments, {
	          formatMessage: formatMessage,
	          providerContext: providerContext,
	          key: _ids.IDS.FORM_FIELDS.DOCUMENTS,
	          appointment: appointment
	        }),
	        fullWidthRow: true
	      }]
	    };
	  }, []);
	
	  var makeSurveyRow = (0, _react.useCallback)(function (_ref6) {
	    var appointment = _ref6.appointment;
	    return {
	      id: ROWS.SURVEYS,
	      row: [{
	        component: _react2.default.createElement(_VisitSurveyListView.VisitSurveyList, {
	          formatMessage: formatMessage,
	          key: _ids.IDS.FORM_FIELDS.SURVEYS,
	          appointment: appointment
	        }),
	        fullWidthRow: true
	      }]
	    };
	  }, []);
	
	  var makeNotificationConsentRow = (0, _react.useCallback)(function (_ref7) {
	    var appointment = _ref7.appointment,
	        providerContext = _ref7.providerContext;
	    return {
	      id: ROWS.NOTIFICATION_CONSENT,
	      row: [{
	        component: _react2.default.createElement(_NotificationConsentView.NotificationConsentView, {
	          formatMessage: formatMessage,
	          key: _ids.IDS.FORM_FIELDS.NOTIFICATION_CONSENTS,
	          appointment: appointment,
	          isProviderContext: providerContext
	        }),
	        fullWidthRow: true
	      }]
	    };
	  }, []);
	
	  var makeConsentRow = (0, _react.useCallback)(function (_ref8) {
	    var appointment = _ref8.appointment,
	        providerContext = _ref8.providerContext;
	    return {
	      id: ROWS.CONSENTS,
	      row: [{
	        component: _react2.default.createElement(_VisitConsents.VisitConsents, {
	          formatMessage: formatMessage,
	          key: _ids.IDS.FORM_FIELDS.CONSENTS,
	          appointment: appointment,
	          providerContext: providerContext
	        }),
	        fullWidthRow: true
	      }]
	    };
	  }, []);
	
	  var makePrescriptionsRow = (0, _react.useCallback)(function (prescriptions) {
	    return {
	      id: ROWS.PRESCRIPTIONS,
	      row: [{
	        component: _react2.default.createElement(_VisitPrescriptions2.default, {
	          formatMessage: formatMessage,
	          prescriptions: prescriptions,
	          key: _ids.IDS.FORM_FIELDS.PRESCRIPTIONS
	        }),
	        fullWidthRow: true
	      }]
	    };
	  }, []);
	
	  var makeEditablePaymentRow = (0, _react.useCallback)(function (_ref9) {
	    var appointment = _ref9.appointment,
	        isUpcoming = _ref9.isUpcoming;
	
	    var paymentStatus = (0, _get2.default)(appointment, 'paymentStatus');
	    var isPaid = paymentStatus === _constants.PAYMENT_STATUSES.PAID;
	    var appointmentId = (0, _get2.default)(appointment, 'id');
	
	    var statusI18n = isPaid ? 'healthboard.appointments.paymentStatus.paid' : 'healthboard.appointments.paymentStatus.unpaid';
	
	    var amount = isPaid ? (0, _get2.default)(appointment, 'paidAmount') : (0, _get2.default)(appointment, 'copay');
	
	    return {
	      id: ROWS.EDITABLE_PAYMENT,
	      row: [{
	        title: formatMessage({
	          id: 'appointment.details.paymentAmount.title'
	        }),
	        text: '$' + (0, _formatAmount.formatAmount)(amount || 0),
	        component: _react2.default.createElement(_PaymentAmountField.PaymentAmountField, {
	          formatMessage: formatMessage,
	          value: amount,
	          isPaid: isPaid,
	          isUpcoming: isUpcoming,
	          appointmentId: appointmentId,
	          appointment: appointment
	        })
	      }, {
	        title: formatMessage({
	          id: 'appointment.details.paymentStatus.title'
	        }),
	        text: formatMessage({ id: statusI18n })
	      }]
	    };
	  }, []);
	
	  if (isInlineVisit) {
	    makeLocationRow = (0, _react.useCallback)(function (location) {
	      return {
	        id: ROWS.LOCATION,
	        row: [{
	          title: formatMessage({ id: 'profile.fields.location' }),
	          text: [location.name, (0, _getFullLocationAdress.getFullAdress)(location)].join('\n')
	        }, {
	          title: formatMessage({ id: 'common.hours' }),
	          text: (0, _dateFilter.formatHours)(location.schedule.metadata.startTime) + ' - ' + (0, _dateFilter.formatHours)(location.schedule.metadata.endTime)
	        }]
	      };
	    }, []);
	
	    makeDateAndTimeRow = (0, _react.useCallback)(function (time) {
	      var displayTime = time ? formatMessage({
	        id: 'common.today'
	      }) + ', ' + (0, _dateFilter.formatHours)(time) : '-';
	
	      return {
	        id: ROWS.DATE_AND_TIME,
	        row: [{
	          title: formatMessage({ id: 'dashboard.table.time' }),
	          text: displayTime
	        }]
	      };
	    }, []);
	  }
	
	  return {
	    makeDateRow: makeDateRow,
	    makeProviderRow: makeProviderRow,
	    makeReasonRow: makeReasonRow,
	    makePrivacyRow: makePrivacyRow,
	    makePaymentRow: makePaymentRow,
	    makeDocRow: makeDocRow,
	    makeSurveyRow: makeSurveyRow,
	    makeEditablePaymentRow: makeEditablePaymentRow,
	    makeConsentRow: makeConsentRow,
	    makeNotificationConsentRow: makeNotificationConsentRow,
	    makeLocationRow: makeLocationRow,
	    makeDateAndTimeRow: makeDateAndTimeRow,
	    makePrescriptionsRow: makePrescriptionsRow
	  };
	}

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAuthAzureErrorMessage = getAuthAzureErrorMessage;
	
	var _constants = __webpack_require__(17);
	
	var NOT_CONFIRMED = _constants.AUTH_AZURE_ERROR_CODE.NOT_CONFIRMED,
	    NOT_FOUND = _constants.AUTH_AZURE_ERROR_CODE.NOT_FOUND,
	    USER_DISABLED = _constants.AUTH_AZURE_ERROR_CODE.USER_DISABLED;
	function getAuthAzureErrorMessage(errorCode, formatMessage) {
	  switch (errorCode) {
	    case NOT_CONFIRMED:
	      return formatMessage({ id: 'auth.errors.notConfirmed' });
	    case NOT_FOUND:
	      return formatMessage({ id: 'auth.errors.notFound' });
	    case USER_DISABLED:
	      return formatMessage({ id: 'auth.errors.userDisabled' });
	    default:
	      return formatMessage({ id: 'errors.common' });
	  }
	}

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _snakeCase = __webpack_require__(467);
	
	var _snakeCase2 = _interopRequireDefault(_snakeCase);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable immutable/no-mutation */
	var getErrorMsg = function getErrorMsg(triggers) {
	  return (0, _keys2.default)(triggers).reduce(function (acc, key) {
	    if (!triggers[key]) {
	      acc.push(_strings.AUTH.errors[key]);
	    }
	
	    return acc;
	  }, []);
	};
	
	exports.default = function (form, validations, formatMessage) {
	  var triggers = (0, _keys2.default)(validations).reduce(function (acc, key) {
	    var _validations$key = validations[key],
	        fields = _validations$key.fields,
	        handler = _validations$key.handler;
	
	    acc[key] = fields.every(function (fieldName) {
	      return handler(form[(0, _snakeCase2.default)(fieldName)], formatMessage);
	    });
	
	    return acc;
	  }, {});
	
	  var errors = getErrorMsg(triggers);
	  return errors.length ? errors : null;
	};

/***/ }),
/* 1912 */,
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeItem = exports.removeMember = exports.removeRole = exports.removeInvitation = exports.addInvitation = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _find = __webpack_require__(462);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addInvitation = exports.addInvitation = function addInvitation(state, _ref) {
	  var email = _ref.email,
	      role = _ref.role,
	      invitationId = _ref.invitationId,
	      id = _ref.id,
	      user = _ref.user;
	
	  var profile = (0, _find2.default)((0, _get2.default)(state, 'list', []), { id: id });
	
	  if (!profile) return state;
	
	  var pendingInvitations = (0, _arrayModify.updateOrPush)((0, _get2.default)(profile, 'pendingInvitations', []), { invitationId: invitationId }, { email: email, role: role, invitationId: invitationId, userId: id, user: user });
	
	  var newProfile = (0, _extends3.default)({}, profile, {
	    pendingInvitations: pendingInvitations
	  });
	
	  return (0, _extends3.default)({}, state, {
	    list: [].concat((0, _toConsumableArray3.default)((0, _arrayModify.removeArrayItem)((0, _get2.default)(state, 'list', []), 'id', id)), [newProfile])
	  });
	};
	
	var removeInvitation = exports.removeInvitation = function removeInvitation(state, _ref2) {
	  var invitationId = _ref2.invitationId,
	      userId = _ref2.userId;
	
	  var profile = (0, _find2.default)((0, _get2.default)(state, 'list', []), { id: userId });
	
	  if (!profile) return state;
	
	  var pendingInvitations = (0, _arrayModify.removeArrayItem)((0, _get2.default)(profile, 'pendingInvitations', []), 'invitationId', invitationId);
	
	  var newProfile = (0, _extends3.default)({}, profile, {
	    pendingInvitations: pendingInvitations
	  });
	
	  return (0, _extends3.default)({}, state, {
	    list: [].concat((0, _toConsumableArray3.default)((0, _arrayModify.removeArrayItem)((0, _get2.default)(state, 'list', []), 'id', userId)), [newProfile])
	  });
	};
	
	var removeRole = exports.removeRole = function removeRole(state, _ref3, role) {
	  var userId = _ref3.userId,
	      memberId = _ref3.memberId;
	
	  var list = (0, _get2.default)(state, 'list', []);
	  var listIndex = list.findIndex(function (item) {
	    return item.id === userId;
	  });
	  var memberIndex = (0, _get2.default)(list[listIndex], 'familyMembers', []).findIndex(function (item) {
	    return item.id === memberId;
	  });
	
	  if (memberIndex !== -1) {
	    var newList = [].concat((0, _toConsumableArray3.default)(list));
	    var familyMembersList = [].concat((0, _toConsumableArray3.default)(state.list[listIndex].familyMembers));
	    var updatedMember = (0, _extends3.default)({}, state.list[listIndex].familyMembers[memberIndex], role);
	
	    familyMembersList[memberIndex] = updatedMember;
	
	    var newListItem = (0, _extends3.default)({}, newList[listIndex], {
	      familyMembers: familyMembersList
	    });
	
	    newList[listIndex] = newListItem;
	
	    return (0, _extends3.default)({}, state, {
	      list: newList
	    });
	  }
	
	  return state;
	};
	
	var removeMember = exports.removeMember = function removeMember(state, _ref4) {
	  var userId = _ref4.userId,
	      memberId = _ref4.memberId;
	
	  var list = (0, _get2.default)(state, 'list', []);
	  var listIndex = list.findIndex(function (item) {
	    return item.id === userId;
	  });
	  var removeIndex = (0, _get2.default)(list[listIndex], 'familyMembers', []).findIndex(function (item) {
	    return item.id === memberId;
	  });
	
	  var filtered = [].concat((0, _toConsumableArray3.default)(state.list[listIndex].familyMembers.slice(0, removeIndex)), (0, _toConsumableArray3.default)(state.list[listIndex].familyMembers.slice(removeIndex + 1)));
	
	  var newList = [].concat((0, _toConsumableArray3.default)(list));
	  var newListItem = (0, _extends3.default)({}, newList[listIndex], { familyMembers: filtered });
	  newList[listIndex] = newListItem;
	
	  if (removeIndex !== -1) {
	    return (0, _extends3.default)({}, state, {
	      list: newList
	    });
	  }
	
	  return state;
	};
	
	var removeItem = exports.removeItem = function removeItem(state, _ref5) {
	  var id = _ref5.id;
	
	  var list = (0, _arrayModify.removeArrayItem)((0, _get2.default)(state, 'list', []), 'id', id);
	
	  return (0, _extends3.default)({}, state, { list: list });
	};

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var convertXMLtoString = function convertXMLtoString(xmlValue) {
	  var htmlEl = document.createElement('span');
	  htmlEl.textContent = xmlValue;
	
	  return htmlEl.textContent;
	};
	
	exports.default = convertXMLtoString;

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getListLocalization = exports.getListLocalization = function getListLocalization(list, formatMessage) {
	  if (!list) return false;
	  return list.map(function (item) {
	    var label = void 0;
	    var id = item.label;
	
	    if (formatMessage) {
	      label = formatMessage({ id: id });
	    }
	
	    return {
	      value: item.value,
	      label: label
	    };
	  });
	};

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCardExpired = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _vaultAccountTypes = __webpack_require__(1211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isCardExpired = exports.isCardExpired = function isCardExpired(mmyy) {
	  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	
	  var month = Number(mmyy.slice(0, 2));
	  var year = Number(mmyy.slice(2, 4));
	
	  var currentYear = now.getFullYear();
	  var currentMonth = now.getMonth() + 1;
	
	  var centuryBase = Math.floor(currentYear / 100) * 100;
	  var fullYear = centuryBase + year;
	
	  if (fullYear < currentYear) return true;
	  if (fullYear === currentYear && month < currentMonth) return true;
	
	  return false;
	};
	
	var formatExpiryMMYY = function formatExpiryMMYY(mmyy) {
	  var month = mmyy.slice(0, 2);
	  var year = mmyy.slice(2, 4);
	  return month + '/' + year;
	};
	
	var mapAccountVaultCardsToItems = function mapAccountVaultCardsToItems(item) {
	  var accountType = (0, _get2.default)(_vaultAccountTypes.VAULT_ACCOUNT_TYPES, '' + item.accountType, _vaultAccountTypes.UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE);
	
	  return {
	    accountType: accountType,
	    expDate: formatExpiryMMYY(item.expDate),
	    id: item.id,
	    isExpired: isCardExpired(item.expDate),
	    label: '**** **** **** ' + item.lastFour,
	    usedByDefault: item.usedByDefault,
	    hasActiveSubscriptions: item.hasActiveSubscriptions,
	    value: item.id
	  };
	};
	
	exports.default = mapAccountVaultCardsToItems;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _startCase = __webpack_require__(2353);
	
	var _startCase2 = _interopRequireDefault(_startCase);
	
	var _format = __webpack_require__(319);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createSurveyPdfName = function createSurveyPdfName(surveyName, userName, date) {
	  var uiSurveyName = surveyName && (0, _startCase2.default)(surveyName);
	  var uiDate = (0, _format2.default)(date, 'MMM DD YYYY');
	  var pdfName = uiSurveyName + ' - ' + userName + ' - ' + uiDate;
	
	  return pdfName.split(' ').join('_');
	};
	
	exports.default = createSurveyPdfName;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.customSerializer = exports.handleBooleans = exports.hashSerializer = undefined;
	
	var _snakeCase = __webpack_require__(467);
	
	var _snakeCase2 = _interopRequireDefault(_snakeCase);
	
	var _dateConverters = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// default hash serializer
	/* eslint-disable no-param-reassign */
	var hashSerializer = exports.hashSerializer = function hashSerializer(result, key, value) {
	  var existing = result[key];
	
	  if (existing) {
	    if (!Array.isArray(existing)) {
	      result[key] = [existing];
	    }
	    result[key].push(value);
	  } else {
	    result[key] = value;
	  }
	  return result;
	};
	
	// handle 'boolean' string values as booleans
	var handleBooleans = exports.handleBooleans = function handleBooleans(val) {
	  switch (val) {
	    case 'true':
	      return true;
	    case 'false':
	      return false;
	    default:
	      return val;
	  }
	};
	
	// custom hash serializer itself
	var customSerializer = exports.customSerializer = function customSerializer(result, key, value, formatMessage) {
	  // handle boolean values
	  var newValue = handleBooleans(value);
	
	  // handle date format
	  if (key === 'dob') {
	    newValue = (0, _dateConverters.convertDateToAPIFormat)(newValue, formatMessage);
	  }
	
	  // handle camelCase -> snake_case
	  var snakeKey = (0, _snakeCase2.default)(key);
	
	  return hashSerializer(result, snakeKey, newValue);
	};

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDashboardFilterDate = formatDashboardFilterDate;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDashboardFilterDate(time) {
	  return (0, _moment2.default)(time).format('YYYY-MM-DD');
	}

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dependentStatusCheck = dependentStatusCheck;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dependentStatusCheck(_ref) {
	  var id = _ref.id,
	      guardianDependentsList = _ref.guardianDependentsList,
	      showDependentCreatedModal = _ref.showDependentCreatedModal;
	
	  var targetPerson = guardianDependentsList && guardianDependentsList.find(function (person) {
	    if (person.dependent) {
	      return person.dependent.id === id;
	    }
	
	    return person.id === id;
	  });
	
	  var status = (0, _get2.default)(targetPerson, 'status');
	  var pending = status === _props.DEPENDENT_STATUSES.PENDING;
	  var unverified = status === _props.DEPENDENT_STATUSES.UNVERIFIED;
	  if (pending || unverified) {
	    showDependentCreatedModal({
	      messageId: 'dependent.form.' + (pending ? 'createComplete' : 'unverifiedRequest')
	    });
	    return false;
	  }
	
	  return true;
	}

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.subscribeImagePreview = exports.emitImagePreview = undefined;
	
	var _pubsubJs = __webpack_require__(994);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IMAGE_PREVIEW = 'IMAGE_PREVIEW';
	
	var emitImagePreview = exports.emitImagePreview = function emitImagePreview(url) {
	  _pubsubJs2.default.publish(IMAGE_PREVIEW, url);
	};
	
	var subscribeImagePreview = exports.subscribeImagePreview = function subscribeImagePreview(cb) {
	  var token = _pubsubJs2.default.subscribe(IMAGE_PREVIEW, function (msg, data) {
	    return cb(data);
	  });
	
	  return function () {
	    _pubsubJs2.default.unsubscribe(token);
	  };
	};

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getScaleAnswers = function getScaleAnswers(scaleDescription) {
	  var answers = [];
	
	  if (scaleDescription) {
	    var minValue = scaleDescription.minValue,
	        maxValue = scaleDescription.maxValue;
	
	    for (var value = minValue; value <= maxValue; value += 1) {
	      answers.push(value);
	    }
	  }
	
	  return answers;
	};
	
	exports.default = getScaleAnswers;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _handleDOB = __webpack_require__(909);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	var _dateConverters = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (profile, genderTypesList, formatMessage) {
	  var gender = (0, _get2.default)(profile, 'gender');
	  var convertedGender = genderTypesList && genderTypesList.find(function (_ref) {
	    var value = _ref.value;
	    return value === gender;
	  });
	  var dob = (0, _get2.default)(profile, 'dob');
	  var dobAPIFormat = (0, _dateConverters.convertDateToUIFormat)(dob, formatMessage);
	  var ageString = dob && (0, _handleDOB.handleAge)(dobAPIFormat, formatMessage);
	
	  var genderString = null;
	
	  if (gender) {
	    var genderTranslated = (0, _convertListWithLocalization.convertGenderList)([convertedGender], formatMessage);
	    genderString = (0, _get2.default)(genderTranslated, '[0].label');
	  }
	
	  if (genderString && ageString) {
	    return genderString + ', ' + ageString;
	  }
	
	  return genderString || ageString || '';
	};

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _capitalize = __webpack_require__(209);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getString = function getString(key, code) {
	  return (0, _capitalize2.default)(key) + ' ' + code;
	};
	
	exports.default = function (errorObj) {
	  var validationErrors = (0, _get2.default)(errorObj, ['meta', 'validationErrors']);
	
	  return validationErrors && (0, _keys2.default)(validationErrors).reduce(function (acc, key) {
	    var entity = validationErrors[key];
	
	    if (entity) {
	      if (Array.isArray(entity)) {
	        entity.forEach(function (error) {
	          return acc.push(getString(key, error.code));
	        });
	      } else {
	        acc.push(getString(key, entity));
	      }
	    }
	
	    return acc;
	  }, []);
	};

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _difference_in_weeks = __webpack_require__(4703);
	
	var _difference_in_weeks2 = _interopRequireDefault(_difference_in_weeks);
	
	var _difference_in_days = __webpack_require__(2172);
	
	var _difference_in_days2 = _interopRequireDefault(_difference_in_days);
	
	var _difference_in_hours = __webpack_require__(4701);
	
	var _difference_in_hours2 = _interopRequireDefault(_difference_in_hours);
	
	var _difference_in_minutes = __webpack_require__(4702);
	
	var _difference_in_minutes2 = _interopRequireDefault(_difference_in_minutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleExpirationTime = function handleExpirationTime(date, useUtcTime) {
	  var now = new Date();
	  var startTime = useUtcTime ? now.getTime() : now;
	  var minsLeft = (0, _difference_in_minutes2.default)(date, startTime);
	  var minsInHour = 60;
	  var minsInDay = minsInHour * 24;
	  var minsInWeek = minsInDay * 7;
	
	  var expirationObj = {
	    amount: minsLeft,
	    units: 'mins'
	  };
	
	  if (minsLeft < 0) return 'Expired';
	
	  if (minsLeft > minsInWeek) {
	    expirationObj = {
	      amount: (0, _difference_in_weeks2.default)(date, new Date()),
	      units: 'weeks'
	    };
	  } else if (minsLeft > minsInDay) {
	    expirationObj = {
	      amount: (0, _difference_in_days2.default)(date, new Date()),
	      units: 'days'
	    };
	  } else if (minsLeft > minsInHour) {
	    expirationObj = {
	      amount: (0, _difference_in_hours2.default)(date, new Date()),
	      units: 'hours'
	    };
	  }
	
	  var expiration = 'Expires in ' + expirationObj.amount + ' ' + expirationObj.units;
	  return expiration;
	};
	
	exports.default = handleExpirationTime;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _includes = __webpack_require__(324);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _find = __webpack_require__(462);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (organizations) {
	  var country = null;
	
	  if (!(0, _size2.default)(organizations)) return null;
	
	  if ((0, _find2.default)(organizations, function (item) {
	    return (0, _includes2.default)(item, 'Flagler');
	  })) {
	    country = 'USA';
	  }
	
	  return country;
	};

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isClosedDisclaimerInforming = exports.clearDisclaimerInformingIds = exports.closeDisclaimerInforming = undefined;
	
	var _stringify = __webpack_require__(914);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DISCLAIMER_INFORMING_ITEM_KEY = 'disclaimer-informing-ids';
	
	var getDisclaimerInformingChatIds = function getDisclaimerInformingChatIds() {
	  var chatIdsClosedDisclaimer = localStorage.getItem(DISCLAIMER_INFORMING_ITEM_KEY);
	
	  return chatIdsClosedDisclaimer ? JSON.parse(chatIdsClosedDisclaimer) : null;
	};
	
	var closeDisclaimerInforming = exports.closeDisclaimerInforming = function closeDisclaimerInforming(chatId) {
	  try {
	    var closedDisclaimerChatIds = getDisclaimerInformingChatIds();
	    var updatesIdsData = closedDisclaimerChatIds ? [].concat((0, _toConsumableArray3.default)(closedDisclaimerChatIds), [chatId]) : [chatId];
	
	    localStorage.setItem(DISCLAIMER_INFORMING_ITEM_KEY, (0, _stringify2.default)(updatesIdsData));
	  } catch (e) {
	    return null;
	  }
	};
	
	var clearDisclaimerInformingIds = exports.clearDisclaimerInformingIds = function clearDisclaimerInformingIds() {
	  try {
	    localStorage.removeItem(DISCLAIMER_INFORMING_ITEM_KEY);
	  } catch (e) {
	    return null;
	  }
	};
	
	var isClosedDisclaimerInforming = exports.isClosedDisclaimerInforming = function isClosedDisclaimerInforming(chatId) {
	  var closedDisclaimerChatIds = getDisclaimerInformingChatIds();
	
	  return closedDisclaimerChatIds ? closedDisclaimerChatIds.includes(chatId) : false;
	};

/***/ }),
/* 1928 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var makeOptionalLabel = exports.makeOptionalLabel = function makeOptionalLabel(i18n, formatMessage) {
	  var label = formatMessage({ id: i18n });
	  var optional = formatMessage({ id: 'common.optional' });
	
	  return label + ' ' + optional;
	};

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertInsuranceFormDataToFormData = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var convertInsuranceFormDataToFormData = exports.convertInsuranceFormDataToFormData = function convertInsuranceFormDataToFormData(_ref) {
	  var insuranceFormData = _ref.insuranceFormData,
	      userId = _ref.userId,
	      insuranceId = _ref.insuranceId;
	  var groupNumber = insuranceFormData.groupNumber,
	      memberId = insuranceFormData.memberId,
	      payerId = insuranceFormData.payerId,
	      primarySubscriber = insuranceFormData.primarySubscriber,
	      isPrimarySubscriber = insuranceFormData.isPrimarySubscriber;
	
	
	  var data = {};
	
	  data['userId'] = userId;
	  data['group_number'] = groupNumber || '';
	  data['member_id'] = memberId;
	  data['payer_id'] = payerId;
	  data['is_primary_subscriber'] = isPrimarySubscriber;
	
	  if (insuranceId) {
	    data['patientInsuranceId'] = insuranceId;
	  }
	
	  if (primarySubscriber && (0, _keys2.default)(primarySubscriber).length) {
	    data['primary_subscriber'] = {
	      first_name: primarySubscriber.firstName,
	      last_name: primarySubscriber.lastName,
	      postal_code: primarySubscriber.postalCode,
	      address_1: primarySubscriber.address1,
	      address_2: primarySubscriber.address2 || '',
	      phone_number: primarySubscriber.phoneNumber,
	      gender: primarySubscriber.gender,
	      insurance_relation_id: primarySubscriber.insuranceRelationId || '',
	      city: primarySubscriber.city,
	      state: primarySubscriber.state,
	      dob: primarySubscriber.dob
	    };
	  } else {
	    data['primary_subscriber'] = {};
	  }
	
	  return data;
	};

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRequestPayloadFromFormState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _formFields = __webpack_require__(38);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DO_NOT_HAVE_INSURANCE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DO_NOT_HAVE_INSURANCE,
	    PRIMARY_SUBSCRIBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PRIMARY_SUBSCRIBER;
	var getRequestPayloadFromFormState = exports.getRequestPayloadFromFormState = function getRequestPayloadFromFormState(formState) {
	  var requestPayloadData = {};
	
	  var payerId = (0, _get2.default)(formState.healthPlan, 'id');
	
	  requestPayloadData.groupNumber = formState.groupNumber.trim() || null;
	  requestPayloadData.memberId = formState.memberId;
	  requestPayloadData.payerId = payerId;
	  requestPayloadData.primarySubscriber = {};
	  requestPayloadData.isPrimarySubscriber = formState[PRIMARY_SUBSCRIBER];
	
	  if (!formState[PRIMARY_SUBSCRIBER]) {
	    var state = (0, _get2.default)(formState.state, 'label') || formState.state;
	
	    requestPayloadData.primarySubscriber.firstName = formState.firstName.trim();
	    requestPayloadData.primarySubscriber.lastName = formState.lastName.trim();
	    requestPayloadData.primarySubscriber.postalCode = formState.postalCode;
	    requestPayloadData.primarySubscriber.address1 = formState.address1.trim();
	    requestPayloadData.primarySubscriber.address2 = formState.address2.trim() || null;
	    requestPayloadData.primarySubscriber.phoneNumber = formState.phoneNumber;
	    requestPayloadData.primarySubscriber.gender = formState.gender;
	    requestPayloadData.primarySubscriber.insuranceRelationId = formState.insuranceRelationId || null;
	    requestPayloadData.primarySubscriber.city = formState.city.trim();
	    requestPayloadData.primarySubscriber.state = state;
	    requestPayloadData.primarySubscriber.dob = (0, _utils.getTimeFromDateUTC)(formState.dob, 'YYYY-MM-DD', false);
	  }
	
	  return requestPayloadData;
	};

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.redirectToPaperworkVisitDetails = redirectToPaperworkVisitDetails;
	exports.redirectToPaperworkCompletedVisitDetails = redirectToPaperworkCompletedVisitDetails;
	
	var _reactRouter = __webpack_require__(42);
	
	var _routes = __webpack_require__(37);
	
	function redirectToPaperworkVisitDetails(id) {
	  _reactRouter.browserHistory.replace(_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_VISIT_DETAILS);
	}
	
	function redirectToPaperworkCompletedVisitDetails(id) {
	  _reactRouter.browserHistory.replace(_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_COMPLETE_VISIT_DETAILS);
	}

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var replacedText = {
	  '&lt;': '<',
	  '<br />': '\n'
	};
	
	exports.default = function (string) {
	  return String(string).replace(/<br\s*\/?>|&lt;/g, function (s) {
	    return replacedText[s];
	  });
	};

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(551);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _reduxActions = __webpack_require__(1654);
	
	var _camelCase = __webpack_require__(322);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * Function that transforms string action constants like this:
	 * const HELLO = 'module/sub-module/HELLO';
	 * const DEAR_ACTION = 'module/sub-module/DEAR_ACTION';
	 *
	 * into object with camel-cased keys of action creators like this:
	 * {
	 *   hello: createAction('module/sub-module/HELLO'),
	 *   dearAction: createAction('module/sub-module/DEAR_ACTION'),
	 * }
	 * */
	var createActions = function createActions(consts) {
	  return (0, _keys2.default)(consts).reduce(function (acc, action) {
	    (0, _defineProperty2.default)(acc, (0, _camelCase2.default)(action), {
	      value: (0, _reduxActions.createAction)(consts[action]),
	      enumerable: true
	    });
	    return acc;
	  }, {});
	};
	
	exports.default = createActions;

/***/ }),
/* 1934 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable no-prototype-builtins */
	// https://github.com/reactjs/redux/blob/master/docs/recipes/ReducingBoilerplate.md#generating-reducers
	var createReducer = function createReducer(initialState, handlers) {
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (handlers.hasOwnProperty(action.type)) {
	      return handlers[action.type](state, action);
	    }
	    return state;
	  };
	};
	
	exports.default = createReducer;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OverrideReactSelectStyles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _hexToRgba = __webpack_require__(4217);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OverrideReactSelectStyles = exports.OverrideReactSelectStyles = {
	  control: function control(base, state) {
	    return (0, _extends3.default)({}, base, {
	      minHeight: 35,
	      borderColor: (0, _hexToRgba.hexToRgba)(_styles.COLORS.bluePrimary, 0.1),
	      borderRadius: 2,
	      boxShadow: state.isFocused ? '0 0 0 1px ' + (0, _hexToRgba.hexToRgba)(_styles.COLORS.fontPrimary, 0.5) : 'none',
	      '&:hover': { borderColor: (0, _hexToRgba.hexToRgba)(_styles.COLORS.bluePrimary, 0.1) }
	    });
	  },
	  placeholder: function placeholder(base) {
	    return (0, _extends3.default)({}, base, {
	      color: (0, _hexToRgba.hexToRgba)(_styles.COLORS.fontPrimary, 0.6),
	      fontSize: 14
	    });
	  },
	  dropdownIndicator: function dropdownIndicator(base) {
	    return (0, _extends3.default)({}, base, {
	      padding: 6
	    });
	  },
	  indicatorSeparator: function indicatorSeparator() {
	    return { display: 'none' };
	  },
	  menu: function menu(base) {
	    return (0, _extends3.default)({}, base, { zIndex: 3 });
	  },
	  option: function option(base) {
	    return (0, _extends3.default)({}, base, {
	      fontSize: 14
	    });
	  },
	  input: function input(base) {
	    return (0, _extends3.default)({}, base, {
	      margin: 0
	    });
	  },
	  valueContainer: function valueContainer(base) {
	    return (0, _extends3.default)({}, base, {
	      padding: '2px 0px 2px 6px'
	    });
	  },
	  singleValue: function singleValue(base, state) {
	    var hasComplexLabel = (0, _react.isValidElement)(state.data && state.data.label);
	    return (0, _extends3.default)({}, base, {
	      fontSize: 14,
	      position: 'static',
	      transform: 'none',
	      whiteSpace: 'normal'
	    }, hasComplexLabel && { padding: '10px 0}' });
	  }
	};

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _props = __webpack_require__(41);
	
	var sortByKey = function sortByKey(values, sortingKey) {
	  var sortingType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _props.SORT_TYPES.desc;
	
	  if (!sortingKey) return values;
	
	  return values.sort(function (a, b) {
	    var x = a[sortingKey] || 0;
	    var y = b[sortingKey] || 0;
	
	    if (sortingKey === _props.LAST_MESSAGE_SORTING) {
	      x = new Date(x);
	      y = new Date(y);
	    }
	
	    return sortingType === _props.SORT_TYPES.desc ? y - x : x - y;
	  });
	};
	
	exports.default = sortByKey;

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var submitForm = exports.submitForm = function submitForm(form) {
	  var btn = document.createElement('button');
	  btn.type = 'submit';
	  btn.style.display = 'none';
	  form.appendChild(btn);
	  btn.click();
	  btn.remove();
	};

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getTeamOrUserName = exports.getTeamOrUserName = function getTeamOrUserName(actor, teamOriginalActor) {
	  return teamOriginalActor ? "(" + actor + "), " + teamOriginalActor : actor;
	};

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getText = undefined;
	
	var _isPlainObject = __webpack_require__(248);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getText = exports.getText = function getText(msg, formatMessage) {
	  if ((0, _isPlainObject2.default)(msg) && msg.id) {
	    return formatMessage(msg);
	  }
	
	  return msg;
	};

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleServerErrorWithToast = handleServerErrorWithToast;
	
	var _makeToast = __webpack_require__(4242);
	
	var _getServerErrorText = __webpack_require__(4241);
	
	function handleServerErrorWithToast(_ref) {
	  var payload = _ref.payload;
	
	  var message = (0, _getServerErrorText.getServerErrorText)(payload);
	  (0, _makeToast.makeToast)('error', message);
	}

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.joinString = undefined;
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.updateDeep = updateDeep;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _update = __webpack_require__(5523);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _findIndex = __webpack_require__(979);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _cloneDeep = __webpack_require__(2346);
	
	var _cloneDeep2 = _interopRequireDefault(_cloneDeep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var joinString = exports.joinString = function joinString() {
	  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
	  return arr.filter(Boolean).join(symbol);
	};
	
	function updateDeep(target, path, updater) {
	  if (typeof updater !== 'function') return target;
	
	  if (typeof path === 'string') {
	    return (0, _update2.default)((0, _cloneDeep2.default)(target), path, updater);
	  }
	
	  var safePath = path.reduce(function (result, entity) {
	    switch (typeof entity === 'undefined' ? 'undefined' : (0, _typeof3.default)(entity)) {
	      case 'number':
	        return result + '[' + entity + ']';
	      case 'string':
	        return joinString([result, entity], '.');
	      default:
	        return result + '[' + (0, _findIndex2.default)((0, _get2.default)(target, result) || target, entity) + ']';
	    }
	  }, '');
	
	  return (0, _update2.default)((0, _cloneDeep2.default)(target), safePath, updater);
	}

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable eqeqeq */
	// validates year/month/day ranges
	var validateDate = function validateDate(year, month, day) {
	  // Check the ranges of month and year
	  var invalidRangeYear = year < 0 || year > 3000;
	  var invalidRangeMonth = month == 0 || month > 12;
	
	  if (invalidRangeYear || invalidRangeMonth) return false;
	
	  // Check the range of the day
	  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	  // Adjust for leap years
	  if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
	    monthLength[1] = 29;
	  }
	
	  var validRangeDay = day > 0 && day <= monthLength[month - 1];
	  return validRangeDay;
	};
	
	exports.default = validateDate;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validateInputDOB = __webpack_require__(4244);
	
	var _validateInputDOB2 = _interopRequireDefault(_validateInputDOB);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (dob) {
	  return !dob || (0, _validateInputDOB2.default)(dob);
	};

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fieldName, code, description) {
	  return {
	    description: description,
	    meta: {
	      validationErrors: (0, _defineProperty3.default)({}, fieldName, [{ code: code, description: description }])
	    }
	  };
	};

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validations = __webpack_require__(81);
	
	exports.default = function (phoneHome) {
	  return !phoneHome || _validations.PATTERNS.PHONE_HOME.test(phoneHome);
	};

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isEmail = undefined;
	
	var _validations = __webpack_require__(81);
	
	var _defaultValidator = __webpack_require__(700);
	
	var isEmail = exports.isEmail = function isEmail(value) {
	  return (0, _defaultValidator.defaultValidator)(_validations.PATTERNS.HAS_ALPHABETICAL_CHARACTER, value);
	};

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return _validations.PATTERNS.POSTAL_CODE.test(value);
	};
	
	var _validations = __webpack_require__(81);

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(103),
	    BRAND_NAME = _require.BRAND_NAME;
	
	var LOWER_CASED_BRAND_NAME = BRAND_NAME.toLowerCase();
	
	var isFlagler = BRAND_NAME === 'FLAGLER';
	
	var isHealthfully = BRAND_NAME === 'HEALTHFULLY';
	
	module.exports = {
	  isFlagler: isFlagler,
	  isHealthfully: isHealthfully,
	  LOWER_CASED_BRAND_NAME: LOWER_CASED_BRAND_NAME
	};

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var BlockCipher = C_lib.BlockCipher;
			var C_algo = C.algo;
	
			// Lookup tables
			var SBOX = [];
			var INV_SBOX = [];
			var SUB_MIX_0 = [];
			var SUB_MIX_1 = [];
			var SUB_MIX_2 = [];
			var SUB_MIX_3 = [];
			var INV_SUB_MIX_0 = [];
			var INV_SUB_MIX_1 = [];
			var INV_SUB_MIX_2 = [];
			var INV_SUB_MIX_3 = [];
	
			// Compute lookup tables
			(function () {
				// Compute double table
				var d = [];
				for (var i = 0; i < 256; i++) {
					if (i < 128) {
						d[i] = i << 1;
					} else {
						d[i] = i << 1 ^ 0x11b;
					}
				}
	
				// Walk GF(2^8)
				var x = 0;
				var xi = 0;
				for (var i = 0; i < 256; i++) {
					// Compute sbox
					var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
					sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
					SBOX[x] = sx;
					INV_SBOX[sx] = x;
	
					// Compute multiplication
					var x2 = d[x];
					var x4 = d[x2];
					var x8 = d[x4];
	
					// Compute sub bytes, mix columns tables
					var t = d[sx] * 0x101 ^ sx * 0x1010100;
					SUB_MIX_0[x] = t << 24 | t >>> 8;
					SUB_MIX_1[x] = t << 16 | t >>> 16;
					SUB_MIX_2[x] = t << 8 | t >>> 24;
					SUB_MIX_3[x] = t;
	
					// Compute inv sub bytes, inv mix columns tables
					var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
					INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
					INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
					INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
					INV_SUB_MIX_3[sx] = t;
	
					// Compute next counter
					if (!x) {
						x = xi = 1;
					} else {
						x = x2 ^ d[d[d[x8 ^ x2]]];
						xi ^= d[d[xi]];
					}
				}
			})();
	
			// Precomputed Rcon lookup
			var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	
			/**
	   * AES block cipher algorithm.
	   */
			var AES = C_algo.AES = BlockCipher.extend({
				_doReset: function _doReset() {
					var t;
	
					// Skip reset of nRounds has been set before and key did not change
					if (this._nRounds && this._keyPriorReset === this._key) {
						return;
					}
	
					// Shortcuts
					var key = this._keyPriorReset = this._key;
					var keyWords = key.words;
					var keySize = key.sigBytes / 4;
	
					// Compute number of rounds
					var nRounds = this._nRounds = keySize + 6;
	
					// Compute number of key schedule rows
					var ksRows = (nRounds + 1) * 4;
	
					// Compute key schedule
					var keySchedule = this._keySchedule = [];
					for (var ksRow = 0; ksRow < ksRows; ksRow++) {
						if (ksRow < keySize) {
							keySchedule[ksRow] = keyWords[ksRow];
						} else {
							t = keySchedule[ksRow - 1];
	
							if (!(ksRow % keySize)) {
								// Rot word
								t = t << 8 | t >>> 24;
	
								// Sub word
								t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
	
								// Mix Rcon
								t ^= RCON[ksRow / keySize | 0] << 24;
							} else if (keySize > 6 && ksRow % keySize == 4) {
								// Sub word
								t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
							}
	
							keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
						}
					}
	
					// Compute inv key schedule
					var invKeySchedule = this._invKeySchedule = [];
					for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
						var ksRow = ksRows - invKsRow;
	
						if (invKsRow % 4) {
							var t = keySchedule[ksRow];
						} else {
							var t = keySchedule[ksRow - 4];
						}
	
						if (invKsRow < 4 || ksRow <= 4) {
							invKeySchedule[invKsRow] = t;
						} else {
							invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
						}
					}
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					// Swap 2nd and 4th rows
					var t = M[offset + 1];
					M[offset + 1] = M[offset + 3];
					M[offset + 3] = t;
	
					this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
	
					// Inv swap 2nd and 4th rows
					var t = M[offset + 1];
					M[offset + 1] = M[offset + 3];
					M[offset + 3] = t;
				},
	
				_doCryptBlock: function _doCryptBlock(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
					// Shortcut
					var nRounds = this._nRounds;
	
					// Get input, add round key
					var s0 = M[offset] ^ keySchedule[0];
					var s1 = M[offset + 1] ^ keySchedule[1];
					var s2 = M[offset + 2] ^ keySchedule[2];
					var s3 = M[offset + 3] ^ keySchedule[3];
	
					// Key schedule row counter
					var ksRow = 4;
	
					// Rounds
					for (var round = 1; round < nRounds; round++) {
						// Shift rows, sub bytes, mix columns, add round key
						var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
						var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
						var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
						var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
	
						// Update state
						s0 = t0;
						s1 = t1;
						s2 = t2;
						s3 = t3;
					}
	
					// Shift rows, sub bytes, add round key
					var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
					var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
					var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
					var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	
					// Set output
					M[offset] = t0;
					M[offset + 1] = t1;
					M[offset + 2] = t2;
					M[offset + 3] = t3;
				},
	
				keySize: 256 / 32
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	   */
			C.AES = BlockCipher._createHelper(AES);
		})();
	
		return CryptoJS.AES;
	});

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var BlockCipher = C_lib.BlockCipher;
			var C_algo = C.algo;
	
			var N = 16;
	
			//Origin pbox and sbox, derived from PI
			var ORIG_P = [0x243F6A88, 0x85A308D3, 0x13198A2E, 0x03707344, 0xA4093822, 0x299F31D0, 0x082EFA98, 0xEC4E6C89, 0x452821E6, 0x38D01377, 0xBE5466CF, 0x34E90C6C, 0xC0AC29B7, 0xC97C50DD, 0x3F84D5B5, 0xB5470917, 0x9216D5D9, 0x8979FB1B];
	
			var ORIG_S = [[0xD1310BA6, 0x98DFB5AC, 0x2FFD72DB, 0xD01ADFB7, 0xB8E1AFED, 0x6A267E96, 0xBA7C9045, 0xF12C7F99, 0x24A19947, 0xB3916CF7, 0x0801F2E2, 0x858EFC16, 0x636920D8, 0x71574E69, 0xA458FEA3, 0xF4933D7E, 0x0D95748F, 0x728EB658, 0x718BCD58, 0x82154AEE, 0x7B54A41D, 0xC25A59B5, 0x9C30D539, 0x2AF26013, 0xC5D1B023, 0x286085F0, 0xCA417918, 0xB8DB38EF, 0x8E79DCB0, 0x603A180E, 0x6C9E0E8B, 0xB01E8A3E, 0xD71577C1, 0xBD314B27, 0x78AF2FDA, 0x55605C60, 0xE65525F3, 0xAA55AB94, 0x57489862, 0x63E81440, 0x55CA396A, 0x2AAB10B6, 0xB4CC5C34, 0x1141E8CE, 0xA15486AF, 0x7C72E993, 0xB3EE1411, 0x636FBC2A, 0x2BA9C55D, 0x741831F6, 0xCE5C3E16, 0x9B87931E, 0xAFD6BA33, 0x6C24CF5C, 0x7A325381, 0x28958677, 0x3B8F4898, 0x6B4BB9AF, 0xC4BFE81B, 0x66282193, 0x61D809CC, 0xFB21A991, 0x487CAC60, 0x5DEC8032, 0xEF845D5D, 0xE98575B1, 0xDC262302, 0xEB651B88, 0x23893E81, 0xD396ACC5, 0x0F6D6FF3, 0x83F44239, 0x2E0B4482, 0xA4842004, 0x69C8F04A, 0x9E1F9B5E, 0x21C66842, 0xF6E96C9A, 0x670C9C61, 0xABD388F0, 0x6A51A0D2, 0xD8542F68, 0x960FA728, 0xAB5133A3, 0x6EEF0B6C, 0x137A3BE4, 0xBA3BF050, 0x7EFB2A98, 0xA1F1651D, 0x39AF0176, 0x66CA593E, 0x82430E88, 0x8CEE8619, 0x456F9FB4, 0x7D84A5C3, 0x3B8B5EBE, 0xE06F75D8, 0x85C12073, 0x401A449F, 0x56C16AA6, 0x4ED3AA62, 0x363F7706, 0x1BFEDF72, 0x429B023D, 0x37D0D724, 0xD00A1248, 0xDB0FEAD3, 0x49F1C09B, 0x075372C9, 0x80991B7B, 0x25D479D8, 0xF6E8DEF7, 0xE3FE501A, 0xB6794C3B, 0x976CE0BD, 0x04C006BA, 0xC1A94FB6, 0x409F60C4, 0x5E5C9EC2, 0x196A2463, 0x68FB6FAF, 0x3E6C53B5, 0x1339B2EB, 0x3B52EC6F, 0x6DFC511F, 0x9B30952C, 0xCC814544, 0xAF5EBD09, 0xBEE3D004, 0xDE334AFD, 0x660F2807, 0x192E4BB3, 0xC0CBA857, 0x45C8740F, 0xD20B5F39, 0xB9D3FBDB, 0x5579C0BD, 0x1A60320A, 0xD6A100C6, 0x402C7279, 0x679F25FE, 0xFB1FA3CC, 0x8EA5E9F8, 0xDB3222F8, 0x3C7516DF, 0xFD616B15, 0x2F501EC8, 0xAD0552AB, 0x323DB5FA, 0xFD238760, 0x53317B48, 0x3E00DF82, 0x9E5C57BB, 0xCA6F8CA0, 0x1A87562E, 0xDF1769DB, 0xD542A8F6, 0x287EFFC3, 0xAC6732C6, 0x8C4F5573, 0x695B27B0, 0xBBCA58C8, 0xE1FFA35D, 0xB8F011A0, 0x10FA3D98, 0xFD2183B8, 0x4AFCB56C, 0x2DD1D35B, 0x9A53E479, 0xB6F84565, 0xD28E49BC, 0x4BFB9790, 0xE1DDF2DA, 0xA4CB7E33, 0x62FB1341, 0xCEE4C6E8, 0xEF20CADA, 0x36774C01, 0xD07E9EFE, 0x2BF11FB4, 0x95DBDA4D, 0xAE909198, 0xEAAD8E71, 0x6B93D5A0, 0xD08ED1D0, 0xAFC725E0, 0x8E3C5B2F, 0x8E7594B7, 0x8FF6E2FB, 0xF2122B64, 0x8888B812, 0x900DF01C, 0x4FAD5EA0, 0x688FC31C, 0xD1CFF191, 0xB3A8C1AD, 0x2F2F2218, 0xBE0E1777, 0xEA752DFE, 0x8B021FA1, 0xE5A0CC0F, 0xB56F74E8, 0x18ACF3D6, 0xCE89E299, 0xB4A84FE0, 0xFD13E0B7, 0x7CC43B81, 0xD2ADA8D9, 0x165FA266, 0x80957705, 0x93CC7314, 0x211A1477, 0xE6AD2065, 0x77B5FA86, 0xC75442F5, 0xFB9D35CF, 0xEBCDAF0C, 0x7B3E89A0, 0xD6411BD3, 0xAE1E7E49, 0x00250E2D, 0x2071B35E, 0x226800BB, 0x57B8E0AF, 0x2464369B, 0xF009B91E, 0x5563911D, 0x59DFA6AA, 0x78C14389, 0xD95A537F, 0x207D5BA2, 0x02E5B9C5, 0x83260376, 0x6295CFA9, 0x11C81968, 0x4E734A41, 0xB3472DCA, 0x7B14A94A, 0x1B510052, 0x9A532915, 0xD60F573F, 0xBC9BC6E4, 0x2B60A476, 0x81E67400, 0x08BA6FB5, 0x571BE91F, 0xF296EC6B, 0x2A0DD915, 0xB6636521, 0xE7B9F9B6, 0xFF34052E, 0xC5855664, 0x53B02D5D, 0xA99F8FA1, 0x08BA4799, 0x6E85076A], [0x4B7A70E9, 0xB5B32944, 0xDB75092E, 0xC4192623, 0xAD6EA6B0, 0x49A7DF7D, 0x9CEE60B8, 0x8FEDB266, 0xECAA8C71, 0x699A17FF, 0x5664526C, 0xC2B19EE1, 0x193602A5, 0x75094C29, 0xA0591340, 0xE4183A3E, 0x3F54989A, 0x5B429D65, 0x6B8FE4D6, 0x99F73FD6, 0xA1D29C07, 0xEFE830F5, 0x4D2D38E6, 0xF0255DC1, 0x4CDD2086, 0x8470EB26, 0x6382E9C6, 0x021ECC5E, 0x09686B3F, 0x3EBAEFC9, 0x3C971814, 0x6B6A70A1, 0x687F3584, 0x52A0E286, 0xB79C5305, 0xAA500737, 0x3E07841C, 0x7FDEAE5C, 0x8E7D44EC, 0x5716F2B8, 0xB03ADA37, 0xF0500C0D, 0xF01C1F04, 0x0200B3FF, 0xAE0CF51A, 0x3CB574B2, 0x25837A58, 0xDC0921BD, 0xD19113F9, 0x7CA92FF6, 0x94324773, 0x22F54701, 0x3AE5E581, 0x37C2DADC, 0xC8B57634, 0x9AF3DDA7, 0xA9446146, 0x0FD0030E, 0xECC8C73E, 0xA4751E41, 0xE238CD99, 0x3BEA0E2F, 0x3280BBA1, 0x183EB331, 0x4E548B38, 0x4F6DB908, 0x6F420D03, 0xF60A04BF, 0x2CB81290, 0x24977C79, 0x5679B072, 0xBCAF89AF, 0xDE9A771F, 0xD9930810, 0xB38BAE12, 0xDCCF3F2E, 0x5512721F, 0x2E6B7124, 0x501ADDE6, 0x9F84CD87, 0x7A584718, 0x7408DA17, 0xBC9F9ABC, 0xE94B7D8C, 0xEC7AEC3A, 0xDB851DFA, 0x63094366, 0xC464C3D2, 0xEF1C1847, 0x3215D908, 0xDD433B37, 0x24C2BA16, 0x12A14D43, 0x2A65C451, 0x50940002, 0x133AE4DD, 0x71DFF89E, 0x10314E55, 0x81AC77D6, 0x5F11199B, 0x043556F1, 0xD7A3C76B, 0x3C11183B, 0x5924A509, 0xF28FE6ED, 0x97F1FBFA, 0x9EBABF2C, 0x1E153C6E, 0x86E34570, 0xEAE96FB1, 0x860E5E0A, 0x5A3E2AB3, 0x771FE71C, 0x4E3D06FA, 0x2965DCB9, 0x99E71D0F, 0x803E89D6, 0x5266C825, 0x2E4CC978, 0x9C10B36A, 0xC6150EBA, 0x94E2EA78, 0xA5FC3C53, 0x1E0A2DF4, 0xF2F74EA7, 0x361D2B3D, 0x1939260F, 0x19C27960, 0x5223A708, 0xF71312B6, 0xEBADFE6E, 0xEAC31F66, 0xE3BC4595, 0xA67BC883, 0xB17F37D1, 0x018CFF28, 0xC332DDEF, 0xBE6C5AA5, 0x65582185, 0x68AB9802, 0xEECEA50F, 0xDB2F953B, 0x2AEF7DAD, 0x5B6E2F84, 0x1521B628, 0x29076170, 0xECDD4775, 0x619F1510, 0x13CCA830, 0xEB61BD96, 0x0334FE1E, 0xAA0363CF, 0xB5735C90, 0x4C70A239, 0xD59E9E0B, 0xCBAADE14, 0xEECC86BC, 0x60622CA7, 0x9CAB5CAB, 0xB2F3846E, 0x648B1EAF, 0x19BDF0CA, 0xA02369B9, 0x655ABB50, 0x40685A32, 0x3C2AB4B3, 0x319EE9D5, 0xC021B8F7, 0x9B540B19, 0x875FA099, 0x95F7997E, 0x623D7DA8, 0xF837889A, 0x97E32D77, 0x11ED935F, 0x16681281, 0x0E358829, 0xC7E61FD6, 0x96DEDFA1, 0x7858BA99, 0x57F584A5, 0x1B227263, 0x9B83C3FF, 0x1AC24696, 0xCDB30AEB, 0x532E3054, 0x8FD948E4, 0x6DBC3128, 0x58EBF2EF, 0x34C6FFEA, 0xFE28ED61, 0xEE7C3C73, 0x5D4A14D9, 0xE864B7E3, 0x42105D14, 0x203E13E0, 0x45EEE2B6, 0xA3AAABEA, 0xDB6C4F15, 0xFACB4FD0, 0xC742F442, 0xEF6ABBB5, 0x654F3B1D, 0x41CD2105, 0xD81E799E, 0x86854DC7, 0xE44B476A, 0x3D816250, 0xCF62A1F2, 0x5B8D2646, 0xFC8883A0, 0xC1C7B6A3, 0x7F1524C3, 0x69CB7492, 0x47848A0B, 0x5692B285, 0x095BBF00, 0xAD19489D, 0x1462B174, 0x23820E00, 0x58428D2A, 0x0C55F5EA, 0x1DADF43E, 0x233F7061, 0x3372F092, 0x8D937E41, 0xD65FECF1, 0x6C223BDB, 0x7CDE3759, 0xCBEE7460, 0x4085F2A7, 0xCE77326E, 0xA6078084, 0x19F8509E, 0xE8EFD855, 0x61D99735, 0xA969A7AA, 0xC50C06C2, 0x5A04ABFC, 0x800BCADC, 0x9E447A2E, 0xC3453484, 0xFDD56705, 0x0E1E9EC9, 0xDB73DBD3, 0x105588CD, 0x675FDA79, 0xE3674340, 0xC5C43465, 0x713E38D8, 0x3D28F89E, 0xF16DFF20, 0x153E21E7, 0x8FB03D4A, 0xE6E39F2B, 0xDB83ADF7], [0xE93D5A68, 0x948140F7, 0xF64C261C, 0x94692934, 0x411520F7, 0x7602D4F7, 0xBCF46B2E, 0xD4A20068, 0xD4082471, 0x3320F46A, 0x43B7D4B7, 0x500061AF, 0x1E39F62E, 0x97244546, 0x14214F74, 0xBF8B8840, 0x4D95FC1D, 0x96B591AF, 0x70F4DDD3, 0x66A02F45, 0xBFBC09EC, 0x03BD9785, 0x7FAC6DD0, 0x31CB8504, 0x96EB27B3, 0x55FD3941, 0xDA2547E6, 0xABCA0A9A, 0x28507825, 0x530429F4, 0x0A2C86DA, 0xE9B66DFB, 0x68DC1462, 0xD7486900, 0x680EC0A4, 0x27A18DEE, 0x4F3FFEA2, 0xE887AD8C, 0xB58CE006, 0x7AF4D6B6, 0xAACE1E7C, 0xD3375FEC, 0xCE78A399, 0x406B2A42, 0x20FE9E35, 0xD9F385B9, 0xEE39D7AB, 0x3B124E8B, 0x1DC9FAF7, 0x4B6D1856, 0x26A36631, 0xEAE397B2, 0x3A6EFA74, 0xDD5B4332, 0x6841E7F7, 0xCA7820FB, 0xFB0AF54E, 0xD8FEB397, 0x454056AC, 0xBA489527, 0x55533A3A, 0x20838D87, 0xFE6BA9B7, 0xD096954B, 0x55A867BC, 0xA1159A58, 0xCCA92963, 0x99E1DB33, 0xA62A4A56, 0x3F3125F9, 0x5EF47E1C, 0x9029317C, 0xFDF8E802, 0x04272F70, 0x80BB155C, 0x05282CE3, 0x95C11548, 0xE4C66D22, 0x48C1133F, 0xC70F86DC, 0x07F9C9EE, 0x41041F0F, 0x404779A4, 0x5D886E17, 0x325F51EB, 0xD59BC0D1, 0xF2BCC18F, 0x41113564, 0x257B7834, 0x602A9C60, 0xDFF8E8A3, 0x1F636C1B, 0x0E12B4C2, 0x02E1329E, 0xAF664FD1, 0xCAD18115, 0x6B2395E0, 0x333E92E1, 0x3B240B62, 0xEEBEB922, 0x85B2A20E, 0xE6BA0D99, 0xDE720C8C, 0x2DA2F728, 0xD0127845, 0x95B794FD, 0x647D0862, 0xE7CCF5F0, 0x5449A36F, 0x877D48FA, 0xC39DFD27, 0xF33E8D1E, 0x0A476341, 0x992EFF74, 0x3A6F6EAB, 0xF4F8FD37, 0xA812DC60, 0xA1EBDDF8, 0x991BE14C, 0xDB6E6B0D, 0xC67B5510, 0x6D672C37, 0x2765D43B, 0xDCD0E804, 0xF1290DC7, 0xCC00FFA3, 0xB5390F92, 0x690FED0B, 0x667B9FFB, 0xCEDB7D9C, 0xA091CF0B, 0xD9155EA3, 0xBB132F88, 0x515BAD24, 0x7B9479BF, 0x763BD6EB, 0x37392EB3, 0xCC115979, 0x8026E297, 0xF42E312D, 0x6842ADA7, 0xC66A2B3B, 0x12754CCC, 0x782EF11C, 0x6A124237, 0xB79251E7, 0x06A1BBE6, 0x4BFB6350, 0x1A6B1018, 0x11CAEDFA, 0x3D25BDD8, 0xE2E1C3C9, 0x44421659, 0x0A121386, 0xD90CEC6E, 0xD5ABEA2A, 0x64AF674E, 0xDA86A85F, 0xBEBFE988, 0x64E4C3FE, 0x9DBC8057, 0xF0F7C086, 0x60787BF8, 0x6003604D, 0xD1FD8346, 0xF6381FB0, 0x7745AE04, 0xD736FCCC, 0x83426B33, 0xF01EAB71, 0xB0804187, 0x3C005E5F, 0x77A057BE, 0xBDE8AE24, 0x55464299, 0xBF582E61, 0x4E58F48F, 0xF2DDFDA2, 0xF474EF38, 0x8789BDC2, 0x5366F9C3, 0xC8B38E74, 0xB475F255, 0x46FCD9B9, 0x7AEB2661, 0x8B1DDF84, 0x846A0E79, 0x915F95E2, 0x466E598E, 0x20B45770, 0x8CD55591, 0xC902DE4C, 0xB90BACE1, 0xBB8205D0, 0x11A86248, 0x7574A99E, 0xB77F19B6, 0xE0A9DC09, 0x662D09A1, 0xC4324633, 0xE85A1F02, 0x09F0BE8C, 0x4A99A025, 0x1D6EFE10, 0x1AB93D1D, 0x0BA5A4DF, 0xA186F20F, 0x2868F169, 0xDCB7DA83, 0x573906FE, 0xA1E2CE9B, 0x4FCD7F52, 0x50115E01, 0xA70683FA, 0xA002B5C4, 0x0DE6D027, 0x9AF88C27, 0x773F8641, 0xC3604C06, 0x61A806B5, 0xF0177A28, 0xC0F586E0, 0x006058AA, 0x30DC7D62, 0x11E69ED7, 0x2338EA63, 0x53C2DD94, 0xC2C21634, 0xBBCBEE56, 0x90BCB6DE, 0xEBFC7DA1, 0xCE591D76, 0x6F05E409, 0x4B7C0188, 0x39720A3D, 0x7C927C24, 0x86E3725F, 0x724D9DB9, 0x1AC15BB4, 0xD39EB8FC, 0xED545578, 0x08FCA5B5, 0xD83D7CD3, 0x4DAD0FC4, 0x1E50EF5E, 0xB161E6F8, 0xA28514D9, 0x6C51133C, 0x6FD5C7E7, 0x56E14EC4, 0x362ABFCE, 0xDDC6C837, 0xD79A3234, 0x92638212, 0x670EFA8E, 0x406000E0], [0x3A39CE37, 0xD3FAF5CF, 0xABC27737, 0x5AC52D1B, 0x5CB0679E, 0x4FA33742, 0xD3822740, 0x99BC9BBE, 0xD5118E9D, 0xBF0F7315, 0xD62D1C7E, 0xC700C47B, 0xB78C1B6B, 0x21A19045, 0xB26EB1BE, 0x6A366EB4, 0x5748AB2F, 0xBC946E79, 0xC6A376D2, 0x6549C2C8, 0x530FF8EE, 0x468DDE7D, 0xD5730A1D, 0x4CD04DC6, 0x2939BBDB, 0xA9BA4650, 0xAC9526E8, 0xBE5EE304, 0xA1FAD5F0, 0x6A2D519A, 0x63EF8CE2, 0x9A86EE22, 0xC089C2B8, 0x43242EF6, 0xA51E03AA, 0x9CF2D0A4, 0x83C061BA, 0x9BE96A4D, 0x8FE51550, 0xBA645BD6, 0x2826A2F9, 0xA73A3AE1, 0x4BA99586, 0xEF5562E9, 0xC72FEFD3, 0xF752F7DA, 0x3F046F69, 0x77FA0A59, 0x80E4A915, 0x87B08601, 0x9B09E6AD, 0x3B3EE593, 0xE990FD5A, 0x9E34D797, 0x2CF0B7D9, 0x022B8B51, 0x96D5AC3A, 0x017DA67D, 0xD1CF3ED6, 0x7C7D2D28, 0x1F9F25CF, 0xADF2B89B, 0x5AD6B472, 0x5A88F54C, 0xE029AC71, 0xE019A5E6, 0x47B0ACFD, 0xED93FA9B, 0xE8D3C48D, 0x283B57CC, 0xF8D56629, 0x79132E28, 0x785F0191, 0xED756055, 0xF7960E44, 0xE3D35E8C, 0x15056DD4, 0x88F46DBA, 0x03A16125, 0x0564F0BD, 0xC3EB9E15, 0x3C9057A2, 0x97271AEC, 0xA93A072A, 0x1B3F6D9B, 0x1E6321F5, 0xF59C66FB, 0x26DCF319, 0x7533D928, 0xB155FDF5, 0x03563482, 0x8ABA3CBB, 0x28517711, 0xC20AD9F8, 0xABCC5167, 0xCCAD925F, 0x4DE81751, 0x3830DC8E, 0x379D5862, 0x9320F991, 0xEA7A90C2, 0xFB3E7BCE, 0x5121CE64, 0x774FBE32, 0xA8B6E37E, 0xC3293D46, 0x48DE5369, 0x6413E680, 0xA2AE0810, 0xDD6DB224, 0x69852DFD, 0x09072166, 0xB39A460A, 0x6445C0DD, 0x586CDECF, 0x1C20C8AE, 0x5BBEF7DD, 0x1B588D40, 0xCCD2017F, 0x6BB4E3BB, 0xDDA26A7E, 0x3A59FF45, 0x3E350A44, 0xBCB4CDD5, 0x72EACEA8, 0xFA6484BB, 0x8D6612AE, 0xBF3C6F47, 0xD29BE463, 0x542F5D9E, 0xAEC2771B, 0xF64E6370, 0x740E0D8D, 0xE75B1357, 0xF8721671, 0xAF537D5D, 0x4040CB08, 0x4EB4E2CC, 0x34D2466A, 0x0115AF84, 0xE1B00428, 0x95983A1D, 0x06B89FB4, 0xCE6EA048, 0x6F3F3B82, 0x3520AB82, 0x011A1D4B, 0x277227F8, 0x611560B1, 0xE7933FDC, 0xBB3A792B, 0x344525BD, 0xA08839E1, 0x51CE794B, 0x2F32C9B7, 0xA01FBAC9, 0xE01CC87E, 0xBCC7D1F6, 0xCF0111C3, 0xA1E8AAC7, 0x1A908749, 0xD44FBD9A, 0xD0DADECB, 0xD50ADA38, 0x0339C32A, 0xC6913667, 0x8DF9317C, 0xE0B12B4F, 0xF79E59B7, 0x43F5BB3A, 0xF2D519FF, 0x27D9459C, 0xBF97222C, 0x15E6FC2A, 0x0F91FC71, 0x9B941525, 0xFAE59361, 0xCEB69CEB, 0xC2A86459, 0x12BAA8D1, 0xB6C1075E, 0xE3056A0C, 0x10D25065, 0xCB03A442, 0xE0EC6E0E, 0x1698DB3B, 0x4C98A0BE, 0x3278E964, 0x9F1F9532, 0xE0D392DF, 0xD3A0342B, 0x8971F21E, 0x1B0A7441, 0x4BA3348C, 0xC5BE7120, 0xC37632D8, 0xDF359F8D, 0x9B992F2E, 0xE60B6F47, 0x0FE3F11D, 0xE54CDA54, 0x1EDAD891, 0xCE6279CF, 0xCD3E7E6F, 0x1618B166, 0xFD2C1D05, 0x848FD2C5, 0xF6FB2299, 0xF523F357, 0xA6327623, 0x93A83531, 0x56CCCD02, 0xACF08162, 0x5A75EBB5, 0x6E163697, 0x88D273CC, 0xDE966292, 0x81B949D0, 0x4C50901B, 0x71C65614, 0xE6C6C7BD, 0x327A140A, 0x45E1D006, 0xC3F27B9A, 0xC9AA53FD, 0x62A80F00, 0xBB25BFE2, 0x35BDD2F6, 0x71126905, 0xB2040222, 0xB6CBCF7C, 0xCD769C2B, 0x53113EC0, 0x1640E3D3, 0x38ABBD60, 0x2547ADF0, 0xBA38209C, 0xF746CE76, 0x77AFA1C5, 0x20756060, 0x85CBFE4E, 0x8AE88DD8, 0x7AAAF9B0, 0x4CF9AA7E, 0x1948C25C, 0x02FB8A8C, 0x01C36AE4, 0xD6EBE1F9, 0x90D4F869, 0xA65CDEA0, 0x3F09252D, 0xC208E69F, 0xB74E6132, 0xCE77E25B, 0x578FDFE3, 0x3AC372E6]];
	
			var BLOWFISH_CTX = {
				pbox: [],
				sbox: []
			};
	
			function F(ctx, x) {
				var a = x >> 24 & 0xFF;
				var b = x >> 16 & 0xFF;
				var c = x >> 8 & 0xFF;
				var d = x & 0xFF;
	
				var y = ctx.sbox[0][a] + ctx.sbox[1][b];
				y = y ^ ctx.sbox[2][c];
				y = y + ctx.sbox[3][d];
	
				return y;
			}
	
			function BlowFish_Encrypt(ctx, left, right) {
				var Xl = left;
				var Xr = right;
				var temp = void 0;
	
				for (var i = 0; i < N; ++i) {
					Xl = Xl ^ ctx.pbox[i];
					Xr = F(ctx, Xl) ^ Xr;
	
					temp = Xl;
					Xl = Xr;
					Xr = temp;
				}
	
				temp = Xl;
				Xl = Xr;
				Xr = temp;
	
				Xr = Xr ^ ctx.pbox[N];
				Xl = Xl ^ ctx.pbox[N + 1];
	
				return { left: Xl, right: Xr };
			}
	
			function BlowFish_Decrypt(ctx, left, right) {
				var Xl = left;
				var Xr = right;
				var temp = void 0;
	
				for (var i = N + 1; i > 1; --i) {
					Xl = Xl ^ ctx.pbox[i];
					Xr = F(ctx, Xl) ^ Xr;
	
					temp = Xl;
					Xl = Xr;
					Xr = temp;
				}
	
				temp = Xl;
				Xl = Xr;
				Xr = temp;
	
				Xr = Xr ^ ctx.pbox[1];
				Xl = Xl ^ ctx.pbox[0];
	
				return { left: Xl, right: Xr };
			}
	
			/**
	   * Initialization ctx's pbox and sbox.
	   *
	   * @param {Object} ctx The object has pbox and sbox.
	   * @param {Array} key An array of 32-bit words.
	   * @param {int} keysize The length of the key.
	   *
	   * @example
	   *
	   *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	   */
			function BlowFishInit(ctx, key, keysize) {
				for (var Row = 0; Row < 4; Row++) {
					ctx.sbox[Row] = [];
					for (var Col = 0; Col < 256; Col++) {
						ctx.sbox[Row][Col] = ORIG_S[Row][Col];
					}
				}
	
				var keyIndex = 0;
				for (var index = 0; index < N + 2; index++) {
					ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
					keyIndex++;
					if (keyIndex >= keysize) {
						keyIndex = 0;
					}
				}
	
				var Data1 = 0;
				var Data2 = 0;
				var res = 0;
				for (var i = 0; i < N + 2; i += 2) {
					res = BlowFish_Encrypt(ctx, Data1, Data2);
					Data1 = res.left;
					Data2 = res.right;
					ctx.pbox[i] = Data1;
					ctx.pbox[i + 1] = Data2;
				}
	
				for (var _i = 0; _i < 4; _i++) {
					for (var j = 0; j < 256; j += 2) {
						res = BlowFish_Encrypt(ctx, Data1, Data2);
						Data1 = res.left;
						Data2 = res.right;
						ctx.sbox[_i][j] = Data1;
						ctx.sbox[_i][j + 1] = Data2;
					}
				}
	
				return true;
			}
	
			/**
	   * Blowfish block cipher algorithm.
	   */
			var Blowfish = C_algo.Blowfish = BlockCipher.extend({
				_doReset: function _doReset() {
					// Skip reset of nRounds has been set before and key did not change
					if (this._keyPriorReset === this._key) {
						return;
					}
	
					// Shortcuts
					var key = this._keyPriorReset = this._key;
					var keyWords = key.words;
					var keySize = key.sigBytes / 4;
	
					//Initialization pbox and sbox
					BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
					M[offset] = res.left;
					M[offset + 1] = res.right;
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
					M[offset] = res.left;
					M[offset + 1] = res.right;
				},
	
				blockSize: 64 / 32,
	
				keySize: 128 / 32,
	
				ivSize: 64 / 32
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	   */
			C.Blowfish = BlockCipher._createHelper(Blowfish);
		})();
	
		return CryptoJS.Blowfish;
	});

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_enc = C.enc;
	
			/**
	   * Base64url encoding strategy.
	   */
			var Base64url = C_enc.Base64url = {
				/**
	    * Converts a word array to a Base64url string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @param {boolean} urlSafe Whether to use url safe
	    *
	    * @return {string} The Base64url string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	    */
				stringify: function stringify(wordArray, urlSafe) {
					if (urlSafe === undefined) {
						urlSafe = true;
					}
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
					var map = urlSafe ? this._safe_map : this._map;
	
					// Clamp excess bits
					wordArray.clamp();
	
					// Convert
					var base64Chars = [];
					for (var i = 0; i < sigBytes; i += 3) {
						var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
						var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
						var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
	
						var triplet = byte1 << 16 | byte2 << 8 | byte3;
	
						for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
							base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
						}
					}
	
					// Add padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						while (base64Chars.length % 4) {
							base64Chars.push(paddingChar);
						}
					}
	
					return base64Chars.join('');
				},
	
				/**
	    * Converts a Base64url string to a word array.
	    *
	    * @param {string} base64Str The Base64url string.
	    *
	    * @param {boolean} urlSafe Whether to use url safe
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	    */
				parse: function parse(base64Str, urlSafe) {
					if (urlSafe === undefined) {
						urlSafe = true;
					}
	
					// Shortcuts
					var base64StrLength = base64Str.length;
					var map = urlSafe ? this._safe_map : this._map;
					var reverseMap = this._reverseMap;
	
					if (!reverseMap) {
						reverseMap = this._reverseMap = [];
						for (var j = 0; j < map.length; j++) {
							reverseMap[map.charCodeAt(j)] = j;
						}
					}
	
					// Ignore padding
					var paddingChar = map.charAt(64);
					if (paddingChar) {
						var paddingIndex = base64Str.indexOf(paddingChar);
						if (paddingIndex !== -1) {
							base64StrLength = paddingIndex;
						}
					}
	
					// Convert
					return parseLoop(base64Str, base64StrLength, reverseMap);
				},
	
				_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
				_safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'
			};
	
			function parseLoop(base64Str, base64StrLength, reverseMap) {
				var words = [];
				var nBytes = 0;
				for (var i = 0; i < base64StrLength; i++) {
					if (i % 4) {
						var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
						var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
						var bitsCombined = bits1 | bits2;
						words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
						nBytes++;
					}
				}
				return WordArray.create(words, nBytes);
			}
		})();
	
		return CryptoJS.enc.Base64url;
	});

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_enc = C.enc;
	
			/**
	   * UTF-16 BE encoding strategy.
	   */
			var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
				/**
	    * Converts a word array to a UTF-16 BE string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The UTF-16 BE string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var utf16Chars = [];
					for (var i = 0; i < sigBytes; i += 2) {
						var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
						utf16Chars.push(String.fromCharCode(codePoint));
					}
	
					return utf16Chars.join('');
				},
	
				/**
	    * Converts a UTF-16 BE string to a word array.
	    *
	    * @param {string} utf16Str The UTF-16 BE string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	    */
				parse: function parse(utf16Str) {
					// Shortcut
					var utf16StrLength = utf16Str.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < utf16StrLength; i++) {
						words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
					}
	
					return WordArray.create(words, utf16StrLength * 2);
				}
			};
	
			/**
	   * UTF-16 LE encoding strategy.
	   */
			C_enc.Utf16LE = {
				/**
	    * Converts a word array to a UTF-16 LE string.
	    *
	    * @param {WordArray} wordArray The word array.
	    *
	    * @return {string} The UTF-16 LE string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	    */
				stringify: function stringify(wordArray) {
					// Shortcuts
					var words = wordArray.words;
					var sigBytes = wordArray.sigBytes;
	
					// Convert
					var utf16Chars = [];
					for (var i = 0; i < sigBytes; i += 2) {
						var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
						utf16Chars.push(String.fromCharCode(codePoint));
					}
	
					return utf16Chars.join('');
				},
	
				/**
	    * Converts a UTF-16 LE string to a word array.
	    *
	    * @param {string} utf16Str The UTF-16 LE string.
	    *
	    * @return {WordArray} The word array.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	    */
				parse: function parse(utf16Str) {
					// Shortcut
					var utf16StrLength = utf16Str.length;
	
					// Convert
					var words = [];
					for (var i = 0; i < utf16StrLength; i++) {
						words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
					}
	
					return WordArray.create(words, utf16StrLength * 2);
				}
			};
	
			function swapEndian(word) {
				return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
			}
		})();
	
		return CryptoJS.enc.Utf16;
	});

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (undefined) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var CipherParams = C_lib.CipherParams;
			var C_enc = C.enc;
			var Hex = C_enc.Hex;
			var C_format = C.format;
	
			var HexFormatter = C_format.Hex = {
				/**
	    * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	    *
	    * @param {CipherParams} cipherParams The cipher params object.
	    *
	    * @return {string} The hexadecimally encoded string.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	    */
				stringify: function stringify(cipherParams) {
					return cipherParams.ciphertext.toString(Hex);
				},
	
				/**
	    * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	    *
	    * @param {string} input The hexadecimally encoded string.
	    *
	    * @return {CipherParams} The cipher params object.
	    *
	    * @static
	    *
	    * @example
	    *
	    *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	    */
				parse: function parse(input) {
					var ciphertext = Hex.parse(input);
					return CipherParams.create({ ciphertext: ciphertext });
				}
			};
		})();
	
		return CryptoJS.format.Hex;
	});

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Check if typed arrays are supported
			if (typeof ArrayBuffer != 'function') {
				return;
			}
	
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
	
			// Reference original init
			var superInit = WordArray.init;
	
			// Augment WordArray.init to handle typed arrays
			var subInit = WordArray.init = function (typedArray) {
				// Convert buffers to uint8
				if (typedArray instanceof ArrayBuffer) {
					typedArray = new Uint8Array(typedArray);
				}
	
				// Convert other array views to uint8
				if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
					typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
				}
	
				// Handle Uint8Array
				if (typedArray instanceof Uint8Array) {
					// Shortcut
					var typedArrayByteLength = typedArray.byteLength;
	
					// Extract bytes
					var words = [];
					for (var i = 0; i < typedArrayByteLength; i++) {
						words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
					}
	
					// Initialize this word array
					superInit.call(this, words, typedArrayByteLength);
				} else {
					// Else call normal init
					superInit.apply(this, arguments);
				}
			};
	
			subInit.prototype = WordArray;
		})();
	
		return CryptoJS.lib.WordArray;
	});

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Cipher Feedback block mode.
	  */
		CryptoJS.mode.CFB = function () {
			var CFB = CryptoJS.lib.BlockCipherMode.extend();
	
			CFB.Encryptor = CFB.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
	
					generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
					// Remember this block to use with next block
					this._prevBlock = words.slice(offset, offset + blockSize);
				}
			});
	
			CFB.Decryptor = CFB.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
	
					// Remember this block to use with next block
					var thisBlock = words.slice(offset, offset + blockSize);
	
					generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
					// This block becomes the previous block
					this._prevBlock = thisBlock;
				}
			});
	
			function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
				var keystream;
	
				// Shortcut
				var iv = this._iv;
	
				// Generate keystream
				if (iv) {
					keystream = iv.slice(0);
	
					// Remove IV for subsequent blocks
					this._iv = undefined;
				} else {
					keystream = this._prevBlock;
				}
				cipher.encryptBlock(keystream, 0);
	
				// Encrypt
				for (var i = 0; i < blockSize; i++) {
					words[offset + i] ^= keystream[i];
				}
			}
	
			return CFB;
		}();
	
		return CryptoJS.mode.CFB;
	});

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/** @preserve
	  * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	  * derived from CryptoJS.mode.CTR
	  * Jan Hruby jhruby.web@gmail.com
	  */
		CryptoJS.mode.CTRGladman = function () {
			var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
	
			function incWord(word) {
				if ((word >> 24 & 0xff) === 0xff) {
					//overflow
					var b1 = word >> 16 & 0xff;
					var b2 = word >> 8 & 0xff;
					var b3 = word & 0xff;
	
					if (b1 === 0xff) // overflow b1
						{
							b1 = 0;
							if (b2 === 0xff) {
								b2 = 0;
								if (b3 === 0xff) {
									b3 = 0;
								} else {
									++b3;
								}
							} else {
								++b2;
							}
						} else {
						++b1;
					}
	
					word = 0;
					word += b1 << 16;
					word += b2 << 8;
					word += b3;
				} else {
					word += 0x01 << 24;
				}
				return word;
			}
	
			function incCounter(counter) {
				if ((counter[0] = incWord(counter[0])) === 0) {
					// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
					counter[1] = incWord(counter[1]);
				}
				return counter;
			}
	
			var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
					var iv = this._iv;
					var counter = this._counter;
	
					// Generate keystream
					if (iv) {
						counter = this._counter = iv.slice(0);
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					}
	
					incCounter(counter);
	
					var keystream = counter.slice(0);
					cipher.encryptBlock(keystream, 0);
	
					// Encrypt
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= keystream[i];
					}
				}
			});
	
			CTRGladman.Decryptor = Encryptor;
	
			return CTRGladman;
		}();
	
		return CryptoJS.mode.CTRGladman;
	});

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Counter block mode.
	  */
		CryptoJS.mode.CTR = function () {
			var CTR = CryptoJS.lib.BlockCipherMode.extend();
	
			var Encryptor = CTR.Encryptor = CTR.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
					var iv = this._iv;
					var counter = this._counter;
	
					// Generate keystream
					if (iv) {
						counter = this._counter = iv.slice(0);
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					}
					var keystream = counter.slice(0);
					cipher.encryptBlock(keystream, 0);
	
					// Increment counter
					counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
	
					// Encrypt
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= keystream[i];
					}
				}
			});
	
			CTR.Decryptor = Encryptor;
	
			return CTR;
		}();
	
		return CryptoJS.mode.CTR;
	});

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Electronic Codebook block mode.
	  */
		CryptoJS.mode.ECB = function () {
			var ECB = CryptoJS.lib.BlockCipherMode.extend();
	
			ECB.Encryptor = ECB.extend({
				processBlock: function processBlock(words, offset) {
					this._cipher.encryptBlock(words, offset);
				}
			});
	
			ECB.Decryptor = ECB.extend({
				processBlock: function processBlock(words, offset) {
					this._cipher.decryptBlock(words, offset);
				}
			});
	
			return ECB;
		}();
	
		return CryptoJS.mode.ECB;
	});

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Output Feedback block mode.
	  */
		CryptoJS.mode.OFB = function () {
			var OFB = CryptoJS.lib.BlockCipherMode.extend();
	
			var Encryptor = OFB.Encryptor = OFB.extend({
				processBlock: function processBlock(words, offset) {
					// Shortcuts
					var cipher = this._cipher;
					var blockSize = cipher.blockSize;
					var iv = this._iv;
					var keystream = this._keystream;
	
					// Generate keystream
					if (iv) {
						keystream = this._keystream = iv.slice(0);
	
						// Remove IV for subsequent blocks
						this._iv = undefined;
					}
					cipher.encryptBlock(keystream, 0);
	
					// Encrypt
					for (var i = 0; i < blockSize; i++) {
						words[offset + i] ^= keystream[i];
					}
				}
			});
	
			OFB.Decryptor = Encryptor;
	
			return OFB;
		}();
	
		return CryptoJS.mode.OFB;
	});

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * ANSI X.923 padding strategy.
	  */
		CryptoJS.pad.AnsiX923 = {
			pad: function pad(data, blockSize) {
				// Shortcuts
				var dataSigBytes = data.sigBytes;
				var blockSizeBytes = blockSize * 4;
	
				// Count padding bytes
				var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
	
				// Compute last byte position
				var lastBytePos = dataSigBytes + nPaddingBytes - 1;
	
				// Pad
				data.clamp();
				data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
				data.sigBytes += nPaddingBytes;
			},
	
			unpad: function unpad(data) {
				// Get number of padding bytes from last byte
				var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
	
				// Remove padding
				data.sigBytes -= nPaddingBytes;
			}
		};
	
		return CryptoJS.pad.Ansix923;
	});

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * ISO 10126 padding strategy.
	  */
		CryptoJS.pad.Iso10126 = {
			pad: function pad(data, blockSize) {
				// Shortcut
				var blockSizeBytes = blockSize * 4;
	
				// Count padding bytes
				var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
				// Pad
				data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
			},
	
			unpad: function unpad(data) {
				// Get number of padding bytes from last byte
				var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
	
				// Remove padding
				data.sigBytes -= nPaddingBytes;
			}
		};
	
		return CryptoJS.pad.Iso10126;
	});

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * ISO/IEC 9797-1 Padding Method 2.
	  */
		CryptoJS.pad.Iso97971 = {
			pad: function pad(data, blockSize) {
				// Add 0x80 byte
				data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
	
				// Zero pad the rest
				CryptoJS.pad.ZeroPadding.pad(data, blockSize);
			},
	
			unpad: function unpad(data) {
				// Remove zero padding
				CryptoJS.pad.ZeroPadding.unpad(data);
	
				// Remove one more byte -- the 0x80 byte
				data.sigBytes--;
			}
		};
	
		return CryptoJS.pad.Iso97971;
	});

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * A noop padding strategy.
	  */
		CryptoJS.pad.NoPadding = {
			pad: function pad() {},
	
			unpad: function unpad() {}
		};
	
		return CryptoJS.pad.NoPadding;
	});

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/**
	  * Zero padding strategy.
	  */
		CryptoJS.pad.ZeroPadding = {
			pad: function pad(data, blockSize) {
				// Shortcut
				var blockSizeBytes = blockSize * 4;
	
				// Pad
				data.clamp();
				data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
			},
	
			unpad: function unpad(data) {
				// Shortcut
				var dataWords = data.words;
	
				// Unpad
				var i = data.sigBytes - 1;
				for (var i = data.sigBytes - 1; i >= 0; i--) {
					if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
						data.sigBytes = i + 1;
						break;
					}
				}
			}
		};
	
		return CryptoJS.pad.ZeroPadding;
	});

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(549), __webpack_require__(548));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(549), __webpack_require__(548)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var Base = C_lib.Base;
			var WordArray = C_lib.WordArray;
			var C_algo = C.algo;
			var SHA256 = C_algo.SHA256;
			var HMAC = C_algo.HMAC;
	
			/**
	   * Password-Based Key Derivation Function 2 algorithm.
	   */
			var PBKDF2 = C_algo.PBKDF2 = Base.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	    * @property {Hasher} hasher The hasher to use. Default: SHA256
	    * @property {number} iterations The number of iterations to perform. Default: 250000
	    */
				cfg: Base.extend({
					keySize: 128 / 32,
					hasher: SHA256,
					iterations: 250000
				}),
	
				/**
	    * Initializes a newly created key derivation function.
	    *
	    * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	    *
	    * @example
	    *
	    *     var kdf = CryptoJS.algo.PBKDF2.create();
	    *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	    *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	    */
				init: function init(cfg) {
					this.cfg = this.cfg.extend(cfg);
				},
	
				/**
	    * Computes the Password-Based Key Derivation Function 2.
	    *
	    * @param {WordArray|string} password The password.
	    * @param {WordArray|string} salt A salt.
	    *
	    * @return {WordArray} The derived key.
	    *
	    * @example
	    *
	    *     var key = kdf.compute(password, salt);
	    */
				compute: function compute(password, salt) {
					// Shortcut
					var cfg = this.cfg;
	
					// Init HMAC
					var hmac = HMAC.create(cfg.hasher, password);
	
					// Initial values
					var derivedKey = WordArray.create();
					var blockIndex = WordArray.create([0x00000001]);
	
					// Shortcuts
					var derivedKeyWords = derivedKey.words;
					var blockIndexWords = blockIndex.words;
					var keySize = cfg.keySize;
					var iterations = cfg.iterations;
	
					// Generate key
					while (derivedKeyWords.length < keySize) {
						var block = hmac.update(salt).finalize(blockIndex);
						hmac.reset();
	
						// Shortcuts
						var blockWords = block.words;
						var blockWordsLength = blockWords.length;
	
						// Iterations
						var intermediate = block;
						for (var i = 1; i < iterations; i++) {
							intermediate = hmac.finalize(intermediate);
							hmac.reset();
	
							// Shortcut
							var intermediateWords = intermediate.words;
	
							// XOR intermediate with block
							for (var j = 0; j < blockWordsLength; j++) {
								blockWords[j] ^= intermediateWords[j];
							}
						}
	
						derivedKey.concat(block);
						blockIndexWords[0]++;
					}
					derivedKey.sigBytes = keySize * 4;
	
					return derivedKey;
				}
			});
	
			/**
	   * Computes the Password-Based Key Derivation Function 2.
	   *
	   * @param {WordArray|string} password The password.
	   * @param {WordArray|string} salt A salt.
	   * @param {Object} cfg (Optional) The configuration options to use for this computation.
	   *
	   * @return {WordArray} The derived key.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var key = CryptoJS.PBKDF2(password, salt);
	   *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	   *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	   */
			C.PBKDF2 = function (password, salt, cfg) {
				return PBKDF2.create(cfg).compute(password, salt);
			};
		})();
	
		return CryptoJS.PBKDF2;
	});

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var StreamCipher = C_lib.StreamCipher;
			var C_algo = C.algo;
	
			// Reusable objects
			var S = [];
			var C_ = [];
			var G = [];
	
			/**
	   * Rabbit stream cipher algorithm.
	   *
	   * This is a legacy version that neglected to convert the key to little-endian.
	   * This error doesn't affect the cipher's security,
	   * but it does affect its compatibility with other implementations.
	   */
			var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var K = this._key.words;
					var iv = this.cfg.iv;
	
					// Generate initial state values
					var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16];
	
					// Generate initial counter values
					var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff];
	
					// Carry bit
					this._b = 0;
	
					// Iterate the system four times
					for (var i = 0; i < 4; i++) {
						nextState.call(this);
					}
	
					// Modify the counters
					for (var i = 0; i < 8; i++) {
						C[i] ^= X[i + 4 & 7];
					}
	
					// IV setup
					if (iv) {
						// Shortcuts
						var IV = iv.words;
						var IV_0 = IV[0];
						var IV_1 = IV[1];
	
						// Generate four subvectors
						var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
						var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
						var i1 = i0 >>> 16 | i2 & 0xffff0000;
						var i3 = i2 << 16 | i0 & 0x0000ffff;
	
						// Modify counter values
						C[0] ^= i0;
						C[1] ^= i1;
						C[2] ^= i2;
						C[3] ^= i3;
						C[4] ^= i0;
						C[5] ^= i1;
						C[6] ^= i2;
						C[7] ^= i3;
	
						// Iterate the system four times
						for (var i = 0; i < 4; i++) {
							nextState.call(this);
						}
					}
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var X = this._X;
	
					// Iterate the system
					nextState.call(this);
	
					// Generate four keystream words
					S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
					S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
					S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
					S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
	
					for (var i = 0; i < 4; i++) {
						// Swap endian
						S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
	
						// Encrypt
						M[offset + i] ^= S[i];
					}
				},
	
				blockSize: 128 / 32,
	
				ivSize: 64 / 32
			});
	
			function nextState() {
				// Shortcuts
				var X = this._X;
				var C = this._C;
	
				// Save old counter values
				for (var i = 0; i < 8; i++) {
					C_[i] = C[i];
				}
	
				// Calculate new counter values
				C[0] = C[0] + 0x4d34d34d + this._b | 0;
				C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
				C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
				C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
				C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
				C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
				C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
				C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
				this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
	
				// Calculate the g-values
				for (var i = 0; i < 8; i++) {
					var gx = X[i] + C[i];
	
					// Construct high and low argument for squaring
					var ga = gx & 0xffff;
					var gb = gx >>> 16;
	
					// Calculate high and low result of squaring
					var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
					var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
	
					// High XOR low
					G[i] = gh ^ gl;
				}
	
				// Calculate new state values
				X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
				X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
				X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
				X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
				X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
				X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
				X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
				X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	   */
			C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
		})();
	
		return CryptoJS.RabbitLegacy;
	});

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var StreamCipher = C_lib.StreamCipher;
			var C_algo = C.algo;
	
			// Reusable objects
			var S = [];
			var C_ = [];
			var G = [];
	
			/**
	   * Rabbit stream cipher algorithm
	   */
			var Rabbit = C_algo.Rabbit = StreamCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var K = this._key.words;
					var iv = this.cfg.iv;
	
					// Swap endian
					for (var i = 0; i < 4; i++) {
						K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
					}
	
					// Generate initial state values
					var X = this._X = [K[0], K[3] << 16 | K[2] >>> 16, K[1], K[0] << 16 | K[3] >>> 16, K[2], K[1] << 16 | K[0] >>> 16, K[3], K[2] << 16 | K[1] >>> 16];
	
					// Generate initial counter values
					var C = this._C = [K[2] << 16 | K[2] >>> 16, K[0] & 0xffff0000 | K[1] & 0x0000ffff, K[3] << 16 | K[3] >>> 16, K[1] & 0xffff0000 | K[2] & 0x0000ffff, K[0] << 16 | K[0] >>> 16, K[2] & 0xffff0000 | K[3] & 0x0000ffff, K[1] << 16 | K[1] >>> 16, K[3] & 0xffff0000 | K[0] & 0x0000ffff];
	
					// Carry bit
					this._b = 0;
	
					// Iterate the system four times
					for (var i = 0; i < 4; i++) {
						nextState.call(this);
					}
	
					// Modify the counters
					for (var i = 0; i < 8; i++) {
						C[i] ^= X[i + 4 & 7];
					}
	
					// IV setup
					if (iv) {
						// Shortcuts
						var IV = iv.words;
						var IV_0 = IV[0];
						var IV_1 = IV[1];
	
						// Generate four subvectors
						var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
						var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
						var i1 = i0 >>> 16 | i2 & 0xffff0000;
						var i3 = i2 << 16 | i0 & 0x0000ffff;
	
						// Modify counter values
						C[0] ^= i0;
						C[1] ^= i1;
						C[2] ^= i2;
						C[3] ^= i3;
						C[4] ^= i0;
						C[5] ^= i1;
						C[6] ^= i2;
						C[7] ^= i3;
	
						// Iterate the system four times
						for (var i = 0; i < 4; i++) {
							nextState.call(this);
						}
					}
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcut
					var X = this._X;
	
					// Iterate the system
					nextState.call(this);
	
					// Generate four keystream words
					S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
					S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
					S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
					S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
	
					for (var i = 0; i < 4; i++) {
						// Swap endian
						S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
	
						// Encrypt
						M[offset + i] ^= S[i];
					}
				},
	
				blockSize: 128 / 32,
	
				ivSize: 64 / 32
			});
	
			function nextState() {
				// Shortcuts
				var X = this._X;
				var C = this._C;
	
				// Save old counter values
				for (var i = 0; i < 8; i++) {
					C_[i] = C[i];
				}
	
				// Calculate new counter values
				C[0] = C[0] + 0x4d34d34d + this._b | 0;
				C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
				C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
				C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
				C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
				C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
				C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
				C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
				this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
	
				// Calculate the g-values
				for (var i = 0; i < 8; i++) {
					var gx = X[i] + C[i];
	
					// Construct high and low argument for squaring
					var ga = gx & 0xffff;
					var gb = gx >>> 16;
	
					// Calculate high and low result of squaring
					var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
					var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
	
					// High XOR low
					G[i] = gh ^ gl;
				}
	
				// Calculate new state values
				X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
				X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
				X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
				X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
				X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
				X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
				X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
				X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	   */
			C.Rabbit = StreamCipher._createHelper(Rabbit);
		})();
	
		return CryptoJS.Rabbit;
	});

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var StreamCipher = C_lib.StreamCipher;
			var C_algo = C.algo;
	
			/**
	   * RC4 stream cipher algorithm.
	   */
			var RC4 = C_algo.RC4 = StreamCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var key = this._key;
					var keyWords = key.words;
					var keySigBytes = key.sigBytes;
	
					// Init sbox
					var S = this._S = [];
					for (var i = 0; i < 256; i++) {
						S[i] = i;
					}
	
					// Key setup
					for (var i = 0, j = 0; i < 256; i++) {
						var keyByteIndex = i % keySigBytes;
						var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
	
						j = (j + S[i] + keyByte) % 256;
	
						// Swap
						var t = S[i];
						S[i] = S[j];
						S[j] = t;
					}
	
					// Counters
					this._i = this._j = 0;
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					M[offset] ^= generateKeystreamWord.call(this);
				},
	
				keySize: 256 / 32,
	
				ivSize: 0
			});
	
			function generateKeystreamWord() {
				// Shortcuts
				var S = this._S;
				var i = this._i;
				var j = this._j;
	
				// Generate keystream word
				var keystreamWord = 0;
				for (var n = 0; n < 4; n++) {
					i = (i + 1) % 256;
					j = (j + S[i]) % 256;
	
					// Swap
					var t = S[i];
					S[i] = S[j];
					S[j] = t;
	
					keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
				}
	
				// Update counters
				this._i = i;
				this._j = j;
	
				return keystreamWord;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	   */
			C.RC4 = StreamCipher._createHelper(RC4);
	
			/**
	   * Modified RC4 stream cipher algorithm.
	   */
			var RC4Drop = C_algo.RC4Drop = RC4.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} drop The number of keystream words to drop. Default 192
	    */
				cfg: RC4.cfg.extend({
					drop: 192
				}),
	
				_doReset: function _doReset() {
					RC4._doReset.call(this);
	
					// Drop
					for (var i = this.cfg.drop; i > 0; i--) {
						generateKeystreamWord.call(this);
					}
				}
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	   */
			C.RC4Drop = StreamCipher._createHelper(RC4Drop);
		})();
	
		return CryptoJS.RC4;
	});

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		/** @preserve
	 (c) 2012 by Cédric Mesnil. All rights reserved.
	 	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	 	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	     - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	 	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_algo = C.algo;
	
			// Constants table
			var _zl = WordArray.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]);
			var _zr = WordArray.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]);
			var _sl = WordArray.create([11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6]);
			var _sr = WordArray.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]);
	
			var _hl = WordArray.create([0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
			var _hr = WordArray.create([0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
	
			/**
	   * RIPEMD160 hash algorithm.
	   */
			var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
				_doReset: function _doReset() {
					this._hash = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
	
					// Swap endian
					for (var i = 0; i < 16; i++) {
						// Shortcuts
						var offset_i = offset + i;
						var M_offset_i = M[offset_i];
	
						// Swap
						M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
					}
					// Shortcut
					var H = this._hash.words;
					var hl = _hl.words;
					var hr = _hr.words;
					var zl = _zl.words;
					var zr = _zr.words;
					var sl = _sl.words;
					var sr = _sr.words;
	
					// Working variables
					var al, bl, cl, dl, el;
					var ar, br, cr, dr, er;
	
					ar = al = H[0];
					br = bl = H[1];
					cr = cl = H[2];
					dr = dl = H[3];
					er = el = H[4];
					// Computation
					var t;
					for (var i = 0; i < 80; i += 1) {
						t = al + M[offset + zl[i]] | 0;
						if (i < 16) {
							t += f1(bl, cl, dl) + hl[0];
						} else if (i < 32) {
							t += f2(bl, cl, dl) + hl[1];
						} else if (i < 48) {
							t += f3(bl, cl, dl) + hl[2];
						} else if (i < 64) {
							t += f4(bl, cl, dl) + hl[3];
						} else {
							// if (i<80) {
							t += f5(bl, cl, dl) + hl[4];
						}
						t = t | 0;
						t = rotl(t, sl[i]);
						t = t + el | 0;
						al = el;
						el = dl;
						dl = rotl(cl, 10);
						cl = bl;
						bl = t;
	
						t = ar + M[offset + zr[i]] | 0;
						if (i < 16) {
							t += f5(br, cr, dr) + hr[0];
						} else if (i < 32) {
							t += f4(br, cr, dr) + hr[1];
						} else if (i < 48) {
							t += f3(br, cr, dr) + hr[2];
						} else if (i < 64) {
							t += f2(br, cr, dr) + hr[3];
						} else {
							// if (i<80) {
							t += f1(br, cr, dr) + hr[4];
						}
						t = t | 0;
						t = rotl(t, sr[i]);
						t = t + er | 0;
						ar = er;
						er = dr;
						dr = rotl(cr, 10);
						cr = br;
						br = t;
					}
					// Intermediate hash value
					t = H[1] + cl + dr | 0;
					H[1] = H[2] + dl + er | 0;
					H[2] = H[3] + el + ar | 0;
					H[3] = H[4] + al + br | 0;
					H[4] = H[0] + bl + cr | 0;
					H[0] = t;
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
	
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
					dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
					data.sigBytes = (dataWords.length + 1) * 4;
	
					// Hash final blocks
					this._process();
	
					// Shortcuts
					var hash = this._hash;
					var H = hash.words;
	
					// Swap endian
					for (var i = 0; i < 5; i++) {
						// Shortcut
						var H_i = H[i];
	
						// Swap
						H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
					}
	
					// Return final computed hash
					return hash;
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
					clone._hash = this._hash.clone();
	
					return clone;
				}
			});
	
			function f1(x, y, z) {
				return x ^ y ^ z;
			}
	
			function f2(x, y, z) {
				return x & y | ~x & z;
			}
	
			function f3(x, y, z) {
				return (x | ~y) ^ z;
			}
	
			function f4(x, y, z) {
				return x & z | y & ~z;
			}
	
			function f5(x, y, z) {
				return x ^ (y | ~z);
			}
	
			function rotl(x, n) {
				return x << n | x >>> 32 - n;
			}
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.RIPEMD160('message');
	   *     var hash = CryptoJS.RIPEMD160(wordArray);
	   */
			C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	   */
			C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
		})(Math);
	
		return CryptoJS.RIPEMD160;
	});

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(549));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(549)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var C_algo = C.algo;
			var SHA256 = C_algo.SHA256;
	
			/**
	   * SHA-224 hash algorithm.
	   */
			var SHA224 = C_algo.SHA224 = SHA256.extend({
				_doReset: function _doReset() {
					this._hash = new WordArray.init([0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4]);
				},
	
				_doFinalize: function _doFinalize() {
					var hash = SHA256._doFinalize.call(this);
	
					hash.sigBytes -= 4;
	
					return hash;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA224('message');
	   *     var hash = CryptoJS.SHA224(wordArray);
	   */
			C.SHA224 = SHA256._createHelper(SHA224);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA224(message, key);
	   */
			C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
		})();
	
		return CryptoJS.SHA224;
	});

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(363));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(363)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function (Math) {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var Hasher = C_lib.Hasher;
			var C_x64 = C.x64;
			var X64Word = C_x64.Word;
			var C_algo = C.algo;
	
			// Constants tables
			var RHO_OFFSETS = [];
			var PI_INDEXES = [];
			var ROUND_CONSTANTS = [];
	
			// Compute Constants
			(function () {
				// Compute rho offset constants
				var x = 1,
				    y = 0;
				for (var t = 0; t < 24; t++) {
					RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
	
					var newX = y % 5;
					var newY = (2 * x + 3 * y) % 5;
					x = newX;
					y = newY;
				}
	
				// Compute pi index constants
				for (var x = 0; x < 5; x++) {
					for (var y = 0; y < 5; y++) {
						PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
					}
				}
	
				// Compute round constants
				var LFSR = 0x01;
				for (var i = 0; i < 24; i++) {
					var roundConstantMsw = 0;
					var roundConstantLsw = 0;
	
					for (var j = 0; j < 7; j++) {
						if (LFSR & 0x01) {
							var bitPosition = (1 << j) - 1;
							if (bitPosition < 32) {
								roundConstantLsw ^= 1 << bitPosition;
							} else /* if (bitPosition >= 32) */{
									roundConstantMsw ^= 1 << bitPosition - 32;
								}
						}
	
						// Compute next LFSR
						if (LFSR & 0x80) {
							// Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
							LFSR = LFSR << 1 ^ 0x71;
						} else {
							LFSR <<= 1;
						}
					}
	
					ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
				}
			})();
	
			// Reusable objects for temporary values
			var T = [];
			(function () {
				for (var i = 0; i < 25; i++) {
					T[i] = X64Word.create();
				}
			})();
	
			/**
	   * SHA-3 hash algorithm.
	   */
			var SHA3 = C_algo.SHA3 = Hasher.extend({
				/**
	    * Configuration options.
	    *
	    * @property {number} outputLength
	    *   The desired number of bits in the output hash.
	    *   Only values permitted are: 224, 256, 384, 512.
	    *   Default: 512
	    */
				cfg: Hasher.cfg.extend({
					outputLength: 512
				}),
	
				_doReset: function _doReset() {
					var state = this._state = [];
					for (var i = 0; i < 25; i++) {
						state[i] = new X64Word.init();
					}
	
					this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
				},
	
				_doProcessBlock: function _doProcessBlock(M, offset) {
					// Shortcuts
					var state = this._state;
					var nBlockSizeLanes = this.blockSize / 2;
	
					// Absorb
					for (var i = 0; i < nBlockSizeLanes; i++) {
						// Shortcuts
						var M2i = M[offset + 2 * i];
						var M2i1 = M[offset + 2 * i + 1];
	
						// Swap endian
						M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
						M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
	
						// Absorb message into state
						var lane = state[i];
						lane.high ^= M2i1;
						lane.low ^= M2i;
					}
	
					// Rounds
					for (var round = 0; round < 24; round++) {
						// Theta
						for (var x = 0; x < 5; x++) {
							// Mix column lanes
							var tMsw = 0,
							    tLsw = 0;
							for (var y = 0; y < 5; y++) {
								var lane = state[x + 5 * y];
								tMsw ^= lane.high;
								tLsw ^= lane.low;
							}
	
							// Temporary values
							var Tx = T[x];
							Tx.high = tMsw;
							Tx.low = tLsw;
						}
						for (var x = 0; x < 5; x++) {
							// Shortcuts
							var Tx4 = T[(x + 4) % 5];
							var Tx1 = T[(x + 1) % 5];
							var Tx1Msw = Tx1.high;
							var Tx1Lsw = Tx1.low;
	
							// Mix surrounding columns
							var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
							var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
							for (var y = 0; y < 5; y++) {
								var lane = state[x + 5 * y];
								lane.high ^= tMsw;
								lane.low ^= tLsw;
							}
						}
	
						// Rho Pi
						for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
							var tMsw;
							var tLsw;
	
							// Shortcuts
							var lane = state[laneIndex];
							var laneMsw = lane.high;
							var laneLsw = lane.low;
							var rhoOffset = RHO_OFFSETS[laneIndex];
	
							// Rotate lanes
							if (rhoOffset < 32) {
								tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
								tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
							} else /* if (rhoOffset >= 32) */{
									tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
									tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
								}
	
							// Transpose lanes
							var TPiLane = T[PI_INDEXES[laneIndex]];
							TPiLane.high = tMsw;
							TPiLane.low = tLsw;
						}
	
						// Rho pi at x = y = 0
						var T0 = T[0];
						var state0 = state[0];
						T0.high = state0.high;
						T0.low = state0.low;
	
						// Chi
						for (var x = 0; x < 5; x++) {
							for (var y = 0; y < 5; y++) {
								// Shortcuts
								var laneIndex = x + 5 * y;
								var lane = state[laneIndex];
								var TLane = T[laneIndex];
								var Tx1Lane = T[(x + 1) % 5 + 5 * y];
								var Tx2Lane = T[(x + 2) % 5 + 5 * y];
	
								// Mix rows
								lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
								lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
							}
						}
	
						// Iota
						var lane = state[0];
						var roundConstant = ROUND_CONSTANTS[round];
						lane.high ^= roundConstant.high;
						lane.low ^= roundConstant.low;
					}
				},
	
				_doFinalize: function _doFinalize() {
					// Shortcuts
					var data = this._data;
					var dataWords = data.words;
					var nBitsTotal = this._nDataBytes * 8;
					var nBitsLeft = data.sigBytes * 8;
					var blockSizeBits = this.blockSize * 32;
	
					// Add padding
					dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
					dataWords[(Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
					data.sigBytes = dataWords.length * 4;
	
					// Hash final blocks
					this._process();
	
					// Shortcuts
					var state = this._state;
					var outputLengthBytes = this.cfg.outputLength / 8;
					var outputLengthLanes = outputLengthBytes / 8;
	
					// Squeeze
					var hashWords = [];
					for (var i = 0; i < outputLengthLanes; i++) {
						// Shortcuts
						var lane = state[i];
						var laneMsw = lane.high;
						var laneLsw = lane.low;
	
						// Swap endian
						laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
						laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
	
						// Squeeze state to retrieve hash
						hashWords.push(laneLsw);
						hashWords.push(laneMsw);
					}
	
					// Return final computed hash
					return new WordArray.init(hashWords, outputLengthBytes);
				},
	
				clone: function clone() {
					var clone = Hasher.clone.call(this);
	
					var state = clone._state = this._state.slice(0);
					for (var i = 0; i < 25; i++) {
						state[i] = state[i].clone();
					}
	
					return clone;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA3('message');
	   *     var hash = CryptoJS.SHA3(wordArray);
	   */
			C.SHA3 = Hasher._createHelper(SHA3);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA3(message, key);
	   */
			C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
		})(Math);
	
		return CryptoJS.SHA3;
	});

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(363), __webpack_require__(913));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(363), __webpack_require__(913)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_x64 = C.x64;
			var X64Word = C_x64.Word;
			var X64WordArray = C_x64.WordArray;
			var C_algo = C.algo;
			var SHA512 = C_algo.SHA512;
	
			/**
	   * SHA-384 hash algorithm.
	   */
			var SHA384 = C_algo.SHA384 = SHA512.extend({
				_doReset: function _doReset() {
					this._hash = new X64WordArray.init([new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507), new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939), new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511), new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)]);
				},
	
				_doFinalize: function _doFinalize() {
					var hash = SHA512._doFinalize.call(this);
	
					hash.sigBytes -= 16;
	
					return hash;
				}
			});
	
			/**
	   * Shortcut function to the hasher's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   *
	   * @return {WordArray} The hash.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hash = CryptoJS.SHA384('message');
	   *     var hash = CryptoJS.SHA384(wordArray);
	   */
			C.SHA384 = SHA512._createHelper(SHA384);
	
			/**
	   * Shortcut function to the HMAC's object interface.
	   *
	   * @param {WordArray|string} message The message to hash.
	   * @param {WordArray|string} key The secret key.
	   *
	   * @return {WordArray} The HMAC.
	   *
	   * @static
	   *
	   * @example
	   *
	   *     var hmac = CryptoJS.HmacSHA384(message, key);
	   */
			C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
		})();
	
		return CryptoJS.SHA384;
	});

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(188), __webpack_require__(189), __webpack_require__(159), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		(function () {
			// Shortcuts
			var C = CryptoJS;
			var C_lib = C.lib;
			var WordArray = C_lib.WordArray;
			var BlockCipher = C_lib.BlockCipher;
			var C_algo = C.algo;
	
			// Permuted Choice 1 constants
			var PC1 = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4];
	
			// Permuted Choice 2 constants
			var PC2 = [14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26, 8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45, 33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32];
	
			// Cumulative bit shift constants
			var BIT_SHIFTS = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
	
			// SBOXes and round permutation constants
			var SBOX_P = [{
				0x0: 0x808200,
				0x10000000: 0x8000,
				0x20000000: 0x808002,
				0x30000000: 0x2,
				0x40000000: 0x200,
				0x50000000: 0x808202,
				0x60000000: 0x800202,
				0x70000000: 0x800000,
				0x80000000: 0x202,
				0x90000000: 0x800200,
				0xa0000000: 0x8200,
				0xb0000000: 0x808000,
				0xc0000000: 0x8002,
				0xd0000000: 0x800002,
				0xe0000000: 0x0,
				0xf0000000: 0x8202,
				0x8000000: 0x0,
				0x18000000: 0x808202,
				0x28000000: 0x8202,
				0x38000000: 0x8000,
				0x48000000: 0x808200,
				0x58000000: 0x200,
				0x68000000: 0x808002,
				0x78000000: 0x2,
				0x88000000: 0x800200,
				0x98000000: 0x8200,
				0xa8000000: 0x808000,
				0xb8000000: 0x800202,
				0xc8000000: 0x800002,
				0xd8000000: 0x8002,
				0xe8000000: 0x202,
				0xf8000000: 0x800000,
				0x1: 0x8000,
				0x10000001: 0x2,
				0x20000001: 0x808200,
				0x30000001: 0x800000,
				0x40000001: 0x808002,
				0x50000001: 0x8200,
				0x60000001: 0x200,
				0x70000001: 0x800202,
				0x80000001: 0x808202,
				0x90000001: 0x808000,
				0xa0000001: 0x800002,
				0xb0000001: 0x8202,
				0xc0000001: 0x202,
				0xd0000001: 0x800200,
				0xe0000001: 0x8002,
				0xf0000001: 0x0,
				0x8000001: 0x808202,
				0x18000001: 0x808000,
				0x28000001: 0x800000,
				0x38000001: 0x200,
				0x48000001: 0x8000,
				0x58000001: 0x800002,
				0x68000001: 0x2,
				0x78000001: 0x8202,
				0x88000001: 0x8002,
				0x98000001: 0x800202,
				0xa8000001: 0x202,
				0xb8000001: 0x808200,
				0xc8000001: 0x800200,
				0xd8000001: 0x0,
				0xe8000001: 0x8200,
				0xf8000001: 0x808002
			}, {
				0x0: 0x40084010,
				0x1000000: 0x4000,
				0x2000000: 0x80000,
				0x3000000: 0x40080010,
				0x4000000: 0x40000010,
				0x5000000: 0x40084000,
				0x6000000: 0x40004000,
				0x7000000: 0x10,
				0x8000000: 0x84000,
				0x9000000: 0x40004010,
				0xa000000: 0x40000000,
				0xb000000: 0x84010,
				0xc000000: 0x80010,
				0xd000000: 0x0,
				0xe000000: 0x4010,
				0xf000000: 0x40080000,
				0x800000: 0x40004000,
				0x1800000: 0x84010,
				0x2800000: 0x10,
				0x3800000: 0x40004010,
				0x4800000: 0x40084010,
				0x5800000: 0x40000000,
				0x6800000: 0x80000,
				0x7800000: 0x40080010,
				0x8800000: 0x80010,
				0x9800000: 0x0,
				0xa800000: 0x4000,
				0xb800000: 0x40080000,
				0xc800000: 0x40000010,
				0xd800000: 0x84000,
				0xe800000: 0x40084000,
				0xf800000: 0x4010,
				0x10000000: 0x0,
				0x11000000: 0x40080010,
				0x12000000: 0x40004010,
				0x13000000: 0x40084000,
				0x14000000: 0x40080000,
				0x15000000: 0x10,
				0x16000000: 0x84010,
				0x17000000: 0x4000,
				0x18000000: 0x4010,
				0x19000000: 0x80000,
				0x1a000000: 0x80010,
				0x1b000000: 0x40000010,
				0x1c000000: 0x84000,
				0x1d000000: 0x40004000,
				0x1e000000: 0x40000000,
				0x1f000000: 0x40084010,
				0x10800000: 0x84010,
				0x11800000: 0x80000,
				0x12800000: 0x40080000,
				0x13800000: 0x4000,
				0x14800000: 0x40004000,
				0x15800000: 0x40084010,
				0x16800000: 0x10,
				0x17800000: 0x40000000,
				0x18800000: 0x40084000,
				0x19800000: 0x40000010,
				0x1a800000: 0x40004010,
				0x1b800000: 0x80010,
				0x1c800000: 0x0,
				0x1d800000: 0x4010,
				0x1e800000: 0x40080010,
				0x1f800000: 0x84000
			}, {
				0x0: 0x104,
				0x100000: 0x0,
				0x200000: 0x4000100,
				0x300000: 0x10104,
				0x400000: 0x10004,
				0x500000: 0x4000004,
				0x600000: 0x4010104,
				0x700000: 0x4010000,
				0x800000: 0x4000000,
				0x900000: 0x4010100,
				0xa00000: 0x10100,
				0xb00000: 0x4010004,
				0xc00000: 0x4000104,
				0xd00000: 0x10000,
				0xe00000: 0x4,
				0xf00000: 0x100,
				0x80000: 0x4010100,
				0x180000: 0x4010004,
				0x280000: 0x0,
				0x380000: 0x4000100,
				0x480000: 0x4000004,
				0x580000: 0x10000,
				0x680000: 0x10004,
				0x780000: 0x104,
				0x880000: 0x4,
				0x980000: 0x100,
				0xa80000: 0x4010000,
				0xb80000: 0x10104,
				0xc80000: 0x10100,
				0xd80000: 0x4000104,
				0xe80000: 0x4010104,
				0xf80000: 0x4000000,
				0x1000000: 0x4010100,
				0x1100000: 0x10004,
				0x1200000: 0x10000,
				0x1300000: 0x4000100,
				0x1400000: 0x100,
				0x1500000: 0x4010104,
				0x1600000: 0x4000004,
				0x1700000: 0x0,
				0x1800000: 0x4000104,
				0x1900000: 0x4000000,
				0x1a00000: 0x4,
				0x1b00000: 0x10100,
				0x1c00000: 0x4010000,
				0x1d00000: 0x104,
				0x1e00000: 0x10104,
				0x1f00000: 0x4010004,
				0x1080000: 0x4000000,
				0x1180000: 0x104,
				0x1280000: 0x4010100,
				0x1380000: 0x0,
				0x1480000: 0x10004,
				0x1580000: 0x4000100,
				0x1680000: 0x100,
				0x1780000: 0x4010004,
				0x1880000: 0x10000,
				0x1980000: 0x4010104,
				0x1a80000: 0x10104,
				0x1b80000: 0x4000004,
				0x1c80000: 0x4000104,
				0x1d80000: 0x4010000,
				0x1e80000: 0x4,
				0x1f80000: 0x10100
			}, {
				0x0: 0x80401000,
				0x10000: 0x80001040,
				0x20000: 0x401040,
				0x30000: 0x80400000,
				0x40000: 0x0,
				0x50000: 0x401000,
				0x60000: 0x80000040,
				0x70000: 0x400040,
				0x80000: 0x80000000,
				0x90000: 0x400000,
				0xa0000: 0x40,
				0xb0000: 0x80001000,
				0xc0000: 0x80400040,
				0xd0000: 0x1040,
				0xe0000: 0x1000,
				0xf0000: 0x80401040,
				0x8000: 0x80001040,
				0x18000: 0x40,
				0x28000: 0x80400040,
				0x38000: 0x80001000,
				0x48000: 0x401000,
				0x58000: 0x80401040,
				0x68000: 0x0,
				0x78000: 0x80400000,
				0x88000: 0x1000,
				0x98000: 0x80401000,
				0xa8000: 0x400000,
				0xb8000: 0x1040,
				0xc8000: 0x80000000,
				0xd8000: 0x400040,
				0xe8000: 0x401040,
				0xf8000: 0x80000040,
				0x100000: 0x400040,
				0x110000: 0x401000,
				0x120000: 0x80000040,
				0x130000: 0x0,
				0x140000: 0x1040,
				0x150000: 0x80400040,
				0x160000: 0x80401000,
				0x170000: 0x80001040,
				0x180000: 0x80401040,
				0x190000: 0x80000000,
				0x1a0000: 0x80400000,
				0x1b0000: 0x401040,
				0x1c0000: 0x80001000,
				0x1d0000: 0x400000,
				0x1e0000: 0x40,
				0x1f0000: 0x1000,
				0x108000: 0x80400000,
				0x118000: 0x80401040,
				0x128000: 0x0,
				0x138000: 0x401000,
				0x148000: 0x400040,
				0x158000: 0x80000000,
				0x168000: 0x80001040,
				0x178000: 0x40,
				0x188000: 0x80000040,
				0x198000: 0x1000,
				0x1a8000: 0x80001000,
				0x1b8000: 0x80400040,
				0x1c8000: 0x1040,
				0x1d8000: 0x80401000,
				0x1e8000: 0x400000,
				0x1f8000: 0x401040
			}, {
				0x0: 0x80,
				0x1000: 0x1040000,
				0x2000: 0x40000,
				0x3000: 0x20000000,
				0x4000: 0x20040080,
				0x5000: 0x1000080,
				0x6000: 0x21000080,
				0x7000: 0x40080,
				0x8000: 0x1000000,
				0x9000: 0x20040000,
				0xa000: 0x20000080,
				0xb000: 0x21040080,
				0xc000: 0x21040000,
				0xd000: 0x0,
				0xe000: 0x1040080,
				0xf000: 0x21000000,
				0x800: 0x1040080,
				0x1800: 0x21000080,
				0x2800: 0x80,
				0x3800: 0x1040000,
				0x4800: 0x40000,
				0x5800: 0x20040080,
				0x6800: 0x21040000,
				0x7800: 0x20000000,
				0x8800: 0x20040000,
				0x9800: 0x0,
				0xa800: 0x21040080,
				0xb800: 0x1000080,
				0xc800: 0x20000080,
				0xd800: 0x21000000,
				0xe800: 0x1000000,
				0xf800: 0x40080,
				0x10000: 0x40000,
				0x11000: 0x80,
				0x12000: 0x20000000,
				0x13000: 0x21000080,
				0x14000: 0x1000080,
				0x15000: 0x21040000,
				0x16000: 0x20040080,
				0x17000: 0x1000000,
				0x18000: 0x21040080,
				0x19000: 0x21000000,
				0x1a000: 0x1040000,
				0x1b000: 0x20040000,
				0x1c000: 0x40080,
				0x1d000: 0x20000080,
				0x1e000: 0x0,
				0x1f000: 0x1040080,
				0x10800: 0x21000080,
				0x11800: 0x1000000,
				0x12800: 0x1040000,
				0x13800: 0x20040080,
				0x14800: 0x20000000,
				0x15800: 0x1040080,
				0x16800: 0x80,
				0x17800: 0x21040000,
				0x18800: 0x40080,
				0x19800: 0x21040080,
				0x1a800: 0x0,
				0x1b800: 0x21000000,
				0x1c800: 0x1000080,
				0x1d800: 0x40000,
				0x1e800: 0x20040000,
				0x1f800: 0x20000080
			}, {
				0x0: 0x10000008,
				0x100: 0x2000,
				0x200: 0x10200000,
				0x300: 0x10202008,
				0x400: 0x10002000,
				0x500: 0x200000,
				0x600: 0x200008,
				0x700: 0x10000000,
				0x800: 0x0,
				0x900: 0x10002008,
				0xa00: 0x202000,
				0xb00: 0x8,
				0xc00: 0x10200008,
				0xd00: 0x202008,
				0xe00: 0x2008,
				0xf00: 0x10202000,
				0x80: 0x10200000,
				0x180: 0x10202008,
				0x280: 0x8,
				0x380: 0x200000,
				0x480: 0x202008,
				0x580: 0x10000008,
				0x680: 0x10002000,
				0x780: 0x2008,
				0x880: 0x200008,
				0x980: 0x2000,
				0xa80: 0x10002008,
				0xb80: 0x10200008,
				0xc80: 0x0,
				0xd80: 0x10202000,
				0xe80: 0x202000,
				0xf80: 0x10000000,
				0x1000: 0x10002000,
				0x1100: 0x10200008,
				0x1200: 0x10202008,
				0x1300: 0x2008,
				0x1400: 0x200000,
				0x1500: 0x10000000,
				0x1600: 0x10000008,
				0x1700: 0x202000,
				0x1800: 0x202008,
				0x1900: 0x0,
				0x1a00: 0x8,
				0x1b00: 0x10200000,
				0x1c00: 0x2000,
				0x1d00: 0x10002008,
				0x1e00: 0x10202000,
				0x1f00: 0x200008,
				0x1080: 0x8,
				0x1180: 0x202000,
				0x1280: 0x200000,
				0x1380: 0x10000008,
				0x1480: 0x10002000,
				0x1580: 0x2008,
				0x1680: 0x10202008,
				0x1780: 0x10200000,
				0x1880: 0x10202000,
				0x1980: 0x10200008,
				0x1a80: 0x2000,
				0x1b80: 0x202008,
				0x1c80: 0x200008,
				0x1d80: 0x0,
				0x1e80: 0x10000000,
				0x1f80: 0x10002008
			}, {
				0x0: 0x100000,
				0x10: 0x2000401,
				0x20: 0x400,
				0x30: 0x100401,
				0x40: 0x2100401,
				0x50: 0x0,
				0x60: 0x1,
				0x70: 0x2100001,
				0x80: 0x2000400,
				0x90: 0x100001,
				0xa0: 0x2000001,
				0xb0: 0x2100400,
				0xc0: 0x2100000,
				0xd0: 0x401,
				0xe0: 0x100400,
				0xf0: 0x2000000,
				0x8: 0x2100001,
				0x18: 0x0,
				0x28: 0x2000401,
				0x38: 0x2100400,
				0x48: 0x100000,
				0x58: 0x2000001,
				0x68: 0x2000000,
				0x78: 0x401,
				0x88: 0x100401,
				0x98: 0x2000400,
				0xa8: 0x2100000,
				0xb8: 0x100001,
				0xc8: 0x400,
				0xd8: 0x2100401,
				0xe8: 0x1,
				0xf8: 0x100400,
				0x100: 0x2000000,
				0x110: 0x100000,
				0x120: 0x2000401,
				0x130: 0x2100001,
				0x140: 0x100001,
				0x150: 0x2000400,
				0x160: 0x2100400,
				0x170: 0x100401,
				0x180: 0x401,
				0x190: 0x2100401,
				0x1a0: 0x100400,
				0x1b0: 0x1,
				0x1c0: 0x0,
				0x1d0: 0x2100000,
				0x1e0: 0x2000001,
				0x1f0: 0x400,
				0x108: 0x100400,
				0x118: 0x2000401,
				0x128: 0x2100001,
				0x138: 0x1,
				0x148: 0x2000000,
				0x158: 0x100000,
				0x168: 0x401,
				0x178: 0x2100400,
				0x188: 0x2000001,
				0x198: 0x2100000,
				0x1a8: 0x0,
				0x1b8: 0x2100401,
				0x1c8: 0x100401,
				0x1d8: 0x400,
				0x1e8: 0x2000400,
				0x1f8: 0x100001
			}, {
				0x0: 0x8000820,
				0x1: 0x20000,
				0x2: 0x8000000,
				0x3: 0x20,
				0x4: 0x20020,
				0x5: 0x8020820,
				0x6: 0x8020800,
				0x7: 0x800,
				0x8: 0x8020000,
				0x9: 0x8000800,
				0xa: 0x20800,
				0xb: 0x8020020,
				0xc: 0x820,
				0xd: 0x0,
				0xe: 0x8000020,
				0xf: 0x20820,
				0x80000000: 0x800,
				0x80000001: 0x8020820,
				0x80000002: 0x8000820,
				0x80000003: 0x8000000,
				0x80000004: 0x8020000,
				0x80000005: 0x20800,
				0x80000006: 0x20820,
				0x80000007: 0x20,
				0x80000008: 0x8000020,
				0x80000009: 0x820,
				0x8000000a: 0x20020,
				0x8000000b: 0x8020800,
				0x8000000c: 0x0,
				0x8000000d: 0x8020020,
				0x8000000e: 0x8000800,
				0x8000000f: 0x20000,
				0x10: 0x20820,
				0x11: 0x8020800,
				0x12: 0x20,
				0x13: 0x800,
				0x14: 0x8000800,
				0x15: 0x8000020,
				0x16: 0x8020020,
				0x17: 0x20000,
				0x18: 0x0,
				0x19: 0x20020,
				0x1a: 0x8020000,
				0x1b: 0x8000820,
				0x1c: 0x8020820,
				0x1d: 0x20800,
				0x1e: 0x820,
				0x1f: 0x8000000,
				0x80000010: 0x20000,
				0x80000011: 0x800,
				0x80000012: 0x8020020,
				0x80000013: 0x20820,
				0x80000014: 0x20,
				0x80000015: 0x8020000,
				0x80000016: 0x8000000,
				0x80000017: 0x8000820,
				0x80000018: 0x8020820,
				0x80000019: 0x8000020,
				0x8000001a: 0x8000800,
				0x8000001b: 0x0,
				0x8000001c: 0x20800,
				0x8000001d: 0x820,
				0x8000001e: 0x20020,
				0x8000001f: 0x8020800
			}];
	
			// Masks that select the SBOX input
			var SBOX_MASK = [0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000, 0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f];
	
			/**
	   * DES block cipher algorithm.
	   */
			var DES = C_algo.DES = BlockCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var key = this._key;
					var keyWords = key.words;
	
					// Select 56 bits according to PC1
					var keyBits = [];
					for (var i = 0; i < 56; i++) {
						var keyBitPos = PC1[i] - 1;
						keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
					}
	
					// Assemble 16 subkeys
					var subKeys = this._subKeys = [];
					for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
						// Create subkey
						var subKey = subKeys[nSubKey] = [];
	
						// Shortcut
						var bitShift = BIT_SHIFTS[nSubKey];
	
						// Select 48 bits according to PC2
						for (var i = 0; i < 24; i++) {
							// Select from the left 28 key bits
							subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
	
							// Select from the right 28 key bits
							subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
						}
	
						// Since each subkey is applied to an expanded 32-bit input,
						// the subkey can be broken into 8 values scaled to 32-bits,
						// which allows the key to be used without expansion
						subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
						for (var i = 1; i < 7; i++) {
							subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
						}
						subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
					}
	
					// Compute inverse subkeys
					var invSubKeys = this._invSubKeys = [];
					for (var i = 0; i < 16; i++) {
						invSubKeys[i] = subKeys[15 - i];
					}
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					this._doCryptBlock(M, offset, this._subKeys);
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					this._doCryptBlock(M, offset, this._invSubKeys);
				},
	
				_doCryptBlock: function _doCryptBlock(M, offset, subKeys) {
					// Get input
					this._lBlock = M[offset];
					this._rBlock = M[offset + 1];
	
					// Initial permutation
					exchangeLR.call(this, 4, 0x0f0f0f0f);
					exchangeLR.call(this, 16, 0x0000ffff);
					exchangeRL.call(this, 2, 0x33333333);
					exchangeRL.call(this, 8, 0x00ff00ff);
					exchangeLR.call(this, 1, 0x55555555);
	
					// Rounds
					for (var round = 0; round < 16; round++) {
						// Shortcuts
						var subKey = subKeys[round];
						var lBlock = this._lBlock;
						var rBlock = this._rBlock;
	
						// Feistel function
						var f = 0;
						for (var i = 0; i < 8; i++) {
							f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
						}
						this._lBlock = rBlock;
						this._rBlock = lBlock ^ f;
					}
	
					// Undo swap from last round
					var t = this._lBlock;
					this._lBlock = this._rBlock;
					this._rBlock = t;
	
					// Final permutation
					exchangeLR.call(this, 1, 0x55555555);
					exchangeRL.call(this, 8, 0x00ff00ff);
					exchangeRL.call(this, 2, 0x33333333);
					exchangeLR.call(this, 16, 0x0000ffff);
					exchangeLR.call(this, 4, 0x0f0f0f0f);
	
					// Set output
					M[offset] = this._lBlock;
					M[offset + 1] = this._rBlock;
				},
	
				keySize: 64 / 32,
	
				ivSize: 64 / 32,
	
				blockSize: 64 / 32
			});
	
			// Swap bits across the left and right words
			function exchangeLR(offset, mask) {
				var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
				this._rBlock ^= t;
				this._lBlock ^= t << offset;
			}
	
			function exchangeRL(offset, mask) {
				var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
				this._lBlock ^= t;
				this._rBlock ^= t << offset;
			}
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	   */
			C.DES = BlockCipher._createHelper(DES);
	
			/**
	   * Triple-DES block cipher algorithm.
	   */
			var TripleDES = C_algo.TripleDES = BlockCipher.extend({
				_doReset: function _doReset() {
					// Shortcuts
					var key = this._key;
					var keyWords = key.words;
					// Make sure the key length is valid (64, 128 or >= 192 bit)
					if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
						throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
					}
	
					// Extend the key according to the keying options defined in 3DES standard
					var key1 = keyWords.slice(0, 2);
					var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
					var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
	
					// Create DES instances
					this._des1 = DES.createEncryptor(WordArray.create(key1));
					this._des2 = DES.createEncryptor(WordArray.create(key2));
					this._des3 = DES.createEncryptor(WordArray.create(key3));
				},
	
				encryptBlock: function encryptBlock(M, offset) {
					this._des1.encryptBlock(M, offset);
					this._des2.decryptBlock(M, offset);
					this._des3.encryptBlock(M, offset);
				},
	
				decryptBlock: function decryptBlock(M, offset) {
					this._des3.decryptBlock(M, offset);
					this._des2.encryptBlock(M, offset);
					this._des1.decryptBlock(M, offset);
				},
	
				keySize: 192 / 32,
	
				ivSize: 64 / 32,
	
				blockSize: 64 / 32
			});
	
			/**
	   * Shortcut functions to the cipher's object interface.
	   *
	   * @example
	   *
	   *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	   *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	   */
			C.TripleDES = BlockCipher._createHelper(TripleDES);
		})();
	
		return CryptoJS.TripleDES;
	});

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4343), __esModule: true };

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4354), __esModule: true };

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function listen(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function () {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function emit() {
	    currentListeners = nextListeners;
	    var listeners = currentListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i].apply(listeners, arguments);
	    }
	  }
	
	  return {
	    listen: listen,
	    emit: emit
	  };
	};

/***/ }),
/* 1978 */
[6495, 30],
/* 1979 */
[6496, 30],
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 1985 */
[6497, 30],
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	            '_'
	        ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split(
	            '_'
	        ),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 1988 */
[6498, 30],
/* 1989 */
[6499, 30],
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	            '_'
	        ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	            '_'
	        ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                '_'
	            ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	            '_'
	        ),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	            '_'
	        ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 1999 */
[6500, 30],
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 2003 */
[6501, 30],
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	            '_'
	        ),
	        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	            '_'
	        ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 2005 */
[6502, 30],
/* 2006 */
[6503, 30],
/* 2007 */
[6504, 30],
/* 2008 */
[6505, 30],
/* 2009 */
[6506, 30],
/* 2010 */
[6507, 30],
/* 2011 */
[6508, 30],
/* 2012 */
[6509, 30],
/* 2013 */
[6510, 30],
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	            '_'
	        ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split(
	            '_'
	        ),
	        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	            '_'
	        ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	            '_'
	        ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        weekdays: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysShort: 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	            ' '
	        ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	            '_'
	        ),
	        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	            '_'
	        ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 2022 */
[6511, 30],
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	            '_'
	        ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split(
	            '_'
	        );
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 2028 */
[6512, 30],
/* 2029 */
[6513, 30],
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                '_'
	            ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                '_'
	            ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split(
	            '_'
	        ),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var hi = moment.defineLocale('hi', {
	        months: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(
	        ' '
	    );
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	            '_'
	        ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 2039 */
[6514, 30],
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	            '_'
	        ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 2041 */
[6515, 30],
/* 2042 */
[6516, 30],
/* 2043 */
[6517, 30],
/* 2044 */
[6518, 30],
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                '_'
	            ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (
	                    $0,
	                    $1,
	                    $2
	                ) {
	                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                });
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 2046 */
[6519, 30],
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 2049 */
[6520, 30],
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split(
	            '_'
	        ),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 2051 */
[6521, 30],
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	            '_'
	        ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                '_'
	            ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	            '_'
	        ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 2058 */
[6522, 30],
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	            '_'
	        ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 2062 */
[6523, 30],
/* 2063 */
[6524, 30],
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 2065 */
[6525, 30],
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                '_'
	            ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	            '_'
	        ),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	            '_'
	        ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                '_'
	            ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	        },
	        weekdays: {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                '_'
	            ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 2078 */
[6526, 30],
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split(
	            '_'
	        ),
	        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	            '_'
	        ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	            '_'
	        ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	            '_'
	        ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 2083 */
[6527, 30],
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'дан',
	            dd: translator.translate,
	            M: 'месец',
	            MM: translator.translate,
	            y: 'годину',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 2087 */
[6528, 30],
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	            '_'
	        ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	            '_'
	        ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 2091 */
[6529, 30],
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 2094 */
[6530, 30],
/* 2095 */
[6531, 30],
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 2098 */
[6532, 30],
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                    '_'
	                ),
	                accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                    '_'
	                ),
	                genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                    '_'
	                ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                '_'
	            ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 2103 */
[6533, 30],
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	            '_'
	        ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 2105 */
[6534, 30],
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(30)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	            '_'
	        ),
	        monthsParseExact: true,
	        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	            '_'
	        ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 2108 */
[6535, 30],
/* 2109 */
[6536, 30],
/* 2110 */
[6537, 30],
/* 2111 */
[6538, 30],
/* 2112 */
[6539, 30],
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

	// Get the chart variable
	var Chart = __webpack_require__(702);
	Chart = typeof(Chart) === 'function' ? Chart : window.Chart;
	
	// Configure plugin namespace
	Chart.Annotation = Chart.Annotation || {};
	
	Chart.Annotation.drawTimeOptions = {
		afterDraw: 'afterDraw',
		afterDatasetsDraw: 'afterDatasetsDraw',
		beforeDatasetsDraw: 'beforeDatasetsDraw'
	};
	
	Chart.Annotation.defaults = {
		drawTime: 'afterDatasetsDraw',
		dblClickSpeed: 350, // ms
		events: [],
		annotations: []
	};
	
	Chart.Annotation.labelDefaults = {
		backgroundColor: 'rgba(0,0,0,0.8)',
		fontFamily: Chart.defaults.global.defaultFontFamily,
		fontSize: Chart.defaults.global.defaultFontSize,
		fontStyle: 'bold',
		fontColor: '#fff',
		xPadding: 6,
		yPadding: 6,
		cornerRadius: 6,
		position: 'center',
		xAdjust: 0,
		yAdjust: 0,
		enabled: false,
		content: null
	};
	
	Chart.Annotation.Element = __webpack_require__(4311)(Chart);
	
	Chart.Annotation.types = {
		line: __webpack_require__(4314)(Chart),
		box: __webpack_require__(4313)(Chart)
	};
	
	var annotationPlugin = __webpack_require__(4310)(Chart);
	
	module.exports = annotationPlugin;
	Chart.pluginService.register(annotationPlugin);


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = lazyInitialize;
	
	var _privateUtils = __webpack_require__(161);
	
	var defineProperty = Object.defineProperty;
	
	function handleDescriptor(target, key, descriptor) {
	  var configurable = descriptor.configurable;
	  var enumerable = descriptor.enumerable;
	  var initializer = descriptor.initializer;
	  var value = descriptor.value;
	
	  return {
	    configurable: configurable,
	    enumerable: enumerable,
	
	    get: function get() {
	      // This happens if someone accesses the
	      // property directly on the prototype
	      if (this === target) {
	        return;
	      }
	
	      var ret = initializer ? initializer.call(this) : value;
	
	      defineProperty(this, key, {
	        configurable: configurable,
	        enumerable: enumerable,
	        writable: true,
	        value: ret
	      });
	
	      return ret;
	    },
	
	    set: (0, _privateUtils.createDefaultSetter)(key)
	  };
	}
	
	function lazyInitialize() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 2115 */
[6547, 241, 918, 1409, 315, 1398, 705, 1403, 2124, 2134, 268, 1404, 1415],
/* 2116 */
[6548, 916, 4358],
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(169);
	var $export = __webpack_require__(110);
	var meta = __webpack_require__(1404);
	var fails = __webpack_require__(438);
	var hide = __webpack_require__(365);
	var redefineAll = __webpack_require__(1409);
	var forOf = __webpack_require__(705);
	var anInstance = __webpack_require__(1398);
	var isObject = __webpack_require__(222);
	var setToStringTag = __webpack_require__(708);
	var dP = __webpack_require__(241).f;
	var each = __webpack_require__(4360)(0);
	var DESCRIPTORS = __webpack_require__(268);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 2118 */
[6556, 169],
/* 2119 */
[6557, 268, 438, 1400],
/* 2120 */
[6559, 552, 170],
/* 2121 */
[6560, 704],
/* 2122 */
[6562, 267],
/* 2123 */
[6565, 170],
/* 2124 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 2125 */
[6575, 2127, 1401],
/* 2126 */
[6576, 439, 554, 1410],
/* 2127 */
[6577, 439, 366, 4359, 1410],
/* 2128 */
[6580, 553, 366, 706],
/* 2129 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 2130 */
[6581, 267, 222, 1405],
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(365);


/***/ }),
/* 2132 */
[6582, 110, 703, 315, 705],
/* 2133 */
[6583, 110],
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(169);
	var core = __webpack_require__(100);
	var dP = __webpack_require__(241);
	var DESCRIPTORS = __webpack_require__(268);
	var SPECIES = __webpack_require__(170)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 2135 */
[6588, 267, 703, 170],
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(242);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(146);
	var toAbsoluteIndex = __webpack_require__(450);
	var toLength = __webpack_require__(126);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 2138 */
[6541, 442],
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(171);
	var toObject = __webpack_require__(146);
	var IObject = __webpack_require__(710);
	var toLength = __webpack_require__(126);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(171);
	var isObject = __webpack_require__(99);
	var invoke = __webpack_require__(2146);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 2141 */
[6547, 125, 444, 448, 243, 441, 442, 1429, 2149, 449, 124, 368, 559],
/* 2142 */
[6548, 709, 2138],
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(448);
	var getWeak = __webpack_require__(368).getWeak;
	var anObject = __webpack_require__(85);
	var isObject = __webpack_require__(99);
	var anInstance = __webpack_require__(441);
	var forOf = __webpack_require__(442);
	var createArrayMethod = __webpack_require__(269);
	var $has = __webpack_require__(204);
	var validate = __webpack_require__(559);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(926);
	var isObject = __webpack_require__(99);
	var toLength = __webpack_require__(126);
	var ctx = __webpack_require__(243);
	var IS_CONCAT_SPREADABLE = __webpack_require__(106)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 2145 */
[6557, 124, 95, 1422],
/* 2146 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 2147 */
[6561, 99],
/* 2148 */
[6562, 85],
/* 2149 */
2124,
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(1431);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 2151 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 2152 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 2153 */
[6569, 446, 930, 711, 146, 710, 95],
/* 2154 */
[6572, 125, 85, 446, 124],
/* 2155 */
[6574, 225, 445],
/* 2156 */
[6577, 204, 225, 922, 1435],
/* 2157 */
[6580, 446, 225, 711],
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(445);
	var gOPS = __webpack_require__(930);
	var anObject = __webpack_require__(85);
	var Reflect = __webpack_require__(89).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(89).parseFloat;
	var $trim = __webpack_require__(558).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(1439) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(89).parseInt;
	var $trim = __webpack_require__(558).trim;
	var ws = __webpack_require__(1439);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 2161 */
2129,
/* 2162 */
[6581, 85, 99, 1433],
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(126);
	var repeat = __webpack_require__(1438);
	var defined = __webpack_require__(271);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(273);
	var toLength = __webpack_require__(126);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 2165 */
[6598, 106],
/* 2166 */
[6603, 2141, 559, 923],
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(124) && /./g.flags != 'g') __webpack_require__(125).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(925)
	});


/***/ }),
/* 2168 */
[6617, 2141, 559, 923],
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(269)(0);
	var redefine = __webpack_require__(206);
	var meta = __webpack_require__(368);
	var assign = __webpack_require__(2153);
	var weak = __webpack_require__(2143);
	var isObject = __webpack_require__(99);
	var fails = __webpack_require__(95);
	var validate = __webpack_require__(559);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(923)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	
	/**
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * var result = compareAsc(
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * )
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var timeLeft = dateLeft.getTime()
	  var dateRight = parse(dirtyDateRight)
	  var timeRight = dateRight.getTime()
	
	  if (timeLeft < timeRight) {
	    return -1
	  } else if (timeLeft > timeRight) {
	    return 1
	  } else {
	    return 0
	  }
	}
	
	module.exports = compareAsc


/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

	var startOfDay = __webpack_require__(2178)
	
	var MILLISECONDS_IN_MINUTE = 60000
	var MILLISECONDS_IN_DAY = 86400000
	
	/**
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 */
	function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
	  var startOfDayLeft = startOfDay(dirtyDateLeft)
	  var startOfDayRight = startOfDay(dirtyDateRight)
	
	  var timestampLeft = startOfDayLeft.getTime() -
	    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	  var timestampRight = startOfDayRight.getTime() -
	    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
	}
	
	module.exports = differenceInCalendarDays


/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	var differenceInCalendarDays = __webpack_require__(2171)
	var compareAsc = __webpack_require__(2170)
	
	/**
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full days between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 */
	function differenceInDays (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
	  dateLeft.setDate(dateLeft.getDate() - sign * difference)
	
	  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastDayNotFull)
	}
	
	module.exports = differenceInDays


/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * var result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	  return dateLeft.getTime() - dateRight.getTime()
	}
	
	module.exports = differenceInMilliseconds


/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	var differenceInCalendarYears = __webpack_require__(4700)
	var compareAsc = __webpack_require__(2170)
	
	/**
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 1
	 */
	function differenceInYears (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  var sign = compareAsc(dateLeft, dateRight)
	  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
	  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)
	
	  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
	  return sign * (difference - isLastYearNotFull)
	}
	
	module.exports = differenceInYears


/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	var startOfISOWeek = __webpack_require__(1467)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * var result = getISOYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var year = date.getFullYear()
	
	  var fourthOfJanuaryOfNextYear = new Date(0)
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
	  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)
	
	  var fourthOfJanuaryOfThisYear = new Date(0)
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
	  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year
	  } else {
	    return year - 1
	  }
	}
	
	module.exports = getISOYear


/***/ }),
/* 2176 */
/***/ (function(module, exports) {

	/**
	 * @category Common Helpers
	 * @summary Is the given argument an instance of Date?
	 *
	 * @description
	 * Is the given argument an instance of Date?
	 *
	 * @param {*} argument - the argument to check
	 * @returns {Boolean} the given argument is an instance of Date
	 *
	 * @example
	 * // Is 'mayonnaise' a Date?
	 * var result = isDate('mayonnaise')
	 * //=> false
	 */
	function isDate (argument) {
	  return argument instanceof Date
	}
	
	module.exports = isDate


/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	
	/**
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to check
	 * @param {Date|String|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * var result = isSameYear(
	 *   new Date(2014, 8, 2),
	 *   new Date(2014, 8, 25)
	 * )
	 * //=> true
	 */
	function isSameYear (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	  return dateLeft.getFullYear() === dateRight.getFullYear()
	}
	
	module.exports = isSameYear


/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	
	/**
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a day
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay (dirtyDate) {
	  var date = parse(dirtyDate)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfDay


/***/ }),
/* 2179 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	
	function assign(target, dirtyObject) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	
	  dirtyObject = dirtyObject || {};
	
	  for (var property in dirtyObject) {
	    if (dirtyObject.hasOwnProperty(property)) {
	      target[property] = dirtyObject[property];
	    }
	  }
	
	  return target;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	
	var _index = _interopRequireDefault(__webpack_require__(2179));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneObject(dirtyObject) {
	  return (0, _index.default)({}, dirtyObject);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2181 */
[6634, 560],
/* 2182 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	}
	
	function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	}
	
	function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/);
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	
	  var dateTimeFormat;
	
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	}
	
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 2183 */
[6636, 31, 938, 4722, 20],
/* 2184 */
[6637, 31, 938, 20],
/* 2185 */
[6638, 31, 939, 4723, 20],
/* 2186 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	
	function throwProtectedError(token, format, input) {
	  if (token === 'YYYY') {
	    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'YY') {
	    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'D') {
	    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  } else if (token === 'DD') {
	    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
	  }
	}

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(944));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(53));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	var _index5 = _interopRequireDefault(__webpack_require__(1476));
	
	var _index6 = _interopRequireDefault(__webpack_require__(2222));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addBusinessDays
	 * @category Day Helpers
	 * @summary Add the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 business days to 1 September 2014:
	 * var result = addBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
	 */
	function addBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var startedOnWeekend = (0, _index.default)(date);
	  var amount = (0, _index3.default)(dirtyAmount);
	  if (isNaN(amount)) return new Date(NaN);
	  var hours = date.getHours();
	  var sign = amount < 0 ? -1 : 1;
	  var fullWeeks = (0, _index3.default)(amount / 5);
	  date.setDate(date.getDate() + fullWeeks * 7); // Get remaining days not part of a full week
	
	  var restDays = Math.abs(amount % 5); // Loops over remaining days
	
	  while (restDays > 0) {
	    date.setDate(date.getDate() + sign);
	    if (!(0, _index.default)(date)) restDays -= 1;
	  } // If the date is a weekend day and we reduce a dividable of
	  // 5 from it, we land on a weekend date.
	  // To counter this, we add days accordingly to land on the next business day
	
	
	  if (startedOnWeekend && (0, _index.default)(date) && amount !== 0) {
	    // If we're reducing days, we want to add days until we land on a weekday
	    // If we're adding days we want to reduce days until we land on a weekday
	    if ((0, _index6.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
	    if ((0, _index5.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
	  } // Restore hours to avoid DST lag
	
	
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(561));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2225));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Add the specified number of ISO week-numbering years to the given date.
	 *
	 * @description
	 * Add the specified number of ISO week-numbering years to the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `addISOYears` to `addISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 ISO week-numbering years to 2 July 2010:
	 * var result = addISOWeekYears(new Date(2010, 6, 2), 5)
	 * //=> Fri Jun 26 2015 00:00:00
	 */
	function addISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index3.default)(dirtyDate, (0, _index2.default)(dirtyDate) + amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(712));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(712));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addSeconds
	 * @category Second Helpers
	 * @summary Add the specified number of seconds to the given date.
	 *
	 * @description
	 * Add the specified number of seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 seconds to 10 July 2014 12:45:00:
	 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:45:30
	 */
	function addSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 1000);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(713));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * var result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(561));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInCalendarISOYears` to `differenceInCalendarISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
	 * var result = differenceInCalendarISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft) - (0, _index.default)(dirtyDateRight);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2193 */
[6649, 31, 20],
/* 2194 */
[6650, 371, 320, 20],
/* 2195 */
[6651, 31, 20],
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInHours;
	
	var _index = _interopRequireDefault(__webpack_require__(941));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	/**
	 * @name differenceInHours
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of hours
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * var result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	
	function differenceInHours(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(941));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * @name differenceInMinutes
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the signed number of full (rounded towards 0) minutes between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of minutes
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * var result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 *
	 * @example
	 * // How many minutes are from 10:01:59 to 10:00:00
	 * var result = differenceInMinutes(
	 *   new Date(2000, 0, 1, 10, 0, 0),
	 *   new Date(2000, 0, 1, 10, 1, 59)
	 * )
	 * //=> -1
	 */
	
	function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInYears;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2195));
	
	var _index3 = _interopRequireDefault(__webpack_require__(452));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInYears
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
	 * //=> 1
	 */
	function differenceInYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
	  // with leap days
	
	  dateLeft.setFullYear('1584');
	  dateRight.setFullYear('1584'); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastYearNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - isLastYearNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachDayOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachDayOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of dates within the specified time interval.
	 *
	 * @description
	 * Return the array of dates within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
	 *
	 *   // v2.0.0 onward
	 *
	 *   eachDayOfInterval(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * var result = eachDayOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 9, 10)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDayOfInterval(dirtyInterval, options) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setDate(currentDate.getDate() + step);
	    currentDate.setHours(0, 0, 0, 0);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2200 */
[6654, 31, 53, 20],
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfYear
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	
	var _index = _interopRequireDefault(__webpack_require__(452));
	
	var _index2 = _interopRequireDefault(__webpack_require__(942));
	
	var _index3 = _interopRequireDefault(__webpack_require__(943));
	
	var _index4 = _interopRequireDefault(__webpack_require__(454));
	
	var _index5 = _interopRequireDefault(__webpack_require__(31));
	
	var _index6 = _interopRequireDefault(__webpack_require__(2180));
	
	var _index7 = _interopRequireDefault(__webpack_require__(320));
	
	var _index8 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MINUTES_IN_DAY = 1440;
	var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
	var MINUTES_IN_MONTH = 43200;
	var MINUTES_IN_TWO_MONTHS = 86400;
	/**
	 * @name formatDistance
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words.
	 *
	 * | Distance between dates                                            | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance between dates | Result               |
	 * |------------------------|----------------------|
	 * | 0 secs ... 5 secs      | less than 5 seconds  |
	 * | 5 secs ... 10 secs     | less than 10 seconds |
	 * | 10 secs ... 20 secs    | less than 20 seconds |
	 * | 20 secs ... 40 secs    | half a minute        |
	 * | 40 secs ... 60 secs    | less than a minute   |
	 * | 60 secs ... 90 secs    | 1 minute             |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWords ` to `formatDistance`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWords(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistance(
	 *     new Date(1986, 3, 4, 11, 32, 0),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { addSuffix: true }
	 *   ) //=> 'in about 1 hour'
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * var result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00, including seconds?
	 * var result = formatDistance(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 *   { includeSeconds: true }
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * var result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> 'about 1 year ago'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> 'pli ol 1 jaro'
	 */
	
	function formatDistance(dirtyDate, dirtyBaseDate, dirtyOptions) {
	  (0, _index8.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index4.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain formatDistance property');
	  }
	
	  var comparison = (0, _index.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index6.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index5.default)(dirtyBaseDate);
	    dateRight = (0, _index5.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index5.default)(dirtyDate);
	    dateRight = (0, _index5.default)(dirtyBaseDate);
	  }
	
	  var seconds = (0, _index3.default)(dateRight, dateLeft);
	  var offsetInSeconds = ((0, _index7.default)(dateRight) - (0, _index7.default)(dateLeft)) / 1000;
	  var minutes = Math.round((seconds - offsetInSeconds) / 60);
	  var months; // 0 up to 2 mins
	
	  if (minutes < 2) {
	    if (options.includeSeconds) {
	      if (seconds < 5) {
	        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
	      } else if (seconds < 10) {
	        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
	      } else if (seconds < 20) {
	        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
	      } else if (seconds < 40) {
	        return locale.formatDistance('halfAMinute', null, localizeOptions);
	      } else if (seconds < 60) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', 1, localizeOptions);
	      }
	    } else {
	      if (minutes === 0) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', minutes, localizeOptions);
	      }
	    } // 2 mins up to 0.75 hrs
	
	  } else if (minutes < 45) {
	    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
	  } else if (minutes < 90) {
	    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
	  } else if (minutes < MINUTES_IN_DAY) {
	    var hours = Math.round(minutes / 60);
	    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
	  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
	    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
	  } else if (minutes < MINUTES_IN_MONTH) {
	    var days = Math.round(minutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
	  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
	    months = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('aboutXMonths', months, localizeOptions);
	  }
	
	  months = (0, _index2.default)(dateRight, dateLeft); // 2 months up to 12 months
	
	  if (months < 12) {
	    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
	  } else {
	    var monthsSinceStartOfYear = months % 12;
	    var years = Math.floor(months / 12); // N years up to 1 years 3 months
	
	    if (monthsSinceStartOfYear < 3) {
	      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
	    } else if (monthsSinceStartOfYear < 9) {
	      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
	    } else {
	      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
	    }
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(320));
	
	var _index2 = _interopRequireDefault(__webpack_require__(452));
	
	var _index3 = _interopRequireDefault(__webpack_require__(31));
	
	var _index4 = _interopRequireDefault(__webpack_require__(943));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2180));
	
	var _index6 = _interopRequireDefault(__webpack_require__(454));
	
	var _index7 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MINUTES_IN_DAY = 1440;
	var MINUTES_IN_MONTH = 43200;
	var MINUTES_IN_YEAR = 525600;
	/**
	 * @name formatDistanceStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 * - The order of arguments is swapped to make the function
	 *   consistent with `differenceIn...` functions.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(2015, 0, 2),
	 *     new Date(2014, 6, 2)
	 *   ) //=> '6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(2014, 6, 2),
	 *     new Date(2015, 0, 2)
	 *   ) //=> '6 months'
	 *   ```
	 *
	 * - `partialMethod` option is renamed to `roundingMethod`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { partialMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { roundingMethod: 'ceil' }
	 *   ) //=> '2 minutes'
	 *   ```
	 *
	 * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
	 *
	 * - `unit` option now accepts one of the strings:
	 *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsStrict(
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     { unit: 'm' }
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceStrict(
	 *     new Date(1986, 3, 4, 10, 33, 1),
	 *     new Date(1986, 3, 4, 10, 32, 0),
	 *     { unit: 'minute' }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
	 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * var result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00?
	 * var result = formatDistanceStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0)
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * var result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> '1 year ago'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, in minutes?
	 * var result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
	 *   unit: 'minute'
	 * })
	 * //=> '525600 minutes'
	 *
	 * @example
	 * // What is the distance from 1 January 2015
	 * // to 28 January 2015, in months, rounded up?
	 * var result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> '1 jaro'
	 */
	
	function formatDistanceStrict(dirtyDate, dirtyBaseDate, dirtyOptions) {
	  (0, _index7.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index6.default;
	
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain localize.formatDistance property');
	  }
	
	  var comparison = (0, _index2.default)(dirtyDate, dirtyBaseDate);
	
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var localizeOptions = (0, _index5.default)(options);
	  localizeOptions.addSuffix = Boolean(options.addSuffix);
	  localizeOptions.comparison = comparison;
	  var dateLeft;
	  var dateRight;
	
	  if (comparison > 0) {
	    dateLeft = (0, _index3.default)(dirtyBaseDate);
	    dateRight = (0, _index3.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index3.default)(dirtyDate);
	    dateRight = (0, _index3.default)(dirtyBaseDate);
	  }
	
	  var roundingMethod = options.roundingMethod == null ? 'round' : String(options.roundingMethod);
	  var roundingMethodFn;
	
	  if (roundingMethod === 'floor') {
	    roundingMethodFn = Math.floor;
	  } else if (roundingMethod === 'ceil') {
	    roundingMethodFn = Math.ceil;
	  } else if (roundingMethod === 'round') {
	    roundingMethodFn = Math.round;
	  } else {
	    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
	  }
	
	  var seconds = (0, _index4.default)(dateRight, dateLeft);
	  var offsetInSeconds = ((0, _index.default)(dateRight) - (0, _index.default)(dateLeft)) / 1000;
	  var minutes = roundingMethodFn((seconds - offsetInSeconds) / 60);
	  var unit;
	
	  if (options.unit == null) {
	    if (minutes < 1) {
	      unit = 'second';
	    } else if (minutes < 60) {
	      unit = 'minute';
	    } else if (minutes < MINUTES_IN_DAY) {
	      unit = 'hour';
	    } else if (minutes < MINUTES_IN_MONTH) {
	      unit = 'day';
	    } else if (minutes < MINUTES_IN_YEAR) {
	      unit = 'month';
	    } else {
	      unit = 'year';
	    }
	  } else {
	    unit = String(options.unit);
	  } // 0 up to 60 seconds
	
	
	  if (unit === 'second') {
	    return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
	  } else if (unit === 'minute') {
	    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 1 up to 24 hours
	  } else if (unit === 'hour') {
	    var hours = roundingMethodFn(minutes / 60);
	    return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
	  } else if (unit === 'day') {
	    var days = roundingMethodFn(minutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
	  } else if (unit === 'month') {
	    var months = roundingMethodFn(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
	  } else if (unit === 'year') {
	    var years = roundingMethodFn(minutes / MINUTES_IN_YEAR);
	    return locale.formatDistance('xYears', years, localizeOptions);
	  }
	
	  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 2204 */
[6655, 31, 20],
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * var result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2206 */
[6656, 31, 20],
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getISODay
	 * @category Weekday Helpers
	 * @summary Get the day of the ISO week of the given date.
	 *
	 * @description
	 * Get the day of the ISO week of the given date,
	 * which is 7 for Sunday, 1 for Monday etc.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the ISO week is 26 February 2012?
	 * var result = getISODay(new Date(2012, 1, 26))
	 * //=> 7
	 */
	function getISODay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	
	  if (day === 0) {
	    day = 7;
	  }
	
	  return day;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(455));
	
	var _index3 = _interopRequireDefault(__webpack_require__(716));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeek
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * var result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	
	function getISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2209 */
[6660, 31, 20],
/* 2210 */
[6662, 31, 20],
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(371));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1480));
	
	var _index3 = _interopRequireDefault(__webpack_require__(31));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getWeek
	 * @category Week Helpers
	 * @summary Get the local week index of the given date.
	 *
	 * @description
	 * Get the local week index of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week of the local week numbering year is 2 January 2005 with default options?
	 * var result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 2
	 *
	 * // Which week of the local week numbering year is 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January?
	 * var result = getISOWeek(new Date(2005, 0, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> 53
	 */
	
	function getWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index3.default)(dirtyDate);
	  var diff = (0, _index.default)(date, options).getTime() - (0, _index2.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(371));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(53));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Get the local week-numbering year of the given date.
	 *
	 * @description
	 * Get the local week-numbering year of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the local week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 with the default settings?
	 * var result = getWeekYear(new Date(2004, 11, 26))
	 * //=> 2005
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
	 * var result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
	 * //=> 2004
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
	 * var result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
	 * //=> 2004
	 */
	function getWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = date.getFullYear();
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index3.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index3.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index.default)(firstWeekOfNextYear, dirtyOptions);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index.default)(firstWeekOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 2213 */
[6665, 31, 20],
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLeapYear;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLeapYear
	 * @category Year Helpers
	 * @summary Is the given date in the leap year?
	 *
	 * @description
	 * Is the given date in the leap year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the leap year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2012 in the leap year?
	 * var result = isLeapYear(new Date(2012, 8, 1))
	 * //=> true
	 */
	function isLeapYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameHour;
	
	var _index = _interopRequireDefault(__webpack_require__(2226));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameHour
	 * @category Hour Helpers
	 * @summary Are the given dates in the same hour?
	 *
	 * @description
	 * Are the given dates in the same hour?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same hour
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
	 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
	 * //=> true
	 */
	function isSameHour(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfHour = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfHour = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(1475));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeek
	 * @category ISO Week Helpers
	 * @summary Are the given dates in the same ISO week?
	 *
	 * @description
	 * Are the given dates in the same ISO week?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
	 * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
	 * //=> true
	 */
	function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft, dirtyDateRight, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(2227));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMinute
	 * @category Minute Helpers
	 * @summary Are the given dates in the same minute?
	 *
	 * @description
	 * Are the given dates in the same minute?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same minute
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
	 * // in the same minute?
	 * var result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 4, 6, 30, 15)
	 * )
	 * //=> true
	 */
	function isSameMinute(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfMinute = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfMinute = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 2218 */
[6669, 31, 20],
/* 2219 */
[6670, 1479, 20],
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(2228));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameSecond
	 * @category Second Helpers
	 * @summary Are the given dates in the same second?
	 *
	 * @description
	 * Are the given dates in the same second?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same second
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
	 * // in the same second?
	 * var result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 30, 15),
	 *   new Date(2014, 8, 4, 6, 30, 15, 500)
	 * )
	 * //=> true
	 */
	function isSameSecond(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfSecond = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfSecond = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 2221 */
[6671, 31, 20],
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSaturday;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSaturday
	 * @category Weekday Helpers
	 * @summary Is the given date Saturday?
	 *
	 * @description
	 * Is the given date Saturday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 27 September 2014 Saturday?
	 * var result = isSaturday(new Date(2014, 8, 27))
	 * //=> true
	 */
	function isSaturday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 6;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfMonth
	 * @category Month Helpers
	 * @summary Return the last day of a month for the given date.
	 *
	 * @description
	 * Return the last day of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a month for 2 September 2014 11:55:00:
	 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(53));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfWeek
	 * @category Week Helpers
	 * @summary Return the last day of a week for the given date.
	 *
	 * @description
	 * Return the last day of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the last day of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The last day of a week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
	 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setHours(0, 0, 0, 0);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(716));
	
	var _index4 = _interopRequireDefault(__webpack_require__(453));
	
	var _index5 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Set the ISO week-numbering year to the given date.
	 *
	 * @description
	 * Set the ISO week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `setISOYear` to `setISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
	 * @returns {Date} the new date with the ISO week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set ISO week-numbering year 2007 to 29 December 2008:
	 * var result = setISOWeekYear(new Date(2008, 11, 29), 2007)
	 * //=> Mon Jan 01 2007 00:00:00
	 */
	function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeekYear = (0, _index.default)(dirtyISOWeekYear);
	  var diff = (0, _index4.default)(date, (0, _index3.default)(date));
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  date = (0, _index3.default)(fourthOfJanuary);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfHour
	 * @category Hour Helpers
	 * @summary Return the start of an hour for the given date.
	 *
	 * @description
	 * Return the start of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an hour for 2 September 2014 11:55:00:
	 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:00:00
	 */
	function startOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMinute
	 * @category Minute Helpers
	 * @summary Return the start of a minute for the given date.
	 *
	 * @description
	 * Return the start of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a minute for 1 December 2014 22:15:45.400:
	 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:00
	 */
	function startOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfSecond
	 * @category Second Helpers
	 * @summary Return the start of a second for the given date.
	 *
	 * @description
	 * Return the start of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a second for 1 December 2014 22:15:45.400:
	 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.000
	 */
	function startOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sub;
	
	var _index = _interopRequireDefault(__webpack_require__(1482));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2231));
	
	var _index3 = _interopRequireDefault(__webpack_require__(31));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	var _index5 = _interopRequireDefault(__webpack_require__(53));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name sub
	 * @category Common Helpers
	 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @description
	 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
	 *
	 * | Key     | Description                        |
	 * |---------|------------------------------------|
	 * | years   | Amount of years to be subtracted   |
	 * | months  | Amount of months to be subtracted  |
	 * | weeks   | Amount of weeks to be subtracted   |
	 * | days    | Amount of days to be subtracted    |
	 * | hours   | Amount of hours to be subtracted   |
	 * | minutes | Amount of minutes to be subtracted |
	 * | seconds | Amount of seconds to be subtracted |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract the following duration from 15 June 2017 15:29:20
	 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> Mon Sep 1 2014 10:19:50
	 */
	function sub(dirtyDate, duration) {
	  (0, _index4.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = 'years' in duration ? (0, _index5.default)(duration.years) : 0;
	  var months = 'months' in duration ? (0, _index5.default)(duration.months) : 0;
	  var weeks = 'weeks' in duration ? (0, _index5.default)(duration.weeks) : 0;
	  var days = 'days' in duration ? (0, _index5.default)(duration.days) : 0;
	  var hours = 'hours' in duration ? (0, _index5.default)(duration.hours) : 0;
	  var minutes = 'minutes' in duration ? (0, _index5.default)(duration.minutes) : 0;
	  var seconds = 'seconds' in duration ? (0, _index5.default)(duration.seconds) : 0; // Subtract years and months
	
	  var dateWithoutMonths = (0, _index2.default)((0, _index3.default)(dirtyDate), months + years * 12); // Subtract weeks and days
	
	  var dateWithoutDays = (0, _index.default)(dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds
	
	  var minutestoSub = minutes + hours * 60;
	  var secondstoSub = seconds + minutestoSub * 60;
	  var mstoSub = secondstoSub * 1000;
	  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2188));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * @description
	 * Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `subISOYears` to `subISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 ISO week-numbering years from 1 September 2014:
	 * var result = subISOWeekYears(new Date(2014, 8, 1), 5)
	 * //=> Mon Aug 31 2009 00:00:00
	 */
	function subISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(713));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * var result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2232 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HandlerRole = void 0;
	var HandlerRole;
	exports.HandlerRole = HandlerRole;
	
	(function (HandlerRole) {
	  HandlerRole["SOURCE"] = "SOURCE";
	  HandlerRole["TARGET"] = "TARGET";
	})(HandlerRole || (exports.HandlerRole = HandlerRole = {}));

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.areDirty = areDirty;
	exports.ALL = exports.NONE = void 0;
	
	var _js_utils = __webpack_require__(562);
	
	var NONE = [];
	exports.NONE = NONE;
	var ALL = [];
	exports.ALL = ALL;
	NONE.__IS_NONE__ = true;
	ALL.__IS_ALL__ = true;
	/**
	 * Determines if the given handler IDs are dirty or not.
	 *
	 * @param dirtyIds The set of dirty handler ids
	 * @param handlerIds The set of handler ids to check
	 */
	
	function areDirty(dirtyIds, handlerIds) {
	  if (dirtyIds === NONE) {
	    return false;
	  }
	
	  if (dirtyIds === ALL || typeof handlerIds === 'undefined') {
	    return true;
	  }
	
	  var commonIds = (0, _js_utils.intersection)(handlerIds, dirtyIds);
	  return commonIds.length > 0;
	}

/***/ }),
/* 2234 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.areCoordsEqual = areCoordsEqual;
	exports.areArraysEqual = areArraysEqual;
	exports.strictEquality = void 0;
	
	var strictEquality = function strictEquality(a, b) {
	  return a === b;
	};
	/**
	 * Determine if two cartesian coordinate offsets are equal
	 * @param offsetA
	 * @param offsetB
	 */
	
	
	exports.strictEquality = strictEquality;
	
	function areCoordsEqual(offsetA, offsetB) {
	  if (!offsetA && !offsetB) {
	    return true;
	  } else if (!offsetA || !offsetB) {
	    return false;
	  } else {
	    return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
	  }
	}
	/**
	 * Determines if two arrays of items are equal
	 * @param a The first array of items
	 * @param b The second array of items
	 */
	
	
	function areArraysEqual(a, b) {
	  var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : strictEquality;
	
	  if (a.length !== b.length) {
	    return false;
	  }
	
	  for (var i = 0; i < a.length; ++i) {
	    if (!isEqual(a[i], b[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 2235 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = matchesType;
	
	function matchesType(targetType, draggedItemType) {
	  if (draggedItemType === null) {
	    return targetType === null;
	  }
	
	  return Array.isArray(targetType) ? targetType.some(function (t) {
	    return t === draggedItemType;
	  }) : targetType === draggedItemType;
	}

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = activeElement;
	
	var _ownerDocument = __webpack_require__(372);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function activeElement() {
	  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();
	
	  try {
	    return doc.activeElement;
	  } catch (e) {/* ie throws if no active element */}
	}
	module.exports = exports['default'];

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelizeStyleName;
	
	var _camelize = __webpack_require__(4884);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^-ms-/; /**
	                          * Copyright 2014-2015, Facebook, Inc.
	                          * All rights reserved.
	                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	                          */
	function camelizeStyleName(string) {
	  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
	}
	module.exports = exports['default'];

/***/ }),
/* 2238 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 2239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_94b53ec1","outerContainer":"_4392e1ff","secondaryToolbar":"_425aadc3","doorHangerRight":"e54ba63d","toolbarContainer":"_3935ab93","toolbarViewerMiddle":"_4c4468eb","progressBar":"_73710b3f","back-to-application":"a33e28be","empty-block":"ffa84e39","modal-body":"_0948057d","locationInfo":"_20cfdec4","locationName":"_22b4b14f","address":"cbaff569","eirVisitTimeSlots":"_97773a87","eirVisitTimeSlots_separator":"_8b16e85c"};

/***/ }),
/* 2240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"abde62c7","outerContainer":"c94d886e","secondaryToolbar":"_409d7f61","doorHangerRight":"_15a0baa5","toolbarContainer":"_489d8b1e","toolbarViewerMiddle":"_6df13e38","progressBar":"_6d107152","back-to-application":"_7aeca3f6","root":"_6fd35d59","loader":"_3438b806","progress":"c3af3d1a","content":"_361abb53","validating":"c0074b34","freeze":"ea52b081","disabled":"e8fb3576","emptyBlock":"dd7b4a47"};

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_46501a93","outerContainer":"ba2c352d","secondaryToolbar":"_60fce83b","doorHangerRight":"bb57c44a","toolbarContainer":"_171ab6f9","toolbarViewerMiddle":"_13d61018","progressBar":"f7f3cf7e","back-to-application":"a39a0b42","root":"b9753b5b","root--raised":"_2225bbc3","root--icon":"c66a4603","root--color--primary":"be378635","root--color--flaglerPrimary":"_564f6f63","root--color--accent":"_3846d9ee","root--color--danger":"c3878896","root--color--danger-white":"_764376e2","root--color--success":"bac18f89","root--color--transparent":"_77712fc4","root--disabled":"e41229eb","root--border":"cfb03f7e"};

/***/ }),
/* 2242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d299922f","outerContainer":"e21efdaa","secondaryToolbar":"_5f692a97","doorHangerRight":"_24d11b30","toolbarContainer":"_45ed72a7","toolbarViewerMiddle":"ec6bc183","progressBar":"_75571579","back-to-application":"_9ecd88b4","root":"_1078af1d","icon":"_7ee0f89e","icon--left":"ea73c7a2","icon--right":"_82e95675","textWrapper":"a3c3a32e","chatWrapper":"_50659b1f","text":"_8873c432","text--primary":"dc44468d","text--secondary":"f3e953e1","helperContainer":"c34f9195","bold":"fb4433b6"};

/***/ }),
/* 2243 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c6bf1769","outerContainer":"_5697b961","secondaryToolbar":"a00fbf17","doorHangerRight":"_1dd345e6","toolbarContainer":"_985aa58b","toolbarViewerMiddle":"_3e9e0dc6","progressBar":"d8c41e07","back-to-application":"a6522cb5","card":"_2b830965","wrapper":"e4fca910","wrapper--placeholder":"_2598b046","header":"_8f5f900b","avatar":"_9b4eda38","content":"fa9f3d99","title":"abf635fd","subtitle":"_7e0b0a1a","footer":"ecbe02bd","image":"fd700bdc","link":"c6ed6eb2"};

/***/ }),
/* 2244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ca679a8a","outerContainer":"c9336c42","secondaryToolbar":"_98ecf026","doorHangerRight":"_7019e179","toolbarContainer":"_0bb4bc39","toolbarViewerMiddle":"_6c18a8f9","progressBar":"ad8a5d9f","back-to-application":"_37962f55","root":"ac7c4770","desc":"_9b0deb7d","history":"_348e8fbc","history-title":"b9ce480f","history-item":"b2d97925","history-item__text":"_93d514f7","menu":"_0e9e3171","item":"_31507915","item--disabled":"c7cc251f","info":"_71e52d1f","card":"_086a828e","link":"_2002aa41","title":"_049fc35f","title__text":"_256f6d94","title__text-secondary":"_6c0bf878"};

/***/ }),
/* 2245 */,
/* 2246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_52621ec0","outerContainer":"_740bd23f","secondaryToolbar":"_96615f41","doorHangerRight":"_2a5d9c47","toolbarContainer":"b7f06104","toolbarViewerMiddle":"_648156b2","progressBar":"_1fc53e3d","back-to-application":"_1033d8d0","root":"e0311ea4","root--fixed":"_009472eb","root--closed":"_9a8e7fbf","root--left":"_7ad8410a","root--right":"cc1e08c8","title":"e1f59c35","title--colored":"_75d4728f"};

/***/ }),
/* 2247 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ace67e43","outerContainer":"f78456cd","secondaryToolbar":"_19ac0a1d","doorHangerRight":"_66f778c5","toolbarContainer":"c089641b","toolbarViewerMiddle":"d3aa01de","progressBar":"_47078d0a","back-to-application":"_0e5ffe96","root":"b8799425","header":"a31c388d","headerMain":"_010e1c66","header--locked":"a061401f","headerSub":"_68349a0f","headerTitle":"_01141229","reverseTitle":"_37a1821e","text--complementary":"_59650b4a","text--primary":"_461ad469","text--short":"d3b25c08"};

/***/ }),
/* 2248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_511b7aad","outerContainer":"_4df9a274","secondaryToolbar":"_8279bf76","doorHangerRight":"c8d8f73f","toolbarContainer":"_5be795cd","toolbarViewerMiddle":"_9e22091e","progressBar":"e24feecc","back-to-application":"_24eeccd5","content":"a2bf8f95","eirVisitContent":"_72fb1738","root":"_06d57635","title":"e20e164b","visitDetails":"cf2273c1","backButton":"_89857c4c","coverHeader":"b1428898","pendingMessage":"ccc33e32","pendingActionButtonWrapper":"_872843c6","confirmButton":"e9c1bfb8","declineButton":"_1ba20112","btns":"_8acf2f37","joinVirtualVisitText":"_890d1614","width":"_228bbb20"};

/***/ }),
/* 2249 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_05da6023","outerContainer":"be961360","secondaryToolbar":"_62f4d0eb","doorHangerRight":"_7a3f9cd5","toolbarContainer":"d999e48a","toolbarViewerMiddle":"db44efb2","progressBar":"_7601df19","back-to-application":"a17ab45a","root":"_80068cff","visitConsentsHeader":"_20952443","visitConsentsTitle":"f0417853","visitConsentItem":"_3966a479","consentInfoWrapper":"_22714c98","icon":"d3533fe5","consentTitle":"_75061abb","consentSubtitleRow":"a7b64734","consentSubTitle":"d8e4f456","consentStatusTitle":"_2df6344a"};

/***/ }),
/* 2250 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a21d6bcf","outerContainer":"_43c2ac34","secondaryToolbar":"_4cc91e0d","doorHangerRight":"d4bf6a04","toolbarContainer":"_05649699","toolbarViewerMiddle":"ba66ece5","progressBar":"eee175c2","back-to-application":"aa29a43f","prescriptionsWrapper":"f2063568","title":"dbe50c17","prescription":"_7fddb4b2","prescriptionHeader":"_1dd65dc4","prescriptionHeaderLeft":"cbe1afe1","prescriptionHeaderRight":"bef899a1","iconType":"_1a5e0900","iconArrow":"_000d8f5b","drugBlock":"_3308061e","date":"_25153558","providerName":"decff422","drugDirections":"_314f86d4","privacyIcon":"b43c598a","prescriptionDetails":"e73c8177","prescriptionDetailsItem":"_40ef826d","detailsData":"_48b44906","detailsTitle":"_9a60284f","bgGrey":"abae83fd"};

/***/ }),
/* 2251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e3779ee5","outerContainer":"_9e2c2f9e","secondaryToolbar":"_467431e7","doorHangerRight":"_2749e0bd","toolbarContainer":"_8a2261ca","toolbarViewerMiddle":"_02bb2168","progressBar":"d53f93d7","back-to-application":"_349a2dbf","root":"_9705d18b","visitSurveyHeader":"_0a1388f5","visitSurveyTitle":"_9a50b48c","viewAttachmentWrapper":"_278409b0","documentWrapper":"_7918788c","documentWrapperDisabled":"d7b1e59c","surveyInfoWrapper":"c80b6c67","icon":"_6a76b741","removeIcon":"dfa30222","surveyName":"e4eb8624","surveyStatus":"dc20987b"};

/***/ }),
/* 2252 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"_7c487050","opened":"_598b7dd9","content":"_5f9c7040","info":"_6fb82afc","text":"_51fec0ff","desc":"_747bcb0f","buttonText":"c01d619f","button":"c6d1681e"};

/***/ }),
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b920db0b","outerContainer":"d793005c","secondaryToolbar":"f93a3455","doorHangerRight":"d2a7703d","toolbarContainer":"_5b1097e4","toolbarViewerMiddle":"_276cf9bb","progressBar":"_24566761","back-to-application":"_7dc0c0c1","root":"_34c2a11a","rootHover":"_61e0f33c","documentsRoot":"_4fe4bbe6","resultsWrapper":"_874b34f3","rootHeader":"d2b99e9c","headerTitle":"_7694fa4b","documentsTitle":"_79b6b9c9","nameResult":"e74e2be0","testName":"_7d2fe483","content":"_22d4d1b8","arrowButton":"ba55e88d","abnormalStatus":"_83809cca","withScale":"_6a57ed11","low":"_7e4a7300","normal":"_8efe06c1","high":"_34229cb8","indicator":"_392c8d08","privacyIcon":"_31f25e46","contentSpacer":"_489c837f","underline":"_9e905a48","resultValue":"_18b6e992","notification":"c348a314","documentWrapper":"b838445e","documentIcon":"_621f993f","documentName":"fe597241","privacyIco":"_07e88f27","left":"e902bd7c","historyButton":"cf83ee6c"};

/***/ }),
/* 2259 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bb2667f6","outerContainer":"a1613612","secondaryToolbar":"_6f366258","doorHangerRight":"c9d47f23","toolbarContainer":"_979bf21f","toolbarViewerMiddle":"_9e62cc06","progressBar":"_300838bc","back-to-application":"_56054482","root":"d8c692f9","header":"bc3be80d","title":"_9a4cb256","seeAllBtn":"_1ea701d5","content":"_21cd8002","card":"_61228b54","wrapperBorder":"e5e488f4","wrapperHover":"c0482468","cardTopWrapper":"_084c5a70","cardBottomWrapper":"_600817bc","cardTitle":"fecff82f","cardTime":"_6347494a","cardValue":"_71245aa3","cardMetric":"_3455e35f","cardIcon":"_90114495","contextOf":"e6c8c87d","rootDetails":"_3d817409","nonClickable":"_1613bc39"};

/***/ }),
/* 2260 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c6fb0530","outerContainer":"_0cb4abf2","secondaryToolbar":"_04dc817f","doorHangerRight":"d6251ae8","toolbarContainer":"_19028edc","toolbarViewerMiddle":"b9706d54","progressBar":"_510812e8","back-to-application":"_8cd7157a","root":"a000049f","rootUserContext":"bf87c73a","modalRoot":"_57bca585","modalContent":"d237bebe","coverHeader":"_1a5228b6","backButton":"_2c61326c","dataHistoricContentWrapper":"_0eb201e0","isHeightType":"_767a8ff4","withOutAddForm":"bdafcea7","navigation":"a5fada1f","patientContent":"_1ebfebf3","contentWrapper":"_0707b00d","contentTitle":"afb94c13","titleLeft":"_738ccec7","refillHistory":"_663b9dac","notAvailable":"ccec452f","notAvailableIcon":"_222747e1"};

/***/ }),
/* 2261 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_6d43a168","outerContainer":"cbf570a7","secondaryToolbar":"_72fe1865","doorHangerRight":"b66cc00d","toolbarContainer":"b8bfe4a1","toolbarViewerMiddle":"_0b9d058e","progressBar":"c8ca1345","back-to-application":"_9a7512c3","comments":"_75fba3ac","comments__list":"_2349d683","activity":"c24b00c4"};

/***/ }),
/* 2262 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_85f61276","outerContainer":"eb045e1c","secondaryToolbar":"_1fbfb087","doorHangerRight":"a799706c","toolbarContainer":"_4b249602","toolbarViewerMiddle":"_8a43684a","progressBar":"_1edd3838","back-to-application":"b7825372","root":"_063754cc","column":"ac911d4a"};

/***/ }),
/* 2263 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_2420ca4f","outerContainer":"_0c292199","secondaryToolbar":"c9597016","doorHangerRight":"_80ea8d1a","toolbarContainer":"_6e9506bc","toolbarViewerMiddle":"cc6fc5c4","progressBar":"c71f6c92","back-to-application":"_87e4d574","root":"d09d1f0e","column":"eaaad97f"};

/***/ }),
/* 2264 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b169836b","outerContainer":"b67312c5","secondaryToolbar":"_525ec62f","doorHangerRight":"_68b7f3bd","toolbarContainer":"_2fc66154","toolbarViewerMiddle":"ef9827cd","progressBar":"_879a4345","back-to-application":"bb507d52","root":"_57ce1280","header":"a040df39","content":"b07c9bda","content-header":"_57c891d4","program-title":"_817ed93b","program-context":"_2993526a","program-container":"_2e3de428","placeholder":"_24548aed","content-btn":"_79a0c3f0"};

/***/ }),
/* 2265 */,
/* 2266 */,
/* 2267 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_355bae84","outerContainer":"_190433ff","secondaryToolbar":"_40742cf1","doorHangerRight":"_62add733","toolbarContainer":"aac167af","toolbarViewerMiddle":"_04a870cf","progressBar":"_6e24901b","back-to-application":"d2241f8e","root":"_6d9bc11a","title":"a6646511","description":"_5b834540","paperClassName":"b2d26b7e","popup":"_2b3697d8"};

/***/ }),
/* 2268 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_60fdf671","outerContainer":"_20c71f0f","secondaryToolbar":"e8be44a9","doorHangerRight":"_6180f933","toolbarContainer":"_9ff5f77d","toolbarViewerMiddle":"_10e743d8","progressBar":"d06a7c87","back-to-application":"b8789e08","root":"b738572f","title":"_54d986e8","description":"_628f3349","stepper":"cc7908f4","paperClassName":"_202fa3cd","popup":"_5a480b32"};

/***/ }),
/* 2269 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_952d1095","outerContainer":"bd7c12fa","secondaryToolbar":"_78fb756b","doorHangerRight":"_7c839ec0","toolbarContainer":"_7d114c1e","toolbarViewerMiddle":"e0f2b4be","progressBar":"d451ae11","back-to-application":"ce9dd989","checkboxWrapper":"a5f2cf09","link":"cd1792ef","link--acceptable":"_2c40334c","text":"_2e036c0b","rootText":"b8598c0c"};

/***/ }),
/* 2270 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e4a8c1a4","outerContainer":"_8a6a35a2","secondaryToolbar":"cfb1597b","doorHangerRight":"_415ed222","toolbarContainer":"f76b736e","toolbarViewerMiddle":"_7604c37a","progressBar":"_7a709928","back-to-application":"f0edf680","cardWrapper":"a207bb0e","card":"_7fbfbc62","rowWrapper":"_67393804","row":"_28d5f127","item":"cda31e08","title":"_80613152","subtitle":"_6b510ebd"};

/***/ }),
/* 2271 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f25c5427","outerContainer":"_480085b5","secondaryToolbar":"_8764d61f","doorHangerRight":"_9b0a47f1","toolbarContainer":"_4d90fca8","toolbarViewerMiddle":"_8aa513b9","progressBar":"_5ed17266","back-to-application":"_87ca96ab","root":"_65039d76","description":"ec144a03","btnAdd":"_1daccc3f","btnsSubmit":"b3f1fd56"};

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_3005ffca","outerContainer":"f4cb8c3e","secondaryToolbar":"a7565e16","doorHangerRight":"_49576706","toolbarContainer":"_26542aef","toolbarViewerMiddle":"_0ec12c77","progressBar":"_5106addb","back-to-application":"_5729fc10","root":"_17714717","visible":"_861efbbc","userRow":"e82a742e","userLeft":"_6cdcf281","userName":"c9f0ae4e","isMe":"_6903ece7","userActions":"_70f2bec3"};

/***/ }),
/* 2273 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4bd36b7f","outerContainer":"_5256de53","secondaryToolbar":"d62695dc","doorHangerRight":"_77d6d14b","toolbarContainer":"_01d50b64","toolbarViewerMiddle":"_0e92f29a","progressBar":"_40396e7d","back-to-application":"d6994c23","root":"_266b4e3e","bar":"_84419e3f","line":"_367afe38","lineWithTransition":"_457cba20","title":"_23cea7be","btn":"_6654eec5"};

/***/ }),
/* 2274 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_5766c0b7","outerContainer":"_7e29d1ab","secondaryToolbar":"_55a0b16c","doorHangerRight":"a5d510cd","toolbarContainer":"_3db3a886","toolbarViewerMiddle":"_513a6b89","progressBar":"bece81ac","back-to-application":"a4850582","content":"f3e54402","btnCancel":"e600908f","btnOverlap":"_9016e1b9"};

/***/ }),
/* 2275 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"af367d05","outerContainer":"a2861bf2","secondaryToolbar":"_8f3578fa","doorHangerRight":"_536f462e","toolbarContainer":"fd83cfc4","toolbarViewerMiddle":"_952390ca","progressBar":"_3db8426d","back-to-application":"_51763ca4","root":"c025d095","content":"_95ef28ad","message":"bf8f1fb0","btn":"e98da1e0","title":"_2597435a","dialog":"_75994118"};

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"input":"_24868075","label":"_74628062","checker":"a67a2931","checked":"_4a9570fe","unchecked":"_4cbab8fd"};

/***/ }),
/* 2277 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_01b08cb3","outerContainer":"_4397b232","secondaryToolbar":"bf50014b","doorHangerRight":"c48b51ee","toolbarContainer":"_083d9490","toolbarViewerMiddle":"_31382012","progressBar":"_7eff5225","back-to-application":"ae52c661","errorMsg":"efbe788e"};

/***/ }),
/* 2278 */,
/* 2279 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"be671a24","outerContainer":"_42e65562","secondaryToolbar":"_23a67e7a","doorHangerRight":"_36091022","toolbarContainer":"_6e9f0233","toolbarViewerMiddle":"e1004d4e","progressBar":"_8df39fd6","back-to-application":"_3c683fcd","info":"_362b45e2"};

/***/ }),
/* 2280 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"f9b2a7bf","input":"_1b1ad9a0","label":"b4315530","checker":"_2aaeb584","checked":"_3db5662e","unchecked":"aab8414f"};

/***/ }),
/* 2281 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_134e2971","outerContainer":"a77cdaf9","secondaryToolbar":"b77c2947","doorHangerRight":"_83893bff","toolbarContainer":"bc2823c3","toolbarViewerMiddle":"b017a541","progressBar":"ff2cdf31","back-to-application":"cee06c37","root":"_95b18a52","itemWrapper":"ac99956d","item":"b398839c","itemBg":"fecb0834"};

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_906f7454","outerContainer":"_8a912b0d","secondaryToolbar":"_8594a11a","doorHangerRight":"d0163af8","toolbarContainer":"a199e26d","toolbarViewerMiddle":"ff530bc3","progressBar":"_66770e3c","back-to-application":"_108cd965","label":"da5309a8","label--selected":"_6ce2a07a","label--filtered":"ec95cd43","content":"d7e3419f","content-input":"_7bd2d9a4","input-wrapper":"_094cfa7e","input-button":"_6d1a640b","list-wrapper":"_4494912b"};

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_6525cdfb","outerContainer":"_459b12ac","secondaryToolbar":"_291e9437","doorHangerRight":"_9f7cea1f","toolbarContainer":"_1991646e","toolbarViewerMiddle":"e97cd717","progressBar":"d504daa0","back-to-application":"_1d0e6f2c","root":"_13d57ae3","root--active":"_514bbb9a","indicator":"_55dc148e","root--invited":"_775acf09","root--created":"_60266edf","root--joined":"_85b2ad27","hover":"_4b0b3b8d"};

/***/ }),
/* 2284 */,
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-fa5eb36c.png";

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-cabd19f9.png";

/***/ }),
/* 2287 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getMargin;
	var toNumber = function toNumber(n) {
	  return parseInt(n) || 0;
	};
	
	function getMargin(style) {
	  return {
	    top: toNumber(style.marginTop),
	    right: toNumber(style.marginRight),
	    bottom: toNumber(style.marginBottom),
	    left: toNumber(style.marginLeft)
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ }),
/* 2293 */
/***/ (function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	// -- Utilities ----------------------------------------------------------------
	function getCacheId(inputs) {
	    return JSON.stringify(inputs.map(function (input) {
	        return input && typeof input === 'object' ? orderedProps(input) : input;
	    }));
	}
	function orderedProps(obj) {
	    return Object.keys(obj)
	        .sort()
	        .map(function (k) {
	        var _a;
	        return (_a = {}, _a[k] = obj[k], _a);
	    });
	}
	var memoizeFormatConstructor = function (FormatConstructor, cache) {
	    if (cache === void 0) { cache = {}; }
	    return function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var cacheId = getCacheId(args);
	        var format = cacheId && cache[cacheId];
	        if (!format) {
	            format = new ((_a = FormatConstructor).bind.apply(_a, __spreadArrays([void 0], args)))();
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	        return format;
	    };
	};
	exports.default = memoizeFormatConstructor;


/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var parser_1 = __webpack_require__(1523);
	var normalize_1 = __webpack_require__(5343);
	__export(__webpack_require__(1524));
	__export(__webpack_require__(1523));
	__export(__webpack_require__(5344));
	function parse(input, opts) {
	    var els = parser_1.pegParse(input, opts);
	    if (!opts || opts.normalizeHashtagInPlural !== false) {
	        normalize_1.normalizeHashtagInPlural(els);
	    }
	    return els;
	}
	exports.parse = parse;


/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var intl_messageformat_parser_1 = __webpack_require__(2294);
	var intl_format_cache_1 = __webpack_require__(2293);
	var formatters_1 = __webpack_require__(2296);
	// -- MessageFormat --------------------------------------------------------
	function mergeConfig(c1, c2) {
	    if (!c2) {
	        return c1;
	    }
	    return __assign(__assign(__assign({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
	        all[k] = __assign(__assign({}, c1[k]), (c2[k] || {}));
	        return all;
	    }, {}));
	}
	function mergeConfigs(defaultConfig, configs) {
	    if (!configs) {
	        return defaultConfig;
	    }
	    return Object.keys(defaultConfig).reduce(function (all, k) {
	        all[k] = mergeConfig(defaultConfig[k], configs[k]);
	        return all;
	    }, __assign({}, defaultConfig));
	}
	function createDefaultFormatters(cache) {
	    if (cache === void 0) { cache = {
	        number: {},
	        dateTime: {},
	        pluralRules: {},
	    }; }
	    return {
	        getNumberFormat: intl_format_cache_1.default(Intl.NumberFormat, cache.number),
	        getDateTimeFormat: intl_format_cache_1.default(Intl.DateTimeFormat, cache.dateTime),
	        getPluralRules: intl_format_cache_1.default(Intl.PluralRules, cache.pluralRules),
	    };
	}
	exports.createDefaultFormatters = createDefaultFormatters;
	var IntlMessageFormat = /** @class */ (function () {
	    function IntlMessageFormat(message, locales, overrideFormats, opts) {
	        var _this = this;
	        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
	        this.formatterCache = {
	            number: {},
	            dateTime: {},
	            pluralRules: {},
	        };
	        this.format = function (values) {
	            return formatters_1.formatToString(_this.ast, _this.locales, _this.formatters, _this.formats, values, _this.message);
	        };
	        this.formatToParts = function (values) {
	            return formatters_1.formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
	        };
	        this.formatHTMLMessage = function (values) {
	            return formatters_1.formatHTMLMessage(_this.ast, _this.locales, _this.formatters, _this.formats, values, _this.message);
	        };
	        this.resolvedOptions = function () { return ({
	            locale: Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
	        }); };
	        this.getAst = function () { return _this.ast; };
	        if (typeof message === 'string') {
	            this.message = message;
	            if (!IntlMessageFormat.__parse) {
	                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
	            }
	            // Parse string messages into an AST.
	            this.ast = IntlMessageFormat.__parse(message, {
	                normalizeHashtagInPlural: false,
	            });
	        }
	        else {
	            this.ast = message;
	        }
	        if (!Array.isArray(this.ast)) {
	            throw new TypeError('A message must be provided as a String or AST.');
	        }
	        // Creates a new object with the specified `formats` merged with the default
	        // formats.
	        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
	        // Defined first because it's used to build the format pattern.
	        this.locales = locales;
	        this.formatters =
	            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
	    }
	    IntlMessageFormat.defaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
	    IntlMessageFormat.__parse = intl_messageformat_parser_1.parse;
	    // Default format options used as the prototype of the `formats` provided to the
	    // constructor. These are used when constructing the internal Intl.NumberFormat
	    // and Intl.DateTimeFormat instances.
	    IntlMessageFormat.formats = {
	        number: {
	            currency: {
	                style: 'currency',
	            },
	            percent: {
	                style: 'percent',
	            },
	        },
	        date: {
	            short: {
	                month: 'numeric',
	                day: 'numeric',
	                year: '2-digit',
	            },
	            medium: {
	                month: 'short',
	                day: 'numeric',
	                year: 'numeric',
	            },
	            long: {
	                month: 'long',
	                day: 'numeric',
	                year: 'numeric',
	            },
	            full: {
	                weekday: 'long',
	                month: 'long',
	                day: 'numeric',
	                year: 'numeric',
	            },
	        },
	        time: {
	            short: {
	                hour: 'numeric',
	                minute: 'numeric',
	            },
	            medium: {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	            },
	            long: {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	                timeZoneName: 'short',
	            },
	            full: {
	                hour: 'numeric',
	                minute: 'numeric',
	                second: 'numeric',
	                timeZoneName: 'short',
	            },
	        },
	    };
	    return IntlMessageFormat;
	}());
	exports.IntlMessageFormat = IntlMessageFormat;
	exports.default = IntlMessageFormat;


/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var intl_messageformat_parser_1 = __webpack_require__(2294);
	var FormatError = /** @class */ (function (_super) {
	    __extends(FormatError, _super);
	    function FormatError(msg, variableId) {
	        var _this = _super.call(this, msg) || this;
	        _this.variableId = variableId;
	        return _this;
	    }
	    return FormatError;
	}(Error));
	function mergeLiteral(parts) {
	    if (parts.length < 2) {
	        return parts;
	    }
	    return parts.reduce(function (all, part) {
	        var lastPart = all[all.length - 1];
	        if (!lastPart ||
	            lastPart.type !== 0 /* literal */ ||
	            part.type !== 0 /* literal */) {
	            all.push(part);
	        }
	        else {
	            lastPart.value += part.value;
	        }
	        return all;
	    }, []);
	}
	// TODO(skeleton): add skeleton support
	function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
	// For debugging
	originalMessage) {
	    // Hot path for straight simple msg translations
	    if (els.length === 1 && intl_messageformat_parser_1.isLiteralElement(els[0])) {
	        return [
	            {
	                type: 0 /* literal */,
	                value: els[0].value,
	            },
	        ];
	    }
	    var result = [];
	    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
	        var el = els_1[_i];
	        // Exit early for string parts.
	        if (intl_messageformat_parser_1.isLiteralElement(el)) {
	            result.push({
	                type: 0 /* literal */,
	                value: el.value,
	            });
	            continue;
	        }
	        // TODO: should this part be literal type?
	        // Replace `#` in plural rules with the actual numeric value.
	        if (intl_messageformat_parser_1.isPoundElement(el)) {
	            if (typeof currentPluralValue === 'number') {
	                result.push({
	                    type: 0 /* literal */,
	                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
	                });
	            }
	            continue;
	        }
	        var varName = el.value;
	        // Enforce that all required values are provided by the caller.
	        if (!(values && varName in values)) {
	            throw new FormatError("The intl string context variable \"" + varName + "\" was not provided to the string \"" + originalMessage + "\"");
	        }
	        var value = values[varName];
	        if (intl_messageformat_parser_1.isArgumentElement(el)) {
	            if (!value || typeof value === 'string' || typeof value === 'number') {
	                value =
	                    typeof value === 'string' || typeof value === 'number'
	                        ? String(value)
	                        : '';
	            }
	            result.push({
	                type: 1 /* argument */,
	                value: value,
	            });
	            continue;
	        }
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (intl_messageformat_parser_1.isDateElement(el)) {
	            var style = typeof el.style === 'string' ? formats.date[el.style] : undefined;
	            result.push({
	                type: 0 /* literal */,
	                value: formatters
	                    .getDateTimeFormat(locales, style)
	                    .format(value),
	            });
	            continue;
	        }
	        if (intl_messageformat_parser_1.isTimeElement(el)) {
	            var style = typeof el.style === 'string'
	                ? formats.time[el.style]
	                : intl_messageformat_parser_1.isDateTimeSkeleton(el.style)
	                    ? intl_messageformat_parser_1.parseDateTimeSkeleton(el.style.pattern)
	                    : undefined;
	            result.push({
	                type: 0 /* literal */,
	                value: formatters
	                    .getDateTimeFormat(locales, style)
	                    .format(value),
	            });
	            continue;
	        }
	        if (intl_messageformat_parser_1.isNumberElement(el)) {
	            var style = typeof el.style === 'string'
	                ? formats.number[el.style]
	                : intl_messageformat_parser_1.isNumberSkeleton(el.style)
	                    ? intl_messageformat_parser_1.convertNumberSkeletonToNumberFormatOptions(el.style.tokens)
	                    : undefined;
	            result.push({
	                type: 0 /* literal */,
	                value: formatters
	                    .getNumberFormat(locales, style)
	                    .format(value),
	            });
	            continue;
	        }
	        if (intl_messageformat_parser_1.isSelectElement(el)) {
	            var opt = el.options[value] || el.options.other;
	            if (!opt) {
	                throw new RangeError("Invalid values for \"" + el.value + "\": \"" + value + "\". Options are \"" + Object.keys(el.options).join('", "') + "\"");
	            }
	            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
	            continue;
	        }
	        if (intl_messageformat_parser_1.isPluralElement(el)) {
	            var opt = el.options["=" + value];
	            if (!opt) {
	                if (!Intl.PluralRules) {
	                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n");
	                }
	                var rule = formatters
	                    .getPluralRules(locales, { type: el.pluralType })
	                    .select(value - (el.offset || 0));
	                opt = el.options[rule] || el.options.other;
	            }
	            if (!opt) {
	                throw new RangeError("Invalid values for \"" + el.value + "\": \"" + value + "\". Options are \"" + Object.keys(el.options).join('", "') + "\"");
	            }
	            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
	            continue;
	        }
	    }
	    return mergeLiteral(result);
	}
	exports.formatToParts = formatToParts;
	function formatToString(els, locales, formatters, formats, values, 
	// For debugging
	originalMessage) {
	    var parts = formatToParts(els, locales, formatters, formats, values, undefined, originalMessage);
	    // Hot path for straight simple msg translations
	    if (parts.length === 1) {
	        return parts[0].value;
	    }
	    return parts.reduce(function (all, part) { return (all += part.value); }, '');
	}
	exports.formatToString = formatToString;
	// Singleton
	var domParser;
	var TOKEN_DELIMITER = '@@';
	var TOKEN_REGEX = /@@(\d+_\d+)@@/g;
	var counter = 0;
	function generateId() {
	    return Date.now() + "_" + ++counter;
	}
	function restoreRichPlaceholderMessage(text, objectParts) {
	    return text
	        .split(TOKEN_REGEX)
	        .filter(Boolean)
	        .map(function (c) { return (objectParts[c] != null ? objectParts[c] : c); })
	        .reduce(function (all, c) {
	        if (!all.length) {
	            all.push(c);
	        }
	        else if (typeof c === 'string' &&
	            typeof all[all.length - 1] === 'string') {
	            all[all.length - 1] += c;
	        }
	        else {
	            all.push(c);
	        }
	        return all;
	    }, []);
	}
	/**
	 * Not exhaustive, just for sanity check
	 */
	var SIMPLE_XML_REGEX = /(<([0-9a-zA-Z-_]*?)>(.*?)<\/([0-9a-zA-Z-_]*?)>)|(<[0-9a-zA-Z-_]*?\/>)/;
	var TEMPLATE_ID = Date.now() + '@@';
	var VOID_ELEMENTS = [
	    'area',
	    'base',
	    'br',
	    'col',
	    'embed',
	    'hr',
	    'img',
	    'input',
	    'link',
	    'meta',
	    'param',
	    'source',
	    'track',
	    'wbr',
	];
	function formatHTMLElement(el, objectParts, values) {
	    var tagName = el.tagName;
	    var outerHTML = el.outerHTML, textContent = el.textContent, childNodes = el.childNodes;
	    // Regular text
	    if (!tagName) {
	        return restoreRichPlaceholderMessage(textContent || '', objectParts);
	    }
	    tagName = tagName.toLowerCase();
	    var isVoidElement = ~VOID_ELEMENTS.indexOf(tagName);
	    var formatFnOrValue = values[tagName];
	    if (formatFnOrValue && isVoidElement) {
	        throw new FormatError(tagName + " is a self-closing tag and can not be used, please use another tag name.");
	    }
	    if (!childNodes.length) {
	        return [outerHTML];
	    }
	    var chunks = Array.prototype.slice.call(childNodes).reduce(function (all, child) {
	        return all.concat(formatHTMLElement(child, objectParts, values));
	    }, []);
	    // Legacy HTML
	    if (!formatFnOrValue) {
	        return __spreadArrays(["<" + tagName + ">"], chunks, ["</" + tagName + ">"]);
	    }
	    // HTML Tag replacement
	    if (typeof formatFnOrValue === 'function') {
	        return [formatFnOrValue.apply(void 0, chunks)];
	    }
	    return [formatFnOrValue];
	}
	function formatHTMLMessage(els, locales, formatters, formats, values, 
	// For debugging
	originalMessage) {
	    var parts = formatToParts(els, locales, formatters, formats, values, undefined, originalMessage);
	    var objectParts = {};
	    var formattedMessage = parts.reduce(function (all, part) {
	        if (part.type === 0 /* literal */) {
	            return (all += part.value);
	        }
	        var id = generateId();
	        objectParts[id] = part.value;
	        return (all += "" + TOKEN_DELIMITER + id + TOKEN_DELIMITER);
	    }, '');
	    // Not designed to filter out aggressively
	    if (!SIMPLE_XML_REGEX.test(formattedMessage)) {
	        return restoreRichPlaceholderMessage(formattedMessage, objectParts);
	    }
	    if (!values) {
	        throw new FormatError('Message has placeholders but no values was given');
	    }
	    if (typeof DOMParser === 'undefined') {
	        throw new FormatError('Cannot format XML message without DOMParser');
	    }
	    if (!domParser) {
	        domParser = new DOMParser();
	    }
	    var content = domParser
	        .parseFromString("<formatted-message id=\"" + TEMPLATE_ID + "\">" + formattedMessage + "</formatted-message>", 'text/html')
	        .getElementById(TEMPLATE_ID);
	    if (!content) {
	        throw new FormatError("Malformed HTML message " + formattedMessage);
	    }
	    var tagsToFormat = Object.keys(values).filter(function (varName) { return !!content.getElementsByTagName(varName).length; });
	    // No tags to format
	    if (!tagsToFormat.length) {
	        return restoreRichPlaceholderMessage(formattedMessage, objectParts);
	    }
	    var caseSensitiveTags = tagsToFormat.filter(function (tagName) { return tagName !== tagName.toLowerCase(); });
	    if (caseSensitiveTags.length) {
	        throw new FormatError("HTML tag must be lowercased but the following tags are not: " + caseSensitiveTags.join(', '));
	    }
	    // We're doing this since top node is `<formatted-message/>` which does not have a formatter
	    return Array.prototype.slice
	        .call(content.childNodes)
	        .reduce(function (all, child) { return all.concat(formatHTMLElement(child, objectParts, values)); }, []);
	}
	exports.formatHTMLMessage = formatHTMLMessage;


/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(2295);
	__export(__webpack_require__(2296));
	__export(__webpack_require__(2295));
	exports.default = core_1.default;


/***/ }),
/* 2298 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Sheets registry to access them all at one place.
	 */
	var SheetsRegistry = function () {
	  function SheetsRegistry() {
	    _classCallCheck(this, SheetsRegistry);
	
	    this.registry = [];
	  }
	
	  _createClass(SheetsRegistry, [{
	    key: 'add',
	
	
	    /**
	     * Register a Style Sheet.
	     */
	    value: function add(sheet) {
	      var registry = this.registry;
	      var index = sheet.options.index;
	
	
	      if (registry.indexOf(sheet) !== -1) return;
	
	      if (registry.length === 0 || index >= this.index) {
	        registry.push(sheet);
	        return;
	      }
	
	      // Find a position.
	      for (var i = 0; i < registry.length; i++) {
	        if (registry[i].options.index > index) {
	          registry.splice(i, 0, sheet);
	          return;
	        }
	      }
	    }
	
	    /**
	     * Reset the registry.
	     */
	
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.registry = [];
	    }
	
	    /**
	     * Remove a Style Sheet.
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(sheet) {
	      var index = this.registry.indexOf(sheet);
	      this.registry.splice(index, 1);
	    }
	
	    /**
	     * Convert all attached sheets to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      return this.registry.filter(function (sheet) {
	        return sheet.attached;
	      }).map(function (sheet) {
	        return sheet.toString(options);
	      }).join('\n');
	    }
	  }, {
	    key: 'index',
	
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	exports['default'] = SheetsRegistry;

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _linkRule = __webpack_require__(2303);
	
	var _linkRule2 = _interopRequireDefault(_linkRule);
	
	var _RuleList = __webpack_require__(725);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StyleSheet = function () {
	  function StyleSheet(styles, options) {
	    _classCallCheck(this, StyleSheet);
	
	    this.attached = false;
	    this.deployed = false;
	    this.linked = false;
	    this.classes = {};
	    this.options = _extends({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes
	    });
	    this.renderer = new options.Renderer(this);
	    this.rules = new _RuleList2['default'](this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  _createClass(StyleSheet, [{
	    key: 'attach',
	    value: function attach() {
	      if (this.attached) return this;
	      if (!this.deployed) this.deploy();
	      this.renderer.attach();
	      if (!this.linked && this.options.link) this.link();
	      this.attached = true;
	      return this;
	    }
	
	    /**
	     * Remove renderable from render tree.
	     */
	
	  }, {
	    key: 'detach',
	    value: function detach() {
	      if (!this.attached) return this;
	      this.renderer.detach();
	      this.attached = false;
	      return this;
	    }
	
	    /**
	     * Add a rule to the current stylesheet.
	     * Will insert a rule also after the stylesheet has been rendered first time.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, decl, options) {
	      var queue = this.queue;
	
	      // Plugins can create rules.
	      // In order to preserve the right order, we need to queue all `.addRule` calls,
	      // which happen after the first `rules.add()` call.
	
	      if (this.attached && !queue) this.queue = [];
	
	      var rule = this.rules.add(name, decl, options);
	      this.options.jss.plugins.onProcessRule(rule);
	
	      if (this.attached) {
	        if (!this.deployed) return rule;
	        // Don't insert rule directly if there is no stringified version yet.
	        // It will be inserted all together when .attach is called.
	        if (queue) queue.push(rule);else {
	          this.insertRule(rule);
	          if (this.queue) {
	            this.queue.forEach(this.insertRule, this);
	            this.queue = undefined;
	          }
	        }
	        return rule;
	      }
	
	      // We can't add rules to a detached style node.
	      // We will redeploy the sheet once user will attach it.
	      this.deployed = false;
	
	      return rule;
	    }
	
	    /**
	     * Insert rule into the StyleSheet
	     */
	
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule) {
	      var renderable = this.renderer.insertRule(rule);
	      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
	    }
	
	    /**
	     * Create and add rules.
	     * Will render also after Style Sheet was rendered the first time.
	     */
	
	  }, {
	    key: 'addRules',
	    value: function addRules(styles, options) {
	      var added = [];
	      for (var name in styles) {
	        added.push(this.addRule(name, styles[name], options));
	      }
	      return added;
	    }
	
	    /**
	     * Get a rule by name.
	     */
	
	  }, {
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Delete a rule by name.
	     * Returns `true`: if rule has been deleted from the DOM.
	     */
	
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(name) {
	      var rule = this.rules.get(name);
	
	      if (!rule) return false;
	
	      this.rules.remove(rule);
	
	      if (this.attached && rule.renderable) {
	        return this.renderer.deleteRule(rule.renderable);
	      }
	
	      return true;
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Deploy pure CSS string to a renderable.
	     */
	
	  }, {
	    key: 'deploy',
	    value: function deploy() {
	      this.renderer.deploy();
	      this.deployed = true;
	      return this;
	    }
	
	    /**
	     * Link renderable CSS rules from sheet with their corresponding models.
	     */
	
	  }, {
	    key: 'link',
	    value: function link() {
	      var cssRules = this.renderer.getRules();
	
	      // Is undefined when VirtualRenderer is used.
	      if (cssRules) this.rules.link(cssRules);
	      this.linked = true;
	      return this;
	    }
	
	    /**
	     * Update the function values with a new data.
	     */
	
	  }, {
	    key: 'update',
	    value: function update(name, data) {
	      this.rules.update(name, data);
	      return this;
	    }
	
	    /**
	     * Convert rules to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      return this.rules.toString(options);
	    }
	  }]);
	
	  return StyleSheet;
	}();
	
	exports['default'] = StyleSheet;

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;
	
	var _getDynamicStyles = __webpack_require__(5382);
	
	Object.defineProperty(exports, 'getDynamicStyles', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getDynamicStyles)['default'];
	  }
	});
	
	var _toCssValue = __webpack_require__(967);
	
	Object.defineProperty(exports, 'toCssValue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_toCssValue)['default'];
	  }
	});
	
	var _SheetsRegistry = __webpack_require__(2298);
	
	Object.defineProperty(exports, 'SheetsRegistry', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SheetsRegistry)['default'];
	  }
	});
	
	var _SheetsManager = __webpack_require__(5369);
	
	Object.defineProperty(exports, 'SheetsManager', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SheetsManager)['default'];
	  }
	});
	
	var _RuleList = __webpack_require__(725);
	
	Object.defineProperty(exports, 'RuleList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RuleList)['default'];
	  }
	});
	
	var _sheets = __webpack_require__(1525);
	
	Object.defineProperty(exports, 'sheets', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_sheets)['default'];
	  }
	});
	
	var _createGenerateClassName = __webpack_require__(2301);
	
	Object.defineProperty(exports, 'createGenerateClassName', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_createGenerateClassName)['default'];
	  }
	});
	
	var _Jss = __webpack_require__(5367);
	
	var _Jss2 = _interopRequireDefault(_Jss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a new instance of Jss.
	 */
	var create = exports.create = function create(options) {
	  return new _Jss2['default'](options);
	};
	
	/**
	 * A global Jss instance.
	 */
	exports['default'] = create();

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _StyleSheet = __webpack_require__(2299);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _moduleId = __webpack_require__(5384);
	
	var _moduleId2 = _interopRequireDefault(_moduleId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var maxRules = 1e10;
	
	
	var env = ("production");
	
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	
	exports['default'] = function () {
	  var ruleCounter = 0;
	  var defaultPrefix = env === 'production' ? 'c' : '';
	
	  return function (rule, sheet) {
	    ruleCounter += 1;
	
	    if (ruleCounter > maxRules) {
	      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
	    }
	
	    var prefix = defaultPrefix;
	    var jssId = '';
	
	    if (sheet) {
	      prefix = sheet.options.classNamePrefix || defaultPrefix;
	      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
	    }
	
	    if (env === 'production') {
	      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
	    }
	
	    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
	  };
	};

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _symbolObservable = __webpack_require__(1050);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (value) {
	  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
	};

/***/ }),
/* 2303 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = linkRule;
	/**
	 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
	 */
	function linkRule(rule, cssRule) {
	  rule.renderable = cssRule;
	  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
	}

/***/ }),
/* 2304 */
[6728, 460, 246],
/* 2305 */
[6732, 246],
/* 2306 */
5819,
/* 2307 */
[6707, 972],
/* 2308 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 2309 */
[6734, 2323, 729, 96, 730, 975, 982],
/* 2310 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 2311 */
5822,
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(726),
	    eq = __webpack_require__(728);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(969),
	    arrayEach = __webpack_require__(2306),
	    assignValue = __webpack_require__(1532),
	    baseAssign = __webpack_require__(5396),
	    baseAssignIn = __webpack_require__(5397),
	    cloneBuffer = __webpack_require__(2326),
	    copyArray = __webpack_require__(1545),
	    copySymbols = __webpack_require__(5440),
	    copySymbolsIn = __webpack_require__(5441),
	    getAllKeys = __webpack_require__(2334),
	    getAllKeysIn = __webpack_require__(1546),
	    getTag = __webpack_require__(574),
	    initCloneArray = __webpack_require__(5462),
	    initCloneByTag = __webpack_require__(5463),
	    initCloneObject = __webpack_require__(2337),
	    isArray = __webpack_require__(96),
	    isBuffer = __webpack_require__(730),
	    isMap = __webpack_require__(5506),
	    isObject = __webpack_require__(139),
	    isSet = __webpack_require__(5508),
	    keys = __webpack_require__(249),
	    keysIn = __webpack_require__(734);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(576);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ }),
/* 2315 */
5825,
/* 2316 */
[6740, 5444],
/* 2317 */
[6743, 970, 96],
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(377),
	    isArrayLike = __webpack_require__(247);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(969),
	    assignMergeValue = __webpack_require__(2312),
	    baseFor = __webpack_require__(2316),
	    baseMergeDeep = __webpack_require__(5420),
	    isObject = __webpack_require__(139),
	    keysIn = __webpack_require__(734),
	    safeGet = __webpack_require__(2343);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(571),
	    baseSet = __webpack_require__(1537),
	    castPath = __webpack_require__(459);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 2321 */
5840,
/* 2322 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ }),
/* 2323 */
5845,
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(5493);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 2325 */
[6765, 972],
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(246);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)(module)))

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1544);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 2328 */
[6710, 5390, 5395, 175, 96],
/* 2329 */
[6768, 572, 575],
/* 2330 */
[6770, 460],
/* 2331 */
[6712, 1529, 2311, 1541],
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(2350),
	    overRest = __webpack_require__(2341),
	    setToString = __webpack_require__(2344);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 2333 */
2696,
/* 2334 */
[6774, 2317, 1548, 249],
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(970),
	    getPrototype = __webpack_require__(1547),
	    getSymbols = __webpack_require__(1548),
	    stubArray = __webpack_require__(2354);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 2336 */
[6781, 459, 729, 96, 975, 1557, 461],
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(5399),
	    getPrototype = __webpack_require__(1547),
	    isPrototype = __webpack_require__(976);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 2338 */
[6789, 139],
/* 2339 */
2699,
/* 2340 */
2873,
/* 2341 */
[6803, 1530],
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(571),
	    baseSlice = __webpack_require__(1538);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 2343 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 2344 */
[6805, 5427, 5484],
/* 2345 */
2700,
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(2313);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(970),
	    baseFlatten = __webpack_require__(570),
	    copyArray = __webpack_require__(1545),
	    isArray = __webpack_require__(96);
	
	/**
	 * Creates a new array concatenating `array` with any additional arrays
	 * and/or values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to concatenate.
	 * @param {...*} [values] The values to concatenate.
	 * @returns {Array} Returns the new concatenated array.
	 * @example
	 *
	 * var array = [1];
	 * var other = _.concat(array, 2, [3], [[4]]);
	 *
	 * console.log(other);
	 * // => [1, 2, 3, [4]]
	 *
	 * console.log(array);
	 * // => [1]
	 */
	function concat() {
	  var length = arguments.length;
	  if (!length) {
	    return [];
	  }
	  var args = Array(length - 1),
	      array = arguments[0],
	      index = length;
	
	  while (index--) {
	    args[index - 1] = arguments[index];
	  }
	  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	}
	
	module.exports = concat;


/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

	var baseConformsTo = __webpack_require__(5398),
	    keys = __webpack_require__(249);
	
	/**
	 * Checks if `object` conforms to `source` by invoking the predicate
	 * properties of `source` with the corresponding property values of `object`.
	 *
	 * **Note:** This method is equivalent to `_.conforms` when `source` is
	 * partially applied.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.14.0
	 * @category Lang
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property predicates to conform to.
	 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 *
	 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	 * // => true
	 *
	 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	 * // => false
	 */
	function conformsTo(object, source) {
	  return source == null || baseConformsTo(object, source, keys(source));
	}
	
	module.exports = conformsTo;


/***/ }),
/* 2349 */,
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(570);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 2351 */
6456,
/* 2352 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeJoin = arrayProto.join;
	
	/**
	 * Converts all elements in `array` into a string separated by `separator`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to convert.
	 * @param {string} [separator=','] The element separator.
	 * @returns {string} Returns the joined string.
	 * @example
	 *
	 * _.join(['a', 'b', 'c'], '~');
	 * // => 'a~b~c'
	 */
	function join(array, separator) {
	  return array == null ? '' : nativeJoin.call(array, separator);
	}
	
	module.exports = join;


/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(973),
	    upperFirst = __webpack_require__(147);
	
	/**
	 * Converts `string` to
	 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.1.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the start cased string.
	 * @example
	 *
	 * _.startCase('--foo-bar--');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('fooBar');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('__FOO_BAR__');
	 * // => 'FOO BAR'
	 */
	var startCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + upperFirst(word);
	});
	
	module.exports = startCase;


/***/ }),
/* 2354 */
5918,
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(176),
	    isObject = __webpack_require__(139);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 2356 */
[6827, 2357],
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(2324),
	    isObject = __webpack_require__(139),
	    isSymbol = __webpack_require__(576);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1539),
	    castSlice = __webpack_require__(1543),
	    charsStartIndex = __webpack_require__(2325),
	    stringToArray = __webpack_require__(1553),
	    toString = __webpack_require__(468);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * Removes leading whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trimStart('  abc  ');
	 * // => 'abc  '
	 *
	 * _.trimStart('-_-abc-_-', '_-');
	 * // => 'abc-_-'
	 */
	function trimStart(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrimStart, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      start = charsStartIndex(strSymbols, stringToArray(chars));
	
	  return castSlice(strSymbols, start).join('');
	}
	
	module.exports = trimStart;


/***/ }),
/* 2359 */
[6831, 5432, 249],
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	var _Paper = __webpack_require__(279);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent Paper
	
	var styles = exports.styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box', // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionSticky: {
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	    positionStatic: {
	      position: 'static'
	    },
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    }
	  };
	};
	
	function AppBar(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      position = props.position,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'position']);
	
	
	  var className = (0, _classnames2.default)(classes.root, classes['position' + (0, _helpers.capitalize)(position)], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), (0, _defineProperty3.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    (0, _extends3.default)({ square: true, component: 'header', elevation: 4, className: className }, other),
	    children
	  );
	}
	
	AppBar.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes2.default.oneOf(['inherit', 'primary', 'secondary', 'default']),
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes2.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
	} : {};
	
	AppBar.defaultProps = {
	  color: 'primary',
	  position: 'fixed'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiAppBar' })(AppBar);

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE11.
	      objectFit: 'cover'
	    }
	  };
	};
	
	function Avatar(props) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties3.default)(props, ['alt', 'children', 'childrenClassName', 'classes', 'className', 'component', 'imgProps', 'sizes', 'src', 'srcSet']);
	
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
	  var children = null;
	
	  if (childrenProp) {
	    if (childrenClassNameProp && typeof childrenProp !== 'string' && _react2.default.isValidElement(childrenProp)) {
	      var childrenClassName = (0, _classnames2.default)(childrenClassNameProp, childrenProp.props.className);
	      children = _react2.default.cloneElement(childrenProp, { className: childrenClassName });
	    } else {
	      children = childrenProp;
	    }
	  } else if (src || srcSet) {
	    children = _react2.default.createElement('img', (0, _extends3.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  }
	
	  return _react2.default.createElement(
	    Component,
	    (0, _extends3.default)({ className: className }, other),
	    children
	  );
	}
	
	Avatar.propTypes =  false ? {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes2.default.string,
	  /**
	   * Used to render icon or text elements inside the Avatar.
	   * `src` and `alt` props will not be used and no `img` will
	   * be rendered by default.
	   *
	   * This can be an element, or just a string.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   * The className of the child element.
	   * Used by Chip and ListItemIcon to style the Avatar icon.
	   */
	  childrenClassName: _propTypes2.default.string,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Properties applied to the `img` element when the component
	   * is used to display an image.
	   */
	  imgProps: _propTypes2.default.object,
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes2.default.string,
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes2.default.string,
	  /**
	   * The `srcSet` attribute for the `img` element.
	   */
	  srcSet: _propTypes2.default.string
	} : {};
	
	Avatar.defaultProps = {
	  component: 'div'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiAvatar' })(Avatar);

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(5533);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Drawer = __webpack_require__(5557);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Drawer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Input = __webpack_require__(1564);
	
	var _helpers = __webpack_require__(127);
	
	var _reactHelpers = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-flex',
	      flexDirection: 'column',
	      position: 'relative',
	      // Reset fieldset default style
	      minWidth: 0,
	      padding: 0,
	      margin: 0,
	      border: 0
	    },
	    marginNormal: {
	      marginTop: theme.spacing.unit * 2,
	      marginBottom: theme.spacing.unit
	    },
	    marginDense: {
	      marginTop: theme.spacing.unit,
	      marginBottom: theme.spacing.unit / 2
	    },
	    fullWidth: {
	      width: '100%'
	    }
	  };
	};
	
	/**
	 * Provides context such as dirty/focused/error/required for form inputs.
	 * Relying on the context provides high flexibilty and ensures that the state always stay
	 * consitent across the children of the `FormControl`.
	 * This context is used by the following components:
	 *  - FormLabel
	 *  - FormHelperText
	 *  - Input
	 *  - InputLabel
	 */
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3.default)(FormControl, _React$Component);
	
	  function FormControl(props, context) {
	    (0, _classCallCheck3.default)(this, FormControl);
	
	    // We need to iterate through the children and find the Input in order
	    // to fully support server side rendering.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FormControl.__proto__ || (0, _getPrototypeOf2.default)(FormControl)).call(this, props, context));
	
	    _this.state = {
	      adornedStart: false,
	      dirty: false,
	      focused: false
	    };
	
	    _this.handleFocus = function (event) {
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	      _this.setState(function (state) {
	        return !state.focused ? { focused: true } : null;
	      });
	    };
	
	    _this.handleBlur = function (event) {
	      // The event might be undefined.
	      // For instance, a child component might call this hook
	      // when an input is disabled but still having the focus.
	      if (_this.props.onBlur && event) {
	        _this.props.onBlur(event);
	      }
	      _this.setState(function (state) {
	        return state.focused ? { focused: false } : null;
	      });
	    };
	
	    _this.handleDirty = function () {
	      if (!_this.state.dirty) {
	        _this.setState({ dirty: true });
	      }
	    };
	
	    _this.handleClean = function () {
	      if (_this.state.dirty) {
	        _this.setState({ dirty: false });
	      }
	    };
	
	    var children = _this.props.children;
	
	    if (children) {
	      _react2.default.Children.forEach(children, function (child) {
	        if ((0, _reactHelpers.isMuiElement)(child, ['Input', 'Select']) && (0, _Input.isDirty)(child.props, true)) {
	          _this.state.dirty = true;
	        }
	        if ((0, _reactHelpers.isMuiElement)(child, ['Input']) && (0, _Input.isAdornedStart)(child.props)) {
	          _this.state.adornedStart = true;
	        }
	      });
	    }
	    return _this;
	  }
	
	  (0, _createClass3.default)(FormControl, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          error = _props.error,
	          required = _props.required,
	          margin = _props.margin;
	      var _state = this.state,
	          adornedStart = _state.adornedStart,
	          dirty = _state.dirty,
	          focused = _state.focused;
	
	
	      return {
	        muiFormControl: {
	          adornedStart: adornedStart,
	          dirty: dirty,
	          disabled: disabled,
	          error: error,
	          focused: focused,
	          margin: margin,
	          required: required,
	          onDirty: this.handleDirty,
	          onClean: this.handleClean,
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props2 = this.props,
	          classes = _props2.classes,
	          className = _props2.className,
	          Component = _props2.component,
	          disabled = _props2.disabled,
	          error = _props2.error,
	          fullWidth = _props2.fullWidth,
	          margin = _props2.margin,
	          required = _props2.required,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['classes', 'className', 'component', 'disabled', 'error', 'fullWidth', 'margin', 'required']);
	
	
	      return _react2.default.createElement(Component, (0, _extends3.default)({
	        className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['margin' + (0, _helpers.capitalize)(margin)], margin !== 'none'), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
	      }, other, {
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur
	      }));
	    }
	  }]);
	  return FormControl;
	}(_react2.default.Component);
	
	FormControl.propTypes =  false ? {
	  /**
	   * The contents of the form control.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the label, input and helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * If `true`, the component will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes2.default.oneOf(['none', 'dense', 'normal']),
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes2.default.bool
	} : {};
	
	FormControl.defaultProps = {
	  component: 'div',
	  disabled: false,
	  error: false,
	  fullWidth: false,
	  margin: 'none',
	  required: false
	};
	
	FormControl.childContextTypes = {
	  muiFormControl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormControl' })(FormControl);

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    flexWrap: 'wrap'
	  },
	  row: {
	    flexDirection: 'row'
	  }
	};
	
	/**
	 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
	 * It provides compact row layout.
	 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
	 */
	function FormGroup(props) {
	  var classes = props.classes,
	      className = props.className,
	      children = props.children,
	      row = props.row,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'children', 'row']);
	
	  var rootClassName = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.row, row), className);
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: rootClassName }, other),
	    children
	  );
	}
	
	FormGroup.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Display group of elements in a compact row.
	   */
	  row: _propTypes2.default.bool
	} : {};
	
	FormGroup.defaultProps = {
	  row: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormGroup' })(FormGroup);

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      color: theme.palette.text.secondary,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(12),
	      textAlign: 'left',
	      marginTop: theme.spacing.unit,
	      lineHeight: '1em',
	      minHeight: '1em',
	      margin: 0
	    },
	    dense: {
	      marginTop: theme.spacing.unit / 2
	    },
	    error: {
	      color: theme.palette.error.main
	    },
	    disabled: {
	      color: theme.palette.text.disabled
	    }
	  };
	};
	
	function FormHelperText(props, context) {
	  var _classNames;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      disabledProp = props.disabled,
	      errorProp = props.error,
	      marginProp = props.margin,
	      Component = props.component,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'disabled', 'error', 'margin', 'component']);
	  var muiFormControl = context.muiFormControl;
	
	
	  var disabled = disabledProp;
	  var error = errorProp;
	  var margin = marginProp;
	
	  if (muiFormControl) {
	    if (typeof disabled === 'undefined') {
	      disabled = muiFormControl.disabled;
	    }
	
	    if (typeof error === 'undefined') {
	      error = muiFormControl.error;
	    }
	
	    if (typeof margin === 'undefined') {
	      margin = muiFormControl.margin;
	    }
	  }
	
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), (0, _defineProperty3.default)(_classNames, classes.dense, margin === 'dense'), _classNames), classNameProp);
	
	  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
	}
	
	FormHelperText.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, helper text should be displayed in an error state.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes2.default.oneOf(['dense'])
	} : {};
	
	FormHelperText.defaultProps = {
	  component: 'p'
	};
	
	FormHelperText.contextTypes = {
	  muiFormControl: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormHelperText' })(FormHelperText);

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormGroup = __webpack_require__(2365);
	
	Object.defineProperty(exports, 'FormGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormGroup).default;
	  }
	});
	
	var _FormLabel = __webpack_require__(5564);
	
	Object.defineProperty(exports, 'FormLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormLabel).default;
	  }
	});
	
	var _FormControl = __webpack_require__(2364);
	
	Object.defineProperty(exports, 'FormControl', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormControl).default;
	  }
	});
	
	var _FormHelperText = __webpack_require__(2366);
	
	Object.defineProperty(exports, 'FormHelperText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormHelperText).default;
	  }
	});
	
	var _FormControlLabel = __webpack_require__(5563);
	
	Object.defineProperty(exports, 'FormControlLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormControlLabel).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Hidden = __webpack_require__(5571);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hidden).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ButtonBase = __webpack_require__(278);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	var _reactHelpers = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left'
	    },
	    container: {
	      position: 'relative'
	    },
	    keyboardFocused: {
	      backgroundColor: theme.palette.action.hover
	    },
	    default: {
	      paddingTop: 12,
	      paddingBottom: 12
	    },
	    dense: {
	      paddingTop: theme.spacing.unit,
	      paddingBottom: theme.spacing.unit
	    },
	    disabled: {
	      opacity: 0.5
	    },
	    divider: {
	      borderBottom: '1px solid ' + theme.palette.divider,
	      backgroundClip: 'padding-box'
	    },
	    gutters: {
	      paddingLeft: theme.spacing.unit * 2,
	      paddingRight: theme.spacing.unit * 2
	    },
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positionned.
	      paddingRight: theme.spacing.unit * 4
	    }
	  };
	};
	
	var ListItem = function (_React$Component) {
	  (0, _inherits3.default)(ListItem, _React$Component);
	
	  function ListItem() {
	    (0, _classCallCheck3.default)(this, ListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense || this.context.dense || false
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          button = _props.button,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          componentProp = _props.component,
	          ContainerComponent = _props.ContainerComponent,
	          ContainerProps = _props.ContainerProps,
	          dense = _props.dense,
	          disabled = _props.disabled,
	          disableGutters = _props.disableGutters,
	          divider = _props.divider,
	          other = (0, _objectWithoutProperties3.default)(_props, ['button', 'children', 'classes', 'className', 'component', 'ContainerComponent', 'ContainerProps', 'dense', 'disabled', 'disableGutters', 'divider']);
	
	
	      var isDense = dense || this.context.dense || false;
	      var children = _react2.default.Children.toArray(childrenProp);
	      var hasAvatar = children.some(function (value) {
	        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
	      });
	      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
	
	      var className = (0, _classnames2.default)(classes.root, isDense || hasAvatar ? classes.dense : classes.default, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty3.default)(_classNames, classes.divider, divider), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.button, button), (0, _defineProperty3.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
	
	      var componentProps = (0, _extends3.default)({ className: className, disabled: disabled }, other);
	      var Component = componentProp || 'li';
	
	      if (button) {
	        componentProps.component = componentProp || 'div';
	        componentProps.keyboardFocusedClassName = classes.keyboardFocused;
	        Component = _ButtonBase2.default;
	      }
	
	      if (hasSecondaryAction) {
	        Component = Component !== _ButtonBase2.default && !componentProp ? 'div' : Component;
	
	        return _react2.default.createElement(
	          ContainerComponent,
	          (0, _extends3.default)({ className: classes.container }, ContainerProps),
	          _react2.default.createElement(
	            Component,
	            componentProps,
	            children
	          ),
	          children.pop()
	        );
	      }
	
	      return _react2.default.createElement(
	        Component,
	        componentProps,
	        children
	      );
	    }
	  }]);
	  return ListItem;
	}(_react2.default.Component);
	
	ListItem.propTypes =  false ? {
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`).
	   */
	  button: _propTypes2.default.bool,
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * The container component. Useful when a `ListItemSecondaryAction` is rendered.
	   */
	  ContainerComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Properties applied to the container element when the component
	   * is used to display a `ListItemSecondaryAction`.
	   */
	  ContainerProps: _propTypes2.default.object,
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes2.default.bool,
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes2.default.bool
	} : {};
	
	ListItem.defaultProps = {
	  button: false,
	  ContainerComponent: 'li',
	  dense: false,
	  disabled: false,
	  disableGutters: false,
	  divider: false
	};
	
	ListItem.contextTypes = {
	  dense: _propTypes2.default.bool
	};
	
	ListItem.childContextTypes = {
	  dense: _propTypes2.default.bool
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItem' })(ListItem);

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(5580);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	var _ListItem = __webpack_require__(2369);
	
	Object.defineProperty(exports, 'ListItem', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItem).default;
	  }
	});
	
	var _ListItemAvatar = __webpack_require__(5581);
	
	Object.defineProperty(exports, 'ListItemAvatar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItemAvatar).default;
	  }
	});
	
	var _ListItemText = __webpack_require__(5584);
	
	Object.defineProperty(exports, 'ListItemText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItemText).default;
	  }
	});
	
	var _ListItemIcon = __webpack_require__(5582);
	
	Object.defineProperty(exports, 'ListItemIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItemIcon).default;
	  }
	});
	
	var _ListItemSecondaryAction = __webpack_require__(5583);
	
	Object.defineProperty(exports, 'ListItemSecondaryAction', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListItemSecondaryAction).default;
	  }
	});
	
	var _ListSubheader = __webpack_require__(5585);
	
	Object.defineProperty(exports, 'ListSubheader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ListSubheader).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _scrollbarSize = __webpack_require__(952);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Popover = __webpack_require__(250);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _MenuList = __webpack_require__(2372);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RTL_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'right'
	}; // @inheritedComponent Popover
	
	var LTR_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	
	var styles = exports.styles = {
	  paper: {
	    // specZ: The maximum height of a simple menu should be one or more rows less than the view
	    // height. This ensures a tappable area outside of the simple menu with which to dismiss
	    // the menu.
	    maxHeight: 'calc(100vh - 96px)',
	    // Add iOS momentum scrolling.
	    WebkitOverflowScrolling: 'touch'
	  }
	};
	
	var Menu = function (_React$Component) {
	  (0, _inherits3.default)(Menu, _React$Component);
	
	  function Menu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Menu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.getContentAnchorEl = function () {
	      if (!_this.menuList || !_this.menuList.selectedItem) {
	        return (0, _reactDom.findDOMNode)(_this.menuList).firstChild;
	      }
	
	      return (0, _reactDom.findDOMNode)(_this.menuList.selectedItem);
	    }, _this.menuList = undefined, _this.focus = function () {
	      if (_this.menuList && _this.menuList.selectedItem) {
	        (0, _reactDom.findDOMNode)(_this.menuList.selectedItem).focus();
	        return;
	      }
	
	      var menuList = (0, _reactDom.findDOMNode)(_this.menuList);
	      if (menuList && menuList.firstChild) {
	        menuList.firstChild.focus();
	      }
	    }, _this.handleEnter = function (element) {
	      var theme = _this.props.theme;
	
	      var menuList = (0, _reactDom.findDOMNode)(_this.menuList);
	
	      // Focus so the scroll computation of the Popover works as expected.
	      _this.focus();
	
	      // Let's ignore that piece of logic if users are already overriding the width
	      // of the menu.
	      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
	        var size = (0, _scrollbarSize2.default)() + 'px';
	        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
	        menuList.style.width = 'calc(100% + ' + size + ')';
	      }
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(element);
	      }
	    }, _this.handleListKeyDown = function (event, key) {
	      if (key === 'tab') {
	        event.preventDefault();
	
	        if (_this.props.onClose) {
	          _this.props.onClose(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          MenuListProps = _props.MenuListProps,
	          onEnter = _props.onEnter,
	          _props$PaperProps = _props.PaperProps,
	          PaperProps = _props$PaperProps === undefined ? {} : _props$PaperProps,
	          PopoverClasses = _props.PopoverClasses,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'MenuListProps', 'onEnter', 'PaperProps', 'PopoverClasses', 'theme']);
	
	
	      return _react2.default.createElement(
	        _Popover2.default,
	        (0, _extends3.default)({
	          getContentAnchorEl: this.getContentAnchorEl,
	          classes: PopoverClasses,
	          onEnter: this.handleEnter,
	          anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	          transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	          PaperProps: (0, _extends3.default)({}, PaperProps, {
	            classes: (0, _extends3.default)({}, PaperProps.classes, {
	              root: classes.paper
	            })
	          })
	        }, other),
	        _react2.default.createElement(
	          _MenuList2.default,
	          (0, _extends3.default)({
	            role: 'menu',
	            onKeyDown: this.handleListKeyDown
	          }, MenuListProps, {
	            ref: function ref(node) {
	              _this2.menuList = node;
	            }
	          }),
	          children
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react2.default.Component);
	
	Menu.propTypes =  false ? {
	  /**
	   * The DOM element used to set the position of the menu.
	   */
	  anchorEl: _propTypes2.default.object,
	  /**
	   * Menu contents, normally `MenuItem`s.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * Properties applied to the `MenuList` element.
	   */
	  MenuListProps: _propTypes2.default.object,
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Callback fired before the Menu enters.
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired when the Menu has entered.
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired when the Menu is entering.
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired before the Menu exits.
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired when the Menu has exited.
	   */
	  onExited: _propTypes2.default.func,
	  /**
	   * Callback fired when the Menu is exiting.
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * If `true`, the menu is visible.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes2.default.object,
	  /**
	   * `classes` property applied to the `Popover` element.
	   */
	  PopoverClasses: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * The length of the transition in `ms`, or 'auto'
	   */
	  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
	} : {};
	
	Menu.defaultProps = {
	  transitionDuration: 'auto'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMenu', withTheme: true })(Menu);

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _keycode = __webpack_require__(568);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _contains = __webpack_require__(950);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _activeElement = __webpack_require__(2236);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _ownerDocument = __webpack_require__(372);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _List = __webpack_require__(2370);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent List
	
	var MenuList = function (_React$Component) {
	  (0, _inherits3.default)(MenuList, _React$Component);
	
	  function MenuList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuList.__proto__ || (0, _getPrototypeOf2.default)(MenuList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      currentTabIndex: undefined
	    }, _this.list = undefined, _this.selectedItem = undefined, _this.blurTimer = undefined, _this.handleBlur = function (event) {
	      _this.blurTimer = setTimeout(function () {
	        if (_this.list) {
	          var list = (0, _reactDom.findDOMNode)(_this.list);
	          var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));
	          if (!(0, _contains2.default)(list, currentFocus)) {
	            _this.resetTabIndex();
	          }
	        }
	      }, 30);
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var list = (0, _reactDom.findDOMNode)(_this.list);
	      var key = (0, _keycode2.default)(event);
	      var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));
	
	      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !(0, _contains2.default)(list, currentFocus))) {
	        if (_this.selectedItem) {
	          (0, _reactDom.findDOMNode)(_this.selectedItem).focus();
	        } else {
	          list.firstChild.focus();
	        }
	      } else if (key === 'down') {
	        event.preventDefault();
	        if (currentFocus.nextElementSibling) {
	          currentFocus.nextElementSibling.focus();
	        }
	      } else if (key === 'up') {
	        event.preventDefault();
	        if (currentFocus.previousElementSibling) {
	          currentFocus.previousElementSibling.focus();
	        }
	      }
	
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(event, key);
	      }
	    }, _this.handleItemFocus = function (event) {
	      var list = (0, _reactDom.findDOMNode)(_this.list);
	      if (list) {
	        for (var i = 0; i < list.children.length; i += 1) {
	          if (list.children[i] === event.currentTarget) {
	            _this.setTabIndex(i);
	            break;
	          }
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.resetTabIndex();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.blurTimer);
	    }
	  }, {
	    key: 'setTabIndex',
	    value: function setTabIndex(index) {
	      this.setState({ currentTabIndex: index });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var currentTabIndex = this.state.currentTabIndex;
	
	      var list = (0, _reactDom.findDOMNode)(this.list);
	      if (!list || !list.children || !list.firstChild) {
	        return;
	      }
	
	      if (currentTabIndex && currentTabIndex >= 0) {
	        list.children[currentTabIndex].focus();
	      } else {
	        list.firstChild.focus();
	      }
	    }
	  }, {
	    key: 'resetTabIndex',
	    value: function resetTabIndex() {
	      var list = (0, _reactDom.findDOMNode)(this.list);
	      var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));
	      var items = [].concat((0, _toConsumableArray3.default)(list.children));
	      var currentFocusIndex = items.indexOf(currentFocus);
	
	      if (currentFocusIndex !== -1) {
	        return this.setTabIndex(currentFocusIndex);
	      }
	
	      if (this.selectedItem) {
	        return this.setTabIndex(items.indexOf((0, _reactDom.findDOMNode)(this.selectedItem)));
	      }
	
	      return this.setTabIndex(0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onBlur = _props.onBlur,
	          onKeyDown = _props.onKeyDown,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onBlur', 'onKeyDown']);
	
	
	      return _react2.default.createElement(
	        _List2.default,
	        (0, _extends3.default)({
	          role: 'menu',
	          ref: function ref(node) {
	            _this2.list = node;
	          },
	          className: className,
	          onKeyDown: this.handleKeyDown,
	          onBlur: this.handleBlur
	        }, other),
	        _react2.default.Children.map(children, function (child, index) {
	          if (!_react2.default.isValidElement(child)) {
	            return null;
	          }
	
	          return _react2.default.cloneElement(child, {
	            tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
	            ref: child.props.selected ? function (node) {
	              _this2.selectedItem = node;
	            } : undefined,
	            onFocus: _this2.handleItemFocus
	          });
	        })
	      );
	    }
	  }]);
	  return MenuList;
	}(_react2.default.Component);
	
	MenuList.propTypes =  false ? {
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes2.default.func
	} : {};
	
	exports.default = MenuList;

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Fade = __webpack_require__(1573);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  root: {
	    zIndex: -1,
	    width: '100%',
	    height: '100%',
	    position: 'fixed',
	    top: 0,
	    left: 0,
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    willChange: 'opacity',
	    backgroundColor: 'rgba(0, 0, 0, 0.5)'
	  },
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	
	function Backdrop(props) {
	  var classes = props.classes,
	      invisible = props.invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'invisible', 'open', 'transitionDuration']);
	
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.invisible, invisible));
	
	  return _react2.default.createElement(
	    _Fade2.default,
	    (0, _extends3.default)({ appear: true, 'in': open, timeout: transitionDuration }, other),
	    _react2.default.createElement('div', { className: className, 'aria-hidden': 'true' })
	  );
	}
	
	Backdrop.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes2.default.bool,
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
	} : {};
	
	Backdrop.defaultProps = {
	  invisible: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBackdrop' })(Backdrop);

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _style = __webpack_require__(4880);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(952);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(5590);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(5591);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function findIndexOf(data, callback) {
	  var idx = -1;
	  data.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	    return false;
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (item) {
	    return item.modals.indexOf(modal) !== -1;
	  });
	}
	
	function getPaddingRight(node) {
	  return parseInt((0, _style2.default)(node, 'paddingRight') || 0, 10);
	}
	
	function setContainerStyle(data, container) {
	  var style = { overflow: 'hidden' };
	
	  // We are only interested in the actual `style` here because we will override it.
	  data.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (data.overflowing) {
	    var scrollbarSize = (0, _scrollbarSize2.default)();
	
	    // Use computed style, here to get the real padding to add our scrollbar width.
	    style.paddingRight = getPaddingRight(container) + scrollbarSize + 'px';
	
	    // .mui-fixed is a global helper.
	    var fixedNodes = document.querySelectorAll('.mui-fixed');
	    for (var i = 0; i < fixedNodes.length; i += 1) {
	      var paddingRight = getPaddingRight(fixedNodes[i]);
	      data.prevPaddings.push(paddingRight);
	      fixedNodes[i].style.paddingRight = paddingRight + scrollbarSize + 'px';
	    }
	  }
	
	  (0, _keys2.default)(style).forEach(function (key) {
	    container.style[key] = style[key];
	  });
	}
	
	function removeContainerStyle(data, container) {
	  (0, _keys2.default)(data.style).forEach(function (key) {
	    container.style[key] = data.style[key];
	  });
	
	  var fixedNodes = document.querySelectorAll('.mui-fixed');
	  for (var i = 0; i < fixedNodes.length; i += 1) {
	    fixedNodes[i].style.paddingRight = data.prevPaddings[i] + 'px';
	  }
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state managment for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$hideSiblingNodes = _ref.hideSiblingNodes,
	      hideSiblingNodes = _ref$hideSiblingNodes === undefined ? true : _ref$hideSiblingNodes,
	      _ref$handleContainerO = _ref.handleContainerOverflow,
	      handleContainerOverflow = _ref$handleContainerO === undefined ? true : _ref$handleContainerO;
	
	  (0, _classCallCheck3.default)(this, ModalManager);
	
	  this.add = function (modal, container) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      overflowing: (0, _isOverflowing2.default)(container),
	      prevPaddings: []
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return modalIdx;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	    _this.modals.splice(modalIdx, 1);
	
	    // If that was the last modal in a container, clean up the container.
	    if (data.modals.length === 0) {
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      // Otherwise make sure the next top modal is visible to a SR.
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	
	    return modalIdx;
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  // this.modals[modalIdx] = modal
	  this.modals = [];
	  // this.containers[containerIdx] = container
	  this.containers = [];
	  // this.data[containerIdx] = {
	  //   modals: [],
	  // }
	  this.data = [];
	};
	
	exports.default = ModalManager;

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(5595);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(5594);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactDom2.default.createPortal ? _Portal2.default : _LegacyPortal2.default;

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CircularProgress = __webpack_require__(5596);
	
	Object.defineProperty(exports, 'CircularProgress', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CircularProgress).default;
	  }
	});
	
	var _LinearProgress = __webpack_require__(579);
	
	Object.defineProperty(exports, 'LinearProgress', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinearProgress).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SelectInput = __webpack_require__(5602);
	
	var _SelectInput2 = _interopRequireDefault(_SelectInput);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Input = __webpack_require__(991);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Import to enforce the CSS injection order
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      width: '100%'
	    },
	    select: {
	      '-moz-appearance': 'none', // Reset
	      '-webkit-appearance': 'none', // Reset
	      // When interacting quickly, the text can end up selected.
	      // Native select can't be selected either.
	      userSelect: 'none',
	      paddingRight: theme.spacing.unit * 4,
	      width: 'calc(100% - ' + theme.spacing.unit * 4 + 'px)',
	      minWidth: theme.spacing.unit * 2, // So it doesn't collapse.
	      cursor: 'pointer',
	      '&:focus': {
	        // Show that it's not an text input
	        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
	        borderRadius: 0 // Reset Chrome style
	      },
	      // Remove Firefox focus border
	      '&:-moz-focusring': {
	        color: 'transparent',
	        textShadow: '0 0 0 #000'
	      },
	      // Remove IE11 arrow
	      '&::-ms-expand': {
	        display: 'none'
	      }
	    },
	    selectMenu: {
	      width: 'auto', // Fix Safari textOverflow
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      minHeight: '1.1875em', // Reset (19px), match the native input line-height
	      lineHeight: '1.1875em' // Reset (19px), match the native input line-height
	    },
	    disabled: {
	      cursor: 'default'
	    },
	    icon: {
	      // We use a position absolute over a flexbox in order to forward the pointer events
	      // to the input.
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 12px)', // Center vertically
	      color: theme.palette.action.active,
	      'pointer-events': 'none' // Don't block pointer events on the select under the icon.
	    }
	  };
	}; // @inheritedComponent Input
	
	function Select(props) {
	  var autoWidth = props.autoWidth,
	      children = props.children,
	      classes = props.classes,
	      displayEmpty = props.displayEmpty,
	      input = props.input,
	      inputProps = props.inputProps,
	      MenuProps = props.MenuProps,
	      multiple = props.multiple,
	      native = props.native,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      renderValue = props.renderValue,
	      other = (0, _objectWithoutProperties3.default)(props, ['autoWidth', 'children', 'classes', 'displayEmpty', 'input', 'inputProps', 'MenuProps', 'multiple', 'native', 'onClose', 'onOpen', 'open', 'renderValue']);
	
	
	  return _react2.default.cloneElement(input, (0, _extends3.default)({
	    // Most of the logic is implemented in `SelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: _SelectInput2.default
	  }, other, {
	    inputProps: (0, _extends3.default)({}, inputProps, input ? input.props.inputProps : {}, {
	      autoWidth: autoWidth,
	      children: children,
	      classes: classes,
	      displayEmpty: displayEmpty,
	      MenuProps: MenuProps,
	      multiple: multiple,
	      native: native,
	      onClose: onClose,
	      onOpen: onOpen,
	      open: open,
	      renderValue: renderValue
	    })
	  }));
	}
	
	Select.propTypes =  false ? {
	  /**
	   * If true, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  displayEmpty: _propTypes2.default.bool,
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes2.default.element,
	  /**
	   * Properties applied to the `input` element.
	   * When `native` is `true`, the properties are applied on the `select` element.
	   */
	  inputProps: _propTypes2.default.object,
	  /**
	   * Properties applied to the `Menu` element.
	   */
	  MenuProps: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support multiple selections.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback
	   * @param {object} child The react element that was selected
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback fired when the component requests to be closed.
	   * Useful in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Callback fired when the component requests to be opened.
	   * Useful in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback
	   */
	  onOpen: _propTypes2.default.func,
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  renderValue: _propTypes2.default.func,
	  /**
	   * The input value, required for a controlled component.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
	} : {};
	
	Select.defaultProps = {
	  autoWidth: false,
	  displayEmpty: false,
	  input: _react2.default.createElement(_Input2.default, null),
	  multiple: false,
	  native: false
	};
	
	Select.muiName = 'Select';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSelect' })(Select);

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Select = __webpack_require__(2377);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Select).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Paper = __webpack_require__(279);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Typography = __webpack_require__(326);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _colorManipulator = __webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  var _root;
	
	  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
	  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
	
	  return {
	    root: (_root = {
	      pointerEvents: 'initial',
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      display: 'flex',
	      alignItems: 'center',
	      flexWrap: 'wrap',
	      padding: '6px ' + theme.spacing.unit * 3 + 'px'
	    }, (0, _defineProperty3.default)(_root, theme.breakpoints.up('md'), {
	      minWidth: 288,
	      maxWidth: 568,
	      borderRadius: 2
	    }), (0, _defineProperty3.default)(_root, theme.breakpoints.down('sm'), {
	      flexGrow: 1
	    }), _root),
	    message: {
	      padding: theme.spacing.unit + 'px 0'
	    },
	    action: {
	      display: 'flex',
	      alignItems: 'center',
	      marginLeft: 'auto',
	      paddingLeft: theme.spacing.unit * 3,
	      marginRight: -theme.spacing.unit
	    }
	  };
	}; // @inheritedComponent Paper
	
	function SnackbarContent(props) {
	  var action = props.action,
	      classes = props.classes,
	      className = props.className,
	      message = props.message,
	      other = (0, _objectWithoutProperties3.default)(props, ['action', 'classes', 'className', 'message']);
	
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    (0, _extends3.default)({
	      component: _Typography2.default,
	      headlineMapping: {
	        body1: 'div'
	      },
	      role: 'alertdialog',
	      square: true,
	      elevation: 6,
	      className: (0, _classnames2.default)(classes.root, className)
	    }, other),
	    _react2.default.createElement(
	      'div',
	      { className: classes.message },
	      message
	    ),
	    action ? _react2.default.createElement(
	      'div',
	      { className: classes.action },
	      action
	    ) : null
	  );
	}
	
	SnackbarContent.propTypes =  false ? {
	  /**
	   * The action to display.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The message to display.
	   */
	  message: _propTypes2.default.node
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSnackbarContent' })(SnackbarContent);

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _CheckCircle = __webpack_require__(5654);
	
	var _CheckCircle2 = _interopRequireDefault(_CheckCircle);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _StepPositionIcon = __webpack_require__(5609);
	
	var _StepPositionIcon2 = _interopRequireDefault(_StepPositionIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'block'
	    },
	    completed: {
	      color: theme.palette.primary.main
	    }
	  };
	};
	
	function StepIcon(props) {
	  var completed = props.completed,
	      icon = props.icon,
	      active = props.active,
	      classes = props.classes;
	
	
	  if (typeof icon === 'number' || typeof icon === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_CheckCircle2.default, { className: (0, _classnames2.default)(classes.root, classes.completed) });
	    }
	    return _react2.default.createElement(_StepPositionIcon2.default, { className: classes.root, position: icon, active: active });
	  }
	
	  return icon;
	}
	
	StepIcon.propTypes =  false ? {
	  /**
	   * Whether this step is active.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Classses for component style customizations.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.node.isRequired
	} : {};
	
	StepIcon.defaultProps = {
	  active: false,
	  completed: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepIcon' })(StepIcon);

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(326);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _StepIcon = __webpack_require__(2380);
	
	var _StepIcon2 = _interopRequireDefault(_StepIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      alignItems: 'center'
	    },
	    horizontal: {},
	    vertical: {},
	    active: {
	      fontWeight: 500
	    },
	    completed: {
	      fontWeight: 500
	    },
	    disabled: {
	      cursor: 'default'
	    },
	    iconContainer: {},
	    iconContainerNoAlternative: {
	      paddingRight: theme.spacing.unit
	    },
	    alternativeLabelRoot: {
	      flexDirection: 'column'
	    },
	    alternativeLabel: {
	      textAlign: 'center',
	      marginTop: theme.spacing.unit * 2
	    }
	  };
	};
	
	function StepLabel(props) {
	  var _classNames, _classNames2;
	
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'disabled', 'icon', 'last', 'optional', 'orientation']);
	
	
	  var className = (0, _classnames2.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.completed, completed), (0, _defineProperty3.default)(_classNames, classes.alternativeLabelRoot, alternativeLabel), (0, _defineProperty3.default)(_classNames, 'classNameProp', classNameProp), _classNames));
	  var labelClassName = (0, _classnames2.default)((_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.alternativeLabel, alternativeLabel), (0, _defineProperty3.default)(_classNames2, classes.completed, completed), (0, _defineProperty3.default)(_classNames2, classes.active, active), _classNames2));
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ className: className }, other),
	    icon && _react2.default.createElement(
	      'span',
	      {
	        className: (0, _classnames2.default)(classes.iconContainer, (0, _defineProperty3.default)({}, classes.iconContainerNoAlternative, !alternativeLabel))
	      },
	      _react2.default.createElement(_StepIcon2.default, {
	        completed: completed,
	        active: active,
	        icon: icon,
	        alternativeLabel: alternativeLabel
	      })
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'body1', component: 'span', className: labelClassName },
	        children
	      ),
	      optional
	    )
	  );
	}
	
	StepLabel.propTypes =  false ? {
	  /**
	   * @ignore
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes2.default.bool,
	  /**
	   * In most cases will simply be a string containing a title for the label.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Custom styles for component.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the default icon.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
	} : {};
	
	StepLabel.defaultProps = {
	  active: false,
	  alternativeLabel: false,
	  completed: false,
	  disabled: false,
	  last: false,
	  orientation: 'horizontal'
	};
	
	StepLabel.muiName = 'StepLabel';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepLabel' })(StepLabel);

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	var _colorManipulator = __webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
	      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
	      borderBottom: '1px solid\n    ' + (theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.8)),
	      textAlign: 'left'
	    },
	    numeric: {
	      textAlign: 'right',
	      flexDirection: 'row-reverse' // can be dynamically inherited at runtime by contents
	    },
	    typeHead: {
	      color: theme.palette.text.secondary,
	      fontSize: theme.typography.pxToRem(12),
	      fontWeight: theme.typography.fontWeightMedium,
	      position: 'relative' // Workaround for Tooltip positioning issue.
	    },
	    typeBody: {
	      fontSize: theme.typography.pxToRem(13),
	      color: theme.palette.text.primary
	    },
	    typeFooter: {
	      borderBottom: 0,
	      color: theme.palette.text.secondary,
	      fontSize: theme.typography.pxToRem(12)
	    },
	    paddingDefault: {
	      padding: theme.spacing.unit / 2 + 'px ' + theme.spacing.unit * 7 + 'px ' + theme.spacing.unit / 2 + 'px ' + theme.spacing.unit * 3 + 'px',
	      '&:last-child': {
	        paddingRight: theme.spacing.unit * 3
	      }
	    },
	    paddingDense: {
	      paddingRight: theme.spacing.unit * 3
	    },
	    paddingCheckbox: {
	      padding: '0 12px'
	    }
	  };
	};
	
	function TableCell(props, context) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      component = props.component,
	      sortDirection = props.sortDirection,
	      numeric = props.numeric,
	      padding = props.padding,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'component', 'sortDirection', 'numeric', 'padding', 'variant']);
	  var table = context.table;
	
	  var Component = void 0;
	  if (component) {
	    Component = component;
	  } else {
	    Component = table && table.head ? 'th' : 'td';
	  }
	
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.numeric, numeric), (0, _defineProperty3.default)(_classNames, classes['padding' + (0, _helpers.capitalize)(padding)], padding !== 'none' && padding !== 'default'), (0, _defineProperty3.default)(_classNames, classes.paddingDefault, padding !== 'none'), (0, _defineProperty3.default)(_classNames, classes.typeHead, variant ? variant === 'head' : table && table.head), (0, _defineProperty3.default)(_classNames, classes.typeBody, variant ? variant === 'body' : table && table.body), (0, _defineProperty3.default)(_classNames, classes.typeFooter, variant ? variant === 'footer' : table && table.footer), _classNames), classNameProp);
	
	  var ariaSort = null;
	  if (sortDirection) {
	    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
	  }
	
	  return _react2.default.createElement(
	    Component,
	    (0, _extends3.default)({ className: className, 'aria-sort': ariaSort }, other),
	    children
	  );
	}
	
	TableCell.propTypes =  false ? {
	  /**
	   * The table cell contents.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, content will align to the right.
	   */
	  numeric: _propTypes2.default.bool,
	  /**
	   * Sets the padding applied to the cell.
	   */
	  padding: _propTypes2.default.oneOf(['default', 'checkbox', 'dense', 'none']),
	  /**
	   * Set aria-sort direction.
	   */
	  sortDirection: _propTypes2.default.oneOf(['asc', 'desc', false]),
	  /**
	   * Specify the cell type.
	   * By default, the TableHead, TableBody or TableFooter parent component set the value.
	   */
	  variant: _propTypes2.default.oneOf(['head', 'body', 'footer'])
	} : {};
	
	TableCell.defaultProps = {
	  numeric: false,
	  padding: 'default'
	};
	
	TableCell.contextTypes = {
	  table: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableCell' })(TableCell);

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _isNan = __webpack_require__(1396);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _debounce = __webpack_require__(469);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _reactScrollbarSize = __webpack_require__(6278);
	
	var _reactScrollbarSize2 = _interopRequireDefault(_reactScrollbarSize);
	
	var _normalizeScrollLeft = __webpack_require__(5688);
	
	var _scroll = __webpack_require__(6480);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _TabIndicator = __webpack_require__(5624);
	
	var _TabIndicator2 = _interopRequireDefault(_TabIndicator);
	
	var _TabScrollButton = __webpack_require__(5625);
	
	var _TabScrollButton2 = _interopRequireDefault(_TabScrollButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      overflow: 'hidden',
	      minHeight: 48,
	      WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	    },
	    flexContainer: {
	      display: 'flex'
	    },
	    scrollingContainer: {
	      position: 'relative',
	      display: 'inline-block',
	      flex: '1 1 auto',
	      whiteSpace: 'nowrap'
	    },
	    fixed: {
	      overflowX: 'hidden',
	      width: '100%'
	    },
	    scrollable: {
	      overflowX: 'scroll'
	    },
	    centered: {
	      justifyContent: 'center'
	    },
	    buttonAuto: (0, _defineProperty3.default)({}, theme.breakpoints.down('xs'), {
	      display: 'none'
	    })
	  };
	};
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      indicatorStyle: {},
	      scrollerStyle: {
	        marginBottom: 0
	      },
	      showLeftScroll: false,
	      showRightScroll: false,
	      mounted: false
	    }, _this.getConditionalElements = function () {
	      var _this$props = _this.props,
	          classes = _this$props.classes,
	          buttonClassName = _this$props.buttonClassName,
	          scrollable = _this$props.scrollable,
	          scrollButtons = _this$props.scrollButtons,
	          TabScrollButtonProp = _this$props.TabScrollButton,
	          theme = _this$props.theme;
	
	      var conditionalElements = {};
	      conditionalElements.scrollbarSizeListener = scrollable ? _react2.default.createElement(_reactScrollbarSize2.default, {
	        onLoad: _this.handleScrollbarSizeChange,
	        onChange: _this.handleScrollbarSizeChange
	      }) : null;
	
	      var showScrollButtons = scrollable && (scrollButtons === 'auto' || scrollButtons === 'on');
	
	      conditionalElements.scrollButtonLeft = showScrollButtons ? _react2.default.createElement(TabScrollButtonProp, {
	        direction: theme && theme.direction === 'rtl' ? 'right' : 'left',
	        onClick: _this.handleLeftScrollClick,
	        visible: _this.state.showLeftScroll,
	        className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.buttonAuto, scrollButtons === 'auto'), buttonClassName)
	      }) : null;
	
	      conditionalElements.scrollButtonRight = showScrollButtons ? _react2.default.createElement(TabScrollButtonProp, {
	        direction: theme && theme.direction === 'rtl' ? 'left' : 'right',
	        onClick: _this.handleRightScrollClick,
	        visible: _this.state.showRightScroll,
	        className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.buttonAuto, scrollButtons === 'auto'), buttonClassName)
	      }) : null;
	
	      return conditionalElements;
	    }, _this.getTabsMeta = function (value, direction) {
	      var tabsMeta = void 0;
	      if (_this.tabs) {
	        var rect = _this.tabs.getBoundingClientRect();
	        // create a new object with ClientRect class props + scrollLeft
	        tabsMeta = {
	          clientWidth: _this.tabs ? _this.tabs.clientWidth : 0,
	          scrollLeft: _this.tabs ? _this.tabs.scrollLeft : 0,
	          scrollLeftNormalized: _this.tabs ? (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, direction) : 0,
	          scrollWidth: _this.tabs ? _this.tabs.scrollWidth : 0,
	          left: rect.left,
	          right: rect.right
	        };
	      }
	
	      var tabMeta = void 0;
	      if (_this.tabs && value !== false) {
	        var children = _this.tabs.children[0].children;
	
	        if (children.length > 0) {
	          var tab = children[_this.valueToIndex[value]];
	           false ? (0, _warning2.default)(tab, 'Material-UI: the value provided `' + value + '` is invalid') : void 0;
	          tabMeta = tab ? tab.getBoundingClientRect() : null;
	        }
	      }
	      return { tabsMeta: tabsMeta, tabMeta: tabMeta };
	    }, _this.tabs = undefined, _this.valueToIndex = {}, _this.handleResize = (0, _debounce2.default)(function () {
	      _this.updateIndicatorState(_this.props);
	      _this.updateScrollButtonState();
	    }, 166), _this.handleLeftScrollClick = function () {
	      if (_this.tabs) {
	        _this.moveTabsScroll(-_this.tabs.clientWidth);
	      }
	    }, _this.handleRightScrollClick = function () {
	      if (_this.tabs) {
	        _this.moveTabsScroll(_this.tabs.clientWidth);
	      }
	    }, _this.handleScrollbarSizeChange = function (_ref2) {
	      var scrollbarHeight = _ref2.scrollbarHeight;
	
	      _this.setState({
	        scrollerStyle: {
	          marginBottom: -scrollbarHeight
	        }
	      });
	    }, _this.handleTabsScroll = (0, _debounce2.default)(function () {
	      _this.updateScrollButtonState();
	    }, 166), _this.moveTabsScroll = function (delta) {
	      var theme = _this.props.theme;
	
	
	      if (_this.tabs) {
	        var multiplier = theme.direction === 'rtl' ? -1 : 1;
	        var nextScrollLeft = _this.tabs.scrollLeft + delta * multiplier;
	        // Fix for Edge
	        var invert = theme.direction === 'rtl' && (0, _normalizeScrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
	        _scroll2.default.left(_this.tabs, invert * nextScrollLeft);
	      }
	    }, _this.scrollSelectedIntoView = function () {
	      var _this$props2 = _this.props,
	          theme = _this$props2.theme,
	          value = _this$props2.value;
	
	      var _this$getTabsMeta = _this.getTabsMeta(value, theme.direction),
	          tabsMeta = _this$getTabsMeta.tabsMeta,
	          tabMeta = _this$getTabsMeta.tabMeta;
	
	      if (!tabMeta || !tabsMeta) {
	        return;
	      }
	
	      if (tabMeta.left < tabsMeta.left) {
	        // left side of button is out of view
	        var nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.left - tabsMeta.left);
	        _scroll2.default.left(_this.tabs, nextScrollLeft);
	      } else if (tabMeta.right > tabsMeta.right) {
	        // right side of button is out of view
	        var _nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.right - tabsMeta.right);
	        _scroll2.default.left(_this.tabs, _nextScrollLeft);
	      }
	    }, _this.updateScrollButtonState = function () {
	      var _this$props3 = _this.props,
	          scrollable = _this$props3.scrollable,
	          scrollButtons = _this$props3.scrollButtons,
	          theme = _this$props3.theme;
	
	
	      if (_this.tabs && scrollable && scrollButtons !== 'off') {
	        var _this$tabs = _this.tabs,
	            scrollWidth = _this$tabs.scrollWidth,
	            clientWidth = _this$tabs.clientWidth;
	
	        var scrollLeft = (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, theme.direction);
	
	        var showLeftScroll = theme.direction === 'rtl' ? scrollWidth > clientWidth + scrollLeft : scrollLeft > 0;
	
	        var showRightScroll = theme.direction === 'rtl' ? scrollLeft > 0 : scrollWidth > clientWidth + scrollLeft;
	
	        if (showLeftScroll !== _this.state.showLeftScroll || showRightScroll !== _this.state.showRightScroll) {
	          _this.setState({ showLeftScroll: showLeftScroll, showRightScroll: showRightScroll });
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // eslint-disable-next-line react/no-did-mount-set-state
	      this.setState({ mounted: true });
	      this.updateIndicatorState(this.props);
	      this.updateScrollButtonState();
	
	      if (this.props.action) {
	        this.props.action({
	          updateIndicator: this.handleResize
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this.updateScrollButtonState();
	
	      // The index might have changed at the same time.
	      // We need to check again the right indicator position.
	      this.updateIndicatorState(this.props);
	
	      if (this.state.indicatorStyle !== prevState.indicatorStyle) {
	        this.scrollSelectedIntoView();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleTabsScroll.cancel();
	    }
	  }, {
	    key: 'updateIndicatorState',
	    value: function updateIndicatorState(props) {
	      var theme = props.theme,
	          value = props.value;
	
	      var _getTabsMeta = this.getTabsMeta(value, theme.direction),
	          tabsMeta = _getTabsMeta.tabsMeta,
	          tabMeta = _getTabsMeta.tabMeta;
	
	      var left = 0;
	
	      if (tabMeta && tabsMeta) {
	        var correction = theme.direction === 'rtl' ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
	        left = tabMeta.left - tabsMeta.left + correction;
	      }
	
	      var indicatorStyle = {
	        left: left,
	        // May be wrong until the font is loaded.
	        width: tabMeta ? tabMeta.width : 0
	      };
	
	      if ((indicatorStyle.left !== this.state.indicatorStyle.left || indicatorStyle.width !== this.state.indicatorStyle.width) && !(0, _isNan2.default)(indicatorStyle.left) && !(0, _isNan2.default)(indicatorStyle.width)) {
	        this.setState({ indicatorStyle: indicatorStyle });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames3,
	          _this2 = this;
	
	      var _props = this.props,
	          action = _props.action,
	          buttonClassName = _props.buttonClassName,
	          centered = _props.centered,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          fullWidth = _props.fullWidth,
	          indicatorClassName = _props.indicatorClassName,
	          indicatorColor = _props.indicatorColor,
	          onChange = _props.onChange,
	          scrollable = _props.scrollable,
	          scrollButtons = _props.scrollButtons,
	          TabScrollButtonProp = _props.TabScrollButton,
	          textColor = _props.textColor,
	          theme = _props.theme,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'buttonClassName', 'centered', 'children', 'classes', 'className', 'fullWidth', 'indicatorClassName', 'indicatorColor', 'onChange', 'scrollable', 'scrollButtons', 'TabScrollButton', 'textColor', 'theme', 'value']);
	
	
	      var className = (0, _classnames2.default)(classes.root, classNameProp);
	      var scrollerClassName = (0, _classnames2.default)(classes.scrollingContainer, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.fixed, !scrollable), (0, _defineProperty3.default)(_classNames3, classes.scrollable, scrollable), _classNames3));
	      var tabItemContainerClassName = (0, _classnames2.default)(classes.flexContainer, (0, _defineProperty3.default)({}, classes.centered, centered && !scrollable));
	
	      var indicator = _react2.default.createElement(_TabIndicator2.default, {
	        style: this.state.indicatorStyle,
	        className: indicatorClassName,
	        color: indicatorColor
	      });
	
	      this.valueToIndex = {};
	      var childIndex = 0;
	      var children = _react2.default.Children.map(childrenProp, function (child) {
	        if (!_react2.default.isValidElement(child)) {
	          return null;
	        }
	
	        var childValue = child.props.value || childIndex;
	        _this2.valueToIndex[childValue] = childIndex;
	        var selected = childValue === value;
	
	        childIndex += 1;
	        return _react2.default.cloneElement(child, {
	          fullWidth: fullWidth,
	          indicator: selected && !_this2.state.mounted && indicator,
	          selected: selected,
	          onChange: onChange,
	          textColor: textColor,
	          value: childValue
	        });
	      });
	
	      var conditionalElements = this.getConditionalElements();
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ className: className }, other),
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        conditionalElements.scrollbarSizeListener,
	        _react2.default.createElement(
	          'div',
	          { className: classes.flexContainer },
	          conditionalElements.scrollButtonLeft,
	          _react2.default.createElement(
	            'div',
	            {
	              className: scrollerClassName,
	              style: this.state.scrollerStyle,
	              ref: function ref(node) {
	                _this2.tabs = node;
	              },
	              role: 'tablist',
	              onScroll: this.handleTabsScroll
	            },
	            _react2.default.createElement(
	              'div',
	              { className: tabItemContainerClassName },
	              children
	            ),
	            this.state.mounted && indicator
	          ),
	          conditionalElements.scrollButtonRight
	        )
	      );
	    }
	  }]);
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.propTypes =  false ? {
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports `updateIndicator()` action.
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes2.default.func,
	  /**
	   * The CSS class name of the scroll button elements.
	   */
	  buttonClassName: _propTypes2.default.string,
	  /**
	   * If `true`, the tabs will be centered.
	   * This property is intended for large views.
	   */
	  centered: _propTypes2.default.bool,
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the tabs will grow to use all the available space.
	   * This property is intended for small views, like on mobile.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The CSS class name of the indicator element.
	   */
	  indicatorClassName: _propTypes2.default.string,
	  /**
	   * Determines the color of the indicator.
	   */
	  indicatorColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(['secondary', 'primary'])]),
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {number} value We default to the index of the child
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * True invokes scrolling properties and allow for horizontally scrolling
	   * (or swiping) the tab bar.
	   */
	  scrollable: _propTypes2.default.bool,
	  /**
	   * Determine behavior of scroll buttons when tabs are set to scroll
	   * `auto` will only present them on medium and larger viewports
	   * `on` will always present them
	   * `off` will never present them
	   */
	  scrollButtons: _propTypes2.default.oneOf(['auto', 'on', 'off']),
	  /**
	   * The component used to render the scroll buttons.
	   */
	  TabScrollButton: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Determines the color of the `Tab`.
	   */
	  textColor: _propTypes2.default.oneOf(['secondary', 'primary', 'inherit']),
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * The value of the currently selected `Tab`.
	   * If you don't want any selected `Tab`, you can set this property to `false`.
	   */
	  value: _propTypes2.default.any
	} : {};
	
	Tabs.defaultProps = {
	  centered: false,
	  fullWidth: false,
	  indicatorColor: 'secondary',
	  scrollable: false,
	  scrollButtons: 'auto',
	  TabScrollButton: _TabScrollButton2.default,
	  textColor: 'inherit'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTabs', withTheme: true })(Tabs);

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Toolbar = __webpack_require__(5628);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Toolbar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2385 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var grey = {
	  50: '#fafafa',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121',
	  A100: '#d5d5d5',
	  A200: '#aaaaaa',
	  A400: '#303030',
	  A700: '#616161'
	};
	
	exports.default = grey;

/***/ }),
/* 2386 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var indigo = {
	  50: '#e8eaf6',
	  100: '#c5cae9',
	  200: '#9fa8da',
	  300: '#7986cb',
	  400: '#5c6bc0',
	  500: '#3f51b5',
	  600: '#3949ab',
	  700: '#303f9f',
	  800: '#283593',
	  900: '#1a237e',
	  A100: '#8c9eff',
	  A200: '#536dfe',
	  A400: '#3d5afe',
	  A700: '#304ffe'
	};
	
	exports.default = indigo;

/***/ }),
/* 2387 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var pink = {
	  50: '#fce4ec',
	  100: '#f8bbd0',
	  200: '#f48fb1',
	  300: '#f06292',
	  400: '#ec407a',
	  500: '#e91e63',
	  600: '#d81b60',
	  700: '#c2185b',
	  800: '#ad1457',
	  900: '#880e4f',
	  A100: '#ff80ab',
	  A200: '#ff4081',
	  A400: '#f50057',
	  A700: '#c51162'
	};
	
	exports.default = pink;

/***/ }),
/* 2388 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red = {
	  50: '#ffebee',
	  100: '#ffcdd2',
	  200: '#ef9a9a',
	  300: '#e57373',
	  400: '#ef5350',
	  500: '#f44336',
	  600: '#e53935',
	  700: '#d32f2f',
	  800: '#c62828',
	  900: '#b71c1c',
	  A100: '#ff8a80',
	  A200: '#ff5252',
	  A400: '#ff1744',
	  A700: '#d50000'
	};
	
	exports.default = red;

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 *
	 * Internal helper component to allow attaching a ref to a
	 * child element that may not accept refs (functional component).
	 */
	var RefHolder = function (_React$Component) {
	  (0, _inherits3.default)(RefHolder, _React$Component);
	
	  function RefHolder() {
	    (0, _classCallCheck3.default)(this, RefHolder);
	    return (0, _possibleConstructorReturn3.default)(this, (RefHolder.__proto__ || (0, _getPrototypeOf2.default)(RefHolder)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RefHolder, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes =  false ? {
	  children: _propTypes2.default.node
	} : {};
	
	exports.default = RefHolder;

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' });
	
	var KeyboardArrowLeft = function KeyboardArrowLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	KeyboardArrowLeft = (0, _pure2.default)(KeyboardArrowLeft);
	KeyboardArrowLeft.muiName = 'SvgIcon';
	
	exports.default = KeyboardArrowLeft;

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' });
	
	var KeyboardArrowRight = function KeyboardArrowRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	KeyboardArrowRight = (0, _pure2.default)(KeyboardArrowRight);
	KeyboardArrowRight.muiName = 'SvgIcon';
	
	exports.default = KeyboardArrowRight;

/***/ }),
/* 2392 */
[6731, 2393],
/* 2393 */
[6804, 5659],
/* 2394 */
331,
/* 2395 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(5669);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createGenerateClassName;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var generatorCounter = 0;
	
	// Returns a function which generates unique class names based on counters.
	// When new generator function is created, rule counter is reset.
	// We need to reset the rule counter for SSR for each request.
	//
	// It's inspired by
	// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
	function createGenerateClassName() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
	      dangerouslyUseGlobalCSS = _options$dangerouslyU === undefined ? false : _options$dangerouslyU,
	      _options$productionPr = options.productionPrefix,
	      productionPrefix = _options$productionPr === undefined ? 'jss' : _options$productionPr;
	
	  var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
	  var ruleCounter = 0;
	
	  // - HMR can lead to many class name generators being instantiated,
	  // so the warning is only triggered in production.
	  // - We expect a class name generator to be instantiated per new request on the server,
	  // so the warning is only triggered client side.
	  // - You can get away with having multiple class name generators
	  // by modifying the `productionPrefix`.
	  if (("production") === 'production' && typeof window !== 'undefined' && productionPrefix === 'jss') {
	    generatorCounter += 1;
	
	    if (generatorCounter > 2) {
	      // eslint-disable-next-line no-console
	      console.error(['Material-UI: we have detected more than needed creation of the class name generator.', 'You should only use one class name generator on the client side.', 'If you do otherwise, you take the risk to have conflicting class names in production.'].join('\n'));
	    }
	  }
	
	  return function (rule, styleSheet) {
	    ruleCounter += 1;
	     false ? (0, _warning2.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;
	
	    // Code branch the whole block at the expense of more code.
	    if (dangerouslyUseGlobalCSS) {
	      if (styleSheet && styleSheet.options.classNamePrefix) {
	        var prefix = styleSheet.options.classNamePrefix;
	        // Sanitize the string as will be used to prefix the generated class name.
	        prefix = prefix.replace(escapeRegex, '-');
	
	        if (prefix.match(/^Mui/)) {
	          return prefix + '-' + rule.key;
	        }
	
	        if (false) {
	          return prefix + '-' + rule.key + '-' + ruleCounter;
	        }
	      }
	
	      if (true) {
	        return '' + productionPrefix + ruleCounter;
	      }
	
	      return rule.key + '-' + ruleCounter;
	    }
	
	    if (true) {
	      return '' + productionPrefix + ruleCounter;
	    }
	
	    if (styleSheet && styleSheet.options.classNamePrefix) {
	      var _prefix = styleSheet.options.classNamePrefix;
	      // Sanitize the string as will be used to prefix the generated class name.
	      _prefix = _prefix.replace(escapeRegex, '-');
	
	      return _prefix + '-' + rule.key + '-' + ruleCounter;
	    }
	
	    return rule.key + '-' + ruleCounter;
	  };
	}

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jssGlobal = __webpack_require__(5363);
	
	var _jssGlobal2 = _interopRequireDefault(_jssGlobal);
	
	var _jssNested = __webpack_require__(5364);
	
	var _jssNested2 = _interopRequireDefault(_jssNested);
	
	var _jssCamelCase = __webpack_require__(5360);
	
	var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);
	
	var _jssDefaultUnit = __webpack_require__(5362);
	
	var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);
	
	var _jssVendorPrefixer = __webpack_require__(5366);
	
	var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);
	
	var _jssPropsSort = __webpack_require__(5365);
	
	var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Subset of jss-preset-default with only the plugins the Material-UI
	// components are using.
	function jssPreset() {
	  return {
	    plugins: [(0, _jssGlobal2.default)(), (0, _jssNested2.default)(), (0, _jssCamelCase2.default)(), (0, _jssDefaultUnit2.default)(), (0, _jssVendorPrefixer2.default)(), (0, _jssPropsSort2.default)()]
	  };
	}
	
	exports.default = jssPreset;

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(580);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _withTheme = __webpack_require__(582);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	var _utils = __webpack_require__(737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getScale(value) {
	  return 'scale(' + value + ', ' + Math.pow(value, 2) + ')';
	} // @inheritedComponent Transition
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    transform: getScale(1)
	  }
	};
	
	/**
	 * The Grow transition is used by the Popover component.
	 * It's using [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow = function (_React$Component) {
	  (0, _inherits3.default)(Grow, _React$Component);
	
	  function Grow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Grow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Grow.__proto__ || (0, _getPrototypeOf2.default)(Grow)).call.apply(_ref, [this].concat(args))), _this), _this.autoTimeout = undefined, _this.handleEnter = function (node) {
	      var _this$props = _this.props,
	          theme = _this$props.theme,
	          timeout = _this$props.timeout;
	
	      (0, _utils.reflow)(node); // So the animation always start from the start.
	
	      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      }),
	          transitionDuration = _getTransitionProps.duration,
	          delay = _getTransitionProps.delay;
	
	      var duration = 0;
	      if (timeout === 'auto') {
	        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	        _this.autoTimeout = duration;
	      } else {
	        duration = transitionDuration;
	      }
	
	      node.style.transition = [theme.transitions.create('opacity', {
	        duration: duration,
	        delay: delay
	      }), theme.transitions.create('transform', {
	        duration: duration * 0.666,
	        delay: delay
	      })].join(',');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.handleExit = function (node) {
	      var _this$props2 = _this.props,
	          theme = _this$props2.theme,
	          timeout = _this$props2.timeout;
	
	      var duration = 0;
	
	      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      }),
	          transitionDuration = _getTransitionProps2.duration,
	          delay = _getTransitionProps2.delay;
	
	      if (timeout === 'auto') {
	        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	        _this.autoTimeout = duration;
	      } else {
	        duration = transitionDuration;
	      }
	
	      node.style.transition = [theme.transitions.create('opacity', {
	        duration: duration,
	        delay: delay
	      }), theme.transitions.create('transform', {
	        duration: duration * 0.666,
	        delay: delay || duration * 0.333
	      })].join(',');
	
	      node.style.opacity = '0';
	      node.style.transform = getScale(0.75);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.addEndListener = function (node, next) {
	      if (_this.props.timeout === 'auto') {
	        setTimeout(next, _this.autoTimeout || 0);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Grow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          onEnter = _props.onEnter,
	          onExit = _props.onExit,
	          styleProp = _props.style,
	          theme = _props.theme,
	          timeout = _props.timeout,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onExit', 'style', 'theme', 'timeout']);
	
	
	      var style = (0, _extends3.default)({}, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        (0, _extends3.default)({
	          appear: true,
	          onEnter: this.handleEnter,
	          onExit: this.handleExit,
	          addEndListener: this.addEndListener,
	          timeout: timeout === 'auto' ? null : timeout
	        }, other),
	        function (state, childProps) {
	          return _react2.default.cloneElement(children, (0, _extends3.default)({
	            style: (0, _extends3.default)({
	              opacity: 0,
	              transform: getScale(0.75)
	            }, styles[state], style)
	          }, childProps));
	        }
	      );
	    }
	  }]);
	  return Grow;
	}(_react2.default.Component);
	
	Grow.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
	} : {};
	
	Grow.defaultProps = {
	  timeout: 'auto'
	};
	
	exports.default = (0, _withTheme2.default)()(Grow);

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null && target.parentNode) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	/**
	 * Listen for click events that are triggered outside of the component children.
	 */
	
	var ClickAwayListener = function (_React$Component) {
	  (0, _inherits3.default)(ClickAwayListener, _React$Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.handleClickAway = function (event) {
	      // Ignore events that have been `event.preventDefault()` marked.
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.mounted) {
	        var el = (0, _reactDom.findDOMNode)(_this);
	
	        if (event.target instanceof HTMLElement && document.documentElement && document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactEventListener2.default,
	        {
	          target: 'document',
	          onMouseup: this.handleClickAway,
	          onTouchend: this.handleClickAway
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return ClickAwayListener;
	}(_react2.default.Component);
	
	ClickAwayListener.propTypes =  false ? {
	  children: _propTypes2.default.node.isRequired,
	  onClickAway: _propTypes2.default.func.isRequired
	} : {};
	
	exports.default = ClickAwayListener;

/***/ }),
/* 2401 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (node, event, handler, capture) {
	  node.addEventListener(event, handler, capture);
	  return {
	    remove: function remove() {
	      node.removeEventListener(event, handler, capture);
	    }
	  };
	};

/***/ }),
/* 2402 */
/***/ (function(module, exports) {

	'use strict';
	
	var safeIsNaN = Number.isNaN ||
	    function ponyfill(value) {
	        return typeof value === 'number' && value !== value;
	    };
	function isEqual(first, second) {
	    if (first === second) {
	        return true;
	    }
	    if (safeIsNaN(first) && safeIsNaN(second)) {
	        return true;
	    }
	    return false;
	}
	function areInputsEqual(newInputs, lastInputs) {
	    if (newInputs.length !== lastInputs.length) {
	        return false;
	    }
	    for (var i = 0; i < newInputs.length; i++) {
	        if (!isEqual(newInputs[i], lastInputs[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoizeOne(resultFn, isEqual) {
	    if (isEqual === void 0) { isEqual = areInputsEqual; }
	    var lastThis;
	    var lastArgs = [];
	    var lastResult;
	    var calledOnce = false;
	    function memoized() {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
	            return lastResult;
	        }
	        lastResult = resultFn.apply(this, newArgs);
	        calledOnce = true;
	        lastThis = this;
	        lastArgs = newArgs;
	        return lastResult;
	    }
	    return memoized;
	}
	
	module.exports = memoizeOne;


/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(5685);
	moment.tz.load(__webpack_require__(5353));


/***/ }),
/* 2404 */
[6495, 29],
/* 2405 */
[6496, 29],
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 2411 */
[6497, 29],
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ }),
/* 2414 */
[6498, 29],
/* 2415 */
[6499, 29],
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 2425 */
[6500, 29],
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ }),
/* 2429 */
[6501, 29],
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ }),
/* 2431 */
[6502, 29],
/* 2432 */
[6503, 29],
/* 2433 */
[6504, 29],
/* 2434 */
[6505, 29],
/* 2435 */
[6506, 29],
/* 2436 */
[6507, 29],
/* 2437 */
[6508, 29],
/* 2438 */
[6509, 29],
/* 2439 */
[6510, 29],
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 2448 */
[6511, 29],
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 2454 */
[6512, 29],
/* 2455 */
[6513, 29],
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 2465 */
[6514, 29],
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ }),
/* 2467 */
[6515, 29],
/* 2468 */
[6516, 29],
/* 2469 */
[6517, 29],
/* 2470 */
[6518, 29],
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 2472 */
[6519, 29],
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 2475 */
[6520, 29],
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 2477 */
[6521, 29],
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 2484 */
[6522, 29],
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 2488 */
[6523, 29],
/* 2489 */
[6524, 29],
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 2491 */
[6525, 29],
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 2504 */
[6526, 29],
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 2509 */
[6527, 29],
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 2513 */
[6528, 29],
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ }),
/* 2517 */
[6529, 29],
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ }),
/* 2520 */
[6530, 29],
/* 2521 */
[6531, 29],
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 2524 */
[6532, 29],
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 2529 */
[6533, 29],
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 2531 */
[6534, 29],
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(29)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 2534 */
[6535, 29],
/* 2535 */
[6536, 29],
/* 2536 */
[6537, 29],
/* 2537 */
[6538, 29],
/* 2538 */
[6539, 29],
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'MMMM [de] D [de] YYYY',
	            LLL : 'MMMM [de] D [de] YYYY h:mm A',
	            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka horan', 'ek hor'],
	            'hh': [number + ' horanim', number + ' horam'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(24)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(2663);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(5691);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 2663 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.Phoenix=t():e.Phoenix=t()}(this,(function(){return function(e){var t={};function n(i){if(t[i])return t[i].exports;var o=t[i]={i:i,l:!1,exports:{}};return e[i].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,i){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:i})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(i,o,function(t){return e[t]}.bind(null,o));return i},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){(function(t){e.exports=t.Phoenix=n(2)}).call(this,n(1))},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";function i(e){return function(e){if(Array.isArray(e))return a(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||s(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function r(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"==typeof Symbol||!(Symbol.iterator in Object(e)))return;var n=[],i=!0,o=!1,r=void 0;try{for(var s,a=e[Symbol.iterator]();!(i=(s=a.next()).done)&&(n.push(s.value),!t||n.length!==t);i=!0);}catch(e){o=!0,r=e}finally{try{i||null==a.return||a.return()}finally{if(o)throw r}}return n}(e,t)||s(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function s(e,t){if(e){if("string"==typeof e)return a(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?a(e,t):void 0}}function a(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,i=new Array(t);n<t;n++)i[n]=e[n];return i}function c(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}function h(e,t,n){return t&&u(e.prototype,t),n&&u(e,n),e}n.r(t),n.d(t,"Channel",(function(){return O})),n.d(t,"Serializer",(function(){return _})),n.d(t,"Socket",(function(){return H})),n.d(t,"LongPoll",(function(){return U})),n.d(t,"Ajax",(function(){return D})),n.d(t,"Presence",(function(){return M}));var l="undefined"!=typeof self?self:null,f="undefined"!=typeof window?window:null,d=l||f||void 0,p=0,v=1,y=2,m=3,g="closed",k="errored",b="joined",j="joining",T="leaving",C="phx_close",R="phx_error",E="phx_join",w="phx_reply",S="phx_leave",A="longpoll",L="websocket",x=function(e){if("function"==typeof e)return e;return function(){return e}},P=function(){function e(t,n,i,o){c(this,e),this.channel=t,this.event=n,this.payload=i||function(){return{}},this.receivedResp=null,this.timeout=o,this.timeoutTimer=null,this.recHooks=[],this.sent=!1}return h(e,[{key:"resend",value:function(e){this.timeout=e,this.reset(),this.send()}},{key:"send",value:function(){this.hasReceived("timeout")||(this.startTimeout(),this.sent=!0,this.channel.socket.push({topic:this.channel.topic,event:this.event,payload:this.payload(),ref:this.ref,join_ref:this.channel.joinRef()}))}},{key:"receive",value:function(e,t){return this.hasReceived(e)&&t(this.receivedResp.response),this.recHooks.push({status:e,callback:t}),this}},{key:"reset",value:function(){this.cancelRefEvent(),this.ref=null,this.refEvent=null,this.receivedResp=null,this.sent=!1}},{key:"matchReceive",value:function(e){var t=e.status,n=e.response;e.ref;this.recHooks.filter((function(e){return e.status===t})).forEach((function(e){return e.callback(n)}))}},{key:"cancelRefEvent",value:function(){this.refEvent&&this.channel.off(this.refEvent)}},{key:"cancelTimeout",value:function(){clearTimeout(this.timeoutTimer),this.timeoutTimer=null}},{key:"startTimeout",value:function(){var e=this;this.timeoutTimer&&this.cancelTimeout(),this.ref=this.channel.socket.makeRef(),this.refEvent=this.channel.replyEventName(this.ref),this.channel.on(this.refEvent,(function(t){e.cancelRefEvent(),e.cancelTimeout(),e.receivedResp=t,e.matchReceive(t)})),this.timeoutTimer=setTimeout((function(){e.trigger("timeout",{})}),this.timeout)}},{key:"hasReceived",value:function(e){return this.receivedResp&&this.receivedResp.status===e}},{key:"trigger",value:function(e,t){this.channel.trigger(this.refEvent,{status:e,response:t})}}]),e}(),O=function(){function e(t,n,i){var o=this;c(this,e),this.state=g,this.topic=t,this.params=x(n||{}),this.socket=i,this.bindings=[],this.bindingRef=0,this.timeout=this.socket.timeout,this.joinedOnce=!1,this.joinPush=new P(this,E,this.params,this.timeout),this.pushBuffer=[],this.stateChangeRefs=[],this.rejoinTimer=new N((function(){o.socket.isConnected()&&o.rejoin()}),this.socket.rejoinAfterMs),this.stateChangeRefs.push(this.socket.onError((function(){return o.rejoinTimer.reset()}))),this.stateChangeRefs.push(this.socket.onOpen((function(){o.rejoinTimer.reset(),o.isErrored()&&o.rejoin()}))),this.joinPush.receive("ok",(function(){o.state=b,o.rejoinTimer.reset(),o.pushBuffer.forEach((function(e){return e.send()})),o.pushBuffer=[]})),this.joinPush.receive("error",(function(){o.state=k,o.socket.isConnected()&&o.rejoinTimer.scheduleTimeout()})),this.onClose((function(){o.rejoinTimer.reset(),o.socket.hasLogger()&&o.socket.log("channel","close ".concat(o.topic," ").concat(o.joinRef())),o.state=g,o.socket.remove(o)})),this.onError((function(e){o.socket.hasLogger()&&o.socket.log("channel","error ".concat(o.topic),e),o.isJoining()&&o.joinPush.reset(),o.state=k,o.socket.isConnected()&&o.rejoinTimer.scheduleTimeout()})),this.joinPush.receive("timeout",(function(){o.socket.hasLogger()&&o.socket.log("channel","timeout ".concat(o.topic," (").concat(o.joinRef(),")"),o.joinPush.timeout),new P(o,S,x({}),o.timeout).send(),o.state=k,o.joinPush.reset(),o.socket.isConnected()&&o.rejoinTimer.scheduleTimeout()})),this.on(w,(function(e,t){o.trigger(o.replyEventName(t),e)}))}return h(e,[{key:"join",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.timeout;if(this.joinedOnce)throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");return this.timeout=e,this.joinedOnce=!0,this.rejoin(),this.joinPush}},{key:"onClose",value:function(e){this.on(C,e)}},{key:"onError",value:function(e){return this.on(R,(function(t){return e(t)}))}},{key:"on",value:function(e,t){var n=this.bindingRef++;return this.bindings.push({event:e,ref:n,callback:t}),n}},{key:"off",value:function(e,t){this.bindings=this.bindings.filter((function(n){return!(n.event===e&&(void 0===t||t===n.ref))}))}},{key:"canPush",value:function(){return this.socket.isConnected()&&this.isJoined()}},{key:"push",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.timeout;if(t=t||{},!this.joinedOnce)throw new Error("tried to push '".concat(e,"' to '").concat(this.topic,"' before joining. Use channel.join() before pushing events"));var i=new P(this,e,(function(){return t}),n);return this.canPush()?i.send():(i.startTimeout(),this.pushBuffer.push(i)),i}},{key:"leave",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.timeout;this.rejoinTimer.reset(),this.joinPush.cancelTimeout(),this.state=T;var n=function(){e.socket.hasLogger()&&e.socket.log("channel","leave ".concat(e.topic)),e.trigger(C,"leave")},i=new P(this,S,x({}),t);return i.receive("ok",(function(){return n()})).receive("timeout",(function(){return n()})),i.send(),this.canPush()||i.trigger("ok",{}),i}},{key:"onMessage",value:function(e,t,n){return t}},{key:"isMember",value:function(e,t,n,i){return this.topic===e&&(!i||i===this.joinRef()||(this.socket.hasLogger()&&this.socket.log("channel","dropping outdated message",{topic:e,event:t,payload:n,joinRef:i}),!1))}},{key:"joinRef",value:function(){return this.joinPush.ref}},{key:"rejoin",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.timeout;this.isLeaving()||(this.socket.leaveOpenTopic(this.topic),this.state=j,this.joinPush.resend(e))}},{key:"trigger",value:function(e,t,n,i){var o=this.onMessage(e,t,n,i);if(t&&!o)throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");for(var r=this.bindings.filter((function(t){return t.event===e})),s=0;s<r.length;s++){r[s].callback(o,n,i||this.joinRef())}}},{key:"replyEventName",value:function(e){return"chan_reply_".concat(e)}},{key:"isClosed",value:function(){return this.state===g}},{key:"isErrored",value:function(){return this.state===k}},{key:"isJoined",value:function(){return this.state===b}},{key:"isJoining",value:function(){return this.state===j}},{key:"isLeaving",value:function(){return this.state===T}}]),e}(),_={HEADER_LENGTH:1,META_LENGTH:4,KINDS:{push:0,reply:1,broadcast:2},encode:function(e,t){if(e.payload.constructor===ArrayBuffer)return t(this.binaryEncode(e));var n=[e.join_ref,e.ref,e.topic,e.event,e.payload];return t(JSON.stringify(n))},decode:function(e,t){if(e.constructor===ArrayBuffer)return t(this.binaryDecode(e));var n=r(JSON.parse(e),5);return t({join_ref:n[0],ref:n[1],topic:n[2],event:n[3],payload:n[4]})},binaryEncode:function(e){var t=e.join_ref,n=e.ref,i=e.event,o=e.topic,r=e.payload,s=this.META_LENGTH+t.length+n.length+o.length+i.length,a=new ArrayBuffer(this.HEADER_LENGTH+s),c=new DataView(a),u=0;c.setUint8(u++,this.KINDS.push),c.setUint8(u++,t.length),c.setUint8(u++,n.length),c.setUint8(u++,o.length),c.setUint8(u++,i.length),Array.from(t,(function(e){return c.setUint8(u++,e.charCodeAt(0))})),Array.from(n,(function(e){return c.setUint8(u++,e.charCodeAt(0))})),Array.from(o,(function(e){return c.setUint8(u++,e.charCodeAt(0))})),Array.from(i,(function(e){return c.setUint8(u++,e.charCodeAt(0))}));var h=new Uint8Array(a.byteLength+r.byteLength);return h.set(new Uint8Array(a),0),h.set(new Uint8Array(r),a.byteLength),h.buffer},binaryDecode:function(e){var t=new DataView(e),n=t.getUint8(0),i=new TextDecoder;switch(n){case this.KINDS.push:return this.decodePush(e,t,i);case this.KINDS.reply:return this.decodeReply(e,t,i);case this.KINDS.broadcast:return this.decodeBroadcast(e,t,i)}},decodePush:function(e,t,n){var i=t.getUint8(1),o=t.getUint8(2),r=t.getUint8(3),s=this.HEADER_LENGTH+this.META_LENGTH-1,a=n.decode(e.slice(s,s+i));s+=i;var c=n.decode(e.slice(s,s+o));s+=o;var u=n.decode(e.slice(s,s+r));return s+=r,{join_ref:a,ref:null,topic:c,event:u,payload:e.slice(s,e.byteLength)}},decodeReply:function(e,t,n){var i=t.getUint8(1),o=t.getUint8(2),r=t.getUint8(3),s=t.getUint8(4),a=this.HEADER_LENGTH+this.META_LENGTH,c=n.decode(e.slice(a,a+i));a+=i;var u=n.decode(e.slice(a,a+o));a+=o;var h=n.decode(e.slice(a,a+r));a+=r;var l=n.decode(e.slice(a,a+s));a+=s;var f=e.slice(a,e.byteLength);return{join_ref:c,ref:u,topic:h,event:w,payload:{status:l,response:f}}},decodeBroadcast:function(e,t,n){var i=t.getUint8(1),o=t.getUint8(2),r=this.HEADER_LENGTH+2,s=n.decode(e.slice(r,r+i));r+=i;var a=n.decode(e.slice(r,r+o));return r+=o,{join_ref:null,ref:null,topic:s,event:a,payload:e.slice(r,e.byteLength)}}},H=function(){function e(t){var n=this,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};c(this,e),this.stateChangeCallbacks={open:[],close:[],error:[],message:[]},this.channels=[],this.sendBuffer=[],this.ref=0,this.timeout=i.timeout||1e4,this.transport=i.transport||d.WebSocket||U,this.defaultEncoder=_.encode.bind(_),this.defaultDecoder=_.decode.bind(_),this.closeWasClean=!1,this.unloaded=!1,this.binaryType=i.binaryType||"arraybuffer",this.transport!==U?(this.encode=i.encode||this.defaultEncoder,this.decode=i.decode||this.defaultDecoder):(this.encode=this.defaultEncoder,this.decode=this.defaultDecoder),f&&f.addEventListener&&f.addEventListener("beforeunload",(function(e){n.conn&&(n.unloaded=!0,n.abnormalClose("unloaded"))})),this.heartbeatIntervalMs=i.heartbeatIntervalMs||3e4,this.rejoinAfterMs=function(e){return i.rejoinAfterMs?i.rejoinAfterMs(e):[1e3,2e3,5e3][e-1]||1e4},this.reconnectAfterMs=function(e){return n.unloaded?100:i.reconnectAfterMs?i.reconnectAfterMs(e):[10,50,100,150,200,250,500,1e3,2e3][e-1]||5e3},this.logger=i.logger||null,this.longpollerTimeout=i.longpollerTimeout||2e4,this.params=x(i.params||{}),this.endPoint="".concat(t,"/").concat(L),this.vsn=i.vsn||"2.0.0",this.heartbeatTimer=null,this.pendingHeartbeatRef=null,this.reconnectTimer=new N((function(){n.teardown((function(){return n.connect()}))}),this.reconnectAfterMs)}return h(e,[{key:"protocol",value:function(){return location.protocol.match(/^https/)?"wss":"ws"}},{key:"endPointURL",value:function(){var e=D.appendParams(D.appendParams(this.endPoint,this.params()),{vsn:this.vsn});return"/"!==e.charAt(0)?e:"/"===e.charAt(1)?"".concat(this.protocol(),":").concat(e):"".concat(this.protocol(),"://").concat(location.host).concat(e)}},{key:"disconnect",value:function(e,t,n){this.closeWasClean=!0,this.reconnectTimer.reset(),this.teardown(e,t,n)}},{key:"connect",value:function(e){var t=this;e&&(console&&console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor"),this.params=x(e)),this.conn||(this.closeWasClean=!1,this.conn=new this.transport(this.endPointURL()),this.conn.binaryType=this.binaryType,this.conn.timeout=this.longpollerTimeout,this.conn.onopen=function(){return t.onConnOpen()},this.conn.onerror=function(e){return t.onConnError(e)},this.conn.onmessage=function(e){return t.onConnMessage(e)},this.conn.onclose=function(e){return t.onConnClose(e)})}},{key:"log",value:function(e,t,n){this.logger(e,t,n)}},{key:"hasLogger",value:function(){return null!==this.logger}},{key:"onOpen",value:function(e){var t=this.makeRef();return this.stateChangeCallbacks.open.push([t,e]),t}},{key:"onClose",value:function(e){var t=this.makeRef();return this.stateChangeCallbacks.close.push([t,e]),t}},{key:"onError",value:function(e){var t=this.makeRef();return this.stateChangeCallbacks.error.push([t,e]),t}},{key:"onMessage",value:function(e){var t=this.makeRef();return this.stateChangeCallbacks.message.push([t,e]),t}},{key:"onConnOpen",value:function(){this.hasLogger()&&this.log("transport","connected to ".concat(this.endPointURL())),this.unloaded=!1,this.closeWasClean=!1,this.flushSendBuffer(),this.reconnectTimer.reset(),this.resetHeartbeat(),this.stateChangeCallbacks.open.forEach((function(e){return(0,r(e,2)[1])()}))}},{key:"heartbeatTimeout",value:function(){this.pendingHeartbeatRef&&(this.pendingHeartbeatRef=null,this.hasLogger()&&this.log("transport","heartbeat timeout. Attempting to re-establish connection"),this.abnormalClose("heartbeat timeout"))}},{key:"resetHeartbeat",value:function(){var e=this;this.conn&&this.conn.skipHeartbeat||(this.pendingHeartbeatRef=null,clearTimeout(this.heartbeatTimer),setTimeout((function(){return e.sendHeartbeat()}),this.heartbeatIntervalMs))}},{key:"teardown",value:function(e,t,n){var i=this;if(!this.conn)return e&&e();this.waitForBufferDone((function(){i.conn&&(t?i.conn.close(t,n||""):i.conn.close()),i.waitForSocketClosed((function(){i.conn&&(i.conn.onclose=function(){},i.conn=null),e&&e()}))}))}},{key:"waitForBufferDone",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;5!==n&&this.conn&&this.conn.bufferedAmount?setTimeout((function(){t.waitForBufferDone(e,n+1)}),150*n):e()}},{key:"waitForSocketClosed",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;5!==n&&this.conn&&this.conn.readyState!==m?setTimeout((function(){t.waitForSocketClosed(e,n+1)}),150*n):e()}},{key:"onConnClose",value:function(e){this.hasLogger()&&this.log("transport","close",e),this.triggerChanError(),clearTimeout(this.heartbeatTimer),this.closeWasClean||this.reconnectTimer.scheduleTimeout(),this.stateChangeCallbacks.close.forEach((function(t){return(0,r(t,2)[1])(e)}))}},{key:"onConnError",value:function(e){this.hasLogger()&&this.log("transport",e),this.triggerChanError(),this.stateChangeCallbacks.error.forEach((function(t){return(0,r(t,2)[1])(e)}))}},{key:"triggerChanError",value:function(){this.channels.forEach((function(e){e.isErrored()||e.isLeaving()||e.isClosed()||e.trigger(R)}))}},{key:"connectionState",value:function(){switch(this.conn&&this.conn.readyState){case p:return"connecting";case v:return"open";case y:return"closing";default:return"closed"}}},{key:"isConnected",value:function(){return"open"===this.connectionState()}},{key:"remove",value:function(e){this.off(e.stateChangeRefs),this.channels=this.channels.filter((function(t){return t.joinRef()!==e.joinRef()}))}},{key:"off",value:function(e){for(var t in this.stateChangeCallbacks)this.stateChangeCallbacks[t]=this.stateChangeCallbacks[t].filter((function(t){var n=r(t,1)[0];return-1===e.indexOf(n)}))}},{key:"channel",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=new O(e,t,this);return this.channels.push(n),n}},{key:"push",value:function(e){var t=this;if(this.hasLogger()){var n=e.topic,i=e.event,o=e.payload,r=e.ref,s=e.join_ref;this.log("push","".concat(n," ").concat(i," (").concat(s,", ").concat(r,")"),o)}this.isConnected()?this.encode(e,(function(e){return t.conn.send(e)})):this.sendBuffer.push((function(){return t.encode(e,(function(e){return t.conn.send(e)}))}))}},{key:"makeRef",value:function(){var e=this.ref+1;return e===this.ref?this.ref=0:this.ref=e,this.ref.toString()}},{key:"sendHeartbeat",value:function(){var e=this;this.pendingHeartbeatRef&&!this.isConnected()||(this.pendingHeartbeatRef=this.makeRef(),this.push({topic:"phoenix",event:"heartbeat",payload:{},ref:this.pendingHeartbeatRef}),this.heartbeatTimer=setTimeout((function(){return e.heartbeatTimeout()}),this.heartbeatIntervalMs))}},{key:"abnormalClose",value:function(e){this.closeWasClean=!1,this.isConnected()&&this.conn.close(1e3,e)}},{key:"flushSendBuffer",value:function(){this.isConnected()&&this.sendBuffer.length>0&&(this.sendBuffer.forEach((function(e){return e()})),this.sendBuffer=[])}},{key:"onConnMessage",value:function(e){var t=this;this.decode(e.data,(function(e){var n=e.topic,i=e.event,o=e.payload,s=e.ref,a=e.join_ref;s&&s===t.pendingHeartbeatRef&&(clearTimeout(t.heartbeatTimer),t.pendingHeartbeatRef=null,setTimeout((function(){return t.sendHeartbeat()}),t.heartbeatIntervalMs)),t.hasLogger()&&t.log("receive","".concat(o.status||""," ").concat(n," ").concat(i," ").concat(s&&"("+s+")"||""),o);for(var c=0;c<t.channels.length;c++){var u=t.channels[c];u.isMember(n,i,o,a)&&u.trigger(i,o,s,a)}for(var h=0;h<t.stateChangeCallbacks.message.length;h++){(0,r(t.stateChangeCallbacks.message[h],2)[1])(e)}}))}},{key:"leaveOpenTopic",value:function(e){var t=this.channels.find((function(t){return t.topic===e&&(t.isJoined()||t.isJoining())}));t&&(this.hasLogger()&&this.log("transport",'leaving duplicate topic "'.concat(e,'"')),t.leave())}}]),e}(),U=function(){function e(t){c(this,e),this.endPoint=null,this.token=null,this.skipHeartbeat=!0,this.onopen=function(){},this.onerror=function(){},this.onmessage=function(){},this.onclose=function(){},this.pollEndpoint=this.normalizeEndpoint(t),this.readyState=p,this.poll()}return h(e,[{key:"normalizeEndpoint",value:function(e){return e.replace("ws://","http://").replace("wss://","https://").replace(new RegExp("(.*)/"+L),"$1/"+A)}},{key:"endpointURL",value:function(){return D.appendParams(this.pollEndpoint,{token:this.token})}},{key:"closeAndRetry",value:function(){this.close(),this.readyState=p}},{key:"ontimeout",value:function(){this.onerror("timeout"),this.closeAndRetry()}},{key:"poll",value:function(){var e=this;this.readyState!==v&&this.readyState!==p||D.request("GET",this.endpointURL(),"application/json",null,this.timeout,this.ontimeout.bind(this),(function(t){if(t){var n=t.status,i=t.token,o=t.messages;e.token=i}else n=0;switch(n){case 200:o.forEach((function(t){setTimeout((function(){e.onmessage({data:t})}),0)})),e.poll();break;case 204:e.poll();break;case 410:e.readyState=v,e.onopen(),e.poll();break;case 403:e.onerror(),e.close();break;case 0:case 500:e.onerror(),e.closeAndRetry();break;default:throw new Error("unhandled poll status ".concat(n))}}))}},{key:"send",value:function(e){var t=this;D.request("POST",this.endpointURL(),"application/json",e,this.timeout,this.onerror.bind(this,"timeout"),(function(e){e&&200===e.status||(t.onerror(e&&e.status),t.closeAndRetry())}))}},{key:"close",value:function(e,t){this.readyState=m,this.onclose()}}]),e}(),D=function(){function e(){c(this,e)}return h(e,null,[{key:"request",value:function(e,t,n,i,o,r,s){if(d.XDomainRequest){var a=new XDomainRequest;this.xdomainRequest(a,e,t,i,o,r,s)}else{var c=new d.XMLHttpRequest;this.xhrRequest(c,e,t,n,i,o,r,s)}}},{key:"xdomainRequest",value:function(e,t,n,i,o,r,s){var a=this;e.timeout=o,e.open(t,n),e.onload=function(){var t=a.parseJSON(e.responseText);s&&s(t)},r&&(e.ontimeout=r),e.onprogress=function(){},e.send(i)}},{key:"xhrRequest",value:function(e,t,n,i,o,r,s,a){var c=this;e.open(t,n,!0),e.timeout=r,e.setRequestHeader("Content-Type",i),e.onerror=function(){a&&a(null)},e.onreadystatechange=function(){if(e.readyState===c.states.complete&&a){var t=c.parseJSON(e.responseText);a(t)}},s&&(e.ontimeout=s),e.send(o)}},{key:"parseJSON",value:function(e){if(!e||""===e)return null;try{return JSON.parse(e)}catch(t){return console&&console.log("failed to parse JSON response",e),null}}},{key:"serialize",value:function(e,t){var n=[];for(var i in e)if(e.hasOwnProperty(i)){var r=t?"".concat(t,"[").concat(i,"]"):i,s=e[i];"object"===o(s)?n.push(this.serialize(s,r)):n.push(encodeURIComponent(r)+"="+encodeURIComponent(s))}return n.join("&")}},{key:"appendParams",value:function(e,t){if(0===Object.keys(t).length)return e;var n=e.match(/\?/)?"&":"?";return"".concat(e).concat(n).concat(this.serialize(t))}}]),e}();D.states={complete:4};var M=function(){function e(t){var n=this,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};c(this,e);var o=i.events||{state:"presence_state",diff:"presence_diff"};this.state={},this.pendingDiffs=[],this.channel=t,this.joinRef=null,this.caller={onJoin:function(){},onLeave:function(){},onSync:function(){}},this.channel.on(o.state,(function(t){var i=n.caller,o=i.onJoin,r=i.onLeave,s=i.onSync;n.joinRef=n.channel.joinRef(),n.state=e.syncState(n.state,t,o,r),n.pendingDiffs.forEach((function(t){n.state=e.syncDiff(n.state,t,o,r)})),n.pendingDiffs=[],s()})),this.channel.on(o.diff,(function(t){var i=n.caller,o=i.onJoin,r=i.onLeave,s=i.onSync;n.inPendingSyncState()?n.pendingDiffs.push(t):(n.state=e.syncDiff(n.state,t,o,r),s())}))}return h(e,[{key:"onJoin",value:function(e){this.caller.onJoin=e}},{key:"onLeave",value:function(e){this.caller.onLeave=e}},{key:"onSync",value:function(e){this.caller.onSync=e}},{key:"list",value:function(t){return e.list(this.state,t)}},{key:"inPendingSyncState",value:function(){return!this.joinRef||this.joinRef!==this.channel.joinRef()}}],[{key:"syncState",value:function(e,t,n,i){var o=this,r=this.clone(e),s={},a={};return this.map(r,(function(e,n){t[e]||(a[e]=n)})),this.map(t,(function(e,t){var n=r[e];if(n){var i=t.metas.map((function(e){return e.phx_ref})),c=n.metas.map((function(e){return e.phx_ref})),u=t.metas.filter((function(e){return c.indexOf(e.phx_ref)<0})),h=n.metas.filter((function(e){return i.indexOf(e.phx_ref)<0}));u.length>0&&(s[e]=t,s[e].metas=u),h.length>0&&(a[e]=o.clone(n),a[e].metas=h)}else s[e]=t})),this.syncDiff(r,{joins:s,leaves:a},n,i)}},{key:"syncDiff",value:function(e,t,n,o){var r=t.joins,s=t.leaves,a=this.clone(e);return n||(n=function(){}),o||(o=function(){}),this.map(r,(function(e,t){var o=a[e];if(a[e]=t,o){var r,s=a[e].metas.map((function(e){return e.phx_ref})),c=o.metas.filter((function(e){return s.indexOf(e.phx_ref)<0}));(r=a[e].metas).unshift.apply(r,i(c))}n(e,o,t)})),this.map(s,(function(e,t){var n=a[e];if(n){var i=t.metas.map((function(e){return e.phx_ref}));n.metas=n.metas.filter((function(e){return i.indexOf(e.phx_ref)<0})),o(e,n,t),0===n.metas.length&&delete a[e]}})),a}},{key:"list",value:function(e,t){return t||(t=function(e,t){return t}),this.map(e,(function(e,n){return t(e,n)}))}},{key:"map",value:function(e,t){return Object.getOwnPropertyNames(e).map((function(n){return t(n,e[n])}))}},{key:"clone",value:function(e){return JSON.parse(JSON.stringify(e))}}]),e}(),N=function(){function e(t,n){c(this,e),this.callback=t,this.timerCalc=n,this.timer=null,this.tries=0}return h(e,[{key:"reset",value:function(){this.tries=0,clearTimeout(this.timer)}},{key:"scheduleTimeout",value:function(){var e=this;clearTimeout(this.timer),this.timer=setTimeout((function(){e.tries=e.tries+1,e.callback()}),this.timerCalc(this.tries+1))}}]),e}()}])}));

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(1686);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	var util = __webpack_require__(1577);
	
	var Format = {
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};
	
	module.exports = util.assign(
	    {
	        'default': Format.RFC3986,
	        formatters: {
	            RFC1738: function (value) {
	                return replace.call(value, percentTwenties, '+');
	            },
	            RFC3986: function (value) {
	                return String(value);
	            }
	        }
	    },
	    Format
	);


/***/ }),
/* 2667 */
[6730, 995, 5782, 5783, 5784, 5785, 5786],
/* 2668 */
[6742, 2669, 1000],
/* 2669 */
[6762, 329, 1582, 5787, 5797],
/* 2670 */
[6712, 5710, 5718, 5740],
/* 2671 */
2696,
/* 2672 */
975,
/* 2673 */
[6789, 1584],
/* 2674 */
2699,
/* 2675 */
2700,
/* 2676 */
1008,
/* 2677 */
[6816, 5726, 740],
/* 2678 */
[6817, 2680, 1583],
/* 2679 */
[6819, 328, 5796],
/* 2680 */
[6820, 739, 1584],
/* 2681 */
[6823, 5730, 5739, 5776],
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */,
/* 2693 */,
/* 2694 */,
/* 2695 */,
/* 2696 */,
/* 2697 */,
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */,
/* 2702 */,
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(382));
	
	var _DayCell = __webpack_require__(1012);
	
	var _Month = _interopRequireDefault(__webpack_require__(5933));
	
	var _DateInput = _interopRequireDefault(__webpack_require__(5930));
	
	var _utils = __webpack_require__(1014);
	
	var _classnames3 = _interopRequireDefault(__webpack_require__(475));
	
	var _reactList = _interopRequireDefault(__webpack_require__(6232));
	
	var _shallowEqual = __webpack_require__(6482);
	
	var _dateFns = __webpack_require__(275);
	
	var _enUS = _interopRequireDefault(__webpack_require__(454));
	
	var _styles = _interopRequireDefault(__webpack_require__(1013));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Calendar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Calendar, _PureComponent);
	
	  function Calendar(_props, context) {
	    var _this;
	
	    _classCallCheck(this, Calendar);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Calendar).call(this, _props, context));
	
	    _defineProperty(_assertThisInitialized(_this), "focusToDate", function (date) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props;
	      var preventUnnecessary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (!props.scroll.enabled) {
	        _this.setState({
	          focusedDate: date
	        });
	
	        return;
	      }
	
	      var targetMonthIndex = (0, _dateFns.differenceInCalendarMonths)(date, props.minDate, _this.dateOptions);
	
	      var visibleMonths = _this.list.getVisibleRange();
	
	      if (preventUnnecessary && visibleMonths.includes(targetMonthIndex)) return;
	      _this.isFirstRender = true;
	
	      _this.list.scrollTo(targetMonthIndex);
	
	      _this.setState({
	        focusedDate: date
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateShownDate", function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	      var newProps = props.scroll.enabled ? _objectSpread({}, props, {
	        months: _this.list.getVisibleRange().length
	      }) : props;
	      var newFocus = (0, _utils.calcFocusDate)(_this.state.focusedDate, newProps);
	
	      _this.focusToDate(newFocus, newProps);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updatePreview", function (val) {
	      if (!val) {
	        _this.setState({
	          preview: null
	        });
	
	        return;
	      }
	
	      var preview = {
	        startDate: val,
	        endDate: val,
	        color: _this.props.color
	      };
	
	      _this.setState({
	        preview: preview
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeShownDate", function (value) {
	      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set';
	      var focusedDate = _this.state.focusedDate;
	      var _this$props = _this.props,
	          onShownDateChange = _this$props.onShownDateChange,
	          minDate = _this$props.minDate,
	          maxDate = _this$props.maxDate;
	      var modeMapper = {
	        monthOffset: function monthOffset() {
	          return (0, _dateFns.addMonths)(focusedDate, value);
	        },
	        setMonth: function setMonth() {
	          return (0, _dateFns.setMonth)(focusedDate, value);
	        },
	        setYear: function setYear() {
	          return (0, _dateFns.setYear)(focusedDate, value);
	        },
	        set: function set() {
	          return value;
	        }
	      };
	      var newDate = (0, _dateFns.min)([(0, _dateFns.max)([modeMapper[mode](), minDate]), maxDate]);
	
	      _this.focusToDate(newDate, _this.props, false);
	
	      onShownDateChange && onShownDateChange(newDate);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleRangeFocusChange", function (rangesIndex, rangeItemIndex) {
	      _this.props.onRangeFocusChange && _this.props.onRangeFocusChange([rangesIndex, rangeItemIndex]);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleScroll", function () {
	      var _this$props2 = _this.props,
	          onShownDateChange = _this$props2.onShownDateChange,
	          minDate = _this$props2.minDate;
	      var focusedDate = _this.state.focusedDate;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          isFirstRender = _assertThisInitialize.isFirstRender;
	
	      var visibleMonths = _this.list.getVisibleRange(); // prevent scroll jump with wrong visible value
	
	
	      if (visibleMonths[0] === undefined) return;
	      var visibleMonth = (0, _dateFns.addMonths)(minDate, visibleMonths[0] || 0);
	      var isFocusedToDifferent = !(0, _dateFns.isSameMonth)(visibleMonth, focusedDate);
	
	      if (isFocusedToDifferent && !isFirstRender) {
	        _this.setState({
	          focusedDate: visibleMonth
	        });
	
	        onShownDateChange && onShownDateChange(visibleMonth);
	      }
	
	      _this.isFirstRender = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderMonthAndYear", function (focusedDate, changeShownDate, props) {
	      var showMonthArrow = props.showMonthArrow,
	          minDate = props.minDate,
	          maxDate = props.maxDate,
	          showMonthAndYearPickers = props.showMonthAndYearPickers;
	      var upperYearLimit = (maxDate || Calendar.defaultProps.maxDate).getFullYear();
	      var lowerYearLimit = (minDate || Calendar.defaultProps.minDate).getFullYear();
	      var styles = _this.styles;
	      return _react["default"].createElement("div", {
	        onMouseUp: function onMouseUp(e) {
	          return e.stopPropagation();
	        },
	        className: styles.monthAndYearWrapper
	      }, showMonthArrow ? _react["default"].createElement("button", {
	        type: "button",
	        className: (0, _classnames3["default"])(styles.nextPrevButton, styles.prevButton),
	        onClick: function onClick() {
	          return changeShownDate(-1, 'monthOffset');
	        }
	      }, _react["default"].createElement("i", null)) : null, showMonthAndYearPickers ? _react["default"].createElement("span", {
	        className: styles.monthAndYearPickers
	      }, _react["default"].createElement("span", {
	        className: styles.monthPicker
	      }, _react["default"].createElement("select", {
	        value: focusedDate.getMonth(),
	        onChange: function onChange(e) {
	          return changeShownDate(e.target.value, 'setMonth');
	        }
	      }, _this.state.monthNames.map(function (monthName, i) {
	        return _react["default"].createElement("option", {
	          key: i,
	          value: i
	        }, monthName);
	      }))), _react["default"].createElement("span", {
	        className: styles.monthAndYearDivider
	      }), _react["default"].createElement("span", {
	        className: styles.yearPicker
	      }, _react["default"].createElement("select", {
	        value: focusedDate.getFullYear(),
	        onChange: function onChange(e) {
	          return changeShownDate(e.target.value, 'setYear');
	        }
	      }, new Array(upperYearLimit - lowerYearLimit + 1).fill(upperYearLimit).map(function (val, i) {
	        var year = val - i;
	        return _react["default"].createElement("option", {
	          key: year,
	          value: year
	        }, year);
	      })))) : _react["default"].createElement("span", {
	        className: styles.monthAndYearPickers
	      }, _this.state.monthNames[focusedDate.getMonth()], " ", focusedDate.getFullYear()), showMonthArrow ? _react["default"].createElement("button", {
	        type: "button",
	        className: (0, _classnames3["default"])(styles.nextPrevButton, styles.nextButton),
	        onClick: function onClick() {
	          return changeShownDate(+1, 'monthOffset');
	        }
	      }, _react["default"].createElement("i", null)) : null);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderDateDisplay", function () {
	      var _this$props3 = _this.props,
	          focusedRange = _this$props3.focusedRange,
	          color = _this$props3.color,
	          ranges = _this$props3.ranges,
	          rangeColors = _this$props3.rangeColors,
	          dateDisplayFormat = _this$props3.dateDisplayFormat,
	          editableDateInputs = _this$props3.editableDateInputs,
	          startDatePlaceholder = _this$props3.startDatePlaceholder,
	          endDatePlaceholder = _this$props3.endDatePlaceholder;
	      var defaultColor = rangeColors[focusedRange[0]] || color;
	      var styles = _this.styles;
	      return _react["default"].createElement("div", {
	        className: styles.dateDisplayWrapper
	      }, ranges.map(function (range, i) {
	        if (range.showDateDisplay === false || range.disabled && !range.showDateDisplay) return null;
	        return _react["default"].createElement("div", {
	          className: styles.dateDisplay,
	          key: i,
	          style: {
	            color: range.color || defaultColor
	          }
	        }, _react["default"].createElement(_DateInput["default"], {
	          className: (0, _classnames3["default"])(styles.dateDisplayItem, _defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 0)),
	          readOnly: !editableDateInputs,
	          disabled: range.disabled,
	          value: range.startDate,
	          placeholder: startDatePlaceholder,
	          dateOptions: _this.dateOptions,
	          dateDisplayFormat: dateDisplayFormat,
	          onChange: _this.onDragSelectionEnd,
	          onFocus: function onFocus() {
	            return _this.handleRangeFocusChange(i, 0);
	          }
	        }), _react["default"].createElement(_DateInput["default"], {
	          className: (0, _classnames3["default"])(styles.dateDisplayItem, _defineProperty({}, styles.dateDisplayItemActive, focusedRange[0] === i && focusedRange[1] === 1)),
	          readOnly: !editableDateInputs,
	          disabled: range.disabled,
	          value: range.endDate,
	          placeholder: endDatePlaceholder,
	          dateOptions: _this.dateOptions,
	          dateDisplayFormat: dateDisplayFormat,
	          onChange: _this.onDragSelectionEnd,
	          onFocus: function onFocus() {
	            return _this.handleRangeFocusChange(i, 1);
	          }
	        }));
	      }));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragSelectionStart", function (date) {
	      var _this$props4 = _this.props,
	          onChange = _this$props4.onChange,
	          dragSelectionEnabled = _this$props4.dragSelectionEnabled;
	
	      if (dragSelectionEnabled) {
	        _this.setState({
	          drag: {
	            status: true,
	            range: {
	              startDate: date,
	              endDate: date
	            },
	            disablePreview: true
	          }
	        });
	      } else {
	        onChange && onChange(date);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragSelectionEnd", function (date) {
	      var _this$props5 = _this.props,
	          updateRange = _this$props5.updateRange,
	          displayMode = _this$props5.displayMode,
	          onChange = _this$props5.onChange,
	          dragSelectionEnabled = _this$props5.dragSelectionEnabled;
	      if (!dragSelectionEnabled) return;
	
	      if (displayMode === 'date' || !_this.state.drag.status) {
	        onChange && onChange(date);
	        return;
	      }
	
	      var newRange = {
	        startDate: _this.state.drag.range.startDate,
	        endDate: date
	      };
	
	      if (displayMode !== 'dateRange' || (0, _dateFns.isSameDay)(newRange.startDate, date)) {
	        _this.setState({
	          drag: {
	            status: false,
	            range: {}
	          }
	        }, function () {
	          return onChange && onChange(date);
	        });
	      } else {
	        _this.setState({
	          drag: {
	            status: false,
	            range: {}
	          }
	        }, function () {
	          updateRange && updateRange(newRange);
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDragSelectionMove", function (date) {
	      var drag = _this.state.drag;
	      if (!drag.status || !_this.props.dragSelectionEnabled) return;
	
	      _this.setState({
	        drag: {
	          status: drag.status,
	          range: {
	            startDate: drag.range.startDate,
	            endDate: date
	          },
	          disablePreview: true
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "estimateMonthSize", function (index, cache) {
	      var _this$props6 = _this.props,
	          direction = _this$props6.direction,
	          minDate = _this$props6.minDate;
	      var scrollArea = _this.state.scrollArea;
	
	      if (cache) {
	        _this.listSizeCache = cache;
	        if (cache[index]) return cache[index];
	      }
	
	      if (direction === 'horizontal') return scrollArea.monthWidth;
	      var monthStep = (0, _dateFns.addMonths)(minDate, index);
	
	      var _getMonthDisplayRange = (0, _utils.getMonthDisplayRange)(monthStep, _this.dateOptions),
	          start = _getMonthDisplayRange.start,
	          end = _getMonthDisplayRange.end;
	
	      var isLongMonth = (0, _dateFns.differenceInDays)(end, start, _this.dateOptions) + 1 > 7 * 5;
	      return isLongMonth ? scrollArea.longMonthHeight : scrollArea.monthHeight;
	    });
	
	    _this.dateOptions = {
	      locale: _props.locale
	    };
	    if (_props.weekStartsOn !== undefined) _this.dateOptions.weekStartsOn = _props.weekStartsOn;
	    _this.styles = (0, _utils.generateStyles)([_styles["default"], _props.classNames]);
	    _this.listSizeCache = {};
	    _this.isFirstRender = true;
	    _this.state = {
	      monthNames: _this.getMonthNames(),
	      focusedDate: (0, _utils.calcFocusDate)(null, _props),
	      drag: {
	        status: false,
	        range: {
	          startDate: null,
	          endDate: null
	        },
	        disablePreview: false
	      },
	      scrollArea: _this.calcScrollArea(_props)
	    };
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: "getMonthNames",
	    value: function getMonthNames() {
	      var _this2 = this;
	
	      return _toConsumableArray(Array(12).keys()).map(function (i) {
	        return _this2.props.locale.localize.month(i);
	      });
	    }
	  }, {
	    key: "calcScrollArea",
	    value: function calcScrollArea(props) {
	      var direction = props.direction,
	          months = props.months,
	          scroll = props.scroll;
	      if (!scroll.enabled) return {
	        enabled: false
	      };
	      var longMonthHeight = scroll.longMonthHeight || scroll.monthHeight;
	
	      if (direction === 'vertical') {
	        return {
	          enabled: true,
	          monthHeight: scroll.monthHeight || 220,
	          longMonthHeight: longMonthHeight || 260,
	          calendarWidth: 'auto',
	          calendarHeight: (scroll.calendarHeight || longMonthHeight || 240) * months
	        };
	      }
	
	      return {
	        enabled: true,
	        monthWidth: scroll.monthWidth || 332,
	        calendarWidth: (scroll.calendarWidth || scroll.monthWidth || 332) * months,
	        monthHeight: longMonthHeight || 300,
	        calendarHeight: longMonthHeight || 300
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      if (this.props.scroll.enabled) {
	        // prevent react-list's initial render focus problem
	        setTimeout(function () {
	          return _this3.focusToDate(_this3.state.focusedDate);
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var propMapper = {
	        dateRange: 'ranges',
	        date: 'date'
	      };
	      var targetProp = propMapper[this.props.displayMode];
	
	      if (this.props[targetProp] !== prevProps[targetProp]) {
	        this.updateShownDate(this.props);
	      }
	
	      if (prevProps.locale !== this.props.locale || prevProps.weekStartsOn !== this.props.weekStartsOn) {
	        this.dateOptions = {
	          locale: this.props.locale
	        };
	        if (this.props.weekStartsOn !== undefined) this.dateOptions.weekStartsOn = this.props.weekStartsOn;
	        this.setState({
	          monthNames: this.getMonthNames()
	        });
	      }
	
	      if (!(0, _shallowEqual.shallowEqualObjects)(prevProps.scroll, this.props.scroll)) {
	        this.setState({
	          scrollArea: this.calcScrollArea(this.props)
	        });
	      }
	    }
	  }, {
	    key: "renderWeekdays",
	    value: function renderWeekdays() {
	      var _this4 = this;
	
	      var now = new Date();
	      return _react["default"].createElement("div", {
	        className: this.styles.weekDays
	      }, (0, _dateFns.eachDayOfInterval)({
	        start: (0, _dateFns.startOfWeek)(now, this.dateOptions),
	        end: (0, _dateFns.endOfWeek)(now, this.dateOptions)
	      }).map(function (day, i) {
	        return _react["default"].createElement("span", {
	          className: _this4.styles.weekDay,
	          key: i
	        }, (0, _dateFns.format)(day, _this4.props.weekdayDisplayFormat, _this4.dateOptions));
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this5 = this;
	
	      var _this$props7 = this.props,
	          showDateDisplay = _this$props7.showDateDisplay,
	          onPreviewChange = _this$props7.onPreviewChange,
	          scroll = _this$props7.scroll,
	          direction = _this$props7.direction,
	          disabledDates = _this$props7.disabledDates,
	          disabledDay = _this$props7.disabledDay,
	          maxDate = _this$props7.maxDate,
	          minDate = _this$props7.minDate,
	          rangeColors = _this$props7.rangeColors,
	          color = _this$props7.color,
	          navigatorRenderer = _this$props7.navigatorRenderer,
	          className = _this$props7.className,
	          preview = _this$props7.preview;
	      var _this$state = this.state,
	          scrollArea = _this$state.scrollArea,
	          focusedDate = _this$state.focusedDate;
	      var isVertical = direction === 'vertical';
	      var monthAndYearRenderer = navigatorRenderer || this.renderMonthAndYear;
	      var ranges = this.props.ranges.map(function (range, i) {
	        return _objectSpread({}, range, {
	          color: range.color || rangeColors[i] || color
	        });
	      });
	      return _react["default"].createElement("div", {
	        className: (0, _classnames3["default"])(this.styles.calendarWrapper, className),
	        onMouseUp: function onMouseUp() {
	          return _this5.setState({
	            drag: {
	              status: false,
	              range: {}
	            }
	          });
	        },
	        onMouseLeave: function onMouseLeave() {
	          _this5.setState({
	            drag: {
	              status: false,
	              range: {}
	            }
	          });
	        }
	      }, showDateDisplay && this.renderDateDisplay(), monthAndYearRenderer(focusedDate, this.changeShownDate, this.props), scroll.enabled ? _react["default"].createElement("div", null, isVertical && this.renderWeekdays(this.dateOptions), _react["default"].createElement("div", {
	        className: (0, _classnames3["default"])(this.styles.infiniteMonths, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal),
	        onMouseLeave: function onMouseLeave() {
	          return onPreviewChange && onPreviewChange();
	        },
	        style: {
	          width: scrollArea.calendarWidth + 11,
	          height: scrollArea.calendarHeight + 11
	        },
	        onScroll: this.handleScroll
	      }, _react["default"].createElement(_reactList["default"], {
	        length: (0, _dateFns.differenceInCalendarMonths)((0, _dateFns.endOfMonth)(maxDate), (0, _dateFns.addDays)((0, _dateFns.startOfMonth)(minDate), -1), this.dateOptions),
	        treshold: 500,
	        type: "variable",
	        ref: function ref(target) {
	          return _this5.list = target;
	        },
	        itemSizeEstimator: this.estimateMonthSize,
	        axis: isVertical ? 'y' : 'x',
	        itemRenderer: function itemRenderer(index, key) {
	          var monthStep = (0, _dateFns.addMonths)(minDate, index);
	          return _react["default"].createElement(_Month["default"], _extends({}, _this5.props, {
	            onPreviewChange: onPreviewChange || _this5.updatePreview,
	            preview: preview || _this5.state.preview,
	            ranges: ranges,
	            key: key,
	            drag: _this5.state.drag,
	            dateOptions: _this5.dateOptions,
	            disabledDates: disabledDates,
	            disabledDay: disabledDay,
	            month: monthStep,
	            onDragSelectionStart: _this5.onDragSelectionStart,
	            onDragSelectionEnd: _this5.onDragSelectionEnd,
	            onDragSelectionMove: _this5.onDragSelectionMove,
	            onMouseLeave: function onMouseLeave() {
	              return onPreviewChange && onPreviewChange();
	            },
	            styles: _this5.styles,
	            style: isVertical ? {
	              height: _this5.estimateMonthSize(index)
	            } : {
	              height: scrollArea.monthHeight,
	              width: _this5.estimateMonthSize(index)
	            },
	            showMonthName: true,
	            showWeekDays: !isVertical
	          }));
	        }
	      }))) : _react["default"].createElement("div", {
	        className: (0, _classnames3["default"])(this.styles.months, isVertical ? this.styles.monthsVertical : this.styles.monthsHorizontal)
	      }, new Array(this.props.months).fill(null).map(function (_, i) {
	        var monthStep = (0, _dateFns.addMonths)(_this5.state.focusedDate, i);
	        return _react["default"].createElement(_Month["default"], _extends({}, _this5.props, {
	          onPreviewChange: onPreviewChange || _this5.updatePreview,
	          preview: preview || _this5.state.preview,
	          ranges: ranges,
	          key: i,
	          drag: _this5.state.drag,
	          dateOptions: _this5.dateOptions,
	          disabledDates: disabledDates,
	          disabledDay: disabledDay,
	          month: monthStep,
	          onDragSelectionStart: _this5.onDragSelectionStart,
	          onDragSelectionEnd: _this5.onDragSelectionEnd,
	          onDragSelectionMove: _this5.onDragSelectionMove,
	          onMouseLeave: function onMouseLeave() {
	            return onPreviewChange && onPreviewChange();
	          },
	          styles: _this5.styles,
	          showWeekDays: !isVertical || i === 0,
	          showMonthName: !isVertical || i > 0
	        }));
	      })));
	    }
	  }]);
	
	  return Calendar;
	}(_react.PureComponent);
	
	Calendar.defaultProps = {
	  showMonthArrow: true,
	  showMonthAndYearPickers: true,
	  disabledDates: [],
	  disabledDay: function disabledDay() {},
	  classNames: {},
	  locale: _enUS["default"],
	  ranges: [],
	  focusedRange: [0, 0],
	  dateDisplayFormat: 'MMM d, yyyy',
	  monthDisplayFormat: 'MMM yyyy',
	  weekdayDisplayFormat: 'E',
	  dayDisplayFormat: 'd',
	  showDateDisplay: true,
	  showPreview: true,
	  displayMode: 'date',
	  months: 1,
	  color: '#3d91ff',
	  scroll: {
	    enabled: false
	  },
	  direction: 'vertical',
	  maxDate: (0, _dateFns.addYears)(new Date(), 20),
	  minDate: (0, _dateFns.addYears)(new Date(), -100),
	  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c'],
	  startDatePlaceholder: 'Early',
	  endDatePlaceholder: 'Continuous',
	  editableDateInputs: false,
	  dragSelectionEnabled: true,
	  fixedHeight: false
	};
	Calendar.propTypes = {
	  showMonthArrow: _propTypes["default"].bool,
	  showMonthAndYearPickers: _propTypes["default"].bool,
	  disabledDates: _propTypes["default"].array,
	  disabledDay: _propTypes["default"].func,
	  minDate: _propTypes["default"].object,
	  maxDate: _propTypes["default"].object,
	  date: _propTypes["default"].object,
	  onChange: _propTypes["default"].func,
	  onPreviewChange: _propTypes["default"].func,
	  onRangeFocusChange: _propTypes["default"].func,
	  classNames: _propTypes["default"].object,
	  locale: _propTypes["default"].object,
	  shownDate: _propTypes["default"].object,
	  onShownDateChange: _propTypes["default"].func,
	  ranges: _propTypes["default"].arrayOf(_DayCell.rangeShape),
	  preview: _propTypes["default"].shape({
	    startDate: _propTypes["default"].object,
	    endDate: _propTypes["default"].object,
	    color: _propTypes["default"].string
	  }),
	  dateDisplayFormat: _propTypes["default"].string,
	  monthDisplayFormat: _propTypes["default"].string,
	  weekdayDisplayFormat: _propTypes["default"].string,
	  weekStartsOn: _propTypes["default"].number,
	  dayDisplayFormat: _propTypes["default"].string,
	  focusedRange: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  initialFocusedRange: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  months: _propTypes["default"].number,
	  className: _propTypes["default"].string,
	  showDateDisplay: _propTypes["default"].bool,
	  showPreview: _propTypes["default"].bool,
	  displayMode: _propTypes["default"].oneOf(['dateRange', 'date']),
	  color: _propTypes["default"].string,
	  updateRange: _propTypes["default"].func,
	  scroll: _propTypes["default"].shape({
	    enabled: _propTypes["default"].bool,
	    monthHeight: _propTypes["default"].number,
	    longMonthHeight: _propTypes["default"].number,
	    monthWidth: _propTypes["default"].number,
	    calendarWidth: _propTypes["default"].number,
	    calendarHeight: _propTypes["default"].number
	  }),
	  direction: _propTypes["default"].oneOf(['vertical', 'horizontal']),
	  startDatePlaceholder: _propTypes["default"].string,
	  endDatePlaceholder: _propTypes["default"].string,
	  navigatorRenderer: _propTypes["default"].func,
	  rangeColors: _propTypes["default"].arrayOf(_propTypes["default"].string),
	  editableDateInputs: _propTypes["default"].bool,
	  dragSelectionEnabled: _propTypes["default"].bool,
	  fixedHeight: _propTypes["default"].bool
	};
	var _default = Calendar;
	exports["default"] = _default;

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(382));
	
	var _Calendar = _interopRequireDefault(__webpack_require__(2706));
	
	var _DayCell = __webpack_require__(1012);
	
	var _utils = __webpack_require__(1014);
	
	var _dateFns = __webpack_require__(275);
	
	var _classnames = _interopRequireDefault(__webpack_require__(475));
	
	var _styles = _interopRequireDefault(__webpack_require__(1013));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DateRange =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DateRange, _Component);
	
	  function DateRange(props, context) {
	    var _this;
	
	    _classCallCheck(this, DateRange);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRange).call(this, props, context));
	
	    _defineProperty(_assertThisInitialized(_this), "calcNewSelection", function (value) {
	      var isSingleValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var focusedRange = _this.props.focusedRange || _this.state.focusedRange;
	      var _this$props = _this.props,
	          ranges = _this$props.ranges,
	          onChange = _this$props.onChange,
	          maxDate = _this$props.maxDate,
	          moveRangeOnFirstSelection = _this$props.moveRangeOnFirstSelection,
	          disabledDates = _this$props.disabledDates;
	      var focusedRangeIndex = focusedRange[0];
	      var selectedRange = ranges[focusedRangeIndex];
	      if (!selectedRange || !onChange) return {};
	      var startDate = selectedRange.startDate,
	          endDate = selectedRange.endDate;
	      if (!endDate) endDate = new Date(startDate);
	      var nextFocusRange;
	
	      if (!isSingleValue) {
	        startDate = value.startDate;
	        endDate = value.endDate;
	      } else if (focusedRange[1] === 0) {
	        // startDate selection
	        var dayOffset = (0, _dateFns.differenceInCalendarDays)(endDate, startDate);
	        startDate = value;
	        endDate = moveRangeOnFirstSelection ? (0, _dateFns.addDays)(value, dayOffset) : value;
	        if (maxDate) endDate = (0, _dateFns.min)([endDate, maxDate]);
	        nextFocusRange = [focusedRange[0], 1];
	      } else {
	        endDate = value;
	      } // reverse dates if startDate before endDate
	
	
	      var isStartDateSelected = focusedRange[1] === 0;
	
	      if ((0, _dateFns.isBefore)(endDate, startDate)) {
	        isStartDateSelected = !isStartDateSelected;
	        var _ref = [endDate, startDate];
	        startDate = _ref[0];
	        endDate = _ref[1];
	      }
	
	      var inValidDatesWithinRange = disabledDates.filter(function (disabledDate) {
	        return (0, _dateFns.isWithinInterval)(disabledDate, {
	          start: startDate,
	          end: endDate
	        });
	      });
	
	      if (inValidDatesWithinRange.length > 0) {
	        if (isStartDateSelected) {
	          startDate = (0, _dateFns.addDays)((0, _dateFns.max)(inValidDatesWithinRange), 1);
	        } else {
	          endDate = (0, _dateFns.addDays)((0, _dateFns.min)(inValidDatesWithinRange), -1);
	        }
	      }
	
	      if (!nextFocusRange) {
	        var nextFocusRangeIndex = (0, _utils.findNextRangeIndex)(_this.props.ranges, focusedRange[0]);
	        nextFocusRange = [nextFocusRangeIndex, 0];
	      }
	
	      return {
	        wasValid: !(inValidDatesWithinRange.length > 0),
	        range: {
	          startDate: startDate,
	          endDate: endDate
	        },
	        nextFocusRange: nextFocusRange
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setSelection", function (value, isSingleValue) {
	      var _this$props2 = _this.props,
	          onChange = _this$props2.onChange,
	          ranges = _this$props2.ranges,
	          onRangeFocusChange = _this$props2.onRangeFocusChange;
	      var focusedRange = _this.props.focusedRange || _this.state.focusedRange;
	      var focusedRangeIndex = focusedRange[0];
	      var selectedRange = ranges[focusedRangeIndex];
	      if (!selectedRange) return;
	
	      var newSelection = _this.calcNewSelection(value, isSingleValue);
	
	      onChange(_defineProperty({}, selectedRange.key || "range".concat(focusedRangeIndex + 1), _objectSpread({}, selectedRange, {}, newSelection.range)));
	
	      _this.setState({
	        focusedRange: newSelection.nextFocusRange,
	        preview: null
	      });
	
	      onRangeFocusChange && onRangeFocusChange(newSelection.nextFocusRange);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleRangeFocusChange", function (focusedRange) {
	      _this.setState({
	        focusedRange: focusedRange
	      });
	
	      _this.props.onRangeFocusChange && _this.props.onRangeFocusChange(focusedRange);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updatePreview", function (val) {
	      if (!val) {
	        _this.setState({
	          preview: null
	        });
	
	        return;
	      }
	
	      var _this$props3 = _this.props,
	          rangeColors = _this$props3.rangeColors,
	          ranges = _this$props3.ranges;
	      var focusedRange = _this.props.focusedRange || _this.state.focusedRange;
	      var color = ranges[focusedRange[0]].color || rangeColors[focusedRange[0]] || color;
	
	      _this.setState({
	        preview: _objectSpread({}, val.range, {
	          color: color
	        })
	      });
	    });
	
	    _this.state = {
	      focusedRange: props.initialFocusedRange || [(0, _utils.findNextRangeIndex)(props.ranges), 0],
	      preview: null
	    };
	    _this.styles = (0, _utils.generateStyles)([_styles["default"], props.classNames]);
	    return _this;
	  }
	
	  _createClass(DateRange, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react["default"].createElement(_Calendar["default"], _extends({
	        focusedRange: this.state.focusedRange,
	        onRangeFocusChange: this.handleRangeFocusChange,
	        preview: this.state.preview,
	        onPreviewChange: function onPreviewChange(value) {
	          _this2.updatePreview(value ? _this2.calcNewSelection(value) : null);
	        }
	      }, this.props, {
	        displayMode: "dateRange",
	        className: (0, _classnames["default"])(this.styles.dateRangeWrapper, this.props.className),
	        onChange: this.setSelection,
	        updateRange: function updateRange(val) {
	          return _this2.setSelection(val, false);
	        },
	        ref: function ref(target) {
	          _this2.calendar = target;
	        }
	      }));
	    }
	  }]);
	
	  return DateRange;
	}(_react.Component);
	
	DateRange.defaultProps = {
	  classNames: {},
	  ranges: [],
	  moveRangeOnFirstSelection: false,
	  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c'],
	  disabledDates: []
	};
	DateRange.propTypes = _objectSpread({}, _Calendar["default"].propTypes, {
	  onChange: _propTypes["default"].func,
	  onRangeFocusChange: _propTypes["default"].func,
	  className: _propTypes["default"].string,
	  ranges: _propTypes["default"].arrayOf(_DayCell.rangeShape),
	  moveRangeOnFirstSelection: _propTypes["default"].bool
	});
	var _default = DateRange;
	exports["default"] = _default;

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(382));
	
	var _styles = _interopRequireDefault(__webpack_require__(1013));
	
	var _defaultRanges = __webpack_require__(2709);
	
	var _DayCell = __webpack_require__(1012);
	
	var _InputRangeField = _interopRequireDefault(__webpack_require__(5932));
	
	var _classnames = _interopRequireDefault(__webpack_require__(475));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DefinedRange =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DefinedRange, _Component);
	
	  function DefinedRange(props) {
	    var _this;
	
	    _classCallCheck(this, DefinedRange);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DefinedRange).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "handleRangeChange", function (range) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          ranges = _this$props.ranges,
	          focusedRange = _this$props.focusedRange;
	      var selectedRange = ranges[focusedRange[0]];
	      if (!onChange || !selectedRange) return;
	      onChange(_defineProperty({}, selectedRange.key || "range".concat(focusedRange[0] + 1), _objectSpread({}, selectedRange, {}, range)));
	    });
	
	    _this.state = {
	      rangeOffset: 0,
	      focusedInput: -1
	    };
	    return _this;
	  }
	
	  _createClass(DefinedRange, [{
	    key: "getRangeOptionValue",
	    value: function getRangeOptionValue(option) {
	      var _this$props2 = this.props,
	          _this$props2$ranges = _this$props2.ranges,
	          ranges = _this$props2$ranges === void 0 ? [] : _this$props2$ranges,
	          _this$props2$focusedR = _this$props2.focusedRange,
	          focusedRange = _this$props2$focusedR === void 0 ? [] : _this$props2$focusedR;
	
	      if (typeof option.getCurrentValue !== 'function') {
	        return '';
	      }
	
	      var selectedRange = ranges[focusedRange[0]] || {};
	      return option.getCurrentValue(selectedRange) || '';
	    }
	  }, {
	    key: "getSelectedRange",
	    value: function getSelectedRange(ranges, staticRange) {
	      var focusedRangeIndex = ranges.findIndex(function (range) {
	        if (!range.startDate || !range.endDate || range.disabled) return false;
	        return staticRange.isSelected(range);
	      });
	      var selectedRange = ranges[focusedRangeIndex];
	      return {
	        selectedRange: selectedRange,
	        focusedRangeIndex: focusedRangeIndex
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          headerContent = _this$props3.headerContent,
	          footerContent = _this$props3.footerContent,
	          onPreviewChange = _this$props3.onPreviewChange,
	          inputRanges = _this$props3.inputRanges,
	          staticRanges = _this$props3.staticRanges,
	          ranges = _this$props3.ranges,
	          renderStaticRangeLabel = _this$props3.renderStaticRangeLabel,
	          rangeColors = _this$props3.rangeColors,
	          className = _this$props3.className;
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])(_styles["default"].definedRangesWrapper, className)
	      }, headerContent, _react["default"].createElement("div", {
	        className: _styles["default"].staticRanges
	      }, staticRanges.map(function (staticRange, i) {
	        var _this2$getSelectedRan = _this2.getSelectedRange(ranges, staticRange),
	            selectedRange = _this2$getSelectedRan.selectedRange,
	            focusedRangeIndex = _this2$getSelectedRan.focusedRangeIndex;
	
	        var labelContent;
	
	        if (staticRange.hasCustomRendering) {
	          labelContent = renderStaticRangeLabel(staticRange);
	        } else {
	          labelContent = staticRange.label;
	        }
	
	        return _react["default"].createElement("button", {
	          type: "button",
	          className: (0, _classnames["default"])(_styles["default"].staticRange, _defineProperty({}, _styles["default"].staticRangeSelected, Boolean(selectedRange))),
	          style: {
	            color: selectedRange ? selectedRange.color || rangeColors[focusedRangeIndex] : null
	          },
	          key: i,
	          onClick: function onClick() {
	            return _this2.handleRangeChange(staticRange.range(_this2.props));
	          },
	          onFocus: function onFocus() {
	            return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
	          },
	          onMouseOver: function onMouseOver() {
	            return onPreviewChange && onPreviewChange(staticRange.range(_this2.props));
	          },
	          onMouseLeave: function onMouseLeave() {
	            onPreviewChange && onPreviewChange();
	          }
	        }, _react["default"].createElement("span", {
	          tabIndex: -1,
	          className: _styles["default"].staticRangeLabel
	        }, labelContent));
	      })), _react["default"].createElement("div", {
	        className: _styles["default"].inputRanges
	      }, inputRanges.map(function (rangeOption, i) {
	        return _react["default"].createElement(_InputRangeField["default"], {
	          key: i,
	          styles: _styles["default"],
	          label: rangeOption.label,
	          onFocus: function onFocus() {
	            return _this2.setState({
	              focusedInput: i,
	              rangeOffset: 0
	            });
	          },
	          onBlur: function onBlur() {
	            return _this2.setState({
	              rangeOffset: 0
	            });
	          },
	          onChange: function onChange(value) {
	            return _this2.handleRangeChange(rangeOption.range(value, _this2.props));
	          },
	          value: _this2.getRangeOptionValue(rangeOption)
	        });
	      })), footerContent);
	    }
	  }]);
	
	  return DefinedRange;
	}(_react.Component);
	
	DefinedRange.propTypes = {
	  inputRanges: _propTypes["default"].array,
	  staticRanges: _propTypes["default"].array,
	  ranges: _propTypes["default"].arrayOf(_DayCell.rangeShape),
	  focusedRange: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  onPreviewChange: _propTypes["default"].func,
	  onChange: _propTypes["default"].func,
	  footerContent: _propTypes["default"].any,
	  headerContent: _propTypes["default"].any,
	  rangeColors: _propTypes["default"].arrayOf(_propTypes["default"].string),
	  className: _propTypes["default"].string,
	  renderStaticRangeLabel: _propTypes["default"].func
	};
	DefinedRange.defaultProps = {
	  inputRanges: _defaultRanges.defaultInputRanges,
	  staticRanges: _defaultRanges.defaultStaticRanges,
	  ranges: [],
	  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c'],
	  focusedRange: [0, 0]
	};
	var _default = DefinedRange;
	exports["default"] = _default;

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createStaticRanges = createStaticRanges;
	exports.defaultInputRanges = exports.defaultStaticRanges = void 0;
	
	var _dateFns = __webpack_require__(275);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defineds = {
	  startOfWeek: (0, _dateFns.startOfWeek)(new Date()),
	  endOfWeek: (0, _dateFns.endOfWeek)(new Date()),
	  startOfLastWeek: (0, _dateFns.startOfWeek)((0, _dateFns.addDays)(new Date(), -7)),
	  endOfLastWeek: (0, _dateFns.endOfWeek)((0, _dateFns.addDays)(new Date(), -7)),
	  startOfToday: (0, _dateFns.startOfDay)(new Date()),
	  endOfToday: (0, _dateFns.endOfDay)(new Date()),
	  startOfYesterday: (0, _dateFns.startOfDay)((0, _dateFns.addDays)(new Date(), -1)),
	  endOfYesterday: (0, _dateFns.endOfDay)((0, _dateFns.addDays)(new Date(), -1)),
	  startOfMonth: (0, _dateFns.startOfMonth)(new Date()),
	  endOfMonth: (0, _dateFns.endOfMonth)(new Date()),
	  startOfLastMonth: (0, _dateFns.startOfMonth)((0, _dateFns.addMonths)(new Date(), -1)),
	  endOfLastMonth: (0, _dateFns.endOfMonth)((0, _dateFns.addMonths)(new Date(), -1))
	};
	var staticRangeHandler = {
	  range: {},
	  isSelected: function isSelected(range) {
	    var definedRange = this.range();
	    return (0, _dateFns.isSameDay)(range.startDate, definedRange.startDate) && (0, _dateFns.isSameDay)(range.endDate, definedRange.endDate);
	  }
	};
	
	function createStaticRanges(ranges) {
	  return ranges.map(function (range) {
	    return _objectSpread({}, staticRangeHandler, {}, range);
	  });
	}
	
	var defaultStaticRanges = createStaticRanges([{
	  label: 'Today',
	  range: function range() {
	    return {
	      startDate: defineds.startOfToday,
	      endDate: defineds.endOfToday
	    };
	  }
	}, {
	  label: 'Yesterday',
	  range: function range() {
	    return {
	      startDate: defineds.startOfYesterday,
	      endDate: defineds.endOfYesterday
	    };
	  }
	}, {
	  label: 'This Week',
	  range: function range() {
	    return {
	      startDate: defineds.startOfWeek,
	      endDate: defineds.endOfWeek
	    };
	  }
	}, {
	  label: 'Last Week',
	  range: function range() {
	    return {
	      startDate: defineds.startOfLastWeek,
	      endDate: defineds.endOfLastWeek
	    };
	  }
	}, {
	  label: 'This Month',
	  range: function range() {
	    return {
	      startDate: defineds.startOfMonth,
	      endDate: defineds.endOfMonth
	    };
	  }
	}, {
	  label: 'Last Month',
	  range: function range() {
	    return {
	      startDate: defineds.startOfLastMonth,
	      endDate: defineds.endOfLastMonth
	    };
	  }
	}]);
	exports.defaultStaticRanges = defaultStaticRanges;
	var defaultInputRanges = [{
	  label: 'days up to today',
	  range: function range(value) {
	    return {
	      startDate: (0, _dateFns.addDays)(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
	      endDate: defineds.endOfToday
	    };
	  },
	  getCurrentValue: function getCurrentValue(range) {
	    if (!(0, _dateFns.isSameDay)(range.endDate, defineds.endOfToday)) return '-';
	    if (!range.startDate) return '∞';
	    return (0, _dateFns.differenceInCalendarDays)(defineds.endOfToday, range.startDate) + 1;
	  }
	}, {
	  label: 'days starting today',
	  range: function range(value) {
	    var today = new Date();
	    return {
	      startDate: today,
	      endDate: (0, _dateFns.addDays)(today, Math.max(Number(value), 1) - 1)
	    };
	  },
	  getCurrentValue: function getCurrentValue(range) {
	    if (!(0, _dateFns.isSameDay)(range.startDate, defineds.startOfToday)) return '-';
	    if (!range.endDate) return '∞';
	    return (0, _dateFns.differenceInCalendarDays)(range.endDate, defineds.startOfToday) + 1;
	  }
	}];
	exports.defaultInputRanges = defaultInputRanges;

/***/ }),
/* 2710 */
1060,
/* 2711 */
560,
/* 2712 */
2182,
/* 2713 */
[6636, 62, 1017, 5950, 47],
/* 2714 */
[6637, 62, 1017, 47],
/* 2715 */
[6638, 62, 1018, 5951, 47],
/* 2716 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	
	function throwProtectedError(token) {
	  if (token === 'YYYY') {
	    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
	  } else if (token === 'YY') {
	    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
	  } else if (token === 'D') {
	    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
	  } else if (token === 'DD') {
	    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
	  }
	}

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1598));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1598));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_MINUTE = 60000;
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1597));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * var result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1599));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * var result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2721 */
[6656, 62, 47],
/* 2722 */
[6672, 62, 47],
/* 2723 */
[6677, 5982, 5983, 5984, 5985, 5986],
/* 2724 */
[6682, 92, 62, 2721, 47],
/* 2725 */
[6688, 62, 47],
/* 2726 */
[6689, 62, 92, 47],
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1598));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 2728 */
[6836, 6007],
/* 2729 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRef = exports.shallowEqual = exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Does a shallow equality check of two objects by comparing the reference
	 * equality of each value.
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var shallowEqual = function shallowEqual(objA, objB) {
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (bKeys.length !== aKeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < bKeys.length; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.shallowEqual = shallowEqual;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === "function") {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	
	exports.setRef = setRef;

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSafari = exports.isFirefox = void 0;
	
	var _js_utils = __webpack_require__(2732);
	
	var isFirefox = (0, _js_utils.memoize)(function () {
	  return /firefox/i.test(navigator.userAgent);
	});
	exports.isFirefox = isFirefox;
	var isSafari = (0, _js_utils.memoize)(function () {
	  return Boolean(window.safari);
	});
	exports.isSafari = isSafari;

/***/ }),
/* 2732 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.memoize = memoize;
	exports.without = without;
	exports.union = union;
	
	// cheap lodash replacements
	function memoize(fn) {
	  var result = null;
	
	  var memoized = function memoized() {
	    if (result == null) {
	      result = fn();
	    }
	
	    return result;
	  };
	
	  return memoized;
	}
	/**
	 * drop-in replacement for _.without
	 */
	
	
	function without(items, item) {
	  return items.filter(function (i) {
	    return i !== item;
	  });
	}
	
	function union(itemsA, itemsB) {
	  var set = new Set();
	
	  var insertItem = function insertItem(item) {
	    return set.add(item);
	  };
	
	  itemsA.forEach(insertItem);
	  itemsB.forEach(insertItem);
	  var result = [];
	  set.forEach(function (key) {
	    return result.push(key);
	  });
	  return result;
	}

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DragSourceMonitorImpl = void 0;
	
	var _invariant = __webpack_require__(129);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var isCallingCanDrag = false;
	var isCallingIsDragging = false;
	
	var DragSourceMonitorImpl =
	/*#__PURE__*/
	function () {
	  function DragSourceMonitorImpl(manager) {
	    _classCallCheck(this, DragSourceMonitorImpl);
	
	    this.sourceId = null;
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  _createClass(DragSourceMonitorImpl, [{
	    key: "receiveHandlerId",
	    value: function receiveHandlerId(sourceId) {
	      this.sourceId = sourceId;
	    }
	  }, {
	    key: "getHandlerId",
	    value: function getHandlerId() {
	      return this.sourceId;
	    }
	  }, {
	    key: "canDrag",
	    value: function canDrag() {
	      (0, _invariant.invariant)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');
	
	      try {
	        isCallingCanDrag = true;
	        return this.internalMonitor.canDragSource(this.sourceId);
	      } finally {
	        isCallingCanDrag = false;
	      }
	    }
	  }, {
	    key: "isDragging",
	    value: function isDragging() {
	      if (!this.sourceId) {
	        return false;
	      }
	
	      (0, _invariant.invariant)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');
	
	      try {
	        isCallingIsDragging = true;
	        return this.internalMonitor.isDraggingSource(this.sourceId);
	      } finally {
	        isCallingIsDragging = false;
	      }
	    }
	  }, {
	    key: "subscribeToStateChange",
	    value: function subscribeToStateChange(listener, options) {
	      return this.internalMonitor.subscribeToStateChange(listener, options);
	    }
	  }, {
	    key: "isDraggingSource",
	    value: function isDraggingSource(sourceId) {
	      return this.internalMonitor.isDraggingSource(sourceId);
	    }
	  }, {
	    key: "isOverTarget",
	    value: function isOverTarget(targetId, options) {
	      return this.internalMonitor.isOverTarget(targetId, options);
	    }
	  }, {
	    key: "getTargetIds",
	    value: function getTargetIds() {
	      return this.internalMonitor.getTargetIds();
	    }
	  }, {
	    key: "isSourcePublic",
	    value: function isSourcePublic() {
	      return this.internalMonitor.isSourcePublic();
	    }
	  }, {
	    key: "getSourceId",
	    value: function getSourceId() {
	      return this.internalMonitor.getSourceId();
	    }
	  }, {
	    key: "subscribeToOffsetChange",
	    value: function subscribeToOffsetChange(listener) {
	      return this.internalMonitor.subscribeToOffsetChange(listener);
	    }
	  }, {
	    key: "canDragSource",
	    value: function canDragSource(sourceId) {
	      return this.internalMonitor.canDragSource(sourceId);
	    }
	  }, {
	    key: "canDropOnTarget",
	    value: function canDropOnTarget(targetId) {
	      return this.internalMonitor.canDropOnTarget(targetId);
	    }
	  }, {
	    key: "getItemType",
	    value: function getItemType() {
	      return this.internalMonitor.getItemType();
	    }
	  }, {
	    key: "getItem",
	    value: function getItem() {
	      return this.internalMonitor.getItem();
	    }
	  }, {
	    key: "getDropResult",
	    value: function getDropResult() {
	      return this.internalMonitor.getDropResult();
	    }
	  }, {
	    key: "didDrop",
	    value: function didDrop() {
	      return this.internalMonitor.didDrop();
	    }
	  }, {
	    key: "getInitialClientOffset",
	    value: function getInitialClientOffset() {
	      return this.internalMonitor.getInitialClientOffset();
	    }
	  }, {
	    key: "getInitialSourceClientOffset",
	    value: function getInitialSourceClientOffset() {
	      return this.internalMonitor.getInitialSourceClientOffset();
	    }
	  }, {
	    key: "getSourceClientOffset",
	    value: function getSourceClientOffset() {
	      return this.internalMonitor.getSourceClientOffset();
	    }
	  }, {
	    key: "getClientOffset",
	    value: function getClientOffset() {
	      return this.internalMonitor.getClientOffset();
	    }
	  }, {
	    key: "getDifferenceFromInitialOffset",
	    value: function getDifferenceFromInitialOffset() {
	      return this.internalMonitor.getDifferenceFromInitialOffset();
	    }
	  }]);
	
	  return DragSourceMonitorImpl;
	}();
	
	exports.DragSourceMonitorImpl = DragSourceMonitorImpl;

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropTargetMonitorImpl = void 0;
	
	var _invariant = __webpack_require__(129);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var isCallingCanDrop = false;
	
	var DropTargetMonitorImpl =
	/*#__PURE__*/
	function () {
	  function DropTargetMonitorImpl(manager) {
	    _classCallCheck(this, DropTargetMonitorImpl);
	
	    this.targetId = null;
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  _createClass(DropTargetMonitorImpl, [{
	    key: "receiveHandlerId",
	    value: function receiveHandlerId(targetId) {
	      this.targetId = targetId;
	    }
	  }, {
	    key: "getHandlerId",
	    value: function getHandlerId() {
	      return this.targetId;
	    }
	  }, {
	    key: "subscribeToStateChange",
	    value: function subscribeToStateChange(listener, options) {
	      return this.internalMonitor.subscribeToStateChange(listener, options);
	    }
	  }, {
	    key: "canDrop",
	    value: function canDrop() {
	      // Cut out early if the target id has not been set. This should prevent errors
	      // where the user has an older version of dnd-core like in
	      // https://github.com/react-dnd/react-dnd/issues/1310
	      if (!this.targetId) {
	        return false;
	      }
	
	      (0, _invariant.invariant)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');
	
	      try {
	        isCallingCanDrop = true;
	        return this.internalMonitor.canDropOnTarget(this.targetId);
	      } finally {
	        isCallingCanDrop = false;
	      }
	    }
	  }, {
	    key: "isOver",
	    value: function isOver(options) {
	      if (!this.targetId) {
	        return false;
	      }
	
	      return this.internalMonitor.isOverTarget(this.targetId, options);
	    }
	  }, {
	    key: "getItemType",
	    value: function getItemType() {
	      return this.internalMonitor.getItemType();
	    }
	  }, {
	    key: "getItem",
	    value: function getItem() {
	      return this.internalMonitor.getItem();
	    }
	  }, {
	    key: "getDropResult",
	    value: function getDropResult() {
	      return this.internalMonitor.getDropResult();
	    }
	  }, {
	    key: "didDrop",
	    value: function didDrop() {
	      return this.internalMonitor.didDrop();
	    }
	  }, {
	    key: "getInitialClientOffset",
	    value: function getInitialClientOffset() {
	      return this.internalMonitor.getInitialClientOffset();
	    }
	  }, {
	    key: "getInitialSourceClientOffset",
	    value: function getInitialSourceClientOffset() {
	      return this.internalMonitor.getInitialSourceClientOffset();
	    }
	  }, {
	    key: "getSourceClientOffset",
	    value: function getSourceClientOffset() {
	      return this.internalMonitor.getSourceClientOffset();
	    }
	  }, {
	    key: "getClientOffset",
	    value: function getClientOffset() {
	      return this.internalMonitor.getClientOffset();
	    }
	  }, {
	    key: "getDifferenceFromInitialOffset",
	    value: function getDifferenceFromInitialOffset() {
	      return this.internalMonitor.getDifferenceFromInitialOffset();
	    }
	  }]);
	
	  return DropTargetMonitorImpl;
	}();
	
	exports.DropTargetMonitorImpl = DropTargetMonitorImpl;

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SourceConnector = void 0;
	
	var _wrapConnectorHooks = _interopRequireDefault(__webpack_require__(2737));
	
	var _isRef = __webpack_require__(2741);
	
	var _shallowequal = __webpack_require__(599);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var SourceConnector =
	/*#__PURE__*/
	function () {
	  function SourceConnector(backend) {
	    var _this = this;
	
	    _classCallCheck(this, SourceConnector);
	
	    this.hooks = (0, _wrapConnectorHooks.default)({
	      dragSource: function dragSource(node, options) {
	        _this.clearDragSource();
	
	        _this.dragSourceOptions = options || null;
	
	        if ((0, _isRef.isRef)(node)) {
	          _this.dragSourceRef = node;
	        } else {
	          _this.dragSourceNode = node;
	        }
	
	        _this.reconnectDragSource();
	      },
	      dragPreview: function dragPreview(node, options) {
	        _this.clearDragPreview();
	
	        _this.dragPreviewOptions = options || null;
	
	        if ((0, _isRef.isRef)(node)) {
	          _this.dragPreviewRef = node;
	        } else {
	          _this.dragPreviewNode = node;
	        }
	
	        _this.reconnectDragPreview();
	      }
	    });
	    this.handlerId = null; // The drop target may either be attached via ref or connect function
	
	    this.dragSourceRef = null;
	    this.dragSourceOptionsInternal = null; // The drag preview may either be attached via ref or connect function
	
	    this.dragPreviewRef = null;
	    this.dragPreviewOptionsInternal = null;
	    this.lastConnectedHandlerId = null;
	    this.lastConnectedDragSource = null;
	    this.lastConnectedDragSourceOptions = null;
	    this.lastConnectedDragPreview = null;
	    this.lastConnectedDragPreviewOptions = null;
	    this.backend = backend;
	  }
	
	  _createClass(SourceConnector, [{
	    key: "receiveHandlerId",
	    value: function receiveHandlerId(newHandlerId) {
	      if (this.handlerId === newHandlerId) {
	        return;
	      }
	
	      this.handlerId = newHandlerId;
	      this.reconnect();
	    }
	  }, {
	    key: "reconnect",
	    value: function reconnect() {
	      this.reconnectDragSource();
	      this.reconnectDragPreview();
	    }
	  }, {
	    key: "reconnectDragSource",
	    value: function reconnectDragSource() {
	      var dragSource = this.dragSource; // if nothing has changed then don't resubscribe
	
	      var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
	
	      if (didChange) {
	        this.disconnectDragSource();
	      }
	
	      if (!this.handlerId) {
	        return;
	      }
	
	      if (!dragSource) {
	        this.lastConnectedDragSource = dragSource;
	        return;
	      }
	
	      if (didChange) {
	        this.lastConnectedHandlerId = this.handlerId;
	        this.lastConnectedDragSource = dragSource;
	        this.lastConnectedDragSourceOptions = this.dragSourceOptions;
	        this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
	      }
	    }
	  }, {
	    key: "reconnectDragPreview",
	    value: function reconnectDragPreview() {
	      var dragPreview = this.dragPreview; // if nothing has changed then don't resubscribe
	
	      var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
	
	      if (!this.handlerId) {
	        this.disconnectDragPreview();
	      } else if (this.dragPreview && didChange) {
	        this.lastConnectedHandlerId = this.handlerId;
	        this.lastConnectedDragPreview = dragPreview;
	        this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
	        this.disconnectDragPreview();
	        this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
	      }
	    }
	  }, {
	    key: "didHandlerIdChange",
	    value: function didHandlerIdChange() {
	      return this.lastConnectedHandlerId !== this.handlerId;
	    }
	  }, {
	    key: "didConnectedDragSourceChange",
	    value: function didConnectedDragSourceChange() {
	      return this.lastConnectedDragSource !== this.dragSource;
	    }
	  }, {
	    key: "didConnectedDragPreviewChange",
	    value: function didConnectedDragPreviewChange() {
	      return this.lastConnectedDragPreview !== this.dragPreview;
	    }
	  }, {
	    key: "didDragSourceOptionsChange",
	    value: function didDragSourceOptionsChange() {
	      return !(0, _shallowequal.shallowEqual)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
	    }
	  }, {
	    key: "didDragPreviewOptionsChange",
	    value: function didDragPreviewOptionsChange() {
	      return !(0, _shallowequal.shallowEqual)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
	    }
	  }, {
	    key: "disconnectDragSource",
	    value: function disconnectDragSource() {
	      if (this.dragSourceUnsubscribe) {
	        this.dragSourceUnsubscribe();
	        this.dragSourceUnsubscribe = undefined;
	      }
	    }
	  }, {
	    key: "disconnectDragPreview",
	    value: function disconnectDragPreview() {
	      if (this.dragPreviewUnsubscribe) {
	        this.dragPreviewUnsubscribe();
	        this.dragPreviewUnsubscribe = undefined;
	        this.dragPreviewNode = null;
	        this.dragPreviewRef = null;
	      }
	    }
	  }, {
	    key: "clearDragSource",
	    value: function clearDragSource() {
	      this.dragSourceNode = null;
	      this.dragSourceRef = null;
	    }
	  }, {
	    key: "clearDragPreview",
	    value: function clearDragPreview() {
	      this.dragPreviewNode = null;
	      this.dragPreviewRef = null;
	    }
	  }, {
	    key: "connectTarget",
	    get: function get() {
	      return this.dragSource;
	    }
	  }, {
	    key: "dragSourceOptions",
	    get: function get() {
	      return this.dragSourceOptionsInternal;
	    },
	    set: function set(options) {
	      this.dragSourceOptionsInternal = options;
	    }
	  }, {
	    key: "dragPreviewOptions",
	    get: function get() {
	      return this.dragPreviewOptionsInternal;
	    },
	    set: function set(options) {
	      this.dragPreviewOptionsInternal = options;
	    }
	  }, {
	    key: "dragSource",
	    get: function get() {
	      return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
	    }
	  }, {
	    key: "dragPreview",
	    get: function get() {
	      return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
	    }
	  }]);
	
	  return SourceConnector;
	}();
	
	exports.SourceConnector = SourceConnector;

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TargetConnector = void 0;
	
	var _shallowequal = __webpack_require__(599);
	
	var _wrapConnectorHooks = _interopRequireDefault(__webpack_require__(2737));
	
	var _isRef = __webpack_require__(2741);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var TargetConnector =
	/*#__PURE__*/
	function () {
	  function TargetConnector(backend) {
	    var _this = this;
	
	    _classCallCheck(this, TargetConnector);
	
	    this.hooks = (0, _wrapConnectorHooks.default)({
	      dropTarget: function dropTarget(node, options) {
	        _this.clearDropTarget();
	
	        _this.dropTargetOptions = options;
	
	        if ((0, _isRef.isRef)(node)) {
	          _this.dropTargetRef = node;
	        } else {
	          _this.dropTargetNode = node;
	        }
	
	        _this.reconnect();
	      }
	    });
	    this.handlerId = null; // The drop target may either be attached via ref or connect function
	
	    this.dropTargetRef = null;
	    this.dropTargetOptionsInternal = null;
	    this.lastConnectedHandlerId = null;
	    this.lastConnectedDropTarget = null;
	    this.lastConnectedDropTargetOptions = null;
	    this.backend = backend;
	  }
	
	  _createClass(TargetConnector, [{
	    key: "reconnect",
	    value: function reconnect() {
	      // if nothing has changed then don't resubscribe
	      var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
	
	      if (didChange) {
	        this.disconnectDropTarget();
	      }
	
	      var dropTarget = this.dropTarget;
	
	      if (!this.handlerId) {
	        return;
	      }
	
	      if (!dropTarget) {
	        this.lastConnectedDropTarget = dropTarget;
	        return;
	      }
	
	      if (didChange) {
	        this.lastConnectedHandlerId = this.handlerId;
	        this.lastConnectedDropTarget = dropTarget;
	        this.lastConnectedDropTargetOptions = this.dropTargetOptions;
	        this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
	      }
	    }
	  }, {
	    key: "receiveHandlerId",
	    value: function receiveHandlerId(newHandlerId) {
	      if (newHandlerId === this.handlerId) {
	        return;
	      }
	
	      this.handlerId = newHandlerId;
	      this.reconnect();
	    }
	  }, {
	    key: "didHandlerIdChange",
	    value: function didHandlerIdChange() {
	      return this.lastConnectedHandlerId !== this.handlerId;
	    }
	  }, {
	    key: "didDropTargetChange",
	    value: function didDropTargetChange() {
	      return this.lastConnectedDropTarget !== this.dropTarget;
	    }
	  }, {
	    key: "didOptionsChange",
	    value: function didOptionsChange() {
	      return !(0, _shallowequal.shallowEqual)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
	    }
	  }, {
	    key: "disconnectDropTarget",
	    value: function disconnectDropTarget() {
	      if (this.unsubscribeDropTarget) {
	        this.unsubscribeDropTarget();
	        this.unsubscribeDropTarget = undefined;
	      }
	    }
	  }, {
	    key: "clearDropTarget",
	    value: function clearDropTarget() {
	      this.dropTargetRef = null;
	      this.dropTargetNode = null;
	    }
	  }, {
	    key: "connectTarget",
	    get: function get() {
	      return this.dropTarget;
	    }
	  }, {
	    key: "dropTargetOptions",
	    get: function get() {
	      return this.dropTargetOptionsInternal;
	    },
	    set: function set(options) {
	      this.dropTargetOptionsInternal = options;
	    }
	  }, {
	    key: "dropTarget",
	    get: function get() {
	      return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
	    }
	  }]);
	
	  return TargetConnector;
	}();
	
	exports.TargetConnector = TargetConnector;

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = wrapConnectorHooks;
	
	var _react = __webpack_require__(1);
	
	var _cloneWithRef = __webpack_require__(6039);
	
	function throwIfCompositeComponentElement(element) {
	  // Custom components can no longer be wrapped directly in React DnD 2.0
	  // so that we don't need to depend on findDOMNode() from react-dom.
	  if (typeof element.type === 'string') {
	    return;
	  }
	
	  var displayName = element.type.displayName || element.type.name || 'the component';
	  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
	}
	
	function wrapHookToRecognizeElement(hook) {
	  return function () {
	    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    // When passed a node, call the hook straight away.
	    if (!(0, _react.isValidElement)(elementOrNode)) {
	      var node = elementOrNode;
	      hook(node, options); // return the node so it can be chained (e.g. when within callback refs
	      // <div ref={node => connectDragSource(connectDropTarget(node))}/>
	
	      return node;
	    } // If passed a ReactElement, clone it and attach this function as a ref.
	    // This helps us achieve a neat API where user doesn't even know that refs
	    // are being used under the hood.
	
	
	    var element = elementOrNode;
	    throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly
	
	    var ref = options ? function (node) {
	      return hook(node, options);
	    } : hook;
	    return (0, _cloneWithRef.cloneWithRef)(element, ref);
	  };
	}
	
	function wrapConnectorHooks(hooks) {
	  var wrappedHooks = {};
	  Object.keys(hooks).forEach(function (key) {
	    var hook = hooks[key]; // ref objects should be passed straight through without wrapping
	
	    if (key.endsWith('Ref')) {
	      wrappedHooks[key] = hooks[key];
	    } else {
	      var wrappedHook = wrapHookToRecognizeElement(hook);
	
	      wrappedHooks[key] = function () {
	        return wrappedHook;
	      };
	    }
	  });
	  return wrappedHooks;
	}

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = decorateHandler;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _shallowequal = __webpack_require__(599);
	
	var _invariant = __webpack_require__(129);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(963));
	
	var _index = __webpack_require__(1020);
	
	var _js_utils = __webpack_require__(476);
	
	var _disposables = __webpack_require__(6031);
	
	var _utils = __webpack_require__(584);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function decorateHandler(_ref) {
	  var DecoratedComponent = _ref.DecoratedComponent,
	      createHandler = _ref.createHandler,
	      createMonitor = _ref.createMonitor,
	      createConnector = _ref.createConnector,
	      registerHandler = _ref.registerHandler,
	      containerDisplayName = _ref.containerDisplayName,
	      getType = _ref.getType,
	      collect = _ref.collect,
	      options = _ref.options;
	  var _options$arePropsEqua = options.arePropsEqual,
	      arePropsEqual = _options$arePropsEqua === void 0 ? _shallowequal.shallowEqual : _options$arePropsEqua;
	  var Decorated = DecoratedComponent;
	  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	  var DragDropContainer =
	  /*#__PURE__*/
	  function (_React$Component) {
	    _inherits(DragDropContainer, _React$Component);
	
	    function DragDropContainer(props) {
	      var _this;
	
	      _classCallCheck(this, DragDropContainer);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(DragDropContainer).call(this, props));
	      _this.decoratedRef = React.createRef();
	
	      _this.handleChange = function () {
	        var nextState = _this.getCurrentState();
	
	        if (!(0, _shallowequal.shallowEqual)(nextState, _this.state)) {
	          _this.setState(nextState);
	        }
	      };
	
	      _this.disposable = new _disposables.SerialDisposable();
	
	      _this.receiveProps(props);
	
	      _this.dispose();
	
	      return _this;
	    }
	
	    _createClass(DragDropContainer, [{
	      key: "getHandlerId",
	      value: function getHandlerId() {
	        return this.handlerId;
	      }
	    }, {
	      key: "getDecoratedComponentInstance",
	      value: function getDecoratedComponentInstance() {
	        (0, _invariant.invariant)(this.decoratedRef.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
	        return this.decoratedRef.current;
	      }
	    }, {
	      key: "shouldComponentUpdate",
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return !arePropsEqual(nextProps, this.props) || !(0, _shallowequal.shallowEqual)(nextState, this.state);
	      }
	    }, {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.disposable = new _disposables.SerialDisposable();
	        this.currentType = undefined;
	        this.receiveProps(this.props);
	        this.handleChange();
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        if (!arePropsEqual(this.props, prevProps)) {
	          this.receiveProps(this.props);
	          this.handleChange();
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.dispose();
	      }
	    }, {
	      key: "receiveProps",
	      value: function receiveProps(props) {
	        if (!this.handler) {
	          return;
	        }
	
	        this.handler.receiveProps(props);
	        this.receiveType(getType(props));
	      }
	    }, {
	      key: "receiveType",
	      value: function receiveType(type) {
	        if (!this.handlerMonitor || !this.manager || !this.handlerConnector) {
	          return;
	        }
	
	        if (type === this.currentType) {
	          return;
	        }
	
	        this.currentType = type;
	
	        var _registerHandler = registerHandler(type, this.handler, this.manager),
	            _registerHandler2 = _slicedToArray(_registerHandler, 2),
	            handlerId = _registerHandler2[0],
	            unregister = _registerHandler2[1];
	
	        this.handlerId = handlerId;
	        this.handlerMonitor.receiveHandlerId(handlerId);
	        this.handlerConnector.receiveHandlerId(handlerId);
	        var globalMonitor = this.manager.getMonitor();
	        var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, {
	          handlerIds: [handlerId]
	        });
	        this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
	      }
	    }, {
	      key: "dispose",
	      value: function dispose() {
	        this.disposable.dispose();
	
	        if (this.handlerConnector) {
	          this.handlerConnector.receiveHandlerId(null);
	        }
	      }
	    }, {
	      key: "getCurrentState",
	      value: function getCurrentState() {
	        if (!this.handlerConnector) {
	          return {};
	        }
	
	        var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor, this.props);
	
	        if (false) {
	          (0, _invariant.invariant)((0, _js_utils.isPlainObject)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
	        }
	
	        return nextState;
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        return React.createElement(_index.DndContext.Consumer, null, function (_ref2) {
	          var dragDropManager = _ref2.dragDropManager;
	
	          _this2.receiveDragDropManager(dragDropManager);
	
	          if (typeof requestAnimationFrame !== 'undefined') {
	            requestAnimationFrame(function () {
	              return _this2.handlerConnector.reconnect();
	            });
	          }
	
	          return React.createElement(Decorated, Object.assign({}, _this2.props, _this2.getCurrentState(), {
	            // NOTE: if Decorated is a Function Component, decoratedRef will not be populated unless it's a refforwarding component.
	            ref: (0, _utils.isRefable)(Decorated) ? _this2.decoratedRef : null
	          }));
	        });
	      }
	    }, {
	      key: "receiveDragDropManager",
	      value: function receiveDragDropManager(dragDropManager) {
	        if (this.manager !== undefined) {
	          return;
	        }
	
	        (0, _invariant.invariant)(dragDropManager !== undefined, 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to render a DndProvider component in your top-level component. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
	        if (dragDropManager === undefined) {
	          return;
	        }
	
	        this.manager = dragDropManager;
	        this.handlerMonitor = createMonitor(dragDropManager);
	        this.handlerConnector = createConnector(dragDropManager.getBackend());
	        this.handler = createHandler(this.handlerMonitor, this.decoratedRef);
	      }
	    }]);
	
	    return DragDropContainer;
	  }(React.Component);
	
	  DragDropContainer.DecoratedComponent = DecoratedComponent;
	  DragDropContainer.displayName = "".concat(containerDisplayName, "(").concat(displayName, ")");
	  return (0, _hoistNonReactStatics.default)(DragDropContainer, DecoratedComponent);
	}

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useCollector = useCollector;
	
	var _shallowequal = __webpack_require__(599);
	
	var _react = __webpack_require__(1);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(585);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	/**
	 *
	 * @param monitor The monitor to collect state from
	 * @param collect The collecting function
	 * @param onUpdate A method to invoke when updates occur
	 */
	function useCollector(monitor, collect, onUpdate) {
	  var _useState = (0, _react.useState)(function () {
	    return collect(monitor);
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      collected = _useState2[0],
	      setCollected = _useState2[1];
	
	  var updateCollected = (0, _react.useCallback)(function () {
	    var nextValue = collect(monitor);
	
	    if (!(0, _shallowequal.shallowEqual)(collected, nextValue)) {
	      setCollected(nextValue);
	
	      if (onUpdate) {
	        onUpdate();
	      }
	    }
	  }, [collected, monitor, onUpdate]); // update the collected properties after the first render
	  // and the components are attached to dnd-core
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(updateCollected, []);
	  return [collected, updateCollected];
	}

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useMonitorOutput = useMonitorOutput;
	
	var _useIsomorphicLayoutEffect = __webpack_require__(585);
	
	var _useCollector3 = __webpack_require__(2739);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function useMonitorOutput(monitor, collect, onCollect) {
	  var _useCollector = (0, _useCollector3.useCollector)(monitor, collect, onCollect),
	      _useCollector2 = _slicedToArray(_useCollector, 2),
	      collected = _useCollector2[0],
	      updateCollected = _useCollector2[1];
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function subscribeToMonitorStateChange() {
	    var handlerId = monitor.getHandlerId();
	
	    if (handlerId == null) {
	      return undefined;
	    }
	
	    return monitor.subscribeToStateChange(updateCollected, {
	      handlerIds: [handlerId]
	    });
	  }, [monitor, updateCollected]);
	  return collected;
	}

/***/ }),
/* 2741 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isRef = isRef;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function isRef(obj) {
	  return (// eslint-disable-next-line no-prototype-builtins
	    obj !== null && _typeof(obj) === 'object' && obj.hasOwnProperty('current')
	  );
	}

/***/ }),
/* 2742 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValidType = isValidType;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function isValidType(type, allowArray) {
	  return typeof type === 'string' || _typeof(type) === 'symbol' || !!allowArray && Array.isArray(type) && type.every(function (t) {
	    return isValidType(t, false);
	  });
	}

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _withScriptjs = __webpack_require__(6060)
	
	Object.defineProperty(exports, "withScriptjs", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withScriptjs).default
	  },
	})
	
	var _withGoogleMap = __webpack_require__(6059)
	
	Object.defineProperty(exports, "withGoogleMap", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withGoogleMap).default
	  },
	})
	
	var _GoogleMap = __webpack_require__(6047)
	
	Object.defineProperty(exports, "GoogleMap", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GoogleMap).default
	  },
	})
	
	var _Circle = __webpack_require__(6044)
	
	Object.defineProperty(exports, "Circle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default
	  },
	})
	
	var _Marker = __webpack_require__(6051)
	
	Object.defineProperty(exports, "Marker", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Marker).default
	  },
	})
	
	var _Polyline = __webpack_require__(6054)
	
	Object.defineProperty(exports, "Polyline", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Polyline).default
	  },
	})
	
	var _Polygon = __webpack_require__(6053)
	
	Object.defineProperty(exports, "Polygon", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Polygon).default
	  },
	})
	
	var _Rectangle = __webpack_require__(6055)
	
	Object.defineProperty(exports, "Rectangle", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Rectangle).default
	  },
	})
	
	var _InfoWindow = __webpack_require__(6049)
	
	Object.defineProperty(exports, "InfoWindow", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_InfoWindow).default
	  },
	})
	
	var _OverlayView = __webpack_require__(6052)
	
	Object.defineProperty(exports, "OverlayView", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OverlayView).default
	  },
	})
	
	var _GroundOverlay = __webpack_require__(6048)
	
	Object.defineProperty(exports, "GroundOverlay", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GroundOverlay).default
	  },
	})
	
	var _DirectionsRenderer = __webpack_require__(6045)
	
	Object.defineProperty(exports, "DirectionsRenderer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DirectionsRenderer).default
	  },
	})
	
	var _FusionTablesLayer = __webpack_require__(6046)
	
	Object.defineProperty(exports, "FusionTablesLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FusionTablesLayer).default
	  },
	})
	
	var _KmlLayer = __webpack_require__(6050)
	
	Object.defineProperty(exports, "KmlLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KmlLayer).default
	  },
	})
	
	var _TrafficLayer = __webpack_require__(6057)
	
	Object.defineProperty(exports, "TrafficLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TrafficLayer).default
	  },
	})
	
	var _StreetViewPanorama = __webpack_require__(6056)
	
	Object.defineProperty(exports, "StreetViewPanorama", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StreetViewPanorama).default
	  },
	})
	
	var _BicyclingLayer = __webpack_require__(6043)
	
	Object.defineProperty(exports, "BicyclingLayer", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BicyclingLayer).default
	  },
	})
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}


/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1609),
	    baseLodash = __webpack_require__(1610);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 2745 */
[6730, 1021, 6159, 6160, 6161, 6162, 6163],
/* 2746 */
[6733, 477, 210],
/* 2747 */
5819,
/* 2748 */
[6735, 2749, 1031],
/* 2749 */
[6737, 2760],
/* 2750 */
[6738, 6079, 6109],
/* 2751 */
[6742, 2754, 1029],
/* 2752 */
[6747, 6085, 587],
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(745),
	    metaMap = __webpack_require__(2769);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ }),
/* 2754 */
[6762, 252, 1613, 6166, 2779],
/* 2755 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ }),
/* 2756 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ }),
/* 2757 */
1545,
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(2755),
	    composeArgsRight = __webpack_require__(2756),
	    countHolders = __webpack_require__(6107),
	    createCtor = __webpack_require__(1024),
	    createRecurry = __webpack_require__(2759),
	    getHolder = __webpack_require__(1612),
	    reorder = __webpack_require__(6155),
	    replaceHolders = __webpack_require__(1028),
	    root = __webpack_require__(210);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(6134),
	    setData = __webpack_require__(2770),
	    setWrapToString = __webpack_require__(2772);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ }),
/* 2760 */
[6770, 477],
/* 2761 */
[6771, 6066, 6074, 6102],
/* 2762 */
2696,
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(2769),
	    noop = __webpack_require__(6179);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 2764 */
[6781, 2754, 2775, 252, 1026, 1614, 1029],
/* 2765 */
5867,
/* 2766 */
2697,
/* 2767 */
[6789, 478],
/* 2768 */
2699,
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(2746);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(2753),
	    shortOut = __webpack_require__(2773);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ }),
/* 2771 */
[6805, 6097, 2773],
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(6125),
	    insertWrapDetails = __webpack_require__(6131),
	    setToString = __webpack_require__(2771),
	    updateWrapDetails = __webpack_require__(6168);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ }),
/* 2773 */
5897,
/* 2774 */
2700,
/* 2775 */
[6816, 6084, 587],
/* 2776 */
[6819, 210, 6183],
/* 2777 */
[6823, 6089, 6101, 6150],
/* 2778 */
[6829, 478, 1034],
/* 2779 */
[6830, 6100],
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(959));
	var hoistNonReactStatics = _interopDefault(__webpack_require__(6061));
	var changeEmitter = __webpack_require__(1977);
	var $$observable = _interopDefault(__webpack_require__(1050));
	
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	var setDisplayName = function setDisplayName(displayName) {
	  return setStatic('displayName', displayName);
	};
	
	var getDisplayName = function getDisplayName(Component$$1) {
	  if (typeof Component$$1 === 'string') {
	    return Component$$1;
	  }
	
	  if (!Component$$1) {
	    return undefined;
	  }
	
	  return Component$$1.displayName || Component$$1.name || 'Component';
	};
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + getDisplayName(BaseComponent) + ')';
	};
	
	var mapProps = function mapProps(propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var MapProps = function MapProps(props) {
	      return factory(propsMapper(props));
	    };
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
	    }
	    return MapProps;
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var withProps = function withProps(input) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, props, typeof input === 'function' ? input(props) : input);
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var pick = function pick(obj, keys) {
	  var result = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (obj.hasOwnProperty(key)) {
	      result[key] = obj[key];
	    }
	  }
	  return result;
	};
	
	var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
	      return !shallowEqual(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
	    };
	
	    var WithPropsOnChange = function (_Component) {
	      inherits(WithPropsOnChange, _Component);
	
	      function WithPropsOnChange() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithPropsOnChange);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (shouldMap(this.props, nextProps)) {
	          this.computedProps = propsMapper(nextProps);
	        }
	      };
	
	      WithPropsOnChange.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.computedProps));
	      };
	
	      return WithPropsOnChange;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
	    }
	    return WithPropsOnChange;
	  };
	};
	
	var mapValues = function mapValues(obj, func) {
	  var result = {};
	  /* eslint-disable no-restricted-syntax */
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      result[key] = func(obj[key], key);
	    }
	  }
	  /* eslint-enable no-restricted-syntax */
	  return result;
	};
	
	/* eslint-disable no-console */
	var withHandlers = function withHandlers(handlers) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithHandlers = function (_Component) {
	      inherits(WithHandlers, _Component);
	
	      function WithHandlers() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	        this.cachedHandlers = {};
	      };
	
	      WithHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.handlers));
	      };
	
	      return WithHandlers;
	    }(React.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.cachedHandlers = {};
	      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
	        return function () {
	          var cachedHandler = _this2.cachedHandlers[handlerName];
	          if (cachedHandler) {
	            return cachedHandler.apply(undefined, arguments);
	          }
	
	          var handler = createHandler(_this2.props);
	          _this2.cachedHandlers[handlerName] = handler;
	
	          if (false) {
	            console.error(
	            // eslint-disable-line no-console
	            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
	          }
	
	          return handler.apply(undefined, arguments);
	        };
	      });
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
	    }
	    return WithHandlers;
	  };
	};
	
	var defaultProps = function defaultProps(props) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var DefaultProps = function DefaultProps(ownerProps) {
	      return factory(ownerProps);
	    };
	    DefaultProps.defaultProps = props;
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
	    }
	    return DefaultProps;
	  };
	};
	
	var omit = function omit(obj, keys) {
	  var rest = objectWithoutProperties(obj, []);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (rest.hasOwnProperty(key)) {
	      delete rest[key];
	    }
	  }
	  return rest;
	};
	
	var renameProp = function renameProp(oldName, newName) {
	  var hoc = mapProps(function (props) {
	    var _babelHelpers$extends;
	
	    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var keys = Object.keys;
	
	
	var mapKeys = function mapKeys(obj, func) {
	  return keys(obj).reduce(function (result, key) {
	    var val = obj[key];
	    /* eslint-disable no-param-reassign */
	    result[func(val, key)] = val;
	    /* eslint-enable no-param-reassign */
	    return result;
	  }, {});
	};
	
	var renameProps = function renameProps(nameMap) {
	  var hoc = mapProps(function (props) {
	    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
	      return nameMap[oldName];
	    }));
	  });
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var flattenProp = function flattenProp(propName) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var FlattenProp = function FlattenProp(props) {
	      return factory(_extends({}, props, props[propName]));
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
	    }
	    return FlattenProp;
	  };
	};
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithState = function (_Component) {
	      inherits(WithState, _Component);
	
	      function WithState() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithState);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithState.prototype.render = function render() {
	        var _babelHelpers$extends;
	
	        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
	      };
	
	      return WithState;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
	    }
	    return WithState;
	  };
	};
	
	var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithStateHandlers = function (_Component) {
	      inherits(WithStateHandlers, _Component);
	
	      function WithStateHandlers() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithStateHandlers);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        var propsChanged = nextProps !== this.props;
	        // the idea is to skip render if stateUpdater handler return undefined
	        // this allows to create no state update handlers with access to state and props
	        var stateChanged = !shallowEqual(nextState, this.state);
	        return propsChanged || stateChanged;
	      };
	
	      WithStateHandlers.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
	      };
	
	      return WithStateHandlers;
	    }(React.Component);
	
	    var _initialiseProps = function _initialiseProps() {
	      var _this2 = this;
	
	      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
	      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
	        return function (mayBeEvent) {
	          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          // Having that functional form of setState can be called async
	          // we need to persist SyntheticEvent
	          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
	            mayBeEvent.persist();
	          }
	
	          _this2.setState(function (state, props) {
	            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
	          });
	        };
	      });
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
	    }
	    return WithStateHandlers;
	  };
	};
	
	var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithReducer = function (_Component) {
	      inherits(WithReducer, _Component);
	
	      function WithReducer() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithReducer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: _this.initializeStateValue()
	        }, _this.dispatch = function (action) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: reducer(stateValue, action)
	            };
	          });
	        }, _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
	        if (initialState !== undefined) {
	          return typeof initialState === 'function' ? initialState(this.props) : initialState;
	        }
	        return reducer(undefined, { type: '@@recompose/INIT' });
	      };
	
	      WithReducer.prototype.render = function render() {
	        var _babelHelpers$extends;
	
	        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
	      };
	
	      return WithReducer;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
	    }
	    return WithReducer;
	  };
	};
	
	var identity = function identity(Component$$1) {
	  return Component$$1;
	};
	
	var branch = function branch(test, left) {
	  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
	  return function (BaseComponent) {
	    var leftFactory = void 0;
	    var rightFactory = void 0;
	    var Branch = function Branch(props) {
	      if (test(props)) {
	        leftFactory = leftFactory || React.createFactory(left(BaseComponent));
	        return leftFactory(props);
	      }
	      rightFactory = rightFactory || React.createFactory(right(BaseComponent));
	      return rightFactory(props);
	    };
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
	    }
	    return Branch;
	  };
	};
	
	var renderComponent = function renderComponent(Component$$1) {
	  return function (_) {
	    var factory = React.createFactory(Component$$1);
	    var RenderComponent = function RenderComponent(props) {
	      return factory(props);
	    };
	    if (false) {
	      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
	    }
	    return RenderComponent;
	  };
	};
	
	var Nothing = function (_Component) {
	  inherits(Nothing, _Component);
	
	  function Nothing() {
	    classCallCheck(this, Nothing);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Nothing.prototype.render = function render() {
	    return null;
	  };
	
	  return Nothing;
	}(React.Component);
	
	var renderNothing = function renderNothing(_) {
	  return Nothing;
	};
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        classCallCheck(this, ShouldUpdate);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(React.Component);
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	var pure = function pure(BaseComponent) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(props, nextProps);
	  });
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
	  var hoc = shouldUpdate(function (props, nextProps) {
	    return !shallowEqual(pick(nextProps, propKeys), pick(props, propKeys));
	  });
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
	  var propTypes = BaseComponent.propTypes;
	
	  if (false) {
	    if (!propTypes) {
	      /* eslint-disable */
	      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
	      /* eslint-enable */
	    }
	  }
	
	  var propKeys = Object.keys(propTypes || {});
	  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);
	
	  if (false) {
	    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
	  }
	  return OnlyUpdateForPropTypes;
	};
	
	var withContext = function withContext(childContextTypes, getChildContext) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    var WithContext = function (_Component) {
	      inherits(WithContext, _Component);
	
	      function WithContext() {
	        var _temp, _this, _ret;
	
	        classCallCheck(this, WithContext);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
	          return getChildContext(_this.props);
	        }, _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      WithContext.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return WithContext;
	    }(React.Component);
	
	    WithContext.childContextTypes = childContextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
	    }
	    return WithContext;
	  };
	};
	
	var getContext = function getContext(contextTypes) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	    var GetContext = function GetContext(ownerProps, context) {
	      return factory(_extends({}, ownerProps, context));
	    };
	
	    GetContext.contextTypes = contextTypes;
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
	    }
	    return GetContext;
	  };
	};
	
	/* eslint-disable no-console */
	var lifecycle = function lifecycle(spec) {
	  return function (BaseComponent) {
	    var factory = React.createFactory(BaseComponent);
	
	    if (false) {
	      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
	    }
	
	    var Lifecycle = function (_Component) {
	      inherits(Lifecycle, _Component);
	
	      function Lifecycle() {
	        classCallCheck(this, Lifecycle);
	        return possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      Lifecycle.prototype.render = function render() {
	        return factory(_extends({}, this.props, this.state));
	      };
	
	      return Lifecycle;
	    }(React.Component);
	
	    Object.keys(spec).forEach(function (hook) {
	      return Lifecycle.prototype[hook] = spec[hook];
	    });
	
	    if (false) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
	    }
	    return Lifecycle;
	  };
	};
	
	var isClassComponent = function isClassComponent(Component$$1) {
	  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
	};
	
	var toClass = function toClass(baseComponent) {
	  if (isClassComponent(baseComponent)) {
	    return baseComponent;
	  }
	
	  var ToClass = function (_Component) {
	    inherits(ToClass, _Component);
	
	    function ToClass() {
	      classCallCheck(this, ToClass);
	      return possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ToClass.prototype.render = function render() {
	      if (typeof baseComponent === 'string') {
	        return React__default.createElement(baseComponent, this.props);
	      }
	      return baseComponent(this.props, this.context);
	    };
	
	    return ToClass;
	  }(React.Component);
	
	  ToClass.displayName = getDisplayName(baseComponent);
	  ToClass.propTypes = baseComponent.propTypes;
	  ToClass.contextTypes = baseComponent.contextTypes;
	  ToClass.defaultProps = baseComponent.defaultProps;
	
	  return ToClass;
	};
	
	var setPropTypes = function setPropTypes(propTypes) {
	  return setStatic('propTypes', propTypes);
	};
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}
	
	var createSink = function createSink(callback) {
	  return function (_Component) {
	    inherits(Sink, _Component);
	
	    function Sink() {
	      classCallCheck(this, Sink);
	      return possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Sink.prototype.componentWillMount = function componentWillMount() {
	      callback(this.props);
	    };
	
	    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      callback(nextProps);
	    };
	
	    Sink.prototype.render = function render() {
	      return null;
	    };
	
	    return Sink;
	  }(React.Component);
	};
	
	var componentFromProp = function componentFromProp(propName) {
	  var Component$$1 = function Component$$1(props) {
	    return React.createElement(props[propName], omit(props, [propName]));
	  };
	  Component$$1.displayName = 'componentFromProp(' + propName + ')';
	  return Component$$1;
	};
	
	var nest = function nest() {
	  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
	    Components[_key] = arguments[_key];
	  }
	
	  var factories = Components.map(React.createFactory);
	  var Nest = function Nest(_ref) {
	    var props = objectWithoutProperties(_ref, []),
	        children = _ref.children;
	    return factories.reduceRight(function (child, factory) {
	      return factory(props, child);
	    }, children);
	  };
	
	  if (false) {
	    var displayNames = Components.map(getDisplayName);
	    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
	  }
	
	  return Nest;
	};
	
	var hoistStatics = function hoistStatics(higherOrderComponent) {
	  return function (BaseComponent) {
	    var NewComponent = higherOrderComponent(BaseComponent);
	    hoistNonReactStatics(NewComponent, BaseComponent);
	    return NewComponent;
	  };
	};
	
	var _config = {
	  fromESObservable: null,
	  toESObservable: null
	};
	
	var configureObservable = function configureObservable(c) {
	  _config = c;
	};
	
	var config = {
	  fromESObservable: function fromESObservable(observable) {
	    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
	  },
	  toESObservable: function toESObservable(stream) {
	    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
	  }
	};
	
	var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
	  return function (propsToVdom) {
	    return function (_Component) {
	      inherits(ComponentFromStream, _Component);
	
	      function ComponentFromStream() {
	        var _config$fromESObserva;
	
	        var _temp, _this, _ret;
	
	        classCallCheck(this, ComponentFromStream);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = changeEmitter.createChangeEmitter(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
	          subscribe: function subscribe(observer) {
	            var unsubscribe = _this.propsEmitter.listen(function (props) {
	              if (props) {
	                observer.next(props);
	              } else {
	                observer.complete();
	              }
	            });
	            return { unsubscribe: unsubscribe };
	          }
	        }, _config$fromESObserva[$$observable] = function () {
	          return this;
	        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
	      }
	
	      // Stream of props
	
	
	      // Stream of vdom
	
	
	      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        // Subscribe to child prop changes so we know when to re-render
	        this.subscription = this.vdom$.subscribe({
	          next: function next(vdom) {
	            _this2.setState({ vdom: vdom });
	          }
	        });
	        this.propsEmitter.emit(this.props);
	      };
	
	      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        // Receive new props from the owner
	        this.propsEmitter.emit(nextProps);
	      };
	
	      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        return nextState.vdom !== this.state.vdom;
	      };
	
	      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
	        // Call without arguments to complete stream
	        this.propsEmitter.emit();
	
	        // Clean-up subscription before un-mounting
	        this.subscription.unsubscribe();
	      };
	
	      ComponentFromStream.prototype.render = function render() {
	        return this.state.vdom;
	      };
	
	      return ComponentFromStream;
	    }(React.Component);
	  };
	};
	
	var componentFromStream = function componentFromStream(propsToVdom) {
	  return componentFromStreamWithConfig(config)(propsToVdom);
	};
	
	var identity$1 = function identity(t) {
	  return t;
	};
	
	var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
	  var componentFromStream = componentFromStreamWithConfig({
	    fromESObservable: identity$1,
	    toESObservable: identity$1
	  });
	  return function (transform) {
	    return function (BaseComponent) {
	      var factory = React.createFactory(BaseComponent);
	      var fromESObservable = config$$1.fromESObservable,
	          toESObservable = config$$1.toESObservable;
	
	      return componentFromStream(function (props$) {
	        var _ref;
	
	        return _ref = {
	          subscribe: function subscribe(observer) {
	            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
	              next: function next(childProps) {
	                return observer.next(factory(childProps));
	              }
	            });
	            return {
	              unsubscribe: function unsubscribe() {
	                return subscription.unsubscribe();
	              }
	            };
	          }
	        }, _ref[$$observable] = function () {
	          return this;
	        }, _ref;
	      });
	    };
	  };
	};
	
	var mapPropsStream = function mapPropsStream(transform) {
	  var hoc = mapPropsStreamWithConfig(config)(transform);
	
	  if (false) {
	    return function (BaseComponent) {
	      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
	    };
	  }
	  return hoc;
	};
	
	var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
	  return function () {
	    var _config$fromESObserva;
	
	    var emitter = changeEmitter.createChangeEmitter();
	    var stream = config$$1.fromESObservable((_config$fromESObserva = {
	      subscribe: function subscribe(observer) {
	        var unsubscribe = emitter.listen(function (value) {
	          return observer.next(value);
	        });
	        return { unsubscribe: unsubscribe };
	      }
	    }, _config$fromESObserva[$$observable] = function () {
	      return this;
	    }, _config$fromESObserva));
	    return {
	      handler: emitter.emit,
	      stream: stream
	    };
	  };
	};
	
	var createEventHandler = createEventHandlerWithConfig(config);
	
	// Higher-order component helpers
	
	exports.mapProps = mapProps;
	exports.withProps = withProps;
	exports.withPropsOnChange = withPropsOnChange;
	exports.withHandlers = withHandlers;
	exports.defaultProps = defaultProps;
	exports.renameProp = renameProp;
	exports.renameProps = renameProps;
	exports.flattenProp = flattenProp;
	exports.withState = withState;
	exports.withStateHandlers = withStateHandlers;
	exports.withReducer = withReducer;
	exports.branch = branch;
	exports.renderComponent = renderComponent;
	exports.renderNothing = renderNothing;
	exports.shouldUpdate = shouldUpdate;
	exports.pure = pure;
	exports.onlyUpdateForKeys = onlyUpdateForKeys;
	exports.onlyUpdateForPropTypes = onlyUpdateForPropTypes;
	exports.withContext = withContext;
	exports.getContext = getContext;
	exports.lifecycle = lifecycle;
	exports.toClass = toClass;
	exports.setStatic = setStatic;
	exports.setPropTypes = setPropTypes;
	exports.setDisplayName = setDisplayName;
	exports.compose = compose;
	exports.getDisplayName = getDisplayName;
	exports.wrapDisplayName = wrapDisplayName;
	exports.shallowEqual = shallowEqual;
	exports.isClassComponent = isClassComponent;
	exports.createSink = createSink;
	exports.componentFromProp = componentFromProp;
	exports.nest = nest;
	exports.hoistStatics = hoistStatics;
	exports.componentFromStream = componentFromStream;
	exports.componentFromStreamWithConfig = componentFromStreamWithConfig;
	exports.mapPropsStream = mapPropsStream;
	exports.mapPropsStreamWithConfig = mapPropsStreamWithConfig;
	exports.createEventHandler = createEventHandler;
	exports.createEventHandlerWithConfig = createEventHandlerWithConfig;
	exports.setObservableConfig = configureObservable;


/***/ }),
/* 2781 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _aphrodite = __webpack_require__(1684);
	
	var _reactScrolllock = __webpack_require__(6280);
	
	var _reactScrolllock2 = _interopRequireDefault(_reactScrolllock);
	
	var _theme = __webpack_require__(479);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Arrow = __webpack_require__(2783);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _Container = __webpack_require__(6189);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Footer = __webpack_require__(6190);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(6191);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _PaginatedThumbnails = __webpack_require__(6192);
	
	var _PaginatedThumbnails2 = _interopRequireDefault(_PaginatedThumbnails);
	
	var _Portal = __webpack_require__(6194);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Spinner = __webpack_require__(6195);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	var _bindFunctions = __webpack_require__(6200);
	
	var _bindFunctions2 = _interopRequireDefault(_bindFunctions);
	
	var _canUseDom = __webpack_require__(6201);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	var _deepMerge = __webpack_require__(588);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// consumers sometimes provide incorrect type or casing
	function normalizeSourceSet(data) {
		var sourceSet = data.srcSet || data.srcset;
	
		if (Array.isArray(sourceSet)) {
			return sourceSet.join();
		}
	
		return sourceSet;
	}
	
	var Lightbox = function (_Component) {
		_inherits(Lightbox, _Component);
	
		function Lightbox(props) {
			_classCallCheck(this, Lightbox);
	
			var _this = _possibleConstructorReturn(this, (Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call(this, props));
	
			_this.theme = (0, _deepMerge2.default)(_theme2.default, props.theme);
			_this.classes = _aphrodite.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, _this.theme));
			_this.state = { imageLoaded: false };
	
			_bindFunctions2.default.call(_this, ['gotoNext', 'gotoPrev', 'closeBackdrop', 'handleKeyboardInput', 'handleImageLoaded']);
			return _this;
		}
	
		_createClass(Lightbox, [{
			key: 'getChildContext',
			value: function getChildContext() {
				return {
					theme: this.theme
				};
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (this.props.isOpen) {
					if (this.props.enableKeyboardInput) {
						window.addEventListener('keydown', this.handleKeyboardInput);
					}
					if (typeof this.props.currentImage === 'number') {
						this.preloadImage(this.props.currentImage, this.handleImageLoaded);
					}
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!_canUseDom2.default) return;
	
				// preload images
				if (nextProps.preloadNextImage) {
					var currentIndex = this.props.currentImage;
					var nextIndex = nextProps.currentImage + 1;
					var prevIndex = nextProps.currentImage - 1;
					var preloadIndex = void 0;
	
					if (currentIndex && nextProps.currentImage > currentIndex) {
						preloadIndex = nextIndex;
					} else if (currentIndex && nextProps.currentImage < currentIndex) {
						preloadIndex = prevIndex;
					}
	
					// if we know the user's direction just get one image
					// otherwise, to be safe, we need to grab one in each direction
					if (preloadIndex) {
						this.preloadImage(preloadIndex);
					} else {
						this.preloadImage(prevIndex);
						this.preloadImage(nextIndex);
					}
				}
	
				// preload current image
				if (this.props.currentImage !== nextProps.currentImage || !this.props.isOpen && nextProps.isOpen) {
					var img = this.preloadImageData(nextProps.images[nextProps.currentImage], this.handleImageLoaded);
					if (img) this.setState({ imageLoaded: img.complete });
				}
	
				// add/remove event listeners
				if (!this.props.isOpen && nextProps.isOpen && nextProps.enableKeyboardInput) {
					window.addEventListener('keydown', this.handleKeyboardInput);
				}
				if (!nextProps.isOpen && nextProps.enableKeyboardInput) {
					window.removeEventListener('keydown', this.handleKeyboardInput);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (this.props.enableKeyboardInput) {
					window.removeEventListener('keydown', this.handleKeyboardInput);
				}
			}
	
			// ==============================
			// METHODS
			// ==============================
	
		}, {
			key: 'preloadImage',
			value: function preloadImage(idx, onload) {
				return this.preloadImageData(this.props.images[idx], onload);
			}
		}, {
			key: 'preloadImageData',
			value: function preloadImageData(data, onload) {
				if (!data) return;
				var img = new Image();
				var sourceSet = normalizeSourceSet(data);
	
				// TODO: add error handling for missing images
				img.onerror = onload;
				img.onload = onload;
				img.src = data.src;
	
				if (sourceSet) img.srcset = sourceSet;
	
				return img;
			}
		}, {
			key: 'gotoNext',
			value: function gotoNext(event) {
				var _props = this.props,
				    currentImage = _props.currentImage,
				    images = _props.images;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!imageLoaded || currentImage === images.length - 1) return;
	
				if (event) {
					event.preventDefault();
					event.stopPropagation();
				}
	
				this.props.onClickNext();
			}
		}, {
			key: 'gotoPrev',
			value: function gotoPrev(event) {
				var currentImage = this.props.currentImage;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!imageLoaded || currentImage === 0) return;
	
				if (event) {
					event.preventDefault();
					event.stopPropagation();
				}
	
				this.props.onClickPrev();
			}
		}, {
			key: 'closeBackdrop',
			value: function closeBackdrop(event) {
				// make sure event only happens if they click the backdrop
				// and if the caption is widening the figure element let that respond too
				if (event.target.id === 'lightboxBackdrop' || event.target.tagName === 'FIGURE') {
					this.props.onClose();
				}
			}
		}, {
			key: 'handleKeyboardInput',
			value: function handleKeyboardInput(event) {
				if (event.keyCode === 37) {
					// left
					this.gotoPrev(event);
					return true;
				} else if (event.keyCode === 39) {
					// right
					this.gotoNext(event);
					return true;
				} else if (event.keyCode === 27) {
					// esc
					this.props.onClose();
					return true;
				}
				return false;
			}
		}, {
			key: 'handleImageLoaded',
			value: function handleImageLoaded() {
				this.setState({ imageLoaded: true });
			}
	
			// ==============================
			// RENDERERS
			// ==============================
	
		}, {
			key: 'renderArrowPrev',
			value: function renderArrowPrev() {
				if (this.props.currentImage === 0) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'left',
					icon: 'arrowLeft',
					onClick: this.gotoPrev,
					title: this.props.leftArrowTitle,
					type: 'button'
				});
			}
		}, {
			key: 'renderArrowNext',
			value: function renderArrowNext() {
				if (this.props.currentImage === this.props.images.length - 1) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'right',
					icon: 'arrowRight',
					onClick: this.gotoNext,
					title: this.props.rightArrowTitle,
					type: 'button'
				});
			}
		}, {
			key: 'renderDialog',
			value: function renderDialog() {
				var _props2 = this.props,
				    backdropClosesModal = _props2.backdropClosesModal,
				    isOpen = _props2.isOpen,
				    showThumbnails = _props2.showThumbnails,
				    width = _props2.width;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!isOpen) return _react2.default.createElement('span', { key: 'closed' });
	
				var offsetThumbnails = 0;
				if (showThumbnails) {
					offsetThumbnails = this.theme.thumbnail.size + this.theme.container.gutter.vertical;
				}
	
				return _react2.default.createElement(
					_Container2.default,
					{
						key: 'open',
						onClick: backdropClosesModal && this.closeBackdrop,
						onTouchEnd: backdropClosesModal && this.closeBackdrop
					},
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'div',
							{ className: (0, _aphrodite.css)(this.classes.content), style: { marginBottom: offsetThumbnails, maxWidth: width } },
							imageLoaded && this.renderHeader(),
							this.renderImages(),
							this.renderSpinner(),
							imageLoaded && this.renderFooter()
						),
						imageLoaded && this.renderThumbnails(),
						imageLoaded && this.renderArrowPrev(),
						imageLoaded && this.renderArrowNext(),
						this.props.preventScroll && _react2.default.createElement(_reactScrolllock2.default, null)
					)
				);
			}
		}, {
			key: 'renderImages',
			value: function renderImages() {
				var _props3 = this.props,
				    currentImage = _props3.currentImage,
				    images = _props3.images,
				    onClickImage = _props3.onClickImage,
				    showThumbnails = _props3.showThumbnails;
				var imageLoaded = this.state.imageLoaded;
	
	
				if (!images || !images.length) return null;
	
				var image = images[currentImage];
				var sourceSet = normalizeSourceSet(image);
				var sizes = sourceSet ? '100vw' : null;
	
				var thumbnailsSize = showThumbnails ? this.theme.thumbnail.size : 0;
				var heightOffset = this.theme.header.height + this.theme.footer.height + thumbnailsSize + this.theme.container.gutter.vertical + 'px';
	
				return _react2.default.createElement(
					'figure',
					{ className: (0, _aphrodite.css)(this.classes.figure) },
					_react2.default.createElement('img', {
						className: (0, _aphrodite.css)(this.classes.image, imageLoaded && this.classes.imageLoaded),
						onClick: onClickImage,
						sizes: sizes,
						alt: image.alt,
						src: image.src,
						srcSet: sourceSet,
						style: {
							cursor: onClickImage ? 'pointer' : 'auto',
							maxHeight: 'calc(100vh - ' + heightOffset + ')'
						}
					})
				);
			}
		}, {
			key: 'renderThumbnails',
			value: function renderThumbnails() {
				var _props4 = this.props,
				    images = _props4.images,
				    currentImage = _props4.currentImage,
				    onClickThumbnail = _props4.onClickThumbnail,
				    showThumbnails = _props4.showThumbnails,
				    thumbnailOffset = _props4.thumbnailOffset;
	
	
				if (!showThumbnails) return;
	
				return _react2.default.createElement(_PaginatedThumbnails2.default, {
					currentImage: currentImage,
					images: images,
					offset: thumbnailOffset,
					onClickThumbnail: onClickThumbnail
				});
			}
		}, {
			key: 'renderHeader',
			value: function renderHeader() {
				var _props5 = this.props,
				    closeButtonTitle = _props5.closeButtonTitle,
				    customControls = _props5.customControls,
				    onClose = _props5.onClose,
				    showCloseButton = _props5.showCloseButton;
	
	
				return _react2.default.createElement(_Header2.default, {
					customControls: customControls,
					onClose: onClose,
					showCloseButton: showCloseButton,
					closeButtonTitle: closeButtonTitle
				});
			}
		}, {
			key: 'renderFooter',
			value: function renderFooter() {
				var _props6 = this.props,
				    currentImage = _props6.currentImage,
				    images = _props6.images,
				    imageCountSeparator = _props6.imageCountSeparator,
				    showImageCount = _props6.showImageCount;
	
	
				if (!images || !images.length) return null;
	
				return _react2.default.createElement(_Footer2.default, {
					caption: images[currentImage].caption,
					countCurrent: currentImage + 1,
					countSeparator: imageCountSeparator,
					countTotal: images.length,
					showCount: showImageCount
				});
			}
		}, {
			key: 'renderSpinner',
			value: function renderSpinner() {
				var _props7 = this.props,
				    spinner = _props7.spinner,
				    spinnerColor = _props7.spinnerColor,
				    spinnerSize = _props7.spinnerSize;
				var imageLoaded = this.state.imageLoaded;
	
				var Spinner = spinner;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _aphrodite.css)(this.classes.spinner, !imageLoaded && this.classes.spinnerActive) },
					_react2.default.createElement(Spinner, {
						color: spinnerColor,
						size: spinnerSize
					})
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Portal2.default,
					null,
					this.renderDialog()
				);
			}
		}]);
	
		return Lightbox;
	}(_react.Component);
	
	Lightbox.propTypes = {
		backdropClosesModal: _propTypes2.default.bool,
		closeButtonTitle: _propTypes2.default.string,
		currentImage: _propTypes2.default.number,
		customControls: _propTypes2.default.arrayOf(_propTypes2.default.node),
		enableKeyboardInput: _propTypes2.default.bool,
		imageCountSeparator: _propTypes2.default.string,
		images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			src: _propTypes2.default.string.isRequired,
			srcSet: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
			caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
			thumbnail: _propTypes2.default.string
		})).isRequired,
		isOpen: _propTypes2.default.bool,
		leftArrowTitle: _propTypes2.default.string,
		onClickImage: _propTypes2.default.func,
		onClickNext: _propTypes2.default.func,
		onClickPrev: _propTypes2.default.func,
		onClose: _propTypes2.default.func.isRequired,
		preloadNextImage: _propTypes2.default.bool,
		preventScroll: _propTypes2.default.bool,
		rightArrowTitle: _propTypes2.default.string,
		showCloseButton: _propTypes2.default.bool,
		showImageCount: _propTypes2.default.bool,
		showThumbnails: _propTypes2.default.bool,
		spinner: _propTypes2.default.func,
		spinnerColor: _propTypes2.default.string,
		spinnerSize: _propTypes2.default.number,
		theme: _propTypes2.default.object,
		thumbnailOffset: _propTypes2.default.number,
		width: _propTypes2.default.number
	};
	Lightbox.defaultProps = {
		closeButtonTitle: 'Close (Esc)',
		currentImage: 0,
		enableKeyboardInput: true,
		imageCountSeparator: ' of ',
		leftArrowTitle: 'Previous (Left arrow key)',
		onClickShowNextImage: true,
		preloadNextImage: true,
		preventScroll: true,
		rightArrowTitle: 'Next (Right arrow key)',
		showCloseButton: true,
		showImageCount: true,
		spinner: _Spinner2.default,
		spinnerColor: 'white',
		spinnerSize: 100,
		theme: {},
		thumbnailOffset: 2,
		width: 1024
	};
	Lightbox.childContextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		content: {
			position: 'relative'
		},
		figure: {
			margin: 0 // remove browser default
		},
		image: {
			display: 'block', // removes browser default gutter
			height: 'auto',
			margin: '0 auto', // maintain center on very short screens OR very narrow image
			maxWidth: '100%',
	
			// disable user select
			WebkitTouchCallout: 'none',
			userSelect: 'none',
	
			// opacity animation on image load
			opacity: 0,
			transition: 'opacity 0.3s'
		},
		imageLoaded: {
			opacity: 1
		},
		spinner: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
	
			// opacity animation to make spinner appear with delay
			opacity: 0,
			transition: 'opacity 0.3s',
			pointerEvents: 'none'
		},
		spinnerActive: {
			opacity: 1
		}
	};
	
	exports.default = Lightbox;

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(389);
	
	var _theme = __webpack_require__(479);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(588);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	var _Icon = __webpack_require__(2784);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Arrow(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var direction = _ref.direction,
		    icon = _ref.icon,
		    onClick = _ref.onClick,
		    size = _ref.size,
		    props = _objectWithoutProperties(_ref, ['direction', 'icon', 'onClick', 'size']);
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement(
			'button',
			_extends({
				type: 'button',
				className: (0, _noImportant.css)(classes.arrow, classes['arrow__direction__' + direction], size && classes['arrow__size__' + size]),
				onClick: onClick,
				onTouchEnd: onClick
			}, props),
			_react2.default.createElement(_Icon2.default, { fill: !!theme.arrow && theme.arrow.fill || _theme2.default.arrow.fill, type: icon })
		);
	}
	
	Arrow.propTypes = {
		direction: _propTypes2.default.oneOf(['left', 'right']),
		icon: _propTypes2.default.string,
		onClick: _propTypes2.default.func.isRequired,
		size: _propTypes2.default.oneOf(['medium', 'small']).isRequired
	};
	Arrow.defaultProps = {
		size: 'medium'
	};
	Arrow.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		arrow: {
			background: 'none',
			border: 'none',
			borderRadius: 4,
			cursor: 'pointer',
			outline: 'none',
			padding: 10, // increase hit area
			position: 'absolute',
			top: '50%',
	
			// disable user select
			WebkitTouchCallout: 'none',
			userSelect: 'none'
		},
	
		// sizes
		arrow__size__medium: {
			height: _theme2.default.arrow.height,
			marginTop: _theme2.default.arrow.height / -2,
			width: 40,
	
			'@media (min-width: 768px)': {
				width: 70
			}
		},
		arrow__size__small: {
			height: _theme2.default.thumbnail.size,
			marginTop: _theme2.default.thumbnail.size / -2,
			width: 30,
	
			'@media (min-width: 500px)': {
				width: 40
			}
		},
	
		// direction
		arrow__direction__right: {
			right: _theme2.default.container.gutter.horizontal
		},
		arrow__direction__left: {
			left: _theme2.default.container.gutter.horizontal
		}
	};
	
	exports.default = Arrow;

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _arrowLeft = __webpack_require__(6197);
	
	var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
	var _arrowRight = __webpack_require__(6198);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _close = __webpack_require__(6199);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var icons = { arrowLeft: _arrowLeft2.default, arrowRight: _arrowRight2.default, close: _close2.default };
	
	var Icon = function Icon(_ref) {
		var fill = _ref.fill,
		    type = _ref.type,
		    props = _objectWithoutProperties(_ref, ['fill', 'type']);
	
		var icon = icons[type];
	
		return _react2.default.createElement('span', _extends({
			dangerouslySetInnerHTML: { __html: icon(fill) }
		}, props));
	};
	
	Icon.propTypes = {
		fill: _propTypes2.default.string,
		type: _propTypes2.default.oneOf(Object.keys(icons))
	};
	Icon.defaultProps = {
		fill: 'white'
	};
	
	exports.default = Icon;

/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(746));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(71));
	
	var _reactLifecyclesCompat = __webpack_require__(1616);
	
	var _PropTypes = __webpack_require__(2787);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   *  appear: 500,
	   * }}
	   * ```
	   *
	   * If the value of appear is not set, then the value from enter is taken.
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(746));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(1616);
	
	var _ChildMapping = __webpack_require__(6211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 2787 */
[6834, 746],
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		_createClass(AutosizeInput, null, [{
			key: 'getDerivedStateFromProps',
			value: function getDerivedStateFromProps(props, state) {
				var id = props.id;
	
				return id !== state.prevId ? { inputId: id || generateId(), prevId: id } : null;
			}
		}]);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId(),
				prevId: props.id
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var utils_1 = __webpack_require__(180);
	var injectIntl_1 = __webpack_require__(383);
	var DisplayName;
	(function (DisplayName) {
	    DisplayName["formatDate"] = "FormattedDate";
	    DisplayName["formatTime"] = "FormattedTime";
	    DisplayName["formatNumber"] = "FormattedNumber";
	    DisplayName["formatList"] = "FormattedList";
	    // Note that this DisplayName is the locale display name, not to be confused with
	    // the name of the enum, which is for React component display name in dev tools.
	    DisplayName["formatDisplayName"] = "FormattedDisplayName";
	})(DisplayName || (DisplayName = {}));
	var DisplayNameParts;
	(function (DisplayNameParts) {
	    DisplayNameParts["formatDate"] = "FormattedDateParts";
	    DisplayNameParts["formatTime"] = "FormattedTimeParts";
	    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
	    DisplayNameParts["formatList"] = "FormattedListParts";
	})(DisplayNameParts || (DisplayNameParts = {}));
	exports.FormattedNumberParts = function (props) { return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	    utils_1.invariantIntlContext(intl);
	    var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
	    return children(intl.formatNumberToParts(value, formatProps));
	})); };
	exports.FormattedNumberParts.displayName = 'FormattedNumberParts';
	function createFormattedDateTimePartsComponent(name) {
	    var ComponentParts = function (props) { return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	        utils_1.invariantIntlContext(intl);
	        var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
	        var date = typeof value === 'string' ? new Date(value || 0) : value;
	        var formattedParts = name === 'formatDate'
	            ? intl.formatDateToParts(date, formatProps)
	            : intl.formatTimeToParts(date, formatProps);
	        return children(formattedParts);
	    })); };
	    ComponentParts.displayName = DisplayNameParts[name];
	    return ComponentParts;
	}
	exports.createFormattedDateTimePartsComponent = createFormattedDateTimePartsComponent;
	function createFormattedComponent(name) {
	    var Component = function (props) { return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	        utils_1.invariantIntlContext(intl);
	        var value = props.value, children = props.children, formatProps = __rest(props, ["value", "children"]);
	        // TODO: fix TS type definition for localeMatcher upstream
	        var formattedValue = intl[name](value, formatProps);
	        if (typeof children === 'function') {
	            return children(formattedValue);
	        }
	        var Text = intl.textComponent || React.Fragment;
	        return React.createElement(Text, null, formattedValue);
	    })); };
	    Component.displayName = DisplayName[name];
	    return Component;
	}
	exports.createFormattedComponent = createFormattedComponent;


/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __rest = (this && this.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(383);
	var message_1 = __webpack_require__(2791);
	var utils_1 = __webpack_require__(180);
	var shallowEquals_ = __webpack_require__(2885);
	var shallowEquals = shallowEquals_.default || shallowEquals_;
	var defaultFormatMessage = function (descriptor, values) {
	    if (false) {
	        console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
	    }
	    return message_1.formatMessage(__assign(__assign({}, utils_1.DEFAULT_INTL_CONFIG), { locale: 'en' }), utils_1.createFormatters(), descriptor, values);
	};
	var FormattedMessage = /** @class */ (function (_super) {
	    __extends(FormattedMessage, _super);
	    function FormattedMessage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FormattedMessage.prototype.shouldComponentUpdate = function (nextProps) {
	        var _a = this.props, values = _a.values, otherProps = __rest(_a, ["values"]);
	        var nextValues = nextProps.values, nextOtherProps = __rest(nextProps, ["values"]);
	        return (!shallowEquals(nextValues, values) ||
	            !shallowEquals(otherProps, nextOtherProps));
	    };
	    FormattedMessage.prototype.render = function () {
	        var _this = this;
	        return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	            if (!_this.props.defaultMessage) {
	                utils_1.invariantIntlContext(intl);
	            }
	            var _a = intl || {}, _b = _a.formatMessage, formatMessage = _b === void 0 ? defaultFormatMessage : _b, _c = _a.textComponent, Text = _c === void 0 ? React.Fragment : _c;
	            var _d = _this.props, id = _d.id, description = _d.description, defaultMessage = _d.defaultMessage, values = _d.values, children = _d.children, _e = _d.tagName, Component = _e === void 0 ? Text : _e;
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var nodes = formatMessage(descriptor, values);
	            if (!Array.isArray(nodes)) {
	                nodes = [nodes];
	            }
	            if (typeof children === 'function') {
	                return children.apply(void 0, nodes);
	            }
	            if (Component) {
	                // Needs to use `createElement()` instead of JSX, otherwise React will
	                // warn about a missing `key` prop with rich-text message formatting.
	                return React.createElement.apply(React, __spreadArrays([Component, null], nodes));
	            }
	            return nodes;
	        }));
	    };
	    FormattedMessage.displayName = 'FormattedMessage';
	    FormattedMessage.defaultProps = {
	        values: {},
	    };
	    return FormattedMessage;
	}(React.Component));
	exports.default = FormattedMessage;


/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var intl_utils_1 = __webpack_require__(1058);
	var utils_1 = __webpack_require__(180);
	var intl_messageformat_1 = __webpack_require__(2297);
	function setTimeZoneInOptions(opts, timeZone) {
	    return Object.keys(opts).reduce(function (all, k) {
	        all[k] = __assign({ timeZone: timeZone }, opts[k]);
	        return all;
	    }, {});
	}
	function deepMergeOptions(opts1, opts2) {
	    var keys = Object.keys(__assign(__assign({}, opts1), opts2));
	    return keys.reduce(function (all, k) {
	        all[k] = __assign(__assign({}, (opts1[k] || {})), (opts2[k] || {}));
	        return all;
	    }, {});
	}
	function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
	    if (!timeZone) {
	        return f1;
	    }
	    var mfFormats = intl_messageformat_1.default.formats;
	    return __assign(__assign(__assign({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
	}
	exports.prepareIntlMessageFormatHtmlOutput = function (chunks) { return React.createElement.apply(React, __spreadArrays([React.Fragment, null], chunks)); };
	function formatMessage(_a, state, messageDescriptor, values) {
	    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, onError = _a.onError, timeZone = _a.timeZone;
	    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
	    if (values === void 0) { values = {}; }
	    var id = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
	    // `id` is a required field of a Message Descriptor.
	    intl_utils_1.invariant(!!id, '[React Intl] An `id` must be provided to format a message.');
	    var message = messages && messages[String(id)];
	    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
	    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
	    var formattedMessageParts = [];
	    if (message) {
	        try {
	            var formatter = state.getMessageFormat(message, locale, formats, {
	                formatters: state,
	            });
	            formattedMessageParts = formatter.formatHTMLMessage(values);
	        }
	        catch (e) {
	            onError(utils_1.createError("Error formatting message: \"" + id + "\" for locale: \"" + locale + "\"" +
	                (defaultMessage ? ', using default message as fallback.' : ''), e));
	        }
	    }
	    else {
	        // This prevents warnings from littering the console in development
	        // when no `messages` are passed into the <IntlProvider> for the
	        // default locale, and a default message is in the source.
	        if (!defaultMessage ||
	            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
	            onError(utils_1.createError("Missing message: \"" + id + "\" for locale: \"" + locale + "\"" +
	                (defaultMessage ? ', using default message as fallback.' : '')));
	        }
	    }
	    if (!formattedMessageParts.length && defaultMessage) {
	        try {
	            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	            formattedMessageParts = formatter.formatHTMLMessage(values);
	        }
	        catch (e) {
	            onError(utils_1.createError("Error formatting the default message for: \"" + id + "\"", e));
	        }
	    }
	    if (!formattedMessageParts.length) {
	        onError(utils_1.createError("Cannot format message: \"" + id + "\", " +
	            ("using message " + (message || defaultMessage ? 'source' : 'id') + " as fallback.")));
	        if (typeof message === 'string') {
	            return message || defaultMessage || String(id);
	        }
	        return defaultMessage || String(id);
	    }
	    if (formattedMessageParts.length === 1 &&
	        typeof formattedMessageParts[0] === 'string') {
	        return formattedMessageParts[0] || defaultMessage || String(id);
	    }
	    return exports.prepareIntlMessageFormatHtmlOutput(formattedMessageParts);
	}
	exports.formatMessage = formatMessage;
	function formatHTMLMessage(config, state, messageDescriptor, rawValues) {
	    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
	    if (rawValues === void 0) { rawValues = {}; }
	    // Process all the values before they are used when formatting the ICU
	    // Message string. Since the formatted message might be injected via
	    // `innerHTML`, all String-based values need to be HTML-escaped.
	    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	        var value = rawValues[name];
	        escaped[name] = typeof value === 'string' ? utils_1.escape(value) : value;
	        return escaped;
	    }, {});
	    return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	exports.formatHTMLMessage = formatHTMLMessage;


/***/ }),
/* 2792 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Namespaces to avoid conflicts on the context.
	 */
	var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
	var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
	var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
	var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultProps = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// create defaults
	var defaultProps = exports.defaultProps = {
	  attributes: {},
	  styles: {}
	};
	
	var PropToggle = function (_PureComponent) {
	  _inherits(PropToggle, _PureComponent);
	
	  function PropToggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PropToggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PropToggle.__proto__ || Object.getPrototypeOf(PropToggle)).call.apply(_ref, [this].concat(args))), _this), _this.originalAttributes = {}, _this.originalStyles = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PropToggle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          attributes = _props.attributes,
	          styles = _props.styles,
	          _props$target = _props.target,
	          target = _props$target === undefined ? document.body : _props$target;
	
	      if (!target) return;
	
	      this.attributeKeys = Object.keys(attributes);
	      this.styleKeys = Object.keys(styles);
	
	      // styles
	      if (this.styleKeys.length) {
	        this.styleKeys.forEach(function (k) {
	          _this2.originalStyles[k] = target.style.getPropertyValue(k);
	          target.style.setProperty(k, styles[k]);
	        });
	      }
	
	      // attributes
	      if (this.attributeKeys.length) {
	        this.attributeKeys.forEach(function (k) {
	          _this2.originalAttributes[k] = target.getAttribute(k) || '';
	          target.setAttribute(k, attributes[k]);
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      var _props$target2 = this.props.target,
	          target = _props$target2 === undefined ? document.body : _props$target2;
	
	      if (!target) return;
	
	      // styles
	      if (this.styleKeys.length) {
	        this.styleKeys.forEach(function (k) {
	          target.style.setProperty(k, _this3.originalStyles[k]);
	        });
	      }
	
	      // attributes
	      if (this.attributeKeys.length) {
	        this.attributeKeys.forEach(function (k) {
	          if (_this3.originalAttributes[k]) {
	            target.setAttribute(k, _this3.originalAttributes[k]);
	          } else {
	            target.removeAttribute(k);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return PropToggle;
	}(_react.PureComponent);
	
	PropToggle.defaultProps = defaultProps;
	exports.default = PropToggle;

/***/ }),
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */,
/* 2800 */,
/* 2801 */,
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */,
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preventTouchMove = preventTouchMove;
	exports.allowTouchMove = allowTouchMove;
	exports.preventInertiaScroll = preventInertiaScroll;
	exports.isTouchDevice = isTouchDevice;
	exports.getPadding = getPadding;
	exports.camelToKebab = camelToKebab;
	exports.getWindowHeight = getWindowHeight;
	exports.getDocumentHeight = getDocumentHeight;
	exports.parse = parse;
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	}
	
	// `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	function isTouchDevice() {
	  if (!window) return false;
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	function getPadding() {
	  if (!document || !window) return 0;
	
	  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
	  var clientWidth = document.body ? document.body.clientWidth : 0;
	  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	
	  return adjustedPadding;
	}
	
	function camelToKebab(str) {
	  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
	
	function getWindowHeight() {
	  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	  if (window && window.innerHeight) {
	    return window.innerHeight * multiplier;
	  }
	}
	
	function getDocumentHeight() {
	  if (document && document.body) {
	    return document.body.clientHeight;
	  }
	}
	
	function parse(val) {
	  return isNaN(val) ? val : val + 'px';
	}

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(1043));
	var _extends = _interopDefault(__webpack_require__(1040));
	var _defineProperty = _interopDefault(__webpack_require__(1628));
	var _classCallCheck = _interopDefault(__webpack_require__(1038));
	var _createClass = _interopDefault(__webpack_require__(1039));
	var _inherits = _interopDefault(__webpack_require__(1042));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(1044));
	var _getPrototypeOf = _interopDefault(__webpack_require__(1041));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var core = __webpack_require__(1629);
	var reactDom = __webpack_require__(71);
	var _typeof = _interopDefault(__webpack_require__(749));
	var _css = _interopDefault(__webpack_require__(486));
	var _taggedTemplateLiteral = _interopDefault(__webpack_require__(2820));
	var AutosizeInput = _interopDefault(__webpack_require__(2788));
	
	// ==============================
	// NO OP
	// ==============================
	var noop = function noop() {};
	// Class Name Prefixer
	// ==============================
	
	/**
	 String representation of component state for styling with class names.
	
	 Expects an array of strings OR a string/object pair:
	 - className(['comp', 'comp-arg', 'comp-arg-2'])
	   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
	 - className('comp', { some: true, state: false })
	   @returns 'react-select__comp react-select__comp--some'
	*/
	
	function applyPrefixToName(prefix, name) {
	  if (!name) {
	    return prefix;
	  } else if (name[0] === '-') {
	    return prefix + name;
	  } else {
	    return prefix + '__' + name;
	  }
	}
	
	function classNames(prefix, state, className) {
	  var arr = [className];
	
	  if (state && prefix) {
	    for (var key in state) {
	      if (state.hasOwnProperty(key) && state[key]) {
	        arr.push("".concat(applyPrefixToName(prefix, key)));
	      }
	    }
	  }
	
	  return arr.filter(function (i) {
	    return i;
	  }).map(function (i) {
	    return String(i).trim();
	  }).join(' ');
	} // ==============================
	// Clean Value
	// ==============================
	
	var cleanValue = function cleanValue(value) {
	  if (Array.isArray(value)) return value.filter(Boolean);
	  if (_typeof(value) === 'object' && value !== null) return [value];
	  return [];
	}; // ==============================
	// Handle Input Change
	// ==============================
	
	function handleInputChange(inputValue, actionMeta, onInputChange) {
	  if (onInputChange) {
	    var newValue = onInputChange(inputValue, actionMeta);
	    if (typeof newValue === 'string') return newValue;
	  }
	
	  return inputValue;
	} // ==============================
	// Scroll Helpers
	// ==============================
	
	function isDocumentElement(el) {
	  return [document.documentElement, document.body, window].indexOf(el) > -1;
	} // Normalized Scroll Top
	// ------------------------------
	
	function getScrollTop(el) {
	  if (isDocumentElement(el)) {
	    return window.pageYOffset;
	  }
	
	  return el.scrollTop;
	}
	function scrollTo(el, top) {
	  // with a scroll distance, we perform scroll on the element
	  if (isDocumentElement(el)) {
	    window.scrollTo(0, top);
	    return;
	  }
	
	  el.scrollTop = top;
	} // Get Scroll Parent
	// ------------------------------
	
	function getScrollParent(element) {
	  var style = getComputedStyle(element);
	  var excludeStaticParent = style.position === 'absolute';
	  var overflowRx = /(auto|scroll)/;
	  var docEl = document.documentElement; // suck it, flow...
	
	  if (style.position === 'fixed') return docEl;
	
	  for (var parent = element; parent = parent.parentElement;) {
	    style = getComputedStyle(parent);
	
	    if (excludeStaticParent && style.position === 'static') {
	      continue;
	    }
	
	    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
	      return parent;
	    }
	  }
	
	  return docEl;
	} // Animated Scroll To
	// ------------------------------
	
	/**
	  @param t: time (elapsed)
	  @param b: initial value
	  @param c: amount of change
	  @param d: duration
	*/
	
	function easeOutCubic(t, b, c, d) {
	  return c * ((t = t / d - 1) * t * t + 1) + b;
	}
	
	function animatedScrollTo(element, to) {
	  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
	  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
	  var start = getScrollTop(element);
	  var change = to - start;
	  var increment = 10;
	  var currentTime = 0;
	
	  function animateScroll() {
	    currentTime += increment;
	    var val = easeOutCubic(currentTime, start, change, duration);
	    scrollTo(element, val);
	
	    if (currentTime < duration) {
	      window.requestAnimationFrame(animateScroll);
	    } else {
	      callback(element);
	    }
	  }
	
	  animateScroll();
	} // Scroll Into View
	// ------------------------------
	
	function scrollIntoView(menuEl, focusedEl) {
	  var menuRect = menuEl.getBoundingClientRect();
	  var focusedRect = focusedEl.getBoundingClientRect();
	  var overScroll = focusedEl.offsetHeight / 3;
	
	  if (focusedRect.bottom + overScroll > menuRect.bottom) {
	    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
	  } else if (focusedRect.top - overScroll < menuRect.top) {
	    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
	  }
	} // ==============================
	// Get bounding client object
	// ==============================
	// cannot get keys using array notation with DOMRect
	
	function getBoundingClientObj(element) {
	  var rect = element.getBoundingClientRect();
	  return {
	    bottom: rect.bottom,
	    height: rect.height,
	    left: rect.left,
	    right: rect.right,
	    top: rect.top,
	    width: rect.width
	  };
	}
	// Touch Capability Detector
	// ==============================
	
	function isTouchCapable() {
	  try {
	    document.createEvent('TouchEvent');
	    return true;
	  } catch (e) {
	    return false;
	  }
	} // ==============================
	// Mobile Device Detector
	// ==============================
	
	function isMobileDevice() {
	  try {
	    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	  } catch (e) {
	    return false;
	  }
	}
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	function getMenuPlacement(_ref) {
	  var maxHeight = _ref.maxHeight,
	      menuEl = _ref.menuEl,
	      minHeight = _ref.minHeight,
	      placement = _ref.placement,
	      shouldScroll = _ref.shouldScroll,
	      isFixedPosition = _ref.isFixedPosition,
	      theme = _ref.theme;
	  var spacing = theme.spacing;
	  var scrollParent = getScrollParent(menuEl);
	  var defaultState = {
	    placement: 'bottom',
	    maxHeight: maxHeight
	  }; // something went wrong, return default state
	
	  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
	  // the menu is rendered
	
	  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
	      scrollHeight = _scrollParent$getBoun.height;
	
	  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
	      menuBottom = _menuEl$getBoundingCl.bottom,
	      menuHeight = _menuEl$getBoundingCl.height,
	      menuTop = _menuEl$getBoundingCl.top;
	
	  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
	      containerTop = _menuEl$offsetParent$.top;
	
	  var viewHeight = window.innerHeight;
	  var scrollTop = getScrollTop(scrollParent);
	  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
	  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
	  var viewSpaceAbove = containerTop - marginTop;
	  var viewSpaceBelow = viewHeight - menuTop;
	  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
	  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
	  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
	  var scrollUp = scrollTop + menuTop - marginTop;
	  var scrollDuration = 160;
	
	  switch (placement) {
	    case 'auto':
	    case 'bottom':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceBelow >= menuHeight) {
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
	        }
	
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
	        if (shouldScroll) {
	          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
	        } // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	
	        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
	        return {
	          placement: 'bottom',
	          maxHeight: constrainedHeight
	        };
	      } // 4. Forked beviour when there isn't enough space below
	      // AUTO: flip the menu, render above
	
	
	      if (placement === 'auto' || isFixedPosition) {
	        // may need to be constrained after flipping
	        var _constrainedHeight = maxHeight;
	        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
	
	        if (spaceAbove >= minHeight) {
	          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight
	        };
	      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
	
	
	      if (placement === 'bottom') {
	        scrollTo(scrollParent, scrollDown);
	        return {
	          placement: 'bottom',
	          maxHeight: maxHeight
	        };
	      }
	
	      break;
	
	    case 'top':
	      // 1: the menu will fit, do nothing
	      if (viewSpaceAbove >= menuHeight) {
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 2: the menu will fit, if scrolled
	
	
	      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
	        if (shouldScroll) {
	          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: maxHeight
	        };
	      } // 3: the menu will fit, if constrained
	
	
	      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
	        // so give them whatever is available below rather than the minHeight.
	
	        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
	          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
	        }
	
	        if (shouldScroll) {
	          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
	        }
	
	        return {
	          placement: 'top',
	          maxHeight: _constrainedHeight2
	        };
	      } // 4. not enough space, the browser WILL NOT increase scrollable area when
	      // absolutely positioned element rendered above the viewport (only below).
	      // Flip the menu, render below
	
	
	      return {
	        placement: 'bottom',
	        maxHeight: maxHeight
	      };
	
	    default:
	      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
	  } // fulfil contract with flow: implicit return value of undefined
	
	
	  return defaultState;
	} // Menu Component
	// ------------------------------
	
	function alignToControl(placement) {
	  var placementToCSSProp = {
	    bottom: 'top',
	    top: 'bottom'
	  };
	  return placement ? placementToCSSProp[placement] : 'bottom';
	}
	
	var coercePlacement = function coercePlacement(p) {
	  return p === 'auto' ? 'bottom' : p;
	};
	
	var menuCSS = function menuCSS(_ref2) {
	  var _ref3;
	
	  var placement = _ref2.placement,
	      _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      spacing = _ref2$theme.spacing,
	      colors = _ref2$theme.colors;
	  return _ref3 = {
	    label: 'menu'
	  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
	};
	var PortalPlacementContext = /*#__PURE__*/React.createContext({
	  getPortalPlacement: null
	}); // NOTE: internal only
	
	var MenuPlacer = /*#__PURE__*/function (_Component) {
	  _inherits(MenuPlacer, _Component);
	
	  var _super = _createSuper(MenuPlacer);
	
	  function MenuPlacer() {
	    var _this;
	
	    _classCallCheck(this, MenuPlacer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	    _this.state = {
	      maxHeight: _this.props.maxMenuHeight,
	      placement: null
	    };
	
	    _this.getPlacement = function (ref) {
	      var _this$props = _this.props,
	          minMenuHeight = _this$props.minMenuHeight,
	          maxMenuHeight = _this$props.maxMenuHeight,
	          menuPlacement = _this$props.menuPlacement,
	          menuPosition = _this$props.menuPosition,
	          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
	          theme = _this$props.theme;
	      if (!ref) return; // DO NOT scroll if position is fixed
	
	      var isFixedPosition = menuPosition === 'fixed';
	      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
	      var state = getMenuPlacement({
	        maxHeight: maxMenuHeight,
	        menuEl: ref,
	        minHeight: minMenuHeight,
	        placement: menuPlacement,
	        shouldScroll: shouldScroll,
	        isFixedPosition: isFixedPosition,
	        theme: theme
	      });
	      var getPortalPlacement = _this.context.getPortalPlacement;
	      if (getPortalPlacement) getPortalPlacement(state);
	
	      _this.setState(state);
	    };
	
	    _this.getUpdatedProps = function () {
	      var menuPlacement = _this.props.menuPlacement;
	      var placement = _this.state.placement || coercePlacement(menuPlacement);
	      return _objectSpread(_objectSpread({}, _this.props), {}, {
	        placement: placement,
	        maxHeight: _this.state.maxHeight
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuPlacer, [{
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return children({
	        ref: this.getPlacement,
	        placerProps: this.getUpdatedProps()
	      });
	    }
	  }]);
	
	  return MenuPlacer;
	}(React.Component);
	MenuPlacer.contextType = PortalPlacementContext;
	
	var Menu = function Menu(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('menu', props),
	    className: cx({
	      menu: true
	    }, className)
	  }, innerProps, {
	    ref: innerRef
	  }), children);
	};
	// Menu List
	// ==============================
	
	var menuListCSS = function menuListCSS(_ref4) {
	  var maxHeight = _ref4.maxHeight,
	      baseUnit = _ref4.theme.spacing.baseUnit;
	  return {
	    maxHeight: maxHeight,
	    overflowY: 'auto',
	    paddingBottom: baseUnit,
	    paddingTop: baseUnit,
	    position: 'relative',
	    // required for offset[Height, Top] > keyboard scroll
	    WebkitOverflowScrolling: 'touch'
	  };
	};
	var MenuList = function MenuList(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isMulti = props.isMulti,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('menuList', props),
	    className: cx({
	      'menu-list': true,
	      'menu-list--is-multi': isMulti
	    }, className),
	    ref: innerRef
	  }, innerProps), children);
	}; // ==============================
	// Menu Notices
	// ==============================
	
	var noticeCSS = function noticeCSS(_ref5) {
	  var _ref5$theme = _ref5.theme,
	      baseUnit = _ref5$theme.spacing.baseUnit,
	      colors = _ref5$theme.colors;
	  return {
	    color: colors.neutral40,
	    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
	    textAlign: 'center'
	  };
	};
	
	var noOptionsMessageCSS = noticeCSS;
	var loadingMessageCSS = noticeCSS;
	var NoOptionsMessage = function NoOptionsMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('noOptionsMessage', props),
	    className: cx({
	      'menu-notice': true,
	      'menu-notice--no-options': true
	    }, className)
	  }, innerProps), children);
	};
	NoOptionsMessage.defaultProps = {
	  children: 'No options'
	};
	var LoadingMessage = function LoadingMessage(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('loadingMessage', props),
	    className: cx({
	      'menu-notice': true,
	      'menu-notice--loading': true
	    }, className)
	  }, innerProps), children);
	};
	LoadingMessage.defaultProps = {
	  children: 'Loading...'
	}; // ==============================
	// Menu Portal
	// ==============================
	
	var menuPortalCSS = function menuPortalCSS(_ref6) {
	  var rect = _ref6.rect,
	      offset = _ref6.offset,
	      position = _ref6.position;
	  return {
	    left: rect.left,
	    position: position,
	    top: offset,
	    width: rect.width,
	    zIndex: 1
	  };
	};
	var MenuPortal = /*#__PURE__*/function (_Component2) {
	  _inherits(MenuPortal, _Component2);
	
	  var _super2 = _createSuper(MenuPortal);
	
	  function MenuPortal() {
	    var _this2;
	
	    _classCallCheck(this, MenuPortal);
	
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    _this2 = _super2.call.apply(_super2, [this].concat(args));
	    _this2.state = {
	      placement: null
	    };
	
	    _this2.getPortalPlacement = function (_ref7) {
	      var placement = _ref7.placement;
	      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
	
	      if (placement !== initialPlacement) {
	        _this2.setState({
	          placement: placement
	        });
	      }
	    };
	
	    return _this2;
	  }
	
	  _createClass(MenuPortal, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          appendTo = _this$props2.appendTo,
	          children = _this$props2.children,
	          controlElement = _this$props2.controlElement,
	          menuPlacement = _this$props2.menuPlacement,
	          position = _this$props2.menuPosition,
	          getStyles = _this$props2.getStyles;
	      var isFixed = position === 'fixed'; // bail early if required elements aren't present
	
	      if (!appendTo && !isFixed || !controlElement) {
	        return null;
	      }
	
	      var placement = this.state.placement || coercePlacement(menuPlacement);
	      var rect = getBoundingClientObj(controlElement);
	      var scrollDistance = isFixed ? 0 : window.pageYOffset;
	      var offset = rect[placement] + scrollDistance;
	      var state = {
	        offset: offset,
	        position: position,
	        rect: rect
	      }; // same wrapper element whether fixed or portalled
	
	      var menuWrapper = core.jsx("div", {
	        css: getStyles('menuPortal', state)
	      }, children);
	      return core.jsx(PortalPlacementContext.Provider, {
	        value: {
	          getPortalPlacement: this.getPortalPlacement
	        }
	      }, appendTo ? /*#__PURE__*/reactDom.createPortal(menuWrapper, appendTo) : menuWrapper);
	    }
	  }]);
	
	  return MenuPortal;
	}(React.Component);
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
	    var arrA = isArray(a),
	        arrB = isArray(b),
	        i,
	        length,
	        key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	
	      for (i = length; i-- !== 0;) {
	        if (!equal(a[i], b[i])) return false;
	      }
	
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	    var dateA = a instanceof Date,
	        dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	    var regexpA = a instanceof RegExp,
	        regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length) {
	      return false;
	    }
	
	    for (i = length; i-- !== 0;) {
	      if (!hasProp.call(b, keys[i])) return false;
	    } // end fast-deep-equal
	    // Custom handling for React
	
	
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    } // fast-deep-equal index.js 2.0.1
	
	
	    return true;
	  }
	
	  return a !== a && b !== b;
	} // end fast-deep-equal
	
	
	function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (error.message && error.message.match(/stack|recursion/i)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    } // some other error. we should definitely know about these
	
	
	    throw error;
	  }
	}
	
	var containerCSS = function containerCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isRtl = _ref.isRtl;
	  return {
	    label: 'container',
	    direction: isRtl ? 'rtl' : null,
	    pointerEvents: isDisabled ? 'none' : null,
	    // cancel mouse events when disabled
	    position: 'relative'
	  };
	};
	var SelectContainer = function SelectContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isDisabled = props.isDisabled,
	      isRtl = props.isRtl;
	  return core.jsx("div", _extends({
	    css: getStyles('container', props),
	    className: cx({
	      '--is-disabled': isDisabled,
	      '--is-rtl': isRtl
	    }, className)
	  }, innerProps), children);
	}; // ==============================
	// Value Container
	// ==============================
	
	var valueContainerCSS = function valueContainerCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    alignItems: 'center',
	    display: 'flex',
	    flex: 1,
	    flexWrap: 'wrap',
	    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
	    WebkitOverflowScrolling: 'touch',
	    position: 'relative',
	    overflow: 'hidden'
	  };
	};
	var ValueContainer = function ValueContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      isMulti = props.isMulti,
	      getStyles = props.getStyles,
	      hasValue = props.hasValue;
	  return core.jsx("div", {
	    css: getStyles('valueContainer', props),
	    className: cx({
	      'value-container': true,
	      'value-container--is-multi': isMulti,
	      'value-container--has-value': hasValue
	    }, className)
	  }, children);
	}; // ==============================
	// Indicator Container
	// ==============================
	
	var indicatorsContainerCSS = function indicatorsContainerCSS() {
	  return {
	    alignItems: 'center',
	    alignSelf: 'stretch',
	    display: 'flex',
	    flexShrink: 0
	  };
	};
	var IndicatorsContainer = function IndicatorsContainer(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles;
	  return core.jsx("div", {
	    css: getStyles('indicatorsContainer', props),
	    className: cx({
	      indicators: true
	    }, className)
	  }, children);
	};
	
	function _templateObject() {
	  var data = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
	
	var _ref2 =  true ? {
	  name: "19bqh2r",
	  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
	} : {
	  name: "19bqh2r",
	  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
	  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
	};
	
	// ==============================
	// Dropdown & Clear Icons
	// ==============================
	var Svg = function Svg(_ref) {
	  var size = _ref.size,
	      props = _objectWithoutProperties(_ref, ["size"]);
	
	  return core.jsx("svg", _extends({
	    height: size,
	    width: size,
	    viewBox: "0 0 20 20",
	    "aria-hidden": "true",
	    focusable: "false",
	    css: _ref2
	  }, props));
	};
	
	var CrossIcon = function CrossIcon(props) {
	  return core.jsx(Svg, _extends({
	    size: 20
	  }, props), core.jsx("path", {
	    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
	  }));
	};
	var DownChevron = function DownChevron(props) {
	  return core.jsx(Svg, _extends({
	    size: 20
	  }, props), core.jsx("path", {
	    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
	  }));
	}; // ==============================
	// Dropdown & Clear Buttons
	// ==============================
	
	var baseCSS = function baseCSS(_ref3) {
	  var isFocused = _ref3.isFocused,
	      _ref3$theme = _ref3.theme,
	      baseUnit = _ref3$theme.spacing.baseUnit,
	      colors = _ref3$theme.colors;
	  return {
	    label: 'indicatorContainer',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    ':hover': {
	      color: isFocused ? colors.neutral80 : colors.neutral40
	    }
	  };
	};
	
	var dropdownIndicatorCSS = baseCSS;
	var DropdownIndicator = function DropdownIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({}, innerProps, {
	    css: getStyles('dropdownIndicator', props),
	    className: cx({
	      indicator: true,
	      'dropdown-indicator': true
	    }, className)
	  }), children || core.jsx(DownChevron, null));
	};
	var clearIndicatorCSS = baseCSS;
	var ClearIndicator = function ClearIndicator(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({}, innerProps, {
	    css: getStyles('clearIndicator', props),
	    className: cx({
	      indicator: true,
	      'clear-indicator': true
	    }, className)
	  }), children || core.jsx(CrossIcon, null));
	}; // ==============================
	// Separator
	// ==============================
	
	var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
	  var isDisabled = _ref4.isDisabled,
	      _ref4$theme = _ref4.theme,
	      baseUnit = _ref4$theme.spacing.baseUnit,
	      colors = _ref4$theme.colors;
	  return {
	    label: 'indicatorSeparator',
	    alignSelf: 'stretch',
	    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
	    marginBottom: baseUnit * 2,
	    marginTop: baseUnit * 2,
	    width: 1
	  };
	};
	var IndicatorSeparator = function IndicatorSeparator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("span", _extends({}, innerProps, {
	    css: getStyles('indicatorSeparator', props),
	    className: cx({
	      'indicator-separator': true
	    }, className)
	  }));
	}; // ==============================
	// Loading
	// ==============================
	
	var loadingDotAnimations = core.keyframes(_templateObject());
	var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
	  var isFocused = _ref5.isFocused,
	      size = _ref5.size,
	      _ref5$theme = _ref5.theme,
	      colors = _ref5$theme.colors,
	      baseUnit = _ref5$theme.spacing.baseUnit;
	  return {
	    label: 'loadingIndicator',
	    color: isFocused ? colors.neutral60 : colors.neutral20,
	    display: 'flex',
	    padding: baseUnit * 2,
	    transition: 'color 150ms',
	    alignSelf: 'center',
	    fontSize: size,
	    lineHeight: 1,
	    marginRight: size,
	    textAlign: 'center',
	    verticalAlign: 'middle'
	  };
	};
	
	var LoadingDot = function LoadingDot(_ref6) {
	  var delay = _ref6.delay,
	      offset = _ref6.offset;
	  return core.jsx("span", {
	    css: /*#__PURE__*/_css({
	      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
	      backgroundColor: 'currentColor',
	      borderRadius: '1em',
	      display: 'inline-block',
	      marginLeft: offset ? '1em' : null,
	      height: '1em',
	      verticalAlign: 'top',
	      width: '1em'
	    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
	  });
	};
	
	var LoadingIndicator = function LoadingIndicator(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isRtl = props.isRtl;
	  return core.jsx("div", _extends({}, innerProps, {
	    css: getStyles('loadingIndicator', props),
	    className: cx({
	      indicator: true,
	      'loading-indicator': true
	    }, className)
	  }), core.jsx(LoadingDot, {
	    delay: 0,
	    offset: isRtl
	  }), core.jsx(LoadingDot, {
	    delay: 160,
	    offset: true
	  }), core.jsx(LoadingDot, {
	    delay: 320,
	    offset: !isRtl
	  }));
	};
	LoadingIndicator.defaultProps = {
	  size: 4
	};
	
	var css = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      _ref$theme = _ref.theme,
	      colors = _ref$theme.colors,
	      borderRadius = _ref$theme.borderRadius,
	      spacing = _ref$theme.spacing;
	  return {
	    label: 'control',
	    alignItems: 'center',
	    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
	    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
	    borderRadius: borderRadius,
	    borderStyle: 'solid',
	    borderWidth: 1,
	    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
	    cursor: 'default',
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'space-between',
	    minHeight: spacing.controlHeight,
	    outline: '0 !important',
	    position: 'relative',
	    transition: 'all 100ms',
	    '&:hover': {
	      borderColor: isFocused ? colors.primary : colors.neutral30
	    }
	  };
	};
	
	var Control = function Control(props) {
	  var children = props.children,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      className = props.className,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps,
	      menuIsOpen = props.menuIsOpen;
	  return core.jsx("div", _extends({
	    ref: innerRef,
	    css: getStyles('control', props),
	    className: cx({
	      control: true,
	      'control--is-disabled': isDisabled,
	      'control--is-focused': isFocused,
	      'control--menu-is-open': menuIsOpen
	    }, className)
	  }, innerProps), children);
	};
	
	function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var groupCSS = function groupCSS(_ref) {
	  var spacing = _ref.theme.spacing;
	  return {
	    paddingBottom: spacing.baseUnit * 2,
	    paddingTop: spacing.baseUnit * 2
	  };
	};
	
	var Group = function Group(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      Heading = props.Heading,
	      headingProps = props.headingProps,
	      label = props.label,
	      theme = props.theme,
	      selectProps = props.selectProps;
	  return core.jsx("div", {
	    css: getStyles('group', props),
	    className: cx({
	      group: true
	    }, className)
	  }, core.jsx(Heading, _extends({}, headingProps, {
	    selectProps: selectProps,
	    theme: theme,
	    getStyles: getStyles,
	    cx: cx
	  }), label), core.jsx("div", null, children));
	};
	
	var groupHeadingCSS = function groupHeadingCSS(_ref2) {
	  var spacing = _ref2.theme.spacing;
	  return {
	    label: 'group',
	    color: '#999',
	    cursor: 'default',
	    display: 'block',
	    fontSize: '75%',
	    fontWeight: '500',
	    marginBottom: '0.25em',
	    paddingLeft: spacing.baseUnit * 3,
	    paddingRight: spacing.baseUnit * 3,
	    textTransform: 'uppercase'
	  };
	};
	var GroupHeading = function GroupHeading(props) {
	  var className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      theme = props.theme,
	      selectProps = props.selectProps,
	      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);
	
	  return core.jsx("div", _extends({
	    css: getStyles('groupHeading', _objectSpread$1({
	      theme: theme
	    }, cleanProps)),
	    className: cx({
	      'group-heading': true
	    }, className)
	  }, cleanProps));
	};
	
	function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var inputCSS = function inputCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    margin: spacing.baseUnit / 2,
	    paddingBottom: spacing.baseUnit / 2,
	    paddingTop: spacing.baseUnit / 2,
	    visibility: isDisabled ? 'hidden' : 'visible',
	    color: colors.neutral80
	  };
	};
	
	var inputStyle = function inputStyle(isHidden) {
	  return {
	    label: 'input',
	    background: 0,
	    border: 0,
	    fontSize: 'inherit',
	    opacity: isHidden ? 0 : 1,
	    outline: 0,
	    padding: 0,
	    color: 'inherit'
	  };
	};
	
	var Input = function Input(_ref2) {
	  var className = _ref2.className,
	      cx = _ref2.cx,
	      getStyles = _ref2.getStyles,
	      innerRef = _ref2.innerRef,
	      isHidden = _ref2.isHidden,
	      isDisabled = _ref2.isDisabled,
	      theme = _ref2.theme,
	      selectProps = _ref2.selectProps,
	      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);
	
	  return core.jsx("div", {
	    css: getStyles('input', _objectSpread$2({
	      theme: theme
	    }, props))
	  }, core.jsx(AutosizeInput, _extends({
	    className: cx({
	      input: true
	    }, className),
	    inputRef: innerRef,
	    inputStyle: inputStyle(isHidden),
	    disabled: isDisabled
	  }, props)));
	};
	
	function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var multiValueCSS = function multiValueCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      borderRadius = _ref$theme.borderRadius,
	      colors = _ref$theme.colors;
	  return {
	    label: 'multiValue',
	    backgroundColor: colors.neutral10,
	    borderRadius: borderRadius / 2,
	    display: 'flex',
	    margin: spacing.baseUnit / 2,
	    minWidth: 0 // resolves flex/text-overflow bug
	
	  };
	};
	var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
	  var _ref2$theme = _ref2.theme,
	      borderRadius = _ref2$theme.borderRadius,
	      colors = _ref2$theme.colors,
	      cropWithEllipsis = _ref2.cropWithEllipsis;
	  return {
	    borderRadius: borderRadius / 2,
	    color: colors.neutral80,
	    fontSize: '85%',
	    overflow: 'hidden',
	    padding: 3,
	    paddingLeft: 6,
	    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
	    whiteSpace: 'nowrap'
	  };
	};
	var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
	  var _ref3$theme = _ref3.theme,
	      spacing = _ref3$theme.spacing,
	      borderRadius = _ref3$theme.borderRadius,
	      colors = _ref3$theme.colors,
	      isFocused = _ref3.isFocused;
	  return {
	    alignItems: 'center',
	    borderRadius: borderRadius / 2,
	    backgroundColor: isFocused && colors.dangerLight,
	    display: 'flex',
	    paddingLeft: spacing.baseUnit,
	    paddingRight: spacing.baseUnit,
	    ':hover': {
	      backgroundColor: colors.dangerLight,
	      color: colors.danger
	    }
	  };
	};
	var MultiValueGeneric = function MultiValueGeneric(_ref4) {
	  var children = _ref4.children,
	      innerProps = _ref4.innerProps;
	  return core.jsx("div", innerProps, children);
	};
	var MultiValueContainer = MultiValueGeneric;
	var MultiValueLabel = MultiValueGeneric;
	function MultiValueRemove(_ref5) {
	  var children = _ref5.children,
	      innerProps = _ref5.innerProps;
	  return core.jsx("div", innerProps, children || core.jsx(CrossIcon, {
	    size: 14
	  }));
	}
	
	var MultiValue = function MultiValue(props) {
	  var children = props.children,
	      className = props.className,
	      components = props.components,
	      cx = props.cx,
	      data = props.data,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps,
	      isDisabled = props.isDisabled,
	      removeProps = props.removeProps,
	      selectProps = props.selectProps;
	  var Container = components.Container,
	      Label = components.Label,
	      Remove = components.Remove;
	  return core.jsx(core.ClassNames, null, function (_ref6) {
	    var css = _ref6.css,
	        emotionCx = _ref6.cx;
	    return core.jsx(Container, {
	      data: data,
	      innerProps: _objectSpread$3(_objectSpread$3({}, innerProps), {}, {
	        className: emotionCx(css(getStyles('multiValue', props)), cx({
	          'multi-value': true,
	          'multi-value--is-disabled': isDisabled
	        }, className))
	      }),
	      selectProps: selectProps
	    }, core.jsx(Label, {
	      data: data,
	      innerProps: {
	        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
	          'multi-value__label': true
	        }, className))
	      },
	      selectProps: selectProps
	    }, children), core.jsx(Remove, {
	      data: data,
	      innerProps: _objectSpread$3({
	        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
	          'multi-value__remove': true
	        }, className))
	      }, removeProps),
	      selectProps: selectProps
	    }));
	  });
	};
	
	MultiValue.defaultProps = {
	  cropWithEllipsis: true
	};
	
	var optionCSS = function optionCSS(_ref) {
	  var isDisabled = _ref.isDisabled,
	      isFocused = _ref.isFocused,
	      isSelected = _ref.isSelected,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'option',
	    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
	    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
	    cursor: 'default',
	    display: 'block',
	    fontSize: 'inherit',
	    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
	    width: '100%',
	    userSelect: 'none',
	    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	    // provide some affordance on touch devices
	    ':active': {
	      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
	    }
	  };
	};
	
	var Option = function Option(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      isFocused = props.isFocused,
	      isSelected = props.isSelected,
	      innerRef = props.innerRef,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('option', props),
	    className: cx({
	      option: true,
	      'option--is-disabled': isDisabled,
	      'option--is-focused': isFocused,
	      'option--is-selected': isSelected
	    }, className),
	    ref: innerRef
	  }, innerProps), children);
	};
	
	var placeholderCSS = function placeholderCSS(_ref) {
	  var _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'placeholder',
	    color: colors.neutral50,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    position: 'absolute',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	var Placeholder = function Placeholder(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('placeholder', props),
	    className: cx({
	      placeholder: true
	    }, className)
	  }, innerProps), children);
	};
	
	var css$1 = function css(_ref) {
	  var isDisabled = _ref.isDisabled,
	      _ref$theme = _ref.theme,
	      spacing = _ref$theme.spacing,
	      colors = _ref$theme.colors;
	  return {
	    label: 'singleValue',
	    color: isDisabled ? colors.neutral40 : colors.neutral80,
	    marginLeft: spacing.baseUnit / 2,
	    marginRight: spacing.baseUnit / 2,
	    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
	    overflow: 'hidden',
	    position: 'absolute',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap',
	    top: '50%',
	    transform: 'translateY(-50%)'
	  };
	};
	
	var SingleValue = function SingleValue(props) {
	  var children = props.children,
	      className = props.className,
	      cx = props.cx,
	      getStyles = props.getStyles,
	      isDisabled = props.isDisabled,
	      innerProps = props.innerProps;
	  return core.jsx("div", _extends({
	    css: getStyles('singleValue', props),
	    className: cx({
	      'single-value': true,
	      'single-value--is-disabled': isDisabled
	    }, className)
	  }, innerProps), children);
	};
	
	function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var components = {
	  ClearIndicator: ClearIndicator,
	  Control: Control,
	  DropdownIndicator: DropdownIndicator,
	  DownChevron: DownChevron,
	  CrossIcon: CrossIcon,
	  Group: Group,
	  GroupHeading: GroupHeading,
	  IndicatorsContainer: IndicatorsContainer,
	  IndicatorSeparator: IndicatorSeparator,
	  Input: Input,
	  LoadingIndicator: LoadingIndicator,
	  Menu: Menu,
	  MenuList: MenuList,
	  MenuPortal: MenuPortal,
	  LoadingMessage: LoadingMessage,
	  NoOptionsMessage: NoOptionsMessage,
	  MultiValue: MultiValue,
	  MultiValueContainer: MultiValueContainer,
	  MultiValueLabel: MultiValueLabel,
	  MultiValueRemove: MultiValueRemove,
	  Option: Option,
	  Placeholder: Placeholder,
	  SelectContainer: SelectContainer,
	  SingleValue: SingleValue,
	  ValueContainer: ValueContainer
	};
	var defaultComponents = function defaultComponents(props) {
	  return _objectSpread$4(_objectSpread$4({}, components), props.components);
	};
	
	exports.MenuPlacer = MenuPlacer;
	exports.classNames = classNames;
	exports.cleanValue = cleanValue;
	exports.clearIndicatorCSS = clearIndicatorCSS;
	exports.components = components;
	exports.containerCSS = containerCSS;
	exports.css = css;
	exports.css$1 = css$1;
	exports.defaultComponents = defaultComponents;
	exports.dropdownIndicatorCSS = dropdownIndicatorCSS;
	exports.exportedEqual = exportedEqual;
	exports.groupCSS = groupCSS;
	exports.groupHeadingCSS = groupHeadingCSS;
	exports.handleInputChange = handleInputChange;
	exports.indicatorSeparatorCSS = indicatorSeparatorCSS;
	exports.indicatorsContainerCSS = indicatorsContainerCSS;
	exports.inputCSS = inputCSS;
	exports.isDocumentElement = isDocumentElement;
	exports.isMobileDevice = isMobileDevice;
	exports.isTouchCapable = isTouchCapable;
	exports.loadingIndicatorCSS = loadingIndicatorCSS;
	exports.loadingMessageCSS = loadingMessageCSS;
	exports.menuCSS = menuCSS;
	exports.menuListCSS = menuListCSS;
	exports.menuPortalCSS = menuPortalCSS;
	exports.multiValueCSS = multiValueCSS;
	exports.multiValueLabelCSS = multiValueLabelCSS;
	exports.multiValueRemoveCSS = multiValueRemoveCSS;
	exports.noOptionsMessageCSS = noOptionsMessageCSS;
	exports.noop = noop;
	exports.optionCSS = optionCSS;
	exports.placeholderCSS = placeholderCSS;
	exports.scrollIntoView = scrollIntoView;
	exports.valueContainerCSS = valueContainerCSS;


/***/ }),
/* 2818 */
/***/ (function(module, exports) {

	function _arrayLikeToArray(r, a) {
	  (null == a || a > r.length) && (a = r.length);
	  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	  return n;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(6284);
	var iterableToArrayLimit = __webpack_require__(6287);
	var unsupportedIterableToArray = __webpack_require__(2823);
	var nonIterableRest = __webpack_require__(6288);
	function _slicedToArray(r, e) {
	  return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
	}
	module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2820 */
/***/ (function(module, exports) {

	function _taggedTemplateLiteral(e, t) {
	  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
	    raw: {
	      value: Object.freeze(t)
	    }
	  }));
	}
	module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(6285);
	var iterableToArray = __webpack_require__(6286);
	var unsupportedIterableToArray = __webpack_require__(2823);
	var nonIterableSpread = __webpack_require__(6289);
	function _toConsumableArray(r) {
	  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
	}
	module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(749)["default"];
	var toPrimitive = __webpack_require__(6292);
	function toPropertyKey(t) {
	  var i = toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : i + "";
	}
	module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(2818);
	function _unsupportedIterableToArray(r, a) {
	  if (r) {
	    if ("string" == typeof r) return arrayLikeToArray(r, a);
	    var t = {}.toString.call(r).slice(8, -1);
	    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
	  }
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2824 */
6258,
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(598);
	var Stylis = _interopDefault(__webpack_require__(1055));
	__webpack_require__(1057);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses && cache.compat !== true) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ }),
/* 2826 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getScrollBarWidth = getScrollBarWidth;
	exports.calcOffset = calcOffset;
	
	function getScrollBarWidth() {
	  var scrollDiv = document.createElement('div');
	  scrollDiv.className = 'react-timekeeper-scrollbar-measure';
	  document.body.appendChild(scrollDiv);
	  var width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return width;
	}
	
	function calcOffset(el) {
	  var style = window.getComputedStyle(el, null);
	  return function (clientX, clientY) {
	    var borderLeftWidth = parseInt(style.borderLeftWidth, 10) || 0;
	    var borderTopWidth = parseInt(style.borderTopWidth, 10) || 0;
	    var rect = el.getBoundingClientRect();
	    return {
	      offsetX: clientX - borderLeftWidth - rect.left,
	      offsetY: clientY - borderTopWidth - rect.top
	    };
	  };
	}

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(6321);
	} else {
	  module.exports = require("./cjs/react-toastify.js");
	}

/***/ }),
/* 2828 */
[6838, 591, 1644, 6332],
/* 2829 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 2830 */
[6834, 591],
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = exports.buttonFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(8);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	var _FontIcon = __webpack_require__(592);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Ripple = __webpack_require__(1046);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, FontIcon) {
	  var Button = function (_Component) {
	    _inherits(Button, _Component);
	
	    function Button() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Button);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
	        if (_this.props.primary) return 'primary';
	        if (_this.props.accent) return 'accent';
	        return 'neutral';
	      }, _this.getShape = function () {
	        if (_this.props.raised) return 'raised';
	        if (_this.props.floating) return 'floating';
	        return 'flat';
	      }, _this.handleMouseUp = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
	      }, _this.handleMouseLeave = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Button, [{
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this2 = this;
	
	        var _props = this.props,
	            accent = _props.accent,
	            children = _props.children,
	            className = _props.className,
	            flat = _props.flat,
	            floating = _props.floating,
	            href = _props.href,
	            icon = _props.icon,
	            inverse = _props.inverse,
	            label = _props.label,
	            mini = _props.mini,
	            neutral = _props.neutral,
	            primary = _props.primary,
	            raised = _props.raised,
	            theme = _props.theme,
	            type = _props.type,
	            others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'flat', 'floating', 'href', 'icon', 'inverse', 'label', 'mini', 'neutral', 'primary', 'raised', 'theme', 'type']);
	
	        var element = href ? 'a' : 'button';
	        var level = this.getLevel();
	        var shape = this.getShape();
	        var mouseEvents = {
	          onMouseUp: this.handleMouseUp,
	          onMouseLeave: this.handleMouseLeave
	        };
	
	        var classes = (0, _classnames3.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.mini, mini), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);
	
	        var props = _extends({}, others, mouseEvents, {
	          href: href,
	          ref: function ref(node) {
	            _this2.buttonNode = node;
	          },
	          className: classes,
	          disabled: this.props.disabled,
	          type: !href ? type : null,
	          'data-react-toolbox': 'button'
	        });
	
	        var buttonElement = _react2.default.createElement(element, props, icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, label, children);
	
	        return others.onMouseEnter && this.props.disabled ? _react2.default.createElement(
	          'span',
	          mouseEvents,
	          buttonElement
	        ) : buttonElement;
	      }
	    }]);
	
	    return Button;
	  }(_react.Component);
	
	  Button.propTypes = {
	    accent: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    flat: _propTypes2.default.bool,
	    floating: _propTypes2.default.bool,
	    href: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inverse: _propTypes2.default.bool,
	    label: _propTypes2.default.string,
	    mini: _propTypes2.default.bool,
	    neutral: _propTypes2.default.bool,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    primary: _propTypes2.default.bool,
	    raised: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      accent: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      flat: _propTypes2.default.string,
	      floating: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      inverse: _propTypes2.default.string,
	      mini: _propTypes2.default.string,
	      neutral: _propTypes2.default.string,
	      primary: _propTypes2.default.string,
	      raised: _propTypes2.default.string,
	      rippleWrapper: _propTypes2.default.string,
	      toggle: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string
	  };
	  Button.defaultProps = {
	    accent: false,
	    className: '',
	    flat: false,
	    floating: false,
	    mini: false,
	    neutral: true,
	    primary: false,
	    raised: false,
	    type: 'button'
	  };
	
	
	  return ripple(Button);
	};
	
	var Button = factory((0, _Ripple2.default)({ centered: false }), _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(Button);
	exports.buttonFactory = factory;
	exports.Button = Button;

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IconButton = exports.iconButtonFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(8);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	var _FontIcon = __webpack_require__(592);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Ripple = __webpack_require__(1046);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, FontIcon) {
	  var IconButton = function (_Component) {
	    _inherits(IconButton, _Component);
	
	    function IconButton() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, IconButton);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
	        if (_this.props.primary) return 'primary';
	        if (_this.props.accent) return 'accent';
	        return 'neutral';
	      }, _this.handleMouseUp = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
	      }, _this.handleMouseLeave = function (event) {
	        _this.buttonNode.blur();
	        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(IconButton, [{
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this2 = this;
	
	        var _props = this.props,
	            accent = _props.accent,
	            children = _props.children,
	            className = _props.className,
	            href = _props.href,
	            icon = _props.icon,
	            inverse = _props.inverse,
	            neutral = _props.neutral,
	            primary = _props.primary,
	            theme = _props.theme,
	            type = _props.type,
	            others = _objectWithoutProperties(_props, ['accent', 'children', 'className', 'href', 'icon', 'inverse', 'neutral', 'primary', 'theme', 'type']);
	
	        var element = href ? 'a' : 'button';
	        var level = this.getLevel();
	        var classes = (0, _classnames3.default)([theme.toggle], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);
	
	        var props = _extends({}, others, {
	          href: href,
	          ref: function ref(node) {
	            _this2.buttonNode = node;
	          },
	          className: classes,
	          disabled: this.props.disabled,
	          onMouseUp: this.handleMouseUp,
	          onMouseLeave: this.handleMouseLeave,
	          type: !href ? type : null,
	          'data-react-toolbox': 'button'
	        });
	
	        var iconElement = typeof icon === 'string' ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : icon;
	
	        return _react2.default.createElement(element, props, icon && iconElement, children);
	      }
	    }]);
	
	    return IconButton;
	  }(_react.Component);
	
	  IconButton.propTypes = {
	    accent: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    href: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inverse: _propTypes2.default.bool,
	    neutral: _propTypes2.default.bool,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    primary: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      accent: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      flat: _propTypes2.default.string,
	      floating: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      inverse: _propTypes2.default.string,
	      mini: _propTypes2.default.string,
	      neutral: _propTypes2.default.string,
	      primary: _propTypes2.default.string,
	      raised: _propTypes2.default.string,
	      rippleWrapper: _propTypes2.default.string,
	      toggle: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string
	  };
	  IconButton.defaultProps = {
	    accent: false,
	    className: '',
	    neutral: true,
	    primary: false,
	    type: 'button'
	  };
	
	
	  return ripple(IconButton);
	};
	
	var IconButton = factory((0, _Ripple2.default)({ centered: true }), _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(IconButton);
	exports.iconButtonFactory = factory;
	exports.IconButton = IconButton;

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BrowseButton = exports.IconButton = exports.Button = undefined;
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	var _Button = __webpack_require__(2831);
	
	var _BrowseButton = __webpack_require__(6333);
	
	var _IconButton = __webpack_require__(2832);
	
	var _FontIcon = __webpack_require__(592);
	
	var _ripple = __webpack_require__(6342);
	
	var _ripple2 = _interopRequireDefault(_ripple);
	
	var _theme = __webpack_require__(5253);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = (0, _Button.buttonFactory)((0, _ripple2.default)({ centered: false }), _FontIcon.FontIcon);
	var IconButton = (0, _IconButton.iconButtonFactory)((0, _ripple2.default)({ centered: true }), _FontIcon.FontIcon);
	var BrowseButton = (0, _BrowseButton.browseButtonFactory)((0, _ripple2.default)({ centered: false }), _FontIcon.FontIcon);
	var ThemedButton = (0, _reactCssThemr.themr)(_identifiers.BUTTON, _theme2.default)(Button);
	var ThemedIconButton = (0, _reactCssThemr.themr)(_identifiers.BUTTON, _theme2.default)(IconButton);
	var ThemedBrowseButton = (0, _reactCssThemr.themr)(_identifiers.BUTTON, _theme2.default)(BrowseButton);
	
	exports.default = ThemedButton;
	exports.Button = ThemedButton;
	exports.IconButton = ThemedIconButton;
	exports.BrowseButton = ThemedBrowseButton;

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(6361);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransition = __webpack_require__(6359);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _utils = __webpack_require__(1645);
	
	var _time = __webpack_require__(750);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _CalendarMonth = __webpack_require__(6335);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DIRECTION_STEPS = { left: -1, right: 1 };
	
	var factory = function factory(IconButton) {
	  var Calendar = function (_Component) {
	    _inherits(Calendar, _Component);
	
	    function Calendar() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Calendar);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        viewDate: _this.props.selectedDate
	      }, _this.handleDayClick = function (day) {
	        _this.props.onChange(_time2.default.setDay(_this.state.viewDate, day), true);
	      }, _this.handleYearClick = function (event) {
	        var year = parseInt(event.currentTarget.id, 10);
	        var viewDate = _time2.default.setYear(_this.props.selectedDate, year);
	        _this.setState({ viewDate: viewDate });
	        _this.props.onChange(viewDate, false);
	      }, _this.handleKeys = function (e) {
	        var selectedDate = _this.props.selectedDate;
	
	
	        if (e.which === 37 || e.which === 38 || e.which === 39 || e.which === 40 || e.which === 13) {
	          e.preventDefault();
	        }
	
	        switch (e.which) {
	          case 13:
	            _this.props.handleSelect();break; // enter
	          case 37:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, -1));break; // left
	          case 38:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, -7));break; // up
	          case 39:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, 1));break; // right
	          case 40:
	            _this.handleDayArrowKey(_time2.default.addDays(selectedDate, 7));break; // down
	          default:
	            break;
	        }
	      }, _this.handleDayArrowKey = function (date) {
	        _this.setState({ viewDate: date });
	        _this.props.onChange(date, false);
	      }, _this.changeViewMonth = function (event) {
	        var direction = event.currentTarget.id;
	        _this.setState({
	          direction: direction,
	          viewDate: _time2.default.addMonths(_this.state.viewDate, DIRECTION_STEPS[direction])
	        });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Calendar, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        document.body.addEventListener('keydown', this.handleKeys);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        if (this.activeYearNode) {
	          this.scrollToActive();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        document.body.removeEventListener('keydown', this.handleKeys);
	      }
	    }, {
	      key: 'scrollToActive',
	      value: function scrollToActive() {
	        var offset = this.yearsNode.offsetHeight / 2 + this.activeYearNode.offsetHeight / 2;
	        this.yearsNode.scrollTop = this.activeYearNode.offsetTop - offset;
	      }
	    }, {
	      key: 'renderYears',
	      value: function renderYears() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          'ul',
	          {
	            'data-react-toolbox': 'years',
	            className: this.props.theme.years,
	            ref: function ref(node) {
	              _this2.yearsNode = node;
	            }
	          },
	          (0, _utils.range)(1900, 2100).map(function (year) {
	            return _react2.default.createElement(
	              'li',
	              {
	                className: year === _this2.state.viewDate.getFullYear() ? _this2.props.theme.active : '',
	                id: year,
	                key: year,
	                onClick: _this2.handleYearClick,
	                ref: function ref(node) {
	                  if (year === _this2.state.viewDate.getFullYear()) {
	                    _this2.activeYearNode = node;
	                  }
	                }
	              },
	              year
	            );
	          })
	        );
	      }
	    }, {
	      key: 'renderMonths',
	      value: function renderMonths() {
	        var theme = this.props.theme;
	
	        var animation = this.state.direction === 'left' ? 'slideLeft' : 'slideRight';
	        var animationModule = (0, _utils.getAnimationModule)(animation, theme);
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'calendar' },
	          _react2.default.createElement(IconButton, { id: 'left', className: theme.prev, icon: 'chevron_left', onClick: this.changeViewMonth }),
	          _react2.default.createElement(IconButton, { id: 'right', className: theme.next, icon: 'chevron_right', onClick: this.changeViewMonth }),
	          _react2.default.createElement(
	            _TransitionGroup2.default,
	            null,
	            _react2.default.createElement(
	              _CSSTransition2.default,
	              { classNames: animationModule, timeout: 350 },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                enabledDates: this.props.enabledDates,
	                disabledDates: this.props.disabledDates,
	                key: this.state.viewDate.getMonth(),
	                locale: this.props.locale,
	                maxDate: this.props.maxDate,
	                minDate: this.props.minDate,
	                onDayClick: this.handleDayClick,
	                selectedDate: this.props.selectedDate,
	                sundayFirstDayOfWeek: this.props.sundayFirstDayOfWeek,
	                theme: this.props.theme,
	                viewDate: this.state.viewDate
	              })
	            )
	          )
	        );
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(
	          'div',
	          { className: this.props.theme.calendar },
	          this.props.display === 'months' ? this.renderMonths() : this.renderYears()
	        );
	      }
	    }]);
	
	    return Calendar;
	  }(_react.Component);
	
	  Calendar.propTypes = {
	    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    display: _propTypes2.default.oneOf(['months', 'years']),
	    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    handleSelect: _propTypes2.default.func,
	    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    maxDate: _propTypes2.default.instanceOf(Date),
	    minDate: _propTypes2.default.instanceOf(Date),
	    onChange: _propTypes2.default.func,
	    selectedDate: _propTypes2.default.instanceOf(Date),
	    sundayFirstDayOfWeek: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      calendar: _propTypes2.default.string,
	      next: _propTypes2.default.string,
	      prev: _propTypes2.default.string,
	      years: _propTypes2.default.string
	    })
	  };
	  Calendar.defaultProps = {
	    display: 'months',
	    selectedDate: new Date()
	  };
	
	
	  return Calendar;
	};
	
	exports.default = factory;

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _time = __webpack_require__(750);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Dialog, Calendar) {
	  var CalendarDialog = function (_Component) {
	    _inherits(CalendarDialog, _Component);
	
	    function CalendarDialog() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, CalendarDialog);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CalendarDialog.__proto__ || Object.getPrototypeOf(CalendarDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        display: 'months',
	        date: _this.props.value
	      }, _this.handleNewDate = function (value, dayClick) {
	        var state = { display: 'months', date: value };
	        if (_time2.default.dateOutOfRange(value, _this.props.minDate, _this.props.maxDate)) {
	          if (_this.props.maxDate && _this.props.minDate) {
	            state.date = _time2.default.closestDate(value, _this.props.maxDate, _this.props.minDate);
	          } else {
	            state.date = _this.props.maxDate || _this.props.minDate;
	          }
	        }
	        _this.setState(state);
	        if (dayClick && _this.props.autoOk && _this.props.onSelect) {
	          _this.props.onSelect(value);
	        }
	      }, _this.handleSelect = function (event) {
	        if (_this.props.onSelect) _this.props.onSelect(_this.state.date, event);
	      }, _this.handleSwitchDisplay = function (event) {
	        _this.setState({ display: event.target.id });
	      }, _this.updateStateDate = function (date) {
	        if (Object.prototype.toString.call(date) === '[object Date]') {
	          _this.handleNewDate(date, false);
	        }
	      }, _this.actions = [{
	        label: _this.props.cancelLabel,
	        className: _this.props.theme.button,
	        onClick: _this.props.onDismiss
	      }, {
	        label: _this.props.okLabel,
	        className: _this.props.theme.button,
	        name: _this.props.name,
	        onClick: _this.handleSelect
	      }], _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(CalendarDialog, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.updateStateDate(this.props.value);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this.updateStateDate(nextProps.value);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var theme = this.props.theme;
	
	        var display = this.state.display + 'Display';
	        var className = (0, _classnames2.default)(theme.dialog, this.props.className);
	        var headerClassName = (0, _classnames2.default)(theme.header, theme[display]);
	        var shortDayOfWeek = _time2.default.getShortDayOfWeek(this.state.date.getDay(), this.props.locale);
	        var shortMonth = _time2.default.getShortMonth(this.state.date, this.props.locale);
	        var date = this.state.date.getDate();
	
	        return _react2.default.createElement(
	          Dialog,
	          {
	            actions: this.actions,
	            active: this.props.active,
	            className: className,
	            onEscKeyDown: this.props.onEscKeyDown,
	            onOverlayClick: this.props.onOverlayClick,
	            type: 'custom'
	          },
	          _react2.default.createElement(
	            'header',
	            { className: headerClassName },
	            _react2.default.createElement(
	              'span',
	              { id: 'years', className: theme.year, onClick: this.handleSwitchDisplay },
	              this.state.date.getFullYear()
	            ),
	            _react2.default.createElement(
	              'h3',
	              { id: 'months', className: theme.date, onClick: this.handleSwitchDisplay },
	              shortDayOfWeek,
	              ', ',
	              shortMonth,
	              ' ',
	              date
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: theme.calendarWrapper },
	            _react2.default.createElement(Calendar, {
	              disabledDates: this.props.disabledDates,
	              display: this.state.display,
	              enabledDates: this.props.enabledDates,
	              handleSelect: this.handleSelect,
	              maxDate: this.props.maxDate,
	              minDate: this.props.minDate,
	              onChange: this.handleNewDate,
	              selectedDate: this.state.date,
	              theme: this.props.theme,
	              locale: this.props.locale,
	              sundayFirstDayOfWeek: this.props.sundayFirstDayOfWeek
	            })
	          )
	        );
	      }
	    }]);
	
	    return CalendarDialog;
	  }(_react.Component);
	
	  CalendarDialog.propTypes = {
	    active: _propTypes2.default.bool,
	    autoOk: _propTypes2.default.bool,
	    cancelLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    maxDate: _propTypes2.default.instanceOf(Date),
	    minDate: _propTypes2.default.instanceOf(Date),
	    name: _propTypes2.default.string,
	    okLabel: _propTypes2.default.string,
	    onDismiss: _propTypes2.default.func,
	    onEscKeyDown: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func,
	    sundayFirstDayOfWeek: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      button: _propTypes2.default.string,
	      calendarWrapper: _propTypes2.default.string,
	      date: _propTypes2.default.string,
	      dialog: _propTypes2.default.string,
	      header: _propTypes2.default.string,
	      monthsDisplay: _propTypes2.default.string,
	      year: _propTypes2.default.string,
	      yearsDisplay: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.instanceOf(Date)
	  };
	  CalendarDialog.defaultProps = {
	    active: false,
	    cancelLabel: 'Cancel',
	    className: '',
	    okLabel: 'Ok',
	    value: new Date()
	  };
	
	
	  return CalendarDialog;
	};
	
	exports.default = factory;

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DatePickerDialog = exports.DatePicker = undefined;
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	var _DatePicker = __webpack_require__(6336);
	
	var _DatePickerDialog = __webpack_require__(2835);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _Calendar = __webpack_require__(2834);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _button = __webpack_require__(2833);
	
	var _input = __webpack_require__(6340);
	
	var _dialog = __webpack_require__(6337);
	
	var _theme = __webpack_require__(5254);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Calendar = (0, _Calendar2.default)(_button.IconButton);
	var DatePickerDialog = (0, _DatePickerDialog2.default)(_dialog.Dialog, Calendar);
	var DatePicker = (0, _DatePicker.datePickerFactory)(_input.Input, DatePickerDialog);
	
	var ThemedDatePicker = (0, _reactCssThemr.themr)(_identifiers.DATE_PICKER, _theme2.default)(DatePicker);
	exports.default = ThemedDatePicker;
	exports.DatePicker = ThemedDatePicker;
	
	
	var ThemedDatePickerDialog = (0, _reactCssThemr.themr)(_identifiers.DIALOG, _theme2.default)(DatePickerDialog);
	exports.DatePickerDialog = ThemedDatePickerDialog;

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dialogFactory = exports.Dialog = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _classnames3 = __webpack_require__(8);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _identifiers = __webpack_require__(212);
	
	var _Portal = __webpack_require__(6339);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ActivableRenderer = __webpack_require__(6338);
	
	var _ActivableRenderer2 = _interopRequireDefault(_ActivableRenderer);
	
	var _Button = __webpack_require__(2831);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Overlay = __webpack_require__(2839);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable jsx-a11y/aria-role */
	
	
	var factory = function factory(Overlay, Button) {
	  var Dialog = function Dialog(props) {
	    var actions = props.actions.map(function (action, idx) {
	      var className = (0, _classnames4.default)(props.theme.button, _defineProperty({}, action.className, action.className));
	      return _react2.default.createElement(Button, _extends({ key: idx }, action, { className: className })); // eslint-disable-line
	    });
	
	    var className = (0, _classnames4.default)([props.theme.dialog, props.theme[props.type]], _defineProperty({}, props.theme.active, props.active), props.className);
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { className: props.theme.wrapper },
	      _react2.default.createElement(Overlay, {
	        active: props.active,
	        className: props.theme.overlay,
	        onClick: props.onOverlayClick,
	        onEscKeyDown: props.onEscKeyDown,
	        onMouseDown: props.onOverlayMouseDown,
	        onMouseMove: props.onOverlayMouseMove,
	        onMouseUp: props.onOverlayMouseUp,
	        theme: props.theme,
	        themeNamespace: 'overlay'
	      }),
	      _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'dialog', className: className },
	        _react2.default.createElement(
	          'section',
	          { role: 'body', className: props.theme.body },
	          props.title ? _react2.default.createElement(
	            'h6',
	            { className: props.theme.title },
	            props.title
	          ) : null,
	          props.children
	        ),
	        actions.length ? _react2.default.createElement(
	          'nav',
	          { className: props.theme.navigation },
	          actions
	        ) : null
	      )
	    );
	  };
	
	  Dialog.propTypes = {
	    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      className: _propTypes2.default.string,
	      label: _propTypes2.default.string,
	      children: _propTypes2.default.node
	    })),
	    active: _propTypes2.default.bool,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    onEscKeyDown: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    onOverlayMouseDown: _propTypes2.default.func,
	    onOverlayMouseMove: _propTypes2.default.func,
	    onOverlayMouseUp: _propTypes2.default.func,
	    theme: _propTypes2.default.shape({
	      active: _propTypes2.default.string,
	      body: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      dialog: _propTypes2.default.string,
	      navigation: _propTypes2.default.string,
	      overflow: _propTypes2.default.string,
	      overlay: _propTypes2.default.string,
	      title: _propTypes2.default.string,
	      wrapper: _propTypes2.default.string
	    }),
	    title: _propTypes2.default.string,
	    type: _propTypes2.default.string
	  };
	
	  Dialog.defaultProps = {
	    actions: [],
	    active: false,
	    type: 'normal'
	  };
	
	  return (0, _ActivableRenderer2.default)()(Dialog);
	};
	
	var Dialog = factory(_Overlay2.default, _Button2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.DIALOG)(Dialog);
	exports.Dialog = Dialog;
	exports.dialogFactory = factory;

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Input = exports.inputFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames4 = __webpack_require__(8);
	
	var _classnames5 = _interopRequireDefault(_classnames4);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _utils = __webpack_require__(1645);
	
	var _identifiers = __webpack_require__(212);
	
	var _FontIcon = __webpack_require__(592);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(FontIcon) {
	  var Input = function (_React$Component) {
	    _inherits(Input, _React$Component);
	
	    function Input() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Input);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            onChange = _this$props.onChange,
	            multiline = _this$props.multiline,
	            maxLength = _this$props.maxLength;
	
	        var valueFromEvent = event.target.value;
	
	        // Trim value to maxLength if that exists (only on multiline inputs).
	        // Note that this is still required even tho we have the onKeyPress filter
	        // because the user could paste smt in the textarea.
	        var haveToTrim = multiline && maxLength && event.target.value.length > maxLength;
	        var value = haveToTrim ? valueFromEvent.substr(0, maxLength) : valueFromEvent;
	
	        // propagate to to store and therefore to the input
	        if (onChange) onChange(value, event);
	      }, _this.handleAutoresize = function () {
	        var element = _this.inputNode;
	        var rows = _this.props.rows;
	
	        if (typeof rows === 'number' && !isNaN(rows)) {
	          element.style.height = null;
	        } else {
	          // compute the height difference between inner height and outer height
	          var style = getComputedStyle(element, null);
	          var heightOffset = style.boxSizing === 'content-box' ? -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)) : parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
	
	          // resize the input to its content size
	          element.style.height = 'auto';
	          element.style.height = element.scrollHeight + heightOffset + 'px';
	        }
	      }, _this.handleKeyPress = function (event) {
	        // prevent insertion of more characters if we're a multiline input
	        // and maxLength exists
	        var _this$props2 = _this.props,
	            multiline = _this$props2.multiline,
	            maxLength = _this$props2.maxLength,
	            onKeyPress = _this$props2.onKeyPress;
	
	        if (multiline && maxLength) {
	          // check if smt is selected, in which case the newly added charcter would
	          // replace the selected characters, so the length of value doesn't actually
	          // increase.
	          var isReplacing = event.target.selectionEnd - event.target.selectionStart;
	          var value = event.target.value;
	
	          if (!isReplacing && value.length === maxLength) {
	            event.preventDefault();
	            event.stopPropagation();
	            return undefined;
	          }
	        }
	
	        if (onKeyPress) onKeyPress(event);
	        return undefined;
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Input, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.multiline) {
	          window.addEventListener('resize', this.handleAutoresize);
	          this.handleAutoresize();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!this.props.multiline && nextProps.multiline) {
	          window.addEventListener('resize', this.handleAutoresize);
	        } else if (this.props.multiline && !nextProps.multiline) {
	          window.removeEventListener('resize', this.handleAutoresize);
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        // resize the textarea, if nessesary
	        if (this.props.multiline) this.handleAutoresize();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.props.multiline) window.removeEventListener('resize', this.handleAutoresize);
	      }
	    }, {
	      key: 'blur',
	      value: function blur() {
	        this.inputNode.blur();
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        this.inputNode.focus();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classnames2,
	            _this2 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            defaultValue = _props.defaultValue,
	            disabled = _props.disabled,
	            error = _props.error,
	            floating = _props.floating,
	            hint = _props.hint,
	            icon = _props.icon,
	            name = _props.name,
	            labelText = _props.label,
	            maxLength = _props.maxLength,
	            multiline = _props.multiline,
	            required = _props.required,
	            role = _props.role,
	            theme = _props.theme,
	            type = _props.type,
	            value = _props.value,
	            onKeyPress = _props.onKeyPress,
	            _props$rows = _props.rows,
	            rows = _props$rows === undefined ? 1 : _props$rows,
	            others = _objectWithoutProperties(_props, ['children', 'defaultValue', 'disabled', 'error', 'floating', 'hint', 'icon', 'name', 'label', 'maxLength', 'multiline', 'required', 'role', 'theme', 'type', 'value', 'onKeyPress', 'rows']);
	
	        var length = maxLength && value ? value.length : 0;
	        var labelClassName = (0, _classnames5.default)(theme.label, _defineProperty({}, theme.fixed, !floating));
	
	        var className = (0, _classnames5.default)(theme.input, (_classnames2 = {}, _defineProperty(_classnames2, theme.disabled, disabled), _defineProperty(_classnames2, theme.errored, error), _defineProperty(_classnames2, theme.hidden, type === 'hidden'), _defineProperty(_classnames2, theme.withIcon, icon), _classnames2), this.props.className);
	
	        var valuePresent = (0, _utils.isValuePresent)(value) || (0, _utils.isValuePresent)(defaultValue);
	
	        var inputElementProps = _extends({}, others, {
	          className: (0, _classnames5.default)(theme.inputElement, _defineProperty({}, theme.filled, valuePresent)),
	          onChange: this.handleChange,
	          ref: function ref(node) {
	            _this2.inputNode = node;
	          },
	          role: role,
	          name: name,
	          defaultValue: defaultValue,
	          disabled: disabled,
	          required: required,
	          type: type,
	          value: value
	        });
	        if (!multiline) {
	          inputElementProps.maxLength = maxLength;
	          inputElementProps.onKeyPress = onKeyPress;
	        } else {
	          inputElementProps.rows = rows;
	          inputElementProps.onKeyPress = this.handleKeyPress;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'input', className: className },
	          _react2.default.createElement(multiline ? 'textarea' : 'input', inputElementProps),
	          icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null,
	          _react2.default.createElement('span', { className: theme.bar }),
	          labelText ? _react2.default.createElement(
	            'label',
	            { className: labelClassName },
	            labelText,
	            required ? _react2.default.createElement(
	              'span',
	              { className: theme.required },
	              ' * '
	            ) : null
	          ) : null,
	          hint ? _react2.default.createElement(
	            'span',
	            { hidden: labelText, className: theme.hint },
	            hint
	          ) : null,
	          error ? _react2.default.createElement(
	            'span',
	            { className: theme.error },
	            error
	          ) : null,
	          maxLength ? _react2.default.createElement(
	            'span',
	            { className: theme.counter },
	            length,
	            '/',
	            maxLength
	          ) : null,
	          children
	        );
	      }
	    }]);
	
	    return Input;
	  }(_react2.default.Component);
	
	  Input.propTypes = {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    defaultValue: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    floating: _propTypes2.default.bool,
	    hint: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	    maxLength: _propTypes2.default.number,
	    multiline: _propTypes2.default.bool,
	    name: _propTypes2.default.string,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onKeyPress: _propTypes2.default.func,
	    required: _propTypes2.default.bool,
	    role: _propTypes2.default.string,
	    rows: _propTypes2.default.number,
	    theme: _propTypes2.default.shape({
	      bar: _propTypes2.default.string,
	      counter: _propTypes2.default.string,
	      disabled: _propTypes2.default.string,
	      error: _propTypes2.default.string,
	      errored: _propTypes2.default.string,
	      hidden: _propTypes2.default.string,
	      hint: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      input: _propTypes2.default.string,
	      inputElement: _propTypes2.default.string,
	      required: _propTypes2.default.string,
	      withIcon: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.string])
	  };
	  Input.defaultProps = {
	    className: '',
	    hint: '',
	    disabled: false,
	    floating: true,
	    multiline: false,
	    required: false,
	    role: 'input',
	    type: 'text'
	  };
	
	
	  return Input;
	};
	
	var Input = factory(_FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.INPUT)(Input);
	exports.inputFactory = factory;
	exports.Input = Input;

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Overlay = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(8);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Overlay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this.handleEscKey = function (e) {
	      if (_this.props.active && _this.props.onEscKeyDown && e.which === 27) {
	        _this.props.onEscKeyDown(e);
	      }
	    }, _this.handleClick = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          active = _props.active,
	          lockScroll = _props.lockScroll,
	          onEscKeyDown = _props.onEscKeyDown;
	
	      if (onEscKeyDown) document.body.addEventListener('keydown', this.handleEscKey);
	      if (active && lockScroll) document.body.style.overflow = 'hidden';
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (this.props.lockScroll) {
	        var becomingActive = nextProps.active && !this.props.active;
	        var becomingUnactive = !nextProps.active && this.props.active;
	
	        if (becomingActive) {
	          document.body.style.overflow = 'hidden';
	        }
	
	        if (becomingUnactive && !document.querySelectorAll('[data-react-toolbox="overlay"]')[1]) {
	          document.body.style.overflow = '';
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.onEscKeyDown) {
	        if (this.props.active && !prevProps.active) {
	          document.body.addEventListener('keydown', this.handleEscKey);
	        } else if (!this.props.active && prevProps.active) {
	          document.body.removeEventListener('keydown', this.handleEscKey);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.active && this.props.lockScroll) {
	        if (!document.querySelectorAll('[data-react-toolbox="overlay"]')[1]) {
	          document.body.style.overflow = '';
	        }
	      }
	
	      if (this.props.onEscKeyDown) {
	        document.body.removeEventListener('keydown', this.handleEscKey);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          active = _props2.active,
	          className = _props2.className,
	          lockScroll = _props2.lockScroll,
	          theme = _props2.theme,
	          onEscKeyDown = _props2.onEscKeyDown,
	          other = _objectWithoutProperties(_props2, ['active', 'className', 'lockScroll', 'theme', 'onEscKeyDown']); // eslint-disable-line
	
	
	      return _react2.default.createElement('div', _extends({}, other, {
	        onClick: this.handleClick,
	        className: (0, _classnames3.default)(theme.overlay, _defineProperty({}, theme.active, active), className)
	      }));
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.propTypes = {
	  active: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  lockScroll: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onEscKeyDown: _propTypes2.default.func,
	  theme: _propTypes2.default.shape({
	    active: _propTypes2.default.string,
	    backdrop: _propTypes2.default.string,
	    overlay: _propTypes2.default.string
	  })
	};
	Overlay.defaultProps = {
	  lockScroll: true
	};
	exports.default = (0, _reactCssThemr.themr)(_identifiers.OVERLAY)(Overlay);
	exports.Overlay = Overlay;

/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(2846);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  getMousePosition: function getMousePosition(event) {
	    return {
	      x: event.pageX - (window.scrollX || window.pageXOffset),
	      y: event.pageY - (window.scrollY || window.pageYOffset)
	    };
	  },
	  getTouchPosition: function getTouchPosition(event) {
	    return {
	      x: event.touches[0].pageX - (window.scrollX || window.pageXOffset),
	      y: event.touches[0].pageY - (window.scrollY || window.pageYOffset)
	    };
	  },
	  pauseEvent: function pauseEvent(event) {
	    event.stopPropagation();
	    event.preventDefault();
	  },
	  addEventsToDocument: function addEventsToDocument(eventMap) {
	    Object.keys(eventMap).forEach(function (key) {
	      document.addEventListener(key, eventMap[key], false);
	    });
	  },
	  removeEventsFromDocument: function removeEventsFromDocument(eventMap) {
	    Object.keys(eventMap).forEach(function (key) {
	      document.removeEventListener(key, eventMap[key], false);
	    });
	  },
	  targetIsDescendant: function targetIsDescendant(event, parent) {
	    var node = event.target;
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	    return false;
	  },
	  addEventListenerOnTransitionEnded: function addEventListenerOnTransitionEnded(element, fn) {
	    var eventName = transitionEventNamesFor(element);
	    if (!eventName) return false;
	    element.addEventListener(eventName, fn);
	    return true;
	  },
	  removeEventListenerOnTransitionEnded: function removeEventListenerOnTransitionEnded(element, fn) {
	    var eventName = transitionEventNamesFor(element);
	    if (!eventName) return false;
	    element.removeEventListener(eventName, fn);
	    return true;
	  }
	};
	
	
	var TRANSITIONS = {
	  transition: 'transitionend',
	  OTransition: 'oTransitionEnd',
	  MozTransition: 'transitionend',
	  WebkitTransition: 'webkitTransitionEnd'
	};
	
	function transitionEventNamesFor(element) {
	  return (0, _keys2.default)(TRANSITIONS).reduce(function (result, transition) {
	    return !result && element && element.style[transition] !== undefined ? TRANSITIONS[transition] : result;
	  }, null);
	}

/***/ }),
/* 2841 */
/***/ (function(module, exports) {

	module.exports = function _arity(n, fn) {
	  /* eslint-disable no-unused-vars */
	  switch (n) {
	    case 0: return function() { return fn.apply(this, arguments); };
	    case 1: return function(a0) { return fn.apply(this, arguments); };
	    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
	    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
	    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
	    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
	    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
	    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
	    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
	    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
	    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
	    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
	  }
	};


/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

	var _isArray = __webpack_require__(2844);
	
	
	/**
	 * This checks whether a function has a [methodname] function. If it isn't an
	 * array it will execute that function otherwise it will default to the ramda
	 * implementation.
	 *
	 * @private
	 * @param {Function} fn ramda implemtation
	 * @param {String} methodname property to check for a custom implementation
	 * @return {Object} Whatever the return value of the method is.
	 */
	module.exports = function _checkForMethod(methodname, fn) {
	  return function() {
	    var length = arguments.length;
	    if (length === 0) {
	      return fn();
	    }
	    var obj = arguments[length - 1];
	    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
	      fn.apply(this, arguments) :
	      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
	  };
	};


/***/ }),
/* 2843 */
/***/ (function(module, exports) {

	module.exports = function _has(prop, obj) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	};


/***/ }),
/* 2844 */
/***/ (function(module, exports) {

	/**
	 * Tests whether or not an object is an array.
	 *
	 * @private
	 * @param {*} val The object to test.
	 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
	 * @example
	 *
	 *      _isArray([]); //=> true
	 *      _isArray(null); //=> false
	 *      _isArray({}); //=> false
	 */
	module.exports = Array.isArray || function _isArray(val) {
	  return (val != null &&
	          val.length >= 0 &&
	          Object.prototype.toString.call(val) === '[object Array]');
	};


/***/ }),
/* 2845 */
/***/ (function(module, exports) {

	module.exports = function _isString(x) {
	  return Object.prototype.toString.call(x) === '[object String]';
	};


/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(593);
	var _has = __webpack_require__(2843);
	var _isArguments = __webpack_require__(6349);
	
	
	/**
	 * Returns a list containing the names of all the enumerable own properties of
	 * the supplied object.
	 * Note that the order of the output array is not guaranteed to be consistent
	 * across different JS platforms.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Object
	 * @sig {k: v} -> [k]
	 * @param {Object} obj The object to extract properties from
	 * @return {Array} An array of the object's own properties.
	 * @example
	 *
	 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
	 */
	module.exports = (function() {
	  // cover IE < 9 keys issues
	  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
	                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	  // Safari bug
	  var hasArgsEnumBug = (function() {
	    'use strict';
	    return arguments.propertyIsEnumerable('length');
	  }());
	
	  var contains = function contains(list, item) {
	    var idx = 0;
	    while (idx < list.length) {
	      if (list[idx] === item) {
	        return true;
	      }
	      idx += 1;
	    }
	    return false;
	  };
	
	  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
	    _curry1(function keys(obj) {
	      return Object(obj) !== obj ? [] : Object.keys(obj);
	    }) :
	    _curry1(function keys(obj) {
	      if (Object(obj) !== obj) {
	        return [];
	      }
	      var prop, nIdx;
	      var ks = [];
	      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
	      for (prop in obj) {
	        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
	          ks[ks.length] = prop;
	        }
	      }
	      if (hasEnumBug) {
	        nIdx = nonEnumerableProps.length - 1;
	        while (nIdx >= 0) {
	          prop = nonEnumerableProps[nIdx];
	          if (_has(prop, obj) && !contains(ks, prop)) {
	            ks[ks.length] = prop;
	          }
	          nIdx -= 1;
	        }
	      }
	      return ks;
	    });
	}());


/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(1646);
	var _reduce = __webpack_require__(6351);
	
	
	/**
	 * Returns a single item by iterating through the list, successively calling
	 * the iterator function and passing it an accumulator value and the current
	 * value from the array, and then passing the result to the next call.
	 *
	 * The iterator function receives two values: *(acc, value)*. It may use
	 * `R.reduced` to shortcut the iteration.
	 *
	 * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
	 *
	 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
	 * arrays), unlike the native `Array.prototype.reduce` method. For more details
	 * on this behavior, see:
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
	 *
	 * Dispatches to the `reduce` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig ((a, b) -> a) -> a -> [b] -> a
	 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
	 *        current element from the array.
	 * @param {*} acc The accumulator value.
	 * @param {Array} list The list to iterate over.
	 * @return {*} The final, accumulated value.
	 * @see R.reduced, R.addIndex, R.reduceRight
	 * @example
	 *
	 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
	 *                -               -10
	 *               / \              / \
	 *              -   4           -6   4
	 *             / \              / \
	 *            -   3   ==>     -3   3
	 *           / \              / \
	 *          -   2           -1   2
	 *         / \              / \
	 *        0   1            0   1
	 *
	 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
	 */
	module.exports = _curry3(_reduce);


/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),
/* 2849 */
[6838, 594, 1649, 6366],
/* 2850 */
2829,
/* 2851 */
[6839, 6363, 6364, 6365, 2849, 1648, 2850],
/* 2852 */
[6834, 594],
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_WIDTH = exports.DEFAULT_HEIGHT = undefined;
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_HEIGHT = exports.DEFAULT_HEIGHT = 30;
	var DEFAULT_WIDTH = exports.DEFAULT_WIDTH = 100;
	
	// Enables more intelligent mapping of a given column and row index to an item ID.
	// This prevents a cell cache from being invalidated when its parent collection is modified.
	
	/**
	 * Caches measurements for a given cell.
	 */
	var CellMeasurerCache = function () {
	  function CellMeasurerCache() {
	    var _this = this;
	
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, CellMeasurerCache);
	    this._cellHeightCache = {};
	    this._cellWidthCache = {};
	    this._columnWidthCache = {};
	    this._rowHeightCache = {};
	    this._columnCount = 0;
	    this._rowCount = 0;
	
	    this.columnWidth = function (_ref) {
	      var index = _ref.index;
	
	      var key = _this._keyMapper(0, index);
	
	      return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
	    };
	
	    this.rowHeight = function (_ref2) {
	      var index = _ref2.index;
	
	      var key = _this._keyMapper(index, 0);
	
	      return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
	    };
	
	    var defaultHeight = params.defaultHeight,
	        defaultWidth = params.defaultWidth,
	        fixedHeight = params.fixedHeight,
	        fixedWidth = params.fixedWidth,
	        keyMapper = params.keyMapper,
	        minHeight = params.minHeight,
	        minWidth = params.minWidth;
	
	
	    this._hasFixedHeight = fixedHeight === true;
	    this._hasFixedWidth = fixedWidth === true;
	    this._minHeight = minHeight || 0;
	    this._minWidth = minWidth || 0;
	    this._keyMapper = keyMapper || defaultKeyMapper;
	
	    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
	    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);
	
	    if (false) {
	      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
	        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
	      }
	
	      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
	        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
	      }
	
	      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
	        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
	      }
	    }
	  }
	
	  (0, _createClass3.default)(CellMeasurerCache, [{
	    key: 'clear',
	    value: function clear(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      delete this._cellHeightCache[key];
	      delete this._cellWidthCache[key];
	
	      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
	    }
	  }, {
	    key: 'clearAll',
	    value: function clearAll() {
	      this._cellHeightCache = {};
	      this._cellWidthCache = {};
	      this._columnWidthCache = {};
	      this._rowHeightCache = {};
	      this._rowCount = 0;
	      this._columnCount = 0;
	    }
	  }, {
	    key: 'hasFixedHeight',
	    value: function hasFixedHeight() {
	      return this._hasFixedHeight;
	    }
	  }, {
	    key: 'hasFixedWidth',
	    value: function hasFixedWidth() {
	      return this._hasFixedWidth;
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this._hasFixedHeight) {
	        return this._defaultHeight;
	      } else {
	        var _key = this._keyMapper(rowIndex, columnIndex);
	
	        return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
	      }
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this._hasFixedWidth) {
	        return this._defaultWidth;
	      } else {
	        var _key2 = this._keyMapper(rowIndex, columnIndex);
	
	        return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
	      }
	    }
	  }, {
	    key: 'has',
	    value: function has(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      return this._cellHeightCache.hasOwnProperty(key);
	    }
	  }, {
	    key: 'set',
	    value: function set(rowIndex, columnIndex, width, height) {
	      var key = this._keyMapper(rowIndex, columnIndex);
	
	      if (columnIndex >= this._columnCount) {
	        this._columnCount = columnIndex + 1;
	      }
	      if (rowIndex >= this._rowCount) {
	        this._rowCount = rowIndex + 1;
	      }
	
	      // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
	      this._cellHeightCache[key] = height;
	      this._cellWidthCache[key] = width;
	
	      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
	    }
	  }, {
	    key: '_updateCachedColumnAndRowSizes',
	    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
	      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
	      // Pre-cache these derived values for faster lookup later.
	      // Reads are expected to occur more frequently than writes in this case.
	      // Only update non-fixed dimensions though to avoid doing unnecessary work.
	      if (!this._hasFixedWidth) {
	        var columnWidth = 0;
	        for (var i = 0; i < this._rowCount; i++) {
	          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
	        }
	        var columnKey = this._keyMapper(0, columnIndex);
	        this._columnWidthCache[columnKey] = columnWidth;
	      }
	      if (!this._hasFixedHeight) {
	        var rowHeight = 0;
	        for (var _i = 0; _i < this._columnCount; _i++) {
	          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
	        }
	        var rowKey = this._keyMapper(rowIndex, 0);
	        this._rowHeightCache[rowKey] = rowHeight;
	      }
	    }
	  }, {
	    key: 'defaultHeight',
	    get: function get() {
	      return this._defaultHeight;
	    }
	  }, {
	    key: 'defaultWidth',
	    get: function get() {
	      return this._defaultWidth;
	    }
	  }]);
	  return CellMeasurerCache;
	}();
	
	exports.default = CellMeasurerCache;
	
	
	function defaultKeyMapper(rowIndex, columnIndex) {
	  return rowIndex + '-' + columnIndex;
	}

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CellMeasurerCache = exports.CellMeasurer = undefined;
	
	var _CellMeasurer = __webpack_require__(6378);
	
	var _CellMeasurer2 = _interopRequireDefault(_CellMeasurer);
	
	var _CellMeasurerCache = __webpack_require__(2853);
	
	var _CellMeasurerCache2 = _interopRequireDefault(_CellMeasurerCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CellMeasurer2.default;
	exports.CellMeasurer = _CellMeasurer2.default;
	exports.CellMeasurerCache = _CellMeasurerCache2.default;

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRangeRenderer;
	
	/**
	 * Default implementation of cellRangeRenderer used by Grid.
	 * This renderer supports cell-caching while the user is scrolling.
	 */
	
	var babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_CellRangeRendererParams || __webpack_require__(2).any;
	
	function defaultCellRangeRenderer(_ref) {
	  var cellCache = _ref.cellCache,
	      cellRenderer = _ref.cellRenderer,
	      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
	      columnStartIndex = _ref.columnStartIndex,
	      columnStopIndex = _ref.columnStopIndex,
	      deferredMeasurementCache = _ref.deferredMeasurementCache,
	      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
	      isScrolling = _ref.isScrolling,
	      parent = _ref.parent,
	      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
	      rowStartIndex = _ref.rowStartIndex,
	      rowStopIndex = _ref.rowStopIndex,
	      styleCache = _ref.styleCache,
	      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
	      visibleColumnIndices = _ref.visibleColumnIndices,
	      visibleRowIndices = _ref.visibleRowIndices;
	
	  var renderedCells = [];
	
	  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
	  // User cannot scroll beyond these size limitations.
	  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
	  // We should never cache styles for compressed offsets though as this can lead to bugs.
	  // See issue #576 for more.
	  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
	
	  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
	
	  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
	    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
	
	    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
	      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
	      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
	      var key = rowIndex + '-' + columnIndex;
	      var style = void 0;
	
	      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
	      if (canCacheStyle && styleCache[key]) {
	        style = styleCache[key];
	      } else {
	        // In deferred mode, cells will be initially rendered before we know their size.
	        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
	        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
	          // Position not-yet-measured cells at top/left 0,0,
	          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
	          // Positioning them further to the right/bottom influences their measured size.
	          style = {
	            height: 'auto',
	            left: 0,
	            position: 'absolute',
	            top: 0,
	            width: 'auto'
	          };
	        } else {
	          style = {
	            height: rowDatum.size,
	            left: columnDatum.offset + horizontalOffsetAdjustment,
	            position: 'absolute',
	            top: rowDatum.offset + verticalOffsetAdjustment,
	            width: columnDatum.size
	          };
	
	          styleCache[key] = style;
	        }
	      }
	
	      var cellRendererParams = {
	        columnIndex: columnIndex,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        parent: parent,
	        rowIndex: rowIndex,
	        style: style
	      };
	
	      var renderedCell = void 0;
	
	      // Avoid re-creating cells while scrolling.
	      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	      // If a scroll is in progress- cache and reuse cells.
	      // This cache will be thrown away once scrolling completes.
	      // However if we are scaling scroll positions and sizes, we should also avoid caching.
	      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
	      // For more info refer to issue #395
	      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
	        if (!cellCache[key]) {
	          cellCache[key] = cellRenderer(cellRendererParams);
	        }
	
	        renderedCell = cellCache[key];
	
	        // If the user is no longer scrolling, don't cache cells.
	        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
	      } else {
	        renderedCell = cellRenderer(cellRendererParams);
	      }
	
	      if (renderedCell == null || renderedCell === false) {
	        continue;
	      }
	
	      if (false) {
	        warnAboutMissingStyle(parent, renderedCell);
	      }
	
	      renderedCells.push(renderedCell);
	    }
	  }
	
	  return renderedCells;
	}
	
	function warnAboutMissingStyle(parent, renderedCell) {
	  if (false) {
	    if (renderedCell) {
	      // If the direct child is a CellMeasurer, then we should check its child
	      // See issue #611
	      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
	        renderedCell = renderedCell.props.children;
	      }
	
	      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
	        parent.__warnedAboutMissingStyle = true;
	
	        console.warn('Rendered cell should include style property for positioning.');
	      }
	    }
	  }
	}

/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultOverscanIndicesGetter;
	
	var babelPluginFlowReactPropTypes_proptype_OverscanIndices = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_OverscanIndices || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams || __webpack_require__(2).any;
	
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
	var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
	
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 */
	
	function defaultOverscanIndicesGetter(_ref) {
	  var cellCount = _ref.cellCount,
	      overscanCellsCount = _ref.overscanCellsCount,
	      scrollDirection = _ref.scrollDirection,
	      startIndex = _ref.startIndex,
	      stopIndex = _ref.stopIndex;
	
	  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
	    return {
	      overscanStartIndex: Math.max(0, startIndex),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
	    };
	  } else {
	    return {
	      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
	    };
	  }
	}

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _defaultHeaderRenderer = __webpack_require__(2861);
	
	var _defaultHeaderRenderer2 = _interopRequireDefault(_defaultHeaderRenderer);
	
	var _defaultCellRenderer = __webpack_require__(2860);
	
	var _defaultCellRenderer2 = _interopRequireDefault(_defaultCellRenderer);
	
	var _defaultCellDataGetter = __webpack_require__(2859);
	
	var _defaultCellDataGetter2 = _interopRequireDefault(_defaultCellDataGetter);
	
	var _SortDirection = __webpack_require__(1048);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Describes the header and cell contents of a table column.
	 */
	var Column = function (_Component) {
	  (0, _inherits3.default)(Column, _Component);
	
	  function Column() {
	    (0, _classCallCheck3.default)(this, Column);
	    return (0, _possibleConstructorReturn3.default)(this, (Column.__proto__ || (0, _getPrototypeOf2.default)(Column)).apply(this, arguments));
	  }
	
	  return Column;
	}(_react.Component);
	
	Column.defaultProps = {
	  cellDataGetter: _defaultCellDataGetter2.default,
	  cellRenderer: _defaultCellRenderer2.default,
	  defaultSortDirection: _SortDirection2.default.ASC,
	  flexGrow: 0,
	  flexShrink: 1,
	  headerRenderer: _defaultHeaderRenderer2.default,
	  style: {}
	};
	exports.default = Column;
	Column.propTypes =  false ? {
	  /** Optional aria-label value to set on the column header */
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Callback responsible for returning a cell's data, given its :dataKey
	   * ({ columnData: any, dataKey: string, rowData: any }): any
	   */
	  cellDataGetter: _propTypes2.default.func,
	
	  /**
	   * Callback responsible for rendering a cell's contents.
	   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
	   */
	  cellRenderer: _propTypes2.default.func,
	
	  /** Optional CSS class to apply to cell */
	  className: _propTypes2.default.string,
	
	  /** Optional additional data passed to this column's :cellDataGetter */
	  columnData: _propTypes2.default.object,
	
	  /** Uniquely identifies the row-data attribute corresponding to this cell */
	  dataKey: _propTypes2.default.any.isRequired,
	
	  /** Optional direction to be used when clicked the first time */
	  defaultSortDirection: _propTypes2.default.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC]),
	
	  /** If sort is enabled for the table at large, disable it for this column */
	  disableSort: _propTypes2.default.bool,
	
	  /** Flex grow style; defaults to 0 */
	  flexGrow: _propTypes2.default.number,
	
	  /** Flex shrink style; defaults to 1 */
	  flexShrink: _propTypes2.default.number,
	
	  /** Optional CSS class to apply to this column's header */
	  headerClassName: _propTypes2.default.string,
	
	  /**
	   * Optional callback responsible for rendering a column header contents.
	   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
	   */
	  headerRenderer: _propTypes2.default.func.isRequired,
	
	  /** Optional inline style to apply to this column's header */
	  headerStyle: _propTypes2.default.object,
	
	  /** Optional id to set on the column header */
	  id: _propTypes2.default.string,
	
	  /** Header label for this column */
	  label: _propTypes2.default.node,
	
	  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
	  maxWidth: _propTypes2.default.number,
	
	  /** Minimum width of column. */
	  minWidth: _propTypes2.default.number,
	
	  /** Optional inline style to apply to cell */
	  style: _propTypes2.default.object,
	
	  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
	  width: _propTypes2.default.number.isRequired
	} : {};

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SortIndicator;
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SortDirection = __webpack_require__(1048);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Displayed beside a header to indicate that a Table is currently sorted by this column.
	 */
	function SortIndicator(_ref) {
	  var sortDirection = _ref.sortDirection;
	
	  var classNames = (0, _classnames2.default)('ReactVirtualized__Table__sortableHeaderIcon', {
	    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === _SortDirection2.default.ASC,
	    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === _SortDirection2.default.DESC
	  });
	
	  return _react2.default.createElement(
	    'svg',
	    { className: classNames, width: 18, height: 18, viewBox: '0 0 24 24' },
	    sortDirection === _SortDirection2.default.ASC ? _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' }) : _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' }),
	    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
	  );
	}
	
	SortIndicator.propTypes =  false ? {
	  sortDirection: _propTypes2.default.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC])
	} : {};

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellDataGetter;
	
	/**
	 * Default accessor for returning a cell value for a given attribute.
	 * This function expects to operate on either a vanilla Object or an Immutable Map.
	 * You should override the column's cellDataGetter if your data is some other type of object.
	 */
	var babelPluginFlowReactPropTypes_proptype_CellDataGetterParams = __webpack_require__(751).babelPluginFlowReactPropTypes_proptype_CellDataGetterParams || __webpack_require__(2).any;
	
	function defaultCellDataGetter(_ref) {
	  var dataKey = _ref.dataKey,
	      rowData = _ref.rowData;
	
	  if (typeof rowData.get === 'function') {
	    return rowData.get(dataKey);
	  } else {
	    return rowData[dataKey];
	  }
	}

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultCellRenderer;
	
	/**
	 * Default cell renderer that displays an attribute as a simple string
	 * You should override the column's cellRenderer if your data is some other type of object.
	 */
	var babelPluginFlowReactPropTypes_proptype_CellRendererParams = __webpack_require__(751).babelPluginFlowReactPropTypes_proptype_CellRendererParams || __webpack_require__(2).any;
	
	function defaultCellRenderer(_ref) {
	  var cellData = _ref.cellData;
	
	  if (cellData == null) {
	    return '';
	  } else {
	    return String(cellData);
	  }
	}

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultHeaderRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SortIndicator = __webpack_require__(2858);
	
	var _SortIndicator2 = _interopRequireDefault(_SortIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default table header renderer.
	 */
	var babelPluginFlowReactPropTypes_proptype_HeaderRendererParams = __webpack_require__(751).babelPluginFlowReactPropTypes_proptype_HeaderRendererParams || __webpack_require__(2).any;
	
	function defaultHeaderRenderer(_ref) {
	  var dataKey = _ref.dataKey,
	      label = _ref.label,
	      sortBy = _ref.sortBy,
	      sortDirection = _ref.sortDirection;
	
	  var showSortIndicator = sortBy === dataKey;
	  var children = [_react2.default.createElement(
	    'span',
	    {
	      className: 'ReactVirtualized__Table__headerTruncatedText',
	      key: 'label',
	      title: label },
	    label
	  )];
	
	  if (showSortIndicator) {
	    children.push(_react2.default.createElement(_SortIndicator2.default, { key: 'SortIndicator', sortDirection: sortDirection }));
	  }
	
	  return children;
	}
	defaultHeaderRenderer.propTypes =  true ? null : babelPluginFlowReactPropTypes_proptype_HeaderRendererParams === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_HeaderRendererParams;

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultHeaderRowRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams = __webpack_require__(751).babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams || __webpack_require__(2).any;
	
	function defaultHeaderRowRenderer(_ref) {
	  var className = _ref.className,
	      columns = _ref.columns,
	      style = _ref.style;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, role: 'row', style: style },
	    columns
	  );
	}
	defaultHeaderRowRenderer.propTypes =  true ? null : babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_HeaderRowRendererParams;

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = defaultRowRenderer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default row renderer for Table.
	 */
	var babelPluginFlowReactPropTypes_proptype_RowRendererParams = __webpack_require__(751).babelPluginFlowReactPropTypes_proptype_RowRendererParams || __webpack_require__(2).any;
	
	function defaultRowRenderer(_ref) {
	  var className = _ref.className,
	      columns = _ref.columns,
	      index = _ref.index,
	      key = _ref.key,
	      onRowClick = _ref.onRowClick,
	      onRowDoubleClick = _ref.onRowDoubleClick,
	      onRowMouseOut = _ref.onRowMouseOut,
	      onRowMouseOver = _ref.onRowMouseOver,
	      onRowRightClick = _ref.onRowRightClick,
	      rowData = _ref.rowData,
	      style = _ref.style;
	
	  var a11yProps = {};
	
	  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
	    a11yProps['aria-label'] = 'row';
	    a11yProps.tabIndex = 0;
	
	    if (onRowClick) {
	      a11yProps.onClick = function (event) {
	        return onRowClick({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowDoubleClick) {
	      a11yProps.onDoubleClick = function (event) {
	        return onRowDoubleClick({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOut) {
	      a11yProps.onMouseOut = function (event) {
	        return onRowMouseOut({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowMouseOver) {
	      a11yProps.onMouseOver = function (event) {
	        return onRowMouseOver({ event: event, index: index, rowData: rowData });
	      };
	    }
	    if (onRowRightClick) {
	      a11yProps.onContextMenu = function (event) {
	        return onRowRightClick({ event: event, index: index, rowData: rowData });
	      };
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, a11yProps, {
	      className: className,
	      key: key,
	      role: 'row',
	      style: style }),
	    columns
	  );
	}
	defaultRowRenderer.propTypes =  true ? null : babelPluginFlowReactPropTypes_proptype_RowRendererParams === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_RowRendererParams;

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_SCROLLING_TIMEOUT = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _onScroll = __webpack_require__(6410);
	
	var _dimensions = __webpack_require__(6409);
	
	var _detectElementResize = __webpack_require__(2865);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = exports.IS_SCROLLING_TIMEOUT = 150;
	
	var getWindow = function getWindow() {
	  return typeof window !== 'undefined' ? window : undefined;
	};
	
	var WindowScroller = function (_React$PureComponent) {
	  (0, _inherits3.default)(WindowScroller, _React$PureComponent);
	
	  function WindowScroller() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, WindowScroller);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WindowScroller.__proto__ || (0, _getPrototypeOf2.default)(WindowScroller)).call.apply(_ref, [this].concat(args))), _this), _this._window = getWindow(), _this._isMounted = false, _this._positionFromTop = 0, _this._positionFromLeft = 0, _this.state = (0, _extends3.default)({}, (0, _dimensions.getDimensions)(_this.props.scrollElement, _this.props), {
	      isScrolling: false,
	      scrollLeft: 0,
	      scrollTop: 0
	    }), _this._registerChild = function (element) {
	      if (element && !(element instanceof Element)) {
	        console.warn('WindowScroller registerChild expects to be passed Element or null');
	      }
	      _this._child = element;
	      _this.updatePosition();
	    }, _this._onChildScroll = function (_ref2) {
	      var scrollTop = _ref2.scrollTop;
	
	      if (_this.state.scrollTop === scrollTop) {
	        return;
	      }
	
	      var scrollElement = _this.props.scrollElement;
	      if (scrollElement) {
	        if (typeof scrollElement.scrollTo === 'function') {
	          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
	        } else {
	          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
	        }
	      }
	    }, _this._registerResizeListener = function (element) {
	      if (element === window) {
	        window.addEventListener('resize', _this._onResize, false);
	      } else {
	        _this._detectElementResize.addResizeListener(element, _this._onResize);
	      }
	    }, _this._unregisterResizeListener = function (element) {
	      if (element === window) {
	        window.removeEventListener('resize', _this._onResize, false);
	      } else if (element) {
	        _this._detectElementResize.removeResizeListener(element, _this._onResize);
	      }
	    }, _this._onResize = function () {
	      _this.updatePosition();
	    }, _this.__handleWindowScrollEvent = function () {
	      if (!_this._isMounted) {
	        return;
	      }
	
	      var onScroll = _this.props.onScroll;
	
	
	      var scrollElement = _this.props.scrollElement;
	      if (scrollElement) {
	        var scrollOffset = (0, _dimensions.getScrollOffset)(scrollElement);
	        var _scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
	        var _scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);
	
	        _this.setState({
	          isScrolling: true,
	          scrollLeft: _scrollLeft,
	          scrollTop: _scrollTop
	        });
	
	        onScroll({
	          scrollLeft: _scrollLeft,
	          scrollTop: _scrollTop
	        });
	      }
	    }, _this.__resetIsScrolling = function () {
	      _this.setState({
	        isScrolling: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(WindowScroller, [{
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      var onResize = this.props.onResize;
	      var _state = this.state,
	          height = _state.height,
	          width = _state.width;
	
	
	      var thisNode = this._child || _reactDom2.default.findDOMNode(this);
	      if (thisNode instanceof Element && scrollElement) {
	        var offset = (0, _dimensions.getPositionOffset)(thisNode, scrollElement);
	        this._positionFromTop = offset.top;
	        this._positionFromLeft = offset.left;
	      }
	
	      var dimensions = (0, _dimensions.getDimensions)(scrollElement, props);
	      if (height !== dimensions.height || width !== dimensions.width) {
	        this.setState({
	          height: dimensions.height,
	          width: dimensions.width
	        });
	        onResize({
	          height: dimensions.height,
	          width: dimensions.width
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var scrollElement = this.props.scrollElement;
	
	      this._detectElementResize = (0, _detectElementResize2.default)();
	
	      this.updatePosition(scrollElement);
	
	      if (scrollElement) {
	        (0, _onScroll.registerScrollListener)(this, scrollElement);
	        this._registerResizeListener(scrollElement);
	      }
	
	      this._isMounted = true;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var scrollElement = this.props.scrollElement;
	      var nextScrollElement = nextProps.scrollElement;
	
	      if (scrollElement !== nextScrollElement && scrollElement && nextScrollElement) {
	        this.updatePosition(nextScrollElement, nextProps);
	
	        (0, _onScroll.unregisterScrollListener)(this, scrollElement);
	        (0, _onScroll.registerScrollListener)(this, nextScrollElement);
	
	        this._unregisterResizeListener(scrollElement);
	        this._registerResizeListener(nextScrollElement);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var scrollElement = this.props.scrollElement;
	      if (scrollElement) {
	        (0, _onScroll.unregisterScrollListener)(this, scrollElement);
	        this._unregisterResizeListener(scrollElement);
	      }
	
	      this._isMounted = false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state2 = this.state,
	          isScrolling = _state2.isScrolling,
	          scrollTop = _state2.scrollTop,
	          scrollLeft = _state2.scrollLeft,
	          height = _state2.height,
	          width = _state2.width;
	
	
	      return children({
	        onChildScroll: this._onChildScroll,
	        registerChild: this._registerChild,
	        height: height,
	        isScrolling: isScrolling,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        width: width
	      });
	    }
	
	    // Referenced by utils/onScroll
	
	
	    // Referenced by utils/onScroll
	
	  }]);
	  return WindowScroller;
	}(React.PureComponent);
	
	WindowScroller.defaultProps = {
	  onResize: function onResize() {},
	  onScroll: function onScroll() {},
	  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
	  scrollElement: getWindow(),
	  serverHeight: 0,
	  serverWidth: 0
	};
	WindowScroller.propTypes =  true ? null : {
	  /**
	   * Function responsible for rendering children.
	   * This function should implement the following signature:
	   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
	   */
	  children: require('prop-types').func.isRequired,
	
	
	  /** Callback to be invoked on-resize: ({ height, width }) */
	  onResize: require('prop-types').func.isRequired,
	
	
	  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
	  onScroll: require('prop-types').func.isRequired,
	
	
	  /** Element to attach scroll event listeners. Defaults to window. */
	  scrollElement: require('prop-types').oneOfType([require('prop-types').any, typeof Element === 'function' ? require('prop-types').instanceOf(Element) : require('prop-types').any]),
	
	  /**
	   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
	   */
	  scrollingResetTimeInterval: require('prop-types').number.isRequired,
	
	
	  /** Height used for server-side rendering */
	  serverHeight: require('prop-types').number.isRequired,
	
	
	  /** Width used for server-side rendering */
	  serverWidth: require('prop-types').number.isRequired
	};
	exports.default = WindowScroller;

/***/ }),
/* 2865 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createDetectElementResize;
	/**
	 * Detect Element Resize.
	 * https://github.com/sdecima/javascript-detect-element-resize
	 * Sebastian Decima
	 *
	 * Forked from version 0.5.3; includes the following modifications:
	 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
	 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
	 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
	 * 4) Add nonce for style element.
	 **/
	
	function createDetectElementResize(nonce) {
	  // Check `document` and `window` in case of server-side rendering
	  var _window;
	  if (typeof window !== 'undefined') {
	    _window = window;
	  } else if (typeof self !== 'undefined') {
	    _window = self;
	  } else {
	    _window = global;
	  }
	
	  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
	
	  if (!attachEvent) {
	    var requestFrame = function () {
	      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
	        return _window.setTimeout(fn, 20);
	      };
	      return function (fn) {
	        return raf(fn);
	      };
	    }();
	
	    var cancelFrame = function () {
	      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
	      return function (id) {
	        return cancel(id);
	      };
	    }();
	
	    var resetTriggers = function resetTriggers(element) {
	      var triggers = element.__resizeTriggers__,
	          expand = triggers.firstElementChild,
	          contract = triggers.lastElementChild,
	          expandChild = expand.firstElementChild;
	      contract.scrollLeft = contract.scrollWidth;
	      contract.scrollTop = contract.scrollHeight;
	      expandChild.style.width = expand.offsetWidth + 1 + 'px';
	      expandChild.style.height = expand.offsetHeight + 1 + 'px';
	      expand.scrollLeft = expand.scrollWidth;
	      expand.scrollTop = expand.scrollHeight;
	    };
	
	    var checkTriggers = function checkTriggers(element) {
	      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
	    };
	
	    var scrollListener = function scrollListener(e) {
	      // Don't measure (which forces) reflow for scrolls that happen inside of children!
	      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
	        return;
	      }
	
	      var element = this;
	      resetTriggers(this);
	      if (this.__resizeRAF__) {
	        cancelFrame(this.__resizeRAF__);
	      }
	      this.__resizeRAF__ = requestFrame(function () {
	        if (checkTriggers(element)) {
	          element.__resizeLast__.width = element.offsetWidth;
	          element.__resizeLast__.height = element.offsetHeight;
	          element.__resizeListeners__.forEach(function (fn) {
	            fn.call(element, e);
	          });
	        }
	      });
	    };
	
	    /* Detect CSS Animations support to detect element display/re-attach */
	    var animation = false,
	        keyframeprefix = '',
	        animationstartevent = 'animationstart',
	        domPrefixes = 'Webkit Moz O ms'.split(' '),
	        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
	        pfx = '';
	    {
	      var elm = document.createElement('fakeelement');
	      if (elm.style.animationName !== undefined) {
	        animation = true;
	      }
	
	      if (animation === false) {
	        for (var i = 0; i < domPrefixes.length; i++) {
	          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	            pfx = domPrefixes[i];
	            keyframeprefix = '-' + pfx.toLowerCase() + '-';
	            animationstartevent = startEvents[i];
	            animation = true;
	            break;
	          }
	        }
	      }
	    }
	
	    var animationName = 'resizeanim';
	    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
	    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
	  }
	
	  var createStyles = function createStyles(doc) {
	    if (!doc.getElementById('detectElementResize')) {
	      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
	      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
	          head = doc.head || doc.getElementsByTagName('head')[0],
	          style = doc.createElement('style');
	
	      style.id = 'detectElementResize';
	      style.type = 'text/css';
	
	      if (nonce != null) {
	        style.setAttribute('nonce', nonce);
	      }
	
	      if (style.styleSheet) {
	        style.styleSheet.cssText = css;
	      } else {
	        style.appendChild(doc.createTextNode(css));
	      }
	
	      head.appendChild(style);
	    }
	  };
	
	  var addResizeListener = function addResizeListener(element, fn) {
	    if (attachEvent) {
	      element.attachEvent('onresize', fn);
	    } else {
	      if (!element.__resizeTriggers__) {
	        var doc = element.ownerDocument;
	        var elementStyle = _window.getComputedStyle(element);
	        if (elementStyle && elementStyle.position == 'static') {
	          element.style.position = 'relative';
	        }
	        createStyles(doc);
	        element.__resizeLast__ = {};
	        element.__resizeListeners__ = [];
	        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
	        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
	        element.appendChild(element.__resizeTriggers__);
	        resetTriggers(element);
	        element.addEventListener('scroll', scrollListener, true);
	
	        /* Listen for a css animation to detect element display/re-attach */
	        if (animationstartevent) {
	          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
	            if (e.animationName == animationName) {
	              resetTriggers(element);
	            }
	          };
	          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	        }
	      }
	      element.__resizeListeners__.push(fn);
	    }
	  };
	
	  var removeResizeListener = function removeResizeListener(element, fn) {
	    if (attachEvent) {
	      element.detachEvent('onresize', fn);
	    } else {
	      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
	      if (!element.__resizeListeners__.length) {
	        element.removeEventListener('scroll', scrollListener, true);
	        if (element.__resizeTriggers__.__animationListener__) {
	          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
	          element.__resizeTriggers__.__animationListener__ = null;
	        }
	        try {
	          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
	        } catch (e) {
	          // Preact compat; see developit/preact-compat/issues/228
	        }
	      }
	    }
	  };
	
	  return {
	    addResizeListener: addResizeListener,
	    removeResizeListener: removeResizeListener
	  };
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2866 */,
/* 2867 */,
/* 2868 */,
/* 2869 */,
/* 2870 */,
/* 2871 */,
/* 2872 */,
/* 2873 */,
/* 2874 */,
/* 2875 */,
/* 2876 */,
/* 2877 */,
/* 2878 */,
/* 2879 */,
/* 2880 */,
/* 2881 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ }),
/* 2882 */
/***/ (function(module, exports) {

	'use strict';
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(2882);
	
	var supportsDescriptors = __webpack_require__(1483).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	var $TypeError = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if ((/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(global) {"use strict";function _createForOfIteratorHelper(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray2(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;var F=function F(){};return{s:F,n:function n(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};},e:function e(_e){throw _e;},f:F};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var normalCompletion=true,didErr=false,err;return{s:function s(){it=o[Symbol.iterator]();},n:function n(){var step=it.next();normalCompletion=step.done;return step;},e:function e(_e2){didErr=true;err=_e2;},f:function f(){try{if(!normalCompletion&&it["return"]!=null)it["return"]();}finally{if(didErr)throw err;}}};}function _unsupportedIterableToArray2(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray2(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray2(o,minLen);}function _arrayLikeToArray2(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _typeof(obj){"@babel/helpers - typeof";if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(obj){return typeof obj;};}else{_typeof=function _typeof(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};}return _typeof(obj);}(function(f){if(( false?"undefined":_typeof(exports))==="object"&&typeof module!=="undefined"){module.exports=f();}else if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else{var g;if(typeof window!=="undefined"){g=window;}else if(typeof global!=="undefined"){g=global;}else if(typeof self!=="undefined"){g=self;}else{g=this;}g.sanitizeHtml=f();}})(function(){var define,module,exports;return function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a;}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r);},p,p.exports,r,e,n,t);}return n[i].exports;}for(var u="function"==typeof require&&require,i=0;i<t.length;i++){o(t[i]);}return o;}return r;}()({1:[function(require,module,exports){'use strict';exports.byteLength=byteLength;exports.toByteArray=toByteArray;exports.fromByteArray=fromByteArray;var lookup=[];var revLookup=[];var Arr=typeof Uint8Array!=='undefined'?Uint8Array:Array;var code='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';for(var i=0,len=code.length;i<len;++i){lookup[i]=code[i];revLookup[code.charCodeAt(i)]=i;}// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)]=62;revLookup['_'.charCodeAt(0)]=63;function getLens(b64){var len=b64.length;if(len%4>0){throw new Error('Invalid string. Length must be a multiple of 4');}// Trim off extra bytes after placeholder bytes are found
	// See: https://github.com/beatgammit/base64-js/issues/42
	var validLen=b64.indexOf('=');if(validLen===-1)validLen=len;var placeHoldersLen=validLen===len?0:4-validLen%4;return[validLen,placeHoldersLen];}// base64 is 4/3 + up to two characters of the original data
	function byteLength(b64){var lens=getLens(b64);var validLen=lens[0];var placeHoldersLen=lens[1];return(validLen+placeHoldersLen)*3/4-placeHoldersLen;}function _byteLength(b64,validLen,placeHoldersLen){return(validLen+placeHoldersLen)*3/4-placeHoldersLen;}function toByteArray(b64){var tmp;var lens=getLens(b64);var validLen=lens[0];var placeHoldersLen=lens[1];var arr=new Arr(_byteLength(b64,validLen,placeHoldersLen));var curByte=0;// if there are placeholders, only get up to the last complete 4 chars
	var len=placeHoldersLen>0?validLen-4:validLen;var i;for(i=0;i<len;i+=4){tmp=revLookup[b64.charCodeAt(i)]<<18|revLookup[b64.charCodeAt(i+1)]<<12|revLookup[b64.charCodeAt(i+2)]<<6|revLookup[b64.charCodeAt(i+3)];arr[curByte++]=tmp>>16&0xFF;arr[curByte++]=tmp>>8&0xFF;arr[curByte++]=tmp&0xFF;}if(placeHoldersLen===2){tmp=revLookup[b64.charCodeAt(i)]<<2|revLookup[b64.charCodeAt(i+1)]>>4;arr[curByte++]=tmp&0xFF;}if(placeHoldersLen===1){tmp=revLookup[b64.charCodeAt(i)]<<10|revLookup[b64.charCodeAt(i+1)]<<4|revLookup[b64.charCodeAt(i+2)]>>2;arr[curByte++]=tmp>>8&0xFF;arr[curByte++]=tmp&0xFF;}return arr;}function tripletToBase64(num){return lookup[num>>18&0x3F]+lookup[num>>12&0x3F]+lookup[num>>6&0x3F]+lookup[num&0x3F];}function encodeChunk(uint8,start,end){var tmp;var output=[];for(var i=start;i<end;i+=3){tmp=(uint8[i]<<16&0xFF0000)+(uint8[i+1]<<8&0xFF00)+(uint8[i+2]&0xFF);output.push(tripletToBase64(tmp));}return output.join('');}function fromByteArray(uint8){var tmp;var len=uint8.length;var extraBytes=len%3;// if we have 1 byte left, pad 2 bytes
	var parts=[];var maxChunkLength=16383;// must be multiple of 3
	// go through the array every three bytes, we'll deal with trailing stuff later
	for(var i=0,len2=len-extraBytes;i<len2;i+=maxChunkLength){parts.push(encodeChunk(uint8,i,i+maxChunkLength>len2?len2:i+maxChunkLength));}// pad the end with zeros, but make sure to not forget the extra bytes
	if(extraBytes===1){tmp=uint8[len-1];parts.push(lookup[tmp>>2]+lookup[tmp<<4&0x3F]+'==');}else if(extraBytes===2){tmp=(uint8[len-2]<<8)+uint8[len-1];parts.push(lookup[tmp>>10]+lookup[tmp>>4&0x3F]+lookup[tmp<<2&0x3F]+'=');}return parts.join('');}},{}],2:[function(require,module,exports){},{}],3:[function(require,module,exports){(function(Buffer){/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */ /* eslint-disable no-proto */'use strict';var base64=require('base64-js');var ieee754=require('ieee754');exports.Buffer=Buffer;exports.SlowBuffer=SlowBuffer;exports.INSPECT_MAX_BYTES=50;var K_MAX_LENGTH=0x7fffffff;exports.kMaxLength=K_MAX_LENGTH;/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
	 *               implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * We report that the browser does not support typed arrays if the are not subclassable
	 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
	 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
	 * for __proto__ and has a buggy typed array implementation.
	 */Buffer.TYPED_ARRAY_SUPPORT=typedArraySupport();if(!Buffer.TYPED_ARRAY_SUPPORT&&typeof console!=='undefined'&&typeof console.error==='function'){console.error('This browser lacks typed array (Uint8Array) support which is required by '+'`buffer` v5.x. Use `buffer` v4.x if you require old browser support.');}function typedArraySupport(){// Can typed array instances can be augmented?
	try{var arr=new Uint8Array(1);arr.__proto__={__proto__:Uint8Array.prototype,foo:function foo(){return 42;}};return arr.foo()===42;}catch(e){return false;}}Object.defineProperty(Buffer.prototype,'parent',{enumerable:true,get:function get(){if(!Buffer.isBuffer(this))return undefined;return this.buffer;}});Object.defineProperty(Buffer.prototype,'offset',{enumerable:true,get:function get(){if(!Buffer.isBuffer(this))return undefined;return this.byteOffset;}});function createBuffer(length){if(length>K_MAX_LENGTH){throw new RangeError('The value "'+length+'" is invalid for option "size"');}// Return an augmented `Uint8Array` instance
	var buf=new Uint8Array(length);buf.__proto__=Buffer.prototype;return buf;}/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */function Buffer(arg,encodingOrOffset,length){// Common case.
	if(typeof arg==='number'){if(typeof encodingOrOffset==='string'){throw new TypeError('The "string" argument must be of type string. Received type number');}return allocUnsafe(arg);}return from(arg,encodingOrOffset,length);}// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	if(typeof Symbol!=='undefined'&&Symbol.species!=null&&Buffer[Symbol.species]===Buffer){Object.defineProperty(Buffer,Symbol.species,{value:null,configurable:true,enumerable:false,writable:false});}Buffer.poolSize=8192;// not used by this implementation
	function from(value,encodingOrOffset,length){if(typeof value==='string'){return fromString(value,encodingOrOffset);}if(ArrayBuffer.isView(value)){return fromArrayLike(value);}if(value==null){throw TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, '+'or Array-like Object. Received type '+_typeof(value));}if(isInstance(value,ArrayBuffer)||value&&isInstance(value.buffer,ArrayBuffer)){return fromArrayBuffer(value,encodingOrOffset,length);}if(typeof value==='number'){throw new TypeError('The "value" argument must not be of type number. Received type number');}var valueOf=value.valueOf&&value.valueOf();if(valueOf!=null&&valueOf!==value){return Buffer.from(valueOf,encodingOrOffset,length);}var b=fromObject(value);if(b)return b;if(typeof Symbol!=='undefined'&&Symbol.toPrimitive!=null&&typeof value[Symbol.toPrimitive]==='function'){return Buffer.from(value[Symbol.toPrimitive]('string'),encodingOrOffset,length);}throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, '+'or Array-like Object. Received type '+_typeof(value));}/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/Buffer.from=function(value,encodingOrOffset,length){return from(value,encodingOrOffset,length);};// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
	// https://github.com/feross/buffer/pull/148
	Buffer.prototype.__proto__=Uint8Array.prototype;Buffer.__proto__=Uint8Array;function assertSize(size){if(typeof size!=='number'){throw new TypeError('"size" argument must be of type number');}else if(size<0){throw new RangeError('The value "'+size+'" is invalid for option "size"');}}function alloc(size,fill,encoding){assertSize(size);if(size<=0){return createBuffer(size);}if(fill!==undefined){// Only pay attention to encoding if it's a string. This
	// prevents accidentally sending in a number that would
	// be interpretted as a start offset.
	return typeof encoding==='string'?createBuffer(size).fill(fill,encoding):createBuffer(size).fill(fill);}return createBuffer(size);}/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/Buffer.alloc=function(size,fill,encoding){return alloc(size,fill,encoding);};function allocUnsafe(size){assertSize(size);return createBuffer(size<0?0:checked(size)|0);}/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */Buffer.allocUnsafe=function(size){return allocUnsafe(size);};/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */Buffer.allocUnsafeSlow=function(size){return allocUnsafe(size);};function fromString(string,encoding){if(typeof encoding!=='string'||encoding===''){encoding='utf8';}if(!Buffer.isEncoding(encoding)){throw new TypeError('Unknown encoding: '+encoding);}var length=byteLength(string,encoding)|0;var buf=createBuffer(length);var actual=buf.write(string,encoding);if(actual!==length){// Writing a hex string, for example, that contains invalid characters will
	// cause everything after the first invalid character to be ignored. (e.g.
	// 'abxxcd' will be treated as 'ab')
	buf=buf.slice(0,actual);}return buf;}function fromArrayLike(array){var length=array.length<0?0:checked(array.length)|0;var buf=createBuffer(length);for(var i=0;i<length;i+=1){buf[i]=array[i]&255;}return buf;}function fromArrayBuffer(array,byteOffset,length){if(byteOffset<0||array.byteLength<byteOffset){throw new RangeError('"offset" is outside of buffer bounds');}if(array.byteLength<byteOffset+(length||0)){throw new RangeError('"length" is outside of buffer bounds');}var buf;if(byteOffset===undefined&&length===undefined){buf=new Uint8Array(array);}else if(length===undefined){buf=new Uint8Array(array,byteOffset);}else{buf=new Uint8Array(array,byteOffset,length);}// Return an augmented `Uint8Array` instance
	buf.__proto__=Buffer.prototype;return buf;}function fromObject(obj){if(Buffer.isBuffer(obj)){var len=checked(obj.length)|0;var buf=createBuffer(len);if(buf.length===0){return buf;}obj.copy(buf,0,0,len);return buf;}if(obj.length!==undefined){if(typeof obj.length!=='number'||numberIsNaN(obj.length)){return createBuffer(0);}return fromArrayLike(obj);}if(obj.type==='Buffer'&&Array.isArray(obj.data)){return fromArrayLike(obj.data);}}function checked(length){// Note: cannot use `length < K_MAX_LENGTH` here because that fails when
	// length is NaN (which is otherwise coerced to zero.)
	if(length>=K_MAX_LENGTH){throw new RangeError('Attempt to allocate Buffer larger than maximum '+'size: 0x'+K_MAX_LENGTH.toString(16)+' bytes');}return length|0;}function SlowBuffer(length){if(+length!=length){// eslint-disable-line eqeqeq
	length=0;}return Buffer.alloc(+length);}Buffer.isBuffer=function isBuffer(b){return b!=null&&b._isBuffer===true&&b!==Buffer.prototype;// so Buffer.isBuffer(Buffer.prototype) will be false
	};Buffer.compare=function compare(a,b){if(isInstance(a,Uint8Array))a=Buffer.from(a,a.offset,a.byteLength);if(isInstance(b,Uint8Array))b=Buffer.from(b,b.offset,b.byteLength);if(!Buffer.isBuffer(a)||!Buffer.isBuffer(b)){throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');}if(a===b)return 0;var x=a.length;var y=b.length;for(var i=0,len=Math.min(x,y);i<len;++i){if(a[i]!==b[i]){x=a[i];y=b[i];break;}}if(x<y)return-1;if(y<x)return 1;return 0;};Buffer.isEncoding=function isEncoding(encoding){switch(String(encoding).toLowerCase()){case'hex':case'utf8':case'utf-8':case'ascii':case'latin1':case'binary':case'base64':case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return true;default:return false;}};Buffer.concat=function concat(list,length){if(!Array.isArray(list)){throw new TypeError('"list" argument must be an Array of Buffers');}if(list.length===0){return Buffer.alloc(0);}var i;if(length===undefined){length=0;for(i=0;i<list.length;++i){length+=list[i].length;}}var buffer=Buffer.allocUnsafe(length);var pos=0;for(i=0;i<list.length;++i){var buf=list[i];if(isInstance(buf,Uint8Array)){buf=Buffer.from(buf);}if(!Buffer.isBuffer(buf)){throw new TypeError('"list" argument must be an Array of Buffers');}buf.copy(buffer,pos);pos+=buf.length;}return buffer;};function byteLength(string,encoding){if(Buffer.isBuffer(string)){return string.length;}if(ArrayBuffer.isView(string)||isInstance(string,ArrayBuffer)){return string.byteLength;}if(typeof string!=='string'){throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. '+'Received type '+_typeof(string));}var len=string.length;var mustMatch=arguments.length>2&&arguments[2]===true;if(!mustMatch&&len===0)return 0;// Use a for loop to avoid recursion
	var loweredCase=false;for(;;){switch(encoding){case'ascii':case'latin1':case'binary':return len;case'utf8':case'utf-8':return utf8ToBytes(string).length;case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return len*2;case'hex':return len>>>1;case'base64':return base64ToBytes(string).length;default:if(loweredCase){return mustMatch?-1:utf8ToBytes(string).length;// assume utf8
	}encoding=(''+encoding).toLowerCase();loweredCase=true;}}}Buffer.byteLength=byteLength;function slowToString(encoding,start,end){var loweredCase=false;// No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	// property of a typed array.
	// This behaves neither like String nor Uint8Array in that we set start/end
	// to their upper/lower bounds if the value passed is out of range.
	// undefined is handled specially as per ECMA-262 6th Edition,
	// Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	if(start===undefined||start<0){start=0;}// Return early if start > this.length. Done here to prevent potential uint32
	// coercion fail below.
	if(start>this.length){return'';}if(end===undefined||end>this.length){end=this.length;}if(end<=0){return'';}// Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	end>>>=0;start>>>=0;if(end<=start){return'';}if(!encoding)encoding='utf8';while(true){switch(encoding){case'hex':return hexSlice(this,start,end);case'utf8':case'utf-8':return utf8Slice(this,start,end);case'ascii':return asciiSlice(this,start,end);case'latin1':case'binary':return latin1Slice(this,start,end);case'base64':return base64Slice(this,start,end);case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return utf16leSlice(this,start,end);default:if(loweredCase)throw new TypeError('Unknown encoding: '+encoding);encoding=(encoding+'').toLowerCase();loweredCase=true;}}}// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
	// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
	// reliably in a browserify context because there could be multiple different
	// copies of the 'buffer' package in use. This method works even for Buffer
	// instances that were created from another copy of the `buffer` package.
	// See: https://github.com/feross/buffer/issues/154
	Buffer.prototype._isBuffer=true;function swap(b,n,m){var i=b[n];b[n]=b[m];b[m]=i;}Buffer.prototype.swap16=function swap16(){var len=this.length;if(len%2!==0){throw new RangeError('Buffer size must be a multiple of 16-bits');}for(var i=0;i<len;i+=2){swap(this,i,i+1);}return this;};Buffer.prototype.swap32=function swap32(){var len=this.length;if(len%4!==0){throw new RangeError('Buffer size must be a multiple of 32-bits');}for(var i=0;i<len;i+=4){swap(this,i,i+3);swap(this,i+1,i+2);}return this;};Buffer.prototype.swap64=function swap64(){var len=this.length;if(len%8!==0){throw new RangeError('Buffer size must be a multiple of 64-bits');}for(var i=0;i<len;i+=8){swap(this,i,i+7);swap(this,i+1,i+6);swap(this,i+2,i+5);swap(this,i+3,i+4);}return this;};Buffer.prototype.toString=function toString(){var length=this.length;if(length===0)return'';if(arguments.length===0)return utf8Slice(this,0,length);return slowToString.apply(this,arguments);};Buffer.prototype.toLocaleString=Buffer.prototype.toString;Buffer.prototype.equals=function equals(b){if(!Buffer.isBuffer(b))throw new TypeError('Argument must be a Buffer');if(this===b)return true;return Buffer.compare(this,b)===0;};Buffer.prototype.inspect=function inspect(){var str='';var max=exports.INSPECT_MAX_BYTES;str=this.toString('hex',0,max).replace(/(.{2})/g,'$1 ').trim();if(this.length>max)str+=' ... ';return'<Buffer '+str+'>';};Buffer.prototype.compare=function compare(target,start,end,thisStart,thisEnd){if(isInstance(target,Uint8Array)){target=Buffer.from(target,target.offset,target.byteLength);}if(!Buffer.isBuffer(target)){throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. '+'Received type '+_typeof(target));}if(start===undefined){start=0;}if(end===undefined){end=target?target.length:0;}if(thisStart===undefined){thisStart=0;}if(thisEnd===undefined){thisEnd=this.length;}if(start<0||end>target.length||thisStart<0||thisEnd>this.length){throw new RangeError('out of range index');}if(thisStart>=thisEnd&&start>=end){return 0;}if(thisStart>=thisEnd){return-1;}if(start>=end){return 1;}start>>>=0;end>>>=0;thisStart>>>=0;thisEnd>>>=0;if(this===target)return 0;var x=thisEnd-thisStart;var y=end-start;var len=Math.min(x,y);var thisCopy=this.slice(thisStart,thisEnd);var targetCopy=target.slice(start,end);for(var i=0;i<len;++i){if(thisCopy[i]!==targetCopy[i]){x=thisCopy[i];y=targetCopy[i];break;}}if(x<y)return-1;if(y<x)return 1;return 0;};// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf(buffer,val,byteOffset,encoding,dir){// Empty buffer means no match
	if(buffer.length===0)return-1;// Normalize byteOffset
	if(typeof byteOffset==='string'){encoding=byteOffset;byteOffset=0;}else if(byteOffset>0x7fffffff){byteOffset=0x7fffffff;}else if(byteOffset<-0x80000000){byteOffset=-0x80000000;}byteOffset=+byteOffset;// Coerce to Number.
	if(numberIsNaN(byteOffset)){// byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	byteOffset=dir?0:buffer.length-1;}// Normalize byteOffset: negative offsets start from the end of the buffer
	if(byteOffset<0)byteOffset=buffer.length+byteOffset;if(byteOffset>=buffer.length){if(dir)return-1;else byteOffset=buffer.length-1;}else if(byteOffset<0){if(dir)byteOffset=0;else return-1;}// Normalize val
	if(typeof val==='string'){val=Buffer.from(val,encoding);}// Finally, search either indexOf (if dir is true) or lastIndexOf
	if(Buffer.isBuffer(val)){// Special case: looking for empty string/buffer always fails
	if(val.length===0){return-1;}return arrayIndexOf(buffer,val,byteOffset,encoding,dir);}else if(typeof val==='number'){val=val&0xFF;// Search for a byte value [0-255]
	if(typeof Uint8Array.prototype.indexOf==='function'){if(dir){return Uint8Array.prototype.indexOf.call(buffer,val,byteOffset);}else{return Uint8Array.prototype.lastIndexOf.call(buffer,val,byteOffset);}}return arrayIndexOf(buffer,[val],byteOffset,encoding,dir);}throw new TypeError('val must be string, number or Buffer');}function arrayIndexOf(arr,val,byteOffset,encoding,dir){var indexSize=1;var arrLength=arr.length;var valLength=val.length;if(encoding!==undefined){encoding=String(encoding).toLowerCase();if(encoding==='ucs2'||encoding==='ucs-2'||encoding==='utf16le'||encoding==='utf-16le'){if(arr.length<2||val.length<2){return-1;}indexSize=2;arrLength/=2;valLength/=2;byteOffset/=2;}}function read(buf,i){if(indexSize===1){return buf[i];}else{return buf.readUInt16BE(i*indexSize);}}var i;if(dir){var foundIndex=-1;for(i=byteOffset;i<arrLength;i++){if(read(arr,i)===read(val,foundIndex===-1?0:i-foundIndex)){if(foundIndex===-1)foundIndex=i;if(i-foundIndex+1===valLength)return foundIndex*indexSize;}else{if(foundIndex!==-1)i-=i-foundIndex;foundIndex=-1;}}}else{if(byteOffset+valLength>arrLength)byteOffset=arrLength-valLength;for(i=byteOffset;i>=0;i--){var found=true;for(var j=0;j<valLength;j++){if(read(arr,i+j)!==read(val,j)){found=false;break;}}if(found)return i;}}return-1;}Buffer.prototype.includes=function includes(val,byteOffset,encoding){return this.indexOf(val,byteOffset,encoding)!==-1;};Buffer.prototype.indexOf=function indexOf(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,true);};Buffer.prototype.lastIndexOf=function lastIndexOf(val,byteOffset,encoding){return bidirectionalIndexOf(this,val,byteOffset,encoding,false);};function hexWrite(buf,string,offset,length){offset=Number(offset)||0;var remaining=buf.length-offset;if(!length){length=remaining;}else{length=Number(length);if(length>remaining){length=remaining;}}var strLen=string.length;if(length>strLen/2){length=strLen/2;}for(var i=0;i<length;++i){var parsed=parseInt(string.substr(i*2,2),16);if(numberIsNaN(parsed))return i;buf[offset+i]=parsed;}return i;}function utf8Write(buf,string,offset,length){return blitBuffer(utf8ToBytes(string,buf.length-offset),buf,offset,length);}function asciiWrite(buf,string,offset,length){return blitBuffer(asciiToBytes(string),buf,offset,length);}function latin1Write(buf,string,offset,length){return asciiWrite(buf,string,offset,length);}function base64Write(buf,string,offset,length){return blitBuffer(base64ToBytes(string),buf,offset,length);}function ucs2Write(buf,string,offset,length){return blitBuffer(utf16leToBytes(string,buf.length-offset),buf,offset,length);}Buffer.prototype.write=function write(string,offset,length,encoding){// Buffer#write(string)
	if(offset===undefined){encoding='utf8';length=this.length;offset=0;// Buffer#write(string, encoding)
	}else if(length===undefined&&typeof offset==='string'){encoding=offset;length=this.length;offset=0;// Buffer#write(string, offset[, length][, encoding])
	}else if(isFinite(offset)){offset=offset>>>0;if(isFinite(length)){length=length>>>0;if(encoding===undefined)encoding='utf8';}else{encoding=length;length=undefined;}}else{throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');}var remaining=this.length-offset;if(length===undefined||length>remaining)length=remaining;if(string.length>0&&(length<0||offset<0)||offset>this.length){throw new RangeError('Attempt to write outside buffer bounds');}if(!encoding)encoding='utf8';var loweredCase=false;for(;;){switch(encoding){case'hex':return hexWrite(this,string,offset,length);case'utf8':case'utf-8':return utf8Write(this,string,offset,length);case'ascii':return asciiWrite(this,string,offset,length);case'latin1':case'binary':return latin1Write(this,string,offset,length);case'base64':// Warning: maxLength not taken into account in base64Write
	return base64Write(this,string,offset,length);case'ucs2':case'ucs-2':case'utf16le':case'utf-16le':return ucs2Write(this,string,offset,length);default:if(loweredCase)throw new TypeError('Unknown encoding: '+encoding);encoding=(''+encoding).toLowerCase();loweredCase=true;}}};Buffer.prototype.toJSON=function toJSON(){return{type:'Buffer',data:Array.prototype.slice.call(this._arr||this,0)};};function base64Slice(buf,start,end){if(start===0&&end===buf.length){return base64.fromByteArray(buf);}else{return base64.fromByteArray(buf.slice(start,end));}}function utf8Slice(buf,start,end){end=Math.min(buf.length,end);var res=[];var i=start;while(i<end){var firstByte=buf[i];var codePoint=null;var bytesPerSequence=firstByte>0xEF?4:firstByte>0xDF?3:firstByte>0xBF?2:1;if(i+bytesPerSequence<=end){var secondByte,thirdByte,fourthByte,tempCodePoint;switch(bytesPerSequence){case 1:if(firstByte<0x80){codePoint=firstByte;}break;case 2:secondByte=buf[i+1];if((secondByte&0xC0)===0x80){tempCodePoint=(firstByte&0x1F)<<0x6|secondByte&0x3F;if(tempCodePoint>0x7F){codePoint=tempCodePoint;}}break;case 3:secondByte=buf[i+1];thirdByte=buf[i+2];if((secondByte&0xC0)===0x80&&(thirdByte&0xC0)===0x80){tempCodePoint=(firstByte&0xF)<<0xC|(secondByte&0x3F)<<0x6|thirdByte&0x3F;if(tempCodePoint>0x7FF&&(tempCodePoint<0xD800||tempCodePoint>0xDFFF)){codePoint=tempCodePoint;}}break;case 4:secondByte=buf[i+1];thirdByte=buf[i+2];fourthByte=buf[i+3];if((secondByte&0xC0)===0x80&&(thirdByte&0xC0)===0x80&&(fourthByte&0xC0)===0x80){tempCodePoint=(firstByte&0xF)<<0x12|(secondByte&0x3F)<<0xC|(thirdByte&0x3F)<<0x6|fourthByte&0x3F;if(tempCodePoint>0xFFFF&&tempCodePoint<0x110000){codePoint=tempCodePoint;}}}}if(codePoint===null){// we did not generate a valid codePoint so insert a
	// replacement char (U+FFFD) and advance only 1 byte
	codePoint=0xFFFD;bytesPerSequence=1;}else if(codePoint>0xFFFF){// encode to utf16 (surrogate pair dance)
	codePoint-=0x10000;res.push(codePoint>>>10&0x3FF|0xD800);codePoint=0xDC00|codePoint&0x3FF;}res.push(codePoint);i+=bytesPerSequence;}return decodeCodePointsArray(res);}// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH=0x1000;function decodeCodePointsArray(codePoints){var len=codePoints.length;if(len<=MAX_ARGUMENTS_LENGTH){return String.fromCharCode.apply(String,codePoints);// avoid extra slice()
	}// Decode in chunks to avoid "call stack size exceeded".
	var res='';var i=0;while(i<len){res+=String.fromCharCode.apply(String,codePoints.slice(i,i+=MAX_ARGUMENTS_LENGTH));}return res;}function asciiSlice(buf,start,end){var ret='';end=Math.min(buf.length,end);for(var i=start;i<end;++i){ret+=String.fromCharCode(buf[i]&0x7F);}return ret;}function latin1Slice(buf,start,end){var ret='';end=Math.min(buf.length,end);for(var i=start;i<end;++i){ret+=String.fromCharCode(buf[i]);}return ret;}function hexSlice(buf,start,end){var len=buf.length;if(!start||start<0)start=0;if(!end||end<0||end>len)end=len;var out='';for(var i=start;i<end;++i){out+=toHex(buf[i]);}return out;}function utf16leSlice(buf,start,end){var bytes=buf.slice(start,end);var res='';for(var i=0;i<bytes.length;i+=2){res+=String.fromCharCode(bytes[i]+bytes[i+1]*256);}return res;}Buffer.prototype.slice=function slice(start,end){var len=this.length;start=~~start;end=end===undefined?len:~~end;if(start<0){start+=len;if(start<0)start=0;}else if(start>len){start=len;}if(end<0){end+=len;if(end<0)end=0;}else if(end>len){end=len;}if(end<start)end=start;var newBuf=this.subarray(start,end);// Return an augmented `Uint8Array` instance
	newBuf.__proto__=Buffer.prototype;return newBuf;};/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */function checkOffset(offset,ext,length){if(offset%1!==0||offset<0)throw new RangeError('offset is not uint');if(offset+ext>length)throw new RangeError('Trying to access beyond buffer length');}Buffer.prototype.readUIntLE=function readUIntLE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var val=this[offset];var mul=1;var i=0;while(++i<byteLength&&(mul*=0x100)){val+=this[offset+i]*mul;}return val;};Buffer.prototype.readUIntBE=function readUIntBE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){checkOffset(offset,byteLength,this.length);}var val=this[offset+--byteLength];var mul=1;while(byteLength>0&&(mul*=0x100)){val+=this[offset+--byteLength]*mul;}return val;};Buffer.prototype.readUInt8=function readUInt8(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,1,this.length);return this[offset];};Buffer.prototype.readUInt16LE=function readUInt16LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);return this[offset]|this[offset+1]<<8;};Buffer.prototype.readUInt16BE=function readUInt16BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);return this[offset]<<8|this[offset+1];};Buffer.prototype.readUInt32LE=function readUInt32LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return(this[offset]|this[offset+1]<<8|this[offset+2]<<16)+this[offset+3]*0x1000000;};Buffer.prototype.readUInt32BE=function readUInt32BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]*0x1000000+(this[offset+1]<<16|this[offset+2]<<8|this[offset+3]);};Buffer.prototype.readIntLE=function readIntLE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var val=this[offset];var mul=1;var i=0;while(++i<byteLength&&(mul*=0x100)){val+=this[offset+i]*mul;}mul*=0x80;if(val>=mul)val-=Math.pow(2,8*byteLength);return val;};Buffer.prototype.readIntBE=function readIntBE(offset,byteLength,noAssert){offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert)checkOffset(offset,byteLength,this.length);var i=byteLength;var mul=1;var val=this[offset+--i];while(i>0&&(mul*=0x100)){val+=this[offset+--i]*mul;}mul*=0x80;if(val>=mul)val-=Math.pow(2,8*byteLength);return val;};Buffer.prototype.readInt8=function readInt8(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,1,this.length);if(!(this[offset]&0x80))return this[offset];return(0xff-this[offset]+1)*-1;};Buffer.prototype.readInt16LE=function readInt16LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);var val=this[offset]|this[offset+1]<<8;return val&0x8000?val|0xFFFF0000:val;};Buffer.prototype.readInt16BE=function readInt16BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,2,this.length);var val=this[offset+1]|this[offset]<<8;return val&0x8000?val|0xFFFF0000:val;};Buffer.prototype.readInt32LE=function readInt32LE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]|this[offset+1]<<8|this[offset+2]<<16|this[offset+3]<<24;};Buffer.prototype.readInt32BE=function readInt32BE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return this[offset]<<24|this[offset+1]<<16|this[offset+2]<<8|this[offset+3];};Buffer.prototype.readFloatLE=function readFloatLE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return ieee754.read(this,offset,true,23,4);};Buffer.prototype.readFloatBE=function readFloatBE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,4,this.length);return ieee754.read(this,offset,false,23,4);};Buffer.prototype.readDoubleLE=function readDoubleLE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,8,this.length);return ieee754.read(this,offset,true,52,8);};Buffer.prototype.readDoubleBE=function readDoubleBE(offset,noAssert){offset=offset>>>0;if(!noAssert)checkOffset(offset,8,this.length);return ieee754.read(this,offset,false,52,8);};function checkInt(buf,value,offset,ext,max,min){if(!Buffer.isBuffer(buf))throw new TypeError('"buffer" argument must be a Buffer instance');if(value>max||value<min)throw new RangeError('"value" argument is out of bounds');if(offset+ext>buf.length)throw new RangeError('Index out of range');}Buffer.prototype.writeUIntLE=function writeUIntLE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){var maxBytes=Math.pow(2,8*byteLength)-1;checkInt(this,value,offset,byteLength,maxBytes,0);}var mul=1;var i=0;this[offset]=value&0xFF;while(++i<byteLength&&(mul*=0x100)){this[offset+i]=value/mul&0xFF;}return offset+byteLength;};Buffer.prototype.writeUIntBE=function writeUIntBE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;byteLength=byteLength>>>0;if(!noAssert){var maxBytes=Math.pow(2,8*byteLength)-1;checkInt(this,value,offset,byteLength,maxBytes,0);}var i=byteLength-1;var mul=1;this[offset+i]=value&0xFF;while(--i>=0&&(mul*=0x100)){this[offset+i]=value/mul&0xFF;}return offset+byteLength;};Buffer.prototype.writeUInt8=function writeUInt8(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,1,0xff,0);this[offset]=value&0xff;return offset+1;};Buffer.prototype.writeUInt16LE=function writeUInt16LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0xffff,0);this[offset]=value&0xff;this[offset+1]=value>>>8;return offset+2;};Buffer.prototype.writeUInt16BE=function writeUInt16BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0xffff,0);this[offset]=value>>>8;this[offset+1]=value&0xff;return offset+2;};Buffer.prototype.writeUInt32LE=function writeUInt32LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0xffffffff,0);this[offset+3]=value>>>24;this[offset+2]=value>>>16;this[offset+1]=value>>>8;this[offset]=value&0xff;return offset+4;};Buffer.prototype.writeUInt32BE=function writeUInt32BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0xffffffff,0);this[offset]=value>>>24;this[offset+1]=value>>>16;this[offset+2]=value>>>8;this[offset+3]=value&0xff;return offset+4;};Buffer.prototype.writeIntLE=function writeIntLE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;if(!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit);}var i=0;var mul=1;var sub=0;this[offset]=value&0xFF;while(++i<byteLength&&(mul*=0x100)){if(value<0&&sub===0&&this[offset+i-1]!==0){sub=1;}this[offset+i]=(value/mul>>0)-sub&0xFF;}return offset+byteLength;};Buffer.prototype.writeIntBE=function writeIntBE(value,offset,byteLength,noAssert){value=+value;offset=offset>>>0;if(!noAssert){var limit=Math.pow(2,8*byteLength-1);checkInt(this,value,offset,byteLength,limit-1,-limit);}var i=byteLength-1;var mul=1;var sub=0;this[offset+i]=value&0xFF;while(--i>=0&&(mul*=0x100)){if(value<0&&sub===0&&this[offset+i+1]!==0){sub=1;}this[offset+i]=(value/mul>>0)-sub&0xFF;}return offset+byteLength;};Buffer.prototype.writeInt8=function writeInt8(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,1,0x7f,-0x80);if(value<0)value=0xff+value+1;this[offset]=value&0xff;return offset+1;};Buffer.prototype.writeInt16LE=function writeInt16LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0x7fff,-0x8000);this[offset]=value&0xff;this[offset+1]=value>>>8;return offset+2;};Buffer.prototype.writeInt16BE=function writeInt16BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,2,0x7fff,-0x8000);this[offset]=value>>>8;this[offset+1]=value&0xff;return offset+2;};Buffer.prototype.writeInt32LE=function writeInt32LE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0x7fffffff,-0x80000000);this[offset]=value&0xff;this[offset+1]=value>>>8;this[offset+2]=value>>>16;this[offset+3]=value>>>24;return offset+4;};Buffer.prototype.writeInt32BE=function writeInt32BE(value,offset,noAssert){value=+value;offset=offset>>>0;if(!noAssert)checkInt(this,value,offset,4,0x7fffffff,-0x80000000);if(value<0)value=0xffffffff+value+1;this[offset]=value>>>24;this[offset+1]=value>>>16;this[offset+2]=value>>>8;this[offset+3]=value&0xff;return offset+4;};function checkIEEE754(buf,value,offset,ext,max,min){if(offset+ext>buf.length)throw new RangeError('Index out of range');if(offset<0)throw new RangeError('Index out of range');}function writeFloat(buf,value,offset,littleEndian,noAssert){value=+value;offset=offset>>>0;if(!noAssert){checkIEEE754(buf,value,offset,4,3.4028234663852886e+38,-3.4028234663852886e+38);}ieee754.write(buf,value,offset,littleEndian,23,4);return offset+4;}Buffer.prototype.writeFloatLE=function writeFloatLE(value,offset,noAssert){return writeFloat(this,value,offset,true,noAssert);};Buffer.prototype.writeFloatBE=function writeFloatBE(value,offset,noAssert){return writeFloat(this,value,offset,false,noAssert);};function writeDouble(buf,value,offset,littleEndian,noAssert){value=+value;offset=offset>>>0;if(!noAssert){checkIEEE754(buf,value,offset,8,1.7976931348623157E+308,-1.7976931348623157E+308);}ieee754.write(buf,value,offset,littleEndian,52,8);return offset+8;}Buffer.prototype.writeDoubleLE=function writeDoubleLE(value,offset,noAssert){return writeDouble(this,value,offset,true,noAssert);};Buffer.prototype.writeDoubleBE=function writeDoubleBE(value,offset,noAssert){return writeDouble(this,value,offset,false,noAssert);};// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy=function copy(target,targetStart,start,end){if(!Buffer.isBuffer(target))throw new TypeError('argument should be a Buffer');if(!start)start=0;if(!end&&end!==0)end=this.length;if(targetStart>=target.length)targetStart=target.length;if(!targetStart)targetStart=0;if(end>0&&end<start)end=start;// Copy 0 bytes; we're done
	if(end===start)return 0;if(target.length===0||this.length===0)return 0;// Fatal error conditions
	if(targetStart<0){throw new RangeError('targetStart out of bounds');}if(start<0||start>=this.length)throw new RangeError('Index out of range');if(end<0)throw new RangeError('sourceEnd out of bounds');// Are we oob?
	if(end>this.length)end=this.length;if(target.length-targetStart<end-start){end=target.length-targetStart+start;}var len=end-start;if(this===target&&typeof Uint8Array.prototype.copyWithin==='function'){// Use built-in when available, missing from IE11
	this.copyWithin(targetStart,start,end);}else if(this===target&&start<targetStart&&targetStart<end){// descending copy from end
	for(var i=len-1;i>=0;--i){target[i+targetStart]=this[i+start];}}else{Uint8Array.prototype.set.call(target,this.subarray(start,end),targetStart);}return len;};// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill=function fill(val,start,end,encoding){// Handle string cases:
	if(typeof val==='string'){if(typeof start==='string'){encoding=start;start=0;end=this.length;}else if(typeof end==='string'){encoding=end;end=this.length;}if(encoding!==undefined&&typeof encoding!=='string'){throw new TypeError('encoding must be a string');}if(typeof encoding==='string'&&!Buffer.isEncoding(encoding)){throw new TypeError('Unknown encoding: '+encoding);}if(val.length===1){var code=val.charCodeAt(0);if(encoding==='utf8'&&code<128||encoding==='latin1'){// Fast path: If `val` fits into a single byte, use that numeric value.
	val=code;}}}else if(typeof val==='number'){val=val&255;}// Invalid ranges are not set to a default, so can range check early.
	if(start<0||this.length<start||this.length<end){throw new RangeError('Out of range index');}if(end<=start){return this;}start=start>>>0;end=end===undefined?this.length:end>>>0;if(!val)val=0;var i;if(typeof val==='number'){for(i=start;i<end;++i){this[i]=val;}}else{var bytes=Buffer.isBuffer(val)?val:Buffer.from(val,encoding);var len=bytes.length;if(len===0){throw new TypeError('The value "'+val+'" is invalid for argument "value"');}for(i=0;i<end-start;++i){this[i+start]=bytes[i%len];}}return this;};// HELPER FUNCTIONS
	// ================
	var INVALID_BASE64_RE=/[^+/0-9A-Za-z-_]/g;function base64clean(str){// Node takes equal signs as end of the Base64 encoding
	str=str.split('=')[0];// Node strips out invalid characters like \n and \t from the string, base64-js does not
	str=str.trim().replace(INVALID_BASE64_RE,'');// Node converts strings with length < 2 to ''
	if(str.length<2)return'';// Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	while(str.length%4!==0){str=str+'=';}return str;}function toHex(n){if(n<16)return'0'+n.toString(16);return n.toString(16);}function utf8ToBytes(string,units){units=units||Infinity;var codePoint;var length=string.length;var leadSurrogate=null;var bytes=[];for(var i=0;i<length;++i){codePoint=string.charCodeAt(i);// is surrogate component
	if(codePoint>0xD7FF&&codePoint<0xE000){// last char was a lead
	if(!leadSurrogate){// no lead yet
	if(codePoint>0xDBFF){// unexpected trail
	if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);continue;}else if(i+1===length){// unpaired lead
	if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);continue;}// valid lead
	leadSurrogate=codePoint;continue;}// 2 leads in a row
	if(codePoint<0xDC00){if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);leadSurrogate=codePoint;continue;}// valid surrogate pair
	codePoint=(leadSurrogate-0xD800<<10|codePoint-0xDC00)+0x10000;}else if(leadSurrogate){// valid bmp char, but last char was a lead
	if((units-=3)>-1)bytes.push(0xEF,0xBF,0xBD);}leadSurrogate=null;// encode utf8
	if(codePoint<0x80){if((units-=1)<0)break;bytes.push(codePoint);}else if(codePoint<0x800){if((units-=2)<0)break;bytes.push(codePoint>>0x6|0xC0,codePoint&0x3F|0x80);}else if(codePoint<0x10000){if((units-=3)<0)break;bytes.push(codePoint>>0xC|0xE0,codePoint>>0x6&0x3F|0x80,codePoint&0x3F|0x80);}else if(codePoint<0x110000){if((units-=4)<0)break;bytes.push(codePoint>>0x12|0xF0,codePoint>>0xC&0x3F|0x80,codePoint>>0x6&0x3F|0x80,codePoint&0x3F|0x80);}else{throw new Error('Invalid code point');}}return bytes;}function asciiToBytes(str){var byteArray=[];for(var i=0;i<str.length;++i){// Node's code seems to be doing this and not & 0x7F..
	byteArray.push(str.charCodeAt(i)&0xFF);}return byteArray;}function utf16leToBytes(str,units){var c,hi,lo;var byteArray=[];for(var i=0;i<str.length;++i){if((units-=2)<0)break;c=str.charCodeAt(i);hi=c>>8;lo=c%256;byteArray.push(lo);byteArray.push(hi);}return byteArray;}function base64ToBytes(str){return base64.toByteArray(base64clean(str));}function blitBuffer(src,dst,offset,length){for(var i=0;i<length;++i){if(i+offset>=dst.length||i>=src.length)break;dst[i+offset]=src[i];}return i;}// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
	// the `instanceof` check but they should be treated as of that type.
	// See: https://github.com/feross/buffer/issues/166
	function isInstance(obj,type){return obj instanceof type||obj!=null&&obj.constructor!=null&&obj.constructor.name!=null&&obj.constructor.name===type.name;}function numberIsNaN(obj){// For IE11 support
	return obj!==obj;// eslint-disable-line no-self-compare
	}}).call(this,require("buffer").Buffer);},{"base64-js":1,"buffer":3,"ieee754":32}],4:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.attributeNames=exports.elementNames=void 0;exports.elementNames=new Map([["altglyph","altGlyph"],["altglyphdef","altGlyphDef"],["altglyphitem","altGlyphItem"],["animatecolor","animateColor"],["animatemotion","animateMotion"],["animatetransform","animateTransform"],["clippath","clipPath"],["feblend","feBlend"],["fecolormatrix","feColorMatrix"],["fecomponenttransfer","feComponentTransfer"],["fecomposite","feComposite"],["feconvolvematrix","feConvolveMatrix"],["fediffuselighting","feDiffuseLighting"],["fedisplacementmap","feDisplacementMap"],["fedistantlight","feDistantLight"],["fedropshadow","feDropShadow"],["feflood","feFlood"],["fefunca","feFuncA"],["fefuncb","feFuncB"],["fefuncg","feFuncG"],["fefuncr","feFuncR"],["fegaussianblur","feGaussianBlur"],["feimage","feImage"],["femerge","feMerge"],["femergenode","feMergeNode"],["femorphology","feMorphology"],["feoffset","feOffset"],["fepointlight","fePointLight"],["fespecularlighting","feSpecularLighting"],["fespotlight","feSpotLight"],["fetile","feTile"],["feturbulence","feTurbulence"],["foreignobject","foreignObject"],["glyphref","glyphRef"],["lineargradient","linearGradient"],["radialgradient","radialGradient"],["textpath","textPath"]]);exports.attributeNames=new Map([["definitionurl","definitionURL"],["attributename","attributeName"],["attributetype","attributeType"],["basefrequency","baseFrequency"],["baseprofile","baseProfile"],["calcmode","calcMode"],["clippathunits","clipPathUnits"],["diffuseconstant","diffuseConstant"],["edgemode","edgeMode"],["filterunits","filterUnits"],["glyphref","glyphRef"],["gradienttransform","gradientTransform"],["gradientunits","gradientUnits"],["kernelmatrix","kernelMatrix"],["kernelunitlength","kernelUnitLength"],["keypoints","keyPoints"],["keysplines","keySplines"],["keytimes","keyTimes"],["lengthadjust","lengthAdjust"],["limitingconeangle","limitingConeAngle"],["markerheight","markerHeight"],["markerunits","markerUnits"],["markerwidth","markerWidth"],["maskcontentunits","maskContentUnits"],["maskunits","maskUnits"],["numoctaves","numOctaves"],["pathlength","pathLength"],["patterncontentunits","patternContentUnits"],["patterntransform","patternTransform"],["patternunits","patternUnits"],["pointsatx","pointsAtX"],["pointsaty","pointsAtY"],["pointsatz","pointsAtZ"],["preservealpha","preserveAlpha"],["preserveaspectratio","preserveAspectRatio"],["primitiveunits","primitiveUnits"],["refx","refX"],["refy","refY"],["repeatcount","repeatCount"],["repeatdur","repeatDur"],["requiredextensions","requiredExtensions"],["requiredfeatures","requiredFeatures"],["specularconstant","specularConstant"],["specularexponent","specularExponent"],["spreadmethod","spreadMethod"],["startoffset","startOffset"],["stddeviation","stdDeviation"],["stitchtiles","stitchTiles"],["surfacescale","surfaceScale"],["systemlanguage","systemLanguage"],["tablevalues","tableValues"],["targetx","targetX"],["targety","targetY"],["textlength","textLength"],["viewbox","viewBox"],["viewtarget","viewTarget"],["xchannelselector","xChannelSelector"],["ychannelselector","yChannelSelector"],["zoomandpan","zoomAndPan"]]);},{}],5:[function(require,module,exports){"use strict";var __assign=this&&this.__assign||function(){__assign=Object.assign||function(t){for(var s,i=1,n=arguments.length;i<n;i++){s=arguments[i];for(var p in s){if(Object.prototype.hasOwnProperty.call(s,p))t[p]=s[p];}}return t;};return __assign.apply(this,arguments);};var __createBinding=this&&this.__createBinding||(Object.create?function(o,m,k,k2){if(k2===undefined)k2=k;Object.defineProperty(o,k2,{enumerable:true,get:function get(){return m[k];}});}:function(o,m,k,k2){if(k2===undefined)k2=k;o[k2]=m[k];});var __setModuleDefault=this&&this.__setModuleDefault||(Object.create?function(o,v){Object.defineProperty(o,"default",{enumerable:true,value:v});}:function(o,v){o["default"]=v;});var __importStar=this&&this.__importStar||function(mod){if(mod&&mod.__esModule)return mod;var result={};if(mod!=null)for(var k in mod){if(k!=="default"&&Object.prototype.hasOwnProperty.call(mod,k))__createBinding(result,mod,k);}__setModuleDefault(result,mod);return result;};Object.defineProperty(exports,"__esModule",{value:true});/*
	 * Module dependencies
	 */var ElementType=__importStar(require("domelementtype"));var entities_1=require("entities");/*
	 * Mixed-case SVG and MathML tags & attributes
	 * recognized by the HTML parser, see
	 * https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
	 */var foreignNames_1=require("./foreignNames");var unencodedElements=new Set(["style","script","xmp","iframe","noembed","noframes","plaintext","noscript"]);/**
	 * Format attributes
	 */function formatAttributes(attributes,opts){if(!attributes)return;return Object.keys(attributes).map(function(key){var _a,_b;var value=(_a=attributes[key])!==null&&_a!==void 0?_a:"";if(opts.xmlMode==="foreign"){/* Fix up mixed-case attribute names */key=(_b=foreignNames_1.attributeNames.get(key))!==null&&_b!==void 0?_b:key;}if(!opts.emptyAttrs&&!opts.xmlMode&&value===""){return key;}return key+"=\""+(opts.decodeEntities?entities_1.encodeXML(value):value.replace(/"/g,"&quot;"))+"\"";}).join(" ");}/**
	 * Self-enclosing tags
	 */var singleTag=new Set(["area","base","basefont","br","col","command","embed","frame","hr","img","input","isindex","keygen","link","meta","param","source","track","wbr"]);/**
	 * Renders a DOM node or an array of DOM nodes to a string.
	 *
	 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
	 *
	 * @param node Node to be rendered.
	 * @param options Changes serialization behavior
	 */function render(node,options){if(options===void 0){options={};}// TODO: This is a bit hacky.
	var nodes=Array.isArray(node)||node.cheerio?node:[node];var output="";for(var i=0;i<nodes.length;i++){output+=renderNode(nodes[i],options);}return output;}exports["default"]=render;function renderNode(node,options){switch(node.type){case"root":return render(node.children,options);case ElementType.Directive:return renderDirective(node);case ElementType.Comment:return renderComment(node);case ElementType.CDATA:return renderCdata(node);default:return ElementType.isTag(node)?renderTag(node,options):renderText(node,options);}}var foreignModeIntegrationPoints=new Set(["mi","mo","mn","ms","mtext","annotation-xml","foreignObject","desc","title"]);var foreignElements=new Set(["svg","math"]);function renderTag(elem,opts){var _a;// Handle SVG / MathML in HTML
	if(opts.xmlMode==="foreign"){/* Fix up mixed-case element names */elem.name=(_a=foreignNames_1.elementNames.get(elem.name))!==null&&_a!==void 0?_a:elem.name;/* Exit foreign mode at integration points */if(elem.parent&&foreignModeIntegrationPoints.has(elem.parent.name)){opts=__assign(__assign({},opts),{xmlMode:false});}}if(!opts.xmlMode&&foreignElements.has(elem.name)){opts=__assign(__assign({},opts),{xmlMode:"foreign"});}var tag="<"+elem.name;var attribs=formatAttributes(elem.attribs,opts);if(attribs){tag+=" "+attribs;}if(elem.children.length===0&&(opts.xmlMode?// In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
	opts.selfClosingTags!==false:// User explicitly asked for self-closing tags, even in HTML mode
	opts.selfClosingTags&&singleTag.has(elem.name))){if(!opts.xmlMode)tag+=" ";tag+="/>";}else{tag+=">";if(elem.children.length>0){tag+=render(elem.children,opts);}if(opts.xmlMode||!singleTag.has(elem.name)){tag+="</"+elem.name+">";}}return tag;}function renderDirective(elem){return"<"+elem.data+">";}function renderText(elem,opts){var data=elem.data||"";// If entities weren't decoded, no need to encode them back
	if(opts.decodeEntities&&!(elem.parent&&unencodedElements.has(elem.parent.name))){data=entities_1.encodeXML(data);}return data;}function renderCdata(elem){return"<![CDATA["+elem.children[0].data+"]]>";}function renderComment(elem){return"<!--"+elem.data+"-->";}},{"./foreignNames":4,"domelementtype":6,"entities":20}],6:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.Doctype=exports.CDATA=exports.Tag=exports.Style=exports.Script=exports.Comment=exports.Directive=exports.Text=exports.isTag=void 0;/**
	 * Tests whether an element is a tag or not.
	 *
	 * @param elem Element to test
	 */function isTag(elem){return elem.type==="tag"/* Tag */||elem.type==="script"/* Script */||elem.type==="style"/* Style */;}exports.isTag=isTag;// Exports for backwards compatibility
	/** Type for Text */exports.Text="text"/* Text */;/** Type for <? ... ?> */exports.Directive="directive"/* Directive */;/** Type for <!-- ... --> */exports.Comment="comment"/* Comment */;/** Type for <script> tags */exports.Script="script"/* Script */;/** Type for <style> tags */exports.Style="style"/* Style */;/** Type for Any tag */exports.Tag="tag"/* Tag */;/** Type for <![CDATA[ ... ]]> */exports.CDATA="cdata"/* CDATA */;/** Type for <!doctype ...> */exports.Doctype="doctype"/* Doctype */;},{}],7:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});var node_1=require("./node");exports.Node=node_1.Node;exports.Element=node_1.Element;exports.DataNode=node_1.DataNode;exports.NodeWithChildren=node_1.NodeWithChildren;var reWhitespace=/\s+/g;// Default options
	var defaultOpts={normalizeWhitespace:false,withStartIndices:false,withEndIndices:false};var DomHandler=/** @class */function(){/**
	     * Initiate a new DomHandler.
	     *
	     * @param callback Called once parsing has completed.
	     * @param options Settings for the handler.
	     * @param elementCB Callback whenever a tag is closed.
	     */function DomHandler(callback,options,elementCB){/** The constructed DOM */this.dom=[];/** Indicated whether parsing has been completed. */this._done=false;/** Stack of open tags. */this._tagStack=[];/** A data node that is still being written to. */this._lastNode=null;/** Reference to the parser instance. Used for location information. */this._parser=null;// Make it possible to skip arguments, for backwards-compatibility
	if(typeof options==="function"){elementCB=options;options=defaultOpts;}if(_typeof(callback)==="object"){options=callback;callback=undefined;}this._callback=callback||null;this._options=options||defaultOpts;this._elementCB=elementCB||null;}DomHandler.prototype.onparserinit=function(parser){this._parser=parser;};// Resets the handler back to starting state
	DomHandler.prototype.onreset=function(){this.dom=[];this._done=false;this._tagStack=[];this._lastNode=null;this._parser=this._parser||null;};// Signals the handler that parsing is done
	DomHandler.prototype.onend=function(){if(this._done)return;this._done=true;this._parser=null;this.handleCallback(null);};DomHandler.prototype.onerror=function(error){this.handleCallback(error);};DomHandler.prototype.onclosetag=function(){this._lastNode=null;// If(this._tagStack.pop().name !== name) this.handleCallback(Error("Tagname didn't match!"));
	var elem=this._tagStack.pop();if(!elem||!this._parser){return;}if(this._options.withEndIndices){elem.endIndex=this._parser.endIndex;}if(this._elementCB)this._elementCB(elem);};DomHandler.prototype.onopentag=function(name,attribs){var element=new node_1.Element(name,attribs);this.addNode(element);this._tagStack.push(element);};DomHandler.prototype.ontext=function(data){var normalize=this._options.normalizeWhitespace;var _lastNode=this._lastNode;if(_lastNode&&_lastNode.type==="text"/* Text */){if(normalize){_lastNode.data=(_lastNode.data+data).replace(reWhitespace," ");}else{_lastNode.data+=data;}}else{if(normalize){data=data.replace(reWhitespace," ");}var node=new node_1.DataNode("text"/* Text */,data);this.addNode(node);this._lastNode=node;}};DomHandler.prototype.oncomment=function(data){if(this._lastNode&&this._lastNode.type==="comment"/* Comment */){this._lastNode.data+=data;return;}var node=new node_1.DataNode("comment"/* Comment */,data);this.addNode(node);this._lastNode=node;};DomHandler.prototype.oncommentend=function(){this._lastNode=null;};DomHandler.prototype.oncdatastart=function(){var text=new node_1.DataNode("text"/* Text */,"");var node=new node_1.NodeWithChildren("cdata"/* CDATA */,[text]);this.addNode(node);text.parent=node;this._lastNode=text;};DomHandler.prototype.oncdataend=function(){this._lastNode=null;};DomHandler.prototype.onprocessinginstruction=function(name,data){var node=new node_1.ProcessingInstruction(name,data);this.addNode(node);};DomHandler.prototype.handleCallback=function(error){if(typeof this._callback==="function"){this._callback(error,this.dom);}else if(error){throw error;}};DomHandler.prototype.addNode=function(node){var parent=this._tagStack[this._tagStack.length-1];var siblings=parent?parent.children:this.dom;var previousSibling=siblings[siblings.length-1];if(this._parser){if(this._options.withStartIndices){node.startIndex=this._parser.startIndex;}if(this._options.withEndIndices){node.endIndex=this._parser.endIndex;}}siblings.push(node);if(previousSibling){node.prev=previousSibling;previousSibling.next=node;}if(parent){node.parent=parent;}this._lastNode=null;};DomHandler.prototype.addDataNode=function(node){this.addNode(node);this._lastNode=node;};return DomHandler;}();exports.DomHandler=DomHandler;exports["default"]=DomHandler;},{"./node":8}],8:[function(require,module,exports){"use strict";var __extends=this&&this.__extends||function(){var _extendStatics=function extendStatics(d,b){_extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b;}||function(d,b){for(var p in b){if(b.hasOwnProperty(p))d[p]=b[p];}};return _extendStatics(d,b);};return function(d,b){_extendStatics(d,b);function __(){this.constructor=d;}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __());};}();Object.defineProperty(exports,"__esModule",{value:true});var nodeTypes=new Map([["tag"/* Tag */,1],["script"/* Script */,1],["style"/* Style */,1],["directive"/* Directive */,1],["text"/* Text */,3],["cdata"/* CDATA */,4],["comment"/* Comment */,8]]);// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var Node=/** @class */function(){/**
	     *
	     * @param type The type of the node.
	     */function Node(type){this.type=type;/** Parent of the node */this.parent=null;/** Previous sibling */this.prev=null;/** Next sibling */this.next=null;/** The start index of the node. Requires `withStartIndices` on the handler to be `true. */this.startIndex=null;/** The end index of the node. Requires `withEndIndices` on the handler to be `true. */this.endIndex=null;}Object.defineProperty(Node.prototype,"nodeType",{// Read-only aliases
	get:function get(){return nodeTypes.get(this.type)||1;},enumerable:true,configurable:true});Object.defineProperty(Node.prototype,"parentNode",{// Read-write aliases for properties
	get:function get(){return this.parent||null;},set:function set(parent){this.parent=parent;},enumerable:true,configurable:true});Object.defineProperty(Node.prototype,"previousSibling",{get:function get(){return this.prev||null;},set:function set(prev){this.prev=prev;},enumerable:true,configurable:true});Object.defineProperty(Node.prototype,"nextSibling",{get:function get(){return this.next||null;},set:function set(next){this.next=next;},enumerable:true,configurable:true});return Node;}();exports.Node=Node;var DataNode=/** @class */function(_super){__extends(DataNode,_super);/**
	     *
	     * @param type The type of the node
	     * @param data The content of the data node
	     */function DataNode(type,data){var _this=_super.call(this,type)||this;_this.data=data;return _this;}Object.defineProperty(DataNode.prototype,"nodeValue",{get:function get(){return this.data;},set:function set(data){this.data=data;},enumerable:true,configurable:true});return DataNode;}(Node);exports.DataNode=DataNode;var ProcessingInstruction=/** @class */function(_super){__extends(ProcessingInstruction,_super);function ProcessingInstruction(name,data){var _this=_super.call(this,"directive"/* Directive */,data)||this;_this.name=name;return _this;}return ProcessingInstruction;}(DataNode);exports.ProcessingInstruction=ProcessingInstruction;var NodeWithChildren=/** @class */function(_super){__extends(NodeWithChildren,_super);/**
	     *
	     * @param type Type of the node.
	     * @param children Children of the node. Only certain node types can have children.
	     */function NodeWithChildren(type,children){var _this=_super.call(this,type)||this;_this.children=children;return _this;}Object.defineProperty(NodeWithChildren.prototype,"firstChild",{// Aliases
	get:function get(){return this.children[0]||null;},enumerable:true,configurable:true});Object.defineProperty(NodeWithChildren.prototype,"lastChild",{get:function get(){return this.children[this.children.length-1]||null;},enumerable:true,configurable:true});Object.defineProperty(NodeWithChildren.prototype,"childNodes",{get:function get(){return this.children;},set:function set(children){this.children=children;},enumerable:true,configurable:true});return NodeWithChildren;}(Node);exports.NodeWithChildren=NodeWithChildren;var Element=/** @class */function(_super){__extends(Element,_super);/**
	     *
	     * @param name Name of the tag, eg. `div`, `span`
	     * @param attribs Object mapping attribute names to attribute values
	     */function Element(name,attribs){var _this=_super.call(this,name==="script"?"script"/* Script */:name==="style"?"style"/* Style */:"tag"/* Tag */,[])||this;_this.name=name;_this.attribs=attribs;_this.attribs=attribs;return _this;}Object.defineProperty(Element.prototype,"tagName",{// DOM Level 1 aliases
	get:function get(){return this.name;},set:function set(name){this.name=name;},enumerable:true,configurable:true});return Element;}(NodeWithChildren);exports.Element=Element;},{}],9:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.uniqueSort=exports.compareDocumentPosition=exports.removeSubsets=void 0;var tagtypes_1=require("./tagtypes");/**
	 * Given an array of nodes, remove any member that is contained by another.
	 *
	 * @param nodes Nodes to filter.
	 */function removeSubsets(nodes){var idx=nodes.length;/*
	     * Check if each node (or one of its ancestors) is already contained in the
	     * array.
	     */while(--idx>=0){var node=nodes[idx];/*
	         * Remove the node if it is not unique.
	         * We are going through the array from the end, so we only
	         * have to check nodes that preceed the node under consideration in the array.
	         */if(idx>0&&nodes.lastIndexOf(node,idx-1)>=0){nodes.splice(idx,1);continue;}for(var ancestor=node.parent;ancestor;ancestor=ancestor.parent){if(nodes.includes(ancestor)){nodes.splice(idx,1);break;}}}return nodes;}exports.removeSubsets=removeSubsets;/**
	 * Compare the position of one node against another node in any other document.
	 * The return value is a bitmask with the following values:
	 *
	 * document order:
	 * > There is an ordering, document order, defined on all the nodes in the
	 * > document corresponding to the order in which the first character of the
	 * > XML representation of each node occurs in the XML representation of the
	 * > document after expansion of general entities. Thus, the document element
	 * > node will be the first node. Element nodes occur before their children.
	 * > Thus, document order orders element nodes in order of the occurrence of
	 * > their start-tag in the XML (after expansion of entities). The attribute
	 * > nodes of an element occur after the element and before its children. The
	 * > relative order of attribute nodes is implementation-dependent./
	 *
	 * Source:
	 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	 * @param nodaA The first node to use in the comparison
	 * @param nodeB The second node to use in the comparison
	 *
	 * @return A bitmask describing the input nodes' relative position.
	 *
	 *        See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	 *        a description of these values.
	 */function compareDocumentPosition(nodeA,nodeB){var aParents=[];var bParents=[];if(nodeA===nodeB){return 0;}var current=tagtypes_1.hasChildren(nodeA)?nodeA:nodeA.parent;while(current){aParents.unshift(current);current=current.parent;}current=tagtypes_1.hasChildren(nodeB)?nodeB:nodeB.parent;while(current){bParents.unshift(current);current=current.parent;}var maxIdx=Math.min(aParents.length,bParents.length);var idx=0;while(idx<maxIdx&&aParents[idx]===bParents[idx]){idx++;}if(idx===0){return 1/* DISCONNECTED */;}var sharedParent=aParents[idx-1];var siblings=sharedParent.children;var aSibling=aParents[idx];var bSibling=bParents[idx];if(siblings.indexOf(aSibling)>siblings.indexOf(bSibling)){if(sharedParent===nodeB){return 4/* FOLLOWING */|16/* CONTAINED_BY */;}return 4/* FOLLOWING */;}if(sharedParent===nodeA){return 2/* PRECEDING */|8/* CONTAINS */;}return 2/* PRECEDING */;}exports.compareDocumentPosition=compareDocumentPosition;/**
	 * Sort an array of nodes based on their relative position in the document and
	 * remove any duplicate nodes. If the array contains nodes that do not belong
	 * to the same document, sort order is unspecified.
	 *
	 * @param nodes Array of DOM nodes
	 * @returns collection of unique nodes, sorted in document order
	 */function uniqueSort(nodes){nodes=nodes.filter(function(node,i,arr){return!arr.includes(node,i+1);});nodes.sort(function(a,b){var relative=compareDocumentPosition(a,b);if(relative&2/* PRECEDING */){return-1;}else if(relative&4/* FOLLOWING */){return 1;}return 0;});return nodes;}exports.uniqueSort=uniqueSort;},{"./tagtypes":15}],10:[function(require,module,exports){"use strict";var __createBinding=this&&this.__createBinding||(Object.create?function(o,m,k,k2){if(k2===undefined)k2=k;Object.defineProperty(o,k2,{enumerable:true,get:function get(){return m[k];}});}:function(o,m,k,k2){if(k2===undefined)k2=k;o[k2]=m[k];});var __exportStar=this&&this.__exportStar||function(m,exports){for(var p in m){if(p!=="default"&&!Object.prototype.hasOwnProperty.call(exports,p))__createBinding(exports,m,p);}};Object.defineProperty(exports,"__esModule",{value:true});__exportStar(require("./stringify"),exports);__exportStar(require("./traversal"),exports);__exportStar(require("./manipulation"),exports);__exportStar(require("./querying"),exports);__exportStar(require("./legacy"),exports);__exportStar(require("./helpers"),exports);__exportStar(require("./tagtypes"),exports);},{"./helpers":9,"./legacy":11,"./manipulation":12,"./querying":13,"./stringify":14,"./tagtypes":15,"./traversal":16}],11:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.getElementsByTagType=exports.getElementsByTagName=exports.getElementById=exports.getElements=exports.testElement=void 0;var querying_1=require("./querying");var tagtypes_1=require("./tagtypes");function isTextNode(node){return node.type==="text"/* Text */;}var Checks={tag_name:function tag_name(name){if(typeof name==="function"){return function(elem){return tagtypes_1.isTag(elem)&&name(elem.name);};}else if(name==="*"){return tagtypes_1.isTag;}return function(elem){return tagtypes_1.isTag(elem)&&elem.name===name;};},tag_type:function tag_type(type){if(typeof type==="function"){return function(elem){return type(elem.type);};}return function(elem){return elem.type===type;};},tag_contains:function tag_contains(data){if(typeof data==="function"){return function(elem){return isTextNode(elem)&&data(elem.data);};}return function(elem){return isTextNode(elem)&&elem.data===data;};}};function getAttribCheck(attrib,value){if(typeof value==="function"){return function(elem){return tagtypes_1.isTag(elem)&&value(elem.attribs[attrib]);};}return function(elem){return tagtypes_1.isTag(elem)&&elem.attribs[attrib]===value;};}function combineFuncs(a,b){return function(elem){return a(elem)||b(elem);};}function compileTest(options){var funcs=Object.keys(options).map(function(key){var value=options[key];return key in Checks?Checks[key](value):getAttribCheck(key,value);});return funcs.length===0?null:funcs.reduce(combineFuncs);}function testElement(options,element){var test=compileTest(options);return test?test(element):true;}exports.testElement=testElement;function getElements(options,element,recurse,limit){if(limit===void 0){limit=Infinity;}var test=compileTest(options);return test?querying_1.filter(test,element,recurse,limit):[];}exports.getElements=getElements;function getElementById(id,element,recurse){if(recurse===void 0){recurse=true;}if(!Array.isArray(element))element=[element];return querying_1.findOne(getAttribCheck("id",id),element,recurse);}exports.getElementById=getElementById;function getElementsByTagName(name,element,recurse,limit){if(limit===void 0){limit=Infinity;}return querying_1.filter(Checks.tag_name(name),element,recurse,limit);}exports.getElementsByTagName=getElementsByTagName;function getElementsByTagType(type,element,recurse,limit){if(recurse===void 0){recurse=true;}if(limit===void 0){limit=Infinity;}return querying_1.filter(Checks.tag_type(type),element,recurse,limit);}exports.getElementsByTagType=getElementsByTagType;},{"./querying":13,"./tagtypes":15}],12:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.prepend=exports.append=exports.appendChild=exports.replaceElement=exports.removeElement=void 0;/**
	 * Remove an element from the dom
	 *
	 * @param elem The element to be removed
	 */function removeElement(elem){if(elem.prev)elem.prev.next=elem.next;if(elem.next)elem.next.prev=elem.prev;if(elem.parent){var childs=elem.parent.children;childs.splice(childs.lastIndexOf(elem),1);}}exports.removeElement=removeElement;/**
	 * Replace an element in the dom
	 *
	 * @param elem The element to be replaced
	 * @param replacement The element to be added
	 */function replaceElement(elem,replacement){var prev=replacement.prev=elem.prev;if(prev){prev.next=replacement;}var next=replacement.next=elem.next;if(next){next.prev=replacement;}var parent=replacement.parent=elem.parent;if(parent){var childs=parent.children;childs[childs.lastIndexOf(elem)]=replacement;}}exports.replaceElement=replaceElement;/**
	 * Append a child to an element
	 *
	 * @param elem The element to append to
	 * @param child The element to be added as a child
	 */function appendChild(elem,child){removeElement(child);child.parent=elem;if(elem.children.push(child)!==1){var sibling=elem.children[elem.children.length-2];sibling.next=child;child.prev=sibling;child.next=null;}}exports.appendChild=appendChild;/**
	 * Append an element after another
	 *
	 * @param elem The element to append to
	 * @param next The element be added
	 */function append(elem,next){removeElement(next);var parent=elem.parent;var currNext=elem.next;next.next=currNext;next.prev=elem;elem.next=next;next.parent=parent;if(currNext){currNext.prev=next;if(parent){var childs=parent.children;childs.splice(childs.lastIndexOf(currNext),0,next);}}else if(parent){parent.children.push(next);}}exports.append=append;/**
	 * Prepend an element before another
	 *
	 * @param elem The element to append to
	 * @param prev The element be added
	 */function prepend(elem,prev){var parent=elem.parent;if(parent){var childs=parent.children;childs.splice(childs.lastIndexOf(elem),0,prev);}if(elem.prev){elem.prev.next=prev;}prev.parent=parent;prev.prev=elem.prev;prev.next=elem;elem.prev=prev;}exports.prepend=prepend;},{}],13:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.findAll=exports.existsOne=exports.findOne=exports.findOneChild=exports.find=exports.filter=void 0;var tagtypes_1=require("./tagtypes");/**
	 * Search a node and its children for nodes passing a test function.
	 *
	 * @param test Function to test nodes on.
	 * @param element Element to search. Will be included in the result set if it matches.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 */function filter(test,node,recurse,limit){if(recurse===void 0){recurse=true;}if(limit===void 0){limit=Infinity;}if(!Array.isArray(node))node=[node];return find(test,node,recurse,limit);}exports.filter=filter;/**
	 * Like `filter`, but only works on an array of nodes.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @param recurse Also consider child nodes.
	 * @param limit Maximum number of nodes to return.
	 */function find(test,nodes,recurse,limit){var result=[];for(var _i=0,nodes_1=nodes;_i<nodes_1.length;_i++){var elem=nodes_1[_i];if(test(elem)){result.push(elem);if(--limit<=0)break;}if(recurse&&tagtypes_1.hasChildren(elem)&&elem.children.length>0){var children=find(test,elem.children,recurse,limit);result.push.apply(result,children);limit-=children.length;if(limit<=0)break;}}return result;}exports.find=find;/**
	 * Finds the first element inside of an array that matches a test function.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 */function findOneChild(test,nodes){return nodes.find(test);}exports.findOneChild=findOneChild;/**
	 * Finds one element in a tree that passes a test.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 * @param recurse Also consider child nodes.
	 */function findOne(test,nodes,recurse){if(recurse===void 0){recurse=true;}var elem=null;for(var i=0;i<nodes.length&&!elem;i++){var checked=nodes[i];if(!tagtypes_1.isTag(checked)){continue;}else if(test(checked)){elem=checked;}else if(recurse&&checked.children.length>0){elem=findOne(test,checked.children);}}return elem;}exports.findOne=findOne;/**
	 * Returns whether a tree of nodes contains at least one node passing a test.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 */function existsOne(test,nodes){return nodes.some(function(checked){return tagtypes_1.isTag(checked)&&(test(checked)||checked.children.length>0&&existsOne(test,checked.children));});}exports.existsOne=existsOne;/**
	 * Search and array of nodes and its children for nodes passing a test function.
	 *
	 * Same as `find`, only with less options, leading to reduced complexity.
	 *
	 * @param test Function to test nodes on.
	 * @param nodes Array of nodes to search.
	 */function findAll(test,nodes){var _a;var result=[];var stack=nodes.filter(tagtypes_1.isTag);var elem;while(elem=stack.shift()){var children=(_a=elem.children)===null||_a===void 0?void 0:_a.filter(tagtypes_1.isTag);if(children&&children.length>0){stack.unshift.apply(stack,children);}if(test(elem))result.push(elem);}return result;}exports.findAll=findAll;},{"./tagtypes":15}],14:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});exports.getText=exports.getInnerHTML=exports.getOuterHTML=void 0;var tagtypes_1=require("./tagtypes");var dom_serializer_1=__importDefault(require("dom-serializer"));function getOuterHTML(node,options){return dom_serializer_1["default"](node,options);}exports.getOuterHTML=getOuterHTML;function getInnerHTML(node,options){return tagtypes_1.hasChildren(node)?node.children.map(function(node){return getOuterHTML(node,options);}).join(""):"";}exports.getInnerHTML=getInnerHTML;function getText(node){if(Array.isArray(node))return node.map(getText).join("");if(tagtypes_1.isTag(node))return node.name==="br"?"\n":getText(node.children);if(tagtypes_1.isCDATA(node))return getText(node.children);if(tagtypes_1.isText(node))return node.data;return"";}exports.getText=getText;},{"./tagtypes":15,"dom-serializer":5}],15:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.hasChildren=exports.isComment=exports.isText=exports.isCDATA=exports.isTag=void 0;var domelementtype_1=require("domelementtype");function isTag(node){return domelementtype_1.isTag(node);}exports.isTag=isTag;function isCDATA(node){return node.type==="cdata"/* CDATA */;}exports.isCDATA=isCDATA;function isText(node){return node.type==="text"/* Text */;}exports.isText=isText;function isComment(node){return node.type==="comment"/* Comment */;}exports.isComment=isComment;function hasChildren(node){return Object.prototype.hasOwnProperty.call(node,"children");}exports.hasChildren=hasChildren;},{"domelementtype":6}],16:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.nextElementSibling=exports.getName=exports.hasAttrib=exports.getAttributeValue=exports.getSiblings=exports.getParent=exports.getChildren=void 0;function getChildren(elem){return elem.children||null;}exports.getChildren=getChildren;function getParent(elem){return elem.parent||null;}exports.getParent=getParent;function getSiblings(elem){var parent=getParent(elem);return parent?getChildren(parent):[elem];}exports.getSiblings=getSiblings;function getAttributeValue(elem,name){var _a;return(_a=elem.attribs)===null||_a===void 0?void 0:_a[name];}exports.getAttributeValue=getAttributeValue;function hasAttrib(elem,name){return!!elem.attribs&&Object.prototype.hasOwnProperty.call(elem.attribs,name)&&elem.attribs[name]!=null;}exports.hasAttrib=hasAttrib;/**
	 * Returns the name property of an element
	 *
	 * @param elem The element to get the name for
	 */function getName(elem){return elem.name;}exports.getName=getName;function nextElementSibling(elem){var node=elem.next;while(node!==null&&node.type!=="tag"){node=node.next;}return node;}exports.nextElementSibling=nextElementSibling;},{}],17:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});exports.decodeHTML=exports.decodeHTMLStrict=exports.decodeXML=void 0;var entities_json_1=__importDefault(require("./maps/entities.json"));var legacy_json_1=__importDefault(require("./maps/legacy.json"));var xml_json_1=__importDefault(require("./maps/xml.json"));var decode_codepoint_1=__importDefault(require("./decode_codepoint"));exports.decodeXML=getStrictDecoder(xml_json_1["default"]);exports.decodeHTMLStrict=getStrictDecoder(entities_json_1["default"]);function getStrictDecoder(map){var keys=Object.keys(map).join("|");var replace=getReplacer(map);keys+="|#[xX][\\da-fA-F]+|#\\d+";var re=new RegExp("&(?:"+keys+");","g");return function(str){return String(str).replace(re,replace);};}var sorter=function sorter(a,b){return a<b?1:-1;};exports.decodeHTML=function(){var legacy=Object.keys(legacy_json_1["default"]).sort(sorter);var keys=Object.keys(entities_json_1["default"]).sort(sorter);for(var i=0,j=0;i<keys.length;i++){if(legacy[j]===keys[i]){keys[i]+=";?";j++;}else{keys[i]+=";";}}var re=new RegExp("&(?:"+keys.join("|")+"|#[xX][\\da-fA-F]+;?|#\\d+;?)","g");var replace=getReplacer(entities_json_1["default"]);function replacer(str){if(str.substr(-1)!==";")str+=";";return replace(str);}//TODO consider creating a merged map
	return function(str){return String(str).replace(re,replacer);};}();function getReplacer(map){return function replace(str){if(str.charAt(1)==="#"){var secondChar=str.charAt(2);if(secondChar==="X"||secondChar==="x"){return decode_codepoint_1["default"](parseInt(str.substr(3),16));}return decode_codepoint_1["default"](parseInt(str.substr(2),10));}return map[str.slice(1,-1)];};}},{"./decode_codepoint":18,"./maps/entities.json":22,"./maps/legacy.json":23,"./maps/xml.json":24}],18:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});var decode_json_1=__importDefault(require("./maps/decode.json"));// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint){if(codePoint>=0xd800&&codePoint<=0xdfff||codePoint>0x10ffff){return"\uFFFD";}if(codePoint in decode_json_1["default"]){codePoint=decode_json_1["default"][codePoint];}var output="";if(codePoint>0xffff){codePoint-=0x10000;output+=String.fromCharCode(codePoint>>>10&0x3ff|0xd800);codePoint=0xdc00|codePoint&0x3ff;}output+=String.fromCharCode(codePoint);return output;}exports["default"]=decodeCodePoint;},{"./maps/decode.json":21}],19:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});exports.escape=exports.encodeHTML=exports.encodeXML=void 0;var xml_json_1=__importDefault(require("./maps/xml.json"));var inverseXML=getInverseObj(xml_json_1["default"]);var xmlReplacer=getInverseReplacer(inverseXML);exports.encodeXML=getInverse(inverseXML,xmlReplacer);var entities_json_1=__importDefault(require("./maps/entities.json"));var inverseHTML=getInverseObj(entities_json_1["default"]);var htmlReplacer=getInverseReplacer(inverseHTML);exports.encodeHTML=getInverse(inverseHTML,htmlReplacer);function getInverseObj(obj){return Object.keys(obj).sort().reduce(function(inverse,name){inverse[obj[name]]="&"+name+";";return inverse;},{});}function getInverseReplacer(inverse){var single=[];var multiple=[];for(var _i=0,_a=Object.keys(inverse);_i<_a.length;_i++){var k=_a[_i];if(k.length===1){// Add value to single array
	single.push("\\"+k);}else{// Add value to multiple array
	multiple.push(k);}}// Add ranges to single characters.
	single.sort();for(var start=0;start<single.length-1;start++){// Find the end of a run of characters
	var end=start;while(end<single.length-1&&single[end].charCodeAt(1)+1===single[end+1].charCodeAt(1)){end+=1;}var count=1+end-start;// We want to replace at least three characters
	if(count<3)continue;single.splice(start,count,single[start]+"-"+single[end]);}multiple.unshift("["+single.join("")+"]");return new RegExp(multiple.join("|"),"g");}var reNonASCII=/(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;function singleCharReplacer(c){// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	return"&#x"+c.codePointAt(0).toString(16).toUpperCase()+";";}function getInverse(inverse,re){return function(data){return data.replace(re,function(name){return inverse[name];}).replace(reNonASCII,singleCharReplacer);};}var reXmlChars=getInverseReplacer(inverseXML);function escape(data){return data.replace(reXmlChars,singleCharReplacer).replace(reNonASCII,singleCharReplacer);}exports.escape=escape;},{"./maps/entities.json":22,"./maps/xml.json":24}],20:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.encode=exports.decodeStrict=exports.decode=void 0;var decode_1=require("./decode");var encode_1=require("./encode");/**
	 * Decodes a string with entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 */function decode(data,level){return(!level||level<=0?decode_1.decodeXML:decode_1.decodeHTML)(data);}exports.decode=decode;/**
	 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
	 *
	 * @param data String to decode.
	 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
	 */function decodeStrict(data,level){return(!level||level<=0?decode_1.decodeXML:decode_1.decodeHTMLStrict)(data);}exports.decodeStrict=decodeStrict;/**
	 * Encodes a string with entities.
	 *
	 * @param data String to encode.
	 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
	 */function encode(data,level){return(!level||level<=0?encode_1.encodeXML:encode_1.encodeHTML)(data);}exports.encode=encode;var encode_2=require("./encode");Object.defineProperty(exports,"encodeXML",{enumerable:true,get:function get(){return encode_2.encodeXML;}});Object.defineProperty(exports,"encodeHTML",{enumerable:true,get:function get(){return encode_2.encodeHTML;}});Object.defineProperty(exports,"escape",{enumerable:true,get:function get(){return encode_2.escape;}});// Legacy aliases
	Object.defineProperty(exports,"encodeHTML4",{enumerable:true,get:function get(){return encode_2.encodeHTML;}});Object.defineProperty(exports,"encodeHTML5",{enumerable:true,get:function get(){return encode_2.encodeHTML;}});var decode_2=require("./decode");Object.defineProperty(exports,"decodeXML",{enumerable:true,get:function get(){return decode_2.decodeXML;}});Object.defineProperty(exports,"decodeHTML",{enumerable:true,get:function get(){return decode_2.decodeHTML;}});Object.defineProperty(exports,"decodeHTMLStrict",{enumerable:true,get:function get(){return decode_2.decodeHTMLStrict;}});// Legacy aliases
	Object.defineProperty(exports,"decodeHTML4",{enumerable:true,get:function get(){return decode_2.decodeHTML;}});Object.defineProperty(exports,"decodeHTML5",{enumerable:true,get:function get(){return decode_2.decodeHTML;}});Object.defineProperty(exports,"decodeHTML4Strict",{enumerable:true,get:function get(){return decode_2.decodeHTMLStrict;}});Object.defineProperty(exports,"decodeHTML5Strict",{enumerable:true,get:function get(){return decode_2.decodeHTMLStrict;}});Object.defineProperty(exports,"decodeXMLStrict",{enumerable:true,get:function get(){return decode_2.decodeXML;}});},{"./decode":17,"./encode":19}],21:[function(require,module,exports){module.exports={"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376};},{}],22:[function(require,module,exports){module.exports={"Aacute":"\xC1","aacute":"\xE1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xC2","acirc":"\xE2","acute":"\xB4","Acy":"\u0410","acy":"\u0430","AElig":"\xC6","aelig":"\xE6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xC0","agrave":"\xE0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xC5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xC5","aring":"\xE5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xC3","atilde":"\xE3","Auml":"\xC4","auml":"\xE4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xA6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xC7","ccedil":"\xE7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xB8","Cedilla":"\xB8","cemptyv":"\u29B2","cent":"\xA2","centerdot":"\xB7","CenterDot":"\xB7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xAE","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xA9","COPY":"\xA9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xA4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xB0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xB4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xA8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xF7","divide":"\xF7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xA8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xA8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xC9","eacute":"\xE9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xCA","ecirc":"\xEA","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xC8","egrave":"\xE8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xD0","eth":"\xF0","Euml":"\xCB","euml":"\xEB","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xBD","frac13":"\u2153","frac14":"\xBC","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xBE","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xBD","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xCD","iacute":"\xED","ic":"\u2063","Icirc":"\xCE","icirc":"\xEE","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xA1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xCC","igrave":"\xEC","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xBF","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xCF","iuml":"\xEF","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xAB","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xAF","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xB5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xB7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xA0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xA0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xAC","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xD1","ntilde":"\xF1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xD3","oacute":"\xF3","oast":"\u229B","Ocirc":"\xD4","ocirc":"\xF4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xD2","ograve":"\xF2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xAA","ordm":"\xBA","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xD8","oslash":"\xF8","osol":"\u2298","Otilde":"\xD5","otilde":"\xF5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xD6","ouml":"\xF6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xB6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xB1","plusmn":"\xB1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xB1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xA3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\"","QUOT":"\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xBB","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xAE","REG":"\xAE","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xA7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xAD","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xAF","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xB9","sup2":"\xB2","sup3":"\xB3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xDF","Tab":"\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xDE","thorn":"\xFE","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xD7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xDA","uacute":"\xFA","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xDB","ucirc":"\xFB","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xD9","ugrave":"\xF9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xA8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xDC","uuml":"\xFC","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xDD","yacute":"\xFD","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xA5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xFF","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"};},{}],23:[function(require,module,exports){module.exports={"Aacute":"\xC1","aacute":"\xE1","Acirc":"\xC2","acirc":"\xE2","acute":"\xB4","AElig":"\xC6","aelig":"\xE6","Agrave":"\xC0","agrave":"\xE0","amp":"&","AMP":"&","Aring":"\xC5","aring":"\xE5","Atilde":"\xC3","atilde":"\xE3","Auml":"\xC4","auml":"\xE4","brvbar":"\xA6","Ccedil":"\xC7","ccedil":"\xE7","cedil":"\xB8","cent":"\xA2","copy":"\xA9","COPY":"\xA9","curren":"\xA4","deg":"\xB0","divide":"\xF7","Eacute":"\xC9","eacute":"\xE9","Ecirc":"\xCA","ecirc":"\xEA","Egrave":"\xC8","egrave":"\xE8","ETH":"\xD0","eth":"\xF0","Euml":"\xCB","euml":"\xEB","frac12":"\xBD","frac14":"\xBC","frac34":"\xBE","gt":">","GT":">","Iacute":"\xCD","iacute":"\xED","Icirc":"\xCE","icirc":"\xEE","iexcl":"\xA1","Igrave":"\xCC","igrave":"\xEC","iquest":"\xBF","Iuml":"\xCF","iuml":"\xEF","laquo":"\xAB","lt":"<","LT":"<","macr":"\xAF","micro":"\xB5","middot":"\xB7","nbsp":"\xA0","not":"\xAC","Ntilde":"\xD1","ntilde":"\xF1","Oacute":"\xD3","oacute":"\xF3","Ocirc":"\xD4","ocirc":"\xF4","Ograve":"\xD2","ograve":"\xF2","ordf":"\xAA","ordm":"\xBA","Oslash":"\xD8","oslash":"\xF8","Otilde":"\xD5","otilde":"\xF5","Ouml":"\xD6","ouml":"\xF6","para":"\xB6","plusmn":"\xB1","pound":"\xA3","quot":"\"","QUOT":"\"","raquo":"\xBB","reg":"\xAE","REG":"\xAE","sect":"\xA7","shy":"\xAD","sup1":"\xB9","sup2":"\xB2","sup3":"\xB3","szlig":"\xDF","THORN":"\xDE","thorn":"\xFE","times":"\xD7","Uacute":"\xDA","uacute":"\xFA","Ucirc":"\xDB","ucirc":"\xFB","Ugrave":"\xD9","ugrave":"\xF9","uml":"\xA8","Uuml":"\xDC","uuml":"\xFC","Yacute":"\xDD","yacute":"\xFD","yen":"\xA5","yuml":"\xFF"};},{}],24:[function(require,module,exports){module.exports={"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""};},{}],25:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	var objectCreate=Object.create||objectCreatePolyfill;var objectKeys=Object.keys||objectKeysPolyfill;var bind=Function.prototype.bind||functionBindPolyfill;function EventEmitter(){if(!this._events||!Object.prototype.hasOwnProperty.call(this,'_events')){this._events=objectCreate(null);this._eventsCount=0;}this._maxListeners=this._maxListeners||undefined;}module.exports=EventEmitter;// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter=EventEmitter;EventEmitter.prototype._events=undefined;EventEmitter.prototype._maxListeners=undefined;// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners=10;var hasDefineProperty;try{var o={};if(Object.defineProperty)Object.defineProperty(o,'x',{value:0});hasDefineProperty=o.x===0;}catch(err){hasDefineProperty=false;}if(hasDefineProperty){Object.defineProperty(EventEmitter,'defaultMaxListeners',{enumerable:true,get:function get(){return defaultMaxListeners;},set:function set(arg){// check whether the input is a positive number (whose value is zero or
	// greater and not a NaN).
	if(typeof arg!=='number'||arg<0||arg!==arg)throw new TypeError('"defaultMaxListeners" must be a positive number');defaultMaxListeners=arg;}});}else{EventEmitter.defaultMaxListeners=defaultMaxListeners;}// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners=function setMaxListeners(n){if(typeof n!=='number'||n<0||isNaN(n))throw new TypeError('"n" argument must be a positive number');this._maxListeners=n;return this;};function $getMaxListeners(that){if(that._maxListeners===undefined)return EventEmitter.defaultMaxListeners;return that._maxListeners;}EventEmitter.prototype.getMaxListeners=function getMaxListeners(){return $getMaxListeners(this);};// These standalone emit* functions are used to optimize calling of event
	// handlers for fast cases because emit() itself often has a variable number of
	// arguments and can be deoptimized because of that. These functions always have
	// the same number of arguments and thus do not get deoptimized, so the code
	// inside them can execute faster.
	function emitNone(handler,isFn,self){if(isFn)handler.call(self);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].call(self);}}}function emitOne(handler,isFn,self,arg1){if(isFn)handler.call(self,arg1);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].call(self,arg1);}}}function emitTwo(handler,isFn,self,arg1,arg2){if(isFn)handler.call(self,arg1,arg2);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].call(self,arg1,arg2);}}}function emitThree(handler,isFn,self,arg1,arg2,arg3){if(isFn)handler.call(self,arg1,arg2,arg3);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].call(self,arg1,arg2,arg3);}}}function emitMany(handler,isFn,self,args){if(isFn)handler.apply(self,args);else{var len=handler.length;var listeners=arrayClone(handler,len);for(var i=0;i<len;++i){listeners[i].apply(self,args);}}}EventEmitter.prototype.emit=function emit(type){var er,handler,len,args,i,events;var doError=type==='error';events=this._events;if(events)doError=doError&&events.error==null;else if(!doError)return false;// If there is no 'error' event listener then throw.
	if(doError){if(arguments.length>1)er=arguments[1];if(er instanceof Error){throw er;// Unhandled 'error' event
	}else{// At least give some kind of context to the user
	var err=new Error('Unhandled "error" event. ('+er+')');err.context=er;throw err;}return false;}handler=events[type];if(!handler)return false;var isFn=typeof handler==='function';len=arguments.length;switch(len){// fast cases
	case 1:emitNone(handler,isFn,this);break;case 2:emitOne(handler,isFn,this,arguments[1]);break;case 3:emitTwo(handler,isFn,this,arguments[1],arguments[2]);break;case 4:emitThree(handler,isFn,this,arguments[1],arguments[2],arguments[3]);break;// slower
	default:args=new Array(len-1);for(i=1;i<len;i++){args[i-1]=arguments[i];}emitMany(handler,isFn,this,args);}return true;};function _addListener(target,type,listener,prepend){var m;var events;var existing;if(typeof listener!=='function')throw new TypeError('"listener" argument must be a function');events=target._events;if(!events){events=target._events=objectCreate(null);target._eventsCount=0;}else{// To avoid recursion in the case that type === "newListener"! Before
	// adding it to the listeners, first emit "newListener".
	if(events.newListener){target.emit('newListener',type,listener.listener?listener.listener:listener);// Re-assign `events` because a newListener handler could have caused the
	// this._events to be assigned to a new object
	events=target._events;}existing=events[type];}if(!existing){// Optimize the case of one listener. Don't need the extra array object.
	existing=events[type]=listener;++target._eventsCount;}else{if(typeof existing==='function'){// Adding the second element, need to change to array.
	existing=events[type]=prepend?[listener,existing]:[existing,listener];}else{// If we've already got an array, just append.
	if(prepend){existing.unshift(listener);}else{existing.push(listener);}}// Check for listener leak
	if(!existing.warned){m=$getMaxListeners(target);if(m&&m>0&&existing.length>m){existing.warned=true;var w=new Error('Possible EventEmitter memory leak detected. '+existing.length+' "'+String(type)+'" listeners '+'added. Use emitter.setMaxListeners() to '+'increase limit.');w.name='MaxListenersExceededWarning';w.emitter=target;w.type=type;w.count=existing.length;if((typeof console==="undefined"?"undefined":_typeof(console))==='object'&&console.warn){console.warn('%s: %s',w.name,w.message);}}}}return target;}EventEmitter.prototype.addListener=function addListener(type,listener){return _addListener(this,type,listener,false);};EventEmitter.prototype.on=EventEmitter.prototype.addListener;EventEmitter.prototype.prependListener=function prependListener(type,listener){return _addListener(this,type,listener,true);};function onceWrapper(){if(!this.fired){this.target.removeListener(this.type,this.wrapFn);this.fired=true;switch(arguments.length){case 0:return this.listener.call(this.target);case 1:return this.listener.call(this.target,arguments[0]);case 2:return this.listener.call(this.target,arguments[0],arguments[1]);case 3:return this.listener.call(this.target,arguments[0],arguments[1],arguments[2]);default:var args=new Array(arguments.length);for(var i=0;i<args.length;++i){args[i]=arguments[i];}this.listener.apply(this.target,args);}}}function _onceWrap(target,type,listener){var state={fired:false,wrapFn:undefined,target:target,type:type,listener:listener};var wrapped=bind.call(onceWrapper,state);wrapped.listener=listener;state.wrapFn=wrapped;return wrapped;}EventEmitter.prototype.once=function once(type,listener){if(typeof listener!=='function')throw new TypeError('"listener" argument must be a function');this.on(type,_onceWrap(this,type,listener));return this;};EventEmitter.prototype.prependOnceListener=function prependOnceListener(type,listener){if(typeof listener!=='function')throw new TypeError('"listener" argument must be a function');this.prependListener(type,_onceWrap(this,type,listener));return this;};// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener=function removeListener(type,listener){var list,events,position,i,originalListener;if(typeof listener!=='function')throw new TypeError('"listener" argument must be a function');events=this._events;if(!events)return this;list=events[type];if(!list)return this;if(list===listener||list.listener===listener){if(--this._eventsCount===0)this._events=objectCreate(null);else{delete events[type];if(events.removeListener)this.emit('removeListener',type,list.listener||listener);}}else if(typeof list!=='function'){position=-1;for(i=list.length-1;i>=0;i--){if(list[i]===listener||list[i].listener===listener){originalListener=list[i].listener;position=i;break;}}if(position<0)return this;if(position===0)list.shift();else spliceOne(list,position);if(list.length===1)events[type]=list[0];if(events.removeListener)this.emit('removeListener',type,originalListener||listener);}return this;};EventEmitter.prototype.removeAllListeners=function removeAllListeners(type){var listeners,events,i;events=this._events;if(!events)return this;// not listening for removeListener, no need to emit
	if(!events.removeListener){if(arguments.length===0){this._events=objectCreate(null);this._eventsCount=0;}else if(events[type]){if(--this._eventsCount===0)this._events=objectCreate(null);else delete events[type];}return this;}// emit removeListener for all listeners on all events
	if(arguments.length===0){var keys=objectKeys(events);var key;for(i=0;i<keys.length;++i){key=keys[i];if(key==='removeListener')continue;this.removeAllListeners(key);}this.removeAllListeners('removeListener');this._events=objectCreate(null);this._eventsCount=0;return this;}listeners=events[type];if(typeof listeners==='function'){this.removeListener(type,listeners);}else if(listeners){// LIFO order
	for(i=listeners.length-1;i>=0;i--){this.removeListener(type,listeners[i]);}}return this;};function _listeners(target,type,unwrap){var events=target._events;if(!events)return[];var evlistener=events[type];if(!evlistener)return[];if(typeof evlistener==='function')return unwrap?[evlistener.listener||evlistener]:[evlistener];return unwrap?unwrapListeners(evlistener):arrayClone(evlistener,evlistener.length);}EventEmitter.prototype.listeners=function listeners(type){return _listeners(this,type,true);};EventEmitter.prototype.rawListeners=function rawListeners(type){return _listeners(this,type,false);};EventEmitter.listenerCount=function(emitter,type){if(typeof emitter.listenerCount==='function'){return emitter.listenerCount(type);}else{return listenerCount.call(emitter,type);}};EventEmitter.prototype.listenerCount=listenerCount;function listenerCount(type){var events=this._events;if(events){var evlistener=events[type];if(typeof evlistener==='function'){return 1;}else if(evlistener){return evlistener.length;}}return 0;}EventEmitter.prototype.eventNames=function eventNames(){return this._eventsCount>0?Reflect.ownKeys(this._events):[];};// About 1.5x faster than the two-arg version of Array#splice().
	function spliceOne(list,index){for(var i=index,k=i+1,n=list.length;k<n;i+=1,k+=1){list[i]=list[k];}list.pop();}function arrayClone(arr,n){var copy=new Array(n);for(var i=0;i<n;++i){copy[i]=arr[i];}return copy;}function unwrapListeners(arr){var ret=new Array(arr.length);for(var i=0;i<ret.length;++i){ret[i]=arr[i].listener||arr[i];}return ret;}function objectCreatePolyfill(proto){var F=function F(){};F.prototype=proto;return new F();}function objectKeysPolyfill(obj){var keys=[];for(var k in obj){if(Object.prototype.hasOwnProperty.call(obj,k)){keys.push(k);}}return k;}function functionBindPolyfill(context){var fn=this;return function(){return fn.apply(context,arguments);};}},{}],26:[function(require,module,exports){"use strict";var __extends=this&&this.__extends||function(){var _extendStatics2=function extendStatics(d,b){_extendStatics2=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b;}||function(d,b){for(var p in b){if(b.hasOwnProperty(p))d[p]=b[p];}};return _extendStatics2(d,b);};return function(d,b){_extendStatics2(d,b);function __(){this.constructor=d;}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __());};}();var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});var MultiplexHandler_1=__importDefault(require("./MultiplexHandler"));var CollectingHandler=/** @class */function(_super){__extends(CollectingHandler,_super);function CollectingHandler(cbs){if(cbs===void 0){cbs={};}var _this=_super.call(this,function(name){var _a;var args=[];for(var _i=1;_i<arguments.length;_i++){args[_i-1]=arguments[_i];}_this.events.push([name].concat(args));// @ts-ignore
	if(_this._cbs[name])(_a=_this._cbs)[name].apply(_a,args);})||this;_this._cbs=cbs;_this.events=[];return _this;}CollectingHandler.prototype.onreset=function(){this.events=[];if(this._cbs.onreset)this._cbs.onreset();};CollectingHandler.prototype.restart=function(){var _a;if(this._cbs.onreset)this._cbs.onreset();for(var i=0;i<this.events.length;i++){var _b=this.events[i],name_1=_b[0],args=_b.slice(1);if(!this._cbs[name_1]){continue;}// @ts-ignore
	(_a=this._cbs)[name_1].apply(_a,args);}};return CollectingHandler;}(MultiplexHandler_1["default"]);exports.CollectingHandler=CollectingHandler;},{"./MultiplexHandler":28}],27:[function(require,module,exports){"use strict";var __extends=this&&this.__extends||function(){var _extendStatics3=function extendStatics(d,b){_extendStatics3=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b;}||function(d,b){for(var p in b){if(b.hasOwnProperty(p))d[p]=b[p];}};return _extendStatics3(d,b);};return function(d,b){_extendStatics3(d,b);function __(){this.constructor=d;}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __());};}();var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};var __importStar=this&&this.__importStar||function(mod){if(mod&&mod.__esModule)return mod;var result={};if(mod!=null)for(var k in mod){if(Object.hasOwnProperty.call(mod,k))result[k]=mod[k];}result["default"]=mod;return result;};Object.defineProperty(exports,"__esModule",{value:true});var domhandler_1=__importDefault(require("domhandler"));var DomUtils=__importStar(require("domutils"));var Parser_1=require("./Parser");//TODO: Consume data as it is coming in
	var FeedHandler=/** @class */function(_super){__extends(FeedHandler,_super);/**
	     *
	     * @param callback
	     * @param options
	     */function FeedHandler(callback,options){var _this=this;if(_typeof(callback)==="object"&&callback!==null){callback=undefined;options=callback;}_this=_super.call(this,callback,options)||this;return _this;}FeedHandler.prototype.onend=function(){var feed={};var feedRoot=getOneElement(isValidFeed,this.dom);if(feedRoot){if(feedRoot.name==="feed"){var childs=feedRoot.children;feed.type="atom";addConditionally(feed,"id","id",childs);addConditionally(feed,"title","title",childs);var href=getAttribute("href",getOneElement("link",childs));if(href){feed.link=href;}addConditionally(feed,"description","subtitle",childs);var updated=fetch("updated",childs);if(updated){feed.updated=new Date(updated);}addConditionally(feed,"author","email",childs,true);feed.items=getElements("entry",childs).map(function(item){var entry={};var children=item.children;addConditionally(entry,"id","id",children);addConditionally(entry,"title","title",children);var href=getAttribute("href",getOneElement("link",children));if(href){entry.link=href;}var description=fetch("summary",children)||fetch("content",children);if(description){entry.description=description;}var pubDate=fetch("updated",children);if(pubDate){entry.pubDate=new Date(pubDate);}return entry;});}else{var childs=getOneElement("channel",feedRoot.children).children;feed.type=feedRoot.name.substr(0,3);feed.id="";addConditionally(feed,"title","title",childs);addConditionally(feed,"link","link",childs);addConditionally(feed,"description","description",childs);var updated=fetch("lastBuildDate",childs);if(updated){feed.updated=new Date(updated);}addConditionally(feed,"author","managingEditor",childs,true);feed.items=getElements("item",feedRoot.children).map(function(item){var entry={};var children=item.children;addConditionally(entry,"id","guid",children);addConditionally(entry,"title","title",children);addConditionally(entry,"link","link",children);addConditionally(entry,"description","description",children);var pubDate=fetch("pubDate",children);if(pubDate)entry.pubDate=new Date(pubDate);return entry;});}}this.feed=feed;this.handleCallback(feedRoot?null:Error("couldn't find root of feed"));};return FeedHandler;}(domhandler_1["default"]);exports.FeedHandler=FeedHandler;function getElements(what,where){return DomUtils.getElementsByTagName(what,where,true);}function getOneElement(what,where){return DomUtils.getElementsByTagName(what,where,true,1)[0];}function fetch(what,where,recurse){if(recurse===void 0){recurse=false;}return DomUtils.getText(DomUtils.getElementsByTagName(what,where,recurse,1)).trim();}function getAttribute(name,elem){if(!elem){return null;}var attribs=elem.attribs;return attribs[name];}function addConditionally(obj,prop,what,where,recurse){if(recurse===void 0){recurse=false;}var tmp=fetch(what,where,recurse);// @ts-ignore
	if(tmp)obj[prop]=tmp;}function isValidFeed(value){return value==="rss"||value==="feed"||value==="rdf:RDF";}var defaultOptions={xmlMode:true};/**
	 * Parse a feed.
	 *
	 * @param feed The feed that should be parsed, as a string.
	 * @param options Optionally, options for parsing. When using this option, you probably want to set `xmlMode` to `true`.
	 */function parseFeed(feed,options){if(options===void 0){options=defaultOptions;}var handler=new FeedHandler(options);new Parser_1.Parser(handler,options).end(feed);return handler.feed;}exports.parseFeed=parseFeed;},{"./Parser":29,"domhandler":7,"domutils":10}],28:[function(require,module,exports){"use strict";Object.defineProperty(exports,"__esModule",{value:true});/**
	 * Calls a specific handler function for all events that are encountered.
	 *
	 * @param func — The function to multiplex all events to.
	 */var MultiplexHandler=/** @class */function(){function MultiplexHandler(func){this._func=func;}/* Format: eventname: number of arguments */MultiplexHandler.prototype.onattribute=function(name,value){this._func("onattribute",name,value);};MultiplexHandler.prototype.oncdatastart=function(){this._func("oncdatastart");};MultiplexHandler.prototype.oncdataend=function(){this._func("oncdataend");};MultiplexHandler.prototype.ontext=function(text){this._func("ontext",text);};MultiplexHandler.prototype.onprocessinginstruction=function(name,value){this._func("onprocessinginstruction",name,value);};MultiplexHandler.prototype.oncomment=function(comment){this._func("oncomment",comment);};MultiplexHandler.prototype.oncommentend=function(){this._func("oncommentend");};MultiplexHandler.prototype.onclosetag=function(name){this._func("onclosetag",name);};MultiplexHandler.prototype.onopentag=function(name,attribs){this._func("onopentag",name,attribs);};MultiplexHandler.prototype.onopentagname=function(name){this._func("onopentagname",name);};MultiplexHandler.prototype.onerror=function(error){this._func("onerror",error);};MultiplexHandler.prototype.onend=function(){this._func("onend");};MultiplexHandler.prototype.onparserinit=function(parser){this._func("onparserinit",parser);};MultiplexHandler.prototype.onreset=function(){this._func("onreset");};return MultiplexHandler;}();exports["default"]=MultiplexHandler;},{}],29:[function(require,module,exports){"use strict";var __extends=this&&this.__extends||function(){var _extendStatics4=function extendStatics(d,b){_extendStatics4=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b;}||function(d,b){for(var p in b){if(b.hasOwnProperty(p))d[p]=b[p];}};return _extendStatics4(d,b);};return function(d,b){_extendStatics4(d,b);function __(){this.constructor=d;}d.prototype=b===null?Object.create(b):(__.prototype=b.prototype,new __());};}();var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});var Tokenizer_1=__importDefault(require("./Tokenizer"));var events_1=require("events");var formTags=new Set(["input","option","optgroup","select","button","datalist","textarea"]);var pTag=new Set(["p"]);var openImpliesClose={tr:new Set(["tr","th","td"]),th:new Set(["th"]),td:new Set(["thead","th","td"]),body:new Set(["head","link","script"]),li:new Set(["li"]),p:pTag,h1:pTag,h2:pTag,h3:pTag,h4:pTag,h5:pTag,h6:pTag,select:formTags,input:formTags,output:formTags,button:formTags,datalist:formTags,textarea:formTags,option:new Set(["option"]),optgroup:new Set(["optgroup","option"]),dd:new Set(["dt","dd"]),dt:new Set(["dt","dd"]),address:pTag,article:pTag,aside:pTag,blockquote:pTag,details:pTag,div:pTag,dl:pTag,fieldset:pTag,figcaption:pTag,figure:pTag,footer:pTag,form:pTag,header:pTag,hr:pTag,main:pTag,nav:pTag,ol:pTag,pre:pTag,section:pTag,table:pTag,ul:pTag,rt:new Set(["rt","rp"]),rp:new Set(["rt","rp"]),tbody:new Set(["thead","tbody"]),tfoot:new Set(["thead","tbody"])};var voidElements=new Set(["area","base","basefont","br","col","command","embed","frame","hr","img","input","isindex","keygen","link","meta","param","source","track","wbr"]);var foreignContextElements=new Set(["math","svg"]);var htmlIntegrationElements=new Set(["mi","mo","mn","ms","mtext","annotation-xml","foreignObject","desc","title"]);var reNameEnd=/\s|\//;var Parser=/** @class */function(_super){__extends(Parser,_super);function Parser(cbs,options){var _this=_super.call(this)||this;_this._tagname="";_this._attribname="";_this._attribvalue="";_this._attribs=null;_this._stack=[];_this._foreignContext=[];_this.startIndex=0;_this.endIndex=null;// Aliases for backwards compatibility
	_this.parseChunk=Parser.prototype.write;_this.done=Parser.prototype.end;_this._options=options||{};_this._cbs=cbs||{};_this._tagname="";_this._attribname="";_this._attribvalue="";_this._attribs=null;_this._stack=[];_this._foreignContext=[];_this.startIndex=0;_this.endIndex=null;_this._lowerCaseTagNames="lowerCaseTags"in _this._options?!!_this._options.lowerCaseTags:!_this._options.xmlMode;_this._lowerCaseAttributeNames="lowerCaseAttributeNames"in _this._options?!!_this._options.lowerCaseAttributeNames:!_this._options.xmlMode;_this._tokenizer=new(_this._options.Tokenizer||Tokenizer_1["default"])(_this._options,_this);if(_this._cbs.onparserinit)_this._cbs.onparserinit(_this);return _this;}Parser.prototype._updatePosition=function(initialOffset){if(this.endIndex===null){if(this._tokenizer._sectionStart<=initialOffset){this.startIndex=0;}else{this.startIndex=this._tokenizer._sectionStart-initialOffset;}}else this.startIndex=this.endIndex+1;this.endIndex=this._tokenizer.getAbsoluteIndex();};//Tokenizer event handlers
	Parser.prototype.ontext=function(data){this._updatePosition(1);// @ts-ignore
	this.endIndex--;if(this._cbs.ontext)this._cbs.ontext(data);};Parser.prototype.onopentagname=function(name){if(this._lowerCaseTagNames){name=name.toLowerCase();}this._tagname=name;if(!this._options.xmlMode&&Object.prototype.hasOwnProperty.call(openImpliesClose,name)){for(var el=void 0;// @ts-ignore
	openImpliesClose[name].has(el=this._stack[this._stack.length-1]);this.onclosetag(el)){;}}if(this._options.xmlMode||!voidElements.has(name)){this._stack.push(name);if(foreignContextElements.has(name)){this._foreignContext.push(true);}else if(htmlIntegrationElements.has(name)){this._foreignContext.push(false);}}if(this._cbs.onopentagname)this._cbs.onopentagname(name);if(this._cbs.onopentag)this._attribs={};};Parser.prototype.onopentagend=function(){this._updatePosition(1);if(this._attribs){if(this._cbs.onopentag){this._cbs.onopentag(this._tagname,this._attribs);}this._attribs=null;}if(!this._options.xmlMode&&this._cbs.onclosetag&&voidElements.has(this._tagname)){this._cbs.onclosetag(this._tagname);}this._tagname="";};Parser.prototype.onclosetag=function(name){this._updatePosition(1);if(this._lowerCaseTagNames){name=name.toLowerCase();}if(foreignContextElements.has(name)||htmlIntegrationElements.has(name)){this._foreignContext.pop();}if(this._stack.length&&(this._options.xmlMode||!voidElements.has(name))){var pos=this._stack.lastIndexOf(name);if(pos!==-1){if(this._cbs.onclosetag){pos=this._stack.length-pos;// @ts-ignore
	while(pos--){this._cbs.onclosetag(this._stack.pop());}}else this._stack.length=pos;}else if(name==="p"&&!this._options.xmlMode){this.onopentagname(name);this._closeCurrentTag();}}else if(!this._options.xmlMode&&(name==="br"||name==="p")){this.onopentagname(name);this._closeCurrentTag();}};Parser.prototype.onselfclosingtag=function(){if(this._options.xmlMode||this._options.recognizeSelfClosing||this._foreignContext[this._foreignContext.length-1]){this._closeCurrentTag();}else{this.onopentagend();}};Parser.prototype._closeCurrentTag=function(){var name=this._tagname;this.onopentagend();//self-closing tags will be on the top of the stack
	//(cheaper check than in onclosetag)
	if(this._stack[this._stack.length-1]===name){if(this._cbs.onclosetag){this._cbs.onclosetag(name);}this._stack.pop();}};Parser.prototype.onattribname=function(name){if(this._lowerCaseAttributeNames){name=name.toLowerCase();}this._attribname=name;};Parser.prototype.onattribdata=function(value){this._attribvalue+=value;};Parser.prototype.onattribend=function(){if(this._cbs.onattribute)this._cbs.onattribute(this._attribname,this._attribvalue);if(this._attribs&&!Object.prototype.hasOwnProperty.call(this._attribs,this._attribname)){this._attribs[this._attribname]=this._attribvalue;}this._attribname="";this._attribvalue="";};Parser.prototype._getInstructionName=function(value){var idx=value.search(reNameEnd);var name=idx<0?value:value.substr(0,idx);if(this._lowerCaseTagNames){name=name.toLowerCase();}return name;};Parser.prototype.ondeclaration=function(value){if(this._cbs.onprocessinginstruction){var name_1=this._getInstructionName(value);this._cbs.onprocessinginstruction("!"+name_1,"!"+value);}};Parser.prototype.onprocessinginstruction=function(value){if(this._cbs.onprocessinginstruction){var name_2=this._getInstructionName(value);this._cbs.onprocessinginstruction("?"+name_2,"?"+value);}};Parser.prototype.oncomment=function(value){this._updatePosition(4);if(this._cbs.oncomment)this._cbs.oncomment(value);if(this._cbs.oncommentend)this._cbs.oncommentend();};Parser.prototype.oncdata=function(value){this._updatePosition(1);if(this._options.xmlMode||this._options.recognizeCDATA){if(this._cbs.oncdatastart)this._cbs.oncdatastart();if(this._cbs.ontext)this._cbs.ontext(value);if(this._cbs.oncdataend)this._cbs.oncdataend();}else{this.oncomment("[CDATA["+value+"]]");}};Parser.prototype.onerror=function(err){if(this._cbs.onerror)this._cbs.onerror(err);};Parser.prototype.onend=function(){if(this._cbs.onclosetag){for(var i=this._stack.length;i>0;this._cbs.onclosetag(this._stack[--i])){;}}if(this._cbs.onend)this._cbs.onend();};//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset=function(){if(this._cbs.onreset)this._cbs.onreset();this._tokenizer.reset();this._tagname="";this._attribname="";this._attribs=null;this._stack=[];if(this._cbs.onparserinit)this._cbs.onparserinit(this);};//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete=function(data){this.reset();this.end(data);};Parser.prototype.write=function(chunk){this._tokenizer.write(chunk);};Parser.prototype.end=function(chunk){this._tokenizer.end(chunk);};Parser.prototype.pause=function(){this._tokenizer.pause();};Parser.prototype.resume=function(){this._tokenizer.resume();};return Parser;}(events_1.EventEmitter);exports.Parser=Parser;},{"./Tokenizer":30,"events":25}],30:[function(require,module,exports){"use strict";var __importDefault=this&&this.__importDefault||function(mod){return mod&&mod.__esModule?mod:{"default":mod};};Object.defineProperty(exports,"__esModule",{value:true});var decode_codepoint_1=__importDefault(require("entities/lib/decode_codepoint"));var entities_json_1=__importDefault(require("entities/lib/maps/entities.json"));var legacy_json_1=__importDefault(require("entities/lib/maps/legacy.json"));var xml_json_1=__importDefault(require("entities/lib/maps/xml.json"));function whitespace(c){return c===" "||c==="\n"||c==="\t"||c==="\f"||c==="\r";}function ifElseState(upper,SUCCESS,FAILURE){var lower=upper.toLowerCase();if(upper===lower){return function(t,c){if(c===lower){t._state=SUCCESS;}else{t._state=FAILURE;t._index--;}};}else{return function(t,c){if(c===lower||c===upper){t._state=SUCCESS;}else{t._state=FAILURE;t._index--;}};}}function consumeSpecialNameChar(upper,NEXT_STATE){var lower=upper.toLowerCase();return function(t,c){if(c===lower||c===upper){t._state=NEXT_STATE;}else{t._state=3/* InTagName */;t._index--;//consume the token again
	}};}var stateBeforeCdata1=ifElseState("C",23/* BeforeCdata2 */,16/* InDeclaration */);var stateBeforeCdata2=ifElseState("D",24/* BeforeCdata3 */,16/* InDeclaration */);var stateBeforeCdata3=ifElseState("A",25/* BeforeCdata4 */,16/* InDeclaration */);var stateBeforeCdata4=ifElseState("T",26/* BeforeCdata5 */,16/* InDeclaration */);var stateBeforeCdata5=ifElseState("A",27/* BeforeCdata6 */,16/* InDeclaration */);var stateBeforeScript1=consumeSpecialNameChar("R",34/* BeforeScript2 */);var stateBeforeScript2=consumeSpecialNameChar("I",35/* BeforeScript3 */);var stateBeforeScript3=consumeSpecialNameChar("P",36/* BeforeScript4 */);var stateBeforeScript4=consumeSpecialNameChar("T",37/* BeforeScript5 */);var stateAfterScript1=ifElseState("R",39/* AfterScript2 */,1/* Text */);var stateAfterScript2=ifElseState("I",40/* AfterScript3 */,1/* Text */);var stateAfterScript3=ifElseState("P",41/* AfterScript4 */,1/* Text */);var stateAfterScript4=ifElseState("T",42/* AfterScript5 */,1/* Text */);var stateBeforeStyle1=consumeSpecialNameChar("Y",44/* BeforeStyle2 */);var stateBeforeStyle2=consumeSpecialNameChar("L",45/* BeforeStyle3 */);var stateBeforeStyle3=consumeSpecialNameChar("E",46/* BeforeStyle4 */);var stateAfterStyle1=ifElseState("Y",48/* AfterStyle2 */,1/* Text */);var stateAfterStyle2=ifElseState("L",49/* AfterStyle3 */,1/* Text */);var stateAfterStyle3=ifElseState("E",50/* AfterStyle4 */,1/* Text */);var stateBeforeEntity=ifElseState("#",52/* BeforeNumericEntity */,53/* InNamedEntity */);var stateBeforeNumericEntity=ifElseState("X",55/* InHexEntity */,54/* InNumericEntity */);var Tokenizer=/** @class */function(){function Tokenizer(options,cbs){/** The current state the tokenizer is in. */this._state=1/* Text */;/** The read buffer. */this._buffer="";/** The beginning of the section that is currently being read. */this._sectionStart=0;/** The index within the buffer that we are currently looking at. */this._index=0;/**
	         * Data that has already been processed will be removed from the buffer occasionally.
	         * `_bufferOffset` keeps track of how many characters have been removed, to make sure position information is accurate.
	         */this._bufferOffset=0;/** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */this._baseState=1/* Text */;/** For special parsing behavior inside of script and style tags. */this._special=1/* None */;/** Indicates whether the tokenizer has been paused. */this._running=true;/** Indicates whether the tokenizer has finished running / `.end` has been called. */this._ended=false;this._cbs=cbs;this._xmlMode=!!(options&&options.xmlMode);this._decodeEntities=!!(options&&options.decodeEntities);}Tokenizer.prototype.reset=function(){this._state=1/* Text */;this._buffer="";this._sectionStart=0;this._index=0;this._bufferOffset=0;this._baseState=1/* Text */;this._special=1/* None */;this._running=true;this._ended=false;};Tokenizer.prototype._stateText=function(c){if(c==="<"){if(this._index>this._sectionStart){this._cbs.ontext(this._getSection());}this._state=2/* BeforeTagName */;this._sectionStart=this._index;}else if(this._decodeEntities&&this._special===1/* None */&&c==="&"){if(this._index>this._sectionStart){this._cbs.ontext(this._getSection());}this._baseState=1/* Text */;this._state=51/* BeforeEntity */;this._sectionStart=this._index;}};Tokenizer.prototype._stateBeforeTagName=function(c){if(c==="/"){this._state=5/* BeforeClosingTagName */;}else if(c==="<"){this._cbs.ontext(this._getSection());this._sectionStart=this._index;}else if(c===">"||this._special!==1/* None */||whitespace(c)){this._state=1/* Text */;}else if(c==="!"){this._state=15/* BeforeDeclaration */;this._sectionStart=this._index+1;}else if(c==="?"){this._state=17/* InProcessingInstruction */;this._sectionStart=this._index+1;}else{this._state=!this._xmlMode&&(c==="s"||c==="S")?31/* BeforeSpecial */:3/* InTagName */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInTagName=function(c){if(c==="/"||c===">"||whitespace(c)){this._emitToken("onopentagname");this._state=8/* BeforeAttributeName */;this._index--;}};Tokenizer.prototype._stateBeforeClosingTagName=function(c){if(whitespace(c)){// ignore
	}else if(c===">"){this._state=1/* Text */;}else if(this._special!==1/* None */){if(c==="s"||c==="S"){this._state=32/* BeforeSpecialEnd */;}else{this._state=1/* Text */;this._index--;}}else{this._state=6/* InClosingTagName */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInClosingTagName=function(c){if(c===">"||whitespace(c)){this._emitToken("onclosetag");this._state=7/* AfterClosingTagName */;this._index--;}};Tokenizer.prototype._stateAfterClosingTagName=function(c){//skip everything until ">"
	if(c===">"){this._state=1/* Text */;this._sectionStart=this._index+1;}};Tokenizer.prototype._stateBeforeAttributeName=function(c){if(c===">"){this._cbs.onopentagend();this._state=1/* Text */;this._sectionStart=this._index+1;}else if(c==="/"){this._state=4/* InSelfClosingTag */;}else if(!whitespace(c)){this._state=9/* InAttributeName */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInSelfClosingTag=function(c){if(c===">"){this._cbs.onselfclosingtag();this._state=1/* Text */;this._sectionStart=this._index+1;}else if(!whitespace(c)){this._state=8/* BeforeAttributeName */;this._index--;}};Tokenizer.prototype._stateInAttributeName=function(c){if(c==="="||c==="/"||c===">"||whitespace(c)){this._cbs.onattribname(this._getSection());this._sectionStart=-1;this._state=10/* AfterAttributeName */;this._index--;}};Tokenizer.prototype._stateAfterAttributeName=function(c){if(c==="="){this._state=11/* BeforeAttributeValue */;}else if(c==="/"||c===">"){this._cbs.onattribend();this._state=8/* BeforeAttributeName */;this._index--;}else if(!whitespace(c)){this._cbs.onattribend();this._state=9/* InAttributeName */;this._sectionStart=this._index;}};Tokenizer.prototype._stateBeforeAttributeValue=function(c){if(c==='"'){this._state=12/* InAttributeValueDq */;this._sectionStart=this._index+1;}else if(c==="'"){this._state=13/* InAttributeValueSq */;this._sectionStart=this._index+1;}else if(!whitespace(c)){this._state=14/* InAttributeValueNq */;this._sectionStart=this._index;this._index--;//reconsume token
	}};Tokenizer.prototype._stateInAttributeValueDoubleQuotes=function(c){if(c==='"'){this._emitToken("onattribdata");this._cbs.onattribend();this._state=8/* BeforeAttributeName */;}else if(this._decodeEntities&&c==="&"){this._emitToken("onattribdata");this._baseState=this._state;this._state=51/* BeforeEntity */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInAttributeValueSingleQuotes=function(c){if(c==="'"){this._emitToken("onattribdata");this._cbs.onattribend();this._state=8/* BeforeAttributeName */;}else if(this._decodeEntities&&c==="&"){this._emitToken("onattribdata");this._baseState=this._state;this._state=51/* BeforeEntity */;this._sectionStart=this._index;}};Tokenizer.prototype._stateInAttributeValueNoQuotes=function(c){if(whitespace(c)||c===">"){this._emitToken("onattribdata");this._cbs.onattribend();this._state=8/* BeforeAttributeName */;this._index--;}else if(this._decodeEntities&&c==="&"){this._emitToken("onattribdata");this._baseState=this._state;this._state=51/* BeforeEntity */;this._sectionStart=this._index;}};Tokenizer.prototype._stateBeforeDeclaration=function(c){this._state=c==="["?22/* BeforeCdata1 */:c==="-"?18/* BeforeComment */:16/* InDeclaration */;};Tokenizer.prototype._stateInDeclaration=function(c){if(c===">"){this._cbs.ondeclaration(this._getSection());this._state=1/* Text */;this._sectionStart=this._index+1;}};Tokenizer.prototype._stateInProcessingInstruction=function(c){if(c===">"){this._cbs.onprocessinginstruction(this._getSection());this._state=1/* Text */;this._sectionStart=this._index+1;}};Tokenizer.prototype._stateBeforeComment=function(c){if(c==="-"){this._state=19/* InComment */;this._sectionStart=this._index+1;}else{this._state=16/* InDeclaration */;}};Tokenizer.prototype._stateInComment=function(c){if(c==="-")this._state=20/* AfterComment1 */;};Tokenizer.prototype._stateAfterComment1=function(c){if(c==="-"){this._state=21/* AfterComment2 */;}else{this._state=19/* InComment */;}};Tokenizer.prototype._stateAfterComment2=function(c){if(c===">"){//remove 2 trailing chars
	this._cbs.oncomment(this._buffer.substring(this._sectionStart,this._index-2));this._state=1/* Text */;this._sectionStart=this._index+1;}else if(c!=="-"){this._state=19/* InComment */;}// else: stay in AFTER_COMMENT_2 (`--->`)
	};Tokenizer.prototype._stateBeforeCdata6=function(c){if(c==="["){this._state=28/* InCdata */;this._sectionStart=this._index+1;}else{this._state=16/* InDeclaration */;this._index--;}};Tokenizer.prototype._stateInCdata=function(c){if(c==="]")this._state=29/* AfterCdata1 */;};Tokenizer.prototype._stateAfterCdata1=function(c){if(c==="]")this._state=30/* AfterCdata2 */;else this._state=28/* InCdata */;};Tokenizer.prototype._stateAfterCdata2=function(c){if(c===">"){//remove 2 trailing chars
	this._cbs.oncdata(this._buffer.substring(this._sectionStart,this._index-2));this._state=1/* Text */;this._sectionStart=this._index+1;}else if(c!=="]"){this._state=28/* InCdata */;}//else: stay in AFTER_CDATA_2 (`]]]>`)
	};Tokenizer.prototype._stateBeforeSpecial=function(c){if(c==="c"||c==="C"){this._state=33/* BeforeScript1 */;}else if(c==="t"||c==="T"){this._state=43/* BeforeStyle1 */;}else{this._state=3/* InTagName */;this._index--;//consume the token again
	}};Tokenizer.prototype._stateBeforeSpecialEnd=function(c){if(this._special===2/* Script */&&(c==="c"||c==="C")){this._state=38/* AfterScript1 */;}else if(this._special===3/* Style */&&(c==="t"||c==="T")){this._state=47/* AfterStyle1 */;}else this._state=1/* Text */;};Tokenizer.prototype._stateBeforeScript5=function(c){if(c==="/"||c===">"||whitespace(c)){this._special=2/* Script */;}this._state=3/* InTagName */;this._index--;//consume the token again
	};Tokenizer.prototype._stateAfterScript5=function(c){if(c===">"||whitespace(c)){this._special=1/* None */;this._state=6/* InClosingTagName */;this._sectionStart=this._index-6;this._index--;//reconsume the token
	}else this._state=1/* Text */;};Tokenizer.prototype._stateBeforeStyle4=function(c){if(c==="/"||c===">"||whitespace(c)){this._special=3/* Style */;}this._state=3/* InTagName */;this._index--;//consume the token again
	};Tokenizer.prototype._stateAfterStyle4=function(c){if(c===">"||whitespace(c)){this._special=1/* None */;this._state=6/* InClosingTagName */;this._sectionStart=this._index-5;this._index--;//reconsume the token
	}else this._state=1/* Text */;};//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict=function(){//offset = 1
	if(this._sectionStart+1<this._index){var entity=this._buffer.substring(this._sectionStart+1,this._index),map=this._xmlMode?xml_json_1["default"]:entities_json_1["default"];if(Object.prototype.hasOwnProperty.call(map,entity)){// @ts-ignore
	this._emitPartial(map[entity]);this._sectionStart=this._index+1;}}};//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity=function(){var start=this._sectionStart+1;var limit=this._index-start;if(limit>6)limit=6;// The max length of legacy entities is 6
	while(limit>=2){// The min length of legacy entities is 2
	var entity=this._buffer.substr(start,limit);if(Object.prototype.hasOwnProperty.call(legacy_json_1["default"],entity)){// @ts-ignore
	this._emitPartial(legacy_json_1["default"][entity]);this._sectionStart+=limit+1;return;}else{limit--;}}};Tokenizer.prototype._stateInNamedEntity=function(c){if(c===";"){this._parseNamedEntityStrict();if(this._sectionStart+1<this._index&&!this._xmlMode){this._parseLegacyEntity();}this._state=this._baseState;}else if((c<"a"||c>"z")&&(c<"A"||c>"Z")&&(c<"0"||c>"9")){if(this._xmlMode||this._sectionStart+1===this._index){// ignore
	}else if(this._baseState!==1/* Text */){if(c!=="="){this._parseNamedEntityStrict();}}else{this._parseLegacyEntity();}this._state=this._baseState;this._index--;}};Tokenizer.prototype._decodeNumericEntity=function(offset,base){var sectionStart=this._sectionStart+offset;if(sectionStart!==this._index){//parse entity
	var entity=this._buffer.substring(sectionStart,this._index);var parsed=parseInt(entity,base);this._emitPartial(decode_codepoint_1["default"](parsed));this._sectionStart=this._index;}else{this._sectionStart--;}this._state=this._baseState;};Tokenizer.prototype._stateInNumericEntity=function(c){if(c===";"){this._decodeNumericEntity(2,10);this._sectionStart++;}else if(c<"0"||c>"9"){if(!this._xmlMode){this._decodeNumericEntity(2,10);}else{this._state=this._baseState;}this._index--;}};Tokenizer.prototype._stateInHexEntity=function(c){if(c===";"){this._decodeNumericEntity(3,16);this._sectionStart++;}else if((c<"a"||c>"f")&&(c<"A"||c>"F")&&(c<"0"||c>"9")){if(!this._xmlMode){this._decodeNumericEntity(3,16);}else{this._state=this._baseState;}this._index--;}};Tokenizer.prototype._cleanup=function(){if(this._sectionStart<0){this._buffer="";this._bufferOffset+=this._index;this._index=0;}else if(this._running){if(this._state===1/* Text */){if(this._sectionStart!==this._index){this._cbs.ontext(this._buffer.substr(this._sectionStart));}this._buffer="";this._bufferOffset+=this._index;this._index=0;}else if(this._sectionStart===this._index){//the section just started
	this._buffer="";this._bufferOffset+=this._index;this._index=0;}else{//remove everything unnecessary
	this._buffer=this._buffer.substr(this._sectionStart);this._index-=this._sectionStart;this._bufferOffset+=this._sectionStart;}this._sectionStart=0;}};//TODO make events conditional
	Tokenizer.prototype.write=function(chunk){if(this._ended)this._cbs.onerror(Error(".write() after done!"));this._buffer+=chunk;this._parse();};// Iterates through the buffer, calling the function corresponding to the current state.
	// States that are more likely to be hit are higher up, as a performance improvement.
	Tokenizer.prototype._parse=function(){while(this._index<this._buffer.length&&this._running){var c=this._buffer.charAt(this._index);if(this._state===1/* Text */){this._stateText(c);}else if(this._state===12/* InAttributeValueDq */){this._stateInAttributeValueDoubleQuotes(c);}else if(this._state===9/* InAttributeName */){this._stateInAttributeName(c);}else if(this._state===19/* InComment */){this._stateInComment(c);}else if(this._state===8/* BeforeAttributeName */){this._stateBeforeAttributeName(c);}else if(this._state===3/* InTagName */){this._stateInTagName(c);}else if(this._state===6/* InClosingTagName */){this._stateInClosingTagName(c);}else if(this._state===2/* BeforeTagName */){this._stateBeforeTagName(c);}else if(this._state===10/* AfterAttributeName */){this._stateAfterAttributeName(c);}else if(this._state===13/* InAttributeValueSq */){this._stateInAttributeValueSingleQuotes(c);}else if(this._state===11/* BeforeAttributeValue */){this._stateBeforeAttributeValue(c);}else if(this._state===5/* BeforeClosingTagName */){this._stateBeforeClosingTagName(c);}else if(this._state===7/* AfterClosingTagName */){this._stateAfterClosingTagName(c);}else if(this._state===31/* BeforeSpecial */){this._stateBeforeSpecial(c);}else if(this._state===20/* AfterComment1 */){this._stateAfterComment1(c);}else if(this._state===14/* InAttributeValueNq */){this._stateInAttributeValueNoQuotes(c);}else if(this._state===4/* InSelfClosingTag */){this._stateInSelfClosingTag(c);}else if(this._state===16/* InDeclaration */){this._stateInDeclaration(c);}else if(this._state===15/* BeforeDeclaration */){this._stateBeforeDeclaration(c);}else if(this._state===21/* AfterComment2 */){this._stateAfterComment2(c);}else if(this._state===18/* BeforeComment */){this._stateBeforeComment(c);}else if(this._state===32/* BeforeSpecialEnd */){this._stateBeforeSpecialEnd(c);}else if(this._state===38/* AfterScript1 */){stateAfterScript1(this,c);}else if(this._state===39/* AfterScript2 */){stateAfterScript2(this,c);}else if(this._state===40/* AfterScript3 */){stateAfterScript3(this,c);}else if(this._state===33/* BeforeScript1 */){stateBeforeScript1(this,c);}else if(this._state===34/* BeforeScript2 */){stateBeforeScript2(this,c);}else if(this._state===35/* BeforeScript3 */){stateBeforeScript3(this,c);}else if(this._state===36/* BeforeScript4 */){stateBeforeScript4(this,c);}else if(this._state===37/* BeforeScript5 */){this._stateBeforeScript5(c);}else if(this._state===41/* AfterScript4 */){stateAfterScript4(this,c);}else if(this._state===42/* AfterScript5 */){this._stateAfterScript5(c);}else if(this._state===43/* BeforeStyle1 */){stateBeforeStyle1(this,c);}else if(this._state===28/* InCdata */){this._stateInCdata(c);}else if(this._state===44/* BeforeStyle2 */){stateBeforeStyle2(this,c);}else if(this._state===45/* BeforeStyle3 */){stateBeforeStyle3(this,c);}else if(this._state===46/* BeforeStyle4 */){this._stateBeforeStyle4(c);}else if(this._state===47/* AfterStyle1 */){stateAfterStyle1(this,c);}else if(this._state===48/* AfterStyle2 */){stateAfterStyle2(this,c);}else if(this._state===49/* AfterStyle3 */){stateAfterStyle3(this,c);}else if(this._state===50/* AfterStyle4 */){this._stateAfterStyle4(c);}else if(this._state===17/* InProcessingInstruction */){this._stateInProcessingInstruction(c);}else if(this._state===53/* InNamedEntity */){this._stateInNamedEntity(c);}else if(this._state===22/* BeforeCdata1 */){stateBeforeCdata1(this,c);}else if(this._state===51/* BeforeEntity */){stateBeforeEntity(this,c);}else if(this._state===23/* BeforeCdata2 */){stateBeforeCdata2(this,c);}else if(this._state===24/* BeforeCdata3 */){stateBeforeCdata3(this,c);}else if(this._state===29/* AfterCdata1 */){this._stateAfterCdata1(c);}else if(this._state===30/* AfterCdata2 */){this._stateAfterCdata2(c);}else if(this._state===25/* BeforeCdata4 */){stateBeforeCdata4(this,c);}else if(this._state===26/* BeforeCdata5 */){stateBeforeCdata5(this,c);}else if(this._state===27/* BeforeCdata6 */){this._stateBeforeCdata6(c);}else if(this._state===55/* InHexEntity */){this._stateInHexEntity(c);}else if(this._state===54/* InNumericEntity */){this._stateInNumericEntity(c);}else if(this._state===52/* BeforeNumericEntity */){stateBeforeNumericEntity(this,c);}else{this._cbs.onerror(Error("unknown _state"),this._state);}this._index++;}this._cleanup();};Tokenizer.prototype.pause=function(){this._running=false;};Tokenizer.prototype.resume=function(){this._running=true;if(this._index<this._buffer.length){this._parse();}if(this._ended){this._finish();}};Tokenizer.prototype.end=function(chunk){if(this._ended)this._cbs.onerror(Error(".end() after done!"));if(chunk)this.write(chunk);this._ended=true;if(this._running)this._finish();};Tokenizer.prototype._finish=function(){//if there is remaining data, emit it in a reasonable way
	if(this._sectionStart<this._index){this._handleTrailingData();}this._cbs.onend();};Tokenizer.prototype._handleTrailingData=function(){var data=this._buffer.substr(this._sectionStart);if(this._state===28/* InCdata */||this._state===29/* AfterCdata1 */||this._state===30/* AfterCdata2 */){this._cbs.oncdata(data);}else if(this._state===19/* InComment */||this._state===20/* AfterComment1 */||this._state===21/* AfterComment2 */){this._cbs.oncomment(data);}else if(this._state===53/* InNamedEntity */&&!this._xmlMode){this._parseLegacyEntity();if(this._sectionStart<this._index){this._state=this._baseState;this._handleTrailingData();}}else if(this._state===54/* InNumericEntity */&&!this._xmlMode){this._decodeNumericEntity(2,10);if(this._sectionStart<this._index){this._state=this._baseState;this._handleTrailingData();}}else if(this._state===55/* InHexEntity */&&!this._xmlMode){this._decodeNumericEntity(3,16);if(this._sectionStart<this._index){this._state=this._baseState;this._handleTrailingData();}}else if(this._state!==3/* InTagName */&&this._state!==8/* BeforeAttributeName */&&this._state!==11/* BeforeAttributeValue */&&this._state!==10/* AfterAttributeName */&&this._state!==9/* InAttributeName */&&this._state!==13/* InAttributeValueSq */&&this._state!==12/* InAttributeValueDq */&&this._state!==14/* InAttributeValueNq */&&this._state!==6/* InClosingTagName */){this._cbs.ontext(data);}//else, ignore remaining data
	//TODO add a way to remove current tag
	};Tokenizer.prototype.getAbsoluteIndex=function(){return this._bufferOffset+this._index;};Tokenizer.prototype._getSection=function(){return this._buffer.substring(this._sectionStart,this._index);};Tokenizer.prototype._emitToken=function(name){this._cbs[name](this._getSection());this._sectionStart=-1;};Tokenizer.prototype._emitPartial=function(value){if(this._baseState!==1/* Text */){this._cbs.onattribdata(value);//TODO implement the new event
	}else{this._cbs.ontext(value);}};return Tokenizer;}();exports["default"]=Tokenizer;},{"entities/lib/decode_codepoint":18,"entities/lib/maps/entities.json":22,"entities/lib/maps/legacy.json":23,"entities/lib/maps/xml.json":24}],31:[function(require,module,exports){"use strict";function __export(m){for(var p in m){if(!exports.hasOwnProperty(p))exports[p]=m[p];}}var __importStar=this&&this.__importStar||function(mod){if(mod&&mod.__esModule)return mod;var result={};if(mod!=null)for(var k in mod){if(Object.hasOwnProperty.call(mod,k))result[k]=mod[k];}result["default"]=mod;return result;};Object.defineProperty(exports,"__esModule",{value:true});var Parser_1=require("./Parser");exports.Parser=Parser_1.Parser;var domhandler_1=require("domhandler");exports.DomHandler=domhandler_1.DomHandler;exports.DefaultHandler=domhandler_1.DomHandler;// Helper methods
	/**
	 * Parses data, returns the resulting DOM.
	 *
	 * @param data The data that should be parsed.
	 * @param options Optional options for the parser and DOM builder.
	 */function parseDOM(data,options){var handler=new domhandler_1.DomHandler(void 0,options);new Parser_1.Parser(handler,options).end(data);return handler.dom;}exports.parseDOM=parseDOM;/**
	 * Creates a parser instance, with an attached DOM handler.
	 *
	 * @param cb A callback that will be called once parsing has been completed.
	 * @param options Optional options for the parser and DOM builder.
	 * @param elementCb An optional callback that will be called every time a tag has been completed inside of the DOM.
	 */function createDomStream(cb,options,elementCb){var handler=new domhandler_1.DomHandler(cb,options,elementCb);return new Parser_1.Parser(handler,options);}exports.createDomStream=createDomStream;var Tokenizer_1=require("./Tokenizer");exports.Tokenizer=Tokenizer_1["default"];var ElementType=__importStar(require("domelementtype"));exports.ElementType=ElementType;/**
	 * List of all events that the parser emits.
	 *
	 * Format: eventname: number of arguments.
	 */exports.EVENTS={attribute:2,cdatastart:0,cdataend:0,text:1,processinginstruction:2,comment:1,commentend:0,closetag:1,opentag:2,opentagname:1,error:1,end:0};/*
	    All of the following exports exist for backwards-compatibility.
	    They should probably be removed eventually.
	*/__export(require("./FeedHandler"));__export(require("./WritableStream"));__export(require("./CollectingHandler"));var DomUtils=__importStar(require("domutils"));exports.DomUtils=DomUtils;var FeedHandler_1=require("./FeedHandler");exports.RssHandler=FeedHandler_1.FeedHandler;},{"./CollectingHandler":26,"./FeedHandler":27,"./Parser":29,"./Tokenizer":30,"./WritableStream":2,"domelementtype":6,"domhandler":7,"domutils":10}],32:[function(require,module,exports){exports.read=function(buffer,offset,isLE,mLen,nBytes){var e,m;var eLen=nBytes*8-mLen-1;var eMax=(1<<eLen)-1;var eBias=eMax>>1;var nBits=-7;var i=isLE?nBytes-1:0;var d=isLE?-1:1;var s=buffer[offset+i];i+=d;e=s&(1<<-nBits)-1;s>>=-nBits;nBits+=eLen;for(;nBits>0;e=e*256+buffer[offset+i],i+=d,nBits-=8){}m=e&(1<<-nBits)-1;e>>=-nBits;nBits+=mLen;for(;nBits>0;m=m*256+buffer[offset+i],i+=d,nBits-=8){}if(e===0){e=1-eBias;}else if(e===eMax){return m?NaN:(s?-1:1)*Infinity;}else{m=m+Math.pow(2,mLen);e=e-eBias;}return(s?-1:1)*m*Math.pow(2,e-mLen);};exports.write=function(buffer,value,offset,isLE,mLen,nBytes){var e,m,c;var eLen=nBytes*8-mLen-1;var eMax=(1<<eLen)-1;var eBias=eMax>>1;var rt=mLen===23?Math.pow(2,-24)-Math.pow(2,-77):0;var i=isLE?0:nBytes-1;var d=isLE?1:-1;var s=value<0||value===0&&1/value<0?1:0;value=Math.abs(value);if(isNaN(value)||value===Infinity){m=isNaN(value)?1:0;e=eMax;}else{e=Math.floor(Math.log(value)/Math.LN2);if(value*(c=Math.pow(2,-e))<1){e--;c*=2;}if(e+eBias>=1){value+=rt/c;}else{value+=rt*Math.pow(2,1-eBias);}if(value*c>=2){e++;c/=2;}if(e+eBias>=eMax){m=0;e=eMax;}else if(e+eBias>=1){m=(value*c-1)*Math.pow(2,mLen);e=e+eBias;}else{m=value*Math.pow(2,eBias-1)*Math.pow(2,mLen);e=0;}}for(;mLen>=8;buffer[offset+i]=m&0xff,i+=d,m/=256,mLen-=8){}e=e<<mLen|m;eLen+=mLen;for(;eLen>0;buffer[offset+i]=e&0xff,i+=d,e/=256,eLen-=8){}buffer[offset+i-d]|=s*128;};},{}],33:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var DataView=getNative(root,'DataView');module.exports=DataView;},{"./_getNative":93,"./_root":130}],34:[function(require,module,exports){var hashClear=require('./_hashClear'),hashDelete=require('./_hashDelete'),hashGet=require('./_hashGet'),hashHas=require('./_hashHas'),hashSet=require('./_hashSet');/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}// Add methods to `Hash`.
	Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;module.exports=Hash;},{"./_hashClear":100,"./_hashDelete":101,"./_hashGet":102,"./_hashHas":103,"./_hashSet":104}],35:[function(require,module,exports){var listCacheClear=require('./_listCacheClear'),listCacheDelete=require('./_listCacheDelete'),listCacheGet=require('./_listCacheGet'),listCacheHas=require('./_listCacheHas'),listCacheSet=require('./_listCacheSet');/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}// Add methods to `ListCache`.
	ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;module.exports=ListCache;},{"./_listCacheClear":113,"./_listCacheDelete":114,"./_listCacheGet":115,"./_listCacheHas":116,"./_listCacheSet":117}],36:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var Map=getNative(root,'Map');module.exports=Map;},{"./_getNative":93,"./_root":130}],37:[function(require,module,exports){var mapCacheClear=require('./_mapCacheClear'),mapCacheDelete=require('./_mapCacheDelete'),mapCacheGet=require('./_mapCacheGet'),mapCacheHas=require('./_mapCacheHas'),mapCacheSet=require('./_mapCacheSet');/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}// Add methods to `MapCache`.
	MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;module.exports=MapCache;},{"./_mapCacheClear":118,"./_mapCacheDelete":119,"./_mapCacheGet":120,"./_mapCacheHas":121,"./_mapCacheSet":122}],38:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var Promise=getNative(root,'Promise');module.exports=Promise;},{"./_getNative":93,"./_root":130}],39:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var Set=getNative(root,'Set');module.exports=Set;},{"./_getNative":93,"./_root":130}],40:[function(require,module,exports){var ListCache=require('./_ListCache'),stackClear=require('./_stackClear'),stackDelete=require('./_stackDelete'),stackGet=require('./_stackGet'),stackHas=require('./_stackHas'),stackSet=require('./_stackSet');/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}// Add methods to `Stack`.
	Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;module.exports=Stack;},{"./_ListCache":35,"./_stackClear":134,"./_stackDelete":135,"./_stackGet":136,"./_stackHas":137,"./_stackSet":138}],41:[function(require,module,exports){var root=require('./_root');/** Built-in value references. */var _Symbol=root.Symbol;module.exports=_Symbol;},{"./_root":130}],42:[function(require,module,exports){var root=require('./_root');/** Built-in value references. */var Uint8Array=root.Uint8Array;module.exports=Uint8Array;},{"./_root":130}],43:[function(require,module,exports){var getNative=require('./_getNative'),root=require('./_root');/* Built-in method references that are verified to be native. */var WeakMap=getNative(root,'WeakMap');module.exports=WeakMap;},{"./_getNative":93,"./_root":130}],44:[function(require,module,exports){/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}module.exports=apply;},{}],45:[function(require,module,exports){/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}module.exports=arrayEach;},{}],46:[function(require,module,exports){/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}module.exports=arrayFilter;},{}],47:[function(require,module,exports){var baseTimes=require('./_baseTimes'),isArguments=require('./isArguments'),isArray=require('./isArray'),isBuffer=require('./isBuffer'),isIndex=require('./_isIndex'),isTypedArray=require('./isTypedArray');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
	key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
	isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
	isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
	isIndex(key,length)))){result.push(key);}}return result;}module.exports=arrayLikeKeys;},{"./_baseTimes":72,"./_isIndex":108,"./isArguments":145,"./isArray":146,"./isBuffer":149,"./isTypedArray":159}],48:[function(require,module,exports){/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}module.exports=arrayMap;},{}],49:[function(require,module,exports){/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}module.exports=arrayPush;},{}],50:[function(require,module,exports){var baseAssignValue=require('./_baseAssignValue'),eq=require('./eq');/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}module.exports=assignMergeValue;},{"./_baseAssignValue":55,"./eq":142}],51:[function(require,module,exports){var baseAssignValue=require('./_baseAssignValue'),eq=require('./eq');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}module.exports=assignValue;},{"./_baseAssignValue":55,"./eq":142}],52:[function(require,module,exports){var eq=require('./eq');/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}module.exports=assocIndexOf;},{"./eq":142}],53:[function(require,module,exports){var copyObject=require('./_copyObject'),keys=require('./keys');/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}module.exports=baseAssign;},{"./_copyObject":82,"./keys":160}],54:[function(require,module,exports){var copyObject=require('./_copyObject'),keysIn=require('./keysIn');/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}module.exports=baseAssignIn;},{"./_copyObject":82,"./keysIn":161}],55:[function(require,module,exports){var defineProperty=require('./_defineProperty');/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}module.exports=baseAssignValue;},{"./_defineProperty":88}],56:[function(require,module,exports){var Stack=require('./_Stack'),arrayEach=require('./_arrayEach'),assignValue=require('./_assignValue'),baseAssign=require('./_baseAssign'),baseAssignIn=require('./_baseAssignIn'),cloneBuffer=require('./_cloneBuffer'),copyArray=require('./_copyArray'),copySymbols=require('./_copySymbols'),copySymbolsIn=require('./_copySymbolsIn'),getAllKeys=require('./_getAllKeys'),getAllKeysIn=require('./_getAllKeysIn'),getTag=require('./_getTag'),initCloneArray=require('./_initCloneArray'),initCloneByTag=require('./_initCloneByTag'),initCloneObject=require('./_initCloneObject'),isArray=require('./isArray'),isBuffer=require('./isBuffer'),isMap=require('./isMap'),isObject=require('./isObject'),isSet=require('./isSet'),keys=require('./keys'),keysIn=require('./keysIn');/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',boolTag='[object Boolean]',dateTag='[object Date]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',objectTag='[object Object]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',weakMapTag='[object WeakMap]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
	stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});}else if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
	assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}module.exports=baseClone;},{"./_Stack":40,"./_arrayEach":45,"./_assignValue":51,"./_baseAssign":53,"./_baseAssignIn":54,"./_cloneBuffer":76,"./_copyArray":81,"./_copySymbols":83,"./_copySymbolsIn":84,"./_getAllKeys":90,"./_getAllKeysIn":91,"./_getTag":98,"./_initCloneArray":105,"./_initCloneByTag":106,"./_initCloneObject":107,"./isArray":146,"./isBuffer":149,"./isMap":152,"./isObject":153,"./isSet":156,"./keys":160,"./keysIn":161}],57:[function(require,module,exports){var isObject=require('./isObject');/** Built-in value references. */var objectCreate=Object.create;/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();module.exports=baseCreate;},{"./isObject":153}],58:[function(require,module,exports){var createBaseFor=require('./_createBaseFor');/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */var baseFor=createBaseFor();module.exports=baseFor;},{"./_createBaseFor":87}],59:[function(require,module,exports){var arrayPush=require('./_arrayPush'),isArray=require('./isArray');/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}module.exports=baseGetAllKeys;},{"./_arrayPush":49,"./isArray":146}],60:[function(require,module,exports){var _Symbol2=require('./_Symbol'),getRawTag=require('./_getRawTag'),objectToString=require('./_objectToString');/** `Object#toString` result references. */var nullTag='[object Null]',undefinedTag='[object Undefined]';/** Built-in value references. */var symToStringTag=_Symbol2?_Symbol2.toStringTag:undefined;/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}module.exports=baseGetTag;},{"./_Symbol":41,"./_getRawTag":95,"./_objectToString":127}],61:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var argsTag='[object Arguments]';/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}module.exports=baseIsArguments;},{"./_baseGetTag":60,"./isObjectLike":154}],62:[function(require,module,exports){var getTag=require('./_getTag'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var mapTag='[object Map]';/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}module.exports=baseIsMap;},{"./_getTag":98,"./isObjectLike":154}],63:[function(require,module,exports){var isFunction=require('./isFunction'),isMasked=require('./_isMasked'),isObject=require('./isObject'),toSource=require('./_toSource');/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used for built-in method references. */var funcProto=Function.prototype,objectProto=Object.prototype;/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}module.exports=baseIsNative;},{"./_isMasked":111,"./_toSource":139,"./isFunction":150,"./isObject":153}],64:[function(require,module,exports){var getTag=require('./_getTag'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var setTag='[object Set]';/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}module.exports=baseIsSet;},{"./_getTag":98,"./isObjectLike":154}],65:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isLength=require('./isLength'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',boolTag='[object Boolean]',dateTag='[object Date]',errorTag='[object Error]',funcTag='[object Function]',mapTag='[object Map]',numberTag='[object Number]',objectTag='[object Object]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',weakMapTag='[object WeakMap]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}module.exports=baseIsTypedArray;},{"./_baseGetTag":60,"./isLength":151,"./isObjectLike":154}],66:[function(require,module,exports){var isPrototype=require('./_isPrototype'),nativeKeys=require('./_nativeKeys');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}module.exports=baseKeys;},{"./_isPrototype":112,"./_nativeKeys":124}],67:[function(require,module,exports){var isObject=require('./isObject'),isPrototype=require('./_isPrototype'),nativeKeysIn=require('./_nativeKeysIn');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}module.exports=baseKeysIn;},{"./_isPrototype":112,"./_nativeKeysIn":125,"./isObject":153}],68:[function(require,module,exports){var Stack=require('./_Stack'),assignMergeValue=require('./_assignMergeValue'),baseFor=require('./_baseFor'),baseMergeDeep=require('./_baseMergeDeep'),isObject=require('./isObject'),keysIn=require('./keysIn'),safeGet=require('./_safeGet');/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){stack||(stack=new Stack());if(isObject(srcValue)){baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}module.exports=baseMerge;},{"./_Stack":40,"./_assignMergeValue":50,"./_baseFor":58,"./_baseMergeDeep":69,"./_safeGet":131,"./isObject":153,"./keysIn":161}],69:[function(require,module,exports){var assignMergeValue=require('./_assignMergeValue'),cloneBuffer=require('./_cloneBuffer'),cloneTypedArray=require('./_cloneTypedArray'),copyArray=require('./_copyArray'),initCloneObject=require('./_initCloneObject'),isArguments=require('./isArguments'),isArray=require('./isArray'),isArrayLikeObject=require('./isArrayLikeObject'),isBuffer=require('./isBuffer'),isFunction=require('./isFunction'),isObject=require('./isObject'),isPlainObject=require('./isPlainObject'),isTypedArray=require('./isTypedArray'),safeGet=require('./_safeGet'),toPlainObject=require('./toPlainObject');/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
	stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}module.exports=baseMergeDeep;},{"./_assignMergeValue":50,"./_cloneBuffer":76,"./_cloneTypedArray":80,"./_copyArray":81,"./_initCloneObject":107,"./_safeGet":131,"./isArguments":145,"./isArray":146,"./isArrayLikeObject":148,"./isBuffer":149,"./isFunction":150,"./isObject":153,"./isPlainObject":155,"./isTypedArray":159,"./toPlainObject":165}],70:[function(require,module,exports){var identity=require('./identity'),overRest=require('./_overRest'),setToString=require('./_setToString');/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}module.exports=baseRest;},{"./_overRest":129,"./_setToString":132,"./identity":144}],71:[function(require,module,exports){var constant=require('./constant'),defineProperty=require('./_defineProperty'),identity=require('./identity');/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};module.exports=baseSetToString;},{"./_defineProperty":88,"./constant":141,"./identity":144}],72:[function(require,module,exports){/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}module.exports=baseTimes;},{}],73:[function(require,module,exports){var _Symbol3=require('./_Symbol'),arrayMap=require('./_arrayMap'),isArray=require('./isArray'),isSymbol=require('./isSymbol');/** Used as references for various `Number` constants. */var INFINITY=1/0;/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol3?_Symbol3.prototype:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
	if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
	return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}module.exports=baseToString;},{"./_Symbol":41,"./_arrayMap":48,"./isArray":146,"./isSymbol":158}],74:[function(require,module,exports){/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */function baseUnary(func){return function(value){return func(value);};}module.exports=baseUnary;},{}],75:[function(require,module,exports){var Uint8Array=require('./_Uint8Array');/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}module.exports=cloneArrayBuffer;},{"./_Uint8Array":42}],76:[function(require,module,exports){var root=require('./_root');/** Detect free variable `exports`. */var freeExports=_typeof(exports)=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&_typeof(module)=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Built-in value references. */var Buffer=moduleExports?root.Buffer:undefined,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined;/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}module.exports=cloneBuffer;},{"./_root":130}],77:[function(require,module,exports){var cloneArrayBuffer=require('./_cloneArrayBuffer');/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}module.exports=cloneDataView;},{"./_cloneArrayBuffer":75}],78:[function(require,module,exports){/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}module.exports=cloneRegExp;},{}],79:[function(require,module,exports){var _Symbol4=require('./_Symbol');/** Used to convert symbols to primitives and strings. */var symbolProto=_Symbol4?_Symbol4.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined;/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}module.exports=cloneSymbol;},{"./_Symbol":41}],80:[function(require,module,exports){var cloneArrayBuffer=require('./_cloneArrayBuffer');/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}module.exports=cloneTypedArray;},{"./_cloneArrayBuffer":75}],81:[function(require,module,exports){/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}module.exports=copyArray;},{}],82:[function(require,module,exports){var assignValue=require('./_assignValue'),baseAssignValue=require('./_baseAssignValue');/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}module.exports=copyObject;},{"./_assignValue":51,"./_baseAssignValue":55}],83:[function(require,module,exports){var copyObject=require('./_copyObject'),getSymbols=require('./_getSymbols');/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}module.exports=copySymbols;},{"./_copyObject":82,"./_getSymbols":96}],84:[function(require,module,exports){var copyObject=require('./_copyObject'),getSymbolsIn=require('./_getSymbolsIn');/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}module.exports=copySymbolsIn;},{"./_copyObject":82,"./_getSymbolsIn":97}],85:[function(require,module,exports){var root=require('./_root');/** Used to detect overreaching core-js shims. */var coreJsData=root['__core-js_shared__'];module.exports=coreJsData;},{"./_root":130}],86:[function(require,module,exports){var baseRest=require('./_baseRest'),isIterateeCall=require('./_isIterateeCall');/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}module.exports=createAssigner;},{"./_baseRest":70,"./_isIterateeCall":109}],87:[function(require,module,exports){/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}module.exports=createBaseFor;},{}],88:[function(require,module,exports){var getNative=require('./_getNative');var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();module.exports=defineProperty;},{"./_getNative":93}],89:[function(require,module,exports){(function(global){/** Detect free variable `global` from Node.js. */var freeGlobal=_typeof(global)=='object'&&global&&global.Object===Object&&global;module.exports=freeGlobal;}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{}],90:[function(require,module,exports){var baseGetAllKeys=require('./_baseGetAllKeys'),getSymbols=require('./_getSymbols'),keys=require('./keys');/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}module.exports=getAllKeys;},{"./_baseGetAllKeys":59,"./_getSymbols":96,"./keys":160}],91:[function(require,module,exports){var baseGetAllKeys=require('./_baseGetAllKeys'),getSymbolsIn=require('./_getSymbolsIn'),keysIn=require('./keysIn');/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}module.exports=getAllKeysIn;},{"./_baseGetAllKeys":59,"./_getSymbolsIn":97,"./keysIn":161}],92:[function(require,module,exports){var isKeyable=require('./_isKeyable');/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}module.exports=getMapData;},{"./_isKeyable":110}],93:[function(require,module,exports){var baseIsNative=require('./_baseIsNative'),getValue=require('./_getValue');/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}module.exports=getNative;},{"./_baseIsNative":63,"./_getValue":99}],94:[function(require,module,exports){var overArg=require('./_overArg');/** Built-in value references. */var getPrototype=overArg(Object.getPrototypeOf,Object);module.exports=getPrototype;},{"./_overArg":128}],95:[function(require,module,exports){var _Symbol5=require('./_Symbol');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */var nativeObjectToString=objectProto.toString;/** Built-in value references. */var symToStringTag=_Symbol5?_Symbol5.toStringTag:undefined;/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}module.exports=getRawTag;},{"./_Symbol":41}],96:[function(require,module,exports){var arrayFilter=require('./_arrayFilter'),stubArray=require('./stubArray');/** Used for built-in method references. */var objectProto=Object.prototype;/** Built-in value references. */var propertyIsEnumerable=objectProto.propertyIsEnumerable;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeGetSymbols=Object.getOwnPropertySymbols;/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};module.exports=getSymbols;},{"./_arrayFilter":46,"./stubArray":163}],97:[function(require,module,exports){var arrayPush=require('./_arrayPush'),getPrototype=require('./_getPrototype'),getSymbols=require('./_getSymbols'),stubArray=require('./stubArray');/* Built-in method references for those with the same name as other `lodash` methods. */var nativeGetSymbols=Object.getOwnPropertySymbols;/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};module.exports=getSymbolsIn;},{"./_arrayPush":49,"./_getPrototype":94,"./_getSymbols":96,"./stubArray":163}],98:[function(require,module,exports){var DataView=require('./_DataView'),Map=require('./_Map'),Promise=require('./_Promise'),Set=require('./_Set'),WeakMap=require('./_WeakMap'),baseGetTag=require('./_baseGetTag'),toSource=require('./_toSource');/** `Object#toString` result references. */var mapTag='[object Map]',objectTag='[object Object]',promiseTag='[object Promise]',setTag='[object Set]',weakMapTag='[object WeakMap]';var dataViewTag='[object DataView]';/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function getTag(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}module.exports=getTag;},{"./_DataView":33,"./_Map":36,"./_Promise":38,"./_Set":39,"./_WeakMap":43,"./_baseGetTag":60,"./_toSource":139}],99:[function(require,module,exports){/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */function getValue(object,key){return object==null?undefined:object[key];}module.exports=getValue;},{}],100:[function(require,module,exports){var nativeCreate=require('./_nativeCreate');/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}module.exports=hashClear;},{"./_nativeCreate":123}],101:[function(require,module,exports){/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}module.exports=hashDelete;},{}],102:[function(require,module,exports){var nativeCreate=require('./_nativeCreate');/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}module.exports=hashGet;},{"./_nativeCreate":123}],103:[function(require,module,exports){var nativeCreate=require('./_nativeCreate');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}module.exports=hashHas;},{"./_nativeCreate":123}],104:[function(require,module,exports){var nativeCreate=require('./_nativeCreate');/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}module.exports=hashSet;},{"./_nativeCreate":123}],105:[function(require,module,exports){/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
	if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}module.exports=initCloneArray;},{}],106:[function(require,module,exports){var cloneArrayBuffer=require('./_cloneArrayBuffer'),cloneDataView=require('./_cloneDataView'),cloneRegExp=require('./_cloneRegExp'),cloneSymbol=require('./_cloneSymbol'),cloneTypedArray=require('./_cloneTypedArray');/** `Object#toString` result references. */var boolTag='[object Boolean]',dateTag='[object Date]',mapTag='[object Map]',numberTag='[object Number]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}module.exports=initCloneByTag;},{"./_cloneArrayBuffer":75,"./_cloneDataView":77,"./_cloneRegExp":78,"./_cloneSymbol":79,"./_cloneTypedArray":80}],107:[function(require,module,exports){var baseCreate=require('./_baseCreate'),getPrototype=require('./_getPrototype'),isPrototype=require('./_isPrototype');/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}module.exports=initCloneObject;},{"./_baseCreate":57,"./_getPrototype":94,"./_isPrototype":112}],108:[function(require,module,exports){/** Used as references for various `Number` constants. */var MAX_SAFE_INTEGER=9007199254740991;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */function isIndex(value,length){var type=_typeof(value);length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}module.exports=isIndex;},{}],109:[function(require,module,exports){var eq=require('./eq'),isArrayLike=require('./isArrayLike'),isIndex=require('./_isIndex'),isObject=require('./isObject');/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=_typeof(index);if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}module.exports=isIterateeCall;},{"./_isIndex":108,"./eq":142,"./isArrayLike":147,"./isObject":153}],110:[function(require,module,exports){/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */function isKeyable(value){var type=_typeof(value);return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}module.exports=isKeyable;},{}],111:[function(require,module,exports){var coreJsData=require('./_coreJsData');/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}module.exports=isMasked;},{"./_coreJsData":85}],112:[function(require,module,exports){/** Used for built-in method references. */var objectProto=Object.prototype;/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}module.exports=isPrototype;},{}],113:[function(require,module,exports){/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */function listCacheClear(){this.__data__=[];this.size=0;}module.exports=listCacheClear;},{}],114:[function(require,module,exports){var assocIndexOf=require('./_assocIndexOf');/** Used for built-in method references. */var arrayProto=Array.prototype;/** Built-in value references. */var splice=arrayProto.splice;/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}module.exports=listCacheDelete;},{"./_assocIndexOf":52}],115:[function(require,module,exports){var assocIndexOf=require('./_assocIndexOf');/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}module.exports=listCacheGet;},{"./_assocIndexOf":52}],116:[function(require,module,exports){var assocIndexOf=require('./_assocIndexOf');/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}module.exports=listCacheHas;},{"./_assocIndexOf":52}],117:[function(require,module,exports){var assocIndexOf=require('./_assocIndexOf');/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}module.exports=listCacheSet;},{"./_assocIndexOf":52}],118:[function(require,module,exports){var Hash=require('./_Hash'),ListCache=require('./_ListCache'),Map=require('./_Map');/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}module.exports=mapCacheClear;},{"./_Hash":34,"./_ListCache":35,"./_Map":36}],119:[function(require,module,exports){var getMapData=require('./_getMapData');/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}module.exports=mapCacheDelete;},{"./_getMapData":92}],120:[function(require,module,exports){var getMapData=require('./_getMapData');/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */function mapCacheGet(key){return getMapData(this,key).get(key);}module.exports=mapCacheGet;},{"./_getMapData":92}],121:[function(require,module,exports){var getMapData=require('./_getMapData');/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */function mapCacheHas(key){return getMapData(this,key).has(key);}module.exports=mapCacheHas;},{"./_getMapData":92}],122:[function(require,module,exports){var getMapData=require('./_getMapData');/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}module.exports=mapCacheSet;},{"./_getMapData":92}],123:[function(require,module,exports){var getNative=require('./_getNative');/* Built-in method references that are verified to be native. */var nativeCreate=getNative(Object,'create');module.exports=nativeCreate;},{"./_getNative":93}],124:[function(require,module,exports){var overArg=require('./_overArg');/* Built-in method references for those with the same name as other `lodash` methods. */var nativeKeys=overArg(Object.keys,Object);module.exports=nativeKeys;},{"./_overArg":128}],125:[function(require,module,exports){/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}module.exports=nativeKeysIn;},{}],126:[function(require,module,exports){var freeGlobal=require('./_freeGlobal');/** Detect free variable `exports`. */var freeExports=_typeof(exports)=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&_typeof(module)=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
	var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
	return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();module.exports=nodeUtil;},{"./_freeGlobal":89}],127:[function(require,module,exports){/** Used for built-in method references. */var objectProto=Object.prototype;/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */var nativeObjectToString=objectProto.toString;/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */function objectToString(value){return nativeObjectToString.call(value);}module.exports=objectToString;},{}],128:[function(require,module,exports){/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */function overArg(func,transform){return function(arg){return func(transform(arg));};}module.exports=overArg;},{}],129:[function(require,module,exports){var apply=require('./_apply');/* Built-in method references for those with the same name as other `lodash` methods. */var nativeMax=Math.max;/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}module.exports=overRest;},{"./_apply":44}],130:[function(require,module,exports){var freeGlobal=require('./_freeGlobal');/** Detect free variable `self`. */var freeSelf=(typeof self==="undefined"?"undefined":_typeof(self))=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();module.exports=root;},{"./_freeGlobal":89}],131:[function(require,module,exports){/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */function safeGet(object,key){if(key==='constructor'&&typeof object[key]==='function'){return;}if(key=='__proto__'){return;}return object[key];}module.exports=safeGet;},{}],132:[function(require,module,exports){var baseSetToString=require('./_baseSetToString'),shortOut=require('./_shortOut');/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */var setToString=shortOut(baseSetToString);module.exports=setToString;},{"./_baseSetToString":71,"./_shortOut":133}],133:[function(require,module,exports){/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeNow=Date.now;/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}module.exports=shortOut;},{}],134:[function(require,module,exports){var ListCache=require('./_ListCache');/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */function stackClear(){this.__data__=new ListCache();this.size=0;}module.exports=stackClear;},{"./_ListCache":35}],135:[function(require,module,exports){/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}module.exports=stackDelete;},{}],136:[function(require,module,exports){/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */function stackGet(key){return this.__data__.get(key);}module.exports=stackGet;},{}],137:[function(require,module,exports){/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */function stackHas(key){return this.__data__.has(key);}module.exports=stackHas;},{}],138:[function(require,module,exports){var ListCache=require('./_ListCache'),Map=require('./_Map'),MapCache=require('./_MapCache');/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}module.exports=stackSet;},{"./_ListCache":35,"./_Map":36,"./_MapCache":37}],139:[function(require,module,exports){/** Used for built-in method references. */var funcProto=Function.prototype;/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}module.exports=toSource;},{}],140:[function(require,module,exports){var baseClone=require('./_baseClone');/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_SYMBOLS_FLAG=4;/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}module.exports=cloneDeep;},{"./_baseClone":56}],141:[function(require,module,exports){/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */function constant(value){return function(){return value;};}module.exports=constant;},{}],142:[function(require,module,exports){/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */function eq(value,other){return value===other||value!==value&&other!==other;}module.exports=eq;},{}],143:[function(require,module,exports){var toString=require('./toString');/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/**
	 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}module.exports=escapeRegExp;},{"./toString":166}],144:[function(require,module,exports){/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */function identity(value){return value;}module.exports=identity;},{}],145:[function(require,module,exports){var baseIsArguments=require('./_baseIsArguments'),isObjectLike=require('./isObjectLike');/** Used for built-in method references. */var objectProto=Object.prototype;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Built-in value references. */var propertyIsEnumerable=objectProto.propertyIsEnumerable;/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};module.exports=isArguments;},{"./_baseIsArguments":61,"./isObjectLike":154}],146:[function(require,module,exports){/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */var isArray=Array.isArray;module.exports=isArray;},{}],147:[function(require,module,exports){var isFunction=require('./isFunction'),isLength=require('./isLength');/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}module.exports=isArrayLike;},{"./isFunction":150,"./isLength":151}],148:[function(require,module,exports){var isArrayLike=require('./isArrayLike'),isObjectLike=require('./isObjectLike');/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}module.exports=isArrayLikeObject;},{"./isArrayLike":147,"./isObjectLike":154}],149:[function(require,module,exports){var root=require('./_root'),stubFalse=require('./stubFalse');/** Detect free variable `exports`. */var freeExports=_typeof(exports)=='object'&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&_typeof(module)=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Built-in value references. */var Buffer=moduleExports?root.Buffer:undefined;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeIsBuffer=Buffer?Buffer.isBuffer:undefined;/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */var isBuffer=nativeIsBuffer||stubFalse;module.exports=isBuffer;},{"./_root":130,"./stubFalse":164}],150:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isObject=require('./isObject');/** `Object#toString` result references. */var asyncTag='[object AsyncFunction]',funcTag='[object Function]',genTag='[object GeneratorFunction]',proxyTag='[object Proxy]';/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
	// in Safari 9 which returns 'object' for typed arrays and other constructors.
	var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}module.exports=isFunction;},{"./_baseGetTag":60,"./isObject":153}],151:[function(require,module,exports){/** Used as references for various `Number` constants. */var MAX_SAFE_INTEGER=9007199254740991;/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}module.exports=isLength;},{}],152:[function(require,module,exports){var baseIsMap=require('./_baseIsMap'),baseUnary=require('./_baseUnary'),nodeUtil=require('./_nodeUtil');/* Node.js helper references. */var nodeIsMap=nodeUtil&&nodeUtil.isMap;/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;module.exports=isMap;},{"./_baseIsMap":62,"./_baseUnary":74,"./_nodeUtil":126}],153:[function(require,module,exports){/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */function isObject(value){var type=_typeof(value);return value!=null&&(type=='object'||type=='function');}module.exports=isObject;},{}],154:[function(require,module,exports){/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */function isObjectLike(value){return value!=null&&_typeof(value)=='object';}module.exports=isObjectLike;},{}],155:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),getPrototype=require('./_getPrototype'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var objectTag='[object Object]';/** Used for built-in method references. */var funcProto=Function.prototype,objectProto=Object.prototype;/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}module.exports=isPlainObject;},{"./_baseGetTag":60,"./_getPrototype":94,"./isObjectLike":154}],156:[function(require,module,exports){var baseIsSet=require('./_baseIsSet'),baseUnary=require('./_baseUnary'),nodeUtil=require('./_nodeUtil');/* Node.js helper references. */var nodeIsSet=nodeUtil&&nodeUtil.isSet;/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;module.exports=isSet;},{"./_baseIsSet":64,"./_baseUnary":74,"./_nodeUtil":126}],157:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isArray=require('./isArray'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var stringTag='[object String]';/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}module.exports=isString;},{"./_baseGetTag":60,"./isArray":146,"./isObjectLike":154}],158:[function(require,module,exports){var baseGetTag=require('./_baseGetTag'),isObjectLike=require('./isObjectLike');/** `Object#toString` result references. */var symbolTag='[object Symbol]';/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */function isSymbol(value){return _typeof(value)=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}module.exports=isSymbol;},{"./_baseGetTag":60,"./isObjectLike":154}],159:[function(require,module,exports){var baseIsTypedArray=require('./_baseIsTypedArray'),baseUnary=require('./_baseUnary'),nodeUtil=require('./_nodeUtil');/* Node.js helper references. */var nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;module.exports=isTypedArray;},{"./_baseIsTypedArray":65,"./_baseUnary":74,"./_nodeUtil":126}],160:[function(require,module,exports){var arrayLikeKeys=require('./_arrayLikeKeys'),baseKeys=require('./_baseKeys'),isArrayLike=require('./isArrayLike');/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}module.exports=keys;},{"./_arrayLikeKeys":47,"./_baseKeys":66,"./isArrayLike":147}],161:[function(require,module,exports){var arrayLikeKeys=require('./_arrayLikeKeys'),baseKeysIn=require('./_baseKeysIn'),isArrayLike=require('./isArrayLike');/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}module.exports=keysIn;},{"./_arrayLikeKeys":47,"./_baseKeysIn":67,"./isArrayLike":147}],162:[function(require,module,exports){var baseMerge=require('./_baseMerge'),createAssigner=require('./_createAssigner');/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined`, merging is handled by the
	 * method instead. The `customizer` is invoked with six arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = { 'a': [1], 'b': [2] };
	 * var other = { 'a': [3], 'b': [4] };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'a': [1, 3], 'b': [2, 4] }
	 */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});module.exports=mergeWith;},{"./_baseMerge":68,"./_createAssigner":86}],163:[function(require,module,exports){/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */function stubArray(){return[];}module.exports=stubArray;},{}],164:[function(require,module,exports){/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */function stubFalse(){return false;}module.exports=stubFalse;},{}],165:[function(require,module,exports){var copyObject=require('./_copyObject'),keysIn=require('./keysIn');/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */function toPlainObject(value){return copyObject(value,keysIn(value));}module.exports=toPlainObject;},{"./_copyObject":82,"./keysIn":161}],166:[function(require,module,exports){var baseToString=require('./_baseToString');/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */function toString(value){return value==null?'':baseToString(value);}module.exports=toString;},{"./_baseToString":73}],167:[function(require,module,exports){/**
	 * Srcset Parser
	 *
	 * By Alex Bell |  MIT License
	 *
	 * JS Parser for the string value that appears in markup <img srcset="here">
	 *
	 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
	 *
	 * Based super duper closely on the reference algorithm at:
	 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
	 *
	 * Most comments are copied in directly from the spec
	 * (except for comments in parens).
	 */(function(root,factory){if(typeof define==='function'&&define.amd){// AMD. Register as an anonymous module.
	define([],factory);}else if(_typeof(module)==='object'&&module.exports){// Node. Does not work with strict CommonJS, but
	// only CommonJS-like environments that support module.exports,
	// like Node.
	module.exports=factory();}else{// Browser globals (root is window)
	root.parseSrcset=factory();}})(this,function(){// 1. Let input be the value passed to this algorithm.
	return function(input){// UTILITY FUNCTIONS
	// Manual is faster than RegEx
	// http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
	// http://jsperf.com/whitespace-character/5
	function isSpace(c){return c===" "||// space
	c==="\t"||// horizontal tab
	c==="\n"||// new line
	c==="\f"||// form feed
	c==="\r";// carriage return
	}function collectCharacters(regEx){var chars,match=regEx.exec(input.substring(pos));if(match){chars=match[0];pos+=chars.length;return chars;}}var inputLength=input.length,// (Don't use \s, to avoid matching non-breaking space)
	regexLeadingSpaces=/^[ \t\n\r\u000c]+/,regexLeadingCommasOrSpaces=/^[, \t\n\r\u000c]+/,regexLeadingNotSpaces=/^[^ \t\n\r\u000c]+/,regexTrailingCommas=/[,]+$/,regexNonNegativeInteger=/^\d+$/,// ( Positive or negative or unsigned integers or decimals, without or without exponents.
	// Must include at least one digit.
	// According to spec tests any decimal point must be followed by a digit.
	// No leading plus sign is allowed.)
	// https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
	regexFloatingPoint=/^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,url,descriptors,currentDescriptor,state,c,// 2. Let position be a pointer into input, initially pointing at the start
	//    of the string.
	pos=0,// 3. Let candidates be an initially empty source set.
	candidates=[];// 4. Splitting loop: Collect a sequence of characters that are space
	//    characters or U+002C COMMA characters. If any U+002C COMMA characters
	//    were collected, that is a parse error.
	while(true){collectCharacters(regexLeadingCommasOrSpaces);// 5. If position is past the end of input, return candidates and abort these steps.
	if(pos>=inputLength){return candidates;// (we're done, this is the sole return path)
	}// 6. Collect a sequence of characters that are not space characters,
	//    and let that be url.
	url=collectCharacters(regexLeadingNotSpaces);// 7. Let descriptors be a new empty list.
	descriptors=[];// 8. If url ends with a U+002C COMMA character (,), follow these substeps:
	//		(1). Remove all trailing U+002C COMMA characters from url. If this removed
	//         more than one character, that is a parse error.
	if(url.slice(-1)===","){url=url.replace(regexTrailingCommas,"");// (Jump ahead to step 9 to skip tokenization and just push the candidate).
	parseDescriptors();//	Otherwise, follow these substeps:
	}else{tokenize();}// (close else of step 8)
	// 16. Return to the step labeled splitting loop.
	}// (Close of big while loop.)
	/**
			 * Tokenizes descriptor properties prior to parsing
			 * Returns undefined.
			 */function tokenize(){// 8.1. Descriptor tokeniser: Skip whitespace
	collectCharacters(regexLeadingSpaces);// 8.2. Let current descriptor be the empty string.
	currentDescriptor="";// 8.3. Let state be in descriptor.
	state="in descriptor";while(true){// 8.4. Let c be the character at position.
	c=input.charAt(pos);//  Do the following depending on the value of state.
	//  For the purpose of this step, "EOF" is a special character representing
	//  that position is past the end of input.
	// In descriptor
	if(state==="in descriptor"){// Do the following, depending on the value of c:
	// Space character
	// If current descriptor is not empty, append current descriptor to
	// descriptors and let current descriptor be the empty string.
	// Set state to after descriptor.
	if(isSpace(c)){if(currentDescriptor){descriptors.push(currentDescriptor);currentDescriptor="";state="after descriptor";}// U+002C COMMA (,)
	// Advance position to the next character in input. If current descriptor
	// is not empty, append current descriptor to descriptors. Jump to the step
	// labeled descriptor parser.
	}else if(c===","){pos+=1;if(currentDescriptor){descriptors.push(currentDescriptor);}parseDescriptors();return;// U+0028 LEFT PARENTHESIS (()
	// Append c to current descriptor. Set state to in parens.
	}else if(c==="("){currentDescriptor=currentDescriptor+c;state="in parens";// EOF
	// If current descriptor is not empty, append current descriptor to
	// descriptors. Jump to the step labeled descriptor parser.
	}else if(c===""){if(currentDescriptor){descriptors.push(currentDescriptor);}parseDescriptors();return;// Anything else
	// Append c to current descriptor.
	}else{currentDescriptor=currentDescriptor+c;}// (end "in descriptor"
	// In parens
	}else if(state==="in parens"){// U+0029 RIGHT PARENTHESIS ())
	// Append c to current descriptor. Set state to in descriptor.
	if(c===")"){currentDescriptor=currentDescriptor+c;state="in descriptor";// EOF
	// Append current descriptor to descriptors. Jump to the step labeled
	// descriptor parser.
	}else if(c===""){descriptors.push(currentDescriptor);parseDescriptors();return;// Anything else
	// Append c to current descriptor.
	}else{currentDescriptor=currentDescriptor+c;}// After descriptor
	}else if(state==="after descriptor"){// Do the following, depending on the value of c:
	// Space character: Stay in this state.
	if(isSpace(c)){// EOF: Jump to the step labeled descriptor parser.
	}else if(c===""){parseDescriptors();return;// Anything else
	// Set state to in descriptor. Set position to the previous character in input.
	}else{state="in descriptor";pos-=1;}}// Advance position to the next character in input.
	pos+=1;// Repeat this step.
	}// (close while true loop)
	}/**
			 * Adds descriptor properties to a candidate, pushes to the candidates array
			 * @return undefined
			 */ // Declared outside of the while loop so that it's only created once.
	function parseDescriptors(){// 9. Descriptor parser: Let error be no.
	var pError=false,// 10. Let width be absent.
	// 11. Let density be absent.
	// 12. Let future-compat-h be absent. (We're implementing it now as h)
	w,d,h,i,candidate={},desc,lastChar,value,intVal,floatVal;// 13. For each descriptor in descriptors, run the appropriate set of steps
	// from the following list:
	for(i=0;i<descriptors.length;i++){desc=descriptors[i];lastChar=desc[desc.length-1];value=desc.substring(0,desc.length-1);intVal=parseInt(value,10);floatVal=parseFloat(value);// If the descriptor consists of a valid non-negative integer followed by
	// a U+0077 LATIN SMALL LETTER W character
	if(regexNonNegativeInteger.test(value)&&lastChar==="w"){// If width and density are not both absent, then let error be yes.
	if(w||d){pError=true;}// Apply the rules for parsing non-negative integers to the descriptor.
	// If the result is zero, let error be yes.
	// Otherwise, let width be the result.
	if(intVal===0){pError=true;}else{w=intVal;}// If the descriptor consists of a valid floating-point number followed by
	// a U+0078 LATIN SMALL LETTER X character
	}else if(regexFloatingPoint.test(value)&&lastChar==="x"){// If width, density and future-compat-h are not all absent, then let error
	// be yes.
	if(w||d||h){pError=true;}// Apply the rules for parsing floating-point number values to the descriptor.
	// If the result is less than zero, let error be yes. Otherwise, let density
	// be the result.
	if(floatVal<0){pError=true;}else{d=floatVal;}// If the descriptor consists of a valid non-negative integer followed by
	// a U+0068 LATIN SMALL LETTER H character
	}else if(regexNonNegativeInteger.test(value)&&lastChar==="h"){// If height and density are not both absent, then let error be yes.
	if(h||d){pError=true;}// Apply the rules for parsing non-negative integers to the descriptor.
	// If the result is zero, let error be yes. Otherwise, let future-compat-h
	// be the result.
	if(intVal===0){pError=true;}else{h=intVal;}// Anything else, Let error be yes.
	}else{pError=true;}}// (close step 13 for loop)
	// 15. If error is still no, then append a new image source to candidates whose
	// URL is url, associated with a width width if not absent and a pixel
	// density density if not absent. Otherwise, there is a parse error.
	if(!pError){candidate.url=url;if(w){candidate.w=w;}if(d){candidate.d=d;}if(h){candidate.h=h;}candidates.push(candidate);}else if(console&&console.log){console.log("Invalid srcset descriptor found in '"+input+"' at '"+desc+"'.");}}// (close parseDescriptors fn)
	};});},{}],168:[function(require,module,exports){(function(process){// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
	// backported and transplited with Babel, with backwards-compat fixes
	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts,allowAboveRoot){// if the path tries to go above the root, `up` ends up > 0
	var up=0;for(var i=parts.length-1;i>=0;i--){var last=parts[i];if(last==='.'){parts.splice(i,1);}else if(last==='..'){parts.splice(i,1);up++;}else if(up){parts.splice(i,1);up--;}}// if the path is allowed to go above the root, restore leading ..s
	if(allowAboveRoot){for(;up--;up){parts.unshift('..');}}return parts;}// path.resolve([from ...], to)
	// posix version
	exports.resolve=function(){var resolvedPath='',resolvedAbsolute=false;for(var i=arguments.length-1;i>=-1&&!resolvedAbsolute;i--){var path=i>=0?arguments[i]:process.cwd();// Skip empty and invalid entries
	if(typeof path!=='string'){throw new TypeError('Arguments to path.resolve must be strings');}else if(!path){continue;}resolvedPath=path+'/'+resolvedPath;resolvedAbsolute=path.charAt(0)==='/';}// At this point the path should be resolved to a full absolute path, but
	// handle relative paths to be safe (might happen when process.cwd() fails)
	// Normalize the path
	resolvedPath=normalizeArray(filter(resolvedPath.split('/'),function(p){return!!p;}),!resolvedAbsolute).join('/');return(resolvedAbsolute?'/':'')+resolvedPath||'.';};// path.normalize(path)
	// posix version
	exports.normalize=function(path){var isAbsolute=exports.isAbsolute(path),trailingSlash=substr(path,-1)==='/';// Normalize the path
	path=normalizeArray(filter(path.split('/'),function(p){return!!p;}),!isAbsolute).join('/');if(!path&&!isAbsolute){path='.';}if(path&&trailingSlash){path+='/';}return(isAbsolute?'/':'')+path;};// posix version
	exports.isAbsolute=function(path){return path.charAt(0)==='/';};// posix version
	exports.join=function(){var paths=Array.prototype.slice.call(arguments,0);return exports.normalize(filter(paths,function(p,index){if(typeof p!=='string'){throw new TypeError('Arguments to path.join must be strings');}return p;}).join('/'));};// path.relative(from, to)
	// posix version
	exports.relative=function(from,to){from=exports.resolve(from).substr(1);to=exports.resolve(to).substr(1);function trim(arr){var start=0;for(;start<arr.length;start++){if(arr[start]!=='')break;}var end=arr.length-1;for(;end>=0;end--){if(arr[end]!=='')break;}if(start>end)return[];return arr.slice(start,end-start+1);}var fromParts=trim(from.split('/'));var toParts=trim(to.split('/'));var length=Math.min(fromParts.length,toParts.length);var samePartsLength=length;for(var i=0;i<length;i++){if(fromParts[i]!==toParts[i]){samePartsLength=i;break;}}var outputParts=[];for(var i=samePartsLength;i<fromParts.length;i++){outputParts.push('..');}outputParts=outputParts.concat(toParts.slice(samePartsLength));return outputParts.join('/');};exports.sep='/';exports.delimiter=':';exports.dirname=function(path){if(typeof path!=='string')path=path+'';if(path.length===0)return'.';var code=path.charCodeAt(0);var hasRoot=code===47/*/*/;var end=-1;var matchedSlash=true;for(var i=path.length-1;i>=1;--i){code=path.charCodeAt(i);if(code===47/*/*/){if(!matchedSlash){end=i;break;}}else{// We saw the first non-path separator
	matchedSlash=false;}}if(end===-1)return hasRoot?'/':'.';if(hasRoot&&end===1){// return '//';
	// Backwards-compat fix:
	return'/';}return path.slice(0,end);};function basename(path){if(typeof path!=='string')path=path+'';var start=0;var end=-1;var matchedSlash=true;var i;for(i=path.length-1;i>=0;--i){if(path.charCodeAt(i)===47/*/*/){// If we reached a path separator that was not part of a set of path
	// separators at the end of the string, stop now
	if(!matchedSlash){start=i+1;break;}}else if(end===-1){// We saw the first non-path separator, mark this as the end of our
	// path component
	matchedSlash=false;end=i+1;}}if(end===-1)return'';return path.slice(start,end);}// Uses a mixed approach for backwards-compatibility, as ext behavior changed
	// in new Node.js versions, so only basename() above is backported here
	exports.basename=function(path,ext){var f=basename(path);if(ext&&f.substr(-1*ext.length)===ext){f=f.substr(0,f.length-ext.length);}return f;};exports.extname=function(path){if(typeof path!=='string')path=path+'';var startDot=-1;var startPart=0;var end=-1;var matchedSlash=true;// Track the state of characters (if any) we see before our first dot and
	// after any path separator we find
	var preDotState=0;for(var i=path.length-1;i>=0;--i){var code=path.charCodeAt(i);if(code===47/*/*/){// If we reached a path separator that was not part of a set of path
	// separators at the end of the string, stop now
	if(!matchedSlash){startPart=i+1;break;}continue;}if(end===-1){// We saw the first non-path separator, mark this as the end of our
	// extension
	matchedSlash=false;end=i+1;}if(code===46/*.*/){// If this is our first dot, mark it as the start of our extension
	if(startDot===-1)startDot=i;else if(preDotState!==1)preDotState=1;}else if(startDot!==-1){// We saw a non-dot and non-path separator before our dot, so we should
	// have a good chance at having a non-empty extension
	preDotState=-1;}}if(startDot===-1||end===-1||// We saw a non-dot character immediately before the dot
	preDotState===0||// The (right-most) trimmed path component is exactly '..'
	preDotState===1&&startDot===end-1&&startDot===startPart+1){return'';}return path.slice(startDot,end);};function filter(xs,f){if(xs.filter)return xs.filter(f);var res=[];for(var i=0;i<xs.length;i++){if(f(xs[i],i,xs))res.push(xs[i]);}return res;}// String.prototype.substr - negative index don't work in IE8
	var substr='ab'.substr(-1)==='b'?function(str,start,len){return str.substr(start,len);}:function(str,start,len){if(start<0)start=str.length+start;return str.substr(start,len);};}).call(this,require('_process'));},{"_process":193}],169:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _container=_interopRequireDefault(require("./container"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents an at-rule.
	 *
	 * If it’s followed in the CSS by a {} block, this node will have
	 * a nodes property representing its children.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('@charset "UTF-8"; @media print {}')
	 *
	 * const charset = root.first
	 * charset.type  //=> 'atrule'
	 * charset.nodes //=> undefined
	 *
	 * const media = root.last
	 * media.nodes   //=> []
	 */var AtRule=/*#__PURE__*/function(_Container){_inheritsLoose(AtRule,_Container);function AtRule(defaults){var _this;_this=_Container.call(this,defaults)||this;_this.type='atrule';return _this;}var _proto=AtRule.prototype;_proto.append=function append(){var _Container$prototype$;if(!this.nodes)this.nodes=[];for(var _len=arguments.length,children=new Array(_len),_key=0;_key<_len;_key++){children[_key]=arguments[_key];}return(_Container$prototype$=_Container.prototype.append).call.apply(_Container$prototype$,[this].concat(children));};_proto.prepend=function prepend(){var _Container$prototype$2;if(!this.nodes)this.nodes=[];for(var _len2=arguments.length,children=new Array(_len2),_key2=0;_key2<_len2;_key2++){children[_key2]=arguments[_key2];}return(_Container$prototype$2=_Container.prototype.prepend).call.apply(_Container$prototype$2,[this].concat(children));}/**
	   * @memberof AtRule#
	   * @member {string} name The at-rule’s name immediately follows the `@`.
	   *
	   * @example
	   * const root  = postcss.parse('@media print {}')
	   * media.name //=> 'media'
	   * const media = root.first
	   */ /**
	   * @memberof AtRule#
	   * @member {string} params The at-rule’s parameters, the values
	   *                         that follow the at-rule’s name but precede
	   *                         any {} block.
	   *
	   * @example
	   * const root  = postcss.parse('@media print, screen {}')
	   * const media = root.first
	   * media.params //=> 'print, screen'
	   */ /**
	   * @memberof AtRule#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                        node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `before`: the space symbols before the node. It also stores `*`
	   *   and `_` symbols before the declaration (IE hack).
	   * * `after`: the space symbols after the last child of the node
	   *   to the end of the node.
	   * * `between`: the symbols between the property and value
	   *   for declarations, selector and `{` for rules, or last parameter
	   *   and `{` for at-rules.
	   * * `semicolon`: contains true if the last child has
	   *   an (optional) semicolon.
	   * * `afterName`: the space between the at-rule name and its parameters.
	   *
	   * PostCSS cleans at-rule parameters from comments and extra spaces,
	   * but it stores origin content in raws properties.
	   * As such, if you don’t change a declaration’s value,
	   * PostCSS will use the raw value with comments.
	   *
	   * @example
	   * const root = postcss.parse('  @media\nprint {\n}')
	   * root.first.first.raws //=> { before: '  ',
	   *                       //     between: ' ',
	   *                       //     afterName: '\n',
	   *                       //     after: '\n' }
	   */;return AtRule;}(_container["default"]);var _default=AtRule;exports["default"]=_default;module.exports=exports["default"];},{"./container":171}],170:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _node=_interopRequireDefault(require("./node"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents a comment between declarations or statements (rule and at-rules).
	 *
	 * Comments inside selectors, at-rule parameters, or declaration values
	 * will be stored in the `raws` properties explained above.
	 *
	 * @extends Node
	 */var Comment=/*#__PURE__*/function(_Node){_inheritsLoose(Comment,_Node);function Comment(defaults){var _this;_this=_Node.call(this,defaults)||this;_this.type='comment';return _this;}/**
	   * @memberof Comment#
	   * @member {string} text The comment’s text.
	   */ /**
	   * @memberof Comment#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                       node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `before`: the space symbols before the node.
	   * * `left`: the space symbols between `/*` and the comment’s text.
	   * * `right`: the space symbols between the comment’s text.
	   */return Comment;}(_node["default"]);var _default=Comment;exports["default"]=_default;module.exports=exports["default"];},{"./node":178}],171:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _declaration=_interopRequireDefault(require("./declaration"));var _comment=_interopRequireDefault(require("./comment"));var _node=_interopRequireDefault(require("./node"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}function cleanSource(nodes){return nodes.map(function(i){if(i.nodes)i.nodes=cleanSource(i.nodes);delete i.source;return i;});}/**
	 * The {@link Root}, {@link AtRule}, and {@link Rule} container nodes
	 * inherit some common methods to help work with their children.
	 *
	 * Note that all containers can store any content. If you write a rule inside
	 * a rule, PostCSS will parse it.
	 *
	 * @extends Node
	 * @abstract
	 */var Container=/*#__PURE__*/function(_Node){_inheritsLoose(Container,_Node);function Container(){return _Node.apply(this,arguments)||this;}var _proto=Container.prototype;_proto.push=function push(child){child.parent=this;this.nodes.push(child);return this;}/**
	   * Iterates through the container’s immediate children,
	   * calling `callback` for each child.
	   *
	   * Returning `false` in the callback will break iteration.
	   *
	   * This method only iterates through the container’s immediate children.
	   * If you need to recursively iterate through all the container’s descendant
	   * nodes, use {@link Container#walk}.
	   *
	   * Unlike the for `{}`-cycle or `Array#forEach` this iterator is safe
	   * if you are mutating the array of child nodes during iteration.
	   * PostCSS will adjust the current index to match the mutations.
	   *
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black; z-index: 1 }')
	   * const rule = root.first
	   *
	   * for (const decl of rule.nodes) {
	   *   decl.cloneBefore({ prop: '-webkit-' + decl.prop })
	   *   // Cycle will be infinite, because cloneBefore moves the current node
	   *   // to the next index
	   * }
	   *
	   * rule.each(decl => {
	   *   decl.cloneBefore({ prop: '-webkit-' + decl.prop })
	   *   // Will be executed only for color and z-index
	   * })
	   */;_proto.each=function each(callback){if(!this.lastEach)this.lastEach=0;if(!this.indexes)this.indexes={};this.lastEach+=1;var id=this.lastEach;this.indexes[id]=0;if(!this.nodes)return undefined;var index,result;while(this.indexes[id]<this.nodes.length){index=this.indexes[id];result=callback(this.nodes[index],index);if(result===false)break;this.indexes[id]+=1;}delete this.indexes[id];return result;}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each node.
	   *
	   * Like container.each(), this method is safe to use
	   * if you are mutating arrays during iteration.
	   *
	   * If you only need to iterate through the container’s immediate children,
	   * use {@link Container#each}.
	   *
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * root.walk(node => {
	   *   // Traverses all descendant nodes.
	   * })
	   */;_proto.walk=function walk(callback){return this.each(function(child,i){var result;try{result=callback(child,i);}catch(e){e.postcssNode=child;if(e.stack&&child.source&&/\n\s{4}at /.test(e.stack)){var s=child.source;e.stack=e.stack.replace(/\n\s{4}at /,"$&"+s.input.from+":"+s.start.line+":"+s.start.column+"$&");}throw e;}if(result!==false&&child.walk){result=child.walk(callback);}return result;});}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each declaration node.
	   *
	   * If you pass a filter, iteration will only happen over declarations
	   * with matching properties.
	   *
	   * Like {@link Container#each}, this method is safe
	   * to use if you are mutating arrays during iteration.
	   *
	   * @param {string|RegExp} [prop]   String or regular expression
	   *                                 to filter declarations by property name.
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * root.walkDecls(decl => {
	   *   checkPropertySupport(decl.prop)
	   * })
	   *
	   * root.walkDecls('border-radius', decl => {
	   *   decl.remove()
	   * })
	   *
	   * root.walkDecls(/^background/, decl => {
	   *   decl.value = takeFirstColorFromGradient(decl.value)
	   * })
	   */;_proto.walkDecls=function walkDecls(prop,callback){if(!callback){callback=prop;return this.walk(function(child,i){if(child.type==='decl'){return callback(child,i);}});}if(prop instanceof RegExp){return this.walk(function(child,i){if(child.type==='decl'&&prop.test(child.prop)){return callback(child,i);}});}return this.walk(function(child,i){if(child.type==='decl'&&child.prop===prop){return callback(child,i);}});}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each rule node.
	   *
	   * If you pass a filter, iteration will only happen over rules
	   * with matching selectors.
	   *
	   * Like {@link Container#each}, this method is safe
	   * to use if you are mutating arrays during iteration.
	   *
	   * @param {string|RegExp} [selector] String or regular expression
	   *                                   to filter rules by selector.
	   * @param {childIterator} callback   Iterator receives each node and index.
	   *
	   * @return {false|undefined} returns `false` if iteration was broke.
	   *
	   * @example
	   * const selectors = []
	   * root.walkRules(rule => {
	   *   selectors.push(rule.selector)
	   * })
	   * console.log(`Your CSS uses ${ selectors.length } selectors`)
	   */;_proto.walkRules=function walkRules(selector,callback){if(!callback){callback=selector;return this.walk(function(child,i){if(child.type==='rule'){return callback(child,i);}});}if(selector instanceof RegExp){return this.walk(function(child,i){if(child.type==='rule'&&selector.test(child.selector)){return callback(child,i);}});}return this.walk(function(child,i){if(child.type==='rule'&&child.selector===selector){return callback(child,i);}});}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each at-rule node.
	   *
	   * If you pass a filter, iteration will only happen over at-rules
	   * that have matching names.
	   *
	   * Like {@link Container#each}, this method is safe
	   * to use if you are mutating arrays during iteration.
	   *
	   * @param {string|RegExp} [name]   String or regular expression
	   *                                 to filter at-rules by name.
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * root.walkAtRules(rule => {
	   *   if (isOld(rule.name)) rule.remove()
	   * })
	   *
	   * let first = false
	   * root.walkAtRules('charset', rule => {
	   *   if (!first) {
	   *     first = true
	   *   } else {
	   *     rule.remove()
	   *   }
	   * })
	   */;_proto.walkAtRules=function walkAtRules(name,callback){if(!callback){callback=name;return this.walk(function(child,i){if(child.type==='atrule'){return callback(child,i);}});}if(name instanceof RegExp){return this.walk(function(child,i){if(child.type==='atrule'&&name.test(child.name)){return callback(child,i);}});}return this.walk(function(child,i){if(child.type==='atrule'&&child.name===name){return callback(child,i);}});}/**
	   * Traverses the container’s descendant nodes, calling callback
	   * for each comment node.
	   *
	   * Like {@link Container#each}, this method is safe
	   * to use if you are mutating arrays during iteration.
	   *
	   * @param {childIterator} callback Iterator receives each node and index.
	   *
	   * @return {false|undefined} Returns `false` if iteration was broke.
	   *
	   * @example
	   * root.walkComments(comment => {
	   *   comment.remove()
	   * })
	   */;_proto.walkComments=function walkComments(callback){return this.walk(function(child,i){if(child.type==='comment'){return callback(child,i);}});}/**
	   * Inserts new nodes to the end of the container.
	   *
	   * @param {...(Node|object|string|Node[])} children New nodes.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * const decl1 = postcss.decl({ prop: 'color', value: 'black' })
	   * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' })
	   * rule.append(decl1, decl2)
	   *
	   * root.append({ name: 'charset', params: '"UTF-8"' })  // at-rule
	   * root.append({ selector: 'a' })                       // rule
	   * rule.append({ prop: 'color', value: 'black' })       // declaration
	   * rule.append({ text: 'Comment' })                     // comment
	   *
	   * root.append('a {}')
	   * root.first.append('color: black; z-index: 1')
	   */;_proto.append=function append(){for(var _len=arguments.length,children=new Array(_len),_key=0;_key<_len;_key++){children[_key]=arguments[_key];}for(var _i=0,_children=children;_i<_children.length;_i++){var child=_children[_i];var nodes=this.normalize(child,this.last);for(var _iterator=_createForOfIteratorHelperLoose(nodes),_step;!(_step=_iterator()).done;){var node=_step.value;this.nodes.push(node);}}return this;}/**
	   * Inserts new nodes to the start of the container.
	   *
	   * @param {...(Node|object|string|Node[])} children New nodes.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * const decl1 = postcss.decl({ prop: 'color', value: 'black' })
	   * const decl2 = postcss.decl({ prop: 'background-color', value: 'white' })
	   * rule.prepend(decl1, decl2)
	   *
	   * root.append({ name: 'charset', params: '"UTF-8"' })  // at-rule
	   * root.append({ selector: 'a' })                       // rule
	   * rule.append({ prop: 'color', value: 'black' })       // declaration
	   * rule.append({ text: 'Comment' })                     // comment
	   *
	   * root.append('a {}')
	   * root.first.append('color: black; z-index: 1')
	   */;_proto.prepend=function prepend(){for(var _len2=arguments.length,children=new Array(_len2),_key2=0;_key2<_len2;_key2++){children[_key2]=arguments[_key2];}children=children.reverse();for(var _iterator2=_createForOfIteratorHelperLoose(children),_step2;!(_step2=_iterator2()).done;){var child=_step2.value;var nodes=this.normalize(child,this.first,'prepend').reverse();for(var _iterator3=_createForOfIteratorHelperLoose(nodes),_step3;!(_step3=_iterator3()).done;){var node=_step3.value;this.nodes.unshift(node);}for(var id in this.indexes){this.indexes[id]=this.indexes[id]+nodes.length;}}return this;};_proto.cleanRaws=function cleanRaws(keepBetween){_Node.prototype.cleanRaws.call(this,keepBetween);if(this.nodes){for(var _iterator4=_createForOfIteratorHelperLoose(this.nodes),_step4;!(_step4=_iterator4()).done;){var node=_step4.value;node.cleanRaws(keepBetween);}}}/**
	   * Insert new node before old node within the container.
	   *
	   * @param {Node|number} exist             Child or child’s index.
	   * @param {Node|object|string|Node[]} add New node.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * rule.insertBefore(decl, decl.clone({ prop: '-webkit-' + decl.prop }))
	   */;_proto.insertBefore=function insertBefore(exist,add){exist=this.index(exist);var type=exist===0?'prepend':false;var nodes=this.normalize(add,this.nodes[exist],type).reverse();for(var _iterator5=_createForOfIteratorHelperLoose(nodes),_step5;!(_step5=_iterator5()).done;){var node=_step5.value;this.nodes.splice(exist,0,node);}var index;for(var id in this.indexes){index=this.indexes[id];if(exist<=index){this.indexes[id]=index+nodes.length;}}return this;}/**
	   * Insert new node after old node within the container.
	   *
	   * @param {Node|number} exist             Child or child’s index.
	   * @param {Node|object|string|Node[]} add New node.
	   *
	   * @return {Node} This node for methods chain.
	   */;_proto.insertAfter=function insertAfter(exist,add){exist=this.index(exist);var nodes=this.normalize(add,this.nodes[exist]).reverse();for(var _iterator6=_createForOfIteratorHelperLoose(nodes),_step6;!(_step6=_iterator6()).done;){var node=_step6.value;this.nodes.splice(exist+1,0,node);}var index;for(var id in this.indexes){index=this.indexes[id];if(exist<index){this.indexes[id]=index+nodes.length;}}return this;}/**
	   * Removes node from the container and cleans the parent properties
	   * from the node and its children.
	   *
	   * @param {Node|number} child Child or child’s index.
	   *
	   * @return {Node} This node for methods chain
	   *
	   * @example
	   * rule.nodes.length  //=> 5
	   * rule.removeChild(decl)
	   * rule.nodes.length  //=> 4
	   * decl.parent        //=> undefined
	   */;_proto.removeChild=function removeChild(child){child=this.index(child);this.nodes[child].parent=undefined;this.nodes.splice(child,1);var index;for(var id in this.indexes){index=this.indexes[id];if(index>=child){this.indexes[id]=index-1;}}return this;}/**
	   * Removes all children from the container
	   * and cleans their parent properties.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * rule.removeAll()
	   * rule.nodes.length //=> 0
	   */;_proto.removeAll=function removeAll(){for(var _iterator7=_createForOfIteratorHelperLoose(this.nodes),_step7;!(_step7=_iterator7()).done;){var node=_step7.value;node.parent=undefined;}this.nodes=[];return this;}/**
	   * Passes all declaration values within the container that match pattern
	   * through callback, replacing those values with the returned result
	   * of callback.
	   *
	   * This method is useful if you are using a custom unit or function
	   * and need to iterate through all values.
	   *
	   * @param {string|RegExp} pattern      Replace pattern.
	   * @param {object} opts                Options to speed up the search.
	   * @param {string|string[]} opts.props An array of property names.
	   * @param {string} opts.fast           String that’s used to narrow down
	   *                                     values and speed up the regexp search.
	   * @param {function|string} callback   String to replace pattern or callback
	   *                                     that returns a new value. The callback
	   *                                     will receive the same arguments
	   *                                     as those passed to a function parameter
	   *                                     of `String#replace`.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * root.replaceValues(/\d+rem/, { fast: 'rem' }, string => {
	   *   return 15 * parseInt(string) + 'px'
	   * })
	   */;_proto.replaceValues=function replaceValues(pattern,opts,callback){if(!callback){callback=opts;opts={};}this.walkDecls(function(decl){if(opts.props&&opts.props.indexOf(decl.prop)===-1)return;if(opts.fast&&decl.value.indexOf(opts.fast)===-1)return;decl.value=decl.value.replace(pattern,callback);});return this;}/**
	   * Returns `true` if callback returns `true`
	   * for all of the container’s children.
	   *
	   * @param {childCondition} condition Iterator returns true or false.
	   *
	   * @return {boolean} Is every child pass condition.
	   *
	   * @example
	   * const noPrefixes = rule.every(i => i.prop[0] !== '-')
	   */;_proto.every=function every(condition){return this.nodes.every(condition);}/**
	   * Returns `true` if callback returns `true` for (at least) one
	   * of the container’s children.
	   *
	   * @param {childCondition} condition Iterator returns true or false.
	   *
	   * @return {boolean} Is some child pass condition.
	   *
	   * @example
	   * const hasPrefix = rule.some(i => i.prop[0] === '-')
	   */;_proto.some=function some(condition){return this.nodes.some(condition);}/**
	   * Returns a `child`’s index within the {@link Container#nodes} array.
	   *
	   * @param {Node} child Child of the current container.
	   *
	   * @return {number} Child index.
	   *
	   * @example
	   * rule.index( rule.nodes[2] ) //=> 2
	   */;_proto.index=function index(child){if(typeof child==='number'){return child;}return this.nodes.indexOf(child);}/**
	   * The container’s first child.
	   *
	   * @type {Node}
	   *
	   * @example
	   * rule.first === rules.nodes[0]
	   */;_proto.normalize=function normalize(nodes,sample){var _this=this;if(typeof nodes==='string'){var parse=require('./parse');nodes=cleanSource(parse(nodes).nodes);}else if(Array.isArray(nodes)){nodes=nodes.slice(0);for(var _iterator8=_createForOfIteratorHelperLoose(nodes),_step8;!(_step8=_iterator8()).done;){var i=_step8.value;if(i.parent)i.parent.removeChild(i,'ignore');}}else if(nodes.type==='root'){nodes=nodes.nodes.slice(0);for(var _iterator9=_createForOfIteratorHelperLoose(nodes),_step9;!(_step9=_iterator9()).done;){var _i2=_step9.value;if(_i2.parent)_i2.parent.removeChild(_i2,'ignore');}}else if(nodes.type){nodes=[nodes];}else if(nodes.prop){if(typeof nodes.value==='undefined'){throw new Error('Value field is missed in node creation');}else if(typeof nodes.value!=='string'){nodes.value=String(nodes.value);}nodes=[new _declaration["default"](nodes)];}else if(nodes.selector){var Rule=require('./rule');nodes=[new Rule(nodes)];}else if(nodes.name){var AtRule=require('./at-rule');nodes=[new AtRule(nodes)];}else if(nodes.text){nodes=[new _comment["default"](nodes)];}else{throw new Error('Unknown node type in node creation');}var processed=nodes.map(function(i){if(i.parent)i.parent.removeChild(i);if(typeof i.raws.before==='undefined'){if(sample&&typeof sample.raws.before!=='undefined'){i.raws.before=sample.raws.before.replace(/[^\s]/g,'');}}i.parent=_this;return i;});return processed;}/**
	   * @memberof Container#
	   * @member {Node[]} nodes An array containing the container’s children.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black }')
	   * root.nodes.length           //=> 1
	   * root.nodes[0].selector      //=> 'a'
	   * root.nodes[0].nodes[0].prop //=> 'color'
	   */;_createClass(Container,[{key:"first",get:function get(){if(!this.nodes)return undefined;return this.nodes[0];}/**
	     * The container’s last child.
	     *
	     * @type {Node}
	     *
	     * @example
	     * rule.last === rule.nodes[rule.nodes.length - 1]
	     */},{key:"last",get:function get(){if(!this.nodes)return undefined;return this.nodes[this.nodes.length-1];}}]);return Container;}(_node["default"]);var _default=Container;/**
	 * @callback childCondition
	 * @param {Node} node    Container child.
	 * @param {number} index Child index.
	 * @param {Node[]} nodes All container children.
	 * @return {boolean}
	 */ /**
	 * @callback childIterator
	 * @param {Node} node    Container child.
	 * @param {number} index Child index.
	 * @return {false|undefined} Returning `false` will break iteration.
	 */exports["default"]=_default;module.exports=exports["default"];},{"./at-rule":169,"./comment":170,"./declaration":173,"./node":178,"./parse":179,"./rule":186}],172:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _supportsColor=_interopRequireDefault(require("supports-color"));var _chalk=_interopRequireDefault(require("chalk"));var _terminalHighlight=_interopRequireDefault(require("./terminal-highlight"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _assertThisInitialized(self){if(self===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}function _wrapNativeSuper(Class){var _cache=typeof Map==="function"?new Map():undefined;_wrapNativeSuper=function _wrapNativeSuper(Class){if(Class===null||!_isNativeFunction(Class))return Class;if(typeof Class!=="function"){throw new TypeError("Super expression must either be null or a function");}if(typeof _cache!=="undefined"){if(_cache.has(Class))return _cache.get(Class);_cache.set(Class,Wrapper);}function Wrapper(){return _construct(Class,arguments,_getPrototypeOf(this).constructor);}Wrapper.prototype=Object.create(Class.prototype,{constructor:{value:Wrapper,enumerable:false,writable:true,configurable:true}});return _setPrototypeOf(Wrapper,Class);};return _wrapNativeSuper(Class);}function _construct(Parent,args,Class){if(_isNativeReflectConstruct()){_construct=Reflect.construct;}else{_construct=function _construct(Parent,args,Class){var a=[null];a.push.apply(a,args);var Constructor=Function.bind.apply(Parent,a);var instance=new Constructor();if(Class)_setPrototypeOf(instance,Class.prototype);return instance;};}return _construct.apply(null,arguments);}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Date.prototype.toString.call(Reflect.construct(Date,[],function(){}));return true;}catch(e){return false;}}function _isNativeFunction(fn){return Function.toString.call(fn).indexOf("[native code]")!==-1;}function _setPrototypeOf(o,p){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(o,p){o.__proto__=p;return o;};return _setPrototypeOf(o,p);}function _getPrototypeOf(o){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(o){return o.__proto__||Object.getPrototypeOf(o);};return _getPrototypeOf(o);}/**
	 * The CSS parser throws this error for broken CSS.
	 *
	 * Custom parsers can throw this error for broken custom syntax using
	 * the {@link Node#error} method.
	 *
	 * PostCSS will use the input source map to detect the original error location.
	 * If you wrote a Sass file, compiled it to CSS and then parsed it with PostCSS,
	 * PostCSS will show the original position in the Sass file.
	 *
	 * If you need the position in the PostCSS input
	 * (e.g., to debug the previous compiler), use `error.input.file`.
	 *
	 * @example
	 * // Catching and checking syntax error
	 * try {
	 *   postcss.parse('a{')
	 * } catch (error) {
	 *   if (error.name === 'CssSyntaxError') {
	 *     error //=> CssSyntaxError
	 *   }
	 * }
	 *
	 * @example
	 * // Raising error from plugin
	 * throw node.error('Unknown variable', { plugin: 'postcss-vars' })
	 */var CssSyntaxError=/*#__PURE__*/function(_Error){_inheritsLoose(CssSyntaxError,_Error);/**
	   * @param {string} message  Error message.
	   * @param {number} [line]   Source line of the error.
	   * @param {number} [column] Source column of the error.
	   * @param {string} [source] Source code of the broken file.
	   * @param {string} [file]   Absolute path to the broken file.
	   * @param {string} [plugin] PostCSS plugin name, if error came from plugin.
	   */function CssSyntaxError(message,line,column,source,file,plugin){var _this;_this=_Error.call(this,message)||this;/**
	     * Always equal to `'CssSyntaxError'`. You should always check error type
	     * by `error.name === 'CssSyntaxError'`
	     * instead of `error instanceof CssSyntaxError`,
	     * because npm could have several PostCSS versions.
	     *
	     * @type {string}
	     *
	     * @example
	     * if (error.name === 'CssSyntaxError') {
	     *   error //=> CssSyntaxError
	     * }
	     */_this.name='CssSyntaxError';/**
	     * Error message.
	     *
	     * @type {string}
	     *
	     * @example
	     * error.message //=> 'Unclosed block'
	     */_this.reason=message;if(file){/**
	       * Absolute path to the broken file.
	       *
	       * @type {string}
	       *
	       * @example
	       * error.file       //=> 'a.sass'
	       * error.input.file //=> 'a.css'
	       */_this.file=file;}if(source){/**
	       * Source code of the broken file.
	       *
	       * @type {string}
	       *
	       * @example
	       * error.source       //=> 'a { b {} }'
	       * error.input.column //=> 'a b { }'
	       */_this.source=source;}if(plugin){/**
	       * Plugin name, if error came from plugin.
	       *
	       * @type {string}
	       *
	       * @example
	       * error.plugin //=> 'postcss-vars'
	       */_this.plugin=plugin;}if(typeof line!=='undefined'&&typeof column!=='undefined'){/**
	       * Source line of the error.
	       *
	       * @type {number}
	       *
	       * @example
	       * error.line       //=> 2
	       * error.input.line //=> 4
	       */_this.line=line;/**
	       * Source column of the error.
	       *
	       * @type {number}
	       *
	       * @example
	       * error.column       //=> 1
	       * error.input.column //=> 4
	       */_this.column=column;}_this.setMessage();if(Error.captureStackTrace){Error.captureStackTrace(_assertThisInitialized(_this),CssSyntaxError);}return _this;}var _proto=CssSyntaxError.prototype;_proto.setMessage=function setMessage(){/**
	     * Full error text in the GNU error format
	     * with plugin, file, line and column.
	     *
	     * @type {string}
	     *
	     * @example
	     * error.message //=> 'a.css:1:1: Unclosed block'
	     */this.message=this.plugin?this.plugin+': ':'';this.message+=this.file?this.file:'<css input>';if(typeof this.line!=='undefined'){this.message+=':'+this.line+':'+this.column;}this.message+=': '+this.reason;}/**
	   * Returns a few lines of CSS source that caused the error.
	   *
	   * If the CSS has an input source map without `sourceContent`,
	   * this method will return an empty string.
	   *
	   * @param {boolean} [color] Whether arrow will be colored red by terminal
	   *                          color codes. By default, PostCSS will detect
	   *                          color support by `process.stdout.isTTY`
	   *                          and `process.env.NODE_DISABLE_COLORS`.
	   *
	   * @example
	   * error.showSourceCode() //=> "  4 | }
	   *                        //      5 | a {
	   *                        //    > 6 |   bad
	   *                        //        |   ^
	   *                        //      7 | }
	   *                        //      8 | b {"
	   *
	   * @return {string} Few lines of CSS source that caused the error.
	   */;_proto.showSourceCode=function showSourceCode(color){var _this2=this;if(!this.source)return'';var css=this.source;if(_terminalHighlight["default"]){if(typeof color==='undefined')color=_supportsColor["default"].stdout;if(color)css=(0,_terminalHighlight["default"])(css);}var lines=css.split(/\r?\n/);var start=Math.max(this.line-3,0);var end=Math.min(this.line+2,lines.length);var maxWidth=String(end).length;function mark(text){if(color&&_chalk["default"].red){return _chalk["default"].red.bold(text);}return text;}function aside(text){if(color&&_chalk["default"].gray){return _chalk["default"].gray(text);}return text;}return lines.slice(start,end).map(function(line,index){var number=start+1+index;var gutter=' '+(' '+number).slice(-maxWidth)+' | ';if(number===_this2.line){var spacing=aside(gutter.replace(/\d/g,' '))+line.slice(0,_this2.column-1).replace(/[^\t]/g,' ');return mark('>')+aside(gutter)+line+'\n '+spacing+mark('^');}return' '+aside(gutter)+line;}).join('\n');}/**
	   * Returns error position, message and source code of the broken part.
	   *
	   * @example
	   * error.toString() //=> "CssSyntaxError: app.css:1:1: Unclosed block
	   *                  //    > 1 | a {
	   *                  //        | ^"
	   *
	   * @return {string} Error position, message and source code.
	   */;_proto.toString=function toString(){var code=this.showSourceCode();if(code){code='\n\n'+code+'\n';}return this.name+': '+this.message+code;}/**
	   * @memberof CssSyntaxError#
	   * @member {Input} input Input object with PostCSS internal information
	   *                       about input file. If input has source map
	   *                       from previous tool, PostCSS will use origin
	   *                       (for example, Sass) source. You can use this
	   *                       object to get PostCSS input source.
	   *
	   * @example
	   * error.input.file //=> 'a.css'
	   * error.file       //=> 'a.sass'
	   */;return CssSyntaxError;}(/*#__PURE__*/_wrapNativeSuper(Error));var _default=CssSyntaxError;exports["default"]=_default;module.exports=exports["default"];},{"./terminal-highlight":2,"chalk":2,"supports-color":2}],173:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _node=_interopRequireDefault(require("./node"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents a CSS declaration.
	 *
	 * @extends Node
	 *
	 * @example
	 * const root = postcss.parse('a { color: black }')
	 * const decl = root.first.first
	 * decl.type       //=> 'decl'
	 * decl.toString() //=> ' color: black'
	 */var Declaration=/*#__PURE__*/function(_Node){_inheritsLoose(Declaration,_Node);function Declaration(defaults){var _this;_this=_Node.call(this,defaults)||this;_this.type='decl';return _this;}/**
	   * @memberof Declaration#
	   * @member {string} prop The declaration’s property name.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black }')
	   * const decl = root.first.first
	   * decl.prop //=> 'color'
	   */ /**
	   * @memberof Declaration#
	   * @member {string} value The declaration’s value.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black }')
	   * const decl = root.first.first
	   * decl.value //=> 'black'
	   */ /**
	   * @memberof Declaration#
	   * @member {boolean} important `true` if the declaration
	   *                             has an !important annotation.
	   *
	   * @example
	   * const root = postcss.parse('a { color: black !important; color: red }')
	   * root.first.first.important //=> true
	   * root.first.last.important  //=> undefined
	   */ /**
	   * @memberof Declaration#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                       node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `before`: the space symbols before the node. It also stores `*`
	   *   and `_` symbols before the declaration (IE hack).
	   * * `between`: the symbols between the property and value
	   *   for declarations.
	   * * `important`: the content of the important statement,
	   *   if it is not just `!important`.
	   *
	   * PostCSS cleans declaration from comments and extra spaces,
	   * but it stores origin content in raws properties.
	   * As such, if you don’t change a declaration’s value,
	   * PostCSS will use the raw value with comments.
	   *
	   * @example
	   * const root = postcss.parse('a {\n  color:black\n}')
	   * root.first.first.raws //=> { before: '\n  ', between: ':' }
	   */return Declaration;}(_node["default"]);var _default=Declaration;exports["default"]=_default;module.exports=exports["default"];},{"./node":178}],174:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _path=_interopRequireDefault(require("path"));var _cssSyntaxError=_interopRequireDefault(require("./css-syntax-error"));var _previousMap=_interopRequireDefault(require("./previous-map"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}var sequence=0;/**
	 * Represents the source CSS.
	 *
	 * @example
	 * const root  = postcss.parse(css, { from: file })
	 * const input = root.source.input
	 */var Input=/*#__PURE__*/function(){/**
	   * @param {string} css    Input CSS source.
	   * @param {object} [opts] {@link Processor#process} options.
	   */function Input(css,opts){if(opts===void 0){opts={};}if(css===null||typeof css==='undefined'||_typeof(css)==='object'&&!css.toString){throw new Error("PostCSS received "+css+" instead of CSS string");}/**
	     * Input CSS source
	     *
	     * @type {string}
	     *
	     * @example
	     * const input = postcss.parse('a{}', { from: file }).input
	     * input.css //=> "a{}"
	     */this.css=css.toString();if(this.css[0]==="\uFEFF"||this.css[0]==="\uFFFE"){this.hasBOM=true;this.css=this.css.slice(1);}else{this.hasBOM=false;}if(opts.from){if(/^\w+:\/\//.test(opts.from)||_path["default"].isAbsolute(opts.from)){/**
	         * The absolute path to the CSS source file defined
	         * with the `from` option.
	         *
	         * @type {string}
	         *
	         * @example
	         * const root = postcss.parse(css, { from: 'a.css' })
	         * root.source.input.file //=> '/home/ai/a.css'
	         */this.file=opts.from;}else{this.file=_path["default"].resolve(opts.from);}}var map=new _previousMap["default"](this.css,opts);if(map.text){/**
	       * The input source map passed from a compilation step before PostCSS
	       * (for example, from Sass compiler).
	       *
	       * @type {PreviousMap}
	       *
	       * @example
	       * root.source.input.map.consumer().sources //=> ['a.sass']
	       */this.map=map;var file=map.consumer().file;if(!this.file&&file)this.file=this.mapResolve(file);}if(!this.file){sequence+=1;/**
	       * The unique ID of the CSS source. It will be created if `from` option
	       * is not provided (because PostCSS does not know the file path).
	       *
	       * @type {string}
	       *
	       * @example
	       * const root = postcss.parse(css)
	       * root.source.input.file //=> undefined
	       * root.source.input.id   //=> "<input css 1>"
	       */this.id='<input css '+sequence+'>';}if(this.map)this.map.file=this.from;}var _proto=Input.prototype;_proto.error=function error(message,line,column,opts){if(opts===void 0){opts={};}var result;var origin=this.origin(line,column);if(origin){result=new _cssSyntaxError["default"](message,origin.line,origin.column,origin.source,origin.file,opts.plugin);}else{result=new _cssSyntaxError["default"](message,line,column,this.css,this.file,opts.plugin);}result.input={line:line,column:column,source:this.css};if(this.file)result.input.file=this.file;return result;}/**
	   * Reads the input source map and returns a symbol position
	   * in the input source (e.g., in a Sass file that was compiled
	   * to CSS before being passed to PostCSS).
	   *
	   * @param {number} line   Line in input CSS.
	   * @param {number} column Column in input CSS.
	   *
	   * @return {filePosition} Position in input source.
	   *
	   * @example
	   * root.source.input.origin(1, 1) //=> { file: 'a.css', line: 3, column: 1 }
	   */;_proto.origin=function origin(line,column){if(!this.map)return false;var consumer=this.map.consumer();var from=consumer.originalPositionFor({line:line,column:column});if(!from.source)return false;var result={file:this.mapResolve(from.source),line:from.line,column:from.column};var source=consumer.sourceContentFor(from.source);if(source)result.source=source;return result;};_proto.mapResolve=function mapResolve(file){if(/^\w+:\/\//.test(file)){return file;}return _path["default"].resolve(this.map.consumer().sourceRoot||'.',file);}/**
	   * The CSS source identifier. Contains {@link Input#file} if the user
	   * set the `from` option, or {@link Input#id} if they did not.
	   *
	   * @type {string}
	   *
	   * @example
	   * const root = postcss.parse(css, { from: 'a.css' })
	   * root.source.input.from //=> "/home/ai/a.css"
	   *
	   * const root = postcss.parse(css)
	   * root.source.input.from //=> "<input css 1>"
	   */;_createClass(Input,[{key:"from",get:function get(){return this.file||this.id;}}]);return Input;}();var _default=Input;/**
	 * @typedef  {object} filePosition
	 * @property {string} file   Path to file.
	 * @property {number} line   Source line in file.
	 * @property {number} column Source column in file.
	 */exports["default"]=_default;module.exports=exports["default"];},{"./css-syntax-error":172,"./previous-map":182,"path":168}],175:[function(require,module,exports){(function(process){"use strict";exports.__esModule=true;exports["default"]=void 0;var _mapGenerator=_interopRequireDefault(require("./map-generator"));var _stringify2=_interopRequireDefault(require("./stringify"));var _warnOnce=_interopRequireDefault(require("./warn-once"));var _result=_interopRequireDefault(require("./result"));var _parse=_interopRequireDefault(require("./parse"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function isPromise(obj){return _typeof(obj)==='object'&&typeof obj.then==='function';}/**
	 * A Promise proxy for the result of PostCSS transformations.
	 *
	 * A `LazyResult` instance is returned by {@link Processor#process}.
	 *
	 * @example
	 * const lazy = postcss([autoprefixer]).process(css)
	 */var LazyResult=/*#__PURE__*/function(){function LazyResult(processor,css,opts){this.stringified=false;this.processed=false;var root;if(_typeof(css)==='object'&&css!==null&&css.type==='root'){root=css;}else if(css instanceof LazyResult||css instanceof _result["default"]){root=css.root;if(css.map){if(typeof opts.map==='undefined')opts.map={};if(!opts.map.inline)opts.map.inline=false;opts.map.prev=css.map;}}else{var parser=_parse["default"];if(opts.syntax)parser=opts.syntax.parse;if(opts.parser)parser=opts.parser;if(parser.parse)parser=parser.parse;try{root=parser(css,opts);}catch(error){this.error=error;}}this.result=new _result["default"](processor,root,opts);}/**
	   * Returns a {@link Processor} instance, which will be used
	   * for CSS transformations.
	   *
	   * @type {Processor}
	   */var _proto=LazyResult.prototype;/**
	   * Processes input CSS through synchronous plugins
	   * and calls {@link Result#warnings()}.
	   *
	   * @return {Warning[]} Warnings from plugins.
	   */_proto.warnings=function warnings(){return this.sync().warnings();}/**
	   * Alias for the {@link LazyResult#css} property.
	   *
	   * @example
	   * lazy + '' === lazy.css
	   *
	   * @return {string} Output CSS.
	   */;_proto.toString=function toString(){return this.css;}/**
	   * Processes input CSS through synchronous and asynchronous plugins
	   * and calls `onFulfilled` with a Result instance. If a plugin throws
	   * an error, the `onRejected` callback will be executed.
	   *
	   * It implements standard Promise API.
	   *
	   * @param {onFulfilled} onFulfilled Callback will be executed
	   *                                  when all plugins will finish work.
	   * @param {onRejected}  onRejected  Callback will be executed on any error.
	   *
	   * @return {Promise} Promise API to make queue.
	   *
	   * @example
	   * postcss([autoprefixer]).process(css, { from: cssPath }).then(result => {
	   *   console.log(result.css)
	   * })
	   */;_proto.then=function then(onFulfilled,onRejected){if(process.env.NODE_ENV!=='production'){if(!('from'in this.opts)){(0,_warnOnce["default"])('Without `from` option PostCSS could generate wrong source map '+'and will not find Browserslist config. Set it to CSS file path '+'or to `undefined` to prevent this warning.');}}return this.async().then(onFulfilled,onRejected);}/**
	   * Processes input CSS through synchronous and asynchronous plugins
	   * and calls onRejected for each error thrown in any plugin.
	   *
	   * It implements standard Promise API.
	   *
	   * @param {onRejected} onRejected Callback will be executed on any error.
	   *
	   * @return {Promise} Promise API to make queue.
	   *
	   * @example
	   * postcss([autoprefixer]).process(css).then(result => {
	   *   console.log(result.css)
	   * }).catch(error => {
	   *   console.error(error)
	   * })
	   */;_proto["catch"]=function _catch(onRejected){return this.async()["catch"](onRejected);}/**
	   * Processes input CSS through synchronous and asynchronous plugins
	   * and calls onFinally on any error or when all plugins will finish work.
	   *
	   * It implements standard Promise API.
	   *
	   * @param {onFinally} onFinally Callback will be executed on any error or
	   *                              when all plugins will finish work.
	   *
	   * @return {Promise} Promise API to make queue.
	   *
	   * @example
	   * postcss([autoprefixer]).process(css).finally(() => {
	   *   console.log('processing ended')
	   * })
	   */;_proto["finally"]=function _finally(onFinally){return this.async().then(onFinally,onFinally);};_proto.handleError=function handleError(error,plugin){try{this.error=error;if(error.name==='CssSyntaxError'&&!error.plugin){error.plugin=plugin.postcssPlugin;error.setMessage();}else if(plugin.postcssVersion){if(process.env.NODE_ENV!=='production'){var pluginName=plugin.postcssPlugin;var pluginVer=plugin.postcssVersion;var runtimeVer=this.result.processor.version;var a=pluginVer.split('.');var b=runtimeVer.split('.');if(a[0]!==b[0]||parseInt(a[1])>parseInt(b[1])){console.error('Unknown error from PostCSS plugin. Your current PostCSS '+'version is '+runtimeVer+', but '+pluginName+' uses '+pluginVer+'. Perhaps this is the source of the error below.');}}}}catch(err){if(console&&console.error)console.error(err);}};_proto.asyncTick=function asyncTick(resolve,reject){var _this=this;if(this.plugin>=this.processor.plugins.length){this.processed=true;return resolve();}try{var plugin=this.processor.plugins[this.plugin];var promise=this.run(plugin);this.plugin+=1;if(isPromise(promise)){promise.then(function(){_this.asyncTick(resolve,reject);})["catch"](function(error){_this.handleError(error,plugin);_this.processed=true;reject(error);});}else{this.asyncTick(resolve,reject);}}catch(error){this.processed=true;reject(error);}};_proto.async=function async(){var _this2=this;if(this.processed){return new Promise(function(resolve,reject){if(_this2.error){reject(_this2.error);}else{resolve(_this2.stringify());}});}if(this.processing){return this.processing;}this.processing=new Promise(function(resolve,reject){if(_this2.error)return reject(_this2.error);_this2.plugin=0;_this2.asyncTick(resolve,reject);}).then(function(){_this2.processed=true;return _this2.stringify();});return this.processing;};_proto.sync=function sync(){if(this.processed)return this.result;this.processed=true;if(this.processing){throw new Error('Use process(css).then(cb) to work with async plugins');}if(this.error)throw this.error;for(var _iterator=_createForOfIteratorHelperLoose(this.result.processor.plugins),_step;!(_step=_iterator()).done;){var plugin=_step.value;var promise=this.run(plugin);if(isPromise(promise)){throw new Error('Use process(css).then(cb) to work with async plugins');}}return this.result;};_proto.run=function run(plugin){this.result.lastPlugin=plugin;try{return plugin(this.result.root,this.result);}catch(error){this.handleError(error,plugin);throw error;}};_proto.stringify=function stringify(){if(this.stringified)return this.result;this.stringified=true;this.sync();var opts=this.result.opts;var str=_stringify2["default"];if(opts.syntax)str=opts.syntax.stringify;if(opts.stringifier)str=opts.stringifier;if(str.stringify)str=str.stringify;var map=new _mapGenerator["default"](str,this.result.root,this.result.opts);var data=map.generate();this.result.css=data[0];this.result.map=data[1];return this.result;};_createClass(LazyResult,[{key:"processor",get:function get(){return this.result.processor;}/**
	     * Options from the {@link Processor#process} call.
	     *
	     * @type {processOptions}
	     */},{key:"opts",get:function get(){return this.result.opts;}/**
	     * Processes input CSS through synchronous plugins, converts `Root`
	     * to a CSS string and returns {@link Result#css}.
	     *
	     * This property will only work with synchronous plugins.
	     * If the processor contains any asynchronous plugins
	     * it will throw an error. This is why this method is only
	     * for debug purpose, you should always use {@link LazyResult#then}.
	     *
	     * @type {string}
	     * @see Result#css
	     */},{key:"css",get:function get(){return this.stringify().css;}/**
	     * An alias for the `css` property. Use it with syntaxes
	     * that generate non-CSS output.
	     *
	     * This property will only work with synchronous plugins.
	     * If the processor contains any asynchronous plugins
	     * it will throw an error. This is why this method is only
	     * for debug purpose, you should always use {@link LazyResult#then}.
	     *
	     * @type {string}
	     * @see Result#content
	     */},{key:"content",get:function get(){return this.stringify().content;}/**
	     * Processes input CSS through synchronous plugins
	     * and returns {@link Result#map}.
	     *
	     * This property will only work with synchronous plugins.
	     * If the processor contains any asynchronous plugins
	     * it will throw an error. This is why this method is only
	     * for debug purpose, you should always use {@link LazyResult#then}.
	     *
	     * @type {SourceMapGenerator}
	     * @see Result#map
	     */},{key:"map",get:function get(){return this.stringify().map;}/**
	     * Processes input CSS through synchronous plugins
	     * and returns {@link Result#root}.
	     *
	     * This property will only work with synchronous plugins. If the processor
	     * contains any asynchronous plugins it will throw an error.
	     *
	     * This is why this method is only for debug purpose,
	     * you should always use {@link LazyResult#then}.
	     *
	     * @type {Root}
	     * @see Result#root
	     */},{key:"root",get:function get(){return this.sync().root;}/**
	     * Processes input CSS through synchronous plugins
	     * and returns {@link Result#messages}.
	     *
	     * This property will only work with synchronous plugins. If the processor
	     * contains any asynchronous plugins it will throw an error.
	     *
	     * This is why this method is only for debug purpose,
	     * you should always use {@link LazyResult#then}.
	     *
	     * @type {Message[]}
	     * @see Result#messages
	     */},{key:"messages",get:function get(){return this.sync().messages;}}]);return LazyResult;}();var _default=LazyResult;/**
	 * @callback onFulfilled
	 * @param {Result} result
	 */ /**
	 * @callback onRejected
	 * @param {Error} error
	 */exports["default"]=_default;module.exports=exports["default"];}).call(this,require('_process'));},{"./map-generator":177,"./parse":179,"./result":184,"./stringify":188,"./warn-once":191,"_process":193}],176:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;/**
	 * Contains helpers for safely splitting lists of CSS values,
	 * preserving parentheses and quotes.
	 *
	 * @example
	 * const list = postcss.list
	 *
	 * @namespace list
	 */var list={split:function split(string,separators,last){var array=[];var current='';var split=false;var func=0;var quote=false;var escape=false;for(var i=0;i<string.length;i++){var letter=string[i];if(quote){if(escape){escape=false;}else if(letter==='\\'){escape=true;}else if(letter===quote){quote=false;}}else if(letter==='"'||letter==='\''){quote=letter;}else if(letter==='('){func+=1;}else if(letter===')'){if(func>0)func-=1;}else if(func===0){if(separators.indexOf(letter)!==-1)split=true;}if(split){if(current!=='')array.push(current.trim());current='';split=false;}else{current+=letter;}}if(last||current!=='')array.push(current.trim());return array;},/**
	   * Safely splits space-separated values (such as those for `background`,
	   * `border-radius`, and other shorthand properties).
	   *
	   * @param {string} string Space-separated values.
	   *
	   * @return {string[]} Split values.
	   *
	   * @example
	   * postcss.list.space('1px calc(10% + 1px)') //=> ['1px', 'calc(10% + 1px)']
	   */space:function space(string){var spaces=[' ','\n','\t'];return list.split(string,spaces);},/**
	   * Safely splits comma-separated values (such as those for `transition-*`
	   * and `background` properties).
	   *
	   * @param {string} string Comma-separated values.
	   *
	   * @return {string[]} Split values.
	   *
	   * @example
	   * postcss.list.comma('black, linear-gradient(white, black)')
	   * //=> ['black', 'linear-gradient(white, black)']
	   */comma:function comma(string){return list.split(string,[','],true);}};var _default=list;exports["default"]=_default;module.exports=exports["default"];},{}],177:[function(require,module,exports){(function(Buffer){"use strict";exports.__esModule=true;exports["default"]=void 0;var _sourceMap=_interopRequireDefault(require("source-map"));var _path=_interopRequireDefault(require("path"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}var MapGenerator=/*#__PURE__*/function(){function MapGenerator(stringify,root,opts){this.stringify=stringify;this.mapOpts=opts.map||{};this.root=root;this.opts=opts;}var _proto=MapGenerator.prototype;_proto.isMap=function isMap(){if(typeof this.opts.map!=='undefined'){return!!this.opts.map;}return this.previous().length>0;};_proto.previous=function previous(){var _this=this;if(!this.previousMaps){this.previousMaps=[];this.root.walk(function(node){if(node.source&&node.source.input.map){var map=node.source.input.map;if(_this.previousMaps.indexOf(map)===-1){_this.previousMaps.push(map);}}});}return this.previousMaps;};_proto.isInline=function isInline(){if(typeof this.mapOpts.inline!=='undefined'){return this.mapOpts.inline;}var annotation=this.mapOpts.annotation;if(typeof annotation!=='undefined'&&annotation!==true){return false;}if(this.previous().length){return this.previous().some(function(i){return i.inline;});}return true;};_proto.isSourcesContent=function isSourcesContent(){if(typeof this.mapOpts.sourcesContent!=='undefined'){return this.mapOpts.sourcesContent;}if(this.previous().length){return this.previous().some(function(i){return i.withContent();});}return true;};_proto.clearAnnotation=function clearAnnotation(){if(this.mapOpts.annotation===false)return;var node;for(var i=this.root.nodes.length-1;i>=0;i--){node=this.root.nodes[i];if(node.type!=='comment')continue;if(node.text.indexOf('# sourceMappingURL=')===0){this.root.removeChild(i);}}};_proto.setSourcesContent=function setSourcesContent(){var _this2=this;var already={};this.root.walk(function(node){if(node.source){var from=node.source.input.from;if(from&&!already[from]){already[from]=true;var relative=_this2.relative(from);_this2.map.setSourceContent(relative,node.source.input.css);}}});};_proto.applyPrevMaps=function applyPrevMaps(){for(var _iterator=_createForOfIteratorHelperLoose(this.previous()),_step;!(_step=_iterator()).done;){var prev=_step.value;var from=this.relative(prev.file);var root=prev.root||_path["default"].dirname(prev.file);var map=void 0;if(this.mapOpts.sourcesContent===false){map=new _sourceMap["default"].SourceMapConsumer(prev.text);if(map.sourcesContent){map.sourcesContent=map.sourcesContent.map(function(){return null;});}}else{map=prev.consumer();}this.map.applySourceMap(map,from,this.relative(root));}};_proto.isAnnotation=function isAnnotation(){if(this.isInline()){return true;}if(typeof this.mapOpts.annotation!=='undefined'){return this.mapOpts.annotation;}if(this.previous().length){return this.previous().some(function(i){return i.annotation;});}return true;};_proto.toBase64=function toBase64(str){if(Buffer){return Buffer.from(str).toString('base64');}return window.btoa(unescape(encodeURIComponent(str)));};_proto.addAnnotation=function addAnnotation(){var content;if(this.isInline()){content='data:application/json;base64,'+this.toBase64(this.map.toString());}else if(typeof this.mapOpts.annotation==='string'){content=this.mapOpts.annotation;}else{content=this.outputFile()+'.map';}var eol='\n';if(this.css.indexOf('\r\n')!==-1)eol='\r\n';this.css+=eol+'/*# sourceMappingURL='+content+' */';};_proto.outputFile=function outputFile(){if(this.opts.to){return this.relative(this.opts.to);}if(this.opts.from){return this.relative(this.opts.from);}return'to.css';};_proto.generateMap=function generateMap(){this.generateString();if(this.isSourcesContent())this.setSourcesContent();if(this.previous().length>0)this.applyPrevMaps();if(this.isAnnotation())this.addAnnotation();if(this.isInline()){return[this.css];}return[this.css,this.map];};_proto.relative=function relative(file){if(file.indexOf('<')===0)return file;if(/^\w+:\/\//.test(file))return file;var from=this.opts.to?_path["default"].dirname(this.opts.to):'.';if(typeof this.mapOpts.annotation==='string'){from=_path["default"].dirname(_path["default"].resolve(from,this.mapOpts.annotation));}file=_path["default"].relative(from,file);if(_path["default"].sep==='\\'){return file.replace(/\\/g,'/');}return file;};_proto.sourcePath=function sourcePath(node){if(this.mapOpts.from){return this.mapOpts.from;}return this.relative(node.source.input.from);};_proto.generateString=function generateString(){var _this3=this;this.css='';this.map=new _sourceMap["default"].SourceMapGenerator({file:this.outputFile()});var line=1;var column=1;var lines,last;this.stringify(this.root,function(str,node,type){_this3.css+=str;if(node&&type!=='end'){if(node.source&&node.source.start){_this3.map.addMapping({source:_this3.sourcePath(node),generated:{line:line,column:column-1},original:{line:node.source.start.line,column:node.source.start.column-1}});}else{_this3.map.addMapping({source:'<no source>',original:{line:1,column:0},generated:{line:line,column:column-1}});}}lines=str.match(/\n/g);if(lines){line+=lines.length;last=str.lastIndexOf('\n');column=str.length-last;}else{column+=str.length;}if(node&&type!=='start'){var p=node.parent||{raws:{}};if(node.type!=='decl'||node!==p.last||p.raws.semicolon){if(node.source&&node.source.end){_this3.map.addMapping({source:_this3.sourcePath(node),generated:{line:line,column:column-2},original:{line:node.source.end.line,column:node.source.end.column-1}});}else{_this3.map.addMapping({source:'<no source>',original:{line:1,column:0},generated:{line:line,column:column-1}});}}}});};_proto.generate=function generate(){this.clearAnnotation();if(this.isMap()){return this.generateMap();}var result='';this.stringify(this.root,function(i){result+=i;});return[result];};return MapGenerator;}();var _default=MapGenerator;exports["default"]=_default;module.exports=exports["default"];}).call(this,require("buffer").Buffer);},{"buffer":3,"path":168,"source-map":208}],178:[function(require,module,exports){(function(process){"use strict";exports.__esModule=true;exports["default"]=void 0;var _cssSyntaxError=_interopRequireDefault(require("./css-syntax-error"));var _stringifier=_interopRequireDefault(require("./stringifier"));var _stringify=_interopRequireDefault(require("./stringify"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function cloneNode(obj,parent){var cloned=new obj.constructor();for(var i in obj){if(!obj.hasOwnProperty(i))continue;var value=obj[i];var type=_typeof(value);if(i==='parent'&&type==='object'){if(parent)cloned[i]=parent;}else if(i==='source'){cloned[i]=value;}else if(value instanceof Array){cloned[i]=value.map(function(j){return cloneNode(j,cloned);});}else{if(type==='object'&&value!==null)value=cloneNode(value);cloned[i]=value;}}return cloned;}/**
	 * All node classes inherit the following common methods.
	 *
	 * @abstract
	 */var Node=/*#__PURE__*/function(){/**
	   * @param {object} [defaults] Value for node properties.
	   */function Node(defaults){if(defaults===void 0){defaults={};}this.raws={};if(process.env.NODE_ENV!=='production'){if(_typeof(defaults)!=='object'&&typeof defaults!=='undefined'){throw new Error('PostCSS nodes constructor accepts object, not '+JSON.stringify(defaults));}}for(var name in defaults){this[name]=defaults[name];}}/**
	   * Returns a `CssSyntaxError` instance containing the original position
	   * of the node in the source, showing line and column numbers and also
	   * a small excerpt to facilitate debugging.
	   *
	   * If present, an input source map will be used to get the original position
	   * of the source, even from a previous compilation step
	   * (e.g., from Sass compilation).
	   *
	   * This method produces very useful error messages.
	   *
	   * @param {string} message     Error description.
	   * @param {object} [opts]      Options.
	   * @param {string} opts.plugin Plugin name that created this error.
	   *                             PostCSS will set it automatically.
	   * @param {string} opts.word   A word inside a node’s string that should
	   *                             be highlighted as the source of the error.
	   * @param {number} opts.index  An index inside a node’s string that should
	   *                             be highlighted as the source of the error.
	   *
	   * @return {CssSyntaxError} Error object to throw it.
	   *
	   * @example
	   * if (!variables[name]) {
	   *   throw decl.error('Unknown variable ' + name, { word: name })
	   *   // CssSyntaxError: postcss-vars:a.sass:4:3: Unknown variable $black
	   *   //   color: $black
	   *   // a
	   *   //          ^
	   *   //   background: white
	   * }
	   */var _proto=Node.prototype;_proto.error=function error(message,opts){if(opts===void 0){opts={};}if(this.source){var pos=this.positionBy(opts);return this.source.input.error(message,pos.line,pos.column,opts);}return new _cssSyntaxError["default"](message);}/**
	   * This method is provided as a convenience wrapper for {@link Result#warn}.
	   *
	   * @param {Result} result      The {@link Result} instance
	   *                             that will receive the warning.
	   * @param {string} text        Warning message.
	   * @param {object} [opts]      Options
	   * @param {string} opts.plugin Plugin name that created this warning.
	   *                             PostCSS will set it automatically.
	   * @param {string} opts.word   A word inside a node’s string that should
	   *                             be highlighted as the source of the warning.
	   * @param {number} opts.index  An index inside a node’s string that should
	   *                             be highlighted as the source of the warning.
	   *
	   * @return {Warning} Created warning object.
	   *
	   * @example
	   * const plugin = postcss.plugin('postcss-deprecated', () => {
	   *   return (root, result) => {
	   *     root.walkDecls('bad', decl => {
	   *       decl.warn(result, 'Deprecated property bad')
	   *     })
	   *   }
	   * })
	   */;_proto.warn=function warn(result,text,opts){var data={node:this};for(var i in opts){data[i]=opts[i];}return result.warn(text,data);}/**
	   * Removes the node from its parent and cleans the parent properties
	   * from the node and its children.
	   *
	   * @example
	   * if (decl.prop.match(/^-webkit-/)) {
	   *   decl.remove()
	   * }
	   *
	   * @return {Node} Node to make calls chain.
	   */;_proto.remove=function remove(){if(this.parent){this.parent.removeChild(this);}this.parent=undefined;return this;}/**
	   * Returns a CSS string representing the node.
	   *
	   * @param {stringifier|syntax} [stringifier] A syntax to use
	   *                                           in string generation.
	   *
	   * @return {string} CSS string of this node.
	   *
	   * @example
	   * postcss.rule({ selector: 'a' }).toString() //=> "a {}"
	   */;_proto.toString=function toString(stringifier){if(stringifier===void 0){stringifier=_stringify["default"];}if(stringifier.stringify)stringifier=stringifier.stringify;var result='';stringifier(this,function(i){result+=i;});return result;}/**
	   * Returns an exact clone of the node.
	   *
	   * The resulting cloned node and its (cloned) children will retain
	   * code style properties.
	   *
	   * @param {object} [overrides] New properties to override in the clone.
	   *
	   * @example
	   * decl.raws.before    //=> "\n  "
	   * const cloned = decl.clone({ prop: '-moz-' + decl.prop })
	   * cloned.raws.before  //=> "\n  "
	   * cloned.toString()   //=> -moz-transform: scale(0)
	   *
	   * @return {Node} Clone of the node.
	   */;_proto.clone=function clone(overrides){if(overrides===void 0){overrides={};}var cloned=cloneNode(this);for(var name in overrides){cloned[name]=overrides[name];}return cloned;}/**
	   * Shortcut to clone the node and insert the resulting cloned node
	   * before the current node.
	   *
	   * @param {object} [overrides] Mew properties to override in the clone.
	   *
	   * @example
	   * decl.cloneBefore({ prop: '-moz-' + decl.prop })
	   *
	   * @return {Node} New node
	   */;_proto.cloneBefore=function cloneBefore(overrides){if(overrides===void 0){overrides={};}var cloned=this.clone(overrides);this.parent.insertBefore(this,cloned);return cloned;}/**
	   * Shortcut to clone the node and insert the resulting cloned node
	   * after the current node.
	   *
	   * @param {object} [overrides] New properties to override in the clone.
	   *
	   * @return {Node} New node.
	   */;_proto.cloneAfter=function cloneAfter(overrides){if(overrides===void 0){overrides={};}var cloned=this.clone(overrides);this.parent.insertAfter(this,cloned);return cloned;}/**
	   * Inserts node(s) before the current node and removes the current node.
	   *
	   * @param {...Node} nodes Mode(s) to replace current one.
	   *
	   * @example
	   * if (atrule.name === 'mixin') {
	   *   atrule.replaceWith(mixinRules[atrule.params])
	   * }
	   *
	   * @return {Node} Current node to methods chain.
	   */;_proto.replaceWith=function replaceWith(){if(this.parent){for(var _len=arguments.length,nodes=new Array(_len),_key=0;_key<_len;_key++){nodes[_key]=arguments[_key];}for(var _i=0,_nodes=nodes;_i<_nodes.length;_i++){var node=_nodes[_i];this.parent.insertBefore(this,node);}this.remove();}return this;}/**
	   * Returns the next child of the node’s parent.
	   * Returns `undefined` if the current node is the last child.
	   *
	   * @return {Node|undefined} Next node.
	   *
	   * @example
	   * if (comment.text === 'delete next') {
	   *   const next = comment.next()
	   *   if (next) {
	   *     next.remove()
	   *   }
	   * }
	   */;_proto.next=function next(){if(!this.parent)return undefined;var index=this.parent.index(this);return this.parent.nodes[index+1];}/**
	   * Returns the previous child of the node’s parent.
	   * Returns `undefined` if the current node is the first child.
	   *
	   * @return {Node|undefined} Previous node.
	   *
	   * @example
	   * const annotation = decl.prev()
	   * if (annotation.type === 'comment') {
	   *   readAnnotation(annotation.text)
	   * }
	   */;_proto.prev=function prev(){if(!this.parent)return undefined;var index=this.parent.index(this);return this.parent.nodes[index-1];}/**
	   * Insert new node before current node to current node’s parent.
	   *
	   * Just alias for `node.parent.insertBefore(node, add)`.
	   *
	   * @param {Node|object|string|Node[]} add New node.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * decl.before('content: ""')
	   */;_proto.before=function before(add){this.parent.insertBefore(this,add);return this;}/**
	   * Insert new node after current node to current node’s parent.
	   *
	   * Just alias for `node.parent.insertAfter(node, add)`.
	   *
	   * @param {Node|object|string|Node[]} add New node.
	   *
	   * @return {Node} This node for methods chain.
	   *
	   * @example
	   * decl.after('color: black')
	   */;_proto.after=function after(add){this.parent.insertAfter(this,add);return this;};_proto.toJSON=function toJSON(){var fixed={};for(var name in this){if(!this.hasOwnProperty(name))continue;if(name==='parent')continue;var value=this[name];if(value instanceof Array){fixed[name]=value.map(function(i){if(_typeof(i)==='object'&&i.toJSON){return i.toJSON();}else{return i;}});}else if(_typeof(value)==='object'&&value.toJSON){fixed[name]=value.toJSON();}else{fixed[name]=value;}}return fixed;}/**
	   * Returns a {@link Node#raws} value. If the node is missing
	   * the code style property (because the node was manually built or cloned),
	   * PostCSS will try to autodetect the code style property by looking
	   * at other nodes in the tree.
	   *
	   * @param {string} prop          Name of code style property.
	   * @param {string} [defaultType] Name of default value, it can be missed
	   *                               if the value is the same as prop.
	   *
	   * @example
	   * const root = postcss.parse('a { background: white }')
	   * root.nodes[0].append({ prop: 'color', value: 'black' })
	   * root.nodes[0].nodes[1].raws.before   //=> undefined
	   * root.nodes[0].nodes[1].raw('before') //=> ' '
	   *
	   * @return {string} Code style value.
	   */;_proto.raw=function raw(prop,defaultType){var str=new _stringifier["default"]();return str.raw(this,prop,defaultType);}/**
	   * Finds the Root instance of the node’s tree.
	   *
	   * @example
	   * root.nodes[0].nodes[0].root() === root
	   *
	   * @return {Root} Root parent.
	   */;_proto.root=function root(){var result=this;while(result.parent){result=result.parent;}return result;}/**
	   * Clear the code style properties for the node and its children.
	   *
	   * @param {boolean} [keepBetween] Keep the raws.between symbols.
	   *
	   * @return {undefined}
	   *
	   * @example
	   * node.raws.before  //=> ' '
	   * node.cleanRaws()
	   * node.raws.before  //=> undefined
	   */;_proto.cleanRaws=function cleanRaws(keepBetween){delete this.raws.before;delete this.raws.after;if(!keepBetween)delete this.raws.between;};_proto.positionInside=function positionInside(index){var string=this.toString();var column=this.source.start.column;var line=this.source.start.line;for(var i=0;i<index;i++){if(string[i]==='\n'){column=1;line+=1;}else{column+=1;}}return{line:line,column:column};};_proto.positionBy=function positionBy(opts){var pos=this.source.start;if(opts.index){pos=this.positionInside(opts.index);}else if(opts.word){var index=this.toString().indexOf(opts.word);if(index!==-1)pos=this.positionInside(index);}return pos;}/**
	   * @memberof Node#
	   * @member {string} type String representing the node’s type.
	   *                       Possible values are `root`, `atrule`, `rule`,
	   *                       `decl`, or `comment`.
	   *
	   * @example
	   * postcss.decl({ prop: 'color', value: 'black' }).type //=> 'decl'
	   */ /**
	   * @memberof Node#
	   * @member {Container} parent The node’s parent node.
	   *
	   * @example
	   * root.nodes[0].parent === root
	   */ /**
	   * @memberof Node#
	   * @member {source} source The input source of the node.
	   *
	   * The property is used in source map generation.
	   *
	   * If you create a node manually (e.g., with `postcss.decl()`),
	   * that node will not have a `source` property and will be absent
	   * from the source map. For this reason, the plugin developer should
	   * consider cloning nodes to create new ones (in which case the new node’s
	   * source will reference the original, cloned node) or setting
	   * the `source` property manually.
	   *
	   * ```js
	   * // Bad
	   * const prefixed = postcss.decl({
	   *   prop: '-moz-' + decl.prop,
	   *   value: decl.value
	   * })
	   *
	   * // Good
	   * const prefixed = decl.clone({ prop: '-moz-' + decl.prop })
	   * ```
	   *
	   * ```js
	   * if (atrule.name === 'add-link') {
	   *   const rule = postcss.rule({ selector: 'a', source: atrule.source })
	   *   atrule.parent.insertBefore(atrule, rule)
	   * }
	   * ```
	   *
	   * @example
	   * decl.source.input.from //=> '/home/ai/a.sass'
	   * decl.source.start      //=> { line: 10, column: 2 }
	   * decl.source.end        //=> { line: 10, column: 12 }
	   */ /**
	   * @memberof Node#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                       node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `before`: the space symbols before the node. It also stores `*`
	   *   and `_` symbols before the declaration (IE hack).
	   * * `after`: the space symbols after the last child of the node
	   *   to the end of the node.
	   * * `between`: the symbols between the property and value
	   *   for declarations, selector and `{` for rules, or last parameter
	   *   and `{` for at-rules.
	   * * `semicolon`: contains true if the last child has
	   *   an (optional) semicolon.
	   * * `afterName`: the space between the at-rule name and its parameters.
	   * * `left`: the space symbols between `/*` and the comment’s text.
	   * * `right`: the space symbols between the comment’s text
	   *   and <code>*&#47;</code>.
	   * * `important`: the content of the important statement,
	   *   if it is not just `!important`.
	   *
	   * PostCSS cleans selectors, declaration values and at-rule parameters
	   * from comments and extra spaces, but it stores origin content in raws
	   * properties. As such, if you don’t change a declaration’s value,
	   * PostCSS will use the raw value with comments.
	   *
	   * @example
	   * const root = postcss.parse('a {\n  color:black\n}')
	   * root.first.first.raws //=> { before: '\n  ', between: ':' }
	   */;return Node;}();var _default=Node;/**
	 * @typedef {object} position
	 * @property {number} line   Source line in file.
	 * @property {number} column Source column in file.
	 */ /**
	 * @typedef {object} source
	 * @property {Input} input    {@link Input} with input file
	 * @property {position} start The starting position of the node’s source.
	 * @property {position} end   The ending position of the node’s source.
	 */exports["default"]=_default;module.exports=exports["default"];}).call(this,require('_process'));},{"./css-syntax-error":172,"./stringifier":187,"./stringify":188,"_process":193}],179:[function(require,module,exports){(function(process){"use strict";exports.__esModule=true;exports["default"]=void 0;var _parser=_interopRequireDefault(require("./parser"));var _input=_interopRequireDefault(require("./input"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function parse(css,opts){var input=new _input["default"](css,opts);var parser=new _parser["default"](input);try{parser.parse();}catch(e){if(process.env.NODE_ENV!=='production'){if(e.name==='CssSyntaxError'&&opts&&opts.from){if(/\.scss$/i.test(opts.from)){e.message+='\nYou tried to parse SCSS with '+'the standard CSS parser; '+'try again with the postcss-scss parser';}else if(/\.sass/i.test(opts.from)){e.message+='\nYou tried to parse Sass with '+'the standard CSS parser; '+'try again with the postcss-sass parser';}else if(/\.less$/i.test(opts.from)){e.message+='\nYou tried to parse Less with '+'the standard CSS parser; '+'try again with the postcss-less parser';}}}throw e;}return parser.root;}var _default=parse;exports["default"]=_default;module.exports=exports["default"];}).call(this,require('_process'));},{"./input":174,"./parser":180,"_process":193}],180:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _declaration=_interopRequireDefault(require("./declaration"));var _tokenize=_interopRequireDefault(require("./tokenize"));var _comment=_interopRequireDefault(require("./comment"));var _atRule=_interopRequireDefault(require("./at-rule"));var _root=_interopRequireDefault(require("./root"));var _rule=_interopRequireDefault(require("./rule"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}var Parser=/*#__PURE__*/function(){function Parser(input){this.input=input;this.root=new _root["default"]();this.current=this.root;this.spaces='';this.semicolon=false;this.createTokenizer();this.root.source={input:input,start:{line:1,column:1}};}var _proto=Parser.prototype;_proto.createTokenizer=function createTokenizer(){this.tokenizer=(0,_tokenize["default"])(this.input);};_proto.parse=function parse(){var token;while(!this.tokenizer.endOfFile()){token=this.tokenizer.nextToken();switch(token[0]){case'space':this.spaces+=token[1];break;case';':this.freeSemicolon(token);break;case'}':this.end(token);break;case'comment':this.comment(token);break;case'at-word':this.atrule(token);break;case'{':this.emptyRule(token);break;default:this.other(token);break;}}this.endFile();};_proto.comment=function comment(token){var node=new _comment["default"]();this.init(node,token[2],token[3]);node.source.end={line:token[4],column:token[5]};var text=token[1].slice(2,-2);if(/^\s*$/.test(text)){node.text='';node.raws.left=text;node.raws.right='';}else{var match=text.match(/^(\s*)([^]*[^\s])(\s*)$/);node.text=match[2];node.raws.left=match[1];node.raws.right=match[3];}};_proto.emptyRule=function emptyRule(token){var node=new _rule["default"]();this.init(node,token[2],token[3]);node.selector='';node.raws.between='';this.current=node;};_proto.other=function other(start){var end=false;var type=null;var colon=false;var bracket=null;var brackets=[];var tokens=[];var token=start;while(token){type=token[0];tokens.push(token);if(type==='('||type==='['){if(!bracket)bracket=token;brackets.push(type==='('?')':']');}else if(brackets.length===0){if(type===';'){if(colon){this.decl(tokens);return;}else{break;}}else if(type==='{'){this.rule(tokens);return;}else if(type==='}'){this.tokenizer.back(tokens.pop());end=true;break;}else if(type===':'){colon=true;}}else if(type===brackets[brackets.length-1]){brackets.pop();if(brackets.length===0)bracket=null;}token=this.tokenizer.nextToken();}if(this.tokenizer.endOfFile())end=true;if(brackets.length>0)this.unclosedBracket(bracket);if(end&&colon){while(tokens.length){token=tokens[tokens.length-1][0];if(token!=='space'&&token!=='comment')break;this.tokenizer.back(tokens.pop());}this.decl(tokens);}else{this.unknownWord(tokens);}};_proto.rule=function rule(tokens){tokens.pop();var node=new _rule["default"]();this.init(node,tokens[0][2],tokens[0][3]);node.raws.between=this.spacesAndCommentsFromEnd(tokens);this.raw(node,'selector',tokens);this.current=node;};_proto.decl=function decl(tokens){var node=new _declaration["default"]();this.init(node);var last=tokens[tokens.length-1];if(last[0]===';'){this.semicolon=true;tokens.pop();}if(last[4]){node.source.end={line:last[4],column:last[5]};}else{node.source.end={line:last[2],column:last[3]};}while(tokens[0][0]!=='word'){if(tokens.length===1)this.unknownWord(tokens);node.raws.before+=tokens.shift()[1];}node.source.start={line:tokens[0][2],column:tokens[0][3]};node.prop='';while(tokens.length){var type=tokens[0][0];if(type===':'||type==='space'||type==='comment'){break;}node.prop+=tokens.shift()[1];}node.raws.between='';var token;while(tokens.length){token=tokens.shift();if(token[0]===':'){node.raws.between+=token[1];break;}else{if(token[0]==='word'&&/\w/.test(token[1])){this.unknownWord([token]);}node.raws.between+=token[1];}}if(node.prop[0]==='_'||node.prop[0]==='*'){node.raws.before+=node.prop[0];node.prop=node.prop.slice(1);}node.raws.between+=this.spacesAndCommentsFromStart(tokens);this.precheckMissedSemicolon(tokens);for(var i=tokens.length-1;i>0;i--){token=tokens[i];if(token[1].toLowerCase()==='!important'){node.important=true;var string=this.stringFrom(tokens,i);string=this.spacesFromEnd(tokens)+string;if(string!==' !important')node.raws.important=string;break;}else if(token[1].toLowerCase()==='important'){var cache=tokens.slice(0);var str='';for(var j=i;j>0;j--){var _type=cache[j][0];if(str.trim().indexOf('!')===0&&_type!=='space'){break;}str=cache.pop()[1]+str;}if(str.trim().indexOf('!')===0){node.important=true;node.raws.important=str;tokens=cache;}}if(token[0]!=='space'&&token[0]!=='comment'){break;}}this.raw(node,'value',tokens);if(node.value.indexOf(':')!==-1)this.checkMissedSemicolon(tokens);};_proto.atrule=function atrule(token){var node=new _atRule["default"]();node.name=token[1].slice(1);if(node.name===''){this.unnamedAtrule(node,token);}this.init(node,token[2],token[3]);var prev;var shift;var last=false;var open=false;var params=[];while(!this.tokenizer.endOfFile()){token=this.tokenizer.nextToken();if(token[0]===';'){node.source.end={line:token[2],column:token[3]};this.semicolon=true;break;}else if(token[0]==='{'){open=true;break;}else if(token[0]==='}'){if(params.length>0){shift=params.length-1;prev=params[shift];while(prev&&prev[0]==='space'){prev=params[--shift];}if(prev){node.source.end={line:prev[4],column:prev[5]};}}this.end(token);break;}else{params.push(token);}if(this.tokenizer.endOfFile()){last=true;break;}}node.raws.between=this.spacesAndCommentsFromEnd(params);if(params.length){node.raws.afterName=this.spacesAndCommentsFromStart(params);this.raw(node,'params',params);if(last){token=params[params.length-1];node.source.end={line:token[4],column:token[5]};this.spaces=node.raws.between;node.raws.between='';}}else{node.raws.afterName='';node.params='';}if(open){node.nodes=[];this.current=node;}};_proto.end=function end(token){if(this.current.nodes&&this.current.nodes.length){this.current.raws.semicolon=this.semicolon;}this.semicolon=false;this.current.raws.after=(this.current.raws.after||'')+this.spaces;this.spaces='';if(this.current.parent){this.current.source.end={line:token[2],column:token[3]};this.current=this.current.parent;}else{this.unexpectedClose(token);}};_proto.endFile=function endFile(){if(this.current.parent)this.unclosedBlock();if(this.current.nodes&&this.current.nodes.length){this.current.raws.semicolon=this.semicolon;}this.current.raws.after=(this.current.raws.after||'')+this.spaces;};_proto.freeSemicolon=function freeSemicolon(token){this.spaces+=token[1];if(this.current.nodes){var prev=this.current.nodes[this.current.nodes.length-1];if(prev&&prev.type==='rule'&&!prev.raws.ownSemicolon){prev.raws.ownSemicolon=this.spaces;this.spaces='';}}}// Helpers
	;_proto.init=function init(node,line,column){this.current.push(node);node.source={start:{line:line,column:column},input:this.input};node.raws.before=this.spaces;this.spaces='';if(node.type!=='comment')this.semicolon=false;};_proto.raw=function raw(node,prop,tokens){var token,type;var length=tokens.length;var value='';var clean=true;var next,prev;var pattern=/^([.|#])?([\w])+/i;for(var i=0;i<length;i+=1){token=tokens[i];type=token[0];if(type==='comment'&&node.type==='rule'){prev=tokens[i-1];next=tokens[i+1];if(prev[0]!=='space'&&next[0]!=='space'&&pattern.test(prev[1])&&pattern.test(next[1])){value+=token[1];}else{clean=false;}continue;}if(type==='comment'||type==='space'&&i===length-1){clean=false;}else{value+=token[1];}}if(!clean){var raw=tokens.reduce(function(all,i){return all+i[1];},'');node.raws[prop]={value:value,raw:raw};}node[prop]=value;};_proto.spacesAndCommentsFromEnd=function spacesAndCommentsFromEnd(tokens){var lastTokenType;var spaces='';while(tokens.length){lastTokenType=tokens[tokens.length-1][0];if(lastTokenType!=='space'&&lastTokenType!=='comment')break;spaces=tokens.pop()[1]+spaces;}return spaces;};_proto.spacesAndCommentsFromStart=function spacesAndCommentsFromStart(tokens){var next;var spaces='';while(tokens.length){next=tokens[0][0];if(next!=='space'&&next!=='comment')break;spaces+=tokens.shift()[1];}return spaces;};_proto.spacesFromEnd=function spacesFromEnd(tokens){var lastTokenType;var spaces='';while(tokens.length){lastTokenType=tokens[tokens.length-1][0];if(lastTokenType!=='space')break;spaces=tokens.pop()[1]+spaces;}return spaces;};_proto.stringFrom=function stringFrom(tokens,from){var result='';for(var i=from;i<tokens.length;i++){result+=tokens[i][1];}tokens.splice(from,tokens.length-from);return result;};_proto.colon=function colon(tokens){var brackets=0;var token,type,prev;for(var i=0;i<tokens.length;i++){token=tokens[i];type=token[0];if(type==='('){brackets+=1;}if(type===')'){brackets-=1;}if(brackets===0&&type===':'){if(!prev){this.doubleColon(token);}else if(prev[0]==='word'&&prev[1]==='progid'){continue;}else{return i;}}prev=token;}return false;}// Errors
	;_proto.unclosedBracket=function unclosedBracket(bracket){throw this.input.error('Unclosed bracket',bracket[2],bracket[3]);};_proto.unknownWord=function unknownWord(tokens){throw this.input.error('Unknown word',tokens[0][2],tokens[0][3]);};_proto.unexpectedClose=function unexpectedClose(token){throw this.input.error('Unexpected }',token[2],token[3]);};_proto.unclosedBlock=function unclosedBlock(){var pos=this.current.source.start;throw this.input.error('Unclosed block',pos.line,pos.column);};_proto.doubleColon=function doubleColon(token){throw this.input.error('Double colon',token[2],token[3]);};_proto.unnamedAtrule=function unnamedAtrule(node,token){throw this.input.error('At-rule without name',token[2],token[3]);};_proto.precheckMissedSemicolon=function precheckMissedSemicolon()/* tokens */{// Hook for Safe Parser
	};_proto.checkMissedSemicolon=function checkMissedSemicolon(tokens){var colon=this.colon(tokens);if(colon===false)return;var founded=0;var token;for(var j=colon-1;j>=0;j--){token=tokens[j];if(token[0]!=='space'){founded+=1;if(founded===2)break;}}throw this.input.error('Missed semicolon',token[2],token[3]);};return Parser;}();exports["default"]=Parser;module.exports=exports["default"];},{"./at-rule":169,"./comment":170,"./declaration":173,"./root":185,"./rule":186,"./tokenize":189}],181:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _declaration=_interopRequireDefault(require("./declaration"));var _processor=_interopRequireDefault(require("./processor"));var _stringify=_interopRequireDefault(require("./stringify"));var _comment=_interopRequireDefault(require("./comment"));var _atRule=_interopRequireDefault(require("./at-rule"));var _vendor=_interopRequireDefault(require("./vendor"));var _parse=_interopRequireDefault(require("./parse"));var _list=_interopRequireDefault(require("./list"));var _rule=_interopRequireDefault(require("./rule"));var _root=_interopRequireDefault(require("./root"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}/**
	 * Create a new {@link Processor} instance that will apply `plugins`
	 * as CSS processors.
	 *
	 * @param {Array.<Plugin|pluginFunction>|Processor} plugins PostCSS plugins.
	 *        See {@link Processor#use} for plugin format.
	 *
	 * @return {Processor} Processor to process multiple CSS.
	 *
	 * @example
	 * import postcss from 'postcss'
	 *
	 * postcss(plugins).process(css, { from, to }).then(result => {
	 *   console.log(result.css)
	 * })
	 *
	 * @namespace postcss
	 */function postcss(){for(var _len=arguments.length,plugins=new Array(_len),_key=0;_key<_len;_key++){plugins[_key]=arguments[_key];}if(plugins.length===1&&Array.isArray(plugins[0])){plugins=plugins[0];}return new _processor["default"](plugins);}/**
	 * Creates a PostCSS plugin with a standard API.
	 *
	 * The newly-wrapped function will provide both the name and PostCSS
	 * version of the plugin.
	 *
	 * ```js
	 * const processor = postcss([replace])
	 * processor.plugins[0].postcssPlugin  //=> 'postcss-replace'
	 * processor.plugins[0].postcssVersion //=> '6.0.0'
	 * ```
	 *
	 * The plugin function receives 2 arguments: {@link Root}
	 * and {@link Result} instance. The function should mutate the provided
	 * `Root` node. Alternatively, you can create a new `Root` node
	 * and override the `result.root` property.
	 *
	 * ```js
	 * const cleaner = postcss.plugin('postcss-cleaner', () => {
	 *   return (root, result) => {
	 *     result.root = postcss.root()
	 *   }
	 * })
	 * ```
	 *
	 * As a convenience, plugins also expose a `process` method so that you can use
	 * them as standalone tools.
	 *
	 * ```js
	 * cleaner.process(css, processOpts, pluginOpts)
	 * // This is equivalent to:
	 * postcss([ cleaner(pluginOpts) ]).process(css, processOpts)
	 * ```
	 *
	 * Asynchronous plugins should return a `Promise` instance.
	 *
	 * ```js
	 * postcss.plugin('postcss-import', () => {
	 *   return (root, result) => {
	 *     return new Promise( (resolve, reject) => {
	 *       fs.readFile('base.css', (base) => {
	 *         root.prepend(base)
	 *         resolve()
	 *       })
	 *     })
	 *   }
	 * })
	 * ```
	 *
	 * Add warnings using the {@link Node#warn} method.
	 * Send data to other plugins using the {@link Result#messages} array.
	 *
	 * ```js
	 * postcss.plugin('postcss-caniuse-test', () => {
	 *   return (root, result) => {
	 *     root.walkDecls(decl => {
	 *       if (!caniuse.support(decl.prop)) {
	 *         decl.warn(result, 'Some browsers do not support ' + decl.prop)
	 *       }
	 *     })
	 *   }
	 * })
	 * ```
	 *
	 * @param {string} name          PostCSS plugin name. Same as in `name`
	 *                               property in `package.json`. It will be saved
	 *                               in `plugin.postcssPlugin` property.
	 * @param {function} initializer Will receive plugin options
	 *                               and should return {@link pluginFunction}
	 *
	 * @return {Plugin} PostCSS plugin.
	 */postcss.plugin=function plugin(name,initializer){function creator(){var transformer=initializer.apply(void 0,arguments);transformer.postcssPlugin=name;transformer.postcssVersion=new _processor["default"]().version;return transformer;}var cache;Object.defineProperty(creator,'postcss',{get:function get(){if(!cache)cache=creator();return cache;}});creator.process=function(css,processOpts,pluginOpts){return postcss([creator(pluginOpts)]).process(css,processOpts);};return creator;};/**
	 * Default function to convert a node tree into a CSS string.
	 *
	 * @param {Node} node       Start node for stringifing. Usually {@link Root}.
	 * @param {builder} builder Function to concatenate CSS from node’s parts
	 *                          or generate string and source map.
	 *
	 * @return {void}
	 *
	 * @function
	 */postcss.stringify=_stringify["default"];/**
	 * Parses source css and returns a new {@link Root} node,
	 * which contains the source CSS nodes.
	 *
	 * @param {string|toString} css   String with input CSS or any object
	 *                                with toString() method, like a Buffer
	 * @param {processOptions} [opts] Options with only `from` and `map` keys.
	 *
	 * @return {Root} PostCSS AST.
	 *
	 * @example
	 * // Simple CSS concatenation with source map support
	 * const root1 = postcss.parse(css1, { from: file1 })
	 * const root2 = postcss.parse(css2, { from: file2 })
	 * root1.append(root2).toResult().css
	 *
	 * @function
	 */postcss.parse=_parse["default"];/**
	 * Contains the {@link vendor} module.
	 *
	 * @type {vendor}
	 *
	 * @example
	 * postcss.vendor.unprefixed('-moz-tab') //=> ['tab']
	 */postcss.vendor=_vendor["default"];/**
	 * Contains the {@link list} module.
	 *
	 * @member {list}
	 *
	 * @example
	 * postcss.list.space('5px calc(10% + 5px)') //=> ['5px', 'calc(10% + 5px)']
	 */postcss.list=_list["default"];/**
	 * Creates a new {@link Comment} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {Comment} New comment node
	 *
	 * @example
	 * postcss.comment({ text: 'test' })
	 */postcss.comment=function(defaults){return new _comment["default"](defaults);};/**
	 * Creates a new {@link AtRule} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {AtRule} new at-rule node
	 *
	 * @example
	 * postcss.atRule({ name: 'charset' }).toString() //=> "@charset"
	 */postcss.atRule=function(defaults){return new _atRule["default"](defaults);};/**
	 * Creates a new {@link Declaration} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {Declaration} new declaration node
	 *
	 * @example
	 * postcss.decl({ prop: 'color', value: 'red' }).toString() //=> "color: red"
	 */postcss.decl=function(defaults){return new _declaration["default"](defaults);};/**
	 * Creates a new {@link Rule} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {Rule} new rule node
	 *
	 * @example
	 * postcss.rule({ selector: 'a' }).toString() //=> "a {\n}"
	 */postcss.rule=function(defaults){return new _rule["default"](defaults);};/**
	 * Creates a new {@link Root} node.
	 *
	 * @param {object} [defaults] Properties for the new node.
	 *
	 * @return {Root} new root node.
	 *
	 * @example
	 * postcss.root({ after: '\n' }).toString() //=> "\n"
	 */postcss.root=function(defaults){return new _root["default"](defaults);};var _default=postcss;exports["default"]=_default;module.exports=exports["default"];},{"./at-rule":169,"./comment":170,"./declaration":173,"./list":176,"./parse":179,"./processor":183,"./root":185,"./rule":186,"./stringify":188,"./vendor":190}],182:[function(require,module,exports){(function(Buffer){"use strict";exports.__esModule=true;exports["default"]=void 0;var _sourceMap=_interopRequireDefault(require("source-map"));var _path=_interopRequireDefault(require("path"));var _fs=_interopRequireDefault(require("fs"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function fromBase64(str){if(Buffer){return Buffer.from(str,'base64').toString();}else{return window.atob(str);}}/**
	 * Source map information from input CSS.
	 * For example, source map after Sass compiler.
	 *
	 * This class will automatically find source map in input CSS or in file system
	 * near input file (according `from` option).
	 *
	 * @example
	 * const root = postcss.parse(css, { from: 'a.sass.css' })
	 * root.input.map //=> PreviousMap
	 */var PreviousMap=/*#__PURE__*/function(){/**
	   * @param {string}         css    Input CSS source.
	   * @param {processOptions} [opts] {@link Processor#process} options.
	   */function PreviousMap(css,opts){this.loadAnnotation(css);/**
	     * Was source map inlined by data-uri to input CSS.
	     *
	     * @type {boolean}
	     */this.inline=this.startWith(this.annotation,'data:');var prev=opts.map?opts.map.prev:undefined;var text=this.loadMap(opts.from,prev);if(text)this.text=text;}/**
	   * Create a instance of `SourceMapGenerator` class
	   * from the `source-map` library to work with source map information.
	   *
	   * It is lazy method, so it will create object only on first call
	   * and then it will use cache.
	   *
	   * @return {SourceMapGenerator} Object with source map information.
	   */var _proto=PreviousMap.prototype;_proto.consumer=function consumer(){if(!this.consumerCache){this.consumerCache=new _sourceMap["default"].SourceMapConsumer(this.text);}return this.consumerCache;}/**
	   * Does source map contains `sourcesContent` with input source text.
	   *
	   * @return {boolean} Is `sourcesContent` present.
	   */;_proto.withContent=function withContent(){return!!(this.consumer().sourcesContent&&this.consumer().sourcesContent.length>0);};_proto.startWith=function startWith(string,start){if(!string)return false;return string.substr(0,start.length)===start;};_proto.getAnnotationURL=function getAnnotationURL(sourceMapString){return sourceMapString.match(/\/\*\s*# sourceMappingURL=(.*)\s*\*\//)[1].trim();};_proto.loadAnnotation=function loadAnnotation(css){var annotations=css.match(/\/\*\s*# sourceMappingURL=(.*)\s*\*\//mg);if(annotations&&annotations.length>0){// Locate the last sourceMappingURL to avoid picking up
	// sourceMappingURLs from comments, strings, etc.
	var lastAnnotation=annotations[annotations.length-1];if(lastAnnotation){this.annotation=this.getAnnotationURL(lastAnnotation);}}};_proto.decodeInline=function decodeInline(text){var baseCharsetUri=/^data:application\/json;charset=utf-?8;base64,/;var baseUri=/^data:application\/json;base64,/;var uri='data:application/json,';if(this.startWith(text,uri)){return decodeURIComponent(text.substr(uri.length));}if(baseCharsetUri.test(text)||baseUri.test(text)){return fromBase64(text.substr(RegExp.lastMatch.length));}var encoding=text.match(/data:application\/json;([^,]+),/)[1];throw new Error('Unsupported source map encoding '+encoding);};_proto.loadMap=function loadMap(file,prev){if(prev===false)return false;if(prev){if(typeof prev==='string'){return prev;}else if(typeof prev==='function'){var prevPath=prev(file);if(prevPath&&_fs["default"].existsSync&&_fs["default"].existsSync(prevPath)){return _fs["default"].readFileSync(prevPath,'utf-8').toString().trim();}else{throw new Error('Unable to load previous source map: '+prevPath.toString());}}else if(prev instanceof _sourceMap["default"].SourceMapConsumer){return _sourceMap["default"].SourceMapGenerator.fromSourceMap(prev).toString();}else if(prev instanceof _sourceMap["default"].SourceMapGenerator){return prev.toString();}else if(this.isMap(prev)){return JSON.stringify(prev);}else{throw new Error('Unsupported previous source map format: '+prev.toString());}}else if(this.inline){return this.decodeInline(this.annotation);}else if(this.annotation){var map=this.annotation;if(file)map=_path["default"].join(_path["default"].dirname(file),map);this.root=_path["default"].dirname(map);if(_fs["default"].existsSync&&_fs["default"].existsSync(map)){return _fs["default"].readFileSync(map,'utf-8').toString().trim();}else{return false;}}};_proto.isMap=function isMap(map){if(_typeof(map)!=='object')return false;return typeof map.mappings==='string'||typeof map._mappings==='string';};return PreviousMap;}();var _default=PreviousMap;exports["default"]=_default;module.exports=exports["default"];}).call(this,require("buffer").Buffer);},{"buffer":3,"fs":2,"path":168,"source-map":208}],183:[function(require,module,exports){(function(process){"use strict";exports.__esModule=true;exports["default"]=void 0;var _lazyResult=_interopRequireDefault(require("./lazy-result"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}/**
	 * Contains plugins to process CSS. Create one `Processor` instance,
	 * initialize its plugins, and then use that instance on numerous CSS files.
	 *
	 * @example
	 * const processor = postcss([autoprefixer, precss])
	 * processor.process(css1).then(result => console.log(result.css))
	 * processor.process(css2).then(result => console.log(result.css))
	 */var Processor=/*#__PURE__*/function(){/**
	   * @param {Array.<Plugin|pluginFunction>|Processor} plugins PostCSS plugins.
	   *        See {@link Processor#use} for plugin format.
	   */function Processor(plugins){if(plugins===void 0){plugins=[];}/**
	     * Current PostCSS version.
	     *
	     * @type {string}
	     *
	     * @example
	     * if (result.processor.version.split('.')[0] !== '6') {
	     *   throw new Error('This plugin works only with PostCSS 6')
	     * }
	     */this.version='7.0.34';/**
	     * Plugins added to this processor.
	     *
	     * @type {pluginFunction[]}
	     *
	     * @example
	     * const processor = postcss([autoprefixer, precss])
	     * processor.plugins.length //=> 2
	     */this.plugins=this.normalize(plugins);}/**
	   * Adds a plugin to be used as a CSS processor.
	   *
	   * PostCSS plugin can be in 4 formats:
	   * * A plugin created by {@link postcss.plugin} method.
	   * * A function. PostCSS will pass the function a @{link Root}
	   *   as the first argument and current {@link Result} instance
	   *   as the second.
	   * * An object with a `postcss` method. PostCSS will use that method
	   *   as described in #2.
	   * * Another {@link Processor} instance. PostCSS will copy plugins
	   *   from that instance into this one.
	   *
	   * Plugins can also be added by passing them as arguments when creating
	   * a `postcss` instance (see [`postcss(plugins)`]).
	   *
	   * Asynchronous plugins should return a `Promise` instance.
	   *
	   * @param {Plugin|pluginFunction|Processor} plugin PostCSS plugin
	   *                                                 or {@link Processor}
	   *                                                 with plugins.
	   *
	   * @example
	   * const processor = postcss()
	   *   .use(autoprefixer)
	   *   .use(precss)
	   *
	   * @return {Processes} Current processor to make methods chain.
	   */var _proto=Processor.prototype;_proto.use=function use(plugin){this.plugins=this.plugins.concat(this.normalize([plugin]));return this;}/**
	   * Parses source CSS and returns a {@link LazyResult} Promise proxy.
	   * Because some plugins can be asynchronous it doesn’t make
	   * any transformations. Transformations will be applied
	   * in the {@link LazyResult} methods.
	   *
	   * @param {string|toString|Result} css String with input CSS or any object
	   *                                     with a `toString()` method,
	   *                                     like a Buffer. Optionally, send
	   *                                     a {@link Result} instance
	   *                                     and the processor will take
	   *                                     the {@link Root} from it.
	   * @param {processOptions} [opts]      Options.
	   *
	   * @return {LazyResult} Promise proxy.
	   *
	   * @example
	   * processor.process(css, { from: 'a.css', to: 'a.out.css' })
	   *   .then(result => {
	   *      console.log(result.css)
	   *   })
	   */;_proto.process=function(_process){function process(_x){return _process.apply(this,arguments);}process.toString=function(){return _process.toString();};return process;}(function(css,opts){if(opts===void 0){opts={};}if(this.plugins.length===0&&opts.parser===opts.stringifier){if(process.env.NODE_ENV!=='production'){if(typeof console!=='undefined'&&console.warn){console.warn('You did not set any plugins, parser, or stringifier. '+'Right now, PostCSS does nothing. Pick plugins for your case '+'on https://www.postcss.parts/ and use them in postcss.config.js.');}}}return new _lazyResult["default"](this,css,opts);});_proto.normalize=function normalize(plugins){var normalized=[];for(var _iterator=_createForOfIteratorHelperLoose(plugins),_step;!(_step=_iterator()).done;){var i=_step.value;if(i.postcss===true){var plugin=i();throw new Error('PostCSS plugin '+plugin.postcssPlugin+' requires PostCSS 8. Update PostCSS or downgrade this plugin.');}if(i.postcss)i=i.postcss;if(_typeof(i)==='object'&&Array.isArray(i.plugins)){normalized=normalized.concat(i.plugins);}else if(typeof i==='function'){normalized.push(i);}else if(_typeof(i)==='object'&&(i.parse||i.stringify)){if(process.env.NODE_ENV!=='production'){throw new Error('PostCSS syntaxes cannot be used as plugins. Instead, please use '+'one of the syntax/parser/stringifier options as outlined '+'in your PostCSS runner documentation.');}}else if(_typeof(i)==='object'&&i.postcssPlugin){throw new Error('PostCSS plugin '+i.postcssPlugin+' requires PostCSS 8. Update PostCSS or downgrade this plugin.');}else{throw new Error(i+' is not a PostCSS plugin');}}return normalized;};return Processor;}();var _default=Processor;/**
	 * @callback builder
	 * @param {string} part          Part of generated CSS connected to this node.
	 * @param {Node}   node          AST node.
	 * @param {"start"|"end"} [type] Node’s part type.
	 */ /**
	 * @callback parser
	 *
	 * @param {string|toString} css   String with input CSS or any object
	 *                                with toString() method, like a Buffer.
	 * @param {processOptions} [opts] Options with only `from` and `map` keys.
	 *
	 * @return {Root} PostCSS AST
	 */ /**
	 * @callback stringifier
	 *
	 * @param {Node} node       Start node for stringifing. Usually {@link Root}.
	 * @param {builder} builder Function to concatenate CSS from node’s parts
	 *                          or generate string and source map.
	 *
	 * @return {void}
	 */ /**
	 * @typedef {object} syntax
	 * @property {parser} parse          Function to generate AST by string.
	 * @property {stringifier} stringify Function to generate string by AST.
	 */ /**
	 * @typedef {object} toString
	 * @property {function} toString
	 */ /**
	 * @callback pluginFunction
	 * @param {Root} root     Parsed input CSS.
	 * @param {Result} result Result to set warnings or check other plugins.
	 */ /**
	 * @typedef {object} Plugin
	 * @property {function} postcss PostCSS plugin function.
	 */ /**
	 * @typedef {object} processOptions
	 * @property {string} from             The path of the CSS source file.
	 *                                     You should always set `from`,
	 *                                     because it is used in source map
	 *                                     generation and syntax error messages.
	 * @property {string} to               The path where you’ll put the output
	 *                                     CSS file. You should always set `to`
	 *                                     to generate correct source maps.
	 * @property {parser} parser           Function to generate AST by string.
	 * @property {stringifier} stringifier Class to generate string by AST.
	 * @property {syntax} syntax           Object with `parse` and `stringify`.
	 * @property {object} map              Source map options.
	 * @property {boolean} map.inline                    Does source map should
	 *                                                   be embedded in the output
	 *                                                   CSS as a base64-encoded
	 *                                                   comment.
	 * @property {string|object|false|function} map.prev Source map content
	 *                                                   from a previous
	 *                                                   processing step
	 *                                                   (for example, Sass).
	 *                                                   PostCSS will try to find
	 *                                                   previous map automatically,
	 *                                                   so you could disable it by
	 *                                                   `false` value.
	 * @property {boolean} map.sourcesContent            Does PostCSS should set
	 *                                                   the origin content to map.
	 * @property {string|false} map.annotation           Does PostCSS should set
	 *                                                   annotation comment to map.
	 * @property {string} map.from                       Override `from` in map’s
	 *                                                   sources`.
	 */exports["default"]=_default;module.exports=exports["default"];}).call(this,require('_process'));},{"./lazy-result":175,"_process":193}],184:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _warning=_interopRequireDefault(require("./warning"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}/**
	 * Provides the result of the PostCSS transformations.
	 *
	 * A Result instance is returned by {@link LazyResult#then}
	 * or {@link Root#toResult} methods.
	 *
	 * @example
	 * postcss([autoprefixer]).process(css).then(result => {
	 *  console.log(result.css)
	 * })
	 *
	 * @example
	 * const result2 = postcss.parse(css).toResult()
	 */var Result=/*#__PURE__*/function(){/**
	   * @param {Processor} processor Processor used for this transformation.
	   * @param {Root}      root      Root node after all transformations.
	   * @param {processOptions} opts Options from the {@link Processor#process}
	   *                              or {@link Root#toResult}.
	   */function Result(processor,root,opts){/**
	     * The Processor instance used for this transformation.
	     *
	     * @type {Processor}
	     *
	     * @example
	     * for (const plugin of result.processor.plugins) {
	     *   if (plugin.postcssPlugin === 'postcss-bad') {
	     *     throw 'postcss-good is incompatible with postcss-bad'
	     *   }
	     * })
	     */this.processor=processor;/**
	     * Contains messages from plugins (e.g., warnings or custom messages).
	     * Each message should have type and plugin properties.
	     *
	     * @type {Message[]}
	     *
	     * @example
	     * postcss.plugin('postcss-min-browser', () => {
	     *   return (root, result) => {
	     *     const browsers = detectMinBrowsersByCanIUse(root)
	     *     result.messages.push({
	     *       type: 'min-browser',
	     *       plugin: 'postcss-min-browser',
	     *       browsers
	     *     })
	     *   }
	     * })
	     */this.messages=[];/**
	     * Root node after all transformations.
	     *
	     * @type {Root}
	     *
	     * @example
	     * root.toResult().root === root
	     */this.root=root;/**
	     * Options from the {@link Processor#process} or {@link Root#toResult} call
	     * that produced this Result instance.
	     *
	     * @type {processOptions}
	     *
	     * @example
	     * root.toResult(opts).opts === opts
	     */this.opts=opts;/**
	     * A CSS string representing of {@link Result#root}.
	     *
	     * @type {string}
	     *
	     * @example
	     * postcss.parse('a{}').toResult().css //=> "a{}"
	     */this.css=undefined;/**
	     * An instance of `SourceMapGenerator` class from the `source-map` library,
	     * representing changes to the {@link Result#root} instance.
	     *
	     * @type {SourceMapGenerator}
	     *
	     * @example
	     * result.map.toJSON() //=> { version: 3, file: 'a.css', … }
	     *
	     * @example
	     * if (result.map) {
	     *   fs.writeFileSync(result.opts.to + '.map', result.map.toString())
	     * }
	     */this.map=undefined;}/**
	   * Returns for @{link Result#css} content.
	   *
	   * @example
	   * result + '' === result.css
	   *
	   * @return {string} String representing of {@link Result#root}.
	   */var _proto=Result.prototype;_proto.toString=function toString(){return this.css;}/**
	   * Creates an instance of {@link Warning} and adds it
	   * to {@link Result#messages}.
	   *
	   * @param {string} text        Warning message.
	   * @param {Object} [opts]      Warning options.
	   * @param {Node}   opts.node   CSS node that caused the warning.
	   * @param {string} opts.word   Word in CSS source that caused the warning.
	   * @param {number} opts.index  Index in CSS node string that caused
	   *                             the warning.
	   * @param {string} opts.plugin Name of the plugin that created
	   *                             this warning. {@link Result#warn} fills
	   *                             this property automatically.
	   *
	   * @return {Warning} Created warning.
	   */;_proto.warn=function warn(text,opts){if(opts===void 0){opts={};}if(!opts.plugin){if(this.lastPlugin&&this.lastPlugin.postcssPlugin){opts.plugin=this.lastPlugin.postcssPlugin;}}var warning=new _warning["default"](text,opts);this.messages.push(warning);return warning;}/**
	     * Returns warnings from plugins. Filters {@link Warning} instances
	     * from {@link Result#messages}.
	     *
	     * @example
	     * result.warnings().forEach(warn => {
	     *   console.warn(warn.toString())
	     * })
	     *
	     * @return {Warning[]} Warnings from plugins.
	     */;_proto.warnings=function warnings(){return this.messages.filter(function(i){return i.type==='warning';});}/**
	   * An alias for the {@link Result#css} property.
	   * Use it with syntaxes that generate non-CSS output.
	   *
	   * @type {string}
	   *
	   * @example
	   * result.css === result.content
	   */;_createClass(Result,[{key:"content",get:function get(){return this.css;}}]);return Result;}();var _default=Result;/**
	 * @typedef  {object} Message
	 * @property {string} type   Message type.
	 * @property {string} plugin Source PostCSS plugin name.
	 */exports["default"]=_default;module.exports=exports["default"];},{"./warning":192}],185:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _container=_interopRequireDefault(require("./container"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _createForOfIteratorHelperLoose(o,allowArrayLike){var it;if(typeof Symbol==="undefined"||o[Symbol.iterator]==null){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&typeof o.length==="number"){if(it)o=it;var i=0;return function(){if(i>=o.length)return{done:true};return{done:false,value:o[i++]};};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}it=o[Symbol.iterator]();return it.next.bind(it);}function _unsupportedIterableToArray(o,minLen){if(!o)return;if(typeof o==="string")return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);if(n==="Object"&&o.constructor)n=o.constructor.name;if(n==="Map"||n==="Set")return Array.from(o);if(n==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen);}function _arrayLikeToArray(arr,len){if(len==null||len>arr.length)len=arr.length;for(var i=0,arr2=new Array(len);i<len;i++){arr2[i]=arr[i];}return arr2;}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents a CSS file and contains all its parsed nodes.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{color:black} b{z-index:2}')
	 * root.type         //=> 'root'
	 * root.nodes.length //=> 2
	 */var Root=/*#__PURE__*/function(_Container){_inheritsLoose(Root,_Container);function Root(defaults){var _this;_this=_Container.call(this,defaults)||this;_this.type='root';if(!_this.nodes)_this.nodes=[];return _this;}var _proto=Root.prototype;_proto.removeChild=function removeChild(child,ignore){var index=this.index(child);if(!ignore&&index===0&&this.nodes.length>1){this.nodes[1].raws.before=this.nodes[index].raws.before;}return _Container.prototype.removeChild.call(this,child);};_proto.normalize=function normalize(child,sample,type){var nodes=_Container.prototype.normalize.call(this,child);if(sample){if(type==='prepend'){if(this.nodes.length>1){sample.raws.before=this.nodes[1].raws.before;}else{delete sample.raws.before;}}else if(this.first!==sample){for(var _iterator=_createForOfIteratorHelperLoose(nodes),_step;!(_step=_iterator()).done;){var node=_step.value;node.raws.before=sample.raws.before;}}}return nodes;}/**
	   * Returns a {@link Result} instance representing the root’s CSS.
	   *
	   * @param {processOptions} [opts] Options with only `to` and `map` keys.
	   *
	   * @return {Result} Result with current root’s CSS.
	   *
	   * @example
	   * const root1 = postcss.parse(css1, { from: 'a.css' })
	   * const root2 = postcss.parse(css2, { from: 'b.css' })
	   * root1.append(root2)
	   * const result = root1.toResult({ to: 'all.css', map: true })
	   */;_proto.toResult=function toResult(opts){if(opts===void 0){opts={};}var LazyResult=require('./lazy-result');var Processor=require('./processor');var lazy=new LazyResult(new Processor(),this,opts);return lazy.stringify();}/**
	   * @memberof Root#
	   * @member {object} raws Information to generate byte-to-byte equal
	   *                       node string as it was in the origin input.
	   *
	   * Every parser saves its own properties,
	   * but the default CSS parser uses:
	   *
	   * * `after`: the space symbols after the last child to the end of file.
	   * * `semicolon`: is the last child has an (optional) semicolon.
	   *
	   * @example
	   * postcss.parse('a {}\n').raws //=> { after: '\n' }
	   * postcss.parse('a {}').raws   //=> { after: '' }
	   */;return Root;}(_container["default"]);var _default=Root;exports["default"]=_default;module.exports=exports["default"];},{"./container":171,"./lazy-result":175,"./processor":183}],186:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _container=_interopRequireDefault(require("./container"));var _list=_interopRequireDefault(require("./list"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function _defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}function _createClass(Constructor,protoProps,staticProps){if(protoProps)_defineProperties(Constructor.prototype,protoProps);if(staticProps)_defineProperties(Constructor,staticProps);return Constructor;}function _inheritsLoose(subClass,superClass){subClass.prototype=Object.create(superClass.prototype);subClass.prototype.constructor=subClass;subClass.__proto__=superClass;}/**
	 * Represents a CSS rule: a selector followed by a declaration block.
	 *
	 * @extends Container
	 *
	 * @example
	 * const root = postcss.parse('a{}')
	 * const rule = root.first
	 * rule.type       //=> 'rule'
	 * rule.toString() //=> 'a{}'
	 */var Rule=/*#__PURE__*/function(_Container){_inheritsLoose(Rule,_Container);function Rule(defaults){var _this;_this=_Container.call(this,defaults)||this;_this.type='rule';if(!_this.nodes)_this.nodes=[];return _this;}/**
	   * An array containing the rule’s individual selectors.
	   * Groups of selectors are split at commas.
	   *
	   * @type {string[]}
	   *
	   * @example
	   * const root = postcss.parse('a, b { }')
	   * const rule = root.first
	   *
	   * rule.selector  //=> 'a, b'
	   * rule.selectors //=> ['a', 'b']
	   *
	   * rule.selectors = ['a', 'strong']
	   * rule.selector //=> 'a, strong'
	   */_createClass(Rule,[{key:"selectors",get:function get(){return _list["default"].comma(this.selector);},set:function set(values){var match=this.selector?this.selector.match(/,\s*/):null;var sep=match?match[0]:','+this.raw('between','beforeOpen');this.selector=values.join(sep);}/**
	     * @memberof Rule#
	     * @member {string} selector The rule’s full selector represented
	     *                           as a string.
	     *
	     * @example
	     * const root = postcss.parse('a, b { }')
	     * const rule = root.first
	     * rule.selector //=> 'a, b'
	     */ /**
	     * @memberof Rule#
	     * @member {object} raws Information to generate byte-to-byte equal
	     *                       node string as it was in the origin input.
	     *
	     * Every parser saves its own properties,
	     * but the default CSS parser uses:
	     *
	     * * `before`: the space symbols before the node. It also stores `*`
	     *   and `_` symbols before the declaration (IE hack).
	     * * `after`: the space symbols after the last child of the node
	     *   to the end of the node.
	     * * `between`: the symbols between the property and value
	     *   for declarations, selector and `{` for rules, or last parameter
	     *   and `{` for at-rules.
	     * * `semicolon`: contains `true` if the last child has
	     *   an (optional) semicolon.
	     * * `ownSemicolon`: contains `true` if there is semicolon after rule.
	     *
	     * PostCSS cleans selectors from comments and extra spaces,
	     * but it stores origin content in raws properties.
	     * As such, if you don’t change a declaration’s value,
	     * PostCSS will use the raw value with comments.
	     *
	     * @example
	     * const root = postcss.parse('a {\n  color:black\n}')
	     * root.first.first.raws //=> { before: '', between: ' ', after: '\n' }
	     */}]);return Rule;}(_container["default"]);var _default=Rule;exports["default"]=_default;module.exports=exports["default"];},{"./container":171,"./list":176}],187:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var DEFAULT_RAW={colon:': ',indent:'    ',beforeDecl:'\n',beforeRule:'\n',beforeOpen:' ',beforeClose:'\n',beforeComment:'\n',after:'\n',emptyBody:'',commentLeft:' ',commentRight:' ',semicolon:false};function capitalize(str){return str[0].toUpperCase()+str.slice(1);}var Stringifier=/*#__PURE__*/function(){function Stringifier(builder){this.builder=builder;}var _proto=Stringifier.prototype;_proto.stringify=function stringify(node,semicolon){this[node.type](node,semicolon);};_proto.root=function root(node){this.body(node);if(node.raws.after)this.builder(node.raws.after);};_proto.comment=function comment(node){var left=this.raw(node,'left','commentLeft');var right=this.raw(node,'right','commentRight');this.builder('/*'+left+node.text+right+'*/',node);};_proto.decl=function decl(node,semicolon){var between=this.raw(node,'between','colon');var string=node.prop+between+this.rawValue(node,'value');if(node.important){string+=node.raws.important||' !important';}if(semicolon)string+=';';this.builder(string,node);};_proto.rule=function rule(node){this.block(node,this.rawValue(node,'selector'));if(node.raws.ownSemicolon){this.builder(node.raws.ownSemicolon,node,'end');}};_proto.atrule=function atrule(node,semicolon){var name='@'+node.name;var params=node.params?this.rawValue(node,'params'):'';if(typeof node.raws.afterName!=='undefined'){name+=node.raws.afterName;}else if(params){name+=' ';}if(node.nodes){this.block(node,name+params);}else{var end=(node.raws.between||'')+(semicolon?';':'');this.builder(name+params+end,node);}};_proto.body=function body(node){var last=node.nodes.length-1;while(last>0){if(node.nodes[last].type!=='comment')break;last-=1;}var semicolon=this.raw(node,'semicolon');for(var i=0;i<node.nodes.length;i++){var child=node.nodes[i];var before=this.raw(child,'before');if(before)this.builder(before);this.stringify(child,last!==i||semicolon);}};_proto.block=function block(node,start){var between=this.raw(node,'between','beforeOpen');this.builder(start+between+'{',node,'start');var after;if(node.nodes&&node.nodes.length){this.body(node);after=this.raw(node,'after');}else{after=this.raw(node,'after','emptyBody');}if(after)this.builder(after);this.builder('}',node,'end');};_proto.raw=function raw(node,own,detect){var value;if(!detect)detect=own;// Already had
	if(own){value=node.raws[own];if(typeof value!=='undefined')return value;}var parent=node.parent;// Hack for first rule in CSS
	if(detect==='before'){if(!parent||parent.type==='root'&&parent.first===node){return'';}}// Floating child without parent
	if(!parent)return DEFAULT_RAW[detect];// Detect style by other nodes
	var root=node.root();if(!root.rawCache)root.rawCache={};if(typeof root.rawCache[detect]!=='undefined'){return root.rawCache[detect];}if(detect==='before'||detect==='after'){return this.beforeAfter(node,detect);}else{var method='raw'+capitalize(detect);if(this[method]){value=this[method](root,node);}else{root.walk(function(i){value=i.raws[own];if(typeof value!=='undefined')return false;});}}if(typeof value==='undefined')value=DEFAULT_RAW[detect];root.rawCache[detect]=value;return value;};_proto.rawSemicolon=function rawSemicolon(root){var value;root.walk(function(i){if(i.nodes&&i.nodes.length&&i.last.type==='decl'){value=i.raws.semicolon;if(typeof value!=='undefined')return false;}});return value;};_proto.rawEmptyBody=function rawEmptyBody(root){var value;root.walk(function(i){if(i.nodes&&i.nodes.length===0){value=i.raws.after;if(typeof value!=='undefined')return false;}});return value;};_proto.rawIndent=function rawIndent(root){if(root.raws.indent)return root.raws.indent;var value;root.walk(function(i){var p=i.parent;if(p&&p!==root&&p.parent&&p.parent===root){if(typeof i.raws.before!=='undefined'){var parts=i.raws.before.split('\n');value=parts[parts.length-1];value=value.replace(/[^\s]/g,'');return false;}}});return value;};_proto.rawBeforeComment=function rawBeforeComment(root,node){var value;root.walkComments(function(i){if(typeof i.raws.before!=='undefined'){value=i.raws.before;if(value.indexOf('\n')!==-1){value=value.replace(/[^\n]+$/,'');}return false;}});if(typeof value==='undefined'){value=this.raw(node,null,'beforeDecl');}else if(value){value=value.replace(/[^\s]/g,'');}return value;};_proto.rawBeforeDecl=function rawBeforeDecl(root,node){var value;root.walkDecls(function(i){if(typeof i.raws.before!=='undefined'){value=i.raws.before;if(value.indexOf('\n')!==-1){value=value.replace(/[^\n]+$/,'');}return false;}});if(typeof value==='undefined'){value=this.raw(node,null,'beforeRule');}else if(value){value=value.replace(/[^\s]/g,'');}return value;};_proto.rawBeforeRule=function rawBeforeRule(root){var value;root.walk(function(i){if(i.nodes&&(i.parent!==root||root.first!==i)){if(typeof i.raws.before!=='undefined'){value=i.raws.before;if(value.indexOf('\n')!==-1){value=value.replace(/[^\n]+$/,'');}return false;}}});if(value)value=value.replace(/[^\s]/g,'');return value;};_proto.rawBeforeClose=function rawBeforeClose(root){var value;root.walk(function(i){if(i.nodes&&i.nodes.length>0){if(typeof i.raws.after!=='undefined'){value=i.raws.after;if(value.indexOf('\n')!==-1){value=value.replace(/[^\n]+$/,'');}return false;}}});if(value)value=value.replace(/[^\s]/g,'');return value;};_proto.rawBeforeOpen=function rawBeforeOpen(root){var value;root.walk(function(i){if(i.type!=='decl'){value=i.raws.between;if(typeof value!=='undefined')return false;}});return value;};_proto.rawColon=function rawColon(root){var value;root.walkDecls(function(i){if(typeof i.raws.between!=='undefined'){value=i.raws.between.replace(/[^\s:]/g,'');return false;}});return value;};_proto.beforeAfter=function beforeAfter(node,detect){var value;if(node.type==='decl'){value=this.raw(node,null,'beforeDecl');}else if(node.type==='comment'){value=this.raw(node,null,'beforeComment');}else if(detect==='before'){value=this.raw(node,null,'beforeRule');}else{value=this.raw(node,null,'beforeClose');}var buf=node.parent;var depth=0;while(buf&&buf.type!=='root'){depth+=1;buf=buf.parent;}if(value.indexOf('\n')!==-1){var indent=this.raw(node,null,'indent');if(indent.length){for(var step=0;step<depth;step++){value+=indent;}}}return value;};_proto.rawValue=function rawValue(node,prop){var value=node[prop];var raw=node.raws[prop];if(raw&&raw.value===value){return raw.raw;}return value;};return Stringifier;}();var _default=Stringifier;exports["default"]=_default;module.exports=exports["default"];},{}],188:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;var _stringifier=_interopRequireDefault(require("./stringifier"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}function stringify(node,builder){var str=new _stringifier["default"](builder);str.stringify(node);}var _default=stringify;exports["default"]=_default;module.exports=exports["default"];},{"./stringifier":187}],189:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=tokenizer;var SINGLE_QUOTE='\''.charCodeAt(0);var DOUBLE_QUOTE='"'.charCodeAt(0);var BACKSLASH='\\'.charCodeAt(0);var SLASH='/'.charCodeAt(0);var NEWLINE='\n'.charCodeAt(0);var SPACE=' '.charCodeAt(0);var FEED='\f'.charCodeAt(0);var TAB='\t'.charCodeAt(0);var CR='\r'.charCodeAt(0);var OPEN_SQUARE='['.charCodeAt(0);var CLOSE_SQUARE=']'.charCodeAt(0);var OPEN_PARENTHESES='('.charCodeAt(0);var CLOSE_PARENTHESES=')'.charCodeAt(0);var OPEN_CURLY='{'.charCodeAt(0);var CLOSE_CURLY='}'.charCodeAt(0);var SEMICOLON=';'.charCodeAt(0);var ASTERISK='*'.charCodeAt(0);var COLON=':'.charCodeAt(0);var AT='@'.charCodeAt(0);var RE_AT_END=/[ \n\t\r\f{}()'"\\;/[\]#]/g;var RE_WORD_END=/[ \n\t\r\f(){}:;@!'"\\\][#]|\/(?=\*)/g;var RE_BAD_BRACKET=/.[\\/("'\n]/;var RE_HEX_ESCAPE=/[a-f0-9]/i;function tokenizer(input,options){if(options===void 0){options={};}var css=input.css.valueOf();var ignore=options.ignoreErrors;var code,next,quote,lines,last,content,escape;var nextLine,nextOffset,escaped,escapePos,prev,n,currentToken;var length=css.length;var offset=-1;var line=1;var pos=0;var buffer=[];var returned=[];function position(){return pos;}function unclosed(what){throw input.error('Unclosed '+what,line,pos-offset);}function endOfFile(){return returned.length===0&&pos>=length;}function nextToken(opts){if(returned.length)return returned.pop();if(pos>=length)return;var ignoreUnclosed=opts?opts.ignoreUnclosed:false;code=css.charCodeAt(pos);if(code===NEWLINE||code===FEED||code===CR&&css.charCodeAt(pos+1)!==NEWLINE){offset=pos;line+=1;}switch(code){case NEWLINE:case SPACE:case TAB:case CR:case FEED:next=pos;do{next+=1;code=css.charCodeAt(next);if(code===NEWLINE){offset=next;line+=1;}}while(code===SPACE||code===NEWLINE||code===TAB||code===CR||code===FEED);currentToken=['space',css.slice(pos,next)];pos=next-1;break;case OPEN_SQUARE:case CLOSE_SQUARE:case OPEN_CURLY:case CLOSE_CURLY:case COLON:case SEMICOLON:case CLOSE_PARENTHESES:var controlChar=String.fromCharCode(code);currentToken=[controlChar,controlChar,line,pos-offset];break;case OPEN_PARENTHESES:prev=buffer.length?buffer.pop()[1]:'';n=css.charCodeAt(pos+1);if(prev==='url'&&n!==SINGLE_QUOTE&&n!==DOUBLE_QUOTE&&n!==SPACE&&n!==NEWLINE&&n!==TAB&&n!==FEED&&n!==CR){next=pos;do{escaped=false;next=css.indexOf(')',next+1);if(next===-1){if(ignore||ignoreUnclosed){next=pos;break;}else{unclosed('bracket');}}escapePos=next;while(css.charCodeAt(escapePos-1)===BACKSLASH){escapePos-=1;escaped=!escaped;}}while(escaped);currentToken=['brackets',css.slice(pos,next+1),line,pos-offset,line,next-offset];pos=next;}else{next=css.indexOf(')',pos+1);content=css.slice(pos,next+1);if(next===-1||RE_BAD_BRACKET.test(content)){currentToken=['(','(',line,pos-offset];}else{currentToken=['brackets',content,line,pos-offset,line,next-offset];pos=next;}}break;case SINGLE_QUOTE:case DOUBLE_QUOTE:quote=code===SINGLE_QUOTE?'\'':'"';next=pos;do{escaped=false;next=css.indexOf(quote,next+1);if(next===-1){if(ignore||ignoreUnclosed){next=pos+1;break;}else{unclosed('string');}}escapePos=next;while(css.charCodeAt(escapePos-1)===BACKSLASH){escapePos-=1;escaped=!escaped;}}while(escaped);content=css.slice(pos,next+1);lines=content.split('\n');last=lines.length-1;if(last>0){nextLine=line+last;nextOffset=next-lines[last].length;}else{nextLine=line;nextOffset=offset;}currentToken=['string',css.slice(pos,next+1),line,pos-offset,nextLine,next-nextOffset];offset=nextOffset;line=nextLine;pos=next;break;case AT:RE_AT_END.lastIndex=pos+1;RE_AT_END.test(css);if(RE_AT_END.lastIndex===0){next=css.length-1;}else{next=RE_AT_END.lastIndex-2;}currentToken=['at-word',css.slice(pos,next+1),line,pos-offset,line,next-offset];pos=next;break;case BACKSLASH:next=pos;escape=true;while(css.charCodeAt(next+1)===BACKSLASH){next+=1;escape=!escape;}code=css.charCodeAt(next+1);if(escape&&code!==SLASH&&code!==SPACE&&code!==NEWLINE&&code!==TAB&&code!==CR&&code!==FEED){next+=1;if(RE_HEX_ESCAPE.test(css.charAt(next))){while(RE_HEX_ESCAPE.test(css.charAt(next+1))){next+=1;}if(css.charCodeAt(next+1)===SPACE){next+=1;}}}currentToken=['word',css.slice(pos,next+1),line,pos-offset,line,next-offset];pos=next;break;default:if(code===SLASH&&css.charCodeAt(pos+1)===ASTERISK){next=css.indexOf('*/',pos+2)+1;if(next===0){if(ignore||ignoreUnclosed){next=css.length;}else{unclosed('comment');}}content=css.slice(pos,next+1);lines=content.split('\n');last=lines.length-1;if(last>0){nextLine=line+last;nextOffset=next-lines[last].length;}else{nextLine=line;nextOffset=offset;}currentToken=['comment',content,line,pos-offset,nextLine,next-nextOffset];offset=nextOffset;line=nextLine;pos=next;}else{RE_WORD_END.lastIndex=pos+1;RE_WORD_END.test(css);if(RE_WORD_END.lastIndex===0){next=css.length-1;}else{next=RE_WORD_END.lastIndex-2;}currentToken=['word',css.slice(pos,next+1),line,pos-offset,line,next-offset];buffer.push(currentToken);pos=next;}break;}pos++;return currentToken;}function back(token){returned.push(token);}return{back:back,nextToken:nextToken,endOfFile:endOfFile,position:position};}module.exports=exports["default"];},{}],190:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;/**
	 * Contains helpers for working with vendor prefixes.
	 *
	 * @example
	 * const vendor = postcss.vendor
	 *
	 * @namespace vendor
	 */var vendor={/**
	   * Returns the vendor prefix extracted from an input string.
	   *
	   * @param {string} prop String with or without vendor prefix.
	   *
	   * @return {string} vendor prefix or empty string
	   *
	   * @example
	   * postcss.vendor.prefix('-moz-tab-size') //=> '-moz-'
	   * postcss.vendor.prefix('tab-size')      //=> ''
	   */prefix:function prefix(prop){var match=prop.match(/^(-\w+-)/);if(match){return match[0];}return'';},/**
	     * Returns the input string stripped of its vendor prefix.
	     *
	     * @param {string} prop String with or without vendor prefix.
	     *
	     * @return {string} String name without vendor prefixes.
	     *
	     * @example
	     * postcss.vendor.unprefixed('-moz-tab-size') //=> 'tab-size'
	     */unprefixed:function unprefixed(prop){return prop.replace(/^-\w+-/,'');}};var _default=vendor;exports["default"]=_default;module.exports=exports["default"];},{}],191:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=warnOnce;var printed={};function warnOnce(message){if(printed[message])return;printed[message]=true;if(typeof console!=='undefined'&&console.warn){console.warn(message);}}module.exports=exports["default"];},{}],192:[function(require,module,exports){"use strict";exports.__esModule=true;exports["default"]=void 0;/**
	 * Represents a plugin’s warning. It can be created using {@link Node#warn}.
	 *
	 * @example
	 * if (decl.important) {
	 *   decl.warn(result, 'Avoid !important', { word: '!important' })
	 * }
	 */var Warning=/*#__PURE__*/function(){/**
	   * @param {string} text        Warning message.
	   * @param {Object} [opts]      Warning options.
	   * @param {Node}   opts.node   CSS node that caused the warning.
	   * @param {string} opts.word   Word in CSS source that caused the warning.
	   * @param {number} opts.index  Index in CSS node string that caused
	   *                             the warning.
	   * @param {string} opts.plugin Name of the plugin that created
	   *                             this warning. {@link Result#warn} fills
	   *                             this property automatically.
	   */function Warning(text,opts){if(opts===void 0){opts={};}/**
	     * Type to filter warnings from {@link Result#messages}.
	     * Always equal to `"warning"`.
	     *
	     * @type {string}
	     *
	     * @example
	     * const nonWarning = result.messages.filter(i => i.type !== 'warning')
	     */this.type='warning';/**
	     * The warning message.
	     *
	     * @type {string}
	     *
	     * @example
	     * warning.text //=> 'Try to avoid !important'
	     */this.text=text;if(opts.node&&opts.node.source){var pos=opts.node.positionBy(opts);/**
	       * Line in the input file with this warning’s source.
	       * @type {number}
	       *
	       * @example
	       * warning.line //=> 5
	       */this.line=pos.line;/**
	       * Column in the input file with this warning’s source.
	       *
	       * @type {number}
	       *
	       * @example
	       * warning.column //=> 6
	       */this.column=pos.column;}for(var opt in opts){this[opt]=opts[opt];}}/**
	   * Returns a warning position and message.
	   *
	   * @example
	   * warning.toString() //=> 'postcss-lint:a.css:10:14: Avoid !important'
	   *
	   * @return {string} Warning position and message.
	   */var _proto=Warning.prototype;_proto.toString=function toString(){if(this.node){return this.node.error(this.text,{plugin:this.plugin,index:this.index,word:this.word}).message;}if(this.plugin){return this.plugin+': '+this.text;}return this.text;}/**
	   * @memberof Warning#
	   * @member {string} plugin The name of the plugin that created
	   *                         it will fill this property automatically.
	   *                         this warning. When you call {@link Node#warn}
	   *
	   * @example
	   * warning.plugin //=> 'postcss-important'
	   */ /**
	   * @memberof Warning#
	   * @member {Node} node Contains the CSS node that caused the warning.
	   *
	   * @example
	   * warning.node.toString() //=> 'color: white !important'
	   */;return Warning;}();var _default=Warning;exports["default"]=_default;module.exports=exports["default"];},{}],193:[function(require,module,exports){// shim for using process in browser
	var process=module.exports={};// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	var cachedSetTimeout;var cachedClearTimeout;function defaultSetTimout(){throw new Error('setTimeout has not been defined');}function defaultClearTimeout(){throw new Error('clearTimeout has not been defined');}(function(){try{if(typeof setTimeout==='function'){cachedSetTimeout=setTimeout;}else{cachedSetTimeout=defaultSetTimout;}}catch(e){cachedSetTimeout=defaultSetTimout;}try{if(typeof clearTimeout==='function'){cachedClearTimeout=clearTimeout;}else{cachedClearTimeout=defaultClearTimeout;}}catch(e){cachedClearTimeout=defaultClearTimeout;}})();function runTimeout(fun){if(cachedSetTimeout===setTimeout){//normal enviroments in sane situations
	return setTimeout(fun,0);}// if setTimeout wasn't available but was latter defined
	if((cachedSetTimeout===defaultSetTimout||!cachedSetTimeout)&&setTimeout){cachedSetTimeout=setTimeout;return setTimeout(fun,0);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
	return cachedSetTimeout(fun,0);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	return cachedSetTimeout.call(null,fun,0);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	return cachedSetTimeout.call(this,fun,0);}}}function runClearTimeout(marker){if(cachedClearTimeout===clearTimeout){//normal enviroments in sane situations
	return clearTimeout(marker);}// if clearTimeout wasn't available but was latter defined
	if((cachedClearTimeout===defaultClearTimeout||!cachedClearTimeout)&&clearTimeout){cachedClearTimeout=clearTimeout;return clearTimeout(marker);}try{// when when somebody has screwed with setTimeout but no I.E. maddness
	return cachedClearTimeout(marker);}catch(e){try{// When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	return cachedClearTimeout.call(null,marker);}catch(e){// same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	// Some versions of I.E. have different rules for clearTimeout vs setTimeout
	return cachedClearTimeout.call(this,marker);}}}var queue=[];var draining=false;var currentQueue;var queueIndex=-1;function cleanUpNextTick(){if(!draining||!currentQueue){return;}draining=false;if(currentQueue.length){queue=currentQueue.concat(queue);}else{queueIndex=-1;}if(queue.length){drainQueue();}}function drainQueue(){if(draining){return;}var timeout=runTimeout(cleanUpNextTick);draining=true;var len=queue.length;while(len){currentQueue=queue;queue=[];while(++queueIndex<len){if(currentQueue){currentQueue[queueIndex].run();}}queueIndex=-1;len=queue.length;}currentQueue=null;draining=false;runClearTimeout(timeout);}process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1){for(var i=1;i<arguments.length;i++){args[i-1]=arguments[i];}}queue.push(new Item(fun,args));if(queue.length===1&&!draining){runTimeout(drainQueue);}};// v8 likes predictible objects
	function Item(fun,array){this.fun=fun;this.array=array;}Item.prototype.run=function(){this.fun.apply(null,this.array);};process.title='browser';process.browser=true;process.env={};process.argv=[];process.version='';// empty string to avoid regexp issues
	process.versions={};function noop(){}process.on=noop;process.addListener=noop;process.once=noop;process.off=noop;process.removeListener=noop;process.removeAllListeners=noop;process.emit=noop;process.prependListener=noop;process.prependOnceListener=noop;process.listeners=function(name){return[];};process.binding=function(name){throw new Error('process.binding is not supported');};process.cwd=function(){return'/';};process.chdir=function(dir){throw new Error('process.chdir is not supported');};process.umask=function(){return 0;};},{}],194:[function(require,module,exports){(function(global){/*! https://mths.be/punycode v1.4.1 by @mathias */;(function(root){/** Detect free variables */var freeExports=_typeof(exports)=='object'&&exports&&!exports.nodeType&&exports;var freeModule=_typeof(module)=='object'&&module&&!module.nodeType&&module;var freeGlobal=_typeof(global)=='object'&&global;if(freeGlobal.global===freeGlobal||freeGlobal.window===freeGlobal||freeGlobal.self===freeGlobal){root=freeGlobal;}/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */var punycode,/** Highest positive signed 32-bit float value */maxInt=2147483647,// aka. 0x7FFFFFFF or 2^31-1
	/** Bootstring parameters */base=36,tMin=1,tMax=26,skew=38,damp=700,initialBias=72,initialN=128,// 0x80
	delimiter='-',// '\x2D'
	/** Regular expressions */regexPunycode=/^xn--/,regexNonASCII=/[^\x20-\x7E]/,// unprintable ASCII chars + non-ASCII chars
	regexSeparators=/[\x2E\u3002\uFF0E\uFF61]/g,// RFC 3490 separators
	/** Error messages */errors={'overflow':'Overflow: input needs wider integers to process','not-basic':'Illegal input >= 0x80 (not a basic code point)','invalid-input':'Invalid input'},/** Convenience shortcuts */baseMinusTMin=base-tMin,floor=Math.floor,stringFromCharCode=String.fromCharCode,/** Temporary variable */key;/*--------------------------------------------------------------------------*/ /**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */function error(type){throw new RangeError(errors[type]);}/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */function map(array,fn){var length=array.length;var result=[];while(length--){result[length]=fn(array[length]);}return result;}/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */function mapDomain(string,fn){var parts=string.split('@');var result='';if(parts.length>1){// In email addresses, only the domain name should be punycoded. Leave
	// the local part (i.e. everything up to `@`) intact.
	result=parts[0]+'@';string=parts[1];}// Avoid `split(regex)` for IE8 compatibility. See #17.
	string=string.replace(regexSeparators,'\x2E');var labels=string.split('.');var encoded=map(labels,fn).join('.');return result+encoded;}/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */function ucs2decode(string){var output=[],counter=0,length=string.length,value,extra;while(counter<length){value=string.charCodeAt(counter++);if(value>=0xD800&&value<=0xDBFF&&counter<length){// high surrogate, and there is a next character
	extra=string.charCodeAt(counter++);if((extra&0xFC00)==0xDC00){// low surrogate
	output.push(((value&0x3FF)<<10)+(extra&0x3FF)+0x10000);}else{// unmatched surrogate; only append this code unit, in case the next
	// code unit is the high surrogate of a surrogate pair
	output.push(value);counter--;}}else{output.push(value);}}return output;}/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */function ucs2encode(array){return map(array,function(value){var output='';if(value>0xFFFF){value-=0x10000;output+=stringFromCharCode(value>>>10&0x3FF|0xD800);value=0xDC00|value&0x3FF;}output+=stringFromCharCode(value);return output;}).join('');}/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */function basicToDigit(codePoint){if(codePoint-48<10){return codePoint-22;}if(codePoint-65<26){return codePoint-65;}if(codePoint-97<26){return codePoint-97;}return base;}/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */function digitToBasic(digit,flag){//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit+22+75*(digit<26)-((flag!=0)<<5);}/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * https://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */function adapt(delta,numPoints,firstTime){var k=0;delta=firstTime?floor(delta/damp):delta>>1;delta+=floor(delta/numPoints);for(;/* no initialization */delta>baseMinusTMin*tMax>>1;k+=base){delta=floor(delta/baseMinusTMin);}return floor(k+(baseMinusTMin+1)*delta/(delta+skew));}/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */function decode(input){// Don't use UCS-2
	var output=[],inputLength=input.length,out,i=0,n=initialN,bias=initialBias,basic,j,index,oldi,w,k,digit,t,/** Cached calculation results */baseMinusT;// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.
	basic=input.lastIndexOf(delimiter);if(basic<0){basic=0;}for(j=0;j<basic;++j){// if it's not a basic code point
	if(input.charCodeAt(j)>=0x80){error('not-basic');}output.push(input.charCodeAt(j));}// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.
	for(index=basic>0?basic+1:0;index<inputLength;)/* no final expression */{// `index` is the index of the next character to be consumed.
	// Decode a generalized variable-length integer into `delta`,
	// which gets added to `i`. The overflow checking is easier
	// if we increase `i` as we go, then subtract off its starting
	// value at the end to obtain `delta`.
	for(oldi=i,w=1,k=base;;/* no condition */k+=base){if(index>=inputLength){error('invalid-input');}digit=basicToDigit(input.charCodeAt(index++));if(digit>=base||digit>floor((maxInt-i)/w)){error('overflow');}i+=digit*w;t=k<=bias?tMin:k>=bias+tMax?tMax:k-bias;if(digit<t){break;}baseMinusT=base-t;if(w>floor(maxInt/baseMinusT)){error('overflow');}w*=baseMinusT;}out=output.length+1;bias=adapt(i-oldi,out,oldi==0);// `i` was supposed to wrap around from `out` to `0`,
	// incrementing `n` each time, so we'll fix that now:
	if(floor(i/out)>maxInt-n){error('overflow');}n+=floor(i/out);i%=out;// Insert `n` at position `i` of the output
	output.splice(i++,0,n);}return ucs2encode(output);}/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */function encode(input){var n,delta,handledCPCount,basicLength,bias,j,m,q,k,t,currentValue,output=[],/** `inputLength` will hold the number of code points in `input`. */inputLength,/** Cached calculation results */handledCPCountPlusOne,baseMinusT,qMinusT;// Convert the input in UCS-2 to Unicode
	input=ucs2decode(input);// Cache the length
	inputLength=input.length;// Initialize the state
	n=initialN;delta=0;bias=initialBias;// Handle the basic code points
	for(j=0;j<inputLength;++j){currentValue=input[j];if(currentValue<0x80){output.push(stringFromCharCode(currentValue));}}handledCPCount=basicLength=output.length;// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.
	// Finish the basic string - if it is not empty - with a delimiter
	if(basicLength){output.push(delimiter);}// Main encoding loop:
	while(handledCPCount<inputLength){// All non-basic code points < n have been handled already. Find the next
	// larger one:
	for(m=maxInt,j=0;j<inputLength;++j){currentValue=input[j];if(currentValue>=n&&currentValue<m){m=currentValue;}}// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
	// but guard against overflow
	handledCPCountPlusOne=handledCPCount+1;if(m-n>floor((maxInt-delta)/handledCPCountPlusOne)){error('overflow');}delta+=(m-n)*handledCPCountPlusOne;n=m;for(j=0;j<inputLength;++j){currentValue=input[j];if(currentValue<n&&++delta>maxInt){error('overflow');}if(currentValue==n){// Represent delta as a generalized variable-length integer
	for(q=delta,k=base;;/* no condition */k+=base){t=k<=bias?tMin:k>=bias+tMax?tMax:k-bias;if(q<t){break;}qMinusT=q-t;baseMinusT=base-t;output.push(stringFromCharCode(digitToBasic(t+qMinusT%baseMinusT,0)));q=floor(qMinusT/baseMinusT);}output.push(stringFromCharCode(digitToBasic(q,0)));bias=adapt(delta,handledCPCountPlusOne,handledCPCount==basicLength);delta=0;++handledCPCount;}}++delta;++n;}return output.join('');}/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */function toUnicode(input){return mapDomain(input,function(string){return regexPunycode.test(string)?decode(string.slice(4).toLowerCase()):string;});}/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */function toASCII(input){return mapDomain(input,function(string){return regexNonASCII.test(string)?'xn--'+encode(string):string;});}/*--------------------------------------------------------------------------*/ /** Define the public API */punycode={/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */'version':'1.4.1',/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */'ucs2':{'decode':ucs2decode,'encode':ucs2encode},'decode':decode,'encode':encode,'toASCII':toASCII,'toUnicode':toUnicode};/** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if(typeof define=='function'&&_typeof(define.amd)=='object'&&define.amd){define('punycode',function(){return punycode;});}else if(freeExports&&freeModule){if(module.exports==freeExports){// in Node.js, io.js, or RingoJS v0.8.0+
	freeModule.exports=punycode;}else{// in Narwhal or RingoJS v0.7.0-
	for(key in punycode){punycode.hasOwnProperty(key)&&(freeExports[key]=punycode[key]);}}}else{// in Rhino or a web browser
	root.punycode=punycode;}})(this);}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{}],195:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	'use strict';// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop);}module.exports=function(qs,sep,eq,options){sep=sep||'&';eq=eq||'=';var obj={};if(typeof qs!=='string'||qs.length===0){return obj;}var regexp=/\+/g;qs=qs.split(sep);var maxKeys=1000;if(options&&typeof options.maxKeys==='number'){maxKeys=options.maxKeys;}var len=qs.length;// maxKeys <= 0 means that we should not limit keys count
	if(maxKeys>0&&len>maxKeys){len=maxKeys;}for(var i=0;i<len;++i){var x=qs[i].replace(regexp,'%20'),idx=x.indexOf(eq),kstr,vstr,k,v;if(idx>=0){kstr=x.substr(0,idx);vstr=x.substr(idx+1);}else{kstr=x;vstr='';}k=decodeURIComponent(kstr);v=decodeURIComponent(vstr);if(!hasOwnProperty(obj,k)){obj[k]=v;}else if(isArray(obj[k])){obj[k].push(v);}else{obj[k]=[obj[k],v];}}return obj;};var isArray=Array.isArray||function(xs){return Object.prototype.toString.call(xs)==='[object Array]';};},{}],196:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	'use strict';var stringifyPrimitive=function stringifyPrimitive(v){switch(_typeof(v)){case'string':return v;case'boolean':return v?'true':'false';case'number':return isFinite(v)?v:'';default:return'';}};module.exports=function(obj,sep,eq,name){sep=sep||'&';eq=eq||'=';if(obj===null){obj=undefined;}if(_typeof(obj)==='object'){return map(objectKeys(obj),function(k){var ks=encodeURIComponent(stringifyPrimitive(k))+eq;if(isArray(obj[k])){return map(obj[k],function(v){return ks+encodeURIComponent(stringifyPrimitive(v));}).join(sep);}else{return ks+encodeURIComponent(stringifyPrimitive(obj[k]));}}).join(sep);}if(!name)return'';return encodeURIComponent(stringifyPrimitive(name))+eq+encodeURIComponent(stringifyPrimitive(obj));};var isArray=Array.isArray||function(xs){return Object.prototype.toString.call(xs)==='[object Array]';};function map(xs,f){if(xs.map)return xs.map(f);var res=[];for(var i=0;i<xs.length;i++){res.push(f(xs[i],i));}return res;}var objectKeys=Object.keys||function(obj){var res=[];for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))res.push(key);}return res;};},{}],197:[function(require,module,exports){'use strict';exports.decode=exports.parse=require('./decode');exports.encode=exports.stringify=require('./encode');},{"./decode":195,"./encode":196}],198:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var util=require('./util');var has=Object.prototype.hasOwnProperty;var hasNativeMap=typeof Map!=="undefined";/**
	 * A data structure which is a combination of an array and a set. Adding a new
	 * member is O(1), testing for membership is O(1), and finding the index of an
	 * element is O(1). Removing elements from the set is not supported. Only
	 * strings are supported for membership.
	 */function ArraySet(){this._array=[];this._set=hasNativeMap?new Map():Object.create(null);}/**
	 * Static method for creating ArraySet instances from an existing array.
	 */ArraySet.fromArray=function ArraySet_fromArray(aArray,aAllowDuplicates){var set=new ArraySet();for(var i=0,len=aArray.length;i<len;i++){set.add(aArray[i],aAllowDuplicates);}return set;};/**
	 * Return how many unique items are in this ArraySet. If duplicates have been
	 * added, than those do not count towards the size.
	 *
	 * @returns Number
	 */ArraySet.prototype.size=function ArraySet_size(){return hasNativeMap?this._set.size:Object.getOwnPropertyNames(this._set).length;};/**
	 * Add the given string to this set.
	 *
	 * @param String aStr
	 */ArraySet.prototype.add=function ArraySet_add(aStr,aAllowDuplicates){var sStr=hasNativeMap?aStr:util.toSetString(aStr);var isDuplicate=hasNativeMap?this.has(aStr):has.call(this._set,sStr);var idx=this._array.length;if(!isDuplicate||aAllowDuplicates){this._array.push(aStr);}if(!isDuplicate){if(hasNativeMap){this._set.set(aStr,idx);}else{this._set[sStr]=idx;}}};/**
	 * Is the given string a member of this set?
	 *
	 * @param String aStr
	 */ArraySet.prototype.has=function ArraySet_has(aStr){if(hasNativeMap){return this._set.has(aStr);}else{var sStr=util.toSetString(aStr);return has.call(this._set,sStr);}};/**
	 * What is the index of the given string in the array?
	 *
	 * @param String aStr
	 */ArraySet.prototype.indexOf=function ArraySet_indexOf(aStr){if(hasNativeMap){var idx=this._set.get(aStr);if(idx>=0){return idx;}}else{var sStr=util.toSetString(aStr);if(has.call(this._set,sStr)){return this._set[sStr];}}throw new Error('"'+aStr+'" is not in the set.');};/**
	 * What is the element at the given index?
	 *
	 * @param Number aIdx
	 */ArraySet.prototype.at=function ArraySet_at(aIdx){if(aIdx>=0&&aIdx<this._array.length){return this._array[aIdx];}throw new Error('No element indexed by '+aIdx);};/**
	 * Returns the array representation of this set (which has the proper indices
	 * indicated by indexOf). Note that this is a copy of the internal array used
	 * for storing the members so that no one can mess with internal state.
	 */ArraySet.prototype.toArray=function ArraySet_toArray(){return this._array.slice();};exports.ArraySet=ArraySet;},{"./util":207}],199:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 *
	 * Based on the Base 64 VLQ implementation in Closure Compiler:
	 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
	 *
	 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *  * Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *  * Neither the name of Google Inc. nor the names of its
	 *    contributors may be used to endorse or promote products derived
	 *    from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */var base64=require('./base64');// A single base 64 digit can contain 6 bits of data. For the base 64 variable
	// length quantities we use in the source map spec, the first bit is the sign,
	// the next four bits are the actual value, and the 6th bit is the
	// continuation bit. The continuation bit tells us whether there are more
	// digits in this value following this digit.
	//
	//   Continuation
	//   |    Sign
	//   |    |
	//   V    V
	//   101011
	var VLQ_BASE_SHIFT=5;// binary: 100000
	var VLQ_BASE=1<<VLQ_BASE_SHIFT;// binary: 011111
	var VLQ_BASE_MASK=VLQ_BASE-1;// binary: 100000
	var VLQ_CONTINUATION_BIT=VLQ_BASE;/**
	 * Converts from a two-complement value to a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	 */function toVLQSigned(aValue){return aValue<0?(-aValue<<1)+1:(aValue<<1)+0;}/**
	 * Converts to a two-complement value from a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	 */function fromVLQSigned(aValue){var isNegative=(aValue&1)===1;var shifted=aValue>>1;return isNegative?-shifted:shifted;}/**
	 * Returns the base 64 VLQ encoded value.
	 */exports.encode=function base64VLQ_encode(aValue){var encoded="";var digit;var vlq=toVLQSigned(aValue);do{digit=vlq&VLQ_BASE_MASK;vlq>>>=VLQ_BASE_SHIFT;if(vlq>0){// There are still more digits in this value, so we must make sure the
	// continuation bit is marked.
	digit|=VLQ_CONTINUATION_BIT;}encoded+=base64.encode(digit);}while(vlq>0);return encoded;};/**
	 * Decodes the next base 64 VLQ value from the given string and returns the
	 * value and the rest of the string via the out parameter.
	 */exports.decode=function base64VLQ_decode(aStr,aIndex,aOutParam){var strLen=aStr.length;var result=0;var shift=0;var continuation,digit;do{if(aIndex>=strLen){throw new Error("Expected more digits in base 64 VLQ value.");}digit=base64.decode(aStr.charCodeAt(aIndex++));if(digit===-1){throw new Error("Invalid base64 digit: "+aStr.charAt(aIndex-1));}continuation=!!(digit&VLQ_CONTINUATION_BIT);digit&=VLQ_BASE_MASK;result=result+(digit<<shift);shift+=VLQ_BASE_SHIFT;}while(continuation);aOutParam.value=fromVLQSigned(result);aOutParam.rest=aIndex;};},{"./base64":200}],200:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var intToCharMap='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');/**
	 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
	 */exports.encode=function(number){if(0<=number&&number<intToCharMap.length){return intToCharMap[number];}throw new TypeError("Must be between 0 and 63: "+number);};/**
	 * Decode a single base 64 character code digit to an integer. Returns -1 on
	 * failure.
	 */exports.decode=function(charCode){var bigA=65;// 'A'
	var bigZ=90;// 'Z'
	var littleA=97;// 'a'
	var littleZ=122;// 'z'
	var zero=48;// '0'
	var nine=57;// '9'
	var plus=43;// '+'
	var slash=47;// '/'
	var littleOffset=26;var numberOffset=52;// 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
	if(bigA<=charCode&&charCode<=bigZ){return charCode-bigA;}// 26 - 51: abcdefghijklmnopqrstuvwxyz
	if(littleA<=charCode&&charCode<=littleZ){return charCode-littleA+littleOffset;}// 52 - 61: 0123456789
	if(zero<=charCode&&charCode<=nine){return charCode-zero+numberOffset;}// 62: +
	if(charCode==plus){return 62;}// 63: /
	if(charCode==slash){return 63;}// Invalid base64 digit.
	return-1;};},{}],201:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */exports.GREATEST_LOWER_BOUND=1;exports.LEAST_UPPER_BOUND=2;/**
	 * Recursive implementation of binary search.
	 *
	 * @param aLow Indices here and lower do not contain the needle.
	 * @param aHigh Indices here and higher do not contain the needle.
	 * @param aNeedle The element being searched for.
	 * @param aHaystack The non-empty array being searched.
	 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 */function recursiveSearch(aLow,aHigh,aNeedle,aHaystack,aCompare,aBias){// This function terminates when one of the following is true:
	//
	//   1. We find the exact element we are looking for.
	//
	//   2. We did not find the exact element, but we can return the index of
	//      the next-closest element.
	//
	//   3. We did not find the exact element, and there is no next-closest
	//      element than the one we are searching for, so we return -1.
	var mid=Math.floor((aHigh-aLow)/2)+aLow;var cmp=aCompare(aNeedle,aHaystack[mid],true);if(cmp===0){// Found the element we are looking for.
	return mid;}else if(cmp>0){// Our needle is greater than aHaystack[mid].
	if(aHigh-mid>1){// The element is in the upper half.
	return recursiveSearch(mid,aHigh,aNeedle,aHaystack,aCompare,aBias);}// The exact needle element was not found in this haystack. Determine if
	// we are in termination case (3) or (2) and return the appropriate thing.
	if(aBias==exports.LEAST_UPPER_BOUND){return aHigh<aHaystack.length?aHigh:-1;}else{return mid;}}else{// Our needle is less than aHaystack[mid].
	if(mid-aLow>1){// The element is in the lower half.
	return recursiveSearch(aLow,mid,aNeedle,aHaystack,aCompare,aBias);}// we are in termination case (3) or (2) and return the appropriate thing.
	if(aBias==exports.LEAST_UPPER_BOUND){return mid;}else{return aLow<0?-1:aLow;}}}/**
	 * This is an implementation of binary search which will always try and return
	 * the index of the closest element if there is no exact hit. This is because
	 * mappings between original and generated line/col pairs are single points,
	 * and there is an implicit region between each of them, so a miss just means
	 * that you aren't on the very start of a region.
	 *
	 * @param aNeedle The element you are looking for.
	 * @param aHaystack The array that is being searched.
	 * @param aCompare A function which takes the needle and an element in the
	 *     array and returns -1, 0, or 1 depending on whether the needle is less
	 *     than, equal to, or greater than the element, respectively.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	 */exports.search=function search(aNeedle,aHaystack,aCompare,aBias){if(aHaystack.length===0){return-1;}var index=recursiveSearch(-1,aHaystack.length,aNeedle,aHaystack,aCompare,aBias||exports.GREATEST_LOWER_BOUND);if(index<0){return-1;}// We have found either the exact element, or the next-closest element than
	// the one we are searching for. However, there may be more than one such
	// element. Make sure we always return the smallest of these.
	while(index-1>=0){if(aCompare(aHaystack[index],aHaystack[index-1],true)!==0){break;}--index;}return index;};},{}],202:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2014 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var util=require('./util');/**
	 * Determine whether mappingB is after mappingA with respect to generated
	 * position.
	 */function generatedPositionAfter(mappingA,mappingB){// Optimized for most common case
	var lineA=mappingA.generatedLine;var lineB=mappingB.generatedLine;var columnA=mappingA.generatedColumn;var columnB=mappingB.generatedColumn;return lineB>lineA||lineB==lineA&&columnB>=columnA||util.compareByGeneratedPositionsInflated(mappingA,mappingB)<=0;}/**
	 * A data structure to provide a sorted view of accumulated mappings in a
	 * performance conscious manner. It trades a neglibable overhead in general
	 * case for a large speedup in case of mappings being added in order.
	 */function MappingList(){this._array=[];this._sorted=true;// Serves as infimum
	this._last={generatedLine:-1,generatedColumn:0};}/**
	 * Iterate through internal items. This method takes the same arguments that
	 * `Array.prototype.forEach` takes.
	 *
	 * NOTE: The order of the mappings is NOT guaranteed.
	 */MappingList.prototype.unsortedForEach=function MappingList_forEach(aCallback,aThisArg){this._array.forEach(aCallback,aThisArg);};/**
	 * Add the given source mapping.
	 *
	 * @param Object aMapping
	 */MappingList.prototype.add=function MappingList_add(aMapping){if(generatedPositionAfter(this._last,aMapping)){this._last=aMapping;this._array.push(aMapping);}else{this._sorted=false;this._array.push(aMapping);}};/**
	 * Returns the flat, sorted array of mappings. The mappings are sorted by
	 * generated position.
	 *
	 * WARNING: This method returns internal data without copying, for
	 * performance. The return value must NOT be mutated, and should be treated as
	 * an immutable borrow. If you want to take ownership, you must make your own
	 * copy.
	 */MappingList.prototype.toArray=function MappingList_toArray(){if(!this._sorted){this._array.sort(util.compareByGeneratedPositionsInflated);this._sorted=true;}return this._array;};exports.MappingList=MappingList;},{"./util":207}],203:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */ // It turns out that some (most?) JavaScript engines don't self-host
	// `Array.prototype.sort`. This makes sense because C++ will likely remain
	// faster than JS when doing raw CPU-intensive sorting. However, when using a
	// custom comparator function, calling back and forth between the VM's C++ and
	// JIT'd JS is rather slow *and* loses JIT type information, resulting in
	// worse generated code for the comparator function than would be optimal. In
	// fact, when sorting with a comparator, these costs outweigh the benefits of
	// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
	// a ~3500ms mean speed-up in `bench/bench.html`.
	/**
	 * Swap the elements indexed by `x` and `y` in the array `ary`.
	 *
	 * @param {Array} ary
	 *        The array.
	 * @param {Number} x
	 *        The index of the first item.
	 * @param {Number} y
	 *        The index of the second item.
	 */function swap(ary,x,y){var temp=ary[x];ary[x]=ary[y];ary[y]=temp;}/**
	 * Returns a random integer within the range `low .. high` inclusive.
	 *
	 * @param {Number} low
	 *        The lower bound on the range.
	 * @param {Number} high
	 *        The upper bound on the range.
	 */function randomIntInRange(low,high){return Math.round(low+Math.random()*(high-low));}/**
	 * The Quick Sort algorithm.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 * @param {Number} p
	 *        Start index of the array
	 * @param {Number} r
	 *        End index of the array
	 */function doQuickSort(ary,comparator,p,r){// If our lower bound is less than our upper bound, we (1) partition the
	// array into two pieces and (2) recurse on each half. If it is not, this is
	// the empty array and our base case.
	if(p<r){// (1) Partitioning.
	//
	// The partitioning chooses a pivot between `p` and `r` and moves all
	// elements that are less than or equal to the pivot to the before it, and
	// all the elements that are greater than it after it. The effect is that
	// once partition is done, the pivot is in the exact place it will be when
	// the array is put in sorted order, and it will not need to be moved
	// again. This runs in O(n) time.
	// Always choose a random pivot so that an input array which is reverse
	// sorted does not cause O(n^2) running time.
	var pivotIndex=randomIntInRange(p,r);var i=p-1;swap(ary,pivotIndex,r);var pivot=ary[r];// Immediately after `j` is incremented in this loop, the following hold
	// true:
	//
	//   * Every element in `ary[p .. i]` is less than or equal to the pivot.
	//
	//   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
	for(var j=p;j<r;j++){if(comparator(ary[j],pivot)<=0){i+=1;swap(ary,i,j);}}swap(ary,i+1,j);var q=i+1;// (2) Recurse on each half.
	doQuickSort(ary,comparator,p,q-1);doQuickSort(ary,comparator,q+1,r);}}/**
	 * Sort the given array in-place with the given comparator function.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 */exports.quickSort=function(ary,comparator){doQuickSort(ary,comparator,0,ary.length-1);};},{}],204:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var util=require('./util');var binarySearch=require('./binary-search');var ArraySet=require('./array-set').ArraySet;var base64VLQ=require('./base64-vlq');var quickSort=require('./quick-sort').quickSort;function SourceMapConsumer(aSourceMap,aSourceMapURL){var sourceMap=aSourceMap;if(typeof aSourceMap==='string'){sourceMap=util.parseSourceMapInput(aSourceMap);}return sourceMap.sections!=null?new IndexedSourceMapConsumer(sourceMap,aSourceMapURL):new BasicSourceMapConsumer(sourceMap,aSourceMapURL);}SourceMapConsumer.fromSourceMap=function(aSourceMap,aSourceMapURL){return BasicSourceMapConsumer.fromSourceMap(aSourceMap,aSourceMapURL);};/**
	 * The version of the source mapping spec that we are consuming.
	 */SourceMapConsumer.prototype._version=3;// `__generatedMappings` and `__originalMappings` are arrays that hold the
	// parsed mapping coordinates from the source map's "mappings" attribute. They
	// are lazily instantiated, accessed via the `_generatedMappings` and
	// `_originalMappings` getters respectively, and we only parse the mappings
	// and create these arrays once queried for a source location. We jump through
	// these hoops because there can be many thousands of mappings, and parsing
	// them is expensive, so we only want to do it if we must.
	//
	// Each object in the arrays is of the form:
	//
	//     {
	//       generatedLine: The line number in the generated code,
	//       generatedColumn: The column number in the generated code,
	//       source: The path to the original source file that generated this
	//               chunk of code,
	//       originalLine: The line number in the original source that
	//                     corresponds to this chunk of generated code,
	//       originalColumn: The column number in the original source that
	//                       corresponds to this chunk of generated code,
	//       name: The name of the original symbol which generated this chunk of
	//             code.
	//     }
	//
	// All properties except for `generatedLine` and `generatedColumn` can be
	// `null`.
	//
	// `_generatedMappings` is ordered by the generated positions.
	//
	// `_originalMappings` is ordered by the original positions.
	SourceMapConsumer.prototype.__generatedMappings=null;Object.defineProperty(SourceMapConsumer.prototype,'_generatedMappings',{configurable:true,enumerable:true,get:function get(){if(!this.__generatedMappings){this._parseMappings(this._mappings,this.sourceRoot);}return this.__generatedMappings;}});SourceMapConsumer.prototype.__originalMappings=null;Object.defineProperty(SourceMapConsumer.prototype,'_originalMappings',{configurable:true,enumerable:true,get:function get(){if(!this.__originalMappings){this._parseMappings(this._mappings,this.sourceRoot);}return this.__originalMappings;}});SourceMapConsumer.prototype._charIsMappingSeparator=function SourceMapConsumer_charIsMappingSeparator(aStr,index){var c=aStr.charAt(index);return c===";"||c===",";};/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */SourceMapConsumer.prototype._parseMappings=function SourceMapConsumer_parseMappings(aStr,aSourceRoot){throw new Error("Subclasses must implement _parseMappings");};SourceMapConsumer.GENERATED_ORDER=1;SourceMapConsumer.ORIGINAL_ORDER=2;SourceMapConsumer.GREATEST_LOWER_BOUND=1;SourceMapConsumer.LEAST_UPPER_BOUND=2;/**
	 * Iterate over each mapping between an original source/line/column and a
	 * generated line/column in this source map.
	 *
	 * @param Function aCallback
	 *        The function that is called with each mapping.
	 * @param Object aContext
	 *        Optional. If specified, this object will be the value of `this` every
	 *        time that `aCallback` is called.
	 * @param aOrder
	 *        Either `SourceMapConsumer.GENERATED_ORDER` or
	 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	 *        iterate over the mappings sorted by the generated file's line/column
	 *        order or the original's source/line/column order, respectively. Defaults to
	 *        `SourceMapConsumer.GENERATED_ORDER`.
	 */SourceMapConsumer.prototype.eachMapping=function SourceMapConsumer_eachMapping(aCallback,aContext,aOrder){var context=aContext||null;var order=aOrder||SourceMapConsumer.GENERATED_ORDER;var mappings;switch(order){case SourceMapConsumer.GENERATED_ORDER:mappings=this._generatedMappings;break;case SourceMapConsumer.ORIGINAL_ORDER:mappings=this._originalMappings;break;default:throw new Error("Unknown order of iteration.");}var sourceRoot=this.sourceRoot;mappings.map(function(mapping){var source=mapping.source===null?null:this._sources.at(mapping.source);source=util.computeSourceURL(sourceRoot,source,this._sourceMapURL);return{source:source,generatedLine:mapping.generatedLine,generatedColumn:mapping.generatedColumn,originalLine:mapping.originalLine,originalColumn:mapping.originalColumn,name:mapping.name===null?null:this._names.at(mapping.name)};},this).forEach(aCallback,context);};/**
	 * Returns all generated line and column information for the original source,
	 * line, and column provided. If no column is provided, returns all mappings
	 * corresponding to a either the line we are searching for or the next
	 * closest line that has any mappings. Otherwise, returns all mappings
	 * corresponding to the given line and either the column we are searching for
	 * or the next closest column that has any offsets.
	 *
	 * The only argument is an object with the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.  The line number is 1-based.
	 *   - column: Optional. the column number in the original source.
	 *    The column number is 0-based.
	 *
	 * and an array of objects is returned, each with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.  The
	 *    line number is 1-based.
	 *   - column: The column number in the generated source, or null.
	 *    The column number is 0-based.
	 */SourceMapConsumer.prototype.allGeneratedPositionsFor=function SourceMapConsumer_allGeneratedPositionsFor(aArgs){var line=util.getArg(aArgs,'line');// When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
	// returns the index of the closest mapping less than the needle. By
	// setting needle.originalColumn to 0, we thus find the last mapping for
	// the given line, provided such a mapping exists.
	var needle={source:util.getArg(aArgs,'source'),originalLine:line,originalColumn:util.getArg(aArgs,'column',0)};needle.source=this._findSourceIndex(needle.source);if(needle.source<0){return[];}var mappings=[];var index=this._findMapping(needle,this._originalMappings,"originalLine","originalColumn",util.compareByOriginalPositions,binarySearch.LEAST_UPPER_BOUND);if(index>=0){var mapping=this._originalMappings[index];if(aArgs.column===undefined){var originalLine=mapping.originalLine;// Iterate until either we run out of mappings, or we run into
	// a mapping for a different line than the one we found. Since
	// mappings are sorted, this is guaranteed to find all mappings for
	// the line we found.
	while(mapping&&mapping.originalLine===originalLine){mappings.push({line:util.getArg(mapping,'generatedLine',null),column:util.getArg(mapping,'generatedColumn',null),lastColumn:util.getArg(mapping,'lastGeneratedColumn',null)});mapping=this._originalMappings[++index];}}else{var originalColumn=mapping.originalColumn;// Iterate until either we run out of mappings, or we run into
	// a mapping for a different line than the one we were searching for.
	// Since mappings are sorted, this is guaranteed to find all mappings for
	// the line we are searching for.
	while(mapping&&mapping.originalLine===line&&mapping.originalColumn==originalColumn){mappings.push({line:util.getArg(mapping,'generatedLine',null),column:util.getArg(mapping,'generatedColumn',null),lastColumn:util.getArg(mapping,'lastGeneratedColumn',null)});mapping=this._originalMappings[++index];}}}return mappings;};exports.SourceMapConsumer=SourceMapConsumer;/**
	 * A BasicSourceMapConsumer instance represents a parsed source map which we can
	 * query for information about the original file positions by giving it a file
	 * position in the generated source.
	 *
	 * The first parameter is the raw source map (either as a JSON string, or
	 * already parsed to an object). According to the spec, source maps have the
	 * following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - sources: An array of URLs to the original source files.
	 *   - names: An array of identifiers which can be referrenced by individual mappings.
	 *   - sourceRoot: Optional. The URL root from which all sources are relative.
	 *   - sourcesContent: Optional. An array of contents of the original source files.
	 *   - mappings: A string of base64 VLQs which contain the actual mappings.
	 *   - file: Optional. The generated file this source map is associated with.
	 *
	 * Here is an example source map, taken from the source map spec[0]:
	 *
	 *     {
	 *       version : 3,
	 *       file: "out.js",
	 *       sourceRoot : "",
	 *       sources: ["foo.js", "bar.js"],
	 *       names: ["src", "maps", "are", "fun"],
	 *       mappings: "AA,AB;;ABCDE;"
	 *     }
	 *
	 * The second parameter, if given, is a string whose value is the URL
	 * at which the source map was found.  This URL is used to compute the
	 * sources array.
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	 */function BasicSourceMapConsumer(aSourceMap,aSourceMapURL){var sourceMap=aSourceMap;if(typeof aSourceMap==='string'){sourceMap=util.parseSourceMapInput(aSourceMap);}var version=util.getArg(sourceMap,'version');var sources=util.getArg(sourceMap,'sources');// Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
	// requires the array) to play nice here.
	var names=util.getArg(sourceMap,'names',[]);var sourceRoot=util.getArg(sourceMap,'sourceRoot',null);var sourcesContent=util.getArg(sourceMap,'sourcesContent',null);var mappings=util.getArg(sourceMap,'mappings');var file=util.getArg(sourceMap,'file',null);// Once again, Sass deviates from the spec and supplies the version as a
	// string rather than a number, so we use loose equality checking here.
	if(version!=this._version){throw new Error('Unsupported version: '+version);}if(sourceRoot){sourceRoot=util.normalize(sourceRoot);}sources=sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
	// "foo.js".  Normalize these first so that future comparisons will succeed.
	// See bugzil.la/1090768.
	.map(util.normalize)// Always ensure that absolute sources are internally stored relative to
	// the source root, if the source root is absolute. Not doing this would
	// be particularly problematic when the source root is a prefix of the
	// source (valid, but why??). See github issue #199 and bugzil.la/1188982.
	.map(function(source){return sourceRoot&&util.isAbsolute(sourceRoot)&&util.isAbsolute(source)?util.relative(sourceRoot,source):source;});// Pass `true` below to allow duplicate names and sources. While source maps
	// are intended to be compressed and deduplicated, the TypeScript compiler
	// sometimes generates source maps with duplicates in them. See Github issue
	// #72 and bugzil.la/889492.
	this._names=ArraySet.fromArray(names.map(String),true);this._sources=ArraySet.fromArray(sources,true);this._absoluteSources=this._sources.toArray().map(function(s){return util.computeSourceURL(sourceRoot,s,aSourceMapURL);});this.sourceRoot=sourceRoot;this.sourcesContent=sourcesContent;this._mappings=mappings;this._sourceMapURL=aSourceMapURL;this.file=file;}BasicSourceMapConsumer.prototype=Object.create(SourceMapConsumer.prototype);BasicSourceMapConsumer.prototype.consumer=SourceMapConsumer;/**
	 * Utility function to find the index of a source.  Returns -1 if not
	 * found.
	 */BasicSourceMapConsumer.prototype._findSourceIndex=function(aSource){var relativeSource=aSource;if(this.sourceRoot!=null){relativeSource=util.relative(this.sourceRoot,relativeSource);}if(this._sources.has(relativeSource)){return this._sources.indexOf(relativeSource);}// Maybe aSource is an absolute URL as returned by |sources|.  In
	// this case we can't simply undo the transform.
	var i;for(i=0;i<this._absoluteSources.length;++i){if(this._absoluteSources[i]==aSource){return i;}}return-1;};/**
	 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
	 *
	 * @param SourceMapGenerator aSourceMap
	 *        The source map that will be consumed.
	 * @param String aSourceMapURL
	 *        The URL at which the source map can be found (optional)
	 * @returns BasicSourceMapConsumer
	 */BasicSourceMapConsumer.fromSourceMap=function SourceMapConsumer_fromSourceMap(aSourceMap,aSourceMapURL){var smc=Object.create(BasicSourceMapConsumer.prototype);var names=smc._names=ArraySet.fromArray(aSourceMap._names.toArray(),true);var sources=smc._sources=ArraySet.fromArray(aSourceMap._sources.toArray(),true);smc.sourceRoot=aSourceMap._sourceRoot;smc.sourcesContent=aSourceMap._generateSourcesContent(smc._sources.toArray(),smc.sourceRoot);smc.file=aSourceMap._file;smc._sourceMapURL=aSourceMapURL;smc._absoluteSources=smc._sources.toArray().map(function(s){return util.computeSourceURL(smc.sourceRoot,s,aSourceMapURL);});// Because we are modifying the entries (by converting string sources and
	// names to indices into the sources and names ArraySets), we have to make
	// a copy of the entry or else bad things happen. Shared mutable state
	// strikes again! See github issue #191.
	var generatedMappings=aSourceMap._mappings.toArray().slice();var destGeneratedMappings=smc.__generatedMappings=[];var destOriginalMappings=smc.__originalMappings=[];for(var i=0,length=generatedMappings.length;i<length;i++){var srcMapping=generatedMappings[i];var destMapping=new Mapping();destMapping.generatedLine=srcMapping.generatedLine;destMapping.generatedColumn=srcMapping.generatedColumn;if(srcMapping.source){destMapping.source=sources.indexOf(srcMapping.source);destMapping.originalLine=srcMapping.originalLine;destMapping.originalColumn=srcMapping.originalColumn;if(srcMapping.name){destMapping.name=names.indexOf(srcMapping.name);}destOriginalMappings.push(destMapping);}destGeneratedMappings.push(destMapping);}quickSort(smc.__originalMappings,util.compareByOriginalPositions);return smc;};/**
	 * The version of the source mapping spec that we are consuming.
	 */BasicSourceMapConsumer.prototype._version=3;/**
	 * The list of original sources.
	 */Object.defineProperty(BasicSourceMapConsumer.prototype,'sources',{get:function get(){return this._absoluteSources.slice();}});/**
	 * Provide the JIT with a nice shape / hidden class.
	 */function Mapping(){this.generatedLine=0;this.generatedColumn=0;this.source=null;this.originalLine=null;this.originalColumn=null;this.name=null;}/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */BasicSourceMapConsumer.prototype._parseMappings=function SourceMapConsumer_parseMappings(aStr,aSourceRoot){var generatedLine=1;var previousGeneratedColumn=0;var previousOriginalLine=0;var previousOriginalColumn=0;var previousSource=0;var previousName=0;var length=aStr.length;var index=0;var cachedSegments={};var temp={};var originalMappings=[];var generatedMappings=[];var mapping,str,segment,end,value;while(index<length){if(aStr.charAt(index)===';'){generatedLine++;index++;previousGeneratedColumn=0;}else if(aStr.charAt(index)===','){index++;}else{mapping=new Mapping();mapping.generatedLine=generatedLine;// Because each offset is encoded relative to the previous one,
	// many segments often have the same encoding. We can exploit this
	// fact by caching the parsed variable length fields of each segment,
	// allowing us to avoid a second parse if we encounter the same
	// segment again.
	for(end=index;end<length;end++){if(this._charIsMappingSeparator(aStr,end)){break;}}str=aStr.slice(index,end);segment=cachedSegments[str];if(segment){index+=str.length;}else{segment=[];while(index<end){base64VLQ.decode(aStr,index,temp);value=temp.value;index=temp.rest;segment.push(value);}if(segment.length===2){throw new Error('Found a source, but no line and column');}if(segment.length===3){throw new Error('Found a source and line, but no column');}cachedSegments[str]=segment;}// Generated column.
	mapping.generatedColumn=previousGeneratedColumn+segment[0];previousGeneratedColumn=mapping.generatedColumn;if(segment.length>1){// Original source.
	mapping.source=previousSource+segment[1];previousSource+=segment[1];// Original line.
	mapping.originalLine=previousOriginalLine+segment[2];previousOriginalLine=mapping.originalLine;// Lines are stored 0-based
	mapping.originalLine+=1;// Original column.
	mapping.originalColumn=previousOriginalColumn+segment[3];previousOriginalColumn=mapping.originalColumn;if(segment.length>4){// Original name.
	mapping.name=previousName+segment[4];previousName+=segment[4];}}generatedMappings.push(mapping);if(typeof mapping.originalLine==='number'){originalMappings.push(mapping);}}}quickSort(generatedMappings,util.compareByGeneratedPositionsDeflated);this.__generatedMappings=generatedMappings;quickSort(originalMappings,util.compareByOriginalPositions);this.__originalMappings=originalMappings;};/**
	 * Find the mapping that best matches the hypothetical "needle" mapping that
	 * we are searching for in the given "haystack" of mappings.
	 */BasicSourceMapConsumer.prototype._findMapping=function SourceMapConsumer_findMapping(aNeedle,aMappings,aLineName,aColumnName,aComparator,aBias){// To return the position we are searching for, we must first find the
	// mapping for the given position and then return the opposite position it
	// points to. Because the mappings are sorted, we can use binary search to
	// find the best mapping.
	if(aNeedle[aLineName]<=0){throw new TypeError('Line must be greater than or equal to 1, got '+aNeedle[aLineName]);}if(aNeedle[aColumnName]<0){throw new TypeError('Column must be greater than or equal to 0, got '+aNeedle[aColumnName]);}return binarySearch.search(aNeedle,aMappings,aComparator,aBias);};/**
	 * Compute the last column for each generated mapping. The last column is
	 * inclusive.
	 */BasicSourceMapConsumer.prototype.computeColumnSpans=function SourceMapConsumer_computeColumnSpans(){for(var index=0;index<this._generatedMappings.length;++index){var mapping=this._generatedMappings[index];// Mappings do not contain a field for the last generated columnt. We
	// can come up with an optimistic estimate, however, by assuming that
	// mappings are contiguous (i.e. given two consecutive mappings, the
	// first mapping ends where the second one starts).
	if(index+1<this._generatedMappings.length){var nextMapping=this._generatedMappings[index+1];if(mapping.generatedLine===nextMapping.generatedLine){mapping.lastGeneratedColumn=nextMapping.generatedColumn-1;continue;}}// The last mapping for each line spans the entire line.
	mapping.lastGeneratedColumn=Infinity;}};/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.  The line number
	 *     is 1-based.
	 *   - column: The column number in the generated source.  The column
	 *     number is 0-based.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.  The
	 *     line number is 1-based.
	 *   - column: The column number in the original source, or null.  The
	 *     column number is 0-based.
	 *   - name: The original identifier, or null.
	 */BasicSourceMapConsumer.prototype.originalPositionFor=function SourceMapConsumer_originalPositionFor(aArgs){var needle={generatedLine:util.getArg(aArgs,'line'),generatedColumn:util.getArg(aArgs,'column')};var index=this._findMapping(needle,this._generatedMappings,"generatedLine","generatedColumn",util.compareByGeneratedPositionsDeflated,util.getArg(aArgs,'bias',SourceMapConsumer.GREATEST_LOWER_BOUND));if(index>=0){var mapping=this._generatedMappings[index];if(mapping.generatedLine===needle.generatedLine){var source=util.getArg(mapping,'source',null);if(source!==null){source=this._sources.at(source);source=util.computeSourceURL(this.sourceRoot,source,this._sourceMapURL);}var name=util.getArg(mapping,'name',null);if(name!==null){name=this._names.at(name);}return{source:source,line:util.getArg(mapping,'originalLine',null),column:util.getArg(mapping,'originalColumn',null),name:name};}}return{source:null,line:null,column:null,name:null};};/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */BasicSourceMapConsumer.prototype.hasContentsOfAllSources=function BasicSourceMapConsumer_hasContentsOfAllSources(){if(!this.sourcesContent){return false;}return this.sourcesContent.length>=this._sources.size()&&!this.sourcesContent.some(function(sc){return sc==null;});};/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */BasicSourceMapConsumer.prototype.sourceContentFor=function SourceMapConsumer_sourceContentFor(aSource,nullOnMissing){if(!this.sourcesContent){return null;}var index=this._findSourceIndex(aSource);if(index>=0){return this.sourcesContent[index];}var relativeSource=aSource;if(this.sourceRoot!=null){relativeSource=util.relative(this.sourceRoot,relativeSource);}var url;if(this.sourceRoot!=null&&(url=util.urlParse(this.sourceRoot))){// XXX: file:// URIs and absolute paths lead to unexpected behavior for
	// many users. We can help them out when they expect file:// URIs to
	// behave like it would if they were running a local HTTP server. See
	// https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
	var fileUriAbsPath=relativeSource.replace(/^file:\/\//,"");if(url.scheme=="file"&&this._sources.has(fileUriAbsPath)){return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];}if((!url.path||url.path=="/")&&this._sources.has("/"+relativeSource)){return this.sourcesContent[this._sources.indexOf("/"+relativeSource)];}}// This function is used recursively from
	// IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
	// don't want to throw if we can't find the source - we just want to
	// return null, so we provide a flag to exit gracefully.
	if(nullOnMissing){return null;}else{throw new Error('"'+relativeSource+'" is not in the SourceMap.');}};/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.  The line number
	 *     is 1-based.
	 *   - column: The column number in the original source.  The column
	 *     number is 0-based.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.  The
	 *     line number is 1-based.
	 *   - column: The column number in the generated source, or null.
	 *     The column number is 0-based.
	 */BasicSourceMapConsumer.prototype.generatedPositionFor=function SourceMapConsumer_generatedPositionFor(aArgs){var source=util.getArg(aArgs,'source');source=this._findSourceIndex(source);if(source<0){return{line:null,column:null,lastColumn:null};}var needle={source:source,originalLine:util.getArg(aArgs,'line'),originalColumn:util.getArg(aArgs,'column')};var index=this._findMapping(needle,this._originalMappings,"originalLine","originalColumn",util.compareByOriginalPositions,util.getArg(aArgs,'bias',SourceMapConsumer.GREATEST_LOWER_BOUND));if(index>=0){var mapping=this._originalMappings[index];if(mapping.source===needle.source){return{line:util.getArg(mapping,'generatedLine',null),column:util.getArg(mapping,'generatedColumn',null),lastColumn:util.getArg(mapping,'lastGeneratedColumn',null)};}}return{line:null,column:null,lastColumn:null};};exports.BasicSourceMapConsumer=BasicSourceMapConsumer;/**
	 * An IndexedSourceMapConsumer instance represents a parsed source map which
	 * we can query for information. It differs from BasicSourceMapConsumer in
	 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	 * input.
	 *
	 * The first parameter is a raw source map (either as a JSON string, or already
	 * parsed to an object). According to the spec for indexed source maps, they
	 * have the following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - file: Optional. The generated file this source map is associated with.
	 *   - sections: A list of section definitions.
	 *
	 * Each value under the "sections" field has two fields:
	 *   - offset: The offset into the original specified at which this section
	 *       begins to apply, defined as an object with a "line" and "column"
	 *       field.
	 *   - map: A source map definition. This source map could also be indexed,
	 *       but doesn't have to be.
	 *
	 * Instead of the "map" field, it's also possible to have a "url" field
	 * specifying a URL to retrieve a source map from, but that's currently
	 * unsupported.
	 *
	 * Here's an example source map, taken from the source map spec[0], but
	 * modified to omit a section which uses the "url" field.
	 *
	 *  {
	 *    version : 3,
	 *    file: "app.js",
	 *    sections: [{
	 *      offset: {line:100, column:10},
	 *      map: {
	 *        version : 3,
	 *        file: "section.js",
	 *        sources: ["foo.js", "bar.js"],
	 *        names: ["src", "maps", "are", "fun"],
	 *        mappings: "AAAA,E;;ABCDE;"
	 *      }
	 *    }],
	 *  }
	 *
	 * The second parameter, if given, is a string whose value is the URL
	 * at which the source map was found.  This URL is used to compute the
	 * sources array.
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	 */function IndexedSourceMapConsumer(aSourceMap,aSourceMapURL){var sourceMap=aSourceMap;if(typeof aSourceMap==='string'){sourceMap=util.parseSourceMapInput(aSourceMap);}var version=util.getArg(sourceMap,'version');var sections=util.getArg(sourceMap,'sections');if(version!=this._version){throw new Error('Unsupported version: '+version);}this._sources=new ArraySet();this._names=new ArraySet();var lastOffset={line:-1,column:0};this._sections=sections.map(function(s){if(s.url){// The url field will require support for asynchronicity.
	// See https://github.com/mozilla/source-map/issues/16
	throw new Error('Support for url field in sections not implemented.');}var offset=util.getArg(s,'offset');var offsetLine=util.getArg(offset,'line');var offsetColumn=util.getArg(offset,'column');if(offsetLine<lastOffset.line||offsetLine===lastOffset.line&&offsetColumn<lastOffset.column){throw new Error('Section offsets must be ordered and non-overlapping.');}lastOffset=offset;return{generatedOffset:{// The offset fields are 0-based, but we use 1-based indices when
	// encoding/decoding from VLQ.
	generatedLine:offsetLine+1,generatedColumn:offsetColumn+1},consumer:new SourceMapConsumer(util.getArg(s,'map'),aSourceMapURL)};});}IndexedSourceMapConsumer.prototype=Object.create(SourceMapConsumer.prototype);IndexedSourceMapConsumer.prototype.constructor=SourceMapConsumer;/**
	 * The version of the source mapping spec that we are consuming.
	 */IndexedSourceMapConsumer.prototype._version=3;/**
	 * The list of original sources.
	 */Object.defineProperty(IndexedSourceMapConsumer.prototype,'sources',{get:function get(){var sources=[];for(var i=0;i<this._sections.length;i++){for(var j=0;j<this._sections[i].consumer.sources.length;j++){sources.push(this._sections[i].consumer.sources[j]);}}return sources;}});/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.  The line number
	 *     is 1-based.
	 *   - column: The column number in the generated source.  The column
	 *     number is 0-based.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.  The
	 *     line number is 1-based.
	 *   - column: The column number in the original source, or null.  The
	 *     column number is 0-based.
	 *   - name: The original identifier, or null.
	 */IndexedSourceMapConsumer.prototype.originalPositionFor=function IndexedSourceMapConsumer_originalPositionFor(aArgs){var needle={generatedLine:util.getArg(aArgs,'line'),generatedColumn:util.getArg(aArgs,'column')};// Find the section containing the generated position we're trying to map
	// to an original position.
	var sectionIndex=binarySearch.search(needle,this._sections,function(needle,section){var cmp=needle.generatedLine-section.generatedOffset.generatedLine;if(cmp){return cmp;}return needle.generatedColumn-section.generatedOffset.generatedColumn;});var section=this._sections[sectionIndex];if(!section){return{source:null,line:null,column:null,name:null};}return section.consumer.originalPositionFor({line:needle.generatedLine-(section.generatedOffset.generatedLine-1),column:needle.generatedColumn-(section.generatedOffset.generatedLine===needle.generatedLine?section.generatedOffset.generatedColumn-1:0),bias:aArgs.bias});};/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */IndexedSourceMapConsumer.prototype.hasContentsOfAllSources=function IndexedSourceMapConsumer_hasContentsOfAllSources(){return this._sections.every(function(s){return s.consumer.hasContentsOfAllSources();});};/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */IndexedSourceMapConsumer.prototype.sourceContentFor=function IndexedSourceMapConsumer_sourceContentFor(aSource,nullOnMissing){for(var i=0;i<this._sections.length;i++){var section=this._sections[i];var content=section.consumer.sourceContentFor(aSource,true);if(content){return content;}}if(nullOnMissing){return null;}else{throw new Error('"'+aSource+'" is not in the SourceMap.');}};/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.  The line number
	 *     is 1-based.
	 *   - column: The column number in the original source.  The column
	 *     number is 0-based.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.  The
	 *     line number is 1-based. 
	 *   - column: The column number in the generated source, or null.
	 *     The column number is 0-based.
	 */IndexedSourceMapConsumer.prototype.generatedPositionFor=function IndexedSourceMapConsumer_generatedPositionFor(aArgs){for(var i=0;i<this._sections.length;i++){var section=this._sections[i];// Only consider this section if the requested source is in the list of
	// sources of the consumer.
	if(section.consumer._findSourceIndex(util.getArg(aArgs,'source'))===-1){continue;}var generatedPosition=section.consumer.generatedPositionFor(aArgs);if(generatedPosition){var ret={line:generatedPosition.line+(section.generatedOffset.generatedLine-1),column:generatedPosition.column+(section.generatedOffset.generatedLine===generatedPosition.line?section.generatedOffset.generatedColumn-1:0)};return ret;}}return{line:null,column:null};};/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */IndexedSourceMapConsumer.prototype._parseMappings=function IndexedSourceMapConsumer_parseMappings(aStr,aSourceRoot){this.__generatedMappings=[];this.__originalMappings=[];for(var i=0;i<this._sections.length;i++){var section=this._sections[i];var sectionMappings=section.consumer._generatedMappings;for(var j=0;j<sectionMappings.length;j++){var mapping=sectionMappings[j];var source=section.consumer._sources.at(mapping.source);source=util.computeSourceURL(section.consumer.sourceRoot,source,this._sourceMapURL);this._sources.add(source);source=this._sources.indexOf(source);var name=null;if(mapping.name){name=section.consumer._names.at(mapping.name);this._names.add(name);name=this._names.indexOf(name);}// The mappings coming from the consumer for the section have
	// generated positions relative to the start of the section, so we
	// need to offset them to be relative to the start of the concatenated
	// generated file.
	var adjustedMapping={source:source,generatedLine:mapping.generatedLine+(section.generatedOffset.generatedLine-1),generatedColumn:mapping.generatedColumn+(section.generatedOffset.generatedLine===mapping.generatedLine?section.generatedOffset.generatedColumn-1:0),originalLine:mapping.originalLine,originalColumn:mapping.originalColumn,name:name};this.__generatedMappings.push(adjustedMapping);if(typeof adjustedMapping.originalLine==='number'){this.__originalMappings.push(adjustedMapping);}}}quickSort(this.__generatedMappings,util.compareByGeneratedPositionsDeflated);quickSort(this.__originalMappings,util.compareByOriginalPositions);};exports.IndexedSourceMapConsumer=IndexedSourceMapConsumer;},{"./array-set":198,"./base64-vlq":199,"./binary-search":201,"./quick-sort":203,"./util":207}],205:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var base64VLQ=require('./base64-vlq');var util=require('./util');var ArraySet=require('./array-set').ArraySet;var MappingList=require('./mapping-list').MappingList;/**
	 * An instance of the SourceMapGenerator represents a source map which is
	 * being built incrementally. You may pass an object with the following
	 * properties:
	 *
	 *   - file: The filename of the generated source.
	 *   - sourceRoot: A root for all relative URLs in this source map.
	 */function SourceMapGenerator(aArgs){if(!aArgs){aArgs={};}this._file=util.getArg(aArgs,'file',null);this._sourceRoot=util.getArg(aArgs,'sourceRoot',null);this._skipValidation=util.getArg(aArgs,'skipValidation',false);this._sources=new ArraySet();this._names=new ArraySet();this._mappings=new MappingList();this._sourcesContents=null;}SourceMapGenerator.prototype._version=3;/**
	 * Creates a new SourceMapGenerator based on a SourceMapConsumer
	 *
	 * @param aSourceMapConsumer The SourceMap.
	 */SourceMapGenerator.fromSourceMap=function SourceMapGenerator_fromSourceMap(aSourceMapConsumer){var sourceRoot=aSourceMapConsumer.sourceRoot;var generator=new SourceMapGenerator({file:aSourceMapConsumer.file,sourceRoot:sourceRoot});aSourceMapConsumer.eachMapping(function(mapping){var newMapping={generated:{line:mapping.generatedLine,column:mapping.generatedColumn}};if(mapping.source!=null){newMapping.source=mapping.source;if(sourceRoot!=null){newMapping.source=util.relative(sourceRoot,newMapping.source);}newMapping.original={line:mapping.originalLine,column:mapping.originalColumn};if(mapping.name!=null){newMapping.name=mapping.name;}}generator.addMapping(newMapping);});aSourceMapConsumer.sources.forEach(function(sourceFile){var sourceRelative=sourceFile;if(sourceRoot!==null){sourceRelative=util.relative(sourceRoot,sourceFile);}if(!generator._sources.has(sourceRelative)){generator._sources.add(sourceRelative);}var content=aSourceMapConsumer.sourceContentFor(sourceFile);if(content!=null){generator.setSourceContent(sourceFile,content);}});return generator;};/**
	 * Add a single mapping from original source line and column to the generated
	 * source's line and column for this source map being created. The mapping
	 * object should have the following properties:
	 *
	 *   - generated: An object with the generated line and column positions.
	 *   - original: An object with the original line and column positions.
	 *   - source: The original source file (relative to the sourceRoot).
	 *   - name: An optional original token name for this mapping.
	 */SourceMapGenerator.prototype.addMapping=function SourceMapGenerator_addMapping(aArgs){var generated=util.getArg(aArgs,'generated');var original=util.getArg(aArgs,'original',null);var source=util.getArg(aArgs,'source',null);var name=util.getArg(aArgs,'name',null);if(!this._skipValidation){this._validateMapping(generated,original,source,name);}if(source!=null){source=String(source);if(!this._sources.has(source)){this._sources.add(source);}}if(name!=null){name=String(name);if(!this._names.has(name)){this._names.add(name);}}this._mappings.add({generatedLine:generated.line,generatedColumn:generated.column,originalLine:original!=null&&original.line,originalColumn:original!=null&&original.column,source:source,name:name});};/**
	 * Set the source content for a source file.
	 */SourceMapGenerator.prototype.setSourceContent=function SourceMapGenerator_setSourceContent(aSourceFile,aSourceContent){var source=aSourceFile;if(this._sourceRoot!=null){source=util.relative(this._sourceRoot,source);}if(aSourceContent!=null){// Add the source content to the _sourcesContents map.
	// Create a new _sourcesContents map if the property is null.
	if(!this._sourcesContents){this._sourcesContents=Object.create(null);}this._sourcesContents[util.toSetString(source)]=aSourceContent;}else if(this._sourcesContents){// Remove the source file from the _sourcesContents map.
	// If the _sourcesContents map is empty, set the property to null.
	delete this._sourcesContents[util.toSetString(source)];if(Object.keys(this._sourcesContents).length===0){this._sourcesContents=null;}}};/**
	 * Applies the mappings of a sub-source-map for a specific source file to the
	 * source map being generated. Each mapping to the supplied source file is
	 * rewritten using the supplied source map. Note: The resolution for the
	 * resulting mappings is the minimium of this map and the supplied map.
	 *
	 * @param aSourceMapConsumer The source map to be applied.
	 * @param aSourceFile Optional. The filename of the source file.
	 *        If omitted, SourceMapConsumer's file property will be used.
	 * @param aSourceMapPath Optional. The dirname of the path to the source map
	 *        to be applied. If relative, it is relative to the SourceMapConsumer.
	 *        This parameter is needed when the two source maps aren't in the same
	 *        directory, and the source map to be applied contains relative source
	 *        paths. If so, those relative source paths need to be rewritten
	 *        relative to the SourceMapGenerator.
	 */SourceMapGenerator.prototype.applySourceMap=function SourceMapGenerator_applySourceMap(aSourceMapConsumer,aSourceFile,aSourceMapPath){var sourceFile=aSourceFile;// If aSourceFile is omitted, we will use the file property of the SourceMap
	if(aSourceFile==null){if(aSourceMapConsumer.file==null){throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, '+'or the source map\'s "file" property. Both were omitted.');}sourceFile=aSourceMapConsumer.file;}var sourceRoot=this._sourceRoot;// Make "sourceFile" relative if an absolute Url is passed.
	if(sourceRoot!=null){sourceFile=util.relative(sourceRoot,sourceFile);}// Applying the SourceMap can add and remove items from the sources and
	// the names array.
	var newSources=new ArraySet();var newNames=new ArraySet();// Find mappings for the "sourceFile"
	this._mappings.unsortedForEach(function(mapping){if(mapping.source===sourceFile&&mapping.originalLine!=null){// Check if it can be mapped by the source map, then update the mapping.
	var original=aSourceMapConsumer.originalPositionFor({line:mapping.originalLine,column:mapping.originalColumn});if(original.source!=null){// Copy mapping
	mapping.source=original.source;if(aSourceMapPath!=null){mapping.source=util.join(aSourceMapPath,mapping.source);}if(sourceRoot!=null){mapping.source=util.relative(sourceRoot,mapping.source);}mapping.originalLine=original.line;mapping.originalColumn=original.column;if(original.name!=null){mapping.name=original.name;}}}var source=mapping.source;if(source!=null&&!newSources.has(source)){newSources.add(source);}var name=mapping.name;if(name!=null&&!newNames.has(name)){newNames.add(name);}},this);this._sources=newSources;this._names=newNames;// Copy sourcesContents of applied map.
	aSourceMapConsumer.sources.forEach(function(sourceFile){var content=aSourceMapConsumer.sourceContentFor(sourceFile);if(content!=null){if(aSourceMapPath!=null){sourceFile=util.join(aSourceMapPath,sourceFile);}if(sourceRoot!=null){sourceFile=util.relative(sourceRoot,sourceFile);}this.setSourceContent(sourceFile,content);}},this);};/**
	 * A mapping can have one of the three levels of data:
	 *
	 *   1. Just the generated position.
	 *   2. The Generated position, original position, and original source.
	 *   3. Generated and original position, original source, as well as a name
	 *      token.
	 *
	 * To maintain consistency, we validate that any new mapping being added falls
	 * in to one of these categories.
	 */SourceMapGenerator.prototype._validateMapping=function SourceMapGenerator_validateMapping(aGenerated,aOriginal,aSource,aName){// When aOriginal is truthy but has empty values for .line and .column,
	// it is most likely a programmer error. In this case we throw a very
	// specific error message to try to guide them the right way.
	// For example: https://github.com/Polymer/polymer-bundler/pull/519
	if(aOriginal&&typeof aOriginal.line!=='number'&&typeof aOriginal.column!=='number'){throw new Error('original.line and original.column are not numbers -- you probably meant to omit '+'the original mapping entirely and only map the generated position. If so, pass '+'null for the original mapping instead of an object with empty or null values.');}if(aGenerated&&'line'in aGenerated&&'column'in aGenerated&&aGenerated.line>0&&aGenerated.column>=0&&!aOriginal&&!aSource&&!aName){// Case 1.
	return;}else if(aGenerated&&'line'in aGenerated&&'column'in aGenerated&&aOriginal&&'line'in aOriginal&&'column'in aOriginal&&aGenerated.line>0&&aGenerated.column>=0&&aOriginal.line>0&&aOriginal.column>=0&&aSource){// Cases 2 and 3.
	return;}else{throw new Error('Invalid mapping: '+JSON.stringify({generated:aGenerated,source:aSource,original:aOriginal,name:aName}));}};/**
	 * Serialize the accumulated mappings in to the stream of base 64 VLQs
	 * specified by the source map format.
	 */SourceMapGenerator.prototype._serializeMappings=function SourceMapGenerator_serializeMappings(){var previousGeneratedColumn=0;var previousGeneratedLine=1;var previousOriginalColumn=0;var previousOriginalLine=0;var previousName=0;var previousSource=0;var result='';var next;var mapping;var nameIdx;var sourceIdx;var mappings=this._mappings.toArray();for(var i=0,len=mappings.length;i<len;i++){mapping=mappings[i];next='';if(mapping.generatedLine!==previousGeneratedLine){previousGeneratedColumn=0;while(mapping.generatedLine!==previousGeneratedLine){next+=';';previousGeneratedLine++;}}else{if(i>0){if(!util.compareByGeneratedPositionsInflated(mapping,mappings[i-1])){continue;}next+=',';}}next+=base64VLQ.encode(mapping.generatedColumn-previousGeneratedColumn);previousGeneratedColumn=mapping.generatedColumn;if(mapping.source!=null){sourceIdx=this._sources.indexOf(mapping.source);next+=base64VLQ.encode(sourceIdx-previousSource);previousSource=sourceIdx;// lines are stored 0-based in SourceMap spec version 3
	next+=base64VLQ.encode(mapping.originalLine-1-previousOriginalLine);previousOriginalLine=mapping.originalLine-1;next+=base64VLQ.encode(mapping.originalColumn-previousOriginalColumn);previousOriginalColumn=mapping.originalColumn;if(mapping.name!=null){nameIdx=this._names.indexOf(mapping.name);next+=base64VLQ.encode(nameIdx-previousName);previousName=nameIdx;}}result+=next;}return result;};SourceMapGenerator.prototype._generateSourcesContent=function SourceMapGenerator_generateSourcesContent(aSources,aSourceRoot){return aSources.map(function(source){if(!this._sourcesContents){return null;}if(aSourceRoot!=null){source=util.relative(aSourceRoot,source);}var key=util.toSetString(source);return Object.prototype.hasOwnProperty.call(this._sourcesContents,key)?this._sourcesContents[key]:null;},this);};/**
	 * Externalize the source map.
	 */SourceMapGenerator.prototype.toJSON=function SourceMapGenerator_toJSON(){var map={version:this._version,sources:this._sources.toArray(),names:this._names.toArray(),mappings:this._serializeMappings()};if(this._file!=null){map.file=this._file;}if(this._sourceRoot!=null){map.sourceRoot=this._sourceRoot;}if(this._sourcesContents){map.sourcesContent=this._generateSourcesContent(map.sources,map.sourceRoot);}return map;};/**
	 * Render the source map being generated to a string.
	 */SourceMapGenerator.prototype.toString=function SourceMapGenerator_toString(){return JSON.stringify(this.toJSON());};exports.SourceMapGenerator=SourceMapGenerator;},{"./array-set":198,"./base64-vlq":199,"./mapping-list":202,"./util":207}],206:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */var SourceMapGenerator=require('./source-map-generator').SourceMapGenerator;var util=require('./util');// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
	// operating systems these days (capturing the result).
	var REGEX_NEWLINE=/(\r?\n)/;// Newline character code for charCodeAt() comparisons
	var NEWLINE_CODE=10;// Private symbol for identifying `SourceNode`s when multiple versions of
	// the source-map library are loaded. This MUST NOT CHANGE across
	// versions!
	var isSourceNode="$$$isSourceNode$$$";/**
	 * SourceNodes provide a way to abstract over interpolating/concatenating
	 * snippets of generated JavaScript source code while maintaining the line and
	 * column information associated with the original source code.
	 *
	 * @param aLine The original line number.
	 * @param aColumn The original column number.
	 * @param aSource The original source's filename.
	 * @param aChunks Optional. An array of strings which are snippets of
	 *        generated JS, or other SourceNodes.
	 * @param aName The original identifier.
	 */function SourceNode(aLine,aColumn,aSource,aChunks,aName){this.children=[];this.sourceContents={};this.line=aLine==null?null:aLine;this.column=aColumn==null?null:aColumn;this.source=aSource==null?null:aSource;this.name=aName==null?null:aName;this[isSourceNode]=true;if(aChunks!=null)this.add(aChunks);}/**
	 * Creates a SourceNode from generated code and a SourceMapConsumer.
	 *
	 * @param aGeneratedCode The generated code
	 * @param aSourceMapConsumer The SourceMap for the generated code
	 * @param aRelativePath Optional. The path that relative sources in the
	 *        SourceMapConsumer should be relative to.
	 */SourceNode.fromStringWithSourceMap=function SourceNode_fromStringWithSourceMap(aGeneratedCode,aSourceMapConsumer,aRelativePath){// The SourceNode we want to fill with the generated code
	// and the SourceMap
	var node=new SourceNode();// All even indices of this array are one line of the generated code,
	// while all odd indices are the newlines between two adjacent lines
	// (since `REGEX_NEWLINE` captures its match).
	// Processed fragments are accessed by calling `shiftNextLine`.
	var remainingLines=aGeneratedCode.split(REGEX_NEWLINE);var remainingLinesIndex=0;var shiftNextLine=function shiftNextLine(){var lineContents=getNextLine();// The last line of a file might not have a newline.
	var newLine=getNextLine()||"";return lineContents+newLine;function getNextLine(){return remainingLinesIndex<remainingLines.length?remainingLines[remainingLinesIndex++]:undefined;}};// We need to remember the position of "remainingLines"
	var lastGeneratedLine=1,lastGeneratedColumn=0;// The generate SourceNodes we need a code range.
	// To extract it current and last mapping is used.
	// Here we store the last mapping.
	var lastMapping=null;aSourceMapConsumer.eachMapping(function(mapping){if(lastMapping!==null){// We add the code from "lastMapping" to "mapping":
	// First check if there is a new line in between.
	if(lastGeneratedLine<mapping.generatedLine){// Associate first line with "lastMapping"
	addMappingWithCode(lastMapping,shiftNextLine());lastGeneratedLine++;lastGeneratedColumn=0;// The remaining code is added without mapping
	}else{// There is no new line in between.
	// Associate the code between "lastGeneratedColumn" and
	// "mapping.generatedColumn" with "lastMapping"
	var nextLine=remainingLines[remainingLinesIndex]||'';var code=nextLine.substr(0,mapping.generatedColumn-lastGeneratedColumn);remainingLines[remainingLinesIndex]=nextLine.substr(mapping.generatedColumn-lastGeneratedColumn);lastGeneratedColumn=mapping.generatedColumn;addMappingWithCode(lastMapping,code);// No more remaining code, continue
	lastMapping=mapping;return;}}// We add the generated code until the first mapping
	// to the SourceNode without any mapping.
	// Each line is added as separate string.
	while(lastGeneratedLine<mapping.generatedLine){node.add(shiftNextLine());lastGeneratedLine++;}if(lastGeneratedColumn<mapping.generatedColumn){var nextLine=remainingLines[remainingLinesIndex]||'';node.add(nextLine.substr(0,mapping.generatedColumn));remainingLines[remainingLinesIndex]=nextLine.substr(mapping.generatedColumn);lastGeneratedColumn=mapping.generatedColumn;}lastMapping=mapping;},this);// We have processed all mappings.
	if(remainingLinesIndex<remainingLines.length){if(lastMapping){// Associate the remaining code in the current line with "lastMapping"
	addMappingWithCode(lastMapping,shiftNextLine());}// and add the remaining lines without any mapping
	node.add(remainingLines.splice(remainingLinesIndex).join(""));}// Copy sourcesContent into SourceNode
	aSourceMapConsumer.sources.forEach(function(sourceFile){var content=aSourceMapConsumer.sourceContentFor(sourceFile);if(content!=null){if(aRelativePath!=null){sourceFile=util.join(aRelativePath,sourceFile);}node.setSourceContent(sourceFile,content);}});return node;function addMappingWithCode(mapping,code){if(mapping===null||mapping.source===undefined){node.add(code);}else{var source=aRelativePath?util.join(aRelativePath,mapping.source):mapping.source;node.add(new SourceNode(mapping.originalLine,mapping.originalColumn,source,code,mapping.name));}}};/**
	 * Add a chunk of generated JS to this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */SourceNode.prototype.add=function SourceNode_add(aChunk){if(Array.isArray(aChunk)){aChunk.forEach(function(chunk){this.add(chunk);},this);}else if(aChunk[isSourceNode]||typeof aChunk==="string"){if(aChunk){this.children.push(aChunk);}}else{throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got "+aChunk);}return this;};/**
	 * Add a chunk of generated JS to the beginning of this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */SourceNode.prototype.prepend=function SourceNode_prepend(aChunk){if(Array.isArray(aChunk)){for(var i=aChunk.length-1;i>=0;i--){this.prepend(aChunk[i]);}}else if(aChunk[isSourceNode]||typeof aChunk==="string"){this.children.unshift(aChunk);}else{throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got "+aChunk);}return this;};/**
	 * Walk over the tree of JS snippets in this node and its children. The
	 * walking function is called once for each snippet of JS and is passed that
	 * snippet and the its original associated source's line/column location.
	 *
	 * @param aFn The traversal function.
	 */SourceNode.prototype.walk=function SourceNode_walk(aFn){var chunk;for(var i=0,len=this.children.length;i<len;i++){chunk=this.children[i];if(chunk[isSourceNode]){chunk.walk(aFn);}else{if(chunk!==''){aFn(chunk,{source:this.source,line:this.line,column:this.column,name:this.name});}}}};/**
	 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
	 * each of `this.children`.
	 *
	 * @param aSep The separator.
	 */SourceNode.prototype.join=function SourceNode_join(aSep){var newChildren;var i;var len=this.children.length;if(len>0){newChildren=[];for(i=0;i<len-1;i++){newChildren.push(this.children[i]);newChildren.push(aSep);}newChildren.push(this.children[i]);this.children=newChildren;}return this;};/**
	 * Call String.prototype.replace on the very right-most source snippet. Useful
	 * for trimming whitespace from the end of a source node, etc.
	 *
	 * @param aPattern The pattern to replace.
	 * @param aReplacement The thing to replace the pattern with.
	 */SourceNode.prototype.replaceRight=function SourceNode_replaceRight(aPattern,aReplacement){var lastChild=this.children[this.children.length-1];if(lastChild[isSourceNode]){lastChild.replaceRight(aPattern,aReplacement);}else if(typeof lastChild==='string'){this.children[this.children.length-1]=lastChild.replace(aPattern,aReplacement);}else{this.children.push(''.replace(aPattern,aReplacement));}return this;};/**
	 * Set the source content for a source file. This will be added to the SourceMapGenerator
	 * in the sourcesContent field.
	 *
	 * @param aSourceFile The filename of the source file
	 * @param aSourceContent The content of the source file
	 */SourceNode.prototype.setSourceContent=function SourceNode_setSourceContent(aSourceFile,aSourceContent){this.sourceContents[util.toSetString(aSourceFile)]=aSourceContent;};/**
	 * Walk over the tree of SourceNodes. The walking function is called for each
	 * source file content and is passed the filename and source content.
	 *
	 * @param aFn The traversal function.
	 */SourceNode.prototype.walkSourceContents=function SourceNode_walkSourceContents(aFn){for(var i=0,len=this.children.length;i<len;i++){if(this.children[i][isSourceNode]){this.children[i].walkSourceContents(aFn);}}var sources=Object.keys(this.sourceContents);for(var i=0,len=sources.length;i<len;i++){aFn(util.fromSetString(sources[i]),this.sourceContents[sources[i]]);}};/**
	 * Return the string representation of this source node. Walks over the tree
	 * and concatenates all the various snippets together to one string.
	 */SourceNode.prototype.toString=function SourceNode_toString(){var str="";this.walk(function(chunk){str+=chunk;});return str;};/**
	 * Returns the string representation of this source node along with a source
	 * map.
	 */SourceNode.prototype.toStringWithSourceMap=function SourceNode_toStringWithSourceMap(aArgs){var generated={code:"",line:1,column:0};var map=new SourceMapGenerator(aArgs);var sourceMappingActive=false;var lastOriginalSource=null;var lastOriginalLine=null;var lastOriginalColumn=null;var lastOriginalName=null;this.walk(function(chunk,original){generated.code+=chunk;if(original.source!==null&&original.line!==null&&original.column!==null){if(lastOriginalSource!==original.source||lastOriginalLine!==original.line||lastOriginalColumn!==original.column||lastOriginalName!==original.name){map.addMapping({source:original.source,original:{line:original.line,column:original.column},generated:{line:generated.line,column:generated.column},name:original.name});}lastOriginalSource=original.source;lastOriginalLine=original.line;lastOriginalColumn=original.column;lastOriginalName=original.name;sourceMappingActive=true;}else if(sourceMappingActive){map.addMapping({generated:{line:generated.line,column:generated.column}});lastOriginalSource=null;sourceMappingActive=false;}for(var idx=0,length=chunk.length;idx<length;idx++){if(chunk.charCodeAt(idx)===NEWLINE_CODE){generated.line++;generated.column=0;// Mappings end at eol
	if(idx+1===length){lastOriginalSource=null;sourceMappingActive=false;}else if(sourceMappingActive){map.addMapping({source:original.source,original:{line:original.line,column:original.column},generated:{line:generated.line,column:generated.column},name:original.name});}}else{generated.column++;}}});this.walkSourceContents(function(sourceFile,sourceContent){map.setSourceContent(sourceFile,sourceContent);});return{code:generated.code,map:map};};exports.SourceNode=SourceNode;},{"./source-map-generator":205,"./util":207}],207:[function(require,module,exports){/* -*- Mode: js; js-indent-level: 2; -*- */ /*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */ /**
	 * This is a helper function for getting values from parameter/options
	 * objects.
	 *
	 * @param args The object we are extracting values from
	 * @param name The name of the property we are getting.
	 * @param defaultValue An optional value to return if the property is missing
	 * from the object. If this is not specified and the property is missing, an
	 * error will be thrown.
	 */function getArg(aArgs,aName,aDefaultValue){if(aName in aArgs){return aArgs[aName];}else if(arguments.length===3){return aDefaultValue;}else{throw new Error('"'+aName+'" is a required argument.');}}exports.getArg=getArg;var urlRegexp=/^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;var dataUrlRegexp=/^data:.+\,.+$/;function urlParse(aUrl){var match=aUrl.match(urlRegexp);if(!match){return null;}return{scheme:match[1],auth:match[2],host:match[3],port:match[4],path:match[5]};}exports.urlParse=urlParse;function urlGenerate(aParsedUrl){var url='';if(aParsedUrl.scheme){url+=aParsedUrl.scheme+':';}url+='//';if(aParsedUrl.auth){url+=aParsedUrl.auth+'@';}if(aParsedUrl.host){url+=aParsedUrl.host;}if(aParsedUrl.port){url+=":"+aParsedUrl.port;}if(aParsedUrl.path){url+=aParsedUrl.path;}return url;}exports.urlGenerate=urlGenerate;/**
	 * Normalizes a path, or the path portion of a URL:
	 *
	 * - Replaces consecutive slashes with one slash.
	 * - Removes unnecessary '.' parts.
	 * - Removes unnecessary '<dir>/..' parts.
	 *
	 * Based on code in the Node.js 'path' core module.
	 *
	 * @param aPath The path or url to normalize.
	 */function normalize(aPath){var path=aPath;var url=urlParse(aPath);if(url){if(!url.path){return aPath;}path=url.path;}var isAbsolute=exports.isAbsolute(path);var parts=path.split(/\/+/);for(var part,up=0,i=parts.length-1;i>=0;i--){part=parts[i];if(part==='.'){parts.splice(i,1);}else if(part==='..'){up++;}else if(up>0){if(part===''){// The first part is blank if the path is absolute. Trying to go
	// above the root is a no-op. Therefore we can remove all '..' parts
	// directly after the root.
	parts.splice(i+1,up);up=0;}else{parts.splice(i,2);up--;}}}path=parts.join('/');if(path===''){path=isAbsolute?'/':'.';}if(url){url.path=path;return urlGenerate(url);}return path;}exports.normalize=normalize;/**
	 * Joins two paths/URLs.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be joined with the root.
	 *
	 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	 *   first.
	 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	 *   is updated with the result and aRoot is returned. Otherwise the result
	 *   is returned.
	 *   - If aPath is absolute, the result is aPath.
	 *   - Otherwise the two paths are joined with a slash.
	 * - Joining for example 'http://' and 'www.example.com' is also supported.
	 */function join(aRoot,aPath){if(aRoot===""){aRoot=".";}if(aPath===""){aPath=".";}var aPathUrl=urlParse(aPath);var aRootUrl=urlParse(aRoot);if(aRootUrl){aRoot=aRootUrl.path||'/';}// `join(foo, '//www.example.org')`
	if(aPathUrl&&!aPathUrl.scheme){if(aRootUrl){aPathUrl.scheme=aRootUrl.scheme;}return urlGenerate(aPathUrl);}if(aPathUrl||aPath.match(dataUrlRegexp)){return aPath;}// `join('http://', 'www.example.com')`
	if(aRootUrl&&!aRootUrl.host&&!aRootUrl.path){aRootUrl.host=aPath;return urlGenerate(aRootUrl);}var joined=aPath.charAt(0)==='/'?aPath:normalize(aRoot.replace(/\/+$/,'')+'/'+aPath);if(aRootUrl){aRootUrl.path=joined;return urlGenerate(aRootUrl);}return joined;}exports.join=join;exports.isAbsolute=function(aPath){return aPath.charAt(0)==='/'||urlRegexp.test(aPath);};/**
	 * Make a path relative to a URL or another path.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be made relative to aRoot.
	 */function relative(aRoot,aPath){if(aRoot===""){aRoot=".";}aRoot=aRoot.replace(/\/$/,'');// It is possible for the path to be above the root. In this case, simply
	// checking whether the root is a prefix of the path won't work. Instead, we
	// need to remove components from the root one by one, until either we find
	// a prefix that fits, or we run out of components to remove.
	var level=0;while(aPath.indexOf(aRoot+'/')!==0){var index=aRoot.lastIndexOf("/");if(index<0){return aPath;}// If the only part of the root that is left is the scheme (i.e. http://,
	// file:///, etc.), one or more slashes (/), or simply nothing at all, we
	// have exhausted all components, so the path is not relative to the root.
	aRoot=aRoot.slice(0,index);if(aRoot.match(/^([^\/]+:\/)?\/*$/)){return aPath;}++level;}// Make sure we add a "../" for each component we removed from the root.
	return Array(level+1).join("../")+aPath.substr(aRoot.length+1);}exports.relative=relative;var supportsNullProto=function(){var obj=Object.create(null);return!('__proto__'in obj);}();function identity(s){return s;}/**
	 * Because behavior goes wacky when you set `__proto__` on objects, we
	 * have to prefix all the strings in our set with an arbitrary character.
	 *
	 * See https://github.com/mozilla/source-map/pull/31 and
	 * https://github.com/mozilla/source-map/issues/30
	 *
	 * @param String aStr
	 */function toSetString(aStr){if(isProtoString(aStr)){return'$'+aStr;}return aStr;}exports.toSetString=supportsNullProto?identity:toSetString;function fromSetString(aStr){if(isProtoString(aStr)){return aStr.slice(1);}return aStr;}exports.fromSetString=supportsNullProto?identity:fromSetString;function isProtoString(s){if(!s){return false;}var length=s.length;if(length<9/* "__proto__".length */){return false;}if(s.charCodeAt(length-1)!==95/* '_' */||s.charCodeAt(length-2)!==95/* '_' */||s.charCodeAt(length-3)!==111/* 'o' */||s.charCodeAt(length-4)!==116/* 't' */||s.charCodeAt(length-5)!==111/* 'o' */||s.charCodeAt(length-6)!==114/* 'r' */||s.charCodeAt(length-7)!==112/* 'p' */||s.charCodeAt(length-8)!==95/* '_' */||s.charCodeAt(length-9)!==95/* '_' */){return false;}for(var i=length-10;i>=0;i--){if(s.charCodeAt(i)!==36/* '$' */){return false;}}return true;}/**
	 * Comparator between two mappings where the original positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same original source/line/column, but different generated
	 * line and column the same. Useful when searching for a mapping with a
	 * stubbed out mapping.
	 */function compareByOriginalPositions(mappingA,mappingB,onlyCompareOriginal){var cmp=strcmp(mappingA.source,mappingB.source);if(cmp!==0){return cmp;}cmp=mappingA.originalLine-mappingB.originalLine;if(cmp!==0){return cmp;}cmp=mappingA.originalColumn-mappingB.originalColumn;if(cmp!==0||onlyCompareOriginal){return cmp;}cmp=mappingA.generatedColumn-mappingB.generatedColumn;if(cmp!==0){return cmp;}cmp=mappingA.generatedLine-mappingB.generatedLine;if(cmp!==0){return cmp;}return strcmp(mappingA.name,mappingB.name);}exports.compareByOriginalPositions=compareByOriginalPositions;/**
	 * Comparator between two mappings with deflated source and name indices where
	 * the generated positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same generated line and column, but different
	 * source/name/original line and column the same. Useful when searching for a
	 * mapping with a stubbed out mapping.
	 */function compareByGeneratedPositionsDeflated(mappingA,mappingB,onlyCompareGenerated){var cmp=mappingA.generatedLine-mappingB.generatedLine;if(cmp!==0){return cmp;}cmp=mappingA.generatedColumn-mappingB.generatedColumn;if(cmp!==0||onlyCompareGenerated){return cmp;}cmp=strcmp(mappingA.source,mappingB.source);if(cmp!==0){return cmp;}cmp=mappingA.originalLine-mappingB.originalLine;if(cmp!==0){return cmp;}cmp=mappingA.originalColumn-mappingB.originalColumn;if(cmp!==0){return cmp;}return strcmp(mappingA.name,mappingB.name);}exports.compareByGeneratedPositionsDeflated=compareByGeneratedPositionsDeflated;function strcmp(aStr1,aStr2){if(aStr1===aStr2){return 0;}if(aStr1===null){return 1;// aStr2 !== null
	}if(aStr2===null){return-1;// aStr1 !== null
	}if(aStr1>aStr2){return 1;}return-1;}/**
	 * Comparator between two mappings with inflated source and name strings where
	 * the generated positions are compared.
	 */function compareByGeneratedPositionsInflated(mappingA,mappingB){var cmp=mappingA.generatedLine-mappingB.generatedLine;if(cmp!==0){return cmp;}cmp=mappingA.generatedColumn-mappingB.generatedColumn;if(cmp!==0){return cmp;}cmp=strcmp(mappingA.source,mappingB.source);if(cmp!==0){return cmp;}cmp=mappingA.originalLine-mappingB.originalLine;if(cmp!==0){return cmp;}cmp=mappingA.originalColumn-mappingB.originalColumn;if(cmp!==0){return cmp;}return strcmp(mappingA.name,mappingB.name);}exports.compareByGeneratedPositionsInflated=compareByGeneratedPositionsInflated;/**
	 * Strip any JSON XSSI avoidance prefix from the string (as documented
	 * in the source maps specification), and then parse the string as
	 * JSON.
	 */function parseSourceMapInput(str){return JSON.parse(str.replace(/^\)]}'[^\n]*\n/,''));}exports.parseSourceMapInput=parseSourceMapInput;/**
	 * Compute the URL of a source given the the source root, the source's
	 * URL, and the source map's URL.
	 */function computeSourceURL(sourceRoot,sourceURL,sourceMapURL){sourceURL=sourceURL||'';if(sourceRoot){// This follows what Chrome does.
	if(sourceRoot[sourceRoot.length-1]!=='/'&&sourceURL[0]!=='/'){sourceRoot+='/';}// The spec says:
	//   Line 4: An optional source root, useful for relocating source
	//   files on a server or removing repeated values in the
	//   “sources” entry.  This value is prepended to the individual
	//   entries in the “source” field.
	sourceURL=sourceRoot+sourceURL;}// Historically, SourceMapConsumer did not take the sourceMapURL as
	// a parameter.  This mode is still somewhat supported, which is why
	// this code block is conditional.  However, it's preferable to pass
	// the source map URL to SourceMapConsumer, so that this function
	// can implement the source URL resolution algorithm as outlined in
	// the spec.  This block is basically the equivalent of:
	//    new URL(sourceURL, sourceMapURL).toString()
	// ... except it avoids using URL, which wasn't available in the
	// older releases of node still supported by this library.
	//
	// The spec says:
	//   If the sources are not absolute URLs after prepending of the
	//   “sourceRoot”, the sources are resolved relative to the
	//   SourceMap (like resolving script src in a html document).
	if(sourceMapURL){var parsed=urlParse(sourceMapURL);if(!parsed){throw new Error("sourceMapURL could not be parsed");}if(parsed.path){// Strip the last path component, but keep the "/".
	var index=parsed.path.lastIndexOf('/');if(index>=0){parsed.path=parsed.path.substring(0,index+1);}}sourceURL=join(urlGenerate(parsed),sourceURL);}return normalize(sourceURL);}exports.computeSourceURL=computeSourceURL;},{}],208:[function(require,module,exports){/*
	 * Copyright 2009-2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE.txt or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */exports.SourceMapGenerator=require('./lib/source-map-generator').SourceMapGenerator;exports.SourceMapConsumer=require('./lib/source-map-consumer').SourceMapConsumer;exports.SourceNode=require('./lib/source-node').SourceNode;},{"./lib/source-map-consumer":204,"./lib/source-map-generator":205,"./lib/source-node":206}],209:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	'use strict';var punycode=require('punycode');var util=require('./util');exports.parse=urlParse;exports.resolve=urlResolve;exports.resolveObject=urlResolveObject;exports.format=urlFormat;exports.Url=Url;function Url(){this.protocol=null;this.slashes=null;this.auth=null;this.host=null;this.port=null;this.hostname=null;this.hash=null;this.search=null;this.query=null;this.pathname=null;this.path=null;this.href=null;}// Reference: RFC 3986, RFC 1808, RFC 2396
	// define these here so at least they only have to be
	// compiled once on the first module load.
	var protocolPattern=/^([a-z0-9.+-]+:)/i,portPattern=/:[0-9]*$/,// Special case for a simple path URL
	simplePathPattern=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,// RFC 2396: characters reserved for delimiting URLs.
	// We actually just auto-escape these.
	delims=['<','>','"','`',' ','\r','\n','\t'],// RFC 2396: characters not allowed for various reasons.
	unwise=['{','}','|','\\','^','`'].concat(delims),// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	autoEscape=['\''].concat(unwise),// Characters that are never ever allowed in a hostname.
	// Note that any invalid chars are also handled, but these
	// are the ones that are *expected* to be seen, so we fast-path
	// them.
	nonHostChars=['%','/','?',';','#'].concat(autoEscape),hostEndingChars=['/','?','#'],hostnameMaxLen=255,hostnamePartPattern=/^[+a-z0-9A-Z_-]{0,63}$/,hostnamePartStart=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,// protocols that can allow "unsafe" and "unwise" chars.
	unsafeProtocol={'javascript':true,'javascript:':true},// protocols that never have a hostname.
	hostlessProtocol={'javascript':true,'javascript:':true},// protocols that always contain a // bit.
	slashedProtocol={'http':true,'https':true,'ftp':true,'gopher':true,'file':true,'http:':true,'https:':true,'ftp:':true,'gopher:':true,'file:':true},querystring=require('querystring');function urlParse(url,parseQueryString,slashesDenoteHost){if(url&&util.isObject(url)&&url instanceof Url)return url;var u=new Url();u.parse(url,parseQueryString,slashesDenoteHost);return u;}Url.prototype.parse=function(url,parseQueryString,slashesDenoteHost){if(!util.isString(url)){throw new TypeError("Parameter 'url' must be a string, not "+_typeof(url));}// Copy chrome, IE, opera backslash-handling behavior.
	// Back slashes before the query string get converted to forward slashes
	// See: https://code.google.com/p/chromium/issues/detail?id=25916
	var queryIndex=url.indexOf('?'),splitter=queryIndex!==-1&&queryIndex<url.indexOf('#')?'?':'#',uSplit=url.split(splitter),slashRegex=/\\/g;uSplit[0]=uSplit[0].replace(slashRegex,'/');url=uSplit.join(splitter);var rest=url;// trim before proceeding.
	// This is to support parse stuff like "  http://foo.com  \n"
	rest=rest.trim();if(!slashesDenoteHost&&url.split('#').length===1){// Try fast path regexp
	var simplePath=simplePathPattern.exec(rest);if(simplePath){this.path=rest;this.href=rest;this.pathname=simplePath[1];if(simplePath[2]){this.search=simplePath[2];if(parseQueryString){this.query=querystring.parse(this.search.substr(1));}else{this.query=this.search.substr(1);}}else if(parseQueryString){this.search='';this.query={};}return this;}}var proto=protocolPattern.exec(rest);if(proto){proto=proto[0];var lowerProto=proto.toLowerCase();this.protocol=lowerProto;rest=rest.substr(proto.length);}// figure out if it's got a host
	// user@server is *always* interpreted as a hostname, and url
	// resolution will treat //foo/bar as host=foo,path=bar because that's
	// how the browser resolves relative URLs.
	if(slashesDenoteHost||proto||rest.match(/^\/\/[^@\/]+@[^@\/]+/)){var slashes=rest.substr(0,2)==='//';if(slashes&&!(proto&&hostlessProtocol[proto])){rest=rest.substr(2);this.slashes=true;}}if(!hostlessProtocol[proto]&&(slashes||proto&&!slashedProtocol[proto])){// there's a hostname.
	// the first instance of /, ?, ;, or # ends the host.
	//
	// If there is an @ in the hostname, then non-host chars *are* allowed
	// to the left of the last @ sign, unless some host-ending character
	// comes *before* the @-sign.
	// URLs are obnoxious.
	//
	// ex:
	// http://a@b@c/ => user:a@b host:c
	// http://a@b?@c => user:a host:c path:/?@c
	// v0.12 TODO(isaacs): This is not quite how Chrome does things.
	// Review our test case against browsers more comprehensively.
	// find the first instance of any hostEndingChars
	var hostEnd=-1;for(var i=0;i<hostEndingChars.length;i++){var hec=rest.indexOf(hostEndingChars[i]);if(hec!==-1&&(hostEnd===-1||hec<hostEnd))hostEnd=hec;}// at this point, either we have an explicit point where the
	// auth portion cannot go past, or the last @ char is the decider.
	var auth,atSign;if(hostEnd===-1){// atSign can be anywhere.
	atSign=rest.lastIndexOf('@');}else{// atSign must be in auth portion.
	// http://a@b/c@d => host:b auth:a path:/c@d
	atSign=rest.lastIndexOf('@',hostEnd);}// Now we have a portion which is definitely the auth.
	// Pull that off.
	if(atSign!==-1){auth=rest.slice(0,atSign);rest=rest.slice(atSign+1);this.auth=decodeURIComponent(auth);}// the host is the remaining to the left of the first non-host char
	hostEnd=-1;for(var i=0;i<nonHostChars.length;i++){var hec=rest.indexOf(nonHostChars[i]);if(hec!==-1&&(hostEnd===-1||hec<hostEnd))hostEnd=hec;}// if we still have not hit it, then the entire thing is a host.
	if(hostEnd===-1)hostEnd=rest.length;this.host=rest.slice(0,hostEnd);rest=rest.slice(hostEnd);// pull out port.
	this.parseHost();// we've indicated that there is a hostname,
	// so even if it's empty, it has to be present.
	this.hostname=this.hostname||'';// if hostname begins with [ and ends with ]
	// assume that it's an IPv6 address.
	var ipv6Hostname=this.hostname[0]==='['&&this.hostname[this.hostname.length-1]===']';// validate a little.
	if(!ipv6Hostname){var hostparts=this.hostname.split(/\./);for(var i=0,l=hostparts.length;i<l;i++){var part=hostparts[i];if(!part)continue;if(!part.match(hostnamePartPattern)){var newpart='';for(var j=0,k=part.length;j<k;j++){if(part.charCodeAt(j)>127){// we replace non-ASCII char with a temporary placeholder
	// we need this to make sure size of hostname is not
	// broken by replacing non-ASCII by nothing
	newpart+='x';}else{newpart+=part[j];}}// we test again with ASCII char only
	if(!newpart.match(hostnamePartPattern)){var validParts=hostparts.slice(0,i);var notHost=hostparts.slice(i+1);var bit=part.match(hostnamePartStart);if(bit){validParts.push(bit[1]);notHost.unshift(bit[2]);}if(notHost.length){rest='/'+notHost.join('.')+rest;}this.hostname=validParts.join('.');break;}}}}if(this.hostname.length>hostnameMaxLen){this.hostname='';}else{// hostnames are always lower case.
	this.hostname=this.hostname.toLowerCase();}if(!ipv6Hostname){// IDNA Support: Returns a punycoded representation of "domain".
	// It only converts parts of the domain name that
	// have non-ASCII characters, i.e. it doesn't matter if
	// you call it with a domain that already is ASCII-only.
	this.hostname=punycode.toASCII(this.hostname);}var p=this.port?':'+this.port:'';var h=this.hostname||'';this.host=h+p;this.href+=this.host;// strip [ and ] from the hostname
	// the host field still retains them, though
	if(ipv6Hostname){this.hostname=this.hostname.substr(1,this.hostname.length-2);if(rest[0]!=='/'){rest='/'+rest;}}}// now rest is set to the post-host stuff.
	// chop off any delim chars.
	if(!unsafeProtocol[lowerProto]){// First, make 100% sure that any "autoEscape" chars get
	// escaped, even if encodeURIComponent doesn't think they
	// need to be.
	for(var i=0,l=autoEscape.length;i<l;i++){var ae=autoEscape[i];if(rest.indexOf(ae)===-1)continue;var esc=encodeURIComponent(ae);if(esc===ae){esc=escape(ae);}rest=rest.split(ae).join(esc);}}// chop off from the tail first.
	var hash=rest.indexOf('#');if(hash!==-1){// got a fragment string.
	this.hash=rest.substr(hash);rest=rest.slice(0,hash);}var qm=rest.indexOf('?');if(qm!==-1){this.search=rest.substr(qm);this.query=rest.substr(qm+1);if(parseQueryString){this.query=querystring.parse(this.query);}rest=rest.slice(0,qm);}else if(parseQueryString){// no query string, but parseQueryString still requested
	this.search='';this.query={};}if(rest)this.pathname=rest;if(slashedProtocol[lowerProto]&&this.hostname&&!this.pathname){this.pathname='/';}//to support http.request
	if(this.pathname||this.search){var p=this.pathname||'';var s=this.search||'';this.path=p+s;}// finally, reconstruct the href based on what has been validated.
	this.href=this.format();return this;};// format a parsed object into a url string
	function urlFormat(obj){// ensure it's an object, and not a string url.
	// If it's an obj, this is a no-op.
	// this way, you can call url_format() on strings
	// to clean up potentially wonky urls.
	if(util.isString(obj))obj=urlParse(obj);if(!(obj instanceof Url))return Url.prototype.format.call(obj);return obj.format();}Url.prototype.format=function(){var auth=this.auth||'';if(auth){auth=encodeURIComponent(auth);auth=auth.replace(/%3A/i,':');auth+='@';}var protocol=this.protocol||'',pathname=this.pathname||'',hash=this.hash||'',host=false,query='';if(this.host){host=auth+this.host;}else if(this.hostname){host=auth+(this.hostname.indexOf(':')===-1?this.hostname:'['+this.hostname+']');if(this.port){host+=':'+this.port;}}if(this.query&&util.isObject(this.query)&&Object.keys(this.query).length){query=querystring.stringify(this.query);}var search=this.search||query&&'?'+query||'';if(protocol&&protocol.substr(-1)!==':')protocol+=':';// only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	// unless they had them to begin with.
	if(this.slashes||(!protocol||slashedProtocol[protocol])&&host!==false){host='//'+(host||'');if(pathname&&pathname.charAt(0)!=='/')pathname='/'+pathname;}else if(!host){host='';}if(hash&&hash.charAt(0)!=='#')hash='#'+hash;if(search&&search.charAt(0)!=='?')search='?'+search;pathname=pathname.replace(/[?#]/g,function(match){return encodeURIComponent(match);});search=search.replace('#','%23');return protocol+host+pathname+search+hash;};function urlResolve(source,relative){return urlParse(source,false,true).resolve(relative);}Url.prototype.resolve=function(relative){return this.resolveObject(urlParse(relative,false,true)).format();};function urlResolveObject(source,relative){if(!source)return relative;return urlParse(source,false,true).resolveObject(relative);}Url.prototype.resolveObject=function(relative){if(util.isString(relative)){var rel=new Url();rel.parse(relative,false,true);relative=rel;}var result=new Url();var tkeys=Object.keys(this);for(var tk=0;tk<tkeys.length;tk++){var tkey=tkeys[tk];result[tkey]=this[tkey];}// hash is always overridden, no matter what.
	// even href="" will remove it.
	result.hash=relative.hash;// if the relative url is empty, then there's nothing left to do here.
	if(relative.href===''){result.href=result.format();return result;}// hrefs like //foo/bar always cut to the protocol.
	if(relative.slashes&&!relative.protocol){// take everything except the protocol from relative
	var rkeys=Object.keys(relative);for(var rk=0;rk<rkeys.length;rk++){var rkey=rkeys[rk];if(rkey!=='protocol')result[rkey]=relative[rkey];}//urlParse appends trailing / to urls like http://www.example.com
	if(slashedProtocol[result.protocol]&&result.hostname&&!result.pathname){result.path=result.pathname='/';}result.href=result.format();return result;}if(relative.protocol&&relative.protocol!==result.protocol){// if it's a known url protocol, then changing
	// the protocol does weird things
	// first, if it's not file:, then we MUST have a host,
	// and if there was a path
	// to begin with, then we MUST have a path.
	// if it is file:, then the host is dropped,
	// because that's known to be hostless.
	// anything else is assumed to be absolute.
	if(!slashedProtocol[relative.protocol]){var keys=Object.keys(relative);for(var v=0;v<keys.length;v++){var k=keys[v];result[k]=relative[k];}result.href=result.format();return result;}result.protocol=relative.protocol;if(!relative.host&&!hostlessProtocol[relative.protocol]){var relPath=(relative.pathname||'').split('/');while(relPath.length&&!(relative.host=relPath.shift())){;}if(!relative.host)relative.host='';if(!relative.hostname)relative.hostname='';if(relPath[0]!=='')relPath.unshift('');if(relPath.length<2)relPath.unshift('');result.pathname=relPath.join('/');}else{result.pathname=relative.pathname;}result.search=relative.search;result.query=relative.query;result.host=relative.host||'';result.auth=relative.auth;result.hostname=relative.hostname||relative.host;result.port=relative.port;// to support http.request
	if(result.pathname||result.search){var p=result.pathname||'';var s=result.search||'';result.path=p+s;}result.slashes=result.slashes||relative.slashes;result.href=result.format();return result;}var isSourceAbs=result.pathname&&result.pathname.charAt(0)==='/',isRelAbs=relative.host||relative.pathname&&relative.pathname.charAt(0)==='/',mustEndAbs=isRelAbs||isSourceAbs||result.host&&relative.pathname,removeAllDots=mustEndAbs,srcPath=result.pathname&&result.pathname.split('/')||[],relPath=relative.pathname&&relative.pathname.split('/')||[],psychotic=result.protocol&&!slashedProtocol[result.protocol];// if the url is a non-slashed url, then relative
	// links like ../.. should be able
	// to crawl up to the hostname, as well.  This is strange.
	// result.protocol has already been set by now.
	// Later on, put the first path part into the host field.
	if(psychotic){result.hostname='';result.port=null;if(result.host){if(srcPath[0]==='')srcPath[0]=result.host;else srcPath.unshift(result.host);}result.host='';if(relative.protocol){relative.hostname=null;relative.port=null;if(relative.host){if(relPath[0]==='')relPath[0]=relative.host;else relPath.unshift(relative.host);}relative.host=null;}mustEndAbs=mustEndAbs&&(relPath[0]===''||srcPath[0]==='');}if(isRelAbs){// it's absolute.
	result.host=relative.host||relative.host===''?relative.host:result.host;result.hostname=relative.hostname||relative.hostname===''?relative.hostname:result.hostname;result.search=relative.search;result.query=relative.query;srcPath=relPath;// fall through to the dot-handling below.
	}else if(relPath.length){// it's relative
	// throw away the existing file, and take the new path instead.
	if(!srcPath)srcPath=[];srcPath.pop();srcPath=srcPath.concat(relPath);result.search=relative.search;result.query=relative.query;}else if(!util.isNullOrUndefined(relative.search)){// just pull out the search.
	// like href='?foo'.
	// Put this after the other two cases because it simplifies the booleans
	if(psychotic){result.hostname=result.host=srcPath.shift();//occationaly the auth can get stuck only in host
	//this especially happens in cases like
	//url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	var authInHost=result.host&&result.host.indexOf('@')>0?result.host.split('@'):false;if(authInHost){result.auth=authInHost.shift();result.host=result.hostname=authInHost.shift();}}result.search=relative.search;result.query=relative.query;//to support http.request
	if(!util.isNull(result.pathname)||!util.isNull(result.search)){result.path=(result.pathname?result.pathname:'')+(result.search?result.search:'');}result.href=result.format();return result;}if(!srcPath.length){// no path at all.  easy.
	// we've already handled the other stuff above.
	result.pathname=null;//to support http.request
	if(result.search){result.path='/'+result.search;}else{result.path=null;}result.href=result.format();return result;}// if a url ENDs in . or .., then it must get a trailing slash.
	// however, if it ends in anything else non-slashy,
	// then it must NOT get a trailing slash.
	var last=srcPath.slice(-1)[0];var hasTrailingSlash=(result.host||relative.host||srcPath.length>1)&&(last==='.'||last==='..')||last==='';// strip single dots, resolve double dots to parent dir
	// if the path tries to go above the root, `up` ends up > 0
	var up=0;for(var i=srcPath.length;i>=0;i--){last=srcPath[i];if(last==='.'){srcPath.splice(i,1);}else if(last==='..'){srcPath.splice(i,1);up++;}else if(up){srcPath.splice(i,1);up--;}}// if the path is allowed to go above the root, restore leading ..s
	if(!mustEndAbs&&!removeAllDots){for(;up--;up){srcPath.unshift('..');}}if(mustEndAbs&&srcPath[0]!==''&&(!srcPath[0]||srcPath[0].charAt(0)!=='/')){srcPath.unshift('');}if(hasTrailingSlash&&srcPath.join('/').substr(-1)!=='/'){srcPath.push('');}var isAbsolute=srcPath[0]===''||srcPath[0]&&srcPath[0].charAt(0)==='/';// put the host back
	if(psychotic){result.hostname=result.host=isAbsolute?'':srcPath.length?srcPath.shift():'';//occationaly the auth can get stuck only in host
	//this especially happens in cases like
	//url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	var authInHost=result.host&&result.host.indexOf('@')>0?result.host.split('@'):false;if(authInHost){result.auth=authInHost.shift();result.host=result.hostname=authInHost.shift();}}mustEndAbs=mustEndAbs||result.host&&srcPath.length;if(mustEndAbs&&!isAbsolute){srcPath.unshift('');}if(!srcPath.length){result.pathname=null;result.path=null;}else{result.pathname=srcPath.join('/');}//to support request.http
	if(!util.isNull(result.pathname)||!util.isNull(result.search)){result.path=(result.pathname?result.pathname:'')+(result.search?result.search:'');}result.auth=relative.auth||result.auth;result.slashes=result.slashes||relative.slashes;result.href=result.format();return result;};Url.prototype.parseHost=function(){var host=this.host;var port=portPattern.exec(host);if(port){port=port[0];if(port!==':'){this.port=port.substr(1);}host=host.substr(0,host.length-port.length);}if(host)this.hostname=host;};},{"./util":210,"punycode":194,"querystring":197}],210:[function(require,module,exports){'use strict';module.exports={isString:function isString(arg){return typeof arg==='string';},isObject:function isObject(arg){return _typeof(arg)==='object'&&arg!==null;},isNull:function isNull(arg){return arg===null;},isNullOrUndefined:function isNullOrUndefined(arg){return arg==null;}};},{}],211:[function(require,module,exports){/* eslint-disable no-useless-escape */var htmlparser=require('htmlparser2');var quoteRegexp=require('lodash/escapeRegExp');var cloneDeep=require('lodash/cloneDeep');var mergeWith=require('lodash/mergeWith');var isString=require('lodash/isString');var isPlainObject=require('lodash/isPlainObject');var parseSrcset=require('parse-srcset');var postcss=require('postcss');var url=require('url');// Tags that can conceivably represent stand-alone media.
	var mediaTags=['img','audio','video','picture','svg','object','map','iframe','embed'];// Tags that are inherently vulnerable to being used in XSS attacks.
	var vulnerableTags=['script','style'];function each(obj,cb){if(obj){Object.keys(obj).forEach(function(key){cb(obj[key],key);});}}// Avoid false positives with .__proto__, .hasOwnProperty, etc.
	function has(obj,key){return{}.hasOwnProperty.call(obj,key);}// Returns those elements of `a` for which `cb(a)` returns truthy
	function filter(a,cb){var n=[];each(a,function(v){if(cb(v)){n.push(v);}});return n;}function isEmptyObject(obj){for(var key in obj){if(has(obj,key)){return false;}}return true;}function stringifySrcset(parsedSrcset){return parsedSrcset.map(function(part){if(!part.url){throw new Error('URL missing');}return part.url+(part.w?" ".concat(part.w,"w"):'')+(part.h?" ".concat(part.h,"h"):'')+(part.d?" ".concat(part.d,"x"):'');}).join(', ');}module.exports=sanitizeHtml;// A valid attribute name.
	// We use a tolerant definition based on the set of strings defined by
	// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
	// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
	// The characters accepted are ones which can be appended to the attribute
	// name buffer without triggering a parse error:
	//   * unexpected-equals-sign-before-attribute-name
	//   * unexpected-null-character
	//   * unexpected-character-in-attribute-name
	// We exclude the empty string because it's impossible to get to the after
	// attribute name state with an empty attribute name buffer.
	var VALID_HTML_ATTRIBUTE_NAME=/^[^\0\t\n\f\r /<=>]+$/;// Ignore the _recursing flag; it's there for recursive
	// invocation as a guard against this exploit:
	// https://github.com/fb55/htmlparser2/issues/105
	function sanitizeHtml(html,options,_recursing){var result='';// Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
	var tempResult='';function Frame(tag,attribs){var that=this;this.tag=tag;this.attribs=attribs||{};this.tagPosition=result.length;this.text='';// Node inner text
	this.mediaChildren=[];this.updateParentNodeText=function(){if(stack.length){var parentFrame=stack[stack.length-1];parentFrame.text+=that.text;}};this.updateParentNodeMediaChildren=function(){if(stack.length&&mediaTags.indexOf(this.tag)>-1){var parentFrame=stack[stack.length-1];parentFrame.mediaChildren.push(this.tag);}};}if(!options){options=sanitizeHtml.defaults;options.parser=htmlParserDefaults;}else{options=Object.assign({},sanitizeHtml.defaults,options);if(options.parser){options.parser=Object.assign({},htmlParserDefaults,options.parser);}else{options.parser=htmlParserDefaults;}}// vulnerableTags
	vulnerableTags.forEach(function(tag){if(options.allowedTags&&options.allowedTags.indexOf(tag)>-1&&!options.allowVulnerableTags){// eslint-disable-next-line no-console
	console.warn("\n\n\u26A0\uFE0F Your `allowedTags` option includes, `".concat(tag,"`, which is inherently\nvulnerable to XSS attacks. Please remove it from `allowedTags`.\nOr, to disable this warning, add the `allowVulnerableTags` option\nand ensure you are accounting for this risk.\n\n"));}});// Tags that contain something other than HTML, or where discarding
	// the text when the tag is disallowed makes sense for other reasons.
	// If we are not allowing these tags, we should drop their content too.
	// For other tags you would drop the tag but keep its content.
	var nonTextTagsArray=options.nonTextTags||['script','style','textarea','option'];var allowedAttributesMap;var allowedAttributesGlobMap;if(options.allowedAttributes){allowedAttributesMap={};allowedAttributesGlobMap={};each(options.allowedAttributes,function(attributes,tag){allowedAttributesMap[tag]=[];var globRegex=[];attributes.forEach(function(obj){if(isString(obj)&&obj.indexOf('*')>=0){globRegex.push(quoteRegexp(obj).replace(/\\\*/g,'.*'));}else{allowedAttributesMap[tag].push(obj);}});allowedAttributesGlobMap[tag]=new RegExp('^('+globRegex.join('|')+')$');});}var allowedClassesMap={};each(options.allowedClasses,function(classes,tag){// Implicitly allows the class attribute
	if(allowedAttributesMap){if(!has(allowedAttributesMap,tag)){allowedAttributesMap[tag]=[];}allowedAttributesMap[tag].push('class');}allowedClassesMap[tag]=classes;});var transformTagsMap={};var transformTagsAll;each(options.transformTags,function(transform,tag){var transFun;if(typeof transform==='function'){transFun=transform;}else if(typeof transform==='string'){transFun=sanitizeHtml.simpleTransform(transform);}if(tag==='*'){transformTagsAll=transFun;}else{transformTagsMap[tag]=transFun;}});var depth;var stack;var skipMap;var transformMap;var skipText;var skipTextDepth;var addedText=false;initializeState();var parser=new htmlparser.Parser({onopentag:function onopentag(name,attribs){// If `enforceHtmlBoundary` is `true` and this has found the opening
	// `html` tag, reset the state.
	if(options.enforceHtmlBoundary&&name==='html'){initializeState();}if(skipText){skipTextDepth++;return;}var frame=new Frame(name,attribs);stack.push(frame);var skip=false;var hasText=!!frame.text;var transformedTag;if(has(transformTagsMap,name)){transformedTag=transformTagsMap[name](name,attribs);frame.attribs=attribs=transformedTag.attribs;if(transformedTag.text!==undefined){frame.innerText=transformedTag.text;}if(name!==transformedTag.tagName){frame.name=name=transformedTag.tagName;transformMap[depth]=transformedTag.tagName;}}if(transformTagsAll){transformedTag=transformTagsAll(name,attribs);frame.attribs=attribs=transformedTag.attribs;if(name!==transformedTag.tagName){frame.name=name=transformedTag.tagName;transformMap[depth]=transformedTag.tagName;}}if(options.allowedTags&&options.allowedTags.indexOf(name)===-1||options.disallowedTagsMode==='recursiveEscape'&&!isEmptyObject(skipMap)){skip=true;skipMap[depth]=true;if(options.disallowedTagsMode==='discard'){if(nonTextTagsArray.indexOf(name)!==-1){skipText=true;skipTextDepth=1;}}skipMap[depth]=true;}depth++;if(skip){if(options.disallowedTagsMode==='discard'){// We want the contents but not this tag
	return;}tempResult=result;result='';}result+='<'+name;if(!allowedAttributesMap||has(allowedAttributesMap,name)||allowedAttributesMap['*']){each(attribs,function(value,a){if(!VALID_HTML_ATTRIBUTE_NAME.test(a)){// This prevents part of an attribute name in the output from being
	// interpreted as the end of an attribute, or end of a tag.
	delete frame.attribs[a];return;}var parsed;// check allowedAttributesMap for the element and attribute and modify the value
	// as necessary if there are specific values defined.
	var passedAllowedAttributesMapCheck=false;if(!allowedAttributesMap||has(allowedAttributesMap,name)&&allowedAttributesMap[name].indexOf(a)!==-1||allowedAttributesMap['*']&&allowedAttributesMap['*'].indexOf(a)!==-1||has(allowedAttributesGlobMap,name)&&allowedAttributesGlobMap[name].test(a)||allowedAttributesGlobMap['*']&&allowedAttributesGlobMap['*'].test(a)){passedAllowedAttributesMapCheck=true;}else if(allowedAttributesMap&&allowedAttributesMap[name]){var _iterator10=_createForOfIteratorHelper(allowedAttributesMap[name]),_step10;try{for(_iterator10.s();!(_step10=_iterator10.n()).done;){var o=_step10.value;if(isPlainObject(o)&&o.name&&o.name===a){passedAllowedAttributesMapCheck=true;var newValue='';if(o.multiple===true){// verify the values that are allowed
	var splitStrArray=value.split(' ');var _iterator11=_createForOfIteratorHelper(splitStrArray),_step11;try{for(_iterator11.s();!(_step11=_iterator11.n()).done;){var s=_step11.value;if(o.values.indexOf(s)!==-1){if(newValue===''){newValue=s;}else{newValue+=' '+s;}}}}catch(err){_iterator11.e(err);}finally{_iterator11.f();}}else if(o.values.indexOf(value)>=0){// verified an allowed value matches the entire attribute value
	newValue=value;}value=newValue;}}}catch(err){_iterator10.e(err);}finally{_iterator10.f();}}if(passedAllowedAttributesMapCheck){if(options.allowedSchemesAppliedToAttributes.indexOf(a)!==-1){if(naughtyHref(name,value)){delete frame.attribs[a];return;}}if(name==='iframe'&&a==='src'){var allowed=true;try{// naughtyHref is in charge of whether protocol relative URLs
	// are cool. We should just accept them.
	// eslint-disable-next-line node/no-deprecated-api
	parsed=url.parse(value,false,true);var isRelativeUrl=parsed&&parsed.host===null&&parsed.protocol===null;if(isRelativeUrl){// default value of allowIframeRelativeUrls is true
	// unless allowedIframeHostnames or allowedIframeDomains specified
	allowed=has(options,'allowIframeRelativeUrls')?options.allowIframeRelativeUrls:!options.allowedIframeHostnames&&!options.allowedIframeDomains;}else if(options.allowedIframeHostnames||options.allowedIframeDomains){var allowedHostname=(options.allowedIframeHostnames||[]).find(function(hostname){return hostname===parsed.hostname;});var allowedDomain=(options.allowedIframeDomains||[]).find(function(domain){return parsed.hostname===domain||parsed.hostname.endsWith(".".concat(domain));});allowed=allowedHostname||allowedDomain;}}catch(e){// Unparseable iframe src
	allowed=false;}if(!allowed){delete frame.attribs[a];return;}}if(a==='srcset'){try{parsed=parseSrcset(value);each(parsed,function(value){if(naughtyHref('srcset',value.url)){value.evil=true;}});parsed=filter(parsed,function(v){return!v.evil;});if(!parsed.length){delete frame.attribs[a];return;}else{value=stringifySrcset(filter(parsed,function(v){return!v.evil;}));frame.attribs[a]=value;}}catch(e){// Unparseable srcset
	delete frame.attribs[a];return;}}if(a==='class'){value=filterClasses(value,allowedClassesMap[name]);if(!value.length){delete frame.attribs[a];return;}}if(a==='style'){try{var abstractSyntaxTree=postcss.parse(name+' {'+value+'}');var filteredAST=filterCss(abstractSyntaxTree,options.allowedStyles);value=stringifyStyleAttributes(filteredAST);if(value.length===0){delete frame.attribs[a];return;}}catch(e){delete frame.attribs[a];return;}}result+=' '+a;if(value&&value.length){result+='="'+escapeHtml(value,true)+'"';}}else{delete frame.attribs[a];}});}if(options.selfClosing.indexOf(name)!==-1){result+=' />';}else{result+='>';if(frame.innerText&&!hasText&&!options.textFilter){result+=frame.innerText;addedText=true;}}if(skip){result=tempResult+escapeHtml(result);tempResult='';}},ontext:function ontext(text){if(skipText){return;}var lastFrame=stack[stack.length-1];var tag;if(lastFrame){tag=lastFrame.tag;// If inner text was set by transform function then let's use it
	text=lastFrame.innerText!==undefined?lastFrame.innerText:text;}if(options.disallowedTagsMode==='discard'&&(tag==='script'||tag==='style')){// htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
	// script tags is, by definition, game over for XSS protection, so if that's
	// your concern, don't allow them. The same is essentially true for style tags
	// which have their own collection of XSS vectors.
	result+=text;}else{var escaped=escapeHtml(text,false);if(options.textFilter&&!addedText){result+=options.textFilter(escaped,tag);}else if(!addedText){result+=escaped;}}if(stack.length){var frame=stack[stack.length-1];frame.text+=text;}},onclosetag:function onclosetag(name){if(skipText){skipTextDepth--;if(!skipTextDepth){skipText=false;}else{return;}}var frame=stack.pop();if(!frame){// Do not crash on bad markup
	return;}skipText=options.enforceHtmlBoundary?name==='html':false;depth--;var skip=skipMap[depth];if(skip){delete skipMap[depth];if(options.disallowedTagsMode==='discard'){frame.updateParentNodeText();return;}tempResult=result;result='';}if(transformMap[depth]){name=transformMap[depth];delete transformMap[depth];}if(options.exclusiveFilter&&options.exclusiveFilter(frame)){result=result.substr(0,frame.tagPosition);return;}frame.updateParentNodeMediaChildren();frame.updateParentNodeText();if(options.selfClosing.indexOf(name)!==-1){// Already output />
	if(skip){result=tempResult;tempResult='';}return;}result+='</'+name+'>';if(skip){result=tempResult+escapeHtml(result);tempResult='';}}},options.parser);parser.write(html);parser.end();return result;function initializeState(){result='';depth=0;stack=[];skipMap={};transformMap={};skipText=false;skipTextDepth=0;}function escapeHtml(s,quote){if(typeof s!=='string'){s=s+'';}if(options.parser.decodeEntities){s=s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/\>/g,'&gt;');if(quote){s=s.replace(/\"/g,'&quot;');}}// TODO: this is inadequate because it will pass `&0;`. This approach
	// will not work, each & must be considered with regard to whether it
	// is followed by a 100% syntactically valid entity or not, and escaped
	// if it is not. If this bothers you, don't set parser.decodeEntities
	// to false. (The default is true.)
	s=s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g,'&amp;')// Match ampersands not part of existing HTML entity
	.replace(/</g,'&lt;').replace(/\>/g,'&gt;');if(quote){s=s.replace(/\"/g,'&quot;');}return s;}function naughtyHref(name,href){// Browsers ignore character codes of 32 (space) and below in a surprising
	// number of situations. Start reading here:
	// https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
	// eslint-disable-next-line no-control-regex
	href=href.replace(/[\x00-\x20]+/g,'');// Clobber any comments in URLs, which the browser might
	// interpret inside an XML data island, allowing
	// a javascript: URL to be snuck through
	href=href.replace(/<\!\-\-.*?\-\-\>/g,'');// Case insensitive so we don't get faked out by JAVASCRIPT #1
	var matches=href.match(/^([a-zA-Z]+)\:/);if(!matches){// Protocol-relative URL starting with any combination of '/' and '\'
	if(href.match(/^[\/\\]{2}/)){return!options.allowProtocolRelative;}// No scheme
	return false;}var scheme=matches[1].toLowerCase();if(has(options.allowedSchemesByTag,name)){return options.allowedSchemesByTag[name].indexOf(scheme)===-1;}return!options.allowedSchemes||options.allowedSchemes.indexOf(scheme)===-1;}/**
	   * Filters user input css properties by whitelisted regex attributes.
	   *
	   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
	   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
	   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
	   * @return {object}                    - Abstract Syntax Tree with filtered style attributes.
	   */function filterCss(abstractSyntaxTree,allowedStyles){if(!allowedStyles){return abstractSyntaxTree;}var filteredAST=cloneDeep(abstractSyntaxTree);var astRules=abstractSyntaxTree.nodes[0];var selectedRule;// Merge global and tag-specific styles into new AST.
	if(allowedStyles[astRules.selector]&&allowedStyles['*']){selectedRule=mergeWith(cloneDeep(allowedStyles[astRules.selector]),allowedStyles['*'],function(objValue,srcValue){if(Array.isArray(objValue)){return objValue.concat(srcValue);}});}else{selectedRule=allowedStyles[astRules.selector]||allowedStyles['*'];}if(selectedRule){filteredAST.nodes[0].nodes=astRules.nodes.reduce(filterDeclarations(selectedRule),[]);}return filteredAST;}/**
	   * Extracts the style attribues from an AbstractSyntaxTree and formats those
	   * values in the inline style attribute format.
	   *
	   * @param  {AbstractSyntaxTree} filteredAST
	   * @return {string}             - Example: "color:yellow;text-align:center;font-family:helvetica;"
	   */function stringifyStyleAttributes(filteredAST){return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes,attributeObject){extractedAttributes.push(attributeObject.prop+':'+attributeObject.value);return extractedAttributes;},[]).join(';');}/**
	    * Filters the existing attributes for the given property. Discards any attributes
	    * which don't match the whitelist.
	    *
	    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
	    * @param  {array} allowedDeclarationsList   - List of declarations which pass whitelisting.
	    * @param  {object} attributeObject          - Object representing the current css property.
	    * @property {string} attributeObject.type   - Typically 'declaration'.
	    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
	    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
	    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
	    */function filterDeclarations(selectedRule){return function(allowedDeclarationsList,attributeObject){// If this property is whitelisted...
	if(has(selectedRule,attributeObject.prop)){var matchesRegex=selectedRule[attributeObject.prop].some(function(regularExpression){return regularExpression.test(attributeObject.value);});if(matchesRegex){allowedDeclarationsList.push(attributeObject);}}return allowedDeclarationsList;};}function filterClasses(classes,allowed){if(!allowed){// The class attribute is allowed without filtering on this tag
	return classes;}classes=classes.split(/\s+/);return classes.filter(function(clss){return allowed.indexOf(clss)!==-1;}).join(' ');}}// Defaults are accessible to you so that you can use them as a starting point
	// programmatically if you wish
	var htmlParserDefaults={decodeEntities:true};sanitizeHtml.defaults={allowedTags:['h3','h4','h5','h6','blockquote','p','a','ul','ol','nl','li','b','i','strong','em','strike','abbr','code','hr','br','div','table','thead','caption','tbody','tr','th','td','pre','iframe'],disallowedTagsMode:'discard',allowedAttributes:{a:['href','name','target'],// We don't currently allow img itself by default, but this
	// would make sense if we did. You could add srcset here,
	// and if you do the URL is checked for safety
	img:['src']},// Lots of these won't come up by default because we don't allow them
	selfClosing:['img','br','hr','area','base','basefont','input','link','meta'],// URL schemes we permit
	allowedSchemes:['http','https','ftp','mailto'],allowedSchemesByTag:{},allowedSchemesAppliedToAttributes:['href','src','cite'],allowProtocolRelative:true,enforceHtmlBoundary:false};sanitizeHtml.simpleTransform=function(newTagName,newAttribs,merge){merge=merge===undefined?true:merge;newAttribs=newAttribs||{};return function(tagName,attribs){var attrib;if(merge){for(attrib in newAttribs){attribs[attrib]=newAttribs[attrib];}}else{attribs=newAttribs;}return{tagName:newTagName,attribs:attribs};};};},{"htmlparser2":31,"lodash/cloneDeep":140,"lodash/escapeRegExp":143,"lodash/isPlainObject":155,"lodash/isString":157,"lodash/mergeWith":162,"parse-srcset":167,"postcss":181,"url":209}]},{},[211])(211);});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2885 */
/***/ (function(module, exports) {

	'use strict';
	
	function shallowEqualObjects(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (!objA || !objB) {
	    return false;
	  }
	
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	  var len = aKeys.length;
	
	  if (bKeys.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqualObjects;


/***/ }),
/* 2886 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 2887 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(5696).enable();
	  window.Promise = __webpack_require__(5695);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(6490);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(5689);
	
	// Element.prototype.remove
	// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
	(function (arr) {
	  arr.forEach(function (item) {
	    if (item.hasOwnProperty('remove')) {
	      return;
	    }
	    Object.defineProperty(item, 'remove', {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function remove() {
	        this.parentNode && this.parentNode.removeChild(this);
	      }
	    });
	  });
	})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
	
	
	// LocalStorage polyfill
	try {
	  const key = 'localStorageIsSupportedInThisBrowser';
	  window.localStorage.setItem(key, 'test');
	  window.localStorage.removeItem(key);
	
	  // localstorage ok
	  window.storage = window.localStorage;
	}
	catch (e) {
	  console.warn('localStorage not functional, falling back to session Object.');
	
	  window.storage = {
	    _data       : {},
	    setItem     : function(id, val) { return this._data[id] = String(val); },
	    getItem     : function(id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined; },
	    removeItem  : function(id) { return delete this._data[id]; },
	    clear       : function() { return this._data = {}; }
	  };
	}
	
	// String.prototype.includes
	if (!String.prototype.includes) {
	  String.prototype.includes = function(search, start) {
	    'use strict';
	    if (typeof start !== 'number') {
	      start = 0;
	    }
	
	    if (start + search.length > this.length) {
	      return false;
	    } else {
	      return this.indexOf(search, start) !== -1;
	    }
	  };
	}
	
	// Canvas toBlob polyfill
	if (!HTMLCanvasElement.prototype.toBlob) {
	  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
	    value: function (callback, type, quality) {
	
	      var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
	        len = binStr.length,
	        arr = new Uint8Array(len);
	
	      for (var i = 0; i < len; i++ ) {
	        arr[i] = binStr.charCodeAt(i);
	      }
	
	      callback( new Blob( [arr], {type: type || 'image/png'} ) );
	    }
	  });
	}


/***/ }),
/* 2889 */
/***/ (function(module, exports) {

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	module.exports = _arrayWithHoles;

/***/ }),
/* 2890 */
6257,
/* 2891 */
/***/ (function(module, exports) {

	function _iterableToArrayLimit(arr, i) {
	  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
	    return;
	  }
	
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;
	
	  try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	module.exports = _iterableToArrayLimit;

/***/ }),
/* 2892 */
/***/ (function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance");
	}
	
	module.exports = _nonIterableRest;

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(1051);
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? Object(arguments[i]) : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	module.exports = _objectSpread;

/***/ }),
/* 2894 */
2825,
/* 2895 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash2_32_gc(str) {
	  var l = str.length,
	      h = l ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	  return (h >>> 0).toString(36);
	}
	
	exports.default = murmurhash2_32_gc;


/***/ }),
/* 2896 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ }),
/* 2897 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ }),
/* 2898 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* @generated */
	// prettier-ignore  
	exports.default = { "aa-SAAHO": "ssy", "aam": "aas", "aar": "aa", "abk": "ab", "adp": "dz", "afr": "af", "aju": "jrb", "aka": "ak", "alb": "sq", "als": "sq", "amh": "am", "ara": "ar", "arb": "ar", "arg": "an", "arm": "hy", "art-lojban": "jbo", "asd": "snz", "asm": "as", "aue": "ktz", "ava": "av", "ave": "ae", "aym": "ay", "ayr": "ay", "ayx": "nun", "az-AZ": "az-Latn-AZ", "aze": "az", "azj": "az", "bak": "ba", "bam": "bm", "baq": "eu", "bcc": "bal", "bcl": "bik", "bel": "be", "ben": "bn", "bgm": "bcg", "bh": "bho", "bih": "bho", "bis": "bi", "bjd": "drl", "bod": "bo", "bos": "bs", "bre": "br", "bs-BA": "bs-Latn-BA", "bul": "bg", "bur": "my", "bxk": "luy", "bxr": "bua", "cat": "ca", "ccq": "rki", "cel-gaulish": "xtg-x-cel-gaulish", "ces": "cs", "cha": "ch", "che": "ce", "chi": "zh", "chu": "cu", "chv": "cv", "cjr": "mom", "cka": "cmr", "cld": "syr", "cmk": "xch", "cmn": "zh", "cnr": "sr-ME", "cor": "kw", "cos": "co", "coy": "pij", "cqu": "quh", "cre": "cr", "cwd": "cr", "cym": "cy", "cze": "cs", "dan": "da", "deu": "de", "dgo": "doi", "dhd": "mwr", "dik": "din", "diq": "zza", "dit": "dif", "div": "dv", "drh": "mn", "drw": "fa-af", "dut": "nl", "dzo": "dz", "ekk": "et", "ell": "el", "emk": "man", "eng": "en", "epo": "eo", "esk": "ik", "est": "et", "eus": "eu", "ewe": "ee", "fao": "fo", "fas": "fa", "fat": "ak", "fij": "fj", "fin": "fi", "fra": "fr", "fre": "fr", "fry": "fy", "fuc": "ff", "ful": "ff", "gav": "dev", "gaz": "om", "gbo": "grb", "geo": "ka", "ger": "de", "gfx": "vaj", "ggn": "gvr", "gla": "gd", "gle": "ga", "glg": "gl", "glv": "gv", "gno": "gon", "gre": "el", "grn": "gn", "gti": "nyc", "gug": "gn", "guj": "gu", "guv": "duz", "gya": "gba", "ha-Latn-GH": "ha-GH", "ha-Latn-NE": "ha-NE", "ha-Latn-NG": "ha-NG", "hat": "ht", "hau": "ha", "hbs": "sr-Latn", "hdn": "hai", "hea": "hmn", "heb": "he", "her": "hz", "him": "srx", "hin": "hi", "hmo": "ho", "hrr": "jal", "hrv": "hr", "hun": "hu", "hye": "hy", "i-ami": "ami", "i-bnn": "bnn", "i-hak": "hak", "i-klingon": "tlh", "i-lux": "lb", "i-navajo": "nv", "i-pwn": "pwn", "i-tao": "tao", "i-tay": "tay", "i-tsu": "tsu", "i-default": "en-x-i-default", "i-enochian": "und-x-i-enochian", "i-mingo": "see-x-i-mingo", "ibi": "opa", "ibo": "ig", "ice": "is", "ido": "io", "iii": "ii", "ike": "iu", "iku": "iu", "ile": "ie", "ilw": "gal", "in": "id", "ina": "ia", "ind": "id", "ipk": "ik", "isl": "is", "ita": "it", "iw": "he", "jav": "jv", "jeg": "oyb", "ji": "yi", "jpn": "ja", "jw": "jv", "kal": "kl", "kan": "kn", "kas": "ks", "kat": "ka", "kau": "kr", "kaz": "kk", "kgc": "tdf", "kgh": "kml", "khk": "mn", "khm": "km", "kik": "ki", "kin": "rw", "kir": "ky", "kk-Cyrl-KZ": "kk-KZ", "kmr": "ku", "knc": "kr", "kng": "kg", "knn": "kok", "koj": "kwv", "kom": "kv", "kon": "kg", "kor": "ko", "kpv": "kv", "krm": "bmf", "ks-Arab-IN": "ks-IN", "ktr": "dtp", "kua": "kj", "kur": "ku", "kvs": "gdj", "kwq": "yam", "kxe": "tvd", "ky-Cyrl-KG": "ky-KG", "kzj": "dtp", "kzt": "dtp", "lao": "lo", "lat": "la", "lav": "lv", "lbk": "bnc", "lii": "raq", "lim": "li", "lin": "ln", "lit": "lt", "llo": "ngt", "lmm": "rmx", "ltz": "lb", "lub": "lu", "lug": "lg", "lvs": "lv", "mac": "mk", "mah": "mh", "mal": "ml", "mao": "mi", "mar": "mr", "may": "ms", "meg": "cir", "mhr": "chm", "mkd": "mk", "mlg": "mg", "mlt": "mt", "mn-Cyrl-MN": "mn-MN", "mnk": "man", "mo": "ro", "mol": "ro", "mon": "mn", "mri": "mi", "ms-Latn-BN": "ms-BN", "ms-Latn-MY": "ms-MY", "ms-Latn-SG": "ms-SG", "msa": "ms", "mst": "mry", "mup": "raj", "mwj": "vaj", "mya": "my", "myd": "aog", "myt": "mry", "nad": "xny", "nau": "na", "nav": "nv", "nbl": "nr", "ncp": "kdz", "nde": "nd", "ndo": "ng", "nep": "ne", "nld": "nl", "nno": "nn", "nns": "nbr", "nnx": "ngv", "no": "nb", "no-bok": "nb", "no-BOKMAL": "nb", "no-nyn": "nn", "no-NYNORSK": "nn", "nob": "nb", "nor": "nb", "npi": "ne", "nts": "pij", "nya": "ny", "oci": "oc", "ojg": "oj", "oji": "oj", "ori": "or", "orm": "om", "ory": "or", "oss": "os", "oun": "vaj", "pa-IN": "pa-Guru-IN", "pa-PK": "pa-Arab-PK", "pan": "pa", "pbu": "ps", "pcr": "adx", "per": "fa", "pes": "fa", "pli": "pi", "plt": "mg", "pmc": "huw", "pmu": "phr", "pnb": "lah", "pol": "pl", "por": "pt", "ppa": "bfy", "ppr": "lcq", "prs": "fa-AF", "pry": "prt", "pus": "ps", "puz": "pub", "que": "qu", "quz": "qu", "rmy": "rom", "roh": "rm", "ron": "ro", "rum": "ro", "run": "rn", "rus": "ru", "sag": "sg", "san": "sa", "sca": "hle", "scc": "sr", "scr": "hr", "sgn-BE-FR": "sfb", "sgn-BE-NL": "vgt", "sgn-CH-DE": "sgg", "sh": "sr-Latn", "shi-MA": "shi-Tfng-MA", "sin": "si", "skk": "oyb", "slk": "sk", "slo": "sk", "slv": "sl", "sme": "se", "smo": "sm", "sna": "sn", "snd": "sd", "som": "so", "sot": "st", "spa": "es", "spy": "kln", "sqi": "sq", "sr-BA": "sr-Cyrl-BA", "sr-ME": "sr-Latn-ME", "sr-RS": "sr-Cyrl-RS", "sr-XK": "sr-Cyrl-XK", "src": "sc", "srd": "sc", "srp": "sr", "ssw": "ss", "sun": "su", "swa": "sw", "swc": "sw-CD", "swe": "sv", "swh": "sw", "tah": "ty", "tam": "ta", "tat": "tt", "tdu": "dtp", "tel": "te", "tgk": "tg", "tgl": "fil", "tha": "th", "thc": "tpo", "thx": "oyb", "tib": "bo", "tie": "ras", "tir": "ti", "tkk": "twm", "tl": "fil", "tlw": "weo", "tmp": "tyj", "tne": "kak", "tnf": "fa-af", "ton": "to", "tsf": "taj", "tsn": "tn", "tso": "ts", "ttq": "tmh", "tuk": "tk", "tur": "tr", "tw": "ak", "twi": "ak", "tzm-Latn-MA": "tzm-MA", "ug-Arab-CN": "ug-CN", "uig": "ug", "ukr": "uk", "umu": "del", "uok": "ema", "urd": "ur", "uz-AF": "uz-Arab-AF", "uz-UZ": "uz-Latn-UZ", "uzb": "uz", "uzn": "uz", "vai-LR": "vai-Vaii-LR", "ven": "ve", "vie": "vi", "vol": "vo", "wel": "cy", "wln": "wa", "wol": "wo", "xba": "cax", "xho": "xh", "xia": "acn", "xkh": "waw", "xpe": "kpe", "xsj": "suj", "xsl": "den", "ybd": "rki", "ydd": "yi", "yid": "yi", "yma": "lrr", "ymt": "mtm", "yor": "yo", "yos": "zom", "yue-CN": "yue-Hans-CN", "yue-HK": "yue-Hant-HK", "yuu": "yug", "zai": "zap", "zh-CN": "zh-Hans-CN", "zh-guoyu": "zh", "zh-hakka": "hak", "zh-HK": "zh-Hant-HK", "zh-min-nan": "nan", "zh-MO": "zh-Hant-MO", "zh-SG": "zh-Hans-SG", "zh-TW": "zh-Hant-TW", "zh-xiang": "hsn", "zh-min": "nan-x-zh-min", "zha": "za", "zho": "zh", "zsm": "ms", "zul": "zu", "zyb": "za" };
	//# sourceMappingURL=aliases.js.map

/***/ }),
/* 2899 */
/***/ (function(module, exports) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var MS_PER_SECOND = 1e3;
	var SECS_PER_MIN = 60;
	var SECS_PER_HOUR = SECS_PER_MIN * 60;
	var SECS_PER_DAY = SECS_PER_HOUR * 24;
	var SECS_PER_WEEK = SECS_PER_DAY * 7;
	function selectUnit(from, to, thresholds) {
	    if (to === void 0) { to = Date.now(); }
	    if (thresholds === void 0) { thresholds = {}; }
	    var resolvedThresholds = __assign(__assign({}, exports.DEFAULT_THRESHOLDS), (thresholds || {}));
	    var secs = (+from - +to) / MS_PER_SECOND;
	    if (Math.abs(secs) < resolvedThresholds.second) {
	        return {
	            value: Math.round(secs),
	            unit: 'second',
	        };
	    }
	    var mins = secs / SECS_PER_MIN;
	    if (Math.abs(mins) < resolvedThresholds.minute) {
	        return {
	            value: Math.round(mins),
	            unit: 'minute',
	        };
	    }
	    var hours = secs / SECS_PER_HOUR;
	    if (Math.abs(hours) < resolvedThresholds.hour) {
	        return {
	            value: Math.round(hours),
	            unit: 'hour',
	        };
	    }
	    var days = secs / SECS_PER_DAY;
	    if (Math.abs(days) < resolvedThresholds.day) {
	        return {
	            value: Math.round(days),
	            unit: 'day',
	        };
	    }
	    var fromDate = new Date(from);
	    var toDate = new Date(to);
	    var years = fromDate.getFullYear() - toDate.getFullYear();
	    if (Math.round(Math.abs(years)) > 0) {
	        return {
	            value: Math.round(years),
	            unit: 'year',
	        };
	    }
	    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
	    if (Math.round(Math.abs(months)) > 0) {
	        return {
	            value: Math.round(months),
	            unit: 'month',
	        };
	    }
	    var weeks = secs / SECS_PER_WEEK;
	    return {
	        value: Math.round(weeks),
	        unit: 'week',
	    };
	}
	exports.selectUnit = selectUnit;
	exports.DEFAULT_THRESHOLDS = {
	    second: 45,
	    minute: 45,
	    hour: 22,
	    day: 5,
	};
	//# sourceMappingURL=diff.js.map

/***/ }),
/* 2900 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var InternalSlotToken;
	(function (InternalSlotToken) {
	    // To prevent collision with {0} in CLDR
	    InternalSlotToken["compactName"] = "compactName";
	    InternalSlotToken["compactSymbol"] = "compactSymbol";
	    InternalSlotToken["currencyCode"] = "currencyCode";
	    InternalSlotToken["currencyName"] = "currencyName";
	    InternalSlotToken["currencyNarrowSymbol"] = "currencyNarrowSymbol";
	    InternalSlotToken["currencySymbol"] = "currencySymbol";
	    InternalSlotToken["minusSign"] = "minusSign";
	    InternalSlotToken["number"] = "number";
	    InternalSlotToken["percentSign"] = "percentSign";
	    InternalSlotToken["plusSign"] = "plusSign";
	    InternalSlotToken["scientificExponent"] = "scientificExponent";
	    InternalSlotToken["scientificSeparator"] = "scientificSeparator";
	    InternalSlotToken["unitName"] = "unitName";
	    InternalSlotToken["unitNarrowSymbol"] = "unitNarrowSymbol";
	    InternalSlotToken["unitSymbol"] = "unitSymbol";
	})(InternalSlotToken = exports.InternalSlotToken || (exports.InternalSlotToken = {}));
	//# sourceMappingURL=number-types.js.map

/***/ }),
/* 2901 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* @generated */
	// prettier-ignore  
	exports.default = { "en-150": "en-001", "en-AG": "en-001", "en-AI": "en-001", "en-AU": "en-001", "en-BB": "en-001", "en-BM": "en-001", "en-BS": "en-001", "en-BW": "en-001", "en-BZ": "en-001", "en-CA": "en-001", "en-CC": "en-001", "en-CK": "en-001", "en-CM": "en-001", "en-CX": "en-001", "en-CY": "en-001", "en-DG": "en-001", "en-DM": "en-001", "en-ER": "en-001", "en-FJ": "en-001", "en-FK": "en-001", "en-FM": "en-001", "en-GB": "en-001", "en-GD": "en-001", "en-GG": "en-001", "en-GH": "en-001", "en-GI": "en-001", "en-GM": "en-001", "en-GY": "en-001", "en-HK": "en-001", "en-IE": "en-001", "en-IL": "en-001", "en-IM": "en-001", "en-IN": "en-001", "en-IO": "en-001", "en-JE": "en-001", "en-JM": "en-001", "en-KE": "en-001", "en-KI": "en-001", "en-KN": "en-001", "en-KY": "en-001", "en-LC": "en-001", "en-LR": "en-001", "en-LS": "en-001", "en-MG": "en-001", "en-MO": "en-001", "en-MS": "en-001", "en-MT": "en-001", "en-MU": "en-001", "en-MW": "en-001", "en-MY": "en-001", "en-NA": "en-001", "en-NF": "en-001", "en-NG": "en-001", "en-NR": "en-001", "en-NU": "en-001", "en-NZ": "en-001", "en-PG": "en-001", "en-PH": "en-001", "en-PK": "en-001", "en-PN": "en-001", "en-PW": "en-001", "en-RW": "en-001", "en-SB": "en-001", "en-SC": "en-001", "en-SD": "en-001", "en-SG": "en-001", "en-SH": "en-001", "en-SL": "en-001", "en-SS": "en-001", "en-SX": "en-001", "en-SZ": "en-001", "en-TC": "en-001", "en-TK": "en-001", "en-TO": "en-001", "en-TT": "en-001", "en-TV": "en-001", "en-TZ": "en-001", "en-UG": "en-001", "en-VC": "en-001", "en-VG": "en-001", "en-VU": "en-001", "en-WS": "en-001", "en-ZA": "en-001", "en-ZM": "en-001", "en-ZW": "en-001", "en-AT": "en-150", "en-BE": "en-150", "en-CH": "en-150", "en-DE": "en-150", "en-DK": "en-150", "en-FI": "en-150", "en-NL": "en-150", "en-SE": "en-150", "en-SI": "en-150", "es-AR": "es-419", "es-BO": "es-419", "es-BR": "es-419", "es-BZ": "es-419", "es-CL": "es-419", "es-CO": "es-419", "es-CR": "es-419", "es-CU": "es-419", "es-DO": "es-419", "es-EC": "es-419", "es-GT": "es-419", "es-HN": "es-419", "es-MX": "es-419", "es-NI": "es-419", "es-PA": "es-419", "es-PE": "es-419", "es-PR": "es-419", "es-PY": "es-419", "es-SV": "es-419", "es-US": "es-419", "es-UY": "es-419", "es-VE": "es-419", "pt-AO": "pt-PT", "pt-CH": "pt-PT", "pt-CV": "pt-PT", "pt-FR": "pt-PT", "pt-GQ": "pt-PT", "pt-GW": "pt-PT", "pt-LU": "pt-PT", "pt-MO": "pt-PT", "pt-MZ": "pt-PT", "pt-ST": "pt-PT", "pt-TL": "pt-PT", "zh-Hant-MO": "zh-Hant-HK" };
	//# sourceMappingURL=parentLocales.js.map

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var get_canonical_locales_1 = __webpack_require__(1664);
	var invariant_1 = __webpack_require__(1059);
	var polyfill_utils_1 = __webpack_require__(1665);
	function createResolveLocale(getDefaultLocale) {
	    var lookupMatcher = createLookupMatcher(getDefaultLocale);
	    var bestFitMatcher = createBestFitMatcher(getDefaultLocale);
	    /**
	     * https://tc39.es/ecma402/#sec-resolvelocale
	     */
	    return function resolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	        var matcher = options.localeMatcher;
	        var r;
	        if (matcher === 'lookup') {
	            r = lookupMatcher(availableLocales, requestedLocales);
	        }
	        else {
	            r = bestFitMatcher(availableLocales, requestedLocales);
	        }
	        var foundLocale = r.locale;
	        var result = { locale: '', dataLocale: foundLocale };
	        var supportedExtension = '-u';
	        for (var _i = 0, relevantExtensionKeys_1 = relevantExtensionKeys; _i < relevantExtensionKeys_1.length; _i++) {
	            var key = relevantExtensionKeys_1[_i];
	            var foundLocaleData = localeData[foundLocale];
	            invariant_1.invariant(typeof foundLocaleData === 'object' && foundLocaleData !== null, "locale data " + key + " must be an object");
	            var keyLocaleData = foundLocaleData[key];
	            invariant_1.invariant(Array.isArray(keyLocaleData), "keyLocaleData for " + key + " must be an array");
	            var value = keyLocaleData[0];
	            invariant_1.invariant(typeof value === 'string' || value === null, 'value must be string or null');
	            var supportedExtensionAddition = '';
	            if (r.extension) {
	                var requestedValue = unicodeExtensionValue(r.extension, key);
	                if (requestedValue !== undefined) {
	                    if (requestedValue !== '') {
	                        if (~keyLocaleData.indexOf(requestedValue)) {
	                            value = requestedValue;
	                            supportedExtensionAddition = "-" + key + "-" + value;
	                        }
	                    }
	                    else if (~requestedValue.indexOf('true')) {
	                        value = 'true';
	                        supportedExtensionAddition = "-" + key;
	                    }
	                }
	            }
	            if (key in options) {
	                var optionsValue = options[key];
	                invariant_1.invariant(typeof optionsValue === 'string' ||
	                    typeof optionsValue === 'undefined' ||
	                    optionsValue === null, 'optionsValue must be String, Undefined or Null');
	                if (~keyLocaleData.indexOf(optionsValue)) {
	                    if (optionsValue !== value) {
	                        value = optionsValue;
	                        supportedExtensionAddition = '';
	                    }
	                }
	            }
	            result[key] = value;
	            supportedExtension += supportedExtensionAddition;
	        }
	        if (supportedExtension.length > 2) {
	            var privateIndex = foundLocale.indexOf('-x-');
	            if (privateIndex === -1) {
	                foundLocale = foundLocale + supportedExtension;
	            }
	            else {
	                var preExtension = foundLocale.slice(0, privateIndex);
	                var postExtension = foundLocale.slice(privateIndex, foundLocale.length);
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	            foundLocale = get_canonical_locales_1.getCanonicalLocales(foundLocale)[0];
	        }
	        result.locale = foundLocale;
	        return result;
	    };
	}
	exports.createResolveLocale = createResolveLocale;
	/**
	 * https://tc39.es/ecma402/#sec-unicodeextensionvalue
	 * @param extension
	 * @param key
	 */
	function unicodeExtensionValue(extension, key) {
	    invariant_1.invariant(key.length === 2, 'key must have 2 elements');
	    var size = extension.length;
	    var searchValue = "-" + key + "-";
	    var pos = extension.indexOf(searchValue);
	    if (pos !== -1) {
	        var start = pos + 4;
	        var end = start;
	        var k = start;
	        var done = false;
	        while (!done) {
	            var e = extension.indexOf('-', k);
	            var len = void 0;
	            if (e === -1) {
	                len = size - k;
	            }
	            else {
	                len = e - k;
	            }
	            if (len === 2) {
	                done = true;
	            }
	            else if (e === -1) {
	                end = size;
	                done = true;
	            }
	            else {
	                end = e;
	                k = e + 1;
	            }
	        }
	        return extension.slice(start, end);
	    }
	    searchValue = "-" + key;
	    pos = extension.indexOf(searchValue);
	    if (pos !== -1 && pos + 3 === size) {
	        return '';
	    }
	    return undefined;
	}
	var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
	/**
	 * https://tc39.es/ecma402/#sec-bestavailablelocale
	 * @param availableLocales
	 * @param locale
	 */
	function bestAvailableLocale(availableLocales, locale) {
	    var candidate = locale;
	    while (true) {
	        if (~availableLocales.indexOf(candidate)) {
	            return candidate;
	        }
	        var pos = candidate.lastIndexOf('-');
	        if (!~pos) {
	            return undefined;
	        }
	        if (pos >= 2 && candidate[pos - 2] === '-') {
	            pos -= 2;
	        }
	        candidate = candidate.slice(0, pos);
	    }
	}
	function createLookupMatcher(getDefaultLocale) {
	    /**
	     * https://tc39.es/ecma402/#sec-lookupmatcher
	     */
	    return function lookupMatcher(availableLocales, requestedLocales) {
	        var result = { locale: '' };
	        for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
	            var locale = requestedLocales_1[_i];
	            var noExtensionLocale = locale.replace(UNICODE_EXTENSION_SEQUENCE_REGEX, '');
	            var availableLocale = bestAvailableLocale(availableLocales, noExtensionLocale);
	            if (availableLocale) {
	                result.locale = availableLocale;
	                if (locale !== noExtensionLocale) {
	                    result.extension = locale.slice(noExtensionLocale.length + 1, locale.length);
	                }
	                return result;
	            }
	        }
	        result.locale = getDefaultLocale();
	        return result;
	    };
	}
	function createBestFitMatcher(getDefaultLocale) {
	    return function bestFitMatcher(availableLocales, requestedLocales) {
	        var result = { locale: '' };
	        for (var _i = 0, requestedLocales_2 = requestedLocales; _i < requestedLocales_2.length; _i++) {
	            var locale = requestedLocales_2[_i];
	            var noExtensionLocale = locale.replace(UNICODE_EXTENSION_SEQUENCE_REGEX, '');
	            var availableLocale = bestAvailableLocale(availableLocales, noExtensionLocale);
	            if (availableLocale) {
	                result.locale = availableLocale;
	                if (locale !== noExtensionLocale) {
	                    result.extension = locale.slice(noExtensionLocale.length + 1, locale.length);
	                }
	                return result;
	            }
	        }
	        result.locale = getDefaultLocale();
	        return result;
	    };
	}
	function getLocaleHierarchy(locale, aliases, parentLocales) {
	    var results = [locale];
	    if (aliases[locale]) {
	        locale = aliases[locale];
	        results.push(locale);
	    }
	    var parentLocale = parentLocales[locale];
	    if (parentLocale) {
	        results.push(parentLocale);
	    }
	    var localeParts = locale.split('-');
	    for (var i = localeParts.length; i > 1; i--) {
	        results.push(localeParts.slice(0, i - 1).join('-'));
	    }
	    return results;
	}
	exports.getLocaleHierarchy = getLocaleHierarchy;
	function lookupSupportedLocales(availableLocales, requestedLocales) {
	    var subset = [];
	    for (var _i = 0, requestedLocales_3 = requestedLocales; _i < requestedLocales_3.length; _i++) {
	        var locale = requestedLocales_3[_i];
	        var noExtensionLocale = locale.replace(UNICODE_EXTENSION_SEQUENCE_REGEX, '');
	        var availableLocale = bestAvailableLocale(availableLocales, noExtensionLocale);
	        if (availableLocale) {
	            subset.push(availableLocale);
	        }
	    }
	    return subset;
	}
	function supportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = 'best fit';
	    if (options !== undefined) {
	        options = polyfill_utils_1.toObject(options);
	        matcher = polyfill_utils_1.getOption(options, 'localeMatcher', 'string', ['lookup', 'best fit'], 'best fit');
	    }
	    if (matcher === 'best fit') {
	        return lookupSupportedLocales(availableLocales, requestedLocales);
	    }
	    return lookupSupportedLocales(availableLocales, requestedLocales);
	}
	exports.supportedLocales = supportedLocales;
	var MissingLocaleDataError = /** @class */ (function (_super) {
	    __extends(MissingLocaleDataError, _super);
	    function MissingLocaleDataError() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.type = 'MISSING_LOCALE_DATA';
	        return _this;
	    }
	    return MissingLocaleDataError;
	}(Error));
	function isMissingLocaleDataError(e) {
	    return e.type === 'MISSING_LOCALE_DATA';
	}
	exports.isMissingLocaleDataError = isMissingLocaleDataError;
	function unpackData(locale, localeData, 
	/** By default shallow merge the dictionaries. */
	reducer) {
	    if (reducer === void 0) { reducer = function (all, d) { return (__assign(__assign({}, all), d)); }; }
	    var localeHierarchy = getLocaleHierarchy(locale, localeData.aliases, localeData.parentLocales);
	    var dataToMerge = localeHierarchy
	        .map(function (l) { return localeData.data[l]; })
	        .filter(Boolean);
	    if (!dataToMerge.length) {
	        throw new MissingLocaleDataError("Missing locale data for \"" + locale + "\", lookup hierarchy: " + localeHierarchy.join(', '));
	    }
	    dataToMerge.reverse();
	    return dataToMerge.reduce(reducer, {});
	}
	exports.unpackData = unpackData;
	//# sourceMappingURL=resolve-locale.js.map

/***/ }),
/* 2903 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// https://tc39.es/proposal-unified-intl-numberformat/section6/locales-currencies-tz_diff_out.html#sec-issanctionedsimpleunitidentifier
	exports.SANCTIONED_UNITS = [
	    'angle-degree',
	    'area-acre',
	    'area-hectare',
	    'concentr-percent',
	    'digital-bit',
	    'digital-byte',
	    'digital-gigabit',
	    'digital-gigabyte',
	    'digital-kilobit',
	    'digital-kilobyte',
	    'digital-megabit',
	    'digital-megabyte',
	    'digital-petabyte',
	    'digital-terabit',
	    'digital-terabyte',
	    'duration-day',
	    'duration-hour',
	    'duration-millisecond',
	    'duration-minute',
	    'duration-month',
	    'duration-second',
	    'duration-week',
	    'duration-year',
	    'length-centimeter',
	    'length-foot',
	    'length-inch',
	    'length-kilometer',
	    'length-meter',
	    'length-mile-scandinavian',
	    'length-mile',
	    'length-millimeter',
	    'length-yard',
	    'mass-gram',
	    'mass-kilogram',
	    'mass-ounce',
	    'mass-pound',
	    'mass-stone',
	    'temperature-celsius',
	    'temperature-fahrenheit',
	    'volume-fluid-ounce',
	    'volume-gallon',
	    'volume-liter',
	    'volume-milliliter',
	];
	// In CLDR, the unit name always follows the form `namespace-unit` pattern.
	// For example: `digital-bit` instead of `bit`. This function removes the namespace prefix.
	function removeUnitNamespace(unit) {
	    return unit.replace(/^(.*?)-/, '');
	}
	exports.removeUnitNamespace = removeUnitNamespace;
	//# sourceMappingURL=units.js.map

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asap = asap;
	
	var _raw = __webpack_require__(2906);
	
	var freeTasks = [];
	/**
	 * Calls a task as soon as possible after returning, in its own event, with
	 * priority over IO events. An exception thrown in a task can be handled by
	 * `process.on("uncaughtException") or `domain.on("error")`, but will otherwise
	 * crash the process. If the error is handled, all subsequent tasks will
	 * resume.
	 *
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	
	function asap(task) {
	  var rawTask;
	
	  if (freeTasks.length) {
	    rawTask = freeTasks.pop();
	  } else {
	    rawTask = new RawTask();
	  }
	
	  rawTask.task = task;
	  rawTask.domain = process.domain;
	  (0, _raw.rawAsap)(rawTask);
	}
	
	var RawTask =
	/** @class */
	function () {
	  function RawTask() {}
	
	  RawTask.prototype.call = function () {
	    if (this.domain) {
	      this.domain.enter();
	    }
	
	    var threw = true;
	
	    try {
	      this.task.call();
	      threw = false; // If the task throws an exception (presumably) Node.js restores the
	      // domain stack for the next event.
	
	      if (this.domain) {
	        this.domain.exit();
	      }
	    } finally {
	      // We use try/finally and a threw flag to avoid messing up stack traces
	      // when we catch and release errors.
	      if (threw) {
	        // In Node.js, uncaught exceptions are considered fatal errors.
	        // Re-throw them to interrupt flushing!
	        // Ensure that flushing continues if an uncaught exception is
	        // suppressed listening process.on("uncaughtException") or
	        // domain.on("error").
	        _raw.rawAsap.requestFlush();
	      } // If the task threw an error, we do not want to exit the domain here.
	      // Exiting the domain would prevent the domain from catching the error.
	
	
	      this.task = null;
	      this.domain = null;
	      freeTasks.push(this);
	    }
	  };
	
	  return RawTask;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(583)))

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _asap = __webpack_require__(2904);
	
	Object.keys(_asap).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _asap[key];
	    }
	  });
	});

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rawAsap = rawAsap;
	var domain; // The domain module is executed on demand
	
	var hasSetImmediate = typeof setImmediate === 'function'; // Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including network IO events in Node.js.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	
	function rawAsap(task) {
	  if (!queue.length) {
	    requestFlush();
	    flushing = true;
	  } // Avoids a function call
	
	
	  queue[queue.length] = task;
	}
	
	var queue = []; // Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	
	var flushing = false; // The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	
	var index = 0; // If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory excaustion, the task queue will periodically
	// truncate already-completed tasks.
	
	var capacity = 1024; // The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	
	function flush() {
	  while (index < queue.length) {
	    var currentIndex = index; // Advance the index before calling the task. This ensures that we will
	    // begin flushing on the next task the task throws an error.
	
	    index = index + 1;
	    queue[currentIndex].call(); // Prevent leaking memory for long chains of recursive calls to `asap`.
	    // If we call `asap` within tasks scheduled by `asap`, the queue will
	    // grow, but to avoid an O(n) walk for every task we execute, we don't
	    // shift tasks off the queue after they have been executed.
	    // Instead, we periodically shift 1024 tasks off the queue.
	
	    if (index > capacity) {
	      // Manually shift all values starting at the index back to the
	      // beginning of the queue.
	      for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	        queue[scan] = queue[scan + index];
	      }
	
	      queue.length -= index;
	      index = 0;
	    }
	  }
	
	  queue.length = 0;
	  index = 0;
	  flushing = false;
	}
	
	rawAsap.requestFlush = requestFlush;
	
	function requestFlush() {
	  // Ensure flushing is not bound to any domain.
	  // It is not sufficient to exit the domain, because domains exist on a stack.
	  // To execute code outside of any domain, the following dance is necessary.
	  var parentDomain = process.domain;
	
	  if (parentDomain) {
	    if (!domain) {
	      // Lazy execute the domain module.
	      // Only employed if the user elects to use domains.
	      domain = __webpack_require__(4887);
	    }
	
	    domain.active = process.domain = null;
	  } // `setImmediate` is slower that `process.nextTick`, but `process.nextTick`
	  // cannot handle recursion.
	  // `requestFlush` will only be called recursively from `asap.js`, to resume
	  // flushing after an error is thrown into a domain.
	  // Conveniently, `setImmediate` was introduced in the same version
	  // `process.nextTick` started throwing recursion errors.
	
	
	  if (flushing && hasSetImmediate) {
	    setImmediate(flush);
	  } else {
	    process.nextTick(flush);
	  }
	
	  if (parentDomain) {
	    domain.active = process.domain = parentDomain;
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6488).setImmediate, __webpack_require__(583)))

/***/ }),
/* 2907 */
/***/ (function(module, exports) {

	"use strict";exports.invariant=function(r,e){for(var n=arguments.length,i=new Array(n>2?n-2:0),o=2;o<n;o++)i[o-2]=arguments[o];if(!r){var a;if(void 0===e)a=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var t=0;(a=new Error(e.replace(/%s/g,(function(){return i[t++]})))).name="Invariant Violation"}throw a.framesToPop=1,a}};
	//# sourceMappingURL=invariant.cjs.production.min.js.map


/***/ }),
/* 2908 */
/***/ (function(module, exports) {

	"use strict";exports.shallowEqual=function(r,t,e,o){var n=e?e.call(o,r,t):void 0;if(void 0!==n)return!!n;if(r===t)return!0;if("object"!=typeof r||!r||"object"!=typeof t||!t)return!1;var i=Object.keys(r),a=Object.keys(t);if(i.length!==a.length)return!1;for(var f=Object.prototype.hasOwnProperty.bind(t),l=0;l<i.length;l++){var u=i[l];if(!f(u))return!1;var c=r[u],v=t[u];if(!1===(n=e?e.call(o,c,v,u):void 0)||void 0===n&&c!==v)return!1}return!0};
	//# sourceMappingURL=shallowequal.cjs.production.min.js.map


/***/ }),
/* 2909 */,
/* 2910 */,
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	__webpack_require__(600);
	__webpack_require__(1060);
	var is = __webpack_require__(1062);
	var __chunk_1 = __webpack_require__(1666);
	__webpack_require__(1061);
	
	var done = function done(value) {
	  return {
	    done: true,
	    value: value
	  };
	};
	
	var qEnd = {};
	function safeName(patternOrChannel) {
	  if (is.channel(patternOrChannel)) {
	    return 'channel';
	  }
	
	  if (is.stringableFunc(patternOrChannel)) {
	    return String(patternOrChannel);
	  }
	
	  if (is.func(patternOrChannel)) {
	    return patternOrChannel.name;
	  }
	
	  return String(patternOrChannel);
	}
	function fsmIterator(fsm, startState, name) {
	  var stateUpdater,
	      errorState,
	      effect,
	      nextState = startState;
	
	  function next(arg, error) {
	    if (nextState === qEnd) {
	      return done(arg);
	    }
	
	    if (error && !errorState) {
	      nextState = qEnd;
	      throw error;
	    } else {
	      stateUpdater && stateUpdater(arg);
	      var currentState = error ? fsm[errorState](error) : fsm[nextState]();
	      nextState = currentState.nextState;
	      effect = currentState.effect;
	      stateUpdater = currentState.stateUpdater;
	      errorState = currentState.errorState;
	      return nextState === qEnd ? done(arg) : effect;
	    }
	  }
	
	  return __chunk_1.makeIterator(next, function (error) {
	    return next(null, error);
	  }, name);
	}
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = {
	    done: false,
	    value: __chunk_1.take(patternOrChannel)
	  };
	
	  var yFork = function yFork(ac) {
	    return {
	      done: false,
	      value: __chunk_1.fork.apply(void 0, [worker].concat(args, [ac]))
	    };
	  };
	
	  var action,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return {
	        nextState: 'q2',
	        effect: yTake,
	        stateUpdater: setAction
	      };
	    },
	    q2: function q2() {
	      return {
	        nextState: 'q1',
	        effect: yFork(action)
	      };
	    }
	  }, 'q1', "takeEvery(" + safeName(patternOrChannel) + ", " + worker.name + ")");
	}
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = {
	    done: false,
	    value: __chunk_1.take(patternOrChannel)
	  };
	
	  var yFork = function yFork(ac) {
	    return {
	      done: false,
	      value: __chunk_1.fork.apply(void 0, [worker].concat(args, [ac]))
	    };
	  };
	
	  var yCancel = function yCancel(task) {
	    return {
	      done: false,
	      value: __chunk_1.cancel(task)
	    };
	  };
	
	  var task, action;
	
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return {
	        nextState: 'q2',
	        effect: yTake,
	        stateUpdater: setAction
	      };
	    },
	    q2: function q2() {
	      return task ? {
	        nextState: 'q3',
	        effect: yCancel(task)
	      } : {
	        nextState: 'q1',
	        effect: yFork(action),
	        stateUpdater: setTask
	      };
	    },
	    q3: function q3() {
	      return {
	        nextState: 'q1',
	        effect: yFork(action),
	        stateUpdater: setTask
	      };
	    }
	  }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
	}
	
	function takeLeading(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = {
	    done: false,
	    value: __chunk_1.take(patternOrChannel)
	  };
	
	  var yCall = function yCall(ac) {
	    return {
	      done: false,
	      value: __chunk_1.call.apply(void 0, [worker].concat(args, [ac]))
	    };
	  };
	
	  var action;
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return {
	        nextState: 'q2',
	        effect: yTake,
	        stateUpdater: setAction
	      };
	    },
	    q2: function q2() {
	      return {
	        nextState: 'q1',
	        effect: yCall(action)
	      };
	    }
	  }, 'q1', "takeLeading(" + safeName(patternOrChannel) + ", " + worker.name + ")");
	}
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var action, channel;
	  var yActionChannel = {
	    done: false,
	    value: __chunk_1.actionChannel(pattern, __chunk_1.sliding(1))
	  };
	
	  var yTake = function yTake() {
	    return {
	      done: false,
	      value: __chunk_1.take(channel)
	    };
	  };
	
	  var yFork = function yFork(ac) {
	    return {
	      done: false,
	      value: __chunk_1.fork.apply(void 0, [worker].concat(args, [ac]))
	    };
	  };
	
	  var yDelay = {
	    done: false,
	    value: __chunk_1.delay(delayLength)
	  };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return {
	        nextState: 'q2',
	        effect: yActionChannel,
	        stateUpdater: setChannel
	      };
	    },
	    q2: function q2() {
	      return {
	        nextState: 'q3',
	        effect: yTake(),
	        stateUpdater: setAction
	      };
	    },
	    q3: function q3() {
	      return {
	        nextState: 'q4',
	        effect: yFork(action)
	      };
	    },
	    q4: function q4() {
	      return {
	        nextState: 'q2',
	        effect: yDelay
	      };
	    }
	  }, 'q1', "throttle(" + safeName(pattern) + ", " + worker.name + ")");
	}
	
	function retry(maxTries, delayLength, fn) {
	  var counter = maxTries;
	
	  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var yCall = {
	    done: false,
	    value: __chunk_1.call.apply(void 0, [fn].concat(args))
	  };
	  var yDelay = {
	    done: false,
	    value: __chunk_1.delay(delayLength)
	  };
	  return fsmIterator({
	    q1: function q1() {
	      return {
	        nextState: 'q2',
	        effect: yCall,
	        errorState: 'q10'
	      };
	    },
	    q2: function q2() {
	      return {
	        nextState: qEnd
	      };
	    },
	    q10: function q10(error) {
	      counter -= 1;
	
	      if (counter <= 0) {
	        throw error;
	      }
	
	      return {
	        nextState: 'q1',
	        effect: yDelay
	      };
	    }
	  }, 'q1', "retry(" + fn.name + ")");
	}
	
	function debounceHelper(delayLength, patternOrChannel, worker) {
	  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var action, raceOutput;
	  var yTake = {
	    done: false,
	    value: __chunk_1.take(patternOrChannel)
	  };
	  var yRace = {
	    done: false,
	    value: __chunk_1.race({
	      action: __chunk_1.take(patternOrChannel),
	      debounce: __chunk_1.delay(delayLength)
	    })
	  };
	
	  var yFork = function yFork(ac) {
	    return {
	      done: false,
	      value: __chunk_1.fork.apply(void 0, [worker].concat(args, [ac]))
	    };
	  };
	
	  var yNoop = function yNoop(value) {
	    return {
	      done: false,
	      value: value
	    };
	  };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  var setRaceOutput = function setRaceOutput(ro) {
	    return raceOutput = ro;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return {
	        nextState: 'q2',
	        effect: yTake,
	        stateUpdater: setAction
	      };
	    },
	    q2: function q2() {
	      return {
	        nextState: 'q3',
	        effect: yRace,
	        stateUpdater: setRaceOutput
	      };
	    },
	    q3: function q3() {
	      return raceOutput.debounce ? {
	        nextState: 'q1',
	        effect: yFork(action)
	      } : {
	        nextState: 'q2',
	        effect: yNoop(raceOutput.action),
	        stateUpdater: setAction
	      };
	    }
	  }, 'q1', "debounce(" + safeName(patternOrChannel) + ", " + worker.name + ")");
	}
	
	function takeEvery$1(patternOrChannel, worker) {
	
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  return __chunk_1.fork.apply(void 0, [takeEvery, patternOrChannel, worker].concat(args));
	}
	function takeLatest$1(patternOrChannel, worker) {
	
	  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    args[_key2 - 2] = arguments[_key2];
	  }
	
	  return __chunk_1.fork.apply(void 0, [takeLatest, patternOrChannel, worker].concat(args));
	}
	function takeLeading$1(patternOrChannel, worker) {
	
	  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	    args[_key3 - 2] = arguments[_key3];
	  }
	
	  return __chunk_1.fork.apply(void 0, [takeLeading, patternOrChannel, worker].concat(args));
	}
	function throttle$1(ms, pattern, worker) {
	
	  for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	    args[_key4 - 3] = arguments[_key4];
	  }
	
	  return __chunk_1.fork.apply(void 0, [throttle, ms, pattern, worker].concat(args));
	}
	function retry$1(maxTries, delayLength, worker) {
	  for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
	    args[_key5 - 3] = arguments[_key5];
	  }
	
	  return __chunk_1.call.apply(void 0, [retry, maxTries, delayLength, worker].concat(args));
	}
	function debounce(delayLength, pattern, worker) {
	  for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
	    args[_key6 - 3] = arguments[_key6];
	  }
	
	  return __chunk_1.fork.apply(void 0, [debounceHelper, delayLength, pattern, worker].concat(args));
	}
	
	exports.effectTypes = __chunk_1.effectTypes;
	exports.take = __chunk_1.take;
	exports.takeMaybe = __chunk_1.takeMaybe;
	exports.put = __chunk_1.put;
	exports.putResolve = __chunk_1.putResolve;
	exports.all = __chunk_1.all;
	exports.race = __chunk_1.race;
	exports.call = __chunk_1.call;
	exports.apply = __chunk_1.apply;
	exports.cps = __chunk_1.cps;
	exports.fork = __chunk_1.fork;
	exports.spawn = __chunk_1.spawn;
	exports.join = __chunk_1.join;
	exports.cancel = __chunk_1.cancel;
	exports.select = __chunk_1.select;
	exports.actionChannel = __chunk_1.actionChannel;
	exports.cancelled = __chunk_1.cancelled;
	exports.flush = __chunk_1.flush;
	exports.getContext = __chunk_1.getContext;
	exports.setContext = __chunk_1.setContext;
	exports.delay = __chunk_1.delay;
	exports.debounce = debounce;
	exports.retry = retry$1;
	exports.takeEvery = takeEvery$1;
	exports.takeLatest = takeLatest$1;
	exports.takeLeading = takeLeading$1;
	exports.throttle = throttle$1;


/***/ }),
/* 2912 */,
/* 2913 */,
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var core_1 = __webpack_require__(192);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var eventbuilder_1 = __webpack_require__(1063);
	var transports_1 = __webpack_require__(1670);
	/**
	 * The Sentry Browser SDK Backend.
	 * @hidden
	 */
	var BrowserBackend = /** @class */ (function (_super) {
	    tslib_1.__extends(BrowserBackend, _super);
	    function BrowserBackend() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromException = function (exception, hint) {
	        return eventbuilder_1.eventFromException(this._options, exception, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
	        if (level === void 0) { level = types_1.Severity.Info; }
	        return eventbuilder_1.eventFromMessage(this._options, message, level, hint);
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserBackend.prototype._setupTransport = function () {
	        if (!this._options.dsn) {
	            // We return the noop transport here in case there is no Dsn.
	            return _super.prototype._setupTransport.call(this);
	        }
	        var transportOptions = tslib_1.__assign(tslib_1.__assign({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
	        if (this._options.transport) {
	            return new this._options.transport(transportOptions);
	        }
	        if (utils_1.supportsFetch()) {
	            return new transports_1.FetchTransport(transportOptions);
	        }
	        return new transports_1.XHRTransport(transportOptions);
	    };
	    return BrowserBackend;
	}(core_1.BaseBackend));
	exports.BrowserBackend = BrowserBackend;
	//# sourceMappingURL=backend.js.map

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(164);
	exports.Severity = types_1.Severity;
	exports.Status = types_1.Status;
	var core_1 = __webpack_require__(192);
	exports.addGlobalEventProcessor = core_1.addGlobalEventProcessor;
	exports.addBreadcrumb = core_1.addBreadcrumb;
	exports.captureException = core_1.captureException;
	exports.captureEvent = core_1.captureEvent;
	exports.captureMessage = core_1.captureMessage;
	exports.configureScope = core_1.configureScope;
	exports.getHubFromCarrier = core_1.getHubFromCarrier;
	exports.getCurrentHub = core_1.getCurrentHub;
	exports.Hub = core_1.Hub;
	exports.makeMain = core_1.makeMain;
	exports.Scope = core_1.Scope;
	exports.startTransaction = core_1.startTransaction;
	exports.SDK_VERSION = core_1.SDK_VERSION;
	exports.setContext = core_1.setContext;
	exports.setExtra = core_1.setExtra;
	exports.setExtras = core_1.setExtras;
	exports.setTag = core_1.setTag;
	exports.setTags = core_1.setTags;
	exports.setUser = core_1.setUser;
	exports.withScope = core_1.withScope;
	var client_1 = __webpack_require__(1668);
	exports.BrowserClient = client_1.BrowserClient;
	var helpers_1 = __webpack_require__(601);
	exports.injectReportDialog = helpers_1.injectReportDialog;
	var eventbuilder_1 = __webpack_require__(1063);
	exports.eventFromException = eventbuilder_1.eventFromException;
	exports.eventFromMessage = eventbuilder_1.eventFromMessage;
	var sdk_1 = __webpack_require__(2922);
	exports.defaultIntegrations = sdk_1.defaultIntegrations;
	exports.forceLoad = sdk_1.forceLoad;
	exports.init = sdk_1.init;
	exports.lastEventId = sdk_1.lastEventId;
	exports.onLoad = sdk_1.onLoad;
	exports.showReportDialog = sdk_1.showReportDialog;
	exports.flush = sdk_1.flush;
	exports.close = sdk_1.close;
	exports.wrap = sdk_1.wrap;
	var version_1 = __webpack_require__(2925);
	exports.SDK_NAME = version_1.SDK_NAME;
	//# sourceMappingURL=exports.js.map

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable max-lines */
	var core_1 = __webpack_require__(192);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	/**
	 * Default Breadcrumbs instrumentations
	 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
	 */
	var Breadcrumbs = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Breadcrumbs(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = Breadcrumbs.id;
	        this._options = tslib_1.__assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
	    }
	    /**
	     * Create a breadcrumb of `sentry` from the events themselves
	     */
	    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
	        if (!this._options.sentry) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
	            event_id: event.event_id,
	            level: event.level,
	            message: utils_1.getEventDescription(event),
	        }, {
	            event: event,
	        });
	    };
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - Console API
	     *  - DOM API (click/typing)
	     *  - XMLHttpRequest API
	     *  - Fetch API
	     *  - History API
	     */
	    Breadcrumbs.prototype.setupOnce = function () {
	        var _this = this;
	        if (this._options.console) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._consoleBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'console',
	            });
	        }
	        if (this._options.dom) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._domBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'dom',
	            });
	        }
	        if (this._options.xhr) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._xhrBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'xhr',
	            });
	        }
	        if (this._options.fetch) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._fetchBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'fetch',
	            });
	        }
	        if (this._options.history) {
	            utils_1.addInstrumentationHandler({
	                callback: function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    _this._historyBreadcrumb.apply(_this, tslib_1.__spread(args));
	                },
	                type: 'history',
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from console API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
	        var breadcrumb = {
	            category: 'console',
	            data: {
	                arguments: handlerData.args,
	                logger: 'console',
	            },
	            level: types_1.Severity.fromString(handlerData.level),
	            message: utils_1.safeJoin(handlerData.args, ' '),
	        };
	        if (handlerData.level === 'assert') {
	            if (handlerData.args[0] === false) {
	                breadcrumb.message = "Assertion failed: " + (utils_1.safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
	                breadcrumb.data.arguments = handlerData.args.slice(1);
	            }
	            else {
	                // Don't capture a breadcrumb for passed assertions
	                return;
	            }
	        }
	        core_1.getCurrentHub().addBreadcrumb(breadcrumb, {
	            input: handlerData.args,
	            level: handlerData.level,
	        });
	    };
	    /**
	     * Creates breadcrumbs from DOM API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
	        var target;
	        var keyAttrs = typeof this._options.dom === 'object' ? this._options.dom.serializeAttribute : undefined;
	        if (typeof keyAttrs === 'string') {
	            keyAttrs = [keyAttrs];
	        }
	        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
	        try {
	            target = handlerData.event.target
	                ? utils_1.htmlTreeAsString(handlerData.event.target, keyAttrs)
	                : utils_1.htmlTreeAsString(handlerData.event, keyAttrs);
	        }
	        catch (e) {
	            target = '<unknown>';
	        }
	        if (target.length === 0) {
	            return;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: "ui." + handlerData.name,
	            message: target,
	        }, {
	            event: handlerData.event,
	            name: handlerData.name,
	            global: handlerData.global,
	        });
	    };
	    /**
	     * Creates breadcrumbs from XHR API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
	        if (handlerData.endTimestamp) {
	            // We only capture complete, non-sentry requests
	            if (handlerData.xhr.__sentry_own_request__) {
	                return;
	            }
	            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'xhr',
	                data: {
	                    method: method,
	                    url: url,
	                    status_code: status_code,
	                },
	                type: 'http',
	            }, {
	                xhr: handlerData.xhr,
	                input: body,
	            });
	            return;
	        }
	    };
	    /**
	     * Creates breadcrumbs from fetch API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
	        // We only capture complete fetch requests
	        if (!handlerData.endTimestamp) {
	            return;
	        }
	        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
	            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
	            return;
	        }
	        if (handlerData.error) {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: handlerData.fetchData,
	                level: types_1.Severity.Error,
	                type: 'http',
	            }, {
	                data: handlerData.error,
	                input: handlerData.args,
	            });
	        }
	        else {
	            core_1.getCurrentHub().addBreadcrumb({
	                category: 'fetch',
	                data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
	                type: 'http',
	            }, {
	                input: handlerData.args,
	                response: handlerData.response,
	            });
	        }
	    };
	    /**
	     * Creates breadcrumbs from history API calls
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
	        var global = utils_1.getGlobalObject();
	        var from = handlerData.from;
	        var to = handlerData.to;
	        var parsedLoc = utils_1.parseUrl(global.location.href);
	        var parsedFrom = utils_1.parseUrl(from);
	        var parsedTo = utils_1.parseUrl(to);
	        // Initial pushState doesn't provide `from` information
	        if (!parsedFrom.path) {
	            parsedFrom = parsedLoc;
	        }
	        // Use only the path component of the URL if the URL matches the current
	        // document (almost all the time when using pushState)
	        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
	            to = parsedTo.relative;
	        }
	        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
	            from = parsedFrom.relative;
	        }
	        core_1.getCurrentHub().addBreadcrumb({
	            category: 'navigation',
	            data: {
	                from: from,
	                to: to,
	            },
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Breadcrumbs.id = 'Breadcrumbs';
	    return Breadcrumbs;
	}());
	exports.Breadcrumbs = Breadcrumbs;
	//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	/** Deduplication filter */
	var Dedupe = /** @class */ (function () {
	    function Dedupe() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Dedupe.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
	        addGlobalEventProcessor(function (currentEvent) {
	            var self = getCurrentHub().getIntegration(Dedupe);
	            if (self) {
	                // Juuust in case something goes wrong
	                try {
	                    if (self._shouldDropEvent(currentEvent, self._previousEvent)) {
	                        utils_1.logger.warn("Event dropped due to being a duplicate of previously captured event.");
	                        return null;
	                    }
	                }
	                catch (_oO) {
	                    return (self._previousEvent = currentEvent);
	                }
	                return (self._previousEvent = currentEvent);
	            }
	            return currentEvent;
	        });
	    };
	    /** JSDoc */
	    Dedupe.prototype._shouldDropEvent = function (currentEvent, previousEvent) {
	        if (!previousEvent) {
	            return false;
	        }
	        if (this._isSameMessageEvent(currentEvent, previousEvent)) {
	            return true;
	        }
	        if (this._isSameExceptionEvent(currentEvent, previousEvent)) {
	            return true;
	        }
	        return false;
	    };
	    /** JSDoc */
	    Dedupe.prototype._isSameMessageEvent = function (currentEvent, previousEvent) {
	        var currentMessage = currentEvent.message;
	        var previousMessage = previousEvent.message;
	        // If neither event has a message property, they were both exceptions, so bail out
	        if (!currentMessage && !previousMessage) {
	            return false;
	        }
	        // If only one event has a stacktrace, but not the other one, they are not the same
	        if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
	            return false;
	        }
	        if (currentMessage !== previousMessage) {
	            return false;
	        }
	        if (!this._isSameFingerprint(currentEvent, previousEvent)) {
	            return false;
	        }
	        if (!this._isSameStacktrace(currentEvent, previousEvent)) {
	            return false;
	        }
	        return true;
	    };
	    /** JSDoc */
	    Dedupe.prototype._getFramesFromEvent = function (event) {
	        var exception = event.exception;
	        if (exception) {
	            try {
	                // @ts-ignore Object could be undefined
	                return exception.values[0].stacktrace.frames;
	            }
	            catch (_oO) {
	                return undefined;
	            }
	        }
	        else if (event.stacktrace) {
	            return event.stacktrace.frames;
	        }
	        return undefined;
	    };
	    /** JSDoc */
	    Dedupe.prototype._isSameStacktrace = function (currentEvent, previousEvent) {
	        var currentFrames = this._getFramesFromEvent(currentEvent);
	        var previousFrames = this._getFramesFromEvent(previousEvent);
	        // If neither event has a stacktrace, they are assumed to be the same
	        if (!currentFrames && !previousFrames) {
	            return true;
	        }
	        // If only one event has a stacktrace, but not the other one, they are not the same
	        if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
	            return false;
	        }
	        currentFrames = currentFrames;
	        previousFrames = previousFrames;
	        // If number of frames differ, they are not the same
	        if (previousFrames.length !== currentFrames.length) {
	            return false;
	        }
	        // Otherwise, compare the two
	        for (var i = 0; i < previousFrames.length; i++) {
	            var frameA = previousFrames[i];
	            var frameB = currentFrames[i];
	            if (frameA.filename !== frameB.filename ||
	                frameA.lineno !== frameB.lineno ||
	                frameA.colno !== frameB.colno ||
	                frameA.function !== frameB.function) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /** JSDoc */
	    Dedupe.prototype._getExceptionFromEvent = function (event) {
	        return event.exception && event.exception.values && event.exception.values[0];
	    };
	    /** JSDoc */
	    Dedupe.prototype._isSameExceptionEvent = function (currentEvent, previousEvent) {
	        var previousException = this._getExceptionFromEvent(previousEvent);
	        var currentException = this._getExceptionFromEvent(currentEvent);
	        if (!previousException || !currentException) {
	            return false;
	        }
	        if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
	            return false;
	        }
	        if (!this._isSameFingerprint(currentEvent, previousEvent)) {
	            return false;
	        }
	        if (!this._isSameStacktrace(currentEvent, previousEvent)) {
	            return false;
	        }
	        return true;
	    };
	    /** JSDoc */
	    Dedupe.prototype._isSameFingerprint = function (currentEvent, previousEvent) {
	        var currentFingerprint = currentEvent.fingerprint;
	        var previousFingerprint = previousEvent.fingerprint;
	        // If neither event has a fingerprint, they are assumed to be the same
	        if (!currentFingerprint && !previousFingerprint) {
	            return true;
	        }
	        // If only one event has a fingerprint, but not the other one, they are not the same
	        if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
	            return false;
	        }
	        currentFingerprint = currentFingerprint;
	        previousFingerprint = previousFingerprint;
	        // Otherwise, compare the two
	        try {
	            return !!(currentFingerprint.join('') === previousFingerprint.join(''));
	        }
	        catch (_oO) {
	            return false;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Dedupe.id = 'Dedupe';
	    return Dedupe;
	}());
	exports.Dedupe = Dedupe;
	//# sourceMappingURL=dedupe.js.map

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	var core_1 = __webpack_require__(192);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var eventbuilder_1 = __webpack_require__(1063);
	var helpers_1 = __webpack_require__(601);
	/** Global handlers */
	var GlobalHandlers = /** @class */ (function () {
	    /** JSDoc */
	    function GlobalHandlers(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = GlobalHandlers.id;
	        /** JSDoc */
	        this._onErrorHandlerInstalled = false;
	        /** JSDoc */
	        this._onUnhandledRejectionHandlerInstalled = false;
	        this._options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
	    }
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.prototype.setupOnce = function () {
	        Error.stackTraceLimit = 50;
	        if (this._options.onerror) {
	            utils_1.logger.log('Global Handler attached: onerror');
	            this._installGlobalOnErrorHandler();
	        }
	        if (this._options.onunhandledrejection) {
	            utils_1.logger.log('Global Handler attached: onunhandledrejection');
	            this._installGlobalOnUnhandledRejectionHandler();
	        }
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
	        var _this = this;
	        if (this._onErrorHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (data) {
	                var error = data.error;
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return;
	                }
	                var client = currentHub.getClient();
	                var event = error === undefined && utils_1.isString(data.msg)
	                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
	                    : _this._enhanceEventWithInitialFrame(eventbuilder_1.eventFromUnknownInput(error || data.msg, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: false,
	                    }), data.url, data.line, data.column);
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onerror',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	            },
	            type: 'error',
	        });
	        this._onErrorHandlerInstalled = true;
	    };
	    /** JSDoc */
	    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
	        var _this = this;
	        if (this._onUnhandledRejectionHandlerInstalled) {
	            return;
	        }
	        utils_1.addInstrumentationHandler({
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            callback: function (e) {
	                var error = e;
	                // dig the object of the rejection out of known event types
	                try {
	                    // PromiseRejectionEvents store the object of the rejection under 'reason'
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
	                    if ('reason' in e) {
	                        error = e.reason;
	                    }
	                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
	                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
	                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
	                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
	                    // https://github.com/getsentry/sentry-javascript/issues/2380
	                    else if ('detail' in e && 'reason' in e.detail) {
	                        error = e.detail.reason;
	                    }
	                }
	                catch (_oO) {
	                    // no-empty
	                }
	                var currentHub = core_1.getCurrentHub();
	                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
	                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
	                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
	                    return true;
	                }
	                var client = currentHub.getClient();
	                var event = utils_1.isPrimitive(error)
	                    ? _this._eventFromRejectionWithPrimitive(error)
	                    : eventbuilder_1.eventFromUnknownInput(error, undefined, {
	                        attachStacktrace: client && client.getOptions().attachStacktrace,
	                        rejection: true,
	                    });
	                event.level = types_1.Severity.Error;
	                utils_1.addExceptionMechanism(event, {
	                    handled: false,
	                    type: 'onunhandledrejection',
	                });
	                currentHub.captureEvent(event, {
	                    originalException: error,
	                });
	                return;
	            },
	            type: 'unhandledrejection',
	        });
	        this._onUnhandledRejectionHandlerInstalled = true;
	    };
	    /**
	     * This function creates a stack from an old, error-less onerror handler.
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
	        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
	        // If 'message' is ErrorEvent, get real message from inside
	        var message = utils_1.isErrorEvent(msg) ? msg.message : msg;
	        var name;
	        var groups = message.match(ERROR_TYPES_RE);
	        if (groups) {
	            name = groups[1];
	            message = groups[2];
	        }
	        var event = {
	            exception: {
	                values: [
	                    {
	                        type: name || 'Error',
	                        value: message,
	                    },
	                ],
	            },
	        };
	        return this._enhanceEventWithInitialFrame(event, url, line, column);
	    };
	    /**
	     * Create an event from a promise rejection where the `reason` is a primitive.
	     *
	     * @param reason: The `reason` property of the promise rejection
	     * @returns An Event object with an appropriate `exception` value
	     */
	    GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function (reason) {
	        return {
	            exception: {
	                values: [
	                    {
	                        type: 'UnhandledRejection',
	                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
	                        value: "Non-Error promise rejection captured with value: " + String(reason),
	                    },
	                ],
	            },
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
	        event.exception = event.exception || {};
	        event.exception.values = event.exception.values || [];
	        event.exception.values[0] = event.exception.values[0] || {};
	        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
	        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
	        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
	        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
	        var filename = utils_1.isString(url) && url.length > 0 ? url : utils_1.getLocationHref();
	        if (event.exception.values[0].stacktrace.frames.length === 0) {
	            event.exception.values[0].stacktrace.frames.push({
	                colno: colno,
	                filename: filename,
	                function: '?',
	                in_app: true,
	                lineno: lineno,
	            });
	        }
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    GlobalHandlers.id = 'GlobalHandlers';
	    return GlobalHandlers;
	}());
	exports.GlobalHandlers = GlobalHandlers;
	//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var core_1 = __webpack_require__(192);
	var utils_1 = __webpack_require__(65);
	var parsers_1 = __webpack_require__(1669);
	var tracekit_1 = __webpack_require__(1065);
	var DEFAULT_KEY = 'cause';
	var DEFAULT_LIMIT = 5;
	/** Adds SDK info to an event. */
	var LinkedErrors = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function LinkedErrors(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = LinkedErrors.id;
	        this._key = options.key || DEFAULT_KEY;
	        this._limit = options.limit || DEFAULT_LIMIT;
	    }
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event, hint) {
	            var self = core_1.getCurrentHub().getIntegration(LinkedErrors);
	            if (self) {
	                var handler = self._handler && self._handler.bind(self);
	                return typeof handler === 'function' ? handler(event, hint) : event;
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._handler = function (event, hint) {
	        if (!event.exception || !event.exception.values || !hint || !utils_1.isInstanceOf(hint.originalException, Error)) {
	            return event;
	        }
	        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
	        event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
	        return event;
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
	        if (stack === void 0) { stack = []; }
	        if (!utils_1.isInstanceOf(error[key], Error) || stack.length + 1 >= this._limit) {
	            return stack;
	        }
	        var stacktrace = tracekit_1.computeStackTrace(error[key]);
	        var exception = parsers_1.exceptionFromStacktrace(stacktrace);
	        return this._walkErrorTree(error[key], key, tslib_1.__spread([exception], stack));
	    };
	    /**
	     * @inheritDoc
	     */
	    LinkedErrors.id = 'LinkedErrors';
	    return LinkedErrors;
	}());
	exports.LinkedErrors = LinkedErrors;
	//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	var helpers_1 = __webpack_require__(601);
	var DEFAULT_EVENT_TARGET = [
	    'EventTarget',
	    'Window',
	    'Node',
	    'ApplicationCache',
	    'AudioTrackList',
	    'ChannelMergerNode',
	    'CryptoOperation',
	    'EventSource',
	    'FileReader',
	    'HTMLUnknownElement',
	    'IDBDatabase',
	    'IDBRequest',
	    'IDBTransaction',
	    'KeyOperation',
	    'MediaController',
	    'MessagePort',
	    'ModalWindow',
	    'Notification',
	    'SVGElementInstance',
	    'Screen',
	    'TextTrack',
	    'TextTrackCue',
	    'TextTrackList',
	    'WebSocket',
	    'WebSocketWorker',
	    'Worker',
	    'XMLHttpRequest',
	    'XMLHttpRequestEventTarget',
	    'XMLHttpRequestUpload',
	];
	/** Wrap timer functions and event targets to catch errors and provide better meta data */
	var TryCatch = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function TryCatch(options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = TryCatch.id;
	        this._options = tslib_1.__assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
	    }
	    /**
	     * Wrap timer functions and event targets to catch errors
	     * and provide better metadata.
	     */
	    TryCatch.prototype.setupOnce = function () {
	        var global = utils_1.getGlobalObject();
	        if (this._options.setTimeout) {
	            utils_1.fill(global, 'setTimeout', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.setInterval) {
	            utils_1.fill(global, 'setInterval', this._wrapTimeFunction.bind(this));
	        }
	        if (this._options.requestAnimationFrame) {
	            utils_1.fill(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
	        }
	        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
	            utils_1.fill(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
	        }
	        if (this._options.eventTarget) {
	            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
	            eventTarget.forEach(this._wrapEventTarget.bind(this));
	        }
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapTimeFunction = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var originalCallback = args[0];
	            args[0] = helpers_1.wrap(originalCallback, {
	                mechanism: {
	                    data: { function: utils_1.getFunctionName(original) },
	                    handled: true,
	                    type: 'instrument',
	                },
	            });
	            return original.apply(this, args);
	        };
	    };
	    /** JSDoc */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    TryCatch.prototype._wrapRAF = function (original) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function (callback) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return original.call(this, helpers_1.wrap(callback, {
	                mechanism: {
	                    data: {
	                        function: 'requestAnimationFrame',
	                        handler: utils_1.getFunctionName(original),
	                    },
	                    handled: true,
	                    type: 'instrument',
	                },
	            }));
	        };
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapEventTarget = function (target) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var global = utils_1.getGlobalObject();
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        utils_1.fill(proto, 'addEventListener', function (original) {
	            return function (eventName, fn, options) {
	                try {
	                    if (typeof fn.handleEvent === 'function') {
	                        fn.handleEvent = helpers_1.wrap(fn.handleEvent.bind(fn), {
	                            mechanism: {
	                                data: {
	                                    function: 'handleEvent',
	                                    handler: utils_1.getFunctionName(fn),
	                                    target: target,
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        });
	                    }
	                }
	                catch (err) {
	                    // can sometimes get 'Permission denied to access property "handle Event'
	                }
	                return original.call(this, eventName, 
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                helpers_1.wrap(fn, {
	                    mechanism: {
	                        data: {
	                            function: 'addEventListener',
	                            handler: utils_1.getFunctionName(fn),
	                            target: target,
	                        },
	                        handled: true,
	                        type: 'instrument',
	                    },
	                }), options);
	            };
	        });
	        utils_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	            return function (eventName, fn, options) {
	                var _a;
	                /**
	                 * There are 2 possible scenarios here:
	                 *
	                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
	                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
	                 * as a pass-through, and call original `removeEventListener` with it.
	                 *
	                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
	                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
	                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
	                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
	                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
	                 *
	                 * When someone adds a handler prior to initialization, and then do it again, but after,
	                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
	                 * to get rid of the initial handler and it'd stick there forever.
	                 */
	                var wrappedEventHandler = fn;
	                try {
	                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
	                    if (originalEventHandler) {
	                        originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
	                    }
	                }
	                catch (e) {
	                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
	                }
	                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
	            };
	        });
	    };
	    /** JSDoc */
	    TryCatch.prototype._wrapXHR = function (originalSend) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
	            xmlHttpRequestProps.forEach(function (prop) {
	                if (prop in xhr && typeof xhr[prop] === 'function') {
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    utils_1.fill(xhr, prop, function (original) {
	                        var wrapOptions = {
	                            mechanism: {
	                                data: {
	                                    function: prop,
	                                    handler: utils_1.getFunctionName(original),
	                                },
	                                handled: true,
	                                type: 'instrument',
	                            },
	                        };
	                        // If Instrument integration has been called before TryCatch, get the name of original function
	                        if (original.__sentry_original__) {
	                            wrapOptions.mechanism.data.handler = utils_1.getFunctionName(original.__sentry_original__);
	                        }
	                        // Otherwise wrap directly
	                        return helpers_1.wrap(original, wrapOptions);
	                    });
	                }
	            });
	            return originalSend.apply(this, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    TryCatch.id = 'TryCatch';
	    return TryCatch;
	}());
	exports.TryCatch = TryCatch;
	//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var core_1 = __webpack_require__(192);
	var utils_1 = __webpack_require__(65);
	var global = utils_1.getGlobalObject();
	/** UserAgent */
	var UserAgent = /** @class */ (function () {
	    function UserAgent() {
	        /**
	         * @inheritDoc
	         */
	        this.name = UserAgent.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    UserAgent.prototype.setupOnce = function () {
	        core_1.addGlobalEventProcessor(function (event) {
	            var _a, _b, _c;
	            if (core_1.getCurrentHub().getIntegration(UserAgent)) {
	                // if none of the information we want exists, don't bother
	                if (!global.navigator && !global.location && !global.document) {
	                    return event;
	                }
	                // grab as much info as exists and add it to the event
	                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = global.location) === null || _b === void 0 ? void 0 : _b.href);
	                var referrer = (global.document || {}).referrer;
	                var userAgent = (global.navigator || {}).userAgent;
	                var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
	                var request = tslib_1.__assign(tslib_1.__assign({}, (url && { url: url })), { headers: headers });
	                return tslib_1.__assign(tslib_1.__assign({}, event), { request: request });
	            }
	            return event;
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    UserAgent.id = 'UserAgent';
	    return UserAgent;
	}());
	exports.UserAgent = UserAgent;
	//# sourceMappingURL=useragent.js.map

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var core_1 = __webpack_require__(192);
	var utils_1 = __webpack_require__(65);
	var client_1 = __webpack_require__(1668);
	var helpers_1 = __webpack_require__(601);
	var integrations_1 = __webpack_require__(1064);
	exports.defaultIntegrations = [
	    new core_1.Integrations.InboundFilters(),
	    new core_1.Integrations.FunctionToString(),
	    new integrations_1.TryCatch(),
	    new integrations_1.Breadcrumbs(),
	    new integrations_1.GlobalHandlers(),
	    new integrations_1.LinkedErrors(),
	    new integrations_1.Dedupe(),
	    new integrations_1.UserAgent(),
	];
	/**
	 * The Sentry Browser SDK Client.
	 *
	 * To use this SDK, call the {@link init} function as early as possible when
	 * loading the web page. To set context information or send manual events, use
	 * the provided methods.
	 *
	 * @example
	 *
	 * ```
	 *
	 * import { init } from '@sentry/browser';
	 *
	 * init({
	 *   dsn: '__DSN__',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { configureScope } from '@sentry/browser';
	 * configureScope((scope: Scope) => {
	 *   scope.setExtra({ battery: 0.7 });
	 *   scope.setTag({ user_mode: 'admin' });
	 *   scope.setUser({ id: '4711' });
	 * });
	 * ```
	 *
	 * @example
	 * ```
	 *
	 * import { addBreadcrumb } from '@sentry/browser';
	 * addBreadcrumb({
	 *   message: 'My Breadcrumb',
	 *   // ...
	 * });
	 * ```
	 *
	 * @example
	 *
	 * ```
	 *
	 * import * as Sentry from '@sentry/browser';
	 * Sentry.captureMessage('Hello, world!');
	 * Sentry.captureException(new Error('Good bye'));
	 * Sentry.captureEvent({
	 *   message: 'Manual',
	 *   stacktrace: [
	 *     // ...
	 *   ],
	 * });
	 * ```
	 *
	 * @see {@link BrowserOptions} for documentation on configuration options.
	 */
	function init(options) {
	    if (options === void 0) { options = {}; }
	    if (options.defaultIntegrations === undefined) {
	        options.defaultIntegrations = exports.defaultIntegrations;
	    }
	    if (options.release === undefined) {
	        var window_1 = utils_1.getGlobalObject();
	        // This supports the variable that sentry-webpack-plugin injects
	        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
	            options.release = window_1.SENTRY_RELEASE.id;
	        }
	    }
	    if (options.autoSessionTracking === undefined) {
	        options.autoSessionTracking = true;
	    }
	    if (options.sendClientReports === undefined) {
	        options.sendClientReports = true;
	    }
	    core_1.initAndBind(client_1.BrowserClient, options);
	    if (options.autoSessionTracking) {
	        startSessionTracking();
	    }
	}
	exports.init = init;
	/**
	 * Present the user with a report dialog.
	 *
	 * @param options Everything is optional, we try to fetch all info need from the global scope.
	 */
	function showReportDialog(options) {
	    if (options === void 0) { options = {}; }
	    var hub = core_1.getCurrentHub();
	    var scope = hub.getScope();
	    if (scope) {
	        options.user = tslib_1.__assign(tslib_1.__assign({}, scope.getUser()), options.user);
	    }
	    if (!options.eventId) {
	        options.eventId = hub.lastEventId();
	    }
	    var client = hub.getClient();
	    if (client) {
	        client.showReportDialog(options);
	    }
	}
	exports.showReportDialog = showReportDialog;
	/**
	 * This is the getter for lastEventId.
	 *
	 * @returns The last event id of a captured event.
	 */
	function lastEventId() {
	    return core_1.getCurrentHub().lastEventId();
	}
	exports.lastEventId = lastEventId;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function forceLoad() {
	    // Noop
	}
	exports.forceLoad = forceLoad;
	/**
	 * This function is here to be API compatible with the loader.
	 * @hidden
	 */
	function onLoad(callback) {
	    callback();
	}
	exports.onLoad = onLoad;
	/**
	 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
	 *
	 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
	 * the client to wait until all events are sent before resolving the promise.
	 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
	 * doesn't (or if there's no client defined).
	 */
	function flush(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.flush(timeout);
	    }
	    utils_1.logger.warn('Cannot flush events. No client defined.');
	    return utils_1.SyncPromise.resolve(false);
	}
	exports.flush = flush;
	/**
	 * Call `close()` on the current client, if there is one. See {@link Client.close}.
	 *
	 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
	 * parameter will cause the client to wait until all events are sent before disabling itself.
	 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
	 * doesn't (or if there's no client defined).
	 */
	function close(timeout) {
	    var client = core_1.getCurrentHub().getClient();
	    if (client) {
	        return client.close(timeout);
	    }
	    utils_1.logger.warn('Cannot flush events and disable SDK. No client defined.');
	    return utils_1.SyncPromise.resolve(false);
	}
	exports.close = close;
	/**
	 * Wrap code within a try/catch block so the SDK is able to capture errors.
	 *
	 * @param fn A function to wrap.
	 *
	 * @returns The result of wrapped function call.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function wrap(fn) {
	    return helpers_1.wrap(fn)();
	}
	exports.wrap = wrap;
	/**
	 * Enable automatic Session Tracking for the initial page load.
	 */
	function startSessionTracking() {
	    var window = utils_1.getGlobalObject();
	    var document = window.document;
	    if (typeof document === 'undefined') {
	        utils_1.logger.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
	        return;
	    }
	    var hub = core_1.getCurrentHub();
	    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
	    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
	    // pinned at the same version in package.json, but there are edge cases where it's possible. See
	    // https://github.com/getsentry/sentry-javascript/issues/3207 and
	    // https://github.com/getsentry/sentry-javascript/issues/3234 and
	    // https://github.com/getsentry/sentry-javascript/issues/3278.
	    if (typeof hub.startSession !== 'function' || typeof hub.captureSession !== 'function') {
	        return;
	    }
	    // The session duration for browser sessions does not track a meaningful
	    // concept that can be used as a metric.
	    // Automatically captured sessions are akin to page views, and thus we
	    // discard their duration.
	    hub.startSession({ ignoreDuration: true });
	    hub.captureSession();
	    // We want to create a session for every navigation as well
	    utils_1.addInstrumentationHandler({
	        callback: function (_a) {
	            var from = _a.from, to = _a.to;
	            // Don't create an additional session for the initial route or if the location did not change
	            if (from === undefined || from === to) {
	                return;
	            }
	            hub.startSession({ ignoreDuration: true });
	            hub.captureSession();
	        },
	        type: 'history',
	    });
	}
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var core_1 = __webpack_require__(192);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var base_1 = __webpack_require__(1066);
	var utils_2 = __webpack_require__(1671);
	/** `fetch` based transport */
	var FetchTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(FetchTransport, _super);
	    function FetchTransport(options, fetchImpl) {
	        if (fetchImpl === void 0) { fetchImpl = utils_2.getNativeFetchImplementation(); }
	        var _this = _super.call(this, options) || this;
	        _this._fetch = fetchImpl;
	        return _this;
	    }
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    FetchTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            this.recordLostEvent(types_1.Outcome.RateLimitBackoff, sentryRequest.type);
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        var options = {
	            body: sentryRequest.body,
	            method: 'POST',
	            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
	            // https://caniuse.com/#feat=referrer-policy
	            // It doesn't. And it throw exception instead of ignoring this parameter...
	            // REF: https://github.com/getsentry/raven-js/issues/1233
	            referrerPolicy: (utils_1.supportsReferrerPolicy() ? 'origin' : ''),
	        };
	        if (this.options.fetchParameters !== undefined) {
	            Object.assign(options, this.options.fetchParameters);
	        }
	        if (this.options.headers !== undefined) {
	            options.headers = this.options.headers;
	        }
	        return this._buffer
	            .add(function () {
	            return new utils_1.SyncPromise(function (resolve, reject) {
	                void _this._fetch(sentryRequest.url, options)
	                    .then(function (response) {
	                    var headers = {
	                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
	                        'retry-after': response.headers.get('Retry-After'),
	                    };
	                    _this._handleResponse({
	                        requestType: sentryRequest.type,
	                        response: response,
	                        headers: headers,
	                        resolve: resolve,
	                        reject: reject,
	                    });
	                })
	                    .catch(reject);
	            });
	        })
	            .then(undefined, function (reason) {
	            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
	            if (reason instanceof utils_1.SentryError) {
	                _this.recordLostEvent(types_1.Outcome.QueueOverflow, sentryRequest.type);
	            }
	            else {
	                _this.recordLostEvent(types_1.Outcome.NetworkError, sentryRequest.type);
	            }
	            throw reason;
	        });
	    };
	    return FetchTransport;
	}(base_1.BaseTransport));
	exports.FetchTransport = FetchTransport;
	//# sourceMappingURL=fetch.js.map

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var core_1 = __webpack_require__(192);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var base_1 = __webpack_require__(1066);
	/** `XHR` based transport */
	var XHRTransport = /** @class */ (function (_super) {
	    tslib_1.__extends(XHRTransport, _super);
	    function XHRTransport() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendEvent = function (event) {
	        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
	    };
	    /**
	     * @inheritDoc
	     */
	    XHRTransport.prototype.sendSession = function (session) {
	        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
	    };
	    /**
	     * @param sentryRequest Prepared SentryRequest to be delivered
	     * @param originalPayload Original payload used to create SentryRequest
	     */
	    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
	        var _this = this;
	        if (this._isRateLimited(sentryRequest.type)) {
	            this.recordLostEvent(types_1.Outcome.RateLimitBackoff, sentryRequest.type);
	            return Promise.reject({
	                event: originalPayload,
	                type: sentryRequest.type,
	                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
	                status: 429,
	            });
	        }
	        return this._buffer
	            .add(function () {
	            return new utils_1.SyncPromise(function (resolve, reject) {
	                var request = new XMLHttpRequest();
	                request.onreadystatechange = function () {
	                    if (request.readyState === 4) {
	                        var headers = {
	                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
	                            'retry-after': request.getResponseHeader('Retry-After'),
	                        };
	                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
	                    }
	                };
	                request.open('POST', sentryRequest.url);
	                for (var header in _this.options.headers) {
	                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
	                        request.setRequestHeader(header, _this.options.headers[header]);
	                    }
	                }
	                request.send(sentryRequest.body);
	            });
	        })
	            .then(undefined, function (reason) {
	            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
	            if (reason instanceof utils_1.SentryError) {
	                _this.recordLostEvent(types_1.Outcome.QueueOverflow, sentryRequest.type);
	            }
	            else {
	                _this.recordLostEvent(types_1.Outcome.NetworkError, sentryRequest.type);
	            }
	            throw reason;
	        });
	    };
	    return XHRTransport;
	}(base_1.BaseTransport));
	exports.XHRTransport = XHRTransport;
	//# sourceMappingURL=xhr.js.map

/***/ }),
/* 2925 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
	exports.SDK_NAME = 'sentry.javascript.browser';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	var SENTRY_API_VERSION = '7';
	/**
	 * Helper class to provide urls, headers and metadata that can be used to form
	 * different types of requests to Sentry endpoints.
	 * Supports both envelopes and regular event requests.
	 **/
	var API = /** @class */ (function () {
	    /** Create a new instance of API */
	    function API(dsn, metadata, tunnel) {
	        if (metadata === void 0) { metadata = {}; }
	        this.dsn = dsn;
	        this._dsnObject = new utils_1.Dsn(dsn);
	        this.metadata = metadata;
	        this._tunnel = tunnel;
	    }
	    /** Returns the Dsn object. */
	    API.prototype.getDsn = function () {
	        return this._dsnObject;
	    };
	    /** Does this transport force envelopes? */
	    API.prototype.forceEnvelope = function () {
	        return !!this._tunnel;
	    };
	    /** Returns the prefix to construct Sentry ingestion API endpoints. */
	    API.prototype.getBaseApiEndpoint = function () {
	        var dsn = this.getDsn();
	        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
	        var port = dsn.port ? ":" + dsn.port : '';
	        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
	    };
	    /** Returns the store endpoint URL. */
	    API.prototype.getStoreEndpoint = function () {
	        return this._getIngestEndpoint('store');
	    };
	    /**
	     * Returns the store endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
	        return this.getStoreEndpoint() + "?" + this._encodedAuth();
	    };
	    /**
	     * Returns the envelope endpoint URL with auth in the query string.
	     *
	     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
	     */
	    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
	        if (this.forceEnvelope()) {
	            return this._tunnel;
	        }
	        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
	    };
	    /** Returns only the path component for the store endpoint. */
	    API.prototype.getStoreEndpointPath = function () {
	        var dsn = this.getDsn();
	        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
	    };
	    /**
	     * Returns an object that can be used in request headers.
	     * This is needed for node and the old /store endpoint in sentry
	     */
	    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
	        // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
	        var dsn = this.getDsn();
	        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
	        header.push("sentry_client=" + clientName + "/" + clientVersion);
	        header.push("sentry_key=" + dsn.publicKey);
	        if (dsn.pass) {
	            header.push("sentry_secret=" + dsn.pass);
	        }
	        return {
	            'Content-Type': 'application/json',
	            'X-Sentry-Auth': header.join(', '),
	        };
	    };
	    /** Returns the url to the report dialog endpoint. */
	    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
	        if (dialogOptions === void 0) { dialogOptions = {}; }
	        var dsn = this.getDsn();
	        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
	        var encodedOptions = [];
	        encodedOptions.push("dsn=" + dsn.toString());
	        for (var key in dialogOptions) {
	            if (key === 'dsn') {
	                continue;
	            }
	            if (key === 'user') {
	                if (!dialogOptions.user) {
	                    continue;
	                }
	                if (dialogOptions.user.name) {
	                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
	                }
	                if (dialogOptions.user.email) {
	                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
	                }
	            }
	            else {
	                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
	            }
	        }
	        if (encodedOptions.length) {
	            return endpoint + "?" + encodedOptions.join('&');
	        }
	        return endpoint;
	    };
	    /** Returns the envelope endpoint URL. */
	    API.prototype._getEnvelopeEndpoint = function () {
	        return this._getIngestEndpoint('envelope');
	    };
	    /** Returns the ingest API endpoint for target. */
	    API.prototype._getIngestEndpoint = function (target) {
	        if (this._tunnel) {
	            return this._tunnel;
	        }
	        var base = this.getBaseApiEndpoint();
	        var dsn = this.getDsn();
	        return "" + base + dsn.projectId + "/" + target + "/";
	    };
	    /** Returns a URL-encoded string with auth config suitable for a query string. */
	    API.prototype._encodedAuth = function () {
	        var dsn = this.getDsn();
	        var auth = {
	            // We send only the minimum set of required information. See
	            // https://github.com/getsentry/sentry-javascript/issues/2572.
	            sentry_key: dsn.publicKey,
	            sentry_version: SENTRY_API_VERSION,
	        };
	        return utils_1.urlEncode(auth);
	    };
	    return API;
	}());
	exports.API = API;
	//# sourceMappingURL=api.js.map

/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	var noop_1 = __webpack_require__(1672);
	/**
	 * This is the base implemention of a Backend.
	 * @hidden
	 */
	var BaseBackend = /** @class */ (function () {
	    /** Creates a new backend instance. */
	    function BaseBackend(options) {
	        this._options = options;
	        if (!this._options.dsn) {
	            utils_1.logger.warn('No DSN provided, backend will not do anything.');
	        }
	        this._transport = this._setupTransport();
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromException` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
	        throw new utils_1.SentryError('Backend has to implement `eventFromMessage` method');
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendEvent = function (event) {
	        void this._transport.sendEvent(event).then(null, function (reason) {
	            utils_1.logger.error("Error while sending event: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.sendSession = function (session) {
	        if (!this._transport.sendSession) {
	            utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        void this._transport.sendSession(session).then(null, function (reason) {
	            utils_1.logger.error("Error while sending session: " + reason);
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseBackend.prototype.getTransport = function () {
	        return this._transport;
	    };
	    /**
	     * Sets up the transport so it can be used later to send requests.
	     */
	    BaseBackend.prototype._setupTransport = function () {
	        return new noop_1.NoopTransport();
	    };
	    return BaseBackend;
	}());
	exports.BaseBackend = BaseBackend;
	//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	/* eslint-disable max-lines */
	var hub_1 = __webpack_require__(284);
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var integration_1 = __webpack_require__(2929);
	var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
	/**
	 * Base implementation for all JavaScript SDK clients.
	 *
	 * Call the constructor with the corresponding backend constructor and options
	 * specific to the client subclass. To access these options later, use
	 * {@link Client.getOptions}. Also, the Backend instance is available via
	 * {@link Client.getBackend}.
	 *
	 * If a Dsn is specified in the options, it will be parsed and stored. Use
	 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
	 * invalid, the constructor will throw a {@link SentryException}. Note that
	 * without a valid Dsn, the SDK will not send any events to Sentry.
	 *
	 * Before sending an event via the backend, it is passed through
	 * {@link BaseClient._prepareEvent} to add SDK information and scope data
	 * (breadcrumbs and context). To add more custom information, override this
	 * method and extend the resulting prepared event.
	 *
	 * To issue automatically created events (e.g. via instrumentation), use
	 * {@link Client.captureEvent}. It will prepare the event and pass it through
	 * the callback lifecycle. To issue auto-breadcrumbs, use
	 * {@link Client.addBreadcrumb}.
	 *
	 * @example
	 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
	 *   public constructor(options: NodeOptions) {
	 *     super(NodeBackend, options);
	 *   }
	 *
	 *   // ...
	 * }
	 */
	var BaseClient = /** @class */ (function () {
	    /**
	     * Initializes this client instance.
	     *
	     * @param backendClass A constructor function to create the backend.
	     * @param options Options for the client.
	     */
	    function BaseClient(backendClass, options) {
	        /** Array of used integrations. */
	        this._integrations = {};
	        /** Number of calls being processed */
	        this._numProcessing = 0;
	        this._backend = new backendClass(options);
	        this._options = options;
	        if (options.dsn) {
	            this._dsn = new utils_1.Dsn(options.dsn);
	        }
	    }
	    /**
	     * @inheritDoc
	     */
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
	    BaseClient.prototype.captureException = function (exception, hint, scope) {
	        var _this = this;
	        // ensure we haven't captured this very object before
	        if (utils_1.checkOrSetAlreadyCaught(exception)) {
	            utils_1.logger.log(ALREADY_SEEN_ERROR);
	            return;
	        }
	        var eventId = hint && hint.event_id;
	        this._process(this._getBackend()
	            .eventFromException(exception, hint)
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
	        var _this = this;
	        var eventId = hint && hint.event_id;
	        var promisedEvent = utils_1.isPrimitive(message)
	            ? this._getBackend().eventFromMessage(String(message), level, hint)
	            : this._getBackend().eventFromException(message, hint);
	        this._process(promisedEvent
	            .then(function (event) { return _this._captureEvent(event, hint, scope); })
	            .then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureEvent = function (event, hint, scope) {
	        var _a;
	        // ensure we haven't captured this very object before
	        if (((_a = hint) === null || _a === void 0 ? void 0 : _a.originalException) && utils_1.checkOrSetAlreadyCaught(hint.originalException)) {
	            utils_1.logger.log(ALREADY_SEEN_ERROR);
	            return;
	        }
	        var eventId = hint && hint.event_id;
	        this._process(this._captureEvent(event, hint, scope).then(function (result) {
	            eventId = result;
	        }));
	        return eventId;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.captureSession = function (session) {
	        if (!this._isEnabled()) {
	            utils_1.logger.warn('SDK not enabled, will not capture session.');
	            return;
	        }
	        if (!(typeof session.release === 'string')) {
	            utils_1.logger.warn('Discarded session because of missing or non-string release');
	        }
	        else {
	            this._sendSession(session);
	            // After sending, we set init false to indicate it's not the first occurrence
	            session.update({ init: false });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getDsn = function () {
	        return this._dsn;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getOptions = function () {
	        return this._options;
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getTransport = function () {
	        return this._getBackend().getTransport();
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.flush = function (timeout) {
	        var _this = this;
	        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
	            return _this.getTransport()
	                .close(timeout)
	                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.close = function (timeout) {
	        var _this = this;
	        return this.flush(timeout).then(function (result) {
	            _this.getOptions().enabled = false;
	            return result;
	        });
	    };
	    /**
	     * Sets up the integrations
	     */
	    BaseClient.prototype.setupIntegrations = function () {
	        if (this._isEnabled() && !this._integrations.initialized) {
	            this._integrations = integration_1.setupIntegrations(this._options);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    BaseClient.prototype.getIntegration = function (integration) {
	        try {
	            return this._integrations[integration.id] || null;
	        }
	        catch (_oO) {
	            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
	            return null;
	        }
	    };
	    /** Updates existing session based on the provided event */
	    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
	        var e_1, _a;
	        var crashed = false;
	        var errored = false;
	        var exceptions = event.exception && event.exception.values;
	        if (exceptions) {
	            errored = true;
	            try {
	                for (var exceptions_1 = tslib_1.__values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
	                    var ex = exceptions_1_1.value;
	                    var mechanism = ex.mechanism;
	                    if (mechanism && mechanism.handled === false) {
	                        crashed = true;
	                        break;
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	        // A session is updated and that session update is sent in only one of the two following scenarios:
	        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
	        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
	        var sessionNonTerminal = session.status === types_1.SessionStatus.Ok;
	        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
	        if (shouldUpdateAndSend) {
	            session.update(tslib_1.__assign(tslib_1.__assign({}, (crashed && { status: types_1.SessionStatus.Crashed })), { errors: session.errors || Number(errored || crashed) }));
	            this.captureSession(session);
	        }
	    };
	    /** Deliver captured session to Sentry */
	    BaseClient.prototype._sendSession = function (session) {
	        this._getBackend().sendSession(session);
	    };
	    /**
	     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
	     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
	     *
	     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
	     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
	     * `true`.
	     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
	     * `false` otherwise
	     */
	    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
	        var _this = this;
	        return new utils_1.SyncPromise(function (resolve) {
	            var ticked = 0;
	            var tick = 1;
	            var interval = setInterval(function () {
	                if (_this._numProcessing == 0) {
	                    clearInterval(interval);
	                    resolve(true);
	                }
	                else {
	                    ticked += tick;
	                    if (timeout && ticked >= timeout) {
	                        clearInterval(interval);
	                        resolve(false);
	                    }
	                }
	            }, tick);
	        });
	    };
	    /** Returns the current backend. */
	    BaseClient.prototype._getBackend = function () {
	        return this._backend;
	    };
	    /** Determines whether this SDK is enabled and a valid Dsn is present. */
	    BaseClient.prototype._isEnabled = function () {
	        return this.getOptions().enabled !== false && this._dsn !== undefined;
	    };
	    /**
	     * Adds common information to events.
	     *
	     * The information includes release and environment from `options`,
	     * breadcrumbs and context (extra, tags and user) from the scope.
	     *
	     * Information that is already present in the event is never overwritten. For
	     * nested objects, such as the context, keys are merged.
	     *
	     * @param event The original event.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A new event with more information.
	     */
	    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
	        var _this = this;
	        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
	        var prepared = tslib_1.__assign(tslib_1.__assign({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : utils_1.uuid4()), timestamp: event.timestamp || utils_1.dateTimestampInSeconds() });
	        this._applyClientOptions(prepared);
	        this._applyIntegrationsMetadata(prepared);
	        // If we have scope given to us, use it as the base for further modifications.
	        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
	        var finalScope = scope;
	        if (hint && hint.captureContext) {
	            finalScope = hub_1.Scope.clone(finalScope).update(hint.captureContext);
	        }
	        // We prepare the result here with a resolved Event.
	        var result = utils_1.SyncPromise.resolve(prepared);
	        // This should be the last thing called, since we want that
	        // {@link Hub.addEventProcessor} gets the finished prepared event.
	        if (finalScope) {
	            // In case we have a hub we reassign it.
	            result = finalScope.applyToEvent(prepared, hint);
	        }
	        return result.then(function (evt) {
	            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
	                return _this._normalizeEvent(evt, normalizeDepth);
	            }
	            return evt;
	        });
	    };
	    /**
	     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
	     * Normalized keys:
	     * - `breadcrumbs.data`
	     * - `user`
	     * - `contexts`
	     * - `extra`
	     * @param event Event
	     * @returns Normalized event
	     */
	    BaseClient.prototype._normalizeEvent = function (event, depth) {
	        if (!event) {
	            return null;
	        }
	        var normalized = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, event), (event.breadcrumbs && {
	            breadcrumbs: event.breadcrumbs.map(function (b) { return (tslib_1.__assign(tslib_1.__assign({}, b), (b.data && {
	                data: utils_1.normalize(b.data, depth),
	            }))); }),
	        })), (event.user && {
	            user: utils_1.normalize(event.user, depth),
	        })), (event.contexts && {
	            contexts: utils_1.normalize(event.contexts, depth),
	        })), (event.extra && {
	            extra: utils_1.normalize(event.extra, depth),
	        }));
	        // event.contexts.trace stores information about a Transaction. Similarly,
	        // event.spans[] stores information about child Spans. Given that a
	        // Transaction is conceptually a Span, normalization should apply to both
	        // Transactions and Spans consistently.
	        // For now the decision is to skip normalization of Transactions and Spans,
	        // so this block overwrites the normalized event to add back the original
	        // Transaction information prior to normalization.
	        if (event.contexts && event.contexts.trace) {
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            normalized.contexts.trace = event.contexts.trace;
	        }
	        var _a = this.getOptions()._experiments, _experiments = _a === void 0 ? {} : _a;
	        if (_experiments.ensureNoCircularStructures) {
	            return utils_1.normalize(normalized);
	        }
	        return normalized;
	    };
	    /**
	     *  Enhances event using the client configuration.
	     *  It takes care of all "static" values like environment, release and `dist`,
	     *  as well as truncating overly long values.
	     * @param event event instance to be enhanced
	     */
	    BaseClient.prototype._applyClientOptions = function (event) {
	        var options = this.getOptions();
	        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
	        if (!('environment' in event)) {
	            event.environment = 'environment' in options ? environment : 'production';
	        }
	        if (event.release === undefined && release !== undefined) {
	            event.release = release;
	        }
	        if (event.dist === undefined && dist !== undefined) {
	            event.dist = dist;
	        }
	        if (event.message) {
	            event.message = utils_1.truncate(event.message, maxValueLength);
	        }
	        var exception = event.exception && event.exception.values && event.exception.values[0];
	        if (exception && exception.value) {
	            exception.value = utils_1.truncate(exception.value, maxValueLength);
	        }
	        var request = event.request;
	        if (request && request.url) {
	            request.url = utils_1.truncate(request.url, maxValueLength);
	        }
	    };
	    /**
	     * This function adds all used integrations to the SDK info in the event.
	     * @param event The event that will be filled with all integrations.
	     */
	    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
	        var integrationsArray = Object.keys(this._integrations);
	        if (integrationsArray.length > 0) {
	            event.sdk = event.sdk || {};
	            event.sdk.integrations = tslib_1.__spread((event.sdk.integrations || []), integrationsArray);
	        }
	    };
	    /**
	     * Tells the backend to send this event
	     * @param event The Sentry event to send
	     */
	    BaseClient.prototype._sendEvent = function (event) {
	        this._getBackend().sendEvent(event);
	    };
	    /**
	     * Processes the event and logs an error in case of rejection
	     * @param event
	     * @param hint
	     * @param scope
	     */
	    BaseClient.prototype._captureEvent = function (event, hint, scope) {
	        return this._processEvent(event, hint, scope).then(function (finalEvent) {
	            return finalEvent.event_id;
	        }, function (reason) {
	            utils_1.logger.error(reason);
	            return undefined;
	        });
	    };
	    /**
	     * Processes an event (either error or message) and sends it to Sentry.
	     *
	     * This also adds breadcrumbs and context information to the event. However,
	     * platform specific meta data (such as the User's IP address) must be added
	     * by the SDK implementor.
	     *
	     *
	     * @param event The event to send to Sentry.
	     * @param hint May contain additional information about the original exception.
	     * @param scope A scope containing event metadata.
	     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
	     */
	    BaseClient.prototype._processEvent = function (event, hint, scope) {
	        var _this = this;
	        var _a, _b;
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _c = this.getOptions(), beforeSend = _c.beforeSend, sampleRate = _c.sampleRate;
	        var transport = this.getTransport();
	        if (!this._isEnabled()) {
	            return utils_1.SyncPromise.reject(new utils_1.SentryError('SDK not enabled, will not capture event.'));
	        }
	        var isTransaction = event.type === 'transaction';
	        // 1.0 === 100% events are sent
	        // 0.0 === 0% events are sent
	        // Sampling for transaction happens somewhere else
	        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
	            (_b = (_a = transport).recordLostEvent) === null || _b === void 0 ? void 0 : _b.call(_a, types_1.Outcome.SampleRate, 'event');
	            return utils_1.SyncPromise.reject(new utils_1.SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
	        }
	        return this._prepareEvent(event, scope, hint)
	            .then(function (prepared) {
	            var _a, _b;
	            if (prepared === null) {
	                (_b = (_a = transport).recordLostEvent) === null || _b === void 0 ? void 0 : _b.call(_a, types_1.Outcome.EventProcessor, event.type || 'event');
	                throw new utils_1.SentryError('An event processor returned null, will not send event.');
	            }
	            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
	            if (isInternalException || isTransaction || !beforeSend) {
	                return prepared;
	            }
	            var beforeSendResult = beforeSend(prepared, hint);
	            return _this._ensureBeforeSendRv(beforeSendResult);
	        })
	            .then(function (processedEvent) {
	            var _a, _b;
	            if (processedEvent === null) {
	                (_b = (_a = transport).recordLostEvent) === null || _b === void 0 ? void 0 : _b.call(_a, types_1.Outcome.BeforeSend, event.type || 'event');
	                throw new utils_1.SentryError('`beforeSend` returned `null`, will not send event.');
	            }
	            var session = scope && scope.getSession && scope.getSession();
	            if (!isTransaction && session) {
	                _this._updateSessionFromEvent(session, processedEvent);
	            }
	            _this._sendEvent(processedEvent);
	            return processedEvent;
	        })
	            .then(null, function (reason) {
	            if (reason instanceof utils_1.SentryError) {
	                throw reason;
	            }
	            _this.captureException(reason, {
	                data: {
	                    __sentry__: true,
	                },
	                originalException: reason,
	            });
	            throw new utils_1.SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
	        });
	    };
	    /**
	     * Occupies the client with processing and event
	     */
	    BaseClient.prototype._process = function (promise) {
	        var _this = this;
	        this._numProcessing += 1;
	        void promise.then(function (value) {
	            _this._numProcessing -= 1;
	            return value;
	        }, function (reason) {
	            _this._numProcessing -= 1;
	            return reason;
	        });
	    };
	    /**
	     * Verifies that return value of configured `beforeSend` is of expected type.
	     */
	    BaseClient.prototype._ensureBeforeSendRv = function (rv) {
	        var nullErr = '`beforeSend` method has to return `null` or a valid event.';
	        if (utils_1.isThenable(rv)) {
	            return rv.then(function (event) {
	                if (!(utils_1.isPlainObject(event) || event === null)) {
	                    throw new utils_1.SentryError(nullErr);
	                }
	                return event;
	            }, function (e) {
	                throw new utils_1.SentryError("beforeSend rejected with " + e);
	            });
	        }
	        else if (!(utils_1.isPlainObject(rv) || rv === null)) {
	            throw new utils_1.SentryError(nullErr);
	        }
	        return rv;
	    };
	    return BaseClient;
	}());
	exports.BaseClient = BaseClient;
	//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var hub_1 = __webpack_require__(284);
	var utils_1 = __webpack_require__(65);
	exports.installedIntegrations = [];
	/**
	 * @private
	 */
	function filterDuplicates(integrations) {
	    return integrations.reduce(function (acc, integrations) {
	        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
	            acc.push(integrations);
	        }
	        return acc;
	    }, []);
	}
	/** Gets integration to install */
	function getIntegrationsToSetup(options) {
	    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
	    var userIntegrations = options.integrations;
	    var integrations = tslib_1.__spread(filterDuplicates(defaultIntegrations));
	    if (Array.isArray(userIntegrations)) {
	        // Filter out integrations that are also included in user options
	        integrations = tslib_1.__spread(integrations.filter(function (integrations) {
	            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
	        }), filterDuplicates(userIntegrations));
	    }
	    else if (typeof userIntegrations === 'function') {
	        integrations = userIntegrations(integrations);
	        integrations = Array.isArray(integrations) ? integrations : [integrations];
	    }
	    // Make sure that if present, `Debug` integration will always run last
	    var integrationsNames = integrations.map(function (i) { return i.name; });
	    var alwaysLastToRun = 'Debug';
	    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
	        integrations.push.apply(integrations, tslib_1.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
	    }
	    return integrations;
	}
	exports.getIntegrationsToSetup = getIntegrationsToSetup;
	/** Setup given integration */
	function setupIntegration(integration) {
	    if (exports.installedIntegrations.indexOf(integration.name) !== -1) {
	        return;
	    }
	    integration.setupOnce(hub_1.addGlobalEventProcessor, hub_1.getCurrentHub);
	    exports.installedIntegrations.push(integration.name);
	    utils_1.logger.log("Integration installed: " + integration.name);
	}
	exports.setupIntegration = setupIntegration;
	/**
	 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
	 * integrations are added unless they were already provided before.
	 * @param integrations array of integration instances
	 * @param withDefault should enable default integrations
	 */
	function setupIntegrations(options) {
	    var integrations = {};
	    getIntegrationsToSetup(options).forEach(function (integration) {
	        integrations[integration.name] = integration;
	        setupIntegration(integration);
	    });
	    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
	    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
	    // considered a member of the index the way the actual integrations are
	    Object.defineProperty(integrations, 'initialized', { value: true });
	    return integrations;
	}
	exports.setupIntegrations = setupIntegrations;
	//# sourceMappingURL=integration.js.map

/***/ }),
/* 2930 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var originalFunctionToString;
	/** Patch toString calls to return proper name for wrapped functions */
	var FunctionToString = /** @class */ (function () {
	    function FunctionToString() {
	        /**
	         * @inheritDoc
	         */
	        this.name = FunctionToString.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.prototype.setupOnce = function () {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        originalFunctionToString = Function.prototype.toString;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        Function.prototype.toString = function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var context = this.__sentry_original__ || this;
	            return originalFunctionToString.apply(context, args);
	        };
	    };
	    /**
	     * @inheritDoc
	     */
	    FunctionToString.id = 'FunctionToString';
	    return FunctionToString;
	}());
	exports.FunctionToString = FunctionToString;
	//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var hub_1 = __webpack_require__(284);
	var utils_1 = __webpack_require__(65);
	// "Script error." is hard coded into browsers for errors that it can't read.
	// this is the result of a script being pulled in from an external domain and CORS.
	var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
	/** Inbound filters configurable by the user */
	var InboundFilters = /** @class */ (function () {
	    function InboundFilters(_options) {
	        if (_options === void 0) { _options = {}; }
	        this._options = _options;
	        /**
	         * @inheritDoc
	         */
	        this.name = InboundFilters.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.prototype.setupOnce = function () {
	        hub_1.addGlobalEventProcessor(function (event) {
	            var hub = hub_1.getCurrentHub();
	            if (!hub) {
	                return event;
	            }
	            var self = hub.getIntegration(InboundFilters);
	            if (self) {
	                var client = hub.getClient();
	                var clientOptions = client ? client.getOptions() : {};
	                // This checks prevents most of the occurrences of the bug linked below:
	                // https://github.com/getsentry/sentry-javascript/issues/2622
	                // The bug is caused by multiple SDK instances, where one is minified and one is using non-mangled code.
	                // Unfortunatelly we cannot fix it reliably (thus reserved property in rollup's terser config),
	                // as we cannot force people using multiple instances in their apps to sync SDK versions.
	                var options = typeof self._mergeOptions === 'function' ? self._mergeOptions(clientOptions) : {};
	                if (typeof self._shouldDropEvent !== 'function') {
	                    return event;
	                }
	                return self._shouldDropEvent(event, options) ? null : event;
	            }
	            return event;
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._shouldDropEvent = function (event, options) {
	        if (this._isSentryError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isIgnoredError(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + utils_1.getEventDescription(event));
	            return true;
	        }
	        if (this._isDeniedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        if (!this._isAllowedUrl(event, options)) {
	            utils_1.logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
	            return true;
	        }
	        return false;
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isSentryError = function (event, options) {
	        if (!options.ignoreInternal) {
	            return false;
	        }
	        try {
	            return ((event &&
	                event.exception &&
	                event.exception.values &&
	                event.exception.values[0] &&
	                event.exception.values[0].type === 'SentryError') ||
	                false);
	        }
	        catch (_oO) {
	            return false;
	        }
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isIgnoredError = function (event, options) {
	        if (!options.ignoreErrors || !options.ignoreErrors.length) {
	            return false;
	        }
	        return this._getPossibleEventMessages(event).some(function (message) {
	            // Not sure why TypeScript complains here...
	            return options.ignoreErrors.some(function (pattern) { return utils_1.isMatchingPattern(message, pattern); });
	        });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isDeniedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.denyUrls || !options.denyUrls.length) {
	            return false;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? false : options.denyUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._isAllowedUrl = function (event, options) {
	        // TODO: Use Glob instead?
	        if (!options.allowUrls || !options.allowUrls.length) {
	            return true;
	        }
	        var url = this._getEventFilterUrl(event);
	        return !url ? true : options.allowUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
	    };
	    /** JSDoc */
	    InboundFilters.prototype._mergeOptions = function (clientOptions) {
	        if (clientOptions === void 0) { clientOptions = {}; }
	        return {
	            allowUrls: tslib_1.__spread((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
	            denyUrls: tslib_1.__spread((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
	            ignoreErrors: tslib_1.__spread((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
	            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
	        };
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getPossibleEventMessages = function (event) {
	        if (event.message) {
	            return [event.message];
	        }
	        if (event.exception) {
	            try {
	                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
	                return ["" + value, type + ": " + value];
	            }
	            catch (oO) {
	                utils_1.logger.error("Cannot extract message for event " + utils_1.getEventDescription(event));
	                return [];
	            }
	        }
	        return [];
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getLastValidUrl = function (frames) {
	        if (frames === void 0) { frames = []; }
	        var _a, _b;
	        for (var i = frames.length - 1; i >= 0; i--) {
	            var frame = frames[i];
	            if (((_a = frame) === null || _a === void 0 ? void 0 : _a.filename) !== '<anonymous>' && ((_b = frame) === null || _b === void 0 ? void 0 : _b.filename) !== '[native code]') {
	                return frame.filename || null;
	            }
	        }
	        return null;
	    };
	    /** JSDoc */
	    InboundFilters.prototype._getEventFilterUrl = function (event) {
	        try {
	            if (event.stacktrace) {
	                var frames_1 = event.stacktrace.frames;
	                return this._getLastValidUrl(frames_1);
	            }
	            if (event.exception) {
	                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
	                return this._getLastValidUrl(frames_2);
	            }
	            return null;
	        }
	        catch (oO) {
	            utils_1.logger.error("Cannot extract url for event " + utils_1.getEventDescription(event));
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    InboundFilters.id = 'InboundFilters';
	    return InboundFilters;
	}());
	exports.InboundFilters = InboundFilters;
	//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var functiontostring_1 = __webpack_require__(2930);
	exports.FunctionToString = functiontostring_1.FunctionToString;
	var inboundfilters_1 = __webpack_require__(2931);
	exports.InboundFilters = inboundfilters_1.InboundFilters;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	/** Extract sdk info from from the API metadata */
	function getSdkMetadataForEnvelopeHeader(api) {
	    if (!api.metadata || !api.metadata.sdk) {
	        return;
	    }
	    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
	    return { name: name, version: version };
	}
	/**
	 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
	 * Merge with existing data if any.
	 **/
	function enhanceEventWithSdkInfo(event, sdkInfo) {
	    if (!sdkInfo) {
	        return event;
	    }
	    event.sdk = event.sdk || {};
	    event.sdk.name = event.sdk.name || sdkInfo.name;
	    event.sdk.version = event.sdk.version || sdkInfo.version;
	    event.sdk.integrations = tslib_1.__spread((event.sdk.integrations || []), (sdkInfo.integrations || []));
	    event.sdk.packages = tslib_1.__spread((event.sdk.packages || []), (sdkInfo.packages || []));
	    return event;
	}
	/** Creates a SentryRequest from a Session. */
	function sessionToSentryRequest(session, api) {
	    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
	    var envelopeHeaders = JSON.stringify(tslib_1.__assign(tslib_1.__assign({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (api.forceEnvelope() && { dsn: api.getDsn().toString() })));
	    // I know this is hacky but we don't want to add `session` to request type since it's never rate limited
	    var type = 'aggregates' in session ? 'sessions' : 'session';
	    var itemHeaders = JSON.stringify({
	        type: type,
	    });
	    return {
	        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
	        type: type,
	        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
	    };
	}
	exports.sessionToSentryRequest = sessionToSentryRequest;
	/** Creates a SentryRequest from an event. */
	function eventToSentryRequest(event, api) {
	    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
	    var eventType = event.type || 'event';
	    var useEnvelope = eventType === 'transaction' || api.forceEnvelope();
	    var _a = event.debug_meta || {}, transactionSampling = _a.transactionSampling, metadata = tslib_1.__rest(_a, ["transactionSampling"]);
	    var _b = transactionSampling || {}, samplingMethod = _b.method, sampleRate = _b.rate;
	    if (Object.keys(metadata).length === 0) {
	        delete event.debug_meta;
	    }
	    else {
	        event.debug_meta = metadata;
	    }
	    var req = {
	        body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
	        type: eventType,
	        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
	    };
	    // https://develop.sentry.dev/sdk/envelopes/
	    // Since we don't need to manipulate envelopes nor store them, there is no
	    // exported concept of an Envelope with operations including serialization and
	    // deserialization. Instead, we only implement a minimal subset of the spec to
	    // serialize events inline here.
	    if (useEnvelope) {
	        var envelopeHeaders = JSON.stringify(tslib_1.__assign(tslib_1.__assign({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (api.forceEnvelope() && { dsn: api.getDsn().toString() })));
	        var itemHeaders = JSON.stringify({
	            type: eventType,
	            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
	            // explicitly-set sampling decisions). Are we good with that?
	            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
	        });
	        // The trailing newline is optional. We intentionally don't send it to avoid
	        // sending unnecessary bytes.
	        //
	        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
	        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
	        req.body = envelope;
	    }
	    return req;
	}
	exports.eventToSentryRequest = eventToSentryRequest;
	//# sourceMappingURL=request.js.map

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hub_1 = __webpack_require__(284);
	var utils_1 = __webpack_require__(65);
	/**
	 * Internal function to create a new SDK client instance. The client is
	 * installed and then bound to the current scope.
	 *
	 * @param clientClass The client class to instantiate.
	 * @param options Options to pass to the client.
	 */
	function initAndBind(clientClass, options) {
	    var _a;
	    if (options.debug === true) {
	        utils_1.logger.enable();
	    }
	    var hub = hub_1.getCurrentHub();
	    (_a = hub.getScope()) === null || _a === void 0 ? void 0 : _a.update(options.initialScope);
	    var client = new clientClass(options);
	    hub.bindClient(client);
	}
	exports.initAndBind = initAndBind;
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 2935 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SDK_VERSION = '6.16.1';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(164);
	var utils_1 = __webpack_require__(65);
	var hub_1 = __webpack_require__(1673);
	/**
	 * @inheritdoc
	 */
	var SessionFlusher = /** @class */ (function () {
	    function SessionFlusher(transport, attrs) {
	        var _this = this;
	        this.flushTimeout = 60;
	        this._pendingAggregates = {};
	        this._isEnabled = true;
	        this._transport = transport;
	        // Call to setInterval, so that flush is called every 60 seconds
	        this._intervalId = setInterval(function () { return _this.flush(); }, this.flushTimeout * 1000);
	        this._sessionAttrs = attrs;
	    }
	    /** Sends session aggregates to Transport */
	    SessionFlusher.prototype.sendSessionAggregates = function (sessionAggregates) {
	        if (!this._transport.sendSession) {
	            utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
	            return;
	        }
	        void this._transport.sendSession(sessionAggregates).then(null, function (reason) {
	            utils_1.logger.error("Error while sending session: " + reason);
	        });
	    };
	    /** Checks if `pendingAggregates` has entries, and if it does flushes them by calling `sendSessions` */
	    SessionFlusher.prototype.flush = function () {
	        var sessionAggregates = this.getSessionAggregates();
	        if (sessionAggregates.aggregates.length === 0) {
	            return;
	        }
	        this._pendingAggregates = {};
	        this.sendSessionAggregates(sessionAggregates);
	    };
	    /** Massages the entries in `pendingAggregates` and returns aggregated sessions */
	    SessionFlusher.prototype.getSessionAggregates = function () {
	        var _this = this;
	        var aggregates = Object.keys(this._pendingAggregates).map(function (key) {
	            return _this._pendingAggregates[parseInt(key)];
	        });
	        var sessionAggregates = {
	            attrs: this._sessionAttrs,
	            aggregates: aggregates,
	        };
	        return utils_1.dropUndefinedKeys(sessionAggregates);
	    };
	    /** JSDoc */
	    SessionFlusher.prototype.close = function () {
	        clearInterval(this._intervalId);
	        this._isEnabled = false;
	        this.flush();
	    };
	    /**
	     * Wrapper function for _incrementSessionStatusCount that checks if the instance of SessionFlusher is enabled then
	     * fetches the session status of the request from `Scope.getRequestSession().status` on the scope and passes them to
	     * `_incrementSessionStatusCount` along with the start date
	     */
	    SessionFlusher.prototype.incrementSessionStatusCount = function () {
	        var _a, _b;
	        if (!this._isEnabled) {
	            return;
	        }
	        var scope = hub_1.getCurrentHub().getScope();
	        var requestSession = (_a = scope) === null || _a === void 0 ? void 0 : _a.getRequestSession();
	        if (requestSession && requestSession.status) {
	            this._incrementSessionStatusCount(requestSession.status, new Date());
	            // This is not entirely necessarily but is added as a safe guard to indicate the bounds of a request and so in
	            // case captureRequestSession is called more than once to prevent double count
	            (_b = scope) === null || _b === void 0 ? void 0 : _b.setRequestSession(undefined);
	            /* eslint-enable @typescript-eslint/no-unsafe-member-access */
	        }
	    };
	    /**
	     * Increments status bucket in pendingAggregates buffer (internal state) corresponding to status of
	     * the session received
	     */
	    SessionFlusher.prototype._incrementSessionStatusCount = function (status, date) {
	        // Truncate minutes and seconds on Session Started attribute to have one minute bucket keys
	        var sessionStartedTrunc = new Date(date).setSeconds(0, 0);
	        this._pendingAggregates[sessionStartedTrunc] = this._pendingAggregates[sessionStartedTrunc] || {};
	        // corresponds to aggregated sessions in one specific minute bucket
	        // for example, {"started":"2021-03-16T08:00:00.000Z","exited":4, "errored": 1}
	        var aggregationCounts = this._pendingAggregates[sessionStartedTrunc];
	        if (!aggregationCounts.started) {
	            aggregationCounts.started = new Date(sessionStartedTrunc).toISOString();
	        }
	        switch (status) {
	            case types_1.RequestSessionStatus.Errored:
	                aggregationCounts.errored = (aggregationCounts.errored || 0) + 1;
	                return aggregationCounts.errored;
	            case types_1.RequestSessionStatus.Ok:
	                aggregationCounts.exited = (aggregationCounts.exited || 0) + 1;
	                return aggregationCounts.exited;
	            case types_1.RequestSessionStatus.Crashed:
	                aggregationCounts.crashed = (aggregationCounts.crashed || 0) + 1;
	                return aggregationCounts.crashed;
	        }
	    };
	    return SessionFlusher;
	}());
	exports.SessionFlusher = SessionFlusher;
	//# sourceMappingURL=sessionflusher.js.map

/***/ }),
/* 2937 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.REACT_RENDER_OP = 'ui.react.render';
	exports.REACT_UPDATE_OP = 'ui.react.update';
	exports.REACT_MOUNT_OP = 'ui.react.mount';
	//# sourceMappingURL=constants.js.map

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var browser_1 = __webpack_require__(602);
	var utils_1 = __webpack_require__(65);
	var hoist_non_react_statics_1 = tslib_1.__importDefault(__webpack_require__(1068));
	var React = tslib_1.__importStar(__webpack_require__(1));
	var reactVersion = utils_1.parseSemver(React.version);
	exports.UNKNOWN_COMPONENT = 'unknown';
	var INITIAL_STATE = {
	    componentStack: null,
	    error: null,
	    eventId: null,
	};
	/**
	 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
	 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
	 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
	 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
	 */
	var ErrorBoundary = /** @class */ (function (_super) {
	    tslib_1.__extends(ErrorBoundary, _super);
	    function ErrorBoundary() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = INITIAL_STATE;
	        _this.resetErrorBoundary = function () {
	            var onReset = _this.props.onReset;
	            var _a = _this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
	            if (onReset) {
	                onReset(error, componentStack, eventId);
	            }
	            _this.setState(INITIAL_STATE);
	        };
	        return _this;
	    }
	    ErrorBoundary.prototype.componentDidCatch = function (error, _a) {
	        var _this = this;
	        var componentStack = _a.componentStack;
	        var _b = this.props, beforeCapture = _b.beforeCapture, onError = _b.onError, showDialog = _b.showDialog, dialogOptions = _b.dialogOptions;
	        browser_1.withScope(function (scope) {
	            // If on React version >= 17, create stack trace from componentStack param and links
	            // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
	            // Linking errors requires the `LinkedErrors` integration be enabled.
	            if (reactVersion.major && reactVersion.major >= 17) {
	                var errorBoundaryError = new Error(error.message);
	                errorBoundaryError.name = "React ErrorBoundary " + errorBoundaryError.name;
	                errorBoundaryError.stack = componentStack;
	                // Using the `LinkedErrors` integration to link the errors together.
	                error.cause = errorBoundaryError;
	            }
	            if (beforeCapture) {
	                beforeCapture(scope, error, componentStack);
	            }
	            var eventId = browser_1.captureException(error, { contexts: { react: { componentStack: componentStack } } });
	            if (onError) {
	                onError(error, componentStack, eventId);
	            }
	            if (showDialog) {
	                browser_1.showReportDialog(tslib_1.__assign(tslib_1.__assign({}, dialogOptions), { eventId: eventId }));
	            }
	            // componentDidCatch is used over getDerivedStateFromError
	            // so that componentStack is accessible through state.
	            _this.setState({ error: error, componentStack: componentStack, eventId: eventId });
	        });
	    };
	    ErrorBoundary.prototype.componentDidMount = function () {
	        var onMount = this.props.onMount;
	        if (onMount) {
	            onMount();
	        }
	    };
	    ErrorBoundary.prototype.componentWillUnmount = function () {
	        var _a = this.state, error = _a.error, componentStack = _a.componentStack, eventId = _a.eventId;
	        var onUnmount = this.props.onUnmount;
	        if (onUnmount) {
	            onUnmount(error, componentStack, eventId);
	        }
	    };
	    ErrorBoundary.prototype.render = function () {
	        var _a = this.props, fallback = _a.fallback, children = _a.children;
	        var _b = this.state, error = _b.error, componentStack = _b.componentStack, eventId = _b.eventId;
	        if (error) {
	            var element = undefined;
	            if (typeof fallback === 'function') {
	                element = fallback({ error: error, componentStack: componentStack, resetError: this.resetErrorBoundary, eventId: eventId });
	            }
	            else {
	                element = fallback;
	            }
	            if (React.isValidElement(element)) {
	                return element;
	            }
	            if (fallback) {
	                utils_1.logger.warn('fallback did not produce a valid ReactElement');
	            }
	            // Fail gracefully if no fallback provided or is not valid
	            return null;
	        }
	        if (typeof children === 'function') {
	            return children();
	        }
	        return children;
	    };
	    return ErrorBoundary;
	}(React.Component));
	exports.ErrorBoundary = ErrorBoundary;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || exports.UNKNOWN_COMPONENT;
	    var Wrapped = function (props) { return (React.createElement(ErrorBoundary, tslib_1.__assign({}, errorBoundaryOptions),
	        React.createElement(WrappedComponent, tslib_1.__assign({}, props)))); };
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    Wrapped.displayName = "errorBoundary(" + componentDisplayName + ")";
	    // Copy over static methods from Wrapped component to Profiler HOC
	    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
	    hoist_non_react_statics_1.default(Wrapped, WrappedComponent);
	    return Wrapped;
	}
	exports.withErrorBoundary = withErrorBoundary;
	//# sourceMappingURL=errorboundary.js.map

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var browser_1 = __webpack_require__(602);
	var utils_1 = __webpack_require__(65);
	var hoist_non_react_statics_1 = tslib_1.__importDefault(__webpack_require__(1068));
	var React = tslib_1.__importStar(__webpack_require__(1));
	var constants_1 = __webpack_require__(2937);
	exports.UNKNOWN_COMPONENT = 'unknown';
	var TRACING_GETTER = {
	    id: 'Tracing',
	};
	var globalTracingIntegration = null;
	/** @deprecated remove when @sentry/apm no longer used */
	var getTracingIntegration = function () {
	    if (globalTracingIntegration) {
	        return globalTracingIntegration;
	    }
	    globalTracingIntegration = browser_1.getCurrentHub().getIntegration(TRACING_GETTER);
	    return globalTracingIntegration;
	};
	/**
	 * pushActivity creates an new react activity.
	 * Is a no-op if Tracing integration is not valid
	 * @param name displayName of component that started activity
	 * @deprecated remove when @sentry/apm no longer used
	 */
	function pushActivity(name, op) {
	    if (globalTracingIntegration === null) {
	        return null;
	    }
	    return globalTracingIntegration.constructor.pushActivity(name, {
	        description: "<" + name + ">",
	        op: op,
	    });
	}
	/**
	 * popActivity removes a React activity.
	 * Is a no-op if Tracing integration is not valid.
	 * @param activity id of activity that is being popped
	 * @deprecated remove when @sentry/apm no longer used
	 */
	function popActivity(activity) {
	    if (activity === null || globalTracingIntegration === null) {
	        return;
	    }
	    globalTracingIntegration.constructor.popActivity(activity);
	}
	/**
	 * Obtain a span given an activity id.
	 * Is a no-op if Tracing integration is not valid.
	 * @param activity activity id associated with obtained span
	 * @deprecated remove when @sentry/apm no longer used
	 */
	function getActivitySpan(activity) {
	    if (activity === null || globalTracingIntegration === null) {
	        return undefined;
	    }
	    return globalTracingIntegration.constructor.getActivitySpan(activity);
	}
	/**
	 * The Profiler component leverages Sentry's Tracing integration to generate
	 * spans based on component lifecycles.
	 */
	var Profiler = /** @class */ (function (_super) {
	    tslib_1.__extends(Profiler, _super);
	    function Profiler(props) {
	        var _this = _super.call(this, props) || this;
	        /**
	         * The span of the mount activity
	         * Made protected for the React Native SDK to access
	         */
	        _this._mountSpan = undefined;
	        // The activity representing how long it takes to mount a component.
	        _this._mountActivity = null;
	        var _a = _this.props, name = _a.name, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
	        if (disabled) {
	            return _this;
	        }
	        // If they are using @sentry/apm, we need to push/pop activities
	        // eslint-disable-next-line deprecation/deprecation
	        if (getTracingIntegration()) {
	            // eslint-disable-next-line deprecation/deprecation
	            _this._mountActivity = pushActivity(name, constants_1.REACT_MOUNT_OP);
	        }
	        else {
	            var activeTransaction = getActiveTransaction();
	            if (activeTransaction) {
	                _this._mountSpan = activeTransaction.startChild({
	                    description: "<" + name + ">",
	                    op: constants_1.REACT_MOUNT_OP,
	                });
	            }
	        }
	        return _this;
	    }
	    // If a component mounted, we can finish the mount activity.
	    Profiler.prototype.componentDidMount = function () {
	        if (this._mountSpan) {
	            this._mountSpan.finish();
	        }
	        else {
	            // eslint-disable-next-line deprecation/deprecation
	            this._mountSpan = getActivitySpan(this._mountActivity);
	            // eslint-disable-next-line deprecation/deprecation
	            popActivity(this._mountActivity);
	            this._mountActivity = null;
	        }
	    };
	    Profiler.prototype.componentDidUpdate = function (_a) {
	        var _this = this;
	        var updateProps = _a.updateProps, _b = _a.includeUpdates, includeUpdates = _b === void 0 ? true : _b;
	        // Only generate an update span if hasUpdateSpan is true, if there is a valid mountSpan,
	        // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
	        // We are just trying to give baseline clues for further investigation.
	        if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
	            // See what props haved changed between the previous props, and the current props. This is
	            // set as data on the span. We just store the prop keys as the values could be potenially very large.
	            var changedProps = Object.keys(updateProps).filter(function (k) { return updateProps[k] !== _this.props.updateProps[k]; });
	            if (changedProps.length > 0) {
	                // The update span is a point in time span with 0 duration, just signifying that the component
	                // has been updated.
	                var now = utils_1.timestampWithMs();
	                this._mountSpan.startChild({
	                    data: {
	                        changedProps: changedProps,
	                    },
	                    description: "<" + this.props.name + ">",
	                    endTimestamp: now,
	                    op: constants_1.REACT_UPDATE_OP,
	                    startTimestamp: now,
	                });
	            }
	        }
	    };
	    // If a component is unmounted, we can say it is no longer on the screen.
	    // This means we can finish the span representing the component render.
	    Profiler.prototype.componentWillUnmount = function () {
	        var _a = this.props, name = _a.name, _b = _a.includeRender, includeRender = _b === void 0 ? true : _b;
	        if (this._mountSpan && includeRender) {
	            // If we were able to obtain the spanId of the mount activity, we should set the
	            // next activity as a child to the component mount activity.
	            this._mountSpan.startChild({
	                description: "<" + name + ">",
	                endTimestamp: utils_1.timestampWithMs(),
	                op: constants_1.REACT_RENDER_OP,
	                startTimestamp: this._mountSpan.endTimestamp,
	            });
	        }
	    };
	    Profiler.prototype.render = function () {
	        return this.props.children;
	    };
	    // eslint-disable-next-line @typescript-eslint/member-ordering
	    Profiler.defaultProps = {
	        disabled: false,
	        includeRender: true,
	        includeUpdates: true,
	    };
	    return Profiler;
	}(React.Component));
	exports.Profiler = Profiler;
	/**
	 * withProfiler is a higher order component that wraps a
	 * component in a {@link Profiler} component. It is recommended that
	 * the higher order component be used over the regular {@link Profiler} component.
	 *
	 * @param WrappedComponent component that is wrapped by Profiler
	 * @param options the {@link ProfilerProps} you can pass into the Profiler
	 */
	function withProfiler(WrappedComponent, 
	// We do not want to have `updateProps` given in options, it is instead filled through the HOC.
	options) {
	    var componentDisplayName = (options && options.name) || WrappedComponent.displayName || WrappedComponent.name || exports.UNKNOWN_COMPONENT;
	    var Wrapped = function (props) { return (React.createElement(Profiler, tslib_1.__assign({}, options, { name: componentDisplayName, updateProps: props }),
	        React.createElement(WrappedComponent, tslib_1.__assign({}, props)))); };
	    Wrapped.displayName = "profiler(" + componentDisplayName + ")";
	    // Copy over static methods from Wrapped component to Profiler HOC
	    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
	    hoist_non_react_statics_1.default(Wrapped, WrappedComponent);
	    return Wrapped;
	}
	exports.withProfiler = withProfiler;
	/**
	 *
	 * `useProfiler` is a React hook that profiles a React component.
	 *
	 * Requires React 16.8 or above.
	 * @param name displayName of component being profiled
	 */
	function useProfiler(name, options) {
	    if (options === void 0) { options = {
	        disabled: false,
	        hasRenderSpan: true,
	    }; }
	    var _a = tslib_1.__read(React.useState(function () {
	        if (options && options.disabled) {
	            return undefined;
	        }
	        var activeTransaction = getActiveTransaction();
	        if (activeTransaction) {
	            return activeTransaction.startChild({
	                description: "<" + name + ">",
	                op: constants_1.REACT_MOUNT_OP,
	            });
	        }
	        return undefined;
	    }), 1), mountSpan = _a[0];
	    React.useEffect(function () {
	        if (mountSpan) {
	            mountSpan.finish();
	        }
	        return function () {
	            if (mountSpan && options.hasRenderSpan) {
	                mountSpan.startChild({
	                    description: "<" + name + ">",
	                    endTimestamp: utils_1.timestampWithMs(),
	                    op: constants_1.REACT_RENDER_OP,
	                    startTimestamp: mountSpan.endTimestamp,
	                });
	            }
	        };
	        // We only want this to run once.
	        // eslint-disable-next-line react-hooks/exhaustive-deps
	    }, []);
	}
	exports.useProfiler = useProfiler;
	/** Grabs active transaction off scope */
	function getActiveTransaction(hub) {
	    if (hub === void 0) { hub = browser_1.getCurrentHub(); }
	    if (hub) {
	        var scope = hub.getScope();
	        if (scope) {
	            return scope.getTransaction();
	        }
	    }
	    return undefined;
	}
	exports.getActiveTransaction = getActiveTransaction;
	//# sourceMappingURL=profiler.js.map

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	var hoist_non_react_statics_1 = tslib_1.__importDefault(__webpack_require__(1068));
	var React = tslib_1.__importStar(__webpack_require__(1));
	/* eslint-enable @typescript-eslint/no-explicit-any */
	var global = utils_1.getGlobalObject();
	var activeTransaction;
	function reactRouterV4Instrumentation(history, routes, matchPath) {
	    return createReactRouterInstrumentation(history, 'react-router-v4', routes, matchPath);
	}
	exports.reactRouterV4Instrumentation = reactRouterV4Instrumentation;
	function reactRouterV5Instrumentation(history, routes, matchPath) {
	    return createReactRouterInstrumentation(history, 'react-router-v5', routes, matchPath);
	}
	exports.reactRouterV5Instrumentation = reactRouterV5Instrumentation;
	function createReactRouterInstrumentation(history, name, allRoutes, matchPath) {
	    if (allRoutes === void 0) { allRoutes = []; }
	    function getInitPathName() {
	        if (history && history.location) {
	            return history.location.pathname;
	        }
	        if (global && global.location) {
	            return global.location.pathname;
	        }
	        return undefined;
	    }
	    function getTransactionName(pathname) {
	        if (allRoutes.length === 0 || !matchPath) {
	            return pathname;
	        }
	        var branches = matchRoutes(allRoutes, pathname, matchPath);
	        // eslint-disable-next-line @typescript-eslint/prefer-for-of
	        for (var x = 0; x < branches.length; x++) {
	            if (branches[x].match.isExact) {
	                return branches[x].match.path;
	            }
	        }
	        return pathname;
	    }
	    return function (customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
	        if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
	        if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
	        var initPathName = getInitPathName();
	        if (startTransactionOnPageLoad && initPathName) {
	            activeTransaction = customStartTransaction({
	                name: getTransactionName(initPathName),
	                op: 'pageload',
	                tags: {
	                    'routing.instrumentation': name,
	                },
	            });
	        }
	        if (startTransactionOnLocationChange && history.listen) {
	            history.listen(function (location, action) {
	                if (action && (action === 'PUSH' || action === 'POP')) {
	                    if (activeTransaction) {
	                        activeTransaction.finish();
	                    }
	                    var tags = {
	                        'routing.instrumentation': name,
	                    };
	                    activeTransaction = customStartTransaction({
	                        name: getTransactionName(location.pathname),
	                        op: 'navigation',
	                        tags: tags,
	                    });
	                }
	            });
	        }
	    };
	}
	/**
	 * Matches a set of routes to a pathname
	 * Based on implementation from
	 */
	function matchRoutes(routes, pathname, matchPath, branch) {
	    if (branch === void 0) { branch = []; }
	    routes.some(function (route) {
	        var match = route.path
	            ? matchPath(pathname, route)
	            : branch.length
	                ? branch[branch.length - 1].match // use parent match
	                : computeRootMatch(pathname); // use default "root" match
	        if (match) {
	            branch.push({ route: route, match: match });
	            if (route.routes) {
	                matchRoutes(route.routes, pathname, matchPath, branch);
	            }
	        }
	        return !!match;
	    });
	    return branch;
	}
	function computeRootMatch(pathname) {
	    return { path: '/', url: '/', params: {}, isExact: pathname === '/' };
	}
	/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
	function withSentryRouting(Route) {
	    var componentDisplayName = Route.displayName || Route.name;
	    var WrappedRoute = function (props) {
	        if (activeTransaction && props && props.computedMatch && props.computedMatch.isExact) {
	            activeTransaction.setName(props.computedMatch.path);
	        }
	        // @ts-ignore Setting more specific React Component typing for `R` generic above
	        // will break advanced type inference done by react router params:
	        // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
	        return React.createElement(Route, tslib_1.__assign({}, props));
	    };
	    WrappedRoute.displayName = "sentryRoute(" + componentDisplayName + ")";
	    hoist_non_react_statics_1.default(WrappedRoute, Route);
	    // @ts-ignore Setting more specific React Component typing for `R` generic above
	    // will break advanced type inference done by react router params:
	    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
	    return WrappedRoute;
	}
	exports.withSentryRouting = withSentryRouting;
	/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
	//# sourceMappingURL=reactrouter.js.map

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	var global = utils_1.getGlobalObject();
	/**
	 * Creates routing instrumentation for React Router v3
	 * Works for React Router >= 3.2.0 and < 4.0.0
	 *
	 * @param history object from the `history` library
	 * @param routes a list of all routes, should be
	 * @param match `Router.match` utility
	 */
	function reactRouterV3Instrumentation(history, routes, match) {
	    return function (startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
	        if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
	        if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
	        var activeTransaction;
	        var prevName;
	        // Have to use global.location because history.location might not be defined.
	        if (startTransactionOnPageLoad && global && global.location) {
	            normalizeTransactionName(routes, global.location, match, function (localName) {
	                prevName = localName;
	                activeTransaction = startTransaction({
	                    name: prevName,
	                    op: 'pageload',
	                    tags: {
	                        'routing.instrumentation': 'react-router-v3',
	                    },
	                });
	            });
	        }
	        if (startTransactionOnLocationChange && history.listen) {
	            history.listen(function (location) {
	                if (location.action === 'PUSH' || location.action === 'POP') {
	                    if (activeTransaction) {
	                        activeTransaction.finish();
	                    }
	                    var tags_1 = {
	                        'routing.instrumentation': 'react-router-v3',
	                    };
	                    if (prevName) {
	                        tags_1.from = prevName;
	                    }
	                    normalizeTransactionName(routes, location, match, function (localName) {
	                        prevName = localName;
	                        activeTransaction = startTransaction({
	                            name: prevName,
	                            op: 'navigation',
	                            tags: tags_1,
	                        });
	                    });
	                }
	            });
	        }
	    };
	}
	exports.reactRouterV3Instrumentation = reactRouterV3Instrumentation;
	/**
	 * Normalize transaction names using `Router.match`
	 */
	function normalizeTransactionName(appRoutes, location, match, callback) {
	    var name = location.pathname;
	    match({
	        location: location,
	        routes: appRoutes,
	    }, function (error, _redirectLocation, renderProps) {
	        if (error || !renderProps) {
	            return callback(name);
	        }
	        var routePath = getRouteStringFromRoutes(renderProps.routes || []);
	        if (routePath.length === 0 || routePath === '/*') {
	            return callback(name);
	        }
	        name = routePath;
	        return callback(name);
	    });
	}
	/**
	 * Generate route name from array of routes
	 */
	function getRouteStringFromRoutes(routes) {
	    if (!Array.isArray(routes) || routes.length === 0) {
	        return '';
	    }
	    var routesWithPaths = routes.filter(function (route) { return !!route.path; });
	    var index = -1;
	    for (var x = routesWithPaths.length - 1; x >= 0; x--) {
	        var route = routesWithPaths[x];
	        if (route.path && route.path.startsWith('/')) {
	            index = x;
	            break;
	        }
	    }
	    return routesWithPaths
	        .slice(index)
	        .filter(function (_a) {
	        var path = _a.path;
	        return !!path;
	    })
	        .map(function (_a) {
	        var path = _a.path;
	        return path;
	    })
	        .join('');
	}
	//# sourceMappingURL=reactrouterv3.js.map

/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	/* eslint-disable @typescript-eslint/no-explicit-any */
	var minimal_1 = __webpack_require__(1676);
	var ACTION_BREADCRUMB_CATEGORY = 'redux.action';
	var ACTION_BREADCRUMB_TYPE = 'info';
	var STATE_CONTEXT_KEY = 'redux.state';
	var defaultOptions = {
	    actionTransformer: function (action) { return action; },
	    stateTransformer: function (state) { return state || null; },
	};
	/**
	 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
	 *
	 * @param enhancerOptions Options to pass to the enhancer
	 */
	function createReduxEnhancer(enhancerOptions) {
	    // Note: We return an any type as to not have type conflicts.
	    var options = tslib_1.__assign(tslib_1.__assign({}, defaultOptions), enhancerOptions);
	    return function (next) { return function (reducer, initialState) {
	        var sentryReducer = function (state, action) {
	            var newState = reducer(state, action);
	            minimal_1.configureScope(function (scope) {
	                /* Action breadcrumbs */
	                var transformedAction = options.actionTransformer(action);
	                if (typeof transformedAction !== 'undefined' && transformedAction !== null) {
	                    scope.addBreadcrumb({
	                        category: ACTION_BREADCRUMB_CATEGORY,
	                        data: transformedAction,
	                        type: ACTION_BREADCRUMB_TYPE,
	                    });
	                }
	                /* Set latest state to scope */
	                var transformedState = options.stateTransformer(newState);
	                if (typeof transformedState !== 'undefined' && transformedState !== null) {
	                    scope.setContext(STATE_CONTEXT_KEY, transformedState);
	                }
	                else {
	                    scope.setContext(STATE_CONTEXT_KEY, null);
	                }
	                /* Allow user to configure scope with latest state */
	                // eslint-disable-next-line @typescript-eslint/unbound-method
	                var configureScopeWithState = options.configureScopeWithState;
	                if (typeof configureScopeWithState === 'function') {
	                    configureScopeWithState(scope, newState);
	                }
	            });
	            return newState;
	        };
	        return next(sentryReducer, initialState);
	    }; };
	}
	exports.createReduxEnhancer = createReduxEnhancer;
	//# sourceMappingURL=redux.js.map

/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var browser_1 = __webpack_require__(602);
	/**
	 * Inits the React SDK
	 */
	function init(options) {
	    options._metadata = options._metadata || {};
	    options._metadata.sdk = options._metadata.sdk || {
	        name: 'sentry.javascript.react',
	        packages: [
	            {
	                name: 'npm:@sentry/react',
	                version: browser_1.SDK_VERSION,
	            },
	        ],
	        version: browser_1.SDK_VERSION,
	    };
	    browser_1.init(options);
	}
	exports.init = init;
	//# sourceMappingURL=sdk.js.map

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	var constants_1 = __webpack_require__(1678);
	var spanstatus_1 = __webpack_require__(386);
	var utils_2 = __webpack_require__(387);
	var global = utils_1.getGlobalObject();
	/**
	 * Add a listener that cancels and finishes a transaction when the global
	 * document is hidden.
	 */
	function registerBackgroundTabDetection() {
	    if (global && global.document) {
	        global.document.addEventListener('visibilitychange', function () {
	            var activeTransaction = utils_2.getActiveTransaction();
	            if (global.document.hidden && activeTransaction) {
	                utils_1.logger.log("[Tracing] Transaction: " + spanstatus_1.SpanStatus.Cancelled + " -> since tab moved to the background, op: " + activeTransaction.op);
	                // We should not set status if it is already set, this prevent important statuses like
	                // error or data loss from being overwritten on transaction.
	                if (!activeTransaction.status) {
	                    activeTransaction.setStatus(spanstatus_1.SpanStatus.Cancelled);
	                }
	                activeTransaction.setTag('visibilitychange', 'document.hidden');
	                activeTransaction.setTag(constants_1.FINISH_REASON_TAG, constants_1.IDLE_TRANSACTION_FINISH_REASONS[2]);
	                activeTransaction.finish();
	            }
	        });
	    }
	    else {
	        utils_1.logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
	    }
	}
	exports.registerBackgroundTabDetection = registerBackgroundTabDetection;
	//# sourceMappingURL=backgroundtab.js.map

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	var hubextensions_1 = __webpack_require__(1074);
	var idletransaction_1 = __webpack_require__(1075);
	var spanstatus_1 = __webpack_require__(386);
	var utils_2 = __webpack_require__(387);
	var backgroundtab_1 = __webpack_require__(2944);
	var metrics_1 = __webpack_require__(2946);
	var request_1 = __webpack_require__(1677);
	var router_1 = __webpack_require__(2947);
	exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
	var DEFAULT_BROWSER_TRACING_OPTIONS = tslib_1.__assign({ idleTimeout: idletransaction_1.DEFAULT_IDLE_TIMEOUT, markBackgroundTransactions: true, maxTransactionDuration: exports.DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: router_1.instrumentRoutingWithDefaults, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, request_1.defaultRequestInstrumentationOptions);
	/**
	 * The Browser Tracing integration automatically instruments browser pageload/navigation
	 * actions as transactions, and captures requests, metrics and errors as spans.
	 *
	 * The integration can be configured with a variety of options, and can be extended to use
	 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
	 */
	var BrowserTracing = /** @class */ (function () {
	    function BrowserTracing(_options) {
	        /**
	         * @inheritDoc
	         */
	        this.name = BrowserTracing.id;
	        this._emitOptionsWarning = false;
	        /** Store configured idle timeout so that it can be added as a tag to transactions */
	        this._configuredIdleTimeout = undefined;
	        var tracingOrigins = request_1.defaultRequestInstrumentationOptions.tracingOrigins;
	        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
	        if (_options) {
	            this._configuredIdleTimeout = _options.idleTimeout;
	            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
	                tracingOrigins = _options.tracingOrigins;
	            }
	            else {
	                this._emitOptionsWarning = true;
	            }
	        }
	        this.options = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
	        var _metricOptions = this.options._metricOptions;
	        this._metrics = new metrics_1.MetricsInstrumentation(_metricOptions && _metricOptions._reportAllChanges);
	    }
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
	        var _this = this;
	        this._getCurrentHub = getCurrentHub;
	        if (this._emitOptionsWarning) {
	            utils_1.logger.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
	            utils_1.logger.warn("[Tracing] We added a reasonable default for you: " + request_1.defaultRequestInstrumentationOptions.tracingOrigins);
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
	        instrumentRouting(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
	        if (markBackgroundTransactions) {
	            backgroundtab_1.registerBackgroundTabDetection();
	        }
	        request_1.instrumentOutgoingRequests({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
	    };
	    /** Create routing idle transaction. */
	    BrowserTracing.prototype._createRouteTransaction = function (context) {
	        var _this = this;
	        if (!this._getCurrentHub) {
	            utils_1.logger.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
	            return undefined;
	        }
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
	        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
	        var expandedContext = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, context), parentContextFromHeader), { trimEnd: true });
	        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
	        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
	        // from being sent to Sentry).
	        var finalContext = modifiedContext === undefined ? tslib_1.__assign(tslib_1.__assign({}, expandedContext), { sampled: false }) : modifiedContext;
	        if (finalContext.sampled === false) {
	            utils_1.logger.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
	        }
	        utils_1.logger.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
	        var hub = this._getCurrentHub();
	        var location = utils_1.getGlobalObject().location;
	        var idleTransaction = hubextensions_1.startIdleTransaction(hub, finalContext, idleTimeout, true, { location: location });
	        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
	            _this._metrics.addPerformanceEntries(transaction);
	            adjustTransactionDuration(utils_2.secToMs(maxTransactionDuration), transaction, endTimestamp);
	        });
	        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
	        return idleTransaction;
	    };
	    /**
	     * @inheritDoc
	     */
	    BrowserTracing.id = 'BrowserTracing';
	    return BrowserTracing;
	}());
	exports.BrowserTracing = BrowserTracing;
	/**
	 * Gets transaction context from a sentry-trace meta.
	 *
	 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
	 */
	function getHeaderContext() {
	    var header = getMetaContent('sentry-trace');
	    if (header) {
	        return utils_2.extractTraceparentData(header);
	    }
	    return undefined;
	}
	exports.getHeaderContext = getHeaderContext;
	/** Returns the value of a meta tag */
	function getMetaContent(metaName) {
	    var el = utils_1.getGlobalObject().document.querySelector("meta[name=" + metaName + "]");
	    return el ? el.getAttribute('content') : null;
	}
	exports.getMetaContent = getMetaContent;
	/** Adjusts transaction value based on max transaction duration */
	function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
	    var diff = endTimestamp - transaction.startTimestamp;
	    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
	    if (isOutdatedTransaction) {
	        transaction.setStatus(spanstatus_1.SpanStatus.DeadlineExceeded);
	        transaction.setTag('maxTransactionDurationExceeded', 'true');
	    }
	}
	//# sourceMappingURL=browsertracing.js.map

/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	var utils_2 = __webpack_require__(387);
	var getCLS_1 = __webpack_require__(2948);
	var getFID_1 = __webpack_require__(2949);
	var getLCP_1 = __webpack_require__(2950);
	var getVisibilityWatcher_1 = __webpack_require__(1071);
	var global = utils_1.getGlobalObject();
	/** Class tracking metrics  */
	var MetricsInstrumentation = /** @class */ (function () {
	    function MetricsInstrumentation(_reportAllChanges) {
	        if (_reportAllChanges === void 0) { _reportAllChanges = false; }
	        var _a, _b;
	        this._reportAllChanges = _reportAllChanges;
	        this._measurements = {};
	        this._performanceCursor = 0;
	        if (!utils_1.isNodeEnv() && ((_a = global) === null || _a === void 0 ? void 0 : _a.performance) && ((_b = global) === null || _b === void 0 ? void 0 : _b.document)) {
	            if (global.performance.mark) {
	                global.performance.mark('sentry-tracing-init');
	            }
	            this._trackCLS();
	            this._trackLCP();
	            this._trackFID();
	        }
	    }
	    /** Add performance related spans to a transaction */
	    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
	        var _this = this;
	        if (!global || !global.performance || !global.performance.getEntries || !utils_1.browserPerformanceTimeOrigin) {
	            // Gatekeeper if performance API not available
	            return;
	        }
	        utils_1.logger.log('[Tracing] Adding & adjusting spans using Performance API');
	        var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	        var entryScriptSrc;
	        if (global.document && global.document.scripts) {
	            // eslint-disable-next-line @typescript-eslint/prefer-for-of
	            for (var i = 0; i < global.document.scripts.length; i++) {
	                // We go through all scripts on the page and look for 'data-entry'
	                // We remember the name and measure the time between this script finished loading and
	                // our mark 'sentry-tracing-init'
	                if (global.document.scripts[i].dataset.entry === 'true') {
	                    entryScriptSrc = global.document.scripts[i].src;
	                    break;
	                }
	            }
	        }
	        var entryScriptStartTimestamp;
	        var tracingInitMarkStartTime;
	        var responseStartTimestamp;
	        var requestStartTimestamp;
	        global.performance
	            .getEntries()
	            .slice(this._performanceCursor)
	            .forEach(function (entry) {
	            var startTime = utils_2.msToSec(entry.startTime);
	            var duration = utils_2.msToSec(entry.duration);
	            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
	                return;
	            }
	            switch (entry.entryType) {
	                case 'navigation': {
	                    addNavigationSpans(transaction, entry, timeOrigin);
	                    responseStartTimestamp = timeOrigin + utils_2.msToSec(entry.responseStart);
	                    requestStartTimestamp = timeOrigin + utils_2.msToSec(entry.requestStart);
	                    break;
	                }
	                case 'mark':
	                case 'paint':
	                case 'measure': {
	                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
	                    if (tracingInitMarkStartTime === undefined && entry.name === 'sentry-tracing-init') {
	                        tracingInitMarkStartTime = startTimestamp;
	                    }
	                    // capture web vitals
	                    var firstHidden = getVisibilityWatcher_1.getVisibilityWatcher();
	                    // Only report if the page wasn't hidden prior to the web vital.
	                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
	                    if (entry.name === 'first-paint' && shouldRecord) {
	                        utils_1.logger.log('[Measurements] Adding FP');
	                        _this._measurements['fp'] = { value: entry.startTime };
	                        _this._measurements['mark.fp'] = { value: startTimestamp };
	                    }
	                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
	                        utils_1.logger.log('[Measurements] Adding FCP');
	                        _this._measurements['fcp'] = { value: entry.startTime };
	                        _this._measurements['mark.fcp'] = { value: startTimestamp };
	                    }
	                    break;
	                }
	                case 'resource': {
	                    var resourceName = entry.name.replace(global.location.origin, '');
	                    var endTimestamp = addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
	                    // We remember the entry script end time to calculate the difference to the first init mark
	                    if (entryScriptStartTimestamp === undefined && (entryScriptSrc || '').indexOf(resourceName) > -1) {
	                        entryScriptStartTimestamp = endTimestamp;
	                    }
	                    break;
	                }
	                default:
	                // Ignore other entry types.
	            }
	        });
	        if (entryScriptStartTimestamp !== undefined && tracingInitMarkStartTime !== undefined) {
	            _startChild(transaction, {
	                description: 'evaluation',
	                endTimestamp: tracingInitMarkStartTime,
	                op: 'script',
	                startTimestamp: entryScriptStartTimestamp,
	            });
	        }
	        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
	        this._trackNavigator(transaction);
	        // Measurements are only available for pageload transactions
	        if (transaction.op === 'pageload') {
	            // normalize applicable web vital values to be relative to transaction.startTimestamp
	            var timeOrigin_1 = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
	            // start of the response in milliseconds
	            if (typeof responseStartTimestamp === 'number') {
	                utils_1.logger.log('[Measurements] Adding TTFB');
	                this._measurements['ttfb'] = { value: (responseStartTimestamp - transaction.startTimestamp) * 1000 };
	                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
	                    // Capture the time spent making the request and receiving the first byte of the response.
	                    // This is the time between the start of the request and the start of the response in milliseconds.
	                    this._measurements['ttfb.requestTime'] = { value: (responseStartTimestamp - requestStartTimestamp) * 1000 };
	                }
	            }
	            ['fcp', 'fp', 'lcp'].forEach(function (name) {
	                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
	                    return;
	                }
	                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
	                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
	                // to be adjusted to be relative to transaction.startTimestamp.
	                var oldValue = _this._measurements[name].value;
	                var measurementTimestamp = timeOrigin_1 + utils_2.msToSec(oldValue);
	                // normalizedValue should be in milliseconds
	                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
	                var delta = normalizedValue - oldValue;
	                utils_1.logger.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
	                _this._measurements[name].value = normalizedValue;
	            });
	            if (this._measurements['mark.fid'] && this._measurements['fid']) {
	                // create span for FID
	                _startChild(transaction, {
	                    description: 'first input delay',
	                    endTimestamp: this._measurements['mark.fid'].value + utils_2.msToSec(this._measurements['fid'].value),
	                    op: 'web.vitals',
	                    startTimestamp: this._measurements['mark.fid'].value,
	                });
	            }
	            // If FCP is not recorded we should not record the cls value
	            // according to the new definition of CLS.
	            if (!('fcp' in this._measurements)) {
	                delete this._measurements.cls;
	            }
	            transaction.setMeasurements(this._measurements);
	            this._tagMetricInfo(transaction);
	            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
	        }
	    };
	    /** Add LCP / CLS data to transaction to allow debugging */
	    MetricsInstrumentation.prototype._tagMetricInfo = function (transaction) {
	        if (this._lcpEntry) {
	            utils_1.logger.log('[Measurements] Adding LCP Data');
	            // Capture Properties of the LCP element that contributes to the LCP.
	            if (this._lcpEntry.element) {
	                transaction.setTag('lcp.element', utils_1.htmlTreeAsString(this._lcpEntry.element));
	            }
	            if (this._lcpEntry.id) {
	                transaction.setTag('lcp.id', this._lcpEntry.id);
	            }
	            if (this._lcpEntry.url) {
	                // Trim URL to the first 200 characters.
	                transaction.setTag('lcp.url', this._lcpEntry.url.trim().slice(0, 200));
	            }
	            transaction.setTag('lcp.size', this._lcpEntry.size);
	        }
	        // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
	        if (this._clsEntry && this._clsEntry.sources) {
	            utils_1.logger.log('[Measurements] Adding CLS Data');
	            this._clsEntry.sources.forEach(function (source, index) {
	                return transaction.setTag("cls.source." + (index + 1), utils_1.htmlTreeAsString(source.node));
	            });
	        }
	    };
	    /** Starts tracking the Cumulative Layout Shift on the current page. */
	    MetricsInstrumentation.prototype._trackCLS = function () {
	        var _this = this;
	        // See:
	        // https://web.dev/evolving-cls/
	        // https://web.dev/cls-web-tooling/
	        getCLS_1.getCLS(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            utils_1.logger.log('[Measurements] Adding CLS');
	            _this._measurements['cls'] = { value: metric.value };
	            _this._clsEntry = entry;
	        });
	    };
	    /**
	     * Capture the information of the user agent.
	     */
	    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
	        var navigator = global.navigator;
	        if (!navigator) {
	            return;
	        }
	        // track network connectivity
	        var connection = navigator.connection;
	        if (connection) {
	            if (connection.effectiveType) {
	                transaction.setTag('effectiveConnectionType', connection.effectiveType);
	            }
	            if (connection.type) {
	                transaction.setTag('connectionType', connection.type);
	            }
	            if (isMeasurementValue(connection.rtt)) {
	                this._measurements['connection.rtt'] = { value: connection.rtt };
	            }
	            if (isMeasurementValue(connection.downlink)) {
	                this._measurements['connection.downlink'] = { value: connection.downlink };
	            }
	        }
	        if (isMeasurementValue(navigator.deviceMemory)) {
	            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
	        }
	        if (isMeasurementValue(navigator.hardwareConcurrency)) {
	            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
	        }
	    };
	    /** Starts tracking the Largest Contentful Paint on the current page. */
	    MetricsInstrumentation.prototype._trackLCP = function () {
	        var _this = this;
	        getLCP_1.getLCP(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            utils_1.logger.log('[Measurements] Adding LCP');
	            _this._measurements['lcp'] = { value: metric.value };
	            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
	            _this._lcpEntry = entry;
	        }, this._reportAllChanges);
	    };
	    /** Starts tracking the First Input Delay on the current page. */
	    MetricsInstrumentation.prototype._trackFID = function () {
	        var _this = this;
	        getFID_1.getFID(function (metric) {
	            var entry = metric.entries.pop();
	            if (!entry) {
	                return;
	            }
	            var timeOrigin = utils_2.msToSec(utils_1.browserPerformanceTimeOrigin);
	            var startTime = utils_2.msToSec(entry.startTime);
	            utils_1.logger.log('[Measurements] Adding FID');
	            _this._measurements['fid'] = { value: metric.value };
	            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
	        });
	    };
	    return MetricsInstrumentation;
	}());
	exports.MetricsInstrumentation = MetricsInstrumentation;
	/** Instrument navigation entries */
	function addNavigationSpans(transaction, entry, timeOrigin) {
	    addPerformanceNavigationTiming({ transaction: transaction, entry: entry, event: 'unloadEvent', timeOrigin: timeOrigin });
	    addPerformanceNavigationTiming({ transaction: transaction, entry: entry, event: 'redirect', timeOrigin: timeOrigin });
	    addPerformanceNavigationTiming({ transaction: transaction, entry: entry, event: 'domContentLoadedEvent', timeOrigin: timeOrigin });
	    addPerformanceNavigationTiming({ transaction: transaction, entry: entry, event: 'loadEvent', timeOrigin: timeOrigin });
	    addPerformanceNavigationTiming({ transaction: transaction, entry: entry, event: 'connect', timeOrigin: timeOrigin });
	    addPerformanceNavigationTiming({
	        transaction: transaction,
	        entry: entry,
	        event: 'secureConnection',
	        timeOrigin: timeOrigin,
	        eventEnd: 'connectEnd',
	        description: 'TLS/SSL',
	    });
	    addPerformanceNavigationTiming({
	        transaction: transaction,
	        entry: entry,
	        event: 'fetch',
	        timeOrigin: timeOrigin,
	        eventEnd: 'domainLookupStart',
	        description: 'cache',
	    });
	    addPerformanceNavigationTiming({ transaction: transaction, entry: entry, event: 'domainLookup', timeOrigin: timeOrigin, description: 'DNS' });
	    addRequest(transaction, entry, timeOrigin);
	}
	/** Create measure related spans */
	function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
	    var measureStartTimestamp = timeOrigin + startTime;
	    var measureEndTimestamp = measureStartTimestamp + duration;
	    _startChild(transaction, {
	        description: entry.name,
	        endTimestamp: measureEndTimestamp,
	        op: entry.entryType,
	        startTimestamp: measureStartTimestamp,
	    });
	    return measureStartTimestamp;
	}
	/** Create resource-related spans */
	function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
	    // we already instrument based on fetch and xhr, so we don't need to
	    // duplicate spans here.
	    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
	        return undefined;
	    }
	    var data = {};
	    if ('transferSize' in entry) {
	        data['Transfer Size'] = entry.transferSize;
	    }
	    if ('encodedBodySize' in entry) {
	        data['Encoded Body Size'] = entry.encodedBodySize;
	    }
	    if ('decodedBodySize' in entry) {
	        data['Decoded Body Size'] = entry.decodedBodySize;
	    }
	    var startTimestamp = timeOrigin + startTime;
	    var endTimestamp = startTimestamp + duration;
	    _startChild(transaction, {
	        description: resourceName,
	        endTimestamp: endTimestamp,
	        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
	        startTimestamp: startTimestamp,
	        data: data,
	    });
	    return endTimestamp;
	}
	exports.addResourceSpans = addResourceSpans;
	/** Create performance navigation related spans */
	function addPerformanceNavigationTiming(props) {
	    var transaction = props.transaction, entry = props.entry, event = props.event, timeOrigin = props.timeOrigin, eventEnd = props.eventEnd, description = props.description;
	    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
	    var start = entry[event + "Start"];
	    if (!start || !end) {
	        return;
	    }
	    _startChild(transaction, {
	        op: 'browser',
	        description: (description !== null && description !== void 0 ? description : event),
	        startTimestamp: timeOrigin + utils_2.msToSec(start),
	        endTimestamp: timeOrigin + utils_2.msToSec(end),
	    });
	}
	/** Create request and response related spans */
	function addRequest(transaction, entry, timeOrigin) {
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'request',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.requestStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	    _startChild(transaction, {
	        op: 'browser',
	        description: 'response',
	        startTimestamp: timeOrigin + utils_2.msToSec(entry.responseStart),
	        endTimestamp: timeOrigin + utils_2.msToSec(entry.responseEnd),
	    });
	}
	/**
	 * Helper function to start child on transactions. This function will make sure that the transaction will
	 * use the start timestamp of the created child span if it is earlier than the transactions actual
	 * start timestamp.
	 */
	function _startChild(transaction, _a) {
	    var startTimestamp = _a.startTimestamp, ctx = tslib_1.__rest(_a, ["startTimestamp"]);
	    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
	        transaction.startTimestamp = startTimestamp;
	    }
	    return transaction.startChild(tslib_1.__assign({ startTimestamp: startTimestamp }, ctx));
	}
	exports._startChild = _startChild;
	/**
	 * Checks if a given value is a valid measurement value.
	 */
	function isMeasurementValue(value) {
	    return typeof value === 'number' && isFinite(value);
	}
	//# sourceMappingURL=metrics.js.map

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	var global = utils_1.getGlobalObject();
	/**
	 * Default function implementing pageload and navigation transactions
	 */
	function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
	    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
	    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
	    if (!global || !global.location) {
	        utils_1.logger.warn('Could not initialize routing instrumentation due to invalid location');
	        return;
	    }
	    var startingUrl = global.location.href;
	    var activeTransaction;
	    if (startTransactionOnPageLoad) {
	        activeTransaction = customStartTransaction({ name: global.location.pathname, op: 'pageload' });
	    }
	    if (startTransactionOnLocationChange) {
	        utils_1.addInstrumentationHandler({
	            callback: function (_a) {
	                var to = _a.to, from = _a.from;
	                /**
	                 * This early return is there to account for some cases where a navigation transaction starts right after
	                 * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
	                 * create an uneccessary navigation transaction.
	                 *
	                 * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
	                 * only be caused in certain development environments where the usage of a hot module reloader is causing
	                 * errors.
	                 */
	                if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
	                    startingUrl = undefined;
	                    return;
	                }
	                if (from !== to) {
	                    startingUrl = undefined;
	                    if (activeTransaction) {
	                        utils_1.logger.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
	                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
	                        activeTransaction.finish();
	                    }
	                    activeTransaction = customStartTransaction({ name: global.location.pathname, op: 'navigation' });
	                }
	            },
	            type: 'history',
	        });
	    }
	}
	exports.instrumentRoutingWithDefaults = instrumentRoutingWithDefaults;
	//# sourceMappingURL=router.js.map

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(1070);
	var initMetric_1 = __webpack_require__(1072);
	var observe_1 = __webpack_require__(1073);
	var onHidden_1 = __webpack_require__(756);
	exports.getCLS = function (onReport, reportAllChanges) {
	    var metric = initMetric_1.initMetric('CLS', 0);
	    var report;
	    var sessionValue = 0;
	    var sessionEntries = [];
	    var entryHandler = function (entry) {
	        // Only count layout shifts without recent user input.
	        // TODO: Figure out why entry can be undefined
	        if (entry && !entry.hadRecentInput) {
	            var firstSessionEntry = sessionEntries[0];
	            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
	            // If the entry occurred less than 1 second after the previous entry and
	            // less than 5 seconds after the first entry in the session, include the
	            // entry in the current session. Otherwise, start a new session.
	            if (sessionValue &&
	                sessionEntries.length !== 0 &&
	                entry.startTime - lastSessionEntry.startTime < 1000 &&
	                entry.startTime - firstSessionEntry.startTime < 5000) {
	                sessionValue += entry.value;
	                sessionEntries.push(entry);
	            }
	            else {
	                sessionValue = entry.value;
	                sessionEntries = [entry];
	            }
	            // If the current session value is larger than the current CLS value,
	            // update CLS and the entries contributing to it.
	            if (sessionValue > metric.value) {
	                metric.value = sessionValue;
	                metric.entries = sessionEntries;
	                if (report) {
	                    report();
	                }
	            }
	        }
	    };
	    var po = observe_1.observe('layout-shift', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, reportAllChanges);
	        onHidden_1.onHidden(function () {
	            po.takeRecords().map(entryHandler);
	            report(true);
	        });
	    }
	};
	//# sourceMappingURL=getCLS.js.map

/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(1070);
	var getVisibilityWatcher_1 = __webpack_require__(1071);
	var initMetric_1 = __webpack_require__(1072);
	var observe_1 = __webpack_require__(1073);
	var onHidden_1 = __webpack_require__(756);
	exports.getFID = function (onReport, reportAllChanges) {
	    var visibilityWatcher = getVisibilityWatcher_1.getVisibilityWatcher();
	    var metric = initMetric_1.initMetric('FID');
	    var report;
	    var entryHandler = function (entry) {
	        // Only report if the page wasn't hidden prior to the first input.
	        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
	            metric.value = entry.processingStart - entry.startTime;
	            metric.entries.push(entry);
	            report(true);
	        }
	    };
	    var po = observe_1.observe('first-input', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, reportAllChanges);
	        onHidden_1.onHidden(function () {
	            po.takeRecords().map(entryHandler);
	            po.disconnect();
	        }, true);
	    }
	};
	//# sourceMappingURL=getFID.js.map

/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var bindReporter_1 = __webpack_require__(1070);
	var getVisibilityWatcher_1 = __webpack_require__(1071);
	var initMetric_1 = __webpack_require__(1072);
	var observe_1 = __webpack_require__(1073);
	var onHidden_1 = __webpack_require__(756);
	var reportedMetricIDs = {};
	exports.getLCP = function (onReport, reportAllChanges) {
	    var visibilityWatcher = getVisibilityWatcher_1.getVisibilityWatcher();
	    var metric = initMetric_1.initMetric('LCP');
	    var report;
	    var entryHandler = function (entry) {
	        // The startTime attribute returns the value of the renderTime if it is not 0,
	        // and the value of the loadTime otherwise.
	        var value = entry.startTime;
	        // If the page was hidden prior to paint time of the entry,
	        // ignore it and mark the metric as final, otherwise add the entry.
	        if (value < visibilityWatcher.firstHiddenTime) {
	            metric.value = value;
	            metric.entries.push(entry);
	        }
	        if (report) {
	            report();
	        }
	    };
	    var po = observe_1.observe('largest-contentful-paint', entryHandler);
	    if (po) {
	        report = bindReporter_1.bindReporter(onReport, metric, reportAllChanges);
	        var stopListening_1 = function () {
	            if (!reportedMetricIDs[metric.id]) {
	                po.takeRecords().map(entryHandler);
	                po.disconnect();
	                reportedMetricIDs[metric.id] = true;
	                report(true);
	            }
	        };
	        // Stop listening after input. Note: while scrolling is an input that
	        // stop LCP observation, it's unreliable since it can be programmatically
	        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
	        ['keydown', 'click'].forEach(function (type) {
	            addEventListener(type, stopListening_1, { once: true, capture: true });
	        });
	        onHidden_1.onHidden(stopListening_1, true);
	    }
	};
	//# sourceMappingURL=getLCP.js.map

/***/ }),
/* 2951 */
/***/ (function(module, exports) {

	/*
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     https://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Performantly generate a unique, 30-char string by combining a version
	 * number, the current timestamp with a 13-digit number integer.
	 * @return {string}
	 */
	exports.generateUniqueID = function () {
	    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
	};
	//# sourceMappingURL=generateUniqueID.js.map

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	var spanstatus_1 = __webpack_require__(386);
	var utils_2 = __webpack_require__(387);
	/**
	 * Configures global error listeners
	 */
	function registerErrorInstrumentation() {
	    utils_1.addInstrumentationHandler({
	        callback: errorCallback,
	        type: 'error',
	    });
	    utils_1.addInstrumentationHandler({
	        callback: errorCallback,
	        type: 'unhandledrejection',
	    });
	}
	exports.registerErrorInstrumentation = registerErrorInstrumentation;
	/**
	 * If an error or unhandled promise occurs, we mark the active transaction as failed
	 */
	function errorCallback() {
	    var activeTransaction = utils_2.getActiveTransaction();
	    if (activeTransaction) {
	        utils_1.logger.log("[Tracing] Transaction: " + spanstatus_1.SpanStatus.InternalError + " -> Global error occured");
	        activeTransaction.setStatus(spanstatus_1.SpanStatus.InternalError);
	    }
	}
	//# sourceMappingURL=errors.js.map

/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var hubextensions_1 = __webpack_require__(1074);
	exports.addExtensionMethods = hubextensions_1.addExtensionMethods;
	var Integrations = __webpack_require__(2954);
	exports.Integrations = Integrations;
	// This is already exported as part of `Integrations` above (and for the moment will remain so for
	// backwards compatibility), but that interferes with treeshaking, so we also export it separately
	// here.
	//
	// Previously we expected users to import tracing integrations like
	//
	// import { Integrations } from '@sentry/tracing';
	// const instance = new Integrations.BrowserTracing();
	//
	// This makes the integrations unable to be treeshaken though. To address this, we now have
	// this individual export. We now expect users to consume BrowserTracing like so:
	//
	// import { BrowserTracing } from '@sentry/tracing';
	// const instance = new BrowserTracing();
	//
	// For an example of of the new usage of BrowserTracing, see @sentry/nextjs index.client.ts
	var browser_1 = __webpack_require__(1069);
	exports.BrowserTracing = browser_1.BrowserTracing;
	var span_1 = __webpack_require__(1076);
	exports.Span = span_1.Span;
	var transaction_1 = __webpack_require__(1077);
	exports.Transaction = transaction_1.Transaction;
	var browser_2 = __webpack_require__(1069);
	// TODO deprecate old name in v7
	exports.registerRequestInstrumentation = browser_2.instrumentOutgoingRequests;
	exports.defaultRequestInstrumentationOptions = browser_2.defaultRequestInstrumentationOptions;
	var spanstatus_1 = __webpack_require__(386);
	exports.SpanStatus = spanstatus_1.SpanStatus;
	var idletransaction_1 = __webpack_require__(1075);
	exports.IdleTransaction = idletransaction_1.IdleTransaction;
	var hubextensions_2 = __webpack_require__(1074);
	exports.startIdleTransaction = hubextensions_2.startIdleTransaction;
	// We are patching the global object with our hub extension methods
	hubextensions_1.addExtensionMethods();
	var utils_1 = __webpack_require__(387);
	exports.extractTraceparentData = utils_1.extractTraceparentData;
	exports.getActiveTransaction = utils_1.getActiveTransaction;
	exports.hasTracingEnabled = utils_1.hasTracingEnabled;
	exports.stripUrlQueryAndFragment = utils_1.stripUrlQueryAndFragment;
	exports.TRACEPARENT_REGEXP = utils_1.TRACEPARENT_REGEXP;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var express_1 = __webpack_require__(2955);
	exports.Express = express_1.Express;
	var postgres_1 = __webpack_require__(2958);
	exports.Postgres = postgres_1.Postgres;
	var mysql_1 = __webpack_require__(2957);
	exports.Mysql = mysql_1.Mysql;
	var mongo_1 = __webpack_require__(2956);
	exports.Mongo = mongo_1.Mongo;
	// TODO(v7): Remove this export
	// Please see `src/index.ts` for more details.
	var browser_1 = __webpack_require__(1069);
	exports.BrowserTracing = browser_1.BrowserTracing;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	/**
	 * Express integration
	 *
	 * Provides an request and error handler for Express framework as well as tracing capabilities
	 */
	var Express = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Express(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Express.id;
	        this._router = options.router || options.app;
	        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
	    }
	    /**
	     * @inheritDoc
	     */
	    Express.prototype.setupOnce = function () {
	        if (!this._router) {
	            utils_1.logger.error('ExpressIntegration is missing an Express instance');
	            return;
	        }
	        instrumentMiddlewares(this._router, this._methods);
	    };
	    /**
	     * @inheritDoc
	     */
	    Express.id = 'Express';
	    return Express;
	}());
	exports.Express = Express;
	/**
	 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
	 * and finishes it once the middleware is done invoking.
	 *
	 * Express middlewares have 3 various forms, thus we have to take care of all of them:
	 * // sync
	 * app.use(function (req, res) { ... })
	 * // async
	 * app.use(function (req, res, next) { ... })
	 * // error handler
	 * app.use(function (err, req, res, next) { ... })
	 *
	 * They all internally delegate to the `router[method]` of the given application instance.
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
	function wrap(fn, method) {
	    var arity = fn.length;
	    switch (arity) {
	        case 2: {
	            return function (req, res) {
	                var transaction = res.__sentry_transaction;
	                if (transaction) {
	                    var span_1 = transaction.startChild({
	                        description: fn.name,
	                        op: "express.middleware." + method,
	                    });
	                    res.once('finish', function () {
	                        span_1.finish();
	                    });
	                }
	                return fn.call(this, req, res);
	            };
	        }
	        case 3: {
	            return function (req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "express.middleware." + method,
	                });
	                fn.call(this, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        case 4: {
	            return function (err, req, res, next) {
	                var _a;
	                var transaction = res.__sentry_transaction;
	                var span = (_a = transaction) === null || _a === void 0 ? void 0 : _a.startChild({
	                    description: fn.name,
	                    op: "express.middleware." + method,
	                });
	                fn.call(this, err, req, res, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var _a;
	                    (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                    next.call.apply(next, tslib_1.__spread([this], args));
	                });
	            };
	        }
	        default: {
	            throw new Error("Express middleware takes 2-4 arguments. Got: " + arity);
	        }
	    }
	}
	/**
	 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
	 * and wraps every function, as well as array of functions with a call to our `wrap` method.
	 * We have to take care of the arrays as well as iterate over all of the arguments,
	 * as `app.use` can accept middlewares in few various forms.
	 *
	 * app.use([<path>], <fn>)
	 * app.use([<path>], <fn>, ...<fn>)
	 * app.use([<path>], ...<fn>[])
	 */
	function wrapMiddlewareArgs(args, method) {
	    return args.map(function (arg) {
	        if (typeof arg === 'function') {
	            return wrap(arg, method);
	        }
	        if (Array.isArray(arg)) {
	            return arg.map(function (a) {
	                if (typeof a === 'function') {
	                    return wrap(a, method);
	                }
	                return a;
	            });
	        }
	        return arg;
	    });
	}
	/**
	 * Patches original router to utilize our tracing functionality
	 */
	function patchMiddleware(router, method) {
	    var originalCallback = router[method];
	    router[method] = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return originalCallback.call.apply(originalCallback, tslib_1.__spread([this], wrapMiddlewareArgs(args, method)));
	    };
	    return router;
	}
	/**
	 * Patches original router methods
	 */
	function instrumentMiddlewares(router, methods) {
	    if (methods === void 0) { methods = []; }
	    methods.forEach(function (method) { return patchMiddleware(router, method); });
	}
	//# sourceMappingURL=express.js.map

/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var utils_1 = __webpack_require__(65);
	var OPERATIONS = [
	    'aggregate',
	    'bulkWrite',
	    'countDocuments',
	    'createIndex',
	    'createIndexes',
	    'deleteMany',
	    'deleteOne',
	    'distinct',
	    'drop',
	    'dropIndex',
	    'dropIndexes',
	    'estimatedDocumentCount',
	    'find',
	    'findOne',
	    'findOneAndDelete',
	    'findOneAndReplace',
	    'findOneAndUpdate',
	    'indexes',
	    'indexExists',
	    'indexInformation',
	    'initializeOrderedBulkOp',
	    'insertMany',
	    'insertOne',
	    'isCapped',
	    'mapReduce',
	    'options',
	    'parallelCollectionScan',
	    'rename',
	    'replaceOne',
	    'stats',
	    'updateMany',
	    'updateOne',
	];
	// All of the operations above take `options` and `callback` as their final parameters, but some of them
	// take additional parameters as well. For those operations, this is a map of
	// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
	// positional arguments when we add them to the span's `data` object later
	var OPERATION_SIGNATURES = {
	    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
	    // see https://github.com/getsentry/sentry-javascript/pull/3102
	    bulkWrite: ['operations'],
	    countDocuments: ['query'],
	    createIndex: ['fieldOrSpec'],
	    createIndexes: ['indexSpecs'],
	    deleteMany: ['filter'],
	    deleteOne: ['filter'],
	    distinct: ['key', 'query'],
	    dropIndex: ['indexName'],
	    find: ['query'],
	    findOne: ['query'],
	    findOneAndDelete: ['filter'],
	    findOneAndReplace: ['filter', 'replacement'],
	    findOneAndUpdate: ['filter', 'update'],
	    indexExists: ['indexes'],
	    insertMany: ['docs'],
	    insertOne: ['doc'],
	    mapReduce: ['map', 'reduce'],
	    rename: ['newName'],
	    replaceOne: ['filter', 'doc'],
	    updateMany: ['filter', 'update'],
	    updateOne: ['filter', 'update'],
	};
	/** Tracing integration for mongo package */
	var Mongo = /** @class */ (function () {
	    /**
	     * @inheritDoc
	     */
	    function Mongo(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Mongo.id;
	        this._operations = Array.isArray(options.operations)
	            ? options.operations
	            : OPERATIONS;
	        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
	        this._useMongoose = !!options.useMongoose;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mongo.prototype.setupOnce = function (_, getCurrentHub) {
	        var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
	        var pkg = utils_1.loadModule(moduleName);
	        if (!pkg) {
	            utils_1.logger.error("Mongo Integration was unable to require `" + moduleName + "` package.");
	            return;
	        }
	        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
	    };
	    /**
	     * Patches original collection methods
	     */
	    Mongo.prototype._instrumentOperations = function (collection, operations, getCurrentHub) {
	        var _this = this;
	        operations.forEach(function (operation) { return _this._patchOperation(collection, operation, getCurrentHub); });
	    };
	    /**
	     * Patches original collection to utilize our tracing functionality
	     */
	    Mongo.prototype._patchOperation = function (collection, operation, getCurrentHub) {
	        if (!(operation in collection.prototype))
	            return;
	        var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
	        utils_1.fill(collection.prototype, operation, function (orig) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a, _b, _c, _d;
	                var lastArg = args[args.length - 1];
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                // Check if the operation was passed a callback. (mapReduce requires a different check, as
	                // its (non-callback) arguments can also be functions.)
	                if (typeof lastArg !== 'function' || (operation === 'mapReduce' && args.length === 2)) {
	                    var span_1 = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild(getSpanContext(this, operation, args));
	                    var maybePromise = orig.call.apply(orig, tslib_1.__spread([this], args));
	                    if (utils_1.isThenable(maybePromise)) {
	                        return maybePromise.then(function (res) {
	                            var _a;
	                            (_a = span_1) === null || _a === void 0 ? void 0 : _a.finish();
	                            return res;
	                        });
	                    }
	                    else {
	                        (_c = span_1) === null || _c === void 0 ? void 0 : _c.finish();
	                        return maybePromise;
	                    }
	                }
	                var span = (_d = parentSpan) === null || _d === void 0 ? void 0 : _d.startChild(getSpanContext(this, operation, args.slice(0, -1)));
	                return orig.call.apply(orig, tslib_1.__spread([this], args.slice(0, -1), [function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        lastArg(err, result);
	                    }]));
	            };
	        });
	    };
	    /**
	     * Form a SpanContext based on the user input to a given operation.
	     */
	    Mongo.prototype._getSpanContextFromOperationArguments = function (collection, operation, args) {
	        var data = {
	            collectionName: collection.collectionName,
	            dbName: collection.dbName,
	            namespace: collection.namespace,
	        };
	        var spanContext = {
	            op: "db",
	            description: operation,
	            data: data,
	        };
	        // If the operation takes no arguments besides `options` and `callback`, or if argument
	        // collection is disabled for this operation, just return early.
	        var signature = OPERATION_SIGNATURES[operation];
	        var shouldDescribe = Array.isArray(this._describeOperations)
	            ? this._describeOperations.includes(operation)
	            : this._describeOperations;
	        if (!signature || !shouldDescribe) {
	            return spanContext;
	        }
	        try {
	            // Special case for `mapReduce`, as the only one accepting functions as arguments.
	            if (operation === 'mapReduce') {
	                var _a = tslib_1.__read(args, 2), map = _a[0], reduce = _a[1];
	                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
	                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
	            }
	            else {
	                for (var i = 0; i < signature.length; i++) {
	                    data[signature[i]] = JSON.stringify(args[i]);
	                }
	            }
	        }
	        catch (_oO) {
	            // no-empty
	        }
	        return spanContext;
	    };
	    /**
	     * @inheritDoc
	     */
	    Mongo.id = 'Mongo';
	    return Mongo;
	}());
	exports.Mongo = Mongo;
	//# sourceMappingURL=mongo.js.map

/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	/** Tracing integration for node-mysql package */
	var Mysql = /** @class */ (function () {
	    function Mysql() {
	        /**
	         * @inheritDoc
	         */
	        this.name = Mysql.id;
	    }
	    /**
	     * @inheritDoc
	     */
	    Mysql.prototype.setupOnce = function (_, getCurrentHub) {
	        var pkg = utils_1.loadModule('mysql/lib/Connection.js');
	        if (!pkg) {
	            utils_1.logger.error('Mysql Integration was unable to require `mysql` package.');
	            return;
	        }
	        // The original function will have one of these signatures:
	        //    function (callback) => void
	        //    function (options, callback) => void
	        //    function (options, values, callback) => void
	        utils_1.fill(pkg, 'createQuery', function (orig) {
	            return function (options, values, callback) {
	                var _a, _b;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof options === 'string' ? options : options.sql,
	                    op: "db",
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, options, values, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result, fields);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, options, function (err, result, fields) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result, fields);
	                    });
	                }
	                return orig.call(this, options, values, callback);
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Mysql.id = 'Mysql';
	    return Mysql;
	}());
	exports.Mysql = Mysql;
	//# sourceMappingURL=mysql.js.map

/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(65);
	/** Tracing integration for node-postgres package */
	var Postgres = /** @class */ (function () {
	    function Postgres(options) {
	        if (options === void 0) { options = {}; }
	        /**
	         * @inheritDoc
	         */
	        this.name = Postgres.id;
	        this._usePgNative = !!options.usePgNative;
	    }
	    /**
	     * @inheritDoc
	     */
	    Postgres.prototype.setupOnce = function (_, getCurrentHub) {
	        var _a;
	        var pkg = utils_1.loadModule('pg');
	        if (!pkg) {
	            utils_1.logger.error('Postgres Integration was unable to require `pg` package.');
	            return;
	        }
	        if (this._usePgNative && !((_a = pkg.native) === null || _a === void 0 ? void 0 : _a.Client)) {
	            utils_1.logger.error("Postgres Integration was unable to access 'pg-native' bindings.");
	            return;
	        }
	        var Client = (this._usePgNative ? pkg.native : pkg).Client;
	        /**
	         * function (query, callback) => void
	         * function (query, params, callback) => void
	         * function (query) => Promise
	         * function (query, params) => Promise
	         * function (pg.Cursor) => pg.Cursor
	         */
	        utils_1.fill(Client.prototype, 'query', function (orig) {
	            return function (config, values, callback) {
	                var _a, _b, _c;
	                var scope = getCurrentHub().getScope();
	                var parentSpan = (_a = scope) === null || _a === void 0 ? void 0 : _a.getSpan();
	                var span = (_b = parentSpan) === null || _b === void 0 ? void 0 : _b.startChild({
	                    description: typeof config === 'string' ? config : config.text,
	                    op: "db",
	                });
	                if (typeof callback === 'function') {
	                    return orig.call(this, config, values, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        callback(err, result);
	                    });
	                }
	                if (typeof values === 'function') {
	                    return orig.call(this, config, function (err, result) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        values(err, result);
	                    });
	                }
	                var rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
	                if (utils_1.isThenable(rv)) {
	                    return rv.then(function (res) {
	                        var _a;
	                        (_a = span) === null || _a === void 0 ? void 0 : _a.finish();
	                        return res;
	                    });
	                }
	                (_c = span) === null || _c === void 0 ? void 0 : _c.finish();
	                return rv;
	            };
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    Postgres.id = 'Postgres';
	    return Postgres;
	}());
	exports.Postgres = Postgres;
	//# sourceMappingURL=postgres.js.map

/***/ }),
/* 2959 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** Console logging verbosity for the SDK. */
	var LogLevel;
	(function (LogLevel) {
	    /** No logs will be generated. */
	    LogLevel[LogLevel["None"] = 0] = "None";
	    /** Only SDK internal errors will be logged. */
	    LogLevel[LogLevel["Error"] = 1] = "Error";
	    /** Information useful for debugging the SDK will be logged. */
	    LogLevel[LogLevel["Debug"] = 2] = "Debug";
	    /** All SDK actions will be logged. */
	    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
	})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
	//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 2960 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Session Status
	 */
	var SessionStatus;
	(function (SessionStatus) {
	    /** JSDoc */
	    SessionStatus["Ok"] = "ok";
	    /** JSDoc */
	    SessionStatus["Exited"] = "exited";
	    /** JSDoc */
	    SessionStatus["Crashed"] = "crashed";
	    /** JSDoc */
	    SessionStatus["Abnormal"] = "abnormal";
	})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));
	var RequestSessionStatus;
	(function (RequestSessionStatus) {
	    /** JSDoc */
	    RequestSessionStatus["Ok"] = "ok";
	    /** JSDoc */
	    RequestSessionStatus["Errored"] = "errored";
	    /** JSDoc */
	    RequestSessionStatus["Crashed"] = "crashed";
	})(RequestSessionStatus = exports.RequestSessionStatus || (exports.RequestSessionStatus = {}));
	//# sourceMappingURL=session.js.map

/***/ }),
/* 2961 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	// eslint-disable-next-line import/export
	var Severity;
	(function (Severity) {
	    /** JSDoc */
	    Severity["Fatal"] = "fatal";
	    /** JSDoc */
	    Severity["Error"] = "error";
	    /** JSDoc */
	    Severity["Warning"] = "warning";
	    /** JSDoc */
	    Severity["Log"] = "log";
	    /** JSDoc */
	    Severity["Info"] = "info";
	    /** JSDoc */
	    Severity["Debug"] = "debug";
	    /** JSDoc */
	    Severity["Critical"] = "critical";
	})(Severity = exports.Severity || (exports.Severity = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Severity) {
	    /**
	     * Converts a string-based level into a {@link Severity}.
	     *
	     * @param level string representation of Severity
	     * @returns Severity
	     */
	    function fromString(level) {
	        switch (level) {
	            case 'debug':
	                return Severity.Debug;
	            case 'info':
	                return Severity.Info;
	            case 'warn':
	            case 'warning':
	                return Severity.Warning;
	            case 'error':
	                return Severity.Error;
	            case 'fatal':
	                return Severity.Fatal;
	            case 'critical':
	                return Severity.Critical;
	            case 'log':
	            default:
	                return Severity.Log;
	        }
	    }
	    Severity.fromString = fromString;
	})(Severity = exports.Severity || (exports.Severity = {}));
	//# sourceMappingURL=severity.js.map

/***/ }),
/* 2962 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/** The status of an event. */
	// eslint-disable-next-line import/export
	var Status;
	(function (Status) {
	    /** The status could not be determined. */
	    Status["Unknown"] = "unknown";
	    /** The event was skipped due to configuration or callbacks. */
	    Status["Skipped"] = "skipped";
	    /** The event was sent to Sentry successfully. */
	    Status["Success"] = "success";
	    /** The client is currently rate limited and will try again later. */
	    Status["RateLimit"] = "rate_limit";
	    /** The event could not be processed. */
	    Status["Invalid"] = "invalid";
	    /** A server-side error occurred during submission. */
	    Status["Failed"] = "failed";
	})(Status = exports.Status || (exports.Status = {}));
	// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
	(function (Status) {
	    /**
	     * Converts a HTTP status code into a {@link Status}.
	     *
	     * @param code The HTTP response status code.
	     * @returns The send status or {@link Status.Unknown}.
	     */
	    function fromHttpCode(code) {
	        if (code >= 200 && code < 300) {
	            return Status.Success;
	        }
	        if (code === 429) {
	            return Status.RateLimit;
	        }
	        if (code >= 400 && code < 500) {
	            return Status.Invalid;
	        }
	        if (code >= 500) {
	            return Status.Failed;
	        }
	        return Status.Unknown;
	    }
	    Status.fromHttpCode = fromHttpCode;
	})(Status = exports.Status || (exports.Status = {}));
	//# sourceMappingURL=status.js.map

/***/ }),
/* 2963 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var TransactionSamplingMethod;
	(function (TransactionSamplingMethod) {
	    TransactionSamplingMethod["Explicit"] = "explicitly_set";
	    TransactionSamplingMethod["Sampler"] = "client_sampler";
	    TransactionSamplingMethod["Rate"] = "client_rate";
	    TransactionSamplingMethod["Inheritance"] = "inheritance";
	})(TransactionSamplingMethod = exports.TransactionSamplingMethod || (exports.TransactionSamplingMethod = {}));
	//# sourceMappingURL=transaction.js.map

/***/ }),
/* 2964 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var Outcome;
	(function (Outcome) {
	    Outcome["BeforeSend"] = "before_send";
	    Outcome["EventProcessor"] = "event_processor";
	    Outcome["NetworkError"] = "network_error";
	    Outcome["QueueOverflow"] = "queue_overflow";
	    Outcome["RateLimitBackoff"] = "ratelimit_backoff";
	    Outcome["SampleRate"] = "sample_rate";
	})(Outcome = exports.Outcome || (exports.Outcome = {}));
	//# sourceMappingURL=transport.js.map

/***/ }),
/* 2965 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Consumes the promise and logs the error when it rejects.
	 * @param promise A promise to forget.
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	function forget(promise) {
	    void promise.then(null, function (e) {
	        // TODO: Use a better logging mechanism
	        // eslint-disable-next-line no-console
	        console.error(e);
	    });
	}
	exports.forget = forget;
	//# sourceMappingURL=async.js.map

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var error_1 = __webpack_require__(1078);
	/** Regular expression used to parse a Dsn. */
	var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
	/** Error message */
	var ERROR_MESSAGE = 'Invalid Dsn';
	/** The Sentry Dsn, identifying a Sentry instance and project. */
	var Dsn = /** @class */ (function () {
	    /** Creates a new Dsn component */
	    function Dsn(from) {
	        if (typeof from === 'string') {
	            this._fromString(from);
	        }
	        else {
	            this._fromComponents(from);
	        }
	        this._validate();
	    }
	    /**
	     * Renders the string representation of this Dsn.
	     *
	     * By default, this will render the public representation without the password
	     * component. To get the deprecated private representation, set `withPassword`
	     * to true.
	     *
	     * @param withPassword When set to true, the password will be included.
	     */
	    Dsn.prototype.toString = function (withPassword) {
	        if (withPassword === void 0) { withPassword = false; }
	        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, publicKey = _a.publicKey;
	        return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
	            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
	    };
	    /** Parses a string into this Dsn. */
	    Dsn.prototype._fromString = function (str) {
	        var match = DSN_REGEX.exec(str);
	        if (!match) {
	            throw new error_1.SentryError(ERROR_MESSAGE);
	        }
	        var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
	        var path = '';
	        var projectId = lastPath;
	        var split = projectId.split('/');
	        if (split.length > 1) {
	            path = split.slice(0, -1).join('/');
	            projectId = split.pop();
	        }
	        if (projectId) {
	            var projectMatch = projectId.match(/^\d+/);
	            if (projectMatch) {
	                projectId = projectMatch[0];
	            }
	        }
	        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
	    };
	    /** Maps Dsn components into this instance. */
	    Dsn.prototype._fromComponents = function (components) {
	        // TODO this is for backwards compatibility, and can be removed in a future version
	        if ('user' in components && !('publicKey' in components)) {
	            components.publicKey = components.user;
	        }
	        this.user = components.publicKey || '';
	        this.protocol = components.protocol;
	        this.publicKey = components.publicKey || '';
	        this.pass = components.pass || '';
	        this.host = components.host;
	        this.port = components.port || '';
	        this.path = components.path || '';
	        this.projectId = components.projectId;
	    };
	    /** Validates this Dsn and throws on error. */
	    Dsn.prototype._validate = function () {
	        var _this = this;
	        ['protocol', 'publicKey', 'host', 'projectId'].forEach(function (component) {
	            if (!_this[component]) {
	                throw new error_1.SentryError(ERROR_MESSAGE + ": " + component + " missing");
	            }
	        });
	        if (!this.projectId.match(/^\d+$/)) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
	        }
	        if (this.protocol !== 'http' && this.protocol !== 'https') {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
	        }
	        if (this.port && isNaN(parseInt(this.port, 10))) {
	            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
	        }
	    };
	    return Dsn;
	}());
	exports.Dsn = Dsn;
	//# sourceMappingURL=dsn.js.map

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var global_1 = __webpack_require__(388);
	var is_1 = __webpack_require__(487);
	var logger_1 = __webpack_require__(1079);
	var object_1 = __webpack_require__(1681);
	var stacktrace_1 = __webpack_require__(1081);
	var supports_1 = __webpack_require__(1682);
	var global = global_1.getGlobalObject();
	/**
	 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
	 *  - Console API
	 *  - Fetch API
	 *  - XHR API
	 *  - History API
	 *  - DOM API (click/typing)
	 *  - Error API
	 *  - UnhandledRejection API
	 */
	var handlers = {};
	var instrumented = {};
	/** Instruments given API */
	function instrument(type) {
	    if (instrumented[type]) {
	        return;
	    }
	    instrumented[type] = true;
	    switch (type) {
	        case 'console':
	            instrumentConsole();
	            break;
	        case 'dom':
	            instrumentDOM();
	            break;
	        case 'xhr':
	            instrumentXHR();
	            break;
	        case 'fetch':
	            instrumentFetch();
	            break;
	        case 'history':
	            instrumentHistory();
	            break;
	        case 'error':
	            instrumentError();
	            break;
	        case 'unhandledrejection':
	            instrumentUnhandledRejection();
	            break;
	        default:
	            logger_1.logger.warn('unknown instrumentation type:', type);
	    }
	}
	/**
	 * Add handler that will be called when given type of instrumentation triggers.
	 * Use at your own risk, this might break without changelog notice, only used internally.
	 * @hidden
	 */
	function addInstrumentationHandler(handler) {
	    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
	        return;
	    }
	    handlers[handler.type] = handlers[handler.type] || [];
	    handlers[handler.type].push(handler.callback);
	    instrument(handler.type);
	}
	exports.addInstrumentationHandler = addInstrumentationHandler;
	/** JSDoc */
	function triggerHandlers(type, data) {
	    var e_1, _a;
	    if (!type || !handlers[type]) {
	        return;
	    }
	    try {
	        for (var _b = tslib_1.__values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var handler = _c.value;
	            try {
	                handler(data);
	            }
	            catch (e) {
	                logger_1.logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + stacktrace_1.getFunctionName(handler) + "\nError: " + e);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	/** JSDoc */
	function instrumentConsole() {
	    if (!('console' in global)) {
	        return;
	    }
	    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
	        if (!(level in global.console)) {
	            return;
	        }
	        object_1.fill(global.console, level, function (originalConsoleLevel) {
	            return function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                triggerHandlers('console', { args: args, level: level });
	                // this fails for some browsers. :(
	                if (originalConsoleLevel) {
	                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
	                }
	            };
	        });
	    });
	}
	/** JSDoc */
	function instrumentFetch() {
	    if (!supports_1.supportsNativeFetch()) {
	        return;
	    }
	    object_1.fill(global, 'fetch', function (originalFetch) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var handlerData = {
	                args: args,
	                fetchData: {
	                    method: getFetchMethod(args),
	                    url: getFetchUrl(args),
	                },
	                startTimestamp: Date.now(),
	            };
	            triggerHandlers('fetch', tslib_1.__assign({}, handlerData));
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            return originalFetch.apply(global, args).then(function (response) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
	                return response;
	            }, function (error) {
	                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
	                //       it means the sentry.javascript SDK caught an error invoking your application code.
	                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
	                throw error;
	            });
	        };
	    });
	}
	/* eslint-disable @typescript-eslint/no-unsafe-member-access */
	/** Extract `method` from fetch call arguments */
	function getFetchMethod(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
	        return String(fetchArgs[0].method).toUpperCase();
	    }
	    if (fetchArgs[1] && fetchArgs[1].method) {
	        return String(fetchArgs[1].method).toUpperCase();
	    }
	    return 'GET';
	}
	/** Extract `url` from fetch call arguments */
	function getFetchUrl(fetchArgs) {
	    if (fetchArgs === void 0) { fetchArgs = []; }
	    if (typeof fetchArgs[0] === 'string') {
	        return fetchArgs[0];
	    }
	    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request)) {
	        return fetchArgs[0].url;
	    }
	    return String(fetchArgs[0]);
	}
	/* eslint-enable @typescript-eslint/no-unsafe-member-access */
	/** JSDoc */
	function instrumentXHR() {
	    if (!('XMLHttpRequest' in global)) {
	        return;
	    }
	    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
	    var requestKeys = [];
	    var requestValues = [];
	    var xhrproto = XMLHttpRequest.prototype;
	    object_1.fill(xhrproto, 'open', function (originalOpen) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            // eslint-disable-next-line @typescript-eslint/no-this-alias
	            var xhr = this;
	            var url = args[1];
	            xhr.__sentry_xhr__ = {
	                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	                method: is_1.isString(args[0]) ? args[0].toUpperCase() : args[0],
	                url: args[1],
	            };
	            // if Sentry key appears in URL, don't capture it as a request
	            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	            if (is_1.isString(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
	                xhr.__sentry_own_request__ = true;
	            }
	            var onreadystatechangeHandler = function () {
	                if (xhr.readyState === 4) {
	                    try {
	                        // touching statusCode in some platforms throws
	                        // an exception
	                        if (xhr.__sentry_xhr__) {
	                            xhr.__sentry_xhr__.status_code = xhr.status;
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    try {
	                        var requestPos = requestKeys.indexOf(xhr);
	                        if (requestPos !== -1) {
	                            // Make sure to pop both key and value to keep it in sync.
	                            requestKeys.splice(requestPos);
	                            var args_1 = requestValues.splice(requestPos)[0];
	                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
	                                xhr.__sentry_xhr__.body = args_1[0];
	                            }
	                        }
	                    }
	                    catch (e) {
	                        /* do nothing */
	                    }
	                    triggerHandlers('xhr', {
	                        args: args,
	                        endTimestamp: Date.now(),
	                        startTimestamp: Date.now(),
	                        xhr: xhr,
	                    });
	                }
	            };
	            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
	                object_1.fill(xhr, 'onreadystatechange', function (original) {
	                    return function () {
	                        var readyStateArgs = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            readyStateArgs[_i] = arguments[_i];
	                        }
	                        onreadystatechangeHandler();
	                        return original.apply(xhr, readyStateArgs);
	                    };
	                });
	            }
	            else {
	                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
	            }
	            return originalOpen.apply(xhr, args);
	        };
	    });
	    object_1.fill(xhrproto, 'send', function (originalSend) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            requestKeys.push(this);
	            requestValues.push(args);
	            triggerHandlers('xhr', {
	                args: args,
	                startTimestamp: Date.now(),
	                xhr: this,
	            });
	            return originalSend.apply(this, args);
	        };
	    });
	}
	var lastHref;
	/** JSDoc */
	function instrumentHistory() {
	    if (!supports_1.supportsHistory()) {
	        return;
	    }
	    var oldOnPopState = global.onpopstate;
	    global.onpopstate = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var to = global.location.href;
	        // keep track of the current URL state, as we always receive only the updated state
	        var from = lastHref;
	        lastHref = to;
	        triggerHandlers('history', {
	            from: from,
	            to: to,
	        });
	        if (oldOnPopState) {
	            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
	            // https://github.com/getsentry/sentry-javascript/issues/3344
	            // https://github.com/bugsnag/bugsnag-js/issues/469
	            try {
	                return oldOnPopState.apply(this, args);
	            }
	            catch (_oO) {
	                // no-empty
	            }
	        }
	    };
	    /** @hidden */
	    function historyReplacementFunction(originalHistoryFunction) {
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var url = args.length > 2 ? args[2] : undefined;
	            if (url) {
	                // coerce to string (this is what pushState does)
	                var from = lastHref;
	                var to = String(url);
	                // keep track of the current URL state, as we always receive only the updated state
	                lastHref = to;
	                triggerHandlers('history', {
	                    from: from,
	                    to: to,
	                });
	            }
	            return originalHistoryFunction.apply(this, args);
	        };
	    }
	    object_1.fill(global.history, 'pushState', historyReplacementFunction);
	    object_1.fill(global.history, 'replaceState', historyReplacementFunction);
	}
	var debounceDuration = 1000;
	var debounceTimerID;
	var lastCapturedEvent;
	/**
	 * Decide whether the current event should finish the debounce of previously captured one.
	 * @param previous previously captured event
	 * @param current event to be captured
	 */
	function shouldShortcircuitPreviousDebounce(previous, current) {
	    // If there was no previous event, it should always be swapped for the new one.
	    if (!previous) {
	        return true;
	    }
	    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
	    if (previous.type !== current.type) {
	        return true;
	    }
	    try {
	        // If both events have the same type, it's still possible that actions were performed on different targets.
	        // e.g. 2 clicks on different buttons.
	        if (previous.target !== current.target) {
	            return true;
	        }
	    }
	    catch (e) {
	        // just accessing `target` property can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/sentry-javascript/issues/838
	    }
	    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
	    // to which an event listener was attached), we treat them as the same action, as we want to capture
	    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
	    return false;
	}
	/**
	 * Decide whether an event should be captured.
	 * @param event event to be captured
	 */
	function shouldSkipDOMEvent(event) {
	    // We are only interested in filtering `keypress` events for now.
	    if (event.type !== 'keypress') {
	        return false;
	    }
	    try {
	        var target = event.target;
	        if (!target || !target.tagName) {
	            return true;
	        }
	        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
	        // e.g.tabbing through elements, hotkeys, etc.
	        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
	            return false;
	        }
	    }
	    catch (e) {
	        // just accessing `target` property can throw an exception in some rare circumstances
	        // see: https://github.com/getsentry/sentry-javascript/issues/838
	    }
	    return true;
	}
	/**
	 * Wraps addEventListener to capture UI breadcrumbs
	 * @param handler function that will be triggered
	 * @param globalListener indicates whether event was captured by the global event listener
	 * @returns wrapped breadcrumb events handler
	 * @hidden
	 */
	function makeDOMEventHandler(handler, globalListener) {
	    if (globalListener === void 0) { globalListener = false; }
	    return function (event) {
	        // It's possible this handler might trigger multiple times for the same
	        // event (e.g. event propagation through node ancestors).
	        // Ignore if we've already captured that event.
	        if (!event || lastCapturedEvent === event) {
	            return;
	        }
	        // We always want to skip _some_ events.
	        if (shouldSkipDOMEvent(event)) {
	            return;
	        }
	        var name = event.type === 'keypress' ? 'input' : event.type;
	        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
	        if (debounceTimerID === undefined) {
	            handler({
	                event: event,
	                name: name,
	                global: globalListener,
	            });
	            lastCapturedEvent = event;
	        }
	        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
	        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
	        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
	            handler({
	                event: event,
	                name: name,
	                global: globalListener,
	            });
	            lastCapturedEvent = event;
	        }
	        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
	        clearTimeout(debounceTimerID);
	        debounceTimerID = global.setTimeout(function () {
	            debounceTimerID = undefined;
	        }, debounceDuration);
	    };
	}
	/** JSDoc */
	function instrumentDOM() {
	    if (!('document' in global)) {
	        return;
	    }
	    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
	    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
	    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
	    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
	    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
	    global.document.addEventListener('click', globalDOMEventHandler, false);
	    global.document.addEventListener('keypress', globalDOMEventHandler, false);
	    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
	    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
	    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
	    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
	    // guaranteed to fire at least once.)
	    ['EventTarget', 'Node'].forEach(function (target) {
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	        var proto = global[target] && global[target].prototype;
	        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
	        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
	            return;
	        }
	        object_1.fill(proto, 'addEventListener', function (originalAddEventListener) {
	            return function (type, listener, options) {
	                if (type === 'click' || type == 'keypress') {
	                    try {
	                        var el = this;
	                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
	                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
	                        if (!handlerForType.handler) {
	                            var handler = makeDOMEventHandler(triggerDOMHandler);
	                            handlerForType.handler = handler;
	                            originalAddEventListener.call(this, type, handler, options);
	                        }
	                        handlerForType.refCount += 1;
	                    }
	                    catch (e) {
	                        // Accessing dom properties is always fragile.
	                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
	                    }
	                }
	                return originalAddEventListener.call(this, type, listener, options);
	            };
	        });
	        object_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
	            return function (type, listener, options) {
	                if (type === 'click' || type == 'keypress') {
	                    try {
	                        var el = this;
	                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
	                        var handlerForType = handlers_2[type];
	                        if (handlerForType) {
	                            handlerForType.refCount -= 1;
	                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
	                            if (handlerForType.refCount <= 0) {
	                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
	                                handlerForType.handler = undefined;
	                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
	                            }
	                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
	                            if (Object.keys(handlers_2).length === 0) {
	                                delete el.__sentry_instrumentation_handlers__;
	                            }
	                        }
	                    }
	                    catch (e) {
	                        // Accessing dom properties is always fragile.
	                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
	                    }
	                }
	                return originalRemoveEventListener.call(this, type, listener, options);
	            };
	        });
	    });
	}
	var _oldOnErrorHandler = null;
	/** JSDoc */
	function instrumentError() {
	    _oldOnErrorHandler = global.onerror;
	    global.onerror = function (msg, url, line, column, error) {
	        triggerHandlers('error', {
	            column: column,
	            error: error,
	            line: line,
	            msg: msg,
	            url: url,
	        });
	        if (_oldOnErrorHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnErrorHandler.apply(this, arguments);
	        }
	        return false;
	    };
	}
	var _oldOnUnhandledRejectionHandler = null;
	/** JSDoc */
	function instrumentUnhandledRejection() {
	    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
	    global.onunhandledrejection = function (e) {
	        triggerHandlers('unhandledrejection', e);
	        if (_oldOnUnhandledRejectionHandler) {
	            // eslint-disable-next-line prefer-rest-params
	            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
	        }
	        return true;
	    };
	}
	//# sourceMappingURL=instrument.js.map

/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(72);
	var global_1 = __webpack_require__(388);
	var string_1 = __webpack_require__(1082);
	/**
	 * UUID4 generator
	 *
	 * @returns string Generated UUID4.
	 */
	function uuid4() {
	    var global = global_1.getGlobalObject();
	    var crypto = global.crypto || global.msCrypto;
	    if (!(crypto === void 0) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	        // set 4 in byte 7
	        // eslint-disable-next-line no-bitwise
	        arr[3] = (arr[3] & 0xfff) | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        // eslint-disable-next-line no-bitwise
	        arr[4] = (arr[4] & 0x3fff) | 0x8000;
	        var pad = function (num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = "0" + v;
	            }
	            return v;
	        };
	        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
	    }
	    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        // eslint-disable-next-line no-bitwise
	        var r = (Math.random() * 16) | 0;
	        // eslint-disable-next-line no-bitwise
	        var v = c === 'x' ? r : (r & 0x3) | 0x8;
	        return v.toString(16);
	    });
	}
	exports.uuid4 = uuid4;
	/**
	 * Parses string form of URL into an object
	 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	 * // intentionally using regex and not <a/> href parsing trick because React Native and other
	 * // environments where DOM might not be available
	 * @returns parsed URL object
	 */
	function parseUrl(url) {
	    if (!url) {
	        return {};
	    }
	    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) {
	        return {};
	    }
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        host: match[4],
	        path: match[5],
	        protocol: match[2],
	        relative: match[5] + query + fragment,
	    };
	}
	exports.parseUrl = parseUrl;
	/**
	 * Extracts either message or type+value from an event that can be used for user-facing logs
	 * @returns event's description
	 */
	function getEventDescription(event) {
	    if (event.message) {
	        return event.message;
	    }
	    if (event.exception && event.exception.values && event.exception.values[0]) {
	        var exception = event.exception.values[0];
	        if (exception.type && exception.value) {
	            return exception.type + ": " + exception.value;
	        }
	        return exception.type || exception.value || event.event_id || '<unknown>';
	    }
	    return event.event_id || '<unknown>';
	}
	exports.getEventDescription = getEventDescription;
	/**
	 * Adds exception values, type and value to an synthetic Exception.
	 * @param event The event to modify.
	 * @param value Value of the exception.
	 * @param type Type of the exception.
	 * @hidden
	 */
	function addExceptionTypeValue(event, value, type) {
	    event.exception = event.exception || {};
	    event.exception.values = event.exception.values || [];
	    event.exception.values[0] = event.exception.values[0] || {};
	    event.exception.values[0].value = event.exception.values[0].value || value || '';
	    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
	}
	exports.addExceptionTypeValue = addExceptionTypeValue;
	/**
	 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
	 *
	 * @param event The event to modify.
	 * @param newMechanism Mechanism data to add to the event.
	 * @hidden
	 */
	function addExceptionMechanism(event, newMechanism) {
	    var _a;
	    if (!event.exception || !event.exception.values) {
	        return;
	    }
	    var exceptionValue0 = event.exception.values[0];
	    var defaultMechanism = { type: 'generic', handled: true };
	    var currentMechanism = exceptionValue0.mechanism;
	    exceptionValue0.mechanism = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, defaultMechanism), currentMechanism), newMechanism);
	    if (newMechanism && 'data' in newMechanism) {
	        var mergedData = tslib_1.__assign(tslib_1.__assign({}, (_a = currentMechanism) === null || _a === void 0 ? void 0 : _a.data), newMechanism.data);
	        exceptionValue0.mechanism.data = mergedData;
	    }
	}
	exports.addExceptionMechanism = addExceptionMechanism;
	// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
	var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
	/**
	 * Parses input into a SemVer interface
	 * @param input string representation of a semver version
	 */
	function parseSemver(input) {
	    var match = input.match(SEMVER_REGEXP) || [];
	    var major = parseInt(match[1], 10);
	    var minor = parseInt(match[2], 10);
	    var patch = parseInt(match[3], 10);
	    return {
	        buildmetadata: match[5],
	        major: isNaN(major) ? undefined : major,
	        minor: isNaN(minor) ? undefined : minor,
	        patch: isNaN(patch) ? undefined : patch,
	        prerelease: match[4],
	    };
	}
	exports.parseSemver = parseSemver;
	var defaultRetryAfter = 60 * 1000; // 60 seconds
	/**
	 * Extracts Retry-After value from the request header or returns default value
	 * @param now current unix timestamp
	 * @param header string representation of 'Retry-After' header
	 */
	function parseRetryAfterHeader(now, header) {
	    if (!header) {
	        return defaultRetryAfter;
	    }
	    var headerDelay = parseInt("" + header, 10);
	    if (!isNaN(headerDelay)) {
	        return headerDelay * 1000;
	    }
	    var headerDate = Date.parse("" + header);
	    if (!isNaN(headerDate)) {
	        return headerDate - now;
	    }
	    return defaultRetryAfter;
	}
	exports.parseRetryAfterHeader = parseRetryAfterHeader;
	/**
	 * This function adds context (pre/post/line) lines to the provided frame
	 *
	 * @param lines string[] containing all lines
	 * @param frame StackFrame that will be mutated
	 * @param linesOfContext number of context lines we want to add pre/post
	 */
	function addContextToFrame(lines, frame, linesOfContext) {
	    if (linesOfContext === void 0) { linesOfContext = 5; }
	    var lineno = frame.lineno || 0;
	    var maxLines = lines.length;
	    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
	    frame.pre_context = lines
	        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	    frame.context_line = string_1.snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
	    frame.post_context = lines
	        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
	        .map(function (line) { return string_1.snipLine(line, 0); });
	}
	exports.addContextToFrame = addContextToFrame;
	/**
	 * Strip the query string and fragment off of a given URL or path (if present)
	 *
	 * @param urlPath Full URL or path, including possible query string and/or fragment
	 * @returns URL or path without query string or fragment
	 */
	function stripUrlQueryAndFragment(urlPath) {
	    // eslint-disable-next-line no-useless-escape
	    return urlPath.split(/[\?#]/, 1)[0];
	}
	exports.stripUrlQueryAndFragment = stripUrlQueryAndFragment;
	/**
	 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
	 * in question), and marks it captured if not.
	 *
	 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
	 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
	 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
	 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
	 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
	 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
	 * see it.
	 *
	 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
	 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
	 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
	 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
	 * must be done before the exception captured.
	 *
	 * @param A thrown exception to check or flag as having been seen
	 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
	 */
	function checkOrSetAlreadyCaught(exception) {
	    var _a;
	    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	    if ((_a = exception) === null || _a === void 0 ? void 0 : _a.__sentry_captured__) {
	        return true;
	    }
	    try {
	        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
	        // `ExtraErrorData` integration
	        Object.defineProperty(exception, '__sentry_captured__', {
	            value: true,
	        });
	    }
	    catch (err) {
	        // `exception` is a primitive, so we can't mark it seen
	    }
	    return false;
	}
	exports.checkOrSetAlreadyCaught = checkOrSetAlreadyCaught;
	//# sourceMappingURL=misc.js.map

/***/ }),
/* 2969 */
/***/ (function(module, exports) {

	// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
	// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
	Object.defineProperty(exports, "__esModule", { value: true });
	/** JSDoc */
	function normalizeArray(parts, allowAboveRoot) {
	    // if the path tries to go above the root, `up` ends up > 0
	    var up = 0;
	    for (var i = parts.length - 1; i >= 0; i--) {
	        var last = parts[i];
	        if (last === '.') {
	            parts.splice(i, 1);
	        }
	        else if (last === '..') {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up++;
	        }
	        else if (up) {
	            parts.splice(i, 1);
	            // eslint-disable-next-line no-plusplus
	            up--;
	        }
	    }
	    // if the path is allowed to go above the root, restore leading ..s
	    if (allowAboveRoot) {
	        // eslint-disable-next-line no-plusplus
	        for (; up--; up) {
	            parts.unshift('..');
	        }
	    }
	    return parts;
	}
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
	/** JSDoc */
	function splitPath(filename) {
	    var parts = splitPathRe.exec(filename);
	    return parts ? parts.slice(1) : [];
	}
	// path.resolve([from ...], to)
	// posix version
	/** JSDoc */
	function resolve() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var resolvedPath = '';
	    var resolvedAbsolute = false;
	    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	        var path = i >= 0 ? args[i] : '/';
	        // Skip empty entries
	        if (!path) {
	            continue;
	        }
	        resolvedPath = path + "/" + resolvedPath;
	        resolvedAbsolute = path.charAt(0) === '/';
	    }
	    // At this point the path should be resolved to a full absolute path, but
	    // handle relative paths to be safe (might happen when process.cwd() fails)
	    // Normalize the path
	    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
	    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
	}
	exports.resolve = resolve;
	/** JSDoc */
	function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	        if (arr[start] !== '') {
	            break;
	        }
	    }
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	        if (arr[end] !== '') {
	            break;
	        }
	    }
	    if (start > end) {
	        return [];
	    }
	    return arr.slice(start, end - start + 1);
	}
	// path.relative(from, to)
	// posix version
	/** JSDoc */
	function relative(from, to) {
	    /* eslint-disable no-param-reassign */
	    from = resolve(from).substr(1);
	    to = resolve(to).substr(1);
	    /* eslint-enable no-param-reassign */
	    var fromParts = trim(from.split('/'));
	    var toParts = trim(to.split('/'));
	    var length = Math.min(fromParts.length, toParts.length);
	    var samePartsLength = length;
	    for (var i = 0; i < length; i++) {
	        if (fromParts[i] !== toParts[i]) {
	            samePartsLength = i;
	            break;
	        }
	    }
	    var outputParts = [];
	    for (var i = samePartsLength; i < fromParts.length; i++) {
	        outputParts.push('..');
	    }
	    outputParts = outputParts.concat(toParts.slice(samePartsLength));
	    return outputParts.join('/');
	}
	exports.relative = relative;
	// path.normalize(path)
	// posix version
	/** JSDoc */
	function normalizePath(path) {
	    var isPathAbsolute = isAbsolute(path);
	    var trailingSlash = path.substr(-1) === '/';
	    // Normalize the path
	    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
	    if (!normalizedPath && !isPathAbsolute) {
	        normalizedPath = '.';
	    }
	    if (normalizedPath && trailingSlash) {
	        normalizedPath += '/';
	    }
	    return (isPathAbsolute ? '/' : '') + normalizedPath;
	}
	exports.normalizePath = normalizePath;
	// posix version
	/** JSDoc */
	function isAbsolute(path) {
	    return path.charAt(0) === '/';
	}
	exports.isAbsolute = isAbsolute;
	// posix version
	/** JSDoc */
	function join() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return normalizePath(args.join('/'));
	}
	exports.join = join;
	/** JSDoc */
	function dirname(path) {
	    var result = splitPath(path);
	    var root = result[0];
	    var dir = result[1];
	    if (!root && !dir) {
	        // No dirname whatsoever
	        return '.';
	    }
	    if (dir) {
	        // It has a dirname, strip trailing slash
	        dir = dir.substr(0, dir.length - 1);
	    }
	    return root + dir;
	}
	exports.dirname = dirname;
	/** JSDoc */
	function basename(path, ext) {
	    var f = splitPath(path)[2];
	    if (ext && f.substr(ext.length * -1) === ext) {
	        f = f.substr(0, f.length - ext.length);
	    }
	    return f;
	}
	exports.basename = basename;
	//# sourceMappingURL=path.js.map

/***/ }),
/* 2970 */
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", { value: true });
	exports.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
	/**
	 * setPrototypeOf polyfill using __proto__
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function setProtoOf(obj, proto) {
	    // @ts-ignore __proto__ does not exist on obj
	    obj.__proto__ = proto;
	    return obj;
	}
	/**
	 * setPrototypeOf polyfill using mixin
	 */
	// eslint-disable-next-line @typescript-eslint/ban-types
	function mixinProperties(obj, proto) {
	    for (var prop in proto) {
	        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
	            // @ts-ignore typescript complains about indexing so we remove
	            obj[prop] = proto[prop];
	        }
	    }
	    return obj;
	}
	//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(1078);
	var syncpromise_1 = __webpack_require__(1683);
	/** A simple queue that holds promises. */
	var PromiseBuffer = /** @class */ (function () {
	    function PromiseBuffer(_limit) {
	        this._limit = _limit;
	        /** Internal set of queued Promises */
	        this._buffer = [];
	    }
	    /**
	     * Says if the buffer is ready to take more requests
	     */
	    PromiseBuffer.prototype.isReady = function () {
	        return this._limit === undefined || this.length() < this._limit;
	    };
	    /**
	     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
	     *
	     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
	     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
	     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
	     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
	     *        limit check.
	     * @returns The original promise.
	     */
	    PromiseBuffer.prototype.add = function (taskProducer) {
	        var _this = this;
	        if (!this.isReady()) {
	            return syncpromise_1.SyncPromise.reject(new error_1.SentryError('Not adding Promise due to buffer limit reached.'));
	        }
	        // start the task and add its promise to the queue
	        var task = taskProducer();
	        if (this._buffer.indexOf(task) === -1) {
	            this._buffer.push(task);
	        }
	        void task
	            .then(function () { return _this.remove(task); })
	            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
	            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
	            // have promises, so TS has to polyfill when down-compiling.)
	            .then(null, function () {
	            return _this.remove(task).then(null, function () {
	                // We have to add another catch here because `this.remove()` starts a new promise chain.
	            });
	        });
	        return task;
	    };
	    /**
	     * Remove a promise from the queue.
	     *
	     * @param task Can be any PromiseLike<T>
	     * @returns Removed promise.
	     */
	    PromiseBuffer.prototype.remove = function (task) {
	        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
	        return removedTask;
	    };
	    /**
	     * This function returns the number of unresolved promises in the queue.
	     */
	    PromiseBuffer.prototype.length = function () {
	        return this._buffer.length;
	    };
	    /**
	     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
	     *
	     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
	     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
	     * `true`.
	     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
	     * `false` otherwise
	     */
	    PromiseBuffer.prototype.drain = function (timeout) {
	        var _this = this;
	        return new syncpromise_1.SyncPromise(function (resolve) {
	            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
	            var capturedSetTimeout = setTimeout(function () {
	                if (timeout && timeout > 0) {
	                    resolve(false);
	                }
	            }, timeout);
	            // if all promises resolve in time, cancel the timer and resolve to `true`
	            void syncpromise_1.SyncPromise.all(_this._buffer)
	                .then(function () {
	                clearTimeout(capturedSetTimeout);
	                resolve(true);
	            })
	                .then(null, function () {
	                resolve(true);
	            });
	        });
	    };
	    return PromiseBuffer;
	}());
	exports.PromiseBuffer = PromiseBuffer;
	//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {Object.defineProperty(exports, "__esModule", { value: true });
	var global_1 = __webpack_require__(388);
	var node_1 = __webpack_require__(1080);
	/**
	 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
	 *
	 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
	 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
	 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
	 */
	var dateTimestampSource = {
	    nowSeconds: function () { return Date.now() / 1000; },
	};
	/**
	 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
	 * support the API.
	 *
	 * Wrapping the native API works around differences in behavior from different browsers.
	 */
	function getBrowserPerformance() {
	    var performance = global_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        return undefined;
	    }
	    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
	    //
	    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
	    // performance.now() gives a date arbitrarily in the past.
	    //
	    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
	    // undefined.
	    //
	    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
	    // interact with data coming out of performance entries.
	    //
	    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
	    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
	    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
	    // observed skews that can be as long as days, weeks or months.
	    //
	    // See https://github.com/getsentry/sentry-javascript/issues/2590.
	    //
	    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
	    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
	    // transactions of long-lived web pages.
	    var timeOrigin = Date.now() - performance.now();
	    return {
	        now: function () { return performance.now(); },
	        timeOrigin: timeOrigin,
	    };
	}
	/**
	 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
	 * implement the API.
	 */
	function getNodePerformance() {
	    try {
	        var perfHooks = node_1.dynamicRequire(module, 'perf_hooks');
	        return perfHooks.performance;
	    }
	    catch (_) {
	        return undefined;
	    }
	}
	/**
	 * The Performance API implementation for the current platform, if available.
	 */
	var platformPerformance = node_1.isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
	var timestampSource = platformPerformance === undefined
	    ? dateTimestampSource
	    : {
	        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
	    };
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
	 */
	exports.dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
	/**
	 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
	 * availability of the Performance API.
	 *
	 * See `usingPerformanceAPI` to test whether the Performance API is used.
	 *
	 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
	 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
	 * skew can grow to arbitrary amounts like days, weeks or months.
	 * See https://github.com/getsentry/sentry-javascript/issues/2590.
	 */
	exports.timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
	// Re-exported with an old name for backwards-compatibility.
	exports.timestampWithMs = exports.timestampInSeconds;
	/**
	 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
	 */
	exports.usingPerformanceAPI = platformPerformance !== undefined;
	/**
	 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
	 * performance API is available.
	 */
	exports.browserPerformanceTimeOrigin = (function () {
	    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
	    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
	    // data as reliable if they are within a reasonable threshold of the current time.
	    var performance = global_1.getGlobalObject().performance;
	    if (!performance || !performance.now) {
	        exports._browserPerformanceTimeOriginMode = 'none';
	        return undefined;
	    }
	    var threshold = 3600 * 1000;
	    var performanceNow = performance.now();
	    var dateNow = Date.now();
	    // if timeOrigin isn't available set delta to threshold so it isn't used
	    var timeOriginDelta = performance.timeOrigin
	        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
	        : threshold;
	    var timeOriginIsReliable = timeOriginDelta < threshold;
	    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
	    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
	    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
	    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
	    // Date API.
	    // eslint-disable-next-line deprecation/deprecation
	    var navigationStart = performance.timing && performance.timing.navigationStart;
	    var hasNavigationStart = typeof navigationStart === 'number';
	    // if navigationStart isn't available set delta to threshold so it isn't used
	    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
	    var navigationStartIsReliable = navigationStartDelta < threshold;
	    if (timeOriginIsReliable || navigationStartIsReliable) {
	        // Use the more reliable time origin
	        if (timeOriginDelta <= navigationStartDelta) {
	            exports._browserPerformanceTimeOriginMode = 'timeOrigin';
	            return performance.timeOrigin;
	        }
	        else {
	            exports._browserPerformanceTimeOriginMode = 'navigationStart';
	            return navigationStart;
	        }
	    }
	    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
	    exports._browserPerformanceTimeOriginMode = 'dateNow';
	    return dateNow;
	})();
	//# sourceMappingURL=time.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)(module)))

/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _inlineStylePrefixerStatic = __webpack_require__(5341);
	
	var _inlineStylePrefixerStatic2 = _interopRequireDefault(_inlineStylePrefixerStatic);
	
	var _util = __webpack_require__(1083);
	
	/**
	 * Generate CSS for a selector and some styles.
	 *
	 * This function handles the media queries, pseudo selectors, and descendant
	 * styles that can be used in aphrodite styles.
	 *
	 * @param {string} selector: A base CSS selector for the styles to be generated
	 *     with.
	 * @param {Object} styleTypes: A list of properties of the return type of
	 *     StyleSheet.create, e.g. [styles.red, styles.blue].
	 * @param stringHandlers: See `generateCSSRuleset`
	 * @param useImportant: See `generateCSSRuleset`
	 *
	 * To actually generate the CSS special-construct-less styles are passed to
	 * `generateCSSRuleset`.
	 *
	 * For instance, a call to
	 *
	 *     generateCSSInner(".foo", {
	 *       color: "red",
	 *       "@media screen": {
	 *         height: 20,
	 *         ":hover": {
	 *           backgroundColor: "black"
	 *         }
	 *       },
	 *       ":active": {
	 *         fontWeight: "bold",
	 *         ">>bar": {
	 *           _names: { "foo_bar": true },
	 *           height: 10,
	 *         }
	 *       }
	 *     });
	 *
	 * will make 5 calls to `generateCSSRuleset`:
	 *
	 *     generateCSSRuleset(".foo", { color: "red" }, ...)
	 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
	 *     generateCSSRuleset(".foo:active .foo_bar", { height: 10 }, ...)
	 *     // These 2 will be wrapped in @media screen {}
	 *     generateCSSRuleset(".foo", { height: 20 }, ...)
	 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
	 */
	var generateCSS = function generateCSS(selector, styleTypes, stringHandlers, useImportant) {
	    var merged = styleTypes.reduce(_util.recursiveMerge);
	
	    var declarations = {};
	    var mediaQueries = {};
	    var pseudoStyles = {};
	
	    Object.keys(merged).forEach(function (key) {
	        if (key[0] === ':') {
	            pseudoStyles[key] = merged[key];
	        } else if (key[0] === '@') {
	            mediaQueries[key] = merged[key];
	        } else {
	            declarations[key] = merged[key];
	        }
	    });
	
	    return generateCSSRuleset(selector, declarations, stringHandlers, useImportant) + Object.keys(pseudoStyles).map(function (pseudoSelector) {
	        return generateCSSRuleset(selector + pseudoSelector, pseudoStyles[pseudoSelector], stringHandlers, useImportant);
	    }).join("") + Object.keys(mediaQueries).map(function (mediaQuery) {
	        var ruleset = generateCSS(selector, [mediaQueries[mediaQuery]], stringHandlers, useImportant);
	        return mediaQuery + '{' + ruleset + '}';
	    }).join("");
	};
	
	exports.generateCSS = generateCSS;
	/**
	 * Helper method of generateCSSRuleset to facilitate custom handling of certain
	 * CSS properties. Used for e.g. font families.
	 *
	 * See generateCSSRuleset for usage and documentation of paramater types.
	 */
	var runStringHandlers = function runStringHandlers(declarations, stringHandlers) {
	    var result = {};
	
	    Object.keys(declarations).forEach(function (key) {
	        // If a handler exists for this particular key, let it interpret
	        // that value first before continuing
	        if (stringHandlers && stringHandlers.hasOwnProperty(key)) {
	            result[key] = stringHandlers[key](declarations[key]);
	        } else {
	            result[key] = declarations[key];
	        }
	    });
	
	    return result;
	};
	
	/**
	 * Generate a CSS ruleset with the selector and containing the declarations.
	 *
	 * This function assumes that the given declarations don't contain any special
	 * children (such as media queries, pseudo-selectors, or descendant styles).
	 *
	 * Note that this method does not deal with nesting used for e.g.
	 * psuedo-selectors or media queries. That responsibility is left to  the
	 * `generateCSS` function.
	 *
	 * @param {string} selector: the selector associated with the ruleset
	 * @param {Object} declarations: a map from camelCased CSS property name to CSS
	 *     property value.
	 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
	 *     property name to a function which will map the given value to the value
	 *     that is output.
	 * @param {bool} useImportant: A boolean saying whether to append "!important"
	 *     to each of the CSS declarations.
	 * @returns {string} A string of raw CSS.
	 *
	 * Examples:
	 *
	 *    generateCSSRuleset(".blah", { color: "red" })
	 *    -> ".blah{color: red !important;}"
	 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
	 *    -> ".blah{color: red}"
	 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
	 *    -> ".blah{color: RED}"
	 *    generateCSSRuleset(".blah:hover", { color: "red" })
	 *    -> ".blah:hover{color: red}"
	 */
	var generateCSSRuleset = function generateCSSRuleset(selector, declarations, stringHandlers, useImportant) {
	    var handledDeclarations = runStringHandlers(declarations, stringHandlers);
	
	    var prefixedDeclarations = (0, _inlineStylePrefixerStatic2['default'])(handledDeclarations);
	
	    var prefixedRules = (0, _util.flatten)((0, _util.objectToPairs)(prefixedDeclarations).map(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var key = _ref2[0];
	        var value = _ref2[1];
	
	        if (Array.isArray(value)) {
	            var _ret = (function () {
	                // inline-style-prefix-all returns an array when there should be
	                // multiple rules, we will flatten to single rules
	
	                var prefixedValues = [];
	                var unprefixedValues = [];
	
	                value.forEach(function (v) {
	                    if (v.indexOf('-') === 0) {
	                        prefixedValues.push(v);
	                    } else {
	                        unprefixedValues.push(v);
	                    }
	                });
	
	                prefixedValues.sort();
	                unprefixedValues.sort();
	
	                return {
	                    v: prefixedValues.concat(unprefixedValues).map(function (v) {
	                        return [key, v];
	                    })
	                };
	            })();
	
	            if (typeof _ret === 'object') return _ret.v;
	        }
	        return [[key, value]];
	    }));
	
	    var rules = prefixedRules.map(function (_ref3) {
	        var _ref32 = _slicedToArray(_ref3, 2);
	
	        var key = _ref32[0];
	        var value = _ref32[1];
	
	        var stringValue = (0, _util.stringifyValue)(key, value);
	        var ret = (0, _util.kebabifyStyleName)(key) + ':' + stringValue + ';';
	        return useImportant === false ? ret : (0, _util.importantify)(ret);
	    }).join("");
	
	    if (rules) {
	        return selector + '{' + rules + '}';
	    } else {
	        return "";
	    }
	};
	exports.generateCSSRuleset = generateCSSRuleset;

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

	// Module with the same interface as the core aphrodite module,
	// except that styles injected do not automatically have !important
	// appended to them.
	//
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _inject = __webpack_require__(1685);
	
	var _indexJs = __webpack_require__(1684);
	
	var css = function css() {
	    for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
	        styleDefinitions[_key] = arguments[_key];
	    }
	
	    var useImportant = false; // Don't append !important to style definitions
	    return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions);
	};
	
	exports.StyleSheet = _indexJs.StyleSheet;
	exports.StyleSheetServer = _indexJs.StyleSheetServer;
	exports.StyleSheetTestUtils = _indexJs.StyleSheetTestUtils;
	exports.css = css;

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// rawAsap provides everything we need except exception management.
	var rawAsap = __webpack_require__(1686);
	// RawTasks are recycled to reduce GC churn.
	var freeTasks = [];
	// We queue errors to ensure they are thrown in right order (FIFO).
	// Array-as-queue is good enough here, since we are just dealing with exceptions.
	var pendingErrors = [];
	var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);
	
	function throwFirstError() {
	    if (pendingErrors.length) {
	        throw pendingErrors.shift();
	    }
	}
	
	/**
	 * Calls a task as soon as possible after returning, in its own event, with priority
	 * over other events like animation, reflow, and repaint. An error thrown from an
	 * event will not interrupt, nor even substantially slow down the processing of
	 * other events, but will be rather postponed to a lower priority event.
	 * @param {{call}} task A callable object, typically a function that takes no
	 * arguments.
	 */
	module.exports = asap;
	function asap(task) {
	    var rawTask;
	    if (freeTasks.length) {
	        rawTask = freeTasks.pop();
	    } else {
	        rawTask = new RawTask();
	    }
	    rawTask.task = task;
	    rawAsap(rawTask);
	}
	
	// We wrap tasks with recyclable task objects.  A task object implements
	// `call`, just like a function.
	function RawTask() {
	    this.task = null;
	}
	
	// The sole purpose of wrapping the task is to catch the exception and recycle
	// the task object after its single use.
	RawTask.prototype.call = function () {
	    try {
	        this.task.call();
	    } catch (error) {
	        if (asap.onerror) {
	            // This hook exists purely for testing purposes.
	            // Its name will be periodically randomized to break any code that
	            // depends on its existence.
	            asap.onerror(error);
	        } else {
	            // In a web browser, exceptions are not fatal. However, to avoid
	            // slowing down the queue of pending tasks, we rethrow the error in a
	            // lower priority turn.
	            pendingErrors.push(error);
	            requestErrorThrow();
	        }
	    } finally {
	        this.task = null;
	        freeTasks[freeTasks.length] = this;
	    }
	};


/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.parseHtml = void 0;
	var tslib_1 = __webpack_require__(181);
	var regex_lib_1 = __webpack_require__(392);
	var utils_1 = __webpack_require__(488);
	// For debugging: search for other "For debugging" lines
	// import CliTable from 'cli-table';
	/**
	 * Parses an HTML string, calling the callbacks to notify of tags and text.
	 *
	 * ## History
	 *
	 * This file previously used a regular expression to find html tags in the input
	 * text. Unfortunately, we ran into a bunch of catastrophic backtracking issues
	 * with certain input text, causing Autolinker to either hang or just take a
	 * really long time to parse the string.
	 *
	 * The current code is intended to be a O(n) algorithm that walks through
	 * the string in one pass, and tries to be as cheap as possible. We don't need
	 * to implement the full HTML spec, but rather simply determine where the string
	 * looks like an HTML tag, and where it looks like text (so that we can autolink
	 * that).
	 *
	 * This state machine parser is intended just to be a simple but performant
	 * parser of HTML for the subset of requirements we have. We simply need to:
	 *
	 * 1. Determine where HTML tags are
	 * 2. Determine the tag name (Autolinker specifically only cares about <a>,
	 *    <script>, and <style> tags, so as not to link any text within them)
	 *
	 * We don't need to:
	 *
	 * 1. Create a parse tree
	 * 2. Auto-close tags with invalid markup
	 * 3. etc.
	 *
	 * The other intention behind this is that we didn't want to add external
	 * dependencies on the Autolinker utility which would increase its size. For
	 * instance, adding htmlparser2 adds 125kb to the minified output file,
	 * increasing its final size from 47kb to 172kb (at the time of writing). It
	 * also doesn't work exactly correctly, treating the string "<3 blah blah blah"
	 * as an HTML tag.
	 *
	 * Reference for HTML spec:
	 *
	 *     https://www.w3.org/TR/html51/syntax.html#sec-tokenization
	 *
	 * @param {String} html The HTML to parse
	 * @param {Object} callbacks
	 * @param {Function} callbacks.onOpenTag Callback function to call when an open
	 *   tag is parsed. Called with the tagName as its argument.
	 * @param {Function} callbacks.onCloseTag Callback function to call when a close
	 *   tag is parsed. Called with the tagName as its argument. If a self-closing
	 *   tag is found, `onCloseTag` is called immediately after `onOpenTag`.
	 * @param {Function} callbacks.onText Callback function to call when text (i.e
	 *   not an HTML tag) is parsed. Called with the text (string) as its first
	 *   argument, and offset (number) into the string as its second.
	 */
	function parseHtml(html, _a) {
	    var onOpenTag = _a.onOpenTag, onCloseTag = _a.onCloseTag, onText = _a.onText, onComment = _a.onComment, onDoctype = _a.onDoctype;
	    var noCurrentTag = new CurrentTag();
	    var charIdx = 0, len = html.length, state = 0 /* Data */, currentDataIdx = 0, // where the current data start index is
	    currentTag = noCurrentTag; // describes the current tag that is being read
	    // For debugging: search for other "For debugging" lines
	    // const table = new CliTable( {
	    // 	head: [ 'charIdx', 'char', 'state', 'currentDataIdx', 'currentOpenTagIdx', 'tag.type' ]
	    // } );
	    while (charIdx < len) {
	        var char = html.charAt(charIdx);
	        // For debugging: search for other "For debugging" lines
	        // ALSO: Temporarily remove the 'const' keyword on the State enum
	        // table.push(
	        // 	[ charIdx, char, State[ state ], currentDataIdx, currentTag.idx, currentTag.idx === -1 ? '' : currentTag.type ]
	        // );
	        switch (state) {
	            case 0 /* Data */:
	                stateData(char);
	                break;
	            case 1 /* TagOpen */:
	                stateTagOpen(char);
	                break;
	            case 2 /* EndTagOpen */:
	                stateEndTagOpen(char);
	                break;
	            case 3 /* TagName */:
	                stateTagName(char);
	                break;
	            case 4 /* BeforeAttributeName */:
	                stateBeforeAttributeName(char);
	                break;
	            case 5 /* AttributeName */:
	                stateAttributeName(char);
	                break;
	            case 6 /* AfterAttributeName */:
	                stateAfterAttributeName(char);
	                break;
	            case 7 /* BeforeAttributeValue */:
	                stateBeforeAttributeValue(char);
	                break;
	            case 8 /* AttributeValueDoubleQuoted */:
	                stateAttributeValueDoubleQuoted(char);
	                break;
	            case 9 /* AttributeValueSingleQuoted */:
	                stateAttributeValueSingleQuoted(char);
	                break;
	            case 10 /* AttributeValueUnquoted */:
	                stateAttributeValueUnquoted(char);
	                break;
	            case 11 /* AfterAttributeValueQuoted */:
	                stateAfterAttributeValueQuoted(char);
	                break;
	            case 12 /* SelfClosingStartTag */:
	                stateSelfClosingStartTag(char);
	                break;
	            case 13 /* MarkupDeclarationOpenState */:
	                stateMarkupDeclarationOpen(char);
	                break;
	            case 14 /* CommentStart */:
	                stateCommentStart(char);
	                break;
	            case 15 /* CommentStartDash */:
	                stateCommentStartDash(char);
	                break;
	            case 16 /* Comment */:
	                stateComment(char);
	                break;
	            case 17 /* CommentEndDash */:
	                stateCommentEndDash(char);
	                break;
	            case 18 /* CommentEnd */:
	                stateCommentEnd(char);
	                break;
	            case 19 /* CommentEndBang */:
	                stateCommentEndBang(char);
	                break;
	            case 20 /* Doctype */:
	                stateDoctype(char);
	                break;
	            default:
	                (0, utils_1.throwUnhandledCaseError)(state);
	        }
	        // For debugging: search for other "For debugging" lines
	        // ALSO: Temporarily remove the 'const' keyword on the State enum
	        // table.push(
	        // 	[ charIdx, char, State[ state ], currentDataIdx, currentTag.idx, currentTag.idx === -1 ? '' : currentTag.type ]
	        // );
	        charIdx++;
	    }
	    if (currentDataIdx < charIdx) {
	        emitText();
	    }
	    // For debugging: search for other "For debugging" lines
	    // console.log( '\n' + table.toString() );
	    // Called when non-tags are being read (i.e. the text around HTML †ags)
	    // https://www.w3.org/TR/html51/syntax.html#data-state
	    function stateData(char) {
	        if (char === '<') {
	            startNewTag();
	        }
	    }
	    // Called after a '<' is read from the Data state
	    // https://www.w3.org/TR/html51/syntax.html#tag-open-state
	    function stateTagOpen(char) {
	        if (char === '!') {
	            state = 13 /* MarkupDeclarationOpenState */;
	        }
	        else if (char === '/') {
	            state = 2 /* EndTagOpen */;
	            currentTag = new CurrentTag((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentTag), { isClosing: true }));
	        }
	        else if (char === '<') {
	            // start of another tag (ignore the previous, incomplete one)
	            startNewTag();
	        }
	        else if (regex_lib_1.letterRe.test(char)) {
	            // tag name start (and no '/' read)
	            state = 3 /* TagName */;
	            currentTag = new CurrentTag((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentTag), { isOpening: true }));
	        }
	        else {
	            // Any other
	            state = 0 /* Data */;
	            currentTag = noCurrentTag;
	        }
	    }
	    // After a '<x', '</x' sequence is read (where 'x' is a letter character),
	    // this is to continue reading the tag name
	    // https://www.w3.org/TR/html51/syntax.html#tag-name-state
	    function stateTagName(char) {
	        if (regex_lib_1.whitespaceRe.test(char)) {
	            currentTag = new CurrentTag((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentTag), { name: captureTagName() }));
	            state = 4 /* BeforeAttributeName */;
	        }
	        else if (char === '<') {
	            // start of another tag (ignore the previous, incomplete one)
	            startNewTag();
	        }
	        else if (char === '/') {
	            currentTag = new CurrentTag((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentTag), { name: captureTagName() }));
	            state = 12 /* SelfClosingStartTag */;
	        }
	        else if (char === '>') {
	            currentTag = new CurrentTag((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentTag), { name: captureTagName() }));
	            emitTagAndPreviousTextNode(); // resets to Data state as well
	        }
	        else if (!regex_lib_1.letterRe.test(char) && !regex_lib_1.digitRe.test(char) && char !== ':') {
	            // Anything else that does not form an html tag. Note: the colon
	            // character is accepted for XML namespaced tags
	            resetToDataState();
	        }
	        else {
	            // continue reading tag name
	        }
	    }
	    // Called after the '/' is read from a '</' sequence
	    // https://www.w3.org/TR/html51/syntax.html#end-tag-open-state
	    function stateEndTagOpen(char) {
	        if (char === '>') {
	            // parse error. Encountered "</>". Skip it without treating as a tag
	            resetToDataState();
	        }
	        else if (regex_lib_1.letterRe.test(char)) {
	            state = 3 /* TagName */;
	        }
	        else {
	            // some other non-tag-like character, don't treat this as a tag
	            resetToDataState();
	        }
	    }
	    // https://www.w3.org/TR/html51/syntax.html#before-attribute-name-state
	    function stateBeforeAttributeName(char) {
	        if (regex_lib_1.whitespaceRe.test(char)) {
	            // stay in BeforeAttributeName state - continue reading chars
	        }
	        else if (char === '/') {
	            state = 12 /* SelfClosingStartTag */;
	        }
	        else if (char === '>') {
	            emitTagAndPreviousTextNode(); // resets to Data state as well
	        }
	        else if (char === '<') {
	            // start of another tag (ignore the previous, incomplete one)
	            startNewTag();
	        }
	        else if (char === "=" || regex_lib_1.quoteRe.test(char) || regex_lib_1.controlCharsRe.test(char)) {
	            // "Parse error" characters that, according to the spec, should be
	            // appended to the attribute name, but we'll treat these characters
	            // as not forming a real HTML tag
	            resetToDataState();
	        }
	        else {
	            // Any other char, start of a new attribute name
	            state = 5 /* AttributeName */;
	        }
	    }
	    // https://www.w3.org/TR/html51/syntax.html#attribute-name-state
	    function stateAttributeName(char) {
	        if (regex_lib_1.whitespaceRe.test(char)) {
	            state = 6 /* AfterAttributeName */;
	        }
	        else if (char === '/') {
	            state = 12 /* SelfClosingStartTag */;
	        }
	        else if (char === '=') {
	            state = 7 /* BeforeAttributeValue */;
	        }
	        else if (char === '>') {
	            emitTagAndPreviousTextNode(); // resets to Data state as well
	        }
	        else if (char === '<') {
	            // start of another tag (ignore the previous, incomplete one)
	            startNewTag();
	        }
	        else if (regex_lib_1.quoteRe.test(char)) {
	            // "Parse error" characters that, according to the spec, should be
	            // appended to the attribute name, but we'll treat these characters
	            // as not forming a real HTML tag
	            resetToDataState();
	        }
	        else {
	            // anything else: continue reading attribute name
	        }
	    }
	    // https://www.w3.org/TR/html51/syntax.html#after-attribute-name-state
	    function stateAfterAttributeName(char) {
	        if (regex_lib_1.whitespaceRe.test(char)) {
	            // ignore the character - continue reading
	        }
	        else if (char === '/') {
	            state = 12 /* SelfClosingStartTag */;
	        }
	        else if (char === '=') {
	            state = 7 /* BeforeAttributeValue */;
	        }
	        else if (char === '>') {
	            emitTagAndPreviousTextNode();
	        }
	        else if (char === '<') {
	            // start of another tag (ignore the previous, incomplete one)
	            startNewTag();
	        }
	        else if (regex_lib_1.quoteRe.test(char)) {
	            // "Parse error" characters that, according to the spec, should be
	            // appended to the attribute name, but we'll treat these characters
	            // as not forming a real HTML tag
	            resetToDataState();
	        }
	        else {
	            // Any other character, start a new attribute in the current tag
	            state = 5 /* AttributeName */;
	        }
	    }
	    // https://www.w3.org/TR/html51/syntax.html#before-attribute-value-state
	    function stateBeforeAttributeValue(char) {
	        if (regex_lib_1.whitespaceRe.test(char)) {
	            // ignore the character - continue reading
	        }
	        else if (char === "\"") {
	            state = 8 /* AttributeValueDoubleQuoted */;
	        }
	        else if (char === "'") {
	            state = 9 /* AttributeValueSingleQuoted */;
	        }
	        else if (/[>=`]/.test(char)) {
	            // Invalid chars after an '=' for an attribute value, don't count
	            // the current tag as an HTML tag
	            resetToDataState();
	        }
	        else if (char === '<') {
	            // start of another tag (ignore the previous, incomplete one)
	            startNewTag();
	        }
	        else {
	            // Any other character, consider it an unquoted attribute value
	            state = 10 /* AttributeValueUnquoted */;
	        }
	    }
	    // https://www.w3.org/TR/html51/syntax.html#attribute-value-double-quoted-state
	    function stateAttributeValueDoubleQuoted(char) {
	        if (char === "\"") {
	            // end the current double-quoted attribute
	            state = 11 /* AfterAttributeValueQuoted */;
	        }
	        else {
	            // consume the character as part of the double-quoted attribute value
	        }
	    }
	    // https://www.w3.org/TR/html51/syntax.html#attribute-value-single-quoted-state
	    function stateAttributeValueSingleQuoted(char) {
	        if (char === "'") {
	            // end the current single-quoted attribute
	            state = 11 /* AfterAttributeValueQuoted */;
	        }
	        else {
	            // consume the character as part of the double-quoted attribute value
	        }
	    }
	    // https://www.w3.org/TR/html51/syntax.html#attribute-value-unquoted-state
	    function stateAttributeValueUnquoted(char) {
	        if (regex_lib_1.whitespaceRe.test(char)) {
	            state = 4 /* BeforeAttributeName */;
	        }
	        else if (char === '>') {
	            emitTagAndPreviousTextNode();
	        }
	        else if (char === '<') {
	            // start of another tag (ignore the previous, incomplete one)
	            startNewTag();
	        }
	        else {
	            // Any other character, treat it as part of the attribute value
	        }
	    }
	    // https://www.w3.org/TR/html51/syntax.html#after-attribute-value-quoted-state
	    function stateAfterAttributeValueQuoted(char) {
	        if (regex_lib_1.whitespaceRe.test(char)) {
	            state = 4 /* BeforeAttributeName */;
	        }
	        else if (char === '/') {
	            state = 12 /* SelfClosingStartTag */;
	        }
	        else if (char === '>') {
	            emitTagAndPreviousTextNode();
	        }
	        else if (char === '<') {
	            // start of another tag (ignore the previous, incomplete one)
	            startNewTag();
	        }
	        else {
	            // Any other character, "parse error". Spec says to switch to the
	            // BeforeAttributeState and re-consume the character, as it may be
	            // the start of a new attribute name
	            state = 4 /* BeforeAttributeName */;
	            reconsumeCurrentCharacter();
	        }
	    }
	    // A '/' has just been read in the current tag (presumably for '/>'), and
	    // this handles the next character
	    // https://www.w3.org/TR/html51/syntax.html#self-closing-start-tag-state
	    function stateSelfClosingStartTag(char) {
	        if (char === '>') {
	            currentTag = new CurrentTag((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentTag), { isClosing: true }));
	            emitTagAndPreviousTextNode(); // resets to Data state as well
	        }
	        else {
	            state = 4 /* BeforeAttributeName */;
	        }
	    }
	    // https://www.w3.org/TR/html51/syntax.html#markup-declaration-open-state
	    // (HTML Comments or !DOCTYPE)
	    function stateMarkupDeclarationOpen(char) {
	        if (html.substr(charIdx, 2) === '--') {
	            // html comment
	            charIdx += 2; // "consume" characters
	            currentTag = new CurrentTag((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentTag), { type: 'comment' }));
	            state = 14 /* CommentStart */;
	        }
	        else if (html.substr(charIdx, 7).toUpperCase() === 'DOCTYPE') {
	            charIdx += 7; // "consume" characters
	            currentTag = new CurrentTag((0, tslib_1.__assign)((0, tslib_1.__assign)({}, currentTag), { type: 'doctype' }));
	            state = 20 /* Doctype */;
	        }
	        else {
	            // At this point, the spec specifies that the state machine should
	            // enter the "bogus comment" state, in which case any character(s)
	            // after the '<!' that were read should become an HTML comment up
	            // until the first '>' that is read (or EOF). Instead, we'll assume
	            // that a user just typed '<!' as part of text data
	            resetToDataState();
	        }
	    }
	    // Handles after the sequence '<!--' has been read
	    // https://www.w3.org/TR/html51/syntax.html#comment-start-state
	    function stateCommentStart(char) {
	        if (char === '-') {
	            // We've read the sequence '<!---' at this point (3 dashes)
	            state = 15 /* CommentStartDash */;
	        }
	        else if (char === '>') {
	            // At this point, we'll assume the comment wasn't a real comment
	            // so we'll just emit it as data. We basically read the sequence
	            // '<!-->'
	            resetToDataState();
	        }
	        else {
	            // Any other char, take it as part of the comment
	            state = 16 /* Comment */;
	        }
	    }
	    // We've read the sequence '<!---' at this point (3 dashes)
	    // https://www.w3.org/TR/html51/syntax.html#comment-start-dash-state
	    function stateCommentStartDash(char) {
	        if (char === '-') {
	            // We've read '<!----' (4 dashes) at this point
	            state = 18 /* CommentEnd */;
	        }
	        else if (char === '>') {
	            // At this point, we'll assume the comment wasn't a real comment
	            // so we'll just emit it as data. We basically read the sequence
	            // '<!--->'
	            resetToDataState();
	        }
	        else {
	            // Anything else, take it as a valid comment
	            state = 16 /* Comment */;
	        }
	    }
	    // Currently reading the comment's text (data)
	    // https://www.w3.org/TR/html51/syntax.html#comment-state
	    function stateComment(char) {
	        if (char === '-') {
	            state = 17 /* CommentEndDash */;
	        }
	        else {
	            // Any other character, stay in the Comment state
	        }
	    }
	    // When we we've read the first dash inside a comment, it may signal the
	    // end of the comment if we read another dash
	    // https://www.w3.org/TR/html51/syntax.html#comment-end-dash-state
	    function stateCommentEndDash(char) {
	        if (char === '-') {
	            state = 18 /* CommentEnd */;
	        }
	        else {
	            // Wasn't a dash, must still be part of the comment
	            state = 16 /* Comment */;
	        }
	    }
	    // After we've read two dashes inside a comment, it may signal the end of
	    // the comment if we then read a '>' char
	    // https://www.w3.org/TR/html51/syntax.html#comment-end-state
	    function stateCommentEnd(char) {
	        if (char === '>') {
	            emitTagAndPreviousTextNode();
	        }
	        else if (char === '!') {
	            state = 19 /* CommentEndBang */;
	        }
	        else if (char === '-') {
	            // A 3rd '-' has been read: stay in the CommentEnd state
	        }
	        else {
	            // Anything else, switch back to the comment state since we didn't
	            // read the full "end comment" sequence (i.e. '-->')
	            state = 16 /* Comment */;
	        }
	    }
	    // We've read the sequence '--!' inside of a comment
	    // https://www.w3.org/TR/html51/syntax.html#comment-end-bang-state
	    function stateCommentEndBang(char) {
	        if (char === '-') {
	            // We read the sequence '--!-' inside of a comment. The last dash
	            // could signify that the comment is going to close
	            state = 17 /* CommentEndDash */;
	        }
	        else if (char === '>') {
	            // End of comment with the sequence '--!>'
	            emitTagAndPreviousTextNode();
	        }
	        else {
	            // The '--!' was not followed by a '>', continue reading the
	            // comment's text
	            state = 16 /* Comment */;
	        }
	    }
	    /**
	     * For DOCTYPES in particular, we don't care about the attributes. Just
	     * advance to the '>' character and emit the tag, unless we find a '<'
	     * character in which case we'll start a new tag.
	     *
	     * Example doctype tag:
	     *    <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01//EN" "http://www.w3.org/TR/html4/strict.dtd">
	     *
	     * Actual spec: https://www.w3.org/TR/html51/syntax.html#doctype-state
	     */
	    function stateDoctype(char) {
	        if (char === '>') {
	            emitTagAndPreviousTextNode();
	        }
	        else if (char === '<') {
	            startNewTag();
	        }
	        else {
	            // stay in the Doctype state
	        }
	    }
	    /**
	     * Resets the state back to the Data state, and removes the current tag.
	     *
	     * We'll generally run this function whenever a "parse error" is
	     * encountered, where the current tag that is being read no longer looks
	     * like a real HTML tag.
	     */
	    function resetToDataState() {
	        state = 0 /* Data */;
	        currentTag = noCurrentTag;
	    }
	    /**
	     * Starts a new HTML tag at the current index, ignoring any previous HTML
	     * tag that was being read.
	     *
	     * We'll generally run this function whenever we read a new '<' character,
	     * including when we read a '<' character inside of an HTML tag that we were
	     * previously reading.
	     */
	    function startNewTag() {
	        state = 1 /* TagOpen */;
	        currentTag = new CurrentTag({ idx: charIdx });
	    }
	    /**
	     * Once we've decided to emit an open tag, that means we can also emit the
	     * text node before it.
	     */
	    function emitTagAndPreviousTextNode() {
	        var textBeforeTag = html.slice(currentDataIdx, currentTag.idx);
	        if (textBeforeTag) {
	            // the html tag was the first element in the html string, or two
	            // tags next to each other, in which case we should not emit a text
	            // node
	            onText(textBeforeTag, currentDataIdx);
	        }
	        if (currentTag.type === 'comment') {
	            onComment(currentTag.idx);
	        }
	        else if (currentTag.type === 'doctype') {
	            onDoctype(currentTag.idx);
	        }
	        else {
	            if (currentTag.isOpening) {
	                onOpenTag(currentTag.name, currentTag.idx);
	            }
	            if (currentTag.isClosing) {
	                // note: self-closing tags will emit both opening and closing
	                onCloseTag(currentTag.name, currentTag.idx);
	            }
	        }
	        // Since we just emitted a tag, reset to the data state for the next char
	        resetToDataState();
	        currentDataIdx = charIdx + 1;
	    }
	    function emitText() {
	        var text = html.slice(currentDataIdx, charIdx);
	        onText(text, currentDataIdx);
	        currentDataIdx = charIdx + 1;
	    }
	    /**
	     * Captures the tag name from the start of the tag to the current character
	     * index, and converts it to lower case
	     */
	    function captureTagName() {
	        var startIdx = currentTag.idx + (currentTag.isClosing ? 2 : 1);
	        return html.slice(startIdx, charIdx).toLowerCase();
	    }
	    /**
	     * Causes the main loop to re-consume the current character, such as after
	     * encountering a "parse error" that changed state and needs to reconsume
	     * the same character in that new state.
	     */
	    function reconsumeCurrentCharacter() {
	        charIdx--;
	    }
	}
	exports.parseHtml = parseHtml;
	var CurrentTag = /** @class */ (function () {
	    function CurrentTag(cfg) {
	        if (cfg === void 0) { cfg = {}; }
	        this.idx = cfg.idx !== undefined ? cfg.idx : -1;
	        this.type = cfg.type || 'tag';
	        this.name = cfg.name || '';
	        this.isOpening = !!cfg.isOpening;
	        this.isClosing = !!cfg.isClosing;
	    }
	    return CurrentTag;
	}());
	//# sourceMappingURL=parse-html.js.map

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(181);
	(0, tslib_1.__exportStar)(__webpack_require__(1086), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1087), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(390), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1088), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1089), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1090), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(181);
	(0, tslib_1.__exportStar)(__webpack_require__(1688), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1689), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(391), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1690), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1691), exports);
	(0, tslib_1.__exportStar)(__webpack_require__(1693), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.UrlMatchValidator = void 0;
	var regex_lib_1 = __webpack_require__(392);
	/**
	 * @private
	 * @class Autolinker.matcher.UrlMatchValidator
	 * @singleton
	 *
	 * Used by Autolinker to filter out false URL positives from the
	 * {@link Autolinker.matcher.Url UrlMatcher}.
	 *
	 * Due to the limitations of regular expressions (including the missing feature
	 * of look-behinds in JS regular expressions), we cannot always determine the
	 * validity of a given match. This class applies a bit of additional logic to
	 * filter out any false positives that have been matched by the
	 * {@link Autolinker.matcher.Url UrlMatcher}.
	 */
	var UrlMatchValidator = /** @class */ (function () {
	    function UrlMatchValidator() {
	    }
	    /**
	     * Determines if a given URL match found by the {@link Autolinker.matcher.Url UrlMatcher}
	     * is valid. Will return `false` for:
	     *
	     * 1) URL matches which do not have at least have one period ('.') in the
	     *    domain name (effectively skipping over matches like "abc:def").
	     *    However, URL matches with a protocol will be allowed (ex: 'http://localhost')
	     * 2) URL matches which do not have at least one word character in the
	     *    domain name (effectively skipping over matches like "git:1.0").
	     *    However, URL matches with a protocol will be allowed (ex: 'intra-net://271219.76')
	     * 3) A protocol-relative url match (a URL beginning with '//') whose
	     *    previous character is a word character (effectively skipping over
	     *    strings like "abc//google.com")
	     *
	     * Otherwise, returns `true`.
	     *
	     * @param {String} urlMatch The matched URL, if there was one. Will be an
	     *   empty string if the match is not a URL match.
	     * @param {String} protocolUrlMatch The match URL string for a protocol
	     *   match. Ex: 'http://yahoo.com'. This is used to match something like
	     *   'http://localhost', where we won't double check that the domain name
	     *   has at least one '.' in it.
	     * @return {Boolean} `true` if the match given is valid and should be
	     *   processed, or `false` if the match is invalid and/or should just not be
	     *   processed.
	     */
	    UrlMatchValidator.isValid = function (urlMatch, protocolUrlMatch) {
	        if ((protocolUrlMatch && !this.isValidUriScheme(protocolUrlMatch)) ||
	            this.urlMatchDoesNotHaveProtocolOrDot(urlMatch, protocolUrlMatch) || // At least one period ('.') must exist in the URL match for us to consider it an actual URL, *unless* it was a full protocol match (like 'http://localhost')
	            (this.urlMatchDoesNotHaveAtLeastOneWordChar(urlMatch, protocolUrlMatch) && // At least one letter character must exist in the domain name after a protocol match. Ex: skip over something like "git:1.0"
	                !this.isValidIpAddress(urlMatch)) || // Except if it's an IP address
	            this.containsMultipleDots(urlMatch)) {
	            return false;
	        }
	        return true;
	    };
	    UrlMatchValidator.isValidIpAddress = function (uriSchemeMatch) {
	        var newRegex = new RegExp(this.hasFullProtocolRegex.source + this.ipRegex.source);
	        var uriScheme = uriSchemeMatch.match(newRegex);
	        return uriScheme !== null;
	    };
	    UrlMatchValidator.containsMultipleDots = function (urlMatch) {
	        var stringBeforeSlash = urlMatch;
	        if (this.hasFullProtocolRegex.test(urlMatch)) {
	            stringBeforeSlash = urlMatch.split('://')[1];
	        }
	        return stringBeforeSlash.split('/')[0].indexOf('..') > -1;
	    };
	    /**
	     * Determines if the URI scheme is a valid scheme to be autolinked. Returns
	     * `false` if the scheme is 'javascript:' or 'vbscript:'
	     *
	     * @private
	     * @param {String} uriSchemeMatch The match URL string for a full URI scheme
	     *   match. Ex: 'http://yahoo.com' or 'mailto:a@a.com'.
	     * @return {Boolean} `true` if the scheme is a valid one, `false` otherwise.
	     */
	    UrlMatchValidator.isValidUriScheme = function (uriSchemeMatch) {
	        var uriSchemeMatchArr = uriSchemeMatch.match(this.uriSchemeRegex), uriScheme = uriSchemeMatchArr && uriSchemeMatchArr[0].toLowerCase();
	        return uriScheme !== 'javascript:' && uriScheme !== 'vbscript:';
	    };
	    /**
	     * Determines if a URL match does not have either:
	     *
	     * a) a full protocol (i.e. 'http://'), or
	     * b) at least one dot ('.') in the domain name (for a non-full-protocol
	     *    match).
	     *
	     * Either situation is considered an invalid URL (ex: 'git:d' does not have
	     * either the '://' part, or at least one dot in the domain name. If the
	     * match was 'git:abc.com', we would consider this valid.)
	     *
	     * @private
	     * @param {String} urlMatch The matched URL, if there was one. Will be an
	     *   empty string if the match is not a URL match.
	     * @param {String} protocolUrlMatch The match URL string for a protocol
	     *   match. Ex: 'http://yahoo.com'. This is used to match something like
	     *   'http://localhost', where we won't double check that the domain name
	     *   has at least one '.' in it.
	     * @return {Boolean} `true` if the URL match does not have a full protocol,
	     *   or at least one dot ('.') in a non-full-protocol match.
	     */
	    UrlMatchValidator.urlMatchDoesNotHaveProtocolOrDot = function (urlMatch, protocolUrlMatch) {
	        return (!!urlMatch &&
	            (!protocolUrlMatch || !this.hasFullProtocolRegex.test(protocolUrlMatch)) &&
	            urlMatch.indexOf('.') === -1);
	    };
	    /**
	     * Determines if a URL match does not have either:
	     *
	     * a) a full protocol (i.e. 'http://'), or
	     * b) at least one word character after the protocol (i.e. in the domain name)
	     *
	     * At least one letter character must exist in the domain name after a
	     * protocol match. Ex: skip over something like "git:1.0"
	     *
	     * @private
	     * @param {String} urlMatch The matched URL, if there was one. Will be an
	     *   empty string if the match is not a URL match.
	     * @param {String} protocolUrlMatch The match URL string for a protocol
	     *   match. Ex: 'http://yahoo.com'. This is used to know whether or not we
	     *   have a protocol in the URL string, in order to check for a word
	     *   character after the protocol separator (':').
	     * @return {Boolean} `true` if the URL match does not have a full protocol, or
	     * at least one word character in it, `false` otherwise.
	     */
	    UrlMatchValidator.urlMatchDoesNotHaveAtLeastOneWordChar = function (urlMatch, protocolUrlMatch) {
	        if (urlMatch && protocolUrlMatch) {
	            return (!this.hasFullProtocolRegex.test(protocolUrlMatch) &&
	                !this.hasWordCharAfterProtocolRegex.test(urlMatch));
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * Regex to test for a full protocol, with the two trailing slashes. Ex: 'http://'
	     *
	     * @private
	     * @property {RegExp} hasFullProtocolRegex
	     */
	    UrlMatchValidator.hasFullProtocolRegex = /^[A-Za-z][-.+A-Za-z0-9]*:\/\//;
	    /**
	     * Regex to find the URI scheme, such as 'mailto:'.
	     *
	     * This is used to filter out 'javascript:' and 'vbscript:' schemes.
	     *
	     * @private
	     * @property {RegExp} uriSchemeRegex
	     */
	    UrlMatchValidator.uriSchemeRegex = /^[A-Za-z][-.+A-Za-z0-9]*:/;
	    /**
	     * Regex to determine if at least one word char exists after the protocol (i.e. after the ':')
	     *
	     * @private
	     * @property {RegExp} hasWordCharAfterProtocolRegex
	     */
	    UrlMatchValidator.hasWordCharAfterProtocolRegex = new RegExp(':[^\\s]*?[' + regex_lib_1.alphaCharsStr + ']');
	    /**
	     * Regex to determine if the string is a valid IP address
	     *
	     * @private
	     * @property {RegExp} ipRegex
	     */
	    UrlMatchValidator.ipRegex = /[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/;
	    return UrlMatchValidator;
	}());
	exports.UrlMatchValidator = UrlMatchValidator;
	//# sourceMappingURL=url-match-validator.js.map

/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.truncateEnd = void 0;
	var utils_1 = __webpack_require__(488);
	/**
	 * A truncation feature where the ellipsis will be placed at the end of the URL.
	 *
	 * @param {String} anchorText
	 * @param {Number} truncateLen The maximum length of the truncated output URL string.
	 * @param {String} ellipsisChars The characters to place within the url, e.g. "..".
	 * @return {String} The truncated URL.
	 */
	function truncateEnd(anchorText, truncateLen, ellipsisChars) {
	    return (0, utils_1.ellipsis)(anchorText, truncateLen, ellipsisChars);
	}
	exports.truncateEnd = truncateEnd;
	//# sourceMappingURL=truncate-end.js.map

/***/ }),
/* 2981 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.truncateMiddle = void 0;
	/**
	 * Date: 2015-10-05
	 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
	 *
	 * A truncation feature, where the ellipsis will be placed in the dead-center of the URL.
	 *
	 * @param {String} url             A URL.
	 * @param {Number} truncateLen     The maximum length of the truncated output URL string.
	 * @param {String} ellipsisChars   The characters to place within the url, e.g. "..".
	 * @return {String} The truncated URL.
	 */
	function truncateMiddle(url, truncateLen, ellipsisChars) {
	    if (url.length <= truncateLen) {
	        return url;
	    }
	    var ellipsisLengthBeforeParsing;
	    var ellipsisLength;
	    if (ellipsisChars == null) {
	        ellipsisChars = '&hellip;';
	        ellipsisLengthBeforeParsing = 8;
	        ellipsisLength = 3;
	    }
	    else {
	        ellipsisLengthBeforeParsing = ellipsisChars.length;
	        ellipsisLength = ellipsisChars.length;
	    }
	    var availableLength = truncateLen - ellipsisLength;
	    var end = '';
	    if (availableLength > 0) {
	        end = url.substr(-1 * Math.floor(availableLength / 2));
	    }
	    return (url.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
	}
	exports.truncateMiddle = truncateMiddle;
	//# sourceMappingURL=truncate-middle.js.map

/***/ }),
/* 2982 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.truncateSmart = void 0;
	/**
	 * Date: 2015-10-05
	 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
	 *
	 * A truncation feature, where the ellipsis will be placed at a section within
	 * the URL making it still somewhat human readable.
	 *
	 * @param {String} url						 A URL.
	 * @param {Number} truncateLen		 The maximum length of the truncated output URL string.
	 * @param {String} ellipsisChars	 The characters to place within the url, e.g. "...".
	 * @return {String} The truncated URL.
	 */
	function truncateSmart(url, truncateLen, ellipsisChars) {
	    var ellipsisLengthBeforeParsing;
	    var ellipsisLength;
	    if (ellipsisChars == null) {
	        ellipsisChars = '&hellip;';
	        ellipsisLength = 3;
	        ellipsisLengthBeforeParsing = 8;
	    }
	    else {
	        ellipsisLength = ellipsisChars.length;
	        ellipsisLengthBeforeParsing = ellipsisChars.length;
	    }
	    var parse_url = function (url) {
	        // Functionality inspired by PHP function of same name
	        var urlObj = {};
	        var urlSub = url;
	        var match = urlSub.match(/^([a-z]+):\/\//i);
	        if (match) {
	            urlObj.scheme = match[1];
	            urlSub = urlSub.substr(match[0].length);
	        }
	        match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
	        if (match) {
	            urlObj.host = match[1];
	            urlSub = urlSub.substr(match[0].length);
	        }
	        match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
	        if (match) {
	            urlObj.path = match[1];
	            urlSub = urlSub.substr(match[0].length);
	        }
	        match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
	        if (match) {
	            urlObj.query = match[1];
	            urlSub = urlSub.substr(match[0].length);
	        }
	        match = urlSub.match(/^#(.*?)$/i);
	        if (match) {
	            urlObj.fragment = match[1];
	            //urlSub = urlSub.substr(match[0].length);  -- not used. Uncomment if adding another block.
	        }
	        return urlObj;
	    };
	    var buildUrl = function (urlObj) {
	        var url = '';
	        if (urlObj.scheme && urlObj.host) {
	            url += urlObj.scheme + '://';
	        }
	        if (urlObj.host) {
	            url += urlObj.host;
	        }
	        if (urlObj.path) {
	            url += '/' + urlObj.path;
	        }
	        if (urlObj.query) {
	            url += '?' + urlObj.query;
	        }
	        if (urlObj.fragment) {
	            url += '#' + urlObj.fragment;
	        }
	        return url;
	    };
	    var buildSegment = function (segment, remainingAvailableLength) {
	        var remainingAvailableLengthHalf = remainingAvailableLength / 2, startOffset = Math.ceil(remainingAvailableLengthHalf), endOffset = -1 * Math.floor(remainingAvailableLengthHalf), end = '';
	        if (endOffset < 0) {
	            end = segment.substr(endOffset);
	        }
	        return segment.substr(0, startOffset) + ellipsisChars + end;
	    };
	    if (url.length <= truncateLen) {
	        return url;
	    }
	    var availableLength = truncateLen - ellipsisLength;
	    var urlObj = parse_url(url);
	    // Clean up the URL
	    if (urlObj.query) {
	        var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
	        if (matchQuery) {
	            // Malformed URL; two or more "?". Removed any content behind the 2nd.
	            urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
	            url = buildUrl(urlObj);
	        }
	    }
	    if (url.length <= truncateLen) {
	        return url;
	    }
	    if (urlObj.host) {
	        urlObj.host = urlObj.host.replace(/^www\./, '');
	        url = buildUrl(urlObj);
	    }
	    if (url.length <= truncateLen) {
	        return url;
	    }
	    // Process and build the URL
	    var str = '';
	    if (urlObj.host) {
	        str += urlObj.host;
	    }
	    if (str.length >= availableLength) {
	        if (urlObj.host.length == truncateLen) {
	            return (urlObj.host.substr(0, truncateLen - ellipsisLength) + ellipsisChars).substr(0, availableLength + ellipsisLengthBeforeParsing);
	        }
	        return buildSegment(str, availableLength).substr(0, availableLength + ellipsisLengthBeforeParsing);
	    }
	    var pathAndQuery = '';
	    if (urlObj.path) {
	        pathAndQuery += '/' + urlObj.path;
	    }
	    if (urlObj.query) {
	        pathAndQuery += '?' + urlObj.query;
	    }
	    if (pathAndQuery) {
	        if ((str + pathAndQuery).length >= availableLength) {
	            if ((str + pathAndQuery).length == truncateLen) {
	                return (str + pathAndQuery).substr(0, truncateLen);
	            }
	            var remainingAvailableLength = availableLength - str.length;
	            return (str + buildSegment(pathAndQuery, remainingAvailableLength)).substr(0, availableLength + ellipsisLengthBeforeParsing);
	        }
	        else {
	            str += pathAndQuery;
	        }
	    }
	    if (urlObj.fragment) {
	        var fragment = '#' + urlObj.fragment;
	        if ((str + fragment).length >= availableLength) {
	            if ((str + fragment).length == truncateLen) {
	                return (str + fragment).substr(0, truncateLen);
	            }
	            var remainingAvailableLength2 = availableLength - str.length;
	            return (str + buildSegment(fragment, remainingAvailableLength2)).substr(0, availableLength + ellipsisLengthBeforeParsing);
	        }
	        else {
	            str += fragment;
	        }
	    }
	    if (urlObj.scheme && urlObj.host) {
	        var scheme = urlObj.scheme + '://';
	        if ((str + scheme).length < availableLength) {
	            return (scheme + str).substr(0, truncateLen);
	        }
	    }
	    if (str.length <= truncateLen) {
	        return str;
	    }
	    var end = '';
	    if (availableLength > 0) {
	        end = str.substr(-1 * Math.floor(availableLength / 2));
	    }
	    return (str.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
	}
	exports.truncateSmart = truncateSmart;
	//# sourceMappingURL=truncate-smart.js.map

/***/ }),
/* 2983 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.version = void 0;
	// Important: this file is generated from the 'build' script and should not be
	// edited directly
	exports.version = '3.16.2';
	//# sourceMappingURL=version.js.map

/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Autosize 3.0.21
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
			factory(exports, module);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod.exports, mod);
			global.autosize = mod.exports;
		}
	})(this, function (exports, module) {
		'use strict';
	
		var map = typeof Map === "function" ? new Map() : (function () {
			var keys = [];
			var values = [];
	
			return {
				has: function has(key) {
					return keys.indexOf(key) > -1;
				},
				get: function get(key) {
					return values[keys.indexOf(key)];
				},
				set: function set(key, value) {
					if (keys.indexOf(key) === -1) {
						keys.push(key);
						values.push(value);
					}
				},
				'delete': function _delete(key) {
					var index = keys.indexOf(key);
					if (index > -1) {
						keys.splice(index, 1);
						values.splice(index, 1);
					}
				}
			};
		})();
	
		var createEvent = function createEvent(name) {
			return new Event(name, { bubbles: true });
		};
		try {
			new Event('test');
		} catch (e) {
			// IE does not support `new Event()`
			createEvent = function (name) {
				var evt = document.createEvent('Event');
				evt.initEvent(name, true, false);
				return evt;
			};
		}
	
		function assign(ta) {
			if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
	
			var heightOffset = null;
			var clientWidth = ta.clientWidth;
			var cachedHeight = null;
	
			function init() {
				var style = window.getComputedStyle(ta, null);
	
				if (style.resize === 'vertical') {
					ta.style.resize = 'none';
				} else if (style.resize === 'both') {
					ta.style.resize = 'horizontal';
				}
	
				if (style.boxSizing === 'content-box') {
					heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
				} else {
					heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
				}
				// Fix when a textarea is not on document body and heightOffset is Not a Number
				if (isNaN(heightOffset)) {
					heightOffset = 0;
				}
	
				update();
			}
	
			function changeOverflow(value) {
				{
					// Chrome/Safari-specific fix:
					// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
					// made available by removing the scrollbar. The following forces the necessary text reflow.
					var width = ta.style.width;
					ta.style.width = '0px';
					// Force reflow:
					/* jshint ignore:start */
					ta.offsetWidth;
					/* jshint ignore:end */
					ta.style.width = width;
				}
	
				ta.style.overflowY = value;
			}
	
			function getParentOverflows(el) {
				var arr = [];
	
				while (el && el.parentNode && el.parentNode instanceof Element) {
					if (el.parentNode.scrollTop) {
						arr.push({
							node: el.parentNode,
							scrollTop: el.parentNode.scrollTop
						});
					}
					el = el.parentNode;
				}
	
				return arr;
			}
	
			function resize() {
				var originalHeight = ta.style.height;
				var overflows = getParentOverflows(ta);
				var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
	
				ta.style.height = 'auto';
	
				var endHeight = ta.scrollHeight + heightOffset;
	
				if (ta.scrollHeight === 0) {
					// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
					ta.style.height = originalHeight;
					return;
				}
	
				ta.style.height = endHeight + 'px';
	
				// used to check if an update is actually necessary on window.resize
				clientWidth = ta.clientWidth;
	
				// prevents scroll-position jumping
				overflows.forEach(function (el) {
					el.node.scrollTop = el.scrollTop;
				});
	
				if (docTop) {
					document.documentElement.scrollTop = docTop;
				}
			}
	
			function update() {
				resize();
	
				var styleHeight = Math.round(parseFloat(ta.style.height));
				var computed = window.getComputedStyle(ta, null);
	
				// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
				var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
	
				// The actual height not matching the style height (set via the resize method) indicates that
				// the max-height has been exceeded, in which case the overflow should be allowed.
				if (actualHeight !== styleHeight) {
					if (computed.overflowY === 'hidden') {
						changeOverflow('scroll');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				} else {
					// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
					if (computed.overflowY !== 'hidden') {
						changeOverflow('hidden');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				}
	
				if (cachedHeight !== actualHeight) {
					cachedHeight = actualHeight;
					var evt = createEvent('autosize:resized');
					try {
						ta.dispatchEvent(evt);
					} catch (err) {
						// Firefox will throw an error on dispatchEvent for a detached element
						// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
					}
				}
			}
	
			var pageResize = function pageResize() {
				if (ta.clientWidth !== clientWidth) {
					update();
				}
			};
	
			var destroy = (function (style) {
				window.removeEventListener('resize', pageResize, false);
				ta.removeEventListener('input', update, false);
				ta.removeEventListener('keyup', update, false);
				ta.removeEventListener('autosize:destroy', destroy, false);
				ta.removeEventListener('autosize:update', update, false);
	
				Object.keys(style).forEach(function (key) {
					ta.style[key] = style[key];
				});
	
				map['delete'](ta);
			}).bind(ta, {
				height: ta.style.height,
				resize: ta.style.resize,
				overflowY: ta.style.overflowY,
				overflowX: ta.style.overflowX,
				wordWrap: ta.style.wordWrap
			});
	
			ta.addEventListener('autosize:destroy', destroy, false);
	
			// IE9 does not fire onpropertychange or oninput for deletions,
			// so binding to onkeyup to catch most of those events.
			// There is no way that I know of to detect something like 'cut' in IE9.
			if ('onpropertychange' in ta && 'oninput' in ta) {
				ta.addEventListener('keyup', update, false);
			}
	
			window.addEventListener('resize', pageResize, false);
			ta.addEventListener('input', update, false);
			ta.addEventListener('autosize:update', update, false);
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
	
			map.set(ta, {
				destroy: destroy,
				update: update
			});
	
			init();
		}
	
		function destroy(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.destroy();
			}
		}
	
		function update(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.update();
			}
		}
	
		var autosize = null;
	
		// Do nothing in Node.js environment and IE8 (or lower)
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
			autosize = function (el) {
				return el;
			};
			autosize.destroy = function (el) {
				return el;
			};
			autosize.update = function (el) {
				return el;
			};
		} else {
			autosize = function (el, options) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], function (x) {
						return assign(x, options);
					});
				}
				return el;
			};
			autosize.destroy = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], destroy);
				}
				return el;
			};
			autosize.update = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], update);
				}
				return el;
			};
		}
	
		module.exports = autosize;
	});

/***/ }),
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.initialLoader = initialLoader;
	exports.enableServiceWorker = enableServiceWorker;
	exports.initSentry = initSentry;
	exports.windowIntlPolyfill = windowIntlPolyfill;
	exports.loadSVG = loadSVG;
	exports.loadFonts = loadFonts;
	exports.deviceTypeDetecting = deviceTypeDetecting;
	exports.redirectToAdminWebsite = redirectToAdminWebsite;
	exports.addIntercomIntegration = addIntercomIntegration;
	
	var _svg4everybody = __webpack_require__(6486);
	
	var _svg4everybody2 = _interopRequireDefault(_svg4everybody);
	
	var _nprogress = __webpack_require__(993);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _browser = __webpack_require__(602);
	
	var Sentry = _interopRequireWildcard(_browser);
	
	var _env = __webpack_require__(103);
	
	var _rotationHelper = __webpack_require__(4233);
	
	var _ga = __webpack_require__(4212);
	
	var _ga2 = _interopRequireDefault(_ga);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable promise/param-names,promise/avoid-new,compat/compat,immutable/no-mutation,jsx-control-statements/jsx-jcs-no-undef,max-len */
	var htmlNode = document.documentElement;
	
	function initialLoader() {
	  _nprogress2.default.configure({ showSpinner: false });
	
	  document.onreadystatechange = function () {
	    /*
	     * Disabling 'Loading...' state when the document gets the interactive mode
	     * */
	    if (document.readyState === 'interactive') {
	      htmlNode.classList.remove('html--initial');
	      document.getElementById('loading').remove();
	      document.getElementById('loading-style').remove();
	
	      if (_env.GOOGLE_ANALYTICS_ID) {
	        (0, _ga2.default)(_env.GOOGLE_ANALYTICS_ID);
	      }
	    }
	  };
	}
	
	function enableServiceWorker() {
	  /*
	   * Enable service workers in production mode
	   * */
	  /* eslint-disable global-require, import/no-extraneous-dependencies */
	  var runtime = __webpack_require__(5693);
	
	  runtime.install({
	    onUpdateReady: function onUpdateReady() {
	      runtime.applyUpdate();
	    }
	  });
	}
	
	function initSentry() {
	  Sentry.init({
	    dsn: _env.SENTRY_CLIENT_DNS,
	    environment: _env.ENV_NAME
	  });
	}
	
	function windowIntlPolyfill() {
	  return new _promise2.default(function (resolve, reject) {
	    if (!window.Intl) {
	      new _promise2.default(function (_resolve) {
	        _resolve(__webpack_require__(5345));
	      }).then(function () {
	        return _promise2.default.all([__webpack_require__(5347), __webpack_require__(5348)]);
	      }).then(function () {
	        return resolve();
	      }).catch(function (err) {
	        reject(err);
	        throw err;
	      });
	    } else {
	      resolve();
	    }
	  });
	}
	
	/*
	 * Loading contents of SVG as a string to inject it into the `#svg` in the <body> element and
	 * make SVG available inlined, not like an external resource. SVG MUST be cleaned up before
	 * to prevent unnecessary bandwidth losses and XSS
	 * */
	function loadSVG() {
	  __webpack_require__.e/* nsure */(35, function () {
	    /* eslint-disable global-require, import/no-unresolved, import/no-webpack-loader-syntax,
	    import/no-extraneous-dependencies */
	    document.getElementById('svg').innerHTML = __webpack_require__(5705);
	    (0, _svg4everybody2.default)({
	      polyfill: true
	    });
	    /* eslint-enable global-require, import/no-unresolved, import/no-webpack-loader-syntax,
	    import/no-extraneous-dependencies */
	  });
	}
	
	/*
	 * Async font loading and caching in localStorage
	 * https://github.com/bdadam/OptimizedWebfontLoading
	 * Described here: http://bdadam.com/blog/loading-webfonts-with-high-performance.html
	 * */
	function loadFonts() {
	  __webpack_require__.e/* nsure */(28, function () {
	    /* eslint-disable global-require */
	    var _require = __webpack_require__(18),
	        FONT_FAMILY = _require.FONT_FAMILY;
	
	    var loadFont = __webpack_require__(3917);
	    var woff = __webpack_require__(5312);
	    var woff2 = __webpack_require__(5313);
	    /* eslint-enable global-require */
	    loadFont(FONT_FAMILY.primary, woff, woff2);
	  });
	}
	
	/*
	 * Device type detecting to add specific class name to the <html> element. It helps to omit double
	 * tap issue at touch devices, when the hover styles applies at the first tap and the actions
	 * triggers at the second. See `handheld-hover` Stylus mixin for details
	 * */
	function deviceTypeDetecting() {
	  __webpack_require__.e/* nsure */(36, function () {
	    /* eslint-disable global-require */
	    var MobileDetect = __webpack_require__(5684);
	    /* eslint-enable global-require */
	    var md = new MobileDetect(window.navigator.userAgent);
	    var deviceTypeClassName = md.mobile() ? 'html--handheld' : 'html--notHandheld';
	    htmlNode.classList.add(deviceTypeClassName);
	
	    // iPhone 6s+ landscape mode handling
	    if (md.is('iPhone') && md.userAgent() === 'Safari') {
	      var supportsOrientationChange = 'onorientationchange' in window;
	      var orientationEvent = supportsOrientationChange ? 'orientationchange' : 'resize';
	
	      // initial landscape orientation
	      if (window.innerHeight < window.innerWidth) (0, _rotationHelper.setViewportHeight)();
	      // update on orientation change
	      window.addEventListener(orientationEvent, _rotationHelper.setViewportHeight, false);
	    }
	  });
	}
	
	function redirectToAdminWebsite() {
	  if (window.location.pathname === '/admin') {
	    window.location.replace(_env.ADMIN_URL);
	  }
	}
	
	function addIntercomIntegration() {
	  var APP_ID = _env.INTERCOM_CHAT_APP_ID;
	
	  (function () {
	    var w = window;
	    var ic = w.Intercom;
	    if (typeof ic === 'function') {
	      ic('reattach_activator');
	      ic('update', w.intercomSettings);
	    } else {
	      var d = document;
	      var i = function i() {
	        i.c(arguments);
	      };
	      i.q = [];
	      i.c = function (args) {
	        i.q.push(args);
	      };
	      w.Intercom = i;
	      var l = function l() {
	        var s = d.createElement('script');
	        s.type = 'text/javascript';
	        s.async = true;
	        s.src = 'https://widget.intercom.io/widget/' + APP_ID;
	        var x = d.getElementsByTagName('script')[0];
	        x.parentNode.insertBefore(s, x);
	      };
	      if (document.readyState === 'complete') {
	        l();
	      } else if (w.attachEvent) {
	        w.attachEvent('onload', l);
	      } else {
	        w.addEventListener('load', l, false);
	      }
	    }
	  })();
	
	  window.Intercom('boot', {
	    api_base: 'https://api-iam.intercom.io',
	    app_id: APP_ID
	  });
	}

/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _cryptoJs = __webpack_require__(4290);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	var _react = __webpack_require__(1);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _reactRedux = __webpack_require__(6);
	
	var _updateIntercom = __webpack_require__(4243);
	
	var _updateIntercom2 = _interopRequireDefault(_updateIntercom);
	
	var _selectors = __webpack_require__(23);
	
	var _env = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IntercomIntegration = function IntercomIntegration() {
	  var loggedUser = (0, _reactRedux.useSelector)(_selectors.loggedUserSelector);
	
	  var isUserLogged = (0, _keys2.default)(loggedUser).length > 0;
	
	  var email = (0, _get2.default)(loggedUser, 'email', '');
	
	  var phoneNumber = (0, _get2.default)(loggedUser, 'phoneNumber', '');
	
	  var emailReplace = '#' + phoneNumber + '@phone.com';
	
	  var emailValue = email || emailReplace;
	
	  var intercomData = {
	    email: emailValue,
	    user_hash: _cryptoJs2.default.HmacSHA256(emailValue, _env.INTERCOM_SECRET_KEY).toString(_cryptoJs2.default.enc.Hex)
	  };
	
	  (0, _react.useEffect)(function () {
	    var unlisten = function unlisten() {};
	
	    if (isUserLogged) {
	      unlisten = _browserHistory2.default.listen(function () {
	        (0, _updateIntercom2.default)(intercomData);
	      });
	    }
	
	    return function () {
	      unlisten();
	    };
	  }, [isUserLogged, intercomData]);
	
	  return null;
	};
	
	exports.default = IntercomIntegration;

/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _caregiver = __webpack_require__(297);
	
	var _constants = __webpack_require__(1278);
	
	var _privacyPolicies = __webpack_require__(1281);
	
	var _getLoggedUser = __webpack_require__(539);
	
	var _getTeamUser = __webpack_require__(876);
	
	var _chatConnection = __webpack_require__(183);
	
	var _sentryMethods = __webpack_require__(437);
	
	var _countries = __webpack_require__(1279);
	
	var _getGuardianDependents = __webpack_require__(353);
	
	var _appStateReq = __webpack_require__(526);
	
	var _selectors = __webpack_require__(93);
	
	var _selectors2 = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    // check progress
	    caregiver: state.circles.caregiver,
	    consts: state.data.constants,
	    // check conditions
	    authToken: (0, _selectors.authTokenSelector)(state),
	    loggedIn: (0, _selectors.isLoggedInSelector)(state),
	    loggedUser: (0, _selectors2.loggedUserSelector)(state),
	    getUserState: state.profiles.getUser,
	    teamUserId: (0, _selectors2.selectTeamUserId)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  connectChat: _chatConnection.actions.connect,
	  getCaregiverCircles: _caregiver.actions.send,
	  getConsts: _constants.actions.send,
	  getUser: _getLoggedUser.actions.send,
	  privacyPolicies: _privacyPolicies.actions.send,
	  getGuardianDependents: _getGuardianDependents.actions.send,
	  fetchAppState: _appStateReq.actions.send,
	  getTeamUser: _getTeamUser.actions.send,
	  getCountries: _countries.actions.send
	};
	
	var Requests = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
	  (0, _inherits3.default)(Requests, _React$Component);
	
	  function Requests() {
	    (0, _classCallCheck3.default)(this, Requests);
	    return (0, _possibleConstructorReturn3.default)(this, (Requests.__proto__ || (0, _getPrototypeOf2.default)(Requests)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Requests, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          authToken = _props.authToken,
	          loggedIn = _props.loggedIn,
	          loggedUser = _props.loggedUser;
	
	
	      var authTokenReceived = nextProps.authToken && !authToken;
	      var loginSucceed = nextProps.loggedIn && !loggedIn;
	      var loggedUserReceived = !(0, _isEmpty2.default)(nextProps.loggedUser) && (0, _isEmpty2.default)(loggedUser);
	
	      return authTokenReceived || loginSucceed || loggedUserReceived;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          caregiver = _props2.caregiver,
	          consts = _props2.consts,
	          authToken = _props2.authToken,
	          loggedIn = _props2.loggedIn,
	          loggedUser = _props2.loggedUser,
	          connectChat = _props2.connectChat,
	          getCaregiverCircles = _props2.getCaregiverCircles,
	          getConsts = _props2.getConsts,
	          getUserState = _props2.getUserState,
	          getUser = _props2.getUser,
	          privacyPolicies = _props2.privacyPolicies,
	          getGuardianDependents = _props2.getGuardianDependents,
	          fetchAppState = _props2.fetchAppState,
	          getTeamUser = _props2.getTeamUser,
	          getCountries = _props2.getCountries,
	          teamUserId = _props2.teamUserId;
	
	      // needs authToken
	
	      if (authToken && !consts.succeed && !consts.sending) getConsts();
	      getCountries();
	      privacyPolicies();
	      // needs authToken and loggedUser
	      if (loggedIn && !caregiver.succeed && !caregiver.sending) getCaregiverCircles();
	      if (loggedIn) {
	        getGuardianDependents();
	        fetchAppState();
	      }
	
	      // get user
	      // connect to app notifications
	      if (loggedIn && !getUserState.sending && !getUserState.succeed && (0, _get2.default)(loggedUser, 'id')) {
	        connectChat();
	        getUser({ id: (0, _get2.default)(loggedUser, 'id') });
	        var userId = (0, _get2.default)(loggedUser, 'id');
	
	        (0, _sentryMethods.setupSentryScope)({ id: userId });
	      }
	
	      if (teamUserId) {
	        getTeamUser({ id: teamUserId });
	      }
	
	      return null;
	    }
	  }]);
	  return Requests;
	}(_react2.default.Component)) || _class);
	exports.default = Requests;
	
	
	Requests.propTypes = {
	  caregiver: _propTypes2.default.shape({
	    sending: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }),
	  consts: _propTypes2.default.shape({
	    sending: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }),
	  // check conditions
	  authToken: _propTypes2.default.string,
	  loggedIn: _propTypes2.default.bool,
	  loggedUser: _propTypes2.default.shape({
	    primaryPatientProfile: _propTypes2.default.object
	  }),
	  // actions
	  connectChat: _propTypes2.default.func,
	  getCaregiverCircles: _propTypes2.default.func,
	  getConsts: _propTypes2.default.func,
	  getUser: _propTypes2.default.func,
	  getUserState: _propTypes2.default.shape({
	    sending: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }),
	  privacyPolicies: _propTypes2.default.func,
	  getGuardianDependents: _propTypes2.default.func,
	  getTeamUser: _propTypes2.default.func,
	  getCountries: _propTypes2.default.func,
	  fetchAppState: _propTypes2.default.func,
	  teamUserId: _propTypes2.default.number
	};
	
	Requests.defaultProps = {
	  caregiver: {},
	  consts: {},
	  authToken: '',
	  loggedIn: false,
	  loggedUser: {},
	  connectChat: function connectChat() {},
	  getCaregiverCircles: function getCaregiverCircles() {},
	  getConsts: function getConsts() {},
	  getUser: function getUser() {},
	  getUserState: {},
	  privacyPolicies: function privacyPolicies() {}
	};

/***/ }),
/* 3006 */,
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _Route = __webpack_require__(2809);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Router = __webpack_require__(2810);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	var _IndexRoute = __webpack_require__(2806);
	
	var _IndexRoute2 = _interopRequireDefault(_IndexRoute);
	
	var _IndexRedirect = __webpack_require__(2805);
	
	var _IndexRedirect2 = _interopRequireDefault(_IndexRedirect);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouterRedux = __webpack_require__(1037);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _nprogress = __webpack_require__(993);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _react3 = __webpack_require__(1067);
	
	var Sentry = _interopRequireWildcard(_react3);
	
	var _store = __webpack_require__(4171);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Login = __webpack_require__(3093);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _SignUp = __webpack_require__(3097);
	
	var _SignUp2 = _interopRequireDefault(_SignUp);
	
	var _ExpiredLink = __webpack_require__(3091);
	
	var _ExpiredLink2 = _interopRequireDefault(_ExpiredLink);
	
	var _Registration = __webpack_require__(3096);
	
	var _Registration2 = _interopRequireDefault(_Registration);
	
	var _AccessDenied = __webpack_require__(3080);
	
	var _AccessDenied2 = _interopRequireDefault(_AccessDenied);
	
	var _ExpiredToken = __webpack_require__(3092);
	
	var _ExpiredToken2 = _interopRequireDefault(_ExpiredToken);
	
	var _CreatePassword = __webpack_require__(3089);
	
	var _CreatePassword2 = _interopRequireDefault(_CreatePassword);
	
	var _ChangePassword = __webpack_require__(3088);
	
	var _ChangePassword2 = _interopRequireDefault(_ChangePassword);
	
	var _RecoverPassword = __webpack_require__(3095);
	
	var _RecoverPassword2 = _interopRequireDefault(_RecoverPassword);
	
	var _AuthPersonalInfo = __webpack_require__(3083);
	
	var _AuthPersonalInfo2 = _interopRequireDefault(_AuthPersonalInfo);
	
	var _BrowserSupportInfo = __webpack_require__(3086);
	
	var _BrowserSupportInfo2 = _interopRequireDefault(_BrowserSupportInfo);
	
	var _ExpiredConfirmation = __webpack_require__(3090);
	
	var _ExpiredConfirmation2 = _interopRequireDefault(_ExpiredConfirmation);
	
	var _AuthSignupInvitation = __webpack_require__(3085);
	
	var _AuthSignupInvitation2 = _interopRequireDefault(_AuthSignupInvitation);
	
	var _MainLayout = __webpack_require__(3382);
	
	var _MainLayout2 = _interopRequireDefault(_MainLayout);
	
	var _NotFound = __webpack_require__(3425);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _Profile = __webpack_require__(3609);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _PatientProfile = __webpack_require__(3604);
	
	var _PatientProfile2 = _interopRequireDefault(_PatientProfile);
	
	var _ProviderProfile = __webpack_require__(3634);
	
	var _ProviderProfile2 = _interopRequireDefault(_ProviderProfile);
	
	var _ProfileSettings = __webpack_require__(3630);
	
	var _ProfileSettings2 = _interopRequireDefault(_ProfileSettings);
	
	var _ProfilePaymentMethods = __webpack_require__(3628);
	
	var _ProfilePaymentMethods2 = _interopRequireDefault(_ProfilePaymentMethods);
	
	var _Support = __webpack_require__(3636);
	
	var _Support2 = _interopRequireDefault(_Support);
	
	var _ProfileDocumentation = __webpack_require__(3617);
	
	var _ProfileDocumentation2 = _interopRequireDefault(_ProfileDocumentation);
	
	var _DataSurveys = __webpack_require__(3247);
	
	var _DataSurveys2 = _interopRequireDefault(_DataSurveys);
	
	var _PatientInfo = __webpack_require__(3602);
	
	var _PatientInfo2 = _interopRequireDefault(_PatientInfo);
	
	var _TeamProfile = __webpack_require__(3638);
	
	var _TeamProfile2 = _interopRequireDefault(_TeamProfile);
	
	var _ProviderInfo = __webpack_require__(3632);
	
	var _ProviderInfo2 = _interopRequireDefault(_ProviderInfo);
	
	var _Requests = __webpack_require__(3005);
	
	var _Requests2 = _interopRequireDefault(_Requests);
	
	var _Community = __webpack_require__(1736);
	
	var _Community2 = _interopRequireDefault(_Community);
	
	var _CommunityPreview = __webpack_require__(3188);
	
	var _CommunityPreview2 = _interopRequireDefault(_CommunityPreview);
	
	var _DiscoverCommunities = __webpack_require__(3162);
	
	var _DiscoverCommunities2 = _interopRequireDefault(_DiscoverCommunities);
	
	var _index = __webpack_require__(3164);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _OrganizationCommunities = __webpack_require__(3168);
	
	var _OrganizationCommunities2 = _interopRequireDefault(_OrganizationCommunities);
	
	var _Activities = __webpack_require__(3153);
	
	var _Activities2 = _interopRequireDefault(_Activities);
	
	var _Reports = __webpack_require__(3176);
	
	var _Post = __webpack_require__(3558);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _CircleOfCare = __webpack_require__(3128);
	
	var _CircleOfCare2 = _interopRequireDefault(_CircleOfCare);
	
	var _PatientRegistrationInfo = __webpack_require__(3552);
	
	var _PatientRegistrationInfo2 = _interopRequireDefault(_PatientRegistrationInfo);
	
	var _PatientRegistrationContact = __webpack_require__(3549);
	
	var _PatientRegistrationContact2 = _interopRequireDefault(_PatientRegistrationContact);
	
	var _PatientRegistrationAddress = __webpack_require__(3546);
	
	var _PatientRegistrationAddress2 = _interopRequireDefault(_PatientRegistrationAddress);
	
	var _PatientEmergencyContact = __webpack_require__(3542);
	
	var _PatientEmergencyContact2 = _interopRequireDefault(_PatientEmergencyContact);
	
	var _Programs = __webpack_require__(3658);
	
	var _Programs2 = _interopRequireDefault(_Programs);
	
	var _Surveys = __webpack_require__(3741);
	
	var _Surveys2 = _interopRequireDefault(_Surveys);
	
	var _AppAlert = __webpack_require__(3816);
	
	var _AppAlert2 = _interopRequireDefault(_AppAlert);
	
	var _LanguageProvider = __webpack_require__(3381);
	
	var _LanguageProvider2 = _interopRequireDefault(_LanguageProvider);
	
	var _AppHelmet = __webpack_require__(3008);
	
	var _AppHelmet2 = _interopRequireDefault(_AppHelmet);
	
	var _offline = __webpack_require__(4222);
	
	var _routes = __webpack_require__(37);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _strings = __webpack_require__(15);
	
	var _persistentState = __webpack_require__(1898);
	
	var _selectors = __webpack_require__(93);
	
	var _selectors2 = __webpack_require__(23);
	
	var _fixVideoFullscreenScrolling = __webpack_require__(4209);
	
	var _fixVideoFullscreenScrolling2 = _interopRequireDefault(_fixVideoFullscreenScrolling);
	
	var _i18n = __webpack_require__(1219);
	
	var _reducers = __webpack_require__(1357);
	
	var _getMainConsent = __webpack_require__(875);
	
	var fetchMainConsent = _interopRequireWildcard(_getMainConsent);
	
	var _AppPopup = __webpack_require__(3818);
	
	var _AppPopup2 = _interopRequireDefault(_AppPopup);
	
	var _CustomToastsContainer = __webpack_require__(3848);
	
	var _ProfileDetails = __webpack_require__(3704);
	
	var _ProfileInfo = __webpack_require__(3705);
	
	var _DependentRole = __webpack_require__(3263);
	
	var _DependentRole2 = _interopRequireDefault(_DependentRole);
	
	var _DependentPersonalInfo = __webpack_require__(3259);
	
	var _DependentPersonalInfo2 = _interopRequireDefault(_DependentPersonalInfo);
	
	var _DependentDocuments = __webpack_require__(3250);
	
	var _DependentDocuments2 = _interopRequireDefault(_DependentDocuments);
	
	var _DependentGeneralInfo = __webpack_require__(3256);
	
	var _DependentGeneralInfo2 = _interopRequireDefault(_DependentGeneralInfo);
	
	var _DependentRelation = __webpack_require__(3261);
	
	var _DependentRelation2 = _interopRequireDefault(_DependentRelation);
	
	var _DependentComplete = __webpack_require__(3248);
	
	var _DependentComplete2 = _interopRequireDefault(_DependentComplete);
	
	var _DependentExistingUser = __webpack_require__(3252);
	
	var _DependentExistingUser2 = _interopRequireDefault(_DependentExistingUser);
	
	var _AppointmentUsers = __webpack_require__(3057);
	
	var _AppointmentUsers2 = _interopRequireDefault(_AppointmentUsers);
	
	var _AppointmentVisitType = __webpack_require__(3063);
	
	var _AppointmentVisitType2 = _interopRequireDefault(_AppointmentVisitType);
	
	var _AppointmentPublixInfo = __webpack_require__(3050);
	
	var _AppointmentPublixInfo2 = _interopRequireDefault(_AppointmentPublixInfo);
	
	var _AppointmentServices = __webpack_require__(3052);
	
	var _AppointmentServices2 = _interopRequireDefault(_AppointmentServices);
	
	var _AppointmentConsentForm = __webpack_require__(3011);
	
	var _AppointmentConsentForm2 = _interopRequireDefault(_AppointmentConsentForm);
	
	var _AppointmentPatientInfo = __webpack_require__(3034);
	
	var _AppointmentPatientInfo2 = _interopRequireDefault(_AppointmentPatientInfo);
	
	var _AppointmentPayment = __webpack_require__(3037);
	
	var _AppointmentPayment2 = _interopRequireDefault(_AppointmentPayment);
	
	var _AppointmentSummary = __webpack_require__(3054);
	
	var _AppointmentSummary2 = _interopRequireDefault(_AppointmentSummary);
	
	var _AppointmentVisitDetails = __webpack_require__(3061);
	
	var _AppointmentVisitDetails2 = _interopRequireDefault(_AppointmentVisitDetails);
	
	var _AppointmentPharmacy = __webpack_require__(3040);
	
	var _AppointmentPharmacy2 = _interopRequireDefault(_AppointmentPharmacy);
	
	var _HealthboardHome = __webpack_require__(3360);
	
	var _HealthboardHome2 = _interopRequireDefault(_HealthboardHome);
	
	var _AppointmentListTabs = __webpack_require__(1742);
	
	var _AppointmentListTabs2 = _interopRequireDefault(_AppointmentListTabs);
	
	var _AppointmentProviderHistory = __webpack_require__(3364);
	
	var _AppointmentProviderHistory2 = _interopRequireDefault(_AppointmentProviderHistory);
	
	var _DashboardPatientInfo = __webpack_require__(3237);
	
	var _DashboardPatientInfo2 = _interopRequireDefault(_DashboardPatientInfo);
	
	var _DashboardVisitInfo = __webpack_require__(3240);
	
	var _DashboardVisitInfo2 = _interopRequireDefault(_DashboardVisitInfo);
	
	var _AppointmentProviders = __webpack_require__(3048);
	
	var _AppointmentProviders2 = _interopRequireDefault(_AppointmentProviders);
	
	var _AppointmentMyProviders = __webpack_require__(1704);
	
	var _AppointmentMyProviders2 = _interopRequireDefault(_AppointmentMyProviders);
	
	var _AppointmentProviderDetails = __webpack_require__(3045);
	
	var _AppointmentProviderDetails2 = _interopRequireDefault(_AppointmentProviderDetails);
	
	var _AppointmentHealthInformation = __webpack_require__(3017);
	
	var _AppointmentHealthInformation2 = _interopRequireDefault(_AppointmentHealthInformation);
	
	var _AppointmentHealthInformationProvider = __webpack_require__(3019);
	
	var _AppointmentHealthInformationProvider2 = _interopRequireDefault(_AppointmentHealthInformationProvider);
	
	var _AppointmentOverview = __webpack_require__(3028);
	
	var _AppointmentOverview2 = _interopRequireDefault(_AppointmentOverview);
	
	var _VisitDetails = __webpack_require__(3808);
	
	var _VisitDetails2 = _interopRequireDefault(_VisitDetails);
	
	var _TodoListTabs = __webpack_require__(3366);
	
	var _TodoListTabs2 = _interopRequireDefault(_TodoListTabs);
	
	var _EmptyPage = __webpack_require__(3355);
	
	var _EmptyPage2 = _interopRequireDefault(_EmptyPage);
	
	var _VirtualVideoRoom = __webpack_require__(3793);
	
	var _VirtualVideoRoom2 = _interopRequireDefault(_VirtualVideoRoom);
	
	var _AppointmentOrganizations = __webpack_require__(3026);
	
	var _AppointmentOrganizations2 = _interopRequireDefault(_AppointmentOrganizations);
	
	var _ConsentDetailsPopup = __webpack_require__(3342);
	
	var _selectors3 = __webpack_require__(56);
	
	var _browserChecker = __webpack_require__(356);
	
	var _PatientHealthboard = __webpack_require__(1778);
	
	var _PatientHealthboard2 = _interopRequireDefault(_PatientHealthboard);
	
	var _storageKeys = __webpack_require__(215);
	
	var _MembershipPaymentInfoPopup = __webpack_require__(3654);
	
	var _MembershipPaymentInfoPopup2 = _interopRequireDefault(_MembershipPaymentInfoPopup);
	
	var _VideoCallEndPopup = __webpack_require__(3792);
	
	var _VideoCallEndPopup2 = _interopRequireDefault(_VideoCallEndPopup);
	
	var _DevicePermissionsPopup = __webpack_require__(3278);
	
	var _DevicePermissionsPopup2 = _interopRequireDefault(_DevicePermissionsPopup);
	
	var _VirtualTestCallModal = __webpack_require__(3799);
	
	var _VirtualTestCallModal2 = _interopRequireDefault(_VirtualTestCallModal);
	
	var _AppointmentLocations = __webpack_require__(3022);
	
	var _AppointmentLocations2 = _interopRequireDefault(_AppointmentLocations);
	
	var _SignUpAzure = __webpack_require__(3099);
	
	var _SignUpAzure2 = _interopRequireDefault(_SignUpAzure);
	
	var _AvailableTimeSlots = __webpack_require__(3065);
	
	var _AvailableTimeSlots2 = _interopRequireDefault(_AvailableTimeSlots);
	
	var _VirtualRoom = __webpack_require__(3764);
	
	var _VirtualRoom2 = _interopRequireDefault(_VirtualRoom);
	
	var _IntercomIntegration = __webpack_require__(3004);
	
	var _IntercomIntegration2 = _interopRequireDefault(_IntercomIntegration);
	
	var _Paperwork = __webpack_require__(3441);
	
	var _Paperwork2 = _interopRequireDefault(_Paperwork);
	
	var _AppointmentPaymentInfoPopup = __webpack_require__(3068);
	
	var _AppointmentPaymentInfoPopup2 = _interopRequireDefault(_AppointmentPaymentInfoPopup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-restricted-globals,consistent-return */
	var persistentState = (0, _persistentState.getPersistentState)(_store2.default);
	var store = (0, _store2.default)(persistentState);
	(0, _persistentState.initializePersistingState)(store, persistentState);
	(0, _offline.initializeOfflineHandling)(store);
	(0, _fixVideoFullscreenScrolling2.default)();
	
	window.ocstore = store;
	(0, _store.runRootSaga)(store);
	
	var loggedInGuard = function loggedInGuard(currentStore, replace) {
	  var _currentStore$getStat = currentStore.getState(),
	      auth = _currentStore$getStat.auth,
	      routing = _currentStore$getStat.routing;
	
	  var loggedIn = (0, _get2.default)(auth, 'status.loggedIn');
	  var pathname = (0, _get2.default)(routing, 'locationBeforeTransitions.pathname');
	  var isInvitation = pathname.includes('invitations');
	
	  if (!loggedIn && !isInvitation) {
	    store.dispatch({
	      type: _reducers.loginReferrerConsts.SET_LOGIN_REFERRER,
	      payload: {
	        referrer: location.pathname
	      }
	    });
	
	    window.storage.setItem(_storageKeys.REDIRECT_TO_PAGE, '' + location.pathname + (location.search || ''));
	
	    return replace(_routes2.default.LOGIN);
	  }
	
	  if (!(0, _browserChecker.isSupportedBrowser)()) {
	    return replace(_routes2.default.BROWSER_SUPPORT);
	  }
	};
	
	var rootGuard = function rootGuard(currentStore, replace) {
	  var state = currentStore.getState();
	
	  if ((0, _selectors.isLoggedInSelector)(state)) {
	    var url = state.routing.loginReferrer === _routes2.default.ROOT || !state.routing.loginReferrer ? _routes2.default.HEALTHBOARD : state.routing.loginReferrer;
	    return replace(url);
	  }
	};
	
	var mainConsentGuard = function mainConsentGuard(currentStore, replace) {
	  var state = currentStore.getState();
	  var currentUser = (0, _selectors2.loggedUserSelector)(state);
	  var isSignedMainConsent = (0, _selectors3.selectIsSignedMainConsentSelector)(state);
	
	  if (currentUser && !isSignedMainConsent) {
	    store.dispatch(fetchMainConsent.actions.send());
	    return replace('/' + _routes2.default.HEALTHBOARD);
	  }
	};
	
	var browserGuard = function browserGuard(replace) {
	  if (!(0, _browserChecker.isSupportedBrowser)()) {
	    return replace('/' + _routes2.default.BROWSER_SUPPORT);
	  }
	};
	
	var App = function App() {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(
	      _LanguageProvider2.default,
	      { messages: (0, _i18n.getTranslationMessages)() },
	      _react2.default.createElement(
	        'div',
	        { className: 'App relative' },
	        _react2.default.createElement(_CustomToastsContainer.CustomToastsContainer, null),
	        _react2.default.createElement(_AppHelmet2.default, null),
	        _react2.default.createElement(_Requests2.default, null),
	        _react2.default.createElement(_AppAlert2.default, null),
	        _react2.default.createElement(_AppPopup2.default, null),
	        _react2.default.createElement(_ConsentDetailsPopup.ConsentDetailsPopup, null),
	        _react2.default.createElement(_VirtualVideoRoom2.default, null),
	        _react2.default.createElement(_VideoCallEndPopup2.default, null),
	        _react2.default.createElement(_DevicePermissionsPopup2.default, null),
	        _react2.default.createElement(_VirtualTestCallModal2.default, null),
	        _react2.default.createElement(_MembershipPaymentInfoPopup2.default, null),
	        _react2.default.createElement(_AppointmentPaymentInfoPopup2.default, null),
	        _react2.default.createElement(_IntercomIntegration2.default, null),
	        _react2.default.createElement(
	          _Router2.default,
	          { history: (0, _reactRouterRedux.syncHistoryWithStore)(_browserHistory2.default, store) },
	          _react2.default.createElement(_Route2.default, {
	            path: _routes2.default.VIRTUAL_ROOM,
	            getComponent: function getComponent(nextState, cb) {
	              !/* require.ensure */(function () {
	                _nprogress2.default.start();
	                var VirtualCall = function VirtualCall() {
	                  return _react2.default.createElement(_VirtualRoom2.default, null);
	                };
	                cb(null, VirtualCall);
	                _nprogress2.default.done();
	              }(__webpack_require__));
	            }
	          }),
	          _react2.default.createElement(_Route2.default, {
	            path: _routes2.default.IN_OFFICE_VISIT,
	            getComponent: function getComponent(nextState, cb) {
	              __webpack_require__.e/* nsure */(22, function (require) {
	                _nprogress2.default.start();
	                var InOfficeVirtualVisit = __webpack_require__(3373).default;
	                cb(null, InOfficeVirtualVisit);
	                _nprogress2.default.done();
	              });
	            }
	          }),
	          _react2.default.createElement(_Route2.default, {
	            path: _routes2.default.CONNECTION_ROOM,
	            getComponent: function getComponent(nextState, cb) {
	              !/* require.ensure */(function () {
	                _nprogress2.default.start();
	                var VirtualCall = function VirtualCall() {
	                  return _react2.default.createElement(_VirtualRoom2.default, { connectionRoom: true });
	                };
	                cb(null, VirtualCall);
	                _nprogress2.default.done();
	              }(__webpack_require__));
	            }
	          }),
	          _react2.default.createElement(
	            _Route2.default,
	            { path: _routes.PAPERWORK + '/:uuid', component: _Paperwork2.default },
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_VISIT_DETAILS,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(10, function (require) {
	                  _nprogress2.default.start();
	                  var PaperworkVisitDetails = __webpack_require__(3448).default;
	                  cb(null, PaperworkVisitDetails);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_INSURANCE_DETAILS,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(23, function (require) {
	                  _nprogress2.default.start();
	                  var PaperworkInsuranceDetails = __webpack_require__(3445).default;
	                  cb(null, PaperworkInsuranceDetails);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_COMPLETE_YOUR_PROFILE,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(15, function (require) {
	                  _nprogress2.default.start();
	                  var CompleteYourProfile = __webpack_require__(3443).default;
	                  cb(null, CompleteYourProfile);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_GUARANTOR_INFORMATION,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(7, function (require) {
	                  _nprogress2.default.start();
	                  var GuarantorInformationDetails = __webpack_require__(3444).default;
	                  cb(null, GuarantorInformationDetails);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_PREFERRED_PHARMACY,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(18, function (require) {
	                  _nprogress2.default.start();
	                  var PreferredPharmacy = __webpack_require__(3449).default;
	                  cb(null, PreferredPharmacy);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_PRIMARY_CARE_PROVIDER,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(21, function (require) {
	                  _nprogress2.default.start();
	                  var PaperworkPrimaryCareProvider = __webpack_require__(3451).default;
	                  cb(null, PaperworkPrimaryCareProvider);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_ADDITIONAL_INFORMATION,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(11, function (require) {
	                  _nprogress2.default.start();
	                  var AdditionalInformation = __webpack_require__(3442).default;
	                  cb(null, AdditionalInformation);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_SIGN_CONSENT,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(19, function (require) {
	                  _nprogress2.default.start();
	                  var PaperworkSignConsent = __webpack_require__(3452).default;
	                  cb(null, PaperworkSignConsent);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_SUBMIT,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(5, function (require) {
	                  _nprogress2.default.start();
	                  var PaperworkSubmit = __webpack_require__(3453).default;
	                  cb(null, PaperworkSubmit);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes.PAPERWORK + '/:uuid/' + _routes.PAPERWORK_COMPLETE_VISIT_DETAILS,
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(4, function (require) {
	                  _nprogress2.default.start();
	                  var PaperworkCompletedVisitDetails = __webpack_require__(3447).default;
	                  cb(null, PaperworkCompletedVisitDetails);
	                  _nprogress2.default.done();
	                });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _Route2.default,
	            { path: _routes2.default.ROOT, component: _MainLayout2.default },
	            _react2.default.createElement(_IndexRoute2.default, {
	              onEnter: function onEnter(nextState, replace) {
	                loggedInGuard(store, replace);
	                rootGuard(store, replace);
	              },
	              component: function component() {
	                return _react2.default.createElement(
	                  'div',
	                  { style: { fontSize: '5em', padding: '1em' } },
	                  'Root page'
	                );
	              }
	            }),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.ROOT,
	                getComponent: function getComponent(nextState, cb) {
	                  __webpack_require__.e/* nsure */(0, function (require) {
	                    _nprogress2.default.start();
	                    var Auth = __webpack_require__(1710).default;
	                    cb(null, Auth);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.BROWSER_SUPPORT,
	                components: { children: _BrowserSupportInfo2.default }
	              })
	            ),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.ROOT,
	                getComponent: function getComponent(nextState, cb) {
	                  __webpack_require__.e/* nsure */(0/* duplicate */, function (require) {
	                    _nprogress2.default.start();
	                    var Auth = __webpack_require__(1710).default;
	                    cb(null, Auth);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.ACCESS_DENIED,
	                components: { children: _AccessDenied2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.ACCESS_DENIED_COMMUNITIES,
	                getComponent: function getComponent(nextState, cb) {
	                  !/* require.ensure */(function () {
	                    var forwardRoute = {
	                      name: _strings.COMMON.myCommunities,
	                      path: _routes2.default.COMMUNITIES
	                    };
	                    var ErrorScreen = function ErrorScreen() {
	                      return _react2.default.createElement(_AccessDenied2.default, { forwardRoute: forwardRoute });
	                    };
	                    cb(null, ErrorScreen);
	                  }(__webpack_require__));
	                }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.EXPIRED_TOKEN,
	                components: { children: _ExpiredToken2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.EXPIRED_LINK,
	                components: { children: _ExpiredLink2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DEFAULT_EXPIRED_LINK,
	                components: { children: _ExpiredLink2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.CONFIRMATION,
	                components: { children: _ExpiredConfirmation2.default }
	              }),
	              _react2.default.createElement(_Route2.default, { path: _routes2.default.LOGIN, components: { children: _Login2.default } }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.PERSONAL_INFO,
	                components: { children: _AuthPersonalInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.RESET_PASSWORD,
	                components: { children: _RecoverPassword2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.CHANGE_PASSWORD,
	                components: { children: _ChangePassword2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.CREATE_PASSWORD,
	                components: { children: _CreatePassword2.default }
	              }),
	              _react2.default.createElement(_Route2.default, { path: _routes2.default.SIGNUP, components: { children: _SignUp2.default } }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.SIGN_UP_AZURE,
	                components: { children: _SignUpAzure2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.ACCEPT_INVITATION,
	                components: { children: _Registration2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.SIGNUP_INVITATION,
	                components: { children: _AuthSignupInvitation2.default }
	              })
	            ),
	            _react2.default.createElement(_Route2.default, {
	              onEnter: function onEnter(nextState, replace) {
	                browserGuard(replace);
	              },
	              path: _routes2.default.COMMUNITY_PREVIEW + '/:communityId',
	              components: { children: _CommunityPreview2.default }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.MESSAGES,
	              onEnter: function onEnter(nextState, replace) {
	                loggedInGuard(store, replace);
	                mainConsentGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	
	                __webpack_require__.e/* nsure */(2, function (require) {
	                  var Messages = __webpack_require__(3409).default;
	                  cb(null, Messages);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.CIRCLE_OF_CARE + '/:id',
	              components: { children: _CircleOfCare2.default }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.PROGRAM + '/:id',
	              components: { children: _Programs2.default }
	            }),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.PATIENT_REGISTRATION,
	                onEnter: function onEnter(nextState, replace) {
	                  return loggedInGuard(store, replace);
	                },
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	                  __webpack_require__.e/* nsure */(30, function (require) {
	                    var PatientRegistration_ = __webpack_require__(3554).default;
	                    cb(null, PatientRegistration_);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_IndexRedirect2.default, { to: _routes2.default.CONTACT_INFO }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.CONTACT_INFO,
	                components: { children: _PatientRegistrationContact2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.PERSONAL_INFO,
	                components: { children: _PatientRegistrationInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.ADDRESS,
	                components: { children: _PatientRegistrationAddress2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.EMERGENCY_CONTACT,
	                components: { children: _PatientEmergencyContact2.default }
	              })
	            ),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.SURVEYS_GENERAL_SUB_PATH + '/:contextId',
	              components: { children: _Surveys2.default }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.CIRCLES,
	              onEnter: function onEnter(nextState, replace) {
	                return loggedInGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	
	                __webpack_require__.e/* nsure */(8, function (require) {
	                  var CirclesLayout = __webpack_require__(3147).default;
	                  cb(null, CirclesLayout);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.APP_NOTIFICATIONS,
	              onEnter: function onEnter(nextState, replace) {
	                return loggedInGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	
	                __webpack_require__.e/* nsure */(12, function (require) {
	                  var DependentManagement = __webpack_require__(3276).default;
	                  cb(null, DependentManagement);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.DASHBOARD,
	              onEnter: function onEnter(nextState, replace) {
	                return loggedInGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	                __webpack_require__.e/* nsure */(6, function (require) {
	                  var Component = __webpack_require__(3234).default;
	                  cb(null, Component);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.COMMUNITIES,
	                onEnter: function onEnter(nextState, replace) {
	                  return loggedInGuard(store, replace);
	                },
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	
	                  __webpack_require__.e/* nsure */(25, function (require) {
	                    var Communities = __webpack_require__(3177).default;
	                    cb(null, Communities);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_IndexRedirect2.default, { to: _routes2.default.DISCOVER }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DISCOVER + '/' + _routes2.default.ORGANIZATION,
	                components: { children: _OrganizationCommunities2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DISCOVER,
	                components: { children: _DiscoverCommunities2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.MY_COMMUNITIES,
	                components: { children: _index2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.ACTIVITIES,
	                components: { children: _Activities2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.REPORTS,
	                components: { children: _Reports.Reports }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':communityId',
	                components: { children: _Community2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':communityId/' + _routes2.default.NOT_FOUND,
	                component: _NotFound2.default
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':communityId/' + _routes2.default.POST + '/:postId',
	                components: { children: _Post2.default }
	              })
	            ),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.PUBLIC_PROFILE,
	                onEnter: function onEnter(nextState, replace) {
	                  return loggedInGuard(store, replace);
	                },
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	                  __webpack_require__.e/* nsure */(26, function (require) {
	                    var PublicProfile = __webpack_require__(3708).default;
	                    cb(null, PublicProfile);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_Route2.default, {
	                path: ':id',
	                components: { children: _ProfileDetails.PublicProfileDetails }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.PUBLIC_PROFILE_INFO,
	                components: { children: _ProfileInfo.PublicProfileInfo }
	              })
	            ),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.PATIENT_HEALTHBOARD,
	              onEnter: function onEnter(nextState, replace) {
	                return loggedInGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	                !/* require.ensure */(function (require) {
	                  var Component = __webpack_require__(1778).default;
	                  cb(null, Component);
	                  _nprogress2.default.done();
	                }(__webpack_require__));
	              }
	            }),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.HEALTHBOARD,
	                onEnter: function onEnter(nextState, replace) {
	                  return loggedInGuard(store, replace);
	                },
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	                  __webpack_require__.e/* nsure */(24, function (require) {
	                    var Component = __webpack_require__(3368).default;
	                    cb(null, Component);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_IndexRoute2.default, {
	                onEnter: function onEnter(nextState, replace) {
	                  return replace(_routes2.default.HEALTHBOARD + '/' + (0, _selectors2.loggedUserIdSelector)(store.getState()) + '/' + _routes2.default.HEALTHBOARD_HOME);
	                }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.HEALTHBOARD_HOME,
	                components: { children: _HealthboardHome2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.HEALTHBOARD_TODO,
	                components: { children: _TodoListTabs2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.HEALTHBOARD_APPOINTMENTS,
	                components: { children: _AppointmentListTabs2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.HEALTHBOARD_APPOINTMENTS_HISTORY,
	                components: { children: _AppointmentProviderHistory2.default }
	              })
	            ),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.HEALTHBOARD_EMPTY,
	              components: { children: _EmptyPage2.default }
	            }),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.DEPENDENT_FORM,
	                onEnter: function onEnter(nextState, replace) {
	                  return loggedInGuard(store, replace);
	                },
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	                  __webpack_require__.e/* nsure */(32, function (require) {
	                    var DependentForm = __webpack_require__(3265).default;
	                    cb(null, DependentForm);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_IndexRedirect2.default, { to: _routes2.default.DEPENDENT_FORM_ROLE }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DEPENDENT_FORM_ROLE,
	                components: { children: _DependentRole2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DEPENDENT_FORM_PERSONAL,
	                components: { children: _DependentPersonalInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DEPENDENT_FORM_GENERAL,
	                components: { children: _DependentGeneralInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DEPENDENT_FORM_DOCUMENTS,
	                components: { children: _DependentDocuments2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DEPENDENT_FORM_RELATION,
	                components: { children: _DependentRelation2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DEPENDENT_FORM_COMPLETE,
	                components: { children: _DependentComplete2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DEPENDENT_FORM_EXISTING,
	                components: { children: _DependentExistingUser2.default }
	              })
	            ),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.APPOINTMENT_FORM,
	                onEnter: function onEnter(nextState, replace) {
	                  return loggedInGuard(store, replace);
	                },
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	                  __webpack_require__.e/* nsure */(27, function (require) {
	                    var Root = __webpack_require__(3078).default;
	                    cb(null, Root);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_IndexRedirect2.default, { to: _routes2.default.APPOINTMENT_FORM_USERS }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_USERS,
	                components: { children: _AppointmentUsers2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_ORGANIZATIONS,
	                components: { children: _AppointmentOrganizations2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_VISIT_TYPE,
	                components: { children: _AppointmentVisitType2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_PUBLIX_INFO,
	                components: { children: _AppointmentPublixInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_VISIT_SERVICES,
	                components: { children: _AppointmentServices2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_VISIT_LOCATIONS,
	                components: { children: _AppointmentLocations2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_CONSENT_FORM,
	                components: { children: _AppointmentConsentForm2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_PHARMACY,
	                components: { children: _AppointmentPharmacy2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_HEALTH_INFO,
	                components: { children: _AppointmentHealthInformation2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_HEALTH_INFO_PROVIDER,
	                components: {
	                  children: _AppointmentHealthInformationProvider2.default
	                }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_PAYMENT,
	                components: { children: _AppointmentPayment2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_PATIENT_INFO,
	                components: { children: _AppointmentPatientInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_VISIT_DETAILS,
	                components: { children: _AppointmentVisitDetails2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_EMERGENCY_CONTACT,
	                getComponent: function getComponent(nextState, cb) {
	                  __webpack_require__.e/* nsure */(17, function (require) {
	                    var AppointmentEmergencyContact = __webpack_require__(3012).default;
	                    cb(null, AppointmentEmergencyContact);
	                  });
	                }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_GUARANTOR_INFORMATION,
	                getComponent: function getComponent(nextState, cb) {
	                  __webpack_require__.e/* nsure */(9, function (require) {
	                    var AppointmentGuarantorInformation = __webpack_require__(3013).default;
	                    cb(null, AppointmentGuarantorInformation);
	                  });
	                }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_ADDITIONAL_INFO,
	                getComponent: function getComponent(nextState, cb) {
	                  __webpack_require__.e/* nsure */(13, function (require) {
	                    var AppointmentAdditionalInfo = __webpack_require__(3009).default;
	                    cb(null, AppointmentAdditionalInfo);
	                  });
	                }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_PROVIDERS,
	                components: { children: _AppointmentProviders2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_MY_PROVIDERS,
	                getComponent: function getComponent(nextState, cb) {
	                  !/* require.ensure */(function () {
	                    _nprogress2.default.start();
	                    var MyRescheduleProviders = function MyRescheduleProviders() {
	                      return _react2.default.createElement(_AppointmentMyProviders2.default, { fullView: true });
	                    };
	                    cb(null, MyRescheduleProviders);
	                    _nprogress2.default.done();
	                  }(__webpack_require__));
	                }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_AVAILABLE_TIME_SLOTS,
	                components: { children: _AvailableTimeSlots2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_PROVIDER_DETAILS,
	                components: { children: _AppointmentProviderDetails2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_OVERVIEW,
	                components: { children: _AppointmentOverview2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_SUMMARY,
	                components: { children: _AppointmentSummary2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.APPOINTMENT_FORM_INSURANCE_FORM,
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	                  __webpack_require__.e/* nsure */(34, function (require) {
	                    var AppointmentInsuranceFullForm = __webpack_require__(3020).default;
	                    cb(null, AppointmentInsuranceFullForm);
	                    _nprogress2.default.done();
	                  });
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.DASHBOARD_RECORD,
	                onEnter: function onEnter(nextState, replace) {
	                  return loggedInGuard(store, replace);
	                },
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	                  __webpack_require__.e/* nsure */(33, function (require) {
	                    var DashboardRecord = __webpack_require__(3242).default;
	                    cb(null, DashboardRecord);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_IndexRedirect2.default, { to: _routes2.default.PATIENT_INFO }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.PATIENT_INFO,
	                components: { children: _DashboardPatientInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: _routes2.default.DASHBOARD_VISIT_INFO,
	                components: { children: _DashboardVisitInfo2.default }
	              })
	            ),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.CHOOSE_ADD_ACCOUNT,
	              onEnter: function onEnter(nextState, replace) {
	                return loggedInGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	                __webpack_require__.e/* nsure */(16, function (require) {
	                  var DashboardRecord = __webpack_require__(3564).default;
	                  cb(null, DashboardRecord);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.VIRTUAL_VISIT,
	                onEnter: function onEnter(nextState, replace) {
	                  return loggedInGuard(store, replace);
	                },
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	                  __webpack_require__.e/* nsure */(31, function (require) {
	                    var VirtualVisit = __webpack_require__(3810).default;
	                    cb(null, VirtualVisit);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_Route2.default, {
	                path: ':userId/' + _routes2.default.DETAILS,
	                components: { children: _VisitDetails2.default }
	              })
	            ),
	            _react2.default.createElement(
	              _Route2.default,
	              {
	                path: _routes2.default.PROFILE,
	                onEnter: function onEnter(nextState, replace) {
	                  return loggedInGuard(store, replace);
	                },
	                getComponent: function getComponent(nextState, cb) {
	                  _nprogress2.default.start();
	                  __webpack_require__.e/* nsure */(20, function (require) {
	                    var ProfileLayout = __webpack_require__(3644).default;
	                    cb(null, ProfileLayout);
	                    _nprogress2.default.done();
	                  });
	                }
	              },
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.CIRCLE_OF_CARE,
	                components: { children: _CircleOfCare2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.SURVEYS_GENERAL_SUB_PATH,
	                components: { children: _DataSurveys2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PROGRAM,
	                components: { children: _Programs2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PROFILE_DOCUMENTATION,
	                components: { children: _ProfileDocumentation2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PROFILE_SETTINGS,
	                components: { children: _ProfileSettings2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PROFILE_PAYMENT_METHODS,
	                components: { children: _ProfilePaymentMethods2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.SUPPORT,
	                components: { children: _Support2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PATIENT_INFO,
	                components: { children: _PatientInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PROVIDER_INFO,
	                components: { children: _ProviderInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PATIENT_HEALTHBOARD,
	                components: { children: _PatientHealthboard2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PROVIDER_PROFILE + '/:memberId/' + _routes2.default.PROVIDER_INFO,
	                components: { children: _ProviderInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PROVIDER_MEMBER_PROFILE + '/:memberId/' + _routes2.default.PROVIDER_INFO,
	                components: { children: _ProviderInfo2.default }
	              }),
	              _react2.default.createElement(_Route2.default, {
	                path: ':id/' + _routes2.default.PARENT_PROVIDER + '/:memberId/' + _routes2.default.PROVIDER_INFO,
	                components: { children: _ProviderInfo2.default }
	              }),
	              _react2.default.createElement(
	                _Route2.default,
	                { path: ':id', components: { children: _Profile2.default } },
	                _react2.default.createElement(_Route2.default, {
	                  path: _routes2.default.PATIENT_PROFILE,
	                  components: { children: _PatientProfile2.default }
	                }),
	                _react2.default.createElement(_Route2.default, {
	                  path: _routes2.default.PROVIDER_PROFILE,
	                  components: { children: _ProviderProfile2.default }
	                }),
	                _react2.default.createElement(_Route2.default, {
	                  path: _routes2.default.USER_PROFILE,
	                  components: { children: _PatientProfile2.default }
	                }),
	                _react2.default.createElement(_Route2.default, {
	                  path: _routes2.default.PATIENT_PROFILE + '-view',
	                  components: { children: _PatientProfile2.default }
	                }),
	                _react2.default.createElement(_Route2.default, {
	                  path: _routes2.default.FAMILY_MEMBER_PROFILE + '/:memberId',
	                  components: { children: _PatientProfile2.default }
	                }),
	                _react2.default.createElement(_Route2.default, {
	                  path: _routes2.default.PROVIDER_PROFILE + '/:memberId',
	                  components: { children: _ProviderProfile2.default }
	                }),
	                _react2.default.createElement(_Route2.default, {
	                  path: _routes2.default.PROVIDER_MEMBER_PROFILE + '/:memberId',
	                  components: { children: _ProviderProfile2.default }
	                }),
	                _react2.default.createElement(_Route2.default, {
	                  path: _routes2.default.TEAM_MEMBER_PROFILE + '/:memberId',
	                  components: { children: _TeamProfile2.default }
	                }),
	                _react2.default.createElement(_Route2.default, {
	                  path: _routes2.default.PARENT_PROVIDER + '/:memberId',
	                  components: { children: _ProviderProfile2.default }
	                })
	              )
	            ),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.PROVIDER_CALENDAR,
	              onEnter: function onEnter(nextState, replace) {
	                return loggedInGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	                __webpack_require__.e/* nsure */(3, function (require) {
	                  var Calendar = __webpack_require__(3701).default;
	                  cb(null, Calendar);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: '/:id/:providerId/test',
	              onEnter: function onEnter(nextState, replace) {
	                return loggedInGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	                __webpack_require__.e/* nsure */(14, function (require) {
	                  var Calendar = __webpack_require__(3675).default;
	                  cb(null, Calendar);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.CALENDAR_MOB,
	              onEnter: function onEnter(nextState, replace) {
	                return loggedInGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	                __webpack_require__.e/* nsure */(29, function (require) {
	                  var MobileView = __webpack_require__(3680).default;
	                  cb(null, MobileView);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: _routes2.default.APPOINTMENTS + '/:id',
	              onEnter: function onEnter(nextState, replace) {
	                return loggedInGuard(store, replace);
	              },
	              getComponent: function getComponent(nextState, cb) {
	                _nprogress2.default.start();
	                __webpack_require__.e/* nsure */(37, function (require) {
	                  var Appointments = __webpack_require__(3079).default;
	                  cb(null, Appointments);
	                  _nprogress2.default.done();
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, {
	              path: 'styleguide',
	              getComponent: function getComponent(nextState, cb) {
	                __webpack_require__.e/* nsure */(38, function (require) {
	                  var StyleGuide = __webpack_require__(3006).default;
	                  cb(null, StyleGuide);
	                });
	              }
	            }),
	            _react2.default.createElement(_Route2.default, { path: '*', component: _NotFound2.default })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Sentry.withProfiler(App);

/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactHelmet = __webpack_require__(1615);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _metadata = __webpack_require__(291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reactIntl.injectIntl)(function (_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	  return _react2.default.createElement(_reactHelmet2.default, (0, _extends3.default)({}, (0, _metadata.getAppMetadata)(formatMessage)));
	});

/***/ }),
/* 3009 */,
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	var _progressTypes = __webpack_require__(55);
	
	var _consentReq = __webpack_require__(505);
	
	var consent = _interopRequireWildcard(_consentReq);
	
	var _selectors = __webpack_require__(43);
	
	var _styles = __webpack_require__(4890);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loading: (0, _selectors.selectConsentFormPending)(state),
	    url: (0, _selectors.selectConsentFormUrl)(state),
	    userId: (0, _selectors.selectProgressCareUserId)(state),
	    visitType: (0, _selectors.selectProgressVisitType)(state),
	    service: (0, _selectors.selectProgressService)(state),
	    locationId: (0, _selectors.selectProgressScheduleLocationId)(state),
	    consentsData: (0, _selectors.selectConsentFormData)(state),
	    consentsLoading: (0, _selectors.selectConsentFormPending)(state),
	    organizationName: (0, _selectors.selectProgressScheduleProviderOrganizationName)(state),
	    isUrgentVisitFlow: (0, _selectors.selectProgressIsUrgentVisitFlow)(state),
	    rescheduleData: (0, _selectors.selectProgressRescheduleData)(state),
	    provider: (0, _selectors.selectProgressScheduleProvider)(state)
	  };
	};
	var mapDispatchToProps = {
	  fetchConsent: consent.actions.send,
	  inspectConsent: _progressTypes.appointmentProgressActions.inspectConsent,
	  openModalConsents: _appointmentConsentModal.appointmentConsentsModalActions.open
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var rescheduleData = _ref.rescheduleData,
	      provider = _ref.provider;
	  return {
	    providerId: (0, _get2.default)(provider, 'id'),
	    isRescheduleFlow: !!(0, _get2.default)(rescheduleData, 'id', null)
	  };
	}), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _enhance = __webpack_require__(3010);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _useNavigateToPreviousPage = __webpack_require__(230);
	
	var _useNavigateToPreviousPage2 = _interopRequireDefault(_useNavigateToPreviousPage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentConsentForm(_ref) {
	  var loading = _ref.loading,
	      fetchConsent = _ref.fetchConsent,
	      userId = _ref.userId,
	      consentsData = _ref.consentsData,
	      visitType = _ref.visitType,
	      service = _ref.service,
	      locationId = _ref.locationId,
	      consentsLoading = _ref.consentsLoading,
	      openModalConsents = _ref.openModalConsents,
	      organizationName = _ref.organizationName,
	      isUrgentVisitFlow = _ref.isUrgentVisitFlow,
	      isRescheduleFlow = _ref.isRescheduleFlow,
	      providerId = _ref.providerId;
	
	  (0, _usePageView.usePageView)('Get Care | Sign Consent Form');
	
	  var _useNavigateToPreviou = (0, _useNavigateToPreviousPage2.default)(),
	      navigateToPrevPage = _useNavigateToPreviou.navigateToPrevPage;
	
	  (0, _react.useEffect)(function () {
	    fetchConsent({
	      locationId: locationId,
	      serviceId: service.id,
	      visitTypeCode: visitType.code,
	      userId: userId
	    });
	  }, []);
	
	  var handleBack = function handleBack() {
	    if (isRescheduleFlow) {
	      return (0, _redirectUtils.redirectToRescheduleProviderDetails)({
	        providerId: providerId,
	        locationId: locationId
	      });
	    }
	
	    return navigateToPrevPage();
	  };
	
	  (0, _react.useEffect)(function () {
	    if (consentsData && !consentsData.allSigned) {
	      var consents = consentsData.consents;
	
	      var allConsents = consents.filter(function (_ref2) {
	        var accepted = _ref2.accepted;
	        return !accepted;
	      });
	
	      openModalConsents({
	        consent: allConsents[0],
	        organizationName: organizationName,
	        allConsents: allConsents,
	        patientUserInfoId: userId,
	        urgentVisitFlow: isUrgentVisitFlow,
	        selfSchedulingFlow: !isUrgentVisitFlow,
	        rescheduleFlow: {
	          providerId: providerId,
	          isRescheduleFlow: isRescheduleFlow,
	          locationId: locationId
	        }
	      });
	    }
	
	    if (!consentsLoading && consentsData && consentsData.allSigned) {
	      isUrgentVisitFlow ? (0, _redirectUtils.redirectToPharmacy)() : (0, _redirectUtils.redirectToAppointmentOverview)();
	    }
	  }, [consentsData, consentsLoading, isUrgentVisitFlow]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.consent' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      title: 'appointments.form.consentForm',
	      handleBack: handleBack
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      loading && _react2.default.createElement(_Loader2.default, null)
	    )
	  );
	}
	
	AppointmentConsentForm.propTypes = {
	  fetchConsent: PropTypes.func,
	  loading: PropTypes.bool,
	  userId: PropTypes.number,
	  consentsData: PropTypes.object,
	  visitType: PropTypes.object,
	  service: PropTypes.object,
	  consentsLoading: PropTypes.bool,
	  openModalConsents: PropTypes.func,
	  organizationName: PropTypes.string,
	  isUrgentVisitFlow: PropTypes.bool,
	  isRescheduleFlow: PropTypes.bool,
	  providerId: PropTypes.number,
	  locationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentConsentForm);

/***/ }),
/* 3012 */,
/* 3013 */,
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usePCPField = undefined;
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SingleSelect = __webpack_require__(257);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _styles = __webpack_require__(4891);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usePCPField = exports.usePCPField = function usePCPField(_ref) {
	  var details = _ref.details,
	      formatMessage = _ref.formatMessage,
	      pcpProviderAnswer = _ref.pcpProviderAnswer;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      pcpAnswer = _useState2[0],
	      setPcpAnswer = _useState2[1];
	
	  var hasPrimaryCareProvider = (0, _get2.default)(details, 'hasPrimaryCareProvider', true);
	  var shouldContinue = Boolean(hasPrimaryCareProvider || !hasPrimaryCareProvider && pcpAnswer || pcpProviderAnswer !== 'N');
	  var providerQuestion = formatMessage({
	    id: 'profile.fields.helpFindProvider'
	  });
	  var answers = {
	    S: formatMessage({ id: 'common.yes' }),
	    N: formatMessage({ id: 'common.no' })
	  };
	  var list = (0, _entries2.default)(answers).map(function (_ref2) {
	    var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	        k = _ref3[0],
	        v = _ref3[1];
	
	    return {
	      label: v,
	      value: k
	    };
	  });
	
	  var handleOptionChange = (0, _react.useCallback)(function (value) {
	    setPcpAnswer(value);
	  }, []);
	
	  var PCPField = function PCPField(_ref4) {
	    var children = _ref4.children;
	    return children;
	  };
	
	  var renderPcpField = (0, _react.useMemo)(function () {
	    return _react2.default.createElement(
	      PCPField,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.questions },
	        providerQuestion
	      ),
	      _react2.default.createElement(_SingleSelect2.default, {
	        name: 'pcpQ',
	        list: list,
	        radioInputClass: _styles2.default.list,
	        onChange: handleOptionChange,
	        selectedValue: pcpAnswer
	      })
	    );
	  }, []);
	
	  return hasPrimaryCareProvider || pcpProviderAnswer !== 'N' ? { shouldContinue: shouldContinue } : {
	    pcpAnswer: pcpAnswer,
	    shouldContinue: shouldContinue,
	    renderPcpField: renderPcpField
	  };
	};

/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _debounce = __webpack_require__(176);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _enhance = __webpack_require__(3016);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _hooks = __webpack_require__(3014);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _makeOptionalLabel = __webpack_require__(1928);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HealthInformationForm(_ref) {
	  var details = _ref.details,
	      updateData = _ref.updateData,
	      setHealthInfo = _ref.setHealthInfo,
	      medicationSearch = _ref.medicationSearch,
	      fetchMedications = _ref.fetchMedications,
	      loadMoreMedications = _ref.loadMoreMedications,
	      healthConditionsList = _ref.healthConditionsList,
	      clearMedicationSearch = _ref.clearMedicationSearch,
	      medicationAllergiesList = _ref.medicationAllergiesList,
	      formatMessage = _ref.intl.formatMessage,
	      pcpProviderAnswer = _ref.pcpProviderAnswer;
	
	  var offsetRef = (0, _react.useRef)(0);
	  var primaryPatientProfile = details.primaryPatientProfile,
	      id = details.id;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      medicationQuery = _useState2[0],
	      setMedicationQuery = _useState2[1];
	
	  var _ref2 = primaryPatientProfile || {},
	      healthConditions = _ref2.healthConditions,
	      medicationAllergies = _ref2.medicationAllergies;
	
	  var patientProfileNdcDrugs = (0, _get2.default)(primaryPatientProfile, 'patientProfileNdcDrugs', []);
	
	  var _useState3 = (0, _react.useState)(medicationAllergies),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      allegries = _useState4[0],
	      setAllergies = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(patientProfileNdcDrugs),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      currentMedications = _useState6[0],
	      setCurrentMedications = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(healthConditions),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      healthConditionsValue = _useState8[0],
	      setHealthConditionsValue = _useState8[1];
	
	  var handleNext = function handleNext(e) {
	    e.preventDefault();
	
	    setHealthInfo({
	      pcpProviderAnswer: pcpAnswer || pcpProviderAnswer,
	      medicationAllergies: allegries,
	      ndcDrugIds: currentMedications,
	      healthConditions: healthConditionsValue
	    });
	
	    updateData();
	  };
	
	  var handleMedicationsSearch = (0, _debounce2.default)(function (text) {
	    offsetRef.current = 0;
	    clearMedicationSearch();
	
	    if (text.length < 3) return;
	    setMedicationQuery(text);
	
	    fetchMedications({
	      userId: id,
	      limit: 10,
	      query: text,
	      offset: offsetRef.current
	    });
	  }, 1000);
	
	  var loadMore = (0, _react.useCallback)((0, _debounce2.default)(function () {
	    loadMoreMedications({
	      userId: id,
	      query: medicationQuery,
	      offset: offsetRef.current
	    });
	    offsetRef.current += 10;
	  }, 100), [id, medicationQuery]);
	
	  var getSafeNdcDrugs = patientProfileNdcDrugs.map(function (drug) {
	    return {
	      id: drug.ndcDrugId,
	      name: drug.displayableName
	    };
	  });
	
	  var filterFormSelectOptions = function filterFormSelectOptions(selectData) {
	    return selectData.filter(function (el) {
	      return el.value.enabled;
	    });
	  };
	
	  var renderMedicationSearch = (0, _react.useMemo)(function () {
	    return _react2.default.createElement(_SelectCustom2.default, {
	      multi: true,
	      className: 'mt3',
	      id: 'currentMedications',
	      options: medicationSearch,
	      defaultValue: getSafeNdcDrugs,
	      onMenuScrollToBottom: loadMore,
	      onInputChange: handleMedicationsSearch,
	      onChange: function onChange(select) {
	        return setCurrentMedications(select.map(function (el) {
	          return el.value.id;
	        }));
	      },
	      label: (0, _makeOptionalLabel.makeOptionalLabel)('common.currentMedications', formatMessage),
	      placeholder: formatMessage({
	        id: 'common.currentMedications'
	      })
	    });
	  }, [getSafeNdcDrugs, medicationSearch.length]);
	
	  var _usePCPField = (0, _hooks.usePCPField)({
	    details: details,
	    formatMessage: formatMessage,
	    pcpProviderAnswer: pcpProviderAnswer
	  }),
	      pcpAnswer = _usePCPField.pcpAnswer,
	      renderPcpField = _usePCPField.renderPcpField,
	      shouldContinue = _usePCPField.shouldContinue;
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleNext },
	    renderPcpField,
	    _react2.default.createElement(_SelectCustom2.default, {
	      multi: true,
	      className: 'mt3',
	      id: 'healthConditions',
	      options: filterFormSelectOptions(healthConditionsList),
	      defaultValue: healthConditionsValue,
	      onChange: function onChange(select) {
	        return setHealthConditionsValue(select.map(function (el) {
	          return el.value;
	        }));
	      },
	      label: (0, _makeOptionalLabel.makeOptionalLabel)('profile.fields.healthConditions', formatMessage),
	      placeholder: formatMessage({ id: 'profile.fields.healthConditions' })
	    }),
	    _react2.default.createElement(_SelectCustom2.default, {
	      multi: true,
	      className: 'mt3',
	      id: 'medicationAllergies',
	      defaultValue: allegries,
	      options: filterFormSelectOptions(medicationAllergiesList),
	      onChange: function onChange(select) {
	        return setAllergies(select.map(function (el) {
	          return el.value;
	        }));
	      },
	      label: (0, _makeOptionalLabel.makeOptionalLabel)('profile.fields.medicationAllergies', formatMessage),
	      placeholder: formatMessage({
	        id: 'profile.fields.medicationAllergies'
	      })
	    }),
	    renderMedicationSearch,
	    _react2.default.createElement(
	      'div',
	      { className: 'mt4 tr' },
	      _react2.default.createElement(
	        _Button2.default,
	        { raised: true, color: 'primary', disabled: !shouldContinue },
	        formatMessage({ id: 'common.next' })
	      )
	    )
	  );
	}
	
	HealthInformationForm.propTypes = {
	  intl: _propTypes2.default.object,
	  details: _propTypes2.default.object,
	  updateData: _propTypes2.default.func,
	  setHealthInfo: _propTypes2.default.func,
	  fetchMedications: _propTypes2.default.func,
	  medicationSearch: _propTypes2.default.array,
	  loadMoreMedications: _propTypes2.default.func,
	  healthConditionsList: _propTypes2.default.array,
	  clearMedicationSearch: _propTypes2.default.func,
	  medicationAllergiesList: _propTypes2.default.array,
	  pcpProviderAnswer: _propTypes2.default.string
	};
	
	exports.default = (0, _enhance.enhance)(HealthInformationForm);

/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _progressTypes = __webpack_require__(55);
	
	var _medicationsReq = __webpack_require__(627);
	
	var _selectors = __webpack_require__(50);
	
	var _selectors2 = __webpack_require__(43);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    details: (0, _selectors2.selectProgressCareUser)(state),
	    medicationSearch: (0, _selectors2.selectMedicationSearchData)(state),
	    healthConditionsList: (0, _selectors.selectHealthConditions)(state),
	    medicationAllergiesList: (0, _selectors.selectMedicationAllergies)(state),
	    pcpProviderAnswer: (0, _selectors2.selectPcpProviderAnswer)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchMedications: _medicationsReq.actions.send,
	  loadMoreMedications: _medicationsReq.actions.loadMore,
	  clearMedicationSearch: _medicationsReq.actions.clear,
	  setHealthInfo: _progressTypes.appointmentProgressActions.setHealthInfo,
	  updateData: _progressTypes.appointmentProgressActions.updateNecessaryData
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HealthInformationForm = __webpack_require__(3015);
	
	var _HealthInformationForm2 = _interopRequireDefault(_HealthInformationForm);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _useNavigateToPreviousPage = __webpack_require__(230);
	
	var _useNavigateToPreviousPage2 = _interopRequireDefault(_useNavigateToPreviousPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentHealthInformation() {
	  (0, _usePageView.usePageView)('Get Care | Health Information');
	
	  var _useNavigateToPreviou = (0, _useNavigateToPreviousPage2.default)(),
	      navigateToPrevPage = _useNavigateToPreviou.navigateToPrevPage;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.health' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      title: 'profile.section.health',
	      handleBack: navigateToPrevPage
	    }),
	    _react2.default.createElement(_HealthInformationForm2.default, null)
	  );
	}
	
	exports.default = AppointmentHealthInformation;

/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _PrimaryCareProviderForm = __webpack_require__(3898);
	
	var _PrimaryCareProviderForm2 = _interopRequireDefault(_PrimaryCareProviderForm);
	
	var _PrimaryCareProviderWithExtraFieldsForm = __webpack_require__(1850);
	
	var _PrimaryCareProviderWithExtraFieldsForm2 = _interopRequireDefault(_PrimaryCareProviderWithExtraFieldsForm);
	
	var _selectors = __webpack_require__(43);
	
	var _progressTypes = __webpack_require__(55);
	
	var _getPCPDictionaries = __webpack_require__(358);
	
	var _index = __webpack_require__(4892);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _usePrimaryCareProviderData = __webpack_require__(1849);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HealthInformationProviderForm() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var isEirVisitType = (0, _reactRedux.useSelector)(_selectors.selectIsEirVisitTypeCode);
	
	  var eirVisitTypePCPFormData = (0, _reactRedux.useSelector)(_selectors.selectEirVisitTypePCPFormData);
	
	  var organizationId = (0, _reactRedux.useSelector)(_selectors.selectProgressOrganizationId);
	
	  var providerQuestion = formatMessage({
	    id: 'profile.fields.doYouHavePCP'
	  });
	
	  var _usePrimaryCareProvid = (0, _usePrimaryCareProviderData.usePrimaryCareProviderData)({
	    isPaperworkFlow: false
	  }),
	      primaryProviderPreloadedData = _usePrimaryCareProvid.primaryProviderPreloadedData;
	
	  var initialValues = (0, _react.useMemo)(function () {
	    if (!eirVisitTypePCPFormData) return null;
	
	    return {
	      pcpProviderAnswer: eirVisitTypePCPFormData.pcpProviderAnswer,
	      pcpName: eirVisitTypePCPFormData.pcpName,
	      considerUsPcp: (0, _getPCPDictionaries.getInitialPcpFormConsiderUsPcpValue)(eirVisitTypePCPFormData.considerUsPcp),
	      pcp: (0, _getPCPDictionaries.convertPrimaryCareProviderDataToFormOption)(eirVisitTypePCPFormData.primaryCareProvider, eirVisitTypePCPFormData.pcpName, formatMessage)
	    };
	  }, [eirVisitTypePCPFormData]);
	
	  var handleNext = (0, _react.useCallback)(function (formData) {
	    if (isEirVisitType) {
	      var payload = {
	        pcpProviderAnswer: formData.pcpProviderAnswer,
	        pcpName: formData.pcpName,
	        considerUsPcp: (0, _getPCPDictionaries.getConsiderUsAsYourPCPPayload)(formData),
	        primaryCareProvider: formData.pcp
	      };
	
	      dispatch(_progressTypes.appointmentProgressActions.setPrimaryCareProviderFormData(payload));
	    } else {
	      dispatch(_progressTypes.appointmentProgressActions.setHaveCareProviderAnswer({
	        pcpProviderAnswer: formData
	      }));
	    }
	
	    dispatch(_progressTypes.appointmentProgressActions.determineNextStepAfterHealthInfoProvider());
	  }, [isEirVisitType]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.questions },
	      providerQuestion
	    ),
	    isEirVisitType ? _react2.default.createElement(_PrimaryCareProviderWithExtraFieldsForm2.default, {
	      handleNext: handleNext,
	      initialValues: initialValues || primaryProviderPreloadedData,
	      organizationId: organizationId
	    }) : _react2.default.createElement(_PrimaryCareProviderForm2.default, { handleNext: handleNext })
	  );
	}
	
	exports.default = HealthInformationProviderForm;

/***/ }),
/* 3019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _HealthInformationProviderForm = __webpack_require__(3018);
	
	var _HealthInformationProviderForm2 = _interopRequireDefault(_HealthInformationProviderForm);
	
	var _usePageView = __webpack_require__(52);
	
	var _useNavigateToPreviousPage = __webpack_require__(230);
	
	var _useNavigateToPreviousPage2 = _interopRequireDefault(_useNavigateToPreviousPage);
	
	var _ids = __webpack_require__(46);
	
	var _submitForm = __webpack_require__(1937);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentHealthInformationProvider() {
	  (0, _usePageView.usePageView)('Get Care | Health Information');
	
	  var _useNavigateToPreviou = (0, _useNavigateToPreviousPage2.default)(),
	      navigateToPrevPage = _useNavigateToPreviou.navigateToPrevPage;
	
	  var handleNavigateToPrevPage = function handleNavigateToPrevPage() {
	    var form = document.forms[_ids.IDS.PCP_QUESTIONS_WITH_EXTRA_FIELDS_FORM];
	
	    if (!form) {
	      navigateToPrevPage();
	      return;
	    }
	
	    var onSubmitPreventReload = function onSubmitPreventReload(e) {
	      e.preventDefault();
	      navigateToPrevPage();
	    };
	
	    form.addEventListener('submit', onSubmitPreventReload, { once: true });
	
	    if (typeof form.requestSubmit === 'function') {
	      form.requestSubmit();
	    } else {
	      (0, _submitForm.submitForm)(form);
	    }
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.health' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      title: 'profile.section.health',
	      handleBack: handleNavigateToPrevPage
	    }),
	    _react2.default.createElement(_HealthInformationProviderForm2.default, null)
	  );
	}
	
	exports.default = AppointmentHealthInformationProvider;

/***/ }),
/* 3020 */,
/* 3021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _progressTypes = __webpack_require__(55);
	
	var _selectors = __webpack_require__(43);
	
	var _inspectionReq = __webpack_require__(293);
	
	var inspectReq = _interopRequireWildcard(_inspectionReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    locations: (0, _selectors.selectProgressLocationsByVisit)(state),
	    visitType: (0, _selectors.selectProgressVisitType)(state),
	    careUser: (0, _selectors.selectProgressCareUser)(state)
	  };
	};
	var mapDispatchToProps = {
	  setLocation: _progressTypes.appointmentProgressActions.setLocation,
	  inspectAll: inspectReq.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _constants = __webpack_require__(17);
	
	var _getFullLocationAdress = __webpack_require__(1707);
	
	var _enhance = __webpack_require__(3021);
	
	var _styles = __webpack_require__(4893);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentLocations(_ref) {
	  var setLocation = _ref.setLocation,
	      locations = _ref.locations,
	      visitType = _ref.visitType,
	      inspectAll = _ref.inspectAll,
	      careUser = _ref.careUser,
	      formatMessage = _ref.intl.formatMessage;
	
	  (0, _usePageView.usePageView)('Get Care | Locations');
	
	  var isPublixInfo = visitType.code === _constants.PUBLIX_CODE;
	
	  var handleLocationSelect = function handleLocationSelect(location) {
	    if (!isPublixInfo) {
	      setLocation(location);
	      inspectAll({
	        userId: careUser.id,
	        inspectionFor: [_constants.APPOINTMENT_INSPECTION.LOCAL_PROFILE]
	      });
	    }
	  };
	
	  var getAddressAndPhone = function getAddressAndPhone(location) {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      (0, _getFullLocationAdress.getFullAdress)(location),
	      isPublixInfo && location.phone ? _react2.default.createElement(
	        'span',
	        null,
	        ', ' + location.phone
	      ) : ''
	    );
	  };
	
	  var getWaitTime = function getWaitTime(location) {
	    return !!location.approximateWaitTime && _react2.default.createElement(
	      'span',
	      null,
	      formatMessage({ id: 'appointmentForm.appointmentLocations.waitTime' }),
	      ': \xA0',
	      _react2.default.createElement(
	        'strong',
	        null,
	        location.approximateWaitTime,
	        ' ',
	        formatMessage({
	          id: 'appointmentForm.appointmentLocations.minutes'
	        })
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.locations' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      type: 'name',
	      title: 'visitType.locations',
	      typeName: visitType.name,
	      handleBack: _redirectUtils.redirectToVisitType
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      locations.map(function (location) {
	        return _react2.default.createElement(_Shape2.default, {
	          key: location.id,
	          className: !isPublixInfo ? _styles2.default.location : _styles2.default.location + ' ' + _styles2.default.pointer,
	          onClick: function onClick() {
	            return handleLocationSelect(location);
	          },
	          renderPrimary: function renderPrimary() {
	            return location.name;
	          },
	          renderSecondary: function renderSecondary() {
	            return getAddressAndPhone(location);
	          },
	          renderRight: function renderRight() {
	            return getWaitTime(location);
	          }
	        });
	      })
	    )
	  );
	}
	
	AppointmentLocations.propTypes = {
	  setLocation: PropTypes.func,
	  locations: PropTypes.arrayOf(PropTypes.shape({
	    id: PropTypes.number,
	    name: PropTypes.string,
	    phone: PropTypes.string,
	    address: PropTypes.string,
	    city: PropTypes.string,
	    code: PropTypes.string,
	    state: PropTypes.string,
	    zip: PropTypes.string,
	    approximateWaitTime: PropTypes.number
	  })),
	  visitType: PropTypes.object,
	  inspectAll: PropTypes.func,
	  careUser: PropTypes.object,
	  intl: { formatMessage: PropTypes.func }
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentLocations);

/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _InfoPopover = __webpack_require__(773);
	
	var _InfoPopover2 = _interopRequireDefault(_InfoPopover);
	
	var _styles = __webpack_require__(18);
	
	var _IconButton = __webpack_require__(605);
	
	var _appointment = __webpack_require__(286);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProviderDetails(_ref) {
	  var provider = _ref.provider,
	      formatMessage = _ref.formatMessage,
	      languageTypes = _ref.languageTypes;
	
	  var _useReducer = (0, _react.useReducer)(function (open) {
	    return !open;
	  }, false),
	      _useReducer2 = (0, _slicedToArray3.default)(_useReducer, 2),
	      isOpened = _useReducer2[0],
	      toggleTooltip = _useReducer2[1];
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      anchor = _useState2[0],
	      setAnchor = _useState2[1];
	
	  var handleOpenProviderInfo = function handleOpenProviderInfo(e) {
	    e.stopPropagation();
	    setAnchor(e.currentTarget);
	    toggleTooltip();
	  };
	
	  var list = (0, _react.useMemo)(function () {
	    return (0, _appointment.getMyProviderDetails)(formatMessage, provider, languageTypes);
	  }, [provider, languageTypes]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_IconButton.IconButton, {
	      size: 12,
	      className: 'ml2 dib',
	      name: 'info-default',
	      fill: _styles.COLORS.blueDark,
	      onClick: handleOpenProviderInfo
	    }),
	    _react2.default.createElement(_InfoPopover2.default, {
	      list: list,
	      isOpen: isOpened,
	      anchorEl: anchor,
	      onClose: function onClose() {
	        return toggleTooltip();
	      },
	      description: provider.greeting
	    })
	  );
	}
	
	ProviderDetails.propTypes = {
	  provider: PropTypes.object,
	  formatMessage: PropTypes.func,
	  languageTypes: PropTypes.array
	};
	
	exports.default = ProviderDetails;

/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _myProvidersReq = __webpack_require__(338);
	
	var _selectors = __webpack_require__(43);
	
	var _selectors2 = __webpack_require__(50);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userId: (0, _selectors.selectProgressCareUserId)(state),
	    loading: (0, _selectors.selectMyProvidersLoading)(state),
	    paginationLoading: (0, _selectors.selectMyProvidersPaginationLoading)(state),
	    providers: (0, _selectors.selectMyProvidersList)(state),
	    organizationId: (0, _selectors.selectProgressOrganizationId)(state),
	    languageTypes: (0, _selectors2.selectLanguageTypes)(state),
	    providersCount: (0, _selectors.selectMyProvidersCount)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchMyProviders: _myProvidersReq.actions.send,
	  loadMoreMyProviders: _myProvidersReq.actions.loadMore,
	  initRescheduleFlow: _myProvidersReq.actions.selectMyProvider
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _progressTypes = __webpack_require__(55);
	
	var _selectors = __webpack_require__(43);
	
	var _myProvidersReq = __webpack_require__(338);
	
	var myProviders = _interopRequireWildcard(_myProvidersReq);
	
	var _withCareUserSubtitle = __webpack_require__(603);
	
	var _withCareUserSubtitle2 = _interopRequireDefault(_withCareUserSubtitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    organizations: (0, _selectors.selectSchedulingTreeOrganizations)(state)
	  };
	};
	var mapDispatchToProps = {
	  myProvidersInit: myProviders.actions.init,
	  setActiveOrganization: _progressTypes.appointmentProgressActions.setOrganization
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, _withCareUserSubtitle2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _styles = __webpack_require__(2240);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _enhance = __webpack_require__(3025);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentOrganizations(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      setActiveOrganization = _ref.setActiveOrganization,
	      myProvidersInit = _ref.myProvidersInit,
	      organizations = _ref.organizations,
	      subtitle = _ref.subtitle;
	
	  (0, _usePageView.usePageView)('Get Care | Choose Organization');
	
	  var handleSelect = function handleSelect(organization) {
	    setActiveOrganization(organization);
	    myProvidersInit(organization);
	  };
	
	  function renderImage(logo) {
	    return function () {
	      return _react2.default.createElement('img', {
	        alt: 'organization',
	        style: { width: 40 },
	        src: (0, _get2.default)(logo, 'thumbMin')
	      });
	    };
	  }
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.organization' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      title: 'appointments.chooseOrganization',
	      subtitle: subtitle,
	      handleBack: _redirectUtils.redirectToUsers
	    }),
	    organizations.map(function (organization) {
	      return _react2.default.createElement(_Shape2.default, {
	        onClick: function onClick() {
	          return handleSelect(organization);
	        },
	        renderPrimary: function renderPrimary() {
	          return organization.name;
	        },
	        renderLeft: renderImage(organization.logo),
	        key: organization.id
	      });
	    }),
	    !organizations.length && _react2.default.createElement(_Content2.default, {
	      className: _styles2.default.emptyBlock,
	      text: formatMessage({ id: 'appointments.emptyOrganizations' }),
	      icon: 'search-list'
	    })
	  );
	}
	
	AppointmentOrganizations.propTypes = {
	  setActiveOrganization: PropTypes.func,
	  myProvidersInit: PropTypes.func,
	  organizations: PropTypes.array,
	  subtitle: PropTypes.object,
	  intl: PropTypes.object
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentOrganizations);

/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(17);
	
	var _selectors = __webpack_require__(43);
	
	var _progressTypes = __webpack_require__(55);
	
	var _confirmVisitSelfSchedulingReq = __webpack_require__(504);
	
	var confirmVisitSelfScheduling = _interopRequireWildcard(_confirmVisitSelfSchedulingReq);
	
	var _confirmVisitGWReq = __webpack_require__(503);
	
	var confirmVisitGW = _interopRequireWildcard(_confirmVisitGWReq);
	
	var _consentReq = __webpack_require__(505);
	
	var consent = _interopRequireWildcard(_consentReq);
	
	var _inlineVisitsTimeSlots = __webpack_require__(506);
	
	var inlineVisitTimeSlots = _interopRequireWildcard(_inlineVisitsTimeSlots);
	
	var _confirmInlineVisit = __webpack_require__(622);
	
	var confirmInlineVisit = _interopRequireWildcard(_confirmInlineVisit);
	
	var _fetchCopay = __webpack_require__(1226);
	
	var fetchCopay = _interopRequireWildcard(_fetchCopay);
	
	var _createEirUrgentCareAppointment = __webpack_require__(624);
	
	var _selectors2 = __webpack_require__(64);
	
	var _paperworkAdditionalInfo = __webpack_require__(421);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    careUser: (0, _selectors.selectProgressCareUser)(state),
	    consentsData: (0, _selectors.selectConsentFormData)(state),
	    createEirUrgentCareAppointmentPending: (0, _selectors.selectCreateEirUrgentCareAppointmentPending)(state),
	    fetchScheduleIdPending: (0, _selectors.selectProviderGWDetailsPending)(state),
	    insuranceEligibilityId: (0, _selectors.selectProgressInsuranceEligibilityId)(state) || (0, _selectors.selectInsuranceEligibilityId)(state),
	    isConfirmedInlineVisit: (0, _selectors.selectSuccessConfirmInlineVisit)(state),
	    isEirVisitType: (0, _selectors.selectIsEirVisitTypeCode)(state),
	    isGWFlow: (0, _selectors.selectProgressIsCreateFlowGW)(state),
	    loading: (0, _selectors.selectConfirmVisitPending)(state),
	    loadingGW: (0, _selectors.selectConfirmVisitGWPending)(state),
	    loadingTimeSlots: (0, _selectors.selectInlineVisitTimeSlotsPending)(state),
	    location: (0, _selectors.selectProgressLocation)(state),
	    locationId: (0, _selectors.selectProgressScheduleLocationId)(state),
	    organization: (0, _selectors.selectProgressOrganization)(state),
	    price: (0, _selectors.selectCopayPrice)(state),
	    pharmacyId: (0, _selectors.selectPreferredPharmacy)(state),
	    programBasedVisitId: (0, _selectors.selectProgramBasedVisitId)(state),
	    provider: (0, _selectors.selectProgressScheduleProvider)(state),
	    reason: (0, _selectors.selectReasonForOverview)(state),
	    rescheduleData: (0, _selectors.selectProgressRescheduleData)(state),
	    schedule: (0, _selectors.selectProgressSchedule)(state),
	    scheduleId: (0, _selectors.selectProgressScheduleId)(state),
	    selfScheduleConfirmPending: (0, _selectors.selectSelfSchedulingConfirmPending)(state),
	    service: (0, _selectors.selectProgressService)(state),
	    timeSlots: (0, _selectors.selectInlineVisitTimeSlots)(state),
	    visitType: (0, _selectors.selectProgressVisitType)(state),
	    pcpFormData: (0, _selectors.selectEirVisitTypePCPFormData)(state),
	    isConsentDataFetching: (0, _selectors.selectConsentFormPending)(state),
	    additionalInfoFormData: (0, _selectors.selectAdditionalInfoFormData)(state) || (0, _selectors2.selectUpcomingAppointmentList)(state).find(function (_ref) {
	      var id = _ref.id;
	      return id === (0, _selectors2.selectActiveAppointmentId)(state);
	    }),
	    showPaperworkAppointmentQuestionStep: (0, _paperworkAdditionalInfo.selectShowPaperworkAppointmentQuestionStep)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  clearProgressConsents: consent.actions.clear,
	  confirmInlineVisit: confirmInlineVisit.actions.send,
	  confirmVisit: confirmVisitSelfScheduling.actions.send,
	  confirmVisitGW: confirmVisitGW.actions.send,
	  createEirUrgentCareAppointment: _createEirUrgentCareAppointment.actions.send,
	  fetchConsent: consent.actions.send,
	  fetchCopay: fetchCopay.actions.send,
	  getAvailableTimeSlots: inlineVisitTimeSlots.actions.send,
	  setScheduleData: _progressTypes.appointmentProgressActions.setScheduleData
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref2) {
	  var rescheduleData = _ref2.rescheduleData;
	  return {
	    isRescheduleFlow: !!(0, _get2.default)(rescheduleData, 'id', null)
	  };
	}), (0, _recompose.lifecycle)({
	  componentDidMount: function componentDidMount() {
	    var _props = this.props,
	        careUser = _props.careUser,
	        consentsData = _props.consentsData,
	        fetchConsent = _props.fetchConsent,
	        locationId = _props.locationId,
	        service = _props.service,
	        visitType = _props.visitType;
	
	
	    var isUrgentVirtualVisit = visitType.code === _constants.URGENT_VISIT_TYPE_CODE;
	
	    if (!consentsData && !isUrgentVirtualVisit) fetchConsent({
	      serviceId: service.id,
	      locationId: locationId,
	      visitTypeCode: visitType.code,
	      userId: careUser.id
	    });
	  }
	}));

/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _VisitOverview = __webpack_require__(1706);
	
	var _VisitOverview2 = _interopRequireDefault(_VisitOverview);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _CompleteInlineVisitModal = __webpack_require__(3066);
	
	var _CompleteInlineVisitModal2 = _interopRequireDefault(_CompleteInlineVisitModal);
	
	var _useOverviewRows2 = __webpack_require__(3029);
	
	var _usePageView = __webpack_require__(52);
	
	var _useNavigateToPreviousPage = __webpack_require__(230);
	
	var _useNavigateToPreviousPage2 = _interopRequireDefault(_useNavigateToPreviousPage);
	
	var _selectors = __webpack_require__(43);
	
	var _constants = __webpack_require__(17);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _convertAdditionalInfoDataToRequestPayload = __webpack_require__(1907);
	
	var _convertAdditionalInfoDataToRequestPayload2 = _interopRequireDefault(_convertAdditionalInfoDataToRequestPayload);
	
	var _enhance = __webpack_require__(3027);
	
	var _styles = __webpack_require__(4895);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _gerPCPData = __webpack_require__(1908);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentOverview(_ref) {
	  var careUser = _ref.careUser,
	      clearProgressConsents = _ref.clearProgressConsents,
	      confirmInlineVisit = _ref.confirmInlineVisit,
	      confirmVisit = _ref.confirmVisit,
	      confirmVisitGW = _ref.confirmVisitGW,
	      consentsData = _ref.consentsData,
	      createEirUrgentCareAppointment = _ref.createEirUrgentCareAppointment,
	      createEirUrgentCareAppointmentPending = _ref.createEirUrgentCareAppointmentPending,
	      fetchCopay = _ref.fetchCopay,
	      fetchScheduleIdPending = _ref.fetchScheduleIdPending,
	      formatMessage = _ref.formatMessage,
	      getAvailableTimeSlots = _ref.getAvailableTimeSlots,
	      insuranceEligibilityId = _ref.insuranceEligibilityId,
	      isConfirmedInlineVisit = _ref.isConfirmedInlineVisit,
	      isConsentDataFetching = _ref.isConsentDataFetching,
	      isEirVisitType = _ref.isEirVisitType,
	      isGWFlow = _ref.isGWFlow,
	      pharmacyId = _ref.pharmacyId,
	      isRescheduleFlow = _ref.isRescheduleFlow,
	      loading = _ref.loading,
	      loadingGW = _ref.loadingGW,
	      loadingTimeSlots = _ref.loadingTimeSlots,
	      location = _ref.location,
	      locationId = _ref.locationId,
	      organization = _ref.organization,
	      pcpFormData = _ref.pcpFormData,
	      price = _ref.price,
	      programBasedVisitId = _ref.programBasedVisitId,
	      provider = _ref.provider,
	      reason = _ref.reason,
	      schedule = _ref.schedule,
	      scheduleId = _ref.scheduleId,
	      selfScheduleConfirmPending = _ref.selfScheduleConfirmPending,
	      service = _ref.service,
	      setScheduleData = _ref.setScheduleData,
	      subtitle = _ref.subtitle,
	      timeSlots = _ref.timeSlots,
	      visitType = _ref.visitType,
	      _ref$additionalInfoFo = _ref.additionalInfoFormData,
	      additionalInfoFormData = _ref$additionalInfoFo === undefined ? {} : _ref$additionalInfoFo,
	      showPaperworkAppointmentQuestionStep = _ref.showPaperworkAppointmentQuestionStep;
	
	  var language = (0, _reactRedux.useSelector)(_selectors.selectPreferredLanguage);
	  var guarantorUserId = (0, _reactRedux.useSelector)(_selectors.selectUserPrimaryPatientProfileGuarantorId);
	
	  var isInlineVisit = _constants.INLINE_TYPES.includes(visitType.code);
	
	  var submitBtnTitle = isInlineVisit ? formatMessage({ id: 'submit.getInLine' }) : formatMessage({ id: 'submit.fillProfile' });
	
	  var cancelBtnTitle = isInlineVisit ? formatMessage({ id: 'common.changeTime' }) : formatMessage({ id: 'common.cancel' });
	
	  (0, _usePageView.usePageView)('Get Care | Appointment Overview');
	
	  var _useNavigateToPreviou = (0, _useNavigateToPreviousPage2.default)(),
	      navigateToPrevPage = _useNavigateToPreviou.navigateToPrevPage;
	
	  (0, _react.useEffect)(function () {
	    if (isInlineVisit) {
	      getAvailableTimeSlots({
	        reasonTypeId: reason.id,
	        serviceId: service.id,
	        locationId: location.id
	      });
	    }
	  }, [isInlineVisit, reason, service, location]);
	
	  (0, _react.useEffect)(function () {
	    if (timeSlots && timeSlots.length > 0 && !schedule.time) {
	      setScheduleData({ time: timeSlots[0] });
	    }
	  }, [timeSlots, schedule]);
	
	  (0, _react.useEffect)(function () {
	    if (isInlineVisit || isEirVisitType) return;
	
	    var timeSlotsSource = (0, _get2.default)(schedule, 'provider.timeSlotsSource', null) || (0, _get2.default)(schedule, 'timeSlotsSource', null);
	
	    fetchCopay({
	      locationId: locationId,
	      date: schedule.time,
	      userId: careUser.id,
	      serviceId: service.id,
	      visitTypeId: visitType.id,
	      insuranceEligibilityResultId: insuranceEligibilityId,
	      timeSlotsSource: timeSlotsSource
	    });
	  }, [isInlineVisit, isEirVisitType, locationId, service.id, careUser.id, visitType.id, schedule.time, schedule.provider, insuranceEligibilityId, schedule.timeSlotsSource]);
	
	  var makeAppointmentEntity = (0, _react.useMemo)(function () {
	    return function () {
	      return {
	        service: service,
	        providerInfo: provider,
	        dateTime: schedule.time,
	        consentsAssignment: (0, _extends3.default)({}, consentsData && (0, _extends3.default)({}, consentsData))
	      };
	    };
	  }, [consentsData, service, provider, schedule]);
	
	  var _useOverviewRows = (0, _useOverviewRows2.useOverviewRows)({
	    price: price,
	    reason: reason,
	    service: service,
	    provider: provider,
	    location: location,
	    schedule: schedule,
	    visitType: visitType,
	    formatMessage: formatMessage,
	    appointment: makeAppointmentEntity()
	  }),
	      rows = _useOverviewRows.rows;
	
	  var visitTypeName = isInlineVisit ? visitType.name + ' ' + formatMessage({
	    id: 'common.visit'
	  }) : visitType.name;
	
	  var allLoadings = loading || loadingGW || fetchScheduleIdPending || selfScheduleConfirmPending || loadingTimeSlots || createEirUrgentCareAppointmentPending || isConsentDataFetching;
	
	  var handleRedirect = function handleRedirect(inlineRedirect) {
	    if (!isInlineVisit) clearProgressConsents();
	
	    if (isRescheduleFlow) {
	      return (0, _redirectUtils.redirectToRescheduleProviderDetails)({
	        locationId: locationId,
	        providerId: provider.id
	      });
	    }
	
	    if (isInlineVisit) {
	      if (showPaperworkAppointmentQuestionStep) {
	        (0, _redirectUtils.redirectToAdditionalInformation)();
	        return;
	      }
	
	      inlineRedirect();
	      return;
	    }
	
	    return (0, _redirectUtils.redirectToProviders)();
	  };
	
	  var handleCancel = function handleCancel() {
	    return handleRedirect(_redirectUtils.redirectToAvailableTimeSlots);
	  };
	
	  var handleConfirm = function handleConfirm() {
	    var additionalParams = reason.isHomeLocationDifferent ? {
	      country: reason.country,
	      state: reason.state
	    } : {};
	
	    var convertedAdditionalInfoData = (0, _convertAdditionalInfoDataToRequestPayload2.default)(additionalInfoFormData);
	
	    if (isInlineVisit) {
	      confirmInlineVisit((0, _extends3.default)({
	        note: reason.note,
	        serviceId: service.id,
	        reasonTypeId: reason.id,
	        organizationId: organization.id,
	        locationId: location.id,
	        dateTime: schedule.time,
	        userId: careUser.id
	      }, additionalParams, insuranceEligibilityId && {
	        insuranceEligibilityResultId: insuranceEligibilityId
	      }, convertedAdditionalInfoData));
	    } else {
	      var payload = (0, _extends3.default)({
	        providerId: provider.id,
	        visitTypeId: visitType.id,
	        dateTime: schedule.time,
	        id: careUser.id
	      }, additionalParams, insuranceEligibilityId && {
	        insuranceEligibilityResultId: insuranceEligibilityId
	      }, isGWFlow && { schedulingId: scheduleId || schedule.id }, !isGWFlow && { serviceId: service.id }, !isGWFlow && { reasonTypeId: reason.id }, !isGWFlow && { reasonNote: reason.note || null }, !isGWFlow && { locationId: locationId }, !isGWFlow && { organizationId: organization.id }, !isGWFlow && programBasedVisitId && { pbvConfigId: programBasedVisitId }, convertedAdditionalInfoData);
	
	      if (isEirVisitType) {
	        createEirUrgentCareAppointment((0, _extends3.default)({}, payload, pcpFormData && (0, _extends3.default)({
	          pharmacy_id: pharmacyId
	        }, (0, _gerPCPData.gerPCPData)(pcpFormData)), {
	          guarantor_user_id: guarantorUserId,
	          language: language
	        }));
	      } else if (isGWFlow) {
	        confirmVisitGW(payload);
	      } else {
	        confirmVisit(payload);
	      }
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.appointment },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.overview' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      title: {
	        text: isInlineVisit ? visitTypeName : visitType.name
	      },
	      subtitle: subtitle,
	      handleBack: navigateToPrevPage
	    }),
	    _react2.default.createElement(_VisitOverview2.default, {
	      rows: rows,
	      provider: provider,
	      loading: allLoadings,
	      withTopPositionDefault: true,
	      visitName: visitTypeName,
	      organization: organization,
	      isInlineVisit: isInlineVisit,
	      isEirVisitType: isEirVisitType,
	      renderBtn: function renderBtn() {
	        return _react2.default.createElement(
	          'div',
	          { className: isInlineVisit ? _styles2.default.inlineVisitBtns : 'mt3 tr' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              onClick: handleCancel,
	              className: 'mr3',
	              color: 'accent',
	              raised: true
	            },
	            cancelBtnTitle
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              onClick: handleConfirm,
	              disabled: allLoadings,
	              color: 'primary',
	              raised: true
	            },
	            submitBtnTitle
	          )
	        );
	      }
	    }),
	    _react2.default.createElement(_CompleteInlineVisitModal2.default, {
	      formatMessage: formatMessage,
	      userId: careUser.id,
	      isOpened: isConfirmedInlineVisit
	    })
	  );
	}
	
	AppointmentOverview.propTypes = {
	  showPaperworkAppointmentQuestionStep: PropTypes.bool,
	  careUser: PropTypes.object,
	  clearProgressConsents: PropTypes.func,
	  confirmInlineVisit: PropTypes.func,
	  confirmVisit: PropTypes.func,
	  confirmVisitGW: PropTypes.func,
	  consentsData: PropTypes.object,
	  createEirUrgentCareAppointment: PropTypes.func,
	  createEirUrgentCareAppointmentPending: PropTypes.bool,
	  fetchCopay: PropTypes.func,
	  fetchScheduleIdPending: PropTypes.bool,
	  formatMessage: PropTypes.func,
	  getAvailableTimeSlots: PropTypes.func,
	  insuranceEligibilityId: PropTypes.number,
	  isConfirmedInlineVisit: PropTypes.bool,
	  isConsentDataFetching: PropTypes.bool,
	  isEirVisitType: PropTypes.bool,
	  isGWFlow: PropTypes.bool,
	  isRescheduleFlow: PropTypes.bool,
	  loading: PropTypes.bool,
	  loadingGW: PropTypes.bool,
	  loadingTimeSlots: PropTypes.bool,
	  location: PropTypes.object,
	  pharmacyId: PropTypes.number,
	  locationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  organization: PropTypes.object,
	  pcpFormData: PropTypes.object,
	  additionalInfoFormData: PropTypes.object,
	  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  programBasedVisitId: PropTypes.number,
	  provider: PropTypes.object,
	  reason: PropTypes.object,
	  schedule: PropTypes.object,
	  scheduleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  selfScheduleConfirmPending: PropTypes.bool,
	  service: PropTypes.object,
	  setScheduleData: PropTypes.func,
	  subtitle: PropTypes.object,
	  timeSlots: PropTypes.array,
	  visitType: PropTypes.object
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentOverview);

/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _map = __webpack_require__(160);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useOverviewRows = useOverviewRows;
	
	var _react = __webpack_require__(1);
	
	var _useOverviewRowsBuilder = __webpack_require__(1909);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useOverviewRows(_ref) {
	  var price = _ref.price,
	      reason = _ref.reason,
	      service = _ref.service,
	      provider = _ref.provider,
	      location = _ref.location,
	      appointment = _ref.appointment,
	      formatMessage = _ref.formatMessage,
	      code = _ref.visitType.code,
	      additionalInfoFormData = _ref.additionalInfoFormData,
	      _ref$schedule = _ref.schedule,
	      time = _ref$schedule.time,
	      selfSchedulingLocation = _ref$schedule.location;
	  var consentsAssigment = appointment.consentsAssigment,
	      _appointment$location = appointment.location,
	      appointmentLocation = _appointment$location === undefined ? {} : _appointment$location;
	
	
	  var isVirtualVisit = code === _constants.VIRTUAL_VISIT_TYPE_CODE;
	
	  var isEirTelemedicineVisit = code === _constants.TELEMEDICINE_VISIT_TYPE_CODE;
	
	  var isEirHotMySpotVisit = code === _constants.HOLD_MY_SPOT_VISIT_TYPE_CODE;
	
	  var isInlineVisit = _constants.INLINE_TYPES.includes(code);
	
	  var isOfficeVisit = code === _constants.OFFICE_VISIT_TYPE_CODE;
	
	  var isUrgentCareVisit = code === _constants.URGENT_CARE_TYPE_CODE;
	
	  var showAdditionalInfo = additionalInfoFormData && (isOfficeVisit || isVirtualVisit || isUrgentCareVisit);
	
	  var _appointmentLocation = (0, _extends3.default)({}, appointmentLocation),
	      geofenceLat = _appointmentLocation.geofenceLat,
	      geofenceLng = _appointmentLocation.geofenceLng;
	
	  var isForbiddenMap = _constants.FORBIDDEN_VISIT_TYPES_FOR_MAP.includes(code) || !(geofenceLat && geofenceLng);
	
	  var _useOverviewRowsBuild = (0, _useOverviewRowsBuilder.useOverviewRowsBuilder)({ formatMessage: formatMessage, isInlineVisit: isInlineVisit }),
	      makeDateRow = _useOverviewRowsBuild.makeDateRow,
	      makeReasonRow = _useOverviewRowsBuild.makeReasonRow,
	      makeConsentRow = _useOverviewRowsBuild.makeConsentRow,
	      makePaymentRow = _useOverviewRowsBuild.makePaymentRow,
	      makeLocationRow = _useOverviewRowsBuild.makeLocationRow,
	      makeProviderRow = _useOverviewRowsBuild.makeProviderRow,
	      makeDateAndTimeRow = _useOverviewRowsBuild.makeDateAndTimeRow;
	
	  var DATE_ROW = (0, _react.useMemo)(function () {
	    return makeDateRow({ time: time });
	  }, [time]);
	
	  var REASON_ROW = (0, _react.useMemo)(function () {
	    return makeReasonRow(reason);
	  }, [reason]);
	
	  var PROVIDER_ROW = (0, _react.useMemo)(function () {
	    return makeProviderRow({
	      provider: (0, _extends3.default)({}, provider, { location: selfSchedulingLocation }),
	      service: service,
	      hasLocation: true,
	      isVirtualVisit: isVirtualVisit,
	      isForbiddenMap: isForbiddenMap
	    });
	  }, [provider, selfSchedulingLocation, isVirtualVisit, isForbiddenMap]);
	
	  var PAYMENT_ROW = (0, _react.useMemo)(function () {
	    return makePaymentRow(price);
	  }, [price]);
	
	  var CONSENT_ROW = (0, _react.useMemo)(function () {
	    return makeConsentRow({
	      appointment: appointment,
	      providerContext: false
	    });
	  }, [appointment, consentsAssigment]);
	
	  var LOCATION_ROW = (0, _react.useMemo)(function () {
	    if (isInlineVisit) {
	      return makeLocationRow(location);
	    }
	  }, [location, isInlineVisit]);
	
	  var DATE_AND_TIME_ROW = (0, _react.useMemo)(function () {
	    if (isInlineVisit) {
	      return makeDateAndTimeRow(time);
	    }
	  }, [time, isInlineVisit]);
	
	  var visitTypeRowsMap = new _map2.default([[isInlineVisit, [LOCATION_ROW, REASON_ROW, DATE_AND_TIME_ROW]], [isEirHotMySpotVisit, [DATE_ROW, PROVIDER_ROW, REASON_ROW, CONSENT_ROW]], [isEirTelemedicineVisit, [DATE_ROW, REASON_ROW, CONSENT_ROW]]]);
	
	  var defaultRows = [DATE_ROW, PROVIDER_ROW, REASON_ROW, CONSENT_ROW, PAYMENT_ROW];
	
	  var selectedRows = visitTypeRowsMap.get(true) || defaultRows;
	
	  return { rows: selectedRows };
	}

/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	var _countryDetails = __webpack_require__(527);
	
	var _selectors = __webpack_require__(43);
	
	var _selectors2 = __webpack_require__(50);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    rawGenderList: (0, _selectors2.selectGenderTypes)(state),
	    rawRaceList: (0, _selectors2.selectRaceTypes)(state),
	    rawEthnicityList: (0, _selectors2.selectEthnicTypes)(state),
	    isEirVisitType: (0, _selectors.selectIsEirVisitTypeCode)(state),
	    countryList: (0, _selectors2.selectCountryOptions)(state),
	    details: (0, _selectors.selectUserDetails)(state),
	    patientForm: (0, _selectors.selectProgressPatientForm)(state),
	    visitTypeCode: (0, _selectors.selectProgressVisitTypeCode)(state)
	  };
	};
	var mapDispatchToProps = {
	  getCountryDetails: _countryDetails.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var formatMessage = _ref.formatMessage,
	      rawGenderList = _ref.rawGenderList,
	      rawRaceList = _ref.rawRaceList,
	      rawEthnicityList = _ref.rawEthnicityList;
	  return {
	    genderList: (0, _convertListWithLocalization.convertGenderList)(rawGenderList, formatMessage) || [],
	    raceList: rawRaceList || [],
	    ethnicityList: rawEthnicityList || []
	  };
	}), (0, _recompose.branch)(function (_ref2) {
	  var details = _ref2.details;
	  return !details;
	}, _recompose.renderNothing));

/***/ }),
/* 3031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _reactRedux = __webpack_require__(6);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _formFields = __webpack_require__(38);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _useCountrySelect2 = __webpack_require__(145);
	
	var _HomeAddressFormSection = __webpack_require__(1789);
	
	var _utils = __webpack_require__(233);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _DateDropdown = __webpack_require__(498);
	
	var _DateDropdown2 = _interopRequireDefault(_DateDropdown);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _ids = __webpack_require__(46);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _usePatientCountryDetails = __webpack_require__(3035);
	
	var _usePatientForm2 = __webpack_require__(3032);
	
	var _useGetIsFieldDisabled = __webpack_require__(1855);
	
	var _useGetIsFieldDisabled2 = _interopRequireDefault(_useGetIsFieldDisabled);
	
	var _constants = __webpack_require__(17);
	
	var _enhance = __webpack_require__(3030);
	
	var _selectors = __webpack_require__(50);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LAST_NAME = _formFields.PROFILE_FIELDS_TYPES.LAST_NAME,
	    FIRST_NAME = _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME,
	    DOB = _formFields.PROFILE_FIELDS_TYPES.DOB,
	    GENDER = _formFields.PROFILE_FIELDS_TYPES.GENDER,
	    HOME_PHONE = _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE,
	    RACE = _formFields.PROFILE_FIELDS_TYPES.RACE,
	    ETHNICITY = _formFields.PROFILE_FIELDS_TYPES.ETHNICITY,
	    LANGUAGE = _formFields.PROFILE_FIELDS_TYPES.LANGUAGE;
	
	
	function PatientForm(_ref) {
	  var onSubmit = _ref.onSubmit,
	      errors = _ref.errors,
	      genderList = _ref.genderList,
	      raceList = _ref.raceList,
	      ethnicityList = _ref.ethnicityList,
	      isEirVisitType = _ref.isEirVisitType,
	      countryList = _ref.countryList,
	      formatMessage = _ref.formatMessage,
	      patientForm = _ref.patientForm,
	      details = _ref.details,
	      getCountryDetails = _ref.getCountryDetails,
	      visitTypeCode = _ref.visitTypeCode;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isFormSubmitted = _useState2[0],
	      setIsFormSubmitted = _useState2[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var languageList = (0, _reactRedux.useSelector)(_selectors.selectLanguageTypes);
	
	  var targetCountryEntity = (0, _usePatientCountryDetails.usePatientCountryDetails)();
	
	  var language = (0, _get2.default)(details, 'language', null);
	
	  var isInlineVisitType = _constants.INLINE_TYPES.includes(visitTypeCode);
	
	  (0, _react.useEffect)(function () {
	    if (!isInlineVisitType && targetCountryEntity) getCountryDetails({ code: targetCountryEntity.value });
	  }, [targetCountryEntity, isInlineVisitType]);
	
	  var _useGetIsFieldDisable = (0, _useGetIsFieldDisabled2.default)(),
	      checkIsFieldDisabled = _useGetIsFieldDisable.checkIsFieldDisabled;
	
	  var _useCountrySelect = (0, _useCountrySelect2.useCountrySelect)(formatMessage),
	      stateList = _useCountrySelect.stateList,
	      zipLimit = _useCountrySelect.zipLimit,
	      isZipApplicable = _useCountrySelect.isZipApplicable,
	      zipExamples = _useCountrySelect.zipExamples;
	
	  var _usePatientForm = (0, _usePatientForm2.usePatientForm)(errors, details, patientForm, isZipApplicable, isInlineVisitType, isEirVisitType, (0, _utils.makeInitialValue)(details, countryList, stateList, isEirVisitType, true)),
	      handleFormChange = _usePatientForm.handleFormChange,
	      validateErrors = _usePatientForm.validateErrors,
	      clearErrors = _usePatientForm.clearErrors,
	      isDisabled = _usePatientForm.isDisabled,
	      setCountryValue = _usePatientForm.setCountryValue,
	      formState = _usePatientForm.formState,
	      isValid = _usePatientForm.isValid;
	
	  // immediately show errors for postal code field, but for other fields
	  // show errors only after form submission attempt
	
	
	  var formErrors = isFormSubmitted ? validateErrors : {};
	
	  var isPhoneNumberFieldDisabled = isDisabled(HOME_PHONE) && checkIsFieldDisabled(HOME_PHONE, validateErrors);
	
	  var onCountryChange = function onCountryChange(data) {
	    getCountryDetails({ code: data.value });
	    setCountryValue(data);
	  };
	
	  var onLanguageChange = function onLanguageChange(data) {
	    handleFormChange((0, _defineProperty3.default)({}, LANGUAGE, data.value));
	    dispatch(_progressTypes.appointmentProgressActions.setPreferredLanguage(data.value));
	  };
	
	  var makeField = (0, _getFieldProps.getFieldProps)(formatMessage, handleFormChange);
	
	  (0, _useFormWithValidation.clearValidationErrorsOnChange)(clearErrors, formState);
	
	  var isHomePhoneValid = formState[HOME_PHONE] ? formState[HOME_PHONE].length >= 8 : true;
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    clearErrors();
	
	    var fullCountryName = (0, _get2.default)(formState, 'country.label', '');
	    var fullStateName = (0, _get2.default)(formState, 'state.label', '');
	
	    var payload = (0, _extends3.default)({}, (0, _omit2.default)(formState, ['language', 'race', 'ethnicity']), formState.race && { race: formState.race }, formState.ethnicity && { ethnicity: formState.ethnicity }, formState.language && { language: formState.language }, {
	      country: fullCountryName,
	      state: fullStateName
	    });
	
	    setIsFormSubmitted(true);
	
	    onSubmit(payload);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (language) {
	      dispatch(_progressTypes.appointmentProgressActions.setPreferredLanguage(language));
	    }
	  }, [language]);
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(FIRST_NAME), {
	      value: formState.firstName,
	      disabled: isDisabled(FIRST_NAME)
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: FIRST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(LAST_NAME), {
	      value: formState.lastName,
	      disabled: isDisabled(LAST_NAME)
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: LAST_NAME, errors: validateErrors }),
	    !isInlineVisitType && _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(GENDER), {
	      options: genderList,
	      value: formState.gender,
	      disabled: isDisabled(GENDER)
	    })),
	    _react2.default.createElement(_DateDropdown2.default, (0, _extends3.default)({}, makeField(DOB), {
	      value: formState.dob,
	      disabled: isDisabled(DOB)
	    })),
	    isEirVisitType && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(RACE), {
	        value: formState.race,
	        options: raceList,
	        required: true,
	        disabled: isDisabled(RACE)
	      })),
	      _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(ETHNICITY), {
	        value: formState.ethnicity,
	        options: ethnicityList,
	        required: true,
	        disabled: isDisabled(ETHNICITY)
	      })),
	      _react2.default.createElement(_SelectCustom2.default, {
	        className: 'mt3',
	        onChange: onLanguageChange,
	        name: LANGUAGE,
	        type: 'select',
	        label: formatMessage({ id: 'profile.fields.prefLanguage' }),
	        placeholder: formatMessage({ id: 'profile.fields.prefLanguage' }),
	        value: formState.language,
	        options: languageList,
	        required: true,
	        disabled: isDisabled(LANGUAGE)
	      })
	    ),
	    isInlineVisitType && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(HOME_PHONE), {
	        required: true,
	        value: formState.homePhone,
	        disabled: isPhoneNumberFieldDisabled
	      })),
	      _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: HOME_PHONE, errors: formErrors })
	    ),
	    !isInlineVisitType && _react2.default.createElement(_HomeAddressFormSection.HomeAddressFormSection, (0, _extends3.default)({}, formState, {
	      formatMessage: formatMessage,
	      countryList: countryList,
	      validateErrors: validateErrors,
	      targetCountryEntity: targetCountryEntity,
	      isZipApplicable: isZipApplicable,
	      onChange: handleFormChange,
	      onCountryChange: onCountryChange,
	      statesList: stateList,
	      zipLimit: zipLimit,
	      isDisabled: isDisabled,
	      zipExamples: zipExamples,
	      homePhoneRequired: true,
	      cityRequired: true,
	      address1Required: true,
	      rowMode: true,
	      isAppointmentPatientForm: true,
	      isFormSubmitted: isFormSubmitted
	    })),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt4 tr' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: _ids.IDS.APPOINTMENT_FORM.SUBMIT_PATIENT_FORM,
	          type: 'submit',
	          raised: true,
	          color: 'primary',
	          disabled: !isValid || !isHomePhoneValid
	        },
	        formatMessage({ id: 'common.next' })
	      )
	    )
	  );
	}
	
	PatientForm.propTypes = {
	  formatMessage: PropTypes.func,
	  onSubmit: PropTypes.func,
	  genderList: PropTypes.array,
	  raceList: PropTypes.array,
	  ethnicityList: PropTypes.array,
	  isEirVisitType: PropTypes.bool,
	  countryList: PropTypes.array,
	  details: PropTypes.object,
	  patientForm: PropTypes.object,
	  errors: PropTypes.array,
	  getCountryDetails: PropTypes.func,
	  visitTypeCode: PropTypes.string
	};
	
	exports.default = (0, _enhance.enhance)(PatientForm);

/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateRequiredFields = exports.additionalState = exports.extraInitialState = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _commonInitialState, _extraInitialState, _additionalState, _msg;
	
	exports.usePatientForm = usePatientForm;
	
	var _lodash = __webpack_require__(58);
	
	var _react = __webpack_require__(1);
	
	var _camelCase = __webpack_require__(322);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _formFields = __webpack_require__(38);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonInitialState = (_commonInitialState = {}, (0, _defineProperty3.default)(_commonInitialState, _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, ''), (0, _defineProperty3.default)(_commonInitialState, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, ''), (0, _defineProperty3.default)(_commonInitialState, _formFields.PROFILE_FIELDS_TYPES.DOB, ''), (0, _defineProperty3.default)(_commonInitialState, _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE, ''), _commonInitialState);
	
	var extraInitialState = exports.extraInitialState = (_extraInitialState = {}, (0, _defineProperty3.default)(_extraInitialState, _formFields.PROFILE_FIELDS_TYPES.GENDER, ''), (0, _defineProperty3.default)(_extraInitialState, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1, ''), (0, _defineProperty3.default)(_extraInitialState, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2, ''), (0, _defineProperty3.default)(_extraInitialState, _formFields.PROFILE_FIELDS_TYPES.CITY, ''), (0, _defineProperty3.default)(_extraInitialState, _formFields.PROFILE_FIELDS_TYPES.STATE, ''), (0, _defineProperty3.default)(_extraInitialState, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, ''), (0, _defineProperty3.default)(_extraInitialState, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, ''), _extraInitialState);
	
	var additionalState = exports.additionalState = (_additionalState = {}, (0, _defineProperty3.default)(_additionalState, _formFields.PROFILE_FIELDS_TYPES.RACE, ''), (0, _defineProperty3.default)(_additionalState, _formFields.PROFILE_FIELDS_TYPES.ETHNICITY, ''), (0, _defineProperty3.default)(_additionalState, _formFields.PROFILE_FIELDS_TYPES.LANGUAGE, ''), _additionalState);
	
	var getInitialState = function getInitialState(isInlineVisitType, isEirVisitType) {
	  var additionalVisitType = isEirVisitType ? additionalState : {};
	
	  return isInlineVisitType ? commonInitialState : (0, _extends4.default)({}, commonInitialState, extraInitialState, additionalVisitType);
	};
	
	var msg = (_msg = {}, (0, _defineProperty3.default)(_msg, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, _strings.VALIDATION_ERRORS.profile.postalCode.format), (0, _defineProperty3.default)(_msg, _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE, _strings.VALIDATION_ERRORS.profile.phoneHome.required), (0, _defineProperty3.default)(_msg, _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE, _strings.VALIDATION_ERRORS.profile.phoneHome.format), _msg);
	
	var commonRequiredFields = [[_formFields.PROFILE_FIELDS_TYPES.FIRST_NAME], [_formFields.PROFILE_FIELDS_TYPES.LAST_NAME], [_formFields.PROFILE_FIELDS_TYPES.DOB], [_formFields.PROFILE_FIELDS_TYPES.HOME_PHONE]];
	
	var extraRequiredFields = [[_formFields.PROFILE_FIELDS_TYPES.GENDER], [_formFields.PROFILE_FIELDS_TYPES.ADDRESS_1], [_formFields.PROFILE_FIELDS_TYPES.CITY], [_formFields.PROFILE_FIELDS_TYPES.STATE], [_formFields.PROFILE_FIELDS_TYPES.COUNTRY]];
	
	var eirVisitTypeRequiredFields = [[_formFields.PROFILE_FIELDS_TYPES.RACE], [_formFields.PROFILE_FIELDS_TYPES.ETHNICITY], [_formFields.PROFILE_FIELDS_TYPES.LANGUAGE]];
	
	var validateRequiredFields = exports.validateRequiredFields = function validateRequiredFields() {
	  var isZipApplicable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  var isInlineVisitType = arguments[1];
	  var isEirVisitType = arguments[2];
	
	  return isInlineVisitType ? (0, _useFormWithValidation.makeRequiredFieldsValidator)([].concat(commonRequiredFields)) : (0, _useFormWithValidation.makeRequiredFieldsValidator)([].concat(commonRequiredFields, extraRequiredFields, (0, _toConsumableArray3.default)(isZipApplicable && [_formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE]), (0, _toConsumableArray3.default)(isEirVisitType && eirVisitTypeRequiredFields)));
	};
	function makePopulatedObject(source, isInlineVisitType, isEirVisitType) {
	  return (0, _lodash.mapValues)(getInitialState(isInlineVisitType, isEirVisitType), function (value, key) {
	    return (0, _lodash.get)(source, key, '');
	  });
	}
	
	function usePatientForm(errors, originData, savedFormValues, isZipApplicable, isInlineVisitType, isEirVisitType, homeAddressSectionInitialValue) {
	  var filledKeys = (0, _react.useMemo)(function () {
	    return (0, _lodash.keys)((0, _lodash.omitBy)(makePopulatedObject(originData, isInlineVisitType, isEirVisitType), _lodash.isEmpty));
	  }, [originData, isInlineVisitType, isEirVisitType]);
	
	  var state = (0, _react.useMemo)(function () {
	    return makePopulatedObject(savedFormValues || originData, isInlineVisitType, isEirVisitType);
	  }, [originData, savedFormValues]);
	
	  var _useFormValidation = useFormValidation(errors),
	      validateErrors = _useFormValidation.validateErrors,
	      clearErrors = _useFormValidation.clearErrors,
	      addLocalValidateErrors = _useFormValidation.addLocalValidateErrors;
	
	  var initialFormState = (0, _react.useMemo)(function () {
	    return (0, _extends4.default)({}, getInitialState(isInlineVisitType, isEirVisitType), state, homeAddressSectionInitialValue);
	  }, [isInlineVisitType, isEirVisitType, state, homeAddressSectionInitialValue]);
	
	  var _useFormState = (0, _useFormWithValidation.useFormState)(initialFormState),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var isValid = validateRequiredFields(isZipApplicable, isInlineVisitType, isEirVisitType)(formState);
	
	  function isDisabled(field) {
	    return filledKeys.includes(field);
	  }
	
	  var setCountryValue = function setCountryValue(value) {
	    var _extends2;
	
	    return handleFormChange((0, _extends4.default)({}, formState, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, value), (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.STATE, ''), (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, ''), _extends2)));
	  };
	
	  return {
	    validateErrors: validateErrors,
	    clearErrors: clearErrors,
	    formState: formState,
	    isDisabled: isDisabled,
	    addLocalValidateErrors: addLocalValidateErrors,
	    handleFormChange: handleFormChange,
	    isValid: isValid,
	    setCountryValue: setCountryValue
	  };
	}
	
	function useFormValidation(errors) {
	  var _useState = (0, _react.useState)({}),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      validateErrors = _useState2[0],
	      setValidateErrors = _useState2[1];
	
	  var errorsMsg = errors.reduce(function (acc, item) {
	    var defaultError = [{ id: 'errors.validation.common' }];
	    var key = (0, _camelCase2.default)((0, _lodash.get)(item, 'key', null));
	    acc[key] = [msg[key]] || defaultError;
	    return acc;
	  }, {});
	
	  (0, _react.useEffect)(function () {
	    if (errors) {
	      setValidateErrors(errorsMsg);
	    }
	  }, [errors]);
	
	  function clearErrors() {
	    setValidateErrors({});
	  }
	
	  return { validateErrors: validateErrors, clearErrors: clearErrors };
	}

/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _progressTypes = __webpack_require__(55);
	
	var _selectors = __webpack_require__(43);
	
	var _withUserDetails = __webpack_require__(3075);
	
	var _withUserDetails2 = _interopRequireDefault(_withUserDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loading: (0, _selectors.selectUserDetailsPending)(state),
	    services: (0, _selectors.selectProgressServicesByVisit)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  inspectPatient: _progressTypes.appointmentProgressActions.inspectPatient
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _withUserDetails2.default);

/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _PatientForm = __webpack_require__(3031);
	
	var _PatientForm2 = _interopRequireDefault(_PatientForm);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _usePageView = __webpack_require__(52);
	
	var _useNavigateToPreviousPage = __webpack_require__(230);
	
	var _useNavigateToPreviousPage2 = _interopRequireDefault(_useNavigateToPreviousPage);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _selectors = __webpack_require__(43);
	
	var _enhance = __webpack_require__(3033);
	
	var _styles = __webpack_require__(4896);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentPatientInfo(_ref) {
	  var inspectPatient = _ref.inspectPatient,
	      loading = _ref.loading,
	      services = _ref.services;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var errors = (0, _reactRedux.useSelector)(_selectors.selectProfileFormInspectionFieldListErrors);
	
	  (0, _usePageView.usePageView)('Get Care | Patient Info');
	
	  var _useNavigateToPreviou = (0, _useNavigateToPreviousPage2.default)(),
	      navigateToPrevPage = _useNavigateToPreviou.navigateToPrevPage;
	
	  var handleBack = function handleBack() {
	    if (navigateToPrevPage) {
	      navigateToPrevPage();
	      return;
	    }
	
	    (0, _redirectUtils.redirectBackToServiceOrVisitType)(services);
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.patientInfo' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      titleClassName: _styles2.default.header,
	      title: 'appointments.form.patientInfo',
	      subtitle: 'appointments.form.patientInfo.subtitle',
	      handleBack: handleBack
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      loading && _react2.default.createElement(_Loader2.default, null)
	    ),
	    _react2.default.createElement(_PatientForm2.default, {
	      formatMessage: formatMessage,
	      onSubmit: inspectPatient,
	      errors: errors
	    })
	  );
	}
	
	AppointmentPatientInfo.propTypes = {
	  inspectPatient: PropTypes.func,
	  loading: PropTypes.bool,
	  services: PropTypes.array
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentPatientInfo);

/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usePatientCountryDetails = usePatientCountryDetails;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(43);
	
	var _selectors2 = __webpack_require__(50);
	
	function usePatientCountryDetails() {
	  var userCountryName = (0, _reactRedux.useSelector)(_selectors.selectUserCountryDetails);
	  var targetCountry = (0, _reactRedux.useSelector)(_selectors2.selectCountryList).find(function (_ref) {
	    var name = _ref.name;
	    return name === userCountryName;
	  });
	
	  if (!targetCountry) return null;
	
	  var targetCountryEntity = {
	    label: targetCountry.name,
	    value: targetCountry.isoCode
	  };
	
	  return (0, _react.useMemo)(function () {
	    return targetCountryEntity;
	  }, [userCountryName, targetCountry]);
	}

/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _recompose = __webpack_require__(22);
	
	var _selectors = __webpack_require__(294);
	
	var _appointmentDetailsReq = __webpack_require__(259);
	
	var appointmentDetails = _interopRequireWildcard(_appointmentDetailsReq);
	
	var _confirmVisitUrgentReq = __webpack_require__(623);
	
	var confirmUrgentVisit = _interopRequireWildcard(_confirmVisitUrgentReq);
	
	var _selectors2 = __webpack_require__(43);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appointment: (0, _selectors.selectCurrentAppointment)(state),
	    isUrgentVisit: (0, _selectors2.selectProgressIsUrgentVisitFlow)(state),
	    urgentVisitPayload: (0, _selectors2.selectUrgentVisitPayload)(state),
	    additionalInfoFormData: (0, _selectors2.selectAdditionalInfoFormData)(state),
	    urgentVisitPending: (0, _selectors2.selectUrgentVisitConfirmPending)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  resetAppointment: appointmentDetails.actions.clear,
	  urgentVisitRequest: confirmUrgentVisit.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var resetAppointment = _ref.resetAppointment,
	      urgentVisitPayload = _ref.urgentVisitPayload,
	      _ref$additionalInfoFo = _ref.additionalInfoFormData,
	      additionalInfoFormData = _ref$additionalInfoFo === undefined ? {} : _ref$additionalInfoFo,
	      urgentVisitRequest = _ref.urgentVisitRequest;
	  return {
	    confirmUrgentVisit: function confirmUrgentVisit() {
	      resetAppointment();
	      urgentVisitRequest((0, _extends3.default)({}, urgentVisitPayload, additionalInfoFormData));
	    }
	  };
	}));

/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _AppointmentPaymentForm = __webpack_require__(1121);
	
	var _AppointmentPaymentForm2 = _interopRequireDefault(_AppointmentPaymentForm);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _paymentUrgentVisit = __webpack_require__(1868);
	
	var _injectSaga = __webpack_require__(116);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _enhance = __webpack_require__(3036);
	
	var _styles = __webpack_require__(4897);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentPayment(_ref) {
	  var appointment = _ref.appointment,
	      isUrgentVisit = _ref.isUrgentVisit,
	      confirmUrgentVisit = _ref.confirmUrgentVisit,
	      urgentVisitPending = _ref.urgentVisitPending,
	      formatMessage = _ref.intl.formatMessage;
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'couponUrgentVisit',
	    saga: _paymentUrgentVisit.couponUrgentVisit,
	    mode: _sagaInjectors.RESTART_ON_REMOUNT
	  });
	
	  var userId = (0, _get2.default)(appointment, 'userId');
	  (0, _usePageView.usePageView)('Get Care | Payment');
	
	  (0, _react.useEffect)(function () {
	    if (isUrgentVisit) {
	      confirmUrgentVisit();
	    }
	  }, []);
	
	  return urgentVisitPending ? _react2.default.createElement(_Loader2.default, null) : appointment && _react2.default.createElement(
	    'div',
	    { className: _styles2.default.payment },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.payment' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      titleClassName: _styles2.default.content,
	      title: 'appointment.payment.title',
	      handleBack: function handleBack() {
	        return userId && (0, _redirectUtils.redirectToHealthBoard)(userId);
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_styles2.default.content, _styles2.default.form) },
	      _react2.default.createElement(_AppointmentPaymentForm2.default, {
	        appointment: appointment,
	        formatMessage: formatMessage
	      })
	    )
	  );
	}
	
	AppointmentPayment.propTypes = {
	  intl: _propTypes2.default.object,
	  appointment: _propTypes2.default.object,
	  isUrgentVisit: _propTypes2.default.bool,
	  confirmUrgentVisit: _propTypes2.default.func,
	  urgentVisitPending: _propTypes2.default.bool
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentPayment);

/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _enhance = __webpack_require__(760);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PharmacyPopup = __webpack_require__(759);
	
	var _PharmacyPopup2 = _interopRequireDefault(_PharmacyPopup);
	
	var _makePharmacyTitle = __webpack_require__(311);
	
	var _progressTypes = __webpack_require__(55);
	
	var _styles = __webpack_require__(4898);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PharmacyContent(_ref) {
	  var user = _ref.user,
	      updateData = _ref.updateData,
	      clearPharmacyList = _ref.clearPharmacyList,
	      formatMessage = _ref.intl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      pharmacy = _useState4[0],
	      setPharmacy = _useState4[1];
	
	  var primaryPatientProfile = user.primaryPatientProfile;
	
	
	  var pharmacyId = (0, _get2.default)(user, 'primaryPatientProfile.pharmacy.id');
	
	  var togglePopupHandle = function togglePopupHandle() {
	    setIsOpen(function (current) {
	      return !current;
	    });
	    clearPharmacyList();
	  };
	
	  var handleNext = function handleNext() {
	    if (pharmacyId) {
	      updateData();
	    } else {
	      dispatch(_progressTypes.appointmentProgressActions.determineNextStepAfterPharmacy());
	    }
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.location },
	      formatMessage({ id: 'appointments.form.pharmacyLocation' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.address },
	      primaryPatientProfile && (0, _makePharmacyTitle.makePharmacyTitle)(pharmacy || primaryPatientProfile.pharmacy, true)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.buttonsBlock },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            raised: true,
	            color: 'accent',
	            className: 'mr2',
	            onClick: togglePopupHandle
	          },
	          formatMessage({ id: 'appointments.form.changePharmacy' })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { raised: true, disabled: true, color: 'accent', className: _styles2.default.hide },
	          formatMessage({ id: 'appointments.form.selectFromMap' })
	        )
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { raised: true, color: 'primary', onClick: handleNext },
	        formatMessage({ id: 'common.next' })
	      )
	    ),
	    isOpen && _react2.default.createElement(_PharmacyPopup2.default, {
	      isOpen: isOpen,
	      onClose: togglePopupHandle,
	      setPharmacy: setPharmacy
	    })
	  );
	}
	
	PharmacyContent.propTypes = {
	  user: _propTypes2.default.object,
	  intl: _propTypes2.default.object,
	  updateData: _propTypes2.default.func,
	  clearPharmacyList: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(PharmacyContent);

/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhance = __webpack_require__(760);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _icSearch = __webpack_require__(2285);
	
	var _icSearch2 = _interopRequireDefault(_icSearch);
	
	var _styles = __webpack_require__(4899);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PharmacyForm(_ref) {
	  var id = _ref.id,
	      formData = _ref.formData,
	      handleChange = _ref.handleChange,
	      handleSubmit = _ref.handleSubmit,
	      activeMailOrder = _ref.activeMailOrder,
	      handleCheckboxToggle = _ref.handleCheckboxToggle,
	      formatMessage = _ref.intl.formatMessage,
	      _ref$withMailOrder = _ref.withMailOrder,
	      withMailOrder = _ref$withMailOrder === undefined ? true : _ref$withMailOrder;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_styles2.default.searchPharmacy, (0, _defineProperty3.default)({}, _styles2.default.withoutMailOrder, !withMailOrder))
	    },
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.searchBlock },
	        _react2.default.createElement(_TextInput2.default, {
	          limit: 9,
	          type: 'text',
	          shouldUpperCase: true,
	          src: _icSearch2.default,
	          value: formData,
	          placeholder: formatMessage({
	            id: 'appointments.form.searchByZipCode'
	          }),
	          className: _styles2.default.inputStyles,
	          onChange: handleChange
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            raised: true,
	            disabled: !id,
	            color: 'primary',
	            className: _styles2.default.confirmBtn
	          },
	          formatMessage({ id: 'submit.fillProfile' })
	        )
	      )
	    ),
	    withMailOrder && _react2.default.createElement(_Checkbox2.default, {
	      size: 16,
	      id: 'pharmacy',
	      checked: activeMailOrder,
	      onChange: handleCheckboxToggle,
	      className: _styles2.default.checkboxStyles,
	      label: formatMessage({ id: 'appointments.form.showWithMailOrder' })
	    })
	  );
	}
	
	PharmacyForm.propTypes = {
	  id: _propTypes2.default.number,
	  intl: _propTypes2.default.object,
	  formData: _propTypes2.default.string,
	  handleChange: _propTypes2.default.func,
	  handleSubmit: _propTypes2.default.func,
	  withMailOrder: _propTypes2.default.bool,
	  activeMailOrder: _propTypes2.default.bool,
	  handleCheckboxToggle: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(PharmacyForm);

/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhance = __webpack_require__(760);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _PharmacyContent = __webpack_require__(3038);
	
	var _PharmacyContent2 = _interopRequireDefault(_PharmacyContent);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _useNavigateToPreviousPage = __webpack_require__(230);
	
	var _useNavigateToPreviousPage2 = _interopRequireDefault(_useNavigateToPreviousPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentPharmacy(_ref) {
	  var user = _ref.user,
	      getUser = _ref.getUser,
	      careUser = _ref.careUser,
	      updateCareUser = _ref.updateCareUser,
	      setPreferredPharmacy = _ref.setPreferredPharmacy;
	
	  (0, _usePageView.usePageView)('Get Care | Preferred Pharmacy');
	
	  var _useNavigateToPreviou = (0, _useNavigateToPreviousPage2.default)(),
	      navigateToPrevPage = _useNavigateToPreviou.navigateToPrevPage;
	
	  (0, _react.useEffect)(function () {
	    getUser({ id: careUser.id });
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (user.succeed) {
	      var pharmacyId = (0, _get2.default)(user, 'primaryPatientProfile.pharmacy.id');
	      updateCareUser(user);
	      setPreferredPharmacy({ id: pharmacyId });
	    }
	  }, [user]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.pharm' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      handleBack: navigateToPrevPage,
	      title: 'appointments.form.preferredPharmacy'
	    }),
	    user.sending ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(_PharmacyContent2.default, null)
	  );
	}
	
	AppointmentPharmacy.propTypes = {
	  user: _propTypes2.default.object,
	  getUser: _propTypes2.default.func,
	  careUser: _propTypes2.default.object,
	  consentsData: _propTypes2.default.object,
	  updateCareUser: _propTypes2.default.func,
	  setPreferredPharmacy: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentPharmacy);

/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _useProviderCalendar2 = __webpack_require__(3042);
	
	var _renderAddress = __webpack_require__(1093);
	
	var _TimeSlots = __webpack_require__(761);
	
	var _TimeSlots2 = _interopRequireDefault(_TimeSlots);
	
	var _Calendar = __webpack_require__(3820);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(4901);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProviderCalendar(_ref) {
	  var onDateChange = _ref.onDateChange,
	      onTimeSelect = _ref.onTimeSelect,
	      isOfficeVisit = _ref.isOfficeVisit;
	
	  var _useProviderCalendar = (0, _useProviderCalendar2.useProviderCalendar)(onDateChange),
	      availableLocationsByProvider = _useProviderCalendar.availableLocationsByProvider,
	      formatCurrentDate = _useProviderCalendar.formatCurrentDate,
	      handleDateChange = _useProviderCalendar.handleDateChange,
	      displayableTime = _useProviderCalendar.displayableTime,
	      startDate = _useProviderCalendar.startDate,
	      loading = _useProviderCalendar.loading;
	
	  return _react2.default.createElement(
	    _Shape2.default,
	    { styleName: 'root' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'left' },
	      _react2.default.createElement(_Calendar2.default, {
	        disabled: true,
	        minDate: _useProviderCalendar2.nowDate,
	        onChange: handleDateChange,
	        selected: startDate,
	        inline: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'right' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'time-title' },
	        displayableTime
	      ),
	      loading && _react2.default.createElement(_Loader2.default, null),
	      !loading && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.locationWrapper },
	        availableLocationsByProvider.length > 0 ? availableLocationsByProvider.map(function (location) {
	          var slotsSource = location.providers[0].timeSlotsSource;
	          return _react2.default.createElement(
	            'div',
	            { className: _styles2.default.content, key: location.id },
	            _react2.default.createElement(
	              'div',
	              { className: _styles2.default.locationHeader },
	              _react2.default.createElement(
	                'div',
	                { className: _styles2.default.locationName },
	                _react2.default.createElement(_Icon2.default, { name: 'pin-location-fill-black', size: 12 }),
	                location.name
	              ),
	              isOfficeVisit && _react2.default.createElement(
	                'div',
	                { className: _styles2.default.locationAddress },
	                (0, _renderAddress.renderAddress)(location)
	              )
	            ),
	            _react2.default.createElement(_TimeSlots2.default, {
	              variant: 'sm',
	              list: location.providers[0].timeSlots,
	              onSelect: function onSelect(slot) {
	                return onTimeSelect(slot, location, slotsSource, formatCurrentDate);
	              }
	            })
	          );
	        }) : _react2.default.createElement(
	          'div',
	          { styleName: 'emptyList' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appointments.form.noAvailableProviders' })
	        )
	      )
	    )
	  );
	}
	
	ProviderCalendar.propTypes = {
	  onDateChange: PropTypes.func,
	  onTimeSelect: PropTypes.func,
	  isOfficeVisit: PropTypes.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(ProviderCalendar, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nowDate = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useProviderCalendar = useProviderCalendar;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(43);
	
	var _dateFilter = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nowDate = exports.nowDate = _dateFilter.nowLocalMoment.toDate();
	var format = (0, _dateFilter.momentFormat)('MMMM, D');
	
	function useProviderCalendar(onDateChange) {
	  var availableLocationsByProvider = (0, _reactRedux.useSelector)(_selectors.selectProviderDetails) || [];
	  var loadingProviderDetailsGW = (0, _reactRedux.useSelector)(_selectors.selectProviderGWDetailsPending);
	  var loadingProviderDetails = (0, _reactRedux.useSelector)(_selectors.selectProviderDetailsPending);
	
	  var _useState = (0, _react.useState)(nowDate),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      startDate = _useState2[0],
	      setStartDate = _useState2[1];
	
	  var displayableTime = (0, _react.useMemo)(function () {
	    return format(startDate, true);
	  }, [startDate]);
	  var loading = loadingProviderDetailsGW || loadingProviderDetails;
	
	  (0, _react.useEffect)(function () {
	    onDateChange((0, _dateFilter.getISOString)(startDate));
	  }, []);
	
	  var handleDateChange = function handleDateChange(date) {
	    if (loading) return;
	    setStartDate(date);
	    onDateChange((0, _dateFilter.getISOString)(date));
	  };
	
	  return {
	    loading: loading,
	    startDate: startDate,
	    displayableTime: displayableTime,
	    handleDateChange: handleDateChange,
	    availableLocationsByProvider: availableLocationsByProvider,
	    formatCurrentDate: (0, _dateFilter.getISOString)(startDate)
	  };
	}

/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _providerDetailsFormatter = __webpack_require__(904);
	
	var _ProviderNameAvatar = __webpack_require__(1092);
	
	var _ProviderNameAvatar2 = _interopRequireDefault(_ProviderNameAvatar);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _styles = __webpack_require__(4902);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProviderInfo(_ref) {
	  var provider = _ref.provider,
	      languageTypes = _ref.languageTypes;
	
	  var renderProviderSubTitle = (0, _react.useCallback)(_providerDetailsFormatter.shortProviderSubtitle, []);
	  var providerDetails = (0, _react.useMemo)(function () {
	    return (0, _providerDetailsFormatter.transformProviderNameWithTitle)(provider);
	  }, [provider]);
	  var organization = provider.organization,
	      specialization = provider.specialization,
	      _provider$languages = provider.languages,
	      languages = _provider$languages === undefined ? [] : _provider$languages,
	      greeting = provider.greeting;
	
	  var organizationLogo = (0, _get2.default)(organization, 'logo.thumbMiddle');
	
	  var languageString = (0, _react.useMemo)(function () {
	    return languages.map(function (key) {
	      var matched = languageTypes.find(function (_ref2) {
	        var value = _ref2.value;
	        return key === value;
	      });
	      return matched ? matched.label : key;
	    }).join(', ');
	  }, [languages, languageTypes]);
	
	  return _react2.default.createElement(
	    _Shape2.default,
	    { styleName: 'root' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'row' },
	      _react2.default.createElement(_ProviderNameAvatar2.default, {
	        withoutLocation: true,
	        provider: providerDetails,
	        renderMeta: renderProviderSubTitle
	      }),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'right' },
	        organizationLogo && _react2.default.createElement('img', { src: organizationLogo, styleName: 'logo' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'row align-top' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'info-block' },
	        _react2.default.createElement(
	          'span',
	          { styleName: 'info-title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appointments.specialization' }),
	          ':'
	        ),
	        _react2.default.createElement(
	          'span',
	          { styleName: 'meta' },
	          specialization || '-'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'info-block' },
	        _react2.default.createElement(
	          'span',
	          { styleName: 'info-title' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.fields.language' }),
	          ':'
	        ),
	        _react2.default.createElement(
	          'span',
	          { styleName: 'meta' },
	          languageString || '-'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'description' },
	      greeting
	    )
	  );
	}
	
	ProviderInfo.propTypes = {
	  provider: PropTypes.object,
	  languageTypes: PropTypes.array
	};
	
	exports.default = (0, _reactCssModules2.default)(ProviderInfo, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _constants = __webpack_require__(17);
	
	var _styles2 = __webpack_require__(4903);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProviderVisitTypeToggle(_ref) {
	  var isOfficeVisit = _ref.isOfficeVisit,
	      _ref$manageVisitType = _ref.manageVisitType,
	      setVisitType = _ref$manageVisitType.setVisitType,
	      visitType = _ref$manageVisitType.visitType,
	      visitTypesList = _ref$manageVisitType.visitTypesList,
	      visitTypeCodes = _ref.reasonType.visitTypeCodes;
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      viewNotification = _useState2[0],
	      setViewNotification = _useState2[1];
	
	  var isVirtualVisitAllowed = visitTypeCodes.find(function (code) {
	    return code === _constants.VIRTUAL_VISIT_TYPE_CODE;
	  });
	  var isOfficeVisitAllowed = visitTypeCodes.find(function (code) {
	    return code === _constants.OFFICE_VISIT_TYPE_CODE;
	  });
	
	  var isAllowedToggleVisitType = isVirtualVisitAllowed && isOfficeVisitAllowed;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles3.default.root },
	    isAllowedToggleVisitType && _react2.default.createElement(
	      'div',
	      { className: _styles3.default.toggle },
	      visitTypesList.map(function (_ref2) {
	        var name = _ref2.name,
	            code = _ref2.code,
	            id = _ref2.id;
	        return _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_styles3.default.button, (0, _defineProperty3.default)({}, _styles3.default.activeButton, visitType.id === id)),
	            key: id,
	            onClick: function onClick() {
	              return setVisitType({ name: name, code: code, id: id });
	            }
	          },
	          name
	        );
	      })
	    ),
	    viewNotification && !isOfficeVisit && _react2.default.createElement(
	      'div',
	      { className: _styles3.default.notification },
	      _react2.default.createElement(_Icon2.default, {
	        size: 8,
	        name: 'ico-24-close',
	        className: _styles3.default.closeBtn,
	        style: { fill: _styles.COLORS.fontPrimary },
	        onClick: function onClick() {
	          return setViewNotification(false);
	        }
	      }),
	      isVirtualVisitAllowed && !isOfficeVisitAllowed && _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appointmentForm.rescheduleFlow.notification' }),
	      !isOfficeVisit && _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'appointmentForm.rescheduleFlow.notification.warning',
	        values: {
	          visit: _react2.default.createElement(
	            'b',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appointmentForm.rescheduleFlow.notification.onlineVisit' })
	          )
	        }
	      })
	    )
	  );
	}
	
	ProviderVisitTypeToggle.propTypes = {
	  isOfficeVisit: PropTypes.bool,
	  reasonType: PropTypes.object,
	  manageVisitType: PropTypes.object
	};
	
	exports.default = (0, _react.memo)(ProviderVisitTypeToggle);

/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(43);
	
	var _consentReq = __webpack_require__(505);
	
	var appointmentProgressConsents = _interopRequireWildcard(_consentReq);
	
	var _providerGWDetailsReq = __webpack_require__(802);
	
	var providerGWDetails = _interopRequireWildcard(_providerGWDetailsReq);
	
	var _providerDetailsReq = __webpack_require__(1233);
	
	var providerDetails = _interopRequireWildcard(_providerDetailsReq);
	
	var _progressTypes = __webpack_require__(55);
	
	var _selectors2 = __webpack_require__(50);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _ProviderCalendar = __webpack_require__(3041);
	
	var _ProviderCalendar2 = _interopRequireDefault(_ProviderCalendar);
	
	var _ProviderInfo = __webpack_require__(3043);
	
	var _ProviderInfo2 = _interopRequireDefault(_ProviderInfo);
	
	var _LeaveFlowModal = __webpack_require__(1705);
	
	var _LeaveFlowModal2 = _interopRequireDefault(_LeaveFlowModal);
	
	var _constants = __webpack_require__(17);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _ProviderVisitTypeToggle = __webpack_require__(3044);
	
	var _ProviderVisitTypeToggle2 = _interopRequireDefault(_ProviderVisitTypeToggle);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentProviderDetails(_ref) {
	  var formatMessage = _ref.formatMessage,
	      id = _ref.params.id,
	      hash = _ref.location.hash;
	
	  var confirmModalRef = (0, _react.useRef)();
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(new Date().toISOString()),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      currentDate = _useState2[0],
	      setCurrentDate = _useState2[1];
	
	  var locationId = hash.slice(1, hash.length);
	  var rescheduleData = (0, _reactRedux.useSelector)(_selectors.selectProgressRescheduleData);
	  var reason = (0, _reactRedux.useSelector)(_selectors.selectProgressReason);
	  var scheduleMeta = (0, _reactRedux.useSelector)(_selectors.selectScheduleMetaDataFromProviderInfo);
	  var provider = (0, _reactRedux.useSelector)((0, _selectors.makeAppointmentProviderByIdSelect)(id, locationId));
	  var languageTypes = (0, _reactRedux.useSelector)(_selectors2.selectLanguageTypes);
	  var payload = (0, _reactRedux.useSelector)(_selectors.selectSchedulePayloadData);
	  var organizationId = (0, _reactRedux.useSelector)(_selectors.selectProgressOrganizationId);
	  var visitType = (0, _reactRedux.useSelector)(_selectors.selectProgressVisitType);
	  var visitTypesList = (0, _reactRedux.useSelector)(_selectors.selectMyProvidersVisitTypes);
	
	  var isRescheduleFlow = !!(0, _get2.default)(rescheduleData, 'id');
	  var rescheduleProvider = (0, _get2.default)(rescheduleData, 'providerInfo', {});
	  var isOfficeVisit = visitType.code === _constants.OFFICE_VISIT_TYPE_CODE;
	
	  var safeProvider = isRescheduleFlow ? rescheduleProvider : provider;
	
	  var clearProgressConsents = function clearProgressConsents() {
	    dispatch(appointmentProgressConsents.actions.clear());
	  };
	
	  (0, _usePageView.usePageView)('Get Care | Provider Details');
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      dispatch(providerDetails.actions.clear());
	      dispatch(providerGWDetails.actions.clear());
	    };
	  }, []);
	
	  var fetchProviderDetails = (0, _react.useCallback)(function (date, visitTypeId) {
	    var data = (0, _extends3.default)({}, payload, { providerId: id, date: date });
	
	    setCurrentDate(date);
	
	    dispatch(providerDetails.actions.send((0, _extends3.default)({
	      reasonTypeId: data.payload.reasonTypeId,
	      serviceId: data.payload.serviceId,
	      organizationId: organizationId,
	      visitTypeId: visitTypeId || visitType.id,
	      date: date || currentDate,
	      userId: data.userId,
	      providerProfileId: id
	    }, !isRescheduleFlow && { priorityLocationId: locationId })));
	  }, [id, payload, visitType, locationId, currentDate, organizationId, isRescheduleFlow]);
	
	  var setVisitType = function setVisitType(data) {
	    dispatch(_progressTypes.appointmentProgressActions.setVisitType(data));
	    fetchProviderDetails(currentDate, data.id);
	  };
	
	  var handleTimeSelect = function handleTimeSelect(time, location, timeSlotsSource, date) {
	    var data = (0, _extends3.default)({}, scheduleMeta, {
	      provider: safeProvider,
	      time: time,
	      location: location,
	      timeSlotsSource: timeSlotsSource
	    });
	
	    dispatch(_progressTypes.appointmentProgressActions.setScheduleData(data));
	
	    if (timeSlotsSource !== _constants.PROVIDER_CALENDAR_SOURCE) {
	      dispatch(providerGWDetails.actions.send((0, _extends3.default)({}, payload, {
	        providerId: id,
	        date: date,
	        organizationId: organizationId,
	        timeSlotsSource: timeSlotsSource
	      })));
	    }
	
	    dispatch(_progressTypes.appointmentProgressActions.setCreateTypeFlowGW(timeSlotsSource !== _constants.PROVIDER_CALENDAR_SOURCE));
	
	    dispatch(_progressTypes.appointmentProgressActions.determineNextStepAfterAppointmentProviders());
	  };
	
	  var handleBack = function handleBack() {
	    if (isRescheduleFlow) {
	      confirmModalRef.current.open();
	    } else {
	      (0, _redirectUtils.redirectToProviders)();
	    }
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.providerInfo' }),
	    _react2.default.createElement(_AppointmentHeader2.default, { handleBack: handleBack }),
	    _react2.default.createElement(_ProviderInfo2.default, { provider: safeProvider, languageTypes: languageTypes }),
	    isRescheduleFlow && _react2.default.createElement(_ProviderVisitTypeToggle2.default, {
	      isOfficeVisit: isOfficeVisit,
	      reasonType: reason.reasonType,
	      manageVisitType: { setVisitType: setVisitType, visitType: visitType, visitTypesList: visitTypesList }
	    }),
	    _react2.default.createElement(_ProviderCalendar2.default, {
	      onDateChange: fetchProviderDetails,
	      onTimeSelect: handleTimeSelect,
	      isOfficeVisit: isOfficeVisit
	    }),
	    _react2.default.createElement(_LeaveFlowModal2.default, {
	      ref: confirmModalRef,
	      formatMessage: formatMessage,
	      clearProgressConsents: clearProgressConsents
	    })
	  );
	}
	
	AppointmentProviderDetails.propTypes = {
	  params: PropTypes.object,
	  location: PropTypes.object,
	  formatMessage: PropTypes.func
	};
	
	exports.default = (0, _reactIntl.injectIntl)(AppointmentProviderDetails);

/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _root = __webpack_require__(1828);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _LocationPicker = __webpack_require__(3071);
	
	var _LocationPicker2 = _interopRequireDefault(_LocationPicker);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _dateFilter = __webpack_require__(310);
	
	var _styles2 = __webpack_require__(4904);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var minDate = (0, _dateFilter.getMinDate)().toDate();
	
	function ScheduleFilter(_ref) {
	  var activeDate = _ref.activeDate,
	      activeLocations = _ref.activeLocations,
	      disabled = _ref.disabled,
	      filterList = _ref.filterList,
	      formatMessage = _ref.formatMessage,
	      isEirVisitType = _ref.isEirVisitType,
	      isVirtualVisit = _ref.isVirtualVisit,
	      onDateChange = _ref.onDateChange,
	      onLocationFilterApply = _ref.onLocationFilterApply,
	      _styles = _ref.styles;
	
	  var formattedDate = (0, _react.useMemo)(function () {
	    return (0, _dateFilter.formatToDate)(activeDate);
	  }, [activeDate]);
	  var displayableDate = (0, _react.useMemo)(function () {
	    return (0, _dateFilter.humanizeDate)(activeDate);
	  }, [activeDate]);
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      dateOpened = _useToggleFlag2[0],
	      openDateModal = _useToggleFlag2[1],
	      closeDateModal = _useToggleFlag2[2];
	
	  var handleDateChange = function handleDateChange(newDate) {
	    var date = (0, _dateFilter.getISOString)(newDate);
	    onDateChange(date);
	    closeDateModal();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: (0, _classnames2.default)('root', { disabled: disabled }) },
	    _react2.default.createElement(_root2.default, {
	      inputClassName: _styles.DateFilterInput,
	      active: dateOpened,
	      onChange: handleDateChange,
	      value: formattedDate,
	      minDate: minDate,
	      sundayFirstDayOfWeek: true,
	      onDismiss: closeDateModal
	    }),
	    !isEirVisitType && _react2.default.createElement(
	      _Button2.default,
	      {
	        styleName: 'DateFilter',
	        onClick: openDateModal,
	        color: 'accent',
	        border: true
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'calendar' }),
	      displayableDate
	    ),
	    _react2.default.createElement(_LocationPicker2.default, {
	      isVirtualVisit: isVirtualVisit,
	      formatMessage: formatMessage,
	      onApply: onLocationFilterApply,
	      activeLocations: activeLocations,
	      filterList: filterList
	    })
	  );
	}
	
	ScheduleFilter.propTypes = {
	  activeDate: PropTypes.string,
	  activeLocations: PropTypes.array,
	  disabled: PropTypes.bool,
	  filterList: PropTypes.array,
	  formatMessage: PropTypes.func,
	  isEirVisitType: PropTypes.bool,
	  isVirtualVisit: PropTypes.bool,
	  onDateChange: PropTypes.func,
	  onLocationFilterApply: PropTypes.func,
	  styles: PropTypes.object
	};
	
	exports.default = (0, _reactCssModules2.default)(ScheduleFilter, _styles3.default, { allowMultiple: true });

/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _map = __webpack_require__(160);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _consentReq = __webpack_require__(505);
	
	var appointmentProgressConsents = _interopRequireWildcard(_consentReq);
	
	var _filtersReq = __webpack_require__(1227);
	
	var locations = _interopRequireWildcard(_filtersReq);
	
	var _progressTypes = __webpack_require__(55);
	
	var _filters = __webpack_require__(1862);
	
	var _withCareUserSubtitle = __webpack_require__(603);
	
	var _withCareUserSubtitle2 = _interopRequireDefault(_withCareUserSubtitle);
	
	var _selectors = __webpack_require__(43);
	
	var _constants = __webpack_require__(17);
	
	var _styles = __webpack_require__(2239);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    activeDate: (0, _selectors.selectAppointmentDateFilter)(state),
	    activeLocations: (0, _selectors.selectAppointmentLocationFilter)(state),
	    availableSelfSchedulingLocations: (0, _selectors.selectAvailableProvidersSelfScheduling)(state),
	    filterList: (0, _selectors.selectAppointmentFilterList)(state),
	    filterLoading: (0, _selectors.selectAppointmentFilterPending)(state),
	    filterPayload: (0, _selectors.selectFilterPayloadData)(state),
	    isEirVisitType: (0, _selectors.selectIsEirVisitTypeCode)(state),
	    providersLoading: (0, _selectors.selectAvailableProvidersSelfSchedulingLoading)(state),
	    eirLocations: (0, _selectors.selectAvailableEirLocationsData)(state),
	    eirLocationsLoading: (0, _selectors.selectAvailableEirLocationLoading)(state),
	    scheduleMeta: (0, _selectors.selectScheduleMetaDataFromProviderList)(state),
	    visitType: (0, _selectors.selectProgressVisitType)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  setDateFilter: _filters.appointmentFilterActions.setDate,
	  setLocationFilter: _filters.appointmentFilterActions.setLocation,
	  setScheduleData: _progressTypes.appointmentProgressActions.setScheduleData,
	  fetchProviderList: _progressTypes.appointmentProgressActions.fetchProviderList,
	  clearProgressConsents: appointmentProgressConsents.actions.clear,
	  fetchLocationsReq: locations.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var availableSelfSchedulingLocations = _ref.availableSelfSchedulingLocations,
	      eirLocations = _ref.eirLocations,
	      eirLocationsLoading = _ref.eirLocationsLoading,
	      fetchLocationsReq = _ref.fetchLocationsReq,
	      filterLoading = _ref.filterLoading,
	      filterPayload = _ref.filterPayload,
	      isEirVisitType = _ref.isEirVisitType,
	      providersLoading = _ref.providersLoading,
	      visitType = _ref.visitType;
	
	  var locationsMap = new _map2.default([[isEirVisitType, eirLocations]]);
	
	  var visitTypeCode = (0, _get2.default)(visitType, 'code');
	
	  return {
	    loading: filterLoading || providersLoading || eirLocationsLoading,
	    fetchLocations: function fetchLocations() {
	      fetchLocationsReq(filterPayload);
	    },
	    isOfficeVisit: visitTypeCode === _constants.OFFICE_VISIT_TYPE_CODE,
	    isVirtualVisit: visitTypeCode === _constants.VIRTUAL_VISIT_TYPE_CODE,
	    locationList: locationsMap.get(true) || availableSelfSchedulingLocations
	  };
	}), _withCareUserSubtitle2.default, (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ScheduleFilter = __webpack_require__(3046);
	
	var _ScheduleFilter2 = _interopRequireDefault(_ScheduleFilter);
	
	var _TimeSlots = __webpack_require__(761);
	
	var _TimeSlots2 = _interopRequireDefault(_TimeSlots);
	
	var _DayPicker = __webpack_require__(3069);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _ProviderCard = __webpack_require__(3072);
	
	var _ProviderCard2 = _interopRequireDefault(_ProviderCard);
	
	var _LeaveFlowModal = __webpack_require__(1705);
	
	var _LeaveFlowModal2 = _interopRequireDefault(_LeaveFlowModal);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _renderAddress = __webpack_require__(1093);
	
	var _usePageView = __webpack_require__(52);
	
	var _enhance = __webpack_require__(3047);
	
	var _progressTypes = __webpack_require__(55);
	
	var _styles = __webpack_require__(2239);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentProviders(_ref) {
	  var activeDate = _ref.activeDate,
	      activeLocations = _ref.activeLocations,
	      clearProgressConsents = _ref.clearProgressConsents,
	      fetchLocations = _ref.fetchLocations,
	      fetchProviderList = _ref.fetchProviderList,
	      filterList = _ref.filterList,
	      formatMessage = _ref.formatMessage,
	      isEirVisitType = _ref.isEirVisitType,
	      isOfficeVisit = _ref.isOfficeVisit,
	      isVirtualVisit = _ref.isVirtualVisit,
	      loading = _ref.loading,
	      locationList = _ref.locationList,
	      scheduleMeta = _ref.scheduleMeta,
	      setDateFilter = _ref.setDateFilter,
	      setLocationFilter = _ref.setLocationFilter,
	      setScheduleData = _ref.setScheduleData,
	      subtitle = _ref.subtitle;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var confirmModalRef = (0, _react.useRef)();
	
	  (0, _usePageView.usePageView)('Get Care | Available Providers');
	
	  var showAddress = isOfficeVisit || isEirVisitType;
	
	  var handleTimeSelect = function handleTimeSelect(time, provider, location) {
	    setScheduleData((0, _extends3.default)({}, scheduleMeta, { provider: provider, time: time, location: location }));
	
	    dispatch(_progressTypes.appointmentProgressActions.determineNextStepAfterAppointmentProviders());
	  };
	
	  var handleLocationFilter = function handleLocationFilter(locations) {
	    setLocationFilter(locations);
	    fetchProviderList();
	  };
	
	  (0, _react.useEffect)(function () {
	    fetchLocations();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (activeDate) {
	      fetchProviderList();
	    }
	  }, [activeDate]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.providers' }),
	    _react2.default.createElement(
	      _AppointmentHeader2.default,
	      {
	        title: isEirVisitType ? 'appointment.actions.selectYourSlot' : 'appointments.form.availableProviders',
	        subtitle: subtitle,
	        handleBack: function handleBack() {
	          return confirmModalRef.current.open();
	        }
	      },
	      _react2.default.createElement(_ScheduleFilter2.default, {
	        activeDate: activeDate,
	        activeLocations: activeLocations,
	        disabled: loading,
	        filterList: filterList,
	        formatMessage: formatMessage,
	        isEirVisitType: isEirVisitType,
	        isVirtualVisit: isVirtualVisit,
	        onDateChange: setDateFilter,
	        onLocationFilterApply: handleLocationFilter
	      })
	    ),
	    _react2.default.createElement(_DayPicker2.default, {
	      activeDate: activeDate,
	      onChange: setDateFilter,
	      disabled: loading
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      loading && _react2.default.createElement(_Loader2.default, null)
	    ),
	    !loading && locationList.map(function (location) {
	      var _ref2 = location || {},
	          id = _ref2.id,
	          _ref2$providers = _ref2.providers,
	          providers = _ref2$providers === undefined ? [] : _ref2$providers,
	          _ref2$timeSlots = _ref2.timeSlots,
	          timeSlots = _ref2$timeSlots === undefined ? [] : _ref2$timeSlots;
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        { key: id },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.locationInfo },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.locationName },
	            _react2.default.createElement(_Icon2.default, { name: 'pin-location-fill-black', size: 12 }),
	            location.name
	          ),
	          showAddress && _react2.default.createElement(
	            'div',
	            { className: _styles2.default.address },
	            (0, _renderAddress.renderAddress)(location)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          providers.map(function (provider) {
	            return _react2.default.createElement(_ProviderCard2.default, {
	              onTimeSelect: function onTimeSelect(time, providerEntity) {
	                return handleTimeSelect(time, providerEntity, location);
	              },
	              provider: provider,
	              key: provider.id,
	              locationId: id
	            });
	          })
	        ),
	        isEirVisitType && _react2.default.createElement(
	          'div',
	          { className: _styles2.default.eirVisitTimeSlots },
	          _react2.default.createElement('div', { className: _styles2.default.eirVisitTimeSlots_separator }),
	          _react2.default.createElement(_TimeSlots2.default, {
	            list: timeSlots,
	            onSelect: function onSelect(time, providerEntity) {
	              return handleTimeSelect(time, providerEntity, location);
	            }
	          })
	        )
	      );
	    }),
	    !loading && !locationList.length && _react2.default.createElement(_Content2.default, {
	      styleName: 'empty-block',
	      text: formatMessage({
	        id: isEirVisitType ? 'appointments.emptySlots' : 'appointments.emptyProviders'
	      }),
	      icon: isEirVisitType ? 'search-list' : 'no-one-found'
	    }),
	    _react2.default.createElement(_LeaveFlowModal2.default, {
	      ref: confirmModalRef,
	      formatMessage: formatMessage,
	      clearProgressConsents: clearProgressConsents
	    })
	  );
	}
	
	AppointmentProviders.propTypes = {
	  activeDate: _propTypes2.default.string,
	  activeLocations: _propTypes2.default.array,
	  clearProgressConsents: _propTypes2.default.func,
	  fetchLocations: _propTypes2.default.func,
	  fetchProviderList: _propTypes2.default.func,
	  filterList: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  isEirVisitType: _propTypes2.default.bool,
	  isOfficeVisit: _propTypes2.default.bool,
	  isVirtualVisit: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  locationList: _propTypes2.default.array,
	  scheduleMeta: _propTypes2.default.object,
	  setDateFilter: _propTypes2.default.func,
	  setLocationFilter: _propTypes2.default.func,
	  setScheduleData: _propTypes2.default.func,
	  subtitle: _propTypes2.default.object
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentProviders);

/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(43);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    data: (0, _selectors.selectPublixInfo)(state),
	    loadingPublixInfo: (0, _selectors.selectPublixInfoPending)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3049);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _styles = __webpack_require__(4905);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentPublixInfo(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      data = _ref.data,
	      loadingPublixInfo = _ref.loadingPublixInfo;
	
	  (0, _usePageView.usePageView)('Get Care | Publix');
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.publix' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      type: 'name',
	      title: 'visitType.publix',
	      handleBack: _redirectUtils.redirectToVisitType
	    }),
	    loadingPublixInfo && _react2.default.createElement(_Loader2.default, null),
	    !loadingPublixInfo && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.infoWrapper },
	        data.sort(function (item) {
	          return item.order;
	        }).map(function (_ref2) {
	          var id = _ref2.id,
	              order = _ref2.order,
	              content = _ref2.content,
	              attachment = _ref2.attachment;
	          return _react2.default.createElement(_Shape2.default, {
	            key: id,
	            className: _styles2.default.info,
	            renderPrimary: order === 1 ? function () {
	              return formatMessage({ id: 'visitType.publix.title' });
	            } : function () {
	              return '';
	            },
	            renderSecondary: function renderSecondary() {
	              return content;
	            },
	            renderLeft: function renderLeft() {
	              return _react2.default.createElement('img', {
	                style: { width: 42 },
	                src: attachment.url,
	                alt: content
	              });
	            }
	          });
	        })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'primary',
	          className: _styles2.default.button,
	          onClick: function onClick() {
	            return (0, _redirectUtils.redirectToLocations)();
	          }
	        },
	        formatMessage({ id: 'task.seeLocations' })
	      )
	    )
	  );
	}
	
	AppointmentPublixInfo.propTypes = {
	  data: PropTypes.array,
	  intl: PropTypes.object,
	  loadingPublixInfo: PropTypes.bool
	};
	exports.default = (0, _enhance.enhance)(AppointmentPublixInfo);

/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _progressTypes = __webpack_require__(55);
	
	var _inspectionReq = __webpack_require__(293);
	
	var inspectReq = _interopRequireWildcard(_inspectionReq);
	
	var _withCareUserSubtitle = __webpack_require__(603);
	
	var _withCareUserSubtitle2 = _interopRequireDefault(_withCareUserSubtitle);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    services: (0, _selectors.selectProgressServicesByVisit)(state),
	    careUser: (0, _selectors.selectProgressCareUser)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  setService: _progressTypes.appointmentProgressActions.setService,
	  inspectAll: inspectReq.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, _withCareUserSubtitle2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	var _constants = __webpack_require__(17);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _enhance = __webpack_require__(3051);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentServices(_ref) {
	  var setService = _ref.setService,
	      inspectAll = _ref.inspectAll,
	      careUser = _ref.careUser,
	      services = _ref.services,
	      subtitle = _ref.subtitle;
	
	  (0, _usePageView.usePageView)('Get Care | Services');
	
	  var handleServiceSelect = function handleServiceSelect(service) {
	    setService(service);
	    inspectAll({
	      userId: careUser.id,
	      inspectionFor: [_constants.APPOINTMENT_INSPECTION.PROFILE]
	    });
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.servces' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      title: 'appointments.seeAProvider',
	      subtitle: subtitle,
	      handleBack: _redirectUtils.redirectToVisitType
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      services.map(function (service) {
	        return _react2.default.createElement(_Shape2.default, {
	          onClick: function onClick() {
	            return handleServiceSelect(service);
	          },
	          renderPrimary: function renderPrimary() {
	            return service.name;
	          },
	          renderSecondary: function renderSecondary() {
	            return service.description;
	          },
	          key: service.id
	        });
	      })
	    )
	  );
	}
	
	AppointmentServices.propTypes = {
	  setService: PropTypes.func,
	  inspectAll: PropTypes.func,
	  careUser: PropTypes.object,
	  services: PropTypes.array,
	  subtitle: PropTypes.object
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentServices);

/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _recompose = __webpack_require__(22);
	
	var _constants = __webpack_require__(17);
	
	var _selectors = __webpack_require__(294);
	
	var _appointmentDetails = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appointment: (0, _selectors.selectCurrentAppointment)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  changeStatus: _appointmentDetails.appointmentDetailsActions.changeStatus
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var appointment = _ref.appointment,
	      changeStatus = _ref.changeStatus;
	  return {
	    handleStartVisit: function handleStartVisit() {
	      return changeStatus({
	        appointment: appointment,
	        id: (0, _get2.default)(appointment, 'userId'),
	        event: _constants.VIRTUAL_VISIT_EVENTS.START_VISIT,
	        flow: 'get-care'
	      });
	    }
	  };
	}));

/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _AppointmentDetailsPopup = __webpack_require__(490);
	
	var _AppointmentDetailsPopup2 = _interopRequireDefault(_AppointmentDetailsPopup);
	
	var _enhance = __webpack_require__(3053);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentSummary(_ref) {
	  var appointment = _ref.appointment,
	      handleStartVisit = _ref.handleStartVisit;
	
	  var onceStarted = (0, _react.useRef)(false);
	  var userId = (0, _get2.default)(appointment, 'userId');
	
	  (0, _usePageView.usePageView)('Get Care | Summary');
	
	  var onClose = function onClose() {
	    if (userId) {
	      (0, _redirectUtils.redirectToHealthBoard)(userId);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (appointment && !onceStarted.current) {
	      onceStarted.current = true;
	      handleStartVisit(appointment);
	    }
	  }, [appointment]);
	
	  return appointment && _react2.default.createElement(_AppointmentDetailsPopup2.default, {
	    opened: true,
	    userId: userId,
	    appointment: appointment,
	    onStartVideoVisit: handleStartVisit,
	    onClose: onClose
	  });
	}
	
	AppointmentSummary.propTypes = {
	  appointment: _propTypes2.default.object,
	  handleStartVisit: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentSummary);

/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddNewUser(_ref) {
	  var formatMessage = _ref.formatMessage,
	      setDependentSubmitRedirect = _ref.setDependentSubmitRedirect;
	
	  var handleClick = function handleClick() {
	    setDependentSubmitRedirect(_constants.DEPENDENT_FORM_SUBMIT_REDIRECT.GET_CARE);
	    (0, _redirectUtils.redirectToDependentForm)();
	  };
	
	  return _react2.default.createElement(_Shape2.default, {
	    renderLeft: function renderLeft() {
	      return _react2.default.createElement(_Icon2.default, { name: 'add-new', size: 40 });
	    },
	    onClick: handleClick,
	    renderPrimary: function renderPrimary() {
	      return formatMessage({ id: 'appointments.form.step1.addNewPrimary' });
	    },
	    renderSecondary: function renderSecondary() {
	      return formatMessage({ id: 'appointments.form.step1.addNewSecondary' });
	    }
	  });
	}
	
	AddNewUser.propTypes = {
	  formatMessage: PropTypes.func,
	  setDependentSubmitRedirect: PropTypes.func
	};
	
	exports.default = AddNewUser;

/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _careUsersReq = __webpack_require__(1225);
	
	var careUsersRedux = _interopRequireWildcard(_careUsersReq);
	
	var _schedulableTreeReq = __webpack_require__(804);
	
	var schedulingTree = _interopRequireWildcard(_schedulableTreeReq);
	
	var _progressTypes = __webpack_require__(55);
	
	var _insurancePayersReq = __webpack_require__(800);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(43);
	
	var _selectors3 = __webpack_require__(50);
	
	var _progress = __webpack_require__(121);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loading: (0, _selectors2.selectCareUsersPending)(state),
	    careUsers: (0, _selectors2.selectCareUsersList)(state),
	    currentUser: (0, _selectors.loggedUserSelector)(state),
	    currentUserAppointmentSchedulingForSelfAllowed: (0, _selectors3.selectAppointmentSchedulingForSelfAllowed)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  careUsersReq: careUsersRedux.actions.send,
	  setCareUser: _progressTypes.appointmentProgressActions.setCareUser,
	  fetchSchedulingTree: schedulingTree.actions.init,
	  clearHealthPlans: _insurancePayersReq.actions.clear,
	  clearProgress: _progressTypes.appointmentProgressActions.clear,
	  finishValidate: _progressTypes.appointmentProgressActions.finishValidate,
	  setDependentSubmitRedirect: _progress.dependentFormActions.setSubmitRedirect
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var currentUser = _ref.currentUser,
	      careUsersReq = _ref.careUsersReq,
	      careUsers = _ref.careUsers,
	      currentUserAppointmentSchedulingForSelfAllowed = _ref.currentUserAppointmentSchedulingForSelfAllowed;
	  return {
	    fetchCareUsers: function fetchCareUsers() {
	      return careUsersReq({ id: currentUser.id });
	    },
	    users: [formatToDependent(currentUser, currentUserAppointmentSchedulingForSelfAllowed)].concat((0, _toConsumableArray3.default)(filterDependents(careUsers)))
	  };
	}));
	
	function formatToDependent() {
	  var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var currentUserAppointmentSchedulingForSelfAllowed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return {
	    id: user.id,
	    user: (0, _extends3.default)({}, user),
	    metadata: {
	      isMe: true,
	      appointmentSchedulingAllowed: currentUserAppointmentSchedulingForSelfAllowed
	    }
	  };
	}
	
	function filterDependents(list) {
	  return list.filter(function (_ref2) {
	    var metadata = _ref2.metadata;
	
	    if (metadata.status === 'pending') {
	      return metadata.careUserCreator;
	    }
	    return true;
	  });
	}

/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _AddNew = __webpack_require__(3055);
	
	var _AddNew2 = _interopRequireDefault(_AddNew);
	
	var _enhance = __webpack_require__(3056);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentUsers(_ref) {
	  var clearHealthPlans = _ref.clearHealthPlans,
	      clearProgress = _ref.clearProgress,
	      fetchCareUsers = _ref.fetchCareUsers,
	      fetchSchedulingTree = _ref.fetchSchedulingTree,
	      finishValidate = _ref.finishValidate,
	      formatMessage = _ref.formatMessage,
	      loading = _ref.loading,
	      hash = _ref.location.hash,
	      setCareUser = _ref.setCareUser,
	      users = _ref.users,
	      setDependentSubmitRedirect = _ref.setDependentSubmitRedirect;
	
	  var activeUserId = (0, _react.useMemo)(function () {
	    return hash.replace('#', '');
	  }, [hash]);
	
	  (0, _usePageView.usePageView)('Get Care | Who needs care?');
	
	  (0, _react.useEffect)(function () {
	    clearProgress();
	    clearHealthPlans();
	    finishValidate();
	    fetchCareUsers();
	  }, []);
	
	  var handleUserSelect = function handleUserSelect(user) {
	    fetchSchedulingTree({ userId: user.id, schedulingBy: 'patient' });
	    setCareUser(user);
	  };
	
	  function renderName(user, meta) {
	    return function () {
	      return meta.isMe ? formatMessage({ id: 'appointments.form.book4me' }) : user.displayableName;
	    };
	  }
	
	  function renderAvatar(user) {
	    return function () {
	      return _react2.default.createElement(_SimpleAvatar2.default, {
	        src: (0, _get2.default)(user, 'avatar.thumbMin'),
	        text: user.displayableName,
	        size: 44,
	        bordered: true
	      });
	    };
	  }
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.users' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      title: 'appointments.form.step1.title',
	      subtitle: 'appointments.form.step1.subTitle',
	      handleBack: _reactRouter.browserHistory.goBack
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      users.map(function (_ref2) {
	        var id = _ref2.id,
	            user = _ref2.user,
	            metadata = _ref2.metadata;
	
	        if (!metadata.appointmentSchedulingAllowed) {
	          return null;
	        }
	        return _react2.default.createElement(_Shape2.default, {
	          renderPrimary: renderName(user, metadata),
	          onClick: function onClick() {
	            return handleUserSelect(user);
	          },
	          renderLeft: renderAvatar(user),
	          active: id.toString() === activeUserId,
	          key: id
	        });
	      }),
	      !loading && _react2.default.createElement(_AddNew2.default, {
	        formatMessage: formatMessage,
	        setDependentSubmitRedirect: setDependentSubmitRedirect
	      }),
	      loading && _react2.default.createElement(_Loader2.default, null)
	    )
	  );
	}
	
	AppointmentUsers.propTypes = {
	  fetchSchedulingTree: PropTypes.func,
	  clearHealthPlans: PropTypes.func,
	  fetchCareUsers: PropTypes.func,
	  formatMessage: PropTypes.func,
	  setCareUser: PropTypes.func,
	  location: PropTypes.object,
	  loading: PropTypes.bool,
	  users: PropTypes.array,
	  finishValidate: PropTypes.func,
	  clearProgress: PropTypes.func,
	  setDependentSubmitRedirect: PropTypes.func
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentUsers);

/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(50);
	
	var _progressTypes = __webpack_require__(55);
	
	var _reasonVisitReq = __webpack_require__(1235);
	
	var reasonVisit = _interopRequireWildcard(_reasonVisitReq);
	
	var _selectors2 = __webpack_require__(43);
	
	var _styles = __webpack_require__(4906);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    service: (0, _selectors2.selectProgressService)(state),
	    careUser: (0, _selectors2.selectProgressCareUser)(state),
	    savedReason: (0, _selectors2.selectProgressReason)(state),
	    visitTypeCode: (0, _selectors2.selectProgressVisitTypeCode)(state),
	    services: (0, _selectors2.selectProgressServicesByVisit)(state),
	    allVisitTypes: (0, _selectors2.selectMyProvidersVisitTypes)(state),
	    requiredSteps: (0, _selectors2.selectInspectorRequiredSteps)(state),
	    organizationId: (0, _selectors2.selectProgressOrganizationId)(state),
	    rescheduleData: (0, _selectors2.selectProgressRescheduleData)(state),
	    organization: (0, _selectors2.selectProgressOrganization)(state),
	    programBasedVisitId: (0, _selectors2.selectProgramBasedVisitId)(state),
	    isUrgentVisitFlow: (0, _selectors2.selectProgressIsUrgentVisitFlow)(state),
	    careUserSkipInsurance: (0, _selectors2.selectProgressCareUserSkipInsurance)(state),
	    selectedOrganizationTenantSkipInsurance: (0, _selectors2.selectProgressOrganizationTenantSkipInsurance)(state),
	    countriesList: (0, _selectors.selectCountryList)(state),
	    reasonVisit: {
	      list: (0, _selectors2.selectReasonVisitList)(state),
	      loading: (0, _selectors2.selectReasonVisitPending)(state)
	    }
	  };
	};
	
	var mapDispatchToProps = {
	  reasonVisitReq: reasonVisit.actions.send,
	  setReason: _progressTypes.appointmentProgressActions.setReason,
	  setVisitType: _progressTypes.appointmentProgressActions.setVisitType
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var service = _ref.service,
	      reasonVisitReq = _ref.reasonVisitReq,
	      rescheduleData = _ref.rescheduleData,
	      countriesList = _ref.countriesList,
	      _ref$reasonVisit = _ref.reasonVisit,
	      reasonVisitInfo = _ref$reasonVisit === undefined ? {} : _ref$reasonVisit;
	  return {
	    loading: reasonVisitInfo.loading,
	    reasonVisitList: reasonVisitInfo.list.map(function (item) {
	      return {
	        value: item.id,
	        label: item.name
	      };
	    }),
	    fetchReasonVisit: function fetchReasonVisit() {
	      return reasonVisitReq({ serviceId: service.id });
	    },
	    reasonTypesList: function () {
	      if (service && service.reasonTypes) {
	        return service.reasonTypes.map(function (item) {
	          return {
	            label: item.name,
	            value: item.id
	          };
	        });
	      }
	      if (rescheduleData && rescheduleData.possibleReasonTypes) {
	        return rescheduleData.possibleReasonTypes.map(function (item) {
	          return {
	            value: item.id,
	            label: item.name,
	            visitTypeCodes: item.visitTypeCodes
	          };
	        });
	      }
	      return [];
	    }(),
	    countries: countriesList.map(function (country) {
	      return {
	        label: country.name,
	        value: country.name
	      };
	    }),
	    isRescheduleFlow: !!(0, _get2.default)(rescheduleData, 'id', null),
	    isEnabledInsurance: (0, _get2.default)(service, 'insuranceEligibilityCheckEnabled', false)
	  };
	}), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3059 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isNonEmptyString = exports.isNonEmptyString = function isNonEmptyString(value) {
	  return typeof value === 'string' && value.trim().length > 0;
	};
	
	var isNonEmptyArrayOrString = exports.isNonEmptyArrayOrString = function isNonEmptyArrayOrString(value) {
	  return (typeof value === 'string' || Array.isArray(value)) && value.length > 0;
	};

/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _useCountrySelect2 = __webpack_require__(145);
	
	var _selectors = __webpack_require__(50);
	
	var _selectors2 = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useAppointmentVisitDetailsStateData = function useAppointmentVisitDetailsStateData() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var country = (0, _reactRedux.useSelector)(_selectors2.selectAppointmentFormUserCountry);
	
	  var state = (0, _reactRedux.useSelector)(_selectors2.selectAppointmentFormUserState);
	
	  var countryList = (0, _reactRedux.useSelector)(_selectors.selectCountryList);
	
	  var _useCountrySelect = (0, _useCountrySelect2.useCountrySelect)(formatMessage),
	      loadCountryDetails = _useCountrySelect.loadCountryDetails,
	      stateList = _useCountrySelect.stateList;
	
	  var targetCountry = countryList.find(function (_ref) {
	    var name = _ref.name;
	    return name === country;
	  });
	
	  var targetCountryEntity = (0, _react.useMemo)(function () {
	    if (!targetCountry) return null;
	
	    return { label: targetCountry.name, value: targetCountry.isoCode };
	  }, [targetCountry]);
	
	  var stateOptions = (0, _react.useMemo)(function () {
	    return stateList.map(function (option) {
	      return {
	        value: option.label,
	        label: option.label
	      };
	    });
	  }, [stateList]);
	
	  (0, _react.useEffect)(function () {
	    var countryValue = (0, _get2.default)(targetCountryEntity, 'value', null);
	
	    if (countryValue) {
	      loadCountryDetails(countryValue);
	    }
	  }, [targetCountryEntity]);
	
	  return {
	    initCountryFormValue: (0, _get2.default)(targetCountryEntity, 'label', null),
	    state: state,
	    stateList: stateList,
	    stateOptions: stateOptions
	  };
	};
	
	exports.default = useAppointmentVisitDetailsStateData;

/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _ids = __webpack_require__(46);
	
	var _formFields = __webpack_require__(38);
	
	var _constants = __webpack_require__(17);
	
	var _enhance = __webpack_require__(3058);
	
	var _usePageView = __webpack_require__(52);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _useNavigateToPreviousPage = __webpack_require__(230);
	
	var _useNavigateToPreviousPage2 = _interopRequireDefault(_useNavigateToPreviousPage);
	
	var _useAppointmentVisitDetailsStateData = __webpack_require__(3060);
	
	var _useAppointmentVisitDetailsStateData2 = _interopRequireDefault(_useAppointmentVisitDetailsStateData);
	
	var _selectors = __webpack_require__(43);
	
	var _checkFieldValues = __webpack_require__(3059);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _progressTypes = __webpack_require__(55);
	
	var _redirectUtils = __webpack_require__(77);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _IDS$APPOINTMENT_FORM = _ids.IDS.APPOINTMENT_FORM,
	    OTHER_REASON_TYPE = _IDS$APPOINTMENT_FORM.OTHER_REASON_TYPE,
	    SUBMIT_REASON_TYPE = _IDS$APPOINTMENT_FORM.SUBMIT_REASON_TYPE;
	var REASON_NOTE = _formFields.PROFILE_FIELDS_TYPES.REASON_NOTE,
	    REASON_TYPE = _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE,
	    REASON_VISIT = _formFields.PROFILE_FIELDS_TYPES.REASON_VISIT,
	    COUNTRY = _formFields.PROFILE_FIELDS_TYPES.COUNTRY,
	    STATE = _formFields.PROFILE_FIELDS_TYPES.STATE,
	    IS_HOME_LOCATION_DIFFERENT = _formFields.PROFILE_FIELDS_TYPES.IS_HOME_LOCATION_DIFFERENT;
	
	
	function AppointmentVisitDetails(_ref) {
	  var formatMessage = _ref.formatMessage,
	      loading = _ref.loading,
	      fetchReasonVisit = _ref.fetchReasonVisit,
	      setReason = _ref.setReason,
	      savedReason = _ref.savedReason,
	      reasonTypesList = _ref.reasonTypesList,
	      reasonVisitList = _ref.reasonVisitList,
	      isUrgentVisitFlow = _ref.isUrgentVisitFlow,
	      visitTypeCode = _ref.visitTypeCode,
	      setVisitType = _ref.setVisitType,
	      allVisitTypes = _ref.allVisitTypes,
	      isRescheduleFlow = _ref.isRescheduleFlow,
	      rescheduleData = _ref.rescheduleData,
	      countries = _ref.countries,
	      organization = _ref.organization;
	
	  (0, _usePageView.usePageView)('Get Care | Visit Details');
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var isEirTelemedicineVisitType = (0, _reactRedux.useSelector)(_selectors.selectIsEirTelemedicineVisitTypeCode);
	
	  var isInlineVisitType = _constants.INLINE_TYPES.includes(visitTypeCode);
	
	  var isVirtualVisitType = _constants.FORBIDDEN_VISIT_TYPES_FOR_MAP.includes(visitTypeCode);
	
	  var _useAppointmentVisitD = (0, _useAppointmentVisitDetailsStateData2.default)(),
	      initCountryFormValue = _useAppointmentVisitD.initCountryFormValue,
	      stateList = _useAppointmentVisitD.stateList,
	      careUserStateName = _useAppointmentVisitD.stateName,
	      stateOptions = _useAppointmentVisitD.stateOptions;
	
	  var _useNavigateToPreviou = (0, _useNavigateToPreviousPage2.default)(),
	      navigateToPrevPage = _useNavigateToPreviou.navigateToPrevPage;
	
	  var initialFormValues = (0, _react.useMemo)(function () {
	    var values = (0, _extends3.default)({}, savedReason);
	
	    var reasonType = (0, _get2.default)(savedReason, 'reasonType.id', '');
	
	    if (reasonType) {
	      values[REASON_TYPE] = reasonType;
	    }
	
	    return values;
	  }, [savedReason]);
	
	  var _useFormState = (0, _useFormWithValidation.useFormState)(initialFormValues),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var makeField = (0, _getFieldProps.getFieldProps)(formatMessage, handleFormChange);
	
	  var reasonType = formState.reasonType,
	      reasonNote = formState.reasonNote,
	      _formState$reasonVisi = formState.reasonVisit,
	      reasonVisit = _formState$reasonVisi === undefined ? [] : _formState$reasonVisi,
	      isHomeLocationDifferent = formState.isHomeLocationDifferent,
	      state = formState.state,
	      country = formState.country;
	
	
	  var hasReasonNote = (0, _react.useMemo)(function () {
	    return reasonVisit.some(function (_ref2) {
	      var value = _ref2.value;
	      return value === OTHER_REASON_TYPE;
	    });
	  }, [reasonVisit]);
	
	  var reasonVisitListOptions = (0, _react.useMemo)(function () {
	    return reasonVisitList.concat({
	      value: OTHER_REASON_TYPE,
	      label: formatMessage({ id: 'common.other' })
	    });
	  }, [reasonVisitList]);
	
	  var isLimitedByStateCertification = (0, _get2.default)(organization, 'limitedByStateCertification', false);
	
	  var showHomeLocationCheckbox = isLimitedByStateCertification && (isVirtualVisitType || isEirTelemedicineVisitType);
	
	  var isOnlyOneReasonTypeInList = !loading && (0, _size2.default)(reasonTypesList) === 1;
	
	  var isValid = (0, _react.useMemo)(function () {
	    var getBaseValidation = function getBaseValidation() {
	      if (!reasonType) return false;
	
	      if (isUrgentVisitFlow) {
	        if (hasReasonNote) {
	          return (0, _checkFieldValues.isNonEmptyString)(reasonNote);
	        }
	        return (0, _checkFieldValues.isNonEmptyArrayOrString)(reasonVisit);
	      }
	
	      return (0, _checkFieldValues.isNonEmptyString)(reasonNote);
	    };
	
	    var baseValidation = getBaseValidation();
	
	    return isHomeLocationDifferent ? baseValidation && country && state : baseValidation;
	  }, [isUrgentVisitFlow, reasonType, hasReasonNote, reasonNote, reasonVisit, isHomeLocationDifferent, country, state]);
	
	  var handleSelectReasonType = function handleSelectReasonType(_ref3) {
	    var value = _ref3.value,
	        visitTypeCodes = _ref3.visitTypeCodes;
	
	    handleFormChange((0, _defineProperty3.default)({}, REASON_TYPE, value));
	    if (isRescheduleFlow) {
	      var targetVisitType = allVisitTypes.find(function (_ref4) {
	        var code = _ref4.code;
	        return code === visitTypeCodes[0];
	      }) || {};
	      setVisitType(targetVisitType);
	    }
	  };
	
	  var handleNext = function handleNext(e) {
	    e.preventDefault();
	
	    var targetReason = reasonTypesList.find(function (_ref5) {
	      var value = _ref5.value;
	      return value === formState[REASON_TYPE];
	    });
	
	    setReason((0, _extends3.default)({}, formState, {
	      reasonType: {
	        id: targetReason.value,
	        name: targetReason.label,
	        visitTypeCodes: targetReason.visitTypeCodes
	      }
	    }));
	
	    if (isRescheduleFlow) {
	      var locationId = (0, _get2.default)(rescheduleData, 'location.id');
	      var providerId = (0, _get2.default)(rescheduleData, 'providerInfo.id');
	      (0, _redirectUtils.redirectToRescheduleProviderDetails)({ locationId: locationId, providerId: providerId });
	    } else {
	      dispatch(_progressTypes.appointmentProgressActions.determineNextStepAfterVisitDetails());
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (isUrgentVisitFlow) {
	      fetchReasonVisit();
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (isOnlyOneReasonTypeInList) {
	      handleFormChange((0, _defineProperty3.default)({}, REASON_TYPE, reasonTypesList[0].value));
	    }
	  }, [reasonTypesList, isOnlyOneReasonTypeInList]);
	
	  (0, _react.useEffect)(function () {
	    if (!isInlineVisitType && !hasReasonNote) {
	      handleFormChange((0, _defineProperty3.default)({}, REASON_NOTE, ''));
	    }
	  }, [hasReasonNote, isInlineVisitType]);
	
	  (0, _react.useEffect)(function () {
	    handleFormChange((0, _defineProperty3.default)({}, COUNTRY, initCountryFormValue));
	  }, [initCountryFormValue]);
	
	  (0, _react.useEffect)(function () {
	    if (stateList.length && careUserStateName) {
	      var userState = stateList.find(function (s) {
	        return s.label === careUserStateName;
	      });
	
	      if (userState) handleFormChange((0, _defineProperty3.default)({}, STATE, userState.label));
	    }
	  }, [stateList, careUserStateName]);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(
	      'div',
	      null,
	      loading && _react2.default.createElement(_Loader2.default, { styleName: 'loader' })
	    ),
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.details' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      title: 'appointments.form.visitDetails',
	      handleBack: navigateToPrevPage
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleNext },
	        !isOnlyOneReasonTypeInList && _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(REASON_TYPE), {
	          value: reasonType,
	          options: reasonTypesList,
	          onChange: handleSelectReasonType
	        })),
	        isUrgentVisitFlow && _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(REASON_VISIT), {
	          multi: true,
	          value: reasonVisit,
	          options: reasonVisitListOptions
	        })),
	        isUrgentVisitFlow ? _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(REASON_NOTE), {
	          value: reasonNote,
	          disabled: isUrgentVisitFlow && !hasReasonNote
	        })) : _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(REASON_NOTE), {
	          value: reasonNote,
	          label: formatMessage({ id: 'fields.reasonNote' }),
	          placeholder: formatMessage({
	            id: 'fields.reasonNote.placeholder'
	          })
	        })),
	        showHomeLocationCheckbox && _react2.default.createElement(_Checkbox2.default, (0, _extends3.default)({}, makeField(IS_HOME_LOCATION_DIFFERENT), {
	          checked: Boolean(isHomeLocationDifferent)
	        })),
	        Boolean(isHomeLocationDifferent) && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(COUNTRY, Boolean(isHomeLocationDifferent) && _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	            value: country,
	            onChange: function onChange(value) {
	              return handleFormChange((0, _defineProperty3.default)({}, COUNTRY, value.value));
	            },
	            options: countries,
	            needUpdateDefaultValue: true,
	            required: Boolean(isHomeLocationDifferent),
	            disabled: true
	          })),
	          _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(STATE, Boolean(isHomeLocationDifferent) && _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	            onChange: function onChange(value) {
	              return handleFormChange((0, _defineProperty3.default)({}, STATE, value.value));
	            },
	            deleteRemoves: false,
	            backspaceRemoves: false,
	            value: state,
	            options: stateOptions,
	            needUpdateDefaultValue: true,
	            required: Boolean(isHomeLocationDifferent)
	          }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mt4 tr' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              id: SUBMIT_REASON_TYPE,
	              raised: true,
	              color: 'primary',
	              disabled: !isValid
	            },
	            formatMessage({ id: 'common.next' })
	          )
	        )
	      )
	    )
	  );
	}
	
	AppointmentVisitDetails.propTypes = {
	  services: PropTypes.array,
	  formatMessage: PropTypes.func,
	  updateData: PropTypes.func,
	  setReason: PropTypes.func,
	  loading: PropTypes.bool,
	  reasonTypesList: PropTypes.array,
	  reasonVisitList: PropTypes.array,
	  savedReason: PropTypes.object,
	  organization: PropTypes.object,
	  requiredSteps: PropTypes.array,
	  isUrgentVisitFlow: PropTypes.bool,
	  fetchReasonVisit: PropTypes.func,
	  visitTypeCode: PropTypes.string,
	  isEnabledInsurance: PropTypes.bool,
	  setVisitType: PropTypes.func,
	  clearRescheduleData: PropTypes.func,
	  isRescheduleFlow: PropTypes.bool,
	  allVisitTypes: PropTypes.array,
	  rescheduleData: PropTypes.object,
	  careUserSkipInsurance: PropTypes.bool,
	  selectedOrganizationTenantSkipInsurance: PropTypes.bool,
	  countries: PropTypes.array.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentVisitDetails);

/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _progressTypes = __webpack_require__(55);
	
	var _visitTypesReq = __webpack_require__(630);
	
	var visitTypes = _interopRequireWildcard(_visitTypesReq);
	
	var _withCareUserSubtitle = __webpack_require__(603);
	
	var _withCareUserSubtitle2 = _interopRequireDefault(_withCareUserSubtitle);
	
	var _constants = __webpack_require__(17);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    organization: (0, _selectors.selectProgressOrganization)(state),
	    programBasedVisitId: (0, _selectors.selectProgramBasedVisitId)(state)
	  };
	};
	var mapDispatchToProps = {
	  init: visitTypes.actions.init,
	  selectVisitType: _progressTypes.appointmentProgressActions.selectVisitType,
	  selectProgramBasedVisit: _progressTypes.appointmentProgressActions.selectProgramBasedVisit
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, _withCareUserSubtitle2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var organization = _ref.organization;
	  return {
	    programBasedVisits: organization.pbvConfigs || [],
	    types: organization.visitTypes.filter(function (_ref2) {
	      var code = _ref2.code;
	      return !_constants.APPOINTMENT_HIDDEN_TYPES.includes(code);
	    })
	  };
	}));

/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _visitTypePlaceholder = __webpack_require__(5266);
	
	var _visitTypePlaceholder2 = _interopRequireDefault(_visitTypePlaceholder);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AppointmentMyProviders = __webpack_require__(1704);
	
	var _AppointmentMyProviders2 = _interopRequireDefault(_AppointmentMyProviders);
	
	var _constants = __webpack_require__(17);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _enhance = __webpack_require__(3062);
	
	var _progressTypes = __webpack_require__(55);
	
	var _styles = __webpack_require__(4907);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentVisitType(_ref) {
	  var init = _ref.init,
	      types = _ref.types,
	      selectVisitType = _ref.selectVisitType,
	      programBasedVisits = _ref.programBasedVisits,
	      programBasedVisitId = _ref.programBasedVisitId,
	      selectProgramBasedVisit = _ref.selectProgramBasedVisit,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      externalLink = _useState4[0],
	      setExternalLink = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      selectedType = _useState6[0],
	      setSelectedType = _useState6[1];
	
	  var activeTypes = (0, _react.useMemo)(function () {
	    return types.filter(function (_ref2) {
	      var code = _ref2.code;
	      return _constants.APPOINTMENT_ALLOWED_TYPES.includes(code);
	    });
	  }, [types]);
	
	  (0, _usePageView.usePageView)('Get Care | Visit Type');
	
	  (0, _react.useEffect)(function () {
	    init();
	  }, []);
	
	  function renderImage(type) {
	    var src = (0, _get2.default)(type, 'icon.url') || (0, _get2.default)(type, 'organization.logo.thumbMin') || _visitTypePlaceholder2.default;
	    return function () {
	      return _react2.default.createElement('img', { alt: 'icon', style: { width: 40 }, src: src });
	    };
	  }
	
	  var handleBack = function handleBack() {
	    if (programBasedVisitId) {
	      init();
	    } else (0, _redirectUtils.redirectToUsers)();
	  };
	
	  var emptyState = (0, _react.useMemo)(function () {
	    return [activeTypes.length, programBasedVisits.length].every(function (el) {
	      return !el;
	    });
	  }, [activeTypes, programBasedVisits]);
	
	  var handleSelectVisitType = function handleSelectVisitType(type) {
	    if (type.code === _constants.URGENT_CARE_TYPE_CODE) {
	      setOpen(true);
	      if (type.additionalInfoLink) {
	        setExternalLink(type.additionalInfoLink);
	      }
	      setSelectedType(type);
	    } else {
	      selectVisitType(type);
	    }
	  };
	
	  var handleMoreInfo = function handleMoreInfo() {
	    if (externalLink) {
	      window.open(externalLink, '_blank');
	      setOpen(false);
	    } else {
	      setOpen(false);
	    }
	  };
	
	  var handleProceed = function handleProceed() {
	    setOpen(false);
	    selectVisitType(selectedType);
	  };
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    dispatch(_progressTypes.appointmentProgressActions.setReason(null));
	    dispatch(_progressTypes.appointmentProgressActions.setAdditionalInfoFormData(null));
	    dispatch(_progressTypes.appointmentProgressActions.setPrimaryCareProviderFormData(null));
	  }, []);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.visitType' }),
	    _react2.default.createElement(_AppointmentHeader2.default, { handleBack: handleBack }),
	    _react2.default.createElement(_AppointmentMyProviders2.default, null),
	    _react2.default.createElement(
	      'h2',
	      { className: _styles2.default.title },
	      formatMessage({ id: 'appointments.visitType' })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      programBasedVisits.map(function (visit) {
	        return _react2.default.createElement(_Shape2.default, {
	          renderPrimary: function renderPrimary() {
	            return visit.name;
	          },
	          onClick: function onClick() {
	            return selectProgramBasedVisit(visit);
	          },
	          renderSecondary: function renderSecondary() {
	            return visit.description;
	          },
	          renderLeft: renderImage(visit),
	          key: visit.id
	        });
	      }),
	      activeTypes.map(function (type) {
	        return _react2.default.createElement(_Shape2.default, {
	          renderPrimary: function renderPrimary() {
	            return type.name;
	          },
	          onClick: function onClick() {
	            return handleSelectVisitType(type);
	          },
	          renderSecondary: function renderSecondary() {
	            return type.description;
	          },
	          renderLeft: renderImage(type),
	          key: type.id
	        });
	      }),
	      emptyState && _react2.default.createElement(_Content2.default, {
	        className: _styles2.default.emptyBlock,
	        text: formatMessage({ id: 'appointments.emptyVisitTypes' }),
	        icon: 'search-list',
	        size: 132
	      }),
	      open && _react2.default.createElement(
	        _Popup2.default,
	        {
	          opened: open,
	          onClose: function onClose() {
	            return setOpen(false);
	          },
	          withHeading: false,
	          mobileFullScreen: false,
	          width: 'notification',
	          contentNoPadding: true
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.modalWrapper },
	          _react2.default.createElement(_Icon2.default, { name: 'information', size: 48 }),
	          _react2.default.createElement(
	            'h1',
	            { className: _styles2.default.modalTitle },
	            formatMessage({ id: 'common.important' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.description },
	            formatMessage({
	              id: 'visitType.urgentCare.description'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.buttonsWrapper },
	            _react2.default.createElement(
	              _Button2.default,
	              { color: 'accent', onClick: handleMoreInfo },
	              formatMessage({ id: 'common.moreInfo' })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { color: 'primary', onClick: handleProceed },
	              formatMessage({ id: 'submit.expiredToken' })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	AppointmentVisitType.propTypes = {
	  init: PropTypes.func,
	  types: PropTypes.array,
	  intl: PropTypes.object,
	  selectVisitType: PropTypes.func,
	  programBasedVisits: PropTypes.array,
	  programBasedVisitId: PropTypes.number,
	  selectProgramBasedVisit: PropTypes.func
	};
	
	exports.default = (0, _enhance.enhance)(AppointmentVisitType);

/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(43);
	
	var _progressTypes = __webpack_require__(55);
	
	var _withCareUserSubtitle = __webpack_require__(603);
	
	var _withCareUserSubtitle2 = _interopRequireDefault(_withCareUserSubtitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    timeSlots: (0, _selectors.selectInlineVisitTimeSlots)(state),
	    visitType: (0, _selectors.selectProgressVisitType)(state),
	    schedule: (0, _selectors.selectProgressSchedule)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  setScheduleData: _progressTypes.appointmentProgressActions.setScheduleData
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, _withCareUserSubtitle2.default, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _AppointmentHeader = __webpack_require__(118);
	
	var _AppointmentHeader2 = _interopRequireDefault(_AppointmentHeader);
	
	var _TimeSlots = __webpack_require__(761);
	
	var _TimeSlots2 = _interopRequireDefault(_TimeSlots);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _usePageView = __webpack_require__(52);
	
	var _enhance = __webpack_require__(3064);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _styles = __webpack_require__(4908);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AvailableTimeSlots(_ref) {
	  var formatMessage = _ref.formatMessage,
	      timeSlots = _ref.timeSlots,
	      visitType = _ref.visitType,
	      setScheduleData = _ref.setScheduleData,
	      time = _ref.schedule.time,
	      subtitle = _ref.subtitle;
	
	  var _useState = (0, _react.useState)(time),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeTimeSlot = _useState2[0],
	      setActiveTimeSlot = _useState2[1];
	
	  (0, _usePageView.usePageView)('Get Care | Available Time Slots');
	
	  var handleTimeSelect = function handleTimeSelect(timeSlot) {
	    setActiveTimeSlot(timeSlot);
	  };
	
	  var handleSubmit = function handleSubmit() {
	    setScheduleData({ time: activeTimeSlot });
	    (0, _redirectUtils.redirectToAppointmentOverview)();
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.getCare.timeSlots' }),
	    _react2.default.createElement(_AppointmentHeader2.default, {
	      title: {
	        text: visitType.name + ' ' + formatMessage({
	          id: 'common.visit'
	        })
	      },
	      subtitle: subtitle,
	      handleBack: _redirectUtils.redirectToAppointmentOverview
	    }),
	    _react2.default.createElement(
	      _Shape2.default,
	      { className: _styles2.default.header },
	      _react2.default.createElement(_BackButton2.default, { onBack: _redirectUtils.redirectToAppointmentOverview, hasTitle: false }),
	      _react2.default.createElement(
	        'p',
	        null,
	        formatMessage({ id: 'appointment.inlineVisit.availableTimeSlots' })
	      )
	    ),
	    _react2.default.createElement(
	      _Shape2.default,
	      { className: _styles2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.slots },
	        _react2.default.createElement(_TimeSlots2.default, {
	          variant: 'sm',
	          list: timeSlots,
	          onSelect: handleTimeSelect,
	          activeSlot: activeTimeSlot
	        })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { onClick: handleSubmit, color: 'primary', raised: true },
	        formatMessage({ id: 'common.ok' })
	      )
	    )
	  );
	}
	
	AvailableTimeSlots.propTypes = {
	  formatMessage: PropTypes.func,
	  timeSlots: PropTypes.array,
	  visitType: PropTypes.object,
	  setScheduleData: PropTypes.func,
	  schedule: PropTypes.object,
	  subtitle: PropTypes.object
	};
	
	exports.default = (0, _enhance.enhance)(AvailableTimeSlots);

/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styles = __webpack_require__(4909);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CompleteInlineVisitModal(_ref) {
	  var isOpened = _ref.isOpened,
	      formatMessage = _ref.formatMessage,
	      userId = _ref.userId;
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      opened: isOpened,
	      withHeading: false,
	      mobileFullScreen: false,
	      width: 'rubber',
	      contentNoPadding: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.root },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.title },
	        formatMessage({
	          id: 'appointment.inlineVisit.success.inLine.title'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.message },
	        formatMessage({
	          id: 'appointment.inlineVisit.success.inLine.description'
	        })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          raised: true,
	          color: 'primary',
	          className: _styles2.default.button,
	          onClick: function onClick() {
	            return (0, _redirectUtils.redirectToHealthBoard)(userId);
	          }
	        },
	        formatMessage({ id: 'common.complete' })
	      )
	    )
	  );
	}
	
	CompleteInlineVisitModal.propTypes = {
	  isOpened: PropTypes.bool,
	  formatMessage: PropTypes.func,
	  userId: PropTypes.number
	};
	
	exports.default = CompleteInlineVisitModal;

/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(43);
	
	var _styles = __webpack_require__(4910);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    globalPending: (0, _selectors.selectProgressGlobalPending)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _RadioGroup = __webpack_require__(1837);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _PaymentAccountFormLoader = __webpack_require__(1189);
	
	var _PaymentAccountFormLoader2 = _interopRequireDefault(_PaymentAccountFormLoader);
	
	var _styles = __webpack_require__(18);
	
	var _props = __webpack_require__(41);
	
	var _useDefaultCard2 = __webpack_require__(1858);
	
	var _useDefaultCard3 = _interopRequireDefault(_useDefaultCard2);
	
	var _currency = __webpack_require__(4206);
	
	var _popup = __webpack_require__(76);
	
	var _accountVaultsForm = __webpack_require__(354);
	
	var _appointmentAccountFormPaymentReq = __webpack_require__(339);
	
	var _appointmentPaymentInfoModal = __webpack_require__(1220);
	
	var _selectors = __webpack_require__(64);
	
	var _selectors2 = __webpack_require__(264);
	
	var _selectors3 = __webpack_require__(294);
	
	var _selectors4 = __webpack_require__(43);
	
	var _stylesModule = __webpack_require__(4911);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var labelStyle = {
	  fontSize: '12px',
	  fontWeight: 'normal',
	  lineHeight: 'normal',
	  opacity: 1,
	  color: _styles.COLORS.fontRegular
	};
	
	var AppointmentPaymentInfoPopup = function AppointmentPaymentInfoPopup() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      cardAgreement = _useState2[0],
	      setCardAgreement = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      selectedCardId = _useState4[0],
	      setSelectedCardId = _useState4[1];
	
	  var isOpened = (0, _reactRedux.useSelector)(_selectors4.selectAppointmentPaymentInfoModalOpened);
	
	  var modalProps = (0, _reactRedux.useSelector)(_selectors4.selectAppointmentPaymentInfoModalProps);
	
	  var areCardsLoading = (0, _reactRedux.useSelector)(_selectors2.selectAccountVaultsListLoading);
	
	  var appointmentAccountFormPaymentSending = (0, _reactRedux.useSelector)(_selectors3.selectAppointmentAccountFormPaymentSending);
	
	  var price = (0, _reactRedux.useSelector)(_selectors.selectPaymentOrderAmount);
	
	  var _useDefaultCard = (0, _useDefaultCard3.default)(),
	      defaultCard = _useDefaultCard.defaultCard,
	      mappedCards = _useDefaultCard.mappedCards;
	
	  var addPaymentMethodTitle = formatMessage({
	    id: 'paya.payment.addNewPaymentMethod'
	  });
	
	  var formDescription = formatMessage({
	    id: 'profile.payment.addCardForFutureUse'
	  });
	
	  var _ref = modalProps || {},
	      userId = _ref.userId,
	      locationId = _ref.locationId,
	      paymentOrderId = _ref.paymentOrderId;
	
	  var isSubmitDisabled = !selectedCardId || !cardAgreement;
	
	  var amount = (0, _react.useMemo)(function () {
	    return (0, _currency.formatCurrencyUSD)(price);
	  }, [price]);
	
	  var handleOnChange = function handleOnChange(id) {
	    return setSelectedCardId(id);
	  };
	
	  var onClose = function onClose() {
	    dispatch(_appointmentPaymentInfoModal.appointmentPaymentInfoModalActions.close());
	  };
	
	  var handleAddNewCard = function handleAddNewCard() {
	    dispatch(_accountVaultsForm.actions.send({
	      userId: userId,
	      locationId: locationId
	    }));
	
	    dispatch({
	      type: _popup.consts.SHOW,
	      payload: {
	        contentType: _props.UI_POPUP_TYPES.PAYA_ACCOUNT_FORM,
	        contentOptions: {
	          noCards: false
	        }
	      }
	    });
	  };
	
	  var handleSubmitPayment = function handleSubmitPayment() {
	    dispatch(_appointmentAccountFormPaymentReq.actions.send({
	      accountVaultId: selectedCardId,
	      paymentOrderId: paymentOrderId
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    if (defaultCard) {
	      setSelectedCardId(defaultCard.id);
	    }
	  }, [defaultCard]);
	
	  (0, _react.useEffect)(function () {
	    if (!isOpened) {
	      onClose();
	      dispatch(_appointmentAccountFormPaymentReq.actions.clear());
	      setCardAgreement(false);
	      setSelectedCardId(undefined);
	    }
	  }, [isOpened]);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    { opened: isOpened, withHeading: false },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.root },
	      _react2.default.createElement(_BackButton2.default, {
	        onBack: onClose,
	        className: _stylesModule2.default.backBtn,
	        minWidth: 100
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_stylesModule2.default.content, (0, _defineProperty3.default)({}, _stylesModule2.default.loading, appointmentAccountFormPaymentSending))
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.mainTitle },
	          formatMessage({ id: 'appointment.list.card.payment' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.headerDescription },
	          formDescription
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.description },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.cellTitle },
	              formatMessage({ id: 'paya.payment.amount' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.cellText },
	              amount
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.card },
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.title },
	            formatMessage({ id: 'paya.payment.card' })
	          ),
	          areCardsLoading && !mappedCards.length ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(_RadioGroup2.default, {
	            name: 'cardsradioBtn',
	            value: selectedCardId,
	            onChange: handleOnChange,
	            radios: mappedCards
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.btnAdd },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onClick: handleAddNewCard },
	              _react2.default.createElement(_Icon2.default, { name: 'add-text', size: 16, className: _stylesModule2.default.icon }),
	              _react2.default.createElement(
	                'span',
	                null,
	                addPaymentMethodTitle
	              )
	            )
	          ),
	          _react2.default.createElement(_Checkbox2.default, {
	            size: 16,
	            id: 'cardAgreement',
	            name: 'cardAgreement',
	            checked: cardAgreement,
	            labelStyle: labelStyle,
	            label: formatMessage({ id: 'paya.payment.cardAgreement' }),
	            onChange: function onChange() {
	              return setCardAgreement(function (prev) {
	                return !prev;
	              });
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.transactionDescription },
	            formatMessage({ id: 'paya.payment.transactionDescription' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.btnSubmit },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              disabled: isSubmitDisabled,
	              color: 'primary',
	              onClick: handleSubmitPayment
	            },
	            formatMessage({ id: 'paya.payment.submitPayment' })
	          )
	        )
	      )
	    ),
	    appointmentAccountFormPaymentSending && _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.loaderWrapper },
	      _react2.default.createElement(_PaymentAccountFormLoader2.default, null)
	    )
	  );
	};
	
	exports.default = AppointmentPaymentInfoPopup;

/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _useDayPicker2 = __webpack_require__(3070);
	
	var _styles = __webpack_require__(4912);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DayPicker(_ref) {
	  var activeDate = _ref.activeDate,
	      onChange = _ref.onChange,
	      disabled = _ref.disabled;
	
	  var _useDayPicker = (0, _useDayPicker2.useDayPicker)(activeDate),
	      offset = _useDayPicker.offset,
	      options = _useDayPicker.options,
	      disabledNext = _useDayPicker.disabledNext,
	      disabledPrev = _useDayPicker.disabledPrev,
	      handleNext = _useDayPicker.handleNext,
	      handleBack = _useDayPicker.handleBack,
	      daysBoxRef = _useDayPicker.daysBoxRef;
	
	  function printDateList() {
	    return options.dateList.map(function (_ref2) {
	      var timestamp = _ref2.timestamp,
	          dayText = _ref2.dayText,
	          dateText = _ref2.dateText;
	
	      var active = activeDate === timestamp;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onClick: function onClick() {
	            return onChange(timestamp);
	          },
	          styleName: 'DayItem',
	          key: timestamp
	        },
	        _react2.default.createElement(
	          'div',
	          { styleName: (0, _classnames2.default)('DayItemWrapper', { active: active }) },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'DayItemDay' },
	            dayText
	          ),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'DayItemDate' },
	            dateText
	          )
	        )
	      );
	    });
	  }
	
	  return _react2.default.createElement(
	    _Shape2.default,
	    { styleName: (0, _classnames2.default)('DayPicker', { disabled: disabled }) },
	    _react2.default.createElement(
	      'div',
	      {
	        styleName: (0, _classnames2.default)('DayPickerBack', { disabled: disabledPrev }),
	        onClick: handleBack
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'arrow-back' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'DayPickerContainer', ref: daysBoxRef },
	      _react2.default.createElement(
	        'div',
	        {
	          styleName: 'DayPickerCarousel',
	          style: {
	            width: options.MAX_WIDTH,
	            transform: 'translate3d(' + offset + 'px, 0, 0)'
	          }
	        },
	        printDateList()
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        styleName: (0, _classnames2.default)('DayPickerNext', { disabled: disabledNext }),
	        onClick: handleNext
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'arrow-back' })
	    )
	  );
	}
	
	DayPicker.propTypes = {
	  onChange: PropTypes.func,
	  activeDate: PropTypes.string,
	  disabled: PropTypes.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(DayPicker, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useDayPicker = useDayPicker;
	
	var _react = __webpack_require__(1);
	
	var _dateFns = __webpack_require__(275);
	
	var _dateFilter = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DAY_WIDTH = 83;
	
	var SAFETY_PADDING_PX = 10;
	
	function useDayPicker(activeDate) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$days = _ref.days,
	      days = _ref$days === undefined ? 14 : _ref$days,
	      _ref$ITEMS_TO_DISPLAY = _ref.ITEMS_TO_DISPLAY,
	      ITEMS_TO_DISPLAY = _ref$ITEMS_TO_DISPLAY === undefined ? 6 : _ref$ITEMS_TO_DISPLAY;
	
	  var daysBoxRef = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      offset = _useState2[0],
	      setOffset = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(ITEMS_TO_DISPLAY),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      itemsToDisplay = _useState4[0],
	      setItemsToDisplay = _useState4[1];
	
	  var options = (0, _react.useMemo)(function () {
	    var today = (0, _dateFns.startOfDay)(new Date());
	    var activeDateObj = activeDate ? new Date(activeDate) : null;
	    var daysNeeded = activeDateObj && (0, _dateFns.isAfter)(activeDateObj, today) ? Math.max(days, (0, _dateFns.differenceInCalendarDays)(activeDateObj, today) + Math.ceil(itemsToDisplay)) : days;
	    var dateList = (0, _dateFilter.makeDateList)(daysNeeded, null);
	    var timestampList = dateList.map(function (_ref2) {
	      var timestamp = _ref2.timestamp;
	      return timestamp;
	    });
	    var MAX_WIDTH = DAY_WIDTH * dateList.length;
	    var LIMIT_NEXT = itemsToDisplay * DAY_WIDTH - MAX_WIDTH;
	
	    return {
	      dateList: dateList,
	      timestampList: timestampList,
	      MAX_WIDTH: MAX_WIDTH,
	      LIMIT_NEXT: LIMIT_NEXT
	    };
	  }, [days, itemsToDisplay, activeDate]);
	
	  var disabledNext = offset <= options.LIMIT_NEXT;
	  var disabledPrev = offset >= 0;
	
	  var handleNext = function handleNext() {
	    return setOffset(function (prev) {
	      var coord = prev - DAY_WIDTH;
	
	      if (coord - SAFETY_PADDING_PX <= options.LIMIT_NEXT) {
	        return options.LIMIT_NEXT;
	      }
	
	      return coord;
	    });
	  };
	
	  var handleBack = function handleBack() {
	    setOffset(function (prev) {
	      var coord = prev + DAY_WIDTH;
	
	      if (coord + SAFETY_PADDING_PX >= 0) {
	        return 0;
	      }
	
	      return coord;
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    if (!activeDate) return;
	
	    var activeIndex = options.timestampList.findIndex(function (ts) {
	      return (0, _dateFns.isSameDay)(new Date(ts), new Date(activeDate));
	    });
	    if (activeIndex < 0) return;
	
	    var newOffset = -activeIndex * DAY_WIDTH;
	    setOffset(Math.max(options.LIMIT_NEXT, Math.min(0, newOffset)));
	  }, [activeDate, itemsToDisplay]);
	
	  (0, _react.useEffect)(function () {
	    if (daysBoxRef.current) {
	      var rect = daysBoxRef.current.getBoundingClientRect();
	
	      var width = rect.width;
	
	
	      var newItemsToDisplay = width / DAY_WIDTH;
	      setItemsToDisplay(newItemsToDisplay);
	    }
	  }, [activeDate]);
	
	  return {
	    offset: offset,
	    options: options,
	    handleNext: handleNext,
	    handleBack: handleBack,
	    disabledNext: disabledNext,
	    disabledPrev: disabledPrev,
	    daysBoxRef: daysBoxRef
	  };
	}

/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Popover = __webpack_require__(250);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _arrayModify = __webpack_require__(153);
	
	var _renderAddress = __webpack_require__(1093);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(4914);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LocationPicker(_ref) {
	  var formatMessage = _ref.formatMessage,
	      filterList = _ref.filterList,
	      onApply = _ref.onApply,
	      activeLocations = _ref.activeLocations,
	      isVirtualVisit = _ref.isVirtualVisit;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      anchorEl = _useState2[0],
	      setAnchor = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(activeLocations),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      locations = _useState4[0],
	      setLocations = _useState4[1];
	
	  var locationSize = (0, _size2.default)(locations);
	  var showCounter = locationSize !== 0 && locationSize !== (0, _size2.default)(filterList);
	
	  (0, _react.useEffect)(function () {
	    setLocations(activeLocations);
	  }, [activeLocations]);
	
	  var handleOpen = function handleOpen(event) {
	    return setAnchor(event.currentTarget);
	  };
	  var handleClose = function handleClose() {
	    setAnchor(null);
	    setLocations(activeLocations);
	  };
	  var handleSelect = function handleSelect(id) {
	    return setLocations((0, _arrayModify.toggleElementInList)(locations, id));
	  };
	  var handleApply = function handleApply() {
	    setAnchor(null);
	    onApply(locations);
	  };
	  var resetLocationFilter = function resetLocationFilter(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    onApply([]);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        styleName: (0, _classnames2.default)('LocationPickerTrigger', { fill: showCounter }),
	        onClick: handleOpen,
	        color: 'accent',
	        border: true
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'location', styleName: 'left-icon' }),
	      formatMessage({ id: 'dashboard.filter.location' }),
	      showCounter && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        ':',
	        locationSize,
	        _react2.default.createElement(_Icon2.default, {
	          onClick: resetLocationFilter,
	          styleName: 'right-icon',
	          name: 'close'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _Popover2.default,
	      {
	        open: Boolean(anchorEl),
	        anchorEl: anchorEl,
	        onClose: handleClose,
	        anchorOrigin: {
	          vertical: 'bottom',
	          horizontal: 'center'
	        },
	        transformOrigin: {
	          vertical: 'top',
	          horizontal: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'LocationPicker' },
	        filterList.map(function (_ref2) {
	          var id = _ref2.id,
	              name = _ref2.name,
	              rest = (0, _objectWithoutProperties3.default)(_ref2, ['id', 'name']);
	          return _react2.default.createElement(
	            'div',
	            { styleName: 'LocationPickerRow', key: id },
	            _react2.default.createElement(
	              _Checkbox2.default,
	              {
	                id: 'location-' + id,
	                checked: locations.includes(id),
	                onChange: function onChange() {
	                  return handleSelect(id);
	                },
	                size: 14
	              },
	              _react2.default.createElement(
	                'div',
	                { styleName: 'LocationPickerInfo' },
	                _react2.default.createElement(
	                  'div',
	                  { styleName: 'strong' },
	                  name
	                ),
	                !isVirtualVisit && _react2.default.createElement(
	                  'div',
	                  { styleName: 'meta' },
	                  (0, _renderAddress.renderAddress)(rest)
	                )
	              )
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'tr' },
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: handleApply, color: 'primary' },
	            formatMessage({ id: 'common.apply' })
	          )
	        )
	      )
	    )
	  );
	}
	
	LocationPicker.propTypes = {
	  formatMessage: PropTypes.func,
	  onApply: PropTypes.func,
	  filterList: PropTypes.array,
	  isVirtualVisit: PropTypes.bool,
	  activeLocations: PropTypes.array
	};
	
	exports.default = (0, _reactCssModules2.default)(LocationPicker, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(42);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _providerDetailsFormatter = __webpack_require__(904);
	
	var _progressTypes = __webpack_require__(55);
	
	var _providerGWDetailsReq = __webpack_require__(802);
	
	var providerGWDetails = _interopRequireWildcard(_providerGWDetailsReq);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _routes = __webpack_require__(37);
	
	var _ProviderNameAvatar = __webpack_require__(1092);
	
	var _ProviderNameAvatar2 = _interopRequireDefault(_ProviderNameAvatar);
	
	var _TimeSlots = __webpack_require__(761);
	
	var _TimeSlots2 = _interopRequireDefault(_TimeSlots);
	
	var _selectors = __webpack_require__(43);
	
	var _constants = __webpack_require__(17);
	
	var _styles = __webpack_require__(4915);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProviderCard(_ref) {
	  var provider = _ref.provider,
	      onTimeSelect = _ref.onTimeSelect,
	      locationId = _ref.locationId;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var renderProviderSubTitle = (0, _react.useCallback)(_providerDetailsFormatter.fullProviderSubtitle, []);
	  var payload = (0, _reactRedux.useSelector)(_selectors.selectSchedulePayloadData);
	  var date = (0, _reactRedux.useSelector)(_selectors.selectAppointmentDateFilter);
	  var organizationId = (0, _reactRedux.useSelector)(_selectors.selectProgressOrganizationId);
	
	  var _ref2 = provider || {},
	      id = _ref2.id,
	      timeSlots = _ref2.timeSlots,
	      timeSlotsSource = _ref2.timeSlotsSource;
	
	  var isGWCreatedFlow = (0, _get2.default)(provider, 'timeSlotsSource', '') !== _constants.PROVIDER_CALENDAR_SOURCE;
	
	  var providerPath = (0, _react.useMemo)(function () {
	    var formattedUrl = _routes.APPOINTMENT_FORM_PROVIDER_DETAILS.replace(':id', id);
	    return _routes.APPOINTMENT_FORM + '/' + formattedUrl + '#' + locationId;
	  }, [id, locationId]);
	
	  var handleTimeSelectPerProvider = function handleTimeSelectPerProvider(time) {
	    if (isGWCreatedFlow) {
	      var data = (0, _extends3.default)({}, payload, {
	        providerId: id,
	        date: date,
	        organizationId: organizationId,
	        timeSlotsSource: timeSlotsSource
	      });
	      dispatch(providerGWDetails.actions.send(data));
	    }
	    handleOnClick();
	    onTimeSelect(time, provider);
	  };
	
	  var handleOnClick = function handleOnClick() {
	    dispatch(_progressTypes.appointmentProgressActions.setCreateTypeFlowGW(isGWCreatedFlow));
	  };
	
	  return _react2.default.createElement(
	    _Shape2.default,
	    { styleName: 'root' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'row' },
	      _react2.default.createElement(_ProviderNameAvatar2.default, {
	        withoutLocation: true,
	        avatarSize: 40,
	        provider: provider,
	        renderMeta: renderProviderSubTitle
	      }),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'right' },
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: providerPath, onClick: handleOnClick, styleName: 'link' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'reports.seeDetails' })
	        )
	      )
	    ),
	    _react2.default.createElement('div', { styleName: 'separator' }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'content' },
	      _react2.default.createElement(_TimeSlots2.default, { list: timeSlots, onSelect: handleTimeSelectPerProvider })
	    )
	  );
	}
	
	ProviderCard.propTypes = {
	  provider: PropTypes.object,
	  onTimeSelect: PropTypes.func,
	  locationId: PropTypes.number
	};
	
	exports.default = (0, _reactCssModules2.default)(ProviderCard, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3073 */,
/* 3074 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var sequenceWords = exports.sequenceWords = function sequenceWords(arrayOfWords) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
	  return arrayOfWords.filter(function (w) {
	    return w;
	  }).join(separator);
	};

/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _userDetailsReq = __webpack_require__(629);
	
	var userDetails = _interopRequireWildcard(_userDetailsReq);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    careUser: (0, _selectors.selectProgressCareUser)(state),
	    patientForm: (0, _selectors.selectProgressPatientForm)(state),
	    userDetailsLoading: (0, _selectors.selectUserDetailsPending)(state),
	    details: (0, _selectors.selectUserDetails)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  userDetailsReq: userDetails.actions.send
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.lifecycle)({
	  componentDidMount: function componentDidMount() {
	    var _props = this.props,
	        patientForm = _props.patientForm,
	        careUser = _props.careUser,
	        userDetailsReq = _props.userDetailsReq,
	        details = _props.details;
	    var id = careUser.id;
	
	
	    if (!patientForm && (0, _get2.default)(details, 'id') !== id) {
	      userDetailsReq({ id: id });
	    }
	  }
	}));

/***/ }),
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _strings = __webpack_require__(15);
	
	var _routes = __webpack_require__(37);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AccessDenied = function AccessDenied(_ref) {
	  var forwardRoute = _ref.forwardRoute;
	
	  (0, _usePageView.usePageView)('Access Denied');
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'formWrapper' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.accessDenied' }),
	    _react2.default.createElement(
	      'p',
	      { styleName: 'formTitle' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.titles.accessDenied)
	    ),
	    _react2.default.createElement(
	      'p',
	      { styleName: 'formText', className: 'mb4' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.actions.accessDenied.textTitle)
	    ),
	    forwardRoute.path !== 'communities' ? _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'db w-100',
	        color: 'primary',
	        raised: true,
	        type: 'button',
	        onClick: function onClick() {
	          return _browserHistory2.default.push('/' + forwardRoute.path);
	        }
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, forwardRoute.name)
	    ) : null
	  );
	};
	
	AccessDenied.propTypes = {
	  forwardRoute: _propTypes2.default.shape({
	    name: _propTypes2.default.object,
	    path: _propTypes2.default.string
	  })
	};
	
	AccessDenied.defaultProps = {
	  forwardRoute: {
	    name: _strings.COMMON.myHealthboard,
	    path: _routes.HEALTHBOARD
	  }
	};
	
	exports.default = (0, _reactCssModules2.default)(AccessDenied, _index2.default, { allowMultiple: true });

/***/ }),
/* 3081 */,
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(56);
	
	var _selectors2 = __webpack_require__(403);
	
	var _selectors3 = __webpack_require__(93);
	
	var _selectors4 = __webpack_require__(50);
	
	var _actions = __webpack_require__(632);
	
	var _selectors5 = __webpack_require__(23);
	
	var _getSelectOptions = __webpack_require__(1163);
	
	var _actions2 = __webpack_require__(1871);
	
	var _selectors6 = __webpack_require__(1239);
	
	var _checkCountryForOrganization = __webpack_require__(1926);
	
	var _checkCountryForOrganization2 = _interopRequireDefault(_checkCountryForOrganization);
	
	var _parseJSONSafely = __webpack_require__(910);
	
	var _parseJSONSafely2 = _interopRequireDefault(_parseJSONSafely);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    nameSuffixList: (0, _selectors4.selectNameSuffixesList)(state),
	    profile: (0, _selectors5.loggedUserSelector)(state),
	    dataValidationErrors: (0, _selectors.selectEditedUserErrors)(state),
	    profileEditable: (0, _parseJSONSafely2.default)(localStorage.getItem('fieldsEditable')),
	    personalInfoData: (0, _selectors2.selectSignupPersonalInfoFormData)(state),
	    signupData: (0, _selectors2.selectSignupProcessFormData)(state),
	    changePasswordData: (0, _selectors6.selectChangePasswordProcessFormData)(state),
	    isPasswordUpdate: (0, _selectors3.selectRequestPasswordUpdate)(state),
	    countriesList: (0, _selectors4.selectCountryList)(state),
	    pendingProcess: (0, _selectors.selectSignupProcessPending)(state),
	    rawGenderList: (0, _selectors4.selectGenderTypes)(state),
	    races: (0, _selectors4.selectRaceTypes)(state),
	    ethnicitys: (0, _selectors4.selectEthnicTypes)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  confirmSignUp: _actions.signupActions.confirm,
	  confirmChangePassword: _actions2.changePasswordActions.confirm,
	  personalInfoChange: _actions.signupActions.personalInfoChange
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      signupData = _ref.signupData,
	      confirmSignUp = _ref.confirmSignUp,
	      changePasswordData = _ref.changePasswordData,
	      confirmChangePassword = _ref.confirmChangePassword,
	      profile = _ref.profile,
	      isPasswordUpdate = _ref.isPasswordUpdate,
	      countriesList = _ref.countriesList,
	      rawGenderList = _ref.rawGenderList,
	      races = _ref.races,
	      ethnicitys = _ref.ethnicitys;
	
	  var _ref2 = profile || {},
	      id = _ref2.id,
	      userOrganizations = _ref2.userOrganizations;
	
	  return {
	    confirm: isPasswordUpdate ? confirmChangePassword : confirmSignUp,
	    firstStepData: signupData || changePasswordData,
	    userId: id,
	    formatMessage: formatMessage,
	    isPasswordUpdate: isPasswordUpdate,
	    title: 'titles.signup',
	    countries: (0, _getSelectOptions.getSelectOptions)(countriesList.map(function (country) {
	      return country && country.name;
	    })),
	    genderList: (0, _convertListWithLocalization.convertGenderList)(rawGenderList, formatMessage) || [],
	    countryForOrganization: (0, _checkCountryForOrganization2.default)(userOrganizations),
	    races: races,
	    ethnicitys: ethnicitys
	  };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _useAuthPersonalInfoState = __webpack_require__(1712);
	
	var _AuthPersonalInfoForm = __webpack_require__(1708);
	
	var _AuthPersonalInfoForm2 = _interopRequireDefault(_AuthPersonalInfoForm);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _routes = __webpack_require__(37);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _enhance = __webpack_require__(3082);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthPersonalInfo = function AuthPersonalInfo(_ref) {
	  var errors = _ref.dataValidationErrors,
	      formatMessage = _ref.formatMessage,
	      nameSuffixList = _ref.nameSuffixList,
	      profile = _ref.profile,
	      confirm = _ref.confirm,
	      personalInfoChange = _ref.personalInfoChange,
	      personalInfoData = _ref.personalInfoData,
	      profileEditable = _ref.profileEditable,
	      firstStepData = _ref.firstStepData,
	      userId = _ref.userId,
	      title = _ref.title,
	      countries = _ref.countries,
	      pendingProcess = _ref.pendingProcess,
	      genderList = _ref.genderList,
	      races = _ref.races,
	      ethnicitys = _ref.ethnicitys,
	      changePasswordData = _ref.changePasswordData,
	      countryForOrganization = _ref.countryForOrganization;
	
	  var formStateRef = (0, _react.useRef)({});
	
	  var _useAuthPersonalInfoF = (0, _useAuthPersonalInfoState.useAuthPersonalInfoForm)((0, _extends3.default)({}, profile, personalInfoData), errors, {
	    showPrivacy: true
	  }),
	      handleFormChange = _useAuthPersonalInfoF.handleFormChange,
	      validateErrors = _useAuthPersonalInfoF.validateErrors,
	      clearErrors = _useAuthPersonalInfoF.clearErrors,
	      formState = _useAuthPersonalInfoF.formState,
	      isValid = _useAuthPersonalInfoF.isValid;
	
	  (0, _react.useEffect)(function () {
	    if (!firstStepData) _browserHistory2.default.push(_routes2.default.LOGIN);
	    return function () {
	      return personalInfoChange(formStateRef.current);
	    };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    formStateRef.current = formState;
	  }, [formState]);
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    clearErrors();
	    confirm((0, _extends3.default)({}, formState, changePasswordData, { id: userId }));
	  };
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    profile && firstStepData ? _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_index2.default.formWrapper, { mt5: !(0, _mobileHelpers.isDesktop)() }) },
	      _react2.default.createElement(
	        'p',
	        { className: _index2.default.formTitle },
	        _react2.default.createElement(
	          'span',
	          null,
	          formatMessage({ id: title })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _index2.default.formStep },
	          ' (2/2)'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { className: _index2.default.formText },
	          formatMessage({ id: 'auth.signup.personalInfoDesc' })
	        ),
	        _react2.default.createElement(_AuthPersonalInfoForm2.default, (0, _extends3.default)({
	          showPrivacy: true
	        }, formState, {
	          races: races,
	          countries: countries,
	          ethnicitys: ethnicitys,
	          genderList: genderList,
	          onChange: handleFormChange,
	          formatMessage: formatMessage,
	          nameSuffixList: nameSuffixList,
	          validateErrors: validateErrors,
	          profileEditable: profileEditable,
	          countryForOrganization: countryForOrganization
	        })),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: (0, _classnames2.default)(_index2.default.acceptBtn, 'db mb3 w-100 lh-copy'),
	            color: 'primary',
	            raised: true,
	            type: 'button',
	            onClick: handleSubmit,
	            disabled: !isValid || pendingProcess
	          },
	          formatMessage({ id: 'common.complete' })
	        )
	      )
	    ) : _react2.default.createElement(_Loader2.default, null)
	  );
	};
	
	AuthPersonalInfo.propTypes = {
	  dataValidationErrors: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func,
	  nameSuffixList: _propTypes2.default.array.isRequired,
	  profile: _propTypes2.default.object,
	  personalInfoChange: _propTypes2.default.func.isRequired,
	  profileEditable: _propTypes2.default.bool,
	  personalInfoData: _propTypes2.default.object,
	  firstStepData: _propTypes2.default.object,
	  isPasswordUpdate: _propTypes2.default.bool,
	  userId: _propTypes2.default.number,
	  confirm: _propTypes2.default.func.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  countries: _propTypes2.default.array.isRequired,
	  countryForOrganization: _propTypes2.default.string,
	  pendingProcess: _propTypes2.default.bool,
	  genderList: _propTypes2.default.array,
	  races: _propTypes2.default.array,
	  ethnicitys: _propTypes2.default.array
	};
	
	exports.default = (0, _enhance.enhance)(AuthPersonalInfo);

/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _userRegistrationReq = __webpack_require__(807);
	
	var generalUserRegistrations = _interopRequireWildcard(_userRegistrationReq);
	
	var _selectors = __webpack_require__(403);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    errors: (0, _selectors.selectUserRegistrationErrors)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  registrationUser: generalUserRegistrations.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FieldsList = __webpack_require__(1182);
	
	var _FieldsList2 = _interopRequireDefault(_FieldsList);
	
	var _formFields = __webpack_require__(38);
	
	var _useSimpleForm2 = __webpack_require__(499);
	
	var _errors = __webpack_require__(120);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _SimpleInfoPopup = __webpack_require__(795);
	
	var _SimpleInfoPopup2 = _interopRequireDefault(_SimpleInfoPopup);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _enhance = __webpack_require__(3084);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIELDS = [_formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE];
	var CUSTOM_FIELDS_STYLES = (0, _defineProperty3.default)({}, _formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE, (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField));
	
	var AuthSignupInvitation = function AuthSignupInvitation(_ref) {
	  var errors = _ref.errors,
	      formatMessage = _ref.intl.formatMessage,
	      registrationUser = _ref.registrationUser;
	
	  var _useSimpleForm = (0, _useSimpleForm2.useSimpleForm)(FIELDS, FIELDS, errors),
	      handleFormChange = _useSimpleForm.handleFormChange,
	      validateErrors = _useSimpleForm.validateErrors,
	      clearErrors = _useSimpleForm.clearErrors,
	      formState = _useSimpleForm.formState,
	      isValid = _useSimpleForm.isValid;
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      opened = _useToggleFlag2[0],
	      openConfirm = _useToggleFlag2[1],
	      closeConfirm = _useToggleFlag2[2];
	
	  (0, _usePageView.usePageView)('Sign Up Invitation');
	  (0, _react.useEffect)(function () {
	    if (!(0, _isEmpty2.default)(errors)) {
	      var code = (0, _get2.default)(errors, 'code');
	      if (code === _errors.LOGIN_ERROR_CODES.INVITE_NOT_CONFIRMED) {
	        openConfirm();
	      }
	    }
	  }, [errors]);
	
	  var handleClick = function handleClick(e) {
	    e.preventDefault();
	    clearErrors();
	
	    var emailOrPhone = formState.emailOrPhone;
	
	
	    registrationUser({
	      user: {
	        login: emailOrPhone
	      }
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_index2.default.formWrapper) },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.signupInvite' }),
	    _react2.default.createElement(
	      'p',
	      { className: _index2.default.formTitle },
	      formatMessage({ id: 'titles.signup' })
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: _index2.default.formText },
	      formatMessage({
	        id: 'auth.signup.invitationLinkDesc'
	      }) + ' ' + formatMessage({ id: 'auth.expiredToken.text' })
	    ),
	    _react2.default.createElement(_FieldsList2.default, {
	      className: _index2.default.fieldsList,
	      fields: FIELDS,
	      formState: formState,
	      validateErrors: validateErrors,
	      onChange: handleFormChange,
	      initialData: formState
	    }),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: (0, _classnames2.default)(_index2.default.acceptBtn, 'db mb3 w-100 lh-copy'),
	        color: 'primary',
	        onClick: handleClick,
	        disabled: !isValid
	      },
	      formatMessage({ id: 'common.invite' })
	    ),
	    _react2.default.createElement(_SimpleInfoPopup2.default, {
	      icon: 'icon-plane',
	      opened: opened,
	      width: 'xsmall',
	      messageId: 'auth.info.signUpInviteNotConfirmed',
	      onClick: closeConfirm,
	      withHeading: false,
	      buttonTitleId: 'submit.expiredToken',
	      mobileFullScreen: false
	    })
	  );
	};
	
	AuthSignupInvitation.propTypes = {
	  errors: _propTypes2.default.object,
	  intl: _propTypes2.default.object.isRequired,
	  registrationUser: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(AuthSignupInvitation);

/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BROWSER_LINK = 'https://www.google.com/intl/en/chrome/';
	
	var BrowserSupportInfo = function BrowserSupportInfo(_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_index2.default.formWrapper, _index2.default.withPadding, 'tc items-center')
	    },
	    _react2.default.createElement(
	      'p',
	      { className: _index2.default.formTitle },
	      formatMessage({ id: 'auth.browser.notSupport' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_index2.default.formDescription, 'mb3 f-12') },
	      formatMessage({ id: 'auth.browser.newVersion' })
	    ),
	    _react2.default.createElement(_Icon2.default, { name: 'chrome', size: 32 }),
	    _react2.default.createElement(
	      'a',
	      {
	        href: BROWSER_LINK,
	        target: '_blank',
	        rel: 'noopener noreferrer',
	        className: (0, _classnames2.default)(_index2.default.link, 'mt2 f-12 db')
	      },
	      formatMessage({ id: 'auth.browser.getChrome' })
	    )
	  );
	};
	
	BrowserSupportInfo.propTypes = {
	  intl: _propTypes2.default.object
	};
	
	exports.default = (0, _reactIntl.injectIntl)(BrowserSupportInfo);

/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(56);
	
	var _actions = __webpack_require__(1871);
	
	var _selectors3 = __webpack_require__(1239);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    errors: (0, _selectors2.selectEditedUserErrors)(state),
	    loggedUserId: (0, _selectors.loggedUserIdSelector)(state),
	    changePasswordFormData: (0, _selectors3.selectChangePasswordProcessFormData)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  proceed: _actions.changePasswordActions.proceed
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _strings = __webpack_require__(15);
	
	var _PasswordInput = __webpack_require__(335);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _formFields = __webpack_require__(38);
	
	var _useSimpleForm2 = __webpack_require__(499);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _enhance = __webpack_require__(3087);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	var _CheckPasswordList = __webpack_require__(1094);
	
	var _CheckPasswordList2 = _interopRequireDefault(_CheckPasswordList);
	
	var _usernameValidation = __webpack_require__(1713);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _selectors = __webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FIELDS = [_formFields.PROFILE_FIELDS_TYPES.USERNAME, _formFields.PROFILE_FIELDS_TYPES.PASSWORD, _formFields.PROFILE_FIELDS_TYPES.PASSWORD_CONFIRMATION];
	
	var ChangePassword = function ChangePassword(_ref) {
	  var errors = _ref.errors,
	      proceed = _ref.proceed,
	      formatMessage = _ref.intl.formatMessage,
	      changePasswordFormData = _ref.changePasswordFormData;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isOpenPopover = _useState2[0],
	      setIsOpenPopover = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      isUsernameTouched = _useState4[0],
	      setIsUsernameTouched = _useState4[1];
	
	  var _useSimpleForm = (0, _useSimpleForm2.useSimpleForm)(FIELDS, FIELDS, errors, changePasswordFormData),
	      handleFormChange = _useSimpleForm.handleFormChange,
	      validateErrors = _useSimpleForm.validateErrors,
	      clearErrors = _useSimpleForm.clearErrors,
	      formState = _useSimpleForm.formState,
	      isValid = _useSimpleForm.isValid;
	
	  var _useState5 = (0, _react.useState)(!changePasswordFormData),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      disabled = _useState6[0],
	      setDisabledState = _useState6[1];
	
	  (0, _usePageView.usePageView)('Change Password');
	  var passwordError = (0, _get2.default)(validateErrors, 'password');
	
	  var usernameAvailabilityError = (0, _reactRedux.useSelector)(_selectors.selectUsernameAvailabilityError);
	
	  var username = formState.username,
	      password = formState.password,
	      passwordConfirmation = formState.passwordConfirmation;
	
	  var isValidPasswordsMatch = password === passwordConfirmation;
	
	  var isValidUsername = (0, _usernameValidation.validateUsernameLength)(username) && (0, _usernameValidation.validateUsernameCharacters)(username) && (0, _usernameValidation.validateUsernameSpaces)(username) && (0, _usernameValidation.validateUsernameRepeating)(username);
	
	  var availabilityError = (0, _get2.default)(usernameAvailabilityError, 'description', null) && formatMessage(_strings.PROFILE.errors.username.taken);
	
	  var isEnabled = isValidPasswordsMatch && !passwordError && isValidUsername;
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    clearErrors();
	    proceed((0, _extends3.default)({}, formState));
	  };
	
	  var handlePasswordChange = function handlePasswordChange(name, value, invalid) {
	    handleFormChange((0, _defineProperty3.default)({}, name, value));
	    setDisabledState(invalid);
	  };
	
	  var handleUsernameChange = function handleUsernameChange(value) {
	    handleFormChange({ username: value });
	  };
	
	  var usernameRequiredError = isUsernameTouched && !username ? formatMessage(_strings.PROFILE.errors.username.required) : null;
	
	  var handleOpenPopover = function handleOpenPopover() {
	    return setIsOpenPopover(true);
	  };
	  var handleClosePopover = function handleClosePopover() {
	    setIsOpenPopover(false);
	    setIsUsernameTouched(true);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.formWrapper },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.changePassword' }),
	    _react2.default.createElement(
	      'p',
	      { className: _index2.default.formTitle },
	      formatMessage(_strings.AUTH.titles.signup)
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: _index2.default.formHeading },
	      formatMessage({ id: 'auth.changePassword.text' })
	    ),
	    _react2.default.createElement(
	      _TextInput2.default,
	      {
	        className: 'mb3 relative',
	        id: 'username',
	        label: _react2.default.createElement(
	          'div',
	          { className: 'df items-end' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.fields.username)
	        ),
	        name: 'username',
	        value: username,
	        placeholder: formatMessage((0, _extends3.default)({}, _strings.AUTH.fields.username)),
	        rounded: true,
	        type: 'text',
	        invalid: !!usernameRequiredError,
	        onChange: handleUsernameChange,
	        onFocus: handleOpenPopover,
	        onBlur: handleClosePopover
	      },
	      isOpenPopover && _react2.default.createElement(
	        _CheckPasswordList2.default,
	        {
	          title: 'auth.signup.popover.title',
	          list: (0, _usernameValidation.getUsernameTooltipOptions)(username)
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.popoverInfo },
	          _react2.default.createElement(_Icon2.default, { name: 'icon-info', size: 16 }),
	          formatMessage({ id: 'auth.signup.text.username' })
	        )
	      )
	    ),
	    usernameRequiredError && _react2.default.createElement(_ErrorBlock2.default, {
	      className: (0, _classnames2.default)(_index2.default.errorBlock, 'mt1 mb2'),
	      errors: usernameRequiredError
	    }),
	    _react2.default.createElement(_PasswordInput2.default, {
	      autoComplete: 'new-password',
	      className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb3'),
	      name: 'password',
	      label: formatMessage({ id: 'auth.signup.newPassword' }),
	      placeholder: formatMessage({ id: 'fields.password' }),
	      rounded: true,
	      onChange: handlePasswordChange,
	      required: true,
	      withValidation: true,
	      value: password
	    }),
	    _react2.default.createElement(_PasswordInput2.default, {
	      autoComplete: 'new-password',
	      className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField),
	      name: 'passwordConfirmation',
	      rounded: true,
	      label: formatMessage(_strings.AUTH.actions.signup.confirmationPassword),
	      placeholder: formatMessage({ id: 'fields.password' }),
	      onChange: handlePasswordChange,
	      required: true,
	      withValidation: true,
	      value: passwordConfirmation
	    }),
	    (!isValidPasswordsMatch || passwordError || availabilityError) && _react2.default.createElement(_ErrorBlock2.default, {
	      className: (0, _classnames2.default)(_index2.default.errorBlock, 'mt3'),
	      errors: availabilityError || passwordError || formatMessage(_strings.AUTH.actions.signup.matchPassword)
	    }),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: (0, _classnames2.default)(_index2.default.acceptBtn, 'db mb3 w-100 lh-copy'),
	        color: 'primary',
	        raised: true,
	        type: 'submit',
	        disabled: !isValid || disabled || !isEnabled,
	        onClick: handleSubmit
	      },
	      formatMessage({ id: 'common.next' })
	    )
	  );
	};
	
	ChangePassword.propTypes = {
	  errors: _propTypes2.default.object,
	  proceed: _propTypes2.default.func.isRequired,
	  changePasswordFormData: _propTypes2.default.object,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired
	};
	
	exports.default = (0, _enhance.enhance)(ChangePassword);

/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _PasswordInput = __webpack_require__(335);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _strings = __webpack_require__(15);
	
	var _routes = __webpack_require__(37);
	
	var _createPassword = __webpack_require__(1240);
	
	var _createPasswordValidation = __webpack_require__(4187);
	
	var _createPasswordValidation2 = _interopRequireDefault(_createPasswordValidation);
	
	var _handleApiError = __webpack_require__(1924);
	
	var _handleApiError2 = _interopRequireDefault(_handleApiError);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _gtag = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    createPasswordReq: state.auth.createPassword,
	    token: ownProps.routeParams.token
	  };
	};
	
	var mapDispatchToProps = {
	  send: _createPassword.actions.send
	};
	
	var CreatePassword = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = function (_PureComponent) {
	  (0, _inherits3.default)(CreatePassword, _PureComponent);
	
	  function CreatePassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CreatePassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CreatePassword.__proto__ || (0, _getPrototypeOf2.default)(CreatePassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      disabled: true
	    }, _this.getValidationErrors = function () {
	      var _this$props = _this.props,
	          _this$props$createPas = _this$props.createPasswordReq,
	          error = _this$props$createPas.error,
	          rejected = _this$props$createPas.rejected,
	          formatMessage = _this$props.intl.formatMessage;
	      var _this$state = _this.state,
	          errors = _this$state.errors,
	          submitted = _this$state.submitted;
	
	
	      if (rejected) {
	        return (0, _handleApiError2.default)(error) || formatMessage(_strings.AUTH.errors.common);
	      }
	      if (submitted) {
	        return errors;
	      }
	
	      return null;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CreatePassword, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _gtag.GATrackPageView)('Create Password');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var serializedForm = this.props.serializedForm;
	      var formatMessage = nextProps.intl.formatMessage;
	
	
	      if (serializedForm !== nextProps.serializedForm) {
	        var form = nextProps.serializedForm;
	        var errors = (0, _createPasswordValidation2.default)(form) && formatMessage(_strings.AUTH.errors.password);
	
	        this.setState({
	          errors: errors,
	          submitted: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          errors = _state.errors,
	          submitted = _state.submitted,
	          disabled = _state.disabled;
	      var _props = this.props,
	          _props$createPassword = _props.createPasswordReq,
	          rejected = _props$createPassword.rejected,
	          succeed = _props$createPassword.succeed,
	          getAction = _props.getAction,
	          getOptions = _props.getOptions,
	          send = _props.send,
	          token = _props.token;
	
	
	      getOptions({ token: token });
	
	      if (succeed) {
	        // redirect to login
	        _reactRouter.browserHistory.push(_routes.LOGIN);
	      }
	
	      if (submitted && !errors) {
	        getAction(send);
	      }
	
	      var errorEncountered = rejected || submitted && !!errors;
	      var validationErrors = this.getValidationErrors();
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'formWrapper' },
	        _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.createPassword' }),
	        _react2.default.createElement(
	          'p',
	          { styleName: 'formTitle' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.titles.createPassword)
	        ),
	        _react2.default.createElement(
	          'p',
	          { styleName: 'formText' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.actions.createPassword.textTitle)
	        ),
	        _react2.default.createElement(_PasswordInput2.default, {
	          className: 'mt2 mb4',
	          withValidation: true,
	          id: 'create-password',
	          required: true,
	          rounded: true,
	          onChange: function onChange(name, value, invalid) {
	            return _this2.setState({ disabled: invalid });
	          }
	        }),
	        errorEncountered ? _react2.default.createElement(_ErrorBlock2.default, { className: 'mb4', errors: validationErrors }) : null,
	        _react2.default.createElement(
	          _Button2.default,
	          { className: 'db w-100', color: 'primary', raised: true, disabled: disabled },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.submit.createPassword)
	        )
	      );
	    }
	  }]);
	  return CreatePassword;
	}(_react.PureComponent)) || _class) || _class) || _class);
	exports.default = CreatePassword;
	
	
	CreatePassword.propTypes = {
	  createPasswordReq: _propTypes2.default.shape({
	    error: _propTypes2.default.object,
	    rejected: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }).isRequired,
	  getAction: _propTypes2.default.func.isRequired,
	  getOptions: _propTypes2.default.func.isRequired,
	  send: _propTypes2.default.func.isRequired,
	  serializedForm: _propTypes2.default.object.isRequired,
	  token: _propTypes2.default.string.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired
	};

/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _strings = __webpack_require__(15);
	
	var _routes = __webpack_require__(37);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpiredConfirmation = function ExpiredConfirmation() {
	  (0, _usePageView.usePageView)('Expired Confirmation');
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'formWrapper' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.expiredConfirmation' }),
	    _react2.default.createElement(
	      'p',
	      { styleName: 'formTitle' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.titles.expiredConfirmation)
	    ),
	    _react2.default.createElement(
	      'p',
	      { styleName: 'formText', className: 'mb4' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.actions.expiredConfirmation.textTitle)
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'db w-100',
	        color: 'primary',
	        raised: true,
	        onClick: function onClick() {
	          return _browserHistory2.default.push('/' + _routes.HEALTHBOARD);
	        }
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.submit.expiredToken)
	    )
	  );
	};
	
	exports.default = (0, _reactCssModules2.default)(ExpiredConfirmation, _index2.default, { allowMultiple: true });

/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _recompose = __webpack_require__(22);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _strings = __webpack_require__(15);
	
	var _env = __webpack_require__(103);
	
	var _routes = __webpack_require__(37);
	
	var _selectors = __webpack_require__(115);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpiredLink = function ExpiredLink(_ref) {
	  var description = _ref.description,
	      values = _ref.values;
	
	  (0, _usePageView.usePageView)('Expired Link');
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.formWrapper },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.expiredLink' }),
	    _react2.default.createElement(
	      'p',
	      { className: _index2.default.formContent },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: description, values: values })
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'db w-100',
	        color: 'primary',
	        raised: true,
	        onClick: function onClick() {
	          return _browserHistory2.default.push(_routes.LOGIN);
	        }
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.submit.expiredToken)
	    )
	  );
	};
	
	ExpiredLink.propTypes = {
	  values: _propTypes2.default.object,
	  description: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    location: (0, _selectors.currentLocationSelector)(state)
	  };
	};
	
	exports.default = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _recompose.withProps)(function (_ref2) {
	  var location = _ref2.location;
	
	  if (location === '/' + _routes.EXPIRED_LINK) {
	    return {
	      description: 'auth.expiredLink.text',
	      values: {
	        link: _react2.default.createElement(
	          'a',
	          { href: _env.WEB_APP_URL, className: 'clickable' },
	          _env.WEB_APP_URL
	        )
	      }
	    };
	  }
	  return { description: 'auth.expiredLinkDefault.text' };
	}))(ExpiredLink);

/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _strings = __webpack_require__(15);
	
	var _routes = __webpack_require__(37);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpiredToken = function ExpiredToken() {
	  (0, _usePageView.usePageView)('Expired Token');
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'formWrapper' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.expiredToken' }),
	    _react2.default.createElement(
	      'p',
	      { styleName: 'formTitle' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.titles.expiredToken)
	    ),
	    _react2.default.createElement(
	      'p',
	      { styleName: 'formText', className: 'mb4' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.actions.expiredToken.textTitle)
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'db w-100',
	        color: 'primary',
	        raised: true,
	        onClick: function onClick() {
	          return _browserHistory2.default.push(_routes.LOGIN);
	        }
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.submit.expiredToken)
	    )
	  );
	};
	
	exports.default = (0, _reactCssModules2.default)(ExpiredToken, _index2.default, { allowMultiple: true });

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _PasswordInput = __webpack_require__(335);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _errors = __webpack_require__(120);
	
	var _defaultValidator = __webpack_require__(700);
	
	var _sendInvitationReq = __webpack_require__(806);
	
	var sendUserInvitation = _interopRequireWildcard(_sendInvitationReq);
	
	var _strings = __webpack_require__(15);
	
	var _login = __webpack_require__(402);
	
	var login = _interopRequireWildcard(_login);
	
	var _authAzure = __webpack_require__(631);
	
	var _validations = __webpack_require__(81);
	
	var _selectors = __webpack_require__(93);
	
	var _SimpleInfoPopup = __webpack_require__(795);
	
	var _SimpleInfoPopup2 = _interopRequireDefault(_SimpleInfoPopup);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _MfaDialog = __webpack_require__(1132);
	
	var _MfaDialog2 = _interopRequireDefault(_MfaDialog);
	
	var _routes = __webpack_require__(37);
	
	var _mfaConfirmations = __webpack_require__(681);
	
	var _loginAzure = __webpack_require__(340);
	
	var _logout = __webpack_require__(198);
	
	var _selectors2 = __webpack_require__(56);
	
	var _publicConstants = __webpack_require__(838);
	
	var _authAzureExternalRedirect = __webpack_require__(1869);
	
	var _parseJSONSafely = __webpack_require__(910);
	
	var _parseJSONSafely2 = _interopRequireDefault(_parseJSONSafely);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	var _OtpModal = __webpack_require__(3427);
	
	var _OtpModal2 = _interopRequireDefault(_OtpModal);
	
	var _selectors3 = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTTP_STATUS_LOCKED = 423;
	
	var Login = function Login(_ref) {
	  var _cn, _cn2;
	
	  var getAction = _ref.getAction,
	      rejected = _ref.rejected,
	      send = _ref.send,
	      clear = _ref.clear,
	      error = _ref.error,
	      expiredError = _ref.expiredError,
	      sending = _ref.sending,
	      sendInvitation = _ref.sendInvitation,
	      clearInvitation = _ref.clearInvitation,
	      clearLogoutAction = _ref.clearLogoutAction,
	      sendInvitationError = _ref.sendInvitationError,
	      sendInvitationSucceed = _ref.sendInvitationSucceed,
	      sendInvitationPending = _ref.sendInvitationPending,
	      getMfaConfirmtation = _ref.getMfaConfirmtation,
	      clearMfaConfirmtation = _ref.clearMfaConfirmtation,
	      clearMfaCredential = _ref.clearMfaCredential,
	      formatMessage = _ref.intl.formatMessage,
	      serializedForm = _ref.serializedForm,
	      loginForMFA = _ref.loginForMFA,
	      token = _ref.token;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isErrored = _useState2[0],
	      showError = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      savedLogin = _useState4[0],
	      setLogin = _useState4[1];
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      opened = _useToggleFlag2[0],
	      openConfirm = _useToggleFlag2[1],
	      closeConfirm = _useToggleFlag2[2];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      loginError = _useState6[0],
	      setLoginError = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      mfaOpen = _useState8[0],
	      setMfaOpen = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
	      mfaError = _useState10[0],
	      setMfaError = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
	      showOtpModal = _useState12[0],
	      setShowOtpModal = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = (0, _slicedToArray3.default)(_useState13, 2),
	      isAnyOfOtpPathModalsOpen = _useState14[0],
	      setIsAnyOfOtpPathModalsOpen = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = (0, _slicedToArray3.default)(_useState15, 2),
	      showOtpLink = _useState16[0],
	      setShowOtpLink = _useState16[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var searchParams = new URLSearchParams(window.location.search);
	
	  var type = searchParams.get('type');
	
	  var codeSearchParam = searchParams.get('code');
	
	  var loginSearchParam = searchParams.get('login');
	
	  var tokenSearchParam = searchParams.get('token');
	
	  var _useSelector = (0, _reactRedux.useSelector)(_selectors2.getMfaConfirmationData),
	      mfaConfirmationData = _useSelector.data,
	      mfaConfirmationLoading = _useSelector.sending;
	
	  var isOtpEnabled = (0, _reactRedux.useSelector)(_selectors3.selectIsOtpEnabled);
	
	  (0, _usePageView.usePageView)('Login');
	  (0, _react.useEffect)(function () {
	    if (rejected && !isAnyOfOtpPathModalsOpen) {
	      var code = (0, _get2.default)(error, 'code');
	      var status = (0, _get2.default)(error, 'status');
	      if (status === HTTP_STATUS_LOCKED) {
	        showError(false);
	        if (!mfaOpen) {
	          handleSendMfaCode();
	        } else {
	          setMfaError(code);
	        }
	      } else if (_errors.LOGIN_INVITATION_ERRORS.includes(code)) {
	        showError(false);
	        openConfirm();
	      } else {
	        showError(true);
	      }
	    } else {
	      showError(false);
	    }
	  }, [rejected, error, loginForMFA, isAnyOfOtpPathModalsOpen]);
	
	  (0, _react.useEffect)(function () {
	    if (mfaConfirmationData) {
	      setMfaOpen(true);
	    }
	  }, [mfaConfirmationData]);
	
	  var isEmail = function isEmail(value) {
	    return (0, _defaultValidator.defaultValidator)(_validations.PATTERNS.HAS_ALPHABETICAL_CHARACTER, value);
	  };
	
	  var errorTextId = (0, _react.useMemo)(function () {
	    var code = (0, _get2.default)(error, 'code');
	    return _errors.LOGIN_ERRORS[code] || 'errors.login.unauthorized';
	  }, [error]);
	
	  var invitationTextIDs = (0, _react.useMemo)(function () {
	    return isEmail(savedLogin) ? {
	      messageId: 'auth.info.inviteEmailNotConfirmed',
	      titleId: 'auth.info.title.inviteEmailNotConfirmed'
	    } : {
	      messageId: 'auth.info.invitePhoneNotConfirmed',
	      titleId: 'auth.info.title.invitePhoneNotConfirmed'
	    };
	  }, [savedLogin]);
	
	  var headingTextId = expiredError ? 'auth.expire.expiredSession' : 'auth.login.text';
	
	  var resetReqError = function resetReqError() {
	    if (error) clear();
	  };
	
	  var resetLoginError = function resetLoginError() {
	    if (loginError) setLoginError('');
	    resetReqError();
	  };
	
	  var handleInvitation = function handleInvitation() {
	    return sendInvitation({ user: { login: savedLogin } });
	  };
	
	  var handleCloseConfirm = function handleCloseConfirm() {
	    clearInvitation();
	    closeConfirm();
	    setLogin('');
	    clearMfaCredential();
	  };
	
	  var handleSendMfaCode = function handleSendMfaCode() {
	    getMfaConfirmtation({ login: savedLogin || loginForMFA });
	  };
	
	  var handleMfaLogin = function handleMfaLogin(code) {
	    var data = (0, _extends4.default)({}, serializedForm, {
	      mfa_code: code
	    });
	    if (loginForMFA) {
	      dispatch(_loginAzure.actions.send({ mfa_code: code, access_token: token }));
	    } else {
	      send(data);
	    }
	  };
	
	  var handleMfaClose = function handleMfaClose() {
	    setMfaOpen(false);
	    setMfaError(false);
	    clearMfaConfirmtation();
	    clearMfaCredential();
	  };
	
	  getAction(function (data) {
	    setShowOtpLink(isOtpEnabled);
	    clearLogoutAction();
	
	    var mfaFingerprint = (0, _get2.default)((0, _parseJSONSafely2.default)(localStorage.getItem('user')), 'mfaFingerprint');
	    var user = (0, _extends4.default)({}, data);
	    if (mfaFingerprint) {
	      user.mfa_fingerprint = mfaFingerprint;
	    }
	
	    var userLogin = (0, _get2.default)(data, 'login', null);
	
	    if (!sending) {
	      setLogin(userLogin);
	      send(user);
	    }
	  });
	
	  var handleLoginAzure = function handleLoginAzure(e) {
	    e.preventDefault();
	    resetReqError();
	    clearMfaConfirmtation();
	    dispatch(_authAzure.actions.init({ intl: formatMessage }));
	  };
	
	  var handleSendOTPLinkClick = function handleSendOTPLinkClick() {
	    clear();
	    setShowOtpModal(true);
	  };
	
	  var handleCloseOtpModal = function handleCloseOtpModal() {
	    setShowOtpModal(false);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (isOtpEnabled === undefined) {
	      dispatch(_publicConstants.actions.send());
	    }
	  }, [isOtpEnabled]);
	
	  (0, _react.useEffect)(function () {
	    if (type) {
	      _browserHistory2.default.push(_routes.LOGIN);
	      dispatch(_authAzureExternalRedirect.actions.init({
	        type: type,
	        code: codeSearchParam,
	        intl: formatMessage,
	        login: loginSearchParam,
	        token: tokenSearchParam
	      }));
	    }
	  }, []);
	
	  var _useState17 = (0, _react.useState)({}),
	      _useState18 = (0, _slicedToArray3.default)(_useState17, 2),
	      valueForms = _useState18[0],
	      setFormValues = _useState18[1];
	
	  var checkFormValues = function checkFormValues(name, value) {
	    setFormValues(function (prevState) {
	      return (0, _extends4.default)({}, prevState, (0, _defineProperty3.default)({}, name, value));
	    });
	  };
	
	  var isDisabledSubmit = (0, _react.useMemo)(function () {
	    var isFormFilled = valueForms.password;
	
	    return sending || mfaConfirmationLoading || !isFormFilled;
	  }, [sending, mfaConfirmationLoading, valueForms]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_index2.default.formWrapper, 'relative') },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.login' }),
	    sending && _react2.default.createElement(_Loader2.default, { className: 'absolute-center z-999' }),
	    _react2.default.createElement(
	      'p',
	      { className: _index2.default.formTitle },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.titles.login)
	    ),
	    _brandConfig2.default.welcomeText && _react2.default.createElement(
	      'p',
	      { className: _index2.default.welcomeText },
	      _brandConfig2.default.welcomeText
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.formHeading },
	      formatMessage({
	        id: _brandConfig.isFlagler ? 'auth.login.flagler.text' : headingTextId
	      })
	    ),
	    _react2.default.createElement(_TextInput2.default, {
	      className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb3'),
	      id: 'login-login',
	      label: formatMessage(_strings.AUTH.fields.login),
	      name: 'login',
	      placeholder: formatMessage(_strings.AUTH.fields.loginPlaceholder),
	      required: true,
	      rounded: true,
	      onBlur: function onBlur(val) {
	        checkFormValues('login', val);
	      },
	      onFocus: resetLoginError
	    }),
	    _react2.default.createElement(_PasswordInput2.default, {
	      className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb3'),
	      id: 'login-password',
	      autoComplete: 'new-password',
	      required: true,
	      rounded: true,
	      onFocus: resetReqError,
	      onBlur: function onBlur(val) {
	        checkFormValues('password', val);
	      }
	    }),
	    isErrored && _react2.default.createElement(_ErrorBlock2.default, {
	      errors: formatMessage({ id: errorTextId }),
	      className: (0, _classnames2.default)(_index2.default.errorBlock, 'mt3')
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.links },
	      _react2.default.createElement(
	        'div',
	        {
	          onClick: handleSendOTPLinkClick,
	          className: (0, _classnames2.default)(_index2.default.link, (_cn = {}, (0, _defineProperty3.default)(_cn, _index2.default.forgotPassBtn, !_brandConfig.isFlagler), (0, _defineProperty3.default)(_cn, _index2.default.recoverLink, _brandConfig.isFlagler), (0, _defineProperty3.default)(_cn, _index2.default.hidden, !isOtpEnabled && !showOtpLink), _cn), { mt3: isErrored })
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.actions.otp.textLink)
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.link, (_cn2 = {}, (0, _defineProperty3.default)(_cn2, _index2.default.forgotPassBtn, !_brandConfig.isFlagler), (0, _defineProperty3.default)(_cn2, _index2.default.recoverLink, _brandConfig.isFlagler), _cn2), { mt3: isErrored })
	        },
	        _react2.default.createElement(
	          _Link2.default,
	          { to: '/' + _routes.RESET_PASSWORD },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.actions.recoverPassword.textLink)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: (0, _classnames2.default)(_index2.default.acceptBtn, 'db mb3 w-100 lh-copy'),
	        color: 'primary',
	        raised: true,
	        type: 'submit',
	        disabled: isDisabledSubmit
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.submit.signin)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.loginAzureWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.dividerOr },
	        formatMessage({ id: 'auth.otherLoginOptions' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)(_index2.default.acceptBtn, _index2.default.microsoftButton, 'db mb3 w-100 lh-copy'),
	          color: 'accent',
	          raised: true,
	          onClick: handleLoginAzure,
	          disabled: sending || mfaConfirmationLoading
	        },
	        _react2.default.createElement(_Icon2.default, {
	          name: 'icon-microsoft',
	          size: 24,
	          className: _index2.default.microsoftLogo
	        }),
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.submit.loginAzure)
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: (0, _classnames2.default)(_index2.default.signupLink, { mb4: _brandConfig.isFlagler }, 'pt0') },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: _brandConfig2.default.registrationLinkTitle }),
	      _react2.default.createElement(
	        _Link2.default,
	        { className: (0, _classnames2.default)(_index2.default.link, 'ml1'), to: '/' + _routes.SIGNUP_INVITATION },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'submit.registerHere' })
	      )
	    ),
	    _react2.default.createElement(
	      _SimpleInfoPopup2.default,
	      (0, _extends4.default)({}, invitationTextIDs, {
	        icon: 'icon-plane',
	        opened: opened,
	        width: 'rubber',
	        withHeading: false,
	        mobileFullScreen: false,
	        dialogClassName: 'w-100',
	        autoHeight: true
	      }),
	      sendInvitationError && _react2.default.createElement(_ErrorBlock2.default, {
	        errors: formatMessage({ id: 'errors.common' }),
	        className: (0, _classnames2.default)(_index2.default.errorBlock, 'mt3')
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'df justify-center mt4' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            onClick: handleInvitation,
	            color: 'primary',
	            raised: true,
	            disabled: sendInvitationPending || sendInvitationSucceed,
	            className: 'w-50'
	          },
	          formatMessage({ id: 'common.resendInvite' })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            onClick: handleCloseConfirm,
	            color: 'primary',
	            raised: true,
	            className: 'ml2 w-50'
	          },
	          formatMessage({ id: 'submit.expiredToken' })
	        )
	      )
	    ),
	    mfaOpen && _react2.default.createElement(_MfaDialog2.default, {
	      open: true,
	      title: formatMessage({ id: 'mfa.dialog.title' }),
	      mfaData: mfaConfirmationData,
	      onClose: handleMfaClose,
	      onResend: handleSendMfaCode,
	      onSubmit: handleMfaLogin,
	      error: mfaError,
	      loading: sending
	    }),
	    _react2.default.createElement(_OtpModal2.default, {
	      open: showOtpModal,
	      formatMessage: formatMessage,
	      onClose: handleCloseOtpModal,
	      setIsAnyOfOtpPathModalsOpen: setIsAnyOfOtpPathModalsOpen
	    })
	  );
	};
	
	Login.propTypes = {
	  getAction: _propTypes2.default.func.isRequired,
	  clearLogoutAction: _propTypes2.default.func,
	  loggedIn: _propTypes2.default.bool.isRequired,
	  rejected: _propTypes2.default.bool.isRequired,
	  send: _propTypes2.default.func.isRequired,
	  clear: _propTypes2.default.func.isRequired,
	  error: _propTypes2.default.object,
	  succeed: _propTypes2.default.bool.isRequired,
	  sending: _propTypes2.default.bool.isRequired,
	  expiredError: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  sendInvitation: _propTypes2.default.func,
	  clearInvitation: _propTypes2.default.func,
	  sendInvitationError: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
	  sendInvitationSucceed: _propTypes2.default.bool,
	  sendInvitationPending: _propTypes2.default.bool,
	  getMfaConfirmtation: _propTypes2.default.func,
	  clearMfaConfirmtation: _propTypes2.default.func,
	  serializedForm: _propTypes2.default.object,
	  clearMfaCredential: _propTypes2.default.func,
	  loginForMFA: _propTypes2.default.string,
	  token: _propTypes2.default.string
	};
	
	Login.defaultProps = {
	  error: null
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loggedIn: (0, _selectors.isLoggedInSelector)(state),
	    rejected: !!state.auth.login.rejected || !!state.auth.loginAzure.rejected,
	    sending: !!state.auth.login.sending || !!state.auth.loginAzure.sending,
	    error: state.auth.login.error || state.auth.loginAzure.error,
	    succeed: !!state.auth.login.succeed || !!state.auth.loginAzure.succeed,
	    expiredError: (0, _selectors.selectAuthLogoutError)(state),
	    sendInvitationSucceed: (0, _selectors.selectSendInvitationSucceed)(state),
	    sendInvitationPending: (0, _selectors.selectSendInvitationPending)(state),
	    sendInvitationError: (0, _selectors.selectSendInvitationError)(state),
	    loginForMFA: state.auth.loginAzure.loginMFA,
	    token: state.auth.loginAzure.token
	  };
	};
	
	var mapDispatchToProps = {
	  send: login.actions.send,
	  clear: login.actions.clear,
	  clearLogoutAction: _logout.actions.clear,
	  clearMfaCredential: _loginAzure.actions.clear,
	  sendInvitation: sendUserInvitation.actions.send,
	  clearInvitation: sendUserInvitation.actions.clear,
	  getMfaConfirmtation: _mfaConfirmations.actions.send,
	  clearMfaConfirmtation: _mfaConfirmations.actions.clear
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Login));

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _recompose = __webpack_require__(22);
	
	var _selectors = __webpack_require__(93);
	
	var _resetPassword = __webpack_require__(1241);
	
	var resetPassword = _interopRequireWildcard(_resetPassword);
	
	var _selectors2 = __webpack_require__(50);
	
	var _publicConstants = __webpack_require__(838);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    succeed: (0, _selectors.selectResetPasswordSucceed)(state),
	    errors: (0, _selectors.selectResetPasswordError)(state),
	    primaryContactsEnabled: (0, _selectors2.selectPrimaryContactsEnabled)(state),
	    publicConstantsLoading: (0, _selectors2.selectPublicConstantsSending)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  resetPassword: resetPassword.actions.send,
	  fetchPublicConstants: _publicConstants.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _FieldsList = __webpack_require__(1182);
	
	var _FieldsList2 = _interopRequireDefault(_FieldsList);
	
	var _transformErrors = __webpack_require__(3101);
	
	var _transformErrors2 = _interopRequireDefault(_transformErrors);
	
	var _strings = __webpack_require__(15);
	
	var _brandConfig = __webpack_require__(142);
	
	var _formFields = __webpack_require__(38);
	
	var _useSimpleForm2 = __webpack_require__(499);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _enhance = __webpack_require__(3094);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRecoverPasswordTextTitle = function getRecoverPasswordTextTitle(primaryContactsEnabled) {
	  return primaryContactsEnabled ? _strings.AUTH.actions.recoverPassword.textTitlePrimaryContacts : _strings.AUTH.actions.recoverPassword.textTitle;
	};
	
	var getFields = function getFields(primaryContactsEnabled) {
	  return primaryContactsEnabled ? [_formFields.PROFILE_FIELDS_TYPES.USERNAME] : [_formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE];
	};
	
	var RecoverPassword = function RecoverPassword(_ref) {
	  var resetPassword = _ref.resetPassword,
	      succeed = _ref.succeed,
	      errors = _ref.errors,
	      getAction = _ref.getAction,
	      primaryContactsEnabled = _ref.primaryContactsEnabled,
	      publicConstantsLoading = _ref.publicConstantsLoading,
	      fetchPublicConstants = _ref.fetchPublicConstants,
	      formatMessage = _ref.intl.formatMessage;
	
	  (0, _react.useEffect)(function () {
	    fetchPublicConstants();
	    getAction(null);
	  }, []);
	
	  (0, _usePageView.usePageView)('Recover Password');
	
	  var fields = getFields(primaryContactsEnabled);
	
	  var fieldName = primaryContactsEnabled ? 'username' : 'emailOrPhone';
	
	  var _useSimpleForm = (0, _useSimpleForm2.useSimpleForm)(fields, fields, (0, _transformErrors2.default)(errors, formatMessage, fieldName)),
	      handleFormChange = _useSimpleForm.handleFormChange,
	      validateErrors = _useSimpleForm.validateErrors,
	      clearErrors = _useSimpleForm.clearErrors,
	      formState = _useSimpleForm.formState,
	      isValid = _useSimpleForm.isValid;
	
	  var emailOrPhone = formState.emailOrPhone,
	      username = formState.username;
	
	
	  var type = typeof emailOrPhone === 'string' && emailOrPhone.includes('@') ? 'email' : 'phone';
	
	  var handleSubmit = function handleSubmit() {
	    resetPassword({ login: primaryContactsEnabled ? username : emailOrPhone });
	    clearErrors();
	  };
	
	  var handleBack = function handleBack(e) {
	    e.preventDefault();
	    _browserHistory2.default.goBack();
	  };
	
	  if (publicConstantsLoading) {
	    return _react2.default.createElement(_Loader2.default, { className: 'absolute-center' });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.formWrapper },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.recoverPassword' }),
	    !succeed && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'p',
	        { className: _index2.default.formTitle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.titles.recoverPassword)
	      ),
	      _react2.default.createElement(
	        'p',
	        {
	          className: (0, _classnames2.default)(_index2.default.formText, 'mb3 pt0'),
	          style: { textAlign: 'left' }
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, getRecoverPasswordTextTitle(primaryContactsEnabled))
	      ),
	      _react2.default.createElement(_FieldsList2.default, {
	        className: _index2.default.fieldsList,
	        fields: fields,
	        formState: formState,
	        validateErrors: validateErrors,
	        onChange: handleFormChange,
	        initialData: formState
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)(_index2.default.acceptBtn, 'db mb2 w-100 lh-copy'),
	          color: 'primary',
	          raised: true,
	          onClick: handleSubmit,
	          disabled: !isValid
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.submit.recoverPassword)
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)(_index2.default.cancelBtn, 'db w-100 lh-copy'),
	          color: 'accent',
	          type: 'button',
	          onClick: handleBack
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.cancel)
	      )
	    ),
	    succeed && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _brandConfig.isFlagler && _react2.default.createElement(
	        'p',
	        { className: 'md3 tc' },
	        _react2.default.createElement(_Icon2.default, { name: 'icon-plane-line', size: 64 })
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _index2.default.formTitle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.titles.recoverConfirm)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: (0, _classnames2.default)(_index2.default.formText, 'mb0') },
	        formatMessage(_strings.AUTH.actions.recoverConfirm[type].textTitle)
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: (0, _classnames2.default)(_index2.default.formText, 'mb2 pt1 fw5') },
	        emailOrPhone
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: (0, _classnames2.default)(_index2.default.formText, 'pt2 mb0') },
	        formatMessage(_strings.AUTH.actions.recoverConfirm[type].textConfirm)
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)(_index2.default.acceptBtn, 'db mb3 w-100 lh-copy'),
	          color: 'primary',
	          raised: true,
	          onClick: handleBack
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.submit.recoverConfirm)
	      )
	    )
	  );
	};
	
	RecoverPassword.propTypes = {
	  errors: _propTypes2.default.object,
	  resetPassword: _propTypes2.default.func.isRequired,
	  succeed: _propTypes2.default.bool,
	  getAction: _propTypes2.default.func.isRequired,
	  primaryContactsEnabled: _propTypes2.default.bool,
	  publicConstantsLoading: _propTypes2.default.bool.isRequired,
	  fetchPublicConstants: _propTypes2.default.func.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired
	};
	
	exports.default = (0, _enhance.enhance)(RecoverPassword);

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(42);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _signupReq = __webpack_require__(341);
	
	var _logout = __webpack_require__(198);
	
	var _strings = __webpack_require__(15);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    logout: state.auth.logout,
	    status: state.auth.status,
	    signup: state.auth.signup,
	    token: ownProps.routeParams.token
	  };
	};
	
	var mapDispatchToProps = {
	  acceptInvitation: _signupReq.actions.send,
	  logoutAction: _logout.actions.send
	};
	
	var Registration = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactIntl.injectIntl)(_class = _dec(_class = function (_Component) {
	  (0, _inherits3.default)(Registration, _Component);
	
	  function Registration() {
	    (0, _classCallCheck3.default)(this, Registration);
	    return (0, _possibleConstructorReturn3.default)(this, (Registration.__proto__ || (0, _getPrototypeOf2.default)(Registration)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Registration, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var signupSucceed = nextProps.signup.succeed && !(0, _get2.default)(this.props, 'signup.succeed');
	      var signupRejected = nextProps.signup.rejected && !(0, _get2.default)(this.props, 'signup.rejected');
	
	      var logoutSucceed = nextProps.logout.succeed && !(0, _get2.default)(this.props, 'logout.succeed');
	      var logoutRejected = nextProps.logout.rejected && !(0, _get2.default)(this.props, 'logout.rejected');
	
	      return signupSucceed || signupRejected || logoutSucceed || logoutRejected;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$status = _props.status,
	          loggedIn = _props$status.loggedIn,
	          redirectTo = _props$status.redirectTo,
	          signup = _props.signup,
	          logout = _props.logout,
	          token = _props.token,
	          acceptInvitation = _props.acceptInvitation,
	          logoutAction = _props.logoutAction,
	          formatMessage = _props.intl.formatMessage;
	
	      // error handling
	
	      if (signup.rejected) {
	        _reactRouter.browserHistory.push(_routes.EXPIRED_TOKEN);
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      if (logout.rejected) {
	        return _react2.default.createElement(_ErrorBlock2.default, {
	          errors: formatMessage(_strings.AUTH.errors.common),
	          className: 'mb3'
	        });
	      }
	
	      // second render
	      if (signup.succeed && redirectTo) {
	        _reactRouter.browserHistory.push('/' + redirectTo);
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      // first + render
	      if (logout.succeed) {
	        acceptInvitation({ token: token });
	        return _react2.default.createElement(_Loader2.default, null);
	      }
	
	      // first render
	      if (loggedIn) {
	        logoutAction();
	      } else {
	        acceptInvitation({ token: token });
	      }
	
	      return _react2.default.createElement(_Loader2.default, null);
	    }
	  }]);
	  return Registration;
	}(_react.Component)) || _class) || _class);
	exports.default = Registration;
	
	
	Registration.propTypes = {
	  logout: _propTypes2.default.shape({
	    rejected: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }),
	  status: _propTypes2.default.shape({
	    loggedIn: _propTypes2.default.bool,
	    redirectTo: _propTypes2.default.string
	  }),
	  signup: _propTypes2.default.shape({
	    rejected: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }),
	  token: _propTypes2.default.string,
	  acceptInvitation: _propTypes2.default.func,
	  logoutAction: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _isNull = __webpack_require__(732);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _camelize2 = __webpack_require__(364);
	
	var _camelize3 = _interopRequireDefault(_camelize2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _PasswordInput = __webpack_require__(335);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _strings = __webpack_require__(15);
	
	var _handleApiError = __webpack_require__(1924);
	
	var _handleApiError2 = _interopRequireDefault(_handleApiError);
	
	var _routes = __webpack_require__(37);
	
	var _status = __webpack_require__(1244);
	
	var _getPhone = __webpack_require__(187);
	
	var _editUserValidation = __webpack_require__(4188);
	
	var _editUserValidation2 = _interopRequireDefault(_editUserValidation);
	
	var _selectors = __webpack_require__(93);
	
	var _actions = __webpack_require__(632);
	
	var _selectors2 = __webpack_require__(56);
	
	var _selectors3 = __webpack_require__(23);
	
	var _authAzure = __webpack_require__(631);
	
	var _countryDetails = __webpack_require__(527);
	
	var _selectors4 = __webpack_require__(50);
	
	var _selectors5 = __webpack_require__(403);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _gtag = __webpack_require__(182);
	
	var _CheckPasswordList = __webpack_require__(1094);
	
	var _CheckPasswordList2 = _interopRequireDefault(_CheckPasswordList);
	
	var _usernameValidation = __webpack_require__(1713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    user: (0, _selectors3.loggedUserSelector)(state),
	    invitationType: _selectors5.selectAuthStatusInvitationType,
	    loggedIn: (0, _selectors.isLoggedInSelector)(state),
	    editUser: (0, _selectors2.selectEditedUser)(state),
	    usernameAvailabilityError: (0, _selectors5.selectUsernameAvailabilityError)(state),
	    invitationMethod: (0, _selectors5.selectAuthStatusInvitationMethod)(state),
	    countries: (0, _selectors4.selectCountryList)(state),
	    privacyList: (0, _selectors4.privacyListSelector)(state),
	    signupFormData: (0, _selectors5.selectSignupProcessFormData)(state),
	    isSuccessAuthAzureForSignUp: (0, _selectors.selectSuccessAuthAzureForSignUpFlow)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  proceed: _actions.signupActions.proceed,
	  authAzure: _authAzure.actions.init,
	  getDetailsCountry: _countryDetails.actions.send
	};
	
	var SignUp = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = function (_PureComponent) {
	  (0, _inherits3.default)(SignUp, _PureComponent);
	
	  function SignUp() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SignUp);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SignUp.__proto__ || (0, _getPrototypeOf2.default)(SignUp)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      errors: null,
	      submitted: false,
	      password: null,
	      passwordConfirmation: null,
	      isValidPassword: false,
	      phoneNumberConfirmed: true,
	      emailConfirmed: true,
	      isOpenPopover: false
	    }, _this.getSubtitleId = function () {
	      var _this2 = _this,
	          isNotFakeEmail = _this2.isNotFakeEmail,
	          props = _this2.props;
	      var phoneNumber = props.user.phoneNumber;
	
	      var id = 'auth.signup.text.phone';
	      if (isNotFakeEmail) id = 'auth.signup.text.email';
	      if (isNotFakeEmail && phoneNumber) id = 'auth.signup.text.emailPhone';
	      return id;
	    }, _this.handleConfirm = function (type, value) {
	      _this.setState((0, _defineProperty3.default)({}, type, value));
	    }, _this.handlePassword = function (type, value, invalid) {
	      var _this$setState2;
	
	      _this.setState((_this$setState2 = {}, (0, _defineProperty3.default)(_this$setState2, type, value), (0, _defineProperty3.default)(_this$setState2, 'isValidPassword', !invalid), _this$setState2));
	    }, _this.handleTypeUsername = function (username) {
	      _this.setState({ username: username });
	    }, _this.handleOpenPopover = function () {
	      _this.setState({ isOpenPopover: true });
	    }, _this.handleClosePopover = function () {
	      _this.setState({ isOpenPopover: false });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SignUp, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          signupFormData = _props.signupFormData,
	          getDetailsCountry = _props.getDetailsCountry;
	
	      getDetailsCountry({ code: 'us' });
	
	      (0, _gtag.GATrackPageView)('Sign Up');
	      if (signupFormData) {
	        var _camelize = (0, _camelize3.default)(signupFormData),
	            passwordConfirmation = _camelize.passwordConfirmation,
	            password = _camelize.password,
	            username = _camelize.username;
	
	        this.setState({
	          password: password,
	          passwordConfirmation: passwordConfirmation,
	          username: username,
	          isValidPassword: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // eslint-disable-next-line react/destructuring-assignment
	      if (this.props.serializedForm !== nextProps.serializedForm) {
	        var form = nextProps.serializedForm;
	        var errors = (0, _editUserValidation2.default)(form);
	
	        this.setState({
	          errors: errors,
	          submitted: true
	        });
	      }
	    }
	  }, {
	    key: 'getEmailField',
	    value: function getEmailField(value, classes) {
	      var formatMessage = this.props.intl.formatMessage;
	
	
	      return _react2.default.createElement(_TextInput2.default, {
	        key: 1,
	        className: classes,
	        disabled: true,
	        id: 'signup-email',
	        label: formatMessage(_strings.AUTH.fields.email),
	        name: 'email',
	        value: value,
	        placeholder: formatMessage(_strings.AUTH.fields.email),
	        rounded: true,
	        type: 'email'
	      });
	    }
	  }, {
	    key: 'getPhoneNumberField',
	    value: function getPhoneNumberField(value, classes) {
	      var formatMessage = this.props.intl.formatMessage;
	
	
	      return _react2.default.createElement(_TextInput2.default, {
	        key: 2,
	        className: classes,
	        disabled: true,
	        id: 'signup-phoneNumber',
	        label: formatMessage(_strings.AUTH.fields.phoneNumber),
	        name: 'phoneNumber',
	        value: (0, _getPhone.getPhoneWithoutUSCode)(value),
	        placeholder: formatMessage(_strings.AUTH.fields.phoneNumber),
	        rounded: true,
	        type: 'text'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var isNotFakeEmail = this.isNotFakeEmail;
	      var _state = this.state,
	          errors = _state.errors,
	          submitted = _state.submitted,
	          password = _state.password,
	          passwordConfirmation = _state.passwordConfirmation,
	          isValidPassword = _state.isValidPassword,
	          phoneNumberConfirmed = _state.phoneNumberConfirmed,
	          emailConfirmed = _state.emailConfirmed,
	          username = _state.username,
	          isOpenPopover = _state.isOpenPopover;
	      var _props2 = this.props,
	          usernameAvailabilityError = _props2.usernameAvailabilityError,
	          _props2$editUser = _props2.editUser,
	          error = _props2$editUser.error,
	          rejected = _props2$editUser.rejected,
	          getAction = _props2.getAction,
	          user = _props2.user,
	          proceed = _props2.proceed,
	          invitationType = _props2.invitationType,
	          loggedIn = _props2.loggedIn,
	          formatMessage = _props2.intl.formatMessage,
	          invitationMethod = _props2.invitationMethod,
	          countries = _props2.countries,
	          privacyList = _props2.privacyList,
	          authAzure = _props2.authAzure,
	          isSuccessAuthAzureForSignUp = _props2.isSuccessAuthAzureForSignUp;
	
	
	      var isValidUsername = (0, _usernameValidation.validateUsernameLength)(username) && (0, _usernameValidation.validateUsernameCharacters)(username) && (0, _usernameValidation.validateUsernameSpaces)(username) && (0, _usernameValidation.validateUsernameRepeating)(username);
	
	      if (!invitationType) {
	        var route = loggedIn ? _routes.MESSAGES : _routes.LOGIN;
	        _reactRouter.browserHistory.push(route);
	      }
	
	      if (isSuccessAuthAzureForSignUp) {
	        _reactRouter.browserHistory.push(_routes.SIGN_UP_AZURE);
	      }
	
	      var isPasswordsChecked = password === passwordConfirmation;
	      // allow api request if front validation passed
	      if (submitted && !errors && isPasswordsChecked) {
	        getAction(function (data) {
	          proceed(data);
	        });
	      }
	
	      var email = user.email,
	          phoneNumber = user.phoneNumber;
	
	
	      var passwordConfirmationError = !isPasswordsChecked && formatMessage(_strings.AUTH.actions.signup.matchPassword);
	
	      var availabilityError = (0, _get2.default)(usernameAvailabilityError, 'description', null) && formatMessage(_strings.PROFILE.errors.username.taken);
	
	      var errorEncountered = rejected || submitted && !!errors || !!passwordConfirmationError || !!availabilityError;
	      // eslint-disable-next-line no-nested-ternary
	      var validationErrors = rejected ? (0, _handleApiError2.default)(error) || formatMessage(_strings.AUTH.errors.common) : submitted ? errors : null;
	      var hasPassword = !(0, _isNull2.default)(password) && !(0, _isNull2.default)(passwordConfirmation);
	      var isEnabled = isPasswordsChecked && hasPassword && isValidPassword && isValidUsername;
	      var isLoadedPrivacyAndCountries = privacyList.length && countries.length;
	
	      var inputFieldCn = (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb3');
	
	      var handleProceedAzureSignUp = function handleProceedAzureSignUp(e) {
	        e.preventDefault();
	        authAzure({ intl: formatMessage, signUpFlow: true });
	      };
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.signup' }),
	        user && invitationType && isLoadedPrivacyAndCountries ? _react2.default.createElement(
	          'div',
	          { className: _index2.default.formWrapper },
	          _react2.default.createElement(
	            'p',
	            { className: _index2.default.formTitle },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.titles.signup),
	            _react2.default.createElement(
	              'span',
	              { className: _index2.default.formStep },
	              ' (1/2)'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _index2.default.formText },
	            formatMessage({ id: this.getSubtitleId() })
	          ),
	          invitationMethod === _status.invitationMethods.phoneNumber && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            this.getPhoneNumberField(phoneNumber, inputFieldCn),
	            isNotFakeEmail && _react2.default.createElement(
	              _react.Fragment,
	              null,
	              this.getEmailField(email, inputFieldCn),
	              _react2.default.createElement(_Checkbox2.default, {
	                className: _index2.default.checkboxConfirm,
	                id: 'emailConfirmed',
	                name: 'emailConfirmed',
	                value: emailConfirmed,
	                checked: emailConfirmed,
	                label: formatMessage(_strings.AUTH.titles.confirmMyEmail),
	                onChange: function onChange(value) {
	                  return _this3.handleConfirm('emailConfirmed', value);
	                }
	              })
	            )
	          ),
	          invitationMethod === _status.invitationMethods.email && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            this.getEmailField(email, inputFieldCn),
	            phoneNumber && _react2.default.createElement(
	              _react.Fragment,
	              null,
	              this.getPhoneNumberField(phoneNumber, inputFieldCn),
	              _react2.default.createElement(_Checkbox2.default, {
	                className: _index2.default.checkboxConfirm,
	                id: 'phoneNumberConfirmed',
	                name: 'phoneNumberConfirmed',
	                checked: phoneNumberConfirmed,
	                value: phoneNumberConfirmed,
	                label: formatMessage(_strings.AUTH.titles.confirmMyPhoneNumber),
	                onChange: function onChange(value) {
	                  return _this3.handleConfirm('phoneNumberConfirmed', value);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(_PasswordInput2.default, {
	            autoComplete: 'new-password',
	            className: inputFieldCn,
	            withValidation: true,
	            id: 'password',
	            name: 'password',
	            rounded: true,
	            value: password,
	            onChange: this.handlePassword
	          }),
	          _react2.default.createElement(_PasswordInput2.default, {
	            autoComplete: 'new-password',
	            className: inputFieldCn,
	            id: 'passwordConfirmation',
	            name: 'passwordConfirmation',
	            value: passwordConfirmation,
	            rounded: true,
	            placeholder: formatMessage(_strings.AUTH.actions.signup.confirmationPassword),
	            onChange: this.handlePassword,
	            withValidation: true
	          }),
	          _react2.default.createElement(
	            _TextInput2.default,
	            {
	              className: 'mb3 relative',
	              id: 'signup-username',
	              label: _react2.default.createElement(
	                'div',
	                { className: 'df items-end' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.fields.username)
	              ),
	              name: 'username',
	              value: username,
	              placeholder: formatMessage((0, _extends3.default)({}, _strings.AUTH.fields.username)),
	              rounded: true,
	              type: 'text',
	              onChange: this.handleTypeUsername,
	              onFocus: this.handleOpenPopover,
	              onBlur: this.handleClosePopover
	            },
	            isOpenPopover && _react2.default.createElement(
	              _CheckPasswordList2.default,
	              {
	                title: 'auth.signup.popover.title',
	                list: (0, _usernameValidation.getUsernameTooltipOptions)(username)
	              },
	              _react2.default.createElement(
	                'div',
	                { className: _index2.default.popoverInfo },
	                _react2.default.createElement(_Icon2.default, { name: 'icon-info', size: 16 }),
	                formatMessage({ id: 'auth.signup.text.username' })
	              )
	            )
	          ),
	          errorEncountered && _react2.default.createElement(_ErrorBlock2.default, {
	            className: _index2.default.errorBlock,
	            errors: availabilityError || passwordConfirmationError || validationErrors
	          }),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: (0, _classnames2.default)(_index2.default.acceptBtn, 'db mb3 w-100 lh-copy'),
	              color: 'primary',
	              raised: true,
	              type: 'submit',
	              disabled: !isEnabled
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'auth.nextStep' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.loginAzureWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.dividerOr },
	              formatMessage({ id: 'auth.otherLoginOptions' })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: (0, _classnames2.default)(_index2.default.acceptBtn, _index2.default.microsoftButton, 'db mb3 w-100 lh-copy'),
	                color: 'accent',
	                raised: true,
	                onClick: handleProceedAzureSignUp
	              },
	              _react2.default.createElement(_Icon2.default, {
	                name: 'icon-microsoft',
	                size: 24,
	                className: _index2.default.microsoftLogo
	              }),
	              _react2.default.createElement(_reactIntl.FormattedMessage, _strings.AUTH.submit.signUpAzure)
	            )
	          )
	        ) : _react2.default.createElement(_Loader2.default, null)
	      );
	    }
	  }, {
	    key: 'isNotFakeEmail',
	    get: function get() {
	      var _props$user = this.props.user,
	          email = _props$user.email,
	          emailFake = _props$user.emailFake;
	
	      return email && !emailFake;
	    }
	  }]);
	  return SignUp;
	}(_react.PureComponent)) || _class) || _class) || _class);
	exports.default = SignUp;
	
	
	SignUp.propTypes = {
	  editUser: _propTypes2.default.shape({
	    error: _propTypes2.default.object,
	    rejected: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }),
	  getAction: _propTypes2.default.func,
	  user: _propTypes2.default.shape({
	    emailFake: _propTypes2.default.bool,
	    id: _propTypes2.default.number,
	    email: _propTypes2.default.string,
	    bio: _propTypes2.default.string,
	    username: _propTypes2.default.string,
	    healthInterests: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    displayableName: _propTypes2.default.string,
	    avatar: _propTypes2.default.objectOf(_propTypes2.default.string),
	    phoneNumber: _propTypes2.default.string,
	    primaryProviderProfile: _propTypes2.default.object,
	    primaryPatientProfile: _propTypes2.default.object,
	    country: _propTypes2.default.string,
	    userOrganizations: _propTypes2.default.array
	  }),
	  redirectTo: _propTypes2.default.string,
	  proceed: _propTypes2.default.func,
	  serializedForm: _propTypes2.default.object,
	  invitationType: _propTypes2.default.string,
	  loggedIn: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  invitationMethod: _propTypes2.default.string,
	  countries: _propTypes2.default.array,
	  signupFormData: _propTypes2.default.object,
	  usernameAvailabilityError: _propTypes2.default.object,
	  privacyList: _propTypes2.default.array,
	  getDetailsCountry: _propTypes2.default.func,
	  authAzure: _propTypes2.default.func,
	  isSuccessAuthAzureForSignUp: _propTypes2.default.bool
	};

/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(56);
	
	var _selectors2 = __webpack_require__(403);
	
	var _selectors3 = __webpack_require__(50);
	
	var _actions = __webpack_require__(632);
	
	var _selectors4 = __webpack_require__(23);
	
	var _getSelectOptions = __webpack_require__(1163);
	
	var _checkCountryForOrganization = __webpack_require__(1926);
	
	var _checkCountryForOrganization2 = _interopRequireDefault(_checkCountryForOrganization);
	
	var _parseJSONSafely = __webpack_require__(910);
	
	var _parseJSONSafely2 = _interopRequireDefault(_parseJSONSafely);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	var _index = __webpack_require__(373);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    races: (0, _selectors3.selectRaceTypes)(state),
	    profile: (0, _selectors4.loggedUserSelector)(state),
	    ethnicitys: (0, _selectors3.selectEthnicTypes)(state),
	    rawGenderList: (0, _selectors3.selectGenderTypes)(state),
	    nameSuffixList: (0, _selectors3.selectNameSuffixesList)(state),
	    countriesList: (0, _selectors3.selectCountryList)(state),
	    pendingProcess: (0, _selectors.selectSignupProcessPending)(state),
	    dataValidationErrors: (0, _selectors.selectEditedUserErrors)(state),
	    invitationMethod: (0, _selectors2.selectAuthStatusInvitationMethod)(state),
	    profileEditable: (0, _parseJSONSafely2.default)(localStorage.getItem('fieldsEditable'))
	  };
	};
	
	var mapDispatchToProps = {
	  confirmSignUp: _actions.signupActions.confirm
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      profile = _ref.profile,
	      countriesList = _ref.countriesList,
	      rawGenderList = _ref.rawGenderList;
	
	  var _ref2 = profile || {},
	      id = _ref2.id,
	      userOrganizations = _ref2.userOrganizations;
	
	  return {
	    userId: id,
	    formatMessage: formatMessage,
	    title: 'titles.signup',
	    countries: (0, _getSelectOptions.getSelectOptions)(countriesList.map(function (country) {
	      return country && country.name;
	    })),
	    genderList: (0, _convertListWithLocalization.convertGenderList)(rawGenderList, formatMessage) || [],
	    countryForOrganization: (0, _checkCountryForOrganization2.default)(userOrganizations)
	  };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _strings = __webpack_require__(15);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _status = __webpack_require__(1244);
	
	var _getPhone = __webpack_require__(187);
	
	var _useAuthPersonalInfoState = __webpack_require__(1712);
	
	var _AuthPersonalInfoForm = __webpack_require__(1708);
	
	var _AuthPersonalInfoForm2 = _interopRequireDefault(_AuthPersonalInfoForm);
	
	var _enhance = __webpack_require__(3098);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignUpAzure = function SignUpAzure(_ref) {
	  var title = _ref.title,
	      userId = _ref.userId,
	      profile = _ref.profile,
	      countries = _ref.countries,
	      genderList = _ref.genderList,
	      confirmSignUp = _ref.confirmSignUp,
	      formatMessage = _ref.formatMessage,
	      pendingProcess = _ref.pendingProcess,
	      nameSuffixList = _ref.nameSuffixList,
	      profileEditable = _ref.profileEditable,
	      invitationMethod = _ref.invitationMethod,
	      countryForOrganization = _ref.countryForOrganization,
	      errors = _ref.dataValidationErrors,
	      races = _ref.races,
	      ethnicitys = _ref.ethnicitys;
	
	  var _useAuthPersonalInfoF = (0, _useAuthPersonalInfoState.useAuthPersonalInfoForm)((0, _extends3.default)({}, profile), errors, {
	    showPrivacy: true
	  }),
	      handleFormChange = _useAuthPersonalInfoF.handleFormChange,
	      validateErrors = _useAuthPersonalInfoF.validateErrors,
	      clearErrors = _useAuthPersonalInfoF.clearErrors,
	      formState = _useAuthPersonalInfoF.formState,
	      isValid = _useAuthPersonalInfoF.isValid;
	
	  (0, _usePageView.usePageView)('Sign Up (Azure)');
	
	  var _useReducer = (0, _react.useReducer)(function (confirm) {
	    return !confirm;
	  }, true),
	      _useReducer2 = (0, _slicedToArray3.default)(_useReducer, 2),
	      phoneConfirmed = _useReducer2[0],
	      togglePhoneConfirm = _useReducer2[1];
	
	  var inviteByEmail = invitationMethod === _status.invitationMethods.email;
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    clearErrors();
	
	    confirmSignUp((0, _extends3.default)({}, formState, {
	      id: userId
	    }, inviteByEmail && profile.phoneNumber && { phoneNumberConfirmed: phoneConfirmed }, !inviteByEmail && profile.email && !profile.emailFake && { emailConfirmed: true }));
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.signupAzure' }),
	    profile ? _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_index2.default.formWrapper, { mt5: !(0, _mobileHelpers.isDesktop)() }) },
	      _react2.default.createElement(
	        'p',
	        { className: _index2.default.formTitle },
	        _react2.default.createElement(
	          'span',
	          null,
	          formatMessage({ id: title })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _index2.default.formStep },
	          ' (2/2)'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { className: _index2.default.formText },
	          formatMessage({ id: 'auth.signup.azure.description' })
	        ),
	        inviteByEmail ? _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_TextInput2.default, {
	            key: 1,
	            disabled: true,
	            id: 'signup-email',
	            label: formatMessage(_strings.AUTH.fields.email),
	            name: 'email',
	            value: profile.email,
	            placeholder: formatMessage(_strings.AUTH.fields.email),
	            rounded: true,
	            type: 'email',
	            className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb3')
	          }),
	          profile.phoneNumber && _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(_TextInput2.default, {
	              key: 2,
	              disabled: true,
	              id: 'signup-phone',
	              label: formatMessage(_strings.AUTH.fields.phoneNumber),
	              name: 'phone',
	              value: (0, _getPhone.getPhoneWithoutUSCode)(profile.phoneNumber),
	              placeholder: formatMessage(_strings.AUTH.fields.phoneNumber),
	              rounded: true,
	              type: 'phoneNumber',
	              className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb2')
	            }),
	            _react2.default.createElement(_Checkbox2.default, {
	              className: (0, _classnames2.default)(_index2.default.checkboxConfirm, 'mb3'),
	              id: 'phoneConfirmed',
	              name: 'phoneConfirmed',
	              value: phoneConfirmed,
	              checked: phoneConfirmed,
	              label: formatMessage(_strings.AUTH.titles.confirmMyPhoneNumber),
	              onChange: function onChange() {
	                return togglePhoneConfirm();
	              }
	            })
	          )
	        ) : _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_TextInput2.default, {
	            key: 3,
	            disabled: true,
	            id: 'signup-phone',
	            label: formatMessage(_strings.AUTH.fields.phoneNumber),
	            name: 'phone',
	            value: (0, _getPhone.getPhoneWithoutUSCode)(profile.phoneNumber),
	            placeholder: formatMessage(_strings.AUTH.fields.phoneNumber),
	            rounded: true,
	            type: 'phoneNumber',
	            className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb3')
	          }),
	          profile.email && !profile.emailFake && _react2.default.createElement(_TextInput2.default, {
	            key: 4,
	            disabled: true,
	            id: 'signup-email',
	            label: formatMessage(_strings.AUTH.fields.email),
	            name: 'email',
	            value: profile.email,
	            placeholder: formatMessage(_strings.AUTH.fields.email),
	            rounded: true,
	            type: 'email',
	            className: (0, _classnames2.default)(_index2.default.labelField, _index2.default.inputField, 'mb3')
	          })
	        ),
	        _react2.default.createElement(_AuthPersonalInfoForm2.default, (0, _extends3.default)({}, formState, {
	          showPrivacy: true,
	          races: races,
	          countries: countries,
	          genderList: genderList,
	          ethnicitys: ethnicitys,
	          onChange: handleFormChange,
	          formatMessage: formatMessage,
	          nameSuffixList: nameSuffixList,
	          validateErrors: validateErrors,
	          profileEditable: profileEditable,
	          countryForOrganization: countryForOrganization
	        })),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: (0, _classnames2.default)(_index2.default.acceptBtn, 'db mb3 w-100 lh-copy'),
	            color: 'primary',
	            raised: true,
	            type: 'button',
	            onClick: handleSubmit,
	            disabled: !isValid || pendingProcess
	          },
	          formatMessage({ id: 'common.complete' })
	        )
	      )
	    ) : _react2.default.createElement(_Loader2.default, null)
	  );
	};
	
	SignUpAzure.propTypes = {
	  profile: _propTypes2.default.object,
	  userId: _propTypes2.default.number,
	  genderList: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  pendingProcess: _propTypes2.default.bool,
	  profileEditable: _propTypes2.default.bool,
	  races: _propTypes2.default.array.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  invitationMethod: _propTypes2.default.string,
	  countries: _propTypes2.default.array.isRequired,
	  ethnicitys: _propTypes2.default.array.isRequired,
	  dataValidationErrors: _propTypes2.default.object,
	  countryForOrganization: _propTypes2.default.string,
	  confirmSignUp: _propTypes2.default.func.isRequired,
	  nameSuffixList: _propTypes2.default.array.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(SignUpAzure);

/***/ }),
/* 3100 */,
/* 3101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _getErrorObject = __webpack_require__(1944);
	
	var _getErrorObject2 = _interopRequireDefault(_getErrorObject);
	
	var _errors = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (error, formatMessage) {
	  var fieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'emailOrPhone';
	
	  var code = (0, _get2.default)(error, 'code');
	  if (!code) return null;
	
	  if (code === _errors.ERROR_CODES.LOGIN_NOT_FOUND) return (0, _getErrorObject2.default)(fieldName, 'invalid', formatMessage({
	    id: fieldName === 'username' ? 'errors.login.unauthorized' : 'errors.login.notFound'
	  }));
	
	  if (code === _errors.ERROR_CODES.REGISTRATION_NOT_FINISHED) return (0, _getErrorObject2.default)(fieldName, 'invalid', formatMessage({ id: 'errors.login.registrationNotFinished' }));
	
	  if (code === _errors.ERROR_CODES.INVALID_LOGIN) return (0, _getErrorObject2.default)(fieldName, 'invalid', formatMessage({ id: 'errors.login.incorrect' }));
	
	  return (0, _getErrorObject2.default)(fieldName, 'invalid', formatMessage({ id: 'errors.common' }));
	};

/***/ }),
/* 3102 */,
/* 3103 */,
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _reduce = __webpack_require__(1560);
	
	var _reduce2 = _interopRequireDefault(_reduce);
	
	var _set = __webpack_require__(1561);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _react = __webpack_require__(1);
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFields = [_formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, _formFields.PROFILE_FIELDS_TYPES.NAME_SUFFIX, _formFields.PROFILE_FIELDS_TYPES.DOB, _formFields.PROFILE_FIELDS_TYPES.GENDER, _formFields.PROFILE_FIELDS_TYPES.ETHNICITY, _formFields.PROFILE_FIELDS_TYPES.RACE];
	
	var defaultValidationFields = [_formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, _formFields.PROFILE_FIELDS_TYPES.DOB, _formFields.PROFILE_FIELDS_TYPES.GENDER];
	
	var initialFieldsWithPrivacy = [].concat(defaultFields, [_formFields.PROFILE_FIELDS_TYPES.COUNTRY]);
	
	var validationFieldsWithPrivacy = [].concat(defaultValidationFields, [_formFields.PROFILE_FIELDS_TYPES.ACCEPTED_PRIVACY_POLICY, _formFields.PROFILE_FIELDS_TYPES.ACCEPTED_TERMS_AND_CONDITIONS]);
	
	var useFields = function useFields(_ref) {
	  var showPrivacy = _ref.showPrivacy;
	
	  return (0, _react.useMemo)(function () {
	    var initialFields = defaultFields;
	    var validationFields = defaultValidationFields;
	
	    if (showPrivacy) {
	      initialFields = initialFieldsWithPrivacy;
	      validationFields = [].concat((0, _toConsumableArray3.default)(validationFieldsWithPrivacy), [_formFields.PROFILE_FIELDS_TYPES.COUNTRY]);
	    }
	
	    var initialState = (0, _reduce2.default)(initialFields, function (result, value) {
	      return (0, _set2.default)(result, value, '');
	    }, {});
	
	    return { initialState: initialState, initialFields: initialFields, validationFields: validationFields };
	  }, [showPrivacy]);
	};
	
	exports.default = useFields;

/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _group = __webpack_require__(4920);
	
	var _group2 = _interopRequireDefault(_group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupAvatar = function GroupAvatar(_ref) {
	  var active = _ref.active,
	      iconSize = _ref.iconSize,
	      iconName = _ref.iconName,
	      width = _ref.width,
	      height = _ref.height,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: className,
	      style: {
	        height: height,
	        width: width
	      },
	      styleName: (0, _classnames2.default)('image', { 'image--bordered': active })
	    },
	    _react2.default.createElement(_Icon2.default, { name: iconName, size: iconSize, style: { fill: _styles.COLORS.white } })
	  );
	};
	
	GroupAvatar.propTypes = {
	  active: _propTypes2.default.bool,
	  iconSize: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  iconName: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string
	};
	
	GroupAvatar.defaultProps = {
	  className: '',
	  active: false,
	  iconSize: 20,
	  width: 32,
	  height: 32
	};
	
	exports.default = (0, _reactCssModules2.default)(GroupAvatar, _group2.default, { allowMultiple: true });

/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _completeCarePlanTaskReq = __webpack_require__(852);
	
	var completeCarePlanTask = _interopRequireWildcard(_completeCarePlanTaskReq);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userId: (0, _selectors.targetUserIdSelector)(state),
	    pending: (0, _selectors2.selectCompleteCarePlanTaskPending)(state),
	    succeed: (0, _selectors2.selectCompleteCarePlanTaskSucceed)(state),
	    error: (0, _selectors2.selectCompleteCarePlanTaskError)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  clear: completeCarePlanTask.actions.clear,
	  complete: completeCarePlanTask.actions.start
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _enhance = __webpack_require__(3106);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _SingleSelect = __webpack_require__(257);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _ExpandableListItem = __webpack_require__(285);
	
	var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);
	
	var _tasks = __webpack_require__(3902);
	
	var _handleTaskTime = __webpack_require__(608);
	
	var _constants = __webpack_require__(17);
	
	var _selectors = __webpack_require__(64);
	
	var _TaskDocuments = __webpack_require__(1752);
	
	var _styles = __webpack_require__(4923);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarePlanDetailsPopup = function CarePlanDetailsPopup(_ref) {
	  var id = _ref.id,
	      error = _ref.error,
	      clear = _ref.clear,
	      itemId = _ref.itemId,
	      succeed = _ref.succeed,
	      pending = _ref.pending,
	      onClose = _ref.onClose,
	      complete = _ref.complete,
	      userId = _ref.userId,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      outcomeId = _useState2[0],
	      setOutcomeId = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      attachments = _useState4[0],
	      setAttachment = _useState4[1];
	
	  var activeItem = (0, _reactRedux.useSelector)(_selectors.selectActiveTodoItem);
	  var name = activeItem.name,
	      status = activeItem.status,
	      todoTask = activeItem.todoTask,
	      description = activeItem.description,
	      expiredTime = activeItem.expiredTime,
	      chosenOutcome = activeItem.chosenOutcome,
	      completedTime = activeItem.completedTime,
	      carePlanTodoType = activeItem.carePlanTodoType,
	      _activeItem$taskOutco = activeItem.taskOutcomes,
	      taskOutcomes = _activeItem$taskOutco === undefined ? [] : _activeItem$taskOutco,
	      outcomeAttachments = activeItem.outcomeAttachments,
	      displayableName = activeItem.assigner.displayableName;
	
	
	  var links = todoTask ? todoTask.links : [];
	
	  var activeOutcome = (0, _react.useMemo)(function () {
	    return taskOutcomes.find(function (el) {
	      return el.id === outcomeId;
	    });
	  }, [outcomeId, taskOutcomes]);
	
	  var completedOutcome = (0, _react.useMemo)(function () {
	    return taskOutcomes.find(function (el) {
	      return el.id === chosenOutcome;
	    });
	  }, [outcomeId, taskOutcomes]);
	
	  var attachmentRequired = (0, _get2.default)(activeOutcome, 'attachmentEnabled');
	
	  var disabled = (0, _react.useMemo)(function () {
	    var noRequiredAttachment = !(0, _size2.default)(attachments) && attachmentRequired;
	
	    return carePlanTodoType === 'base' && (!outcomeId || pending || (0, _size2.default)(attachments) > _tasks.TASK_ATTACHMENT_LIMIT || noRequiredAttachment) && taskOutcomes.length;
	  }, [pending, outcomeId, attachments, attachmentRequired]);
	
	  var completed = (0, _react.useMemo)(function () {
	    return _constants.COMPLETED_STATUSES.includes(status);
	  }, [status]);
	
	  var note = (0, _handleTaskTime.timeToShow)(completedTime, expiredTime, null, formatMessage);
	
	  var subtitle = formatMessage({ id: 'carePlan.assignedBy.provider' }, { displayableName: displayableName });
	  var titleId = (0, _react.useMemo)(function () {
	    switch (status) {
	      case _constants.TODO_STATUSES.CANCELED:
	        return 'task.canceled';
	      case _constants.TODO_STATUSES.COMPLETED:
	        return 'task.completed';
	      default:
	        return 'task.upcoming';
	    }
	  }, [status]);
	
	  var outcomesList = (0, _react.useMemo)(function () {
	    return taskOutcomes.map(function (item) {
	      return {
	        value: item.id,
	        label: item.text
	      };
	    });
	  }, [taskOutcomes]);
	
	  var handleComplete = function handleComplete() {
	    var data = { id: id, userId: userId, itemId: itemId, outcomeId: outcomeId, attachments: attachments };
	    complete(data);
	  };
	
	  var handleOptionChange = (0, _react.useCallback)(function (value) {
	    setOutcomeId(value);
	  }, []);
	
	  var showDocuments = completed ? !(0, _isEmpty2.default)(outcomeAttachments) : attachmentRequired;
	
	  var completedOutcomeText = (0, _get2.default)(completedOutcome, 'text');
	
	  var errorText = (0, _react.useMemo)(function () {
	    return error && ((0, _get2.default)(error, 'description') || formatMessage({ id: 'errors.common' }));
	  }, [error]);
	
	  (0, _react.useEffect)(function () {
	    if (succeed) onClose();
	  }, [succeed]);
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      return clear();
	    };
	  }, []);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      onClose: onClose,
	      opened: Boolean(itemId),
	      title: formatMessage({ id: titleId }),
	      width: (0, _mobileHelpers.isDesktop)() ? 'small' : 'medium'
	    },
	    _react2.default.createElement(
	      _ExpandableListItem2.default,
	      {
	        locked: true,
	        key: itemId,
	        'data-id': itemId,
	        header: {
	          note: note,
	          subtitle: subtitle,
	          title: name,
	          icon: 'assigned-task'
	        }
	      },
	      error ? _react2.default.createElement(_ErrorBlock2.default, { className: 'mt2 mb2', errors: errorText }) : null,
	      pending ? _react2.default.createElement(_Loader2.default, { className: 'absolute-center' }) : null,
	      Boolean(description) ? _react2.default.createElement(
	        'p',
	        { className: _styles2.default.description },
	        description
	      ) : null,
	      !(0, _isEmpty2.default)(links) ? links.map(function (link) {
	        return _react2.default.createElement(
	          'a',
	          {
	            target: '_blank',
	            key: (0, _get2.default)(link, 'id'),
	            className: _styles2.default.link,
	            rel: 'noopener noreferrer',
	            href: (0, _get2.default)(link, 'urlLink')
	          },
	          (0, _get2.default)(link, 'urlDescription')
	        );
	      }) : null,
	      Boolean(taskOutcomes.length && !completed) ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section },
	        _react2.default.createElement(
	          'h3',
	          { className: _styles2.default.title },
	          formatMessage({ id: 'task.selectOutcome' })
	        ),
	        _react2.default.createElement(_SingleSelect2.default, {
	          name: 'outcome',
	          list: outcomesList,
	          radioInputClass: 'mr2',
	          selectClass: _styles2.default.list,
	          onChange: handleOptionChange,
	          selectedValue: outcomeId
	        })
	      ) : null,
	      Boolean(completedOutcomeText) && completed ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section },
	        _react2.default.createElement(
	          'h3',
	          { className: _styles2.default.title },
	          formatMessage({ id: 'task.outcome' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          completedOutcomeText
	        )
	      ) : null,
	      showDocuments ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section },
	        _react2.default.createElement(
	          'h3',
	          { className: _styles2.default.title },
	          formatMessage({ id: 'common.documents' })
	        ),
	        _react2.default.createElement(_TaskDocuments.TaskDocuments, {
	          completed: completed,
	          formatMessage: formatMessage,
	          addAttachment: setAttachment,
	          disabled: (0, _size2.default)(attachments) >= _tasks.TASK_ATTACHMENT_LIMIT,
	          attachments: completed ? outcomeAttachments : attachments
	        })
	      ) : null,
	      !completed && !error ? _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'primary',
	          disabled: disabled,
	          onClick: handleComplete,
	          className: (0, _classnames2.default)(_styles2.default.completed, { mt0: Boolean(description) })
	        },
	        formatMessage({ id: 'common.complete' })
	      ) : null
	    )
	  );
	};
	
	CarePlanDetailsPopup.propTypes = {
	  id: _propTypes2.default.number,
	  clear: _propTypes2.default.func,
	  error: _propTypes2.default.object,
	  succeed: _propTypes2.default.bool,
	  pending: _propTypes2.default.bool,
	  itemId: _propTypes2.default.number,
	  onClose: _propTypes2.default.func,
	  complete: _propTypes2.default.func,
	  userId: _propTypes2.default.number,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _enhance.enhance)(CarePlanDetailsPopup);

/***/ }),
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(237);
	
	var _cancelFamilyMemberInvitation = __webpack_require__(511);
	
	var cancelFamilyMemberInvitation = _interopRequireWildcard(_cancelFamilyMemberInvitation);
	
	var _cancelCaregiverInvitation = __webpack_require__(510);
	
	var cancelCaregiverInvitation = _interopRequireWildcard(_cancelCaregiverInvitation);
	
	var _cancelGuardianInvitationReq = __webpack_require__(816);
	
	var cancelGuardianInvitation = _interopRequireWildcard(_cancelGuardianInvitationReq);
	
	var _cancelPendingInvitationSaga = __webpack_require__(4003);
	
	var _cancelPendingInvitationSaga2 = _interopRequireDefault(_cancelPendingInvitationSaga);
	
	var _injectSaga = __webpack_require__(116);
	
	var _injectSaga2 = _interopRequireDefault(_injectSaga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapDispatchToProps = {
	  cancelFamilyMemberInvite: cancelFamilyMemberInvitation.actions.send,
	  cancelCaregiverInvite: cancelCaregiverInvitation.actions.send,
	  cancelGuardianInvite: cancelGuardianInvitation.actions.send,
	  clearFamilyMemberInvite: cancelFamilyMemberInvitation.actions.clear,
	  clearCaregiverInvite: cancelCaregiverInvitation.actions.clear,
	  clearGuardianInvite: cancelGuardianInvitation.actions.clear
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    succeed: (0, _selectors.selectCancelPendingInvitationSucceed)(state),
	    rejected: (0, _selectors.selectCancelPendingInvitationReqError)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _injectSaga2.default)({
	  key: 'pendingInvitationSaga',
	  saga: _cancelPendingInvitationSaga2.default
	}), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var clearCaregiverInvite = _ref.clearCaregiverInvite,
	      clearGuardianInvite = _ref.clearGuardianInvite,
	      clearFamilyMemberInvite = _ref.clearFamilyMemberInvite;
	
	  return {
	    clearRequests: function clearRequests() {
	      clearCaregiverInvite();
	      clearGuardianInvite();
	      clearFamilyMemberInvite();
	    }
	  };
	}));

/***/ }),
/* 3122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lowerCase = __webpack_require__(464);
	
	var _lowerCase2 = _interopRequireDefault(_lowerCase);
	
	var _resolveFamilyMemberOption = __webpack_require__(906);
	
	var _resolveFamilyMemberOption2 = _interopRequireDefault(_resolveFamilyMemberOption);
	
	var _checkUserRole = __webpack_require__(3129);
	
	var _strings = __webpack_require__(15);
	
	var _CancelPopup = __webpack_require__(1096);
	
	var _CancelPopup2 = _interopRequireDefault(_CancelPopup);
	
	var _CancelForm = __webpack_require__(1095);
	
	var _CancelForm2 = _interopRequireDefault(_CancelForm);
	
	var _enhance = __webpack_require__(3121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CancelPendingInvitationsPopup(_ref) {
	  var user = _ref.user,
	      onClose = _ref.onClose,
	      rejected = _ref.rejected,
	      succeed = _ref.succeed,
	      clearRequests = _ref.clearRequests,
	      targetUserId = _ref.targetUserId,
	      formatMessage = _ref.formatMessage,
	      cancelGuardianInvite = _ref.cancelGuardianInvite,
	      cancelCaregiverInvite = _ref.cancelCaregiverInvite,
	      cancelFamilyMemberInvite = _ref.cancelFamilyMemberInvite;
	
	  (0, _react.useEffect)(function () {
	    if (succeed) {
	      handleClose();
	    }
	  }, [succeed]);
	
	  var role = user.role,
	      login = user.login,
	      invitationId = user.invitationId,
	      careRole = user.careRole;
	
	  var cancelPopupText = formatMessage(_strings.CANCEL_INVITE.text, {
	    role: (0, _lowerCase2.default)((0, _resolveFamilyMemberOption2.default)({ role: role }, formatMessage)),
	    login: login
	  });
	
	  var cancelAction = function cancelAction() {
	    if ((0, _checkUserRole.isGuardianProxyPatent)(careRole)) return cancelGuardianInvite;
	    if ((0, _checkUserRole.isCaregiver)(careRole)) return cancelCaregiverInvite;
	    return cancelFamilyMemberInvite;
	  };
	
	  var handleClose = function handleClose() {
	    onClose();
	    clearRequests();
	  };
	
	  return _react2.default.createElement(
	    _CancelPopup2.default,
	    {
	      isOpened: true,
	      onClose: handleClose,
	      title: formatMessage(_strings.CANCEL_INVITE.title)
	    },
	    _react2.default.createElement(_CancelForm2.default, {
	      userId: targetUserId,
	      onClose: handleClose,
	      onSubmit: cancelAction(),
	      invitationId: invitationId,
	      text: cancelPopupText,
	      rejected: rejected
	    })
	  );
	}
	
	CancelPendingInvitationsPopup.propTypes = {
	  user: _propTypes2.default.object,
	  onClose: _propTypes2.default.func,
	  succeed: _propTypes2.default.bool,
	  rejected: _propTypes2.default.bool,
	  clearRequests: _propTypes2.default.func,
	  formatMessage: _propTypes2.default.func,
	  targetUserId: _propTypes2.default.number,
	  cancelGuardianInvite: _propTypes2.default.func,
	  cancelCaregiverInvite: _propTypes2.default.func,
	  cancelFamilyMemberInvite: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(CancelPendingInvitationsPopup);

/***/ }),
/* 3123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRouter = __webpack_require__(42);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _getPreparedProfileData = __webpack_require__(908);
	
	var _getPreparedProfileData2 = _interopRequireDefault(_getPreparedProfileData);
	
	var _Intro = __webpack_require__(195);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _style = __webpack_require__(954);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var ContextProfile = function ContextProfile(_ref) {
	  var profileLink = _ref.profileLink,
	      profileData = _ref.profileData,
	      genderList = _ref.genderList,
	      formatMessage = _ref.formatMessage;
	
	  var _getPreparedProfileDa = (0, _getPreparedProfileData2.default)(profileData, genderList, formatMessage),
	      avatar = _getPreparedProfileDa.avatar,
	      name = _getPreparedProfileDa.name,
	      shortDescription = _getPreparedProfileDa.shortDescription;
	
	  return shortDescription ? _react2.default.createElement(
	    _reactRouter.Link,
	    { to: profileLink, className: 'g-hoverable' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'card-wrapper' },
	      _react2.default.createElement(_Card2.default, {
	        userId: (0, _get2.default)(profileData, 'id'),
	        className: 'fw6',
	        text: {
	          primary: name,
	          complementary: shortDescription,
	          intro: _Intro.INTRO_HINT_SELECTORS.patient.messages.patientContext
	        },
	        additionalContent: {
	          left: _react2.default.createElement(_Avatar2.default, { children: name, size: 48, src: avatar })
	        },
	        styleName: 'card'
	      })
	    )
	  ) : null;
	};
	
	ContextProfile.propTypes = {
	  profileLink: _propTypes2.default.string,
	  profileData: _propTypes2.default.object,
	  genderList: _propTypes2.default.array
	};
	
	exports.default = (0, _reactCssModules2.default)(ContextProfile, _style2.default, { allowMultiple: true });

/***/ }),
/* 3124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _UserCard = __webpack_require__(1714);
	
	var _UserCard2 = _interopRequireDefault(_UserCard);
	
	var _getUser2 = __webpack_require__(3131);
	
	var _styles = __webpack_require__(18);
	
	var _style = __webpack_require__(954);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FamilyCircle = function FamilyCircle(_ref) {
	  var relatedPatientId = _ref.relatedPatientId,
	      type = _ref.type,
	      title = _ref.title,
	      list = _ref.list,
	      formatMessage = _ref.formatMessage,
	      isProvider = _ref.isProvider,
	      onInvite = _ref.onInvite,
	      onOpen = _ref.onOpen,
	      hideHeader = _ref.hideHeader,
	      hasFixedHeight = _ref.hasFixedHeight;
	  return _react2.default.createElement(
	    'div',
	    {
	      styleName: (0, _classnames2.default)('circle', {
	        'circle--fixed': hasFixedHeight
	      })
	    },
	    !hideHeader ? _react2.default.createElement(
	      'div',
	      { styleName: 'provider-label' },
	      _react2.default.createElement(
	        'span',
	        { styleName: 'label' },
	        title
	      ),
	      isProvider ? _react2.default.createElement(
	        'div',
	        { styleName: 'assign-wrapper', onClick: onInvite },
	        _react2.default.createElement(_Icon2.default, { name: 'assign-blue', size: 24 }),
	        _react2.default.createElement(
	          'span',
	          { styleName: 'assign-label' },
	          formatMessage({ id: 'dialog.common.inviteMember' })
	        )
	      ) : null
	    ) : null,
	    list.length > 0 && list.map(function (item, index) {
	      var _getUser = (0, _getUser2.getUser)(item, formatMessage),
	          role = _getUser.role,
	          user = _getUser.user;
	
	      var pending = item.pending,
	          isTargetUser = item.isTargetUser;
	
	      return _react2.default.createElement(
	        'div',
	        { key: user.id + '-' + index, styleName: 'family' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'family-header' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'user' },
	            _react2.default.createElement(_UserCard2.default, {
	              className: 'ph3 pv2 fw6',
	              user: user,
	              note: role,
	              size: 40,
	              linkType: type,
	              disabled: pending || isTargetUser,
	              relatedPatientId: relatedPatientId
	            })
	          ),
	          pending && _react2.default.createElement(
	            'p',
	            {
	              styleName: (0, _classnames2.default)('note', {
	                'note--withPadding': !isProvider
	              })
	            },
	            formatMessage({ id: 'common.pending' })
	          ),
	          isProvider ? _react2.default.createElement(
	            'div',
	            { styleName: 'options', onClick: function onClick(e) {
	                return onOpen(e, item);
	              } },
	            _react2.default.createElement(_Icon2.default, {
	              name: 'more',
	              size: 12,
	              style: { fill: _styles.COLORS.cloudyBlue }
	            })
	          ) : null
	        )
	      );
	    })
	  );
	};
	
	FamilyCircle.propTypes = {
	  relatedPatientId: _propTypes2.default.number,
	  type: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  list: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  isProvider: _propTypes2.default.bool,
	  onInvite: _propTypes2.default.func,
	  onOpen: _propTypes2.default.func,
	  hideHeader: _propTypes2.default.bool,
	  hasFixedHeight: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(FamilyCircle, _style2.default, { allowMultiple: true });

/***/ }),
/* 3125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(23);
	
	var _circleOfCare = __webpack_require__(815);
	
	var _selectors2 = __webpack_require__(56);
	
	var _withPopoverMenu = __webpack_require__(501);
	
	var _withPopoverMenu2 = _interopRequireDefault(_withPopoverMenu);
	
	var _transformDataErrors = __webpack_require__(3133);
	
	var _transformDataErrors2 = _interopRequireDefault(_transformDataErrors);
	
	var _circleOfCare2 = __webpack_require__(4005);
	
	var _circleOfCare3 = _interopRequireDefault(_circleOfCare2);
	
	var _inviteToFamilyCircle = __webpack_require__(412);
	
	var _changeMemberRoleReq = __webpack_require__(817);
	
	var _leaveFamilyCircle = __webpack_require__(298);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _actions = __webpack_require__(1255);
	
	var _selectors3 = __webpack_require__(237);
	
	var _injectSaga = __webpack_require__(116);
	
	var _injectSaga2 = _interopRequireDefault(_injectSaga);
	
	var _reqInvitePatient = __webpack_require__(508);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    targetUser: (0, _selectors.targetUserSelector)(state),
	    targetUserId: (0, _selectors.targetUserIdSelector)(state),
	    familyCircle: (0, _circleOfCare.familyCircleSelector)(state),
	    loadingCircle: (0, _circleOfCare.sendingReqCircleOfCareSelector)(state),
	    isProvider: (0, _selectors2.selectIsAccessLeverProvider)(state),
	    inviteToFamilyCircleErrors: (0, _selectors3.selectErrorInviteToFamilyCircle)(state),
	    circleLoading: (0, _selectors3.selectCircleLoadingState)(state),
	    succeedFamilyCircleReq: (0, _selectors3.selectSucceedFamilyCircleReq)(state),
	    rejectedFamilyCircleReq: (0, _selectors3.selectRejectedFamilyCircleReq)(state),
	    pendingFamilyMembers: (0, _circleOfCare.selectPendingFamilyMembers)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  inviteFamilyMember: _actions.circleActions.inviteToFamilyCircle,
	  changeRole: _actions.circleActions.changeRole,
	  removeFamilyMember: _actions.circleActions.removeMember,
	  clearInviteToFamilyCircle: _inviteToFamilyCircle.actions.clear,
	  clearLeaveFamilyCircle: _leaveFamilyCircle.actions.clear,
	  clearChangeMemberRole: _changeMemberRoleReq.actions.clear,
	  clearPatientInviteReq: _reqInvitePatient.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _injectSaga2.default)({
	  key: 'circleOfCareSaga',
	  saga: _circleOfCare3.default,
	  mode: _sagaInjectors.RESTART_ON_REMOUNT
	}), _withPopoverMenu2.default, _reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var inviteToFamilyCircleErrors = _ref.inviteToFamilyCircleErrors,
	      succeedFamilyCircleReq = _ref.succeedFamilyCircleReq,
	      rejectedFamilyCircleReq = _ref.rejectedFamilyCircleReq,
	      clearInviteToFamilyCircle = _ref.clearInviteToFamilyCircle,
	      clearLeaveFamilyCircle = _ref.clearLeaveFamilyCircle,
	      clearChangeMemberRole = _ref.clearChangeMemberRole,
	      invitePatientSucceed = _ref.invitePatientSucceed,
	      clearPatientInviteReq = _ref.clearPatientInviteReq;
	
	  // in case if we have already assigned an error code, we show error popup
	  // other errors handle form validation
	  var inviteMemberErrors = (0, _transformDataErrors2.default)(inviteToFamilyCircleErrors);
	  return {
	    shouldClear: succeedFamilyCircleReq || invitePatientSucceed || rejectedFamilyCircleReq && !inviteMemberErrors,
	    inviteMemberErrors: inviteMemberErrors,
	    clearRequests: function clearRequests() {
	      clearInviteToFamilyCircle();
	      clearLeaveFamilyCircle();
	      clearChangeMemberRole();
	      clearPatientInviteReq();
	    }
	  };
	}));

/***/ }),
/* 3126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _UserCard = __webpack_require__(1714);
	
	var _UserCard2 = _interopRequireDefault(_UserCard);
	
	var _strings = __webpack_require__(15);
	
	var _chat = __webpack_require__(67);
	
	var _style = __webpack_require__(954);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRole = function getRole(rawRole) {
	  var isMainCareProvider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var caregiver = arguments[2];
	  var formatMessage = arguments[3];
	
	  var defaultProviderRole = isMainCareProvider ? _strings.MAIN_CARE_PROVIDER : _strings.MEMBER_PROVIDER_CIRCLE;
	  var role = rawRole;
	
	  if (role) return role;
	
	  if (defaultProviderRole) return formatMessage(defaultProviderRole);
	
	  return '';
	};
	
	var getNote = function getNote(provider, isTeamMember, formatMessage) {
	  var note = (0, _get2.default)(provider, 'primaryProviderProfile.role') || formatMessage(_strings.CARE_PROVIDER);
	  var organization = (0, _get2.default)(provider, 'organizationName');
	
	  if (isTeamMember) return organization;
	
	  return organization ? note + ', ' + organization : note;
	};
	
	var ProviderCircle = function ProviderCircle(_ref) {
	  var type = _ref.type,
	      title = _ref.title,
	      careProviders = _ref.careProviders,
	      relatedPatientId = _ref.relatedPatientId,
	      mainCareProviderIndex = _ref.mainCareProviderIndex,
	      formatMessage = _ref.intl.formatMessage;
	  return (0, _size2.default)(careProviders) > 0 && _react2.default.createElement(
	    'div',
	    { styleName: 'circle' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'provider-label' },
	      _react2.default.createElement(
	        'span',
	        { styleName: 'label' },
	        title
	      )
	    ),
	    careProviders.map(function (provider) {
	      var isTeamMember = (0, _get2.default)(provider, 'teamActingUser', false);
	      var list = (0, _get2.default)(provider, 'providerCircle', []);
	      var note = getNote(provider, isTeamMember, formatMessage);
	
	      return _react2.default.createElement(
	        'div',
	        { key: provider.id, styleName: 'provider' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'provider-header' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'user' },
	            _react2.default.createElement(_UserCard2.default, {
	              className: 'ph3 pv2 fw6',
	              user: provider,
	              note: note,
	              size: 40,
	              linkType: type,
	              relatedPatientId: relatedPatientId,
	              additionalIcons: isTeamMember ? [_chat.TEAM_ICON] : null
	            })
	          )
	        ),
	        (0, _size2.default)(list) > 0 && _react2.default.createElement(
	          'ul',
	          { styleName: 'provider-row' },
	          _react2.default.createElement('div', { styleName: 'vl' }),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'provider-column' },
	            list.map(function (item, i) {
	              var role = getRole(item.role, i === mainCareProviderIndex, item.caregiver, formatMessage);
	              var providerOrganization = (0, _get2.default)(item, 'organizationName');
	
	              return _react2.default.createElement(_UserCard2.default, {
	                linkType: type,
	                relatedPatientId: relatedPatientId,
	                key: item.id,
	                className: 'ph3 pv2 fw6',
	                user: item,
	                note: providerOrganization ? role + ', ' + providerOrganization : role,
	                size: 40
	              });
	            })
	          )
	        )
	      );
	    })
	  );
	};
	
	ProviderCircle.propTypes = {
	  title: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  careProviders: _propTypes2.default.array,
	  relatedPatientId: _propTypes2.default.number,
	  onOpen: _propTypes2.default.func,
	  mainCareProviderIndex: _propTypes2.default.number,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(ProviderCircle, _style2.default, { allowMultiple: true }));

/***/ }),
/* 3127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(23);
	
	var _circleOfCare = __webpack_require__(815);
	
	var _selectors2 = __webpack_require__(56);
	
	var _withPopoverMenu = __webpack_require__(501);
	
	var _withPopoverMenu2 = _interopRequireDefault(_withPopoverMenu);
	
	var _context = __webpack_require__(216);
	
	var _reqCircleOfCare = __webpack_require__(404);
	
	var _getUser = __webpack_require__(202);
	
	var _reqAssignProvider = __webpack_require__(639);
	
	var _removeAssignedProvider = __webpack_require__(515);
	
	var _getAccessLevels = __webpack_require__(426);
	
	var _contextbar = __webpack_require__(695);
	
	var _reqRelationshipPriority = __webpack_require__(814);
	
	var _style = __webpack_require__(954);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profileData: (0, _selectors.targetUserSelector)(state),
	    targetUserId: (0, _selectors.targetUserIdSelector)(state),
	    genderList: state.data.processedConsts.genderTypes,
	    careProviders: (0, _circleOfCare.careProvidersSelector)(state),
	    isLoggedUser: (0, _selectors.isLoggedUserSelector)(state),
	    loadingProfile: (0, _selectors2.sendingSelector)(state),
	    loadingCircle: (0, _circleOfCare.sendingReqCircleOfCareSelector)(state),
	    canAssignProvider: (0, _selectors2.canAssignProviderSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  setTargetUserId: _context.actions.setTargetUserId,
	  getCircleOfCare: _reqCircleOfCare.actions.send,
	  getUser: _getUser.actions.send,
	  assignProvider: _reqAssignProvider.actions.send,
	  removeAssignedProvider: _removeAssignedProvider.actions.send,
	  getAccessLevels: _getAccessLevels.actions.send,
	  toggleContextVisibility: _contextbar.actions.toggleVisibility,
	  getRelationshipPriority: _reqRelationshipPriority.actions.send,
	  clearRelationshipPriority: _reqRelationshipPriority.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_withPopoverMenu2.default, _reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }));

/***/ }),
/* 3128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _ContextProfile = __webpack_require__(3123);
	
	var _ContextProfile2 = _interopRequireDefault(_ContextProfile);
	
	var _ProviderCircle = __webpack_require__(3126);
	
	var _ProviderCircle2 = _interopRequireDefault(_ProviderCircle);
	
	var _SearchDialogWithForm = __webpack_require__(3877);
	
	var _SearchDialogWithForm2 = _interopRequireDefault(_SearchDialogWithForm);
	
	var _MobileNavbar = __webpack_require__(256);
	
	var _MobileNavbar2 = _interopRequireDefault(_MobileNavbar);
	
	var _PopoverMenu = __webpack_require__(398);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _routes = __webpack_require__(37);
	
	var _styles = __webpack_require__(18);
	
	var _props3 = __webpack_require__(41);
	
	var _FamilyCircleWrapper = __webpack_require__(1719);
	
	var _FamilyCircleWrapper2 = _interopRequireDefault(_FamilyCircleWrapper);
	
	var _enhance = __webpack_require__(3127);
	
	var _gtag = __webpack_require__(182);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobileNavigation = function MobileNavigation(_ref) {
	  var title = _ref.title,
	      isHandleBack = _ref.isHandleBack;
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { maxWidth: _styles.BREAKPOINT },
	    _react2.default.createElement(
	      _MobileNavbar2.default,
	      { openContext: 'arrow-down', toggleContext: isHandleBack },
	      _react2.default.createElement('p', { children: title })
	    )
	  );
	};
	
	MobileNavigation.propTypes = {
	  title: _propTypes2.default.string,
	  isHandleBack: _propTypes2.default.func
	};
	
	var CircleOfCare = function (_Component) {
	  (0, _inherits3.default)(CircleOfCare, _Component);
	
	  function CircleOfCare() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CircleOfCare);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = CircleOfCare.__proto__ || (0, _getPrototypeOf2.default)(CircleOfCare)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      isAssignProviderOpen: false,
	      isPopoverOpen: false,
	      expanded: false,
	      anchorEl: null
	    }, _this.handleBack = function () {
	      _reactRouter.browserHistory.push('/' + _routes.MESSAGES);
	      setTimeout(function () {
	        _this.toggleContext();
	      }, 1000);
	    }, _this.handleClearState = function () {
	      _this.setState({
	        isAssignProviderOpen: false,
	        isPopoverOpen: false
	      });
	    }, _this.toggleContext = function () {
	      if (_this.state.expanded) return;
	      _this.props.toggleContextVisibility();
	    }, _this.handleOpenAssignProvider = function () {
	      _this.setState(function (prevState) {
	        return {
	          isAssignProviderOpen: !prevState.isAssignProviderOpen
	        };
	      });
	    }, _this.handleAssignProvider = function (selectedIds, selectedOption, reasonCode, relation) {
	      var _this$props = _this.props,
	          targetUserId = _this$props.targetUserId,
	          assignProvider = _this$props.assignProvider;
	
	
	      assignProvider({
	        ids: selectedIds,
	        userId: targetUserId,
	        assignment_status: selectedOption,
	        reason_code: reasonCode,
	        relationship_priority_id: relation
	      });
	    }, _this.handleRemoveProvider = function () {
	      var _this$props2 = _this.props,
	          removeAssignedProvider = _this$props2.removeAssignedProvider,
	          targetUserId = _this$props2.targetUserId;
	      var user = _this.state.user;
	
	
	      removeAssignedProvider({
	        providerId: (0, _get2.default)(user, 'primaryProviderProfile.id'),
	        userId: targetUserId
	      });
	
	      _this.handleClearState();
	    }, _this.handleOpenPopover = function (e, user) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      var isPopoverOpen = _this.state.isPopoverOpen;
	
	
	      _this.setState({
	        anchorEl: e.currentTarget,
	        isPopoverOpen: !isPopoverOpen,
	        user: user
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CircleOfCare, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _gtag.GATrackPageView)('Circle of Care');
	
	      var _props = this.props,
	          getAccessLevels = _props.getAccessLevels,
	          getRelationshipPriority = _props.getRelationshipPriority,
	          setTargetUserId = _props.setTargetUserId,
	          getCircleOfCare = _props.getCircleOfCare,
	          targetUserId = _props.targetUserId,
	          id = _props.params.id;
	
	      var userId = Number(id);
	
	      getCircleOfCare({ id: userId });
	      getAccessLevels({ id: userId });
	      getRelationshipPriority();
	
	      if (userId !== targetUserId) {
	        setTargetUserId({ id: userId });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var clearRelationshipPriority = this.props.clearRelationshipPriority;
	
	      clearRelationshipPriority();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          isLoggedUser = _props2.isLoggedUser,
	          targetUserId = _props2.targetUserId,
	          genderList = _props2.genderList,
	          profileData = _props2.profileData,
	          careProviders = _props2.careProviders,
	          loadingProfile = _props2.loadingProfile,
	          loadingCircle = _props2.loadingCircle,
	          canAssignProvider = _props2.canAssignProvider,
	          formatMessage = _props2.intl.formatMessage,
	          routes = _props2.routes;
	      var _state = this.state,
	          isPopoverOpen = _state.isPopoverOpen,
	          anchorEl = _state.anchorEl,
	          isAssignProviderOpen = _state.isAssignProviderOpen;
	
	
	      var restrictionPath = isLoggedUser ? 'patient' : 'patient-view';
	      var profileLink = '/profile/' + profileData.id + '/' + restrictionPath;
	      var isProfile = (0, _get2.default)(routes, '[1].path') === 'profile';
	      var rootClassName = !isProfile ? 'g-content' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: rootClassName, styleName: 'root' },
	        _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.circleOfCare' }),
	        !isProfile ? [_react2.default.createElement(
	          _reactResponsive2.default,
	          { maxWidth: _styles.BREAKPOINT, key: '0'
	          },
	          _react2.default.createElement(MobileNavigation, {
	            title: formatMessage({ id: 'circles.circleOfCare' }),
	            isHandleBack: this.handleBack
	          })
	        ), _react2.default.createElement(
	          'div',
	          { styleName: 'header', key: '1'
	          },
	          _react2.default.createElement(
	            _reactResponsive2.default,
	            { minWidth: _styles.BREAKPOINT },
	            _react2.default.createElement(_BackButton2.default, { onBack: this.handleBack })
	          )
	        )] : null,
	        targetUserId && _react2.default.createElement(_SearchDialogWithForm2.default, {
	          type: 'context_provider',
	          isOpen: isAssignProviderOpen,
	          contextUserId: targetUserId,
	          title: formatMessage(_strings.DIALOG_TITLE.assignProviderOrTeamToPatient),
	          buttonTitle: formatMessage(_strings.DIALOG_TITLE.assign),
	          defaultState: formatMessage(_strings.DIALOG_TITLE.defaultProviderAssign),
	          emptyState: formatMessage(_strings.NEW_CHAT.noOneFound),
	          searchPlaceholder: formatMessage(_strings.DIALOG_TITLE.searchProvider),
	          onClose: this.handleOpenAssignProvider,
	          onCreate: this.handleAssignProvider,
	          withTabs: [_props3.SEARCH_TABS.PEOPLE, _props3.SEARCH_TABS.TEAMS]
	        }),
	        loadingProfile || loadingCircle ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(
	          'div',
	          { styleName: 'content' },
	          isPopoverOpen ? _react2.default.createElement(_PopoverMenu2.default, {
	            size: 'small',
	            isOpen: true,
	            anchorEl: anchorEl,
	            items: this.circleMenuItems,
	            onClose: this.handleClearState
	          }) : null,
	          !isProfile ? _react2.default.createElement(_ContextProfile2.default, (0, _extends3.default)({ formatMessage: formatMessage }, { profileLink: profileLink }, {
	            profileData: profileData,
	            genderList: genderList
	          })) : null,
	          _react2.default.createElement(_FamilyCircleWrapper2.default, null),
	          _react2.default.createElement(_ProviderCircle2.default, (0, _extends3.default)({ canAssignProvider: canAssignProvider }, {
	            onOpen: this.handleOpenPopover,
	            onAssignProvider: this.handleOpenAssignProvider,
	            mainCareProviderIndex: -1
	          }, { careProviders: careProviders }, {
	            title: formatMessage(_strings.CHAT.titles.providersChatTab),
	            type: 'provider',
	            relatedPatientId: targetUserId
	          }))
	        )
	      );
	    }
	  }, {
	    key: 'circleMenuItems',
	    get: function get() {
	      var getMenuItems = this.props.getMenuItems;
	
	
	      var providerCircleMenuItems = (0, _defineProperty3.default)({}, _constants.POPOVER_MENU_ITEMS.UNASSIGN, this.handleRemoveProvider);
	
	      return getMenuItems(providerCircleMenuItems);
	    }
	  }]);
	  return CircleOfCare;
	}(_react.Component);
	
	CircleOfCare.propTypes = {
	  isLoggedUser: _propTypes2.default.bool,
	  loadingProfile: _propTypes2.default.bool,
	  loadingCircle: _propTypes2.default.bool,
	  targetUserId: _propTypes2.default.number,
	  genderList: _propTypes2.default.array,
	  profileData: _propTypes2.default.object,
	  getCircleOfCare: _propTypes2.default.func,
	  getUser: _propTypes2.default.func,
	  careProviders: _propTypes2.default.array,
	  removeAssignedProvider: _propTypes2.default.func,
	  canAssignProvider: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  routes: _propTypes2.default.array,
	  params: _propTypes2.default.object,
	  getAccessLevels: _propTypes2.default.func,
	  getRelationshipPriority: _propTypes2.default.func,
	  clearRelationshipPriority: _propTypes2.default.func,
	  setTargetUserId: _propTypes2.default.func,
	  assignProvider: _propTypes2.default.func,
	  getMenuItems: _propTypes2.default.func,
	  toggleContextVisibility: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(CircleOfCare);

/***/ }),
/* 3129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCaregiver = exports.isGuardianProxyPatent = undefined;
	
	var _includes = __webpack_require__(324);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isGuardianProxyPatent = exports.isGuardianProxyPatent = function isGuardianProxyPatent(role) {
	  return (0, _includes2.default)([_props.CARE_ROLE.GUARDIAN, _props.CARE_ROLE.PARENT, _props.CARE_ROLE.PROXY], role);
	};
	
	var isCaregiver = exports.isCaregiver = function isCaregiver(role) {
	  return _props.CARE_ROLE.CAREGIVER === role;
	};

/***/ }),
/* 3130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _formFields = __webpack_require__(38);
	
	var _constants = __webpack_require__(17);
	
	var _handleRolesOptions = __webpack_require__(3132);
	
	var _handleRolesOptions2 = _interopRequireDefault(_handleRolesOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROLE = _formFields.PROFILE_FIELDS_TYPES.ROLE,
	    RELATIONSHIP = _formFields.PROFILE_FIELDS_TYPES.RELATIONSHIP,
	    EMAIL_OR_PHONE = _formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE,
	    PHONE_NUMBER = _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER,
	    EMAIL = _formFields.PROFILE_FIELDS_TYPES.EMAIL;
	
	var CHANGE_ROLE_POPUP_FIELDS = [ROLE];
	var INVITE_ROLE_POPUP_FIELDS = [ROLE, RELATIONSHIP, EMAIL_OR_PHONE];
	var INVITE_PATIENT_POPUP_FIELDS = [ROLE, PHONE_NUMBER, EMAIL];
	
	exports.default = function (handlers, actionType, user, formatMessage, additionalParams) {
	  var patientInvite = additionalParams.patientInvite,
	      usePatientFields = additionalParams.usePatientFields;
	
	
	  if (patientInvite) {
	    var handler = usePatientFields ? _constants.POPOVER_MENU_ITEMS.INVITE_PATIENT : _constants.POPOVER_MENU_ITEMS.INVITE_MEMBER;
	    var fields = usePatientFields ? INVITE_PATIENT_POPUP_FIELDS : INVITE_ROLE_POPUP_FIELDS;
	
	    return {
	      title: formatMessage({ id: 'dialog.common.invitePerson' }),
	      submitBtnText: formatMessage({ id: 'common.invite' }),
	      description: formatMessage({
	        id: 'circles.invites.invitePerson'
	      }),
	      fields: fields,
	      onSubmit: handlers[handler],
	      validateFields: usePatientFields ? [ROLE] : fields
	    };
	  }
	
	  if (actionType === _constants.POPOVER_MENU_ITEMS.CHANGE_ROLE) {
	    return {
	      title: formatMessage({ id: 'common.changeRole' }),
	      description: formatMessage({
	        id: 'circles.invites.makeChangeRoleDescription'
	      }),
	      initialData: user,
	      fields: CHANGE_ROLE_POPUP_FIELDS,
	      onSubmit: handlers[_constants.POPOVER_MENU_ITEMS.CHANGE_ROLE],
	      handleFieldOptions: (0, _defineProperty3.default)({}, _formFields.PROFILE_FIELDS_TYPES.ROLE, _handleRolesOptions2.default)
	    };
	  }
	
	  return {
	    title: formatMessage({ id: 'circles.actions.inviteFamily' }),
	    submitBtnText: formatMessage({ id: 'common.invite' }),
	    description: formatMessage({
	      id: 'circles.invites.makeInviteToFamilyCommon'
	    }),
	    fields: INVITE_ROLE_POPUP_FIELDS,
	    onSubmit: handlers[_constants.POPOVER_MENU_ITEMS.INVITE_MEMBER]
	  };
	};

/***/ }),
/* 3131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUser = getUser;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _resolveFamilyMemberOption = __webpack_require__(906);
	
	var _resolveFamilyMemberOption2 = _interopRequireDefault(_resolveFamilyMemberOption);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRole = function getRole(member, formatMessage) {
	  var careRole = (0, _get2.default)(member, 'careRole');
	  var additionalRole = careRole ? formatMessage({ id: 'circles.roles.' + careRole }) : null;
	  var role = (0, _resolveFamilyMemberOption2.default)(member, formatMessage, additionalRole);
	
	  return role || '';
	};
	
	function getUser(member, formatMessage) {
	  var login = member.login,
	      memberName = member.displayableName,
	      memberAvatar = member.avatar,
	      memberId = member.id,
	      user = member.user,
	      invitationId = member.invitationId;
	
	  var _ref = user || {},
	      userName = _ref.displayableName,
	      userAvatar = _ref.avatar,
	      userId = _ref.id;
	
	  var name = memberName || userName;
	  var displayableName = name || login;
	  var avatar = memberAvatar || userAvatar;
	  var id = memberId || userId || invitationId;
	  var role = getRole(member, formatMessage);
	
	  return {
	    role: role,
	    user: {
	      displayableName: displayableName,
	      avatar: avatar,
	      id: id
	    }
	  };
	}

/***/ }),
/* 3132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pick = __webpack_require__(466);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _pickBy = __webpack_require__(984);
	
	var _pickBy2 = _interopRequireDefault(_pickBy);
	
	var _includes = __webpack_require__(324);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _keys = __webpack_require__(249);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _filter = __webpack_require__(978);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PICKED_ROLES = [_props.CARE_ROLE.GUARDIAN, _props.CARE_ROLE.CAREGIVER, _props.CARE_ROLE.PROXY, _props.CARE_ROLE.PARENT];
	
	exports.default = function (options, initialData) {
	  var selectedRoles = (0, _pick2.default)(initialData, PICKED_ROLES);
	  var selectedPositive = (0, _pickBy2.default)(selectedRoles, function (item) {
	    return item === true;
	  });
	  var selectedKeys = (0, _keys2.default)(selectedPositive);
	  var filteredOptions = (0, _filter2.default)(options, function (item) {
	    return !(0, _includes2.default)(selectedKeys, item.value);
	  });
	
	  if (!(0, _size2.default)(selectedKeys)) {
	    return (0, _filter2.default)(filteredOptions, function (item) {
	      return item.value !== _props.CARE_ROLE.FAMILY_MEMBER;
	    });
	  }
	
	  return filteredOptions;
	};

/***/ }),
/* 3133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set2 = __webpack_require__(1561);
	
	var _set3 = _interopRequireDefault(_set2);
	
	var _formFields = __webpack_require__(38);
	
	var _errors = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (error) {
	  if (!error || (0, _get2.default)(error, 'meta.validationErrors.login[0].code') === _errors.ERROR_CODES.ALREADY_ASSIGNED) {
	    return null;
	  }
	
	  return (0, _set3.default)((0, _extends3.default)({}, error), 'meta.validationErrors', (0, _defineProperty3.default)({}, _formFields.PROFILE_FIELDS_TYPES.EMAIL_OR_PHONE, (0, _get2.default)(error, 'description')));
	};

/***/ }),
/* 3134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useFamilyCircle = useFamilyCircle;
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  user: {},
	  anchorEl: null,
	  actionType: null,
	  isModalOpen: false,
	  isPopoverOpen: false,
	  isSimpleFormOpen: false,
	  isCancelPopupOpen: false
	};
	
	function useFamilyCircle(_ref) {
	  var getMenuItems = _ref.getMenuItems,
	      createdUser = _ref.createdUser,
	      clearRequests = _ref.clearRequests,
	      handleTargetUserInvite = _ref.handleTargetUserInvite;
	
	  var _useState = (0, _react.useState)(initialState),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      circleState = _useState2[0],
	      setCircleState = _useState2[1];
	
	  var user = circleState.user,
	      isPopoverOpen = circleState.isPopoverOpen;
	
	
	  var handleOpenInvite = function handleOpenInvite() {
	    handleTargetUserInvite();
	    setCircleState((0, _extends3.default)({}, circleState, {
	      isPopoverOpen: false
	    }));
	  };
	
	  var handleOpenChangeRole = function handleOpenChangeRole() {
	    setCircleState((0, _extends3.default)({}, circleState, {
	      isSimpleFormOpen: true,
	      actionType: _constants.POPOVER_MENU_ITEMS.CHANGE_ROLE,
	      isPopoverOpen: false
	    }));
	  };
	
	  var handleOpenRemoveMember = function handleOpenRemoveMember() {
	    setCircleState((0, _extends3.default)({}, circleState, {
	      isModalOpen: true,
	      actionType: _constants.POPOVER_MENU_ITEMS.REMOVE_MEMBER,
	      isPopoverOpen: false
	    }));
	  };
	
	  var handleOpenCancelInvitation = function handleOpenCancelInvitation() {
	    setCircleState((0, _extends3.default)({}, circleState, {
	      isCancelPopupOpen: true,
	      actionType: _constants.POPOVER_MENU_ITEMS.CANCEL_PENDING_INVITATION,
	      isPopoverOpen: false
	    }));
	  };
	
	  var getItems = (0, _react.useMemo)(function () {
	    var _familyMemberCircleMe;
	
	    var pending = user.pending,
	        isTargetUser = user.isTargetUser;
	
	
	    if (isTargetUser) {
	      var targetUserItems = createdUser ? _constants.POPOVER_MENU_ITEMS.INVITE_PATIENT : _constants.POPOVER_MENU_ITEMS.REINVITE_PATIENT;
	
	      return getMenuItems((0, _defineProperty3.default)({}, targetUserItems, handleOpenInvite));
	    }
	
	    var familyMemberCircleMenuItems = (_familyMemberCircleMe = {}, (0, _defineProperty3.default)(_familyMemberCircleMe, _constants.POPOVER_MENU_ITEMS.CHANGE_ROLE, handleOpenChangeRole), (0, _defineProperty3.default)(_familyMemberCircleMe, _constants.POPOVER_MENU_ITEMS.REMOVE_MEMBER, handleOpenRemoveMember), _familyMemberCircleMe);
	
	    var pendingFamilyMemberCircleMenuItems = (0, _defineProperty3.default)({}, _constants.POPOVER_MENU_ITEMS.CANCEL_PENDING_INVITATION, handleOpenCancelInvitation);
	
	    var familyCircleItems = pending ? pendingFamilyMemberCircleMenuItems : familyMemberCircleMenuItems;
	
	    return getMenuItems(familyCircleItems);
	  }, [user, createdUser, handleOpenInvite, handleOpenChangeRole, handleOpenRemoveMember, handleOpenCancelInvitation]);
	
	  var handleClearState = function handleClearState() {
	    clearRequests();
	
	    setCircleState(initialState);
	  };
	
	  var handleOpenPopover = function handleOpenPopover(e, member) {
	    e.preventDefault();
	    e.stopPropagation();
	
	    setCircleState((0, _extends3.default)({}, circleState, {
	      anchorEl: e.currentTarget,
	      isPopoverOpen: !isPopoverOpen,
	      user: member
	    }));
	  };
	
	  var handleOpenSimpleFormPopup = function handleOpenSimpleFormPopup() {
	    return setCircleState((0, _extends3.default)({}, circleState, { isSimpleFormOpen: true }));
	  };
	
	  return {
	    getItems: getItems,
	    circleState: circleState,
	    handleClearState: handleClearState,
	    handleOpenPopover: handleOpenPopover,
	    handleOpenSimpleFormPopup: handleOpenSimpleFormPopup
	  };
	}

/***/ }),
/* 3135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useSimpleForm = useSimpleForm;
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _formFields = __webpack_require__(38);
	
	var _props = __webpack_require__(41);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useSimpleForm(_ref) {
	  var memberId = _ref.memberId,
	      targetUser = _ref.targetUser,
	      changeRole = _ref.changeRole,
	      sendPatientInvite = _ref.sendPatientInvite,
	      inviteFamilyMember = _ref.inviteFamilyMember;
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      simpleFormFields = _useState2[0],
	      setFormFields = _useState2[1];
	
	  var role = (0, _get2.default)(simpleFormFields, 'role');
	  var useCustomFields = (0, _react.useMemo)(function () {
	    return role === _props.PATIENT;
	  }, [role]);
	  var email = targetUser.email,
	      phoneNumber = targetUser.phoneNumber,
	      id = targetUser.id;
	
	
	  var simpleFormInitState = (0, _react.useMemo)(function () {
	    var _ref2;
	
	    return useCustomFields ? (_ref2 = {}, (0, _defineProperty3.default)(_ref2, _formFields.PROFILE_FIELDS_TYPES.ROLE, _props.PATIENT), (0, _defineProperty3.default)(_ref2, _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER, phoneNumber), (0, _defineProperty3.default)(_ref2, _formFields.PROFILE_FIELDS_TYPES.EMAIL, email), _ref2) : (0, _defineProperty3.default)({}, _formFields.PROFILE_FIELDS_TYPES.ROLE, role);
	  }, [useCustomFields]);
	
	  var handleActions = function handleActions(type, formState) {
	    if (type === _constants.POPOVER_MENU_ITEMS.CHANGE_ROLE) {
	      changeRole((0, _extends3.default)({ memberId: memberId }, formState));
	    }
	    if (type === _constants.POPOVER_MENU_ITEMS.INVITE_MEMBER) {
	      inviteFamilyMember(formState);
	    }
	    if (type === _constants.POPOVER_MENU_ITEMS.INVITE_PATIENT) {
	      sendPatientInvite((0, _extends3.default)({}, formState, { userId: id }));
	    }
	  };
	
	  var simpleFormHandlers = function simpleFormHandlers() {
	    var _ref4;
	
	    return _ref4 = {}, (0, _defineProperty3.default)(_ref4, _constants.POPOVER_MENU_ITEMS.CHANGE_ROLE, function (formState) {
	      return handleActions(_constants.POPOVER_MENU_ITEMS.CHANGE_ROLE, formState);
	    }), (0, _defineProperty3.default)(_ref4, _constants.POPOVER_MENU_ITEMS.INVITE_MEMBER, function (formState) {
	      return handleActions(_constants.POPOVER_MENU_ITEMS.INVITE_MEMBER, formState);
	    }), (0, _defineProperty3.default)(_ref4, _constants.POPOVER_MENU_ITEMS.INVITE_PATIENT, function (formState) {
	      return handleActions(_constants.POPOVER_MENU_ITEMS.INVITE_PATIENT, formState);
	    }), _ref4;
	  };
	  return {
	    setFormFields: setFormFields,
	    useCustomFields: useCustomFields,
	    simpleFormHandlers: simpleFormHandlers,
	    simpleFormInitState: simpleFormInitState
	  };
	}

/***/ }),
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable react/require-default-props,react/destructuring-assignment,react/button-has-type */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _index = __webpack_require__(1727);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(1486);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var Replies = (_dec = (0, _reactCssModules2.default)(_index4.default, { allowMultiple: true }), _dec(_class = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(Replies, _PureComponent);
	
	  function Replies() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Replies);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Replies.__proto__ || (0, _getPrototypeOf2.default)(Replies)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      collapsed: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Replies, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        collapsed: this.props.list.length > 2
	      });
	    }
	  }, {
	    key: 'handleExpand',
	    value: function handleExpand(e) {
	      e.preventDefault();
	      this.setState({ collapsed: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          commentAuthor = _props.commentAuthor,
	          list = _props.list,
	          getCommentDeleteHandler = _props.getCommentDeleteHandler,
	          getCommentEditHandler = _props.getCommentEditHandler,
	          parentId = _props.parentId,
	          onRequestConversation = _props.onRequestConversation,
	          canComment = _props.canComment,
	          loggedUserId = _props.loggedUserId;
	      var collapsed = this.state.collapsed;
	
	      var visibleList = collapsed ? list.slice(-2) : list;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        collapsed ? _react2.default.createElement(
	          'button',
	          { styleName: 'previousLink', onClick: this.handleExpand },
	          'Show previous'
	        ) : null,
	        _react2.default.createElement(
	          'ul',
	          { styleName: 'replies' },
	          visibleList && visibleList.map(function (reply) {
	            return _react2.default.createElement(
	              'li',
	              { key: reply.id },
	              _react2.default.createElement(_index2.default, (0, _extends3.default)({}, (0, _omit2.default)(reply, ['comments']), {
	                getCommentDeleteHandler: getCommentDeleteHandler,
	                getCommentEditHandler: getCommentEditHandler,
	                parentId: parentId,
	                replyTo: commentAuthor,
	                onRequestConversation: onRequestConversation,
	                canComment: canComment,
	                loggedUserId: loggedUserId
	              }))
	            );
	          })
	        )
	      );
	    }
	  }]);
	  return Replies;
	}(_react.PureComponent), _class3.propTypes = {
	  commentAuthor: _propTypes2.default.string,
	  list: _propTypes2.default.array, // todo,
	  getCommentDeleteHandler: _propTypes2.default.func,
	  getCommentEditHandler: _propTypes2.default.func,
	  parentId: _propTypes2.default.number,
	  onRequestConversation: _propTypes2.default.func,
	  canComment: _propTypes2.default.bool,
	  loggedUserId: _propTypes2.default.number
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleExpand', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleExpand'), _class2.prototype)), _class2)) || _class);
	exports.default = Replies;

/***/ }),
/* 3151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable react/require-default-props,react/destructuring-assignment,consistent-return */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _strings = __webpack_require__(15);
	
	var _styles = __webpack_require__(18);
	
	var _sanitizeHtml = __webpack_require__(313);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _convertXMLtoString = __webpack_require__(1914);
	
	var _convertXMLtoString2 = _interopRequireDefault(_convertXMLtoString);
	
	var _prettifyText = __webpack_require__(1932);
	
	var _prettifyText2 = _interopRequireDefault(_prettifyText);
	
	var _ids = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var REPLY_LIMIT_SIZE = 500;
	
	var Reply = (0, _reactIntl.injectIntl)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
	  (0, _inherits3.default)(Reply, _Component);
	
	  function Reply() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Reply);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Reply.__proto__ || (0, _getPrototypeOf2.default)(Reply)).call.apply(_ref, [this].concat(args))), _this), _this.textarea = null, _this.state = {
	      content: ''
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Reply, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var content = this.props.initialContent;
	
	      var contentText = content && (0, _prettifyText2.default)(content);
	      if (content) {
	        this.setState({ content: (0, _convertXMLtoString2.default)(contentText) });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Handling Ctrl+Enter event to put a line-break into the textarea
	      this.textarea.node.addEventListener('keydown', this.handleKeyboardSubmit);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.textarea.node.removeEventListener('keydown', this.handleKeyboardSubmit);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	
	      var content = this.state.content;
	
	
	      this.props.onSubmit((0, _sanitizeHtml2.default)(content, true, []));
	    }
	  }, {
	    key: 'handleKeyboardSubmit',
	    value: function handleKeyboardSubmit(e) {
	      var enterKey = e.keyCode === 10 || e.keyCode === 13;
	      var empty = !this.state.content.trim().length;
	
	      if (enterKey && e.ctrlKey) {
	        this.setState({
	          content: this.textarea.node.value + '\n'
	        });
	      } else if (enterKey && empty) {
	        return e.preventDefault();
	      } else if (enterKey && !e.ctrlKey) {
	        this.handleSubmit(e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var value = this.state.content;
	      var formatMessage = this.props.intl.formatMessage;
	
	      var empty = !value.trim().length;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'df justify-between' },
	        _react2.default.createElement(_TextInput2.default, {
	          autoresize: true,
	          autoFocus: true,
	          textarea: true,
	          rows: '1',
	          color: 'primary',
	          limit: REPLY_LIMIT_SIZE,
	          ref: function ref(node) {
	            return _this2.textarea = node;
	          },
	          style: {
	            lineHeight: '21px',
	            height: 'auto',
	            maxHeight: 21 * 4,
	            backgroundColor: 'white',
	            border: '1px solid ' + _styles.COLORS.sanMarino
	          },
	          wrapperStyle: {
	            width: '100%',
	            marginRight: '10px'
	          },
	          value: value,
	          onChange: function onChange(content) {
	            return _this2.setState({ content: content });
	          },
	          rounded: true,
	          id: _ids.IDS.POST.REPLY_TEXT_AREA,
	          placeholder: formatMessage(_strings.POST_REPLY_PLACEHOLDER),
	          useNumberHeight: true
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            id: _ids.IDS.POST.SEND_REPLY_COMMENT_BTN,
	            color: 'primary',
	            onClick: this.handleSubmit,
	            raised: true,
	            disabled: empty,
	            style: { width: '56px', paddingLeft: 0, paddingRight: 0 }
	          },
	          _react2.default.createElement(_Icon2.default, { name: 'send-message', style: { fill: _styles.COLORS.white } })
	        )
	      );
	    }
	  }]);
	  return Reply;
	}(_react.Component), _class3.propTypes = {
	  onSubmit: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  initialContent: _propTypes2.default.string
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleSubmit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleSubmit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleKeyboardSubmit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleKeyboardSubmit'), _class2.prototype)), _class2)) || _class;
	
	exports.default = Reply;

/***/ }),
/* 3152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRedux = __webpack_require__(6);
	
	var _styles = __webpack_require__(581);
	
	var _communitiesJoinRequests = __webpack_require__(343);
	
	var _communitiesJoinRequests2 = __webpack_require__(4038);
	
	var _removeNotificationsCounters = __webpack_require__(345);
	
	var _activities = __webpack_require__(1256);
	
	var _activitiesSelector = __webpack_require__(829);
	
	var _constants = __webpack_require__(17);
	
	var _styles2 = __webpack_require__(18);
	
	var _index = __webpack_require__(374);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabStyles = {
	  root: {
	    fontFamily: _styles2.FONT_FAMILY.primary,
	    textTransform: 'initial',
	    paddingLeft: 0,
	    fontWeight: 400
	  },
	  label: {
	    fontSize: 14,
	    lineHeight: 1.5,
	    paddingLeft: 0
	  }
	};
	
	var JOIN_REQUESTS = _constants.ACTIVITY_TYPES.JOIN_REQUESTS,
	    NOTIFICATIONS = _constants.ACTIVITY_TYPES.NOTIFICATIONS,
	    MEMBER_INVITATIONS = _constants.ACTIVITY_TYPES.MEMBER_INVITATIONS;
	
	
	var mapDispatchToProps = {
	  communitiesJoinReq: _communitiesJoinRequests.actions.send,
	  loadNextRequests: _communitiesJoinRequests.paginatedActions.loadNextRequests,
	  removeNotifications: _removeNotificationsCounters.actions.send,
	  pageLeave: _communitiesJoinRequests.actions.pageLeave,
	  changeTab: _activities.activitiesActions.changeTab
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    tab: (0, _activitiesSelector.selectActivitiesActiveTab)(state),
	    list: (0, _activitiesSelector.selectActivitiesList)(state),
	    hasNotifications: (0, _activitiesSelector.selectIsActivitiesNotEmpty)(state),
	
	    sendingJoinRequests: (0, _communitiesJoinRequests2.sendingCommunitiesJoinRequestsSelector)(state),
	    joinReqCounter: (0, _activitiesSelector.selectActivityCounterByType)(JOIN_REQUESTS)(state),
	    invitesCounter: (0, _activitiesSelector.selectActivityCounterByType)(MEMBER_INVITATIONS)(state),
	    notifyCounter: (0, _activitiesSelector.selectActivityCounterByType)(NOTIFICATIONS)(state),
	    newNotifications: (0, _communitiesJoinRequests2.selectNewNotifications)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _styles.withStyles)(tabStyles), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppBar = __webpack_require__(1563);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _Tabs = __webpack_require__(1566);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Tab = __webpack_require__(992);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _index = __webpack_require__(3158);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _styles = __webpack_require__(18);
	
	var _enhance = __webpack_require__(3152);
	
	var _index3 = __webpack_require__(35);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _ids = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Activities = function Activities(_ref) {
	  var joinReqCounter = _ref.joinReqCounter,
	      invitesCounter = _ref.invitesCounter,
	      notifyCounter = _ref.notifyCounter,
	      sendingJoinRequests = _ref.sendingJoinRequests,
	      pageLeave = _ref.pageLeave,
	      communitiesJoinReq = _ref.communitiesJoinReq,
	      loadNextRequests = _ref.loadNextRequests,
	      formatMessage = _ref.intl.formatMessage,
	      classes = _ref.classes,
	      hasNotifications = _ref.hasNotifications,
	      changeTab = _ref.changeTab,
	      tab = _ref.tab,
	      list = _ref.list;
	
	  var rootRef = (0, _react.useRef)();
	  var tabs = useTabs(formatMessage, notifyCounter, joinReqCounter, invitesCounter);
	  var loadMore = (0, _react.useCallback)(function () {
	    loadNextRequests({ limit: 5, type: tab });
	  }, [tab]);
	  (0, _useLazyLoad.useLazyLoad)({ node: rootRef, loadMore: loadMore, path: ['parentNode'] });
	  (0, _react.useEffect)(function () {
	    communitiesJoinReq({ limit: 10, type: _constants.ACTIVITY_TYPES.JOIN_REQUESTS });
	    communitiesJoinReq({ limit: 10, type: _constants.ACTIVITY_TYPES.MEMBER_INVITATIONS });
	    communitiesJoinReq({ limit: 10, type: _constants.ACTIVITY_TYPES.NOTIFICATIONS });
	
	    return function () {
	      pageLeave();
	    };
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'wrapper', className: 'flex flex-column', ref: rootRef },
	    !sendingJoinRequests ? hasNotifications ? _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _AppBar2.default,
	        {
	          position: 'static',
	          color: 'default',
	          style: {
	            background: 'transparent',
	            border: 0,
	            boxShadow: 'none',
	            marginLeft: (0, _mobileHelpers.isDesktop)() && '-56px',
	            marginTop: 16
	          }
	        },
	        _react2.default.createElement(
	          _Tabs2.default,
	          {
	            indicatorColor: _styles.COLORS.bluePrimary,
	            onChange: function onChange(e, value) {
	              return changeTab(value);
	            },
	            value: tab,
	            scrollable: true
	          },
	          tabs.map(function (_ref2) {
	            var id = _ref2.id,
	                counter = _ref2.counter,
	                label = _ref2.label,
	                tabValue = _ref2.tab;
	            return !!counter ? _react2.default.createElement(_Tab2.default, {
	              label: label + ' (' + counter + ')',
	              key: id,
	              id: id,
	              value: tabValue,
	              classes: {
	                root: classes.root,
	                label: classes.label
	              }
	            }) : null;
	          })
	        )
	      ),
	      _react2.default.createElement(_index2.default, {
	        className: 'w-100 flex-grow-1',
	        list: list,
	        listType: tab
	      })
	    ) : _react2.default.createElement(
	      'div',
	      { styleName: 'empty-state' },
	      _react2.default.createElement(_Content2.default, {
	        text: formatMessage(_strings.COMMUNITIES_EMPTY_ACTIVITIES),
	        icon: 'icon-megaphone'
	      })
	    ) : _react2.default.createElement(_index4.default, null)
	  );
	}; /* eslint-disable no-use-before-define */
	
	
	Activities.propTypes = {
	  changeTab: _propTypes2.default.func.isRequired,
	  hasNotifications: _propTypes2.default.bool.isRequired,
	  tab: _propTypes2.default.string.isRequired,
	  list: _propTypes2.default.array.isRequired,
	  communitiesJoinReq: _propTypes2.default.func.isRequired,
	  joinReqCounter: _propTypes2.default.number,
	  invitesCounter: _propTypes2.default.number,
	  notifyCounter: _propTypes2.default.number,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  classes: _propTypes2.default.object.isRequired,
	  sendingJoinRequests: _propTypes2.default.bool,
	  loadNextRequests: _propTypes2.default.func.isRequired,
	  pageLeave: _propTypes2.default.func.isRequired
	};
	
	Activities.defaultProps = {
	  joinReqCounter: 0,
	  invitesCounter: 0,
	  notifyCounter: 0,
	  sendingJoinRequests: false
	};
	
	exports.default = (0, _enhance.enhance)(Activities);
	
	
	function useTabs(formatMessage, notificationCounter, requestsCounter, invitesCounter) {
	  return (0, _react.useMemo)(function () {
	    return [{
	      label: formatMessage(_strings.COMMON.notifications),
	      id: _ids.IDS.ACTIVITIES_TABS.NOTIFICATIONS,
	      tab: _constants.ACTIVITY_TYPES.NOTIFICATIONS,
	      counter: notificationCounter
	    }, {
	      label: formatMessage(_strings.COMMUNITIES_COMMON.joinRequests),
	      id: _ids.IDS.ACTIVITIES_TABS.JOIN_REQUESTS,
	      tab: _constants.ACTIVITY_TYPES.JOIN_REQUESTS,
	      counter: requestsCounter
	    }, {
	      label: formatMessage(_strings.COMMUNITIES_COMMON.invites),
	      id: _ids.IDS.ACTIVITIES_TABS.MEMBER_INVITATIONS,
	      tab: _constants.ACTIVITY_TYPES.MEMBER_INVITATIONS,
	      counter: invitesCounter
	    }];
	  }, [notificationCounter, requestsCounter, invitesCounter]);
	}

/***/ }),
/* 3154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActivityContentWrap = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityContentWrap = exports.ActivityContentWrap = function ActivityContentWrap(_ref) {
	  var onClick = _ref.onClick,
	      text = _ref.text;
	  return _react2.default.createElement(
	    'span',
	    { onClick: onClick, className: 'g-color--info fw6 pointer' },
	    text
	  );
	};
	
	ActivityContentWrap.propTypes = {
	  onClick: _propTypes2.default.func,
	  text: _propTypes2.default.string
	};
	ActivityContentWrap.defaultProps = {
	  onClick: function onClick() {},
	  text: ''
	};

/***/ }),
/* 3155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _strings = __webpack_require__(15);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CommunityCard = __webpack_require__(606);
	
	var _TimeShow = __webpack_require__(399);
	
	var _ids = __webpack_require__(46);
	
	var _index = __webpack_require__(955);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityListItem = function ActivityListItem(_ref) {
	  var logo = _ref.logo,
	      name = _ref.name,
	      userName = _ref.userName,
	      subtitle = _ref.subtitle,
	      _onClick = _ref.onClick,
	      createdAt = _ref.createdAt,
	      onHandleJoinRequest = _ref.onHandleJoinRequest,
	      organizations = _ref.organizations,
	      formatMessage = _ref.intl.formatMessage,
	      id = _ref.id,
	      communityId = _ref.communityId,
	      role = _ref.role,
	      disabled = _ref.disabled,
	      requestId = _ref.requestId;
	  return _react2.default.createElement(_CommunityCard.CommunityCard, {
	    avatar: {
	      src: logo,
	      size: 100,
	      name: name
	    },
	    renderTitle: function renderTitle() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'pointer', onClick: function onClick() {
	            return _onClick(id, 'profile');
	          } },
	        name,
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: 'fw4 g-color--accent' },
	          userName
	        )
	      );
	    },
	    renderSubTitle: function renderSubTitle() {
	      return _react2.default.createElement(
	        'p',
	        null,
	        !!role && _react2.default.createElement(
	          'span',
	          null,
	          role,
	          ' \u2022 '
	        ),
	        organizations
	      );
	    },
	    renderContent: function renderContent() {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _strings.COMMUNITY_ACTIVITY_REQUEST, {
	        values: {
	          communityName: _react2.default.createElement(
	            'span',
	            {
	              onClick: function onClick() {
	                return _onClick(communityId, 'community');
	              },
	              className: 'g-color--info fw6 pointer'
	            },
	            subtitle
	          )
	        }
	      }));
	    },
	    renderInfo: function renderInfo() {
	      return _react2.default.createElement(_TimeShow.TimeShow, { timestamp: createdAt });
	    },
	    renderActions: function renderActions() {
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            id: _ids.IDS.ACTIVITIES.JOIN_REQUEST_ACCEPT_BTN,
	            disabled: disabled,
	            color: 'primary',
	            className: 'mb1',
	            onClick: function onClick() {
	              return onHandleJoinRequest(requestId, 'accept');
	            }
	          },
	          formatMessage(_strings.COMMON.accept)
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            id: _ids.IDS.ACTIVITIES.JOIN_REQUEST_DECLINE_BTN,
	            disabled: disabled,
	            color: 'accent',
	            onClick: function onClick() {
	              return onHandleJoinRequest(requestId, 'decline');
	            }
	          },
	          formatMessage(_strings.COMMON.decline)
	        )
	      );
	    }
	  });
	};
	
	ActivityListItem.propTypes = {
	  createdAt: _propTypes2.default.string,
	  logo: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  userName: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onHandleJoinRequest: _propTypes2.default.func,
	  organizations: _propTypes2.default.string,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  id: _propTypes2.default.number.isRequired,
	  communityId: _propTypes2.default.number,
	  role: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  requestId: _propTypes2.default.number.isRequired
	};
	
	ActivityListItem.defaultProps = {
	  createdAt: '',
	  logo: '',
	  name: '',
	  userName: '',
	  subtitle: '',
	  onClick: null,
	  onHandleJoinRequest: null,
	  organizations: '',
	  communityId: null,
	  role: '',
	  disabled: null
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(ActivityListItem, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _strings = __webpack_require__(15);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CommunityCard = __webpack_require__(606);
	
	var _TimeShow = __webpack_require__(399);
	
	var _ids = __webpack_require__(46);
	
	var _index = __webpack_require__(955);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteListItem = function InviteListItem(_ref) {
	  var logo = _ref.logo,
	      name = _ref.name,
	      userName = _ref.userName,
	      subtitle = _ref.subtitle,
	      _onClick = _ref.onClick,
	      createdAt = _ref.createdAt,
	      handleAccept = _ref.handleAccept,
	      handleDecline = _ref.handleDecline,
	      organizations = _ref.organizations,
	      formatMessage = _ref.intl.formatMessage,
	      id = _ref.id,
	      invitationId = _ref.invitationId,
	      communityId = _ref.communityId,
	      role = _ref.role,
	      disabled = _ref.disabled;
	
	  var subtitleContent = (0, _react.useMemo)(function () {
	    if (!role) return null;
	
	    return function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        role
	      );
	    };
	  }, [role]);
	
	  return _react2.default.createElement(_CommunityCard.CommunityCard, {
	    avatar: {
	      src: logo,
	      size: 100,
	      name: name
	    },
	    renderTitle: function renderTitle() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'pointer', onClick: function onClick() {
	            return _onClick(id, 'profile');
	          } },
	        name,
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: 'fw4 g-color--accent' },
	          userName
	        )
	      );
	    },
	    renderSubTitle: subtitleContent,
	    renderContent: function renderContent() {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'community.activity.invite',
	        values: {
	          communityName: _react2.default.createElement(
	            'span',
	            {
	              onClick: function onClick() {
	                return _onClick(communityId, 'community');
	              },
	              className: 'g-color--info fw6 pointer'
	            },
	            subtitle
	          )
	        }
	      });
	    },
	    renderSubContent: function renderSubContent() {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: 'community.activity.fromOrganization',
	        values: {
	          organization: organizations
	        }
	      });
	    },
	    renderInfo: function renderInfo() {
	      return _react2.default.createElement(_TimeShow.TimeShow, { timestamp: createdAt });
	    },
	    renderActions: function renderActions() {
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            id: _ids.IDS.ACTIVITIES.INVITATION_ACCEPT_BTN,
	            disabled: disabled,
	            color: 'primary',
	            className: 'mb1',
	            onClick: function onClick() {
	              return handleAccept(invitationId);
	            }
	          },
	          formatMessage(_strings.COMMON.accept)
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            id: _ids.IDS.ACTIVITIES.INVITATION_DECLINE_BTN,
	            disabled: disabled,
	            color: 'accent',
	            onClick: function onClick() {
	              return handleDecline(invitationId);
	            }
	          },
	          formatMessage(_strings.COMMON.decline)
	        )
	      );
	    }
	  });
	};
	
	InviteListItem.propTypes = {
	  createdAt: _propTypes2.default.string,
	  logo: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  userName: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  handleDecline: _propTypes2.default.func,
	  handleAccept: _propTypes2.default.func,
	  organizations: _propTypes2.default.string,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  id: _propTypes2.default.number.isRequired,
	  communityId: _propTypes2.default.number,
	  invitationId: _propTypes2.default.number,
	  role: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool
	};
	
	InviteListItem.defaultProps = {
	  createdAt: '',
	  logo: '',
	  name: '',
	  userName: '',
	  subtitle: '',
	  onClick: null,
	  handleDecline: null,
	  handleAccept: null,
	  organizations: '',
	  invitationId: null,
	  communityId: null,
	  role: '',
	  disabled: null
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(InviteListItem, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _ActivityContentWrap = __webpack_require__(3154);
	
	var _utils = __webpack_require__(3159);
	
	var _CommunityCard = __webpack_require__(606);
	
	var _TimeShow = __webpack_require__(399);
	
	var _Label = __webpack_require__(1187);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _routes = __webpack_require__(37);
	
	var _index = __webpack_require__(955);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationListItem = function NotificationListItem(_ref) {
	  var createdAt = _ref.createdAt,
	      _onClick = _ref.onClick,
	      hasNewLabel = _ref.hasNewLabel,
	      newLabelText = _ref.newLabelText,
	      subject = _ref.subject;
	
	  var type = (0, _utils.getNotificationType)(subject);
	  var _subject$community = subject.community,
	      communityId = _subject$community.id,
	      name = _subject$community.name;
	
	  var _getNotificationDetai = (0, _utils.getNotificationDetailsByType)(type, subject),
	      translationKey = _getNotificationDetai.translationKey,
	      extraTitle = _getNotificationDetai.extraTitle,
	      logo = _getNotificationDetai.logo,
	      route = _getNotificationDetai.route,
	      id = _getNotificationDetai.id,
	      title = _getNotificationDetai.title;
	
	  return _react2.default.createElement(_CommunityCard.CommunityCard, {
	    avatar: {
	      src: logo,
	      size: 100,
	      name: title
	    },
	    renderTitle: function renderTitle() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'pointer', onClick: function onClick() {
	            return _onClick(id, route);
	          } },
	        _react2.default.createElement(
	          'span',
	          null,
	          title
	        ),
	        ' ',
	        extraTitle,
	        hasNewLabel && _react2.default.createElement(_Label2.default, {
	          text: newLabelText,
	          className: 'ml1 relative',
	          additionalClass: 'uppercase'
	        })
	      );
	    },
	    renderContent: function renderContent() {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, {
	        id: translationKey,
	        values: {
	          communityName: _react2.default.createElement(_ActivityContentWrap.ActivityContentWrap, {
	            onClick: function onClick() {
	              return _onClick(communityId, 'community');
	            },
	            text: name
	          })
	        }
	      });
	    },
	    renderInfo: function renderInfo() {
	      return _react2.default.createElement(_TimeShow.TimeShow, { timestamp: createdAt });
	    },
	    renderActions: function renderActions() {
	      return subject.approvalStatus === 'approved' && _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'primary',
	          onClick: function onClick() {
	            return _browserHistory2.default.push(_routes.COMMUNITIES + '/' + communityId + '/post/' + subject.id);
	          }
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'community.activity.openPost' })
	      );
	    }
	  });
	};
	
	NotificationListItem.propTypes = {
	  createdAt: _propTypes2.default.string.isRequired,
	  subject: _propTypes2.default.object.isRequired,
	  onClick: _propTypes2.default.func,
	  newLabelText: _propTypes2.default.string,
	  hasNewLabel: _propTypes2.default.bool
	};
	
	NotificationListItem.defaultProps = {
	  onClick: null,
	  newLabelText: '',
	  hasNewLabel: false
	};
	
	exports.default = (0, _reactCssModules2.default)(NotificationListItem, _index2.default, { allowMultiple: true });

/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _is_same_day = __webpack_require__(937);
	
	var _is_same_day2 = _interopRequireDefault(_is_same_day);
	
	var _format = __webpack_require__(319);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(58);
	
	var _acceptJoinRequest = __webpack_require__(818);
	
	var _declineJoinRequest = __webpack_require__(825);
	
	var _declineInvitation = __webpack_require__(518);
	
	var _acceptInvitation = __webpack_require__(342);
	
	var _routes = __webpack_require__(37);
	
	var _dateConverters = __webpack_require__(83);
	
	var _MessageSeparatorView = __webpack_require__(763);
	
	var _MessageSeparatorView2 = _interopRequireDefault(_MessageSeparatorView);
	
	var _NotificationListItem = __webpack_require__(3157);
	
	var _NotificationListItem2 = _interopRequireDefault(_NotificationListItem);
	
	var _ActivityListItem = __webpack_require__(3155);
	
	var _ActivityListItem2 = _interopRequireDefault(_ActivityListItem);
	
	var _InviteListItem = __webpack_require__(3156);
	
	var _InviteListItem2 = _interopRequireDefault(_InviteListItem);
	
	var _constants = __webpack_require__(17);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(955);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TIMESTAMP_FORMATTING_PATTERN = 'h:mm a';
	
	var mapDispatchToProps = {
	  acceptCommunityJoinRequest: _acceptJoinRequest.actions.send,
	  declineCommunityJoinRequest: _declineJoinRequest.actions.send,
	  acceptInvite: _declineInvitation.actions.send,
	  declineInvite: _acceptInvitation.actions.send
	};
	
	var ActivitiesList = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(ActivitiesList, _Component);
	
	  function ActivitiesList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ActivitiesList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActivitiesList.__proto__ || (0, _getPrototypeOf2.default)(ActivitiesList)).call.apply(_ref, [this].concat(args))), _this), _this.isNewDayForMessage = function (list, index) {
	      if (index === 0) return true;
	
	      var previousTime = (0, _dateConverters.adaptDateToLocalTimezone)(list[index - 1].createdAt);
	      var nextTime = (0, _dateConverters.adaptDateToLocalTimezone)(list[index].createdAt);
	      return !(0, _is_same_day2.default)(previousTime, nextTime);
	    }, _this.convertItemTime = function (createdAt) {
	      var date = (0, _dateConverters.adaptDateToLocalTimezone)(createdAt);
	      return (0, _format2.default)(date, TIMESTAMP_FORMATTING_PATTERN);
	    }, _this.handleJoinRequest = function (id, type) {
	      var _this$props = _this.props,
	          acceptCommunityJoinRequest = _this$props.acceptCommunityJoinRequest,
	          declineCommunityJoinRequest = _this$props.declineCommunityJoinRequest;
	
	      return type === 'accept' ? acceptCommunityJoinRequest({ id: id, type: type }) : declineCommunityJoinRequest({ id: id, type: type });
	    }, _this.acceptCommunityInvite = function (id) {
	      var acceptInvite = _this.props.acceptInvite;
	
	
	      acceptInvite({ id: id, actionType: 'accept' });
	    }, _this.declineCommunityInvite = function (id) {
	      var declineInvite = _this.props.declineInvite;
	
	
	      declineInvite({ id: id, actionType: 'decline' });
	    }, _this.handleOpen = function (id, routeType) {
	      var route = routeType === 'community' ? '/' + _routes.COMMUNITIES + '/' + id : '/' + _routes.PUBLIC_PROFILE + '/' + id;
	      _browserHistory2.default.push(route);
	    }, _this.renderInviteItem = function (item) {
	      var _item$subject = item.subject,
	          subject = _item$subject === undefined ? {} : _item$subject,
	          disabled = item.disabled,
	          createdAt = item.createdAt;
	      var id = subject.id,
	          community = subject.community,
	          inviter = subject.inviter;
	
	      var userName = (0, _lodash.get)(inviter, 'username');
	      var name = (0, _lodash.get)(inviter, 'displayableName', userName);
	
	      return _react2.default.createElement(_InviteListItem2.default, {
	        key: id,
	        logo: (0, _lodash.get)(inviter, 'avatar.thumbMiddle'),
	        name: name,
	        userName: userName,
	        role: (0, _lodash.get)(inviter, 'providerRole'),
	        id: (0, _lodash.get)(inviter, 'id'),
	        disabled: disabled,
	        createdAt: createdAt,
	        handleAccept: _this.acceptCommunityInvite,
	        handleDecline: _this.declineCommunityInvite,
	        invitationId: id,
	        onClick: _this.handleOpen,
	        organizations: (0, _lodash.get)(community, 'organization.name'),
	        communityId: (0, _lodash.get)(community, 'id'),
	        subtitle: (0, _lodash.get)(community, 'name')
	      });
	    }, _this.renderRequestItem = function (item) {
	      var subject = item.subject,
	          disabled = item.disabled,
	          createdAt = item.createdAt;
	
	      var community = (0, _lodash.get)(subject, 'community');
	      var user = (0, _lodash.get)(subject, 'user');
	      var subjectId = (0, _lodash.get)(subject, 'id');
	
	      var _ref2 = community || {},
	          name = _ref2.name,
	          communityId = _ref2.id;
	
	      var _ref3 = user || {},
	          username = _ref3.username,
	          displayableName = _ref3.displayableName,
	          _ref3$userOrganizatio = _ref3.userOrganizations,
	          userOrganizations = _ref3$userOrganizatio === undefined ? [] : _ref3$userOrganizatio,
	          providerRole = _ref3.providerRole,
	          _ref3$avatar = _ref3.avatar,
	          avatar = _ref3$avatar === undefined ? {} : _ref3$avatar,
	          id = _ref3.id;
	
	      return _react2.default.createElement(_ActivityListItem2.default, {
	        key: subjectId,
	        userName: username,
	        name: displayableName || username,
	        subtitle: name,
	        createdAt: createdAt,
	        time: _this.convertItemTime(createdAt),
	        onHandleJoinRequest: _this.handleJoinRequest,
	        logo: avatar.url,
	        organizations: userOrganizations.join(', '),
	        id: id,
	        communityId: communityId,
	        onClick: _this.handleOpen,
	        role: providerRole,
	        disabled: disabled,
	        requestId: subjectId
	      });
	    }, _this.renderNotificationItem = function (item) {
	      var formatMessage = _this.props.intl.formatMessage;
	      var id = item.id,
	          subject = item.subject,
	          createdAt = item.createdAt,
	          isNew = item.isNew;
	
	
	      return _react2.default.createElement(_NotificationListItem2.default, {
	        key: id,
	        subject: subject,
	        createdAt: createdAt,
	        onClick: _this.handleOpen,
	        hasNewLabel: isNew,
	        newLabelText: formatMessage(_strings.COMMON.new)
	      });
	    }, _this.renderItems = function () {
	      var _this$props2 = _this.props,
	          list = _this$props2.list,
	          listType = _this$props2.listType;
	
	
	      return list.reduce(function (acc, item, index) {
	        var isConfirmedData = (0, _lodash.get)(item, 'subject.user.emailConfirmed', false) || (0, _lodash.get)(item, 'subject.user.phoneNumberConfirmed', false);
	        if (_this.isNewDayForMessage(list, index) && listType !== _constants.ACTIVITY_TYPES.JOIN_REQUESTS || listType === _constants.ACTIVITY_TYPES.JOIN_REQUESTS && isConfirmedData) {
	          acc.push(_react2.default.createElement(_MessageSeparatorView2.default, {
	            key: item.id + '-' + item.createdAt,
	            date: (0, _dateConverters.adaptDateToLocalTimezone)(item.createdAt),
	            left: true,
	            hasBorder: true
	          }));
	        }
	        if (listType === _constants.ACTIVITY_TYPES.NOTIFICATIONS) {
	          acc.push(_this.renderNotificationItem(item));
	        }
	
	        if (listType === _constants.ACTIVITY_TYPES.JOIN_REQUESTS && isConfirmedData) {
	          acc.push(_this.renderRequestItem(item));
	        }
	
	        if (listType === _constants.ACTIVITY_TYPES.MEMBER_INVITATIONS) {
	          acc.push(_this.renderInviteItem(item));
	        }
	
	        return acc;
	      }, []);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ActivitiesList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          list = _props.list,
	          className = _props.className,
	          listType = _props.listType;
	
	
	      return _react2.default.createElement(
	        'ul',
	        { styleName: 'list', className: className, key: listType },
	        Boolean(list.length) && this.renderItems()
	      );
	    }
	  }]);
	  return ActivitiesList;
	}(_react.Component), _class2.propTypes = {
	  acceptCommunityJoinRequest: _propTypes2.default.func,
	  declineCommunityJoinRequest: _propTypes2.default.func,
	  acceptInvite: _propTypes2.default.func,
	  declineInvite: _propTypes2.default.func,
	  list: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  className: _propTypes2.default.string,
	  listType: _propTypes2.default.string.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired
	}, _class2.defaultProps = {
	  className: '',
	  acceptCommunityJoinRequest: null,
	  declineCommunityJoinRequest: null
	}, _temp2)) || _class) || _class) || _class);
	exports.default = ActivitiesList;

/***/ }),
/* 3159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NOTIFICATION_TYPE = undefined;
	exports.getNotificationType = getNotificationType;
	exports.getNotificationDetailsByType = getNotificationDetailsByType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOTIFICATION_TYPE = exports.NOTIFICATION_TYPE = {
	  POST: 'post',
	  INVITE: 'invite',
	  JOIN_REQUEST: 'joinRequest'
	};
	
	function getNotificationType(subject) {
	  if ('inviter' in subject) return NOTIFICATION_TYPE.INVITE;
	  if ('approvalStatus' in subject) return NOTIFICATION_TYPE.POST;
	  return NOTIFICATION_TYPE.JOIN_REQUEST;
	}
	
	function getNotificationDetailsByType(type, subject) {
	  switch (type) {
	    case NOTIFICATION_TYPE.INVITE:
	      {
	        var username = (0, _get2.default)(subject, 'targetUser.username');
	
	        return {
	          title: (0, _get2.default)(subject, 'targetUser.displayableName', username),
	          logo: (0, _get2.default)(subject, 'targetUser.avatar.thumbMiddle'),
	          id: (0, _get2.default)(subject, 'targetUser.id'),
	          route: 'profile',
	          translationKey: (0, _get2.default)(subject, 'status') === 'declined' ? 'community.activity.inviteDeclined' : 'community.activity.inviteAccepted',
	          extraTitle: _react2.default.createElement(
	            'span',
	            { className: 'fw4 g-color--accent ml1' },
	            username
	          )
	        };
	      }
	    case NOTIFICATION_TYPE.JOIN_REQUEST:
	      {
	        return {
	          title: (0, _get2.default)(subject, 'community.name'),
	          logo: (0, _get2.default)(subject, 'community.logo.thumbMiddle'),
	          id: (0, _get2.default)(subject, 'community.id'),
	          route: 'community',
	          translationKey: (0, _get2.default)(subject, 'status') === 'declined' ? 'community.activity.requestDeclined' : 'community.activity.requestAccepted',
	          extraTitle: null
	        };
	      }
	    case NOTIFICATION_TYPE.POST:
	      {
	        return {
	          title: (0, _get2.default)(subject, 'community.name'),
	          logo: (0, _get2.default)(subject, 'community.logo.thumbMiddle'),
	          id: (0, _get2.default)(subject, 'community.id'),
	          route: 'community',
	          translationKey: (0, _get2.default)(subject, 'approvalStatus') === 'approved' ? 'community.activity.postApproved' : 'community.activity.postDeclined',
	          extraTitle: null
	        };
	      }
	    default:
	      return {};
	  }
	}

/***/ }),
/* 3160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(2243);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlaceholderCard = function PlaceholderCard(_ref) {
	  var counter = _ref.counter,
	      text = _ref.text,
	      route = _ref.route;
	  return _react2.default.createElement(
	    'li',
	    { styleName: 'card' },
	    _react2.default.createElement(
	      _Link2.default,
	      { to: route },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'wrapper wrapper--placeholder' },
	        _react2.default.createElement('div', { styleName: 'header' }),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'image' },
	          _react2.default.createElement(
	            'span',
	            null,
	            counter
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'link' },
	          text,
	          _react2.default.createElement(_Icon2.default, { className: 'ml2', name: 'icon-arrow-left', height: 10, width: 18 })
	        )
	      )
	    )
	  );
	};
	
	PlaceholderCard.propTypes = {
	  counter: _propTypes2.default.string.isRequired,
	  text: _propTypes2.default.string.isRequired,
	  route: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactCssModules2.default)(PlaceholderCard, _index2.default, { allowMultiple: true });

/***/ }),
/* 3161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reqDiscoverCommunities = __webpack_require__(520);
	
	var _reqJoinCommunity = __webpack_require__(521);
	
	var _acceptInvitation = __webpack_require__(342);
	
	var _currentCommunity = __webpack_require__(824);
	
	var _selectors = __webpack_require__(151);
	
	var _constants = __webpack_require__(17);
	
	var _index = __webpack_require__(374);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = {
	  getAllCommunities: _reqDiscoverCommunities.actions.send,
	  loadNextCommunities: _reqDiscoverCommunities.paginatedActions.loadNextCommunities,
	  reqJoinCommunity: _reqJoinCommunity.actions.send,
	  acceptInvite: _acceptInvitation.actions.send,
	  setCurrentCommunity: _currentCommunity.actions.set
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    globalCommunitiesList: (0, _selectors.makeDiscoverCommunitiesListSelector)(_constants.DISCOVERY_LIST_TYPES.GLOBAL)(state),
	    organizationCommunitiesList: (0, _selectors.makeDiscoverCommunitiesListSelector)(_constants.DISCOVERY_LIST_TYPES.ORGANIZATION)(state),
	    globalCommunitiesCount: (0, _selectors.makeDiscoverCommunitiesCounterSelector)(_constants.DISCOVERY_LIST_TYPES.GLOBAL)(state),
	    organizationCommunitiesCount: (0, _selectors.makeDiscoverCommunitiesCounterSelector)(_constants.DISCOVERY_LIST_TYPES.ORGANIZATION)(state),
	    sendingRequest: (0, _selectors.sendingDiscoverCommunitiesSelector)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(42);
	
	var _VerticalCard = __webpack_require__(1729);
	
	var _VerticalCard2 = _interopRequireDefault(_VerticalCard);
	
	var _PlaceholderCard = __webpack_require__(3160);
	
	var _PlaceholderCard2 = _interopRequireDefault(_PlaceholderCard);
	
	var _HorizontalCard = __webpack_require__(1728);
	
	var _HorizontalCard2 = _interopRequireDefault(_HorizontalCard);
	
	var _CommunitiesList = __webpack_require__(1098);
	
	var _CommunitiesList2 = _interopRequireDefault(_CommunitiesList);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _withLazyLoad = __webpack_require__(620);
	
	var _withLazyLoad2 = _interopRequireDefault(_withLazyLoad);
	
	var _routes = __webpack_require__(37);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _injectSaga = __webpack_require__(116);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _updateCurrentCommunity = __webpack_require__(1265);
	
	var _updateCurrentCommunity2 = _interopRequireDefault(_updateCurrentCommunity);
	
	var _getButtonInfo = __webpack_require__(1379);
	
	var _getButtonInfo2 = _interopRequireDefault(_getButtonInfo);
	
	var _enhance = __webpack_require__(3161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DiscoverCommunities = function DiscoverCommunities(_ref) {
	  var getAllCommunities = _ref.getAllCommunities,
	      organizationCommunitiesList = _ref.organizationCommunitiesList,
	      organizationCommunitiesCount = _ref.organizationCommunitiesCount,
	      loadNextCommunities = _ref.loadNextCommunities,
	      reqJoinCommunity = _ref.reqJoinCommunity,
	      acceptInvite = _ref.acceptInvite,
	      globalCommunitiesCount = _ref.globalCommunitiesCount,
	      globalCommunitiesList = _ref.globalCommunitiesList,
	      sendingRequest = _ref.sendingRequest,
	      formatMessage = _ref.intl.formatMessage;
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'updateCurrentCommunity',
	    saga: _updateCurrentCommunity2.default,
	    mode: _sagaInjectors.RESTART_ON_REMOUNT
	  });
	
	  (0, _react.useEffect)(function () {
	    getAllCommunities({ type: _constants.DISCOVERY_LIST_TYPES.ORGANIZATION });
	    getAllCommunities({ type: _constants.DISCOVERY_LIST_TYPES.GLOBAL, limit: 12 });
	  }, []);
	
	  var handleSelect = function handleSelect(id) {
	    var route = '/' + _routes.COMMUNITIES + '/' + id;
	    _reactRouter.browserHistory.push(route);
	  };
	
	  var loadMore = function loadMore() {
	    loadNextCommunities({ type: _constants.DISCOVERY_LIST_TYPES.GLOBAL });
	  };
	
	  var handleJoinCommunity = function handleJoinCommunity(_ref2, actionType) {
	    var id = _ref2.id,
	        memberInvitationId = _ref2.memberInvitationId;
	
	    if (actionType === _constants.COMMUNITY_BTN_ACTIONS.ACCEPT) {
	      acceptInvite({
	        id: memberInvitationId,
	        actionType: _constants.COMMUNITY_BTN_ACTIONS.ACCEPT
	      });
	      return;
	    }
	    reqJoinCommunity({ communityId: id });
	  };
	
	  var organizationCommunitiesNumber = (0, _size2.default)(organizationCommunitiesList);
	  var defaultCardsNumber = organizationCommunitiesNumber > _constants.ORGANIZATION_COMMUNITIES_NUMBER_MAX ? _constants.ORGANIZATION_COMMUNITIES_NUMBER_MAX - 1 : _constants.ORGANIZATION_COMMUNITIES_NUMBER_MAX;
	  var organizationPreview = organizationCommunitiesList && organizationCommunitiesList.slice(0, defaultCardsNumber);
	  var placeholderCounter = organizationCommunitiesCount - (0, _size2.default)(organizationPreview);
	
	  return _react2.default.createElement(
	    _withLazyLoad2.default,
	    { loadMore: loadMore },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'wrapper' },
	      !!organizationCommunitiesCount ? _react2.default.createElement(
	        _CommunitiesList2.default,
	        {
	          title: formatMessage(_strings.COMMUNITIES_COMMON.fromOrganization),
	          counter: organizationCommunitiesCount
	        },
	        organizationPreview.map(function (community) {
	          var buttonInfo = (0, _getButtonInfo2.default)(community, formatMessage);
	
	          return _react2.default.createElement(_VerticalCard2.default, {
	            key: community.id,
	            banner: (0, _get2.default)(community, 'banner.url'),
	            logo: (0, _get2.default)(community, 'logo.url'),
	            name: community.name,
	            organization: (0, _get2.default)(community, 'organization.name'),
	            totalPosts: community.totalPosts,
	            totalUsers: community.totalUsers,
	            onClick: function onClick() {
	              return handleSelect(community.id);
	            },
	            buttonText: formatMessage(_strings.DIALOG_TITLE.join),
	            joinCommunity: function joinCommunity() {
	              return handleJoinCommunity(community, buttonInfo.type);
	            },
	            buttonInfo: buttonInfo
	          });
	        }),
	        organizationCommunitiesNumber > _constants.ORGANIZATION_COMMUNITIES_NUMBER_MAX ? _react2.default.createElement(_PlaceholderCard2.default, {
	          counter: '+' + placeholderCounter,
	          text: formatMessage(_strings.COMMUNITIES_COMMON.seeAll),
	          route: '/' + _routes.COMMUNITIES + '/' + _routes.DISCOVER + '/' + _routes.ORGANIZATION
	        }) : null
	      ) : null,
	      !!globalCommunitiesCount ? _react2.default.createElement(
	        _CommunitiesList2.default,
	        {
	          title: formatMessage(_strings.COMMUNITIES_COMMON.otherCommunities),
	          counter: globalCommunitiesCount
	        },
	        globalCommunitiesList.map(function (community) {
	          var buttonInfo = (0, _getButtonInfo2.default)(community, formatMessage);
	
	          return _react2.default.createElement(_HorizontalCard2.default, {
	            key: community.id,
	            banner: (0, _get2.default)(community, 'banner.url'),
	            logo: (0, _get2.default)(community, 'logo.url'),
	            name: community.name,
	            organization: (0, _get2.default)(community, 'organization.name'),
	            totalPosts: community.totalPosts,
	            totalUsers: community.totalUsers,
	            onClick: function onClick() {
	              return handleSelect(community.id);
	            },
	            buttonText: formatMessage(_strings.DIALOG_TITLE.join),
	            joinCommunity: function joinCommunity() {
	              return handleJoinCommunity(community, buttonInfo.type);
	            },
	            buttonInfo: buttonInfo
	          });
	        })
	      ) : null,
	      !sendingRequest && !organizationCommunitiesCount && !globalCommunitiesCount ? _react2.default.createElement(
	        'div',
	        { styleName: 'empty-state' },
	        _react2.default.createElement(_Content2.default, {
	          icon: 'icon-megaphone',
	          text: formatMessage(_strings.COMMUNITIES_EMPTY)
	        })
	      ) : null,
	      sendingRequest ? _react2.default.createElement(_Loader2.default, null) : null
	    )
	  );
	};
	
	DiscoverCommunities.propTypes = {
	  getAllCommunities: _propTypes2.default.func.isRequired,
	  loadNextCommunities: _propTypes2.default.func.isRequired,
	  reqJoinCommunity: _propTypes2.default.func.isRequired,
	  globalCommunitiesList: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  organizationCommunitiesList: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  globalCommunitiesCount: _propTypes2.default.number.isRequired,
	  organizationCommunitiesCount: _propTypes2.default.number.isRequired,
	  sendingRequest: _propTypes2.default.bool.isRequired,
	  acceptInvite: _propTypes2.default.func.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired
	};
	
	exports.default = (0, _enhance.enhance)(DiscoverCommunities);

/***/ }),
/* 3163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRedux = __webpack_require__(6);
	
	var _styles = __webpack_require__(581);
	
	var _styles2 = __webpack_require__(18);
	
	var _userCommunities = __webpack_require__(414);
	
	var _removeNotificationsCounters = __webpack_require__(345);
	
	var _usersJoinRequests = __webpack_require__(830);
	
	var _selectors = __webpack_require__(151);
	
	var _usersJoinRequests2 = __webpack_require__(1882);
	
	var _index = __webpack_require__(374);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tabStyles = {
	  root: {
	    fontFamily: _styles2.FONT_FAMILY.primary,
	    textTransform: 'initial',
	    paddingLeft: 0,
	    fontWeight: 400
	  },
	  label: {
	    fontSize: 14,
	    lineHeight: 1.5,
	    paddingLeft: 0
	  }
	};
	
	var mapDispatchToProps = {
	  communitiesList: _userCommunities.actions.send,
	  loadNextRequests: _userCommunities.paginatedActions.loadNextCommunities,
	  removeNotifications: _removeNotificationsCounters.actions.send,
	  usersJoinReq: _usersJoinRequests.actions.send,
	  loadNextUserRequests: _usersJoinRequests.paginatedActions.loadNextRequests
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    sendingRequests: (0, _selectors.sendingUserCommunitiesSelector)(state),
	    memberCommunitiesList: (0, _selectors.makeUserCommunitiesListSelector)('memberCommunities')(state),
	    moderatorCommunitiesList: (0, _selectors.makeUserCommunitiesListSelector)('moderatorCommunities')(state),
	    memberCommunitiesCounter: (0, _selectors.makeUserCommunitiesCounterSelector)('memberCommunitiesCount')(state),
	    moderatorCommunitiesCounter: (0, _selectors.makeUserCommunitiesCounterSelector)('moderatorCommunitiesCount')(state),
	    usersJoinRequestsList: (0, _usersJoinRequests2.usersJoinRequestsListSelector)(state),
	    usersJoinRequestsCounter: (0, _usersJoinRequests2.usersJoinRequestsCounterSelector)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _styles.withStyles)(tabStyles), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppBar = __webpack_require__(1563);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _Tabs = __webpack_require__(1566);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Tab = __webpack_require__(992);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _HorizontalCard = __webpack_require__(1728);
	
	var _HorizontalCard2 = _interopRequireDefault(_HorizontalCard);
	
	var _CommunitiesList = __webpack_require__(1098);
	
	var _CommunitiesList2 = _interopRequireDefault(_CommunitiesList);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _styles = __webpack_require__(18);
	
	var _enhance = __webpack_require__(3163);
	
	var _index = __webpack_require__(35);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _strings = __webpack_require__(15);
	
	var _routes = __webpack_require__(37);
	
	var _ids = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TABS = {
	  MEMBER: 'member',
	  MODERATOR: 'moderator',
	  REQUESTS: 'requests'
	};
	
	var MyCommunities = function MyCommunities(_ref) {
	  var moderatorCounter = _ref.moderatorCommunitiesCounter,
	      moderatorList = _ref.moderatorCommunitiesList,
	      memberCounter = _ref.memberCommunitiesCounter,
	      memberList = _ref.memberCommunitiesList,
	      requests = _ref.usersJoinRequestsList,
	      requestsCounter = _ref.usersJoinRequestsCounter,
	      usersJoinReq = _ref.usersJoinReq,
	      sendingRequests = _ref.sendingRequests,
	      removeNotifications = _ref.removeNotifications,
	      communitiesList = _ref.communitiesList,
	      loadNextRequests = _ref.loadNextRequests,
	      loadNextUserRequests = _ref.loadNextUserRequests,
	      formatMessage = _ref.intl.formatMessage,
	      classes = _ref.classes;
	
	  var rootRef = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(TABS.MEMBER),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      tab = _useState2[0],
	      setTab = _useState2[1];
	
	  var tabs = useTabs(formatMessage, memberCounter, moderatorCounter, requestsCounter);
	  var list = useList(tab, memberList, moderatorList, requests);
	  var hasList = memberCounter || moderatorCounter || requestsCounter;
	  var loadMore = (0, _react.useCallback)(function () {
	    if (tab === 'requests') {
	      loadNextUserRequests({ limit: 10 });
	    } else {
	      loadNextRequests({ type: tab });
	    }
	  }, [tab]);
	  (0, _useLazyLoad.useLazyLoad)({ node: rootRef, loadMore: loadMore, path: ['parentNode'] });
	
	  (0, _react.useEffect)(function () {
	    communitiesList({ limit: 20 });
	    usersJoinReq({ limit: 20 });
	  }, []);
	
	  /** Choose default active tab */
	  (0, _react.useEffect)(function () {
	    if (memberCounter === 0) {
	      handleTabChange(null, TABS.MODERATOR);
	    }
	
	    if (moderatorCounter === 0) {
	      handleTabChange(null, TABS.MEMBER);
	    }
	
	    if (memberCounter === 0 && moderatorCounter === 0) {
	      handleTabChange(null, TABS.REQUESTS);
	    }
	  }, [moderatorCounter, memberCounter, sendingRequests]);
	
	  var handleTabChange = function handleTabChange(e, value) {
	    if (value !== tab) {
	      setTab(value);
	    }
	  };
	
	  var handleSelect = function handleSelect(id) {
	    if (tab !== 'requests') {
	      removeNotifications({ type: 'communities', community_ids: [id] });
	    }
	    var route = '/' + _routes.COMMUNITIES + '/' + id;
	    _reactRouter.browserHistory.push(route);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'wrapper', className: 'flex flex-column', ref: rootRef },
	    !sendingRequests ? hasList ? _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _AppBar2.default,
	        {
	          position: 'static',
	          color: 'default',
	          style: {
	            background: 'transparent',
	            border: 0,
	            boxShadow: 'none',
	            marginLeft: (0, _mobileHelpers.isDesktop)() && '-56px',
	            marginTop: 16
	          }
	        },
	        _react2.default.createElement(
	          _Tabs2.default,
	          {
	            indicatorColor: _styles.COLORS.bluePrimary,
	            onChange: handleTabChange,
	            value: tab,
	            scrollable: true
	          },
	          tabs.map(function (_ref2) {
	            var id = _ref2.id,
	                counter = _ref2.counter,
	                label = _ref2.label,
	                tabValue = _ref2.tab;
	            return !!counter ? _react2.default.createElement(_Tab2.default, {
	              label: label + ' (' + counter + ')',
	              key: id,
	              id: id,
	              value: tabValue,
	              classes: {
	                root: classes.root,
	                label: classes.label
	              }
	            }) : null;
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _CommunitiesList2.default,
	        { key: tab },
	        list.map(function (community) {
	          var _ref3 = community.community || community || {},
	              id = _ref3.id,
	              _ref3$banner = _ref3.banner,
	              banner = _ref3$banner === undefined ? {} : _ref3$banner,
	              _ref3$logo = _ref3.logo,
	              logo = _ref3$logo === undefined ? {} : _ref3$logo,
	              name = _ref3.name,
	              _ref3$organization = _ref3.organization,
	              organization = _ref3$organization === undefined ? {} : _ref3$organization,
	              totalPosts = _ref3.totalPosts,
	              totalUsers = _ref3.totalUsers,
	              _ref3$communityMember = _ref3.communityMemberChatroom,
	              communityMemberChatroom = _ref3$communityMember === undefined ? {} : _ref3$communityMember;
	
	          return _react2.default.createElement(_HorizontalCard2.default, {
	            key: id,
	            banner: banner.url,
	            logo: logo.url,
	            name: name,
	            organization: organization.name,
	            totalPosts: totalPosts,
	            totalUsers: totalUsers,
	            onClick: function onClick() {
	              return handleSelect(id);
	            },
	            counter: communityMemberChatroom.totalUnreadCount
	          });
	        })
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { styleName: 'empty-state' },
	      _react2.default.createElement(_Content2.default, {
	        text: formatMessage(_strings.COMMUNITIES_EMPTY),
	        icon: 'icon-megaphone'
	      })
	    ) : _react2.default.createElement(_index2.default, null)
	  );
	};
	
	MyCommunities.propTypes = {
	  communitiesList: _propTypes2.default.func.isRequired,
	  memberCommunitiesCounter: _propTypes2.default.number,
	  moderatorCommunitiesCounter: _propTypes2.default.number,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  classes: _propTypes2.default.object.isRequired,
	  sendingRequests: _propTypes2.default.bool,
	  memberCommunitiesList: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  moderatorCommunitiesList: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  loadNextRequests: _propTypes2.default.func.isRequired,
	  removeNotifications: _propTypes2.default.func.isRequired,
	  usersJoinReq: _propTypes2.default.func.isRequired,
	  loadNextUserRequests: _propTypes2.default.func.isRequired,
	  usersJoinRequestsList: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  usersJoinRequestsCounter: _propTypes2.default.number
	};
	
	MyCommunities.defaultProps = {
	  memberCommunitiesCounter: 0,
	  moderatorCommunitiesCounter: 0,
	  usersJoinRequestsCounter: 0,
	  sendingRequests: false,
	  memberCommunitiesList: [],
	  moderatorCommunitiesList: [],
	  usersJoinRequestsList: []
	};
	
	exports.default = (0, _enhance.enhance)(MyCommunities);
	
	
	function useTabs(formatMessage, memberCounter, moderatorCounter, requestsCounter) {
	  return (0, _react.useMemo)(function () {
	    return [{
	      label: formatMessage(_strings.COMMUNITIES_TITLE_MEMBER),
	      id: _ids.IDS.MY_COMMUNITIES_TABS.ALL,
	      counter: memberCounter,
	      tab: TABS.MEMBER
	    }, {
	      label: formatMessage(_strings.COMMUNITIES_TITLE_MODERATOR),
	      id: _ids.IDS.MY_COMMUNITIES_TABS.I_AM_MODERATOR,
	      counter: moderatorCounter,
	      tab: TABS.MODERATOR
	    }, {
	      label: formatMessage(_strings.COMMUNITIES_COMMON.requested),
	      id: _ids.IDS.MY_COMMUNITIES_TABS.REQUESTED,
	      counter: requestsCounter,
	      tab: TABS.REQUESTS
	    }];
	  }, [memberCounter, moderatorCounter, requestsCounter]);
	}
	
	function useList(tab, memberList, moderatorList, requests) {
	  return (0, _react.useMemo)(function () {
	    switch (tab) {
	      case TABS.MEMBER:
	        return memberList;
	      case TABS.MODERATOR:
	        return moderatorList;
	      case TABS.REQUESTS:
	        return requests;
	      default:
	        return [];
	    }
	  }, [tab, memberList, moderatorList, requests]);
	}

/***/ }),
/* 3165 */,
/* 3166 */,
/* 3167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reqDiscoverCommunities = __webpack_require__(520);
	
	var _reqJoinCommunity = __webpack_require__(521);
	
	var _acceptInvitation = __webpack_require__(342);
	
	var _selectors = __webpack_require__(151);
	
	var _constants = __webpack_require__(17);
	
	var _index = __webpack_require__(374);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = {
	  getAllCommunities: _reqDiscoverCommunities.actions.send,
	  loadNextCommunities: _reqDiscoverCommunities.paginatedActions.loadNextCommunities,
	  reqJoinCommunity: _reqJoinCommunity.actions.send,
	  acceptInvite: _acceptInvitation.actions.send
	};
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    organizationCommunitiesList: (0, _selectors.makeDiscoverCommunitiesListSelector)(_constants.DISCOVERY_LIST_TYPES.ORGANIZATION)(state),
	    sendingDiscoverCommunities: (0, _selectors.sendingDiscoverCommunitiesSelector)(state),
	    organizationCommunitiesCount: (0, _selectors.makeDiscoverCommunitiesCounterSelector)(_constants.DISCOVERY_LIST_TYPES.ORGANIZATION)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(42);
	
	var _VerticalCard = __webpack_require__(1729);
	
	var _VerticalCard2 = _interopRequireDefault(_VerticalCard);
	
	var _CommunitiesList = __webpack_require__(1098);
	
	var _CommunitiesList2 = _interopRequireDefault(_CommunitiesList);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _withLazyLoad = __webpack_require__(620);
	
	var _withLazyLoad2 = _interopRequireDefault(_withLazyLoad);
	
	var _routes = __webpack_require__(37);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _injectSaga = __webpack_require__(116);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _updateCurrentCommunity = __webpack_require__(1265);
	
	var _updateCurrentCommunity2 = _interopRequireDefault(_updateCurrentCommunity);
	
	var _getButtonInfo = __webpack_require__(1379);
	
	var _getButtonInfo2 = _interopRequireDefault(_getButtonInfo);
	
	var _enhance = __webpack_require__(3167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrganizationCommunities = function OrganizationCommunities(_ref) {
	  var getAllCommunities = _ref.getAllCommunities,
	      organizationCommunitiesCount = _ref.organizationCommunitiesCount,
	      organizationCommunitiesList = _ref.organizationCommunitiesList,
	      sendingDiscoverCommunities = _ref.sendingDiscoverCommunities,
	      loadNextCommunities = _ref.loadNextCommunities,
	      reqJoinCommunity = _ref.reqJoinCommunity,
	      formatMessage = _ref.intl.formatMessage,
	      acceptInvite = _ref.acceptInvite;
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'updateCurrentCommunity',
	    saga: _updateCurrentCommunity2.default,
	    mode: _sagaInjectors.RESTART_ON_REMOUNT
	  });
	
	  (0, _react.useEffect)(function () {
	    getAllCommunities({ type: _constants.DISCOVERY_LIST_TYPES.ORGANIZATION, limit: 12 });
	  }, []);
	
	  var loadMore = function loadMore() {
	    loadNextCommunities({ type: _constants.DISCOVERY_LIST_TYPES.ORGANIZATION });
	  };
	
	  var handleSelect = function handleSelect(community) {
	    var route = '/' + _routes.COMMUNITIES + '/' + community.id;
	    _reactRouter.browserHistory.push(route);
	  };
	
	  var handleJoinCommunity = function handleJoinCommunity(_ref2, actionType) {
	    var id = _ref2.id,
	        memberInvitationId = _ref2.memberInvitationId;
	
	    if (actionType === _constants.COMMUNITY_BTN_ACTIONS.ACCEPT) {
	      acceptInvite({
	        id: memberInvitationId,
	        actionType: _constants.COMMUNITY_BTN_ACTIONS.ACCEPT
	      });
	      return;
	    }
	    reqJoinCommunity({ communityId: id });
	  };
	
	  return _react2.default.createElement(
	    _withLazyLoad2.default,
	    { loadMore: loadMore },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'wrapper' },
	      _react2.default.createElement(
	        _CommunitiesList2.default,
	        {
	          title: formatMessage(_strings.COMMUNITIES_COMMON.fromOrganization),
	          counter: organizationCommunitiesCount
	        },
	        organizationCommunitiesList.map(function (community) {
	          var buttonInfo = (0, _getButtonInfo2.default)(community, formatMessage);
	
	          return _react2.default.createElement(_VerticalCard2.default, {
	            key: community.id,
	            banner: (0, _get2.default)(community, 'banner.url'),
	            logo: (0, _get2.default)(community, 'logo.url'),
	            name: community.name,
	            organization: (0, _get2.default)(community, 'organization.name'),
	            totalPosts: community.totalPosts,
	            totalUsers: community.totalUsers,
	            onClick: function onClick() {
	              return handleSelect(community);
	            },
	            joinCommunity: function joinCommunity() {
	              return handleJoinCommunity(community, buttonInfo.type);
	            },
	            buttonInfo: buttonInfo
	          });
	        })
	      ),
	      sendingDiscoverCommunities ? _react2.default.createElement(_Loader2.default, null) : null
	    )
	  );
	};
	
	OrganizationCommunities.propTypes = {
	  getAllCommunities: _propTypes2.default.func.isRequired,
	  loadNextCommunities: _propTypes2.default.func.isRequired,
	  reqJoinCommunity: _propTypes2.default.func.isRequired,
	  acceptInvite: _propTypes2.default.func.isRequired,
	  organizationCommunitiesList: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  sendingDiscoverCommunities: _propTypes2.default.bool.isRequired,
	  organizationCommunitiesCount: _propTypes2.default.number.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired
	};
	
	OrganizationCommunities.defaultProps = {
	  organizationCommunitiesList: []
	};
	
	exports.default = (0, _enhance.enhance)(OrganizationCommunities);

/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TextMessageForm = __webpack_require__(1197);
	
	var _TextMessageForm2 = _interopRequireDefault(_TextMessageForm);
	
	var _strings = __webpack_require__(15);
	
	var _styles = __webpack_require__(18);
	
	var _constants = __webpack_require__(17);
	
	var _chat = __webpack_require__(67);
	
	var _props = __webpack_require__(41);
	
	var _ids = __webpack_require__(46);
	
	var _styles2 = __webpack_require__(2244);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportMenu = function ReportMenu(_ref) {
	  var type = _ref.type,
	      appliedActions = _ref.appliedActions,
	      formatMessage = _ref.formatMessage,
	      id = _ref.id,
	      onResolve = _ref.onResolve;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isMessageFieldOpened = _useState2[0],
	      openMessageField = _useState2[1];
	
	  var checkStatus = function checkStatus(buttonAction) {
	    return appliedActions.map(function (action) {
	      return (0, _get2.default)(action, 'actionName');
	    }, null).includes(buttonAction);
	  };
	
	  var getCard = function getCard(text, icon, applied) {
	    return _react2.default.createElement(_Card2.default, {
	      text: { primary: text },
	      additionalContent: {
	        left: _react2.default.createElement(_Icon2.default, {
	          className: 'db mb1',
	          name: icon,
	          style: { fill: _styles.COLORS.bluePrimary }
	        }),
	        right: applied ? _react2.default.createElement(_Icon2.default, {
	          className: 'db mb1',
	          name: 'check',
	          style: { fill: _styles.COLORS.greenLime }
	        }) : null
	      }
	    });
	  };
	
	  var handleResolveActions = function handleResolveActions(actionType, message) {
	    var data = {
	      apply_action: actionType,
	      text_message: message,
	      id: id
	    };
	    onResolve(data);
	  };
	
	  return _react2.default.createElement(
	    'ul',
	    { styleName: 'menu' },
	    _chat.ALLOW_SOCIAL_CHAT_CREATION ? [_react2.default.createElement(
	      'li',
	      {
	        id: _ids.IDS.REPORTS.SEND_MESSAGE_OPTION,
	        styleName: 'item',
	        onClick: function onClick() {
	          return openMessageField(!isMessageFieldOpened);
	        },
	        key: '0'
	      },
	      getCard(formatMessage(_strings.ACTIONS.chat.sendMessage), 'comment', checkStatus(_props.COMPLAINT_RESOLVE_ACTIONS.SEND_MESSAGE))
	    ), isMessageFieldOpened ? _react2.default.createElement(_TextMessageForm2.default, {
	      onSendMessage: function onSendMessage(message) {
	        return handleResolveActions(_props.COMPLAINT_RESOLVE_ACTIONS.SEND_MESSAGE, message);
	      },
	      formatMessage: formatMessage,
	      onClose: function onClose() {
	        return openMessageField(false);
	      },
	      key: '1'
	    }) : null] : null,
	    type !== _constants.COMPLAINT_TYPE.COMMUNITY ? [_react2.default.createElement(
	      'li',
	      {
	        styleName: (0, _classnames2.default)('item', {
	          'item--disabled': checkStatus(_props.COMPLAINT_RESOLVE_ACTIONS.REMOVE_AUTHOR)
	        }),
	        onClick: function onClick() {
	          return handleResolveActions(_props.COMPLAINT_RESOLVE_ACTIONS.REMOVE_AUTHOR);
	        },
	        id: _ids.IDS.REPORTS.REMOVE_AUTHOR_OPTION,
	        key: '0'
	      },
	      getCard(formatMessage({
	        id: 'community.menu.removeMemberFromCommunity'
	      }), 'remove-from-community', checkStatus(_props.COMPLAINT_RESOLVE_ACTIONS.REMOVE_AUTHOR))
	    ), _react2.default.createElement(
	      'li',
	      {
	        styleName: (0, _classnames2.default)('item', {
	          'item--disabled': checkStatus(_props.COMPLAINT_RESOLVE_ACTIONS.DESTROY_REPORTABLE)
	        }),
	        onClick: function onClick() {
	          return handleResolveActions(_props.COMPLAINT_RESOLVE_ACTIONS.DESTROY_REPORTABLE);
	        },
	        id: _ids.IDS.REPORTS.DESTROY_REPORTABLE_OPTION,
	        key: '1'
	      },
	      getCard(formatMessage({
	        id: type === _constants.COMPLAINT_TYPE.POST ? 'community.postMenu.deletePost' : 'community.commentMenu.deleteComment'
	      }), 'remove', checkStatus(_props.COMPLAINT_RESOLVE_ACTIONS.DESTROY_REPORTABLE))
	    )] : null
	  );
	};
	
	ReportMenu.propTypes = {
	  type: _propTypes2.default.string,
	  id: _propTypes2.default.number,
	  appliedActions: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  onResolve: _propTypes2.default.func
	};
	
	exports.default = (0, _reactCssModules2.default)(ReportMenu, _styles3.default, { allowMultiple: true });

/***/ }),
/* 3170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ReportInfoRow = __webpack_require__(1731);
	
	var _ReportPreview = __webpack_require__(3172);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TimeShow = __webpack_require__(399);
	
	var _ReportMenu = __webpack_require__(3169);
	
	var _ReportMenu2 = _interopRequireDefault(_ReportMenu);
	
	var _constants = __webpack_require__(17);
	
	var _ids = __webpack_require__(46);
	
	var _routes = __webpack_require__(37);
	
	var _props = __webpack_require__(41);
	
	var _styles = __webpack_require__(2244);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportDetails = function ReportDetails(_ref) {
	  var _ref$report = _ref.report;
	  _ref$report = _ref$report === undefined ? {} : _ref$report;
	  var id = _ref$report.id,
	      realm = _ref$report.realm,
	      reportable = _ref$report.reportable,
	      reason = _ref$report.reason,
	      createdAt = _ref$report.createdAt,
	      type = _ref$report.type,
	      status = _ref$report.status,
	      reporter = _ref$report.reporter,
	      appliedActions = _ref$report.appliedActions,
	      onResolve = _ref.onResolve,
	      loading = _ref.loading,
	      formatMessage = _ref.intl.formatMessage;
	
	  var hasAppliedActions = Boolean(appliedActions);
	  var menuProps = {
	    id: id,
	    formatMessage: formatMessage,
	    onResolve: onResolve,
	    type: type,
	    appliedActions: appliedActions || []
	  };
	
	  var getSubtitle = function getSubtitle() {
	    if (type === _constants.COMPLAINT_TYPE.POST || type === _constants.COMPLAINT_TYPE.COMMENT) {
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            styleName: 'link',
	            to: '/' + _routes.PUBLIC_PROFILE + '/' + (0, _get2.default)(reporter, 'id')
	          },
	          (0, _get2.default)(reporter, 'username')
	        ),
	        '\xA0reported\xA0',
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            styleName: 'link',
	            to: '/' + _routes.PUBLIC_PROFILE + '/' + (0, _get2.default)(reportable, 'author.user.id')
	          },
	          (0, _get2.default)(reportable, 'author.user.aliasName')
	        ),
	        '\'s\xA0 ',
	        type
	      );
	    }
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        { styleName: 'link', to: '/' + _routes.PUBLIC_PROFILE + '/' + (0, _get2.default)(reporter, 'id') },
	        (0, _get2.default)(reporter, 'username')
	      ),
	      _react2.default.createElement(
	        _Link2.default,
	        { to: '/' + _routes.COMMUNITIES + '/' + (0, _get2.default)(realm, 'id') },
	        '\xA0',
	        formatMessage({ id: 'community.reports.reported' })
	      )
	    );
	  };
	
	  var getHistory = function getHistory() {
	    return appliedActions.map(function (action) {
	      var isPost = type === _constants.COMPLAINT_TYPE.POST;
	      var actionName = (0, _get2.default)(action, 'actionName');
	      var isDestroyReportable = actionName === _props.COMPLAINT_RESOLVE_ACTIONS.DESTROY_REPORTABLE;
	
	      return _react2.default.createElement(
	        'li',
	        { styleName: 'history-item', key: action.appliedAt },
	        _react2.default.createElement(
	          'div',
	          null,
	          isDestroyReportable ? _react2.default.createElement(
	            'p',
	            { styleName: 'history-item__text' },
	            formatMessage({
	              id: isPost ? 'reports.post.type' : 'reports.comment.type'
	            }),
	            '\xA0'
	          ) : null,
	          formatMessage({ id: _props.COMPLAINT_RESOLVED_TITLES[actionName] })
	        ),
	        _react2.default.createElement(_TimeShow.TimeShow, { timestamp: action.appliedAt, hideIcon: true })
	      );
	    });
	  };
	
	  var handleResolve = function handleResolve() {
	    var data = (0, _extends3.default)({
	      id: id,
	      mark_as_resolved: 'yes'
	    }, !hasAppliedActions && { apply_action: 'resolve_with_no_actions' });
	    return onResolve(data, true);
	  };
	
	  if (loading) {
	    return _react2.default.createElement(_Loader2.default, { style: { minWidth: 460 } });
	  }
	
	  var getPreviewLink = function getPreviewLink() {
	    var param = type === _constants.COMPLAINT_TYPE.COMMENT ? 'postId' : 'id';
	    var postId = (0, _get2.default)(reportable, param);
	    var communityId = (0, _get2.default)(realm, 'id');
	    return '/' + _routes.COMMUNITIES + '/' + communityId + '/' + _routes.POST + '/' + postId;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'card' },
	      _react2.default.createElement(_Avatar2.default, {
	        src: (0, _get2.default)(realm, 'logo.thumbMin'),
	        children: (0, _get2.default)(realm, 'name'),
	        size: 60,
	        bordered: true,
	        position: 'center'
	      }),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'title' },
	        _react2.default.createElement(
	          'span',
	          { styleName: 'title__text' },
	          (0, _get2.default)(realm, 'name')
	        ),
	        _react2.default.createElement(
	          'span',
	          { styleName: 'title__text-secondary' },
	          getSubtitle()
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'info' },
	      _react2.default.createElement(_ReportInfoRow.ReportInfo, {
	        formatMessage: formatMessage,
	        type: type,
	        status: status,
	        reason: reason,
	        createdAt: createdAt,
	        column: true,
	        showTimerTitle: true
	      })
	    ),
	    type !== _constants.COMPLAINT_TYPE.COMMUNITY ? _react2.default.createElement(_ReportPreview.ReportPreview, (0, _extends3.default)({}, reportable, { type: type, path: getPreviewLink() })) : null,
	    status !== 'resolved' ? [_react2.default.createElement(_ReportMenu2.default, (0, _extends3.default)({}, menuProps, {
	      key: '0'
	    })), _react2.default.createElement(
	      'div',
	      { className: 'ml2 mt2', key: '1'
	      },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: _ids.IDS.REPORTS.RESOLVE_BTN,
	          className: 'mt2 w-20',
	          color: 'primary',
	          onClick: handleResolve
	        },
	        formatMessage({ id: 'common.resolve' })
	      )
	    )] : hasAppliedActions ? _react2.default.createElement(
	      'div',
	      { styleName: 'history' },
	      _react2.default.createElement(
	        'p',
	        { styleName: 'history-title' },
	        formatMessage({ id: 'reports.history' })
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        getHistory()
	      )
	    ) : null
	  );
	};
	
	ReportDetails.propTypes = {
	  report: _propTypes2.default.object,
	  loading: _propTypes2.default.bool.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  onResolve: _propTypes2.default.func.isRequired
	};
	
	ReportDetails.defaultProps = {
	  report: {}
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }))(ReportDetails);

/***/ }),
/* 3171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReportItem = exports.ReportItemImpl = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _translationsByType;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _routes = __webpack_require__(37);
	
	var _CommunityCard = __webpack_require__(606);
	
	var _constants = __webpack_require__(17);
	
	var _ReportInfoRow = __webpack_require__(1731);
	
	var _ids = __webpack_require__(46);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styles = __webpack_require__(4933);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var translationsByType = (_translationsByType = {}, (0, _defineProperty3.default)(_translationsByType, _constants.COMPLAINT_TYPE.COMMUNITY, 'reports.community.info'), (0, _defineProperty3.default)(_translationsByType, _constants.COMPLAINT_TYPE.COMMENT, 'reports.comment.info'), (0, _defineProperty3.default)(_translationsByType, _constants.COMPLAINT_TYPE.POST, 'reports.post.info'), _translationsByType);
	
	var ReportItemImpl = exports.ReportItemImpl = function ReportItemImpl(_ref) {
	  var formatMessage = _ref.formatMessage,
	      _ref$item = _ref.item;
	  _ref$item = _ref$item === undefined ? {} : _ref$item;
	  var _ref$item$realm = _ref$item.realm;
	  _ref$item$realm = _ref$item$realm === undefined ? {} : _ref$item$realm;
	  var logo = _ref$item$realm.logo,
	      name = _ref$item$realm.name,
	      id = _ref$item$realm.id,
	      _ref$item$reporter = _ref$item.reporter,
	      username = _ref$item$reporter.username,
	      reporterId = _ref$item$reporter.id,
	      _ref$item$reportable = _ref$item.reportable,
	      reportable = _ref$item$reportable === undefined ? {} : _ref$item$reportable,
	      _ref$item$reason = _ref$item.reason,
	      reason = _ref$item$reason === undefined ? {} : _ref$item$reason,
	      createdAt = _ref$item.createdAt,
	      type = _ref$item.type,
	      status = _ref$item.status,
	      onClick = _ref.onClick;
	
	  var _ref2 = reportable || {},
	      author = _ref2.author;
	
	  var contentMessage = function contentMessage() {
	    switch (type) {
	      case _constants.COMPLAINT_TYPE.COMMENT:
	      case _constants.COMPLAINT_TYPE.POST:
	        {
	          var authorName = (0, _get2.default)(author, 'user.aliasName');
	          var userId = (0, _get2.default)(author, 'user.id');
	          var community = _react2.default.createElement(
	            _Link2.default,
	            { to: '/' + _routes.COMMUNITIES + '/' + id },
	            name
	          );
	          var user = _react2.default.createElement(
	            _Link2.default,
	            { to: '/' + _routes.PUBLIC_PROFILE + '/' + userId },
	            authorName
	          );
	
	          return _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: translationsByType[type],
	            values: { user: user, community: community }
	          });
	        }
	
	      case _constants.COMPLAINT_TYPE.COMMUNITY:
	        {
	          return _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'reports.community.info',
	            values: {
	              user: _react2.default.createElement(
	                _Link2.default,
	                { to: '/' + _routes.PUBLIC_PROFILE + '/' + reporterId },
	                username
	              )
	            }
	          });
	        }
	    }
	  };
	
	  return _react2.default.createElement(_CommunityCard.CommunityCard, {
	    avatar: {
	      src: (0, _get2.default)(logo, 'thumbMin'),
	      size: 80,
	      name: name
	    },
	    renderTitle: function renderTitle() {
	      return name;
	    },
	    renderContent: function renderContent() {
	      return contentMessage();
	    },
	    renderActions: function renderActions() {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          id: _ids.IDS.REPORTS.SEE_DETAILS_BTN,
	          onClick: onClick,
	          color: 'accent',
	          border: true
	        },
	        formatMessage({ id: 'reports.seeDetails' })
	      );
	    },
	    renderInfo: function renderInfo() {
	      return _react2.default.createElement(_ReportInfoRow.ReportInfo, {
	        formatMessage: formatMessage,
	        type: type,
	        status: status,
	        createdAt: createdAt,
	        reason: reason,
	        showDangerTitle: true
	      });
	    }
	  });
	};
	
	var ReportItem = exports.ReportItem = (0, _recompose.compose)((0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }))(ReportItemImpl);
	var propTypes = {
	  item: _propTypes2.default.object.isRequired,
	  formatMessage: _propTypes2.default.func.isRequired
	};
	ReportItemImpl.propTypes = (0, _extends3.default)({}, ReportItemImpl);
	ReportItem.propTypes = propTypes;

/***/ }),
/* 3172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReportPreview = exports.ReportPreviewImpl = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _lodash = __webpack_require__(58);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _constants = __webpack_require__(17);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Header = __webpack_require__(1782);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Heading = __webpack_require__(1726);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _styles = __webpack_require__(4934);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Body = __webpack_require__(1781);
	
	var _Body2 = _interopRequireDefault(_Body);
	
	var _Image = __webpack_require__(1783);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Video = __webpack_require__(1784);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _UrlPreview = __webpack_require__(1099);
	
	var _UrlPreview2 = _interopRequireDefault(_UrlPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportPreviewImpl = exports.ReportPreviewImpl = function ReportPreviewImpl(_ref) {
	  var attachment = _ref.attachment,
	      author = _ref.author,
	      createdAt = _ref.createdAt,
	      updated = _ref.updated,
	      content = _ref.content,
	      comments = _ref.comments,
	      type = _ref.type,
	      path = _ref.path;
	
	  var isPost = type === _constants.COMPLAINT_TYPE.POST;
	  var images = (0, _lodash.get)(attachment, 'files');
	  var link = (0, _lodash.get)(attachment, 'urlPreview');
	
	  var aliasName = (0, _lodash.get)(author, 'user.aliasName');
	
	  var getHeader = function getHeader() {
	    if (isPost) {
	      return _react2.default.createElement(_Header2.default, { author: author, createdAt: createdAt, updated: updated });
	    }
	
	    return _react2.default.createElement(_Heading2.default, {
	      userName: aliasName,
	      comments: comments,
	      createdAt: createdAt,
	      updated: updated
	    });
	  };
	  var header = getHeader();
	  return _react2.default.createElement(
	    _Link2.default,
	    { to: path, styleName: 'root' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'grid' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'avatar' },
	        _react2.default.createElement(_Avatar2.default, {
	          children: aliasName,
	          size: 40,
	          src: (0, _lodash.get)(author, 'user.avatar.thumbMin')
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'content' },
	        header
	      )
	    ),
	    content ? _react2.default.createElement(_Body2.default, (0, _extends3.default)({ content: content }, { className: 'pl0 mt2 mb2' })) : null,
	    (0, _lodash.size)(images) ? _react2.default.createElement(
	      'div',
	      { styleName: 'images' },
	      images.map(function (image) {
	        return _react2.default.createElement(
	          'div',
	          { styleName: 'images-item', key: image.index },
	          _react2.default.createElement(_Image2.default, {
	            image: image,
	            key: image.index,
	            relative: true,
	            className: 'lazy-image-wrapper'
	          })
	        );
	      })
	    ) : null,
	    (0, _lodash.get)(link, 'url') ? link.video && link.video !== 'null' ? _react2.default.createElement(_Video2.default, { src: link.video }) : _react2.default.createElement(_UrlPreview2.default, (0, _extends3.default)({}, link, { readonly: true })) : null
	  );
	};
	
	var ReportPreview = exports.ReportPreview = (0, _recompose.compose)((0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }))(ReportPreviewImpl);
	
	var propTypes = {
	  attachment: _propTypes2.default.object,
	  comments: _propTypes2.default.array,
	  author: _propTypes2.default.object.isRequired,
	  createdAt: _propTypes2.default.string.isRequired,
	  updated: _propTypes2.default.bool.isRequired,
	  content: _propTypes2.default.string.isRequired,
	  type: _propTypes2.default.string.isRequired,
	  path: _propTypes2.default.string.isRequired
	};
	var defaultProps = {
	  comments: [],
	  attachment: null
	};
	ReportPreviewImpl.propTypes = propTypes;
	ReportPreviewImpl.defaultProps = defaultProps;
	ReportPreview.propTypes = propTypes;

/***/ }),
/* 3173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _styles = __webpack_require__(4935);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _complaintDetails = __webpack_require__(831);
	
	var complaintDetails = _interopRequireWildcard(_complaintDetails);
	
	var _resolveComplaint = __webpack_require__(655);
	
	var resolveComplaint = _interopRequireWildcard(_resolveComplaint);
	
	var _selectors = __webpack_require__(656);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loading: (0, _selectors.selectComplaintDetailsLoading)(state),
	    details: (0, _selectors.selectComplaintDetails)(state),
	    resolveLoading: (0, _selectors.selectResolveComplaintLoading)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchComplaint: complaintDetails.actions.send,
	  resetDetails: complaintDetails.actions.reset,
	  resolve: resolveComplaint.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReportsList = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateConverters = __webpack_require__(83);
	
	var _MessageSeparatorView = __webpack_require__(763);
	
	var _MessageSeparatorView2 = _interopRequireDefault(_MessageSeparatorView);
	
	var _ReportItem = __webpack_require__(3171);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _ReportDetails = __webpack_require__(3170);
	
	var _ReportDetails2 = _interopRequireDefault(_ReportDetails);
	
	var _enhance = __webpack_require__(3173);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _mobileHelpers = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportsListImpl = function ReportsListImpl(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      fetchComplaint = _ref.fetchComplaint,
	      resetDetails = _ref.resetDetails,
	      resolveLoading = _ref.resolveLoading,
	      details = _ref.details,
	      loading = _ref.loading,
	      resolve = _ref.resolve,
	      list = _ref.list;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isShowPopup = _useState2[0],
	      togglePopup = _useState2[1];
	
	  var openDetailsModal = (0, _react.useCallback)(function (id) {
	    fetchComplaint({ id: id });
	    togglePopup(true);
	  }, []);
	
	  var closeDetailsModal = (0, _react.useCallback)(function () {
	    togglePopup(false);
	    resetDetails();
	  }, []);
	
	  var handleResolve = (0, _react.useCallback)(function (data, closeModal) {
	    resolve(data);
	    return closeModal && closeDetailsModal();
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    resolveLoading && _react2.default.createElement(_Loader2.default, { styleName: 'loading' }),
	    list.map(function (item, index) {
	      var isNewDay = (0, _dateConverters.isNewDayInList)(list, index);
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        { key: item.id },
	        isNewDay && _react2.default.createElement(_MessageSeparatorView2.default, {
	          date: (0, _dateConverters.adaptDateToLocalTimezone)(item.createdAt),
	          hasBorder: true,
	          left: true
	        }),
	        _react2.default.createElement(_ReportItem.ReportItem, {
	          item: item,
	          onClick: function onClick() {
	            return openDetailsModal(item.id);
	          },
	          formatMessage: formatMessage
	        })
	      );
	    }),
	    _react2.default.createElement(
	      _Popup2.default,
	      {
	        onClose: closeDetailsModal,
	        opened: isShowPopup,
	        width: (0, _mobileHelpers.isDesktop)() ? 'postCommunity' : 'medium',
	        title: formatMessage({ id: 'reports.details' })
	      },
	      _react2.default.createElement(_ReportDetails2.default, {
	        report: details,
	        loading: loading,
	        onResolve: handleResolve
	      })
	    )
	  );
	};
	
	var ReportsList = exports.ReportsList = (0, _enhance.enhance)(ReportsListImpl);
	
	var propTypes = {
	  list: _propTypes2.default.array.isRequired
	};
	ReportsListImpl.propTypes = (0, _extends3.default)({
	  details: _propTypes2.default.object.isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  resolveLoading: _propTypes2.default.bool.isRequired,
	  resolve: _propTypes2.default.func.isRequired
	}, propTypes);
	ReportsList.propTypes = propTypes;

/***/ }),
/* 3175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _index = __webpack_require__(374);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _selectors = __webpack_require__(656);
	
	var _complaintResolvedList = __webpack_require__(522);
	
	var _complaintUnResolvedList = __webpack_require__(346);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    resolvedList: (0, _selectors.selectResolvedList)(state),
	    unresolvedList: (0, _selectors.selectUnResolvedList)(state),
	    loading: (0, _selectors.selectComplaintsLoading)(state),
	    unresolvedCounter: (0, _selectors.makeSelectComplaintsCounter)('unresolved')(state),
	    resolvedCounter: (0, _selectors.makeSelectComplaintsCounter)('resolved')(state)
	  };
	};
	var mapDispatchToProps = {
	  fetchResolvedList: _complaintResolvedList.actions.send,
	  fetchUnresolvedList: _complaintUnResolvedList.actions.send,
	  loadMoreResolved: _complaintResolvedList.actions.loadMore,
	  loadMoreUnresolved: _complaintUnResolvedList.actions.loadMore
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Reports = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _CommonTabs = __webpack_require__(255);
	
	var _ReportsList = __webpack_require__(3174);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _enhance = __webpack_require__(3175);
	
	var _ids = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB_KEYS = {
	  UNRESOLVED: 'unresolved',
	  RESOLVED: 'resolved'
	};
	
	var ReportsImpl = function ReportsImpl(_ref) {
	  var unresolvedCounter = _ref.unresolvedCounter,
	      resolvedCounter = _ref.resolvedCounter,
	      unresolvedList = _ref.unresolvedList,
	      resolvedList = _ref.resolvedList,
	      fetchResolvedList = _ref.fetchResolvedList,
	      fetchUnresolvedList = _ref.fetchUnresolvedList,
	      loadMoreResolved = _ref.loadMoreResolved,
	      loadMoreUnresolved = _ref.loadMoreUnresolved,
	      loading = _ref.loading,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(TAB_KEYS.UNRESOLVED),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  var getList = useReportListByTab(unresolvedList, resolvedList);
	  var tabs = useTabs(unresolvedCounter, resolvedCounter);
	  var rootRef = (0, _react.useRef)();
	  var loadMore = (0, _react.useCallback)(function () {
	    if (activeTab === TAB_KEYS.UNRESOLVED) loadMoreUnresolved();
	    if (activeTab === TAB_KEYS.RESOLVED) loadMoreResolved();
	  }, [activeTab]);
	
	  (0, _useLazyLoad.useLazyLoad)({ node: rootRef, loadMore: loadMore, path: ['parentNode'] });
	  var isEmpty = !unresolvedCounter && !resolvedCounter;
	
	  (0, _react.useEffect)(function () {
	    fetchResolvedList({
	      status: 'resolved',
	      limit: 10,
	      offset: 0
	    });
	    fetchUnresolvedList({
	      status: 'unresolved',
	      limit: 10,
	      offset: 0
	    });
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (!unresolvedCounter && resolvedCounter) {
	      setActiveTab(TAB_KEYS.RESOLVED);
	    }
	  }, [unresolvedCounter, resolvedCounter]);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'wrapper', ref: rootRef },
	    loading && _react2.default.createElement(_Loader2.default, null),
	    !loading && !isEmpty && _react2.default.createElement(_CommonTabs.CommonTabs, {
	      onTabSelect: setActiveTab,
	      activeTab: activeTab,
	      tabList: tabs,
	      renderContent: function renderContent(tab) {
	        return _react2.default.createElement(_ReportsList.ReportsList, { list: getList(tab) });
	      }
	    }),
	    !loading && isEmpty && _react2.default.createElement(
	      'div',
	      { styleName: 'empty-state' },
	      _react2.default.createElement(_Content2.default, {
	        text: formatMessage({ id: 'reports.emptyMessage' }),
	        icon: 'icon-megaphone'
	      })
	    )
	  );
	};
	
	var Reports = exports.Reports = (0, _enhance.enhance)(ReportsImpl);
	
	ReportsImpl.propTypes = {
	  unresolvedList: _propTypes2.default.array,
	  resolvedList: _propTypes2.default.array,
	  unresolvedCounter: _propTypes2.default.number,
	  resolvedCounter: _propTypes2.default.number,
	  fetchUnresolvedList: _propTypes2.default.func.isRequired,
	  fetchResolvedList: _propTypes2.default.func.isRequired,
	  loadMoreUnresolved: _propTypes2.default.func.isRequired,
	  loadMoreResolved: _propTypes2.default.func.isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  intl: _propTypes2.default.object.isRequired
	};
	
	ReportsImpl.defaultProps = {
	  unresolvedList: [],
	  resolvedList: [],
	  unresolvedCounter: 0,
	  resolvedCounter: 0
	};
	
	function useTabs(unresolvedCounter, resolvedCounter) {
	  return (0, _react.useMemo)(function () {
	    var tabs = [];
	    if (unresolvedCounter) tabs.push({
	      label: 'community.reports.unresolved',
	      id: _ids.IDS.REPORTS_TABS.UNRESOLVED,
	      tab: TAB_KEYS.UNRESOLVED,
	      counter: unresolvedCounter
	    });
	
	    if (resolvedCounter) tabs.push({
	      label: 'community.reports.resolved',
	      id: _ids.IDS.REPORTS_TABS.RESOLVED,
	      tab: TAB_KEYS.RESOLVED,
	      counter: resolvedCounter
	    });
	    return tabs;
	  }, [unresolvedCounter, resolvedCounter]);
	}
	
	function useReportListByTab(unresolvedList, resolvedList) {
	  return (0, _react.useCallback)(function (tab) {
	    switch (tab) {
	      case TAB_KEYS.RESOLVED:
	        return resolvedList;
	      case TAB_KEYS.UNRESOLVED:
	        return unresolvedList;
	      default:
	        return [];
	    }
	  }, [unresolvedList, resolvedList]);
	}

/***/ }),
/* 3177 */,
/* 3178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(718);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _styles = __webpack_require__(18);
	
	var _ReadMoreBtn = __webpack_require__(1194);
	
	var _ReadMoreBtn2 = _interopRequireDefault(_ReadMoreBtn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Description = function Description(_ref) {
	  var text = _ref.text;
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      shortened = _useState2[0],
	      setShortened = _useState2[1];
	
	  var isTooLong = text.length > _styles.DESCRIPTION_MAX_SYMBOLS;
	
	  var textTransform = function textTransform(string) {
	    return string.slice(0, _styles.DESCRIPTION_MAX_SYMBOLS).replace(/([^ ]*)$/, '');
	  };
	
	  var rootText = shortened && isTooLong ? textTransform(text) : text;
	
	  var handleClick = function handleClick() {
	    setShortened(!shortened);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'description' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'description__text' },
	      _react2.default.createElement(
	        'p',
	        null,
	        rootText
	      )
	    ),
	    shortened && isTooLong ? _react2.default.createElement(
	      'div',
	      { styleName: 'description__button' },
	      _react2.default.createElement(_ReadMoreBtn2.default, { onClick: handleClick })
	    ) : null
	  );
	};
	
	Description.propTypes = {
	  text: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _recompose.compose)((0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(Description);

/***/ }),
/* 3179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _index = __webpack_require__(718);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _selectors = __webpack_require__(1733);
	
	var _selectors2 = __webpack_require__(151);
	
	var _communityMembers = __webpack_require__(516);
	
	var _communityModerators = __webpack_require__(517);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchMoreMembers: function fetchMoreMembers(communityId) {
	      return dispatch(_communityMembers.actions.getOlderMembers({ communityId: communityId }));
	    },
	    fetchMoreModerators: function fetchMoreModerators(communityId) {
	      return dispatch(_communityModerators.actions.getOlderModerators({ communityId: communityId }));
	    }
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    membersList: (0, _selectors.membersListSelector)(state),
	    moderatorsList: (0, _selectors.moderatorsListSelector)(state),
	    communityId: (0, _selectors2.currentCommunityIdSelector)(state),
	    membersCount: (0, _selectors.membersCountSelector)(state),
	    moderatorsCount: (0, _selectors.moderatorsCountSelector)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var membersList = _ref.membersList,
	      moderatorsList = _ref.moderatorsList,
	      membersCount = _ref.membersCount,
	      moderatorsCount = _ref.moderatorsCount,
	      listType = _ref.listType;
	
	  return {
	    isListTypeMembers: listType === _constants.COMMUNITIES_USER_ROLES.MEMBER,
	    shouldLoadMoreMembers: Boolean(membersList.length && membersCount > membersList.length),
	    shouldLoadMoreModerators: Boolean(moderatorsList.length && moderatorsCount > moderatorsList.length)
	  };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhance = __webpack_require__(3179);
	
	var _ListItem = __webpack_require__(1732);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _useLazyLoad = __webpack_require__(197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullList = function FullList(_ref) {
	  var items = _ref.items,
	      isMobile = _ref.isMobile,
	      onListItemMenuClick = _ref.onListItemMenuClick,
	      communityId = _ref.communityId,
	      shouldLoadMoreMembers = _ref.shouldLoadMoreMembers,
	      shouldLoadMoreModerators = _ref.shouldLoadMoreModerators,
	      fetchMoreMembers = _ref.fetchMoreMembers,
	      fetchMoreModerators = _ref.fetchMoreModerators,
	      isListTypeMembers = _ref.isListTypeMembers,
	      loggedUserId = _ref.loggedUserId,
	      listType = _ref.listType,
	      showMenu = _ref.showMenu;
	
	  var rootRef = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      setLoaded = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    setLoaded(true);
	  }, []);
	
	  var handleLoadMore = function handleLoadMore() {
	    if (isListTypeMembers) {
	      fetchMoreMembers(communityId);
	      return;
	    }
	
	    fetchMoreModerators(communityId);
	  };
	
	  var loadMore = (0, _react.useCallback)(function () {
	    var shouldLoadMore = isListTypeMembers ? shouldLoadMoreMembers : shouldLoadMoreModerators;
	    if (shouldLoadMore) {
	      handleLoadMore();
	    }
	  }, [shouldLoadMoreMembers, shouldLoadMoreModerators]);
	
	  (0, _useLazyLoad.useLazyLoad)({
	    node: rootRef,
	    path: ['parentNode'],
	    loadMore: loadMore
	  });
	
	  return _react2.default.createElement(
	    'div',
	    {
	      ref: rootRef,
	      className: 'full-list-modal',
	      styleName: (0, _classnames2.default)('full-list', {
	        'full-list-mobile': isMobile
	      })
	    },
	    _react2.default.createElement(
	      'ul',
	      null,
	      items.map(function (item) {
	        return _react2.default.createElement(
	          'li',
	          { key: item.id, styleName: 'full-list__item' },
	          _react2.default.createElement(_ListItem2.default, {
	            type: listType,
	            item: item,
	            avatarSize: 32,
	            showMenu: showMenu,
	            onClick: onListItemMenuClick,
	            loggedUserId: loggedUserId
	          })
	        );
	      })
	    )
	  );
	};
	
	FullList.propTypes = {
	  showMenu: _propTypes2.default.bool,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  isMobile: _propTypes2.default.bool.isRequired,
	  onListItemMenuClick: _propTypes2.default.func.isRequired,
	  communityId: _propTypes2.default.number.isRequired,
	  shouldLoadMoreMembers: _propTypes2.default.bool.isRequired,
	  shouldLoadMoreModerators: _propTypes2.default.bool.isRequired,
	  fetchMoreMembers: _propTypes2.default.func.isRequired,
	  fetchMoreModerators: _propTypes2.default.func.isRequired,
	  isListTypeMembers: _propTypes2.default.bool.isRequired,
	  loggedUserId: _propTypes2.default.number.isRequired,
	  listType: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(FullList);

/***/ }),
/* 3181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _strings = __webpack_require__(15);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _constants = __webpack_require__(17);
	
	var _ids = __webpack_require__(46);
	
	var _ListItem = __webpack_require__(1732);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _index = __webpack_require__(718);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function List(_ref) {
	  var items = _ref.items,
	      title = _ref.title,
	      showMenu = _ref.showMenu,
	      formatMessage = _ref.intl.formatMessage,
	      limitList = _ref.limitList,
	      onListItemMenuClick = _ref.onListItemMenuClick,
	      onSeeAll = _ref.onSeeAll,
	      loggedUserId = _ref.loggedUserId,
	      type = _ref.type;
	
	  // show short or full list
	  var currentList = limitList ? items.slice(0, limitList) : items;
	  var isShowSeeAllBtn = limitList && limitList < items.length - 1;
	  var seeAllID = type === _constants.COMMUNITIES_USER_ROLES.MODERATOR ? _ids.IDS.COMMUNITY.SEE_ALL_MODERATORS : _ids.IDS.COMMUNITY.SEE_ALL_MEMBERS;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'list' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'list__header' },
	      _react2.default.createElement('p', { children: title }),
	      isShowSeeAllBtn ? _react2.default.createElement(
	        _ClickableElement2.default,
	        { onClick: onSeeAll, id: seeAllID },
	        _react2.default.createElement(
	          'span',
	          null,
	          formatMessage(_strings.COMMUNITIES_COMMON.seeAll)
	        )
	      ) : null
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      currentList.map(function (item) {
	        return _react2.default.createElement(
	          'li',
	          { key: item.id },
	          _react2.default.createElement(_ListItem2.default, {
	            item: item,
	            avatarSize: 24,
	            isCanBlockUser: true,
	            onClick: onListItemMenuClick,
	            loggedUserId: loggedUserId,
	            type: type,
	            showMenu: showMenu
	          })
	        );
	      })
	    )
	  );
	};
	
	List.propTypes = {
	  items: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  title: _propTypes2.default.string,
	  showMenu: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  limitList: _propTypes2.default.number,
	  onSeeAll: _propTypes2.default.func.isRequired,
	  onListItemMenuClick: _propTypes2.default.func.isRequired,
	  loggedUserId: _propTypes2.default.number.isRequired,
	  type: _propTypes2.default.string.isRequired
	};
	
	List.defaultProps = {
	  title: '',
	  limitList: 0
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(List);

/***/ }),
/* 3182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(1733);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _props = __webpack_require__(41);
	
	var _withPopoverMenu = __webpack_require__(501);
	
	var _withPopoverMenu2 = _interopRequireDefault(_withPopoverMenu);
	
	var _sendMessage2 = __webpack_require__(1254);
	
	var _sendMessage = _interopRequireWildcard(_sendMessage2);
	
	var _communityMembers = __webpack_require__(516);
	
	var _selectors3 = __webpack_require__(151);
	
	var _communityModerators = __webpack_require__(517);
	
	var _removeUserCommunity = __webpack_require__(653);
	
	var _currentCommunity = __webpack_require__(301);
	
	var _index = __webpack_require__(718);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    sendMessage: function sendMessage(message) {
	      return dispatch(_sendMessage.actions.send(message));
	    },
	    fetchMembers: function fetchMembers(communityId) {
	      return dispatch(_communityMembers.actions.getMembers({ communityId: communityId }));
	    },
	    fetchModerators: function fetchModerators(communityId) {
	      return dispatch(_communityModerators.actions.getModerators({ communityId: communityId }));
	    },
	    clearMembers: function clearMembers() {
	      return dispatch(_communityMembers.actions.clearMembers());
	    },
	    clearModerators: function clearModerators() {
	      return dispatch(_communityModerators.actions.clearModerators());
	    },
	    removeUserCommunity: function removeUserCommunity(userType, communityId, memberId) {
	      return dispatch(_removeUserCommunity.actions.send({ userType: userType, communityId: communityId, memberId: memberId }));
	    }
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loggedUserId: (0, _selectors.loggedUserIdSelector)(state),
	    membersList: (0, _selectors2.membersListSelector)(state),
	    moderatorsList: (0, _selectors2.moderatorsListSelector)(state),
	    communityId: (0, _selectors3.currentCommunityIdSelector)(state),
	    isLoggedUserProvider: (0, _selectors.hasProviderProfileSelector)(state),
	    membersCount: (0, _selectors2.membersCountSelector)(state),
	    moderatorsCount: (0, _selectors2.moderatorsCountSelector)(state),
	    isModerator: (0, _currentCommunity.isCurrentCommunityModeratorSelector)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _recompose.branch)(function (_ref) {
	  var community = _ref.community;
	  return !community.id;
	}, (0, _recompose.renderComponent)(_Loader2.default)), _withPopoverMenu2.default, _reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref2) {
	  var membersList = _ref2.membersList,
	      moderatorsList = _ref2.moderatorsList,
	      _ref2$community = _ref2.community,
	      currentUserRole = _ref2$community.currentUserRole,
	      type = _ref2$community.type,
	      moderatorsCount = _ref2.moderatorsCount,
	      membersCount = _ref2.membersCount,
	      formatMessage = _ref2.intl.formatMessage;
	
	  return {
	    shouldLoadMoreMembers: Boolean(membersList.length && membersCount > membersList.length),
	    shouldLoadMoreModerators: Boolean(moderatorsList.length && moderatorsCount > moderatorsList.length),
	    isPublic: type === _props.COMMUNITY_TYPES.public,
	    isMember: Boolean(currentUserRole),
	    formatMessage: formatMessage
	  };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(58);
	
	var _List = __webpack_require__(3181);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _FullList = __webpack_require__(3180);
	
	var _FullList2 = _interopRequireDefault(_FullList);
	
	var _Line = __webpack_require__(3864);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Description = __webpack_require__(3178);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _PopoverMenu = __webpack_require__(398);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	var _styles = __webpack_require__(18);
	
	var _constants = __webpack_require__(17);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _SendMessagePopup = __webpack_require__(3878);
	
	var _SendMessagePopup2 = _interopRequireDefault(_SendMessagePopup);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _chat = __webpack_require__(67);
	
	var _strings = __webpack_require__(15);
	
	var _enhance = __webpack_require__(3182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(_ref) {
	  var community = _ref.community,
	      intl = _ref.intl,
	      loggedUserId = _ref.loggedUserId,
	      membersList = _ref.membersList,
	      moderatorsList = _ref.moderatorsList,
	      isModerator = _ref.isModerator,
	      sendMessage = _ref.sendMessage,
	      isPublic = _ref.isPublic,
	      isMember = _ref.isMember,
	      communityId = _ref.communityId,
	      moderatorsCount = _ref.moderatorsCount,
	      membersCount = _ref.membersCount,
	      clearMembers = _ref.clearMembers,
	      clearModerators = _ref.clearModerators,
	      fetchMembers = _ref.fetchMembers,
	      fetchModerators = _ref.fetchModerators,
	      getMenuItems = _ref.getMenuItems,
	      removeUserCommunity = _ref.removeUserCommunity;
	  var formatMessage = intl.formatMessage;
	  var description = community.description;
	
	
	  (0, _react.useEffect)(function () {
	    clearMembers();
	    clearModerators();
	
	    if (isMember) {
	      if (isPublic || isModerator) fetchMembers(communityId);
	      if (isModerator) fetchModerators(communityId);
	    }
	
	    return function () {
	      clearMembers();
	      clearModerators();
	    };
	  }, [isMember]);
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(false),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      confirmOpened = _useToggleFlag2[0],
	      openConfirm = _useToggleFlag2[1],
	      closeConfirm = _useToggleFlag2[2];
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isOpened = _useState2[0],
	      togglePopup = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(_constants.COMMUNITIES_USER_ROLES.MEMBER),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      listType = _useState4[0],
	      setListType = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      isOpenPopover = _useState6[0],
	      togglePopover = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      anchorListItemMenuEl = _useState8[0],
	      setAnchorListItemMenuEl = _useState8[1];
	
	  var _useState9 = (0, _react.useState)({}),
	      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
	      selectedProfile = _useState10[0],
	      selectProfile = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
	      isOpenSendMessage = _useState12[0],
	      setOpenSendMessage = _useState12[1];
	
	  var moderatorsListTitle = (0, _react.useMemo)(function () {
	    return formatMessage(_strings.COMMUNITY_MODERATORS_LIST, {
	      count: moderatorsCount
	    });
	  }, [moderatorsCount]);
	  var membersTitle = (0, _react.useMemo)(function () {
	    return formatMessage(_strings.COMMUNITY_MEMBERS_LIST, {
	      count: membersCount
	    });
	  }, [membersCount]);
	  var sendMessagePopupTitle = (0, _react.useMemo)(function () {
	    return formatMessage({ id: 'chat.actions.sendMessage' });
	  }, []);
	
	  var hasMembers = membersList.length !== 0;
	  var hasModerators = moderatorsList.length !== 0;
	
	  var totalMembers = (0, _lodash.uniqBy)(membersList, function (item) {
	    return item.id;
	  });
	
	  var isListTypeMembers = listType === _constants.COMMUNITIES_USER_ROLES.MEMBER;
	  var popupTitle = isListTypeMembers ? membersTitle : moderatorsListTitle;
	  var popupItems = isListTypeMembers ? totalMembers : moderatorsList;
	
	  var handleListClick = function handleListClick(type) {
	    togglePopup(true);
	    setListType(type);
	  };
	
	  var handlePopupClose = function handlePopupClose() {
	    togglePopup(false);
	  };
	
	  var handleSendMessage = function handleSendMessage() {
	    togglePopover(false);
	    setOpenSendMessage(true);
	  };
	
	  var handleRemoveUser = function handleRemoveUser() {
	    openConfirm();
	    togglePopover(false);
	  };
	
	  var handleRemovePopoverAction = function handleRemovePopoverAction() {
	    removeUserCommunity(listType, communityId, selectedProfile.id);
	  };
	
	  var handleSubmitSendMessage = function handleSubmitSendMessage(body) {
	    var message = { body: body, recipientId: selectedProfile.id };
	    sendMessage({ message: message });
	  };
	
	  var handleListItemMenuClick = function handleListItemMenuClick(e, profile, type) {
	    e.preventDefault();
	    e.stopPropagation();
	
	    togglePopover(true);
	    selectProfile(profile);
	    setListType(type);
	
	    setAnchorListItemMenuEl(e.currentTarget);
	  };
	
	  var getSendMessageOption = function getSendMessageOption() {
	    if (_chat.ALLOW_SOCIAL_CHAT_CREATION) {
	      return { sendMessage: handleSendMessage };
	    }
	    return {};
	  };
	
	  var getMembersListMenuOptions = function getMembersListMenuOptions() {
	    var options = {};
	    if (isModerator) {
	      options = (0, _extends3.default)({}, options, { removeFromCommunity: handleRemoveUser });
	    }
	    return (0, _extends3.default)({}, options, getSendMessageOption());
	  };
	
	  var memberListOptions = getMembersListMenuOptions();
	
	  var menuItems = isListTypeMembers ? memberListOptions : getSendMessageOption();
	
	  var menu = getMenuItems(menuItems);
	
	  var showMembersListMenu = Boolean(!(0, _lodash.isEmpty)(memberListOptions));
	
	  var popoverMenu = _react2.default.createElement(_PopoverMenu2.default, {
	    size: 'small',
	    isOpen: isOpenPopover,
	    anchorEl: anchorListItemMenuEl,
	    container: (0, _lodash.get)(anchorListItemMenuEl, 'current.parentNode.parentNode'),
	    items: menu,
	    onClose: function onClose() {
	      togglePopover(false);
	    }
	  });
	
	  var popup = _react2.default.createElement(
	    _reactResponsive2.default,
	    { maxWidth: _styles.BREAKPOINT },
	    function (isMobile) {
	      return _react2.default.createElement(
	        _Popup2.default,
	        {
	          onClose: handlePopupClose,
	          title: popupTitle,
	          opened: isOpened,
	          width: isMobile ? 'medium' : 'small',
	          strictClose: isOpenSendMessage || isOpenPopover || confirmOpened
	        },
	        _react2.default.createElement(_FullList2.default, {
	          items: popupItems,
	          isMobile: isMobile,
	          loggedUserId: loggedUserId,
	          onListItemMenuClick: handleListItemMenuClick,
	          listType: listType,
	          showMenu: isListTypeMembers ? showMembersListMenu : _chat.ALLOW_SOCIAL_CHAT_CREATION
	        })
	      );
	    }
	  );
	
	  var handleCloseSendMessage = function handleCloseSendMessage() {
	    setOpenSendMessage(false);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'about' },
	    _react2.default.createElement(_Description2.default, { text: description || 'No description' }),
	    hasModerators ? [_react2.default.createElement(_Line2.default, {
	      key: '0'
	    }), _react2.default.createElement(_List2.default, {
	      items: moderatorsList,
	      showMenu: _chat.ALLOW_SOCIAL_CHAT_CREATION,
	      title: moderatorsListTitle.toUpperCase(),
	      loggedUserId: loggedUserId,
	      limitList: 7,
	      onListItemMenuClick: handleListItemMenuClick,
	      type: _constants.COMMUNITIES_USER_ROLES.MODERATOR,
	      onSeeAll: function onSeeAll() {
	        handleListClick(_constants.COMMUNITIES_USER_ROLES.MODERATOR);
	      },
	      key: '1'
	    })] : null,
	    hasMembers ? [_react2.default.createElement(_Line2.default, {
	      key: '0'
	    }), _react2.default.createElement(_List2.default, {
	      items: totalMembers,
	      showMenu: showMembersListMenu,
	      title: membersTitle.toUpperCase(),
	      loggedUserId: loggedUserId,
	      limitList: 7,
	      type: _constants.COMMUNITIES_USER_ROLES.MEMBER,
	      onListItemMenuClick: handleListItemMenuClick,
	      onSeeAll: function onSeeAll() {
	        handleListClick(_constants.COMMUNITIES_USER_ROLES.MEMBER);
	      },
	      key: '1'
	    })] : null,
	    _react2.default.createElement(_ActionConfirmation2.default, {
	      intl: intl,
	      onClose: closeConfirm,
	      onSubmit: handleRemovePopoverAction,
	      opened: confirmOpened,
	      title: formatMessage({ id: 'community.menu.removeMember' }),
	      body: formatMessage({ id: 'community.menu.removeMemberMessage' }),
	      actionButtonText: formatMessage({ id: 'common.remove' }),
	      width: 'xsmall'
	    }),
	    isOpenSendMessage && _react2.default.createElement(_SendMessagePopup2.default, {
	      opened: true,
	      title: sendMessagePopupTitle,
	      onSubmit: handleSubmitSendMessage,
	      onClose: handleCloseSendMessage
	    }),
	    isOpenPopover && popoverMenu,
	    isOpened && popup
	  );
	};
	
	About.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  community: _propTypes2.default.object.isRequired,
	  loggedUserId: _propTypes2.default.number.isRequired,
	  communityId: _propTypes2.default.number.isRequired,
	  membersList: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  moderatorsList: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  isModerator: _propTypes2.default.bool.isRequired,
	  sendMessage: _propTypes2.default.func.isRequired,
	  isMember: _propTypes2.default.bool.isRequired,
	  isPublic: _propTypes2.default.bool.isRequired,
	  moderatorsCount: _propTypes2.default.number.isRequired,
	  membersCount: _propTypes2.default.number.isRequired,
	  clearMembers: _propTypes2.default.func.isRequired,
	  clearModerators: _propTypes2.default.func.isRequired,
	  fetchMembers: _propTypes2.default.func.isRequired,
	  fetchModerators: _propTypes2.default.func.isRequired,
	  getMenuItems: _propTypes2.default.func.isRequired,
	  removeUserCommunity: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(About);

/***/ }),
/* 3184 */,
/* 3185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2; /* eslint-disable no-unused-expressions,global-require,react/destructuring-assignment,react/require-default-props */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEqual = __webpack_require__(325);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _ImageManager = __webpack_require__(1184);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imageManagerStyles = {
	  position: 'absolute',
	  top: '8px',
	  right: '8px'
	};
	
	var Banner = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = (_temp2 = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(Banner, _PureComponent);
	
	  function Banner() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Banner);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Banner.__proto__ || (0, _getPrototypeOf2.default)(Banner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      image: null,
	      loaded: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Banner, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.preloadImage();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var newImageValid = nextProps.image && !(0, _isEqual2.default)(this.props.image, nextProps.image);
	
	      if (newImageValid) {
	        this.preloadImage(nextProps);
	      }
	    }
	  }, {
	    key: 'preloadImage',
	    value: function preloadImage(props) {
	      var _this2 = this;
	
	      var _ref2 = props || this.props,
	          image = _ref2.image;
	
	      this.setState({
	        image: null,
	        loaded: false
	      });
	
	      var urlImage = (0, _get2.default)(image, 'url');
	      var urlThumb = (0, _get2.default)(image, 'small');
	
	      var cb = (0, _mobileHelpers.isDesktop)() ? function () {
	        return _this2.preloadUrl(urlImage);
	      } : null;
	
	      this.preloadUrl(urlThumb, cb);
	    }
	  }, {
	    key: 'preloadUrl',
	    value: function preloadUrl(url, callback) {
	      var _this3 = this;
	
	      var img = new Image();
	
	      if (!url) {
	        return;
	      }
	
	      img.onload = function () {
	        var isNeededImage = _this3.isAppropriateImage(url);
	
	        isNeededImage && _this3.setState({
	          image: url,
	          loaded: !callback
	        }, callback);
	      };
	
	      img.src = url;
	    }
	  }, {
	    key: 'isAppropriateImage',
	    value: function isAppropriateImage(url) {
	      var image = this.props.image;
	
	
	      var oUrl = (0, _get2.default)(image, 'url');
	      var sUrl = (0, _get2.default)(image, 'small');
	
	      return [oUrl, sUrl].includes(url);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          formatMessage = _props.intl.formatMessage,
	          onImageRemove = _props.onImageRemove,
	          onImageCrop = _props.onImageCrop,
	          isModerator = _props.isModerator;
	      var _state = this.state,
	          image = _state.image,
	          loaded = _state.loaded;
	
	
	      var defaultBanner = 'url(\'' + __webpack_require__(2286) + '\')';
	      var backgroundImage = image ? 'url(\'' + image + '\')' : defaultBanner;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          styleName: (0, _classnames2.default)('banner', {
	            'banner--blurred': image && !loaded
	          }),
	          style: { backgroundImage: backgroundImage }
	        },
	        _react2.default.createElement(_ImageManager.ImageManager, {
	          removeTitle: formatMessage({ id: 'community.banner.removeTitle' }),
	          cropTitle: formatMessage({ id: 'community.banner.cropTitle' }),
	          cropTip: formatMessage({ id: 'community.banner.cropTip' }),
	          onImageRemove: onImageRemove,
	          onImageCrop: onImageCrop,
	          hidden: !isModerator,
	          style: imageManagerStyles,
	          aspectRatio: 4 / 1
	        })
	      );
	    }
	  }]);
	  return Banner;
	}(_react.PureComponent), _class2.propTypes = {
	  onImageRemove: _propTypes2.default.func.isRequired,
	  onImageCrop: _propTypes2.default.func.isRequired,
	  isModerator: _propTypes2.default.bool.isRequired,
	  intl: _propTypes2.default.object.isRequired,
	  image: _propTypes2.default.shape({
	    url: _propTypes2.default.string
	  })
	}, _temp2)) || _class) || _class);
	exports.default = Banner;

/***/ }),
/* 3186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _currentCommunity = __webpack_require__(301);
	
	var _leaveCommunity = __webpack_require__(651);
	
	var _communityInfoUpdate = __webpack_require__(821);
	
	var _popup = __webpack_require__(76);
	
	var _withPopoverMenu = __webpack_require__(501);
	
	var _withPopoverMenu2 = _interopRequireDefault(_withPopoverMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isModerator: (0, _currentCommunity.isCurrentCommunityModeratorSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  showCommunityReport: _popup.reportActions.community,
	  leaveCommunity: _leaveCommunity.actions.send,
	  updateCommunityInfo: _communityInfoUpdate.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_withPopoverMenu2.default, _reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CommunityMenu = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _strings = __webpack_require__(15);
	
	var _InviteToCommunityModal = __webpack_require__(3191);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _CopyToClipboard = __webpack_require__(3845);
	
	var _CopyToClipboard2 = _interopRequireDefault(_CopyToClipboard);
	
	var _EditCommunityForm = __webpack_require__(3189);
	
	var _EditCommunityForm2 = _interopRequireDefault(_EditCommunityForm);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _IconMenu = __webpack_require__(337);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _ids = __webpack_require__(46);
	
	var _enhance = __webpack_require__(3186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunityMenuImpl = function CommunityMenuImpl(_ref) {
	  var leaveCommunity = _ref.leaveCommunity,
	      updateCommunityInfo = _ref.updateCommunityInfo,
	      showCommunityReport = _ref.showCommunityReport,
	      formatMessage = _ref.intl.formatMessage,
	      getMenuItems = _ref.getMenuItems,
	      isModerator = _ref.isModerator,
	      _ref$community = _ref.community;
	  _ref$community = _ref$community === undefined ? {} : _ref$community;
	  var name = _ref$community.name,
	      description = _ref$community.description,
	      currentUserRole = _ref$community.currentUserRole,
	      communityId = _ref$community.id,
	      linkSharing = _ref$community.linkSharing,
	      sharedLink = _ref$community.sharedLink;
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      isSearchOpen = _useToggleFlag2[0],
	      openSearch = _useToggleFlag2[1],
	      closeSearch = _useToggleFlag2[2];
	
	  var _useToggleFlag3 = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag4 = (0, _slicedToArray3.default)(_useToggleFlag3, 3),
	      isLeaveOpen = _useToggleFlag4[0],
	      openLeave = _useToggleFlag4[1],
	      closeLeave = _useToggleFlag4[2];
	
	  var _useToggleFlag5 = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag6 = (0, _slicedToArray3.default)(_useToggleFlag5, 3),
	      isSharingOpen = _useToggleFlag6[0],
	      openSharing = _useToggleFlag6[1],
	      closeSharing = _useToggleFlag6[2];
	
	  var _useToggleFlag7 = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag8 = (0, _slicedToArray3.default)(_useToggleFlag7, 3),
	      isEditOpen = _useToggleFlag8[0],
	      openEdit = _useToggleFlag8[1],
	      closeEdit = _useToggleFlag8[2];
	
	  var handleLeavePopup = (0, _react.useCallback)(function () {
	    leaveCommunity({ communityId: communityId });
	    closeLeave();
	  }, [communityId]);
	
	  var handleUpdateCommunity = (0, _react.useCallback)(function (data) {
	    updateCommunityInfo((0, _extends3.default)({ communityId: communityId }, data));
	    closeEdit();
	  }, [communityId]);
	
	  var openReportModal = (0, _react.useCallback)(function () {
	    return showCommunityReport(communityId);
	  }, [communityId]);
	
	  var menuItems = {
	    editCommunity: isModerator ? openEdit : null,
	    inviteToCommunity: isModerator ? openSearch : null,
	    shareLink: linkSharing && currentUserRole ? openSharing : null,
	    report: openReportModal,
	    leaveCommunity: currentUserRole ? openLeave : null
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_IconMenu2.default, {
	      id: _ids.IDS.COMMUNITY.MENU_TRIGGER,
	      position: { horizontal: 'right', vertical: 'bottom' },
	      items: getMenuItems(menuItems),
	      className: 'mr2 ml2',
	      allScreens: true
	    }),
	    isModerator ? _react2.default.createElement(_InviteToCommunityModal.InviteToCommunityModal, {
	      communityId: communityId,
	      isOpen: isSearchOpen,
	      onClose: closeSearch
	    }) : null,
	    currentUserRole ? _react2.default.createElement(_ActionConfirmation2.default, {
	      onClose: closeLeave,
	      onSubmit: handleLeavePopup,
	      opened: isLeaveOpen,
	      title: formatMessage({ id: 'community.menu.leaveCommunity' }),
	      body: formatMessage({ id: 'community.menu.leaveMessage' }),
	      actionButtonText: formatMessage({ id: 'community.menu.leave' }),
	      width: 'xsmall',
	      mobileFullScreen: false
	    }) : null,
	    linkSharing && currentUserRole ? _react2.default.createElement(
	      _Popup2.default,
	      {
	        title: formatMessage(_strings.COMMUNITIES_COMMON.share),
	        mobileFullScreen: false,
	        opened: isSharingOpen,
	        onClose: closeSharing,
	        strictClose: true,
	        width: 'small'
	      },
	      _react2.default.createElement(_CopyToClipboard2.default, {
	        buttonText: formatMessage(_strings.COMMON.copy),
	        copySuccessText: formatMessage(_strings.DIALOG_TITLE.copiedToClipboard),
	        title: formatMessage(_strings.DIALOG_TITLE.shareableLink),
	        link: sharedLink
	      })
	    ) : null,
	    isModerator ? _react2.default.createElement(
	      _Popup2.default,
	      {
	        title: formatMessage({ id: 'community.menu.editCommunity' }),
	        mobileFullScreen: true,
	        opened: isEditOpen,
	        onClose: closeEdit,
	        strictClose: true,
	        width: 'small'
	      },
	      _react2.default.createElement(_EditCommunityForm2.default, {
	        onSubmit: handleUpdateCommunity,
	        formatMessage: formatMessage,
	        name: name,
	        onCancel: closeEdit,
	        description: description
	      })
	    ) : null
	  );
	};
	
	var CommunityMenu = exports.CommunityMenu = (0, _enhance.enhance)(CommunityMenuImpl);
	
	var propTypes = {
	  community: _propTypes2.default.object.isRequired
	};
	CommunityMenuImpl.propTypes = (0, _extends3.default)({
	  leaveCommunity: _propTypes2.default.func.isRequired,
	  updateCommunityInfo: _propTypes2.default.func.isRequired,
	  showCommunityReport: _propTypes2.default.func.isRequired,
	  getMenuItems: _propTypes2.default.func.isRequired,
	  isModerator: _propTypes2.default.bool.isRequired,
	  community: _propTypes2.default.object.isRequired,
	  intl: _propTypes2.default.object.isRequired
	}, propTypes);
	
	CommunityMenu.propTypes = propTypes;

/***/ }),
/* 3188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp2; /* eslint-disable react/require-default-props */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactRouter = __webpack_require__(42);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _routes = __webpack_require__(37);
	
	var _joinPopup = __webpack_require__(519);
	
	var _sidebar = __webpack_require__(219);
	
	var _reqMemberInvitation = __webpack_require__(654);
	
	var _selectors = __webpack_require__(151);
	
	var _selectors2 = __webpack_require__(90);
	
	var _selectors3 = __webpack_require__(93);
	
	var _strings = __webpack_require__(15);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _index = __webpack_require__(1736);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _MobileNavigation = __webpack_require__(1730);
	
	var _MobileNavigation2 = _interopRequireDefault(_MobileNavigation);
	
	var _Content = __webpack_require__(214);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _ContentArea = __webpack_require__(155);
	
	var _ContentArea2 = _interopRequireDefault(_ContentArea);
	
	var _UserInviteForm = __webpack_require__(3757);
	
	var _UserInviteForm2 = _interopRequireDefault(_UserInviteForm);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _index3 = __webpack_require__(245);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var successMessagesMap = {
	  email: _strings.AUTH.titles.sentEmailVerification,
	  phone: _strings.AUTH.titles.sentPhoneVerification
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    joinPopup: (0, _selectors.communityJoinPopupSelector)(state),
	    isCommunityDrawerVisible: (0, _selectors2.uiSidebarSelector)(state),
	    isLoggedIn: (0, _selectors3.isLoggedInSelector)(state),
	    invitationTargetUser: (0, _selectors.selectMemberInvitationTargetUser)(state)
	  };
	};
	var mapDispatchToProps = {
	  openJoinPopup: _joinPopup.actions.show,
	  hideJoinPopup: _joinPopup.actions.hide,
	  toggleSidebarVisibility: _sidebar.actions.toggleVisibility,
	  setPopupTimer: _joinPopup.actions.setTimer,
	  stopPopupTimer: _joinPopup.actions.stopTimer,
	  sendMemberInvitation: _reqMemberInvitation.actions.send
	};
	
	var CommunityPreview = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index4.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(CommunityPreview, _Component);
	
	  function CommunityPreview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CommunityPreview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CommunityPreview.__proto__ || (0, _getPrototypeOf2.default)(CommunityPreview)).call.apply(_ref, [this].concat(args))), _this), _this.handleTogglePopup = function (content) {
	      var openJoinPopup = _this.props.openJoinPopup;
	
	      openJoinPopup({ content: content });
	    }, _this.handleClosePopup = function () {
	      var _this$props = _this.props,
	          joinPopup = _this$props.joinPopup,
	          hideJoinPopup = _this$props.hideJoinPopup,
	          stopPopupTimer = _this$props.stopPopupTimer;
	      var content = joinPopup.content;
	
	
	      switch (content) {
	        case 'join':
	          stopPopupTimer();
	          hideJoinPopup();
	          break;
	        case 'signUp':
	          _this.handleTogglePopup('join');
	          break;
	        default:
	          break;
	      }
	    }, _this.successContent = function (formatMessage) {
	      var invitationTargetUser = _this.props.invitationTargetUser;
	
	      var invitationType = 'email';
	
	      if ((0, _get2.default)(invitationTargetUser, 'phoneNumber')) {
	        invitationType = 'phone';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'flex flex-column items-center pt4 pb2' },
	        _react2.default.createElement(_Icon2.default, { className: 'db mb1', name: 'icon-plane', size: 50 }),
	        _react2.default.createElement(
	          'p',
	          { className: 'mt4 pl5 pr5 tc' },
	          formatMessage(successMessagesMap[invitationType])
	        )
	      );
	    }, _this.joinPopup = function (formatMessage) {
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'popup' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex flex-column items-center' },
	          _react2.default.createElement(_Icon2.default, {
	            name: _brandConfig2.default.logo,
	            size: _brandConfig2.default.logoSize,
	            style: { fill: _brandConfig2.default.fillColor }
	          }),
	          _react2.default.createElement(
	            'p',
	            { styleName: 'popup-title' },
	            formatMessage(_strings.COMMUNITIES_COMMON.join)
	          ),
	          _react2.default.createElement(
	            'p',
	            { styleName: 'popup-subtitle' },
	            formatMessage(_strings.COMMUNITIES_COMMON.signUpToJoin)
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'primary',
	            className: 'w-80 mt4 mb4 f-14',
	            onClick: function onClick() {
	              return _this.handleTogglePopup('signUp');
	            }
	          },
	          formatMessage(_strings.AUTH.submit.signUp)
	        ),
	        _react2.default.createElement(
	          'p',
	          { styleName: 'popup-subtitle' },
	          formatMessage(_strings.DIALOG_TITLE.alreadyMember),
	          _react2.default.createElement(
	            _Link2.default,
	            { to: _routes.LOGIN, styleName: 'popup-subtitle--primary' },
	            '\xA0',
	            formatMessage(_strings.AUTH.submit.login)
	          )
	        )
	      );
	    }, _this.userInviteForm = function (formatMessage) {
	      var _this$props2 = _this.props,
	          sendMemberInvitation = _this$props2.sendMemberInvitation,
	          routeParams = _this$props2.routeParams;
	
	      return _react2.default.createElement(_UserInviteForm2.default, {
	        formatMessage: formatMessage,
	        sendInvite: sendMemberInvitation,
	        closeInvitePopup: function closeInvitePopup() {
	          return _this.handleTogglePopup('join');
	        },
	        communityId: routeParams.communityId
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CommunityPreview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          isLoggedIn = _props.isLoggedIn,
	          communityId = _props.routeParams.communityId;
	
	
	      if (isLoggedIn) {
	        _reactRouter.browserHistory.push('/' + _routes.COMMUNITIES + '/' + communityId);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props,
	          setPopupTimer = _props2.setPopupTimer,
	          isLoggedIn = _props2.isLoggedIn;
	
	
	      if (!isLoggedIn) {
	        setPopupTimer({ delay: 15000 });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          routeParams = _props3.routeParams,
	          joinPopup = _props3.joinPopup,
	          toggleSidebarVisibility = _props3.toggleSidebarVisibility,
	          isCommunityDrawerVisible = _props3.isCommunityDrawerVisible,
	          isLoggedIn = _props3.isLoggedIn,
	          formatMessage = _props3.intl.formatMessage;
	      var isPopupVisible = joinPopup.visible,
	          popupContent = joinPopup.content;
	
	      var toggleSidebar = isCommunityDrawerVisible.visible && toggleSidebarVisibility;
	      var signUpPopup = popupContent === 'signUp';
	      var isWithHeading = popupContent === 'join';
	      var popup = {
	        join: this.joinPopup(formatMessage),
	        signUp: this.userInviteForm(formatMessage),
	        success: this.successContent(formatMessage)
	      };
	      var MatchedComponent = popup[popupContent];
	
	      if (isLoggedIn) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'g-content', styleName: 'preview' },
	        _react2.default.createElement(
	          _ContentArea2.default,
	          { className: 'relative' },
	          isCommunityDrawerVisible.visible && _react2.default.createElement(_MobileNavigation2.default, { toggleContext: toggleSidebar }),
	          _react2.default.createElement(
	            _Content2.default,
	            { fullHeight: true },
	            _react2.default.createElement(_index2.default, { routeParams: routeParams }),
	            _react2.default.createElement(
	              _Popup2.default,
	              {
	                opened: isPopupVisible,
	                white: true,
	                width: (0, _mobileHelpers.isDesktop)() ? 'xsmall' : 'medium',
	                withHeading: isWithHeading,
	                enabled: true,
	                title: signUpPopup ? formatMessage(_strings.AUTH.actions.signup.textLink) : '',
	                onClose: this.handleClosePopup
	              },
	              MatchedComponent
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return CommunityPreview;
	}(_react.Component), _class2.propTypes = {
	  routeParams: _propTypes2.default.object.isRequired,
	  openJoinPopup: _propTypes2.default.func.isRequired,
	  hideJoinPopup: _propTypes2.default.func.isRequired,
	  joinPopup: _propTypes2.default.object.isRequired,
	  invitationTargetUser: _propTypes2.default.object,
	  isLoggedIn: _propTypes2.default.bool,
	  toggleSidebarVisibility: _propTypes2.default.func.isRequired,
	  isCommunityDrawerVisible: _propTypes2.default.object.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  stopPopupTimer: _propTypes2.default.func.isRequired,
	  setPopupTimer: _propTypes2.default.func.isRequired,
	  sendMemberInvitation: _propTypes2.default.func.isRequired
	}, _class2.defaultProps = {
	  isLoggedIn: null
	}, _temp2)) || _class) || _class) || _class);
	exports.default = CommunityPreview;

/***/ }),
/* 3189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(58);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ValidationError = __webpack_require__(500);
	
	var _ValidationError2 = _interopRequireDefault(_ValidationError);
	
	var _ids = __webpack_require__(46);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditCommunityForm = function EditCommunityForm(_ref) {
	  var formatMessage = _ref.formatMessage,
	      onSubmit = _ref.onSubmit,
	      name = _ref.name,
	      description = _ref.description,
	      onCancel = _ref.onCancel;
	
	  var initialState = {
	    name: name,
	    description: description
	  };
	
	  var _useState = (0, _react.useState)(initialState),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      values = _useState2[0],
	      setValues = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({}),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      errors = _useState4[0],
	      setErrors = _useState4[1];
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    onSubmit(values);
	  };
	
	  var handleInputChange = function handleInputChange(fieldName, value) {
	    var error = validateInput(fieldName, value);
	    setValues((0, _extends5.default)({}, values, (0, _defineProperty3.default)({}, fieldName, value)));
	    setErrors((0, _extends5.default)({}, errors, (0, _defineProperty3.default)({}, fieldName, error)));
	  };
	
	  var validateInput = function validateInput(fieldName, value) {
	    var error = void 0;
	    if (fieldName === 'name' && (!(0, _lodash.trim)(value) || value.length < _index.EDIT_COMMUNITY_VALIDATION_RULES.NAME_MIN_LENGTH)) {
	      error = formatMessage({ id: 'chat.errors.minLength' }, { length: _index.EDIT_COMMUNITY_VALIDATION_RULES.NAME_MIN_LENGTH });
	    }
	    if (fieldName === 'name' && value.length > _index.EDIT_COMMUNITY_VALIDATION_RULES.NAME_MAX_LENGTH) {
	      error = formatMessage({ id: 'chat.errors.tooLong' }, { length: _index.EDIT_COMMUNITY_VALIDATION_RULES.NAME_MAX_LENGTH });
	    }
	    if (fieldName === 'description' && value.length > _index.EDIT_COMMUNITY_VALIDATION_RULES.DESCRIPTION_MAX_LENGTH) {
	      error = formatMessage({ id: 'chat.errors.tooLong' }, { length: _index.EDIT_COMMUNITY_VALIDATION_RULES.DESCRIPTION_MAX_LENGTH });
	    }
	    return error;
	  };
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit },
	    _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_TextInput2.default, {
	        type: 'text',
	        label: formatMessage({ id: 'community.communityName' }),
	        placeholder: formatMessage({ id: 'community.communityName' }),
	        limit: _index.EDIT_COMMUNITY_VALIDATION_RULES.NAME_MAX_LENGTH + 1,
	        name: 'name',
	        value: values.name,
	        onChange: function onChange(val) {
	          return handleInputChange('name', val);
	        }
	      }),
	      _react2.default.createElement(_ValidationError2.default, { content: errors.name, className: 'mb3' })
	    ),
	    _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_TextInput2.default, {
	        textarea: true,
	        rows: '4',
	        type: 'text',
	        label: formatMessage({ id: 'common.description' }),
	        placeholder: formatMessage({ id: 'common.description' }),
	        limit: _index.EDIT_COMMUNITY_VALIDATION_RULES.DESCRIPTION_MAX_LENGTH + 1,
	        name: 'description',
	        value: values.description,
	        onChange: function onChange(val) {
	          return handleInputChange('description', val);
	        }
	      }),
	      _react2.default.createElement(_ValidationError2.default, { content: errors.description })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt3' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: _ids.IDS.COMMUNITY.MENU_EDIT,
	          className: 'mr3',
	          raised: true,
	          color: 'primary',
	          type: 'submit',
	          disabled: Boolean(errors.description || errors.name)
	        },
	        formatMessage(_strings.COMMON.save)
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: _ids.IDS.COMMUNITY.MENU_CANCEL,
	          raised: true,
	          color: 'accent',
	          type: 'button',
	          onClick: onCancel
	        },
	        formatMessage(_strings.COMMON.cancel)
	      )
	    )
	  );
	};
	
	EditCommunityForm.propTypes = {
	  formatMessage: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func,
	  name: _propTypes2.default.string,
	  description: _propTypes2.default.string
	};
	
	exports.default = EditCommunityForm;

/***/ }),
/* 3190 */,
/* 3191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InviteToCommunityModal = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(151);
	
	var _invitationUserToCommunity = __webpack_require__(1262);
	
	var invitationUserToCommunity = _interopRequireWildcard(_invitationUserToCommunity);
	
	var _invitationUserSearch = __webpack_require__(1261);
	
	var invitationUsersSearch = _interopRequireWildcard(_invitationUserSearch);
	
	var _SearchDialogImpl = __webpack_require__(1841);
	
	var _SearchDialogImpl2 = _interopRequireDefault(_SearchDialogImpl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    users: (0, _selectors.selectCommunityInvitationSearchUsers)(state),
	    loading: (0, _selectors.selectCommunityInvitationSearchSending)(state),
	    succeed: (0, _selectors.selectCommunityInvitationSearchSucceed)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchUserList: invitationUsersSearch.actions.send,
	  inviteUsers: invitationUserToCommunity.actions.send,
	  clear: invitationUsersSearch.actions.clear
	};
	
	var enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var fetchUserList = _ref.fetchUserList,
	      communityId = _ref.communityId,
	      inviteUsers = _ref.inviteUsers;
	  return {
	    getUsers: function getUsers(payload) {
	      return fetchUserList((0, _extends3.default)({}, payload, { communityId: communityId }));
	    },
	    onCreate: function onCreate(candidateUserIds) {
	      return inviteUsers({ communityId: communityId, candidateUserIds: candidateUserIds });
	    }
	  };
	}));
	
	var InviteToCommunityModalImpl = function InviteToCommunityModalImpl(_ref2) {
	  var formatMessage = _ref2.intl.formatMessage,
	      rest = (0, _objectWithoutProperties3.default)(_ref2, ['intl']);
	
	  return _react2.default.createElement(_SearchDialogImpl2.default, (0, _extends3.default)({
	    searchPlaceholder: formatMessage({ id: 'messages.chat.searchAUser' }),
	    defaultState: formatMessage({ id: 'community.menu.inviteDefault' }),
	    emptyState: formatMessage({ id: 'messages.chat.noOneFound' }),
	    buttonTitle: formatMessage({ id: 'community.menu.invite' }),
	    title: formatMessage({ id: 'community.menu.invitePeople' }),
	    defaultIcon: 'no-one-found'
	  }, rest));
	};
	
	InviteToCommunityModalImpl.propTypes = {
	  intl: _propTypes2.default.object.isRequired
	};
	
	var InviteToCommunityModal = exports.InviteToCommunityModal = enhance(InviteToCommunityModalImpl);

/***/ }),
/* 3192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ImageManager = __webpack_require__(1184);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var imageManagerStyles = {
	  position: 'absolute',
	  top: '0',
	  right: '0'
	};
	
	var Logo = function Logo(_ref) {
	  var image = _ref.image,
	      offset = _ref.offset,
	      name = _ref.name,
	      size = _ref.size,
	      formatMessage = _ref.formatMessage,
	      isModerator = _ref.isModerator,
	      onImageRemove = _ref.onImageRemove,
	      onImageCrop = _ref.onImageCrop;
	
	  var url = (0, _get2.default)(image, 'thumbMin');
	
	  return _react2.default.createElement(
	    'div',
	    {
	      styleName: (0, _classnames2.default)('logo', {
	        'logo--offset': offset
	      })
	    },
	    _react2.default.createElement(_Avatar2.default, {
	      children: name,
	      src: url,
	      bordered: true,
	      position: 'center',
	      size: size,
	      noTransparent: true
	    }),
	    _react2.default.createElement(_ImageManager.ImageManager, {
	      removeTitle: formatMessage({ id: 'community.logo.removeTitle' }),
	      cropTitle: formatMessage({ id: 'community.logo.cropTitle' }),
	      onImageRemove: onImageRemove,
	      onImageCrop: onImageCrop,
	      hidden: !isModerator,
	      style: imageManagerStyles,
	      aspectRatio: 1,
	      rounded: true
	    })
	  );
	};
	
	Logo.propTypes = {
	  onImageRemove: _propTypes2.default.func.isRequired,
	  onImageCrop: _propTypes2.default.func.isRequired,
	  isModerator: _propTypes2.default.bool.isRequired,
	  formatMessage: _propTypes2.default.func.isRequired,
	  image: _propTypes2.default.shape({
	    url: _propTypes2.default.string
	  }),
	  offset: _propTypes2.default.bool,
	  name: _propTypes2.default.string,
	  size: _propTypes2.default.number
	};
	
	Logo.defaultProps = {
	  size: 40
	};
	
	exports.default = (0, _reactCssModules2.default)(Logo, _index2.default, { allowMultiple: true });

/***/ }),
/* 3193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _PostForm = __webpack_require__(1735);
	
	var _PostForm2 = _interopRequireDefault(_PostForm);
	
	var _strings = __webpack_require__(15);
	
	var _newPostForm = __webpack_require__(652);
	
	var _urlPreview = __webpack_require__(413);
	
	var _index = __webpack_require__(719);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    editPostRequest: state.communities.editPost
	  };
	};
	
	var mapDispatchToProps = {
	  updateForm: _newPostForm.actions.updateForm,
	  clearForm: _newPostForm.actions.clearForm,
	  clearUrlPreview: _urlPreview.actions.clear
	};
	
	var EditPostPopup = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(EditPostPopup, _PureComponent);
	
	  function EditPostPopup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EditPostPopup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditPostPopup.__proto__ || (0, _getPrototypeOf2.default)(EditPostPopup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isOpened: false,
	      error: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EditPostPopup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        intl: this.props.intl,
	        store: this.context.store
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          content = _props.content,
	          attachment = _props.attachment;
	      var _nextProps$editPostRe = nextProps.editPostRequest,
	          sending = _nextProps$editPostRe.sending,
	          succeed = _nextProps$editPostRe.succeed,
	          error = _nextProps$editPostRe.error;
	
	
	      if (this.props.editPostRequest.sending && !sending) {
	        if (succeed) {
	          this.openPopup(false);
	        } else {
	          this.setState({ error: error.description });
	        }
	      }
	
	      if (!this.props.forceOpened && nextProps.forceOpened) {
	        this.props.updateForm({ content: content, attachment: attachment });
	        this.openPopup();
	      }
	    }
	  }, {
	    key: 'openPopup',
	    value: function openPopup() {
	      var isOpened = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var updates = {
	        isOpened: isOpened
	      };
	
	      if (this.state.isOpened && !isOpened) {
	        (0, _assign2.default)(updates, { error: false });
	        this.props.clearForm();
	        this.props.clearUrlPreview();
	      }
	
	      this.setState(updates);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(data) {
	      var _props2 = this.props,
	          editPost = _props2.editPost,
	          communityId = _props2.communityId,
	          postId = _props2.postId;
	
	
	      if (!communityId) throw new Error('EditPost: required communityId prop is missing');
	      if (!data || !(data instanceof FormData)) throw new Error('EditPost: wrong data passed');
	
	      data.append('communityId', communityId);
	      data.append('postId', postId);
	
	      editPost(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          intl = _props3.intl,
	          communityName = _props3.communityName,
	          formatMessage = _props3.intl.formatMessage,
	          sending = _props3.editPostRequest.sending,
	          attachment = _props3.attachment;
	      var _state = this.state,
	          isOpened = _state.isOpened,
	          error = _state.error;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_PostForm2.default, {
	          modalTitle: formatMessage(_strings.COMMUNUNNITY_NEW_POST.editTitle, {
	            name: communityName
	          }),
	          discardModalTitle: formatMessage({
	            id: 'dialog.common.changesNotSave'
	          }),
	          isModalOpen: isOpened,
	          submitting: sending,
	          store: this.context.store,
	          intl: intl,
	          onSubmit: this.handleSubmit,
	          onCancel: function onCancel() {
	            return _this2.openPopup(false);
	          },
	          error: error,
	          attachment: attachment,
	          edit: true,
	          key: isOpened,
	          discardBtnText: formatMessage({ id: 'profile.actions.cancel' })
	        })
	      );
	    }
	  }]);
	  return EditPostPopup;
	}(_react.PureComponent), _class3.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  communityId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  editPost: _propTypes2.default.func,
	  updateForm: _propTypes2.default.func,
	  communityName: _propTypes2.default.string,
	  postId: _propTypes2.default.number,
	  editPostRequest: _propTypes2.default.shape({
	    sending: _propTypes2.default.bool,
	    rejected: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }),
	  forceOpened: _propTypes2.default.bool,
	  content: _propTypes2.default.string,
	  attachment: _propTypes2.default.object,
	  clearForm: _propTypes2.default.func,
	  clearUrlPreview: _propTypes2.default.func
	}, _class3.childContextTypes = {
	  intl: _propTypes2.default.object,
	  store: _propTypes2.default.object
	}, _class3.contextTypes = {
	  store: _propTypes2.default.object
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'openPopup', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSubmit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleSubmit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	
	var EditPost = function (_PureComponent2) {
	  (0, _inherits3.default)(EditPost, _PureComponent2);
	
	  function EditPost() {
	    var _ref2;
	
	    var _temp3, _this3, _ret2;
	
	    (0, _classCallCheck3.default)(this, EditPost);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = EditPost.__proto__ || (0, _getPrototypeOf2.default)(EditPost)).call.apply(_ref2, [this].concat(args))), _this3), _this3.state = {
	      forceOpen: false
	    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret2);
	  }
	
	  (0, _createClass3.default)(EditPost, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.forceOpen) this.setState({ forceOpen: false });
	    }
	  }, {
	    key: 'forceOpen',
	    value: function forceOpen() {
	      this.setState({ forceOpen: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(EditPostPopup, (0, _extends3.default)({}, this.props, { forceOpened: this.state.forceOpen }));
	    }
	  }]);
	  return EditPost;
	}(_react.PureComponent);
	
	exports.default = EditPost;

/***/ }),
/* 3194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InviteBtn = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _currentCommunity = __webpack_require__(301);
	
	var _declineInvitation = __webpack_require__(518);
	
	var _acceptInvitation = __webpack_require__(342);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteBtnImpl = function InviteBtnImpl(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      acceptInvite = _ref.acceptInvite,
	      declineInvite = _ref.declineInvite,
	      id = _ref.invitationId,
	      disabled = _ref.disabled;
	
	  var handleAccept = (0, _react.useCallback)(function () {
	    acceptInvite({ id: id, actionType: _constants.COMMUNITY_BTN_ACTIONS.ACCEPT });
	  }, [id]);
	
	  var handleDecline = (0, _react.useCallback)(function () {
	    declineInvite({ id: id, actionType: _constants.COMMUNITY_BTN_ACTIONS.DECLINE });
	  }, [id]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        color: 'primary',
	        raised: true,
	        type: 'button',
	        onClick: handleAccept,
	        disabled: disabled
	      },
	      formatMessage({ id: 'common.accept' })
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        raised: true,
	        type: 'button',
	        className: 'ml2',
	        disabled: disabled,
	        onClick: handleDecline
	      },
	      formatMessage({ id: 'common.decline' })
	    )
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    disabled: (0, _currentCommunity.selectAcceptDeclineDisabledState)(state)
	  };
	};
	var mapDispatchToProps = {
	  acceptInvite: _acceptInvitation.actions.send,
	  declineInvite: _declineInvitation.actions.send
	};
	
	var InviteBtn = exports.InviteBtn = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(InviteBtnImpl);
	
	var propTypes = {
	  invitationId: _propTypes2.default.number.isRequired
	};
	InviteBtnImpl.propTypes = (0, _extends3.default)({}, propTypes, {
	  intl: _propTypes2.default.object.isRequired,
	  disabled: _propTypes2.default.bool.isRequired,
	  acceptInvite: _propTypes2.default.func.isRequired,
	  declineInvite: _propTypes2.default.func.isRequired
	});
	
	InviteBtn.propTypes = propTypes;

/***/ }),
/* 3195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ActionButton = __webpack_require__(1178);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(719);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable jsx-a11y/no-autofocus,react/require-default-props,react/prop-types */
	var UrlInput = function UrlInput(_ref) {
	  var onCancel = _ref.onCancel,
	      onUrl = _ref.onUrl,
	      formatMessage = _ref.formatMessage;
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'url-input' },
	    _react2.default.createElement('input', {
	      autoFocus: true,
	      onChange: function onChange(e) {
	        return onUrl(e.target.value);
	      },
	      placeholder: formatMessage(_strings.COMMUNUNNITY_NEW_POST.enterUrl),
	      type: 'text',
	      styleName: 'input'
	    }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'icon-close' },
	      _react2.default.createElement(
	        _ActionButton2.default,
	        { onClick: onCancel },
	        _react2.default.createElement(_Icon2.default, { name: 'close', size: 24, style: { fill: _styles.COLORS.white } })
	      )
	    )
	  );
	};
	
	UrlInput.propTypes = {
	  onCancel: _propTypes2.default.func,
	  onUrl: _propTypes2.default.func
	};
	
	exports.default = (0, _reactCssModules2.default)(UrlInput, _index2.default);

/***/ }),
/* 3196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRedux = __webpack_require__(6);
	
	var _createPost = __webpack_require__(823);
	
	var _reqJoinCommunity = __webpack_require__(521);
	
	var _joinPopup = __webpack_require__(519);
	
	var _selectors = __webpack_require__(151);
	
	var _selectors2 = __webpack_require__(93);
	
	var _index = __webpack_require__(719);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = {
	  createPost: _createPost.actions.send,
	  reqJoinCommunity: _reqJoinCommunity.actions.send,
	  openJoinPopup: _joinPopup.actions.show
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    createPostRequest: (0, _selectors.selectCreateCommunityPost)(state),
	    isLoggedIn: (0, _selectors2.isLoggedInSelector)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(58);
	
	var _constants = __webpack_require__(17);
	
	var _strings = __webpack_require__(15);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _getButtonInfo2 = __webpack_require__(1379);
	
	var _getButtonInfo3 = _interopRequireDefault(_getButtonInfo2);
	
	var _CommunityMenu = __webpack_require__(3187);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PostForm = __webpack_require__(1735);
	
	var _PostForm2 = _interopRequireDefault(_PostForm);
	
	var _enhance = __webpack_require__(3196);
	
	var _InviteBtns = __webpack_require__(3194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var READ_AND_POST = _constants.COMMUNITIES_ACCESS_LEVELS.READ_AND_POST,
	    READ_AND_POST_WITH_APPROVAL = _constants.COMMUNITIES_ACCESS_LEVELS.READ_AND_POST_WITH_APPROVAL;
	
	
	var NewPostButton = function NewPostButton(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      createPost = _ref.createPost,
	      reqJoinCommunity = _ref.reqJoinCommunity,
	      openJoinPopup = _ref.openJoinPopup,
	      isLoggedIn = _ref.isLoggedIn,
	      accessLevel = _ref.accessLevel,
	      _ref$createPostReques = _ref.createPostRequest,
	      sending = _ref$createPostReques.sending,
	      rejected = _ref$createPostReques.rejected,
	      error = _ref$createPostReques.error,
	      succeed = _ref$createPostReques.succeed,
	      community = _ref.community,
	      isModerator = _ref.isModerator;
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      isModalOpen = _useToggleFlag2[0],
	      openModal = _useToggleFlag2[1],
	      closeModal = _useToggleFlag2[2];
	
	  var _useToggleFlag3 = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag4 = (0, _slicedToArray3.default)(_useToggleFlag3, 3),
	      isNotificationOpen = _useToggleFlag4[0],
	      openNotification = _useToggleFlag4[1],
	      closeNotification = _useToggleFlag4[2];
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      postError = _useState2[0],
	      setPostError = _useState2[1];
	
	  var communityId = community.id,
	      name = community.name,
	      currentUserRole = community.currentUserRole,
	      memberInvitationId = community.memberInvitationId;
	
	
	  (0, _react.useEffect)(function () {
	    if (succeed) {
	      closeModal();
	    }
	  }, [succeed]);
	
	  (0, _react.useEffect)(function () {
	    if (rejected) {
	      setPostError((0, _lodash.get)(error, 'description'));
	    }
	  }, [rejected]);
	
	  var _getButtonInfo = (0, _getButtonInfo3.default)(community, formatMessage, true),
	      buttonText = _getButtonInfo.buttonText,
	      disabled = _getButtonInfo.disabled,
	      btnID = _getButtonInfo.id;
	
	  var handleClosePopup = function handleClosePopup() {
	    setPostError('');
	    closeModal();
	  };
	
	  var onSubmitPost = function onSubmitPost(data) {
	    if (!communityId) {
	      throw new Error('NewPost: required communityId prop is missing');
	    }
	    if (!data || !(data instanceof FormData)) {
	      throw new Error('NewPost: wrong data passed');
	    }
	
	    data.append('communityId', communityId);
	
	    createPost(data);
	  };
	
	  var checkButtonAction = function checkButtonAction() {
	    if (isLoggedIn) {
	      return currentUserRole ? openModal() : reqJoinCommunity({ communityId: communityId });
	    }
	    openJoinPopup({ content: 'join' });
	  };
	
	  var canPost = currentUserRole === _constants.COMMUNITIES_USER_ROLES.MODERATOR || accessLevel === READ_AND_POST || accessLevel === READ_AND_POST_WITH_APPROVAL;
	  var showButton = !currentUserRole || currentUserRole && canPost;
	  var buttonCondition = showButton && !memberInvitationId;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: (0, _classnames2.default)('wrapper__action', { 'full-width': buttonCondition }) },
	    buttonCondition ? _react2.default.createElement(
	      _Button2.default,
	      {
	        id: btnID,
	        color: 'primary',
	        raised: true,
	        type: 'button',
	        onClick: checkButtonAction,
	        className: 'w-100',
	        disabled: disabled
	      },
	      buttonText
	    ) : null,
	    memberInvitationId ? _react2.default.createElement(_InviteBtns.InviteBtn, { invitationId: memberInvitationId }) : null,
	    isLoggedIn ? _react2.default.createElement(_CommunityMenu.CommunityMenu, { community: community }) : null,
	    _react2.default.createElement(_PostForm2.default, {
	      modalTitle: formatMessage(_strings.COMMUNUNNITY_NEW_POST.title, { name: name }),
	      discardModalTitle: formatMessage({
	        id: 'community.newPost.cancelPost'
	      }),
	      isModalOpen: isModalOpen,
	      submitting: sending,
	      onSubmit: onSubmitPost,
	      onCancel: handleClosePopup,
	      error: postError,
	      key: isModalOpen,
	      discardBtnText: formatMessage({ id: 'post.actions.discardPost' }),
	      accessLevel: accessLevel,
	      isModerator: isModerator,
	      isNotificationOpen: isNotificationOpen,
	      openNotification: openNotification,
	      closeNotification: closeNotification
	    })
	  );
	};
	
	NewPostButton.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  community: _propTypes2.default.object.isRequired,
	  createPost: _propTypes2.default.func,
	  createPostRequest: _propTypes2.default.shape({
	    sending: _propTypes2.default.bool,
	    rejected: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool,
	    error: _propTypes2.default.object
	  }),
	  accessLevel: _propTypes2.default.string,
	  reqJoinCommunity: _propTypes2.default.func,
	  isLoggedIn: _propTypes2.default.bool,
	  openJoinPopup: _propTypes2.default.func,
	  isModerator: _propTypes2.default.bool
	};
	
	exports.default = (0, _enhance.enhance)(NewPostButton);

/***/ }),
/* 3198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _styles = __webpack_require__(18);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewPostBtn = function NewPostBtn(_ref) {
	  var title = _ref.title,
	      handleClick = _ref.handleClick;
	  return _react2.default.createElement(
	    _ClickableElement2.default,
	    { onClick: handleClick, styleName: 'newPostBtn' },
	    _react2.default.createElement(
	      'span',
	      { className: 'mr2' },
	      title
	    ),
	    _react2.default.createElement(_Icon2.default, {
	      name: 'arrow-down-forms',
	      width: 12,
	      height: 12,
	      style: { fill: _styles.COLORS.blueAccent, transform: 'rotate(180deg)' }
	    })
	  );
	};
	
	NewPostBtn.propTypes = {
	  handleClick: _propTypes2.default.func.isRequired,
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _reactCssModules2.default)(NewPostBtn, _index2.default, { allowMultiple: true });

/***/ }),
/* 3199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp; /* eslint-disable react/require-default-props,react/destructuring-assignment */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactIntl = __webpack_require__(5);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _partition3 = __webpack_require__(5516);
	
	var _partition4 = _interopRequireDefault(_partition3);
	
	var _strings = __webpack_require__(15);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _PostPreview = __webpack_require__(1785);
	
	var _PostPreview2 = _interopRequireDefault(_PostPreview);
	
	var _SectionTitle = __webpack_require__(1100);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _deletePost = __webpack_require__(826);
	
	var _editPost = __webpack_require__(827);
	
	var _selectors = __webpack_require__(23);
	
	var _props4 = __webpack_require__(41);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var HEADER_HEIGHT = 56;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    postDetails: state.communities.postDetails,
	    currentUserId: (0, _selectors.loggedUserIdSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  deletePost: _deletePost.actions.send,
	  editPost: _editPost.actions.send
	};
	
	var Posts = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
	  (0, _inherits3.default)(Posts, _Component);
	
	  function Posts() {
	    (0, _classCallCheck3.default)(this, Posts);
	    return (0, _possibleConstructorReturn3.default)(this, (Posts.__proto__ || (0, _getPrototypeOf2.default)(Posts)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Posts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var id = this.props.postDetails.id;
	
	
	      if (id) {
	        this.timeoutId = setTimeout(function () {
	          return _this2.scrollToItem(id);
	        }, 0);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeoutId);
	    }
	  }, {
	    key: 'scrollToItem',
	    value: function scrollToItem(id) {
	      var targetElement = this.ref && this.ref.querySelector('[data-id="' + id + '"]');
	
	      if (targetElement) {
	        targetElement.scrollIntoView(true);
	
	        // get top spacing equal community expandable header
	        var scrolledElement = (0, _get2.default)(targetElement, 'offsetParent.children[0]');
	
	        if (scrolledElement) {
	          var header = document.querySelector('.community__header');
	          var headerHeight = header && header.offsetHeight;
	
	          scrolledElement.scrollTop -= headerHeight || HEADER_HEIGHT;
	        }
	      }
	    }
	  }, {
	    key: 'handleDeletePost',
	    value: function handleDeletePost(id) {
	      var _props = this.props,
	          deletePost = _props.deletePost,
	          communityId = _props.communityId;
	
	
	      deletePost({
	        communityId: communityId,
	        id: id
	      });
	    }
	  }, {
	    key: 'canDelete',
	    value: function canDelete(post) {
	      var _props2 = this.props,
	          currentUserId = _props2.currentUserId,
	          isModerator = _props2.isModerator;
	
	
	      return isModerator || post.author.user.id === currentUserId;
	    }
	  }, {
	    key: 'handleEditPost',
	    value: function handleEditPost(data) {
	      this.props.editPost(data);
	    }
	  }, {
	    key: 'canEdit',
	    value: function canEdit(post) {
	      return post.author.user.id === this.props.currentUserId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          communityId = _props3.communityId,
	          intl = _props3.intl,
	          list = _props3.list,
	          isModerator = _props3.isModerator,
	          currentUserRole = _props3.currentUserRole,
	          type = _props3.type,
	          communityName = _props3.communityName;
	      var formatMessage = intl.formatMessage;
	
	      var isPrivateCommunity = type === _props4.COMMUNITY_TYPES.private;
	      var isEmptyContent = isPrivateCommunity && !currentUserRole || (0, _isEmpty2.default)(list);
	      var emptyContentIcon = isPrivateCommunity ? 'icon-megaphone' : 'no-posts';
	      var emptyContentText = isPrivateCommunity ? formatMessage(_strings.COMMUNITY_POSTS_PRIVATE) : formatMessage(_strings.COMMUNITY_POSTS_EMPTY);
	      var emptyContentSubtitle = formatMessage(_strings.COMMUNITY_POSTS_EMPTY_SUB, {
	        name: communityName
	      });
	
	      var _partition = (0, _partition4.default)(list, 'pinned'),
	          _partition2 = (0, _slicedToArray3.default)(_partition, 2),
	          pinnedPost = _partition2[0],
	          otherPosts = _partition2[1];
	
	      var sortedList = pinnedPost.concat(otherPosts);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          styleName: (0, _classnames2.default)('posts', {
	            'posts--empty': isEmptyContent
	          })
	        },
	        isEmptyContent ? [_react2.default.createElement(_Content2.default, { icon: emptyContentIcon, text: emptyContentText, key: '0'
	        }), _react2.default.createElement(
	          'p',
	          { styleName: 'subtitle', key: '1'
	          },
	          emptyContentSubtitle
	        )] : [_react2.default.createElement(_SectionTitle2.default, { text: formatMessage(_strings.COMMUNITY_POSTS), key: '0'
	        }), _react2.default.createElement(
	          'ul',
	          { styleName: 'posts__list', ref: function ref(node) {
	              return _this3.ref = node;
	            }, key: '1'
	          },
	          sortedList.map(function (post, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: post.id, className: 'pb3', 'data-id': post.id },
	              _react2.default.createElement(_PostPreview2.default, (0, _extends3.default)({
	                intl: intl,
	                onDelete: _this3.canDelete(post) ? function () {
	                  return _this3.handleDeletePost(post.id);
	                } : null,
	                onEdit: _this3.canEdit(post) ? _this3.handleEditPost : null
	              }, { communityId: communityId }, post, {
	                isLink: true,
	                isModerator: isModerator,
	                currentUserRole: currentUserRole
	              }))
	            );
	          })
	        )]
	      );
	    }
	  }]);
	  return Posts;
	}(_react.Component), _class3.propTypes = {
	  communityId: _propTypes2.default.number,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  list: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  postDetails: _propTypes2.default.shape({
	    id: _propTypes2.default.number
	  }),
	  deletePost: _propTypes2.default.func,
	  editPost: _propTypes2.default.func,
	  isModerator: _propTypes2.default.bool,
	  currentUserId: _propTypes2.default.number,
	  type: _propTypes2.default.string,
	  communityName: _propTypes2.default.string,
	  currentUserRole: _propTypes2.default.string
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleDeletePost', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleDeletePost'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleEditPost', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleEditPost'), _class2.prototype)), _class2)) || _class) || _class) || _class);
	exports.default = Posts;

/***/ }),
/* 3200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _props = __webpack_require__(41);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _getCommunityTypeText = __webpack_require__(4199);
	
	var _getCommunityTypeText2 = _interopRequireDefault(_getCommunityTypeText);
	
	var _getMembersText = __webpack_require__(4200);
	
	var _getMembersText2 = _interopRequireDefault(_getMembersText);
	
	var _getCommunityAccessType = __webpack_require__(4198);
	
	var _getCommunityAccessType2 = _interopRequireDefault(_getCommunityAccessType);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = function Title(_ref) {
	  var totalUsers = _ref.totalUsers,
	      name = _ref.name,
	      organizationName = _ref.organizationName,
	      type = _ref.type,
	      accessLevel = _ref.accessLevel,
	      totalPosts = _ref.totalPosts,
	      formatMessage = _ref.intl.formatMessage;
	
	  var readOnly = (0, _getCommunityAccessType2.default)(accessLevel, formatMessage);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    (0, _mobileHelpers.isDesktop)() && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'div',
	        { styleName: 'title__name' },
	        name
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'title__desc' },
	        formatMessage(_strings.COMMON.from),
	        ' ',
	        organizationName
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'title__sub' },
	      _react2.default.createElement(
	        'div',
	        { className: 'mr1' },
	        _react2.default.createElement(_Icon2.default, {
	          name: 'icon-private',
	          size: 12,
	          className: 'mr1',
	          style: {
	            minWidth: 12,
	            minHeight: 12,
	            background: _styles.COLORS.grayBluish
	          }
	        }),
	        _react2.default.createElement(
	          'span',
	          { className: 'mr1' },
	          (0, _getCommunityTypeText2.default)(type, formatMessage) + ','
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          readOnly
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'mr1' },
	        _react2.default.createElement(_Icon2.default, {
	          name: 'icon-members',
	          size: 12,
	          className: 'mr1',
	          style: {
	            minWidth: 12,
	            minHeight: 12,
	            background: _styles.COLORS.grayBluish
	          }
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          (0, _getMembersText2.default)(totalUsers, formatMessage)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Icon2.default, {
	          name: 'icon-posts',
	          height: '5%',
	          width: '5%',
	          className: 'mr1',
	          style: { minWidth: 12, minHeight: 12 }
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          totalPosts,
	          ' ',
	          formatMessage(_strings.COMMUNITIES_COMMON.posts)
	        )
	      )
	    )
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	Title.propTypes = {
	  totalUsers: _propTypes2.default.number,
	  name: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(_props.PROPS_LIST.community.type),
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  organizationName: _propTypes2.default.string,
	  accessLevel: _propTypes2.default.string,
	  totalPosts: _propTypes2.default.number
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(Title, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _currentCommunityInfo = __webpack_require__(344);
	
	var _communityPreview = __webpack_require__(1258);
	
	var _communityPostsPreview = __webpack_require__(822);
	
	var _communityImageUpdate = __webpack_require__(820);
	
	var _communityImageRemove = __webpack_require__(819);
	
	var _communityPosts = __webpack_require__(650);
	
	var _currentCommunityScrollStatus = __webpack_require__(1259);
	
	var _postsList = __webpack_require__(166);
	
	var _currentCommunity = __webpack_require__(301);
	
	var _communityPreview2 = __webpack_require__(1266);
	
	var _selectors = __webpack_require__(151);
	
	var _constants = __webpack_require__(17);
	
	var _selectors2 = __webpack_require__(90);
	
	var _withLoggedIn = __webpack_require__(3904);
	
	var _index = __webpack_require__(245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-confusing-arrow,prettier/prettier */
	var mapStateToProps = function mapStateToProps(state, _ref) {
	  var isLoggedIn = _ref.isLoggedIn;
	
	  return {
	    postsList: state.communities.postsList,
	    isDrawerVisible: (0, _selectors2.uiSidebarSelector)(state),
	    temporaryPostList: (0, _currentCommunity.currentCommunityTemporaryPostsSelector)(state),
	    imageProcessing: (0, _selectors.selectCommunityImageProcessing)(state),
	    community: isLoggedIn ? (0, _currentCommunity.currentCommunityInfoSelector)(state) : (0, _communityPreview2.communityPreviewSelector)(state),
	    communityLoading: isLoggedIn ? (0, _currentCommunity.sendingCurrentCommunityInfoSelector)(state) : (0, _communityPreview2.sendingCommunityPreviewSelector)(state)
	  };
	};
	
	var privateActions = function privateActions(d, communityId) {
	  return {
	    fetchCommunity: function fetchCommunity() {
	      return d(_currentCommunityInfo.actions.send({ id: communityId }));
	    },
	    fetchPosts: function fetchPosts() {
	      return d(_communityPosts.actions.getPosts({ communityId: communityId }));
	    },
	    fetchMorePosts: function fetchMorePosts() {
	      return d(_communityPosts.actions.getOlderPosts({ communityId: communityId }));
	    },
	    resetCommunity: function resetCommunity() {
	      return d(_currentCommunityInfo.actions.resetCommunity());
	    },
	    setScrollStatus: function setScrollStatus(payload) {
	      return d(_currentCommunityScrollStatus.actions.setScroll(payload));
	    },
	    addPostsList: function addPostsList(payload) {
	      return d(_postsList.actions.addNewPost(payload));
	    },
	    resetScrollStatus: function resetScrollStatus() {
	      return d(_currentCommunityScrollStatus.actions.reset());
	    },
	    updateImage: function updateImage(data) {
	      return d(_communityImageUpdate.actions.send((0, _extends3.default)({ communityId: communityId }, data)));
	    },
	    removeImage: function removeImage(data) {
	      return d(_communityImageRemove.actions.send((0, _extends3.default)({ communityId: communityId }, data)));
	    }
	  };
	};
	var publicActions = function publicActions(d, communityId) {
	  return {
	    fetchCommunity: function fetchCommunity() {
	      return d(_communityPreview.actions.send({ id: communityId }));
	    },
	    fetchPosts: function fetchPosts() {
	      return d(_communityPostsPreview.actions.getPostsPreview({ communityId: communityId }));
	    },
	    fetchMorePosts: function fetchMorePosts() {
	      return d(_communityPostsPreview.actions.getOlderPostsPreview({ communityId: communityId }));
	    },
	    resetCommunity: function resetCommunity() {
	      return d(_communityPreview.actions.resetCommunity());
	    },
	    updateImage: function updateImage() {},
	    removeImage: function removeImage() {}
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
	  var routeParams = _ref2.routeParams,
	      isLoggedIn = _ref2.isLoggedIn;
	
	  var communityId = +(0, _get2.default)(routeParams, 'communityId');
	
	  return isLoggedIn ? privateActions(dispatch, communityId) : publicActions(dispatch, communityId);
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, _withLoggedIn.withLoggedIn, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref3) {
	  var routeParams = _ref3.routeParams,
	      postsList = _ref3.postsList,
	      _ref3$community = _ref3.community,
	      totalPosts = _ref3$community.totalPosts,
	      currentUserRole = _ref3$community.currentUserRole;
	  return {
	    communityId: +(0, _get2.default)(routeParams, 'communityId'),
	    shouldLoadMore: Boolean(postsList.length && totalPosts > postsList.length),
	    isModerator: currentUserRole === _constants.COMMUNITIES_USER_ROLES.MODERATOR
	  };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _reactIntl = __webpack_require__(5);
	
	var _sanitizeHtml = __webpack_require__(2884);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _ExpandableListItem = __webpack_require__(285);
	
	var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);
	
	var _styles = __webpack_require__(4936);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConsentDetails(_ref) {
	  var total = _ref.total,
	      consent = _ref.consent,
	      onClose = _ref.onClose,
	      onAccept = _ref.onAccept,
	      _ref$details = _ref.details,
	      details = _ref$details === undefined ? {} : _ref$details,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _consent = (0, _extends3.default)({}, consent),
	      idx = _consent.idx,
	      name = _consent.name,
	      content = _consent.content,
	      version = _consent.version,
	      _consent$consentType = _consent.consentType,
	      consentType = _consent$consentType === undefined ? {} : _consent$consentType;
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    { onClose: onClose, title: details.title, opened: Boolean(consent) },
	    _react2.default.createElement(
	      _ExpandableListItem2.default,
	      {
	        locked: true,
	        header: {
	          title: details.for,
	          icon: 'icon-consent',
	          subtitle: details.subtitle
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.consent },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.title },
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.name },
	            name
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: _styles2.default.idx },
	              idx
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _styles2.default.total },
	              '/',
	              total
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.subtitle },
	          (0, _compact2.default)([consentType.name, formatMessage({ id: 'common.version' }) + ' ' + version]).join(', ')
	        ),
	        _react2.default.createElement('div', {
	          className: _styles2.default.content,
	          dangerouslySetInnerHTML: {
	            __html: (0, _sanitizeHtml2.default)(content)
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('bsw2-1', _styles2.default.footer) },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'primary',
	            className: _styles2.default.button,
	            onClick: function onClick() {
	              return onAccept(consent);
	            }
	          },
	          formatMessage({ id: 'common.accept' })
	        )
	      )
	    )
	  );
	}
	
	ConsentDetails.propTypes = {
	  intl: _propTypes2.default.object,
	  total: _propTypes2.default.number,
	  onClose: _propTypes2.default.func,
	  onAccept: _propTypes2.default.func,
	  consent: _propTypes2.default.object,
	  details: _propTypes2.default.object
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl)(ConsentDetails);

/***/ }),
/* 3203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(4938);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConsentItem(_ref) {
	  var consent = _ref.consent,
	      onClick = _ref.onClick,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _consent = (0, _extends3.default)({}, consent),
	      name = _consent.name,
	      accepted = _consent.accepted,
	      version = _consent.version,
	      fileUrl = _consent.fileUrl,
	      _consent$consentType = _consent.consentType,
	      consentType = _consent$consentType === undefined ? {} : _consent$consentType;
	
	  var openConsent = function openConsent() {
	    return accepted && fileUrl ? window.open(fileUrl) : onClick(consent);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.consent, onClick: openConsent },
	    _react2.default.createElement(_Icon2.default, { name: 'icon-document-black', size: 32, className: _styles2.default.icon }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.info },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.title },
	        name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.subtitle },
	        (0, _compact2.default)([consentType.name, formatMessage({ id: 'common.version' }) + ' ' + version]).join(', '),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.assignment },
	          _react2.default.createElement(_Icon2.default, {
	            size: 12,
	            className: _styles2.default.icon,
	            name: accepted ? 'icon-signed-consent' : 'icon-noSigned-consent'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.status },
	            accepted ? formatMessage({ id: 'appointment.consent.signed' }) : formatMessage({ id: 'appointment.consent.notSigned' })
	          )
	        )
	      )
	    )
	  );
	}
	
	ConsentItem.propTypes = {
	  intl: _propTypes2.default.object,
	  onClick: _propTypes2.default.func,
	  consent: _propTypes2.default.object
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl)(ConsentItem);

/***/ }),
/* 3204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _useConsents = __webpack_require__(3205);
	
	Object.defineProperty(exports, 'useConsents', {
	  enumerable: true,
	  get: function get() {
	    return _useConsents.useConsents;
	  }
	});

/***/ }),
/* 3205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toArray2 = __webpack_require__(4302);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useConsents = useConsents;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _differenceBy = __webpack_require__(1554);
	
	var _differenceBy2 = _interopRequireDefault(_differenceBy);
	
	var _ConsentItem = __webpack_require__(3203);
	
	var _ConsentItem2 = _interopRequireDefault(_ConsentItem);
	
	var _ConsentDetails = __webpack_require__(3202);
	
	var _ConsentDetails2 = _interopRequireDefault(_ConsentDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useConsents(_ref) {
	  var _ref$details = _ref.details,
	      details = _ref$details === undefined ? {} : _ref$details,
	      _ref$consents = _ref.consents,
	      consents = _ref$consents === undefined ? [] : _ref$consents,
	      onAccept = _ref.onAccept;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      queue = _useState2[0],
	      setQueue = _useState2[1];
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    var indexed = consents.map(function (item, idx) {
	      return (0, _extends3.default)({}, item, { idx: idx + 1 });
	    });
	    return [indexed, indexed.filter(function (_ref2) {
	      var accepted = _ref2.accepted;
	      return !accepted;
	    })];
	  }, [consents]),
	      _useMemo2 = (0, _slicedToArray3.default)(_useMemo, 2),
	      indexed = _useMemo2[0],
	      forAccept = _useMemo2[1];
	
	  (0, _react.useEffect)(function () {
	    if (queue.length) {
	      var _queue = (0, _toArray3.default)(queue),
	          next = _queue.slice(1);
	
	      setQueue((0, _differenceBy2.default)(next, forAccept));
	    }
	  }, [forAccept]);
	
	  var proxify = (0, _react.useCallback)(function (handler) {
	    return function () {
	      return forAccept.length ? setQueue(forAccept) : handler();
	    };
	  }, [forAccept]);
	
	  var list = _react2.default.createElement(
	    _react.Fragment,
	    null,
	    indexed.map(function (consent) {
	      return _react2.default.createElement(_ConsentItem2.default, {
	        key: consent.id,
	        consent: consent,
	        onClick: function onClick() {
	          return setQueue([consent]);
	        }
	      });
	    }),
	    _react2.default.createElement(_ConsentDetails2.default, {
	      details: details,
	      consent: queue[0],
	      onAccept: onAccept,
	      total: indexed.length,
	      onClose: function onClose() {
	        return setQueue([]);
	      }
	    })
	  );
	
	  return { list: list, proxify: proxify };
	}

/***/ }),
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChangeStatusForm = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _formFields = __webpack_require__(38);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _getFieldProps = __webpack_require__(117);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOCATION = _formFields.PROFILE_FIELDS_TYPES.LOCATION,
	    REASON_TYPE = _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE,
	    REASON_NOTE = _formFields.PROFILE_FIELDS_TYPES.REASON_NOTE,
	    REASON_TYPE_ID = _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID,
	    REASON_COMMENT = _formFields.PROFILE_FIELDS_TYPES.REASON_COMMENT;
	var ChangeStatusForm = exports.ChangeStatusForm = function ChangeStatusForm(_ref) {
	  var formatMessage = _ref.formatMessage,
	      errors = _ref.errors,
	      _onChange2 = _ref.onChange,
	      locationsList = _ref.locationsList,
	      reasonList = _ref.reasonList,
	      locationId = _ref.locationId,
	      reasonTypeId = _ref.reasonTypeId,
	      note = _ref.note;
	
	  var makeField = (0, _getFieldProps.getFieldProps)(formatMessage, _onChange2);
	  var error = (0, _get2.default)(errors, 'description') || { id: 'common.error' };
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(LOCATION, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      options: locationsList,
	      value: locationId,
	      needUpdateDefaultValue: true
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(REASON_TYPE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      options: reasonList,
	      value: reasonTypeId,
	      needUpdateDefaultValue: true,
	      name: REASON_TYPE_ID,
	      onChange: function onChange(_ref2) {
	        var value = _ref2.value;
	        return _onChange2((0, _defineProperty3.default)({}, REASON_TYPE_ID, value));
	      }
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(REASON_NOTE, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      value: note,
	      name: REASON_COMMENT,
	      onChange: function onChange(value) {
	        return _onChange2((0, _defineProperty3.default)({}, REASON_COMMENT, value));
	      }
	    })),
	    Boolean(errors) ? _react2.default.createElement(_ErrorBlock2.default, { errors: error, className: 'mt3' }) : null
	  );
	};
	
	ChangeStatusForm.propTypes = {
	  errors: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({ description: PropTypes.string })]),
	  formatMessage: PropTypes.func,
	  onChange: PropTypes.func,
	  locationId: PropTypes.number,
	  reasonTypeId: PropTypes.number,
	  note: PropTypes.string,
	  locationsList: PropTypes.array,
	  reasonList: PropTypes.array
	};

/***/ }),
/* 3215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _changeStatusReq = __webpack_require__(525);
	
	var changeStatusReq = _interopRequireWildcard(_changeStatusReq);
	
	var _selectors = __webpack_require__(134);
	
	var _popup = __webpack_require__(76);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    pending: (0, _selectors.selectChangeStatusPending)(state),
	    errors: (0, _selectors.selectChangeStatusError)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  changeStatus: changeStatusReq.actions.send,
	  hidePopup: _popup.actions.hide
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getVisitFormData = __webpack_require__(1738);
	
	var _useStatusInfoFormState = __webpack_require__(3229);
	
	var _ChangeStatusForm = __webpack_require__(3214);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChangeStatusModal = function ChangeStatusModal(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      errors = _ref.errors,
	      options = _ref.options,
	      pending = _ref.pending,
	      hidePopup = _ref.hidePopup,
	      changeStatus = _ref.changeStatus;
	
	  var _useChangeStatusForm = (0, _useStatusInfoFormState.useChangeStatusForm)(),
	      isValid = _useChangeStatusForm.isValid,
	      formState = _useChangeStatusForm.formState,
	      handleFormChange = _useChangeStatusForm.handleFormChange;
	
	  var id = options.id,
	      status = options.status;
	  var statusId = status.id,
	      statusChangeLocations = status.statusChangeLocations,
	      statusChangeReasonTypes = status.statusChangeReasonTypes;
	
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    changeStatus((0, _extends3.default)({ id: id, statusId: statusId }, formState));
	  };
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handleSubmit, className: pending ? 'disabled' : '' },
	    _react2.default.createElement(_ChangeStatusForm.ChangeStatusForm, (0, _extends3.default)({}, formState, {
	      formatMessage: formatMessage,
	      onChange: handleFormChange,
	      locationsList: (0, _getVisitFormData.getVisitFormOptions)(statusChangeLocations),
	      reasonList: (0, _getVisitFormData.getVisitFormOptions)(statusChangeReasonTypes),
	      errors: errors
	    })),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt3' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'mr3',
	          type: 'submit',
	          raised: true,
	          color: 'primary',
	          disabled: !isValid || pending
	        },
	        formatMessage({ id: 'common.save' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'mr3',
	          type: 'button',
	          onClick: hidePopup,
	          raised: true,
	          color: 'accent'
	        },
	        formatMessage({ id: 'common.cancel' })
	      )
	    )
	  );
	};
	
	ChangeStatusModal.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  changeStatus: _propTypes2.default.func,
	  pending: _propTypes2.default.bool,
	  options: _propTypes2.default.object,
	  hidePopup: _propTypes2.default.func,
	  errors: _propTypes2.default.object
	};
	
	exports.default = (0, _enhance.enhance)(ChangeStatusModal);

/***/ }),
/* 3217 */,
/* 3218 */,
/* 3219 */,
/* 3220 */,
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */,
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleUpdateStatusSurveyInDetails = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleUpdateStatusSurveyInDetails = exports.handleUpdateStatusSurveyInDetails = function handleUpdateStatusSurveyInDetails(state, _ref) {
	  var payload = _ref.payload;
	
	  var target = state.activeAppointment;
	  if (!target) return state;
	
	  var handleReplaceItem = function handleReplaceItem(allItem, item) {
	    if (item) {
	      var index = allItem.findIndex(function (_ref2) {
	        var assignmentId = _ref2.assignmentId;
	
	        return item.assignmentId === assignmentId;
	      });
	      allItem.splice(index, 1, item);
	      return allItem;
	    }
	  };
	
	  return (0, _extends3.default)({}, state, {
	    activeAppointment: (0, _extends3.default)({}, target, {
	      surveyAssignments: handleReplaceItem(target.surveyAssignments, payload)
	    })
	  });
	};

/***/ }),
/* 3229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateRequiredFields = exports.initialState = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialState;
	
	exports.useChangeStatusForm = useChangeStatusForm;
	
	var _formFields = __webpack_require__(38);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = (_initialState = {}, (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.LOCATION, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.REASON_COMMENT, null), _initialState);
	
	var validateRequiredFields = exports.validateRequiredFields = (0, _useFormWithValidation.makeRequiredFieldsValidator)([_formFields.PROFILE_FIELDS_TYPES.LOCATION, _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID]);
	
	function useChangeStatusForm() {
	  var _useFormState = (0, _useFormWithValidation.useFormState)(initialState),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var isValid = validateRequiredFields(formState);
	
	  return {
	    isValid: isValid,
	    formState: formState,
	    handleFormChange: handleFormChange
	  };
	}

/***/ }),
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PatientInfoForm = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _formFields = __webpack_require__(38);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _PasswordInput = __webpack_require__(335);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _DateDropdown = __webpack_require__(498);
	
	var _DateDropdown2 = _interopRequireDefault(_DateDropdown);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _SSNField = __webpack_require__(1171);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LAST_NAME = _formFields.PROFILE_FIELDS_TYPES.LAST_NAME,
	    FIRST_NAME = _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME,
	    DOB = _formFields.PROFILE_FIELDS_TYPES.DOB,
	    SSN = _formFields.PROFILE_FIELDS_TYPES.SSN,
	    LOGIN = _formFields.PROFILE_FIELDS_TYPES.LOGIN,
	    EMAIL = _formFields.PROFILE_FIELDS_TYPES.EMAIL,
	    PHONE_NUMBER = _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER;
	var PatientInfoForm = exports.PatientInfoForm = function PatientInfoForm(_ref) {
	  var firstName = _ref.firstName,
	      lastName = _ref.lastName,
	      validateErrors = _ref.validateErrors,
	      dob = _ref.dob,
	      ssn = _ref.ssn,
	      login = _ref.login,
	      formatMessage = _ref.formatMessage,
	      onChange = _ref.onChange,
	      serverError = _ref.serverError;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, onChange);
	  var errors = serverError && _react2.default.createElement(_reactIntl.FormattedMessage, serverError);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(FIRST_NAME), { value: firstName })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: FIRST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(LAST_NAME), { value: lastName })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: LAST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_SSNField.SSNField, {
	      formatMessage: formatMessage,
	      children: _react2.default.createElement(_PasswordInput2.default, (0, _extends3.default)({}, makeProfileField(SSN), { value: ssn }))
	    }),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: SSN, errors: validateErrors }),
	    _react2.default.createElement(_DateDropdown2.default, (0, _extends3.default)({}, makeProfileField(DOB), { value: dob })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(LOGIN, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      value: login,
	      label: formatMessage({ id: 'profile.fields.emailOrPhone' })
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: EMAIL || PHONE_NUMBER, errors: validateErrors }),
	    serverError && _react2.default.createElement(_ErrorBlock2.default, { errors: errors, className: 'mt3' })
	  );
	};
	
	PatientInfoForm.propTypes = {
	  validateErrors: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({ description: PropTypes.string })]),
	  ssn: PropTypes.string,
	  formatMessage: PropTypes.func,
	  firstName: PropTypes.string,
	  lastName: PropTypes.string,
	  onChange: PropTypes.func,
	  dob: PropTypes.string,
	  login: PropTypes.string,
	  serverError: PropTypes.object
	};

/***/ }),
/* 3236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _record = __webpack_require__(834);
	
	var _selectors = __webpack_require__(134);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    patientValidationError: (0, _selectors.selectDashboardPatientRecordValidationError)(state),
	    commonErrors: (0, _selectors.selectDashboardPatientCommonErrors)(state),
	    pending: (0, _selectors.selectSendingValidatePatientInfo)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  validatePatientInfo: _record.actions.validatePatientInfo,
	  clearRecordErrors: _record.actions.clearErrors
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omitBy = __webpack_require__(983);
	
	var _omitBy2 = _interopRequireDefault(_omitBy);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _usePatientInfoFormState = __webpack_require__(3244);
	
	var _PatientInfoForm = __webpack_require__(3235);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3236);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardPatientInfo = function DashboardPatientInfo(_ref) {
	  var serverError = _ref.patientValidationError,
	      validatePatientInfo = _ref.validatePatientInfo,
	      clearRecordErrors = _ref.clearRecordErrors,
	      formatMessage = _ref.formatMessage,
	      commonErrors = _ref.commonErrors,
	      pending = _ref.pending,
	      patient = _ref.patient;
	
	  var _usePatientInfoForm = (0, _usePatientInfoFormState.usePatientInfoForm)(patient, commonErrors),
	      handleFormChange = _usePatientInfoForm.handleFormChange,
	      validateErrors = _usePatientInfoForm.validateErrors,
	      clearErrors = _usePatientInfoForm.clearErrors,
	      formState = _usePatientInfoForm.formState,
	      isValid = _usePatientInfoForm.isValid;
	
	  (0, _react.useEffect)(function () {
	    clearErrors();
	    clearRecordErrors();
	  }, [formState]);
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    validatePatientInfo({
	      data: (0, _omitBy2.default)(formState, _isEmpty2.default)
	    });
	  };
	
	  var disabled = !isValid || Boolean(serverError) || Boolean(commonErrors) || pending;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'section' },
	    _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('content', { disabled: pending }) },
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'label',
	          { styleName: 'form--label' },
	          formatMessage({ id: 'dashboard.record.patientInfo' })
	        ),
	        _react2.default.createElement(_PatientInfoForm.PatientInfoForm, (0, _extends3.default)({}, formState, {
	          formatMessage: formatMessage,
	          validateErrors: validateErrors,
	          onChange: handleFormChange,
	          serverError: serverError
	        })),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'btn-block' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'mr3',
	              type: 'submit',
	              raised: true,
	              color: 'primary',
	              disabled: disabled
	            },
	            formatMessage({ id: 'common.next' })
	          )
	        )
	      )
	    )
	  );
	};
	
	DashboardPatientInfo.propTypes = {
	  validatePatientInfo: PropTypes.func,
	  formatMessage: PropTypes.func,
	  pending: PropTypes.bool,
	  patientValidationError: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	  commonErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	  patient: PropTypes.object,
	  clearRecordErrors: PropTypes.func
	};
	
	exports.default = (0, _enhance.enhance)(DashboardPatientInfo);

/***/ }),
/* 3238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VisitInfoForm = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _formFields = __webpack_require__(38);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _getFieldProps = __webpack_require__(117);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROOM = _formFields.PROFILE_FIELDS_TYPES.ROOM,
	    SERVICE = _formFields.PROFILE_FIELDS_TYPES.SERVICE,
	    LOCATION = _formFields.PROFILE_FIELDS_TYPES.LOCATION,
	    PROVIDER = _formFields.PROFILE_FIELDS_TYPES.PROVIDER,
	    REASON_TYPE = _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE,
	    REASON_NOTE = _formFields.PROFILE_FIELDS_TYPES.REASON_NOTE,
	    REASON_COMMENT = _formFields.PROFILE_FIELDS_TYPES.REASON_COMMENT,
	    PAYMENT_STATUS = _formFields.PROFILE_FIELDS_TYPES.PAYMENT_STATUS,
	    REASON_TYPE_ID = _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID;
	var VisitInfoForm = exports.VisitInfoForm = function VisitInfoForm(_ref) {
	  var errors = _ref.errors,
	      formatMessage = _ref.formatMessage,
	      _onChange2 = _ref.onChange,
	      locationsList = _ref.locationsList,
	      servicesList = _ref.servicesList,
	      reasonList = _ref.reasonList,
	      paymentStatusList = _ref.paymentStatusList,
	      searchProvider = _ref.searchProvider,
	      providersList = _ref.providersList,
	      isLoadingProviders = _ref.isLoadingProviders,
	      locationId = _ref.locationId,
	      serviceId = _ref.serviceId,
	      reasonTypeId = _ref.reasonTypeId,
	      note = _ref.note,
	      providerId = _ref.providerId,
	      room = _ref.room,
	      paymentStatus = _ref.paymentStatus;
	
	  var makeField = (0, _getFieldProps.getFieldProps)(formatMessage, _onChange2);
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(LOCATION, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      options: locationsList,
	      value: locationId,
	      needUpdateDefaultValue: true
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(SERVICE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      options: servicesList,
	      value: serviceId,
	      needUpdateDefaultValue: true,
	      disabled: !locationId
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(REASON_TYPE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      options: reasonList,
	      value: reasonTypeId,
	      needUpdateDefaultValue: true,
	      disabled: !serviceId,
	      name: REASON_TYPE_ID,
	      onChange: function onChange(_ref2) {
	        var value = _ref2.value;
	        return _onChange2((0, _defineProperty3.default)({}, REASON_TYPE_ID, value));
	      }
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(REASON_NOTE, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      value: note,
	      name: REASON_COMMENT,
	      onChange: function onChange(value) {
	        return _onChange2((0, _defineProperty3.default)({}, REASON_COMMENT, value));
	      }
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(PROVIDER, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      onInputChange: searchProvider,
	      options: providersList,
	      value: providerId,
	      canSearch: true,
	      isLoading: isLoadingProviders
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(ROOM, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      value: room
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(PAYMENT_STATUS, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      options: paymentStatusList,
	      value: paymentStatus,
	      needUpdateDefaultValue: true
	    })),
	    Boolean(errors) ? _react2.default.createElement(_ErrorBlock2.default, { errors: (0, _get2.default)(errors, 'description'), className: 'mt3' }) : null
	  );
	};
	
	VisitInfoForm.propTypes = {
	  errors: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({ description: PropTypes.string })]),
	  formatMessage: PropTypes.func,
	  onChange: PropTypes.func,
	  locationId: PropTypes.number,
	  serviceId: PropTypes.number,
	  reasonTypeId: PropTypes.number,
	  note: PropTypes.string,
	  providerId: PropTypes.number,
	  room: PropTypes.string,
	  paymentStatus: PropTypes.string,
	  locationsList: PropTypes.array,
	  servicesList: PropTypes.array,
	  reasonList: PropTypes.array,
	  paymentStatusList: PropTypes.array,
	  searchProvider: PropTypes.func,
	  providersList: PropTypes.array,
	  isLoadingProviders: PropTypes.bool
	};

/***/ }),
/* 3239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _appointmentLocationsReq = __webpack_require__(1274);
	
	var locationReq = _interopRequireWildcard(_appointmentLocationsReq);
	
	var _createAppointmentReq = __webpack_require__(836);
	
	var createAppointmentReq = _interopRequireWildcard(_createAppointmentReq);
	
	var _selectors = __webpack_require__(134);
	
	var _reqAllUsers = __webpack_require__(637);
	
	var _AllUsers = __webpack_require__(1252);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    locationsList: (0, _selectors.selectAppointmentsRecordLocations)(state),
	    loadingLocations: (0, _selectors.selectLoadingAppointmentsLocations)(state),
	    providersList: (0, _AllUsers.usersSelector)(state),
	    isLoadingProviders: (0, _AllUsers.sendingSelector)(state),
	    pending: (0, _selectors.selectSendingCreateAppointmentReq)(state),
	    rejected: (0, _selectors.selectRejectedCreateAppointmentReq)(state),
	    errors: (0, _selectors.selectCreateAppointmentReqError)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  locationsReq: locationReq.actions.send,
	  createAppointment: createAppointmentReq.actions.send,
	  clearAppointmentReq: createAppointmentReq.actions.clear,
	  getProviders: _reqAllUsers.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _debounce = __webpack_require__(176);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _reactRouter = __webpack_require__(42);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _useVisitInfoFormState = __webpack_require__(3245);
	
	var _VisitInfoForm = __webpack_require__(3238);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TimePickerButton = __webpack_require__(3886);
	
	var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);
	
	var _getVisitFormData = __webpack_require__(1738);
	
	var _strings = __webpack_require__(15);
	
	var _formFields = __webpack_require__(38);
	
	var _dateConverters = __webpack_require__(83);
	
	var _getSelectOptions = __webpack_require__(1163);
	
	var _props = __webpack_require__(41);
	
	var _errors = __webpack_require__(120);
	
	var _routes = __webpack_require__(37);
	
	var _addRecordSaga = __webpack_require__(4051);
	
	var _addRecordSaga2 = _interopRequireDefault(_addRecordSaga);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _injectSaga = __webpack_require__(116);
	
	var _convertVisitTime = __webpack_require__(3243);
	
	var _enhance = __webpack_require__(3239);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValidDayOfWeek = function isValidDayOfWeek(list) {
	  var today = (0, _moment2.default)().format('dddd').toLocaleLowerCase();
	  return list[today];
	};
	
	var DashboardVisitInfo = function DashboardVisitInfo(_ref) {
	  var errors = _ref.errors,
	      formatMessage = _ref.formatMessage,
	      pending = _ref.pending,
	      rejected = _ref.rejected,
	      locationsReq = _ref.locationsReq,
	      locationsList = _ref.locationsList,
	      createAppointment = _ref.createAppointment,
	      patient = _ref.patient,
	      getProviders = _ref.getProviders,
	      providersList = _ref.providersList,
	      loadingLocations = _ref.loadingLocations,
	      isLoadingProviders = _ref.isLoadingProviders,
	      clearAppointmentReq = _ref.clearAppointmentReq;
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'addRecordSaga',
	    saga: _addRecordSaga2.default
	  });
	
	  var _useVisitInfoForm = (0, _useVisitInfoFormState.useVisitInfoForm)(),
	      handleFormChange = _useVisitInfoForm.handleFormChange,
	      formState = _useVisitInfoForm.formState,
	      isValid = _useVisitInfoForm.isValid;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      pickedTime = _useState2[0],
	      setPickedTime = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      error = _useState4[0],
	      setError = _useState4[1];
	
	  var location = formState[_formFields.PROFILE_FIELDS_TYPES.LOCATION];
	  var service = formState[_formFields.PROFILE_FIELDS_TYPES.SERVICE];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      recordErrors = _useState6[0],
	      setRecordError = _useState6[1];
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      opened = _useToggleFlag2[0],
	      openConfirm = _useToggleFlag2[1],
	      closeConfirm = _useToggleFlag2[2];
	
	  (0, _react.useEffect)(function () {
	    if (rejected) {
	      var code = (0, _get2.default)(errors, 'code');
	      if (_errors.DASHBOARD_RECORD_CAPACITY_ERRORS.includes(code)) {
	        openConfirm();
	      } else {
	        setRecordError(errors);
	      }
	    }
	  }, [rejected, errors]);
	
	  var locationSchedule = (0, _react.useMemo)(function () {
	    var currentLocation = locationsList.find(function (_ref2) {
	      var id = _ref2.id;
	      return id === location;
	    });
	    return (0, _get2.default)(currentLocation, 'schedule');
	  }, [locationsList, location]);
	
	  var _ref3 = locationSchedule || {},
	      startTime = _ref3.startTime,
	      endTime = _ref3.endTime,
	      bookingTimeOffset = _ref3.bookingTimeOffset,
	      weekdays = _ref3.weekdays;
	
	  (0, _react.useEffect)(function () {
	    if ((0, _isEmpty2.default)(patient)) {
	      _reactRouter.browserHistory.push(_routes.DASHBOARD_RECORD + '/' + _routes.PATIENT_INFO);
	    } else {
	      locationsReq({
	        creatableOnDashboard: true
	      });
	    }
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    var isValidDay = location ? isValidDayOfWeek(weekdays) : true;
	
	    if (!isValidDay) {
	      var validationError = formatMessage({
	        id: 'dashboard.record.notWorkingDay'
	      });
	      setError(validationError);
	    } else {
	      setError('');
	    }
	  }, [location, weekdays]);
	
	  (0, _react.useEffect)(function () {
	    setPickedTime('');
	  }, [location]);
	
	  var serviceList = (0, _react.useMemo)(function () {
	    return (0, _getVisitFormData.getSelectableList)(locationsList, location, 'services');
	  }, [location, locationsList]);
	
	  var visitReasonList = (0, _react.useMemo)(function () {
	    return (0, _getVisitFormData.getSelectableList)(serviceList, service, 'reasonTypes');
	  }, [service, serviceList]);
	
	  var timePickerBtnText = (0, _react.useMemo)(function () {
	    return formatMessage({
	      id: pickedTime ? 'dashboard.record.changeTime' : 'dashboard.record.chooseTime'
	    });
	  }, [pickedTime]);
	
	  var inlineBtnText = (0, _react.useMemo)(function () {
	    return formatMessage({
	      id: pickedTime ? 'dashboard.record.addInLine' : 'dashboard.record.addInLineNow'
	    });
	  }, [pickedTime]);
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    onCreateAppointment(false);
	  };
	
	  var onCreateAppointment = function onCreateAppointment(ignoreCapacityLimit) {
	    var time = pickedTime ? (0, _convertVisitTime.getRecordVisitTime)(pickedTime, _props.DASHBOARD_TIME_VALIDATION_RULES.format) : null;
	
	    var data = {
	      appointment: (0, _extends3.default)({}, formState, { startTime: time, ignoreCapacityLimit: ignoreCapacityLimit }),
	      patient: patient
	    };
	    createAppointment(data);
	  };
	
	  var capacityText = (0, _react.useMemo)(function () {
	    var message = (0, _get2.default)(errors, 'meta.message');
	    return message || 'errors.common';
	  }, [errors]);
	
	  var handleCloseConfirm = function handleCloseConfirm() {
	    clearAppointmentReq();
	    closeConfirm();
	  };
	
	  var handleTimeSave = function handleTimeSave(time) {
	    setPickedTime(time);
	  };
	
	  var debouncedFetch = (0, _react.useCallback)((0, _debounce2.default)(function (search) {
	    if (!search) {
	      return;
	    }
	    getProviders({
	      type: _strings.CIRCLE_PROVIDER,
	      query: search,
	      limit: 20,
	      dashboardProviderSearch: true
	    });
	  }, 100), []);
	
	  function handleSearchProvider(inputValue) {
	    debouncedFetch(inputValue);
	  }
	
	  var validateTime = function validateTime(time) {
	    var pickerTime = (0, _convertVisitTime.convertVisitTime)(time, _props.DASHBOARD_TIME_VALIDATION_RULES.format);
	    var recordEndTimeWithOffset = (0, _moment2.default)(endTime, _props.DASHBOARD_TIME_VALIDATION_RULES.format).subtract(bookingTimeOffset, 'minutes').utcOffset(endTime).format(_props.DASHBOARD_TIME_VALIDATION_RULES.format);
	
	    var workingTime = {
	      startTime: startTime,
	      endTime: recordEndTimeWithOffset,
	      format: _props.DASHBOARD_TIME_VALIDATION_RULES.format
	    };
	
	    var isValidTime = (0, _dateConverters.isBetweenTimeRange)((0, _extends3.default)({}, workingTime, {
	      time: (0, _moment2.default)(pickerTime, _props.DASHBOARD_TIME_VALIDATION_RULES.format).utcOffset(startTime).format(_props.DASHBOARD_TIME_VALIDATION_RULES.format)
	    }));
	
	    if (!isValidTime) return formatMessage({
	      id: 'dashboard.record.validTime'
	    }, {
	      startTime: (0, _moment2.default)(startTime, _props.DASHBOARD_TIME_VALIDATION_RULES.format).local().format('HH:mm A'),
	      endTime: (0, _moment2.default)(recordEndTimeWithOffset, _props.DASHBOARD_TIME_VALIDATION_RULES.format).local().format('HH:mm A')
	    });
	  };
	
	  if (loadingLocations) return _react2.default.createElement(_Loader2.default, null);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'section' },
	    _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('content', { disabled: pending }) },
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'label',
	          { styleName: 'form--label' },
	          formatMessage({ id: 'dashboard.record.aboutVisit' })
	        ),
	        _react2.default.createElement(_VisitInfoForm.VisitInfoForm, (0, _extends3.default)({}, formState, {
	          formatMessage: formatMessage,
	          errors: recordErrors,
	          onChange: handleFormChange,
	          locationsList: (0, _getVisitFormData.getVisitFormOptions)(locationsList),
	          servicesList: (0, _getVisitFormData.getVisitFormOptions)(serviceList),
	          reasonList: (0, _getVisitFormData.getVisitFormOptions)(visitReasonList),
	          paymentStatusList: (0, _getSelectOptions.getSelectOptions)((0, _keys2.default)(_props.PAYMENT_STATUS)),
	          searchProvider: handleSearchProvider,
	          providersList: (0, _getVisitFormData.getVisitFormOptions)(providersList, 'providerProfileId', 'displayableName'),
	          isLoadingProviders: isLoadingProviders
	        })),
	        error ? _react2.default.createElement(_ErrorBlock2.default, { errors: error, className: 'mt3' }) : null,
	        _react2.default.createElement(
	          'div',
	          { styleName: 'btn-block' },
	          Boolean(pickedTime) ? _react2.default.createElement(
	            'span',
	            { className: 'mr2 f-14 o-70' },
	            formatMessage({ id: 'dashboard.record.visitTime' }),
	            ' ',
	            (0, _moment2.default)(pickedTime, 'HH:mm').format('HH:mm A')
	          ) : null,
	          _react2.default.createElement(_TimePickerButton2.default, {
	            title: timePickerBtnText,
	            saveButtonTitle: formatMessage({ id: 'common.ok' }),
	            cancelButtonTitle: formatMessage({ id: 'common.cancel' }),
	            disabled: !isValid || pending,
	            onSave: handleTimeSave,
	            validateTime: validateTime,
	            format: 'formatted24'
	          }),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'mr3',
	              type: 'submit',
	              raised: true,
	              color: 'primary',
	              disabled: !isValid || pending
	            },
	            inlineBtnText
	          )
	        )
	      ),
	      _react2.default.createElement(_ActionConfirmation2.default, {
	        width: 'xsmall',
	        danger: false,
	        opened: opened,
	        body: capacityText,
	        title: formatMessage({ id: 'dashboard.modal.title' }),
	        actionButtonText: formatMessage({ id: 'surveys.actions.proceed' }),
	        onClose: handleCloseConfirm,
	        onSubmit: function onSubmit() {
	          return onCreateAppointment(true);
	        }
	      })
	    )
	  );
	};
	
	DashboardVisitInfo.propTypes = {
	  formatMessage: PropTypes.func,
	  pending: PropTypes.bool,
	  rejected: PropTypes.bool,
	  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	  locationsReq: PropTypes.func,
	  createAppointment: PropTypes.func,
	  locationsList: PropTypes.array,
	  patient: PropTypes.object,
	  getProviders: PropTypes.func,
	  providersList: PropTypes.array,
	  loadingLocations: PropTypes.bool,
	  isLoadingProviders: PropTypes.bool,
	  clearAppointmentReq: PropTypes.func
	};
	
	exports.default = (0, _enhance.enhance)(DashboardVisitInfo);

/***/ }),
/* 3241 */,
/* 3242 */,
/* 3243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRecordVisitTime = exports.convertVisitTime = undefined;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var convertVisitTime = exports.convertVisitTime = function convertVisitTime(time, format) {
	  return (0, _moment2.default)(time, 'HH:mm').format(format);
	};
	
	var getRecordVisitTime = exports.getRecordVisitTime = function getRecordVisitTime(time, format) {
	  var pickerTime = convertVisitTime(time, format);
	
	  var startRecordTime = _moment2.default.utc(pickerTime, format);
	
	  return startRecordTime.isBefore(_moment2.default.utc(), 'day') ? startRecordTime.add(1, 'day').format() : startRecordTime.format();
	};

/***/ }),
/* 3244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialState;
	
	exports.usePatientInfoForm = usePatientInfoForm;
	
	var _react = __webpack_require__(1);
	
	var _lodash = __webpack_require__(58);
	
	var _reactRedux = __webpack_require__(6);
	
	var _formFields = __webpack_require__(38);
	
	var _selectors = __webpack_require__(50);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = (_initialState = {}, (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.SSN, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.DOB, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.LOGIN, null), _initialState);
	
	function usePatientInfoForm(state, errors) {
	  var _useFormState = (0, _useFormWithValidation.useFormState)(initialState),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var _useFormValidation = (0, _useFormWithValidation.useFormValidation)(errors),
	      validateErrors = _useFormValidation.validateErrors,
	      clearErrors = _useFormValidation.clearErrors;
	
	  var ssnHidingEnabled = (0, _reactRedux.useSelector)(_selectors.selectSsnHidingEnabled);
	
	  var isValid = (0, _useFormWithValidation.makeLocalFieldsValidation)([_formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, _formFields.PROFILE_FIELDS_TYPES.DOB, _formFields.PROFILE_FIELDS_TYPES.LOGIN].concat((0, _toConsumableArray3.default)(!ssnHidingEnabled ? [_formFields.PROFILE_FIELDS_TYPES.SSN] : [])))(formState);
	
	  (0, _react.useEffect)(function () {
	    if (state) {
	      var populate = (0, _lodash.mapValues)(initialState, function (value, key) {
	        return state[key] || null;
	      });
	
	      handleFormChange(populate);
	    }
	  }, [state]);
	
	  return {
	    formState: formState,
	    handleFormChange: handleFormChange,
	    validateErrors: validateErrors,
	    clearErrors: clearErrors,
	    isValid: isValid
	  };
	}

/***/ }),
/* 3245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateRequiredFields = exports.initialState = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialState;
	
	exports.useVisitInfoForm = useVisitInfoForm;
	
	var _react = __webpack_require__(1);
	
	var _lodash = __webpack_require__(58);
	
	var _formFields = __webpack_require__(38);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = (_initialState = {}, (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.LOCATION, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.SERVICE, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.REASON_COMMENT, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.PROVIDER, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.ROOM, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.PAYMENT_STATUS, null), _initialState);
	
	var validateRequiredFields = exports.validateRequiredFields = (0, _useFormWithValidation.makeRequiredFieldsValidator)([_formFields.PROFILE_FIELDS_TYPES.LOCATION, _formFields.PROFILE_FIELDS_TYPES.SERVICE, _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID]);
	
	function useVisitInfoForm() {
	  var _useFormState = (0, _useFormWithValidation.useFormState)(initialState),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var location = formState[_formFields.PROFILE_FIELDS_TYPES.LOCATION];
	  var service = formState[_formFields.PROFILE_FIELDS_TYPES.SERVICE];
	
	  function populateData(fieldKey) {
	    if (formState) {
	      var populate = (0, _lodash.mapValues)(formState, function (value, key) {
	        if (key === fieldKey) return null;
	
	        return formState[key] || null;
	      });
	      handleFormChange(populate);
	    }
	  }
	
	  (0, _react.useEffect)(function () {
	    populateData(_formFields.PROFILE_FIELDS_TYPES.SERVICE);
	  }, [location]);
	
	  (0, _react.useEffect)(function () {
	    populateData(_formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID);
	  }, [service]);
	
	  var isValid = validateRequiredFields(formState);
	
	  return {
	    formState: formState,
	    handleFormChange: handleFormChange,
	    isValid: isValid
	  };
	}

/***/ }),
/* 3246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _upcoming = __webpack_require__(309);
	
	var _answered = __webpack_require__(355);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(158);
	
	var _index = __webpack_require__(4944);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    answeredList: (0, _selectors2.answeredListSelector)(state),
	    upcomingList: (0, _selectors2.selectUpcomingList)(state),
	    answeredListCounter: (0, _selectors2.selectAnsweredListCounter)(state),
	    upcomingListCounter: (0, _selectors2.selectUpcomingListCounter)(state),
	    answeredSending: (0, _selectors2.selectAnsweredListSending)(state),
	    upcomingSending: (0, _selectors2.selectUpcomingSending)(state),
	    targetUserId: (0, _selectors.targetUserIdSelector)(state)
	  };
	};
	var mapDispatchToProps = {
	  fetchUpcomingSurveys: _upcoming.actions.send,
	  fetchAnsweredSurveys: _answered.actions.send,
	  loadNextUpcomingReq: _upcoming.paginatedActions.loadNextRequests,
	  loadNextAnsweredReq: _answered.paginatedActions.loadNextRequests
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var answeredSending = _ref.answeredSending,
	      upcomingSending = _ref.upcomingSending;
	  return {
	    loading: answeredSending || upcomingSending
	  };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _SurveyList = __webpack_require__(1804);
	
	var _SurveyList2 = _interopRequireDefault(_SurveyList);
	
	var _CommonTabs = __webpack_require__(255);
	
	var _withLazyLoad = __webpack_require__(620);
	
	var _withLazyLoad2 = _interopRequireDefault(_withLazyLoad);
	
	var _constants = __webpack_require__(17);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _SurveysResults = __webpack_require__(1805);
	
	var _SurveysResults2 = _interopRequireDefault(_SurveysResults);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _strings = __webpack_require__(15);
	
	var _enhance = __webpack_require__(3246);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataSurvey = function DataSurvey(_ref) {
	  var loadNextUpcomingReq = _ref.loadNextUpcomingReq,
	      loadNextAnsweredReq = _ref.loadNextAnsweredReq,
	      formatMessage = _ref.intl.formatMessage,
	      fetchAnsweredSurveys = _ref.fetchAnsweredSurveys,
	      fetchUpcomingSurveys = _ref.fetchUpcomingSurveys,
	      answeredListCounter = _ref.answeredListCounter,
	      upcomingListCounter = _ref.upcomingListCounter,
	      answeredList = _ref.answeredList,
	      upcomingList = _ref.upcomingList,
	      targetUserId = _ref.targetUserId,
	      loading = _ref.loading;
	
	  var _useState = (0, _react.useState)(_constants.SURVEYS_LIST_TYPE.UPCOMING),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  var tabs = useTabs(upcomingListCounter, answeredListCounter);
	  var isEmpty = !upcomingListCounter && !answeredListCounter;
	
	  (0, _usePageView.usePageView)('Profile | Surveys');
	  (0, _react.useEffect)(function () {
	    if (!targetUserId) return;
	    fetchAnsweredSurveys({
	      id: targetUserId,
	      limit: 20
	    });
	
	    fetchUpcomingSurveys({
	      id: targetUserId,
	      limit: 20
	    });
	  }, [targetUserId]);
	
	  (0, _react.useEffect)(function () {
	    if (!loading && !upcomingListCounter && answeredListCounter) {
	      setActiveTab(_constants.SURVEYS_LIST_TYPE.RESULTS);
	    }
	  }, [upcomingListCounter, answeredListCounter, loading]);
	
	  var loadMore = (0, _react.useCallback)(function () {
	    var params = {
	      id: targetUserId,
	      limit: 10
	    };
	    if (activeTab === _constants.SURVEYS_LIST_TYPE.UPCOMING) loadNextUpcomingReq(params);
	    if (activeTab === _constants.SURVEYS_LIST_TYPE.RESULTS) loadNextAnsweredReq(params);
	  }, [activeTab]);
	
	  var getCurrentSurveys = function getCurrentSurveys(tab) {
	    switch (tab) {
	      case _constants.SURVEYS_LIST_TYPE.UPCOMING:
	        return _react2.default.createElement(_SurveyList2.default, {
	          surveys: upcomingList,
	          loadMore: loadMore,
	          className: 'pt3'
	        });
	      case _constants.SURVEYS_LIST_TYPE.RESULTS:
	        return _react2.default.createElement(
	          _withLazyLoad2.default,
	          { loadMore: loadMore },
	          _react2.default.createElement(_SurveysResults2.default, {
	            surveys: answeredList,
	            locked: false,
	            hideTitle: true,
	            className: 'pt3'
	          })
	        );
	      default:
	        return null;
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'h-100 w-90 relative center' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.profile.surveys' }),
	    loading && _react2.default.createElement(_Loader2.default, null),
	    !loading && !isEmpty && _react2.default.createElement(_CommonTabs.CommonTabs, {
	      onTabSelect: setActiveTab,
	      activeTab: activeTab,
	      tabList: tabs,
	      renderContent: function renderContent(tab) {
	        return getCurrentSurveys(tab);
	      },
	      styleName: 'content'
	    }),
	    !loading && isEmpty && _react2.default.createElement(_Content2.default, {
	      icon: 'no-surveys',
	      text: formatMessage(_strings.SURVEYS_ANSWERED_EMPTY),
	      className: 'absolute-center g-color--primary'
	    })
	  );
	};
	
	DataSurvey.propTypes = {
	  loadNextUpcomingReq: _propTypes2.default.func,
	  loadNextAnsweredReq: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  fetchAnsweredSurveys: _propTypes2.default.func,
	  fetchUpcomingSurveys: _propTypes2.default.func,
	  answeredListCounter: _propTypes2.default.number,
	  upcomingListCounter: _propTypes2.default.number,
	  answeredList: _propTypes2.default.array,
	  upcomingList: _propTypes2.default.array,
	  targetUserId: _propTypes2.default.number,
	  loading: _propTypes2.default.bool
	};
	
	exports.default = (0, _enhance.enhance)(DataSurvey);
	
	
	function useTabs(upcomingCounter, answeredCounter) {
	  return (0, _react.useMemo)(function () {
	    var tabs = [];
	    if (upcomingCounter) tabs.push({
	      label: 'surveys.actions.upcomingTitle',
	      tab: _constants.SURVEYS_LIST_TYPE.UPCOMING,
	      id: _constants.SURVEYS_LIST_TYPE.UPCOMING,
	      counter: upcomingCounter
	    });
	
	    if (answeredCounter) tabs.push({
	      label: 'surveys.actions.resultsTitle',
	      tab: _constants.SURVEYS_LIST_TYPE.RESULTS,
	      id: _constants.SURVEYS_LIST_TYPE.RESULTS,
	      counter: answeredCounter
	    });
	    return tabs;
	  }, [upcomingCounter, answeredCounter]);
	}

/***/ }),
/* 3248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _popup = __webpack_require__(76);
	
	var _usePageView = __webpack_require__(52);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _gtag = __webpack_require__(182);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(167);
	
	var _constants = __webpack_require__(17);
	
	var _myProfileRedirect = __webpack_require__(682);
	
	var DependentComplete = function DependentComplete() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _usePageView.usePageView)('Add Dependent | Complete');
	
	  var id = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	  var submitRedirect = (0, _reactRedux.useSelector)(_selectors2.selectDependentFormSubmitRedirect);
	
	  (0, _react.useEffect)(function () {
	    var options = { onClose: redirectToGetCare };
	    dispatch((0, _popup.showDependentCreateModal)(options));
	  }, []);
	
	  var redirectToGetCare = function redirectToGetCare() {
	    if (submitRedirect === _constants.DEPENDENT_FORM_SUBMIT_REDIRECT.GET_CARE) {
	      (0, _redirectUtils.redirectToUsers)(id, false);
	      (0, _gtag.GATrackCustomEvent)(_gtag.CustomEvents.GET_CARE_START);
	    } else if (submitRedirect === _constants.DEPENDENT_FORM_SUBMIT_REDIRECT.PROFILE) {
	      dispatch(_myProfileRedirect.myProfileRedirectActions.goToProfile());
	    }
	  };
	
	  return null;
	};
	
	exports.default = DependentComplete;

/***/ }),
/* 3249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(167);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    dependentFormUser: (0, _selectors.selectDependentFormUserData)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _handleDocumentsErrorSaga = __webpack_require__(4069);
	
	var _progress = __webpack_require__(121);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _injectSaga = __webpack_require__(116);
	
	var _enhance = __webpack_require__(3249);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _InsuranceForm = __webpack_require__(615);
	
	var _InsuranceForm2 = _interopRequireDefault(_InsuranceForm);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _useGetPatientInsuranceData = __webpack_require__(799);
	
	var _useGetPatientInsuranceData2 = _interopRequireDefault(_useGetPatientInsuranceData);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FLOW_TYPE = _insuranceFlowType.INSURANCE_FLOW_TYPE.GET_CARE_FLOW;
	
	var DependentDocuments = function DependentDocuments(_ref) {
	  var goNext = _ref.goNext,
	      titleWithRole = _ref.titleWithRole,
	      dependentFormUser = _ref.dependentFormUser;
	
	  (0, _usePageView.usePageView)('Add Dependent | Documents');
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'handleDependentDocumentsErrorsSaga',
	    saga: _handleDocumentsErrorSaga.handleDependentDocumentsErrorsSaga,
	    mode: _sagaInjectors.RESTART_ON_REMOUNT
	  });
	
	  var userId = dependentFormUser.id;
	  var userName = dependentFormUser.displayableName;
	
	  var _useGetPatientInsuran = (0, _useGetPatientInsuranceData2.default)({
	    flowType: FLOW_TYPE,
	    userId: userId
	  }),
	      insuranceData = _useGetPatientInsuran.insuranceData,
	      isInsuranceRelatedDataFetching = _useGetPatientInsuran.isInsuranceRelatedDataFetching;
	
	  var handleSubmit = function handleSubmit() {
	    goNext({
	      step: _progress.DEPENDENT_FORM_STEPS.DOCUMENTS,
	      data: {}
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'section' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.dependentDocuments' }),
	    titleWithRole,
	    isInsuranceRelatedDataFetching ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(_InsuranceForm2.default, {
	      flowType: FLOW_TYPE,
	      insuranceData: insuranceData,
	      navigateToNextPage: handleSubmit,
	      userId: userId,
	      userName: userName,
	      withSelfPayEnding: true
	    })
	  );
	};
	
	DependentDocuments.propTypes = {
	  goNext: PropTypes.func,
	  dependentFormUser: PropTypes.object,
	  titleWithRole: PropTypes.node
	};
	
	exports.default = (0, _enhance.enhance)(DependentDocuments);

/***/ }),
/* 3251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(167);
	
	var _myProfileRedirect = __webpack_require__(682);
	
	var _sendMessage = __webpack_require__(1254);
	
	var sendMessage = _interopRequireWildcard(_sendMessage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    guardianList: (0, _selectors.selectDependentGuardianList)(state),
	    loading: (0, _selectors.selectDependentGuardianListLoading)(state)
	  };
	};
	var mapDispatchToProps = {
	  redirectToProfile: _myProfileRedirect.myProfileRedirectActions.goToProfile,
	  sendMessage: sendMessage.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _CollapsedSendMessagePopup = __webpack_require__(3843);
	
	var _CollapsedSendMessagePopup2 = _interopRequireDefault(_CollapsedSendMessagePopup);
	
	var _enhance = __webpack_require__(3251);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DependentExistingUser = function DependentExistingUser(_ref) {
	  var guardianList = _ref.guardianList,
	      redirectToProfile = _ref.redirectToProfile,
	      sendMessage = _ref.sendMessage,
	      loading = _ref.loading,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(true),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      showPopup = _useState2[0],
	      togglePopup = _useState2[1];
	
	  (0, _usePageView.usePageView)('Add Dependent | Existing User');
	
	  var handleSubmit = function handleSubmit(body, recipientId) {
	    var message = { body: body, recipientId: recipientId };
	    sendMessage({ message: message });
	  };
	  var handleClose = function handleClose() {
	    togglePopup(false);
	    redirectToProfile();
	  };
	
	  return _react2.default.createElement(_CollapsedSendMessagePopup2.default, {
	    icon: 'icon-plane',
	    loading: loading,
	    description: formatMessage({ id: 'dependent.dependentExists' }),
	    profiles: guardianList,
	    opened: showPopup,
	    onSubmit: handleSubmit,
	    onClose: handleClose
	  });
	};
	
	DependentExistingUser.propTypes = {
	  redirectToProfile: PropTypes.func,
	  sendMessage: PropTypes.func,
	  guardianList: PropTypes.array,
	  loading: PropTypes.bool,
	  intl: PropTypes.shape({
	    formatMessage: PropTypes.func
	  }).isRequired
	};
	
	exports.default = (0, _enhance.enhance)(DependentExistingUser);

/***/ }),
/* 3253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _formFields = __webpack_require__(38);
	
	var _utils = __webpack_require__(233);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _useLoggedUserCountry = __webpack_require__(1104);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADDRESS_1 = _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1,
	    ADDRESS_2 = _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2,
	    CITY = _formFields.PROFILE_FIELDS_TYPES.CITY,
	    STATE = _formFields.PROFILE_FIELDS_TYPES.STATE,
	    POSTAL_CODE = _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE,
	    COUNTRY = _formFields.PROFILE_FIELDS_TYPES.COUNTRY;
	
	
	var GeneralInfoAddressForm = function GeneralInfoAddressForm(_ref) {
	  var postalCode = _ref.postalCode,
	      address1 = _ref.address1,
	      address2 = _ref.address2,
	      city = _ref.city,
	      state = _ref.state,
	      country = _ref.country,
	      validateErrors = _ref.validateErrors,
	      formatMessage = _ref.formatMessage,
	      _onChange = _ref.onChange,
	      statesList = _ref.statesList,
	      countryList = _ref.countryList,
	      zipLimit = _ref.zipLimit,
	      onCountryChange = _ref.onCountryChange,
	      isZipApplicable = _ref.isZipApplicable,
	      zipExamples = _ref.zipExamples,
	      loadCountryDetails = _ref.loadCountryDetails;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, _onChange);
	  var targetCountryEntity = (0, _useLoggedUserCountry.useLoggedUserCountry)();
	
	  var handleCountryChange = (0, _react.useMemo)(function () {
	    return function (data) {
	      if (!data) return;
	      if (country === data || country === data.label) {
	        onCountryChange(data);
	        return;
	      }
	      onCountryChange(data);
	    };
	  }, [country, targetCountryEntity, address1, city]);
	
	  var safeCountry = (0, _utils.adaptInitialValueCountry)(country, countryList);
	  var safeState = (0, _utils.adaptInitialValueState)(state, statesList);
	
	  (0, _react.useEffect)(function () {
	    if (targetCountryEntity) loadCountryDetails(targetCountryEntity.value);
	    if (country) {
	      var countryEntity = (0, _utils.adaptInitialValueCountry)(country.label, countryList);
	      loadCountryDetails(countryEntity.value);
	    }
	  }, [targetCountryEntity, country]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.column },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(ADDRESS_1, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	          value: address1,
	          required: false
	        })),
	        _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: ADDRESS_1, errors: validateErrors })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(ADDRESS_2, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	          value: address2,
	          required: false
	        })),
	        _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: ADDRESS_2, errors: validateErrors })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.column },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(CITY, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	          required: false,
	          value: city
	        })),
	        _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: CITY, errors: validateErrors })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(STATE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	          onChange: function onChange(data) {
	            return _onChange({ state: data });
	          },
	          value: safeState,
	          options: statesList,
	          needUpdateDefaultValue: true,
	          required: false
	        })),
	        _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: STATE, errors: validateErrors })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.column },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(POSTAL_CODE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	          limit: zipLimit,
	          value: postalCode,
	          disabled: !isZipApplicable,
	          shouldUpperCase: true,
	          required: false
	        })),
	        (0, _get2.default)(validateErrors, POSTAL_CODE) ? _react2.default.createElement(_ErrorBlock2.default, {
	          errors: [formatMessage({ id: 'errors.validation.profile.postalCode.format' }, { example: zipExamples })],
	          className: 'mt3 w-100'
	        }) : null
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(COUNTRY, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	          onChange: function onChange(val) {
	            return handleCountryChange(val);
	          },
	          value: safeCountry || targetCountryEntity,
	          options: countryList,
	          needUpdateDefaultValue: true,
	          required: false
	        })),
	        _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: COUNTRY, errors: validateErrors })
	      )
	    )
	  );
	};
	
	GeneralInfoAddressForm.propTypes = {
	  formatMessage: PropTypes.func,
	  postalCode: PropTypes.string,
	  city: PropTypes.string,
	  country: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	  state: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	  validateErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	  address1: PropTypes.string,
	  address2: PropTypes.string,
	  phoneNumber: PropTypes.string,
	  onChange: PropTypes.func,
	  statesList: PropTypes.array,
	  countryList: PropTypes.array,
	  zipLimit: PropTypes.number,
	  onCountryChange: PropTypes.func,
	  isZipApplicable: PropTypes.bool,
	  zipExamples: PropTypes.string,
	  loadCountryDetails: PropTypes.func
	};
	
	exports.default = GeneralInfoAddressForm;

/***/ }),
/* 3254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _formFields = __webpack_require__(38);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _strings = __webpack_require__(15);
	
	var _MobilePhone = __webpack_require__(776);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMAIL = _formFields.PROFILE_FIELDS_TYPES.EMAIL,
	    PHONE_NUMBER = _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER;
	
	
	var GeneralInfoContactForm = function GeneralInfoContactForm(_ref) {
	  var email = _ref.email,
	      phoneNumber = _ref.phoneNumber,
	      formatMessage = _ref.formatMessage,
	      onChange = _ref.onChange,
	      validateErrors = _ref.validateErrors;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, onChange);
	
	  var handlePhoneChange = function handlePhoneChange(phone) {
	    onChange((0, _defineProperty3.default)({}, PHONE_NUMBER, phone));
	  };
	
	  var emailError = validateErrors[EMAIL] && (0, _defineProperty3.default)({}, EMAIL, formatMessage({ id: 'error.alreadyTakenEmail' }));
	  var phoneNumberError = validateErrors[PHONE_NUMBER] && (0, _defineProperty3.default)({}, PHONE_NUMBER, formatMessage({ id: 'error.invalidPhoneNumber' }));
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(EMAIL, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      value: email
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: EMAIL, errors: emailError }),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt3', styleName: 'and-or' },
	      formatMessage(_strings.DIALOG_TITLE.andOr)
	    ),
	    _react2.default.createElement(_MobilePhone.MobilePhone, (0, _extends3.default)({}, makeProfileField(PHONE_NUMBER, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      value: phoneNumber,
	      formatMessage: formatMessage,
	      onChange: handlePhoneChange
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: PHONE_NUMBER, errors: phoneNumberError })
	  );
	};
	
	GeneralInfoContactForm.propTypes = {
	  formatMessage: PropTypes.func,
	  email: PropTypes.string,
	  phoneNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  onChange: PropTypes.func,
	  validateErrors: PropTypes.object
	};
	
	exports.default = (0, _reactCssModules2.default)(GeneralInfoContactForm, _styles2.default, {
	  allowMultiple: true
	});

/***/ }),
/* 3255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(167);
	
	var _selectors2 = __webpack_require__(50);
	
	var _assignmentFetchReq = __webpack_require__(1283);
	
	var assignmentFetch = _interopRequireWildcard(_assignmentFetchReq);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    assignmentId: (0, _selectors.selectDependentFormAssigmentId)(state),
	    dependentInfo: (0, _selectors.selectDependentFormUserData)(state),
	    dataValidationErrors: (0, _selectors.selectDependentFormGeneralInfoErrors)(state),
	    dependent: (0, _selectors.selectDependentFormDependent)(state),
	    registrationSteps: (0, _selectors.selectDependentFormRegistrationSteps)(state),
	    statesList: (0, _selectors2.selectUsStates)(state),
	    countryList: (0, _selectors2.selectCountryOptions)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchAssignment: assignmentFetch.actions.send,
	  clearAssignment: assignmentFetch.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _progress = __webpack_require__(121);
	
	var _useCountrySelect2 = __webpack_require__(145);
	
	var _deepTrim = __webpack_require__(357);
	
	var _deepTrim2 = _interopRequireDefault(_deepTrim);
	
	var _ids = __webpack_require__(46);
	
	var _AvatarWithCropModal = __webpack_require__(3819);
	
	var _AvatarWithCropModal2 = _interopRequireDefault(_AvatarWithCropModal);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _useGeneralInfoFormState = __webpack_require__(3267);
	
	var _GeneralInfoContactForm = __webpack_require__(3254);
	
	var _GeneralInfoContactForm2 = _interopRequireDefault(_GeneralInfoContactForm);
	
	var _GeneralInfoAddressForm = __webpack_require__(3253);
	
	var _GeneralInfoAddressForm2 = _interopRequireDefault(_GeneralInfoAddressForm);
	
	var _enhance = __webpack_require__(3255);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DependentGeneralInfo = function DependentGeneralInfo(_ref) {
	  var errors = _ref.dataValidationErrors,
	      formatMessage = _ref.formatMessage,
	      goNext = _ref.goNext,
	      pending = _ref.pending,
	      dependentInfo = _ref.dependentInfo,
	      assignmentId = _ref.assignmentId,
	      fetchAssignment = _ref.fetchAssignment,
	      clearAssignment = _ref.clearAssignment,
	      dependent = _ref.dependent,
	      registrationSteps = _ref.registrationSteps,
	      titleWithRole = _ref.titleWithRole,
	      countryList = _ref.countryList;
	
	  (0, _usePageView.usePageView)('Add Dependent | General Info');
	
	  (0, _react.useEffect)(function () {
	    if (registrationSteps[_progress.DEPENDENT_FORM_STEPS.GENERAL]) fetchAssignment({ id: assignmentId });
	    return function () {
	      return clearAssignment();
	    };
	  }, []);
	
	  var _useAvatarState = (0, _useGeneralInfoFormState.useAvatarState)(dependentInfo),
	      handleImageRemove = _useAvatarState.handleImageRemove,
	      handleImageCrop = _useAvatarState.handleImageCrop,
	      avatar = _useAvatarState.avatar;
	
	  var _useCountrySelect = (0, _useCountrySelect2.useCountrySelect)(formatMessage),
	      loadCountryDetails = _useCountrySelect.loadCountryDetails,
	      stateList = _useCountrySelect.stateList,
	      zipLimit = _useCountrySelect.zipLimit,
	      isZipApplicable = _useCountrySelect.isZipApplicable,
	      zipExamples = _useCountrySelect.zipExamples;
	
	  var _useGeneralInfoFormSt = (0, _useGeneralInfoFormState.useGeneralInfoFormState)(dependent || dependentInfo, errors, isZipApplicable),
	      handleFormChange = _useGeneralInfoFormSt.handleFormChange,
	      validateErrors = _useGeneralInfoFormSt.validateErrors,
	      setCountryValue = _useGeneralInfoFormSt.setCountryValue,
	      clearErrors = _useGeneralInfoFormSt.clearErrors,
	      formState = _useGeneralInfoFormSt.formState,
	      isValid = _useGeneralInfoFormSt.isValid;
	
	  (0, _react.useEffect)(function () {
	    var city = dependent.city,
	        postalCode = dependent.postalCode,
	        address1 = dependent.address1,
	        country = dependent.country,
	        state = dependent.state,
	        email = dependent.email,
	        phoneNumber = dependent.phoneNumber,
	        emailFake = dependent.emailFake;
	
	    handleFormChange((0, _extends3.default)({}, formState, dependent && (0, _extends3.default)({}, city && { city: city }, postalCode && { postalCode: postalCode }, address1 && { address1: address1 }, !emailFake && email && { email: email }, {
	      phoneNumber: phoneNumber
	    }, state && { state: { value: state, label: state } }, country && { country: { value: country, label: country } })));
	  }, [dependent]);
	
	  var onCountryChange = function onCountryChange(data) {
	    clearErrors();
	    loadCountryDetails(data.value);
	    setCountryValue(data);
	  };
	
	  (0, _react.useEffect)(function () {
	    clearErrors();
	  }, []);
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	
	    var fullCountryName = (0, _get2.default)(formState, 'country.label', '');
	    var fullStateName = (0, _get2.default)(formState, 'state.label', '');
	
	    clearErrors();
	    goNext({
	      step: _progress.DEPENDENT_FORM_STEPS.GENERAL,
	      data: (0, _deepTrim2.default)((0, _extends3.default)({}, formState, {
	        country: fullCountryName,
	        state: fullStateName,
	        avatar: avatar
	      }))
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'section' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.dependentGeneral' }),
	    titleWithRole,
	    _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('content', { disabled: pending }) },
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit, className: 'flex flex-column' },
	        _react2.default.createElement(
	          'label',
	          { styleName: 'form--label' },
	          formatMessage({ id: 'profile.section.general' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'avatar' },
	          _react2.default.createElement(_AvatarWithCropModal2.default, {
	            size: 96,
	            onImageRemove: handleImageRemove,
	            onImageCrop: handleImageCrop,
	            edit: true,
	            formatMessage: formatMessage,
	            url: avatar,
	            offsetX: 20
	          })
	        ),
	        _react2.default.createElement(_GeneralInfoContactForm2.default, (0, _extends3.default)({}, formState, {
	          validateErrors: validateErrors,
	          formatMessage: formatMessage,
	          onChange: handleFormChange
	        })),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'address-form' },
	          _react2.default.createElement(
	            'label',
	            { styleName: 'form--label' },
	            formatMessage({ id: 'profile.section.address' })
	          ),
	          _react2.default.createElement(_GeneralInfoAddressForm2.default, (0, _extends3.default)({}, formState, {
	            validateErrors: validateErrors,
	            onCountryChange: onCountryChange,
	            zipLimit: zipLimit,
	            isZipApplicable: isZipApplicable,
	            formatMessage: formatMessage,
	            onChange: handleFormChange,
	            statesList: stateList,
	            countryList: countryList,
	            zipExamples: zipExamples,
	            loadCountryDetails: loadCountryDetails
	          }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'btn-block' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'mr3',
	              id: _ids.IDS.ADD_DEPENDENT.NEXT,
	              type: 'submit',
	              raised: true,
	              color: 'primary',
	              disabled: !isValid || pending
	            },
	            formatMessage({ id: 'common.next' })
	          )
	        )
	      )
	    )
	  );
	};
	
	DependentGeneralInfo.propTypes = {
	  dataValidationErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	  dependentInfo: PropTypes.object,
	  titleWithRole: PropTypes.node,
	  formatMessage: PropTypes.func,
	  goNext: PropTypes.func,
	  pending: PropTypes.bool,
	  assignmentId: PropTypes.number,
	  fetchAssignment: PropTypes.func.isRequired,
	  clearAssignment: PropTypes.func.isRequired,
	  dependent: PropTypes.object,
	  registrationSteps: PropTypes.object,
	  statesList: PropTypes.array,
	  countryList: PropTypes.array
	};
	
	exports.default = (0, _enhance.enhance)(DependentGeneralInfo);

/***/ }),
/* 3257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PersonalInfoForm = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _formFields = __webpack_require__(38);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _PasswordInput = __webpack_require__(335);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _DateDropdown = __webpack_require__(498);
	
	var _DateDropdown2 = _interopRequireDefault(_DateDropdown);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _SSNField = __webpack_require__(1171);
	
	var _selectors = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LAST_NAME = _formFields.PROFILE_FIELDS_TYPES.LAST_NAME,
	    FIRST_NAME = _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME,
	    MIDDLE_NAME = _formFields.PROFILE_FIELDS_TYPES.MIDDLE_NAME,
	    DOB = _formFields.PROFILE_FIELDS_TYPES.DOB,
	    GENDER = _formFields.PROFILE_FIELDS_TYPES.GENDER,
	    SSN = _formFields.PROFILE_FIELDS_TYPES.SSN,
	    NAME_SUFFIX = _formFields.PROFILE_FIELDS_TYPES.NAME_SUFFIX;
	var PersonalInfoForm = exports.PersonalInfoForm = function PersonalInfoForm(_ref) {
	  var firstName = _ref.firstName,
	      lastName = _ref.lastName,
	      middleName = _ref.middleName,
	      validateErrors = _ref.validateErrors,
	      nameSuffixList = _ref.nameSuffixList,
	      genderList = _ref.genderList,
	      nameSuffix = _ref.nameSuffix,
	      dob = _ref.dob,
	      gender = _ref.gender,
	      ssn = _ref.ssn,
	      formatMessage = _ref.formatMessage,
	      onChange = _ref.onChange;
	
	  var ssnHidingEnabled = (0, _reactRedux.useSelector)(_selectors.selectSsnHidingEnabled);
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, onChange);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    validateErrors.careUserId && _react2.default.createElement(_ErrorBlock2.default, {
	      errors: formatMessage({ id: 'dependent.form.careUserIdError' }),
	      className: 'mt3'
	    }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(FIRST_NAME), { value: firstName })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: FIRST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(MIDDLE_NAME), { value: middleName })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: MIDDLE_NAME, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(LAST_NAME), { value: lastName })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: LAST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(NAME_SUFFIX), {
	      options: nameSuffixList,
	      value: nameSuffix,
	      needUpdateDefaultValue: true
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(GENDER), {
	      options: genderList,
	      value: gender,
	      needUpdateDefaultValue: true
	    })),
	    _react2.default.createElement(_DateDropdown2.default, (0, _extends3.default)({}, makeProfileField(DOB), { value: dob })),
	    !ssnHidingEnabled && _react2.default.createElement(_SSNField.SSNField, {
	      formatMessage: formatMessage,
	      children: _react2.default.createElement(_PasswordInput2.default, (0, _extends3.default)({}, makeProfileField(SSN, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	        value: ssn
	      }))
	    }),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: SSN, errors: validateErrors })
	  );
	};
	
	PersonalInfoForm.propTypes = {
	  validateErrors: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({ description: PropTypes.string })]),
	  nameSuffixList: PropTypes.array,
	  genderList: PropTypes.array,
	  nameSuffix: PropTypes.string,
	  ssn: PropTypes.string,
	  formatMessage: PropTypes.func,
	  firstName: PropTypes.string,
	  lastName: PropTypes.string,
	  gender: PropTypes.string,
	  middleName: PropTypes.string,
	  onChange: PropTypes.func,
	  dob: PropTypes.string
	};

/***/ }),
/* 3258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	var _personalInfoReq = __webpack_require__(659);
	
	var personalInfoReq = _interopRequireWildcard(_personalInfoReq);
	
	var _selectors = __webpack_require__(167);
	
	var _selectors2 = __webpack_require__(50);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    dataValidationErrors: (0, _selectors.selectDependentFormPersonalInfoErrors)(state),
	    nameSuffixList: (0, _selectors2.selectNameSuffixesList)(state),
	    rawGenderList: (0, _selectors2.selectGenderTypes)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  clearPersonalReq: personalInfoReq.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var formatMessage = _ref.formatMessage,
	      rawGenderList = _ref.rawGenderList;
	  return {
	    genderList: (0, _convertListWithLocalization.convertGenderList)(rawGenderList, formatMessage) || []
	  };
	}), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _progress = __webpack_require__(121);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _usePersonalInfoFormState = __webpack_require__(3268);
	
	var _deepTrim = __webpack_require__(357);
	
	var _deepTrim2 = _interopRequireDefault(_deepTrim);
	
	var _PersonalInfoForm = __webpack_require__(3257);
	
	var _ids = __webpack_require__(46);
	
	var _enhance = __webpack_require__(3258);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DependentPersonalInfo = function DependentPersonalInfo(_ref) {
	  var errors = _ref.dataValidationErrors,
	      clearPersonalReq = _ref.clearPersonalReq,
	      titleWithRole = _ref.titleWithRole,
	      formatMessage = _ref.formatMessage,
	      genderList = _ref.genderList,
	      nameSuffixList = _ref.nameSuffixList,
	      goNext = _ref.goNext,
	      pending = _ref.pending;
	
	  var _usePersonalInfoForm = (0, _usePersonalInfoFormState.usePersonalInfoForm)(errors),
	      handleFormChange = _usePersonalInfoForm.handleFormChange,
	      validateErrors = _usePersonalInfoForm.validateErrors,
	      clearErrors = _usePersonalInfoForm.clearErrors,
	      formState = _usePersonalInfoForm.formState,
	      isValid = _usePersonalInfoForm.isValid;
	
	  (0, _usePageView.usePageView)('Add Dependent | Personal Info');
	
	  (0, _react.useEffect)(function () {
	    return clearPersonalReq;
	  }, []);
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    clearErrors();
	    goNext({
	      step: _progress.DEPENDENT_FORM_STEPS.PERSONAL,
	      data: (0, _deepTrim2.default)(formState)
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'section' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.dependentPersonal' }),
	    titleWithRole,
	    _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('content', { disabled: pending }) },
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'label',
	          { styleName: 'form--label' },
	          formatMessage({ id: 'profile.section.personal' })
	        ),
	        _react2.default.createElement(_PersonalInfoForm.PersonalInfoForm, (0, _extends3.default)({}, formState, {
	          nameSuffixList: nameSuffixList,
	          genderList: genderList,
	          formatMessage: formatMessage,
	          validateErrors: validateErrors,
	          onChange: handleFormChange
	        })),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'btn-block' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'mr3',
	              id: _ids.IDS.ADD_DEPENDENT.NEXT,
	              type: 'submit',
	              raised: true,
	              color: 'primary',
	              disabled: !isValid || pending
	            },
	            formatMessage({ id: 'common.next' })
	          )
	        )
	      )
	    )
	  );
	};
	
	DependentPersonalInfo.propTypes = {
	  goNext: PropTypes.func,
	  clearPersonalReq: PropTypes.func,
	  titleWithRole: PropTypes.node,
	  formatMessage: PropTypes.func,
	  genderList: PropTypes.array,
	  nameSuffixList: PropTypes.array,
	  pending: PropTypes.bool,
	  dataValidationErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
	};
	
	exports.default = (0, _enhance.enhance)(DependentPersonalInfo);

/***/ }),
/* 3260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(167);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isCareUserCreator: (0, _selectors.selectDependentFormIsCareUserCreator)(state),
	    role: (0, _selectors.selectDependentFormRole)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _convertListWithLocalization = __webpack_require__(186);
	
	var _progress = __webpack_require__(121);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _ids = __webpack_require__(46);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3260);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DependentRelation = function DependentRelation(_ref) {
	  var goNext = _ref.goNext,
	      titleWithRole = _ref.titleWithRole,
	      formatMessage = _ref.formatMessage,
	      pending = _ref.pending,
	      isCareUserCreator = _ref.isCareUserCreator,
	      role = _ref.role;
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      relation = _useState2[0],
	      setRelation = _useState2[1];
	
	  var roleOptions = (0, _react.useMemo)(function () {
	    return role === _constants.DEPENDENT_ROLES.PARENT ? _strings.PARENT_OPTIONS : _strings.FAMILY_MEMBERS_OPTIONS;
	  }, [role]);
	  var options = (0, _convertListWithLocalization.convertRelationsList)(roleOptions, formatMessage);
	  (0, _usePageView.usePageView)('Add Dependent | Relationship');
	
	  var handleRelationChange = function handleRelationChange(option) {
	    return setRelation((0, _get2.default)(option, 'value'));
	  };
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    goNext({
	      step: _progress.DEPENDENT_FORM_STEPS.RELATION,
	      data: { role: relation }
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'section' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.dependentRelation' }),
	    titleWithRole,
	    _react2.default.createElement(
	      'p',
	      { styleName: 'sub-title' },
	      isCareUserCreator ? formatMessage({ id: 'dependent.form.relationshipSubTitle' }) : formatMessage({ id: 'dependent.form.relationshipExistSubTitle' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('content', { disabled: pending }) },
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(_SelectCustom2.default, {
	          id: _ids.IDS.FORM_FIELDS.RELATIONSHIP,
	          onChange: handleRelationChange,
	          multi: false,
	          name: 'role',
	          label: formatMessage({ id: 'dependent.form.relationshipLabel' }),
	          options: options,
	          placeholder: formatMessage({
	            id: 'profile.fields.relationship.placeholder'
	          }),
	          value: relation,
	          searchable: false
	        }),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'btn-block' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'mr3',
	              id: _ids.IDS.ADD_DEPENDENT.NEXT,
	              type: 'submit',
	              raised: true,
	              color: 'primary',
	              disabled: !relation || pending
	            },
	            formatMessage({ id: 'submit.fillProfile' })
	          )
	        )
	      )
	    )
	  );
	};
	
	DependentRelation.propTypes = {
	  goNext: PropTypes.func,
	  titleWithRole: PropTypes.node,
	  formatMessage: PropTypes.func,
	  pending: PropTypes.bool,
	  isCareUserCreator: PropTypes.bool,
	  role: PropTypes.string
	};
	
	exports.default = (0, _enhance.enhance)(DependentRelation);

/***/ }),
/* 3262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _styles = __webpack_require__(4946);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoleCard = function RoleCard(_ref) {
	  var title = _ref.title,
	      text = _ref.text,
	      id = _ref.id,
	      role = _ref.role,
	      onCardClick = _ref.onCardClick,
	      disabled = _ref.disabled;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      id: id,
	      styleName: (0, _classnames2.default)('root', { disabled: disabled }),
	      onClick: function onClick() {
	        return onCardClick(role);
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'row' },
	      _react2.default.createElement(
	        'p',
	        { styleName: 'title' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: title })
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { styleName: 'text' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: text })
	    )
	  );
	};
	
	RoleCard.propTypes = {
	  onCardClick: PropTypes.func.isRequired,
	  role: PropTypes.string.isRequired,
	  title: PropTypes.string.isRequired,
	  text: PropTypes.string.isRequired,
	  id: PropTypes.string.isRequired,
	  disabled: PropTypes.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true })(RoleCard);

/***/ }),
/* 3263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _progress = __webpack_require__(121);
	
	var _roleList = __webpack_require__(3266);
	
	var _RoleCard = __webpack_require__(3262);
	
	var _RoleCard2 = _interopRequireDefault(_RoleCard);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DependentRole = function DependentRole(_ref) {
	  var printTitle = _ref.printTitle,
	      goNext = _ref.goNext;
	
	  (0, _usePageView.usePageView)('Add Dependent | Role');
	  var handleRoleSelect = function handleRoleSelect(role) {
	    goNext({
	      step: _progress.DEPENDENT_FORM_STEPS.ROLE,
	      data: { role: role }
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.dependentRole' }),
	    printTitle('dependent.form.selectRoleTitle'),
	    _roleList.roleList.map(function (_ref2) {
	      var role = _ref2.role,
	          id = _ref2.id,
	          title = _ref2.title,
	          translateId = _ref2.translateId,
	          disabled = _ref2.disabled;
	      return _react2.default.createElement(_RoleCard2.default, {
	        onCardClick: handleRoleSelect,
	        disabled: disabled,
	        text: translateId,
	        title: title,
	        key: id,
	        id: id,
	        role: role
	      });
	    })
	  );
	};
	
	DependentRole.propTypes = {
	  printTitle: PropTypes.func,
	  goNext: PropTypes.func
	};
	
	exports.default = DependentRole;

/***/ }),
/* 3264 */,
/* 3265 */,
/* 3266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.roleList = undefined;
	
	var _constants = __webpack_require__(17);
	
	var _ids = __webpack_require__(46);
	
	var roleList = exports.roleList = [{
	  id: _ids.IDS.DEPENDENT_ROLES.PARENT,
	  role: _constants.DEPENDENT_ROLES.PARENT,
	  title: 'dependent.form.parentTitle',
	  translateId: 'dependent.form.parentInfo',
	  isLegal: false
	}, {
	  id: _ids.IDS.DEPENDENT_ROLES.GUARDIAN,
	  role: _constants.DEPENDENT_ROLES.GUARDIAN,
	  title: 'dependent.form.guardianTitle',
	  translateId: 'dependent.form.guardianInfo',
	  isLegal: true
	}, {
	  id: _ids.IDS.DEPENDENT_ROLES.PROXY,
	  role: _constants.DEPENDENT_ROLES.PROXY,
	  title: 'dependent.form.proxyTitle',
	  translateId: 'dependent.form.proxyInfo',
	  isLegal: true
	}];

/***/ }),
/* 3267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateRequiredFields = exports.initialState = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialState;
	
	exports.useGeneralInfoFormState = useGeneralInfoFormState;
	exports.useAvatarState = useAvatarState;
	
	var _react = __webpack_require__(1);
	
	var _lodash = __webpack_require__(58);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = (_initialState = {}, (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.EMAIL, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.CITY, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.STATE, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, ''), _initialState);
	
	var validateRequiredFields = exports.validateRequiredFields = function validateRequiredFields() {
	  var isZipApplicable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  return (0, _useFormWithValidation.makeRequiredFieldsValidator)([_formFields.PROFILE_FIELDS_TYPES.ADDRESS_1, _formFields.PROFILE_FIELDS_TYPES.CITY, _formFields.PROFILE_FIELDS_TYPES.STATE].concat((0, _toConsumableArray3.default)(isZipApplicable && [_formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE])));
	};
	
	function useGeneralInfoFormState(data, errors, isZipApplicable) {
	  var _useFormState = (0, _useFormWithValidation.useFormState)(initialState),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var _useFormValidation = (0, _useFormWithValidation.useFormValidation)(errors),
	      validateErrors = _useFormValidation.validateErrors,
	      clearErrors = _useFormValidation.clearErrors,
	      addLocalValidateErrors = _useFormValidation.addLocalValidateErrors;
	
	  // todo: enhance is valid with validateErrors obj
	
	
	  var isValid = validateRequiredFields(isZipApplicable)(formState);
	
	  var setCountryValue = function setCountryValue(value) {
	    var _extends2;
	
	    handleFormChange((0, _extends4.default)({}, formState, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, value), (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.STATE, ''), (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, ''), _extends2)));
	  };
	
	  return (0, _react.useMemo)(function () {
	    return {
	      formState: formState,
	      handleFormChange: handleFormChange,
	      validateErrors: validateErrors,
	      addLocalValidateErrors: addLocalValidateErrors,
	      setCountryValue: setCountryValue,
	      clearErrors: clearErrors,
	      isValid: isValid
	    };
	  }, [formState, handleFormChange, validateErrors, addLocalValidateErrors, setCountryValue, clearErrors, isValid]);
	}
	
	function useAvatarState(state) {
	  var _useState = (0, _react.useState)((0, _lodash.get)(state, 'avatar.url', '')),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      avatar = _useState2[0],
	      setAvatar = _useState2[1];
	
	  var handleImageCrop = function handleImageCrop(base64) {
	    return setAvatar(base64);
	  };
	  var handleImageRemove = function handleImageRemove() {
	    return setAvatar('');
	  };
	
	  return {
	    avatar: avatar,
	    handleImageCrop: handleImageCrop,
	    handleImageRemove: handleImageRemove
	  };
	}

/***/ }),
/* 3268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialState;
	
	exports.usePersonalInfoForm = usePersonalInfoForm;
	
	var _reactRedux = __webpack_require__(6);
	
	var _formFields = __webpack_require__(38);
	
	var _selectors = __webpack_require__(50);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = (_initialState = {}, (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.MIDDLE_NAME, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.NAME_SUFFIX, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.GENDER, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.DOB, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.SSN, ''), _initialState);
	
	function usePersonalInfoForm(errors) {
	  var _useFormState = (0, _useFormWithValidation.useFormState)(initialState),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var _useFormValidation = (0, _useFormWithValidation.useFormValidation)(errors),
	      validateErrors = _useFormValidation.validateErrors,
	      clearErrors = _useFormValidation.clearErrors;
	
	  var ssnHidingEnabled = (0, _reactRedux.useSelector)(_selectors.selectSsnHidingEnabled);
	
	  var isValid = (0, _useFormWithValidation.makeLocalFieldsValidation)([_formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, _formFields.PROFILE_FIELDS_TYPES.GENDER, _formFields.PROFILE_FIELDS_TYPES.DOB].concat((0, _toConsumableArray3.default)(!ssnHidingEnabled ? [_formFields.PROFILE_FIELDS_TYPES.SSN] : [])))(formState);
	
	  return {
	    formState: formState,
	    handleFormChange: handleFormChange,
	    validateErrors: validateErrors,
	    clearErrors: clearErrors,
	    isValid: isValid
	  };
	}

/***/ }),
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _utils = __webpack_require__(307);
	
	var _devicePermissions = __webpack_require__(1287);
	
	var _devicePermissionHelper = __webpack_require__(1894);
	
	var _selectors = __webpack_require__(64);
	
	var _styles = __webpack_require__(4951);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable promise/catch-or-return,promise/always-return */
	function DevicePermissions(_ref) {
	  var type = _ref.type,
	      invitable = _ref.invitable;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var close = function close() {
	    return dispatch(_devicePermissions.devicePermissionActions.close());
	  };
	
	  (0, _react.useEffect)(function () {
	    var isDenied = type === _devicePermissionHelper.DEVICE_PERMISSION_TYPES.DENIED;
	    var timer = void 0;
	
	    function tick() {
	      (0, _utils.getAllMediaDevices)().then(function (devices) {
	        var hasPermission = (0, _devicePermissionHelper.hasDevicePermissions)(devices);
	        if (hasPermission) {
	          dispatch(_devicePermissions.devicePermissionActions.mediaPermissionsGranted());
	        }
	        return devices;
	      });
	    }
	    if (isDenied) {
	      timer = setInterval(tick, 1000);
	    }
	
	    return function () {
	      if (isDenied) clearInterval(timer);
	    };
	  }, [type]);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    if (type === _devicePermissionHelper.DEVICE_PERMISSION_TYPES.REQUEST) {
	      return (0, _devicePermissionHelper.getRequestPermissionData)();
	    }
	    return (0, _devicePermissionHelper.getDeniedPermissionData)();
	  }, [type]),
	      title = _useMemo.title,
	      description = _useMemo.description,
	      src = _useMemo.src;
	
	  var handleCTA = function handleCTA() {
	    if (invitable) {
	      dispatch(_devicePermissions.devicePermissionActions.retry());
	      return;
	    }
	
	    close();
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      opened: true,
	      autoHeight: true,
	      withHeading: false,
	      dialogClassName: _styles2.default.dialog,
	      width: (0, _mobileHelpers.isDesktop)() ? 'auto' : 'medium',
	      paperClassName: _styles2.default.root
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.title },
	      formatMessage({ id: title })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.content },
	      formatMessage({ id: description })
	    ),
	    src && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.image },
	      _react2.default.createElement('img', { alt: 'preview', src: src })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.button },
	      _react2.default.createElement(
	        _Button2.default,
	        { color: 'primary', onClick: handleCTA },
	        formatMessage({
	          id: invitable ? 'common.tryAgain' : 'common.gotIt'
	        })
	      )
	    )
	  );
	}
	
	DevicePermissions.propTypes = {
	  invitable: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf([_devicePermissionHelper.DEVICE_PERMISSION_TYPES.REQUEST, _devicePermissionHelper.DEVICE_PERMISSION_TYPES.DENIED])
	};
	
	function DevicePermissionsPopup() {
	  var opened = (0, _reactRedux.useSelector)(_selectors.selectDevicePerissionModalOpened);
	  var props = (0, _reactRedux.useSelector)(_selectors.selectDevicePerissionModalProps);
	
	  if (!opened) return null;
	
	  return _react2.default.createElement(DevicePermissions, props);
	}
	
	exports.default = DevicePermissionsPopup;

/***/ }),
/* 3279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ErrorBoundary = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /* eslint-disable react/sort-comp,react/jsx-handler-names */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorBoundary = exports.ErrorBoundary = (_temp = _class = function (_React$Component) {
	  (0, _inherits3.default)(ErrorBoundary, _React$Component);
	
	  function ErrorBoundary(props) {
	    (0, _classCallCheck3.default)(this, ErrorBoundary);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ErrorBoundary.__proto__ || (0, _getPrototypeOf2.default)(ErrorBoundary)).call(this, props));
	
	    _this.openReportDialog = function () {
	      console.log('show sentry dialog');
	    };
	
	    _this.state = {
	      error: null
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ErrorBoundary, [{
	    key: 'componentDidCatch',
	    value: function componentDidCatch(error) {
	      this.setState(error);
	
	      console.log('ERROR HAPPENED', error);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var error = this.state.error;
	      var children = this.props.children;
	
	
	      if (error) {
	        return _react2.default.createElement(
	          'button',
	          { type: 'button', onClick: this.openReportDialog },
	          _react2.default.createElement(
	            'p',
	            null,
	            'We\'re sorry \u2014 something\'s gone wrong.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Our team has been notified, but click here to fill out a report.'
	          )
	        );
	      }
	      return children;
	    }
	  }]);
	  return ErrorBoundary;
	}(_react2.default.Component), _class.propTypes = {
	  children: _propTypes2.default.node
	}, _class.defaultProps = {
	  children: null
	}, _temp);

/***/ }),
/* 3280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _InfoPopover = __webpack_require__(773);
	
	var _InfoPopover2 = _interopRequireDefault(_InfoPopover);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _ProgressBar = __webpack_require__(3869);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(2247);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var icon = _ref.icon,
	      title = _ref.title,
	      subtitle = _ref.subtitle,
	      note = _ref.note,
	      status = _ref.status,
	      locked = _ref.locked,
	      description = _ref.description,
	      openPopover = _ref.openPopover,
	      showPopover = _ref.showPopover,
	      closePopover = _ref.closePopover,
	      reverseTitle = _ref.reverseTitle,
	      progress = _ref.progress,
	      list = _ref.list,
	      formatMessage = _ref.intl.formatMessage;
	
	  var anchorRef = (0, _react.useRef)(null);
	
	  return _react2.default.createElement(
	    'div',
	    { ref: anchorRef },
	    _react2.default.createElement(
	      'div',
	      {
	        styleName: (0, _classnames2.default)('header', {
	          'header--locked': locked
	        }),
	        className: 'bsw2-1 relative'
	      },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'headerMain' },
	        icon && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          typeof icon !== 'string' ? icon : _react2.default.createElement(_Icon2.default, { name: icon, size: 32, className: 'mr2' })
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            styleName: 'headerTitle',
	            className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _index2.default.reverseTitle, reverseTitle))
	          },
	          subtitle && _react2.default.createElement(
	            'span',
	            { styleName: 'text--complementary' },
	            subtitle
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'flex items-center' },
	            _react2.default.createElement(
	              'p',
	              {
	                styleName: (0, _classnames2.default)('text--primary', {
	                  'text--short': description
	                }),
	                className: 'mr2'
	              },
	              title
	            ),
	            !(0, _isEmpty2.default)(description || list) && _react2.default.createElement(
	              _ClickableElement2.default,
	              { onClick: openPopover },
	              _react2.default.createElement(_Icon2.default, {
	                name: 'info-default',
	                size: 16,
	                style: { fill: _styles.COLORS.bluePrimary },
	                className: 'db'
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'tr' },
	        status && _react2.default.createElement(
	          'div',
	          { styleName: 'headerSub', className: 'pb1' },
	          status
	        ),
	        note && _react2.default.createElement(
	          'div',
	          { styleName: 'headerSub' },
	          note
	        )
	      )
	    ),
	    progress && _react2.default.createElement(_ProgressBar2.default, { progress: progress }),
	    _react2.default.createElement(_InfoPopover2.default, {
	      formatMessage: formatMessage,
	      onClose: closePopover,
	      isOpen: showPopover,
	      description: description,
	      anchorEl: anchorRef.current,
	      list: list
	    })
	  );
	};
	
	Header.propTypes = {
	  icon: _propTypes2.default.node,
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  note: _propTypes2.default.any,
	  locked: _propTypes2.default.bool,
	  description: _propTypes2.default.string,
	  openPopover: _propTypes2.default.func,
	  closePopover: _propTypes2.default.func,
	  showPopover: _propTypes2.default.bool,
	  progress: _propTypes2.default.number,
	  list: _propTypes2.default.array,
	  intl: _propTypes2.default.object,
	  status: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string])
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(Header, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3281 */,
/* 3282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.WorkingHoursView = WorkingHoursView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(766);
	
	var _index = __webpack_require__(4954);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WorkingHoursView(_ref) {
	  var formatMessage = _ref.formatMessage,
	      currentWorkingHours = _ref.currentWorkingHours,
	      schedule = _ref.schedule;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isFullMode = _useState2[0],
	      setFullMode = _useState2[1];
	
	  var closedTitle = formatMessage({ id: 'googleMaps.closed' });
	
	  var sunday = schedule.sunday;
	
	  var sundayEntity = (0, _utils.getWorkingHoursByDay)(sunday, (0, _utils.getKeyByValue)(_utils.DAY_OF_WEEK, 'Sun'), closedTitle);
	  var safeSchedule = (0, _entries2.default)(schedule);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      formatMessage({ id: 'googleMaps.workingHours' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      !isFullMode && _react2.default.createElement(
	        'div',
	        { className: _index2.default.row, id: currentWorkingHours.currentDay },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.dayOfWeek },
	          currentWorkingHours.currentDay
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.workingHours },
	          currentWorkingHours.workingHours
	        ),
	        _react2.default.createElement(_Icon2.default, {
	          size: 16,
	          name: 'down',
	          className: _index2.default.toggleStateView,
	          onClick: function onClick() {
	            return setFullMode(true);
	          }
	        })
	      ),
	      isFullMode && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.row, id: sundayEntity.day },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.dayOfWeek },
	            sundayEntity.day
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.workingHours },
	            sundayEntity.workingHours
	          ),
	          _react2.default.createElement(_Icon2.default, {
	            size: 16,
	            name: 'up',
	            className: _index2.default.toggleStateView,
	            onClick: function onClick() {
	              return setFullMode(false);
	            }
	          })
	        ),
	        safeSchedule.map(function (_ref2) {
	          var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	              name = _ref3[0],
	              value = _ref3[1];
	
	          if (name === (0, _utils.getKeyByValue)(_utils.DAY_OF_WEEK, 'Sun')) return;
	          var entity = (0, _utils.getWorkingHoursByDay)(value, name, closedTitle);
	          return _react2.default.createElement(
	            'div',
	            { className: _index2.default.row, id: name },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.dayOfWeek, (0, _defineProperty3.default)({}, _index2.default.currentDay, entity.isCurrentDay))
	              },
	              entity.day
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.workingHours, (0, _defineProperty3.default)({}, _index2.default.currentDay, entity.isCurrentDay))
	              },
	              entity.workingHours
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	WorkingHoursView.propTypes = {
	  formatMessage: PropTypes.func,
	  schedule: PropTypes.object,
	  currentWorkingHours: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
	};

/***/ }),
/* 3283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocationDetailsView = LocationDetailsView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _styles = __webpack_require__(18);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(766);
	
	var _WorkingHoursView = __webpack_require__(3282);
	
	var _index = __webpack_require__(4955);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LocationDetailsView(_ref) {
	  var formatMessage = _ref.formatMessage,
	      myGeoLocation = _ref.myGeoLocation,
	      isMyPosition = _ref.isMyPosition,
	      location = _ref.location,
	      opened = _ref.opened,
	      onClose = _ref.onClose,
	      isAppointment = _ref.isAppointment,
	      startTime = _ref.startTime;
	
	  var schedule = location ? location.schedule : {};
	  var delta = isMyPosition ? (0, _utils.computeDistanceBetweenLocations)(myGeoLocation, location) : '';
	  var workingHours = (0, _utils.currentWorkingHours)(formatMessage, schedule, false, true);
	  var description = '' + delta + formatMessage({ id: 'googleMaps.miAway' });
	
	  return opened && _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.headerPopup },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.titleLocation },
	        location ? location.name : '',
	        _react2.default.createElement(
	          _Button2.default,
	          { icon: true, onClick: onClose, className: _index2.default.closeBtn },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'ico-24-close',
	            size: 16,
	            style: { fill: _styles.COLORS.stormyBlue }
	          })
	        )
	      ),
	      isMyPosition && _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        description
	      ),
	      _react2.default.createElement('div', { className: _index2.default.divider })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        formatMessage({ id: 'googleMaps.location' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        isAppointment ? location && location.address && location.city ? location.address + ', ' + location.city : '-' : location && location.address ? location.address : '-'
	      ),
	      _react2.default.createElement('div', { className: _index2.default.divider })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        formatMessage({ id: 'common.phone' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        location && (location.phoneNumber || location.phone) ? location.phoneNumber || location.phone : '-'
	      ),
	      _react2.default.createElement('div', { className: _index2.default.divider })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.wrapper },
	      !isAppointment ? _react2.default.createElement(_WorkingHoursView.WorkingHoursView, {
	        schedule: schedule,
	        currentWorkingHours: workingHours,
	        formatMessage: formatMessage
	      }) : _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.title },
	          formatMessage({ id: 'dashboard.record.visitTime.map' })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          (0, _moment2.default)(startTime).format('D MMM, YYYY h:mm A')
	        )
	      ),
	      !isAppointment && _react2.default.createElement('div', { className: _index2.default.divider })
	    ),
	    !isAppointment && _react2.default.createElement(
	      'div',
	      { className: _index2.default.wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        formatMessage({ id: 'googleMaps.about' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        location && location.description ? location.description : '-'
	      )
	    )
	  );
	}
	
	LocationDetailsView.propTypes = {
	  formatMessage: PropTypes.func,
	  location: PropTypes.object,
	  opened: PropTypes.bool,
	  onClose: PropTypes.func,
	  myGeoLocation: PropTypes.object,
	  isMyPosition: PropTypes.bool,
	  isAppointment: PropTypes.bool,
	  startTime: PropTypes.string
	};

/***/ }),
/* 3284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactGoogleMaps = __webpack_require__(2743);
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _withGoogleMapsProps = __webpack_require__(3286);
	
	var _withGoogleMapsProps2 = _interopRequireDefault(_withGoogleMapsProps);
	
	var _selectors = __webpack_require__(294);
	
	var _selectors2 = __webpack_require__(64);
	
	var _getGeoLocationsReq = __webpack_require__(1308);
	
	var geoLocations = _interopRequireWildcard(_getGeoLocationsReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentAppointment: (0, _selectors.selectCurrentAppointment)(state),
	    appointmentsList: (0, _selectors2.selectUpcomingAppointmentList)(state),
	    currentAppointmentId: (0, _selectors2.selectActiveAppointmentId)(state),
	    activeTodoItemTaskId: (0, _selectors2.selectActiveTodoItemTaskId)(state),
	    geolocations: (0, _selectors2.selectActiveTodoItemTaskGeoLocations)(state),
	    historyAppointmentsList: (0, _selectors2.selectHistoryAppointmentList)(state)
	  };
	};
	var mapDispatchToProps = {
	  getLocationsDetails: geoLocations.actions.send
	};
	
	var enhance = function enhance(component) {
	  return (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _reactIntl.injectIntl, (0, _recompose.setDisplayName)('GoogleMaps'), _withGoogleMapsProps2.default, _reactGoogleMaps.withScriptjs, _reactGoogleMaps.withGoogleMap)(component);
	};
	
	exports.default = enhance;

/***/ }),
/* 3285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useGoogleMapsData = useGoogleMapsData;
	
	var _react = __webpack_require__(1);
	
	var _utils = __webpack_require__(766);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useGoogleMapsData() {
	  var mapRef = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      currentPosition = _useState2[0],
	      setCurrentPosition = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(_utils.DEFAULT_ZOOM_WITHOUT_PERMISSION),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      currentZoom = _useState4[0],
	      setCurrentZoom = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      myGeoLocation = _useState6[0],
	      setMyGeoLocation = _useState6[1];
	
	  var successCurrentLocation = function successCurrentLocation(position) {
	    var currentPositionEntity = {
	      lat: position.coords.latitude,
	      lng: position.coords.longitude
	    };
	    setCurrentPosition(currentPositionEntity);
	    setMyGeoLocation(currentPositionEntity);
	    setCurrentZoom(_utils.DEFAULT_ZOOM_WITH_PERMISSION);
	  };
	
	  (0, _react.useEffect)(function () {
	    navigator.geolocation.getCurrentPosition(successCurrentLocation);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (mapRef) {
	      var centerControlDiv = document.createElement('div');
	      (0, _utils.CenterControl)(centerControlDiv, mapRef);
	      centerControlDiv.index = 1;
	      mapRef.current.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(centerControlDiv);
	    }
	  }, [mapRef]);
	
	  var getCenter = (0, _react.useCallback)(function () {
	    if (!mapRef || !mapRef.current) {
	      return null;
	    }
	
	    return mapRef.current.getCenter();
	  }, []);
	
	  var handleMapDragEnd = (0, _react.useCallback)(function () {
	    if (!mapRef || !mapRef.current) {
	      return;
	    }
	
	    var newCenter = getCenter();
	
	    if (!newCenter) {
	      return;
	    }
	
	    var newPosition = {
	      lat: newCenter.lat(),
	      lng: newCenter.lng()
	    };
	
	    setCurrentPosition(newPosition);
	  }, [getCenter]);
	
	  return {
	    mapRef: mapRef,
	    zoom: currentZoom,
	    isMyPosition: !!myGeoLocation,
	    myGeoLocation: myGeoLocation,
	    currentPosition: currentPosition || {
	      lat: _utils.FALLBACK_LOCATION.latitude,
	      lng: _utils.FALLBACK_LOCATION.longitude
	    },
	    handleMapDragEnd: handleMapDragEnd
	  };
	}

/***/ }),
/* 3286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _qs = __webpack_require__(5699);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _env = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var withGoogleMapsProps = (0, _recompose.compose)((0, _recompose.mapProps)(function (_ref) {
	  var locale = _ref.locale,
	      rest = (0, _objectWithoutProperties3.default)(_ref, ['locale']);
	  return (0, _extends3.default)({
	    googleMapURL: 'https://maps.googleapis.com/maps/api/js?' + _qs2.default.stringify({
	      key: _env.REACT_APP_GOOGLE_MAPS_API_KEY,
	      v: '3.exp',
	      libraries: 'geometry,places',
	      language: 'en'
	    }),
	    loadingElement: _react2.default.createElement('div', null),
	    containerElement: _react2.default.createElement('div', { style: { height: 'inherit', position: 'relative' } }),
	    mapElement: _react2.default.createElement('div', { style: { height: 'inherit', width: '100%' } })
	  }, rest);
	}));
	
	exports.default = withGoogleMapsProps;

/***/ }),
/* 3287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _PopoverMenu = __webpack_require__(398);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	var _ids = __webpack_require__(46);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _AssignMenuList = __webpack_require__(1741);
	
	var _AssignMenuList2 = _interopRequireDefault(_AssignMenuList);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssignBtn = function AssignBtn(_ref) {
	  var isProvider = _ref.isProvider;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      open = _useState2[0],
	      setOpened = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      anchor = _useState4[0],
	      setAnchor = _useState4[1];
	
	  var handleOpenPopover = function handleOpenPopover(e) {
	    setOpened(true);
	    setAnchor(e.currentTarget);
	  };
	
	  var handleClosePopover = function handleClosePopover() {
	    setOpened(false);
	    setAnchor(null);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'item' },
	    _react2.default.createElement(
	      _ClickableElement2.default,
	      {
	        id: _ids.IDS.NAV_BAR.OPEN_JOIN_POPUP,
	        onClick: handleOpenPopover,
	        className: 'ph3',
	        styleName: 'link',
	        ariaLabel: 'assign patient'
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'assign-patient', size: 36 })
	    ),
	    _react2.default.createElement(_AssignMenuList2.default, {
	      selectItem: handleClosePopover,
	      isProvider: isProvider,
	      renderItems: function renderItems(items) {
	        return _react2.default.createElement(_PopoverMenu2.default, {
	          style: { marginTop: '-10px' },
	          size: 'large',
	          isOpen: open,
	          anchorEl: anchor,
	          items: items,
	          onClose: handleClosePopover
	        });
	      }
	    })
	  );
	};
	
	AssignBtn.propTypes = {
	  isProvider: PropTypes.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(AssignBtn, _index2.default, { allowMultiple: true });

/***/ }),
/* 3288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _strings = __webpack_require__(15);
	
	var _selectors = __webpack_require__(23);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HiddenLink = function HiddenLink(_ref) {
	  var href = _ref.href,
	      isLoggedUser = _ref.isLoggedUser,
	      isMobile = _ref.isMobile,
	      isOpened = _ref.isOpened;
	
	  if (!isMobile || isOpened) return null;
	
	  var PROFILE_LINK_TEXT = isLoggedUser ? _strings.MY_PROFILE : _strings.PROFILE_STR;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'item' },
	    _react2.default.createElement(
	      _Link2.default,
	      { activeClassName: _index2.default['link--active'], styleName: 'link', to: href },
	      _react2.default.createElement(_reactIntl.FormattedMessage, PROFILE_LINK_TEXT)
	    )
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	HiddenLink.propTypes = {
	  href: _propTypes2.default.string,
	  isLoggedUser: _propTypes2.default.bool,
	  isMobile: _propTypes2.default.bool,
	  isOpened: _propTypes2.default.bool
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoggedUser: (0, _selectors.isLoggedUserSelector)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactCssModules2.default)(HiddenLink, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _routes = __webpack_require__(37);
	
	var _strings = __webpack_require__(15);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginBtn = function LoginBtn(_ref) {
	  var formatMessage = _ref.formatMessage,
	      openJoinPopup = _ref.openJoinPopup,
	      visible = _ref.visible;
	
	  if (!visible) return null;
	
	  var handleSignUp = function handleSignUp() {
	    return openJoinPopup({ content: 'signUp' });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'auth' },
	    _react2.default.createElement(
	      _Link2.default,
	      { to: _routes.LOGIN, className: 'mr3' },
	      _react2.default.createElement(
	        _Button2.default,
	        { color: 'accent', border: true, className: 'w-100' },
	        formatMessage(_strings.AUTH.submit.login)
	      )
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { color: 'primary', className: 'mr3', onClick: handleSignUp },
	      formatMessage(_strings.AUTH.submit.signUp)
	    )
	  );
	};
	
	LoginBtn.propTypes = {
	  formatMessage: PropTypes.func,
	  openJoinPopup: PropTypes.func,
	  visible: PropTypes.bool
	};
	LoginBtn.defaultProps = {
	  visible: false
	};
	
	exports.default = (0, _reactCssModules2.default)(LoginBtn, _index2.default, { allowMultiple: true });

/***/ }),
/* 3290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _Intro = __webpack_require__(195);
	
	var _logout = __webpack_require__(198);
	
	var _ids = __webpack_require__(46);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var mapDispatchToProps = {
	  logout: _logout.actions.send
	};
	
	var Header = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(Header, _PureComponent);
	
	  function Header() {
	    (0, _classCallCheck3.default)(this, Header);
	    return (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Header, [{
	    key: 'handleLogout',
	    value: function handleLogout() {
	      this.props.logout();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'item', className: 'logout-btn' },
	        _react2.default.createElement(
	          _ClickableElement2.default,
	          {
	            id: _ids.IDS.NAV_BAR.LOG_OUT,
	            onClick: this.handleLogout,
	            className: 'ph3 ' + _Intro.INTRO_HINT_SELECTORS.common.logout,
	            styleName: 'link',
	            ariaLabel: 'logout'
	          },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'log-out',
	            size: 24,
	            style: { transform: 'rotate(180deg)' }
	          }),
	          this.props.text ? _react2.default.createElement(
	            'span',
	            { className: 'pl2' },
	            this.props.text
	          ) : null
	        )
	      );
	    }
	  }]);
	  return Header;
	}(_react.PureComponent), _class3.propTypes = {
	  logout: _propTypes2.default.func,
	  text: _propTypes2.default.string
	}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleLogout', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleLogout'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = Header;

/***/ }),
/* 3291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _routes = __webpack_require__(37);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuItems = function MenuItems(_ref) {
	  var items = _ref.items;
	
	  var isHomeForAR = window.location.pathname.includes(_routes.HEALTHBOARD_HOME);
	
	  return items.map(function (item) {
	    var href = item.href,
	        title = item.title;
	
	    var isHomeLink = href.includes(_routes.HEALTHBOARD_HOME);
	
	    return _react2.default.createElement(
	      'li',
	      {
	        styleName: (0, _classnames2.default)('item', { linkActiveAR: isHomeLink && isHomeForAR }),
	        key: item.id
	      },
	      _react2.default.createElement(_Link2.default, {
	        activeClassName: _index2.default['link--active'],
	        children: title,
	        styleName: 'link',
	        to: '/' + href,
	        id: item.id
	      })
	    );
	  });
	};
	
	MenuItems.propTypes = {
	  items: PropTypes.array
	};
	
	exports.default = (0, _reactCssModules2.default)(MenuItems, _index2.default, { allowMultiple: true });

/***/ }),
/* 3292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(914);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _routes = __webpack_require__(37);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamsMenu = function TeamsMenu(_ref) {
	  var list = _ref.list,
	      handleClose = _ref.handleClose;
	
	  var handleClickMenItem = function handleClickMenItem(item) {
	    if (item.isLoggedUser) {
	      window.storage.removeItem('selectedTeamId');
	      window.storage.removeItem('actingUserId');
	    } else {
	      window.storage.setItem('selectedTeamId', (0, _stringify2.default)((0, _get2.default)(item, 'id')));
	      window.storage.setItem('actingUserId', (0, _stringify2.default)((0, _get2.default)(item, 'actingUserId')));
	    }
	    window.location.replace(_routes.HEALTHBOARD);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { onMouseLeave: handleClose },
	    list.map(function (item) {
	      return _react2.default.createElement(_Card2.default, {
	        additionalContent: {
	          left: _react2.default.createElement(_Avatar2.default, {
	            children: item.name,
	            size: 24,
	            src: (0, _get2.default)(item, 'logo.thumbMin')
	          })
	        },
	        className: 'f-14 pa2 pointer g-hoverable',
	        text: { primary: item.name },
	        key: item.id,
	        handleClick: function handleClick() {
	          return handleClickMenItem(item);
	        }
	      });
	    })
	  );
	};
	
	TeamsMenu.propTypes = {
	  list: _propTypes2.default.array,
	  handleClose: _propTypes2.default.func
	};
	
	exports.default = TeamsMenu;

/***/ }),
/* 3293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Menu = __webpack_require__(1565);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _TeamsMenu = __webpack_require__(3292);
	
	var _TeamsMenu2 = _interopRequireDefault(_TeamsMenu);
	
	var _ids = __webpack_require__(46);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserLink = function UserLink(_ref) {
	  var href = _ref.href,
	      avatar = _ref.avatar,
	      displayableName = _ref.displayableName,
	      teamsMenuItems = _ref.teamsMenuItems,
	      isTeamMember = _ref.isTeamMember,
	      isMobile = _ref.isMobile;
	
	  var btnRef = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      menuShown = _useState2[0],
	      setMenuShown = _useState2[1];
	
	  var handleBtnEnter = function handleBtnEnter() {
	    setMenuShown(true);
	  };
	
	  var handleBtnLeave = function handleBtnLeave(e) {
	    if (menuShown && btnRef.current) {
	      var rect = btnRef.current.getBoundingClientRect();
	
	      var leaveTop = e.nativeEvent.pageY < 0;
	      var leaveLeft = e.nativeEvent.pageX < rect.x;
	      var leaveRight = e.nativeEvent.pageX > rect.x + rect.width;
	
	      if (leaveTop || leaveLeft || leaveRight) {
	        handleCloseMenu();
	      }
	    }
	  };
	
	  var handleCloseMenu = function handleCloseMenu() {
	    setMenuShown(false);
	  };
	
	  var handleOpenProfile = function handleOpenProfile() {
	    if (!href) return;
	    _browserHistory2.default.push(href);
	    handleCloseMenu();
	  };
	
	  var linkCard = _react2.default.createElement(_Card2.default, {
	    additionalContent: { left: avatar },
	    text: { primary: displayableName }
	  });
	
	  return isTeamMember && !isMobile ? [_react2.default.createElement(
	    'div',
	    {
	      ref: btnRef,
	      onMouseEnter: handleBtnEnter,
	      onMouseLeave: handleBtnLeave,
	      onClick: handleOpenProfile,
	      styleName: 'link',
	      className: 'flex-grow-0',
	      key: '0'
	    },
	    linkCard
	  ), _react2.default.createElement(
	    _Menu2.default,
	    {
	      anchorEl: btnRef.current,
	      open: menuShown,
	      onClose: handleCloseMenu,
	      style: { top: 45, left: 0, zIndex: 0 },
	      key: '1'
	    },
	    _react2.default.createElement(_TeamsMenu2.default, { list: teamsMenuItems, handleClose: handleCloseMenu })
	  )] : _react2.default.createElement(
	    _Link2.default,
	    {
	      activeClassName: _index2.default['link--active'],
	      styleName: 'link',
	      id: _ids.IDS.NAV_BAR.PROFILE,
	      to: href,
	      className: 'header-profile-link flex-grow-0'
	    },
	    linkCard
	  );
	};
	
	UserLink.propTypes = {
	  href: _propTypes2.default.string,
	  avatar: _propTypes2.default.any,
	  displayableName: _propTypes2.default.string,
	  teamsMenuItems: _propTypes2.default.array,
	  isTeamMember: _propTypes2.default.bool,
	  isMobile: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(UserLink, _index2.default, { allowMultiple: true });

/***/ }),
/* 3294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _HiddenLink = __webpack_require__(3288);
	
	var _HiddenLink2 = _interopRequireDefault(_HiddenLink);
	
	var _UserLink = __webpack_require__(3293);
	
	var _UserLink2 = _interopRequireDefault(_UserLink);
	
	var _LogoutBtn = __webpack_require__(3290);
	
	var _LogoutBtn2 = _interopRequireDefault(_LogoutBtn);
	
	var _AssignBtn = __webpack_require__(3287);
	
	var _AssignBtn2 = _interopRequireDefault(_AssignBtn);
	
	var _LoginBtn = __webpack_require__(3289);
	
	var _LoginBtn2 = _interopRequireDefault(_LoginBtn);
	
	var _MenuItems = __webpack_require__(3291);
	
	var _MenuItems2 = _interopRequireDefault(_MenuItems);
	
	var _AppNotificationsBtn = __webpack_require__(1740);
	
	var _AppNotificationsBtn2 = _interopRequireDefault(_AppNotificationsBtn);
	
	var _AssignMenuList = __webpack_require__(1741);
	
	var _AssignMenuList2 = _interopRequireDefault(_AssignMenuList);
	
	var _styles = __webpack_require__(18);
	
	var _routes = __webpack_require__(37);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(_ref) {
	  var items = _ref.items,
	      isOpened = _ref.isOpened,
	      user = _ref.user,
	      isProvider = _ref.isProvider,
	      isLoggedIn = _ref.isLoggedIn,
	      isCommunityPreview = _ref.isCommunityPreview,
	      formatMessage = _ref.intl.formatMessage,
	      openJoinPopup = _ref.openJoinPopup,
	      teamsMenuItems = _ref.teamsMenuItems,
	      isTeamMemberProvider = _ref.isTeamMemberProvider,
	      loggedUserId = _ref.loggedUserId;
	
	  var _ref2 = user || {},
	      displayableName = _ref2.displayableName,
	      id = _ref2.id,
	      primaryProviderProfile = _ref2.primaryProviderProfile,
	      username = _ref2.username;
	
	  var role = primaryProviderProfile ? 'provider' : 'patient';
	  var profileLink = id === loggedUserId ? '/' + _routes.PROFILE + '/' + id + '/' + role : null;
	  var name = displayableName || username;
	
	  var openJoinDialog = function openJoinDialog() {
	    return openJoinPopup({ content: 'join' });
	  };
	  var showCondition = function showCondition(isMobile) {
	    return !isMobile || isMobile && isOpened;
	  };
	  var avatar = _react2.default.createElement(_Avatar2.default, { children: name, size: 32, src: (0, _get2.default)(user, 'avatar.thumbMiddle') });
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'menu' },
	    isLoggedIn || isCommunityPreview ? _react2.default.createElement(
	      'ul',
	      { styleName: (0, _classnames2.default)('nav', { 'nav--grow': isCommunityPreview }) },
	      isCommunityPreview && _react2.default.createElement('div', { styleName: 'overlay', onClick: openJoinDialog }),
	      _react2.default.createElement(_MenuItems2.default, { items: items }),
	      _react2.default.createElement(_LoginBtn2.default, {
	        visible: isCommunityPreview && !isLoggedIn,
	        formatMessage: formatMessage,
	        openJoinPopup: openJoinPopup
	      })
	    ) : null,
	    !isCommunityPreview ? _react2.default.createElement('div', { styleName: 'separator', className: 'g-shownOnDesktop' }) : null,
	    isLoggedIn ? [_react2.default.createElement(
	      _reactResponsive2.default,
	      { minWidth: _styles.BREAKPOINT + 1, key: '0'
	      },
	      _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(_AppNotificationsBtn2.default, { isProvider: isProvider }),
	        _react2.default.createElement(_AssignBtn2.default, { isProvider: isProvider })
	      )
	    ), _react2.default.createElement(
	      _reactResponsive2.default,
	      { maxWidth: _styles.BREAKPOINT, key: '1'
	      },
	      _react2.default.createElement(_AssignMenuList2.default, {
	        isProvider: isProvider,
	        renderItems: function renderItems(assignOptions) {
	          return assignOptions.map(function (_ref3) {
	            var optId = _ref3.id,
	                onClick = _ref3.onClick,
	                text = _ref3.text;
	            return _react2.default.createElement(
	              'li',
	              { styleName: 'item', id: optId, onClick: onClick, key: optId },
	              _react2.default.createElement(
	                'span',
	                { styleName: 'link' },
	                text
	              )
	            );
	          });
	        }
	      })
	    ), _react2.default.createElement(
	      _reactResponsive2.default,
	      { maxWidth: _styles.BREAKPOINT, key: '2'
	      },
	      function (isMobile) {
	        if (showCondition(isMobile)) {
	          return _react2.default.createElement(_UserLink2.default, {
	            href: profileLink,
	            displayableName: name,
	            avatar: avatar,
	            teamsMenuItems: teamsMenuItems,
	            isTeamMember: isTeamMemberProvider,
	            isMobile: isMobile
	          });
	        }
	
	        return _react2.default.createElement(_HiddenLink2.default, (0, _extends3.default)({ href: '/' + _routes.PROFILE }, { isMobile: isMobile, isOpened: isOpened }));
	      }
	    ), _react2.default.createElement(
	      _reactResponsive2.default,
	      { maxWidth: _styles.BREAKPOINT, key: '3'
	      },
	      function (isMobile) {
	        var text = isOpened ? formatMessage(_strings.AUTH.actions.logout) : null;
	
	        return showCondition(isMobile) ? _react2.default.createElement(_LogoutBtn2.default, { text: text }) : null;
	      }
	    )] : null
	  );
	};
	
	Menu.propTypes = {
	  items: _propTypes2.default.array.isRequired,
	  isOpened: _propTypes2.default.bool.isRequired,
	  user: _propTypes2.default.object,
	  isProvider: _propTypes2.default.bool,
	  isLoggedIn: _propTypes2.default.bool,
	  isCommunityPreview: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  openJoinPopup: _propTypes2.default.func,
	  teamsMenuItems: _propTypes2.default.array,
	  isTeamMemberProvider: _propTypes2.default.bool,
	  loggedUserId: _propTypes2.default.number
	};
	
	Menu.defaultProps = {
	  user: {},
	  isProvider: false,
	  isLoggedIn: false,
	  isCommunityPreview: false,
	  openJoinPopup: false
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(Menu, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactClickOutside = __webpack_require__(1001);
	
	var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _IndexLink = __webpack_require__(1623);
	
	var _IndexLink2 = _interopRequireDefault(_IndexLink);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _joinPopup = __webpack_require__(519);
	
	var _overlay = __webpack_require__(1905);
	
	var _constants = __webpack_require__(17);
	
	var _routes = __webpack_require__(37);
	
	var _styles = __webpack_require__(18);
	
	var _selectors = __webpack_require__(93);
	
	var _selectors2 = __webpack_require__(23);
	
	var _AppNotificationsBtn = __webpack_require__(1740);
	
	var _AppNotificationsBtn2 = _interopRequireDefault(_AppNotificationsBtn);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Menu = __webpack_require__(3294);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _index = __webpack_require__(276);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _browserChecker = __webpack_require__(356);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	/*
	 * TODO:
	 * - avatar layout changing according to screen width
	 * Now it's implemented according to components state
	 * - header overlay z-indexes to resolve!
	 */
	
	var IS_BROWSER_SUPPORTABLE = (0, _browserChecker.isSupportedBrowser)();
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoggedIn: (0, _selectors.isLoggedInSelector)(state),
	    loggedUser: (0, _selectors2.loggedUserSelector)(state),
	    user: (0, _selectors2.selectUserToShow)(state),
	    logoutSucceed: state.auth.logout.succeed,
	    signupSending: state.auth.signup.sending,
	    isProvider: (0, _selectors2.hasProviderProfileSelector)(state),
	    teamsList: (0, _selectors2.selectLoggedProviderTeamsList)(state),
	    isTeamMemberProvider: (0, _selectors2.selectIsTeamMemberProvider)(state),
	    dashboardVisible: (0, _selectors2.selectDashboardVisible)(state),
	    isRequestPasswordUpdate: (0, _selectors.selectRequestPasswordUpdate)(state),
	    isRegistrationCompleted: (0, _selectors.selectRegistrationCompleted)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  hideOverlay: _overlay.actions.hide,
	  toggleOverlay: _overlay.actions.toggleVisibility,
	  openJoinPopup: _joinPopup.actions.show
	};
	
	var Header = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = (0, _reactRouter.withRouter)(_class = _dec(_class = (0, _reactClickOutside2.default)(_class = _dec2(_class = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(Header, _PureComponent);
	
	  function Header() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isOpened: false,
	      loggedOut: false
	    }, _this.getTeamsMenuItems = function () {
	      var _this$props = _this.props,
	          loggedUser = _this$props.loggedUser,
	          teamsList = _this$props.teamsList;
	
	      var loggedUserItem = {
	        logo: (0, _get2.default)(loggedUser, 'avatar'),
	        name: (0, _get2.default)(loggedUser, 'displayableName'),
	        id: (0, _get2.default)(loggedUser, 'id'),
	        isLoggedUser: true
	      };
	      return [loggedUserItem].concat((0, _toConsumableArray3.default)(teamsList));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Header, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          logoutSucceed = _props.logoutSucceed,
	          signupSending = _props.signupSending;
	
	      var logoutUpdated = logoutSucceed !== nextProps.logoutSucceed;
	
	      if (logoutUpdated) {
	        // prevent redirecting on autologout when accept invitation from loggedIn state
	        var signupInProgress = !signupSending && nextProps.signupSending;
	
	        this.setState({
	          loggedOut: nextProps.logoutSucceed && !signupInProgress
	        });
	      }
	    }
	  }, {
	    key: 'handleClickOutside',
	    value: function handleClickOutside() {
	      this.closeMobileHeader();
	    }
	  }, {
	    key: 'toggleMobileHeader',
	    value: function toggleMobileHeader() {
	      var isOpened = this.state.isOpened;
	      var toggleOverlay = this.props.toggleOverlay;
	
	      this.setState({ isOpened: !isOpened });
	      toggleOverlay();
	    }
	  }, {
	    key: 'closeMobileHeader',
	    value: function closeMobileHeader() {
	      var isOpened = this.state.isOpened;
	      var hideOverlay = this.props.hideOverlay;
	
	      if (isOpened) {
	        this.setState({ isOpened: !isOpened });
	        hideOverlay();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isOpened = _state.isOpened,
	          loggedOut = _state.loggedOut;
	      var _props2 = this.props,
	          location = _props2.location,
	          isLoggedIn = _props2.isLoggedIn,
	          user = _props2.user,
	          isProvider = _props2.isProvider,
	          formatMessage = _props2.intl.formatMessage,
	          openJoinPopup = _props2.openJoinPopup,
	          isTeamMemberProvider = _props2.isTeamMemberProvider,
	          dashboardVisible = _props2.dashboardVisible,
	          loggedUser = _props2.loggedUser,
	          isRequestPasswordUpdate = _props2.isRequestPasswordUpdate,
	          isRegistrationCompleted = _props2.isRegistrationCompleted;
	
	
	      var loggedIn = isLoggedIn && !isRequestPasswordUpdate && isRegistrationCompleted;
	
	      // avoid infinite loop on logout
	      if (loggedOut && location.pathname !== _routes.LOGIN) {
	        // browserHistory.push(LOGIN);
	        return null;
	      }
	      var loggedUserId = loggedUser.id;
	
	
	      var currentActive = location.pathname.slice(1);
	      var isCommunityPreview = currentActive.includes('community-preview');
	
	      return _react2.default.createElement(
	        'header',
	        {
	          styleName: (0, _classnames2.default)('root', {
	            'root--opened-mobile': isOpened
	          })
	          /* eslint-disable-next-line react/jsx-handler-names */
	          , onClick: this.closeMobileHeader
	        },
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { maxWidth: _styles.BREAKPOINT },
	          function (isMobile) {
	            if (!isMobile && isOpened) _this2.closeMobileHeader();
	            return null;
	          }
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'item' },
	          _react2.default.createElement(
	            _IndexLink2.default,
	            { styleName: 'link home-link', to: _routes.ROOT, 'aria-label': 'home' },
	            _react2.default.createElement(_Icon2.default, { name: _brandConfig2.default.logo, size: _brandConfig2.default.logoSize })
	          )
	        ),
	        IS_BROWSER_SUPPORTABLE && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(
	            'div',
	            { styleName: 'item item--title' },
	            _react2.default.createElement(
	              _Link2.default,
	              { styleName: 'link', to: _routes.ROOT },
	              _react2.default.createElement(_reactIntl.FormattedMessage, _constants.TITLE)
	            )
	          ),
	          _react2.default.createElement(_Menu2.default, (0, _extends3.default)({ isOpened: isOpened, user: user, isProvider: isProvider }, {
	            items: (0, _constants.getNavConfig)(formatMessage, dashboardVisible, loggedUserId, isProvider),
	            isLoggedIn: loggedIn,
	            isCommunityPreview: isCommunityPreview,
	            openJoinPopup: openJoinPopup,
	            teamsMenuItems: this.getTeamsMenuItems(),
	            isTeamMemberProvider: isTeamMemberProvider,
	            loggedUserId: loggedUserId
	          })),
	          _react2.default.createElement('div', { className: 'g-shownOnMobile', styleName: 'separator' }),
	          loggedIn ? _react2.default.createElement(
	            _reactResponsive2.default,
	            { maxWidth: _styles.BREAKPOINT },
	            _react2.default.createElement(_AppNotificationsBtn2.default, { isProvider: isProvider })
	          ) : null,
	          loggedIn || isCommunityPreview ? _react2.default.createElement(
	            'div',
	            { styleName: (0, _classnames2.default)('item item--menu'), className: 'ph2' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                icon: true,
	                className: (0, _classnames2.default)({ dn: !isOpened }),
	                onClick: function onClick() {
	                  return _this2.toggleMobileHeader();
	                }
	              },
	              _react2.default.createElement(_Icon2.default, { name: 'close', style: { stroke: _styles.COLORS.bluePrimary } })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                icon: true,
	                className: (0, _classnames2.default)({ dn: isOpened }),
	                onClick: function onClick() {
	                  return _this2.toggleMobileHeader();
	                }
	              },
	              _react2.default.createElement(_Icon2.default, { name: 'menu', style: { stroke: _styles.COLORS.bluePrimary } })
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	  return Header;
	}(_react.PureComponent), _class3.propTypes = {
	  hideOverlay: _propTypes2.default.func.isRequired,
	  isLoggedIn: _propTypes2.default.bool,
	  loggedUser: _propTypes2.default.object,
	  toggleOverlay: _propTypes2.default.func.isRequired,
	  logoutSucceed: _propTypes2.default.bool,
	  signupSending: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  location: _propTypes2.default.shape({
	    pathname: _propTypes2.default.string
	  }).isRequired,
	  openJoinPopup: _propTypes2.default.func,
	  isProvider: _propTypes2.default.bool,
	  teamsList: _propTypes2.default.array,
	  dashboardVisible: _propTypes2.default.bool,
	  isTeamMemberProvider: _propTypes2.default.bool,
	  user: _propTypes2.default.object,
	  isRequestPasswordUpdate: _propTypes2.default.bool,
	  isRegistrationCompleted: _propTypes2.default.bool
	}, _class3.defaultProps = {
	  isLoggedIn: null,
	  loggedUser: null,
	  logoutSucceed: false,
	  signupSending: false,
	  openJoinPopup: false,
	  isProvider: false
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleClickOutside', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleClickOutside'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleMobileHeader', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleMobileHeader'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'closeMobileHeader', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'closeMobileHeader'), _class2.prototype)), _class2)) || _class) || _class) || _class) || _class) || _class);
	exports.default = Header;

/***/ }),
/* 3296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _appointmentsUpcommingReq = __webpack_require__(348);
	
	var upcomingAppointmentList = _interopRequireWildcard(_appointmentsUpcommingReq);
	
	var _appointmentsHistoryReq = __webpack_require__(347);
	
	var historyAppointmentList = _interopRequireWildcard(_appointmentsHistoryReq);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    upcomingList: (0, _selectors.selectUpcomingAppointmentList)(state),
	    upcomingCount: (0, _selectors.selectUpcomingCount)(state),
	    upcomingLoading: (0, _selectors.selectUpcomingAppointmentsPending)(state),
	    upcommingPaginationLoading: (0, _selectors.selectUpcomingPaginationPending)(state),
	    historyPaginationLoading: (0, _selectors.selectHistoryPaginationPending)(state),
	    historyLoading: (0, _selectors.selectHistoryAppointmentsPending)(state),
	    historyList: (0, _selectors.selectHistoryAppointmentList)(state),
	    historyCount: (0, _selectors.selectHistoryCount)(state)
	  };
	};
	var mapDispatchToProps = {
	  fetchUpcomingList: upcomingAppointmentList.actions.send,
	  loadMoreUpcomingList: upcomingAppointmentList.actions.loadMore,
	  fetchHistoryList: historyAppointmentList.actions.send,
	  loadMoreHistoryList: historyAppointmentList.actions.loadMore
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var userId = _ref.userId,
	      historyPaginationLoading = _ref.historyPaginationLoading,
	      upcommingPaginationLoading = _ref.upcommingPaginationLoading;
	  return {
	    id: userId,
	    paginationSending: upcommingPaginationLoading || historyPaginationLoading
	  };
	}));

/***/ }),
/* 3297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _strings = __webpack_require__(15);
	
	var _styles = __webpack_require__(720);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EirVisitView = function EirVisitView(_ref) {
	  var service = _ref.service,
	      reasonType = _ref.reasonType,
	      paymentDetails = _ref.paymentDetails,
	      providerView = _ref.providerView;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  return _react2.default.createElement(
	    'section',
	    { className: _styles2.default.row },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.columnWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.meta },
	          formatMessage({ id: 'appointment.list.card.service' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.meta },
	          formatMessage({
	            id: providerView ? 'appointment.list.card.payment' : 'appointment.list.card.yourCost'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.provider },
	          service
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.provider },
	          paymentDetails
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.columnWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.meta },
	          formatMessage({
	            id: 'appointment.list.card.reasonForVisit'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.provider },
	          reasonType || _strings.DEFAULT_EMPTY_VALUE
	        )
	      )
	    )
	  );
	};
	
	EirVisitView.propTypes = {
	  paymentDetails: _propTypes2.default.string,
	  providerView: _propTypes2.default.bool,
	  reasonType: _propTypes2.default.string,
	  service: _propTypes2.default.string
	};
	
	exports.default = EirVisitView;

/***/ }),
/* 3298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _styles = __webpack_require__(720);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImgRadLabVisitView(_ref) {
	  var formatMessage = _ref.formatMessage,
	      reasonType = _ref.reasonType,
	      location = _ref.location;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.columnWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.meta },
	          formatMessage({
	            id: 'appointment.list.card.location'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.provider },
	          location
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.columnWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.meta },
	          formatMessage({
	            id: 'appointment.list.card.reasonForVisit'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.provider },
	          reasonType
	        )
	      )
	    )
	  );
	}
	
	ImgRadLabVisitView.propTypes = {
	  formatMessage: PropTypes.func,
	  reasonType: PropTypes.string,
	  location: PropTypes.string
	};
	
	exports.default = (0, _reactCssModules2.default)(ImgRadLabVisitView, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _styles = __webpack_require__(720);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoVisitAWView(_ref) {
	  var formatMessage = _ref.formatMessage;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'row' },
	    _react2.default.createElement(
	      'span',
	      { className: _styles2.default.videoVisitAW },
	      formatMessage({ id: 'appointment.list.card.videoVisitAW' })
	    )
	  );
	}
	
	VideoVisitAWView.propTypes = {
	  formatMessage: PropTypes.func
	};
	
	exports.default = (0, _reactCssModules2.default)(VideoVisitAWView, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _styles = __webpack_require__(720);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VirtualAndOfficeVisitView(_ref) {
	  var formatMessage = _ref.formatMessage,
	      reasonType = _ref.reasonType,
	      providerView = _ref.providerView,
	      personName = _ref.personName,
	      service = _ref.service,
	      paymentDetails = _ref.paymentDetails;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.columnWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.meta },
	          formatMessage({
	            id: providerView ? 'appointment.list.card.patient' : 'appointment.list.card.provider'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.meta },
	          formatMessage({ id: 'appointment.list.card.service' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.provider },
	          personName || '-'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.provider },
	          service
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.columnWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.meta },
	          formatMessage({
	            id: 'appointment.list.card.reasonForVisit'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.meta },
	          formatMessage({
	            id: providerView ? 'appointment.list.card.payment' : 'appointment.list.card.yourCost'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.column },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.provider },
	          reasonType
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.provider },
	          paymentDetails
	        )
	      )
	    )
	  );
	}
	
	VirtualAndOfficeVisitView.propTypes = {
	  formatMessage: PropTypes.func,
	  reasonType: PropTypes.string,
	  providerView: PropTypes.bool,
	  personName: PropTypes.string,
	  service: PropTypes.string,
	  paymentDetails: PropTypes.string
	};
	
	exports.default = (0, _reactCssModules2.default)(VirtualAndOfficeVisitView, _styles2.default, {
	  allowMultiple: true
	});

/***/ }),
/* 3301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _EirVisitView = __webpack_require__(3297);
	
	var _EirVisitView2 = _interopRequireDefault(_EirVisitView);
	
	var _VideoVisitAWView = __webpack_require__(3299);
	
	var _VideoVisitAWView2 = _interopRequireDefault(_VideoVisitAWView);
	
	var _ImgRadLabVisitView = __webpack_require__(3298);
	
	var _ImgRadLabVisitView2 = _interopRequireDefault(_ImgRadLabVisitView);
	
	var _VirtualAndOfficeVisitView = __webpack_require__(3300);
	
	var _VirtualAndOfficeVisitView2 = _interopRequireDefault(_VirtualAndOfficeVisitView);
	
	var _appointment = __webpack_require__(286);
	
	var _constants = __webpack_require__(17);
	
	var _getVisitTypeName = __webpack_require__(436);
	
	var _getVisitTypeName2 = _interopRequireDefault(_getVisitTypeName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RenderVisitView = function RenderVisitView(_ref) {
	  var appointment = _ref.appointment,
	      providerContext = _ref.providerContext,
	      providerView = _ref.providerView;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var providerName = (0, _get2.default)(appointment, 'providerInfo.name');
	  var patientName = (0, _get2.default)(appointment, 'patientUserInfo.displayableName');
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	
	  var reasonType = (0, _getVisitTypeName2.default)({
	    sourceOfCreation: (0, _get2.default)(appointment, 'sourceOfCreation'),
	    defaultValue: (0, _get2.default)(appointment, 'reasonType.name'),
	    formatMessage: formatMessage,
	    visitTypeCode: code
	  });
	
	  var service = (0, _get2.default)(appointment, 'service.name');
	  var location = (0, _get2.default)(appointment, 'location.name');
	
	  var personName = providerView ? patientName : providerName;
	
	  var manageable = providerView || providerContext ? (0, _get2.default)(appointment, 'manageable') : true;
	
	  var paymentDetails = (0, _react.useMemo)(function () {
	    return (0, _appointment.getPaymentDetails)({ appointment: appointment, providerContext: providerContext, formatMessage: formatMessage });
	  }, [appointment, providerContext]);
	
	  var targetName = (0, _react.useMemo)(function () {
	    if (manageable) return personName;
	    if (providerContext && !providerView) return personName;
	
	    return formatMessage({ id: 'common.hidden' });
	  }, [manageable, personName, providerContext, providerView]);
	
	  switch (code) {
	    case _constants.LAB_TYPE_CODE:
	    case _constants.URGENT_CARE_TYPE_CODE:
	    case _constants.IMAGING_TYPE_CODE:
	    case _constants.TECH_CONNECT_CODE:
	      {
	        return _react2.default.createElement(_ImgRadLabVisitView2.default, {
	          formatMessage: formatMessage,
	          location: location,
	          reasonType: reasonType
	        });
	      }
	
	    case _constants.AW_TYPE_CODE:
	      {
	        return _react2.default.createElement(_VideoVisitAWView2.default, { formatMessage: formatMessage });
	      }
	
	    case _constants.VIRTUAL_VISIT_TYPE_CODE:
	    case _constants.URGENT_VISIT_TYPE_CODE:
	      {
	        return _react2.default.createElement(_VirtualAndOfficeVisitView2.default, {
	          reasonType: reasonType,
	          formatMessage: formatMessage,
	          service: service,
	          paymentDetails: paymentDetails,
	          personName: targetName,
	          providerView: providerView
	        });
	      }
	
	    case _constants.HOLD_MY_SPOT_VISIT_TYPE_CODE:
	    case _constants.TELEMEDICINE_VISIT_TYPE_CODE:
	      {
	        return _react2.default.createElement(_EirVisitView2.default, {
	          service: service,
	          reasonType: reasonType,
	          paymentDetails: paymentDetails,
	          providerView: providerView
	        });
	      }
	
	    case _constants.OFFICE_VISIT_TYPE_CODE:
	      return _react2.default.createElement(_VirtualAndOfficeVisitView2.default, {
	        reasonType: reasonType,
	        formatMessage: formatMessage,
	        service: service,
	        paymentDetails: paymentDetails,
	        personName: targetName,
	        providerView: providerView
	      });
	
	    default:
	      return null;
	  }
	};
	
	RenderVisitView.propTypes = {
	  appointment: _propTypes2.default.object.isRequired,
	  providerContext: _propTypes2.default.bool,
	  providerView: _propTypes2.default.bool
	};
	
	exports.default = RenderVisitView;

/***/ }),
/* 3302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _index = __webpack_require__(4957);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TestVideoButton = function TestVideoButton(_ref) {
	  var handleOpenTestCall = _ref.handleOpenTestCall,
	      isJoinVirtualVisitByCode = _ref.isJoinVirtualVisitByCode,
	      showVisitBtn = _ref.showVisitBtn;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  if (!showVisitBtn) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.testBtn },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        border: true,
	        color: 'accent',
	        className: 'w-100',
	        onClick: handleOpenTestCall,
	        disabled: isJoinVirtualVisitByCode
	      },
	      formatMessage({ id: 'virtualVisit.test.check' })
	    )
	  );
	};
	
	TestVideoButton.propTypes = {
	  handleOpenTestCall: _propTypes2.default.func.isRequired,
	  isJoinVirtualVisitByCode: _propTypes2.default.bool.isRequired,
	  showVisitBtn: _propTypes2.default.bool.isRequired
	};
	
	exports.default = TestVideoButton;

/***/ }),
/* 3303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _VideoVisitBtn = __webpack_require__(491);
	
	var _VideoVisitBtn2 = _interopRequireDefault(_VideoVisitBtn);
	
	var _ConfirmVisitByPatientBtn = __webpack_require__(1122);
	
	var _ConfirmVisitByPatientBtn2 = _interopRequireDefault(_ConfirmVisitByPatientBtn);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VisitButtons = function VisitButtons(_ref) {
	  var appointment = _ref.appointment,
	      handleStartVideoVisit = _ref.handleStartVideoVisit,
	      showConfirmByPatientButton = _ref.showConfirmByPatientButton,
	      showVideoVisitButton = _ref.showVideoVisitButton,
	      isJoinVirtualVisitByCode = _ref.isJoinVirtualVisitByCode;
	
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	
	  var text = code === _constants.URGENT_VISIT_TYPE_CODE ? 'common.joinVisit' : null;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    showVideoVisitButton && _react2.default.createElement(_VideoVisitBtn2.default, {
	      title: text,
	      disabled: isJoinVirtualVisitByCode,
	      onStartVideoVisit: handleStartVideoVisit
	    }),
	    showConfirmByPatientButton && _react2.default.createElement(_ConfirmVisitByPatientBtn2.default, {
	      userId: appointment.userId,
	      appointmentId: appointment.id
	    })
	  );
	};
	
	VisitButtons.propTypes = {
	  appointment: _propTypes2.default.object.isRequired,
	  handleStartVideoVisit: _propTypes2.default.func.isRequired,
	  showConfirmByPatientButton: _propTypes2.default.bool.isRequired,
	  showVideoVisitButton: _propTypes2.default.bool.isRequired,
	  isJoinVirtualVisitByCode: _propTypes2.default.bool.isRequired
	};
	
	exports.default = VisitButtons;

/***/ }),
/* 3304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(50);
	
	var _appointment = __webpack_require__(286);
	
	var _constants = __webpack_require__(17);
	
	var _getVisitTypeName = __webpack_require__(436);
	
	var _getVisitTypeName2 = _interopRequireDefault(_getVisitTypeName);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _useVirtualVisitGuard2 = __webpack_require__(1763);
	
	var _selectors2 = __webpack_require__(23);
	
	var _testCall = __webpack_require__(535);
	
	var _styles = __webpack_require__(720);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _TestVideoButton = __webpack_require__(3302);
	
	var _TestVideoButton2 = _interopRequireDefault(_TestVideoButton);
	
	var _VisitButtons = __webpack_require__(3303);
	
	var _VisitButtons2 = _interopRequireDefault(_VisitButtons);
	
	var _RenderVisitView = __webpack_require__(3301);
	
	var _RenderVisitView2 = _interopRequireDefault(_RenderVisitView);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentCard(_ref) {
	  var appointment = _ref.data,
	      isUpcoming = _ref.isUpcoming,
	      formatMessage = _ref.formatMessage,
	      onStartVideoVisit = _ref.onStartVideoVisit,
	      onClick = _ref.onClick,
	      providerView = _ref.providerView,
	      providerContext = _ref.providerContext;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var isProvider = (0, _reactRedux.useSelector)(_selectors2.hasProviderProfileSelector);
	  var testCallPerformed = (0, _reactRedux.useSelector)(_selectors.selectVisitTestCallPerformed);
	
	  var _useVirtualVisitGuard = (0, _useVirtualVisitGuard2.useVirtualVisitGuard)({
	    appointment: appointment,
	    isUpcoming: isUpcoming
	  }),
	      showVisitBtn = _useVirtualVisitGuard.showVisitBtn,
	      virtualCallEnabled = _useVirtualVisitGuard.virtualCallEnabled,
	      isUpcomingAppointmentStatus = _useVirtualVisitGuard.isUpcomingAppointmentStatus;
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return (0, _appointment.getAppointmentTime)({ appointment: appointment, isUpcoming: isUpcoming });
	  }, [appointment, isUpcoming]),
	      hours = _useMemo.hours,
	      date = _useMemo.date;
	
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	
	  var visitTypeName = (0, _get2.default)(appointment, 'visitType.name');
	
	  var visitType = (0, _getVisitTypeName2.default)({
	    sourceOfCreation: (0, _get2.default)(appointment, 'sourceOfCreation'),
	    defaultValue: visitTypeName,
	    formatMessage: formatMessage,
	    visitTypeCode: code
	  });
	
	  var formattedDuration = (0, _get2.default)(appointment, 'formattedDuration');
	
	  var status = _constants.INLINE_TYPES.includes(code) && isUpcomingAppointmentStatus ? formatMessage({ id: 'appointment.list.tabs.inLine' }) : (0, _get2.default)(appointment, 'status.coreAppName');
	
	  var isJoinVirtualVisitByCode = (0, _get2.default)(appointment, 'service.joinVirtualVisitByCode');
	
	  var isConfirmedByPatient = (0, _get2.default)(appointment, 'confirmed');
	  var isConfirmByPatientEnabled = (0, _get2.default)(appointment, 'canConfirmVisit');
	  var prohibitConfirmationForPatientByReasonType = (0, _get2.default)(appointment, 'reasonType.prohibitConfirmationForPatient', false);
	
	  var _ref2 = (0, _get2.default)(appointment, 'allowedActions') || {},
	      checkIn = _ref2.checkIn;
	
	  var isAW = code === _constants.AW_TYPE_CODE;
	
	  var isPendingStatus = status === _constants.APPOINTMENT_STATUSES.PENDING;
	  var manageable = providerView || providerContext ? (0, _get2.default)(appointment, 'manageable') : true;
	
	  var isPatientConfirmationAllowed = isConfirmByPatientEnabled && !prohibitConfirmationForPatientByReasonType;
	
	  var showConfirmByPatientButton = isPatientConfirmationAllowed && !isProvider && !checkIn;
	
	  var showVideoVisitButton = virtualCallEnabled && showVisitBtn;
	
	  var statusTitle = isConfirmedByPatient ? status + '/' + formatMessage({ id: 'common.confirmed' }) : status;
	
	  var securedFormattedDuration = (0, _react.useMemo)(function () {
	    if (_constants.EIR_APPOINTMENT_TYPES.includes(code) && status !== _constants.APPOINTMENT_STATUSES.COMPLETED) {
	      return '';
	    }
	
	    return formattedDuration ? '(' + formattedDuration + ')' : '';
	  }, [formattedDuration]);
	
	  var handleOpenTestCall = function handleOpenTestCall(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    dispatch(_testCall.testCallActions.init({ onStartVideoVisit: onStartVideoVisit, virtualCallEnabled: virtualCallEnabled }));
	  };
	
	  var handleStartVideoVisit = function handleStartVideoVisit(e) {
	    return testCallPerformed ? onStartVideoVisit() : handleOpenTestCall(e);
	  };
	
	  var handleClick = function handleClick() {
	    if (isAW || !manageable) return;
	
	    onClick();
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _Shape2.default,
	      {
	        className: (0, _classnames2.default)(_styles2.default.root, (0, _defineProperty3.default)({}, _styles2.default.notManagable, !manageable)),
	        onClick: handleClick
	      },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'row', className: _styles2.default.strong },
	        _react2.default.createElement(
	          'span',
	          null,
	          visitType + ' ' + date + ', ' + hours + ' ' + securedFormattedDuration
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'right' },
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)(_styles2.default.status, (0, _defineProperty3.default)({}, _styles2.default.pendingStatus, isPendingStatus))
	            },
	            statusTitle
	          )
	        )
	      ),
	      _react2.default.createElement('div', { styleName: 'separator' }),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'content' },
	        _react2.default.createElement(_RenderVisitView2.default, {
	          appointment: appointment,
	          providerContext: providerContext,
	          providerView: providerView
	        }),
	        manageable && (virtualCallEnabled || isPatientConfirmationAllowed) ? _react2.default.createElement(_VisitButtons2.default, {
	          appointment: appointment,
	          isJoinVirtualVisitByCode: isJoinVirtualVisitByCode,
	          handleStartVideoVisit: handleStartVideoVisit,
	          showConfirmByPatientButton: showConfirmByPatientButton,
	          showVideoVisitButton: showVideoVisitButton
	        }) : _react2.default.createElement(_TestVideoButton2.default, {
	          handleOpenTestCall: handleOpenTestCall,
	          isJoinVirtualVisitByCode: isJoinVirtualVisitByCode,
	          showVisitBtn: showVisitBtn
	        })
	      )
	    )
	  );
	}
	
	AppointmentCard.propTypes = {
	  data: PropTypes.object,
	  onClick: PropTypes.func,
	  onStartVideoVisit: PropTypes.func,
	  formatMessage: PropTypes.func,
	  providerContext: PropTypes.bool,
	  providerView: PropTypes.bool,
	  isUpcoming: PropTypes.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(AppointmentCard, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TransactionInfo = __webpack_require__(1123);
	
	var _TransactionInfo2 = _interopRequireDefault(_TransactionInfo);
	
	var _VideoVisitBtn = __webpack_require__(491);
	
	var _VideoVisitBtn2 = _interopRequireDefault(_VideoVisitBtn);
	
	var _appointment = __webpack_require__(286);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _constants = __webpack_require__(17);
	
	var _styles = __webpack_require__(4958);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DRAFT = _constants.APPOINTMENT_STATUSES.DRAFT,
	    WAITING = _constants.APPOINTMENT_STATUSES.WAITING,
	    PENDING = _constants.APPOINTMENT_STATUSES.PENDING,
	    UPCOMING = _constants.APPOINTMENT_STATUSES.UPCOMING,
	    CHECKED_IN = _constants.APPOINTMENT_STATUSES.CHECKED_IN;
	
	
	function AppointmentFooter(_ref) {
	  var providerContext = _ref.providerContext,
	      renderTestButton = _ref.renderTestButton,
	      appointment = _ref.appointment,
	      formatMessage = _ref.formatMessage,
	      handleVideoVisit = _ref.handleVideoVisit,
	      onPayNow = _ref.onPayNow,
	      onCancel = _ref.onCancel,
	      disabled = _ref.disabled,
	      isPendingStatus = _ref.isPendingStatus;
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      opened = _useToggleFlag2[0],
	      openConfirm = _useToggleFlag2[1],
	      closeConfirm = _useToggleFlag2[2];
	
	  var _ref2 = (0, _get2.default)(appointment, 'allowedActions') || {},
	      cancel = _ref2.cancel;
	
	  var copay = (0, _get2.default)(appointment, 'copay');
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	  var status = (0, _get2.default)(appointment, 'status.coreAppName');
	  var paymentStatus = (0, _get2.default)(appointment, 'paymentStatus');
	  var prohibitCancelationForPatient = (0, _get2.default)(appointment, 'reasonType.prohibitCancelationForPatient', false);
	
	  var _formatPaymentInfo = (0, _appointment.formatPaymentInfo)(appointment, true),
	      id = _formatPaymentInfo.id,
	      scope = _formatPaymentInfo.scope,
	      canPay = _formatPaymentInfo.canPay;
	
	  var isZeroCopay = copay === 0;
	  var isPaid = paymentStatus === _constants.PAYMENT_STATUSES.PAID;
	  var isVoided = paymentStatus === _constants.PAYMENT_STATUSES.VOIDED;
	
	  var handleCancel = function handleCancel() {
	    onCancel();
	    closeConfirm();
	  };
	
	  var patientPaymentRow = function patientPaymentRow() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      id !== null && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { styleName: 'paymentTitle' },
	          formatMessage({ id: 'appointment.form.costTitle' }),
	          ':'
	        ),
	        _react2.default.createElement(
	          'span',
	          { styleName: 'paymentValue' },
	          formatMessage({ id: id }, scope)
	        ),
	        (isPaid || isVoided && Boolean(copay)) && _react2.default.createElement(_TransactionInfo2.default, {
	          appointment: appointment,
	          formatMessage: formatMessage
	        })
	      ),
	      canPay && !isPendingStatus && !isZeroCopay && _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: onPayNow,
	          color: 'primary',
	          styleName: 'btn btn--wide',
	          raised: true
	        },
	        formatMessage({ id: 'appointment.actions.pay' })
	      )
	    );
	  };
	
	  var providerContextPaymentRow = function providerContextPaymentRow() {
	    var isVV = (0, _get2.default)(appointment, 'visitType.code') === _constants.VIRTUAL_VISIT_TYPE_CODE;
	
	    var patientAllowedStart = (0, _get2.default)(appointment, 'allowedActions.patientStart');
	
	    if (!isVV || isPendingStatus) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { styleName: 'btn--wide btn--offset' },
	      patientAllowedStart && !isPendingStatus ? _react2.default.createElement(_VideoVisitBtn2.default, { onStartVideoVisit: handleVideoVisit, type: 'primary' }) : renderTestButton()
	    );
	  };
	
	  var renderPaymentRow = function renderPaymentRow() {
	    if (_constants.INLINE_TYPES.includes(code)) {
	      return null;
	    }
	
	    return providerContext ? providerContextPaymentRow() : patientPaymentRow();
	  };
	
	  function renderActionButtons() {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      prohibitCancelationForPatient ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.contactProvider },
	        formatMessage({ id: 'appointment.actions.askProviderForCancel' })
	      ) : _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: openConfirm,
	          color: 'danger-white',
	          disabled: disabled,
	          raised: true,
	          styleName: 'btn--wide btn--offset'
	        },
	        formatMessage({ id: 'appointment.actions.cancelVisit' })
	      ),
	      _react2.default.createElement(_ActionConfirmation2.default, {
	        opened: opened,
	        width: 'rubber',
	        onClose: closeConfirm,
	        onSubmit: handleCancel,
	        title: formatMessage({
	          id: isPaid ? 'appointment.actions.cancelUrgentVisitConfirmation' : 'appointment.actions.cancelVisitConfirmation'
	        }),
	        actionButtonText: formatMessage({
	          id: 'appointment.actions.yesCancel'
	        }),
	        cancelButtonText: { id: 'appointment.actions.noGoBack' }
	      })
	    );
	  }
	
	  var allowedStatuses = (0, _react.useMemo)(function () {
	    switch (code) {
	      case _constants.LAB_TYPE_CODE:
	      case _constants.IMAGING_TYPE_CODE:
	      case _constants.TECH_CONNECT_CODE:
	      case _constants.URGENT_CARE_TYPE_CODE:
	        return [UPCOMING, CHECKED_IN];
	
	      case _constants.URGENT_VISIT_TYPE_CODE:
	        return [DRAFT, WAITING];
	
	      case _constants.VIRTUAL_VISIT_TYPE_CODE:
	        return [UPCOMING, PENDING];
	
	      case _constants.OFFICE_VISIT_TYPE_CODE:
	      case _constants.HOLD_MY_SPOT_VISIT_TYPE_CODE:
	      case _constants.TELEMEDICINE_VISIT_TYPE_CODE:
	        return cancel ? [UPCOMING, PENDING, CHECKED_IN] : [];
	
	      default:
	        return [];
	    }
	  }, [code, cancel]);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'footer' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'confirmationRow' },
	      allowedStatuses.includes(status) && renderActionButtons()
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'paymentRow' },
	      renderPaymentRow()
	    )
	  );
	}
	
	AppointmentFooter.propTypes = {
	  appointment: PropTypes.object,
	  formatMessage: PropTypes.func,
	  handleVideoVisit: PropTypes.func,
	  disabled: PropTypes.bool,
	  providerContext: PropTypes.bool,
	  onPayNow: PropTypes.func,
	  onCancel: PropTypes.func,
	  renderTestButton: PropTypes.func,
	  isPendingStatus: PropTypes.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(AppointmentFooter, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(17);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmVisitByPatientBtn = __webpack_require__(1122);
	
	var _ConfirmVisitByPatientBtn2 = _interopRequireDefault(_ConfirmVisitByPatientBtn);
	
	var _styles = __webpack_require__(4959);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentHeader(_ref) {
	  var hasMandatoryPaymentWarning = _ref.hasMandatoryPaymentWarning,
	      providerContext = _ref.providerContext,
	      appointment = _ref.appointment,
	      formatMessage = _ref.formatMessage,
	      onCheckIn = _ref.onCheckIn,
	      onNoShow = _ref.onNoShow,
	      onComplete = _ref.onComplete,
	      disabled = _ref.disabled;
	
	  var status = (0, _get2.default)(appointment, 'status.coreAppName');
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	  var isConfirmedByPatient = (0, _get2.default)(appointment, 'confirmed');
	
	  var _ref2 = (0, _get2.default)(appointment, 'allowedActions') || {},
	      checkIn = _ref2.checkIn,
	      checkInPossible = _ref2.checkInPossible;
	
	  var isConfirmByPatientEnabled = (0, _get2.default)(appointment, 'canConfirmVisit');
	  var appointmentFormattedDuration = (0, _get2.default)(appointment, 'formattedDuration');
	  var prohibitConfirmationForPatientByReasonType = (0, _get2.default)(appointment, 'reasonType.prohibitConfirmationForPatient', false);
	
	  var isNotCheckedIn = checkIn === false;
	  var isConfirmByPatientForbidden = isConfirmByPatientEnabled === false;
	  var isHoldMySpotVisitType = code === _constants.HOLD_MY_SPOT_VISIT_TYPE_CODE;
	
	  function renderNoShowBtn() {
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        onClick: onNoShow,
	        styleName: 'btn',
	        color: 'transparent',
	        disabled: disabled
	      },
	      formatMessage({ id: 'appointment.actions.noShow' })
	    );
	  }
	
	  function renderCompleteBtn() {
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        onClick: onComplete,
	        color: 'transparent',
	        styleName: 'btn',
	        disabled: disabled
	      },
	      formatMessage({ id: 'appointment.actions.complete' })
	    );
	  }
	
	  function renderCheckInBtn() {
	    return _react2.default.createElement(
	      _Button2.default,
	      { onClick: onCheckIn, color: 'primary', raised: true, disabled: disabled },
	      formatMessage({ id: 'appointment.actions.checkIn' })
	    );
	  }
	
	  switch (status) {
	    case _constants.APPOINTMENT_STATUSES.IN_PROCESS:
	      {
	        if (code === _constants.TECH_CONNECT_CODE) {
	          return null;
	        }
	
	        if (providerContext) {
	          return _react2.default.createElement(
	            'div',
	            { styleName: 'in-progress' },
	            renderNoShowBtn(),
	            renderCompleteBtn()
	          );
	        }
	
	        return _react2.default.createElement(
	          'span',
	          { styleName: 'status' },
	          status
	        );
	      }
	
	    case _constants.APPOINTMENT_STATUSES.CHECKED_IN:
	      {
	        if (providerContext) {
	          return _react2.default.createElement(
	            'div',
	            { styleName: 'in-progress' },
	            renderNoShowBtn(),
	            renderCompleteBtn()
	          );
	        }
	
	        return _react2.default.createElement(
	          'span',
	          { styleName: 'status' },
	          status
	        );
	      }
	
	    case _constants.APPOINTMENT_STATUSES.UPCOMING:
	      {
	        var showStatus = void 0;
	
	        if (providerContext) {
	          return renderNoShowBtn();
	        }
	
	        if (_constants.INLINE_TYPES.includes(code)) {
	          return null;
	        }
	
	        if (checkIn && checkInPossible && !isHoldMySpotVisitType) {
	          if (hasMandatoryPaymentWarning) {
	            return _react2.default.createElement(
	              'span',
	              { styleName: 'status' },
	              formatMessage({ id: 'appointment.actions.checkIn.warning' })
	            );
	          }
	          return renderCheckInBtn();
	        }
	
	        if (isConfirmByPatientEnabled && !prohibitConfirmationForPatientByReasonType) {
	          return _react2.default.createElement(_ConfirmVisitByPatientBtn2.default, {
	            userId: appointment.userId,
	            appointmentId: appointment.id,
	            type: 'primary'
	          });
	        }
	
	        if (!prohibitConfirmationForPatientByReasonType && isConfirmByPatientForbidden && isConfirmedByPatient === false && isNotCheckedIn && !isHoldMySpotVisitType) {
	          showStatus = formatMessage({
	            id: 'appointment.actions.availableConfirm'
	          });
	        }
	
	        if ((isConfirmByPatientForbidden && isConfirmedByPatient === true || prohibitConfirmationForPatientByReasonType) && isNotCheckedIn && !isHoldMySpotVisitType) {
	          var i18n = hasMandatoryPaymentWarning ? 'appointment.actions.checkIn.warning' : 'appointment.actions.availableCheckInTime';
	
	          showStatus = formatMessage({ id: i18n });
	        }
	
	        if (!checkInPossible) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'span',
	          { styleName: 'status' },
	          showStatus
	        );
	      }
	
	    case _constants.APPOINTMENT_STATUSES.COMPLETED:
	      {
	        return _react2.default.createElement(
	          'div',
	          { className: _styles2.default.durationWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.durationTitle },
	            formatMessage({ id: 'appointment.details.visitDuration.title' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.durationValue },
	            appointmentFormattedDuration
	          )
	        );
	      }
	
	    default:
	      return _react2.default.createElement(
	        'span',
	        { styleName: 'status' },
	        isConfirmedByPatient ? status + '/' + formatMessage({ id: 'common.confirmed' }) : status
	      );
	  }
	}
	
	AppointmentHeader.propTypes = {
	  disabled: PropTypes.bool,
	  onNoShow: PropTypes.func,
	  onCheckIn: PropTypes.func,
	  onComplete: PropTypes.func,
	  formatMessage: PropTypes.func,
	  appointment: PropTypes.object,
	  providerContext: PropTypes.bool,
	  hasMandatoryPaymentWarning: PropTypes.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(AppointmentHeader, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _couponPriceCalculationReq = __webpack_require__(667);
	
	var couponCalculation = _interopRequireWildcard(_couponPriceCalculationReq);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _selectors = __webpack_require__(64);
	
	var _styles = __webpack_require__(4960);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    couponPending: (0, _selectors.selectCouponCalculationPending)(state),
	    couponErrors: (0, _selectors.selectCouponCalculationError)(state),
	    discount: (0, _selectors.selectCouponCalculationData)(state),
	    couponVerification: (0, _selectors.selectCouponVerificationData)(state),
	    couponVerificationPending: (0, _selectors.selectCouponVerificationPending)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  calculateDiscount: couponCalculation.actions.send,
	  clearCalculation: couponCalculation.actions.clear,
	  clearPayment: _appointmentDetails.appointmentDetailsActions.clearPayment,
	  startPayment: _appointmentDetails.appointmentDetailsActions.startPaymentProcess
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var clearPayment = _ref.clearPayment,
	      clearCalculation = _ref.clearCalculation;
	  return {
	    clear: function clear() {
	      clearPayment();
	      clearCalculation();
	    }
	  };
	}), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(4961);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConfirmedIcon = function ConfirmedIcon() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Icon2.default, { name: 'icon-signed-consent', size: 12, className: _index2.default.icon }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.confirmedStatusTitle },
	      formatMessage({ id: 'common.confirmed' })
	    )
	  );
	};
	
	exports.default = ConfirmedIcon;

/***/ }),
/* 3309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styles = __webpack_require__(4962);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DiscountForm(_ref) {
	  var formatMessage = _ref.formatMessage,
	      loading = _ref.loading,
	      onApply = _ref.onApply,
	      serverErrors = _ref.serverErrors;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      coupon = _useState2[0],
	      setCoupon = _useState2[1];
	
	  var isValid = !!coupon && !loading;
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    onApply(coupon);
	  };
	
	  var validationError = (0, _react.useMemo)(function () {
	    return serverErrors ? formatMessage({ id: 'appointment.payment.discountError' }) : null;
	  }, [serverErrors]);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'Discount' },
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'DiscountTitle' },
	        formatMessage({ id: 'appointment.payment.discountTitle' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'DiscountText' },
	        formatMessage({ id: 'appointment.payment.discountText' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'DiscountInput' },
	        _react2.default.createElement(_TextInput2.default, {
	          styleName: 'DiscountInput-control',
	          type: 'text',
	          limit: 10,
	          label: formatMessage({ id: 'appointment.payment.couponCode' }),
	          placeholder: formatMessage({
	            id: 'appointment.payment.couponCode'
	          }),
	          onChange: function onChange(value) {
	            return setCoupon(value);
	          },
	          value: coupon
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          { type: 'submit', disabled: !isValid, color: 'primary', raised: true },
	          formatMessage({ id: 'appointment.payment.apply' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'DiscountError' },
	        validationError
	      )
	    )
	  );
	}
	
	DiscountForm.propTypes = {
	  formatMessage: PropTypes.func,
	  loading: PropTypes.bool,
	  onApply: PropTypes.func,
	  serverErrors: PropTypes.object
	};
	
	exports.default = (0, _reactCssModules2.default)(DiscountForm, _styles2.default, {
	  allowMultiple: true
	});

/***/ }),
/* 3310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _getVisitTypeName = __webpack_require__(436);
	
	var _getVisitTypeName2 = _interopRequireDefault(_getVisitTypeName);
	
	var _index = __webpack_require__(4963);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EirVisitTypeHeaderTopSection = function EirVisitTypeHeaderTopSection(_ref) {
	  var appointment = _ref.appointment;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var organization = (0, _get2.default)(appointment, 'organization');
	
	  var name = (0, _get2.default)(organization, 'name');
	  var thumbMin = (0, _get2.default)(organization, 'logo.thumbMin');
	  var visitName = (0, _get2.default)(appointment, 'visitType.name');
	  var visitTypeCode = (0, _get2.default)(appointment, 'visitType.code');
	
	  var visitTypeName = (0, _getVisitTypeName2.default)({
	    sourceOfCreation: (0, _get2.default)(appointment, 'sourceOfCreation'),
	    defaultValue: visitName,
	    formatMessage: formatMessage,
	    visitTypeCode: visitTypeCode
	  });
	
	  return _react2.default.createElement(
	    'section',
	    { className: _index2.default.section },
	    _react2.default.createElement('img', {
	      style: { width: 32, height: 32 },
	      src: thumbMin,
	      alt: 'organization-logo'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.titles },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        visitTypeName
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.subtitle },
	        name
	      )
	    )
	  );
	};
	
	EirVisitTypeHeaderTopSection.propTypes = {
	  appointment: _propTypes2.default.object
	};
	
	exports.default = EirVisitTypeHeaderTopSection;

/***/ }),
/* 3311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(42);
	
	var _couponVerificationReq = __webpack_require__(418);
	
	var couponVerification = _interopRequireWildcard(_couponVerificationReq);
	
	var _checkInAppointmentReq = __webpack_require__(533);
	
	var checkInReq = _interopRequireWildcard(_checkInAppointmentReq);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var cancelReq = _interopRequireWildcard(_cancelAppointmentReq);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _selectors = __webpack_require__(50);
	
	var _selectors2 = __webpack_require__(64);
	
	var _constants = __webpack_require__(17);
	
	var _managePendingRequest = __webpack_require__(263);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    checkingPending: (0, _selectors2.selectCheckInAppointmentPending)(state),
	    cancelPending: (0, _selectors2.selectCancelAppointmentPending)(state),
	    paymentVerificationPending: (0, _selectors2.selectPaymentVerificationPending)(state),
	    globalPaymentPending: (0, _selectors2.selectPaymentGlobalLoader)(state),
	    isCouponAvailable: (0, _selectors2.selectCouponAvailability)(state),
	    testCallPerformed: (0, _selectors.selectVisitTestCallPerformed)(state),
	    pendingManageReq: (0, _selectors2.selectManagePendingRequestSending)(state)
	  };
	};
	var mapDispatchToProps = {
	  checkIn: checkInReq.actions.send,
	  cancel: cancelReq.actions.send,
	  verifyCoupon: couponVerification.actions.send,
	  clearCouponVerification: couponVerification.actions.clear,
	  changeStatus: _appointmentDetails.appointmentDetailsActions.changeStatus,
	  managePendingRequest: _managePendingRequest.actions.send,
	  openConsentModal: _appointmentConsentModal.appointmentConsentsModalActions.open
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, _reactRouter.withRouter, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var changeStatus = _ref.changeStatus;
	  return {
	    noShowVisit: function noShowVisit(id, appointment) {
	      changeStatus({
	        event: _constants.VIRTUAL_VISIT_EVENTS.BREAK_VISIT,
	        reason: 'no_show',
	        appointment: appointment,
	        id: id
	      });
	    },
	    completeVisit: function completeVisit(id, appointment) {
	      changeStatus({
	        event: _constants.VIRTUAL_VISIT_EVENTS.FINISH_VISIT,
	        appointment: appointment,
	        id: id
	      });
	    },
	    cancelVirtualVisit: function cancelVirtualVisit(id, appointment) {
	      changeStatus({
	        event: _constants.VIRTUAL_VISIT_EVENTS.BREAK_VISIT,
	        reason: 'canceled',
	        appointment: appointment,
	        id: id
	      });
	    }
	  };
	}));

/***/ }),
/* 3312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useDetailsRows = useDetailsRows;
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _useOverviewRowsBuilder = __webpack_require__(1909);
	
	var _appointment = __webpack_require__(286);
	
	var _constants = __webpack_require__(17);
	
	var _getVisitTypeName = __webpack_require__(436);
	
	var _getVisitTypeName2 = _interopRequireDefault(_getVisitTypeName);
	
	var _checkForIsSignedAllConsents = __webpack_require__(767);
	
	var _constants2 = __webpack_require__(493);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useDetailsRows(_ref) {
	  var provider = _ref.provider,
	      isUpcoming = _ref.isUpcoming,
	      appointment = _ref.appointment,
	      formatMessage = _ref.formatMessage,
	      isUrgentVisit = _ref.isUrgentVisit,
	      providerContext = _ref.providerContext,
	      prescribedMedications = _ref.prescribedMedications;
	
	  var status = (0, _get2.default)(appointment, 'status.coreAppName');
	  var icsAllowed = (0, _get2.default)(appointment, 'status.icsUrlAllowed');
	  var icsUrl = (0, _get2.default)(appointment, 'icsUrl');
	  var visitTypeCode = (0, _get2.default)(appointment, 'visitType.code');
	  var appointmentFormattedDuration = (0, _get2.default)(appointment, 'formattedDuration');
	  var isRequiredSurvey = (0, _get2.default)(appointment, 'requiredSurveys', false);
	  var isSignedAllConsents = (0, _checkForIsSignedAllConsents.checkForIsSignedAllConsents)(appointment);
	
	  var isEirTelemedicineVisitType = visitTypeCode === _constants.TELEMEDICINE_VISIT_TYPE_CODE;
	
	  var notSignedPreVisits = (0, _get2.default)(appointment, 'surveyAssignments', []).filter(function (form) {
	    return ![_constants2.STATUS_SURVEY.COMPLETED, _constants2.STATUS_SURVEY.EXPIRED].includes(form.status) && !!form.survey.required;
	  });
	
	  var isAvailablePrescriptionSection = (0, _get2.default)(appointment, 'prescriptionTabAvailability', false);
	
	  var _useOverviewRowsBuild = (0, _useOverviewRowsBuilder.useOverviewRowsBuilder)({ formatMessage: formatMessage }),
	      makeDocRow = _useOverviewRowsBuild.makeDocRow,
	      makeProviderRow = _useOverviewRowsBuild.makeProviderRow,
	      makeReasonRow = _useOverviewRowsBuild.makeReasonRow,
	      makeDateRow = _useOverviewRowsBuild.makeDateRow,
	      makeSurveyRow = _useOverviewRowsBuild.makeSurveyRow,
	      makeEditablePaymentRow = _useOverviewRowsBuild.makeEditablePaymentRow,
	      makeConsentRow = _useOverviewRowsBuild.makeConsentRow,
	      makeNotificationConsentRow = _useOverviewRowsBuild.makeNotificationConsentRow,
	      makePrescriptionsRow = _useOverviewRowsBuild.makePrescriptionsRow;
	
	  var service = (0, _get2.default)(appointment, 'service');
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	  var location = (0, _get2.default)(appointment, 'location', {});
	  var geofenceLat = location.geofenceLat,
	      geofenceLng = location.geofenceLng;
	
	
	  var isInlineAppointment = _constants.INLINE_TYPES.includes(code);
	
	  var isVirtualVisit = _constants.VIRTUAL_VISIT_TYPE_CODE === code;
	
	  var isForbiddenMap = _constants.FORBIDDEN_VISIT_TYPES_FOR_MAP.includes(code) || !(geofenceLat && geofenceLng);
	
	  var icsVisitTypeCodeAllowed = [_constants.OFFICE_VISIT_TYPE_CODE, _constants.VIRTUAL_VISIT_TYPE_CODE];
	
	  var _visitOverviewAdapter = (0, _appointment.visitOverviewAdapter)(appointment),
	      schedule = _visitOverviewAdapter.schedule,
	      reason = _visitOverviewAdapter.reason;
	
	  var time = schedule.time;
	
	  var resolvedReason = (0, _extends3.default)({}, reason, {
	    type: (0, _getVisitTypeName2.default)({
	      sourceOfCreation: (0, _get2.default)(appointment, 'sourceOfCreation'),
	      defaultValue: (0, _get2.default)(reason, 'type'),
	      formatMessage: formatMessage,
	      visitTypeCode: code
	    })
	  });
	
	  var DATE_ROW = (0, _react.useMemo)(function () {
	    return makeDateRow({
	      time: time,
	      status: status,
	      icsUrl: icsUrl,
	      icsAllowed: icsAllowed && icsVisitTypeCodeAllowed.includes(visitTypeCode),
	      additionalDuration: appointmentFormattedDuration,
	      visitTypeCode: code
	    });
	  }, [time, appointmentFormattedDuration, status, code]);
	
	  var REASON_ROW = (0, _react.useMemo)(function () {
	    return makeReasonRow(resolvedReason);
	  }, [resolvedReason]);
	
	  var PRESCRIPTION_ROW = (0, _react.useMemo)(function () {
	    return makePrescriptionsRow(prescribedMedications);
	  }, [prescribedMedications]);
	
	  var PROVIDER_ROW = (0, _react.useMemo)(function () {
	    var hasLocation = !isUrgentVisit;
	    var options = isInlineAppointment ? {
	      renderCell: function renderCell() {
	        return (0, _appointment.getInlineCellData)(provider, formatMessage);
	      }
	    } : { service: service, isVirtualVisit: isVirtualVisit };
	
	    return makeProviderRow((0, _extends3.default)({
	      provider: provider,
	      hasLocation: hasLocation
	    }, options, {
	      isForbiddenMap: isForbiddenMap
	    }));
	  }, [provider, service, isInlineAppointment]);
	
	  var DOC_ROW = (0, _react.useMemo)(function () {
	    return makeDocRow({ providerContext: providerContext, appointment: appointment });
	  }, [providerContext, appointment]);
	
	  var SURVEY_ROW = (0, _react.useMemo)(function () {
	    return makeSurveyRow({ appointment: appointment });
	  }, [appointment]);
	
	  var CONSENT_ROW = (0, _react.useMemo)(function () {
	    return makeConsentRow({ appointment: appointment, providerContext: providerContext });
	  }, [appointment, providerContext]);
	
	  var NOTIFICATION_ROW = (0, _react.useMemo)(function () {
	    return makeNotificationConsentRow({ appointment: appointment, providerContext: providerContext });
	  }, [appointment, providerContext]);
	
	  var extraRows = providerContext ? [makeEditablePaymentRow({
	    appointment: appointment,
	    isUpcoming: isUpcoming
	  })] : [];
	
	  var showNotificationRow = (0, _react.useMemo)(function () {
	    return !providerContext && status === _constants.APPOINTMENT_STATUSES.UPCOMING;
	  }, [providerContext, status]);
	
	  var rows = isInlineAppointment ? [].concat((0, _toConsumableArray3.default)(showNotificationRow && [NOTIFICATION_ROW]), [DATE_ROW, PROVIDER_ROW, REASON_ROW], (0, _toConsumableArray3.default)(isAvailablePrescriptionSection && [PRESCRIPTION_ROW]), [SURVEY_ROW, DOC_ROW]) : [].concat((0, _toConsumableArray3.default)((!isSignedAllConsents || isRequiredSurvey && notSignedPreVisits.length > 0) && [NOTIFICATION_ROW]), [DATE_ROW], (0, _toConsumableArray3.default)(isEirTelemedicineVisitType ? [] : [PROVIDER_ROW]), [REASON_ROW], (0, _toConsumableArray3.default)(isAvailablePrescriptionSection && [PRESCRIPTION_ROW]), extraRows, [SURVEY_ROW, DOC_ROW, CONSENT_ROW]);
	
	  return {
	    rows: rows
	  };
	}

/***/ }),
/* 3313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.AppointmentFilter = AppointmentFilter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _styles = __webpack_require__(18);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(4964);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AppointmentFilter(_ref) {
	  var formatMessage = _ref.formatMessage,
	      setAppointmentFiltersOption = _ref.setAppointmentFiltersOption,
	      isFilterToday = _ref.isFilterToday,
	      isFilterByTypeVisit = _ref.isFilterByTypeVisit;
	
	  var todayBtn = formatMessage({ id: 'common.today' });
	  var virtualVisitBtn = formatMessage({
	    id: 'healthboard.filter.virtualVisit'
	  });
	  var clearFiltersBtn = formatMessage({
	    id: 'healthboard.filter.clearFilters'
	  });
	
	  var handleResetAllFilters = function handleResetAllFilters() {
	    setAppointmentFiltersOption({
	      isFilterToday: false,
	      isFilterByTypeVisit: false
	    });
	  };
	
	  var handleSetEnabledToday = function handleSetEnabledToday(e) {
	    e.stopPropagation();
	    setAppointmentFiltersOption({
	      isFilterToday: false
	    });
	  };
	
	  var handleSetEnabledVirtualVisit = function handleSetEnabledVirtualVisit(e) {
	    e.stopPropagation();
	    setAppointmentFiltersOption({
	      isFilterByTypeVisit: false
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: (0, _classnames2.default)(_index2.default.btn, (0, _defineProperty3.default)({}, _index2.default.enabledBtn, isFilterToday)),
	        onClick: function onClick() {
	          return setAppointmentFiltersOption({
	            isFilterToday: true
	          });
	        },
	        border: true
	      },
	      _react2.default.createElement(
	        'span',
	        null,
	        todayBtn
	      ),
	      isFilterToday && _react2.default.createElement(_Icon2.default, {
	        className: _index2.default.icon,
	        style: { fill: _styles.COLORS.white },
	        width: 12,
	        height: 12,
	        onClick: handleSetEnabledToday,
	        name: 'close'
	      })
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: (0, _classnames2.default)(_index2.default.btn, _index2.default.btnVirtualVisit, (0, _defineProperty3.default)({}, _index2.default.enabledBtn, isFilterByTypeVisit)),
	        onClick: function onClick() {
	          return setAppointmentFiltersOption({
	            isFilterByTypeVisit: true
	          });
	        },
	        border: true
	      },
	      _react2.default.createElement(
	        'span',
	        null,
	        virtualVisitBtn
	      ),
	      isFilterByTypeVisit && _react2.default.createElement(_Icon2.default, {
	        className: _index2.default.icon,
	        style: { fill: _styles.COLORS.white },
	        width: 12,
	        height: 12,
	        onClick: handleSetEnabledVirtualVisit,
	        name: 'close'
	      })
	    ),
	    (isFilterToday || isFilterByTypeVisit) && _react2.default.createElement(
	      'div',
	      {
	        className: _index2.default.clearBtn,
	        onClick: function onClick() {
	          return handleResetAllFilters();
	        }
	      },
	      clearFiltersBtn
	    )
	  );
	}
	
	AppointmentFilter.propTypes = {
	  formatMessage: PropTypes.func,
	  setAppointmentFiltersOption: PropTypes.func,
	  isFilterToday: PropTypes.bool,
	  isFilterByTypeVisit: PropTypes.bool
	};

/***/ }),
/* 3314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _VisitConsents = __webpack_require__(1125);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CompletedConsentPopup(_ref) {
	  var item = _ref.item,
	      opened = _ref.opened,
	      onClose = _ref.onClose,
	      targetUser = _ref.targetUser,
	      formatMessage = _ref.formatMessage;
	
	  var userAppointmentService = (0, _get2.default)(item, 'userAppointment.service');
	  var dateTime = (0, _get2.default)(item, 'userAppointment.startTime');
	
	  var consentItem = {
	    service: userAppointmentService,
	    dateTime: dateTime,
	    consentsAssignment: item,
	    patientUserInfo: targetUser
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: opened,
	      onClose: onClose,
	      title: formatMessage({ id: 'appointments.form.consentForm' }),
	      width: (0, _mobileHelpers.isDesktop)() ? 'small' : 'medium'
	    },
	    _react2.default.createElement(
	      _Paper2.default,
	      { isLayoutColumn: true, className: 'pa3' },
	      _react2.default.createElement(_VisitConsents.VisitConsents, {
	        appointment: consentItem,
	        formatMessage: formatMessage
	      })
	    )
	  );
	}
	
	CompletedConsentPopup.propTypes = {
	  formatMessage: PropTypes.func,
	  opened: PropTypes.bool,
	  item: PropTypes.object,
	  onClose: PropTypes.func,
	  targetUser: PropTypes.object
	};
	
	exports.default = CompletedConsentPopup;

/***/ }),
/* 3315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _VisitConsents = __webpack_require__(1125);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CompletedElectronicConsentPopup(_ref) {
	  var item = _ref.item,
	      opened = _ref.opened,
	      onClose = _ref.onClose,
	      targetUser = _ref.targetUser,
	      formatMessage = _ref.formatMessage;
	
	  var dateTime = (0, _get2.default)(item, 'completedTime');
	
	  var consentItem = {
	    service: {},
	    patientUserInfo: targetUser,
	    dateTime: dateTime,
	    consentsAssignment: {
	      allSigned: true,
	      consents: [item.consent],
	      consentsCount: 1,
	      id: item.id
	    }
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: opened,
	      onClose: onClose,
	      title: formatMessage({ id: 'appointments.form.consentForm' }),
	      width: (0, _mobileHelpers.isDesktop)() ? 'small' : 'medium'
	    },
	    _react2.default.createElement(
	      _Paper2.default,
	      { isLayoutColumn: true, className: 'pa3' },
	      _react2.default.createElement(_VisitConsents.VisitConsents, {
	        appointment: consentItem,
	        formatMessage: formatMessage
	      })
	    )
	  );
	}
	
	CompletedElectronicConsentPopup.propTypes = {
	  formatMessage: PropTypes.func,
	  opened: PropTypes.bool,
	  item: PropTypes.object,
	  onClose: PropTypes.func,
	  targetUser: PropTypes.object
	};
	
	exports.default = CompletedElectronicConsentPopup;

/***/ }),
/* 3316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(64);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    providerContext: (0, _selectors.hasProviderProfileSelector)(state),
	    isSignConsentLoading: (0, _selectors2.selectSignAppointmentConsentLoading)(state),
	    isSignConsentSucceed: (0, _selectors2.selectSignAppointmentConsentSucceed)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  signAppointmentConsent: _signAppointmentConsentReq.actions.send,
	  clearSignConsentData: _signAppointmentConsentReq.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ConsentInfo = __webpack_require__(1101);
	
	var _ConsentInfo2 = _interopRequireDefault(_ConsentInfo);
	
	var _SingConsentButton = __webpack_require__(492);
	
	var _SingConsentButton2 = _interopRequireDefault(_SingConsentButton);
	
	var _useConsentOutcomesInfo = __webpack_require__(798);
	
	var _useConsentOutcomesInfo2 = _interopRequireDefault(_useConsentOutcomesInfo);
	
	var _useSignAppointmentConsent = __webpack_require__(1212);
	
	var _useSignAppointmentConsent2 = _interopRequireDefault(_useSignAppointmentConsent);
	
	var _renderElectronicConsentHeader = __webpack_require__(1755);
	
	var _getElectronicConsentHeaderRenderData = __webpack_require__(1762);
	
	var _getElectronicConsentHeaderRenderData2 = _interopRequireDefault(_getElectronicConsentHeaderRenderData);
	
	var _enhance = __webpack_require__(3316);
	
	var _styles = __webpack_require__(4967);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ElectronicConsentPopup = function ElectronicConsentPopup(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      clearSignConsentData = _ref.clearSignConsentData,
	      isSignConsentLoading = _ref.isSignConsentLoading,
	      isSignConsentSucceed = _ref.isSignConsentSucceed,
	      item = _ref.item,
	      onClose = _ref.onClose,
	      opened = _ref.opened,
	      providerContext = _ref.providerContext;
	
	  var title = formatMessage({
	    id: 'appointment.electronicConsent.details.titlePatient'
	  });
	
	  var _getElectronicConsent = (0, _getElectronicConsentHeaderRenderData2.default)(item, formatMessage),
	      assignedBy = _getElectronicConsent.assignedBy,
	      consentId = _getElectronicConsent.consentId,
	      consentName = _getElectronicConsent.consentName,
	      consentTypeName = _getElectronicConsent.consentTypeName,
	      consentVersionTitle = _getElectronicConsent.consentVersionTitle,
	      content = _getElectronicConsent.content,
	      formatTime = _getElectronicConsent.formatTime,
	      multipleOutcomes = _getElectronicConsent.multipleOutcomes,
	      organizationName = _getElectronicConsent.organizationName,
	      outcomeTitles = _getElectronicConsent.outcomeTitles,
	      userId = _getElectronicConsent.userId,
	      version = _getElectronicConsent.version;
	
	  var consent = (0, _react.useMemo)(function () {
	    return {
	      content: content,
	      multipleOutcomes: multipleOutcomes,
	      name: consentName,
	      outcomeTitles: outcomeTitles,
	      typeName: consentTypeName,
	      version: version,
	      versionTitle: consentVersionTitle
	    };
	  }, [consentName, consentTypeName, consentVersionTitle, content, version, multipleOutcomes, outcomeTitles]);
	
	  var _useConsentOutcomesIn = (0, _useConsentOutcomesInfo2.default)(consent),
	      buttonAccept = _useConsentOutcomesIn.buttonAccept,
	      consentOutcomeTitles = _useConsentOutcomesIn.consentOutcomeTitles,
	      isConsentHasMultipleOutcomes = _useConsentOutcomesIn.isConsentHasMultipleOutcomes;
	
	  var handleAcceptConsent = (0, _useSignAppointmentConsent2.default)({
	    consentId: consentId,
	    userId: userId,
	    consentVersion: version
	  });
	
	  (0, _react.useEffect)(function () {
	    if (isSignConsentSucceed) {
	      onClose();
	    }
	  }, [isSignConsentSucceed]);
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      clearSignConsentData();
	      onClose();
	    };
	  }, []);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: opened,
	      onClose: onClose,
	      title: title,
	      width: 'medium',
	      mobileFullScreen: false
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_styles2.default.root, (0, _defineProperty3.default)({}, _styles2.default.disableModal, isSignConsentLoading))
	      },
	      isSignConsentLoading ? _react2.default.createElement(_Loader2.default, { className: 'absolute-center' }) : null,
	      !providerContext && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.header },
	        (0, _renderElectronicConsentHeader.renderElectronicConsentHeader)(formatMessage, assignedBy, consentName, organizationName, formatTime)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.consent },
	        _react2.default.createElement(_ConsentInfo2.default, { consent: consent }),
	        !providerContext && _react2.default.createElement(_SingConsentButton2.default, {
	          buttonAccept: buttonAccept,
	          handleAcceptConsent: handleAcceptConsent,
	          isConsentHasMultipleOutcomes: isConsentHasMultipleOutcomes,
	          titles: consentOutcomeTitles
	        })
	      )
	    )
	  );
	};
	
	ElectronicConsentPopup.propTypes = {
	  opened: PropTypes.bool,
	  intl: PropTypes.object,
	  item: PropTypes.object,
	  onClose: PropTypes.func,
	  providerContext: PropTypes.bool,
	  isSignConsentSucceed: PropTypes.bool,
	  isSignConsentLoading: PropTypes.bool,
	  clearSignConsentData: PropTypes.func
	};
	
	exports.default = (0, _enhance.enhance)(ElectronicConsentPopup);

/***/ }),
/* 3318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _PopupWrapper = __webpack_require__(1747);
	
	var _PopupWrapper2 = _interopRequireDefault(_PopupWrapper);
	
	var _InsurancesInfo = __webpack_require__(775);
	
	var _InsurancesInfo2 = _interopRequireDefault(_InsurancesInfo);
	
	var _DescriptionSection = __webpack_require__(1746);
	
	var _DescriptionSection2 = _interopRequireDefault(_DescriptionSection);
	
	var _useFetchToDoTaskInsurancesData = __webpack_require__(1748);
	
	var _useFetchToDoTaskInsurancesData2 = _interopRequireDefault(_useFetchToDoTaskInsurancesData);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _index = __webpack_require__(4969);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompletedInsuranceToDoTaskPopup = function CompletedInsuranceToDoTaskPopup(_ref) {
	  var task = _ref.task,
	      taskId = _ref.taskId,
	      onClose = _ref.onClose,
	      userId = _ref.userId;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _ref2 = task || {},
	      todoTask = _ref2.todoTask,
	      taskAssigneeId = _ref2.taskAssigneeId,
	      taskAssigneeFullName = _ref2.taskAssigneeFullName,
	      itemId = _ref2.itemId,
	      hasAdditionalPatientInsurances = _ref2.hasAdditionalPatientInsurances;
	
	  var _ref3 = todoTask || {},
	      description = _ref3.description,
	      links = _ref3.links;
	
	  var _useFetchToDoTaskInsu = (0, _useFetchToDoTaskInsurancesData2.default)({
	    userId: userId,
	    hasAdditionalPatientInsurances: hasAdditionalPatientInsurances,
	    todoTaskAssignmentId: taskId,
	    isCompleted: true
	  }),
	      isInsuranceRelatedDataFetching = _useFetchToDoTaskInsu.isInsuranceRelatedDataFetching;
	
	  var toDoTaskData = (0, _react.useMemo)(function () {
	    return {
	      itemId: itemId,
	      isCompleted: true
	    };
	  }, [itemId]);
	
	  return _react2.default.createElement(
	    _PopupWrapper2.default,
	    {
	      handleClose: onClose,
	      taskId: taskId,
	      formatMessage: formatMessage,
	      task: task,
	      title: formatMessage({ id: 'task.completed' })
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.descriptionSection },
	        _react2.default.createElement(_DescriptionSection2.default, { description: description, links: links })
	      ),
	      isInsuranceRelatedDataFetching ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(_InsurancesInfo2.default, {
	        flowType: _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO,
	        withSelfPayEnding: true,
	        userId: taskAssigneeId,
	        userName: taskAssigneeFullName,
	        toDoTaskData: toDoTaskData
	      })
	    )
	  );
	};
	
	CompletedInsuranceToDoTaskPopup.propTypes = {
	  onClose: _propTypes2.default.func,
	  task: _propTypes2.default.object,
	  taskId: _propTypes2.default.number,
	  userId: _propTypes2.default.number
	};
	
	exports.default = CompletedInsuranceToDoTaskPopup;

/***/ }),
/* 3319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _PopupWrapper = __webpack_require__(1747);
	
	var _PopupWrapper2 = _interopRequireDefault(_PopupWrapper);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _DescriptionSection = __webpack_require__(1746);
	
	var _DescriptionSection2 = _interopRequireDefault(_DescriptionSection);
	
	var _InsuranceForm = __webpack_require__(615);
	
	var _InsuranceForm2 = _interopRequireDefault(_InsuranceForm);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _useFetchToDoTaskInsurancesData = __webpack_require__(1748);
	
	var _useFetchToDoTaskInsurancesData2 = _interopRequireDefault(_useFetchToDoTaskInsurancesData);
	
	var _index = __webpack_require__(4970);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FLOW_TYPE = _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO;
	
	var InsuranceToDoTaskInProgressPopup = function InsuranceToDoTaskInProgressPopup(_ref) {
	  var task = _ref.task,
	      taskId = _ref.taskId,
	      onClose = _ref.onClose,
	      userId = _ref.userId;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _ref2 = task || {},
	      todoTask = _ref2.todoTask,
	      taskAssigneeId = _ref2.taskAssigneeId,
	      hasAdditionalPatientInsurances = _ref2.hasAdditionalPatientInsurances,
	      patientInsurance = _ref2.patientInsurance;
	
	  var _ref3 = todoTask || {},
	      allowToCompleteWithoutFileUpload = _ref3.allowToCompleteWithoutFileUpload,
	      description = _ref3.description,
	      links = _ref3.links;
	
	  var _useFetchToDoTaskInsu = (0, _useFetchToDoTaskInsurancesData2.default)({
	    userId: userId,
	    hasAdditionalPatientInsurances: hasAdditionalPatientInsurances,
	    todoTaskAssignmentId: taskId,
	    isCompleted: false
	  }),
	      isInsuranceRelatedDataFetching = _useFetchToDoTaskInsu.isInsuranceRelatedDataFetching;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _PopupWrapper2.default,
	      {
	        handleClose: onClose,
	        taskId: taskId,
	        task: task,
	        title: formatMessage({ id: 'task.upcoming' })
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.content },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.descriptionSection },
	          _react2.default.createElement(_DescriptionSection2.default, { description: description, links: links })
	        ),
	        isInsuranceRelatedDataFetching ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(_InsuranceForm2.default, {
	          cancel: onClose,
	          flowType: FLOW_TYPE,
	          insuranceData: patientInsurance,
	          taskAssignmentId: taskId,
	          userId: taskAssigneeId,
	          withSelfPayEnding: true,
	          allowToCompleteWithoutFileUpload: allowToCompleteWithoutFileUpload
	        })
	      )
	    )
	  );
	};
	
	InsuranceToDoTaskInProgressPopup.propTypes = {
	  onClose: _propTypes2.default.func,
	  task: _propTypes2.default.object,
	  taskId: _propTypes2.default.number,
	  userId: _propTypes2.default.number
	};
	
	exports.default = InsuranceToDoTaskInProgressPopup;

/***/ }),
/* 3320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CompletedInsuranceToDoTaskPopup = __webpack_require__(3318);
	
	var _CompletedInsuranceToDoTaskPopup2 = _interopRequireDefault(_CompletedInsuranceToDoTaskPopup);
	
	var _InsuranceToDoTaskInProgressPopup = __webpack_require__(3319);
	
	var _InsuranceToDoTaskInProgressPopup2 = _interopRequireDefault(_InsuranceToDoTaskInProgressPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InsuranceToDoTaskPopup = function InsuranceToDoTaskPopup(_ref) {
	  var isCompleted = _ref.isCompleted,
	      rest = (0, _objectWithoutProperties3.default)(_ref, ['isCompleted']);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    isCompleted ? _react2.default.createElement(_CompletedInsuranceToDoTaskPopup2.default, rest) : _react2.default.createElement(_InsuranceToDoTaskInProgressPopup2.default, rest)
	  );
	};
	
	InsuranceToDoTaskPopup.propTypes = {
	  task: _propTypes2.default.object,
	  taskId: _propTypes2.default.number,
	  onClose: _propTypes2.default.func,
	  formatMessage: _propTypes2.default.func,
	  isCompleted: _propTypes2.default.bool
	};
	
	exports.default = InsuranceToDoTaskPopup;

/***/ }),
/* 3321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _acceptInviteToFamilyCircle = __webpack_require__(408);
	
	var _declineInviteToFamilyCircle = __webpack_require__(411);
	
	var _acceptCaregiverRole = __webpack_require__(407);
	
	var _declineCaregiverRole = __webpack_require__(410);
	
	var _acceptGuardianRole = __webpack_require__(406);
	
	var _declineGuardianRole = __webpack_require__(409);
	
	var _selectors = __webpack_require__(237);
	
	var _selectors2 = __webpack_require__(64);
	
	var _selectors3 = __webpack_require__(23);
	
	var _constants = __webpack_require__(17);
	
	var _strings = __webpack_require__(15);
	
	var _utils = __webpack_require__(254);
	
	var _styles = __webpack_require__(4972);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    sendingCaregiverInvite: (0, _selectors.selectCaregiverInvitationPending)(state),
	    sendingGuardianInvite: (0, _selectors.selectGuardianInvitationPending)(state),
	    sendingFamilyMemberInvite: (0, _selectors.selectFamilyInvitationPending)(state),
	    scheduleTasks: (0, _selectors2.selectScheduledTasks)(state),
	    loggedUser: (0, _selectors3.loggedUserSelector)(state)
	  };
	};
	var mapDispatchToProps = {
	  acceptFamilyMemberInvite: _acceptInviteToFamilyCircle.actions.send,
	  declineFamilyMemberInvite: _declineInviteToFamilyCircle.actions.send,
	  acceptCaregiverInvite: _acceptCaregiverRole.actions.send,
	  declineCaregiverInvite: _declineCaregiverRole.actions.send,
	  acceptGuardianInvite: _acceptGuardianRole.actions.send,
	  declineGuardianInvite: _declineGuardianRole.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var scheduleTasks = _ref.scheduleTasks,
	      invitationId = _ref.invitationId;
	  return {
	    invitation: scheduleTasks.filter(function (_ref2) {
	      var type = _ref2.type;
	      return type === _constants.TODO_TYPES.INVITATION;
	    }).map(function (_ref3) {
	      var payload = _ref3.payload;
	      return payload;
	    }).find(function (_ref4) {
	      var id = _ref4.id;
	      return id === invitationId;
	    })
	  };
	}), (0, _recompose.withProps)(function (_ref5) {
	  var acceptFamilyMemberInvite = _ref5.acceptFamilyMemberInvite,
	      declineFamilyMemberInvite = _ref5.declineFamilyMemberInvite,
	      declineCaregiverInvite = _ref5.declineCaregiverInvite,
	      acceptCaregiverInvite = _ref5.acceptCaregiverInvite,
	      acceptGuardianInvite = _ref5.acceptGuardianInvite,
	      declineGuardianInvite = _ref5.declineGuardianInvite,
	      sendingCaregiverInvite = _ref5.sendingCaregiverInvite,
	      sendingGuardianInvite = _ref5.sendingGuardianInvite,
	      sendingFamilyMemberInvite = _ref5.sendingFamilyMemberInvite,
	      formatMessage = _ref5.intl.formatMessage,
	      invitation = _ref5.invitation;
	  return {
	    getOptions: function getOptions() {
	      var name = (0, _utils.getFullName)((0, _get2.default)(invitation, 'targetUser'));
	
	      switch ((0, _get2.default)(invitation, 'type')) {
	        case _constants.INVITATION_TYPES.FAMILY_MEMBER:
	          return {
	            renderInfo: function renderInfo() {
	              return formatMessage(_strings.INVITE_TEXT.family);
	            },
	            pending: sendingFamilyMemberInvite,
	            accept: acceptFamilyMemberInvite,
	            decline: declineFamilyMemberInvite
	          };
	
	        case _constants.INVITATION_TYPES.CAREGIVER:
	          return {
	            renderInfo: function renderInfo() {
	              return formatMessage(_strings.INVITE_TEXT.caregiver, {
	                patient: name
	              });
	            },
	            pending: sendingCaregiverInvite,
	            accept: acceptCaregiverInvite,
	            decline: declineCaregiverInvite
	          };
	        case _constants.INVITATION_TYPES.GUARDIAN_PROXY:
	          return {
	            renderInfo: function renderInfo() {
	              return formatMessage(_strings.INVITE_TEXT.guardian, { patient: name });
	            },
	            pending: sendingGuardianInvite,
	            accept: acceptGuardianInvite,
	            decline: declineGuardianInvite
	          };
	
	        default:
	          return {
	            renderInfo: function renderInfo() {},
	            accept: function accept() {},
	            decline: function decline() {},
	            pending: false
	          };
	      }
	    }
	  };
	}), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _TermsAndConditions = __webpack_require__(781);
	
	var _TermsAndConditions2 = _interopRequireDefault(_TermsAndConditions);
	
	var _InvitationListItem = __webpack_require__(1749);
	
	var _InvitationListItem2 = _interopRequireDefault(_InvitationListItem);
	
	var _utils = __webpack_require__(254);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Shape = __webpack_require__(141);
	
	var _Shape2 = _interopRequireDefault(_Shape);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3321);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InvitationDetailsPopup(_ref) {
	  var onClose = _ref.onClose,
	      invitation = _ref.invitation,
	      getOptions = _ref.getOptions,
	      loggedUser = _ref.loggedUser,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      valid = _useState2[0],
	      setValidity = _useState2[1];
	
	  var title = formatMessage({ id: 'healthboard.invitations.modal.title' });
	  var country = (0, _get2.default)(loggedUser, 'country');
	  var inviteId = (0, _get2.default)(invitation, 'id');
	  var name = (0, _utils.getFullName)((0, _get2.default)(invitation, 'targetUser'));
	
	  var _getOptions = getOptions(),
	      renderInfo = _getOptions.renderInfo,
	      accept = _getOptions.accept,
	      decline = _getOptions.decline,
	      pending = _getOptions.pending;
	
	  var handleAccept = function handleAccept() {
	    return accept({ termsAndConditionsAccepted: true, id: inviteId });
	  };
	
	  var handleDecline = function handleDecline() {
	    return decline({ id: inviteId });
	  };
	
	  (0, _react.useEffect)(function () {
	    if (!invitation) {
	      setValidity(false);
	    }
	  }, [invitation]);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: Boolean(invitation),
	      onClose: onClose,
	      title: title,
	      width: 'auto',
	      autoHeight: true
	    },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'root' },
	      _react2.default.createElement(_InvitationListItem2.default, {
	        styleName: 'header',
	        formatMessage: formatMessage,
	        invitation: invitation
	      }),
	      _react2.default.createElement(
	        _Shape2.default,
	        { styleName: (0, _classnames2.default)('content', { pending: pending }) },
	        pending && _react2.default.createElement(_Loader2.default, { styleName: 'loader' }),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'details' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'info' },
	            _react2.default.createElement(
	              'span',
	              { styleName: 'invitator' },
	              name
	            ),
	            renderInfo()
	          ),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'terms' },
	            _react2.default.createElement(_TermsAndConditions2.default, {
	              onSelect: function onSelect(checked) {
	                return setValidity(checked);
	              },
	              country: country,
	              hasSeparator: true,
	              acceptable: true
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                onClick: handleAccept,
	                disabled: !valid,
	                color: 'primary',
	                className: 'mr3',
	                raised: true
	              },
	              formatMessage({ id: 'common.accept' })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { color: 'accent', raised: true, onClick: handleDecline },
	              formatMessage({ id: 'common.decline' })
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	InvitationDetailsPopup.propTypes = {
	  onClose: PropTypes.func,
	  getOptions: PropTypes.func,
	  invitation: PropTypes.object,
	  loggedUser: PropTypes.object,
	  intl: PropTypes.object
	};
	
	exports.default = (0, _enhance.enhance)(InvitationDetailsPopup);

/***/ }),
/* 3323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _styles = __webpack_require__(4975);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NameWithAvatar(_ref) {
	  var avatar = _ref.avatar,
	      name = _ref.name,
	      avatarSize = _ref.avatarSize,
	      metaText = _ref.metaText,
	      noAvatar = _ref.noAvatar,
	      whiteAvatar = _ref.whiteAvatar,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_styles2.default.root, className) },
	    !noAvatar && _react2.default.createElement(_SimpleAvatar2.default, {
	      src: (0, _get2.default)(avatar, 'thumbMin'),
	      text: name,
	      size: avatarSize,
	      white: whiteAvatar,
	      bordered: true
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_styles2.default.name, (0, _defineProperty3.default)({}, _styles2.default.noAvatar, noAvatar)) },
	      _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)(_styles2.default.strong, (0, _defineProperty3.default)({}, _styles2.default.noMeta, !metaText)) },
	        name
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: _styles2.default.meta },
	        metaText
	      )
	    )
	  );
	}
	
	NameWithAvatar.propTypes = {
	  avatar: PropTypes.object,
	  name: PropTypes.string,
	  className: PropTypes.string,
	  avatarSize: PropTypes.number,
	  metaText: PropTypes.node,
	  whiteAvatar: PropTypes.bool,
	  noAvatar: PropTypes.bool
	};
	
	NameWithAvatar.defaultProps = {
	  avatarSize: 68,
	  noAvatar: false
	};
	
	exports.default = NameWithAvatar;

/***/ }),
/* 3324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _PaymentAccountFormLoader = __webpack_require__(1189);
	
	var _PaymentAccountFormLoader2 = _interopRequireDefault(_PaymentAccountFormLoader);
	
	var _styles = __webpack_require__(4976);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _selectors = __webpack_require__(264);
	
	var _paymentInfoModal = __webpack_require__(541);
	
	var _injectSaga = __webpack_require__(116);
	
	var _payaAccountFormSaga = __webpack_require__(4105);
	
	var _payaAccountFormSaga2 = _interopRequireDefault(_payaAccountFormSaga);
	
	var _sagaInjectors = __webpack_require__(137);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEADER_HEIGHT = 56;
	
	function PayaAccountForm(_ref) {
	  var onClose = _ref.onClose,
	      _ref$options$noCards = _ref.options.noCards,
	      noCards = _ref$options$noCards === undefined ? false : _ref$options$noCards;
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'payaAccountFormSaga',
	    saga: _payaAccountFormSaga2.default,
	    mode: _sagaInjectors.RESTART_ON_REMOUNT
	  });
	
	  var formLoading = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalFormLoading);
	  var payaFormUrl = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalPayaFormURL);
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      height = _useState2[0],
	      setHeight = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  var formTitle = 'program.membership.payaAccountForm.title';
	
	  var formDescription = 'profile.payment.addCardForFutureUse';
	
	  var showLoader = formLoading || loading || !payaFormUrl;
	
	  var finishLoading = function finishLoading() {
	    return setLoading(false);
	  };
	
	  var handleBack = (0, _react.useCallback)(function () {
	    if (noCards) {
	      dispatch(_paymentInfoModal.paymentInfoModalActions.close());
	    }
	    onClose();
	  }, [onClose, noCards]);
	
	  (0, _react.useEffect)(function () {
	    setHeight(window.innerHeight - HEADER_HEIGHT);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    dispatch(_paymentInfoModal.paymentInfoModalActions.clearPayaForm());
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(_BackButton2.default, {
	      onBack: handleBack,
	      className: _styles2.default.backBtn,
	      minWidth: 100
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.header },
	      _react2.default.createElement(
	        'p',
	        { className: _styles2.default.headerTitle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: formTitle })
	      ),
	      !showLoader && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.headerDescription },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: formDescription })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_styles2.default.paymentView, (0, _defineProperty3.default)({}, _styles2.default.paymentViewLoading, loading))
	      },
	      showLoader && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.loader },
	        _react2.default.createElement(_PaymentAccountFormLoader2.default, null)
	      ),
	      payaFormUrl && _react2.default.createElement('iframe', {
	        title: 'paya-form-url',
	        src: payaFormUrl,
	        height: height,
	        onLoad: finishLoading
	      })
	    )
	  );
	}
	
	PayaAccountForm.propTypes = {
	  onClose: PropTypes.func,
	  options: PropTypes.shape({
	    noCards: PropTypes.bool
	  })
	};
	
	exports.default = PayaAccountForm;

/***/ }),
/* 3325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _payaPaymentSaga = __webpack_require__(1888);
	
	var _payaPaymentSaga2 = _interopRequireDefault(_payaPaymentSaga);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _injectSaga = __webpack_require__(116);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _styles = __webpack_require__(4977);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEADER_HEIGHT = 56;
	
	function PayaPayment(_ref) {
	  var url = _ref.options.url,
	      onClose = _ref.onClose;
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'payaPaymentSaga',
	    saga: _payaPaymentSaga2.default,
	    mode: _sagaInjectors.RESTART_ON_REMOUNT
	  });
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      height = _useState2[0],
	      setHeight = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  var finishLoading = function finishLoading() {
	    return setLoading(false);
	  };
	
	  (0, _react.useEffect)(function () {
	    setHeight(window.innerHeight - HEADER_HEIGHT);
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(_BackButton2.default, { onBack: onClose, styleName: 'back-btn', minWidth: 100 }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'header' },
	      _react2.default.createElement(
	        'p',
	        { styleName: 'header--title' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appointment.payment.title' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('payment-view', { loading: loading }) },
	      loading && _react2.default.createElement(_Loader2.default, null),
	      _react2.default.createElement('iframe', {
	        src: url,
	        height: height,
	        onLoad: finishLoading,
	        title: 'account-form'
	      })
	    )
	  );
	}
	
	PayaPayment.propTypes = {
	  onClose: PropTypes.func,
	  options: PropTypes.shape({
	    url: PropTypes.string
	  })
	};
	
	exports.default = (0, _reactCssModules2.default)(PayaPayment, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styles = __webpack_require__(4978);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PayaPaymentHandleResponse(_ref) {
	  var onClose = _ref.onClose,
	      _ref$options = _ref.options,
	      errorMessage = _ref$options.errorMessage,
	      formatMessage = _ref$options.formatMessage,
	      programName = _ref$options.programName,
	      success = _ref$options.success,
	      dependentName = _ref$options.dependentName;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.title },
	      !success && (errorMessage || formatMessage({ id: 'appointment.payment.errorTitle' })),
	      success && formatMessage({ id: 'appointment.payment.successMessage' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.staticMessage },
	      success ? formatMessage({
	        id: dependentName ? 'program.membership.payaResponse.dependent.success' : 'program.membership.payaResponse.success'
	      }, { programName: programName, dependentName: dependentName }) : formatMessage({ id: 'program.membership.payaResponse.static' })
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        raised: true,
	        color: 'primary',
	        onClick: onClose,
	        className: _styles2.default.button
	      },
	      formatMessage({ id: 'auth.errors.gotIt' })
	    )
	  );
	}
	
	PayaPaymentHandleResponse.propTypes = {
	  onClose: PropTypes.func,
	  options: PropTypes.shape({
	    errorMessage: PropTypes.string,
	    formatMessage: PropTypes.func,
	    programName: PropTypes.string,
	    dependentName: PropTypes.string,
	    success: PropTypes.bool
	  })
	};
	
	exports.default = PayaPaymentHandleResponse;

/***/ }),
/* 3327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.amountFieldProps = undefined;
	
	var _validations = __webpack_require__(81);
	
	var _amountValidator = __webpack_require__(911);
	
	var _amountValidator2 = _interopRequireDefault(_amountValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var amountFieldProps = exports.amountFieldProps = function amountFieldProps(formatMessage) {
	  return {
	    className: 'mt1',
	    type: 'text',
	    inputMode: 'decimal',
	    limit: _validations.LENGTH_VALUES.COPAY.MAX,
	    placeholder: formatMessage({
	      id: 'virtualVisit.details.paymentAmount'
	    }),
	    errorText: formatMessage({ id: 'errors.appointment.copay' }),
	    validationRule: _amountValidator2.default
	  };
	};

/***/ }),
/* 3328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.usePaymentAmountData = usePaymentAmountData;
	
	var _react = __webpack_require__(1);
	
	var _formatAmount = __webpack_require__(434);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function usePaymentAmountData(formatMessage, value) {
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      editMode = _useState2[0],
	      setEditMode = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      errorState = _useState4[0],
	      setError = _useState4[1];
	
	  var safeValue = value ? (0, _formatAmount.formatAmount)(value) : (0, _formatAmount.formatAmount)(0);
	
	  var _useState5 = (0, _react.useState)(safeValue),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      currentValue = _useState6[0],
	      setCurrentValue = _useState6[1];
	
	  var isPristine = currentValue === safeValue;
	
	  var handleCopayChange = function handleCopayChange(amountValue, err) {
	    setError(err);
	    setCurrentValue(amountValue);
	  };
	
	  var handleToInitialState = function handleToInitialState() {
	    setCurrentValue(safeValue);
	    setEditMode(false);
	  };
	
	  var handleToggleEditState = function handleToggleEditState() {
	    setEditMode(!editMode);
	    setCurrentValue(safeValue);
	  };
	
	  return (0, _react.useMemo)(function () {
	    return {
	      editMode: editMode,
	      errorState: errorState,
	      handleCopayChange: handleCopayChange,
	      handleToInitialState: handleToInitialState,
	      handleToggleEditState: handleToggleEditState,
	      safeValue: safeValue,
	      isPristine: isPristine,
	      currentValue: currentValue
	    };
	  }, [editMode, errorState, handleCopayChange, handleToInitialState, handleToggleEditState, safeValue, isPristine, currentValue]);
	}

/***/ }),
/* 3329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _ShowMore = __webpack_require__(1844);
	
	var _ShowMore2 = _interopRequireDefault(_ShowMore);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _ExpandableListItem = __webpack_require__(285);
	
	var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);
	
	var _hooks = __webpack_require__(1164);
	
	var _ProgramSubscription = __webpack_require__(1796);
	
	var _ProgramSubscription2 = _interopRequireDefault(_ProgramSubscription);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(64);
	
	var _useProgramSubscription = __webpack_require__(1859);
	
	var _useProgramSubscription2 = _interopRequireDefault(_useProgramSubscription);
	
	var _acceptInvitation = __webpack_require__(687);
	
	var _declineInvitation = __webpack_require__(689);
	
	var _styles = __webpack_require__(4980);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProgramDetailsPopup(_ref) {
	  var item = _ref.item,
	      opened = _ref.opened,
	      onClose = _ref.onClose,
	      formatMessage = _ref.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var todos = (0, _reactRedux.useSelector)(_selectors2.selectScheduledTasks);
	  var userId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	
	  var _item = (0, _extends3.default)({}, item),
	      program = _item.program,
	      itemId = _item.itemId;
	
	  var _program = (0, _extends3.default)({}, program),
	      id = _program.id,
	      name = _program.name,
	      _program$logo = _program.logo,
	      logo = _program$logo === undefined ? {} : _program$logo,
	      description = _program.description,
	      withSubscription = _program.withSubscription,
	      organization = _program.organizationName,
	      organizationId = _program.organization.id;
	
	  var _useProgramSubscripti = (0, _useProgramSubscription2.default)({ program: program }),
	      handleChangeMembershipDuration = _useProgramSubscripti.handleChangeMembershipDuration,
	      isSubscriptionStatusPending = _useProgramSubscripti.isSubscriptionStatusPending,
	      moreThanOneSubscriptionOption = _useProgramSubscripti.moreThanOneSubscriptionOption,
	      prepaidByProvider = _useProgramSubscripti.prepaidByProvider,
	      selectedMembershipId = _useProgramSubscripti.selectedMembershipId,
	      subscriptionsSetting = _useProgramSubscripti.subscriptionsSetting;
	
	  var payload = {
	    userId: userId,
	    organizationId: organizationId,
	    todoId: itemId,
	    withSubscription: withSubscription,
	    programName: name,
	    prepaidByProvider: prepaidByProvider,
	    subscriptionsSetting: subscriptionsSetting,
	    programId: program.id,
	    invitationId: item.id
	  };
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return (0, _get2.default)(todos.find(function (_ref2) {
	      var entityId = _ref2.id;
	      return entityId === itemId;
	    }), 'payload', {});
	  }, [todos]),
	      _useMemo$consents = _useMemo.consents,
	      consents = _useMemo$consents === undefined ? [] : _useMemo$consents;
	
	  var _useProgramConsents = (0, _hooks.useProgramConsents)({
	    program: program,
	    consents: consents,
	    formatMessage: formatMessage,
	    todo: { itemId: itemId }
	  }),
	      list = _useProgramConsents.list,
	      proxify = _useProgramConsents.proxify;
	
	  var title = formatMessage({ id: 'program.invite.title' }, { name: name });
	
	  var icon = (0, _react.useMemo)(function () {
	    return logo.thumbMin && _react2.default.createElement(_SimpleAvatar2.default, {
	      size: 32,
	      text: name,
	      className: 'mr2',
	      src: logo.thumbMin
	    });
	  }, [logo]);
	
	  var subtitle = (0, _react.useMemo)(function () {
	    return [formatMessage({ id: 'healthboard.program.card.type' }), organization].join(', ');
	  }, [organization]);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: opened,
	      onClose: onClose,
	      width: (0, _mobileHelpers.isDesktop)() ? 'small' : 'medium',
	      title: formatMessage({ id: 'program.invite.details.title' })
	    },
	    _react2.default.createElement(
	      _ExpandableListItem2.default,
	      {
	        locked: true,
	        key: id,
	        'data-id': id,
	        header: { subtitle: subtitle, title: title, icon: icon || 'program' }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section },
	        _react2.default.createElement(
	          'p',
	          { className: 'f-12' },
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.organization },
	            organization,
	            ' '
	          ),
	          formatMessage({ id: 'program.invite.details.titleInvite' }, { name: name })
	        )
	      ),
	      Boolean(description) ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section },
	        _react2.default.createElement(
	          'p',
	          { className: _styles2.default.title },
	          formatMessage({ id: 'program.invite.details.descriptionTitle' })
	        ),
	        _react2.default.createElement(
	          _ShowMore2.default,
	          {
	            minHeight: 12 * 3,
	            more: formatMessage({ id: 'common.readMore' }),
	            less: formatMessage({ id: 'common.collapse' })
	          },
	          _react2.default.createElement(
	            'p',
	            { className: _styles2.default.description },
	            description
	          )
	        )
	      ) : null,
	      Boolean(consents.length) ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section },
	        list
	      ) : null,
	      _react2.default.createElement(_ProgramSubscription2.default, {
	        formatMessage: formatMessage,
	        handleChangeMembershipDuration: handleChangeMembershipDuration,
	        isSubscriptionStatusPending: isSubscriptionStatusPending,
	        prepaidByProvider: prepaidByProvider,
	        program: program,
	        selectedMembershipId: selectedMembershipId,
	        subscriptionsSetting: subscriptionsSetting
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.buttonWrapper },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              color: 'primary',
	              className: _styles2.default.button,
	              disabled: moreThanOneSubscriptionOption && !selectedMembershipId,
	              onClick: proxify(function () {
	                dispatch(_acceptInvitation.actions.init(payload));
	              })
	            },
	            formatMessage({
	              id: withSubscription && !prepaidByProvider ? 'program.membership.pay' : 'common.join'
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              color: 'accent',
	              className: _styles2.default.button,
	              onClick: function onClick() {
	                dispatch(_declineInvitation.actions.init(payload));
	              }
	            },
	            formatMessage({ id: 'common.decline' })
	          )
	        )
	      )
	    )
	  );
	}
	
	ProgramDetailsPopup.propTypes = {
	  item: _propTypes2.default.object,
	  opened: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = ProgramDetailsPopup;

/***/ }),
/* 3330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _styles = __webpack_require__(4981);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ProgramListItem(_ref) {
	  var entity = _ref.entity,
	      formatMessage = _ref.formatMessage,
	      onClick = _ref.onClick;
	
	  var _entity$program = (0, _extends3.default)({}, entity.program),
	      name = _entity$program.name,
	      _entity$program$logo = _entity$program.logo,
	      logo = _entity$program$logo === undefined ? {} : _entity$program$logo,
	      organizationName = _entity$program.organizationName;
	
	  var subTitle = (0, _react.useMemo)(function () {
	    return [formatMessage({ id: 'healthboard.program.card.type' }), organizationName].join(', ');
	  }, [organizationName]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root, onClick: onClick },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.left },
	      logo.thumbMin ? _react2.default.createElement(_SimpleAvatar2.default, { src: logo.thumbMin, text: name, size: 32 }) : _react2.default.createElement(_Icon2.default, { name: 'program', size: 32 })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.right },
	      _react2.default.createElement(
	        'p',
	        { className: _styles2.default.meta },
	        subTitle
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _styles2.default.strong },
	        formatMessage({ id: 'program.invite.title' }, { name: name })
	      )
	    )
	  );
	}
	
	ProgramListItem.propTypes = {
	  onClick: PropTypes.func,
	  entity: PropTypes.object,
	  className: PropTypes.string,
	  formatMessage: PropTypes.func
	};
	
	exports.default = ProgramListItem;

/***/ }),
/* 3331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _getParentProvider = __webpack_require__(680);
	
	var _selectors = __webpack_require__(56);
	
	var _selectors2 = __webpack_require__(23);
	
	var _routes = __webpack_require__(37);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styles = __webpack_require__(4982);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ScheduleButton(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      userId = _ref.userId;
	
	  var hasAccess = (0, _reactRedux.useSelector)(_selectors.selectProviderCalendarManageAccess);
	  var providerId = (0, _reactRedux.useSelector)(_selectors2.selectTargetProviderId);
	  var dispatch = (0, _reactRedux.useDispatch)();
	  (0, _react.useEffect)(function () {
	    dispatch(_getParentProvider.actions.send({ id: userId }));
	  }, [userId]);
	
	  var redirectToCalendar = function redirectToCalendar() {
	    var url = _routes.PROVIDER_CALENDAR.replace(':id', userId).replace(':providerId', providerId);
	    _browserHistory2.default.push(url);
	  };
	
	  if (!hasAccess) return null;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: _styles2.default.button,
	        raised: true,
	        color: 'primary',
	        onClick: redirectToCalendar
	      },
	      formatMessage({ id: 'calendar.manageSchedule' })
	    )
	  );
	}
	
	ScheduleButton.propTypes = {
	  intl: PropTypes.object,
	  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	
	exports.default = (0, _reactIntl.injectIntl)(ScheduleButton);

/***/ }),
/* 3332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _completeTaskReq = __webpack_require__(665);
	
	var completeTask = _interopRequireWildcard(_completeTaskReq);
	
	var _completeTaskCustomReq = __webpack_require__(853);
	
	var completeTaskCustom = _interopRequireWildcard(_completeTaskCustomReq);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    pending: (0, _selectors2.selectCompleteTaskPending)(state),
	    succeed: (0, _selectors2.selectCompleteTaskSucceed)(state),
	    error: (0, _selectors2.selectCompleteTaskError)(state),
	    userId: (0, _selectors.targetUserIdSelector)(state),
	    custom: {
	      pending: (0, _selectors2.selectCompleteTaskCustomPending)(state),
	      succeed: (0, _selectors2.selectCompleteTaskCustomSucceed)(state),
	      error: (0, _selectors2.selectCompleteTaskCustomError)(state)
	    }
	  };
	};
	var mapDispatchToProps = {
	  completeCustom: completeTaskCustom.actions.start,
	  clearCustom: completeTaskCustom.actions.clear,
	  complete: completeTask.actions.start,
	  clear: completeTask.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getToDoAssigmentText = __webpack_require__(1386);
	
	var _getToDoAssigmentText2 = _interopRequireDefault(_getToDoAssigmentText);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _errors = __webpack_require__(120);
	
	var _handleTaskTime = __webpack_require__(608);
	
	var _SingleSelect = __webpack_require__(257);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _constants = __webpack_require__(17);
	
	var _InfoCardPopup = __webpack_require__(1764);
	
	var _InfoCardPopup2 = _interopRequireDefault(_InfoCardPopup);
	
	var _GoogleMaps = __webpack_require__(765);
	
	var _GoogleMaps2 = _interopRequireDefault(_GoogleMaps);
	
	var _TaskDocuments = __webpack_require__(1752);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _utils = __webpack_require__(254);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3332);
	
	var _styles = __webpack_require__(4983);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TASK_ATTACHMENT_LIMIT = 5;
	var TASK_CUSTOM = _constants.TODO_TYPES.TASK_CUSTOM;
	
	
	function TaskDetailsPopup(_ref) {
	  var task = _ref.task,
	      clear = _ref.clear,
	      error = _ref.error,
	      taskId = _ref.taskId,
	      custom = _ref.custom,
	      userId = _ref.userId,
	      onClose = _ref.onClose,
	      succeed = _ref.succeed,
	      pending = _ref.pending,
	      complete = _ref.complete,
	      clearCustom = _ref.clearCustom,
	      completeCustom = _ref.completeCustom,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      errorText = _useState2[0],
	      setError = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      outcomeId = _useState4[0],
	      setOutcomeId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      attachments = _useState6[0],
	      setAttachment = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      isOpenLocations = _useState8[0],
	      toggleOpenLocations = _useState8[1];
	
	  var errorCustom = custom.error,
	      pendingCustom = custom.pending,
	      succeedCustom = custom.succeed;
	
	
	  (0, _react.useEffect)(function () {
	    if (succeed || succeedCustom) handleClose();
	  }, [succeed, succeedCustom]);
	
	  (0, _react.useEffect)(function () {
	    if (error || errorCustom) {
	      var isAlreadyCompleted = (0, _get2.default)(error, 'code') === _errors.ERROR_CODES.TASK_ALREADY_COMPLETED;
	      var textId = isAlreadyCompleted ? 'task.alreadyCompleted' : 'errors.common';
	      setError(formatMessage({ id: textId }));
	    }
	  }, [error, errorCustom]);
	
	  var _ref2 = task || {},
	      todoType = _ref2.todoType,
	      todoTask = _ref2.todoTask,
	      expiredTime = _ref2.expiredTime,
	      todoStatus = _ref2.todoStatus,
	      taskAssignmentId = _ref2.taskAssignmentId,
	      completedTime = _ref2.completedTime,
	      taskOutcomes = _ref2.taskOutcomes,
	      chosenOutcome = _ref2.chosenOutcome,
	      outcomeAttachments = _ref2.outcomeAttachments;
	
	  var _ref3 = todoTask || {},
	      name = _ref3.name,
	      description = _ref3.description,
	      links = _ref3.links,
	      geolocationsPresent = _ref3.geolocationsPresent,
	      dueDescription = _ref3.dueDescription;
	
	  var completed = (0, _react.useMemo)(function () {
	    return (0, _utils.isCompleted)(todoStatus);
	  }, [todoStatus]);
	  var hasOutcomesList = (0, _react.useMemo)(function () {
	    return !(0, _isEmpty2.default)(taskOutcomes);
	  }, [taskOutcomes]);
	
	  var outcomesList = (0, _react.useMemo)(function () {
	    return hasOutcomesList && taskOutcomes.map(function (item) {
	      return {
	        value: item.id,
	        label: item.text
	      };
	    });
	  }, [taskOutcomes]);
	
	  var popupTitle = (0, _react.useMemo)(function () {
	    var textId = completed ? 'task.completed' : 'task.upcoming';
	    return formatMessage({ id: textId });
	  }, [completed]);
	
	  var getOutcomeValue = function getOutcomeValue(selectedId, param) {
	    var outcome = hasOutcomesList && taskOutcomes.find(function (_ref4) {
	      var id = _ref4.id;
	      return id === selectedId;
	    });
	    return (0, _get2.default)(outcome, param);
	  };
	
	  var attachmentRequired = getOutcomeValue(outcomeId, 'attachmentEnabled');
	
	  var disabled = (0, _react.useMemo)(function () {
	    var noRequiredAttachment = !(0, _size2.default)(attachments) && attachmentRequired;
	
	    return hasOutcomesList && !outcomeId || pending || pendingCustom || (0, _size2.default)(attachments) > TASK_ATTACHMENT_LIMIT || noRequiredAttachment;
	  }, [attachments, attachmentRequired, hasOutcomesList, outcomeId, attachments, pending, pendingCustom]);
	
	  var handleOptionChange = (0, _react.useCallback)(function (value) {
	    setOutcomeId(value);
	  }, []);
	
	  var showDocuments = completed ? !(0, _isEmpty2.default)(outcomeAttachments) : attachmentRequired;
	
	  var completedOutcomeText = getOutcomeValue(chosenOutcome, 'text');
	
	  var handleComplete = function handleComplete() {
	    var data = {
	      status: 'completed',
	      id: taskAssignmentId,
	      userId: userId,
	      outcomeId: outcomeId,
	      attachments: attachments,
	      attachmentRequired: attachmentRequired
	    };
	
	    todoType === TASK_CUSTOM ? completeCustom(data) : complete(data);
	  };
	
	  var handleClose = function handleClose() {
	    setError(null);
	    onClose();
	    clear();
	    clearCustom();
	  };
	
	  return _react2.default.createElement(
	    _InfoCardPopup2.default,
	    {
	      title: popupTitle,
	      onClose: handleClose,
	      icon: 'assigned-task',
	      headerInfo: (0, _handleTaskTime.timeToShow)(completedTime, expiredTime, dueDescription, formatMessage),
	      headerTitle: name,
	      headerSubtitle: (0, _getToDoAssigmentText2.default)(task, formatMessage),
	      isOpened: Boolean(taskId),
	      width: (0, _mobileHelpers.isDesktop)() ? 'small' : 'medium'
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.content },
	      pending || pendingCustom ? _react2.default.createElement(_Loader2.default, { className: 'absolute-center' }) : null,
	      _react2.default.createElement(
	        'p',
	        { className: 'mb2' },
	        description
	      ),
	      !(0, _isEmpty2.default)(links) ? links.map(function (link) {
	        return _react2.default.createElement(
	          'a',
	          {
	            href: (0, _get2.default)(link, 'urlLink'),
	            target: '_blank',
	            rel: 'noopener noreferrer',
	            className: _styles2.default.link,
	            key: (0, _get2.default)(link, 'id')
	          },
	          (0, _get2.default)(link, 'urlDescription')
	        );
	      }) : null,
	      geolocationsPresent ? _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)('mt3', _styles2.default.actionButton),
	          border: true,
	          color: 'accent',
	          onClick: function onClick() {
	            return toggleOpenLocations(true);
	          }
	        },
	        formatMessage({ id: 'task.seeLocations' })
	      ) : null,
	      hasOutcomesList && !completed ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section, key: 'outcome' },
	        _react2.default.createElement(
	          'h3',
	          { className: _styles2.default.title },
	          formatMessage({ id: 'task.selectOutcome' })
	        ),
	        _react2.default.createElement(_SingleSelect2.default, {
	          name: 'outcome',
	          list: outcomesList,
	          selectClass: _styles2.default.list,
	          radioInputClass: 'mr2',
	          onChange: handleOptionChange,
	          selectedValue: outcomeId
	        })
	      ) : null,
	      Boolean(completedOutcomeText) && completed ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section, key: 'outcomeText' },
	        _react2.default.createElement(
	          'h3',
	          { className: _styles2.default.title },
	          formatMessage({ id: 'task.outcome' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          completedOutcomeText
	        )
	      ) : null,
	      showDocuments ? _react2.default.createElement(
	        'div',
	        { className: _styles2.default.section, key: 'doc' },
	        _react2.default.createElement(_TaskDocuments.TaskDocuments, {
	          disabled: (0, _size2.default)(attachments) >= TASK_ATTACHMENT_LIMIT,
	          formatMessage: formatMessage,
	          completed: completed,
	          attachments: completed ? outcomeAttachments : attachments,
	          addAttachment: setAttachment
	        })
	      ) : null,
	      errorText ? _react2.default.createElement(_ErrorBlock2.default, { className: 'mt2 mb2', errors: errorText }) : null,
	      !completed ? _react2.default.createElement(
	        _Button2.default,
	        {
	          className: (0, _classnames2.default)('mt4', _styles2.default.actionButton),
	          color: 'primary',
	          onClick: handleComplete,
	          disabled: disabled
	        },
	        formatMessage({ id: 'common.complete' })
	      ) : null
	    ),
	    _react2.default.createElement(
	      _Popup2.default,
	      {
	        strictClose: true,
	        opened: isOpenLocations,
	        onClose: function onClose() {
	          return toggleOpenLocations(false);
	        },
	        title: formatMessage({ id: 'googleMaps.popup.title' }),
	        mobileFullScreen: false,
	        overflowVisible: true,
	        withoutAdaptive: true
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.width },
	        _react2.default.createElement(_GoogleMaps2.default, null)
	      )
	    )
	  );
	}
	
	TaskDetailsPopup.propTypes = {
	  error: PropTypes.object,
	  succeed: PropTypes.bool,
	  pending: PropTypes.bool,
	  clear: PropTypes.func,
	  task: PropTypes.object,
	  taskId: PropTypes.number,
	  onClose: PropTypes.func,
	  complete: PropTypes.func,
	  intl: PropTypes.shape({
	    formatMessage: PropTypes.func
	  }),
	  userId: PropTypes.number,
	  custom: PropTypes.object,
	  clearCustom: PropTypes.func,
	  completeCustom: PropTypes.func
	};
	
	exports.default = (0, _enhance.enhance)(TaskDetailsPopup);

/***/ }),
/* 3334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(158);
	
	var _selectors2 = __webpack_require__(23);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    surveyProceeding: (0, _selectors.selectUpcomingSurveyProceedPending)(state),
	    targetUser: (0, _selectors2.targetUserSelector)(state)
	  };
	};
	var mapDispatchToProps = {};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useTodoRenderItem = useTodoRenderItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _preVisitForm = __webpack_require__(288);
	
	var _constants = __webpack_require__(17);
	
	var _getToDoAssigmentText = __webpack_require__(1386);
	
	var _getToDoAssigmentText2 = _interopRequireDefault(_getToDoAssigmentText);
	
	var _getSpecification2 = __webpack_require__(361);
	
	var _getSpecification3 = _interopRequireDefault(_getSpecification2);
	
	var _ConsentListItem = __webpack_require__(3343);
	
	var _SurveyListItem = __webpack_require__(1175);
	
	var _SurveyListItem2 = _interopRequireDefault(_SurveyListItem);
	
	var _ProgramPopup = __webpack_require__(1190);
	
	var _ProgramPopup2 = _interopRequireDefault(_ProgramPopup);
	
	var _handleTaskTime = __webpack_require__(608);
	
	var _InvitationListItem = __webpack_require__(1749);
	
	var _InvitationListItem2 = _interopRequireDefault(_InvitationListItem);
	
	var _CardIcon = __webpack_require__(1821);
	
	var _CardIcon2 = _interopRequireDefault(_CardIcon);
	
	var _ProgramListItem = __webpack_require__(3330);
	
	var _ProgramListItem2 = _interopRequireDefault(_ProgramListItem);
	
	var _utils = __webpack_require__(254);
	
	var _ElectronicConsentListItem = __webpack_require__(3345);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useTodoRenderItem(formatMessage, setActiveItem) {
	  var renderSurvey = (0, _react.useCallback)(function (item) {
	    var _getSpecification = (0, _getSpecification3.default)(item, formatMessage),
	        description = _getSpecification.description,
	        name = _getSpecification.name,
	        status = _getSpecification.status,
	        heading = _getSpecification.heading,
	        date = _getSpecification.date;
	
	    var hidden = (0, _get2.default)(item, 'hidden');
	    var itemAssignmentId = (0, _get2.default)(item, 'assignmentId');
	    var userAppointment = (0, _get2.default)(item, 'userAppointment');
	    var list = (0, _preVisitForm.convertPreVisitFormData)(formatMessage, userAppointment);
	    var completed = (0, _utils.isCompleted)((0, _get2.default)(item, 'todoStatus'));
	
	    var renderSurveyItem = hidden ? null : _react2.default.createElement(_SurveyListItem2.default, {
	      key: itemAssignmentId,
	      heading: heading,
	      title: name,
	      status: !completed ? status : null,
	      description: description,
	      onClick: function onClick() {
	        return !completed ? setActiveItem(item) : null;
	      },
	      list: list,
	      date: date
	    });
	
	    return completed ? _react2.default.createElement(
	      _ProgramPopup2.default,
	      {
	        date: (0, _get2.default)(item, 'completedAt'),
	        program: (0, _get2.default)(item, 'program'),
	        openedAssignmentId: itemAssignmentId,
	        openedSurveyId: (0, _get2.default)(item, 'survey.id'),
	        activeChannelId: _constants.APPOINTMENT_CHANNEL_ID,
	        forceFetch: true,
	        pdfExportable: true
	      },
	      renderSurveyItem
	    ) : renderSurveyItem;
	  }, []);
	
	  var renderCarePlan = (0, _react.useCallback)(function (item) {
	    var id = item.id,
	        name = item.name,
	        expiredTime = item.expiredTime,
	        dueDescription = item.dueDescription,
	        completedTime = item.completedTime,
	        displayableName = item.assigner.displayableName;
	
	    var subtitle = formatMessage({ id: 'carePlan.assignedBy.provider' }, { displayableName: displayableName });
	
	    return _react2.default.createElement(_CardIcon2.default, {
	      key: id,
	      icon: 'assigned-task',
	      title: name,
	      subtitle: subtitle,
	      onClick: function onClick() {
	        return setActiveItem(item);
	      },
	      withBg: true,
	      info: (0, _handleTaskTime.timeToShow)(completedTime, expiredTime, dueDescription, formatMessage)
	    });
	  }, []);
	
	  var renderInvitation = (0, _react.useCallback)(function (item) {
	    return _react2.default.createElement(_InvitationListItem2.default, {
	      formatMessage: formatMessage,
	      invitation: item,
	      onClick: function onClick() {
	        return setActiveItem(item);
	      }
	    });
	  }, []);
	
	  var renderConsent = (0, _react.useCallback)(function (item) {
	    var todoStatus = item.todoStatus;
	
	
	    return _react2.default.createElement(_ConsentListItem.ConsentListItem, {
	      formatMessage: formatMessage,
	      entity: item,
	      onClick: (0, _utils.isCompleted)(todoStatus) ? function () {
	        return setActiveItem(item);
	      } : null
	    });
	  }, []);
	
	  var renderTask = (0, _react.useCallback)(function (item) {
	    var todoTask = (0, _get2.default)(item, 'todoTask');
	
	    var _ref = todoTask || item,
	        name = _ref.name,
	        dueDescription = _ref.dueDescription;
	
	    var expiredTime = item.expiredTime,
	        completedTime = item.completedTime;
	
	
	    return _react2.default.createElement(_CardIcon2.default, {
	      icon: 'assigned-task',
	      title: name,
	      subtitle: (0, _getToDoAssigmentText2.default)(item, formatMessage),
	      onClick: function onClick() {
	        return setActiveItem(item);
	      },
	      withBg: true,
	      info: (0, _handleTaskTime.timeToShow)(completedTime, expiredTime, dueDescription, formatMessage)
	    });
	  }, []);
	
	  var renderProgram = (0, _react.useCallback)(function (item) {
	    return _react2.default.createElement(_ProgramListItem2.default, {
	      entity: item,
	      formatMessage: formatMessage,
	      onClick: function onClick() {
	        return setActiveItem(item);
	      }
	    });
	  }, []);
	
	  var renderConsentUserAssignment = (0, _react.useCallback)(function (item) {
	    return _react2.default.createElement(_ElectronicConsentListItem.ElectronicConsentListItem, {
	      formatMessage: formatMessage,
	      entity: item,
	      onClick: function onClick() {
	        return setActiveItem(item);
	      }
	    });
	  }, []);
	
	  var getRenderByType = (0, _react.useCallback)(function (type) {
	    switch (type) {
	      case _constants.TODO_TYPES.INVITATION:
	        return renderInvitation;
	      case _constants.TODO_TYPES.SURVEY:
	        return renderSurvey;
	      case _constants.TODO_TYPES.CARE_PLAN_TASK:
	        return renderCarePlan;
	      case _constants.TODO_TYPES.CONSENT:
	        return renderConsent;
	      case _constants.TODO_TYPES.TASK:
	      case _constants.TODO_TYPES.TASK_CUSTOM:
	        return renderTask;
	      case _constants.TODO_TYPES.PROGRAM:
	        return renderProgram;
	      case _constants.TODO_TYPES.CONSENT_USER_ASSIGNMENT:
	        return renderConsentUserAssignment;
	      default:
	        return function () {};
	    }
	  }, []);
	
	  return {
	    getRenderByType: getRenderByType
	  };
	}

/***/ }),
/* 3336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConsentDetailsMainView = ConsentDetailsMainView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SingConsentButton = __webpack_require__(492);
	
	var _SingConsentButton2 = _interopRequireDefault(_SingConsentButton);
	
	var _renderConsentHeader = __webpack_require__(1128);
	
	var _index = __webpack_require__(721);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConsentDetailsMainView(_ref) {
	  var buttonAccept = _ref.buttonAccept,
	      buttonDecline = _ref.buttonDecline,
	      consentOutcomeTitles = _ref.consentOutcomeTitles,
	      convertedTime = _ref.convertedTime,
	      createMarkup = _ref.createMarkup,
	      formatMessage = _ref.formatMessage,
	      handleAcceptConsent = _ref.handleAcceptConsent,
	      handleClosePopup = _ref.handleClosePopup,
	      isConsentHasMultipleOutcomes = _ref.isConsentHasMultipleOutcomes,
	      isSignConsentLoading = _ref.isSignConsentLoading,
	      name = _ref.name,
	      organizationName = _ref.organizationName,
	      serviceName = _ref.serviceName,
	      titleTypeConsent = _ref.titleTypeConsent;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      (0, _renderConsentHeader.renderConsentHeader)(formatMessage, titleTypeConsent, organizationName, serviceName, convertedTime, true, name)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.mainConsentContent },
	      _react2.default.createElement('div', { className: _index2.default.text, dangerouslySetInnerHTML: createMarkup() }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.mainConsentBtnWrapper },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: _index2.default.declineButton,
	            onClick: handleClosePopup,
	            color: 'accent'
	          },
	          buttonDecline
	        ),
	        _react2.default.createElement(_SingConsentButton2.default, {
	          buttonAccept: buttonAccept,
	          handleAcceptConsent: handleAcceptConsent,
	          isConsentHasMultipleOutcomes: isConsentHasMultipleOutcomes,
	          isSignConsentLoading: isSignConsentLoading,
	          titles: consentOutcomeTitles
	        })
	      )
	    )
	  );
	}
	
	ConsentDetailsMainView.propTypes = {
	  buttonAccept: PropTypes.string,
	  buttonDecline: PropTypes.string,
	  consentOutcomeTitles: PropTypes.arrayOf(PropTypes.string),
	  convertedTime: PropTypes.string,
	  createMarkup: PropTypes.func,
	  formatMessage: PropTypes.func,
	  handleAcceptConsent: PropTypes.func,
	  handleClosePopup: PropTypes.func,
	  isConsentHasMultipleOutcomes: PropTypes.bool,
	  isSignConsentLoading: PropTypes.bool,
	  name: PropTypes.string,
	  organizationName: PropTypes.string,
	  serviceName: PropTypes.string,
	  titleTypeConsent: PropTypes.string
	};

/***/ }),
/* 3337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConsentDetailsSelfSchedulingView = ConsentDetailsSelfSchedulingView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SingConsentButton = __webpack_require__(492);
	
	var _SingConsentButton2 = _interopRequireDefault(_SingConsentButton);
	
	var _handleNumberOfCount = __webpack_require__(1127);
	
	var _index = __webpack_require__(721);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConsentDetailsSelfSchedulingView(_ref) {
	  var allConsents = _ref.allConsents,
	      buttonAccept = _ref.buttonAccept,
	      buttonDecline = _ref.buttonDecline,
	      consentOutcomeTitles = _ref.consentOutcomeTitles,
	      consentTypeName = _ref.consentTypeName,
	      consentVersionTitle = _ref.consentVersionTitle,
	      createMarkup = _ref.createMarkup,
	      handleAcceptConsent = _ref.handleAcceptConsent,
	      handleClosePopup = _ref.handleClosePopup,
	      id = _ref.id,
	      isConsentHasMultipleOutcomes = _ref.isConsentHasMultipleOutcomes,
	      isSignConsentLoading = _ref.isSignConsentLoading,
	      name = _ref.name,
	      providerContext = _ref.providerContext,
	      version = _ref.version;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.contentHeader },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.mainTitle },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.consentTitle },
	            name
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: _index2.default.consentSubTitle
	            },
	            consentTypeName + ', ' + consentVersionTitle + ' ' + version
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.counter },
	          (0, _handleNumberOfCount.handleNumberOfCount)(allConsents, id)
	        )
	      ),
	      _react2.default.createElement('div', { className: _index2.default.text, dangerouslySetInnerHTML: createMarkup() }),
	      !providerContext && _react2.default.createElement(
	        'div',
	        { className: _index2.default.mainConsentBtnWrapper },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: _index2.default.declineButton,
	            onClick: handleClosePopup,
	            color: 'accent'
	          },
	          buttonDecline
	        ),
	        _react2.default.createElement(_SingConsentButton2.default, {
	          buttonAccept: buttonAccept,
	          handleAcceptConsent: handleAcceptConsent,
	          isConsentHasMultipleOutcomes: isConsentHasMultipleOutcomes,
	          isSignConsentLoading: isSignConsentLoading,
	          titles: consentOutcomeTitles
	        })
	      )
	    )
	  );
	}
	
	ConsentDetailsSelfSchedulingView.propTypes = {
	  allConsents: PropTypes.array,
	  buttonAccept: PropTypes.string,
	  buttonDecline: PropTypes.string,
	  consentOutcomeTitles: PropTypes.arrayOf(PropTypes.string),
	  consentTypeName: PropTypes.string,
	  consentVersionTitle: PropTypes.string,
	  createMarkup: PropTypes.func,
	  handleAcceptConsent: PropTypes.func,
	  handleClosePopup: PropTypes.func,
	  id: PropTypes.number,
	  isConsentHasMultipleOutcomes: PropTypes.bool,
	  isSignConsentLoading: PropTypes.bool,
	  name: PropTypes.string,
	  providerContext: PropTypes.bool,
	  version: PropTypes.number
	};

/***/ }),
/* 3338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConsentDetailsView = ConsentDetailsView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _SingConsentButton = __webpack_require__(492);
	
	var _SingConsentButton2 = _interopRequireDefault(_SingConsentButton);
	
	var _renderConsentHeader = __webpack_require__(1128);
	
	var _handleNumberOfCount = __webpack_require__(1127);
	
	var _index = __webpack_require__(721);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConsentDetailsView(_ref) {
	  var allConsents = _ref.allConsents,
	      buttonAccept = _ref.buttonAccept,
	      consentOutcomeTitles = _ref.consentOutcomeTitles,
	      consentTypeName = _ref.consentTypeName,
	      consentVersionTitle = _ref.consentVersionTitle,
	      convertedTime = _ref.convertedTime,
	      createMarkup = _ref.createMarkup,
	      formatMessage = _ref.formatMessage,
	      handleAcceptConsent = _ref.handleAcceptConsent,
	      id = _ref.id,
	      isConsentHasMultipleOutcomes = _ref.isConsentHasMultipleOutcomes,
	      isSignConsentLoading = _ref.isSignConsentLoading,
	      name = _ref.name,
	      organizationName = _ref.organizationName,
	      providerContext = _ref.providerContext,
	      serviceName = _ref.serviceName,
	      titleTypeConsent = _ref.titleTypeConsent,
	      version = _ref.version;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    !providerContext && _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      (0, _renderConsentHeader.renderConsentHeader)(formatMessage, titleTypeConsent, organizationName, serviceName, convertedTime, false)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.contentHeader },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.mainTitle },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.consentTitle },
	            name
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: _index2.default.consentSubTitle
	            },
	            consentTypeName + ', ' + consentVersionTitle + ' ' + version
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.counter },
	          (0, _handleNumberOfCount.handleNumberOfCount)(allConsents, id)
	        )
	      ),
	      _react2.default.createElement('div', { className: _index2.default.text, dangerouslySetInnerHTML: createMarkup() }),
	      !providerContext && _react2.default.createElement(_SingConsentButton2.default, {
	        buttonAccept: buttonAccept,
	        handleAcceptConsent: handleAcceptConsent,
	        isConsentHasMultipleOutcomes: isConsentHasMultipleOutcomes,
	        isSignConsentLoading: isSignConsentLoading,
	        titles: consentOutcomeTitles
	      })
	    )
	  );
	}
	
	ConsentDetailsView.propTypes = {
	  allConsents: PropTypes.array,
	  buttonAccept: PropTypes.string,
	  consentOutcomeTitles: PropTypes.arrayOf(PropTypes.string),
	  consentTypeName: PropTypes.string,
	  consentVersionTitle: PropTypes.string,
	  convertedTime: PropTypes.string,
	  createMarkup: PropTypes.func,
	  formatMessage: PropTypes.func,
	  handleAcceptConsent: PropTypes.func,
	  id: PropTypes.number,
	  isConsentHasMultipleOutcomes: PropTypes.bool,
	  isSignConsentLoading: PropTypes.bool,
	  name: PropTypes.string,
	  organizationName: PropTypes.string,
	  providerContext: PropTypes.bool,
	  serviceName: PropTypes.string,
	  titleTypeConsent: PropTypes.string,
	  version: PropTypes.number
	};

/***/ }),
/* 3339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEBOUNCE_DELAY = 150;
	
	var useMenuPosition = function useMenuPosition(isConsentHasMultipleOutcomes) {
	  var buttonRef = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)({ top: 0, left: 0, width: 0 }),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      position = _useState2[0],
	      setPosition = _useState2[1];
	
	  var getMenuPosition = (0, _react.useCallback)(function () {
	    if (isConsentHasMultipleOutcomes) {
	      var button = (0, _get2.default)(buttonRef, 'current.button', null);
	
	      var rect = button.getBoundingClientRect();
	
	      var x = rect.x,
	          y = rect.y,
	          width = rect.width;
	
	
	      setPosition({ top: y, left: x, width: width });
	    }
	  }, [isConsentHasMultipleOutcomes]);
	
	  (0, _react.useEffect)(function () {
	    var timeoutId = void 0;
	
	    var handleResize = function handleResize() {
	      clearTimeout(timeoutId);
	      timeoutId = setTimeout(function () {
	        getMenuPosition();
	      }, DEBOUNCE_DELAY);
	    };
	
	    window.addEventListener('resize', handleResize);
	
	    return function () {
	      clearTimeout(timeoutId);
	      window.removeEventListener('resize', handleResize);
	    };
	  }, []);
	
	  return { getMenuPosition: getMenuPosition, buttonRef: buttonRef, position: position };
	};
	
	exports.default = useMenuPosition;

/***/ }),
/* 3340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _useMenuPosition2 = __webpack_require__(3339);
	
	var _useMenuPosition3 = _interopRequireDefault(_useMenuPosition2);
	
	var _index = __webpack_require__(4985);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MENU_BOTTOM_MARGIN = 30;
	
	var MultipleOutcomesMenu = function MultipleOutcomesMenu(_ref) {
	  var children = _ref.children,
	      isConsentHasMultipleOutcomes = _ref.isConsentHasMultipleOutcomes,
	      titles = _ref.titles;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      openMenu = _useState2[0],
	      setOpenMenu = _useState2[1];
	
	  var menuRef = (0, _react.useRef)(null);
	
	  var _useMenuPosition = (0, _useMenuPosition3.default)(isConsentHasMultipleOutcomes),
	      getMenuPosition = _useMenuPosition.getMenuPosition,
	      buttonRef = _useMenuPosition.buttonRef,
	      position = _useMenuPosition.position;
	
	  var className = (0, _get2.default)(children.props, 'className', '');
	
	  var handleOutcomeTitleClick = function handleOutcomeTitleClick(e) {
	    var button = e.target.closest('button');
	
	    if (button) {
	      var title = button.textContent;
	      children.props.onClick({ outcomeTitle: title });
	      setOpenMenu(false);
	    }
	  };
	
	  var onAcceptButtonClick = function onAcceptButtonClick() {
	    if (isConsentHasMultipleOutcomes) {
	      getMenuPosition();
	
	      setOpenMenu(function (prev) {
	        return !prev;
	      });
	    } else {
	      children.props.onClick();
	    }
	  };
	
	  var enhancedChildren = (0, _react.cloneElement)(children, (0, _extends3.default)({}, children.props, {
	    ref: buttonRef,
	    onClick: onAcceptButtonClick,
	    className: (0, _classnames2.default)(className, (0, _defineProperty3.default)({}, _index2.default.disableButton, openMenu))
	  }));
	
	  var menuPositionStyle = (0, _react.useMemo)(function () {
	    return {
	      top: position.top + MENU_BOTTOM_MARGIN,
	      left: position.left + position.width
	    };
	  }, [position]);
	
	  (0, _react.useEffect)(function () {
	    var controller = new AbortController();
	    var signal = controller.signal;
	
	
	    var handleClickOutside = function handleClickOutside(event) {
	      if (menuRef.current && !menuRef.current.contains(event.target)) {
	        setOpenMenu(false);
	      }
	    };
	
	    document.addEventListener('pointerdown', handleClickOutside, { signal: signal });
	    document.addEventListener('mousedown', handleClickOutside, { signal: signal });
	    document.addEventListener('touchstart', handleClickOutside, { signal: signal });
	    document.addEventListener('keydown', handleClickOutside, { signal: signal });
	
	    return function () {
	      controller.abort();
	    };
	  }, []);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    (0, _reactDom.createPortal)(_react2.default.createElement(
	      'div',
	      { className: _index2.default.wrapper, style: menuPositionStyle },
	      openMenu && _react2.default.createElement(
	        'ul',
	        {
	          className: _index2.default.menuList,
	          role: 'menu',
	          ref: menuRef,
	          onClick: handleOutcomeTitleClick
	        },
	        titles.map(function (item) {
	          return _react2.default.createElement(
	            'li',
	            { key: item },
	            _react2.default.createElement(
	              'button',
	              {
	                type: 'button',
	                className: _index2.default.listItem,
	                style: { minWidth: position.width }
	              },
	              _react2.default.createElement(
	                'div',
	                { className: _index2.default.title },
	                item
	              ),
	              _react2.default.createElement(_Icon2.default, {
	                name: 'arrow-right',
	                size: 16,
	                className: _index2.default.icon
	              })
	            )
	          );
	        })
	      )
	    ), document.body),
	    enhancedChildren
	  );
	};
	
	MultipleOutcomesMenu.propTypes = {
	  children: _propTypes2.default.node,
	  isConsentHasMultipleOutcomes: _propTypes2.default.bool,
	  titles: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	exports.default = MultipleOutcomesMenu;

/***/ }),
/* 3341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	var _selectors = __webpack_require__(64);
	
	var _selectors2 = __webpack_require__(23);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    providerContext: (0, _selectors2.hasProviderProfileSelector)(state),
	    userId: (0, _selectors.selectPatientUserInfoIdWithAppointmentState)(state),
	    isOpened: (0, _selectors.selectAppointmentConsentsModalOpen)(state),
	    isMainConsentView: (0, _selectors.selectIsMainConsentViewState)(state),
	    currentConsent: (0, _selectors.selectAppointmentCurrentConsentState)(state),
	    organizationName: (0, _selectors.selectAppointmentOrganizationName)(state),
	    serviceName: (0, _selectors.selectAppointmentServiceName)(state),
	    timeConsent: (0, _selectors.selectAppointmentConsentTime)(state),
	    allConsents: (0, _selectors.selectAppointmentAllConsentState)(state),
	    urgentVisitFlow: (0, _selectors.selectAppointmentConsentsModalOpenUrgentVisit)(state),
	    selfSchedulingFlow: (0, _selectors.selectAppointmentConsentsModalOpenSelfScheduling)(state),
	    rescheduleFlow: (0, _selectors.selectAppointmentConsentsModalOpenRescheduleFlow)(state),
	    isSignConsentLoading: (0, _selectors.selectSignAppointmentConsentLoading)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  appointmentConsentsModalOpen: _appointmentConsentModal.appointmentConsentsModalActions.open,
	  appointmentConsentsModalClose: _appointmentConsentModal.appointmentConsentsModalActions.close
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConsentDetailsPopup = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports._ConsentDetailsPopup = _ConsentDetailsPopup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _dateConverters = __webpack_require__(83);
	
	var _sanitizeHtml = __webpack_require__(313);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _ConsentDetailsMainView = __webpack_require__(3336);
	
	var _ConsentDetailsView = __webpack_require__(3338);
	
	var _enhance = __webpack_require__(3341);
	
	var _useConsentOutcomesInfo = __webpack_require__(798);
	
	var _useConsentOutcomesInfo2 = _interopRequireDefault(_useConsentOutcomesInfo);
	
	var _useSignAppointmentConsent = __webpack_require__(1212);
	
	var _useSignAppointmentConsent2 = _interopRequireDefault(_useSignAppointmentConsent);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _ConsentDetailsSelfSchedulingView = __webpack_require__(3337);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _ConsentDetailsPopup(_ref) {
	  var allConsents = _ref.allConsents,
	      appointmentConsentsModalClose = _ref.appointmentConsentsModalClose,
	      appointmentConsentsModalOpen = _ref.appointmentConsentsModalOpen,
	      currentConsent = _ref.currentConsent,
	      formatMessage = _ref.intl.formatMessage,
	      isMainConsentView = _ref.isMainConsentView,
	      isOpened = _ref.isOpened,
	      isSignConsentLoading = _ref.isSignConsentLoading,
	      organizationName = _ref.organizationName,
	      providerContext = _ref.providerContext,
	      _ref$rescheduleFlow = _ref.rescheduleFlow,
	      isRescheduleFlow = _ref$rescheduleFlow.isRescheduleFlow,
	      providerId = _ref$rescheduleFlow.providerId,
	      locationId = _ref$rescheduleFlow.locationId,
	      selfSchedulingFlow = _ref.selfSchedulingFlow,
	      serviceName = _ref.serviceName,
	      timeConsent = _ref.timeConsent,
	      urgentVisitFlow = _ref.urgentVisitFlow,
	      userId = _ref.userId;
	
	  var titlePopupProvider = formatMessage({
	    id: 'appointment.consent.details.titleProvider'
	  });
	  var titlePopupPatient = formatMessage({
	    id: 'appointment.consent.details.titlePatient'
	  });
	  var buttonDecline = formatMessage({
	    id: 'common.decline'
	  });
	  var titleTypeConsent = formatMessage({
	    id: 'appointment.consent.details.type'
	  });
	  var consentVersionTitle = formatMessage({
	    id: 'appointment.consent.consentVersion'
	  });
	
	  var convertedTime = (0, _dateConverters.formatDate)(timeConsent, formatMessage);
	
	  var _useConsentOutcomesIn = (0, _useConsentOutcomesInfo2.default)(currentConsent),
	      buttonAccept = _useConsentOutcomesIn.buttonAccept,
	      consentOutcomeTitles = _useConsentOutcomesIn.consentOutcomeTitles,
	      isConsentHasMultipleOutcomes = _useConsentOutcomesIn.isConsentHasMultipleOutcomes;
	
	  var handleAcceptConsent = (0, _useSignAppointmentConsent2.default)({
	    consentId: currentConsent.id,
	    userId: userId,
	    consentVersion: currentConsent.version
	  });
	
	  var notSignedConsent = allConsents.filter(function (item) {
	    return !item.accepted;
	  });
	
	  var checkForNonSignedConsent = (0, _react.useMemo)(function () {
	    return function (currentNonSignedConsent, nextNonSignedConsent) {
	      if (notSignedConsent.length === 0) {
	        appointmentConsentsModalClose();
	        if (urgentVisitFlow) {
	          (0, _redirectUtils.redirectToPharmacy)();
	        }
	        if (selfSchedulingFlow) {
	          (0, _redirectUtils.redirectToAppointmentOverview)();
	        }
	        return {};
	      }
	
	      if (currentNonSignedConsent.accepted) {
	        appointmentConsentsModalOpen({
	          organizationName: organizationName,
	          serviceName: serviceName,
	          startTime: timeConsent,
	          allConsents: allConsents,
	          consent: nextNonSignedConsent,
	          patientUserInfoId: userId,
	          isMainConsentView: isMainConsentView
	        });
	        return nextNonSignedConsent;
	      }
	
	      if (currentNonSignedConsent) return currentNonSignedConsent;
	      return nextNonSignedConsent;
	    };
	  }, [currentConsent, notSignedConsent, urgentVisitFlow]);
	
	  var _checkForNonSignedCon = checkForNonSignedConsent(currentConsent, notSignedConsent[0]),
	      name = _checkForNonSignedCon.name,
	      version = _checkForNonSignedCon.version,
	      content = _checkForNonSignedCon.content,
	      id = _checkForNonSignedCon.id,
	      consentType = _checkForNonSignedCon.consentType;
	
	  var subTitle = formatMessage({
	    id: 'appointment.consent.mainConsentTitle'
	  }, {
	    name: name
	  });
	
	  var consentTypeName = consentType ? consentType.name : '';
	
	  var handleClosePopup = function handleClosePopup() {
	    if (urgentVisitFlow) (0, _redirectUtils.redirectToVisitDetails)();
	    if (selfSchedulingFlow) {
	      if (isRescheduleFlow) {
	        (0, _redirectUtils.redirectToRescheduleProviderDetails)({ locationId: locationId, providerId: providerId });
	      } else {
	        (0, _redirectUtils.redirectToProviders)();
	      }
	    }
	    appointmentConsentsModalClose();
	  };
	
	  function createMarkup() {
	    return {
	      __html: (0, _sanitizeHtml2.default)(content)
	    };
	  }
	
	  var consentViewSharedProps = (0, _react.useMemo)(function () {
	    return {
	      buttonAccept: buttonAccept,
	      buttonDecline: buttonDecline,
	      consentOutcomeTitles: consentOutcomeTitles,
	      createMarkup: createMarkup,
	      handleAcceptConsent: handleAcceptConsent,
	      handleClosePopup: handleClosePopup,
	      isConsentHasMultipleOutcomes: isConsentHasMultipleOutcomes,
	      isSignConsentLoading: isSignConsentLoading,
	      name: name
	    };
	  }, [buttonAccept, buttonDecline, consentOutcomeTitles, createMarkup, handleAcceptConsent, handleClosePopup, isConsentHasMultipleOutcomes, isSignConsentLoading, name]);
	
	  var renderView = function renderView() {
	    if (urgentVisitFlow || selfSchedulingFlow) {
	      return _react2.default.createElement(_ConsentDetailsSelfSchedulingView.ConsentDetailsSelfSchedulingView, (0, _extends3.default)({}, consentViewSharedProps, {
	        allConsents: allConsents,
	        providerContext: providerContext,
	        id: id,
	        consentTypeName: consentTypeName,
	        consentVersionTitle: consentVersionTitle,
	        version: version
	      }));
	    }
	    if (isMainConsentView) {
	      return _react2.default.createElement(_ConsentDetailsMainView.ConsentDetailsMainView, (0, _extends3.default)({
	        formatMessage: formatMessage
	      }, consentViewSharedProps, {
	        convertedTime: convertedTime,
	        organizationName: organizationName,
	        serviceName: serviceName,
	        titleTypeConsent: titleTypeConsent
	      }));
	    }
	    return _react2.default.createElement(_ConsentDetailsView.ConsentDetailsView, (0, _extends3.default)({}, consentViewSharedProps, {
	      allConsents: allConsents,
	      consentTypeName: consentTypeName,
	      consentVersionTitle: consentVersionTitle,
	      convertedTime: convertedTime,
	      formatMessage: formatMessage,
	      id: id,
	      organizationName: organizationName,
	      providerContext: providerContext,
	      serviceName: serviceName,
	      titleTypeConsent: titleTypeConsent,
	      version: version
	    }));
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: isOpened,
	      onClose: handleClosePopup,
	      title: providerContext || isMainConsentView || selfSchedulingFlow ? titlePopupProvider : titlePopupPatient,
	      subTitle: isMainConsentView && subTitle,
	      mobileFullScreen: false,
	      width: 'medium'
	    },
	    renderView()
	  );
	}
	
	_ConsentDetailsPopup.propTypes = {
	  allConsents: PropTypes.array,
	  appointmentConsentsModalClose: PropTypes.func,
	  appointmentConsentsModalOpen: PropTypes.func,
	  currentConsent: PropTypes.object,
	  intl: PropTypes.shape({ formatMessage: PropTypes.func }),
	  isMainConsentView: PropTypes.bool,
	  isOpened: PropTypes.bool,
	  isSignConsentLoading: PropTypes.bool,
	  organizationName: PropTypes.string,
	  providerContext: PropTypes.bool,
	  rescheduleFlow: PropTypes.object,
	  selfSchedulingFlow: PropTypes.bool,
	  serviceName: PropTypes.string,
	  timeConsent: PropTypes.string,
	  urgentVisitFlow: PropTypes.bool,
	  userId: PropTypes.number
	};
	
	var ConsentDetailsPopup = exports.ConsentDetailsPopup = (0, _enhance.enhance)(_ConsentDetailsPopup);

/***/ }),
/* 3343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConsentListItem = ConsentListItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	var _dateConverters = __webpack_require__(83);
	
	var _renderConsentHeader = __webpack_require__(1128);
	
	var _utils = __webpack_require__(254);
	
	var _index = __webpack_require__(4987);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConsentListItem(_ref) {
	  var entity = _ref.entity,
	      formatMessage = _ref.formatMessage,
	      onClick = _ref.onClick;
	
	  var titleTypeConsent = formatMessage({
	    id: 'appointment.consent.details.type'
	  });
	
	  var id = entity.id,
	      completedTime = entity.completedTime,
	      todoStatus = entity.todoStatus,
	      _entity$userAppointme = entity.userAppointment,
	      organizationName = _entity$userAppointme.organization.name,
	      serviceName = _entity$userAppointme.service.name,
	      startTime = _entity$userAppointme.startTime,
	      userId = _entity$userAppointme.userId,
	      consents = entity.consents;
	
	  var time = (0, _utils.isCompleted)(todoStatus) ? completedTime : startTime;
	  var formatTime = (0, _dateConverters.formatDateByYear)(time, formatMessage);
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var handleOpenConsent = function handleOpenConsent() {
	    return onClick ? onClick() : dispatch(_appointmentConsentModal.appointmentConsentsModalActions.open({
	      consent: consents[0],
	      organizationName: organizationName,
	      serviceName: serviceName,
	      startTime: startTime,
	      allConsents: consents,
	      patientUserInfoId: userId
	    }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root, onClick: handleOpenConsent, key: id },
	    (0, _renderConsentHeader.renderConsentHeader)(formatMessage, titleTypeConsent, organizationName, serviceName, formatTime)
	  );
	}
	
	ConsentListItem.defaultProps = {
	  onClick: null
	};
	
	ConsentListItem.propTypes = {
	  entity: PropTypes.object,
	  formatMessage: PropTypes.func,
	  onClick: PropTypes.func
	};

/***/ }),
/* 3344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConsentRenderView = ConsentRenderView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(2249);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConsentRenderView(_ref) {
	  var id = _ref.id,
	      accepted = _ref.accepted,
	      fileUrl = _ref.fileUrl,
	      currentConsent = _ref.currentConsent,
	      _ref$name = _ref.name,
	      name = _ref$name === undefined ? '' : _ref$name,
	      version = _ref.version,
	      _ref$consentType = _ref.consentType;
	  _ref$consentType = _ref$consentType === undefined ? {} : _ref$consentType;
	  var consentTypeTitle = _ref$consentType.name,
	      formatMessage = _ref.formatMessage,
	      organizationName = _ref.organizationName,
	      serviceName = _ref.serviceName,
	      startTime = _ref.startTime,
	      allConsents = _ref.allConsents,
	      consentVersionTitle = _ref.consentVersionTitle,
	      patientUserInfoId = _ref.patientUserInfoId;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var handleOpenConsent = function handleOpenConsent() {
	    if (accepted && fileUrl) {
	      window.open(fileUrl);
	    } else {
	      dispatch(_appointmentConsentModal.appointmentConsentsModalActions.open({
	        consent: currentConsent,
	        organizationName: organizationName,
	        serviceName: serviceName,
	        startTime: startTime,
	        allConsents: allConsents,
	        patientUserInfoId: patientUserInfoId
	      }));
	    }
	  };
	  var signedTitle = formatMessage({ id: 'appointment.consent.signed' });
	  var notSignedTitle = formatMessage({ id: 'appointment.consent.notSigned' });
	
	  return _react2.default.createElement(
	    'div',
	    {
	      key: id,
	      className: _index2.default.visitConsentItem,
	      onClick: function onClick() {
	        return handleOpenConsent();
	      }
	    },
	    _react2.default.createElement(_Icon2.default, { name: 'icon-document-black', size: 32, className: _index2.default.icon }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.consentInfoWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.consentTitle },
	        name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.consentSubtitleRow },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.consentSubTitle },
	          consentTypeTitle + ', ' + consentVersionTitle + ' ' + version
	        ),
	        _react2.default.createElement(_Icon2.default, {
	          name: accepted ? 'icon-signed-consent' : 'icon-noSigned-consent',
	          size: 12,
	          className: _index2.default.icon
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.consentStatusTitle },
	          accepted ? signedTitle : notSignedTitle
	        )
	      )
	    )
	  );
	}
	
	ConsentRenderView.propTypes = {
	  id: PropTypes.number,
	  accepted: PropTypes.bool,
	  fileUrl: PropTypes.string,
	  currentConsent: PropTypes.object,
	  name: PropTypes.string,
	  version: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  consentType: PropTypes.object,
	  formatMessage: PropTypes.func,
	  organizationName: PropTypes.string,
	  serviceName: PropTypes.string,
	  startTime: PropTypes.string,
	  allConsents: PropTypes.array,
	  consentVersionTitle: PropTypes.string,
	  patientUserInfoId: PropTypes.number
	};

/***/ }),
/* 3345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ElectronicConsentListItem = ElectronicConsentListItem;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _renderElectronicConsentHeader = __webpack_require__(1755);
	
	var _getElectronicConsentHeaderRenderData = __webpack_require__(1762);
	
	var _getElectronicConsentHeaderRenderData2 = _interopRequireDefault(_getElectronicConsentHeaderRenderData);
	
	var _index = __webpack_require__(4988);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ElectronicConsentListItem(_ref) {
	  var entity = _ref.entity,
	      formatMessage = _ref.formatMessage,
	      onClick = _ref.onClick;
	
	  var _getElectronicConsent = (0, _getElectronicConsentHeaderRenderData2.default)(entity, formatMessage),
	      assignedBy = _getElectronicConsent.assignedBy,
	      consentName = _getElectronicConsent.consentName,
	      organizationName = _getElectronicConsent.organizationName,
	      formatTime = _getElectronicConsent.formatTime,
	      id = _getElectronicConsent.id;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root, onClick: onClick, key: id },
	    (0, _renderElectronicConsentHeader.renderElectronicConsentHeader)(formatMessage, assignedBy, consentName, organizationName, formatTime)
	  );
	}
	
	ElectronicConsentListItem.defaultProps = {
	  onClick: null
	};
	
	ElectronicConsentListItem.propTypes = {
	  entity: PropTypes.object,
	  formatMessage: PropTypes.func,
	  onClick: PropTypes.func
	};

/***/ }),
/* 3346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateRequiredFields = exports.initialStateFields = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialStateFields;
	
	var _constants = __webpack_require__(768);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialStateFields = exports.initialStateFields = (_initialStateFields = {}, (0, _defineProperty3.default)(_initialStateFields, _constants.VISIT_DOCUMENTS_TYPES.CATEGORY, null), (0, _defineProperty3.default)(_initialStateFields, _constants.VISIT_DOCUMENTS_TYPES.SUB_CATEGORY, null), (0, _defineProperty3.default)(_initialStateFields, _constants.VISIT_DOCUMENTS_TYPES.DOCUMENTS, null), _initialStateFields);
	
	var validateRequiredFields = exports.validateRequiredFields = (0, _useFormWithValidation.makeRequiredFieldsValidator)([_constants.VISIT_DOCUMENTS_TYPES.CATEGORY, _constants.VISIT_DOCUMENTS_TYPES.SUB_CATEGORY, _constants.VISIT_DOCUMENTS_TYPES.DOCUMENTS]);

/***/ }),
/* 3347 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.AddDocumentForm = AddDocumentForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _uploadDocumentReq = __webpack_require__(304);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ViewDocuments = __webpack_require__(1757);
	
	var _useUploadDocumentForm = __webpack_require__(3348);
	
	var _constants = __webpack_require__(768);
	
	var _index = __webpack_require__(4990);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddDocumentForm(_ref) {
	  var formatMessage = _ref.formatMessage,
	      onClose = _ref.onClose,
	      attachment = _ref.attachment,
	      appointmentId = _ref.appointmentId,
	      allowedDocumentCategories = _ref.allowedDocumentCategories;
	
	  var description = formatMessage({
	    id: 'appointment.documents.description'
	  });
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handleSubmit = function handleSubmit() {
	    dispatch(_uploadDocumentReq.actions.startUpload((0, _extends3.default)({}, formState, {
	      documents: attachment.file,
	      appointmentId: appointmentId
	    })));
	    onClose();
	  };
	
	  var handleCancelButton = function handleCancelButton() {
	    clearForm();
	    onClose();
	  };
	
	  var _useUploadDocumentFor = (0, _useUploadDocumentForm.useUploadDocumentForm)(attachment, allowedDocumentCategories),
	      formState = _useUploadDocumentFor.formState,
	      handleFormChange = _useUploadDocumentFor.handleFormChange,
	      clearForm = _useUploadDocumentFor.clearForm,
	      isValid = _useUploadDocumentFor.isValid,
	      categoryOptions = _useUploadDocumentFor.categoryOptions,
	      subcategoryOptions = _useUploadDocumentFor.subcategoryOptions,
	      stateCategory = _useUploadDocumentFor.stateCategory,
	      stateSubcategory = _useUploadDocumentFor.stateSubcategory;
	
	  var makeField = (0, _getFieldProps.getFieldProps)(formatMessage, handleFormChange);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.description },
	      description
	    ),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(_constants.VISIT_DOCUMENTS_TYPES.CATEGORY), {
	      needUpdateDefaultValue: true,
	      options: categoryOptions,
	      value: stateCategory
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(_constants.VISIT_DOCUMENTS_TYPES.SUB_CATEGORY), {
	      options: subcategoryOptions,
	      needUpdateDefaultValue: true,
	      value: stateSubcategory
	    })),
	    _react2.default.createElement(_ViewDocuments.ViewDocuments, { attachment: attachment, singleView: true }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.buttonWrapper },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: _index2.default.buttonAction,
	          raised: true,
	          color: 'primary',
	          type: 'submit',
	          onClick: handleSubmit,
	          disabled: !isValid
	        },
	        formatMessage({ id: 'common.save' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: _index2.default.buttonAction,
	          raised: true,
	          color: 'accent',
	          onClick: handleCancelButton
	        },
	        formatMessage({ id: 'common.cancel' })
	      )
	    )
	  );
	}
	
	AddDocumentForm.propTypes = {
	  formatMessage: PropTypes.func,
	  onClose: PropTypes.func,
	  attachment: PropTypes.object,
	  appointmentId: PropTypes.number,
	  allowedDocumentCategories: PropTypes.array
	};

/***/ }),
/* 3348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useUploadDocumentForm = useUploadDocumentForm;
	
	var _react = __webpack_require__(1);
	
	var _lodash = __webpack_require__(58);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _fields = __webpack_require__(3346);
	
	var _constants = __webpack_require__(768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useUploadDocumentForm(attachment, allowedCategory) {
	  var _useFormState = (0, _useFormWithValidation.useFormState)(_fields.initialStateFields),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange,
	      clearForm = _useFormState.clearForm;
	
	  var stateCategory = formState[_constants.VISIT_DOCUMENTS_TYPES.CATEGORY];
	  var stateSubcategory = formState[_constants.VISIT_DOCUMENTS_TYPES.SUB_CATEGORY];
	
	  function handleRestrictionSelectField(fieldKey) {
	    if (formState) {
	      var populate = (0, _lodash.mapValues)(formState, function (value, key) {
	        if (key === fieldKey) return null;
	
	        return formState[key] || null;
	      });
	      handleFormChange(populate);
	    }
	  }
	
	  (0, _react.useEffect)(function () {
	    handleRestrictionSelectField(_constants.VISIT_DOCUMENTS_TYPES.SUB_CATEGORY);
	  }, [stateCategory]);
	
	  var isValid = (0, _fields.validateRequiredFields)((0, _extends3.default)({}, formState, {
	    documents: attachment ? attachment.file : null
	  }));
	
	  var handleChooseCategorySubCategory = function handleChooseCategorySubCategory() {
	    var currentCategoryId = formState.category;
	
	    var allCategories = allowedCategory.map(function (_ref) {
	      var id = _ref.id,
	          name = _ref.name;
	
	      return { label: name, value: id };
	    });
	    var currentCategory = allowedCategory.filter(function (_ref2) {
	      var id = _ref2.id;
	      return id === currentCategoryId;
	    });
	
	    var currentSubcategories = currentCategory.length > 0 ? currentCategory[0].documentSubcategories.map(function (_ref3) {
	      var id = _ref3.id,
	          name = _ref3.name;
	      return {
	        label: name,
	        value: id
	      };
	    }) : [];
	
	    return {
	      categoryOptions: allCategories,
	      subcategoryOptions: currentSubcategories
	    };
	  };
	
	  var _handleChooseCategory = handleChooseCategorySubCategory(),
	      categoryOptions = _handleChooseCategory.categoryOptions,
	      subcategoryOptions = _handleChooseCategory.subcategoryOptions;
	
	  return (0, _react.useMemo)(function () {
	    return {
	      formState: formState,
	      handleFormChange: handleFormChange,
	      clearForm: clearForm,
	      isValid: isValid,
	      categoryOptions: categoryOptions,
	      subcategoryOptions: subcategoryOptions,
	      stateCategory: stateCategory,
	      stateSubcategory: stateSubcategory
	    };
	  }, [formState, isValid, categoryOptions, subcategoryOptions, stateCategory, stateSubcategory]);
	}

/***/ }),
/* 3349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddDocumentPopup = AddDocumentPopup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _AddDocumentForm = __webpack_require__(3347);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddDocumentPopup(_ref) {
	  var opened = _ref.opened,
	      onClose = _ref.onClose,
	      formatMessage = _ref.formatMessage,
	      attachment = _ref.attachment,
	      setAttachment = _ref.setAttachment,
	      appointmentId = _ref.appointmentId,
	      allowedDocumentCategories = _ref.allowedDocumentCategories;
	
	  var title = formatMessage({
	    id: 'appointment.documents.addDocument.title'
	  });
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: opened,
	      onClose: onClose,
	      title: title,
	      mobileFullScreen: false
	    },
	    _react2.default.createElement(_AddDocumentForm.AddDocumentForm, {
	      formatMessage: formatMessage,
	      onClose: onClose,
	      attachment: attachment,
	      setAttachment: setAttachment,
	      appointmentId: appointmentId,
	      allowedDocumentCategories: allowedDocumentCategories
	    })
	  );
	}
	
	AddDocumentPopup.propTypes = {
	  opened: PropTypes.bool,
	  onClose: PropTypes.func,
	  formatMessage: PropTypes.func,
	  attachment: PropTypes.object,
	  setAttachment: PropTypes.func,
	  appointmentId: PropTypes.number,
	  allowedDocumentCategories: PropTypes.array
	};

/***/ }),
/* 3350 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultState = exports.defaultState = {
	  fileError: false,
	  file: null,
	  loading: false,
	  deleted: false,
	  errors: null
	};

/***/ }),
/* 3351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.VisitDocuments = VisitDocuments;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(17);
	
	var _defaultState = __webpack_require__(3350);
	
	var _AddDocumentPopup = __webpack_require__(3349);
	
	var _UploadDocument = __webpack_require__(1756);
	
	var _ViewDocuments = __webpack_require__(1757);
	
	var _index = __webpack_require__(4993);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VisitDocuments(_ref) {
	  var formatMessage = _ref.formatMessage,
	      providerContext = _ref.providerContext,
	      appointment = _ref.appointment;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isOpenModal = _useState2[0],
	      toggleOpenModal = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(_defaultState.defaultState),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      attachment = _useState4[0],
	      setAttachment = _useState4[1];
	
	  var titleDocuments = formatMessage({
	    id: 'common.documents'
	  });
	  var titleAddButton = formatMessage({
	    id: 'appointment.documents.addDocument.title'
	  });
	
	  var appointmentId = appointment.id,
	      allowedDocumentCategories = appointment.allowedDocumentCategories,
	      status = appointment.status;
	
	
	  var isPendingStatus = (0, _get2.default)(status, 'coreAppName') === _constants.APPOINTMENT_STATUSES.PENDING;
	
	  var handleAddDocument = function handleAddDocument() {
	    toggleOpenModal(!isOpenModal);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.visitDocumentsHeader },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.visitDocumentsTitle },
	        titleDocuments
	      ),
	      providerContext && !isPendingStatus && _react2.default.createElement(
	        'div',
	        { className: _index2.default.addActionWrapper },
	        _react2.default.createElement(_UploadDocument.UploadDocument, {
	          attachment: attachment,
	          setAttachment: setAttachment,
	          handleAddDocument: handleAddDocument,
	          titleAddButton: titleAddButton,
	          allowedFormats: _constants.DOCUMENT_ALLOWED_FORMATS
	        })
	      )
	    ),
	    _react2.default.createElement(_ViewDocuments.ViewDocuments, {
	      singleView: false,
	      appointment: appointment,
	      providerContext: providerContext,
	      formatMessage: formatMessage
	    }),
	    _react2.default.createElement(_AddDocumentPopup.AddDocumentPopup, {
	      onClose: handleAddDocument,
	      opened: isOpenModal,
	      formatMessage: formatMessage,
	      attachment: attachment,
	      setAttachment: setAttachment,
	      appointmentId: appointmentId,
	      allowedDocumentCategories: allowedDocumentCategories
	    })
	  );
	}
	
	VisitDocuments.propTypes = {
	  formatMessage: PropTypes.func,
	  providerContext: PropTypes.bool,
	  appointment: PropTypes.object
	};

/***/ }),
/* 3352 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _dateFilter = __webpack_require__(310);
	
	var _makeSafePharmacyAddress = __webpack_require__(4186);
	
	var _styles = __webpack_require__(2250);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Prescription = function Prescription(_ref) {
	  var prescription = _ref.prescription,
	      formatMessage = _ref.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isDetailed = _useState2[0],
	      setIsDetailed = _useState2[1];
	
	  var pharmacyTitle = formatMessage({
	    id: 'patient.portal.medications.pharmacy'
	  });
	  var phoneTitle = formatMessage({
	    id: 'common.phone'
	  });
	  var directionTitle = formatMessage({
	    id: 'patient.portal.medications.directions'
	  });
	
	  var safePharmacyAddress = (0, _makeSafePharmacyAddress.makeSafePharmacyAddress)({
	    city: prescription.ccdPharmacy.city,
	    state: prescription.ccdPharmacy.state,
	    address: prescription.ccdPharmacy.address1
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_styles2.default.prescription, (0, _defineProperty3.default)({}, _styles2.default.bgGrey, isDetailed)) },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.prescriptionHeader },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.prescriptionHeaderLeft },
	        _react2.default.createElement(_Icon2.default, { size: 32, name: 'icon-medications', className: _styles2.default.iconType }),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.drugBlock },
	          _react2.default.createElement(
	            'div',
	            null,
	            prescription.name,
	            ', ',
	            prescription.quantityAmount,
	            prescription.quantityUnit,
	            _react2.default.createElement(_PrivacyIcon2.default, {
	              show: prescription.isPrivate,
	              className: _styles2.default.privacyIcon
	            })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: _styles2.default.providerName },
	            prescription.providerProfile.firstName,
	            ' ',
	            prescription.providerProfile.lastName,
	            ' ',
	            prescription.providerProfile.credential
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.prescriptionHeaderRight },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.date },
	          _react2.default.createElement(
	            'div',
	            null,
	            (0, _dateFilter.humanizeDate)(prescription.prescribedDate, formatMessage)
	          )
	        ),
	        _react2.default.createElement(_Icon2.default, {
	          size: 16,
	          className: _styles2.default.iconArrow,
	          onClick: function onClick() {
	            return setIsDetailed(!isDetailed);
	          },
	          name: isDetailed ? 'icon-arrow-up' : 'icon-arrow-down'
	        })
	      )
	    ),
	    isDetailed && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.prescriptionDetails },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.prescriptionDetailsItem },
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.detailsTitle },
	          directionTitle
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.detailsData },
	          _react2.default.createElement(
	            'div',
	            null,
	            prescription.frequency
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.prescriptionDetailsItem },
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.detailsTitle },
	          pharmacyTitle
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.detailsData },
	          _react2.default.createElement(
	            'div',
	            null,
	            prescription.ccdPharmacy.name && prescription.ccdPharmacy.name,
	            ', ',
	            safePharmacyAddress
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.prescriptionDetailsItem },
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.detailsTitle },
	          phoneTitle
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.detailsData },
	          prescription.ccdPharmacy.phone
	        )
	      )
	    )
	  );
	};
	
	Prescription.propTypes = {
	  formatMessage: PropTypes.func,
	  prescription: PropTypes.object
	};
	
	exports.default = Prescription;

/***/ }),
/* 3353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Prescription = __webpack_require__(3352);
	
	var _Prescription2 = _interopRequireDefault(_Prescription);
	
	var _styles = __webpack_require__(2250);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VisitPrescriptions = function VisitPrescriptions(_ref) {
	  var prescriptions = _ref.prescriptions,
	      formatMessage = _ref.formatMessage;
	
	  var title = formatMessage({ id: 'common.prescriptions' });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.prescriptionsWrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.title },
	      title
	    ),
	    prescriptions.length ? prescriptions.map(function (prescription) {
	      return _react2.default.createElement(_Prescription2.default, {
	        key: prescription.id,
	        prescription: prescription,
	        formatMessage: formatMessage
	      });
	    }) : '-'
	  );
	};
	
	VisitPrescriptions.propTypes = {
	  formatMessage: PropTypes.func,
	  prescriptions: PropTypes.array
	};
	
	exports.default = VisitPrescriptions;

/***/ }),
/* 3354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _SurveyTranslations;
	
	exports.ViewSurvey = ViewSurvey;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(493);
	
	var _index = __webpack_require__(2251);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveyTranslations = (_SurveyTranslations = {}, (0, _defineProperty3.default)(_SurveyTranslations, _constants.SURVEY_TYPES.PROGRAM, 'appointment.programForm'), (0, _defineProperty3.default)(_SurveyTranslations, _constants.SURVEY_TYPES.PRE_VISIT, 'appointment.preVisitForm'), (0, _defineProperty3.default)(_SurveyTranslations, _constants.SURVEY_TYPES.PROVIDER_POST_VISIT, 'appointment.postVisitForm'), _SurveyTranslations);
	
	function ViewSurvey(_ref) {
	  var setAssignmentId = _ref.setAssignmentId,
	      formatMessage = _ref.formatMessage,
	      status = _ref.status,
	      name = _ref.name,
	      id = _ref.id,
	      surveyType = _ref.surveyType,
	      isCompletedSurvey = _ref.isCompletedSurvey,
	      _ref$isExpired = _ref.isExpired,
	      isExpired = _ref$isExpired === undefined ? false : _ref$isExpired,
	      targetUserId = _ref.targetUserId,
	      setIntervieweeId = _ref.setIntervieweeId;
	
	  var statusTitleSurvey = function statusTitleSurvey(currentStatus) {
	    switch (currentStatus) {
	      case _constants.STATUS_SURVEY.COMPLETED:
	        return formatMessage({ id: 'general.completed' });
	      case _constants.STATUS_SURVEY.EXPIRED:
	        return formatMessage({ id: 'chat.placeholders.surveyExpired' });
	      case _constants.STATUS_SURVEY.UPCOMING:
	        return formatMessage({ id: 'appointment.surveys.title.upcoming' });
	      default:
	        return currentStatus;
	    }
	  };
	
	  var surveyTypeMessage = (0, _react.useMemo)(function () {
	    var statusMessage = statusTitleSurvey(status);
	    var surveyTypeTranslation = SurveyTranslations[surveyType];
	    var message = surveyTypeTranslation ? formatMessage({ id: surveyTypeTranslation }) : '';
	
	    if (message) return message + ', ' + statusMessage;
	
	    return statusMessage;
	  }, [surveyType, status]);
	
	  (0, _react.useEffect)(function () {
	    setIntervieweeId(targetUserId);
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.viewAttachmentWrapper },
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_index2.default.documentWrapper, (0, _defineProperty3.default)({}, _index2.default.documentWrapperDisabled, isExpired)),
	        onClick: function onClick() {
	          return !isExpired && !isCompletedSurvey && setAssignmentId(id);
	        }
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'up-surveys', size: 32, className: _index2.default.icon }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.surveyInfoWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.surveyName },
	          name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.surveyStatus },
	          surveyTypeMessage
	        )
	      )
	    )
	  );
	}
	
	ViewSurvey.propTypes = {
	  formatMessage: PropTypes.func.isRequired,
	  status: PropTypes.string.isRequired,
	  name: PropTypes.string.isRequired,
	  id: PropTypes.number.isRequired,
	  isCompletedSurvey: PropTypes.bool,
	  isExpired: PropTypes.bool,
	  surveyType: PropTypes.string,
	  setAssignmentId: PropTypes.func.isRequired,
	  targetUserId: PropTypes.number.isRequired,
	  setIntervieweeId: PropTypes.func.isRequired
	};

/***/ }),
/* 3355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _styles = __webpack_require__(4994);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EmtpyHealthBoard(_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'g-content' },
	    _react2.default.createElement(_Content2.default, {
	      text: formatMessage({ id: 'healthboard.title.teamPlaceholder' }),
	      className: (0, _classnames2.default)('absolute-center', _styles2.default.empty),
	      icon: 'checked-list'
	    })
	  );
	}
	
	EmtpyHealthBoard.propTypes = {
	  intl: PropTypes.object
	};
	
	exports.default = (0, _reactIntl.injectIntl)(EmtpyHealthBoard);

/***/ }),
/* 3356 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CustomButtons = __webpack_require__(3357);
	
	var _CustomButtons2 = _interopRequireDefault(_CustomButtons);
	
	var _RedirectToMozzazButton = __webpack_require__(1759);
	
	var _RedirectToMozzazButton2 = _interopRequireDefault(_RedirectToMozzazButton);
	
	var _useIsMobile = __webpack_require__(3914);
	
	var _selectors = __webpack_require__(50);
	
	var _index = __webpack_require__(4995);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppointmentListWrapper = function AppointmentListWrapper(_ref) {
	  var actionText = _ref.actionText,
	      additionalAction = _ref.additionalAction,
	      buttonText = _ref.buttonText,
	      children = _ref.children,
	      formatMessage = _ref.formatMessage,
	      onClick = _ref.onClick,
	      title = _ref.title;
	
	  var customButtons = (0, _reactRedux.useSelector)(_selectors.selectAppCustomButtons);
	
	  var isMobile = (0, _useIsMobile.useIsMobile)();
	
	  var getCareButton = (0, _react.useMemo)(function () {
	    return Boolean(buttonText) ? _react2.default.createElement(
	      _Button2.default,
	      {
	        raised: true,
	        color: 'primary',
	        onClick: onClick,
	        className: (0, _classnames2.default)(_index2.default.getCareButton, (0, _defineProperty3.default)({}, _index2.default.mobileButton, isMobile))
	      },
	      buttonText
	    ) : null;
	  }, [customButtons, isMobile, buttonText, formatMessage]);
	
	  var renderCustomButtonsRowItems = (0, _react.useMemo)(function () {
	    var buttons = customButtons.filter(function (button) {
	      return !(0, _get2.default)(button, 'isInMenuBar');
	    });
	
	    if (!buttons.length) return null;
	
	    return _react2.default.createElement(_CustomButtons2.default, {
	      isMenuBar: false,
	      customButtons: buttons,
	      formatMessage: formatMessage,
	      isFullWidthButton: isMobile
	    });
	  }, [customButtons, isMobile, formatMessage]);
	
	  var renderCustomButtonsMenuItems = (0, _react.useMemo)(function () {
	    var isFullWidthButton = isMobile && !buttonText;
	
	    var menuButtons = customButtons.filter(function (button) {
	      return (0, _get2.default)(button, 'isInMenuBar');
	    });
	
	    if (!menuButtons.length) return null;
	
	    return _react2.default.createElement(_CustomButtons2.default, {
	      isMenuBar: true,
	      customButtons: menuButtons,
	      formatMessage: formatMessage,
	      isFullWidthButton: isFullWidthButton,
	      additionalButtonStyles: (0, _classnames2.default)((0, _defineProperty3.default)({}, _index2.default.mobileCustomButtons, isFullWidthButton))
	    });
	  }, [customButtons, isMobile, buttonText, formatMessage]);
	
	  var redirectToMozzazButton = (0, _react.useMemo)(function () {
	    return _react2.default.createElement(_RedirectToMozzazButton2.default, {
	      btnTitle: formatMessage({ id: 'other.goToMozzaz' })
	    });
	  }, [formatMessage]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    !isMobile ? renderCustomButtonsRowItems : null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      isMobile ? [_react2.default.createElement(
	        'div',
	        { className: _index2.default.mobileButtonsSection, key: '0'
	        },
	        getCareButton,
	        renderCustomButtonsMenuItems
	      ), isMobile ? renderCustomButtonsRowItems : null] : null,
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        _react2.default.createElement(
	          'h3',
	          { className: _index2.default.text },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { onClick: additionalAction, className: _index2.default.link },
	          actionText
	        )
	      ),
	      !isMobile ? _react2.default.createElement(
	        'div',
	        { className: _index2.default.buttonsSection },
	        redirectToMozzazButton,
	        getCareButton,
	        renderCustomButtonsMenuItems
	      ) : null,
	      isMobile ? redirectToMozzazButton : null
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      children
	    )
	  );
	};
	
	AppointmentListWrapper.propTypes = {
	  actionText: PropTypes.string,
	  additionalAction: PropTypes.func,
	  buttonText: PropTypes.string,
	  children: PropTypes.node,
	  formatMessage: PropTypes.func,
	  onClick: PropTypes.func,
	  title: PropTypes.string
	};
	
	exports.default = (0, _react.memo)(AppointmentListWrapper);

/***/ }),
/* 3357 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _getLinkProps3 = __webpack_require__(3358);
	
	var _index = __webpack_require__(4996);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomButtons = function CustomButtons(_ref) {
	  var _ref$additionalButton = _ref.additionalButtonStyles,
	      additionalButtonStyles = _ref$additionalButton === undefined ? '' : _ref$additionalButton,
	      customButtons = _ref.customButtons,
	      isFullWidthButton = _ref.isFullWidthButton,
	      formatMessage = _ref.formatMessage,
	      isMenuBar = _ref.isMenuBar;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var menuRef = (0, _react.useRef)(null);
	
	  var onButtonClick = function onButtonClick() {
	    setIsOpen(!isOpen);
	  };
	
	  var buttonAdditionalTitle = formatMessage({
	    id: 'healthboard.buttons.additionalResources'
	  });
	
	  (0, _react.useEffect)(function () {
	    var handleClickOutside = function handleClickOutside(event) {
	      if (menuRef.current && !menuRef.current.contains(event.target)) {
	        setIsOpen(false);
	      }
	    };
	
	    document.addEventListener('mousedown', handleClickOutside);
	    document.addEventListener('touchstart', handleClickOutside);
	    return function () {
	      document.removeEventListener('mousedown', handleClickOutside);
	      document.removeEventListener('touchstart', handleClickOutside);
	    };
	  }, []);
	
	  if (!customButtons.length) {
	    return null;
	  }
	
	  if (isMenuBar) {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_index2.default.buttonContainer, additionalButtonStyles),
	        ref: menuRef
	      },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'accent',
	          raised: true,
	          onClick: onButtonClick,
	          className: _index2.default.menuButton,
	          border: true
	        },
	        isFullWidthButton ? buttonAdditionalTitle : _react2.default.createElement(_Icon2.default, { name: 'three-dots-16', size: 16 })
	      ),
	      isOpen && _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.dropdownMenu, (0, _defineProperty3.default)({}, _index2.default.dropdownMenuFullWidth, isFullWidthButton))
	        },
	        customButtons.map(function (item) {
	          var _getLinkProps = (0, _getLinkProps3.getLinkProps)(item),
	              target = _getLinkProps.target,
	              href = _getLinkProps.href;
	
	          return _react2.default.createElement(
	            'a',
	            {
	              key: item.id,
	              href: href,
	              target: target,
	              rel: 'noopener noreferrer',
	              className: _index2.default.dropdownItem
	            },
	            item.name
	          );
	        })
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_index2.default.listItems, (0, _defineProperty3.default)({}, _index2.default.mobileList, isFullWidthButton))
	    },
	    customButtons.map(function (item) {
	      var _getLinkProps2 = (0, _getLinkProps3.getLinkProps)(item),
	          target = _getLinkProps2.target,
	          href = _getLinkProps2.href;
	
	      return _react2.default.createElement(
	        'a',
	        {
	          key: item.id,
	          href: href,
	          target: target,
	          rel: 'noopener noreferrer',
	          className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _index2.default.mobileButton, isFullWidthButton))
	        },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            raised: true,
	            color: 'primary',
	            className: (0, _classnames2.default)(_index2.default.listButton, (0, _defineProperty3.default)({}, _index2.default.mobileButton, isFullWidthButton))
	          },
	          item.name
	        )
	      );
	    })
	  );
	};
	
	CustomButtons.propTypes = {
	  additionalButtonStyles: PropTypes.string,
	  customButtons: PropTypes.array,
	  isFullWidthButton: PropTypes.bool,
	  isMenuBar: PropTypes.bool,
	  formatMessage: PropTypes.func
	};
	
	exports.default = CustomButtons;

/***/ }),
/* 3358 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LINK_TYPES = {
	  EMAIL: 'email',
	  PHONE: 'phone',
	  URL: 'url'
	};
	
	var getLinkProps = exports.getLinkProps = function getLinkProps(link) {
	  switch (link.linkType) {
	    case LINK_TYPES.EMAIL:
	      return { href: 'mailto:' + link.linkValue, target: '_self' };
	    case LINK_TYPES.PHONE:
	      return { href: 'tel:' + link.linkValue, target: '_blank' };
	    case LINK_TYPES.URL:
	    default:
	      return { href: link.linkValue, target: '_blank' };
	  }
	};

/***/ }),
/* 3359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(56);
	
	var _selectors3 = __webpack_require__(64);
	
	var _scheduledTasksUpcomingReq = __webpack_require__(303);
	
	var _scheduledTasksCompletedReq = __webpack_require__(534);
	
	var _appointmentsUpcommingReq = __webpack_require__(348);
	
	var _appointmentsHistoryReq = __webpack_require__(347);
	
	var _defaultTab = __webpack_require__(1372);
	
	var _ProviderAppointmentList = __webpack_require__(1761);
	
	var _ProviderAppointmentList2 = _interopRequireDefault(_ProviderAppointmentList);
	
	var _progress = __webpack_require__(121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    scheduleTasks: (0, _selectors3.selectScheduledTasks)(state),
	    scheduleTasksPending: (0, _selectors3.selectScheduledTasksPending)(state),
	    scheduleTasksCount: (0, _selectors3.selectScheduledTasksCount)(state),
	    loggedUserId: (0, _selectors.loggedUserIdSelector)(state),
	    dependentsList: (0, _selectors2.selectGuardianDependentsList)(state),
	    completedTasksCount: (0, _selectors3.selectScheduledCompletedTasksCount)(state),
	    appointmentLoading: (0, _selectors3.selectUpcomingAppointmentsPending)(state),
	    appointmentList: (0, _selectors3.selectUpcomingAppointmentList)(state),
	    upcomingAppointmentsCount: (0, _selectors3.selectUpcomingCount)(state),
	    historyAvailableUpcomingList: (0, _selectors3.selectMetaAvailableUpcomingList)(state),
	    historyAvailableScheduledTasks: (0, _selectors3.selectMetaAvailableScheduledTasks)(state),
	    historyAppointmentsCount: (0, _selectors3.selectHistoryCount)(state),
	    isProvider: (0, _selectors.hasProviderProfileSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchScheduledTasks: _scheduledTasksUpcomingReq.actions.send,
	  fetchCompletedTasks: _scheduledTasksCompletedReq.actions.send,
	  fetchUpcomingAppointments: _appointmentsUpcommingReq.actions.send,
	  fetchHistoryAppointments: _appointmentsHistoryReq.actions.send,
	  setTab: _defaultTab.actions.setTab,
	  setDependentSubmitRedirect: _progress.dependentFormActions.setSubmitRedirect
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var scheduleTasksPending = _ref.scheduleTasksPending,
	      loadingAnsweredSurveys = _ref.loadingAnsweredSurveys;
	  return {
	    pending: scheduleTasksPending || loadingAnsweredSurveys
	  };
	}), (0, _recompose.branch)(function (_ref2) {
	  var isProvider = _ref2.isProvider;
	  return isProvider;
	}, (0, _recompose.renderComponent)(_ProviderAppointmentList2.default)));

/***/ }),
/* 3360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isNull = __webpack_require__(732);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _ListWrapper = __webpack_require__(1750);
	
	var _ListWrapper2 = _interopRequireDefault(_ListWrapper);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _routes = __webpack_require__(37);
	
	var _utils = __webpack_require__(254);
	
	var _selectors = __webpack_require__(56);
	
	var _AppointmentList = __webpack_require__(1743);
	
	var _AppointmentList2 = _interopRequireDefault(_AppointmentList);
	
	var _constants = __webpack_require__(17);
	
	var _useCareUsers2 = __webpack_require__(1129);
	
	var _EmptyBlock = __webpack_require__(1745);
	
	var _EmptyBlock2 = _interopRequireDefault(_EmptyBlock);
	
	var _TodoList = __webpack_require__(1753);
	
	var _TodoList2 = _interopRequireDefault(_TodoList);
	
	var _enhance = __webpack_require__(3359);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	var _gtag = __webpack_require__(182);
	
	var _RedirectToMozzazButton = __webpack_require__(1759);
	
	var _RedirectToMozzazButton2 = _interopRequireDefault(_RedirectToMozzazButton);
	
	var _selectors2 = __webpack_require__(50);
	
	var _AppointmentListWrapper = __webpack_require__(3356);
	
	var _AppointmentListWrapper2 = _interopRequireDefault(_AppointmentListWrapper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HealthBoardHome(_ref) {
	  var appointmentList = _ref.appointmentList,
	      appointmentLoading = _ref.appointmentLoading,
	      completedTasksCount = _ref.completedTasksCount,
	      dependentsList = _ref.dependentsList,
	      fetchScheduledTasks = _ref.fetchScheduledTasks,
	      fetchUpcomingAppointments = _ref.fetchUpcomingAppointments,
	      historyAvailableScheduledTasks = _ref.historyAvailableScheduledTasks,
	      historyAvailableUpcomingList = _ref.historyAvailableUpcomingList,
	      loggedUserId = _ref.loggedUserId,
	      pending = _ref.pending,
	      scheduleTasks = _ref.scheduleTasks,
	      scheduleTasksCount = _ref.scheduleTasksCount,
	      setTab = _ref.setTab,
	      setDependentSubmitRedirect = _ref.setDependentSubmitRedirect,
	      upcomingAppointmentsCount = _ref.upcomingAppointmentsCount,
	      userId = _ref.userId,
	      formatMessage = _ref.intl.formatMessage;
	
	  var id = Number(userId);
	
	  var _useCareUsers = (0, _useCareUsers2.useCareUsers)(),
	      getTargetUser = _useCareUsers.getTargetUser;
	
	  var dependentStatus = (0, _reactRedux.useSelector)((0, _selectors.selectDependentStatusById)(id));
	  var isAppointmentSchedulingAllowed = (0, _reactRedux.useSelector)(_selectors2.selectAppointmentSchedulingAllowed);
	  var targetUser = getTargetUser(id);
	
	  (0, _usePageView.usePageView)('Home');
	  (0, _react.useEffect)(function () {
	    fetchUpcomingAppointments({ id: id, offset: 0, limit: 3 });
	    fetchScheduledTasks({ id: id, offset: 0, limit: 3 });
	  }, [userId]);
	
	  var _printListTitle = (0, _utils.printListTitle)({
	    upcomingCounter: scheduleTasksCount,
	    formatMessage: formatMessage,
	    upcomingTab: _constants.SURVEYS_LIST_TYPE.UPCOMING,
	    completedTab: _constants.SURVEYS_LIST_TYPE.RESULTS,
	    historyAvailable: historyAvailableScheduledTasks
	  }),
	      surveysActionText = _printListTitle.text,
	      todoTab = _printListTitle.tab;
	
	  var _printListTitle2 = (0, _utils.printListTitle)({
	    upcomingCounter: upcomingAppointmentsCount,
	    formatMessage: formatMessage,
	    historyAvailable: historyAvailableUpcomingList
	  }),
	      appointmentActionText = _printListTitle2.text;
	
	  var surveysEmptyBlockData = (0, _utils.getSurveyEmptyBlockData)(dependentStatus, scheduleTasksCount, completedTasksCount, formatMessage);
	
	  var handleAppointmentListActionClick = function handleAppointmentListActionClick() {
	    _browserHistory2.default.push(_routes.HEALTHBOARD + '/' + userId + '/' + _routes.HEALTHBOARD_APPOINTMENTS);
	  };
	
	  var getListTitle = function getListTitle(messageId) {
	    var prefix = id === loggedUserId ? formatMessage({ id: 'common.my' }) : (0, _utils.getFirstName)(targetUser);
	    return prefix + ' ' + formatMessage({ id: messageId });
	  };
	
	  var handleGetCare = function handleGetCare() {
	    setDependentSubmitRedirect(_constants.DEPENDENT_FORM_SUBMIT_REDIRECT.GET_CARE);
	    (0, _redirectUtils.redirectToUsers)(id, false);
	    (0, _gtag.GATrackCustomEvent)(_gtag.CustomEvents.GET_CARE_START);
	  };
	
	  var getButtonText = function getButtonText() {
	    if (id === loggedUserId) {
	      return isAppointmentSchedulingAllowed ? formatMessage({ id: 'appointments.seeAProvider' }) : null;
	    }
	
	    var activeDependent = dependentsList.find(function (_ref2) {
	      var dependent = _ref2.dependent;
	      return dependent.id === id;
	    });
	
	    var isAppointmentSchedulingAllowedMetadata = (0, _get2.default)(activeDependent, 'metadata.appointmentSchedulingAllowed', null);
	
	    if (!activeDependent && isAppointmentSchedulingAllowed) {
	      return formatMessage({ id: 'appointments.seeAProvider' });
	    }
	
	    return isAppointmentSchedulingAllowedMetadata ? formatMessage({ id: 'appointments.seeAProvider' }) : null;
	  };
	
	  var appointmentListTitle = (0, _react.useMemo)(function () {
	    var title = getListTitle('healthboard.title.appointments');
	
	    var counter = appointmentLoading ? null : upcomingAppointmentsCount;
	
	    var counterText = !(0, _isNull2.default)(counter) ? '(' + counter + ')' : '';
	
	    return title + ' ' + counterText;
	  }, [appointmentLoading, upcomingAppointmentsCount]);
	
	  if (!targetUser) return _react2.default.createElement(_Loader2.default, null);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'pl2 pr2 overflow-y-auto' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.home' }),
	    _react2.default.createElement(
	      _ListWrapper2.default,
	      {
	        title: getListTitle('chat.titles.activitiesChatTab'),
	        counter: pending ? null : scheduleTasksCount,
	        actionText: pending ? null : surveysActionText,
	        redirectTo: _routes.HEALTHBOARD + '/' + userId + '/' + _routes.HEALTHBOARD_TODO,
	        additionalAction: function additionalAction() {
	          return setTab(todoTab);
	        }
	      },
	      pending && _react2.default.createElement(_Loader2.default, { className: 'mt3' }),
	      !pending && (Boolean(scheduleTasksCount) ? _react2.default.createElement(_TodoList2.default, { list: scheduleTasks }) : _react2.default.createElement(_EmptyBlock2.default, (0, _extends3.default)({}, surveysEmptyBlockData, { className: 'mt3' })))
	    ),
	    _react2.default.createElement(
	      _AppointmentListWrapper2.default,
	      {
	        actionText: appointmentLoading ? null : appointmentActionText,
	        title: appointmentListTitle,
	        additionalAction: handleAppointmentListActionClick,
	        formatMessage: formatMessage,
	        onClick: handleGetCare,
	        buttonText: getButtonText(),
	        renderAdditionalButton: _react2.default.createElement(_RedirectToMozzazButton2.default, {
	          btnTitle: formatMessage({ id: 'other.goToMozzaz' })
	        })
	      },
	      _react2.default.createElement(_AppointmentList2.default, {
	        loading: appointmentLoading,
	        list: appointmentList,
	        id: userId,
	        isUpcoming: true
	      })
	    )
	  );
	}
	
	HealthBoardHome.propTypes = {
	  appointmentList: PropTypes.array,
	  appointmentLoading: PropTypes.bool,
	  completedTasksCount: PropTypes.number,
	  dependentsList: PropTypes.array,
	  fetchCompletedTasks: PropTypes.func,
	  fetchHistoryAppointments: PropTypes.func,
	  fetchScheduledTasks: PropTypes.func,
	  fetchUpcomingAppointments: PropTypes.func,
	  historyAvailableScheduledTasks: PropTypes.bool,
	  historyAvailableUpcomingList: PropTypes.bool,
	  intl: PropTypes.object,
	  loggedUserId: PropTypes.number,
	  pending: PropTypes.bool,
	  scheduleTasks: PropTypes.array,
	  scheduleTasksCount: PropTypes.number,
	  setTab: PropTypes.func,
	  setDependentSubmitRedirect: PropTypes.func,
	  targetUser: PropTypes.object,
	  upcomingAppointmentsCount: PropTypes.number,
	  userId: PropTypes.string
	};
	
	exports.default = (0, _enhance.enhance)(HealthBoardHome);

/***/ }),
/* 3361 */,
/* 3362 */,
/* 3363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var mapStateToProps = function mapStateToProps() {
	  return {
	    providerContextHistory: true
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, null));

/***/ }),
/* 3364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(1761);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _enhance = __webpack_require__(3363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _enhance.enhance)(_index2.default);

/***/ }),
/* 3365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _styles = __webpack_require__(4998);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _selectors = __webpack_require__(90);
	
	var _defaultTab = __webpack_require__(1372);
	
	var _selectors2 = __webpack_require__(64);
	
	var _scheduledTasksUpcomingReq = __webpack_require__(303);
	
	var _scheduledTasksCompletedReq = __webpack_require__(534);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    scheduleTasks: (0, _selectors2.selectScheduledTasks)(state),
	    scheduleTasksPending: (0, _selectors2.selectScheduledTasksPending)(state),
	    scheduleTasksCount: (0, _selectors2.selectScheduledTasksCount)(state),
	
	    completedTasks: (0, _selectors2.selectScheduledCompletedTasks)(state),
	    completedTasksPending: (0, _selectors2.selectScheduledCompletedTasksPending)(state),
	    completedTasksCount: (0, _selectors2.selectScheduledCompletedTasksCount)(state),
	    defaultTab: (0, _selectors.selectDefaultTabId)(state)
	  };
	};
	var mapDispatchToProps = {
	  fetchScheduledTasks: _scheduledTasksUpcomingReq.actions.send,
	  loadNextScheduledTasks: _scheduledTasksUpcomingReq.actions.loadMore,
	
	  fetchCompletedTasks: _scheduledTasksCompletedReq.actions.send,
	  loadNextCompletedTasks: _scheduledTasksCompletedReq.actions.loadMore,
	  resetTab: _defaultTab.actions.reset
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var userId = _ref.userId;
	  return {
	    id: userId
	  };
	}), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _constants = __webpack_require__(17);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _CommonTabs = __webpack_require__(255);
	
	var _TodoList = __webpack_require__(1753);
	
	var _TodoList2 = _interopRequireDefault(_TodoList);
	
	var _enhance = __webpack_require__(3365);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TodoListTabs(_ref) {
	  var resetTab = _ref.resetTab,
	      defaultTab = _ref.defaultTab,
	      scheduleTasks = _ref.scheduleTasks,
	      scheduleTasksPending = _ref.scheduleTasksPending,
	      scheduleTasksCount = _ref.scheduleTasksCount,
	      fetchScheduledTasks = _ref.fetchScheduledTasks,
	      loadNextScheduledTasks = _ref.loadNextScheduledTasks,
	      fetchCompletedTasks = _ref.fetchCompletedTasks,
	      completedTasks = _ref.completedTasks,
	      completedTasksPending = _ref.completedTasksPending,
	      completedTasksCount = _ref.completedTasksCount,
	      loadNextCompletedTasks = _ref.loadNextCompletedTasks,
	      id = _ref.id;
	
	  var _useState = (0, _react.useState)(defaultTab || _constants.SURVEYS_LIST_TYPE.UPCOMING),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  var tabs = useTabs(scheduleTasksCount, completedTasksCount);
	  var rootRef = (0, _react.useRef)();
	  var loadMore = (0, _react.useCallback)(function () {
	    if (activeTab === _constants.SURVEYS_LIST_TYPE.RESULTS) {
	      loadNextCompletedTasks({ id: id, limit: 10 });
	    }
	    if (activeTab === _constants.SURVEYS_LIST_TYPE.UPCOMING) {
	      loadNextScheduledTasks({ id: id });
	    }
	  }, [activeTab]);
	  (0, _usePageView.usePageView)('Home | Todo List');
	  (0, _useLazyLoad.useLazyLoad)({ node: rootRef, loadMore: loadMore, path: [] });
	  (0, _react.useEffect)(function () {
	    fetchScheduledTasks({ id: id, limit: 20, offset: 0 });
	    fetchCompletedTasks({ id: id, limit: 20, offset: 0 });
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      return resetTab();
	    };
	  }, []);
	
	  var contentData = function contentData(tab) {
	    switch (tab) {
	      case _constants.SURVEYS_LIST_TYPE.RESULTS:
	        return {
	          list: completedTasks,
	          loading: completedTasksPending,
	          isUpcoming: false
	        };
	      case _constants.SURVEYS_LIST_TYPE.UPCOMING:
	        return {
	          list: scheduleTasks,
	          loading: scheduleTasksPending,
	          isUpcoming: true
	        };
	      default:
	        return null;
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', ref: rootRef },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.homeTodos' }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'content' },
	      _react2.default.createElement(_CommonTabs.CommonTabs, {
	        onTabSelect: setActiveTab,
	        activeTab: activeTab,
	        tabList: tabs,
	        renderContent: function renderContent(tab) {
	          return _react2.default.createElement(_TodoList2.default, contentData(tab));
	        }
	      })
	    )
	  );
	}
	
	TodoListTabs.propTypes = {
	  intl: PropTypes.object,
	  resetTab: PropTypes.func,
	  scheduleTasks: PropTypes.array,
	  scheduleTasksCount: PropTypes.number,
	  scheduleTasksPending: PropTypes.bool,
	  fetchScheduledTasks: PropTypes.func,
	  loadNextScheduledTasks: PropTypes.func,
	  fetchCompletedTasks: PropTypes.func,
	  completedTasks: PropTypes.array,
	  completedTasksPending: PropTypes.bool,
	  completedTasksCount: PropTypes.number,
	  loadNextCompletedTasks: PropTypes.func,
	  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  defaultTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	};
	
	exports.default = (0, _enhance.enhance)(TodoListTabs);
	
	
	function useTabs(upcomingCounter, completedCounter) {
	  return (0, _react.useMemo)(function () {
	    return [{
	      label: 'general.todo',
	      tab: _constants.SURVEYS_LIST_TYPE.UPCOMING,
	      id: _constants.SURVEYS_LIST_TYPE.UPCOMING,
	      counter: upcomingCounter
	    }, {
	      label: 'general.completed',
	      tab: _constants.SURVEYS_LIST_TYPE.RESULTS,
	      id: _constants.SURVEYS_LIST_TYPE.RESULTS,
	      counter: completedCounter
	    }];
	  }, [upcomingCounter, completedCounter]);
	}

/***/ }),
/* 3367 */,
/* 3368 */,
/* 3369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.handleCheckin = handleCheckin;
	
	var _arrayModify = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleCheckin(state, payload) {
	  var target = state.list.find(function (_ref) {
	    var id = _ref.id;
	    return payload.id === id;
	  });
	
	  if (target) {
	    var status = payload.status,
	        allowedActions = payload.allowedActions;
	
	
	    return (0, _extends3.default)({}, state, {
	      list: (0, _arrayModify.findAndReplace)(state.list, (0, _extends3.default)({}, target, {
	        status: status,
	        allowedActions: allowedActions
	      }))
	    });
	  }
	
	  return state;
	}

/***/ }),
/* 3370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useAppointmentTitle = useAppointmentTitle;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _constants = __webpack_require__(17);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _providerDetailsFormatter = __webpack_require__(904);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useAppointmentTitle(_ref) {
	  var appointment = _ref.appointment,
	      providerView = _ref.providerView,
	      formatMessage = _ref.formatMessage,
	      detailsView = _ref.detailsView;
	
	  var code = (0, _get2.default)(appointment, 'visitType.code');
	  var location = (0, _get2.default)(appointment, 'location');
	  var serviceName = (0, _get2.default)(appointment, 'service.name');
	  var visitType = (0, _get2.default)(appointment, 'visitType.name', '');
	  var organization = (0, _get2.default)(appointment, 'organization', {});
	  var providerInfo = (0, _get2.default)(appointment, 'providerInfo');
	
	  switch (code) {
	    case _constants.AW_TYPE_CODE:
	      {
	        var i18n = 'healthboard.appointments.mobileAppAvailable';
	
	        return {
	          name: formatMessage({ id: i18n }),
	          metaText: serviceName,
	          noAvatar: true
	        };
	      }
	    case _constants.URGENT_CARE_TYPE_CODE:
	    case _constants.IMAGING_TYPE_CODE:
	    case _constants.LAB_TYPE_CODE:
	    case _constants.TECH_CONNECT_CODE:
	      {
	        return {
	          name: (0, _get2.default)(location, 'name'),
	          metaText: serviceName,
	          whiteAvatar: true,
	          avatar: {
	            thumbMin: (0, _get2.default)(organization, 'logo.thumbMin') || _brandConfig2.default.logoPath
	          }
	        };
	      }
	    case _constants.URGENT_VISIT_TYPE_CODE:
	      {
	        return {
	          name: providerInfo ? (0, _get2.default)(providerInfo, 'displayableName') : (0, _get2.default)(organization, 'name'),
	          avatar: providerInfo ? (0, _get2.default)(providerInfo, 'avatar') : {
	            thumbMin: (0, _get2.default)(organization, 'logo.thumbMin') || _brandConfig2.default.logoPath
	          },
	          metaText: visitType,
	          whiteAvatar: (0, _isEmpty2.default)(providerInfo)
	        };
	      }
	    /**
	     * All other appointment types
	     * */
	    default:
	      {
	        var provider = (0, _get2.default)(appointment, 'providerInfo', {});
	        var metaText = providerView ? '' : (0, _providerDetailsFormatter.fullProviderSubtitle)((0, _extends3.default)({}, provider, { location: location }));
	        var name = (0, _get2.default)(provider, 'name');
	        var avatar = (0, _get2.default)(provider, 'avatar');
	
	        if (providerView) {
	          var patient = (0, _get2.default)(appointment, 'patientUserInfo');
	          var username = (0, _get2.default)(patient, 'username');
	          name = (0, _get2.default)(patient, 'displayableName') || username;
	          avatar = (0, _get2.default)(patient, 'avatar');
	          provider = { name: name, avatar: avatar };
	        }
	
	        return {
	          name: detailsView ? (0, _providerDetailsFormatter.transformProviderNameWithTitle)(provider).name : name,
	          avatar: avatar,
	          metaText: metaText
	        };
	      }
	  }
	}

/***/ }),
/* 3371 */,
/* 3372 */,
/* 3373 */,
/* 3374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _IconButton = __webpack_require__(605);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5004);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PopoverContent(_ref) {
	  var list = _ref.list,
	      description = _ref.description,
	      onClose = _ref.onClose;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'content', onClick: function onClick(event) {
	        return event.stopPropagation();
	      } },
	    _react2.default.createElement(_IconButton.IconButton, {
	      styleName: 'close',
	      name: 'close',
	      size: 16,
	      fill: _styles.COLORS.fontLighter,
	      onClick: onClose
	    }),
	    !(0, _isEmpty2.default)(list) ? list.map(function (row) {
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'row', key: Math.random() },
	        row.map(function (_ref2) {
	          var title = _ref2.title,
	              subtitle = _ref2.subtitle;
	          return _react2.default.createElement(
	            'div',
	            { styleName: 'item', key: title },
	            _react2.default.createElement(
	              'p',
	              { styleName: 'title' },
	              title
	            ),
	            _react2.default.createElement(
	              'p',
	              { styleName: 'subtitle' },
	              subtitle
	            )
	          );
	        })
	      );
	    }) : null,
	    Boolean(description) ? _react2.default.createElement(
	      'div',
	      { styleName: 'row' },
	      _react2.default.createElement(
	        'p',
	        { styleName: 'subtitle' },
	        description
	      )
	    ) : null
	  );
	}
	
	PopoverContent.propTypes = {
	  list: _propTypes2.default.array,
	  onClose: _propTypes2.default.func,
	  description: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(PopoverContent, _index2.default, { allowMultiple: true });

/***/ }),
/* 3375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	var _react = __webpack_require__(1);
	
	var _utils = __webpack_require__(1131);
	
	var _utils2 = __webpack_require__(78);
	
	var _dateConverters = __webpack_require__(83);
	
	var _useGenderOptions2 = __webpack_require__(1860);
	
	var _useGenderOptions3 = _interopRequireDefault(_useGenderOptions2);
	
	var _useInsuranceRelationOptions = __webpack_require__(621);
	
	var _useInsuranceRelationOptions2 = _interopRequireDefault(_useInsuranceRelationOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useInsuranceInfo = function useInsuranceInfo() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _useGenderOptions = (0, _useGenderOptions3.default)(formatMessage),
	      getGenderTitleByValue = _useGenderOptions.getGenderTitleByValue;
	
	  var _useInsuranceRelation = (0, _useInsuranceRelationOptions2.default)(),
	      hideInsuranceRelationFieldOrInfo = _useInsuranceRelation.hideInsuranceRelationFieldOrInfo,
	      getInsuranceRelationTitleById = _useInsuranceRelation.getInsuranceRelationTitleById;
	
	  var getPayerAndVerificationDate = (0, _react.useCallback)(function (_ref, flowType) {
	    var payer = _ref.payer,
	        createdAt = _ref.createdAt,
	        isVerified = _ref.isVerified;
	    var isAdditionalInsurance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var skipInsurance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    var isPaperworkFlowType = (0, _utils.checkIsPaperworkFlow)(flowType);
	
	    var ignoreValues = skipInsurance && !isAdditionalInsurance && isPaperworkFlowType;
	
	    var data = [{
	      label: formatMessage({
	        id: 'profile.section.insurance.healthPlan'
	      }),
	      value: ignoreValues ? undefined : payer && (0, _get2.default)(payer, 'name')
	    }];
	
	    if (!isPaperworkFlowType && !isAdditionalInsurance) {
	      data.push({
	        label: formatMessage({
	          id: 'profile.section.insurance.verificationDate'
	        }),
	        value: ignoreValues ? undefined : createdAt && isVerified && (0, _utils2.formatDate)(createdAt, 'MMM D, Y')
	      });
	    }
	
	    return data;
	  }, []);
	
	  var getMemberIdAndGroupNumber = (0, _react.useCallback)(function (_ref2, flowType) {
	    var memberId = _ref2.memberId,
	        groupNumber = _ref2.groupNumber;
	    var isAdditionalInsurance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var skipInsurance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    var isPaperworkFlowType = (0, _utils.checkIsPaperworkFlow)(flowType);
	
	    var ignoreValues = skipInsurance && !isAdditionalInsurance && isPaperworkFlowType;
	
	    return [{
	      label: formatMessage({ id: 'fields.insurance.memberId' }),
	      value: ignoreValues ? undefined : memberId
	    }, {
	      label: formatMessage({ id: 'fields.insurance.groupNumber' }),
	      value: ignoreValues ? undefined : groupNumber
	    }];
	  }, []);
	
	  var getPrimarySubscriberMainData = (0, _react.useCallback)(function (_ref3) {
	    var primarySubscriber = _ref3.primarySubscriber;
	
	    if (!primarySubscriber) return [];
	
	    var _ref4 = primarySubscriber || {},
	        dob = _ref4.dob,
	        firstName = _ref4.firstName,
	        lastName = _ref4.lastName,
	        phoneNumber = _ref4.phoneNumber,
	        gender = _ref4.gender,
	        insuranceRelationId = _ref4.insuranceRelationId;
	
	    var data = [{
	      label: formatMessage({
	        id: 'profile.fields.name'
	      }),
	      value: ((firstName || '') + ' ' + (lastName || '')).trim()
	    }, {
	      label: formatMessage({
	        id: 'profile.fields.dob'
	      }),
	      value: (0, _dateConverters.formatToMonthDayYear)(dob)
	    }, {
	      label: formatMessage({ id: 'common.phoneNumber' }),
	      value: phoneNumber
	    }, {
	      label: formatMessage({
	        id: 'profile.fields.gender'
	      }),
	      value: getGenderTitleByValue(gender)
	    }];
	
	    if (!hideInsuranceRelationFieldOrInfo) {
	      data.push({
	        label: formatMessage({
	          id: 'profile.fields.relationship'
	        }),
	        value: getInsuranceRelationTitleById(insuranceRelationId)
	      });
	    }
	
	    return data;
	  }, [hideInsuranceRelationFieldOrInfo]);
	
	  var getPrimarySubscriberAddressData = (0, _react.useCallback)(function (_ref5) {
	    var primarySubscriber = _ref5.primarySubscriber;
	
	    if (!primarySubscriber) return [];
	
	    var address1 = primarySubscriber.address1,
	        address2 = primarySubscriber.address2,
	        city = primarySubscriber.city,
	        state = primarySubscriber.state,
	        postalCode = primarySubscriber.postalCode;
	
	
	    return [{
	      label: formatMessage({
	        id: 'profile.fields.address1'
	      }),
	      value: address1
	    }, {
	      label: formatMessage({
	        id: 'profile.fields.address2'
	      }),
	      value: address2
	    }, {
	      label: formatMessage({ id: 'profile.fields.city' }),
	      value: city
	    }, {
	      label: formatMessage({ id: 'profile.fields.onlyState' }),
	      value: state
	    }, {
	      label: formatMessage({ id: 'profile.fields.postalCode' }),
	      value: postalCode
	    }];
	  }, []);
	
	  return {
	    getPayerAndVerificationDate: getPayerAndVerificationDate,
	    getMemberIdAndGroupNumber: getMemberIdAndGroupNumber,
	    getPrimarySubscriberAddressData: getPrimarySubscriberAddressData,
	    getPrimarySubscriberMainData: getPrimarySubscriberMainData
	  };
	};
	
	exports.default = useInsuranceInfo;

/***/ }),
/* 3376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(18);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(2252);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InvitationButton(_ref) {
	  var onClick = _ref.onClick,
	      formatMessage = _ref.formatMessage;
	
	  return _react2.default.createElement(
	    _Button2.default,
	    { color: 'accent', onClick: onClick, className: _index2.default.button },
	    _react2.default.createElement(_Icon2.default, {
	      name: 'assign-blue',
	      size: 24,
	      style: { fill: _styles.COLORS.blueAccent },
	      className: 'mr1'
	    }),
	    _react2.default.createElement(
	      'span',
	      { className: _index2.default.buttonText },
	      formatMessage({ id: 'dialog.common.invitePerson' })
	    )
	  );
	}
	
	InvitationButton.propTypes = {
	  onClick: _propTypes2.default.func,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = InvitationButton;

/***/ }),
/* 3377 */,
/* 3378 */,
/* 3379 */,
/* 3380 */,
/* 3381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LanguageProvider = function LanguageProvider(_ref) {
	  var locale = _ref.locale,
	      messages = _ref.messages,
	      children = _ref.children;
	  return _react2.default.createElement(
	    _reactIntl.IntlProvider,
	    { locale: locale, key: locale, messages: messages[locale] },
	    _react2.default.Children.only(children)
	  );
	};
	
	LanguageProvider.propTypes = {
	  locale: _propTypes2.default.string,
	  messages: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.element.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    locale: (0, _selectors.uiLocaleSelector)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(LanguageProvider);

/***/ }),
/* 3382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Header = __webpack_require__(3295);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Overlay = __webpack_require__(3428);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _selectors = __webpack_require__(90);
	
	var _GlobalImageViewer = __webpack_require__(3860);
	
	var _GlobalImageViewer2 = _interopRequireDefault(_GlobalImageViewer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainLayout = function MainLayout(_ref) {
	  var children = _ref.children,
	      theme = _ref.theme;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('MainLayout', (0, _defineProperty3.default)({}, theme, theme)) },
	    children,
	    _react2.default.createElement(_Overlay2.default, null),
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(_GlobalImageViewer2.default, null)
	  );
	};
	
	MainLayout.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  theme: _propTypes2.default.string
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    theme: (0, _selectors.selectTheme)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(MainLayout);

/***/ }),
/* 3383 */,
/* 3384 */,
/* 3385 */,
/* 3386 */,
/* 3387 */,
/* 3388 */,
/* 3389 */,
/* 3390 */,
/* 3391 */,
/* 3392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _dateConverters = __webpack_require__(83);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _GroupAvatar = __webpack_require__(3105);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _Badge = __webpack_require__(604);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _StatusIndicator = __webpack_require__(3883);
	
	var _StatusIndicator2 = _interopRequireDefault(_StatusIndicator);
	
	var _props5 = __webpack_require__(41);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5011);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _chat = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListItem = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(ListItem, _PureComponent);
	
	  function ListItem() {
	    (0, _classCallCheck3.default)(this, ListItem);
	    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'createAvatar',
	    value: function createAvatar(params) {
	      var _ref = params || {},
	          size = _ref.size,
	          withStatus = _ref.withStatus;
	
	      var active = this.props.active;
	      var _contextUser = this.contextUser,
	          avatar = _contextUser.avatar,
	          displayableName = _contextUser.displayableName,
	          status = _contextUser.status;
	
	      var pending = status === _props5.DEPENDENT_STATUSES.PENDING;
	      var unverified = status === _props5.DEPENDENT_STATUSES.UNVERIFIED;
	
	      var _contextChannel = this.contextChannel,
	          channelAvatar = _contextChannel.avatar,
	          channelName = _contextChannel.channelName,
	          type = _contextChannel.type,
	          blocked = _contextChannel.blocked;
	
	
	      var blockedStyle = blocked ? 'o-50' : '';
	
	      var avatarComponent = _react2.default.createElement(_SimpleAvatar2.default, {
	        size: size,
	        bordered: active,
	        waiting: pending,
	        disabled: unverified,
	        unverified: unverified,
	        text: displayableName || channelName,
	        src: (0, _get3.default)(avatar, 'thumbMin') || (0, _get3.default)(channelAvatar, 'thumbMin')
	      });
	
	      var iconComponent = _react2.default.createElement(_GroupAvatar2.default, (0, _extends3.default)({
	        className: blockedStyle
	      }, {
	        active: active,
	        iconName: 'chat-group',
	        iconSize: 20,
	        width: 32,
	        height: 32
	      }));
	
	      if (withStatus && status) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'relative' },
	          avatarComponent,
	          _react2.default.createElement(_StatusIndicator2.default, { active: active, status: status })
	        );
	      }
	
	      return type === 'group' ? iconComponent : avatarComponent;
	    }
	  }, {
	    key: 'createUnreadBadge',
	    value: function createUnreadBadge(params) {
	      var _ref2 = params || {},
	          colored = _ref2.colored;
	
	      var _props = this.props,
	          unreadCount = _props.unreadCount,
	          minimized = _props.minimized;
	
	
	      if (!unreadCount) return null;
	
	      return _react2.default.createElement(_Badge2.default, (0, _extends3.default)({ large: !minimized }, { colored: colored }, { text: unreadCount }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          active = _props2.active,
	          minimized = _props2.minimized,
	          _onClick = _props2.onClick;
	      var id = this.contextUser.id;
	      var _contextChannel2 = this.contextChannel,
	          channelId = _contextChannel2.channelId,
	          type = _contextChannel2.type;
	      // manage global navigation list styles
	
	      var className = (0, _classnames2.default)({
	        'g-navLink': !minimized,
	        'g-navLink--active': !minimized && active
	      });
	
	      // manage custom minimized navigation list styles
	      var styleName = (0, _classnames2.default)({
	        'item--minimized': minimized,
	        'item--active': minimized && active
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-id': id || channelId },
	        _react2.default.createElement(
	          _Link2.default,
	          (0, _extends3.default)({ className: className, styleName: styleName }, {
	            onClick: function onClick() {
	              return _onClick(id || channelId, type);
	            }
	          }),
	          this.itemBody
	        )
	      );
	    }
	  }, {
	    key: 'contextUser',
	    get: function get() {
	      return (0, _get3.default)(this.props, 'contextUser', {});
	    }
	  }, {
	    key: 'contextChannel',
	    get: function get() {
	      return (0, _get3.default)(this.props, 'contextChannel', {});
	    }
	  }, {
	    key: 'lastMessageTime',
	    get: function get() {
	      var _props3 = this.props,
	          lastMessageAt = _props3.lastMessageAt,
	          formatMessage = _props3.intl.formatMessage;
	
	
	      if (!lastMessageAt) return null;
	
	      return (0, _dateConverters.getLastMessageTime)(lastMessageAt, formatMessage);
	    }
	  }, {
	    key: 'userData',
	    get: function get() {
	      var intro = this.props.intro;
	      var displayableName = this.contextUser.displayableName;
	
	
	      return {
	        primary: displayableName,
	        complementary: this.lastMessageTime,
	        intro: intro
	      };
	    }
	  }, {
	    key: 'channelData',
	    get: function get() {
	      var channelName = this.contextChannel.channelName;
	
	
	      return {
	        primary: channelName,
	        complementary: this.lastMessageTime
	      };
	    }
	  }, {
	    key: 'rightControls',
	    get: function get() {
	      var _props4 = this.props,
	          active = _props4.active,
	          unreadCount = _props4.unreadCount;
	
	
	      if (!active && !unreadCount) return null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'flex items-center' },
	        this.createUnreadBadge()
	      );
	    }
	  }, {
	    key: 'expandedItem',
	    get: function get() {
	      var id = this.contextUser.id;
	      var _contextChannel3 = this.contextChannel,
	          channelId = _contextChannel3.channelId,
	          blocked = _contextChannel3.blocked;
	      var active = this.props.active;
	
	      var styleName = (0, _classnames2.default)('card', { 'card--active': active });
	
	      var iconContext = this.props.contextUser ? [_chat.CONTEXT_CHAT_ICON] : null;
	      var iconBlockChat = blocked ? [_chat.ICON_BLOCK] : null;
	
	      return _react2.default.createElement(_Card2.default, {
	        additionalIcons: iconContext || iconBlockChat,
	        className: 'pa2 user-status--card',
	        styleName: styleName,
	        userId: id || channelId,
	        text: id ? this.userData : this.channelData,
	        additionalContent: {
	          left: this.createAvatar({ size: 32 }),
	          right: this.rightControls
	        }
	      });
	    }
	  }, {
	    key: 'minimizedItem',
	    get: function get() {
	      var patientPortalContext = this.props.patientPortalContext;
	
	      return patientPortalContext ? _react2.default.createElement(
	        'div',
	        { styleName: 'avatar__wrapper' },
	        this.createAvatar({ size: 36 })
	      ) : _react2.default.createElement(
	        'div',
	        { styleName: 'avatar__wrapper' },
	        this.createAvatar({ size: 32 }),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'badge__wrapper' },
	          this.createUnreadBadge({ colored: true })
	        )
	      );
	    }
	  }, {
	    key: 'itemBody',
	    get: function get() {
	      if (this.props.minimized) {
	        return this.minimizedItem;
	      }
	
	      return this.expandedItem;
	    }
	  }]);
	  return ListItem;
	}(_react.PureComponent), _class2.propTypes = {
	  active: _propTypes2.default.bool,
	  contextUser: _propTypes2.default.shape({
	    // eslint-disable-line react/no-unused-prop-types
	    avatar: _propTypes2.default.objectOf(_propTypes2.default.string),
	    displayableName: _propTypes2.default.string,
	    id: _propTypes2.default.number,
	    status: _propTypes2.default.string
	  }),
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  intro: _propTypes2.default.string,
	  lastMessageAt: _propTypes2.default.string,
	  minimized: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  unreadCount: _propTypes2.default.number,
	  patientPortalContext: _propTypes2.default.bool
	}, _temp)) || _class) || _class);
	exports.default = ListItem;

/***/ }),
/* 3393 */,
/* 3394 */,
/* 3395 */,
/* 3396 */,
/* 3397 */,
/* 3398 */,
/* 3399 */,
/* 3400 */,
/* 3401 */,
/* 3402 */,
/* 3403 */,
/* 3404 */,
/* 3405 */,
/* 3406 */,
/* 3407 */,
/* 3408 */,
/* 3409 */,
/* 3410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _index = __webpack_require__(5016);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResendButton = function ResendButton(_ref) {
	  var intl = _ref.intl,
	      onResend = _ref.onResend,
	      _ref$counterValue = _ref.counterValue,
	      counterValue = _ref$counterValue === undefined ? 30 : _ref$counterValue,
	      _ref$customCounterTex = _ref.customCounterText,
	      customCounterText = _ref$customCounterTex === undefined ? '' : _ref$customCounterTex;
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      counter = _useState2[0],
	      setCounter = _useState2[1];
	
	  var formatMessage = intl.formatMessage;
	
	
	  var handleResend = function handleResend() {
	    onResend();
	    setCounter(counterValue);
	  };
	
	  var counterText = (0, _react.useMemo)(function () {
	    if (counter === 0) {
	      return _react2.default.createElement(
	        'div',
	        { onClick: handleResend, className: _index2.default.resend },
	        formatMessage({ id: 'common.resendCode' })
	      );
	    }
	
	    if (customCounterText) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        formatMessage({ id: customCounterText }, { counter: counter })
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      formatMessage({ id: 'mfa.dialog.resendCode' }, { counter: counter })
	    );
	  }, [counter, customCounterText]);
	
	  (0, _react.useEffect)(function () {
	    var timer = null;
	    if (counter > 0) {
	      timer = setTimeout(function () {
	        return setCounter(counter - 1);
	      }, 1000);
	    }
	
	    return function () {
	      return clearTimeout(timer);
	    };
	  }, [counter]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    counterText
	  );
	};
	
	ResendButton.propTypes = {
	  counterValue: _propTypes2.default.number,
	  customCounterText: _propTypes2.default.string,
	  intl: _propTypes2.default.object,
	  onResend: _propTypes2.default.func
	};
	
	exports.default = (0, _reactIntl.injectIntl)(ResendButton);

/***/ }),
/* 3411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _popup = __webpack_require__(76);
	
	var _mfaNotice = __webpack_require__(1329);
	
	var _routes = __webpack_require__(37);
	
	var _selectors = __webpack_require__(23);
	
	var _index = __webpack_require__(5018);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MfaNoticeDialog = function MfaNoticeDialog(_ref) {
	  var intl = _ref.intl;
	  var formatMessage = intl.formatMessage;
	
	  var targetUserId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handleSkip = function handleSkip() {
	    dispatch(_mfaNotice.actions.send());
	    dispatch((0, _popup.hideMobileAppPopup)());
	  };
	  var handleRedirect = function handleRedirect() {
	    _reactRouter.browserHistory.push('/' + _routes.PROFILE + '/' + targetUserId + '/' + _routes.PROFILE_SETTINGS);
	    dispatch((0, _popup.hideMobileAppPopup)());
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.iconWrapper },
	      _react2.default.createElement(_Icon2.default, { name: 'lock', size: 48 })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      formatMessage({ id: 'mfa.dialog.advert.title' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.contentText },
	      formatMessage({ id: 'mfa.dialog.advert.contentText' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.actions },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: handleRedirect,
	          color: 'primary',
	          raised: true,
	          className: _index2.default.button
	        },
	        formatMessage({ id: 'mfa.dialog.activate.button' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'accent',
	          raised: true,
	          onClick: handleSkip,
	          className: _index2.default.button
	        },
	        formatMessage({ id: 'common.skip' })
	      )
	    )
	  );
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MfaNoticeDialog);

/***/ }),
/* 3412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useMobileInput = useMobileInput;
	
	var _reactRedux = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isObject = __webpack_require__(139);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _selectors = __webpack_require__(50);
	
	var _selectors2 = __webpack_require__(56);
	
	var _selectors3 = __webpack_require__(167);
	
	var _countryCode = __webpack_require__(1322);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_CODE = '+1';
	
	function useMobileInput(phoneValue, formatMessage, phoneCode) {
	  var userPhoneNumberCountryCode = (0, _reactRedux.useSelector)(_selectors2.selectUserPhoneNumberCountryCode);
	  var userPhoneNumberCountryISOCode = (0, _reactRedux.useSelector)(_selectors2.selectUserPhoneNumberCountryISOCode);
	  var dependentPhoneNumberCountryCode = (0, _reactRedux.useSelector)(_selectors3.selectDependentPhoneNumberCountryCode);
	  var patientPhoneNumberCountryIsoCode = (0, _reactRedux.useSelector)(_selectors2.selectPatientPhoneNumberCountryIsoCode);
	  var countryList = (0, _reactRedux.useSelector)(_selectors.selectCountryList);
	
	  var adaptInitialValueCountryCodeByIsoCode = function adaptInitialValueCountryCodeByIsoCode(isoCode) {
	    var target = countryList.find(function (item) {
	      return (0, _get2.default)(item, 'isoCode', '') === isoCode;
	    });
	    return target ? target.phone.countryCode : '';
	  };
	
	  var handleSetInitialValuePhoneNumber = function handleSetInitialValuePhoneNumber(value, code) {
	    return value ? value.replace(code || adaptInitialValueCountryCodeByIsoCode(patientPhoneNumberCountryIsoCode) || dependentPhoneNumberCountryCode || userPhoneNumberCountryCode || DEFAULT_CODE, '') : '';
	  };
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var countryPhoneSettings = (0, _reactRedux.useSelector)(_selectors.selectCountryPhoneSettings);
	
	  var _useState = (0, _react.useState)(phoneCode || adaptInitialValueCountryCodeByIsoCode(patientPhoneNumberCountryIsoCode) || dependentPhoneNumberCountryCode || userPhoneNumberCountryCode || DEFAULT_CODE),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      code = _useState2[0],
	      setCode = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(handleSetInitialValuePhoneNumber(phoneValue, phoneCode) || ''),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      phone = _useState4[0],
	      setPhone = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    if (phoneValue && !phone) {
	      setPhone(handleSetInitialValuePhoneNumber(phoneValue, phoneCode));
	    }
	  }, [phoneValue]);
	
	  (0, _react.useEffect)(function () {
	    if (dependentPhoneNumberCountryCode && phoneValue) {
	      setCode(dependentPhoneNumberCountryCode);
	      dispatch(_countryCode.actions.set(handleSetCountryIsoCode(dependentPhoneNumberCountryCode)));
	    }
	  }, [dependentPhoneNumberCountryCode]);
	
	  var handleSetCountryIsoCode = (0, _react.useMemo)(function () {
	    return function (data) {
	      if ((0, _isObject2.default)(data)) return data.isoCode;
	      var target = countryList.find(function (item) {
	        if (patientPhoneNumberCountryIsoCode) {
	          return (0, _get2.default)(item, 'isoCode', '') === patientPhoneNumberCountryIsoCode;
	        }
	        return (0, _get2.default)(item, 'phone.countryCode', '') === data && ((0, _get2.default)(item, 'isoCode', '') === dependentPhoneNumberCountryCode || (0, _get2.default)(item, 'isoCode', '') === userPhoneNumberCountryISOCode);
	      });
	      return target ? target.isoCode : '';
	    };
	  }, [code, countryList]);
	
	  var codeOptions = (0, _react.useMemo)(function () {
	    return countryList.map(function (_ref) {
	      var isoCode = _ref.isoCode,
	          name = _ref.name,
	          countryCode = _ref.phone.countryCode;
	      return {
	        label: countryCode + ' ' + name,
	        value: { isoCode: isoCode, countryCode: countryCode }
	      };
	    });
	  }, [countryList]);
	
	  var handleCodeChange = (0, _react.useCallback)(function (_ref2) {
	    var value = _ref2.value;
	
	    setCode(value.countryCode);
	  }, []);
	
	  var limit = (0, _react.useMemo)(function () {
	    var match = countryPhoneSettings.find(function (_ref3) {
	      var countryCode = _ref3.countryCode;
	      return countryCode === code;
	    });
	
	    return match ? match.numberLength : 8;
	  }, [code, countryPhoneSettings]);
	
	  var handlePhoneChange = (0, _react.useCallback)(function (value) {
	    setPhone(value);
	  }, []);
	
	  var validate = (0, _react.useCallback)(function (value) {
	    var errors = null;
	    if (value.length === 0) return null;
	    if (value.length > limit) errors = [formatMessage({ id: 'profile.fields.mobilePhone.validation.long' })];
	    if (value.length < limit) errors = [formatMessage({ id: 'profile.fields.mobilePhone.validation.short' })];
	
	    return errors;
	  }, [limit]);
	
	  return {
	    codeControl: {
	      options: codeOptions,
	      handleSetCountryIsoCode: handleSetCountryIsoCode,
	      handleCodeChange: handleCodeChange,
	      code: code
	    },
	    phoneControl: {
	      handlePhoneChange: handlePhoneChange,
	      phone: phone
	    },
	    validation: {
	      validate: validate,
	      limit: limit
	    }
	  };
	}

/***/ }),
/* 3413 */,
/* 3414 */,
/* 3415 */,
/* 3416 */,
/* 3417 */,
/* 3418 */,
/* 3419 */,
/* 3420 */,
/* 3421 */,
/* 3422 */,
/* 3423 */,
/* 3424 */,
/* 3425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ContentArea = __webpack_require__(155);
	
	var _ContentArea2 = _interopRequireDefault(_ContentArea);
	
	var _Content = __webpack_require__(214);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFound = function NotFound() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'g-content' },
	    _react2.default.createElement(
	      _ContentArea2.default,
	      null,
	      _react2.default.createElement(
	        _Content2.default,
	        { empty: true },
	        _react2.default.createElement(_Icon2.default, { name: '404', size: 194, className: 'mb4' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'mh2 tc ttc f3 lh-copy' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.ERROR_404)
	        )
	      )
	    )
	  );
	};
	
	exports.default = NotFound;

/***/ }),
/* 3426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SimpleInfoPopup = __webpack_require__(795);
	
	var _SimpleInfoPopup2 = _interopRequireDefault(_SimpleInfoPopup);
	
	var _sendInvitationReq = __webpack_require__(806);
	
	var sendUserInvitation = _interopRequireWildcard(_sendInvitationReq);
	
	var _selectors = __webpack_require__(93);
	
	var _index = __webpack_require__(213);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvitationModal = function InvitationModal(_ref) {
	  var formatMessage = _ref.formatMessage,
	      opened = _ref.opened,
	      handleCloseInvitationModal = _ref.handleCloseInvitationModal,
	      loginValue = _ref.loginValue;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var sendInvitationSucceed = (0, _reactRedux.useSelector)(_selectors.selectSendInvitationSucceed);
	  var sendInvitationPending = (0, _reactRedux.useSelector)(_selectors.selectSendInvitationPending);
	  var isError = (0, _reactRedux.useSelector)(_selectors.selectSendInvitationError);
	
	  var handleInvitation = function handleInvitation() {
	    dispatch(sendUserInvitation.actions.send({ user: { login: loginValue } }));
	  };
	
	  return _react2.default.createElement(
	    _SimpleInfoPopup2.default,
	    {
	      messageId: 'auth.sendOtp.inviteNotConfirmed',
	      icon: 'icon-plane',
	      opened: opened,
	      width: 'rubber',
	      withHeading: false,
	      mobileFullScreen: false,
	      dialogClassName: 'w-100',
	      autoHeight: true
	    },
	    isError ? _react2.default.createElement(_ErrorBlock2.default, {
	      errors: formatMessage({ id: 'errors.common' }),
	      className: (0, _classnames2.default)(_index2.default.errorBlock, 'mt3')
	    }) : null,
	    _react2.default.createElement(
	      'div',
	      { className: 'df justify-center mt4' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: handleInvitation,
	          color: 'primary',
	          raised: true,
	          disabled: sendInvitationPending || sendInvitationSucceed,
	          className: 'w-50'
	        },
	        formatMessage({ id: 'common.resendInvite' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          onClick: handleCloseInvitationModal,
	          color: 'primary',
	          raised: true,
	          className: 'ml2 w-50'
	        },
	        formatMessage({ id: 'submit.expiredToken' })
	      )
	    )
	  );
	};
	
	InvitationModal.propTypes = {
	  formatMessage: _propTypes2.default.func,
	  opened: _propTypes2.default.bool,
	  handleCloseInvitationModal: _propTypes2.default.func,
	  loginValue: _propTypes2.default.string
	};
	
	exports.default = InvitationModal;

/***/ }),
/* 3427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(50);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _index = __webpack_require__(5021);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _MfaDialog = __webpack_require__(1132);
	
	var _MfaDialog2 = _interopRequireDefault(_MfaDialog);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _login = __webpack_require__(402);
	
	var login = _interopRequireWildcard(_login);
	
	var _selectors2 = __webpack_require__(93);
	
	var _validations = __webpack_require__(81);
	
	var _loginValidator = __webpack_require__(1393);
	
	var _loginValidator2 = _interopRequireDefault(_loginValidator);
	
	var _optAuthCodes = __webpack_require__(1280);
	
	var _defaultValidator = __webpack_require__(700);
	
	var _InvitationModal = __webpack_require__(3426);
	
	var _InvitationModal2 = _interopRequireDefault(_InvitationModal);
	
	var _errors = __webpack_require__(120);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INIT_INVITATION_MODAL_DATA = {
	  showInvitationModal: false,
	  loginValue: ''
	};
	
	var INIT_OTP_ERROR_DATA = {
	  error: false,
	  errorText: ''
	};
	
	var HTTP_STATUS_TOO_MANY_REQUESTS = 429;
	var HTTP_STATUS_UNAUTHORIZED = 401;
	var HTTP_STATUS_LOCKED = 403;
	
	var OtpModal = function OtpModal(_ref) {
	  var open = _ref.open,
	      formatMessage = _ref.formatMessage,
	      onClose = _ref.onClose,
	      setIsAnyOfOtpPathModalsOpen = _ref.setIsAnyOfOtpPathModalsOpen;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      fieldValue = _useState2[0],
	      setFieldValue = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      fieldError = _useState4[0],
	      setFieldError = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(INIT_INVITATION_MODAL_DATA),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      invitationModalData = _useState6[0],
	      setInvitationModalData = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      isOtpConfirmationOpened = _useState8[0],
	      setIsOtpConfirmationOpened = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(INIT_OTP_ERROR_DATA),
	      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
	      otpErrorData = _useState10[0],
	      setOtpErrorData = _useState10[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(_selectors.selectOptAuthCodesState),
	      sending = _useSelector.sending,
	      succeed = _useSelector.succeed,
	      error = _useSelector.error,
	      rejected = _useSelector.rejected;
	
	  var _useSelector2 = (0, _reactRedux.useSelector)(_selectors2.selectAuthLoginData),
	      loginRejected = _useSelector2.rejected,
	      loginError = _useSelector2.error;
	
	  var otpCodeExpirationSeconds = (0, _reactRedux.useSelector)(_selectors.selectOtpCodeExpirationSeconds);
	
	  var isEmail = function isEmail(value) {
	    return (0, _defaultValidator.defaultValidator)(_validations.PATTERNS.HAS_ALPHABETICAL_CHARACTER, value);
	  };
	
	  var isValidFieldValue = function isValidFieldValue(value) {
	    var isValid = value ? (0, _loginValidator2.default)(value) : true;
	    if (!isValid) {
	      var loginErrorId = isEmail(value) ? 'errors.validation.invalidLoginEmail' : 'errors.validation.invalidLoginPhone';
	      setFieldError(formatMessage({ id: loginErrorId }));
	    }
	    return isValid;
	  };
	
	  var resetLoginError = function resetLoginError() {
	    if (fieldError) setFieldError('');
	  };
	
	  var handleCancelBtnClick = function handleCancelBtnClick() {
	    onClose();
	    setFieldError('');
	    setOtpErrorData(INIT_OTP_ERROR_DATA);
	  };
	
	  var handleTextInputChange = function handleTextInputChange(value) {
	    setFieldValue(value);
	  };
	
	  var handleSubmitPasscode = function handleSubmitPasscode() {
	    dispatch(_optAuthCodes.actions.send({ login: fieldValue }));
	  };
	
	  var handleCloseOtpDialog = function handleCloseOtpDialog() {
	    dispatch(login.actions.clear());
	    dispatch(_optAuthCodes.actions.clear());
	    setIsOtpConfirmationOpened(false);
	    setOtpErrorData(INIT_OTP_ERROR_DATA);
	    setFieldValue('');
	  };
	
	  var handleResendOtpCode = function handleResendOtpCode() {
	    setOtpErrorData(INIT_OTP_ERROR_DATA);
	    handleSubmitPasscode();
	  };
	
	  var handleCloseInvitationModal = function handleCloseInvitationModal() {
	    dispatch(_optAuthCodes.actions.clear());
	    setInvitationModalData(INIT_INVITATION_MODAL_DATA);
	    setFieldValue('');
	  };
	
	  var handleOtpLogin = function handleOtpLogin(code) {
	    dispatch(login.actions.send({
	      login: fieldValue,
	      otpCode: code
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    if (succeed) {
	      setIsOtpConfirmationOpened(Boolean(succeed));
	      handleCancelBtnClick();
	    }
	  }, [succeed]);
	
	  (0, _react.useEffect)(function () {
	    if (rejected || loginRejected) {
	      var code = (0, _get2.default)(error, 'code');
	      var status = (0, _get2.default)(error, 'status');
	
	      var loginStatus = (0, _get2.default)(loginError, 'status');
	      var loginCode = (0, _get2.default)(loginError, 'code');
	
	      if (loginStatus === HTTP_STATUS_UNAUTHORIZED) {
	        setOtpErrorData({
	          error: true,
	          errorText: _errors.LOGIN_ERRORS[loginCode] || 'mfa.dialog.error.message'
	        });
	      } else if (status === HTTP_STATUS_TOO_MANY_REQUESTS) {
	        setOtpErrorData({
	          error: true,
	          errorText: 'otp.dialog.error.tooManyRequests'
	        });
	      } else if (status === HTTP_STATUS_LOCKED || loginStatus === HTTP_STATUS_LOCKED) {
	        setOtpErrorData({
	          error: true,
	          errorText: 'errors.login.authenticationLockout'
	        });
	      } else if (_errors.LOGIN_INVITATION_ERRORS.includes(code)) {
	        setInvitationModalData({
	          showInvitationModal: true,
	          loginValue: fieldValue
	        });
	        handleCancelBtnClick();
	      } else if (code === _errors.LOGIN_ERROR_CODES.AUTHENTICATION_LOCKOUT || loginCode === _errors.LOGIN_ERROR_CODES.AUTHENTICATION_LOCKOUT) {
	        setOtpErrorData({
	          error: true,
	          errorText: 'errors.login.authenticationLockout'
	        });
	      }
	    } else {
	      setOtpErrorData(INIT_OTP_ERROR_DATA);
	    }
	  }, [rejected, error, loginRejected, loginError]);
	
	  (0, _react.useEffect)(function () {
	    if (loginRejected) {
	      dispatch(_optAuthCodes.actions.clear());
	    }
	  }, [loginRejected]);
	
	  (0, _react.useEffect)(function () {
	    if (rejected) {
	      dispatch(login.actions.clear());
	    }
	  }, [rejected]);
	
	  (0, _react.useEffect)(function () {
	    setIsAnyOfOtpPathModalsOpen(isOtpConfirmationOpened || invitationModalData.showInvitationModal);
	  }, [isOtpConfirmationOpened, invitationModalData.showInvitationModal]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Popup2.default,
	      { opened: open, withHeading: false, mobileFullScreen: false },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.modalWrapper },
	        sending && _react2.default.createElement(
	          'div',
	          { className: _index2.default.loader },
	          _react2.default.createElement(_Loader2.default, null)
	        ),
	        _react2.default.createElement(
	          'h1',
	          { className: _index2.default.title },
	          formatMessage({ id: 'otp.dialog.title' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentText },
	          formatMessage({ id: 'otp.dialog.contentText' })
	        ),
	        _react2.default.createElement(_TextInput2.default, {
	          className: _index2.default.textField,
	          id: 'email-or-phone',
	          label: formatMessage({ id: 'profile.fields.emailOrPhone' }),
	          name: 'emailOrPhone',
	          placeholder: formatMessage({ id: 'profile.fields.emailOrPhone' }),
	          required: true,
	          rounded: true,
	          onBlur: isValidFieldValue,
	          onFocus: resetLoginError,
	          onChange: handleTextInputChange
	        }),
	        Boolean(fieldError || otpErrorData.error) ? _react2.default.createElement(_ErrorBlock2.default, {
	          errors: fieldError || formatMessage({ id: otpErrorData.errorText }) || formatMessage({ id: 'otp.dialog.error.tooManyRequests' }),
	          className: _index2.default.errorBlock
	        }) : null,
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: _index2.default.getPasscodeBtn,
	            color: 'primary',
	            raised: true,
	            type: 'button',
	            onClick: handleSubmitPasscode,
	            disabled: Boolean(fieldError || !fieldValue || otpErrorData.error)
	          },
	          formatMessage({ id: 'otp.dialog.getPasscode' })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: (0, _classnames2.default)(_index2.default.cancelBtn, 'db w-100 lh-copy'),
	            color: 'accent',
	            type: 'button',
	            onClick: function onClick() {
	              handleCancelBtnClick();
	              setFieldValue('');
	            }
	          },
	          formatMessage({ id: 'common.cancel' })
	        )
	      )
	    ),
	    isOtpConfirmationOpened && _react2.default.createElement(_MfaDialog2.default, {
	      counterValue: otpCodeExpirationSeconds,
	      disableVerifyButton: loginRejected,
	      error: otpErrorData.error,
	      errorText: otpErrorData.errorText,
	      loading: sending,
	      onClose: handleCloseOtpDialog,
	      onResend: handleResendOtpCode,
	      onSubmit: handleOtpLogin,
	      open: isOtpConfirmationOpened,
	      title: formatMessage({ id: 'otp.dialog.title' }),
	      withContentText: formatMessage({
	        id: 'mfa.dialog.phoneAndEmailConfirmation'
	      })
	    }),
	    _react2.default.createElement(_InvitationModal2.default, {
	      formatMessage: formatMessage,
	      opened: invitationModalData.showInvitationModal,
	      loginValue: invitationModalData.loginValue,
	      handleCloseInvitationModal: handleCloseInvitationModal
	    })
	  );
	};
	
	OtpModal.propTypes = {
	  open: _propTypes2.default.bool,
	  formatMessage: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  setIsAnyOfOtpPathModalsOpen: _propTypes2.default.func
	};
	
	OtpModal.defaultProps = {
	  open: false,
	  formatMessage: function formatMessage() {},
	  onClose: function onClose() {}
	};
	
	exports.default = OtpModal;

/***/ }),
/* 3428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _selectors = __webpack_require__(90);
	
	var _index = __webpack_require__(5022);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Overlay = function Overlay(_ref) {
	  var visible = _ref.visible;
	  return _react2.default.createElement('div', {
	    styleName: (0, _classnames2.default)('root', {
	      'root--visible': visible
	    })
	  });
	};
	
	Overlay.propTypes = {
	  visible: _propTypes2.default.bool
	};
	
	Overlay.defaultProps = {
	  visible: false
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    visible: (0, _selectors.overlayVisibleSelector)(state)
	  };
	})((0, _reactCssModules2.default)(Overlay, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3429 */,
/* 3430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5025);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppointmentError = function AppointmentError() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var errorMessage = formatMessage({ id: 'errors.securityLink' });
	
	  return _react2.default.createElement(
	    'section',
	    { className: _index2.default.section },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(_Icon2.default, { icon: 'error', name: 'error', size: 48 }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.message },
	        errorMessage
	      )
	    )
	  );
	};
	
	exports.default = AppointmentError;

/***/ }),
/* 3431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLottie = __webpack_require__(1617);
	
	var _reactLottie2 = _interopRequireDefault(_reactLottie);
	
	var _reactIntl = __webpack_require__(5);
	
	var _PaperworkAuthLoader = __webpack_require__(5354);
	
	var _PaperworkAuthLoader2 = _interopRequireDefault(_PaperworkAuthLoader);
	
	var _index = __webpack_require__(5026);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var animationOptions = {
	  loop: true,
	  autoplay: true,
	  animationData: _PaperworkAuthLoader2.default,
	  rendererSettings: {
	    preserveAspectRatio: 'xMidYMid slice'
	  }
	};
	
	var AppointmentSessionLoader = function AppointmentSessionLoader() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var title = formatMessage({
	    id: 'paperwork.dialog.verifyingLink'
	  });
	
	  return _react2.default.createElement(
	    'section',
	    { className: _index2.default.section },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(_reactLottie2.default, { options: animationOptions, height: 200, width: 200 }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        title
	      )
	    )
	  );
	};
	
	exports.default = AppointmentSessionLoader;

/***/ }),
/* 3432 */,
/* 3433 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ERROR_CODES = exports.ERROR_CODES = {
	  paperwork_dob_appointment_unavailable: 'paperwork.error.appointmentUnavailable',
	  paperwork_dob_verification_failed: 'paperwork.error.verifyDob.invalidDob'
	};

/***/ }),
/* 3434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactIntl = __webpack_require__(5);
	
	var _strings = __webpack_require__(15);
	
	var useJoinFormTitles = function useJoinFormTitles() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var title = formatMessage({ id: 'paperwork.dob.title' });
	  var descriptionText = formatMessage({ id: 'paperwork.dob.description' });
	  var confirmButtonText = formatMessage({ id: 'paperwork.dob.confirm' });
	  var agreeWithTermsAndPolicyText = function agreeWithTermsAndPolicyText(_ref) {
	    var terms = _ref.terms,
	        policy = _ref.policy;
	    return formatMessage({ id: 'paperwork.dob.agreeWithTermsAndPolicy' }, { terms: terms, policy: policy });
	  };
	  var termOfUseText = formatMessage(_strings.COMMON.termOfUse);
	  var privacyText = formatMessage(_strings.COMMON.privacy);
	
	  return {
	    title: title,
	    descriptionText: descriptionText,
	    confirmButtonText: confirmButtonText,
	    agreeWithTermsAndPolicyText: agreeWithTermsAndPolicyText,
	    termOfUseText: termOfUseText,
	    privacyText: privacyText
	  };
	};
	
	exports.default = useJoinFormTitles;

/***/ }),
/* 3435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _DateDropdown = __webpack_require__(498);
	
	var _DateDropdown2 = _interopRequireDefault(_DateDropdown);
	
	var _helpers = __webpack_require__(3433);
	
	var _useJoinFormTitles2 = __webpack_require__(3434);
	
	var _useJoinFormTitles3 = _interopRequireDefault(_useJoinFormTitles2);
	
	var _useHandleGlobalPaperworkPending = __webpack_require__(232);
	
	var _useHandleGlobalPaperworkPending2 = _interopRequireDefault(_useHandleGlobalPaperworkPending);
	
	var _paperworkVerifyDob = __webpack_require__(676);
	
	var _paperworkVerifyDob2 = __webpack_require__(4141);
	
	var _TermsAndPolicies = __webpack_require__(1846);
	
	var _TermsAndPolicies2 = _interopRequireDefault(_TermsAndPolicies);
	
	var _selectors = __webpack_require__(50);
	
	var _constants = __webpack_require__(17);
	
	var _stylesModule = __webpack_require__(5029);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinForm = function JoinForm(_ref) {
	  var params = _ref.params;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      dateOfBirth = _useState2[0],
	      setDateOfBirth = _useState2[1];
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var verifyDobPending = (0, _reactRedux.useSelector)(_paperworkVerifyDob2.selectPaperworkVerifyDobPending);
	
	  var verifyDobError = (0, _reactRedux.useSelector)(_paperworkVerifyDob2.selectPaperworkVerifyDobError);
	
	  var privacyList = (0, _reactRedux.useSelector)(_selectors.privacyListSelector);
	
	  var appointmentUUID = (0, _get2.default)(params, 'uuid', '');
	
	  var _useJoinFormTitles = (0, _useJoinFormTitles3.default)(),
	      title = _useJoinFormTitles.title,
	      descriptionText = _useJoinFormTitles.descriptionText,
	      confirmButtonText = _useJoinFormTitles.confirmButtonText,
	      agreeWithTermsAndPolicyText = _useJoinFormTitles.agreeWithTermsAndPolicyText,
	      termOfUseText = _useJoinFormTitles.termOfUseText,
	      privacyText = _useJoinFormTitles.privacyText;
	
	  (0, _useHandleGlobalPaperworkPending2.default)(verifyDobPending);
	
	  var privacyByCountry = (0, _react.useMemo)(function () {
	    return privacyList.find(function (item) {
	      return item.country === _constants.DEFAULT_COUNTRY;
	    }) || {};
	  }, [privacyList]);
	
	  var errorMessage = (0, _react.useMemo)(function () {
	    var errorCode = (0, _get2.default)(verifyDobError, 'code');
	
	    if (!errorCode) return '';
	
	    var errorText = _helpers.ERROR_CODES[errorCode] || 'errors.common';
	
	    return formatMessage({ id: errorText });
	  }, [verifyDobError]);
	
	  var confirmDob = function confirmDob() {
	    dispatch(_paperworkVerifyDob.actions.send({
	      dob: dateOfBirth,
	      appointmentUUID: appointmentUUID
	    }));
	  };
	
	  return _react2.default.createElement(
	    'section',
	    { className: _stylesModule2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.form },
	      _react2.default.createElement(
	        'h1',
	        { className: _stylesModule2.default.title },
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _stylesModule2.default.text },
	        descriptionText
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inputWrapper },
	        verifyDobError && _react2.default.createElement(_ErrorBlock2.default, { className: _stylesModule2.default.error, errors: errorMessage }),
	        _react2.default.createElement(_DateDropdown2.default, {
	          value: dateOfBirth,
	          onChange: setDateOfBirth,
	          labelMessageId: 'paperwork.dob.fieldLabel'
	        })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          raised: true,
	          color: 'primary',
	          onClick: confirmDob,
	          className: _stylesModule2.default.button,
	          disabled: !dateOfBirth || verifyDobPending
	        },
	        confirmButtonText
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.termsAndPoliciesWrapper },
	        agreeWithTermsAndPolicyText({
	          terms: _react2.default.createElement(_TermsAndPolicies2.default, {
	            className: _stylesModule2.default.termsAndPolicies,
	            textLink: termOfUseText,
	            document: privacyByCountry.terms
	          }),
	          policy: _react2.default.createElement(_TermsAndPolicies2.default, {
	            className: _stylesModule2.default.termsAndPolicies,
	            textLink: privacyText,
	            document: privacyByCountry.privacyPolicy
	          })
	        })
	      )
	    )
	  );
	};
	
	JoinForm.propTypes = {
	  params: _propTypes2.default.object
	};
	
	exports.default = (0, _reactRouter.withRouter)(JoinForm);

/***/ }),
/* 3436 */,
/* 3437 */,
/* 3438 */,
/* 3439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _react = __webpack_require__(1);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactRedux = __webpack_require__(6);
	
	var _queryParams = __webpack_require__(1772);
	
	var _paperwork = __webpack_require__(265);
	
	var _selectors = __webpack_require__(93);
	
	var _paperworkAppointmentSession = __webpack_require__(1896);
	
	var _paperworkAppointmentSession2 = __webpack_require__(673);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useHandleAutoAuthenticate = function useHandleAutoAuthenticate(query) {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var appointmentUUID = (0, _paperwork.getAppointmentId)();
	
	  var isLoggedIn = (0, _reactRedux.useSelector)(_selectors.selectAuthLoggedInStatus);
	
	  var appointmentSessionError = (0, _reactRedux.useSelector)(_paperworkAppointmentSession.selectPaperworkAppointmentSessionError);
	
	  var removeQueryParam = (0, _react.useCallback)(function () {
	    var location = _reactRouter.browserHistory.getCurrentLocation();
	
	    var newQuery = (0, _extends3.default)({}, query);
	
	    var authToken = (0, _get2.default)(query, _queryParams.PAPERWORK_QUERY_PARAMS.AUTH_TOKEN);
	
	    if (authToken) {
	      delete newQuery[_queryParams.PAPERWORK_QUERY_PARAMS.AUTH_TOKEN];
	      dispatch(_paperworkAppointmentSession2.actions.clear());
	    }
	
	    _reactRouter.browserHistory.replace({
	      pathname: location.pathname,
	      query: newQuery
	    });
	  }, [query]);
	
	  (0, _react.useEffect)(function () {
	    var authToken = (0, _get2.default)(query, _queryParams.PAPERWORK_QUERY_PARAMS.AUTH_TOKEN);
	
	    if (authToken && !isLoggedIn) {
	      dispatch(_paperworkAppointmentSession2.actions.send({
	        authToken: authToken,
	        appointmentUUID: appointmentUUID
	      }));
	    }
	  }, [query, isLoggedIn, appointmentUUID]);
	
	  (0, _react.useEffect)(function () {
	    if (appointmentSessionError) {
	      removeQueryParam();
	    }
	  }, [appointmentSessionError]);
	};
	
	exports.default = useHandleAutoAuthenticate;

/***/ }),
/* 3440 */,
/* 3441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _IndexLink = __webpack_require__(1623);
	
	var _IndexLink2 = _interopRequireDefault(_IndexLink);
	
	var _LinearProgress = __webpack_require__(579);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _JoinForm = __webpack_require__(3435);
	
	var _JoinForm2 = _interopRequireDefault(_JoinForm);
	
	var _AppointmentSessionLoader = __webpack_require__(3431);
	
	var _AppointmentSessionLoader2 = _interopRequireDefault(_AppointmentSessionLoader);
	
	var _AppointmentError = __webpack_require__(3430);
	
	var _AppointmentError2 = _interopRequireDefault(_AppointmentError);
	
	var _queryParams = __webpack_require__(1772);
	
	var _storageKeys = __webpack_require__(215);
	
	var _routes = __webpack_require__(37);
	
	var _useHandleAutoAuthenticate = __webpack_require__(3439);
	
	var _useHandleAutoAuthenticate2 = _interopRequireDefault(_useHandleAutoAuthenticate);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _selectors = __webpack_require__(93);
	
	var _common = __webpack_require__(135);
	
	var _paperworkAppointmentSession = __webpack_require__(1896);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(82);
	
	var _common2 = __webpack_require__(239);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _paperworkGetUserDetails = __webpack_require__(866);
	
	var _paperworkGetAppointmentDetails2 = __webpack_require__(675);
	
	var _index = __webpack_require__(5032);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ids = __webpack_require__(46);
	
	var _usePaperworkFlowFormSteps = __webpack_require__(287);
	
	var _usePaperworkFlowFormSteps2 = _interopRequireDefault(_usePaperworkFlowFormSteps);
	
	var _useScrollTopByElementId = __webpack_require__(1861);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaperworkPageLayout = function PaperworkPageLayout(_ref) {
	  var children = _ref.children,
	      query = _ref.query;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _usePaperworkFlowForm = (0, _usePaperworkFlowFormSteps2.default)(),
	      currentStepNumber = _usePaperworkFlowForm.currentStepNumber;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      showContent = _useState2[0],
	      setShowContent = _useState2[1];
	
	  var showProgress = (0, _reactRedux.useSelector)(_common.selectPaperworkGlobalPending);
	
	  var isLoggedIn = (0, _reactRedux.useSelector)(_selectors.selectAuthLoggedInStatus);
	
	  var LogoContainer = isLoggedIn ? 'div' : _IndexLink2.default;
	  var logoContainerProps = {
	    className: _index2.default.link,
	    'aria-label': 'paperwork',
	    to: isLoggedIn ? null : _routes.ROOT
	  };
	
	  var isAppointmentSessionSending = (0, _reactRedux.useSelector)(_paperworkAppointmentSession.selectPaperworkAppointmentSessionSending);
	
	  var validating = (0, _reactRedux.useSelector)(_common.selectPaperworkValidating);
	
	  var appointmentError = (0, _reactRedux.useSelector)(_paperworkGetAppointmentDetails.selectPaperworkAppointmentDataError);
	  var appointmentSessionError = (0, _reactRedux.useSelector)(_paperworkAppointmentSession.selectPaperworkAppointmentSessionError);
	
	  (0, _useScrollTopByElementId.useScrollTopByElementId)(_ids.IDS.PAPERWORK.ROOT, currentStepNumber);
	
	  var visitTitle = formatMessage({ id: 'common.urgentCareVisit' });
	
	  var authToken = (0, _get2.default)(query, _queryParams.PAPERWORK_QUERY_PARAMS.AUTH_TOKEN);
	
	  var showSessionLoader = (0, _react.useMemo)(function () {
	    return !isLoggedIn && authToken || isLoggedIn && validating && !appointmentError;
	  }, [isLoggedIn, validating, appointmentError, authToken]);
	
	  var content = (0, _react.useMemo)(function () {
	    var showJoinForm = !isLoggedIn && !authToken;
	
	    var showChildren = isLoggedIn && !authToken && !isAppointmentSessionSending && !appointmentError && !validating;
	
	    var joinFormContent = showJoinForm && appointmentSessionError ? _react2.default.createElement(_AppointmentError2.default, null) : _react2.default.createElement(_JoinForm2.default, null);
	
	    return showSessionLoader || !showContent ? _react2.default.createElement(_AppointmentSessionLoader2.default, null) : _react2.default.createElement(
	      _react.Fragment,
	      null,
	      showChildren ? children : joinFormContent
	    );
	  }, [appointmentSessionError, showSessionLoader, showContent, isLoggedIn, validating, authToken, isAppointmentSessionSending, appointmentError, children]);
	
	  (0, _react.useEffect)(function () {
	    if (!showSessionLoader) {
	      // This fake delay is needed to prevent the content from flickering
	      var timer = setTimeout(function () {
	        setShowContent(true);
	      }, 1000);
	      return function () {
	        return clearTimeout(timer);
	      };
	      // eslint-disable-next-line no-else-return
	    } else {
	      setShowContent(false);
	    }
	  }, [showSessionLoader]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'header',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          LogoContainer,
	          logoContainerProps,
	          _react2.default.createElement(_Icon2.default, {
	            name: _brandConfig2.default.logo,
	            size: _brandConfig2.default.logoSize,
	            className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _index2.default.icon, _brandConfig.isFlagler))
	          })
	        )
	      ),
	      isLoggedIn && _react2.default.createElement(
	        'div',
	        { className: _index2.default.visitTitle },
	        visitTitle
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('g-content', _index2.default.root, (0, _defineProperty3.default)({}, _index2.default.backgroundImage, !isLoggedIn)),
	        id: _ids.IDS.PAPERWORK.ROOT
	      },
	      showProgress && _react2.default.createElement(_LinearProgress2.default, { className: _index2.default.progress }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.content, (0, _defineProperty3.default)({}, _index2.default.freeze, showProgress))
	        },
	        content
	      )
	    )
	  );
	};
	
	var Paperwork = function Paperwork(_ref2) {
	  var children = _ref2.children,
	      location = _ref2.location;
	  var query = location.query;
	
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var isLoggedIn = (0, _reactRedux.useSelector)(_selectors.selectAuthLoggedInStatus);
	
	  (0, _useHandleAutoAuthenticate2.default)(query);
	
	  (0, _react.useEffect)(function () {
	    if (isLoggedIn) {
	      dispatch(_common2.paperworkCommonActions.validate());
	    }
	  }, [isLoggedIn]);
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      dispatch(_paperworkGetAppointmentDetails2.actions.clear());
	      dispatch(_paperworkGetUserDetails.actions.clear());
	      dispatch(_manageInsurancesActions.manageInsurancesActions.clearManageInsuranceRelatedData());
	      window.storage.removeItem(_storageKeys.PAPERWORK_TOKEN);
	    };
	  }, []);
	
	  return _react2.default.createElement(
	    PaperworkPageLayout,
	    { query: query },
	    children
	  );
	};
	
	PaperworkPageLayout.propTypes = {
	  children: PropTypes.node,
	  query: PropTypes.object
	};
	
	Paperwork.propTypes = {
	  children: PropTypes.node,
	  location: PropTypes.object
	};
	
	exports.default = Paperwork;

/***/ }),
/* 3442 */,
/* 3443 */,
/* 3444 */,
/* 3445 */,
/* 3446 */,
/* 3447 */,
/* 3448 */,
/* 3449 */,
/* 3450 */,
/* 3451 */,
/* 3452 */,
/* 3453 */,
/* 3454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _addDataModal = __webpack_require__(880);
	
	var _selectors = __webpack_require__(109);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    openedAddDataModal: (0, _selectors.selectOpenedAddDataModal)(state),
	    type: (0, _selectors.selectTypeAddDataModal)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  close: _addDataModal.addDataModalActions.close
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _constants = __webpack_require__(54);
	
	var _enhance = __webpack_require__(3454);
	
	var _index = __webpack_require__(5037);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddDataModal(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      type = _ref.type,
	      openedAddDataModal = _ref.openedAddDataModal,
	      close = _ref.close,
	      component = _ref.component;
	
	  var safeType = _constants.VITALS_ACTIVITY_TYPE.BMI === type ? 'portal.emptyState.bodyInfo' : 'healthboard.' + type;
	  var handleCloseModal = function handleCloseModal() {
	    close();
	  };
	  var adaptTitle = formatMessage({
	    id: 'patient.portal.emptyState.addData'
	  }, { type: formatMessage({ id: 'patient.' + safeType }) });
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      title: adaptTitle,
	      mobileFullScreen: false,
	      onClose: handleCloseModal,
	      opened: openedAddDataModal,
	      strictClose: true,
	      overflowVisible: true,
	      withoutAdaptive: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.root },
	      component
	    )
	  );
	}
	
	AddDataModal.propTypes = {
	  intl: PropTypes.object,
	  close: PropTypes.func,
	  openedAddDataModal: PropTypes.bool,
	  type: PropTypes.string,
	  component: PropTypes.element
	};
	
	exports.default = (0, _enhance.enhance)(AddDataModal);

/***/ }),
/* 3456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FILTERS = undefined;
	
	var _constants = __webpack_require__(54);
	
	var DAY = _constants.CHART_FILTERS_TYPE.DAY,
	    MONTH = _constants.CHART_FILTERS_TYPE.MONTH,
	    QUARTER = _constants.CHART_FILTERS_TYPE.QUARTER,
	    WEEK = _constants.CHART_FILTERS_TYPE.WEEK,
	    YEAR = _constants.CHART_FILTERS_TYPE.YEAR;
	var FILTERS = exports.FILTERS = [{
	  title: DAY.title,
	  type: DAY.type
	}, {
	  title: WEEK.title,
	  type: WEEK.type
	}, {
	  title: MONTH.title,
	  type: MONTH.type
	}, {
	  title: QUARTER.title,
	  type: QUARTER.type
	}, {
	  title: YEAR.title,
	  type: YEAR.type
	}];

/***/ }),
/* 3457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Filters = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _filters = __webpack_require__(3456);
	
	var _index = __webpack_require__(5038);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Filters = exports.Filters = function Filters(_ref) {
	  var activeFilter = _ref.activeFilter,
	      handleClick = _ref.handleClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _filters.FILTERS.map(function (_ref2) {
	      var type = _ref2.type,
	          title = _ref2.title;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.item, (0, _defineProperty3.default)({}, _index2.default.activeItem, type === activeFilter)),
	          onClick: function onClick() {
	            return handleClick(type);
	          },
	          key: type
	        },
	        title
	      );
	    })
	  );
	};
	
	Filters.propTypes = {
	  handleClick: PropTypes.func,
	  activeFilter: PropTypes.string
	};

/***/ }),
/* 3458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BUTTONS = undefined;
	
	var _constants = __webpack_require__(54);
	
	var CCD = _constants.DATA_SOURCE_TYPE.CCD,
	    DEVICES = _constants.DATA_SOURCE_TYPE.DEVICES;
	var BUTTONS = exports.BUTTONS = [{
	  type: DEVICES,
	  color: '#326cba'
	}, {
	  type: CCD,
	  color: '#f87f5c'
	}];

/***/ }),
/* 3459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Legend = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(18);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _buttons = __webpack_require__(3458);
	
	var _constants = __webpack_require__(54);
	
	var _index = __webpack_require__(5039);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _hooks = __webpack_require__(144);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YEAR = _constants.CHART_FILTERS_TYPE.YEAR,
	    QUARTER = _constants.CHART_FILTERS_TYPE.QUARTER;
	var DEVICES = _constants.DATA_SOURCE_TYPE.DEVICES,
	    CCD = _constants.DATA_SOURCE_TYPE.CCD;
	var WEIGHT = _constants.VITALS_ACTIVITY_TYPE.WEIGHT,
	    BMI = _constants.VITALS_ACTIVITY_TYPE.BMI,
	    DISTANCE = _constants.VITALS_ACTIVITY_TYPE.DISTANCE,
	    STEPS = _constants.VITALS_ACTIVITY_TYPE.STEPS,
	    SATURATION = _constants.VITALS_ACTIVITY_TYPE.SATURATION,
	    HEIGHT = _constants.VITALS_ACTIVITY_TYPE.HEIGHT,
	    HEART_RATE = _constants.VITALS_ACTIVITY_TYPE.HEART_RATE,
	    BLOOD_GLUCOSE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE;
	var Legend = exports.Legend = function Legend(_ref) {
	  var sourceType = _ref.sourceType,
	      handleClick = _ref.handleClick,
	      formatMessage = _ref.formatMessage,
	      _ref$availableDataSou = _ref.availableDataSource,
	      availableDataSource = _ref$availableDataSou === undefined ? {} : _ref$availableDataSou,
	      dataType = _ref.dataType,
	      activeFilter = _ref.activeFilter,
	      targetUserFirstName = _ref.targetUserFirstName,
	      mainUser = _ref.mainUser,
	      setSourceType = _ref.setSourceType;
	  var ccd = availableDataSource.ccd,
	      devices = availableDataSource.devices;
	
	  var noAllSources = !ccd || !devices;
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  (0, _react.useEffect)(function () {
	    if (noAllSources) {
	      setSourceType(ccd ? CCD : DEVICES);
	    }
	  }, [noAllSources]);
	  var getIconForDatasetType = function getIconForDatasetType(type, color) {
	    switch (dataType) {
	      case STEPS:
	      case HEIGHT:
	      case DISTANCE:
	        {
	          return '';
	        }
	      case BMI:
	      case WEIGHT:
	        {
	          var isActive = type === sourceType;
	          var isDisabled = !availableDataSource[type];
	          var getIconWithStatus = function getIconWithStatus() {
	            var forQuarterYear = [QUARTER.type, YEAR.type].includes(activeFilter);
	            if (isActive) {
	              if (type === DEVICES) {
	                return 'icon-graph-devices-line-point-white';
	              }
	              return forQuarterYear ? 'icon-graph-health-record-line-point-white' : 'icon-graph-health-record-point-white';
	            }
	            if (isDisabled) {
	              if (type === DEVICES) {
	                return 'icon-graph-devices-line-point-disable';
	              }
	              return forQuarterYear ? 'icon-graph-health-record-line-point-disable' : 'icon-graph-health-record-point-disable';
	            }
	            if (type === DEVICES) {
	              return 'icon-graph-devices-line-point-black';
	            }
	            return forQuarterYear ? 'icon-graph-health-record-line-orange' : 'icon-graph-health-record-point-orange';
	          };
	          return _react2.default.createElement(_Icon2.default, { className: _index2.default.icon, size: 24, name: getIconWithStatus() });
	        }
	      case HEART_RATE:
	      case SATURATION:
	      case BLOOD_GLUCOSE:
	        {
	          return _react2.default.createElement('div', {
	            className: _index2.default.itemColor,
	            style: (0, _extends3.default)({
	              backgroundColor: color
	            }, type === sourceType && { backgroundColor: _styles.COLORS.white }, !availableDataSource[type] && {
	              backgroundColor: _styles.COLORS.stormyBlue
	            })
	          });
	        }
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _buttons.BUTTONS.map(function (_ref2) {
	      var _cn, _cn2;
	
	      var type = _ref2.type,
	          color = _ref2.color;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.itemWrapper, (_cn = {}, (0, _defineProperty3.default)(_cn, _index2.default.activeItem, type === sourceType), (0, _defineProperty3.default)(_cn, _index2.default.disabled, !availableDataSource[type]), (0, _defineProperty3.default)(_cn, _index2.default.activeItemNoAction, type === sourceType && noAllSources), _cn)),
	          onClick: function onClick() {
	            return handleClick(type);
	          },
	          key: type
	        },
	        getIconForDatasetType(type, color),
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_index2.default.itemTitle, (_cn2 = {}, (0, _defineProperty3.default)(_cn2, _index2.default.itemTitleActive, type === sourceType), (0, _defineProperty3.default)(_cn2, _index2.default.itemDisableTitle, !availableDataSource[type]), _cn2))
	          },
	          getSafeDataSourceTitle(type, formatMessage, mainUser, targetUserFirstName)
	        )
	      );
	    })
	  );
	};
	
	Legend.propTypes = {
	  handleClick: PropTypes.func,
	  sourceType: PropTypes.string,
	  formatMessage: PropTypes.func,
	  dataType: PropTypes.string,
	  activeFilter: PropTypes.string,
	  availableDataSource: PropTypes.object,
	  mainUser: PropTypes.bool,
	  targetUserFirstName: PropTypes.string,
	  setSourceType: PropTypes.func
	};

/***/ }),
/* 3460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _singlePointValuesModal = __webpack_require__(1351);
	
	var _selectors = __webpack_require__(109);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    openedSinglePointValueModal: (0, _selectors.selectOpenedSinglePointValuesModal)(state),
	    dataType: (0, _selectors.selectTypeSinglePointValuesModal)(state),
	    month: (0, _selectors.selectMonthTitleSinglePointValuesModal)(state),
	    entity: (0, _selectors.selectEntitySinglePointValuesModal)(state),
	    value: (0, _selectors.selectValueSinglePointValuesModal)(state),
	    metricSettings: (0, _selectors.selectMetricSettingsSinglePointValuesModal)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  close: _singlePointValuesModal.singlePointValuesModalActions.close
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _enhance = __webpack_require__(3460);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _index = __webpack_require__(5040);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _constants = __webpack_require__(54);
	
	var _useAverageData2 = __webpack_require__(1774);
	
	var _DataHistoricList = __webpack_require__(1157);
	
	var _DataHistoricList2 = _interopRequireDefault(_DataHistoricList);
	
	var _hooks = __webpack_require__(144);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CCD = _constants.DATA_SOURCE_TYPE.CCD;
	var DAY = _constants.CHART_FILTERS_TYPE.DAY;
	
	
	function SinglePointValueModal(_ref) {
	  var openedSinglePointValueModal = _ref.openedSinglePointValueModal,
	      close = _ref.close,
	      dataType = _ref.dataType,
	      month = _ref.month,
	      entity = _ref.entity,
	      value = _ref.value,
	      isWeightInKg = _ref.metricSettings.isWeightInKg,
	      formatMessage = _ref.intl.formatMessage;
	
	  var adaptMainTitle = formatMessage({
	    id: 'patient.healthboard.titleHistoric.' + dataType
	  }).substring(4);
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  var sourceTypeTitle = getSafeDataSourceTitle(CCD, formatMessage);
	  var safeDateTitle = formatMessage({
	    id: 'patient.healthboard.average'
	  }) + ' ' + month;
	
	  var data = {
	    averageOrTotal: { value: value, showAverageLine: false, dateForSingleMode: '' }
	  };
	
	  var _useAverageData = (0, _useAverageData2.useAverageData)(formatMessage, data, dataType, DAY.type, true, isWeightInKg),
	      formatValue = _useAverageData.formatValue,
	      metric = _useAverageData.metric;
	
	  var matchedDataForMonth = (0, _react.useMemo)(function () {
	    return [].concat((0, _toConsumableArray3.default)(entity)).filter(function (item) {
	      return (0, _moment2.default)(month, 'MMMM, YYYY').isSame(item.measuredAt, 'month');
	    }).reverse();
	  }, [entity, month]);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      title: adaptMainTitle,
	      mobileFullScreen: false,
	      onClose: close,
	      opened: openedSinglePointValueModal,
	      strictClose: true,
	      overflowVisible: true,
	      withoutAdaptive: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.root },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.singleMonthRoot },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.valueWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.value },
	            formatValue || ''
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.metric },
	            metric
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.rightSideWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.date },
	            safeDateTitle
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.dataSourceTitle },
	            sourceTypeTitle
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.dataHistoricList },
	        _react2.default.createElement(_DataHistoricList2.default, {
	          formatMessage: formatMessage,
	          type: dataType,
	          data: matchedDataForMonth,
	          isWeightInKg: isWeightInKg,
	          allValuesForOneDay: true,
	          calendarFormatTime: _constants.HISTORIC_MONTHS_CALENDAR_TYPE
	        })
	      )
	    )
	  );
	}
	
	SinglePointValueModal.propTypes = {
	  intl: PropTypes.object,
	  close: PropTypes.func,
	  openedSinglePointValueModal: PropTypes.bool,
	  dataType: PropTypes.string,
	  month: PropTypes.string,
	  entity: PropTypes.array,
	  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  metricSettings: PropTypes.object
	};
	
	exports.default = (0, _enhance.enhance)(SinglePointValueModal);

/***/ }),
/* 3462 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.customDrawRectangle = customDrawRectangle;
	/* eslint-disable */
	/**Customize the Rectangle.prototype draw method**/
	
	function customDrawRectangle() {
	  var ctx = this._chart.ctx;
	  var vm = this._view;
	  var left = void 0,
	      right = void 0,
	      top = void 0,
	      bottom = void 0,
	      signX = void 0,
	      signY = void 0,
	      borderSkipped = void 0;
	  var borderWidth = vm.borderWidth;
	
	  // If radius is less than 0 or is large enough to cause drawing errors a max
	  //      radius is imposed. If cornerRadius is not defined set it to 0.
	  var cornerRadius = this._chart.config.options.cornerRadius;
	  var fullCornerRadius = this._chart.config.options.fullCornerRadius;
	  var typeOfChart = this._chart.config.type;
	
	  if (cornerRadius < 0) {
	    cornerRadius = 0;
	  }
	  if (typeof cornerRadius === 'undefined') {
	    cornerRadius = 0;
	  }
	  if (typeof fullCornerRadius === 'undefined') {
	    fullCornerRadius = false;
	  }
	
	  if (!vm.horizontal) {
	    // bar
	    left = vm.x - vm.width / 2;
	    right = vm.x + vm.width / 2;
	    top = vm.y;
	    bottom = vm.base;
	    signX = 1;
	    signY = bottom > top ? 1 : -1;
	    borderSkipped = vm.borderSkipped || 'bottom';
	  }
	
	  // Canvas doesn't allow us to stroke inside the width so we can
	  // adjust the sizes to fit if we're setting a stroke on the line
	  if (borderWidth) {
	    // borderWidth shold be less than bar width and bar height.
	    var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
	    borderWidth = borderWidth > barSize ? barSize : borderWidth;
	    var halfStroke = borderWidth / 2;
	    // Adjust borderWidth when bar top position is near vm.base(zero).
	    var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
	    var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
	    var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
	    var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
	    // not become a vertical line?
	    if (borderLeft !== borderRight) {
	      top = borderTop;
	      bottom = borderBottom;
	    }
	    // not become a horizontal line?
	    if (borderTop !== borderBottom) {
	      left = borderLeft;
	      right = borderRight;
	    }
	  }
	
	  ctx.beginPath();
	  ctx.fillStyle = vm.backgroundColor;
	  ctx.strokeStyle = vm.borderColor;
	  ctx.lineWidth = borderWidth;
	
	  // Corner points, from bottom-left to bottom-right clockwise
	  // | 1 2 |
	  // | 0 3 |
	  var corners = [[left, bottom], [left, top], [right, top], [right, bottom]];
	
	  // Find first (starting) corner with fallback to 'bottom'
	  var borders = ['bottom', 'left', 'top', 'right'];
	  var startCorner = borders.indexOf(borderSkipped, 0);
	  if (startCorner === -1) {
	    startCorner = 0;
	  }
	
	  function cornerAt(index) {
	    return corners[(startCorner + index) % 4];
	  }
	
	  // Draw rectangle from 'startCorner'
	  var corner = cornerAt(0);
	  ctx.moveTo(corner[0], corner[1]);
	
	  var nextCornerId = void 0,
	      nextCorner = void 0,
	      width = void 0,
	      height = void 0,
	      x = void 0,
	      y = void 0;
	  for (var i = 1; i < 4; i++) {
	    corner = cornerAt(i);
	    nextCornerId = i + 1;
	    if (nextCornerId === 4) {
	      nextCornerId = 0;
	    }
	
	    nextCorner = cornerAt(nextCornerId);
	
	    width = corners[2][0] - corners[1][0];
	    height = corners[0][1] - corners[1][1];
	    x = corners[1][0];
	    y = corners[1][1];
	
	    var radius = cornerRadius;
	    // Fix radius being too large
	    if (radius > Math.abs(height) / 2) {
	      radius = Math.floor(Math.abs(height) / 2);
	    }
	    if (radius > Math.abs(width) / 2) {
	      radius = Math.floor(Math.abs(width) / 2);
	    }
	
	    if (this._chart.config.data.isCandleType) {
	      if (radius > height / 2) {
	        radius = height / 2;
	      }
	      if (radius > width / 2) {
	        radius = width / 2;
	      }
	
	      ctx.moveTo(x + radius, y);
	      ctx.lineTo(x + width - radius, y);
	      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
	      ctx.lineTo(x + width, y + height - radius);
	      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
	      ctx.lineTo(x + radius, y + height);
	      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
	      ctx.lineTo(x, y + radius);
	      ctx.quadraticCurveTo(x, y, x + radius, y);
	    } else {
	      var x_tl = void 0,
	          x_tr = void 0,
	          y_tl = void 0,
	          y_tr = void 0,
	          x_bl = void 0,
	          x_br = void 0,
	          y_bl = void 0,
	          y_br = void 0;
	      if (height < 0) {
	        // Negative values in a standard bar chart
	        x_tl = x;
	        x_tr = x + width;
	        y_tl = y + height;
	        y_tr = y + height;
	
	        x_bl = x;
	        x_br = x + width;
	        y_bl = y;
	        y_br = y;
	
	        // Draw
	        ctx.moveTo(x_bl + radius, y_bl);
	
	        ctx.lineTo(x_br - radius, y_br);
	
	        // bottom right
	        ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius);
	
	        ctx.lineTo(x_tr, y_tr + radius);
	
	        // top right
	        fullCornerRadius ? ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr) : ctx.lineTo(x_tr, y_tr, x_tr - radius, y_tr);
	
	        ctx.lineTo(x_tl + radius, y_tl);
	
	        // top left
	        fullCornerRadius ? ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius) : ctx.lineTo(x_tl, y_tl, x_tl, y_tl + radius);
	
	        ctx.lineTo(x_bl, y_bl - radius);
	
	        //  bottom left
	        ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);
	      } else if (width < 0) {
	        // Negative values in a horizontal bar chart
	        x_tl = x + width;
	        x_tr = x;
	        y_tl = y;
	        y_tr = y;
	
	        x_bl = x + width;
	        x_br = x;
	        y_bl = y + height;
	        y_br = y + height;
	
	        // Draw
	        ctx.moveTo(x_bl + radius, y_bl);
	
	        ctx.lineTo(x_br - radius, y_br);
	
	        //  Bottom right corner
	        fullCornerRadius ? ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius) : ctx.lineTo(x_br, y_br, x_br, y_br - radius);
	
	        ctx.lineTo(x_tr, y_tr + radius);
	
	        // top right Corner
	        fullCornerRadius ? ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr) : ctx.lineTo(x_tr, y_tr, x_tr - radius, y_tr);
	
	        ctx.lineTo(x_tl + radius, y_tl);
	
	        // top left corner
	        ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius);
	
	        ctx.lineTo(x_bl, y_bl - radius);
	
	        //  bttom left corner
	        ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);
	      } else {
	        var lastVisible = 0;
	        for (var findLast = 0, findLastTo = this._chart.data.datasets.length; findLast < findLastTo; findLast++) {
	          if (!this._chart.getDatasetMeta(findLast).hidden) {
	            lastVisible = findLast;
	          }
	        }
	        var rounded = this._datasetIndex === lastVisible;
	
	        if (rounded) {
	          //Positive Value
	          ctx.moveTo(x + radius, y);
	
	          ctx.lineTo(x + width - radius, y);
	
	          // top right
	          ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
	
	          ctx.lineTo(x + width, y + height - radius);
	
	          // bottom right
	          if (fullCornerRadius || typeOfChart === 'horizontalBar') ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);else ctx.lineTo(x + width, y + height, x + width - radius, y + height);
	
	          ctx.lineTo(x + radius, y + height);
	
	          // bottom left
	          if (fullCornerRadius) ctx.quadraticCurveTo(x, y + height, x, y + height - radius);else ctx.lineTo(x, y + height, x, y + height - radius);
	
	          ctx.lineTo(x, y + radius);
	
	          // top left
	          if (fullCornerRadius || typeOfChart === 'bar') ctx.quadraticCurveTo(x, y, x + radius, y);else ctx.lineTo(x, y, x + radius, y);
	        } else {
	          ctx.moveTo(x, y);
	          ctx.lineTo(x + width, y);
	          ctx.lineTo(x + width, y + height);
	          ctx.lineTo(x, y + height);
	          ctx.lineTo(x, y);
	        }
	      }
	    }
	  }
	
	  ctx.fill();
	  if (borderWidth) {
	    ctx.stroke();
	  }
	}

/***/ }),
/* 3463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.useCCDSourceWeightBMI = useCCDSourceWeightBMI;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _merge = __webpack_require__(379);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _selectors = __webpack_require__(109);
	
	var _utils = __webpack_require__(78);
	
	var _constants = __webpack_require__(54);
	
	var _singlePointValuesModal = __webpack_require__(1351);
	
	var _hooks = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BMI = _constants.VITALS_ACTIVITY_TYPE.BMI,
	    WEIGHT = _constants.VITALS_ACTIVITY_TYPE.WEIGHT;
	var CCD = _constants.DATA_SOURCE_TYPE.CCD,
	    DEVICES = _constants.DATA_SOURCE_TYPE.DEVICES,
	    ALL_SOURCES = _constants.DATA_SOURCE_TYPE.ALL_SOURCES;
	var QUARTER = _constants.CHART_FILTERS_TYPE.QUARTER,
	    YEAR = _constants.CHART_FILTERS_TYPE.YEAR;
	function useCCDSourceWeightBMI(_ref) {
	  var rowData = _ref.rowData,
	      activeFilter = _ref.activeFilter,
	      singleDayMode = _ref.singleDayMode,
	      options = _ref.options,
	      dataType = _ref.dataType,
	      sourceType = _ref.sourceType,
	      currentChartInstance = _ref.currentChartInstance,
	      formatMessage = _ref.formatMessage,
	      mainUser = _ref.mainUser,
	      targetUserFirstName = _ref.targetUserFirstName,
	      isWeightInKg = _ref.isWeightInKg;
	
	  var bmiDataEntity = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBMIMeasurementEntity));
	  var bmiDataModal = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBMIMeasurementModalEntity));
	  var weightDataEntity = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectWeightMeasurementEntity));
	  var weightDataModal = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectWeightMeasurementModalEntity));
	
	  var isApplicableModalOneValues = [QUARTER.type, YEAR.type].includes(activeFilter);
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  var ccdSourceTooltipLabel = getSafeDataSourceTitle(CCD, formatMessage, mainUser, targetUserFirstName);
	
	  var deviceSourceTooltipLabel = getSafeDataSourceTitle(DEVICES, formatMessage, mainUser, targetUserFirstName);
	
	  var getSafeData = (0, _react.useMemo)(function () {
	    switch (dataType) {
	      case BMI:
	        return singleDayMode ? bmiDataModal : bmiDataEntity;
	      case WEIGHT:
	        return singleDayMode ? weightDataModal : weightDataEntity;
	    }
	  }, [singleDayMode, dataType, bmiDataEntity, bmiDataModal, weightDataEntity, weightDataModal]);
	
	  if (![BMI, WEIGHT].includes(dataType)) return {};
	
	  var safeDataDevices = (0, _utils.getSourceDataWithType)(getSafeData, DEVICES);
	  var safeDataCCD = (0, _utils.getSourceDataWithType)(getSafeData, CCD);
	
	  var dataEntityDevices = (0, _utils.checkForAvailableSourceData)(safeDataDevices) ? (0, _utils.makeValueForGraf)(safeDataDevices.measurements, 'value', activeFilter, false, dataType, singleDayMode, false) : [];
	
	  var dataEntityCCD = (0, _utils.checkForAvailableSourceData)(safeDataCCD) ? (0, _utils.makeValueForGraf)(safeDataCCD.measurements, 'value', activeFilter, false, dataType, singleDayMode, false, true) : [];
	
	  var rowDataDevicesForAverageCalc = (0, _utils.checkForAvailableSourceData)(safeDataDevices) ? safeDataDevices.measurements.map(function (item) {
	    return item.value;
	  }) : [];
	  var rowDataCCDForAverageCalc = (0, _utils.checkForAvailableSourceData)(safeDataCCD) ? safeDataCCD.measurements.map(function (item) {
	    return item.value;
	  }) : [];
	
	  var averageValueDevices = (0, _utils.calculateAverageValue)(rowDataDevicesForAverageCalc);
	  var averageValueCCD = (0, _utils.calculateAverageValue)(rowDataCCDForAverageCalc);
	
	  var timeSets = (0, _utils.checkForAvailableSourceData)(safeDataCCD) ? (0, _utils.makeValueForGraf)(safeDataCCD.measurements, 'value', activeFilter, true, dataType, singleDayMode, false, true) : [];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handleShowAverageValue = function handleShowAverageValue() {
	    if ((0, _utils.checkForAvailableSourceData)(safeDataDevices) && (0, _utils.checkForAvailableSourceData)(safeDataCCD) && sourceType === ALL_SOURCES) {
	      return (0, _utils.calculateAverageValue)([].concat((0, _toConsumableArray3.default)(rowDataDevicesForAverageCalc), (0, _toConsumableArray3.default)(rowDataCCDForAverageCalc)));
	    }
	    if (!(0, _utils.checkForAvailableSourceData)(safeDataDevices) && (0, _utils.checkForAvailableSourceData)(safeDataCCD) && sourceType === ALL_SOURCES) {
	      return averageValueCCD;
	    }
	    if ((0, _utils.checkForAvailableSourceData)(safeDataDevices) && !(0, _utils.checkForAvailableSourceData)(safeDataCCD) && sourceType === ALL_SOURCES) {
	      return averageValueDevices;
	    }
	    if (sourceType === DEVICES) {
	      return averageValueDevices;
	    }
	    if (sourceType === CCD) {
	      return averageValueCCD;
	    }
	    return '';
	  };
	
	  var datasets = [(0, _extends3.default)({}, rowData.datasets[0], {
	    label: 'dataDevices',
	    data: [DEVICES, ALL_SOURCES].includes(sourceType) ? dataEntityDevices : [],
	    sourceType: {
	      title: deviceSourceTooltipLabel,
	      code: _constants.DATA_SOURCE_TYPE.DEVICES,
	      codes: safeDataDevices && safeDataDevices.measurements ? safeDataDevices.measurements.map(function (el) {
	        return {
	          providerCode: el.originalProviderCodes,
	          value: el.value,
	          measuredAt: el.measuredAt
	        };
	      }) : null
	    },
	    order: 2
	  }), (0, _extends3.default)({}, rowData.datasets[0], {
	    label: 'dataCCD',
	    type: isApplicableModalOneValues ? 'line' : 'bubble',
	    data: [CCD, ALL_SOURCES].includes(sourceType) ? dataEntityCCD : [],
	    backgroundColor: '#f87f5c',
	    borderColor: '#f87f5c',
	    borderWidth: 0
	  }, isApplicableModalOneValues && {
	    fill: false,
	    showLine: true,
	    borderWidth: 1,
	    pointBackgroundColor: '#f87f5c',
	    pointBorderColor: '#f87f5c',
	    pointBorderWidth: 1,
	    pointHoverBackgroundColor: '#f87f5c',
	    pointHoverBorderColor: '#f87f5c',
	    pointHoverBorderWidth: 1
	  }, {
	    pointStyle: 'rectRot',
	    radius: 3,
	    sourceType: {
	      title: ccdSourceTooltipLabel,
	      code: _constants.DATA_SOURCE_TYPE.CCD
	    },
	    order: 1
	  })];
	
	  var bmiWeightData = (0, _extends3.default)({}, rowData, isApplicableModalOneValues && (0, _utils.checkForAvailableSourceData)(safeDataCCD) && { timeSets: timeSets }, {
	    datasets: datasets,
	    averageOrTotal: (0, _extends3.default)({}, rowData.averageOrTotal, {
	      showAverageLine: (0, _utils.checkForAvailableSourceData)(safeDataDevices) && (0, _utils.checkForAvailableSourceData)(safeDataCCD) && sourceType === ALL_SOURCES,
	      value: handleShowAverageValue()
	    }),
	    availableDataSource: {
	      ccd: (0, _utils.checkForAvailableSourceData)(safeDataCCD),
	      devices: (0, _utils.checkForAvailableSourceData)(safeDataDevices)
	    },
	    optionsToolTip: (0, _utils.createTooltips)(datasets)
	  });
	
	  (0, _react.useEffect)(function () {
	    if (currentChartInstance && currentChartInstance.chartInstance) {
	      currentChartInstance.chartInstance.update();
	    }
	  }, [currentChartInstance, sourceType]);
	
	  var bmiWeightOptions = (0, _merge2.default)((0, _extends3.default)({}, options), {
	    hover: {
	      mode: 'nearest'
	    },
	    onClick: function onClick(evt, element) {
	      if (element.length > 0) {
	        if (currentChartInstance && currentChartInstance.current) {
	          var allEntity = currentChartInstance.current.chartInstance.data;
	          var indexActiveDataset = element[0]._chart.tooltip._active[0]._datasetIndex;
	          var isHealthRecordSource = allEntity.datasets[indexActiveDataset].sourceType.code === CCD;
	          if (isApplicableModalOneValues && isHealthRecordSource) {
	            dispatch(_singlePointValuesModal.singlePointValuesModalActions.open({
	              metricSettings: { isWeightInKg: isWeightInKg },
	              type: dataType,
	              value: allEntity.datasets[indexActiveDataset].data[element[0]._index],
	              monthTitle: allEntity.timeSets[element[0]._index],
	              entity: safeDataCCD && safeDataCCD.measurements ? safeDataCCD.measurements : []
	            }));
	          }
	          allEntity.optionsToolTip[indexActiveDataset][0].forEach(function (item, index) {
	            if (index === element[0]._index && item.keepTooltipOpen) {
	              // eslint-disable-next-line no-param-reassign
	              item.keepTooltipOpen = false;
	              // eslint-disable-next-line no-param-reassign
	            } else item.keepTooltipOpen = index === element[0]._index;
	          });
	        }
	      }
	    }
	  });
	
	  return { bmiWeightData: bmiWeightData, bmiWeightOptions: bmiWeightOptions };
	}

/***/ }),
/* 3464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useDataGraf = useDataGraf;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _styles = __webpack_require__(18);
	
	var _selectors = __webpack_require__(109);
	
	var _constants = __webpack_require__(54);
	
	var _utils = __webpack_require__(78);
	
	var _useCalculatePaddingYAxis = __webpack_require__(609);
	
	var _hooks = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SATURATION = _constants.VITALS_ACTIVITY_TYPE.SATURATION,
	    WEIGHT = _constants.VITALS_ACTIVITY_TYPE.WEIGHT,
	    BMI = _constants.VITALS_ACTIVITY_TYPE.BMI,
	    DISTANCE = _constants.VITALS_ACTIVITY_TYPE.DISTANCE,
	    STEPS = _constants.VITALS_ACTIVITY_TYPE.STEPS,
	    HEIGHT = _constants.VITALS_ACTIVITY_TYPE.HEIGHT,
	    HEART_RATE = _constants.VITALS_ACTIVITY_TYPE.HEART_RATE,
	    BLOOD_GLUCOSE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE;
	var MONTH = _constants.CHART_FILTERS_TYPE.MONTH,
	    WEEK = _constants.CHART_FILTERS_TYPE.WEEK,
	    QUARTER = _constants.CHART_FILTERS_TYPE.QUARTER,
	    DAY = _constants.CHART_FILTERS_TYPE.DAY,
	    YEAR = _constants.CHART_FILTERS_TYPE.YEAR;
	function useDataGraf(_ref) {
	  var formatMessage = _ref.formatMessage,
	      dataType = _ref.dataType,
	      filterType = _ref.filterType,
	      chartInstanceRef = _ref.chartInstanceRef,
	      singleDayMode = _ref.singleDayMode,
	      isWeightInKg = _ref.isWeightInKg,
	      isMilligramsPerDeciliter = _ref.isMilligramsPerDeciliter;
	
	  var isGrafTypeLine = [WEIGHT, BMI, HEIGHT].includes(dataType);
	  var isCandleDataType = [SATURATION, HEART_RATE, BLOOD_GLUCOSE].includes(dataType);
	  var isWithoutLimit = [HEART_RATE, BLOOD_GLUCOSE].includes(dataType);
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  var stepsData = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectStepsMeasurementEntity)));
	  var stepsDataModal = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectStepsMeasurementModalEntity)));
	  var distanceData = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectDistanceMeasurementEntity)));
	  var distanceDataModal = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectDistanceMeasurementModalEntity)));
	  var bmiData = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBMIMeasurementEntity)));
	  var bmiDataModal = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBMIMeasurementModalEntity)));
	  var weightData = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectWeightMeasurementEntity)));
	  var weightDataModal = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectWeightMeasurementModalEntity)));
	  var heightData = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectHeightMeasurementEntity)));
	  var heightDataModal = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectHeightMeasurementModalEntity)));
	  var saturationData = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectSaturationMeasurementEntity)));
	  var saturationDataModal = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectSaturationMeasurementModalHistoricList)));
	  var heartRateData = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectHeartRateMeasurementEntity)));
	  var heartRateDataModal = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectHeartRateMeasurementModalHistoricList)));
	  var bloodGlucoseData = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBloodGlucoseMeasurementEntity)));
	  var bloodGlucoseDataModal = (0, _utils.chooseAvailableSourceData)((0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBloodGlucoseMeasurementModalEntity)));
	
	  var getEntityData = (0, _react.useMemo)(function () {
	    return function () {
	      switch (dataType) {
	        case STEPS:
	          return singleDayMode ? stepsDataModal : stepsData;
	        case DISTANCE:
	          return singleDayMode ? distanceDataModal : distanceData;
	        case BMI:
	          return singleDayMode ? bmiDataModal : bmiData;
	        case WEIGHT:
	          return singleDayMode ? weightDataModal : weightData;
	        case HEIGHT:
	          return singleDayMode ? heightDataModal : heightData;
	        case SATURATION:
	          return singleDayMode ? saturationDataModal : saturationData;
	        case HEART_RATE:
	          return singleDayMode ? heartRateDataModal : heartRateData;
	        case BLOOD_GLUCOSE:
	          return singleDayMode ? bloodGlucoseDataModal : bloodGlucoseData;
	        default:
	          return {};
	      }
	    };
	  }, [dataType, stepsData, distanceData, bmiData, weightData, heightData, filterType, singleDayMode, stepsDataModal, distanceDataModal, bmiDataModal, weightDataModal, heightDataModal, saturationDataModal, saturationData, heartRateDataModal, heartRateData, bloodGlucoseData, bloodGlucoseDataModal]);
	
	  var getOptionsWithFilterType = (0, _react.useMemo)(function () {
	    return function () {
	      switch (filterType) {
	        case MONTH.type:
	          return {
	            maxBarThickness: 14
	          };
	        case DAY.type:
	          return {
	            maxBarThickness: 14
	          };
	        case WEEK.type:
	          return {
	            maxBarThickness: 29
	          };
	        case QUARTER.type:
	          return {
	            maxBarThickness: 29
	          };
	        case YEAR.type:
	          return {
	            maxBarThickness: 29
	          };
	      }
	    };
	  }, [filterType, singleDayMode]);
	  var adaptEntityForGraf = (0, _react.useMemo)(function () {
	    return function () {
	      var rowData = getEntityData();
	      var checkForAvailableData = rowData && rowData.measurements && rowData.measurements.length !== 0;
	      return (0, _extends3.default)({
	        labels: checkForAvailableData ? (0, _utils.makeValueForGraf)(rowData.measurements, 'labels', filterType, false, dataType, singleDayMode) : [],
	        datasets: [(0, _extends3.default)({
	          data: checkForAvailableData ? (0, _utils.makeValueForGraf)(rowData.measurements, 'value', filterType, false, dataType, singleDayMode) : [],
	          backgroundColor: checkForAvailableData ? (0, _utils.makeValueForGraf)(rowData.measurements, 'background', filterType, false, dataType, singleDayMode) : [],
	          barPercentage: 0.5,
	          yAxisID: 'right-y-axis'
	        }, isGrafTypeLine && {
	          lineTension: 0.4,
	          borderColor: '#000000',
	          borderWidth: 1,
	          spanGaps: true,
	          pointBackgroundColor: '#000000',
	          pointBorderColor: '#000000',
	          pointBorderWidth: 1,
	          pointHoverBackgroundColor: '#ffffff',
	          pointHoverBorderColor: '#000000',
	          pointHoverBorderWidth: 2,
	          pointHoverRadius: 6,
	          pointRadius: checkForAvailableData ? (0, _utils.makeValueForGraf)(rowData.measurements, 'points', filterType, false, dataType, singleDayMode) : []
	        }, {
	          sourceType: {
	            code: _constants.DATA_SOURCE_TYPE.DEVICES,
	            codes: checkForAvailableData && rowData.measurements.map(function (el) {
	              return {
	                providerCode: el.originalProviderCodes,
	                value: el.value,
	                measuredAt: el.measuredAt
	              };
	            })
	          }
	        }, getOptionsWithFilterType())],
	        timeSets: checkForAvailableData ? (0, _utils.makeValueForGraf)(rowData.measurements, 'value', filterType, true, dataType, singleDayMode) : [],
	        optionsToolTip: checkForAvailableData ? (0, _utils.makeValueForGraf)(rowData.measurements, 'tooltip', filterType, false, dataType, singleDayMode) : [],
	        averageOrTotal: {
	          dateForSingleMode: checkForAvailableData ? (0, _utils.makeDateForAverageOrTotal)(rowData.measurements, filterType, true) : '',
	          value: checkForAvailableData ? (0, _utils.makeValueForGraf)(rowData.measurements, 'value', filterType, false, dataType, singleDayMode, true) : '',
	          showAverageLine: checkForAvailableData ? (0, _utils.shouldHideAverageLine)(rowData.measurements, isCandleDataType) : false
	        }
	      }, isCandleDataType && { isCandleType: true });
	    };
	  }, [getEntityData, filterType, dataType, singleDayMode, isCandleDataType]);
	
	  var calculatePaddingForYAxis = (0, _useCalculatePaddingYAxis.useCalculatePaddingYAxis)();
	
	  var getGlobalOptionsForChart = (0, _react.useMemo)(function () {
	    return function (type, isWeightMetricInKg) {
	      return {
	        scales: {
	          xAxes: [(0, _extends3.default)({
	            offset: true,
	            gridLines: {
	              borderDash: [2, 4],
	              color: '#e5e5e5',
	              display: false,
	              drawOnChartArea: false,
	              drawTicks: true
	            },
	            ticks: {
	              padding: 0,
	              fontColor: 'rgba(84, 118, 164, 0.6)',
	              fontSize: 12,
	              fontFamily: 'Helvetica',
	              fontStyle: 'bold',
	              autoSkip: true,
	              autoSkipPadding: singleDayMode ? 10 : 15,
	              maxRotation: 0
	            }
	          }, isCandleDataType && { stacked: true })],
	          yAxes: [(0, _extends3.default)({
	            id: 'right-y-axis',
	            type: 'linear',
	            position: 'right',
	            offset: true,
	            gridLines: {
	              borderDash: [2, 4],
	              color: '#e5e5e5',
	              drawOnChartArea: true,
	              drawTicks: true,
	              drawBorder: false,
	              zeroLineWidth: 0,
	              zeroLineColor: '#ffffff'
	            },
	            ticks: (0, _extends3.default)({
	              padding: 1,
	              beginAtZero: false,
	              fontColor: 'rgba(38, 65, 74, 0.4)',
	              fontSize: 11,
	              fontFamily: 'Helvetica',
	              callback: function callback(value) {
	                return (0, _utils.makeTickForData)(value, type, true, isWeightMetricInKg);
	              }
	            }, isCandleDataType && {
	              min: 75,
	              max: 100,
	              autoSkip: true,
	              autoSkipPadding: calculatePaddingForYAxis,
	              callback: function callback(value, _, data) {
	                if (dataType === BLOOD_GLUCOSE && !isMilligramsPerDeciliter) return value === 0 ? 0 : value.toFixed(1);
	                var roundedValue = Math.round(value);
	                if (data.includes(roundedValue) && roundedValue !== value) return null;
	                return value > 100 && !isWithoutLimit ? null : roundedValue;
	              }
	            })
	          }, isCandleDataType && { stacked: true })]
	        },
	        layout: {
	          padding: {
	            left: 0,
	            right: 0,
	            top: 30,
	            bottom: 0
	          }
	        },
	        legend: {
	          display: false
	        },
	        cornerRadius: 4,
	        fullCornerRadius: false,
	        stackedRounded: false,
	        animation: {
	          duration: 0
	        },
	        tooltips: {
	          backgroundColor: '#ffffff',
	          displayColors: false,
	          titleFontColor: '#26414a',
	          titleFontSize: 16,
	          titleFontStyle: 'bold',
	          titleFontFamily: _styles.FONT_FAMILY.primary,
	          footerFontSize: 11,
	          footerFontStyle: 'normal',
	          footerFontColor: 'rgba(38, 65, 74, 0.75)',
	          bodyFontSize: 11,
	          footerSpacing: 6,
	          footerMarginTop: 6,
	          bodyFontColor: 'rgba(38, 65, 74, 0.75)',
	          xPadding: 9,
	          yPadding: 9,
	          borderColor: 'rgba(39, 45, 57, 0.05)',
	          borderWidth: 1,
	          shadowOffsetX: 3,
	          shadowOffsetY: 3,
	          shadowBlur: 10,
	          shadowColor: 'rgba(39, 45, 57, 0.15)',
	          callbacks: {
	            title: function title(tooltipItem, data) {
	              if (!tooltipItem.length) return;
	
	              var _getDataListByType = (0, _utils.getDataListByType)({
	                formatMessage: formatMessage,
	                type: dataType,
	                item: {
	                  value: isCandleDataType ? data.datasets[tooltipItem[0].datasetIndex].ranges[tooltipItem[0].index] : tooltipItem[0].value,
	                  measuredAt: ''
	                },
	                isWeightInKg: isWeightMetricInKg,
	                isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	                isConvertedData: true
	              }),
	                  value = _getDataListByType.value,
	                  metric = _getDataListByType.metric;
	
	              return value + ' ' + metric;
	            },
	            afterFooter: function afterFooter(item, data) {
	              if (!item.length) return;
	              if (isCandleDataType || isGrafTypeLine) {
	                var sourceType = data.datasets[item[0].datasetIndex].sourceType.code;
	                if ([QUARTER.type, YEAR.type].includes(filterType) && isGrafTypeLine && sourceType === _constants.DATA_SOURCE_TYPE.CCD) {
	                  return formatMessage({
	                    id: 'patient.healthboard.clickSeeAllData'
	                  });
	                }
	              }
	            },
	            label: function label(tooltipItem, data) {
	              if (!tooltipItem) return;
	              var sourceData = data.datasets[tooltipItem.datasetIndex].sourceType.code;
	              return (0, _utils.getTooltipDate)(sourceData, data, tooltipItem, isCandleDataType, isGrafTypeLine, filterType);
	            },
	            footer: function footer(tooltipItem, data) {
	              if (!tooltipItem.length) return;
	              var tooltip = tooltipItem[0];
	              var sourceData = data.datasets[tooltip.datasetIndex].sourceType.title;
	              var sourceTypeDataCode = data.datasets[tooltip.datasetIndex].sourceType.code;
	              var sourceDataCodes = data.datasets[tooltip.datasetIndex].sourceType.codes;
	              if (sourceDataCodes) {
	                var tooltipDate = (0, _utils.getTooltipDate)(sourceTypeDataCode, data, tooltip, isCandleDataType, isGrafTypeLine, filterType);
	                var sourceCode = (0, _utils.sourceDataCodeFilteredByDate)(sourceDataCodes, filterType, tooltipDate, formatMessage, getSafeDataSourceTitle);
	                if (sourceCode) {
	                  return sourceCode;
	                }
	                return sourceData || '';
	              }
	
	              return sourceData || '';
	            }
	          }
	        },
	        onClick: function onClick(evt, element) {
	          if (element.length > 0) {
	            var allEntity = chartInstanceRef.current.chartInstance.data.optionsToolTip;
	            if (isCandleDataType) {
	              var indexActiveDataset = element[0]._chart.tooltip._active[0]._datasetIndex;
	              allEntity[indexActiveDataset][0].forEach(function (item, index) {
	                if (index === element[0]._index && item.keepTooltipOpen) {
	                  // eslint-disable-next-line no-param-reassign
	                  item.keepTooltipOpen = false;
	                  // eslint-disable-next-line no-param-reassign
	                } else item.keepTooltipOpen = index === element[0]._index;
	              });
	            } else {
	              // eslint-disable-next-line no-param-reassign,no-return-assign
	              allEntity.forEach(function (item, index) {
	                if (index === element[0]._index && item.keepTooltipOpen) {
	                  // eslint-disable-next-line no-param-reassign
	                  item.keepTooltipOpen = false;
	                  // eslint-disable-next-line no-param-reassign
	                } else item.keepTooltipOpen = index === element[0]._index;
	              });
	            }
	          }
	        }
	      };
	    };
	  }, [dataType, singleDayMode, isWeightInKg, isCandleDataType, filterType, isWithoutLimit, isMilligramsPerDeciliter]);
	
	  return {
	    data: adaptEntityForGraf(),
	    options: getGlobalOptionsForChart(dataType, isWeightInKg),
	    isGrafTypeLine: isGrafTypeLine
	  };
	}

/***/ }),
/* 3465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.usePluginForChart = usePluginForChart;
	
	var _reactChartjs = __webpack_require__(1578);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function usePluginForChart(isGrafTypeLine, isCandleType) {
	  return [(0, _extends3.default)({
	    beforeRender: function beforeRender(chart) {
	      if (isGrafTypeLine) {
	        var dataset = chart.data.datasets[0];
	        var gradient = chart.ctx.createLinearGradient(0, 0, 0, chart.height ? chart.height - 40 : 0);
	        gradient.addColorStop(0, 'rgba(119, 177, 255, 0.7)');
	        gradient.addColorStop(1, 'rgba(255, 255, 255, 0.5)');
	        var model = chart.data.datasets[0]._meta[(0, _keys2.default)(dataset._meta)[0]].$filler.el._model;
	        model.backgroundColor = gradient;
	      }
	
	      var optionsToolTip = chart.data.optionsToolTip;
	      // eslint-disable-next-line no-param-reassign
	
	      chart.pluginTooltips = [];
	      if (isCandleType || isGrafTypeLine) {
	        if (optionsToolTip && optionsToolTip.length > 0) {
	          for (var i = 0; i < optionsToolTip.length; i++) {
	            for (var k = 0; k < optionsToolTip[i][0].length; k++) {
	              if (optionsToolTip[i][0].length > 0 && optionsToolTip[i][0][k] && optionsToolTip[i][0][k].keepTooltipOpen) {
	                chart.pluginTooltips.push(new _reactChartjs.Chart.Tooltip({
	                  _chart: chart.chart,
	                  _chartInstance: chart,
	                  _data: chart.data,
	                  _options: chart.options.tooltips,
	                  _active: [chart.getDatasetMeta(i).data[k]]
	                }, chart));
	              }
	            }
	          }
	        }
	      } else {
	        for (var _i = 0; _i < optionsToolTip.length; _i++) {
	          if (optionsToolTip[_i].keepTooltipOpen) {
	            chart.pluginTooltips.push(new _reactChartjs.Chart.Tooltip({
	              _chart: chart.chart,
	              _chartInstance: chart,
	              _data: chart.data,
	              _options: chart.options.tooltips,
	              _active: [chart.getDatasetMeta(0).data[_i]]
	            }, chart));
	          }
	        }
	      }
	    }
	  }, isGrafTypeLine && {
	    afterDraw: function afterDraw(chart) {
	      if (chart.tooltip._active && chart.tooltip._active.length) {
	        var activePoint = chart.controller.tooltip._active[0];
	        var ctx = chart.ctx;
	
	        var _activePoint$tooltipP = activePoint.tooltipPosition(),
	            x = _activePoint$tooltipP.x,
	            y = _activePoint$tooltipP.y;
	
	        var topY = y;
	        var bottomY = chart.scales['right-y-axis'].bottom;
	
	        ctx.save();
	        ctx.beginPath();
	        ctx.moveTo(x, topY);
	        ctx.lineTo(x, bottomY);
	        ctx.lineWidth = 1;
	        ctx.strokeStyle = '#e5e5e5';
	        ctx.stroke();
	        ctx.restore();
	      }
	    }
	  }, {
	    afterDatasetsDraw: function afterDatasetsDraw(chart, easing) {
	      _reactChartjs.Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
	        tooltip.initialize();
	        tooltip.update();
	        tooltip.pivot();
	        tooltip.transition(easing).draw();
	      });
	    }
	  })];
	}

/***/ }),
/* 3466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _isFinite = __webpack_require__(4294);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.useSaturationDataGraf = useSaturationDataGraf;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _merge = __webpack_require__(379);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _selectors = __webpack_require__(109);
	
	var _utils = __webpack_require__(78);
	
	var _constants = __webpack_require__(54);
	
	var _hooks = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SATURATION = _constants.VITALS_ACTIVITY_TYPE.SATURATION,
	    HEART_RATE = _constants.VITALS_ACTIVITY_TYPE.HEART_RATE,
	    BLOOD_GLUCOSE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE;
	var CCD = _constants.DATA_SOURCE_TYPE.CCD,
	    DEVICES = _constants.DATA_SOURCE_TYPE.DEVICES,
	    ALL_SOURCES = _constants.DATA_SOURCE_TYPE.ALL_SOURCES;
	function useSaturationDataGraf(_ref) {
	  var rowData = _ref.rowData,
	      activeFilter = _ref.activeFilter,
	      singleDayMode = _ref.singleDayMode,
	      options = _ref.options,
	      isCandleType = _ref.isCandleType,
	      sourceType = _ref.sourceType,
	      currentChartInstance = _ref.currentChartInstance,
	      formatMessage = _ref.formatMessage,
	      mainUser = _ref.mainUser,
	      targetUserFirstName = _ref.targetUserFirstName,
	      type = _ref.type,
	      isMilligramsPerDeciliter = _ref.isMilligramsPerDeciliter;
	
	  var isWithoutLimit = [HEART_RATE, BLOOD_GLUCOSE].includes(type);
	
	  var saturationDataEntity = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectSaturationMeasurementEntity));
	  var saturationDataModal = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectSaturationMeasurementModalHistoricList));
	  var heartRateDataEntity = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectHeartRateMeasurementEntity));
	  var heartRateDataModal = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectHeartRateMeasurementModalHistoricList));
	  var bloodGlucoseDataEntity = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBloodGlucoseMeasurementEntity), { type: type, isMilligramsPerDeciliter: isMilligramsPerDeciliter });
	  var bloodGlucoseDataModal = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBloodGlucoseMeasurementModalHistoricList), { type: type, isMilligramsPerDeciliter: isMilligramsPerDeciliter });
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    switch (type) {
	      case HEART_RATE:
	        return {
	          safeDataEntity: heartRateDataEntity,
	          safeDataModal: heartRateDataModal
	        };
	      case SATURATION:
	        return {
	          safeDataEntity: saturationDataEntity,
	          safeDataModal: saturationDataModal
	        };
	      case BLOOD_GLUCOSE:
	        return {
	          safeDataEntity: bloodGlucoseDataEntity,
	          safeDataModal: bloodGlucoseDataModal
	        };
	      default:
	        return {
	          safeDataEntity: [],
	          safeDataModal: []
	        };
	    }
	  }, [type, heartRateDataEntity, saturationDataEntity, bloodGlucoseDataEntity, heartRateDataModal, saturationDataModal, bloodGlucoseDataModal]),
	      safeDataEntity = _useMemo.safeDataEntity,
	      safeDataModal = _useMemo.safeDataModal;
	
	  var ccdSourceTooltipLabel = getSafeDataSourceTitle(CCD, formatMessage, mainUser, targetUserFirstName);
	
	  var deviceSourceTooltipLabel = getSafeDataSourceTitle(DEVICES, formatMessage, mainUser, targetUserFirstName);
	
	  var saturationDataModalDevices = (0, _utils.getSourceDataWithType)(safeDataModal, DEVICES);
	
	  var saturationDataModalCCD = (0, _utils.getSourceDataWithType)(safeDataModal, CCD);
	
	  var saturationDataDevices = (0, _utils.getSourceDataWithType)(safeDataEntity, DEVICES);
	
	  var saturationDataCCD = (0, _utils.getSourceDataWithType)(safeDataEntity, CCD);
	
	  var safeSaturationDataDevices = singleDayMode ? saturationDataModalDevices : saturationDataDevices;
	  var safeSaturationDataCCD = singleDayMode ? saturationDataModalCCD : saturationDataCCD;
	
	  var timeSetsCCD = (0, _utils.checkForAvailableSourceData)(safeSaturationDataCCD) ? (0, _utils.makeValueForGraf)(safeSaturationDataCCD.measurements, 'value', activeFilter, true, SATURATION, singleDayMode) : [];
	
	  var timeSetsDevices = (0, _utils.checkForAvailableSourceData)(safeSaturationDataDevices) ? (0, _utils.makeValueForGraf)(safeSaturationDataDevices.measurements, 'value', activeFilter, true, SATURATION, singleDayMode) : [];
	
	  (0, _react.useEffect)(function () {
	    if (currentChartInstance && currentChartInstance.chartInstance) {
	      currentChartInstance.chartInstance.update();
	    }
	  }, [currentChartInstance, sourceType]);
	
	  var _useMemo2 = (0, _react.useMemo)(function () {
	    return (0, _utils.makeSplitDataForSaturation)(safeSaturationDataDevices, activeFilter, isCandleType, isWithoutLimit);
	  }, [safeDataEntity, singleDayMode, safeDataModal, saturationDataModalDevices, activeFilter, isCandleType, safeSaturationDataDevices, isWithoutLimit]),
	      transparentDataEntityDevices = _useMemo2.transparentDataEntity,
	      valueDataEntityDevices = _useMemo2.valueDataEntity;
	
	  var _useMemo3 = (0, _react.useMemo)(function () {
	    return (0, _utils.makeSplitDataForSaturation)(safeSaturationDataCCD, activeFilter, isCandleType, isWithoutLimit);
	  }, [safeDataEntity, singleDayMode, safeDataModal, saturationDataModalCCD, safeSaturationDataCCD, activeFilter, isCandleType, isWithoutLimit]),
	      transparentDataEntityCCD = _useMemo3.transparentDataEntity,
	      valueDataEntityDevicesCCD = _useMemo3.valueDataEntity;
	
	  if (!isCandleType) return {};
	
	  var _makeValueForBothData = (0, _utils.makeValueForBothDataset)({
	    baseTimeArr: rowData.timeSets,
	    transparentEntity: transparentDataEntityDevices,
	    valueEntity: valueDataEntityDevices,
	    activeFilter: activeFilter,
	    dataType: type,
	    isWithoutLimit: isWithoutLimit,
	    isMilligramsPerDeciliter: isMilligramsPerDeciliter
	  }),
	      valueDataDevices = _makeValueForBothData.valueData,
	      transparentDataDevices = _makeValueForBothData.transparentData,
	      rangesDevices = _makeValueForBothData.ranges,
	      maxValueForRangeDevices = _makeValueForBothData.maxValueForRange,
	      minValueForRangeDevices = _makeValueForBothData.minValueForRange,
	      minLimitForYAxisDevices = _makeValueForBothData.minLimitForYAxis,
	      maxLimitForYAxisDevices = _makeValueForBothData.maxLimitForYAxis;
	
	  var _makeValueForBothData2 = (0, _utils.makeValueForBothDataset)({
	    baseTimeArr: rowData.timeSets,
	    transparentEntity: transparentDataEntityCCD,
	    valueEntity: valueDataEntityDevicesCCD,
	    activeFilter: activeFilter,
	    dataType: type,
	    isWithoutLimit: isWithoutLimit,
	    isMilligramsPerDeciliter: isMilligramsPerDeciliter
	  }),
	      valueDataCCD = _makeValueForBothData2.valueData,
	      transparentDataCCD = _makeValueForBothData2.transparentData,
	      rangesCCD = _makeValueForBothData2.ranges,
	      maxValueForRangeCCD = _makeValueForBothData2.maxValueForRange,
	      minValueForRangeCCD = _makeValueForBothData2.minValueForRange,
	      minLimitForYAxisCCD = _makeValueForBothData2.minLimitForYAxis,
	      maxLimitForYAxisCCD = _makeValueForBothData2.maxLimitForYAxis;
	
	  var _ref2 = function () {
	    switch (sourceType) {
	      case ALL_SOURCES:
	        return {
	          concatMinValueForRange: Math.min.apply(Math, (0, _toConsumableArray3.default)((0, _compact2.default)([minValueForRangeCCD, minValueForRangeDevices]))),
	          concatMaxValueForRange: Math.max.apply(Math, (0, _toConsumableArray3.default)((0, _compact2.default)([maxValueForRangeCCD, maxValueForRangeDevices]))),
	          concatMinLimitForYAxis: Math.min.apply(Math, (0, _toConsumableArray3.default)((0, _compact2.default)([minLimitForYAxisCCD, minLimitForYAxisDevices]))),
	          concatMaxLimitForYAxis: Math.max.apply(Math, (0, _toConsumableArray3.default)((0, _compact2.default)([maxLimitForYAxisCCD, maxLimitForYAxisDevices])))
	        };
	      case DEVICES:
	        return {
	          concatMinValueForRange: minValueForRangeDevices,
	          concatMaxValueForRange: maxValueForRangeDevices,
	          concatMinLimitForYAxis: minLimitForYAxisDevices,
	          concatMaxLimitForYAxis: maxLimitForYAxisDevices
	        };
	      case CCD:
	        return {
	          concatMinValueForRange: minValueForRangeCCD,
	          concatMaxValueForRange: maxValueForRangeCCD,
	          concatMinLimitForYAxis: minLimitForYAxisCCD,
	          concatMaxLimitForYAxis: maxLimitForYAxisCCD
	        };
	    }
	  }(),
	      concatMinValueForRange = _ref2.concatMinValueForRange,
	      concatMaxValueForRange = _ref2.concatMaxValueForRange,
	      concatMinLimitForYAxis = _ref2.concatMinLimitForYAxis,
	      concatMaxLimitForYAxis = _ref2.concatMaxLimitForYAxis;
	
	  var safeRangeTitle = concatMinValueForRange === concatMaxValueForRange ? concatMinValueForRange : ((0, _isFinite2.default)(concatMinValueForRange) ? (0, _utils.getConvertedSafeData)(concatMinValueForRange, {
	    type: type,
	    isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	    forRound: true
	  }) : '') + ' - ' + ((0, _isFinite2.default)(concatMaxValueForRange) ? (0, _utils.getConvertedSafeData)(concatMaxValueForRange, {
	    type: type,
	    isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	    forRound: true
	  }) : '');
	
	  var safeDataEntityDevices = safeDataEntity && safeDataEntity.length ? safeDataEntity[0] : [];
	  var safeDataModalDevices = safeDataModal && safeDataModal.length ? safeDataModal[0] : [];
	
	  var safeData = singleDayMode ? safeDataModalDevices : safeDataEntityDevices;
	  var datasets = [{
	    label: 'transparentDataDevices',
	    data: [DEVICES, ALL_SOURCES].includes(sourceType) ? transparentDataDevices : [],
	    backgroundColor: 'transparent',
	    pointHitRadius: 0,
	    hoverBorderWidth: 0,
	    barThickness: 'flex',
	    categoryPercentage: (0, _utils.getCategoryPercentageWithFilter)(activeFilter, singleDayMode, rangesDevices.length === 1, ALL_SOURCES !== sourceType),
	    barPercentage: 0.92,
	    ranges: rangesDevices,
	    stack: 1,
	    sourceType: {
	      title: deviceSourceTooltipLabel,
	      code: _constants.DATA_SOURCE_TYPE.DEVICES,
	      codes: safeData.measurements ? safeData.measurements.map(function (el) {
	        return {
	          providerCode: el.originalProviderCodes,
	          value: el.value,
	          measuredAt: el.measuredAt
	        };
	      }) : null
	    }
	  }, {
	    label: 'valueDataDevices',
	    data: [DEVICES, ALL_SOURCES].includes(sourceType) ? valueDataDevices : [],
	    backgroundColor: '#326cba',
	    hoverBackgroundColor: '#326cba',
	    hoverBorderWidth: 1,
	    barThickness: 'flex',
	    categoryPercentage: (0, _utils.getCategoryPercentageWithFilter)(activeFilter, singleDayMode, rangesDevices.length === 1, ALL_SOURCES !== sourceType),
	    barPercentage: 0.92,
	    ranges: rangesDevices,
	    stack: 1,
	    sourceType: {
	      title: deviceSourceTooltipLabel,
	      code: _constants.DATA_SOURCE_TYPE.DEVICES,
	      codes: safeData.measurements ? safeData.measurements.map(function (el) {
	        return {
	          providerCode: el.originalProviderCodes,
	          value: el.value,
	          measuredAt: el.measuredAt
	        };
	      }) : null
	    }
	  }, {
	    label: 'transparentDataCCD',
	    data: [CCD, ALL_SOURCES].includes(sourceType) ? transparentDataCCD : [],
	    backgroundColor: 'transparent',
	    pointHitRadius: 0,
	    hoverBorderWidth: 0,
	    barThickness: 'flex',
	    categoryPercentage: (0, _utils.getCategoryPercentageWithFilter)(activeFilter, singleDayMode, rangesCCD.length === 1, ALL_SOURCES !== sourceType),
	    barPercentage: 0.92,
	    ranges: rangesCCD,
	    stack: ALL_SOURCES === sourceType ? 2 : 1,
	    sourceType: { title: ccdSourceTooltipLabel, code: _constants.DATA_SOURCE_TYPE.CCD }
	  }, {
	    label: 'valueDataCCD',
	    data: [CCD, ALL_SOURCES].includes(sourceType) ? valueDataCCD : [],
	    backgroundColor: '#f87f5c',
	    hoverBackgroundColor: '#f87f5c',
	    hoverBorderWidth: 1,
	    barPercentage: 0.92,
	    categoryPercentage: (0, _utils.getCategoryPercentageWithFilter)(activeFilter, singleDayMode, rangesCCD.length === 1, ALL_SOURCES !== sourceType),
	    barThickness: 'flex',
	    ranges: rangesCCD,
	    stack: ALL_SOURCES === sourceType ? 2 : 1,
	    sourceType: { title: ccdSourceTooltipLabel, code: _constants.DATA_SOURCE_TYPE.CCD }
	  }];
	  var saturationData = (0, _extends3.default)({}, rowData, {
	    timeSets: { ccd: timeSetsCCD, devices: timeSetsDevices },
	    datasets: datasets,
	    averageOrTotal: (0, _extends3.default)({}, rowData.averageOrTotal, {
	      value: (0, _utils.checkForAvailableSourceData)(safeSaturationDataCCD) || (0, _utils.checkForAvailableSourceData)(safeSaturationDataDevices) ? safeRangeTitle : ''
	    }),
	    availableDataSource: {
	      ccd: (0, _utils.checkForAvailableSourceData)(safeSaturationDataCCD),
	      devices: (0, _utils.checkForAvailableSourceData)(safeSaturationDataDevices)
	    },
	    optionsToolTip: (0, _utils.createTooltips)(datasets)
	  });
	
	  var saturationOptions = (0, _merge2.default)((0, _extends3.default)({}, options), {
	    tooltips: {
	      filter: function filter(tooltips) {
	        return [1, 3].includes(tooltips.datasetIndex);
	      }
	    },
	    scales: {
	      yAxes: [{
	        ticks: {
	          min: concatMinLimitForYAxis < 0 ? 0 : concatMinLimitForYAxis,
	          max: concatMaxLimitForYAxis > 100 && !isWithoutLimit ? 100 : concatMaxLimitForYAxis
	        }
	      }]
	    }
	  });
	
	  return { saturationData: saturationData, saturationOptions: saturationOptions };
	}

/***/ }),
/* 3467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmptyState = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _addDataModal = __webpack_require__(880);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(78);
	
	var _constants = __webpack_require__(54);
	
	var _index = __webpack_require__(5043);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMBINED_ACTIVITY_TYPE = [_constants.VITALS_ACTIVITY_TYPE.HEIGHT, _constants.VITALS_ACTIVITY_TYPE.WEIGHT, _constants.VITALS_ACTIVITY_TYPE.BMI];
	
	var EmptyState = exports.EmptyState = function EmptyState(_ref) {
	  var formatMessage = _ref.formatMessage,
	      type = _ref.type,
	      isProvider = _ref.isProvider,
	      userId = _ref.userId,
	      mainUser = _ref.mainUser;
	
	  var _getTitleAndDescripti = (0, _utils.getTitleAndDescriptionEmptyState)({
	    formatMessage: formatMessage,
	    type: type,
	    isProvider: isProvider
	  }),
	      description = _getTitleAndDescripti.description,
	      titleButton = _getTitleAndDescripti.titleButton,
	      descriptionForAccount = _getTitleAndDescripti.descriptionForAccount,
	      withOutCapitalize = _getTitleAndDescripti.withOutCapitalize;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var handleClick = function handleClick() {
	    if (COMBINED_ACTIVITY_TYPE.includes(type)) {
	      dispatch(_addDataModal.addDataModalActions.open({ type: type }));
	    } else {
	      (0, _redirectUtils.redirectToSettings)(userId);
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(_Icon2.default, { name: 'ico-1000-graph', size: 60 }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.emptyStateDescription },
	      description
	    ),
	    descriptionForAccount && mainUser && _react2.default.createElement(
	      'div',
	      { className: _index2.default.emptyStateDescriptionAccount },
	      descriptionForAccount
	    ),
	    mainUser && titleButton && _react2.default.createElement(
	      _Button2.default,
	      {
	        color: 'accent',
	        className: (0, _classnames2.default)(_index2.default.addDataButton, (0, _defineProperty3.default)({}, _index2.default.capitalize, !withOutCapitalize)),
	        onClick: handleClick
	      },
	      titleButton
	    )
	  );
	};
	
	EmptyState.propTypes = {
	  formatMessage: PropTypes.func,
	  type: PropTypes.string,
	  isProvider: PropTypes.bool,
	  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  mainUser: PropTypes.bool
	};

/***/ }),
/* 3468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddBodyInfoForm = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(6);
	
	var _addHeightData = __webpack_require__(683);
	
	var addHeightData = _interopRequireWildcard(_addHeightData);
	
	var _addWeightData = __webpack_require__(684);
	
	var addWeightData = _interopRequireWildcard(_addWeightData);
	
	var _selectors = __webpack_require__(109);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _styles = __webpack_require__(18);
	
	var _ids = __webpack_require__(46);
	
	var _DatePickerCustom = __webpack_require__(234);
	
	var _DatePickerCustom2 = _interopRequireDefault(_DatePickerCustom);
	
	var _TimePickerInput = __webpack_require__(796);
	
	var _TimePickerInput2 = _interopRequireDefault(_TimePickerInput);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(957);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_BODY_INFO_FORM = _ids.IDS.PATIENT_PORTAL.ADD_BODY_INFO_FORM;
	var AddBodyInfoForm = exports.AddBodyInfoForm = function AddBodyInfoForm(_ref) {
	  var formatMessage = _ref.formatMessage,
	      modalMode = _ref.modalMode,
	      isHeightInMeters = _ref.isHeightInMeters,
	      isWeightInKg = _ref.isWeightInKg;
	
	  var currentTime = (0, _moment2.default)().format('h:mm A');
	
	  var _useFormState = (0, _useFormWithValidation.useFormState)((0, _defineProperty3.default)({}, ADD_BODY_INFO_FORM.TIME, currentTime)),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var currentDate = new Date();
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var pendingHeight = (0, _reactRedux.useSelector)(_selectors.selectAddHeightDataPending);
	  var pendingWeight = (0, _reactRedux.useSelector)(_selectors.selectAddWeightDataPending);
	  var combinedPending = pendingHeight || pendingWeight;
	  var combinedDisable = !formState[ADD_BODY_INFO_FORM.FEET] || !formState[ADD_BODY_INFO_FORM.INCH] || !formState[ADD_BODY_INFO_FORM.WEIGHT] || !formState[ADD_BODY_INFO_FORM.TIME] || combinedPending;
	
	  var handleSubmit = function handleSubmit(e) {
	    var _handleFormChange;
	
	    e.preventDefault();
	    var safeDate = (0, _moment2.default)(formState[ADD_BODY_INFO_FORM.DATE]).format('YYYY-MM-D');
	    var safeTime = formState[ADD_BODY_INFO_FORM.TIME] ? 'T' + formState[ADD_BODY_INFO_FORM.TIME] : 'T' + (0, _moment2.default)().format('hh:mm A');
	
	    var heightValue = isHeightInMeters ? parseInt(formState[ADD_BODY_INFO_FORM.FEET], 10) / 100 : (0, _utils.convertValueToMeters)(formState[ADD_BODY_INFO_FORM.FEET], formState[ADD_BODY_INFO_FORM.INCH]);
	    var weightValue = isWeightInKg ? parseInt(formState[ADD_BODY_INFO_FORM.WEIGHT], 10) : (0, _utils.convertValueWeightToKg)(formState[ADD_BODY_INFO_FORM.WEIGHT]);
	
	    dispatch(addHeightData.actions.send({
	      local_height_measurement: {
	        measured_at: (0, _moment2.default)(safeDate + safeTime, 'YYYY-MM-DThh:mm A').format(),
	        value: { baseValue: heightValue }
	      }
	    }));
	
	    dispatch(addWeightData.actions.send({
	      local_weight_measurement: {
	        measured_at: (0, _moment2.default)(safeDate + safeTime, 'YYYY-MM-DThh:mm A').format(),
	        value: { baseValue: weightValue }
	      }
	    }));
	
	    handleFormChange((_handleFormChange = {}, (0, _defineProperty3.default)(_handleFormChange, ADD_BODY_INFO_FORM.FEET, ''), (0, _defineProperty3.default)(_handleFormChange, ADD_BODY_INFO_FORM.INCH, ''), (0, _defineProperty3.default)(_handleFormChange, ADD_BODY_INFO_FORM.WEIGHT, ''), _handleFormChange));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.rootModalMode, modalMode)) },
	    !modalMode && _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      formatMessage({ id: 'patient.portal.emptyState.addData' }, {
	        type: formatMessage({ id: 'patient.portal.emptyState.bodyInfo' })
	      })
	    ),
	    combinedPending && _react2.default.createElement(_Loader2.default, { className: (0, _classnames2.default)(_index2.default.loader, _index2.default.loaderHeight) }),
	    _react2.default.createElement(
	      'form',
	      {
	        className: (0, _classnames2.default)(_index2.default.content, (0, _defineProperty3.default)({}, _index2.default.modalMode, modalMode)),
	        onSubmit: handleSubmit
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.dateWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.datePickerWrapper },
	          _react2.default.createElement(_DatePickerCustom2.default, {
	            value: formState[ADD_BODY_INFO_FORM.DATE] || currentDate,
	            label: formatMessage({ id: 'common.date' }),
	            name: ADD_BODY_INFO_FORM.DATE,
	            maxDate: new Date(),
	            formatDate: 'MMM D, YYYY',
	            onChange: function onChange(value) {
	              var _handleFormChange2;
	
	              return handleFormChange((_handleFormChange2 = {}, (0, _defineProperty3.default)(_handleFormChange2, ADD_BODY_INFO_FORM.DATE, value), (0, _defineProperty3.default)(_handleFormChange2, ADD_BODY_INFO_FORM.TIME, ''), _handleFormChange2));
	            },
	            disabled: combinedPending
	          }),
	          _react2.default.createElement(_Icon2.default, {
	            name: 'calendar',
	            style: { fill: _styles.COLORS.bluePrimary },
	            className: _index2.default.datePickerIcon
	          })
	        ),
	        _react2.default.createElement(_TimePickerInput2.default, {
	          time: (0, _utils.getCurrentTime)(),
	          value: formState[ADD_BODY_INFO_FORM.TIME],
	          name: ADD_BODY_INFO_FORM.TIME,
	          onChange: function onChange(value) {
	            return handleFormChange((0, _defineProperty3.default)({}, ADD_BODY_INFO_FORM.TIME, value.toUpperCase()));
	          },
	          label: formatMessage({ id: 'reports.time' }),
	          placeholder: formatMessage({ id: 'reports.time' }),
	          className: _index2.default.timePickerWrapper,
	          disabled: combinedPending,
	          validateTime: function validateTime(pickTime) {
	            return (0, _utils.validateFutureTime)(formatMessage, pickTime, formState[ADD_BODY_INFO_FORM.DATE]);
	          }
	        })
	      ),
	      _react2.default.createElement(_TextInput2.default, {
	        id: ADD_BODY_INFO_FORM.WEIGHT,
	        type: 'number',
	        label: formatMessage({ id: 'patient.healthboard.weight' }),
	        limit: 5,
	        isFractionNumber: true,
	        placeholder: formatMessage({
	          id: 'profile.section.unitsSettings.weight.metric.' + (isWeightInKg ? 'kilograms' : 'pounds')
	        }),
	        value: formState[ADD_BODY_INFO_FORM.WEIGHT],
	        onChange: function onChange(value) {
	          return handleFormChange((0, _defineProperty3.default)({}, ADD_BODY_INFO_FORM.WEIGHT, value));
	        },
	        className: _index2.default.weightInput,
	        disabled: combinedPending,
	        min: 1
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.heightInputWrapper },
	        _react2.default.createElement(_TextInput2.default, {
	          id: ADD_BODY_INFO_FORM.FEET,
	          type: 'number',
	          label: formatMessage({ id: 'patient.healthboard.height' }),
	          limit: isHeightInMeters ? 3 : 1,
	          isFractionNumber: true,
	          placeholder: formatMessage({
	            id: 'profile.section.unitsSettings.height.metric.' + (isHeightInMeters ? 'meters' : 'feet_and_inches')
	          }),
	          value: formState[ADD_BODY_INFO_FORM.FEET],
	          onChange: function onChange(value) {
	            return handleFormChange((0, _defineProperty3.default)({}, ADD_BODY_INFO_FORM.FEET, value));
	          },
	          className: (0, _classnames2.default)(_index2.default.weightInput, _index2.default.marginFirstChild),
	          disabled: combinedPending,
	          min: 1
	        }),
	        !isHeightInMeters && _react2.default.createElement(_TextInput2.default, {
	          id: ADD_BODY_INFO_FORM.INCH,
	          type: 'number',
	          limit: 2,
	          isFractionNumber: true,
	          placeholder: formatMessage({
	            id: 'patient.healthboard.height.metric.inches'
	          }),
	          value: formState[ADD_BODY_INFO_FORM.INCH],
	          onChange: function onChange(value) {
	            return handleFormChange((0, _defineProperty3.default)({}, ADD_BODY_INFO_FORM.INCH, value));
	          },
	          className: _index2.default.weightInput,
	          disabled: combinedPending
	        })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: ADD_BODY_INFO_FORM.ADD_BUTTON,
	          raised: true,
	          color: 'primary',
	          className: _index2.default.addButton,
	          disabled: combinedDisable
	        },
	        formatMessage({ id: 'common.add' })
	      )
	    )
	  );
	};
	
	AddBodyInfoForm.propTypes = {
	  formatMessage: PropTypes.func,
	  modalMode: PropTypes.bool,
	  isHeightInMeters: PropTypes.bool,
	  isWeightInKg: PropTypes.bool
	};

/***/ }),
/* 3469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddHeightForm = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(109);
	
	var _addHeightData = __webpack_require__(683);
	
	var addHeightData = _interopRequireWildcard(_addHeightData);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _styles = __webpack_require__(18);
	
	var _ids = __webpack_require__(46);
	
	var _DatePickerCustom = __webpack_require__(234);
	
	var _DatePickerCustom2 = _interopRequireDefault(_DatePickerCustom);
	
	var _TimePickerInput = __webpack_require__(796);
	
	var _TimePickerInput2 = _interopRequireDefault(_TimePickerInput);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(957);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_HEIGHT_FORM = _ids.IDS.PATIENT_PORTAL.ADD_HEIGHT_FORM;
	var AddHeightForm = exports.AddHeightForm = function AddHeightForm(_ref) {
	  var formatMessage = _ref.formatMessage,
	      modalMode = _ref.modalMode,
	      handleRedirect = _ref.handleRedirect,
	      isHeightInMeters = _ref.isHeightInMeters;
	
	  var currentTime = (0, _moment2.default)().format('h:mm A');
	
	  var _useFormState = (0, _useFormWithValidation.useFormState)((0, _defineProperty3.default)({}, ADD_HEIGHT_FORM.TIME, currentTime)),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var currentDate = new Date();
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var pending = (0, _reactRedux.useSelector)(_selectors.selectAddHeightDataPending);
	  var combinedDisable = !formState[ADD_HEIGHT_FORM.FEET] || !isHeightInMeters && !formState[ADD_HEIGHT_FORM.INCH] || !formState[ADD_HEIGHT_FORM.TIME] || pending;
	
	  var handleSubmit = function handleSubmit(e) {
	    var _handleFormChange;
	
	    e.preventDefault();
	    var safeDate = (0, _moment2.default)(formState[ADD_HEIGHT_FORM.DATE]).format('YYYY-MM-D');
	    var safeTime = formState[ADD_HEIGHT_FORM.TIME] ? 'T' + formState[ADD_HEIGHT_FORM.TIME] : 'T' + (0, _moment2.default)().format('hh:mm A');
	
	    var heightValue = isHeightInMeters ? parseInt(formState[ADD_HEIGHT_FORM.FEET], 10) / 100 : (0, _utils.convertValueToMeters)(formState[ADD_HEIGHT_FORM.FEET], formState[ADD_HEIGHT_FORM.INCH]);
	
	    dispatch(addHeightData.actions.send({
	      local_height_measurement: {
	        measured_at: (0, _moment2.default)(safeDate + safeTime, 'YYYY-MM-DThh:mm A').format(),
	        value: { baseValue: heightValue }
	      }
	    }));
	
	    handleFormChange((_handleFormChange = {}, (0, _defineProperty3.default)(_handleFormChange, ADD_HEIGHT_FORM.FEET, ''), (0, _defineProperty3.default)(_handleFormChange, ADD_HEIGHT_FORM.INCH, ''), _handleFormChange));
	
	    if (handleRedirect) {
	      handleRedirect();
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.rootModalMode, modalMode)) },
	    !modalMode && _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      formatMessage({ id: 'patient.portal.emptyState.addData' }, { type: formatMessage({ id: 'patient.healthboard.height' }) })
	    ),
	    pending && _react2.default.createElement(_Loader2.default, { className: (0, _classnames2.default)(_index2.default.loader, _index2.default.loaderHeight) }),
	    _react2.default.createElement(
	      'form',
	      {
	        className: (0, _classnames2.default)(_index2.default.content, (0, _defineProperty3.default)({}, _index2.default.modalMode, modalMode)),
	        onSubmit: handleSubmit
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.dateWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.datePickerWrapper },
	          _react2.default.createElement(_DatePickerCustom2.default, {
	            value: formState[ADD_HEIGHT_FORM.DATE] || currentDate,
	            label: formatMessage({ id: 'common.date' }),
	            name: ADD_HEIGHT_FORM.DATE,
	            maxDate: new Date(),
	            formatDate: 'MMM D, YYYY',
	            onChange: function onChange(value) {
	              var _handleFormChange2;
	
	              return handleFormChange((_handleFormChange2 = {}, (0, _defineProperty3.default)(_handleFormChange2, ADD_HEIGHT_FORM.DATE, value), (0, _defineProperty3.default)(_handleFormChange2, ADD_HEIGHT_FORM.TIME, ''), _handleFormChange2));
	            },
	            disabled: pending
	          }),
	          _react2.default.createElement(_Icon2.default, {
	            name: 'calendar',
	            style: { fill: _styles.COLORS.bluePrimary },
	            className: _index2.default.datePickerIcon
	          })
	        ),
	        _react2.default.createElement(_TimePickerInput2.default, {
	          value: formState[ADD_HEIGHT_FORM.TIME],
	          name: ADD_HEIGHT_FORM.TIME,
	          onChange: function onChange(value) {
	            return handleFormChange((0, _defineProperty3.default)({}, ADD_HEIGHT_FORM.TIME, value.toUpperCase()));
	          },
	          label: formatMessage({ id: 'reports.time' }),
	          placeholder: formatMessage({ id: 'reports.time' }),
	          className: _index2.default.timePickerWrapper,
	          disabled: pending,
	          validateTime: function validateTime(pickTime) {
	            return (0, _utils.validateFutureTime)(formatMessage, pickTime, formState[ADD_HEIGHT_FORM.DATE]);
	          },
	          time: (0, _utils.getCurrentTime)()
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.heightInputWrapper },
	        _react2.default.createElement(_TextInput2.default, {
	          id: ADD_HEIGHT_FORM.FEET,
	          type: 'number',
	          label: formatMessage({ id: 'patient.healthboard.height' }),
	          limit: isHeightInMeters ? 3 : 1,
	          isFractionNumber: true,
	          placeholder: formatMessage({
	            id: 'profile.section.unitsSettings.height.metric.' + (isHeightInMeters ? 'meters' : 'feet_and_inches')
	          }),
	          value: formState[ADD_HEIGHT_FORM.FEET],
	          onChange: function onChange(value) {
	            return handleFormChange((0, _defineProperty3.default)({}, ADD_HEIGHT_FORM.FEET, value));
	          },
	          className: (0, _classnames2.default)(_index2.default.weightInput, _index2.default.marginFirstChild),
	          disabled: pending,
	          min: 1
	        }),
	        !isHeightInMeters && _react2.default.createElement(_TextInput2.default, {
	          limit: 2,
	          type: 'number',
	          isFractionNumber: true,
	          disabled: pending,
	          id: ADD_HEIGHT_FORM.INCH,
	          className: _index2.default.weightInput,
	          value: formState[ADD_HEIGHT_FORM.INCH],
	          placeholder: formatMessage({
	            id: 'patient.healthboard.height.metric.inches'
	          }),
	          onChange: function onChange(value) {
	            return handleFormChange((0, _defineProperty3.default)({}, ADD_HEIGHT_FORM.INCH, value));
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: ADD_HEIGHT_FORM.ADD_BUTTON,
	          raised: true,
	          color: 'primary',
	          className: _index2.default.addButton,
	          disabled: combinedDisable
	        },
	        formatMessage({ id: 'common.add' })
	      )
	    )
	  );
	};
	
	AddHeightForm.propTypes = {
	  formatMessage: PropTypes.func,
	  modalMode: PropTypes.bool,
	  handleRedirect: PropTypes.func,
	  isHeightInMeters: PropTypes.bool
	};

/***/ }),
/* 3470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddWeightForm = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(6);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _selectors = __webpack_require__(109);
	
	var _addWeightData = __webpack_require__(684);
	
	var addWeightData = _interopRequireWildcard(_addWeightData);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _styles = __webpack_require__(18);
	
	var _ids = __webpack_require__(46);
	
	var _DatePickerCustom = __webpack_require__(234);
	
	var _DatePickerCustom2 = _interopRequireDefault(_DatePickerCustom);
	
	var _TimePickerInput = __webpack_require__(796);
	
	var _TimePickerInput2 = _interopRequireDefault(_TimePickerInput);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(957);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADD_WEIGHT_FORM = _ids.IDS.PATIENT_PORTAL.ADD_WEIGHT_FORM;
	var AddWeightForm = exports.AddWeightForm = function AddWeightForm(_ref) {
	  var formatMessage = _ref.formatMessage,
	      modalMode = _ref.modalMode,
	      isWeightInKg = _ref.isWeightInKg;
	
	  var currentTime = (0, _moment2.default)().format('h:mm A');
	
	  var _useFormState = (0, _useFormWithValidation.useFormState)((0, _defineProperty3.default)({}, ADD_WEIGHT_FORM.TIME, currentTime)),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var currentDate = new Date();
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var pending = (0, _reactRedux.useSelector)(_selectors.selectAddWeightDataPending);
	
	  var combinedDisable = !formState[ADD_WEIGHT_FORM.WEIGHT] || !formState[ADD_WEIGHT_FORM.TIME] || pending;
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    var safeDate = (0, _moment2.default)(formState[ADD_WEIGHT_FORM.DATE]).format('YYYY-MM-D');
	
	    var safeTime = formState[ADD_WEIGHT_FORM.TIME] ? 'T' + formState[ADD_WEIGHT_FORM.TIME] : 'T' + (0, _moment2.default)().format('hh:mm A');
	
	    var weightValue = isWeightInKg ? parseInt(formState[ADD_WEIGHT_FORM.WEIGHT], 10) : (0, _utils.convertValueWeightToKg)(formState[ADD_WEIGHT_FORM.WEIGHT]);
	
	    dispatch(addWeightData.actions.send({
	      local_weight_measurement: {
	        measured_at: (0, _moment2.default)(safeDate + safeTime, 'YYYY-MM-DThh:mm A').format(),
	        value: { baseValue: weightValue }
	      }
	    }));
	
	    handleFormChange((0, _defineProperty3.default)({}, ADD_WEIGHT_FORM.WEIGHT, ''));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.rootModalMode, modalMode)) },
	    !modalMode && _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      formatMessage({ id: 'patient.portal.emptyState.addData' }, { type: formatMessage({ id: 'patient.healthboard.weight' }) })
	    ),
	    pending && _react2.default.createElement(_Loader2.default, { className: _index2.default.loader }),
	    _react2.default.createElement(
	      'form',
	      {
	        className: (0, _classnames2.default)(_index2.default.content, (0, _defineProperty3.default)({}, _index2.default.modalMode, modalMode)),
	        onSubmit: handleSubmit
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.dateWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.datePickerWrapper },
	          _react2.default.createElement(_DatePickerCustom2.default, {
	            value: formState[ADD_WEIGHT_FORM.DATE] || currentDate,
	            label: formatMessage({ id: 'common.date' }),
	            name: ADD_WEIGHT_FORM.DATE,
	            maxDate: new Date(),
	            formatDate: 'MMM D, YYYY',
	            onChange: function onChange(value) {
	              var _handleFormChange2;
	
	              return handleFormChange((_handleFormChange2 = {}, (0, _defineProperty3.default)(_handleFormChange2, ADD_WEIGHT_FORM.DATE, value), (0, _defineProperty3.default)(_handleFormChange2, ADD_WEIGHT_FORM.TIME, ''), _handleFormChange2));
	            },
	            disabled: pending
	          }),
	          _react2.default.createElement(_Icon2.default, {
	            name: 'calendar',
	            style: { fill: _styles.COLORS.bluePrimary },
	            className: _index2.default.datePickerIcon
	          })
	        ),
	        _react2.default.createElement(_TimePickerInput2.default, {
	          value: formState[ADD_WEIGHT_FORM.TIME],
	          name: ADD_WEIGHT_FORM.TIME,
	          onChange: function onChange(value) {
	            return handleFormChange((0, _defineProperty3.default)({}, ADD_WEIGHT_FORM.TIME, value.toUpperCase()));
	          },
	          label: formatMessage({ id: 'reports.time' }),
	          placeholder: formatMessage({ id: 'reports.time' }),
	          className: _index2.default.timePickerWrapper,
	          disabled: pending,
	          validateTime: function validateTime(pickTime) {
	            return (0, _utils.validateFutureTime)(formatMessage, pickTime, formState[ADD_WEIGHT_FORM.DATE]);
	          },
	          time: (0, _utils.getCurrentTime)()
	        })
	      ),
	      _react2.default.createElement(_TextInput2.default, {
	        id: ADD_WEIGHT_FORM.WEIGHT,
	        type: 'number',
	        label: formatMessage({ id: 'patient.healthboard.weight' }),
	        limit: 5,
	        isFractionNumber: true,
	        placeholder: formatMessage({
	          id: 'profile.section.unitsSettings.weight.metric.' + (isWeightInKg ? 'kilograms' : 'pounds')
	        }),
	        value: formState[ADD_WEIGHT_FORM.WEIGHT],
	        onChange: function onChange(value) {
	          return handleFormChange((0, _defineProperty3.default)({}, ADD_WEIGHT_FORM.WEIGHT, value));
	        },
	        className: _index2.default.weightInput,
	        disabled: pending,
	        min: 1
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          id: ADD_WEIGHT_FORM.ADD_BUTTON,
	          raised: true,
	          color: 'primary',
	          className: _index2.default.addButton,
	          disabled: combinedDisable
	        },
	        formatMessage({ id: 'common.add' })
	      )
	    )
	  );
	};
	
	AddWeightForm.propTypes = {
	  formatMessage: PropTypes.func,
	  modalMode: PropTypes.bool,
	  isWeightInKg: PropTypes.bool
	};

/***/ }),
/* 3471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SaturationInfoForm = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _constants = __webpack_require__(54);
	
	var _index = __webpack_require__(957);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SaturationInfoForm = exports.SaturationInfoForm = function SaturationInfoForm(_ref) {
	  var formatMessage = _ref.formatMessage;
	
	  var handleOpenOuterLink = function handleOpenOuterLink() {
	    window.open(_constants.MAYO_CLINIC_URL, '_blank');
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      formatMessage({ id: 'patient.healthboard.saturation.info' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        formatMessage({ id: 'patient.healthboard.saturation.description' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.clinicDescriptionWrapper },
	        _react2.default.createElement(
	          'span',
	          { className: _index2.default.clinicDescription },
	          formatMessage({ id: 'patient.healthboard.saturation.mayoClinic' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: _index2.default.redirectLink, onClick: handleOpenOuterLink },
	          formatMessage({
	            id: 'patient.healthboard.saturation.mayoClinicTitle'
	          })
	        )
	      )
	    )
	  );
	};
	
	SaturationInfoForm.propTypes = {
	  formatMessage: PropTypes.func
	};

/***/ }),
/* 3472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.PatientPortalCategory = PatientPortalCategory;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ChatsList = __webpack_require__(1766);
	
	var _ChatsList2 = _interopRequireDefault(_ChatsList);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5044);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PatientPortalCategory(_ref) {
	  var handleSelectTab = _ref.handleSelectTab,
	      dependentList = _ref.dependentList,
	      toggleDrawer = _ref.toggleDrawer,
	      activeTab = _ref.activeTab,
	      tabs = _ref.tabs;
	
	  var handleChooseTab = function handleChooseTab(tab) {
	    handleSelectTab(tab);
	    toggleDrawer();
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_index2.default.panel, _index2.default.panelPrimary) },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.panelContainer },
	        _react2.default.createElement(_ChatsList2.default, {
	          minimized: true,
	          patientPortalContext: true,
	          patientPortalARList: dependentList
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_index2.default.panel, _index2.default.panelSecondary) },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.panelContainer },
	        tabs.length !== 0 && _react2.default.createElement(
	          'div',
	          { className: _index2.default.tabWrapper },
	          tabs.map(function (_ref2) {
	            var id = _ref2.id,
	                tab = _ref2.tab,
	                title = _ref2.title;
	            return _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.tab, (0, _defineProperty3.default)({}, _index2.default.tabActive, tab === activeTab)),
	                key: id,
	                onClick: function onClick() {
	                  return handleChooseTab(tab);
	                }
	              },
	              _react2.default.createElement(_Icon2.default, {
	                size: 24,
	                className: _index2.default.tabIcon,
	                name: 'icon-' + tab + '-white'
	              }),
	              title
	            );
	          })
	        )
	      )
	    )
	  );
	}
	
	PatientPortalCategory.propTypes = {
	  tabs: PropTypes.array,
	  handleSelectTab: PropTypes.func,
	  activeTab: PropTypes.string,
	  toggleDrawer: PropTypes.func,
	  dependentList: PropTypes.array
	};

/***/ }),
/* 3473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(23);
	
	var _popup = __webpack_require__(76);
	
	var _selectors2 = __webpack_require__(237);
	
	var _selectors3 = __webpack_require__(56);
	
	var _drawer = __webpack_require__(185);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoggedUser: (0, _selectors.isLoggedUserSelector)(state),
	    loggedUserId: (0, _selectors.loggedUserIdSelector)(state),
	    caregiverCirclePending: (0, _selectors2.selectCaregiverCirclePending)(state),
	    guardianDependentsList: (0, _selectors3.selectGuardianDependentsList)(state),
	    guardianCirclePending: (0, _selectors3.selectIsLoadingGuardianDependents)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  toggleDrawer: _drawer.actions.toggleVisibility,
	  showDependentCreatedModal: _popup.showDependentCreateModal
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var caregiverCirclePending = _ref.caregiverCirclePending,
	      guardianCirclePending = _ref.guardianCirclePending;
	  return {
	    pending: caregiverCirclePending || guardianCirclePending
	  };
	}));

/***/ }),
/* 3474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _routes = __webpack_require__(37);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _useCareUsers2 = __webpack_require__(1129);
	
	var _NavList = __webpack_require__(1760);
	
	var _NavList2 = _interopRequireDefault(_NavList);
	
	var _ContextBar = __webpack_require__(1102);
	
	var _ContextBar2 = _interopRequireDefault(_ContextBar);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _PatientPortalCategory = __webpack_require__(3472);
	
	var _enhance = __webpack_require__(3473);
	
	var _dependentStatusCheck = __webpack_require__(1920);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Navigation(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      isLoggedUser = _ref.isLoggedUser,
	      toggleDrawer = _ref.toggleDrawer,
	      pending = _ref.pending,
	      userId = _ref.userId,
	      loggedUserId = _ref.loggedUserId,
	      setTargetUserId = _ref.setTargetUserId,
	      tabs = _ref.tabs,
	      handleSelectTab = _ref.handleSelectTab,
	      activeTab = _ref.activeTab,
	      showDependentCreatedModal = _ref.showDependentCreatedModal,
	      guardianDependentsList = _ref.guardianDependentsList;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      expanded = _useState2[0],
	      setExpanded = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    if (activeTab && !expanded) {
	      handleSelectTab(activeTab);
	      setExpanded(true);
	    }
	  }, [activeTab]);
	
	  var handleClickOnPerson = function handleClickOnPerson(id) {
	    var isVerified = (0, _dependentStatusCheck.dependentStatusCheck)({
	      id: id,
	      guardianDependentsList: guardianDependentsList,
	      showDependentCreatedModal: showDependentCreatedModal
	    });
	    if (!isVerified) return;
	
	    _reactRouter.browserHistory.push('' + _routes.PATIENT_HEALTHBOARD);
	    setTargetUserId({ id: id });
	    if (!(0, _mobileHelpers.isDesktop)()) toggleDrawer();
	    setExpanded(true);
	  };
	
	  var handleBackButton = function handleBackButton() {
	    setExpanded(false);
	  };
	
	  var _useCareUsers = (0, _useCareUsers2.useCareUsers)(),
	      makeNavList = _useCareUsers.makeNavList,
	      getTargetUser = _useCareUsers.getTargetUser;
	
	  var navigationList = makeNavList(formatMessage);
	  var targetUser = getTargetUser(userId);
	
	  var getContextTitle = (0, _react.useCallback)(function () {
	    if (isLoggedUser) {
	      return formatMessage({ id: 'general.labels.me' });
	    }
	    return (0, _get2.default)(targetUser, 'displayableName');
	  }, [isLoggedUser, targetUser]);
	
	  var dependentList = (0, _react.useMemo)(function () {
	    var tempList = [];
	    navigationList.forEach(function (_ref2) {
	      var list = _ref2.list;
	
	      list.forEach(function (item) {
	        tempList.push({
	          contextUser: {
	            avatar: item.avatar,
	            id: item.id,
	            displayableName: item.displayableName,
	            status: item.status
	          }
	        });
	      });
	    });
	    return tempList;
	  }, [navigationList]);
	
	  if (pending) return _react2.default.createElement(_Loader2.default, null);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_ContextBar2.default, {
	      onClick: handleBackButton,
	      contextTitle: getContextTitle(),
	      contextSubtitle: formatMessage({
	        id: 'chat.title.inContextOf'
	      }),
	      expanded: expanded,
	      title: formatMessage({ id: 'general.labels.profiles' }),
	      transparent: !expanded
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'list pl0' },
	      !expanded && navigationList.map(function (item) {
	        return _react2.default.createElement(_NavList2.default, {
	          title: item.title,
	          list: item.list,
	          key: item.key,
	          activeUserId: userId,
	          onClick: handleClickOnPerson,
	          loggedUserId: loggedUserId,
	          subtitleContext: formatMessage({ id: 'general.labels.me' })
	        });
	      }),
	      expanded && _react2.default.createElement(_PatientPortalCategory.PatientPortalCategory, {
	        formatMessage: formatMessage,
	        activeTab: activeTab,
	        handleSelectTab: handleSelectTab,
	        toggleDrawer: toggleDrawer,
	        dependentList: dependentList,
	        tabs: tabs
	      })
	    )
	  );
	}
	
	Navigation.propTypes = {
	  intl: PropTypes.object,
	  isLoggedUser: PropTypes.bool,
	  toggleDrawer: PropTypes.func,
	  pending: PropTypes.bool,
	  userId: PropTypes.number,
	  setTargetUserId: PropTypes.func,
	  tabs: PropTypes.array,
	  handleSelectTab: PropTypes.func,
	  activeTab: PropTypes.string,
	  showDependentCreatedModal: PropTypes.func,
	  guardianDependentsList: PropTypes.arrayOf(PropTypes.object),
	  loggedUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	
	exports.default = (0, _enhance.enhance)(Navigation);

/***/ }),
/* 3475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _chatMembersModal = __webpack_require__(1290);
	
	var _selectors = __webpack_require__(23);
	
	var _utils = __webpack_require__(78);
	
	var _utils2 = __webpack_require__(193);
	
	var _index = __webpack_require__(5045);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityLog = function ActivityLog(_ref) {
	  var entity = _ref.entity,
	      formatMessage = _ref.formatMessage;
	
	  var _ref2 = entity || {},
	      _ref2$requesterUser = _ref2.requesterUser,
	      requesterUser = _ref2$requesterUser === undefined ? {} : _ref2$requesterUser,
	      createdAt = _ref2.createdAt,
	      category = _ref2.category,
	      chatroomName = _ref2.chatroomName,
	      chatShareEventParticipants = _ref2.chatShareEventParticipants,
	      filename = _ref2.filename,
	      messageType = _ref2.messageType,
	      ipAddress = _ref2.ipAddress,
	      email = _ref2.email,
	      title = _ref2.title;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var loggedUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	
	  var user = formatMessage({
	    id: 'patient.portal.healthRecord.activityLog.user'
	  });
	
	  var verifySafeUserRole = function verifySafeUserRole() {
	    return requesterUser.requesterUserId === loggedUserId ? formatMessage({
	      id: 'patient.portal.healthRecord.activityLog.you'
	    }) : (0, _utils2.getSafeRole)(requesterUser.role, formatMessage);
	  };
	
	  var safeUserName = ipAddress && !requesterUser.requesterUserId ? user + ' ' + ipAddress : (requesterUser.firstName || '') + ' ' + (requesterUser.lastName || '');
	  var safeRole = ipAddress && !requesterUser.requesterUserId ? '' : verifySafeUserRole();
	  var safeAction = (0, _utils2.getSafeAction)(messageType, category, title, filename, chatroomName, email, chatShareEventParticipants, formatMessage);
	  var handleOpenSeeMembersModal = function handleOpenSeeMembersModal() {
	    dispatch(_chatMembersModal.chatMembersModalActions.open({
	      date: createdAt ? (0, _utils.formatDate)(createdAt, 'MMM D, Y h:mm A') : '',
	      chatRoomName: chatroomName,
	      memberList: chatShareEventParticipants
	    }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.leftSideWrapper },
	      _react2.default.createElement(_SimpleAvatar2.default, {
	        className: _index2.default.avatar,
	        text: (0, _get2.default)(requesterUser, 'firstName') || user,
	        src: (0, _get2.default)(requesterUser.avatar, 'thumbMin'),
	        size: 32
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        _react2.default.createElement(
	          'span',
	          null,
	          safeUserName + ' ' + (safeRole ? '(' + safeRole + ')' : '') + ' ' + safeAction,
	          _react2.default.createElement(
	            'span',
	            null,
	            chatShareEventParticipants.length > 0 && _react2.default.createElement(
	              _react.Fragment,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                ' - '
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  className: _index2.default.actionButton,
	                  onClick: handleOpenSeeMembersModal
	                },
	                formatMessage({
	                  id: 'patient.portal.healthRecord.activityLog.seeMembers'
	                })
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.date },
	      createdAt ? (0, _utils.formatDate)(createdAt, 'MMM D, Y h:mm A') : ''
	    )
	  );
	};
	
	ActivityLog.propTypes = {
	  entity: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = ActivityLog;

/***/ }),
/* 3476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _constants = __webpack_require__(54);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllergiesCard = function AllergiesCard(_ref) {
	  var entity = _ref.entity,
	      formatMessage = _ref.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeCard = _useState2[0],
	      setActiveCard = _useState2[1];
	
	  var name = entity.name,
	      startDate = entity.startDate,
	      severity = entity.severity,
	      allergyType = entity.allergyType,
	      reaction = entity.reaction,
	      isPrivate = entity.isPrivate;
	
	  var applyStyleForSeverity = (0, _react.useCallback)(function (type) {
	    switch (type) {
	      case _constants.ALLERGIE_TYPE.SEVERE:
	        return (0, _classnames2.default)(_index2.default.context, _index2.default.severityPink);
	      case _constants.ALLERGIE_TYPE.MODERATE:
	        return (0, _classnames2.default)(_index2.default.context, _index2.default.severityModerate);
	      case _constants.ALLERGIE_TYPE.MILD:
	        return (0, _classnames2.default)(_index2.default.context, _index2.default.severityGreen);
	      default:
	        return _index2.default.context;
	    }
	  }, [severity]);
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        _react2.default.createElement(_Icon2.default, {
	          size: 28,
	          name: 'icon-allergies-black',
	          className: _index2.default.iconType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.titleWrapper, (0, _defineProperty3.default)({}, _index2.default.noTitle, !name))
	              },
	              name
	            ),
	            _react2.default.createElement(_PrivacyIcon2.default, { show: isPrivate, className: _index2.default.privacyIcon })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.description },
	            reaction || ''
	          )
	        )
	      ),
	      _react2.default.createElement(_Icon2.default, {
	        size: 16,
	        name: activeCard ? 'icon-arrow-up' : 'icon-arrow-down',
	        className: _index2.default.icon,
	        onClick: function onClick() {
	          return setActiveCard(!activeCard);
	        }
	      })
	    ),
	    activeCard && _react2.default.createElement(
	      'div',
	      { className: _index2.default.activeCardRoot },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.columnWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({
	              id: 'patient.portal.allergies.severity'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({ id: 'patient.portal.allergies.type' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: applyStyleForSeverity(severity) },
	            severity || ''
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.context },
	            allergyType || ''
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.columnWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({
	              id: 'patient.portal.allergies.effectiveDate'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.context },
	            startDate ? (0, _utils.formatDate)(startDate, 'MMM D, Y') : ''
	          )
	        )
	      )
	    )
	  );
	};
	
	AllergiesCard.propTypes = {
	  entity: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = AllergiesCard;

/***/ }),
/* 3477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConditionCard = function ConditionCard(_ref) {
	  var entity = _ref.entity;
	  var name = entity.name,
	      startDate = entity.startDate,
	      isPrivate = entity.isPrivate;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        _react2.default.createElement(_Icon2.default, {
	          size: 28,
	          name: 'icon-conditions-black',
	          className: _index2.default.iconType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_index2.default.title, _index2.default.cropConditionsTitle) },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.titleWrapper, (0, _defineProperty3.default)({}, _index2.default.noTitle, !name))
	              },
	              name
	            ),
	            _react2.default.createElement(_PrivacyIcon2.default, { show: isPrivate, className: _index2.default.privacyIcon })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.description },
	            startDate ? (0, _utils.formatDate)(startDate, 'MMM D, Y') : ''
	          )
	        )
	      )
	    )
	  );
	};
	
	ConditionCard.propTypes = {
	  entity: _propTypes2.default.object
	};
	
	exports.default = ConditionCard;

/***/ }),
/* 3478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(78);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _constants = __webpack_require__(54);
	
	var _selectors = __webpack_require__(23);
	
	var _loggingActionReq = __webpack_require__(663);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(5046);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionType = _constants.ACTIVITY_LOG_USER_ACTION_TYPE.VIEW;
	
	
	var EncounterCard = function EncounterCard(_ref) {
	  var entity = _ref.entity,
	      formatMessage = _ref.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var userId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeCard = _useState2[0],
	      setActiveCard = _useState2[1];
	
	  var _entity = (0, _extends3.default)({}, entity),
	      date = _entity.date,
	      description = _entity.description,
	      diagnosis = _entity.diagnosis,
	      providerLocation = _entity.providerLocation,
	      providerProfile = _entity.providerProfile,
	      isPrivate = _entity.isPrivate,
	      _entity$ccdaUserDocum = _entity.ccdaUserDocuments,
	      ccdaUserDocuments = _entity$ccdaUserDocum === undefined ? [] : _entity$ccdaUserDocum;
	
	  var _ref2 = providerProfile || {},
	      firstName = _ref2.firstName,
	      lastName = _ref2.lastName,
	      credential = _ref2.credential;
	
	  var safeProviderName = (firstName || '') + ' ' + (lastName || '') + (credential ? ', ' + credential : '');
	
	  var documents = (0, _react.useMemo)(function () {
	    return ccdaUserDocuments.filter(function (_ref3) {
	      var _ref3$files = _ref3.files,
	          files = _ref3$files === undefined ? [] : _ref3$files;
	      return Boolean(files.length);
	    });
	  }, [ccdaUserDocuments]);
	
	  var viewDocument = (0, _react.useCallback)(function (_ref4) {
	    var url = _ref4.url,
	        documentUid = _ref4.documentUid;
	
	    window.open(url);
	    dispatch(_loggingActionReq.actions.send({ userId: userId, documentUid: documentUid, actionType: actionType }));
	  }, [userId]);
	
	  var cardData = [{
	    content: providerLocation,
	    meta: formatMessage({ id: 'profile.fields.location' })
	  }, {
	    content: diagnosis,
	    meta: formatMessage({ id: 'patient.portal.diagnosis' })
	  }, {
	    meta: formatMessage({ id: 'common.documents' }),
	    content: documents.length && documents.map(function (_ref5) {
	      var files = _ref5.files,
	          filename = _ref5.filename,
	          documentUid = _ref5.documentUid,
	          title = _ref5.title;
	      return files.map(function (_ref6) {
	        var url = _ref6.url,
	            extension = _ref6.extension;
	        return _react2.default.createElement(
	          'div',
	          {
	            key: url,
	            className: _index4.default.file,
	            onClick: function onClick() {
	              return viewDocument({ url: url, documentUid: documentUid });
	            }
	          },
	          _react2.default.createElement(_Icon2.default, { size: 32, name: 'icon-document-black' }),
	          _react2.default.createElement(
	            'span',
	            { className: _index4.default.filename },
	            title || filename.split('.')[0] + '.' + extension
	          )
	        );
	      });
	    })
	  }];
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        _react2.default.createElement(_Icon2.default, {
	          size: 28,
	          name: 'icon-encounters-black',
	          className: _index2.default.iconType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.titleWrapper, (0, _defineProperty3.default)({}, _index2.default.noTitle, !description))
	              },
	              description
	            ),
	            _react2.default.createElement(_PrivacyIcon2.default, { show: isPrivate, className: _index2.default.privacyIcon })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.descriptionWrapper },
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.description },
	              safeProviderName
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.description },
	              date ? (0, _utils.formatDate)(date, 'MMM D, Y h:mm A') : ''
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Icon2.default, {
	        size: 16,
	        name: activeCard ? 'icon-arrow-up' : 'icon-arrow-down',
	        className: _index2.default.icon,
	        onClick: function onClick() {
	          return setActiveCard(!activeCard);
	        }
	      })
	    ),
	    activeCard && _react2.default.createElement(
	      'div',
	      { className: _index4.default.card },
	      cardData.map(function (_ref7) {
	        var meta = _ref7.meta,
	            content = _ref7.content;
	        return _react2.default.createElement(
	          'div',
	          { style: { display: 'flex' } },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_index2.default.meta, _index4.default.meta) },
	            meta
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_index2.default.fullContent, _index4.default.content) },
	            content || _react2.default.createElement(
	              'span',
	              null,
	              '\u2014'
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	EncounterCard.propTypes = {
	  entity: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = EncounterCard;

/***/ }),
/* 3479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FamilyHistoryCard = function FamilyHistoryCard(_ref) {
	  var entity = _ref.entity;
	  var condition = entity.condition,
	      startDate = entity.startDate,
	      isPrivate = entity.isPrivate;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        _react2.default.createElement(_Icon2.default, {
	          size: 28,
	          name: 'icon-family-history-black',
	          className: _index2.default.iconType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.titleWrapper, (0, _defineProperty3.default)({}, _index2.default.noTitle, !condition))
	              },
	              condition
	            ),
	            _react2.default.createElement(_PrivacyIcon2.default, { show: isPrivate, className: _index2.default.privacyIcon })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.description },
	            startDate ? (0, _utils.formatDate)(startDate, 'MMM D, Y') : ''
	          )
	        )
	      )
	    )
	  );
	};
	
	FamilyHistoryCard.propTypes = {
	  entity: _propTypes2.default.object
	};
	
	exports.default = FamilyHistoryCard;

/***/ }),
/* 3480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ids = __webpack_require__(46);
	
	var _IconMenu = __webpack_require__(337);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(78);
	
	var _utils2 = __webpack_require__(193);
	
	var _useMenuItemBuilder2 = __webpack_require__(3481);
	
	var _constants = __webpack_require__(54);
	
	var _index = __webpack_require__(5047);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOWNLOAD = _constants.ACTIVITY_LOG_USER_ACTION_TYPE.DOWNLOAD,
	    VIEW = _constants.ACTIVITY_LOG_USER_ACTION_TYPE.VIEW;
	
	
	var HealthRecordCard = function HealthRecordCard(_ref) {
	  var entity = _ref.entity,
	      formatMessage = _ref.formatMessage;
	  var createdAt = entity.createdAt,
	      title = entity.title,
	      filename = entity.filename,
	      isPrivate = entity.isPrivate,
	      effectiveTime = entity.effectiveTime;
	
	  var _useMenuItemBuilder = (0, _useMenuItemBuilder2.useMenuItemBuilder)(formatMessage, entity),
	      shareItems = _useMenuItemBuilder.shareItems,
	      downloadItems = _useMenuItemBuilder.downloadItems,
	      openItems = _useMenuItemBuilder.openItems,
	      _useMenuItemBuilder$a = _useMenuItemBuilder.anyTypeFileData,
	      anyTypeFileData = _useMenuItemBuilder$a === undefined ? {} : _useMenuItemBuilder$a,
	      isXmlFormat = _useMenuItemBuilder.isXmlFormat,
	      isTxtFormat = _useMenuItemBuilder.isTxtFormat,
	      isConvertibleToPdfData = _useMenuItemBuilder.isConvertibleToPdfData,
	      loggingEvent = _useMenuItemBuilder.loggingEvent;
	
	  var optionMenuView = isXmlFormat || isTxtFormat || isConvertibleToPdfData;
	
	  var handleViewFile = function handleViewFile() {
	    if (!optionMenuView) {
	      loggingEvent(VIEW);
	      window.open(anyTypeFileData.url, '_blank');
	    }
	  };
	
	  var handleDownloadFile = function handleDownloadFile() {
	    if (!optionMenuView) {
	      loggingEvent(DOWNLOAD);
	      (0, _utils2.downloadFile)(anyTypeFileData.url, anyTypeFileData.extension, title, anyTypeFileData.mimeType);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.leftSideWrapper },
	      _react2.default.createElement(_Icon2.default, { size: 32, name: 'icon-document-black' }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.contentCard },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.title },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.titleWrapper },
	            title || filename
	          ),
	          _react2.default.createElement(_PrivacyIcon2.default, { show: isPrivate, className: _index2.default.privacyIcon })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.date },
	          (0, _utils.formatDate)(effectiveTime || createdAt, 'MMM D, Y')
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.rightSideWrapper },
	      _react2.default.createElement(_IconMenu2.default, {
	        id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.VIEW_RECORD,
	        icon: { size: 20, name: 'icon-eye-menu' },
	        position: { horizontal: 'left', vertical: 'bottom' },
	        items: openItems,
	        iconActionMode: !optionMenuView,
	        onClick: handleViewFile,
	        allScreens: true
	      }),
	      _react2.default.createElement(_IconMenu2.default, {
	        id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.DOWNLOAD_RECORD,
	        icon: { size: 20, name: 'icon-download' },
	        position: { horizontal: 'left', vertical: 'bottom' },
	        items: downloadItems,
	        iconActionMode: !optionMenuView,
	        onClick: handleDownloadFile,
	        allScreens: true
	      }),
	      _react2.default.createElement(_IconMenu2.default, {
	        id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.SHARE_RECORD,
	        icon: { size: 20, name: 'icon-share' },
	        position: { horizontal: 'left', vertical: 'bottom' },
	        items: shareItems,
	        allScreens: true
	      })
	    )
	  );
	};
	
	HealthRecordCard.propTypes = {
	  entity: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = HealthRecordCard;

/***/ }),
/* 3481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useMenuItemBuilder = useMenuItemBuilder;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _patientChannelsForShare = __webpack_require__(1300);
	
	var _socialChannelsForShare = __webpack_require__(1306);
	
	var _loggingActionReq = __webpack_require__(663);
	
	var _shareToChatModal = __webpack_require__(848);
	
	var _shareToEmailModal = __webpack_require__(1305);
	
	var _chat = __webpack_require__(67);
	
	var _ids = __webpack_require__(46);
	
	var _constants = __webpack_require__(54);
	
	var _selectors = __webpack_require__(23);
	
	var _utils = __webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PDF = _constants.HEALTH_RECORD_DOC_TYPE.PDF,
	    ZIP = _constants.HEALTH_RECORD_DOC_TYPE.ZIP;
	var DOWNLOAD = _constants.ACTIVITY_LOG_USER_ACTION_TYPE.DOWNLOAD,
	    VIEW = _constants.ACTIVITY_LOG_USER_ACTION_TYPE.VIEW;
	function useMenuItemBuilder(formatMessage, entity) {
	  var documentUid = entity.documentUid,
	      title = entity.title,
	      files = entity.files;
	
	  var _parseFileAttribute = (0, _utils.parseFileAttribute)(files),
	      zipFileData = _parseFileAttribute.zipFileData,
	      pdfFileData = _parseFileAttribute.pdfFileData,
	      xmlFileData = _parseFileAttribute.xmlFileData,
	      isXmlFormat = _parseFileAttribute.isXmlFormat,
	      isTxtFormat = _parseFileAttribute.isTxtFormat,
	      isPdfFormat = _parseFileAttribute.isPdfFormat,
	      txtFileData = _parseFileAttribute.txtFileData,
	      anyTypeFileData = _parseFileAttribute.anyTypeFileData;
	
	  var mainUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	  var targetUserId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	
	  var _getSafeUserId = (0, _utils.getSafeUserId)(targetUserId, mainUserId),
	      safeUserId = _getSafeUserId.safeUserId;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var safeEntityCCD = isXmlFormat ? xmlFileData : txtFileData;
	  var safeTitleOpenItems = isXmlFormat ? 'CCD' : 'TXT';
	  var isConvertibleToPdfData = !isXmlFormat && !isTxtFormat && isPdfFormat && files && files.length >= 1;
	
	  var fileType = (0, _get2.default)(files.find(function (file) {
	    return file.extension !== PDF.fileType;
	  }), 'extension', '') || '';
	  var getFileTypeWithoutPdf = fileType.toUpperCase() || 'CCD';
	
	  var loggingEvent = function loggingEvent(eventType) {
	    dispatch(_loggingActionReq.actions.send({
	      userId: safeUserId,
	      actionType: eventType,
	      documentUid: documentUid
	    }));
	  };
	
	  var _openAsCCD$openAsPDF$ = {
	    openAsCCD: {
	      id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.OPEN_AS_CCD,
	      text: formatMessage({
	        id: 'patient.portal.healthRecord.openAs'
	      }, {
	        fileType: isConvertibleToPdfData ? getFileTypeWithoutPdf : safeTitleOpenItems
	      }),
	      onClick: function onClick() {
	        loggingEvent(VIEW);
	        window.open(safeEntityCCD.url, '_blank');
	      }
	    },
	    openAsPDF: {
	      id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.OPEN_AS_PDF,
	      text: formatMessage({ id: 'patient.portal.healthRecord.openAsPDF' }),
	      onClick: function onClick() {
	        window.open(pdfFileData.url, '_blank');
	        loggingEvent(VIEW);
	      }
	    },
	    downloadAsCCD: {
	      id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.DOWNLOAD_AS_CCD,
	      text: formatMessage({
	        id: 'patient.portal.healthRecord.downloadAs'
	      }, {
	        fileType: isConvertibleToPdfData ? getFileTypeWithoutPdf : safeTitleOpenItems
	      }),
	      onClick: function onClick() {
	        (0, _utils.downloadFile)(safeEntityCCD.url, safeEntityCCD.extension, title, safeEntityCCD.mimeType);
	        loggingEvent(DOWNLOAD);
	      }
	    },
	    downloadAsPDF: {
	      id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.DOWNLOAD_AS_PDF,
	      text: formatMessage({ id: 'patient.portal.healthRecord.downloadAsPDF' }),
	      onClick: function onClick() {
	        (0, _utils.downloadFile)(pdfFileData.url, PDF.fileType, title, PDF.mimeType);
	        loggingEvent(DOWNLOAD);
	      }
	    },
	    downloadAsZIP: {
	      id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.DOWNLOAD_AS_ZIP,
	      text: formatMessage({ id: 'patient.portal.healthRecord.downloadAsCCD' }),
	      onClick: function onClick() {
	        (0, _utils.downloadFile)(zipFileData.url, ZIP.fileType, title, ZIP.mimeType);
	        loggingEvent(DOWNLOAD);
	      }
	    },
	    shareToChat: {
	      id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.SHARE_TO_CHAT,
	      text: formatMessage({ id: 'patient.portal.healthRecord.shareToChat' }),
	      onClick: function onClick() {
	        dispatch(_patientChannelsForShare.actions.send({
	          type: 'patient',
	          offset: 0,
	          limit: 1000
	        }));
	        if (_chat.ALLOW_SOCIAL_CHAT_CREATION) {
	          dispatch(_socialChannelsForShare.actions.send({
	            type: 'social',
	            offset: 0,
	            limit: 1000
	          }));
	        }
	        dispatch(_shareToChatModal.shareToChatModalActions.open({ documentUid: documentUid }));
	      }
	    },
	    shareToEmail: {
	      id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.SHARE_TO_EMAIL,
	      text: formatMessage({ id: 'patient.portal.healthRecord.shareToEmail' }),
	      onClick: function onClick() {
	        dispatch(_shareToEmailModal.shareToEmailModalActions.open({ documentUid: documentUid }));
	      }
	    }
	  },
	      openAsCCD = _openAsCCD$openAsPDF$.openAsCCD,
	      openAsPDF = _openAsCCD$openAsPDF$.openAsPDF,
	      downloadAsCCD = _openAsCCD$openAsPDF$.downloadAsCCD,
	      downloadAsPDF = _openAsCCD$openAsPDF$.downloadAsPDF,
	      shareToChat = _openAsCCD$openAsPDF$.shareToChat,
	      shareToEmail = _openAsCCD$openAsPDF$.shareToEmail,
	      downloadAsZIP = _openAsCCD$openAsPDF$.downloadAsZIP;
	
	
	  var withCCD = files.find(function (_ref) {
	    var extension = _ref.extension;
	    return ['xml', 'txt'].includes(extension);
	  });
	
	  var withPDF = files.find(function (_ref2) {
	    var extension = _ref2.extension;
	    return ['pdf'].includes(extension);
	  });
	
	  var withZIP = files.find(function (_ref3) {
	    var extension = _ref3.extension;
	    return ['zip'].includes(extension);
	  });
	
	  var downloadZIP = withZIP && downloadAsZIP;
	  var downloadCCD = withCCD && downloadAsCCD;
	
	  var shareItems = [shareToChat, shareToEmail];
	  var openItems = (0, _compact2.default)([withCCD && openAsCCD, withPDF && openAsPDF]);
	  var downloadItems = (0, _compact2.default)([downloadZIP || downloadCCD, withPDF && downloadAsPDF]);
	
	  return (0, _react.useMemo)(function () {
	    return {
	      openItems: openItems,
	      downloadItems: downloadItems,
	      shareItems: shareItems,
	      isXmlFormat: isXmlFormat,
	      isTxtFormat: isTxtFormat,
	      txtFileData: txtFileData,
	      anyTypeFileData: anyTypeFileData,
	      isConvertibleToPdfData: isConvertibleToPdfData,
	      loggingEvent: loggingEvent
	    };
	  }, [entity]);
	}

/***/ }),
/* 3482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImmunizationCard = function ImmunizationCard(_ref) {
	  var entity = _ref.entity;
	  var name = entity.name,
	      receivedAt = entity.receivedAt,
	      isPrivate = entity.isPrivate,
	      manufacturer = entity.manufacturer;
	
	  var safeTitle = manufacturer ? name + ', (' + manufacturer + ')' : name;
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        _react2.default.createElement(_Icon2.default, {
	          size: 28,
	          name: 'icon-vaccines-black',
	          className: _index2.default.iconType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.titleWrapper },
	              safeTitle
	            ),
	            _react2.default.createElement(_PrivacyIcon2.default, { show: isPrivate, className: _index2.default.privacyIcon })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.description },
	            receivedAt ? (0, _utils.formatDate)(receivedAt, 'MMM D, Y') : ''
	          )
	        )
	      )
	    )
	  );
	};
	
	ImmunizationCard.propTypes = {
	  entity: _propTypes2.default.object
	};
	
	exports.default = ImmunizationCard;

/***/ }),
/* 3483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HistoryNavigation = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5048);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HistoryNavigation = exports.HistoryNavigation = function HistoryNavigation(_ref) {
	  var componentAvailability = _ref.componentAvailability;
	
	  return componentAvailability && _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    _react2.default.createElement(_Icon2.default, { name: 'arrow-left', size: 24, className: _index2.default.arrowRight })
	  );
	};
	
	HistoryNavigation.propTypes = {
	  componentCode: _propTypes2.default.string
	};

/***/ }),
/* 3484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(2258);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabTestResultDetailsCardDocuments = function LabTestResultDetailsCardDocuments(_ref) {
	  var loggingView = _ref.loggingView,
	      formatMessage = _ref.formatMessage,
	      _ref$resultDocument = _ref.resultDocument,
	      resultDocument = _ref$resultDocument === undefined ? [] : _ref$resultDocument;
	
	  var globalDocument = (0, _get2.default)(resultDocument, '[0]', {});
	  var hasReferenceToPdf = !!globalDocument.files;
	
	  var handleOpenDocument = function handleOpenDocument(file) {
	    loggingView((0, _get2.default)(file, 'documentUid'));
	    window.open((0, _get2.default)(file, 'files[0].url'));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.documentsRoot },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.documentsTitle },
	      formatMessage({
	        id: 'common.documents'
	      })
	    ),
	    hasReferenceToPdf ? resultDocument.map(function (document) {
	      return _react2.default.createElement(
	        'div',
	        {
	          key: document.documentUid,
	          className: _index2.default.documentWrapper,
	          onClick: function onClick() {
	            return handleOpenDocument(document);
	          }
	        },
	        _react2.default.createElement(_Icon2.default, {
	          size: 32,
	          name: 'icon-document-black',
	          className: _index2.default.documentIcon
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.documentName },
	          document.title || ''
	        )
	      );
	    }) : _react2.default.createElement(
	      'div',
	      { className: _index2.default.notification },
	      formatMessage({
	        id: 'patient.portal.labTestResult.availablePdfIvy'
	      })
	    )
	  );
	};
	
	LabTestResultDetailsCardDocuments.propTypes = {
	  resultDocument: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  loggingView: _propTypes2.default.func
	};
	
	exports.default = LabTestResultDetailsCardDocuments;

/***/ }),
/* 3485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Marker = __webpack_require__(3486);
	
	var _Marker2 = _interopRequireDefault(_Marker);
	
	var _TestResultsScale = __webpack_require__(3487);
	
	var _TestResultsScale2 = _interopRequireDefault(_TestResultsScale);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _HistoryNavigation = __webpack_require__(3483);
	
	var _utils = __webpack_require__(193);
	
	var _constants = __webpack_require__(54);
	
	var _useLabTestResultDetailsData = __webpack_require__(3488);
	
	var _labResultHistoryModal = __webpack_require__(1296);
	
	var _index = __webpack_require__(2258);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabTestResultDetailsCard = function LabTestResultDetailsCard(_ref) {
	  var _ref$entity = _ref.entity,
	      entity = _ref$entity === undefined ? {} : _ref$entity,
	      headerMode = _ref.headerMode,
	      formatMessage = _ref.formatMessage;
	  var componentCode = entity.componentCode,
	      componentAvailability = entity.componentAvailability;
	
	  var _useLabTestResultDeta = (0, _useLabTestResultDetailsData.useLabTestResultDetailsData)({ entity: entity }),
	      safeValue = _useLabTestResultDeta.safeValue,
	      isPrivate = _useLabTestResultDeta.isPrivate,
	      componentName = _useLabTestResultDeta.componentName,
	      safeViewValue = _useLabTestResultDeta.safeViewValue,
	      safeNormalRange = _useLabTestResultDeta.safeNormalRange,
	      shouldShowScale = _useLabTestResultDeta.shouldShowScale,
	      rangePointsArray = _useLabTestResultDeta.rangePointsArray,
	      componentResultValue = _useLabTestResultDeta.componentResultValue,
	      componentAbnormalStatus = _useLabTestResultDeta.componentAbnormalStatus;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handleOpenHistory = function handleOpenHistory() {
	    if (componentAvailability) {
	      dispatch(_labResultHistoryModal.labResultHistoryModalActions.open({
	        componentCode: componentCode,
	        name: componentName
	      }));
	    }
	  };
	
	  if (headerMode) {
	    return _react2.default.createElement(
	      'div',
	      { className: _index2.default.rootHeader },
	      _react2.default.createElement('div', { className: _index2.default.nameResult }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.headerTitle },
	        formatMessage({ id: 'patient.portal.labTestResult.result' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.headerTitle },
	        formatMessage({
	          id: 'patient.portal.labTestResult.normalRangeState'
	        })
	      ),
	      _react2.default.createElement('div', { className: _index2.default.arrowButton })
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    {
	      onClick: handleOpenHistory,
	      className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.rootHover, componentAvailability))
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.testName },
	      componentName,
	      isPrivate && _react2.default.createElement(_PrivacyIcon2.default, { className: _index2.default.privacyIco, show: isPrivate })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      safeViewValue,
	      _react2.default.createElement(
	        'span',
	        { className: _index2.default.abnormalStatus },
	        (0, _utils.getSafeAbnormalStatus)(componentAbnormalStatus)
	      )
	    ),
	    safeNormalRange ? _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      safeNormalRange
	    ) : _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      '\u2014'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.historyButton },
	      _react2.default.createElement(_HistoryNavigation.HistoryNavigation, {
	        name: componentName,
	        formatMessage: formatMessage,
	        componentAvailability: componentAvailability
	      })
	    ),
	    shouldShowScale && _react2.default.createElement(_TestResultsScale2.default, {
	      formatMessage: formatMessage,
	      rangesPoints: rangePointsArray,
	      height: 16,
	      backgroundColors: _constants.SCALE_BACKGROUND_COLOR,
	      points: [{
	        value: safeValue,
	        marker: _react2.default.createElement(_Marker2.default, { value: componentResultValue })
	      }],
	      edges: ['', '']
	    })
	  );
	};
	
	LabTestResultDetailsCard.propTypes = {
	  entity: _propTypes2.default.object,
	  headerMode: _propTypes2.default.bool,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = LabTestResultDetailsCard;

/***/ }),
/* 3486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(5049);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Marker = function Marker(_ref) {
	  var value = _ref.value;
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.markerValue },
	      value
	    ),
	    _react2.default.createElement('div', { className: _index2.default.markerLine })
	  );
	};
	
	Marker.propTypes = {
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = Marker;

/***/ }),
/* 3487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(193);
	
	var _useScaleData2 = __webpack_require__(3489);
	
	var _index = __webpack_require__(5050);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TestResultsScale = function TestResultsScale(_ref) {
	  var formatMessage = _ref.formatMessage,
	      backgroundColors = _ref.backgroundColors,
	      points = _ref.points,
	      edges = _ref.edges,
	      rangesPoints = _ref.rangesPoints,
	      height = _ref.height;
	
	  var _useScaleData = (0, _useScaleData2.useScaleData)({
	    rangesPoints: rangesPoints
	  }),
	      calculatedRanges = _useScaleData.calculatedRanges,
	      sumWidth = _useScaleData.sumWidth,
	      rangesPrefixSums = _useScaleData.rangesPrefixSums;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.scale },
	      calculatedRanges.map(function (range, index) {
	        if (range === 0) return;
	        var widthInPercentage = range / sumWidth * 100;
	        var width = widthInPercentage + '%';
	        var rangeEndPointLeftPercentage = rangesPrefixSums[index] / sumWidth * 100;
	        return _react2.default.createElement(
	          'div',
	          {
	            // eslint-disable-next-line react/no-array-index-key
	            key: range + '-' + index,
	            style: (0, _extends3.default)({}, index === 1 && {
	              borderTopLeftRadius: '4px',
	              borderBottomLeftRadius: '4px'
	            }, index === 2 && {
	              marginLeft: '2px',
	              marginRight: '2px'
	            }, index === 3 && {
	              borderTopRightRadius: '4px',
	              borderBottomRightRadius: '4px'
	            }, {
	              height: height,
	              width: width,
	              background: backgroundColors[(index - 1) % backgroundColors.length]
	            })
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: _index2.default.rangeEndPointContainer,
	              style: { left: rangeEndPointLeftPercentage + '%' }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.rangeEndPointTextContainer },
	              _react2.default.createElement(
	                'span',
	                { className: _index2.default.rangeEndPointText },
	                edges && (index === 0 || index === calculatedRanges.length - 1) ? _react2.default.createElement(
	                  _react.Fragment,
	                  null,
	                  edges[index === 0 ? 0 : 1]
	                ) : _react2.default.createElement(
	                  _react.Fragment,
	                  null,
	                  rangesPoints ? rangesPoints[index] : rangesPrefixSums[index]
	                )
	              )
	            )
	          )
	        );
	      }),
	      points.map(function (point, index) {
	        var value = point.value,
	            marker = point.marker;
	
	        var _normalizeData = (0, _utils.normalizeData)(value, rangesPoints, sumWidth, calculatedRanges),
	            pointValue = _normalizeData.pointValue,
	            pointLeftPositionPercentage = _normalizeData.pointLeftPositionPercentage;
	
	        return _react2.default.createElement(
	          'div',
	          {
	            // eslint-disable-next-line react/no-array-index-key
	            key: pointValue + '-' + index,
	            className: _index2.default.pointContainer,
	            style: {
	              left: pointLeftPositionPercentage + '%'
	            }
	          },
	          marker
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.subscriptionContainer },
	      _react2.default.createElement(
	        'div',
	        null,
	        formatMessage({ id: 'patient.portal.labTestResult.low' })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        formatMessage({ id: 'patient.portal.labTestResult.normal' })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        formatMessage({ id: 'patient.portal.labTestResult.high' })
	      )
	    )
	  );
	};
	
	TestResultsScale.propTypes = {
	  formatMessage: _propTypes2.default.func,
	  rangesPoints: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	  backgroundColors: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  edges: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
	  height: _propTypes2.default.number.isRequired
	};
	
	exports.default = TestResultsScale;

/***/ }),
/* 3488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useLabTestResultDetailsData = useLabTestResultDetailsData;
	
	var _react = __webpack_require__(1);
	
	var _utils = __webpack_require__(193);
	
	function useLabTestResultDetailsData(_ref) {
	  var entity = _ref.entity;
	
	  var iconType = 'icon-arrow-down';
	  var componentAbnormalStatus = entity.componentAbnormalStatus,
	      componentName = entity.componentName,
	      componentResultNormalRange = entity.componentResultNormalRange,
	      componentResultUnits = entity.componentResultUnits,
	      componentResultValue = entity.componentResultValue,
	      isPrivate = entity.isPrivate;
	
	  var safeUnits = componentResultUnits || '';
	  var shouldShowScale = /^\d+(\.\d+)?-\d+(\.\d+)?$/.test(componentResultNormalRange);
	  var safeViewValue = (0, _utils.getSafeNormalRange)(componentResultValue, safeUnits);
	  var safeValue = componentResultValue ? parseFloat(componentResultValue.replace(/[^\d.]/g, '')) : '';
	  var safeNormalRange = (0, _utils.getSafeNormalRange)(componentResultNormalRange, safeUnits);
	
	  var _getStartEndNormalRan = (0, _utils.getStartEndNormalRange)(componentResultNormalRange),
	      startPointNormal = _getStartEndNormalRan.startPointNormal,
	      endPointNormal = _getStartEndNormalRan.endPointNormal,
	      endPointHigh = _getStartEndNormalRan.endPointHigh,
	      startPointLow = _getStartEndNormalRan.startPointLow;
	
	  var _checkActiveRange = (0, _utils.checkActiveRange)(startPointNormal, endPointNormal, endPointHigh, startPointLow, componentResultValue),
	      normalActive = _checkActiveRange.normalActive,
	      highActive = _checkActiveRange.highActive,
	      lowActive = _checkActiveRange.lowActive;
	
	  return (0, _react.useMemo)(function () {
	    return {
	      safeValue: safeValue,
	      componentAbnormalStatus: componentAbnormalStatus,
	      componentName: componentName,
	      componentResultValue: componentResultValue,
	      highActive: highActive,
	      iconType: iconType,
	      isPrivate: isPrivate,
	      normalActive: normalActive,
	      lowActive: lowActive,
	      safeNormalRange: safeNormalRange,
	      safeViewValue: safeViewValue,
	      shouldShowScale: shouldShowScale,
	      rangePointsArray: [startPointLow, startPointNormal, endPointNormal, endPointHigh]
	    };
	  }, [entity, safeValue, componentAbnormalStatus, componentName, componentResultValue, highActive, iconType, isPrivate, normalActive, lowActive, safeNormalRange, safeViewValue, shouldShowScale, startPointLow, startPointNormal, endPointNormal, endPointHigh]);
	}

/***/ }),
/* 3489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useScaleData = useScaleData;
	
	var _react = __webpack_require__(1);
	
	function useScaleData(_ref) {
	  var rangesPoints = _ref.rangesPoints;
	
	  var calculatedRanges = rangesPoints.reduce(function (acc, cur, index) {
	    var range = Math.abs(cur - rangesPoints[Math.max(index - 1, 0)]);
	    acc.push(range);
	    return acc;
	  }, []);
	
	  var rangesPrefixSums = calculatedRanges.reduce(function (acc, cur, index) {
	    acc.push(cur + (acc[index - 1] || 0));
	    return acc;
	  }, []);
	
	  var sumWidth = rangesPrefixSums[rangesPrefixSums.length - 1];
	
	  return (0, _react.useMemo)(function () {
	    return { sumWidth: sumWidth, calculatedRanges: calculatedRanges, rangesPrefixSums: rangesPrefixSums };
	  }, [rangesPoints, calculatedRanges, rangesPrefixSums, sumWidth]);
	}

/***/ }),
/* 3490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _utils = __webpack_require__(78);
	
	var _utils2 = __webpack_require__(193);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicationCard = function MedicationCard(_ref) {
	  var entity = _ref.entity,
	      formatMessage = _ref.formatMessage,
	      isInactive = _ref.isInactive;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeCard = _useState2[0],
	      setActiveCard = _useState2[1];
	
	  var name = entity.name,
	      frequency = entity.frequency,
	      prescribedDate = entity.prescribedDate,
	      ccdPharmacy = entity.ccdPharmacy,
	      providerProfile = entity.providerProfile,
	      quantityAmount = entity.quantityAmount,
	      quantityUnit = entity.quantityUnit,
	      isPrivate = entity.isPrivate,
	      discontinuedDate = entity.discontinuedDate,
	      _entity$sources = entity.sources,
	      sources = _entity$sources === undefined ? [] : _entity$sources,
	      memberReportedMedication = entity.memberReportedMedication,
	      providerFirstName = entity.providerFirstName,
	      providerLastName = entity.providerLastName;
	
	
	  var safeAddress = ccdPharmacy && ccdPharmacy.address1 ? (ccdPharmacy.address1 || ccdPharmacy.address2) + ', ' + ccdPharmacy.city + ', ' + ccdPharmacy.state : ccdPharmacy && ccdPharmacy.city + ', ' + ccdPharmacy.state;
	
	  var safeName = quantityAmount && quantityUnit ? name + ', ' + quantityAmount + quantityUnit : name;
	
	  var source = sources.join(', ');
	
	  var providerName = (0, _react.useMemo)(function () {
	    if (providerFirstName && providerLastName) {
	      return providerFirstName + ' ' + providerLastName;
	    }
	
	    if (providerProfile) {
	      return providerProfile.firstName + ' ' + providerProfile.lastName;
	    }
	
	    return '';
	  }, [providerProfile, providerFirstName, providerLastName]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_index2.default.header, _index2.default.medicationHeader) },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        _react2.default.createElement(_Icon2.default, {
	          size: 28,
	          name: 'icon-medications-black',
	          className: (0, _classnames2.default)(_index2.default.iconType, _index2.default.medicationIcon)
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.titleWrapper, (0, _defineProperty3.default)({}, _index2.default.noTitle, !safeName))
	              },
	              safeName,
	              _react2.default.createElement(_PrivacyIcon2.default, { show: isPrivate, className: _index2.default.privacyIcon })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_index2.default.description, _index2.default.medicationDescription)
	            },
	            frequency
	          ),
	          memberReportedMedication && _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_index2.default.description, _index2.default.medicationDescription, _index2.default.selfReportedText)
	            },
	            formatMessage({
	              id: 'patient.portal.medications.selfReported'
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_index2.default.rightBlock, _index2.default.medicaationRightBlock) },
	        isInactive && _react2.default.createElement(
	          'span',
	          { className: _index2.default.inactive },
	          formatMessage({
	            id: 'profile.section.mfaSettings.label.inActive'
	          })
	        ),
	        _react2.default.createElement(_Icon2.default, {
	          size: 16,
	          name: activeCard ? 'icon-arrow-up' : 'icon-arrow-down',
	          className: _index2.default.icon,
	          onClick: function onClick() {
	            return setActiveCard(!activeCard);
	          }
	        })
	      )
	    ),
	    activeCard && _react2.default.createElement(
	      'div',
	      { className: _index2.default.activeCardRoot },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.columnWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({
	              id: memberReportedMedication ? 'patient.portal.medications.startDate' : 'patient.portal.medications.prescribedDate'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({
	              id: 'patient.healthboard.source'
	            })
	          ),
	          !memberReportedMedication && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.meta },
	              formatMessage({
	                id: 'patient.portal.medications.pharmacy'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.meta },
	              formatMessage({ id: 'common.phone' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.context },
	            (0, _utils.formatDate)(prescribedDate, 'MMM D, Y')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.context },
	            source || '-'
	          ),
	          !memberReportedMedication ? _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.context },
	              ccdPharmacy ? ccdPharmacy.name : ''
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.context },
	              ccdPharmacy ? (0, _utils2.safePhoneNumber)(ccdPharmacy.phone) : ''
	            )
	          ) : null
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.columnWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          discontinuedDate && (!memberReportedMedication || isInactive) && _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({
	              id: 'calendar.repeat.endDate'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({ id: 'profile.actions.provider' })
	          ),
	          !memberReportedMedication && _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({ id: 'patient.portal.medications.address' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          discontinuedDate && (!memberReportedMedication || isInactive) && _react2.default.createElement(
	            'div',
	            { className: _index2.default.context },
	            (0, _utils.formatDate)(discontinuedDate, 'MMM D, Y')
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.context },
	            providerName,
	            providerProfile && providerProfile.credential ? ', ' + providerProfile.credential : ''
	          ),
	          !memberReportedMedication && _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)(_index2.default.context, _index2.default.wrapWhiteSpace) },
	            safeAddress || ''
	          )
	        )
	      )
	    )
	  );
	};
	
	MedicationCard.propTypes = {
	  entity: _propTypes2.default.object,
	  isInactive: _propTypes2.default.bool,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = MedicationCard;

/***/ }),
/* 3491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProcedureCard = function ProcedureCard(_ref) {
	  var entity = _ref.entity,
	      formatMessage = _ref.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeCard = _useState2[0],
	      setActiveCard = _useState2[1];
	
	  var beginDate = entity.beginDate,
	      endDate = entity.endDate,
	      performingProviderName = entity.performingProviderName,
	      name = entity.name,
	      locationName = entity.locationName,
	      isPrivate = entity.isPrivate;
	
	
	  var safeDate = endDate || beginDate;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        _react2.default.createElement(_Icon2.default, {
	          size: 28,
	          name: 'icon-procedures-black',
	          className: _index2.default.iconType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.titleWrapper, (0, _defineProperty3.default)({}, _index2.default.noTitle, !name))
	              },
	              name
	            ),
	            _react2.default.createElement(_PrivacyIcon2.default, { show: isPrivate, className: _index2.default.privacyIcon })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.description },
	            safeDate ? (0, _utils.formatDate)(safeDate, 'MMM D, Y') : ''
	          )
	        )
	      ),
	      _react2.default.createElement(_Icon2.default, {
	        size: 16,
	        name: activeCard ? 'icon-arrow-up' : 'icon-arrow-down',
	        className: _index2.default.icon,
	        onClick: function onClick() {
	          return setActiveCard(!activeCard);
	        }
	      })
	    ),
	    activeCard && _react2.default.createElement(
	      'div',
	      { className: _index2.default.activeCardRoot },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.columnWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({
	              id: 'messages.nav.tabs.provider'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.fullContent },
	            performingProviderName || ''
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.columnWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.meta },
	            formatMessage({ id: 'profile.fields.location' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.column },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.fullContent },
	            locationName || ''
	          )
	        )
	      )
	    )
	  );
	};
	
	ProcedureCard.propTypes = {
	  entity: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = ProcedureCard;

/***/ }),
/* 3492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(5051);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RefillCard = function RefillCard(_ref) {
	  var entity = _ref.entity;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeCard = _useState2[0],
	      setActiveCard = _useState2[1];
	
	  var medications = entity.medications,
	      pharmacyDetails = entity.pharmacyDetails,
	      requestedAt = entity.requestedAt,
	      userName = entity.userName;
	
	  var _ref2 = pharmacyDetails || {},
	      address = _ref2.address,
	      pharmacyName = _ref2.pharmacyName,
	      phone = _ref2.phone;
	
	  var safePharmacy = '' + (pharmacyName ? pharmacyName + ', ' : '') + (address ? address + ', ' : '') + (phone || '');
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        _react2.default.createElement(_Icon2.default, { size: 28, name: 'docs', className: _index2.default.iconType }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            userName
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.description },
	            safePharmacy
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.rightBlock },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.date },
	          (0, _utils.formatDate)(requestedAt, 'h:mm A, MMM D, Y')
	        ),
	        _react2.default.createElement(_Icon2.default, {
	          size: 16,
	          className: _index2.default.icon,
	          onClick: function onClick() {
	            return setActiveCard(!activeCard);
	          },
	          name: activeCard ? 'icon-arrow-up' : 'icon-arrow-down'
	        })
	      )
	    ),
	    activeCard && medications.length > 0 && _react2.default.createElement(
	      'div',
	      { className: _index2.default.activeContent },
	      medications.map(function (_ref3) {
	        var id = _ref3.id,
	            name = _ref3.name,
	            sources = _ref3.sources,
	            isPrivate = _ref3.isPrivate,
	            quantityUnit = _ref3.quantityUnit,
	            quantityAmount = _ref3.quantityAmount,
	            providerProfile = _ref3.providerProfile;
	
	        var provider = providerProfile ? providerProfile.firstName + ' ' + providerProfile.lastName + ', ' : '';
	        var source = sources.join(', ');
	        return _react2.default.createElement(
	          'div',
	          { className: _index2.default.activeDrugRoot, key: id },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.drugName },
	            '' + name + (quantityAmount ? ', ' + quantityAmount + (quantityUnit || '') : ''),
	            _react2.default.createElement(_PrivacyIcon2.default, {
	              show: isPrivate,
	              className: _index2.default.privacyIcon
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.description },
	            '' + provider + (source ? '' + source : '')
	          )
	        );
	      })
	    )
	  );
	};
	
	RefillCard.propTypes = {
	  entity: _propTypes2.default.object
	};
	
	exports.default = (0, _react.memo)(RefillCard);

/***/ }),
/* 3493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PrivacyIcon = __webpack_require__(194);
	
	var _PrivacyIcon2 = _interopRequireDefault(_PrivacyIcon);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(277);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialHistoryCard = function SocialHistoryCard(_ref) {
	  var entity = _ref.entity;
	  var description = entity.description,
	      startDate = entity.startDate,
	      stopDate = entity.stopDate,
	      isPrivate = entity.isPrivate;
	
	  var safeDate = stopDate || startDate;
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.leftSideWrapper },
	        _react2.default.createElement(_Icon2.default, {
	          size: 28,
	          name: 'icon-social-history-black',
	          className: _index2.default.iconType
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.contentWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)(_index2.default.titleWrapper, (0, _defineProperty3.default)({}, _index2.default.noTitle, !description))
	              },
	              description
	            ),
	            _react2.default.createElement(_PrivacyIcon2.default, { show: isPrivate, className: _index2.default.privacyIcon })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.description },
	            safeDate ? (0, _utils.formatDate)(safeDate, 'MMM D, Y') : ''
	          )
	        )
	      )
	    )
	  );
	};
	
	SocialHistoryCard.propTypes = {
	  entity: _propTypes2.default.object
	};
	
	exports.default = SocialHistoryCard;

/***/ }),
/* 3494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(157);
	
	var _chatMembersModal = __webpack_require__(1290);
	
	var _selectors2 = __webpack_require__(23);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    openedChatMembersModal: (0, _selectors.chatMembersModalOpened)(state),
	    mainUserId: (0, _selectors2.loggedUserIdSelector)(state),
	    targetUserId: (0, _selectors2.targetUserIdSelector)(state),
	    memberList: (0, _selectors.chatMembersModalList)(state),
	    channelName: (0, _selectors.chatMembersModalChannelName)(state),
	    date: (0, _selectors.chatMembersModalDate)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  close: _chatMembersModal.chatMembersModalActions.close
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(193);
	
	var _constants = __webpack_require__(54);
	
	var _enhance = __webpack_require__(3494);
	
	var _index = __webpack_require__(5052);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PATIENT = _constants.ACTIVITY_LOG_ROLE.PATIENT;
	
	
	function ChatMembersModal(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      openedChatMembersModal = _ref.openedChatMembersModal,
	      mainUserId = _ref.mainUserId,
	      channelName = _ref.channelName,
	      memberList = _ref.memberList,
	      date = _ref.date,
	      close = _ref.close;
	
	  var safeChatName = (0, _utils.getSafeChannelName)(channelName, formatMessage);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      title: formatMessage({
	        id: 'patient.portal.healthRecord.activityLog.chatMembers'
	      }),
	      onClose: close,
	      opened: openedChatMembersModal,
	      mobileFullScreen: false,
	      overflowVisible: true,
	      withoutAdaptive: true,
	      strictClose: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.root },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.header },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.leftSideWrapper },
	          _react2.default.createElement(_Icon2.default, { size: 32, name: 'icon-group', className: _index2.default.avatar }),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            safeChatName
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.date },
	          date
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.contentWrapper },
	        memberList.map(function (_ref2) {
	          var userId = _ref2.userId,
	              lastName = _ref2.lastName,
	              firstName = _ref2.firstName,
	              role = _ref2.role,
	              avatar = _ref2.avatar,
	              id = _ref2.id;
	
	          var mainUserName = userId === mainUserId;
	          var isRolePatient = role === PATIENT;
	          var safeMemberName = (firstName || '') + ' ' + (lastName || '');
	          return _react2.default.createElement(
	            'div',
	            { className: _index2.default.memberCard, key: id },
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.leftSideWrapper },
	              _react2.default.createElement(_SimpleAvatar2.default, {
	                className: _index2.default.avatar,
	                text: safeMemberName,
	                src: (0, _get2.default)(avatar, 'thumbMin'),
	                size: 32
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: _index2.default.description },
	                _react2.default.createElement(
	                  'div',
	                  { className: _index2.default.title },
	                  mainUserName ? safeMemberName + ' (' + formatMessage({
	                    id: 'patient.portal.healthRecord.activityLog.you'
	                  }) + ')' : safeMemberName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: _index2.default.role },
	                  mainUserName && isRolePatient ? formatMessage({
	                    id: 'patient.portal.healthRecord.activityLog.patient'
	                  }) : (0, _utils.getSafeRole)(role, formatMessage)
	                )
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	ChatMembersModal.propTypes = {
	  intl: PropTypes.object,
	  close: PropTypes.func,
	  channelName: PropTypes.string,
	  memberList: PropTypes.array,
	  date: PropTypes.string,
	  mainUserId: PropTypes.number,
	  openedChatMembersModal: PropTypes.bool
	};
	
	exports.default = (0, _enhance.enhance)(ChatMembersModal);

/***/ }),
/* 3496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Card = __webpack_require__(1158);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _EmptyState = __webpack_require__(1159);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ShareToChatModal = __webpack_require__(3499);
	
	var _ShareToChatModal2 = _interopRequireDefault(_ShareToChatModal);
	
	var _ShareToEmailModal = __webpack_require__(3501);
	
	var _ShareToEmailModal2 = _interopRequireDefault(_ShareToEmailModal);
	
	var _HealthRecordSearch = __webpack_require__(1776);
	
	var _HealthRecordSearch2 = _interopRequireDefault(_HealthRecordSearch);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _healthRecordReq = __webpack_require__(1294);
	
	var healthRecord = _interopRequireWildcard(_healthRecordReq);
	
	var _selectors = __webpack_require__(157);
	
	var _index = __webpack_require__(1504);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HealthRecordsList = function HealthRecordsList(_ref) {
	  var userId = _ref.userId,
	      activeTab = _ref.activeTab,
	      formatMessage = _ref.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var rootRef = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      startDate = _useState2[0],
	      setStartDate = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      endDate = _useState4[0],
	      setEndDate = _useState4[1];
	
	  var data = (0, _reactRedux.useSelector)(_selectors.selectHealthRecordEntity);
	  var pending = (0, _reactRedux.useSelector)(_selectors.selectHealthRecordPending);
	  var paginationPending = (0, _reactRedux.useSelector)(_selectors.selectHealthRecordPaginationPending);
	  var total = (0, _reactRedux.useSelector)(_selectors.selectHealthRecordEntityTotal);
	  var listLength = data.length;
	
	  var isNotEmpty = Boolean(data.length);
	
	  var showList = isNotEmpty && !pending;
	  var showEmptyState = !isNotEmpty && !pending && !paginationPending;
	
	  var clearData = function clearData() {
	    return dispatch(healthRecord.actions.clear());
	  };
	
	  var fetchData = function fetchData(withPeriod, withPagination) {
	    var limit = 20;
	    var offset = withPagination ? listLength : 0;
	    var sendPeriod = withPeriod && startDate && endDate;
	    var dateData = (0, _extends3.default)({}, sendPeriod && {
	      startDate: (0, _moment2.default)(startDate).format('YYYY-MM-DD'),
	      endDate: (0, _moment2.default)(endDate).format('YYYY-MM-DD')
	    });
	
	    dispatch(healthRecord.actions.send((0, _extends3.default)({
	      limit: limit,
	      userId: userId,
	      offset: offset,
	      withPagination: withPagination
	    }, dateData)));
	  };
	
	  var loadMore = function loadMore() {
	    var isLastPage = total <= listLength;
	    if (isLastPage) return;
	
	    var hasDate = startDate && endDate;
	    fetchData(hasDate, true);
	  };
	
	  var clearDate = function clearDate() {
	    setEndDate(null);
	    setStartDate(null);
	    fetchData(false, false);
	  };
	
	  (0, _react.useEffect)(function () {
	    fetchData(false, false);
	    return function () {
	      return clearData();
	    };
	  }, []);
	
	  (0, _useLazyLoad.useLazyLoad)({
	    node: rootRef,
	    loadMore: loadMore,
	    path: []
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.rootHealthRecords },
	    _react2.default.createElement(_HealthRecordSearch2.default, {
	      pending: pending,
	      endDate: endDate,
	      onClear: clearDate,
	      startDate: startDate,
	      setEndDate: setEndDate,
	      setStartDate: setStartDate,
	      formatMessage: formatMessage,
	      onSearch: function onSearch() {
	        return fetchData(true, false);
	      }
	    }),
	    pending && _react2.default.createElement(_Loader2.default, null),
	    showEmptyState && _react2.default.createElement(_EmptyState2.default, {
	      activeTab: activeTab,
	      formatMessage: formatMessage,
	      withInfo: Boolean(startDate && endDate)
	    }),
	    showList && _react2.default.createElement(
	      'div',
	      { className: _index2.default.paginationHealthRecords, ref: rootRef },
	      data.map(function (card) {
	        return _react2.default.createElement(_Card2.default, {
	          key: card.id,
	          entity: card,
	          activeTab: activeTab,
	          formatMessage: formatMessage
	        });
	      }),
	      paginationPending && _react2.default.createElement(
	        'div',
	        { className: _index2.default.paginationLoader },
	        _react2.default.createElement(_Loader2.default, null)
	      )
	    ),
	    _react2.default.createElement(_ShareToChatModal2.default, null),
	    _react2.default.createElement(_ShareToEmailModal2.default, null)
	  );
	};
	
	HealthRecordsList.propTypes = {
	  activeTab: _propTypes2.default.string,
	  formatMessage: _propTypes2.default.func,
	  userId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = HealthRecordsList;

/***/ }),
/* 3497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Card = __webpack_require__(1158);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _EmptyState = __webpack_require__(1159);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _medicationStatuses = __webpack_require__(1854);
	
	var _medicationsReq = __webpack_require__(1299);
	
	var medicationsActions = _interopRequireWildcard(_medicationsReq);
	
	var _selectors = __webpack_require__(157);
	
	var _index = __webpack_require__(5054);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTIVE = _medicationStatuses.MEDICATION_STATUSES.ACTIVE,
	    INACTIVE = _medicationStatuses.MEDICATION_STATUSES.INACTIVE;
	
	
	var MedicationsList = function MedicationsList(_ref) {
	  var userId = _ref.userId,
	      category = _ref.category,
	      activeTab = _ref.activeTab,
	      formatMessage = _ref.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isVisible = _useState2[0],
	      setIsVisible = _useState2[1];
	
	  var rootRef = (0, _react.useRef)();
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var total = (0, _reactRedux.useSelector)(_selectors.selectMedicationsTotal);
	  var loading = (0, _reactRedux.useSelector)(_selectors.selectMedicationsLoading);
	
	  var _useSelector = (0, _reactRedux.useSelector)(_selectors.selectMedicationsEntity),
	      active = _useSelector.active,
	      discontinued = _useSelector.discontinued;
	
	  var fetchData = function fetchData(withPagination) {
	    var limit = 20;
	    var offset = withPagination ? discontinued.length : 0;
	
	    if (!withPagination) {
	      dispatch(medicationsActions.actions.send({
	        userId: userId,
	        status: ACTIVE
	      }));
	    }
	
	    dispatch(medicationsActions.actions.send({
	      limit: limit,
	      offset: offset,
	      userId: userId,
	      status: INACTIVE
	    }));
	  };
	
	  var loadMore = (0, _react.useCallback)(function () {
	    var isLastPage = total <= discontinued.length;
	    if (isLastPage) return;
	
	    fetchData(true);
	  }, [total, discontinued.length]);
	
	  (0, _react.useEffect)(function () {
	    fetchData();
	
	    return function () {
	      return dispatch(medicationsActions.actions.clear());
	    };
	  }, []);
	
	  (0, _useLazyLoad.useLazyLoad)({
	    loadMore: loadMore,
	    node: rootRef,
	    path: ['parentNode', 'parentNode']
	  });
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.medicationListWrapper, ref: rootRef },
	    loading && active.length === 0 && discontinued.length === 0 && _react2.default.createElement(_Loader2.default, null),
	    !loading && active.length === 0 && discontinued.length === 0 && _react2.default.createElement(_EmptyState2.default, {
	      category: category,
	      activeTab: activeTab,
	      formatMessage: formatMessage
	    }),
	    active.length > 0 ? active.map(function (card) {
	      return _react2.default.createElement(_Card2.default, {
	        key: card.id,
	        entity: card,
	        activeTab: activeTab,
	        formatMessage: formatMessage
	      });
	    }) : !isVisible && discontinued.length > 0 && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_EmptyState2.default, {
	        withInfo: true,
	        category: category,
	        activeTab: activeTab,
	        formatMessage: formatMessage
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_index2.default.showDiscontinued, _index2.default.fullWidth) },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: _index2.default.buttonStyles,
	            onClick: function onClick() {
	              return setIsVisible(!isVisible);
	            }
	          },
	          formatMessage({ id: 'common.showInactiveMedictions' })
	        )
	      )
	    ),
	    discontinued.length > 0 && !isVisible && active.length > 0 && _react2.default.createElement(
	      'div',
	      { className: _index2.default.showDiscontinued },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: _index2.default.buttonStyles,
	          onClick: function onClick() {
	            return setIsVisible(!isVisible);
	          }
	        },
	        formatMessage({ id: 'common.showInactiveMedictions' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.paginationRoot },
	      isVisible && discontinued.map(function (card) {
	        return _react2.default.createElement(_Card2.default, {
	          isInactive: true,
	          key: card.id,
	          entity: card,
	          activeTab: activeTab,
	          formatMessage: formatMessage
	        });
	      })
	    )
	  );
	};
	
	MedicationsList.propTypes = {
	  userId: _propTypes2.default.number,
	  category: _propTypes2.default.string,
	  activeTab: _propTypes2.default.string,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = MedicationsList;

/***/ }),
/* 3498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _shareToChatModal = __webpack_require__(848);
	
	var _shareToChatReq = __webpack_require__(664);
	
	var _selectors = __webpack_require__(157);
	
	var _selectors2 = __webpack_require__(23);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    openedShareToChatModal: (0, _selectors.shareToChatModal)(state),
	    mainUserId: (0, _selectors2.loggedUserIdSelector)(state),
	    targetUserId: (0, _selectors2.targetUserIdSelector)(state),
	    pending: (0, _selectors.selectPatientChannelsForSharePending)(state) || (0, _selectors.selectSocialChannelsForSharePending)(state),
	    allPatientChannels: (0, _selectors.selectPatientChannelsForShare)(state),
	    allSocialChannels: (0, _selectors.selectSocialChannelsForShare)(state),
	    documentUid: (0, _selectors.shareToChatModalDocumentUid)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  close: _shareToChatModal.shareToChatModalActions.close,
	  shareToChat: _shareToChatReq.actions.init
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(54);
	
	var _readOnlyChat = __webpack_require__(1388);
	
	var _utils = __webpack_require__(193);
	
	var _enhance = __webpack_require__(3498);
	
	var _index = __webpack_require__(5055);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShareToChatModal(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      openedShareToChatModal = _ref.openedShareToChatModal,
	      allPatientChannels = _ref.allPatientChannels,
	      allSocialChannels = _ref.allSocialChannels,
	      targetUserId = _ref.targetUserId,
	      shareToChat = _ref.shareToChat,
	      documentUid = _ref.documentUid,
	      mainUserId = _ref.mainUserId,
	      pending = _ref.pending,
	      close = _ref.close;
	
	  var _getSafeUserId = (0, _utils.getSafeUserId)(targetUserId, mainUserId),
	      safeUserId = _getSafeUserId.safeUserId,
	      isMainUser = _getSafeUserId.isMainUser;
	
	  var handleCloseModal = function handleCloseModal() {
	    close();
	  };
	
	  var patientChannels = allPatientChannels.filter(function (_ref2) {
	    var contextUser = _ref2.contextUser;
	    return contextUser.id === safeUserId;
	  });
	
	  var patientSubChannels = patientChannels[0] ? patientChannels[0].subchannels : [];
	
	  var patientAllowedSubChannels = patientSubChannels.reduce(function (acc, item) {
	    var channelName = item.channelName;
	
	    var isSystemChannel = [_constants.NOTIFICATIONS_SUBCHANNEL, _constants.ACTIVITIES_SUBCHANNEL].includes(channelName);
	
	    var _getReadOnlyChannelDa = (0, _readOnlyChat.getReadOnlyChannelData)({
	      contextChannel: item
	    }),
	        blocked = _getReadOnlyChannelDa.blocked,
	        isReadOnly = _getReadOnlyChannelDa.isReadOnly;
	
	    var isAllowedChannel = !isReadOnly && !blocked && !isSystemChannel;
	
	    return isAllowedChannel ? [].concat((0, _toConsumableArray3.default)(acc), [item]) : acc;
	  }, []);
	
	  var socialSubChannels = allSocialChannels.length > 0 ? allSocialChannels.map(function (_ref3) {
	    var _ref3$contextChannel = _ref3.contextChannel,
	        channelName = _ref3$contextChannel.channelName,
	        channelId = _ref3$contextChannel.channelId,
	        avatar = _ref3$contextChannel.avatar;
	    return {
	      channelName: channelName,
	      channelId: channelId,
	      avatar: avatar
	    };
	  }) : [];
	
	  var allAvailableChats = [].concat((0, _toConsumableArray3.default)(patientAllowedSubChannels), (0, _toConsumableArray3.default)(isMainUser && socialSubChannels));
	
	  var handleShareToChat = function handleShareToChat(id, channelName) {
	    shareToChat({
	      userId: safeUserId,
	      documentUid: documentUid,
	      roomId: id,
	      channelName: channelName
	    });
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      title: formatMessage({ id: 'patient.portal.healthRecord.shareToChat' }),
	      onClose: handleCloseModal,
	      opened: openedShareToChatModal,
	      mobileFullScreen: false,
	      overflowVisible: true,
	      withoutAdaptive: true,
	      strictClose: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.root },
	      pending && _react2.default.createElement(_Loader2.default, null),
	      !pending && _react2.default.createElement(
	        'div',
	        { className: _index2.default.content },
	        allAvailableChats.map(function (_ref4) {
	          var channelId = _ref4.channelId,
	              channelName = _ref4.channelName,
	              avatar = _ref4.avatar;
	
	          var isDefaultPatientChat = [_constants.ALL_MEMBERS_SUBCHANNEL, _constants.FAMILY_CIRCLE_SUBCHANNEL].includes(channelName);
	          var safeChatName = isDefaultPatientChat ? (0, _utils.getSafeChannelName)(channelName, formatMessage) : channelName;
	          return _react2.default.createElement(
	            'div',
	            {
	              className: _index2.default.chatRoot,
	              key: channelId,
	              onClick: function onClick() {
	                return handleShareToChat(channelId, safeChatName);
	              }
	            },
	            isDefaultPatientChat ? _react2.default.createElement(_Icon2.default, { size: 32, name: 'icon-group' }) : _react2.default.createElement(_SimpleAvatar2.default, {
	              className: _index2.default.avatar,
	              text: channelName,
	              src: (0, _get2.default)(avatar, 'thumbMin'),
	              size: 32
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: _index2.default.title },
	              safeChatName
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	ShareToChatModal.propTypes = {
	  intl: PropTypes.object,
	  close: PropTypes.func,
	  openedShareToChatModal: PropTypes.bool,
	  mainUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  targetUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  pending: PropTypes.bool,
	  allPatientChannels: PropTypes.array,
	  shareToChat: PropTypes.func,
	  documentUid: PropTypes.string,
	  allSocialChannels: PropTypes.array
	};
	
	exports.default = (0, _enhance.enhance)(ShareToChatModal);

/***/ }),
/* 3500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _shareToEmailReq = __webpack_require__(849);
	
	var _shareToEmailModal = __webpack_require__(1305);
	
	var _selectors = __webpack_require__(157);
	
	var _selectors2 = __webpack_require__(23);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    openedShareToEmailModal: (0, _selectors.shareToEmailModal)(state),
	    mainUserId: (0, _selectors2.loggedUserIdSelector)(state),
	    targetUserId: (0, _selectors2.targetUserIdSelector)(state),
	    documentUid: (0, _selectors.shareToEmailModalDocumentUid)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  close: _shareToEmailModal.shareToEmailModalActions.close,
	  shareToEmail: _shareToEmailReq.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _loginValidator = __webpack_require__(1393);
	
	var _loginValidator2 = _interopRequireDefault(_loginValidator);
	
	var _ids = __webpack_require__(46);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _utils = __webpack_require__(193);
	
	var _enhance = __webpack_require__(3500);
	
	var _index = __webpack_require__(5056);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShareToEmailModal(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      openedShareToEmailModal = _ref.openedShareToEmailModal,
	      targetUserId = _ref.targetUserId,
	      shareToEmail = _ref.shareToEmail,
	      documentUid = _ref.documentUid,
	      mainUserId = _ref.mainUserId,
	      close = _ref.close;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      email = _useState2[0],
	      setEmail = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      emailError = _useState4[0],
	      setEmailError = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      confirmationView = _useState6[0],
	      setConfirmationView = _useState6[1];
	
	  var _getSafeUserId = (0, _utils.getSafeUserId)(targetUserId, mainUserId),
	      safeUserId = _getSafeUserId.safeUserId;
	
	  var handleCloseModal = function handleCloseModal() {
	    setEmailError('');
	    setEmail('');
	    close();
	  };
	
	  var resetEmailError = function resetEmailError() {
	    if (emailError) setEmailError('');
	  };
	
	  var isValidEmail = function isValidEmail(value) {
	    var isValid = value ? (0, _loginValidator2.default)(value) : true;
	    if (!isValid) {
	      setEmailError(formatMessage({
	        id: 'patient.portal.healthRecord.shareToEmail.validationMsg'
	      }));
	    }
	    return isValid;
	  };
	
	  var handleOnChangeEmail = function handleOnChangeEmail(value) {
	    setEmail(value);
	  };
	
	  var handleShareToEmail = function handleShareToEmail() {
	    handleCloseModal();
	    setConfirmationView(false);
	    shareToEmail({ userId: safeUserId, email: email, document_uid: documentUid });
	  };
	
	  return confirmationView ? _react2.default.createElement(
	    _Popup2.default,
	    {
	      onClose: function onClose() {
	        return setConfirmationView(false);
	      },
	      opened: confirmationView,
	      mobileFullScreen: false,
	      overflowVisible: true,
	      withoutAdaptive: true,
	      withHeading: false,
	      strictClose: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.confirmationView },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.confirmationContentWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.confirmationContent },
	          formatMessage({ id: 'patient.portal.healthRecord.shareToEmail.confirmTitle' }, { recipient: email })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.confirmationContent },
	          formatMessage({
	            id: 'patient.portal.healthRecord.shareToEmail.confirmQuestion'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.confirmationButtonWrapper },
	        _react2.default.createElement(_Button2.default, {
	          id: _ids.IDS.COMMON.ACTION_CONFIRMATION_SUBMIT,
	          color: 'primary',
	          onClick: handleShareToEmail,
	          children: formatMessage({
	            id: 'patient.portal.healthRecord.shareToEmail.confirmButton'
	          }),
	          type: 'button',
	          className: _index2.default.actionButton,
	          raised: true
	        }),
	        _react2.default.createElement(_Button2.default, {
	          id: _ids.IDS.COMMON.ACTION_CONFIRMATION_CANCEL,
	          color: 'accent',
	          raised: true,
	          type: 'button',
	          onClick: function onClick() {
	            return setConfirmationView(false);
	          },
	          className: _index2.default.actionButton,
	          children: formatMessage({ id: 'common.cancel' })
	        })
	      )
	    )
	  ) : _react2.default.createElement(
	    _Popup2.default,
	    {
	      title: formatMessage({ id: 'patient.portal.healthRecord.shareToEmail' }),
	      onClose: handleCloseModal,
	      opened: openedShareToEmailModal,
	      mobileFullScreen: false,
	      overflowVisible: true,
	      withoutAdaptive: true,
	      strictClose: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.root },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        formatMessage({
	          id: 'patient.portal.healthRecord.shareToEmail.description'
	        })
	      ),
	      _react2.default.createElement(_TextInput2.default, {
	        className: _index2.default.inputEmail,
	        id: _ids.IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.SHARE_TO_EMAIL_INPUT,
	        label: formatMessage({
	          id: 'patient.portal.healthRecord.shareToEmailRecipient'
	        }),
	        name: 'email',
	        placeholder: formatMessage({
	          id: 'patient.portal.healthRecord.shareToEmailRecipient'
	        }),
	        onChange: function onChange(val) {
	          return handleOnChangeEmail(val);
	        },
	        onBlur: function onBlur(val) {
	          return isValidEmail(val);
	        },
	        onFocus: resetEmailError,
	        value: email
	      }),
	      email && emailError && _react2.default.createElement(_ErrorBlock2.default, { errors: emailError, className: _index2.default.errorBlock }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.actionButtonWrapper },
	        _react2.default.createElement(_Button2.default, {
	          id: _ids.IDS.COMMON.ACTION_CONFIRMATION_SUBMIT,
	          color: 'primary',
	          onClick: function onClick() {
	            return setConfirmationView(true);
	          },
	          children: formatMessage({ id: 'common.send' }),
	          disabled: !email || !!emailError,
	          type: 'button',
	          className: _index2.default.actionButton,
	          raised: true
	        }),
	        _react2.default.createElement(_Button2.default, {
	          id: _ids.IDS.COMMON.ACTION_CONFIRMATION_CANCEL,
	          color: 'accent',
	          raised: true,
	          type: 'button',
	          onClick: handleCloseModal,
	          className: _index2.default.actionButton,
	          children: formatMessage({ id: 'common.cancel' })
	        })
	      )
	    )
	  );
	}
	
	ShareToEmailModal.propTypes = {
	  intl: PropTypes.object,
	  close: PropTypes.func,
	  openedShareToEmailModal: PropTypes.bool,
	  mainUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  targetUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  shareToEmail: PropTypes.func,
	  documentUid: PropTypes.string
	};
	
	exports.default = (0, _enhance.enhance)(ShareToEmailModal);

/***/ }),
/* 3502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Card = __webpack_require__(1158);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _EmptyState = __webpack_require__(1159);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ChatMembersModal = __webpack_require__(3495);
	
	var _ChatMembersModal2 = _interopRequireDefault(_ChatMembersModal);
	
	var _ResultsDetailsModal = __webpack_require__(3518);
	
	var _ResultsDetailsModal2 = _interopRequireDefault(_ResultsDetailsModal);
	
	var _LabTestHistoryModal = __webpack_require__(3512);
	
	var _LabTestHistoryModal2 = _interopRequireDefault(_LabTestHistoryModal);
	
	var _useLazyLoad = __webpack_require__(197);
	
	var _index = __webpack_require__(1504);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataList = function DataList(_ref) {
	  var data = _ref.data,
	      pending = _ref.pending,
	      category = _ref.category,
	      loadMore = _ref.loadMore,
	      activeTab = _ref.activeTab,
	      formatMessage = _ref.formatMessage,
	      withPagination = _ref.withPagination;
	
	  var rootRef = (0, _react.useRef)();
	  var isNotEmpty = Boolean(data.length);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return {
	      showLoader: pending && !isNotEmpty,
	      showPaginationLoader: pending && withPagination && isNotEmpty,
	      showEmptyState: !pending && !isNotEmpty,
	      showList: !pending && isNotEmpty || withPagination && pending && isNotEmpty
	    };
	  }, [pending, isNotEmpty, withPagination]),
	      showList = _useMemo.showList,
	      showLoader = _useMemo.showLoader,
	      showPaginationLoader = _useMemo.showPaginationLoader,
	      showEmptyState = _useMemo.showEmptyState;
	
	  var rootStyles = (0, _react.useMemo)(function () {
	    return (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.paginationRoot, withPagination));
	  }, [withPagination]);
	
	  (0, _useLazyLoad.useLazyLoad)({ node: rootRef, loadMore: loadMore, path: [] });
	
	  return _react2.default.createElement(
	    'div',
	    { className: rootStyles, ref: rootRef },
	    showLoader && _react2.default.createElement(_Loader2.default, null),
	    showEmptyState && _react2.default.createElement(_EmptyState2.default, {
	      category: category,
	      activeTab: activeTab,
	      formatMessage: formatMessage
	    }),
	    showList && data.map(function (card) {
	      return _react2.default.createElement(_Card2.default, {
	        key: card.id,
	        entity: card,
	        activeTab: activeTab,
	        formatMessage: formatMessage
	      });
	    }),
	    showPaginationLoader && _react2.default.createElement(
	      'div',
	      { className: _index2.default.paginationLoader },
	      _react2.default.createElement(_Loader2.default, null)
	    ),
	    _react2.default.createElement(_LabTestHistoryModal2.default, null),
	    _react2.default.createElement(_ResultsDetailsModal2.default, null),
	    _react2.default.createElement(_ChatMembersModal2.default, null)
	  );
	};
	
	DataList.propTypes = {
	  data: _propTypes2.default.array,
	  pending: _propTypes2.default.bool,
	  loadMore: _propTypes2.default.func,
	  category: _propTypes2.default.string,
	  activeTab: _propTypes2.default.string,
	  formatMessage: _propTypes2.default.func,
	  withPagination: _propTypes2.default.bool
	};
	
	exports.default = DataList;

/***/ }),
/* 3503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DataList = __webpack_require__(3502);
	
	var _DataList2 = _interopRequireDefault(_DataList);
	
	var _constants = __webpack_require__(54);
	
	var _MedicationsList = __webpack_require__(3497);
	
	var _MedicationsList2 = _interopRequireDefault(_MedicationsList);
	
	var _HealthRecordsList = __webpack_require__(3496);
	
	var _HealthRecordsList2 = _interopRequireDefault(_HealthRecordsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HEALTH_RECORD = _constants.TABS_PATIENT_PORTAL.HEALTH_RECORD,
	    MEDICATIONS = _constants.TABS_PATIENT_PORTAL.MEDICATIONS;
	
	
	var DataListWrapper = function DataListWrapper(_ref) {
	  var activeTab = _ref.activeTab,
	      data = (0, _objectWithoutProperties3.default)(_ref, ['activeTab']);
	
	  var props = (0, _extends3.default)({}, data, { activeTab: activeTab });
	  switch (activeTab) {
	    case HEALTH_RECORD:
	      return _react2.default.createElement(_HealthRecordsList2.default, props);
	    case MEDICATIONS:
	      return _react2.default.createElement(_MedicationsList2.default, props);
	    default:
	      return _react2.default.createElement(_DataList2.default, props);
	  }
	};
	
	DataListWrapper.propTypes = {
	  activeTab: _propTypes2.default.string
	};
	
	exports.default = DataListWrapper;

/***/ }),
/* 3504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmptyDataWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5057);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyDataWrapper = exports.EmptyDataWrapper = function EmptyDataWrapper(_ref) {
	  var pending = _ref.pending,
	      children = _ref.children,
	      isDataEmpty = _ref.isDataEmpty,
	      formatMessage = _ref.formatMessage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    pending && _react2.default.createElement(_Loader2.default, null),
	    !pending && isDataEmpty && _react2.default.createElement(
	      'div',
	      { className: _index2.default.empty },
	      _react2.default.createElement(_Icon2.default, { name: 'ico-1000-graph', size: 60 }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        _react2.default.createElement(
	          'div',
	          null,
	          formatMessage({
	            id: 'patient.portal.healthRecord.emptyState.nothingFound'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          formatMessage({
	            id: 'patient.portal.healthRecord.emptyState.tryToChoose'
	          })
	        )
	      )
	    ),
	    !pending && !isDataEmpty && children
	  );
	};

/***/ }),
/* 3505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabTestHistoryGraph = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2113);
	
	var _reactChartjs = __webpack_require__(1578);
	
	var _EmptyWrapper = __webpack_require__(3504);
	
	var _context = __webpack_require__(495);
	
	var _LabTestHistoryLegend = __webpack_require__(3507);
	
	var _graphData = __webpack_require__(1777);
	
	var _index = __webpack_require__(5058);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabTestHistoryGraph = exports.LabTestHistoryGraph = function LabTestHistoryGraph() {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      localData = _useState2[0],
	      setLocalData = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      shouldRenderGraph = _useState4[0],
	      setShouldRenderGraph = _useState4[1];
	
	  var _useLabTestHistoryCon = (0, _context.useLabTestHistoryContext)(),
	      data = _useLabTestHistoryCon.data,
	      pending = _useLabTestHistoryCon.pending,
	      formatMessage = _useLabTestHistoryCon.formatMessage;
	
	  (0, _react.useEffect)(function () {
	    setLocalData(data);
	    setShouldRenderGraph(function () {
	      return (0, _graphData.shouldShowGraph)(data);
	    });
	  }, [pending, data]);
	
	  var props = (0, _extends3.default)({}, (0, _graphData.setConfig)({ localData: localData, shouldRender: shouldRenderGraph }));
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    shouldRenderGraph && _react2.default.createElement(
	      _EmptyWrapper.EmptyDataWrapper,
	      {
	        pending: pending,
	        isDataEmpty: localData.length === 0,
	        formatMessage: formatMessage
	      },
	      _react2.default.createElement(_reactChartjs.Line, props),
	      _react2.default.createElement(_LabTestHistoryLegend.LabTestHistoryLegend, null)
	    )
	  );
	};

/***/ }),
/* 3506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabTestHistoryHeader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(193);
	
	var _options = __webpack_require__(1160);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _context = __webpack_require__(495);
	
	var _index = __webpack_require__(5059);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabTestHistoryHeader = exports.LabTestHistoryHeader = function LabTestHistoryHeader() {
	  var _useLabTestHistoryCon = (0, _context.useLabTestHistoryContext)(),
	      data = _useLabTestHistoryCon.data,
	      name = _useLabTestHistoryCon.name,
	      close = _useLabTestHistoryCon.close,
	      setOption = _useLabTestHistoryCon.setOption,
	      setEndDate = _useLabTestHistoryCon.setEndDate,
	      setStartDate = _useLabTestHistoryCon.setStartDate,
	      formatMessage = _useLabTestHistoryCon.formatMessage,
	      getLabResultHistoryClear = _useLabTestHistoryCon.getLabResultHistoryClear;
	
	  var _ref = data[0] || '',
	      _ref$graphAvailabilit = _ref.graphAvailability,
	      graphAvailability = _ref$graphAvailabilit === undefined ? true : _ref$graphAvailabilit,
	      _ref$componentResultU = _ref.componentResultUnits,
	      componentResultUnits = _ref$componentResultU === undefined ? '' : _ref$componentResultU,
	      _ref$componentResultN = _ref.componentResultNormalRange,
	      componentResultNormalRange = _ref$componentResultN === undefined ? '' : _ref$componentResultN;
	
	  var safeNormalRange = (0, _utils.getSafeNormalRange)(componentResultNormalRange, componentResultUnits);
	
	  var normalStateValue = (0, _react.useMemo)(function () {
	    return componentResultNormalRange ? safeNormalRange : _react2.default.createElement(
	      'span',
	      null,
	      '\u2014'
	    );
	  }, [componentResultNormalRange, safeNormalRange]);
	
	  var handleBackButtonClick = function handleBackButtonClick() {
	    close();
	    setEndDate('');
	    setStartDate('');
	    getLabResultHistoryClear();
	    setOption(_options.optionsValues.FIVE);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.left },
	      _react2.default.createElement(_BackButton2.default, {
	        onBack: handleBackButtonClick,
	        title: { id: 'common.blank' }
	      }),
	      name
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.right },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.rightTop },
	        graphAvailability ? formatMessage({ id: 'patient.portal.labTestResult.normalRange' }) : formatMessage({ id: 'patient.portal.labTestResult.normalState' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.rightBottom },
	        normalStateValue
	      )
	    )
	  );
	};

/***/ }),
/* 3507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabTestHistoryLegend = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _utils = __webpack_require__(193);
	
	var _graphData = __webpack_require__(1777);
	
	var _context = __webpack_require__(495);
	
	var _index = __webpack_require__(5060);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabTestHistoryLegend = exports.LabTestHistoryLegend = function LabTestHistoryLegend() {
	  var _useLabTestHistoryCon = (0, _context.useLabTestHistoryContext)(),
	      data = _useLabTestHistoryCon.data,
	      formatMessage = _useLabTestHistoryCon.formatMessage;
	
	  var isThereRange = (0, _react.useCallback)((0, _graphData.shouldShowRange)(data), [data]);
	
	  var _ref = data[0] || '',
	      _ref$componentResultN = _ref.componentResultNormalRange,
	      componentResultNormalRange = _ref$componentResultN === undefined ? '' : _ref$componentResultN,
	      _ref$componentResultU = _ref.componentResultUnits,
	      componentResultUnits = _ref$componentResultU === undefined ? '' : _ref$componentResultU;
	
	  var safeNormalRange = (0, _utils.getSafeNormalRange)(componentResultNormalRange, componentResultUnits);
	
	  var normalStateValue = (0, _react.useMemo)(function () {
	    return componentResultNormalRange ? safeNormalRange : _react2.default.createElement(
	      'span',
	      null,
	      '\u2014'
	    );
	  }, [componentResultNormalRange, safeNormalRange]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.unit },
	      _react2.default.createElement(_Icon2.default, {
	        className: _index2.default.icon,
	        size: 24,
	        name: 'icon-graph-devices-line-point-black'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.textWrapper },
	        formatMessage({ id: 'patient.healthboard.value' })
	      )
	    ),
	    isThereRange && _react2.default.createElement(
	      'div',
	      { className: _index2.default.unit },
	      _react2.default.createElement(_Icon2.default, {
	        className: _index2.default.icon,
	        size: 24,
	        name: 'icon-graph-health-record-point-green'
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.textWrapper },
	        formatMessage({ id: 'patient.healthboard.normalRange' }) + ': ',
	        normalStateValue
	      )
	    )
	  );
	};

/***/ }),
/* 3508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabTestHistoryList = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _list = __webpack_require__(3513);
	
	var _context = __webpack_require__(495);
	
	var _index = __webpack_require__(5061);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabTestHistoryList = exports.LabTestHistoryList = function LabTestHistoryList() {
	  var _useLabTestHistoryCon = (0, _context.useLabTestHistoryContext)(),
	      data = _useLabTestHistoryCon.data,
	      pending = _useLabTestHistoryCon.pending;
	
	  var list = (0, _list.makeListData)(data);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    !pending && list.length > 0 && list.map(function (l) {
	      return _react2.default.createElement(
	        'div',
	        { className: _index2.default.item, key: l.id },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.left },
	          l.left,
	          _react2.default.createElement(
	            'span',
	            { className: _index2.default.redText },
	            l.leftSuffix
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.right },
	          l.right
	        )
	      );
	    })
	  );
	};

/***/ }),
/* 3509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabTestHistorySelector = undefined;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _options = __webpack_require__(1160);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _context = __webpack_require__(495);
	
	var _HealthRecordSearch = __webpack_require__(1776);
	
	var _HealthRecordSearch2 = _interopRequireDefault(_HealthRecordSearch);
	
	var _dateFormatter = __webpack_require__(314);
	
	var _index = __webpack_require__(5062);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LabTestHistorySelector = exports.LabTestHistorySelector = function LabTestHistorySelector() {
	  var _useLabTestHistoryCon = (0, _context.useLabTestHistoryContext)(),
	      option = _useLabTestHistoryCon.option,
	      pending = _useLabTestHistoryCon.pending,
	      endDate = _useLabTestHistoryCon.endDate,
	      setOption = _useLabTestHistoryCon.setOption,
	      startDate = _useLabTestHistoryCon.startDate,
	      setEndDate = _useLabTestHistoryCon.setEndDate,
	      setStartDate = _useLabTestHistoryCon.setStartDate,
	      formatMessage = _useLabTestHistoryCon.formatMessage;
	
	  var fetchData = (0, _react.useCallback)(function () {
	    if (startDate && endDate) {
	      setStartDate((0, _moment2.default)(startDate).format(_dateFormatter.API_DATE_FORMAT));
	      setEndDate((0, _moment2.default)(endDate).format(_dateFormatter.API_DATE_FORMAT));
	    }
	  }, [startDate, endDate]);
	
	  var clearDate = function clearDate() {
	    setEndDate('');
	    setStartDate('');
	  };
	
	  var msg = (0, _react.useRef)({
	    range: formatMessage({
	      id: 'patient.healthboard.labTestHistory.range'
	    }),
	    ten: formatMessage({
	      id: 'patient.healthboard.labTestHistory.selector.ten'
	    }),
	    all: formatMessage({
	      id: 'patient.healthboard.labTestHistory.selector.all'
	    }),
	    five: formatMessage({
	      id: 'patient.healthboard.labTestHistory.selector.five'
	    }),
	    custom: formatMessage({
	      id: 'patient.healthboard.labTestHistory.selector.custom'
	    })
	  });
	
	  var options = [{ value: _options.optionsValues.FIVE, label: msg.current.five }, { value: _options.optionsValues.TEN, label: msg.current.ten }, { value: _options.optionsValues.ALL, label: msg.current.all }, { value: _options.optionsValues.CUSTOM, label: msg.current.custom }];
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.selectorWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.selectorLabel },
	        msg.current.range
	      ),
	      _react2.default.createElement(_SelectCustom2.default, {
	        options: options,
	        defaultValue: option,
	        className: _index2.default.selector,
	        placeholder: msg.current.five,
	        onChange: function onChange(e) {
	          return setOption(e.value);
	        }
	      })
	    ),
	    option === _options.optionsValues.CUSTOM && _react2.default.createElement(
	      'div',
	      { className: _index2.default.ranger },
	      _react2.default.createElement(_HealthRecordSearch2.default, {
	        pending: pending,
	        endDate: endDate,
	        onClear: clearDate,
	        startDate: startDate,
	        setEndDate: setEndDate,
	        setStartDate: setStartDate,
	        onSearch: function onSearch() {
	          return fetchData();
	        },
	        formatMessage: formatMessage
	      })
	    )
	  );
	};

/***/ }),
/* 3510 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataSetsProps = exports.dataSetsProps = {
	  borderWidth: 0.7,
	  borderColor: '#000',
	  backgroundColor: 'transparent'
	};

/***/ }),
/* 3511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _labResultHistoryModal = __webpack_require__(1296);
	
	var _labResultHistoryReq = __webpack_require__(1297);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(157);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userId: (0, _selectors.loggedUserIdSelector)(state),
	    data: (0, _selectors2.selectLabResultHistoryData)(state),
	    targetUserId: (0, _selectors.targetUserIdSelector)(state),
	    error: (0, _selectors2.selectLabResultHistoryError)(state),
	    name: (0, _selectors2.selectTestResultComponentName)(state),
	    pending: (0, _selectors2.selectLabResultHistoryPending)(state),
	    componentCode: (0, _selectors2.selectTestResultComponentCode)(state),
	    openedLabResultHistoryModal: (0, _selectors2.selectOpenedLabResultHistoryModal)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  close: _labResultHistoryModal.labResultHistoryModalActions.close,
	  getLabResultHistoryReq: _labResultHistoryReq.actions.send,
	  getLabResultHistoryClear: _labResultHistoryReq.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _options = __webpack_require__(1160);
	
	var _context = __webpack_require__(495);
	
	var _LabTestHistoryList = __webpack_require__(3508);
	
	var _LabTestHistoryGraph = __webpack_require__(3505);
	
	var _LabTestHistoryHeader = __webpack_require__(3506);
	
	var _LabTestHistorySelector = __webpack_require__(3509);
	
	var _enhance = __webpack_require__(3511);
	
	var _index = __webpack_require__(5063);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LabTestHistoryModal(_ref) {
	  var intl = _ref.intl,
	      data = _ref.data,
	      name = _ref.name,
	      error = _ref.error,
	      close = _ref.close,
	      userId = _ref.userId,
	      pending = _ref.pending,
	      targetUserId = _ref.targetUserId,
	      componentCode = _ref.componentCode,
	      getLabResultHistoryReq = _ref.getLabResultHistoryReq,
	      getLabResultHistoryClear = _ref.getLabResultHistoryClear,
	      openedLabResultHistoryModal = _ref.openedLabResultHistoryModal;
	  var formatMessage = intl.formatMessage;
	
	  var _useState = (0, _react.useState)(_options.optionsValues.FIVE),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      option = _useState2[0],
	      setOption = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      endDate = _useState4[0],
	      setEndDate = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      startDate = _useState6[0],
	      setStartDate = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    setOption(_options.optionsValues.FIVE);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (openedLabResultHistoryModal) {
	      if (Boolean(componentCode)) {
	        if (option === _options.optionsValues.FIVE || option === _options.optionsValues.TEN) {
	          getLabResultHistoryReq({
	            componentCode: componentCode,
	            limit: option,
	            userId: targetUserId || userId
	          });
	        }
	        if (option === _options.optionsValues.ALL) {
	          getLabResultHistoryReq({
	            componentCode: componentCode,
	            userId: targetUserId || userId
	          });
	        }
	      }
	    }
	  }, [openedLabResultHistoryModal, option, userId, targetUserId]);
	
	  (0, _react.useEffect)(function () {
	    if (Boolean(componentCode)) {
	      if (startDate && startDate.length === 10 && endDate && endDate.length === 10 && option === _options.optionsValues.CUSTOM) {
	        getLabResultHistoryReq({
	          componentCode: componentCode,
	          endTime: endDate,
	          startTime: startDate,
	          userId: targetUserId || userId
	        });
	      }
	    }
	  }, [startDate, endDate, userId, targetUserId]);
	
	  function handleCloseModal() {
	    setStartDate('');
	    setEndDate('');
	    setOption(_options.optionsValues.FIVE);
	    getLabResultHistoryClear();
	    close();
	  }
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      title: formatMessage({
	        id: 'patient.healthboard.labTestHistory.modalTitle'
	      }),
	      onClose: handleCloseModal,
	      opened: openedLabResultHistoryModal,
	      mobileFullScreen: false,
	      overflowVisible: true,
	      width: 'auto',
	      strictClose: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.wrapper },
	      _react2.default.createElement(
	        _context.LabTestHistoryContext.Provider,
	        {
	          value: {
	            data: data,
	            name: name,
	            intl: intl,
	            error: error,
	            close: close,
	            option: option,
	            pending: pending,
	            endDate: endDate,
	            startDate: startDate,
	            setOption: setOption,
	            setEndDate: setEndDate,
	            setStartDate: setStartDate,
	            formatMessage: formatMessage,
	            getLabResultHistoryClear: getLabResultHistoryClear
	          }
	        },
	        _react2.default.createElement(_LabTestHistoryHeader.LabTestHistoryHeader, null),
	        _react2.default.createElement(_LabTestHistorySelector.LabTestHistorySelector, null),
	        _react2.default.createElement(_LabTestHistoryGraph.LabTestHistoryGraph, null),
	        _react2.default.createElement(_LabTestHistoryList.LabTestHistoryList, null)
	      )
	    )
	  );
	}
	
	LabTestHistoryModal.propTypes = {
	  data: PropTypes.array,
	  close: PropTypes.func,
	  name: PropTypes.string,
	  intl: PropTypes.object,
	  error: PropTypes.string,
	  pending: PropTypes.bool,
	  userId: PropTypes.number,
	  targetUserId: PropTypes.number,
	  componentCode: PropTypes.string,
	  getLabResultHistoryReq: PropTypes.func,
	  getLabResultHistoryClear: PropTypes.func,
	  openedLabResultHistoryModal: PropTypes.bool
	};
	
	exports.default = (0, _enhance.enhance)(LabTestHistoryModal);

/***/ }),
/* 3513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeListData = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var safeValue = function safeValue(value) {
	  return value.split('').includes('(') ? value : ['('].concat((0, _toConsumableArray3.default)(value.split('')), [')']).join('');
	};
	
	var makeListData = exports.makeListData = function makeListData(input) {
	  return input.map(function (i) {
	    return {
	      id: i.id,
	      left: (i.componentResultValue || '') + ' ' + (i.componentResultUnits || ''),
	      leftSuffix: '' + (i.componentAbnormalStatus ? safeValue(i.componentAbnormalStatus) : ''),
	      right: (0, _moment2.default)(i.specimenCollectionDate).format(_constants.COMPLETE_DATE_FORMAT)
	    };
	  });
	};

/***/ }),
/* 3514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _makePharmacyTitle = __webpack_require__(311);
	
	var _PharmacyPopup = __webpack_require__(759);
	
	var _PharmacyPopup2 = _interopRequireDefault(_PharmacyPopup);
	
	var _styles = __webpack_require__(5064);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PreferredPharmacy(_ref) {
	  var user = _ref.user,
	      formatMessage = _ref.formatMessage,
	      refillRequestError = _ref.refillRequestError,
	      clearRefillRequest = _ref.clearRefillRequest,
	      refillRequestPending = _ref.refillRequestPending,
	      setPreferredPharmacy = _ref.setPreferredPharmacy;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      pharmacy = _useState4[0],
	      setPharmacy = _useState4[1];
	
	  var primaryPatientProfile = user.primaryPatientProfile;
	
	
	  var togglePopupHandle = function togglePopupHandle() {
	    setIsOpen(function (current) {
	      return !current;
	    });
	  };
	
	  var handleSetPharmacy = function handleSetPharmacy(preferredPharmacy) {
	    clearRefillRequest();
	    setPharmacy(preferredPharmacy);
	    setPreferredPharmacy({ pharmacyId: preferredPharmacy.id, userId: user.id });
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.root },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.locationWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.location },
	          formatMessage({ id: 'appointments.form.preferredPharmacy' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.address },
	          primaryPatientProfile && (0, _makePharmacyTitle.makePharmacyTitle)(pharmacy || primaryPatientProfile.pharmacy, true)
	        )
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          raised: true,
	          color: 'accent',
	          onClick: togglePopupHandle,
	          className: _styles2.default.button,
	          disabled: refillRequestPending
	        },
	        formatMessage({ id: 'appointments.form.changePharmacy' })
	      )
	    ),
	    refillRequestError && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.unavailablePharmacy },
	      formatMessage({ id: 'patient.portal.unavailablePharmacy' })
	    ),
	    _react2.default.createElement(_PharmacyPopup2.default, {
	      isOpen: isOpen,
	      withMailOrder: false,
	      onClose: togglePopupHandle,
	      setPharmacy: handleSetPharmacy
	    })
	  );
	}
	
	PreferredPharmacy.propTypes = {
	  user: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func,
	  clearRefillRequest: _propTypes2.default.func,
	  refillRequestError: _propTypes2.default.bool,
	  refillRequestPending: _propTypes2.default.bool,
	  setPreferredPharmacy: _propTypes2.default.func
	};
	
	exports.default = PreferredPharmacy;

/***/ }),
/* 3515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _setPreferredPharmacyReq = __webpack_require__(532);
	
	var _medicationRefillReq = __webpack_require__(846);
	
	var _refillsAvailableMedicationsReq = __webpack_require__(1302);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(157);
	
	var _selectors3 = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    targetUser: (0, _selectors.targetUserSelector)(state),
	    loggedUser: (0, _selectors.loggedUserSelector)(state),
	    currentPharmacyId: (0, _selectors3.selectPreferredPharmacy)(state),
	    pendingHistory: (0, _selectors2.selectMedicationsRefillsHistoryPending)(state),
	    refillsHistoryList: (0, _selectors2.selectMedicationsRefillsHistoryList)(state),
	    refillRequestPending: (0, _selectors2.selectMedicationRefillsRequestPending)(state),
	    refillsAvailableMedications: (0, _selectors2.selectRefillsAvailableMedicationsList)(state),
	    refillRequestError: (0, _selectors2.selectMedicationRefillsUnavailablePharmacyError)(state),
	    refillsAvailableMedicationsPending: (0, _selectors2.selectRefillsAvailableMedicationsPending)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  clear: _refillsAvailableMedicationsReq.actions.clear,
	  setPreferredPharmacy: _setPreferredPharmacyReq.actions.send,
	  clearRefillRequest: _medicationRefillReq.actions.clear,
	  initMedicationRefill: _medicationRefillReq.actions.init,
	  getAvailableMedications: _refillsAvailableMedicationsReq.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var targetUser = _ref.targetUser,
	      loggedUser = _ref.loggedUser,
	      currentPharmacyId = _ref.currentPharmacyId;
	
	  var safeUser = targetUser.id ? targetUser : loggedUser;
	  return {
	    safeUser: safeUser,
	    definePharmacy: (0, _get2.default)(safeUser, 'primaryPatientProfile.pharmacy') || currentPharmacyId
	  };
	}));

/***/ }),
/* 3516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _RefillCard = __webpack_require__(3492);
	
	var _RefillCard2 = _interopRequireDefault(_RefillCard);
	
	var _PreferredPharmacy = __webpack_require__(3514);
	
	var _PreferredPharmacy2 = _interopRequireDefault(_PreferredPharmacy);
	
	var _arrayModify = __webpack_require__(153);
	
	var _enhance = __webpack_require__(3515);
	
	var _index = __webpack_require__(5065);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Refills(_ref) {
	  var clear = _ref.clear,
	      onClose = _ref.onClose,
	      safeUser = _ref.safeUser,
	      pendingHistory = _ref.pendingHistory,
	      definePharmacy = _ref.definePharmacy,
	      clearRefillRequest = _ref.clearRefillRequest,
	      refillRequestError = _ref.refillRequestError,
	      refillsHistoryList = _ref.refillsHistoryList,
	      setPreferredPharmacy = _ref.setPreferredPharmacy,
	      refillRequestPending = _ref.refillRequestPending,
	      initMedicationRefill = _ref.initMedicationRefill,
	      getAvailableMedications = _ref.getAvailableMedications,
	      refillsAvailableMedications = _ref.refillsAvailableMedications,
	      refillsAvailableMedicationsPending = _ref.refillsAvailableMedicationsPending,
	      _ref$options = _ref.options,
	      viewHistory = _ref$options.viewHistory,
	      formatMessage = _ref$options.formatMessage;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      medications = _useState2[0],
	      setMedications = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    if (!viewHistory) {
	      getAvailableMedications({ userId: safeUser.id });
	    }
	  }, [viewHistory, safeUser]);
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      clear();
	      clearRefillRequest();
	    };
	  }, []);
	
	  var handleCheckMedications = (0, _react.useCallback)(function (id) {
	    setMedications((0, _arrayModify.toggleElementInList)(medications, id));
	  }, [medications]);
	
	  var emptyState = (0, _react.useMemo)(function () {
	    return _react2.default.createElement(
	      'div',
	      { className: _index2.default.emptyStateRoot },
	      _react2.default.createElement(_Icon2.default, { size: 60, name: 'search-list' }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.noDataMessage },
	        formatMessage({ id: 'patient.portal.requestRefillProvider' })
	      )
	    );
	  }, []);
	
	  var getHistoryView = (0, _react.useMemo)(function () {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      pendingHistory && _react2.default.createElement(_Loader2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.refillList },
	        !pendingHistory && refillsHistoryList.length > 0 && refillsHistoryList.map(function (item) {
	          return _react2.default.createElement(_RefillCard2.default, { entity: item, key: item.id });
	        })
	      )
	    );
	  }, [pendingHistory, refillsHistoryList]);
	
	  var handleStartRequest = (0, _react.useCallback)(function () {
	    initMedicationRefill({ medicationIds: medications, userId: safeUser.id });
	  }, [medications, safeUser]);
	
	  var getRequestRefillView = (0, _react.useMemo)(function () {
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      refillsAvailableMedicationsPending ? _react2.default.createElement(_Loader2.default, null) : refillsAvailableMedications.length > 0 && _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.requestContainer, (0, _defineProperty3.default)({}, _index2.default.opacity, refillRequestPending))
	        },
	        refillRequestPending && _react2.default.createElement(_Loader2.default, { className: _index2.default.requestLoader }),
	        _react2.default.createElement(_PreferredPharmacy2.default, {
	          user: safeUser,
	          formatMessage: formatMessage,
	          clearRefillRequest: clearRefillRequest,
	          refillRequestError: refillRequestError,
	          refillRequestPending: refillRequestPending,
	          setPreferredPharmacy: setPreferredPharmacy
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.medicationContainer },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            formatMessage({ id: 'patient.portal.selectMedications' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.list },
	            refillsAvailableMedications.map(function (_ref2) {
	              var id = _ref2.id,
	                  quantityAmount = _ref2.quantityAmount,
	                  quantityUnit = _ref2.quantityUnit,
	                  name = _ref2.name;
	              return _react2.default.createElement(
	                'div',
	                { className: _index2.default.medicationWrapper, key: id },
	                _react2.default.createElement(_Checkbox2.default, {
	                  id: id,
	                  size: 16,
	                  checked: medications.includes(id),
	                  onChange: function onChange() {
	                    return handleCheckMedications(id);
	                  }
	                }),
	                _react2.default.createElement(
	                  'div',
	                  { className: _index2.default.medication },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _index2.default.medicationName },
	                    '' + name + (quantityAmount ? ', ' + quantityAmount + (quantityUnit || '') : '')
	                  )
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              raised: true,
	              color: 'primary',
	              onClick: handleStartRequest,
	              className: _index2.default.confirmButton,
	              disabled: !medications.length || !definePharmacy || refillRequestPending
	            },
	            formatMessage({ id: 'submit.fillProfile' })
	          )
	        )
	      ),
	      !refillsAvailableMedicationsPending && refillsAvailableMedications.length === 0 && emptyState
	    );
	  }, [safeUser, medications, definePharmacy, refillRequestError, refillRequestPending, refillsAvailableMedications, refillsAvailableMedicationsPending]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement('div', { className: _index2.default.maskHeader, onClick: onClose }),
	    _react2.default.createElement(_BackButton2.default, { onBack: onClose, className: _index2.default.backBtn, minWidth: 100 }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'p',
	        { className: _index2.default.headerTitle },
	        formatMessage({
	          id: viewHistory ? 'patient.portal.refillHistory' : 'patient.portal.requestRefills'
	        })
	      )
	    ),
	    viewHistory ? getHistoryView : getRequestRefillView
	  );
	}
	
	Refills.propTypes = {
	  clear: PropTypes.func,
	  onClose: PropTypes.func,
	  options: PropTypes.object,
	  safeUser: PropTypes.object,
	  viewHistory: PropTypes.bool,
	  pendingHistory: PropTypes.bool,
	  clearRefillRequest: PropTypes.func,
	  refillRequestError: PropTypes.bool,
	  refillsHistoryList: PropTypes.array,
	  refillRequestPending: PropTypes.bool,
	  initMedicationRefill: PropTypes.func,
	  setPreferredPharmacy: PropTypes.func,
	  getAvailableMedications: PropTypes.func,
	  refillsAvailableMedications: PropTypes.array,
	  refillsAvailableMedicationsPending: PropTypes.bool,
	  definePharmacy: PropTypes.oneOfType([PropTypes.object, PropTypes.number])
	};
	
	exports.default = (0, _enhance.enhance)(Refills);

/***/ }),
/* 3517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _resultsDetailsReq = __webpack_require__(1304);
	
	var _loggingActionReq = __webpack_require__(663);
	
	var _resultsDetailsModal = __webpack_require__(1303);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(157);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    openedResultsDetailsModal: (0, _selectors2.selectOpenedResultsDetailsModal)(state),
	    ccdLabTestId: (0, _selectors2.selectIdResultsDetailsModal)(state),
	    mainUserId: (0, _selectors.loggedUserIdSelector)(state),
	    targetUserId: (0, _selectors.targetUserIdSelector)(state),
	    pending: (0, _selectors2.selectResultsDetailsPending)(state),
	    resultDocument: (0, _selectors2.selectResultsDocument)(state),
	    entity: (0, _selectors2.selectResultsDetailsModalEntity)(state),
	    detailsEntity: (0, _selectors2.selectResultsDetailsEntity)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  clear: _resultsDetailsReq.actions.clear,
	  close: _resultsDetailsModal.resultsDetailsModalActions.close,
	  getDetailsReq: _resultsDetailsReq.actions.send,
	  loggingViewAction: _loggingActionReq.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _utils = __webpack_require__(193);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _constants = __webpack_require__(54);
	
	var _LabTestResultCard = __webpack_require__(1775);
	
	var _LabTestResultCard2 = _interopRequireDefault(_LabTestResultCard);
	
	var _LabTestResultDetailsCard = __webpack_require__(3485);
	
	var _LabTestResultDetailsCard2 = _interopRequireDefault(_LabTestResultDetailsCard);
	
	var _LabTestResultDetailsCardDocuments = __webpack_require__(3484);
	
	var _LabTestResultDetailsCardDocuments2 = _interopRequireDefault(_LabTestResultDetailsCardDocuments);
	
	var _enhance = __webpack_require__(3517);
	
	var _index = __webpack_require__(5066);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEW = _constants.ACTIVITY_LOG_USER_ACTION_TYPE.VIEW;
	
	
	function ResultsDetailsModal(_ref) {
	  var clear = _ref.clear,
	      close = _ref.close,
	      entity = _ref.entity,
	      pending = _ref.pending,
	      mainUserId = _ref.mainUserId,
	      ccdLabTestId = _ref.ccdLabTestId,
	      targetUserId = _ref.targetUserId,
	      getDetailsReq = _ref.getDetailsReq,
	      detailsEntity = _ref.detailsEntity,
	      resultDocument = _ref.resultDocument,
	      loggingViewAction = _ref.loggingViewAction,
	      formatMessage = _ref.intl.formatMessage,
	      openedResultsDetailsModal = _ref.openedResultsDetailsModal;
	
	  var _getSafeUserId = (0, _utils.getSafeUserId)(targetUserId, mainUserId),
	      safeUserId = _getSafeUserId.safeUserId;
	
	  (0, _react.useEffect)(function () {
	    if (openedResultsDetailsModal && ccdLabTestId) {
	      getDetailsReq({ ccdLabTestId: ccdLabTestId, userId: safeUserId });
	    }
	  }, [openedResultsDetailsModal, ccdLabTestId, safeUserId]);
	
	  var handleCloseModal = function handleCloseModal() {
	    clear();
	    close();
	  };
	
	  var loggingView = function loggingView(documentUid) {
	    loggingViewAction({
	      userId: safeUserId,
	      actionType: VIEW,
	      documentUid: documentUid
	    });
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      title: formatMessage({ id: 'patient.portal.labTestResult.modalTitle' }),
	      onClose: handleCloseModal,
	      opened: openedResultsDetailsModal,
	      mobileFullScreen: false,
	      overflowVisible: true,
	      width: 'auto',
	      strictClose: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.boxShadow },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.root },
	        _react2.default.createElement(_LabTestResultCard2.default, { entity: entity, detailsMode: true }),
	        pending && _react2.default.createElement(_Loader2.default, null),
	        !pending && detailsEntity.length !== 0 && _react2.default.createElement(_LabTestResultDetailsCard2.default, {
	          formatMessage: formatMessage,
	          headerMode: true
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.content },
	          !pending && detailsEntity.length !== 0 && detailsEntity.map(function (item) {
	            return _react2.default.createElement(_LabTestResultDetailsCard2.default, {
	              key: item.id,
	              entity: item,
	              formatMessage: formatMessage
	            });
	          }),
	          resultDocument && !pending && _react2.default.createElement(_LabTestResultDetailsCardDocuments2.default, {
	            loggingView: loggingView,
	            formatMessage: formatMessage,
	            resultDocument: resultDocument
	          })
	        )
	      )
	    )
	  );
	}
	
	ResultsDetailsModal.propTypes = {
	  clear: PropTypes.func,
	  close: PropTypes.func,
	  intl: PropTypes.object,
	  pending: PropTypes.bool,
	  entity: PropTypes.object,
	  mainUserId: PropTypes.number,
	  getDetailsReq: PropTypes.func,
	  detailsEntity: PropTypes.array,
	  targetUserId: PropTypes.number,
	  loggingViewAction: PropTypes.func,
	  openedResultsDetailsModal: PropTypes.bool,
	  ccdLabTestId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  resultDocument: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
	};
	
	exports.default = (0, _enhance.enhance)(ResultsDetailsModal);

/***/ }),
/* 3519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useDataListEntity = useDataListEntity;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _medicationRefillsHistory = __webpack_require__(847);
	
	var medicationsRefills = _interopRequireWildcard(_medicationRefillsHistory);
	
	var _labTestResultsReq = __webpack_require__(1298);
	
	var labTestResults = _interopRequireWildcard(_labTestResultsReq);
	
	var _socialHistoryReq = __webpack_require__(1307);
	
	var socialHistory = _interopRequireWildcard(_socialHistoryReq);
	
	var _immunizationsReq = __webpack_require__(1295);
	
	var immunizations = _interopRequireWildcard(_immunizationsReq);
	
	var _familyHistory = __webpack_require__(1293);
	
	var familyHistory = _interopRequireWildcard(_familyHistory);
	
	var _activityLogReq = __webpack_require__(845);
	
	var activityLog = _interopRequireWildcard(_activityLogReq);
	
	var _conditionsReq = __webpack_require__(1291);
	
	var conditions = _interopRequireWildcard(_conditionsReq);
	
	var _encountersReq = __webpack_require__(1292);
	
	var encounters = _interopRequireWildcard(_encountersReq);
	
	var _proceduresReq = __webpack_require__(1301);
	
	var procedures = _interopRequireWildcard(_proceduresReq);
	
	var _allergiesReq = __webpack_require__(1288);
	
	var allergies = _interopRequireWildcard(_allergiesReq);
	
	var _selectors = __webpack_require__(157);
	
	var _constants = __webpack_require__(54);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONDITIONS = _constants.TABS_PATIENT_PORTAL.CONDITIONS,
	    ALLERGIES = _constants.TABS_PATIENT_PORTAL.ALLERGIES,
	    LAB_TEST_RESULT = _constants.TABS_PATIENT_PORTAL.LAB_TEST_RESULT,
	    IMMUNIZATIONS = _constants.TABS_PATIENT_PORTAL.IMMUNIZATIONS,
	    MEDICATIONS = _constants.TABS_PATIENT_PORTAL.MEDICATIONS,
	    FAMILY_HISTORY = _constants.TABS_PATIENT_PORTAL.FAMILY_HISTORY,
	    ENCOUNTERS = _constants.TABS_PATIENT_PORTAL.ENCOUNTERS,
	    SOCIAL_HISTORY = _constants.TABS_PATIENT_PORTAL.SOCIAL_HISTORY,
	    HEALTH_RECORD = _constants.TABS_PATIENT_PORTAL.HEALTH_RECORD,
	    ACTIVITY_LOG = _constants.TABS_PATIENT_PORTAL.ACTIVITY_LOG,
	    PROCEDURES = _constants.TABS_PATIENT_PORTAL.PROCEDURES,
	    VITALS_AND_ACTIVITY = _constants.TABS_PATIENT_PORTAL.VITALS_AND_ACTIVITY;
	function useDataListEntity(_ref) {
	  var userId = _ref.userId,
	      activeTab = _ref.activeTab,
	      setActiveTab = _ref.setActiveTab,
	      firstCategoryType = _ref.firstCategoryType;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var pending = (0, _reactRedux.useSelector)(_selectors.combinedPendingDataRequest);
	  var labTestResultsData = (0, _reactRedux.useSelector)(_selectors.selectLabTestResultsEntity);
	  var allergiesData = (0, _reactRedux.useSelector)(_selectors.selectAllergiesEntity);
	  var immunizationsData = (0, _reactRedux.useSelector)(_selectors.selectImmunizationEntity);
	  var conditionsData = (0, _reactRedux.useSelector)(_selectors.selectConditionsEntity);
	  var familyHistoryData = (0, _reactRedux.useSelector)(_selectors.selectFamilyHistoryEntity);
	  var encountersData = (0, _reactRedux.useSelector)(_selectors.selectEncountersEntity);
	  var socialHistoryData = (0, _reactRedux.useSelector)(_selectors.selectSocialHistoryEntity);
	  var activityLogData = (0, _reactRedux.useSelector)(_selectors.selectActivityLogEntity);
	  var proceduresData = (0, _reactRedux.useSelector)(_selectors.selectProceduresEntity);
	
	  (0, _react.useEffect)(function () {
	    clearCurrentEntity();
	  }, [userId]);
	
	  (0, _react.useEffect)(function () {
	    if (activeTab === MEDICATIONS) {
	      dispatch(medicationsRefills.actions.send({ userId: userId }));
	    }
	  }, [activeTab, userId]);
	
	  var chooseDataByType = (0, _react.useMemo)(function () {
	    return function (type) {
	      switch (type) {
	        case ACTIVITY_LOG:
	          return {
	            data: activityLogData,
	            action: activityLog.actions.loadMore,
	            clear: activityLog.actions.clear,
	            withPagination: true,
	            pending: pending
	          };
	        case ALLERGIES:
	          return {
	            data: allergiesData,
	            action: allergies.actions.send,
	            clear: allergies.actions.clear,
	            pending: pending
	          };
	        case IMMUNIZATIONS:
	          return {
	            data: immunizationsData,
	            action: immunizations.actions.send,
	            clear: immunizations.actions.clear,
	            pending: pending
	          };
	        case CONDITIONS:
	          return {
	            data: conditionsData,
	            action: conditions.actions.send,
	            clear: conditions.actions.clear,
	            pending: pending
	          };
	        case LAB_TEST_RESULT:
	          return {
	            data: labTestResultsData,
	            action: labTestResults.actions.send,
	            clear: labTestResults.actions.clear,
	            pending: pending
	          };
	        case FAMILY_HISTORY:
	          return {
	            data: familyHistoryData,
	            action: familyHistory.actions.send,
	            clear: familyHistory.actions.clear,
	            pending: pending
	          };
	        case ENCOUNTERS:
	          return {
	            data: encountersData,
	            action: encounters.actions.send,
	            clear: encounters.actions.clear,
	            pending: pending
	          };
	        case SOCIAL_HISTORY:
	          return {
	            data: socialHistoryData,
	            action: socialHistory.actions.send,
	            clear: socialHistory.actions.clear,
	            pending: pending
	          };
	        case PROCEDURES:
	          return {
	            data: proceduresData,
	            action: procedures.actions.send,
	            clear: procedures.actions.clear,
	            pending: pending
	          };
	        default:
	          return {
	            data: activityLogData,
	            action: activityLog.actions.loadMore,
	            clear: activityLog.actions.clear,
	            withPagination: true,
	            pending: pending
	          };
	      }
	    };
	  }, [activeTab, allergiesData, labTestResultsData, conditionsData, immunizationsData, socialHistoryData, proceduresData, pending, userId]);
	
	  var loadMore = (0, _react.useCallback)(function () {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var currentEntity = chooseDataByType(activeTab);
	    if (!currentEntity.withPagination || !currentEntity.action || pending) return;
	
	    dispatch(currentEntity.action((0, _extends3.default)({ userId: userId, withPagination: true }, params)));
	  }, [activeTab, userId, pending]);
	
	  var clearCurrentEntity = function clearCurrentEntity() {
	    var currentEntity = chooseDataByType(activeTab);
	    dispatch(currentEntity.clear());
	  };
	
	  var handleSelectTab = (0, _react.useCallback)(function (tab) {
	    clearCurrentEntity();
	
	    var currentEntity = chooseDataByType(tab);
	
	    setActiveTab(tab);
	
	    if (![HEALTH_RECORD, VITALS_AND_ACTIVITY, MEDICATIONS].includes(tab)) {
	      dispatch(currentEntity.action({
	        userId: userId
	      }));
	    }
	  }, [userId]);
	
	  return (0, _extends3.default)({}, chooseDataByType(activeTab || firstCategoryType), {
	    loadMore: loadMore,
	    handleSelectTab: handleSelectTab
	  });
	}

/***/ }),
/* 3520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useTabs = useTabs;
	
	var _react = __webpack_require__(1);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(157);
	
	var _availableCategories = __webpack_require__(1289);
	
	var _constants = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MEDICATIONS = _constants.TABS_PATIENT_PORTAL.MEDICATIONS,
	    VITALS_AND_ACTIVITY = _constants.TABS_PATIENT_PORTAL.VITALS_AND_ACTIVITY,
	    ALLERGIES = _constants.TABS_PATIENT_PORTAL.ALLERGIES,
	    LAB_TEST_RESULT = _constants.TABS_PATIENT_PORTAL.LAB_TEST_RESULT,
	    CONDITIONS = _constants.TABS_PATIENT_PORTAL.CONDITIONS,
	    IMMUNIZATIONS = _constants.TABS_PATIENT_PORTAL.IMMUNIZATIONS,
	    FAMILY_HISTORY = _constants.TABS_PATIENT_PORTAL.FAMILY_HISTORY,
	    ENCOUNTERS = _constants.TABS_PATIENT_PORTAL.ENCOUNTERS,
	    SOCIAL_HISTORY = _constants.TABS_PATIENT_PORTAL.SOCIAL_HISTORY,
	    HEALTH_RECORD = _constants.TABS_PATIENT_PORTAL.HEALTH_RECORD,
	    ACTIVITY_LOG = _constants.TABS_PATIENT_PORTAL.ACTIVITY_LOG,
	    PROCEDURES = _constants.TABS_PATIENT_PORTAL.PROCEDURES;
	
	
	var IMPLEMENTED_TABS = [MEDICATIONS, ALLERGIES, LAB_TEST_RESULT, CONDITIONS, IMMUNIZATIONS, FAMILY_HISTORY, ENCOUNTERS, SOCIAL_HISTORY, HEALTH_RECORD, ACTIVITY_LOG, PROCEDURES, VITALS_AND_ACTIVITY];
	
	function useTabs(_ref) {
	  var userId = _ref.userId,
	      withVitals = _ref.withVitals,
	      isProvider = _ref.isProvider,
	      deepLinkTab = _ref.deepLinkTab;
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  var availableCategories = (0, _reactRedux.useSelector)(_selectors.selectAvailableCategoriesEntity);
	  var firstCategory = availableCategories[0] || {};
	  var firstCategoryType = (0, _get2.default)(availableCategories[0], 'categoryType', '');
	
	  (0, _react.useEffect)(function () {
	    setActiveTab(deepLinkTab || firstCategoryType);
	  }, [userId, deepLinkTab, firstCategoryType]);
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    if (!isProvider) {
	      dispatch(_availableCategories.actions.send({ userId: userId }));
	    }
	  }, [userId, isProvider]);
	
	  var activeCategory = (0, _react.useMemo)(function () {
	    return availableCategories.find(function (category) {
	      return category.categoryType === activeTab;
	    });
	  }, [availableCategories, activeTab]);
	
	  var tabs = (0, _react.useMemo)(function () {
	    var baseTabs = withVitals ? availableCategories.filter(function (_ref2) {
	      var categoryType = _ref2.categoryType;
	      return IMPLEMENTED_TABS.includes(categoryType);
	    }) : availableCategories.filter(function (_ref3) {
	      var categoryType = _ref3.categoryType;
	      return categoryType !== VITALS_AND_ACTIVITY && IMPLEMENTED_TABS.includes(categoryType);
	    });
	    return baseTabs.map(function (_ref4) {
	      var categoryType = _ref4.categoryType,
	          id = _ref4.id,
	          title = _ref4.title;
	      return {
	        label: 'patient.portal.' + categoryType,
	        id: id,
	        tab: categoryType,
	        title: title
	      };
	    });
	  }, [availableCategories, withVitals]);
	
	  return {
	    availableCategories: availableCategories,
	    activeCategory: activeCategory,
	    firstCategory: firstCategory,
	    setActiveTab: setActiveTab,
	    activeTab: activeTab,
	    tabs: tabs
	  };
	}

/***/ }),
/* 3521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _singleDayGrafModal = __webpack_require__(1350);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(109);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    openedSingleDayGrafModal: (0, _selectors2.selectOpenedSingleDayGrafModal)(state),
	    type: (0, _selectors2.selectTypeSingleDayGrafModal)(state),
	    baseDate: (0, _selectors2.selectBaseDateSingleDayGrafModal)(state),
	    combinedPendingDataModalRequest: (0, _selectors2.combinedPendingDataModalRequest)(state),
	    profile: (0, _selectors.loggedUserSelector)(state),
	    profileTargetUser: (0, _selectors.targetUserSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  close: _singleDayGrafModal.singleDayGrafModalActions.close
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _constants = __webpack_require__(17);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _useActionFilters = __webpack_require__(1156);
	
	var _constants2 = __webpack_require__(54);
	
	var _Chart = __webpack_require__(1773);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _DataHistoricList = __webpack_require__(1157);
	
	var _DataHistoricList2 = _interopRequireDefault(_DataHistoricList);
	
	var _useAllDataForHistoricListOneDay = __webpack_require__(3523);
	
	var _enhance = __webpack_require__(3521);
	
	var _index = __webpack_require__(5067);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STEPS = _constants2.VITALS_ACTIVITY_TYPE.STEPS,
	    DISTANCE = _constants2.VITALS_ACTIVITY_TYPE.DISTANCE;
	
	
	function SingleDayGrafModal(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      type = _ref.type,
	      openedSingleDayGrafModal = _ref.openedSingleDayGrafModal,
	      baseDate = _ref.baseDate,
	      close = _ref.close,
	      combinedPendingDataModalRequest = _ref.combinedPendingDataModalRequest,
	      profileTargetUser = _ref.profileTargetUser,
	      profile = _ref.profile;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return (0, _isEmpty2.default)(profileTargetUser) ? profile : profileTargetUser;
	  }, [profileTargetUser, profile]),
	      id = _useMemo.id,
	      settings = _useMemo.settings;
	
	  var mainUser = id === profile.id;
	
	  var isWeightInKg = settings && settings.measurementUnitsSettings.weight === _constants.WEIGHT_METRIC.KG;
	  var isMilligramsPerDeciliter = settings && settings.measurementUnitsSettings.glucose === _constants.GLUCOSE_METRIC.MG_PER_DECILITER;
	  var getActionCloseByType = (0, _useActionFilters.useActionFilters)(type, true);
	  var stepsOrDistance = [STEPS, DISTANCE].includes(type);
	
	  var adaptTitle = formatMessage({
	    id: 'patient.healthboard.titleHistoric.' + type
	  }).substring(4);
	
	  var _useAllDataForHistori = (0, _useAllDataForHistoricListOneDay.useAllDataForHistoricListOneDay)(type),
	      dataHistoricForOneDay = _useAllDataForHistori.dataHistoricForOneDay,
	      setHistoricSourceType = _useAllDataForHistori.setHistoricSourceType;
	
	  var handleCloseModal = function handleCloseModal() {
	    setHistoricSourceType(_constants2.DATA_SOURCE_TYPE.ALL_SOURCES);
	    dispatch(getActionCloseByType.clear());
	    close();
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      title: adaptTitle,
	      mobileFullScreen: false,
	      onClose: handleCloseModal,
	      opened: openedSingleDayGrafModal,
	      strictClose: true,
	      overflowVisible: true,
	      withoutAdaptive: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.root },
	      _react2.default.createElement(_Chart2.default, {
	        formatMessage: formatMessage,
	        type: type,
	        activeFilter: _constants2.CHART_FILTERS_TYPE.DAY.type,
	        baseDate: baseDate,
	        singleDayMode: true,
	        isWeightInKg: isWeightInKg,
	        setHistoricSourceType: setHistoricSourceType,
	        mainUser: mainUser,
	        isMilligramsPerDeciliter: isMilligramsPerDeciliter
	      }),
	      !stepsOrDistance && _react2.default.createElement(_DataHistoricList2.default, {
	        formatMessage: formatMessage,
	        pending: combinedPendingDataModalRequest,
	        type: type,
	        data: dataHistoricForOneDay,
	        allValuesForOneDay: true,
	        mainUser: mainUser,
	        isWeightInKg: isWeightInKg,
	        isMilligramsPerDeciliter: isMilligramsPerDeciliter
	      })
	    )
	  );
	}
	
	SingleDayGrafModal.propTypes = {
	  intl: PropTypes.object,
	  close: PropTypes.func,
	  openedSingleDayGrafModal: PropTypes.bool,
	  baseDate: PropTypes.string,
	  type: PropTypes.string,
	  combinedPendingDataModalRequest: PropTypes.bool,
	  profile: PropTypes.object,
	  profileTargetUser: PropTypes.object
	};
	
	exports.default = (0, _enhance.enhance)(SingleDayGrafModal);

/***/ }),
/* 3523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useAllDataForHistoricListOneDay = useAllDataForHistoricListOneDay;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectors = __webpack_require__(109);
	
	var _constants = __webpack_require__(54);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SATURATION = _constants.VITALS_ACTIVITY_TYPE.SATURATION,
	    STEPS = _constants.VITALS_ACTIVITY_TYPE.STEPS,
	    DISTANCE = _constants.VITALS_ACTIVITY_TYPE.DISTANCE,
	    BMI = _constants.VITALS_ACTIVITY_TYPE.BMI,
	    WEIGHT = _constants.VITALS_ACTIVITY_TYPE.WEIGHT,
	    HEIGHT = _constants.VITALS_ACTIVITY_TYPE.HEIGHT,
	    HEART_RATE = _constants.VITALS_ACTIVITY_TYPE.HEART_RATE,
	    BLOOD_GLUCOSE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE;
	var DEVICES = _constants.DATA_SOURCE_TYPE.DEVICES,
	    CCD = _constants.DATA_SOURCE_TYPE.CCD,
	    ALL_SOURCES = _constants.DATA_SOURCE_TYPE.ALL_SOURCES;
	function useAllDataForHistoricListOneDay(dataType) {
	  var _useState = (0, _react.useState)(ALL_SOURCES),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      historicSourceType = _useState2[0],
	      setHistoricSourceType = _useState2[1];
	
	  var concatData = [];
	  var heartRateEntityOneDay = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectHeartRateMeasurementModalHistoricList));
	  var saturationEntityOneDay = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectSaturationMeasurementModalHistoricList));
	  var stepsEntityOneDay = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectStepsMeasurementModalHistoricList));
	  var distanceEntityOneDay = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectDistanceMeasurementModalHistoricList));
	  var weightEntityOneDay = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectWeightMeasurementModalHistoricList));
	  var bmiEntityOneDay = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBMIMeasurementModalHistoricList));
	  var heightEntityOneDay = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectHeightMeasurementModalHistoricList));
	  var bloodGlucoseEntityOneDay = (0, _utils.adaptResponse)((0, _reactRedux.useSelector)(_selectors.selectBloodGlucoseMeasurementModalHistoricList));
	
	  var getEntityData = (0, _react.useMemo)(function () {
	    return function () {
	      switch (dataType) {
	        case STEPS:
	          return stepsEntityOneDay;
	        case DISTANCE:
	          return distanceEntityOneDay;
	        case BMI:
	          return bmiEntityOneDay;
	        case WEIGHT:
	          return weightEntityOneDay;
	        case HEIGHT:
	          return heightEntityOneDay;
	        case SATURATION:
	          return saturationEntityOneDay;
	        case HEART_RATE:
	          return heartRateEntityOneDay;
	        case BLOOD_GLUCOSE:
	          return bloodGlucoseEntityOneDay;
	        default:
	          return [];
	      }
	    };
	  }, [dataType, stepsEntityOneDay, distanceEntityOneDay, bmiEntityOneDay, weightEntityOneDay, heightEntityOneDay, saturationEntityOneDay, heartRateEntityOneDay, bloodGlucoseEntityOneDay]);
	
	  getEntityData().forEach(function (_ref) {
	    var measurements = _ref.measurements;
	
	    if (measurements.length > 0) {
	      measurements.forEach(function (entity) {
	        if ((0, _moment2.default)(measurements[0].measuredAt, 'YYYY-MM-DD').isSame(entity.measuredAt, 'day')) {
	          concatData.push(entity);
	        }
	      });
	    }
	  });
	
	  if (CCD === historicSourceType) {
	    return {
	      setHistoricSourceType: setHistoricSourceType,
	      dataHistoricForOneDay: concatData.filter(function (_ref2) {
	        var providerCode = _ref2.providerCode;
	
	        return providerCode === CCD;
	      }).reverse()
	    };
	  }
	
	  if (DEVICES === historicSourceType) {
	    return {
	      setHistoricSourceType: setHistoricSourceType,
	      dataHistoricForOneDay: concatData.filter(function (_ref3) {
	        var providerCode = _ref3.providerCode;
	
	        return providerCode === DEVICES;
	      }).reverse()
	    };
	  }
	
	  return {
	    setHistoricSourceType: setHistoricSourceType,
	    dataHistoricForOneDay: concatData.sort(function (a, b) {
	      return new Date(b.measuredAt) - new Date(a.measuredAt);
	    })
	  };
	}

/***/ }),
/* 3524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _merge = __webpack_require__(379);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = __webpack_require__(114);
	
	var _InfoWrapper = __webpack_require__(787);
	
	var _InfoWrapper2 = _interopRequireDefault(_InfoWrapper);
	
	var _helpers = __webpack_require__(289);
	
	var _ModalWrapper = __webpack_require__(788);
	
	var _ModalWrapper2 = _interopRequireDefault(_ModalWrapper);
	
	var _ChartWrapper = __webpack_require__(785);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	var _ChartProvider = __webpack_require__(784);
	
	var _ChartProvider2 = _interopRequireDefault(_ChartProvider);
	
	var _HistoryWrapper = __webpack_require__(786);
	
	var _HistoryWrapper2 = _interopRequireDefault(_HistoryWrapper);
	
	var _options = __webpack_require__(336);
	
	var _plugins = __webpack_require__(789);
	
	var _converters = __webpack_require__(1823);
	
	var _bloodPressureMeasurementsReq = __webpack_require__(881);
	
	var bloodPressureMeasurement = _interopRequireWildcard(_bloodPressureMeasurementsReq);
	
	var _bloodPressureMeasurementsModalReq = __webpack_require__(1332);
	
	var bloodPressureMeasurementModal = _interopRequireWildcard(_bloodPressureMeasurementsModalReq);
	
	var _hooks = __webpack_require__(144);
	
	var _selectors = __webpack_require__(109);
	
	var _utils = __webpack_require__(78);
	
	var _options2 = __webpack_require__(3525);
	
	var _useCalculatePaddingYAxis = __webpack_require__(609);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DAY = _constants2.PERIOD.DAY,
	    WEEK = _constants2.PERIOD.WEEK,
	    MONTH = _constants2.PERIOD.MONTH;
	var BLOOD_PRESSURE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE;
	var NAME = _constants2.PROVIDER_OPTION.NAME;
	
	
	var BloodPressureChart = function BloodPressureChart(_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	
	  var historyData = (0, _reactRedux.useSelector)(_selectors.selectHistoricMeasurementsList);
	  var periodData = (0, _reactRedux.useSelector)(_selectors.selectBloodPressureMeasurementEntity);
	  var modalData = (0, _reactRedux.useSelector)(_selectors.selectBloodPressureMeasurementModalEntity);
	  var historyLoading = (0, _reactRedux.useSelector)(_selectors.selectHistoricMeasurementsListPending);
	  var periodLoading = (0, _reactRedux.useSelector)(_selectors.selectBloodPressureMeasurementEntityPending);
	  var modalLoading = (0, _reactRedux.useSelector)(_selectors.selectBloodPressureMeasurementModalEntityPending);
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  var formats = (0, _hooks.useChartFormats)({ formatMessage: formatMessage });
	
	  var _useHistoryActions = (0, _hooks.useHistoryActions)({ type: BLOOD_PRESSURE }),
	      loadHistory = _useHistoryActions.loadHistory;
	
	  var _useChartActions = (0, _hooks.useChartActions)({
	    actions: bloodPressureMeasurement.actions,
	    modalActions: bloodPressureMeasurementModal.actions
	  }),
	      isModal = _useChartActions.isModal,
	      openDay = _useChartActions.openDay,
	      closeDay = _useChartActions.closeDay,
	      baseDate = _useChartActions.baseDate,
	      loadPeriod = _useChartActions.loadPeriod;
	
	  var metric = formatMessage({
	    id: 'patient.healthboard.blood_pressure.metric'
	  });
	
	  var paddingYAxisTicks = (0, _useCalculatePaddingYAxis.useCalculatePaddingYAxis)();
	
	  var setConfig = function setConfig(data, date) {
	    return function (_ref2) {
	      var period = _ref2.period;
	
	      var _calculateMinMaxRange = (0, _utils.calculateMinMaxRangeForRawValue)(data),
	          min = _calculateMinMaxRange.min,
	          max = _calculateMinMaxRange.max;
	
	      return {
	        type: 'line',
	        plugins: [_plugins.TOOLTIP_VERTICAL_LINE],
	        data: (0, _helpers.mapChartData)(data, (0, _options2.getCustomOptions)({ period: period, date: date, formats: formats, metric: metric })),
	        options: (0, _merge2.default)(_options.DEFAULTS, _options.TIMELINE[period], {
	          layout: {
	            padding: {
	              top: isModal ? 120 : 140
	            }
	          },
	          scales: {
	            yAxes: [{
	              ticks: {
	                min: min,
	                max: max,
	                autoSkip: true,
	                autoSkipPadding: paddingYAxisTicks,
	                callback: function callback(value, _, allData) {
	                  var roundedValue = Math.round(value);
	                  if (allData.includes(roundedValue) && roundedValue !== value) return null;
	                  return roundedValue;
	                }
	              }
	            }]
	          },
	          tooltips: {
	            mode: 'point',
	            intersect: true,
	            enabled: [DAY, WEEK, MONTH].includes(period),
	            callbacks: (0, _extends3.default)({}, _options.DEFAULTS.tooltips, {
	              footer: function footer(points, _ref3) {
	                var datasets = _ref3.datasets,
	                    customOptions = _ref3.customOptions;
	                var providers = customOptions.providers;
	                var datasetIndex = points[0].datasetIndex;
	
	                var dataset = datasetIndex ? datasets[datasetIndex] : datasets[0];
	                var providerCode = dataset.label.split('.')[0];
	                var codesDataSet = datasets.filter(function (item) {
	                  return item.label.includes(providerCode);
	                });
	                if (providerCode === _constants.DATA_SOURCE_TYPE.DEVICES) {
	                  var label = dataset.label.split('.')[1];
	                  var devicesPeriodData = (isModal ? modalData : periodData).find(function (el) {
	                    return el.provider.code === _constants.DATA_SOURCE_TYPE.DEVICES;
	                  });
	
	                  var _points = (0, _slicedToArray3.default)(points, 1),
	                      f = _points[0];
	
	                  var index = f.index;
	
	                  if (codesDataSet.length > 1) {
	                    var _codesDataSet = (0, _slicedToArray3.default)(codesDataSet, 2),
	                        first = _codesDataSet[0],
	                        second = _codesDataSet[1];
	
	                    var tooltipData = devicesPeriodData.measurements.find(function (el) {
	                      if (label === 'bpDiastolic') {
	                        return el.value.bpDiastolic === second.data[index];
	                      }
	                      return el.value.bpSystolic === first.data[index];
	                    });
	                    if (tooltipData) {
	                      return getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(tooltipData.originalProviderCodes), formatMessage);
	                    }
	                  }
	                }
	                return providers[providerCode][NAME];
	              }
	            })
	          },
	          spanGaps: true
	        })
	      };
	    };
	  };
	
	  var context = {
	    isModal: isModal,
	    mark: metric,
	    converter: _converters.dataConverter.minmax,
	    range: formatMessage({ id: 'patient.healthboard.minMax' })
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _ChartProvider2.default,
	      { extend: context },
	      _react2.default.createElement(_ChartWrapper2.default, {
	        onLoad: loadPeriod,
	        loading: periodLoading,
	        setConfig: setConfig(periodData)
	      }),
	      _react2.default.createElement(
	        _InfoWrapper2.default,
	        {
	          subtitle: formatMessage({ id: 'patient.healthboard.minMaxData' }),
	          title: formatMessage({
	            id: 'patient.healthboard.titleHistoric.all.blood_pressure'
	          })
	        },
	        _react2.default.createElement(_HistoryWrapper2.default, {
	          unit: 'day',
	          onClick: openDay,
	          data: historyData,
	          onLoad: loadHistory,
	          loading: historyLoading
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _ModalWrapper2.default,
	      {
	        title: formatMessage({
	          id: 'patient.healthboard.titleHistoric.blood_pressure'
	        }),
	        open: isModal,
	        onClose: closeDay
	      },
	      _react2.default.createElement(
	        _ChartProvider2.default,
	        { extend: context },
	        _react2.default.createElement(_ChartWrapper2.default, {
	          isModal: true,
	          loading: modalLoading,
	          setConfig: setConfig(modalData, baseDate),
	          footer: _react2.default.createElement(_HistoryWrapper2.default, { isModal: true, data: modalData })
	        })
	      )
	    )
	  );
	};
	
	BloodPressureChart.propTypes = {
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(BloodPressureChart);

/***/ }),
/* 3525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomOptions = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CDD_SYSTOLIC_BY_PERI, _CDD_DIASTOLIC_BY_PER, _DEVICE_SYSTOLIC_BY_P, _DEVICE_DIASTOLIC_BY_;
	
	var _max = __webpack_require__(577);
	
	var _max2 = _interopRequireDefault(_max);
	
	var _constants = __webpack_require__(114);
	
	var _constants2 = __webpack_require__(54);
	
	var _styles = __webpack_require__(18);
	
	var _options = __webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BLOOD_PRESSURE = _constants2.VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE;
	
	
	var DEFAULTS = {
	  radius: 3.5,
	  borderWidth: 1.5,
	  backgroundColor: 'transparent'
	};
	
	var CCD_SYSTOLIC = (0, _extends3.default)({}, DEFAULTS, {
	  pointStyle: 'rectRot',
	  borderColor: _styles.COLORS.orangeRed,
	  pointBackgroundColor: _styles.COLORS.orangeRed
	});
	
	var CDD_SYSTOLIC_BY_PERIOD = (_CDD_SYSTOLIC_BY_PERI = {}, (0, _defineProperty3.default)(_CDD_SYSTOLIC_BY_PERI, _constants.PERIOD.DAY, (0, _extends3.default)({}, CCD_SYSTOLIC)), (0, _defineProperty3.default)(_CDD_SYSTOLIC_BY_PERI, _constants.PERIOD.WEEK, (0, _extends3.default)({}, CCD_SYSTOLIC)), (0, _defineProperty3.default)(_CDD_SYSTOLIC_BY_PERI, _constants.PERIOD.MONTH, (0, _extends3.default)({}, CCD_SYSTOLIC)), (0, _defineProperty3.default)(_CDD_SYSTOLIC_BY_PERI, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, CCD_SYSTOLIC, _options.POINT_WITHOUT_HOVER)), (0, _defineProperty3.default)(_CDD_SYSTOLIC_BY_PERI, _constants.PERIOD.YEAR, (0, _extends3.default)({}, CCD_SYSTOLIC, _options.POINT_WITHOUT_HOVER)), _CDD_SYSTOLIC_BY_PERI);
	
	var CCD_DIASTOLIC = (0, _extends3.default)({}, DEFAULTS, {
	  borderDash: [8, 4],
	  pointStyle: 'rectRot',
	  borderColor: _styles.COLORS.orangeRed,
	  pointBackgroundColor: _styles.COLORS.orangeRed
	});
	
	var CDD_DIASTOLIC_BY_PERIOD = (_CDD_DIASTOLIC_BY_PER = {}, (0, _defineProperty3.default)(_CDD_DIASTOLIC_BY_PER, _constants.PERIOD.DAY, (0, _extends3.default)({}, CCD_DIASTOLIC)), (0, _defineProperty3.default)(_CDD_DIASTOLIC_BY_PER, _constants.PERIOD.WEEK, (0, _extends3.default)({}, CCD_DIASTOLIC)), (0, _defineProperty3.default)(_CDD_DIASTOLIC_BY_PER, _constants.PERIOD.MONTH, (0, _extends3.default)({}, CCD_DIASTOLIC)), (0, _defineProperty3.default)(_CDD_DIASTOLIC_BY_PER, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, CCD_DIASTOLIC, _options.POINT_WITHOUT_HOVER)), (0, _defineProperty3.default)(_CDD_DIASTOLIC_BY_PER, _constants.PERIOD.YEAR, (0, _extends3.default)({}, CCD_DIASTOLIC, _options.POINT_WITHOUT_HOVER)), _CDD_DIASTOLIC_BY_PER);
	
	var DEVICE_SYSTOLIC = (0, _extends3.default)({}, DEFAULTS, {
	  pointStyle: 'circle',
	  borderColor: _styles.COLORS.black,
	  pointBackgroundColor: _styles.COLORS.black
	});
	
	var DEVICE_SYSTOLIC_BY_PERIOD = (_DEVICE_SYSTOLIC_BY_P = {}, (0, _defineProperty3.default)(_DEVICE_SYSTOLIC_BY_P, _constants.PERIOD.DAY, (0, _extends3.default)({}, DEVICE_SYSTOLIC)), (0, _defineProperty3.default)(_DEVICE_SYSTOLIC_BY_P, _constants.PERIOD.WEEK, (0, _extends3.default)({}, DEVICE_SYSTOLIC)), (0, _defineProperty3.default)(_DEVICE_SYSTOLIC_BY_P, _constants.PERIOD.MONTH, (0, _extends3.default)({}, DEVICE_SYSTOLIC)), (0, _defineProperty3.default)(_DEVICE_SYSTOLIC_BY_P, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, DEVICE_SYSTOLIC, _options.POINT_WITHOUT_HOVER)), (0, _defineProperty3.default)(_DEVICE_SYSTOLIC_BY_P, _constants.PERIOD.YEAR, (0, _extends3.default)({}, DEVICE_SYSTOLIC, _options.POINT_WITHOUT_HOVER)), _DEVICE_SYSTOLIC_BY_P);
	
	var DEVICE_DIASTOLIC = (0, _extends3.default)({}, DEFAULTS, {
	  borderDash: [8, 4],
	  pointStyle: 'circle',
	  borderColor: _styles.COLORS.black,
	  pointBackgroundColor: _styles.COLORS.black
	});
	
	var DEVICE_DIASTOLIC_BY_PERIOD = (_DEVICE_DIASTOLIC_BY_ = {}, (0, _defineProperty3.default)(_DEVICE_DIASTOLIC_BY_, _constants.PERIOD.DAY, (0, _extends3.default)({}, DEVICE_DIASTOLIC)), (0, _defineProperty3.default)(_DEVICE_DIASTOLIC_BY_, _constants.PERIOD.WEEK, (0, _extends3.default)({}, DEVICE_DIASTOLIC)), (0, _defineProperty3.default)(_DEVICE_DIASTOLIC_BY_, _constants.PERIOD.MONTH, (0, _extends3.default)({}, DEVICE_DIASTOLIC)), (0, _defineProperty3.default)(_DEVICE_DIASTOLIC_BY_, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, DEVICE_DIASTOLIC, _options.POINT_WITHOUT_HOVER)), (0, _defineProperty3.default)(_DEVICE_DIASTOLIC_BY_, _constants.PERIOD.YEAR, (0, _extends3.default)({}, DEVICE_DIASTOLIC, _options.POINT_WITHOUT_HOVER)), _DEVICE_DIASTOLIC_BY_);
	
	var NAME = _constants.PROVIDER_OPTION.NAME,
	    ICON = _constants.PROVIDER_OPTION.ICON,
	    NAME_ID = _constants.PROVIDER_OPTION.NAME_ID,
	    OPTIONS = _constants.PROVIDER_OPTION.OPTIONS,
	    RESOURCES = _constants.PROVIDER_OPTION.RESOURCES,
	    ACTIVE_ICON = _constants.PROVIDER_OPTION.ACTIVE_ICON,
	    DISABLED_ICON = _constants.PROVIDER_OPTION.DISABLED_ICON,
	    SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.SINGLE_VALUE_ICON,
	    ACTIVE_SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.ACTIVE_SINGLE_VALUE_ICON;
	var DAY = _constants.PERIOD.DAY,
	    WEEK = _constants.PERIOD.WEEK,
	    MONTH = _constants.PERIOD.MONTH;
	var getCustomOptions = exports.getCustomOptions = function getCustomOptions() {
	  var _bpSystolic, _bpDiastolic, _PROVIDERS$DEVICES, _bpSystolic2, _bpDiastolic2, _PROVIDERS$CCD, _providers;
	
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      period = _ref.period,
	      date = _ref.date,
	      formats = _ref.formats,
	      metric = _ref.metric;
	
	  var withPoint = [DAY, WEEK, MONTH].includes(period);
	
	  return {
	    date: date,
	    metric: metric,
	    period: period,
	    range: _max2.default,
	    type: BLOOD_PRESSURE,
	    tooltip: {
	      showVerticalLine: true
	    },
	    providers: (_providers = {}, (0, _defineProperty3.default)(_providers, _constants.PROVIDERS.DEVICES, (_PROVIDERS$DEVICES = {}, (0, _defineProperty3.default)(_PROVIDERS$DEVICES, NAME, formats[_constants.PROVIDERS.DEVICES]), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ICON, withPoint ? 'icon-graph-devices-line-point-black' : 'icon-graph-line-black'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ACTIVE_ICON, withPoint ? 'icon-graph-devices-line-point-white' : 'icon-graph-line-white'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, DISABLED_ICON, withPoint ? 'icon-graph-devices-line-point-disable' : 'icon-graph-line-disable'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, SINGLE_VALUE_ICON, 'icon-graph-device-point-black'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ACTIVE_SINGLE_VALUE_ICON, 'icon-graph-device-point-white'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, RESOURCES, {
	      bpSystolic: (_bpSystolic = {}, (0, _defineProperty3.default)(_bpSystolic, ICON, 'icon-graph-line-black'), (0, _defineProperty3.default)(_bpSystolic, OPTIONS, DEVICE_SYSTOLIC_BY_PERIOD), (0, _defineProperty3.default)(_bpSystolic, NAME_ID, 'patient.healthboard.blood_pressure.systolic'), _bpSystolic),
	      bpDiastolic: (_bpDiastolic = {}, (0, _defineProperty3.default)(_bpDiastolic, ICON, 'icon-graph-dash-line'), (0, _defineProperty3.default)(_bpDiastolic, OPTIONS, DEVICE_DIASTOLIC_BY_PERIOD), (0, _defineProperty3.default)(_bpDiastolic, NAME_ID, 'patient.healthboard.blood_pressure.diastolic'), _bpDiastolic)
	    }), _PROVIDERS$DEVICES)), (0, _defineProperty3.default)(_providers, _constants.PROVIDERS.CCD, (_PROVIDERS$CCD = {}, (0, _defineProperty3.default)(_PROVIDERS$CCD, NAME, formats[_constants.PROVIDERS.CCD]), (0, _defineProperty3.default)(_PROVIDERS$CCD, ICON, withPoint ? 'icon-graph-health-record-line-orange' : 'icon-graph-line'), (0, _defineProperty3.default)(_PROVIDERS$CCD, ACTIVE_ICON, withPoint ? 'icon-graph-health-record-line-point-white' : 'icon-graph-line-white'), (0, _defineProperty3.default)(_PROVIDERS$CCD, DISABLED_ICON, withPoint ? 'icon-graph-health-record-line-point-disable' : 'icon-graph-line-disable'), (0, _defineProperty3.default)(_PROVIDERS$CCD, SINGLE_VALUE_ICON, 'icon-graph-health-record-point-orange'), (0, _defineProperty3.default)(_PROVIDERS$CCD, ACTIVE_SINGLE_VALUE_ICON, 'icon-graph-health-record-point-white'), (0, _defineProperty3.default)(_PROVIDERS$CCD, RESOURCES, {
	      bpSystolic: (_bpSystolic2 = {}, (0, _defineProperty3.default)(_bpSystolic2, ICON, 'icon-graph-line-black'), (0, _defineProperty3.default)(_bpSystolic2, OPTIONS, CDD_SYSTOLIC_BY_PERIOD), (0, _defineProperty3.default)(_bpSystolic2, NAME_ID, 'patient.healthboard.blood_pressure.systolic'), _bpSystolic2),
	      bpDiastolic: (_bpDiastolic2 = {}, (0, _defineProperty3.default)(_bpDiastolic2, ICON, 'icon-graph-dash-line'), (0, _defineProperty3.default)(_bpDiastolic2, OPTIONS, CDD_DIASTOLIC_BY_PERIOD), (0, _defineProperty3.default)(_bpDiastolic2, NAME_ID, 'patient.healthboard.blood_pressure.diastolic'), _bpDiastolic2)
	    }), _PROVIDERS$CCD)), _providers)
	  };
	};

/***/ }),
/* 3526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _merge = __webpack_require__(379);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = __webpack_require__(114);
	
	var _InfoWrapper = __webpack_require__(787);
	
	var _InfoWrapper2 = _interopRequireDefault(_InfoWrapper);
	
	var _helpers = __webpack_require__(289);
	
	var _ModalWrapper = __webpack_require__(788);
	
	var _ModalWrapper2 = _interopRequireDefault(_ModalWrapper);
	
	var _ChartWrapper = __webpack_require__(785);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	var _ChartProvider = __webpack_require__(784);
	
	var _ChartProvider2 = _interopRequireDefault(_ChartProvider);
	
	var _HistoryWrapper = __webpack_require__(786);
	
	var _HistoryWrapper2 = _interopRequireDefault(_HistoryWrapper);
	
	var _options = __webpack_require__(336);
	
	var _plugins = __webpack_require__(789);
	
	var _bodySurfaceAreaMeasurementsReq = __webpack_require__(1335);
	
	var bodySurfaceAreaMeasurement = _interopRequireWildcard(_bodySurfaceAreaMeasurementsReq);
	
	var _bodySurfaceAreaMeasurementsModalReq = __webpack_require__(1334);
	
	var bodySurfaceAreaMeasurementModal = _interopRequireWildcard(_bodySurfaceAreaMeasurementsModalReq);
	
	var _hooks = __webpack_require__(144);
	
	var _selectors = __webpack_require__(109);
	
	var _utils = __webpack_require__(78);
	
	var _options2 = __webpack_require__(3527);
	
	var _useCalculatePaddingYAxis = __webpack_require__(609);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DAY = _constants2.PERIOD.DAY;
	var BODY_SURFACE_AREA = _constants.VITALS_ACTIVITY_TYPE.BODY_SURFACE_AREA;
	var NAME = _constants2.PROVIDER_OPTION.NAME;
	
	
	var BodySurfaceAreaChart = function BodySurfaceAreaChart(_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	
	  var historyData = (0, _reactRedux.useSelector)(_selectors.selectHistoricMeasurementsList);
	  var periodData = (0, _reactRedux.useSelector)(_selectors.selectBodySurfaceAreaMeasurementEntity);
	  var modalData = (0, _reactRedux.useSelector)(_selectors.selectBodySurfaceAreaMeasurementModalEntity);
	  var historyLoading = (0, _reactRedux.useSelector)(_selectors.selectHistoricMeasurementsListPending);
	  var periodLoading = (0, _reactRedux.useSelector)(_selectors.selectBodySurfaceAreaMeasurementEntityPending);
	  var modalLoading = (0, _reactRedux.useSelector)(_selectors.selectBodySurfaceAreaMeasurementModalEntityPending);
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  var formats = (0, _hooks.useChartFormats)({ formatMessage: formatMessage });
	
	  var _useHistoryActions = (0, _hooks.useHistoryActions)({ type: BODY_SURFACE_AREA }),
	      loadHistory = _useHistoryActions.loadHistory;
	
	  var _useChartActions = (0, _hooks.useChartActions)({
	    actions: bodySurfaceAreaMeasurement.actions,
	    modalActions: bodySurfaceAreaMeasurementModal.actions
	  }),
	      isModal = _useChartActions.isModal,
	      openDay = _useChartActions.openDay,
	      closeDay = _useChartActions.closeDay,
	      baseDate = _useChartActions.baseDate,
	      loadPeriod = _useChartActions.loadPeriod;
	
	  var shortMetric = formatMessage({ id: 'patient.healthboard.bsa.metric' });
	  var metric = _react2.default.createElement(
	    'span',
	    null,
	    shortMetric,
	    _react2.default.createElement(
	      'sup',
	      null,
	      formatMessage({ id: 'patient.healthboard.bsa.metricIndex' })
	    )
	  );
	
	  var paddingYAxisTicks = (0, _useCalculatePaddingYAxis.useCalculatePaddingYAxis)();
	
	  var setConfig = function setConfig(data, date) {
	    return function (_ref2) {
	      var period = _ref2.period;
	
	      var _calculateMinMaxRange = (0, _utils.calculateMinMaxRangeForRawValue)(data),
	          min = _calculateMinMaxRange.min,
	          max = _calculateMinMaxRange.max;
	
	      return {
	        type: 'line',
	        plugins: [_plugins.TOOLTIP_VERTICAL_LINE],
	        data: (0, _helpers.mapChartData)(data, (0, _options2.getCustomOptions)({ period: period, date: date, formats: formats, metric: metric, shortMetric: shortMetric })),
	        options: (0, _merge2.default)(_options.DEFAULTS, _options.TIMELINE[period], {
	          scales: {
	            yAxes: [{
	              ticks: {
	                min: min,
	                max: max,
	                autoSkip: true,
	                autoSkipPadding: paddingYAxisTicks,
	                stepSize: 0.1,
	                callback: function callback(value, _, allData) {
	                  var roundedValue = (0, _utils.roundPrecision)(value, 1);
	                  if (allData.includes(roundedValue) && roundedValue !== value) return null;
	                  return roundedValue;
	                }
	              }
	            }]
	          },
	          layout: {
	            padding: {
	              top: isModal ? 120 : 140
	            }
	          },
	          tooltips: {
	            callbacks: (0, _extends3.default)({}, _options.DEFAULTS.tooltips, {
	              footer: function footer(points, _ref3) {
	                var datasets = _ref3.datasets,
	                    customOptions = _ref3.customOptions;
	                var providers = customOptions.providers;
	                var datasetIndex = points[0].datasetIndex;
	
	                var dataset = datasetIndex ? datasets[datasetIndex] : datasets[0];
	                var providerCode = dataset.label.split('.')[0];
	                if (providerCode === _constants.DATA_SOURCE_TYPE.DEVICES) {
	                  var devicesPeriodData = (isModal ? modalData : periodData).find(function (el) {
	                    return el.provider.code === _constants.DATA_SOURCE_TYPE.DEVICES;
	                  });
	
	                  var _points = (0, _slicedToArray3.default)(points, 1),
	                      f = _points[0];
	
	                  var yLabel = f.yLabel;
	
	                  var tooltipData = devicesPeriodData.measurements.find(function (el) {
	                    return el.value.baseValue === yLabel;
	                  });
	                  if (tooltipData) {
	                    return getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(tooltipData.originalProviderCodes), formatMessage);
	                  }
	                }
	                return providers[providerCode][NAME];
	              }
	            })
	          }
	        })
	      };
	    };
	  };
	
	  var context = {
	    isModal: isModal,
	    mark: metric,
	    converter: _helpers.dataConverter.float,
	    range: formatMessage({ id: 'patient.healthboard.average' })
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _ChartProvider2.default,
	      { extend: context },
	      _react2.default.createElement(_ChartWrapper2.default, {
	        onLoad: loadPeriod,
	        loading: periodLoading,
	        setConfig: setConfig(periodData)
	      }),
	      _react2.default.createElement(
	        _InfoWrapper2.default,
	        {
	          subtitle: formatMessage({ id: 'patient.healthboard.averageData' }),
	          title: formatMessage({
	            id: 'patient.healthboard.titleHistoric.bsa'
	          })
	        },
	        _react2.default.createElement(_HistoryWrapper2.default, {
	          unit: DAY,
	          onClick: openDay,
	          data: historyData,
	          onLoad: loadHistory,
	          loading: historyLoading
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _ModalWrapper2.default,
	      {
	        title: formatMessage({
	          id: 'patient.healthboard.bsa'
	        }),
	        open: isModal,
	        onClose: closeDay
	      },
	      _react2.default.createElement(
	        _ChartProvider2.default,
	        { extend: context },
	        _react2.default.createElement(_ChartWrapper2.default, {
	          isModal: true,
	          loading: modalLoading,
	          setConfig: setConfig(modalData, baseDate),
	          footer: _react2.default.createElement(_HistoryWrapper2.default, { isModal: true, data: modalData })
	        })
	      )
	    )
	  );
	};
	
	BodySurfaceAreaChart.propTypes = {
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(BodySurfaceAreaChart);

/***/ }),
/* 3527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomOptions = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _DEVICE_BY_PERIOD, _CDD_BY_PERIOD;
	
	var _max = __webpack_require__(577);
	
	var _max2 = _interopRequireDefault(_max);
	
	var _constants = __webpack_require__(114);
	
	var _constants2 = __webpack_require__(54);
	
	var _styles = __webpack_require__(18);
	
	var _options = __webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BODY_SURFACE_AREA = _constants2.VITALS_ACTIVITY_TYPE.BODY_SURFACE_AREA;
	
	
	var DEFAULTS = {
	  radius: 3.5,
	  showLine: false,
	  borderWidth: 1.5,
	  pointStyle: 'rectRot',
	  backgroundColor: 'transparent'
	};
	
	var CCD_BASE = (0, _extends3.default)({}, DEFAULTS, {
	  borderColor: _styles.COLORS.orangeRed,
	  pointBackgroundColor: _styles.COLORS.orangeRed
	});
	
	var DEVICE_BASE = (0, _extends3.default)({}, DEFAULTS, {
	  pointStyle: 'circle',
	  borderColor: _styles.COLORS.black,
	  pointBackgroundColor: _styles.COLORS.black
	});
	
	var DEVICE_BY_PERIOD = (_DEVICE_BY_PERIOD = {}, (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.DAY, (0, _extends3.default)({}, DEVICE_BASE)), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.WEEK, (0, _extends3.default)({}, DEVICE_BASE)), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.MONTH, (0, _extends3.default)({}, DEVICE_BASE)), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, DEVICE_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.YEAR, (0, _extends3.default)({}, DEVICE_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), _DEVICE_BY_PERIOD);
	
	var CDD_BY_PERIOD = (_CDD_BY_PERIOD = {}, (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.DAY, (0, _extends3.default)({}, CCD_BASE)), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.WEEK, (0, _extends3.default)({}, CCD_BASE)), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.MONTH, (0, _extends3.default)({}, CCD_BASE)), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, CCD_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.YEAR, (0, _extends3.default)({}, CCD_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), _CDD_BY_PERIOD);
	
	var NAME = _constants.PROVIDER_OPTION.NAME,
	    ICON = _constants.PROVIDER_OPTION.ICON,
	    OPTIONS = _constants.PROVIDER_OPTION.OPTIONS,
	    RESOURCES = _constants.PROVIDER_OPTION.RESOURCES,
	    ACTIVE_ICON = _constants.PROVIDER_OPTION.ACTIVE_ICON,
	    DISABLED_ICON = _constants.PROVIDER_OPTION.DISABLED_ICON,
	    SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.SINGLE_VALUE_ICON,
	    ACTIVE_SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.ACTIVE_SINGLE_VALUE_ICON;
	var DAY = _constants.PERIOD.DAY,
	    WEEK = _constants.PERIOD.WEEK,
	    MONTH = _constants.PERIOD.MONTH;
	var getCustomOptions = exports.getCustomOptions = function getCustomOptions() {
	  var _PROVIDERS$DEVICES, _PROVIDERS$CCD, _providers;
	
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      period = _ref.period,
	      date = _ref.date,
	      formats = _ref.formats,
	      metric = _ref.metric,
	      shortMetric = _ref.shortMetric;
	
	  var withPoint = [DAY, WEEK, MONTH].includes(period);
	
	  return {
	    date: date,
	    metric: metric,
	    period: period,
	    shortMetric: shortMetric,
	    range: _max2.default,
	    type: BODY_SURFACE_AREA,
	    tooltip: {
	      showVerticalLine: true
	    },
	    providers: (_providers = {}, (0, _defineProperty3.default)(_providers, _constants.PROVIDERS.DEVICES, (_PROVIDERS$DEVICES = {}, (0, _defineProperty3.default)(_PROVIDERS$DEVICES, RESOURCES, {
	      baseValue: (0, _defineProperty3.default)({}, OPTIONS, DEVICE_BY_PERIOD)
	    }), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, NAME, formats[_constants.PROVIDERS.DEVICES]), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ICON, withPoint ? 'icon-graph-devices-line-point-black' : 'icon-graph-line-black'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ACTIVE_ICON, withPoint ? 'icon-graph-devices-line-point-white' : 'icon-graph-line-white'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, DISABLED_ICON, withPoint ? 'icon-graph-devices-line-point-disable' : 'icon-graph-line-disable'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, SINGLE_VALUE_ICON, 'icon-graph-device-point-black'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ACTIVE_SINGLE_VALUE_ICON, 'icon-graph-device-point-white'), _PROVIDERS$DEVICES)), (0, _defineProperty3.default)(_providers, _constants.PROVIDERS.CCD, (_PROVIDERS$CCD = {}, (0, _defineProperty3.default)(_PROVIDERS$CCD, RESOURCES, {
	      baseValue: (0, _defineProperty3.default)({}, OPTIONS, CDD_BY_PERIOD)
	    }), (0, _defineProperty3.default)(_PROVIDERS$CCD, ICON, withPoint ? 'icon-graph-health-record-point-orange' : 'icon-graph-line'), (0, _defineProperty3.default)(_PROVIDERS$CCD, ACTIVE_ICON, withPoint ? 'icon-graph-health-record-point-white' : 'icon-graph-line-white'), (0, _defineProperty3.default)(_PROVIDERS$CCD, DISABLED_ICON, withPoint ? 'icon-graph-health-record-line-point-disable' : 'icon-graph-line-disable'), (0, _defineProperty3.default)(_PROVIDERS$CCD, SINGLE_VALUE_ICON, 'icon-graph-health-record-point-orange'), (0, _defineProperty3.default)(_PROVIDERS$CCD, ACTIVE_SINGLE_VALUE_ICON, 'icon-graph-health-record-point-white'), (0, _defineProperty3.default)(_PROVIDERS$CCD, NAME, formats[_constants.PROVIDERS.CCD]), _PROVIDERS$CCD)), _providers)
	  };
	};

/***/ }),
/* 3528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _merge = __webpack_require__(379);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = __webpack_require__(114);
	
	var _InfoWrapper = __webpack_require__(787);
	
	var _InfoWrapper2 = _interopRequireDefault(_InfoWrapper);
	
	var _helpers = __webpack_require__(289);
	
	var _ModalWrapper = __webpack_require__(788);
	
	var _ModalWrapper2 = _interopRequireDefault(_ModalWrapper);
	
	var _ChartWrapper = __webpack_require__(785);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	var _ChartProvider = __webpack_require__(784);
	
	var _ChartProvider2 = _interopRequireDefault(_ChartProvider);
	
	var _HistoryWrapper = __webpack_require__(786);
	
	var _HistoryWrapper2 = _interopRequireDefault(_HistoryWrapper);
	
	var _options = __webpack_require__(336);
	
	var _plugins = __webpack_require__(789);
	
	var _bodyTemperatureMeasurementsReq = __webpack_require__(1337);
	
	var bodyTemperatureMeasurement = _interopRequireWildcard(_bodyTemperatureMeasurementsReq);
	
	var _bodyTemperatureMeasurementsModalReq = __webpack_require__(1336);
	
	var bodyTemperatureMeasurementModal = _interopRequireWildcard(_bodyTemperatureMeasurementsModalReq);
	
	var _hooks = __webpack_require__(144);
	
	var _selectors = __webpack_require__(109);
	
	var _utils = __webpack_require__(78);
	
	var _options2 = __webpack_require__(3529);
	
	var _useCalculatePaddingYAxis = __webpack_require__(609);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DAY = _constants2.PERIOD.DAY,
	    WEEK = _constants2.PERIOD.WEEK,
	    MONTH = _constants2.PERIOD.MONTH;
	var BODY_TEMPERATURE = _constants.VITALS_ACTIVITY_TYPE.BODY_TEMPERATURE;
	var NAME = _constants2.PROVIDER_OPTION.NAME;
	
	
	var BodyTemperatureChart = function BodyTemperatureChart(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      isTemperatureInCelsius = _ref.isTemperatureInCelsius;
	
	  var historyData = (0, _reactRedux.useSelector)(_selectors.selectHistoricMeasurementsList);
	  var periodDataTemperature = (0, _reactRedux.useSelector)(_selectors.selectBodyTemperatureMeasurementEntity);
	  var modalDataTemperature = (0, _reactRedux.useSelector)(_selectors.selectBodyTemperatureMeasurementModalEntity);
	  var historyLoadingTemperature = (0, _reactRedux.useSelector)(_selectors.selectHistoricMeasurementsListPending);
	  var periodLoadingTemperature = (0, _reactRedux.useSelector)(_selectors.selectBodyTemperatureMeasurementEntityPending);
	  var modalLoadingTemperature = (0, _reactRedux.useSelector)(_selectors.selectBodyTemperatureMeasurementModalEntityPending);
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  var formats = (0, _hooks.useChartFormats)({ formatMessage: formatMessage });
	
	  var _useHistoryActions = (0, _hooks.useHistoryActions)({ type: BODY_TEMPERATURE }),
	      loadHistory = _useHistoryActions.loadHistory;
	
	  var _useChartActions = (0, _hooks.useChartActions)({
	    actions: bodyTemperatureMeasurement.actions,
	    modalActions: bodyTemperatureMeasurementModal.actions
	  }),
	      isModal = _useChartActions.isModal,
	      openDay = _useChartActions.openDay,
	      closeDay = _useChartActions.closeDay,
	      baseDate = _useChartActions.baseDate,
	      loadPeriod = _useChartActions.loadPeriod;
	
	  var metric = isTemperatureInCelsius ? formatMessage({
	    id: 'patient.healthboard.body_temperature.metric.celsius'
	  }) : formatMessage({
	    id: 'patient.healthboard.body_temperature.metric.fahrenheit'
	  });
	
	  var paddingYAxisTicks = (0, _useCalculatePaddingYAxis.useCalculatePaddingYAxis)();
	
	  var setConfig = function setConfig(data, date) {
	    return function (_ref2) {
	      var period = _ref2.period;
	
	      var _calculateMinMaxRange = (0, _utils.calculateMinMaxRangeForRawValue)(data),
	          min = _calculateMinMaxRange.min,
	          max = _calculateMinMaxRange.max;
	
	      return {
	        options: (0, _merge2.default)(_options.DEFAULTS, _options.TIMELINE[period], {
	          layout: {
	            padding: {
	              top: isModal ? 120 : 140
	            }
	          },
	          tooltips: {
	            enabled: [DAY, WEEK, MONTH].includes(period),
	            callbacks: (0, _extends3.default)({}, _options.DEFAULTS.tooltips, {
	              footer: function footer(points, _ref3) {
	                var datasets = _ref3.datasets,
	                    customOptions = _ref3.customOptions;
	                var providers = customOptions.providers;
	                var _points$ = points[0],
	                    datasetIndex = _points$.datasetIndex,
	                    yLabel = _points$.yLabel;
	
	                var dataset = datasetIndex ? datasets[datasetIndex] : datasets[0];
	                var providerCode = dataset.label.split('.')[0];
	                if (providerCode === _constants.DATA_SOURCE_TYPE.DEVICES) {
	                  var modalDevicesPeriodData = modalDataTemperature.find(function (el) {
	                    return el.provider.code === _constants.DATA_SOURCE_TYPE.DEVICES;
	                  });
	                  var tooltipData = (isModal && modalDevicesPeriodData.measurements ? modalDevicesPeriodData.measurements : historyData).find(function (el) {
	                    return el.value.baseValue === yLabel;
	                  });
	
	                  if (tooltipData) {
	                    return getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(tooltipData.originalProviderCodes), formatMessage);
	                  }
	                }
	                return providers[providerCode][NAME];
	              }
	            })
	          },
	          scales: {
	            yAxes: [{
	              ticks: {
	                min: !isTemperatureInCelsius ? (0, _utils.convertCelsiusToFahrenheit)(min) : min,
	                max: !isTemperatureInCelsius ? (0, _utils.convertCelsiusToFahrenheit)(max) : max,
	                autoSkip: true,
	                autoSkipPadding: paddingYAxisTicks,
	                stepSize: 0.1,
	                callback: function callback(value, _, allData) {
	                  var roundedValue = (0, _utils.roundPrecision)(value, 1);
	                  if (allData.includes(roundedValue) && roundedValue !== value) return null;
	                  return roundedValue;
	                }
	              }
	            }]
	          }
	        }),
	        type: 'line',
	        plugins: [_plugins.TOOLTIP_VERTICAL_LINE],
	        data: (0, _helpers.mapChartData)(data, (0, _options2.getCustomOptions)({
	          period: period,
	          date: date,
	          formats: formats,
	          metric: metric,
	          shouldConvertToFahrenheit: !isTemperatureInCelsius
	        }))
	      };
	    };
	  };
	
	  var context = {
	    isModal: isModal,
	    mark: metric,
	    converter: _helpers.dataConverter.float,
	    shouldConvertToFahrenheit: !isTemperatureInCelsius,
	    range: formatMessage({ id: 'patient.healthboard.average' })
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _ChartProvider2.default,
	      { extend: context },
	      _react2.default.createElement(_ChartWrapper2.default, {
	        onLoad: loadPeriod,
	        loading: periodLoadingTemperature,
	        setConfig: setConfig(periodDataTemperature)
	      }),
	      _react2.default.createElement(
	        _InfoWrapper2.default,
	        {
	          subtitle: formatMessage({ id: 'patient.healthboard.averageData' }),
	          title: formatMessage({
	            id: 'patient.healthboard.titleHistoric.body_temperature'
	          })
	        },
	        _react2.default.createElement(_HistoryWrapper2.default, {
	          unit: DAY,
	          onClick: openDay,
	          data: historyData,
	          onLoad: loadHistory,
	          loading: historyLoadingTemperature
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _ModalWrapper2.default,
	      {
	        title: formatMessage({
	          id: 'patient.healthboard.body_temperature'
	        }),
	        open: isModal,
	        onClose: closeDay
	      },
	      _react2.default.createElement(
	        _ChartProvider2.default,
	        { extend: context },
	        _react2.default.createElement(_ChartWrapper2.default, {
	          isModal: true,
	          loading: modalLoadingTemperature,
	          setConfig: setConfig(modalDataTemperature, baseDate),
	          footer: _react2.default.createElement(_HistoryWrapper2.default, { isModal: true, data: modalDataTemperature })
	        })
	      )
	    )
	  );
	};
	
	BodyTemperatureChart.propTypes = {
	  intl: _propTypes2.default.object.isRequired,
	  isTemperatureInCelsius: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(BodyTemperatureChart);

/***/ }),
/* 3529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomOptions = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CDD_BY_PERIOD, _DEVICE_BY_PERIOD;
	
	var _max = __webpack_require__(577);
	
	var _max2 = _interopRequireDefault(_max);
	
	var _constants = __webpack_require__(114);
	
	var _constants2 = __webpack_require__(54);
	
	var _styles = __webpack_require__(18);
	
	var _options = __webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BODY_TEMPERATURE = _constants2.VITALS_ACTIVITY_TYPE.BODY_TEMPERATURE;
	
	
	var DEFAULTS = {
	  showLine: false,
	  borderWidth: 1.5,
	  pointStyle: 'rectRot',
	  backgroundColor: 'transparent',
	  radius: 3.5
	};
	
	var DEVICE_BASE = (0, _extends3.default)({}, DEFAULTS, {
	  pointStyle: 'circle',
	  borderColor: _styles.COLORS.black,
	  pointBackgroundColor: _styles.COLORS.black
	});
	
	var CCD_BASE = (0, _extends3.default)({
	  pointBackgroundColor: _styles.COLORS.orangeRed,
	  borderColor: _styles.COLORS.orangeRed
	}, DEFAULTS);
	
	var CDD_BY_PERIOD = (_CDD_BY_PERIOD = {}, (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.DAY, (0, _extends3.default)({}, CCD_BASE)), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.WEEK, (0, _extends3.default)({}, CCD_BASE)), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.MONTH, (0, _extends3.default)({}, CCD_BASE)), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, CCD_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.YEAR, (0, _extends3.default)({}, CCD_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), _CDD_BY_PERIOD);
	
	var DEVICE_BY_PERIOD = (_DEVICE_BY_PERIOD = {}, (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.DAY, (0, _extends3.default)({}, DEVICE_BASE)), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.WEEK, (0, _extends3.default)({}, DEVICE_BASE)), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.MONTH, (0, _extends3.default)({}, DEVICE_BASE)), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, DEVICE_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.YEAR, (0, _extends3.default)({}, DEVICE_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), _DEVICE_BY_PERIOD);
	
	var NAME = _constants.PROVIDER_OPTION.NAME,
	    ICON = _constants.PROVIDER_OPTION.ICON,
	    OPTIONS = _constants.PROVIDER_OPTION.OPTIONS,
	    RESOURCES = _constants.PROVIDER_OPTION.RESOURCES,
	    ACTIVE_ICON = _constants.PROVIDER_OPTION.ACTIVE_ICON,
	    DISABLED_ICON = _constants.PROVIDER_OPTION.DISABLED_ICON,
	    SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.SINGLE_VALUE_ICON,
	    ACTIVE_SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.ACTIVE_SINGLE_VALUE_ICON;
	var DAY = _constants.PERIOD.DAY,
	    WEEK = _constants.PERIOD.WEEK,
	    MONTH = _constants.PERIOD.MONTH;
	var getCustomOptions = exports.getCustomOptions = function getCustomOptions() {
	  var _PROVIDERS$DEVICES, _PROVIDERS$CCD, _providers;
	
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      period = _ref.period,
	      date = _ref.date,
	      formats = _ref.formats,
	      metric = _ref.metric,
	      shouldConvertToFahrenheit = _ref.shouldConvertToFahrenheit;
	
	  var withPoint = [DAY, WEEK, MONTH].includes(period);
	
	  return {
	    date: date,
	    metric: metric,
	    period: period,
	    shouldConvertToFahrenheit: shouldConvertToFahrenheit,
	    range: _max2.default,
	    type: BODY_TEMPERATURE,
	    tooltip: {
	      showVerticalLine: true
	    },
	    providers: (_providers = {}, (0, _defineProperty3.default)(_providers, _constants.PROVIDERS.DEVICES, (_PROVIDERS$DEVICES = {}, (0, _defineProperty3.default)(_PROVIDERS$DEVICES, RESOURCES, {
	      baseValue: (0, _defineProperty3.default)({}, OPTIONS, DEVICE_BY_PERIOD)
	    }), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ICON, withPoint ? 'icon-graph-devices-line-point-black' : 'icon-graph-line-black'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ACTIVE_ICON, withPoint ? 'icon-graph-devices-line-point-white' : 'icon-graph-line-white'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, DISABLED_ICON, withPoint ? 'icon-graph-devices-line-point-disable' : 'icon-graph-line-disable'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, SINGLE_VALUE_ICON, 'icon-graph-device-point-black'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ACTIVE_SINGLE_VALUE_ICON, 'icon-graph-device-point-white'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, NAME, formats[_constants.PROVIDERS.DEVICES]), _PROVIDERS$DEVICES)), (0, _defineProperty3.default)(_providers, _constants.PROVIDERS.CCD, (_PROVIDERS$CCD = {}, (0, _defineProperty3.default)(_PROVIDERS$CCD, RESOURCES, {
	      baseValue: (0, _defineProperty3.default)({}, OPTIONS, CDD_BY_PERIOD)
	    }), (0, _defineProperty3.default)(_PROVIDERS$CCD, ICON, withPoint ? 'icon-graph-health-record-point-orange' : 'icon-graph-line'), (0, _defineProperty3.default)(_PROVIDERS$CCD, ACTIVE_ICON, withPoint ? 'icon-graph-health-record-point-white' : 'icon-graph-line-white'), (0, _defineProperty3.default)(_PROVIDERS$CCD, DISABLED_ICON, withPoint ? 'icon-graph-health-record-line-point-disable' : 'icon-graph-line-disable'), (0, _defineProperty3.default)(_PROVIDERS$CCD, SINGLE_VALUE_ICON, 'icon-graph-health-record-point-orange'), (0, _defineProperty3.default)(_PROVIDERS$CCD, ACTIVE_SINGLE_VALUE_ICON, 'icon-graph-health-record-point-white'), (0, _defineProperty3.default)(_PROVIDERS$CCD, NAME, formats[_constants.PROVIDERS.CCD]), _PROVIDERS$CCD)), _providers)
	  };
	};

/***/ }),
/* 3530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _merge = __webpack_require__(379);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _constants = __webpack_require__(54);
	
	var _constants2 = __webpack_require__(114);
	
	var _InfoWrapper = __webpack_require__(787);
	
	var _InfoWrapper2 = _interopRequireDefault(_InfoWrapper);
	
	var _helpers = __webpack_require__(289);
	
	var _ModalWrapper = __webpack_require__(788);
	
	var _ModalWrapper2 = _interopRequireDefault(_ModalWrapper);
	
	var _ChartWrapper = __webpack_require__(785);
	
	var _ChartWrapper2 = _interopRequireDefault(_ChartWrapper);
	
	var _ChartProvider = __webpack_require__(784);
	
	var _ChartProvider2 = _interopRequireDefault(_ChartProvider);
	
	var _HistoryWrapper = __webpack_require__(786);
	
	var _HistoryWrapper2 = _interopRequireDefault(_HistoryWrapper);
	
	var _options = __webpack_require__(336);
	
	var _plugins = __webpack_require__(789);
	
	var _respiratoryRateMeasurementsReq = __webpack_require__(886);
	
	var respiratoryRateMeasurement = _interopRequireWildcard(_respiratoryRateMeasurementsReq);
	
	var _respiratoryRateMeasurementsModalReq = __webpack_require__(1347);
	
	var respiratoryRateMeasurementModal = _interopRequireWildcard(_respiratoryRateMeasurementsModalReq);
	
	var _hooks = __webpack_require__(144);
	
	var _selectors = __webpack_require__(109);
	
	var _options2 = __webpack_require__(3531);
	
	var _utils = __webpack_require__(78);
	
	var _useCalculatePaddingYAxis = __webpack_require__(609);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DAY = _constants2.PERIOD.DAY,
	    WEEK = _constants2.PERIOD.WEEK,
	    MONTH = _constants2.PERIOD.MONTH;
	var RESPIRATORY_RATE = _constants.VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE;
	
	
	var RespiratoryRateChart = function RespiratoryRateChart(_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	
	  var historyData = (0, _reactRedux.useSelector)(_selectors.selectHistoricMeasurementsList);
	  var periodData = (0, _reactRedux.useSelector)(_selectors.selectRespiratoryRateMeasurementEntity);
	  var modalData = (0, _reactRedux.useSelector)(_selectors.selectRespiratoryRateMeasurementModalEntity);
	  var historyLoading = (0, _reactRedux.useSelector)(_selectors.selectHistoricMeasurementsListPending);
	  var periodLoading = (0, _reactRedux.useSelector)(_selectors.selectRespiratoryRateMeasurementEntityPending);
	  var modalLoading = (0, _reactRedux.useSelector)(_selectors.selectRespiratoryRateMeasurementModalEntityPending);
	
	  var formats = (0, _hooks.useChartFormats)({ formatMessage: formatMessage });
	
	  var _useHistoryActions = (0, _hooks.useHistoryActions)({ type: RESPIRATORY_RATE }),
	      loadHistory = _useHistoryActions.loadHistory;
	
	  var _useChartActions = (0, _hooks.useChartActions)({
	    actions: respiratoryRateMeasurement.actions,
	    modalActions: respiratoryRateMeasurementModal.actions
	  }),
	      isModal = _useChartActions.isModal,
	      openDay = _useChartActions.openDay,
	      closeDay = _useChartActions.closeDay,
	      baseDate = _useChartActions.baseDate,
	      loadPeriod = _useChartActions.loadPeriod;
	
	  var metric = formatMessage({
	    id: 'patient.healthboard.respiratory_rate.metric'
	  });
	
	  var paddingYAxisTicks = (0, _useCalculatePaddingYAxis.useCalculatePaddingYAxis)();
	
	  var setConfig = function setConfig(data, date) {
	    return function (_ref2) {
	      var period = _ref2.period;
	
	      var _calculateMinMaxRange = (0, _utils.calculateMinMaxRangeForRawValue)(data),
	          min = _calculateMinMaxRange.min,
	          max = _calculateMinMaxRange.max;
	
	      return {
	        type: 'line',
	        plugins: [_plugins.TOOLTIP_VERTICAL_LINE],
	        data: (0, _helpers.mapChartData)(data, (0, _options2.getCustomOptions)({ period: period, date: date, formats: formats, metric: metric })),
	        options: (0, _merge2.default)(_options.DEFAULTS, _options.TIMELINE[period], {
	          layout: {
	            padding: {
	              top: isModal ? 120 : 140
	            }
	          },
	          tooltips: {
	            enabled: [DAY, WEEK, MONTH].includes(period)
	          },
	          scales: {
	            yAxes: [{
	              ticks: {
	                min: min,
	                max: max,
	                autoSkip: true,
	                autoSkipPadding: paddingYAxisTicks,
	                callback: function callback(value, _, allData) {
	                  var roundedValue = Math.round(value);
	                  if (allData.includes(roundedValue) && roundedValue !== value) return null;
	                  return roundedValue;
	                }
	              }
	            }]
	          }
	        })
	      };
	    };
	  };
	
	  var context = {
	    isModal: isModal,
	    mark: metric,
	    converter: _helpers.dataConverter.average,
	    range: formatMessage({ id: 'patient.healthboard.average' })
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _ChartProvider2.default,
	      { extend: context },
	      _react2.default.createElement(_ChartWrapper2.default, {
	        onLoad: loadPeriod,
	        loading: periodLoading,
	        setConfig: setConfig(periodData)
	      }),
	      _react2.default.createElement(
	        _InfoWrapper2.default,
	        {
	          subtitle: formatMessage({ id: 'patient.healthboard.averageData' }),
	          title: formatMessage({
	            id: 'patient.healthboard.titleHistoric.all.respiratory_rate'
	          })
	        },
	        _react2.default.createElement(_HistoryWrapper2.default, {
	          unit: 'day',
	          onClick: openDay,
	          data: historyData,
	          onLoad: loadHistory,
	          loading: historyLoading
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _ModalWrapper2.default,
	      {
	        title: formatMessage({
	          id: 'patient.healthboard.titleHistoric.respiratory_rate'
	        }),
	        open: isModal,
	        onClose: closeDay
	      },
	      _react2.default.createElement(
	        _ChartProvider2.default,
	        { extend: context },
	        _react2.default.createElement(_ChartWrapper2.default, {
	          isModal: true,
	          loading: modalLoading,
	          setConfig: setConfig(modalData, baseDate),
	          footer: _react2.default.createElement(_HistoryWrapper2.default, { isModal: true, data: modalData })
	        })
	      )
	    )
	  );
	};
	
	RespiratoryRateChart.propTypes = {
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(RespiratoryRateChart);

/***/ }),
/* 3531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCustomOptions = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _CDD_BY_PERIOD, _DEVICE_BY_PERIOD;
	
	var _max = __webpack_require__(577);
	
	var _max2 = _interopRequireDefault(_max);
	
	var _constants = __webpack_require__(114);
	
	var _constants2 = __webpack_require__(54);
	
	var _styles = __webpack_require__(18);
	
	var _options = __webpack_require__(336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RESPIRATORY_RATE = _constants2.VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE;
	
	
	var DEFAULTS = {
	  radius: 3.5,
	  showLine: false,
	  borderWidth: 1.5,
	  pointStyle: 'rectRot',
	  backgroundColor: 'transparent'
	};
	
	var CCD_BASE = (0, _extends3.default)({}, DEFAULTS, {
	  borderColor: _styles.COLORS.orangeRed,
	  pointBackgroundColor: _styles.COLORS.orangeRed
	});
	
	var CDD_BY_PERIOD = (_CDD_BY_PERIOD = {}, (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.DAY, (0, _extends3.default)({}, CCD_BASE)), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.WEEK, (0, _extends3.default)({}, CCD_BASE)), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.MONTH, (0, _extends3.default)({}, CCD_BASE)), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, CCD_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), (0, _defineProperty3.default)(_CDD_BY_PERIOD, _constants.PERIOD.YEAR, (0, _extends3.default)({}, CCD_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), _CDD_BY_PERIOD);
	
	var DEVICE_BASE = (0, _extends3.default)({}, DEFAULTS, {
	  pointStyle: 'circle',
	  borderColor: _styles.COLORS.black,
	  pointBackgroundColor: _styles.COLORS.black
	});
	
	var DEVICE_BY_PERIOD = (_DEVICE_BY_PERIOD = {}, (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.DAY, (0, _extends3.default)({}, DEVICE_BASE)), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.WEEK, (0, _extends3.default)({}, DEVICE_BASE)), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.MONTH, (0, _extends3.default)({}, DEVICE_BASE)), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.QUARTER, (0, _extends3.default)({}, DEVICE_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), (0, _defineProperty3.default)(_DEVICE_BY_PERIOD, _constants.PERIOD.YEAR, (0, _extends3.default)({}, DEVICE_BASE, _options.POINT_WITHOUT_HOVER, {
	  showLine: true
	})), _DEVICE_BY_PERIOD);
	
	var NAME = _constants.PROVIDER_OPTION.NAME,
	    ICON = _constants.PROVIDER_OPTION.ICON,
	    OPTIONS = _constants.PROVIDER_OPTION.OPTIONS,
	    RESOURCES = _constants.PROVIDER_OPTION.RESOURCES,
	    ACTIVE_ICON = _constants.PROVIDER_OPTION.ACTIVE_ICON,
	    DISABLED_ICON = _constants.PROVIDER_OPTION.DISABLED_ICON,
	    SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.SINGLE_VALUE_ICON,
	    ACTIVE_SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.ACTIVE_SINGLE_VALUE_ICON;
	var DAY = _constants.PERIOD.DAY,
	    WEEK = _constants.PERIOD.WEEK,
	    MONTH = _constants.PERIOD.MONTH;
	var getCustomOptions = exports.getCustomOptions = function getCustomOptions() {
	  var _PROVIDERS$DEVICES, _PROVIDERS$CCD, _providers;
	
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      period = _ref.period,
	      date = _ref.date,
	      formats = _ref.formats,
	      metric = _ref.metric;
	
	  var withPoint = [DAY, WEEK, MONTH].includes(period);
	
	  return {
	    date: date,
	    metric: metric,
	    period: period,
	    range: _max2.default,
	    type: RESPIRATORY_RATE,
	    tooltip: {
	      showVerticalLine: true
	    },
	    providers: (_providers = {}, (0, _defineProperty3.default)(_providers, _constants.PROVIDERS.DEVICES, (_PROVIDERS$DEVICES = {}, (0, _defineProperty3.default)(_PROVIDERS$DEVICES, RESOURCES, {
	      baseValue: (0, _defineProperty3.default)({}, OPTIONS, DEVICE_BY_PERIOD)
	    }), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ICON, withPoint ? 'icon-graph-devices-line-point-black' : 'icon-graph-line-black'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ACTIVE_ICON, withPoint ? 'icon-graph-devices-line-point-white' : 'icon-graph-line-white'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, DISABLED_ICON, withPoint ? 'icon-graph-devices-line-point-disable' : 'icon-graph-line-disable'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, SINGLE_VALUE_ICON, 'icon-graph-device-point-black'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, ACTIVE_SINGLE_VALUE_ICON, 'icon-graph-device-point-white'), (0, _defineProperty3.default)(_PROVIDERS$DEVICES, NAME, formats[_constants.PROVIDERS.DEVICES]), _PROVIDERS$DEVICES)), (0, _defineProperty3.default)(_providers, _constants.PROVIDERS.CCD, (_PROVIDERS$CCD = {}, (0, _defineProperty3.default)(_PROVIDERS$CCD, RESOURCES, {
	      baseValue: (0, _defineProperty3.default)({}, OPTIONS, CDD_BY_PERIOD)
	    }), (0, _defineProperty3.default)(_PROVIDERS$CCD, ICON, withPoint ? 'icon-graph-health-record-point-orange' : 'icon-graph-line'), (0, _defineProperty3.default)(_PROVIDERS$CCD, ACTIVE_ICON, withPoint ? 'icon-graph-health-record-point-white' : 'icon-graph-line-white'), (0, _defineProperty3.default)(_PROVIDERS$CCD, DISABLED_ICON, withPoint ? 'icon-graph-health-record-line-point-disable' : 'icon-graph-line-disable'), (0, _defineProperty3.default)(_PROVIDERS$CCD, SINGLE_VALUE_ICON, 'icon-graph-health-record-point-orange'), (0, _defineProperty3.default)(_PROVIDERS$CCD, ACTIVE_SINGLE_VALUE_ICON, 'icon-graph-health-record-point-white'), (0, _defineProperty3.default)(_PROVIDERS$CCD, NAME, formats[_constants.PROVIDERS.CCD]), _PROVIDERS$CCD)), _providers)
	  };
	};

/***/ }),
/* 3532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(54);
	
	var _BloodPressureChart = __webpack_require__(3524);
	
	var _BloodPressureChart2 = _interopRequireDefault(_BloodPressureChart);
	
	var _RespiratoryRateChart = __webpack_require__(3530);
	
	var _RespiratoryRateChart2 = _interopRequireDefault(_RespiratoryRateChart);
	
	var _BodySurfaceAreaChart = __webpack_require__(3526);
	
	var _BodySurfaceAreaChart2 = _interopRequireDefault(_BodySurfaceAreaChart);
	
	var _BodyTemperatureChart = __webpack_require__(3528);
	
	var _BodyTemperatureChart2 = _interopRequireDefault(_BodyTemperatureChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BLOOD_PRESSURE = _constants.VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE,
	    RESPIRATORY_RATE = _constants.VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE,
	    BODY_SURFACE_AREA = _constants.VITALS_ACTIVITY_TYPE.BODY_SURFACE_AREA,
	    BODY_TEMPERATURE = _constants.VITALS_ACTIVITY_TYPE.BODY_TEMPERATURE;
	
	
	var TimeScalableChart = function TimeScalableChart(_ref) {
	  var activeCardType = _ref.activeCardType,
	      isTemperatureInCelsius = _ref.isTemperatureInCelsius;
	
	  switch (activeCardType) {
	    case BLOOD_PRESSURE:
	      return _react2.default.createElement(_BloodPressureChart2.default, null);
	    case RESPIRATORY_RATE:
	      return _react2.default.createElement(_RespiratoryRateChart2.default, null);
	    case BODY_SURFACE_AREA:
	      return _react2.default.createElement(_BodySurfaceAreaChart2.default, null);
	    case BODY_TEMPERATURE:
	      return _react2.default.createElement(_BodyTemperatureChart2.default, { isTemperatureInCelsius: isTemperatureInCelsius });
	    default:
	      return null;
	  }
	};
	
	TimeScalableChart.propTypes = {
	  activeCardType: _propTypes2.default.string,
	  isTemperatureInCelsius: _propTypes2.default.bool
	};
	
	exports.default = TimeScalableChart;

/***/ }),
/* 3533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActivityCard = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(54);
	
	var _useActivityCardData2 = __webpack_require__(3534);
	
	var _cards = __webpack_require__(1161);
	
	var _index = __webpack_require__(2259);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityCard = exports.ActivityCard = function ActivityCard(_ref) {
	  var formatMessage = _ref.formatMessage,
	      typeCard = _ref.typeCard,
	      isActiveCard = _ref.isActiveCard,
	      detailsMode = _ref.detailsMode,
	      data = _ref.data,
	      handleOnClick = _ref.handleOnClick,
	      isWeightInKg = _ref.isWeightInKg,
	      isHeightInMeters = _ref.isHeightInMeters,
	      mainUser = _ref.mainUser,
	      targetUserFirstName = _ref.targetUserFirstName,
	      isTemperatureInCelsius = _ref.isTemperatureInCelsius,
	      isMilligramsPerDeciliter = _ref.isMilligramsPerDeciliter;
	
	  var _useActivityCardData = (0, _useActivityCardData2.useActivityCardData)({
	    formatMessage: formatMessage,
	    typeCard: typeCard,
	    data: data,
	    isActiveCard: isActiveCard,
	    detailsMode: detailsMode,
	    isWeightInKg: isWeightInKg,
	    isHeightInMeters: isHeightInMeters,
	    isTemperatureInCelsius: isTemperatureInCelsius,
	    isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	    mainUser: mainUser,
	    targetUserFirstName: targetUserFirstName
	  }),
	      cardSource = _useActivityCardData.cardSource,
	      cardMetric = _useActivityCardData.cardMetric,
	      cardValue = _useActivityCardData.cardValue,
	      cardTitle = _useActivityCardData.cardTitle,
	      cardIcon = _useActivityCardData.cardIcon,
	      timeText = _useActivityCardData.timeText;
	
	  var isHeightType = _constants.VITALS_ACTIVITY_TYPE.HEIGHT === typeCard;
	  var emptyCard = [_cards.EMPTY_VITALS_CARD].includes(typeCard);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_index2.default.card, (0, _defineProperty3.default)({}, _index2.default.nonClickable, isHeightType && !mainUser || emptyCard)),
	      onClick: function onClick() {
	        return handleOnClick();
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.wrapperBorder },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.wrapperHover },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.cardTopWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.cardIcon },
	            _react2.default.createElement(_Icon2.default, { name: cardIcon, size: 24 })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.cardTitle },
	            cardTitle
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.cardBottomWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.cardValue },
	            cardValue + ' ',
	            _react2.default.createElement(
	              'span',
	              { className: _index2.default.cardMetric },
	              cardMetric
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.cardTime },
	            '' + timeText + (cardSource ? ', ' + cardSource : '')
	          )
	        )
	      )
	    )
	  );
	};
	
	ActivityCard.propTypes = {
	  formatMessage: PropTypes.func,
	  typeCard: PropTypes.string,
	  isActiveCard: PropTypes.bool,
	  detailsMode: PropTypes.bool,
	  handleOnClick: PropTypes.func,
	  data: PropTypes.object,
	  isWeightInKg: PropTypes.bool,
	  isHeightInMeters: PropTypes.bool,
	  isTemperatureInCelsius: PropTypes.bool,
	  isMilligramsPerDeciliter: PropTypes.bool,
	  mainUser: PropTypes.bool,
	  targetUserFirstName: PropTypes.string
	};

/***/ }),
/* 3534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useActivityCardData = useActivityCardData;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dateConverters = __webpack_require__(83);
	
	var _constants = __webpack_require__(54);
	
	var _utils = __webpack_require__(78);
	
	var _cards = __webpack_require__(1161);
	
	var _hooks = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useActivityCardData(_ref) {
	  var formatMessage = _ref.formatMessage,
	      typeCard = _ref.typeCard,
	      data = _ref.data,
	      isActiveCard = _ref.isActiveCard,
	      detailsMode = _ref.detailsMode,
	      isWeightInKg = _ref.isWeightInKg,
	      isHeightInMeters = _ref.isHeightInMeters,
	      isTemperatureInCelsius = _ref.isTemperatureInCelsius,
	      mainUser = _ref.mainUser,
	      targetUserFirstName = _ref.targetUserFirstName,
	      isMilligramsPerDeciliter = _ref.isMilligramsPerDeciliter;
	
	  var _useSafeDataSourceTit = (0, _hooks.useSafeDataSourceTitle)(true),
	      getSafeDataSourceTitle = _useSafeDataSourceTit.getSafeDataSourceTitle;
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    switch (typeCard) {
	      case _constants.VITALS_ACTIVITY_TYPE.STEPS:
	        return {
	          cardIcon: 'steps-black',
	          cardTitle: formatMessage({ id: 'patient.healthboard.steps' }),
	          cardValue: data && data.value ? (0, _utils.numberWithCommas)(data.value.baseValue.toFixed()) : '-',
	          cardMetric: formatMessage({ id: 'patient.healthboard.steps.metric' }),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.DISTANCE:
	        return {
	          cardIcon: 'distance-black',
	          cardTitle: formatMessage({ id: 'patient.healthboard.distance' }),
	          cardValue: data && data.value ? (0, _utils.convertValueDistanceToMiles)(data.value.baseValue) : '-',
	          cardMetric: formatMessage({
	            id: 'patient.healthboard.distance.metric'
	          }),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.BMI:
	        return {
	          cardIcon: 'bmi-black',
	          cardTitle: formatMessage({ id: 'patient.healthboard.bmi' }),
	          cardValue: data && data.value ? data.value.baseValue.toFixed(1) : '-',
	          cardMetric: '',
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.WEIGHT:
	        return {
	          cardIcon: 'weight-black',
	          cardTitle: formatMessage({ id: 'patient.healthboard.weight' }),
	          cardValue: data && data.value ? (0, _utils.formatValueWeightWithMetric)(data.value.baseValue, isWeightInKg) : '-',
	          cardMetric: isWeightInKg ? formatMessage({
	            id: 'patient.healthboard.weight.metric.kg'
	          }) : formatMessage({
	            id: 'patient.healthboard.weight.metric'
	          }),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.HEIGHT:
	        return {
	          cardIcon: 'height-black',
	          cardTitle: formatMessage({ id: 'patient.healthboard.height' }),
	          cardValue: data && data.value ? (0, _utils.formatHeightValueWithMetric)(data.value.baseValue, isHeightInMeters) : '-',
	          cardMetric: isHeightInMeters ? formatMessage({
	            id: 'patient.healthboard.height.metric.cm'
	          }) : '',
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.SATURATION:
	        return {
	          cardIcon: 'icon-saturation-black',
	          cardTitle: _react2.default.createElement(
	            'span',
	            null,
	            formatMessage({ id: 'patient.healthboard.saturation' }),
	            _react2.default.createElement(
	              'sub',
	              null,
	              formatMessage({ id: 'patient.healthboard.saturation.index' })
	            ),
	            ')'
	          ),
	          cardValue: data && data.value ? Math.round(data.value.baseValue) : '-',
	          cardMetric: formatMessage({
	            id: 'patient.healthboard.saturation.metric'
	          }),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.HEART_RATE:
	        return {
	          cardIcon: 'icon-heart-rate-black',
	          cardTitle: formatMessage({ id: 'patient.healthboard.heart_rate' }),
	          cardValue: data && data.value ? Math.round(data.value.baseValue) : '-',
	          cardMetric: formatMessage({
	            id: 'patient.healthboard.heart_rate.metric'
	          }),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.RESPIRATORY_RATE:
	        return {
	          cardIcon: 'icon-respiratory-rate',
	          cardTitle: _react2.default.createElement(
	            'span',
	            null,
	            formatMessage({
	              id: 'patient.healthboard.respiratory_rate'
	            })
	          ),
	          cardValue: data && data.value ? '' + Math.round(data.value.baseValue) : '-',
	          cardMetric: formatMessage({
	            id: 'patient.healthboard.respiratory_rate.metric'
	          }),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.BLOOD_PRESSURE:
	        return {
	          cardIcon: 'icon-blood-pressure-black',
	          cardTitle: _react2.default.createElement(
	            'span',
	            null,
	            formatMessage({
	              id: 'patient.healthboard.blood_pressure'
	            })
	          ),
	          cardValue: data && data.value ? Math.round(data.value.bpSystolic) + '/' + Math.round(data.value.bpDiastolic) : '-',
	          cardMetric: formatMessage({
	            id: 'patient.healthboard.blood_pressure.metric'
	          }),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.BODY_SURFACE_AREA:
	        return {
	          cardIcon: 'bmi-black',
	          cardTitle: formatMessage({ id: 'patient.healthboard.bsa' }),
	          cardValue: data && data.value ? (0, _utils.roundPrecision)(data.value.baseValue, 1, true) : '-',
	          cardMetric: _react2.default.createElement(
	            'span',
	            null,
	            formatMessage({ id: 'patient.healthboard.bsa.metric' }),
	            _react2.default.createElement(
	              'sup',
	              null,
	              formatMessage({ id: 'patient.healthboard.bsa.metricIndex' })
	            )
	          ),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.BODY_TEMPERATURE:
	        return {
	          cardIcon: 'icon-body-temperature-black',
	          cardTitle: formatMessage({
	            id: 'patient.healthboard.body_temperature'
	          }),
	          cardValue: data && data.value ? (0, _utils.formatTemperatureValueWithMetric)(data.value.baseValue, isTemperatureInCelsius) : '-',
	          cardMetric: isTemperatureInCelsius ? formatMessage({
	            id: 'patient.healthboard.body_temperature.metric.celsius'
	          }) : formatMessage({
	            id: 'patient.healthboard.body_temperature.metric.fahrenheit'
	          }),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _constants.VITALS_ACTIVITY_TYPE.BLOOD_GLUCOSE:
	        return {
	          cardIcon: 'icon-blood-glucose-black',
	          cardTitle: formatMessage({
	            id: 'patient.healthboard.blood_glucose'
	          }),
	          cardValue: data && data.providerCode ? (0, _utils.formatGlucoseValueWithMetric)(data.value.baseValue, isMilligramsPerDeciliter) : '-',
	          cardMetric: isMilligramsPerDeciliter ? formatMessage({
	            id: 'patient.healthboard.blood_glucose.metric.milligrams_per_deciliter'
	          }) : formatMessage({
	            id: 'patient.healthboard.blood_glucose.metric.millimoles_per_liter'
	          }),
	          cardDate: data && data.measuredAt ? data.measuredAt : '',
	          cardSource: data && data.originalProviderCodes ? getSafeDataSourceTitle((0, _utils.getOriginalProviderCode)(data.originalProviderCodes), formatMessage, mainUser, targetUserFirstName) : ''
	        };
	      case _cards.EMPTY_VITALS_CARD:
	        return {
	          cardIcon: '',
	          cardTitle: '',
	          cardValue: '',
	          cardMetric: '',
	          cardDate: '',
	          cardSource: ''
	        };
	    }
	  }, [isActiveCard, typeCard, data, detailsMode, formatMessage, isWeightInKg, isHeightInMeters, isTemperatureInCelsius]),
	      cardIcon = _useMemo.cardIcon,
	      cardTitle = _useMemo.cardTitle,
	      cardValue = _useMemo.cardValue,
	      cardMetric = _useMemo.cardMetric,
	      cardDate = _useMemo.cardDate,
	      cardSource = _useMemo.cardSource;
	
	  var timeText = (0, _react.useMemo)(function () {
	    if (!cardDate) return '';
	    var adapted = (0, _dateConverters.adaptDateToLocalTimezone)(cardDate);
	    var time = (0, _moment2.default)(adapted);
	
	    var getFormat = function getFormat() {
	      if (time.isSame(new Date(), 'day')) {
	        return '[Today,] h:mm A';
	      }
	      if (time.isSame(new Date(), 'week')) {
	        return 'MMM D, h:mm A';
	      }
	      if (time.isSame(new Date(), 'year')) {
	        return 'MMM D, h:mm A';
	      }
	      return 'MMM D Y, h:mm A';
	    };
	
	    return time.format(getFormat());
	  }, [cardDate]);
	
	  return {
	    cardIcon: cardIcon,
	    cardTitle: cardTitle,
	    cardValue: cardValue,
	    cardMetric: cardMetric,
	    cardDate: cardDate,
	    timeText: timeText,
	    cardSource: cardSource
	  };
	}

/***/ }),
/* 3535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.VitalsActivity = VitalsActivity;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectors = __webpack_require__(23);
	
	var _historicMeasurementsReq = __webpack_require__(428);
	
	var historicMeasurements = _interopRequireWildcard(_historicMeasurementsReq);
	
	var _vitalsActivityReq = __webpack_require__(887);
	
	var vitalsActivity = _interopRequireWildcard(_vitalsActivityReq);
	
	var _selectors2 = __webpack_require__(109);
	
	var _constants = __webpack_require__(54);
	
	var _cards = __webpack_require__(1161);
	
	var _ActivityCard = __webpack_require__(3533);
	
	var _index = __webpack_require__(2259);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STEPS = _constants.VITALS_ACTIVITY_TYPE.STEPS,
	    SATURATION = _constants.VITALS_ACTIVITY_TYPE.SATURATION,
	    HEIGHT = _constants.VITALS_ACTIVITY_TYPE.HEIGHT;
	function VitalsActivity(_ref) {
	  var formatMessage = _ref.formatMessage,
	      isDetailsView = _ref.isDetailsView,
	      toggleDetailsView = _ref.toggleDetailsView,
	      contextOf = _ref.contextOf,
	      toggleOpenModal = _ref.toggleOpenModal,
	      userId = _ref.userId,
	      activeCardType = _ref.activeCardType,
	      setActiveCardType = _ref.setActiveCardType,
	      isWeightInKg = _ref.isWeightInKg,
	      isHeightInMeters = _ref.isHeightInMeters,
	      isTemperatureInCelsius = _ref.isTemperatureInCelsius,
	      isMilligramsPerDeciliter = _ref.isMilligramsPerDeciliter,
	      mainUser = _ref.mainUser,
	      hideTitle = _ref.hideTitle;
	
	  var vitalsActivityData = (0, _reactRedux.useSelector)(_selectors2.selectVitalsActivityEntity);
	  var previousDate = (0, _reactRedux.useSelector)(_selectors2.selectHistoricMeasurementsPreviousDate);
	
	  var targetUserFirstName = (0, _get2.default)((0, _reactRedux.useSelector)(_selectors.targetUserSelector), 'firstName', '');
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var isSaturationType = SATURATION === activeCardType;
	
	  var selectMeasurementEntity = function selectMeasurementEntity(type) {
	    var target = vitalsActivityData.find(function (item) {
	      return item.type === type;
	    });
	    if (target) return target.measurement || {};
	    return {};
	  };
	
	  var createApiRequestByType = function createApiRequestByType(type) {
	    if (type === HEIGHT) return;
	    dispatch(historicMeasurements.actions.clear());
	    dispatch(historicMeasurements.actions.send({
	      typeMeasurements: type,
	      periodStartDate: previousDate || (0, _moment2.default)(selectMeasurementEntity(type).measuredAt).subtract(1, 'year').format('YYYY-MM-DD'),
	      userId: userId
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    dispatch(vitalsActivity.actions.clear());
	    dispatch(vitalsActivity.actions.send({ userId: userId }));
	  }, [userId]);
	
	  var safeContext = mainUser ? formatMessage({ id: 'general.labels.me' }) : contextOf;
	
	  var safeTitle = isSaturationType ? _react2.default.createElement(
	    'span',
	    null,
	    formatMessage({ id: 'patient.healthboard.saturation' }),
	    _react2.default.createElement(
	      'sub',
	      null,
	      formatMessage({ id: 'patient.healthboard.saturation.index' })
	    ),
	    ')'
	  ) : formatMessage({ id: 'patient.healthboard.' + (activeCardType || STEPS) });
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_index2.default.root, (0, _defineProperty3.default)({}, _index2.default.rootDetails, isDetailsView)) },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        !hideTitle && safeTitle,
	        isDetailsView && _react2.default.createElement(
	          'div',
	          { className: _index2.default.contextOf },
	          formatMessage({
	            id: 'patient.healthboard.contextOf'
	          }) + ' ' + safeContext
	        )
	      )
	    ),
	    !isDetailsView && _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _cards.TYPE_CARDS.map(function (_ref2) {
	        var type = _ref2.type;
	        return _react2.default.createElement(_ActivityCard.ActivityCard, {
	          isActiveCard: activeCardType === type,
	          formatMessage: formatMessage,
	          detailsMode: isDetailsView,
	          typeCard: type,
	          mainUser: mainUser,
	          data: selectMeasurementEntity(type),
	          isWeightInKg: isWeightInKg,
	          isHeightInMeters: isHeightInMeters,
	          isTemperatureInCelsius: isTemperatureInCelsius,
	          isMilligramsPerDeciliter: isMilligramsPerDeciliter,
	          targetUserFirstName: targetUserFirstName,
	          handleOnClick: function handleOnClick() {
	            toggleDetailsView(true);
	            toggleOpenModal(true);
	            setActiveCardType(type);
	            createApiRequestByType(type);
	          },
	          key: type
	        });
	      })
	    )
	  );
	}
	
	VitalsActivity.propTypes = {
	  formatMessage: PropTypes.func,
	  isDetailsView: PropTypes.bool,
	  toggleDetailsView: PropTypes.func,
	  contextOf: PropTypes.string,
	  toggleOpenModal: PropTypes.func,
	  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  activeCardType: PropTypes.string,
	  setActiveCardType: PropTypes.func,
	  isWeightInKg: PropTypes.bool,
	  isHeightInMeters: PropTypes.bool,
	  isTemperatureInCelsius: PropTypes.bool,
	  isMilligramsPerDeciliter: PropTypes.bool,
	  mainUser: PropTypes.bool,
	  hideTitle: PropTypes.bool
	};

/***/ }),
/* 3536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _currentHealthboardOptions = __webpack_require__(1338);
	
	var _historicMeasurementsReq = __webpack_require__(428);
	
	var historicData = _interopRequireWildcard(_historicMeasurementsReq);
	
	var _drawer = __webpack_require__(185);
	
	var _context = __webpack_require__(216);
	
	var _selectors = __webpack_require__(90);
	
	var _selectors2 = __webpack_require__(109);
	
	var _selectors3 = __webpack_require__(157);
	
	var _selectors4 = __webpack_require__(23);
	
	var _index = __webpack_require__(2260);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: (0, _selectors4.loggedUserSelector)(state),
	    profileTargetUser: (0, _selectors4.targetUserSelector)(state),
	    isProvider: (0, _selectors4.hasProviderProfileSelector)(state),
	    vitalsActivityData: (0, _selectors2.selectVitalsActivityEntity)(state),
	    activeCardType: (0, _selectors2.selectCurrentHealthboardOptionsDataType)(state),
	    activeFilter: (0, _selectors2.selectCurrentHealthboardOptionsChartPeriod)(state),
	    deepLinkTab: (0, _selectors3.selectDeepLinkTab)(state),
	    deepLinkDependentId: (0, _selectors3.selectDeepLinkDependentId)(state),
	    drawerVisibility: (0, _selectors.uiDrawerSelector)(state),
	    availableCategoriesPending: (0, _selectors3.selectAvailableCategoriesPending)(state),
	    refillsHistory: (0, _selectors3.selectMedicationsRefillsHistoryList)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  setActiveCardType: _currentHealthboardOptions.currentHealthboardOptionsActions.setDataType,
	  setActiveFilter: _currentHealthboardOptions.currentHealthboardOptionsActions.setChartPeriod,
	  toggleDrawer: _drawer.actions.toggleVisibility,
	  setTargetUserId: _context.actions.setTargetUserId,
	  clearHistoricData: historicData.actions.clear
	};
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useCheckForAvailableData = useCheckForAvailableData;
	
	var _react = __webpack_require__(1);
	
	function useCheckForAvailableData(data, type) {
	  var isAvailableData = (0, _react.useMemo)(function () {
	    return function () {
	      if (type && data) {
	        var target = data.filter(function (item) {
	          return item.type === type;
	        });
	        if (target.length === 0) return false;
	        return !(target && !target[0].measurement);
	      }
	      return false;
	    };
	  }, [data, type]);
	
	  return isAvailableData();
	}

/***/ }),
/* 3538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useFeatureToggleConfig = useFeatureToggleConfig;
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(50);
	
	var _configurations = __webpack_require__(1277);
	
	var _createPayloadForFeatureToggle = __webpack_require__(4205);
	
	var _createPayloadForFeatureToggle2 = _interopRequireDefault(_createPayloadForFeatureToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useFeatureToggleConfig(_ref) {
	  var feature = _ref.feature,
	      options = _ref.options;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var getFeatureConfig = (0, _react.useCallback)(function () {
	    dispatch(_configurations.actions.send((0, _createPayloadForFeatureToggle2.default)([{
	      action: feature,
	      options: (0, _extends3.default)({}, options)
	    }])));
	  }, [feature, options]);
	
	  var clearFeatureConfig = (0, _react.useCallback)(function () {
	    dispatch(_configurations.actions.clear());
	  }, []);
	
	  var featureToggleConfigList = (0, _reactRedux.useSelector)(_selectors.selectDataConfigurationsList);
	  var featureToggleLoading = (0, _reactRedux.useSelector)(_selectors.selectDataConfigurationsLoading);
	
	  var isFeatureToggleOn = (0, _react.useMemo)(function () {
	    var featureToggle = featureToggleConfigList.find(function (entity) {
	      return !!entity[feature];
	    }) || {};
	    return featureToggle[feature];
	  }, [featureToggleConfigList, feature]);
	
	  return {
	    getFeatureConfig: getFeatureConfig,
	    isFeatureToggleOn: isFeatureToggleOn,
	    clearFeatureConfig: clearFeatureConfig,
	    featureToggleLoading: featureToggleLoading
	  };
	}

/***/ }),
/* 3539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _lowerCase = __webpack_require__(464);
	
	var _lowerCase2 = _interopRequireDefault(_lowerCase);
	
	var _upperFirst = __webpack_require__(147);
	
	var _upperFirst2 = _interopRequireDefault(_upperFirst);
	
	var _reactRedux = __webpack_require__(6);
	
	var _relationshipPriority = __webpack_require__(1873);
	
	var _strings = __webpack_require__(15);
	
	var _getListLocalization = __webpack_require__(1915);
	
	var _useSimpleForm2 = __webpack_require__(499);
	
	var _formFields = __webpack_require__(38);
	
	var _convertExistingUsersList = __webpack_require__(3555);
	
	var _props = __webpack_require__(41);
	
	var _UserInfoBlock = __webpack_require__(3756);
	
	var _UserInfoBlock2 = _interopRequireDefault(_UserInfoBlock);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _index = __webpack_require__(5068);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REASON_CODE = _formFields.PROFILE_FIELDS_TYPES.REASON_CODE,
	    RELATIONSHIP_PRIORITY = _formFields.PROFILE_FIELDS_TYPES.RELATIONSHIP_PRIORITY;
	
	var FIELDS = [REASON_CODE, RELATIONSHIP_PRIORITY];
	
	var AddExistingUser = function AddExistingUser(_ref) {
	  var users = _ref.users,
	      onAdd = _ref.onAdd,
	      isOpen = _ref.isOpen,
	      onClose = _ref.onClose,
	      pending = _ref.pending,
	      formatMessage = _ref.intl.formatMessage;
	
	  var relationship = (0, _reactRedux.useSelector)(_relationshipPriority.selectRelationshipPriority);
	
	  var adaptName = function adaptName(name) {
	    return (0, _upperFirst2.default)((0, _lowerCase2.default)(name));
	  };
	
	  var relationshipOptions = (0, _react.useMemo)(function () {
	    return relationship.map(function (item) {
	      return {
	        label: adaptName(item.name),
	        value: item.id
	      };
	    });
	  }, [relationship]);
	
	  var _useSimpleForm = (0, _useSimpleForm2.useSimpleForm)(FIELDS, FIELDS),
	      handleFormChange = _useSimpleForm.handleFormChange,
	      formState = _useSimpleForm.formState,
	      isValid = _useSimpleForm.isValid;
	
	  var _ref2 = formState || {},
	      reason = _ref2.reason,
	      relation = _ref2.relation;
	
	  var counter = (0, _size2.default)(users);
	  var localizationId = counter === 1 ? 'community.roles.member' : 'community.members';
	
	  var handleAdd = function handleAdd(id) {
	    var data = (0, _extends3.default)({}, formState, {
	      assignmentStatus: _props.ASSIGMENT_STATUS.PERMANENT,
	      ids: [id]
	    });
	    onAdd(data);
	  };
	
	  var handleClose = function handleClose() {
	    var _handleFormChange;
	
	    handleFormChange((_handleFormChange = {}, (0, _defineProperty3.default)(_handleFormChange, REASON_CODE, ''), (0, _defineProperty3.default)(_handleFormChange, RELATIONSHIP_PRIORITY, ''), _handleFormChange));
	    onClose();
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      opened: isOpen,
	      onClose: handleClose,
	      width: 'medium',
	      title: formatMessage({ id: 'addPatient.dialog.title' }),
	      strictClose: true
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        { className: _index2.default.title },
	        formatMessage({ id: 'addPatient.dialog.subtitle' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.selectWrapper },
	        _react2.default.createElement(_SelectCustom2.default, {
	          placeholder: formatMessage(_strings.NEW_CHAT.selectReasonForAssignment),
	          label: formatMessage(_strings.NEW_CHAT.reasonForAssignment),
	          options: (0, _getListLocalization.getListLocalization)(_strings.ADD_PROVIDER_REASON_CODE.permanent, formatMessage),
	          value: reason,
	          onChange: function onChange(_ref3) {
	            var value = _ref3.value;
	            return handleFormChange((0, _defineProperty3.default)({}, REASON_CODE, value));
	          },
	          needUpdateDefaultValue: true,
	          className: _index2.default.select
	        }),
	        _react2.default.createElement(_SelectCustom2.default, {
	          placeholder: formatMessage({
	            id: 'relationshipPriority.subtitle'
	          }),
	          label: formatMessage({
	            id: 'relationshipPriority.title'
	          }),
	          options: relationshipOptions,
	          value: relation,
	          onChange: function onChange(_ref4) {
	            var value = _ref4.value;
	            return handleFormChange((0, _defineProperty3.default)({}, RELATIONSHIP_PRIORITY, value));
	          },
	          needUpdateDefaultValue: true,
	          className: _index2.default.select
	        })
	      ),
	      counter && _react2.default.createElement(
	        'div',
	        { className: _index2.default.counter },
	        counter + ' ' + formatMessage({
	          id: localizationId
	        })
	      ),
	      users && users.map(function (user) {
	        var _ref5 = user || {},
	            id = _ref5.id,
	            avatar = _ref5.avatar,
	            displayableName = _ref5.displayableName,
	            dob = _ref5.dob;
	
	        return _react2.default.createElement(_UserInfoBlock2.default, {
	          key: id,
	          avatarSize: 36,
	          avatarUrl: avatar.thumbMin,
	          avatarText: displayableName,
	          textPrimary: displayableName,
	          textComplementary: dob,
	          buttonColor: 'primary',
	          list: (0, _convertExistingUsersList.convertList)(formatMessage, user),
	          buttonText: formatMessage({ id: 'common.add' }),
	          disabled: !isValid || pending,
	          onClick: function onClick() {
	            return handleAdd(id);
	          },
	          className: 'mb2'
	        });
	      })
	    )
	  );
	};
	
	AddExistingUser.propTypes = {
	  isOpen: _propTypes2.default.bool,
	  onAdd: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  users: _propTypes2.default.array,
	  pending: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(AddExistingUser);

/***/ }),
/* 3540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _handleRelationshipOptions = __webpack_require__(1831);
	
	var _handleRelationshipOptions2 = _interopRequireDefault(_handleRelationshipOptions);
	
	var _handleRolesOptions = __webpack_require__(1183);
	
	var _handleRolesOptions2 = _interopRequireDefault(_handleRolesOptions);
	
	var _formFields = __webpack_require__(38);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _constants = __webpack_require__(17);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _strings = __webpack_require__(15);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _index = __webpack_require__(958);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMAIL = _formFields.PROFILE_FIELDS_TYPES.EMAIL,
	    FIRST_NAME = _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME,
	    LAST_NAME = _formFields.PROFILE_FIELDS_TYPES.LAST_NAME,
	    PHONE_NUMBER = _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER,
	    RELATION = _formFields.PROFILE_FIELDS_TYPES.RELATION,
	    ROLE = _formFields.PROFILE_FIELDS_TYPES.ROLE,
	    CARE_ROLE = _formFields.PROFILE_FIELDS_TYPES.CARE_ROLE;
	
	
	var EmergencyContactForm = function EmergencyContactForm(_ref) {
	  var email = _ref.email,
	      _onChange2 = _ref.onChange,
	      lastName = _ref.lastName,
	      relation = _ref.relation,
	      careRole = _ref.careRole,
	      firstName = _ref.firstName,
	      phoneNumber = _ref.phoneNumber,
	      formatMessage = _ref.formatMessage,
	      validateErrors = _ref.validateErrors;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, _onChange2);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(FIRST_NAME), {
	      value: firstName,
	      required: false
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: FIRST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(LAST_NAME), {
	      value: lastName,
	      required: false
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: LAST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(ROLE), {
	      options: (0, _handleRolesOptions2.default)(formatMessage, (0, _extends3.default)({
	        EMPTY_ROLE: _constants.EMPTY_ROLE
	      }, _constants.DEPENDENT_ROLES), false),
	      value: careRole,
	      needUpdateDefaultValue: true,
	      onChange: function onChange(_ref2) {
	        var value = _ref2.value;
	        return _onChange2((0, _defineProperty3.default)({}, CARE_ROLE, value));
	      },
	      defaultValue: careRole
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: CARE_ROLE, errors: validateErrors }),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(RELATION), {
	      options: (0, _handleRelationshipOptions2.default)(careRole, formatMessage),
	      value: relation,
	      needUpdateDefaultValue: true
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: CARE_ROLE, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(EMAIL), { value: email })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: EMAIL, errors: validateErrors }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'option', className: 'mt3' },
	      formatMessage(_strings.DIALOG_TITLE.andOr)
	    ),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(PHONE_NUMBER), {
	      value: phoneNumber,
	      onChange: function onChange(value) {
	        return _onChange2((0, _defineProperty3.default)({}, PHONE_NUMBER, value));
	      }
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: PHONE_NUMBER, errors: validateErrors })
	  );
	};
	
	EmergencyContactForm.propTypes = {
	  email: _propTypes2.default.string,
	  formatMessage: _propTypes2.default.func,
	  firstName: _propTypes2.default.string,
	  phoneNumber: _propTypes2.default.string,
	  lastName: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  relation: _propTypes2.default.string,
	  careRole: _propTypes2.default.string,
	  validateErrors: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({ description: _propTypes2.default.string })])
	};
	
	exports.default = (0, _reactCssModules2.default)(EmergencyContactForm, _index2.default, {
	  allowMultiple: true
	});

/***/ }),
/* 3541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(56);
	
	var _index = __webpack_require__(958);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _addPatientByProvider = __webpack_require__(308);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapDispatchToProps = {
	  createPatient: _addPatientByProvider.actions.send,
	  clearRequest: _addPatientByProvider.actions.clear
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    personalInfo: (0, _selectors.selectSavedPatientPersonalInfo)(state),
	    patientContacts: (0, _selectors.selectSavedPatientContacts)(state),
	    patientAddress: (0, _selectors.selectSavedPatientAddress)(state),
	    isAddPatientSuccess: (0, _selectors.addPatientSuccessSelector)(state),
	    patientProfileAlreadyExists: (0, _selectors.selectPatientProfileAlreadyExists)(state),
	    emergencyContactPatientList: (0, _selectors.selectAddedPatientsList)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _useEmergencyFormState = __webpack_require__(3543);
	
	var _usePatientForm = __webpack_require__(1779);
	
	var _toSnakeCaseObjectKeys = __webpack_require__(699);
	
	var _toSnakeCaseObjectKeys2 = _interopRequireDefault(_toSnakeCaseObjectKeys);
	
	var _metadata = __webpack_require__(291);
	
	var _formFields = __webpack_require__(38);
	
	var _routes = __webpack_require__(37);
	
	var _usePageRedirect = __webpack_require__(1162);
	
	var _strings = __webpack_require__(15);
	
	var _deepTrim = __webpack_require__(357);
	
	var _deepTrim2 = _interopRequireDefault(_deepTrim);
	
	var _EmergencyContactForm = __webpack_require__(3540);
	
	var _EmergencyContactForm2 = _interopRequireDefault(_EmergencyContactForm);
	
	var _convertErrors = __webpack_require__(496);
	
	var _styles = __webpack_require__(18);
	
	var _constants = __webpack_require__(17);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3541);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PatientEmergencyContact = function PatientEmergencyContact(_ref) {
	  var clearRequest = _ref.clearRequest,
	      personalInfo = _ref.personalInfo,
	      formatMessage = _ref.formatMessage,
	      createPatient = _ref.createPatient,
	      patientAddress = _ref.patientAddress,
	      patientContacts = _ref.patientContacts,
	      clearPatientData = _ref.clearPatientData,
	      isAddPatientSuccess = _ref.isAddPatientSuccess,
	      errors = _ref.validationError,
	      pending = _ref.validationPending,
	      patientProfileAlreadyExists = _ref.patientProfileAlreadyExists,
	      emergencyContactPatientList = _ref.emergencyContactPatientList;
	
	  var _useEmergencyFormStat = (0, _useEmergencyFormState.useEmergencyFormState)((0, _defineProperty3.default)({}, _formFields.PROFILE_FIELDS_TYPES.CARE_ROLE, _constants.EMPTY_ROLE)),
	      emergencyState = _useEmergencyFormStat.emergencyState,
	      handleEmergencyFormChange = _useEmergencyFormStat.handleEmergencyFormChange,
	      clearEmergencyForm = _useEmergencyFormStat.clearEmergencyForm;
	
	  (0, _react.useEffect)(function () {
	    var success = isAddPatientSuccess && (!patientProfileAlreadyExists || patientProfileAlreadyExists && (0, _size2.default)(emergencyContactPatientList) !== 2);
	
	    if (success) {
	      clearEmergencyForm();
	      clearPatientData();
	      clearRequest();
	      _reactRouter.browserHistory.push(_routes.PATIENT_REGISTRATION);
	    }
	  }, [isAddPatientSuccess, patientProfileAlreadyExists, emergencyContactPatientList]);
	
	  (0, _usePageRedirect.usePageRedirect)(_routes.PATIENT_REGISTRATION, [patientContacts, personalInfo, patientAddress]);
	
	  var _usePatientValidation = (0, _usePatientForm.usePatientValidation)(errors),
	      validateErrors = _usePatientValidation.validateErrors,
	      clearErrors = _usePatientValidation.clearErrors;
	
	  var isEmpty = (0, _react.useMemo)(function () {
	    var careRole = emergencyState.careRole,
	        other = (0, _objectWithoutProperties3.default)(emergencyState, ['careRole']);
	
	    return careRole === _constants.EMPTY_ROLE && (0, _keys2.default)(other).every(function (key) {
	      return !emergencyState[key];
	    });
	  }, [emergencyState]);
	
	  var emergencyData = (0, _react.useMemo)(function () {
	    var careRole = emergencyState.careRole,
	        other = (0, _objectWithoutProperties3.default)(emergencyState, ['careRole']);
	
	    var hasCareRole = careRole !== _constants.EMPTY_ROLE;
	    var data = hasCareRole ? (0, _extends4.default)({
	      careRole: careRole
	    }, other) : (0, _extends4.default)({}, other);
	
	    return isEmpty ? {} : (0, _toSnakeCaseObjectKeys2.default)(data);
	  }, [emergencyState, isEmpty]);
	
	  var isValid = (0, _useEmergencyFormState.validateRequiredFields)(emergencyState);
	
	  var systemError = (0, _convertErrors.getSystemError)(errors);
	
	  var handleBack = function handleBack() {
	    _reactRouter.browserHistory.goBack();
	  };
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	
	    var patientInfoData = (0, _toSnakeCaseObjectKeys2.default)((0, _extends4.default)({}, patientContacts, personalInfo, patientAddress));
	
	    var patientData = (0, _extends4.default)({}, patientInfoData, (0, _defineProperty3.default)({}, _metadata.EMERGENCY_CONTACT_DATA_KEY, emergencyData));
	
	    createPatient((0, _deepTrim2.default)(patientData));
	  };
	
	  var handleClear = function handleClear() {
	    clearEmergencyForm();
	    clearRequest();
	    clearErrors();
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Root' },
	    _react2.default.createElement(
	      'div',
	      { className: 'g-content', styleName: 'root' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'header' },
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { minWidth: _styles.BREAKPOINT },
	          _react2.default.createElement(_BackButton2.default, { onBack: handleBack })
	        )
	      ),
	      pending ? _react2.default.createElement(_Loader2.default, { className: 'g-centeredAll' }) : null,
	      _react2.default.createElement(
	        'div',
	        { styleName: (0, _classnames2.default)('content', { disabled: pending }) },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit, styleName: 'form' },
	          _react2.default.createElement(
	            'label',
	            { styleName: 'form--label', className: 'mb3' },
	            formatMessage(_strings.DIALOG_TITLE.addPatientTitle)
	          ),
	          _react2.default.createElement(
	            'p',
	            { styleName: 'form--text', className: 'mb4' },
	            formatMessage({ id: 'dialog.titles.emergencyContactRole' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { styleName: 'form--subtitle' },
	            formatMessage({ id: 'dialog.titles.emergencyContact' })
	          ),
	          systemError && _react2.default.createElement(_ErrorBlock2.default, { errors: systemError, className: 'mt3' }),
	          _react2.default.createElement(_EmergencyContactForm2.default, (0, _extends4.default)({}, emergencyState, {
	            clearRequest: clearRequest,
	            formatMessage: formatMessage,
	            onChange: handleEmergencyFormChange,
	            validateErrors: validateErrors
	          })),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'form--btn', className: 'mt4' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'mr3',
	                type: 'submit',
	                raised: true,
	                color: 'primary',
	                disabled: pending || (isEmpty ? false : !isValid)
	              },
	              formatMessage({ id: 'common.complete' })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { raised: true, color: 'accent', onClick: handleClear, type: 'reset' },
	              formatMessage({ id: 'common.clear' })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	PatientEmergencyContact.propTypes = {
	  formatMessage: _propTypes2.default.func,
	  createPatient: _propTypes2.default.func,
	  clearPatientData: _propTypes2.default.func,
	  clearRequest: _propTypes2.default.func,
	  personalInfo: _propTypes2.default.object,
	  patientAddress: _propTypes2.default.object,
	  patientContacts: _propTypes2.default.object,
	  isAddPatientSuccess: _propTypes2.default.bool,
	  validationError: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
	  validationPending: _propTypes2.default.bool,
	  patientProfileAlreadyExists: _propTypes2.default.bool,
	  emergencyContactPatientList: _propTypes2.default.array
	};
	
	exports.default = (0, _enhance.enhance)(PatientEmergencyContact);

/***/ }),
/* 3543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialFormState;
	
	exports.useEmergencyFormState = useEmergencyFormState;
	exports.validateRequiredFields = validateRequiredFields;
	
	var _react = __webpack_require__(1);
	
	var _mapValues = __webpack_require__(1559);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialFormState = (_initialFormState = {}, (0, _defineProperty3.default)(_initialFormState, _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, ''), (0, _defineProperty3.default)(_initialFormState, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, ''), (0, _defineProperty3.default)(_initialFormState, _formFields.PROFILE_FIELDS_TYPES.RELATION, ''), (0, _defineProperty3.default)(_initialFormState, _formFields.PROFILE_FIELDS_TYPES.CARE_ROLE, ''), (0, _defineProperty3.default)(_initialFormState, _formFields.PROFILE_FIELDS_TYPES.EMAIL, ''), (0, _defineProperty3.default)(_initialFormState, _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER, ''), _initialFormState);
	
	function useEmergencyFormState() {
	  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialFormState;
	
	  var _useState = (0, _react.useState)(initialState),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      emergencyState = _useState2[0],
	      setEmergencyContact = _useState2[1];
	
	  function handleEmergencyFormChange(value) {
	    setEmergencyContact((0, _extends3.default)({}, emergencyState, value));
	  }
	
	  function clearEmergencyForm() {
	    setEmergencyContact((0, _mapValues2.default)(emergencyState, function () {
	      return '';
	    }));
	  }
	
	  return { emergencyState: emergencyState, handleEmergencyFormChange: handleEmergencyFormChange, clearEmergencyForm: clearEmergencyForm };
	}
	
	var requiredFields = [_formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, _formFields.PROFILE_FIELDS_TYPES.RELATION, _formFields.PROFILE_FIELDS_TYPES.CARE_ROLE];
	
	function validateRequiredFields(patientData) {
	  return requiredFields.every(function (type) {
	    return Boolean(patientData[type]);
	  }) && Boolean(patientData[_formFields.PROFILE_FIELDS_TYPES.EMAIL] || patientData[_formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER]);
	}

/***/ }),
/* 3544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _formFields = __webpack_require__(38);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _useLoggedUserCountry = __webpack_require__(1104);
	
	var _utils = __webpack_require__(233);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COUNTRY = _formFields.PROFILE_FIELDS_TYPES.COUNTRY,
	    POSTAL_CODE = _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE,
	    STATE = _formFields.PROFILE_FIELDS_TYPES.STATE,
	    CITY = _formFields.PROFILE_FIELDS_TYPES.CITY,
	    ADDRESS_1 = _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1,
	    ADDRESS_2 = _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2;
	
	
	var PatientAddressForm = function PatientAddressForm(_ref) {
	  var city = _ref.city,
	      state = _ref.state,
	      country = _ref.country,
	      _onChange3 = _ref.onChange,
	      address1 = _ref.address1,
	      address2 = _ref.address2,
	      countries = _ref.countries,
	      statesList = _ref.statesList,
	      postalCode = _ref.postalCode,
	      validateErrors = _ref.validateErrors,
	      formatMessage = _ref.formatMessage,
	      zipLimit = _ref.zipLimit,
	      onCountryChange = _ref.onCountryChange,
	      isZipApplicable = _ref.isZipApplicable,
	      zipExamples = _ref.zipExamples,
	      loadCountryDetails = _ref.loadCountryDetails;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, _onChange3);
	  var targetCountryEntity = (0, _useLoggedUserCountry.useLoggedUserCountry)();
	
	  var handleCountryChange = (0, _react.useMemo)(function () {
	    return function (data) {
	      if (!data) return;
	      if (country === data || country === data.label) {
	        onCountryChange(data);
	        return;
	      }
	      onCountryChange(data);
	    };
	  }, [country, targetCountryEntity, city, address1, address2]);
	
	  var safeCountry = (0, _utils.adaptInitialValueCountry)(country, countries);
	  var safeState = (0, _utils.adaptInitialValueState)(state, statesList);
	
	  var upperCasedPostalCode = postalCode ? postalCode.toUpperCase() : postalCode;
	
	  (0, _react.useEffect)(function () {
	    if (!country && targetCountryEntity) loadCountryDetails(targetCountryEntity.value);
	    _onChange3((0, _defineProperty3.default)({}, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, targetCountryEntity));
	    if (country) {
	      var _onChange2;
	
	      var countryEntity = (0, _utils.adaptInitialValueCountry)(country.label || country, countries);
	      loadCountryDetails(countryEntity.value);
	      _onChange3((_onChange2 = {}, (0, _defineProperty3.default)(_onChange2, _formFields.PROFILE_FIELDS_TYPES.STATE, safeState), (0, _defineProperty3.default)(_onChange2, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, safeCountry), _onChange2));
	    }
	  }, [targetCountryEntity, country, safeState]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(COUNTRY, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      options: countries,
	      value: safeCountry || targetCountryEntity,
	      needUpdateDefaultValue: true,
	      onChange: function onChange(val) {
	        return handleCountryChange(val);
	      }
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: COUNTRY, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(POSTAL_CODE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      limit: zipLimit,
	      disabled: !isZipApplicable,
	      value: upperCasedPostalCode
	    })),
	    (0, _get2.default)(validateErrors, POSTAL_CODE) ? _react2.default.createElement(_ErrorBlock2.default, {
	      errors: [formatMessage({ id: 'errors.validation.profile.postalCode.format' }, { example: zipExamples })],
	      className: 'mt3 w-100'
	    }) : null,
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(STATE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      onChange: function onChange(data) {
	        return _onChange3({ state: data });
	      },
	      value: safeState,
	      options: statesList,
	      needUpdateDefaultValue: true
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: STATE, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(CITY, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      value: city
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: CITY, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(ADDRESS_1), { value: address1 })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: ADDRESS_1, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(ADDRESS_2), { value: address2 })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: ADDRESS_2, errors: validateErrors })
	  );
	};
	
	PatientAddressForm.propTypes = {
	  validateErrors: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({ description: PropTypes.string })]),
	  formatMessage: PropTypes.func,
	  onChange: PropTypes.func,
	  address1: PropTypes.string,
	  address2: PropTypes.string,
	  city: PropTypes.string,
	  country: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	  state: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	  postalCode: PropTypes.string,
	  countries: PropTypes.array,
	  statesList: PropTypes.array,
	  zipLimit: PropTypes.number,
	  onCountryChange: PropTypes.func,
	  isZipApplicable: PropTypes.bool,
	  zipExamples: PropTypes.string,
	  loadCountryDetails: PropTypes.func
	};
	
	exports.default = PatientAddressForm;

/***/ }),
/* 3545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(50);
	
	var _selectors2 = __webpack_require__(56);
	
	var _selectors3 = __webpack_require__(23);
	
	var _index = __webpack_require__(958);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    personalInfo: (0, _selectors2.selectSavedPatientPersonalInfo)(state),
	    patientContacts: (0, _selectors2.selectSavedPatientContacts)(state),
	    patientAddress: (0, _selectors2.selectSavedPatientAddress)(state),
	    loggedUser: (0, _selectors3.loggedUserSelector)(state),
	    countries: (0, _selectors.selectCountryOptions)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, null), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(42);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _usePatientAddressForm = __webpack_require__(3547);
	
	var _strings = __webpack_require__(15);
	
	var _routes = __webpack_require__(37);
	
	var _props = __webpack_require__(41);
	
	var _usePageRedirect = __webpack_require__(1162);
	
	var _convertErrors = __webpack_require__(496);
	
	var _styles = __webpack_require__(18);
	
	var _PatientAddressForm = __webpack_require__(3544);
	
	var _PatientAddressForm2 = _interopRequireDefault(_PatientAddressForm);
	
	var _checkErrors = __webpack_require__(1780);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3545);
	
	var _useCountrySelect2 = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PatientRegistrationAddress = function PatientRegistrationAddress(_ref) {
	  var validateData = _ref.validateData,
	      formatMessage = _ref.formatMessage,
	      countries = _ref.countries,
	      personalInfo = _ref.personalInfo,
	      patientAddress = _ref.patientAddress,
	      patientContacts = _ref.patientContacts,
	      savePatientData = _ref.savePatientData,
	      validationError = _ref.validationError,
	      clearValidationData = _ref.clearValidationData,
	      validationPending = _ref.validationPending,
	      clearPatientDataByKey = _ref.clearPatientDataByKey;
	
	  var _useCountrySelect = (0, _useCountrySelect2.useCountrySelect)(formatMessage),
	      loadCountryDetails = _useCountrySelect.loadCountryDetails,
	      stateList = _useCountrySelect.stateList,
	      zipLimit = _useCountrySelect.zipLimit,
	      isZipApplicable = _useCountrySelect.isZipApplicable,
	      zipExamples = _useCountrySelect.zipExamples;
	
	  var _usePatientAddressFor = (0, _usePatientAddressForm.usePatientAddressFormState)((0, _extends3.default)({}, patientAddress), validationError, isZipApplicable),
	      handleFormChange = _usePatientAddressFor.handleFormChange,
	      validateErrors = _usePatientAddressFor.validateErrors,
	      setCountryValue = _usePatientAddressFor.setCountryValue,
	      clearErrors = _usePatientAddressFor.clearErrors,
	      formState = _usePatientAddressFor.formState,
	      isValid = _usePatientAddressFor.isValid,
	      clearPatientForm = _usePatientAddressFor.clearPatientForm;
	
	  var fullCountryName = (0, _get2.default)(formState, 'country.label', '');
	  var fullStateName = (0, _get2.default)(formState, 'state.label', '');
	
	  (0, _react.useEffect)(function () {
	    if (validationError && !(0, _checkErrors.checkErrors)(validationError, _usePatientAddressForm.PATIENT_ADDRESS_FIELDS)) {
	      savePatientData((0, _defineProperty3.default)({}, _props.ADD_PATIENT_STEPS.ADDRESS, (0, _extends3.default)({}, formState, {
	        country: fullCountryName,
	        state: fullStateName
	      })));
	      _reactRouter.browserHistory.push(_routes.PATIENT_REGISTRATION + '/' + _routes.EMERGENCY_CONTACT);
	    }
	
	    return function () {
	      return clearValidationData();
	    };
	  }, [validationError]);
	
	  (0, _usePageRedirect.usePageRedirect)(_routes.PATIENT_REGISTRATION, [patientContacts, personalInfo]);
	
	  var systemError = (0, _convertErrors.getSystemError)(validationError);
	
	  var handleBack = function handleBack() {
	    _reactRouter.browserHistory.goBack();
	  };
	
	  var onCountryChange = function onCountryChange(data) {
	    clearErrors();
	    loadCountryDetails(data.value);
	    setCountryValue(data);
	  };
	
	  var handleClear = function handleClear() {
	    clearPatientForm();
	    clearValidationData();
	    clearPatientDataByKey({ key: _props.ADD_PATIENT_STEPS.ADDRESS });
	  };
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    clearErrors();
	    validateData((0, _extends3.default)({}, formState, {
	      country: fullCountryName,
	      state: fullStateName
	    }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Root' },
	    _react2.default.createElement(
	      'div',
	      { className: 'g-content', styleName: 'root' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'header' },
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { minWidth: _styles.BREAKPOINT },
	          _react2.default.createElement(_BackButton2.default, { onBack: handleBack })
	        )
	      ),
	      validationPending ? _react2.default.createElement(_Loader2.default, { className: 'g-centeredAll' }) : null,
	      _react2.default.createElement(
	        'div',
	        { styleName: (0, _classnames2.default)('content', { disabled: validationPending }) },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit, styleName: 'form' },
	          _react2.default.createElement(
	            'label',
	            { styleName: 'form--label', className: 'mb4' },
	            formatMessage(_strings.DIALOG_TITLE.addPatientTitle)
	          ),
	          _react2.default.createElement(
	            'span',
	            { styleName: 'form--subtitle' },
	            formatMessage({ id: 'profile.section.address' })
	          ),
	          systemError && _react2.default.createElement(_ErrorBlock2.default, { errors: systemError, className: 'mt3' }),
	          _react2.default.createElement(_PatientAddressForm2.default, (0, _extends3.default)({}, formState, {
	            formatMessage: formatMessage,
	            validateErrors: validateErrors,
	            onChange: handleFormChange,
	            countries: countries,
	            statesList: stateList,
	            zipLimit: zipLimit,
	            isZipApplicable: isZipApplicable,
	            zipExamples: zipExamples,
	            onCountryChange: onCountryChange,
	            loadCountryDetails: loadCountryDetails
	          })),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'form--btn', className: 'mt4' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'mr3',
	                type: 'submit',
	                raised: true,
	                color: 'primary',
	                disabled: !isValid
	              },
	              formatMessage({ id: 'common.next' })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { raised: true, color: 'accent', onClick: handleClear, type: 'reset' },
	              formatMessage({ id: 'common.clear' })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	PatientRegistrationAddress.propTypes = {
	  formatMessage: _propTypes2.default.func,
	  validationPending: _propTypes2.default.bool,
	  validationError: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
	  loggedUser: _propTypes2.default.object,
	  countries: _propTypes2.default.array,
	  statesList: _propTypes2.default.array,
	  patientContacts: _propTypes2.default.object,
	  patientAddress: _propTypes2.default.object,
	  personalInfo: _propTypes2.default.object,
	  savePatientData: _propTypes2.default.func,
	  validateData: _propTypes2.default.func,
	  clearValidationData: _propTypes2.default.func,
	  clearPatientDataByKey: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(PatientRegistrationAddress);

/***/ }),
/* 3547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PATIENT_ADDRESS_FIELDS = exports.validateRequiredFields = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _addressForm;
	
	exports.usePatientAddressFormState = usePatientAddressFormState;
	exports.usePatientValidation = usePatientValidation;
	
	var _react = __webpack_require__(1);
	
	var _formFields = __webpack_require__(38);
	
	var _convertErrors = __webpack_require__(496);
	
	var _convertErrors2 = _interopRequireDefault(_convertErrors);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addressForm = (_addressForm = {}, (0, _defineProperty3.default)(_addressForm, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1, ''), (0, _defineProperty3.default)(_addressForm, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2, ''), (0, _defineProperty3.default)(_addressForm, _formFields.PROFILE_FIELDS_TYPES.CITY, ''), (0, _defineProperty3.default)(_addressForm, _formFields.PROFILE_FIELDS_TYPES.STATE, ''), (0, _defineProperty3.default)(_addressForm, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, ''), (0, _defineProperty3.default)(_addressForm, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, ''), _addressForm);
	
	var validateRequiredFields = exports.validateRequiredFields = function validateRequiredFields() {
	  var isZipApplicable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  return (0, _useFormWithValidation.makeRequiredFieldsValidator)([_formFields.PROFILE_FIELDS_TYPES.CITY, _formFields.PROFILE_FIELDS_TYPES.STATE].concat((0, _toConsumableArray3.default)(isZipApplicable && [_formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE])));
	};
	
	function usePatientAddressFormState(data, errors, isZipApplicable) {
	  var _useFormState = (0, _useFormWithValidation.useFormState)((0, _extends5.default)({}, addressForm, data)),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var _useFormValidation = (0, _useFormWithValidation.useFormValidation)(errors),
	      validateErrors = _useFormValidation.validateErrors,
	      clearErrors = _useFormValidation.clearErrors,
	      addLocalValidateErrors = _useFormValidation.addLocalValidateErrors;
	
	  var isValid = validateRequiredFields(isZipApplicable)(formState);
	
	  var setCountryValue = function setCountryValue(value) {
	    var _extends2;
	
	    return handleFormChange((0, _extends5.default)({}, formState, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, value), (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.STATE, ''), (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, ''), _extends2)));
	  };
	
	  var clearPatientForm = function clearPatientForm() {
	    var _extends3;
	
	    return handleFormChange((0, _extends5.default)({}, formState, (_extends3 = {}, (0, _defineProperty3.default)(_extends3, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1, ''), (0, _defineProperty3.default)(_extends3, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2, ''), (0, _defineProperty3.default)(_extends3, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, ''), (0, _defineProperty3.default)(_extends3, _formFields.PROFILE_FIELDS_TYPES.CITY, ''), _extends3)));
	  };
	
	  return (0, _react.useMemo)(function () {
	    return {
	      formState: formState,
	      handleFormChange: handleFormChange,
	      validateErrors: validateErrors,
	      addLocalValidateErrors: addLocalValidateErrors,
	      setCountryValue: setCountryValue,
	      clearErrors: clearErrors,
	      isValid: isValid,
	      clearPatientForm: clearPatientForm
	    };
	  }, [formState, handleFormChange, validateErrors, addLocalValidateErrors, setCountryValue, clearErrors, isValid, clearPatientForm]);
	}
	
	function usePatientValidation(dataValidationErrors) {
	  var _useState = (0, _react.useState)({}),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      validateErrors = _useState2[0],
	      setValidateErrors = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    if (dataValidationErrors) {
	      setValidateErrors((0, _convertErrors2.default)(dataValidationErrors));
	    }
	  }, [dataValidationErrors]);
	
	  function clearErrors() {
	    setValidateErrors({});
	  }
	
	  return { validateErrors: validateErrors, clearErrors: clearErrors };
	}
	
	var requiredFields = [_formFields.PROFILE_FIELDS_TYPES.CITY, _formFields.PROFILE_FIELDS_TYPES.STATE, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, _formFields.PROFILE_FIELDS_TYPES.COUNTRY];
	
	var PATIENT_ADDRESS_FIELDS = exports.PATIENT_ADDRESS_FIELDS = [].concat(requiredFields, [_formFields.PROFILE_FIELDS_TYPES.ADDRESS_1, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2]);

/***/ }),
/* 3548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reqAssignPatient = __webpack_require__(638);
	
	var reqAssignPatient = _interopRequireWildcard(_reqAssignPatient);
	
	var _addPatientByProvider = __webpack_require__(308);
	
	var addPatient = _interopRequireWildcard(_addPatientByProvider);
	
	var _selectors = __webpack_require__(50);
	
	var _selectors2 = __webpack_require__(56);
	
	var _relatedUsers = __webpack_require__(641);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    pendingAssignPatient: (0, _relatedUsers.selectReqAssignPatientPending)(state),
	    succeedAssignPatient: (0, _relatedUsers.selectReqAssignPatientSucceed)(state),
	    patientContacts: (0, _selectors2.selectSavedPatientContacts)(state),
	    existingUsers: (0, _selectors2.selectAddedPatientsList)(state),
	    pending: (0, _selectors2.addPatientSendingSelector)(state),
	    errors: (0, _selectors2.addPatientErrorSelector)(state),
	    phoneNumberCountryIsoCode: (0, _selectors2.selectCurrentCountryCode)(state),
	    countryPhoneSettings: (0, _selectors.selectCountryPhoneSettings)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  checkUserContact: addPatient.actions.send,
	  assignPatient: reqAssignPatient.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _reqRelationshipPriority = __webpack_require__(814);
	
	var _useSimpleForm2 = __webpack_require__(499);
	
	var _routes = __webpack_require__(37);
	
	var _metadata = __webpack_require__(291);
	
	var _formFields = __webpack_require__(38);
	
	var _props = __webpack_require__(41);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _strings = __webpack_require__(15);
	
	var _MobilePhone = __webpack_require__(776);
	
	var _AddExistingUser = __webpack_require__(3539);
	
	var _AddExistingUser2 = _interopRequireDefault(_AddExistingUser);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _enhance = __webpack_require__(3548);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMAIL = _formFields.PROFILE_FIELDS_TYPES.EMAIL,
	    PHONE_NUMBER = _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER;
	
	
	var PatientRegistrationContact = function PatientRegistrationContact(_ref) {
	  var errors = _ref.errors,
	      pending = _ref.pending,
	      patientContacts = _ref.patientContacts,
	      formatMessage = _ref.formatMessage,
	      existingUsers = _ref.existingUsers,
	      assignPatient = _ref.assignPatient,
	      savePatientData = _ref.savePatientData,
	      checkUserContact = _ref.checkUserContact,
	      pendingAssignPatient = _ref.pendingAssignPatient,
	      succeedAssignPatient = _ref.succeedAssignPatient,
	      phoneNumberCountryIsoCode = _ref.phoneNumberCountryIsoCode,
	      countryPhoneSettings = _ref.countryPhoneSettings;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSimpleForm = (0, _useSimpleForm2.useSimpleForm)([EMAIL, PHONE_NUMBER], [], errors, patientContacts || {}),
	      handleFormChange = _useSimpleForm.handleFormChange,
	      validateErrors = _useSimpleForm.validateErrors,
	      formState = _useSimpleForm.formState,
	      clearErrors = _useSimpleForm.clearErrors;
	
	  (0, _react.useEffect)(function () {
	    if (errors) clearErrors();
	  }, [formState]);
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(false),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      opened = _useToggleFlag2[0],
	      openPopup = _useToggleFlag2[1],
	      closePopup = _useToggleFlag2[2];
	
	  (0, _react.useEffect)(function () {
	    if ((0, _size2.default)(existingUsers) > 0) {
	      dispatch(_reqRelationshipPriority.actions.send());
	      openPopup();
	    }
	  }, [existingUsers]);
	
	  (0, _react.useEffect)(function () {
	    if (succeedAssignPatient) {
	      closePopup();
	      clearForm();
	    }
	  }, [succeedAssignPatient]);
	
	  var clearForm = function clearForm() {
	    var _handleFormChange;
	
	    if (errors) clearErrors();
	    handleFormChange((_handleFormChange = {}, (0, _defineProperty3.default)(_handleFormChange, EMAIL, ''), (0, _defineProperty3.default)(_handleFormChange, PHONE_NUMBER, ''), _handleFormChange));
	  };
	
	  var handlePhoneChange = function handlePhoneChange(phone) {
	    handleFormChange((0, _defineProperty3.default)({}, PHONE_NUMBER, phone));
	  };
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, handleFormChange);
	  var email = formState.email,
	      phoneNumber = formState.phoneNumber;
	
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	
	    var isFullPhoneNumber = phoneNumber ? !countryPhoneSettings.map(function (_ref2) {
	      var countryCode = _ref2.countryCode;
	      return countryCode;
	    }).includes(phoneNumber) : false;
	
	    var hasLogin = email || isFullPhoneNumber;
	
	    if (hasLogin) {
	      checkUserContact((0, _extends4.default)({}, formState, phoneNumber ? { phoneNumberCountryIsoCode: phoneNumberCountryIsoCode } : null, (0, _defineProperty3.default)({}, _metadata.EMERGENCY_CONTACT_DATA_KEY, {})));
	    } else {
	      var _ADD_PATIENT_STEPS$CO;
	
	      savePatientData((0, _defineProperty3.default)({}, _props.ADD_PATIENT_STEPS.CONTACTS, (_ADD_PATIENT_STEPS$CO = {}, (0, _defineProperty3.default)(_ADD_PATIENT_STEPS$CO, EMAIL, null), (0, _defineProperty3.default)(_ADD_PATIENT_STEPS$CO, PHONE_NUMBER, null), _ADD_PATIENT_STEPS$CO)));
	      _browserHistory2.default.push(_routes.PATIENT_REGISTRATION + '/' + _routes.PERSONAL_INFO);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'section', className: 'relative' },
	    pending ? _react2.default.createElement(_Loader2.default, { className: 'g-centeredAll' }) : null,
	    _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('content', { disabled: pending }) },
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'label',
	          { styleName: 'form--label' },
	          formatMessage({ id: 'profile.section.contacts' })
	        ),
	        _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_TextInput2.default, (0, _extends4.default)({}, makeProfileField(EMAIL, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	            value: email
	          })),
	          _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: EMAIL, errors: validateErrors }),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'and-or', className: 'mt3' },
	            formatMessage(_strings.DIALOG_TITLE.andOr)
	          ),
	          _react2.default.createElement(_MobilePhone.MobilePhone, (0, _extends4.default)({}, makeProfileField(PHONE_NUMBER, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	            value: phoneNumber,
	            formatMessage: formatMessage,
	            onChange: handlePhoneChange
	          })),
	          _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: PHONE_NUMBER, errors: validateErrors })
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'btn-block' },
	          _react2.default.createElement(
	            _Button2.default,
	            { type: 'submit', raised: true, color: 'primary', disabled: pending },
	            formatMessage({ id: 'common.next' })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'ml3',
	              raised: true,
	              color: 'accent',
	              type: 'button',
	              onClick: clearForm
	            },
	            formatMessage({ id: 'common.clear' })
	          )
	        ),
	        _react2.default.createElement(_AddExistingUser2.default, {
	          isOpen: opened,
	          onClose: function onClose() {
	            return closePopup();
	          },
	          users: existingUsers,
	          onAdd: assignPatient,
	          pending: pendingAssignPatient
	        })
	      )
	    )
	  );
	};
	
	PatientRegistrationContact.propTypes = {
	  errors: PropTypes.object,
	  pending: PropTypes.bool,
	  formatMessage: PropTypes.func,
	  existingUsers: PropTypes.array,
	  checkUserContact: PropTypes.func,
	  assignPatient: PropTypes.func,
	  savePatientData: PropTypes.func,
	  pendingAssignPatient: PropTypes.bool,
	  succeedAssignPatient: PropTypes.bool,
	  patientContacts: PropTypes.object,
	  phoneNumberCountryIsoCode: PropTypes.string,
	  countryPhoneSettings: PropTypes.array
	};
	
	exports.default = (0, _enhance.enhance)(PatientRegistrationContact);

/***/ }),
/* 3550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _formFields = __webpack_require__(38);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _PasswordInput = __webpack_require__(335);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _DateDropdown = __webpack_require__(498);
	
	var _DateDropdown2 = _interopRequireDefault(_DateDropdown);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _SSNField = __webpack_require__(1171);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _selectors = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LAST_NAME = _formFields.PROFILE_FIELDS_TYPES.LAST_NAME,
	    FIRST_NAME = _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME,
	    DOB = _formFields.PROFILE_FIELDS_TYPES.DOB,
	    SSN = _formFields.PROFILE_FIELDS_TYPES.SSN,
	    LOCAL_UID = _formFields.PROFILE_FIELDS_TYPES.LOCAL_UID,
	    NAME_SUFFIX = _formFields.PROFILE_FIELDS_TYPES.NAME_SUFFIX;
	
	
	var PatientInfoForm = function PatientInfoForm(_ref) {
	  var nameSuffixList = _ref.nameSuffixList,
	      nameSuffix = _ref.nameSuffix,
	      validateErrors = _ref.validateErrors,
	      formatMessage = _ref.formatMessage,
	      firstName = _ref.firstName,
	      lastName = _ref.lastName,
	      onChange = _ref.onChange,
	      mrn = _ref.mrn,
	      dob = _ref.dob,
	      ssn = _ref.ssn;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, onChange);
	
	  var ssnHidingEnabled = (0, _reactRedux.useSelector)(_selectors.selectSsnHidingEnabled);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(FIRST_NAME), { value: firstName })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: FIRST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(LAST_NAME), { value: lastName })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: LAST_NAME, errors: validateErrors }),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(NAME_SUFFIX), {
	      options: nameSuffixList,
	      value: nameSuffix,
	      needUpdateDefaultValue: true
	    })),
	    _react2.default.createElement(_DateDropdown2.default, (0, _extends3.default)({}, makeProfileField(DOB), { value: dob })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(LOCAL_UID, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      value: mrn
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: LOCAL_UID, errors: validateErrors }),
	    !ssnHidingEnabled && _react2.default.createElement(_SSNField.SSNField, {
	      formatMessage: formatMessage,
	      noMarginBottom: true,
	      children: _react2.default.createElement(_PasswordInput2.default, (0, _extends3.default)({}, makeProfileField(SSN, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	        value: ssn
	      }))
	    }),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: SSN, errors: validateErrors })
	  );
	};
	
	PatientInfoForm.propTypes = {
	  validateErrors: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({ description: _propTypes2.default.string })]),
	  nameSuffixList: _propTypes2.default.array,
	  nameSuffix: _propTypes2.default.string,
	  ssn: _propTypes2.default.string,
	  formatMessage: _propTypes2.default.func,
	  firstName: _propTypes2.default.string,
	  lastName: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  mrn: _propTypes2.default.string,
	  dob: _propTypes2.default.string
	};
	
	exports.default = PatientInfoForm;

/***/ }),
/* 3551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(50);
	
	var _selectors2 = __webpack_require__(56);
	
	var _index = __webpack_require__(958);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    patientContacts: (0, _selectors2.selectSavedPatientContacts)(state),
	    personalInfo: (0, _selectors2.selectSavedPatientPersonalInfo)(state),
	    nameSuffixList: (0, _selectors.selectNameSuffixesList)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, null), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(42);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _strings = __webpack_require__(15);
	
	var _routes = __webpack_require__(37);
	
	var _props = __webpack_require__(41);
	
	var _usePageRedirect = __webpack_require__(1162);
	
	var _convertErrors = __webpack_require__(496);
	
	var _styles = __webpack_require__(18);
	
	var _checkErrors = __webpack_require__(1780);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _PatientInfoForm = __webpack_require__(3550);
	
	var _PatientInfoForm2 = _interopRequireDefault(_PatientInfoForm);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _usePatientForm = __webpack_require__(1779);
	
	var _enhance = __webpack_require__(3551);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PatientRegistrationInfo = function PatientRegistrationInfo(_ref) {
	  var validateData = _ref.validateData,
	      personalInfo = _ref.personalInfo,
	      formatMessage = _ref.formatMessage,
	      savePatientData = _ref.savePatientData,
	      nameSuffixList = _ref.nameSuffixList,
	      patientContacts = _ref.patientContacts,
	      validationError = _ref.validationError,
	      validationPending = _ref.validationPending,
	      clearValidationData = _ref.clearValidationData,
	      clearPatientDataByKey = _ref.clearPatientDataByKey;
	
	  var _usePatientFormState = (0, _usePatientForm.usePatientFormState)((0, _extends3.default)({}, personalInfo)),
	      patientState = _usePatientFormState.patientState,
	      handlePatientFormChange = _usePatientFormState.handlePatientFormChange,
	      clearPatientForm = _usePatientFormState.clearPatientForm;
	
	  var _usePatientValidation = (0, _usePatientForm.usePatientValidation)(validationError),
	      validateErrors = _usePatientValidation.validateErrors;
	
	  (0, _usePageRedirect.usePageRedirect)(_routes.PATIENT_REGISTRATION, [patientContacts]);
	
	  var systemError = (0, _convertErrors.getSystemError)(validationError);
	  var isValid = (0, _usePatientForm.validateRequiredFields)(patientState);
	
	  (0, _react.useEffect)(function () {
	    if (validationError && !(0, _checkErrors.checkErrors)(validationError, _usePatientForm.PATIENT_INFO_FIELDS)) {
	      savePatientData((0, _defineProperty3.default)({}, _props.ADD_PATIENT_STEPS.PERSONAL_INFO, patientState));
	      _reactRouter.browserHistory.push(_routes.PATIENT_REGISTRATION + '/' + _routes.ADDRESS);
	    }
	    return function () {
	      return clearValidationData();
	    };
	  }, [validationError]);
	
	  var handleBack = function handleBack() {
	    _reactRouter.browserHistory.goBack();
	  };
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    validateData(patientState);
	  };
	
	  var handleClear = function handleClear() {
	    clearPatientForm();
	    clearValidationData();
	    clearPatientDataByKey({ key: _props.ADD_PATIENT_STEPS.PERSONAL_INFO });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Root' },
	    _react2.default.createElement(
	      'div',
	      { className: 'g-content', styleName: 'root' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'header' },
	        _react2.default.createElement(
	          _reactResponsive2.default,
	          { minWidth: _styles.BREAKPOINT },
	          _react2.default.createElement(_BackButton2.default, { onBack: handleBack })
	        )
	      ),
	      validationPending ? _react2.default.createElement(_Loader2.default, { className: 'g-centeredAll' }) : null,
	      _react2.default.createElement(
	        'div',
	        { styleName: (0, _classnames2.default)('content', { disabled: validationPending }) },
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit, styleName: 'form' },
	          _react2.default.createElement(
	            'label',
	            { styleName: 'form--label', className: 'mb4' },
	            formatMessage(_strings.DIALOG_TITLE.addPatientTitle)
	          ),
	          _react2.default.createElement(
	            'span',
	            { styleName: 'form--subtitle' },
	            formatMessage({ id: 'profile.section.personal' })
	          ),
	          systemError && _react2.default.createElement(_ErrorBlock2.default, { errors: systemError, className: 'mt3' }),
	          _react2.default.createElement(_PatientInfoForm2.default, (0, _extends3.default)({}, patientState, {
	            nameSuffixList: nameSuffixList,
	            formatMessage: formatMessage,
	            validateErrors: validateErrors,
	            onChange: handlePatientFormChange
	          })),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'form--btn', className: 'mt4' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'mr3',
	                type: 'submit',
	                raised: true,
	                color: 'primary',
	                disabled: !isValid
	              },
	              formatMessage({ id: 'common.next' })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { raised: true, color: 'accent', onClick: handleClear, type: 'reset' },
	              formatMessage({ id: 'common.clear' })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	PatientRegistrationInfo.propTypes = {
	  validateData: _propTypes2.default.func,
	  clearValidationData: _propTypes2.default.func,
	  nameSuffixList: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  validationPending: _propTypes2.default.bool,
	  validationError: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
	  patientContacts: _propTypes2.default.object,
	  savePatientData: _propTypes2.default.func,
	  personalInfo: _propTypes2.default.object,
	  clearPatientDataByKey: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(PatientRegistrationInfo);

/***/ }),
/* 3553 */,
/* 3554 */,
/* 3555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertList = convertList;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _strings = __webpack_require__(15);
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMAIL = _formFields.PROFILE_FIELDS_TYPES.EMAIL,
	    PHONE_NUMBER = _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER,
	    ADDRESS_1 = _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1,
	    CITY = _formFields.PROFILE_FIELDS_TYPES.CITY,
	    STATE = _formFields.PROFILE_FIELDS_TYPES.STATE;
	function convertList(formatMessage, user) {
	  var getFieldParam = function getFieldParam(field) {
	    return (0, _get2.default)(user, field) || '-';
	  };
	
	  return [[{
	    title: formatMessage(_strings.PROFILE_FIELDS.fieldNames.email),
	    subtitle: getFieldParam(EMAIL)
	  }, {
	    title: formatMessage(_strings.PROFILE_FIELDS.fieldNames.phones),
	    subtitle: getFieldParam(PHONE_NUMBER)
	  }], [{
	    title: formatMessage(_strings.PROFILE_FIELDS.fieldNames.address1),
	    subtitle: getFieldParam(ADDRESS_1)
	  }, {
	    title: formatMessage(_strings.PROFILE_FIELDS.fieldNames.city),
	    subtitle: getFieldParam(CITY)
	  }], [{
	    title: formatMessage(_strings.PROFILE_FIELDS.fieldNames.state),
	    subtitle: getFieldParam(STATE)
	  }]];
	}

/***/ }),
/* 3556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _trim = __webpack_require__(988);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _sanitizeHtml = __webpack_require__(313);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _strings = __webpack_require__(15);
	
	var _styles = __webpack_require__(18);
	
	var _ids = __webpack_require__(46);
	
	var _index = __webpack_require__(5069);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var COMMENT_LIMIT_SIZE = 500;
	
	var AddComment = (_dec = (0, _reactCssModules2.default)(_index2.default), _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
	  (0, _inherits3.default)(AddComment, _Component);
	
	  function AddComment() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AddComment);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddComment.__proto__ || (0, _getPrototypeOf2.default)(AddComment)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      content: ''
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AddComment, [{
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var content = this.state.content;
	      var onSubmit = this.props.onSubmit;
	
	      // eslint-disable-next-line no-unused-expressions
	
	      onSubmit && onSubmit((0, _sanitizeHtml2.default)(content, true, []));
	      this.setState({ content: '' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var value = this.state.content;
	
	      var disabled = typeof value === 'string' && !(0, _trim2.default)(value).length;
	
	      var label = _react2.default.createElement(
	        'span',
	        {
	          style: {
	            opacity: '.8',
	            color: _styles.COLORS.bluePrimary
	          }
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.POST_COMMENTS_ADD)
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'root' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_TextInput2.default, {
	            autoresize: true,
	            textarea: true,
	            rows: '4',
	            id: _ids.IDS.POST.POST_TEXT_AREA,
	            className: 'fw5',
	            color: 'primary',
	            label: label,
	            limit: COMMENT_LIMIT_SIZE,
	            style: {
	              lineHeight: '21px',
	              height: 'auto',
	              maxHeight: 21 * 10,
	              backgroundColor: 'white',
	              border: '1px solid ' + _styles.COLORS.sanMarino
	            },
	            value: value,
	            onChange: function onChange(content) {
	              return _this2.setState({ content: content });
	            },
	            rounded: true,
	            useNumberHeight: true
	          })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            id: _ids.IDS.POST.POST_COMMENT,
	            className: 'mt3',
	            color: 'primary',
	            raised: true,
	            type: 'button',
	            onClick: this.handleSubmit,
	            disabled: disabled
	          },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.ACTIONS.post.createComment)
	        )
	      );
	    }
	  }]);
	  return AddComment;
	}(_react.Component), _class3.propTypes = {
	  onSubmit: _propTypes2.default.func.isRequired
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleSubmit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleSubmit'), _class2.prototype)), _class2)) || _class);
	exports.default = AddComment;

/***/ }),
/* 3557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _strings = __webpack_require__(15);
	
	var _SectionTitle = __webpack_require__(1100);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _Comment = __webpack_require__(1727);
	
	var _Comment2 = _interopRequireDefault(_Comment);
	
	var _index = __webpack_require__(2261);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var Comments = function Comments(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      list = _ref.list,
	      total = _ref.total,
	      _onReply = _ref.onReply,
	      getCommentDeleteHandler = _ref.getCommentDeleteHandler,
	      getCommentEditHandler = _ref.getCommentEditHandler,
	      onRequestConversation = _ref.onRequestConversation,
	      loggedUserId = _ref.loggedUserId,
	      canComment = _ref.canComment;
	
	  var commentsCount = total || 0;
	  var title = formatMessage(_strings.POST_COMMENTS) + ' (' + commentsCount + ')';
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'comments' },
	    _react2.default.createElement(_SectionTitle2.default, { text: title }),
	    _react2.default.createElement(
	      'ul',
	      { styleName: 'comments__list' },
	      list.map(function (comment, i) {
	        return _react2.default.createElement(
	          'li',
	          { key: i, className: 'mt1' },
	          _react2.default.createElement(_Comment2.default, (0, _extends3.default)({}, comment, {
	            getCommentDeleteHandler: getCommentDeleteHandler,
	            getCommentEditHandler: getCommentEditHandler,
	            onReply: function onReply(content) {
	              return _onReply({ content: content, parentId: comment.id });
	            },
	            onRequestConversation: onRequestConversation,
	            loggedUserId: loggedUserId,
	            canComment: canComment
	          }))
	        );
	      })
	    )
	  );
	};
	
	Comments.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  list: _propTypes2.default.array, // todo
	  onReply: _propTypes2.default.func,
	  total: _propTypes2.default.number,
	  getCommentDeleteHandler: _propTypes2.default.func,
	  getCommentEditHandler: _propTypes2.default.func,
	  onRequestConversation: _propTypes2.default.func,
	  loggedUserId: _propTypes2.default.number,
	  canComment: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(Comments, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _dec2, _class, _class2, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _postDetails = __webpack_require__(238);
	
	var _postComment = __webpack_require__(1264);
	
	var _deleteComment = __webpack_require__(1877);
	
	var _editComment = __webpack_require__(1878);
	
	var _commentsListFetch = __webpack_require__(1257);
	
	var _commentsList = __webpack_require__(299);
	
	var _selectors = __webpack_require__(23);
	
	var _deletePost = __webpack_require__(826);
	
	var _editPost = __webpack_require__(827);
	
	var _currentCommunity = __webpack_require__(824);
	
	var _currentCommunityInfo = __webpack_require__(344);
	
	var _currentCommunity2 = __webpack_require__(301);
	
	var _reqSocialChannel = __webpack_require__(295);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _PostPreview = __webpack_require__(1785);
	
	var _PostPreview2 = _interopRequireDefault(_PostPreview);
	
	var _Comments = __webpack_require__(3557);
	
	var _Comments2 = _interopRequireDefault(_Comments);
	
	var _AddComment = __webpack_require__(3556);
	
	var _AddComment2 = _interopRequireDefault(_AddComment);
	
	var _routes = __webpack_require__(37);
	
	var _chat = __webpack_require__(67);
	
	var _constants = __webpack_require__(17);
	
	var _infiniteScroll = __webpack_require__(697);
	
	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _index = __webpack_require__(2261);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    postDetails: state.communities.postDetails,
	    postsList: state.communities.postsList,
	    commentsListRequest: state.communities.commentsList,
	    currentUserId: (0, _selectors.loggedUserIdSelector)(state),
	    isModerator: (0, _currentCommunity2.isCurrentCommunityModeratorSelector)(state),
	    deletePostRequest: state.communities.deletePost,
	    commentsList: state.communities.commentsList,
	    currentCommunityInfo: (0, _currentCommunity2.currentCommunityInfoSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  getPostDetails: _postDetails.actions.send,
	  getComments: _commentsListFetch.actions.getComments,
	  getOlderComments: _commentsListFetch.actions.getOlderComments,
	  postComment: _postComment.actions.send,
	  deleteComment: _deleteComment.actions.send,
	  deletePost: _deletePost.actions.send,
	  editPost: _editPost.actions.send,
	  setCurrentCommunity: _currentCommunity.actions.set,
	  clearComments: _commentsList.actions.clear,
	  editComment: _editComment.actions.send,
	  createSocialChat: _reqSocialChannel.actions.send,
	  currentCommunityInfoRequest: _currentCommunityInfo.actions.send
	};
	
	var Post = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec2 = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
	  (0, _inherits3.default)(Post, _Component);
	
	  function Post() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Post);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Post.__proto__ || (0, _getPrototypeOf2.default)(Post)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      state: null
	    }, _this.postRef = null, _this.infiniteScroll = null, _this.getDetails = function (props) {
	      var posts = props.postsList;
	      var _props$routeParams = props.routeParams,
	          communityId = _props$routeParams.communityId,
	          postId = _props$routeParams.postId;
	
	      // prerender with existed post data
	
	      var post = posts && posts.find(function (item) {
	        return item.id === +postId;
	      });
	      _this.setState({ post: post });
	
	      // fetch details
	      var getPostDetails = props.getPostDetails;
	
	      getPostDetails({
	        communityId: communityId,
	        postId: postId
	      });
	    }, _this.postDetailsReceivedOrChanged = function (nextProps) {
	      var curDetails = _this.props.postDetails;
	      var nextDetails = nextProps.postDetails;
	
	
	      return curDetails.sending && !nextDetails.sending && nextDetails.succeed || curDetails !== nextDetails;
	    }, _this.handleScrollPosition = function () {
	      var postElem = _this.postRef;
	
	      var wrapperElem = (0, _get2.default)(postElem, 'offsetParent');
	      var wrapperItems = wrapperElem && wrapperElem.children;
	      var scrolledElem = wrapperItems && wrapperItems.length && wrapperItems[wrapperItems.length - 1];
	
	      if (scrolledElem) {
	        scrolledElem.scrollTop = 0;
	      }
	    }, _this.fetchComments = function () {
	      var _this$props = _this.props,
	          getComments = _this$props.getComments,
	          postId = _this$props.routeParams.postId;
	
	
	      getComments({ postId: postId });
	    }, _this.postComment = function (comment) {
	      var postComment = _this.props.postComment;
	
	      postComment((0, _extends3.default)({
	        postId: (0, _get2.default)(_this.state, 'post.id')
	      }, comment));
	    }, _this.handleDeletePost = function () {
	      var _this$props2 = _this.props,
	          routeParams = _this$props2.routeParams,
	          deletePost = _this$props2.deletePost;
	      var communityId = routeParams.communityId,
	          id = routeParams.postId;
	
	
	      deletePost({
	        communityId: communityId,
	        id: id
	      });
	    }, _this.canDelete = function (post) {
	      var _this$props3 = _this.props,
	          currentUserId = _this$props3.currentUserId,
	          isModerator = _this$props3.isModerator;
	
	
	      return isModerator || post.author.user.id === currentUserId;
	    }, _this.handleEditPost = function (data) {
	      var editPost = _this.props.editPost;
	
	      editPost(data);
	    }, _this.canEdit = function (post) {
	      var currentUserId = _this.props.currentUserId;
	
	      return post.author.user.id === currentUserId;
	    }, _this.initInfiniteScroll = function () {
	      var ref = (0, _mobileHelpers.isDesktop)() ? 0 : 1;
	      var element = (0, _get2.default)(_this.postRef, 'offsetParent.children[' + ref + ']');
	
	      _this.infiniteScroll = new _infiniteScroll2.default({
	        element: element,
	        loadEdgeOffset: _chat.INFINITE_SCROLL_LOAD_EDGE_OFFSET,
	        loaderHeight: _chat.INFINITE_SCROLL_LOADER_HEIGHT,
	        type: 'lower',
	        onLoad: _this.loadMore
	      });
	    }, _this.loadMore = function () {
	      var post = _this.state.post;
	      var totalComments = post.totalComments;
	      var _this$props4 = _this.props,
	          commentsList = _this$props4.commentsList,
	          postId = _this$props4.routeParams.postId,
	          getOlderComments = _this$props4.getOlderComments;
	
	
	      var hasMore = totalComments > commentsList.length;
	
	      if (hasMore) getOlderComments({ postId: postId });
	    }, _this.unsubscribeInfiniteScroll = function () {
	      if (_this.infiniteScroll) _this.infiniteScroll.unsubscribe();
	    }, _this.getCommentDeleteHandler = function (comment) {
	      var _this$props5 = _this.props,
	          currentUserId = _this$props5.currentUserId,
	          isModerator = _this$props5.isModerator,
	          deleteComment = _this$props5.deleteComment,
	          postDetails = _this$props5.postDetails;
	
	      var canDelete = (0, _get2.default)(comment, 'author.user.id') === currentUserId || isModerator;
	
	      return canDelete ? function () {
	        return deleteComment({
	          postId: postDetails.id,
	          id: comment.id,
	          parentId: comment.parentId
	        });
	      } : null;
	    }, _this.getCommentEditHandler = function (comment) {
	      var _this$props6 = _this.props,
	          currentUserId = _this$props6.currentUserId,
	          editComment = _this$props6.editComment,
	          postDetails = _this$props6.postDetails;
	
	      var canEdit = (0, _get2.default)(comment, 'author.user.id') === currentUserId;
	
	      return canEdit ? function (content) {
	        return editComment({
	          postId: postDetails.id,
	          id: comment.id,
	          parentId: comment.parentId,
	          content: content
	        });
	      } : null;
	    }, _this.handleRequestErrors = function (nextProps) {
	      var _nextProps$postDetail = nextProps.postDetails,
	          sending = _nextProps$postDetail.sending,
	          error = _nextProps$postDetail.error;
	      var postDetails = _this.props.postDetails;
	
	
	      if (postDetails.sending && !sending && error) {
	        var status = error.status;
	
	
	        if (status === 404) {
	          return _browserHistory2.default.push(_routes.NOT_FOUND);
	        }
	      }
	    }, _this.handleStartConversation = function (authorId) {
	      var createSocialChat = _this.props.createSocialChat;
	
	      createSocialChat({ participants: [authorId] });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Post, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          currentCommunityInfoRequest = _props.currentCommunityInfoRequest,
	          setCurrentCommunity = _props.setCurrentCommunity,
	          routeParams = _props.routeParams;
	      var communityId = routeParams.communityId;
	
	      currentCommunityInfoRequest({ id: communityId });
	      this.getDetails(this.props);
	      this.fetchComments();
	      setCurrentCommunity(+routeParams.communityId);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleScrollPosition();
	      this.initInfiniteScroll();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var deletePostRequest = this.props.deletePostRequest;
	
	      if (this.postDetailsReceivedOrChanged(nextProps) && nextProps.postDetails.id) {
	        // while response has invalid key
	        this.setState({ post: nextProps.postDetails });
	      }
	
	      if (deletePostRequest.sending && !nextProps.deletePostRequest.sending && nextProps.deletePostRequest.succeed) {
	        _browserHistory2.default.push('/' + _routes.COMMUNITIES + '/' + nextProps.routeParams.communityId);
	      }
	
	      this.handleRequestErrors(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var clearComments = this.props.clearComments;
	
	      this.unsubscribeInfiniteScroll();
	      clearComments();
	    }
	
	    // comment menu section
	
	  }, {
	    key: 'render',
	
	
	    // end
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          commentsListRequest = _props2.commentsListRequest,
	          commentsList = _props2.commentsList,
	          currentUserId = _props2.currentUserId,
	          currentCommunityInfo = _props2.currentCommunityInfo,
	          isModerator = _props2.isModerator,
	          routeParams = _props2.routeParams;
	      var communityId = routeParams.communityId;
	      var commentsLoading = commentsListRequest.sending;
	      var post = this.state.post;
	
	
	      var hasComments = commentsList && commentsList.length > 0;
	      var accessLevel = (0, _get2.default)(currentCommunityInfo, 'accessLevel');
	      var currentUserRole = (0, _get2.default)(currentCommunityInfo, 'currentUserRole');
	      var canComment = isModerator || accessLevel !== _constants.COMMUNITIES_ACCESS_LEVELS.READ_ONLY;
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(node) {
	            return _this2.postRef = node;
	          } },
	        !post ? _react2.default.createElement(_Loader2.default, null) : [_react2.default.createElement(_PostPreview2.default, (0, _extends3.default)({}, post, {
	          communityId: communityId,
	          onDelete: this.canDelete(post) ? function () {
	            return _this2.handleDeletePost(post.id);
	          } : null,
	          onEdit: this.canEdit(post) ? this.handleEditPost : null,
	          currentUserRole: currentUserRole,
	          key: '0'
	        })), commentsLoading ? _react2.default.createElement(_Loader2.default, {
	          key: '1'
	        }) : null, currentUserRole && canComment ? _react2.default.createElement(_AddComment2.default, { onSubmit: function onSubmit(content) {
	            return _this2.postComment({ content: content });
	          }, key: '2'
	        }) : null, hasComments ? _react2.default.createElement(_Comments2.default, {
	          total: post.totalComments,
	          list: commentsList,
	          onReply: function onReply(comment) {
	            return _this2.postComment(comment);
	          },
	          getCommentDeleteHandler: this.getCommentDeleteHandler,
	          getCommentEditHandler: this.getCommentEditHandler,
	          onRequestConversation: this.handleStartConversation,
	          loggedUserId: currentUserId,
	          canComment: canComment,
	          key: '3'
	        }) : null]
	      );
	    }
	  }]);
	  return Post;
	}(_react.Component), _class2.propTypes = {
	  routeParams: _propTypes2.default.shape({
	    communityId: _propTypes2.default.string,
	    postId: _propTypes2.default.string
	  }).isRequired,
	  postDetails: _propTypes2.default.shape({
	    sending: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool,
	    error: _propTypes2.default.object,
	    comments: _propTypes2.default.array,
	    id: _propTypes2.default.number
	  }).isRequired,
	  commentsListRequest: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.shape({
	    sending: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool,
	    posts: _propTypes2.default.array
	  })]).isRequired,
	  getPostDetails: _propTypes2.default.func.isRequired,
	  getComments: _propTypes2.default.func.isRequired,
	  getOlderComments: _propTypes2.default.func.isRequired,
	  postComment: _propTypes2.default.func.isRequired,
	  deleteComment: _propTypes2.default.func.isRequired,
	  deletePostRequest: _propTypes2.default.shape({
	    sending: _propTypes2.default.bool,
	    succeed: _propTypes2.default.bool
	  }).isRequired,
	  currentUserId: _propTypes2.default.number.isRequired,
	  deletePost: _propTypes2.default.func.isRequired,
	  editPost: _propTypes2.default.func.isRequired,
	  setCurrentCommunity: _propTypes2.default.func.isRequired,
	  isModerator: _propTypes2.default.bool,
	  commentsList: _propTypes2.default.array,
	  clearComments: _propTypes2.default.func.isRequired,
	  editComment: _propTypes2.default.func.isRequired,
	  createSocialChat: _propTypes2.default.func.isRequired,
	  currentCommunityInfoRequest: _propTypes2.default.func.isRequired,
	  currentCommunityInfo: _propTypes2.default.object.isRequired
	}, _class2.defaultProps = {
	  isModerator: false,
	  commentsList: []
	}, _temp2)) || _class) || _class);
	/* eslint-enable no-unused-expressions */
	
	exports.default = Post;

/***/ }),
/* 3559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _strings = __webpack_require__(15);
	
	var _ids = __webpack_require__(46);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Stats = __webpack_require__(3560);
	
	var _Stats2 = _interopRequireDefault(_Stats);
	
	var _index = __webpack_require__(564);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable */
	var Footer = function Footer(_ref) {
	  var totalComments = _ref.totalComments,
	      totalLikes = _ref.totalLikes,
	      redirect = _ref.redirect,
	      liked = _ref.liked,
	      likeAction = _ref.likeAction,
	      canComment = _ref.canComment,
	      currentUserRole = _ref.currentUserRole,
	      isLoggedIn = _ref.isLoggedIn;
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'footer' },
	    _react2.default.createElement(_Stats2.default, (0, _extends3.default)({ totalComments: totalComments, totalLikes: totalLikes, liked: liked }, {
	      commentAction: redirect || null,
	      likeAction: likeAction,
	      hasActions: !!(isLoggedIn && currentUserRole)
	    })),
	    redirect && canComment && currentUserRole ? _react2.default.createElement(
	      _Button2.default,
	      {
	        id: _ids.IDS.POST.ADD_COMMENT,
	        color: 'accent',
	        raised: true,
	        type: 'button',
	        onClick: redirect,
	        className: !(0, _mobileHelpers.isDesktop)() ? 'w-100' : ''
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.POST_COMMENTS_ADD)
	    ) : null
	  );
	};
	
	Footer.propTypes = {
	  totalComments: _propTypes2.default.number,
	  totalLikes: _propTypes2.default.number,
	  redirect: _propTypes2.default.func,
	  likeAction: _propTypes2.default.func,
	  liked: _propTypes2.default.bool,
	  canComment: _propTypes2.default.bool,
	  currentUserRole: _propTypes2.default.string,
	  isLoggedIn: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(Footer, _index2.default, { allowMultiple: true });

/***/ }),
/* 3560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Like = __webpack_require__(3863);
	
	var _Like2 = _interopRequireDefault(_Like);
	
	var _ids = __webpack_require__(46);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(564);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var Stats = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
	  (0, _inherits3.default)(Stats, _Component);
	
	  function Stats() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Stats);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Stats.__proto__ || (0, _getPrototypeOf2.default)(Stats)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: _this.props.liked,
	      likesCount: _this.props.totalLikes || 0
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Stats, [{
	    key: 'handleAddLike',
	    value: function handleAddLike() {
	      var likeAction = this.props.likeAction;
	      var _state = this.state,
	          active = _state.active,
	          likesCount = _state.likesCount;
	
	
	      this.setState({
	        active: !active,
	        likesCount: active ? likesCount - 1 : likesCount + 1
	      });
	
	      likeAction();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          active = _state2.active,
	          likesCount = _state2.likesCount;
	      var _props = this.props,
	          totalComments = _props.totalComments,
	          commentAction = _props.commentAction,
	          liked = _props.liked,
	          likeAction = _props.likeAction,
	          totalLikes = _props.totalLikes,
	          formatMessage = _props.intl.formatMessage,
	          hasActions = _props.hasActions;
	
	
	      var fill = _styles.COLORS.grayDark;
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'footer__stats' },
	        _react2.default.createElement(
	          'button',
	          {
	            onClick: commentAction,
	            id: _ids.IDS.POST.COMMENT_ICON,
	            styleName: 'footer__stats__action',
	            disabled: !hasActions
	          },
	          _react2.default.createElement(_Icon2.default, { name: 'comment', size: 16, style: { fill: fill } }),
	          _react2.default.createElement(
	            'span',
	            { styleName: 'footer__stats__text' },
	            formatMessage(_strings.COMMON.comments),
	            ' (',
	            totalComments,
	            ')'
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            styleName: 'footer__stats__action',
	            id: _ids.IDS.POST.LIKE_ICON,
	            onClick: likeAction,
	            disabled: !hasActions
	          },
	          _react2.default.createElement(_Like2.default, { active: liked }),
	          _react2.default.createElement(
	            'span',
	            { styleName: 'footer__stats__text' },
	            formatMessage(_strings.COMMON.likes),
	            ' (',
	            totalLikes,
	            ')',
	            ' '
	          )
	        )
	      );
	    }
	  }]);
	  return Stats;
	}(_react.Component), _class3.propTypes = {
	  totalComments: _propTypes2.default.number,
	  totalLikes: _propTypes2.default.number,
	  liked: _propTypes2.default.bool,
	  commentAction: _propTypes2.default.func,
	  likeAction: _propTypes2.default.func,
	  hasActions: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleAddLike', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleAddLike'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = Stats;

/***/ }),
/* 3561 */,
/* 3562 */,
/* 3563 */,
/* 3564 */,
/* 3565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _recompose = __webpack_require__(22);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(56);
	
	var _editEmail = __webpack_require__(1323);
	
	var _editMobilePhone = __webpack_require__(1324);
	
	var _confirmMobilePhone = __webpack_require__(678);
	
	var _editPatientByProvider = __webpack_require__(423);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    confirmMobilePhoneRequest: state.profiles.confirmMobilePhone,
	    editMobilePhoneRequest: state.profiles.editMobilePhone,
	    editEmailRequest: state.profiles.editEmail,
	    canEdit: (0, _selectors.isLoggedUserSelector)(state) || (0, _selectors.selectIsVerifiedDependentRole)(state),
	    canEditPatient: (0, _selectors.canEditNotJoinedPatient)(state),
	    profile: (0, _selectors.targetUserSelector)(state),
	    currentCountryCode: (0, _selectors2.selectCurrentCountryCode)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  updateEmail: _editEmail.actions.send,
	  updateMobilePhone: _editMobilePhone.actions.send,
	  confirmMobilePhone: _confirmMobilePhone.actions.send,
	  clearMobilePhoneConfirmation: _confirmMobilePhone.actions.clear,
	  clearEmailRequest: _editEmail.actions.clear,
	  clearPhoneRequest: _editMobilePhone.actions.clear,
	  savePatientByProvider: _editPatientByProvider.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default));

/***/ }),
/* 3566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _selectors = __webpack_require__(23);
	
	var _index = __webpack_require__(5072);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteAccount = function DeleteAccount(_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(_selectors.supportInfoSelector),
	      email = _useSelector.email,
	      phoneNumber = _useSelector.phoneNumber;
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.deleteAccount, onClick: function onClick() {
	          return setOpen(true);
	        } },
	      formatMessage({ id: 'profile.section.deleteAccount.title' })
	    ),
	    open && _react2.default.createElement(
	      _Popup2.default,
	      {
	        opened: open,
	        onClose: function onClose() {
	          return setOpen(false);
	        },
	        withHeading: false,
	        mobileFullScreen: false
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.modalWrapper },
	        _react2.default.createElement(
	          'h1',
	          { className: _index2.default.modalTitle },
	          formatMessage({ id: 'profile.section.deleteAccount.title' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.description },
	          formatMessage({
	            id: 'profile.section.deleteAccount.description'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.field },
	          _react2.default.createElement(
	            'p',
	            { className: _index2.default.title },
	            formatMessage({
	              id: 'fields.phoneNumber'
	            })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _index2.default.content },
	            phoneNumber
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.field },
	          _react2.default.createElement(
	            'p',
	            { className: _index2.default.title },
	            formatMessage({
	              id: 'fields.email'
	            })
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: _index2.default.content },
	            email
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'primary', onClick: function onClick() {
	              return setOpen(false);
	            } },
	          formatMessage({ id: 'common.ok' })
	        )
	      )
	    )
	  );
	};
	
	DeleteAccount.propTypes = {
	  intl: _propTypes2.default.object
	};
	
	exports.default = (0, _reactIntl.injectIntl)(DeleteAccount);

/***/ }),
/* 3567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Account = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Device = __webpack_require__(3569);
	
	var _strings = __webpack_require__(15);
	
	var _styles = __webpack_require__(18);
	
	var _utils = __webpack_require__(78);
	
	var _constants = __webpack_require__(54);
	
	var _index = __webpack_require__(5073);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Account = exports.Account = function Account(_ref) {
	  var _ref$account = _ref.account,
	      provider = _ref$account.provider,
	      id = _ref$account.id,
	      requestFailed = _ref$account.requestFailed,
	      providerEmail = _ref$account.providerEmail,
	      syncedAt = _ref$account.syncedAt,
	      userName = _ref$account.userName,
	      connectedDevices = _ref.connectedDevices,
	      setShowRemoveConfirmation = _ref.setShowRemoveConfirmation,
	      setCurrentAccount = _ref.setCurrentAccount,
	      noPermissionToAccount = _ref.noPermissionToAccount;
	
	  var handleRemoveAccount = function handleRemoveAccount() {
	    setCurrentAccount(id);
	    setShowRemoveConfirmation(true);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.headerWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.nameAccount },
	        _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _strings.PROFILE.deviceSetup.detailsAccount, {
	          values: { name: provider.name }
	        }))
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: _index2.default.removeAccount,
	          onClick: function onClick() {
	            return handleRemoveAccount();
	          }
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE.deviceSetup.removeAccount)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      connectedDevices.length === 0 && (noPermissionToAccount || requestFailed) && _react2.default.createElement(
	        'div',
	        { className: _index2.default.noPermission },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.iconNoPermission },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'exclamation-mark-hover',
	            size: 16,
	            style: { fill: _styles.COLORS.orangePink }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.noPermissionDescription },
	          requestFailed ? _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _strings.PROFILE.deviceSetup.error, {
	            values: { type: provider.name }
	          })) : _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _strings.PROFILE.deviceSetup.noPermission, {
	            values: { type: provider.name }
	          })),
	          _react2.default.createElement(
	            'span',
	            { className: _index2.default.noPermissionAnnotation },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE.deviceSetup.noPermissionAnnotation)
	          )
	        )
	      ),
	      connectedDevices.length === 0 && !noPermissionToAccount && !requestFailed && (providerEmail || userName ? _react2.default.createElement(
	        'div',
	        { className: _index2.default.googleFitWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.email },
	          providerEmail || userName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.syncedDate },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE.deviceSetup.synced),
	          (0, _utils.formatToCalendarTime)(syncedAt, false, _constants.DEVICE_CALENDAR_FORMATS)
	        )
	      ) : _react2.default.createElement(
	        'span',
	        { className: _index2.default.noDevices },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE.deviceSetup.noDevices)
	      )),
	      connectedDevices.length !== 0 && connectedDevices.filter(function (device) {
	        return device.providerCode === provider.code;
	      }).map(function (device, index) {
	        if (index >= 1 && (providerEmail || userName)) return;
	        return _react2.default.createElement(_Device.Device, {
	          device: device,
	          key: device.externalId,
	          providerEmail: providerEmail || userName
	        });
	      })
	    )
	  );
	};
	
	Account.propTypes = {
	  account: _propTypes2.default.object,
	  connectedDevices: _propTypes2.default.array,
	  setShowRemoveConfirmation: _propTypes2.default.func,
	  setCurrentAccount: _propTypes2.default.func,
	  noPermissionToAccount: _propTypes2.default.bool
	};

/***/ }),
/* 3568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppleHealth = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _strings = __webpack_require__(15);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5074);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppleHealth = exports.AppleHealth = function AppleHealth() {
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.header },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE.deviceSetup.appleHealth)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.iconInfo },
	        _react2.default.createElement(_Icon2.default, { name: 'icon-info', size: 16 })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE.deviceSetup.appleHealthDescription)
	      )
	    )
	  );
	};
	
	AppleHealth.propTypes = {
	  formatMessage: _propTypes2.default.func
	};

/***/ }),
/* 3569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Device = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(54);
	
	var _utils = __webpack_require__(78);
	
	var _index = __webpack_require__(5075);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Device = exports.Device = function Device(_ref) {
	  var device = _ref.device,
	      providerEmail = _ref.providerEmail;
	  var name = device.name,
	      syncedAt = device.syncedAt,
	      provider = device.provider;
	
	  var title = providerEmail || provider.name + ' ' + name;
	
	  var titleStyles = (0, _react.useMemo)(function () {
	    return (0, _classnames2.default)(_index2.default.title, (0, _defineProperty3.default)({}, _index2.default.capitalize, !providerEmail));
	  }, [providerEmail]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: titleStyles },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.syncedDate },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE.deviceSetup.synced),
	      (0, _utils.formatToCalendarTime)(syncedAt, false, _constants.DEVICE_CALENDAR_FORMATS)
	    )
	  );
	};
	
	Device.propTypes = {
	  device: _propTypes2.default.object,
	  providerEmail: _propTypes2.default.string
	};

/***/ }),
/* 3570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl);

/***/ }),
/* 3571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _providerAuthentications = __webpack_require__(685);
	
	var providerAuthentications = _interopRequireWildcard(_providerAuthentications);
	
	var _connectedDevices = __webpack_require__(883);
	
	var connectedDevices = _interopRequireWildcard(_connectedDevices);
	
	var _removeAccount = __webpack_require__(885);
	
	var removeAccount = _interopRequireWildcard(_removeAccount);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _selectors = __webpack_require__(109);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(54);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _AppleHealth = __webpack_require__(3568);
	
	var _Account = __webpack_require__(3567);
	
	var _enhance = __webpack_require__(3570);
	
	var _index = __webpack_require__(5076);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSetup = function DeviceSetup(_ref) {
	  var intl = _ref.intl;
	  var formatMessage = intl.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      showRemoveConfirmation = _useState2[0],
	      setShowRemoveConfirmation = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      currentAccount = _useState4[0],
	      setCurrentAccount = _useState4[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    dispatch(providerAuthentications.actions.send());
	    dispatch(connectedDevices.actions.send());
	  }, []);
	
	  var handleAddAccount = function handleAddAccount() {
	    (0, _redirectUtils.redirectToAddAccount)();
	  };
	
	  var listOfAddedAccount = (0, _reactRedux.useSelector)(_selectors.selectProviderAuthentications);
	  var listOfAddedDevices = (0, _reactRedux.useSelector)(_selectors.selectConnectedDevices);
	  var noPermissionToAccount = (0, _reactRedux.useSelector)(_selectors.selectConnectedDevicesError);
	
	  return _react2.default.createElement(
	    'section',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'h3',
	      { className: _index2.default.sectionTitle },
	      formatMessage((0, _extends3.default)({}, _strings.PROFILE.deviceSetup.title))
	    ),
	    _react2.default.createElement(_AppleHealth.AppleHealth, null),
	    listOfAddedAccount.length === 0 && _react2.default.createElement(
	      'div',
	      { className: _index2.default.noAccount },
	      formatMessage((0, _extends3.default)({}, _strings.PROFILE.deviceSetup.noAccount)),
	      _react2.default.createElement(
	        'span',
	        { className: _index2.default.noAccountDescription },
	        formatMessage((0, _extends3.default)({}, _strings.PROFILE.deviceSetup.addAccountDescription))
	      )
	    ),
	    listOfAddedAccount.length !== 0 && listOfAddedAccount.map(function (account) {
	      return _react2.default.createElement(_Account.Account, {
	        setCurrentAccount: setCurrentAccount,
	        setShowRemoveConfirmation: setShowRemoveConfirmation,
	        account: account,
	        key: account.id,
	        connectedDevices: listOfAddedDevices,
	        noPermissionToAccount: noPermissionToAccount
	      });
	    }),
	    listOfAddedAccount.length !== _constants.MAX_ADDED_ACCOUNT && _react2.default.createElement(
	      _Button2.default,
	      {
	        color: 'accent',
	        type: 'button',
	        onClick: handleAddAccount,
	        className: _index2.default.addDeviceBtn
	      },
	      formatMessage((0, _extends3.default)({}, _strings.PROFILE.deviceSetup.addDeviceAccount))
	    ),
	    showRemoveConfirmation && _react2.default.createElement(_ActionConfirmation2.default, {
	      intl: intl,
	      onSubmit: function onSubmit() {
	        return dispatch(removeAccount.actions.send({ id: currentAccount }));
	      },
	      onClose: function onClose() {
	        return setShowRemoveConfirmation(false);
	      },
	      opened: showRemoveConfirmation,
	      withHeading: false,
	      actionButtonText: formatMessage({
	        id: 'common.remove'
	      }),
	      content: _react2.default.createElement(
	        'div',
	        { className: _index2.default.removeConfirmationTitle },
	        formatMessage({
	          id: 'profile.section.deviceSetup.removeConfirmation'
	        })
	      )
	    })
	  );
	};
	
	DeviceSetup.propTypes = {
	  intl: _propTypes2.default.object
	};
	
	exports.default = (0, _enhance.enhance)(DeviceSetup);

/***/ }),
/* 3572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CLOSE_BUTTON_WIDTH = 168;
	
	var EmailConfirmation = function EmailConfirmation(_ref) {
	  var email = _ref.email,
	      showClose = _ref.showClose,
	      onClose = _ref.onClose,
	      style = _ref.style,
	      formatMessage = _ref.formatMessage;
	  return _react2.default.createElement(
	    'section',
	    { style: style },
	    _react2.default.createElement(
	      'div',
	      null,
	      formatMessage(_strings.PROFILE.edit.emailConfirmationText, { email: email })
	    ),
	    showClose ? _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'mt3 mr2',
	        style: { width: CLOSE_BUTTON_WIDTH },
	        raised: true,
	        color: 'primary',
	        onClick: onClose
	      },
	      formatMessage(_strings.COMMON.close)
	    ) : null
	  );
	};
	
	EmailConfirmation.propTypes = {
	  email: _propTypes2.default.string.isRequired,
	  showClose: _propTypes2.default.bool.isRequired,
	  onClose: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = EmailConfirmation;

/***/ }),
/* 3573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _validations = __webpack_require__(81);
	
	var _formFields = __webpack_require__(38);
	
	var _EmergencyContact = __webpack_require__(696);
	
	var _styles = __webpack_require__(2262);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMAIL = _formFields.PROFILE_FIELDS_TYPES.EMAIL,
	    RELATION = _formFields.PROFILE_FIELDS_TYPES.RELATION,
	    LAST_NAME = _formFields.PROFILE_FIELDS_TYPES.LAST_NAME,
	    FIRST_NAME = _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME,
	    PHONE_NUMBER = _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER;
	
	
	var EmergencyContactColumnModeView = function EmergencyContactColumnModeView(_ref) {
	  var _onChange = _ref.onChange,
	      formState = _ref.formState,
	      relationList = _ref.relationList,
	      formatMessage = _ref.formatMessage,
	      onEmailChange = _ref.onEmailChange,
	      validateErrors = _ref.validateErrors,
	      makeProfileField = _ref.makeProfileField,
	      onMobilePhoneChange = _ref.onMobilePhoneChange;
	  var email = formState.email,
	      lastName = formState.lastName,
	      relation = formState.relation,
	      firstName = formState.firstName,
	      phoneNumber = formState.phoneNumber;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(FIRST_NAME), {
	      value: firstName,
	      required: false,
	      limit: _validations.LENGTH_VALUES.FIRST_NAME.MAX
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(LAST_NAME), {
	      value: lastName,
	      required: false,
	      limit: _validations.LENGTH_VALUES.LAST_NAME.MAX
	    })),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(RELATION), {
	        value: relation,
	        needUpdateDefaultValue: true,
	        options: (0, _EmergencyContact.normalizeRelationList)(relationList),
	        onChange: function onChange(data) {
	          return _onChange({ relation: data });
	        }
	      }))
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(PHONE_NUMBER), {
	        value: phoneNumber,
	        limit: _validations.LENGTH_VALUES.EMERGENCY_PHONE.MAX,
	        onChange: function onChange(data) {
	          return onMobilePhoneChange(data, formatMessage);
	        }
	      })),
	      _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: PHONE_NUMBER, errors: validateErrors })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(EMAIL), {
	        value: email,
	        onChange: function onChange(data) {
	          return onEmailChange(data);
	        }
	      })),
	      _react2.default.createElement(_FormErrorBlock.FormErrorBlock, {
	        type: EMAIL,
	        errors: validateErrors.email && {
	          email: formatMessage({
	            id: 'messages.patientNotJoined.errors.emailInvalid'
	          })
	        }
	      })
	    )
	  );
	};
	
	EmergencyContactColumnModeView.propTypes = {
	  onChange: _propTypes2.default.func,
	  formState: _propTypes2.default.object,
	  relationList: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  onEmailChange: _propTypes2.default.func,
	  makeProfileField: _propTypes2.default.func,
	  validateErrors: _propTypes2.default.object,
	  onMobilePhoneChange: _propTypes2.default.func
	};
	
	exports.default = EmergencyContactColumnModeView;

/***/ }),
/* 3574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _validations = __webpack_require__(81);
	
	var _formFields = __webpack_require__(38);
	
	var _EmergencyContact = __webpack_require__(696);
	
	var _styles = __webpack_require__(2262);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EMAIL = _formFields.PROFILE_FIELDS_TYPES.EMAIL,
	    RELATION = _formFields.PROFILE_FIELDS_TYPES.RELATION,
	    LAST_NAME = _formFields.PROFILE_FIELDS_TYPES.LAST_NAME,
	    FIRST_NAME = _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME,
	    PHONE_NUMBER = _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER;
	
	
	var EmergencyContactRowModeView = function EmergencyContactRowModeView(_ref) {
	  var _onChange = _ref.onChange,
	      formState = _ref.formState,
	      relationList = _ref.relationList,
	      formatMessage = _ref.formatMessage,
	      onEmailChange = _ref.onEmailChange,
	      validateErrors = _ref.validateErrors,
	      makeProfileField = _ref.makeProfileField,
	      onMobilePhoneChange = _ref.onMobilePhoneChange;
	  var email = formState.email,
	      lastName = formState.lastName,
	      relation = formState.relation,
	      firstName = formState.firstName,
	      phoneNumber = formState.phoneNumber;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.column },
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(FIRST_NAME), {
	        value: firstName,
	        required: false,
	        limit: _validations.LENGTH_VALUES.FIRST_NAME.MAX
	      })),
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(LAST_NAME), {
	        value: lastName,
	        required: false,
	        limit: _validations.LENGTH_VALUES.LAST_NAME.MAX
	      }))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.column },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(RELATION), {
	          value: relation,
	          needUpdateDefaultValue: true,
	          options: (0, _EmergencyContact.normalizeRelationList)(relationList),
	          onChange: function onChange(data) {
	            return _onChange({ relation: data });
	          }
	        }))
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(PHONE_NUMBER), {
	          value: phoneNumber,
	          limit: _validations.LENGTH_VALUES.EMERGENCY_PHONE.MAX,
	          onChange: function onChange(data) {
	            return onMobilePhoneChange(data, formatMessage);
	          }
	        })),
	        _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: PHONE_NUMBER, errors: validateErrors })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.column },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(EMAIL), {
	          value: email,
	          onChange: function onChange(data) {
	            return onEmailChange(data);
	          }
	        })),
	        _react2.default.createElement(_FormErrorBlock.FormErrorBlock, {
	          type: EMAIL,
	          errors: validateErrors.email && {
	            email: formatMessage({
	              id: 'messages.patientNotJoined.errors.emailInvalid'
	            })
	          }
	        })
	      )
	    )
	  );
	};
	
	EmergencyContactRowModeView.propTypes = {
	  onChange: _propTypes2.default.func,
	  formState: _propTypes2.default.object,
	  relationList: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  onEmailChange: _propTypes2.default.func,
	  makeProfileField: _propTypes2.default.func,
	  validateErrors: _propTypes2.default.object,
	  onMobilePhoneChange: _propTypes2.default.func
	};
	
	exports.default = EmergencyContactRowModeView;

/***/ }),
/* 3575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _styles = __webpack_require__(18);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _EmergencyContactRowModeView = __webpack_require__(3574);
	
	var _EmergencyContactRowModeView2 = _interopRequireDefault(_EmergencyContactRowModeView);
	
	var _EmergencyContactColumnModeView = __webpack_require__(3573);
	
	var _EmergencyContactColumnModeView2 = _interopRequireDefault(_EmergencyContactColumnModeView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmergencyContactFormSection = function EmergencyContactFormSection(_ref) {
	  var onChange = _ref.onChange,
	      formState = _ref.formState,
	      relationList = _ref.relationList,
	      formatMessage = _ref.formatMessage,
	      onEmailChange = _ref.onEmailChange,
	      validateErrors = _ref.validateErrors,
	      onMobilePhoneChange = _ref.onMobilePhoneChange;
	
	  var makeProfileField = (0, _getFieldProps.getFieldProps)(formatMessage, onChange);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactResponsive2.default,
	      { maxWidth: _styles.BREAKPOINT },
	      _react2.default.createElement(_EmergencyContactColumnModeView2.default, {
	        onChange: onChange,
	        formState: formState,
	        relationList: relationList,
	        formatMessage: formatMessage,
	        onEmailChange: onEmailChange,
	        validateErrors: validateErrors,
	        makeProfileField: makeProfileField,
	        onMobilePhoneChange: onMobilePhoneChange
	      })
	    ),
	    _react2.default.createElement(
	      _reactResponsive2.default,
	      { minWidth: _styles.BREAKPOINT },
	      _react2.default.createElement(_EmergencyContactRowModeView2.default, {
	        onChange: onChange,
	        formState: formState,
	        relationList: relationList,
	        formatMessage: formatMessage,
	        onEmailChange: onEmailChange,
	        validateErrors: validateErrors,
	        makeProfileField: makeProfileField,
	        onMobilePhoneChange: onMobilePhoneChange
	      })
	    )
	  );
	};
	
	EmergencyContactFormSection.propTypes = {
	  onChange: _propTypes2.default.func,
	  formState: _propTypes2.default.object,
	  relationList: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  onEmailChange: _propTypes2.default.func,
	  validateErrors: _propTypes2.default.object,
	  onMobilePhoneChange: _propTypes2.default.func
	};
	
	exports.default = EmergencyContactFormSection;

/***/ }),
/* 3576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EditBtn = __webpack_require__(393);
	
	var _EditBtn2 = _interopRequireDefault(_EditBtn);
	
	var _strings = __webpack_require__(15);
	
	var _formFields = __webpack_require__(38);
	
	var _EmergencyContactFormSection = __webpack_require__(3575);
	
	var _EmergencyContactFormSection2 = _interopRequireDefault(_EmergencyContactFormSection);
	
	var _toSnakeCaseObjectKeys = __webpack_require__(699);
	
	var _toSnakeCaseObjectKeys2 = _interopRequireDefault(_toSnakeCaseObjectKeys);
	
	var _metadata = __webpack_require__(291);
	
	var _selectors = __webpack_require__(56);
	
	var _makeEmergencyInitialValue = __webpack_require__(3578);
	
	var _useEmergencyContactFormState = __webpack_require__(3579);
	
	var _getFieldsEmergencyContactSection = __webpack_require__(3577);
	
	var _styles = __webpack_require__(5077);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmergencyContact = function EmergencyContact(_ref) {
	  var profile = _ref.profile,
	      canEdit = _ref.canEdit,
	      savePatient = _ref.savePatient,
	      relationList = _ref.relationList,
	      formatMessage = _ref.formatMessage,
	      isSucceedUpdate = _ref.isSucceedUpdate;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isEdit = _useState2[0],
	      toggleEdit = _useState2[1];
	
	  var errors = (0, _reactRedux.useSelector)(_selectors.selectEditPatientErrors);
	
	  var patientProfileId = (0, _get2.default)(profile, 'primaryPatientProfile.id');
	
	  var fields = (0, _getFieldsEmergencyContactSection.getFieldsEmergencyContactSection)(formatMessage, profile);
	
	  (0, _react.useEffect)(function () {
	    if (isEdit) toggleEdit(!isSucceedUpdate);
	  }, [isSucceedUpdate]);
	
	  var _useEmergencyContactF = (0, _useEmergencyContactFormState.useEmergencyContactFormState)((0, _makeEmergencyInitialValue.makeEmergencyInitialValue)(profile, relationList), errors),
	      formState = _useEmergencyContactF.formState,
	      clearErrors = _useEmergencyContactF.clearErrors,
	      onEmailChange = _useEmergencyContactF.onEmailChange,
	      validateErrors = _useEmergencyContactF.validateErrors,
	      handleFormChange = _useEmergencyContactF.handleFormChange,
	      onMobilePhoneChange = _useEmergencyContactF.onMobilePhoneChange;
	
	  var isEmailValid = !validateErrors.email;
	  var relation = formState[_formFields.PROFILE_FIELDS_TYPES.RELATION] || '';
	  var phoneValue = formState[_formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER] || '';
	
	  var isPhoneValid = phoneValue.length > 9 && !validateErrors.phoneNumber || !phoneValue.length;
	
	  var handleSubmit = function handleSubmit(e) {
	    var _savePatient;
	
	    e.preventDefault();
	
	    clearErrors();
	
	    savePatient((_savePatient = {}, (0, _defineProperty3.default)(_savePatient, _metadata.EMERGENCY_CONTACT_DATA_KEY, (0, _extends3.default)({}, (0, _toSnakeCaseObjectKeys2.default)(formState), {
	      relation: relation.value
	    })), (0, _defineProperty3.default)(_savePatient, 'id', patientProfileId), _savePatient));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.titleWrapper },
	      _react2.default.createElement(
	        'h3',
	        { className: _styles2.default.title },
	        formatMessage({ id: 'profile.section.emergencyContact' })
	      ),
	      canEdit && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.editButton },
	        _react2.default.createElement(_EditBtn2.default, {
	          onClick: function onClick() {
	            handleFormChange((0, _makeEmergencyInitialValue.makeEmergencyInitialValue)(profile, relationList));
	            toggleEdit(!isEdit);
	          }
	        })
	      )
	    ),
	    isEdit && _react2.default.createElement(_EmergencyContactFormSection2.default, {
	      formState: formState,
	      relationList: relationList,
	      onChange: handleFormChange,
	      onEmailChange: onEmailChange,
	      formatMessage: formatMessage,
	      validateErrors: validateErrors,
	      onMobilePhoneChange: onMobilePhoneChange
	    }),
	    !isEdit && _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_styles2.default.fieldsetContent, _styles2.default.withColumns) },
	      fields && fields.map(function (_ref2) {
	        var id = _ref2.id,
	            value = _ref2.value,
	            name = _ref2.name;
	        return _react2.default.createElement(
	          'div',
	          { className: _styles2.default.fieldWrapper, key: id },
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.titleEntity },
	            name
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.contentEntity },
	            value || '-'
	          )
	        );
	      })
	    ),
	    isEdit && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          raised: true,
	          color: 'primary',
	          onClick: handleSubmit,
	          disabled: !isPhoneValid || !isEmailValid,
	          className: 'mt3 mr2 user-profile-save-button'
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.save)
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          raised: true,
	          color: 'accent',
	          className: 'mt3 user-profile-cancel-button',
	          onClick: function onClick() {
	            clearErrors();
	            handleFormChange((0, _makeEmergencyInitialValue.makeEmergencyInitialValue)(profile, relationList));
	            toggleEdit(false);
	          }
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.cancel)
	      )
	    )
	  );
	};
	
	EmergencyContact.propTypes = {
	  canEdit: _propTypes2.default.bool,
	  profile: _propTypes2.default.object,
	  savePatient: _propTypes2.default.func,
	  formatMessage: _propTypes2.default.func,
	  relationList: _propTypes2.default.array,
	  isSucceedUpdate: _propTypes2.default.bool
	};
	
	exports.default = EmergencyContact;

/***/ }),
/* 3577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFieldsEmergencyContactSection = getFieldsEmergencyContactSection;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _upperFirst = __webpack_require__(147);
	
	var _upperFirst2 = _interopRequireDefault(_upperFirst);
	
	var _ids = __webpack_require__(46);
	
	var _strings = __webpack_require__(15);
	
	var _validations = __webpack_require__(81);
	
	var _getPhone = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFieldsEmergencyContactSection(formatMessage, profile) {
	  var emergencyContact = (0, _get2.default)(profile, 'primaryPatientProfile.emergencyContactAttributes') || {};
	  return [{
	    fieldName: 'emergencyFirstName',
	    id: _ids.IDS.FORM_FIELDS.FIRST_NAME,
	    value: emergencyContact.firstName,
	    limit: _validations.LENGTH_VALUES.FIRST_NAME.MAX,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.firstName)
	  }, {
	    fieldName: 'lastName',
	    id: _ids.IDS.FORM_FIELDS.LAST_NAME,
	    value: emergencyContact.lastName,
	    limit: _validations.LENGTH_VALUES.LAST_NAME.MAX,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.lastName)
	  }, {
	    type: 'select',
	    fieldName: 'relation',
	    id: _ids.IDS.FORM_FIELDS.RELATION,
	    value: (0, _upperFirst2.default)(emergencyContact.relation),
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.relation)
	  }, {
	    type: 'number',
	    fieldName: 'phoneNumber',
	    id: _ids.IDS.FORM_FIELDS.PHONE_NUMBER,
	    limit: _validations.LENGTH_VALUES.PHONE_NUMBER.MAX,
	    value: (0, _getPhone.getPhoneWithoutUSCode)(emergencyContact.phoneNumber),
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.mobilePhone)
	  }, {
	    fieldName: 'email',
	    id: _ids.IDS.FORM_FIELDS.EMAIL,
	    value: emergencyContact.email,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.email)
	  }];
	}

/***/ }),
/* 3578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeEmergencyInitialValue = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _formFields = __webpack_require__(38);
	
	var _EmergencyContact = __webpack_require__(696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeEmergencyInitialValue = exports.makeEmergencyInitialValue = function makeEmergencyInitialValue(profile, relationList) {
	  var _ref2;
	
	  var _ref = (0, _get2.default)(profile, 'primaryPatientProfile.emergencyContactAttributes') || {},
	      email = _ref.email,
	      relation = _ref.relation,
	      firstName = _ref.firstName,
	      lastName = _ref.lastName,
	      phoneNumber = _ref.phoneNumber;
	
	  return _ref2 = {}, (0, _defineProperty3.default)(_ref2, _formFields.PROFILE_FIELDS_TYPES.EMAIL, email), (0, _defineProperty3.default)(_ref2, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, lastName), (0, _defineProperty3.default)(_ref2, _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, firstName), (0, _defineProperty3.default)(_ref2, _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER, phoneNumber), (0, _defineProperty3.default)(_ref2, _formFields.PROFILE_FIELDS_TYPES.RELATION, (0, _EmergencyContact.adaptRelationValue)(relation, relationList)), _ref2;
	};

/***/ }),
/* 3579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialEmergencyContactState = undefined;
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialEmergencyCont;
	
	exports.useEmergencyContactFormState = useEmergencyContactFormState;
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialEmergencyContactState = exports.initialEmergencyContactState = (_initialEmergencyCont = {}, (0, _defineProperty3.default)(_initialEmergencyCont, _formFields.PROFILE_FIELDS_TYPES.EMAIL, ''), (0, _defineProperty3.default)(_initialEmergencyCont, _formFields.PROFILE_FIELDS_TYPES.RELATION, ''), (0, _defineProperty3.default)(_initialEmergencyCont, _formFields.PROFILE_FIELDS_TYPES.LAST_NAME, ''), (0, _defineProperty3.default)(_initialEmergencyCont, _formFields.PROFILE_FIELDS_TYPES.FIRST_NAME, ''), (0, _defineProperty3.default)(_initialEmergencyCont, _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER, ''), _initialEmergencyCont);
	
	function useEmergencyContactFormState(state, errors) {
	  var _useFormState = (0, _useFormWithValidation.useFormState)((0, _extends5.default)({}, initialEmergencyContactState, state)),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var _useFormValidation = (0, _useFormWithValidation.useFormValidation)(errors),
	      clearErrors = _useFormValidation.clearErrors,
	      validateErrors = _useFormValidation.validateErrors,
	      addLocalValidateErrors = _useFormValidation.addLocalValidateErrors;
	
	  var onMobilePhoneChange = function onMobilePhoneChange(phone, formatMessage) {
	    clearErrors();
	    if (phone.length && phone.length < 10) {
	      addLocalValidateErrors(_formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER, formatMessage({ id: 'errors.validation.invalidLoginPhone' }));
	    }
	    handleFormChange((0, _extends5.default)({}, formState, (0, _defineProperty3.default)({}, _formFields.PROFILE_FIELDS_TYPES.PHONE_NUMBER, phone)));
	  };
	
	  var onEmailChange = function onEmailChange(email) {
	    clearErrors();
	    handleFormChange((0, _extends5.default)({}, formState, (0, _defineProperty3.default)({}, _formFields.PROFILE_FIELDS_TYPES.EMAIL, email)));
	  };
	
	  return {
	    formState: formState,
	    clearErrors: clearErrors,
	    onEmailChange: onEmailChange,
	    validateErrors: validateErrors,
	    handleFormChange: handleFormChange,
	    onMobilePhoneChange: onMobilePhoneChange,
	    addLocalValidateErrors: addLocalValidateErrors
	  };
	}

/***/ }),
/* 3580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _editWorkingHours = __webpack_require__(1326);
	
	var _selectors = __webpack_require__(23);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    employeeId: (0, _selectors.loggedUserEmployeeIdSelector)(state) || (0, _selectors.targetUserEmployeeIdSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  editWorkingHoursActions: _editWorkingHours.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HomeAddressColumnModeView = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _formFields = __webpack_require__(38);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _index = __webpack_require__(2263);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POSTAL_CODE = _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE,
	    ADDRESS_1 = _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1,
	    STATE = _formFields.PROFILE_FIELDS_TYPES.STATE,
	    CITY = _formFields.PROFILE_FIELDS_TYPES.CITY,
	    COUNTRY = _formFields.PROFILE_FIELDS_TYPES.COUNTRY,
	    ADDRESS_2 = _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2,
	    HOME_PHONE = _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE;
	function HomeAddressColumnModeView(_ref) {
	  var targetCountryEntity = _ref.targetCountryEntity,
	      postalCode = _ref.postalCode,
	      address1 = _ref.address1,
	      address2 = _ref.address2,
	      city = _ref.city,
	      state = _ref.state,
	      country = _ref.country,
	      homePhone = _ref.homePhone,
	      _onChange = _ref.onChange,
	      countryList = _ref.countryList,
	      validateErrors = _ref.validateErrors,
	      isZipApplicable = _ref.isZipApplicable,
	      statesList = _ref.statesList,
	      zipLimit = _ref.zipLimit,
	      makeProfileField = _ref.makeProfileField,
	      handleCountryChange = _ref.handleCountryChange,
	      formatMessage = _ref.formatMessage,
	      zipExamples = _ref.zipExamples,
	      isAppointmentPatientForm = _ref.isAppointmentPatientForm;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.column },
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(ADDRESS_1), { value: address1 })),
	      _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: ADDRESS_1, errors: validateErrors }),
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(ADDRESS_2), { value: address2 })),
	      _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: ADDRESS_2, errors: validateErrors })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.column },
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(CITY), { value: city })),
	      _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: CITY, errors: validateErrors }),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(STATE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	          onChange: function onChange(data) {
	            return _onChange({ state: data });
	          },
	          value: state,
	          options: statesList,
	          needUpdateDefaultValue: true,
	          required: true
	        })),
	        _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: STATE, errors: validateErrors })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.column },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(POSTAL_CODE, isAppointmentPatientForm && _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	          limit: zipLimit,
	          value: postalCode,
	          disabled: !isZipApplicable
	        })),
	        (0, _get2.default)(validateErrors, POSTAL_CODE) ? _react2.default.createElement(_ErrorBlock2.default, {
	          errors: [formatMessage({
	            id: 'errors.validation.profile.postalCode.format'
	          }, { example: zipExamples })],
	          className: 'mt3 w-100'
	        }) : null
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(COUNTRY, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	          onChange: function onChange(val) {
	            return handleCountryChange(val);
	          },
	          value: country || targetCountryEntity,
	          options: countryList,
	          needUpdateDefaultValue: true,
	          required: true
	        })),
	        _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: COUNTRY, errors: validateErrors })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.column },
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(HOME_PHONE), { value: homePhone })),
	      _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: HOME_PHONE, errors: validateErrors })
	    )
	  );
	}
	
	exports.HomeAddressColumnModeView = HomeAddressColumnModeView;
	HomeAddressColumnModeView.propTypes = {
	  postalCode: PropTypes.string,
	  address1: PropTypes.string,
	  address2: PropTypes.string,
	  city: PropTypes.string,
	  state: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	  country: PropTypes.object,
	  homePhone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  onChange: PropTypes.func,
	  statesList: PropTypes.array,
	  countryList: PropTypes.array,
	  zipLimit: PropTypes.number,
	  onCountryChange: PropTypes.func,
	  isZipApplicable: PropTypes.bool,
	  validateErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	  targetCountryEntity: PropTypes.object,
	  makeProfileField: PropTypes.func,
	  handleCountryChange: PropTypes.func,
	  formatMessage: PropTypes.func,
	  zipExamples: PropTypes.string,
	  isAppointmentPatientForm: PropTypes.bool
	};

/***/ }),
/* 3582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HomeAddressRowModeView = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _FormErrorBlock = __webpack_require__(119);
	
	var _formFields = __webpack_require__(38);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _useGetIsFieldDisabled = __webpack_require__(1855);
	
	var _useGetIsFieldDisabled2 = _interopRequireDefault(_useGetIsFieldDisabled);
	
	var _index = __webpack_require__(2263);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POSTAL_CODE = _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE,
	    ADDRESS_1 = _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1,
	    STATE = _formFields.PROFILE_FIELDS_TYPES.STATE,
	    CITY = _formFields.PROFILE_FIELDS_TYPES.CITY,
	    COUNTRY = _formFields.PROFILE_FIELDS_TYPES.COUNTRY,
	    ADDRESS_2 = _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2,
	    HOME_PHONE = _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE;
	function HomeAddressRowModeView(_ref) {
	  var targetCountryEntity = _ref.targetCountryEntity,
	      postalCode = _ref.postalCode,
	      address1 = _ref.address1,
	      address2 = _ref.address2,
	      city = _ref.city,
	      state = _ref.state,
	      country = _ref.country,
	      homePhone = _ref.homePhone,
	      _onChange = _ref.onChange,
	      countryList = _ref.countryList,
	      validateErrors = _ref.validateErrors,
	      isZipApplicable = _ref.isZipApplicable,
	      statesList = _ref.statesList,
	      zipLimit = _ref.zipLimit,
	      makeProfileField = _ref.makeProfileField,
	      handleCountryChange = _ref.handleCountryChange,
	      isDisabled = _ref.isDisabled,
	      formatMessage = _ref.formatMessage,
	      zipExamples = _ref.zipExamples,
	      homePhoneRequired = _ref.homePhoneRequired,
	      cityRequired = _ref.cityRequired,
	      address1Required = _ref.address1Required,
	      isAppointmentPatientForm = _ref.isAppointmentPatientForm,
	      isFormSubmitted = _ref.isFormSubmitted;
	
	  var _useGetIsFieldDisable = (0, _useGetIsFieldDisabled2.default)(),
	      checkIsFieldDisabled = _useGetIsFieldDisable.checkIsFieldDisabled;
	
	  var isPostalCodeFieldErrorExists = (0, _get2.default)(validateErrors, POSTAL_CODE);
	
	  var isPostalCodeFieldDisabled = isDisabled(POSTAL_CODE) && checkIsFieldDisabled(POSTAL_CODE, validateErrors) || !isZipApplicable;
	
	  var isPhoneNumberFieldDisabled = isDisabled(HOME_PHONE) && checkIsFieldDisabled(HOME_PHONE, validateErrors);
	
	  // immediately show errors for postal code field, but for other fields
	  // show errors only after form submission attempt
	  var formErrors = isFormSubmitted ? validateErrors : {};
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(ADDRESS_1), {
	      value: address1,
	      required: address1Required && _getFieldProps.FIELD_FILLING_TYPES.REQUIRED,
	      disabled: isDisabled(ADDRESS_1)
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: ADDRESS_1, errors: formErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(ADDRESS_2), {
	      value: address2,
	      disabled: isDisabled(ADDRESS_2)
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: ADDRESS_2, errors: formErrors }),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(CITY), {
	      required: cityRequired && _getFieldProps.FIELD_FILLING_TYPES.REQUIRED,
	      value: city,
	      disabled: isDisabled(CITY)
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: CITY, errors: formErrors }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(STATE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	        onChange: function onChange(data) {
	          return _onChange({ state: data });
	        },
	        value: state,
	        options: statesList,
	        needUpdateDefaultValue: true,
	        disabled: isDisabled(STATE),
	        required: true
	      })),
	      _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: STATE, errors: formErrors })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(POSTAL_CODE, isAppointmentPatientForm && _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	        limit: zipLimit,
	        value: postalCode,
	        disabled: isPostalCodeFieldDisabled
	      })),
	      isPostalCodeFieldErrorExists && _react2.default.createElement(_ErrorBlock2.default, {
	        errors: [formatMessage({ id: 'errors.validation.profile.postalCode.format' }, { example: zipExamples })],
	        className: 'mt3 w-100'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeProfileField(COUNTRY, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	        onChange: function onChange(val) {
	          return handleCountryChange(val);
	        },
	        value: country || targetCountryEntity,
	        options: countryList,
	        needUpdateDefaultValue: true,
	        disabled: isDisabled(COUNTRY),
	        required: true
	      })),
	      _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: COUNTRY, errors: formErrors })
	    ),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeProfileField(HOME_PHONE), {
	      value: homePhone,
	      required: homePhoneRequired && _getFieldProps.FIELD_FILLING_TYPES.REQUIRED,
	      disabled: isPhoneNumberFieldDisabled
	    })),
	    _react2.default.createElement(_FormErrorBlock.FormErrorBlock, { type: HOME_PHONE, errors: formErrors })
	  );
	}
	
	exports.HomeAddressRowModeView = HomeAddressRowModeView;
	HomeAddressRowModeView.propTypes = {
	  postalCode: PropTypes.string,
	  address1: PropTypes.string,
	  address2: PropTypes.string,
	  city: PropTypes.string,
	  state: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	  country: PropTypes.object,
	  homePhone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	  onChange: PropTypes.func,
	  statesList: PropTypes.array,
	  countryList: PropTypes.array,
	  zipLimit: PropTypes.number,
	  onCountryChange: PropTypes.func,
	  isZipApplicable: PropTypes.bool,
	  validateErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	  targetCountryEntity: PropTypes.object,
	  makeProfileField: PropTypes.func,
	  handleCountryChange: PropTypes.func,
	  isDisabled: PropTypes.func,
	  formatMessage: PropTypes.func,
	  zipExamples: PropTypes.string,
	  homePhoneRequired: PropTypes.bool,
	  cityRequired: PropTypes.bool,
	  address1Required: PropTypes.bool,
	  isAppointmentPatientForm: PropTypes.bool,
	  isFormSubmitted: PropTypes.bool
	};

/***/ }),
/* 3583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.getFieldsHomeAddressSection = getFieldsHomeAddressSection;
	
	var _strings = __webpack_require__(15);
	
	var _validations = __webpack_require__(81);
	
	var _getPhone = __webpack_require__(187);
	
	var _validations2 = __webpack_require__(362);
	
	var _ids = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFieldsHomeAddressSection(formatMessage, profile) {
	  var _validationRules2;
	
	  return [{
	    id: _ids.IDS.FORM_FIELDS.ADDRESS_1,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.address1),
	    value: profile.address1,
	    fieldName: 'address1',
	    limit: _validations.LENGTH_VALUES.ADDRESS_1.MAX
	  }, {
	    id: _ids.IDS.FORM_FIELDS.ADDRESS_2,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.address2),
	    value: profile.address2,
	    fieldName: 'address2',
	    limit: _validations.LENGTH_VALUES.ADDRESS_2.MAX
	  }, {
	    id: _ids.IDS.FORM_FIELDS.CITY,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.city),
	    value: profile.city,
	    fieldName: 'city',
	    limit: _validations.LENGTH_VALUES.CITY.MAX
	  }, {
	    id: _ids.IDS.FORM_FIELDS.STATE,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.state),
	    value: profile.state,
	    fieldName: 'state',
	    type: 'select',
	    limit: _validations.LENGTH_VALUES.STATE.MAX
	  }, {
	    id: _ids.IDS.FORM_FIELDS.POSTAL_CODE,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.postalCode),
	    validationRules: (0, _defineProperty3.default)({}, _validations2.RULES.POSTAL_CODE, {
	      message: 'profile.postalCode.format'
	    }),
	    value: profile.postalCode,
	    fieldName: 'postalCode',
	    limit: _validations.LENGTH_VALUES.POSTAL_CODE.MAX
	  }, {
	    id: _ids.IDS.FORM_FIELDS.COUNTRY,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.country),
	    value: profile.country,
	    fieldName: 'country',
	    limit: _validations.LENGTH_VALUES.COUNTRY.MAX
	  }, {
	    id: _ids.IDS.FORM_FIELDS.HOME_PHONE,
	    name: formatMessage(_strings.PROFILE_FIELDS.fieldNames.homePhone),
	    value: (0, _getPhone.getPhoneWithoutUSCode)(profile.homePhone),
	    limit: _validations.LENGTH_VALUES.HOME_PHONE.MAX,
	    type: 'number',
	    fieldName: 'homePhone',
	    validationRules: (_validationRules2 = {}, (0, _defineProperty3.default)(_validationRules2, _validations2.RULES.PHONE, {
	      message: 'profile.phone.format'
	    }), (0, _defineProperty3.default)(_validationRules2, _validations2.RULES.MIN_LENGTH, {
	      message: 'profile.phoneHome.format',
	      length: _validations.LENGTH_VALUES.PHONE_NUMBER.MIN
	    }), _validationRules2)
	  }];
	}

/***/ }),
/* 3584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateRequiredFields = exports.initialState = undefined;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialState;
	
	exports.useHomeAddressFormState = useHomeAddressFormState;
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = (_initialState = {}, (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.HOME_PHONE, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_1, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.ADDRESS_2, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.CITY, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.STATE, ''), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, ''), _initialState);
	
	var validateRequiredFields = exports.validateRequiredFields = function validateRequiredFields() {
	  return (0, _useFormWithValidation.makeRequiredFieldsValidator)([_formFields.PROFILE_FIELDS_TYPES.STATE]);
	};
	
	function useHomeAddressFormState(state, errors) {
	  var _useFormState = (0, _useFormWithValidation.useFormState)((0, _extends4.default)({}, initialState, state)),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var _useFormValidation = (0, _useFormWithValidation.useFormValidation)(errors),
	      validateErrors = _useFormValidation.validateErrors,
	      clearErrors = _useFormValidation.clearErrors,
	      addLocalValidateErrors = _useFormValidation.addLocalValidateErrors;
	
	  var isValid = validateRequiredFields()(formState);
	
	  var setCountryValue = function setCountryValue(value) {
	    var _extends2;
	
	    return handleFormChange((0, _extends4.default)({}, formState, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.COUNTRY, value), (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.STATE, ''), (0, _defineProperty3.default)(_extends2, _formFields.PROFILE_FIELDS_TYPES.POSTAL_CODE, ''), _extends2)));
	  };
	
	  return {
	    formState: formState,
	    handleFormChange: handleFormChange,
	    validateErrors: validateErrors,
	    addLocalValidateErrors: addLocalValidateErrors,
	    setCountryValue: setCountryValue,
	    clearErrors: clearErrors,
	    isValid: isValid
	  };
	}

/***/ }),
/* 3585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _reactRedux = __webpack_require__(6);
	
	var _recompose = __webpack_require__(22);
	
	var _selectors = __webpack_require__(43);
	
	var _updatePatientInsurance = __webpack_require__(4126);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    visitType: (0, _selectors.selectProgressVisitType)(state),
	    entity: (0, _selectors.selectInsuranceErrorModalEntity)(state),
	    isOpened: (0, _selectors.selectInsuranceErrorModalState)(state),
	    error: (0, _selectors.selectCheckInsuranceEligibilityError)(state) || (0, _updatePatientInsurance.selectUpdatePatientInsuranceError)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 3586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _enhance = __webpack_require__(3585);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _errors = __webpack_require__(120);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _makeInsuranceErrorMessage = __webpack_require__(4185);
	
	var _handleInsuranceErrorModal = __webpack_require__(502);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _index = __webpack_require__(5079);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HandleErrorCheckProfileInsuranceModal(_ref) {
	  var entity = _ref.entity,
	      error = _ref.error,
	      finishAction = _ref.finishAction,
	      flowType = _ref.flowType,
	      handleSave = _ref.handleSave,
	      isOpened = _ref.isOpened,
	      skipInsurance = _ref.skipInsurance,
	      userId = _ref.userId;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _entity = (0, _extends3.default)({}, entity),
	      errors = _entity.errors,
	      id = _entity.insuranceEligibilityResultId;
	
	  var code = (0, _get2.default)(error, 'code');
	
	  var _useCallback = (0, _react.useCallback)((0, _makeInsuranceErrorMessage.makeInsuranceErrorMessage)(code, formatMessage), [code]),
	      title = _useCallback.title,
	      message = _useCallback.message;
	
	  var isInsuranceRequestFailed = code === _errors.INSURANCE_ERROR_CODES.INSURANCE_REQUEST_FAILED;
	
	  var isCopayNotReceived = code === _errors.INSURANCE_ERROR_CODES.COPAY_NOT_RECEIVED;
	
	  var isToDoFlow = flowType === _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO;
	
	  var handleCloseModal = function handleCloseModal() {
	    dispatch(_handleInsuranceErrorModal.insuranceErrorModalActions.close());
	  };
	
	  var handleSaveAnyway = function handleSaveAnyway() {
	    if (isToDoFlow) {
	      handleSave(true);
	    } else {
	      var requestData = {
	        userId: userId,
	        insuranceEligibilityResultId: id,
	        skipInsurance: skipInsurance,
	        finishAction: finishAction,
	        flowType: flowType
	      };
	
	      dispatch(_manageInsurancesActions.manageInsurancesActions.runManualEligibilityActivation(requestData));
	    }
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      opened: isOpened,
	      withHeading: false,
	      mobileFullScreen: false,
	      onClose: handleCloseModal
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.root },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_index2.default.message, (0, _defineProperty3.default)({}, _index2.default.textCenter, !errors || isCopayNotReceived))
	        },
	        message
	      ),
	      errors && isInsuranceRequestFailed && errors.length > 0 && errors.map(function (item) {
	        return _react2.default.createElement(
	          'div',
	          { className: _index2.default.error, key: item },
	          '- ' + item
	        );
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.actionButtonWrapper },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            raised: true,
	            color: 'primary',
	            className: _index2.default.button,
	            onClick: handleSaveAnyway
	          },
	          formatMessage({ id: 'common.saveAnyway' })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            raised: true,
	            color: 'accent',
	            className: _index2.default.button,
	            onClick: handleCloseModal
	          },
	          formatMessage({ id: 'common.cancel' })
	        )
	      )
	    )
	  );
	}
	
	HandleErrorCheckProfileInsuranceModal.propTypes = {
	  entity: _propTypes2.default.object,
	  error: _propTypes2.default.object,
	  finishAction: _propTypes2.default.func,
	  flowType: _propTypes2.default.string,
	  handleSave: _propTypes2.default.func,
	  isOpened: _propTypes2.default.bool,
	  skipInsurance: _propTypes2.default.bool,
	  userId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	exports.default = (0, _enhance.enhance)(HandleErrorCheckProfileInsuranceModal);

/***/ }),
/* 3587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _InsuranceForm = __webpack_require__(615);
	
	var _InsuranceForm2 = _interopRequireDefault(_InsuranceForm);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _selectors = __webpack_require__(23);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InsuranceDetailsForm(_ref) {
	  var targetUserName = _ref.targetUserName,
	      flowType = _ref.flowType,
	      insuranceData = _ref.insuranceData,
	      cancel = _ref.cancel;
	
	  var userId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(_InsuranceForm2.default, {
	      userId: userId,
	      userName: targetUserName,
	      flowType: flowType,
	      insuranceData: insuranceData,
	      cancel: cancel,
	      withPlanNotListedOption: false
	    })
	  );
	}
	
	InsuranceDetailsForm.propTypes = {
	  cancel: PropTypes.func,
	  flowType: PropTypes.oneOf((0, _keys2.default)(_insuranceFlowType.INSURANCE_FLOW_TYPE)),
	  insuranceData: PropTypes.object,
	  targetUserName: PropTypes.string
	};
	
	exports.default = (0, _react.memo)(InsuranceDetailsForm);

/***/ }),
/* 3588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactIntl = __webpack_require__(5);
	
	var _useCountrySelect2 = __webpack_require__(145);
	
	var _lang = __webpack_require__(616);
	
	var useCountryData = function useCountryData() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _useCountrySelect = (0, _useCountrySelect2.useCountrySelect)(formatMessage),
	      isZipApplicable = _useCountrySelect.isZipApplicable,
	      loadCountryDetails = _useCountrySelect.loadCountryDetails,
	      stateList = _useCountrySelect.stateList,
	      zipLimit = _useCountrySelect.zipLimit;
	
	  (0, _react.useEffect)(function () {
	    loadCountryDetails(_lang.ISO_CODES.US);
	  }, []);
	
	  return {
	    stateList: stateList,
	    zipLimit: zipLimit,
	    isZipApplicable: isZipApplicable
	  };
	};
	
	exports.default = useCountryData;

/***/ }),
/* 3589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLottie = __webpack_require__(1617);
	
	var _reactLottie2 = _interopRequireDefault(_reactLottie);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _constants = __webpack_require__(17);
	
	var _UploadInsuranceCard = __webpack_require__(5356);
	
	var _UploadInsuranceCard2 = _interopRequireDefault(_UploadInsuranceCard);
	
	var _index = __webpack_require__(5082);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var animationOptions = {
	  loop: true,
	  autoplay: true,
	  animationData: _UploadInsuranceCard2.default,
	  rendererSettings: {
	    preserveAspectRatio: 'xMidYMid slice'
	  }
	};
	
	var UploadingInsuranceCardModal = function UploadingInsuranceCardModal(_ref) {
	  var isOpened = _ref.isOpened,
	      cardType = _ref.cardType;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var isFrontSideCard = cardType === _constants.DOCUMENTATION_TYPES.CARD_1;
	
	  var title = formatMessage({
	    id: isFrontSideCard ? 'profile.loadingPopup' : 'profile.insuranceCard.uploading'
	  });
	
	  if (!isOpened) return null;
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    { opened: isOpened, withHeading: false, mobileFullScreen: false },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.root },
	      _react2.default.createElement(_reactLottie2.default, { options: animationOptions, height: 200, width: 200 }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.message },
	        title
	      )
	    )
	  );
	};
	
	UploadingInsuranceCardModal.propTypes = {
	  isOpened: _propTypes2.default.bool,
	  cardType: _propTypes2.default.string
	};
	exports.default = UploadingInsuranceCardModal;

/***/ }),
/* 3590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _recompose = __webpack_require__(22);
	
	var _constants = __webpack_require__(17);
	
	var _selectors = __webpack_require__(43);
	
	var _selectors2 = __webpack_require__(23);
	
	var _getUserDocuments = __webpack_require__(425);
	
	var _updateUserDocuments = __webpack_require__(540);
	
	var _uploadUserDocuments = __webpack_require__(429);
	
	var _deleteUserDocuments = __webpack_require__(422);
	
	var _selectors3 = __webpack_require__(56);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    targetUser: (0, _selectors2.targetUserSelector)(state),
	    checkInsuranceLoading: (0, _selectors.selectCheckInsuranceEligibilityLoading)(state),
	    userDocuments: (0, _selectors3.selectUserDocumentsList)(state),
	    canEdit: (0, _selectors2.isLoggedUserSelector)(state) || (0, _selectors2.selectIsVerifiedDependentRole)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  uploadDocuments: _uploadUserDocuments.actions.send,
	  updateDocuments: _updateUserDocuments.actions.send,
	  deleteDocuments: _deleteUserDocuments.actions.send,
	  deleteDocumentItem: _getUserDocuments.actions.deleteItem,
	  clearInsuranceRelatedData: _manageInsurancesActions.manageInsurancesActions.clearManageInsuranceRelatedData
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var targetUser = _ref.targetUser,
	      userDocuments = _ref.userDocuments;
	
	  var driverLicenseDocuments = userDocuments.filter(function (doc) {
	    return doc && doc.key === _constants.DOCUMENTATION_TYPES.DRIVER_LICENCE;
	  });
	
	  return {
	    targetUserId: (0, _get2.default)(targetUser, 'id'),
	    targetUserName: (0, _get2.default)(targetUser, 'displayableName'),
	    driverLicenseDocuments: driverLicenseDocuments
	  };
	}));

/***/ }),
/* 3591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(58);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhance = __webpack_require__(3590);
	
	var _Fieldset = __webpack_require__(1788);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _EditBtn = __webpack_require__(393);
	
	var _EditBtn2 = _interopRequireDefault(_EditBtn);
	
	var _InsurancesInfo = __webpack_require__(775);
	
	var _InsurancesInfo2 = _interopRequireDefault(_InsurancesInfo);
	
	var _InsuranceDetailsForm = __webpack_require__(3587);
	
	var _InsuranceDetailsForm2 = _interopRequireDefault(_InsuranceDetailsForm);
	
	var _UserDocumentsPreview = __webpack_require__(610);
	
	var _UserDocumentsPreview2 = _interopRequireDefault(_UserDocumentsPreview);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _useGetPatientInsuranceData = __webpack_require__(799);
	
	var _useGetPatientInsuranceData2 = _interopRequireDefault(_useGetPatientInsuranceData);
	
	var _getFieldset = __webpack_require__(611);
	
	var _styles = __webpack_require__(5083);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FLOW_TYPE = _insuranceFlowType.INSURANCE_FLOW_TYPE.PROFILE;
	
	function InsuranceDetails(_ref) {
	  var canEdit = _ref.canEdit,
	      checkInsuranceLoading = _ref.checkInsuranceLoading,
	      clearInsuranceRelatedData = _ref.clearInsuranceRelatedData,
	      deleteDocumentItem = _ref.deleteDocumentItem,
	      deleteDocuments = _ref.deleteDocuments,
	      driverLicenseDocuments = _ref.driverLicenseDocuments,
	      formatMessage = _ref.intl.formatMessage,
	      targetUserId = _ref.targetUserId,
	      targetUserName = _ref.targetUserName,
	      updateDocuments = _ref.updateDocuments,
	      uploadDocuments = _ref.uploadDocuments;
	
	  var _useReducer = (0, _react.useReducer)(function (confirm) {
	    return !confirm;
	  }, false),
	      _useReducer2 = (0, _slicedToArray3.default)(_useReducer, 2),
	      edit = _useReducer2[0],
	      toggleEdit = _useReducer2[1];
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isEditMode = _useState2[0],
	      setIsEditMode = _useState2[1];
	
	  var _useGetPatientInsuran = (0, _useGetPatientInsuranceData2.default)({
	    userId: targetUserId,
	    flowType: FLOW_TYPE,
	    isInsuranceEditOpen: edit
	  }),
	      insuranceData = _useGetPatientInsuran.insuranceData,
	      isInsuranceRelatedDataFetching = _useGetPatientInsuran.isInsuranceRelatedDataFetching;
	
	  var showInsuranceInfoData = !edit && !isInsuranceRelatedDataFetching;
	
	  var showInsuranceForm = edit && !isInsuranceRelatedDataFetching;
	
	  var handleEditModeChange = function handleEditModeChange(editMode) {
	    setIsEditMode(editMode);
	  };
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      clearInsuranceRelatedData();
	    };
	  }, []);
	
	  var handleSave = function handleSave(fields) {
	    fields.map(function (field) {
	      var key = (0, _lodash.get)(field, 'fieldName');
	      var id = (0, _lodash.get)(field, 'id');
	      var file = (0, _lodash.get)(field, 'value.file');
	      var deleted = (0, _lodash.get)(field, 'value.deleted');
	      var data = new FormData();
	      data.append('attachment', file);
	      data.append('userId', targetUserId);
	
	      if (deleted && id) {
	        deleteDocumentItem({ id: id });
	        deleteDocuments({ userId: targetUserId, id: id });
	      }
	      if (file && id) {
	        data.append('id', id);
	        deleteDocumentItem({ id: id });
	        updateDocuments(data);
	      }
	      if (file && !id) {
	        data.append('key', key);
	
	        uploadDocuments(data);
	      }
	      return false;
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.titleWrapper },
	      _react2.default.createElement(
	        'h3',
	        { className: _styles2.default.title },
	        formatMessage({ id: 'profile.section.insurance' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.editButton },
	        _react2.default.createElement(_EditBtn2.default, {
	          onClick: toggleEdit,
	          disabled: isInsuranceRelatedDataFetching || checkInsuranceLoading
	        })
	      )
	    ),
	    isInsuranceRelatedDataFetching && _react2.default.createElement(_Loader2.default, null),
	    showInsuranceInfoData && _react2.default.createElement(_InsurancesInfo2.default, {
	      flowType: FLOW_TYPE,
	      userId: targetUserId,
	      userName: targetUserName,
	      withSelfPayEnding: true
	    }),
	    showInsuranceForm && _react2.default.createElement(_InsuranceDetailsForm2.default, {
	      cancel: toggleEdit,
	      flowType: FLOW_TYPE,
	      insuranceData: insuranceData,
	      targetUserName: targetUserName
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.profileDocWrapper },
	      _react2.default.createElement(_Fieldset2.default, {
	        fieldset: (0, _getFieldset.getDriverLicenseDocumentFieldset)(formatMessage, driverLicenseDocuments, isEditMode),
	        onSave: handleSave,
	        disabled: !canEdit,
	        canEdit: canEdit,
	        onEditModeChange: handleEditModeChange
	      })
	    ),
	    _react2.default.createElement(_UserDocumentsPreview2.default, { documents: driverLicenseDocuments })
	  );
	}
	
	InsuranceDetails.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  canEdit: _propTypes2.default.bool,
	  checkInsuranceLoading: _propTypes2.default.bool,
	  clearInsuranceRelatedData: _propTypes2.default.func,
	  deleteDocumentItem: _propTypes2.default.func,
	  deleteDocuments: _propTypes2.default.func,
	  driverLicenseDocuments: _propTypes2.default.array,
	  formatMessage: _propTypes2.default.func,
	  targetUserId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  targetUserName: _propTypes2.default.string,
	  updateDocuments: _propTypes2.default.func,
	  uploadDocuments: _propTypes2.default.func
	};
	
	exports.default = (0, _react.memo)((0, _enhance.enhance)(InsuranceDetails));

/***/ }),
/* 3592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _locale = __webpack_require__(1374);
	
	var _selectors = __webpack_require__(23);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isLoggedUser: (0, _selectors.isLoggedUserSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  setLanguage: _locale.actions.setLocale
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _strings = __webpack_require__(15);
	
	var _enhance = __webpack_require__(3592);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LanguagePicker = function (_PureComponent) {
	  (0, _inherits3.default)(LanguagePicker, _PureComponent);
	
	  function LanguagePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, LanguagePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LanguagePicker.__proto__ || (0, _getPrototypeOf2.default)(LanguagePicker)).call.apply(_ref, [this].concat(args))), _this), _this.onLocaleChange = function (val) {
	      var _this$props = _this.props,
	          isLoggedUser = _this$props.isLoggedUser,
	          onChange = _this$props.onChange,
	          setLanguage = _this$props.setLanguage;
	
	      var lang = val.value;
	
	      onChange(lang);
	      if (isLoggedUser) setLanguage(lang);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(LanguagePicker, [{
	    key: 'render',
	    value: function render() {
	      var locale = this.props.locale;
	
	      var langs = [{ value: 'en', label: 'English' }, { value: 'es', label: 'Español' }, { value: 'zh', label: '中文' }];
	
	      return _react2.default.createElement(
	        'section',
	        { styleName: 'language-settings' },
	        _react2.default.createElement(
	          'h3',
	          { styleName: 'sectionTitle' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE.languageSettings.title)
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'fieldsetContent fieldsetContent--withColumns' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'fieldWrapper' },
	            _react2.default.createElement(
	              'div',
	              { styleName: 'field' },
	              _react2.default.createElement(_SelectCustom2.default, {
	                name: 'language',
	                options: langs,
	                placeholder: 'Pick a language',
	                value: locale,
	                onChange: this.onLocaleChange
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return LanguagePicker;
	}(_react.PureComponent);
	
	LanguagePicker.propTypes = {
	  locale: _propTypes2.default.string,
	  setLanguage: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  onChange: _propTypes2.default.func,
	  isLoggedUser: _propTypes2.default.bool
	};
	
	exports.default = (0, _enhance.enhance)(LanguagePicker);

/***/ }),
/* 3594 */,
/* 3595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _lodash = __webpack_require__(58);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _medicationsReq = __webpack_require__(627);
	
	var _selectors = __webpack_require__(43);
	
	var _selectors2 = __webpack_require__(23);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicationSelect = function MedicationSelect(_ref) {
	  var handleBlur = _ref.handleBlur,
	      onChange = _ref.onChange,
	      onCheckBeforeDelete = _ref.onCheckBeforeDelete,
	      label = _ref.label,
	      value = _ref.value,
	      placeholder = _ref.placeholder;
	
	  var offsetRef = (0, _react.useRef)(0);
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      medicationQuery = _useState2[0],
	      setMedicationQuery = _useState2[1];
	
	  var profile = (0, _reactRedux.useSelector)(_selectors2.targetUserSelector);
	  var medicationList = (0, _reactRedux.useSelector)(_selectors.selectMedicationSearchData);
	
	  var handleMedicationsSearch = (0, _lodash.debounce)(function (text) {
	    offsetRef.current = 0;
	    dispatch(_medicationsReq.actions.clear());
	
	    if (text.length < 3) return;
	    setMedicationQuery(text);
	    dispatch(_medicationsReq.actions.send({
	      userId: profile.id,
	      limit: 10,
	      query: text,
	      offset: offsetRef.current
	    }));
	  }, 1000);
	
	  var loadMore = (0, _react.useCallback)((0, _lodash.debounce)(function () {
	    dispatch(_medicationsReq.actions.loadMore({
	      userId: profile.id,
	      query: medicationQuery,
	      offset: offsetRef.current
	    }));
	    offsetRef.current += 10;
	  }, 100), [profile.id, medicationQuery]);
	
	  var renderMedicationSearch = (0, _react.useMemo)(function () {
	    return _react2.default.createElement(_SelectCustom2.default, {
	      multi: true,
	      options: medicationList,
	      placeholder: placeholder,
	      label: label,
	      defaultValue: value,
	      onMenuScrollToBottom: loadMore,
	      onInputChange: handleMedicationsSearch,
	      onCheckBeforeDelete: onCheckBeforeDelete,
	      onChange: onChange,
	      onBlur: handleBlur
	    });
	  }, [value, medicationList.length]);
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    renderMedicationSearch
	  );
	};
	
	MedicationSelect.propTypes = {
	  handleBlur: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onCheckBeforeDelete: _propTypes2.default.func,
	  placeholder: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  value: _propTypes2.default.array
	};
	
	exports.default = MedicationSelect;

/***/ }),
/* 3596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _recompose = __webpack_require__(22);
	
	var _MfaDialog = __webpack_require__(1132);
	
	var _MfaDialog2 = _interopRequireDefault(_MfaDialog);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _mfaEnable = __webpack_require__(879);
	
	var _mfaDisable = __webpack_require__(878);
	
	var _mfaConfirmations = __webpack_require__(681);
	
	var _selectors = __webpack_require__(56);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MfaSettings = function MfaSettings(_ref) {
	  var id = _ref.id,
	      intl = _ref.intl,
	      active = _ref.active,
	      resetMfa = _ref.resetMfa,
	      enableMfa = _ref.enableMfa,
	      disableMfa = _ref.disableMfa,
	      credential = _ref.credential,
	      sendMfaConfirmation = _ref.sendMfaConfirmation,
	      clearMfaConfirmation = _ref.clearMfaConfirmation;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      showConfirmDialog = _useState2[0],
	      setShowConfirmDialog = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      showMfaDialog = _useState4[0],
	      setShowMfaDialog = _useState4[1];
	
	  var formatMessage = intl.formatMessage;
	
	  var _useSelector = (0, _reactRedux.useSelector)(_selectors.getMfaConfirmationData),
	      mfaConfirmationData = _useSelector.data,
	      mfaConfirmationLoading = _useSelector.sending;
	
	  var _useSelector2 = (0, _reactRedux.useSelector)(_selectors.getEnableMfa),
	      error = _useSelector2.error,
	      enableMfaData = _useSelector2.data,
	      enableMfaLoading = _useSelector2.sending;
	
	  (0, _react.useEffect)(function () {
	    if (mfaConfirmationData) {
	      setShowMfaDialog(true);
	    }
	  }, [mfaConfirmationData]);
	
	  (0, _react.useEffect)(function () {
	    if (enableMfaData) {
	      handleCloseMfaModal();
	    }
	  }, [enableMfaData]);
	
	  var handleActivateMfa = function handleActivateMfa() {
	    sendMfaConfirmation({ login: credential });
	  };
	
	  var handleInActivateMfa = function handleInActivateMfa() {
	    disableMfa({ id: id });
	  };
	
	  var handleSendMfaCode = function handleSendMfaCode(code) {
	    enableMfa({ otp_confirmation: code, id: id });
	  };
	
	  var handleCloseMfaModal = function handleCloseMfaModal() {
	    setShowMfaDialog(false);
	    clearMfaConfirmation();
	    resetMfa();
	  };
	
	  return _react2.default.createElement(
	    'section',
	    { styleName: 'privacy-settings' },
	    _react2.default.createElement(
	      'h3',
	      { styleName: 'sectionTitle' },
	      formatMessage({ id: 'profile.section.mfaSettings' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'label', styleName: 'mfaField' },
	      formatMessage({
	        id: active ? 'profile.section.mfaSettings.label.active' : 'profile.section.mfaSettings.label.inActive'
	      }),
	      _react2.default.createElement(
	        'span',
	        { styleName: 'gray-text' },
	        ' (' + formatMessage({
	          id: 'profile.section.mfaSettings.label.helperText'
	        }) + ')'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'action' },
	      active ? _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'accent',
	          type: 'button',
	          disabled: mfaConfirmationLoading,
	          onClick: function onClick() {
	            return setShowConfirmDialog(true);
	          }
	        },
	        formatMessage({
	          id: 'profile.section.mfaSettings.button.inActivate'
	        })
	      ) : _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'accent',
	          type: 'button',
	          disabled: mfaConfirmationLoading,
	          onClick: handleActivateMfa
	        },
	        formatMessage({
	          id: 'profile.section.mfaSettings.button.activate'
	        })
	      )
	    ),
	    showMfaDialog && _react2.default.createElement(_MfaDialog2.default, {
	      open: showMfaDialog,
	      onClose: handleCloseMfaModal,
	      onSubmit: handleSendMfaCode,
	      mfaData: mfaConfirmationData,
	      error: error,
	      loading: enableMfaLoading
	    }),
	    showConfirmDialog && _react2.default.createElement(_ActionConfirmation2.default, {
	      intl: intl,
	      onSubmit: handleInActivateMfa,
	      onClose: function onClose() {
	        return setShowConfirmDialog(false);
	      },
	      opened: showConfirmDialog,
	      withHeading: false,
	      actionButtonText: formatMessage({
	        id: 'profile.section.mfaSettings.confirmModal.inActivate.button'
	      }),
	      content: _react2.default.createElement(
	        'h1',
	        { styleName: 'dialogTitle' },
	        formatMessage({
	          id: 'profile.section.mfaSettings.confirmModal.inActivate.title'
	        })
	      )
	    })
	  );
	};
	
	MfaSettings.propTypes = {
	  active: _propTypes2.default.bool,
	  credential: _propTypes2.default.string,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.number.isRequired]),
	  enableMfa: _propTypes2.default.func.isRequired,
	  disableMfa: _propTypes2.default.func.isRequired,
	  resetMfa: _propTypes2.default.func.isRequired,
	  sendMfaConfirmation: _propTypes2.default.func.isRequired,
	  clearMfaConfirmation: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(null, {
	  enableMfa: _mfaEnable.actions.send,
	  resetMfa: _mfaEnable.actions.clear,
	  disableMfa: _mfaDisable.actions.send,
	  sendMfaConfirmation: _mfaConfirmations.actions.send,
	  clearMfaConfirmation: _mfaConfirmations.actions.clear
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(MfaSettings);

/***/ }),
/* 3597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Field = __webpack_require__(778);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONFIRM_BUTTON_WIDTH = 168;
	
	var MobilePhoneConfirmation = (_temp2 = _class = function (_PureComponent) {
	  (0, _inherits3.default)(MobilePhoneConfirmation, _PureComponent);
	
	  function MobilePhoneConfirmation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MobilePhoneConfirmation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MobilePhoneConfirmation.__proto__ || (0, _getPrototypeOf2.default)(MobilePhoneConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      code: ''
	    }, _this.getChildContext = function () {
	      return {
	        intl: _this.props.intl
	      };
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MobilePhoneConfirmation, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          phone = _props.phone,
	          onConfirm = _props.onConfirm,
	          onCancel = _props.onCancel,
	          error = _props.error,
	          formatMessage = _props.intl.formatMessage;
	
	      var field = {
	        name: formatMessage(_strings.PROFILE.edit.confirmCode),
	        value: '',
	        fieldName: 'confirmationCode',
	        maxLength: 20
	      };
	      var fieldDescriptor = (0, _assign2.default)({}, field, {
	        value: this.state.code
	      });
	
	      return _react2.default.createElement(
	        'section',
	        { styleName: 'mobile-phone-confirmation' },
	        _react2.default.createElement(
	          'section',
	          null,
	          formatMessage(_strings.PROFILE.edit.phoneConfirmationText, { phone: phone })
	        ),
	        _react2.default.createElement(
	          'section',
	          { styleName: 'phone-confirmation-flex-wrapper' },
	          _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(_Field2.default, {
	              children: fieldDescriptor,
	              fieldStyle: { padding: 0 },
	              onChange: function onChange(code) {
	                return _this2.setState({ code: code });
	              },
	              editMode: true
	            })
	          ),
	          error ? _react2.default.createElement(_ErrorBlock2.default, {
	            className: 'mt3',
	            errors: formatMessage(_strings.PROFILE.edit.invalidCode)
	          }) : null,
	          _react2.default.createElement(
	            'section',
	            { className: 'mt3' },
	            _react2.default.createElement(_Button2.default, {
	              className: 'mr2',
	              children: formatMessage(_strings.PROFILE.edit.confirmCode),
	              style: { width: CONFIRM_BUTTON_WIDTH },
	              raised: true,
	              color: 'primary',
	              onClick: function onClick() {
	                return onConfirm(_this2.state.code);
	              }
	            }),
	            _react2.default.createElement(_Button2.default, {
	              children: formatMessage(_strings.COMMON.cancel),
	              raised: true,
	              color: 'accent',
	              onClick: onCancel
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return MobilePhoneConfirmation;
	}(_react.PureComponent), _class.childContextTypes = {
	  intl: _propTypes2.default.object
	}, _temp2);
	
	
	MobilePhoneConfirmation.propTypes = {
	  phone: _propTypes2.default.string,
	  onConfirm: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func,
	  error: _propTypes2.default.any,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _reactCssModules2.default)(MobilePhoneConfirmation, _index2.default);

/***/ }),
/* 3598 */,
/* 3599 */,
/* 3600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _getLabel = __webpack_require__(3650);
	
	var _getLabel2 = _interopRequireDefault(_getLabel);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var labelStyle = {
	  color: _styles.COLORS.grayDark,
	  fontSize: 14
	};
	
	var checkboxStyle = {
	  marginBottom: 12
	};
	
	var fieldWrapperStyle = {
	  flexDirection: 'column',
	  alignItems: 'flex-start'
	};
	
	var NotificationSettings = function NotificationSettings(_ref) {
	  var settings = _ref.settings,
	      _onChange = _ref.onChange,
	      formatMessage = _ref.intl.formatMessage;
	  return _react2.default.createElement(
	    'section',
	    { styleName: 'notification-settings' },
	    _react2.default.createElement(
	      'h3',
	      { styleName: 'sectionTitle' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.PROFILE.notificationSettings.title)
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'fieldWrapper', style: fieldWrapperStyle },
	      settings.map(function (_ref2) {
	        var type = _ref2.type,
	            value = _ref2.value,
	            enabled = _ref2.enabled;
	        return _react2.default.createElement(_Checkbox2.default, {
	          key: type,
	          id: type,
	          size: 14,
	          checked: enabled,
	          label: (0, _getLabel2.default)(type, value, formatMessage),
	          labelStyle: labelStyle,
	          style: checkboxStyle,
	          onChange: function onChange(val) {
	            return _onChange(type, val);
	          }
	        });
	      })
	    )
	  );
	};
	
	NotificationSettings.propTypes = {
	  settings: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    type: _propTypes2.default.string,
	    value: _propTypes2.default.string,
	    enabled: _propTypes2.default.bool
	  })),
	  onChange: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(NotificationSettings, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(50);
	
	var _editPatient = __webpack_require__(218);
	
	var _editPatientByProvider = __webpack_require__(423);
	
	var _setPreferredPharmacyReq = __webpack_require__(532);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: (0, _selectors.targetUserSelector)(state),
	    canEdit: (0, _selectors.canEditPatient)(state),
	    canEditPatient: (0, _selectors.canEditNotJoinedPatient)(state),
	    medicationAllergiesList: (0, _selectors2.selectMedicationAllergies)(state),
	    healthConditionsList: (0, _selectors2.selectHealthConditions)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  savePatient: _editPatient.actions.send,
	  savePatientByProvider: _editPatientByProvider.actions.send,
	  savePreferredPharmacy: _setPreferredPharmacyReq.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FieldSetList = __webpack_require__(334);
	
	var _FieldSetList2 = _interopRequireDefault(_FieldSetList);
	
	var _InsuranceDetails = __webpack_require__(3591);
	
	var _InsuranceDetails2 = _interopRequireDefault(_InsuranceDetails);
	
	var _getInfoFieldset = __webpack_require__(1795);
	
	var _enhance = __webpack_require__(3601);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _gtag = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PatientInfo = function (_Component) {
	  (0, _inherits3.default)(PatientInfo, _Component);
	
	  function PatientInfo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PatientInfo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PatientInfo.__proto__ || (0, _getPrototypeOf2.default)(PatientInfo)).call.apply(_ref, [this].concat(args))), _this), _this.saveUser = function (data) {
	      var _this$props = _this.props,
	          canEditPatient = _this$props.canEditPatient,
	          savePatientByProvider = _this$props.savePatientByProvider,
	          savePatient = _this$props.savePatient,
	          savePreferredPharmacy = _this$props.savePreferredPharmacy,
	          profile = _this$props.profile;
	
	
	      switch (true) {
	        case canEditPatient:
	          savePatientByProvider((0, _extends3.default)({}, data));
	          break;
	        case Boolean(data.pharmacy):
	          if (data.pharmacy.id) {
	            savePreferredPharmacy({
	              pharmacyId: data.pharmacy.id,
	              userId: profile.id
	            });
	          }
	          break;
	        default:
	          savePatient((0, _extends3.default)({}, data));
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PatientInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _gtag.GATrackPageView)('Profile | Patient Info');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          profile = _props.profile,
	          canEdit = _props.canEdit;
	      var primaryPatientProfile = profile.primaryPatientProfile;
	
	      var _ref2 = primaryPatientProfile || {},
	          id = _ref2.id;
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'content content--profile content--info' },
	        _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.profile.patientInfo' }),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'info' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'common' },
	            _react2.default.createElement(_InsuranceDetails2.default, null),
	            _react2.default.createElement(_FieldSetList2.default, {
	              fieldSetList: (0, _getInfoFieldset.getPatientInfoFieldsetList)(this.props),
	              onSave: function onSave(data) {
	                return _this2.saveUser((0, _extends3.default)({}, data, { id: id }));
	              },
	              disabled: !canEdit,
	              canEdit: canEdit
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return PatientInfo;
	}(_react.Component);
	
	PatientInfo.propTypes = {
	  canEdit: _propTypes2.default.bool,
	  canEditPatient: _propTypes2.default.bool,
	  savePatient: _propTypes2.default.func,
	  savePatientByProvider: _propTypes2.default.func,
	  profile: _propTypes2.default.object,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  savePreferredPharmacy: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(PatientInfo);

/***/ }),
/* 3603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(56);
	
	var _selectors3 = __webpack_require__(50);
	
	var _editPatient = __webpack_require__(218);
	
	var _editUser = __webpack_require__(136);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: (0, _selectors.targetUserSelector)(state),
	    rawGenderList: (0, _selectors3.selectGenderTypes)(state),
	    rawMaritalStatusList: (0, _selectors3.selectMaritalStatus)(state),
	    languageList: (0, _selectors3.selectLanguageTypes)(state),
	    nameSuffixList: (0, _selectors3.selectNameSuffixesList)(state),
	    canEdit: (0, _selectors.canEditPatient)(state),
	    canEditPatient: (0, _selectors.canEditNotJoinedPatient)(state),
	    profileEditable: (0, _selectors2.selectProfileEditable)(state),
	    countryList: (0, _selectors3.selectCountryOptions)(state),
	    isSucceedUpdate: (0, _selectors2.selectEditedUserSucceed)(state),
	    isSucceedPatientUpdate: (0, _selectors2.selectEditPatientSuccess)(state),
	    rawRaceList: (0, _selectors3.selectRaceTypes)(state),
	    rawEthnicityList: (0, _selectors3.selectEthnicTypes)(state),
	    relationList: (0, _selectors3.selectRelationList)(state),
	    rawGenderIdentityList: (0, _selectors3.selectGenderIdentityList)(state),
	    veteranStatusesList: (0, _selectors3.selectVeteranStatusesList)(state),
	    educationLevelsList: (0, _selectors3.selectEducationLevelsList)(state),
	    citizenship: (0, _selectors3.selectCitizinship)(state),
	    ssnHidingEnabled: (0, _selectors3.selectSsnHidingEnabled)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  savePatient: _editPatient.actions.send,
	  saveUser: _editUser.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var profileErrors = _ref.profileErrors;
	
	  return { errors: (0, _get2.default)(profileErrors, 'meta.validationErrors') };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getContactConditions = __webpack_require__(1794);
	
	var _ContactInfoSection = __webpack_require__(1786);
	
	var _ContactInfoSection2 = _interopRequireDefault(_ContactInfoSection);
	
	var _HomeAddress = __webpack_require__(1790);
	
	var _enhance = __webpack_require__(3603);
	
	var _getPhone = __webpack_require__(187);
	
	var _EmergencyContact = __webpack_require__(3576);
	
	var _EmergencyContact2 = _interopRequireDefault(_EmergencyContact);
	
	var _constants = __webpack_require__(17);
	
	var _FieldSetList = __webpack_require__(334);
	
	var _FieldSetList2 = _interopRequireDefault(_FieldSetList);
	
	var _deepTrim = __webpack_require__(357);
	
	var _deepTrim2 = _interopRequireDefault(_deepTrim);
	
	var _getFieldset = __webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PatientProfile = function PatientProfile(props) {
	  var profile = props.profile,
	      canEdit = props.canEdit,
	      saveUser = props.saveUser,
	      savePatient = props.savePatient,
	      canEditPatient = props.canEditPatient,
	      formatMessage = props.intl.formatMessage,
	      countryList = props.countryList,
	      isSucceedUpdate = props.isSucceedUpdate,
	      relationList = props.relationList,
	      profileEditable = props.profileEditable,
	      isSucceedPatientUpdate = props.isSucceedPatientUpdate;
	  var id = profile.id,
	      email = profile.email,
	      phoneNumber = profile.phoneNumber,
	      primaryContactsEnabled = profile.primaryContactsEnabled;
	
	  var _getContactsCondition = (0, _getContactConditions.getContactsConditions)(profile, canEditPatient),
	      showEmail = _getContactsCondition.showEmail,
	      showPhoneNumber = _getContactsCondition.showPhoneNumber;
	
	  var handleSave = function handleSave(data, type) {
	    if (type === _constants.PROFILE_SECTIONS.EMERGENCY_CONTACT) {
	      return;
	    }
	    // exclude ssn, because it's with *
	    var checkedData = (0, _deepTrim2.default)(profileEditable ? data : (0, _omit2.default)(data, ['ssn']));
	
	    saveUser((0, _extends3.default)({}, checkedData, { id: id }));
	  };
	
	  var isEditable = canEdit || canEditPatient;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_ContactInfoSection2.default, {
	      canEdit: canEdit || primaryContactsEnabled,
	      email: showEmail ? email : null,
	      phoneNumber: showPhoneNumber ? (0, _getPhone.getPhoneWithoutUSCode)(phoneNumber) : null
	    }),
	    _react2.default.createElement(_FieldSetList2.default, {
	      fieldSetList: (0, _getFieldset.getPatientFieldsetList)(props),
	      onSave: handleSave,
	      disabled: !isEditable,
	      canEdit: isEditable
	    }),
	    _react2.default.createElement(_EmergencyContact2.default, {
	      profile: profile,
	      canEdit: canEdit,
	      savePatient: savePatient,
	      relationList: relationList,
	      formatMessage: formatMessage,
	      isSucceedUpdate: isSucceedPatientUpdate
	    }),
	    _react2.default.createElement(_HomeAddress.HomeAddress, {
	      formatMessage: formatMessage,
	      profile: profile,
	      canEdit: canEdit,
	      countryList: countryList,
	      saveUser: saveUser,
	      isSucceedUpdate: isSucceedUpdate
	    })
	  );
	};
	
	PatientProfile.propTypes = {
	  profile: _propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    email: _propTypes2.default.string,
	    emailFake: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	    phoneNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    weight: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  savePatient: _propTypes2.default.func,
	  saveUser: _propTypes2.default.func,
	  canEdit: _propTypes2.default.bool,
	  canEditPatient: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  countryList: _propTypes2.default.array,
	  profileEditable: _propTypes2.default.bool,
	  isSucceedUpdate: _propTypes2.default.bool,
	  relationList: _propTypes2.default.array,
	  isSucceedPatientUpdate: _propTypes2.default.bool,
	  // eslint-disable-next-line react/no-unused-prop-types
	  ssnHidingEnabled: _propTypes2.default.bool
	};
	
	exports.default = (0, _enhance.enhance)(PatientProfile);

/***/ }),
/* 3605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _pharmacyReq = __webpack_require__(628);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PharmacyPopup = __webpack_require__(759);
	
	var _PharmacyPopup2 = _interopRequireDefault(_PharmacyPopup);
	
	var _styles = __webpack_require__(5084);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _makePharmacyTitle = __webpack_require__(311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PreferredPharmacy = function PreferredPharmacy(_ref) {
	  var value = _ref.value,
	      placeholder = _ref.placeholder,
	      label = _ref.label,
	      onChange = _ref.onChange,
	      onHandleBlur = _ref.onHandleBlur,
	      limit = _ref.limit,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(value),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      pharmacy = _useState4[0],
	      setPharmacy = _useState4[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var togglePopupHandle = function togglePopupHandle() {
	    setIsOpen(function (current) {
	      return !current;
	    });
	    dispatch(_pharmacyReq.actions.clear());
	  };
	
	  var handlePharmacy = function handlePharmacy(incomePharmacy) {
	    if (incomePharmacy) {
	      onChange(incomePharmacy);
	      setPharmacy((0, _makePharmacyTitle.makePharmacyTitle)(incomePharmacy, true));
	    }
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.wrapper },
	      _react2.default.createElement(_TextInput2.default, {
	        autoresize: true,
	        value: pharmacy,
	        placeholder: placeholder,
	        label: label,
	        type: 'text',
	        textarea: true,
	        onChange: onChange,
	        onBlur: onHandleBlur,
	        limit: limit,
	        className: _styles2.default.textarea,
	        disabled: true
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          raised: true,
	          color: 'accent',
	          className: _styles2.default.button,
	          onClick: togglePopupHandle
	        },
	        formatMessage({ id: 'appointments.form.changePharmacy' })
	      )
	    ),
	    isOpen && _react2.default.createElement(_PharmacyPopup2.default, {
	      isOpen: isOpen,
	      onClose: togglePopupHandle,
	      setPharmacy: handlePharmacy
	    })
	  );
	};
	
	PreferredPharmacy.propTypes = {
	  onHandleBlur: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  placeholder: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  value: _propTypes2.default.string,
	  limit: _propTypes2.default.number,
	  intl: _propTypes2.default.object
	};
	
	exports.default = (0, _reactIntl.injectIntl)(PreferredPharmacy);

/***/ }),
/* 3606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _styles = __webpack_require__(18);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var labelStyle = {
	  color: _styles.COLORS.grayDark,
	  fontSize: 14
	};
	
	var checkboxStyle = {
	  marginBottom: 12
	};
	
	var fieldWrapperStyle = {
	  flexDirection: 'column',
	  alignItems: 'flex-start'
	};
	
	var PrivacySettings = function PrivacySettings(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      onChange = _ref.onChange,
	      hidden = _ref.hidden;
	
	  var privacyLabel = _react2.default.createElement(
	    'span',
	    null,
	    formatMessage({ id: 'profile.privacySettings.labels.nickname' }),
	    _react2.default.createElement(
	      'span',
	      { styleName: 'gray-text' },
	      formatMessage({ id: 'profile.privacySettings.labels.nicknameExtra' })
	    )
	  );
	
	  return _react2.default.createElement(
	    'section',
	    { styleName: 'privacy-settings' },
	    _react2.default.createElement(
	      'h3',
	      { styleName: 'sectionTitle' },
	      formatMessage({ id: 'profile.section.privacySettings' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'fieldWrapper', style: fieldWrapperStyle },
	      _react2.default.createElement(_Checkbox2.default, {
	        id: 'hidden',
	        size: 14,
	        checked: hidden,
	        label: privacyLabel,
	        labelStyle: labelStyle,
	        style: checkboxStyle,
	        onChange: onChange
	      })
	    )
	  );
	};
	
	PrivacySettings.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  hidden: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(PrivacySettings, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (fields, errors) {
	  if (!errors) return null;
	
	  // check if we have errors for fields
	  var hasErrors = fields.find(function (item) {
	    return (0, _get2.default)(errors, [(0, _get2.default)(item, 'fieldName', '')]);
	  });
	
	  if (!hasErrors) return null;
	
	  var checkedErrors = [];
	
	  // get translation for error
	  (0, _keys2.default)(errors).forEach(function (item) {
	    var code = (0, _get2.default)(errors, '[' + item + '][0].code');
	    var error = (0, _get2.default)(_strings.PROFILE.errors, '[' + item + '][' + code + ']');
	    if (error) checkedErrors.push(error);
	  });
	
	  return checkedErrors.length ? checkedErrors : null;
	};

/***/ }),
/* 3608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(56);
	
	var _selectors3 = __webpack_require__(50);
	
	var _editUser = __webpack_require__(136);
	
	var _editPatientByProvider = __webpack_require__(423);
	
	var _editAvatar = __webpack_require__(873);
	
	var _changeSettings = __webpack_require__(538);
	
	var _reqSocialChannel = __webpack_require__(295);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: (0, _selectors.targetUserSelector)(state),
	    isProfileFetching: state.profiles.getUser.sending,
	    editUserSending: (0, _selectors2.selectEditedUserSending)(state),
	    editUserErrors: (0, _selectors2.selectEditedUserErrors)(state),
	    healthInterestsList: (0, _selectors3.selectHealthInterestsList)(state),
	    canEdit: (0, _selectors.canEditPatient)(state),
	    canEditOwnPatient: (0, _selectors.canEditNotJoinedPatient)(state),
	    loggedUserId: (0, _selectors.loggedUserIdSelector)(state),
	    loggedUserCountry: (0, _selectors.loggedUserCountrySelector)(state),
	    isLoggedUser: (0, _selectors.isLoggedUserSelector)(state),
	    isDependent: (0, _selectors.selectIsVerifiedDependentRole)(state),
	    showOwnProviderProfile: (0, _selectors.selectShowOwnProviderProfile)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  saveUser: _editUser.actions.send,
	  savePatientByProvider: _editPatientByProvider.actions.send,
	  saveAvatar: _editAvatar.actions.send,
	  saveSettings: _changeSettings.actions.send,
	  saveUserRequestClear: _editUser.actions.clear,
	  createSocialChat: _reqSocialChannel.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var editUserErrors = _ref.editUserErrors;
	
	  return { errors: (0, _get2.default)(editUserErrors, 'meta.validationErrors') };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _FieldSetList = __webpack_require__(334);
	
	var _FieldSetList2 = _interopRequireDefault(_FieldSetList);
	
	var _ConversationBtn = __webpack_require__(1787);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _getFieldset = __webpack_require__(611);
	
	var _chat = __webpack_require__(67);
	
	var _enhance = __webpack_require__(3608);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _gtag = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * TODO: move static strings to constants
	 */
	var Profile = function (_Component) {
	  (0, _inherits3.default)(Profile, _Component);
	
	  function Profile() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Profile);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Profile.__proto__ || (0, _getPrototypeOf2.default)(Profile)).call.apply(_ref, [this].concat(args))), _this), _this.handleAvatarChange = function (newAvatarFormData) {
	      window.storage.setItem('edit-avatar-user-id', _this.props.profile.id);
	      _this.props.saveAvatar(newAvatarFormData);
	    }, _this.handleAvatarRemove = function () {
	      _this.props.saveUser({
	        id: _this.props.profile.id,
	        removeAvatar: true
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Profile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _gtag.GATrackPageView)('Profile | Details');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          saveUser = _props.saveUser,
	          healthInterestsList = _props.healthInterestsList,
	          profile = _props.profile,
	          editUserSending = _props.editUserSending,
	          errors = _props.errors,
	          canEdit = _props.canEdit,
	          canEditOwnPatient = _props.canEditOwnPatient,
	          formatMessage = _props.intl.formatMessage,
	          saveUserRequestClear = _props.saveUserRequestClear,
	          loggedUserId = _props.loggedUserId;
	      var id = profile.id,
	          avatar = profile.avatar,
	          username = profile.username,
	          primaryPatientProfile = profile.primaryPatientProfile,
	          primaryProviderProfile = profile.primaryProviderProfile,
	          status = profile.status,
	          displayableName = profile.displayableName,
	          teamActingUser = profile.teamActingUser;
	
	      var _ref2 = avatar || {},
	          thumbMiddle = _ref2.thumbMiddle;
	
	      var nestedProfile = primaryPatientProfile || primaryProviderProfile || {};
	      var hasActiveProfile = !status || status === 'joined';
	
	      var firstName = nestedProfile.firstName;
	
	
	      var fieldOptions = (0, _extends3.default)({}, profile, {
	        errors: errors,
	        healthInterestsList: healthInterestsList,
	        hasActiveProfile: hasActiveProfile,
	        canEditOwnPatient: canEditOwnPatient
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'content user-profile-content' },
	        _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.profile.details' }),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'userAvatar', className: 'user-profile-avatar' },
	          _react2.default.createElement(_Avatar2.default, {
	            editable: canEdit,
	            src: thumbMiddle,
	            children: firstName || displayableName,
	            onChange: this.handleAvatarChange,
	            onRemove: this.handleAvatarRemove,
	            loading: editUserSending,
	            size: 96
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'info' },
	          _react2.default.createElement(
	            'div',
	            {
	              styleName: 'userName',
	              className: (0, _classnames2.default)('pb3 flex', {
	                'items-center justify-between': (0, _mobileHelpers.isDesktop)(),
	                'flex-column': !(0, _mobileHelpers.isDesktop)()
	              })
	            },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                teamActingUser && _react2.default.createElement(_Icon2.default, { name: 'team', size: 24, className: 'mr2 mb1' }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'user-profile-name mr1' },
	                  displayableName
	                )
	              ),
	              username && hasActiveProfile && !teamActingUser && _react2.default.createElement(
	                'span',
	                {
	                  styleName: 'colored user-profile-username',
	                  className: 'user-profile-username'
	                },
	                username
	              )
	            ),
	            loggedUserId !== id && !teamActingUser && _chat.ALLOW_SOCIAL_CHAT_CREATION && _react2.default.createElement(_ConversationBtn.ConversationBtn, { userId: id })
	          ),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'user-profile-common' },
	            _react2.default.createElement(_FieldSetList2.default, {
	              fieldSetList: (0, _getFieldset.getProfileFieldsetList)(teamActingUser, fieldOptions, formatMessage),
	              onSave: function onSave(data) {
	                return saveUser((0, _extends3.default)({}, data, { id: id }));
	              },
	              disabled: !canEdit,
	              onCancelCallback: saveUserRequestClear,
	              canEdit: canEdit
	            })
	          ),
	          children
	        )
	      );
	    }
	  }]);
	  return Profile;
	}(_react.Component);
	
	Profile.propTypes = {
	  profile: _propTypes2.default.object,
	  saveUser: _propTypes2.default.func,
	  editUserSending: _propTypes2.default.bool,
	  errors: _propTypes2.default.object,
	  healthInterestsList: _propTypes2.default.array,
	  children: _propTypes2.default.node,
	  canEdit: _propTypes2.default.bool,
	  canEditOwnPatient: _propTypes2.default.bool,
	  saveAvatar: _propTypes2.default.func,
	  saveUserRequestClear: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  loggedUserId: _propTypes2.default.number
	};
	
	exports.default = (0, _enhance.enhance)(Profile);

/***/ }),
/* 3610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5085);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imagesTypesList = ['jpg', 'png', 'jpeg'];
	
	var AttachmentItem = function AttachmentItem(_ref) {
	  var data = _ref.data,
	      onDelete = _ref.onDelete;
	
	  var _ref2 = data || {},
	      id = _ref2.id,
	      uniqId = _ref2.uniqId,
	      type = _ref2.type,
	      name = _ref2.name,
	      link = _ref2.link,
	      extension = _ref2.extension,
	      category = _ref2.category,
	      subcategory = _ref2.subcategory;
	
	  var isImage = imagesTypesList.includes(extension);
	
	  var handleOpenDocument = function handleOpenDocument() {
	    return window.open(link);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.documentWrapper, onClick: handleOpenDocument },
	      isImage ? _react2.default.createElement('img', { className: _index2.default.image, src: link, alt: name }) : _react2.default.createElement(_Icon2.default, { name: 'icon-document-black', size: 32, className: _index2.default.icon }),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.fileTitle },
	          name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.fileCategory },
	          category.name + ', ' + subcategory.name
	        )
	      )
	    ),
	    _react2.default.createElement(_Icon2.default, {
	      size: 16,
	      name: 'remove-member',
	      className: _index2.default.removeIcon,
	      onClick: function onClick() {
	        return onDelete({ id: id, uniqId: uniqId, type: type });
	      }
	    })
	  );
	};
	
	AttachmentItem.propTypes = {
	  data: _propTypes2.default.object,
	  onDelete: _propTypes2.default.func
	};
	
	exports.default = (0, _react.memo)(AttachmentItem);

/***/ }),
/* 3611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _deleteActions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _AttachmentItem = __webpack_require__(3610);
	
	var _AttachmentItem2 = _interopRequireDefault(_AttachmentItem);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _index = __webpack_require__(17);
	
	var _selectors = __webpack_require__(56);
	
	var _getUserAttachment = __webpack_require__(877);
	
	var _deleteUserAttachment = __webpack_require__(871);
	
	var _deleteUserOutcomeAttachment = __webpack_require__(872);
	
	var _index2 = __webpack_require__(5086);
	
	var _index3 = _interopRequireDefault(_index2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DOCUMENTS = _index.PATIENT_ATTACHMENTS_TYPE.DOCUMENTS,
	    OUTCOME_ATTACHMENTS = _index.PATIENT_ATTACHMENTS_TYPE.OUTCOME_ATTACHMENTS;
	
	
	var deleteActions = (_deleteActions = {}, (0, _defineProperty3.default)(_deleteActions, DOCUMENTS, _deleteUserAttachment.actions), (0, _defineProperty3.default)(_deleteActions, OUTCOME_ATTACHMENTS, _deleteUserOutcomeAttachment.actions), _deleteActions);
	
	var ProfileDocumentation = function ProfileDocumentation(_ref) {
	  var userId = _ref.userId,
	      formatMessage = _ref.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      openModal = _useState2[0],
	      toggleOpenModal = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      targetDocumentData = _useState4[0],
	      setTargetDocumentData = _useState4[1];
	
	  var attachments = (0, _reactRedux.useSelector)(_selectors.selectUserAttachmentsList);
	  var hasAttachments = Boolean(attachments.length);
	
	  var openActionConfirmationModal = function openActionConfirmationModal(data) {
	    setTargetDocumentData(data);
	    toggleOpenModal(true);
	  };
	
	  var getAttachments = function getAttachments() {
	    return dispatch(_getUserAttachment.actions.send({ userId: userId }));
	  };
	
	  var clearAttachments = function clearAttachments() {
	    return dispatch(_getUserAttachment.actions.clear());
	  };
	
	  var deleteAttachment = function deleteAttachment() {
	    var _ref2 = targetDocumentData || {},
	        id = _ref2.id,
	        uniqId = _ref2.uniqId,
	        type = _ref2.type;
	
	    var deleteAction = deleteActions[type];
	
	    dispatch(deleteAction.send({
	      id: id,
	      type: type,
	      uniqId: uniqId,
	      userId: userId
	    }));
	  };
	
	  (0, _react.useEffect)(function () {
	    getAttachments();
	    return function () {
	      return clearAttachments();
	    };
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index3.default.wrapper },
	    _react2.default.createElement(
	      'span',
	      { className: _index3.default.sectionTitle },
	      formatMessage({ id: 'documentation.attached.title' })
	    ),
	    !hasAttachments && _react2.default.createElement(
	      'div',
	      null,
	      '-'
	    ),
	    hasAttachments && attachments.map(function (file) {
	      return _react2.default.createElement(_AttachmentItem2.default, {
	        data: file,
	        key: file.id,
	        onDelete: openActionConfirmationModal
	      });
	    }),
	    _react2.default.createElement(_ActionConfirmation2.default, {
	      width: 'xsmall',
	      opened: openModal,
	      mobileFullScreen: false,
	      onSubmit: deleteAttachment,
	      onClose: function onClose() {
	        return toggleOpenModal(false);
	      },
	      actionButtonText: formatMessage({
	        id: 'common.delete'
	      }),
	      title: formatMessage({
	        id: 'appointment.documents.deleteMessage'
	      })
	    })
	  );
	};
	
	ProfileDocumentation.propTypes = {
	  userId: _propTypes2.default.number,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = (0, _react.memo)(ProfileDocumentation);

/***/ }),
/* 3612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(56);
	
	var _index = __webpack_require__(5087);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _RenderViewConsents = __webpack_require__(1793);
	
	var _RenderViewConsents2 = _interopRequireDefault(_RenderViewConsents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Consents = function Consents(_ref) {
	  var formatMessage = _ref.formatMessage;
	
	  var allConsents = (0, _reactRedux.useSelector)(_selectors.selectUserSignedConsents);
	  var hasConsentsForm = Boolean(allConsents.length);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.sectionTitle },
	      formatMessage({ id: 'appointment.consent.title' })
	    ),
	    hasConsentsForm ? allConsents.map(function (_ref2) {
	      var organization = _ref2.organization,
	          consents = _ref2.consents;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _index2.default.content, key: organization.id },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.organizationName },
	          organization.name
	        ),
	        _react2.default.createElement(_RenderViewConsents2.default, {
	          consentsList: consents,
	          formatMessage: formatMessage
	        })
	      );
	    }) : '-'
	  );
	};
	
	Consents.propTypes = {
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = (0, _react.memo)(Consents);

/***/ }),
/* 3613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _RenderViewConsents = __webpack_require__(1793);
	
	var _RenderViewConsents2 = _interopRequireDefault(_RenderViewConsents);
	
	var _selectors = __webpack_require__(56);
	
	var _index = __webpack_require__(5088);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaperConsents = function PaperConsents(_ref) {
	  var formatMessage = _ref.formatMessage;
	
	  var paperConsents = (0, _reactRedux.useSelector)(_selectors.selectUserPaperConsents);
	  var hasPaperConsents = Boolean(paperConsents.length);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    _react2.default.createElement(
	      'span',
	      { className: _index2.default.sectionTitle },
	      formatMessage({ id: 'documentation.paperConsents.title' })
	    ),
	    hasPaperConsents ? _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(_RenderViewConsents2.default, {
	        consentsList: paperConsents,
	        formatMessage: formatMessage
	      })
	    ) : _react2.default.createElement(
	      'div',
	      null,
	      '-'
	    )
	  );
	};
	
	PaperConsents.propTypes = {
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = PaperConsents;

/***/ }),
/* 3614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getConsentStatus = undefined;
	
	var _consentStatus = __webpack_require__(1851);
	
	var _utils = __webpack_require__(78);
	
	var DATE_FORMAT = 'MMM D, Y';
	
	var getConsentStatus = exports.getConsentStatus = function getConsentStatus(_ref) {
	  var status = _ref.status,
	      expiresAt = _ref.expiresAt,
	      formatMessage = _ref.formatMessage,
	      statusChangedAt = _ref.statusChangedAt;
	
	  var statusText = formatMessage(status ? { id: _consentStatus.CONSENT_STATUS_MAPPER[status] } : { id: 'documentation.consent.active' });
	
	  return status === _consentStatus.CONSENT_STATUS.ACTIVE ? statusText + '. Expiring on ' + (0, _utils.formatDate)(expiresAt, DATE_FORMAT) : statusText + ' on ' + (0, _utils.formatDate)(statusChangedAt, DATE_FORMAT);
	};

/***/ }),
/* 3615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(3614);
	
	var _consentStatus = __webpack_require__(1851);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5089);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViewConsent = function ViewConsent(_ref) {
	  var name = _ref.name,
	      status = _ref.status,
	      version = _ref.version,
	      fileUrl = _ref.fileUrl,
	      expiresAt = _ref.expiresAt,
	      programName = _ref.programName,
	      formatMessage = _ref.formatMessage,
	      statusChangedAt = _ref.statusChangedAt,
	      consentTypeTitle = _ref.consentTypeTitle,
	      consentAssignmentType = _ref.consentAssignmentType;
	
	  var consentVersionTitle = formatMessage({
	    id: 'appointment.consent.consentVersion'
	  });
	
	  var paperConsentTitle = formatMessage({
	    id: 'appointment.consent.paper'
	  });
	
	  var isPaperConsent = consentAssignmentType === _consentStatus.CONSENT_ASSIGNMENT_TYPE.PAPER_CONSENT;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.consentItem, onClick: function onClick() {
	        return window.open(fileUrl);
	      } },
	    _react2.default.createElement(_Icon2.default, { name: 'icon-document-black', size: 32, className: _index2.default.icon }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.consentInfoWrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.consentTitle },
	        name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.consentSubtitleRow },
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.consentSubTitle },
	          consentTypeTitle + ', ' + (isPaperConsent ? paperConsentTitle : consentVersionTitle + ' ' + version)
	        ),
	        programName && _react2.default.createElement(
	          'div',
	          { className: _index2.default.consentSubTitle },
	          formatMessage({ id: 'common.program' }),
	          ': ',
	          programName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _index2.default.consentSubTitle },
	          (0, _helpers.getConsentStatus)({
	            status: status,
	            expiresAt: expiresAt,
	            formatMessage: formatMessage,
	            statusChangedAt: statusChangedAt
	          })
	        )
	      )
	    )
	  );
	};
	
	ViewConsent.propTypes = {
	  name: _propTypes2.default.string,
	  status: _propTypes2.default.string,
	  version: _propTypes2.default.number,
	  fileUrl: _propTypes2.default.string,
	  expiresAt: _propTypes2.default.string,
	  formatMessage: _propTypes2.default.func,
	  programName: _propTypes2.default.string,
	  statusChangedAt: _propTypes2.default.string,
	  consentTypeTitle: _propTypes2.default.string,
	  consentAssignmentType: _propTypes2.default.string
	};
	
	exports.default = (0, _react.memo)(ViewConsent);

/***/ }),
/* 3616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _getUserDocuments = __webpack_require__(425);
	
	var _updateUserDocuments = __webpack_require__(540);
	
	var _uploadUserDocuments = __webpack_require__(429);
	
	var _deleteUserDocuments = __webpack_require__(422);
	
	var _selectors = __webpack_require__(56);
	
	var _selectors2 = __webpack_require__(23);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    userId: (0, _selectors2.targetUserIdSelector)(state),
	    isLoading: (0, _selectors.selectDocumentsPageLoading)(state),
	    userDocuments: (0, _selectors.selectUserDocumentsList)(state),
	    canEdit: (0, _selectors2.isLoggedUserSelector)(state) || (0, _selectors2.selectIsVerifiedDependentRole)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  getDocuments: _getUserDocuments.actions.send,
	  clearDocuments: _getUserDocuments.actions.clear,
	  uploadDocuments: _uploadUserDocuments.actions.send,
	  updateDocuments: _updateUserDocuments.actions.send,
	  deleteDocuments: _deleteUserDocuments.actions.send,
	  deleteDocumentItem: _getUserDocuments.actions.deleteItem
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Attachments = __webpack_require__(3611);
	
	var _Attachments2 = _interopRequireDefault(_Attachments);
	
	var _Consents = __webpack_require__(3612);
	
	var _Consents2 = _interopRequireDefault(_Consents);
	
	var _PaperConsents = __webpack_require__(3613);
	
	var _PaperConsents2 = _interopRequireDefault(_PaperConsents);
	
	var _enhance = __webpack_require__(3616);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileDocumentation = function ProfileDocumentation(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      isLoading = _ref.isLoading,
	      userId = _ref.userId;
	
	  (0, _usePageView.usePageView)('Profile | Documentation');
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'content content--info' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.profile.documents' }),
	    _react2.default.createElement(
	      'div',
	      {
	        styleName: (0, _classnames2.default)('info info--docs', {
	          'info--disabled': isLoading
	        })
	      },
	      isLoading ? _react2.default.createElement(_Loader2.default, { className: 'g-centeredAll' }) : null,
	      _react2.default.createElement(_Consents2.default, { formatMessage: formatMessage }),
	      _react2.default.createElement(_PaperConsents2.default, { formatMessage: formatMessage }),
	      _react2.default.createElement(_Attachments2.default, { userId: userId, formatMessage: formatMessage })
	    )
	  );
	};
	
	ProfileDocumentation.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  isLoading: _propTypes2.default.bool,
	  userId: _propTypes2.default.number
	};
	
	exports.default = (0, _enhance.enhance)(ProfileDocumentation);

/***/ }),
/* 3618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(5091);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyOrganizationsState = function EmptyOrganizationsState() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var title = formatMessage({
	    id: 'profile.payment.onlyForOrganizationMessage'
	  });
	
	  return _react2.default.createElement(
	    'section',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_Icon2.default, { name: 'card-search', width: '60', height: '60', className: _stylesModule2.default.icon }),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.title },
	      title
	    )
	  );
	};
	
	exports.default = EmptyOrganizationsState;

/***/ }),
/* 3619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _index = __webpack_require__(5092);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptyState = function EmptyState() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.container },
	    _react2.default.createElement(_Icon2.default, { name: 'card-search', width: '60', height: '60' }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.title },
	      formatMessage({ id: 'profile.payment.noSavedPaymentMethods' })
	    )
	  );
	};
	
	exports.default = EmptyState;

/***/ }),
/* 3620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _debounce = __webpack_require__(176);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _MenuList = __webpack_require__(1819);
	
	var _MenuList2 = _interopRequireDefault(_MenuList);
	
	var _OptionLabel = __webpack_require__(1820);
	
	var _OptionLabel2 = _interopRequireDefault(_OptionLabel);
	
	var _organizationsReq = __webpack_require__(1320);
	
	var _locationsReq = __webpack_require__(1319);
	
	var _selectors = __webpack_require__(869);
	
	var _accountVaultsForm = __webpack_require__(354);
	
	var _popup = __webpack_require__(76);
	
	var _props = __webpack_require__(41);
	
	var _selectors2 = __webpack_require__(23);
	
	var _mapListItemToOption = __webpack_require__(3621);
	
	var _index = __webpack_require__(5093);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrganizationPopup = function OrganizationPopup(_ref) {
	  var opened = _ref.opened,
	      onClose = _ref.onClose;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      selectedOrganization = _useState2[0],
	      setSelectedOrganization = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      selectedLocation = _useState4[0],
	      setSelectedLocation = _useState4[1];
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var organizationList = (0, _reactRedux.useSelector)(_selectors.selectOrganizationList);
	  var locationList = (0, _reactRedux.useSelector)(_selectors.selectLocationList);
	  var isLoading = (0, _reactRedux.useSelector)(_selectors.selectLocationListIsFetching);
	  var userId = (0, _reactRedux.useSelector)(_selectors2.targetUserIdSelector);
	
	  var warningTitle = formatMessage({
	    id: 'profile.payment.addingLocationInfo'
	  });
	
	  var organizationOptions = (0, _react.useMemo)(function () {
	    return organizationList.map(_mapListItemToOption.mapListItemToOption);
	  }, [organizationList]);
	
	  var locationOptions = (0, _react.useMemo)(function () {
	    return locationList.map(function (_ref2) {
	      var id = _ref2.id,
	          name = _ref2.name,
	          fullAddress = _ref2.fullAddress;
	      return {
	        value: id,
	        label: name + ', ' + fullAddress
	      };
	    });
	  }, [locationList]);
	
	  var onClosePopup = function onClosePopup() {
	    onClose();
	    setSelectedOrganization(null);
	    setSelectedLocation(null);
	  };
	
	  var handleSelectOrganization = function handleSelectOrganization(option) {
	    setSelectedOrganization(option.value);
	
	    setSelectedLocation(null);
	
	    dispatch(_locationsReq.actions.clear());
	
	    dispatch(_locationsReq.actions.send({
	      organizationId: option.value
	    }));
	  };
	
	  var handleSelectLocation = function handleSelectLocation(option) {
	    setSelectedLocation(option.value);
	  };
	
	  var handleLocationSearch = (0, _debounce2.default)(function (text) {
	    dispatch(_locationsReq.actions.clear());
	
	    dispatch(_locationsReq.actions.send({
	      organizationId: selectedOrganization,
	      query: text
	    }));
	  }, 700);
	
	  var handleAddNewCard = function handleAddNewCard() {
	    onClosePopup();
	    dispatch(_accountVaultsForm.actions.send({
	      userId: userId,
	      locationId: selectedLocation
	    }));
	
	    dispatch({
	      type: _popup.consts.SHOW,
	      payload: {
	        contentType: _props.UI_POPUP_TYPES.PAYA_ACCOUNT_FORM,
	        contentOptions: {
	          noCards: false
	        }
	      }
	    });
	  };
	
	  (0, _react.useEffect)(function () {
	    dispatch(_organizationsReq.actions.clear());
	
	    if (opened) {
	      dispatch(_organizationsReq.actions.send());
	    }
	  }, [opened]);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: opened,
	      onClose: onClosePopup,
	      width: (0, _mobileHelpers.isDesktop)() ? 'small' : 'medium',
	      title: formatMessage({
	        id: 'profile.payment.informationAboutTheOrganizationTitle'
	      })
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.description },
	        formatMessage({
	          id: 'profile.payment.informationAboutTheOrganizationDescription'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.content },
	        _react2.default.createElement(_SelectCustom2.default, {
	          label: formatMessage({ id: 'profile.payment.chooseOrganization' }),
	          placeholder: formatMessage({
	            id: 'profile.payment.fields.organization'
	          }),
	          value: selectedOrganization,
	          onChange: handleSelectOrganization,
	          options: organizationOptions,
	          disabled: !organizationList.length
	        }),
	        _react2.default.createElement(_SelectCustom2.default, {
	          disabled: !selectedOrganization,
	          value: selectedLocation,
	          onChange: handleSelectLocation,
	          onInputChange: handleLocationSearch,
	          label: formatMessage({ id: 'profile.payment.chooseLocation' }),
	          placeholder: formatMessage({
	            id: 'profile.payment.fields.location'
	          }),
	          options: locationOptions,
	          components: { MenuList: _MenuList2.default, LoadingMessage: function LoadingMessage() {
	              return null;
	            } },
	          filterOption: null,
	          isLoading: isLoading,
	          formatOptionLabel: _OptionLabel2.default,
	          menuPosition: 'fixed'
	        })
	      ),
	      selectedLocation && _react2.default.createElement(
	        'div',
	        { className: _index2.default.warning },
	        warningTitle
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.buttonWrapper },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'primary',
	            className: _index2.default.button,
	            disabled: !selectedLocation,
	            onClick: handleAddNewCard
	          },
	          formatMessage({ id: 'common.next' })
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'accent',
	            className: _index2.default.button,
	            onClick: onClosePopup
	          },
	          formatMessage({ id: 'common.cancel' })
	        )
	      )
	    )
	  );
	};
	exports.default = OrganizationPopup;
	
	
	OrganizationPopup.propTypes = {
	  opened: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func
	};

/***/ }),
/* 3621 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var mapListItemToOption = exports.mapListItemToOption = function mapListItemToOption(item) {
	  return {
	    value: item.id,
	    label: item.name
	  };
	};

/***/ }),
/* 3622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Popover = __webpack_require__(250);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(5094);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentMethodsHint = function PaymentMethodsHint() {
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      anchorEl = _useState2[0],
	      setAnchorEl = _useState2[1];
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var open = Boolean(anchorEl);
	
	  var hintText = formatMessage({ id: 'profile.payment.hint' });
	
	  var handleOpen = function handleOpen(e) {
	    return setAnchorEl(e.currentTarget);
	  };
	  var handleClose = function handleClose() {
	    return setAnchorEl(null);
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Icon2.default, {
	      name: 'icon-info',
	      size: 16,
	      className: _stylesModule2.default.infoIcon,
	      onClick: handleOpen
	    }),
	    _react2.default.createElement(
	      _Popover2.default,
	      {
	        open: open,
	        anchorEl: anchorEl,
	        onClose: handleClose,
	        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
	        transformOrigin: { vertical: 'top', horizontal: 'left' },
	        disableRestoreFocus: true
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.hintText },
	        hintText
	      )
	    )
	  );
	};
	
	exports.default = PaymentMethodsHint;

/***/ }),
/* 3623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _DeletePopup = __webpack_require__(3624);
	
	var _DeletePopup2 = _interopRequireDefault(_DeletePopup);
	
	var _PopoverMenu = __webpack_require__(398);
	
	var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);
	
	var _SubscriptionInfoPopup = __webpack_require__(3626);
	
	var _SubscriptionInfoPopup2 = _interopRequireDefault(_SubscriptionInfoPopup);
	
	var _PaymentMethodLocationsPopup = __webpack_require__(3625);
	
	var _PaymentMethodLocationsPopup2 = _interopRequireDefault(_PaymentMethodLocationsPopup);
	
	var _styles = __webpack_require__(18);
	
	var _vaultAccountTypes = __webpack_require__(1211);
	
	var _useIsLoggedInUser = __webpack_require__(1218);
	
	var _useIsLoggedInUser2 = _interopRequireDefault(_useIsLoggedInUser);
	
	var _stylesModule = __webpack_require__(5095);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var POPOVER_STYLES = {
	  marginTop: '10px',
	  marginLeft: '10px'
	};
	
	var Card = function Card(_ref) {
	  var card = _ref.card;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      anchorEl = _useState2[0],
	      setAnchorEl = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      selectedItemId = _useState4[0],
	      setSelectedItemId = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      paymentMethodLocationsPopupOpened = _useState6[0],
	      setPaymentMethodLocationsPopupOpened = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      subscriptionInfoPopupOpened = _useState8[0],
	      setSubscriptionInfoPopupOpened = _useState8[1];
	
	  var isLoggedInUser = (0, _useIsLoggedInUser2.default)();
	
	  var handlePopoverOpen = function handlePopoverOpen(event) {
	    setAnchorEl(event.currentTarget);
	  };
	
	  var handlePopoverClose = function handlePopoverClose() {
	    setAnchorEl(null);
	  };
	
	  var open = Boolean(anchorEl);
	
	  var isUnknownAccountType = card.accountType === _vaultAccountTypes.UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE;
	
	  var handleClose = function handleClose() {
	    handlePopoverClose();
	    setSelectedItemId(null);
	  };
	
	  var handleItemClick = function handleItemClick(id) {
	    handlePopoverClose();
	    setSelectedItemId(id);
	  };
	
	  var togglePaymentMethodLocationsPopup = (0, _react.useCallback)(function () {
	    handlePopoverClose();
	    setPaymentMethodLocationsPopupOpened(function (prev) {
	      return !prev;
	    });
	  }, []);
	
	  var toggleSubscriptionInfoPopup = (0, _react.useCallback)(function () {
	    handlePopoverClose();
	    setSubscriptionInfoPopupOpened(function (prev) {
	      return !prev;
	    });
	  }, []);
	
	  var menuItems = (0, _react.useMemo)(function () {
	    var seeAssociatedLocationsTitle = formatMessage({
	      id: 'profile.payment.cardMenu.seeAssociatedLocations'
	    });
	
	    var removePaymentMethodTitle = formatMessage({
	      id: 'profile.payment.cardMenu.removePaymentMethod'
	    });
	
	    return [{
	      text: _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.menuItem },
	        _react2.default.createElement(_Icon2.default, {
	          name: 'location',
	          style: {
	            fill: _styles.COLORS.bluePrimary
	          }
	        }),
	        seeAssociatedLocationsTitle
	      ),
	      onClick: togglePaymentMethodLocationsPopup
	    }, {
	      text: _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.menuItem },
	        _react2.default.createElement(_Icon2.default, {
	          name: card.hasActiveSubscriptions ? 'info' : 'remove',
	          style: {
	            fill: card.hasActiveSubscriptions ? _styles.COLORS.orange : _styles.COLORS.bluePrimary,
	            stroke: card.hasActiveSubscriptions && _styles.COLORS.orange
	          }
	        }),
	        removePaymentMethodTitle
	      ),
	      onClick: function onClick() {
	        if (!card.hasActiveSubscriptions) {
	          handleItemClick(card.id);
	        } else {
	          toggleSubscriptionInfoPopup();
	        }
	      },
	      borderTop: true
	    }];
	  }, [card, formatMessage, handleItemClick, togglePaymentMethodLocationsPopup, toggleSubscriptionInfoPopup]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_stylesModule2.default.container, (0, _defineProperty3.default)({}, _stylesModule2.default.containerError, card.isExpired))
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.row },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.cardNumber },
	          card.label
	        ),
	        isLoggedInUser && _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.icon },
	          _react2.default.createElement(_Icon2.default, {
	            name: 'three-dots-16',
	            size: 16,
	            onClick: handlePopoverOpen
	          }),
	          _react2.default.createElement(_PopoverMenu2.default, {
	            isOpen: open,
	            anchorEl: anchorEl,
	            items: menuItems,
	            onClose: handlePopoverClose,
	            size: 'large',
	            style: POPOVER_STYLES
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_stylesModule2.default.expDate, (0, _defineProperty3.default)({}, _stylesModule2.default.expDateExpired, card.isExpired))
	        },
	        formatMessage({
	          id: 'common.expDate'
	        }) + ': ' + card.expDate
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_stylesModule2.default.accountType, (0, _defineProperty3.default)({}, _stylesModule2.default.unknownAccountType, isUnknownAccountType))
	        },
	        card.accountType
	      ),
	      card.isExpired && _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.expired },
	        formatMessage({ id: 'common.expired' })
	      ),
	      _react2.default.createElement(_DeletePopup2.default, {
	        itemId: selectedItemId,
	        opened: Boolean(selectedItemId),
	        onClose: handleClose
	      })
	    ),
	    paymentMethodLocationsPopupOpened && _react2.default.createElement(_PaymentMethodLocationsPopup2.default, {
	      cardId: card.id,
	      onClose: togglePaymentMethodLocationsPopup,
	      opened: paymentMethodLocationsPopupOpened
	    }),
	    subscriptionInfoPopupOpened && _react2.default.createElement(_SubscriptionInfoPopup2.default, {
	      opened: subscriptionInfoPopupOpened,
	      onClose: toggleSubscriptionInfoPopup
	    })
	  );
	};
	
	exports.default = Card;
	
	
	Card.propTypes = {
	  card: _propTypes2.default.object.isRequired
	};

/***/ }),
/* 3624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _index = __webpack_require__(5096);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _selectors = __webpack_require__(23);
	
	var _deleteCardReq = __webpack_require__(677);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeletePopup = function DeletePopup(_ref) {
	  var itemId = _ref.itemId,
	      opened = _ref.opened,
	      onClose = _ref.onClose;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var userId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	
	  var handleDeleteCard = function handleDeleteCard() {
	    dispatch(_deleteCardReq.actions.send({
	      userId: userId,
	      id: itemId
	    }));
	
	    onClose();
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      strictClose: true,
	      opened: opened,
	      onClose: onClose,
	      width: (0, _mobileHelpers.isDesktop)() ? 'small' : 'medium',
	      title: formatMessage({
	        id: 'profile.payment.removeMessage'
	      })
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.buttonWrapper },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'danger',
	          className: _index2.default.button,
	          onClick: handleDeleteCard
	        },
	        formatMessage({ id: 'common.remove' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { color: 'accent', className: _index2.default.button, onClick: onClose },
	        formatMessage({ id: 'common.cancel' })
	      )
	    )
	  );
	};
	exports.default = DeletePopup;
	
	
	DeletePopup.propTypes = {
	  itemId: _propTypes2.default.number,
	  opened: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func
	};

/***/ }),
/* 3625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Modal = __webpack_require__(578);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _useIsOverflow = __webpack_require__(3915);
	
	var _useIsOverflow2 = _interopRequireDefault(_useIsOverflow);
	
	var _selectors = __webpack_require__(869);
	
	var _stylesModule = __webpack_require__(5097);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentMethodLocationsPopup = function PaymentMethodLocationsPopup(_ref) {
	  var cardId = _ref.cardId,
	      onClose = _ref.onClose,
	      opened = _ref.opened;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var locations = (0, _reactRedux.useSelector)((0, _selectors.selectAccountVaultsLocationsByAccountVaultId)(cardId));
	
	  var _useOverflow = (0, _useIsOverflow2.default)(),
	      ref = _useOverflow.ref,
	      y = _useOverflow.overflow.y;
	
	  var buttonTitle = formatMessage({ id: 'common.gotIt' });
	
	  var infoText = formatMessage({ id: 'profile.payment.popup.locationsInfo' });
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { open: opened, onClose: onClose },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_stylesModule2.default.info, (0, _defineProperty3.default)({}, _stylesModule2.default.infoWithBoxShadow, y)) },
	        _react2.default.createElement(_Icon2.default, { name: 'information', size: 48 }),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.infoText },
	          infoText
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { ref: ref, className: _stylesModule2.default.locations },
	        locations.map(function (_ref2) {
	          var id = _ref2.id,
	              name = _ref2.name,
	              fullAddress = _ref2.fullAddress;
	          return _react2.default.createElement(
	            'div',
	            { key: id, className: _stylesModule2.default.location },
	            name,
	            ' - ',
	            fullAddress
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_stylesModule2.default.footer, (0, _defineProperty3.default)({}, _stylesModule2.default.footerWithTopBorder, y)) },
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'primary', onClick: onClose, className: _stylesModule2.default.button },
	          buttonTitle
	        )
	      )
	    )
	  );
	};
	
	PaymentMethodLocationsPopup.propTypes = {
	  cardId: _propTypes2.default.number,
	  onClose: _propTypes2.default.func,
	  opened: _propTypes2.default.bool
	};
	
	exports.default = PaymentMethodLocationsPopup;

/***/ }),
/* 3626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Modal = __webpack_require__(578);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _stylesModule = __webpack_require__(5098);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscriptionInfoPopup = function SubscriptionInfoPopup(_ref) {
	  var opened = _ref.opened,
	      onClose = _ref.onClose;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var buttonTitle = formatMessage({ id: 'common.gotIt' });
	
	  var message = formatMessage({
	    id: 'profile.payment.subscriptionMessage'
	  });
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    { open: opened, onClose: onClose },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.info },
	        _react2.default.createElement(_Icon2.default, { name: 'information', size: 48 })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.message },
	        message
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.footer },
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'primary', onClick: onClose, className: _stylesModule2.default.button },
	          buttonTitle
	        )
	      )
	    )
	  );
	};
	
	SubscriptionInfoPopup.propTypes = {
	  opened: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func
	};
	
	exports.default = SubscriptionInfoPopup;

/***/ }),
/* 3627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(869);
	
	var _Card = __webpack_require__(3623);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _mapAccountVaultCardsToItems = __webpack_require__(1916);
	
	var _mapAccountVaultCardsToItems2 = _interopRequireDefault(_mapAccountVaultCardsToItems);
	
	var _stylesModule = __webpack_require__(5099);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Payments = function Payments() {
	  var paymentList = (0, _reactRedux.useSelector)(_selectors.selectPaymentList);
	
	  var renderLocation = (0, _react.useMemo)(function () {
	    return paymentList.map(function (_ref) {
	      var name = _ref.name,
	          accountvaults = _ref.accountvaults,
	          id = _ref.id;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.section, key: id },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.header },
	          _react2.default.createElement(
	            'span',
	            { className: _stylesModule2.default.title },
	            name
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.cards },
	          accountvaults.map(function (_ref2) {
	            var accountvault = _ref2.accountvault;
	            return _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.section, key: accountvault.id },
	              _react2.default.createElement(_Card2.default, { card: (0, _mapAccountVaultCardsToItems2.default)(accountvault) })
	            );
	          })
	        )
	      );
	    });
	  }, [paymentList]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    renderLocation
	  );
	};
	
	exports.default = Payments;

/***/ }),
/* 3628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Payments = __webpack_require__(3627);
	
	var _Payments2 = _interopRequireDefault(_Payments);
	
	var _EmptyState = __webpack_require__(3619);
	
	var _EmptyState2 = _interopRequireDefault(_EmptyState);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _OrganizationPopup = __webpack_require__(3620);
	
	var _OrganizationPopup2 = _interopRequireDefault(_OrganizationPopup);
	
	var _PaymentMethodsHint = __webpack_require__(3622);
	
	var _PaymentMethodsHint2 = _interopRequireDefault(_PaymentMethodsHint);
	
	var _EmptyOrganizationsState = __webpack_require__(3618);
	
	var _EmptyOrganizationsState2 = _interopRequireDefault(_EmptyOrganizationsState);
	
	var _usePageView = __webpack_require__(52);
	
	var _useIsLoggedInUser = __webpack_require__(1218);
	
	var _useIsLoggedInUser2 = _interopRequireDefault(_useIsLoggedInUser);
	
	var _paymentsReq = __webpack_require__(868);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(869);
	
	var _index = __webpack_require__(5100);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfilePaymentMethods = function ProfilePaymentMethods() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _usePageView.usePageView)('Profile | Payment Methods');
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      opened = _useState2[0],
	      setOpened = _useState2[1];
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var isLoggedInUser = (0, _useIsLoggedInUser2.default)();
	
	  var paymentList = (0, _reactRedux.useSelector)(_selectors2.selectPaymentList);
	
	  var isPaymentListFetching = (0, _reactRedux.useSelector)(_selectors2.selectIsPaymentListFetching);
	
	  var userId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	
	  var userOrganizationsList = (0, _reactRedux.useSelector)(_selectors.selectTargetUserOrganizations);
	
	  var addPaymentMethodTitle = formatMessage({
	    id: 'profile.payment.addPaymentMethod'
	  });
	
	  var description = formatMessage({ id: 'profile.payment.description' });
	
	  var paymentMethodsTitle = formatMessage({
	    id: 'profile.payment.paymentMethods'
	  });
	
	  var togglePopup = function togglePopup() {
	    return setOpened(function (state) {
	      return !state;
	    });
	  };
	
	  var isEmpty = (0, _react.useMemo)(function () {
	    return !Array.isArray(paymentList) || paymentList.length === 0;
	  }, [paymentList]);
	
	  var paymentContent = (0, _react.useMemo)(function () {
	    if (isPaymentListFetching) return _react2.default.createElement(_Loader2.default, null);
	
	    if (isEmpty) return _react2.default.createElement(_EmptyState2.default, null);
	
	    return _react2.default.createElement(_Payments2.default, null);
	  }, [isPaymentListFetching, isEmpty]);
	
	  (0, _react.useEffect)(function () {
	    dispatch(_paymentsReq.actions.clear());
	
	    if (!userId || !userOrganizationsList.length) return;
	
	    dispatch(_paymentsReq.actions.send({ userId: userId }));
	  }, [dispatch, userId, userOrganizationsList.length]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_index2.default.container, (0, _defineProperty3.default)({}, _index2.default.containerWithoutOrganizations, !userOrganizationsList.length))
	    },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.profile.payment' }),
	    userOrganizationsList.length ? _react2.default.createElement(
	      'div',
	      { className: _index2.default.content, 'aria-busy': isPaymentListFetching },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.header },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.title },
	            paymentMethodsTitle,
	            isLoggedInUser && _react2.default.createElement(_PaymentMethodsHint2.default, null)
	          ),
	          isLoggedInUser && _react2.default.createElement(
	            'div',
	            { className: _index2.default.description },
	            description
	          )
	        ),
	        isLoggedInUser && _react2.default.createElement(
	          _Button2.default,
	          { raised: true, color: 'primary', onClick: togglePopup },
	          addPaymentMethodTitle
	        ),
	        _react2.default.createElement(_OrganizationPopup2.default, { opened: opened, onClose: togglePopup })
	      ),
	      paymentContent
	    ) : _react2.default.createElement(
	      'div',
	      { className: _index2.default.withoutOrganizations },
	      _react2.default.createElement(_EmptyOrganizationsState2.default, null)
	    )
	  );
	};
	
	exports.default = ProfilePaymentMethods;

/***/ }),
/* 3629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _changeSettings = __webpack_require__(538);
	
	var _editUser = __webpack_require__(136);
	
	var _selectors = __webpack_require__(23);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: (0, _selectors.targetUserSelector)(state),
	    canEdit: (0, _selectors.canEditPatient)(state),
	    canEditOwnPatient: (0, _selectors.canEditNotJoinedPatient)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  saveUser: _editUser.actions.send,
	  saveSettings: _changeSettings.actions.send
	};
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(23);
	
	var _NotificationSettings = __webpack_require__(3600);
	
	var _NotificationSettings2 = _interopRequireDefault(_NotificationSettings);
	
	var _PrivacySettings = __webpack_require__(3606);
	
	var _PrivacySettings2 = _interopRequireDefault(_PrivacySettings);
	
	var _LanguagePicker = __webpack_require__(3593);
	
	var _LanguagePicker2 = _interopRequireDefault(_LanguagePicker);
	
	var _DeviceSetup = __webpack_require__(3571);
	
	var _DeviceSetup2 = _interopRequireDefault(_DeviceSetup);
	
	var _MfaSettings = __webpack_require__(3596);
	
	var _MfaSettings2 = _interopRequireDefault(_MfaSettings);
	
	var _UnitsSettings = __webpack_require__(3642);
	
	var _UnitsSettings2 = _interopRequireDefault(_UnitsSettings);
	
	var _DeleteAccount = __webpack_require__(3566);
	
	var _DeleteAccount2 = _interopRequireDefault(_DeleteAccount);
	
	var _enhance = __webpack_require__(3629);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProfileSettings = function ProfileSettings(_ref) {
	  var canEdit = _ref.canEdit,
	      canEditOwnPatient = _ref.canEditOwnPatient,
	      saveSettings = _ref.saveSettings,
	      _ref$profile = _ref.profile,
	      id = _ref$profile.id,
	      settings = _ref$profile.settings,
	      phoneNumber = _ref$profile.phoneNumber,
	      email = _ref$profile.email,
	      emailFake = _ref$profile.emailFake,
	      mfaEnabled = _ref$profile.mfaEnabled,
	      phoneNumberConfirmed = _ref$profile.phoneNumberConfirmed;
	
	  (0, _usePageView.usePageView)('Profile | Settings');
	  var notifySettings = useNotificationSettings(settings, email, emailFake, phoneNumber);
	  var isNotProvider = !(0, _reactRedux.useSelector)(_selectors.hasProviderProfileSelector);
	
	  var saveLanguageSettings = function saveLanguageSettings(languageSettings) {
	    return saveSettings({ id: id, languageSettings: languageSettings });
	  };
	
	  var savePrivacySettings = function savePrivacySettings(value) {
	    saveSettings({ id: id, hideFields: value });
	  };
	
	  var saveNotificationSettings = function saveNotificationSettings(type, enabled) {
	    saveSettings((0, _extends3.default)({}, settings, {
	      notificationSettings: (0, _defineProperty3.default)({}, type, enabled),
	      id: id
	    }));
	  };
	
	  var safeCredential = (0, _react.useMemo)(function () {
	    return phoneNumberConfirmed ? phoneNumber : email;
	  }, [phoneNumberConfirmed, phoneNumber, email]);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'content content--profile content--info' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.profile.settings' }),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'info info--settings' },
	      canEdit && !canEditOwnPatient ? [_react2.default.createElement(_LanguagePicker2.default, {
	        onChange: saveLanguageSettings,
	        locale: (0, _get2.default)(settings, 'languageSettings'),
	        key: '0'
	      }), (0, _size2.default)(notifySettings) ? _react2.default.createElement(_NotificationSettings2.default, {
	        settings: notifySettings,
	        onChange: saveNotificationSettings,
	        key: '1'
	      }) : null, isNotProvider ? _react2.default.createElement(_MfaSettings2.default, {
	        id: id,
	        active: mfaEnabled,
	        credential: safeCredential,
	        key: '2'
	      }) : null, _react2.default.createElement(_PrivacySettings2.default, {
	        onChange: savePrivacySettings,
	        hidden: settings.hideFields,
	        key: '3'
	      }), isNotProvider ? _react2.default.createElement(_DeviceSetup2.default, {
	        key: '4'
	      }) : null, isNotProvider ? _react2.default.createElement(_UnitsSettings2.default, {
	        key: '5'
	      }) : null, _react2.default.createElement(_DeleteAccount2.default, {
	        key: '6'
	      })] : null
	    )
	  );
	};
	
	ProfileSettings.propTypes = {
	  canEditOwnPatient: _propTypes2.default.bool,
	  canEdit: _propTypes2.default.bool,
	  saveSettings: _propTypes2.default.func,
	  profile: _propTypes2.default.object
	};
	
	exports.default = (0, _enhance.enhance)(ProfileSettings);
	
	
	function useNotificationSettings(settings, email, emailFake, phoneNumber) {
	  return (0, _react.useMemo)(function () {
	    var notificationSettings = (0, _get2.default)(settings, 'notificationSettings', {});
	    var smsEnabled = notificationSettings.sms,
	        emailEnabled = notificationSettings.email;
	
	
	    var notificationTypes = [];
	
	    if (!emailFake && email) {
	      notificationTypes.push({
	        type: 'email',
	        value: email,
	        enabled: emailEnabled
	      });
	    }
	    if (phoneNumber) {
	      notificationTypes.push({
	        type: 'sms',
	        value: phoneNumber,
	        enabled: smsEnabled
	      });
	    }
	
	    return notificationTypes;
	  }, [settings, email, emailFake, phoneNumber]);
	}

/***/ }),
/* 3631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(23);
	
	var _editProvider = __webpack_require__(424);
	
	var _selectors2 = __webpack_require__(50);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: (0, _selectors.targetUserSelector)(state),
	    rawGenderList: state.data.processedConsts.genderTypes,
	    languageList: state.data.processedConsts.languageTypes,
	    statesList: (0, _selectors2.selectUsStates)(state),
	    canEdit: (0, _selectors.isLoggedUserSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  saveProvider: _editProvider.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FieldSetList = __webpack_require__(334);
	
	var _FieldSetList2 = _interopRequireDefault(_FieldSetList);
	
	var _getInfoFieldset = __webpack_require__(1795);
	
	var _enhance = __webpack_require__(3631);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProviderInfo = function (_PureComponent) {
	  (0, _inherits3.default)(ProviderInfo, _PureComponent);
	
	  function ProviderInfo() {
	    (0, _classCallCheck3.default)(this, ProviderInfo);
	    return (0, _possibleConstructorReturn3.default)(this, (ProviderInfo.__proto__ || (0, _getPrototypeOf2.default)(ProviderInfo)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ProviderInfo, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          canEdit = _props.canEdit,
	          saveProvider = _props.saveProvider;
	
	
	      return _react2.default.createElement(
	        'div',
	        { styleName: 'content content--profile content--info' },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'info' },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'common' },
	            _react2.default.createElement(_FieldSetList2.default, {
	              fieldSetList: (0, _getInfoFieldset.getProviderInfoFieldsetList)(this.props),
	              onSave: saveProvider,
	              disabled: !canEdit,
	              canEdit: canEdit
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return ProviderInfo;
	}(_react.PureComponent);
	
	ProviderInfo.propTypes = {
	  canEdit: _propTypes2.default.bool,
	  saveProvider: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  })
	};
	
	exports.default = (0, _enhance.enhance)(ProviderInfo);

/***/ }),
/* 3633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(23);
	
	var _editUser = __webpack_require__(136);
	
	var _selectors2 = __webpack_require__(50);
	
	var _editPatient = __webpack_require__(218);
	
	var _selectors3 = __webpack_require__(56);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: (0, _selectors.targetUserSelector)(state),
	    profileErrors: (0, _selectors3.selectEditedUserErrors)(state),
	    rawGenderList: (0, _selectors2.selectGenderTypes)(state),
	    languageList: (0, _selectors2.selectLanguageTypes)(state),
	    nameSuffixList: (0, _selectors2.selectNameSuffixesList)(state),
	    rawMaritalStatusList: (0, _selectors2.selectMaritalStatus)(state),
	    statesList: (0, _selectors2.selectUsStates)(state),
	    canEdit: (0, _selectors.isLoggedUserSelector)(state),
	    canEditPatient: (0, _selectors.canEditNotJoinedPatient)(state),
	    profileEditable: (0, _selectors3.selectProfileEditable)(state),
	    showOwnProviderProfile: (0, _selectors.selectShowOwnProviderProfile)(state),
	    countryList: (0, _selectors2.selectCountryOptions)(state),
	    isSucceedUpdate: (0, _selectors3.selectEditedUserSucceed)(state),
	    veteranStatusesList: (0, _selectors2.selectVeteranStatusesList)(state),
	    educationLevelsList: (0, _selectors2.selectEducationLevelsList)(state),
	    citizenship: (0, _selectors2.selectCitizinship)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  saveUser: _editUser.actions.send,
	  savePatient: _editPatient.actions.send
	};
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var profileErrors = _ref.profileErrors;
	
	  return { errors: (0, _get2.default)(profileErrors, 'meta.validationErrors') };
	}), (0, _recompose.branch)(function (_ref2) {
	  var showOwnProviderProfile = _ref2.showOwnProviderProfile;
	  return !showOwnProviderProfile;
	}, _recompose.renderNothing), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(58);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _FieldSetList = __webpack_require__(334);
	
	var _FieldSetList2 = _interopRequireDefault(_FieldSetList);
	
	var _constants = __webpack_require__(17);
	
	var _ContactInfoSection = __webpack_require__(1786);
	
	var _ContactInfoSection2 = _interopRequireDefault(_ContactInfoSection);
	
	var _deepTrim = __webpack_require__(357);
	
	var _deepTrim2 = _interopRequireDefault(_deepTrim);
	
	var _getFieldset = __webpack_require__(611);
	
	var _getContactConditions = __webpack_require__(1794);
	
	var _toSnakeCaseObjectKeys = __webpack_require__(699);
	
	var _toSnakeCaseObjectKeys2 = _interopRequireDefault(_toSnakeCaseObjectKeys);
	
	var _metadata = __webpack_require__(291);
	
	var _enhance = __webpack_require__(3633);
	
	var _HomeAddress = __webpack_require__(1790);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProviderProfile = function ProviderProfile(props) {
	  var profile = props.profile,
	      saveUser = props.saveUser,
	      savePatient = props.savePatient,
	      canEdit = props.canEdit,
	      profileEditable = props.profileEditable,
	      formatMessage = props.intl.formatMessage,
	      countryList = props.countryList,
	      isSucceedUpdate = props.isSucceedUpdate;
	  var id = profile.id,
	      email = profile.email,
	      phoneNumber = profile.phoneNumber;
	
	  var _getContactsCondition = (0, _getContactConditions.getContactsConditions)(profile),
	      showEmail = _getContactsCondition.showEmail,
	      showPhoneNumber = _getContactsCondition.showPhoneNumber;
	
	  var patientProfileId = (0, _lodash.get)(profile, 'primaryPatientProfile.id');
	
	  var handleSave = function handleSave(data, type) {
	    if (type === _constants.PROFILE_SECTIONS.EMERGENCY_CONTACT) {
	      var _savePatient;
	
	      savePatient((_savePatient = {}, (0, _defineProperty3.default)(_savePatient, _metadata.EMERGENCY_CONTACT_DATA_KEY, (0, _toSnakeCaseObjectKeys2.default)(data)), (0, _defineProperty3.default)(_savePatient, 'id', patientProfileId), _savePatient));
	      return;
	    }
	
	    // exclude ssn, because it's with *
	    var checkedData = (0, _deepTrim2.default)(profileEditable ? data : (0, _omit2.default)(data, ['ssn']));
	
	    saveUser((0, _extends3.default)({}, checkedData, { id: id }));
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_ContactInfoSection2.default, {
	      canEdit: canEdit,
	      email: showEmail ? email : null,
	      phoneNumber: showPhoneNumber ? phoneNumber : null
	    }),
	    _react2.default.createElement(_FieldSetList2.default, {
	      fieldSetList: (0, _getFieldset.getProviderFieldsetList)(props),
	      onSave: handleSave,
	      disabled: !canEdit,
	      canEdit: canEdit
	    }),
	    _react2.default.createElement(_HomeAddress.HomeAddress, {
	      formatMessage: formatMessage,
	      profile: profile,
	      canEdit: canEdit,
	      countryList: countryList,
	      saveUser: saveUser,
	      isSucceedUpdate: isSucceedUpdate
	    })
	  );
	};
	
	ProviderProfile.propTypes = {
	  profile: _propTypes2.default.object,
	  saveUser: _propTypes2.default.func,
	  savePatient: _propTypes2.default.func,
	  canEdit: _propTypes2.default.bool,
	  profileEditable: _propTypes2.default.bool,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  countryList: _propTypes2.default.array,
	  isSucceedUpdate: _propTypes2.default.bool
	};
	
	exports.default = (0, _enhance.enhance)(ProviderProfile);

/***/ }),
/* 3635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(50);
	
	var _selectors2 = __webpack_require__(23);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    supportInfo: (0, _selectors2.supportInfoSelector)(state),
	    platformVersion: (0, _selectors.selectPlatformVersion)(state),
	    loggedUserCountry: (0, _selectors2.loggedUserCountrySelector)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 3636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhance = __webpack_require__(3635);
	
	var _env = __webpack_require__(103);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _TermsAndConditions = __webpack_require__(781);
	
	var _TermsAndConditions2 = _interopRequireDefault(_TermsAndConditions);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Support = function Support(_ref) {
	  var supportInfo = _ref.supportInfo,
	      platformVersion = _ref.platformVersion,
	      loggedUserCountry = _ref.loggedUserCountry,
	      formatMessage = _ref.intl.formatMessage;
	
	  (0, _usePageView.usePageView)('Profile | Support');
	  var name = supportInfo.name,
	      email = supportInfo.email,
	      phoneNumber = supportInfo.phoneNumber;
	
	  var needHelp = formatMessage({ id: 'support.needHelp' }, { name: name });
	
	  var version = (0, _react.useMemo)(function () {
	    return [_env.APP_VERSION, _env.CI_PIPELINE_IID].join('.');
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.supportWrapper },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.profile.support' }),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.supportBlock },
	      _react2.default.createElement(
	        'h3',
	        { className: _index2.default.supportTitle },
	        formatMessage({ id: 'support.helpCenter' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.supportQuestion },
	        needHelp
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.supportContacts },
	        _react2.default.createElement(
	          'span',
	          { className: _index2.default.supportLable },
	          formatMessage({ id: 'common.phone' })
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _index2.default.supportText },
	          phoneNumber
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: _index2.default.supportLable },
	        formatMessage({ id: 'fields.email' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: _index2.default.supportText, href: 'mailto:' + email },
	        email
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.supportBlock },
	      _react2.default.createElement(
	        'h3',
	        { className: _index2.default.supportTitle },
	        formatMessage({ id: 'googleMaps.about' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.supportContacts },
	        _react2.default.createElement(
	          'span',
	          { className: _index2.default.supportLable },
	          formatMessage({ id: 'profile.fields.name' })
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _index2.default.supportText },
	          _brandConfig2.default.name
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.supportContacts },
	        _react2.default.createElement(
	          'span',
	          { className: _index2.default.supportLable },
	          formatMessage({ id: 'support.appVersion' })
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _index2.default.supportText },
	          version
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.supportContacts },
	        _react2.default.createElement(
	          'span',
	          { className: _index2.default.supportLable },
	          formatMessage({ id: 'support.platformVersion' })
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _index2.default.supportText },
	          platformVersion
	        )
	      )
	    ),
	    _react2.default.createElement(_TermsAndConditions2.default, {
	      country: loggedUserCountry,
	      additionalStyles: _index2.default.termsAdditionalStyles
	    })
	  );
	};
	
	Support.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  supportInfo: _propTypes2.default.object,
	  platformVersion: _propTypes2.default.string,
	  loggedUserCountry: _propTypes2.default.string
	};
	
	exports.default = (0, _enhance.enhance)(Support);

/***/ }),
/* 3637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(23);
	
	var _index = __webpack_require__(138);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    profile: (0, _selectors.targetUserSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	  return { formatMessage: formatMessage };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _CircleList = __webpack_require__(1097);
	
	var _CircleList2 = _interopRequireDefault(_CircleList);
	
	var _strings = __webpack_require__(15);
	
	var _enhance = __webpack_require__(3637);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamProfile = function TeamProfile(_ref) {
	  var formatMessage = _ref.formatMessage,
	      profile = _ref.profile;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'pl2' },
	    _react2.default.createElement(_CircleList2.default, {
	      list: (0, _get2.default)(profile, 'actingAsTeam.users', []),
	      title: formatMessage({ id: 'teams.teamMember' }),
	      type: _strings.TEAM_PROFILE
	    })
	  );
	};
	
	TeamProfile.propTypes = {
	  profile: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = (0, _enhance.enhance)(TeamProfile);

/***/ }),
/* 3639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _index = __webpack_require__(5101);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnitField = function UnitField(_ref) {
	  var intl = _ref.intl,
	      editMode = _ref.editMode,
	      title = _ref.title,
	      value = _ref.value,
	      viewValue = _ref.viewValue,
	      options = _ref.options,
	      onChange = _ref.onChange;
	  var formatMessage = intl.formatMessage;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.unit },
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.unitTitle },
	      formatMessage({ id: title })
	    ),
	    editMode ? _react2.default.createElement(_SelectCustom2.default, { onChange: onChange, options: options, value: value }) : _react2.default.createElement(
	      'div',
	      { className: _index2.default.unitValue },
	      formatMessage({ id: viewValue })
	    )
	  );
	};
	
	UnitField.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  title: _propTypes2.default.string.isRequired,
	  value: _propTypes2.default.string.isRequired,
	  viewValue: _propTypes2.default.string.isRequired,
	  options: _propTypes2.default.array.isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  editMode: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactIntl.injectIntl)(UnitField);

/***/ }),
/* 3640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGlucoseOptions = exports.getTemperatureOptions = exports.getWeightOptions = exports.getHeightOptions = undefined;
	
	var _constants = __webpack_require__(17);
	
	var getHeightOptions = exports.getHeightOptions = function getHeightOptions(formatMessage) {
	  return [{
	    value: _constants.HEIGHT_METRIC.FEET_INCHES,
	    label: formatMessage({
	      id: 'profile.section.unitsSettings.height.metric.feet_and_inches'
	    })
	  }, {
	    value: _constants.HEIGHT_METRIC.METERS,
	    label: formatMessage({
	      id: 'profile.section.unitsSettings.height.metric.meters'
	    })
	  }];
	};
	
	var getWeightOptions = exports.getWeightOptions = function getWeightOptions(formatMessage) {
	  return [{
	    value: _constants.WEIGHT_METRIC.POUNDS,
	    label: formatMessage({
	      id: 'profile.section.unitsSettings.weight.metric.pounds'
	    })
	  }, {
	    value: _constants.WEIGHT_METRIC.KG,
	    label: formatMessage({
	      id: 'profile.section.unitsSettings.weight.metric.kilograms'
	    })
	  }];
	};
	
	var getTemperatureOptions = exports.getTemperatureOptions = function getTemperatureOptions(formatMessage) {
	  return [{
	    value: _constants.TEMPERATURE_METRIC.FAHRENHEIT,
	    label: formatMessage({
	      id: 'profile.section.unitsSettings.temperature.metric.fahrenheit'
	    })
	  }, {
	    value: _constants.TEMPERATURE_METRIC.CELSIUS,
	    label: formatMessage({
	      id: 'profile.section.unitsSettings.temperature.metric.celsius'
	    })
	  }];
	};
	
	var getGlucoseOptions = exports.getGlucoseOptions = function getGlucoseOptions(formatMessage) {
	  return [{
	    value: _constants.GLUCOSE_METRIC.MMOL_PER_LITER,
	    label: formatMessage({
	      id: 'profile.section.unitsSettings.glucose.metric.mmol/L'
	    })
	  }, {
	    value: _constants.GLUCOSE_METRIC.MG_PER_DECILITER,
	    label: formatMessage({
	      id: 'profile.section.unitsSettings.glucose.metric.mg/dL'
	    })
	  }];
	};

/***/ }),
/* 3641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(109);
	
	var _selectors2 = __webpack_require__(23);
	
	var _currentHealthboardOptions = __webpack_require__(1338);
	
	var _editUser = __webpack_require__(136);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currentMetricHeightType: (0, _selectors.selectCurrentMetricHeightType)(state),
	    currentMetricWeightType: (0, _selectors.selectCurrentMetricWeightType)(state),
	    currentMetricGlucoseType: (0, _selectors.selectCurrentMetricGlucoseType)(state),
	    currentMetricTemperatureType: (0, _selectors.selectCurrentMetricTemperatureType)(state),
	    profile: (0, _selectors2.loggedUserSelector)(state),
	    profileTargetUser: (0, _selectors2.targetUserSelector)(state),
	    userId: (0, _selectors2.targetUserIdSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  editUser: _editUser.actions.send,
	  setCurrentMetric: _currentHealthboardOptions.currentHealthboardOptionsActions.setCurrentMetric
	};
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _EditBtn = __webpack_require__(393);
	
	var _EditBtn2 = _interopRequireDefault(_EditBtn);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _UnitField = __webpack_require__(3639);
	
	var _UnitField2 = _interopRequireDefault(_UnitField);
	
	var _strings = __webpack_require__(15);
	
	var _enhance = __webpack_require__(3641);
	
	var _constants = __webpack_require__(3640);
	
	var _index = __webpack_require__(5102);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnitsSettings = function UnitsSettings(_ref) {
	  var intl = _ref.intl,
	      currentMetricHeightType = _ref.currentMetricHeightType,
	      currentMetricWeightType = _ref.currentMetricWeightType,
	      currentMetricGlucoseType = _ref.currentMetricGlucoseType,
	      currentMetricTemperatureType = _ref.currentMetricTemperatureType,
	      userId = _ref.userId,
	      setCurrentMetric = _ref.setCurrentMetric,
	      editUser = _ref.editUser,
	      profile = _ref.profile,
	      profileTargetUser = _ref.profileTargetUser;
	
	  var _ref2 = (0, _isEmpty2.default)(profileTargetUser) ? profile : profileTargetUser,
	      settings = _ref2.settings,
	      id = _ref2.id;
	
	  var _get = (0, _get3.default)(settings, 'measurementUnitsSettings', {}),
	      height = _get.height,
	      weight = _get.weight,
	      temperature = _get.temperature,
	      glucose = _get.glucose;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      editMode = _useState2[0],
	      setEditMode = _useState2[1];
	
	  var formatMessage = intl.formatMessage;
	
	
	  var glucoseOptions = (0, _react.useMemo)(function () {
	    return (0, _constants.getGlucoseOptions)(formatMessage);
	  }, []);
	  var heightOptions = (0, _react.useMemo)(function () {
	    return (0, _constants.getHeightOptions)(formatMessage);
	  }, []);
	  var weightOptions = (0, _react.useMemo)(function () {
	    return (0, _constants.getWeightOptions)(formatMessage);
	  }, []);
	  var temperatureOptions = (0, _react.useMemo)(function () {
	    return (0, _constants.getTemperatureOptions)(formatMessage);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    handleSetMetric('currentMetricWeight', weight);
	    handleSetMetric('currentMetricHeight', height);
	    handleSetMetric('currentMetricTemperature', temperature);
	    handleSetMetric('currentMetricGlucose', glucose);
	  }, [id]);
	
	  var handleSaveUnits = function handleSaveUnits() {
	    var measurementUnitsSettings = {
	      height: currentMetricHeightType,
	      weight: currentMetricWeightType,
	      glucose: currentMetricGlucoseType,
	      temperature: currentMetricTemperatureType,
	      distance: 'miles' // REQUIRED FIELD ON BE
	    };
	    editUser({ id: userId, measurementUnitsSettings: measurementUnitsSettings });
	    setEditMode(false);
	  };
	
	  var handleCancel = function handleCancel() {
	    handleSetMetric('currentMetricWeight', weight);
	    handleSetMetric('currentMetricHeight', height);
	    handleSetMetric('currentMetricTemperature', temperature);
	    handleSetMetric('currentMetricGlucose', glucose);
	    setEditMode(false);
	  };
	
	  var handleSetMetric = function handleSetMetric(type, value) {
	    setCurrentMetric({ type: type, value: value });
	  };
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.titleWrapper },
	      _react2.default.createElement(
	        'h3',
	        { className: _index2.default.title },
	        formatMessage({ id: 'profile.section.unitsSettings.title' })
	      ),
	      _react2.default.createElement(_EditBtn2.default, { onClick: function onClick() {
	          return setEditMode(!editMode);
	        } })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.unitsWrapper },
	      _react2.default.createElement(_UnitField2.default, {
	        title: 'profile.section.unitsSettings.height',
	        editMode: editMode,
	        value: currentMetricHeightType,
	        viewValue: 'profile.section.unitsSettings.height.metric.' + currentMetricHeightType,
	        options: heightOptions,
	        onChange: function onChange(_ref3) {
	          var value = _ref3.value;
	          return handleSetMetric('currentMetricHeight', value);
	        }
	      }),
	      _react2.default.createElement(_UnitField2.default, {
	        title: 'profile.section.unitsSettings.weight',
	        editMode: editMode,
	        value: currentMetricWeightType,
	        viewValue: 'profile.section.unitsSettings.weight.metric.' + currentMetricWeightType,
	        options: weightOptions,
	        onChange: function onChange(_ref4) {
	          var value = _ref4.value;
	          return handleSetMetric('currentMetricWeight', value);
	        }
	      }),
	      _react2.default.createElement(_UnitField2.default, {
	        title: 'profile.section.unitsSettings.temperature',
	        editMode: editMode,
	        value: currentMetricTemperatureType,
	        viewValue: 'profile.section.unitsSettings.temperature.metric.' + currentMetricTemperatureType,
	        options: temperatureOptions,
	        onChange: function onChange(_ref5) {
	          var value = _ref5.value;
	          return handleSetMetric('currentMetricTemperature', value);
	        }
	      }),
	      _react2.default.createElement(_UnitField2.default, {
	        title: 'profile.section.unitsSettings.glucose',
	        editMode: editMode,
	        value: currentMetricGlucoseType,
	        viewValue: 'profile.section.unitsSettings.glucose.metric.' + currentMetricGlucoseType,
	        options: glucoseOptions,
	        onChange: function onChange(_ref6) {
	          var value = _ref6.value;
	          return handleSetMetric('currentMetricGlucose', value);
	        }
	      })
	    ),
	    editMode ? [_react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'mt3 mr2 user-profile-save-button',
	        raised: true,
	        color: 'primary',
	        onClick: handleSaveUnits,
	        key: '0'
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.save)
	    ), _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'mt3 user-profile-cancel-button',
	        raised: true,
	        color: 'accent',
	        onClick: handleCancel,
	        key: '1'
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.cancel)
	    )] : null
	  );
	};
	
	UnitsSettings.propTypes = {
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  profile: _propTypes2.default.object,
	  userId: _propTypes2.default.number.isRequired,
	  profileTargetUser: _propTypes2.default.object,
	  editUser: _propTypes2.default.func.isRequired,
	  setCurrentMetric: _propTypes2.default.func.isRequired,
	  currentMetricHeightType: _propTypes2.default.string.isRequired,
	  currentMetricWeightType: _propTypes2.default.string.isRequired,
	  currentMetricGlucoseType: _propTypes2.default.string.isRequired,
	  currentMetricTemperatureType: _propTypes2.default.string.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(UnitsSettings);

/***/ }),
/* 3643 */,
/* 3644 */,
/* 3645 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (key) {
	  if (!key) return '';
	  if (key.length === 9) return '***-**-' + key.slice(-4);
	  return key;
	};

/***/ }),
/* 3646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _validations = __webpack_require__(362);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var employers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var formatMessage = arguments[1];
	
	  var prefixID = formatMessage({ id: 'common.ID' });
	  var employeeEmployers = employers ? employers.employeeEmployers : [];
	
	  var _get = (0, _get3.default)(employers, 'workingHours', {}),
	      startTime = _get.startTime,
	      endTime = _get.endTime,
	      timeZone = _get.timeZone;
	
	  var result = [];
	
	  var locations = employeeEmployers.map(function (item) {
	    var employeeType = (0, _get3.default)(item, 'employersEmployeeType.name', '');
	    var fullEmployeeType = employeeType ? ', ' + employeeType : '';
	    return {
	      name: item.employer.name,
	      value: prefixID + ': ' + item.externalId + fullEmployeeType,
	      disabled: true
	    };
	  });
	  var workingHours = employeeEmployers.map(function () {
	    return {
	      name: formatMessage({ id: 'profile.section.workingHours' }),
	      value: [startTime, endTime, { label: timeZone, value: timeZone }],
	      fieldName: 'workingHours',
	      type: _constants.FIELDS_TYPE.CUSTOM_TIME_PICKER,
	      validationRules: (0, _defineProperty3.default)({}, _validations.RULES.WORKING_HOURS, {
	        message: 'profile.workingHours.required'
	      })
	    };
	  });
	
	  for (var i = 0; i < employeeEmployers.length; i++) {
	    result.push(locations[i]);
	    result.push(workingHours[i]);
	  }
	
	  return result;
	};

/***/ }),
/* 3647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var mrns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return mrns.map(function (mrn) {
	    return {
	      name: (0, _get2.default)(mrn, 'organization.name'),
	      value: mrn.localUid
	    };
	  });
	};

/***/ }),
/* 3648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _makePharmacyTitle = __webpack_require__(311);
	
	exports.default = function (pharmacy, formatMessage) {
	  return [{
	    name: formatMessage({ id: 'appointments.form.pharmacyLocation' }),
	    value: pharmacy ? (0, _makePharmacyTitle.makePharmacyTitle)(pharmacy, true) : '-',
	    fieldName: 'pharmacy',
	    type: 'pharmacy'
	  }];
	};

/***/ }),
/* 3649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getFieldValues = function getFieldValues(fields) {
	  return fields.reduce(function (acc, field) {
	    if (!field.fieldName && field.disabled) {
	      return acc;
	    }
	    if (Array.isArray(field.value) && field.type !== 'select' && field.type !== 'medication') {
	      var complexValues = getFieldValues(field.value);
	
	      (0, _keys2.default)(complexValues).forEach(function (key) {
	        // TODO: think about it
	        var fromViewConverter = (0, _lodash.get)(field, 'converters.fromView');
	        var rawValue = complexValues[key];
	        var value = fromViewConverter ? fromViewConverter(rawValue) : rawValue;
	
	        (0, _lodash.set)(acc, key, value);
	      });
	    } else {
	      var fromViewConverter = (0, _lodash.get)(field, 'converters.fromView');
	      var value = fromViewConverter ? fromViewConverter(field.value) : field.value;
	      (0, _lodash.set)(acc, field.fieldName, value);
	    }
	
	    return acc;
	  }, {});
	};
	
	exports.default = getFieldValues;

/***/ }),
/* 3650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _strings = __webpack_require__(15);
	
	exports.default = function (type, value, formatMessage) {
	  return formatMessage(_strings.PROFILE.notificationSettings.label, {
	    type: formatMessage(_strings.PROFILE.notificationSettings.labels[type]),
	    value: value
	  });
	};

/***/ }),
/* 3651 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  return value.length > 1 ? value.replace(/./g, '•') : value;
	};

/***/ }),
/* 3652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _capitalize = __webpack_require__(209);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _trimStart = __webpack_require__(2358);
	
	var _trimStart2 = _interopRequireDefault(_trimStart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (name) {
	  if (!name) return name;
	
	  return (0, _trimStart2.default)(name).split(' ').map(function (word) {
	    return (0, _capitalize2.default)(word);
	  }).join(' ');
	};

/***/ }),
/* 3653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _strings = __webpack_require__(15);
	
	var _beautifyName = __webpack_require__(3652);
	
	var _beautifyName2 = _interopRequireDefault(_beautifyName);
	
	var _index = __webpack_require__(5103);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Program = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(Program, _PureComponent);
	
	  function Program() {
	    (0, _classCallCheck3.default)(this, Program);
	    return (0, _possibleConstructorReturn3.default)(this, (Program.__proto__ || (0, _getPrototypeOf2.default)(Program)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Program, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          program = _props.program,
	          className = _props.className;
	      var name = program.name,
	          description = program.description,
	          organization = program.organization;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        _react2.default.createElement(
	          'div',
	          { styleName: 'heading' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              { styleName: 'title' },
	              (0, _beautifyName2.default)(name)
	            )
	          )
	        ),
	        organization ? _react2.default.createElement(
	          'p',
	          { styleName: 'subtitle' },
	          organization.name
	        ) : null,
	        description ? _react2.default.createElement(
	          'div',
	          { styleName: 'block' },
	          _react2.default.createElement(
	            'p',
	            { styleName: 'blockTitle' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, _strings.ACTIONS.program.subtitle)
	          ),
	          _react2.default.createElement(
	            'p',
	            { styleName: 'blockContent' },
	            description
	          )
	        ) : null
	      );
	    }
	  }]);
	  return Program;
	}(_react.PureComponent), _class2.propTypes = {
	  program: _propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    name: _propTypes2.default.string,
	    organization: _propTypes2.default.shape({
	      id: _propTypes2.default.number,
	      name: _propTypes2.default.string
	    }),
	    description: _propTypes2.default.string,
	    logo: _propTypes2.default.objectOf(_propTypes2.default.string),
	    surveys: _propTypes2.default.array
	  }).isRequired,
	  className: _propTypes2.default.string
	}, _class2.defaultProps = {
	  className: ''
	}, _temp)) || _class);
	exports.default = Program;

/***/ }),
/* 3654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _PaymentAccountFormLoader = __webpack_require__(1189);
	
	var _PaymentAccountFormLoader2 = _interopRequireDefault(_PaymentAccountFormLoader);
	
	var _styles = __webpack_require__(18);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _viewProgramCost = __webpack_require__(1165);
	
	var _RadioGroup = __webpack_require__(1837);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _paymentInfoModal = __webpack_require__(541);
	
	var _popup = __webpack_require__(76);
	
	var _props = __webpack_require__(41);
	
	var _useDefaultCard2 = __webpack_require__(1858);
	
	var _useDefaultCard3 = _interopRequireDefault(_useDefaultCard2);
	
	var _accountVaultsForm = __webpack_require__(354);
	
	var _submitPaymentProgram = __webpack_require__(893);
	
	var _selectors = __webpack_require__(264);
	
	var _programs = __webpack_require__(618);
	
	var _constants = __webpack_require__(17);
	
	var _styles2 = __webpack_require__(5104);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MembershipPaymentInfoPopup = function MembershipPaymentInfoPopup(_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var waitingPayaPaymentResponse = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalWaitingPayaResponse);
	  var isOpened = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalOpen);
	  var programId = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalProgramId);
	  var userId = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalUserId);
	  var mainUserId = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalMainUserId);
	  var loadingCards = (0, _reactRedux.useSelector)(_selectors.selectAccountVaultsListLoading);
	  var subscriptionsSetting = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalSubscriptionsSetting);
	  var prepayFlow = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalPrepayFlow);
	  var duePaymentDate = (0, _reactRedux.useSelector)(_selectors.selectPaymentInfoModalDuePaymentDate);
	
	  var price = subscriptionsSetting.price,
	      period = subscriptionsSetting.period,
	      periodQuantity = subscriptionsSetting.periodQuantity,
	      recurrenceType = subscriptionsSetting.recurrenceType;
	
	
	  var isOneTimePurchase = recurrenceType === _programs.MEMBERSHIP_TYPE.ONE_TIME_PURCHASE;
	
	  var amount = (0, _viewProgramCost.viewProgramCost)({
	    price: price,
	    period: period,
	    recurrenceType: recurrenceType,
	    quantity: periodQuantity,
	    formatMessage: formatMessage
	  });
	
	  var _useDefaultCard = (0, _useDefaultCard3.default)(),
	      defaultCard = _useDefaultCard.defaultCard,
	      mappedCards = _useDefaultCard.mappedCards;
	
	  var onClose = function onClose() {
	    dispatch(_paymentInfoModal.paymentInfoModalActions.close());
	  };
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      cardAgreement = _useState2[0],
	      setCardAgreement = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      automaticallyRenew = _useState4[0],
	      setAutomaticallyRenew = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      selectedCardId = _useState6[0],
	      setSelectedCardId = _useState6[1];
	
	  var startDate = (0, _moment2.default)(prepayFlow ? duePaymentDate : new Date()).format('ll');
	
	  (0, _react.useEffect)(function () {
	    if (defaultCard) {
	      setSelectedCardId(defaultCard.id);
	    }
	  }, [defaultCard]);
	
	  var labelStyle = {
	    fontSize: '12px',
	    fontWeight: 'normal',
	    lineHeight: 'normal',
	    opacity: 1,
	    color: _styles.COLORS.fontRegular
	  };
	
	  var handleOnChange = function handleOnChange(id) {
	    return setSelectedCardId(id);
	  };
	
	  var handleAddNewCard = function handleAddNewCard() {
	    dispatch(_accountVaultsForm.actions.send({ userId: mainUserId, programId: programId }));
	    dispatch({
	      type: _popup.consts.SHOW,
	      payload: {
	        contentType: _props.UI_POPUP_TYPES.PAYA_ACCOUNT_FORM,
	        contentOptions: {
	          noCards: false
	        }
	      }
	    });
	  };
	
	  var handleSubmitPayment = function handleSubmitPayment() {
	    dispatch(_paymentInfoModal.paymentInfoModalActions.waitingPayaPaymentResponse());
	    dispatch(_submitPaymentProgram.actions.send({
	      transaction: (0, _extends3.default)({
	        userId: userId,
	        product: _constants.TRANSACTION_TYPE.USER_SUBSCRIPTION,
	        subscribableId: programId,
	        accountvaultId: selectedCardId,
	        subscribableType: _constants.SUBSCRIBABLE_TYPE.PROGRAM,
	        subscriptionsSettingId: subscriptionsSetting.id
	      }, !isOneTimePurchase && !prepayFlow && { autoRenewal: automaticallyRenew })
	    }));
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    { opened: isOpened, withHeading: false },
	    _react2.default.createElement(
	      'div',
	      { className: _styles3.default.root },
	      _react2.default.createElement(_BackButton2.default, {
	        onBack: onClose,
	        className: _styles3.default.backButton,
	        disabled: waitingPayaPaymentResponse
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_styles3.default.content, (0, _defineProperty3.default)({}, _styles3.default.loading, waitingPayaPaymentResponse))
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _styles3.default.title },
	          formatMessage({ id: 'appointment.list.card.payment' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles3.default.description },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _styles3.default.cellTitle },
	              formatMessage({ id: 'paya.payment.amount' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles3.default.cellText },
	              amount
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _styles3.default.cellTitle },
	              formatMessage({ id: 'paya.payment.startDate' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _styles3.default.cellText },
	              startDate
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles3.default.card },
	          _react2.default.createElement(
	            'div',
	            { className: _styles3.default.title },
	            formatMessage({ id: 'paya.payment.card' })
	          ),
	          loadingCards && !mappedCards.length ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(_RadioGroup2.default, {
	            name: 'cardsradioBtn',
	            value: selectedCardId,
	            onChange: handleOnChange,
	            radios: mappedCards
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _styles3.default.btnAdd },
	            _react2.default.createElement(
	              'button',
	              { type: 'button', onClick: handleAddNewCard },
	              _react2.default.createElement(_Icon2.default, {
	                name: 'add-text',
	                size: 16,
	                style: { fill: _styles.COLORS.bluePrimary }
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                formatMessage({ id: 'paya.payment.addNewPaymentMethod' })
	              )
	            )
	          ),
	          _react2.default.createElement(_Checkbox2.default, {
	            size: 16,
	            id: 'cardAgreement',
	            name: 'cardAgreement',
	            checked: cardAgreement,
	            labelStyle: labelStyle,
	            label: formatMessage({ id: 'paya.payment.cardAgreement' }),
	            onChange: function onChange() {
	              return setCardAgreement(function (prev) {
	                return !prev;
	              });
	            }
	          }),
	          !isOneTimePurchase && !prepayFlow && _react2.default.createElement(_Checkbox2.default, {
	            size: 16,
	            id: 'automaticallyRenew',
	            name: 'automaticallyRenew',
	            checked: automaticallyRenew,
	            labelStyle: labelStyle,
	            label: formatMessage({ id: 'paya.payment.automaticallyRenew' }),
	            onChange: function onChange() {
	              return setAutomaticallyRenew(function (prev) {
	                return !prev;
	              });
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _styles3.default.transactionDescription },
	            formatMessage({ id: 'paya.payment.transactionDescription' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles3.default.btnSubmit },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              disabled: cardAgreement === false || !mappedCards.length || waitingPayaPaymentResponse,
	              color: 'primary',
	              onClick: handleSubmitPayment
	            },
	            formatMessage({ id: 'paya.payment.submitPayment' })
	          )
	        )
	      )
	    ),
	    waitingPayaPaymentResponse && _react2.default.createElement(
	      'div',
	      { className: _styles3.default.loaderWrapper },
	      _react2.default.createElement(_PaymentAccountFormLoader2.default, null)
	    )
	  );
	};
	
	MembershipPaymentInfoPopup.propTypes = {
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MembershipPaymentInfoPopup);

/***/ }),
/* 3655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ShowMore = __webpack_require__(1844);
	
	var _ShowMore2 = _interopRequireDefault(_ShowMore);
	
	var _hooks = __webpack_require__(1164);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _ProgramSubscription = __webpack_require__(1796);
	
	var _ProgramSubscription2 = _interopRequireDefault(_ProgramSubscription);
	
	var _constants = __webpack_require__(17);
	
	var _ExpandableListItem = __webpack_require__(285);
	
	var _ExpandableListItem2 = _interopRequireDefault(_ExpandableListItem);
	
	var _viewProgramCost = __webpack_require__(1165);
	
	var _ActionConfirmation = __webpack_require__(130);
	
	var _ActionConfirmation2 = _interopRequireDefault(_ActionConfirmation);
	
	var _selectors = __webpack_require__(23);
	
	var _programs = __webpack_require__(618);
	
	var _useProgramSubscription = __webpack_require__(1859);
	
	var _useProgramSubscription2 = _interopRequireDefault(_useProgramSubscription);
	
	var _leaveProgram = __webpack_require__(892);
	
	var _acceptInvitation = __webpack_require__(687);
	
	var _declineInvitation = __webpack_require__(689);
	
	var _styles = __webpack_require__(5105);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatDate = function formatDate(date) {
	  return date && (0, _moment2.default)(date).format('MMM DD, YYYY');
	};
	
	function ProgramCard(_ref) {
	  var program = _ref.program,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      confirm = _useState2[0],
	      setConfirm = _useState2[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _ref2 = (0, _reactRedux.useSelector)(_selectors.targetUserSelector) || {},
	      userId = _ref2.id,
	      displayableName = _ref2.displayableName;
	
	  var mainUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	
	  var _program = (0, _extends3.default)({}, program),
	      _program$logo = _program.logo,
	      logo = _program$logo === undefined ? {} : _program$logo,
	      title = _program.name,
	      programType = _program.programType,
	      description = _program.description,
	      organization = _program.organization,
	      _program$joinHistory = _program.joinHistory,
	      joinHistory = _program$joinHistory === undefined ? [] : _program$joinHistory,
	      withSubscription = _program.withSubscription,
	      _program$patientInvit = _program.patientInvitation,
	      patientInvitation = _program$patientInvit === undefined ? {} : _program$patientInvit,
	      _program$subscription = _program.subscriptionOption,
	      subscriptionOption = _program$subscription === undefined ? {} : _program$subscription;
	
	  var _useProgramSubscripti = (0, _useProgramSubscription2.default)({ program: program }),
	      handleChangeMembershipDuration = _useProgramSubscripti.handleChangeMembershipDuration,
	      isSubscriptionStatusPending = _useProgramSubscripti.isSubscriptionStatusPending,
	      moreThanOneSubscriptionOption = _useProgramSubscripti.moreThanOneSubscriptionOption,
	      prepaidByProvider = _useProgramSubscripti.prepaidByProvider,
	      selectedMembershipId = _useProgramSubscripti.selectedMembershipId,
	      subscriptionsSetting = _useProgramSubscripti.subscriptionsSetting;
	
	  var _subscriptionsSetting = (0, _extends3.default)({}, subscriptionsSetting),
	      price = _subscriptionsSetting.price,
	      period = _subscriptionsSetting.period,
	      periodQuantity = _subscriptionsSetting.periodQuantity,
	      recurrenceType = _subscriptionsSetting.recurrenceType;
	
	  var allowPrepay = (0, _get2.default)(subscriptionOption, 'prepayAllowed', false);
	  var duePaymentDate = (0, _get2.default)(subscriptionOption, 'expiredAt', '');
	  var autoRenewal = (0, _get2.default)(subscriptionOption, 'autoRenewal', false);
	  var expiredStatus = (0, _get2.default)(subscriptionOption, 'status', '') === _constants.SUBSCRIPTION_STATUS.EXPIRED;
	
	  var isOneTimePurchase = recurrenceType === _programs.MEMBERSHIP_TYPE.ONE_TIME_PURCHASE;
	
	  var _organization = (0, _extends3.default)({}, organization),
	      subtitle = _organization.name,
	      organizationId = _organization.id;
	
	  var _patientInvitation = (0, _extends3.default)({}, patientInvitation),
	      _patientInvitation$co = _patientInvitation.consents,
	      consents = _patientInvitation$co === undefined ? [] : _patientInvitation$co;
	
	  var activeType = programType === _programs.PROGRAM_TYPE.ACTIVE;
	  var inviteType = programType === _programs.PROGRAM_TYPE.INVITES;
	  var historyType = programType === _programs.PROGRAM_TYPE.HISTORY;
	
	  var _useProgramConsents = (0, _hooks.useProgramConsents)({
	    program: program,
	    consents: consents,
	    formatMessage: formatMessage
	  }),
	      list = _useProgramConsents.list,
	      proxify = _useProgramConsents.proxify;
	
	  var payload = {
	    userId: userId,
	    organizationId: organizationId,
	    duePaymentDate: duePaymentDate,
	    withSubscription: withSubscription,
	    prepaidByProvider: prepaidByProvider,
	    programName: title,
	    subscriptionsSetting: subscriptionsSetting,
	    programId: (0, _get2.default)(program, 'id'),
	    invitationId: (0, _get2.default)(patientInvitation, 'id')
	  };
	
	  var icon = (0, _react.useMemo)(function () {
	    return logo.thumbMin && _react2.default.createElement(_SimpleAvatar2.default, {
	      size: 32,
	      text: title,
	      className: 'mr2',
	      src: logo.thumbMin
	    });
	  }, [logo]);
	
	  var note = (0, _react.useMemo)(function () {
	    var _PROGRAM_TYPE$ACTIVE$;
	
	    return (_PROGRAM_TYPE$ACTIVE$ = {}, (0, _defineProperty3.default)(_PROGRAM_TYPE$ACTIVE$, _programs.PROGRAM_TYPE.ACTIVE, _react2.default.createElement(
	      _react.Fragment,
	      null,
	      withSubscription && duePaymentDate && !autoRenewal && formatMessage({
	        id: 'program.membership.paymentDue'
	      }) + ' ' + formatDate(duePaymentDate)
	    )), (0, _defineProperty3.default)(_PROGRAM_TYPE$ACTIVE$, _programs.PROGRAM_TYPE.HISTORY, _react2.default.createElement(
	      _react.Fragment,
	      null,
	      expiredStatus ? formatMessage({ id: 'common.expired' }) + ' ' + formatDate((0, _get2.default)(subscriptionOption, 'expiredAt')) : formatDate((0, _get2.default)(joinHistory, '[0].joinedAt')) + ' - ' + formatDate((0, _get2.default)(joinHistory, '[0].removedAt'))
	    )), (0, _defineProperty3.default)(_PROGRAM_TYPE$ACTIVE$, _programs.PROGRAM_TYPE.INVITES, _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'accent',
	          className: _styles2.default.button,
	          onClick: function onClick() {
	            dispatch(_declineInvitation.actions.init(payload));
	          }
	        },
	        formatMessage({ id: 'common.decline' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          color: 'primary',
	          className: _styles2.default.button,
	          disabled: moreThanOneSubscriptionOption && !selectedMembershipId,
	          onClick: proxify(function () {
	            dispatch(_acceptInvitation.actions.init(payload));
	          })
	        },
	        formatMessage({
	          id: withSubscription && !prepaidByProvider ? 'program.membership.pay' : 'common.join'
	        })
	      )
	    )), _PROGRAM_TYPE$ACTIVE$)[programType];
	  }, [proxify, programType, joinHistory, withSubscription, subscriptionOption, moreThanOneSubscriptionOption, selectedMembershipId]);
	
	  var handleViewNextPayment = (0, _react.useMemo)(function () {
	    if (duePaymentDate && autoRenewal) return formatDate(duePaymentDate);
	    return '-';
	  }, [duePaymentDate]);
	
	  var safeContent = (0, _react.useMemo)(function () {
	    return mainUserId === userId ? formatMessage({ id: 'program.card.leave.body' }) : formatMessage({ id: 'program.card.leave.body.ar' }, { dependentName: displayableName });
	  }, [mainUserId, userId, displayableName]);
	
	  return _react2.default.createElement(
	    _ExpandableListItem2.default,
	    {
	      opened: inviteType,
	      locked: inviteType,
	      className: _styles2.default.card,
	      header: {
	        note: note,
	        title: title,
	        subtitle: subtitle,
	        reverseTitle: true,
	        icon: icon || 'program'
	      }
	    },
	    inviteType ? _react2.default.createElement(
	      'div',
	      { className: _styles2.default.section },
	      _react2.default.createElement(
	        'p',
	        { className: 'f-12' },
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.subtitle },
	          subtitle,
	          ' '
	        ),
	        formatMessage({ id: 'program.invite.details.titleInvite' }, { name: title })
	      ),
	      _react2.default.createElement(_ProgramSubscription2.default, {
	        formatMessage: formatMessage,
	        handleChangeMembershipDuration: handleChangeMembershipDuration,
	        isSubscriptionStatusPending: isSubscriptionStatusPending,
	        prepaidByProvider: prepaidByProvider,
	        program: program,
	        selectedMembershipId: selectedMembershipId,
	        subscriptionsSetting: subscriptionsSetting
	      })
	    ) : null,
	    withSubscription && (activeType || historyType) ? [_react2.default.createElement(
	      'div',
	      { className: _styles2.default.paidProgramInfo, key: '0'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.columnWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.programCost },
	          formatMessage({ id: 'program.membership.title' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.activeProgramCost },
	          (0, _viewProgramCost.viewProgramCost)({
	            price: price,
	            period: period,
	            formatMessage: formatMessage,
	            recurrenceType: recurrenceType,
	            quantity: periodQuantity
	          })
	        )
	      ),
	      !historyType && !isOneTimePurchase && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.columnWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.programCost },
	          formatMessage({ id: 'program.membership.nextPayment' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.activeProgramCost },
	          handleViewNextPayment
	        )
	      )
	    ), activeType && allowPrepay && _react2.default.createElement(
	      _Button2.default,
	      {
	        raised: true,
	        color: 'primary',
	        className: _styles2.default.prepayButton,
	        onClick: proxify(function () {
	          dispatch(_acceptInvitation.actions.init((0, _extends3.default)({}, payload, {
	            prepayFlow: true
	          })));
	        })
	      },
	      formatMessage({ id: 'program.membership.prepay' })
	    )] : null,
	    consents.length ? _react2.default.createElement(
	      'div',
	      { className: _styles2.default.section },
	      list
	    ) : null,
	    description ? _react2.default.createElement(
	      'div',
	      { className: _styles2.default.section },
	      _react2.default.createElement(
	        'p',
	        { className: _styles2.default.title },
	        formatMessage({ id: 'program.invite.details.descriptionTitle' })
	      ),
	      _react2.default.createElement(
	        _ShowMore2.default,
	        {
	          minHeight: 14 * 3,
	          more: formatMessage({ id: 'common.readMore' }),
	          less: formatMessage({ id: 'common.collapse' })
	        },
	        _react2.default.createElement(
	          'p',
	          { className: _styles2.default.description },
	          description
	        )
	      )
	    ) : null,
	    activeType ? _react2.default.createElement(
	      'div',
	      { className: _styles2.default.section },
	      _react2.default.createElement(
	        _Button2.default,
	        { border: true, color: 'accent', onClick: function onClick() {
	            return setConfirm(true);
	          } },
	        formatMessage({ id: 'program.card.leave' })
	      )
	    ) : null,
	    historyType && expiredStatus ? _react2.default.createElement(
	      'div',
	      { className: _styles2.default.section },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          raised: true,
	          color: 'primary',
	          className: _styles2.default.purchaseAgainButton,
	          onClick: proxify(function () {
	            dispatch(_acceptInvitation.actions.init((0, _extends3.default)({}, payload, {
	              purchaseAgain: true
	            })));
	          })
	        },
	        formatMessage({ id: 'program.membership.pay' })
	      )
	    ) : null,
	    _react2.default.createElement(_ActionConfirmation2.default, {
	      opened: confirm,
	      onClose: function onClose() {
	        return setConfirm(false);
	      },
	      actionButtonText: formatMessage({ id: 'common.leave' }),
	      title: formatMessage({ id: 'program.card.leave.title' }),
	      content: safeContent,
	      onSubmit: function onSubmit() {
	        return dispatch(_leaveProgram.actions.init(payload));
	      }
	    })
	  );
	}
	
	ProgramCard.propTypes = {
	  intl: _propTypes2.default.object,
	  program: _propTypes2.default.object
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl)(ProgramCard);

/***/ }),
/* 3656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useProgramConsents = useProgramConsents;
	
	var _reactRedux = __webpack_require__(6);
	
	var _hooks = __webpack_require__(3204);
	
	var _acceptConsent = __webpack_require__(890);
	
	function useProgramConsents(_ref) {
	  var program = _ref.program,
	      consents = _ref.consents,
	      _ref$todo = _ref.todo,
	      todo = _ref$todo === undefined ? {} : _ref$todo,
	      formatMessage = _ref.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var onAccept = function onAccept(consent) {
	    return dispatch(_acceptConsent.actions.init({
	      todoId: todo.itemId,
	      consentId: consent.id,
	      programId: program.id
	    }));
	  };
	
	  var details = {
	    title: formatMessage({ id: 'program.consent.title' }),
	    subtitle: formatMessage({ id: 'program.consent.subtitle' }),
	    for: formatMessage({ id: 'program.consent.for' }, { name: program.organizationName })
	  };
	
	  return (0, _hooks.useConsents)({ details: details, consents: consents, onAccept: onAccept });
	}

/***/ }),
/* 3657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useProgramTabs = useProgramTabs;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(42);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _ProgramCard = __webpack_require__(3655);
	
	var _ProgramCard2 = _interopRequireDefault(_ProgramCard);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _selectors = __webpack_require__(115);
	
	var _programs = __webpack_require__(618);
	
	var _index = __webpack_require__(2264);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useProgramTabs(_ref) {
	  var user = _ref.user,
	      sending = _ref.sending,
	      programs = _ref.programs,
	      counters = _ref.counters,
	      formatMessage = _ref.formatMessage,
	      deepLinkProgramTab = _ref.deepLinkProgramTab;
	
	  var _useState = (0, _react.useState)(_programs.PROGRAM_TYPE.ACTIVE),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      active = _useState2[0],
	      setActive = _useState2[1];
	
	  var pathname = (0, _reactRedux.useSelector)(_selectors.currentLocationSelector);
	
	  (0, _react.useEffect)(function () {
	    if (deepLinkProgramTab) {
	      setActive(deepLinkProgramTab);
	      _reactRouter.browserHistory.push({ pathname: pathname, search: '' });
	    }
	  }, [deepLinkProgramTab]);
	
	  var list = (0, _react.useMemo)(function () {
	    return (0, _values2.default)(_programs.PROGRAM_TYPE).map(function (tab, id) {
	      return {
	        id: id,
	        tab: tab,
	        label: 'programs.tabs.' + tab,
	        counter: counters[_programs.PROGRAM_COUNTERS[tab]] || 0
	      };
	    });
	  }, [counters]);
	
	  var render = (0, _react.useCallback)(function (tab) {
	    if (sending) return _react2.default.createElement(_Loader2.default, null);
	
	    return programs.length ? programs.map(function (program) {
	      return _react2.default.createElement(_ProgramCard2.default, { program: program, key: program.id });
	    }) : _react2.default.createElement(_Content2.default, {
	      icon: 'programs-empty',
	      className: _index2.default.placeholder,
	      text: formatMessage({ id: 'programs.tabs.' + tab + '.placeholder' }, { name: user })
	    });
	  }, [user, sending, programs]);
	
	  return { list: list, render: render, active: active, setActive: setActive };
	}

/***/ }),
/* 3658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactRedux = __webpack_require__(6);
	
	var _context = __webpack_require__(216);
	
	var _joinedPrograms = __webpack_require__(891);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(264);
	
	var _routes = __webpack_require__(37);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _hooks = __webpack_require__(1164);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _MobileNavbar = __webpack_require__(256);
	
	var _MobileNavbar2 = _interopRequireDefault(_MobileNavbar);
	
	var _CommonTabs = __webpack_require__(255);
	
	var _selectors3 = __webpack_require__(157);
	
	var _index = __webpack_require__(2264);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MobileNavigation(_ref) {
	  var title = _ref.title,
	      isHandleBack = _ref.isHandleBack;
	
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { maxWidth: _styles.BREAKPOINT },
	    _react2.default.createElement(
	      _MobileNavbar2.default,
	      { openContext: 'arrow-down', toggleContext: isHandleBack },
	      _react2.default.createElement('p', { children: title })
	    )
	  );
	}
	
	MobileNavigation.propTypes = {
	  title: _propTypes2.default.string,
	  isHandleBack: _propTypes2.default.func
	};
	
	function Programs(_ref2) {
	  var routes = _ref2.routes,
	      id = _ref2.params.id,
	      formatMessage = _ref2.intl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var profileData = (0, _reactRedux.useSelector)(_selectors.targetUserSelector);
	  var targetUserId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	  var programs = (0, _reactRedux.useSelector)(_selectors2.joinedProgramsListSelector);
	  var counters = (0, _reactRedux.useSelector)(_selectors2.joinedProgramsMetaSelector);
	  var sending = (0, _reactRedux.useSelector)(_selectors2.joinedProgramsSendingSelector);
	  var deepLinkProgramTab = (0, _reactRedux.useSelector)(_selectors3.selectDeepLinkTab);
	
	  var user = profileData.displayableName;
	
	  var tabs = (0, _hooks.useProgramTabs)({
	    user: user,
	    sending: sending,
	    programs: programs,
	    counters: counters,
	    formatMessage: formatMessage,
	    deepLinkProgramTab: deepLinkProgramTab
	  });
	
	  (0, _usePageView.usePageView)('Programs');
	
	  (0, _react.useEffect)(function () {
	    if (Number(id) !== targetUserId) dispatch(_context.actions.setTargetUserId({ id: id }));
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    dispatch(_joinedPrograms.actions.send({ id: id, filterBy: tabs.active }));
	  }, [id, tabs.active]);
	
	  var handleBack = function handleBack() {
	    _reactRouter.browserHistory.push('/' + _routes.MESSAGES);
	  };
	
	  var isProfile = (0, _get2.default)(routes, '[1].path') === 'profile';
	  var rootClassName = !isProfile ? 'g-content' : '';
	
	  return _react2.default.createElement(
	    'div',
	    { className: rootClassName, styleName: 'root' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.programs' }),
	    !isProfile ? [_react2.default.createElement(
	      _reactResponsive2.default,
	      { maxWidth: _styles.BREAKPOINT, key: '0'
	      },
	      _react2.default.createElement(MobileNavigation, {
	        isHandleBack: handleBack,
	        title: formatMessage(_strings.PROGRAMS_TITLE)
	      })
	    ), _react2.default.createElement(
	      'div',
	      { styleName: 'header', key: '1'
	      },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: _styles.BREAKPOINT },
	        _react2.default.createElement(_BackButton2.default, { onBack: handleBack })
	      )
	    )] : null,
	    _react2.default.createElement(
	      'div',
	      { styleName: 'content' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'content-header' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { styleName: 'program-title' },
	            formatMessage(_strings.PROGRAMS_TITLE)
	          ),
	          _react2.default.createElement(
	            'div',
	            { styleName: 'program-context' },
	            ' ',
	            formatMessage(_strings.CHAT.inContextOf),
	            ' ',
	            user
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'program-container' },
	        _react2.default.createElement(_CommonTabs.CommonTabs, {
	          tabList: tabs.list,
	          activeTab: tabs.active,
	          renderContent: tabs.render,
	          onTabSelect: tabs.setActive
	        })
	      )
	    )
	  );
	}
	
	Programs.propTypes = {
	  intl: _propTypes2.default.object,
	  routes: _propTypes2.default.array,
	  params: _propTypes2.default.object
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(Programs);

/***/ }),
/* 3659 */,
/* 3660 */,
/* 3661 */,
/* 3662 */,
/* 3663 */,
/* 3664 */,
/* 3665 */,
/* 3666 */,
/* 3667 */,
/* 3668 */,
/* 3669 */,
/* 3670 */,
/* 3671 */,
/* 3672 */,
/* 3673 */,
/* 3674 */,
/* 3675 */,
/* 3676 */,
/* 3677 */,
/* 3678 */,
/* 3679 */,
/* 3680 */,
/* 3681 */,
/* 3682 */,
/* 3683 */,
/* 3684 */,
/* 3685 */,
/* 3686 */,
/* 3687 */,
/* 3688 */,
/* 3689 */,
/* 3690 */,
/* 3691 */,
/* 3692 */,
/* 3693 */,
/* 3694 */,
/* 3695 */,
/* 3696 */,
/* 3697 */,
/* 3698 */,
/* 3699 */,
/* 3700 */,
/* 3701 */,
/* 3702 */,
/* 3703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(50);
	
	var _profileFieldSet = __webpack_require__(1798);
	
	var _styles = __webpack_require__(1505);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    rawGenderList: (0, _selectors.selectGenderTypes)(state),
	    languagesList: (0, _selectors.selectLanguageTypes)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps), (0, _recompose.withProps)(function (_ref) {
	  var rawGenderList = _ref.rawGenderList,
	      languagesList = _ref.languagesList,
	      _ref$profile = _ref.profile,
	      profile = _ref$profile === undefined ? {} : _ref$profile,
	      formatMessage = _ref.intl.formatMessage;
	  return {
	    newProp: true,
	    generalInfoFields: (0, _profileFieldSet.getGeneralInfoFields)(profile)(formatMessage),
	    addressInfoFields: (0, _profileFieldSet.getAddressInfoFields)(profile)(formatMessage),
	    personalInfoFields: (0, _profileFieldSet.getPersonalInfoFields)(profile, rawGenderList, languagesList)(formatMessage)
	  };
	}), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PublicProfileDetails = exports.PublicProfileDetailsImpl = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _chat = __webpack_require__(67);
	
	var _ConversationBtn = __webpack_require__(1787);
	
	var _FieldSetList = __webpack_require__(334);
	
	var _FieldSetList2 = _interopRequireDefault(_FieldSetList);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _enhance = __webpack_require__(3703);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PublicProfileDetailsImpl = exports.PublicProfileDetailsImpl = function PublicProfileDetailsImpl(_ref) {
	  var _ref$profile = _ref.profile;
	  _ref$profile = _ref$profile === undefined ? {} : _ref$profile;
	  var id = _ref$profile.id,
	      avatar = _ref$profile.avatar,
	      username = _ref$profile.username,
	      isProvider = _ref$profile.isProvider,
	      fullName = _ref.fullName,
	      generalInfoFields = _ref.generalInfoFields,
	      personalInfoFields = _ref.personalInfoFields,
	      addressInfoFields = _ref.addressInfoFields;
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'content content--profile' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'userAvatar', className: 'user-profile-avatar' },
	      _react2.default.createElement(_Avatar2.default, { src: (0, _get2.default)(avatar, 'thumbMiddle'), children: fullName, size: 96 })
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'info' },
	      _react2.default.createElement(
	        'div',
	        {
	          styleName: 'userName',
	          className: (0, _classnames2.default)('pb3 flex', {
	            'items-center justify-between': (0, _mobileHelpers.isDesktop)(),
	            'flex-column': !(0, _mobileHelpers.isDesktop)()
	          })
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'user-profile-name' },
	            fullName
	          ),
	          username ? _react2.default.createElement(
	            'span',
	            {
	              styleName: 'colored user-profile-username',
	              className: 'user-profile-username ml2'
	            },
	            username
	          ) : null
	        ),
	        _chat.ALLOW_SOCIAL_CHAT_CREATION && _react2.default.createElement(_ConversationBtn.ConversationBtn, { userId: id })
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'common' },
	        _react2.default.createElement(_FieldSetList2.default, {
	          fieldSetList: generalInfoFields,
	          disabled: true,
	          canEdit: false
	        })
	      ),
	      !isProvider ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FieldSetList2.default, {
	          fieldSetList: personalInfoFields,
	          disabled: true,
	          canEdit: false
	        }),
	        _react2.default.createElement(_FieldSetList2.default, {
	          fieldSetList: addressInfoFields,
	          disabled: true,
	          canEdit: false
	        })
	      ) : null
	    )
	  );
	};
	
	PublicProfileDetailsImpl.propTypes = {
	  fullName: _propTypes2.default.string.isRequired,
	  profile: _propTypes2.default.object.isRequired,
	  generalInfoFields: _propTypes2.default.array.isRequired,
	  personalInfoFields: _propTypes2.default.array.isRequired,
	  addressInfoFields: _propTypes2.default.array.isRequired
	};
	
	var PublicProfileDetails = exports.PublicProfileDetails = (0, _enhance.enhance)(PublicProfileDetailsImpl);

/***/ }),
/* 3705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PublicProfileInfo = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(42);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _profileFieldSet = __webpack_require__(1798);
	
	var _FieldSetList = __webpack_require__(334);
	
	var _FieldSetList2 = _interopRequireDefault(_FieldSetList);
	
	var _routes = __webpack_require__(37);
	
	var _styles = __webpack_require__(1505);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PublicProfileInfoImpl = function PublicProfileInfoImpl(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      _ref$profile = _ref.profile;
	  _ref$profile = _ref$profile === undefined ? {} : _ref$profile;
	  var id = _ref$profile.id,
	      primaryPatientProfile = _ref$profile.primaryPatientProfile,
	      primaryProviderProfile = _ref$profile.primaryProviderProfile;
	
	  if (!(primaryPatientProfile || primaryProviderProfile)) {
	    _reactRouter.browserHistory.push(_routes.PUBLIC_PROFILE + '/' + id);
	    return null;
	  }
	
	  var fieldSet = primaryPatientProfile ? (0, _profileFieldSet.getPatientFieldSet)(primaryPatientProfile) : (0, _profileFieldSet.getProviderFieldSet)(primaryProviderProfile);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'content content--profile content--info' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'info' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FieldSetList2.default, { fieldSetList: fieldSet(formatMessage), disabled: true })
	      )
	    )
	  );
	};
	
	PublicProfileInfoImpl.propTypes = {
	  intl: _propTypes2.default.object.isRequired,
	  profile: _propTypes2.default.object.isRequired
	};
	
	var PublicProfileInfo = exports.PublicProfileInfo = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }))(PublicProfileInfoImpl);

/***/ }),
/* 3706 */,
/* 3707 */,
/* 3708 */,
/* 3709 */,
/* 3710 */,
/* 3711 */,
/* 3712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckAnswer = function CheckAnswer(_ref) {
	  var tempId = _ref.tempId,
	      selectedValue = _ref.selectedValue,
	      settings = _ref.settings,
	      onChange = _ref.onChange;
	
	  var _useState = (0, _react.useState)(selectedValue === 'true'),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      checked = _useState2[0],
	      toggleCheckbox = _useState2[1];
	
	  var handleChange = function handleChange(value) {
	    toggleCheckbox(value);
	    onChange(value ? 'true' : null);
	  };
	
	  return _react2.default.createElement(_Checkbox2.default, {
	    label: (0, _get2.default)(settings, 'meta.consentDescription.checkboxText'),
	    checked: checked,
	    id: tempId,
	    onChange: handleChange
	  });
	};
	
	CheckAnswer.propTypes = {
	  onChange: _propTypes2.default.func,
	  settings: _propTypes2.default.object,
	  selectedValue: _propTypes2.default.string,
	  tempId: _propTypes2.default.string
	};
	
	exports.default = CheckAnswer;

/***/ }),
/* 3713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_INPUT = 6;
	var INPUT_WIDTH = 80;
	
	var NumericAnswer = function NumericAnswer(_ref) {
	  var tempId = _ref.tempId,
	      selectedValue = _ref.selectedValue,
	      onChange = _ref.onChange;
	  return _react2.default.createElement(_TextInput2.default, {
	    limit: MAX_INPUT,
	    style: { width: INPUT_WIDTH },
	    type: 'number',
	    name: tempId,
	    value: selectedValue,
	    isFractionNumber: true,
	    step: 'any',
	    onChange: onChange
	  });
	};
	
	exports.default = NumericAnswer;

/***/ }),
/* 3714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INPUT_WIDTH = 80;
	var OPTIONS = [{ value: 'true', label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'common.yes' }) }, { value: 'false', label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'common.no' }) }];
	
	var SelectAnswer = function SelectAnswer(_ref) {
	  var tempId = _ref.tempId,
	      selectedValue = _ref.selectedValue,
	      _onChange = _ref.onChange;
	
	  var selected = selectedValue ? OPTIONS.find(function (opt) {
	    return opt.value.toString() === selectedValue;
	  }) : null;
	
	  return _react2.default.createElement(_SelectCustom2.default, {
	    options: OPTIONS,
	    style: { width: INPUT_WIDTH },
	    placeholder: '',
	    name: '' + tempId,
	    searchable: false,
	    defaultValue: selected ? String(selected.value) : null,
	    onChange: function onChange(value) {
	      return _onChange(String(value.value));
	    }
	  });
	};
	
	exports.default = SelectAnswer;

/***/ }),
/* 3715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_SIZE_INPUT_TEXT = 255;
	
	var TextAnswer = function TextAnswer(_ref) {
	  var tempId = _ref.tempId,
	      selectedValue = _ref.selectedValue,
	      onChange = _ref.onChange;
	  return _react2.default.createElement(_TextInput2.default, {
	    className: 'w-100',
	    limit: MAX_SIZE_INPUT_TEXT,
	    type: 'text',
	    name: tempId,
	    value: selectedValue,
	    onChange: onChange
	  });
	};
	
	exports.default = TextAnswer;

/***/ }),
/* 3716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _TextAnswer = __webpack_require__(3715);
	
	var _TextAnswer2 = _interopRequireDefault(_TextAnswer);
	
	var _CheckAnswer = __webpack_require__(3712);
	
	var _CheckAnswer2 = _interopRequireDefault(_CheckAnswer);
	
	var _SelectAnswer = __webpack_require__(3714);
	
	var _SelectAnswer2 = _interopRequireDefault(_SelectAnswer);
	
	var _NumericAnswer = __webpack_require__(3713);
	
	var _NumericAnswer2 = _interopRequireDefault(_NumericAnswer);
	
	var _PickList = __webpack_require__(1834);
	
	var _PickList2 = _interopRequireDefault(_PickList);
	
	var _ScaleRange = __webpack_require__(1840);
	
	var _ScaleRange2 = _interopRequireDefault(_ScaleRange);
	
	var _SingleSelect = __webpack_require__(257);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _props = __webpack_require__(41);
	
	var _getScaleAnswers = __webpack_require__(1922);
	
	var _getScaleAnswers2 = _interopRequireDefault(_getScaleAnswers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Answers = function Answers(_ref) {
	  var answer = _ref.answer,
	      question = _ref.question,
	      _onChange = _ref.onChange;
	
	  var type = (0, _get2.default)(question, 'settings.name');
	
	  var _ref2 = question || {},
	      id = _ref2.id,
	      settings = _ref2.settings;
	
	  var list = (0, _get2.default)(settings, 'meta.availableAnswers');
	  var tempId = 'answer-' + id;
	
	  (0, _react.useEffect)(function () {
	    if (answer) _onChange(answer);
	  }, []);
	
	  switch (type) {
	    case _props.QUESTION_TYPES.appointmentConsent:
	      {
	        return _react2.default.createElement(_SingleSelect2.default, {
	          name: tempId,
	          list: ['No', 'Yes'],
	          selectedValue: answer || null,
	          onChange: function onChange(value) {
	            return _onChange(value === 'Yes' ? 'true' : 'false');
	          }
	        });
	      }
	    case _props.QUESTION_TYPES.general:
	      {
	        return _react2.default.createElement(_SelectAnswer2.default, {
	          tempId: tempId,
	          selectedValue: answer,
	          onChange: _onChange
	        });
	      }
	    case _props.QUESTION_TYPES.consent:
	      {
	        return _react2.default.createElement(_CheckAnswer2.default, {
	          settings: settings,
	          selectedValue: answer,
	          tempId: tempId,
	          onChange: _onChange
	        });
	      }
	    case _props.QUESTION_TYPES.numeric:
	      return _react2.default.createElement(_NumericAnswer2.default, (0, _extends3.default)({ tempId: tempId }, {
	        selectedValue: answer,
	        onChange: _onChange
	      }));
	    case _props.QUESTION_TYPES.text:
	      return _react2.default.createElement(_TextAnswer2.default, (0, _extends3.default)({ tempId: tempId }, {
	        selectedValue: answer,
	        onChange: _onChange
	      }));
	    case _props.QUESTION_TYPES.multiSelect:
	      return _react2.default.createElement(_PickList2.default, (0, _extends3.default)({ list: list }, {
	        name: tempId + '[]',
	        selectedItems: answer,
	        onChange: _onChange
	      }));
	    case _props.QUESTION_TYPES.singleSelect:
	      return _react2.default.createElement(_SingleSelect2.default, (0, _extends3.default)({
	        name: tempId
	      }, { list: list }, {
	        selectedValue: answer || null,
	        onChange: _onChange
	      }));
	    case _props.QUESTION_TYPES.scale:
	      {
	        var scaleDescription = (0, _get2.default)(settings, 'meta.scaleDescription', {});
	        var scaleAnswers = (0, _getScaleAnswers2.default)(scaleDescription);
	
	        return _react2.default.createElement(_ScaleRange2.default, {
	          name: tempId,
	          list: scaleAnswers,
	          selectedItem: answer,
	          onChange: _onChange
	        });
	      }
	
	    default:
	      return null;
	  }
	};
	
	Answers.propTypes = {
	  question: _propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    text: _propTypes2.default.string,
	    settings: _propTypes2.default.shape({
	      name: _propTypes2.default.string,
	      displayableName: _propTypes2.default.string,
	      meta: _propTypes2.default.object
	    })
	  }),
	  answer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number]),
	  surveyId: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	};
	
	Answers.defaultProps = {
	  onChange: function onChange() {}
	};
	
	exports.default = Answers;

/***/ }),
/* 3717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _actions = __webpack_require__(4172);
	
	var _selectors = __webpack_require__(23);
	
	var _appointmentConsentReq = __webpack_require__(898);
	
	var appointmentConsent = _interopRequireWildcard(_appointmentConsentReq);
	
	var _index = __webpack_require__(5140);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    targetUserId: (0, _selectors.targetUserIdSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  getAppointmentConsent: appointmentConsent.actions.send,
	  linkConsent: _actions.surveyActions.linkConsent
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var assignmentId = _ref.assignmentId,
	      targetUserId = _ref.targetUserId,
	      settings = _ref.settings,
	      linkConsent = _ref.linkConsent;
	
	  return {
	    onLink: function onLink() {
	      return linkConsent({
	        settings: settings,
	        assignmentId: assignmentId,
	        targetUserId: targetUserId
	      });
	    }
	  };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _injectSaga = __webpack_require__(116);
	
	var _injectSaga2 = _interopRequireDefault(_injectSaga);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _consentSaga = __webpack_require__(1370);
	
	var _consentSaga2 = _interopRequireDefault(_consentSaga);
	
	var _index = __webpack_require__(5141);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _injectSaga2.default)({
	  key: 'consentSaga',
	  saga: _consentSaga2.default,
	  mode: _sagaInjectors.RESTART_ON_REMOUNT
	}), _reactIntl.injectIntl, (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useDynamicQuestionsTree = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _uniq = __webpack_require__(380);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _checkComment = __webpack_require__(4238);
	
	var _checkComment2 = _interopRequireDefault(_checkComment);
	
	var _upcomingSurvey = __webpack_require__(433);
	
	var _getFlatQuestionsWithPosition = __webpack_require__(1802);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAX_PROGRESS_VALUE = 100;
	
	var useDynamicQuestionsTree = exports.useDynamicQuestionsTree = function useDynamicQuestionsTree(_ref) {
	  var config = _ref.config,
	      answers = _ref.answers,
	      onSubmit = _ref.onSubmit,
	      questions = _ref.questions,
	      setProgress = _ref.setProgress,
	      selectedValue = _ref.selectedValue;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      viewQuestion = _useState2[0],
	      setViewQuestion = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      nextViewQuestion = _useState4[0],
	      setNextViewQuestion = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      answeredQuestions = _useState6[0],
	      setAnsweredQuestions = _useState6[1];
	
	  var flatQuestions = (0, _getFlatQuestionsWithPosition.getFlatQuestionsWithPosition)(questions, false).map(function (vQ) {
	    var previousValue = answers.find(function (q) {
	      return q.questionId === vQ.id;
	    });
	    return (0, _extends3.default)({}, vQ, {
	      answerValue: previousValue ? previousValue.value : ''
	    });
	  });
	
	  (0, _react.useEffect)(function () {
	    if (viewQuestion) {
	      getTargetViewQuestion({
	        target: viewQuestion,
	        value: selectedValue,
	        assumptionLastStep: true,
	        currentId: viewQuestion.id,
	        handleAction: setNextViewQuestion
	      });
	    }
	  }, [selectedValue, viewQuestion]);
	
	  (0, _react.useEffect)(function () {
	    var predefinedFlatQuestions = flatQuestions.filter(function (q) {
	      return !!q.answerValue;
	    }).map(function (q) {
	      return q.id;
	    });
	
	    setAnsweredQuestions(predefinedFlatQuestions);
	
	    if (!(0, _isEmpty2.default)(predefinedFlatQuestions)) {
	      var targetView = flatQuestions.find(function (q) {
	        return q.id === predefinedFlatQuestions[predefinedFlatQuestions.length - 1];
	      });
	      getTargetViewQuestion({
	        target: targetView,
	        predefinedFlatQuestions: predefinedFlatQuestions,
	        currentId: targetView.id,
	        assumptionLastStep: false,
	        value: targetView.answerValue,
	        handleAction: setViewQuestion
	      });
	    } else {
	      setViewQuestion(flatQuestions[0]);
	    }
	  }, []);
	
	  function handleParentChildren(_ref2) {
	    var target = _ref2.target,
	        currentId = _ref2.currentId,
	        handleAction = _ref2.handleAction,
	        assumptionLastStep = _ref2.assumptionLastStep,
	        predefinedFlatQuestions = _ref2.predefinedFlatQuestions;
	
	    var targetParentChild = flatQuestions.find(function (q) {
	      return q.id === target.parentQuestionId;
	    });
	    if (targetParentChild) {
	      var _ref3 = answers.find(function (q) {
	        return q.questionId === targetParentChild.id;
	      }) || {},
	          targetParentValue = _ref3.value;
	
	      getTargetViewQuestion({
	        currentId: currentId,
	        handleAction: handleAction,
	        assumptionLastStep: assumptionLastStep,
	        predefinedFlatQuestions: predefinedFlatQuestions,
	        value: targetParentValue,
	        target: targetParentChild
	      });
	    } else {
	      var rootIndex = questions.findIndex(function (q) {
	        return q.id === target.id;
	      });
	      var safeNextRoot = questions[rootIndex + 1];
	      if (safeNextRoot) {
	        var predefinedNextRoot = flatQuestions.find(function (_ref4) {
	          var id = _ref4.id;
	          return id === safeNextRoot.id;
	        });
	        handleAction(predefinedNextRoot);
	      } else if (assumptionLastStep) {
	        setNextViewQuestion(null);
	      } else {
	        dispatch(_upcomingSurvey.actions.finish((0, _extends3.default)({}, config, {
	          withAnswer: selectedValue
	        })));
	      }
	    }
	  }
	
	  var getTargetViewQuestion = function getTargetViewQuestion(_ref5) {
	    var value = _ref5.value,
	        target = _ref5.target,
	        currentId = _ref5.currentId,
	        handleAction = _ref5.handleAction,
	        assumptionLastStep = _ref5.assumptionLastStep,
	        _ref5$predefinedFlatQ = _ref5.predefinedFlatQuestions,
	        predefinedFlatQuestions = _ref5$predefinedFlatQ === undefined ? [] : _ref5$predefinedFlatQ;
	
	    if (!(0, _isEmpty2.default)(target.questions)) {
	      var targetView = target.questions.find(function (q) {
	        return q.triggeredOnParentValue === value && ![].concat((0, _toConsumableArray3.default)(answeredQuestions), (0, _toConsumableArray3.default)(predefinedFlatQuestions)).includes(q.id) && currentId !== q.id;
	      });
	      if (targetView) {
	        var predefinedQuestion = flatQuestions.find(function (_ref6) {
	          var id = _ref6.id;
	          return id === targetView.id;
	        });
	        handleAction(predefinedQuestion);
	      } else {
	        handleParentChildren({
	          target: target,
	          currentId: currentId,
	          handleAction: handleAction,
	          assumptionLastStep: assumptionLastStep,
	          predefinedFlatQuestions: predefinedFlatQuestions
	        });
	      }
	    } else {
	      handleParentChildren({
	        target: target,
	        currentId: currentId,
	        handleAction: handleAction,
	        assumptionLastStep: assumptionLastStep,
	        predefinedFlatQuestions: predefinedFlatQuestions
	      });
	    }
	  };
	
	  var handleSubmit = (0, _react.useCallback)(function (_ref7) {
	    var id = _ref7.id,
	        value = _ref7.value;
	
	    setAnsweredQuestions([].concat((0, _toConsumableArray3.default)(answeredQuestions), [viewQuestion.id]));
	    getTargetViewQuestion({
	      target: viewQuestion,
	      value: selectedValue,
	      assumptionLastStep: false,
	      currentId: viewQuestion.id,
	      handleAction: setViewQuestion
	    });
	    onSubmit({ id: id, value: value });
	  }, [viewQuestion, answers, selectedValue]);
	
	  var handleBack = (0, _react.useCallback)(function () {
	    var targetView = flatQuestions.find(function (q) {
	      return q.id === answeredQuestions[answeredQuestions.length - 1];
	    });
	    answeredQuestions.pop();
	    setViewQuestion(targetView);
	  }, [viewQuestion, answers, answeredQuestions]);
	
	  var isRequired = (0, _react.useMemo)(function () {
	    return (0, _get2.default)(viewQuestion, 'settings.isRequired', true);
	  }, [viewQuestion]);
	
	  var isComment = (0, _react.useMemo)(function () {
	    return (0, _checkComment2.default)(viewQuestion);
	  }, [viewQuestion]);
	
	  var isLastStep = (0, _react.useMemo)(function () {
	    return !nextViewQuestion;
	  }, [nextViewQuestion]);
	
	  var progress = (0, _react.useMemo)(function () {
	    var quantityRootLevel = (0, _uniq2.default)(flatQuestions.map(function (q) {
	      return q.indexBlock;
	    }));
	    var progressRootQ = Math.round(1 / (0, _size2.default)(quantityRootLevel) * 100);
	    var progressNestedQ = quantityRootLevel.map(function (c) {
	      return (0, _defineProperty3.default)({}, c, Math.floor(progressRootQ / flatQuestions.filter(function (q) {
	        return q.indexBlock === c;
	      }).length));
	    });
	    if (viewQuestion) {
	      var _reduce = [].concat((0, _toConsumableArray3.default)(answeredQuestions), [viewQuestion.id]).reduce(function (_ref9, viewId) {
	        var acc = _ref9.acc,
	            previousIndexBlock = _ref9.previousIndexBlock;
	
	        var _ref10 = flatQuestions.find(function (q) {
	          return q.id === viewId;
	        }) || {},
	            indexBlock = _ref10.indexBlock,
	            parentQuestionId = _ref10.parentQuestionId;
	
	        var targetCost = indexBlock && progressNestedQ.find(function (i) {
	          return (0, _keys2.default)(i).includes(indexBlock.toString());
	        })[indexBlock];
	        if (parentQuestionId) {
	          return { acc: acc + targetCost, previousIndexBlock: indexBlock };
	        }
	
	        if (isLastStep && isRequired && selectedValue || isLastStep && !isRequired || isLastStep && isComment) {
	          return {
	            acc: 100,
	            previousIndexBlock: indexBlock
	          };
	        }
	
	        return {
	          acc: indexBlock !== previousIndexBlock ? (indexBlock - 1) * progressRootQ + targetCost : acc + targetCost,
	          previousIndexBlock: indexBlock
	        };
	      }, { acc: 0, previousIndexBlock: 1 }),
	          overallProgress = _reduce.acc;
	
	      return overallProgress;
	    }
	    return 0;
	  }, [answeredQuestions, viewQuestion, isLastStep, isRequired, isComment, selectedValue]);
	
	  (0, _react.useEffect)(function () {
	    if (progress <= MAX_PROGRESS_VALUE) {
	      setProgress(progress);
	    }
	  }, [progress]);
	
	  return {
	    isComment: isComment,
	    handleBack: handleBack,
	    isRequired: isRequired,
	    isLastStep: isLastStep,
	    handleSubmit: handleSubmit,
	    isFirstStep: (0, _isEmpty2.default)(answeredQuestions),
	    question: (0, _extends3.default)({}, viewQuestion)
	  };
	};

/***/ }),
/* 3720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Link = __webpack_require__(113);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _props = __webpack_require__(41);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consentStyle = {
	  color: _styles.COLORS.flaglerDarkBlue
	};
	
	exports.default = function (_ref) {
	  var onLink = _ref.onLink,
	      text = _ref.text,
	      name = _ref.name,
	      meta = _ref.meta;
	
	  switch (name) {
	    case _props.QUESTION_TYPES.scale:
	      {
	        var minDescription = (0, _get2.default)(meta, 'scaleDescription.min', null);
	        var maxDescription = (0, _get2.default)(meta, 'scaleDescription.max', null);
	        var minValue = (0, _get2.default)(meta, 'scaleDescription.minValue');
	        var maxValue = (0, _get2.default)(meta, 'scaleDescription.maxValue');
	
	        if (!(minDescription && maxDescription)) return null;
	        return _react2.default.createElement(
	          'div',
	          { className: 'flex flex-column mt1 o-50' },
	          _react2.default.createElement(
	            'div',
	            { className: 'mb1' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'surveys.scale.description' })
	          ),
	          minDescription ? _react2.default.createElement(
	            'span',
	            { className: 'mb1' },
	            minValue + ' - ' + minDescription
	          ) : null,
	          maxDescription ? _react2.default.createElement(
	            'span',
	            null,
	            maxValue + ' - ' + maxDescription
	          ) : null
	        );
	      }
	    case _props.QUESTION_TYPES.consent:
	      {
	        var consentName = (0, _get2.default)(meta, 'consentDescription.name', null);
	        return _react2.default.createElement(
	          _Link2.default,
	          { style: consentStyle, onClick: onLink, className: 'mt2' },
	          consentName
	        );
	      }
	    case _props.QUESTION_TYPES.appointmentConsent:
	      {
	        return _react2.default.createElement(
	          'p',
	          { className: 'mt2' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'surveys.appointmentConsent.accept' }),
	          _react2.default.createElement(
	            _Link2.default,
	            { style: consentStyle, onClick: onLink, className: 'ml1' },
	            text
	          )
	        );
	      }
	    default:
	      return null;
	  }
	};

/***/ }),
/* 3721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _props = __webpack_require__(41);
	
	exports.default = function (name) {
	  switch (name) {
	    case _props.QUESTION_TYPES.comment:
	      {
	        return 'text--comment';
	      }
	    default:
	      return '';
	  }
	};

/***/ }),
/* 3722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _props = __webpack_require__(41);
	
	exports.default = function (_ref) {
	  var name = _ref.name,
	      text = _ref.text;
	
	  switch (name) {
	    case _props.QUESTION_TYPES.appointmentConsent:
	      return null;
	    default:
	      return text;
	  }
	};

/***/ }),
/* 3723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(158);
	
	var _upcomingSurvey = __webpack_require__(433);
	
	var _upcomingSurveyProceed = __webpack_require__(694);
	
	var _upcomingSurveyAnswers = __webpack_require__(546);
	
	var _upcomingSurveyCancelFilling = __webpack_require__(693);
	
	var _index = __webpack_require__(2267);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	  var targetUserId = _ref.targetUserId;
	  return {
	    targetUserId: targetUserId || (0, _selectors.targetUserIdSelector)(state) || (0, _selectors.loggedUserIdSelector)(state),
	    upcomingSurvey: (0, _selectors2.selectUpcomingSurvey)(state),
	    isUpcomingSurveyRejected: (0, _selectors2.selectUpcomingSurveyProceedRejected)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  sendUpcomingSurveyProceed: _upcomingSurveyProceed.actions.send,
	  sendUpcomingSurveyAnswers: _upcomingSurveyAnswers.actions.send,
	  sendUpcomingSurveyCancelFilling: _upcomingSurveyCancelFilling.actions.send,
	  clearUpcomingSurvey: _upcomingSurvey.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref2) {
	  var formatMessage = _ref2.intl.formatMessage;
	  return { formatMessage: formatMessage };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3724 */,
/* 3725 */,
/* 3726 */,
/* 3727 */,
/* 3728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _momentTimezone = __webpack_require__(2403);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DATE_FORMAT = 'MMM DD'; /*
	                             * Create table columns containing:
	                             * - answer dates as a value
	                             * - and assignmentId as a key
	                             */
	/* eslint-disable */
	
	var removeMS = function removeMS(date) {
	  return date.substr(0, date.indexOf('.'));
	};
	
	exports.default = function (assignments, triggeredDaysMap) {
	  var defaultColumn = { '': '' };
	
	  if (!assignments) return {};
	
	  return assignments.reduce(function (columns, assignment) {
	    var answers = assignment.answers,
	        assignmentId = assignment.assignmentId,
	        sentAt = assignment.sentAt,
	        localCompletedAt = assignment.localCompletedAt,
	        completedAtTimezone = assignment.completedAtTimezone;
	
	
	    var dateKey = (0, _momentTimezone2.default)(localCompletedAt).tz(completedAtTimezone).format(DATE_FORMAT);
	    var answerDate = removeMS(sentAt);
	
	    triggeredDaysMap[assignmentId] = answers.some(function (answer) {
	      return answer.triggered;
	    }) ? answerDate : false;
	
	    columns[assignmentId] = {
	      value: dateKey,
	      triggered: triggeredDaysMap[assignmentId],
	      answerDate: answerDate
	    };
	
	    return columns;
	  }, defaultColumn);
	};

/***/ }),
/* 3729 */,
/* 3730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _props = __webpack_require__(41);
	
	var _handleValue = __webpack_require__(1803);
	
	var _sorting = __webpack_require__(1174);
	
	var _getQuestionType = __webpack_require__(1172);
	
	var _getQuestionType2 = _interopRequireDefault(_getQuestionType);
	
	var _getScaleDescription = __webpack_require__(3731);
	
	var _getScaleDescription2 = _interopRequireDefault(_getScaleDescription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (questions, assignments, singleModeView) {
	  if (!assignments) return [];
	
	  return questions.reduce(function (tableRows, question) {
	    // create new row starting with question text cell in title column
	    var rowStart = (0, _defineProperty3.default)({}, _sorting.TITLE_COLUMN, (0, _extends3.default)({}, question, { type: _handleValue.QUESTION }));
	    var type = (0, _getQuestionType2.default)(question);
	    var description = type === _props.QUESTION_TYPES.scale ? (0, _getScaleDescription2.default)(question) : null;
	    var parentQuestionId = question.parentQuestionId,
	        triggeredOnParentValue = question.triggeredOnParentValue;
	
	    // add to row answer cells
	
	    var row = assignments.reduce(function (acc, assignment) {
	      var answers = assignment.answers,
	          assignmentId = assignment.assignmentId;
	
	
	      var questionAnswers = answers.filter(function (answer) {
	        return answer.questionId === question.id;
	      });
	      var answer = questionAnswers[0] || { value: '-' };
	
	      var _ref = answers.find(function (item) {
	        return item.questionId === parentQuestionId;
	      }) || { value: '' },
	          parentQuestionValue = _ref.value;
	
	      var shouldHideQuestion = triggeredOnParentValue ? parentQuestionValue !== triggeredOnParentValue : false;
	
	      if (shouldHideQuestion && singleModeView) {
	        acc.shouldHideQuestions = true;
	      }
	
	      acc[assignmentId] = shouldHideQuestion ? null : (0, _extends3.default)({}, answer, {
	        description: description,
	        type: type
	      });
	
	      return acc;
	    }, rowStart);
	    return [].concat((0, _toConsumableArray3.default)(tableRows), [row]);
	  }, []).filter(function (r) {
	    return !r.shouldHideQuestions && (0, _values2.default)(r).some(function (i) {
	      return i && i.value;
	    });
	  });
	}; /*
	    * Transform API data into format needed for Table component
	    */

/***/ }),
/* 3731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getScaleDescription = function getScaleDescription(question) {
	  var scaleData = (0, _get2.default)(question, 'settings.meta.scaleDescription');
	
	  if (scaleData) {
	    var minValue = scaleData.minValue,
	        maxValue = scaleData.maxValue;
	
	
	    return {
	      minValue: minValue,
	      maxValue: maxValue
	    };
	  }
	
	  return null;
	};
	
	exports.default = getScaleDescription;

/***/ }),
/* 3732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _sorting = __webpack_require__(1174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSingleRow = function getSingleRow(assignments, keys, title) {
	  var rowStart = (0, _defineProperty3.default)({}, _sorting.TITLE_COLUMN, title);
	
	  if (!assignments) return {};
	  var totalRow = assignments.reduce(function (acc, assignment) {
	    var assignmentId = assignment.assignmentId;
	
	    var values = keys.reduce(function (result, key) {
	      return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, key, assignment[key]));
	    }, {});
	
	    acc[assignmentId] = (0, _extends4.default)({}, values);
	
	    return acc;
	  }, rowStart);
	  return totalRow;
	};
	
	exports.default = getSingleRow;

/***/ }),
/* 3733 */,
/* 3734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(158);
	
	var _index = __webpack_require__(565);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    upcomingListCounter: (0, _selectors.selectUpcomingListCounter)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps), (0, _recompose.withProps)(function (_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	  return { formatMessage: formatMessage };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Badge = __webpack_require__(604);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(565);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cardStyle = { borderRadius: '4px' };
	
	var SurveyListButton = function SurveyListButton(_ref) {
	  var text = _ref.text,
	      badge = _ref.badge,
	      disabled = _ref.disabled,
	      active = _ref.active,
	      onClick = _ref.onClick,
	      className = _ref.className;
	
	  var getIcon = function getIcon() {
	    return _react2.default.createElement(_Icon2.default, { name: 'up-surveys-small', height: 32, width: 24 });
	  };
	  var getBadge = function getBadge() {
	    return badge ? _react2.default.createElement(_Badge2.default, { colored: true, text: badge }) : null;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      _ClickableElement2.default,
	      {
	        onClick: onClick,
	        hoverable: true,
	        disabled: disabled,
	        styleName: (0, _classnames2.default)('surveys-list-button', {
	          'surveys-list-button--active': active,
	          'surveys-list-button--disabled': disabled
	        }),
	        className: 'flex flex-center'
	      },
	      _react2.default.createElement(_Card2.default, {
	        text: { primary: text },
	        additionalContent: {
	          left: getIcon(),
	          right: getBadge()
	        },
	        className: 'fw6 w-100',
	        style: cardStyle
	      })
	    )
	  );
	};
	
	SurveyListButton.propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  icon: _propTypes2.default.shape({
	    name: _propTypes2.default.string,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  text: _propTypes2.default.string,
	  badge: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onClick: _propTypes2.default.func,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(SurveyListButton, _index2.default, {
	  allowMultiple: true
	});

/***/ }),
/* 3736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SurveyListItem = __webpack_require__(1175);
	
	var _SurveyListItem2 = _interopRequireDefault(_SurveyListItem);
	
	var _Content = __webpack_require__(131);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _strings = __webpack_require__(15);
	
	var _withLazyLoad = __webpack_require__(620);
	
	var _withLazyLoad2 = _interopRequireDefault(_withLazyLoad);
	
	var _index = __webpack_require__(5143);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SurveyResultList = function SurveyResultList(_ref) {
	  var surveyId = _ref.surveyId,
	      answeredList = _ref.answeredList,
	      onClickItem = _ref.onClickItem,
	      formatMessage = _ref.intl.formatMessage,
	      sending = _ref.sending,
	      loadMore = _ref.loadMore;
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'wrapper' },
	    _react2.default.createElement(
	      'span',
	      { styleName: 'title' },
	      formatMessage(_strings.SURVEY_RESULTS)
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'list' },
	      _react2.default.createElement(
	        _withLazyLoad2.default,
	        { loadMore: loadMore },
	        answeredList.map(function (answeredSurvey) {
	          return _react2.default.createElement(_SurveyListItem2.default, {
	            key: 'answered-' + (0, _get2.default)(answeredSurvey, 'id'),
	            title: (0, _get2.default)(answeredSurvey, 'name'),
	            heading: (0, _get2.default)(answeredSurvey, 'frequency'),
	            subtitle: (0, _get2.default)(answeredSurvey, 'assignments[0].program.name'),
	            icon: 'up-surveys',
	            active: surveyId === (0, _get2.default)(answeredSurvey, 'id'),
	            onClick: function onClick() {
	              onClickItem((0, _get2.default)(answeredSurvey, 'id'));
	            }
	          });
	        })
	      ),
	      !(0, _size2.default)(answeredList) && !sending ? _react2.default.createElement(
	        'div',
	        { className: 'mt4' },
	        _react2.default.createElement(_Content2.default, {
	          icon: 'no-surveys',
	          text: formatMessage(_strings.SURVEYS_ANSWERED_EMPTY)
	        })
	      ) : null
	    )
	  );
	};
	
	SurveyResultList.propTypes = {
	  surveyId: _propTypes2.default.number,
	  loadMore: _propTypes2.default.func,
	  answeredList: _propTypes2.default.array,
	  onClickItem: _propTypes2.default.func,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }),
	  sending: _propTypes2.default.bool
	};
	
	SurveyResultList.defaultProps = {
	  answeredList: []
	};
	
	exports.default = (0, _reactIntl.injectIntl)((0, _reactCssModules2.default)(SurveyResultList, _index2.default, { allowMultiple: true }));

/***/ }),
/* 3737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(158);
	
	var _selectors2 = __webpack_require__(50);
	
	var _getComplementary = __webpack_require__(3742);
	
	var _getComplementary2 = _interopRequireDefault(_getComplementary);
	
	var _selectors3 = __webpack_require__(23);
	
	var _answered = __webpack_require__(355);
	
	var _index = __webpack_require__(565);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isSending: (0, _selectors.selectUpcomingSending)(state),
	    upcomingListCounter: (0, _selectors.selectUpcomingListCounter)(state),
	    upcomingList: (0, _selectors.selectUpcomingList)(state),
	    answeredList: (0, _selectors.answeredListSelector)(state),
	    genderList: (0, _selectors2.selectGenderTypes)(state),
	    canEdit: (0, _selectors3.canEditPatient)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  loadNextAnsweredRequests: _answered.paginatedActions.loadNextRequests
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _recompose.withProps)(function (_ref) {
	  var genderList = _ref.genderList,
	      profile = _ref.profile,
	      formatMessage = _ref.intl.formatMessage;
	
	  return {
	    userComplementary: (0, _getComplementary2.default)(profile, genderList, formatMessage),
	    userName: (0, _get2.default)(profile, 'displayableName'),
	    userAvatar: (0, _get2.default)(profile, 'avatar.thumbMin'),
	    formatMessage: formatMessage
	  };
	}));

/***/ }),
/* 3738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isArray = __webpack_require__(96);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Drawer = __webpack_require__(253);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _Intro = __webpack_require__(195);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _SurveyListButton = __webpack_require__(3735);
	
	var _SurveyListButton2 = _interopRequireDefault(_SurveyListButton);
	
	var _SurveyResultList = __webpack_require__(3736);
	
	var _SurveyResultList2 = _interopRequireDefault(_SurveyResultList);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _styles = __webpack_require__(18);
	
	var _enhance = __webpack_require__(3737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var drawerStyle = {
	  color: _styles.COLORS.grayDark,
	  padding: 16
	};
	
	var drawerContStyle = {
	  flexGrow: 0,
	  flexShrink: 1
	};
	
	var buttonBackgroundStyle = {
	  background: _styles.COLORS.blueGrayish,
	  marginLeft: '-16px',
	  marginRight: '-16px',
	  padding: '24px 16px'
	};
	
	var SurveysDrawer = function SurveysDrawer(_ref) {
	  var onBack = _ref.onBack,
	      upcomingList = _ref.upcomingList,
	      upcomingListCounter = _ref.upcomingListCounter,
	      isSending = _ref.isSending,
	      onSurveyResultsClick = _ref.onSurveyResultsClick,
	      onSurveyListClick = _ref.onSurveyListClick,
	      surveyId = _ref.surveyId,
	      answeredList = _ref.answeredList,
	      formatMessage = _ref.formatMessage,
	      userComplementary = _ref.userComplementary,
	      userAvatar = _ref.userAvatar,
	      userName = _ref.userName,
	      contextId = _ref.contextId,
	      loadNextAnsweredRequests = _ref.loadNextAnsweredRequests,
	      isProvider = _ref.isProvider,
	      canEdit = _ref.canEdit;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      selectedButton = _useState2[0],
	      setSelectedButton = _useState2[1];
	
	  var hasUpcomingSurveys = (0, _isArray2.default)(upcomingList) && !(0, _isEmpty2.default)(upcomingList);
	
	  var handleClick = function handleClick(type) {
	    setSelectedButton(type);
	    onSurveyListClick(type);
	  };
	
	  var handleResultListClickItem = function handleResultListClickItem(id) {
	    setSelectedButton(_constants.SURVEYS_LIST_TYPE.RESULTS);
	    onSurveyResultsClick(_constants.SURVEYS_LIST_TYPE.RESULTS, id);
	  };
	
	  var handleLoadMore = function handleLoadMore() {
	    loadNextAnsweredRequests({
	      id: contextId,
	      limit: 10
	    });
	  };
	
	  return _react2.default.createElement(
	    _Drawer2.default,
	    {
	      className: 'bg-white-90',
	      opened: true,
	      scrollable: false,
	      width: 300,
	      style: drawerStyle
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'flex flex-column h-100' },
	      _react2.default.createElement(
	        'div',
	        { style: drawerContStyle },
	        _react2.default.createElement(_BackButton2.default, { onBack: onBack }),
	        _react2.default.createElement(_Card2.default, {
	          className: 'fw6 f5 pv3',
	          text: {
	            primary: userName,
	            complementary: userComplementary,
	            intro: _Intro.INTRO_HINT_SELECTORS.patient.messages.patientContext
	          },
	          additionalContent: {
	            left: _react2.default.createElement(_Avatar2.default, { children: userName, size: 52, src: userAvatar })
	          }
	        }),
	        (isProvider || canEdit) && hasUpcomingSurveys ? _react2.default.createElement(
	          'div',
	          { style: buttonBackgroundStyle },
	          _react2.default.createElement(_SurveyListButton2.default, {
	            onClick: function onClick() {
	              return handleClick(_constants.SURVEYS_LIST_TYPE.UPCOMING);
	            },
	            badge: upcomingListCounter,
	            text: formatMessage(_strings.ACTIONS.survey.upcoming),
	            disabled: isSending,
	            active: selectedButton === _constants.SURVEYS_LIST_TYPE.UPCOMING
	          })
	        ) : null
	      ),
	      _react2.default.createElement(_SurveyResultList2.default, {
	        onClickItem: handleResultListClickItem,
	        answeredList: answeredList,
	        surveyId: selectedButton === _constants.SURVEYS_LIST_TYPE.RESULTS ? surveyId : null,
	        toggle: true,
	        sending: isSending,
	        loadMore: handleLoadMore
	      })
	    )
	  );
	};
	
	SurveysDrawer.propTypes = {
	  isSending: _propTypes2.default.bool,
	  isProvider: _propTypes2.default.bool,
	  canEdit: _propTypes2.default.bool,
	  upcomingListCounter: _propTypes2.default.number,
	  answeredList: _propTypes2.default.array,
	  upcomingList: _propTypes2.default.array,
	  onBack: _propTypes2.default.func,
	  surveyId: _propTypes2.default.number,
	  formatMessage: _propTypes2.default.func.isRequired,
	  loadNextAnsweredRequests: _propTypes2.default.func.isRequired,
	  userComplementary: _propTypes2.default.string,
	  userAvatar: _propTypes2.default.string,
	  userName: _propTypes2.default.string,
	  onSurveyResultsClick: _propTypes2.default.func,
	  onSurveyListClick: _propTypes2.default.func,
	  contextId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	exports.default = (0, _enhance.enhance)(SurveysDrawer);

/***/ }),
/* 3739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _injectSaga = __webpack_require__(116);
	
	var _injectSaga2 = _interopRequireDefault(_injectSaga);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _consentSaga = __webpack_require__(1370);
	
	var _consentSaga2 = _interopRequireDefault(_consentSaga);
	
	var _exportToPDF = __webpack_require__(899);
	
	var _selectors = __webpack_require__(23);
	
	var _index = __webpack_require__(565);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    targetUser: (0, _selectors.targetUserSelector)(state),
	    targetUserId: (0, _selectors.targetUserIdSelector)(state),
	    exportPDFState: (0, _get2.default)(state, 'surveys.pdfExport'),
	    surveysLoading: (0, _get2.default)(state, 'surveys.answered.sending')
	  };
	};
	
	var mapDispatchToProps = {
	  exportToPDF: _exportToPDF.actions.send,
	  clearExportToPDF: _exportToPDF.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _injectSaga2.default)({
	  key: 'consentSaga',
	  saga: _consentSaga2.default,
	  mode: _sagaInjectors.RESTART_ON_REMOUNT
	}), _reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(158);
	
	var _selectors2 = __webpack_require__(23);
	
	var _getUser = __webpack_require__(202);
	
	var _upcoming = __webpack_require__(309);
	
	var _context = __webpack_require__(216);
	
	var _answered = __webpack_require__(355);
	
	var _getAccessLevels = __webpack_require__(426);
	
	var _selectors3 = __webpack_require__(56);
	
	var _index = __webpack_require__(565);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    answeredList: (0, _selectors.answeredListSelector)(state),
	    upcomingList: (0, _selectors.selectUpcomingList)(state),
	    profileData: (0, _selectors2.targetUserSelector)(state),
	    targetUserId: (0, _selectors2.targetUserIdSelector)(state),
	    isProvider: (0, _selectors3.selectIsAccessLeverProvider)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  getUser: _getUser.actions.send,
	  fetchUpcomingSurveys: _upcoming.actions.send,
	  setTargetUserId: _context.actions.setTargetUserId,
	  fetchAnsweredSurveys: _answered.actions.send,
	  loadNextUpcomingRequests: _upcoming.paginatedActions.loadNextRequests,
	  getAccessLevels: _getAccessLevels.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _SurveysResults = __webpack_require__(1805);
	
	var _SurveysResults2 = _interopRequireDefault(_SurveysResults);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ContentArea = __webpack_require__(155);
	
	var _ContentArea2 = _interopRequireDefault(_ContentArea);
	
	var _Content = __webpack_require__(214);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _SurveyList = __webpack_require__(1804);
	
	var _SurveyList2 = _interopRequireDefault(_SurveyList);
	
	var _SurveysDrawer = __webpack_require__(3738);
	
	var _SurveysDrawer2 = _interopRequireDefault(_SurveysDrawer);
	
	var _MobileNavbar = __webpack_require__(256);
	
	var _MobileNavbar2 = _interopRequireDefault(_MobileNavbar);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	var _styles = __webpack_require__(18);
	
	var _routes = __webpack_require__(37);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _enhance = __webpack_require__(3740);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Surveys = function Surveys(_ref) {
	  var fetchAnsweredSurveys = _ref.fetchAnsweredSurveys,
	      setTargetUserId = _ref.setTargetUserId,
	      getUser = _ref.getUser,
	      contextId = _ref.params.contextId,
	      profileData = _ref.profileData,
	      formatMessage = _ref.intl.formatMessage,
	      fetchUpcomingSurveys = _ref.fetchUpcomingSurveys,
	      getAccessLevels = _ref.getAccessLevels,
	      upcomingList = _ref.upcomingList,
	      answeredList = _ref.answeredList,
	      loadNextUpcomingRequests = _ref.loadNextUpcomingRequests,
	      isProvider = _ref.isProvider;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      surveyListType = _useState2[0],
	      setSurveyListType = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      isShowOnlySurveyList = _useState4[0],
	      toggleContent = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      selectedSurveyId = _useState6[0],
	      setSelectedSurveyId = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    getUser({ id: contextId });
	
	    if (contextId) {
	      setTargetUserId({ id: Number(contextId) });
	    }
	
	    getAccessLevels({ id: contextId });
	
	    fetchAnsweredSurveys({
	      id: contextId,
	      limit: 16
	    });
	
	    fetchUpcomingSurveys({
	      id: contextId,
	      limit: 20
	    });
	  }, []);
	  (0, _usePageView.usePageView)('Profile | Surveys');
	
	  var handleSurveyListClick = function handleSurveyListClick(type, id) {
	    if (id) setSelectedSurveyId(id);
	    setSurveyListType(type);
	    if (!(0, _mobileHelpers.isDesktop)()) {
	      toggleContent(true);
	    }
	  };
	
	  var handleBack = function handleBack() {
	    if (isShowOnlySurveyList) {
	      setSurveyListType(null);
	      toggleContent(false);
	      return;
	    }
	    _reactRouter.browserHistory.push('/' + _routes.MESSAGES);
	  };
	
	  var getShownSurveys = function getShownSurveys() {
	    switch (surveyListType) {
	      case _constants.SURVEYS_LIST_TYPE.UPCOMING:
	        return _react2.default.createElement(_SurveyList2.default, {
	          listTitle: formatMessage(_strings.ACTIONS.survey.upcoming),
	          surveys: upcomingList,
	          loadMore: loadMore,
	          className: 'pa3'
	        });
	      case _constants.SURVEYS_LIST_TYPE.RESULTS:
	        return _react2.default.createElement(_SurveysResults2.default, {
	          surveys: answeredList,
	          openedSurveyId: selectedSurveyId,
	          className: 'pa3'
	        });
	      default:
	        return getEmptyState();
	    }
	  };
	
	  var getEmptyState = function getEmptyState() {
	    var emptyStateText = (0, _isEmpty2.default)(upcomingList) && (0, _isEmpty2.default)(answeredList) ? _strings.SURVEYS_ANSWERED_EMPTY : _strings.PICK_ITEM_LEFT;
	
	    return _react2.default.createElement(
	      'div',
	      { styleName: 'empty-state' },
	      _react2.default.createElement(_Icon2.default, { name: 'no-surveys', size: 148, className: 'pb4' }),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'empty-state__text' },
	        formatMessage(emptyStateText)
	      )
	    );
	  };
	
	  var loadMore = function loadMore() {
	    loadNextUpcomingRequests({
	      id: contextId,
	      limit: 10
	    });
	  };
	
	  var mobileButtonTitle = isShowOnlySurveyList ? formatMessage(_strings.SURVEYS_TITLE) : formatMessage(_strings.COMMON.back);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Root' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.surveys' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'g-content', styleName: 'root' },
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { maxWidth: _styles.BREAKPOINT },
	        _react2.default.createElement(
	          _MobileNavbar2.default,
	          { openContext: 'arrow-down', toggleContext: handleBack },
	          _react2.default.createElement('p', { children: mobileButtonTitle })
	        )
	      ),
	      !isShowOnlySurveyList ? _react2.default.createElement(_SurveysDrawer2.default, {
	        contextId: contextId,
	        isProvider: isProvider,
	        profile: profileData,
	        onBack: handleBack,
	        onSurveyListClick: handleSurveyListClick,
	        onSurveyResultsClick: handleSurveyListClick,
	        surveyId: selectedSurveyId
	      }) : null,
	      _react2.default.createElement(
	        _ContentArea2.default,
	        { className: 'relative' },
	        _react2.default.createElement(
	          _Content2.default,
	          null,
	          getShownSurveys()
	        )
	      )
	    )
	  );
	};
	
	Surveys.propTypes = {
	  answeredList: _propTypes2.default.array,
	  upcomingList: _propTypes2.default.array,
	  profileData: _propTypes2.default.object,
	  getUser: _propTypes2.default.func.isRequired,
	  getAccessLevels: _propTypes2.default.func.isRequired,
	  fetchUpcomingSurveys: _propTypes2.default.func.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  fetchAnsweredSurveys: _propTypes2.default.func.isRequired,
	  setTargetUserId: _propTypes2.default.func.isRequired,
	  params: _propTypes2.default.object.isRequired,
	  loadNextUpcomingRequests: _propTypes2.default.func.isRequired,
	  isProvider: _propTypes2.default.bool
	};
	
	exports.default = (0, _enhance.enhance)(Surveys);

/***/ }),
/* 3742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleDOB = __webpack_require__(909);
	
	var _dateConverters = __webpack_require__(83);
	
	exports.default = function (_ref, genderList, formatMessage) {
	  var gender = _ref.gender,
	      dob = _ref.dob;
	
	  var params = [];
	  if (gender && genderList) {
	    var genderOption = genderList.find(function (item) {
	      return item.value === gender;
	    });
	    if (genderOption) params.push(genderOption.label);
	  }
	  if (dob) {
	    var dobAPIFormat = (0, _dateConverters.convertDateToUIFormat)(dob, formatMessage);
	    params.push((0, _handleDOB.handleAge)(dobAPIFormat, formatMessage));
	  }
	  return params.join(', ');
	};

/***/ }),
/* 3743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _recompose = __webpack_require__(22);
	
	var _upcomingSurvey = __webpack_require__(433);
	
	var _appointmentSurveyAssignment = __webpack_require__(844);
	
	var _upcomingSurveyProceed = __webpack_require__(694);
	
	var _upcomingSurveyAnswers = __webpack_require__(546);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _upcomingSurveyCancelFilling = __webpack_require__(693);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(158);
	
	var _index = __webpack_require__(2268);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state, _ref) {
	  var targetUserId = _ref.targetUserId;
	  return {
	    currentSurvey: (0, _selectors2.selectUpcomingSurvey)(state),
	    isUpcomingSurveyRejected: (0, _selectors2.selectUpcomingSurveyProceedRejected)(state),
	    isSendingUpcomingSurveyCompletionsSucceed: (0, _selectors2.sendingUpcomingSurveyCompletionsSucceed)(state),
	    targetUserId: targetUserId || (0, _selectors.targetUserIdSelector)(state) || (0, _selectors.loggedUserIdSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  clearUpcomingSurvey: _upcomingSurvey.actions.clear,
	  clearSurveys: _appointmentSurveyAssignment.preVisitConsentsModalActions.setSurveys,
	  sendUpcomingSurveyProceed: _upcomingSurveyProceed.actions.send,
	  sendUpcomingSurveyAnswers: _upcomingSurveyAnswers.actions.send,
	  clearUpcomingSurveyProceed: _upcomingSurveyProceed.actions.clear,
	  clearUpcomingSurveyCompletions: _upcomingSurveyCompletions.actions.clear,
	  sendUpcomingSurveyCancelFilling: _upcomingSurveyCancelFilling.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref2) {
	  var clearSurveys = _ref2.clearSurveys,
	      clearUpcomingSurvey = _ref2.clearUpcomingSurvey,
	      formatMessage = _ref2.intl.formatMessage,
	      clearUpcomingSurveyProceed = _ref2.clearUpcomingSurveyProceed;
	  return {
	    formatMessage: formatMessage,
	    clearData: function clearData() {
	      clearSurveys([]);
	      clearUpcomingSurvey();
	      clearUpcomingSurveyProceed();
	    }
	  };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _class3, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _coreDecorators = __webpack_require__(73);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _strings = __webpack_require__(15);
	
	var _colToggler = __webpack_require__(5144);
	
	var _colToggler2 = _interopRequireDefault(_colToggler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	var ColToggler = (_dec = (0, _reactCssModules2.default)(_colToggler2.default, { allowMultiple: true }), _dec(_class = (_class2 = (_temp2 = _class3 = function (_PureComponent) {
	  (0, _inherits3.default)(ColToggler, _PureComponent);
	
	  function ColToggler() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ColToggler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ColToggler.__proto__ || (0, _getPrototypeOf2.default)(ColToggler)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ColToggler, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ expanded: this.props.expanded });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'toggleCell',
	    value: function toggleCell() {
	      var onToggle = this.props.onToggle;
	
	
	      onToggle ? onToggle() : this.setState({
	        expanded: !this.state.expanded
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var expanded = this.state.expanded;
	
	
	      return _react2.default.createElement(
	        'button',
	        {
	          styleName: (0, _classnames2.default)('toggler', {
	            'toggler--expanded': expanded
	          }),
	          onClick: this.toggleCell
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.collapse)
	      );
	    }
	  }]);
	  return ColToggler;
	}(_react.PureComponent), _class3.propTypes = {
	  expanded: _propTypes2.default.bool,
	  onToggle: _propTypes2.default.func
	}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'toggleCell', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleCell'), _class2.prototype)), _class2)) || _class);
	exports.default = ColToggler;

/***/ }),
/* 3745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp2; /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _times = __webpack_require__(5521);
	
	var _times2 = _interopRequireDefault(_times);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMeasure = __webpack_require__(6237);
	
	var _reactMeasure2 = _interopRequireDefault(_reactMeasure);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _ColToggler = __webpack_require__(3744);
	
	var _ColToggler2 = _interopRequireDefault(_ColToggler);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _props2 = __webpack_require__(41);
	
	var _handleValue = __webpack_require__(1803);
	
	var _handleValue2 = _interopRequireDefault(_handleValue);
	
	var _ExportBtn = __webpack_require__(1836);
	
	var _ExportBtn2 = _interopRequireDefault(_ExportBtn);
	
	var _getRespondentData = __webpack_require__(1173);
	
	var _getSpecification = __webpack_require__(361);
	
	var _sorting = __webpack_require__(1174);
	
	var _index = __webpack_require__(5145);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_WIDTH = 240;
	var getFirstColStyle = function getFirstColStyle(state) {
	  if ((0, _mobileHelpers.isDesktop)()) return null;
	
	  var colWidth = state.wrapper.width / 2;
	  var firstColWidth = colWidth < 1 ? DEFAULT_WIDTH : colWidth;
	
	  return {
	    width: firstColWidth + 'px',
	    maxWidth: firstColWidth + 'px',
	    minWidth: firstColWidth + 'px'
	  };
	};
	
	var Table = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactIntl.injectIntl)(_class = _dec(_class = (_temp2 = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(Table, _PureComponent);
	
	  function Table() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      narrow: false,
	      wrapper: {
	        width: -1
	      },
	      table: {
	        width: -1
	      },
	      cell: {
	        width: 48 // const from mockup
	      },
	      selectedCol: null
	    }, _this.wrapper = null, _this.getColIdentificator = function (col) {
	      return (0, _get2.default)(col, 'id') || col;
	    }, _this.renderAssigmentInfo = function (data, iconName) {
	      var formatMessage = _this.props.intl.formatMessage;
	      var expanded = _this.state.expanded;
	      var assignmentMethod = data.assignmentMethod,
	          assigner = data.assigner;
	
	      if (!assignmentMethod) return null;
	
	      var info = (0, _getSpecification.getSurveyAssignmentMethod)({
	        assignmentMethod: assignmentMethod,
	        assigner: assigner,
	        formatMessage: formatMessage,
	        showDescription: true
	      });
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(_Icon2.default, { name: iconName, size: 24 }),
	        expanded && _react2.default.createElement(
	          'span',
	          { className: 'ml2' },
	          info
	        )
	      );
	    }, _this.renderCard = function (user) {
	      var expanded = _this.state.expanded;
	
	      var _ref2 = user ? (0, _getRespondentData.getRespondentData)(user) || {} : {},
	          respondentName = _ref2.respondentName,
	          respondentAvatar = _ref2.respondentAvatar,
	          role = _ref2.role,
	          teamName = _ref2.teamName,
	          teamOrganization = _ref2.teamOrganization;
	
	      var primaryInfo = expanded ? _react2.default.createElement(
	        _react.Fragment,
	        null,
	        respondentName,
	        _react2.default.createElement(
	          'span',
	          { className: 'f11 fw4' },
	          ' ',
	          role
	        )
	      ) : null;
	
	      var complementaryInfo = expanded && Boolean(teamName) ? _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(_Icon2.default, { name: 'team' }),
	        ' ',
	        teamName,
	        ' (',
	        teamOrganization,
	        ')'
	      ) : null;
	
	      if (user) {
	        return _react2.default.createElement(_Card2.default, {
	          className: 'inline-flex bg-transparent',
	          text: {
	            primary: primaryInfo,
	            complementary: complementaryInfo
	          },
	          additionalContent: {
	            left: _react2.default.createElement(_Avatar2.default, {
	              children: respondentName,
	              size: 32,
	              src: respondentAvatar
	            })
	          }
	        });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.defineState(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.defineState(nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (!nextProps.singleData) {
	        this.handleFreeSpace(nextProps.cols, nextState);
	      }
	    }
	  }, {
	    key: 'getCellValue',
	    value: function getCellValue(row, rawCol, val) {
	      var assignmentId = this.props.assignmentId;
	
	
	      var col = this.getColIdentificator(rawCol);
	      var rawValue = (0, _handleValue2.default)(row[col], this.state.expanded, assignmentId);
	      var value = (0, _get2.default)(rawValue, val);
	
	      switch (val) {
	        case 'totalScore':
	          {
	            return typeof value !== 'undefined' ? String(value) : rawValue;
	          }
	        case 'respondent':
	          {
	            return rawValue !== 'Respondent:' ? this.renderCard(rawValue) : rawValue;
	          }
	        case 'assignmentMethod':
	          {
	            return typeof value !== 'undefined' ? this.renderAssigmentInfo(rawValue, 'right-arrow') : rawValue;
	          }
	        default:
	          {
	            return value || rawValue;
	          }
	      }
	    }
	  }, {
	    key: 'defineState',
	    value: function defineState(props) {
	      var expanded = !!props.singleData || !!this.state.selectedCol;
	      var narrow = (0, _mobileHelpers.isDesktop)() && expanded;
	
	      this.setState({ narrow: narrow, expanded: expanded });
	    }
	  }, {
	    key: 'handleFreeSpace',
	    value: function handleFreeSpace(cols, state) {
	      var wrapper = state.wrapper,
	          table = state.table,
	          cell = state.cell;
	
	      // Don't recalculate on collapsing
	
	      if (wrapper.width === 0 || table.width === 0) return;
	
	      var freeSpace = wrapper.width - table.width;
	      var hasDummyCols = (0, _keys2.default)(cols).findIndex(function (key) {
	        return key.length > 1 && !key.trim().length;
	      }) > -1;
	      var narrow = freeSpace > 0 || hasDummyCols;
	
	      this.setState({ narrow: narrow });
	
	      if (freeSpace > 0) {
	        // create dummy cols
	        var cellsN = Math.ceil(freeSpace / cell.width);
	        (0, _times2.default)(cellsN, function (index) {
	          cols[(0, _sorting.makeString)(index + 1)] = ' ';
	        });
	      }
	    }
	  }, {
	    key: 'isCellDanger',
	    value: function isCellDanger(row, rawCol, param) {
	      var col = this.getColIdentificator(rawCol);
	      var rawValue = row[col];
	
	      return (0, _get2.default)(rawValue, [param], false);
	    }
	  }, {
	    key: 'isColDanger',
	    value: function isColDanger(rawCol) {
	      return (0, _get2.default)(rawCol, 'value') ? rawCol.triggered : false;
	    }
	  }, {
	    key: 'isCellPrimary',
	    value: function isCellPrimary(row, rawCol) {
	      var col = this.getColIdentificator(rawCol);
	
	      return typeof (0, _get2.default)(row, [col, 'totalScore']) !== 'undefined';
	    }
	  }, {
	    key: 'handleSelectColl',
	    value: function handleSelectColl(key) {
	      var _this2 = this;
	
	      var selectedCol = this.state.selectedCol === key ? null : key;
	
	      this.setState({
	        selectedCol: selectedCol,
	        narrow: (0, _mobileHelpers.isDesktop)() && !!selectedCol,
	        expanded: !!selectedCol
	      }, function () {
	        // scroll survey results into view
	        if (!!selectedCol && !(0, _mobileHelpers.isDesktop)()) {
	          var el = _this2.wrapper;
	
	          if (el) {
	            var scrollWidth = el.scrollWidth - el.offsetWidth;
	            el.scrollBy(scrollWidth, 0);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'renderRowCols',
	    value: function renderRowCols(row, cols, val) {
	      var _this3 = this;
	
	      return cols.map(function (column, i) {
	        var triggeredParam = val === 'totalScore' ? 'totalScoreTriggered' : 'triggered';
	        var styleName = (0, _classnames2.default)('cell', {
	          'cell--data': i > 0,
	          'col--danger': _this3.isColDanger(column),
	          'cell--danger': _this3.isCellDanger(row, column, triggeredParam),
	          'cell--primary': _this3.isCellPrimary(row, column),
	          'cell--bold': val === 'respondent' || 'assignmentMethod'
	        });
	
	        return _react2.default.createElement('td', {
	          key: i,
	          children: _this3.getCellValue(row, column, val),
	          className: (0, _classnames2.default)({ tc: i > 0 }),
	          styleName: styleName,
	          style: i === 0 ? getFirstColStyle(_this3.state) : null
	        });
	      });
	    }
	  }, {
	    key: 'renderComment',
	    value: function renderComment(row, columns) {
	      var comment = (0, _get2.default)(row, [_sorting.TITLE_COLUMN, 'settings', 'name']) === _props2.QUESTION_TYPES.comment;
	      var text = (0, _get2.default)(row, [_sorting.TITLE_COLUMN, 'text']);
	      var columnNumber = (0, _size2.default)(columns);
	
	      if (comment) {
	        return _react2.default.createElement(
	          'td',
	          { styleName: 'text comment', colSpan: columnNumber },
	          text
	        );
	      }
	    }
	  }, {
	    key: 'renderRows',
	    value: function renderRows(rows, cols, val) {
	      var _this4 = this;
	
	      var columns = (0, _sorting.getFilteredColumns)(cols, this.state.selectedCol);
	      var rowStyle = (0, _classnames2.default)('row', {
	        'row--primary': val === 'totalScore',
	        'row--bold': val === 'respondent' || 'assignmentMethod'
	      });
	
	      return rows.map(function (row, index) {
	        return _react2.default.createElement(
	          'tr',
	          { key: index, styleName: rowStyle },
	          _this4.renderComment(row, columns) || _this4.renderRowCols(row, columns, val)
	        );
	      });
	    }
	  }, {
	    key: 'renderCols',
	    value: function renderCols(cols) {
	      var _this5 = this;
	
	      var columns = (0, _sorting.getFilteredColumns)(cols, this.state.selectedCol);
	
	      // handle mobile table view
	      var firstColStyle = getFirstColStyle(this.state);
	
	      return columns.map(function (column, i) {
	        var canBeToggled = !_this5.props.singleData && column.value;
	        var expanded = _this5.state.selectedCol === column.id;
	        var styleName = (0, _classnames2.default)('cell cell--header', {
	          'cell--data': i > 0,
	          'cell--header__danger': column.triggered
	        });
	
	        return _react2.default.createElement(
	          'th',
	          {
	            key: i,
	            styleName: styleName,
	            style: i === 0 ? firstColStyle : null
	          },
	          _react2.default.createElement(
	            'span',
	            { styleName: 'cell--header__text' },
	            column.value
	          ),
	          canBeToggled ? _react2.default.createElement(_ColToggler2.default, {
	            expanded: expanded,
	            onToggle: function onToggle() {
	              _this5.handleSelectColl(column.id);
	            }
	          }) : null
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _state = this.state,
	          narrow = _state.narrow,
	          expanded = _state.expanded;
	      var _props = this.props,
	          cols = _props.cols,
	          rows = _props.rows,
	          totalRow = _props.totalRow,
	          userRow = _props.userRow,
	          assignmentRow = _props.assignmentRow,
	          isProviderPostVisitForm = _props.isProviderPostVisitForm;
	
	      var columns = (0, _sorting.getSortedColumns)(cols);
	      var wrapperStyleName = (0, _classnames2.default)('wrapper', {
	        'wrapper--forNarrow': narrow || expanded
	      });
	      var rowStyle = (0, _classnames2.default)('row', {
	        'row--no-border': totalRow
	      });
	
	      return _react2.default.createElement(
	        _reactMeasure2.default,
	        {
	          onMeasure: function onMeasure(wrapper) {
	            _this6.setState({ wrapper: wrapper });
	          }
	        },
	        _react2.default.createElement(
	          _react.Fragment,
	          null,
	          this.state.expanded && this.props.exportPDF && _react2.default.createElement(
	            'div',
	            { className: _index2.default.exportButton },
	            _react2.default.createElement(_ExportBtn2.default, {
	              onClick: function onClick() {
	                return _this6.props.exportPDF({
	                  openedAssignmentId: _this6.state.selectedCol
	                });
	              }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { styleName: wrapperStyleName, ref: function ref(node) {
	                return _this6.wrapper = node;
	              } },
	            _react2.default.createElement(
	              _reactMeasure2.default,
	              {
	                onMeasure: function onMeasure(table) {
	                  _this6.setState({ table: table });
	                }
	              },
	              _react2.default.createElement(
	                'table',
	                { styleName: (0, _classnames2.default)({ 'table--expanded': expanded }) },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    { styleName: rowStyle },
	                    this.renderCols(columns)
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  totalRow && this.renderRows([totalRow], columns, 'totalScore'),
	                  this.renderRows(rows, columns, 'value'),
	                  this.renderRows([userRow], columns, 'respondent'),
	                  !isProviderPostVisitForm ? this.renderRows([assignmentRow], columns, 'assignmentMethod') : null
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Table;
	}(_react.PureComponent), _class2.propTypes = {
	  cols: _propTypes2.default.object,
	  userRow: _propTypes2.default.object,
	  totalRow: _propTypes2.default.object,
	  singleData: _propTypes2.default.bool,
	  isProviderPostVisitForm: _propTypes2.default.bool,
	  rows: _propTypes2.default.arrayOf(_propTypes2.default.object)
	}, _temp2)) || _class) || _class);
	exports.default = Table;

/***/ }),
/* 3746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(50);
	
	var _strings = __webpack_require__(15);
	
	var _TermsAndPolicies = __webpack_require__(1846);
	
	var _TermsAndPolicies2 = _interopRequireDefault(_TermsAndPolicies);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TermsAndPoliciesBox(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      _onChange2 = _ref.onChange,
	      termsValue = _ref.termsValue,
	      privacyValue = _ref.privacyValue,
	      termsName = _ref.termsName,
	      privacyName = _ref.privacyName,
	      className = _ref.className,
	      privacyByCountry = _ref.privacyByCountry;
	
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    _react2.default.createElement(
	      _Checkbox2.default,
	      {
	        checked: termsValue,
	        name: termsName,
	        value: termsValue,
	        id: termsName,
	        onChange: function onChange(value) {
	          return _onChange2((0, _defineProperty3.default)({}, termsName, value));
	        }
	      },
	      _react2.default.createElement(_TermsAndPolicies2.default, {
	        text: formatMessage(_strings.AUTH.actions.tnc.textTitle),
	        textLink: formatMessage(_strings.AUTH.actions.tnc.textLink),
	        document: privacyByCountry.terms
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt1' },
	      _react2.default.createElement(
	        _Checkbox2.default,
	        {
	          checked: privacyValue,
	          name: privacyName,
	          id: privacyName,
	          value: termsValue,
	          onChange: function onChange(value) {
	            return _onChange2((0, _defineProperty3.default)({}, privacyName, value));
	          }
	        },
	        _react2.default.createElement(_TermsAndPolicies2.default, {
	          text: formatMessage(_strings.AUTH.actions.tnc.textTitle),
	          textLink: formatMessage(_strings.COMMON.privacy),
	          document: privacyByCountry.privacyPolicy
	        })
	      )
	    )
	  );
	}
	
	TermsAndPoliciesBox.propTypes = {
	  intl: _propTypes2.default.object,
	  onChange: _propTypes2.default.func,
	  termsValue: _propTypes2.default.bool,
	  privacyValue: _propTypes2.default.bool,
	  termsName: _propTypes2.default.string,
	  privacyName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  privacyByCountry: _propTypes2.default.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    privacyList: (0, _selectors.privacyListSelector)(state)
	  };
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps), (0, _recompose.withProps)(function (_ref2) {
	  var privacyList = _ref2.privacyList;
	
	  return {
	    privacyByCountry: privacyList.find(function (item) {
	      return item.country === 'USA';
	    }) || {}
	  };
	}))(TermsAndPoliciesBox);

/***/ }),
/* 3747 */,
/* 3748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatValue = formatValue;
	
	var _phone = __webpack_require__(547);
	
	function formatValue() {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var isNumberFieldType = arguments[1];
	  var isPhoneNumberField = arguments[2];
	
	  if (isNumberFieldType && value === 0) {
	    return '';
	  }
	
	  if (isPhoneNumberField) {
	    return (0, _phone.formatVisiblePhoneNumber)(value.toString());
	  }
	
	  return value;
	}

/***/ }),
/* 3749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _popup = __webpack_require__(76);
	
	var _brandConfig = __webpack_require__(142);
	
	var _brandConfig2 = _interopRequireDefault(_brandConfig);
	
	var _MobileAppLogo = __webpack_require__(1768);
	
	var _MobileAppLogo2 = _interopRequireDefault(_MobileAppLogo);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(5147);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MobileAppModal() {
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var skip = function skip() {
	    return dispatch((0, _popup.hideMobileAppPopup)());
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(_Icon2.default, {
	      size: 98,
	      name: _brandConfig2.default.logo,
	      style: (0, _extends3.default)({}, _brandConfig.isFlagler && { fill: _brandConfig2.default.fillColor })
	    }),
	    _react2.default.createElement(
	      'p',
	      { className: _styles2.default.title },
	      formatMessage({ id: 'mobile.app.title' })
	    ),
	    _react2.default.createElement(_MobileAppLogo2.default, { className: _styles2.default.socialApps }),
	    _react2.default.createElement(
	      'p',
	      { className: _styles2.default.meta },
	      formatMessage({ id: 'mobile.app.getAppText' }, { name: _brandConfig2.default.name })
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { onClick: skip, color: 'primary', className: _styles2.default.btn, raised: true },
	      formatMessage({ id: 'common.skip' })
	    )
	  );
	}
	
	exports.default = MobileAppModal;

/***/ }),
/* 3750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _ReportListItem = __webpack_require__(3751);
	
	var _ReportListItem2 = _interopRequireDefault(_ReportListItem);
	
	var _ReadMoreBtn = __webpack_require__(1194);
	
	var _ReadMoreBtn2 = _interopRequireDefault(_ReadMoreBtn);
	
	var _strings = __webpack_require__(15);
	
	var _withErrorBoundary = __webpack_require__(619);
	
	var _index = __webpack_require__(1509);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportList = function ReportList(_ref) {
	  var list = _ref.list,
	      formatMessage = _ref.intl.formatMessage,
	      onSelect = _ref.onSelect;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      showFull = _useState2[0],
	      setShowFull = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      selected = _useState4[0],
	      setSelected = _useState4[1];
	
	  var rootList = showFull ? list : list.filter(function (item) {
	    return !item.extra;
	  });
	  var hasMore = rootList.length !== list.length;
	
	  var textBtn = formatMessage(_strings.ACTIONS.program.more) + '...';
	
	  var handleClickItem = function handleClickItem(_ref2) {
	    var id = _ref2.id;
	
	    setSelected(id);
	    onSelect(id);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    rootList.map(function (item) {
	      return _react2.default.createElement(
	        _ClickableElement2.default,
	        { key: item.id, onClick: function onClick() {
	            return handleClickItem(item);
	          } },
	        _react2.default.createElement(_ReportListItem2.default, { item: item, selected: selected })
	      );
	    }),
	    hasMore && !showFull && _react2.default.createElement(_ReadMoreBtn2.default, {
	      styleName: 'list-btn',
	      onClick: function onClick() {
	        return setShowFull(true);
	      },
	      children: textBtn
	    })
	  );
	};
	
	ReportList.propTypes = {
	  list: _propTypes2.default.array.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  onSelect: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _recompose.compose)(_withErrorBoundary.withErrorBoundary, _reactIntl.injectIntl, (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(ReportList);

/***/ }),
/* 3751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Input = __webpack_require__(1191);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(1509);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportListItem = function ReportListItem(_ref) {
	  var _ref$item = _ref.item,
	      name = _ref$item.name,
	      id = _ref$item.id,
	      selected = _ref.selected;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'list-item' },
	    _react2.default.createElement(_Card2.default, {
	      className: 'fw6',
	      text: {
	        primary: name
	      },
	      additionalContent: {
	        left: _react2.default.createElement(_Input2.default, {
	          size: 16,
	          color: _styles.COLORS.bluePrimary,
	          checked: selected === id,
	          readOnly: true
	        })
	      }
	    })
	  );
	};
	
	ReportListItem.propTypes = {
	  item: _propTypes2.default.object.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  selected: _propTypes2.default.number.isRequired
	};
	
	exports.default = (0, _recompose.compose)((0, _reactCssModules2.default)(_index2.default, { allowMultiple: true })(ReportListItem));

/***/ }),
/* 3752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _withErrorBoundary = __webpack_require__(619);
	
	var _selectors = __webpack_require__(50);
	
	var _index = __webpack_require__(1509);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    reportReasons: (0, _selectors.selectComplaintReasons)(state)
	  };
	};
	
	var mapDispatchToProps = {};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_withErrorBoundary.withErrorBoundary, _reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ReportList = __webpack_require__(3750);
	
	var _ReportList2 = _interopRequireDefault(_ReportList);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _enhance = __webpack_require__(3752);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Report = function Report(_ref) {
	  var reportReasons = _ref.reportReasons,
	      options = _ref.options,
	      formatMessage = _ref.intl.formatMessage,
	      onSelect = _ref.onSelect;
	
	  var rootReportReasons = reportReasons.filter(function (item) {
	    return item.resource === options.resource;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { styleName: 'description', className: 'flex' },
	      _react2.default.createElement(_Icon2.default, {
	        name: 'exclamation-mark-hover',
	        style: { fill: _styles.COLORS.orangePink },
	        className: 'flex-shrink-0'
	      }),
	      _react2.default.createElement(
	        'p',
	        { styleName: 'description__text' },
	        formatMessage(_strings.REPORT.danger)
	      )
	    ),
	    _react2.default.createElement(_ReportList2.default, { list: rootReportReasons, onSelect: onSelect })
	  );
	};
	
	Report.propTypes = {
	  reportReasons: _propTypes2.default.array.isRequired,
	  options: _propTypes2.default.object.isRequired,
	  intl: _propTypes2.default.shape({
	    formatMessage: _propTypes2.default.func
	  }).isRequired,
	  onSelect: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(Report);

/***/ }),
/* 3754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cuid = __webpack_require__(936);
	
	var _cuid2 = _interopRequireDefault(_cuid);
	
	var _index = __webpack_require__(2270);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InfoRow(_ref) {
	  var list = _ref.list;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.rowWrapper },
	    list.map(function (row) {
	      return _react2.default.createElement(
	        'div',
	        { className: _index2.default.row, key: (0, _cuid2.default)() },
	        row.map(function (_ref2) {
	          var title = _ref2.title,
	              subtitle = _ref2.subtitle;
	          return _react2.default.createElement(
	            'div',
	            { className: _index2.default.item, key: title },
	            _react2.default.createElement(
	              'p',
	              { className: _index2.default.title },
	              ' ',
	              title
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: _index2.default.subtitle },
	              subtitle
	            )
	          );
	        })
	      );
	    })
	  );
	}
	
	InfoRow.propTypes = {
	  list: _propTypes2.default.array
	};
	
	exports.default = InfoRow;

/***/ }),
/* 3755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _index = __webpack_require__(2270);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UserInfoCard(_ref) {
	  var onClick = _ref.onClick,
	      disabled = _ref.disabled,
	      avatarUrl = _ref.avatarUrl,
	      avatarText = _ref.avatarText,
	      avatarSize = _ref.avatarSize,
	      buttonText = _ref.buttonText,
	      buttonColor = _ref.buttonColor,
	      textPrimary = _ref.textPrimary,
	      cardClassName = _ref.cardClassName,
	      wrapperClassName = _ref.wrapperClassName,
	      textComplementary = _ref.textComplementary;
	
	  return _react2.default.createElement(
	    'div',
	    { className: wrapperClassName },
	    _react2.default.createElement(_Card2.default, {
	      className: cardClassName,
	      text: {
	        primary: textPrimary,
	        complementary: textComplementary
	      },
	      additionalContent: {
	        left: _react2.default.createElement(_SimpleAvatar2.default, { src: avatarUrl, text: avatarText, size: avatarSize })
	      }
	    }),
	    Boolean(buttonText) ? _react2.default.createElement(
	      _Button2.default,
	      { color: buttonColor, onClick: onClick, disabled: disabled },
	      buttonText
	    ) : null
	  );
	}
	
	UserInfoCard.defaultProps = {
	  wrapperClassName: _index2.default.cardWrapper,
	  cardClassName: _index2.default.card
	};
	
	UserInfoCard.propTypes = {
	  onClick: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  avatarUrl: _propTypes2.default.string,
	  avatarText: _propTypes2.default.string,
	  avatarSize: _propTypes2.default.number,
	  buttonText: _propTypes2.default.string,
	  buttonColor: _propTypes2.default.string,
	  textPrimary: _propTypes2.default.string,
	  cardClassName: _propTypes2.default.string,
	  wrapperClassName: _propTypes2.default.string,
	  textComplementary: _propTypes2.default.string
	};
	
	exports.default = UserInfoCard;

/***/ }),
/* 3756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UserInfoCard = __webpack_require__(3755);
	
	var _UserInfoCard2 = _interopRequireDefault(_UserInfoCard);
	
	var _InfoRow = __webpack_require__(3754);
	
	var _InfoRow2 = _interopRequireDefault(_InfoRow);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UserInfoBlock(_ref) {
	  var list = _ref.list,
	      onClick = _ref.onClick,
	      disabled = _ref.disabled,
	      avatarUrl = _ref.avatarUrl,
	      className = _ref.className,
	      avatarSize = _ref.avatarSize,
	      avatarText = _ref.avatarText,
	      buttonText = _ref.buttonText,
	      buttonColor = _ref.buttonColor,
	      textPrimary = _ref.textPrimary,
	      textComplementary = _ref.textComplementary;
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    { className: className },
	    _react2.default.createElement(_UserInfoCard2.default, {
	      onClick: onClick,
	      disabled: disabled,
	      avatarUrl: avatarUrl,
	      avatarSize: avatarSize,
	      avatarText: avatarText,
	      buttonText: buttonText,
	      buttonColor: buttonColor,
	      textPrimary: textPrimary,
	      textComplementary: textComplementary
	    }),
	    _react2.default.createElement(_InfoRow2.default, { list: list })
	  );
	}
	
	UserInfoBlock.propTypes = {
	  list: _propTypes2.default.array,
	  onClick: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  avatarUrl: _propTypes2.default.string,
	  avatarSize: _propTypes2.default.number,
	  avatarText: _propTypes2.default.string,
	  buttonText: _propTypes2.default.string,
	  buttonColor: _propTypes2.default.string,
	  textPrimary: _propTypes2.default.string,
	  textComplementary: _propTypes2.default.string
	};
	
	exports.default = UserInfoBlock;

/***/ }),
/* 3757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reqMemberInvitation = __webpack_require__(654);
	
	var _selectors = __webpack_require__(151);
	
	var _selectors2 = __webpack_require__(90);
	
	var _selectors3 = __webpack_require__(50);
	
	var _strings = __webpack_require__(15);
	
	var _InviteForm = __webpack_require__(1723);
	
	var _InviteForm2 = _interopRequireDefault(_InviteForm);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserInviteForm = function UserInviteForm(_ref) {
	  var error = _ref.error,
	      sendInvite = _ref.sendInvite,
	      formInProgress = _ref.formInProgress,
	      formatMessage = _ref.formatMessage,
	      clearErrors = _ref.clearErrors,
	      communityId = _ref.communityId,
	      props = (0, _objectWithoutProperties3.default)(_ref, ['error', 'sendInvite', 'formInProgress', 'formatMessage', 'clearErrors', 'communityId']);
	
	  var handleErrors = function handleErrors() {
	    if (!error) return '';
	    var errorMessage = {
	      invalid: formatMessage(_strings.COMMON_ERROR_MESSAGES.emailAndPhoneError),
	      present: formatMessage(_strings.COMMON_ERROR_MESSAGES.alreadyUsed)
	    };
	    var code = (0, _get2.default)(error, 'code');
	    return errorMessage ? errorMessage[code] : formatMessage(_strings.COMMON_ERROR_MESSAGES.error);
	  };
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isSend = _useState2[0],
	      setIsSend = _useState2[1];
	
	  var validateForm = function validateForm(_ref2) {
	    var login = _ref2.login;
	    return !!login === true && !isSend;
	  };
	  var handleSubmit = function handleSubmit(data) {
	    var login = data.login;
	
	    sendInvite({ login: login, communityId: communityId });
	    setIsSend(true);
	  };
	
	  return _react2.default.createElement(
	    _InviteForm2.default,
	    (0, _extends3.default)({
	      onSubmit: handleSubmit,
	      onError: handleErrors,
	      isFormValid: validateForm,
	      inviteMessage: formatMessage(_strings.AUTH.titles.invitationLinkDesc) + ' ' + formatMessage(_strings.AUTH.actions.expiredToken.textTitle),
	      formatMessage: formatMessage
	    }, { error: error }, props, {
	      hideTerms: true
	    }),
	    _react2.default.createElement(_TextInput2.default, {
	      styleName: 'invite-input',
	      className: 'mb3 mt3',
	      id: 'invite-login',
	      label: formatMessage(_strings.AUTH.fields.loginPlaceholder),
	      name: 'login',
	      placeholder: formatMessage(_strings.AUTH.fields.loginPlaceholder),
	      required: true,
	      rounded: true,
	      type: 'text',
	      value: formInProgress.login,
	      onChange: error && clearErrors
	    })
	  );
	}; /* eslint react/require-default-props: 0 */
	
	
	UserInviteForm.propTypes = {
	  sendInvite: _propTypes2.default.func,
	  clearErrors: _propTypes2.default.func,
	  error: _propTypes2.default.object,
	  formInProgress: _propTypes2.default.object,
	  formatMessage: _propTypes2.default.func,
	  communityId: _propTypes2.default.number
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    error: (0, _selectors.reqMemberInvitationErrorSelector)(state),
	    formInProgress: (0, _selectors2.uiFormInProgressSelector)(state),
	    countries: (0, _selectors3.privacyCountriesSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  clearErrors: _reqMemberInvitation.actions.clear
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UserInviteForm);

/***/ }),
/* 3758 */,
/* 3759 */,
/* 3760 */,
/* 3761 */,
/* 3762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SignConsent = __webpack_require__(1810);
	
	var _SignConsent2 = _interopRequireDefault(_SignConsent);
	
	var _useSignConsentAPI2 = __webpack_require__(1811);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvitePatientConsent = function InvitePatientConsent(_ref) {
	  var code = _ref.code;
	
	  var appointment = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationJoinData);
	
	  var _useSignConsentAPI = (0, _useSignConsentAPI2.useSignConsentAPI)({
	    makeUrl: function makeUrl(id) {
	      return '/appointments/consents/' + id + '/user_consent_info';
	    },
	    payload: { invite_code: code }
	  }),
	      loading = _useSignConsentAPI.loading,
	      signConsent = _useSignConsentAPI.signConsent;
	
	  return _react2.default.createElement(_SignConsent2.default, {
	    appointment: appointment,
	    onSign: signConsent,
	    loading: loading
	  });
	};
	
	InvitePatientConsent.propTypes = {
	  code: _propTypes2.default.string
	};
	
	exports.default = InvitePatientConsent;

/***/ }),
/* 3763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _formatAmount = __webpack_require__(434);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _styles = __webpack_require__(5149);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PaymentGate(_ref) {
	  var appointmentId = _ref.appointmentId,
	      copay = _ref.copay;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var handlePay = function handlePay() {
	    dispatch(_appointmentDetails.appointmentDetailsActions.startPaymentProcess({ id: appointmentId }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.card },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.title },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'virtualVisit.paymentGate.title' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.description },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'virtualVisit.paymentGate.description' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.cost },
	      _react2.default.createElement(
	        'span',
	        { className: _styles2.default.costLabel },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'virtualVisit.paymentGate.yourCost' })
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: _styles2.default.costAmount },
	        _react2.default.createElement(_reactIntl.FormattedMessage, {
	          id: 'virtualVisit.paymentGate.total',
	          values: { amount: '$' + (0, _formatAmount.formatAmount)(copay) }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { color: 'primary', raised: true, onClick: handlePay },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'virtualVisit.paymentGate.pay' })
	    )
	  );
	}
	
	PaymentGate.propTypes = {
	  appointmentId: PropTypes.number,
	  copay: PropTypes.number
	};
	
	exports.default = PaymentGate;

/***/ }),
/* 3764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRouter = __webpack_require__(42);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _InvitePatientConsent = __webpack_require__(3762);
	
	var _InvitePatientConsent2 = _interopRequireDefault(_InvitePatientConsent);
	
	var _PaymentGate = __webpack_require__(3763);
	
	var _PaymentGate2 = _interopRequireDefault(_PaymentGate);
	
	var _VisitHeader = __webpack_require__(1176);
	
	var _VisitHeader2 = _interopRequireDefault(_VisitHeader);
	
	var _index = __webpack_require__(17);
	
	var _roomInvitationInfoReq = __webpack_require__(858);
	
	var roomInvitationInfo = _interopRequireWildcard(_roomInvitationInfoReq);
	
	var _connectionRoomJoinReq = __webpack_require__(854);
	
	var connectionRoomJoin = _interopRequireWildcard(_connectionRoomJoinReq);
	
	var _selectors = __webpack_require__(64);
	
	var _styles = __webpack_require__(5151);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _usePageView = __webpack_require__(52);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VirtualRoom(_ref) {
	  var connectionRoom = _ref.connectionRoom,
	      location = _ref.location;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var errorVirtualRoom = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationJoinError);
	  var errorConnectionRoom = (0, _reactRedux.useSelector)(_selectors.selectConnectionRoomJoinError);
	  var errorInvitationInfo = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationInfoError);
	  var joinName = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationJoinRoomName);
	  var infoName = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationInfoPatientName);
	  var name = joinName || infoName;
	  var status = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationJoinStatus);
	  var pendingVirtualRoom = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationJoinPending);
	  var pendingConnectionRoom = (0, _reactRedux.useSelector)(_selectors.selectConnectionRoomJoinPending);
	  var pendingInvitationInfo = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationInfoPending);
	  var shouldSignConsent = (0, _reactRedux.useSelector)(_selectors.selectShouldSignConsent);
	  var invitationInfoSucceed = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationInfoSucceed);
	  var isRequiredPayment = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationInfoPaymentRequired);
	  var appointmentId = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationInfoAppointmentId);
	  var copay = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationInfoCopay);
	  var visitTypeName = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationInfoVisitTypeName);
	  var joinSucceed = (0, _reactRedux.useSelector)(_selectors.selectRoomInvitationJoinSucceed);
	
	  var code = (0, _get2.default)(window.location, 'hash', '').slice(1);
	  var combinedPending = pendingVirtualRoom || pendingConnectionRoom || pendingInvitationInfo;
	  var combinedError = errorVirtualRoom || errorConnectionRoom || errorInvitationInfo;
	
	  (0, _usePageView.usePageView)('Virtual Room | Invite');
	  (0, _react.useEffect)(function () {
	    if (connectionRoom) {
	      dispatch(connectionRoomJoin.actions.send({ inviteCode: code }));
	    } else {
	      dispatch(roomInvitationInfo.actions.send({ inviteCode: code }));
	    }
	  }, [connectionRoom, location]);
	
	  var completed = _index.COMPLETED_APPOINTMENT_STATUSES.includes(status);
	
	  var showPaymentGate = !connectionRoom && !!invitationInfoSucceed && isRequiredPayment && !pendingVirtualRoom && !joinSucceed;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.wrapper },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.virtualRoom' }),
	    _react2.default.createElement(_VisitHeader2.default, {
	      full: true,
	      noInfo: true,
	      noDescription: true,
	      roomDetails: { name: name, connectionRoom: connectionRoom, visitType: visitTypeName }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.content },
	      combinedPending && _react2.default.createElement(_Loader2.default, null),
	      !combinedPending && showPaymentGate && _react2.default.createElement(_PaymentGate2.default, { appointmentId: appointmentId, copay: copay }),
	      shouldSignConsent && _react2.default.createElement(_InvitePatientConsent2.default, { code: code }),
	      !combinedPending && (combinedError || completed) && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(_Icon2.default, { name: 'video-completed', size: 100, className: _styles2.default.icon }),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.text },
	          completed ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'virtualVisit.error.visitCompleted' }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'virtualVisit.error.' + (connectionRoom ? 'callCompleted' : 'invalidLink')
	          })
	        )
	      ),
	      !combinedPending && !combinedError && connectionRoom && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(_Icon2.default, { name: 'video-completed', size: 100, className: _styles2.default.icon }),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.text },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'virtualVisit.error.callCompleted' })
	        )
	      )
	    )
	  );
	}
	
	VirtualRoom.propTypes = {
	  location: PropTypes.object,
	  connectionRoom: PropTypes.bool
	};
	
	exports.default = (0, _reactRouter.withRouter)(VirtualRoom);

/***/ }),
/* 3765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Placeholder = __webpack_require__(1812);
	
	var _Placeholder2 = _interopRequireDefault(_Placeholder);
	
	var _CollapsedBar = __webpack_require__(3768);
	
	var _CollapsedBar2 = _interopRequireDefault(_CollapsedBar);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _PublisherBtns = __webpack_require__(1815);
	
	var _PublisherBtns2 = _interopRequireDefault(_PublisherBtns);
	
	var _context = __webpack_require__(306);
	
	var _shapes = __webpack_require__(351);
	
	var _useDragVideo2 = __webpack_require__(1895);
	
	var _useVirtualVisit2 = __webpack_require__(352);
	
	var _styles = __webpack_require__(5153);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _constants = __webpack_require__(420);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ActiveSpeaker(_ref) {
	  var publisher = _ref.publisher,
	      coords = _ref.coords,
	      onPin = _ref.onPin;
	
	  var _useContext = (0, _react.useContext)(_context.OTContext),
	      state = _useContext.state,
	      focusedId = _useContext.focusedId,
	      PUBLISHER_KEY = _useContext.PUBLISHER_KEY;
	
	  var loading = state.loading,
	      connections = state.connections;
	
	  var _useVirtualVisit = (0, _useVirtualVisit2.useVirtualVisit)(),
	      viewOptions = _useVirtualVisit.viewOptions,
	      placeholder = _useVirtualVisit.placeholder;
	
	  var collapsed = viewOptions.collapsed,
	      fullScreenView = viewOptions.fullScreenView;
	
	  var _useDragVideo = (0, _useDragVideo2.useDragVideo)(coords, collapsed),
	      isDragging = _useDragVideo.isDragging,
	      drag = _useDragVideo.drag;
	
	  var isMe = focusedId === PUBLISHER_KEY;
	  var moreOneUserInRoom = (0, _keys2.default)(connections).length > 1;
	  var activeRef = (0, _react.useRef)();
	
	  var sharingConnectionId = (0, _react.useMemo)(function () {
	    var sharingConnection = (0, _values2.default)(connections).find(function (connection) {
	      return (0, _get2.default)(connection, 'stream.videoType') === _constants.SCREEN_SHARING_VIDEO_TYPE;
	    });
	
	    if ((0, _get2.default)(sharingConnection, 'ready')) {
	      return (0, _get2.default)(sharingConnection, 'id');
	    }
	
	    return null;
	  }, [connections]);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return connections[focusedId] || {};
	  }, [focusedId, connections]),
	      video = _useMemo.video,
	      activeStream = _useMemo.stream,
	      activeUser = _useMemo.user;
	
	  (0, _react.useEffect)(function () {
	    if (activeRef.current) {
	      activeRef.current.srcObject = video ? video.srcObject : null;
	    }
	  }, [video]);
	
	  (0, _react.useEffect)(function () {
	    if (sharingConnectionId) {
	      onPin({ id: sharingConnectionId });
	    }
	  }, [sharingConnectionId]);
	
	  var noVideo = activeStream && !activeStream.hasVideo;
	
	  var style = (0, _react.useMemo)(function () {
	    return {
	      left: coords.left,
	      top: coords.top
	    };
	  }, [coords]);
	
	  var subscriberClasses = (0, _react.useMemo)(function () {
	    var _ref2;
	
	    return _ref2 = {}, (0, _defineProperty3.default)(_ref2, _styles2.default.noVideo, noVideo), (0, _defineProperty3.default)(_ref2, _styles2.default.collapsed, collapsed), (0, _defineProperty3.default)(_ref2, _styles2.default.fullView, !collapsed), (0, _defineProperty3.default)(_ref2, _styles2.default.isDragging, isDragging), (0, _defineProperty3.default)(_ref2, _styles2.default.me, isMe), (0, _defineProperty3.default)(_ref2, _styles2.default.fullScreenView, fullScreenView), _ref2;
	  }, [noVideo, collapsed, isDragging, isMe, fullScreenView]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_styles2.default.subscriber, subscriberClasses),
	      style: style,
	      ref: drag
	    },
	    loading && _react2.default.createElement(_Loader2.default, { className: _styles2.default.loader }),
	    _react2.default.createElement('video', { ref: activeRef, autoPlay: true, muted: true }),
	    collapsed && _react2.default.createElement(_CollapsedBar2.default, { activeUser: activeUser }),
	    !collapsed && publisher && _react2.default.createElement(_PublisherBtns2.default, { publisher: publisher, disabled: loading }),
	    !collapsed && !loading && placeholder && !moreOneUserInRoom && _react2.default.createElement(_Placeholder2.default, placeholder)
	  );
	}
	
	ActiveSpeaker.propTypes = {
	  publisher: _shapes.ConnectionShape,
	  placeholder: PropTypes.object,
	  onPin: PropTypes.func,
	  coords: PropTypes.shape({
	    left: PropTypes.number,
	    top: PropTypes.number
	  })
	};
	
	exports.default = ActiveSpeaker;

/***/ }),
/* 3766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ring = __webpack_require__(6489);
	
	var _ring2 = _interopRequireDefault(_ring);
	
	var _notifications = __webpack_require__(672);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AudioTag() {
	  var audioRef = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    return (0, _notifications.subscribeToNotification)(playAudio);
	  }, []);
	
	  function playAudio() {
	    audioRef.current.play();
	  }
	
	  return _react2.default.createElement(
	    'audio',
	    { ref: audioRef },
	    _react2.default.createElement('source', { src: _ring2.default }),
	    'Your browser isn\'t invited for super fun audio time.'
	  );
	} /* eslint-disable jsx-a11y/media-has-caption */
	
	
	AudioTag.propTypes = {};
	
	exports.default = AudioTag;

/***/ }),
/* 3767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateFns = __webpack_require__(275);
	
	var _useInterval = __webpack_require__(4131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatDuration(ms) {
	  var totalSeconds = Math.floor(ms / 1000);
	  var h = Math.floor(totalSeconds / 3600);
	  var m = Math.floor(totalSeconds % 3600 / 60);
	  var s = totalSeconds % 60;
	  return [h, m, s].map(function (n) {
	    return String(n).padStart(2, '0');
	  }).join(':');
	}
	
	function CallDuration(_ref) {
	  var time = _ref.time,
	      timerActive = _ref.timerActive,
	      currentTimestamp = _ref.currentTimestamp,
	      isConnectionRoom = _ref.isConnectionRoom,
	      previousDuration = _ref.previousDuration,
	      currentSessionStartedAt = _ref.currentSessionStartedAt;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      diff = _useState2[0],
	      setDiff = _useState2[1];
	
	  var duration = (0, _react.useMemo)(function () {
	    if (!diff) return '-';
	    return formatDuration(diff);
	  }, [diff]);
	
	  var clearTime = (0, _react.useMemo)(function () {
	    return time ? (0, _dateFns.parseISO)(time) : null;
	  }, [time]);
	
	  (0, _react.useEffect)(function () {
	    if (!isConnectionRoom && !timerActive && !diff) {
	      setDiff((previousDuration || 0) * 1000);
	    }
	  }, [timerActive, previousDuration, isConnectionRoom, currentSessionStartedAt]);
	
	  (0, _useInterval.useInterval)(function () {
	    if (isConnectionRoom) {
	      setDiff((0, _dateFns.differenceInMilliseconds)(new Date(), clearTime));
	    }
	    if (!isConnectionRoom && timerActive) {
	      setDiff(diff ? diff + 1000 : (previousDuration || 0) * 1000 + (currentSessionStartedAt ? (0, _dateFns.differenceInMilliseconds)(currentTimestamp ? (0, _dateFns.parseISO)(currentTimestamp) : new Date(), (0, _dateFns.parseISO)(currentSessionStartedAt)) : 0));
	    }
	  }, 1000);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'dib' },
	    duration
	  );
	}
	
	CallDuration.propTypes = {
	  time: _propTypes2.default.string,
	  timerActive: _propTypes2.default.bool,
	  isConnectionRoom: _propTypes2.default.bool,
	  previousDuration: _propTypes2.default.number,
	  currentTimestamp: _propTypes2.default.string,
	  currentSessionStartedAt: _propTypes2.default.string
	};
	
	exports.default = CallDuration;

/***/ }),
/* 3768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _useVirtualVisit2 = __webpack_require__(352);
	
	var _styles = __webpack_require__(5154);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/jsx-handler-names */
	function CollapsedBar(_ref) {
	  var activeUser = _ref.activeUser;
	
	  var _useVirtualVisit = (0, _useVirtualVisit2.useVirtualVisit)(),
	      viewOptions = _useVirtualVisit.viewOptions;
	
	  var name = (0, _react.useMemo)(function () {
	    return (0, _get2.default)(activeUser, 'name');
	  }, [activeUser]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'span',
	      { className: _styles2.default.name },
	      name
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.icon, onClick: viewOptions.expandView },
	      _react2.default.createElement(_Icon2.default, { name: 'fullscreen', size: 16 })
	    )
	  );
	}
	
	CollapsedBar.propTypes = {
	  activeUser: PropTypes.object
	};
	
	exports.default = CollapsedBar;

/***/ }),
/* 3769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _loginValidator = __webpack_require__(1393);
	
	var _loginValidator2 = _interopRequireDefault(_loginValidator);
	
	var _isEmail = __webpack_require__(1946);
	
	var _styles = __webpack_require__(2271);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteGuestInput = function InviteGuestInput(_ref) {
	  var formatMessage = _ref.formatMessage,
	      item = _ref.item,
	      _onChange = _ref.onChange,
	      onError = _ref.onError;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      emailOrPhoneError = _useState2[0],
	      setEmailOrPhoneError = _useState2[1];
	
	  var isValidEmailOrPhone = function isValidEmailOrPhone(val) {
	    var isValid = val ? (0, _loginValidator2.default)(val) : true;
	    if (!isValid) {
	      var errorId = (0, _isEmail.isEmail)(val) ? 'errors.validation.invalidLoginEmail' : 'errors.validation.invalidLoginPhone';
	      setEmailOrPhoneError(formatMessage({ id: errorId }));
	    }
	  };
	
	  var resetEmailOrPhoneError = function resetEmailOrPhoneError() {
	    if (emailOrPhoneError) setEmailOrPhoneError('');
	  };
	
	  (0, _react.useEffect)(function () {
	    onError(Boolean(emailOrPhoneError));
	  }, [emailOrPhoneError]);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_TextInput2.default, {
	      placeholder: formatMessage({
	        id: 'fields.emailPhoneNumber'
	      }),
	      label: formatMessage({ id: 'fields.emailPhoneNumber' }),
	      type: 'text',
	      name: 'email',
	      value: item.email,
	      onBlur: function onBlur(val) {
	        return isValidEmailOrPhone(val);
	      },
	      onFocus: resetEmailOrPhoneError,
	      onChange: function onChange(ev) {
	        return _onChange(ev, item.id);
	      }
	    }),
	    Boolean(emailOrPhoneError) ? _react2.default.createElement(_ErrorBlock2.default, {
	      errors: emailOrPhoneError,
	      className: (0, _classnames2.default)(_styles2.default.errorBlock, 'mt3 mb3')
	    }) : null
	  );
	};
	
	InviteGuestInput.propTypes = {
	  item: PropTypes.object,
	  onChange: PropTypes.func,
	  formatMessage: PropTypes.func,
	  onError: PropTypes.func
	};
	
	exports.default = InviteGuestInput;

/***/ }),
/* 3770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _uniq = __webpack_require__(380);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _concat = __webpack_require__(2347);
	
	var _concat2 = _interopRequireDefault(_concat);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _inviteGuestToVirtualRoomReq = __webpack_require__(855);
	
	var _selectors = __webpack_require__(294);
	
	var _selectors2 = __webpack_require__(64);
	
	var _isEmail = __webpack_require__(1946);
	
	var _InviteGuestInput = __webpack_require__(3769);
	
	var _InviteGuestInput2 = _interopRequireDefault(_InviteGuestInput);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _errors = __webpack_require__(120);
	
	var _styles2 = __webpack_require__(2271);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialInputState = {
	  email: '',
	  id: Math.random()
	};
	
	function InviteGuestForm(_ref) {
	  var close = _ref.close,
	      formatMessage = _ref.intl.formatMessage;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isError = _useState2[0],
	      setIsError = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([initialInputState]),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      inputList = _useState4[0],
	      setInputList = _useState4[1];
	
	  var errorRef = (0, _react.useRef)(null);
	
	  var appointment = (0, _reactRedux.useSelector)(_selectors.selectCurrentAppointment);
	  var safeAppointmentId = (0, _reactRedux.useSelector)(_selectors2.selectAppointmentIdFromConfig);
	  var existing = (0, _reactRedux.useSelector)(_selectors2.selectCallInvitationsExisting);
	  var error = (0, _reactRedux.useSelector)(_selectors2.selectCallInvitationsSendError);
	  var loading = (0, _reactRedux.useSelector)(_selectors2.selectCallInvitationsSendLoading);
	
	  var appointmentId = (0, _get2.default)(appointment, 'id', safeAppointmentId);
	  errorRef.current = error;
	
	  var inviteeData = (0, _uniq2.default)(inputList.map(function (el) {
	    return el.email;
	  }));
	  var hasEmptyValues = inputList.some(function (el) {
	    return (0, _isEmpty2.default)(el.email);
	  });
	
	  var handleChange = function handleChange(ev, id) {
	    var currentInputList = inputList.map(function (el) {
	      return el.id === id ? (0, _extends3.default)({}, el, { email: ev }) : el;
	    });
	    setInputList(currentInputList);
	    if (errorRef.current) {
	      dispatch(_inviteGuestToVirtualRoomReq.actions.clear());
	    }
	  };
	
	  var handleAdd = function handleAdd() {
	    var values = [].concat((0, _toConsumableArray3.default)(inputList));
	    values.push((0, _extends3.default)({}, initialInputState, { id: Math.random() }));
	    setInputList(values);
	  };
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      return dispatch(_inviteGuestToVirtualRoomReq.actions.clear());
	    };
	  }, []);
	
	  var errorMessage = (0, _react.useMemo)(function () {
	    if (!error) return '';
	    var code = (0, _get2.default)(error, 'error.code');
	    var id = code === _errors.ERROR_CODES.INVALID_PHONE_NUMBER ? 'errors.validation.invalidLoginPhone' : 'errors.common';
	    return formatMessage({ id: id });
	  }, [error]);
	
	  var handleSubmit = function handleSubmit() {
	    var guests = [];
	    (0, _values2.default)(inviteeData).forEach(function (value) {
	      if ((0, _isEmail.isEmail)(value) && !(0, _concat2.default)(existing, guests.filter(function (el) {
	        return el.email;
	      }).map(function (el) {
	        return el.email;
	      })).includes(value)) {
	        guests.push({ email: value });
	      }
	      if (!(0, _isEmail.isEmail)(value) && !(0, _concat2.default)(existing, guests.filter(function (el) {
	        return el.phoneNumber;
	      }).map(function (el) {
	        return el.phoneNumber;
	      })).includes(value)) {
	        guests.push({ phone_number: value });
	      }
	    });
	    if (guests.length > 0) {
	      var data = { appointmentId: appointmentId, guests: guests, close: close };
	      dispatch(_inviteGuestToVirtualRoomReq.actions.init(data));
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles3.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _styles3.default.description },
	      formatMessage({ id: 'virtualVisit.inviteGuest.description' })
	    ),
	    inputList.map(function (item) {
	      return _react2.default.createElement(_InviteGuestInput2.default, {
	        key: item.id,
	        item: item,
	        formatMessage: formatMessage,
	        onChange: handleChange,
	        onError: setIsError
	      });
	    }),
	    errorMessage && _react2.default.createElement(_ErrorBlock2.default, { errors: errorMessage }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles3.default.btnAdd },
	      _react2.default.createElement(
	        'button',
	        { type: 'button', onClick: function onClick() {
	            return handleAdd();
	          } },
	        _react2.default.createElement(_Icon2.default, { name: 'add-text', size: 16, style: { fill: _styles.COLORS.stormyBlue } }),
	        _react2.default.createElement(
	          'span',
	          null,
	          formatMessage({ id: 'virtualVisit.inviteGuest.addGuest' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles3.default.btnsSubmit },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          type: 'button',
	          color: 'primary',
	          raised: true,
	          disabled: isError || hasEmptyValues || loading,
	          onClick: handleSubmit
	        },
	        formatMessage({ id: 'community.menu.invite' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { type: 'button', raised: true, color: 'accent', onClick: close },
	        formatMessage({ id: 'common.cancel' })
	      )
	    )
	  );
	}
	
	InviteGuestForm.propTypes = {
	  intl: PropTypes.object,
	  close: PropTypes.func
	};
	
	exports.default = (0, _reactIntl.injectIntl)(InviteGuestForm);

/***/ }),
/* 3771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _InviteGuestForm = __webpack_require__(3770);
	
	var _InviteGuestForm2 = _interopRequireDefault(_InviteGuestForm);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _styles = __webpack_require__(5155);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteGuestPopup = function InviteGuestPopup(_ref) {
	  var opened = _ref.opened,
	      onClose = _ref.onClose,
	      formatMessage = _ref.intl.formatMessage;
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      opened: opened,
	      className: _styles2.default.invitePopup,
	      white: true,
	      title: formatMessage({ id: 'virtualVisit.inviteGuest.title' }),
	      onClose: onClose
	    },
	    _react2.default.createElement(_InviteGuestForm2.default, { close: onClose })
	  );
	};
	
	InviteGuestPopup.propTypes = {
	  opened: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(InviteGuestPopup);

/***/ }),
/* 3772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _styles = __webpack_require__(18);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _RemoveInvitationLinkPopup = __webpack_require__(3785);
	
	var _RemoveInvitationLinkPopup2 = _interopRequireDefault(_RemoveInvitationLinkPopup);
	
	var _PatientControls = __webpack_require__(1816);
	
	var _PatientControls2 = _interopRequireDefault(_PatientControls);
	
	var _styles2 = __webpack_require__(1510);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteeBtns = function InviteeBtns(_ref) {
	  var invitee = _ref.invitee;
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      opened = _useToggleFlag2[0],
	      open = _useToggleFlag2[1],
	      close = _useToggleFlag2[2];
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles3.default.root },
	    _react2.default.createElement('div', { className: _styles3.default.overlay }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles3.default.actions },
	      _react2.default.createElement(
	        'button',
	        {
	          type: 'button',
	          className: (0, _classnames2.default)(_styles3.default.btn, _styles3.default.btnClose),
	          onClick: open
	        },
	        _react2.default.createElement(_Icon2.default, { name: 'close', style: { stroke: _styles.COLORS.white, width: '14px' } })
	      ),
	      opened ? _react2.default.createElement(_RemoveInvitationLinkPopup2.default, {
	        opened: opened,
	        onClose: close,
	        email: invitee.login
	      }) : null
	    )
	  );
	};
	
	InviteeBtns.propTypes = {
	  invitee: _propTypes2.default.object
	};
	
	var enhance = (0, _recompose.compose)((0, _recompose.branch)(function (_ref2) {
	  var isProvider = _ref2.isProvider;
	  return !isProvider;
	}, (0, _recompose.renderComponent)(_PatientControls2.default)));
	
	exports.default = enhance(InviteeBtns);

/***/ }),
/* 3773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(5156);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteeView = function InviteeView(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      invitee = _ref.invitee,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.root },
	    children,
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.preview },
	      _react2.default.createElement(_Icon2.default, { name: 'person', size: 47 })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.info },
	      _react2.default.createElement(
	        'span',
	        { className: _stylesModule2.default.truncate },
	        invitee.name || invitee.login
	      ),
	      ' ',
	      _react2.default.createElement(
	        'span',
	        { className: _stylesModule2.default.status },
	        formatMessage({ id: 'virtualVisit.room.pendingInvitation' })
	      )
	    )
	  );
	};
	
	InviteeView.propTypes = {
	  intl: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node,
	  invitee: _propTypes2.default.object
	};
	
	exports.default = (0, _reactIntl.injectIntl)(InviteeView);

/***/ }),
/* 3774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProgressBar = __webpack_require__(782);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AudioLevel(_ref) {
	  var publisher = _ref.publisher;
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      level = _useState2[0],
	      setLevel = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    if (!publisher) return;
	    var movingAvg = null;
	
	    function trackAudioLevelChange(event) {
	      if (movingAvg === null || movingAvg <= event.audioLevel) {
	        movingAvg = event.audioLevel;
	      } else {
	        movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
	      }
	
	      var logLevel = Math.log(movingAvg) / Math.LN10 / 1.5 + 1;
	      logLevel = Math.min(Math.max(logLevel, 0), 1);
	      setLevel(logLevel * 100);
	      return logLevel;
	    }
	
	    publisher.on('audioLevelUpdated', trackAudioLevelChange);
	
	    return function () {
	      if (publisher) {
	        publisher.off('audioLevelUpdated', trackAudioLevelChange);
	      }
	    };
	  }, [publisher]);
	
	  return _react2.default.createElement(_ProgressBar2.default, { progress: level, height: 6 });
	}
	
	AudioLevel.propTypes = {
	  publisher: _propTypes2.default.object
	};
	
	exports.default = AudioLevel;

/***/ }),
/* 3775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(266);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(722);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _AudioLevel = __webpack_require__(3774);
	
	var _AudioLevel2 = _interopRequireDefault(_AudioLevel);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AudioSettings(_ref) {
	  var _this = this;
	
	  var otPublisher = _ref.otPublisher,
	      _ref$devices = _ref.devices,
	      devices = _ref$devices === undefined ? [] : _ref$devices,
	      formatMessage = _ref.formatMessage,
	      publisher = _ref.publisher;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      disabled = _useState2[0],
	      setDisabled = _useState2[1];
	
	  var hasAudio = true;
	  var iconName = hasAudio ? 'mic' : 'sound-on-error';
	
	  var getActiveAudioId = function getActiveAudioId() {
	    try {
	      return otPublisher.publisher.getAudioSource().getCapabilities().deviceId;
	    } catch (e) {
	      return '';
	    }
	  };
	
	  var handleSelectAudioSource = (0, _react.useCallback)(function () {
	    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(deviceId) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              setDisabled(true);
	              _context.prev = 1;
	              _context.next = 4;
	              return otPublisher.changeAudioSource(deviceId);
	
	            case 4:
	              _context.prev = 4;
	
	              setDisabled(false);
	              return _context.finish(4);
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[1,, 4, 7]]);
	    }));
	
	    return function (_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }(), []);
	
	  var audioDevices = devices.map(function (device) {
	    return {
	      value: device.deviceId,
	      label: device.label
	    };
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.row },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_styles2.default.row, 'mr1') },
	      _react2.default.createElement(_Icon2.default, { name: iconName, size: 32, className: 'mr1' }),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { className: (0, _classnames2.default)(_styles2.default.text, 'mb1') },
	          formatMessage({ id: 'virtualVisit.test.mic' })
	        ),
	        _react2.default.createElement(_AudioLevel2.default, { publisher: (0, _get2.default)(publisher, 'entity') })
	      )
	    ),
	    _react2.default.createElement(_SelectCustom2.default, {
	      disabled: disabled,
	      value: getActiveAudioId(),
	      options: audioDevices,
	      needUpdateDefaultValue: true,
	      onChange: function onChange(_ref3) {
	        var value = _ref3.value;
	        return handleSelectAudioSource(value);
	      },
	      className: _styles2.default.select
	    })
	  );
	}
	AudioSettings.propTypes = {
	  formatMessage: _propTypes2.default.func,
	  otPublisher: _propTypes2.default.object.isRequired,
	  publisher: _propTypes2.default.object.isRequired,
	  devices: _propTypes2.default.array.isRequired
	};
	exports.default = AudioSettings;

/***/ }),
/* 3776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactRedux = __webpack_require__(6);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(722);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _selectors = __webpack_require__(23);
	
	var _ProgressBar = __webpack_require__(782);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _getTestResults = __webpack_require__(1818);
	
	var _useTestConnection2 = __webpack_require__(4132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TestButtonPortal(_ref) {
	  var children = _ref.children;
	
	  var wrapper = document.getElementById('media-settings-button');
	  if (!wrapper) return null;
	  return (0, _reactDom.createPortal)(children, wrapper);
	} /* eslint-disable react/jsx-handler-names */
	
	
	function TestConnection(_ref2) {
	  var formatMessage = _ref2.formatMessage;
	
	  var userId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	
	  var _useTestConnection = (0, _useTestConnection2.useTestConnection)({ userId: userId }),
	      disabled = _useTestConnection.disabled,
	      buttonProps = _useTestConnection.buttonProps,
	      stopTesting = _useTestConnection.stopTesting,
	      progress = _useTestConnection.progress,
	      finished = _useTestConnection.finished,
	      testOpened = _useTestConnection.testOpened,
	      result = _useTestConnection.result;
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      return stopTesting();
	    };
	  }, []);
	
	  var testResult = (0, _getTestResults.getConnectionResult)(result);
	  var danger = finished && testResult.danger;
	
	  var title = formatMessage({
	    id: 'virtualVisit.test.completed'
	  }) + ': ' + formatMessage({ id: testResult.qualityId }) + ' ' + formatMessage({
	    id: 'virtualVisit.test.connectivity'
	  });
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    testOpened && _react2.default.createElement(
	      'div',
	      { className: 'mb3' },
	      _react2.default.createElement(
	        'h5',
	        {
	          className: (0, _classnames2.default)(_styles2.default.title, (0, _defineProperty3.default)({}, _styles2.default.titleDanger, danger))
	        },
	        !finished ? formatMessage({ id: 'virtualVisit.test.progress' }) : title
	      ),
	      !finished && _react2.default.createElement(_ProgressBar2.default, {
	        progress: progress,
	        height: 8,
	        transitionDuration: '1s'
	      })
	    ),
	    _react2.default.createElement(
	      TestButtonPortal,
	      null,
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          raised: true,
	          type: 'button',
	          disabled: disabled,
	          color: buttonProps.color,
	          onClick: buttonProps.onClick
	        },
	        formatMessage({ id: buttonProps.title })
	      )
	    )
	  );
	}
	
	TestConnection.propTypes = {
	  formatMessage: _propTypes2.default.func
	};
	
	exports.default = TestConnection;

/***/ }),
/* 3777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(722);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoView(_ref) {
	  var publisher = _ref.publisher;
	
	  var deviceVideoRef = (0, _react.useRef)();
	
	  (0, _react.useEffect)(function () {
	    var deviceVideoEl = deviceVideoRef.current;
	    if (publisher && publisher.video && deviceVideoEl) {
	      deviceVideoEl.srcObject = publisher.video.srcObject;
	    }
	  }, [publisher]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.video },
	    _react2.default.createElement('video', { ref: deviceVideoRef, autoPlay: true, muted: true, playsInline: true })
	  );
	}
	
	VideoView.propTypes = {
	  publisher: _propTypes2.default.object.isRequired
	};
	
	exports.default = VideoView;

/***/ }),
/* 3778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(266);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles = __webpack_require__(722);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoSettings(_ref) {
	  var _this = this;
	
	  var otPublisher = _ref.otPublisher,
	      _ref$devices = _ref.devices,
	      devices = _ref$devices === undefined ? [] : _ref$devices,
	      formatMessage = _ref.formatMessage;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      disabled = _useState2[0],
	      setDisabled = _useState2[1];
	
	  var hasVideo = true;
	
	  var iconName = hasVideo ? 'video' : 'video-on-error';
	
	  var videoDevices = devices.map(function (device) {
	    return {
	      value: device.deviceId,
	      label: device.label
	    };
	  });
	
	  var getActiveVideoId = function getActiveVideoId() {
	    try {
	      return otPublisher.publisher.getVideoSource().deviceId;
	    } catch (e) {
	      return '';
	    }
	  };
	
	  var handleSelectVideoSource = (0, _react.useCallback)(function () {
	    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(deviceId) {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              setDisabled(true);
	              _context.prev = 1;
	              _context.next = 4;
	              return otPublisher.changeVideoSource(deviceId);
	
	            case 4:
	              _context.prev = 4;
	
	              setDisabled(false);
	              return _context.finish(4);
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[1,, 4, 7]]);
	    }));
	
	    return function (_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }(), []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_styles2.default.row, _styles2.default.rowMb) },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_styles2.default.row, 'mr1') },
	      _react2.default.createElement(_Icon2.default, { name: iconName, size: 32, className: 'mr1' }),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: _styles2.default.text },
	          formatMessage({ id: 'virtualVisit.test.camera' })
	        )
	      )
	    ),
	    _react2.default.createElement(_SelectCustom2.default, {
	      disabled: disabled,
	      value: getActiveVideoId(),
	      options: videoDevices,
	      onChange: function onChange(_ref3) {
	        var value = _ref3.value;
	        return handleSelectVideoSource(value);
	      },
	      needUpdateDefaultValue: true,
	      className: _styles2.default.select
	    })
	  );
	}
	
	VideoSettings.propTypes = {
	  formatMessage: _propTypes2.default.func,
	  otPublisher: _propTypes2.default.object.isRequired,
	  publisher: _propTypes2.default.object.isRequired,
	  devices: _propTypes2.default.array.isRequired
	};
	
	exports.default = VideoSettings;

/***/ }),
/* 3779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _AudioSettings = __webpack_require__(3775);
	
	var _AudioSettings2 = _interopRequireDefault(_AudioSettings);
	
	var _VideoSettings = __webpack_require__(3778);
	
	var _VideoSettings2 = _interopRequireDefault(_VideoSettings);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _TestConnection = __webpack_require__(3776);
	
	var _TestConnection2 = _interopRequireDefault(_TestConnection);
	
	var _VideoView = __webpack_require__(3777);
	
	var _VideoView2 = _interopRequireDefault(_VideoView);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _context = __webpack_require__(306);
	
	var _constants = __webpack_require__(17);
	
	var _useForceUpdate = __webpack_require__(4130);
	
	var _notifications = __webpack_require__(672);
	
	var _selectors = __webpack_require__(64);
	
	var _styles = __webpack_require__(722);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable promise/catch-or-return */
	function MediaSettings(_ref) {
	  var formatMessage = _ref.formatMessage;
	
	  var ctx = (0, _react.useContext)(_context.OTContext);
	  var forceUpdate = (0, _useForceUpdate.useForceUpdate)();
	  var state = ctx.state,
	      PUBLISHER_KEY = ctx.PUBLISHER_KEY,
	      otPublisher = ctx.otPublisher;
	  var publisher = state.connections[PUBLISHER_KEY];
	
	  var inviteType = (0, _reactRedux.useSelector)(_selectors.selectInvitationTypeFromConfig);
	
	  var hideTestButton = [_constants.VIRTUAL_VISIT_INVITE_TYPE.GUEST, _constants.VIRTUAL_VISIT_INVITE_TYPE.PATIENT, _constants.VIRTUAL_VISIT_INVITE_TYPE.IN_OFFICE, _constants.VIRTUAL_VISIT_INVITE_TYPE.CONNECTION_ROOM].includes(inviteType);
	
	  var videoDevices = (0, _get2.default)(otPublisher, 'initialMediaDevices.videoSourceList', []);
	  var audioDevices = (0, _get2.default)(otPublisher, 'initialMediaDevices.audioSourceList', []);
	
	  (0, _react.useEffect)(function () {
	    return (0, _notifications.subscribeToForceUpdate)(forceUpdate);
	  }, []);
	  (0, _react.useEffect)(function () {
	    if (otPublisher) otPublisher.updateDeviceList().then(forceUpdate);
	  }, []);
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 1),
	      error = _useState2[0];
	
	  if (!publisher) return _react2.default.createElement(_Loader2.default, null);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.modal },
	    _react2.default.createElement(_VideoView2.default, { publisher: publisher }),
	    !hideTestButton && _react2.default.createElement(_TestConnection2.default, { formatMessage: formatMessage }),
	    error && _react2.default.createElement(_ErrorBlock2.default, { className: 'mb3', errors: formatMessage({ id: error }) }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_VideoSettings2.default, {
	        publisher: publisher,
	        devices: videoDevices,
	        otPublisher: otPublisher,
	        formatMessage: formatMessage
	      }),
	      _react2.default.createElement(_AudioSettings2.default, {
	        publisher: publisher,
	        devices: audioDevices,
	        otPublisher: otPublisher,
	        formatMessage: formatMessage
	      })
	    ),
	    _react2.default.createElement('div', { className: _styles2.default.btns, id: 'media-settings-button' })
	  );
	}
	
	MediaSettings.propTypes = {
	  formatMessage: PropTypes.func
	};
	
	function MediaSettingsModal(_ref2) {
	  var formatMessage = _ref2.intl.formatMessage,
	      opened = _ref2.opened,
	      close = _ref2.close;
	
	  var handleClose = function handleClose() {
	    return close();
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      className: _styles2.default.popup,
	      opened: opened,
	      onClose: handleClose,
	      title: formatMessage({ id: 'common.settings' }),
	      width: 'auto',
	      autoHeight: true,
	      white: true,
	      strictClose: true
	    },
	    _react2.default.createElement(MediaSettings, { formatMessage: formatMessage })
	  );
	}
	
	MediaSettingsModal.propTypes = {
	  intl: PropTypes.object,
	  opened: PropTypes.bool,
	  close: PropTypes.func
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MediaSettingsModal);

/***/ }),
/* 3780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(2851);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _shapes = __webpack_require__(351);
	
	var _SubscriberBtns = __webpack_require__(3786);
	
	var _SubscriberBtns2 = _interopRequireDefault(_SubscriberBtns);
	
	var _MemberView = __webpack_require__(3781);
	
	var _MemberView2 = _interopRequireDefault(_MemberView);
	
	var _InviteeView = __webpack_require__(3773);
	
	var _InviteeView2 = _interopRequireDefault(_InviteeView);
	
	var _InviteeBtns = __webpack_require__(3772);
	
	var _InviteeBtns2 = _interopRequireDefault(_InviteeBtns);
	
	var _styles = __webpack_require__(5158);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MemberList(_ref) {
	  var publisher = _ref.publisher,
	      subscribers = _ref.subscribers,
	      onSelect = _ref.onSelect,
	      pinnedId = _ref.pinnedId,
	      isProvider = _ref.isProvider,
	      onPin = _ref.onPin,
	      invitations = _ref.invitations;
	
	  var members = (0, _react.useMemo)(function () {
	    return (0, _entries2.default)(subscribers);
	  }, [subscribers]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      _reactTransitionGroup.TransitionGroup,
	      null,
	      publisher && _react2.default.createElement(
	        _reactTransitionGroup.CSSTransition,
	        { timeout: 300, classNames: 'vv-member' },
	        _react2.default.createElement(_MemberView2.default, {
	          onClick: onSelect,
	          connection: publisher,
	          showControls: true
	        })
	      ),
	      members.map(function (_ref2) {
	        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	            id = _ref3[0],
	            connection = _ref3[1];
	
	        return _react2.default.createElement(
	          _reactTransitionGroup.CSSTransition,
	          { key: id, timeout: 300, classNames: 'vv-member' },
	          _react2.default.createElement(
	            _MemberView2.default,
	            {
	              showControls: !isProvider,
	              connection: connection,
	              onClick: onSelect
	            },
	            _react2.default.createElement(_SubscriberBtns2.default, {
	              pinnedId: pinnedId,
	              connection: connection,
	              isProvider: isProvider,
	              onPin: onPin
	            })
	          )
	        );
	      }),
	      invitations.map(function (invitee) {
	        return _react2.default.createElement(
	          _reactTransitionGroup.CSSTransition,
	          {
	            key: invitee.login,
	            timeout: 300,
	            classNames: 'vv-member'
	          },
	          _react2.default.createElement(
	            _InviteeView2.default,
	            { invitee: invitee },
	            _react2.default.createElement(_InviteeBtns2.default, { invitee: invitee, isProvider: isProvider })
	          )
	        );
	      })
	    )
	  );
	}
	
	MemberList.propTypes = {
	  publisher: _shapes.ConnectionShape,
	  subscribers: PropTypes.shape({ id: _shapes.ConnectionShape }),
	  onSelect: PropTypes.func,
	  pinnedId: PropTypes.string,
	  onPin: PropTypes.func,
	  isProvider: PropTypes.bool,
	  invitations: PropTypes.array
	};
	
	exports.default = MemberList;

/***/ }),
/* 3781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _MediaIndicator = __webpack_require__(1813);
	
	var _MediaIndicator2 = _interopRequireDefault(_MediaIndicator);
	
	var _context = __webpack_require__(306);
	
	var _utils = __webpack_require__(307);
	
	var _shapes = __webpack_require__(351);
	
	var _styles = __webpack_require__(5159);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MemberView(_ref) {
	  var _cn;
	
	  var onClick = _ref.onClick,
	      children = _ref.children,
	      showControls = _ref.showControls,
	      formatMessage = _ref.intl.formatMessage,
	      _ref$connection = _ref.connection,
	      ready = _ref$connection.ready,
	      id = _ref$connection.id,
	      video = _ref$connection.video,
	      user = _ref$connection.user,
	      stream = _ref$connection.stream;
	
	  var _useContext = (0, _react.useContext)(_context.OTContext),
	      state = _useContext.state,
	      focusedId = _useContext.focusedId,
	      PUBLISHER_KEY = _useContext.PUBLISHER_KEY;
	
	  var pinnedId = state.pinnedId,
	      videoWarningIds = state.videoWarningIds;
	
	  var isMe = id === PUBLISHER_KEY;
	  var videoRef = (0, _react.useRef)();
	
	  var videoType = (0, _get2.default)(stream, 'videoType');
	
	  var videoReady = (0, _react.useMemo)(function () {
	    return ready && video;
	  }, [ready, video]);
	  var hasSlowConnection = (0, _react.useMemo)(function () {
	    return videoWarningIds.includes(id);
	  }, [videoWarningIds, id]);
	  var name = (0, _react.useMemo)(function () {
	    return (0, _utils.formatName)(user, isMe, formatMessage, videoType);
	  }, [user, isMe, videoType]);
	
	  var pinned = id === pinnedId;
	  var noVideo = stream && !stream.hasVideo;
	  var noAudio = stream && !stream.hasAudio;
	
	  (0, _react.useEffect)(function () {
	    if (videoReady && videoRef.current) {
	      videoRef.current.appendChild(video);
	    }
	  }, [videoReady]);
	
	  var handleSelect = function handleSelect() {
	    return onClick({ stream: stream, id: id });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    {
	      onClick: handleSelect,
	      className: (0, _classnames2.default)(_styles2.default.root, (_cn = {}, (0, _defineProperty3.default)(_cn, _styles2.default.active, focusedId === id), (0, _defineProperty3.default)(_cn, _styles2.default.me, isMe), _cn))
	    },
	    !videoReady && _react2.default.createElement(_Loader2.default, { className: _styles2.default.loader }),
	    children,
	    _react2.default.createElement(
	      _react.Fragment,
	      null,
	      pinned && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.pinned },
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.pinnedBtn },
	          _react2.default.createElement(_Icon2.default, { name: 'unpin', size: 24 })
	        )
	      ),
	      _react2.default.createElement('div', {
	        className: (0, _classnames2.default)(_styles2.default.video, (0, _defineProperty3.default)({}, _styles2.default.noVideo, noVideo)),
	        ref: videoRef
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.info },
	        hasSlowConnection && _react2.default.createElement(_Icon2.default, {
	          title: formatMessage({ id: 'virtualVisit.unstableConnection' }),
	          className: _styles2.default.slowConnection,
	          name: 'connection-slow',
	          size: 12
	        }),
	        name,
	        showControls && _react2.default.createElement(_MediaIndicator2.default, {
	          className: _styles2.default.controls,
	          pinned: pinned,
	          noVideo: noVideo,
	          noAudio: noAudio
	        })
	      )
	    )
	  );
	}
	
	MemberView.propTypes = {
	  onClick: PropTypes.func,
	  children: PropTypes.node,
	  connection: _shapes.ConnectionShape,
	  showControls: PropTypes.bool,
	  intl: PropTypes.object
	};
	
	MemberView.defaultProps = {
	  showControls: false
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MemberView);

/***/ }),
/* 3782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _useVirtualVisit2 = __webpack_require__(352);
	
	var _styles = __webpack_require__(5160);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MembersSidebar(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      children = _ref.children,
	      count = _ref.count;
	
	  var _useVirtualVisit = (0, _useVirtualVisit2.useVirtualVisit)(),
	      viewOptions = _useVirtualVisit.viewOptions;
	
	  var mobSidebarOpened = viewOptions.mobSidebarOpened,
	      toggleMobSidebar = viewOptions.toggleMobSidebar;
	
	
	  var title = (0, _react.useMemo)(function () {
	    var i18n = formatMessage({ id: 'virtualVisit.room.callMembers' });
	    return i18n + ' (' + (count || '-') + ')';
	  }, [count]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_styles2.default.root, (0, _defineProperty3.default)({}, _styles2.default.mobOpened, mobSidebarOpened)) },
	    _react2.default.createElement(
	      _ClickableElement2.default,
	      { onClick: toggleMobSidebar, className: _styles2.default.closeBtn },
	      _react2.default.createElement(_Icon2.default, { name: 'close', size: 18 })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.head },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.content },
	      children
	    )
	  );
	}
	
	MembersSidebar.propTypes = {
	  children: PropTypes.node,
	  count: PropTypes.number,
	  intl: PropTypes.object
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MembersSidebar);

/***/ }),
/* 3783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(5161);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Message(_ref) {
	  var message = _ref.message,
	      autoClose = _ref.autoClose,
	      timeout = _ref.timeout,
	      onClose = _ref.onClose,
	      slowConnection = _ref.slowConnection,
	      formatMessage = _ref.formatMessage;
	
	  var shared = (0, _react.useRef)({});
	
	  (0, _react.useEffect)(function () {
	    shared.current = { onClose: onClose };
	  }, [onClose]);
	
	  (0, _react.useEffect)(function () {
	    var timer = autoClose ? setTimeout(function () {
	      return shared.current.onClose();
	    }, timeout) : null;
	
	    return function () {
	      if (timer) clearTimeout(timer);
	    };
	  }, [autoClose]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_styles2.default.root, (0, _defineProperty3.default)({}, _styles2.default.hasWarning, slowConnection)) },
	      message,
	      slowConnection && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.slowConnection },
	        _react2.default.createElement(_Icon2.default, { name: 'connection-slow', size: 12 }),
	        formatMessage({ id: 'virtualVisit.unstableConnection' })
	      )
	    )
	  );
	}
	
	Message.propTypes = {
	  message: PropTypes.string,
	  autoClose: PropTypes.bool,
	  slowConnection: PropTypes.bool,
	  timeout: PropTypes.number,
	  formatMessage: PropTypes.func,
	  onClose: PropTypes.func
	};
	
	Message.defaultProps = {
	  autoClose: false,
	  slowConnection: false,
	  onClose: function onClose() {}
	};
	
	exports.default = Message;

/***/ }),
/* 3784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _cancelInvitationToVirtualRoomReq = __webpack_require__(851);
	
	var _selectors = __webpack_require__(64);
	
	var _styles = __webpack_require__(5164);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemoveInvitationLink = function RemoveInvitationLink(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      close = _ref.close,
	      email = _ref.email;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	  var appointmentId = (0, _reactRedux.useSelector)(_selectors.selectCurrentAppointmentId);
	
	  var handleSubmit = function handleSubmit() {
	    close();
	    dispatch(_cancelInvitationToVirtualRoomReq.actions.send({ data: { appointmentId: appointmentId, email: email } }));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.description },
	      formatMessage({ id: 'virtualVisit.removeInvitationLink.description' }, { email: email })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.btnsSubmit },
	      _react2.default.createElement(
	        _Button2.default,
	        { type: 'button', color: 'primary', raised: true, onClick: handleSubmit },
	        formatMessage({ id: 'common.remove' })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { type: 'button', raised: true, color: 'accent', onClick: close },
	        formatMessage({ id: 'common.cancel' })
	      )
	    )
	  );
	};
	
	RemoveInvitationLink.propTypes = {
	  intl: _propTypes2.default.object.isRequired,
	  close: _propTypes2.default.func,
	  email: _propTypes2.default.string
	};
	
	exports.default = (0, _reactIntl.injectIntl)(RemoveInvitationLink);

/***/ }),
/* 3785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _RemoveInvitationLinkForm = __webpack_require__(3784);
	
	var _RemoveInvitationLinkForm2 = _interopRequireDefault(_RemoveInvitationLinkForm);
	
	var _styles = __webpack_require__(5165);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RemoveInvitationLinkPopup = function RemoveInvitationLinkPopup(_ref) {
	  var opened = _ref.opened,
	      onClose = _ref.onClose,
	      email = _ref.email;
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      opened: opened,
	      className: _styles2.default.cancelPopup,
	      white: true,
	      onClose: onClose
	    },
	    _react2.default.createElement(_RemoveInvitationLinkForm2.default, { close: onClose, email: email })
	  );
	};
	
	RemoveInvitationLinkPopup.propTypes = {
	  opened: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  email: _propTypes2.default.string
	};
	
	exports.default = RemoveInvitationLinkPopup;

/***/ }),
/* 3786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _MediaIndicator = __webpack_require__(1813);
	
	var _MediaIndicator2 = _interopRequireDefault(_MediaIndicator);
	
	var _PatientControls = __webpack_require__(1816);
	
	var _PatientControls2 = _interopRequireDefault(_PatientControls);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(1510);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _useSubscriberControls = __webpack_require__(1817);
	
	var _shapes = __webpack_require__(351);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SubscriberBtns(_ref) {
	  var _ref$connection = _ref.connection;
	  _ref$connection = _ref$connection === undefined ? {} : _ref$connection;
	  var entity = _ref$connection.entity,
	      id = _ref$connection.id,
	      onPin = _ref.onPin,
	      pinnedId = _ref.pinnedId;
	
	  var pinned = pinnedId === id;
	
	  var _useSubscriberControl = (0, _useSubscriberControls.useSubscriberControls)({ pinned: pinned, onPin: onPin, id: id, entity: entity }),
	      handleVideoToggle = _useSubscriberControl.handleVideoToggle,
	      handleAudioToggle = _useSubscriberControl.handleAudioToggle,
	      handlePinToggle = _useSubscriberControl.handlePinToggle,
	      audioIcon = _useSubscriberControl.audioIcon,
	      videoIcon = _useSubscriberControl.videoIcon,
	      pinIcon = _useSubscriberControl.pinIcon,
	      hasAudio = _useSubscriberControl.hasAudio,
	      hasVideo = _useSubscriberControl.hasVideo;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement('div', { className: _styles2.default.overlay }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.actions },
	      _react2.default.createElement(
	        'button',
	        {
	          onClick: handleAudioToggle,
	          className: _styles2.default.btn,
	          type: 'button'
	        },
	        _react2.default.createElement(_Icon2.default, { name: audioIcon, size: 24 })
	      ),
	      _react2.default.createElement(
	        'button',
	        {
	          onClick: handleVideoToggle,
	          className: _styles2.default.btn,
	          type: 'button'
	        },
	        _react2.default.createElement(_Icon2.default, { name: videoIcon, size: 24 })
	      ),
	      _react2.default.createElement(
	        'button',
	        { onClick: handlePinToggle, className: _styles2.default.btn, type: 'button' },
	        _react2.default.createElement(_Icon2.default, { name: pinIcon, size: 24 })
	      )
	    ),
	    _react2.default.createElement(_MediaIndicator2.default, {
	      className: _styles2.default.controls,
	      pinned: pinned,
	      noVideo: !hasVideo,
	      noAudio: !hasAudio
	    })
	  );
	}
	
	SubscriberBtns.propTypes = {
	  connection: _shapes.ConnectionShape,
	  pinnedId: _propTypes2.default.string,
	  onPin: _propTypes2.default.func
	};
	
	var enhance = (0, _recompose.compose)((0, _recompose.branch)(function (_ref2) {
	  var isProvider = _ref2.isProvider;
	  return !isProvider;
	}, (0, _recompose.renderComponent)(_PatientControls2.default)));
	
	exports.default = enhance(SubscriberBtns);

/***/ }),
/* 3787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _useSubscriberControls = __webpack_require__(1817);
	
	var _shapes = __webpack_require__(351);
	
	var _SimpleAvatar = __webpack_require__(132);
	
	var _SimpleAvatar2 = _interopRequireDefault(_SimpleAvatar);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(2272);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _utils = __webpack_require__(307);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UserRow(_ref) {
	  var _ref$connection = _ref.connection;
	  _ref$connection = _ref$connection === undefined ? {} : _ref$connection;
	  var entity = _ref$connection.entity,
	      id = _ref$connection.id,
	      user = _ref$connection.user,
	      formatMessage = _ref.intl.formatMessage,
	      isProvider = _ref.isProvider,
	      pinnedId = _ref.pinnedId,
	      onPin = _ref.onPin,
	      isMe = _ref.isMe;
	
	  var userName = (0, _utils.formatName)(user, isMe, formatMessage);
	  var avatar = (0, _get2.default)(user, 'avatar.thumbMin');
	  var pinned = pinnedId === id;
	
	  var _useSubscriberControl = (0, _useSubscriberControls.useSubscriberControls)({ pinned: pinned, onPin: onPin, id: id, entity: entity }),
	      handleVideoToggle = _useSubscriberControl.handleVideoToggle,
	      handleAudioToggle = _useSubscriberControl.handleAudioToggle,
	      handlePinToggle = _useSubscriberControl.handlePinToggle,
	      audioIcon = _useSubscriberControl.audioIcon,
	      videoIcon = _useSubscriberControl.videoIcon,
	      pinIcon = _useSubscriberControl.pinIcon;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.userRow },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.userLeft },
	      _react2.default.createElement(_SimpleAvatar2.default, { src: avatar, size: 48, text: userName, bordered: true }),
	      _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)(_styles2.default.userName, (0, _defineProperty3.default)({}, _styles2.default.isMe, isMe)) },
	        userName
	      )
	    ),
	    !isMe && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.userActions },
	      isProvider && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'button',
	          { onClick: handleAudioToggle, type: 'button' },
	          _react2.default.createElement(_Icon2.default, { name: audioIcon, size: 16 })
	        ),
	        _react2.default.createElement(
	          'button',
	          { onClick: handleVideoToggle, type: 'button' },
	          _react2.default.createElement(_Icon2.default, { name: videoIcon, size: 16 })
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        { onClick: handlePinToggle, type: 'button' },
	        _react2.default.createElement(_Icon2.default, { name: pinIcon, size: 16 })
	      )
	    )
	  );
	}
	
	UserRow.propTypes = {
	  isMe: PropTypes.bool,
	  isProvider: PropTypes.bool,
	  connection: _shapes.ConnectionShape,
	  onPin: PropTypes.func,
	  pinnedId: PropTypes.string,
	  intl: PropTypes.object
	};
	
	exports.default = (0, _reactIntl.injectIntl)(UserRow);

/***/ }),
/* 3788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UserRow = __webpack_require__(3787);
	
	var _UserRow2 = _interopRequireDefault(_UserRow);
	
	var _styles = __webpack_require__(2272);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MobileSidebar(_ref) {
	  var visible = _ref.visible,
	      publisher = _ref.publisher,
	      users = _ref.users,
	      onPin = _ref.onPin,
	      pinnedId = _ref.pinnedId,
	      isProvider = _ref.isProvider;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_styles2.default.root, (0, _defineProperty3.default)({}, _styles2.default.visible, visible)) },
	    _react2.default.createElement(_UserRow2.default, { connection: publisher, isMe: true }),
	    users.map(function (_ref2) {
	      var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	          id = _ref3[0],
	          connection = _ref3[1];
	
	      return _react2.default.createElement(_UserRow2.default, {
	        connection: connection,
	        isProvider: isProvider,
	        pinnedId: pinnedId,
	        onPin: onPin,
	        key: id
	      });
	    })
	  );
	}
	
	MobileSidebar.propTypes = {
	  visible: PropTypes.bool,
	  isProvider: PropTypes.bool,
	  publisher: PropTypes.object,
	  users: PropTypes.array,
	  onPin: PropTypes.func,
	  pinnedId: PropTypes.string
	};
	
	exports.default = MobileSidebar;

/***/ }),
/* 3789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shapes = __webpack_require__(351);
	
	var _styles = __webpack_require__(5167);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoElement(_ref) {
	  var _ref$connection = _ref.connection;
	  _ref$connection = _ref$connection === undefined ? {} : _ref$connection;
	  var ready = _ref$connection.ready,
	      video = _ref$connection.video,
	      stream = _ref$connection.stream,
	      className = _ref.className;
	
	  var videoReady = (0, _react.useMemo)(function () {
	    return ready && video;
	  }, [ready, video]);
	  var noVideo = stream && !stream.hasVideo;
	  var videoRef = (0, _react.useRef)();
	
	  (0, _react.useEffect)(function () {
	    if (videoReady) {
	      videoRef.current.appendChild(video);
	    }
	  }, [videoReady]);
	
	  return _react2.default.createElement('div', {
	    className: (0, _classnames2.default)(_styles2.default.video, className, (0, _defineProperty3.default)({}, _styles2.default.noVideo, noVideo)),
	    ref: videoRef
	  });
	}
	
	VideoElement.propTypes = {
	  connection: _shapes.ConnectionShape,
	  className: PropTypes.string
	};
	
	exports.default = VideoElement;

/***/ }),
/* 3790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _VideoElement = __webpack_require__(3789);
	
	var _VideoElement2 = _interopRequireDefault(_VideoElement);
	
	var _MobileSidebar = __webpack_require__(3788);
	
	var _MobileSidebar2 = _interopRequireDefault(_MobileSidebar);
	
	var _PublisherBtns = __webpack_require__(1815);
	
	var _PublisherBtns2 = _interopRequireDefault(_PublisherBtns);
	
	var _context = __webpack_require__(306);
	
	var _Notifications = __webpack_require__(1814);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _Placeholder = __webpack_require__(1812);
	
	var _Placeholder2 = _interopRequireDefault(_Placeholder);
	
	var _useVirtualVisit2 = __webpack_require__(352);
	
	var _styles = __webpack_require__(5168);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MobleVideo() {
	  var _useContext = (0, _react.useContext)(_context.OTContext),
	      state = _useContext.state,
	      focusedId = _useContext.focusedId,
	      setPin = _useContext.setPin,
	      isProvider = _useContext.isProvider,
	      PUBLISHER_KEY = _useContext.PUBLISHER_KEY;
	
	  var _useVirtualVisit = (0, _useVirtualVisit2.useVirtualVisit)(),
	      viewOptions = _useVirtualVisit.viewOptions,
	      placeholder = _useVirtualVisit.placeholder;
	
	  var collapsed = viewOptions.collapsed,
	      mobSidebarOpened = viewOptions.mobSidebarOpened;
	  var pinnedId = state.pinnedId,
	      connections = state.connections,
	      loading = state.loading;
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    var pub = connections[PUBLISHER_KEY],
	        sub = (0, _objectWithoutProperties3.default)(connections, [PUBLISHER_KEY]);
	
	    return { publisher: pub, subscribers: sub };
	  }, [connections]),
	      publisher = _useMemo.publisher,
	      subscribers = _useMemo.subscribers;
	
	  var userList = (0, _react.useMemo)(function () {
	    return (0, _entries2.default)(subscribers);
	  }, [subscribers]);
	  var moreOneUserInRoom = (0, _keys2.default)(connections).length > 1;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(_MobileSidebar2.default, {
	      isProvider: isProvider,
	      onPin: setPin,
	      pinnedId: pinnedId,
	      visible: mobSidebarOpened,
	      publisher: publisher,
	      users: userList
	    }),
	    _react2.default.createElement(_VideoElement2.default, { connection: publisher, className: _styles2.default.me }),
	    userList.map(function (_ref) {
	      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	          id = _ref2[0],
	          connection = _ref2[1];
	
	      return _react2.default.createElement(_VideoElement2.default, {
	        className: (0, _classnames2.default)(_styles2.default.subscribers, (0, _defineProperty3.default)({}, _styles2.default.active, id === focusedId)),
	        connection: connection,
	        key: id
	      });
	    }),
	    _react2.default.createElement(_Notifications2.default, null),
	    publisher && _react2.default.createElement(_PublisherBtns2.default, { publisher: publisher, disabled: loading }),
	    !collapsed && !loading && placeholder && !moreOneUserInRoom && _react2.default.createElement(_Placeholder2.default, (0, _extends3.default)({}, placeholder, { subtitleClassName: _styles2.default.mobileMode }))
	  );
	}
	
	exports.default = MobleVideo;

/***/ }),
/* 3791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__(22);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MobileVideo = __webpack_require__(3790);
	
	var _MobileVideo2 = _interopRequireDefault(_MobileVideo);
	
	var _AudioTag = __webpack_require__(3766);
	
	var _AudioTag2 = _interopRequireDefault(_AudioTag);
	
	var _MemberList = __webpack_require__(3780);
	
	var _MemberList2 = _interopRequireDefault(_MemberList);
	
	var _ActiveSpeaker = __webpack_require__(3765);
	
	var _ActiveSpeaker2 = _interopRequireDefault(_ActiveSpeaker);
	
	var _MembersSidebar = __webpack_require__(3782);
	
	var _MembersSidebar2 = _interopRequireDefault(_MembersSidebar);
	
	var _context = __webpack_require__(306);
	
	var _Notifications = __webpack_require__(1814);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _useDragVideo = __webpack_require__(1895);
	
	var _styles = __webpack_require__(5169);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OpentokVideo(_ref) {
	  var collapsed = _ref.collapsed,
	      fullScreenView = _ref.fullScreenView,
	      toggleFullScreenView = _ref.toggleFullScreenView;
	
	  var _useContext = (0, _react.useContext)(_context.OTContext),
	      state = _useContext.state,
	      isProvider = _useContext.isProvider,
	      setPin = _useContext.setPin,
	      PUBLISHER_KEY = _useContext.PUBLISHER_KEY,
	      sendSignal = _useContext.sendSignal;
	
	  var connections = state.connections,
	      pinnedId = state.pinnedId,
	      invitations = state.invitations;
	
	  var _useDropVideo = (0, _useDragVideo.useDropVideo)(),
	      coords = _useDropVideo.coords,
	      drop = _useDropVideo.drop;
	
	  var fullScreenRef = (0, _react.useRef)();
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    var pub = connections[PUBLISHER_KEY],
	        sub = (0, _objectWithoutProperties3.default)(connections, [PUBLISHER_KEY]);
	
	    return { publisher: pub, subscribers: sub };
	  }, [connections]),
	      publisher = _useMemo.publisher,
	      subscribers = _useMemo.subscribers;
	
	  var selectActiveSpeaker = function selectActiveSpeaker() {};
	
	  (0, _react.useEffect)(function () {
	    if (fullScreenRef.current) {
	      if (fullScreenView) {
	        sendSignal({ data: { fullScreenMode: true }, type: 'fullscreen' });
	        if (fullScreenRef.current.requestFullscreen) {
	          fullScreenRef.current.requestFullscreen();
	        } else if (fullScreenRef.current.mozRequestFullScreen) {
	          fullScreenRef.current.mozRequestFullScreen();
	        } else if (fullScreenRef.current.webkitRequestFullScreen) {
	          fullScreenRef.current.webkitRequestFullScreen();
	        } else if (fullScreenRef.current.msRequestFullscreen) {
	          fullScreenRef.current.msRequestFullscreen();
	        }
	      } else if (document.fullscreenElement) {
	        document.exitFullscreen();
	      } else if (document.mozFullscreenElement) {
	        document.mozCancelFullScreen();
	      } else if (document.webkitFullScreenElement) {
	        document.webkitCancelFullScreen();
	      } else if (document.msFullscreenElement) {
	        document.msExitFullscreen();
	      }
	    }
	  }, [fullScreenView]);
	
	  return _react2.default.createElement(
	    'div',
	    {
	      ref: drop,
	      className: _styles2.default.root,
	      onDoubleClick: function onDoubleClick() {
	        return !collapsed && toggleFullScreenView();
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _styles2.default.hidden, collapsed || fullScreenView)) },
	      _react2.default.createElement(
	        _MembersSidebar2.default,
	        { count: (0, _size2.default)(connections) + (0, _size2.default)(invitations) },
	        _react2.default.createElement(_MemberList2.default, {
	          onPin: setPin,
	          pinnedId: pinnedId,
	          publisher: publisher,
	          isProvider: isProvider,
	          subscribers: subscribers,
	          invitations: invitations,
	          onSelect: selectActiveSpeaker
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.fullScreenContainer, ref: fullScreenRef },
	      !collapsed && _react2.default.createElement(_Notifications2.default, { fullScreenView: fullScreenView }),
	      _react2.default.createElement(_ActiveSpeaker2.default, {
	        onPin: setPin,
	        coords: coords,
	        publisher: publisher,
	        fullScreenView: fullScreenView
	      })
	    ),
	    _react2.default.createElement(_AudioTag2.default, null)
	  );
	}
	
	OpentokVideo.propTypes = {
	  collapsed: PropTypes.bool,
	  fullScreenView: PropTypes.bool,
	  toggleFullScreenView: PropTypes.func
	};
	
	var MOBILE_BREAKPOINT = 480;
	
	var enhance = (0, _recompose.compose)((0, _recompose.branch)(function () {
	  return window.innerWidth <= MOBILE_BREAKPOINT;
	}, (0, _recompose.renderComponent)(_MobileVideo2.default)));
	
	exports.default = enhance(OpentokVideo);

/***/ }),
/* 3792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRedux = __webpack_require__(6);
	
	var _SimpleInfoPopup = __webpack_require__(795);
	
	var _SimpleInfoPopup2 = _interopRequireDefault(_SimpleInfoPopup);
	
	var _selectors = __webpack_require__(294);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _constants = __webpack_require__(17);
	
	var _selectors2 = __webpack_require__(90);
	
	var _videoCallEndPopup = __webpack_require__(1376);
	
	var _styles = __webpack_require__(5170);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VideoCallEndPopup() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      message = _useState2[0],
	      setMessage = _useState2[1];
	
	  var appointment = (0, _reactRedux.useSelector)(_selectors.selectCurrentAppointment);
	  var userId = (0, _get2.default)(appointment, 'userId');
	  var popupState = (0, _reactRedux.useSelector)(_selectors2.selectVideoCallEndPopup);
	  var visible = (0, _get2.default)(popupState, 'visible');
	  var status = (0, _get2.default)(popupState, 'status');
	
	  var onPopupOpen = function onPopupOpen(status) {
	    switch (status) {
	      case _constants.APPOINTMENT_STATUSES.NO_SHOW:
	      case _constants.APPOINTMENT_STATUSES.CANCELED:
	        setMessage('virtualVisit.canceledByProvider');
	        break;
	      case _constants.APPOINTMENT_STATUSES.COMPLETED:
	        setMessage('virtualVisit.complete');
	        break;
	      default:
	        return;
	    }
	  };
	
	  var onPopupClose = function onPopupClose() {
	    userId ? (0, _redirectUtils.redirectToHealthBoard)(userId) : (0, _redirectUtils.redirectToLogIn)();
	    dispatch(_appointmentDetails.appointmentDetailsActions.setAppointmentId(undefined));
	    dispatch(_appointmentDetails.appointmentDetailsActions.sliceUpcomingAppointment(appointment));
	    dispatch(_videoCallEndPopup.videoCallEndPopupActions.close());
	  };
	
	  (0, _react.useEffect)(function () {
	    onPopupOpen(status);
	  }, [status]);
	
	  return _react2.default.createElement(_SimpleInfoPopup2.default, {
	    autoHeight: true,
	    opened: visible,
	    icon: 'information',
	    messageId: message,
	    withHeading: false,
	    onClick: onPopupClose,
	    mobileFullScreen: false,
	    iconClassName: _styles2.default.iconStyles,
	    paperClassName: _styles2.default.paperStyles,
	    buttonTitleId: 'submit.expiredToken',
	    buttonClassName: _styles2.default.buttonStyles
	  });
	}
	
	exports.default = VideoCallEndPopup;

/***/ }),
/* 3793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDnd = __webpack_require__(1020);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactDndHtml5Backend = __webpack_require__(6022);
	
	var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Modal = __webpack_require__(1188);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _OpentokVideo = __webpack_require__(3791);
	
	var _OpentokVideo2 = _interopRequireDefault(_OpentokVideo);
	
	var _VisitHeader = __webpack_require__(1176);
	
	var _VisitHeader2 = _interopRequireDefault(_VisitHeader);
	
	var _context = __webpack_require__(306);
	
	var _selectors = __webpack_require__(23);
	
	var _useOTScriptLoad2 = __webpack_require__(1317);
	
	var _useVirtualVisit2 = __webpack_require__(352);
	
	var _styles = __webpack_require__(5171);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VirtualVideoRoom() {
	  var _cn;
	
	  var _useVirtualVisit = (0, _useVirtualVisit2.useVirtualVisit)(),
	      viewOptions = _useVirtualVisit.viewOptions,
	      callState = _useVirtualVisit.callState;
	
	  var collapsed = viewOptions.collapsed,
	      opened = viewOptions.opened,
	      dragging = viewOptions.dragging,
	      fullScreenView = viewOptions.fullScreenView,
	      toggleFullScreenView = viewOptions.toggleFullScreenView;
	  var otConfig = callState.otConfig,
	      roomMeta = callState.roomMeta,
	      initialRoomPendingInvitations = callState.initialRoomPendingInvitations;
	
	  var isProvider = (0, _reactRedux.useSelector)(_selectors.hasProviderProfileSelector);
	
	  var _useOTScriptLoad = (0, _useOTScriptLoad2.useOTScriptLoad)(opened),
	      loaded = _useOTScriptLoad.loaded;
	
	  if (!opened || !loaded) return null;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    null,
	    _react2.default.createElement(
	      _reactDnd.DndProvider,
	      { backend: _reactDndHtml5Backend2.default },
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)(_styles2.default.root, (_cn = {}, (0, _defineProperty3.default)(_cn, _styles2.default.collapsed, collapsed), (0, _defineProperty3.default)(_cn, _styles2.default.dragging, dragging), _cn))
	        },
	        _react2.default.createElement(
	          _context.OTContextProvider,
	          {
	            config: otConfig,
	            isProvider: isProvider,
	            initialPendingInvitations: initialRoomPendingInvitations
	          },
	          _react2.default.createElement(_VisitHeader2.default, { collapsed: collapsed, roomDetails: roomMeta }),
	          _react2.default.createElement(_OpentokVideo2.default, {
	            collapsed: collapsed,
	            fullScreenView: fullScreenView,
	            toggleFullScreenView: toggleFullScreenView
	          })
	        )
	      )
	    )
	  );
	}
	
	exports.default = VirtualVideoRoom;

/***/ }),
/* 3794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _VideoVisitBtn = __webpack_require__(491);
	
	var _VideoVisitBtn2 = _interopRequireDefault(_VideoVisitBtn);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _styles = __webpack_require__(5172);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Intro(_ref) {
	  var formatMessage = _ref.formatMessage,
	      onStartTestVisit = _ref.onStartTestVisit,
	      onStartVideoVisit = _ref.onStartVideoVisit,
	      virtualCallEnabled = _ref.virtualCallEnabled;
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'h3',
	      { className: _styles2.default.title },
	      formatMessage({ id: 'virtualVisit.test.startsSoon' })
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: _styles2.default.subtitle },
	      formatMessage({ id: 'virtualVisit.test.desc' })
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      { color: 'accent', raised: true, onClick: onStartTestVisit },
	      formatMessage({ id: 'virtualVisit.test.check' })
	    ),
	    _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'p',
	        { className: _styles2.default.desc },
	        formatMessage({ id: 'virtualVisit.test.continue' })
	      ),
	      _react2.default.createElement(_VideoVisitBtn2.default, {
	        type: 'primary',
	        onStartVideoVisit: onStartVideoVisit,
	        disabled: !virtualCallEnabled
	      })
	    )
	  );
	}
	
	Intro.propTypes = {
	  formatMessage: PropTypes.func,
	  onStartTestVisit: PropTypes.func,
	  onStartVideoVisit: PropTypes.func,
	  virtualCallEnabled: PropTypes.bool
	};
	
	exports.default = Intro;

/***/ }),
/* 3795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _ProgressBar = __webpack_require__(782);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styles = __webpack_require__(2273);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Progress(_ref) {
	  var progress = _ref.progress,
	      formatMessage = _ref.formatMessage,
	      onClick = _ref.onClick,
	      disabled = _ref.disabled,
	      error = _ref.error;
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'h5',
	      { className: _styles2.default.title },
	      formatMessage({ id: 'virtualVisit.test.progress' })
	    ),
	    _react2.default.createElement(_ProgressBar2.default, { progress: progress, withTransition: true }),
	    error && _react2.default.createElement(_ErrorBlock2.default, { className: 'mt2', errors: formatMessage({ id: error }) }),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: _styles2.default.btn,
	        type: 'button',
	        color: 'primary',
	        raised: true,
	        onClick: onClick,
	        disabled: disabled
	      },
	      formatMessage({ id: 'virtualVisit.test.cancel' })
	    )
	  );
	}
	
	Progress.propTypes = {
	  progress: PropTypes.number,
	  formatMessage: PropTypes.func,
	  onClick: PropTypes.func,
	  disabled: PropTypes.bool,
	  error: PropTypes.string
	};
	
	exports.default = Progress;

/***/ }),
/* 3796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getTestResults3 = __webpack_require__(1818);
	
	var _utils = __webpack_require__(307);
	
	var _VideoVisitBtn = __webpack_require__(491);
	
	var _VideoVisitBtn2 = _interopRequireDefault(_VideoVisitBtn);
	
	var _getAudioLogLevel = __webpack_require__(3802);
	
	var _ProgressBar = __webpack_require__(782);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _ResultsCard = __webpack_require__(3797);
	
	var _ResultsCard2 = _interopRequireDefault(_ResultsCard);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(5173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Results(_ref) {
	  var results = _ref.results,
	      notFound = _ref.notFound,
	      formatMessage = _ref.formatMessage,
	      onStartVideoVisit = _ref.onStartVideoVisit,
	      virtualCallEnabled = _ref.virtualCallEnabled;
	
	  var publisher = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      level = _useState2[0],
	      setLevel = _useState2[1];
	
	  var _useState3 = (0, _react.useState)('default'),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      audio = _useState4[0],
	      setAudio = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(''),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      video = _useState6[0],
	      setVideo = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      populated = _useState8[0],
	      setPopulatedStatus = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
	      audioList = _useState10[0],
	      setAudioList = _useState10[1];
	
	  var _useState11 = (0, _react.useState)([]),
	      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
	      videoList = _useState12[0],
	      setVideoList = _useState12[1];
	
	  var audioSupported = results && results.audio.supported;
	  var videoSupported = results && results.video.supported;
	
	  (0, _react.useEffect)(function () {
	    var _getNotFoundSelectSta = (0, _getTestResults3.getNotFoundSelectState)(formatMessage),
	        videoData = _getNotFoundSelectSta.video,
	        audioData = _getNotFoundSelectSta.audio;
	
	    var hasVideo = videoSupported && !notFound;
	    var hasAudio = audioSupported && !notFound;
	
	    if (!hasAudio) {
	      setAudioList([audioData]);
	      setAudio(audioData.value);
	    }
	
	    if (!hasVideo) {
	      setVideoList([videoData]);
	      setVideo(videoData.value);
	    }
	
	    if (videoSupported || audioSupported) {
	      getUserMedia().then(function (_ref2) {
	        var audioSourceList = _ref2.audioSourceList,
	            videoSourceList = _ref2.videoSourceList;
	
	        if (audioSupported) {
	          setAudioList(audioSourceList);
	        }
	        if (videoSupported) {
	          setVideoList(videoSourceList);
	        }
	
	        if (!populated) {
	          if (videoSupported) {
	            initiateDefaultVideoSelection(videoSourceList);
	          }
	          if (audioSupported) {
	            initiateDefaultAudioSelection(audioSourceList);
	          }
	
	          setPopulatedStatus(true);
	        }
	      });
	    }
	    return function () {
	      if (publisher.current) {
	        publisher.current.off('audioLevelUpdated');
	        publisher.current.destroy();
	      }
	    };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (populated) {
	      publish();
	    }
	  }, [populated]);
	
	  var systemTitle = (0, _react.useMemo)(function () {
	    var _getTestResults = (0, _getTestResults3.getTestResults)(results, notFound, false),
	        videoCommon = _getTestResults.common,
	        videoResults = _getTestResults.results;
	
	    var _getTestResults2 = (0, _getTestResults3.getTestResults)(results, notFound, true),
	        audioCommon = _getTestResults2.common,
	        audioResults = _getTestResults2.results;
	
	    return {
	      video: {
	        title: formatMessage({
	          id: videoCommon
	        }) + ' ' + formatMessage({ id: videoResults.id }),
	        danger: videoResults.danger
	      },
	      audio: {
	        title: formatMessage({
	          id: audioCommon
	        }) + ' ' + formatMessage({ id: audioResults.id }),
	        danger: audioResults.danger,
	        icon: audioResults.icon
	      }
	    };
	  }, [results, notFound]);
	
	  var _useMemo = (0, _react.useMemo)(function () {
	    return (0, _getTestResults3.getCommonResult)(formatMessage, results, notFound);
	  }, [formatMessage, results]),
	      title = _useMemo.title,
	      danger = _useMemo.danger;
	
	  function publish() {
	    publisher.current = OT.initPublisher('publisher', {
	      audioSource: audio,
	      videoSource: video,
	      width: 230,
	      height: 170
	    }, function (err) {
	      if (err) {
	        console.log('Publish error ' + err.message);
	      } else {
	        setupAudioLevelMeter();
	        _onChange(audio, 'audio');
	        _onChange(video, 'video');
	      }
	    });
	  }
	
	  function initiateDefaultVideoSelection(videoSourceList) {
	    if (videoSourceList.length > 0) {
	      var videoSource = (0, _get2.default)(videoSourceList, '[0].value');
	      setVideo(videoSource);
	    }
	  }
	
	  function initiateDefaultAudioSelection(audioSourceList) {
	    var audioSource = (0, _get2.default)(audioSourceList, '[1].value');
	    setAudio(audioSource);
	  }
	
	  function setupAudioLevelMeter() {
	    publisher.current.on('audioLevelUpdated', function (event) {
	      var logLevel = (0, _getAudioLogLevel.getAudioLogLevel)(event);
	      setLevel(logLevel);
	    });
	  }
	
	  function getUserMedia() {
	    return new _promise2.default(function (resolve, reject) {
	      OT.getDevices(function (err, devices) {
	        if (err) {
	          return reject(err);
	        }
	
	        var audioDevices = devices.filter(function (_ref3) {
	          var kind = _ref3.kind;
	          return kind === 'audioInput';
	        });
	        var videoDevices = devices.filter(function (_ref4) {
	          var kind = _ref4.kind;
	          return kind === 'videoInput';
	        });
	
	        return resolve({
	          audioSourceList: (0, _utils.normalizeDevices)(audioDevices),
	          videoSourceList: (0, _utils.normalizeDevices)(videoDevices)
	        });
	      });
	    });
	  }
	
	  var _onChange = function _onChange(val, type) {
	    if (type === 'audio' && val !== audio) {
	      publisher.current.setAudioSource(val).then(function () {
	        setAudio(val);
	      });
	    }
	
	    if (type === 'video' && val !== video) {
	      publisher.current.cycleVideo().then(function (_ref5) {
	        var deviceId = _ref5.deviceId;
	
	        setVideo(deviceId);
	      });
	    }
	  };
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    { className: _styles2.default.root, overflowVisible: true },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.header },
	      _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)(_styles2.default.title, (0, _defineProperty3.default)({}, _styles2.default.titleDanger, danger)) },
	        title
	      ),
	      _react2.default.createElement(_VideoVisitBtn2.default, {
	        type: 'primary',
	        onStartVideoVisit: onStartVideoVisit,
	        disabled: !virtualCallEnabled
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _ResultsCard2.default,
	        {
	          list: videoList,
	          value: video,
	          disabled: !videoList.length || notFound || !videoSupported,
	          formatMessage: formatMessage,
	          onChange: function onChange(value) {
	            return _onChange(value, 'video');
	          },
	          label: formatMessage({ id: 'virtualVisit.device.video' }),
	          title: systemTitle.video.title,
	          subtitle: formatMessage({ id: 'virtualVisit.test.videoSubtitle' }),
	          danger: systemTitle.video.danger
	        },
	        _react2.default.createElement('div', { id: 'publisher' })
	      ),
	      _react2.default.createElement(
	        _ResultsCard2.default,
	        {
	          list: audioList,
	          value: audio,
	          disabled: !audioList.length || notFound || !audioSupported,
	          onChange: function onChange(value) {
	            return _onChange(value, 'audio');
	          },
	          label: formatMessage({ id: 'virtualVisit.device.mic' }),
	          title: systemTitle.audio.title,
	          subtitle: formatMessage({ id: 'virtualVisit.test.audioSubtitle' }),
	          danger: systemTitle.audio.danger
	        },
	        _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_Icon2.default, { size: 32, name: systemTitle.audio.icon, className: 'mb2' }),
	          _react2.default.createElement(
	            'div',
	            { className: _styles2.default.progress },
	            _react2.default.createElement(_ProgressBar2.default, { progress: level, height: 12 })
	          )
	        )
	      )
	    )
	  );
	} /* eslint-disable promise/always-return,promise/catch-or-return */
	
	
	Results.propTypes = {
	  formatMessage: PropTypes.func,
	  results: PropTypes.object,
	  notFound: PropTypes.bool,
	  onStartVideoVisit: PropTypes.func,
	  virtualCallEnabled: PropTypes.bool
	};
	
	exports.default = Results;

/***/ }),
/* 3797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _styles = __webpack_require__(5174);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ResultsCard(_ref) {
	  var title = _ref.title,
	      list = _ref.list,
	      value = _ref.value,
	      label = _ref.label,
	      danger = _ref.danger,
	      _onChange = _ref.onChange,
	      disabled = _ref.disabled,
	      children = _ref.children,
	      subtitle = _ref.subtitle,
	      readOnly = _ref.readOnly;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.details },
	      children
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.content },
	      _react2.default.createElement(
	        'h3',
	        { className: (0, _classnames2.default)(_styles2.default.title, (0, _defineProperty3.default)({}, _styles2.default.titleDanger, danger)) },
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _styles2.default.subtitle },
	        subtitle
	      ),
	      _react2.default.createElement(_SelectCustom2.default, {
	        disabled: disabled,
	        value: value,
	        label: label,
	        options: list,
	        onChange: function onChange(_ref2) {
	          var value = _ref2.value;
	          return _onChange(value);
	        },
	        needUpdateDefaultValue: true,
	        readOnly: readOnly
	      })
	    )
	  );
	}
	
	ResultsCard.propTypes = {
	  title: PropTypes.string,
	  list: PropTypes.array,
	  value: PropTypes.string,
	  onChange: PropTypes.func,
	  disabled: PropTypes.bool,
	  label: PropTypes.string,
	  subtitle: PropTypes.string,
	  children: PropTypes.node,
	  danger: PropTypes.bool,
	  readOnly: PropTypes.bool
	};
	
	exports.default = ResultsCard;

/***/ }),
/* 3798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _useTestCall2 = __webpack_require__(3803);
	
	var _Progress = __webpack_require__(3795);
	
	var _Progress2 = _interopRequireDefault(_Progress);
	
	var _Results = __webpack_require__(3796);
	
	var _Results2 = _interopRequireDefault(_Results);
	
	var _constants = __webpack_require__(1177);
	
	var _Intro = __webpack_require__(3794);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TestDetails(_ref) {
	  var onClose = _ref.onClose,
	      formatMessage = _ref.formatMessage,
	      testCredentials = _ref.testCredentials,
	      onStartVideoVisit = _ref.onStartVideoVisit,
	      virtualCallEnabled = _ref.virtualCallEnabled,
	      visitTestPerformed = _ref.visitTestPerformed;
	
	  var initStep = visitTestPerformed ? _constants.TEST_STEPS.PROGRESS : _constants.TEST_STEPS.INTRO;
	
	  var _useState = (0, _react.useState)(initStep),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      step = _useState2[0],
	      setStep = _useState2[1];
	
	  var _useTestCall = (0, _useTestCall2.useTestCall)(step, testCredentials, null),
	      disabled = _useTestCall.disabled,
	      progress = _useTestCall.progress,
	      results = _useTestCall.results,
	      stopTest = _useTestCall.stopTest,
	      notFound = _useTestCall.notFound,
	      error = _useTestCall.error;
	
	  (0, _react.useEffect)(function () {
	    if (results || notFound) {
	      setStep(_constants.TEST_STEPS.RESULTS);
	    }
	  }, [results, notFound]);
	
	  var handleStartTestVisit = function handleStartTestVisit() {
	    return setStep(_constants.TEST_STEPS.PROGRESS);
	  };
	
	  var handleStop = function handleStop() {
	    stopTest();
	    onClose();
	  };
	
	  var renderContent = function renderContent() {
	    switch (step) {
	      case _constants.TEST_STEPS.INTRO:
	        {
	          return _react2.default.createElement(_Intro2.default, {
	            onStartVideoVisit: onStartVideoVisit,
	            onStartTestVisit: handleStartTestVisit,
	            formatMessage: formatMessage,
	            virtualCallEnabled: virtualCallEnabled
	          });
	        }
	      case _constants.TEST_STEPS.PROGRESS:
	        {
	          return _react2.default.createElement(_Progress2.default, {
	            progress: progress,
	            formatMessage: formatMessage,
	            onClick: handleStop,
	            disabled: disabled,
	            error: error
	          });
	        }
	      case _constants.TEST_STEPS.RESULTS:
	        {
	          return _react2.default.createElement(_Results2.default, {
	            notFound: notFound,
	            results: results,
	            formatMessage: formatMessage,
	            onStartVideoVisit: onStartVideoVisit,
	            virtualCallEnabled: virtualCallEnabled
	          });
	        }
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'mt5' },
	    renderContent()
	  );
	}
	
	TestDetails.propTypes = {
	  onClose: PropTypes.func,
	  formatMessage: PropTypes.func,
	  onStartVideoVisit: PropTypes.func,
	  virtualCallEnabled: PropTypes.bool,
	  testCredentials: PropTypes.object,
	  visitTestPerformed: PropTypes.bool
	};
	
	exports.default = TestDetails;

/***/ }),
/* 3799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _index = __webpack_require__(3801);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _testCall = __webpack_require__(535);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VirtualTestCallModal() {
	  var opened = (0, _reactRedux.useSelector)(_selectors.selectTestCallModalOpened);
	  var props = (0, _reactRedux.useSelector)(_selectors.selectTestCallModalProps);
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var close = function close() {
	    return dispatch(_testCall.testCallActions.close());
	  };
	
	  if (!opened) return null;
	
	  return _react2.default.createElement(_index2.default, (0, _extends3.default)({ onClose: close }, props));
	}
	
	exports.default = VirtualTestCallModal;

/***/ }),
/* 3800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _networkTestCredentialsReq = __webpack_require__(856);
	
	var getTestCredentials = _interopRequireWildcard(_networkTestCredentialsReq);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(64);
	
	var _selectors3 = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loggedUserId: (0, _selectors.loggedUserIdSelector)(state),
	    pending: (0, _selectors2.selectNetworkTestCredentialsPending)(state),
	    testCredentials: (0, _selectors2.selectNetworkTestCredentials)(state),
	    visitTestPerformed: (0, _selectors3.selectVisitTestCallPerformed)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  getCredentials: getTestCredentials.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _styles = __webpack_require__(2248);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _useOTScriptLoad2 = __webpack_require__(1317);
	
	var _BackButton = __webpack_require__(80);
	
	var _BackButton2 = _interopRequireDefault(_BackButton);
	
	var _TestDetails = __webpack_require__(3798);
	
	var _TestDetails2 = _interopRequireDefault(_TestDetails);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _enhance = __webpack_require__(3800);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VirtualVideoTest(_ref) {
	  var onClose = _ref.onClose,
	      pending = _ref.pending,
	      loggedUserId = _ref.loggedUserId,
	      getCredentials = _ref.getCredentials,
	      testCredentials = _ref.testCredentials,
	      visitTestPerformed = _ref.visitTestPerformed,
	      onStartVideoVisit = _ref.onStartVideoVisit,
	      virtualCallEnabled = _ref.virtualCallEnabled,
	      formatMessage = _ref.intl.formatMessage;
	
	  var _useOTScriptLoad = (0, _useOTScriptLoad2.useOTScriptLoad)(true),
	      loaded = _useOTScriptLoad.loaded;
	
	  (0, _react.useEffect)(function () {
	    getCredentials({ id: loggedUserId });
	  }, [loggedUserId]);
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      opened: true,
	      strictClose: true,
	      contentNoPadding: true,
	      onClose: onClose,
	      withHeading: false,
	      disableFillBackground: true,
	      mobileFullScreen: false,
	      overflowVisible: true
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.root },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.content },
	        _react2.default.createElement('div', { className: _styles2.default.coverHeader, onClick: onClose }),
	        _react2.default.createElement(_BackButton2.default, {
	          onBack: onClose,
	          className: _styles2.default.backButton,
	          minWidth: 0
	        }),
	        !loaded || pending ? _react2.default.createElement(_Loader2.default, null) : _react2.default.createElement(_TestDetails2.default, {
	          onClose: onClose,
	          formatMessage: formatMessage,
	          testCredentials: testCredentials,
	          onStartVideoVisit: onStartVideoVisit,
	          virtualCallEnabled: virtualCallEnabled,
	          visitTestPerformed: visitTestPerformed
	        })
	      )
	    )
	  );
	}
	
	VirtualVideoTest.propTypes = {
	  intl: PropTypes.object,
	  onClose: PropTypes.func,
	  onStartVideoVisit: PropTypes.func,
	  virtualCallEnabled: PropTypes.bool,
	  pending: PropTypes.bool,
	  testCredentials: PropTypes.object,
	  loggedUserId: PropTypes.number,
	  getCredentials: PropTypes.func,
	  visitTestPerformed: PropTypes.bool
	};
	
	exports.default = (0, _enhance.enhance)(VirtualVideoTest);

/***/ }),
/* 3802 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAudioLogLevel = getAudioLogLevel;
	var movingAvg = null;
	
	function getAudioLogLevel(event) {
	  if (movingAvg === null || movingAvg <= event.audioLevel) {
	    movingAvg = event.audioLevel;
	  } else {
	    movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
	  }
	
	  // 1.5 scaling to map the -30 - 0 dBm range to [0,1]
	  var logLevel = Math.log(movingAvg) / Math.LN10 / 1.5 + 1;
	  logLevel = Math.min(Math.max(logLevel, 0), 1);
	  return logLevel * 100;
	}

/***/ }),
/* 3803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.useTestCall = useTestCall;
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(1177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable promise/always-return,promise/catch-or-return */
	var QUALITY_PROGRESS = 5;
	
	var getSessionInfo = function getSessionInfo(credentials, devices) {
	  if (!credentials) return null;
	  var apiKey = credentials.apiKey,
	      token = credentials.token,
	      sessionId = credentials.room;
	
	  return {
	    sessionInfo: {
	      apiKey: apiKey,
	      sessionId: sessionId,
	      token: token
	    },
	    options: (0, _extends3.default)({
	      timeout: 20000
	    }, devices)
	  };
	};
	
	function useTestCall(step, testCredentials, devices) {
	  var mountedRef = (0, _react.useRef)(true);
	  var otNetworkTest = (0, _react.useRef)(null);
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      canCancel = _useState2[0],
	      setCancelStatus = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(_constants.PROGRESS_STEPS.INIT),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      progress = _useState4[0],
	      setProgress = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      results = _useState6[0],
	      setResults = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(true),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      disabled = _useState8[0],
	      toggleDisableStatus = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
	      notFound = _useState10[0],
	      setNotFound = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
	      testError = _useState12[0],
	      setError = _useState12[1];
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      stopTest();
	      mountedRef.current = false;
	    };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (testCredentials && step === _constants.TEST_STEPS.PROGRESS) {
	      if (results) setResults(null);
	      if (notFound) setNotFound(false);
	      mountedRef.current = true;
	
	      var _getSessionInfo = getSessionInfo(testCredentials, devices),
	          sessionInfo = _getSessionInfo.sessionInfo,
	          options = _getSessionInfo.options;
	
	      otNetworkTest.current = new OpenTokNetworkConnectivity.default(OT, sessionInfo, options);
	      setProgress(_constants.PROGRESS_STEPS.START);
	
	      otNetworkTest.current.testConnectivity().then(function (res) {
	        if (!mountedRef.current) return null;
	        if (res.success) {
	          setProgress(_constants.PROGRESS_STEPS.CONNECTION_TEST_PASSED);
	          setCancelStatus(true);
	          testQuality();
	        } else {
	          convertErrors(res.failedTests);
	          stopTest();
	        }
	      });
	    }
	  }, [testCredentials, step]);
	
	  (0, _react.useEffect)(function () {
	    if (canCancel) {
	      var timer = setTimeout(function () {
	        toggleDisableStatus(false);
	      }, 4000);
	      return function () {
	        return clearTimeout(timer);
	      };
	    }
	  }, [canCancel]);
	
	  function testQuality() {
	    otNetworkTest.current.testQuality(function updateCallback(stats) {
	      if (!mountedRef.current) return null;
	      setProgress(function (prevState) {
	        if (prevState < _constants.PROGRESS_STEPS.QUALITY_LIMIT) {
	          return prevState + QUALITY_PROGRESS;
	        }
	        return prevState;
	      });
	    }).then(function (res) {
	      if (!mountedRef.current) return null;
	      setResults(res);
	      setProgress(_constants.PROGRESS_STEPS.DONE);
	    });
	  }
	
	  function stopTest() {
	    if (otNetworkTest.current) {
	      otNetworkTest.current.stop();
	      setProgress(_constants.PROGRESS_STEPS.INIT);
	      mountedRef.current = false;
	    }
	  }
	
	  function convertErrors(errs) {
	    var errorNames = errs.map(function (item) {
	      return item.error.name;
	    });
	    if (errorNames.includes(OpenTokNetworkConnectivity.ErrorNames.FAILED_TO_CREATE_LOCAL_PUBLISHER)) {
	      setNotFound(true);
	    } else {
	      setError('errors.common');
	    }
	  }
	
	  return {
	    disabled: disabled,
	    progress: progress,
	    results: results,
	    stopTest: stopTest,
	    notFound: notFound,
	    error: testError
	  };
	}

/***/ }),
/* 3804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _selectors = __webpack_require__(43);
	
	var _createVirtualVisitReq = __webpack_require__(625);
	
	var createVirtualVisit = _interopRequireWildcard(_createVirtualVisitReq);
	
	var _overlapModal = __webpack_require__(1221);
	
	var _styles = __webpack_require__(2274);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isOpenOverlapModal: (0, _selectors.selectOverlapModalState)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  closeModal: _overlapModal.overlapModalActions.close,
	  initOverlap: createVirtualVisit.actions.overlap
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ids = __webpack_require__(46);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _enhance = __webpack_require__(3804);
	
	var _styles = __webpack_require__(2274);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function OverlapModal(_ref) {
	  var isOpenOverlapModal = _ref.isOpenOverlapModal,
	      formatMessage = _ref.intl.formatMessage,
	      closeModal = _ref.closeModal,
	      initOverlap = _ref.initOverlap;
	
	  var handleOverlap = function handleOverlap() {
	    initOverlap();
	    closeModal();
	  };
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    {
	      opened: isOpenOverlapModal,
	      onClose: closeModal,
	      withHeading: false,
	      mobileFullScreen: false
	    },
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.content },
	      formatMessage({ id: 'appointment.form.overlap' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt3' },
	      _react2.default.createElement(_Button2.default, {
	        id: _ids.IDS.COMMON.ACTION_CONFIRMATION_SUBMIT,
	        color: 'primary',
	        onClick: handleOverlap,
	        children: formatMessage({ id: 'common.overlap' }),
	        type: 'button',
	        className: (0, _classnames2.default)('mr3', _styles2.default.btnOverlap),
	        raised: true
	      }),
	      _react2.default.createElement(_Button2.default, {
	        id: _ids.IDS.COMMON.ACTION_CONFIRMATION_CANCEL,
	        color: 'accent',
	        raised: true,
	        type: 'button',
	        onClick: closeModal,
	        children: formatMessage({ id: 'common.cancel' }),
	        className: _styles2.default.btnCancel
	      })
	    )
	  );
	}
	
	OverlapModal.propTypes = {
	  isOpenOverlapModal: PropTypes.bool,
	  intl: PropTypes.object,
	  closeModal: PropTypes.func,
	  initOverlap: PropTypes.func
	};
	
	exports.default = (0, _enhance.enhance)(OverlapModal);

/***/ }),
/* 3806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _AmountInput = __webpack_require__(1179);
	
	var _AmountInput2 = _interopRequireDefault(_AmountInput);
	
	var _styles = __webpack_require__(18);
	
	var _TimePickerInput = __webpack_require__(796);
	
	var _TimePickerInput2 = _interopRequireDefault(_TimePickerInput);
	
	var _DatePickerCustom = __webpack_require__(234);
	
	var _DatePickerCustom2 = _interopRequireDefault(_DatePickerCustom);
	
	var _formFields = __webpack_require__(38);
	
	var _dateConverters = __webpack_require__(83);
	
	var _getFieldProps = __webpack_require__(117);
	
	var _styles2 = __webpack_require__(173);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DATE = _formFields.PROFILE_FIELDS_TYPES.DATE,
	    COPAY = _formFields.PROFILE_FIELDS_TYPES.COPAY,
	    SERVICE = _formFields.PROFILE_FIELDS_TYPES.SERVICE,
	    LOCATION = _formFields.PROFILE_FIELDS_TYPES.LOCATION,
	    PROVIDER = _formFields.PROFILE_FIELDS_TYPES.PROVIDER,
	    START_TIME = _formFields.PROFILE_FIELDS_TYPES.START_TIME,
	    REASON_TYPE = _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE,
	    REASON_NOTE = _formFields.PROFILE_FIELDS_TYPES.REASON_NOTE,
	    REASON_TYPE_ID = _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID;
	
	
	function VisitInfoForm(_ref) {
	  var errors = _ref.errors,
	      formatMessage = _ref.formatMessage,
	      _onChange2 = _ref.onChange,
	      date = _ref.date,
	      copay = _ref.copay,
	      startTime = _ref.startTime,
	      locationsList = _ref.locationsList,
	      servicesList = _ref.servicesList,
	      reasonList = _ref.reasonList,
	      providersList = _ref.providersList,
	      locationId = _ref.locationId,
	      serviceId = _ref.serviceId,
	      reasonTypeId = _ref.reasonTypeId,
	      reasonNote = _ref.reasonNote,
	      providerId = _ref.providerId,
	      showTimeError = _ref.showTimeError,
	      loadingReasonTypes = _ref.loadingReasonTypes,
	      handleCopayChange = _ref.handleCopayChange;
	
	  var makeField = (0, _getFieldProps.getFieldProps)(formatMessage, _onChange2);
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { styleName: 'row row--justify' },
	      _react2.default.createElement(
	        'div',
	        { className: 'relative' },
	        _react2.default.createElement(_DatePickerCustom2.default, {
	          value: date,
	          label: formatMessage({ id: 'common.date' }),
	          name: DATE,
	          minDate: _dateConverters.yesterday,
	          onChange: function onChange(value) {
	            return _onChange2((0, _defineProperty3.default)({}, DATE, value));
	          }
	        }),
	        _react2.default.createElement(_Icon2.default, {
	          styleName: 'input-icon',
	          name: 'calendar',
	          style: { fill: _styles.COLORS.bluePrimary }
	        })
	      ),
	      _react2.default.createElement(_TimePickerInput2.default, {
	        withCurrentTime: true,
	        value: startTime,
	        name: START_TIME,
	        onChange: function onChange(value) {
	          return _onChange2((0, _defineProperty3.default)({}, START_TIME, value));
	        },
	        label: formatMessage({ id: 'reports.time' }),
	        placeholder: formatMessage({ id: 'reports.time' })
	      })
	    ),
	    showTimeError ? _react2.default.createElement(_ErrorBlock2.default, {
	      errors: formatMessage({ id: 'virtualVisit.details.futureTime' }),
	      className: 'mt3'
	    }) : null,
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(LOCATION, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      options: locationsList,
	      value: locationId,
	      needUpdateDefaultValue: true
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(SERVICE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      options: servicesList,
	      value: serviceId,
	      needUpdateDefaultValue: true,
	      disabled: !locationId
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(REASON_TYPE, _getFieldProps.FIELD_FILLING_TYPES.REQUIRED), {
	      options: reasonList,
	      value: reasonTypeId,
	      needUpdateDefaultValue: true,
	      name: REASON_TYPE_ID,
	      onChange: function onChange(_ref2) {
	        var value = _ref2.value;
	        return _onChange2((0, _defineProperty3.default)({}, REASON_TYPE_ID, value));
	      },
	      isLoading: loadingReasonTypes,
	      disabled: !serviceId || loadingReasonTypes
	    })),
	    _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({}, makeField(REASON_NOTE, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      value: reasonNote
	    })),
	    _react2.default.createElement(_SelectCustom2.default, (0, _extends3.default)({}, makeField(PROVIDER, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      options: providersList,
	      value: providerId,
	      canSearch: true,
	      label: formatMessage({
	        id: 'virtualVisit.details.appointmentProvider'
	      })
	    })),
	    _react2.default.createElement(_AmountInput2.default, (0, _extends3.default)({}, makeField(COPAY, _getFieldProps.FIELD_FILLING_TYPES.OPTIONAL), {
	      rounded: true,
	      name: COPAY,
	      value: copay,
	      onChange: handleCopayChange
	    })),
	    Boolean(errors) ? _react2.default.createElement(_ErrorBlock2.default, { errors: (0, _get2.default)(errors, 'description'), className: 'mt3' }) : null
	  );
	}
	
	VisitInfoForm.propTypes = {
	  date: PropTypes.instanceOf(Date),
	  errors: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({ description: PropTypes.string })]),
	  formatMessage: PropTypes.func,
	  onChange: PropTypes.func,
	  locationId: PropTypes.number,
	  serviceId: PropTypes.number,
	  reasonTypeId: PropTypes.number,
	  providerId: PropTypes.number,
	  locationsList: PropTypes.array,
	  servicesList: PropTypes.array,
	  reasonList: PropTypes.array,
	  providersList: PropTypes.array,
	  reasonNote: PropTypes.string,
	  copay: PropTypes.string,
	  startTime: PropTypes.string,
	  loadingReasonTypes: PropTypes.bool,
	  showTimeError: PropTypes.bool,
	  handleCopayChange: PropTypes.func
	};
	
	exports.default = (0, _reactCssModules2.default)(VisitInfoForm, _styles3.default, { allowMultiple: true });

/***/ }),
/* 3807 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _visitTypesReq = __webpack_require__(630);
	
	var visitTypes = _interopRequireWildcard(_visitTypesReq);
	
	var _reasonTypesReq = __webpack_require__(803);
	
	var reasonTypes = _interopRequireWildcard(_reasonTypesReq);
	
	var _createVirtualVisitReq = __webpack_require__(625);
	
	var createVirtualVisit = _interopRequireWildcard(_createVirtualVisitReq);
	
	var _virtualVisitProvidersReq = __webpack_require__(1237);
	
	var _selectors = __webpack_require__(43);
	
	var _styles = __webpack_require__(173);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loadingVisitTypes: (0, _selectors.selectVisitTypesPending)(state),
	    providersList: (0, _selectors.selectVirtualVisitProvidersList)(state),
	    isLoadingProviders: (0, _selectors.selectVirtualVisitProvidersPending)(state),
	    sendingCreateVisit: (0, _selectors.selectCreateVirtualVisitPending)(state),
	    errors: (0, _selectors.selectCreateVirtualVisitError)(state),
	    servicesList: (0, _selectors.selectVirtualVisitServicesList)(state),
	    reasonTypesList: (0, _selectors.selectReasonTypesList)(state),
	    loadingReasonTypes: (0, _selectors.selectReasonTypesPending)(state),
	    locations: (0, _selectors.selectVirtualVisitLocations)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  fetchProviders: _virtualVisitProvidersReq.actions.send,
	  fetchVisitTypes: visitTypes.actions.send,
	  clearVisitTypes: visitTypes.actions.clear,
	  fetchReasonTypes: reasonTypes.actions.send,
	  createVisit: createVirtualVisit.actions.init,
	  clearCreateVisit: createVirtualVisit.actions.clear
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var loadingVisitTypes = _ref.loadingVisitTypes,
	      sendingCreateVisit = _ref.sendingCreateVisit;
	  return {
	    pending: loadingVisitTypes || sendingCreateVisit
	  };
	}), (0, _reactCssModules2.default)(_styles2.default, { allowMultiple: true }));

/***/ }),
/* 3808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _some = __webpack_require__(986);
	
	var _some2 = _interopRequireDefault(_some);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _VisitInfoForm = __webpack_require__(3806);
	
	var _VisitInfoForm2 = _interopRequireDefault(_VisitInfoForm);
	
	var _getVisitTypeIdWithCode = __webpack_require__(4215);
	
	var _getVisitFormData = __webpack_require__(3811);
	
	var _useVisitInfoFormState = __webpack_require__(3812);
	
	var _visitTime = __webpack_require__(3813);
	
	var _formFields = __webpack_require__(38);
	
	var _constants = __webpack_require__(17);
	
	var _selectors = __webpack_require__(43);
	
	var _enhance = __webpack_require__(3807);
	
	var _OverlapModal = __webpack_require__(3805);
	
	var _OverlapModal2 = _interopRequireDefault(_OverlapModal);
	
	var _MetaHelmet = __webpack_require__(49);
	
	var _MetaHelmet2 = _interopRequireDefault(_MetaHelmet);
	
	var _usePageView = __webpack_require__(52);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function VisitDetails(_ref) {
	  var _initErrorsState;
	
	  var errors = _ref.errors,
	      pending = _ref.pending,
	      locations = _ref.locations,
	      createVisit = _ref.createVisit,
	      providersList = _ref.providersList,
	      formatMessage = _ref.formatMessage,
	      fetchProviders = _ref.fetchProviders,
	      clearVisitTypes = _ref.clearVisitTypes,
	      fetchVisitTypes = _ref.fetchVisitTypes,
	      reasonTypesList = _ref.reasonTypesList,
	      clearCreateVisit = _ref.clearCreateVisit,
	      fetchReasonTypes = _ref.fetchReasonTypes,
	      loadingProviders = _ref.loadingProviders,
	      loadingReasonTypes = _ref.loadingReasonTypes,
	      userId = _ref.params.userId;
	
	  var _useVisitInfoForm = (0, _useVisitInfoFormState.useVisitInfoForm)(),
	      handleFormChange = _useVisitInfoForm.handleFormChange,
	      formState = _useVisitInfoForm.formState,
	      clearForm = _useVisitInfoForm.clearForm,
	      isValid = _useVisitInfoForm.isValid;
	
	  var START_TIME = _formFields.PROFILE_FIELDS_TYPES.START_TIME,
	      COPAY = _formFields.PROFILE_FIELDS_TYPES.COPAY;
	  var providerId = formState.providerId,
	      reasonNote = formState.reasonNote,
	      reasonTypeId = formState.reasonTypeId,
	      serviceId = formState.serviceId,
	      locationId = formState.locationId,
	      copay = formState.copay,
	      date = formState.date,
	      startTime = formState.startTime;
	
	
	  var initErrorsState = (_initErrorsState = {}, (0, _defineProperty3.default)(_initErrorsState, COPAY, false), (0, _defineProperty3.default)(_initErrorsState, START_TIME, false), _initErrorsState);
	
	  var _useState = (0, _react.useState)(initErrorsState),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      errorState = _useState2[0],
	      setError = _useState2[1];
	
	  var services = (0, _reactRedux.useSelector)((0, _selectors.selectVirtualServiceByLocationId)(locationId));
	  var allVisitTypesList = (0, _reactRedux.useSelector)(_selectors.selectVisitTypesList);
	
	  (0, _usePageView.usePageView)('Visit Details');
	  (0, _react.useEffect)(function () {
	    fetchProviders({ userId: userId });
	    fetchVisitTypes({ filterVisitTypeLocations: true });
	    return function () {
	      clearVisitTypes();
	      clearCreateVisit();
	    };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (serviceId && locationId) {
	      fetchReasonTypes({
	        serviceId: serviceId,
	        userId: userId,
	        locationId: locationId,
	        visitTypeId: (0, _getVisitTypeIdWithCode.getVisitTypeIdWithCode)(_constants.VIRTUAL_VISIT_TYPE_CODE, allVisitTypesList)
	      });
	    }
	  }, [serviceId, allVisitTypesList, locationId]);
	
	  (0, _react.useEffect)(function () {
	    var timeError = (0, _visitTime.isValidTime)(startTime, date);
	    setError((0, _extends5.default)({}, errorState, (0, _defineProperty3.default)({}, START_TIME, timeError)));
	  }, [startTime, date]);
	
	  var handleCopayChange = function handleCopayChange(value, err) {
	    setError((0, _extends5.default)({}, errorState, (0, _defineProperty3.default)({}, COPAY, err)));
	    handleFormChange((0, _defineProperty3.default)({}, COPAY, value));
	  };
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	
	    var dateTime = (0, _visitTime.convertUTCVisitTime)(date, startTime);
	
	    var visit = {
	      userId: userId,
	      dateTime: dateTime,
	      providerId: providerId,
	      payload: {
	        reasonNote: reasonNote,
	        reasonTypeId: reasonTypeId,
	        serviceId: serviceId,
	        locationId: locationId,
	        copay: copay
	      }
	    };
	    createVisit(visit);
	  };
	
	  if (loadingProviders) return _react2.default.createElement(_Loader2.default, null);
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'section' },
	    _react2.default.createElement(_MetaHelmet2.default, { title: 'pages.title.visitDetails' }),
	    _react2.default.createElement(
	      'div',
	      { styleName: (0, _classnames2.default)('content', { disabled: pending }) },
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(_VisitInfoForm2.default, (0, _extends5.default)({}, formState, {
	          formatMessage: formatMessage,
	          errors: errors,
	          onChange: handleFormChange,
	          showTimeError: errorState[START_TIME],
	          locationsList: (0, _getVisitFormData.getVisitFormOptions)(locations),
	          servicesList: (0, _getVisitFormData.getVisitFormOptions)(services),
	          reasonList: (0, _getVisitFormData.getVisitFormOptions)(reasonTypesList),
	          loadingReasonTypes: loadingReasonTypes,
	          providersList: (0, _getVisitFormData.getVisitFormOptions)(providersList, true),
	          handleCopayChange: handleCopayChange
	        })),
	        _react2.default.createElement(
	          'div',
	          { styleName: 'btn-block' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              type: 'button',
	              raised: true,
	              color: 'accent',
	              disabled: pending,
	              onClick: function onClick() {
	                return clearForm();
	              }
	            },
	            formatMessage({ id: 'common.cancel' })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'ml3',
	              type: 'submit',
	              raised: true,
	              color: 'primary',
	              disabled: !isValid || (0, _some2.default)(errorState) || pending
	            },
	            formatMessage({ id: 'virtualVisit.details.schedule' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_OverlapModal2.default, null)
	  );
	}
	
	VisitDetails.propTypes = {
	  formatMessage: PropTypes.func,
	  pending: PropTypes.bool,
	  errors: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	  fetchVisitTypes: PropTypes.func,
	  createVisit: PropTypes.func,
	  clearVisitTypes: PropTypes.func,
	  clearCreateVisit: PropTypes.func,
	  fetchProviders: PropTypes.func,
	  fetchReasonTypes: PropTypes.func,
	  providersList: PropTypes.array,
	  loadingProviders: PropTypes.bool,
	  locations: PropTypes.array,
	  reasonTypesList: PropTypes.array,
	  loadingReasonTypes: PropTypes.bool,
	  params: PropTypes.object
	};
	
	exports.default = (0, _enhance.enhance)(VisitDetails);

/***/ }),
/* 3809 */,
/* 3810 */,
/* 3811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVisitFormOptions = getVisitFormOptions;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getVisitFormOptions(list, isComplexName) {
	  return list.map(function (item) {
	    var label = isComplexName ? (0, _get2.default)(item, 'firstName') + ' ' + (0, _get2.default)(item, 'lastName') : (0, _get2.default)(item, 'name');
	
	    return {
	      label: label,
	      value: (0, _get2.default)(item, 'id')
	    };
	  });
	}

/***/ }),
/* 3812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateRequiredFields = exports.initialState = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _initialState;
	
	exports.useVisitInfoForm = useVisitInfoForm;
	
	var _react = __webpack_require__(1);
	
	var _lodash = __webpack_require__(58);
	
	var _formFields = __webpack_require__(38);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = (_initialState = {}, (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.START_TIME, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.DATE, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.LOCATION, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.SERVICE, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.REASON_COMMENT, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.PROVIDER, null), (0, _defineProperty3.default)(_initialState, _formFields.PROFILE_FIELDS_TYPES.COPAY, null), _initialState);
	
	var validateRequiredFields = exports.validateRequiredFields = (0, _useFormWithValidation.makeRequiredFieldsValidator)([_formFields.PROFILE_FIELDS_TYPES.START_TIME, _formFields.PROFILE_FIELDS_TYPES.DATE, _formFields.PROFILE_FIELDS_TYPES.LOCATION, _formFields.PROFILE_FIELDS_TYPES.SERVICE, _formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID, _formFields.PROFILE_FIELDS_TYPES.PROVIDER]);
	
	function useVisitInfoForm() {
	  var _useFormState = (0, _useFormWithValidation.useFormState)(initialState),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange,
	      clearForm = _useFormState.clearForm;
	
	  var location = formState[_formFields.PROFILE_FIELDS_TYPES.LOCATION];
	  var service = formState[_formFields.PROFILE_FIELDS_TYPES.SERVICE];
	
	  function populateData(fieldKey) {
	    if (formState) {
	      var populate = (0, _lodash.mapValues)(formState, function (value, key) {
	        if (key === fieldKey) return null;
	
	        return formState[key] || null;
	      });
	      handleFormChange(populate);
	    }
	  }
	
	  (0, _react.useEffect)(function () {
	    populateData(_formFields.PROFILE_FIELDS_TYPES.SERVICE);
	  }, [location]);
	
	  (0, _react.useEffect)(function () {
	    populateData(_formFields.PROFILE_FIELDS_TYPES.REASON_TYPE_ID);
	  }, [service]);
	
	  var isValid = validateRequiredFields(formState);
	
	  return {
	    formState: formState,
	    handleFormChange: handleFormChange,
	    clearForm: clearForm,
	    isValid: isValid
	  };
	}

/***/ }),
/* 3813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValidTime = exports.convertUTCVisitTime = exports.convertVisitTime = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _is_same_day = __webpack_require__(937);
	
	var _is_same_day2 = _interopRequireDefault(_is_same_day);
	
	var _dateConverters = __webpack_require__(83);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var convertVisitTime = exports.convertVisitTime = function convertVisitTime(date, time) {
	  var currentDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	  var formattedTime = (0, _moment2.default)(time, 'HH:mm A').format('HH:mm');
	  return (0, _moment2.default)(currentDate + ' ' + formattedTime).format('YYYY-MM-DD HH:mm:ss');
	};
	
	function parseTime(timeStr) {
	  var _timeStr$split = timeStr.split(' '),
	      _timeStr$split2 = (0, _slicedToArray3.default)(_timeStr$split, 2),
	      time = _timeStr$split2[0],
	      interval = _timeStr$split2[1];
	  // eslint-disable-next-line prefer-const
	
	
	  var _time$split = time.split(':'),
	      _time$split2 = (0, _slicedToArray3.default)(_time$split, 2),
	      hours = _time$split2[0],
	      minutes = _time$split2[1];
	
	  if (interval.toLowerCase() === 'pm' && hours !== '12' || interval.toLowerCase() === 'am' && hours === '12') {
	    hours = Number(hours) + 12;
	  }
	
	  return { hours: hours, minutes: minutes };
	}
	
	var convertUTCVisitTime = exports.convertUTCVisitTime = function convertUTCVisitTime(date, time) {
	  var _parseTime = parseTime(time),
	      hours = _parseTime.hours,
	      minutes = _parseTime.minutes;
	
	  return (0, _moment2.default)(date).startOf('day').add({ minutes: minutes, hours: hours }).toISOString();
	};
	
	var isValidTime = exports.isValidTime = function isValidTime(time, date) {
	  if (time && date) {
	    var visitTime = convertVisitTime(date, time);
	    var now = new Date();
	    var needValidation = (0, _is_same_day2.default)(visitTime, now);
	    return needValidation ? (0, _dateConverters.isBeforeTime)(visitTime, now) : false;
	  }
	  return false;
	};

/***/ }),
/* 3814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _isPlainObject = __webpack_require__(248);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _styles = __webpack_require__(18);
	
	var _strings = __webpack_require__(15);
	
	var _props = __webpack_require__(41);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _index = __webpack_require__(2275);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertBox = function AlertBox(_ref) {
	  var iconType = _ref.iconType,
	      onClose = _ref.onClose,
	      text = _ref.text,
	      type = _ref.type,
	      title = _ref.title,
	      values = _ref.values,
	      showBtn = _ref.showBtn,
	      infoErrorIcon = _ref.infoErrorIcon,
	      props = (0, _objectWithoutProperties3.default)(_ref, ['iconType', 'onClose', 'text', 'type', 'title', 'values', 'showBtn', 'infoErrorIcon']);
	
	  var valuesData = values || {};
	  var message = (0, _isPlainObject2.default)(text) ? _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, text, { values: valuesData })) : text;
	  var iconName = iconType || 'exclamation-mark-hover';
	  var fillColor = type === 'success' ? _styles.COLORS.greenLime : _styles.COLORS.orangePink;
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    (0, _extends3.default)({
	      onClose: onClose,
	      mobileFullScreen: false,
	      opened: !!text,
	      white: true,
	      width: 'rubber',
	      withHeading: false
	    }, props),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'root' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'content' },
	        _react2.default.createElement(_Icon2.default, {
	          name: type === 'error' ? infoErrorIcon || type : iconName,
	          size: 40,
	          className: 'pb2',
	          style: { fill: fillColor }
	        }),
	        title && _react2.default.createElement(
	          'p',
	          { className: _index2.default.title },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: title })
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'pt3 tc', styleName: 'message' },
	          message
	        ),
	        showBtn && _react2.default.createElement(
	          _Button2.default,
	          { color: 'primary', onClick: onClose, styleName: 'btn' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'auth.errors.gotIt' })
	        )
	      )
	    )
	  );
	};
	
	AlertBox.propTypes = {
	  onClose: _propTypes2.default.func,
	  text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    id: _propTypes2.default.string
	  })]),
	  type: _propTypes2.default.oneOf(_props.PROPS_LIST.appAlert.type),
	  iconType: _propTypes2.default.string,
	  values: _propTypes2.default.object,
	  showBtn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  infoErrorIcon: _propTypes2.default.string
	};
	
	AlertBox.defaultProps = {
	  text: _strings.SUCCESS,
	  type: 'success',
	  onClose: null,
	  iconType: null,
	  showBtn: false,
	  title: null
	};
	
	exports.default = (0, _reactCssModules2.default)(AlertBox, _index2.default, { allowMultiple: true });

/***/ }),
/* 3815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _withErrorBoundary = __webpack_require__(619);
	
	var _success = __webpack_require__(104);
	
	var _error = __webpack_require__(101);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    message: (0, _success.successMsgSelector)(state),
	    errorMessage: (0, _error.errorMsgSelector)(state),
	    iconType: (0, _success.succesTypeSelector)(state),
	    values: (0, _success.successValuesForMsgSelector)(state),
	    isStaticFlow: (0, _error.errorIsStaticFlowSelector)(state),
	    infoErrorIcon: (0, _error.infoErrorIconSelector)(state),
	    title: (0, _success.successAlertBoxTitleSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  update: _success.actions.update,
	  updateError: _error.actions.update
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_withErrorBoundary.withErrorBoundary, _reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RenderTemporary = __webpack_require__(1170);
	
	var _RenderTemporary2 = _interopRequireDefault(_RenderTemporary);
	
	var _AlertBox = __webpack_require__(3814);
	
	var _AlertBox2 = _interopRequireDefault(_AlertBox);
	
	var _enhance = __webpack_require__(3815);
	
	var _index = __webpack_require__(2275);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppAlert = function AppAlert(_ref) {
	  var errorMessage = _ref.errorMessage,
	      iconType = _ref.iconType,
	      infoErrorIcon = _ref.infoErrorIcon,
	      isStaticFlow = _ref.isStaticFlow,
	      message = _ref.message,
	      title = _ref.title,
	      update = _ref.update,
	      updateError = _ref.updateError,
	      values = _ref.values;
	
	  var updateSuccessMsg = function updateSuccessMsg() {
	    if (errorMessage && updateError) updateError();
	    if (message && update) update();
	  };
	
	  return isStaticFlow ? _react2.default.createElement(_AlertBox2.default, {
	    onClose: updateSuccessMsg,
	    type: 'error',
	    text: errorMessage,
	    showBtn: true,
	    infoErrorIcon: infoErrorIcon,
	    title: title
	  }) : _react2.default.createElement(
	    _RenderTemporary2.default,
	    {
	      rendered: !!errorMessage || !!message,
	      timeout: 4000,
	      callback: updateSuccessMsg
	    },
	    _react2.default.createElement(_AlertBox2.default, (0, _extends3.default)({ iconType: iconType }, {
	      title: title,
	      type: errorMessage ? 'error' : 'success',
	      text: errorMessage || message,
	      values: values,
	      onClose: updateSuccessMsg,
	      dialogClassName: _index2.default.dialog
	    }))
	  );
	};
	
	AppAlert.propTypes = {
	  message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    id: _propTypes2.default.string
	  })]),
	  update: _propTypes2.default.func,
	  errorMessage: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    id: _propTypes2.default.string
	  })]),
	  updateError: _propTypes2.default.func,
	  iconType: _propTypes2.default.string,
	  values: _propTypes2.default.object,
	  title: _propTypes2.default.string,
	  isStaticFlow: _propTypes2.default.bool,
	  infoErrorIcon: _propTypes2.default.string
	};
	
	AppAlert.defaultProps = {
	  errorMessage: null,
	  updateError: null,
	  update: null,
	  message: null,
	  iconType: null,
	  title: null
	};
	
	exports.default = (0, _enhance.enhance)(AppAlert);

/***/ }),
/* 3817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _withErrorBoundary = __webpack_require__(619);
	
	var _selectors = __webpack_require__(90);
	
	var _popup = __webpack_require__(76);
	
	var _reqSendReport = __webpack_require__(1267);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    visible: (0, _selectors.selectUiPopupVisible)(state),
	    contentOptions: (0, _selectors.selectUiPopupContentOptions)(state),
	    contentType: (0, _selectors.selectUiPopupContentType)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  hidePopup: _popup.actions.hide,
	  sendReport: _reqSendReport.actions.send
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_withErrorBoundary.withErrorBoundary, _reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var formatMessage = _ref.intl.formatMessage;
	  return {
	    formatMessage: formatMessage
	  };
	}));

/***/ }),
/* 3818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ChangeStatus = __webpack_require__(3216);
	
	var _ChangeStatus2 = _interopRequireDefault(_ChangeStatus);
	
	var _PayaPayment = __webpack_require__(3325);
	
	var _PayaPayment2 = _interopRequireDefault(_PayaPayment);
	
	var _LoaderInPopup = __webpack_require__(1808);
	
	var _LoaderInPopup2 = _interopRequireDefault(_LoaderInPopup);
	
	var _MobileAppModal = __webpack_require__(3749);
	
	var _MobileAppModal2 = _interopRequireDefault(_MobileAppModal);
	
	var _TextMessage = __webpack_require__(1809);
	
	var _TextMessage2 = _interopRequireDefault(_TextMessage);
	
	var _Report = __webpack_require__(3753);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _MfaNoticeDialog = __webpack_require__(3411);
	
	var _MfaNoticeDialog2 = _interopRequireDefault(_MfaNoticeDialog);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _PayaAccountForm = __webpack_require__(3324);
	
	var _PayaAccountForm2 = _interopRequireDefault(_PayaAccountForm);
	
	var _PayaPaymentHandleResponse = __webpack_require__(3326);
	
	var _PayaPaymentHandleResponse2 = _interopRequireDefault(_PayaPaymentHandleResponse);
	
	var _Refills = __webpack_require__(3516);
	
	var _Refills2 = _interopRequireDefault(_Refills);
	
	var _strings = __webpack_require__(15);
	
	var _props = __webpack_require__(41);
	
	var _enhance = __webpack_require__(3817);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppPopup = function AppPopup(_ref) {
	  var formatMessage = _ref.formatMessage,
	      sendReport = _ref.sendReport,
	      contentType = _ref.contentType,
	      contentOptions = _ref.contentOptions,
	      visible = _ref.visible,
	      hidePopup = _ref.hidePopup;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      data = _useState2[0],
	      setData = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    if (!visible) setData(null);
	  }, [visible]);
	
	  var handleReportSubmit = function handleReportSubmit() {
	    var resource = contentOptions.resource,
	        reportableId = contentOptions.id;
	
	
	    var payload = {
	      reportableId: reportableId,
	      reportType: _props.REPORT_ENDPOINT_BY_RESOURCE_TYPE[resource],
	      reasonId: data
	    };
	
	    sendReport(payload);
	    hidePopup();
	  };
	
	  var getComponent = function getComponent() {
	    switch (contentType) {
	      case _props.UI_POPUP_TYPES.REPORT:
	        return _react2.default.createElement(_Report2.default, { options: contentOptions, onSelect: setData });
	
	      case _props.UI_POPUP_TYPES.MESSAGE:
	        return _react2.default.createElement(_TextMessage2.default, {
	          icon: contentOptions.icon,
	          title: contentOptions.title,
	          message: contentOptions.message
	        });
	
	      case _props.UI_POPUP_TYPES.MOBILE_APP:
	        return _react2.default.createElement(_MobileAppModal2.default, null);
	
	      case _props.UI_POPUP_TYPES.DASHBOARD_CHANGE_STATUS:
	        return _react2.default.createElement(_ChangeStatus2.default, { options: contentOptions });
	
	      case _props.UI_POPUP_TYPES.PAYA_PAYMENT:
	        return _react2.default.createElement(_PayaPayment2.default, { options: contentOptions, onClose: hidePopup });
	
	      case _props.UI_POPUP_TYPES.LOADER:
	        return _react2.default.createElement(_LoaderInPopup2.default, null);
	
	      case _props.UI_POPUP_TYPES.MFA_NOTICE:
	        return _react2.default.createElement(_MfaNoticeDialog2.default, null);
	
	      case _props.UI_POPUP_TYPES.PAYA_ACCOUNT_FORM:
	        return _react2.default.createElement(_PayaAccountForm2.default, { onClose: hidePopup, options: contentOptions });
	
	      case _props.UI_POPUP_TYPES.PAYA_PAYMENT_HANDLE_RESPONSE:
	        return _react2.default.createElement(_PayaPaymentHandleResponse2.default, {
	          onClose: hidePopup,
	          options: (0, _extends3.default)({}, contentOptions, { formatMessage: formatMessage })
	        });
	
	      case _props.UI_POPUP_TYPES.MEDICATIONS_REFILLS:
	        return _react2.default.createElement(_Refills2.default, {
	          onClose: hidePopup,
	          options: (0, _extends3.default)({}, contentOptions, { formatMessage: formatMessage })
	        });
	
	      default:
	        return null;
	    }
	  };
	
	  var getOptions = function getOptions() {
	    switch (contentType) {
	      case _props.UI_POPUP_TYPES.REPORT:
	        return {
	          onClose: hidePopup,
	          title: formatMessage(_strings.REPORT.title),
	          width: (0, _mobileHelpers.isDesktop)() ? 'xsmall' : 'medium',
	          customControls: true,
	          onSubmit: handleReportSubmit,
	          submitText: formatMessage(_strings.COMMON.send),
	          enabled: Boolean(data)
	        };
	
	      case _props.UI_POPUP_TYPES.MESSAGE:
	        {
	          var closeModal = function closeModal() {
	            if (contentOptions.popupClose) contentOptions.popupClose();
	            hidePopup();
	          };
	          var submitModal = function submitModal() {
	            if (contentOptions.popupAction) contentOptions.popupAction();
	            hidePopup();
	          };
	
	          return {
	            enabled: true,
	            footerCentered: true,
	            buttonWidth: 150,
	            submitText: formatMessage(_strings.AUTH.submit.expiredToken),
	            mobileFullScreen: false,
	            white: true,
	            width: 'rubber',
	            withHeading: false,
	            customControls: true,
	            onSubmit: submitModal,
	            onClose: closeModal,
	            strictClose: true
	          };
	        }
	
	      case _props.UI_POPUP_TYPES.MOBILE_APP:
	        return {
	          onClose: hidePopup,
	          withHeading: false,
	          mobileFullScreen: false,
	          centered: true,
	          contentNoPadding: true,
	          width: 'rubber'
	        };
	
	      case _props.UI_POPUP_TYPES.DASHBOARD_CHANGE_STATUS:
	        return {
	          onClose: hidePopup,
	          title: formatMessage({ id: 'dashboard.record.updateVisitDetails' }),
	          width: (0, _mobileHelpers.isDesktop)() ? 'xsmall' : 'medium'
	        };
	
	      case _props.UI_POPUP_TYPES.PAYA_PAYMENT:
	        {
	          return {
	            onClose: hidePopup,
	            strictClose: true,
	            withHeading: false,
	            overflowVisible: true,
	            contentNoPadding: true,
	            autoHeight: true
	          };
	        }
	
	      case _props.UI_POPUP_TYPES.LOADER:
	        {
	          return {
	            withHeading: false,
	            contentNoPadding: true,
	            overflowVisible: true,
	            autoHeight: true
	          };
	        }
	
	      case _props.UI_POPUP_TYPES.MFA_NOTICE:
	        {
	          return {
	            withHeading: false,
	            width: 'rubber',
	            centered: true,
	            onClose: hidePopup,
	            mobileFullScreen: false
	          };
	        }
	
	      case _props.UI_POPUP_TYPES.PAYA_ACCOUNT_FORM:
	        {
	          return {
	            onClose: hidePopup,
	            strictClose: true,
	            withHeading: false,
	            overflowVisible: true,
	            contentNoPadding: true,
	            autoHeight: true
	          };
	        }
	
	      case _props.UI_POPUP_TYPES.PAYA_PAYMENT_HANDLE_RESPONSE:
	        {
	          return {
	            withHeading: false,
	            width: 'rubber',
	            onClose: hidePopup,
	            mobileFullScreen: false
	          };
	        }
	
	      case _props.UI_POPUP_TYPES.MEDICATIONS_REFILLS:
	        {
	          return {
	            withHeading: false,
	            overflowVisible: true,
	            contentNoPadding: false,
	            autoHeight: true,
	            mobileFullScreen: false,
	            disableFillBackground: true
	          };
	        }
	
	      default:
	        return {};
	    }
	  };
	
	  var options = getOptions();
	  var component = getComponent();
	
	  if (!component) return null;
	  return _react2.default.createElement(_Popup2.default, (0, _extends3.default)({ opened: visible }, options, { children: component }));
	};
	
	AppPopup.propTypes = {
	  sendReport: _propTypes2.default.func.isRequired,
	  formatMessage: _propTypes2.default.func.isRequired,
	  contentType: _propTypes2.default.string.isRequired,
	  contentOptions: _propTypes2.default.object.isRequired,
	  visible: _propTypes2.default.bool.isRequired,
	  hidePopup: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _enhance.enhance)(AppPopup);

/***/ }),
/* 3819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactIntl = __webpack_require__(5);
	
	var _recompose = __webpack_require__(22);
	
	var _ImageManager = __webpack_require__(1184);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _emptyAvatar = __webpack_require__(5267);
	
	var _emptyAvatar2 = _interopRequireDefault(_emptyAvatar);
	
	var _index = __webpack_require__(5179);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvatarWithCropModal = function AvatarWithCropModal(_ref) {
	  var url = _ref.url,
	      name = _ref.name,
	      edit = _ref.edit,
	      onImageRemove = _ref.onImageRemove,
	      onImageCrop = _ref.onImageCrop,
	      bordered = _ref.bordered,
	      size = _ref.size,
	      formatMessage = _ref.formatMessage,
	      offsetX = _ref.offsetX,
	      offsetY = _ref.offsetY;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(_Avatar2.default, {
	      children: name,
	      src: name || url ? url : _emptyAvatar2.default,
	      bordered: bordered,
	      size: size
	    }),
	    _react2.default.createElement(_ImageManager.ImageManager, {
	      removeTitle: formatMessage({ id: 'community.logo.removeTitle' }),
	      cropTitle: formatMessage({ id: 'community.logo.cropTitle' }),
	      onImageRemove: onImageRemove,
	      onImageCrop: onImageCrop,
	      hidden: !edit,
	      style: {
	        position: 'absolute',
	        top: offsetY ? -offsetY + 'px' : 0,
	        right: offsetX ? -offsetX + 'px' : 0
	      },
	      aspectRatio: 1,
	      rounded: true
	    })
	  );
	};
	
	AvatarWithCropModal.defaultPros = {
	  size: 100
	};
	
	AvatarWithCropModal.propTypes = {
	  onImageRemove: _propTypes2.default.func.isRequired,
	  onImageCrop: _propTypes2.default.func.isRequired,
	  edit: _propTypes2.default.bool,
	  formatMessage: _propTypes2.default.func.isRequired,
	  image: _propTypes2.default.shape({
	    url: _propTypes2.default.string
	  }),
	  url: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  bordered: _propTypes2.default.bool,
	  size: _propTypes2.default.number,
	  offsetX: _propTypes2.default.number,
	  offsetY: _propTypes2.default.number
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _recompose.withProps)(function (_ref2) {
	  var formatMessage = _ref2.intl.formatMessage;
	  return {
	    formatMessage: formatMessage
	  };
	}), (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }))(AvatarWithCropModal);

/***/ }),
/* 3820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactDatepicker = __webpack_require__(5937);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _styles2 = __webpack_require__(5181);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Calendar(_ref) {
	  var _styles = _ref.styles,
	      props = (0, _objectWithoutProperties3.default)(_ref, ['styles']);
	
	  return _react2.default.createElement(_reactDatepicker2.default, (0, _extends3.default)({}, props, { calendarClassName: _styles.root }));
	}
	
	Calendar.propTypes = {
	  styles: PropTypes.object
	};
	
	exports.default = (0, _reactCssModules2.default)(Calendar, _styles3.default, { allowMultiple: true });

/***/ }),
/* 3821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _chart = __webpack_require__(702);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactIntl = __webpack_require__(5);
	
	__webpack_require__(3829);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _hooks = __webpack_require__(144);
	
	var _styles = __webpack_require__(5183);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartCanvas = function ChartCanvas(_ref) {
	  var config = _ref.config,
	      loading = _ref.loading,
	      formatMessage = _ref.intl.formatMessage;
	
	  var ref = (0, _react.useRef)(null);
	
	  var _useChartContext = (0, _hooks.useChartContext)(),
	      chart = _useChartContext.chart,
	      setChart = _useChartContext.setChart;
	
	  var nothing = (0, _isEmpty2.default)((0, _get2.default)(config, 'data.datasets', []));
	
	  (0, _react.useEffect)(function () {
	    if (chart) chart.destroy();
	    var canvas = ref && ref.current.getContext('2d');
	    if (!loading && !nothing) setChart(new _chart.Chart(canvas, config));
	  }, [ref, config, loading]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.canvas },
	    _react2.default.createElement('canvas', { ref: ref }),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.info },
	      loading && _react2.default.createElement(_Loader2.default, null),
	      !loading && nothing && _react2.default.createElement(
	        'div',
	        { className: _styles2.default.empty },
	        _react2.default.createElement(_Icon2.default, { name: 'ico-1000-graph', size: 60 }),
	        _react2.default.createElement(
	          'div',
	          { className: _styles2.default.description },
	          formatMessage({ id: 'patient.healthboard.graf.emptyState' })
	        )
	      )
	    )
	  );
	};
	
	ChartCanvas.propTypes = {
	  loading: _propTypes2.default.bool,
	  config: _propTypes2.default.object,
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(ChartCanvas);

/***/ }),
/* 3822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _styles = __webpack_require__(5184);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _constants = __webpack_require__(114);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NAME_ID = _constants.PROVIDER_OPTION.NAME_ID,
	    ICON = _constants.PROVIDER_OPTION.ICON;
	
	
	var MeasurementTitles = function MeasurementTitles(_ref) {
	  var data = _ref.data,
	      mark = _ref.mark,
	      dates = _ref.dates,
	      sources = _ref.sources,
	      loading = _ref.loading,
	      formats = _ref.formats,
	      nothing = _ref.nothing,
	      config = _ref.config,
	      converter = _ref.converter,
	      activeSource = _ref.activeSource,
	      formatMessage = _ref.intl.formatMessage;
	
	  var lastElem = data.length - 1;
	
	  var _ref2 = config.data.customOptions.providers[sources[0]] || {},
	      resources = _ref2.resources;
	
	  var showConverterLabel = Boolean(data.length > 0 && converter.label);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.container },
	    nothing ? _react2.default.createElement(
	      'h2',
	      null,
	      '-'
	    ) : _react2.default.createElement(
	      'div',
	      { className: _styles2.default.groups },
	      data.map(function (_ref3, i) {
	        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	            nameId = _ref4[0],
	            points = _ref4[1];
	
	        var _resources$nameId = resources[nameId],
	            resourceNameId = _resources$nameId[NAME_ID],
	            iconName = _resources$nameId[ICON];
	
	
	        return _react2.default.createElement(
	          'div',
	          { className: _styles2.default.item, key: nameId },
	          _react2.default.createElement(
	            'div',
	            null,
	            iconName && _react2.default.createElement(_Icon2.default, { size: 24, className: 'mr2', name: iconName }),
	            resourceNameId && formatMessage({ id: resourceNameId })
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            converter.func([points]),
	            i === lastElem && _react2.default.createElement(
	              'span',
	              null,
	              ' ',
	              mark
	            )
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(_styles2.default.sub, _styles2.default.dates) },
	      !loading ? _react2.default.createElement(
	        _react.Fragment,
	        null,
	        showConverterLabel && _react2.default.createElement(
	          'span',
	          { className: _styles2.default.label },
	          converter.label
	        ),
	        dates.join(' - ')
	      ) : '-'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.sub },
	      !activeSource ? formats.all : formats[activeSource]
	    )
	  );
	};
	
	MeasurementTitles.propTypes = {
	  data: _propTypes2.default.array,
	  mark: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  dates: _propTypes2.default.array,
	  nothing: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  sources: _propTypes2.default.array,
	  config: _propTypes2.default.object,
	  formats: _propTypes2.default.object,
	  converter: _propTypes2.default.object,
	  activeSource: _propTypes2.default.string,
	  intl: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(MeasurementTitles);

/***/ }),
/* 3823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _noop = __webpack_require__(465);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hooks = __webpack_require__(144);
	
	var _constants = __webpack_require__(114);
	
	var _helpers = __webpack_require__(289);
	
	var _styles = __webpack_require__(5185);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _MeasurementTitles = __webpack_require__(3822);
	
	var _MeasurementTitles2 = _interopRequireDefault(_MeasurementTitles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartHeader = function ChartHeader(_ref) {
	  var config = _ref.config,
	      nothing = _ref.nothing,
	      loading = _ref.loading,
	      noTabs = _ref.noTabs;
	
	  var _useChartContext = (0, _hooks.useChartContext)(),
	      mark = _useChartContext.mark,
	      period = _useChartContext.period,
	      sources = _useChartContext.sources,
	      formats = _useChartContext.formats,
	      setPeriod = _useChartContext.setPeriod,
	      activeSource = _useChartContext.activeSource,
	      _useChartContext$conv = _useChartContext.converter,
	      converter = _useChartContext$conv === undefined ? _noop2.default : _useChartContext$conv;
	
	  var filteredSources = activeSource && sources.includes(activeSource) ? [activeSource] : sources;
	
	  var data = (0, _react.useMemo)(function () {
	    return (0, _helpers.getVisibleData)(config, filteredSources);
	  }, [config, filteredSources]);
	
	  var dates = (0, _react.useMemo)(function () {
	    return (0, _helpers.getVisibleDates)(config, period);
	  }, [config, period]);
	  var measurementOptions = {
	    data: data,
	    mark: mark,
	    dates: dates,
	    config: config,
	    sources: sources,
	    loading: loading,
	    formats: formats,
	    nothing: nothing,
	    converter: converter,
	    period: period,
	    activeSource: activeSource
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_MeasurementTitles2.default, measurementOptions),
	    !noTabs && _react2.default.createElement(
	      'div',
	      { className: _styles2.default.periods },
	      (0, _entries2.default)(_constants.SYMBOL_BY_PERIOD).map(function (_ref2) {
	        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	            periodName = _ref3[0],
	            symbolName = _ref3[1];
	
	        return _react2.default.createElement(
	          'div',
	          {
	            'aria-hidden': true,
	            key: periodName,
	            onClick: function onClick() {
	              return setPeriod(periodName);
	            },
	            className: (0, _classnames2.default)(_styles2.default.period, (0, _defineProperty3.default)({}, _styles2.default.active, periodName === period))
	          },
	          symbolName
	        );
	      })
	    )
	  );
	};
	
	ChartHeader.propTypes = {
	  noTabs: _propTypes2.default.bool,
	  nothing: _propTypes2.default.bool,
	  loading: _propTypes2.default.bool,
	  config: _propTypes2.default.object
	};
	
	exports.default = ChartHeader;

/***/ }),
/* 3824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _noop = __webpack_require__(465);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hooks = __webpack_require__(144);
	
	var _helpers = __webpack_require__(289);
	
	var _styles = __webpack_require__(5186);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartHeaderFixed = function ChartHeaderFixed(_ref) {
	  var config = _ref.config;
	
	  var _useChartContext = (0, _hooks.useChartContext)(),
	      mark = _useChartContext.mark,
	      range = _useChartContext.range,
	      period = _useChartContext.period,
	      sources = _useChartContext.sources,
	      formats = _useChartContext.formats,
	      activeSource = _useChartContext.activeSource,
	      _useChartContext$conv = _useChartContext.converter,
	      converter = _useChartContext$conv === undefined ? _noop2.default : _useChartContext$conv;
	
	  var filteredSources = activeSource && sources.includes(activeSource) ? [activeSource] : sources;
	
	  var data = (0, _react.useMemo)(function () {
	    return (0, _helpers.getVisibleData)(config, filteredSources);
	  }, [config, filteredSources]);
	
	  var dates = (0, _react.useMemo)(function () {
	    return (0, _helpers.getVisibleDates)(config, period);
	  }, [config, period]);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.header },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        converter.func(Object.fromEntries(data)),
	        ' '
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)(_styles2.default.sub, _styles2.default.light) },
	        mark
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _styles2.default.info },
	      _react2.default.createElement(
	        'div',
	        { className: _styles2.default.sub },
	        range,
	        ' ',
	        dates.map(function (date) {
	          return date.toLowerCase();
	        }).join(' - ')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_styles2.default.sub, _styles2.default.light) },
	        !activeSource ? formats.all : formats[activeSource]
	      )
	    )
	  );
	};
	
	ChartHeaderFixed.propTypes = {
	  config: _propTypes2.default.object
	};
	
	exports.default = ChartHeaderFixed;

/***/ }),
/* 3825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _constants = __webpack_require__(114);
	
	var _hooks = __webpack_require__(144);
	
	var _styles = __webpack_require__(5187);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ICON = _constants.PROVIDER_OPTION.ICON,
	    ACTIVE_ICON = _constants.PROVIDER_OPTION.ACTIVE_ICON,
	    DISABLED_ICON = _constants.PROVIDER_OPTION.DISABLED_ICON,
	    SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.SINGLE_VALUE_ICON,
	    ACTIVE_SINGLE_VALUE_ICON = _constants.PROVIDER_OPTION.ACTIVE_SINGLE_VALUE_ICON;
	
	
	var ChartLegend = function ChartLegend(_ref) {
	  var config = _ref.config,
	      loading = _ref.loading,
	      isQuarterOrYear = _ref.isQuarterOrYear;
	
	  var _useChartContext = (0, _hooks.useChartContext)(),
	      chart = _useChartContext.chart,
	      sources = _useChartContext.sources,
	      formats = _useChartContext.formats,
	      activeSource = _useChartContext.activeSource,
	      setActiveSource = _useChartContext.setActiveSource;
	
	  (0, _react.useEffect)(function () {
	    setActiveSource(sources.length > 1 ? null : sources[0]);
	  }, [config, sources]);
	
	  var datasets = (0, _get2.default)(config, 'data.datasets', []);
	
	  var existsSource = function existsSource(source) {
	    return datasets.some(function (_ref2) {
	      var label = _ref2.label;
	      return label.startsWith(source);
	    });
	  };
	
	  var getIsSingleValue = function getIsSingleValue(source) {
	    return datasets.some(function (_ref3) {
	      var label = _ref3.label,
	          data = _ref3.data;
	      return label.startsWith(source) && (0, _compact2.default)(data).length === 1;
	    });
	  };
	
	  var toggleSource = function toggleSource(source) {
	    if (sources.length === 1) return;
	
	    datasets.forEach(function (_ref4, idx) {
	      var label = _ref4.label;
	
	      var meta = chart.getDatasetMeta(idx);
	
	      meta.hidden = source === activeSource ? false : !label.startsWith(source);
	      setActiveSource(source === activeSource ? null : source);
	
	      chart.update();
	    });
	  };
	
	  var getIconName = function getIconName(_ref5) {
	    var provider = _ref5.provider,
	        isActive = _ref5.isActive,
	        isDisabled = _ref5.isDisabled,
	        isSingleValue = _ref5.isSingleValue;
	    var icon = provider[ICON],
	        activeIcon = provider[ACTIVE_ICON],
	        disabledIcon = provider[DISABLED_ICON],
	        singleValueIcon = provider[SINGLE_VALUE_ICON],
	        activeSingleIcon = provider[ACTIVE_SINGLE_VALUE_ICON];
	
	
	    if (isDisabled) return disabledIcon || icon;
	    if (isActive && !isSingleValue) return activeIcon || icon;
	    if (isActive && isSingleValue) return activeSingleIcon || icon;
	    return isSingleValue && singleValueIcon ? singleValueIcon : icon;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _styles2.default.legend },
	    !loading && datasets.length > 0 && (0, _entries2.default)(config.data.customOptions.providers).map(function (_ref6) {
	      var _cn;
	
	      var _ref7 = (0, _slicedToArray3.default)(_ref6, 2),
	          providerCode = _ref7[0],
	          provider = _ref7[1];
	
	      var isActive = providerCode === activeSource;
	      var isDisabled = !existsSource(providerCode);
	      var isSingleValue = isQuarterOrYear && !isDisabled && getIsSingleValue(providerCode);
	      var iconName = getIconName({
	        provider: provider,
	        isActive: isActive,
	        isDisabled: isDisabled,
	        isSingleValue: isSingleValue
	      });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          'aria-hidden': true,
	          key: providerCode,
	          onClick: function onClick() {
	            return toggleSource(providerCode);
	          },
	          className: (0, _classnames2.default)(_styles2.default.item, (_cn = {}, (0, _defineProperty3.default)(_cn, _styles2.default.active, isActive), (0, _defineProperty3.default)(_cn, _styles2.default.disabled, isDisabled), (0, _defineProperty3.default)(_cn, _styles2.default.noclick, providerCode.length === 1), _cn))
	        },
	        _react2.default.createElement(_Icon2.default, { size: 24, className: 'mr2', name: iconName }),
	        formats[providerCode]
	      );
	    })
	  );
	};
	
	ChartLegend.propTypes = {
	  loading: _propTypes2.default.bool,
	  config: _propTypes2.default.object,
	  isQuarterOrYear: _propTypes2.default.bool
	};
	
	exports.default = ChartLegend;

/***/ }),
/* 3826 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PROVIDERS = exports.PROVIDERS = {
	  DEVICES: 'devices',
	  CCD: 'ccd',
	  ALL_SOURCES: 'all_sources',
	  LOCAL: 'local',
	  APPLE: 'apple',
	  FITBIT: 'fitbit',
	  WITHINGS: 'withings',
	  GOOGLE_FIT: 'google_fit',
	  TENOVI: 'tenovi',
	  I_HEALTH: 'ihealth'
	};
	
	var PROVIDER_ALL = exports.PROVIDER_ALL = 'all';
	
	var PROVIDER_OPTION = exports.PROVIDER_OPTION = {
	  ICON: 'icon',
	  NAME: 'name',
	  NAME_ID: 'name_id',
	  OPTIONS: 'options',
	  RESOURCES: 'resources',
	  ACTIVE_ICON: 'active_icon',
	  DISABLED_ICON: 'disabled_icon',
	  SINGLE_VALUE_ICON: 'single_value_icon',
	  ACTIVE_SINGLE_VALUE_ICON: 'active_single_value_icon'
	};

/***/ }),
/* 3827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HISTORY_DATE_FORMAT = exports.TOOLTIP_DATE_FORMAT = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TOOLTIP_DATE_FORMAT;
	
	var _period = __webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOOLTIP_DATE_FORMAT = exports.TOOLTIP_DATE_FORMAT = (_TOOLTIP_DATE_FORMAT = {}, (0, _defineProperty3.default)(_TOOLTIP_DATE_FORMAT, _period.PERIOD.DAY, 'MMM D, YYYY, h:mm A'), (0, _defineProperty3.default)(_TOOLTIP_DATE_FORMAT, _period.PERIOD.WEEK, 'MMM D, YYYY, h:mm A'), (0, _defineProperty3.default)(_TOOLTIP_DATE_FORMAT, _period.PERIOD.MONTH, 'MMM D, YYYY, h:mm A'), (0, _defineProperty3.default)(_TOOLTIP_DATE_FORMAT, _period.PERIOD.QUARTER, 'MMM D, YYYY'), (0, _defineProperty3.default)(_TOOLTIP_DATE_FORMAT, _period.PERIOD.YEAR, 'MMM D, YYYY'), _TOOLTIP_DATE_FORMAT);
	
	var HISTORY_DATE_FORMAT = exports.HISTORY_DATE_FORMAT = {
	  lastDay: 'MMM D, YYYY',
	  sameDay: 'MMM D',
	  sameElse: 'MMM D, YYYY',
	  lastWeek: 'MMM D, YYYY',
	  lastYear: 'MMM D, YYYY'
	};

/***/ }),
/* 3828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INTERVAL = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _INTERVAL;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _period = __webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INTERVAL = exports.INTERVAL = (_INTERVAL = {}, (0, _defineProperty3.default)(_INTERVAL, _period.PERIOD.DAY, function (date) {
	  return {
	    head: (0, _moment2.default)(date).startOf('day').toISOString(),
	    tail: (0, _moment2.default)(date).endOf('day').toISOString()
	  };
	}), (0, _defineProperty3.default)(_INTERVAL, _period.PERIOD.WEEK, function () {
	  return {
	    head: (0, _moment2.default)().startOf('day').subtract(6, 'day').toISOString(),
	    tail: (0, _moment2.default)().endOf('day').toISOString()
	  };
	}), (0, _defineProperty3.default)(_INTERVAL, _period.PERIOD.MONTH, function () {
	  return {
	    head: (0, _moment2.default)().startOf('day').subtract(1, 'month').toISOString(),
	    tail: (0, _moment2.default)().endOf('day').toISOString()
	  };
	}), (0, _defineProperty3.default)(_INTERVAL, _period.PERIOD.QUARTER, function () {
	  return {
	    head: (0, _moment2.default)().startOf('month').subtract(2, 'month').toISOString(),
	    tail: (0, _moment2.default)().endOf('month').toISOString()
	  };
	}), (0, _defineProperty3.default)(_INTERVAL, _period.PERIOD.YEAR, function () {
	  return {
	    head: (0, _moment2.default)().startOf('month').subtract(11, 'month').toISOString(),
	    tail: (0, _moment2.default)().endOf('month').toISOString()
	  };
	}), _INTERVAL);

/***/ }),
/* 3829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(3830);

/***/ }),
/* 3830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _chart = __webpack_require__(702);
	
	_chart.Chart.scaleService.registerScaleType('timecenter', _chart.Chart.scaleService.getScaleConstructor('time').extend({
	  getPixelForTick: function getPixelForTick(index) {
	    var ticks = this.getTicks();
	    // Get the pixel value for the current tick.
	    var px = this.getPixelForOffset(ticks[index].value);
	    // Get the next tick's pixel value.
	    var nextPx = this.right;
	    var nextTick = ticks[index + 1];
	    if (nextTick) nextPx = this.getPixelForOffset(nextTick.value);
	    // Align the labels in the middle of the current and next tick.
	    return px + (nextPx - px) / 2;
	  }
	}), _chart.Chart.scaleService.getScaleDefaults('time'));

/***/ }),
/* 3831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVisibleChartSources = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getVisibleChartSources = exports.getVisibleChartSources = function getVisibleChartSources(chart) {
	  return (0, _get2.default)(chart, 'data.datasets', []).reduce(function (sources, _ref, idx) {
	    var label = _ref.label;
	
	    var source = label.split('.')[0];
	    var meta = chart.getDatasetMeta(idx);
	
	    return !sources.includes(source) && !meta.hidden ? [].concat((0, _toConsumableArray3.default)(sources), [source]) : sources;
	  }, []);
	};

/***/ }),
/* 3832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVisibleData = undefined;
	
	var _map = __webpack_require__(160);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getVisibleData = exports.getVisibleData = function getVisibleData(config, sources) {
	  var visible = (0, _get2.default)(config, 'data.datasets', []).filter(function (_ref) {
	    var label = _ref.label;
	    return sources.includes(label.split('.')[0]);
	  }).reduce(function (res, _ref2) {
	    var label = _ref2.label,
	        data = _ref2.data;
	
	    var type = label.split('.')[1];
	
	    return res.set(type, [].concat((0, _toConsumableArray3.default)(res.get(type) || []), (0, _toConsumableArray3.default)(data)));
	  }, new _map2.default());
	
	  return [].concat((0, _toConsumableArray3.default)(visible.entries()));
	};

/***/ }),
/* 3833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVisibleDates = undefined;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getVisibleDates = exports.getVisibleDates = function getVisibleDates(config, period) {
	  var labels = (0, _get2.default)(config, 'data.labels', []);
	
	  var _ref = [labels[0], labels[labels.length - 1]],
	      head = _ref[0],
	      tail = _ref[1];
	
	
	  switch (period) {
	    case _constants.PERIOD.DAY:
	      return [(0, _moment2.default)(head).format('MMM D, YYYY')];
	    case _constants.PERIOD.WEEK:
	    case _constants.PERIOD.MONTH:
	      return [(0, _moment2.default)(head).format('MMM D, YYYY'), (0, _moment2.default)(tail).format('MMM D, YYYY')];
	    case _constants.PERIOD.QUARTER:
	    case _constants.PERIOD.YEAR:
	      return [(0, _moment2.default)(head).format('MMM, YYYY'), (0, _moment2.default)(tail).format('MMM, YYYY')];
	    default:
	      return [];
	  }
	};

/***/ }),
/* 3834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapChartData = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _map = __webpack_require__(160);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _map3 = __webpack_require__(5509);
	
	var _map4 = _interopRequireDefault(_map3);
	
	var _mapValues = __webpack_require__(1559);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _constants = __webpack_require__(114);
	
	var _utils = __webpack_require__(78);
	
	var _styles = __webpack_require__(18);
	
	var _period = __webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// LABELS
	
	/* eslint-disable */
	var getLabel = function getLabel(date, unit) {
	  if (!unit) return (0, _moment2.default)(date).toISOString();
	
	  return (0, _moment2.default)(date).startOf(unit).toISOString();
	};
	
	var getLabels = function getLabels(head, tail, unit) {
	  var diff = (0, _moment2.default)(tail).diff(head, unit) + 1;
	
	  if (!unit) return new _map2.default().set(head, []).set(tail, []);
	
	  var res = [].concat((0, _toConsumableArray3.default)(Array(diff))).reduce(function (labels, _, idx) {
	    return labels.set((0, _moment2.default)(head).add(idx, unit).toISOString(), []);
	  }, new _map2.default());
	
	  return res;
	};
	
	// DATA
	var OPTIONS = _constants.PROVIDER_OPTION.OPTIONS,
	    RESOURCES = _constants.PROVIDER_OPTION.RESOURCES;
	var mapChartData = exports.mapChartData = function mapChartData(data, customOptions) {
	  var unit = customOptions.unit,
	      date = customOptions.date,
	      range = customOptions.range,
	      period = customOptions.period,
	      providers = customOptions.providers,
	      shouldConvertToFahrenheit = customOptions.shouldConvertToFahrenheit;
	
	  var _INTERVAL$period = _constants.INTERVAL[period](date),
	      head = _INTERVAL$period.head,
	      tail = _INTERVAL$period.tail;
	
	  var labels = getLabels(head, tail, unit);
	
	  var sources = data.reduce(function (results, _ref) {
	    var provider = _ref.provider,
	        measurements = _ref.measurements;
	    return (0, _values2.default)(_constants.PROVIDERS).includes(provider.code) ? (0, _extends4.default)({}, results, (0, _defineProperty3.default)({}, provider.code, measurements.reduce(function (indicators, _ref2) {
	      var values = _ref2.value,
	          measuredAt = _ref2.measuredAt;
	
	      var label = getLabel(measuredAt, unit);
	
	      if (!unit) labels.set(label, []);
	
	      (0, _entries2.default)(values).forEach(function (_ref3) {
	        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	            name = _ref4[0],
	            value = _ref4[1];
	
	        var indicator = indicators[name] || new _map2.default();
	
	        indicators[name] = indicator.set(label, [].concat((0, _toConsumableArray3.default)(indicator.get(label) || []), [value]));
	      });
	
	      return indicators;
	    }, {}))) : results;
	  }, {});
	
	  labels = new _map2.default([].concat((0, _toConsumableArray3.default)(labels)).sort(function (_ref5, _ref6) {
	    var _ref8 = (0, _slicedToArray3.default)(_ref5, 1),
	        prev = _ref8[0];
	
	    var _ref7 = (0, _slicedToArray3.default)(_ref6, 1),
	        next = _ref7[0];
	
	    return (0, _moment2.default)(prev) - (0, _moment2.default)(next);
	  }));
	
	  sources = (0, _mapValues2.default)(sources, function (source) {
	    return (0, _mapValues2.default)(source, function (values) {
	      return new _map2.default([].concat((0, _toConsumableArray3.default)(labels), (0, _toConsumableArray3.default)(values)));
	    });
	  });
	
	  var datasets = (0, _map4.default)(sources, function (values, providerCode) {
	    return (0, _map4.default)(values, function (vals, resourceName) {
	      var data = shouldConvertToFahrenheit ? [].concat((0, _toConsumableArray3.default)(vals.values())).map(function (v) {
	        return range ? range(v) || null : v;
	      }).map(function (v) {
	        return v ? (0, _utils.convertCelsiusToFahrenheit)(v) : v;
	      }) : [].concat((0, _toConsumableArray3.default)(vals.values())).map(function (v) {
	        return range ? range(v) || null : v;
	      });
	      return (0, _extends4.default)({}, providers[providerCode][RESOURCES][resourceName][OPTIONS][period], {
	        label: providerCode + '.' + resourceName,
	        data: data
	      }, (0, _compact2.default)(data).length === 1 && [_period.PERIOD.QUARTER, _period.PERIOD.YEAR].includes(period) && {
	        pointRadius: 3.5,
	        pointHoverRadius: 3.5,
	        hoverBackgroundColor: _styles.COLORS.orangeRed,
	        hoverBorderColor: _styles.COLORS.orangeRed,
	        hoverBorderWidth: 1.5,
	        hoverBorderRadius: 0
	      });
	    });
	  }).flat();
	
	  return { customOptions: customOptions, datasets: datasets, labels: [].concat((0, _toConsumableArray3.default)(labels.keys())) };
	};

/***/ }),
/* 3835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapHistoryList = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _map = __webpack_require__(160);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isArray = __webpack_require__(96);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _mergeWith = __webpack_require__(5512);
	
	var _mergeWith2 = _interopRequireDefault(_mergeWith);
	
	var _constants = __webpack_require__(114);
	
	var _utils = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extendTarget = function extendTarget(target, value) {
	  if ((0, _isArray2.default)(target)) return target.concat(value);
	}; /* eslint-disable */
	
	
	var isSameDay = function isSameDay(firstDate, secondDate) {
	  return (0, _moment2.default)(firstDate).isSame(secondDate, 'day');
	};
	
	var itemWithConvertedProviderCode = function itemWithConvertedProviderCode(el) {
	  return (0, _extends4.default)({}, el, {
	    providerCode: el.providerCode === _constants.PROVIDERS.DEVICES ? (0, _utils.getOriginalProviderCode)(el.originalProviderCodes) : el.providerCode
	  });
	};
	
	var mapHistoryList = exports.mapHistoryList = function mapHistoryList() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isModal = arguments[2];
	  var unit = options.unit;
	
	  var convertedData = data.map(itemWithConvertedProviderCode);
	  var flat = convertedData && convertedData[0] && convertedData[0].measurements ? convertedData.reduce(function (res, _ref) {
	    var measurements = _ref.measurements;
	    return res.concat(measurements);
	  }, []) : convertedData;
	
	  var safeMeasurements = isModal ? flat.map(itemWithConvertedProviderCode) : flat.map(function (item) {
	    return flat.some(function (source) {
	      return isSameDay(item.measuredAt, source.measuredAt) && item.providerCode !== source.providerCode;
	    }) ? (0, _extends4.default)({}, item, { providerCode: _constants.PROVIDER_ALL }) : item;
	  });
	
	  var sources = safeMeasurements.reduce(function (providers, _ref2) {
	    var measuredAt = _ref2.measuredAt,
	        values = _ref2.value,
	        code = _ref2.providerCode;
	
	    var parsed = _moment2.default.parseZone(measuredAt);
	    var date = (!unit ? parsed : parsed.startOf(unit)).toISOString();
	
	    var provider = providers.get(code) || new _map2.default();
	    var measurements = provider.get(date) || new Object();
	
	    var newMeasurements = (0, _entries2.default)(values).reduce(function (res, _ref3) {
	      var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
	          name = _ref4[0],
	          value = _ref4[1];
	
	      var prevValue = res[name] || [];
	      return (0, _extends4.default)({}, res, (0, _defineProperty3.default)({}, name, [].concat((0, _toConsumableArray3.default)(prevValue), [value])));
	    }, {});
	
	    var merged = (0, _mergeWith2.default)(measurements, newMeasurements, extendTarget);
	    return providers.set(code, provider.set(date, merged));
	  }, new _map2.default());
	
	  return [].concat((0, _toConsumableArray3.default)(sources)).map(function (_ref5) {
	    var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
	        source = _ref6[0],
	        values = _ref6[1];
	
	    return [].concat((0, _toConsumableArray3.default)(values)).map(function (_ref7) {
	      var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
	          date = _ref8[0],
	          values = _ref8[1];
	
	      return { date: date, source: source, values: values };
	    });
	  }).reduce(function (results, source) {
	    return results.concat(source);
	  }, []).sort(function (_ref9, _ref10) {
	    var prev = _ref9.date;
	    var next = _ref10.date;
	    return (0, _moment2.default)(next) - (0, _moment2.default)(prev);
	  });
	};

/***/ }),
/* 3836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useChartActions = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useChartActions = exports.useChartActions = function useChartActions(_ref) {
	  var actions = _ref.actions,
	      modalActions = _ref.modalActions;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isModal = _useState2[0],
	      setModalVisible = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      baseDate = _useState4[0],
	      setBaseDate = _useState4[1];
	
	  var targetUserId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	  var loggedUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	
	  var userId = targetUserId || loggedUserId;
	
	  var loadPeriod = function loadPeriod(_ref2) {
	    var period = _ref2.period;
	    return dispatch(actions.send({ userId: userId, period: period }));
	  };
	
	  var openDay = function openDay(_ref3) {
	    var date = _ref3.date;
	
	    setModalVisible(true);
	    setBaseDate(date);
	    dispatch(modalActions.send({ userId: userId, baseDate: date, period: 'day' }));
	  };
	
	  var closeDay = function closeDay() {
	    setModalVisible(false);
	    setBaseDate(null);
	    dispatch(modalActions.clear());
	  };
	
	  return { isModal: isModal, openDay: openDay, closeDay: closeDay, baseDate: baseDate, loadPeriod: loadPeriod };
	};

/***/ }),
/* 3837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useChartContext = undefined;
	
	var _react = __webpack_require__(1);
	
	var _context = __webpack_require__(1822);
	
	var useChartContext = exports.useChartContext = function useChartContext() {
	  return (0, _react.useContext)(_context.ChartContext);
	};

/***/ }),
/* 3838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useHistoryActions = undefined;
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(23);
	
	var _historicMeasurementsReq = __webpack_require__(428);
	
	var historicMeasurements = _interopRequireWildcard(_historicMeasurementsReq);
	
	var _selectors2 = __webpack_require__(109);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var useHistoryActions = exports.useHistoryActions = function useHistoryActions(_ref) {
	  var type = _ref.type;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var targetUserId = (0, _reactRedux.useSelector)(_selectors.targetUserIdSelector);
	  var loggedUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	  var previousDate = (0, _reactRedux.useSelector)(_selectors2.selectHistoricMeasurementsPreviousDate);
	
	  var userId = targetUserId || loggedUserId;
	
	  var loadHistory = function loadHistory() {
	    return dispatch(historicMeasurements.actions.send({
	      userId: userId,
	      typeMeasurements: type,
	      periodStartDate: previousDate
	    }));
	  };
	
	  return { loadHistory: loadHistory };
	};

/***/ }),
/* 3839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useSafeDataSourceTitle = undefined;
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _selectors = __webpack_require__(23);
	
	var _constants = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useSafeDataSourceTitle = exports.useSafeDataSourceTitle = function useSafeDataSourceTitle() {
	  var isNotShowName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var loggedUser = (0, _reactRedux.useSelector)(_selectors.loggedUserSelector);
	  var targetUser = (0, _reactRedux.useSelector)(_selectors.targetUserSelector);
	  var isMeNotTargetUser = !isNotShowName && loggedUser.id !== targetUser.id && !(0, _isEmpty2.default)(targetUser);
	  var name = (0, _get2.default)(targetUser, 'firstName', '');
	  var concatWithName = function concatWithName(device) {
	    if (isMeNotTargetUser) {
	      return name + '\'s ' + device;
	    }
	    return device;
	  };
	
	  var getSafeDataSourceTitle = function getSafeDataSourceTitle(dataSourceType, formatMessage, mainUser, arDevicesTitle) {
	    var stepsOrDistance = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	    if (stepsOrDistance) {
	      return mainUser ? formatMessage({ id: 'patient.healthboard.myDevices' }) : arDevicesTitle + '\u2019s ' + formatMessage({
	        id: 'patient.healthboard.devices'
	      });
	    }
	
	    switch (dataSourceType) {
	      case _constants.DATA_SOURCE_TYPE.DEVICES:
	        {
	          return mainUser ? formatMessage({ id: 'patient.healthboard.myDevices' }) : arDevicesTitle + '\u2019s ' + formatMessage({
	            id: 'patient.healthboard.devices'
	          });
	        }
	      case _constants.DATA_SOURCE_TYPE.CCD:
	        {
	          return formatMessage({ id: 'patient.healthboard.ccd' });
	        }
	      case _constants.DATA_SOURCE_TYPE.ALL_SOURCES:
	        {
	          return formatMessage({ id: 'patient.healthboard.allSources' });
	        }
	      case _constants.DATA_SOURCE_TYPE.LOCAL:
	        {
	          return formatMessage({ id: 'patient.healthboard.local' });
	        }
	      case _constants.DATA_SOURCE_TYPE.FITBIT:
	        {
	          return concatWithName(formatMessage({ id: 'patient.healthboard.fitBit' }));
	        }
	      case _constants.DATA_SOURCE_TYPE.APPLE:
	        {
	          return concatWithName(formatMessage({ id: 'patient.healthboard.apple' }));
	        }
	      case _constants.DATA_SOURCE_TYPE.WITHINGS:
	        {
	          return concatWithName(formatMessage({ id: 'patient.healthboard.withings' }));
	        }
	      case _constants.DATA_SOURCE_TYPE.GOOGLE_FIT:
	        {
	          return concatWithName(formatMessage({ id: 'patient.healthboard.googleFit' }));
	        }
	      case _constants.DATA_SOURCE_TYPE.TENOVI:
	        {
	          return concatWithName(formatMessage({ id: 'patient.healthboard.tenovi' }));
	        }
	      case _constants.DATA_SOURCE_TYPE.I_HEALTH:
	        {
	          return concatWithName(formatMessage({ id: 'patient.healthboard.iHealth' }));
	        }
	      default:
	        return '';
	    }
	  };
	
	  return { getSafeDataSourceTitle: getSafeDataSourceTitle };
	};

/***/ }),
/* 3840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.POINT_WITHOUT_HOVER = exports.DEFAULTS = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _tooltip = __webpack_require__(1826);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULTS = exports.DEFAULTS = {
	  legend: false,
	  responsive: true,
	  maintainAspectRatio: false,
	  layout: {
	    padding: {
	      left: 0,
	      top: 140,
	      right: 0,
	      bottom: 47
	    }
	  },
	  animation: {
	    duration: 0
	  },
	  tooltips: (0, _extends3.default)({
	    mode: 'index',
	    intersect: false
	  }, _tooltip.TOOLTIP),
	  hover: {
	    mode: 'index'
	  },
	  scales: {
	    xAxes: [{
	      gridLines: {
	        display: false,
	        offsetGridLines: true
	      },
	      ticks: {
	        padding: 5,
	        fontSize: 13,
	        autoSkip: true,
	        maxRotation: 0,
	        autoSkipPadding: 20,
	        fontColor: _styles.COLORS.bluePrimary,
	        callback: function callback(tick) {
	          return tick.toUpperCase();
	        },
	        fontFamily: _styles.FONT_FAMILY.primary
	      }
	    }],
	    yAxes: [{
	      position: 'right',
	      gridLines: {
	        drawBorder: false,
	        borderDash: [2, 4],
	        tickMarkLength: 25,
	        color: _styles.COLORS.lightGray
	      },
	      ticks: {
	        padding: 25,
	        stepSize: 1,
	        mirror: true,
	        fontSize: 12,
	        labelOffset: -10,
	        fontColor: _styles.COLORS.cyanBluishGray,
	        fontFamily: _styles.FONT_FAMILY.primary
	      }
	    }]
	  }
	};
	
	var POINT_WITHOUT_HOVER = exports.POINT_WITHOUT_HOVER = {
	  radius: 0,
	  hoverRadius: 0,
	  pointRadius: 0
	};

/***/ }),
/* 3841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TOOLTIP_VERTICAL_LINE = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOOLTIP_VERTICAL_LINE = exports.TOOLTIP_VERTICAL_LINE = {
	  beforeDraw: function beforeDraw(chart) {
	    if (!(0, _get2.default)(chart, 'config.data.customOptions.tooltip.showVerticalLine', false) || !(0, _get2.default)(chart, 'tooltip._active.length', false) || !chart.options.tooltips.enabled) {
	      return;
	    }
	
	    var _chart$controller$too = chart.controller.tooltip._active[0].tooltipPosition(),
	        x = _chart$controller$too.x;
	
	    var ctx = chart.ctx;
	
	    var yAxisName = (0, _keys2.default)(chart.scales).find(function (axis) {
	      return axis.startsWith('y-axis');
	    });
	    var bottom = chart.scales[yAxisName].bottom;
	
	
	    ctx.save();
	    ctx.beginPath();
	    ctx.moveTo(x, 100);
	    ctx.lineTo(x, bottom + 2);
	    ctx.lineWidth = 0.5;
	    ctx.strokeStyle = '#e5e5e5';
	    ctx.stroke();
	    ctx.restore();
	  }
	}; /* eslint-disable no-underscore-dangle */

/***/ }),
/* 3842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Card = __webpack_require__(112);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _TextMessageForm = __webpack_require__(1197);
	
	var _TextMessageForm2 = _interopRequireDefault(_TextMessageForm);
	
	var _strings = __webpack_require__(15);
	
	var _styles = __webpack_require__(18);
	
	var _chat = __webpack_require__(67);
	
	var _styles2 = __webpack_require__(5192);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sendMessageIconStyle = { fill: _styles.COLORS.fontPrimary };
	
	var CollapsedSendMessageItem = function CollapsedSendMessageItem(_ref) {
	  var profile = _ref.profile,
	      withLine = _ref.withLine,
	      onSubmit = _ref.onSubmit,
	      formatMessage = _ref.intl.formatMessage;
	
	  var userName = (0, _get2.default)(profile, 'username');
	  var displayableName = (0, _get2.default)(profile, 'displayableName', userName);
	  var avatar = (0, _get2.default)(profile, 'avatar.thumbMin');
	  var role = (0, _get2.default)(profile, 'role');
	  var formattedRole = role ? formatMessage({ id: 'circles.roles.' + role }) : '';
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      showTextField = _useState2[0],
	      toggleTextField = _useState2[1];
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: (0, _classnames2.default)('root', { 'root--bottomLine': withLine }) },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'heading' },
	      profile ? _react2.default.createElement(_Card2.default, {
	        text: {
	          primary: displayableName,
	          complementary: formattedRole
	        },
	        additionalContent: {
	          left: _react2.default.createElement(_Avatar2.default, { children: displayableName, size: 36, src: avatar })
	        }
	      }) : null,
	      _chat.ALLOW_SOCIAL_CHAT_CREATION ? _react2.default.createElement(
	        'div',
	        {
	          styleName: 'sendMessage',
	          onClick: function onClick() {
	            return toggleTextField(!showTextField);
	          }
	        },
	        _react2.default.createElement(_Icon2.default, { name: 'comment', style: sendMessageIconStyle }),
	        _react2.default.createElement(
	          'span',
	          { styleName: 'sendMessage__text' },
	          formatMessage(_strings.ACTIONS.chat.sendMessage)
	        )
	      ) : null
	    ),
	    showTextField ? _react2.default.createElement(_TextMessageForm2.default, {
	      onSendMessage: onSubmit,
	      formatMessage: formatMessage,
	      onClose: function onClose() {
	        return toggleTextField(false);
	      }
	    }) : null
	  );
	};
	
	CollapsedSendMessageItem.propTypes = {
	  withLine: PropTypes.bool,
	  profile: PropTypes.object,
	  onSubmit: PropTypes.func,
	  intl: PropTypes.shape({
	    formatMessage: PropTypes.func
	  }).isRequired
	};
	
	CollapsedSendMessageItem.defaultProps = {
	  onSubmit: function onSubmit() {}
	};
	
	exports.default = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_styles3.default, { allowMultiple: true }))(CollapsedSendMessageItem);

/***/ }),
/* 3843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _reactIntl = __webpack_require__(5);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CollapsedSendMessageItem = __webpack_require__(3842);
	
	var _CollapsedSendMessageItem2 = _interopRequireDefault(_CollapsedSendMessageItem);
	
	var _styles = __webpack_require__(18);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CollapsedSendMessagePopup = function CollapsedSendMessagePopup(_ref) {
	  var profiles = _ref.profiles,
	      icon = _ref.icon,
	      description = _ref.description,
	      opened = _ref.opened,
	      loading = _ref.loading,
	      onClose = _ref.onClose,
	      _onSubmit = _ref.onSubmit,
	      formatMessage = _ref.intl.formatMessage;
	
	  var profilesSize = (0, _size2.default)(profiles) - 1;
	
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { maxWidth: _styles.BREAKPOINT },
	    function (isMobile) {
	      return _react2.default.createElement(
	        _Popup2.default,
	        {
	          opened: opened,
	          onClose: onClose,
	          width: isMobile ? 'medium' : 'xsmall',
	          enabled: true
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'pl3 pr3 pb3' },
	          _react2.default.createElement(
	            'div',
	            { className: 'flex flex-column items-center' },
	            icon ? _react2.default.createElement(_Icon2.default, { className: 'mb3', name: icon, height: 48, width: 48 }) : null,
	            description ? _react2.default.createElement(
	              'span',
	              { className: 'mb3 tc' },
	              description
	            ) : null
	          ),
	          loading && _react2.default.createElement(_Loader2.default, null),
	          profiles.map(function (item, i) {
	            return _react2.default.createElement(_CollapsedSendMessageItem2.default, {
	              key: item.id,
	              profile: item,
	              withLine: i !== profilesSize,
	              onSubmit: function onSubmit(message) {
	                return _onSubmit(message, item.id);
	              }
	            });
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'mt3 flex flex-column items-center' },
	            _react2.default.createElement(
	              _Button2.default,
	              { color: 'primary', raised: true, onClick: onClose },
	              formatMessage({ id: 'submit.expiredToken' })
	            )
	          )
	        )
	      );
	    }
	  );
	};
	
	CollapsedSendMessagePopup.propTypes = {
	  profiles: PropTypes.array,
	  icon: PropTypes.string,
	  description: PropTypes.string,
	  loading: PropTypes.bool,
	  opened: PropTypes.bool,
	  onClose: PropTypes.func,
	  onSubmit: PropTypes.func,
	  intl: PropTypes.shape({
	    formatMessage: PropTypes.func
	  }).isRequired
	};
	
	CollapsedSendMessagePopup.defaultProps = {
	  profiles: []
	};
	
	exports.default = (0, _reactIntl.injectIntl)(CollapsedSendMessagePopup);

/***/ }),
/* 3844 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _styles = __webpack_require__(18);
	
	exports.default = {
	  root: {
	    fontFamily: _styles.FONT_FAMILY.primary,
	    textTransform: 'initial',
	    paddingLeft: 0,
	    fontWeight: 400
	  },
	  label: {
	    fontSize: 14,
	    lineHeight: 1.5,
	    paddingLeft: 0
	  },
	  appBar: {
	    background: 'transparent',
	    border: 0,
	    boxShadow: 'none',
	    flexFlow: 'row',
	    justifyContent: 'space-between',
	    alignItems: 'center'
	  }
	};

/***/ }),
/* 3845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Tooltip = __webpack_require__(1847);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _RenderTemporary = __webpack_require__(1170);
	
	var _RenderTemporary2 = _interopRequireDefault(_RenderTemporary);
	
	var _styles = __webpack_require__(18);
	
	var _index = __webpack_require__(5193);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CopyToClipboard = function CopyToClipboard(_ref) {
	  var title = _ref.title,
	      link = _ref.link,
	      buttonText = _ref.buttonText,
	      copySuccessText = _ref.copySuccessText;
	
	  var textareaRef = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      copySuccess = _useState2[0],
	      setCopySuccess = _useState2[1];
	
	  var copyToClipboard = function copyToClipboard() {
	    textareaRef.current.select();
	    document.execCommand('copy');
	    setCopySuccess(true);
	  };
	
	  var tooltipContent = function tooltipContent() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'flex items-start' },
	      _react2.default.createElement(_Icon2.default, { name: 'success', size: 12, style: { fill: _styles.COLORS.greenLime } }),
	      _react2.default.createElement(
	        'div',
	        { className: 'ml2' },
	        _react2.default.createElement(
	          'p',
	          { className: 'f-14' },
	          copySuccessText
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'f-12' },
	          link
	        )
	      )
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(
	      'span',
	      null,
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'content' },
	      _react2.default.createElement(
	        'div',
	        { styleName: 'input' },
	        _react2.default.createElement(_TextInput2.default, {
	          name: 'text',
	          rounded: true,
	          type: 'text',
	          value: link,
	          readOnly: true,
	          setRef: textareaRef,
	          className: 'flex-grow-1'
	        })
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { color: 'primary', raised: true, type: 'button', onClick: copyToClipboard },
	        buttonText
	      ),
	      _react2.default.createElement(
	        _RenderTemporary2.default,
	        { rendered: copySuccess, timeout: 2000 },
	        _react2.default.createElement(_Tooltip2.default, {
	          content: tooltipContent(),
	          top: 15,
	          left: 0,
	          width: 250,
	          open: true
	        })
	      )
	    )
	  );
	};
	
	CopyToClipboard.propTypes = {
	  title: _propTypes2.default.string,
	  link: _propTypes2.default.string,
	  buttonText: _propTypes2.default.string,
	  copySuccessText: _propTypes2.default.string
	};
	
	CopyToClipboard.defaultProps = {
	  title: null,
	  link: null,
	  buttonText: null,
	  copySuccessText: null
	};
	
	exports.default = (0, _reactCssModules2.default)(CopyToClipboard, _index2.default, { allowMultiple: true });

/***/ }),
/* 3846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CropModal = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(581);
	
	var _reactIntl = __webpack_require__(5);
	
	var _recompose = __webpack_require__(22);
	
	var _reactCropper = __webpack_require__(5802);
	
	var _reactCropper2 = _interopRequireDefault(_reactCropper);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _styles2 = __webpack_require__(3847);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CropModalImpl = function CropModalImpl(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      onImageCrop = _ref.onImageCrop,
	      onClose = _ref.onClose,
	      aspectRatio = _ref.aspectRatio,
	      title = _ref.title,
	      tip = _ref.tip,
	      image = _ref.image,
	      rounded = _ref.rounded,
	      classes = _ref.classes;
	
	  var cropperRef = (0, _react.useRef)();
	
	  var handleSubmit = (0, _react.useCallback)(function () {
	    var data = cropperRef.current.cropper.getCroppedCanvas().toDataURL();
	    onImageCrop(data);
	    onClose();
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Popup2.default,
	      {
	        strictClose: true,
	        footerEnd: true,
	        customControls: true,
	        enabled: true,
	        submitText: formatMessage({ id: 'common.save' }),
	        title: title,
	        onClose: onClose,
	        onSubmit: handleSubmit,
	        opened: !!image
	      },
	      _react2.default.createElement(_reactCropper2.default, {
	        ref: cropperRef,
	        minCropBoxWidth: 50,
	        minCropBoxHeight: 50,
	        aspectRatio: aspectRatio,
	        className: (0, _classnames2.default)(classes.cropper, (0, _defineProperty3.default)({}, classes.rounded, rounded)),
	        src: image
	      }),
	      tip && _react2.default.createElement(
	        'p',
	        { className: classes.tip },
	        tip
	      )
	    )
	  );
	};
	
	var CropModal = exports.CropModal = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _styles.withStyles)(_styles2.styles))(CropModalImpl);
	
	var propsTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  onImageCrop: _propTypes2.default.func.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.string.isRequired,
	  tip: _propTypes2.default.string,
	  rounded: _propTypes2.default.bool,
	  aspectRatio: _propTypes2.default.number
	};
	
	var defaultProps = {
	  onImageCrop: function onImageCrop() {},
	  aspectRatio: 1,
	  rounded: false,
	  tip: '',
	  image: ''
	};
	
	CropModalImpl.propTypes = (0, _extends3.default)({
	  classes: _propTypes2.default.object.isRequired
	}, propsTypes);
	CropModalImpl.defaultProps = (0, _extends3.default)({}, defaultProps);
	
	CropModal.propTypes = propsTypes;
	CropModal.defaultProps = defaultProps;

/***/ }),
/* 3847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _styles = __webpack_require__(18);
	
	var styles = exports.styles = {
	  cropper: {
	    '& .cropper-modal': {
	      background: _styles.COLORS.black
	    },
	    '& .cropper-line': {
	      background: 'transparent'
	    },
	    '& .cropper-point': {
	      background: '#fff'
	    },
	    '& .cropper-view-box': {
	      outlineColor: _styles.COLORS.white
	    }
	  },
	  tip: {
	    marginTop: 15
	  },
	  rounded: {
	    '& .cropper-view-box': {
	      borderRadius: '100%',
	      outlineColor: 'rgba(255, 255, 255, 0.5)'
	    }
	  }
	};

/***/ }),
/* 3848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomToastsContainer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactToastify = __webpack_require__(2827);
	
	var _styles = __webpack_require__(18);
	
	var _IconButton = __webpack_require__(605);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CloseButton = function CloseButton(_ref) {
	  var closeToast = _ref.closeToast;
	  return _react2.default.createElement(_IconButton.IconButton, { onClick: closeToast, name: 'close', size: 12, fill: _styles.COLORS.white });
	};
	
	var CustomToastsContainer = exports.CustomToastsContainer = function CustomToastsContainer() {
	  return _react2.default.createElement(_reactToastify.ToastContainer, {
	    position: 'bottom-right',
	    pauseOnVisibilityChange: true,
	    draggable: true,
	    closeButton: _react2.default.createElement(CloseButton, null)
	  });
	};
	
	CloseButton.propTypes = {
	  closeToast: PropTypes.func
	};

/***/ }),
/* 3849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DatePickerRange = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDateRange = __webpack_require__(5934);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerRange = exports.DatePickerRange = function DatePickerRange(_ref) {
	  var startDateRange = _ref.startDateRange,
	      setStartDateRange = _ref.setStartDateRange,
	      disabledMaxDate = _ref.disabledMaxDate,
	      endDateRange = _ref.endDateRange,
	      setEndDateRange = _ref.setEndDateRange,
	      months = _ref.months,
	      direction = _ref.direction,
	      rangeColors = _ref.rangeColors,
	      className = _ref.className,
	      shownDate = _ref.shownDate;
	
	  var handleSelect = (0, _react.useCallback)(function (_ref2) {
	    var _ref2$selection = _ref2.selection,
	        startDate = _ref2$selection.startDate,
	        endDate = _ref2$selection.endDate;
	
	    setStartDateRange(startDate);
	    setEndDateRange(endDate);
	  });
	
	  var ranges = (0, _react.useMemo)(function () {
	    return [{
	      startDate: startDateRange,
	      endDate: endDateRange,
	      key: 'selection'
	    }];
	  }, [startDateRange, endDateRange]);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactDateRange.DateRange, {
	      dateDisplayFormat: 'YYYY.MM.DD',
	      fixedHeight: true,
	      ranges: ranges,
	      onChange: handleSelect,
	      showDateDisplay: false,
	      months: months,
	      rangeColors: rangeColors,
	      direction: direction,
	      className: className,
	      weekdayDisplayFormat: 'EEEEE',
	      monthDisplayFormat: 'MMMM yyyy',
	      maxDate: disabledMaxDate,
	      shownDate: shownDate
	    })
	  );
	};
	
	DatePickerRange.propTypes = {
	  startDateRange: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  setStartDateRange: _propTypes2.default.func.isRequired,
	  endDateRange: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  setEndDateRange: _propTypes2.default.func.isRequired,
	  months: _propTypes2.default.number,
	  direction: _propTypes2.default.string,
	  rangeColors: _propTypes2.default.array,
	  className: _propTypes2.default.string,
	  disabledMaxDate: _propTypes2.default.object,
	  shownDate: _propTypes2.default.object
	};

/***/ }),
/* 3850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _class2, _temp; /* eslint-disable react/require-default-props,react/prop-types */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactClickOutside = __webpack_require__(1001);
	
	var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Paper = __webpack_require__(156);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Controls = __webpack_require__(333);
	
	var _Controls2 = _interopRequireDefault(_Controls);
	
	var _ControlsItem = __webpack_require__(394);
	
	var _ControlsItem2 = _interopRequireDefault(_ControlsItem);
	
	var _strings = __webpack_require__(15);
	
	var _styles = __webpack_require__(18);
	
	var _ids = __webpack_require__(46);
	
	var _index = __webpack_require__(5198);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dialog = (_dec = (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }), (0, _reactClickOutside2.default)(_class = _dec(_class = (_temp = _class2 = function (_PureComponent) {
	  (0, _inherits3.default)(Dialog, _PureComponent);
	
	  function Dialog() {
	    (0, _classCallCheck3.default)(this, Dialog);
	    return (0, _possibleConstructorReturn3.default)(this, (Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Dialog, [{
	    key: 'handleClickOutside',
	    value: function handleClickOutside(e) {
	      var _props = this.props,
	          onClose = _props.onClose,
	          strictClose = _props.strictClose;
	
	      !strictClose && onClose && onClose(e); // eslint-disable-line no-unused-expressions
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          mobileFullScreen = _props2.mobileFullScreen,
	          onClose = _props2.onClose,
	          title = _props2.title,
	          white = _props2.white,
	          contentWhite = _props2.contentWhite,
	          contentNoPadding = _props2.contentNoPadding,
	          width = _props2.width,
	          withHeading = _props2.withHeading,
	          controls = _props2.controls,
	          onAdd = _props2.onAdd,
	          enabled = _props2.enabled,
	          customControls = _props2.customControls,
	          submitText = _props2.submitText,
	          cancelText = _props2.cancelText,
	          onSubmit = _props2.onSubmit,
	          footerCentered = _props2.footerCentered,
	          footerEnd = _props2.footerEnd,
	          buttonWidth = _props2.buttonWidth,
	          isLayoutColumn = _props2.isLayoutColumn,
	          submitBtnColor = _props2.submitBtnColor,
	          overflowVisible = _props2.overflowVisible,
	          autoHeight = _props2.autoHeight,
	          subTitle = _props2.subTitle,
	          withoutAdaptive = _props2.withoutAdaptive,
	          dialogClassName = _props2.dialogClassName,
	          paperClassName = _props2.paperClassName,
	          dialogHeaderContent = _props2.dialogHeaderContent,
	          extraContentClassName = _props2.extraContentClassName;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: dialogClassName,
	          styleName: (0, _classnames2.default)('root', (0, _defineProperty3.default)({
	            'root--nonAdaptive': !mobileFullScreen,
	            'root--overflow-visible': overflowVisible
	          }, 'root--width--' + width, width))
	        },
	        _react2.default.createElement(
	          _Paper2.default,
	          {
	            gray: !white,
	            className: paperClassName,
	            isLayoutColumn: isLayoutColumn,
	            overflowVisible: overflowVisible
	          },
	          withHeading || title ? [_react2.default.createElement(
	            'header',
	            { styleName: 'header', key: '0'
	            },
	            _react2.default.createElement(
	              _Controls2.default,
	              { className: 'w-100 h-100 ph2 pt2' },
	              _react2.default.createElement(
	                _ControlsItem2.default,
	                null,
	                title ? _react2.default.createElement('h1', { children: title, className: 'ph2', styleName: 'title' }) : null
	              ),
	              _react2.default.createElement(
	                _ControlsItem2.default,
	                { fixed: true },
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    id: _ids.IDS.COMMON.DIALOG_CLOSE,
	                    icon: true,
	                    onClick: onClose,
	                    ariaLabel: 'close'
	                  },
	                  _react2.default.createElement(_Icon2.default, { name: 'close', style: { stroke: _styles.COLORS.bluePrimary } })
	                )
	              )
	            )
	          ), _react2.default.createElement(
	            _react.Fragment,
	            {
	              key: '1'
	            },
	            dialogHeaderContent && dialogHeaderContent
	          ), title && subTitle ? _react2.default.createElement('div', { children: subTitle, styleName: 'subTitle', key: '2'
	          }) : null] : null,
	          _react2.default.createElement(
	            'div',
	            {
	              styleName: (0, _classnames2.default)('content', {
	                'content--full-height': !controls && !customControls,
	                'content--white': contentWhite,
	                'content--noPadding': contentNoPadding,
	                'content--auto-height': autoHeight,
	                contentWithoutAdaptive: withoutAdaptive
	              }),
	              className: extraContentClassName
	            },
	            children
	          ),
	          controls ? _react2.default.createElement(
	            'footer',
	            { styleName: 'footer' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                id: _ids.IDS.COMMON.DIALOG_OK,
	                disabled: !enabled,
	                className: 'mr3',
	                raised: true,
	                color: 'primary',
	                onClick: onAdd
	              },
	              _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.add)
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                id: _ids.IDS.COMMON.DIALOG_CLOSE,
	                raised: true,
	                color: 'accent',
	                onClick: onClose
	              },
	              _react2.default.createElement(_reactIntl.FormattedMessage, _strings.COMMON.cancel)
	            )
	          ) : null,
	          customControls ? _react2.default.createElement(
	            'footer',
	            {
	              styleName: (0, _classnames2.default)('footer', {
	                'footer--centered': footerCentered,
	                'footer--end': footerEnd
	              })
	            },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                id: _ids.IDS.COMMON.DIALOG_OK,
	                disabled: !enabled,
	                className: footerCentered ? null : 'mr3',
	                raised: true,
	                color: submitBtnColor || 'primary',
	                onClick: onSubmit,
	                style: { minWidth: buttonWidth || null }
	              },
	              submitText
	            ),
	            cancelText && _react2.default.createElement(
	              _Button2.default,
	              {
	                id: _ids.IDS.COMMON.DIALOG_CLOSE,
	                raised: true,
	                color: 'accent',
	                onClick: onClose
	              },
	              cancelText
	            )
	          ) : null
	        )
	      );
	    }
	  }]);
	  return Dialog;
	}(_react.PureComponent), _class2.propTypes = {
	  children: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
	  mobileFullScreen: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  strictClose: _propTypes2.default.bool,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  white: _propTypes2.default.bool,
	  contentWhite: _propTypes2.default.bool,
	  width: _propTypes2.default.string,
	  withHeading: _propTypes2.default.bool,
	  customControls: _propTypes2.default.bool,
	  submitText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  cancelText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  onSubmit: _propTypes2.default.func,
	  footerCentered: _propTypes2.default.bool,
	  buttonWidth: _propTypes2.default.number,
	  isLayoutColumn: _propTypes2.default.bool,
	  submitBtnColor: _propTypes2.default.string,
	  autoHeight: _propTypes2.default.bool,
	  subTitle: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  withoutAdaptive: _propTypes2.default.bool,
	  dialogClassName: _propTypes2.default.string,
	  dialogHeaderContent: _propTypes2.default.object,
	  extraContentClassName: _propTypes2.default.string
	}, _class2.defaultProps = {
	  mobileFullScreen: true,
	  withHeading: true
	}, _temp)) || _class) || _class);
	exports.default = Dialog;

/***/ }),
/* 3851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.DocumentView = DocumentView;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _index = __webpack_require__(5199);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DocumentView(_ref) {
	  var title = _ref.title,
	      accent = _ref.accent,
	      pointer = _ref.pointer,
	      onClick = _ref.onClick,
	      subtitle = _ref.subtitle,
	      onDelete = _ref.onDelete,
	      className = _ref.className,
	      showButton = _ref.showButton,
	      additionalClass = _ref.additionalClass;
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(_index2.default.wrapper, additionalClass) },
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_index2.default.infoWrapper, (0, _defineProperty3.default)({}, _index2.default.pointer, pointer)),
	        onClick: onClick
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'icon-document-black', size: 32, className: _index2.default.icon }),
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.info },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_index2.default.title, (0, _defineProperty3.default)({}, _index2.default.titleAccent, accent), className)
	          },
	          title
	        ),
	        subtitle ? _react2.default.createElement(
	          'div',
	          { className: _index2.default.subtitle },
	          subtitle
	        ) : null
	      )
	    ),
	    showButton && _react2.default.createElement(_Icon2.default, {
	      name: 'remove-member',
	      size: 16,
	      className: _index2.default.removeIcon,
	      onClick: onDelete
	    })
	  );
	}
	
	DocumentView.defaultProps = {
	  additionalClass: 'mb3'
	};
	
	DocumentView.propTypes = {
	  pointer: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  subtitle: _propTypes2.default.string,
	  onDelete: _propTypes2.default.func,
	  showButton: _propTypes2.default.bool,
	  accent: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  additionalClass: _propTypes2.default.string
	};

/***/ }),
/* 3852 */,
/* 3853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _handleRelationshipOptions = __webpack_require__(1831);
	
	var _handleRelationshipOptions2 = _interopRequireDefault(_handleRelationshipOptions);
	
	var _handleRolesOptions = __webpack_require__(1183);
	
	var _handleRolesOptions2 = _interopRequireDefault(_handleRolesOptions);
	
	var _selectors = __webpack_require__(23);
	
	var _formFields = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    loggedUserCountry: (0, _selectors.loggedUserCountrySelector)(state)
	  };
	};
	
	var mapDispatchToProps = {};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _recompose.withProps)(function (_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      formState = _ref.formState;
	
	  return {
	    formatMessage: formatMessage,
	    roleOptions: (0, _handleRolesOptions2.default)(formatMessage),
	    relationshipOptions: (0, _handleRelationshipOptions2.default)(formState[_formFields.PROFILE_FIELDS_TYPES.ROLE], formatMessage)
	  };
	}));

/***/ }),
/* 3854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Popover = __webpack_require__(250);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(5201);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hint = function Hint(_ref) {
	  var hintText = _ref.hintText,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 12 : _ref$size;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      anchorEl = _useState2[0],
	      setAnchorEl = _useState2[1];
	
	  var open = Boolean(anchorEl);
	
	  var handleOpen = function handleOpen(e) {
	    return setAnchorEl(e.currentTarget);
	  };
	  var handleClose = function handleClose() {
	    return setAnchorEl(null);
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Icon2.default, {
	      name: 'icon-info',
	      size: size,
	      className: _stylesModule2.default.infoIcon,
	      onClick: handleOpen
	    }),
	    _react2.default.createElement(
	      _Popover2.default,
	      {
	        open: open,
	        anchorEl: anchorEl,
	        onClose: handleClose,
	        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
	        transformOrigin: { vertical: 'top', horizontal: 'left' },
	        disableRestoreFocus: true
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.hintText },
	        hintText
	      )
	    )
	  );
	};
	
	Hint.propTypes = {
	  hintText: _propTypes2.default.string.isRequired,
	  size: _propTypes2.default.number
	};
	
	exports.default = Hint;

/***/ }),
/* 3855 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Popover = __webpack_require__(250);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _SimpleItem = __webpack_require__(1832);
	
	var _SimpleItem2 = _interopRequireDefault(_SimpleItem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ComplexMenuItem(_ref) {
	  var onClick = _ref.onClick,
	      submenu = _ref.submenu,
	      rest = (0, _objectWithoutProperties3.default)(_ref, ['onClick', 'submenu']);
	
	  var _useState = (0, _react.useState)(),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      anchorEl = _useState2[0],
	      setAnchorEl = _useState2[1];
	
	  var openSubMenu = function openSubMenu(event) {
	    return setAnchorEl(event.currentTarget);
	  };
	  var closeSubMenu = function closeSubMenu() {
	    return setAnchorEl(null);
	  };
	  var isOpen = Boolean(anchorEl);
	
	  var handleSubmenuClick = function handleSubmenuClick(item, e) {
	    closeSubMenu();
	    onClick(e);
	    submenu.onClick(item);
	  };
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_SimpleItem2.default, (0, _extends3.default)({}, rest, { onClick: openSubMenu })),
	    _react2.default.createElement(
	      _Popover2.default,
	      {
	        className: 'popover',
	        open: isOpen,
	        anchorOrigin: submenu.position,
	        anchorEl: anchorEl,
	        onClose: closeSubMenu
	      },
	      submenu.list.map(function (item, i) {
	        return _react2.default.createElement(_SimpleItem2.default, (0, _extends3.default)({
	          onClick: function onClick(e) {
	            return handleSubmenuClick(item, e);
	          },
	          key: item.id
	        }, item));
	      })
	    )
	  );
	}
	
	ComplexMenuItem.propTypes = {
	  onClick: PropTypes.func,
	  submenu: PropTypes.object
	};
	
	exports.default = ComplexMenuItem;

/***/ }),
/* 3856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _SimpleItem = __webpack_require__(1832);
	
	var _SimpleItem2 = _interopRequireDefault(_SimpleItem);
	
	var _ComplexItem = __webpack_require__(3855);
	
	var _ComplexItem2 = _interopRequireDefault(_ComplexItem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MenuItem(props) {
	  var _ref = props || {},
	      submenu = _ref.submenu;
	
	  if (submenu) {
	    return _react2.default.createElement(_ComplexItem2.default, props);
	  }
	
	  return _react2.default.createElement(_SimpleItem2.default, props);
	}
	
	MenuItem.propTypes = {
	  submenu: PropTypes.object,
	  active: PropTypes.bool,
	  icon: PropTypes.string,
	  onClick: PropTypes.func,
	  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	  danger: PropTypes.bool,
	  borderTop: PropTypes.bool,
	  id: PropTypes.string
	};
	
	exports.default = MenuItem;

/***/ }),
/* 3857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ALLOWED_FORMAT = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useFileManagement = useFileManagement;
	
	var _react = __webpack_require__(1);
	
	var _head = __webpack_require__(378);
	
	var _head2 = _interopRequireDefault(_head);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALLOWED_FORMAT = exports.ALLOWED_FORMAT = ['image/jpg', 'image/jpeg', 'image/png'];
	
	function useFileManagement() {
	  var _useState = (0, _react.useState)(),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      file = _useState2[0],
	      setFile = _useState2[1];
	
	  var handleFileChange = (0, _react.useCallback)(function (e) {
	    var selectedFile = (0, _head2.default)(e.target.files);
	    var reader = new FileReader();
	
	    if (!selectedFile) {
	      return setFile(undefined);
	    }
	
	    if (!ALLOWED_FORMAT.includes(selectedFile.type)) {
	      return;
	    }
	
	    reader.addEventListener('load', function () {
	      return setFile(reader.result);
	    });
	    reader.readAsDataURL(selectedFile);
	  }, [setFile]);
	
	  return [file, setFile, handleFileChange];
	}

/***/ }),
/* 3858 */,
/* 3859 */,
/* 3860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _index = __webpack_require__(1186);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _imageViewer = __webpack_require__(903);
	
	var _selectors = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props */
	var GlobalImageViewer = function GlobalImageViewer(_ref) {
	  var config = _ref.config,
	      closeImageViewer = _ref.closeImageViewer;
	  return _react2.default.createElement(_index2.default, { config: config, onClose: closeImageViewer });
	};
	GlobalImageViewer.propTypes = {
	  config: _propTypes2.default.shape({
	    src: _propTypes2.default.string,
	    opened: _propTypes2.default.bool
	  }),
	  closeImageViewer: _propTypes2.default.func
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    config: (0, _selectors.uiImageViewerSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  closeImageViewer: _imageViewer.actions.close
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GlobalImageViewer);

/***/ }),
/* 3861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(2279);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfoContent = function InfoContent(_ref) {
	  var value = _ref.value;
	
	  if (Array.isArray(value)) {
	    var children = value.reduce(function (list, item, i) {
	      var child = _react2.default.createElement(
	        'li',
	        { key: i },
	        item
	      );
	      list.push(child);
	
	      return list;
	    }, []);
	
	    return _react2.default.createElement(
	      'ul',
	      null,
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    'p',
	    null,
	    value
	  );
	};
	
	InfoContent.propTypes = {
	  value: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]).isRequired
	};
	
	exports.default = (0, _reactCssModules2.default)(InfoContent, _index2.default, { allowMultiple: true });

/***/ }),
/* 3862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Popover = __webpack_require__(250);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Info = __webpack_require__(1833);
	
	var _Info2 = _interopRequireDefault(_Info);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InfoBtn = function InfoBtn(_ref) {
	  var iconName = _ref.iconName,
	      size = _ref.size,
	      value = _ref.value;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isPopoverOpened = _useState2[0],
	      togglePopover = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      anchorEl = _useState4[0],
	      setAnchorEl = _useState4[1];
	
	  var handleTouchTap = function handleTouchTap(e) {
	    e.preventDefault();
	
	    togglePopover(true);
	    setAnchorEl(e.currentTarget);
	  };
	
	  var handleRequestClose = function handleRequestClose() {
	    togglePopover(false);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Button2.default,
	      { icon: true, onClick: handleTouchTap },
	      _react2.default.createElement(_Icon2.default, { name: iconName, size: size })
	    ),
	    _react2.default.createElement(
	      _Popover2.default,
	      {
	        className: 'popover',
	        open: isPopoverOpened,
	        anchorEl: anchorEl,
	        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
	        onClose: handleRequestClose
	      },
	      _react2.default.createElement(_Info2.default, { value: value })
	    )
	  );
	};
	
	InfoBtn.propTypes = {
	  iconName: _propTypes2.default.string,
	  size: _propTypes2.default.number,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired
	};
	
	InfoBtn.defaultProps = {
	  iconName: 'info',
	  size: 22
	};
	
	exports.default = InfoBtn;

/***/ }),
/* 3863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(5208);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Like = function Like(_ref) {
	  var active = _ref.active;
	
	  var fill = active ? _styles.COLORS.orangePink : _styles.COLORS.grayDark;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'wrapper' },
	      _react2.default.createElement(
	        'div',
	        {
	          styleName: (0, _classnames2.default)('outer', {
	            'outer--active': active
	          })
	        },
	        _react2.default.createElement(_Icon2.default, {
	          styleName: 'inner',
	          className: (0, _classnames2.default)({ dn: !active }),
	          style: { fill: fill },
	          name: 'heart-filled',
	          size: 16
	        }),
	        _react2.default.createElement(_Icon2.default, {
	          styleName: 'inner',
	          className: (0, _classnames2.default)({ dn: active }),
	          style: { fill: fill },
	          name: 'heart',
	          size: 16
	        })
	      )
	    )
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	Like.propTypes = {
	  active: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(Like, _index2.default, { allowMultiple: true });

/***/ }),
/* 3864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(5209);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Line = function Line() {
	  return _react2.default.createElement('div', { styleName: 'root' });
	}; /* eslint-disable react/require-default-props */
	exports.default = (0, _reactCssModules2.default)(Line, _index2.default, { allowMultiple: true });

/***/ }),
/* 3865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _Avatar = __webpack_require__(87);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _SelectedSizeInfo = __webpack_require__(1195);
	
	var _index = __webpack_require__(5211);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectableList = function SelectableList(_ref) {
	  var items = _ref.items,
	      onSelect = _ref.onSelect,
	      white = _ref.white,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: (0, _classnames2.default)('list', { 'list--white': white }), className: className },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'counter' },
	      _react2.default.createElement(_SelectedSizeInfo.SelectedSizeInfo, {
	        textId: { id: 'chat.title.membersCounter' },
	        size: (0, _size2.default)(items)
	      })
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      items.map(function (item) {
	        var dob = item.dob,
	            city = item.city,
	            id = item.id,
	            displayableName = item.displayableName,
	            username = item.username,
	            role = item.role,
	            organizationName = item.organizationName,
	            avatar = item.avatar,
	            teamActingUser = item.teamActingUser;
	
	        var additionalInfo = dob || city;
	        var name = displayableName || username;
	
	        return _react2.default.createElement(
	          'li',
	          { styleName: 'item', onClick: function onClick() {
	              return onSelect(item);
	            }, key: id },
	          _react2.default.createElement(
	            'div',
	            { styleName: 'wrapper' },
	            _react2.default.createElement(_Avatar2.default, {
	              style: { marginLeft: '5px' },
	              children: name && name.charAt(0).toUpperCase(),
	              size: 40,
	              src: (0, _get2.default)(avatar, 'thumbMin')
	            }),
	            _react2.default.createElement(
	              'div',
	              { styleName: 'content' },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: additionalInfo ? 'flex flex-column' : 'flex flex-row items-center'
	                },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { styleName: 'title title--primary title--left' },
	                    name
	                  ),
	                  !teamActingUser ? _react2.default.createElement(
	                    'span',
	                    { styleName: 'title title--secondary title--left' },
	                    username
	                  ) : null
	                ),
	                !teamActingUser && additionalInfo ? _react2.default.createElement(
	                  'span',
	                  {
	                    styleName: 'title title--secondary title--left',
	                    className: 'mt2'
	                  },
	                  '' + (dob || '') + (dob && city ? ',' : '') + ' ' + (city || '')
	                ) : null
	              ),
	              _react2.default.createElement(
	                'div',
	                { styleName: 'role-content' },
	                _react2.default.createElement(
	                  'span',
	                  { styleName: 'role' },
	                  !teamActingUser ? '' + (role || '') + (role && organizationName ? ',' : '') + ' ' + (organizationName || '') : '' + (organizationName || '')
	                )
	              )
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	SelectableList.propTypes = {
	  items: _propTypes2.default.array,
	  onSelect: _propTypes2.default.func,
	  white: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(SelectableList, _index2.default, { allowMultiple: true });

/***/ }),
/* 3866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp; /* eslint-disable react/require-default-props,react/destructuring-assignment */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocalizationContextWrapper = (_temp = _class = function (_PureComponent) {
	  (0, _inherits3.default)(LocalizationContextWrapper, _PureComponent);
	
	  function LocalizationContextWrapper() {
	    (0, _classCallCheck3.default)(this, LocalizationContextWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (LocalizationContextWrapper.__proto__ || (0, _getPrototypeOf2.default)(LocalizationContextWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LocalizationContextWrapper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        intl: this.props.intl
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      if (!children) return null;
	
	      if (Array.isArray(children)) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          children
	        );
	      }
	
	      // unnecessary wrapper brokes layout (for empty state for example)
	      return children;
	    }
	  }]);
	  return LocalizationContextWrapper;
	}(_react.PureComponent), _class.propTypes = {
	  intl: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.node, _propTypes2.default.number, _propTypes2.default.string])
	}, _class.childContextTypes = {
	  intl: _propTypes2.default.object
	}, _temp);
	exports.default = LocalizationContextWrapper;

/***/ }),
/* 3867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _SVGCheckbox = __webpack_require__(1827);
	
	var _SVGCheckbox2 = _interopRequireDefault(_SVGCheckbox);
	
	var _index = __webpack_require__(2280);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PickInput = function PickInput(_ref) {
	  var id = _ref.id,
	      label = _ref.label,
	      name = _ref.name,
	      value = _ref.value,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['id', 'label', 'name', 'value']);
	  return _react2.default.createElement(
	    'label',
	    { htmlFor: id, styleName: 'input' },
	    _react2.default.createElement('input', (0, _extends3.default)({ type: 'checkbox', defaultValue: value }, { id: id, name: name }, other)),
	    _react2.default.createElement(
	      'div',
	      { styleName: 'checker' },
	      _react2.default.createElement(
	        'span',
	        { styleName: 'unchecked' },
	        _react2.default.createElement(_SVGCheckbox2.default, { size: 12 })
	      ),
	      _react2.default.createElement(
	        'span',
	        { styleName: 'checked' },
	        _react2.default.createElement(_SVGCheckbox2.default, { size: 12, checked: true })
	      )
	    ),
	    label ? _react2.default.createElement(
	      'span',
	      { styleName: 'label' },
	      label
	    ) : null
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	PickInput.propTypes = {
	  id: _propTypes2.default.string,
	  label: _propTypes2.default.string,
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  value: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(PickInput, _index2.default, { allowMultiple: true });

/***/ }),
/* 3868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _injectSaga = __webpack_require__(116);
	
	var _sagaInjectors = __webpack_require__(137);
	
	var _consentSaga = __webpack_require__(1370);
	
	var _consentSaga2 = _interopRequireDefault(_consentSaga);
	
	var _Program = __webpack_require__(3653);
	
	var _Program2 = _interopRequireDefault(_Program);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgramPopupContent = function ProgramPopupContent(_ref) {
	  var title = _ref.title,
	      onClose = _ref.onClose,
	      surveysLoading = _ref.surveysLoading,
	      targetFormLoading = _ref.targetFormLoading,
	      program = _ref.program,
	      date = _ref.date,
	      contextStore = _ref.contextStore,
	      children = _ref.children;
	
	  (0, _injectSaga.useInjectSaga)({
	    key: 'consentSaga',
	    saga: _consentSaga2.default,
	    mode: _sagaInjectors.RESTART_ON_REMOUNT
	  });
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    { opened: true, onClose: onClose, title: title, width: 'medium', strictClose: true },
	    !date ? _react2.default.createElement(_Program2.default, {
	      program: program,
	      className: 'mb3',
	      store: contextStore,
	      onLeave: onClose
	    }) : null,
	    !surveysLoading && !targetFormLoading ? children : _react2.default.createElement(_Loader2.default, null)
	  );
	};
	
	ProgramPopupContent.propTypes = {
	  title: _propTypes2.default.string,
	  onClose: _propTypes2.default.func,
	  surveysLoading: _propTypes2.default.bool,
	  targetFormLoading: _propTypes2.default.bool,
	  program: _propTypes2.default.object,
	  date: _propTypes2.default.string,
	  contextStore: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	
	exports.default = ProgramPopupContent;

/***/ }),
/* 3869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(5219);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBar = function ProgressBar(_ref) {
	  var _ref$progress = _ref.progress,
	      progress = _ref$progress === undefined ? 0 : _ref$progress;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'root', className: 'black-05' },
	    _react2.default.createElement('div', { styleName: 'root-line', style: { width: progress + '%' } })
	  );
	};
	
	ProgressBar.propTypes = {
	  progress: _propTypes2.default.number.isRequired
	};
	
	exports.default = (0, _reactCssModules2.default)(ProgressBar, _index2.default, { allowMultiple: true });

/***/ }),
/* 3870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _index = __webpack_require__(5221);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/require-default-props,react/no-array-index-key */
	var Range = function Range(_ref) {
	  var scale = _ref.scale,
	      selected = _ref.selected;
	
	  var items = [];
	
	  for (var i = scale.minValue; i <= scale.maxValue; i++) {
	    items.push(i);
	  }
	
	  if ((0, _isEmpty2.default)(items)) return null;
	
	  return selected && selected === '-' ? _react2.default.createElement(
	    'span',
	    null,
	    selected
	  ) : _react2.default.createElement(
	    'ul',
	    { styleName: 'root' },
	    items.map(function (item, i) {
	      var isColored = +item <= +selected;
	      var isSelected = +item === +selected;
	
	      return _react2.default.createElement(
	        'li',
	        {
	          key: i,
	          styleName: (0, _classnames2.default)('cell', {
	            'cell--start': i === 0,
	            'cell--colored': isColored,
	            'cell--selected': isSelected
	          })
	        },
	        _react2.default.createElement(
	          'span',
	          { styleName: 'mark' },
	          item
	        )
	      );
	    })
	  );
	};
	
	Range.propTypes = {
	  scale: _propTypes2.default.shape({
	    minValue: _propTypes2.default.number,
	    maxValue: _propTypes2.default.number
	  }),
	  selected: _propTypes2.default.string
	};
	
	exports.default = (0, _reactCssModules2.default)(Range, _index2.default, { allowMultiple: true });

/***/ }),
/* 3871 */,
/* 3872 */,
/* 3873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _RadioInput = __webpack_require__(1193);
	
	var _RadioInput2 = _interopRequireDefault(_RadioInput);
	
	var _index = __webpack_require__(2281);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInput = function ScaleInput(_ref) {
	  var opacity = _ref.opacity,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['opacity']);
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'itemWrapper' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'item' },
	      _react2.default.createElement('div', { styleName: 'itemBg', style: (0, _extends3.default)({ opacity: opacity }) }),
	      _react2.default.createElement(_RadioInput2.default, (0, _extends3.default)({ vertical: true }, other))
	    )
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	ScaleInput.propTypes = {
	  opacity: _propTypes2.default.number
	};
	
	exports.default = (0, _reactCssModules2.default)(ScaleInput, _index2.default, { allowMultiple: true });

/***/ }),
/* 3874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _styles = __webpack_require__(5223);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmptySearchResults = function EmptySearchResults(_ref) {
	  var loading = _ref.loading,
	      emptyState = _ref.emptyState,
	      defaultState = _ref.defaultState,
	      succeed = _ref.succeed,
	      _ref$defaultIcon = _ref.defaultIcon,
	      defaultIcon = _ref$defaultIcon === undefined ? 'no-posts' : _ref$defaultIcon,
	      withTabs = _ref.withTabs;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: (0, _classnames2.default)('root', { 'root--white': withTabs }) },
	    !loading ? [_react2.default.createElement(_Icon2.default, {
	      name: succeed ? 'no-one-found' : defaultIcon,
	      size: 148,
	      className: 'pb4',
	      key: '0'
	    }), _react2.default.createElement(
	      'p',
	      { className: 'ttu', styleName: 'text', key: '1'
	      },
	      succeed ? emptyState : defaultState
	    ), withTabs && !succeed ? _react2.default.createElement(
	      'p',
	      { className: 'pt4', styleName: 'text', key: '2'
	      },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dialog.common.selectTab' })
	    ) : null] : _react2.default.createElement(_Loader2.default, null)
	  );
	};
	
	EmptySearchResults.propTypes = {
	  defaultState: _propTypes2.default.string.isRequired,
	  emptyState: _propTypes2.default.string.isRequired,
	  defaultIcon: _propTypes2.default.string,
	  loading: _propTypes2.default.bool,
	  withTabs: _propTypes2.default.bool,
	  succeed: _propTypes2.default.bool
	};
	
	exports.default = (0, _reactCssModules2.default)(EmptySearchResults, _styles2.default, { allowMultiple: true });

/***/ }),
/* 3875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _AllUsers = __webpack_require__(1252);
	
	var _reqAllUsers = __webpack_require__(637);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    users: (0, _AllUsers.usersSelector)(state),
	    loading: (0, _AllUsers.sendingSelector)(state),
	    succeed: (0, _AllUsers.succeedSelector)(state)
	  };
	};
	
	var mapDispatchToProps = {
	  getUsers: _reqAllUsers.actions.send,
	  clear: _reqAllUsers.actions.clear,
	  clearStatus: _reqAllUsers.actions.clearStatus
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

/***/ }),
/* 3876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AssignmentForm = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _reactRedux = __webpack_require__(6);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _lowerCase = __webpack_require__(464);
	
	var _lowerCase2 = _interopRequireDefault(_lowerCase);
	
	var _upperFirst = __webpack_require__(147);
	
	var _upperFirst2 = _interopRequireDefault(_upperFirst);
	
	var _strings = __webpack_require__(15);
	
	var _ClickableElement = __webpack_require__(75);
	
	var _ClickableElement2 = _interopRequireDefault(_ClickableElement);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _styles = __webpack_require__(18);
	
	var _Tooltip = __webpack_require__(1847);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _SingleSelect = __webpack_require__(257);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _getListLocalization = __webpack_require__(1915);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _ErrorBlock = __webpack_require__(69);
	
	var _ErrorBlock2 = _interopRequireDefault(_ErrorBlock);
	
	var _useToogleFlag = __webpack_require__(108);
	
	var _relationshipPriority = __webpack_require__(1873);
	
	var _styles2 = __webpack_require__(5225);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INPUT_WIDTH = 290;
	
	var AssignmentFormImpl = function AssignmentFormImpl(_ref) {
	  var formatMessage = _ref.intl.formatMessage,
	      onFormChange = _ref.onFormChange;
	
	  var _useToggleFlag = (0, _useToogleFlag.useToggleFlag)(),
	      _useToggleFlag2 = (0, _slicedToArray3.default)(_useToggleFlag, 3),
	      tipOpened = _useToggleFlag2[0],
	      openTip = _useToggleFlag2[1],
	      closeTip = _useToggleFlag2[2];
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      reason = _useState2[0],
	      setReason = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      relation = _useState4[0],
	      setRelation = _useState4[1];
	
	  var _useState5 = (0, _react.useState)('permanent'),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      level = _useState6[0],
	      setLevel = _useState6[1];
	
	  var relationship = (0, _reactRedux.useSelector)(_relationshipPriority.selectRelationshipPriority);
	
	  var adaptName = function adaptName(name) {
	    return (0, _upperFirst2.default)((0, _lowerCase2.default)(name));
	  };
	
	  var relationshipOptions = (0, _react.useMemo)(function () {
	    return relationship.map(function (item) {
	      return {
	        label: adaptName(item.name),
	        value: item.id
	      };
	    });
	  }, [relationship]);
	
	  var reasonOptions = (0, _react.useMemo)(function () {
	    switch (level) {
	      case 'temporary':
	        {
	          return (0, _getListLocalization.getListLocalization)(_strings.ADD_PROVIDER_REASON_CODE.temporary, formatMessage);
	        }
	      default:
	        {
	          return (0, _getListLocalization.getListLocalization)(_strings.ADD_PROVIDER_REASON_CODE.permanent, formatMessage);
	        }
	    }
	  }, [level]);
	
	  var handleOptionChange = (0, _react.useCallback)(function (value) {
	    setLevel(value);
	    setReason(null);
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    onFormChange({
	      isValid: !!reason && !!relation,
	      data: {
	        level: level,
	        reason: (0, _get2.default)(reason, 'value', null),
	        relation: (0, _get2.default)(relation, 'value', null)
	      }
	    });
	  }, [reason, level, relation]);
	
	  var error = false;
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'form' },
	    _react2.default.createElement(
	      'div',
	      { styleName: 'form-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'mr3' },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(
	            'span',
	            { styleName: 'form-label' },
	            formatMessage(_strings.NEW_CHAT.accessLevel)
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'relative',
	              onMouseEnter: openTip,
	              onMouseLeave: closeTip
	            },
	            _react2.default.createElement(
	              _ClickableElement2.default,
	              null,
	              _react2.default.createElement(_Icon2.default, {
	                name: 'info-default',
	                size: 12,
	                style: { fill: _styles.COLORS.darkSlateBlue },
	                className: 'db'
	              })
	            ),
	            _react2.default.createElement(_Tooltip2.default, {
	              content: _react2.default.createElement(
	                'p',
	                { className: 'f-12 lh-20' },
	                formatMessage(_strings.NEW_CHAT.accessLevelTooltip)
	              ),
	              top: 15,
	              left: 0,
	              width: 225,
	              open: tipOpened
	            })
	          )
	        ),
	        _react2.default.createElement(_SingleSelect2.default, {
	          name: 'providerOption',
	          list: (0, _getListLocalization.getListLocalization)(_strings.ADD_PROVIDER_OPTION, formatMessage),
	          selectClass: 'flex',
	          radioInputClass: 'mr2',
	          selectedValue: level,
	          onChange: handleOptionChange
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { styleName: 'form-selects' },
	        _react2.default.createElement(_SelectCustom2.default, {
	          style: { width: INPUT_WIDTH },
	          styleName: 'form-select',
	          placeholder: formatMessage(_strings.NEW_CHAT.selectReasonForAssignment),
	          label: formatMessage(_strings.NEW_CHAT.reasonForAssignment),
	          options: reasonOptions,
	          value: reason,
	          onChange: setReason,
	          needUpdateDefaultValue: true
	        }),
	        _react2.default.createElement(_SelectCustom2.default, {
	          style: { width: INPUT_WIDTH },
	          styleName: 'form-select',
	          placeholder: formatMessage({
	            id: 'relationshipPriority.subtitle'
	          }),
	          label: formatMessage({
	            id: 'relationshipPriority.title'
	          }),
	          options: relationshipOptions,
	          value: relation,
	          onChange: setRelation,
	          needUpdateDefaultValue: true
	        })
	      )
	    ),
	    error ? _react2.default.createElement(_ErrorBlock2.default, {
	      errors: formatMessage(_strings.NEW_CHAT.selectReasonForAssignment),
	      className: 'w-80 mt3'
	    }) : null
	  );
	};
	
	AssignmentFormImpl.propTypes = {
	  intl: _propTypes2.default.object.isRequired,
	  onFormChange: _propTypes2.default.func.isRequired
	};
	
	var AssignmentForm = exports.AssignmentForm = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_styles3.default, { allowMultiple: true }))(AssignmentFormImpl);

/***/ }),
/* 3877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SearchDialog = __webpack_require__(1196);
	
	var _AssigmentForm = __webpack_require__(3876);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchDialogWithForm = function SearchDialogWithForm(_ref) {
	  var onCreate = _ref.onCreate,
	      rest = (0, _objectWithoutProperties3.default)(_ref, ['onCreate']);
	
	  var _useState = (0, _react.useState)({ isValid: undefined, data: {} }),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var handleStart = (0, _react.useCallback)(function (ids) {
	    onCreate(ids, formData.data.level, formData.data.reason, formData.data.relation);
	  }, [formData]);
	
	  return _react2.default.createElement(
	    _SearchDialog.SearchDialog,
	    (0, _extends3.default)({
	      extraValidation: formData.isValid,
	      onCreate: handleStart
	    }, rest),
	    _react2.default.createElement(_AssigmentForm.AssignmentForm, { onFormChange: setFormData })
	  );
	};
	
	SearchDialogWithForm.propTypes = {
	  onCreate: _propTypes2.default.func.isRequired
	};
	
	exports.default = SearchDialogWithForm;

/***/ }),
/* 3878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactResponsive = __webpack_require__(66);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _TextMessageForm = __webpack_require__(1197);
	
	var _TextMessageForm2 = _interopRequireDefault(_TextMessageForm);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SendMessagePopup = function SendMessagePopup(_ref) {
	  var opened = _ref.opened,
	      formatMessage = _ref.intl.formatMessage,
	      onClose = _ref.onClose,
	      onSubmit = _ref.onSubmit,
	      title = _ref.title;
	
	  return _react2.default.createElement(
	    _reactResponsive2.default,
	    { maxWidth: _styles.BREAKPOINT },
	    function (isMobile) {
	      return _react2.default.createElement(
	        _Popup2.default,
	        {
	          opened: opened,
	          onClose: onClose,
	          width: isMobile ? 'medium' : 'small',
	          enabled: true,
	          title: title
	        },
	        _react2.default.createElement(_TextMessageForm2.default, {
	          onSendMessage: onSubmit,
	          formatMessage: formatMessage,
	          onClose: onClose,
	          className: 'pt3'
	        })
	      );
	    }
	  );
	};
	
	SendMessagePopup.propTypes = {
	  opened: PropTypes.bool,
	  onClose: PropTypes.func,
	  onSubmit: PropTypes.func,
	  title: PropTypes.string,
	  intl: PropTypes.shape({
	    formatMessage: PropTypes.func
	  }).isRequired
	};
	
	exports.default = (0, _reactIntl.injectIntl)(SendMessagePopup);

/***/ }),
/* 3879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactIntl = __webpack_require__(5);
	
	var _selectors = __webpack_require__(90);
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    secondaryContentVisible: (0, _selectors.popupSecondaryContentVisibilitySelector)(state)
	  };
	};
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps));

/***/ }),
/* 3880 */,
/* 3881 */,
/* 3882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _strings = __webpack_require__(15);
	
	var _index = __webpack_require__(2283);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/prop-types */
	var Hover = function Hover(_ref) {
	  var status = _ref.status;
	
	  var userStatus = _strings.USER_STATUSES.find(function (item) {
	    return item.status === status;
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: 'hover' },
	    userStatus && userStatus.text
	  );
	};
	
	exports.default = (0, _reactCssModules2.default)(Hover, _index2.default, { allowMultiple: true });

/***/ }),
/* 3883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _props = __webpack_require__(41);
	
	var _Hover = __webpack_require__(3882);
	
	var _Hover2 = _interopRequireDefault(_Hover);
	
	var _index = __webpack_require__(2283);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatusIndicator = function StatusIndicator(_ref) {
	  var active = _ref.active,
	      status = _ref.status;
	
	  var styleNames = (0, _classnames2.default)('root', (0, _defineProperty3.default)({}, 'root--' + status, status), { 'root--active': active });
	
	  return _react2.default.createElement(
	    'div',
	    { styleName: styleNames },
	    _react2.default.createElement('span', { styleName: 'indicator' }),
	    _react2.default.createElement(_Hover2.default, { status: status })
	  );
	}; /* eslint-disable react/require-default-props */
	
	
	StatusIndicator.propTypes = {
	  active: _propTypes2.default.bool,
	  status: _propTypes2.default.oneOf(_props.USER_STATUS_TYPES)
	};
	
	exports.default = (0, _reactCssModules2.default)(StatusIndicator, _index2.default, { allowMultiple: true });

/***/ }),
/* 3884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _index = __webpack_require__(5234);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsAndPoliciesContent = function TermsAndPoliciesContent(_ref) {
	  var title = _ref.title,
	      document = _ref.document,
	      onClose = _ref.onClose;
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    { opened: true, onClose: onClose, title: title, width: 'medium' },
	    _react2.default.createElement('div', {
	      styleName: 'rootText',
	      dangerouslySetInnerHTML: { __html: document }
	    })
	  );
	};
	
	TermsAndPoliciesContent.propTypes = {
	  title: _propTypes2.default.string,
	  document: _propTypes2.default.node,
	  onClose: _propTypes2.default.func
	};
	
	exports.default = (0, _reactCssModules2.default)(TermsAndPoliciesContent, _index2.default, {
	  allowMultiple: true
	});

/***/ }),
/* 3885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.enhance = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactCssModules = __webpack_require__(10);
	
	var _reactCssModules2 = _interopRequireDefault(_reactCssModules);
	
	var _index = __webpack_require__(5235);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var enhance = exports.enhance = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _reactCssModules2.default)(_index2.default, { allowMultiple: true }));

/***/ }),
/* 3886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = TimePickerButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimePicker = __webpack_require__(1198);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _ValidationError = __webpack_require__(500);
	
	var _ValidationError2 = _interopRequireDefault(_ValidationError);
	
	var _index = __webpack_require__(5237);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimePickerButton(_ref) {
	  var title = _ref.title,
	      time = _ref.time,
	      disabled = _ref.disabled,
	      cancelButtonTitle = _ref.cancelButtonTitle,
	      saveButtonTitle = _ref.saveButtonTitle,
	      onSave = _ref.onSave,
	      validateTime = _ref.validateTime,
	      format = _ref.format;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isPopupVisible = _useState2[0],
	      toggleVisibility = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(time),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      pickerTime = _useState4[0],
	      setTime = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      error = _useState6[0],
	      showError = _useState6[1];
	
	  var togglePopup = (0, _react.useCallback)(function () {
	    toggleVisibility(!isPopupVisible);
	    showError(null);
	  }, [isPopupVisible, toggleVisibility]);
	
	  var handleSave = function handleSave() {
	    var errorMessage = validateTime(pickerTime);
	
	    if (!errorMessage) {
	      onSave(pickerTime);
	      toggleVisibility(false);
	    } else {
	      showError(errorMessage);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'dib' },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'mr3',
	        color: 'accent',
	        border: true,
	        disabled: disabled,
	        onClick: togglePopup,
	        type: 'button'
	      },
	      title
	    ),
	    _react2.default.createElement(
	      _Popup2.default,
	      {
	        opened: isPopupVisible,
	        white: true,
	        width: 'rubber',
	        enabled: true,
	        withHeading: false,
	        contentNoPadding: true
	      },
	      _react2.default.createElement(_TimePicker2.default, {
	        time: pickerTime,
	        onChange: function onChange(val) {
	          return setTime(val);
	        },
	        format: format
	      }),
	      error ? _react2.default.createElement(_ValidationError2.default, { content: error, className: _index2.default.error }) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'pt3 pb1 flex justify-end' },
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'transparent', onClick: togglePopup },
	          cancelButtonTitle
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'transparent', onClick: handleSave },
	          saveButtonTitle
	        )
	      )
	    )
	  );
	}
	
	TimePickerButton.propTypes = {
	  title: _propTypes2.default.string,
	  time: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  cancelButtonTitle: _propTypes2.default.string,
	  saveButtonTitle: _propTypes2.default.string,
	  onSave: _propTypes2.default.func,
	  validateTime: _propTypes2.default.func,
	  format: _propTypes2.default.string
	};
	
	TimePickerButton.defaultProps = {
	  time: '12:00 PM'
	};

/***/ }),
/* 3887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimePickerRange = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectors = __webpack_require__(50);
	
	var _styles = __webpack_require__(18);
	
	var _SelectCustom = __webpack_require__(63);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	var _TextInput = __webpack_require__(45);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _ValidationError = __webpack_require__(500);
	
	var _ValidationError2 = _interopRequireDefault(_ValidationError);
	
	var _TimePicker = __webpack_require__(1198);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _index = __webpack_require__(5239);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _utils = __webpack_require__(797);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimePickerRange(_ref) {
	  var label = _ref.label,
	      value = _ref.value,
	      _onChange = _ref.onChange,
	      validateTime = _ref.validateTime,
	      formatMessage = _ref.formatMessage,
	      withCurrentTime = _ref.withCurrentTime,
	      _ref$saveButtonTitle = _ref.saveButtonTitle,
	      saveButtonTitle = _ref$saveButtonTitle === undefined ? formatMessage({ id: 'common.ok' }) : _ref$saveButtonTitle,
	      _ref$cancelButtonTitl = _ref.cancelButtonTitle,
	      cancelButtonTitle = _ref$cancelButtonTitl === undefined ? formatMessage({ id: 'common.cancel' }) : _ref$cancelButtonTitl;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isStartTimePopupVisible = _useState2[0],
	      toggleStartTimeVisibility = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      isEndTimePopupVisible = _useState4[0],
	      toggleEndTimeVisibility = _useState4[1];
	
	  var _useState5 = (0, _react.useState)((0, _utils.parseValueToSelectTimeZone)(value) || null),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      timeZone = _useState6[0],
	      setTimeZone = _useState6[1];
	
	  var timeZonesOption = (0, _reactRedux.useSelector)(_selectors.selectTimeZoneOptions);
	
	  var actualValueStart = withCurrentTime ? (0, _utils.handleInitialTime)() : (0, _utils.parseValueToField)(value, true);
	
	  var actualValueEnd = withCurrentTime ? (0, _utils.handleInitialTime)() : (0, _utils.parseValueToField)(value, false);
	
	  var _useState7 = (0, _react.useState)(actualValueStart),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      pickerTimeStart = _useState8[0],
	      setTimeStart = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(actualValueEnd),
	      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
	      pickerTimeEnd = _useState10[0],
	      setTimeEnd = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(null),
	      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
	      error = _useState12[0],
	      showError = _useState12[1];
	
	  var toggleStartPopup = (0, _react.useCallback)(function () {
	    toggleStartTimeVisibility(!isStartTimePopupVisible);
	    showError(null);
	  }, [isStartTimePopupVisible, toggleStartTimeVisibility]);
	
	  var toggleEndPopup = (0, _react.useCallback)(function () {
	    toggleEndTimeVisibility(!isEndTimePopupVisible);
	    showError(null);
	  }, [isEndTimePopupVisible, toggleEndTimeVisibility]);
	
	  var handleSaveStart = function handleSaveStart() {
	    var errorMessage = validateTime && validateTime(pickerTimeStart);
	
	    if (!errorMessage) {
	      _onChange([{
	        value: pickerTimeStart
	      }, { value: pickerTimeEnd }, { value: timeZone }]);
	      toggleStartTimeVisibility(false);
	    } else {
	      showError(errorMessage);
	    }
	  };
	
	  var handleSaveEnd = function handleSaveEnd() {
	    var errorMessage = validateTime && validateTime(pickerTimeEnd);
	
	    if (!errorMessage) {
	      _onChange([{
	        value: pickerTimeStart
	      }, { value: pickerTimeEnd }, { value: timeZone }]);
	      toggleEndTimeVisibility(false);
	    } else {
	      showError(errorMessage);
	    }
	  };
	
	  var handleResetValue = function handleResetValue() {
	    setTimeStart(null);
	    setTimeEnd(null);
	    setTimeZone(null);
	    _onChange([{
	      value: null
	    }, { value: null }, { value: null }]);
	  };
	
	  var handleSetValue = function handleSetValue(startTime, endTime, isStartTime) {
	    if (isStartTime) {
	      setTimeStart((0, _moment2.default)(startTime, 'h:mm a').format('h:mm A'));
	    } else {
	      setTimeEnd((0, _moment2.default)(endTime, 'h:mm a').format('h:mm A'));
	    }
	  };
	
	  var validateRangeTime = function validateRangeTime(startTime, endTime, isStartTime) {
	    if (startTime && endTime) {
	      var parseTimeStart = (0, _moment2.default)(startTime, 'HH:mm a');
	      var parseTimeEnd = (0, _moment2.default)(endTime, 'HH:mm a');
	      var isTimeStartBeforeTimeEnd = parseTimeStart.isBefore(parseTimeEnd);
	      var isTimeEndAfterTimeStart = parseTimeEnd.isAfter(parseTimeStart);
	
	      if (!isTimeStartBeforeTimeEnd && !isTimeEndAfterTimeStart) {
	        showError(formatMessage({
	          id: isStartTime ? 'profile.employee.workingHours.startTime.error' : 'profile.employee.workingHours.endTime.error'
	        }));
	      } else {
	        showError(null);
	        handleSetValue(startTime, endTime, isStartTime);
	      }
	    } else {
	      handleSetValue(startTime, endTime, isStartTime);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.root },
	    _react2.default.createElement(
	      'span',
	      { className: _index2.default.label },
	      label
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _index2.default.textInputWrapper },
	      _react2.default.createElement(_TextInput2.default, {
	        rounded: true,
	        name: 'startTime',
	        type: 'text',
	        value: pickerTimeStart,
	        onFocus: toggleStartPopup,
	        placeholder: formatMessage({
	          id: 'profile.fields.workingHours.startTime'
	        }),
	        className: 'mr2',
	        readOnly: true
	      }),
	      _react2.default.createElement(_TextInput2.default, {
	        rounded: true,
	        name: 'endTime',
	        type: 'text',
	        value: pickerTimeEnd,
	        onFocus: toggleEndPopup,
	        placeholder: formatMessage({
	          id: 'profile.fields.workingHours.endTime'
	        }),
	        readOnly: true
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          icon: true,
	          raised: true,
	          className: _index2.default.iconReset,
	          disabled: !timeZone && !pickerTimeStart && !pickerTimeEnd
	        },
	        _react2.default.createElement(_Icon2.default, {
	          name: 'ico-24-close',
	          size: 16,
	          onClick: function onClick() {
	            return handleResetValue();
	          },
	          style: { fill: _styles.COLORS.stormyBlue }
	        })
	      )
	    ),
	    _react2.default.createElement(_SelectCustom2.default, {
	      id: 'timeZone',
	      name: 'timeZone',
	      className: 'mt3',
	      value: timeZone ? timeZone.value : null,
	      label: formatMessage({ id: 'profile.fields.workingHours.timeZone' }),
	      placeholder: formatMessage({
	        id: 'profile.fields.workingHours.timeZone'
	      }),
	      needUpdateDefaultValue: true,
	      options: timeZonesOption,
	      canSearch: true,
	      onChange: function onChange(item) {
	        setTimeZone(item);
	        _onChange([{
	          value: pickerTimeStart
	        }, { value: pickerTimeEnd }, { value: item }]);
	      }
	    }),
	    _react2.default.createElement(
	      _Popup2.default,
	      {
	        opened: isStartTimePopupVisible,
	        white: true,
	        width: 'rubber',
	        enabled: true,
	        withHeading: false,
	        contentNoPadding: true,
	        mobileFullScreen: false
	      },
	      _react2.default.createElement(_TimePicker2.default, {
	        time: pickerTimeStart,
	        onChange: function onChange(val) {
	          validateRangeTime(val, pickerTimeEnd, true);
	        }
	      }),
	      error ? _react2.default.createElement(_ValidationError2.default, { content: error, className: _index2.default.validationError }) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'pt3 pb1 flex justify-end' },
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'transparent', onClick: toggleStartPopup },
	          cancelButtonTitle
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'transparent',
	            onClick: handleSaveStart,
	            disabled: !!error
	          },
	          saveButtonTitle
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Popup2.default,
	      {
	        opened: isEndTimePopupVisible,
	        white: true,
	        width: 'rubber',
	        enabled: true,
	        withHeading: false,
	        contentNoPadding: true,
	        mobileFullScreen: false
	      },
	      _react2.default.createElement(_TimePicker2.default, {
	        time: pickerTimeEnd,
	        onChange: function onChange(val) {
	          validateRangeTime(pickerTimeStart, val, false);
	        }
	      }),
	      error ? _react2.default.createElement(_ValidationError2.default, { content: error, className: _index2.default.validationError }) : null,
	      _react2.default.createElement(
	        'div',
	        { className: 'pt3 pb1 flex justify-end' },
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'transparent', onClick: toggleEndPopup },
	          cancelButtonTitle
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'transparent',
	            onClick: handleSaveEnd,
	            disabled: !!error
	          },
	          saveButtonTitle
	        )
	      )
	    )
	  );
	}
	
	exports.TimePickerRange = TimePickerRange;
	TimePickerRange.propTypes = {
	  label: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  cancelButtonTitle: _propTypes2.default.string,
	  saveButtonTitle: _propTypes2.default.string,
	  validateTime: _propTypes2.default.func,
	  formatMessage: _propTypes2.default.func,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
	  withCurrentTime: _propTypes2.default.bool
	};

/***/ }),
/* 3888 */,
/* 3889 */,
/* 3890 */,
/* 3891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _RequiredAdditionalInsuranceDataError = __webpack_require__(3896);
	
	var _RequiredAdditionalInsuranceDataError2 = _interopRequireDefault(_RequiredAdditionalInsuranceDataError);
	
	var _styles = __webpack_require__(18);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _index = __webpack_require__(5244);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ICON_STYLES = { fill: _styles.COLORS.bluePrimary };
	
	var AdditionalInsuranceCollapse = function AdditionalInsuranceCollapse(_ref) {
	  var _cn;
	
	  var children = _ref.children,
	      flowType = _ref.flowType,
	      onClick = _ref.onClick,
	      opened = _ref.opened,
	      showError = _ref.showError;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var withAdditionalStyles = _insuranceFlowType.SHOW_ADDITIONAL_STYLES_FOR_ADDITIONAL_INSURANCES.includes(flowType);
	
	  var title = formatMessage({ id: 'profile.insurance.additional' });
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        onClick: onClick,
	        className: (0, _classnames2.default)(_index2.default.section, (_cn = {}, (0, _defineProperty3.default)(_cn, _index2.default.section_opened, opened), (0, _defineProperty3.default)(_cn, _index2.default.section_additionalStyles, withAdditionalStyles), _cn))
	      },
	      title,
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.endSection },
	        showError && _react2.default.createElement(_RequiredAdditionalInsuranceDataError2.default, null),
	        _react2.default.createElement(_Icon2.default, {
	          size: 12,
	          name: 'arrow-down-forms',
	          className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _index2.default.icon, opened)),
	          style: ICON_STYLES
	        })
	      )
	    ),
	    opened && _react2.default.createElement(
	      'div',
	      null,
	      children
	    ),
	    withAdditionalStyles && _react2.default.createElement('div', { className: _index2.default.divider })
	  );
	};
	
	AdditionalInsuranceCollapse.propTypes = {
	  children: _propTypes2.default.node,
	  flowType: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  opened: _propTypes2.default.bool,
	  showError: _propTypes2.default.bool
	};
	
	exports.default = AdditionalInsuranceCollapse;

/***/ }),
/* 3892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(150);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _DocumentsSection = __webpack_require__(1848);
	
	var _DocumentsSection2 = _interopRequireDefault(_DocumentsSection);
	
	var _PlainTextErrorBlock = __webpack_require__(1830);
	
	var _PlainTextErrorBlock2 = _interopRequireDefault(_PlainTextErrorBlock);
	
	var _AdditionalInsuranceCollapse = __webpack_require__(3891);
	
	var _AdditionalInsuranceCollapse2 = _interopRequireDefault(_AdditionalInsuranceCollapse);
	
	var _DeleteAdditionalInsuranceConfirmationModal = __webpack_require__(3894);
	
	var _DeleteAdditionalInsuranceConfirmationModal2 = _interopRequireDefault(_DeleteAdditionalInsuranceConfirmationModal);
	
	var _MainInsuranceFormSection = __webpack_require__(1791);
	
	var _MainInsuranceFormSection2 = _interopRequireDefault(_MainInsuranceFormSection);
	
	var _PrimarySubscriberFormSection = __webpack_require__(1792);
	
	var _PrimarySubscriberFormSection2 = _interopRequireDefault(_PrimarySubscriberFormSection);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _formFields = __webpack_require__(38);
	
	var _getDocumentsConfig = __webpack_require__(907);
	
	var _useInsuranceRelationOptions = __webpack_require__(621);
	
	var _useInsuranceRelationOptions2 = _interopRequireDefault(_useInsuranceRelationOptions);
	
	var _useIsAdditionalInsurancesEnabledAndMaxNumber = __webpack_require__(1216);
	
	var _useIsAdditionalInsurancesEnabledAndMaxNumber2 = _interopRequireDefault(_useIsAdditionalInsurancesEnabledAndMaxNumber);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _deletePatientInsurance = __webpack_require__(1314);
	
	var _getPatientInsurancesList = __webpack_require__(537);
	
	var _deletePatientInsurance2 = __webpack_require__(1892);
	
	var _checkIsNeedToShowErrorMessage = __webpack_require__(3893);
	
	var _index = __webpack_require__(5245);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRIMARY_SUBSCRIBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PRIMARY_SUBSCRIBER;
	
	
	var AdditionalInsurancesSection = function AdditionalInsurancesSection(_ref) {
	  var addAdditionalInsurance = _ref.addAdditionalInsurance,
	      additionalInsurances = _ref.additionalInsurances,
	      deleteAdditionalInsurance = _ref.deleteAdditionalInsurance,
	      entities = _ref.entities,
	      flowType = _ref.flowType,
	      frozenAdditionalInsurancesListIds = _ref.frozenAdditionalInsurancesListIds,
	      handleAdditionalInsuranceChangeField = _ref.handleAdditionalInsuranceChangeField,
	      handleAdditionalInsuranceFormChange = _ref.handleAdditionalInsuranceFormChange,
	      handleAdditionalInsuranceHealthPlanChange = _ref.handleAdditionalInsuranceHealthPlanChange,
	      handleAdditionalInsurancePrimarySubscriberChange = _ref.handleAdditionalInsurancePrimarySubscriberChange,
	      handleInputChange = _ref.handleInputChange,
	      handleMenuScrollToBottom = _ref.handleMenuScrollToBottom,
	      isLoading = _ref.isLoading,
	      primarySubscriberCheckboxLabel = _ref.primarySubscriberCheckboxLabel,
	      taskAssignmentId = _ref.taskAssignmentId,
	      userId = _ref.userId;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      opened = _useState2[0],
	      setOpened = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(undefined),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      confirmDeleteInsuranceIndex = _useState4[0],
	      setConfirmDeleteInsuranceIndex = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(undefined),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      patientInsuranceId = _useState6[0],
	      setPatientInsuranceId = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      expandedSections = _useState8[0],
	      setExpandedSections = _useState8[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _useIsAdditionalInsur = (0, _useIsAdditionalInsurancesEnabledAndMaxNumber2.default)(),
	      maxAdditionalInsurancesNumber = _useIsAdditionalInsur.maxAdditionalInsurancesNumber;
	
	  var _useInsuranceRelation = (0, _useInsuranceRelationOptions2.default)(),
	      hideInsuranceRelationFieldOrInfo = _useInsuranceRelation.hideInsuranceRelationFieldOrInfo;
	
	  var isInsuranceDeleteSucceeded = (0, _reactRedux.useSelector)(_deletePatientInsurance2.selectIsInsuranceDeleteSucceeded);
	
	  var withAdditionalStyles = _insuranceFlowType.SHOW_ADDITIONAL_STYLES_FOR_ADDITIONAL_INSURANCES.includes(flowType);
	
	  var showAddAdditionalInsuranceButton = additionalInsurances.length < maxAdditionalInsurancesNumber;
	
	  var additionalInsuranceTitle = formatMessage({
	    id: 'profile.insurance.additional'
	  });
	
	  var addInsuranceTitle = formatMessage({ id: 'common.addInsurance' });
	
	  var deleteInsuranceTitle = formatMessage({ id: 'common.deleteInsurance' });
	
	  var additionalInsuranceFormDetailsError = formatMessage({
	    id: 'errors.provideAdditionalInsuranceDetails'
	  });
	
	  var closeDeleteAdditionalInsuranceModal = function closeDeleteAdditionalInsuranceModal() {
	    setOpened(false);
	    setConfirmDeleteInsuranceIndex(undefined);
	    setPatientInsuranceId(undefined);
	  };
	
	  var handleSectionToggle = function handleSectionToggle(index) {
	    return function () {
	      var newExpandedSections = expandedSections.map(function (section, i) {
	        if (i === index) {
	          return (0, _extends3.default)({}, section, { isOpened: !section.isOpened });
	        }
	
	        return section;
	      });
	
	      setExpandedSections(newExpandedSections);
	    };
	  };
	
	  var handleDeleteAdditionalInsuranceFromFormState = function handleDeleteAdditionalInsuranceFromFormState(index) {
	    deleteAdditionalInsurance(index)();
	
	    setExpandedSections(function (prev) {
	      var newExpandedSections = [].concat((0, _toConsumableArray3.default)(prev));
	      newExpandedSections.splice(index, 1);
	      return newExpandedSections;
	    });
	  };
	
	  var toggleConfirmation = function toggleConfirmation(index, insuranceId) {
	    return function () {
	      if (!insuranceId) {
	        handleDeleteAdditionalInsuranceFromFormState(index);
	      } else {
	        setOpened(function (prev) {
	          return !prev;
	        });
	        setConfirmDeleteInsuranceIndex(index);
	        setPatientInsuranceId(insuranceId);
	      }
	    };
	  };
	
	  var onAddAdditionalInsuranceButtonClick = function onAddAdditionalInsuranceButtonClick() {
	    addAdditionalInsurance();
	    setExpandedSections(function (prev) {
	      return [].concat((0, _toConsumableArray3.default)(prev), [{ isOpened: true }]);
	    });
	  };
	
	  var removeInsuranceFromList = function removeInsuranceFromList() {
	    handleDeleteAdditionalInsuranceFromFormState(confirmDeleteInsuranceIndex);
	
	    closeDeleteAdditionalInsuranceModal();
	  };
	
	  var handleDeleteAdditionalInsurance = function handleDeleteAdditionalInsurance() {
	    if (patientInsuranceId) {
	      dispatch(_deletePatientInsurance.actions.send({ userId: userId, patientInsuranceId: patientInsuranceId }));
	    } else {
	      removeInsuranceFromList();
	    }
	  };
	
	  var handleOnImageChange = function handleOnImageChange(index, insuranceId) {
	    return function (fieldName, imgValue, imgId) {
	      dispatch(_manageInsurancesActions.manageInsurancesActions.uploadInsuranceCard((0, _extends3.default)({
	        fieldName: fieldName,
	        flowType: flowType,
	        imgId: imgId,
	        imgValue: imgValue,
	        patientInsuranceId: insuranceId,
	        userId: userId,
	        handleAdditionalInsuranceFormChange: handleAdditionalInsuranceFormChange(index)
	      }, taskAssignmentId && { taskAssignmentId: taskAssignmentId })));
	    };
	  };
	
	  (0, _react.useEffect)(function () {
	    if (isInsuranceDeleteSucceeded) {
	      removeInsuranceFromList();
	      dispatch(_getPatientInsurancesList.actions.removePatientInsuranceFromList({
	        id: patientInsuranceId
	      }));
	      dispatch(_deletePatientInsurance.actions.clear());
	    }
	  }, [isInsuranceDeleteSucceeded]);
	
	  (0, _react.useEffect)(function () {
	    var additionalInsurancesAreExisting = (0, _get2.default)(additionalInsurances, 'length', 0);
	
	    if (additionalInsurancesAreExisting) {
	      var initialState = additionalInsurances.map(function () {
	        return {
	          isOpened: false
	        };
	      });
	      setExpandedSections(initialState);
	    }
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _index2.default.wrapper },
	    _react2.default.createElement(
	      'section',
	      { className: _index2.default.additionalInsurance },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.additionalInsuranceTitle },
	        additionalInsuranceTitle
	      )
	    ),
	    additionalInsurances.map(function (insurance, index) {
	      var _ref2 = insurance || {},
	          formState = _ref2.formState,
	          formErrors = _ref2.formErrors;
	
	      var isAdditionalInsurancePrimarySubscriber = Boolean(formState[PRIMARY_SUBSCRIBER]);
	
	      var insuranceId = (0, _get2.default)(formState, 'id');
	
	      var fieldName = 'additionalInsurance-' + index + '-documents';
	
	      var healthPlan = (0, _get2.default)(formState, 'healthPlan', null);
	      var isPlanNotListedSelected = Boolean(healthPlan && !healthPlan.id);
	
	      var documents = [{
	        key: fieldName + '_1',
	        attachment: (0, _get2.default)(formState, 'frontSide')
	      }, {
	        key: fieldName + '_2',
	        attachment: (0, _get2.default)(formState, 'backSide')
	      }];
	
	      var insuranceDocumentsConfig = (0, _getDocumentsConfig.getAdditionalInsuranceCardDocumentsConfig)({
	        formatMessage: formatMessage,
	        userDocuments: documents,
	        isEditMode: true,
	        fieldName: fieldName
	      });
	
	      var isSectionOpened = (0, _get2.default)(expandedSections[index], 'isOpened') || false;
	
	      var showError = (0, _checkIsNeedToShowErrorMessage.checkIsNeedToShowErrorMessage)({
	        flowType: flowType,
	        insuranceData: formState,
	        hideInsuranceRelationFieldOrInfo: hideInsuranceRelationFieldOrInfo,
	        frozenAdditionalInsurancesListIds: frozenAdditionalInsurancesListIds
	      });
	
	      return _react2.default.createElement(
	        _AdditionalInsuranceCollapse2.default,
	        {
	          flowType: flowType,
	          key: 'additional-insurance-' + index,
	          opened: isSectionOpened,
	          onClick: handleSectionToggle(index),
	          showError: showError
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(_index2.default.additionalInsuranceFormWrapper, (0, _defineProperty3.default)({}, _index2.default.additionalInsuranceFormWrapper_additionalStyles, withAdditionalStyles))
	          },
	          showError && _react2.default.createElement(_PlainTextErrorBlock2.default, {
	            errors: additionalInsuranceFormDetailsError,
	            className: _index2.default.errorBlock
	          }),
	          _react2.default.createElement(_DocumentsSection2.default, {
	            config: insuranceDocumentsConfig,
	            documents: documents,
	            onImageChange: handleOnImageChange(index, insuranceId)
	          }),
	          _react2.default.createElement(_MainInsuranceFormSection2.default, {
	            formState: formState,
	            handleHealthPlanChange: handleAdditionalInsuranceHealthPlanChange(index),
	            isPlanNotListedSelected: isPlanNotListedSelected,
	            entities: entities,
	            handleInputChange: handleInputChange,
	            handleMenuScrollToBottom: handleMenuScrollToBottom,
	            isLoading: isLoading,
	            handleFormChange: handleAdditionalInsuranceFormChange(index)
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: _index2.default.primarySubscriberCheckbox },
	            _react2.default.createElement(_Checkbox2.default, {
	              size: 16,
	              label: primarySubscriberCheckboxLabel,
	              disabled: isPlanNotListedSelected,
	              id: 'additionalInsurance-' + index + '-' + PRIMARY_SUBSCRIBER,
	              checked: isAdditionalInsurancePrimarySubscriber,
	              onChange: handleAdditionalInsurancePrimarySubscriberChange(index)
	            })
	          ),
	          !isAdditionalInsurancePrimarySubscriber && _react2.default.createElement(_PrimarySubscriberFormSection2.default, {
	            formErrors: formErrors,
	            formState: formState,
	            handleChangeField: handleAdditionalInsuranceChangeField(index),
	            handleFormChange: handleAdditionalInsuranceFormChange(index)
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)(_index2.default.deleteInsuranceButtonWrapper, (0, _defineProperty3.default)({}, _index2.default.deleteInsuranceButtonWrapper_additionalStyles, withAdditionalStyles))
	            },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                type: 'button',
	                raised: true,
	                onClick: toggleConfirmation(index, insuranceId),
	                color: 'accent',
	                className: _index2.default.deleteInsuranceButton
	              },
	              deleteInsuranceTitle
	            )
	          )
	        )
	      );
	    }),
	    showAddAdditionalInsuranceButton && _react2.default.createElement(
	      _Button2.default,
	      {
	        type: 'button',
	        raised: true,
	        className: _index2.default.addInsuranceButton,
	        onClick: onAddAdditionalInsuranceButtonClick,
	        color: 'accent'
	      },
	      _react2.default.createElement(_Icon2.default, { name: 'plus', size: 16 }),
	      addInsuranceTitle
	    ),
	    opened && _react2.default.createElement(_DeleteAdditionalInsuranceConfirmationModal2.default, {
	      onClose: closeDeleteAdditionalInsuranceModal,
	      onDelete: handleDeleteAdditionalInsurance
	    })
	  );
	};
	
	AdditionalInsurancesSection.propTypes = {
	  addAdditionalInsurance: _propTypes2.default.func,
	  additionalInsurances: _propTypes2.default.array,
	  deleteAdditionalInsurance: _propTypes2.default.func,
	  entities: _propTypes2.default.array,
	  flowType: _propTypes2.default.string,
	  frozenAdditionalInsurancesListIds: _propTypes2.default.array,
	  handleAdditionalInsuranceChangeField: _propTypes2.default.func,
	  handleAdditionalInsuranceFormChange: _propTypes2.default.func,
	  handleAdditionalInsuranceHealthPlanChange: _propTypes2.default.func,
	  handleAdditionalInsurancePrimarySubscriberChange: _propTypes2.default.func,
	  handleInputChange: _propTypes2.default.func,
	  handleMenuScrollToBottom: _propTypes2.default.func,
	  isLoading: _propTypes2.default.bool,
	  primarySubscriberCheckboxLabel: _propTypes2.default.string,
	  taskAssignmentId: _propTypes2.default.number,
	  userId: _propTypes2.default.number
	};
	
	exports.default = (0, _react.memo)(AdditionalInsurancesSection);

/***/ }),
/* 3893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkIsNeedToShowErrorMessage = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _getInitialInsuranceFormValues = __webpack_require__(1387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkIsNeedToShowErrorMessage = exports.checkIsNeedToShowErrorMessage = function checkIsNeedToShowErrorMessage(_ref) {
	  var flowType = _ref.flowType,
	      insuranceData = _ref.insuranceData,
	      hideInsuranceRelationFieldOrInfo = _ref.hideInsuranceRelationFieldOrInfo,
	      frozenAdditionalInsurancesListIds = _ref.frozenAdditionalInsurancesListIds;
	
	  var insuranceId = (0, _get2.default)(insuranceData, 'id');
	
	  if (![_insuranceFlowType.INSURANCE_FLOW_TYPE.GET_CARE_FLOW, _insuranceFlowType.INSURANCE_FLOW_TYPE.PAPERWORK].includes(flowType)) {
	    return false;
	  }
	
	  var isAllRequiredFieldsFilled = (0, _getInitialInsuranceFormValues.validateInsuranceFormFields)({
	    formState: insuranceData,
	    hideInsuranceRelationFieldOrInfo: hideInsuranceRelationFieldOrInfo
	  });
	
	  return !isAllRequiredFieldsFilled && (frozenAdditionalInsurancesListIds || []).includes(insuranceId);
	};

/***/ }),
/* 3894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Popup = __webpack_require__(40);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _deletePatientInsurance = __webpack_require__(1892);
	
	var _index = __webpack_require__(5246);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeleteAdditionalInsuranceConfirmationModal = function DeleteAdditionalInsuranceConfirmationModal(_ref) {
	  var onClose = _ref.onClose,
	      onDelete = _ref.onDelete;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var loading = (0, _reactRedux.useSelector)(_deletePatientInsurance.selectInsuranceIsDeleting);
	
	  var title = formatMessage({ id: 'paperwork.modal.confirmDeleteInsurance' });
	
	  var subtitle = formatMessage({
	    id: 'paperwork.modal.deleteInsuranceWarning'
	  });
	
	  var deleteButtonTitle = formatMessage({
	    id: 'common.deleteInsurance'
	  });
	
	  var cancelButtonTitle = formatMessage({
	    id: 'common.cancel'
	  });
	
	  return _react2.default.createElement(
	    _Popup2.default,
	    { opened: true, withHeading: false, mobileFullScreen: false },
	    _react2.default.createElement(
	      'section',
	      { className: _index2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.title },
	        title
	      ),
	      subtitle,
	      _react2.default.createElement(
	        'div',
	        { className: _index2.default.buttonWrapper },
	        _react2.default.createElement(
	          _Button2.default,
	          { color: 'primary', onClick: onDelete, type: 'button', raised: true },
	          loading ? _react2.default.createElement(_Loader2.default, { className: _index2.default.loader }) : deleteButtonTitle
	        ),
	        _react2.default.createElement(_Button2.default, {
	          color: 'accent',
	          raised: true,
	          type: 'button',
	          onClick: onClose,
	          children: cancelButtonTitle
	        })
	      )
	    )
	  );
	};
	
	DeleteAdditionalInsuranceConfirmationModal.propTypes = {
	  onClose: _propTypes2.default.func.isRequired,
	  onDelete: _propTypes2.default.func.isRequired
	};
	
	exports.default = DeleteAdditionalInsuranceConfirmationModal;

/***/ }),
/* 3895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Loader = __webpack_require__(35);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _common = __webpack_require__(864);
	
	var _index = __webpack_require__(5248);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FormButtons = function FormButtons(_ref) {
	  var flowType = _ref.flowType,
	      _ref$cancel = _ref.cancel,
	      cancel = _ref$cancel === undefined ? function () {} : _ref$cancel,
	      disableSubmitButton = _ref.disableSubmitButton;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var isInsuranceToDoTaskCompleting = (0, _reactRedux.useSelector)(_common.selectInsuranceToDoTaskCompleting);
	
	  switch (flowType) {
	    case _insuranceFlowType.INSURANCE_FLOW_TYPE.PROFILE:
	      {
	        return _react2.default.createElement(
	          'div',
	          { className: _index2.default.profileFlowButtonWrapper },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              raised: true,
	              color: 'primary',
	              className: _index2.default.profileFlowButton,
	              disabled: disableSubmitButton,
	              type: 'submit'
	            },
	            formatMessage({ id: 'common.save' })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              raised: true,
	              color: 'accent',
	              onClick: cancel,
	              className: _index2.default.profileFlowButton
	            },
	            formatMessage({ id: 'common.cancel' })
	          )
	        );
	      }
	
	    case _insuranceFlowType.INSURANCE_FLOW_TYPE.PAPERWORK:
	    case _insuranceFlowType.INSURANCE_FLOW_TYPE.GET_CARE_FLOW:
	      {
	        return _react2.default.createElement(
	          'div',
	          { className: _index2.default.paperworkFlowButtonWrapper },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: _index2.default.paperworkFlowButton,
	              raised: true,
	              color: 'primary',
	              type: 'submit',
	              disabled: disableSubmitButton
	            },
	            formatMessage({ id: 'common.next' })
	          )
	        );
	      }
	
	    case _insuranceFlowType.INSURANCE_FLOW_TYPE.TO_DO:
	      {
	        return _react2.default.createElement(
	          'div',
	          { className: _index2.default.toDoFlowButtonsWrapper },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              color: 'accent',
	              className: _index2.default.toDoFlowButton,
	              onClick: cancel
	            },
	            formatMessage({
	              id: 'common.cancel'
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              color: 'primary',
	              type: 'submit',
	              className: _index2.default.toDoFlowButton,
	              disabled: disableSubmitButton
	            },
	            isInsuranceToDoTaskCompleting ? _react2.default.createElement(_Loader2.default, { className: _index2.default.toDoFlowLoader }) : formatMessage({ id: 'common.complete' })
	          )
	        );
	      }
	
	    default:
	      return null;
	  }
	};
	
	FormButtons.propTypes = {
	  cancel: _propTypes2.default.func,
	  disableSubmitButton: _propTypes2.default.bool,
	  flowType: _propTypes2.default.oneOf((0, _keys2.default)(_insuranceFlowType.INSURANCE_FLOW_TYPE))
	};
	
	exports.default = FormButtons;

/***/ }),
/* 3896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Icon = __webpack_require__(13);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _stylesModule = __webpack_require__(5249);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequiredAdditionalInsuranceDataError = function RequiredAdditionalInsuranceDataError() {
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.wrapper },
	    _react2.default.createElement(_Icon2.default, { size: 16, name: 'icon-info', className: _stylesModule2.default.icon }),
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'common.requiredInformationMissing' })
	  );
	};
	
	exports.default = RequiredAdditionalInsuranceDataError;

/***/ }),
/* 3897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usePCPForm = function usePCPForm(initialPCPAnswer) {
	  var _useState = (0, _react.useState)(initialPCPAnswer || null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      pcpAnswer = _useState2[0],
	      setPcpAnswer = _useState2[1];
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var answers = {
	    Y: formatMessage({ id: 'common.yes' }),
	    N: formatMessage({ id: 'common.no' }),
	    U: formatMessage({ id: 'common.preferNotToSay' })
	  };
	
	  var optionsList = (0, _entries2.default)(answers).map(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        k = _ref2[0],
	        v = _ref2[1];
	
	    return {
	      label: v,
	      value: k
	    };
	  });
	
	  var handleOptionChange = (0, _react.useCallback)(function (value) {
	    setPcpAnswer(value);
	  }, []);
	
	  return { pcpAnswer: pcpAnswer, handleOptionChange: handleOptionChange, optionsList: optionsList };
	};
	
	exports.default = usePCPForm;

/***/ }),
/* 3898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SingleSelect = __webpack_require__(257);
	
	var _SingleSelect2 = _interopRequireDefault(_SingleSelect);
	
	var _usePCPForm2 = __webpack_require__(3897);
	
	var _usePCPForm3 = _interopRequireDefault(_usePCPForm2);
	
	var _index = __webpack_require__(5251);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrimaryCareProviderForm = function PrimaryCareProviderForm(_ref) {
	  var handleNext = _ref.handleNext,
	      initialPCPAnswer = _ref.initialPCPAnswer;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _usePCPForm = (0, _usePCPForm3.default)(initialPCPAnswer),
	      pcpAnswer = _usePCPForm.pcpAnswer,
	      handleOptionChange = _usePCPForm.handleOptionChange,
	      optionsList = _usePCPForm.optionsList;
	
	  var onSubmit = function onSubmit(e) {
	    e.preventDefault();
	    handleNext(pcpAnswer);
	  };
	
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: onSubmit },
	    _react2.default.createElement(_SingleSelect2.default, {
	      name: 'pcpQ',
	      list: optionsList,
	      radioInputClass: _index2.default.list,
	      onChange: handleOptionChange,
	      selectedValue: pcpAnswer
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt4 tr' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          type: 'submit',
	          raised: true,
	          color: 'primary',
	          disabled: !pcpAnswer,
	          className: _index2.default.button
	        },
	        formatMessage({ id: 'common.next' })
	      )
	    )
	  );
	};
	
	PrimaryCareProviderForm.propTypes = {
	  handleNext: PropTypes.func.isRequired,
	  initialPCPAnswer: PropTypes.string
	};
	
	exports.default = PrimaryCareProviderForm;

/***/ }),
/* 3899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(220);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _react = __webpack_require__(1);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _pcpAnswer = __webpack_require__(617);
	
	var _getPCPDictionaries2 = __webpack_require__(358);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INITIAL_FORM_STATE = {
	  pcpProviderAnswer: null,
	  pcpName: '',
	  considerUsPcp: null,
	  pcp: null
	};
	
	var toOptionsList = function toOptionsList(dict) {
	  return (0, _entries2.default)(dict).map(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        value = _ref2[0],
	        label = _ref2[1];
	
	    return { label: label, value: value };
	  });
	};
	
	var usePCPWithExtraFieldsForm = function usePCPWithExtraFieldsForm(initialValues) {
	  var _useState = (0, _react.useState)(INITIAL_FORM_STATE),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      formData = _useState2[0],
	      setFormData = _useState2[1];
	
	  var pcpNameFieldRef = (0, _react.useRef)(null);
	
	  var focusTimeoutRef = (0, _react.useRef)(null);
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var _getPCPDictionaries = (0, _getPCPDictionaries2.getPCPDictionaries)({
	    formatMessage: formatMessage
	  }),
	      considerUsAsYourPCPAnswers = _getPCPDictionaries.considerUsAsYourPCPAnswers,
	      pcpAnswers = _getPCPDictionaries.pcpAnswers;
	
	  var optionsList = (0, _react.useMemo)(function () {
	    return toOptionsList(pcpAnswers);
	  }, [pcpAnswers]);
	
	  var considerUsAsYourPCPOptions = (0, _react.useMemo)(function () {
	    return toOptionsList(considerUsAsYourPCPAnswers);
	  }, [considerUsAsYourPCPAnswers]);
	
	  var pcpYes = formData.pcpProviderAnswer === optionsList[0].value;
	  var pcpNo = formData.pcpProviderAnswer === optionsList[1].value;
	
	  var isPcpNameNotListedSelected = (0, _get2.default)(formData, 'pcp.value', '') === _pcpAnswer.PCP_NOT_LISTED_VALUE;
	
	  var isNextButtonDisabled = (0, _react.useMemo)(function () {
	    if (!formData.pcpProviderAnswer) {
	      return true;
	    }
	
	    if (pcpYes) {
	      if (isPcpNameNotListedSelected && !formData.pcpName.trim()) {
	        return true;
	      }
	
	      if (!formData.pcp) {
	        return true;
	      }
	    }
	
	    if (pcpNo && !formData.considerUsPcp) {
	      return true;
	    }
	
	    return false;
	  }, [formData, isPcpNameNotListedSelected]);
	
	  var showPcpNameField = pcpYes && isPcpNameNotListedSelected;
	
	  var handleOptionChange = (0, _react.useCallback)(function (value) {
	    return function () {
	      setFormData(function (prevState) {
	        return (0, _extends3.default)({}, prevState, { pcpProviderAnswer: value });
	      });
	    };
	  }, []);
	
	  var handlePcpNameChange = (0, _react.useCallback)(function (value) {
	    setFormData(function (prevState) {
	      return (0, _extends3.default)({}, prevState, { pcpName: value.trim() });
	    });
	  }, []);
	
	  var handleConsiderUsAsYourPCPChange = (0, _react.useCallback)(function (item) {
	    var selectedValue = (0, _get2.default)(item, 'value', null);
	
	    setFormData(function (prevState) {
	      return (0, _extends3.default)({}, prevState, {
	        considerUsPcp: selectedValue
	      });
	    });
	  }, []);
	
	  var handlePcpChange = (0, _react.useCallback)(function (item) {
	    var isPcpNotListedOption = (0, _get2.default)(item, 'value', '') === _pcpAnswer.PCP_NOT_LISTED_VALUE;
	
	    setFormData(function (prevState) {
	      return (0, _extends3.default)({}, prevState, {
	        pcp: item,
	        pcpName: INITIAL_FORM_STATE.pcpName
	      });
	    });
	
	    if (focusTimeoutRef.current) {
	      clearTimeout(focusTimeoutRef.current);
	      focusTimeoutRef.current = null;
	    }
	
	    if (pcpNameFieldRef.current && isPcpNotListedOption) {
	      focusTimeoutRef.current = setTimeout(function () {
	        return pcpNameFieldRef.current.focus();
	      }, 200);
	      focusTimeoutRef.current = null;
	    }
	  }, []);
	
	  var setPcpNameFieldRef = (0, _react.useCallback)(function (node) {
	    pcpNameFieldRef.current = node;
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (initialValues) {
	      setFormData(function (prevState) {
	        return (0, _extends3.default)({}, prevState, initialValues);
	      });
	    }
	  }, [initialValues]);
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      if (focusTimeoutRef.current) {
	        clearTimeout(focusTimeoutRef.current);
	      }
	    };
	  }, []);
	
	  return {
	    considerUsAsYourPCPOptions: considerUsAsYourPCPOptions,
	    formData: formData,
	    handleConsiderUsAsYourPCPChange: handleConsiderUsAsYourPCPChange,
	    handleOptionChange: handleOptionChange,
	    handlePcpNameChange: handlePcpNameChange,
	    handlePcpChange: handlePcpChange,
	    isNextButtonDisabled: isNextButtonDisabled,
	    optionsList: optionsList,
	    pcpNo: pcpNo,
	    pcpYes: pcpYes,
	    setPcpNameFieldRef: setPcpNameFieldRef,
	    showPcpNameField: showPcpNameField
	  };
	};
	
	exports.default = usePCPWithExtraFieldsForm;

/***/ }),
/* 3900 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ERROR_CODES = exports.ERROR_CODES = {
	  RECORD_NOT_FOUND: 'record_not_found'
	};

/***/ }),
/* 3901 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PAYMENT_METHODS = exports.PAYMENT_METHODS = {
	  ACCOUNT_FORM: 'account_form',
	  HOSTED_PAYMENT_PAGE: 'hosted_payment_page'
	};

/***/ }),
/* 3902 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TASK_ATTACHMENT_LIMIT = exports.TASK_ATTACHMENT_LIMIT = 5;

/***/ }),
/* 3903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useForm = useForm;
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useForm(_ref) {
	  var initialValues = _ref.initialValues,
	      onSubmit = _ref.onSubmit,
	      validate = _ref.validate;
	
	  var _useState = (0, _react.useState)(initialValues || {}),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      values = _useState2[0],
	      setValues = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({}),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      errors = _useState4[0],
	      setErrors = _useState4[1];
	
	  var handleSubmit = function handleSubmit(event) {
	    event.preventDefault();
	    onSubmit(values);
	  };
	
	  var handleChange = function handleChange(fieldName, value) {
	    var error = validate(fieldName, value);
	    setValues((0, _extends5.default)({}, values, (0, _defineProperty3.default)({}, fieldName, value)));
	    setErrors((0, _extends5.default)({}, errors, (0, _defineProperty3.default)({}, fieldName, error)));
	  };
	
	  return { values: values, errors: errors, handleSubmit: handleSubmit, handleChange: handleChange };
	}

/***/ }),
/* 3904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withLoggedIn = undefined;
	
	var _recompose = __webpack_require__(22);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(93);
	
	var withLoggedIn = exports.withLoggedIn = (0, _recompose.compose)((0, _reactRedux.connect)(function (state) {
	  return { isLoggedIn: (0, _selectors.isLoggedInSelector)(state) };
	}));

/***/ }),
/* 3905 */,
/* 3906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _formFields = __webpack_require__(38);
	
	var _initialInsuranceFormState = __webpack_require__(1209);
	
	var _useValidatePatientInsuranceForm = __webpack_require__(1857);
	
	var _useValidatePatientInsuranceForm2 = _interopRequireDefault(_useValidatePatientInsuranceForm);
	
	var _useInsuranceRelationOptions = __webpack_require__(621);
	
	var _useInsuranceRelationOptions2 = _interopRequireDefault(_useInsuranceRelationOptions);
	
	var _getInitialInsuranceFormValues = __webpack_require__(1387);
	
	var _getPatientInsurancesList = __webpack_require__(671);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRIMARY_SUBSCRIBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PRIMARY_SUBSCRIBER,
	    HEALTH_PLAN = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.HEALTH_PLAN,
	    GROUP_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GROUP_NUMBER,
	    MEMBER_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.MEMBER_ID,
	    DO_NOT_HAVE_INSURANCE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DO_NOT_HAVE_INSURANCE;
	
	
	var INITIAL_STATE = [];
	
	var reducer = function reducer(state, action) {
	  switch (action.type) {
	    case 'ADD':
	      {
	        return [].concat((0, _toConsumableArray3.default)(state), [{
	          formState: (0, _extends5.default)({}, (0, _omit2.default)(_initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE, DO_NOT_HAVE_INSURANCE), (0, _defineProperty3.default)({}, PRIMARY_SUBSCRIBER, action.payload.isPrimarySubscriber)),
	          formErrors: {}
	        }]);
	      }
	
	    case 'REMOVE':
	      {
	        var index = action.payload.index;
	
	        return state.filter(function (_, i) {
	          return i !== index;
	        });
	      }
	
	    case 'UPDATE':
	      {
	        var _action$payload = action.payload,
	            _index = _action$payload.index,
	            rest = (0, _objectWithoutProperties3.default)(_action$payload, ['index']);
	
	
	        return state.map(function (item, idx) {
	          if (idx === _index) {
	            return (0, _extends5.default)({}, item, {
	              formState: (0, _extends5.default)({}, item.formState, rest)
	            });
	          }
	          return item;
	        });
	      }
	
	    case 'SET_ERRORS':
	      {
	        var _action$payload2 = action.payload,
	            _index2 = _action$payload2.index,
	            errors = _action$payload2.errors;
	
	
	        return state.map(function (item, idx) {
	          if (idx === _index2) {
	            return (0, _extends5.default)({}, item, {
	              formErrors: errors
	            });
	          }
	          return item;
	        });
	      }
	
	    case 'CLEAR_ERROR':
	      {
	        var _action$payload3 = action.payload,
	            _index3 = _action$payload3.index,
	            fieldName = _action$payload3.fieldName;
	
	
	        return state.map(function (item, idx) {
	          if (idx === _index3) {
	            var formErrors = item.formErrors;
	            var removedError = formErrors[fieldName],
	                restErrors = (0, _objectWithoutProperties3.default)(formErrors, [fieldName]);
	
	
	            return (0, _extends5.default)({}, item, {
	              formErrors: restErrors
	            });
	          }
	          return item;
	        });
	      }
	
	    case 'CLEAR_ALL_ERRORS':
	      {
	        var _index4 = action.payload.index;
	
	
	        return state.map(function (item, idx) {
	          if (idx === _index4) {
	            return (0, _extends5.default)({}, item, {
	              formErrors: {}
	            });
	          }
	          return item;
	        });
	      }
	
	    default:
	      return state;
	  }
	};
	
	function useFirstNonEmptyArray(value) {
	  var ref = (0, _react.useRef)(null);
	
	  if (ref.current === null && value.length > 0) {
	    ref.current = value;
	  }
	
	  return ref.current;
	}
	
	var useAdditionalInsurance = function useAdditionalInsurance() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      isPrimarySubscriberDefault = _ref.isPrimarySubscriberDefault;
	
	  var additionalInsurancesList = (0, _reactRedux.useSelector)(_getPatientInsurancesList.selectPatientInsurancesList);
	
	  var additionalInsurancesListIds = (0, _reactRedux.useSelector)(_getPatientInsurancesList.selectPatientInsurancesListIds);
	
	  // snapshot, used to understand where to show error message related to
	  // additional insurances forms
	  var frozenAdditionalInsurancesListIds = useFirstNonEmptyArray(additionalInsurancesListIds);
	
	  var init = (0, _react.useCallback)(function () {
	    if (!additionalInsurancesList.length) {
	      return INITIAL_STATE;
	    }
	
	    var additionalInsurancesFormValues = additionalInsurancesList.reduce(function (acc, item) {
	      var formValues = (0, _getInitialInsuranceFormValues.getInitialInsuranceFormValues)({
	        insurance: item,
	        isAdditionalInsurance: true
	      });
	
	      acc.push({ formState: formValues, formErrors: {} });
	
	      return acc;
	    }, []);
	
	    return additionalInsurancesFormValues;
	  }, [additionalInsurancesList]);
	
	  var _useReducer = (0, _react.useReducer)(reducer, INITIAL_STATE, init),
	      _useReducer2 = (0, _slicedToArray3.default)(_useReducer, 2),
	      additionalInsurances = _useReducer2[0],
	      dispatch = _useReducer2[1];
	
	  var _useInsuranceRelation = (0, _useInsuranceRelationOptions2.default)(),
	      hideInsuranceRelationFieldOrInfo = _useInsuranceRelation.hideInsuranceRelationFieldOrInfo;
	
	  var _useValidatePatientIn = (0, _useValidatePatientInsuranceForm2.default)(),
	      validateFormFields = _useValidatePatientIn.validateFormFields;
	
	  var isAdditionalInsurancesFormsValid = (0, _react.useMemo)(function () {
	    return additionalInsurances.every(function (_ref2) {
	      var formState = _ref2.formState,
	          formErrors = _ref2.formErrors;
	
	      var isFormStateValid = (0, _getInitialInsuranceFormValues.validateInsuranceFormFields)({
	        formState: formState,
	        hideInsuranceRelationFieldOrInfo: hideInsuranceRelationFieldOrInfo
	      });
	
	      var hasErrors = (0, _values2.default)(formErrors).some(Boolean);
	
	      return isFormStateValid && !hasErrors;
	    });
	  }, [additionalInsurances, hideInsuranceRelationFieldOrInfo]);
	
	  var addAdditionalInsurance = (0, _react.useCallback)(function () {
	    dispatch({
	      type: 'ADD',
	      payload: { isPrimarySubscriber: isPrimarySubscriberDefault }
	    });
	  }, [isPrimarySubscriberDefault]);
	
	  var deleteAdditionalInsurance = (0, _react.useCallback)(function (index) {
	    return function () {
	      dispatch({ type: 'REMOVE', payload: { index: index } });
	    };
	  }, []);
	
	  var handleAdditionalInsurancePrimarySubscriberChange = (0, _react.useCallback)(function (index) {
	    return function (value) {
	      dispatch({
	        type: 'UPDATE',
	        payload: (0, _defineProperty3.default)({ index: index }, PRIMARY_SUBSCRIBER, value)
	      });
	
	      dispatch({
	        type: 'CLEAR_ALL_ERRORS',
	        payload: { index: index }
	      });
	    };
	  }, []);
	
	  var handleAdditionalInsuranceHealthPlanChange = (0, _react.useCallback)(function (index) {
	    return function (plan) {
	      var _ref3;
	
	      dispatch({
	        type: 'UPDATE',
	        payload: (0, _extends5.default)((0, _defineProperty3.default)({
	          index: index
	        }, HEALTH_PLAN, plan), !plan.id && (_ref3 = {}, (0, _defineProperty3.default)(_ref3, MEMBER_ID, ''), (0, _defineProperty3.default)(_ref3, GROUP_NUMBER, ''), _ref3))
	      });
	    };
	  }, []);
	
	  var handleAdditionalInsuranceFormChange = (0, _react.useCallback)(function (index) {
	    return function (value) {
	      dispatch({
	        type: 'UPDATE',
	        payload: (0, _extends5.default)({ index: index }, value)
	      });
	    };
	  }, []);
	
	  var handleAdditionalInsuranceChangeField = (0, _react.useCallback)(function (index) {
	    return function (fieldName) {
	      return function (value) {
	        var data = (0, _defineProperty3.default)({}, fieldName, value);
	
	        dispatch({
	          type: 'UPDATE',
	          payload: (0, _extends5.default)({ index: index }, data)
	        });
	
	        dispatch({
	          type: 'CLEAR_ERROR',
	          payload: { index: index, fieldName: fieldName }
	        });
	      };
	    };
	  }, []);
	
	  var validateAdditionalInsurancesFormFields = function validateAdditionalInsurancesFormFields() {
	    var isValid = true;
	
	    additionalInsurances.forEach(function (_ref4, index) {
	      var formState = _ref4.formState;
	
	      var _validateFormFields = validateFormFields(formState),
	          isFormValid = _validateFormFields.isValid,
	          errors = _validateFormFields.errors;
	
	      if (!isFormValid) {
	        isValid = false;
	        dispatch({
	          type: 'SET_ERRORS',
	          payload: { index: index, errors: errors }
	        });
	      }
	    });
	
	    return { isValid: isValid };
	  };
	
	  return {
	    addAdditionalInsurance: addAdditionalInsurance,
	    additionalInsurances: additionalInsurances,
	    deleteAdditionalInsurance: deleteAdditionalInsurance,
	    frozenAdditionalInsurancesListIds: frozenAdditionalInsurancesListIds,
	    handleAdditionalInsuranceChangeField: handleAdditionalInsuranceChangeField,
	    handleAdditionalInsuranceFormChange: handleAdditionalInsuranceFormChange,
	    handleAdditionalInsuranceHealthPlanChange: handleAdditionalInsuranceHealthPlanChange,
	    handleAdditionalInsurancePrimarySubscriberChange: handleAdditionalInsurancePrimarySubscriberChange,
	    isAdditionalInsurancesFormsValid: isAdditionalInsurancesFormsValid,
	    validateAdditionalInsurancesFormFields: validateAdditionalInsurancesFormFields
	  };
	};
	
	exports.default = useAdditionalInsurance;

/***/ }),
/* 3907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(6);
	
	var _selectors = __webpack_require__(23);
	
	var useGetPrimarySubscriberTitle = function useGetPrimarySubscriberTitle(_ref) {
	  var formatMessage = _ref.formatMessage,
	      targetUserName = _ref.targetUserName,
	      targetUserId = _ref.targetUserId;
	
	  var loggedUserId = (0, _reactRedux.useSelector)(_selectors.loggedUserIdSelector);
	
	  var isLoggedUser = loggedUserId === targetUserId;
	
	  return (0, _react.useMemo)(function () {
	    if (isLoggedUser) {
	      return formatMessage({ id: 'fields.insurance.mainPrimarySubscriber' });
	    }
	
	    return formatMessage({ id: 'fields.insurance.primarySubscriber' }, { name: targetUserName });
	  }, [isLoggedUser, targetUserName]);
	};
	
	exports.default = useGetPrimarySubscriberTitle;

/***/ }),
/* 3908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(17);
	
	var useInsuranceCards = function useInsuranceCards(_ref) {
	  var frontSide = _ref.frontSide,
	      backSide = _ref.backSide,
	      frontSideKey = _ref.frontSideKey,
	      backSideKey = _ref.backSideKey;
	
	  return (0, _react.useMemo)(function () {
	    return [{
	      key: frontSideKey || _constants.DOCUMENTATION_TYPES.CARD_1,
	      attachment: frontSide
	    }, {
	      key: backSideKey || _constants.DOCUMENTATION_TYPES.CARD_2,
	      attachment: backSide
	    }];
	  }, [frontSide, backSide, frontSideKey, backSideKey]);
	};
	
	exports.default = useInsuranceCards;

/***/ }),
/* 3909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	exports.useInsuranceForm = useInsuranceForm;
	
	var _react = __webpack_require__(1);
	
	var _initialInsuranceFormState = __webpack_require__(1209);
	
	var _useFormWithValidation = __webpack_require__(107);
	
	var _useValidatePatientInsuranceForm = __webpack_require__(1857);
	
	var _useValidatePatientInsuranceForm2 = _interopRequireDefault(_useValidatePatientInsuranceForm);
	
	var _useInsuranceRelationOptions = __webpack_require__(621);
	
	var _useInsuranceRelationOptions2 = _interopRequireDefault(_useInsuranceRelationOptions);
	
	var _getInitialInsuranceFormValues = __webpack_require__(1387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useInsuranceForm(patientInsurance, flowType) {
	  var _useFormState = (0, _useFormWithValidation.useFormState)(_initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE),
	      formState = _useFormState.formState,
	      handleFormChange = _useFormState.handleFormChange;
	
	  var _useInsuranceRelation = (0, _useInsuranceRelationOptions2.default)(),
	      hideInsuranceRelationFieldOrInfo = _useInsuranceRelation.hideInsuranceRelationFieldOrInfo;
	
	  var _useValidatePatientIn = (0, _useValidatePatientInsuranceForm2.default)(),
	      formErrors = _useValidatePatientIn.formErrors,
	      setFormErrors = _useValidatePatientIn.setFormErrors,
	      validateFormFields = _useValidatePatientIn.validateFormFields;
	
	  var isValid = (0, _getInitialInsuranceFormValues.validateInsuranceFormFields)({
	    formState: formState,
	    hideInsuranceRelationFieldOrInfo: hideInsuranceRelationFieldOrInfo
	  }) && !(0, _values2.default)(formErrors).filter(Boolean).length;
	
	  var clearForm = function clearForm() {
	    handleFormChange(_initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (patientInsurance) {
	      var values = (0, _getInitialInsuranceFormValues.getInitialInsuranceFormValues)({
	        insurance: patientInsurance,
	        isAdditionalInsurance: false,
	        flowType: flowType
	      });
	
	      handleFormChange(values);
	    } else {
	      handleFormChange(_initialInsuranceFormState.INITIAL_INSURANCE_FORM_STATE);
	    }
	  }, []);
	
	  return (0, _react.useMemo)(function () {
	    return {
	      clearForm: clearForm,
	      formErrors: formErrors,
	      formState: formState,
	      handleFormChange: handleFormChange,
	      isValid: isValid,
	      setFormErrors: setFormErrors,
	      validateFormFields: validateFormFields
	    };
	  }, [clearForm, formErrors, formState, handleFormChange, isValid, setFormErrors, validateFormFields]);
	}

/***/ }),
/* 3910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _useInsuranceForm2 = __webpack_require__(3909);
	
	var _useGetHaveInsuranceLabel = __webpack_require__(1856);
	
	var _useGetHaveInsuranceLabel2 = _interopRequireDefault(_useGetHaveInsuranceLabel);
	
	var _useGetPrimarySubscriberTitle = __webpack_require__(3907);
	
	var _useGetPrimarySubscriberTitle2 = _interopRequireDefault(_useGetPrimarySubscriberTitle);
	
	var _formFields = __webpack_require__(38);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRIMARY_SUBSCRIBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.PRIMARY_SUBSCRIBER,
	    HEALTH_PLAN = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.HEALTH_PLAN,
	    MEMBER_ID = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.MEMBER_ID,
	    GROUP_NUMBER = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.GROUP_NUMBER,
	    DO_NOT_HAVE_INSURANCE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DO_NOT_HAVE_INSURANCE;
	
	
	var useInsuranceFormManager = function useInsuranceFormManager(_ref) {
	  var insuranceData = _ref.insuranceData,
	      userId = _ref.userId,
	      userName = _ref.userName,
	      withSelfPayEnding = _ref.withSelfPayEnding,
	      flowType = _ref.flowType;
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var checkInsuranceLoading = (0, _reactRedux.useSelector)(_selectors.selectCheckInsuranceEligibilityLoading);
	
	  var _useInsuranceForm = (0, _useInsuranceForm2.useInsuranceForm)(insuranceData, flowType),
	      formErrors = _useInsuranceForm.formErrors,
	      formState = _useInsuranceForm.formState,
	      handleFormChange = _useInsuranceForm.handleFormChange,
	      isValid = _useInsuranceForm.isValid,
	      setFormErrors = _useInsuranceForm.setFormErrors,
	      validateFormFields = _useInsuranceForm.validateFormFields;
	
	  var haveInsuranceCheckboxLabel = (0, _useGetHaveInsuranceLabel2.default)({
	    formatMessage: formatMessage,
	    targetUserName: userName,
	    targetUserId: userId,
	    withSelfPayEnding: withSelfPayEnding
	  });
	
	  var primarySubscriberCheckboxLabel = (0, _useGetPrimarySubscriberTitle2.default)({
	    formatMessage: formatMessage,
	    targetUserId: userId,
	    targetUserName: userName
	  });
	
	  var userHasNotInsurance = Boolean(formState[DO_NOT_HAVE_INSURANCE]);
	
	  var isPrimarySubscriber = formState[PRIMARY_SUBSCRIBER];
	
	  var handleHealthPlanChange = function handleHealthPlanChange(plan) {
	    var _ref2;
	
	    handleFormChange((0, _extends5.default)((0, _defineProperty3.default)({}, HEALTH_PLAN, plan), !plan.id && (_ref2 = {}, (0, _defineProperty3.default)(_ref2, MEMBER_ID, ''), (0, _defineProperty3.default)(_ref2, GROUP_NUMBER, ''), _ref2)));
	  };
	
	  var onHaveInsuranceChange = function onHaveInsuranceChange(value) {
	    var _handleFormChange;
	
	    handleFormChange((_handleFormChange = {}, (0, _defineProperty3.default)(_handleFormChange, DO_NOT_HAVE_INSURANCE, value), (0, _defineProperty3.default)(_handleFormChange, PRIMARY_SUBSCRIBER, true), _handleFormChange));
	  };
	
	  var onPrimarySubscriberChange = function onPrimarySubscriberChange(value) {
	    handleFormChange((0, _defineProperty3.default)({}, PRIMARY_SUBSCRIBER, value));
	    setFormErrors({});
	  };
	
	  var handleChangeField = function handleChangeField(fieldName) {
	    return function (value) {
	      handleFormChange((0, _defineProperty3.default)({}, fieldName, value));
	      setFormErrors(function (prev) {
	        return (0, _extends5.default)({}, prev, (0, _defineProperty3.default)({}, fieldName, undefined));
	      });
	    };
	  };
	
	  return {
	    checkInsuranceLoading: checkInsuranceLoading,
	    formErrors: formErrors,
	    formState: formState,
	    handleChangeField: handleChangeField,
	    handleFormChange: handleFormChange,
	    handleHealthPlanChange: handleHealthPlanChange,
	    haveInsuranceCheckboxLabel: haveInsuranceCheckboxLabel,
	    isPrimarySubscriber: isPrimarySubscriber,
	    isValid: isValid,
	    onHaveInsuranceChange: onHaveInsuranceChange,
	    onPrimarySubscriberChange: onPrimarySubscriberChange,
	    primarySubscriberCheckboxLabel: primarySubscriberCheckboxLabel,
	    userHasNotInsurance: userHasNotInsurance,
	    validateFormFields: validateFormFields
	  };
	};
	
	exports.default = useInsuranceFormManager;

/***/ }),
/* 3911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _debounce = __webpack_require__(176);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _insurancePayersReq = __webpack_require__(800);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LIMIT = 50;
	
	var mapPayerToOption = function mapPayerToOption(payer) {
	  return {
	    id: payer.id,
	    value: payer.name,
	    label: payer.name
	  };
	};
	
	var useHealthPlanList = function useHealthPlanList() {
	  var withPlanNotListedOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useIntl = (0, _reactIntl.useIntl)(),
	      formatMessage = _useIntl.formatMessage;
	
	  var payersList = (0, _reactRedux.useSelector)(_selectors.selectInsurancePayersList);
	  var isLoading = (0, _reactRedux.useSelector)(_selectors.selectInsurancePayersLoading);
	  var isLastPage = (0, _reactRedux.useSelector)(_selectors.selectInsurancePayersIsLastPage);
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      query = _useState2[0],
	      setQuery = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    if (!payersList.length && !isLoading) {
	      dispatch(_insurancePayersReq.actions.send({ limit: LIMIT, offset: 0, query: '' }));
	    }
	  }, []);
	
	  var fetchWithSearch = (0, _react.useCallback)((0, _debounce2.default)(function (searchQuery) {
	    dispatch(_insurancePayersReq.actions.clear());
	    dispatch(_insurancePayersReq.actions.send({
	      limit: LIMIT,
	      offset: 0,
	      query: searchQuery
	    }));
	  }, 500), []);
	
	  var handleInputChange = (0, _react.useCallback)(function (value) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        action = _ref.action;
	
	    if (action !== 'input-change') return;
	    setQuery(value);
	    fetchWithSearch(value);
	  }, [fetchWithSearch]);
	
	  var handleMenuScrollToBottom = (0, _react.useCallback)(function () {
	    if (isLastPage || isLoading) return;
	
	    var nextOffset = payersList.length;
	
	    dispatch(_insurancePayersReq.actions.send({ limit: LIMIT, offset: nextOffset, query: query }));
	  }, [isLastPage, isLoading, payersList.length, query]);
	
	  var planNotListedOption = (0, _react.useMemo)(function () {
	    return {
	      id: null,
	      value: null,
	      label: formatMessage({ id: 'appointments.form.planNotListed' })
	    };
	  }, [formatMessage]);
	
	  var convertedEntities = (0, _react.useMemo)(function () {
	    return payersList.map(mapPayerToOption);
	  }, [payersList]);
	
	  var entities = (0, _react.useMemo)(function () {
	    return withPlanNotListedOption ? [planNotListedOption].concat((0, _toConsumableArray3.default)(convertedEntities)) : convertedEntities;
	  }, [withPlanNotListedOption, planNotListedOption, convertedEntities]);
	
	  return {
	    entities: entities,
	    handleInputChange: handleInputChange,
	    handleMenuScrollToBottom: handleMenuScrollToBottom,
	    isLoading: isLoading
	  };
	};
	
	exports.default = useHealthPlanList;

/***/ }),
/* 3912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var useDidUpdate = function useDidUpdate(callback) {
	  for (var _len = arguments.length, deps = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    deps[_key - 1] = arguments[_key];
	  }
	
	  var didMount = (0, _react.useRef)(false);
	
	  (0, _react.useEffect)(function () {
	    if (didMount.current) {
	      callback();
	    } else {
	      didMount.current = true;
	    }
	  }, deps);
	};
	
	exports.default = useDidUpdate;

/***/ }),
/* 3913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useDocumentPreview = useDocumentPreview;
	
	var _react = __webpack_require__(1);
	
	var _imagePreview = __webpack_require__(1921);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useDocumentPreview() {
	  var userDocuments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      activeImageIdx = _useState2[0],
	      setImageIdx = _useState2[1];
	
	  var images = userDocuments.map(function (_ref) {
	    var url = _ref.attachment.url;
	    return { src: url };
	  });
	
	  (0, _react.useEffect)(function () {
	    return (0, _imagePreview.subscribeImagePreview)(setActiveIndex);
	  }, [userDocuments]);
	
	  function setActiveIndex(activeUrl) {
	    var index = userDocuments.findIndex(function (_ref2) {
	      var thumbMiddle = _ref2.attachment.thumbMiddle;
	      return activeUrl === thumbMiddle;
	    });
	
	    if (index !== -1) {
	      setImageIdx(index);
	    }
	  }
	
	  function resetImageIdx() {
	    setImageIdx(null);
	  }
	
	  function nextImage() {
	    setImageIdx(activeImageIdx + 1);
	  }
	
	  function prevImage() {
	    setImageIdx(activeImageIdx - 1);
	  }
	
	  return {
	    images: images,
	    activeImageIdx: activeImageIdx,
	    resetImageIdx: resetImageIdx,
	    nextImage: nextImage,
	    prevImage: prevImage
	  };
	}

/***/ }),
/* 3914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useIsMobile = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MOBILE_BREAKPOINT = 768;
	var DEBOUNCE_DELAY = 200;
	
	var useIsMobile = exports.useIsMobile = function useIsMobile() {
	  var _useState = (0, _react.useState)(window.innerWidth < MOBILE_BREAKPOINT),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      isMobile = _useState2[0],
	      setIsMobile = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var timeoutId = void 0;
	
	    var handleResize = function handleResize() {
	      clearTimeout(timeoutId);
	      timeoutId = setTimeout(function () {
	        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
	      }, DEBOUNCE_DELAY);
	    };
	
	    window.addEventListener('resize', handleResize);
	    return function () {
	      clearTimeout(timeoutId);
	      window.removeEventListener('resize', handleResize);
	    };
	  }, []);
	
	  return isMobile;
	};

/***/ }),
/* 3915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useOverflow = function useOverflow() {
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      node = _useState2[0],
	      setNode = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    x: false,
	    y: false,
	    any: false
	  }),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      overflow = _useState4[0],
	      setOverflow = _useState4[1];
	
	  var ref = (0, _react.useCallback)(function (el) {
	    setNode(el);
	  }, []);
	
	  var measure = (0, _react.useCallback)(function (el) {
	    if (!el) return;
	
	    var x = el.scrollWidth - el.clientWidth > 1;
	    var y = el.scrollHeight - el.clientHeight > 1;
	
	    setOverflow(function (prev) {
	      if (prev.x === x && prev.y === y && prev.any === (x || y)) {
	        return prev;
	      }
	
	      return { x: x, y: y, any: x || y };
	    });
	  }, []);
	
	  (0, _react.useLayoutEffect)(function () {
	    if (!node) return;
	
	    measure(node);
	
	    var ro = new ResizeObserver(function () {
	      return measure(node);
	    });
	    ro.observe(node);
	
	    var mo = new MutationObserver(function () {
	      return measure(node);
	    });
	    mo.observe(node, { childList: true, subtree: true, characterData: true });
	
	    return function () {
	      ro.disconnect();
	      mo.disconnect();
	    };
	  }, [node, measure]);
	
	  return { ref: ref, overflow: overflow, remeasure: function remeasure() {
	      return node && measure(node);
	    } };
	};
	
	exports.default = useOverflow;

/***/ }),
/* 3916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	__webpack_require__(5342);
	
	var _App = __webpack_require__(3007);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _env = __webpack_require__(103);
	
	var _bootstrapUtils = __webpack_require__(3003);
	
	__webpack_require__(4889);
	
	__webpack_require__(4236);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapUtils.redirectToAdminWebsite)();
	(0, _bootstrapUtils.initialLoader)();
	
	if (_env.PROD_ENV) {
	  (0, _bootstrapUtils.enableServiceWorker)();
	}
	
	(0, _bootstrapUtils.windowIntlPolyfill)().then(function () {
	  return (0, _reactDom.render)(_react2.default.createElement(_App2.default, null), document.getElementById('root'));
	}).catch(function () {
	  return console.log('!error during polyfill loading');
	});
	
	(0, _bootstrapUtils.loadSVG)();
	(0, _bootstrapUtils.loadFonts)();
	(0, _bootstrapUtils.deviceTypeDetecting)();
	
	if (JSON.parse(_env.USE_INTERCOM_CHAT)) {
	  (0, _bootstrapUtils.addIntercomIntegration)();
	}

/***/ }),
/* 3917 */,
/* 3918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _necessaryDataPreparingReq = __webpack_require__(1230);
	
	var _necessaryDataPreparingReq2 = _interopRequireDefault(_necessaryDataPreparingReq);
	
	var _acceptConsentReq = __webpack_require__(1222);
	
	var _acceptConsentReq2 = _interopRequireDefault(_acceptConsentReq);
	
	var _careUsersReq = __webpack_require__(1225);
	
	var _careUsersReq2 = _interopRequireDefault(_careUsersReq);
	
	var _userDetailsReq = __webpack_require__(629);
	
	var _userDetailsReq2 = _interopRequireDefault(_userDetailsReq);
	
	var _visitTypesReq = __webpack_require__(630);
	
	var _visitTypesReq2 = _interopRequireDefault(_visitTypesReq);
	
	var _reasonTypesReq = __webpack_require__(803);
	
	var _reasonTypesReq2 = _interopRequireDefault(_reasonTypesReq);
	
	var _reasonVisitReq = __webpack_require__(1235);
	
	var _reasonVisitReq2 = _interopRequireDefault(_reasonVisitReq);
	
	var _inspectionReq = __webpack_require__(293);
	
	var _inspectionReq2 = _interopRequireDefault(_inspectionReq);
	
	var _inspectConsentForm = __webpack_require__(1865);
	
	var _inspectConsentForm2 = _interopRequireDefault(_inspectConsentForm);
	
	var _inspectPatientForm = __webpack_require__(1228);
	
	var _inspectPatientForm2 = _interopRequireDefault(_inspectPatientForm);
	
	var _providerGWDetailsReq = __webpack_require__(802);
	
	var _providerGWDetailsReq2 = _interopRequireDefault(_providerGWDetailsReq);
	
	var _primaryProviderData = __webpack_require__(1231);
	
	var _primaryProviderData2 = _interopRequireDefault(_primaryProviderData);
	
	var _providerDetailsReq = __webpack_require__(1233);
	
	var _providerDetailsReq2 = _interopRequireDefault(_providerDetailsReq);
	
	var _schedulingsReq = __webpack_require__(1236);
	
	var _schedulingsReq2 = _interopRequireDefault(_schedulingsReq);
	
	var _programBasedVisitsReq = __webpack_require__(1867);
	
	var _programBasedVisitsReq2 = _interopRequireDefault(_programBasedVisitsReq);
	
	var _availableProvidersSelfScheduling = __webpack_require__(1224);
	
	var _availableProvidersSelfScheduling2 = _interopRequireDefault(_availableProvidersSelfScheduling);
	
	var _confirmVisitSelfSchedulingReq = __webpack_require__(504);
	
	var _confirmVisitSelfSchedulingReq2 = _interopRequireDefault(_confirmVisitSelfSchedulingReq);
	
	var _confirmVisitUrgentReq = __webpack_require__(623);
	
	var _confirmVisitUrgentReq2 = _interopRequireDefault(_confirmVisitUrgentReq);
	
	var _organizationsReq = __webpack_require__(1866);
	
	var _organizationsReq2 = _interopRequireDefault(_organizationsReq);
	
	var _confirmVisitGWReq = __webpack_require__(503);
	
	var _confirmVisitGWReq2 = _interopRequireDefault(_confirmVisitGWReq);
	
	var _filtersReq = __webpack_require__(1227);
	
	var _filtersReq2 = _interopRequireDefault(_filtersReq);
	
	var _consentReq = __webpack_require__(505);
	
	var _consentReq2 = _interopRequireDefault(_consentReq);
	
	var _insurancePayersReq = __webpack_require__(800);
	
	var _insurancePayersReq2 = _interopRequireDefault(_insurancePayersReq);
	
	var _checkInsuranceEligibility = __webpack_require__(292);
	
	var _checkInsuranceEligibility2 = _interopRequireDefault(_checkInsuranceEligibility);
	
	var _checkInsurancePlanConfigReq = __webpack_require__(1864);
	
	var _checkInsurancePlanConfigReq2 = _interopRequireDefault(_checkInsurancePlanConfigReq);
	
	var _latestCheckInsuranceReq = __webpack_require__(626);
	
	var _latestCheckInsuranceReq2 = _interopRequireDefault(_latestCheckInsuranceReq);
	
	var _virtualVisitProvidersReq = __webpack_require__(1237);
	
	var _virtualVisitProvidersReq2 = _interopRequireDefault(_virtualVisitProvidersReq);
	
	var _publixInfoReq = __webpack_require__(1234);
	
	var _publixInfoReq2 = _interopRequireDefault(_publixInfoReq);
	
	var _createVirtualVisitReq = __webpack_require__(625);
	
	var _createVirtualVisitReq2 = _interopRequireDefault(_createVirtualVisitReq);
	
	var _inspectionVirtualVisitForm = __webpack_require__(1229);
	
	var _inspectionVirtualVisitForm2 = _interopRequireDefault(_inspectionVirtualVisitForm);
	
	var _handleInsuranceErrorModal = __webpack_require__(502);
	
	var _handleInsuranceErrorModal2 = _interopRequireDefault(_handleInsuranceErrorModal);
	
	var _overlapModal = __webpack_require__(1221);
	
	var _overlapModal2 = _interopRequireDefault(_overlapModal);
	
	var _progress = __webpack_require__(3920);
	
	var _progress2 = _interopRequireDefault(_progress);
	
	var _filters = __webpack_require__(1862);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _pharmacyReq = __webpack_require__(628);
	
	var _pharmacyReq2 = _interopRequireDefault(_pharmacyReq);
	
	var _medicationsReq = __webpack_require__(627);
	
	var _medicationsReq2 = _interopRequireDefault(_medicationsReq);
	
	var _inlineVisitsTimeSlots = __webpack_require__(506);
	
	var _inlineVisitsTimeSlots2 = _interopRequireDefault(_inlineVisitsTimeSlots);
	
	var _confirmInlineVisit = __webpack_require__(622);
	
	var _confirmInlineVisit2 = _interopRequireDefault(_confirmInlineVisit);
	
	var _schedulableTreeReq = __webpack_require__(804);
	
	var _schedulableTreeReq2 = _interopRequireDefault(_schedulableTreeReq);
	
	var _myProvidersReq = __webpack_require__(338);
	
	var _myProvidersReq2 = _interopRequireDefault(_myProvidersReq);
	
	var _fetchCopay = __webpack_require__(1226);
	
	var _fetchCopay2 = _interopRequireDefault(_fetchCopay);
	
	var _availableEirLocations = __webpack_require__(1223);
	
	var _availableEirLocations2 = _interopRequireDefault(_availableEirLocations);
	
	var _createEirUrgentCareAppointment = __webpack_require__(624);
	
	var _createEirUrgentCareAppointment2 = _interopRequireDefault(_createEirUrgentCareAppointment);
	
	var _primaryProvidersList = __webpack_require__(1232);
	
	var _primaryProvidersList2 = _interopRequireDefault(_primaryProvidersList);
	
	var _organizationEmployersList = __webpack_require__(801);
	
	var _organizationEmployersList2 = _interopRequireDefault(_organizationEmployersList);
	
	var _appointmentPaymentInfoModal = __webpack_require__(1220);
	
	var _appointmentPaymentInfoModal2 = _interopRequireDefault(_appointmentPaymentInfoModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  careUsers: _careUsersReq2.default,
	  acceptConsent: _acceptConsentReq2.default,
	  visitTypes: _visitTypesReq2.default,
	  reasonTypes: _reasonTypesReq2.default,
	  reasonVisit: _reasonVisitReq2.default,
	  userDetails: _userDetailsReq2.default,
	  progress: _progress2.default,
	  filters: _filters2.default,
	  inspection: _inspectionReq2.default,
	  schedulings: _schedulingsReq2.default,
	  availableProvidersSelfScheduling: _availableProvidersSelfScheduling2.default,
	  confirmVisitSelfScheduling: _confirmVisitSelfSchedulingReq2.default,
	  confirmVisitUrgent: _confirmVisitUrgentReq2.default,
	  providerGWDetails: _providerGWDetailsReq2.default,
	  primaryProviderData: _primaryProviderData2.default,
	  providerDetails: _providerDetailsReq2.default,
	  confirmVisitGW: _confirmVisitGWReq2.default,
	  organizations: _organizationsReq2.default,
	  filterList: _filtersReq2.default,
	  consent: _consentReq2.default,
	  inspectConsent: _inspectConsentForm2.default,
	  inspectPatient: _inspectPatientForm2.default,
	  necessaryData: _necessaryDataPreparingReq2.default,
	  virtualVisitProviders: _virtualVisitProvidersReq2.default,
	  publixInfo: _publixInfoReq2.default,
	  createVirtualVisit: _createVirtualVisitReq2.default,
	  inspectVirtualVisit: _inspectionVirtualVisitForm2.default,
	  overlapModal: _overlapModal2.default,
	  programBasedVisits: _programBasedVisitsReq2.default,
	  insurancePayers: _insurancePayersReq2.default,
	  checkInsurancePlanConfig: _checkInsurancePlanConfigReq2.default,
	  checkInsuranceEligibility: _checkInsuranceEligibility2.default,
	  insuranceErrorModal: _handleInsuranceErrorModal2.default,
	  latestCheckInsuranceEligibility: _latestCheckInsuranceReq2.default,
	  pharmaciesList: _pharmacyReq2.default,
	  medicationsList: _medicationsReq2.default,
	  inlineVisitTimeSlots: _inlineVisitsTimeSlots2.default,
	  confirmInlineVisit: _confirmInlineVisit2.default,
	  schedulingTree: _schedulableTreeReq2.default,
	  myProviders: _myProvidersReq2.default,
	  fetchCopay: _fetchCopay2.default,
	  availableEirLocations: _availableEirLocations2.default,
	  createEirUrgentCareAppointment: _createEirUrgentCareAppointment2.default,
	  primaryCareProvidersList: _primaryProvidersList2.default,
	  employersList: _organizationEmployersList2.default,
	  appointmentPaymentInfoModal: _appointmentPaymentInfoModal2.default
	});

/***/ }),
/* 3919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _normalizr = __webpack_require__(1576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var availableProvider = new _normalizr.schema.Entity('availableProviders');
	
	var availableProviderListSchema = new _normalizr.schema.Array(availableProvider);
	
	exports.default = function (data) {
	  return (0, _extends3.default)({}, (0, _normalizr.normalize)(data, availableProviderListSchema));
	};

/***/ }),
/* 3920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _set = __webpack_require__(1975);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _from = __webpack_require__(550);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = progress;
	
	var _lodash = __webpack_require__(58);
	
	var _constants = __webpack_require__(17);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @typedef {Object} AppointmentProgressState
	 * @property {boolean} validating
	 * @property {boolean} pending
	 * @property {Object} careUser
	 * @property {Object} organization
	 * @property {Object} visitType
	 * @property {Object} service
	 * @property {Object} location
	 * @property {Object} patientForm
	 * @property {string} ssn
	 * @property {string} reason
	 * @property {Object} error
	 * @property {Object} schedule
	 * @property {boolean} isGWFlow
	 * @property {string|null} pbvConfigId
	 * @property {boolean} isUrgentVisitFlow
	 * @property {Object} insuranceEligibility
	 * @property {Object} rescheduleData
	 * @property {Object} healthInfo
	 * @property {string|null} pharmacyId
	 * @property {Array} flowPages
	 * @property {Object|null} pcpFormData
	 * @property {AdditionalInfoFormData|null} additionalInfoFormData
	 * */
	var initialState = {
	  validating: true,
	  pending: false,
	  careUser: null,
	  organization: null,
	  visitType: null,
	  service: null,
	  location: null,
	  patientForm: null,
	  ssn: null,
	  reason: null,
	  error: null,
	  schedule: {},
	  isGWFlow: false,
	  pbvConfigId: null,
	  isUrgentVisitFlow: false,
	  insuranceEligibility: {},
	  rescheduleData: {},
	  healthInfo: null,
	  pharmacyId: null,
	  flowPages: [],
	  pcpFormData: null, // used only for EIR visit type flow
	  additionalInfoFormData: null,
	  language: null // used only for EIR visit type flow
	};
	
	/**
	 * @param {AppointmentProgressState} state
	 * */
	function progress() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.VALIDATE:
	      {
	        return (0, _extends3.default)({}, state, { validating: true });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.VALIDATE_FINISH:
	      {
	        return (0, _extends3.default)({}, state, { validating: false });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.UPDATE_CARE_USER_PROFILE:
	      {
	        return (0, _extends3.default)({}, state, { careUser: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER:
	      {
	        return (0, _extends3.default)({}, state, {
	          careUser: payload,
	          patientForm: null,
	          organization: null,
	          ssn: null,
	          reason: null,
	          schedule: {},
	          pbvConfigId: null,
	          insuranceEligibility: {},
	          rescheduleData: {}
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_ORGANIZATION:
	      {
	        return (0, _extends3.default)({}, state, { organization: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_VISIT_TYPE:
	      {
	        return (0, _extends3.default)({}, state, {
	          visitType: payload,
	          isUrgentVisitFlow: payload.code === _constants.URGENT_VISIT_TYPE_CODE
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_SERVICE:
	      {
	        return (0, _extends3.default)({}, state, { service: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_LOCATION:
	      {
	        return (0, _extends3.default)({}, state, { location: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_PROGRAM_BASED_VISIT_ID:
	      {
	        return (0, _extends3.default)({}, state, { pbvConfigId: payload.id });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR_PROGRAM_BASED_VISIT_ID:
	      {
	        return (0, _extends3.default)({}, state, { pbvConfigId: null });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_PATIENT_INFO:
	      {
	        return (0, _extends3.default)({}, state, { patientForm: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_PREFERRED_PHARMACY:
	      {
	        return (0, _extends3.default)({}, state, {
	          pharmacyId: payload.id
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_HEALTH_INFO:
	      {
	        var ndcDrugIds = payload.ndcDrugIds,
	            healthConditions = payload.healthConditions,
	            pcpProviderAnswer = payload.pcpProviderAnswer,
	            medicationAllergies = payload.medicationAllergies;
	
	
	        return (0, _extends3.default)({}, state, {
	          healthInfo: {
	            ndcDrugIds: ndcDrugIds.map(function (el) {
	              return (0, _lodash.isObject)(el) ? el.ndcDrugId : el;
	            }),
	            pcpProviderAnswer: pcpProviderAnswer,
	            healthConditionIds: healthConditions.map(function (el) {
	              return el.id;
	            }),
	            medicationAllergyIds: medicationAllergies.map(function (el) {
	              return el.id;
	            })
	          }
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_HAVE_CARE_PROVIDER_ANSWER:
	      {
	        var _pcpProviderAnswer = payload.pcpProviderAnswer;
	
	
	        return (0, _extends3.default)({}, state, {
	          healthInfo: {
	            pcpProviderAnswer: _pcpProviderAnswer
	          }
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_SSN:
	      {
	        return (0, _extends3.default)({}, state, { ssn: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_RESCHEDULE_DATA:
	      {
	        return (0, _extends3.default)({}, state, {
	          rescheduleData: payload
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_REASON:
	      {
	        return (0, _extends3.default)({}, state, { reason: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_SCHEDULE_DATA:
	      {
	        return (0, _extends3.default)({}, state, { schedule: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_ERROR:
	      {
	        return (0, _extends3.default)({}, state, { error: payload });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR:
	      {
	        return initialState;
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_CREATE_TYPE_FLOW_GW:
	      {
	        return (0, _extends3.default)({}, state, {
	          isGWFlow: payload
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_INSURANCE_ELIGIBILITY:
	      {
	        return (0, _extends3.default)({}, state, {
	          insuranceEligibility: payload
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.CLEAR_INSURANCE_ELIGIBILITY:
	      {
	        return (0, _extends3.default)({}, state, {
	          insuranceEligibility: {}
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_PENDING:
	      {
	        return (0, _extends3.default)({}, state, {
	          pending: payload
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_FLOW_PAGES:
	      {
	        var newFlowPages = (0, _from2.default)(new _set2.default([].concat((0, _toConsumableArray3.default)(state.flowPages), [payload])));
	
	        return (0, _extends3.default)({}, state, {
	          flowPages: newFlowPages
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.REMOVE_FLOW_PAGE:
	      {
	        var _newFlowPages = state.flowPages.filter(function (page) {
	          return page !== payload;
	        });
	
	        return (0, _extends3.default)({}, state, {
	          flowPages: _newFlowPages
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_PRIMARY_CARE_PROVIDER_FORM_DATA:
	      {
	        return (0, _extends3.default)({}, state, {
	          pcpFormData: payload
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_ADDITIONAL_INFO_FORM_DATA:
	      {
	        return (0, _extends3.default)({}, state, {
	          additionalInfoFormData: payload
	        });
	      }
	
	    case _progressTypes.APPOINTMENT_PROGRESS_TYPES.SET_PREFERRED_LANGUAGE:
	      {
	        return (0, _extends3.default)({}, state, {
	          language: payload
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}

/***/ }),
/* 3921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = appointmentFormRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _necessaryDataPreparingReq = __webpack_require__(1230);
	
	var necessaryData = _interopRequireWildcard(_necessaryDataPreparingReq);
	
	var _acceptConsentReq = __webpack_require__(1222);
	
	var acceptConsent = _interopRequireWildcard(_acceptConsentReq);
	
	var _careUsersReq = __webpack_require__(1225);
	
	var careUsers = _interopRequireWildcard(_careUsersReq);
	
	var _userDetailsReq = __webpack_require__(629);
	
	var userDetails = _interopRequireWildcard(_userDetailsReq);
	
	var _visitTypesReq = __webpack_require__(630);
	
	var visitTypes = _interopRequireWildcard(_visitTypesReq);
	
	var _reasonTypesReq = __webpack_require__(803);
	
	var reasonTypes = _interopRequireWildcard(_reasonTypesReq);
	
	var _reasonVisitReq = __webpack_require__(1235);
	
	var reasonVisit = _interopRequireWildcard(_reasonVisitReq);
	
	var _programBasedVisitsReq = __webpack_require__(1867);
	
	var programBasedVisits = _interopRequireWildcard(_programBasedVisitsReq);
	
	var _inspectionReq = __webpack_require__(293);
	
	var inspection = _interopRequireWildcard(_inspectionReq);
	
	var _consentReq = __webpack_require__(505);
	
	var consent = _interopRequireWildcard(_consentReq);
	
	var _inspectPatientForm = __webpack_require__(1228);
	
	var inspectPatient = _interopRequireWildcard(_inspectPatientForm);
	
	var _inspectConsentForm = __webpack_require__(1865);
	
	var inspectConsent = _interopRequireWildcard(_inspectConsentForm);
	
	var _providerGWDetailsReq = __webpack_require__(802);
	
	var providerGWDetails = _interopRequireWildcard(_providerGWDetailsReq);
	
	var _providerDetailsReq = __webpack_require__(1233);
	
	var providerDetails = _interopRequireWildcard(_providerDetailsReq);
	
	var _schedulingsReq = __webpack_require__(1236);
	
	var schedulings = _interopRequireWildcard(_schedulingsReq);
	
	var _availableProvidersSelfScheduling = __webpack_require__(1224);
	
	var availableProvidersSelfScheduling = _interopRequireWildcard(_availableProvidersSelfScheduling);
	
	var _confirmVisitSelfSchedulingReq = __webpack_require__(504);
	
	var confirmVisitSelfScheduling = _interopRequireWildcard(_confirmVisitSelfSchedulingReq);
	
	var _confirmVisitUrgentReq = __webpack_require__(623);
	
	var confirmVisitUrgent = _interopRequireWildcard(_confirmVisitUrgentReq);
	
	var _confirmVisitGWReq = __webpack_require__(503);
	
	var confirmVisitGW = _interopRequireWildcard(_confirmVisitGWReq);
	
	var _filtersReq = __webpack_require__(1227);
	
	var filterList = _interopRequireWildcard(_filtersReq);
	
	var _organizationsReq = __webpack_require__(1866);
	
	var organizations = _interopRequireWildcard(_organizationsReq);
	
	var _virtualVisitProvidersReq = __webpack_require__(1237);
	
	var virtualVisitProviders = _interopRequireWildcard(_virtualVisitProvidersReq);
	
	var _publixInfoReq = __webpack_require__(1234);
	
	var publixInfo = _interopRequireWildcard(_publixInfoReq);
	
	var _createVirtualVisitReq = __webpack_require__(625);
	
	var createVirtualVisit = _interopRequireWildcard(_createVirtualVisitReq);
	
	var _inspectionVirtualVisitForm = __webpack_require__(1229);
	
	var inspectVirtualVisit = _interopRequireWildcard(_inspectionVirtualVisitForm);
	
	var _insurancePayersReq = __webpack_require__(800);
	
	var insurancePayers = _interopRequireWildcard(_insurancePayersReq);
	
	var _checkInsuranceEligibility = __webpack_require__(292);
	
	var checkInsuranceEligibility = _interopRequireWildcard(_checkInsuranceEligibility);
	
	var _latestCheckInsuranceReq = __webpack_require__(626);
	
	var latestCheckInsuranceEligibility = _interopRequireWildcard(_latestCheckInsuranceReq);
	
	var _checkInsurancePlanConfigReq = __webpack_require__(1864);
	
	var checkInsurancePlanConfig = _interopRequireWildcard(_checkInsurancePlanConfigReq);
	
	var _pharmacyReq = __webpack_require__(628);
	
	var pharmaciesList = _interopRequireWildcard(_pharmacyReq);
	
	var _medicationsReq = __webpack_require__(627);
	
	var medicationsList = _interopRequireWildcard(_medicationsReq);
	
	var _inlineVisitsTimeSlots = __webpack_require__(506);
	
	var inlineVisitTimeSlots = _interopRequireWildcard(_inlineVisitsTimeSlots);
	
	var _confirmInlineVisit = __webpack_require__(622);
	
	var confirmInlineVisit = _interopRequireWildcard(_confirmInlineVisit);
	
	var _schedulableTreeReq = __webpack_require__(804);
	
	var schedulingTree = _interopRequireWildcard(_schedulableTreeReq);
	
	var _myProvidersReq = __webpack_require__(338);
	
	var myProviders = _interopRequireWildcard(_myProvidersReq);
	
	var _updateDataSaga = __webpack_require__(3938);
	
	var _updateDataSaga2 = _interopRequireDefault(_updateDataSaga);
	
	var _validateOnMountSaga = __webpack_require__(3939);
	
	var _validateOnMountSaga2 = _interopRequireDefault(_validateOnMountSaga);
	
	var _inspectAllSaga = __webpack_require__(805);
	
	var _inspectAllSaga2 = _interopRequireDefault(_inspectAllSaga);
	
	var _inspectConsentSaga = __webpack_require__(3930);
	
	var _inspectConsentSaga2 = _interopRequireDefault(_inspectConsentSaga);
	
	var _inspectPatientSaga = __webpack_require__(3931);
	
	var _inspectPatientSaga2 = _interopRequireDefault(_inspectPatientSaga);
	
	var _confirmAppointmentSaga = __webpack_require__(3924);
	
	var _confirmAppointmentSaga2 = _interopRequireDefault(_confirmAppointmentSaga);
	
	var _fetchProvidersSaga = __webpack_require__(3926);
	
	var _fetchProvidersSaga2 = _interopRequireDefault(_fetchProvidersSaga);
	
	var _addVirtualVisitSaga = __webpack_require__(3922);
	
	var _addVirtualVisitSaga2 = _interopRequireDefault(_addVirtualVisitSaga);
	
	var _visitTypeListGuardSaga = __webpack_require__(3940);
	
	var _visitTypeListGuardSaga2 = _interopRequireDefault(_visitTypeListGuardSaga);
	
	var _confirmVisitUrgentSaga = __webpack_require__(3925);
	
	var _confirmVisitUrgentSaga2 = _interopRequireDefault(_confirmVisitUrgentSaga);
	
	var _organizationListGuardSaga = __webpack_require__(3936);
	
	var _organizationListGuardSaga2 = _interopRequireDefault(_organizationListGuardSaga);
	
	var _checkInsuranceSaga = __webpack_require__(3923);
	
	var _checkInsuranceSaga2 = _interopRequireDefault(_checkInsuranceSaga);
	
	var _morePharmaciesSaga = __webpack_require__(3933);
	
	var _morePharmaciesSaga2 = _interopRequireDefault(_morePharmaciesSaga);
	
	var _moreMedicationsSaga = __webpack_require__(3932);
	
	var _moreMedicationsSaga2 = _interopRequireDefault(_moreMedicationsSaga);
	
	var _inlineVisitsTimeSlotsSaga = __webpack_require__(3929);
	
	var _inlineVisitsTimeSlotsSaga2 = _interopRequireDefault(_inlineVisitsTimeSlotsSaga);
	
	var _myProvidersPaginationSaga = __webpack_require__(3935);
	
	var _myProvidersPaginationSaga2 = _interopRequireDefault(_myProvidersPaginationSaga);
	
	var _repeatableScheduleFlowSaga = __webpack_require__(3937);
	
	var _repeatableScheduleFlowSaga2 = _interopRequireDefault(_repeatableScheduleFlowSaga);
	
	var _myProvidersListGuardSaga = __webpack_require__(3934);
	
	var _myProvidersListGuardSaga2 = _interopRequireDefault(_myProvidersListGuardSaga);
	
	var _fetchCopay = __webpack_require__(1226);
	
	var fetchCopay = _interopRequireWildcard(_fetchCopay);
	
	var _handleInsuranceSucceedUpdate = __webpack_require__(3927);
	
	var _handleInsuranceSucceedUpdate2 = _interopRequireDefault(_handleInsuranceSucceedUpdate);
	
	var _handleInsuranceUpdateFailed = __webpack_require__(3928);
	
	var _handleInsuranceUpdateFailed2 = _interopRequireDefault(_handleInsuranceUpdateFailed);
	
	var _availableEirLocations = __webpack_require__(1223);
	
	var _createEirUrgentCareAppointment = __webpack_require__(624);
	
	var _primaryProvidersList = __webpack_require__(1232);
	
	var _primaryProviderData = __webpack_require__(1231);
	
	var _organizationEmployersList = __webpack_require__(801);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(appointmentFormRootSaga);
	
	function appointmentFormRootSaga() {
	  return _regenerator2.default.wrap(function appointmentFormRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(necessaryData.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(acceptConsent.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(careUsers.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(userDetails.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(visitTypes.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(reasonTypes.watcher);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(reasonVisit.watcher);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(inspection.watcher);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(consent.watcher);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(inspectPatient.watcher);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.fork)(inspectConsent.watcher);
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.fork)(providerGWDetails.watcher);
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.fork)(providerDetails.watcher);
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.fork)(schedulings.watcher);
	
	        case 28:
	          _context.next = 30;
	          return (0, _effects.fork)(confirmVisitSelfScheduling.watcher);
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.fork)(confirmVisitUrgent.watcher);
	
	        case 32:
	          _context.next = 34;
	          return (0, _effects.fork)(confirmVisitGW.watcher);
	
	        case 34:
	          _context.next = 36;
	          return (0, _effects.fork)(filterList.watcher);
	
	        case 36:
	          _context.next = 38;
	          return (0, _effects.fork)(organizations.watcher);
	
	        case 38:
	          _context.next = 40;
	          return (0, _effects.fork)(virtualVisitProviders.watcher);
	
	        case 40:
	          _context.next = 42;
	          return (0, _effects.fork)(publixInfo.watcher);
	
	        case 42:
	          _context.next = 44;
	          return (0, _effects.fork)(createVirtualVisit.watcher);
	
	        case 44:
	          _context.next = 46;
	          return (0, _effects.fork)(inspectVirtualVisit.watcher);
	
	        case 46:
	          _context.next = 48;
	          return (0, _effects.fork)(availableProvidersSelfScheduling.watcher);
	
	        case 48:
	          _context.next = 50;
	          return (0, _effects.fork)(programBasedVisits.watcher);
	
	        case 50:
	          _context.next = 52;
	          return (0, _effects.fork)(insurancePayers.watcher);
	
	        case 52:
	          _context.next = 54;
	          return (0, _effects.fork)(checkInsurancePlanConfig.watcher);
	
	        case 54:
	          _context.next = 56;
	          return (0, _effects.fork)(checkInsuranceEligibility.watcher);
	
	        case 56:
	          _context.next = 58;
	          return (0, _effects.fork)(latestCheckInsuranceEligibility.watcher);
	
	        case 58:
	          _context.next = 60;
	          return (0, _effects.fork)(pharmaciesList.watcher);
	
	        case 60:
	          _context.next = 62;
	          return (0, _effects.fork)(medicationsList.watcher);
	
	        case 62:
	          _context.next = 64;
	          return (0, _effects.fork)(inlineVisitTimeSlots.watcher);
	
	        case 64:
	          _context.next = 66;
	          return (0, _effects.fork)(confirmInlineVisit.watcher);
	
	        case 66:
	          _context.next = 68;
	          return (0, _effects.fork)(schedulingTree.watcher);
	
	        case 68:
	          _context.next = 70;
	          return (0, _effects.fork)(myProviders.watcher);
	
	        case 70:
	          _context.next = 72;
	          return (0, _effects.fork)(myProviders.paginationWatcher);
	
	        case 72:
	          _context.next = 74;
	          return (0, _effects.fork)(_inlineVisitsTimeSlotsSaga2.default);
	
	        case 74:
	          _context.next = 76;
	          return (0, _effects.fork)(_organizationListGuardSaga2.default);
	
	        case 76:
	          _context.next = 78;
	          return (0, _effects.fork)(_updateDataSaga2.default);
	
	        case 78:
	          _context.next = 80;
	          return (0, _effects.fork)(_validateOnMountSaga2.default);
	
	        case 80:
	          _context.next = 82;
	          return (0, _effects.fork)(_inspectAllSaga2.default);
	
	        case 82:
	          _context.next = 84;
	          return (0, _effects.fork)(_inspectConsentSaga2.default);
	
	        case 84:
	          _context.next = 86;
	          return (0, _effects.fork)(_inspectPatientSaga2.default);
	
	        case 86:
	          _context.next = 88;
	          return (0, _effects.fork)(_confirmAppointmentSaga2.default);
	
	        case 88:
	          _context.next = 90;
	          return (0, _effects.fork)(_fetchProvidersSaga2.default);
	
	        case 90:
	          _context.next = 92;
	          return (0, _effects.fork)(_addVirtualVisitSaga2.default);
	
	        case 92:
	          _context.next = 94;
	          return (0, _effects.fork)(_visitTypeListGuardSaga2.default);
	
	        case 94:
	          _context.next = 96;
	          return (0, _effects.fork)(_confirmVisitUrgentSaga2.default);
	
	        case 96:
	          _context.next = 98;
	          return (0, _effects.fork)(_checkInsuranceSaga2.default);
	
	        case 98:
	          _context.next = 100;
	          return (0, _effects.fork)(_morePharmaciesSaga2.default);
	
	        case 100:
	          _context.next = 102;
	          return (0, _effects.fork)(_moreMedicationsSaga2.default);
	
	        case 102:
	          _context.next = 104;
	          return (0, _effects.fork)(_myProvidersPaginationSaga2.default);
	
	        case 104:
	          _context.next = 106;
	          return (0, _effects.fork)(_repeatableScheduleFlowSaga2.default);
	
	        case 106:
	          _context.next = 108;
	          return (0, _effects.fork)(_myProvidersListGuardSaga2.default);
	
	        case 108:
	          _context.next = 110;
	          return (0, _effects.fork)(fetchCopay.watcher);
	
	        case 110:
	          _context.next = 112;
	          return (0, _effects.fork)(_handleInsuranceSucceedUpdate2.default);
	
	        case 112:
	          _context.next = 114;
	          return (0, _effects.fork)(_handleInsuranceUpdateFailed2.default);
	
	        case 114:
	          _context.next = 116;
	          return (0, _effects.fork)(_availableEirLocations.watcher);
	
	        case 116:
	          _context.next = 118;
	          return (0, _effects.fork)(_createEirUrgentCareAppointment.watcher);
	
	        case 118:
	          _context.next = 120;
	          return (0, _effects.fork)(_primaryProvidersList.watcher);
	
	        case 120:
	          _context.next = 122;
	          return (0, _effects.fork)(_primaryProviderData.watcher);
	
	        case 122:
	          _context.next = 124;
	          return (0, _effects.fork)(_organizationEmployersList.watcher);
	
	        case 124:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 3922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.addVisitWorker = addVisitWorker;
	exports.handleSucceedResponse = handleSucceedResponse;
	exports.overlapVirtualVisit = overlapVirtualVisit;
	exports.default = addVirtualVisitSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _head = __webpack_require__(378);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _includes = __webpack_require__(324);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _reactRouter = __webpack_require__(42);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	var _createVirtualVisitReq = __webpack_require__(625);
	
	var createVisit = _interopRequireWildcard(_createVirtualVisitReq);
	
	var _inspectionVirtualVisitForm = __webpack_require__(1229);
	
	var inspectVirtualVizit = _interopRequireWildcard(_inspectionVirtualVisitForm);
	
	var _routes = __webpack_require__(37);
	
	var _overlapModal = __webpack_require__(1221);
	
	var _selectors = __webpack_require__(43);
	
	var _errors = __webpack_require__(120);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(addVisitWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleSucceedResponse),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(overlapVirtualVisit),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(addVirtualVisitSaga);
	
	var PROVIDER_IS_NOT_AVAILABLE_FOR_THIS_TIME = _errors.ERROR_CODES.PROVIDER_IS_NOT_AVAILABLE_FOR_THIS_TIME,
	    PROVIDER_IS_NOT_AVAILABLE_FOR_SELECTED_SERVICE = _errors.ERROR_CODES.PROVIDER_IS_NOT_AVAILABLE_FOR_SELECTED_SERVICE,
	    APPOINTMENT_IS_EXISTING_AT_THIS_TIME = _errors.ERROR_CODES.APPOINTMENT_IS_EXISTING_AT_THIS_TIME,
	    APPOINTMENT_OVERLAPPING = _errors.ERROR_CODES.APPOINTMENT_OVERLAPPING;
	function addVisitWorker(_ref) {
	  var payload = _ref.payload;
	
	  var _ref2, succeedInspection, rejectedInspection, responseInspection, isCompleted, fieldList, errorCodes, isOverlap, msg, textError;
	
	  return _regenerator2.default.wrap(function addVisitWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(inspectVirtualVizit.actions.send(payload));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.race)({
	            succeedInspection: (0, _effects.take)(inspectVirtualVizit.consts.SUCCEED),
	            rejectedInspection: (0, _effects.take)(inspectVirtualVizit.consts.REJECTED)
	          });
	
	        case 4:
	          _ref2 = _context.sent;
	          succeedInspection = _ref2.succeedInspection;
	          rejectedInspection = _ref2.rejectedInspection;
	
	          if (!rejectedInspection) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'errors.common' }
	          });
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.cancel)();
	
	        case 12:
	          responseInspection = (0, _head2.default)(succeedInspection.payload);
	          isCompleted = (0, _get2.default)(responseInspection, 'completed');
	
	          if (isCompleted) {
	            _context.next = 29;
	            break;
	          }
	
	          fieldList = (0, _get2.default)(responseInspection, 'fieldList', []);
	          errorCodes = [APPOINTMENT_OVERLAPPING, APPOINTMENT_IS_EXISTING_AT_THIS_TIME];
	          isOverlap = fieldList.some(function (_ref3) {
	            var code = _ref3.code;
	            return errorCodes.some(function (errorItem) {
	              return (0, _includes2.default)(code, errorItem);
	            });
	          });
	
	          if (!isOverlap) {
	            _context.next = 23;
	            break;
	          }
	
	          _context.next = 21;
	          return (0, _effects.put)(_overlapModal.overlapModalActions.open(payload));
	
	        case 21:
	          _context.next = 27;
	          break;
	
	        case 23:
	          msg = (0, _get2.default)(fieldList, '[0].code[0]');
	          textError = [PROVIDER_IS_NOT_AVAILABLE_FOR_THIS_TIME, PROVIDER_IS_NOT_AVAILABLE_FOR_SELECTED_SERVICE].includes(msg) ? 'appointment.form.error.notAvailableProvider.combined' : 'errors.common';
	          _context.next = 27;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: textError }
	          });
	
	        case 27:
	          _context.next = 29;
	          return (0, _effects.cancel)();
	
	        case 29:
	          _context.next = 31;
	          return (0, _effects.call)(function () {
	            return handleSucceedResponse(payload);
	          });
	
	        case 31:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleSucceedResponse(data) {
	  var _ref4, succeedCreate;
	
	  return _regenerator2.default.wrap(function handleSucceedResponse$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)(createVisit.actions.send(data));
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.race)({
	            succeedCreate: (0, _effects.take)(createVisit.consts.SUCCEED),
	            rejectedCreate: (0, _effects.take)(createVisit.consts.REJECTED)
	          });
	
	        case 4:
	          _ref4 = _context2.sent;
	          succeedCreate = _ref4.succeedCreate;
	
	          if (!succeedCreate) {
	            _context2.next = 10;
	            break;
	          }
	
	          _context2.next = 9;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'virtualVisit.details.visitScheduled' }
	          });
	
	        case 9:
	          _reactRouter.browserHistory.replace(_routes.MESSAGES);
	
	        case 10:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function overlapVirtualVisit() {
	  var payload;
	  return _regenerator2.default.wrap(function overlapVirtualVisit$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors.selectOverlapModalEntity);
	
	        case 2:
	          payload = _context3.sent;
	          _context3.next = 5;
	          return (0, _effects.call)(function () {
	            return handleSucceedResponse(payload);
	          });
	
	        case 5:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function addVirtualVisitSaga() {
	  return _regenerator2.default.wrap(function addVirtualVisitSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(createVisit.consts.INIT, addVisitWorker);
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.takeLatest)(createVisit.consts.OVERLAP, overlapVirtualVisit);
	
	        case 4:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}

/***/ }),
/* 3923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = checkInsuranceEligibilitySaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _checkInsuranceEligibility = __webpack_require__(292);
	
	var _selectors = __webpack_require__(43);
	
	var _latestCheckInsuranceReq = __webpack_require__(626);
	
	var _handleInsuranceErrorModal = __webpack_require__(502);
	
	var _progressTypes = __webpack_require__(55);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _selectors2 = __webpack_require__(23);
	
	var _success = __webpack_require__(104);
	
	var succeed = _interopRequireWildcard(_success);
	
	var _checkState = __webpack_require__(4196);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleCheckInsuranceWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(checkInsuranceEligibilitySaga);
	
	function handleCheckInsuranceWorker(_ref) {
	  var payload = _ref.payload;
	
	  var dob, city, state, lastName, address1, address2, memberId, firstName, postalCode, phoneNumber, groupNumber, currentHealthPlan, isPrimarySubscriber, isOfficeOrVirtualVisit, checkInsuranceInProfile, careUserId, targetUserId, service, locationId, safePayload, _ref2, success, reject, handledErrorEntity;
	
	  return _regenerator2.default.wrap(function handleCheckInsuranceWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          dob = payload.dob, city = payload.city, state = payload.state, lastName = payload.lastName, address1 = payload.address1, address2 = payload.address2, memberId = payload.memberId, firstName = payload.firstName, postalCode = payload.postalCode, phoneNumber = payload.phoneNumber, groupNumber = payload.groupNumber, currentHealthPlan = payload.currentHealthPlan, isPrimarySubscriber = payload.isPrimarySubscriber, isOfficeOrVirtualVisit = payload.isOfficeOrVirtualVisit, checkInsuranceInProfile = payload.checkInsuranceInProfile;
	          _context.next = 3;
	          return (0, _effects.select)(_selectors.selectProgressCareUserId);
	
	        case 3:
	          careUserId = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(_selectors2.targetUserIdSelector);
	
	        case 6:
	          targetUserId = _context.sent;
	          _context.next = 9;
	          return (0, _effects.select)(_selectors.selectProgressService);
	
	        case 9:
	          service = _context.sent;
	          _context.next = 12;
	          return (0, _effects.select)(_selectors.selectProgressScheduleLocationId);
	
	        case 12:
	          locationId = _context.sent;
	          safePayload = (0, _extends3.default)({
	            memberId: memberId,
	            payerId: currentHealthPlan.id,
	            userId: careUserId || targetUserId
	          }, locationId && { locationId: locationId }, service && service.id && { serviceId: service.id }, groupNumber && groupNumber.trim() && { groupNumber: groupNumber.trim() }, !isPrimarySubscriber && {
	            primarySubscriber: (0, _extends3.default)({
	              firstName: firstName,
	              lastName: lastName,
	              dob: dob,
	              phoneNumber: phoneNumber,
	              address1: address1,
	              address2: address2,
	              city: city,
	              postalCode: postalCode
	            }, state && { state: (0, _checkState.checkState)(state) })
	          });
	          _context.next = 16;
	          return (0, _effects.put)(_checkInsuranceEligibility.actions.send(safePayload));
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.race)({
	            success: (0, _effects.take)(_checkInsuranceEligibility.actions.succeed),
	            reject: (0, _effects.take)([_checkInsuranceEligibility.actions.rejected, _checkInsuranceEligibility.actions.errorEncountered])
	          });
	
	        case 18:
	          _ref2 = _context.sent;
	          success = _ref2.success;
	          reject = _ref2.reject;
	
	          if (!(reject && !reject.payload)) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.put)({
	            type: (0, _consts2.default)('ui', 'error', ['UPDATE']).UPDATE,
	            payload: { id: 'errors.longRequest.502.504' }
	          });
	
	        case 24:
	          if (!(reject && reject.payload)) {
	            _context.next = 33;
	            break;
	          }
	
	          handledErrorEntity = (0, _get2.default)(reject.payload, 'error.meta');
	
	          if (!handledErrorEntity) {
	            _context.next = 31;
	            break;
	          }
	
	          _context.next = 29;
	          return (0, _effects.put)(_handleInsuranceErrorModal.insuranceErrorModalActions.open((0, _extends3.default)({}, handledErrorEntity)));
	
	        case 29:
	          _context.next = 33;
	          break;
	
	        case 31:
	          _context.next = 33;
	          return (0, _effects.put)({
	            type: (0, _consts2.default)('ui', 'error', ['UPDATE']).UPDATE,
	            payload: { id: 'errors.common' }
	          });
	
	        case 33:
	          if (!success) {
	            _context.next = 52;
	            break;
	          }
	
	          if (!checkInsuranceInProfile) {
	            _context.next = 39;
	            break;
	          }
	
	          _context.next = 37;
	          return (0, _effects.put)({
	            type: succeed.consts.UPDATE,
	            payload: { id: 'appointments.form.insuranceDetails,success' }
	          });
	
	        case 37:
	          _context.next = 52;
	          break;
	
	        case 39:
	          _context.next = 41;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setInsuranceEligibility((0, _extends3.default)({}, success.payload)));
	
	        case 41:
	          _context.next = 43;
	          return (0, _effects.put)(_latestCheckInsuranceReq.actions.clear());
	
	        case 43:
	          _context.next = 45;
	          return (0, _effects.put)(_checkInsuranceEligibility.actions.clear());
	
	        case 45:
	          if (!isOfficeOrVirtualVisit) {
	            _context.next = 50;
	            break;
	          }
	
	          _context.next = 48;
	          return (0, _effects.call)(_redirectUtils.redirectToConsentForm);
	
	        case 48:
	          _context.next = 52;
	          break;
	
	        case 50:
	          _context.next = 52;
	          return (0, _effects.call)(_redirectUtils.redirectToVisitDetails);
	
	        case 52:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function checkInsuranceEligibilitySaga() {
	  return _regenerator2.default.wrap(function checkInsuranceEligibilitySaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_checkInsuranceEligibility.actions.init, handleCheckInsuranceWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = confirmAppointmentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _errors = __webpack_require__(120);
	
	var _confirmVisitSelfSchedulingReq = __webpack_require__(504);
	
	var confirmVisitSelfScheduling = _interopRequireWildcard(_confirmVisitSelfSchedulingReq);
	
	var _confirmVisitGWReq = __webpack_require__(503);
	
	var confirmVisitGW = _interopRequireWildcard(_confirmVisitGWReq);
	
	var _confirmInlineVisit = __webpack_require__(622);
	
	var confirmInlineVisit = _interopRequireWildcard(_confirmInlineVisit);
	
	var _inlineVisitsTimeSlots = __webpack_require__(506);
	
	var inlineVisitTimeSlots = _interopRequireWildcard(_inlineVisitsTimeSlots);
	
	var _editUser = __webpack_require__(136);
	
	var editProfiles = _interopRequireWildcard(_editUser);
	
	var _createEirUrgentCareAppointment = __webpack_require__(624);
	
	var _progressTypes = __webpack_require__(55);
	
	var _selectors = __webpack_require__(43);
	
	var _gtag = __webpack_require__(182);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleFailAppointmentConfirm),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(trackCompleteScheduling),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleSuccessAppointmentConfirm),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleFailInlineVisitConfirm),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(confirmAppointmentSaga);
	
	function handleFailAppointmentConfirm(_ref) {
	  var payload = _ref.payload;
	
	  var code, error, description, isGWFlow, isRescheduleFlow, scheduleData, errorMessage, _ref2, providerId, locationId, redirectCb;
	
	  return _regenerator2.default.wrap(function handleFailAppointmentConfirm$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          code = (0, _get2.default)(payload, 'error.code');
	          error = (0, _get2.default)(_errors.APPOINTMENT_ERRORS, code, 'errors.common');
	          description = (0, _get2.default)(payload, 'error.description');
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectProgressIsCreateFlowGW);
	
	        case 5:
	          isGWFlow = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectProgressIsRescheduleData);
	
	        case 8:
	          isRescheduleFlow = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors.selectProgressSchedule);
	
	        case 11:
	          scheduleData = _context.sent;
	          errorMessage = _errors.CHANGE_APPOINTMENT_STATUS_ERROR_CODES.includes(code) ? description : error;
	          _context.next = 15;
	          return (0, _effects.put)(isGWFlow ? confirmVisitGW.actions.showErrorAlert(errorMessage) : confirmVisitSelfScheduling.actions.showErrorAlert('errors.appointment.timeSlotNotAvailable'));
	
	        case 15:
	          if (!isRescheduleFlow) {
	            _context.next = 21;
	            break;
	          }
	
	          _ref2 = scheduleData || { provider: {}, location: {} }, providerId = _ref2.provider.id, locationId = _ref2.location.id;
	          _context.next = 19;
	          return (0, _effects.call)(_redirectUtils.redirectToRescheduleProviderDetails, { providerId: providerId, locationId: locationId });
	
	        case 19:
	          _context.next = 24;
	          break;
	
	        case 21:
	          redirectCb = [_errors.ERROR_CODES.APPOINTMENT_SCHEDULE_TIME_NOT_AVAILABLE, _errors.ERROR_CODES.PROVIDER_IS_NOT_AVAILABLE_FOR_THIS_TIME].includes(code) ? _redirectUtils.redirectToProviders : _redirectUtils.redirectToUsers;
	          _context.next = 24;
	          return (0, _effects.call)(redirectCb);
	
	        case 24:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function trackCompleteScheduling(_ref3) {
	  var payload = _ref3.payload;
	  var visitCode;
	  return _regenerator2.default.wrap(function trackCompleteScheduling$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          visitCode = (0, _get2.default)(payload, 'visitType.code');
	          _context2.next = 3;
	          return (0, _effects.call)(function () {
	            return (0, _gtag.GATrackCustomEvent)(_gtag.CustomEvents.GET_CARE_COMPLETE, { visitCode: visitCode });
	          });
	
	        case 3:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleSuccessAppointmentConfirm() {
	  var _ref4, id, patientForm, careUser, raceValue, ethnicity, language, homePhone, postalCode;
	
	  return _regenerator2.default.wrap(function handleSuccessAppointmentConfirm$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors.selectProgressCareUser);
	
	        case 2:
	          _ref4 = _context3.sent;
	          id = _ref4.id;
	          _context3.next = 6;
	          return (0, _effects.select)(_selectors.selectProgressPatientForm);
	
	        case 6:
	          patientForm = _context3.sent;
	          _context3.next = 9;
	          return (0, _effects.select)(_selectors.selectProgressCareUser);
	
	        case 9:
	          careUser = _context3.sent;
	          raceValue = (0, _get2.default)(patientForm, 'race', null);
	          ethnicity = (0, _get2.default)(patientForm, 'ethnicity', null);
	          language = (0, _get2.default)(patientForm, 'language', null);
	          homePhone = (0, _get2.default)(patientForm, 'homePhone', null);
	          postalCode = (0, _get2.default)(patientForm, 'postalCode', null);
	
	          if (!(_effects.race !== careUser.race || ethnicity !== careUser.ethnicity || language !== careUser.language || homePhone !== careUser.homePhone || postalCode !== careUser.postalCode)) {
	            _context3.next = 18;
	            break;
	          }
	
	          _context3.next = 18;
	          return (0, _effects.put)(editProfiles.actions.send((0, _extends3.default)({
	            id: careUser.id
	          }, raceValue && { race: raceValue }, ethnicity && { ethnicity: ethnicity }, language && { language: language }, homePhone && { homePhone: homePhone }, postalCode && { postalCode: postalCode })));
	
	        case 18:
	          _context3.next = 20;
	          return (0, _effects.call)(_redirectUtils.redirectToHealthBoard, id);
	
	        case 20:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function handleFailInlineVisitConfirm() {
	  var reason, service, location, _ref5, succeed, timeSlots;
	
	  return _regenerator2.default.wrap(function handleFailInlineVisitConfirm$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.select)(_selectors.selectReasonForOverview);
	
	        case 2:
	          reason = _context4.sent;
	          _context4.next = 5;
	          return (0, _effects.select)(_selectors.selectProgressService);
	
	        case 5:
	          service = _context4.sent;
	          _context4.next = 8;
	          return (0, _effects.select)(_selectors.selectProgressLocation);
	
	        case 8:
	          location = _context4.sent;
	          _context4.next = 11;
	          return (0, _effects.put)(confirmInlineVisit.actions.showErrorAlert('errors.appointment.timeSlotNotAvailable'));
	
	        case 11:
	          _context4.next = 13;
	          return (0, _effects.put)(inlineVisitTimeSlots.actions.send({
	            reasonTypeId: reason.id,
	            serviceId: service.id,
	            locationId: location.id
	          }));
	
	        case 13:
	          _context4.next = 15;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(inlineVisitTimeSlots.consts.SUCCEED),
	            rejected: (0, _effects.take)(inlineVisitTimeSlots.consts.REJECTED)
	          });
	
	        case 15:
	          _ref5 = _context4.sent;
	          succeed = _ref5.succeed;
	
	          if (!succeed) {
	            _context4.next = 26;
	            break;
	          }
	
	          _context4.next = 20;
	          return (0, _effects.select)(_selectors.selectInlineVisitTimeSlots);
	
	        case 20:
	          timeSlots = _context4.sent;
	
	          if (!(timeSlots.length > 0)) {
	            _context4.next = 24;
	            break;
	          }
	
	          _context4.next = 24;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setScheduleData({ time: timeSlots[0] }));
	
	        case 24:
	          _context4.next = 28;
	          break;
	
	        case 26:
	          _context4.next = 28;
	          return (0, _effects.put)(confirmInlineVisit.actions.showErrorAlert('errors.common'));
	
	        case 28:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function confirmAppointmentSaga() {
	  return _regenerator2.default.wrap(function confirmAppointmentSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)([confirmVisitGW.consts.SUCCEED, confirmVisitSelfScheduling.consts.SUCCEED, _createEirUrgentCareAppointment.consts.SUCCEED], handleSuccessAppointmentConfirm);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.takeLatest)([confirmVisitGW.consts.SUCCEED, confirmInlineVisit.consts.SUCCEED, confirmVisitSelfScheduling.consts.SUCCEED, _createEirUrgentCareAppointment.consts.SUCCEED], trackCompleteScheduling);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.takeLatest)([confirmVisitGW.consts.REJECTED, confirmVisitSelfScheduling.consts.REJECTED, _createEirUrgentCareAppointment.consts.REJECTED], handleFailAppointmentConfirm);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.takeLatest)(confirmInlineVisit.consts.REJECTED, handleFailInlineVisitConfirm);
	
	        case 8:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 3925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = confirmUrgentVisitSaga;
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _effects = __webpack_require__(14);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(43);
	
	var _confirmVisitUrgentReq = __webpack_require__(623);
	
	var confirmVisitUrgent = _interopRequireWildcard(_confirmVisitUrgentReq);
	
	var _errors = __webpack_require__(120);
	
	var _appointmentDetailsReq = __webpack_require__(259);
	
	var appointmentDetails = _interopRequireWildcard(_appointmentDetailsReq);
	
	var _couponVerificationReq = __webpack_require__(418);
	
	var couponVerification = _interopRequireWildcard(_couponVerificationReq);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _paymentVerificationsReq = __webpack_require__(419);
	
	var paymentVerification = _interopRequireWildcard(_paymentVerificationsReq);
	
	var _appointmentAccountFormPaymentReq = __webpack_require__(339);
	
	var _redirectUtils = __webpack_require__(77);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleSuccessConfirmUrgentVisit),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleErrorConfirmUrgentVisit),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleSuccessPaymentUrgentVisit),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleSuccessAppointmentPaymentAccountForm),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(confirmUrgentVisitSaga);
	
	var APPOINTMENT_PRICING_SCHEDULE_NOT_FOUND = _errors.ERROR_CODES.APPOINTMENT_PRICING_SCHEDULE_NOT_FOUND;
	
	
	function handleSuccessConfirmUrgentVisit(_ref) {
	  var payload = _ref.payload;
	  return _regenerator2.default.wrap(function handleSuccessConfirmUrgentVisit$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(appointmentDetails.actions.succeed(payload));
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleErrorConfirmUrgentVisit(_ref2) {
	  var payload = _ref2.payload;
	
	  var _get, code, userId;
	
	  return _regenerator2.default.wrap(function handleErrorConfirmUrgentVisit$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _get = (0, _get3.default)(payload, 'error', {}), code = _get.code;
	
	          if (!(code === APPOINTMENT_PRICING_SCHEDULE_NOT_FOUND)) {
	            _context2.next = 9;
	            break;
	          }
	
	          _context2.next = 4;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 4:
	          userId = _context2.sent;
	          _context2.next = 7;
	          return (0, _effects.put)(error.actions.update({ id: _errors.APPOINTMENT_ERRORS[code] }));
	
	        case 7:
	          _context2.next = 9;
	          return (0, _effects.call)(_redirectUtils.redirectToHealthBoard, userId);
	
	        case 9:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleSuccessPaymentUrgentVisit() {
	  return _regenerator2.default.wrap(function handleSuccessPaymentUrgentVisit$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors2.selectProgressIsUrgentVisitFlow);
	
	        case 2:
	          if (!_context3.sent) {
	            _context3.next = 9;
	            break;
	          }
	
	          _context3.next = 5;
	          return (0, _effects.take)(paymentVerification.consts.SUCCEED);
	
	        case 5:
	          _context3.next = 7;
	          return (0, _effects.call)(_redirectUtils.redirectToSummary);
	
	        case 7:
	          _context3.next = 9;
	          return (0, _effects.put)(couponVerification.actions.clear());
	
	        case 9:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function handleSuccessAppointmentPaymentAccountForm() {
	  return _regenerator2.default.wrap(function handleSuccessAppointmentPaymentAccountForm$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.put)(couponVerification.actions.clear());
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.select)(_selectors2.selectProgressIsUrgentVisitFlow);
	
	        case 4:
	          if (!_context4.sent) {
	            _context4.next = 7;
	            break;
	          }
	
	          _context4.next = 7;
	          return (0, _effects.call)(_redirectUtils.redirectToSummary);
	
	        case 7:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function confirmUrgentVisitSaga() {
	  return _regenerator2.default.wrap(function confirmUrgentVisitSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)([confirmVisitUrgent.consts.SUCCEED], handleSuccessConfirmUrgentVisit);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.takeLatest)([confirmVisitUrgent.consts.REJECTED], handleErrorConfirmUrgentVisit);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.takeLatest)([_appointmentDetails.APPOINTMENT_DETAILS_TYPES.PAYMENT_SUCCESS], handleSuccessPaymentUrgentVisit);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.takeLatest)([_appointmentAccountFormPaymentReq.consts.SUCCEED], handleSuccessAppointmentPaymentAccountForm);
	
	        case 8:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 3926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = fetchProvidersSaga;
	
	var _effects = __webpack_require__(14);
	
	var _progressTypes = __webpack_require__(55);
	
	var _availableProvidersSelfScheduling = __webpack_require__(1224);
	
	var availableProvidersSelfScheduling = _interopRequireWildcard(_availableProvidersSelfScheduling);
	
	var _availableEirLocations = __webpack_require__(1223);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleStartFetchProviderList),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchProvidersSaga);
	
	function handleStartFetchProviderList() {
	  var scheduleReqPayload, organizationId, visitType, programBasedVisitId, isEirVisitType, baseRequestParams;
	  return _regenerator2.default.wrap(function handleStartFetchProviderList$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectScheduleListReqPayload);
	
	        case 2:
	          scheduleReqPayload = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectProgressOrganizationId);
	
	        case 5:
	          organizationId = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectProgressVisitType);
	
	        case 8:
	          visitType = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors.selectProgramBasedVisitId);
	
	        case 11:
	          programBasedVisitId = _context.sent;
	          _context.next = 14;
	          return (0, _effects.select)(_selectors.selectIsEirVisitTypeCode);
	
	        case 14:
	          isEirVisitType = _context.sent;
	          baseRequestParams = {
	            date: scheduleReqPayload.date,
	            locationIds: scheduleReqPayload.filterIds,
	            organizationId: organizationId,
	            reasonTypeId: scheduleReqPayload.payload.reasonTypeId,
	            serviceId: scheduleReqPayload.payload.serviceId,
	            userId: scheduleReqPayload.userId,
	            visitTypeId: visitType.id
	          };
	
	          if (!isEirVisitType) {
	            _context.next = 21;
	            break;
	          }
	
	          _context.next = 19;
	          return (0, _effects.put)(_availableEirLocations.actions.send(baseRequestParams));
	
	        case 19:
	          _context.next = 23;
	          break;
	
	        case 21:
	          _context.next = 23;
	          return (0, _effects.put)(availableProvidersSelfScheduling.actions.send((0, _extends3.default)({}, baseRequestParams, {
	            pbvConfigId: programBasedVisitId
	          })));
	
	        case 23:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function fetchProvidersSaga() {
	  return _regenerator2.default.wrap(function fetchProvidersSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.FETCH_PROVIDER_LIST, handleStartFetchProviderList);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = handleInsuranceSucceedUpdate;
	
	var _effects = __webpack_require__(14);
	
	var _success = __webpack_require__(104);
	
	var succeed = _interopRequireWildcard(_success);
	
	var _routes = __webpack_require__(37);
	
	var _checkInsuranceEligibility = __webpack_require__(292);
	
	var _insuranceEligibilityManualActivations = __webpack_require__(427);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(succeedWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleInsuranceSucceedUpdate);
	
	function succeedWorker() {
	  var url, parts;
	  return _regenerator2.default.wrap(function succeedWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          url = window.location.href;
	          parts = url.split('/');
	
	          if (!parts.includes(_routes.PATIENT_INFO)) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 5;
	          return (0, _effects.delay)(500);
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)({
	            type: succeed.consts.UPDATE,
	            payload: { id: 'appointments.form.insuranceDetails,success' }
	          });
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleInsuranceSucceedUpdate() {
	  return _regenerator2.default.wrap(function handleInsuranceSucceedUpdate$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_checkInsuranceEligibility.consts.SUCCEED, _insuranceEligibilityManualActivations.consts.SUCCEED], succeedWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _handleInsuranceErrorModal = __webpack_require__(502);
	
	var _checkInsuranceEligibility = __webpack_require__(292);
	
	var _updatePatientInsurance = __webpack_require__(350);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(worker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleInsuranceUpdateFailed);
	
	function worker(_ref) {
	  var payload = _ref.payload;
	  var handledErrorEntity;
	  return _regenerator2.default.wrap(function worker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (!payload) {
	            _context.next = 11;
	            break;
	          }
	
	          handledErrorEntity = (0, _get2.default)(payload, 'error.meta');
	
	          if (!handledErrorEntity) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 5;
	          return (0, _effects.put)(_handleInsuranceErrorModal.insuranceErrorModalActions.open((0, _extends3.default)({}, handledErrorEntity)));
	
	        case 5:
	          _context.next = 9;
	          break;
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)({
	            type: (0, _consts2.default)('ui', 'error', ['UPDATE']).UPDATE,
	            payload: { id: 'errors.common' }
	          });
	
	        case 9:
	          _context.next = 13;
	          break;
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.put)({
	            type: (0, _consts2.default)('ui', 'error', ['UPDATE']).UPDATE,
	            payload: { id: 'errors.longRequest.502.504' }
	          });
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleInsuranceUpdateFailed() {
	  return _regenerator2.default.wrap(function handleInsuranceUpdateFailed$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_checkInsuranceEligibility.consts.REJECTED, _checkInsuranceEligibility.consts.ERROR_ENCOUNTERED, _updatePatientInsurance.consts.REJECTED, _updatePatientInsurance.consts.ERROR_ENCOUNTERED], worker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	exports.default = handleInsuranceUpdateFailed;

/***/ }),
/* 3929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = getAvailableTimeSlots;
	
	var _effects = __webpack_require__(14);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _inlineVisitsTimeSlots = __webpack_require__(506);
	
	var inlineVisitTimeSlots = _interopRequireWildcard(_inlineVisitsTimeSlots);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleGetAvailableTimeSlots),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getAvailableTimeSlots);
	
	function handleGetAvailableTimeSlots() {
	  var timeSlots, loading, availableTimeSlots;
	  return _regenerator2.default.wrap(function handleGetAvailableTimeSlots$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectInlineVisitTimeSlots);
	
	        case 2:
	          timeSlots = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectInlineVisitTimeSlotsPending);
	
	        case 5:
	          loading = _context.sent;
	          availableTimeSlots = !loading && timeSlots;
	
	          if (!(availableTimeSlots && timeSlots.length > 0)) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.cancel)();
	
	        case 10:
	          if (!(availableTimeSlots && timeSlots.length === 0)) {
	            _context.next = 17;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.put)(inlineVisitTimeSlots.actions.showErrorAlert('appointment.inlineVisit.error.noAvailableTime'));
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.delay)(4000);
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.call)(_redirectUtils.redirectToUsers);
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function getAvailableTimeSlots() {
	  return _regenerator2.default.wrap(function getAvailableTimeSlots$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(inlineVisitTimeSlots.consts.SUCCEED, handleGetAvailableTimeSlots);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.default = inspectConsentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(43);
	
	var _acceptConsentReq = __webpack_require__(1222);
	
	var acceptConsent = _interopRequireWildcard(_acceptConsentReq);
	
	var _inspectionReq = __webpack_require__(293);
	
	var inspectReq = _interopRequireWildcard(_inspectionReq);
	
	var _progressTypes = __webpack_require__(55);
	
	var _constants = __webpack_require__(17);
	
	var _inspectAllSaga = __webpack_require__(805);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(validateConsentInspection),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(inspectConsentSaga);
	
	var CONSENT = _constants.APPOINTMENT_INSPECTION.CONSENT;
	
	
	function validateConsentInspection() {
	  var _ref, concentId, version, _ref2, userId, payload, inspection;
	
	  return _regenerator2.default.wrap(function validateConsentInspection$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectConsentFormData);
	
	        case 2:
	          _ref = _context.sent;
	          concentId = _ref.id;
	          version = _ref.version;
	          _context.next = 7;
	          return (0, _effects.select)(_selectors.selectProgressCareUser);
	
	        case 7:
	          _ref2 = _context.sent;
	          userId = _ref2.id;
	          payload = {
	            concentId: concentId,
	            userConsentInfo: {
	              accepted: true,
	              userId: userId,
	              version: version
	            }
	          };
	          _context.next = 12;
	          return (0, _effects.put)(acceptConsent.actions.send(payload));
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.take)(acceptConsent.consts.SUCCEED);
	
	        case 14:
	          inspection = {
	            inspectionFor: CONSENT,
	            completed: true,
	            fieldList: []
	          };
	          _context.next = 17;
	          return (0, _effects.put)(inspectReq.actions.setEntity((0, _defineProperty3.default)({}, CONSENT, inspection)));
	
	        case 17:
	          _context.next = 19;
	          return (0, _effects.call)(_inspectAllSaga.verifyInspection);
	
	        case 19:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function inspectConsentSaga() {
	  return _regenerator2.default.wrap(function inspectConsentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.INSPECT_CONSENT, validateConsentInspection);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = inspectPatientSaga;
	
	var _effects = __webpack_require__(14);
	
	var _inspectPatientForm = __webpack_require__(1228);
	
	var inspectPatient = _interopRequireWildcard(_inspectPatientForm);
	
	var _inspectionReq = __webpack_require__(293);
	
	var inspectReq = _interopRequireWildcard(_inspectionReq);
	
	var _deepTrim = __webpack_require__(357);
	
	var _deepTrim2 = _interopRequireDefault(_deepTrim);
	
	var _constants = __webpack_require__(17);
	
	var _selectors = __webpack_require__(43);
	
	var _progressTypes = __webpack_require__(55);
	
	var _inspectAllSaga = __webpack_require__(805);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(validatePatientProfileInspection),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(inspectPatientSaga);
	
	var PROFILE = _constants.APPOINTMENT_INSPECTION.PROFILE,
	    LOCAL_PROFILE = _constants.APPOINTMENT_INSPECTION.LOCAL_PROFILE;
	
	
	function validatePatientProfileInspection(_ref) {
	  var profile = _ref.payload;
	
	  var _ref2, userId, visitTypeCode, inInlineVisitType, inspectionFor, payload, _ref3, _ref3$payload, inspection;
	
	  return _regenerator2.default.wrap(function validatePatientProfileInspection$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectProgressCareUser);
	
	        case 2:
	          _ref2 = _context.sent;
	          userId = _ref2.id;
	          _context.next = 6;
	          return (0, _effects.select)(_selectors.selectProgressVisitTypeCode);
	
	        case 6:
	          visitTypeCode = _context.sent;
	          inInlineVisitType = _constants.INLINE_TYPES.includes(visitTypeCode);
	          inspectionFor = inInlineVisitType ? LOCAL_PROFILE : PROFILE;
	          payload = { profile: profile };
	          _context.next = 12;
	          return (0, _effects.put)(inspectPatient.actions.send((0, _deepTrim2.default)({ userId: userId, inspectionFor: inspectionFor, payload: payload })));
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.take)(inspectPatient.consts.SUCCEED);
	
	        case 14:
	          _ref3 = _context.sent;
	          _ref3$payload = (0, _slicedToArray3.default)(_ref3.payload, 1);
	          inspection = _ref3$payload[0];
	          _context.next = 19;
	          return (0, _effects.put)(inspectReq.actions.setEntity((0, _defineProperty3.default)({}, inspectionFor, inspection)));
	
	        case 19:
	          _context.next = 21;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setPatientInfo(profile));
	
	        case 21:
	          if (!(inspectionFor === PROFILE && inspection.fieldList.length > 0)) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.cancel)();
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.call)(_inspectAllSaga.handleShowEmergencyContactStep);
	
	        case 26:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function inspectPatientSaga() {
	  return _regenerator2.default.wrap(function inspectPatientSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.INSPECT_PATIENT, validatePatientProfileInspection);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = loadMoreMedicationsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(43);
	
	var _medicationsReq = __webpack_require__(627);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMoreWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(loadMoreMedicationsSaga);
	
	function loadMoreWorker(action) {
	  var payload, userId, query, offset, limit, medicationsList;
	  return _regenerator2.default.wrap(function loadMoreWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          userId = payload.userId, query = payload.query, offset = payload.offset;
	          limit = 10;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectMedicationSearch);
	
	        case 5:
	          medicationsList = _context.sent;
	
	          if (!(offset >= medicationsList.count)) {
	            _context.next = 8;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)(_medicationsReq.actions.send({
	            limit: limit,
	            query: query,
	            userId: userId,
	            offset: offset + limit
	          }));
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function loadMoreMedicationsSaga() {
	  return _regenerator2.default.wrap(function loadMoreMedicationsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_medicationsReq.consts.LOAD_MORE], loadMoreWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = PharmacyMoreSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(43);
	
	var _pharmacyReq = __webpack_require__(628);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMoreWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(PharmacyMoreSaga);
	
	function loadMoreWorker(action) {
	  var payload, zip, activeMailOrder, offset, limit, pharmaciesList;
	  return _regenerator2.default.wrap(function loadMoreWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          zip = payload.zip, activeMailOrder = payload.activeMailOrder, offset = payload.offset;
	          limit = 20;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectPharmaciesList);
	
	        case 5:
	          pharmaciesList = _context.sent;
	
	          if (!(offset >= pharmaciesList.count)) {
	            _context.next = 8;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)(_pharmacyReq.actions.send((0, _extends3.default)({}, activeMailOrder && { mailOrder: true }, {
	            limit: limit,
	            zip: zip,
	            offset: offset + limit
	          })));
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function PharmacyMoreSaga() {
	  return _regenerator2.default.wrap(function PharmacyMoreSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_pharmacyReq.consts.LOAD_MORE], loadMoreWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = myProvidersListGuard;
	
	var _effects = __webpack_require__(14);
	
	var _popup = __webpack_require__(76);
	
	var _myProvidersReq = __webpack_require__(338);
	
	var myProviders = _interopRequireWildcard(_myProvidersReq);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _selectors = __webpack_require__(43);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchMyProviders),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(myProvidersListGuard);
	
	function fetchMyProviders(_ref) {
	  var data = _ref.payload;
	
	  var userId, _ref2, success;
	
	  return _regenerator2.default.wrap(function fetchMyProviders$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectProgressCareUserId);
	
	        case 2:
	          userId = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)((0, _popup.showLoaderInPopup)());
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)(myProviders.actions.send({
	            userId: userId,
	            organizationId: data.id,
	            limit: 3,
	            offset: 0
	          }));
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.race)({
	            error: (0, _effects.take)([myProviders.consts.REJECTED, myProviders.consts.ERROR_ENCOUNTERED]),
	            success: (0, _effects.take)(myProviders.consts.SUCCEED)
	          });
	
	        case 9:
	          _ref2 = _context.sent;
	          success = _ref2.success;
	          _context.next = 13;
	          return (0, _effects.put)((0, _popup.hideLoaderInPopup)());
	
	        case 13:
	          if (!success) {
	            _context.next = 18;
	            break;
	          }
	
	          _context.next = 16;
	          return (0, _effects.call)(_redirectUtils.redirectToVisitType);
	
	        case 16:
	          _context.next = 22;
	          break;
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'errors.common' }
	          });
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.cancel)();
	
	        case 22:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function myProvidersListGuard() {
	  return _regenerator2.default.wrap(function myProvidersListGuard$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(myProviders.consts.INIT, fetchMyProviders);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = myProvidersListPagination;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _myProvidersReq = __webpack_require__(338);
	
	var myProviders = _interopRequireWildcard(_myProvidersReq);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMoreMyProviders),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(myProvidersListPagination);
	
	function loadMoreMyProviders(_ref) {
	  var payload = _ref.payload;
	  var counter, list, listSize;
	  return _regenerator2.default.wrap(function loadMoreMyProviders$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectMyProvidersCount);
	
	        case 2:
	          counter = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectMyProvidersList);
	
	        case 5:
	          list = _context.sent;
	          listSize = (0, _size2.default)(list);
	
	          if (!(counter <= listSize)) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.cancel)();
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.put)(myProviders.paginationActions.send((0, _extends3.default)({}, payload, { offset: listSize })));
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function myProvidersListPagination() {
	  return _regenerator2.default.wrap(function myProvidersListPagination$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([myProviders.consts.LOAD_MORE], loadMoreMyProviders);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = organizationListGuard;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _popup = __webpack_require__(76);
	
	var _schedulableTreeReq = __webpack_require__(804);
	
	var schedulingTree = _interopRequireWildcard(_schedulableTreeReq);
	
	var _myProvidersReq = __webpack_require__(338);
	
	var myProviders = _interopRequireWildcard(_myProvidersReq);
	
	var _progressTypes = __webpack_require__(55);
	
	var _redirectUtils = __webpack_require__(77);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchOrganizationsByUserID),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(organizationListGuard);
	
	function fetchOrganizationsByUserID(_ref) {
	  var data = _ref.payload;
	
	  var _ref2, payload, orgSize;
	
	  return _regenerator2.default.wrap(function fetchOrganizationsByUserID$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)((0, _popup.showLoaderInPopup)());
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)(schedulingTree.actions.send((0, _extends3.default)({}, data)));
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.take)(schedulingTree.consts.SUCCEED);
	
	        case 6:
	          _ref2 = _context.sent;
	          payload = _ref2.payload;
	          _context.next = 10;
	          return (0, _effects.put)((0, _popup.hideLoaderInPopup)());
	
	        case 10:
	          orgSize = (0, _size2.default)(payload.organizations);
	
	          if (!(orgSize === 1)) {
	            _context.next = 18;
	            break;
	          }
	
	          _context.next = 14;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setOrganization(payload.organizations[0]));
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.put)(myProviders.actions.init(payload.organizations[0]));
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.cancel)();
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.call)(_redirectUtils.redirectToOrganizations);
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function organizationListGuard() {
	  return _regenerator2.default.wrap(function organizationListGuard$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(schedulingTree.consts.INIT, fetchOrganizationsByUserID);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.takeLatest)([schedulingTree.consts.REJECTED, schedulingTree.consts.ERROR_ENCOUNTERED], /*#__PURE__*/_regenerator2.default.mark(function handleFailedReq() {
	            return _regenerator2.default.wrap(function handleFailedReq$(_context2) {
	              while (1) {
	                switch (_context2.prev = _context2.next) {
	                  case 0:
	                    _context2.next = 2;
	                    return (0, _effects.put)((0, _popup.hideLoaderInPopup)());
	
	                  case 2:
	                  case 'end':
	                    return _context2.stop();
	                }
	              }
	            }, handleFailedReq, this);
	          }));
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = repeatableScheduleFlow;
	
	var _effects = __webpack_require__(14);
	
	var _myProvidersReq = __webpack_require__(338);
	
	var myProviders = _interopRequireWildcard(_myProvidersReq);
	
	var _inspectionReq = __webpack_require__(293);
	
	var inspectReq = _interopRequireWildcard(_inspectionReq);
	
	var _progressTypes = __webpack_require__(55);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleInitRepeatableFlow),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(repeatableScheduleFlow);
	
	function handleInitRepeatableFlow(_ref) {
	  var payload = _ref.payload;
	  var service, userId, visitType;
	  return _regenerator2.default.wrap(function handleInitRepeatableFlow$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          service = payload.service, userId = payload.userId, visitType = payload.visitType;
	          _context.next = 3;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setRescheduleData(payload));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setVisitType(visitType));
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setService(service));
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)(inspectReq.actions.send({
	            userId: userId,
	            inspectionFor: ['profile_form', 'documents_form']
	          }));
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function repeatableScheduleFlow() {
	  return _regenerator2.default.wrap(function repeatableScheduleFlow$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([myProviders.consts.SELECT_MY_PROVIDER], handleInitRepeatableFlow);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = updateNecessaryData;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _routes = __webpack_require__(37);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _userDetailsReq = __webpack_require__(629);
	
	var userDetails = _interopRequireWildcard(_userDetailsReq);
	
	var _necessaryDataPreparingReq = __webpack_require__(1230);
	
	var necessaryData = _interopRequireWildcard(_necessaryDataPreparingReq);
	
	var _progressTypes = __webpack_require__(55);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(detectFlow),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleUpdate),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(updateNecessaryData);
	
	function detectFlow() {
	  var isRescheduleFlow, careUserId;
	  return _regenerator2.default.wrap(function detectFlow$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectProgressIsRescheduleData);
	
	        case 2:
	          isRescheduleFlow = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectProgressCareUserId);
	
	        case 5:
	          careUserId = _context.sent;
	
	          if (!window.location.pathname.includes(_routes2.default.APPOINTMENT_FORM_EMERGENCY_CONTACT)) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 9;
	          return (0, _effects.put)(userDetails.actions.send({ id: careUserId }));
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.cancel)();
	
	        case 11:
	          if (!window.location.pathname.includes(_routes2.default.APPOINTMENT_FORM_PHARMACY)) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 14;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.determineNextStepAfterPharmacy());
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.cancel)();
	
	        case 16:
	          if (!window.location.pathname.includes(_routes2.default.APPOINTMENT_FORM_HEALTH_INFO)) {
	            _context.next = 21;
	            break;
	          }
	
	          _context.next = 19;
	          return (0, _effects.call)(_redirectUtils.redirectToPayment);
	
	        case 19:
	          _context.next = 21;
	          return (0, _effects.cancel)();
	
	        case 21:
	          if (isRescheduleFlow) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.call)(_redirectUtils.redirectToProviders);
	
	        case 24:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleUpdate(action) {
	  var _ref, userId, patientForm, healthInfoForm, pharmacyId, organizationId, ssn, profile, payload, finishAction, data;
	
	  return _regenerator2.default.wrap(function handleUpdate$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors.selectProgressCareUser);
	
	        case 2:
	          _ref = _context2.sent;
	          userId = _ref.id;
	          _context2.next = 6;
	          return (0, _effects.select)(_selectors.selectProgressPatientForm);
	
	        case 6:
	          patientForm = _context2.sent;
	          _context2.next = 9;
	          return (0, _effects.select)(_selectors.selectHealthInfoForm);
	
	        case 9:
	          healthInfoForm = _context2.sent;
	          _context2.next = 12;
	          return (0, _effects.select)(_selectors.selectPreferredPharmacy);
	
	        case 12:
	          pharmacyId = _context2.sent;
	          _context2.next = 15;
	          return (0, _effects.select)(_selectors.selectProgressOrganizationId);
	
	        case 15:
	          organizationId = _context2.sent;
	          _context2.next = 18;
	          return (0, _effects.select)(_selectors.selectProgressSSN);
	
	        case 18:
	          ssn = _context2.sent;
	          profile = (0, _lodash.omitBy)(patientForm, _lodash.isEmpty);
	          payload = (0, _lodash.omitBy)({ profile: profile, ssn: ssn, healthInfoForm: healthInfoForm }, _lodash.isEmpty);
	          finishAction = (0, _lodash.get)(action, 'meta.finishAction');
	          data = (0, _lodash.get)(action, 'payload');
	
	          if (!(!(0, _lodash.isEmpty)(payload) || !(0, _lodash.isEmpty)(data))) {
	            _context2.next = 37;
	            break;
	          }
	
	          _context2.next = 26;
	          return (0, _effects.put)(necessaryData.actions.send({
	            userId: userId,
	            payload: (0, _extends3.default)({
	              ssn: ssn,
	              profile: profile
	            }, data, pharmacyId && { pharmacyId: pharmacyId }, {
	              organizationId: organizationId
	            }, healthInfoForm)
	          }));
	
	        case 26:
	          _context2.next = 28;
	          return (0, _effects.take)(necessaryData.consts.SUCCEED);
	
	        case 28:
	          if (!finishAction) {
	            _context2.next = 35;
	            break;
	          }
	
	          _context2.next = 31;
	          return (0, _effects.call)(finishAction);
	
	        case 31:
	          _context2.next = 33;
	          return (0, _effects.put)(userDetails.actions.send({ id: userId }));
	
	        case 33:
	          _context2.next = 35;
	          return (0, _effects.cancel)();
	
	        case 35:
	          _context2.next = 37;
	          return (0, _effects.call)(detectFlow);
	
	        case 37:
	          _context2.next = 39;
	          return (0, _effects.call)(detectFlow);
	
	        case 39:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function updateNecessaryData() {
	  return _regenerator2.default.wrap(function updateNecessaryData$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.UPDATE_NECESSARY_DATA, handleUpdate);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 3939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = validateOnMount;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(115);
	
	var _progressTypes = __webpack_require__(55);
	
	var _redirectUtils = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleValidateOnMount),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(validateOnMount);
	
	function handleValidateOnMount() {
	  var currentLocation;
	  return _regenerator2.default.wrap(function handleValidateOnMount$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.currentLocationSelector);
	
	        case 2:
	          currentLocation = _context.sent;
	
	          if (!(currentLocation !== _redirectUtils.rootAppointmentFormPath)) {
	            _context.next = 6;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.call)(_redirectUtils.redirectToUsers);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.delay)(200);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.finishValidate());
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function validateOnMount() {
	  return _regenerator2.default.wrap(function validateOnMount$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.VALIDATE, handleValidateOnMount);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = organizationListGuard;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _inspectionReq = __webpack_require__(293);
	
	var inspectReq = _interopRequireWildcard(_inspectionReq);
	
	var _visitTypesReq = __webpack_require__(630);
	
	var visitTypes = _interopRequireWildcard(_visitTypesReq);
	
	var _popup = __webpack_require__(76);
	
	var _publixInfoReq = __webpack_require__(1234);
	
	var publixInfo = _interopRequireWildcard(_publixInfoReq);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _constants = __webpack_require__(17);
	
	var _progressTypes = __webpack_require__(55);
	
	var _selectors = __webpack_require__(43);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(servicesListGuard),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleCheckVisitType),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleVisitTypeSelect),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleProgramBasedVisitTypeSelect),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(fetchVisits),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(organizationListGuard);
	
	var _INLINE_TYPES = (0, _slicedToArray3.default)(_constants.INLINE_TYPES, 4),
	    URGENT_CARE_TYPE_CODE = _INLINE_TYPES[0],
	    IMAGING_TYPE_CODE = _INLINE_TYPES[1],
	    LAB_TYPE_CODE = _INLINE_TYPES[2],
	    TECH_CONNECT_CODE = _INLINE_TYPES[3];
	
	var PROFILE = _constants.APPOINTMENT_INSPECTION.PROFILE,
	    DOCUMENTS = _constants.APPOINTMENT_INSPECTION.DOCUMENTS;
	
	
	var getNotHiddenVisitTypes = function getNotHiddenVisitTypes(types) {
	  return types.filter(function (_ref) {
	    var code = _ref.code;
	    return !_constants.APPOINTMENT_HIDDEN_TYPES.includes(code);
	  });
	};
	
	function servicesListGuard(services) {
	  var _ref2, userId;
	
	  return _regenerator2.default.wrap(function servicesListGuard$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (!((0, _size2.default)(services) === 1)) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setService(services[0]));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectProgressCareUser);
	
	        case 5:
	          _ref2 = _context.sent;
	          userId = _ref2.id;
	          _context.next = 9;
	          return (0, _effects.put)(inspectReq.actions.send({
	            userId: userId,
	            inspectionFor: [PROFILE, DOCUMENTS]
	          }));
	
	        case 9:
	          _context.next = 13;
	          break;
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.call)(_redirectUtils.redirectToServices);
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleCheckVisitType(visit) {
	  var code, isAllowedType;
	  return _regenerator2.default.wrap(function handleCheckVisitType$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          code = visit.code;
	          isAllowedType = _constants.APPOINTMENT_ALLOWED_TYPES.includes(code);
	
	          if (!isAllowedType) {
	            _context2.next = 5;
	            break;
	          }
	
	          _context2.next = 5;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.selectVisitType(visit));
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleVisitTypeSelect(_ref3) {
	  var payload = _ref3.payload;
	  var code, services;
	  return _regenerator2.default.wrap(function handleVisitTypeSelect$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setVisitType(payload));
	
	        case 2:
	          code = payload.code, services = payload.services;
	          _context3.t0 = code;
	          _context3.next = _context3.t0 === URGENT_CARE_TYPE_CODE ? 6 : _context3.t0 === IMAGING_TYPE_CODE ? 6 : _context3.t0 === LAB_TYPE_CODE ? 6 : _context3.t0 === TECH_CONNECT_CODE ? 6 : _context3.t0 === _constants.PUBLIX_CODE ? 11 : 18;
	          break;
	
	        case 6:
	          _context3.next = 8;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setService(services[0]));
	
	        case 8:
	          _context3.next = 10;
	          return (0, _effects.call)(_redirectUtils.redirectToLocations);
	
	        case 10:
	          return _context3.abrupt('return', _context3.sent);
	
	        case 11:
	          _context3.next = 13;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setService(services[0]));
	
	        case 13:
	          _context3.next = 15;
	          return (0, _effects.put)(publixInfo.actions.send({ visitCode: code }));
	
	        case 15:
	          _context3.next = 17;
	          return (0, _effects.call)(_redirectUtils.redirectToPublixInfo);
	
	        case 17:
	          return _context3.abrupt('return', _context3.sent);
	
	        case 18:
	          _context3.next = 20;
	          return (0, _effects.call)(servicesListGuard, services);
	
	        case 20:
	          return _context3.abrupt('return', _context3.sent);
	
	        case 21:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function handleProgramBasedVisitTypeSelect(_ref4) {
	  var payload = _ref4.payload;
	  var notHiddenVisitTypeList, listSize;
	  return _regenerator2.default.wrap(function handleProgramBasedVisitTypeSelect$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.setProgramBasedVisitId(payload));
	
	        case 2:
	          notHiddenVisitTypeList = getNotHiddenVisitTypes(payload.visitTypes);
	          listSize = (0, _size2.default)(notHiddenVisitTypeList);
	
	          if (!(listSize === 1)) {
	            _context4.next = 7;
	            break;
	          }
	
	          _context4.next = 7;
	          return (0, _effects.call)(handleCheckVisitType, notHiddenVisitTypeList[0]);
	
	        case 7:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function fetchVisits() {
	  var programBasedVisitId, _ref5, visitTypesList, pbvConfigs, safeVisitTypesList, commonVisitsSize, isOnlyOneVisit;
	
	  return _regenerator2.default.wrap(function fetchVisits$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(_selectors.selectProgramBasedVisitId);
	
	        case 2:
	          programBasedVisitId = _context5.sent;
	
	          if (!programBasedVisitId) {
	            _context5.next = 6;
	            break;
	          }
	
	          _context5.next = 6;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.clearProgramBasedVisitId());
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.select)(_selectors.selectProgressOrganization);
	
	        case 8:
	          _ref5 = _context5.sent;
	          visitTypesList = _ref5.visitTypes;
	          pbvConfigs = _ref5.pbvConfigs;
	          safeVisitTypesList = getNotHiddenVisitTypes(visitTypesList);
	          commonVisitsSize = (0, _size2.default)([].concat((0, _toConsumableArray3.default)(pbvConfigs), (0, _toConsumableArray3.default)(safeVisitTypesList)));
	          isOnlyOneVisit = commonVisitsSize === 1;
	
	          if (!(isOnlyOneVisit && (0, _size2.default)(pbvConfigs) === 1)) {
	            _context5.next = 19;
	            break;
	          }
	
	          _context5.next = 17;
	          return (0, _effects.put)(_progressTypes.appointmentProgressActions.selectProgramBasedVisit(pbvConfigs[0]));
	
	        case 17:
	          _context5.next = 19;
	          return (0, _effects.cancel)();
	
	        case 19:
	          if (!(isOnlyOneVisit && (0, _size2.default)(visitTypesList) === 1)) {
	            _context5.next = 22;
	            break;
	          }
	
	          _context5.next = 22;
	          return (0, _effects.call)(handleCheckVisitType, visitTypesList[0]);
	
	        case 22:
	          if (!(commonVisitsSize >= 0)) {
	            _context5.next = 25;
	            break;
	          }
	
	          _context5.next = 25;
	          return (0, _effects.put)((0, _popup.hideLoaderInPopup)());
	
	        case 25:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function organizationListGuard() {
	  return _regenerator2.default.wrap(function organizationListGuard$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.takeLatest)(visitTypes.consts.INIT, fetchVisits);
	
	        case 2:
	          _context6.next = 4;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.SELECT_VISIT_TYPE, handleVisitTypeSelect);
	
	        case 4:
	          _context6.next = 6;
	          return (0, _effects.takeLatest)(_progressTypes.APPOINTMENT_PROGRESS_TYPES.SELECT_PROGRAM_BASED_VISIT, handleProgramBasedVisitTypeSelect);
	
	        case 6:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}

/***/ }),
/* 3941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _appointmentAccountFormPaymentReq = __webpack_require__(339);
	
	var _appointmentAccountFormPaymentReq2 = _interopRequireDefault(_appointmentAccountFormPaymentReq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  appointmentAccountFormPayment: _appointmentAccountFormPaymentReq2.default
	});

/***/ }),
/* 3942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = appointmentsRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _appointmentAccountFormPaymentReq = __webpack_require__(339);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(appointmentsRootSaga);
	
	function appointmentsRootSaga() {
	  return _regenerator2.default.wrap(function appointmentsRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_appointmentAccountFormPaymentReq.watcher);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 3943 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.authAzureSaga = authAzureSaga;
	
	var _effects = __webpack_require__(14);
	
	var _reduxSaga = __webpack_require__(485);
	
	var _constants = __webpack_require__(17);
	
	var _env = __webpack_require__(103);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	var _authAzure = __webpack_require__(631);
	
	var _loginAzure = __webpack_require__(340);
	
	var _getAuthAzureErrorMessage = __webpack_require__(1910);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleAuthAzureWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(authAzureSaga);
	
	var NOT_CONFIRMED = _constants.AUTH_AZURE_ERROR_CODE.NOT_CONFIRMED;
	
	
	function handlePostMessage() {
	  return (0, _reduxSaga.eventChannel)(function (emitter) {
	    window.addEventListener('message', receiveMessage, false);
	    function receiveMessage(event) {
	      var safeOrigin = _env.WEB_APP_URL.slice(0, -1);
	      if (event.origin !== safeOrigin) return;
	      emitter(event.data);
	      emitter(_reduxSaga.END);
	    }
	    return function () {
	      window.removeEventListener('message', receiveMessage, false);
	    };
	  });
	}
	
	function handleAuthAzureWorker(_ref) {
	  var _ref$payload = _ref.payload,
	      intl = _ref$payload.intl,
	      signUpFlow = _ref$payload.signUpFlow;
	  var successRedirectUrl, errorRedirectUrl, signUpRedirectUrl, redirectUrl, postMessageChannel, result;
	  return _regenerator2.default.wrap(function handleAuthAzureWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          successRedirectUrl = '' + _env.WEB_APP_URL + _constants.AUTH_AZURE_REDIRECT.SUCCESS;
	          errorRedirectUrl = '' + _env.WEB_APP_URL + _constants.AUTH_AZURE_REDIRECT.ERROR;
	          signUpRedirectUrl = '' + _env.WEB_APP_URL + _constants.AUTH_AZURE_REDIRECT.SIGN_UP;
	          redirectUrl = _env.API_URI + 'azure_authentication/azure_omniauth?success_redirect_url=' + successRedirectUrl + '&error_redirect_url=' + errorRedirectUrl + (signUpFlow ? '&registration_redirect_url=' + signUpRedirectUrl : '') + '&params=patient';
	          _context.next = 6;
	          return window.open(redirectUrl);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.call)(handlePostMessage);
	
	        case 8:
	          postMessageChannel = _context.sent;
	          _context.prev = 9;
	
	        case 10:
	          if (false) {
	            _context.next = 32;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.take)(postMessageChannel);
	
	        case 13:
	          result = _context.sent;
	
	          if (!(result.type === 'error')) {
	            _context.next = 17;
	            break;
	          }
	
	          _context.next = 17;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: {
	              id: (0, _getAuthAzureErrorMessage.getAuthAzureErrorMessage)(result.code, intl)
	            },
	            isStaticFlow: true,
	            infoErrorIcon: result.code === NOT_CONFIRMED ? 'information' : null
	          });
	
	        case 17:
	          if (!(result.type === 'success')) {
	            _context.next = 27;
	            break;
	          }
	
	          _context.next = 20;
	          return (0, _effects.put)(_authAzure.actions.setCredentialForMfa({
	            login: result.login,
	            token: result.token
	          }));
	
	        case 20:
	          if (!signUpFlow) {
	            _context.next = 25;
	            break;
	          }
	
	          _context.next = 23;
	          return (0, _effects.put)(_authAzure.actions.setSuccessSignUpFlow());
	
	        case 23:
	          _context.next = 27;
	          break;
	
	        case 25:
	          _context.next = 27;
	          return (0, _effects.put)(_loginAzure.actions.send({ access_token: result.token }));
	
	        case 27:
	          if (!(result.type === 'sign_up')) {
	            _context.next = 30;
	            break;
	          }
	
	          _context.next = 30;
	          return (0, _effects.put)(_authAzure.actions.setSuccessSignUpFlow());
	
	        case 30:
	          _context.next = 10;
	          break;
	
	        case 32:
	          _context.prev = 32;
	          _context.next = 35;
	          return (0, _effects.cancelled)();
	
	        case 35:
	          if (!_context.sent) {
	            _context.next = 37;
	            break;
	          }
	
	          postMessageChannel.close();
	
	        case 37:
	          return _context.finish(32);
	
	        case 38:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[9,, 32, 38]]);
	}
	
	function authAzureSaga() {
	  return _regenerator2.default.wrap(function authAzureSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_authAzure.consts.INIT], handleAuthAzureWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.authAzureExternalRedirectSaga = authAzureExternalRedirectSaga;
	
	var _effects = __webpack_require__(14);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	var _constants = __webpack_require__(17);
	
	var _loginAzure = __webpack_require__(340);
	
	var _authAzure = __webpack_require__(631);
	
	var _getAuthAzureErrorMessage = __webpack_require__(1910);
	
	var _authAzureExternalRedirect = __webpack_require__(1869);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleAuthAzureExternalRedirectWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(authAzureExternalRedirectSaga);
	
	var NOT_CONFIRMED = _constants.AUTH_AZURE_ERROR_CODE.NOT_CONFIRMED;
	
	
	function handleAuthAzureExternalRedirectWorker(_ref) {
	  var payload = _ref.payload;
	  var intl, type, code, login, token;
	  return _regenerator2.default.wrap(function handleAuthAzureExternalRedirectWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          intl = payload.intl, type = payload.type, code = payload.code, login = payload.login, token = payload.token;
	
	          if (!(type === 'error')) {
	            _context.next = 4;
	            break;
	          }
	
	          _context.next = 4;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: {
	              id: (0, _getAuthAzureErrorMessage.getAuthAzureErrorMessage)(code, intl)
	            },
	            isStaticFlow: true,
	            infoErrorIcon: code === NOT_CONFIRMED ? 'information' : null
	          });
	
	        case 4:
	          if (!(type === 'success')) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)(_authAzure.actions.setCredentialForMfa({
	            login: login,
	            token: token
	          }));
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)(_loginAzure.actions.send({ access_token: token }));
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function authAzureExternalRedirectSaga() {
	  return _regenerator2.default.wrap(function authAzureExternalRedirectSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_authAzureExternalRedirect.consts.INIT], handleAuthAzureExternalRedirectWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3945 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = _callee;
	
	var _effects = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(42);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(1238);
	
	var _routes = __webpack_require__(37);
	
	var _selectors = __webpack_require__(1239);
	
	var _deepTrim = __webpack_require__(357);
	
	var _deepTrim2 = _interopRequireDefault(_deepTrim);
	
	var _editUser = __webpack_require__(136);
	
	var editUser = _interopRequireWildcard(_editUser);
	
	var _usernameAvailabilityReq = __webpack_require__(808);
	
	var usernameAvailability = _interopRequireWildcard(_usernameAvailabilityReq);
	
	var _decodeQueryParams = __webpack_require__(1711);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleChangePasswordProceed),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleConfirmChangePassword),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(_callee);
	
	function handleChangePasswordProceed(_ref) {
	  var payload = _ref.payload;
	  var username;
	  return _regenerator2.default.wrap(function handleChangePasswordProceed$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          username = (0, _get2.default)(payload, 'username');
	          _context.next = 3;
	          return (0, _effects.put)(usernameAvailability.actions.send({
	            username: (0, _decodeQueryParams.decodeQueryParams)(username)
	          }));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.take)(usernameAvailability.consts.SUCCEED);
	
	        case 5:
	          _context.next = 7;
	          return _reactRouter.browserHistory.push('/' + _routes.PERSONAL_INFO);
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleConfirmChangePassword(_ref2) {
	  var payload = _ref2.payload;
	  var changePasswordFormData, dataToSend;
	  return _regenerator2.default.wrap(function handleConfirmChangePassword$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors.selectChangePasswordProcessFormData);
	
	        case 2:
	          changePasswordFormData = _context2.sent;
	          dataToSend = (0, _deepTrim2.default)((0, _extends3.default)({}, changePasswordFormData, payload));
	          _context2.next = 6;
	          return (0, _effects.put)(editUser.actions.send(dataToSend));
	
	        case 6:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function _callee() {
	  return _regenerator2.default.wrap(function _callee$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_constants.CHANGE_PASSWORD_TYPES.PROCEED, handleChangePasswordProceed);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.takeLatest)(_constants.CHANGE_PASSWORD_TYPES.CONFIRM, handleConfirmChangePassword);
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 3946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changePasswordProcessReducer = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _constants = __webpack_require__(1238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  changePasswordFormData: null,
	  personalInfoFormData: null
	};
	
	var changePasswordProcessReducer = exports.changePasswordProcessReducer = function changePasswordProcessReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.CHANGE_PASSWORD_TYPES.PROCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          changePasswordFormData: action.payload
	        });
	      }
	
	    case _constants.CHANGE_PASSWORD_TYPES.PERSONAL_INFO_CHANGE:
	      {
	        return (0, _extends3.default)({}, state, {
	          personalInfoFormData: action.payload
	        });
	      }
	
	    case _constants.CHANGE_PASSWORD_TYPES.RESET:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 3947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = expireSessionSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _errors = __webpack_require__(120);
	
	var _logout = __webpack_require__(198);
	
	var logout = _interopRequireWildcard(_logout);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(expireSessionSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(expireSessionSaga);
	
	function expireSessionSagaWorker(_ref) {
	  var payload = _ref.payload;
	  var notificationErrorCode;
	  return _regenerator2.default.wrap(function expireSessionSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          notificationErrorCode = (0, _get2.default)(payload, 'data.error.code');
	          _context.next = 3;
	          return (0, _effects.put)({ type: logout.consts.SUCCEED });
	
	        case 3:
	          if (!(notificationErrorCode === _errors.LOGOUT_NOTIFICATIONS_ERRORS.ENTITY_EXCEPTION)) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.take)(logout.consts.CLEAR);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)({
	            type: logout.consts.EXPIRED_ERROR,
	            payload: notificationErrorCode
	          });
	
	        case 8:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function expireSessionSaga() {
	  return _regenerator2.default.wrap(function expireSessionSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_constants2.default.LOGOUT], expireSessionSagaWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _createPassword = __webpack_require__(1240);
	
	var _createPassword2 = _interopRequireDefault(_createPassword);
	
	var _login = __webpack_require__(402);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _loginAzure = __webpack_require__(340);
	
	var _loginAzure2 = _interopRequireDefault(_loginAzure);
	
	var _logout = __webpack_require__(198);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	var _resetPassword = __webpack_require__(1241);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _signupReq = __webpack_require__(341);
	
	var _signupReq2 = _interopRequireDefault(_signupReq);
	
	var _status = __webpack_require__(1244);
	
	var _status2 = _interopRequireDefault(_status);
	
	var _userRegistrationReq = __webpack_require__(807);
	
	var _userRegistrationReq2 = _interopRequireDefault(_userRegistrationReq);
	
	var _usernameAvailabilityReq = __webpack_require__(808);
	
	var _usernameAvailabilityReq2 = _interopRequireDefault(_usernameAvailabilityReq);
	
	var _reducer = __webpack_require__(3953);
	
	var _reducer2 = __webpack_require__(3946);
	
	var _sendInvitationReq = __webpack_require__(806);
	
	var _sendInvitationReq2 = _interopRequireDefault(_sendInvitationReq);
	
	var _sessionRefreshReq = __webpack_require__(1242);
	
	var _sessionRefreshReq2 = _interopRequireDefault(_sessionRefreshReq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  createPassword: _createPassword2.default,
	  login: _login2.default,
	  loginAzure: _loginAzure2.default,
	  logout: _logout2.default,
	  resetPassword: _resetPassword2.default,
	  signup: _signupReq2.default,
	  status: _status2.default,
	  signupProcess: _reducer.signupProcessReducer,
	  changePasswordProcess: _reducer2.changePasswordProcessReducer,
	  generalUserRegistrations: _userRegistrationReq2.default,
	  usernameAvailability: _usernameAvailabilityReq2.default,
	  sendInvitation: _sendInvitationReq2.default,
	  sessionRefresh: _sessionRefreshReq2.default
	});

/***/ }),
/* 3949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = loginPageSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _locationReducer = __webpack_require__(240);
	
	var _routes = __webpack_require__(37);
	
	var _selectors = __webpack_require__(93);
	
	var _authSaga = __webpack_require__(1870);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loginPageSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(loginPageSaga);
	
	function loginPageSagaWorker(action) {
	  var pathname, hasLogin, isLoggedIn;
	  return _regenerator2.default.wrap(function loginPageSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          pathname = (0, _lodash.get)(action, 'payload.pathname');
	          hasLogin = pathname.includes(_routes.LOGIN);
	
	          if (!hasLogin) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.isLoggedInSelector);
	
	        case 5:
	          isLoggedIn = _context.sent;
	
	          if (isLoggedIn) {
	            (0, _authSaga.redirect)();
	          }
	          _context.next = 9;
	          return (0, _effects.cancel)();
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function loginPageSaga() {
	  return _regenerator2.default.wrap(function loginPageSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_locationReducer.LOCATION_CHANGE, loginPageSagaWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = logoutSaga;
	
	var _effects = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(42);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _logout = __webpack_require__(198);
	
	var _signupReq = __webpack_require__(341);
	
	var _settings = __webpack_require__(199);
	
	var _filters = __webpack_require__(260);
	
	var _replies = __webpack_require__(636);
	
	var _chatConnection = __webpack_require__(183);
	
	var _persistentState = __webpack_require__(1898);
	
	var _reducers = __webpack_require__(1357);
	
	var _theme = __webpack_require__(1375);
	
	var theme = _interopRequireWildcard(_theme);
	
	var _storageKeys = __webpack_require__(215);
	
	var _selectors = __webpack_require__(157);
	
	var _routes = __webpack_require__(37);
	
	var _paperwork = __webpack_require__(265);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(logoutSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleLogout),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(logoutSaga);
	
	function logoutSagaWorker() {
	  var _checkIsPaperworkRout, isPaperworkRoute;
	
	  return _regenerator2.default.wrap(function logoutSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)({ type: _chatConnection.consts.DISCONNECT });
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)({ type: _settings.consts.CLEAR });
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.put)({ type: _filters.consts.CLEAR });
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)({ type: _logout.consts.CLEAR });
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)({ type: _reducers.loginReferrerConsts.CLEAR_LOGIN_REFERRER });
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.put)({ type: _replies.consts.CLEAR });
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.put)({ type: theme.consts.SET_DEFAULT });
	
	        case 14:
	          _checkIsPaperworkRout = (0, _paperwork.checkIsPaperworkRoute)(), isPaperworkRoute = _checkIsPaperworkRout.isPaperworkRoute;
	          // Preserve the paperwork token when logging out from a regular-app tab so
	          // that a concurrently open paperwork tab is not disrupted.
	
	          (0, _persistentState.clearLocalStorage)({ preservePaperwork: !isPaperworkRoute });
	
	        case 16:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	var shouldSaveDataOnce = true;
	
	function handleLogout(_ref) {
	  var payload = _ref.payload;
	
	  var locationBeforeTransitions, pathname, search, _checkIsPaperworkRout2, isPaperworkRoute, route;
	
	  return _regenerator2.default.wrap(function handleLogout$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors.selectLocationBeforeTransitions);
	
	        case 2:
	          locationBeforeTransitions = _context2.sent;
	          pathname = (0, _get2.default)(locationBeforeTransitions, 'pathname', '');
	          search = (0, _get2.default)(locationBeforeTransitions, 'search', '');
	          _context2.next = 7;
	          return (0, _effects.call)(logoutSagaWorker);
	
	        case 7:
	
	          if (pathname && shouldSaveDataOnce && !payload) {
	            window.storage.setItem(_storageKeys.REDIRECT_TO_PAGE, '' + pathname + search);
	            shouldSaveDataOnce = false;
	          }
	
	          _checkIsPaperworkRout2 = (0, _paperwork.checkIsPaperworkRoute)(), isPaperworkRoute = _checkIsPaperworkRout2.isPaperworkRoute, route = _checkIsPaperworkRout2.route;
	          _context2.next = 11;
	          return (0, _effects.call)(function () {
	            return _reactRouter.browserHistory.push(isPaperworkRoute ? route : _routes.LOGIN);
	          });
	
	        case 11:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function logoutSaga() {
	  return _regenerator2.default.wrap(function logoutSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeEvery)([_signupReq.consts.SEND], logoutSagaWorker);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.takeEvery)([_logout.consts.SUCCEED, _logout.consts.REJECTED, _logout.consts.ERROR_ENCOUNTERED], handleLogout);
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 3951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = refreshSessionIntervalSaga;
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reduxSaga = __webpack_require__(485);
	
	var _effects = __webpack_require__(14);
	
	var _sessionRefreshReq = __webpack_require__(1242);
	
	var sessionRefresh = _interopRequireWildcard(_sessionRefreshReq);
	
	var _env = __webpack_require__(103);
	
	var _selectors = __webpack_require__(23);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(refreshSessionIntervalSaga);
	
	var interval = _env.REFRESH_SESSION_INTERVAL || 5 * 60 * 1000;
	
	function makeInterval() {
	  return (0, _reduxSaga.eventChannel)(function (emitter) {
	    var iv = setInterval(function () {
	      return emitter(true);
	    }, interval);
	    return function () {
	      return clearInterval(iv);
	    };
	  });
	}
	
	function refreshSessionIntervalSaga() {
	  var isLoggedUser, chan;
	  return _regenerator2.default.wrap(function refreshSessionIntervalSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.loggedUserSelector);
	
	        case 2:
	          isLoggedUser = _context.sent;
	
	          if ((0, _isEmpty2.default)(isLoggedUser)) {
	            _context.next = 21;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.call)(makeInterval);
	
	        case 6:
	          chan = _context.sent;
	          _context.prev = 7;
	
	        case 8:
	          if (false) {
	            _context.next = 15;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.take)(chan);
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.put)(sessionRefresh.actions.send());
	
	        case 13:
	          _context.next = 8;
	          break;
	
	        case 15:
	          _context.prev = 15;
	          _context.next = 18;
	          return (0, _effects.cancelled)();
	
	        case 18:
	          if (!_context.sent) {
	            _context.next = 20;
	            break;
	          }
	
	          chan.close();
	
	        case 20:
	          return _context.finish(15);
	
	        case 21:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[7,, 15, 21]]);
	}

/***/ }),
/* 3952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = authRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _login = __webpack_require__(402);
	
	var login = _interopRequireWildcard(_login);
	
	var _loginAzure = __webpack_require__(340);
	
	var loginAzure = _interopRequireWildcard(_loginAzure);
	
	var _logout = __webpack_require__(198);
	
	var logout = _interopRequireWildcard(_logout);
	
	var _signupReq = __webpack_require__(341);
	
	var signup = _interopRequireWildcard(_signupReq);
	
	var _resetPassword = __webpack_require__(1241);
	
	var resetPassword = _interopRequireWildcard(_resetPassword);
	
	var _createPassword = __webpack_require__(1240);
	
	var createPassword = _interopRequireWildcard(_createPassword);
	
	var _userRegistrationReq = __webpack_require__(807);
	
	var userRegistration = _interopRequireWildcard(_userRegistrationReq);
	
	var _usernameAvailabilityReq = __webpack_require__(808);
	
	var usernameAvailability = _interopRequireWildcard(_usernameAvailabilityReq);
	
	var _sendInvitationReq = __webpack_require__(806);
	
	var sendInvitation = _interopRequireWildcard(_sendInvitationReq);
	
	var _sessionRefreshReq = __webpack_require__(1242);
	
	var sessionRefresh = _interopRequireWildcard(_sessionRefreshReq);
	
	var _authSaga = __webpack_require__(1870);
	
	var _authSaga2 = _interopRequireDefault(_authSaga);
	
	var _logoutSaga = __webpack_require__(3950);
	
	var _logoutSaga2 = _interopRequireDefault(_logoutSaga);
	
	var _signupSaga = __webpack_require__(3954);
	
	var _signupSaga2 = _interopRequireDefault(_signupSaga);
	
	var _loginRedirectSaga = __webpack_require__(3949);
	
	var _loginRedirectSaga2 = _interopRequireDefault(_loginRedirectSaga);
	
	var _changePasswordSaga = __webpack_require__(3945);
	
	var _changePasswordSaga2 = _interopRequireDefault(_changePasswordSaga);
	
	var _expireSessionSaga = __webpack_require__(3947);
	
	var _expireSessionSaga2 = _interopRequireDefault(_expireSessionSaga);
	
	var _userRegistrationSaga = __webpack_require__(3955);
	
	var _userRegistrationSaga2 = _interopRequireDefault(_userRegistrationSaga);
	
	var _authAzureSaga = __webpack_require__(3943);
	
	var _authAzureExternalRedirectSaga = __webpack_require__(3944);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(authRootSaga);
	
	function authRootSaga() {
	  return _regenerator2.default.wrap(function authRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(login.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(loginAzure.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(logout.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(signup.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(resetPassword.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(createPassword.watcher);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(userRegistration.watcher);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(usernameAvailability.watcher);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(sendInvitation.watcher);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(sessionRefresh.watcher);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.fork)(_signupSaga2.default);
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.fork)(_changePasswordSaga2.default);
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.fork)(_logoutSaga2.default);
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.fork)(_authSaga2.default);
	
	        case 28:
	          _context.next = 30;
	          return (0, _effects.fork)(_expireSessionSaga2.default);
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.fork)(_userRegistrationSaga2.default);
	
	        case 32:
	          _context.next = 34;
	          return (0, _effects.fork)(_loginRedirectSaga2.default);
	
	        case 34:
	          _context.next = 36;
	          return (0, _effects.fork)(_authAzureSaga.authAzureSaga);
	
	        case 36:
	          _context.next = 38;
	          return (0, _effects.fork)(_authAzureExternalRedirectSaga.authAzureExternalRedirectSaga);
	
	        case 38:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 3953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.signupProcessReducer = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _constants = __webpack_require__(1243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  signupFormData: null,
	  personalInfoFormData: null
	};
	
	var signupProcessReducer = exports.signupProcessReducer = function signupProcessReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SIGN_UP_TYPES.PROCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          signupFormData: action.payload
	        });
	      }
	
	    case _constants.SIGN_UP_TYPES.PERSONAL_INFO_CHANGE:
	      {
	        return (0, _extends3.default)({}, state, {
	          personalInfoFormData: action.payload
	        });
	      }
	
	    case _constants.SIGN_UP_TYPES.RESET:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 3954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.showMfaNoticePopup = showMfaNoticePopup;
	exports.default = _callee;
	
	var _effects = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(42);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _constants = __webpack_require__(1243);
	
	var _selectors = __webpack_require__(93);
	
	var _selectors2 = __webpack_require__(56);
	
	var _routes = __webpack_require__(37);
	
	var _selectors3 = __webpack_require__(403);
	
	var _signupReq = __webpack_require__(341);
	
	var signup = _interopRequireWildcard(_signupReq);
	
	var _editUser = __webpack_require__(136);
	
	var editUser = _interopRequireWildcard(_editUser);
	
	var _createPatient = __webpack_require__(679);
	
	var createPatient = _interopRequireWildcard(_createPatient);
	
	var _profileEditableReq = __webpack_require__(686);
	
	var profileEditable = _interopRequireWildcard(_profileEditableReq);
	
	var _usernameAvailabilityReq = __webpack_require__(808);
	
	var usernameAvailability = _interopRequireWildcard(_usernameAvailabilityReq);
	
	var _props = __webpack_require__(41);
	
	var _deepTrim = __webpack_require__(357);
	
	var _deepTrim2 = _interopRequireDefault(_deepTrim);
	
	var _parseJSONSafely = __webpack_require__(910);
	
	var _parseJSONSafely2 = _interopRequireDefault(_parseJSONSafely);
	
	var _checkIsAppStoreLinksAvailability = __webpack_require__(905);
	
	var _checkIsAppStoreLinksAvailability2 = _interopRequireDefault(_checkIsAppStoreLinksAvailability);
	
	var _popup = __webpack_require__(76);
	
	var _decodeQueryParams = __webpack_require__(1711);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleSignUpProceed),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleConfirmSignUp),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleSignupSucceed),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(showMfaNoticePopup),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(_callee);
	
	function handleSignUpProceed(_ref) {
	  var payload = _ref.payload;
	  var username;
	  return _regenerator2.default.wrap(function handleSignUpProceed$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          username = (0, _get2.default)(payload, 'username');
	          _context.next = 3;
	          return (0, _effects.put)(usernameAvailability.actions.send({
	            username: (0, _decodeQueryParams.decodeQueryParams)(username)
	          }));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.take)(usernameAvailability.consts.SUCCEED);
	
	        case 5:
	          _context.next = 7;
	          return _reactRouter.browserHistory.push('/' + _routes.PERSONAL_INFO);
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	var EDIT_USER_INVITATION_TYPES = [_props.INVITATION_TYPES.FAMILY_MEMBER, _props.INVITATION_TYPES.COMMUNITY_MEMBER];
	
	function handleConfirmSignUp(_ref2) {
	  var payload = _ref2.payload;
	
	  var signupFormData, editableData, _ref3, invitationType, personalInfoFormData, dataToSend, targetCommunityId, _ref4, hasAtLeastOneStoreLink;
	
	  return _regenerator2.default.wrap(function handleConfirmSignUp$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors3.selectSignupProcessFormData);
	
	        case 2:
	          signupFormData = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_selectors2.selectProfileEditable);
	
	        case 5:
	          editableData = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.select)(_selectors.selectAuthStatus);
	
	        case 8:
	          _ref3 = _context2.sent;
	          invitationType = _ref3.invitationType;
	          personalInfoFormData = editableData ? payload : (0, _omit2.default)(payload, ['ssn']);
	          dataToSend = (0, _deepTrim2.default)((0, _extends3.default)({}, signupFormData, personalInfoFormData));
	
	          if (!EDIT_USER_INVITATION_TYPES.includes(invitationType)) {
	            _context2.next = 32;
	            break;
	          }
	
	          _context2.next = 15;
	          return (0, _effects.put)(createPatient.actions.send(dataToSend));
	
	        case 15:
	          _context2.next = 17;
	          return (0, _effects.take)(createPatient.consts.SUCCEED);
	
	        case 17:
	          if (!(invitationType === _props.INVITATION_TYPES.FAMILY_MEMBER)) {
	            _context2.next = 20;
	            break;
	          }
	
	          _context2.next = 20;
	          return _reactRouter.browserHistory.push('/' + _routes.HEALTHBOARD);
	
	        case 20:
	          if (!(invitationType === _props.INVITATION_TYPES.COMMUNITY_MEMBER)) {
	            _context2.next = 24;
	            break;
	          }
	
	          targetCommunityId = (0, _parseJSONSafely2.default)(window.storage.getItem('communityId'));
	          _context2.next = 24;
	          return _reactRouter.browserHistory.push('/' + _routes.COMMUNITIES + '/' + targetCommunityId);
	
	        case 24:
	          _context2.next = 26;
	          return (0, _effects.call)(_checkIsAppStoreLinksAvailability2.default);
	
	        case 26:
	          _ref4 = _context2.sent;
	          hasAtLeastOneStoreLink = _ref4.hasAtLeastOneStoreLink;
	
	          if (!hasAtLeastOneStoreLink) {
	            _context2.next = 31;
	            break;
	          }
	
	          _context2.next = 31;
	          return (0, _effects.put)((0, _popup.showMobileAppPopup)());
	
	        case 31:
	          return _context2.abrupt('return');
	
	        case 32:
	          _context2.next = 34;
	          return (0, _effects.put)(editUser.actions.send(dataToSend));
	
	        case 34:
	          _context2.next = 36;
	          return (0, _effects.take)(editUser.consts.SUCCEED);
	
	        case 36:
	          _context2.next = 38;
	          return _reactRouter.browserHistory.push('/' + _routes.HEALTHBOARD);
	
	        case 38:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleSignupSucceed(_ref5) {
	  var payload = _ref5.payload;
	  var id;
	  return _regenerator2.default.wrap(function handleSignupSucceed$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          id = (0, _get2.default)(payload, 'authentication.user.id');
	          _context3.next = 3;
	          return (0, _effects.put)(profileEditable.actions.send({ userId: id }));
	
	        case 3:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function showMfaNoticePopup() {
	  var showMfaAfterMobileAppPopup;
	  return _regenerator2.default.wrap(function showMfaNoticePopup$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.select)(_selectors2.selectShowMfaAfterMobileAppPopup);
	
	        case 2:
	          showMfaAfterMobileAppPopup = _context4.sent;
	
	          if (!showMfaAfterMobileAppPopup) {
	            _context4.next = 6;
	            break;
	          }
	
	          _context4.next = 6;
	          return (0, _effects.put)((0, _popup.showMfaNoticePopup)());
	
	        case 6:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function _callee() {
	  return _regenerator2.default.wrap(function _callee$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)(_constants.SIGN_UP_TYPES.PROCEED, handleSignUpProceed);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.takeLatest)(_constants.SIGN_UP_TYPES.CONFIRM, handleConfirmSignUp);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.takeLatest)(signup.consts.SUCCEED, handleSignupSucceed);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.takeLatest)(_popup.consts.HIDE, showMfaNoticePopup);
	
	        case 8:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 3955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.userRegistrationWorker = userRegistrationWorker;
	exports.default = userRegistrationSaga;
	
	var _effects = __webpack_require__(1667);
	
	var _reactRouter = __webpack_require__(42);
	
	var _routes = __webpack_require__(37);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _userRegistrationReq = __webpack_require__(807);
	
	var userRegistration = _interopRequireWildcard(_userRegistrationReq);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(userRegistrationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(userRegistrationSaga);
	
	function userRegistrationWorker() {
	  return _regenerator2.default.wrap(function userRegistrationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'auth.signup.registrationInvitation' }
	          });
	
	        case 2:
	          _context.next = 4;
	          return _reactRouter.browserHistory.push(_routes2.default.LOGIN);
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function userRegistrationSaga() {
	  return _regenerator2.default.wrap(function userRegistrationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(userRegistration.consts.SUCCEED, userRegistrationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _max = __webpack_require__(577);
	
	var _max2 = _interopRequireDefault(_max);
	
	var _chat = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var connectToChatData = function connectToChatData(apiCircles, chatChannels) {
	  return apiCircles.map(function (item) {
	    var contextChannels = (0, _get2.default)(item, 'subchannels');
	    var contextChannel = (0, _get2.default)(item, 'contextChannel');
	
	    // handle context / social chats differences
	    var channels = contextChannels || [contextChannel].filter(Boolean);
	
	    var channelData = channels.reduce(function (acc, channel) {
	      var type = channel.type,
	          channelId = channel.channelId,
	          lastMessageAt = channel.lastMessageAt,
	          totalUnreadCount = channel.totalUnreadCount;
	
	
	      var channelUnreads = (0, _get2.default)(chatChannels, [channelId, 'unreadCount'], totalUnreadCount);
	      var channelLastMessageAt = (0, _get2.default)(chatChannels, [channelId, 'lastMessageAt']) || lastMessageAt;
	
	      acc.unreadCount += channelUnreads;
	
	      if (type !== _chat.SYSTEM_CHANNEL) {
	        acc.lastMessageAt = (0, _max2.default)([acc.lastMessageAt, channelLastMessageAt]);
	      }
	
	      return acc;
	    }, {
	      unreadCount: 0,
	      lastMessageAt: null
	    });
	
	    return (0, _extends3.default)({}, item, channelData);
	  });
	};
	
	exports.default = connectToChatData;

/***/ }),
/* 3957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _reqAllUsers = __webpack_require__(637);
	
	var _reqAllUsers2 = _interopRequireDefault(_reqAllUsers);
	
	var _reqRelatedUsers = __webpack_require__(813);
	
	var _reqRelatedUsers2 = _interopRequireDefault(_reqRelatedUsers);
	
	var _reqNewChannel = __webpack_require__(812);
	
	var _reqNewChannel2 = _interopRequireDefault(_reqNewChannel);
	
	var _reqSocialChannel = __webpack_require__(295);
	
	var _reqSocialChannel2 = _interopRequireDefault(_reqSocialChannel);
	
	var _reqAssignPatient = __webpack_require__(638);
	
	var _reqAssignPatient2 = _interopRequireDefault(_reqAssignPatient);
	
	var _reqChangeChatName = __webpack_require__(809);
	
	var _reqChangeChatName2 = _interopRequireDefault(_reqChangeChatName);
	
	var _reqAssignProvider = __webpack_require__(639);
	
	var _reqAssignProvider2 = _interopRequireDefault(_reqAssignProvider);
	
	var _reqChannels = __webpack_require__(1249);
	
	var _reqChannels2 = _interopRequireDefault(_reqChannels);
	
	var _reqChannel = __webpack_require__(810);
	
	var _reqChannel2 = _interopRequireDefault(_reqChannel);
	
	var _reqCircleOfCare = __webpack_require__(404);
	
	var _reqCircleOfCare2 = _interopRequireDefault(_reqCircleOfCare);
	
	var _reqFilters = __webpack_require__(811);
	
	var _reqFilters2 = _interopRequireDefault(_reqFilters);
	
	var _reqInvitePatient = __webpack_require__(508);
	
	var _reqInvitePatient2 = _interopRequireDefault(_reqInvitePatient);
	
	var _reqMetadata = __webpack_require__(1250);
	
	var _reqMetadata2 = _interopRequireDefault(_reqMetadata);
	
	var _channels = __webpack_require__(634);
	
	var _channels2 = _interopRequireDefault(_channels);
	
	var _circleOfCare = __webpack_require__(635);
	
	var _circleOfCare2 = _interopRequireDefault(_circleOfCare);
	
	var _filters = __webpack_require__(260);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _inviteForm = __webpack_require__(1872);
	
	var _inviteForm2 = _interopRequireDefault(_inviteForm);
	
	var _metadata = __webpack_require__(1247);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _replies = __webpack_require__(636);
	
	var _replies2 = _interopRequireDefault(_replies);
	
	var _settings = __webpack_require__(199);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _reqChannelParticipants = __webpack_require__(640);
	
	var _reqChannelParticipants2 = _interopRequireDefault(_reqChannelParticipants);
	
	var _reqAddParticipants = __webpack_require__(1248);
	
	var _reqAddParticipants2 = _interopRequireDefault(_reqAddParticipants);
	
	var _reqRemoveParticipant = __webpack_require__(1251);
	
	var _reqRemoveParticipant2 = _interopRequireDefault(_reqRemoveParticipant);
	
	var _reqBlockUser = __webpack_require__(507);
	
	var _reqBlockUser2 = _interopRequireDefault(_reqBlockUser);
	
	var _reqUnblockUser = __webpack_require__(509);
	
	var _reqUnblockUser2 = _interopRequireDefault(_reqUnblockUser);
	
	var _blockUserForDependent = __webpack_require__(633);
	
	var _blockUserForDependent2 = _interopRequireDefault(_blockUserForDependent);
	
	var _createChatInboxTaskReq = __webpack_require__(1245);
	
	var _createChatInboxTaskReq2 = _interopRequireDefault(_createChatInboxTaskReq);
	
	var _unblockUserForDependent = __webpack_require__(642);
	
	var _unblockUserForDependent2 = _interopRequireDefault(_unblockUserForDependent);
	
	var _dependentChannelParticipants = __webpack_require__(1246);
	
	var _dependentChannelParticipants2 = _interopRequireDefault(_dependentChannelParticipants);
	
	var _reqRelationshipPriority = __webpack_require__(814);
	
	var _reqRelationshipPriority2 = _interopRequireDefault(_reqRelationshipPriority);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  reqAllUsers: _reqAllUsers2.default,
	  reqRelatedUsers: _reqRelatedUsers2.default,
	  reqNewChannel: _reqNewChannel2.default,
	  reqSocialChannel: _reqSocialChannel2.default,
	  reqChannels: _reqChannels2.default,
	  reqChannel: _reqChannel2.default,
	  reqCircleOfCare: _reqCircleOfCare2.default,
	  reqFilters: _reqFilters2.default,
	  reqInvitePatient: _reqInvitePatient2.default,
	  reqAssignPatient: _reqAssignPatient2.default,
	  reqChangeChatName: _reqChangeChatName2.default,
	  reqAssignProvider: _reqAssignProvider2.default,
	  reqMetadata: _reqMetadata2.default,
	
	  channels: _channels2.default,
	  circleOfCare: _circleOfCare2.default,
	  filters: _filters2.default,
	  inviteForm: _inviteForm2.default,
	  metadata: _metadata2.default,
	  replies: _replies2.default,
	  settings: _settings2.default,
	  reqChannelParticipants: _reqChannelParticipants2.default,
	  reqAddParticipants: _reqAddParticipants2.default,
	  reqRemoveParticipant: _reqRemoveParticipant2.default,
	  reqBlockUser: _reqBlockUser2.default,
	  reqUnblockUser: _reqUnblockUser2.default,
	  createChatInboxTask: _createChatInboxTaskReq2.default,
	  blockUserForDependent: _blockUserForDependent2.default,
	  unblockUserForDependent: _unblockUserForDependent2.default,
	  dependentChannelParticipants: _dependentChannelParticipants2.default,
	  relationshipPriority: _reqRelationshipPriority2.default
	}); // channelWithinNextPage

/***/ }),
/* 3958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = assignProviderSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(23);
	
	var _reqAssignProvider = __webpack_require__(639);
	
	var _removeAssignedProvider = __webpack_require__(515);
	
	var _reqCircleOfCare = __webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(assignProviderWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(assignProviderSaga);
	
	function assignProviderWorker() {
	  var targetUserId;
	  return _regenerator2.default.wrap(function assignProviderWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 2:
	          targetUserId = _context.sent;
	
	          if (!targetUserId) {
	            _context.next = 6;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.put)(_reqCircleOfCare.actions.send({ id: targetUserId }));
	
	        case 6:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function assignProviderSaga() {
	  return _regenerator2.default.wrap(function assignProviderSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_removeAssignedProvider.consts.SUCCEED, _reqAssignProvider.consts.SUCCEED], assignProviderWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3959 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getItemsSaga = getItemsSaga;
	exports.addItemsSaga = addItemsSaga;
	exports.addNewChannelWorker = addNewChannelWorker;
	exports.addNewChannelSaga = addNewChannelSaga;
	exports.addSocialChatWorker = addSocialChatWorker;
	exports.addSocialChatSaga = addSocialChatSaga;
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _find = __webpack_require__(462);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _reactRouter = __webpack_require__(42);
	
	var _chat = __webpack_require__(67);
	
	var _props = __webpack_require__(41);
	
	var _selectors = __webpack_require__(79);
	
	var _selectors2 = __webpack_require__(23);
	
	var _channels = __webpack_require__(236);
	
	var _filters = __webpack_require__(296);
	
	var _settings = __webpack_require__(405);
	
	var _reqChannels = __webpack_require__(1249);
	
	var _reqNewChannel = __webpack_require__(812);
	
	var _reqSocialChannel = __webpack_require__(295);
	
	var _reqFilters = __webpack_require__(811);
	
	var _channels2 = __webpack_require__(634);
	
	var _chatConnection = __webpack_require__(183);
	
	var _filters2 = __webpack_require__(260);
	
	var _loggedUser = __webpack_require__(523);
	
	var _settings2 = __webpack_require__(199);
	
	var _context10 = __webpack_require__(216);
	
	var _routes = __webpack_require__(37);
	
	var _selectors3 = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(getItemsWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getItemsSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(addItemsWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(addItemsSaga),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(addNewChannelWorker),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(addNewChannelSaga),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(addSocialChatWorker),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(addSocialChatSaga),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function getItemsWorker(action) {
	  var connectionReady, loggedUser, state, hasSubFilters, params, availableProgramValues, retrievedProgramValue, program, availableSubChannels, actionType;
	  return _regenerator2.default.wrap(function getItemsWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.connectionReadySelector);
	
	        case 2:
	          connectionReady = _context.sent;
	
	          if (connectionReady) {
	            _context.next = 6;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.take)(_chatConnection.consts.CONNECTION_READY);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.select)(_selectors2.loggedUserSelector);
	
	        case 8:
	          loggedUser = _context.sent;
	
	          if (!(0, _isEmpty2.default)(loggedUser)) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 12;
	          return (0, _effects.take)(_loggedUser.consts.ADD);
	
	        case 12:
	          if (!(action.type !== _settings2.consts.LOAD_NEXT_PAGE)) {
	            _context.next = 19;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)({ type: _channels2.consts.CLEAR });
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.put)({
	            type: _settings2.consts.SET_OFFSET,
	            payload: 0
	          });
	
	        case 17:
	          _context.next = 19;
	          return (0, _effects.put)({ type: _settings2.consts.CLEAR_EXCLUDED_IDS });
	
	        case 19:
	          if (!(action.type === _channels2.consts.GET_ITEMS)) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 22;
	          return (0, _effects.put)({ type: _reqFilters.consts.SEND });
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.take)(_filters2.consts.SET_AVAILABLE_FILTERS);
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.select)();
	
	        case 26:
	          state = _context.sent;
	          hasSubFilters = (0, _filters.subFiltersSelector)(state);
	          params = {
	            type: (0, _filters.typeSelector)(state),
	            limit: (0, _settings.limitSelector)(state),
	            offset: (0, _settings.offsetSelector)(state),
	            query: (0, _filters.searchQuerySelector)(state),
	            excludedIds: (0, _settings.excludedIdsSelector)(state)
	          };
	
	
	          if (hasSubFilters) {
	            // check correctness of restored filters
	            availableProgramValues = (0, _filters.availableProgramsSelector)(state).map(function (program) {
	              return program.filterValue;
	            });
	            retrievedProgramValue = (0, _filters.programValueSelector)(state);
	            program = availableProgramValues.includes(retrievedProgramValue) ? retrievedProgramValue : _props.PROGRAM_VALUE_TYPES.all;
	
	
	            params = (0, _extends3.default)({}, params, {
	              program: program,
	              statuses: (0, _filters.statusSelector)(state)
	            });
	          }
	
	          _context.next = 32;
	          return (0, _effects.put)({
	            type: _reqChannels.consts.SEND,
	            payload: params
	          });
	
	        case 32:
	          if (false) {
	            _context.next = 43;
	            break;
	          }
	
	          _context.next = 35;
	          return (0, _effects.take)(_channels2.consts.ADD_ITEMS);
	
	        case 35:
	          _context.next = 37;
	          return (0, _effects.select)(_channels.subChannelsSelector);
	
	        case 37:
	          availableSubChannels = _context.sent;
	          actionType = action.type === _settings2.consts.LOAD_NEXT_PAGE ? 'UPDATE_AVAILABLE_CHANNELS' : 'SET_AVAILABLE_CHANNELS';
	          _context.next = 41;
	          return (0, _effects.put)({
	            type: _chatConnection.consts[actionType],
	            payload: availableSubChannels
	          });
	
	        case 41:
	          _context.next = 32;
	          break;
	
	        case 43:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function getItemsSaga() {
	  return _regenerator2.default.wrap(function getItemsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_channels2.consts.GET_ITEMS, _filters2.consts.SET_TYPE, _filters2.consts.SET_PROGRAM_VALUE, _filters2.consts.SET_SEARCH_QUERY, _filters2.consts.SET_STATUS, _settings2.consts.LOAD_NEXT_PAGE, _settings2.consts.UPDATE_LAST_USER_ID], getItemsWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function addItemsWorker(action) {
	  return _regenerator2.default.wrap(function addItemsWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)({
	            type: _channels2.consts.ADD_ITEMS,
	            payload: action.payload
	          });
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function addItemsSaga() {
	  return _regenerator2.default.wrap(function addItemsSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(_reqChannels.consts.SUCCEED, addItemsWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function addNewChannelWorker(action) {
	  var target, userChannels, channelId;
	  return _regenerator2.default.wrap(function addNewChannelWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(_selectors2.targetUserIdSelector);
	
	        case 2:
	          target = _context5.sent;
	          _context5.next = 5;
	          return (0, _effects.select)(_selectors.availableTargetUserChannelsDataSelector);
	
	        case 5:
	          userChannels = _context5.sent;
	          channelId = action.payload.channelId;
	
	          if ((0, _find2.default)(userChannels, { channelId: channelId })) {
	            _context5.next = 12;
	            break;
	          }
	
	          _context5.next = 10;
	          return (0, _effects.put)({
	            type: _chatConnection.consts.ADD_NEW_SUBCHANNEL,
	            payload: { subChannel: action.payload, id: target }
	          });
	
	        case 10:
	          _context5.next = 12;
	          return (0, _effects.put)({
	            type: _chatConnection.consts.UPDATE_CHANNEL_SUBCHANNELS,
	            payload: { subChannel: action.payload, id: target }
	          });
	
	        case 12:
	          _context5.next = 14;
	          return (0, _effects.put)({
	            type: _chatConnection.consts.SET_ACTIVE_CHANNEL_ID,
	            payload: channelId
	          });
	
	        case 14:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function addNewChannelSaga() {
	  return _regenerator2.default.wrap(function addNewChannelSaga$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.takeLatest)(_reqNewChannel.consts.SUCCEED, addNewChannelWorker);
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function addSocialChatWorker(action) {
	  var channelId, socialChannels, currentLocation;
	  return _regenerator2.default.wrap(function addSocialChatWorker$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          channelId = action.payload.contextChannel.channelId;
	          _context7.next = 3;
	          return (0, _effects.select)(_selectors.socialChatSelector);
	
	        case 3:
	          socialChannels = _context7.sent;
	          _context7.next = 6;
	          return (0, _effects.select)(_selectors3.currentLocationSelector);
	
	        case 6:
	          currentLocation = _context7.sent;
	          _context7.next = 9;
	          return (0, _effects.put)({
	            type: _filters2.consts.SET_TYPE,
	            payload: _chat.CHATS_FILTER_TYPES.ALL
	          });
	
	        case 9:
	          if ((0, _find2.default)(socialChannels, { channelId: channelId })) {
	            _context7.next = 12;
	            break;
	          }
	
	          _context7.next = 12;
	          return (0, _effects.put)({
	            type: _chatConnection.consts.ADD_SOCIAL_CHAT,
	            payload: action.payload
	          });
	
	        case 12:
	          _context7.next = 14;
	          return (0, _effects.put)({
	            type: _context10.consts.CLEAR
	          });
	
	        case 14:
	          if (!(currentLocation !== '/' + _routes.MESSAGES)) {
	            _context7.next = 17;
	            break;
	          }
	
	          _context7.next = 17;
	          return _reactRouter.browserHistory.push('/' + _routes.MESSAGES);
	
	        case 17:
	          _context7.next = 19;
	          return (0, _effects.put)({
	            type: _chatConnection.consts.SET_ACTIVE_CHANNEL_ID,
	            payload: channelId
	          });
	
	        case 19:
	          _context7.next = 21;
	          return (0, _effects.put)({
	            type: _settings2.consts.SET_LAST_SOCIAL_ID,
	            payload: channelId
	          });
	
	        case 21:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function addSocialChatSaga() {
	  return _regenerator2.default.wrap(function addSocialChatSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.takeLatest)(_reqSocialChannel.consts.SUCCEED, addSocialChatWorker);
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _effects.fork)(getItemsSaga);
	
	        case 2:
	          _context9.next = 4;
	          return (0, _effects.fork)(addItemsSaga);
	
	        case 4:
	          _context9.next = 6;
	          return (0, _effects.fork)(addNewChannelSaga);
	
	        case 6:
	          _context9.next = 8;
	          return (0, _effects.fork)(addSocialChatSaga);
	
	        case 8:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}

/***/ }),
/* 3960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = setAvailableFiltersSaga;
	
	var _effects = __webpack_require__(14);
	
	var _chat = __webpack_require__(67);
	
	var _reqFilters = __webpack_require__(811);
	
	var _filters = __webpack_require__(260);
	
	var _filters2 = __webpack_require__(296);
	
	var _selectors = __webpack_require__(50);
	
	var _selectors2 = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(setAvailableFiltersWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(setAvailableFiltersSaga);
	
	var filterValue = function filterValue(isProvider, isPatient, hasRelations) {
	  var value = _chat.CHATS_FILTER_TYPES.PATIENT;
	
	  if (isProvider) {
	    value = _chat.CHATS_FILTER_TYPES.PROVIDER;
	  } else if (isPatient || hasRelations) {
	    value = _chat.CHATS_FILTER_TYPES.PATIENT;
	  }
	  return value;
	};
	
	function setAvailableFiltersWorker(action) {
	  var selectedType, isPatient, isProvider, hasRelations;
	  return _regenerator2.default.wrap(function setAvailableFiltersWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_filters2.typeSelector);
	
	        case 2:
	          selectedType = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors2.hasPatientProfileSelector);
	
	        case 5:
	          isPatient = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors2.hasProviderProfileSelector);
	
	        case 8:
	          isProvider = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors.selectLoggedUserHasRelations);
	
	        case 11:
	          hasRelations = _context.sent;
	
	          if (selectedType) {
	            _context.next = 15;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)({
	            type: _filters.consts.SET_TYPE,
	            payload: filterValue(isProvider, isPatient, hasRelations)
	          });
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.put)({
	            type: _filters.consts.SET_AVAILABLE_FILTERS,
	            payload: action.payload
	          });
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function setAvailableFiltersSaga() {
	  return _regenerator2.default.wrap(function setAvailableFiltersSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_reqFilters.consts.SUCCEED, setAvailableFiltersWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3961 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = handleUserBlockedSaga;
	
	var _effects = __webpack_require__(14);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _channels = __webpack_require__(236);
	
	var _selectors = __webpack_require__(79);
	
	var _reqChannelParticipants = __webpack_require__(640);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleUserBlocked),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleUserBlockedSaga);
	
	function handleUserBlocked(action) {
	  var _action$payload, blockedIds, unblockedIds, channelIds, blockedStatus, params, activeChannelId, updatedChannels;
	
	  return _regenerator2.default.wrap(function handleUserBlocked$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _action$payload = action.payload, blockedIds = _action$payload.blockedIds, unblockedIds = _action$payload.unblockedIds;
	          channelIds = blockedIds || unblockedIds;
	          blockedStatus = !!blockedIds;
	          params = {
	            ids: channelIds,
	            blocked: blockedStatus
	          };
	          _context.next = 6;
	          return (0, _effects.select)(_selectors.activeChannelIdSelector);
	
	        case 6:
	          activeChannelId = _context.sent;
	
	          if (!activeChannelId) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.put)(_reqChannelParticipants.actions.send({ id: activeChannelId }));
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.put)({
	            type: _constants2.default.UPDATE_BLOCKED_STATUS,
	            payload: params
	          });
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.select)(_channels.subChannelsSelector);
	
	        case 14:
	          updatedChannels = _context.sent;
	          _context.next = 17;
	          return (0, _effects.put)({
	            type: _constants2.default.UPDATE_AVAILABLE_CHANNELS,
	            payload: updatedChannels
	          });
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleUserBlockedSaga() {
	  return _regenerator2.default.wrap(function handleUserBlockedSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.TOGGLE_BLOCKED_CHAT], handleUserBlocked);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _channels = __webpack_require__(3959);
	
	var _channels2 = _interopRequireDefault(_channels);
	
	var _filters = __webpack_require__(3960);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _invitePatient = __webpack_require__(3963);
	
	var _invitePatient2 = _interopRequireDefault(_invitePatient);
	
	var _metadata = __webpack_require__(3964);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _selectNextTargetUser = __webpack_require__(3969);
	
	var _selectNextTargetUser2 = _interopRequireDefault(_selectNextTargetUser);
	
	var _relatedUsers = __webpack_require__(3967);
	
	var _relatedUsers2 = _interopRequireDefault(_relatedUsers);
	
	var _participants = __webpack_require__(3965);
	
	var _participants2 = _interopRequireDefault(_participants);
	
	var _assignProvider = __webpack_require__(3958);
	
	var _assignProvider2 = _interopRequireDefault(_assignProvider);
	
	var _removeContextUser = __webpack_require__(3968);
	
	var _removeContextUser2 = _interopRequireDefault(_removeContextUser);
	
	var _handleBlockedUsers = __webpack_require__(3961);
	
	var _handleBlockedUsers2 = _interopRequireDefault(_handleBlockedUsers);
	
	var _updateChatSaga = __webpack_require__(3971);
	
	var _updateChatSaga2 = _interopRequireDefault(_updateChatSaga);
	
	var _sendMessageWithInboxTaskSaga = __webpack_require__(3970);
	
	var _sendMessageWithInboxTaskSaga2 = _interopRequireDefault(_sendMessageWithInboxTaskSaga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_channels2.default);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(_filters2.default);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(_invitePatient2.default);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(_metadata2.default);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(_selectNextTargetUser2.default);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(_relatedUsers2.default);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_participants2.default);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(_assignProvider2.default);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(_removeContextUser2.default);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(_handleBlockedUsers2.default);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.fork)(_updateChatSaga2.default);
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.fork)(_sendMessageWithInboxTaskSaga2.default);
	
	        case 24:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 3963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = invitePatientSagaWatcher;
	
	var _effects = __webpack_require__(14);
	
	var _reqInvitePatient = __webpack_require__(508);
	
	var _channels = __webpack_require__(634);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(invitePatientWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(invitePatientSagaWatcher);
	
	function invitePatientWorker(action) {
	  var _action$payload, id, email, phoneNumber;
	
	  return _regenerator2.default.wrap(function invitePatientWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _action$payload = action.payload, id = _action$payload.userId, email = _action$payload.email, phoneNumber = _action$payload.phoneNumber;
	          _context.next = 3;
	          return (0, _effects.take)(_reqInvitePatient.consts.SUCCEED);
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.put)({
	            type: _channels.consts.CHANGE_STATUS,
	            payload: {
	              id: id,
	              status: _props.USER_STATUS_INVITED,
	              email: email,
	              phoneNumber: phoneNumber
	            }
	          });
	
	        case 5:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function invitePatientSagaWatcher() {
	  return _regenerator2.default.wrap(function invitePatientSagaWatcher$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_reqInvitePatient.consts.SEND, invitePatientWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getChannelMetadataSaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _uniq = __webpack_require__(380);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _effects = __webpack_require__(14);
	
	var _getAuthorUids = __webpack_require__(3975);
	
	var _getAuthorUids2 = _interopRequireDefault(_getAuthorUids);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(79);
	
	var _metadata = __webpack_require__(1253);
	
	var _reqMetadata = __webpack_require__(1250);
	
	var _metadata2 = __webpack_require__(1247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(getChannelMetadataWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getChannelMetadataSaga);
	
	function getChannelMetadataWorker(action) {
	  var channel, state, loggedUserId, channelId, availableMeta, authorUids, channelMeta, availableUids, ids, _ref, payload;
	
	  return _regenerator2.default.wrap(function getChannelMetadataWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          channel = action.payload;
	          _context.next = 3;
	          return (0, _effects.select)();
	
	        case 3:
	          state = _context.sent;
	          loggedUserId = (0, _selectors.loggedUserIdSelector)(state);
	          channelId = (0, _selectors2.activeChannelIdSelector)(state);
	          availableMeta = (0, _metadata.metadataSelector)(state);
	          authorUids = (0, _uniq2.default)([loggedUserId].concat((0, _toConsumableArray3.default)((0, _getAuthorUids2.default)(channel))));
	          channelMeta = (0, _get2.default)(availableMeta, [channel.channelId], {});
	          availableUids = (0, _keys2.default)(channelMeta).map(function (key) {
	            return parseInt(key, 10);
	          });
	
	          // request only missing meta data
	
	          ids = authorUids.filter(function (uid) {
	            return !availableUids.includes(uid);
	          });
	
	          if ((0, _isEmpty2.default)(ids)) {
	            _context.next = 20;
	            break;
	          }
	
	          _context.next = 14;
	          return (0, _effects.put)({
	            type: _reqMetadata.consts.SEND,
	            payload: {
	              channelId: channelId,
	              ids: ids
	            }
	          });
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.take)(_reqMetadata.consts.SUCCEED);
	
	        case 16:
	          _ref = _context.sent;
	          payload = _ref.payload;
	          _context.next = 20;
	          return (0, _effects.put)({
	            type: _metadata2.consts.ADD_CHANNEL_METADATA,
	            payload: {
	              channelId: channel.channelId,
	              meta: payload
	            }
	          });
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function getChannelMetadataSaga() {
	  return _regenerator2.default.wrap(function getChannelMetadataSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_metadata2.consts.GET_CHANNEL_METADATA], getChannelMetadataWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reqChannelParticipants = __webpack_require__(640);
	
	var _dependentChannelParticipants = __webpack_require__(1246);
	
	var _reqChangeChatName = __webpack_require__(809);
	
	var _reqBlockUser = __webpack_require__(507);
	
	var _reqUnblockUser = __webpack_require__(509);
	
	var _blockUserForDependent = __webpack_require__(633);
	
	var _unblockUserForDependent = __webpack_require__(642);
	
	var _selectors = __webpack_require__(79);
	
	var _selectors2 = __webpack_require__(23);
	
	var _constants3 = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(participantsWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(participantsWorkerSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(changeChatNameWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(chatNameWorkerSaga),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(addParticipantWorkerSaga),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function participantsWorker(_ref) {
	  var payload = _ref.payload;
	
	  var activeChannelId, isVerifiedDependent, targetUserId, isSocialChannel, _ref2, loggedUserParticipantsReq, dependentParticipantsReq, loggedUserParticipants, dependentParticipants;
	
	  return _regenerator2.default.wrap(function participantsWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (!(payload === _constants3.APPOINTMENT_CHANNEL_ID)) {
	            _context.next = 3;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.cancel)();
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.activeChannelIdSelector);
	
	        case 5:
	          activeChannelId = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors2.selectIsVerifiedDependentRole);
	
	        case 8:
	          isVerifiedDependent = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors2.targetUserIdSelector);
	
	        case 11:
	          targetUserId = _context.sent;
	          _context.next = 14;
	          return (0, _effects.select)(_selectors.isSocialChannelSelector);
	
	        case 14:
	          isSocialChannel = _context.sent;
	
	          if (!activeChannelId) {
	            _context.next = 30;
	            break;
	          }
	
	          _context.next = 18;
	          return (0, _effects.put)(_reqChannelParticipants.actions.send({ id: activeChannelId }));
	
	        case 18:
	          if (!(isVerifiedDependent && !isSocialChannel)) {
	            _context.next = 30;
	            break;
	          }
	
	          _context.next = 21;
	          return (0, _effects.put)(_dependentChannelParticipants.actions.send({
	            dependentId: targetUserId,
	            id: activeChannelId
	          }));
	
	        case 21:
	          _context.next = 23;
	          return (0, _effects.all)({
	            loggedUserParticipantsReq: (0, _effects.take)(_reqChannelParticipants.consts.SUCCEED),
	            dependentParticipantsReq: (0, _effects.take)(_dependentChannelParticipants.consts.SUCCEED)
	          });
	
	        case 23:
	          _ref2 = _context.sent;
	          loggedUserParticipantsReq = _ref2.loggedUserParticipantsReq;
	          dependentParticipantsReq = _ref2.dependentParticipantsReq;
	          loggedUserParticipants = loggedUserParticipantsReq.payload;
	          dependentParticipants = dependentParticipantsReq.payload;
	          _context.next = 30;
	          return (0, _effects.put)(_reqChannelParticipants.actions.updateList({
	            loggedUserParticipants: loggedUserParticipants,
	            dependentParticipants: dependentParticipants
	          }));
	
	        case 30:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function participantsWorkerSaga() {
	  return _regenerator2.default.wrap(function participantsWorkerSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_constants2.default.SET_ACTIVE_CHANNEL_ID, participantsWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function changeChatNameWorker(response) {
	  var contextId;
	  return _regenerator2.default.wrap(function changeChatNameWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors2.targetUserIdSelector);
	
	        case 2:
	          contextId = _context3.sent;
	
	          if (!contextId) {
	            _context3.next = 8;
	            break;
	          }
	
	          _context3.next = 6;
	          return (0, _effects.put)({
	            type: _constants2.default.UPDATE_CONTEXT_CHAT_NAME,
	            payload: response.payload,
	            contextId: contextId
	          });
	
	        case 6:
	          _context3.next = 10;
	          break;
	
	        case 8:
	          _context3.next = 10;
	          return (0, _effects.put)({
	            type: _constants2.default.UPDATE_CHAT_NAME,
	            payload: response.payload
	          });
	
	        case 10:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function chatNameWorkerSaga() {
	  return _regenerator2.default.wrap(function chatNameWorkerSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(_reqChangeChatName.consts.SUCCEED, changeChatNameWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function addParticipantWorkerSaga() {
	  return _regenerator2.default.wrap(function addParticipantWorkerSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeEvery)([_reqBlockUser.consts.SUCCEED, _reqUnblockUser.consts.SUCCEED, _blockUserForDependent.consts.SUCCEED, _unblockUserForDependent.consts.SUCCEED], participantsWorker);
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.fork)(participantsWorkerSaga);
	
	        case 2:
	          _context6.next = 4;
	          return (0, _effects.fork)(chatNameWorkerSaga);
	
	        case 4:
	          _context6.next = 6;
	          return (0, _effects.fork)(addParticipantWorkerSaga);
	
	        case 6:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}

/***/ }),
/* 3966 */,
/* 3967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = relatedUsersWorkerSaga;
	
	var _effects = __webpack_require__(14);
	
	var _createchat = __webpack_require__(902);
	
	var _reqRelatedUsers = __webpack_require__(813);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(relatedUsersWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(relatedUsersWorkerSaga);
	
	function relatedUsersWorker(action) {
	  return _regenerator2.default.wrap(function relatedUsersWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (!action.payload) {
	            _context.next = 3;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.put)(_reqRelatedUsers.actions.send(action.payload));
	
	        case 3:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function relatedUsersWorkerSaga() {
	  return _regenerator2.default.wrap(function relatedUsersWorkerSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_createchat.consts.TOGGLE_VISIBILITY, relatedUsersWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = removeContextUserSaga;
	
	var _effects = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(42);
	
	var _chatConnection = __webpack_require__(183);
	
	var _contextbar = __webpack_require__(695);
	
	var _popup = __webpack_require__(76);
	
	var _selectors = __webpack_require__(115);
	
	var _selectors2 = __webpack_require__(90);
	
	var _channels = __webpack_require__(236);
	
	var _settings = __webpack_require__(199);
	
	var _settings2 = __webpack_require__(405);
	
	var _selectors3 = __webpack_require__(237);
	
	var _removeParticipant = __webpack_require__(1874);
	
	var _selectors4 = __webpack_require__(23);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _drawer = __webpack_require__(185);
	
	var _sidebar = __webpack_require__(219);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(showConfirmationPopup),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(toggleMobileSidebars),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(toggleContextBar),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(clearChatId),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(setActiveUserChannel),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(removeContextUserWorker),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(removeContextUserSaga);
	
	function showConfirmationPopup() {
	  return _regenerator2.default.wrap(function showConfirmationPopup$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)((0, _popup.unassignedAction)());
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.take)(_popup.consts.HIDE);
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function toggleMobileSidebars() {
	  var drawerState, sidebarState;
	  return _regenerator2.default.wrap(function toggleMobileSidebars$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors2.uiDrawerSelector);
	
	        case 2:
	          drawerState = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_selectors2.uiSidebarSelector);
	
	        case 5:
	          sidebarState = _context2.sent;
	
	          if (drawerState.visible) {
	            _context2.next = 9;
	            break;
	          }
	
	          _context2.next = 9;
	          return (0, _effects.put)({ type: _drawer.consts.TOGGLE_VISIBILITY });
	
	        case 9:
	          if (!sidebarState.visible) {
	            _context2.next = 12;
	            break;
	          }
	
	          _context2.next = 12;
	          return (0, _effects.put)({ type: _sidebar.consts.TOGGLE_VISIBILITY });
	
	        case 12:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function toggleContextBar() {
	  var contextBarState;
	  return _regenerator2.default.wrap(function toggleContextBar$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors2.contextbarSelector);
	
	        case 2:
	          contextBarState = _context3.sent;
	
	          if (!contextBarState.visible) {
	            _context3.next = 6;
	            break;
	          }
	
	          _context3.next = 6;
	          return (0, _effects.put)({ type: _contextbar.consts.RESET });
	
	        case 6:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function clearChatId() {
	  return _regenerator2.default.wrap(function clearChatId$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.put)({
	            type: _settings.consts.CLEAR_CHAT_ID
	          });
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function setActiveUserChannel() {
	  var firstChannelId, firstContextUser;
	  return _regenerator2.default.wrap(function setActiveUserChannel$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(_channels.defaultFirstActiveChannel);
	
	        case 2:
	          firstChannelId = _context5.sent;
	          _context5.next = 5;
	          return (0, _effects.select)(_channels.defaultFirstContextUser);
	
	        case 5:
	          firstContextUser = _context5.sent;
	          _context5.next = 8;
	          return (0, _effects.put)({
	            type: _chatConnection.consts.SET_ACTIVE_CHANNEL_ID,
	            payload: firstChannelId
	          });
	
	        case 8:
	          if (!firstContextUser) {
	            _context5.next = 11;
	            break;
	          }
	
	          _context5.next = 11;
	          return (0, _effects.put)({
	            type: _settings.consts.SET_LAST_USER_ID,
	            payload: { id: firstContextUser }
	          });
	
	        case 11:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function removeContextUserWorker(action) {
	  var contextUserId, currentLocation, lastUserId, removedContextUserId, removedMemberId, loggedUserId, contextLocation, showPopup;
	  return _regenerator2.default.wrap(function removeContextUserWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          contextUserId = action.payload.contextUserId;
	          _context6.next = 3;
	          return (0, _effects.select)(_selectors.currentLocationSelector);
	
	        case 3:
	          currentLocation = _context6.sent;
	          _context6.next = 6;
	          return (0, _effects.select)(_settings2.lastUserIdSelector);
	
	        case 6:
	          lastUserId = _context6.sent;
	          _context6.next = 9;
	          return (0, _effects.select)(_selectors3.removedContextUserIdSelector);
	
	        case 9:
	          removedContextUserId = _context6.sent;
	          _context6.next = 12;
	          return (0, _effects.select)(_removeParticipant.removedMemberIdSelector);
	
	        case 12:
	          removedMemberId = _context6.sent;
	          _context6.next = 15;
	          return (0, _effects.select)(_selectors4.loggedUserIdSelector);
	
	        case 15:
	          loggedUserId = _context6.sent;
	          contextLocation = ['/' + _routes.CIRCLE_OF_CARE + '/:id', '/' + _routes.SURVEYS_GENERAL_SUB_PATH + '/:id', '/' + _routes.PROGRAM + '/:id', '/' + _routes.MESSAGES].map(function (location) {
	            return location.replace(':id', contextUserId);
	          });
	          showPopup = contextUserId === removedContextUserId || loggedUserId === removedMemberId;
	
	          if (!(lastUserId !== contextUserId)) {
	            _context6.next = 20;
	            break;
	          }
	
	          return _context6.abrupt('return');
	
	        case 20:
	          if (!contextLocation.includes(currentLocation)) {
	            _context6.next = 42;
	            break;
	          }
	
	          if (showPopup) {
	            _context6.next = 24;
	            break;
	          }
	
	          _context6.next = 24;
	          return (0, _effects.call)(showConfirmationPopup);
	
	        case 24:
	          if (!(currentLocation !== '/' + _routes.MESSAGES)) {
	            _context6.next = 31;
	            break;
	          }
	
	          _context6.next = 27;
	          return (0, _effects.call)(clearChatId);
	
	        case 27:
	          _context6.next = 29;
	          return _reactRouter.browserHistory.push('/' + _routes.MESSAGES);
	
	        case 29:
	          _context6.next = 33;
	          break;
	
	        case 31:
	          _context6.next = 33;
	          return (0, _effects.call)(toggleContextBar);
	
	        case 33:
	          if (!(0, _mobileHelpers.isDesktop)()) {
	            _context6.next = 38;
	            break;
	          }
	
	          _context6.next = 36;
	          return (0, _effects.call)(setActiveUserChannel);
	
	        case 36:
	          _context6.next = 40;
	          break;
	
	        case 38:
	          _context6.next = 40;
	          return (0, _effects.call)(toggleMobileSidebars);
	
	        case 40:
	          _context6.next = 44;
	          break;
	
	        case 42:
	          _context6.next = 44;
	          return (0, _effects.call)(clearChatId);
	
	        case 44:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function removeContextUserSaga() {
	  return _regenerator2.default.wrap(function removeContextUserSaga$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.takeEvery)([_chatConnection.consts.REMOVE_CONTEXT_USER], removeContextUserWorker);
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}

/***/ }),
/* 3969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = selectNextTargetUserSaga;
	
	var _effects = __webpack_require__(14);
	
	var _channels = __webpack_require__(236);
	
	var _settings = __webpack_require__(405);
	
	var _filters = __webpack_require__(296);
	
	var _context3 = __webpack_require__(216);
	
	var _settings2 = __webpack_require__(199);
	
	var _chatConnection = __webpack_require__(183);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _selectors = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(selectNextTargetUserWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(selectNextTargetUserSaga);
	
	function selectNextTargetUserWorker() {
	  var state, lastUserId, lastSocialId, targetUserId, userId, filterType;
	  return _regenerator2.default.wrap(function selectNextTargetUserWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if ((0, _mobileHelpers.isDesktop)()) {
	            _context.next = 2;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.select)();
	
	        case 4:
	          state = _context.sent;
	          lastUserId = (0, _settings.lastUserIdSelector)(state);
	          lastSocialId = (0, _settings.lastSocialIdSelector)(state);
	          _context.next = 9;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 9:
	          targetUserId = _context.sent;
	          userId = !lastUserId ? (0, _channels.defaultPatientIdSelector)(state) : lastUserId;
	          _context.next = 13;
	          return (0, _effects.select)(_filters.typeSelector);
	
	        case 13:
	          filterType = _context.sent;
	          _context.t0 = filterType;
	          _context.next = _context.t0 === 'social' ? 17 : _context.t0 === 'all' ? 20 : 33;
	          break;
	
	        case 17:
	          _context.next = 19;
	          return (0, _effects.put)({
	            type: _context3.consts.SET_TARGET_USER_ID,
	            payload: null
	          });
	
	        case 19:
	          return _context.abrupt('break', 39);
	
	        case 20:
	          if (!(userId && !lastSocialId)) {
	            _context.next = 30;
	            break;
	          }
	
	          if (!(targetUserId === lastUserId)) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.cancel)();
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.put)({
	            type: _settings2.consts.SET_LAST_USER_ID,
	            payload: { id: userId }
	          });
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.put)({
	            type: _settings2.consts.REMOVE_LAST_SOCIAL_ID
	          });
	
	        case 28:
	          _context.next = 32;
	          break;
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.put)({
	            type: _context3.consts.SET_TARGET_USER_ID,
	            payload: null
	          });
	
	        case 32:
	          return _context.abrupt('break', 39);
	
	        case 33:
	          if (!(targetUserId === lastUserId)) {
	            _context.next = 36;
	            break;
	          }
	
	          _context.next = 36;
	          return (0, _effects.cancel)();
	
	        case 36:
	          _context.next = 38;
	          return (0, _effects.put)({
	            type: _settings2.consts.SET_LAST_USER_ID,
	            payload: { id: userId }
	          });
	
	        case 38:
	          return _context.abrupt('break', 39);
	
	        case 39:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function selectNextTargetUserSaga() {
	  return _regenerator2.default.wrap(function selectNextTargetUserSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_chatConnection.consts.SET_AVAILABLE_CHANNELS, _settings2.consts.UPDATE_LAST_USER_ID], selectNextTargetUserWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = sendMessageWithInboxTaskSaga;
	
	var _effects = __webpack_require__(14);
	
	var _chat = __webpack_require__(67);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _chatConnection = __webpack_require__(183);
	
	var _selectors = __webpack_require__(23);
	
	var _createChatInboxTaskReq = __webpack_require__(1245);
	
	var _selectors2 = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(sendMessageWithInboxTaskSWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(sendMessageWithInboxTaskSaga);
	
	function sendMessageWithInboxTaskSWorker(_ref) {
	  var payload = _ref.payload;
	
	  var type, files, message, important, linkPayload, quoteMessageId, channel, channelId, contextChannel, _contextChannel, channelTaskId, needsInboxTask, inboxTaskId, _ref2, taskPayload, currentTaskId, data, teamId, teamUserId;
	
	  return _regenerator2.default.wrap(function sendMessageWithInboxTaskSWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          type = payload.type, files = payload.files, message = payload.message, important = payload.important, linkPayload = payload.linkPayload, quoteMessageId = payload.quoteMessageId;
	          _context.next = 3;
	          return (0, _effects.select)(_selectors2.activeChannelSelector);
	
	        case 3:
	          channel = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(_selectors2.activeChannelIdSelector);
	
	        case 6:
	          channelId = _context.sent;
	          _context.next = 9;
	          return (0, _effects.select)(_selectors2.activeContextChannelSelector);
	
	        case 9:
	          contextChannel = _context.sent;
	          _contextChannel = (0, _extends3.default)({}, contextChannel), channelTaskId = _contextChannel.inboxTaskId, needsInboxTask = _contextChannel.needsInboxTask;
	          inboxTaskId = channelTaskId;
	
	          if (!(needsInboxTask && !inboxTaskId)) {
	            _context.next = 21;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)(_createChatInboxTaskReq.actions.send({ chatRoomAppId: channelId }));
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.take)(_createChatInboxTaskReq.actions.succeed);
	
	        case 17:
	          _ref2 = _context.sent;
	          taskPayload = _ref2.payload;
	          currentTaskId = taskPayload.inboxTaskId;
	
	          inboxTaskId = currentTaskId;
	
	        case 21:
	          data = {
	            message: message,
	            important: important,
	            inboxTaskId: inboxTaskId,
	            quoteMessageId: quoteMessageId
	          };
	
	          if (!(type === _chat.MESSAGE_TYPES.ATTACHMENT)) {
	            _context.next = 33;
	            break;
	          }
	
	          _context.next = 25;
	          return (0, _effects.select)(_selectors.selectTeamId);
	
	        case 25:
	          teamId = _context.sent;
	          _context.next = 28;
	          return (0, _effects.select)(_selectors.selectTeamUserId);
	
	        case 28:
	          teamUserId = _context.sent;
	          _context.next = 31;
	          return (0, _effects.put)(_chatConnection.actions.uploadAttachment((0, _extends3.default)({}, data, {
	            files: files,
	            teamId: teamId,
	            channel: channel,
	            teamUserId: teamUserId
	          })));
	
	        case 31:
	          _context.next = 35;
	          break;
	
	        case 33:
	          _context.next = 35;
	          return (0, _effects.put)(_chatConnection.actions.sendMessage((0, _extends3.default)({}, data, {
	            channelId: channelId,
	            linkPayload: linkPayload
	          })));
	
	        case 35:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function sendMessageWithInboxTaskSaga() {
	  return _regenerator2.default.wrap(function sendMessageWithInboxTaskSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_constants2.default.SEND_MESSAGE_WITH_INBOX_TASK], sendMessageWithInboxTaskSWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = updateChatSaga;
	
	var _effects = __webpack_require__(14);
	
	var _has = __webpack_require__(1555);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reqChannelParticipants = __webpack_require__(640);
	
	var _selectors = __webpack_require__(79);
	
	var _reqChannel = __webpack_require__(810);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateChatWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateChatSaga);
	
	function updateChatWorker(action) {
	  var activeChannelId, channelId, updatedChannel;
	  return _regenerator2.default.wrap(function updateChatWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.activeChannelIdSelector);
	
	        case 2:
	          activeChannelId = _context.sent;
	          channelId = parseInt(action.payload.channelId, 10);
	          _context.next = 6;
	          return (0, _effects.put)({
	            type: _reqChannel.consts.SEND,
	            payload: { id: channelId }
	          });
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.take)(_reqChannel.consts.SUCCEED);
	
	        case 8:
	          updatedChannel = _context.sent;
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: _constants2.default.UPDATE_CHANNEL,
	            payload: updatedChannel.payload
	          });
	
	        case 11:
	          if (!(0, _has2.default)(updatedChannel, 'payload.contextUser')) {
	            _context.next = 14;
	            break;
	          }
	
	          _context.next = 14;
	          return (0, _effects.put)({
	            type: _constants2.default.UPDATE_CONTEXT_CHANNEL,
	            payload: updatedChannel.payload,
	            activeChannelId: channelId
	          });
	
	        case 14:
	          if (!(activeChannelId === channelId)) {
	            _context.next = 17;
	            break;
	          }
	
	          _context.next = 17;
	          return (0, _effects.put)(_reqChannelParticipants.actions.send({ id: activeChannelId }));
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateChatSaga() {
	  return _regenerator2.default.wrap(function updateChatSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_constants2.default.UPDATE_CHAT, updateChatWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3972 */,
/* 3973 */,
/* 3974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.connect = connect;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _connection = __webpack_require__(4195);
	
	var _connection2 = _interopRequireDefault(_connection);
	
	var _selectors = __webpack_require__(93);
	
	var _selectors2 = __webpack_require__(23);
	
	var _env = __webpack_require__(103);
	
	var _errors = __webpack_require__(120);
	
	var _realTimeUpdates = __webpack_require__(1273);
	
	var dashboardWS = _interopRequireWildcard(_realTimeUpdates);
	
	var _actions = __webpack_require__(643);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _paymentInfoModal = __webpack_require__(541);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var connection = void 0; /* eslint-disable no-inner-declarations */
	function connect() {
	  return function (dispatch, getStore) {
	    try {
	      var logOut = function logOut(data) {
	        dispatch(_actions2.default.logout(data));
	      };
	
	      // noinspection JSAnnotator
	
	
	      var subscribeToNewComplaints = function subscribeToNewComplaints(data) {
	        var payload = (0, _get2.default)(data, 'message.payload.data.complaint');
	        dispatch(_actions2.default.newComplaint(payload));
	      };
	
	      // connect
	
	
	      var state = getStore();
	      var authToken = (0, _selectors.authTokenSelector)(state);
	      var userId = (0, _selectors2.loggedUserIdSelector)(state);
	      var teamId = (0, _selectors2.selectTeamId)(state);
	      var teamUserId = (0, _selectors2.selectTeamUserId)(state);
	      var isProvider = (0, _selectors2.hasProviderProfileSelector)(state);
	
	      var config = {
	        authToken: authToken,
	        userId: userId,
	        attachmentsUploadUrl: _env.CHAT_ATTACHMENTS_URI + '/upload',
	        socketUrl: _env.CHAT_SOCKET_URI,
	        teamId: teamId,
	        teamUserId: teamUserId,
	        isProvider: isProvider
	      };
	
	      connection = new _connection2.default(config);
	      dispatch(_actions2.default.setChatModuleInstance(connection));
	
	      connection.on('connection_opened', function (data) {
	        // here you can get some connection data
	        // trigger for ready state
	        dispatch(_actions2.default.connectionOpened());
	      });
	
	      connection.on('connection_ready', function (data) {
	        // here you can get some system channel data
	        // trigger for ready state
	        dispatch(_actions2.default.connectionReady());
	      });
	
	      connection.on('conversation_changed', function (data) {
	        dispatch(_actions2.default.conversationChanged(data));
	      });
	
	      connection.on('bump_activity', function (data) {
	        dispatch(_actions2.default.setChannelData(data));
	      });
	
	      connection.on('remove_messages', function (data) {
	        var channel = data.channel,
	            removed = data.removed;
	
	
	        dispatch(_actions2.default.conversationChanged(channel));
	        dispatch(_actions2.default.removeMessages({
	          userId: channel.userId,
	          removedMsgs: removed
	        }));
	      });
	
	      connection.on('reload_history', function () {
	        dispatch(_actions2.default.reloadHistory());
	      });
	
	      connection.on('new_channel_activity', function (data) {
	        dispatch(_actions2.default.newChannelActivity(data));
	      });
	
	      connection.on('remove_chatroom', function (data) {
	        dispatch(_actions2.default.removeChannel(data));
	      });
	
	      connection.on('remove_context_user', function (data) {
	        dispatch(_actions2.default.removeContextUser(data));
	      });
	
	      connection.on('blocked_channels', function (data) {
	        dispatch(_actions2.default.toggleBlockedChat(data));
	      });
	
	      connection.on('update_chat', function (data) {
	        dispatch(_actions2.default.updateChat(data));
	      });
	
	      connection.on('join_request_created', function (data) {
	        dispatch(_actions2.default.newJoinRequest(data));
	      });
	
	      connection.on('join_request_accepted', function (data) {
	        dispatch(_actions2.default.joinRequestAccepted(data));
	      });
	
	      connection.on('join_request_declined', function (data) {
	        dispatch(_actions2.default.joinRequestDeclined(data));
	      });
	
	      connection.on('new_post', function (data) {
	        dispatch(_actions2.default.newPost(data));
	      });
	
	      connection.on('new_post_comment', function (data) {
	        dispatch(_actions2.default.newPostComment(data));
	      });
	
	      connection.on('new_comment_reply', function (data) {
	        dispatch(_actions2.default.newCommentReply(data));
	      });
	
	      connection.on('member_invitation_created', function (data) {
	        dispatch(_actions2.default.newCommunityInvite(data));
	      });
	
	      connection.on('member_invitation_accepted', function (data) {
	        dispatch(_actions2.default.communityInviteAccept(data));
	      });
	      connection.on('member_invitation_declined', function (data) {
	        dispatch(_actions2.default.communityInviteDecline(data));
	      });
	
	      connection.on('community_complaint', subscribeToNewComplaints);
	      connection.on('comment_complaint', subscribeToNewComplaints);
	      connection.on('post_complaint', subscribeToNewComplaints);
	
	      connection.on(_errors.LOGOUT_NOTIFICATIONS_ERRORS.MULTIPLE_DEVICES, logOut);
	      connection.on(_errors.LOGOUT_NOTIFICATIONS_ERRORS.ENTITY_EXCEPTION, logOut);
	
	      /** APPOINTMENTS */
	      connection.on('appointsments:change_status', function (data) {
	        dispatch(dashboardWS.actions.changeStatus(data));
	      });
	      connection.on('appointsments:change_payment_status', function (data) {
	        dispatch(dashboardWS.actions.changePaymentStatus(data));
	      });
	      connection.on('appointsments:update_copay', function (data) {
	        dispatch(dashboardWS.actions.updateCopay(data));
	      });
	
	      connection.on('appointsments:change_room', function (data) {
	        dispatch(dashboardWS.actions.changeRoom(data));
	      });
	
	      connection.on('appointsments:pin', function (data) {
	        dispatch(dashboardWS.actions.pin(data));
	      });
	      connection.on('appointsments:create', function (data) {
	        dispatch(dashboardWS.actions.created(data));
	      });
	
	      connection.on('appointsments:remove_from_dashboard', function (data) {
	        dispatch(dashboardWS.actions.removeFromDashboard(data));
	      });
	
	      connection.on('event:inbox_task_completed', function (data) {
	        dispatch(_actions2.default.completeInboxTask(data));
	      });
	
	      connection.on('event:paya_accountvault_form_url', function (data) {
	        dispatch(_paymentInfoModal.paymentInfoModalActions.receivePayaForm(data));
	      });
	
	      connection.on('event:paya_transaction_successful', function (data) {
	        dispatch(_paymentInfoModal.paymentInfoModalActions.receivedPayaPaymentSuccessResponse(data));
	      });
	
	      connection.on('event:paya_transaction_declined', function (data) {
	        dispatch(_paymentInfoModal.paymentInfoModalActions.receivedPayaPaymentErrorResponse(data));
	      });
	
	      connection.on('phx_reply', function (data) {
	        var errorReason = (0, _get2.default)(data, 'response.reason', null);
	        if (errorReason === 401) {
	          connection.disconnect();
	        }
	      });
	
	      connection.connect();
	    } catch (err) {
	      connection.disconnect();
	      dispatch(_actions2.default.setConnectError(err));
	    }
	  };
	}

/***/ }),
/* 3975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _uniq = __webpack_require__(380);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAuthorUid = function getAuthorUid(message, param) {
	  return parseInt((0, _get2.default)(message, param), 10);
	};
	
	var getAuthorUids = function getAuthorUids(channel) {
	  var messages = (0, _get2.default)(channel, 'messages', []);
	  var uids = messages.reduce(function (acc, message) {
	    var msgAuthorUid = getAuthorUid(message, 'authorUid');
	    var msgTeamUser = getAuthorUid(message, 'userId');
	    acc.push(msgAuthorUid);
	    acc.push(msgTeamUser);
	
	    var quotedMessage = message.quotedMessage;
	
	    if (quotedMessage) {
	      var replyAuthorUid = getAuthorUid(quotedMessage, 'authorUid');
	      var replyTeamUid = getAuthorUid(quotedMessage, 'userId');
	      acc.push(replyAuthorUid);
	      acc.push(replyTeamUid);
	    }
	
	    return acc;
	  }, []).filter(Boolean);
	
	  return (0, _uniq2.default)(uids);
	};
	
	exports.default = getAuthorUids;

/***/ }),
/* 3976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _chat = __webpack_require__(67);
	
	var getFakeUploadAttachmentMessage = function getFakeUploadAttachmentMessage(channelId, name) {
	  var now = new Date().toISOString();
	  var insertedAt = now.substr(0, now.indexOf('Z'));
	
	  return {
	    id: Math.random(),
	    type: _chat.MESSAGE_TYPES.UPLOAD_ATTACHMENT,
	    chatRoomUid: channelId,
	    insertedAt: insertedAt,
	    body: null,
	    authorId: null,
	    meta: {},
	    payload: {
	      name: name
	    }
	  };
	};
	
	exports.default = getFakeUploadAttachmentMessage;

/***/ }),
/* 3977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _sortBy = __webpack_require__(1562);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeWithFakeUploadAttachmentMessages = function mergeWithFakeUploadAttachmentMessages(messages, attachments) {
	  var attachmentsArray = (0, _keys2.default)(attachments).filter(function (key) {
	    return attachments[key].progress < 100;
	  }).map(function (key) {
	    return attachments[key].message;
	  });
	
	  return (0, _sortBy2.default)(messages.concat(attachmentsArray), 'insertedAt');
	};
	
	exports.default = mergeWithFakeUploadAttachmentMessages;

/***/ }),
/* 3978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(266);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var previewImage = function () {
	  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(blob, dispatch) {
	    var fixedBlob;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return (0, _generateImagePreview2.default)(blob, true);
	
	          case 2:
	            fixedBlob = _context.sent;
	
	
	            dispatch(_imageViewer.actions.openViewer({
	              src: window.URL.createObjectURL(fixedBlob)
	            }));
	
	          case 4:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function previewImage(_x, _x2) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var _generateImagePreview = __webpack_require__(1385);
	
	var _generateImagePreview2 = _interopRequireDefault(_generateImagePreview);
	
	var _imageViewer = __webpack_require__(903);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = previewImage;

/***/ }),
/* 3979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends13 = __webpack_require__(3);
	
	var _extends14 = _interopRequireDefault(_extends13);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _createReducer;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _camelize = __webpack_require__(364);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	var _index = __webpack_require__(7);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initState = {
	  opened: false,
	  ready: false,
	  error: null,
	  chatModuleInstance: null,
	  activeChannelId: null,
	  activeUnreadCount: 0,
	
	  availableChannels: {}, // role / targetUser / channel
	  joinedChannels: {}, // initialized channels instances
	
	  uploads: {},
	  downloads: {},
	  lastActiveChannelIds: []
	};
	
	var getChannelByTaskId = function getChannelByTaskId(channel, taskId) {
	  var list = (0, _keys2.default)(channel).map(function (k) {
	    return channel[k];
	  });
	  return list.find(function (item) {
	    return item.inboxTaskId === taskId;
	  });
	};
	
	var parseChannel = function parseChannel(channel) {
	  var messages = (0, _get2.default)(channel, 'messages', []);
	
	  return (0, _extends14.default)({}, channel, { messages: (0, _camelize2.default)(messages) });
	};
	
	var updateJoinedChannels = function updateJoinedChannels(state, action) {
	  var channelId = (0, _get2.default)(action.payload, 'channelId');
	
	  // handle add one channel
	  if (channelId) {
	    return (0, _extends14.default)({}, state, {
	      joinedChannels: (0, _assign2.default)({}, state.joinedChannels, (0, _defineProperty3.default)({}, channelId, parseChannel(action.payload)))
	    });
	  }
	
	  // handle add multiple channels
	  var channels = action.payload;
	  var newChannels = (0, _keys2.default)(channels).reduce(function (acc, key) {
	    acc[key] = parseChannel(channels[key]);
	
	    return acc;
	  }, {});
	
	  return (0, _extends14.default)({}, state, {
	    joinedChannels: (0, _assign2.default)({}, state.joinedChannels, newChannels)
	  });
	};
	
	var setAvailableChannels = function setAvailableChannels(state, action) {
	  return (0, _extends14.default)({}, state, {
	    availableChannels: action.payload
	  });
	};
	
	var removeActiveUnreadCount = function removeActiveUnreadCount(state, action) {
	  return (0, _extends14.default)({}, state, {
	    activeUnreadCount: 0
	  });
	};
	
	var removeChat = function removeChat(state, action) {
	  var _action$payload = action.payload,
	      channelId = _action$payload.channelId,
	      contextId = _action$payload.contextId;
	
	
	  return (0, _extends14.default)({}, state, {
	    availableChannels: (0, _extends14.default)({}, state.availableChannels, (0, _defineProperty3.default)({}, contextId, (0, _omit2.default)(state.availableChannels[contextId], channelId)))
	  });
	};
	
	var updateUploads = function updateUploads(state, action) {
	  var _action$payload2 = action.payload,
	      channelId = _action$payload2.channelId,
	      id = _action$payload2.id;
	
	
	  var existedUpload = (0, _get2.default)(state.uploads, [channelId, id], {});
	  var updatedUpload = (0, _assign2.default)({}, existedUpload, action.payload);
	
	  var updatedChannel = (0, _assign2.default)({}, state.uploads[channelId], (0, _defineProperty3.default)({}, id, updatedUpload));
	
	  return (0, _extends14.default)({}, state, {
	    uploads: (0, _assign2.default)({}, state.uploads, (0, _defineProperty3.default)({}, channelId, updatedChannel))
	  });
	};
	
	var cleanUploads = function cleanUploads(state, action) {
	  var _action$payload3 = action.payload,
	      channelId = _action$payload3.channelId,
	      id = _action$payload3.id;
	
	  var newUploads = (0, _extends14.default)({}, state.uploads);
	
	  delete newUploads[channelId][id];
	
	  return (0, _extends14.default)({}, state, {
	    uploads: newUploads
	  });
	};
	
	var updateDownLoads = function updateDownLoads(state, action) {
	  var _action$payload4 = action.payload,
	      channelId = _action$payload4.channelId,
	      id = _action$payload4.id,
	      parentMsgId = _action$payload4.parentMsgId;
	
	  var updatedParent = void 0;
	
	  if (parentMsgId) {
	    var parentMsg = (0, _get2.default)(state.downloads, [channelId, parentMsgId]);
	    var parentMsgReplies = (0, _get2.default)(parentMsg, 'replies');
	
	    updatedParent = (0, _assign2.default)({}, parentMsg, {
	      replies: (0, _extends14.default)({}, parentMsgReplies, (0, _defineProperty3.default)({}, id, action.payload))
	    });
	  }
	
	  var updatedDownload = (0, _assign2.default)({}, state.downloads[channelId], (0, _defineProperty3.default)({}, parentMsgId || id, updatedParent || action.payload));
	
	  return (0, _extends14.default)({}, state, {
	    downloads: (0, _assign2.default)({}, state.downloads, (0, _defineProperty3.default)({}, channelId, updatedDownload))
	  });
	};
	
	var cleanDownloads = function cleanDownloads(state, action) {
	  var _action$payload5 = action.payload,
	      channelId = _action$payload5.channelId,
	      id = _action$payload5.id,
	      parentMsgId = _action$payload5.parentMsgId;
	
	  var newDownloads = (0, _extends14.default)({}, state.downloads);
	
	  if (parentMsgId) {
	    var download = (0, _get2.default)(newDownloads, [channelId, parentMsgId, 'replies', id]);
	
	    if (download) {
	      delete newDownloads[channelId][parentMsgId].replies[id];
	    }
	  } else {
	    delete newDownloads[channelId][id];
	  }
	
	  return (0, _extends14.default)({}, state, {
	    downloads: newDownloads
	  });
	};
	
	var addActiveUnreadCount = function addActiveUnreadCount(state, action) {
	  return (0, _extends14.default)({}, state, {
	    activeUnreadCount: action.payload
	  });
	};
	
	var updateChannelInboxTask = function updateChannelInboxTask(state, _ref) {
	  var payload = _ref.payload;
	
	  var _payload = (0, _extends14.default)({}, payload),
	      inboxTaskId = _payload.id,
	      patient = _payload.patient;
	
	  var patientId = patient.id;
	  var joinedChannels = state.joinedChannels,
	      availableChannels = state.availableChannels;
	
	
	  var availablePatientChannels = (0, _get2.default)(availableChannels, [patientId], {});
	
	  var availableChannel = getChannelByTaskId(availablePatientChannels, inboxTaskId);
	  var joinedChannel = getChannelByTaskId(joinedChannels, inboxTaskId);
	
	  var channel = joinedChannel || availableChannel;
	
	  if (channel) {
	    var channelId = channel.channelId;
	
	
	    var modifiedAvailableChannels = (0, _extends14.default)({}, availableChannels, (0, _defineProperty3.default)({}, patientId, (0, _extends14.default)({}, availableChannels[patientId], (0, _defineProperty3.default)({}, channelId, (0, _extends14.default)({}, availableChannels[patientId][channelId], {
	      inboxTaskId: null
	    })))));
	
	    var modifiedJoinedChannels = (0, _extends14.default)({}, joinedChannels, (0, _defineProperty3.default)({}, channelId, (0, _extends14.default)({}, joinedChannels[channelId], {
	      inboxTaskId: null
	    })));
	
	    if (joinedChannel) {
	      return (0, _extends14.default)({}, state, {
	        joinedChannels: modifiedJoinedChannels,
	        availableChannels: modifiedAvailableChannels
	      });
	    }
	    return (0, _extends14.default)({}, state, {
	      availableChannels: modifiedAvailableChannels
	    });
	  }
	
	  return (0, _extends14.default)({}, state);
	};
	
	exports.default = (0, _index.createReducer)(initState, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, _constants2.default.CONNECTION_OPENED, function (state, action) {
	  return (0, _extends14.default)({}, state, {
	    opened: true,
	    error: null
	  });
	}), (0, _defineProperty3.default)(_createReducer, _constants2.default.SET_CONNECT_ERROR, function (state, action) {
	  return (0, _extends14.default)({}, state, {
	    opened: false,
	    error: action.payload
	  });
	}), (0, _defineProperty3.default)(_createReducer, _constants2.default.SET_CHAT_MODULE_INSTANCE, function (state, action) {
	  return (0, _extends14.default)({}, state, {
	    chatModuleInstance: action.payload
	  });
	}), (0, _defineProperty3.default)(_createReducer, _constants2.default.CONNECTION_READY, function (state, action) {
	  return (0, _extends14.default)({}, state, {
	    ready: true
	  });
	}), (0, _defineProperty3.default)(_createReducer, _constants2.default.SET_AVAILABLE_CHANNELS, setAvailableChannels), (0, _defineProperty3.default)(_createReducer, _constants2.default.UPDATE_AVAILABLE_CHANNELS, setAvailableChannels), (0, _defineProperty3.default)(_createReducer, _constants2.default.REMOVE_CONTEXT_CHANNEL, removeChat), (0, _defineProperty3.default)(_createReducer, _constants2.default.SET_ACTIVE_CHANNEL_ID, function (state, action) {
	  return (0, _extends14.default)({}, state, {
	    activeChannelId: action.payload
	  });
	}), (0, _defineProperty3.default)(_createReducer, _constants2.default.SET_CHANNEL_DATA, updateJoinedChannels), (0, _defineProperty3.default)(_createReducer, _constants2.default.UPDATE_ATTACHMENT_UPLOAD_STATUS, updateUploads), (0, _defineProperty3.default)(_createReducer, _constants2.default.REMOVE_UPLOAD_ATTACHMENT, cleanUploads), (0, _defineProperty3.default)(_createReducer, _constants2.default.UPDATE_ATTACHMENT_DOWNLOAD_STATUS, updateDownLoads), (0, _defineProperty3.default)(_createReducer, _constants2.default.REMOVE_DOWNLOAD_ATTACHMENT, cleanDownloads), (0, _defineProperty3.default)(_createReducer, _constants2.default.ADD_NEW_SUBCHANNEL, function (state, action) {
	  var _action$payload6 = action.payload,
	      subChannel = _action$payload6.subChannel,
	      id = _action$payload6.id,
	      channelId = _action$payload6.subChannel.channelId;
	
	
	  return (0, _extends14.default)({}, state, {
	    availableChannels: (0, _extends14.default)({}, state.availableChannels, (0, _defineProperty3.default)({}, id, (0, _extends14.default)({}, state.availableChannels[id], (0, _defineProperty3.default)({}, channelId, (0, _extends14.default)({}, subChannel)))))
	  });
	}), (0, _defineProperty3.default)(_createReducer, _constants2.default.SET_LAST_CHANNEL_ID, function (state, action) {
	  var _action$payload7 = action.payload,
	      targetUserId = _action$payload7.targetUserId,
	      id = _action$payload7.id;
	
	  var isAdded = state.lastActiveChannelIds.find(function (item) {
	    return item.targetUserId === targetUserId;
	  });
	
	  var lastChannels = state.lastActiveChannelIds.map(function (item) {
	    if (item.targetUserId === targetUserId) {
	      return { id: id, targetUserId: targetUserId };
	    }
	    return item;
	  });
	
	  return (0, _extends14.default)({}, state, {
	    lastActiveChannelIds: isAdded ? lastChannels : [].concat((0, _toConsumableArray3.default)(state.lastActiveChannelIds), [action.payload])
	  });
	}), (0, _defineProperty3.default)(_createReducer, _constants2.default.ADD_ACTIVE_UNREAD, addActiveUnreadCount), (0, _defineProperty3.default)(_createReducer, _constants2.default.REMOVE_ACTIVE_UNREAD, removeActiveUnreadCount), (0, _defineProperty3.default)(_createReducer, _constants2.default.UPDATE_CONTEXT_CHAT_NAME, function (state, action) {
	  var contextId = action.contextId,
	      _action$payload8 = action.payload,
	      channelId = _action$payload8.channelId,
	      channelName = _action$payload8.channelName;
	
	
	  return (0, _extends14.default)({}, state, {
	    availableChannels: (0, _extends14.default)({}, state.availableChannels, (0, _defineProperty3.default)({}, contextId, (0, _extends14.default)({}, state.availableChannels[contextId], (0, _defineProperty3.default)({}, channelId, (0, _extends14.default)({}, state.availableChannels[contextId][channelId], {
	      channelName: channelName
	    })))))
	  });
	}), (0, _defineProperty3.default)(_createReducer, _constants2.default.UPDATE_CONTEXT_CHANNEL, function (state, action) {
	  var activeChannelId = action.activeChannelId,
	      _action$payload9 = action.payload,
	      subchannels = _action$payload9.subchannels,
	      id = _action$payload9.contextUser.id;
	
	  var subChannel = subchannels.find(function (item) {
	    return (0, _get2.default)(item, 'channelId') === activeChannelId;
	  });
	
	  return (0, _extends14.default)({}, state, {
	    availableChannels: (0, _extends14.default)({}, state.availableChannels, (0, _defineProperty3.default)({}, id, (0, _extends14.default)({}, state.availableChannels[id], (0, _defineProperty3.default)({}, activeChannelId, (0, _extends14.default)({}, subChannel)))))
	  });
	}), (0, _defineProperty3.default)(_createReducer, _constants2.default.UPDATE_CHANNEL_INBOX_TASK_ID, updateChannelInboxTask), _createReducer));

/***/ }),
/* 3980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = bumpActivitySaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(79);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(bumpActivityWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(bumpActivitySaga);
	
	function bumpActivityWorker(action) {
	  var state, chatModuleInstance, channelId, circle;
	  return _regenerator2.default.wrap(function bumpActivityWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context.sent;
	          chatModuleInstance = (0, _selectors.chatModuleInstanceSelector)(state);
	          channelId = action.payload;
	          circle = chatModuleInstance.getCircle(channelId);
	
	
	          if (circle) circle.bumpActivity();
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function bumpActivitySaga() {
	  return _regenerator2.default.wrap(function bumpActivitySaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.BUMP_ACTIVITY], bumpActivityWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = connectToChannelSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(79);
	
	var _selectors2 = __webpack_require__(90);
	
	var _drawer = __webpack_require__(185);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _chat = __webpack_require__(67);
	
	var _constants3 = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(toggleDrawer),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(connectToChannelWorker),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(connectToChannelSaga); /*
	                                                                               * Saga to join selected channel if it wasn't previously
	                                                                               */
	
	function toggleDrawer() {
	  var drawerVisible;
	  return _regenerator2.default.wrap(function toggleDrawer$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors2.drawerVisibleSelector);
	
	        case 2:
	          drawerVisible = _context.sent;
	
	          if (!(!(0, _mobileHelpers.isDesktop)() && drawerVisible)) {
	            _context.next = 6;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.put)({ type: _drawer.consts.TOGGLE_VISIBILITY });
	
	        case 6:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function connectToChannelWorker(action) {
	  var state, chatModuleInstance, activeTargetUserChannel, _ref, channelName, unread, channelInstance, channelId, unreadCount, _ref2, _id, count, _ref3, _id2, _count, _channelInstance, id;
	
	  return _regenerator2.default.wrap(function connectToChannelWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context2.sent;
	
	          if (!(action.payload === _constants3.APPOINTMENT_CHANNEL_ID)) {
	            _context2.next = 8;
	            break;
	          }
	
	          _context2.next = 6;
	          return toggleDrawer();
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.cancel)();
	
	        case 8:
	          chatModuleInstance = (0, _selectors.chatModuleInstanceSelector)(state);
	          activeTargetUserChannel = (0, _selectors.activeTargetUserChannelSelector)(state);
	          _ref = (0, _selectors.nextActiveTargetUserChannelSelector)(state) || {}, channelName = _ref.channelName;
	          unread = void 0;
	
	          if (!activeTargetUserChannel) {
	            _context2.next = 18;
	            break;
	          }
	
	          channelInstance = chatModuleInstance.getCircle(activeTargetUserChannel.channelId);
	
	
	          unread = activeTargetUserChannel.unreadCount;
	          if ((0, _get2.default)(channelInstance, 'currentPage') === 0) {
	            channelInstance.loadNextHistoryPage();
	          }
	          _context2.next = 27;
	          break;
	
	        case 18:
	          // initialize new CircleOfCare instance
	          // TODO REFACTOR
	
	          channelId = void 0;
	          unreadCount = void 0;
	
	
	          if ((0, _selectors.nextActiveTargetUserChannelSelector)(state)) {
	            _ref2 = (0, _selectors.nextActiveTargetUserChannelSelector)(state) || {}, _id = _ref2.channelId, count = _ref2.totalUnreadCount;
	
	            channelId = _id;
	            unreadCount = count;
	          }
	
	          if ((0, _selectors.activeSocialChannelSelector)(state)) {
	            _ref3 = (0, _selectors.activeSocialChannelSelector)(state) || {}, _id2 = _ref3.channelId, _count = _ref3.totalUnreadCount;
	
	            channelId = _id2;
	            unreadCount = _count;
	          }
	
	          unread = unreadCount;
	
	          if (channelId) {
	            _context2.next = 25;
	            break;
	          }
	
	          return _context2.abrupt('return');
	
	        case 25:
	          _channelInstance = chatModuleInstance.createChannel(channelId, {
	            unreadCount: unreadCount
	          });
	
	          _channelInstance.loadNextHistoryPage();
	
	        case 27:
	          _context2.next = 29;
	          return toggleDrawer();
	
	        case 29:
	          id = action.payload;
	
	          if (!id) {
	            _context2.next = 36;
	            break;
	          }
	
	          _context2.next = 33;
	          return (0, _effects.put)({
	            type: _constants2.default.ADD_ACTIVE_UNREAD,
	            payload: unread
	          });
	
	        case 33:
	          if (!(channelName !== _chat.ACTIVITIES_CHANNEL)) {
	            _context2.next = 36;
	            break;
	          }
	
	          _context2.next = 36;
	          return (0, _effects.put)({
	            type: _constants2.default.BUMP_ACTIVITY,
	            payload: id
	          });
	
	        case 36:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function connectToChannelSaga() {
	  return _regenerator2.default.wrap(function connectToChannelSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.SET_ACTIVE_CHANNEL_ID], connectToChannelWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 3982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = conversationChangedSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _selectors = __webpack_require__(79);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _isHealthboardSaga = __webpack_require__(1875);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(conversationChangedWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(conversationChangedSaga);
	
	function conversationChangedWorker(action) {
	  var isHealthBoard, activeChannelID, activeChannel, channel;
	  return _regenerator2.default.wrap(function conversationChangedWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(_isHealthboardSaga.isHealthBoardPage);
	
	        case 2:
	          isHealthBoard = _context.sent;
	
	          if (!isHealthBoard) {
	            _context.next = 6;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.cancel)();
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.activeChannelIdSelector);
	
	        case 8:
	          activeChannelID = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors.activeContextChannelSelector);
	
	        case 11:
	          activeChannel = _context.sent;
	          channel = action.payload;
	
	
	          if (action.payload.channelId === activeChannelID && (0, _get2.default)(activeChannel, 'channelName') !== 'activities') {
	            channel = (0, _extends3.default)({}, action.payload, { unreadCount: 0 });
	          }
	
	          _context.next = 16;
	          return (0, _effects.put)({
	            type: _constants2.default.FETCH_MESSAGES,
	            payload: channel
	          });
	
	        case 16:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function conversationChangedSaga() {
	  return _regenerator2.default.wrap(function conversationChangedSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.CONVERSATION_CHANGED], conversationChangedWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = disconnectSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(79);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(disconnectWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(disconnectSaga);
	
	function disconnectWorker() {
	  var state, chatModuleInstance;
	  return _regenerator2.default.wrap(function disconnectWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context.sent;
	          chatModuleInstance = (0, _selectors.chatModuleInstanceSelector)(state);
	
	          // eslint-disable-next-line no-unused-expressions
	
	          chatModuleInstance && chatModuleInstance.disconnect();
	
	        case 5:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function disconnectSaga() {
	  return _regenerator2.default.wrap(function disconnectSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.DISCONNECT], disconnectWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = downloadAttachmentSaga;
	
	var _fileSaver = __webpack_require__(1516);
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(93);
	
	var _chat = __webpack_require__(67);
	
	var _previewImage = __webpack_require__(3978);
	
	var _previewImage2 = _interopRequireDefault(_previewImage);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _actions = __webpack_require__(643);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(downloadAttachmentWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(downloadAttachmentSaga);
	
	function downloadAttachmentWorker(_ref, action) {
	  var dispatch = _ref.dispatch;
	
	  var state, authToken, _action$payload, id, name, type, channelId, isPreview, parentMsgId, src, credentials, clearDownload, updateDownload, xhr;
	
	  return _regenerator2.default.wrap(function downloadAttachmentWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context.sent;
	          authToken = (0, _selectors.authTokenSelector)(state);
	          _action$payload = action.payload, id = _action$payload.id, name = _action$payload.fileName, type = _action$payload.type, channelId = _action$payload.channelId, isPreview = _action$payload.isPreview, parentMsgId = _action$payload.parentMsgId;
	          src = (0, _chat.attachmentUrlResolver)(authToken, id);
	          credentials = {
	            channelId: channelId,
	            id: id,
	            parentMsgId: parentMsgId
	          };
	
	          clearDownload = function clearDownload() {
	            return dispatch(_actions2.default.removeDownloadAttachment(credentials));
	          };
	
	          updateDownload = function updateDownload(params) {
	            return dispatch(_actions2.default.updateAttachmentDownloadStatus((0, _extends3.default)({}, credentials, params)));
	          };
	
	          if (!(type.includes('pdf') && isPreview)) {
	            _context.next = 13;
	            break;
	          }
	
	          window.open(src);
	          _context.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          xhr = new XMLHttpRequest();
	
	          xhr.open('GET', src);
	          xhr.responseType = 'blob';
	
	          xhr.onprogress = function (e) {
	            return updateDownload({
	              id: id,
	              channelId: channelId,
	              name: name,
	              progress: Math.round(e.loaded / e.total * 100),
	              isPreview: isPreview,
	              cancel: function cancel() {
	                xhr.abort();
	                clearDownload();
	              }
	            });
	          };
	
	          // eslint-disable-next-line consistent-return
	          xhr.onload = function (e) {
	            var blob = new Blob([e.target.response], { type: type });
	            clearDownload();
	
	            if (!isPreview) return (0, _fileSaver.saveAs)(blob, name);
	
	            // Preview functionality
	            if (type.includes('image')) return (0, _previewImage2.default)(blob, dispatch);
	          };
	
	          xhr.send();
	
	        case 19:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function downloadAttachmentSaga() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return _regenerator2.default.wrap(function downloadAttachmentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return _effects.takeLatest.apply(undefined, [[_constants2.default.DOWNLOAD_ATTACHMENT], downloadAttachmentWorker].concat(args));
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = fetchMessagesSaga;
	
	var _camelize = __webpack_require__(364);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(79);
	
	var _mergeWithFakeUploadAttachmentMessages = __webpack_require__(3977);
	
	var _mergeWithFakeUploadAttachmentMessages2 = _interopRequireDefault(_mergeWithFakeUploadAttachmentMessages);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _metadata = __webpack_require__(1247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchMessagesWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchMessagesSaga);
	
	function fetchMessagesWorker(action) {
	  var _action$payload, channelId, _action$payload$messa, messages, state, uploads, attachments, camelizedMessages;
	
	  return _regenerator2.default.wrap(function fetchMessagesWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _action$payload = action.payload, channelId = _action$payload.channelId, _action$payload$messa = _action$payload.messages, messages = _action$payload$messa === undefined ? [] : _action$payload$messa;
	          _context.next = 3;
	          return (0, _effects.select)();
	
	        case 3:
	          state = _context.sent;
	          uploads = (0, _selectors.uploadsSelector)(state);
	          attachments = uploads[channelId] || {};
	          camelizedMessages = (0, _camelize2.default)(messages);
	          _context.next = 9;
	          return (0, _effects.put)({
	            type: _constants2.default.CHECK_NEW_NOTIFICATIONS,
	            payload: {
	              channelId: channelId,
	              messages: camelizedMessages
	            }
	          });
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: _constants2.default.SET_CHANNEL_DATA,
	            payload: (0, _extends3.default)({}, action.payload, {
	              messages: (0, _mergeWithFakeUploadAttachmentMessages2.default)(camelizedMessages, attachments)
	            })
	          });
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.put)({
	            type: _metadata.consts.GET_CHANNEL_METADATA,
	            payload: action.payload
	          });
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function fetchMessagesSaga() {
	  return _regenerator2.default.wrap(function fetchMessagesSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.FETCH_MESSAGES], fetchMessagesWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _bumpActivity = __webpack_require__(3980);
	
	var _bumpActivity2 = _interopRequireDefault(_bumpActivity);
	
	var _connectToChannel = __webpack_require__(3981);
	
	var _connectToChannel2 = _interopRequireDefault(_connectToChannel);
	
	var _conversationChanged = __webpack_require__(3982);
	
	var _conversationChanged2 = _interopRequireDefault(_conversationChanged);
	
	var _disconnect = __webpack_require__(3983);
	
	var _disconnect2 = _interopRequireDefault(_disconnect);
	
	var _fetchMessages = __webpack_require__(3985);
	
	var _fetchMessages2 = _interopRequireDefault(_fetchMessages);
	
	var _loadNextHistoryPage = __webpack_require__(3987);
	
	var _loadNextHistoryPage2 = _interopRequireDefault(_loadNextHistoryPage);
	
	var _locationChange = __webpack_require__(3988);
	
	var _locationChange2 = _interopRequireDefault(_locationChange);
	
	var _newChannelActivity = __webpack_require__(3989);
	
	var _newChannelActivity2 = _interopRequireDefault(_newChannelActivity);
	
	var _reloadHistory = __webpack_require__(3990);
	
	var _reloadHistory2 = _interopRequireDefault(_reloadHistory);
	
	var _sendMessage = __webpack_require__(3992);
	
	var _sendMessage2 = _interopRequireDefault(_sendMessage);
	
	var _setActiveChannel = __webpack_require__(3993);
	
	var _setActiveChannel2 = _interopRequireDefault(_setActiveChannel);
	
	var _removeChannelActivity = __webpack_require__(3991);
	
	var _removeChannelActivity2 = _interopRequireDefault(_removeChannelActivity);
	
	var _updateChannelInboxTaskIdSaga = __webpack_require__(3995);
	
	var _updateChannelInboxTaskIdSaga2 = _interopRequireDefault(_updateChannelInboxTaskIdSaga);
	
	var _socialChatSelectionSaga = __webpack_require__(1876);
	
	var _socialChatSelectionSaga2 = _interopRequireDefault(_socialChatSelectionSaga);
	
	var _socialHatInitSelectionSaga = __webpack_require__(3994);
	
	var _socialHatInitSelectionSaga2 = _interopRequireDefault(_socialHatInitSelectionSaga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_bumpActivity2.default);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(_connectToChannel2.default);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(_conversationChanged2.default);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(_disconnect2.default);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(_fetchMessages2.default);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(_loadNextHistoryPage2.default);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_locationChange2.default);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(_newChannelActivity2.default);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(_reloadHistory2.default);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(_sendMessage2.default);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.fork)(_setActiveChannel2.default);
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.fork)(_removeChannelActivity2.default);
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.fork)(_updateChannelInboxTaskIdSaga2.default);
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.fork)(_socialChatSelectionSaga2.default);
	
	        case 28:
	          _context.next = 30;
	          return (0, _effects.fork)(_socialHatInitSelectionSaga2.default);
	
	        case 30:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 3987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = loadNextHistoryPageSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(79);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadNextHistoryPageWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(loadNextHistoryPageSaga);
	
	function loadNextHistoryPageWorker(action) {
	  var chatModuleInstance, channelId, channel;
	  return _regenerator2.default.wrap(function loadNextHistoryPageWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.chatModuleInstanceSelector);
	
	        case 2:
	          chatModuleInstance = _context.sent;
	          channelId = action.payload.channelId;
	          channel = chatModuleInstance.getCircle(channelId);
	
	
	          channel && channel.loadNextHistoryPage(); // eslint-disable-line no-unused-expressions
	
	        case 6:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function loadNextHistoryPageSaga() {
	  return _regenerator2.default.wrap(function loadNextHistoryPageSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.LOAD_NEXT_HISTORY_PAGE], loadNextHistoryPageWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = locationChangeSaga;
	
	var _effects = __webpack_require__(14);
	
	var _flatten = __webpack_require__(2350);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _invokeMap = __webpack_require__(5504);
	
	var _invokeMap2 = _interopRequireDefault(_invokeMap);
	
	var _locationReducer = __webpack_require__(240);
	
	var _selectors = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(locationChangeWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(locationChangeSaga);
	
	function locationChangeWorker() {
	  var downloads, chatNamesWithActiveDownloads, roomsWithDownloads, nestedDownloadsObject, flattenedDownloads, previewsToCancel;
	  return _regenerator2.default.wrap(function locationChangeWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.downloadsSelector);
	
	        case 2:
	          downloads = _context.sent;
	          chatNamesWithActiveDownloads = (0, _keys2.default)(downloads);
	
	          if (chatNamesWithActiveDownloads) {
	            _context.next = 6;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 6:
	          roomsWithDownloads = chatNamesWithActiveDownloads.map(function (i) {
	            return downloads[i];
	          });
	          nestedDownloadsObject = roomsWithDownloads.map(function (room) {
	            return (0, _keys2.default)(room).map(function (dkey) {
	              return room[dkey];
	            });
	          });
	          flattenedDownloads = (0, _flatten2.default)(nestedDownloadsObject);
	          previewsToCancel = flattenedDownloads.filter(function (download) {
	            return download.isPreview;
	          });
	
	
	          (0, _invokeMap2.default)(previewsToCancel, 'cancel');
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function locationChangeSaga() {
	  return _regenerator2.default.wrap(function locationChangeSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_locationReducer.LOCATION_CHANGE], locationChangeWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = newChannelActivitySaga;
	
	var _effects = __webpack_require__(14);
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _selectors = __webpack_require__(79);
	
	var _channels = __webpack_require__(236);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _channels2 = __webpack_require__(634);
	
	var _reqChannel = __webpack_require__(810);
	
	var _settings = __webpack_require__(199);
	
	var _isHealthboardSaga = __webpack_require__(1875);
	
	var _selectors2 = __webpack_require__(115);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(newChannelActivityWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(newChannelActivitySaga); /*
	                                                                                 * Saga to join updated channel if it wasn't previously
	                                                                                 */
	
	function newChannelActivityWorker(action) {
	  var isHealthBoard, location, isSelfSchedulingFlow, _action$payload, id, _action$payload$messa, masterUserId, insertedAt, chatRoomUid, channelId, state, chatModuleInstance, availableChannels, containingGroup, _get, totalUnreadCount, _ref, circleOfCare, updatedChannel, lastMessageAt, _totalUnreadCount, updatedChannels, _totalUnreadCount2;
	
	  return _regenerator2.default.wrap(function newChannelActivityWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(_isHealthboardSaga.isHealthBoardPage);
	
	        case 2:
	          isHealthBoard = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors2.currentLocationSelector);
	
	        case 5:
	          location = _context.sent;
	          isSelfSchedulingFlow = location.includes(_routes.APPOINTMENT_FORM);
	
	          if (!(isHealthBoard || isSelfSchedulingFlow)) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.cancel)();
	
	        case 10:
	          _action$payload = action.payload, id = _action$payload.channelId, _action$payload$messa = _action$payload.message, masterUserId = _action$payload$messa.masterUserId, insertedAt = _action$payload$messa.insertedAt, chatRoomUid = _action$payload$messa.chatRoomUid;
	          channelId = parseInt(id, 10);
	          _context.next = 14;
	          return (0, _effects.select)();
	
	        case 14:
	          state = _context.sent;
	          chatModuleInstance = (0, _selectors.chatModuleInstanceSelector)(state);
	          availableChannels = (0, _selectors.availableChannelsSelector)(state);
	          containingGroup = (0, _keys2.default)(availableChannels).find(function (key) {
	            return (0, _get3.default)(availableChannels[key], [masterUserId, channelId]);
	          });
	
	          /**
	           *    CONTAIN GROUP
	           * */
	
	          if (!containingGroup) {
	            _context.next = 23;
	            break;
	          }
	
	          // initialize new CircleOfCareChannel instance with existed unreadCounter data
	          _get = (0, _get3.default)(availableChannels, [containingGroup, masterUserId, channelId]), totalUnreadCount = _get.totalUnreadCount;
	
	
	          chatModuleInstance.createChannel(channelId, {
	            unreadCount: totalUnreadCount + 1,
	            lastMessageAt: insertedAt
	          });
	
	          _context.next = 23;
	          return (0, _effects.cancel)();
	
	        case 23:
	          _context.next = 25;
	          return (0, _effects.put)({
	            type: _reqChannel.consts.SEND,
	            payload: { id: chatRoomUid }
	          });
	
	        case 25:
	          _context.next = 27;
	          return (0, _effects.take)(function (a) {
	            var context = a.payload ? a.payload.contextUser : '';
	            if (context) {
	              return a.type === _reqChannel.consts.SUCCEED && a.payload.contextUser.id === masterUserId;
	            }
	            return a.type === _reqChannel.consts.SUCCEED;
	          });
	
	        case 27:
	          _ref = _context.sent;
	          circleOfCare = _ref.payload;
	
	          if (!circleOfCare) {
	            _context.next = 49;
	            break;
	          }
	
	          updatedChannel = (0, _get3.default)(circleOfCare, 'subchannels', []).find(function (channel) {
	            return channel.channelId === channelId;
	          });
	
	          if (!updatedChannel) {
	            _context.next = 45;
	            break;
	          }
	
	          // initialize new CircleOfCareChannel instance with existed unreadCounter data
	          lastMessageAt = updatedChannel.lastMessageAt, _totalUnreadCount = updatedChannel.totalUnreadCount;
	
	          chatModuleInstance.createChannel(channelId, {
	            unreadCount: _totalUnreadCount,
	            lastMessageAt: lastMessageAt
	          });
	
	          _context.next = 36;
	          return (0, _effects.put)({
	            type: _channels2.consts.ADD_ITEMS,
	            payload: circleOfCare
	          });
	
	        case 36:
	          _context.next = 38;
	          return (0, _effects.select)(_channels.subChannelsSelector);
	
	        case 38:
	          updatedChannels = _context.sent;
	          _context.next = 41;
	          return (0, _effects.put)({
	            type: _constants2.default.UPDATE_AVAILABLE_CHANNELS,
	            payload: updatedChannels
	          });
	
	        case 41:
	          _context.next = 43;
	          return (0, _effects.put)({
	            type: _settings.consts.ADD_EXCLUDED_ID,
	            payload: circleOfCare.id
	          });
	
	        case 43:
	          _context.next = 49;
	          break;
	
	        case 45:
	          _totalUnreadCount2 = circleOfCare.totalUnreadCount;
	
	
	          chatModuleInstance.createChannel(channelId, {
	            unreadCount: _totalUnreadCount2,
	            lastMessageAt: insertedAt
	          });
	
	          _context.next = 49;
	          return (0, _effects.put)({
	            type: _channels2.consts.ADD_ITEMS,
	            payload: circleOfCare
	          });
	
	        case 49:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function newChannelActivitySaga() {
	  return _regenerator2.default.wrap(function newChannelActivitySaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_constants2.default.NEW_CHANNEL_ACTIVITY], newChannelActivityWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = reloadHistorySaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(79);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(reloadHistoryWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(reloadHistorySaga);
	
	function reloadHistoryWorker() {
	  var state, activeChannel;
	  return _regenerator2.default.wrap(function reloadHistoryWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context.sent;
	          activeChannel = (0, _selectors.activeTargetUserChannelSelector)(state);
	          _context.next = 6;
	          return (0, _effects.put)({
	            type: _constants2.default.FETCH_MESSAGES,
	            payload: activeChannel
	          });
	
	        case 6:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function reloadHistorySaga() {
	  return _regenerator2.default.wrap(function reloadHistorySaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.RELOAD_HISTORY], reloadHistoryWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = removeChannelActivitySaga;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _head = __webpack_require__(378);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(79);
	
	var _removeParticipant = __webpack_require__(1874);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _channels = __webpack_require__(236);
	
	var _settings = __webpack_require__(199);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _drawer = __webpack_require__(185);
	
	var _sidebar = __webpack_require__(219);
	
	var _selectors3 = __webpack_require__(90);
	
	var _routes = __webpack_require__(37);
	
	var _selectors4 = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(toggleMobileSidebars),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(firstChatSelection),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(firstChannelSelection),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(removeChannelActivityWorker),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(removeChannelActivitySaga);
	
	function toggleMobileSidebars() {
	  var drawerState, sidebarState;
	  return _regenerator2.default.wrap(function toggleMobileSidebars$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors3.uiDrawerSelector);
	
	        case 2:
	          drawerState = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors3.uiSidebarSelector);
	
	        case 5:
	          sidebarState = _context.sent;
	
	          if (drawerState.visible) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 9;
	          return (0, _effects.put)({ type: _drawer.consts.TOGGLE_VISIBILITY });
	
	        case 9:
	          if (!sidebarState.visible) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 12;
	          return (0, _effects.put)({ type: _sidebar.consts.TOGGLE_VISIBILITY });
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function firstChatSelection() {
	  var firstChannelId, firstContextUser;
	  return _regenerator2.default.wrap(function firstChatSelection$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_channels.defaultFirstActiveChannel);
	
	        case 2:
	          firstChannelId = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_channels.defaultFirstContextUser);
	
	        case 5:
	          firstContextUser = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.put)({
	            type: _constants2.default.SET_ACTIVE_CHANNEL_ID,
	            payload: firstChannelId
	          });
	
	        case 8:
	          if (!firstContextUser) {
	            _context2.next = 13;
	            break;
	          }
	
	          _context2.next = 11;
	          return (0, _effects.put)({
	            type: _settings.consts.SET_LAST_USER_ID,
	            payload: { id: firstContextUser }
	          });
	
	        case 11:
	          _context2.next = 13;
	          return (0, _effects.put)({
	            type: _settings.consts.REMOVE_LAST_SOCIAL_ID
	          });
	
	        case 13:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function firstChannelSelection() {
	  var targetUserId, currentChannels, activeSubchannelId;
	  return _regenerator2.default.wrap(function firstChannelSelection$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 2:
	          targetUserId = _context3.sent;
	          _context3.next = 5;
	          return (0, _effects.select)(_selectors2.availableChannelsSelector);
	
	        case 5:
	          currentChannels = _context3.sent;
	          activeSubchannelId = parseInt((0, _head2.default)((0, _keys2.default)(currentChannels[targetUserId])), 10);
	          _context3.next = 9;
	          return (0, _effects.put)({
	            type: _constants2.default.SET_ACTIVE_CHANNEL_ID,
	            payload: activeSubchannelId
	          });
	
	        case 9:
	          _context3.next = 11;
	          return (0, _effects.put)({
	            type: _constants2.default.SET_LAST_CHANNEL_ID,
	            payload: { id: activeSubchannelId, targetUserId: targetUserId }
	          });
	
	        case 11:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function removeChannelActivityWorker(action) {
	  var channelId, targetUserId, activeChannelId, availableChannels, removedMemberId, loggedUserId, currentLocation, showRemoveMessage;
	  return _regenerator2.default.wrap(function removeChannelActivityWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          channelId = action.payload.channelId;
	          _context4.next = 3;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 3:
	          targetUserId = _context4.sent;
	          _context4.next = 6;
	          return (0, _effects.select)(_selectors2.activeChannelIdSelector);
	
	        case 6:
	          activeChannelId = _context4.sent;
	          _context4.next = 9;
	          return (0, _effects.select)(_selectors2.availableChannelsSelector);
	
	        case 9:
	          availableChannels = _context4.sent;
	          _context4.next = 12;
	          return (0, _effects.select)(_removeParticipant.removedMemberIdSelector);
	
	        case 12:
	          removedMemberId = _context4.sent;
	          _context4.next = 15;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 15:
	          loggedUserId = _context4.sent;
	          _context4.next = 18;
	          return (0, _effects.select)(_selectors4.currentLocationSelector);
	
	        case 18:
	          currentLocation = _context4.sent;
	          showRemoveMessage = loggedUserId !== removedMemberId && currentLocation === '/' + _routes.MESSAGES;
	
	          if (!((0, _size2.default)(availableChannels[targetUserId]) > 0)) {
	            _context4.next = 25;
	            break;
	          }
	
	          _context4.next = 23;
	          return (0, _effects.put)({
	            type: _constants2.default.REMOVE_CONTEXT_CHANNEL,
	            payload: { channelId: channelId, contextId: targetUserId }
	          });
	
	        case 23:
	          _context4.next = 27;
	          break;
	
	        case 25:
	          _context4.next = 27;
	          return (0, _effects.put)({
	            type: _constants2.default.REMOVE_SOCIAL_CHANNEL,
	            payload: { channelId: channelId, contextId: targetUserId }
	          });
	
	        case 27:
	          if (!((0, _size2.default)(availableChannels[targetUserId]) === 1)) {
	            _context4.next = 30;
	            break;
	          }
	
	          _context4.next = 30;
	          return (0, _effects.put)({
	            type: _constants2.default.REMOVE_CONTEXT,
	            payload: { contextId: targetUserId }
	          });
	
	        case 30:
	          if (!(activeChannelId === channelId)) {
	            _context4.next = 46;
	            break;
	          }
	
	          if (!showRemoveMessage) {
	            _context4.next = 34;
	            break;
	          }
	
	          _context4.next = 34;
	          return (0, _effects.put)({
	            type: _constants2.default.REMOVE_CHANNEL_MESSAGE
	          });
	
	        case 34:
	          if ((0, _mobileHelpers.isDesktop)()) {
	            _context4.next = 39;
	            break;
	          }
	
	          _context4.next = 37;
	          return (0, _effects.call)(toggleMobileSidebars);
	
	        case 37:
	          _context4.next = 46;
	          break;
	
	        case 39:
	          if (!targetUserId) {
	            _context4.next = 44;
	            break;
	          }
	
	          _context4.next = 42;
	          return (0, _effects.call)(firstChannelSelection);
	
	        case 42:
	          _context4.next = 46;
	          break;
	
	        case 44:
	          _context4.next = 46;
	          return (0, _effects.call)(firstChatSelection);
	
	        case 46:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function removeChannelActivitySaga() {
	  return _regenerator2.default.wrap(function removeChannelActivitySaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.REMOVE_CHANNEL], removeChannelActivityWorker);
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 3992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = sendMessageSaga;
	
	var _effects = __webpack_require__(14);
	
	var _replies = __webpack_require__(636);
	
	var _selectors = __webpack_require__(79);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(sendMessageWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(sendMessageSaga);
	
	function sendMessageWorker(action) {
	  var state, chatModuleInstance, _action$payload, channelId, important, message, quoteMessageId, linkPayload, inboxTaskId;
	
	  return _regenerator2.default.wrap(function sendMessageWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context.sent;
	          chatModuleInstance = (0, _selectors.chatModuleInstanceSelector)(state);
	          _action$payload = action.payload, channelId = _action$payload.channelId, important = _action$payload.important, message = _action$payload.message, quoteMessageId = _action$payload.quoteMessageId, linkPayload = _action$payload.linkPayload, inboxTaskId = _action$payload.inboxTaskId;
	
	
	          chatModuleInstance.getCircle(channelId).sendMessage({
	            message: message,
	            important: important,
	            quoteMessageId: quoteMessageId,
	            linkPayload: linkPayload,
	            inboxTaskId: inboxTaskId
	          });
	
	          if (!quoteMessageId) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 9;
	          return (0, _effects.put)({
	            type: _replies.consts.REMOVE_ITEM,
	            payload: channelId
	          });
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function sendMessageSaga() {
	  return _regenerator2.default.wrap(function sendMessageSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants2.default.SEND_MESSAGE], sendMessageWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.setActiveChannelSaga = setActiveChannelSaga;
	exports.storePatientCircleOfCareSaga = storePatientCircleOfCareSaga;
	exports.clearCircleSaga = clearCircleSaga;
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(79);
	
	var _channels = __webpack_require__(236);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _reqCircleOfCare = __webpack_require__(404);
	
	var _circleOfCare = __webpack_require__(635);
	
	var _settings = __webpack_require__(199);
	
	var _context8 = __webpack_require__(216);
	
	var _permissions = __webpack_require__(832);
	
	var _getUser = __webpack_require__(202);
	
	var _mobileHelpers = __webpack_require__(57);
	
	var _constants3 = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(setActiveChannelWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(setActiveChannelSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(storePatientCircleOfCareWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(storePatientCircleOfCareSaga),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(clearCircleWorker),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(clearCircleSaga),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(root); /*
	                                                               * Saga to set default channel as active on messages targetUser change
	                                                               *
	                                                               * Request patient information:
	                                                               * - family and provider circles,
	                                                               * - upcoming surveys,
	                                                               * - joined programs
	                                                               * - program invitations (disabled)
	                                                               */
	
	function setActiveChannelWorker(action) {
	  var id, state, firstChannelId, activeChannelId, availableChannels, nextActiveTargetUserChannel;
	  return _regenerator2.default.wrap(function setActiveChannelWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          id = action.payload.id;
	          _context.next = 3;
	          return (0, _effects.select)();
	
	        case 3:
	          state = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(_channels.defaultFirstActiveChannel);
	
	        case 6:
	          firstChannelId = _context.sent;
	          _context.next = 9;
	          return (0, _effects.select)(_selectors.activeChannelIdSelector);
	
	        case 9:
	          activeChannelId = _context.sent;
	          availableChannels = (0, _selectors.availableTargetUserChannelsSelector)(state);
	          nextActiveTargetUserChannel = (0, _selectors.defaultChannelIdSelector)(state);
	          _context.next = 14;
	          return (0, _effects.put)({
	            type: _context8.consts.SET_TARGET_USER_ID,
	            payload: id
	          });
	
	        case 14:
	          if ((0, _mobileHelpers.isDesktop)()) {
	            _context.next = 16;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 16:
	          if (!(nextActiveTargetUserChannel === _constants3.APPOINTMENT_CHANNEL_ID)) {
	            _context.next = 23;
	            break;
	          }
	
	          _context.next = 19;
	          return (0, _effects.take)(_getUser.consts.SUCCEED);
	
	        case 19:
	          _context.next = 21;
	          return (0, _effects.put)({
	            type: _constants2.default.SET_ACTIVE_CHANNEL_ID,
	            payload: _constants3.APPOINTMENT_CHANNEL_ID
	          });
	
	        case 21:
	          _context.next = 23;
	          return (0, _effects.cancel)();
	
	        case 23:
	          _context.next = 25;
	          return (0, _effects.put)({ type: _constants2.default.SET_ACTIVE_CHANNEL_ID });
	
	        case 25:
	          _context.next = 27;
	          return (0, _effects.take)(_getUser.consts.SUCCEED);
	
	        case 27:
	          _context.next = 29;
	          return (0, _effects.take)(_permissions.consts.UPDATE);
	
	        case 29:
	          if (availableChannels) {
	            _context.next = 34;
	            break;
	          }
	
	          _context.next = 32;
	          return (0, _effects.put)({
	            type: _constants2.default.SET_ACTIVE_CHANNEL_ID,
	            payload: activeChannelId || firstChannelId
	          });
	
	        case 32:
	          _context.next = 36;
	          break;
	
	        case 34:
	          _context.next = 36;
	          return (0, _effects.put)({
	            type: _constants2.default.SET_ACTIVE_CHANNEL_ID,
	            payload: parseInt(nextActiveTargetUserChannel, 10)
	          });
	
	        case 36:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function setActiveChannelSaga() {
	  return _regenerator2.default.wrap(function setActiveChannelSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_settings.consts.SET_LAST_USER_ID], setActiveChannelWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function storePatientCircleOfCareWorker(action) {
	  var _action$payload, familyCircle, careProviders, _action$payload$pendi, pendingInvitations, _action$payload$pendi2, pendingCaregivers, _action$payload$pendi3, pendingGuardiansProxies, pendingUsers, pendingFamilyMembers;
	
	  return _regenerator2.default.wrap(function storePatientCircleOfCareWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _action$payload = action.payload, familyCircle = _action$payload.familyCircle, careProviders = _action$payload.careProviders, _action$payload$pendi = _action$payload.pendingInvitations, pendingInvitations = _action$payload$pendi === undefined ? [] : _action$payload$pendi, _action$payload$pendi2 = _action$payload.pendingCaregivers, pendingCaregivers = _action$payload$pendi2 === undefined ? [] : _action$payload$pendi2, _action$payload$pendi3 = _action$payload.pendingGuardiansProxies, pendingGuardiansProxies = _action$payload$pendi3 === undefined ? [] : _action$payload$pendi3;
	          pendingUsers = [].concat((0, _toConsumableArray3.default)(pendingGuardiansProxies), (0, _toConsumableArray3.default)(pendingCaregivers), (0, _toConsumableArray3.default)(pendingInvitations));
	          pendingFamilyMembers = pendingUsers.map(function (item) {
	            return (0, _extends3.default)({}, item, {
	              pending: true
	            });
	          });
	          _context3.next = 5;
	          return (0, _effects.put)({
	            type: _circleOfCare.consts.SET_CIRCLE,
	            payload: {
	              familyCircle: familyCircle,
	              careProviders: careProviders,
	              pendingFamilyMembers: pendingFamilyMembers
	            }
	          });
	
	        case 5:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function storePatientCircleOfCareSaga() {
	  return _regenerator2.default.wrap(function storePatientCircleOfCareSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)([_reqCircleOfCare.consts.SUCCEED], storePatientCircleOfCareWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function clearCircleWorker() {
	  return _regenerator2.default.wrap(function clearCircleWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.put)({
	            type: _circleOfCare.consts.CLEAR
	          });
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function clearCircleSaga() {
	  return _regenerator2.default.wrap(function clearCircleSaga$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.takeLatest)([_reqCircleOfCare.consts.SEND], clearCircleWorker);
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.fork)(setActiveChannelSaga);
	
	        case 2:
	          _context7.next = 4;
	          return (0, _effects.fork)(storePatientCircleOfCareSaga);
	
	        case 4:
	          _context7.next = 6;
	          return (0, _effects.fork)(clearCircleSaga);
	
	        case 6:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}

/***/ }),
/* 3994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = socialChannelSelectionSaga;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _settings = __webpack_require__(405);
	
	var _selectors = __webpack_require__(115);
	
	var _socialChatSelectionSaga = __webpack_require__(1876);
	
	var _channels = __webpack_require__(236);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(socialChannelSelectionWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(socialChannelSelectionSaga);
	
	function socialChannelSelectionWorker() {
	  var location, channelsList, lastSocialId, firstChannelId, isMessagingPage;
	  return _regenerator2.default.wrap(function socialChannelSelectionWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.currentLocationSelector);
	
	        case 2:
	          location = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_channels.channelsListSelector);
	
	        case 5:
	          channelsList = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_settings.lastSocialIdSelector);
	
	        case 8:
	          lastSocialId = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_channels.defaultFirstActiveChannel);
	
	        case 11:
	          firstChannelId = _context.sent;
	          isMessagingPage = location.includes(_routes.MESSAGES);
	
	          if (!(isMessagingPage && (0, _size2.default)(channelsList) > 0)) {
	            _context.next = 18;
	            break;
	          }
	
	          _context.next = 16;
	          return (0, _effects.put)({
	            type: _constants2.default.SET_ACTIVE_CHANNEL_ID,
	            payload: lastSocialId || firstChannelId
	          });
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.call)(_socialChatSelectionSaga.showSocialChatSelectionAlert);
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function socialChannelSelectionSaga() {
	  return _regenerator2.default.wrap(function socialChannelSelectionSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_constants2.default.SOCIAL_CHAT_INIT_SELECTION], socialChannelSelectionWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = updateChannelInboxTaskSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _actions = __webpack_require__(643);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _selectors = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateChannelInboxTaskWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateChannelInboxTaskSaga);
	
	function updateChannelInboxTaskWorker(_ref) {
	  var payload = _ref.payload;
	
	  var _payload, kind, _payload2, patient, patientId, availableChannels, availablePatientChannel;
	
	  return _regenerator2.default.wrap(function updateChannelInboxTaskWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _payload = (0, _extends3.default)({}, payload), kind = _payload.kind;
	
	          if (!(kind !== 'message')) {
	            _context.next = 4;
	            break;
	          }
	
	          _context.next = 4;
	          return (0, _effects.cancel)();
	
	        case 4:
	          _payload2 = (0, _extends3.default)({}, payload), patient = _payload2.patient;
	          patientId = patient.id;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.availableChannelsSelector);
	
	        case 8:
	          availableChannels = _context.sent;
	          availablePatientChannel = (0, _get2.default)(availableChannels, [patientId], {});
	
	          if (!(!availablePatientChannel || (0, _isEmpty2.default)(availablePatientChannel))) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)(_actions2.default.updateChannelInboxTaskId(payload));
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateChannelInboxTaskSaga() {
	  return _regenerator2.default.wrap(function updateChannelInboxTaskSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_constants2.default.COMPLETE_INBOX_TASK], updateChannelInboxTaskWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = uploadAttachmentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _generateImagePreview = __webpack_require__(1385);
	
	var _generateImagePreview2 = _interopRequireDefault(_generateImagePreview);
	
	var _chat = __webpack_require__(67);
	
	var _selectors = __webpack_require__(93);
	
	var _getFakeUploadAttachmentMessage = __webpack_require__(3976);
	
	var _getFakeUploadAttachmentMessage2 = _interopRequireDefault(_getFakeUploadAttachmentMessage);
	
	var _selectors2 = __webpack_require__(79);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _actions = __webpack_require__(643);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(uploadAttachmentWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(uploadAttachmentSaga); /* eslint-disable no-use-before-define */
	
	
	function uploadAttachmentWorker(_ref, action) {
	  var dispatch = _ref.dispatch;
	
	  var state, _chatModuleInstanceSe, uploader, authToken, _action$payload, files, messageText, teamId, channel, important, teamUserId, inboxTaskId, quoteMessageId, channelId, attachments, message, credentials, fetchMessages, clearUpload, updateUpload, i, file, attachedPreview, attachmentData, uploadTask;
	
	  return _regenerator2.default.wrap(function uploadAttachmentWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context.sent;
	          _chatModuleInstanceSe = (0, _selectors2.chatModuleInstanceSelector)(state), uploader = _chatModuleInstanceSe.uploader;
	          authToken = (0, _selectors.authTokenSelector)(state);
	          _action$payload = action.payload, files = _action$payload.files, messageText = _action$payload.message, teamId = _action$payload.teamId, channel = _action$payload.channel, important = _action$payload.important, teamUserId = _action$payload.teamUserId, inboxTaskId = _action$payload.inboxTaskId, quoteMessageId = _action$payload.quoteMessageId;
	          channelId = channel.channelId;
	          attachments = [];
	          message = (0, _getFakeUploadAttachmentMessage2.default)(channelId, 'files');
	          credentials = {
	            channelId: channelId,
	            id: message.id
	          };
	
	          fetchMessages = function fetchMessages(params) {
	            return dispatch(_actions2.default.fetchMessages(params));
	          };
	
	          clearUpload = function clearUpload() {
	            return dispatch(_actions2.default.removeUploadAttachment(credentials));
	          };
	
	          updateUpload = function updateUpload(params) {
	            return dispatch(_actions2.default.updateAttachmentUploadStatus((0, _extends3.default)({}, credentials, params)));
	          };
	
	          updateUpload({
	            cancel: function cancel() {
	              uploadTask();
	              clearUpload();
	              fetchMessages(channel);
	            },
	            progress: 0,
	            message: message
	          });
	
	          i = 0;
	
	        case 15:
	          if (!(i < files.length)) {
	            _context.next = 31;
	            break;
	          }
	
	          file = files[i];
	
	          if (!file.type.includes('image')) {
	            _context.next = 23;
	            break;
	          }
	
	          _context.next = 20;
	          return (0, _generateImagePreview2.default)(file, false, _chat.IMAGE_PREVIEW_WIDTH);
	
	        case 20:
	          _context.t0 = _context.sent;
	          _context.next = 24;
	          break;
	
	        case 23:
	          _context.t0 = null;
	
	        case 24:
	          attachedPreview = _context.t0;
	          attachmentData = {
	            attachment: file
	          };
	
	
	          if (attachedPreview) {
	            attachmentData.preview = attachedPreview;
	          }
	
	          attachments.push(attachmentData);
	
	        case 28:
	          i++;
	          _context.next = 15;
	          break;
	
	        case 31:
	          uploadTask = uploader.upload({
	            token: authToken,
	            teamId: teamId,
	            teamUserId: teamUserId,
	            channelId: channelId,
	            attachments: attachments,
	            important: important,
	            inboxTaskId: inboxTaskId,
	            quoteMessageId: quoteMessageId,
	            message: messageText,
	            onSuccess: clearUpload,
	            onError: function onError() {
	              return updateUpload({ error: true });
	            },
	            onProgress: function onProgress(e) {
	              return updateUpload({ progress: Math.round(e.loaded / e.total * 100) });
	            }
	          });
	
	
	          fetchMessages(channel);
	
	        case 33:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function uploadAttachmentSaga() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return _regenerator2.default.wrap(function uploadAttachmentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return _effects.takeLatest.apply(undefined, [[_constants2.default.UPLOAD_ATTACHMENT], uploadAttachmentWorker].concat(args));
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 3997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = checkStore;
	
	var _conformsTo = __webpack_require__(2348);
	
	var _conformsTo2 = _interopRequireDefault(_conformsTo);
	
	var _isFunction = __webpack_require__(731);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isObject = __webpack_require__(139);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _invariant = __webpack_require__(724);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Validate the shape of redux store
	 */
	function checkStore(store) {
	  var shape = {
	    dispatch: _isFunction2.default,
	    subscribe: _isFunction2.default,
	    getState: _isFunction2.default,
	    replaceReducer: _isFunction2.default,
	    runSaga: _isFunction2.default,
	    injectedReducers: _isObject2.default,
	    injectedSagas: _isObject2.default
	  };
	  (0, _invariant2.default)((0, _conformsTo2.default)(store, shape), '(app/utils...) injectors: Expected a valid redux store');
	}

/***/ }),
/* 3998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(91);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _selectors = __webpack_require__(23);
	
	var _strings = __webpack_require__(15);
	
	var _myFamilyCircle = __webpack_require__(514);
	
	var _leaveFamilyCircle = __webpack_require__(298);
	
	var _removeCaregiver = __webpack_require__(649);
	
	var _declineInviteToFamilyCircle = __webpack_require__(411);
	
	var _acceptInviteToFamilyCircle = __webpack_require__(408);
	
	var _memberFamilyCircle = __webpack_require__(647);
	
	var _declineCaregiverRole = __webpack_require__(410);
	
	var _acceptCaregiverRole = __webpack_require__(407);
	
	var _acceptGuardianRole = __webpack_require__(406);
	
	var _declineGuardianRole = __webpack_require__(409);
	
	var _caregiver = __webpack_require__(297);
	
	var _getGuardianCircle = __webpack_require__(644);
	
	var _removeGuardianRole = __webpack_require__(648);
	
	var _getGuardianDependents = __webpack_require__(353);
	
	var _cancelFamilyMemberInvitation = __webpack_require__(511);
	
	var _cancelCaregiverInvitation = __webpack_require__(510);
	
	var _inviteToFamilyCircle = __webpack_require__(412);
	
	var _inviteCaregiver = __webpack_require__(513);
	
	var _familyMember = __webpack_require__(862);
	
	var _caregiver2 = __webpack_require__(861);
	
	var _guardian = __webpack_require__(863);
	
	var _targetUser = __webpack_require__(415);
	
	var _formInProgress = __webpack_require__(1373);
	
	var _scheduledTasksUpcomingReq = __webpack_require__(303);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(acceptCaregiverRole),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(declineCaregiverRole),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(patientRemoveCaregiverRole),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(rejectedAcceptOrDecline),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(acceptFamilyInvite),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(declineFamilyInvite),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(guardianRemovesGuardianRole),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(acceptGuardianRole),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(declineGuardianRole),
	    _marked10 = /*#__PURE__*/_regenerator2.default.mark(caregiverRemoveCaregiverRole),
	    _marked11 = /*#__PURE__*/_regenerator2.default.mark(leaveCaregiverRole),
	    _marked12 = /*#__PURE__*/_regenerator2.default.mark(removeCaregiverRole),
	    _marked13 = /*#__PURE__*/_regenerator2.default.mark(watchAcceptCaregiverRole),
	    _marked14 = /*#__PURE__*/_regenerator2.default.mark(watchDeclineCaregiverRole),
	    _marked15 = /*#__PURE__*/_regenerator2.default.mark(watchRemoveCaregiverRole),
	    _marked16 = /*#__PURE__*/_regenerator2.default.mark(watchAccceptFamilyInvite),
	    _marked17 = /*#__PURE__*/_regenerator2.default.mark(watchDeclineFamilyInvite),
	    _marked18 = /*#__PURE__*/_regenerator2.default.mark(watchRemoveAnotherGuardian),
	    _marked19 = /*#__PURE__*/_regenerator2.default.mark(watchAcceptGuardianRole),
	    _marked20 = /*#__PURE__*/_regenerator2.default.mark(watchDeclineGuardianRole),
	    _marked21 = /*#__PURE__*/_regenerator2.default.mark(addPendingWorker),
	    _marked22 = /*#__PURE__*/_regenerator2.default.mark(addPendingSaga),
	    _marked23 = /*#__PURE__*/_regenerator2.default.mark(clearFormInProgressWorker),
	    _marked24 = /*#__PURE__*/_regenerator2.default.mark(clearFormInProgressSaga),
	    _marked25 = /*#__PURE__*/_regenerator2.default.mark(removePendingWorker),
	    _marked26 = /*#__PURE__*/_regenerator2.default.mark(removePendingSaga),
	    _marked27 = /*#__PURE__*/_regenerator2.default.mark(addPendingCaregiverWorker),
	    _marked28 = /*#__PURE__*/_regenerator2.default.mark(addPendingCaregiverSaga),
	    _marked29 = /*#__PURE__*/_regenerator2.default.mark(removePendingCaregiverWorker),
	    _marked30 = /*#__PURE__*/_regenerator2.default.mark(removePendingCaregiverSaga),
	    _marked31 = /*#__PURE__*/_regenerator2.default.mark(caregiverAddPendingWorker),
	    _marked32 = /*#__PURE__*/_regenerator2.default.mark(caregiverAddPendingSaga),
	    _marked33 = /*#__PURE__*/_regenerator2.default.mark(caregiverRemovePendingWorker),
	    _marked34 = /*#__PURE__*/_regenerator2.default.mark(caregiverRemovePendingSaga),
	    _marked35 = /*#__PURE__*/_regenerator2.default.mark(root);
	
	// circles
	
	// pending invitations
	
	// invitations
	
	// context
	
	// form in progress
	
	
	/** *************************** Family circle ********************************** * */
	
	function acceptCaregiverRole(action) {
	  var id, targetUser, payload;
	  return _regenerator2.default.wrap(function acceptCaregiverRole$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          id = action.payload.id;
	          _context.next = 3;
	          return (0, _effects.select)(_selectors.targetUserSelector);
	
	        case 3:
	          targetUser = _context.sent;
	          _context.prev = 4;
	          _context.next = 7;
	          return (0, _effects.take)(_acceptCaregiverRole.consts.SUCCEED);
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)({
	            type: _caregiver2.consts.REMOVE,
	            payload: { id: id }
	          });
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: _memberFamilyCircle.consts.REMOVE_ITEM,
	            payload: { id: targetUser.id }
	          });
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.put)({
	            type: _caregiver.consts.SEND
	          });
	
	        case 13:
	          if (!targetUser) {
	            _context.next = 17;
	            break;
	          }
	
	          payload = (0, _extends3.default)({}, (0, _omit2.default)(targetUser, ['inviteId', 'inviteType']), {
	            activeCircle: _strings.CIRCLE_CAREGIVER
	          });
	          _context.next = 17;
	          return (0, _effects.put)({
	            type: _targetUser.consts.SET,
	            payload: payload
	          });
	
	        case 17:
	          _context.next = 22;
	          break;
	
	        case 19:
	          _context.prev = 19;
	          _context.t0 = _context['catch'](4);
	
	          console.error('Error on accept caregiver invite', _context.t0);
	
	        case 22:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[4, 19]]);
	}
	
	function declineCaregiverRole(action) {
	  var id, loggedUser;
	  return _regenerator2.default.wrap(function declineCaregiverRole$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          id = action.payload.id;
	          _context2.next = 3;
	          return (0, _effects.select)(_selectors.loggedUserSelector);
	
	        case 3:
	          loggedUser = _context2.sent;
	          _context2.prev = 4;
	          _context2.next = 7;
	          return (0, _effects.take)(_declineCaregiverRole.consts.SUCCEED);
	
	        case 7:
	          _context2.next = 9;
	          return (0, _effects.put)({
	            type: _caregiver2.consts.REMOVE,
	            payload: { id: id }
	          });
	
	        case 9:
	          _context2.next = 11;
	          return (0, _effects.put)({
	            type: _targetUser.consts.SET,
	            payload: loggedUser
	          });
	
	        case 11:
	          _context2.next = 16;
	          break;
	
	        case 13:
	          _context2.prev = 13;
	          _context2.t0 = _context2['catch'](4);
	
	          console.error('Error decline caregiver role', id, _context2.t0);
	
	        case 16:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this, [[4, 13]]);
	}
	
	function patientRemoveCaregiverRole(id) {
	  return _regenerator2.default.wrap(function patientRemoveCaregiverRole$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.prev = 0;
	          _context3.next = 3;
	          return (0, _effects.put)({
	            type: _myFamilyCircle.consts.REMOVE_CAREGIVER_ROLE,
	            payload: { id: id }
	          });
	
	        case 3:
	          _context3.next = 8;
	          break;
	
	        case 5:
	          _context3.prev = 5;
	          _context3.t0 = _context3['catch'](0);
	
	          console.error('Error removing caregiver role', id, _context3.t0);
	
	        case 8:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this, [[0, 5]]);
	}
	
	function rejectedAcceptOrDecline() {
	  var targetUser;
	  return _regenerator2.default.wrap(function rejectedAcceptOrDecline$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.select)(_selectors.targetUserSelector);
	
	        case 2:
	          targetUser = _context4.sent;
	          _context4.next = 5;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'errors.familyMember.invitation' }
	          });
	
	        case 5:
	          _context4.next = 7;
	          return (0, _effects.put)(_scheduledTasksUpcomingReq.actions.send({ id: targetUser.id, limit: 20, offset: 0 }));
	
	        case 7:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function acceptFamilyInvite(action) {
	  var id, targetUser, _ref, success, payload;
	
	  return _regenerator2.default.wrap(function acceptFamilyInvite$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          id = action.payload.id;
	          _context5.next = 3;
	          return (0, _effects.select)(_selectors.targetUserSelector);
	
	        case 3:
	          targetUser = _context5.sent;
	          _context5.next = 6;
	          return (0, _effects.race)({
	            success: (0, _effects.take)(_acceptInviteToFamilyCircle.consts.SUCCEED),
	            reject: (0, _effects.take)(_acceptInviteToFamilyCircle.consts.REJECTED)
	          });
	
	        case 6:
	          _ref = _context5.sent;
	          success = _ref.success;
	
	          if (!success) {
	            _context5.next = 19;
	            break;
	          }
	
	          _context5.next = 11;
	          return (0, _effects.put)({
	            type: _familyMember.consts.REMOVE,
	            payload: { id: id }
	          });
	
	        case 11:
	          _context5.next = 13;
	          return (0, _effects.put)({
	            type: _memberFamilyCircle.consts.SEND
	          });
	
	        case 13:
	          if (!targetUser) {
	            _context5.next = 17;
	            break;
	          }
	
	          payload = (0, _extends3.default)({}, (0, _omit2.default)(targetUser, ['inviteId', 'inviteType']), {
	            activeCircle: _strings.CIRCLE_FAMILY
	          });
	          _context5.next = 17;
	          return (0, _effects.put)({
	            type: _targetUser.consts.SET,
	            payload: payload
	          });
	
	        case 17:
	          _context5.next = 21;
	          break;
	
	        case 19:
	          _context5.next = 21;
	          return (0, _effects.fork)(rejectedAcceptOrDecline);
	
	        case 21:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function declineFamilyInvite(action) {
	  var id, loggedUser, _ref2, success;
	
	  return _regenerator2.default.wrap(function declineFamilyInvite$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          id = action.payload.id;
	          _context6.next = 3;
	          return (0, _effects.select)(_selectors.loggedUserSelector);
	
	        case 3:
	          loggedUser = _context6.sent;
	          _context6.next = 6;
	          return (0, _effects.race)({
	            success: (0, _effects.take)(_declineInviteToFamilyCircle.consts.SUCCEED),
	            reject: (0, _effects.take)(_declineInviteToFamilyCircle.consts.REJECTED)
	          });
	
	        case 6:
	          _ref2 = _context6.sent;
	          success = _ref2.success;
	
	          if (!success) {
	            _context6.next = 15;
	            break;
	          }
	
	          _context6.next = 11;
	          return (0, _effects.put)({
	            type: _familyMember.consts.REMOVE,
	            payload: { id: id }
	          });
	
	        case 11:
	          _context6.next = 13;
	          return (0, _effects.put)({
	            type: _targetUser.consts.SET,
	            payload: loggedUser
	          });
	
	        case 13:
	          _context6.next = 17;
	          break;
	
	        case 15:
	          _context6.next = 17;
	          return (0, _effects.fork)(rejectedAcceptOrDecline);
	
	        case 17:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	/** *************************** Guardian circle ************************************* * */
	
	function guardianRemovesGuardianRole(action) {
	  var _action$payload, userId, memberId, loggedUser, id;
	
	  return _regenerator2.default.wrap(function guardianRemovesGuardianRole$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _action$payload = action.payload, userId = _action$payload.userId, memberId = _action$payload.memberId;
	          _context7.next = 3;
	          return (0, _effects.select)(_selectors.loggedUserSelector);
	
	        case 3:
	          loggedUser = _context7.sent;
	          id = loggedUser.id;
	          _context7.next = 7;
	          return (0, _effects.take)(_removeGuardianRole.consts.SUCCEED);
	
	        case 7:
	          if (!(id === memberId)) {
	            _context7.next = 20;
	            break;
	          }
	
	          _context7.next = 10;
	          return (0, _effects.put)({
	            type: _getGuardianCircle.consts.REMOVE_ITEM,
	            payload: { id: userId }
	          });
	
	        case 10:
	          _context7.next = 12;
	          return (0, _effects.put)({
	            type: _caregiver.consts.SEND
	          });
	
	        case 12:
	          _context7.next = 14;
	          return (0, _effects.put)({
	            type: _memberFamilyCircle.consts.SEND
	          });
	
	        case 14:
	          _context7.next = 16;
	          return (0, _effects.put)({
	            type: _getGuardianDependents.consts.SEND
	          });
	
	        case 16:
	          _context7.next = 18;
	          return (0, _effects.put)({
	            type: _targetUser.consts.SET,
	            payload: loggedUser
	          });
	
	        case 18:
	          _context7.next = 22;
	          break;
	
	        case 20:
	          _context7.next = 22;
	          return (0, _effects.put)({
	            type: _getGuardianCircle.consts.REMOVE_GUARDIAN_ROLE,
	            payload: { userId: userId, memberId: memberId }
	          });
	
	        case 22:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function acceptGuardianRole(action) {
	  var id, targetUser, payload;
	  return _regenerator2.default.wrap(function acceptGuardianRole$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          id = action.payload.id;
	          _context8.next = 3;
	          return (0, _effects.select)(_selectors.targetUserSelector);
	
	        case 3:
	          targetUser = _context8.sent;
	          _context8.next = 6;
	          return (0, _effects.take)(_acceptGuardianRole.consts.SUCCEED);
	
	        case 6:
	          _context8.next = 8;
	          return (0, _effects.put)({
	            type: _guardian.consts.REMOVE,
	            payload: { id: id }
	          });
	
	        case 8:
	          _context8.next = 10;
	          return (0, _effects.put)({
	            type: _memberFamilyCircle.consts.REMOVE_ITEM,
	            payload: { id: targetUser.id }
	          });
	
	        case 10:
	          _context8.next = 12;
	          return (0, _effects.put)({
	            type: _caregiver.consts.REMOVE_ITEM,
	            payload: { id: id }
	          });
	
	        case 12:
	          _context8.next = 14;
	          return (0, _effects.put)({
	            type: _getGuardianCircle.consts.SEND
	          });
	
	        case 14:
	          _context8.next = 16;
	          return (0, _effects.put)({
	            type: _getGuardianDependents.consts.SEND
	          });
	
	        case 16:
	          if (!targetUser) {
	            _context8.next = 20;
	            break;
	          }
	
	          payload = (0, _extends3.default)({}, (0, _omit2.default)(targetUser, ['inviteId', 'inviteType']), {
	            activeCircle: _strings.CIRCLE_DEPENDENTS
	          });
	          _context8.next = 20;
	          return (0, _effects.put)({
	            type: _targetUser.consts.SET,
	            payload: payload
	          });
	
	        case 20:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function declineGuardianRole(action) {
	  var id, loggedUser;
	  return _regenerator2.default.wrap(function declineGuardianRole$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          id = action.payload.id;
	          _context9.next = 3;
	          return (0, _effects.select)(_selectors.loggedUserSelector);
	
	        case 3:
	          loggedUser = _context9.sent;
	          _context9.next = 6;
	          return (0, _effects.take)(_declineGuardianRole.consts.SUCCEED);
	
	        case 6:
	          _context9.next = 8;
	          return (0, _effects.put)({
	            type: _guardian.consts.REMOVE,
	            payload: { id: id }
	          });
	
	        case 8:
	          _context9.next = 10;
	          return (0, _effects.put)({
	            type: _targetUser.consts.SET,
	            payload: loggedUser
	          });
	
	        case 10:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}
	
	/** *************************** Caregiver circle ********************************** * */
	
	function caregiverRemoveCaregiverRole(userId, memberId) {
	  return _regenerator2.default.wrap(function caregiverRemoveCaregiverRole$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.prev = 0;
	          _context10.next = 3;
	          return (0, _effects.put)({
	            type: _caregiver.consts.REMOVE_CAREGIVER,
	            payload: { userId: userId, memberId: memberId }
	          });
	
	        case 3:
	          _context10.next = 5;
	          return (0, _effects.put)({
	            type: _getGuardianCircle.consts.REMOVE_CAREGIVER,
	            payload: { userId: userId, memberId: memberId }
	          });
	
	        case 5:
	          _context10.next = 10;
	          break;
	
	        case 7:
	          _context10.prev = 7;
	          _context10.t0 = _context10['catch'](0);
	
	          console.error('Error removeing caregiver role', _context10.t0);
	
	        case 10:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this, [[0, 7]]);
	}
	
	function leaveCaregiverRole(targetUser) {
	  return _regenerator2.default.wrap(function leaveCaregiverRole$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          _context11.prev = 0;
	          _context11.next = 3;
	          return (0, _effects.put)({
	            type: _caregiver.consts.SEND
	          });
	
	        case 3:
	          _context11.next = 5;
	          return (0, _effects.put)({
	            type: _memberFamilyCircle.consts.SEND
	          });
	
	        case 5:
	          if (!targetUser) {
	            _context11.next = 8;
	            break;
	          }
	
	          _context11.next = 8;
	          return (0, _effects.put)({
	            type: _targetUser.consts.SET,
	            payload: (0, _extends3.default)({}, targetUser, { activeCircle: _strings.CIRCLE_FAMILY })
	          });
	
	        case 8:
	          _context11.next = 13;
	          break;
	
	        case 10:
	          _context11.prev = 10;
	          _context11.t0 = _context11['catch'](0);
	
	          console.error('Error on remove caregiver from caregiver circle', _context11.t0);
	
	        case 13:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked11, this, [[0, 10]]);
	}
	
	function removeCaregiverRole(action) {
	  var _action$payload2, userId, memberId, state, _targetUserPermission, isLoggedUser, isCaregiver, isVerifiedDependent, loggedUser, targetUser, isCaregiverLeaveRole, isCaregiverRemoveRole;
	
	  return _regenerator2.default.wrap(function removeCaregiverRole$(_context12) {
	    while (1) {
	      switch (_context12.prev = _context12.next) {
	        case 0:
	          _action$payload2 = action.payload, userId = _action$payload2.userId, memberId = _action$payload2.memberId;
	          _context12.next = 3;
	          return (0, _effects.select)();
	
	        case 3:
	          state = _context12.sent;
	          _targetUserPermission = (0, _selectors.targetUserPermissionsSelector)(state), isLoggedUser = _targetUserPermission.isLoggedUser, isCaregiver = _targetUserPermission.isCaregiver, isVerifiedDependent = _targetUserPermission.isVerifiedDependent;
	          loggedUser = (0, _selectors.loggedUserSelector)(state);
	          targetUser = (0, _selectors.targetUserSelector)(state);
	          isCaregiverLeaveRole = isCaregiver && !isVerifiedDependent && loggedUser.id === memberId;
	          isCaregiverRemoveRole = isCaregiver && loggedUser.id !== memberId || isVerifiedDependent;
	          _context12.next = 11;
	          return (0, _effects.take)(_removeCaregiver.consts.SUCCEED);
	
	        case 11:
	          if (!isLoggedUser) {
	            _context12.next = 16;
	            break;
	          }
	
	          _context12.next = 14;
	          return (0, _effects.fork)(patientRemoveCaregiverRole, memberId);
	
	        case 14:
	          _context12.next = 24;
	          break;
	
	        case 16:
	          if (!isCaregiverLeaveRole) {
	            _context12.next = 21;
	            break;
	          }
	
	          _context12.next = 19;
	          return (0, _effects.fork)(leaveCaregiverRole, targetUser);
	
	        case 19:
	          _context12.next = 24;
	          break;
	
	        case 21:
	          if (!isCaregiverRemoveRole) {
	            _context12.next = 24;
	            break;
	          }
	
	          _context12.next = 24;
	          return (0, _effects.fork)(caregiverRemoveCaregiverRole, userId, memberId);
	
	        case 24:
	        case 'end':
	          return _context12.stop();
	      }
	    }
	  }, _marked12, this);
	}
	
	/** ************************************************************************** * */
	
	/** ***************************** WATCHERS *********************************** * */
	/** ************************************************************************** * */
	
	function watchAcceptCaregiverRole() {
	  return _regenerator2.default.wrap(function watchAcceptCaregiverRole$(_context13) {
	    while (1) {
	      switch (_context13.prev = _context13.next) {
	        case 0:
	          _context13.next = 2;
	          return (0, _effects.takeEvery)(_acceptCaregiverRole.consts.SEND, acceptCaregiverRole);
	
	        case 2:
	        case 'end':
	          return _context13.stop();
	      }
	    }
	  }, _marked13, this);
	}
	
	function watchDeclineCaregiverRole() {
	  return _regenerator2.default.wrap(function watchDeclineCaregiverRole$(_context14) {
	    while (1) {
	      switch (_context14.prev = _context14.next) {
	        case 0:
	          _context14.next = 2;
	          return (0, _effects.takeEvery)(_declineCaregiverRole.consts.SEND, declineCaregiverRole);
	
	        case 2:
	        case 'end':
	          return _context14.stop();
	      }
	    }
	  }, _marked14, this);
	}
	
	function watchRemoveCaregiverRole() {
	  return _regenerator2.default.wrap(function watchRemoveCaregiverRole$(_context15) {
	    while (1) {
	      switch (_context15.prev = _context15.next) {
	        case 0:
	          _context15.next = 2;
	          return (0, _effects.takeEvery)(_removeCaregiver.consts.SEND, removeCaregiverRole);
	
	        case 2:
	        case 'end':
	          return _context15.stop();
	      }
	    }
	  }, _marked15, this);
	}
	
	function watchAccceptFamilyInvite() {
	  return _regenerator2.default.wrap(function watchAccceptFamilyInvite$(_context16) {
	    while (1) {
	      switch (_context16.prev = _context16.next) {
	        case 0:
	          _context16.next = 2;
	          return (0, _effects.takeEvery)(_acceptInviteToFamilyCircle.consts.SEND, acceptFamilyInvite);
	
	        case 2:
	        case 'end':
	          return _context16.stop();
	      }
	    }
	  }, _marked16, this);
	}
	
	function watchDeclineFamilyInvite() {
	  return _regenerator2.default.wrap(function watchDeclineFamilyInvite$(_context17) {
	    while (1) {
	      switch (_context17.prev = _context17.next) {
	        case 0:
	          _context17.next = 2;
	          return (0, _effects.takeEvery)(_declineInviteToFamilyCircle.consts.SEND, declineFamilyInvite);
	
	        case 2:
	        case 'end':
	          return _context17.stop();
	      }
	    }
	  }, _marked17, this);
	}
	
	function watchRemoveAnotherGuardian() {
	  return _regenerator2.default.wrap(function watchRemoveAnotherGuardian$(_context18) {
	    while (1) {
	      switch (_context18.prev = _context18.next) {
	        case 0:
	          _context18.next = 2;
	          return (0, _effects.takeEvery)(_removeGuardianRole.consts.SEND, guardianRemovesGuardianRole);
	
	        case 2:
	        case 'end':
	          return _context18.stop();
	      }
	    }
	  }, _marked18, this);
	}
	
	function watchAcceptGuardianRole() {
	  return _regenerator2.default.wrap(function watchAcceptGuardianRole$(_context19) {
	    while (1) {
	      switch (_context19.prev = _context19.next) {
	        case 0:
	          _context19.next = 2;
	          return (0, _effects.takeEvery)(_acceptGuardianRole.consts.SEND, acceptGuardianRole);
	
	        case 2:
	        case 'end':
	          return _context19.stop();
	      }
	    }
	  }, _marked19, this);
	}
	
	function watchDeclineGuardianRole() {
	  return _regenerator2.default.wrap(function watchDeclineGuardianRole$(_context20) {
	    while (1) {
	      switch (_context20.prev = _context20.next) {
	        case 0:
	          _context20.next = 2;
	          return (0, _effects.takeEvery)(_declineGuardianRole.consts.SEND, declineGuardianRole);
	
	        case 2:
	        case 'end':
	          return _context20.stop();
	      }
	    }
	  }, _marked20, this);
	}
	
	/** *************************** Pending invitations ************************** * */
	
	/*
	 * There's strange bug now with mocked invitationId data:
	 * when user invites someone to be a familyMember/caregiver
	 * and immediately cancels invitation - an error occured
	 * (as there's no such invitationId in the system), and after that
	 * when user cancels another invitation (valid one) -
	 * errored cancelation behaves on UI as it's cancelled successfully
	 * (but it's not as inviteId was incorrect), and after page refresh
	 * errored cancelation apper on UI as not canceled. ^_^
	 */
	
	/** ***************************** My family Circle *************************** * */
	
	/* Add new pending invitation */
	
	function addPendingWorker(action) {
	  var succeedAction;
	  return _regenerator2.default.wrap(function addPendingWorker$(_context21) {
	    while (1) {
	      switch (_context21.prev = _context21.next) {
	        case 0:
	          _context21.prev = 0;
	          _context21.next = 3;
	          return (0, _effects.take)(_inviteToFamilyCircle.consts.SUCCEED);
	
	        case 3:
	          succeedAction = _context21.sent;
	
	          if (action.payload.isCaregiver) {
	            _context21.next = 7;
	            break;
	          }
	
	          _context21.next = 7;
	          return (0, _effects.put)({
	            type: _myFamilyCircle.consts.ADD_INVITATION,
	            payload: succeedAction.payload
	          });
	
	        case 7:
	          _context21.next = 12;
	          break;
	
	        case 9:
	          _context21.prev = 9;
	          _context21.t0 = _context21['catch'](0);
	
	          console.error('Error add family member invitation', _context21.t0);
	
	        case 12:
	        case 'end':
	          return _context21.stop();
	      }
	    }
	  }, _marked21, this, [[0, 9]]);
	}
	
	function addPendingSaga() {
	  return _regenerator2.default.wrap(function addPendingSaga$(_context22) {
	    while (1) {
	      switch (_context22.prev = _context22.next) {
	        case 0:
	          _context22.next = 2;
	          return (0, _effects.takeEvery)(_inviteToFamilyCircle.consts.SEND, addPendingWorker);
	
	        case 2:
	        case 'end':
	          return _context22.stop();
	      }
	    }
	  }, _marked22, this);
	}
	
	/* Clear requests whether we clear form in progress */
	function clearFormInProgressWorker() {
	  return _regenerator2.default.wrap(function clearFormInProgressWorker$(_context23) {
	    while (1) {
	      switch (_context23.prev = _context23.next) {
	        case 0:
	          _context23.next = 2;
	          return (0, _effects.put)({ type: _inviteToFamilyCircle.consts.CLEAR });
	
	        case 2:
	        case 'end':
	          return _context23.stop();
	      }
	    }
	  }, _marked23, this);
	}
	
	function clearFormInProgressSaga() {
	  return _regenerator2.default.wrap(function clearFormInProgressSaga$(_context24) {
	    while (1) {
	      switch (_context24.prev = _context24.next) {
	        case 0:
	          _context24.next = 2;
	          return (0, _effects.takeEvery)(_formInProgress.consts.DELETE, clearFormInProgressWorker);
	
	        case 2:
	        case 'end':
	          return _context24.stop();
	      }
	    }
	  }, _marked24, this);
	}
	
	/* Remove pending invitation */
	
	function removePendingWorker(action) {
	  return _regenerator2.default.wrap(function removePendingWorker$(_context25) {
	    while (1) {
	      switch (_context25.prev = _context25.next) {
	        case 0:
	          _context25.prev = 0;
	          _context25.next = 3;
	          return (0, _effects.take)(_cancelFamilyMemberInvitation.consts.SUCCEED);
	
	        case 3:
	          _context25.next = 5;
	          return (0, _effects.put)({
	            type: _myFamilyCircle.consts.REMOVE_INVITATION,
	            payload: action.payload
	          });
	
	        case 5:
	          _context25.next = 10;
	          break;
	
	        case 7:
	          _context25.prev = 7;
	          _context25.t0 = _context25['catch'](0);
	
	          console.error('Error remove family member invitation', _context25.t0);
	
	        case 10:
	        case 'end':
	          return _context25.stop();
	      }
	    }
	  }, _marked25, this, [[0, 7]]);
	}
	
	function removePendingSaga() {
	  return _regenerator2.default.wrap(function removePendingSaga$(_context26) {
	    while (1) {
	      switch (_context26.prev = _context26.next) {
	        case 0:
	          _context26.next = 2;
	          return (0, _effects.takeEvery)(_cancelFamilyMemberInvitation.consts.SEND, removePendingWorker);
	
	        case 2:
	        case 'end':
	          return _context26.stop();
	      }
	    }
	  }, _marked26, this);
	}
	
	/* Add new pending caregiver invitation */
	
	function addPendingCaregiverWorker(action) {
	  var successAction;
	  return _regenerator2.default.wrap(function addPendingCaregiverWorker$(_context27) {
	    while (1) {
	      switch (_context27.prev = _context27.next) {
	        case 0:
	          _context27.prev = 0;
	          _context27.next = 3;
	          return (0, _effects.take)(_inviteCaregiver.consts.SUCCEED);
	
	        case 3:
	          successAction = _context27.sent;
	          _context27.next = 6;
	          return (0, _effects.put)({
	            type: _myFamilyCircle.consts.ADD_CAREGIVER_INVITATION,
	            payload: successAction.payload
	          });
	
	        case 6:
	          _context27.next = 11;
	          break;
	
	        case 8:
	          _context27.prev = 8;
	          _context27.t0 = _context27['catch'](0);
	
	          console.error('Error add caregiver invitation', _context27.t0);
	
	        case 11:
	        case 'end':
	          return _context27.stop();
	      }
	    }
	  }, _marked27, this, [[0, 8]]);
	}
	
	function addPendingCaregiverSaga() {
	  return _regenerator2.default.wrap(function addPendingCaregiverSaga$(_context28) {
	    while (1) {
	      switch (_context28.prev = _context28.next) {
	        case 0:
	          _context28.next = 2;
	          return (0, _effects.takeEvery)(_inviteCaregiver.consts.SEND, addPendingCaregiverWorker);
	
	        case 2:
	        case 'end':
	          return _context28.stop();
	      }
	    }
	  }, _marked28, this);
	}
	
	/* Remove caregiver invitation */
	
	function removePendingCaregiverWorker(action) {
	  return _regenerator2.default.wrap(function removePendingCaregiverWorker$(_context29) {
	    while (1) {
	      switch (_context29.prev = _context29.next) {
	        case 0:
	          _context29.prev = 0;
	          _context29.next = 3;
	          return (0, _effects.take)(_cancelCaregiverInvitation.consts.SUCCEED);
	
	        case 3:
	          _context29.next = 5;
	          return (0, _effects.put)({
	            type: _myFamilyCircle.consts.REMOVE_CAREGIVER_INVITATION,
	            payload: action.payload
	          });
	
	        case 5:
	          _context29.next = 10;
	          break;
	
	        case 7:
	          _context29.prev = 7;
	          _context29.t0 = _context29['catch'](0);
	
	          console.error('Error remove caregiver invitation', _context29.t0);
	
	        case 10:
	        case 'end':
	          return _context29.stop();
	      }
	    }
	  }, _marked29, this, [[0, 7]]);
	}
	
	function removePendingCaregiverSaga() {
	  return _regenerator2.default.wrap(function removePendingCaregiverSaga$(_context30) {
	    while (1) {
	      switch (_context30.prev = _context30.next) {
	        case 0:
	          _context30.next = 2;
	          return (0, _effects.takeEvery)(_cancelCaregiverInvitation.consts.SEND, removePendingCaregiverWorker);
	
	        case 2:
	        case 'end':
	          return _context30.stop();
	      }
	    }
	  }, _marked30, this);
	}
	
	/** ***************************** Caregiver Circle *************************** * */
	
	/* Add new pending invitation */
	
	function caregiverAddPendingWorker(action) {
	  var succeedAction;
	  return _regenerator2.default.wrap(function caregiverAddPendingWorker$(_context31) {
	    while (1) {
	      switch (_context31.prev = _context31.next) {
	        case 0:
	          _context31.prev = 0;
	          _context31.next = 3;
	          return (0, _effects.take)(_inviteToFamilyCircle.consts.SUCCEED);
	
	        case 3:
	          succeedAction = _context31.sent;
	
	          if (!action.payload.isCaregiver) {
	            _context31.next = 9;
	            break;
	          }
	
	          _context31.next = 7;
	          return (0, _effects.put)({
	            type: _caregiver.consts.ADD_INVITATION,
	            payload: (0, _assign2.default)(action.payload, succeedAction.payload)
	          });
	
	        case 7:
	          _context31.next = 11;
	          break;
	
	        case 9:
	          _context31.next = 11;
	          return (0, _effects.put)({
	            type: _getGuardianCircle.consts.ADD_INVITATION,
	            payload: (0, _assign2.default)(action.payload, succeedAction.payload)
	          });
	
	        case 11:
	          _context31.next = 16;
	          break;
	
	        case 13:
	          _context31.prev = 13;
	          _context31.t0 = _context31['catch'](0);
	
	          console.error('Error add family member invitation', _context31.t0);
	
	        case 16:
	        case 'end':
	          return _context31.stop();
	      }
	    }
	  }, _marked31, this, [[0, 13]]);
	}
	
	function caregiverAddPendingSaga() {
	  return _regenerator2.default.wrap(function caregiverAddPendingSaga$(_context32) {
	    while (1) {
	      switch (_context32.prev = _context32.next) {
	        case 0:
	          _context32.next = 2;
	          return (0, _effects.takeEvery)(_inviteToFamilyCircle.consts.SEND, caregiverAddPendingWorker);
	
	        case 2:
	        case 'end':
	          return _context32.stop();
	      }
	    }
	  }, _marked32, this);
	}
	
	// /* Remove pending invitation */
	
	function caregiverRemovePendingWorker(action) {
	  return _regenerator2.default.wrap(function caregiverRemovePendingWorker$(_context33) {
	    while (1) {
	      switch (_context33.prev = _context33.next) {
	        case 0:
	          _context33.prev = 0;
	          _context33.next = 3;
	          return (0, _effects.take)(_cancelFamilyMemberInvitation.consts.SUCCEED);
	
	        case 3:
	          _context33.next = 5;
	          return (0, _effects.put)({
	            type: _caregiver.consts.REMOVE_INVITATION,
	            payload: action.payload
	          });
	
	        case 5:
	          _context33.next = 7;
	          return (0, _effects.put)({
	            type: _getGuardianCircle.consts.REMOVE_INVITATION,
	            payload: action.payload
	          });
	
	        case 7:
	          _context33.next = 12;
	          break;
	
	        case 9:
	          _context33.prev = 9;
	          _context33.t0 = _context33['catch'](0);
	
	          console.error('Error remove family member invitation', _context33.t0);
	
	        case 12:
	        case 'end':
	          return _context33.stop();
	      }
	    }
	  }, _marked33, this, [[0, 9]]);
	}
	
	function caregiverRemovePendingSaga() {
	  return _regenerator2.default.wrap(function caregiverRemovePendingSaga$(_context34) {
	    while (1) {
	      switch (_context34.prev = _context34.next) {
	        case 0:
	          _context34.next = 2;
	          return (0, _effects.takeEvery)(_cancelFamilyMemberInvitation.consts.SEND, caregiverRemovePendingWorker);
	
	        case 2:
	        case 'end':
	          return _context34.stop();
	      }
	    }
	  }, _marked34, this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context35) {
	    while (1) {
	      switch (_context35.prev = _context35.next) {
	        case 0:
	          _context35.next = 2;
	          return (0, _effects.fork)(watchAcceptCaregiverRole);
	
	        case 2:
	          _context35.next = 4;
	          return (0, _effects.fork)(watchDeclineCaregiverRole);
	
	        case 4:
	          _context35.next = 6;
	          return (0, _effects.fork)(watchAccceptFamilyInvite);
	
	        case 6:
	          _context35.next = 8;
	          return (0, _effects.fork)(watchRemoveCaregiverRole);
	
	        case 8:
	          _context35.next = 10;
	          return (0, _effects.fork)(watchDeclineFamilyInvite);
	
	        case 10:
	          _context35.next = 12;
	          return (0, _effects.fork)(addPendingSaga);
	
	        case 12:
	          _context35.next = 14;
	          return (0, _effects.fork)(removePendingSaga);
	
	        case 14:
	          _context35.next = 16;
	          return (0, _effects.fork)(addPendingCaregiverSaga);
	
	        case 16:
	          _context35.next = 18;
	          return (0, _effects.fork)(removePendingCaregiverSaga);
	
	        case 18:
	          _context35.next = 20;
	          return (0, _effects.fork)(caregiverAddPendingSaga);
	
	        case 20:
	          _context35.next = 22;
	          return (0, _effects.fork)(caregiverRemovePendingSaga);
	
	        case 22:
	          _context35.next = 24;
	          return (0, _effects.fork)(clearFormInProgressSaga);
	
	        case 24:
	          _context35.next = 26;
	          return (0, _effects.fork)(watchRemoveAnotherGuardian);
	
	        case 26:
	          _context35.next = 28;
	          return (0, _effects.fork)(watchAcceptGuardianRole);
	
	        case 28:
	          _context35.next = 30;
	          return (0, _effects.fork)(watchDeclineGuardianRole);
	
	        case 30:
	        case 'end':
	          return _context35.stop();
	      }
	    }
	  }, _marked35, this);
	}

/***/ }),
/* 3999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _caregiver = __webpack_require__(297);
	
	var _caregiver2 = _interopRequireDefault(_caregiver);
	
	var _memberFamilyCircle = __webpack_require__(647);
	
	var _memberFamilyCircle2 = _interopRequireDefault(_memberFamilyCircle);
	
	var _myFamilyCircle = __webpack_require__(514);
	
	var _myFamilyCircle2 = _interopRequireDefault(_myFamilyCircle);
	
	var _leaveFamilyCircle = __webpack_require__(298);
	
	var _leaveFamilyCircle2 = _interopRequireDefault(_leaveFamilyCircle);
	
	var _inviteToFamilyCircle = __webpack_require__(412);
	
	var _inviteToFamilyCircle2 = _interopRequireDefault(_inviteToFamilyCircle);
	
	var _acceptInviteToFamilyCircle = __webpack_require__(408);
	
	var _acceptInviteToFamilyCircle2 = _interopRequireDefault(_acceptInviteToFamilyCircle);
	
	var _declineInviteToFamilyCircle = __webpack_require__(411);
	
	var _declineInviteToFamilyCircle2 = _interopRequireDefault(_declineInviteToFamilyCircle);
	
	var _inviteCaregiver = __webpack_require__(513);
	
	var _inviteCaregiver2 = _interopRequireDefault(_inviteCaregiver);
	
	var _removeCaregiver = __webpack_require__(649);
	
	var _removeCaregiver2 = _interopRequireDefault(_removeCaregiver);
	
	var _acceptCaregiverRole = __webpack_require__(407);
	
	var _acceptCaregiverRole2 = _interopRequireDefault(_acceptCaregiverRole);
	
	var _declineCaregiverRole = __webpack_require__(410);
	
	var _declineCaregiverRole2 = _interopRequireDefault(_declineCaregiverRole);
	
	var _acceptGuardianRole = __webpack_require__(406);
	
	var _acceptGuardianRole2 = _interopRequireDefault(_acceptGuardianRole);
	
	var _declineGuardianRole = __webpack_require__(409);
	
	var _declineGuardianRole2 = _interopRequireDefault(_declineGuardianRole);
	
	var _cancelFamilyMemberInvitation = __webpack_require__(511);
	
	var _cancelFamilyMemberInvitation2 = _interopRequireDefault(_cancelFamilyMemberInvitation);
	
	var _cancelCaregiverInvitation = __webpack_require__(510);
	
	var _cancelCaregiverInvitation2 = _interopRequireDefault(_cancelCaregiverInvitation);
	
	var _cancelGuardianInvitationReq = __webpack_require__(816);
	
	var _cancelGuardianInvitationReq2 = _interopRequireDefault(_cancelGuardianInvitationReq);
	
	var _inviteCaregiverFamily = __webpack_require__(646);
	
	var _inviteCaregiverFamily2 = _interopRequireDefault(_inviteCaregiverFamily);
	
	var _getGuardianCircle = __webpack_require__(644);
	
	var _getGuardianCircle2 = _interopRequireDefault(_getGuardianCircle);
	
	var _inviteGuardian = __webpack_require__(645);
	
	var _inviteGuardian2 = _interopRequireDefault(_inviteGuardian);
	
	var _removeGuardianRole = __webpack_require__(648);
	
	var _removeGuardianRole2 = _interopRequireDefault(_removeGuardianRole);
	
	var _changeMemberRoleReq = __webpack_require__(817);
	
	var _changeMemberRoleReq2 = _interopRequireDefault(_changeMemberRoleReq);
	
	var _removeAssignedProvider = __webpack_require__(515);
	
	var _removeAssignedProvider2 = _interopRequireDefault(_removeAssignedProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  caregiver: _caregiver2.default,
	  memberFamilyCircle: _memberFamilyCircle2.default,
	  myFamilyCircle: _myFamilyCircle2.default,
	  inviteToFamilyCircle: _inviteToFamilyCircle2.default,
	  leaveFamilyCircle: _leaveFamilyCircle2.default,
	  acceptInviteToFamilyCircle: _acceptInviteToFamilyCircle2.default,
	  declineInviteToFamilyCircle: _declineInviteToFamilyCircle2.default,
	  inviteCaregiver: _inviteCaregiver2.default,
	  removeCaregiver: _removeCaregiver2.default,
	  acceptCaregiverRole: _acceptCaregiverRole2.default,
	  declineCaregiverRole: _declineCaregiverRole2.default,
	  cancelFamilyMemberInvitation: _cancelFamilyMemberInvitation2.default,
	  cancelCaregiverInvitation: _cancelCaregiverInvitation2.default,
	  cancelGuardianInvitation: _cancelGuardianInvitationReq2.default,
	  inviteCaregiverFamily: _inviteCaregiverFamily2.default,
	  guardianCircle: _getGuardianCircle2.default,
	  inviteGuardian: _inviteGuardian2.default,
	  removeGuardianRole: _removeGuardianRole2.default,
	  acceptGuardianRole: _acceptGuardianRole2.default,
	  declineGuardianRole: _declineGuardianRole2.default,
	  changeMemberRole: _changeMemberRoleReq2.default,
	  removeAssignedProvider: _removeAssignedProvider2.default
	}); // current user circles

/***/ }),
/* 4000 */,
/* 4001 */,
/* 4002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _changeMemberRoleReq = __webpack_require__(817);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_changeMemberRoleReq.watcher);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = cancelPendingInvitationSaga;
	
	var _effects = __webpack_require__(14);
	
	var _cancelFamilyMemberInvitation = __webpack_require__(511);
	
	var cancelFamilyMemberInvitation = _interopRequireWildcard(_cancelFamilyMemberInvitation);
	
	var _cancelCaregiverInvitation = __webpack_require__(510);
	
	var cancelCaregiverInvitation = _interopRequireWildcard(_cancelCaregiverInvitation);
	
	var _cancelGuardianInvitationReq = __webpack_require__(816);
	
	var cancelGuardianInvitation = _interopRequireWildcard(_cancelGuardianInvitationReq);
	
	var _circleOfCare = __webpack_require__(635);
	
	var circleOfCare = _interopRequireWildcard(_circleOfCare);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(cancelPendingInvitationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(cancelPendingInvitationSaga);
	
	function cancelPendingInvitationWorker(action) {
	  var _ref, successCancelFamilyMemberInvite, successCancelCaregiverInvite, successCancelGuardianInvite, isInvitationSucceed;
	
	  return _regenerator2.default.wrap(function cancelPendingInvitationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.race)({
	            successCancelFamilyMemberInvite: (0, _effects.take)(cancelFamilyMemberInvitation.consts.SUCCEED),
	            successCancelCaregiverInvite: (0, _effects.take)(cancelCaregiverInvitation.consts.SUCCEED),
	            successCancelGuardianInvite: (0, _effects.take)(cancelGuardianInvitation.consts.SUCCEED)
	          });
	
	        case 2:
	          _ref = _context.sent;
	          successCancelFamilyMemberInvite = _ref.successCancelFamilyMemberInvite;
	          successCancelCaregiverInvite = _ref.successCancelCaregiverInvite;
	          successCancelGuardianInvite = _ref.successCancelGuardianInvite;
	          isInvitationSucceed = successCancelFamilyMemberInvite || successCancelCaregiverInvite || successCancelGuardianInvite;
	
	          if (!isInvitationSucceed) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.put)(circleOfCare.actions.removeInvitation(action.payload));
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function cancelPendingInvitationSaga() {
	  return _regenerator2.default.wrap(function cancelPendingInvitationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([cancelFamilyMemberInvitation.consts.SEND, cancelCaregiverInvitation.consts.SEND, cancelGuardianInvitation.consts.SEND], cancelPendingInvitationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = circleOfCareActionsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(23);
	
	var _constants = __webpack_require__(512);
	
	var _changeMemberRoleReq = __webpack_require__(817);
	
	var changeMemberRoleReq = _interopRequireWildcard(_changeMemberRoleReq);
	
	var _reqCircleOfCare = __webpack_require__(404);
	
	var reqCircleOfCare = _interopRequireWildcard(_reqCircleOfCare);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(changeRoleWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(circleOfCareActionsSaga);
	
	function changeRoleWorker(_ref) {
	  var payload = _ref.payload;
	  var memberId, role, userId;
	  return _regenerator2.default.wrap(function changeRoleWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          memberId = payload.memberId, role = payload.role;
	          _context.next = 3;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 3:
	          userId = _context.sent;
	          _context.next = 6;
	          return (0, _effects.put)(changeMemberRoleReq.actions.send({
	            memberId: memberId,
	            userId: userId,
	            role: role
	          }));
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.take)(changeMemberRoleReq.consts.SUCCEED);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)(reqCircleOfCare.actions.send({ id: userId }));
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'circles.invites.roleChanged' }
	          });
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function circleOfCareActionsSaga() {
	  return _regenerator2.default.wrap(function circleOfCareActionsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_constants.CIRCLE_ACTION_TYPES.CHANGE_ROLE, changeRoleWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _removeMemberSaga = __webpack_require__(4007);
	
	var _removeMemberSaga2 = _interopRequireDefault(_removeMemberSaga);
	
	var _inviteToFamilyCircleSaga = __webpack_require__(4006);
	
	var _inviteToFamilyCircleSaga2 = _interopRequireDefault(_inviteToFamilyCircleSaga);
	
	var _changeRoleSaga = __webpack_require__(4004);
	
	var _changeRoleSaga2 = _interopRequireDefault(_changeRoleSaga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_inviteToFamilyCircleSaga2.default);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(_changeRoleSaga2.default);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(_removeMemberSaga2.default);
	
	        case 6:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = circleOfCareActionsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _includes = __webpack_require__(324);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _constants = __webpack_require__(512);
	
	var _props = __webpack_require__(41);
	
	var _inviteGuardian = __webpack_require__(645);
	
	var inviteGuardian = _interopRequireWildcard(_inviteGuardian);
	
	var _inviteCaregiver = __webpack_require__(513);
	
	var inviteCaregiver = _interopRequireWildcard(_inviteCaregiver);
	
	var _inviteToFamilyCircle = __webpack_require__(412);
	
	var inviteToFamilyCircle = _interopRequireWildcard(_inviteToFamilyCircle);
	
	var _circleOfCare = __webpack_require__(635);
	
	var circleOfCare = _interopRequireWildcard(_circleOfCare);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	var _selectors = __webpack_require__(23);
	
	var _errors = __webpack_require__(120);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(inviteToFamilyWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(inviteToFamilyRejectedWorker),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(inviteToFamilySucceedWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(inviteToFamilyCircleWorker),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(circleOfCareActionsSaga);
	
	var checkErrorCode = function checkErrorCode(payload) {
	  return (0, _get2.default)(payload, 'error.meta.validationErrors.login[0].code') === _errors.ERROR_CODES.ALREADY_ASSIGNED;
	};
	
	function inviteToFamilyWorker(_ref) {
	  var payload = _ref.payload;
	  var userId, role, data;
	  return _regenerator2.default.wrap(function inviteToFamilyWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 2:
	          userId = _context.sent;
	          role = (0, _get2.default)(payload, 'role');
	          data = {
	            id: userId,
	            terms_and_conditions_accepted: 'true',
	            care_role: role,
	            role: (0, _get2.default)(payload, 'relationship'),
	            login: (0, _get2.default)(payload, 'emailOrPhone')
	          };
	
	          // invite to family circle with GUARDIAN/PARENT/PROXY role
	
	          if (!(0, _includes2.default)([_props.CARE_ROLE.GUARDIAN, _props.CARE_ROLE.PARENT, _props.CARE_ROLE.PROXY], role)) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 8;
	          return (0, _effects.put)(inviteGuardian.actions.send(data));
	
	        case 8:
	          return _context.abrupt('return');
	
	        case 9:
	          if (!(role === _props.CARE_ROLE.CAREGIVER)) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 12;
	          return (0, _effects.put)(inviteCaregiver.actions.send(data));
	
	        case 12:
	          return _context.abrupt('return');
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)(inviteToFamilyCircle.actions.send(data));
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function inviteToFamilyRejectedWorker(_ref2) {
	  var payload = _ref2.payload;
	  return _regenerator2.default.wrap(function inviteToFamilyRejectedWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)(inviteToFamilyCircle.actions.rejected(payload));
	
	        case 2:
	          if (!checkErrorCode(payload)) {
	            _context2.next = 5;
	            break;
	          }
	
	          _context2.next = 5;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'circles.invites.cares.error' }
	          });
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function inviteToFamilySucceedWorker(_ref3) {
	  var payload = _ref3.payload;
	  return _regenerator2.default.wrap(function inviteToFamilySucceedWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)(inviteToFamilyCircle.actions.succeed(payload));
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'circles.invites.common.success' }
	          });
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function inviteToFamilyCircleWorker(_ref4) {
	  var type = _ref4.type,
	      payload = _ref4.payload;
	  return _regenerator2.default.wrap(function inviteToFamilyCircleWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (!(type === inviteToFamilyCircle.consts.REJECTED)) {
	            _context4.next = 6;
	            break;
	          }
	
	          if (!checkErrorCode(payload)) {
	            _context4.next = 5;
	            break;
	          }
	
	          _context4.next = 4;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'circles.invites.cares.error' }
	          });
	
	        case 4:
	          return _context4.abrupt('return');
	
	        case 5:
	          return _context4.abrupt('return');
	
	        case 6:
	          _context4.next = 8;
	          return (0, _effects.put)(circleOfCare.actions.addPendingItem(payload));
	
	        case 8:
	          _context4.next = 10;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'circles.invites.common.success' }
	          });
	
	        case 10:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function circleOfCareActionsSaga() {
	  return _regenerator2.default.wrap(function circleOfCareActionsSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)(_constants.CIRCLE_ACTION_TYPES.INVITE_TO_FAMILY_CIRCLE, inviteToFamilyWorker);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.takeEvery)([inviteGuardian.consts.REJECTED, inviteCaregiver.consts.REJECTED], inviteToFamilyRejectedWorker);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.takeEvery)([inviteGuardian.consts.SUCCEED, inviteCaregiver.consts.SUCCEED], inviteToFamilySucceedWorker);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.takeEvery)([inviteToFamilyCircle.consts.SUCCEED, inviteToFamilyCircle.consts.REJECTED], inviteToFamilyCircleWorker);
	
	        case 8:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 4007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = circleOfCareActionsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(23);
	
	var _constants = __webpack_require__(512);
	
	var _leaveFamilyCircle = __webpack_require__(298);
	
	var leaveFamilyCircle = _interopRequireWildcard(_leaveFamilyCircle);
	
	var _circleOfCare = __webpack_require__(635);
	
	var circleOfCare = _interopRequireWildcard(_circleOfCare);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(removeMemberWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(circleOfCareActionsSaga);
	
	function removeMemberWorker(_ref) {
	  var payload = _ref.payload;
	  var userId;
	  return _regenerator2.default.wrap(function removeMemberWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 2:
	          userId = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)(leaveFamilyCircle.actions.send({
	            memberId: payload,
	            userId: userId
	          }));
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.take)(leaveFamilyCircle.consts.SUCCEED);
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)(circleOfCare.actions.removeFamilyCircleItem(payload));
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'circles.family.remove' }
	          });
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function circleOfCareActionsSaga() {
	  return _regenerator2.default.wrap(function circleOfCareActionsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_constants.CIRCLE_ACTION_TYPES.REMOVE_MEMBER, removeMemberWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4008 */,
/* 4009 */,
/* 4010 */,
/* 4011 */,
/* 4012 */,
/* 4013 */,
/* 4014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _urlPreview = __webpack_require__(413);
	
	var _urlPreview2 = _interopRequireDefault(_urlPreview);
	
	var _locations = __webpack_require__(4015);
	
	var _locations2 = _interopRequireDefault(_locations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  urlPreview: _urlPreview2.default,
	  locations: _locations2.default
	});

/***/ }),
/* 4015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _redux = __webpack_require__(7);
	
	var _locationReducer = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var consts = exports.consts = (0, _redux.createConsts)('common', 'locations');
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  previousLocation: null,
	  currentLocation: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _locationReducer.LOCATION_CHANGE:
	      return (0, _extends3.default)({}, state, {
	        previousLocation: state.currentLocation,
	        currentLocation: action.payload.pathname
	      });
	    default:
	      return state;
	  }
	};

/***/ }),
/* 4016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = locationsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _locationReducer = __webpack_require__(240);
	
	var _routes = __webpack_require__(37);
	
	var _storageKeys = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(locationsSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(locationsSaga);
	
	function locationsSagaWorker(action) {
	  var pathname, hasCommunity, hasCommunityPrev, hasLogin, communityId;
	  return _regenerator2.default.wrap(function locationsSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          pathname = (0, _lodash.get)(action, 'payload.pathname');
	          hasCommunity = pathname.includes(_routes.COMMUNITIES);
	          hasCommunityPrev = pathname.includes(_routes.COMMUNITY_PREVIEW);
	          hasLogin = pathname.includes(_routes.LOGIN);
	
	          if (!(hasCommunity || hasCommunityPrev)) {
	            _context.next = 10;
	            break;
	          }
	
	          communityId = pathname.replace(/\D/g, '');
	
	          if (!communityId) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 9;
	          return window.storage.setItem(_storageKeys.ACTIVE_COMMUNITY_ID, communityId);
	
	        case 9:
	          return _context.abrupt('return');
	
	        case 10:
	          if (!hasLogin) {
	            _context.next = 12;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 12:
	          _context.next = 14;
	          return window.storage.removeItem(_storageKeys.ACTIVE_COMMUNITY_ID);
	
	        case 14:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function locationsSaga() {
	  return _regenerator2.default.wrap(function locationsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_locationReducer.LOCATION_CHANGE, locationsSagaWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.getCommentsSaga = getCommentsSaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _commentsListFetch = __webpack_require__(1257);
	
	var _commentsList = __webpack_require__(299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(getCommentsWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getCommentsSaga);
	
	function getCommentsWorker(action) {
	  var COMMENTS_PER_PAGE, state, postId, limit, offset, responseAction, response;
	  return _regenerator2.default.wrap(function getCommentsWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          COMMENTS_PER_PAGE = 10;
	          _context.next = 3;
	          return (0, _effects.select)();
	
	        case 3:
	          state = _context.sent;
	          postId = +(0, _get2.default)(action.payload, 'postId');
	          limit = COMMENTS_PER_PAGE;
	          offset = 0;
	          responseAction = _commentsList.consts.LOAD_COMMENTS;
	
	          // eslint-disable-next-line default-case
	
	          _context.t0 = action.type;
	          _context.next = _context.t0 === _commentsListFetch.consts.GET_NEW_COMMENTS ? 11 : _context.t0 === _commentsListFetch.consts.GET_OLDER_COMMENTS ? 14 : 17;
	          break;
	
	        case 11:
	          limit = (0, _get2.default)(action.payload, 'limit');
	          responseAction = _commentsList.consts.LOAD_NEW_COMMENTS;
	          return _context.abrupt('break', 17);
	
	        case 14:
	          offset = (0, _get2.default)(state, 'communities.commentsList.length');
	          responseAction = _commentsList.consts.LOAD_OLDER_COMMENTS;
	          return _context.abrupt('break', 17);
	
	        case 17:
	          _context.next = 19;
	          return (0, _effects.put)({
	            type: _commentsListFetch.consts.SEND,
	            payload: { postId: postId, limit: limit, offset: offset }
	          });
	
	        case 19:
	          _context.next = 21;
	          return (0, _effects.take)(_commentsListFetch.consts.SUCCEED);
	
	        case 21:
	          response = _context.sent;
	          _context.next = 24;
	          return (0, _effects.put)({
	            type: responseAction,
	            payload: response.payload
	          });
	
	        case 24:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function getCommentsSaga() {
	  return _regenerator2.default.wrap(function getCommentsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_commentsListFetch.consts.GET_COMMENTS, _commentsListFetch.consts.GET_NEW_COMMENTS, _commentsListFetch.consts.GET_OLDER_COMMENTS], getCommentsWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.currentCommunitySaga = currentCommunitySaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _communityPosts = __webpack_require__(650);
	
	var _currentCommunity = __webpack_require__(824);
	
	var _postsList = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(currentCommunityWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(currentCommunitySaga);
	
	function currentCommunityWorker(action) {
	  var state, currentCommunityId, communityId;
	  return _regenerator2.default.wrap(function currentCommunityWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)();
	
	        case 2:
	          state = _context.sent;
	          currentCommunityId = (0, _get2.default)(state, 'communities.currentCommunity');
	          // next community id
	
	          communityId = parseInt((0, _get2.default)(action, 'payload.communityId'), 10);
	
	          if (!(communityId !== currentCommunityId)) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 8;
	          return (0, _effects.put)({
	            type: _postsList.consts.RESTORE
	          });
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)({
	            type: _currentCommunity.consts.SET,
	            payload: communityId
	          });
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function currentCommunitySaga() {
	  return _regenerator2.default.wrap(function currentCommunitySaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_communityPosts.consts.SEND, currentCommunityWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _userCommunities = __webpack_require__(414);
	
	var _userCommunities2 = _interopRequireDefault(_userCommunities);
	
	var _communityPosts = __webpack_require__(650);
	
	var _communityPosts2 = _interopRequireDefault(_communityPosts);
	
	var _membersList = __webpack_require__(1879);
	
	var _membersList2 = _interopRequireDefault(_membersList);
	
	var _moderatorsList = __webpack_require__(1880);
	
	var _moderatorsList2 = _interopRequireDefault(_moderatorsList);
	
	var _communityMembers = __webpack_require__(516);
	
	var _communityMembers2 = _interopRequireDefault(_communityMembers);
	
	var _communityModerators = __webpack_require__(517);
	
	var _communityModerators2 = _interopRequireDefault(_communityModerators);
	
	var _postsList = __webpack_require__(166);
	
	var _postsList2 = _interopRequireDefault(_postsList);
	
	var _postDetails = __webpack_require__(238);
	
	var _postDetails2 = _interopRequireDefault(_postDetails);
	
	var _createPost = __webpack_require__(823);
	
	var _createPost2 = _interopRequireDefault(_createPost);
	
	var _postsCreated = __webpack_require__(1881);
	
	var _postsCreated2 = _interopRequireDefault(_postsCreated);
	
	var _editPost = __webpack_require__(827);
	
	var _editPost2 = _interopRequireDefault(_editPost);
	
	var _newPostForm = __webpack_require__(652);
	
	var _newPostForm2 = _interopRequireDefault(_newPostForm);
	
	var _currentCommunity = __webpack_require__(824);
	
	var _currentCommunity2 = _interopRequireDefault(_currentCommunity);
	
	var _postComment = __webpack_require__(1264);
	
	var _postComment2 = _interopRequireDefault(_postComment);
	
	var _commentsList = __webpack_require__(299);
	
	var _commentsList2 = _interopRequireDefault(_commentsList);
	
	var _deletePost = __webpack_require__(826);
	
	var _deletePost2 = _interopRequireDefault(_deletePost);
	
	var _likePost = __webpack_require__(1263);
	
	var _likePost2 = _interopRequireDefault(_likePost);
	
	var _dislikePost = __webpack_require__(1260);
	
	var _dislikePost2 = _interopRequireDefault(_dislikePost);
	
	var _reqDiscoverCommunities = __webpack_require__(520);
	
	var _reqDiscoverCommunities2 = _interopRequireDefault(_reqDiscoverCommunities);
	
	var _currentCommunityInfo = __webpack_require__(344);
	
	var _currentCommunityInfo2 = _interopRequireDefault(_currentCommunityInfo);
	
	var _reqJoinCommunity = __webpack_require__(521);
	
	var _reqJoinCommunity2 = _interopRequireDefault(_reqJoinCommunity);
	
	var _communitiesJoinRequests = __webpack_require__(343);
	
	var _communitiesJoinRequests2 = _interopRequireDefault(_communitiesJoinRequests);
	
	var _acceptJoinRequest = __webpack_require__(818);
	
	var _acceptJoinRequest2 = _interopRequireDefault(_acceptJoinRequest);
	
	var _declineJoinRequest = __webpack_require__(825);
	
	var _declineJoinRequest2 = _interopRequireDefault(_declineJoinRequest);
	
	var _getUserProfile = __webpack_require__(828);
	
	var _getUserProfile2 = _interopRequireDefault(_getUserProfile);
	
	var _communityPreview = __webpack_require__(1258);
	
	var _communityPreview2 = _interopRequireDefault(_communityPreview);
	
	var _communityPostsPreview = __webpack_require__(822);
	
	var _communityPostsPreview2 = _interopRequireDefault(_communityPostsPreview);
	
	var _joinPopup = __webpack_require__(519);
	
	var _joinPopup2 = _interopRequireDefault(_joinPopup);
	
	var _reqMemberInvitation = __webpack_require__(654);
	
	var _reqMemberInvitation2 = _interopRequireDefault(_reqMemberInvitation);
	
	var _notificationCounters = __webpack_require__(300);
	
	var _notificationCounters2 = _interopRequireDefault(_notificationCounters);
	
	var _removeNotificationsCounters = __webpack_require__(345);
	
	var _removeNotificationsCounters2 = _interopRequireDefault(_removeNotificationsCounters);
	
	var _usersJoinRequests = __webpack_require__(830);
	
	var _usersJoinRequests2 = _interopRequireDefault(_usersJoinRequests);
	
	var _currentCommunityScrollStatus = __webpack_require__(1259);
	
	var _currentCommunityScrollStatus2 = _interopRequireDefault(_currentCommunityScrollStatus);
	
	var _communityImageUpdate = __webpack_require__(820);
	
	var _communityImageUpdate2 = _interopRequireDefault(_communityImageUpdate);
	
	var _communityImageRemove = __webpack_require__(819);
	
	var _communityImageRemove2 = _interopRequireDefault(_communityImageRemove);
	
	var _leaveCommunity = __webpack_require__(651);
	
	var _leaveCommunity2 = _interopRequireDefault(_leaveCommunity);
	
	var _removeUserCommunity = __webpack_require__(653);
	
	var _removeUserCommunity2 = _interopRequireDefault(_removeUserCommunity);
	
	var _communityInfoUpdate = __webpack_require__(821);
	
	var _communityInfoUpdate2 = _interopRequireDefault(_communityInfoUpdate);
	
	var _invitationUserSearch = __webpack_require__(1261);
	
	var _invitationUserSearch2 = _interopRequireDefault(_invitationUserSearch);
	
	var _invitationUserToCommunity = __webpack_require__(1262);
	
	var _invitationUserToCommunity2 = _interopRequireDefault(_invitationUserToCommunity);
	
	var _acceptInvitation = __webpack_require__(342);
	
	var _acceptInvitation2 = _interopRequireDefault(_acceptInvitation);
	
	var _declineInvitation = __webpack_require__(518);
	
	var _declineInvitation2 = _interopRequireDefault(_declineInvitation);
	
	var _activities = __webpack_require__(1256);
	
	var _activities2 = _interopRequireDefault(_activities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  removeUserCommunity: _removeUserCommunity2.default,
	  leaveCommunity: _leaveCommunity2.default,
	  userCommunities: _userCommunities2.default,
	  communityPosts: _communityPosts2.default,
	  postsList: _postsList2.default,
	  membersList: _membersList2.default,
	  moderatorsList: _moderatorsList2.default,
	  communityMembers: _communityMembers2.default,
	  communityModerators: _communityModerators2.default,
	  postDetails: _postDetails2.default,
	  createPost: _createPost2.default,
	  postsCreated: _postsCreated2.default,
	  editPost: _editPost2.default,
	  newPostForm: _newPostForm2.default,
	  currentCommunity: _currentCommunity2.default,
	  postComment: _postComment2.default,
	  commentsList: _commentsList2.default,
	  deletePost: _deletePost2.default,
	  likePost: _likePost2.default,
	  dislikePost: _dislikePost2.default,
	  reqDiscoverCommunities: _reqDiscoverCommunities2.default,
	  currentCommunityInfo: _currentCommunityInfo2.default,
	  reqJoinCommunity: _reqJoinCommunity2.default,
	  communitiesJoinRequests: _communitiesJoinRequests2.default,
	  acceptJoinRequest: _acceptJoinRequest2.default,
	  declineJoinRequest: _declineJoinRequest2.default,
	  getUserProfile: _getUserProfile2.default,
	  communityPreview: _communityPreview2.default,
	  communityPostsPreview: _communityPostsPreview2.default,
	  joinPopup: _joinPopup2.default,
	  reqMemberInvitation: _reqMemberInvitation2.default,
	  notificationCounters: _notificationCounters2.default,
	  removeNotificationsCounters: _removeNotificationsCounters2.default,
	  usersJoinRequests: _usersJoinRequests2.default,
	  currentCommunityScrollStatus: _currentCommunityScrollStatus2.default,
	  communityImageUpdate: _communityImageUpdate2.default,
	  communityImageRemove: _communityImageRemove2.default,
	  communityInfoUpdate: _communityInfoUpdate2.default,
	  invitationUserSearch: _invitationUserSearch2.default,
	  invitationUserToCommunity: _invitationUserToCommunity2.default,
	  acceptInvitation: _acceptInvitation2.default,
	  declineInvitation: _declineInvitation2.default,
	  activities: _activities2.default
	});

/***/ }),
/* 4020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.getMembersListSaga = getMembersListSaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _membersList = __webpack_require__(1879);
	
	var _communityMembers = __webpack_require__(516);
	
	var _selectors = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(getMembersListWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getMembersListSaga);
	
	function getMembersListWorker(action) {
	  var MEMBERS_PER_PAGE, state, communityId, limit, offset, responseAction, response, membersListRes;
	  return _regenerator2.default.wrap(function getMembersListWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (!(action.type === _communityMembers.consts.CLEAR_MEMBERS)) {
	            _context.next = 4;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.put)({
	            type: _membersList.consts.CLEAR
	          });
	
	        case 3:
	          return _context.abrupt('return');
	
	        case 4:
	          MEMBERS_PER_PAGE = 20;
	          _context.next = 7;
	          return (0, _effects.select)();
	
	        case 7:
	          state = _context.sent;
	          communityId = +(0, _get2.default)(action.payload, 'communityId');
	          limit = MEMBERS_PER_PAGE;
	          offset = 0;
	          responseAction = _membersList.consts.LOAD_MEMBERS;
	
	
	          if (action.type === _communityMembers.consts.GET_OLDER_MEMBERS) {
	            offset = (0, _selectors.membersListLengthSelector)(state);
	            responseAction = _membersList.consts.LOAD_OLDER_MEMBERS;
	          }
	
	          // Dispatch request
	          _context.next = 15;
	          return (0, _effects.put)({
	            type: _communityMembers.consts.SEND,
	            payload: { communityId: communityId, limit: limit, offset: offset }
	          });
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.take)(_communityMembers.consts.SUCCEED);
	
	        case 17:
	          response = _context.sent;
	          membersListRes = (0, _get2.default)(response, 'payload', []);
	
	          // Dispatch response
	
	          _context.next = 21;
	          return (0, _effects.put)({
	            type: responseAction,
	            payload: [].concat((0, _toConsumableArray3.default)(membersListRes))
	          });
	
	        case 21:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function getMembersListSaga() {
	  return _regenerator2.default.wrap(function getMembersListSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_communityMembers.consts.GET_MEMBERS, _communityMembers.consts.GET_OLDER_MEMBERS, _communityMembers.consts.CLEAR_MEMBERS], getMembersListWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.getModeratorsListSaga = getModeratorsListSaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _moderatorsList = __webpack_require__(1880);
	
	var _communityModerators = __webpack_require__(517);
	
	var _selectors = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(getModeratorsListWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getModeratorsListSaga);
	
	function getModeratorsListWorker(action) {
	  var MODERATORS_PER_PAGE, state, communityId, limit, offset, responseAction, response;
	  return _regenerator2.default.wrap(function getModeratorsListWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (!(action.type === _communityModerators.consts.CLEAR_MODERATORS)) {
	            _context.next = 4;
	            break;
	          }
	
	          _context.next = 3;
	          return (0, _effects.put)({
	            type: _moderatorsList.consts.CLEAR
	          });
	
	        case 3:
	          return _context.abrupt('return');
	
	        case 4:
	          MODERATORS_PER_PAGE = 20;
	          _context.next = 7;
	          return (0, _effects.select)();
	
	        case 7:
	          state = _context.sent;
	          communityId = +(0, _get2.default)(action.payload, 'communityId');
	          limit = MODERATORS_PER_PAGE;
	          offset = 0;
	          responseAction = _moderatorsList.consts.LOAD_MODERATORS;
	
	
	          if (action.type === _communityModerators.consts.GET_OLDER_MODERATORS) {
	            offset = (0, _selectors.moderatorsListLengthSelector)(state);
	            responseAction = _moderatorsList.consts.LOAD_OLDER_MODERATORS;
	          }
	
	          // Dispatch request
	          _context.next = 15;
	          return (0, _effects.put)({
	            type: _communityModerators.consts.SEND,
	            payload: { communityId: communityId, limit: limit, offset: offset }
	          });
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.take)(_communityModerators.consts.SUCCEED);
	
	        case 17:
	          response = _context.sent;
	          _context.next = 20;
	          return (0, _effects.put)({
	            type: responseAction,
	            payload: response.payload
	          });
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function getModeratorsListSaga() {
	  return _regenerator2.default.wrap(function getModeratorsListSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_communityModerators.consts.GET_MODERATORS, _communityModerators.consts.GET_OLDER_MODERATORS, _communityModerators.consts.CLEAR_MODERATORS], getModeratorsListWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.postDetailsSaga = postDetailsSaga;
	exports.postCommentsSaga = postCommentsSaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _postsList = __webpack_require__(166);
	
	var _postDetails = __webpack_require__(238);
	
	var _commentsList = __webpack_require__(299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(postDetailsWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(postDetailsSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(postCommentsWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(postCommentsSaga);
	
	function postDetailsWorker() {
	  return _regenerator2.default.wrap(function postDetailsWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)({
	            type: _postDetails.consts.CLEAR
	          });
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function postDetailsSaga() {
	  return _regenerator2.default.wrap(function postDetailsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_postsList.consts.RESTORE, postDetailsWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function postCommentsWorker(action) {
	  return _regenerator2.default.wrap(function postCommentsWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)({
	            type: _postDetails.consts.ADD_COMMENTS,
	            payload: (0, _get2.default)(action, 'payload.newComments.length', 0)
	          });
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.put)({
	            type: _postsList.consts.POST_COMMENTS_CHANGED,
	            payload: {
	              postId: (0, _get2.default)(action, 'payload.postId'),
	              change: (0, _get2.default)(action, 'payload.newComments.length', 0)
	            }
	          });
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function postCommentsSaga() {
	  return _regenerator2.default.wrap(function postCommentsSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeEvery)(_commentsList.consts.UPDATE_COMMENTS_LIST, postCommentsWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}

/***/ }),
/* 4023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.createdPostSaga = createdPostSaga;
	exports.getPostsSaga = getPostsSaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _createPost = __webpack_require__(823);
	
	var _postsCreated = __webpack_require__(1881);
	
	var _newPostForm = __webpack_require__(652);
	
	var _postsList = __webpack_require__(166);
	
	var _communityPosts = __webpack_require__(650);
	
	var _urlPreview = __webpack_require__(413);
	
	var _currentCommunityInfo = __webpack_require__(344);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(createdPostWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(createdPostSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(getPostsWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(getPostsSaga);
	
	function createdPostWorker(action) {
	  return _regenerator2.default.wrap(function createdPostWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          if (!(action.payload.approvalStatus === _constants.COMMINITY_APPROVAL_STATUS_PENDING)) {
	            _context.next = 2;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)({
	            type: _postsList.consts.ADD_NEW_POST,
	            payload: [action.payload]
	          });
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.put)({
	            type: _newPostForm.consts.CLEAR_FORM
	          });
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)({
	            type: _urlPreview.consts.CLEAR
	          });
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)({
	            type: _postsCreated.consts.UPDATE,
	            payload: 1
	          });
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.put)({
	            type: _currentCommunityInfo.consts.UPDATE_POSTS_COUNTER
	          });
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function createdPostSaga() {
	  return _regenerator2.default.wrap(function createdPostSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_createPost.consts.SUCCEED, createdPostWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function getPostsWorker(action) {
	  var POSTS_PER_PAGE, state, communityId, limit, offset, responseAction, postsFromUser, response;
	  return _regenerator2.default.wrap(function getPostsWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          // Request data according to action type
	          POSTS_PER_PAGE = 20;
	          _context3.next = 3;
	          return (0, _effects.select)();
	
	        case 3:
	          state = _context3.sent;
	          communityId = +(0, _get2.default)(action.payload, 'communityId');
	          limit = POSTS_PER_PAGE;
	          offset = 0;
	          responseAction = _postsList.consts.LOAD_POSTS;
	
	          // eslint-disable-next-line default-case
	
	          _context3.t0 = action.type;
	          _context3.next = _context3.t0 === _communityPosts.consts.GET_NEW_POSTS ? 11 : _context3.t0 === _communityPosts.consts.GET_OLDER_POSTS ? 15 : 18;
	          break;
	
	        case 11:
	          postsFromUser = state.communities.postsCreated;
	
	          limit = (0, _get2.default)(action.payload, 'limit', 0) + postsFromUser;
	          responseAction = _postsList.consts.LOAD_NEW_POSTS;
	          return _context3.abrupt('break', 18);
	
	        case 15:
	          offset = (0, _get2.default)(state, 'communities.postsList.length');
	          responseAction = _postsList.consts.LOAD_OLDER_POSTS;
	          return _context3.abrupt('break', 18);
	
	        case 18:
	          _context3.next = 20;
	          return (0, _effects.put)({
	            type: _communityPosts.consts.SEND,
	            payload: { communityId: communityId, limit: limit, offset: offset }
	          });
	
	        case 20:
	          _context3.next = 22;
	          return (0, _effects.take)(_communityPosts.consts.SUCCEED);
	
	        case 22:
	          response = _context3.sent;
	          _context3.next = 25;
	          return (0, _effects.put)({
	            type: responseAction,
	            payload: response.payload
	          });
	
	        case 25:
	          if (!(action.type === _communityPosts.consts.GET_NEW_POSTS)) {
	            _context3.next = 28;
	            break;
	          }
	
	          _context3.next = 28;
	          return (0, _effects.put)({
	            type: _postsCreated.consts.CLEAR
	          });
	
	        case 28:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function getPostsSaga() {
	  return _regenerator2.default.wrap(function getPostsSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeEvery)([_communityPosts.consts.GET_POSTS, _communityPosts.consts.GET_NEW_POSTS, _communityPosts.consts.GET_OLDER_POSTS], getPostsWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}

/***/ }),
/* 4024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.getPostsPreviewSaga = getPostsPreviewSaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _communityPostsPreview = __webpack_require__(822);
	
	var _postsList = __webpack_require__(166);
	
	var _communityPreview = __webpack_require__(1266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(getPostsPreviewWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getPostsPreviewSaga);
	
	function getPostsPreviewWorker(action) {
	  var POSTS_PER_PAGE, communityId, limit, offset, response;
	  return _regenerator2.default.wrap(function getPostsPreviewWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          // Request data according to action type
	          POSTS_PER_PAGE = 20;
	          communityId = +(0, _get2.default)(action.payload, 'communityId');
	          limit = POSTS_PER_PAGE;
	          _context.next = 5;
	          return (0, _effects.select)(_communityPreview.communityPostsListSizeSelector);
	
	        case 5:
	          offset = _context.sent;
	          _context.next = 8;
	          return (0, _effects.put)({
	            type: _communityPostsPreview.consts.SEND,
	            payload: { communityId: communityId, limit: limit, offset: offset }
	          });
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.take)(_communityPostsPreview.consts.SUCCEED);
	
	        case 10:
	          response = _context.sent;
	          _context.next = 13;
	          return (0, _effects.put)({
	            type: _postsList.consts.LOAD_OLDER_POSTS_PREVIEW,
	            payload: response.payload
	          });
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function getPostsPreviewSaga() {
	  return _regenerator2.default.wrap(function getPostsPreviewSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_communityPostsPreview.consts.GET_POSTS_PREVIEW, _communityPostsPreview.consts.GET_OLDER_POSTS_PREVIEW], getPostsPreviewWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.default = activitiesRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _activities = __webpack_require__(1256);
	
	var _communitiesJoinRequests = __webpack_require__(343);
	
	var communitiesJoinRequests = _interopRequireWildcard(_communitiesJoinRequests);
	
	var _notificationCounters = __webpack_require__(300);
	
	var notificationCounters = _interopRequireWildcard(_notificationCounters);
	
	var _constants = __webpack_require__(17);
	
	var _activitiesSelector = __webpack_require__(829);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(setDefaultTab),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(activitiesRootSaga);
	
	var MEMBER_INVITATIONS = _constants.ACTIVITY_TYPES.MEMBER_INVITATIONS,
	    NOTIFICATIONS = _constants.ACTIVITY_TYPES.NOTIFICATIONS,
	    JOIN_REQUESTS = _constants.ACTIVITY_TYPES.JOIN_REQUESTS;
	
	
	function setDefaultTab() {
	  var _getTabToSwitch;
	
	  var tab, notifyCount, requestCount, inviteCount, getTabToSwitch, tabToSwitch;
	  return _regenerator2.default.wrap(function setDefaultTab$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.delay)(0);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.select)(_activitiesSelector.selectActivitiesActiveTab);
	
	        case 4:
	          tab = _context.sent;
	          _context.next = 7;
	          return (0, _effects.select)((0, _activitiesSelector.selectActivityCounterByType)(NOTIFICATIONS));
	
	        case 7:
	          notifyCount = _context.sent;
	          _context.next = 10;
	          return (0, _effects.select)((0, _activitiesSelector.selectActivityCounterByType)(JOIN_REQUESTS));
	
	        case 10:
	          requestCount = _context.sent;
	          _context.next = 13;
	          return (0, _effects.select)((0, _activitiesSelector.selectActivityCounterByType)(MEMBER_INVITATIONS));
	
	        case 13:
	          inviteCount = _context.sent;
	          getTabToSwitch = (_getTabToSwitch = {}, (0, _defineProperty3.default)(_getTabToSwitch, MEMBER_INVITATIONS, function () {
	            if (inviteCount) return null;
	            return requestCount ? JOIN_REQUESTS : NOTIFICATIONS;
	          }), (0, _defineProperty3.default)(_getTabToSwitch, JOIN_REQUESTS, function () {
	            if (requestCount) return null;
	            return notifyCount ? NOTIFICATIONS : MEMBER_INVITATIONS;
	          }), (0, _defineProperty3.default)(_getTabToSwitch, NOTIFICATIONS, function () {
	            if (notifyCount) return null;
	
	            return requestCount ? JOIN_REQUESTS : MEMBER_INVITATIONS;
	          }), _getTabToSwitch);
	          tabToSwitch = getTabToSwitch[tab]();
	
	          if (!tabToSwitch) {
	            _context.next = 19;
	            break;
	          }
	
	          _context.next = 19;
	          return (0, _effects.put)(_activities.activitiesActions.changeTab(tabToSwitch));
	
	        case 19:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function activitiesRootSaga() {
	  return _regenerator2.default.wrap(function activitiesRootSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([communitiesJoinRequests.consts.SUCCEED, notificationCounters.consts.UPDATE_ACTIVITY_COUNT], setDefaultTab);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = discoverCommunitiesSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _reqDiscoverCommunities = __webpack_require__(520);
	
	var _selectors = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(discoverCommunitiesWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(discoverCommunitiesSaga);
	
	function discoverCommunitiesWorker(_ref) {
	  var type = _ref.payload.type;
	  var paginationOptions, communitiesTotal, existingCommunities, params;
	  return _regenerator2.default.wrap(function discoverCommunitiesWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)((0, _selectors.makeDiscoverCommunitiesPaginationSelector)(type));
	
	        case 2:
	          paginationOptions = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)((0, _selectors.makeDiscoverCommunitiesCounterSelector)(type));
	
	        case 5:
	          communitiesTotal = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)((0, _selectors.makeDiscoverCommunitiesListSelector)(type));
	
	        case 8:
	          existingCommunities = _context.sent;
	
	          if (!(communitiesTotal <= existingCommunities.length)) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 12;
	          return (0, _effects.cancel)();
	
	        case 12:
	          params = (0, _lodash.merge)({}, paginationOptions, {
	            type: type,
	            offset: existingCommunities.length
	          });
	          _context.next = 15;
	          return (0, _effects.put)(_reqDiscoverCommunities.paginatedActions.updatePaginationParameters(params));
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.put)({
	            type: _reqDiscoverCommunities.paginatedConsts.SEND,
	            payload: params
	          });
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function discoverCommunitiesSaga() {
	  return _regenerator2.default.wrap(function discoverCommunitiesSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_reqDiscoverCommunities.paginatedConsts.LOAD_NEXT_COMMUNITIES, discoverCommunitiesWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mapTypes;
	
	exports.default = handleJoinRequestsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _acceptJoinRequest = __webpack_require__(818);
	
	var _declineJoinRequest = __webpack_require__(825);
	
	var _acceptInvitation = __webpack_require__(342);
	
	var _declineInvitation = __webpack_require__(518);
	
	var _communitiesJoinRequests = __webpack_require__(343);
	
	var _notificationCounters = __webpack_require__(300);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleJoinRequestsWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleJoinRequestsSaga);
	
	var JOIN_REQUESTS = _constants.ACTIVITY_TYPES.JOIN_REQUESTS,
	    MEMBER_INVITATIONS = _constants.ACTIVITY_TYPES.MEMBER_INVITATIONS;
	
	
	var mapTypes = (_mapTypes = {}, (0, _defineProperty3.default)(_mapTypes, _acceptJoinRequest.consts.SEND, {
	  type: JOIN_REQUESTS,
	  SUCCESS_ACTION: _acceptJoinRequest.consts.SUCCEED
	}), (0, _defineProperty3.default)(_mapTypes, _declineJoinRequest.consts.SEND, {
	  type: JOIN_REQUESTS,
	  SUCCESS_ACTION: _declineJoinRequest.consts.SUCCEED
	}), (0, _defineProperty3.default)(_mapTypes, _acceptInvitation.consts.SEND, {
	  type: MEMBER_INVITATIONS,
	  SUCCESS_ACTION: _acceptInvitation.consts.SUCCEED
	}), (0, _defineProperty3.default)(_mapTypes, _declineInvitation.consts.SEND, {
	  type: MEMBER_INVITATIONS,
	  SUCCESS_ACTION: _declineInvitation.consts.SUCCEED
	}), _mapTypes);
	
	function handleJoinRequestsWorker(_ref) {
	  var actionType = _ref.type,
	      payload = _ref.payload;
	
	  var id, _mapTypes$actionType, type, SUCCESS_ACTION;
	
	  return _regenerator2.default.wrap(function handleJoinRequestsWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          id = payload.id;
	          _mapTypes$actionType = mapTypes[actionType], type = _mapTypes$actionType.type, SUCCESS_ACTION = _mapTypes$actionType.SUCCESS_ACTION;
	          _context.next = 4;
	          return (0, _effects.put)(_communitiesJoinRequests.actions.disableRequest({ id: id, type: type }));
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.take)(SUCCESS_ACTION);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)(_communitiesJoinRequests.actions.removeRequest({ id: id, type: type }));
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)(_communitiesJoinRequests.paginatedActions.loadNextRequests({ limit: 1, type: type }));
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.put)(_notificationCounters.actions.updateActivityCount(-1));
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleJoinRequestsSaga() {
	  return _regenerator2.default.wrap(function handleJoinRequestsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_acceptJoinRequest.consts.SEND, _declineJoinRequest.consts.SEND, _acceptInvitation.consts.SEND, _declineInvitation.consts.SEND], handleJoinRequestsWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4028 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _discoverCommunities = __webpack_require__(4026);
	
	var _discoverCommunities2 = _interopRequireDefault(_discoverCommunities);
	
	var _usersCommunitiesSaga = __webpack_require__(4036);
	
	var _usersCommunitiesSaga2 = _interopRequireDefault(_usersCommunitiesSaga);
	
	var _handleJoinRequests = __webpack_require__(4027);
	
	var _handleJoinRequests2 = _interopRequireDefault(_handleJoinRequests);
	
	var _joinRequestListPagination = __webpack_require__(4030);
	
	var _joinRequestListPagination2 = _interopRequireDefault(_joinRequestListPagination);
	
	var _joinCommunityPopup = __webpack_require__(4029);
	
	var _joinCommunityPopup2 = _interopRequireDefault(_joinCommunityPopup);
	
	var _joinRequestNotification = __webpack_require__(4031);
	
	var _joinRequestNotification2 = _interopRequireDefault(_joinRequestNotification);
	
	var _newPost = __webpack_require__(4033);
	
	var _newPost2 = _interopRequireDefault(_newPost);
	
	var _newPostComment = __webpack_require__(4034);
	
	var _newPostComment2 = _interopRequireDefault(_newPostComment);
	
	var _removeNotificationsCounters = __webpack_require__(4035);
	
	var _removeNotificationsCounters2 = _interopRequireDefault(_removeNotificationsCounters);
	
	var _usersJoinRequestsPagination = __webpack_require__(4037);
	
	var _usersJoinRequestsPagination2 = _interopRequireDefault(_usersJoinRequestsPagination);
	
	var _leaveCommunity = __webpack_require__(4032);
	
	var _leaveCommunity2 = _interopRequireDefault(_leaveCommunity);
	
	var _activitiesSaga = __webpack_require__(4025);
	
	var _activitiesSaga2 = _interopRequireDefault(_activitiesSaga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_discoverCommunities2.default);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(_usersCommunitiesSaga2.default);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(_handleJoinRequests2.default);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(_joinRequestListPagination2.default);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(_joinCommunityPopup2.default);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(_joinRequestNotification2.default);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_newPost2.default);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(_newPostComment2.default);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(_removeNotificationsCounters2.default);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(_usersJoinRequestsPagination2.default);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.fork)(_leaveCommunity2.default);
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.fork)(_activitiesSaga2.default);
	
	        case 24:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _joinPopup = __webpack_require__(519);
	
	var _reqMemberInvitation = __webpack_require__(654);
	
	var _selectors = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(joinCommunityPopupWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(joinCommunityPopupSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(succeedInvitePopupWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(succeedInvitePopupSaga),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function joinCommunityPopupWorker(action) {
	  var payload, joinPopup, visible, content, timer, isSignUpPopupOpen;
	  return _regenerator2.default.wrap(function joinCommunityPopupWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          _context.next = 3;
	          return (0, _effects.delay)(payload.delay);
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.communityJoinPopupSelector);
	
	        case 5:
	          joinPopup = _context.sent;
	          visible = joinPopup.visible, content = joinPopup.content, timer = joinPopup.timer;
	          isSignUpPopupOpen = visible && content === ('signUp' || 'success');
	
	          if (!(!timer || isSignUpPopupOpen)) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.cancel)();
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.put)({
	            type: _joinPopup.consts.STOP_TIMER
	          });
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)({
	            type: _joinPopup.consts.SHOW,
	            payload: {
	              content: 'join'
	            }
	          });
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function joinCommunityPopupSaga() {
	  return _regenerator2.default.wrap(function joinCommunityPopupSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_joinPopup.consts.SET_TIMER, joinCommunityPopupWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function succeedInvitePopupWorker() {
	  return _regenerator2.default.wrap(function succeedInvitePopupWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)({
	            type: _joinPopup.consts.SHOW,
	            payload: {
	              content: 'success'
	            }
	          });
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function succeedInvitePopupSaga() {
	  return _regenerator2.default.wrap(function succeedInvitePopupSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(_reqMemberInvitation.consts.SUCCEED, succeedInvitePopupWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.fork)(joinCommunityPopupSaga);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.fork)(succeedInvitePopupSaga);
	
	        case 4:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 4030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = joinRequestsPaginationSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _communitiesJoinRequests = __webpack_require__(343);
	
	var _activitiesSelector = __webpack_require__(829);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(joinRequestsPaginationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(joinRequestsPaginationSaga);
	
	function joinRequestsPaginationWorker(action) {
	  var payload, limit, type, currentList, _ref, total, paginationOptions, params;
	
	  return _regenerator2.default.wrap(function joinRequestsPaginationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          limit = payload.limit, type = payload.type;
	          _context.next = 4;
	          return (0, _effects.select)((0, _activitiesSelector.selectActivityListByType)(type));
	
	        case 4:
	          currentList = _context.sent;
	          _context.next = 7;
	          return (0, _effects.select)((0, _activitiesSelector.selectActivityMetaByType)(type));
	
	        case 7:
	          _ref = _context.sent;
	          total = _ref.total;
	          paginationOptions = (0, _objectWithoutProperties3.default)(_ref, ['total']);
	
	          if (!(total <= currentList.length)) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          params = (0, _lodash.merge)({}, paginationOptions, {
	            offset: currentList.length,
	            limit: limit,
	            type: type
	          });
	          _context.next = 16;
	          return (0, _effects.put)(_communitiesJoinRequests.paginatedActions.updatePaginationParameters(params));
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.put)(_communitiesJoinRequests.paginatedActions.send(params));
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function joinRequestsPaginationSaga() {
	  return _regenerator2.default.wrap(function joinRequestsPaginationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_communitiesJoinRequests.paginatedConsts.LOAD_NEXT_REQUESTS, joinRequestsPaginationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4031 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mapTypes;
	
	exports.default = joinRequestNotificationSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _communitiesJoinRequests = __webpack_require__(343);
	
	var _notificationCounters = __webpack_require__(300);
	
	var _selectors = __webpack_require__(115);
	
	var _routes = __webpack_require__(37);
	
	var _constants = __webpack_require__(17);
	
	var _constants2 = __webpack_require__(94);
	
	var _constants3 = _interopRequireDefault(_constants2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleRealTimeNotificationInsert),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(joinRequestNotificationSaga);
	
	var mapTypes = (_mapTypes = {}, (0, _defineProperty3.default)(_mapTypes, _constants3.default.JOIN_REQUEST_ACCEPTED, _constants.ACTIVITY_TYPES.NOTIFICATIONS), (0, _defineProperty3.default)(_mapTypes, _constants3.default.JOIN_REQUEST_DECLINED, _constants.ACTIVITY_TYPES.NOTIFICATIONS), (0, _defineProperty3.default)(_mapTypes, _constants3.default.COMMUNITY_INVITE_ACCEPT, _constants.ACTIVITY_TYPES.NOTIFICATIONS), (0, _defineProperty3.default)(_mapTypes, _constants3.default.COMMUNITY_INVITE_DECLINE, _constants.ACTIVITY_TYPES.NOTIFICATIONS), (0, _defineProperty3.default)(_mapTypes, _constants3.default.NEW_JOIN_REQUEST, _constants.ACTIVITY_TYPES.JOIN_REQUESTS), (0, _defineProperty3.default)(_mapTypes, _constants3.default.NEW_COMMUNITY_INVITE, _constants.ACTIVITY_TYPES.MEMBER_INVITATIONS), _mapTypes);
	
	function handleRealTimeNotificationInsert(_ref) {
	  var actionType = _ref.type,
	      payload = _ref.payload;
	  var notification, currentLocation, type;
	  return _regenerator2.default.wrap(function handleRealTimeNotificationInsert$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          notification = (0, _lodash.get)(payload, 'message.payload.data.notification');
	          _context.next = 3;
	          return (0, _effects.select)(_selectors.currentLocationSelector);
	
	        case 3:
	          currentLocation = _context.sent;
	          type = mapTypes[actionType];
	          _context.next = 7;
	          return (0, _effects.put)(_notificationCounters.actions.updateActivityCount(1));
	
	        case 7:
	          if (!(notification && currentLocation === '/' + _routes.COMMUNITIES + '/' + _routes.ACTIVITIES)) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.put)(_communitiesJoinRequests.actions.realTimeInsert({
	            list: [notification],
	            type: type
	          }));
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function joinRequestNotificationSaga() {
	  return _regenerator2.default.wrap(function joinRequestNotificationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_constants3.default.JOIN_REQUEST_ACCEPTED, _constants3.default.JOIN_REQUEST_DECLINED, _constants3.default.NEW_JOIN_REQUEST, _constants3.default.NEW_COMMUNITY_INVITE, _constants3.default.COMMUNITY_INVITE_ACCEPT, _constants3.default.COMMUNITY_INVITE_DECLINE], handleRealTimeNotificationInsert);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = leaveCommunitySaga;
	
	var _effects = __webpack_require__(14);
	
	var _leaveCommunity = __webpack_require__(651);
	
	var _communityMembers = __webpack_require__(516);
	
	var _communityModerators = __webpack_require__(517);
	
	var _currentCommunityInfo = __webpack_require__(344);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(leaveCommunityWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(leaveCommunitySaga);
	
	function leaveCommunityWorker() {
	  return _regenerator2.default.wrap(function leaveCommunityWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_communityMembers.actions.clearMembers());
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)(_communityModerators.actions.clearModerators());
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.put)(_currentCommunityInfo.actions.clearUserRole());
	
	        case 6:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function leaveCommunitySaga() {
	  return _regenerator2.default.wrap(function leaveCommunitySaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_leaveCommunity.consts.SUCCEED, leaveCommunityWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4033 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = joinRequestNotificationSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _userCommunities = __webpack_require__(414);
	
	var _selectors = __webpack_require__(115);
	
	var _routes = __webpack_require__(37);
	
	var _postsList = __webpack_require__(166);
	
	var _currentCommunityInfo = __webpack_require__(344);
	
	var _notificationCounters = __webpack_require__(300);
	
	var _removeNotificationsCounters = __webpack_require__(345);
	
	var _currentCommunity = __webpack_require__(301);
	
	var _currentCommunityScrollStatus = __webpack_require__(1259);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(newPostNotificationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(joinRequestNotificationSaga);
	
	function newPostNotificationWorker(action) {
	  var message, communityId, post, newPost, currentLocation, isCurrentCommunity, isScrolled;
	  return _regenerator2.default.wrap(function newPostNotificationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          message = (0, _lodash.get)(action.payload, 'message');
	          communityId = (0, _lodash.get)(message, 'payload.data.communityId');
	          post = (0, _lodash.get)(message, 'payload.data.post');
	          newPost = (0, _extends3.default)({}, post, { isNewPost: true });
	          _context.next = 6;
	          return (0, _effects.select)(_selectors.currentLocationSelector);
	
	        case 6:
	          currentLocation = _context.sent;
	          isCurrentCommunity = !!currentLocation.match('/' + _routes.COMMUNITIES + '/' + communityId);
	          _context.next = 10;
	          return (0, _effects.select)(_currentCommunity.currentCommunityScrollSelector);
	
	        case 10:
	          isScrolled = _context.sent;
	
	          if (!(currentLocation === '/' + _routes.COMMUNITIES + '/' + _routes.MY_COMMUNITIES)) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 14;
	          return (0, _effects.put)({
	            type: _userCommunities.consts.UPDATE_TOTAL_UNREAD_COUNT,
	            payload: { communityId: communityId, updatePostCounter: true }
	          });
	
	        case 14:
	          _context.next = 28;
	          break;
	
	        case 16:
	          if (!isCurrentCommunity) {
	            _context.next = 28;
	            break;
	          }
	
	          if (!isScrolled) {
	            _context.next = 22;
	            break;
	          }
	
	          _context.next = 20;
	          return (0, _effects.put)({
	            type: _currentCommunityScrollStatus.consts.ADD_TEMPORARY_POST_LIST,
	            payload: [newPost]
	          });
	
	        case 20:
	          _context.next = 24;
	          break;
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.put)({
	            type: _postsList.consts.ADD_NEW_POST,
	            payload: [newPost]
	          });
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.put)({
	            type: _currentCommunityInfo.consts.UPDATE_POSTS_COUNTER
	          });
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.put)({
	            type: _removeNotificationsCounters.consts.SEND,
	            payload: { type: 'communities', community_ids: [communityId] }
	          });
	
	        case 28:
	          if (isCurrentCommunity) {
	            _context.next = 31;
	            break;
	          }
	
	          _context.next = 31;
	          return (0, _effects.put)({
	            type: _notificationCounters.consts.UPDATE_COMMUNITY_COUNT,
	            payload: 1
	          });
	
	        case 31:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function joinRequestNotificationSaga() {
	  return _regenerator2.default.wrap(function joinRequestNotificationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_constants2.default.NEW_POST, newPostNotificationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = newCommentNotificationSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _commentsList = __webpack_require__(299);
	
	var _notificationCounters = __webpack_require__(300);
	
	var _routes = __webpack_require__(37);
	
	var _userCommunities = __webpack_require__(414);
	
	var _selectors = __webpack_require__(115);
	
	var _removeNotificationsCounters = __webpack_require__(345);
	
	var _postDetails = __webpack_require__(238);
	
	var _postsList = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(newCommentNotificationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(newCommentNotificationSaga);
	
	function newCommentNotificationWorker(action) {
	  var message, communityId, comment, newComment, postId, currentLocation, isCurrentCommunity;
	  return _regenerator2.default.wrap(function newCommentNotificationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          message = (0, _lodash.get)(action.payload, 'message');
	          communityId = (0, _lodash.get)(message, 'payload.data.communityId');
	          comment = (0, _lodash.get)(message, 'payload.data.comment');
	          newComment = (0, _extends3.default)({}, comment, { isNewComment: true });
	          postId = (0, _lodash.get)(comment, 'postId');
	          _context.next = 7;
	          return (0, _effects.select)(_selectors.currentLocationSelector);
	
	        case 7:
	          currentLocation = _context.sent;
	          isCurrentCommunity = !!currentLocation.match('/' + _routes.COMMUNITIES + '/' + communityId);
	
	          if (!(currentLocation === '/' + _routes.COMMUNITIES + '/' + _routes.MY_COMMUNITIES)) {
	            _context.next = 14;
	            break;
	          }
	
	          _context.next = 12;
	          return (0, _effects.put)({
	            type: _userCommunities.consts.UPDATE_TOTAL_UNREAD_COUNT,
	            payload: { communityId: communityId }
	          });
	
	        case 12:
	          _context.next = 24;
	          break;
	
	        case 14:
	          if (!isCurrentCommunity) {
	            _context.next = 24;
	            break;
	          }
	
	          if (!(currentLocation === '/' + _routes.COMMUNITIES + '/' + communityId + '/' + _routes.POST + '/' + postId)) {
	            _context.next = 20;
	            break;
	          }
	
	          _context.next = 18;
	          return (0, _effects.put)({
	            type: _commentsList.consts.ADD_COMMENT,
	            payload: (0, _extends3.default)({}, newComment, {
	              parentId: newComment.parentId
	            })
	          });
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.put)({
	            type: _postDetails.consts.ADD_COMMENT
	          });
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.put)({
	            type: _postsList.consts.POST_COMMENTS_CHANGED,
	            payload: {
	              postId: postId,
	              change: 1
	            }
	          });
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.put)({
	            type: _removeNotificationsCounters.consts.SEND,
	            payload: { type: 'communities', community_ids: [communityId] }
	          });
	
	        case 24:
	          if (isCurrentCommunity) {
	            _context.next = 27;
	            break;
	          }
	
	          _context.next = 27;
	          return (0, _effects.put)({
	            type: _notificationCounters.consts.UPDATE_COMMUNITY_COUNT,
	            payload: 1
	          });
	
	        case 27:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function newCommentNotificationSaga() {
	  return _regenerator2.default.wrap(function newCommentNotificationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_constants2.default.NEW_POST_COMMENT, _constants2.default.NEW_COMMENT_REPLY], newCommentNotificationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = removeNotificationCountersSaga;
	
	var _lodash = __webpack_require__(58);
	
	var _effects = __webpack_require__(14);
	
	var _removeNotificationsCounters = __webpack_require__(345);
	
	var _notificationCounters = __webpack_require__(300);
	
	var _userCommunities = __webpack_require__(414);
	
	var _selectors = __webpack_require__(151);
	
	var _communitiesJoinRequests = __webpack_require__(343);
	
	var _constants = __webpack_require__(17);
	
	var _activitiesSelector = __webpack_require__(829);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(removeNotificationCountersWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleRealTimeInsert),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleFetchNotificationList),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(removeNotificationCountersSaga);
	
	function removeNotificationCountersWorker(action) {
	  var payload, type, communityIds, communityId, currentCommunityCounter;
	  return _regenerator2.default.wrap(function removeNotificationCountersWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          type = payload.type, communityIds = payload.community_ids;
	          _context.next = 4;
	          return (0, _effects.take)(_removeNotificationsCounters.consts.SUCCEED);
	
	        case 4:
	          if (!(type === 'communities')) {
	            _context.next = 13;
	            break;
	          }
	
	          communityId = communityIds[0];
	          _context.next = 8;
	          return (0, _effects.select)((0, _selectors.communityUnreadCountSelector)(communityId));
	
	        case 8:
	          currentCommunityCounter = _context.sent;
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: _notificationCounters.consts.UPDATE_COMMUNITY_COUNT,
	            payload: -currentCommunityCounter
	          });
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.put)({
	            type: _userCommunities.consts.UPDATE_TOTAL_UNREAD_COUNT,
	            payload: { communityId: communityId, removeCounter: true }
	          });
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function getUnreadIds() {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return list.filter(function (_ref) {
	    var status = _ref.status;
	    return status === 'unread';
	  }).map(function (_ref2) {
	    var id = _ref2.id;
	    return id;
	  });
	}
	
	function isNotificationRealTime(type, payload) {
	  return type === _communitiesJoinRequests.consts.REAL_TIME_INSERT && (0, _lodash.get)(payload, 'type') === _constants.ACTIVITY_TYPES.NOTIFICATIONS;
	}
	
	function handleRealTimeInsert(_ref3) {
	  var type = _ref3.type,
	      payload = _ref3.payload;
	  return _regenerator2.default.wrap(function handleRealTimeInsert$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (isNotificationRealTime(type, payload)) {
	            _context2.next = 3;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _effects.cancel)();
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.call)(handleFetchNotificationList);
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleFetchNotificationList() {
	  var notificationList, unreadIds, unreadSize, clearTask;
	  return _regenerator2.default.wrap(function handleFetchNotificationList$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)((0, _activitiesSelector.selectActivityListByType)(_constants.ACTIVITY_TYPES.NOTIFICATIONS));
	
	        case 2:
	          notificationList = _context5.sent;
	          unreadIds = getUnreadIds(notificationList);
	          unreadSize = (0, _lodash.size)(unreadIds);
	
	          if (!unreadSize) {
	            _context5.next = 15;
	            break;
	          }
	
	          _context5.next = 8;
	          return (0, _effects.put)(_removeNotificationsCounters.actions.send({
	            type: 'activities',
	            meta: _constants.ACTIVITY_TYPES.NOTIFICATIONS,
	            notificationIds: unreadIds
	          }));
	
	        case 8:
	          _context5.next = 10;
	          return (0, _effects.put)(_notificationCounters.actions.updateActivityCount(unreadSize * -1));
	
	        case 10:
	          _context5.next = 12;
	          return (0, _effects.fork)( /*#__PURE__*/_regenerator2.default.mark(function asyncClear() {
	            return _regenerator2.default.wrap(function asyncClear$(_context3) {
	              while (1) {
	                switch (_context3.prev = _context3.next) {
	                  case 0:
	                    _context3.next = 2;
	                    return (0, _effects.delay)(10e3);
	
	                  case 2:
	                    _context3.next = 4;
	                    return (0, _effects.put)(_communitiesJoinRequests.actions.resetIsNewFlag({
	                      type: _constants.ACTIVITY_TYPES.NOTIFICATIONS,
	                      ids: [].concat((0, _toConsumableArray3.default)(unreadIds))
	                    }));
	
	                  case 4:
	                  case 'end':
	                    return _context3.stop();
	                }
	              }
	            }, asyncClear, this);
	          }));
	
	        case 12:
	          clearTask = _context5.sent;
	          _context5.next = 15;
	          return (0, _effects.takeEvery)([_communitiesJoinRequests.consts.PAGE_LEAVE], /*#__PURE__*/_regenerator2.default.mark(function leavePage() {
	            return _regenerator2.default.wrap(function leavePage$(_context4) {
	              while (1) {
	                switch (_context4.prev = _context4.next) {
	                  case 0:
	                    _context4.next = 2;
	                    return (0, _effects.cancel)(clearTask);
	
	                  case 2:
	                  case 'end':
	                    return _context4.stop();
	                }
	              }
	            }, leavePage, this);
	          }));
	
	        case 15:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function removeNotificationCountersSaga() {
	  return _regenerator2.default.wrap(function removeNotificationCountersSaga$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.takeEvery)(_removeNotificationsCounters.consts.SEND, removeNotificationCountersWorker);
	
	        case 2:
	          _context6.next = 4;
	          return (0, _effects.takeEvery)([_communitiesJoinRequests.consts.SUCCEED, _communitiesJoinRequests.paginatedConsts.SUCCEED], handleFetchNotificationList);
	
	        case 4:
	          _context6.next = 6;
	          return (0, _effects.takeEvery)(_communitiesJoinRequests.consts.REAL_TIME_INSERT, handleRealTimeInsert);
	
	        case 6:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked4, this);
	}

/***/ }),
/* 4036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = userCommunitiesSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _userCommunities = __webpack_require__(414);
	
	var _selectors = __webpack_require__(151);
	
	var _selectors2 = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(userCommunitiesWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(userCommunitiesSaga);
	
	function userCommunitiesWorker(_ref) {
	  var type = _ref.payload.type;
	  var paginationOptions, communitiesTotal, existingCommunities, loggedUserId, params;
	  return _regenerator2.default.wrap(function userCommunitiesWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)((0, _selectors.makeUserCommunitiesPaginationSelector)(type));
	
	        case 2:
	          paginationOptions = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)((0, _selectors.makeUserCommunitiesCounterSelector)(type === 'member' ? 'memberCommunitiesCount' : 'moderatorCommunitiesCount'));
	
	        case 5:
	          communitiesTotal = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)((0, _selectors.makeUserCommunitiesListSelector)(type === 'member' ? 'memberCommunities' : 'moderatorCommunities'));
	
	        case 8:
	          existingCommunities = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors2.loggedUserIdSelector);
	
	        case 11:
	          loggedUserId = _context.sent;
	
	          if (!(communitiesTotal <= existingCommunities.length)) {
	            _context.next = 15;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.cancel)();
	
	        case 15:
	          params = (0, _lodash.merge)({}, paginationOptions, {
	            userId: loggedUserId,
	            offset: existingCommunities.length
	          });
	          _context.next = 18;
	          return (0, _effects.put)(_userCommunities.paginatedActions.updatePaginationParameters(params));
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.put)({
	            type: _userCommunities.paginatedConsts.SEND,
	            payload: params
	          });
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function userCommunitiesSaga() {
	  return _regenerator2.default.wrap(function userCommunitiesSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_userCommunities.paginatedConsts.LOAD_NEXT_COMMUNITIES, userCommunitiesWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = usersJoinRequestsPaginationSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _usersJoinRequests = __webpack_require__(830);
	
	var _usersJoinRequests2 = __webpack_require__(1882);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(usersJoinRequestsPaginationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(usersJoinRequestsPaginationSaga);
	
	function usersJoinRequestsPaginationWorker() {
	  var limit, paginationOptions, requestsTotal, existingRequests, params;
	  return _regenerator2.default.wrap(function usersJoinRequestsPaginationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          limit = 10;
	          _context.next = 3;
	          return (0, _effects.select)(_usersJoinRequests2.usersJoinRequestsPaginationSelector);
	
	        case 3:
	          paginationOptions = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(_usersJoinRequests2.usersJoinRequestsCounterSelector);
	
	        case 6:
	          requestsTotal = _context.sent;
	          _context.next = 9;
	          return (0, _effects.select)(_usersJoinRequests2.usersJoinRequestsListSelector);
	
	        case 9:
	          existingRequests = _context.sent;
	
	          if (!(requestsTotal <= existingRequests.length)) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          params = (0, _lodash.merge)({}, paginationOptions, {
	            offset: existingRequests.length,
	            limit: limit
	          });
	          _context.next = 16;
	          return (0, _effects.put)(_usersJoinRequests.paginatedActions.updatePaginationParameters(params));
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.put)({
	            type: _usersJoinRequests.paginatedConsts.SEND,
	            payload: params
	          });
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function usersJoinRequestsPaginationSaga() {
	  return _regenerator2.default.wrap(function usersJoinRequestsPaginationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_usersJoinRequests.paginatedConsts.LOAD_NEXT_REQUESTS, usersJoinRequestsPaginationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4038 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectNewNotifications = exports.makeNotificationPaginationSelector = exports.makeNotificationListCounterSelector = exports.makeNotificationListSelector = exports.sendingCommunitiesJoinRequestsSelector = exports.communitiesJoinRequestsSelector = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _index = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var communitiesJoinRequestsSelector = exports.communitiesJoinRequestsSelector = function communitiesJoinRequestsSelector(state) {
	  return (0, _get2.default)(state, 'communities.communitiesJoinRequests');
	};
	
	var sendingCommunitiesJoinRequestsSelector = exports.sendingCommunitiesJoinRequestsSelector = (0, _index.createSelector)(communitiesJoinRequestsSelector, function (request) {
	  return (0, _get2.default)(request, 'sending', false);
	});
	
	var makeNotificationListSelector = exports.makeNotificationListSelector = function makeNotificationListSelector(notificationList) {
	  return (0, _index.createSelector)(communitiesJoinRequestsSelector, function (request) {
	    return (0, _get2.default)(request, notificationList, []);
	  });
	};
	
	var makeNotificationListCounterSelector = exports.makeNotificationListCounterSelector = function makeNotificationListCounterSelector(notificationType) {
	  return (0, _index.createSelector)(communitiesJoinRequestsSelector, function (request) {
	    var counterName = notificationType + 'NotificationsCount';
	
	    return (0, _get2.default)(request, ['meta', counterName], null);
	  });
	};
	
	var makeNotificationPaginationSelector = exports.makeNotificationPaginationSelector = function makeNotificationPaginationSelector(type) {
	  return (0, _index.createSelector)(communitiesJoinRequestsSelector, function (state) {
	    return (0, _get2.default)(state, ['pagination', type]);
	  });
	};
	
	var selectNewNotifications = exports.selectNewNotifications = (0, _index.createSelector)(makeNotificationListSelector('member'), function (state) {
	  return state.map(function (item) {
	    if ((0, _get2.default)(item, 'status') === 'unread') {
	      return (0, _get2.default)(item, ['subject', 'community', 'id']);
	    }
	    return false;
	  });
	});

/***/ }),
/* 4039 */,
/* 4040 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _complaintResolvedList = __webpack_require__(522);
	
	var _complaintResolvedList2 = _interopRequireDefault(_complaintResolvedList);
	
	var _reqSendReport = __webpack_require__(1267);
	
	var _reqSendReport2 = _interopRequireDefault(_reqSendReport);
	
	var _complaintUnResolvedList = __webpack_require__(346);
	
	var _complaintUnResolvedList2 = _interopRequireDefault(_complaintUnResolvedList);
	
	var _resolveComplaint = __webpack_require__(655);
	
	var _resolveComplaint2 = _interopRequireDefault(_resolveComplaint);
	
	var _complaintCounters = __webpack_require__(1883);
	
	var _complaintCounters2 = _interopRequireDefault(_complaintCounters);
	
	var _complaintDetails = __webpack_require__(831);
	
	var _complaintDetails2 = _interopRequireDefault(_complaintDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  reqSendReport: _reqSendReport2.default,
	  resolvedList: _complaintResolvedList2.default,
	  unresolvedList: _complaintUnResolvedList2.default,
	  resolveComplaint: _resolveComplaint2.default,
	  counters: _complaintCounters2.default,
	  details: _complaintDetails2.default
	});

/***/ }),
/* 4041 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = complaintsRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _complaintUnResolvedList = __webpack_require__(346);
	
	var unresolvedList = _interopRequireWildcard(_complaintUnResolvedList);
	
	var _complaintResolvedList = __webpack_require__(522);
	
	var resolvedList = _interopRequireWildcard(_complaintResolvedList);
	
	var _complaintDetails = __webpack_require__(831);
	
	var complaintDetails = _interopRequireWildcard(_complaintDetails);
	
	var _resolveComplaint = __webpack_require__(655);
	
	var resolveComplaint = _interopRequireWildcard(_resolveComplaint);
	
	var _complaintListPagination = __webpack_require__(4042);
	
	var _complaintListPagination2 = _interopRequireDefault(_complaintListPagination);
	
	var _resolveComplaintWatcher = __webpack_require__(4044);
	
	var _resolveComplaintWatcher2 = _interopRequireDefault(_resolveComplaintWatcher);
	
	var _reportMenuVisibility = __webpack_require__(4043);
	
	var _reportMenuVisibility2 = _interopRequireDefault(_reportMenuVisibility);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(complaintsRootSaga);
	
	function complaintsRootSaga() {
	  return _regenerator2.default.wrap(function complaintsRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(unresolvedList.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(unresolvedList.paginationWatcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(resolvedList.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(resolvedList.paginationWatcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(complaintDetails.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(resolveComplaint.watcher);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_complaintListPagination2.default);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(_resolveComplaintWatcher2.default);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(_reportMenuVisibility2.default);
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = complaintListPagination;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _complaintUnResolvedList = __webpack_require__(346);
	
	var unresolved = _interopRequireWildcard(_complaintUnResolvedList);
	
	var _complaintResolvedList = __webpack_require__(522);
	
	var resolved = _interopRequireWildcard(_complaintResolvedList);
	
	var _selectors = __webpack_require__(656);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMoreUnresolvedComplaints),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(loadMoreResolvedComplaints),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(complaintListPagination);
	
	function loadMoreUnresolvedComplaints() {
	  var counter, currentList, pagination, listSize;
	  return _regenerator2.default.wrap(function loadMoreUnresolvedComplaints$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)((0, _selectors.makeSelectComplaintsCounter)('unresolved'));
	
	        case 2:
	          counter = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectUnResolvedList);
	
	        case 5:
	          currentList = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectUnresolvedListPagination);
	
	        case 8:
	          pagination = _context.sent;
	          listSize = (0, _size2.default)(currentList);
	
	          if (!(counter <= listSize)) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)(unresolved.paginationActions.send((0, _extends3.default)({}, pagination, {
	            offset: listSize,
	            status: 'unresolved'
	          })));
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	function loadMoreResolvedComplaints() {
	  var counter, currentList, pagination, listSize;
	  return _regenerator2.default.wrap(function loadMoreResolvedComplaints$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)((0, _selectors.makeSelectComplaintsCounter)('resolved'));
	
	        case 2:
	          counter = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_selectors.selectResolvedList);
	
	        case 5:
	          currentList = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.select)(_selectors.selectResolvedListPagination);
	
	        case 8:
	          pagination = _context2.sent;
	          listSize = (0, _size2.default)(currentList);
	
	          if (!(counter <= listSize)) {
	            _context2.next = 13;
	            break;
	          }
	
	          _context2.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          _context2.next = 15;
	          return (0, _effects.put)(resolved.paginationActions.send((0, _extends3.default)({}, pagination, {
	            offset: listSize,
	            status: 'resolved'
	          })));
	
	        case 15:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function complaintListPagination() {
	  return _regenerator2.default.wrap(function complaintListPagination$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)([unresolved.consts.LOAD_MORE], loadMoreUnresolvedComplaints);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.takeLatest)([resolved.consts.LOAD_MORE], loadMoreResolvedComplaints);
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = reportMenuVisibility;
	
	var _effects = __webpack_require__(14);
	
	var _complaintUnResolvedList = __webpack_require__(346);
	
	var unresolvedList = _interopRequireWildcard(_complaintUnResolvedList);
	
	var _getLoggedUser = __webpack_require__(539);
	
	var getLoggedUser = _interopRequireWildcard(_getLoggedUser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked2 = /*#__PURE__*/_regenerator2.default.mark(runReportsWatcher),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(reportMenuVisibility);
	
	function runReportsWatcher() {
	  var _marked, task, handleRequestFinish;
	
	  return _regenerator2.default.wrap(function runReportsWatcher$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          handleRequestFinish = function handleRequestFinish(_ref) {
	            var type = _ref.type;
	            var isMenuShown;
	            return _regenerator2.default.wrap(function handleRequestFinish$(_context) {
	              while (1) {
	                switch (_context.prev = _context.next) {
	                  case 0:
	                    isMenuShown = type === unresolvedList.consts.SUCCEED;
	                    _context.next = 3;
	                    return (0, _effects.put)(unresolvedList.actions.toggleMenuVisibility(isMenuShown));
	
	                  case 3:
	                    _context.next = 5;
	                    return (0, _effects.cancel)(task);
	
	                  case 5:
	                  case 'end':
	                    return _context.stop();
	                }
	              }
	            }, _marked, this);
	          };
	
	          _marked = /*#__PURE__*/_regenerator2.default.mark(handleRequestFinish);
	          _context2.next = 4;
	          return (0, _effects.takeLatest)([unresolvedList.consts.SUCCEED, unresolvedList.consts.REJECTED], handleRequestFinish);
	
	        case 4:
	          task = _context2.sent;
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function reportMenuVisibility() {
	  return _regenerator2.default.wrap(function reportMenuVisibility$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)([getLoggedUser.consts.SUCCEED], runReportsWatcher);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = resolveComplaintWatcher;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _complaintResolvedList = __webpack_require__(522);
	
	var resolvedList = _interopRequireWildcard(_complaintResolvedList);
	
	var _complaintUnResolvedList = __webpack_require__(346);
	
	var unresolvedList = _interopRequireWildcard(_complaintUnResolvedList);
	
	var _resolveComplaint = __webpack_require__(655);
	
	var resolveComplaint = _interopRequireWildcard(_resolveComplaint);
	
	var _complaintDetails = __webpack_require__(831);
	
	var _complaintCounters = __webpack_require__(1883);
	
	var _selectors = __webpack_require__(656);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleResolvedComplaint),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(resolveComplaintWatcher);
	
	function handleResolvedComplaint(action) {
	  var FIRST_REQUEST_LIMIT, payload, status, id, unresolvedCounter, unresolved, resolved;
	  return _regenerator2.default.wrap(function handleResolvedComplaint$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          FIRST_REQUEST_LIMIT = 10;
	          payload = action.payload;
	          status = payload.status, id = payload.id;
	
	          if (!(status === 'unresolved')) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.put)(_complaintDetails.actions.update(payload));
	
	        case 6:
	          _context.next = 26;
	          break;
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.select)((0, _selectors.makeSelectComplaintsCounter)('unresolved'));
	
	        case 10:
	          unresolvedCounter = _context.sent;
	          _context.next = 13;
	          return (0, _effects.select)(_selectors.selectUnResolvedList);
	
	        case 13:
	          unresolved = _context.sent;
	          _context.next = 16;
	          return (0, _effects.select)(_selectors.selectResolvedList);
	
	        case 16:
	          resolved = _context.sent;
	          _context.next = 19;
	          return (0, _effects.put)(unresolvedList.actions.removeComplaint({ id: id }));
	
	        case 19:
	          _context.next = 21;
	          return (0, _effects.put)(_complaintCounters.actions.updateUnresolved());
	
	        case 21:
	          if (!(unresolvedCounter >= FIRST_REQUEST_LIMIT)) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.put)(unresolvedList.paginationActions.send({
	            limit: 1,
	            offset: (0, _size2.default)(unresolved),
	            status: 'unresolved'
	          }));
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.put)(resolvedList.actions.send({
	            status: 'resolved',
	            silent: true,
	            limit: (0, _size2.default)(resolved) < FIRST_REQUEST_LIMIT ? FIRST_REQUEST_LIMIT : (0, _size2.default)(resolved),
	            offset: 0
	          }));
	
	        case 26:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function resolveComplaintWatcher() {
	  return _regenerator2.default.wrap(function resolveComplaintWatcher$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([resolveComplaint.consts.SUCCEED], handleResolvedComplaint);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.addLoggedUserSaga = addLoggedUserSaga;
	exports.fetchLoggedUserSaga = fetchLoggedUserSaga;
	exports.createLoggedUserSaga = createLoggedUserSaga;
	exports.updateLoggedUserSaga = updateLoggedUserSaga;
	exports.changeLoggedUserDataSaga = changeLoggedUserDataSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _login = __webpack_require__(402);
	
	var _loginAzure = __webpack_require__(340);
	
	var _signupReq = __webpack_require__(341);
	
	var _editUser = __webpack_require__(136);
	
	var _editPatient = __webpack_require__(218);
	
	var _editProvider = __webpack_require__(424);
	
	var _createPatient = __webpack_require__(679);
	
	var _changeProfileReq = __webpack_require__(870);
	
	var _loggedUser = __webpack_require__(523);
	
	var _getLoggedUser = __webpack_require__(539);
	
	var _locale = __webpack_require__(1374);
	
	var _selectors = __webpack_require__(23);
	
	var _popup = __webpack_require__(76);
	
	var _selectors2 = __webpack_require__(93);
	
	var _selectors3 = __webpack_require__(90);
	
	var _browserChecker = __webpack_require__(356);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(addLoggedUserWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(addLoggedUserSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(fetchLoggedUserSaga),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(createLoggedUserWorker),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(createLoggedUserSaga),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(updateLoggedUserWorker),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(updateLoggedUserSaga),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(changeLoggedUserDataWorker),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(changeLoggedUserDataSaga);
	// consts
	
	
	// actions
	var LOGIN = _login.consts.SUCCEED;
	var LOGIN_AZURE = _loginAzure.consts.SUCCEED;
	var SIGNUP = _signupReq.consts.SUCCEED;
	var CREATE_PATIENT = _createPatient.consts.SUCCEED;
	var EDIT_USER = _editUser.consts.SUCCEED;
	var EDIT_PATIENT = _editPatient.consts.SUCCEED;
	var EDIT_PROVIDER = _editProvider.consts.SUCCEED;
	
	var IS_BROWSER_SUPPORTABLE = (0, _browserChecker.isSupportedBrowser)();
	/*
	 * Saga for adding user data to context/loggedUser state
	 */
	function addLoggedUserWorker(_ref) {
	  var payload = _ref.payload;
	  var user, locale, pathname, uiPopupContentVisible, isRequestPasswordUpdate, isRegistrationCompleted, showMfaNotice, mfaEnabled;
	  return _regenerator2.default.wrap(function addLoggedUserWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)({
	            type: _loggedUser.consts.ADD,
	            payload: payload
	          });
	
	        case 2:
	          user = payload.user || payload;
	          locale = (0, _get2.default)(user, 'settings.languageSettings', null);
	
	          if (!locale) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)({
	            type: _locale.consts.SET_LOCALE,
	            payload: locale
	          });
	
	        case 7:
	          pathname = window.location.pathname;
	          _context.next = 10;
	          return (0, _effects.select)(_selectors3.selectUiPopupVisible);
	
	        case 10:
	          uiPopupContentVisible = _context.sent;
	          _context.next = 13;
	          return (0, _effects.select)(_selectors2.selectRequestPasswordUpdate);
	
	        case 13:
	          isRequestPasswordUpdate = _context.sent;
	          _context.next = 16;
	          return (0, _effects.select)(_selectors2.selectRegistrationCompleted);
	
	        case 16:
	          isRegistrationCompleted = _context.sent;
	          showMfaNotice = (0, _get2.default)(user, 'showMfaNotice', false);
	          mfaEnabled = (0, _get2.default)(user, 'mfaEnabled', false);
	
	          if (!(IS_BROWSER_SUPPORTABLE && showMfaNotice && !mfaEnabled && isRegistrationCompleted && !isRequestPasswordUpdate && !uiPopupContentVisible && !pathname.includes(_routes.PAPERWORK))) {
	            _context.next = 22;
	            break;
	          }
	
	          _context.next = 22;
	          return (0, _effects.put)((0, _popup.showMfaNoticePopup)());
	
	        case 22:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function addLoggedUserSaga() {
	  return _regenerator2.default.wrap(function addLoggedUserSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([LOGIN, SIGNUP, LOGIN_AZURE], addLoggedUserWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function fetchLoggedUserSaga() {
	  var action;
	  return _regenerator2.default.wrap(function fetchLoggedUserSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.take)(_getLoggedUser.consts.SUCCEED);
	
	        case 2:
	          action = _context3.sent;
	          _context3.next = 5;
	          return (0, _effects.fork)(addLoggedUserWorker, action);
	
	        case 5:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	/*
	 * Saga for updating user data to context/loggedUser state
	 */
	function createLoggedUserWorker(action) {
	  return _regenerator2.default.wrap(function createLoggedUserWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.put)({
	            type: _loggedUser.consts.UPDATE,
	            payload: action.payload
	          });
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function createLoggedUserSaga() {
	  return _regenerator2.default.wrap(function createLoggedUserSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeEvery)([CREATE_PATIENT], createLoggedUserWorker);
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	/*
	 * Saga for updating user data to context/loggedUser state
	 */
	function updateLoggedUserWorker(action) {
	  var state, targetUserId, loggedUserId, isLoggedUser, registerUser, editLoggedUser, payloadId;
	  return _regenerator2.default.wrap(function updateLoggedUserWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.prev = 0;
	          _context6.next = 3;
	          return (0, _effects.select)();
	
	        case 3:
	          state = _context6.sent;
	          targetUserId = state.context.permissions.targetUserId;
	          loggedUserId = state.context.loggedUser.id;
	          isLoggedUser = (0, _selectors.isLoggedUserSelector)(state);
	          registerUser = !targetUserId;
	          editLoggedUser = targetUserId && isLoggedUser;
	          payloadId = (0, _get2.default)(action, 'payload.id');
	
	          if (!((registerUser || editLoggedUser) && payloadId === loggedUserId)) {
	            _context6.next = 13;
	            break;
	          }
	
	          _context6.next = 13;
	          return (0, _effects.put)({
	            type: _loggedUser.consts.UPDATE,
	            payload: action.payload
	          });
	
	        case 13:
	          _context6.next = 18;
	          break;
	
	        case 15:
	          _context6.prev = 15;
	          _context6.t0 = _context6['catch'](0);
	
	          console.error('Error while editing another user', _context6.t0);
	
	        case 18:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this, [[0, 15]]);
	}
	
	function updateLoggedUserSaga() {
	  return _regenerator2.default.wrap(function updateLoggedUserSaga$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.takeEvery)([EDIT_USER, EDIT_PATIENT, EDIT_PROVIDER], updateLoggedUserWorker);
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function changeLoggedUserDataWorker(_ref2) {
	  var payload = _ref2.payload;
	  var loggedUserId, id;
	  return _regenerator2.default.wrap(function changeLoggedUserDataWorker$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 2:
	          loggedUserId = _context8.sent;
	          id = payload.id;
	
	          if (!(id === loggedUserId)) {
	            _context8.next = 7;
	            break;
	          }
	
	          _context8.next = 7;
	          return (0, _effects.put)({
	            type: _loggedUser.consts.UPDATE,
	            payload: payload
	          });
	
	        case 7:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function changeLoggedUserDataSaga() {
	  return _regenerator2.default.wrap(function changeLoggedUserDataSaga$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _effects.takeEvery)([_changeProfileReq.actions.succeed], changeLoggedUserDataWorker);
	
	        case 2:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}

/***/ }),
/* 4046 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.updateCaregiverCirclesSaga = updateCaregiverCirclesSaga;
	exports.updateDependentsListSaga = updateDependentsListSaga;
	exports.updateLoggedUserIdSaga = updateLoggedUserIdSaga;
	exports.updateTargetUserIdSaga = updateTargetUserIdSaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _caregiver = __webpack_require__(297);
	
	var _getGuardianDependents = __webpack_require__(353);
	
	var _targetUser = __webpack_require__(415);
	
	var _loggedUser = __webpack_require__(523);
	
	var _permissions = __webpack_require__(832);
	
	var _selectors = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateCaregiverCirclesWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateCaregiverCirclesSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(updateDependentsListWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(updateDependentsListSaga),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(updateLoggedUserWorker),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(updateLoggedUserIdSaga),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(updateTargetUserWorker),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(updateTargetUserIdSaga);
	
	// actions
	var GET_CAREGIVER_CIRCLES = _caregiver.consts.SUCCEED;
	var ADD_LOGGED_USER = _loggedUser.consts.ADD;
	var UPDATE_LOGGED_USER = _loggedUser.consts.UPDATE;
	var REMOVE_LOGGED_USER = _loggedUser.consts.REMOVE;
	var SET_TARGET_USER = _targetUser.consts.SET;
	var REMOVE_TARGET_USER = _targetUser.consts.REMOVE;
	var GET_DEPENDENTS_LIST = _getGuardianDependents.consts.SUCCEED;
	
	/*
	 * Saga for updating caregiver circles to context/permissions state
	 */
	function updateCaregiverCirclesWorker(action) {
	  var caregiverCircles;
	  return _regenerator2.default.wrap(function updateCaregiverCirclesWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          caregiverCircles = action.payload.map(function (circle) {
	            return circle.id;
	          });
	          _context.next = 3;
	          return (0, _effects.put)({
	            type: _permissions.consts.UPDATE,
	            payload: { caregiverCircles: caregiverCircles }
	          });
	
	        case 3:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateCaregiverCirclesSaga() {
	  return _regenerator2.default.wrap(function updateCaregiverCirclesSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([GET_CAREGIVER_CIRCLES], updateCaregiverCirclesWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function updateDependentsListWorker() {
	  var verifiedDependentsList, dependentsIdList;
	  return _regenerator2.default.wrap(function updateDependentsListWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors.selectVerifiedGuardianDependentsList);
	
	        case 2:
	          verifiedDependentsList = _context3.sent;
	          dependentsIdList = verifiedDependentsList.map(function (item) {
	            return (0, _get2.default)(item, 'dependent.id');
	          });
	          _context3.next = 6;
	          return (0, _effects.put)({
	            type: _permissions.consts.UPDATE,
	            payload: { dependentsList: dependentsIdList }
	          });
	
	        case 6:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function updateDependentsListSaga() {
	  return _regenerator2.default.wrap(function updateDependentsListSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeEvery)([GET_DEPENDENTS_LIST], updateDependentsListWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	/*
	 * Saga for updating logged user id to context/permissions state
	 */
	
	function updateLoggedUserWorker(action) {
	  var payload, loggedUserId;
	  return _regenerator2.default.wrap(function updateLoggedUserWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          payload = action.payload;
	          loggedUserId = (0, _get2.default)(payload, 'user.id') || (0, _get2.default)(payload, 'authentication.user.id');
	          _context5.next = 4;
	          return (0, _effects.put)({
	            type: _permissions.consts.UPDATE,
	            payload: { loggedUserId: loggedUserId }
	          });
	
	        case 4:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function updateLoggedUserIdSaga() {
	  return _regenerator2.default.wrap(function updateLoggedUserIdSaga$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.takeEvery)([ADD_LOGGED_USER, UPDATE_LOGGED_USER, REMOVE_LOGGED_USER], updateLoggedUserWorker);
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	/*
	 * Saga for updating target user id to context/permissions state
	 */
	
	function updateTargetUserWorker(action) {
	  var targetUserId;
	  return _regenerator2.default.wrap(function updateTargetUserWorker$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          targetUserId = (0, _get2.default)(action.payload, 'id');
	          _context7.next = 3;
	          return (0, _effects.put)({
	            type: _permissions.consts.UPDATE,
	            payload: {
	              targetUserId: targetUserId,
	              targetUser: action.payload
	            }
	          });
	
	        case 3:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function updateTargetUserIdSaga() {
	  return _regenerator2.default.wrap(function updateTargetUserIdSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.takeEvery)([SET_TARGET_USER, REMOVE_TARGET_USER], updateTargetUserWorker);
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}

/***/ }),
/* 4047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.updateTargetUserSaga = updateTargetUserSaga;
	exports.setTargetUserSaga = setTargetUserSaga;
	exports.fetchTargetUserSaga = fetchTargetUserSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(23);
	
	var _getUser = __webpack_require__(202);
	
	var _getFamilyMember = __webpack_require__(874);
	
	var _getProvider = __webpack_require__(1328);
	
	var _getProviderMember = __webpack_require__(1327);
	
	var _getParentProvider = __webpack_require__(680);
	
	var _getUserProfile = __webpack_require__(828);
	
	var _editPatient = __webpack_require__(218);
	
	var _editPatientByProvider = __webpack_require__(423);
	
	var _editProvider = __webpack_require__(424);
	
	var _editUser = __webpack_require__(136);
	
	var _changeSettings = __webpack_require__(538);
	
	var _invitations = __webpack_require__(1901);
	
	var _upcoming = __webpack_require__(309);
	
	var _targetUser = __webpack_require__(415);
	
	var _index = __webpack_require__(216);
	
	var _constants = __webpack_require__(94);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateTargetUserWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateTargetUserSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(setTargetUserWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(setTargetUserSaga),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(fetchTargetUserWorker),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(fetchTargetUserSaga);
	
	/*
	 * TODO:
	 * - separate edit mode for logged and target user
	 * - sidebar tabs changing error
	 */
	
	// actions
	var GET_USER = _getUser.consts.SUCCEED;
	var GET_FAMILY_MEMBER = _getFamilyMember.consts.SUCCEED;
	var GET_PROVIDER = _getProvider.consts.SUCCEED;
	var GET_PROVIDER_MEMBER = _getProviderMember.consts.SUCCEED;
	var GET_PARENT_PROVIDER = _getParentProvider.consts.SUCCEED;
	var EDIT_PATIENT = _editPatient.consts.SUCCEED;
	var EDIT_PATIENT_BY_PROVIDER = _editPatientByProvider.consts.SUCCEED;
	var EDIT_PROVIDER = _editProvider.consts.SUCCEED;
	var EDIT_USER = _editUser.consts.SUCCEED;
	var EDIT_SETTINGS = _changeSettings.consts.SUCCEED;
	var GET_USER_PROFILE = _getUserProfile.consts.SUCCEED;
	// logout
	
	// actions to clear data when target user changes completely
	var CLEAR_ACTIONS = [_invitations.consts.CLEAR, _upcoming.consts.CLEAR, _targetUser.consts.REMOVE];
	
	var getUserAction = function getUserAction(userType) {
	  switch (userType) {
	    case 'family-member':
	      return _getFamilyMember.consts.SEND;
	    case 'provider':
	      return _getProvider.consts.SEND;
	    case 'provider-member':
	      return _getProviderMember.consts.SEND;
	    case 'parent-provider':
	      return _getParentProvider.consts.SEND;
	    case 'user':
	      return _getUserProfile.consts.SEND;
	    case 'profile':
	    default:
	      return _getUser.consts.SEND;
	  }
	};
	
	/*
	 * Saga for updating target user data to context/targetUser state
	 */
	function updateTargetUserWorker(action) {
	  return _regenerator2.default.wrap(function updateTargetUserWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)({
	            type: _targetUser.consts.UPDATE,
	            payload: action.payload
	          });
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateTargetUserSaga() {
	  return _regenerator2.default.wrap(function updateTargetUserSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([EDIT_PATIENT, EDIT_PATIENT_BY_PROVIDER, EDIT_PROVIDER, EDIT_USER, EDIT_SETTINGS], updateTargetUserWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	/*
	 * Saga for setting target user data to context
	 */
	function setTargetUserWorker(action) {
	  return _regenerator2.default.wrap(function setTargetUserWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)({
	            type: _targetUser.consts.SET,
	            payload: action.payload
	          });
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function setTargetUserSaga() {
	  return _regenerator2.default.wrap(function setTargetUserSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeEvery)([GET_USER, GET_FAMILY_MEMBER, GET_PROVIDER, GET_PROVIDER_MEMBER, GET_PARENT_PROVIDER, GET_USER_PROFILE], setTargetUserWorker);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	/*
	  Saga for fetching user profile when context.targetUserId is changed
	 */
	
	function fetchTargetUserWorker(action) {
	  var currentTargetUser, defaultBehavior, id, userType, userId;
	  return _regenerator2.default.wrap(function fetchTargetUserWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(_selectors.targetUserSelector);
	
	        case 2:
	          currentTargetUser = _context5.sent;
	          defaultBehavior = (0, _index.isDefaultBehavior)(action.payload);
	          id = defaultBehavior ? action.payload : action.payload.id;
	          userType = defaultBehavior ? 'profile' : action.payload.type;
	          userId = defaultBehavior ? null : action.payload.userId;
	
	          if (!(currentTargetUser.id !== id)) {
	            _context5.next = 10;
	            break;
	          }
	
	          _context5.next = 10;
	          return CLEAR_ACTIONS.map(function (type) {
	            return (0, _effects.put)({ type: type });
	          });
	
	        case 10:
	          if (!id) {
	            _context5.next = 15;
	            break;
	          }
	
	          _context5.next = 13;
	          return (0, _effects.put)({
	            type: getUserAction(userType),
	            payload: { userId: userId, id: id }
	          });
	
	        case 13:
	          _context5.next = 17;
	          break;
	
	        case 15:
	          _context5.next = 17;
	          return (0, _effects.put)({
	            type: _constants2.default.SOCIAL_CHAT_INIT_SELECTION
	          });
	
	        case 17:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function fetchTargetUserSaga() {
	  return _regenerator2.default.wrap(function fetchTargetUserSaga$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.takeEvery)(_index.consts.SET_TARGET_USER_ID, fetchTargetUserWorker);
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}

/***/ }),
/* 4048 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.addTeamUserSaga = addTeamUserSaga;
	
	var _effects = __webpack_require__(14);
	
	var _teamUser = __webpack_require__(1884);
	
	var _getTeamUser = __webpack_require__(876);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(addTeamUserWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(addTeamUserSaga);
	
	function addTeamUserWorker(action) {
	  return _regenerator2.default.wrap(function addTeamUserWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)({
	            type: _teamUser.consts.ADD,
	            payload: action.payload
	          });
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function addTeamUserSaga() {
	  return _regenerator2.default.wrap(function addTeamUserSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_getTeamUser.consts.SUCCEED, addTeamUserWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var _appointmentListReq2 = _interopRequireDefault(_appointmentListReq);
	
	var _locationsReq = __webpack_require__(1275);
	
	var _locationsReq2 = _interopRequireDefault(_locationsReq);
	
	var _changeRoomReq = __webpack_require__(657);
	
	var _changeRoomReq2 = _interopRequireDefault(_changeRoomReq);
	
	var _changeStatusReq = __webpack_require__(525);
	
	var _changeStatusReq2 = _interopRequireDefault(_changeStatusReq);
	
	var _pinReq = __webpack_require__(837);
	
	var _pinReq2 = _interopRequireDefault(_pinReq);
	
	var _appointmentLocationsReq = __webpack_require__(1274);
	
	var _appointmentLocationsReq2 = _interopRequireDefault(_appointmentLocationsReq);
	
	var _changePaidStatusReq = __webpack_require__(835);
	
	var _changePaidStatusReq2 = _interopRequireDefault(_changePaidStatusReq);
	
	var _changeRoomModal = __webpack_require__(1269);
	
	var _changeRoomModal2 = _interopRequireDefault(_changeRoomModal);
	
	var _editPaymentAmountModal = __webpack_require__(1271);
	
	var _editPaymentAmountModal2 = _interopRequireDefault(_editPaymentAmountModal);
	
	var _changePaidStatusModal = __webpack_require__(1268);
	
	var _changePaidStatusModal2 = _interopRequireDefault(_changePaidStatusModal);
	
	var _filter = __webpack_require__(833);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _record = __webpack_require__(834);
	
	var _record2 = _interopRequireDefault(_record);
	
	var _validatePatientInfoReq = __webpack_require__(1276);
	
	var _validatePatientInfoReq2 = _interopRequireDefault(_validatePatientInfoReq);
	
	var _createAppointmentReq = __webpack_require__(836);
	
	var _createAppointmentReq2 = _interopRequireDefault(_createAppointmentReq);
	
	var _appointmentDetailsReq = __webpack_require__(524);
	
	var _appointmentDetailsReq2 = _interopRequireDefault(_appointmentDetailsReq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  appointmentList: _appointmentListReq2.default,
	  locations: _locationsReq2.default,
	  changeRoomModal: _changeRoomModal2.default,
	  editPaymentAmountModal: _editPaymentAmountModal2.default,
	  changePaidStatusModal: _changePaidStatusModal2.default,
	  changeStatus: _changeStatusReq2.default,
	  pinAppointment: _pinReq2.default,
	  updateRoom: _changeRoomReq2.default,
	  filter: _filter2.default,
	  appointmentLocations: _appointmentLocationsReq2.default,
	  record: _record2.default,
	  validatePatientInfo: _validatePatientInfoReq2.default,
	  createAppointmentReq: _createAppointmentReq2.default,
	  changePaidStatus: _changePaidStatusReq2.default,
	  appointmentDetailsReq: _appointmentDetailsReq2.default
	});

/***/ }),
/* 4050 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _normalizr = __webpack_require__(1576);
	
	var status = new _normalizr.schema.Entity('statuses');
	var service = new _normalizr.schema.Entity('services', {
	  statuses: [status]
	});
	var location = new _normalizr.schema.Entity('locations', {
	  services: [service]
	});
	
	exports.default = function (data) {
	  return (0, _normalizr.normalize)(data, { locations: [location] });
	};

/***/ }),
/* 4051 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.addRecordWorker = addRecordWorker;
	exports.default = addRecordSaga;
	
	var _effects = __webpack_require__(14);
	
	var _reactRouter = __webpack_require__(42);
	
	var _createAppointmentReq = __webpack_require__(836);
	
	var createAppointment = _interopRequireWildcard(_createAppointmentReq);
	
	var _record = __webpack_require__(834);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(addRecordWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(addRecordSaga);
	
	function addRecordWorker() {
	  return _regenerator2.default.wrap(function addRecordWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_record.actions.clear());
	
	        case 2:
	          _reactRouter.browserHistory.replace(_routes.DASHBOARD);
	
	        case 3:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function addRecordSaga() {
	  return _regenerator2.default.wrap(function addRecordSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(createAppointment.consts.SUCCEED, addRecordWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.appointmentDetailsWorker = appointmentDetailsWorker;
	exports.default = appointmentDetailsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _appointmentDetailsReq = __webpack_require__(524);
	
	var appointmentDetails = _interopRequireWildcard(_appointmentDetailsReq);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var appointmentActions = _interopRequireWildcard(_appointmentListReq);
	
	var _selectors = __webpack_require__(134);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(appointmentDetailsWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(appointmentDetailsSaga);
	
	function appointmentDetailsWorker() {
	  var currentAppointment;
	  return _regenerator2.default.wrap(function appointmentDetailsWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectCurrentAppointmentDetails);
	
	        case 2:
	          currentAppointment = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)(appointmentActions.actions.setActiveAppointment(currentAppointment));
	
	        case 5:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function appointmentDetailsSaga() {
	  return _regenerator2.default.wrap(function appointmentDetailsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(appointmentDetails.consts.SUCCEED, appointmentDetailsWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4053 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.changeStatus = changeStatus;
	exports.default = addRecordSaga;
	
	var _effects = __webpack_require__(14);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var appointmentListReq = _interopRequireWildcard(_appointmentListReq);
	
	var _changeStatusReq = __webpack_require__(525);
	
	var changeStatusReq = _interopRequireWildcard(_changeStatusReq);
	
	var _props = __webpack_require__(41);
	
	var _popup = __webpack_require__(76);
	
	var popup = _interopRequireWildcard(_popup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(changeStatus),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(addRecordSaga);
	
	function changeStatus(_ref) {
	  var payload = _ref.payload;
	  var id, status, statusId, statusChangeInfoRequired;
	  return _regenerator2.default.wrap(function changeStatus$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          id = payload.id, status = payload.status;
	          statusId = status.id, statusChangeInfoRequired = status.statusChangeInfoRequired;
	
	          if (!statusChangeInfoRequired) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 5;
	          return (0, _effects.put)({
	            type: popup.consts.SHOW,
	            payload: {
	              contentType: _props.UI_POPUP_TYPES.DASHBOARD_CHANGE_STATUS,
	              contentOptions: { id: id, status: status }
	            }
	          });
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.take)(changeStatusReq.consts.SUCCEED);
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)(appointmentListReq.actions.removeItem({ id: id }));
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: popup.consts.HIDE
	          });
	
	        case 11:
	          _context.next = 15;
	          break;
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)(changeStatusReq.actions.send({ id: id, statusId: statusId }));
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function addRecordSaga() {
	  return _regenerator2.default.wrap(function addRecordSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(changeStatusReq.consts.UPDATE, changeStatus);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.initFilter = initFilter;
	exports.firstDashboardLoadWorker = firstDashboardLoadWorker;
	exports.default = fetchFilteredAppointmentsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _filter = __webpack_require__(833);
	
	var _locationsReq = __webpack_require__(1275);
	
	var locations = _interopRequireWildcard(_locationsReq);
	
	var _selectors = __webpack_require__(134);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var appointmentList = _interopRequireWildcard(_appointmentListReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(initFilter),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(firstDashboardLoadWorker),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(fetchFilteredAppointmentsSaga);
	
	function initFilter() {
	  var statusesList, displayableByDefault, displayableByDefaultIds;
	  return _regenerator2.default.wrap(function initFilter$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectDashboardFilterStatuses);
	
	        case 2:
	          statusesList = _context.sent;
	          displayableByDefault = statusesList.filter(function (status) {
	            return status.displayableByDefaultOnDashboard === true;
	          });
	          displayableByDefaultIds = displayableByDefault.map(function (status) {
	            return status.id;
	          });
	          _context.next = 7;
	          return (0, _effects.put)(_filter.dashboardFilterActions.addDisplayableByDefault({
	            statuses: [].concat((0, _toConsumableArray3.default)(displayableByDefaultIds))
	          }));
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function firstDashboardLoadWorker() {
	  var _ref, _ref2, error;
	
	  return _regenerator2.default.wrap(function firstDashboardLoadWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)(locations.actions.send({ assignedToUser: true }));
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.race)([(0, _effects.take)(locations.actions.errorEncountered), (0, _effects.take)(locations.actions.succeed)]);
	
	        case 4:
	          _ref = _context2.sent;
	          _ref2 = (0, _slicedToArray3.default)(_ref, 1);
	          error = _ref2[0];
	
	          if (!error) {
	            _context2.next = 10;
	            break;
	          }
	
	          _context2.next = 10;
	          return (0, _effects.cancel)();
	
	        case 10:
	          _context2.next = 12;
	          return (0, _effects.call)(initFilter);
	
	        case 12:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function fetchFilteredAppointmentsSaga() {
	  return _regenerator2.default.wrap(function fetchFilteredAppointmentsSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(appointmentList.actions.initialLoad, firstDashboardLoadWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4055 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = intervalSaga;
	
	var _effects = __webpack_require__(14);
	
	var _reduxSaga = __webpack_require__(485);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var appointmentList = _interopRequireWildcard(_appointmentListReq);
	
	var _config = __webpack_require__(1270);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(intervalSaga);
	
	function makeInterval() {
	  return (0, _reduxSaga.eventChannel)(function (emitter) {
	    var iv = setInterval(function () {
	      return emitter(true);
	    }, _config.CHECK_OVERDUE_INTERVAL_TIME);
	    return function () {
	      return clearInterval(iv);
	    };
	  });
	}
	
	function intervalSaga() {
	  var chan;
	  return _regenerator2.default.wrap(function intervalSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(makeInterval);
	
	        case 2:
	          chan = _context.sent;
	          _context.prev = 3;
	
	        case 4:
	          if (false) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.take)(chan);
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)(appointmentList.actions.markOverdue());
	
	        case 9:
	          _context.next = 4;
	          break;
	
	        case 11:
	          _context.prev = 11;
	          _context.next = 14;
	          return (0, _effects.cancelled)();
	
	        case 14:
	          if (!_context.sent) {
	            _context.next = 16;
	            break;
	          }
	
	          chan.close();
	
	        case 16:
	          return _context.finish(11);
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[3,, 11, 17]]);
	}

/***/ }),
/* 4056 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = realTimeCreate;
	
	var _effects = __webpack_require__(14);
	
	var _validateAppointmentByFilter = __webpack_require__(1382);
	
	var _selectors = __webpack_require__(134);
	
	var _config = __webpack_require__(1270);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var appointmentList = _interopRequireWildcard(_appointmentListReq);
	
	var _realTimeUpdates = __webpack_require__(1273);
	
	var wsActions = _interopRequireWildcard(_realTimeUpdates);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleRealTimeCreate),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(realTimeCreate);
	
	function handleRealTimeCreate(_ref) {
	  var payload = _ref.payload;
	  var filterOptions, fitFilter, id, clearTask;
	  return _regenerator2.default.wrap(function handleRealTimeCreate$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors.selectDashboardNotEmptyFilterState);
	
	        case 2:
	          filterOptions = _context3.sent;
	          fitFilter = (0, _validateAppointmentByFilter.validateAppointment)(payload, filterOptions);
	
	          if (fitFilter) {
	            _context3.next = 7;
	            break;
	          }
	
	          _context3.next = 7;
	          return (0, _effects.cancel)();
	
	        case 7:
	          id = payload.id;
	          _context3.next = 10;
	          return (0, _effects.put)(appointmentList.actions.insert((0, _extends3.default)({}, payload, { isnew: true })));
	
	        case 10:
	          _context3.next = 12;
	          return (0, _effects.spawn)( /*#__PURE__*/_regenerator2.default.mark(function asyncClear() {
	            return _regenerator2.default.wrap(function asyncClear$(_context2) {
	              while (1) {
	                switch (_context2.prev = _context2.next) {
	                  case 0:
	                    _context2.next = 2;
	                    return (0, _effects.takeEvery)(appointmentList.consts.PAGE_LEAVE, /*#__PURE__*/_regenerator2.default.mark(function leavePage() {
	                      return _regenerator2.default.wrap(function leavePage$(_context) {
	                        while (1) {
	                          switch (_context.prev = _context.next) {
	                            case 0:
	                              _context.next = 2;
	                              return (0, _effects.cancel)(clearTask);
	
	                            case 2:
	                            case 'end':
	                              return _context.stop();
	                          }
	                        }
	                      }, leavePage, this);
	                    }));
	
	                  case 2:
	                    _context2.next = 4;
	                    return (0, _effects.delay)(_config.NEW_APPOINTMENT_HIGHLIGHT_TIME);
	
	                  case 4:
	                    _context2.next = 6;
	                    return (0, _effects.put)(appointmentList.actions.removeNewStatus({ id: id }));
	
	                  case 6:
	                  case 'end':
	                    return _context2.stop();
	                }
	              }
	            }, asyncClear, this);
	          }));
	
	        case 12:
	          clearTask = _context3.sent;
	
	        case 13:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function realTimeCreate() {
	  return _regenerator2.default.wrap(function realTimeCreate$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(wsActions.consts.CREATED, handleRealTimeCreate);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _actionsMap;
	
	exports.default = realTimeUpdate;
	
	var _effects = __webpack_require__(14);
	
	var _validateAppointmentByFilter = __webpack_require__(1382);
	
	var _selectors = __webpack_require__(134);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var appointmentList = _interopRequireWildcard(_appointmentListReq);
	
	var _realTimeUpdates = __webpack_require__(1273);
	
	var wsActions = _interopRequireWildcard(_realTimeUpdates);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleRealTimeUpdate),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(realTimeUpdate);
	
	var actionsMap = (_actionsMap = {}, (0, _defineProperty3.default)(_actionsMap, wsActions.consts.CHANGE_STATUS, {
	  action: appointmentList.actions.updateViaWs,
	  validate: _validateAppointmentByFilter.validateAppointmentByDate
	}), (0, _defineProperty3.default)(_actionsMap, wsActions.consts.CHANGE_PAYMENT_STATUS, {
	  action: appointmentList.actions.updateViaWs,
	  validate: _validateAppointmentByFilter.validateAppointmentByDate
	}), (0, _defineProperty3.default)(_actionsMap, wsActions.consts.UPDATE_COPAY, {
	  action: appointmentList.actions.updateViaWs,
	  validate: _validateAppointmentByFilter.validateAppointment
	}), (0, _defineProperty3.default)(_actionsMap, wsActions.consts.CHANGE_ROOM, {
	  action: appointmentList.actions.updateViaWs,
	  validate: _validateAppointmentByFilter.validateAppointment
	}), (0, _defineProperty3.default)(_actionsMap, wsActions.consts.PIN, {
	  action: appointmentList.actions.pinViaWs,
	  validate: _validateAppointmentByFilter.validateAppointment
	}), (0, _defineProperty3.default)(_actionsMap, wsActions.consts.REMOVE_FROM_DASHBOARD, {
	  action: appointmentList.actions.removeItem,
	  validate: _validateAppointmentByFilter.validateAppointment
	}), _actionsMap);
	
	function handleRealTimeUpdate(_ref) {
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  var filterOptions, _actionsMap$type, action, validate, fitFilter;
	
	  return _regenerator2.default.wrap(function handleRealTimeUpdate$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectDashboardNotEmptyFilterState);
	
	        case 2:
	          filterOptions = _context.sent;
	          _actionsMap$type = actionsMap[type], action = _actionsMap$type.action, validate = _actionsMap$type.validate;
	          fitFilter = validate(payload, filterOptions);
	
	          if (fitFilter) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 8;
	          return (0, _effects.cancel)();
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)(action(payload));
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function realTimeUpdate() {
	  return _regenerator2.default.wrap(function realTimeUpdate$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([wsActions.consts.REMOVE_FROM_DASHBOARD, wsActions.consts.CHANGE_PAYMENT_STATUS, wsActions.consts.UPDATE_COPAY, wsActions.consts.CHANGE_STATUS, wsActions.consts.CHANGE_ROOM, wsActions.consts.PIN], handleRealTimeUpdate);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4058 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = reloadOnFilterChange;
	
	var _effects = __webpack_require__(14);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(1270);
	
	var _filterTypes = __webpack_require__(1272);
	
	var _selectors = __webpack_require__(134);
	
	var _appointmentListReq = __webpack_require__(184);
	
	var appointmentList = _interopRequireWildcard(_appointmentListReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchFilteredAppointments),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(reloadOnFilterChange);
	
	function fetchFilteredAppointments() {
	  var _ref, originDate, rest, date, options;
	
	  return _regenerator2.default.wrap(function fetchFilteredAppointments$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectDashboardNotEmptyFilterState);
	
	        case 2:
	          _ref = _context.sent;
	          originDate = _ref.date;
	          rest = (0, _objectWithoutProperties3.default)(_ref, ['date']);
	          date = (0, _moment2.default)(originDate).startOf('day').toISOString(true);
	          options = (0, _extends3.default)({}, rest, { date: encodeURIComponent(date) });
	          _context.next = 9;
	          return (0, _effects.put)(appointmentList.actions.send(options));
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function reloadOnFilterChange() {
	  return _regenerator2.default.wrap(function reloadOnFilterChange$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.debounce)(_config.FILTER_APPLY_DEBOUNCE_TIME, _filterTypes.DASHBOARD_FILTER_TYPES.SET_FILTER, fetchFilteredAppointments);
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.takeLatest)(_filterTypes.DASHBOARD_FILTER_TYPES.ADD_DISPLAYABLE_BY_DEFAULT, fetchFilteredAppointments);
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.savePatientInfoWorker = savePatientInfoWorker;
	exports.default = savePatientInfoSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRouter = __webpack_require__(42);
	
	var _errors = __webpack_require__(120);
	
	var _formFields = __webpack_require__(38);
	
	var _record = __webpack_require__(834);
	
	var _validatePatientInfoReq = __webpack_require__(1276);
	
	var validatePatientInfoReq = _interopRequireWildcard(_validatePatientInfoReq);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(savePatientInfoWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handlePatientInfoError),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(savePatientInfoSaga);
	
	function savePatientInfoWorker(action) {
	  var patient, _ref, type, payload;
	
	  return _regenerator2.default.wrap(function savePatientInfoWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          patient = action.payload.data;
	          _context.next = 3;
	          return (0, _effects.put)(validatePatientInfoReq.actions.send({ patient: patient }));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.take)([validatePatientInfoReq.consts.SUCCEED, validatePatientInfoReq.consts.REJECTED]);
	
	        case 5:
	          _ref = _context.sent;
	          type = _ref.type;
	          payload = _ref.payload;
	
	          if (!(type === validatePatientInfoReq.consts.REJECTED)) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.call)(handlePatientInfoError, payload);
	
	        case 11:
	          _context.next = 16;
	          break;
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)(_record.actions.savePatientInfo(patient));
	
	        case 15:
	          _reactRouter.browserHistory.push(_routes.DASHBOARD_RECORD + '/' + _routes.DASHBOARD_VISIT_INFO);
	
	        case 16:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handlePatientInfoError(payload) {
	  var code, user, loginType, fieldName, messageId, _messageId;
	
	  return _regenerator2.default.wrap(function handlePatientInfoError$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          code = (0, _get2.default)(payload, 'error.code');
	          user = (0, _get2.default)(payload, 'error.meta.otherUserName');
	          _context2.t0 = code;
	          _context2.next = _context2.t0 === _errors.ERROR_CODES.DASHBOARD_LOGIN_TAKEN ? 5 : _context2.t0 === _errors.ERROR_CODES.DASHBOARD_SSN_TAKEN ? 11 : _context2.t0 === _errors.ERROR_CODES.RECORD_INVALID ? 15 : 18;
	          break;
	
	        case 5:
	          loginType = (0, _get2.default)(payload, 'error.meta.loginType');
	          fieldName = loginType === _formFields.PROFILE_FIELDS_TYPES.EMAIL ? 'Email' : 'Phone';
	          messageId = {
	            id: _errors.DASHBOARD_RECORD_ERROR[code],
	            values: {
	              name: user,
	              field: fieldName
	            }
	          };
	          _context2.next = 10;
	          return (0, _effects.put)(_record.actions.savePatientInfoError(messageId));
	
	        case 10:
	          return _context2.abrupt('return', _context2.sent);
	
	        case 11:
	          _messageId = _errors.DASHBOARD_RECORD_ERROR[code];
	          _context2.next = 14;
	          return (0, _effects.put)(_record.actions.savePatientInfoError({
	            id: _messageId,
	            values: {
	              name: user
	            }
	          }));
	
	        case 14:
	          return _context2.abrupt('return', _context2.sent);
	
	        case 15:
	          _context2.next = 17;
	          return (0, _effects.put)(_record.actions.saveCommonErrors((0, _get2.default)(payload, 'error')));
	
	        case 17:
	          return _context2.abrupt('return', _context2.sent);
	
	        case 18:
	          _context2.next = 20;
	          return (0, _effects.put)(_record.actions.savePatientInfoError({
	            id: 'common.error'
	          }));
	
	        case 20:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function savePatientInfoSaga() {
	  return _regenerator2.default.wrap(function savePatientInfoSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_record.consts.VALIDATE_PATIENT_INFO, savePatientInfoWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4060 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _processConstants = __webpack_require__(4062);
	
	var _processConstants2 = _interopRequireDefault(_processConstants);
	
	var _sortArrayByPriority = __webpack_require__(4237);
	
	var _sortArrayByPriority2 = _interopRequireDefault(_sortArrayByPriority);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleConsts = function handleConsts(state, action) {
	  var payload = action.payload;
	
	  // lead given data to a standard needed on front form
	
	  var processedConsts = (0, _processConstants2.default)(payload);
	
	  // change initial gender types sorting according to types priority
	  var genderTypes = processedConsts.genderTypes;
	
	  var priority = ['f', 'm'];
	  processedConsts.genderTypes = (0, _sortArrayByPriority2.default)(genderTypes, priority);
	
	  return processedConsts;
	};
	
	exports.default = handleConsts;

/***/ }),
/* 4061 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.processedConsts = exports.formActions = exports.SUCCEED = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _redux = __webpack_require__(98);
	
	var _reduxActions = __webpack_require__(1654);
	
	var _reducer = __webpack_require__(1934);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _handleConstants = __webpack_require__(4060);
	
	var _handleConstants2 = _interopRequireDefault(_handleConstants);
	
	var _constants = __webpack_require__(1278);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _privacyPolicies = __webpack_require__(1281);
	
	var _privacyPolicies2 = _interopRequireDefault(_privacyPolicies);
	
	var _appStateReq = __webpack_require__(526);
	
	var _appStateReq2 = _interopRequireDefault(_appStateReq);
	
	var _countries = __webpack_require__(1279);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	var _optAuthCodes = __webpack_require__(1280);
	
	var _optAuthCodes2 = _interopRequireDefault(_optAuthCodes);
	
	var _countryDetails = __webpack_require__(527);
	
	var _countryDetails2 = _interopRequireDefault(_countryDetails);
	
	var _configurations = __webpack_require__(1277);
	
	var _configurations2 = _interopRequireDefault(_configurations);
	
	var _publicConstants = __webpack_require__(838);
	
	var _publicConstants2 = _interopRequireDefault(_publicConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SUCCEED = exports.SUCCEED = 'data/constants/SUCCEED';
	var formActions = exports.formActions = {
	  handleConsts: (0, _reduxActions.createAction)(SUCCEED)
	};
	
	var processedConsts = exports.processedConsts = (0, _reducer2.default)({}, (0, _defineProperty3.default)({}, SUCCEED, _handleConstants2.default));
	
	exports.default = (0, _redux.combineReducers)({
	  constants: _constants2.default,
	  appState: _appStateReq2.default,
	  countries: _countries2.default,
	  optAuthCodes: _optAuthCodes2.default,
	  configurations: _configurations2.default,
	  countryDetails: _countryDetails2.default,
	  processedConsts: processedConsts,
	  privacyPolicies: _privacyPolicies2.default,
	  publicConstants: _publicConstants2.default
	});

/***/ }),
/* 4062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _isPlainObject = __webpack_require__(248);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isArray = __webpack_require__(96);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _keys3 = __webpack_require__(249);
	
	var _keys4 = _interopRequireDefault(_keys3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processConstants = function processConstants(constantsSets) {
	  return (0, _keys4.default)(constantsSets).reduce(function (acc, key) {
	    var currentConst = constantsSets[key];
	
	    if ((0, _isPlainObject2.default)(currentConst) || (0, _isArray2.default)(currentConst)) {
	      var iterableConsts = (0, _isPlainObject2.default)(currentConst) ? (0, _keys2.default)(currentConst) : currentConst;
	      // eslint-disable-next-line no-param-reassign
	      acc[key] = iterableConsts.reduce(function (prev, cur) {
	        prev.push({
	          label: (0, _isPlainObject2.default)(cur) ? cur.name : cur,
	          value: (0, _isPlainObject2.default)(currentConst) ? currentConst[cur] : cur
	        });
	        return prev;
	      }, []);
	    } else {
	      acc[key] = currentConst;
	    }
	
	    return acc;
	  }, {});
	}; // replace initial object with key-value pairs or array of strings
	// with array of objects where:
	// 'label' equals initial object prop name / array item value,
	// 'value' equals object key value / array item value
	exports.default = processConstants;

/***/ }),
/* 4063 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = dataRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _countries = __webpack_require__(1279);
	
	var countries = _interopRequireWildcard(_countries);
	
	var _countryDetails = __webpack_require__(527);
	
	var countryDetails = _interopRequireWildcard(_countryDetails);
	
	var _configurations = __webpack_require__(1277);
	
	var configurations = _interopRequireWildcard(_configurations);
	
	var _publicConstants = __webpack_require__(838);
	
	var publicConstants = _interopRequireWildcard(_publicConstants);
	
	var _optAuthCodes = __webpack_require__(1280);
	
	var optAuthCodes = _interopRequireWildcard(_optAuthCodes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(dataRootSaga);
	
	function dataRootSaga() {
	  return _regenerator2.default.wrap(function dataRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(countries.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(countryDetails.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(configurations.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(publicConstants.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(optAuthCodes.watcher);
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _assignedGuardianListReq = __webpack_require__(1282);
	
	var _assignedGuardianListReq2 = _interopRequireDefault(_assignedGuardianListReq);
	
	var _documentsCompletionReq = __webpack_require__(1284);
	
	var _documentsCompletionReq2 = _interopRequireDefault(_documentsCompletionReq);
	
	var _assignmentFetchReq = __webpack_require__(1283);
	
	var _assignmentFetchReq2 = _interopRequireDefault(_assignmentFetchReq);
	
	var _documentsUploadReq = __webpack_require__(839);
	
	var _documentsUploadReq2 = _interopRequireDefault(_documentsUploadReq);
	
	var _documentsDeleteReq = __webpack_require__(658);
	
	var _documentsDeleteReq2 = _interopRequireDefault(_documentsDeleteReq);
	
	var _documentsFetchListReq = __webpack_require__(1886);
	
	var _documentsFetchListReq2 = _interopRequireDefault(_documentsFetchListReq);
	
	var _generalInfoReq = __webpack_require__(1285);
	
	var _generalInfoReq2 = _interopRequireDefault(_generalInfoReq);
	
	var _personalInfoReq = __webpack_require__(659);
	
	var _personalInfoReq2 = _interopRequireDefault(_personalInfoReq);
	
	var _relationshipReq = __webpack_require__(1286);
	
	var _relationshipReq2 = _interopRequireDefault(_relationshipReq);
	
	var _progress = __webpack_require__(4065);
	
	var _progress2 = _interopRequireDefault(_progress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  assignedGuardianList: _assignedGuardianListReq2.default,
	  documentsCompletion: _documentsCompletionReq2.default,
	  documentsUpload: _documentsUploadReq2.default,
	  assignment: _assignmentFetchReq2.default,
	  documentsDelete: _documentsDeleteReq2.default,
	  documentsList: _documentsFetchListReq2.default,
	  generalInfo: _generalInfoReq2.default,
	  personalInfo: _personalInfoReq2.default,
	  relationship: _relationshipReq2.default,
	  progress: _progress2.default
	});

/***/ }),
/* 4065 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _registrationSteps;
	
	var _progress = __webpack_require__(121);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  validating: true,
	  currentStep: _progress.DEPENDENT_FORM_STEPS.ROLE,
	  id: null,
	  role: null,
	  dependent: null,
	  registrationCompleted: false,
	  careUserCreator: true,
	  status: 'new',
	  submitRedirect: _constants.DEPENDENT_FORM_SUBMIT_REDIRECT.PROFILE,
	  metadata: {
	    documentationStepEnabled: false
	  },
	  registrationSteps: (_registrationSteps = {}, (0, _defineProperty3.default)(_registrationSteps, _progress.DEPENDENT_FORM_STEPS.PERSONAL, false), (0, _defineProperty3.default)(_registrationSteps, _progress.DEPENDENT_FORM_STEPS.GENERAL, false), (0, _defineProperty3.default)(_registrationSteps, _progress.DEPENDENT_FORM_STEPS.DOCUMENTS, false), (0, _defineProperty3.default)(_registrationSteps, _progress.DEPENDENT_FORM_STEPS.RELATION, false), _registrationSteps)
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _progress.DEPENDENT_FORM_PROGRESS_TYPES.SET_ROLE:
	      {
	        return (0, _extends3.default)({}, state, { role: payload });
	      }
	
	    case _progress.DEPENDENT_FORM_PROGRESS_TYPES.SET_STEP:
	      {
	        return (0, _extends3.default)({}, state, { currentStep: payload });
	      }
	
	    case _progress.DEPENDENT_FORM_PROGRESS_TYPES.SET_SUBMIT_REDIRECT:
	      {
	        return (0, _extends3.default)({}, state, { submitRedirect: payload });
	      }
	
	    case _progress.DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE:
	      {
	        return (0, _extends3.default)({}, state, { validating: true });
	      }
	
	    case _progress.DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE_FINISH:
	      {
	        return (0, _extends3.default)({}, state, { validating: false });
	      }
	
	    case _progress.DEPENDENT_FORM_PROGRESS_TYPES.UPDATE_DEPENDENT:
	      {
	        var registrationCompleted = payload.registrationCompleted,
	            registrationSteps = payload.registrationSteps,
	            metadata = payload.metadata,
	            careUserCreator = payload.careUserCreator,
	            role = payload.careRole,
	            dependent = payload.dependent,
	            status = payload.status,
	            id = payload.id;
	
	
	        return (0, _extends3.default)({}, state, {
	          registrationCompleted: registrationCompleted,
	          registrationSteps: registrationSteps,
	          metadata: metadata,
	          careUserCreator: careUserCreator,
	          dependent: dependent,
	          status: status,
	          role: role,
	          id: id
	        });
	      }
	
	    case _progress.DEPENDENT_FORM_PROGRESS_TYPES.RESET:
	      {
	        return initialState;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 4066 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _assignedGuardianListReq = __webpack_require__(1282);
	
	var _documentsCompletionReq = __webpack_require__(1284);
	
	var _assignmentFetchReq = __webpack_require__(1283);
	
	var _documentsUploadReq = __webpack_require__(839);
	
	var _documentsDeleteReq = __webpack_require__(658);
	
	var _documentsFetchListReq = __webpack_require__(1886);
	
	var _personalInfoReq = __webpack_require__(659);
	
	var _generalInfoReq = __webpack_require__(1285);
	
	var _relationshipReq = __webpack_require__(1286);
	
	var _sagas = __webpack_require__(4070);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_assignedGuardianListReq.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(_personalInfoReq.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(_generalInfoReq.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(_documentsCompletionReq.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(_documentsFetchListReq.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(_documentsUploadReq.watcher);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_assignmentFetchReq.watcher);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(_documentsDeleteReq.watcher);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(_relationshipReq.watcher);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(_sagas2.default);
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handleBack = handleBack;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _progress = __webpack_require__(121);
	
	var _selectors = __webpack_require__(167);
	
	var _redirectSaga = __webpack_require__(416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleBack);
	
	function handleBack() {
	  var isBackDisabled, assignmentId, step, metadata;
	  return _regenerator2.default.wrap(function handleBack$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectDependentFormIsBackDisabled);
	
	        case 2:
	          isBackDisabled = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectDependentFormAssigmentId);
	
	        case 5:
	          assignmentId = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectDependentFormCurrentStep);
	
	        case 8:
	          step = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors.selectDependentFormProgressMetadata);
	
	        case 11:
	          metadata = _context.sent;
	
	          if (!isBackDisabled) {
	            _context.next = 14;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 14:
	          _context.t0 = step;
	          _context.next = _context.t0 === _progress.DEPENDENT_FORM_STEPS.ROLE ? 17 : _context.t0 === _progress.DEPENDENT_FORM_STEPS.PERSONAL ? 20 : _context.t0 === _progress.DEPENDENT_FORM_STEPS.DOCUMENTS ? 23 : _context.t0 === _progress.DEPENDENT_FORM_STEPS.RELATION ? 26 : 34;
	          break;
	
	        case 17:
	          _context.next = 19;
	          return (0, _effects.call)(_redirectSaga.redirectHistoryBack);
	
	        case 19:
	          return _context.abrupt('break', 35);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.call)(_redirectSaga.redirectToRole);
	
	        case 22:
	          return _context.abrupt('break', 35);
	
	        case 23:
	          _context.next = 25;
	          return (0, _effects.call)(_redirectSaga.redirectToGeneralInfo, assignmentId);
	
	        case 25:
	          return _context.abrupt('break', 35);
	
	        case 26:
	          if (!(0, _get2.default)(metadata, 'documentationStepEnabled')) {
	            _context.next = 31;
	            break;
	          }
	
	          _context.next = 29;
	          return (0, _effects.call)(_redirectSaga.redirectToDocuments, assignmentId);
	
	        case 29:
	          _context.next = 33;
	          break;
	
	        case 31:
	          _context.next = 33;
	          return (0, _effects.call)(_redirectSaga.redirectToGeneralInfo, assignmentId);
	
	        case 33:
	          return _context.abrupt('break', 35);
	
	        case 34:
	          return _context.abrupt('break', 35);
	
	        case 35:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4068 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.deleteDocumentWatcher = deleteDocumentWatcher;
	
	var _effects = __webpack_require__(14);
	
	var _documentsDeleteReq = __webpack_require__(658);
	
	var documentDeleteReq = _interopRequireWildcard(_documentsDeleteReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleSuccessDelete),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(deleteDocumentWatcher);
	
	function handleSuccessDelete(_ref) {
	  var payload = _ref.payload;
	  return _regenerator2.default.wrap(function handleSuccessDelete$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.take)(documentDeleteReq.consts.SUCCEED);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)(documentDeleteReq.actions.deleteSuccess(payload.docId));
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function deleteDocumentWatcher() {
	  return _regenerator2.default.wrap(function deleteDocumentWatcher$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(documentDeleteReq.consts.SEND, handleSuccessDelete);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handleDependentDocumentsErrorsSaga = handleDependentDocumentsErrorsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _documentsUploadReq = __webpack_require__(839);
	
	var _documentsDeleteReq = __webpack_require__(658);
	
	var _handleServerErrorsWithToast = __webpack_require__(1940);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleDependentDocumentsErrorsSaga);
	
	function handleDependentDocumentsErrorsSaga() {
	  return _regenerator2.default.wrap(function handleDependentDocumentsErrorsSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeEvery)([_documentsUploadReq.consts.REJECTED, _documentsUploadReq.consts.ERROR_ENCOUNTERED, _documentsDeleteReq.consts.REJECTED, _documentsDeleteReq.consts.ERROR_ENCOUNTERED], _handleServerErrorsWithToast.handleServerErrorWithToast);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4070 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = progressRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _progress = __webpack_require__(121);
	
	var _deleteDocumentSaga = __webpack_require__(4068);
	
	var _backNavigationSaga = __webpack_require__(4067);
	
	var _nextNavigationSaga = __webpack_require__(4071);
	
	var _validateStepsSaga = __webpack_require__(4077);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(progressRootSaga);
	
	function progressRootSaga() {
	  return _regenerator2.default.wrap(function progressRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.takeLatest)(_progress.DEPENDENT_FORM_PROGRESS_TYPES.VALIDATE, _validateStepsSaga.validateDependentFormProgress);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.takeLatest)(_progress.DEPENDENT_FORM_PROGRESS_TYPES.GO_BACK, _backNavigationSaga.handleBack);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.takeLatest)(_progress.DEPENDENT_FORM_PROGRESS_TYPES.GO_NEXT, _nextNavigationSaga.handleNext);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(_deleteDocumentSaga.deleteDocumentWatcher);
	
	        case 8:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4071 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handleNext = handleNext;
	
	var _effects = __webpack_require__(14);
	
	var _progress = __webpack_require__(121);
	
	var _sendPersonalInfoSaga = __webpack_require__(4074);
	
	var _sendGeneraInfoSaga = __webpack_require__(4073);
	
	var _sendDocumentsSaga = __webpack_require__(4072);
	
	var _sendRelationSaga = __webpack_require__(4075);
	
	var _setRoleSaga = __webpack_require__(4076);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleNext);
	
	function handleNext(_ref) {
	  var _ref$payload = _ref.payload,
	      step = _ref$payload.step,
	      data = _ref$payload.data;
	  return _regenerator2.default.wrap(function handleNext$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.t0 = step;
	          _context.next = _context.t0 === _progress.DEPENDENT_FORM_STEPS.ROLE ? 3 : _context.t0 === _progress.DEPENDENT_FORM_STEPS.PERSONAL ? 6 : _context.t0 === _progress.DEPENDENT_FORM_STEPS.GENERAL ? 9 : _context.t0 === _progress.DEPENDENT_FORM_STEPS.DOCUMENTS ? 12 : _context.t0 === _progress.DEPENDENT_FORM_STEPS.RELATION ? 15 : 18;
	          break;
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.call)(_setRoleSaga.setRole, data);
	
	        case 5:
	          return _context.abrupt('break', 19);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.call)(_sendPersonalInfoSaga.sendPersonalInfo, data);
	
	        case 8:
	          return _context.abrupt('break', 19);
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.call)(_sendGeneraInfoSaga.sendGeneralInfo, data);
	
	        case 11:
	          return _context.abrupt('break', 19);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.call)(_sendDocumentsSaga.sendDocuments, data);
	
	        case 14:
	          return _context.abrupt('break', 19);
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.call)(_sendRelationSaga.sendRelation, data);
	
	        case 17:
	          return _context.abrupt('break', 19);
	
	        case 18:
	          return _context.abrupt('break', 19);
	
	        case 19:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.sendDocuments = sendDocuments;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(167);
	
	var _progress = __webpack_require__(121);
	
	var _documentsCompletionReq = __webpack_require__(1284);
	
	var docCompletion = _interopRequireWildcard(_documentsCompletionReq);
	
	var _redirectSaga = __webpack_require__(416);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(sendDocuments);
	
	function sendDocuments() {
	  var id, _ref, assignment;
	
	  return _regenerator2.default.wrap(function sendDocuments$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectDependentFormAssigmentId);
	
	        case 2:
	          id = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)(docCompletion.actions.send({ id: id }));
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.take)(docCompletion.consts.SUCCEED);
	
	        case 7:
	          _ref = _context.sent;
	          assignment = _ref.payload;
	          _context.next = 11;
	          return (0, _effects.put)(_progress.dependentFormActions.updateDependent(assignment));
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.call)(_redirectSaga.redirectToRelation, id);
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4073 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.sendGeneralInfo = sendGeneralInfo;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _omitBy = __webpack_require__(983);
	
	var _omitBy2 = _interopRequireDefault(_omitBy);
	
	var _each = __webpack_require__(5500);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _snakecaseKeys = __webpack_require__(1391);
	
	var _snakecaseKeys2 = _interopRequireDefault(_snakecaseKeys);
	
	var _base64ToFile = __webpack_require__(4189);
	
	var _progress = __webpack_require__(121);
	
	var _selectors = __webpack_require__(167);
	
	var _generalInfoReq = __webpack_require__(1285);
	
	var generalInfoReq = _interopRequireWildcard(_generalInfoReq);
	
	var _redirectSaga = __webpack_require__(416);
	
	var _selectors2 = __webpack_require__(56);
	
	var _selectors3 = __webpack_require__(50);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(sendGeneralInfo);
	
	function appendAvatarToFormData(formData, avatar) {
	  if (avatar === null || avatar.indexOf('http') === 0) {
	    return null;
	  }
	
	  if (avatar.indexOf('data:') === 0) {
	    return formData.append('dependent[avatar]', (0, _base64ToFile.dataURItoBlob)(avatar));
	  }
	
	  formData.append('dependent[avatar]', avatar);
	}
	
	function preparePayload(_ref, id, isoCode, countriesPhoneCode) {
	  var avatar = _ref.avatar,
	      phoneNumber = _ref.phoneNumber,
	      rest = (0, _objectWithoutProperties3.default)(_ref, ['avatar', 'phoneNumber']);
	
	  var data = (0, _omitBy2.default)(rest, function (value) {
	    return (0, _isEmpty2.default)(value);
	  });
	  var formData = new FormData();
	  formData.append('id', id);
	
	  var isFullPhoneNumber = !countriesPhoneCode.map(function (_ref2) {
	    var countryCode = _ref2.countryCode;
	    return countryCode;
	  }).includes(phoneNumber);
	
	  if (phoneNumber && isFullPhoneNumber) {
	    formData.append('dependent[phone_number_country_iso_code]', isoCode);
	    formData.append('dependent[phone_number]', phoneNumber);
	  }
	  appendAvatarToFormData(formData, avatar);
	  (0, _each2.default)((0, _snakecaseKeys2.default)(data), function (value, key) {
	    formData.append('dependent[' + key + ']', value);
	  });
	  return formData;
	}
	
	function sendGeneralInfo(data) {
	  var id, countriesPhoneCode, metadata, phoneNumberCountryIsoCode, dependentPhoneNumberCountryIsoCode, payload, _ref3, assignment;
	
	  return _regenerator2.default.wrap(function sendGeneralInfo$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectDependentFormAssigmentId);
	
	        case 2:
	          id = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors3.selectCountryPhoneSettings);
	
	        case 5:
	          countriesPhoneCode = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectDependentFormProgressMetadata);
	
	        case 8:
	          metadata = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors2.selectCurrentCountryCode);
	
	        case 11:
	          phoneNumberCountryIsoCode = _context.sent;
	          _context.next = 14;
	          return (0, _effects.select)(_selectors.selectDependentPhoneNumberCountryIsoCode);
	
	        case 14:
	          dependentPhoneNumberCountryIsoCode = _context.sent;
	          payload = preparePayload(data, id, phoneNumberCountryIsoCode || dependentPhoneNumberCountryIsoCode, countriesPhoneCode);
	          _context.next = 18;
	          return (0, _effects.put)(generalInfoReq.actions.send(payload));
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.take)(generalInfoReq.consts.SUCCEED);
	
	        case 20:
	          _ref3 = _context.sent;
	          assignment = _ref3.payload;
	          _context.next = 24;
	          return (0, _effects.put)(_progress.dependentFormActions.updateDependent(assignment));
	
	        case 24:
	          if (!(0, _get2.default)(metadata, 'documentationStepEnabled')) {
	            _context.next = 29;
	            break;
	          }
	
	          _context.next = 27;
	          return (0, _effects.call)(_redirectSaga.redirectToDocuments, id);
	
	        case 27:
	          _context.next = 31;
	          break;
	
	        case 29:
	          _context.next = 31;
	          return (0, _effects.call)(_redirectSaga.redirectToRelation, id);
	
	        case 31:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.sendPersonalInfo = sendPersonalInfo;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _redirectSaga = __webpack_require__(416);
	
	var _progress = __webpack_require__(121);
	
	var _assignedGuardianListReq = __webpack_require__(1282);
	
	var assignedGuardianListReq = _interopRequireWildcard(_assignedGuardianListReq);
	
	var _personalInfoReq = __webpack_require__(659);
	
	var personalInfoReq = _interopRequireWildcard(_personalInfoReq);
	
	var _selectors = __webpack_require__(167);
	
	var _errors = __webpack_require__(120);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(sendPersonalInfo),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handlePersonalInfoError);
	
	function sendPersonalInfo(dependent) {
	  var careRole, _ref, type, payload;
	
	  return _regenerator2.default.wrap(function sendPersonalInfo$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectDependentFormRole);
	
	        case 2:
	          careRole = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)(personalInfoReq.actions.send({ careRole: careRole, dependent: dependent }));
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.take)([personalInfoReq.consts.SUCCEED, personalInfoReq.consts.REJECTED]);
	
	        case 7:
	          _ref = _context.sent;
	          type = _ref.type;
	          payload = _ref.payload;
	
	          if (!(type === personalInfoReq.consts.REJECTED)) {
	            _context.next = 14;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.call)(handlePersonalInfoError, payload, dependent);
	
	        case 13:
	          return _context.abrupt('return');
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.put)(_progress.dependentFormActions.updateDependent(payload));
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.call)(_redirectSaga.checkAlreadyCreatedUserAndRedirect, payload);
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handlePersonalInfoError(payload, data) {
	  var code;
	  return _regenerator2.default.wrap(function handlePersonalInfoError$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          code = (0, _lodash.get)(payload, 'error.code');
	
	          if (!(code === _errors.ERROR_CODES.USER_ALREADY_HAS_GUARDIAN)) {
	            _context2.next = 6;
	            break;
	          }
	
	          _context2.next = 4;
	          return (0, _effects.put)(assignedGuardianListReq.actions.send(data));
	
	        case 4:
	          _context2.next = 6;
	          return (0, _effects.call)(_redirectSaga.redirectToDependentExistPage);
	
	        case 6:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4075 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.sendRelation = sendRelation;
	
	var _effects = __webpack_require__(14);
	
	var _relationshipReq = __webpack_require__(1286);
	
	var relation = _interopRequireWildcard(_relationshipReq);
	
	var _selectors = __webpack_require__(167);
	
	var _progress = __webpack_require__(121);
	
	var _redirectSaga = __webpack_require__(416);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(sendRelation);
	
	function sendRelation(_ref) {
	  var role = _ref.role;
	
	  var id, _ref2, assignment;
	
	  return _regenerator2.default.wrap(function sendRelation$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectDependentFormAssigmentId);
	
	        case 2:
	          id = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)(relation.actions.send({ id: id, role: role }));
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.take)(relation.consts.SUCCEED);
	
	        case 7:
	          _ref2 = _context.sent;
	          assignment = _ref2.payload;
	          _context.next = 11;
	          return (0, _effects.put)(_progress.dependentFormActions.updateDependent(assignment));
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.call)(_redirectSaga.redirectToCompletePage, assignment);
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4076 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.setRole = setRole;
	
	var _effects = __webpack_require__(14);
	
	var _progress = __webpack_require__(121);
	
	var _redirectSaga = __webpack_require__(416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(setRole);
	
	function setRole(data) {
	  return _regenerator2.default.wrap(function setRole$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_progress.dependentFormActions.setRole(data.role));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.call)(_redirectSaga.redirectToPersonalInfo);
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.validateDependentFormProgress = validateDependentFormProgress;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(167);
	
	var _progress = __webpack_require__(121);
	
	var _redirectSaga = __webpack_require__(416);
	
	var _selectors2 = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(validateDependentFormProgress);
	
	var stepsToCheck = [{
	  step: _progress.DEPENDENT_FORM_STEPS.DOCUMENTS,
	  cb: _redirectSaga.redirectToRelation
	}, {
	  step: _progress.DEPENDENT_FORM_STEPS.GENERAL,
	  cb: _redirectSaga.redirectToDocuments
	}, {
	  step: _progress.DEPENDENT_FORM_STEPS.PERSONAL,
	  cb: _redirectSaga.redirectToGeneralInfo
	}];
	
	function validateDependentFormProgress(_ref) {
	  var id = _ref.payload.id;
	  var role, dependent, i, current;
	  return _regenerator2.default.wrap(function validateDependentFormProgress$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectDependentFormRole);
	
	        case 2:
	          role = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)((0, _selectors2.selectGuardianDependentById)(Number(id)));
	
	        case 5:
	          dependent = _context.sent;
	
	          if (!(id && id !== 'new' && dependent)) {
	            _context.next = 21;
	            break;
	          }
	
	          _context.next = 9;
	          return (0, _effects.put)(_progress.dependentFormActions.updateDependent(dependent));
	
	        case 9:
	          i = 0;
	
	        case 10:
	          if (!(i < stepsToCheck.length)) {
	            _context.next = 19;
	            break;
	          }
	
	          current = stepsToCheck[i];
	
	          if (!dependent.registrationSteps[current.step]) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.call)(current.cb, dependent.id);
	
	        case 15:
	          return _context.abrupt('break', 19);
	
	        case 16:
	          i++;
	          _context.next = 10;
	          break;
	
	        case 19:
	          _context.next = 24;
	          break;
	
	        case 21:
	          if (role) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.call)(_redirectSaga.redirectToRole);
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.put)(_progress.dependentFormActions.finishValidate());
	
	        case 26:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4078 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _assignmentPendingReq = __webpack_require__(528);
	
	var _assignmentPendingReq2 = _interopRequireDefault(_assignmentPendingReq);
	
	var _assignmentReviewedReq = __webpack_require__(529);
	
	var _assignmentReviewedReq2 = _interopRequireDefault(_assignmentReviewedReq);
	
	var _assignmentUpdateReq = __webpack_require__(530);
	
	var _assignmentUpdateReq2 = _interopRequireDefault(_assignmentUpdateReq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  assignmentPending: _assignmentPendingReq2.default,
	  assignmentReviewed: _assignmentReviewedReq2.default,
	  assignmentUpdate: _assignmentUpdateReq2.default
	});

/***/ }),
/* 4079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = dependentManagementRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _assignmentPendingReq = __webpack_require__(528);
	
	var assignmentPendingList = _interopRequireWildcard(_assignmentPendingReq);
	
	var _assignmentReviewedReq = __webpack_require__(529);
	
	var assignmentReviewedList = _interopRequireWildcard(_assignmentReviewedReq);
	
	var _assignmentUpdateReq = __webpack_require__(530);
	
	var assignmentUpdate = _interopRequireWildcard(_assignmentUpdateReq);
	
	var _assignmentListPagination = __webpack_require__(4080);
	
	var _assignmentListPagination2 = _interopRequireDefault(_assignmentListPagination);
	
	var _resolveAssignments = __webpack_require__(4081);
	
	var _resolveAssignments2 = _interopRequireDefault(_resolveAssignments);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(dependentManagementRootSaga);
	
	function dependentManagementRootSaga() {
	  return _regenerator2.default.wrap(function dependentManagementRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(assignmentPendingList.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(assignmentPendingList.paginationWatcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(assignmentReviewedList.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(assignmentReviewedList.paginationWatcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(assignmentUpdate.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(_assignmentListPagination2.default);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_resolveAssignments2.default);
	
	        case 14:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4080 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = assignmentListPagination;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _assignmentPendingReq = __webpack_require__(528);
	
	var pendingAssignments = _interopRequireWildcard(_assignmentPendingReq);
	
	var _assignmentReviewedReq = __webpack_require__(529);
	
	var reviewedAssignments = _interopRequireWildcard(_assignmentReviewedReq);
	
	var _selectors = __webpack_require__(840);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMorePendingAssignments),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(loadMoreReviewedAssignments),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(assignmentListPagination);
	
	function loadMorePendingAssignments() {
	  var pagination, counter, list, listSize;
	  return _regenerator2.default.wrap(function loadMorePendingAssignments$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectPendingAssignmentListPagination);
	
	        case 2:
	          pagination = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectPendingAssignmentListCount);
	
	        case 5:
	          counter = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectPendingAssignmentList);
	
	        case 8:
	          list = _context.sent;
	          listSize = (0, _size2.default)(list);
	
	          if (!(counter <= listSize)) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)(pendingAssignments.paginationActions.send((0, _extends3.default)({}, pagination, {
	            offset: listSize
	          })));
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	function loadMoreReviewedAssignments() {
	  var pagination, counter, list, listSize;
	  return _regenerator2.default.wrap(function loadMoreReviewedAssignments$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors.selectReviewedAssignmentListPagination);
	
	        case 2:
	          pagination = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_selectors.selectReviewedAssignmentListCount);
	
	        case 5:
	          counter = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.select)(_selectors.selectReviewedAssignmentList);
	
	        case 8:
	          list = _context2.sent;
	          listSize = (0, _size2.default)(list);
	
	          if (!(counter <= listSize)) {
	            _context2.next = 13;
	            break;
	          }
	
	          _context2.next = 13;
	          return (0, _effects.cancel)();
	
	        case 13:
	          _context2.next = 15;
	          return (0, _effects.put)(reviewedAssignments.paginationActions.send((0, _extends3.default)({}, pagination, {
	            offset: listSize
	          })));
	
	        case 15:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function assignmentListPagination() {
	  return _regenerator2.default.wrap(function assignmentListPagination$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)([pendingAssignments.consts.LOAD_MORE], loadMorePendingAssignments);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.takeLatest)([reviewedAssignments.consts.LOAD_MORE], loadMoreReviewedAssignments);
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4081 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = resolveAssignments;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _assignmentUpdateReq = __webpack_require__(530);
	
	var updateAssignment = _interopRequireWildcard(_assignmentUpdateReq);
	
	var _assignmentPendingReq = __webpack_require__(528);
	
	var pendingAssignments = _interopRequireWildcard(_assignmentPendingReq);
	
	var _assignmentReviewedReq = __webpack_require__(529);
	
	var reviewedAssignments = _interopRequireWildcard(_assignmentReviewedReq);
	
	var _selectors = __webpack_require__(840);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleResolveAssignments),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(resolveAssignments);
	
	function handleResolveAssignments() {
	  var FIRST_REQUEST_LIMIT, counter, reviewedList, pendingList;
	  return _regenerator2.default.wrap(function handleResolveAssignments$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          FIRST_REQUEST_LIMIT = 10;
	          _context.next = 3;
	          return (0, _effects.select)(_selectors.selectPendingAssignmentListCount);
	
	        case 3:
	          counter = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(_selectors.selectReviewedAssignmentList);
	
	        case 6:
	          reviewedList = _context.sent;
	          _context.next = 9;
	          return (0, _effects.select)(_selectors.selectPendingAssignmentList);
	
	        case 9:
	          pendingList = _context.sent;
	
	          if (!(counter >= FIRST_REQUEST_LIMIT)) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.put)(pendingAssignments.paginationActions.send({
	            limit: 1,
	            offset: (0, _size2.default)(pendingList)
	          }));
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)(reviewedAssignments.actions.send({
	            silent: true,
	            limit: (0, _size2.default)(reviewedList) < FIRST_REQUEST_LIMIT ? FIRST_REQUEST_LIMIT : (0, _size2.default)(reviewedList)
	          }));
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function resolveAssignments() {
	  return _regenerator2.default.wrap(function resolveAssignments$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([updateAssignment.consts.SUCCEED], handleResolveAssignments);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _guarantorsReq = __webpack_require__(662);
	
	var _guarantorsReq2 = _interopRequireDefault(_guarantorsReq);
	
	var _createGuarantorReq = __webpack_require__(661);
	
	var _createGuarantorReq2 = _interopRequireDefault(_createGuarantorReq);
	
	var _updateGuarantorReq = __webpack_require__(842);
	
	var _updateGuarantorReq2 = _interopRequireDefault(_updateGuarantorReq);
	
	var _selectedGuarantor = __webpack_require__(4083);
	
	var _selectedGuarantor2 = _interopRequireDefault(_selectedGuarantor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  guarantors: _guarantorsReq2.default,
	  createGuarantor: _createGuarantorReq2.default,
	  updateGuarantor: _updateGuarantorReq2.default,
	  selectedGuarantor: _selectedGuarantor2.default
	});

/***/ }),
/* 4083 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	exports.default = progress;
	
	var _actions = __webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  isSelfGuarantor: false,
	  guarantorsForm: {}
	};
	
	function progress() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _actions.GUARANTORS_INFORMATION_TYPES.SET_IS_SELF_GUARANTOR:
	      {
	        return (0, _extends4.default)({}, state, { isSelfGuarantor: payload });
	      }
	
	    case _actions.GUARANTORS_INFORMATION_TYPES.UPDATE_GUARANTOR_FORM_VALUES:
	      {
	        return (0, _extends4.default)({}, state, {
	          guarantorsForm: (0, _extends4.default)({}, state.guarantorsForm, (0, _defineProperty3.default)({}, payload.id, payload.data))
	        });
	      }
	
	    case _actions.GUARANTORS_INFORMATION_TYPES.RESET_GUARANTOR_FORM_VALUES:
	      {
	        return (0, _extends4.default)({}, state, {
	          guarantorsForm: initialState.guarantorsForm
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}

/***/ }),
/* 4084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = guarantorsInformationRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _guarantorsReq = __webpack_require__(662);
	
	var guarantors = _interopRequireWildcard(_guarantorsReq);
	
	var _createGuarantorReq = __webpack_require__(661);
	
	var createGuarantor = _interopRequireWildcard(_createGuarantorReq);
	
	var _updateGuarantorReq = __webpack_require__(842);
	
	var updateGuarantor = _interopRequireWildcard(_updateGuarantorReq);
	
	var _removeGuarantorReq = __webpack_require__(841);
	
	var removeGuarantor = _interopRequireWildcard(_removeGuarantorReq);
	
	var _applyGuarantorReq = __webpack_require__(660);
	
	var applyGuarantor = _interopRequireWildcard(_applyGuarantorReq);
	
	var _refetchGuarantors = __webpack_require__(4086);
	
	var _applyGuarantor = __webpack_require__(4085);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(guarantorsInformationRootSaga);
	
	function guarantorsInformationRootSaga() {
	  return _regenerator2.default.wrap(function guarantorsInformationRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(guarantors.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(createGuarantor.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(updateGuarantor.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(removeGuarantor.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(applyGuarantor.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(_refetchGuarantors.refetchGuarantorsInformation);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_applyGuarantor.applyGuarantorInformation);
	
	        case 14:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4085 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.applyGuarantorInformation = applyGuarantorInformation;
	
	var _effects = __webpack_require__(14);
	
	var _applyGuarantorReq = __webpack_require__(660);
	
	var _inspectAllSaga = __webpack_require__(805);
	
	var _actions = __webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(applyGuarantorInformation);
	
	function applyGuarantorInformation() {
	  return _regenerator2.default.wrap(function applyGuarantorInformation$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_actions.guarantorInformationActions.setIsSelfGuarantor(false));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.takeLatest)([_applyGuarantorReq.consts.SUCCEED], _inspectAllSaga.determineNextStepAfterGuarantorInformation);
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4086 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handleRefetchGuarantorsInformation = handleRefetchGuarantorsInformation;
	exports.refetchGuarantorsInformation = refetchGuarantorsInformation;
	
	var _effects = __webpack_require__(14);
	
	var _createGuarantorReq = __webpack_require__(661);
	
	var _removeGuarantorReq = __webpack_require__(841);
	
	var _guarantorsReq = __webpack_require__(662);
	
	var _selectors = __webpack_require__(43);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(82);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleRefetchGuarantorsInformation),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(refetchGuarantorsInformation);
	
	function handleRefetchGuarantorsInformation() {
	  var getCareUserId, paperworkUserId, pathname, userId;
	  return _regenerator2.default.wrap(function handleRefetchGuarantorsInformation$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectProgressCareUserId);
	
	        case 2:
	          getCareUserId = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails.selectPaperworkAppointmentUserId);
	
	        case 5:
	          paperworkUserId = _context.sent;
	          pathname = window.location.pathname;
	          userId = pathname.includes(_routes.PAPERWORK) ? paperworkUserId : getCareUserId;
	
	          if (!userId) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.put)(_guarantorsReq.actions.send({ userId: userId }));
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function refetchGuarantorsInformation() {
	  return _regenerator2.default.wrap(function refetchGuarantorsInformation$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_removeGuarantorReq.consts.SUCCEED], handleRefetchGuarantorsInformation);
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.takeLatest)([_createGuarantorReq.consts.SUCCEED], handleRefetchGuarantorsInformation);
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4087 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TODO_ASSIGNMENT_METHOD = exports.TODO_ASSIGNMENT_METHOD = {
	  SYSTEM: 'system',
	  EMPLOYER: 'employer',
	  PROVIDER: 'provider'
	};

/***/ }),
/* 4088 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _refillsAvailableMedicationsReq = __webpack_require__(1302);
	
	var _refillsAvailableMedicationsReq2 = _interopRequireDefault(_refillsAvailableMedicationsReq);
	
	var _patientChannelsForShare = __webpack_require__(1300);
	
	var _patientChannelsForShare2 = _interopRequireDefault(_patientChannelsForShare);
	
	var _socialChannelsForShare = __webpack_require__(1306);
	
	var _socialChannelsForShare2 = _interopRequireDefault(_socialChannelsForShare);
	
	var _setPreferredPharmacyReq = __webpack_require__(532);
	
	var _setPreferredPharmacyReq2 = _interopRequireDefault(_setPreferredPharmacyReq);
	
	var _labResultHistoryModal = __webpack_require__(1296);
	
	var _labResultHistoryModal2 = _interopRequireDefault(_labResultHistoryModal);
	
	var _labResultHistoryReq = __webpack_require__(1297);
	
	var _labResultHistoryReq2 = _interopRequireDefault(_labResultHistoryReq);
	
	var _medicationRefillReq = __webpack_require__(846);
	
	var _medicationRefillReq2 = _interopRequireDefault(_medicationRefillReq);
	
	var _medicationRefillsHistory = __webpack_require__(847);
	
	var _medicationRefillsHistory2 = _interopRequireDefault(_medicationRefillsHistory);
	
	var _resultsDetailsModal = __webpack_require__(1303);
	
	var _resultsDetailsModal2 = _interopRequireDefault(_resultsDetailsModal);
	
	var _availableCategories = __webpack_require__(1289);
	
	var _availableCategories2 = _interopRequireDefault(_availableCategories);
	
	var _shareToEmailModal = __webpack_require__(1305);
	
	var _shareToEmailModal2 = _interopRequireDefault(_shareToEmailModal);
	
	var _shareToChatModal = __webpack_require__(848);
	
	var _shareToChatModal2 = _interopRequireDefault(_shareToChatModal);
	
	var _chatMembersModal = __webpack_require__(1290);
	
	var _chatMembersModal2 = _interopRequireDefault(_chatMembersModal);
	
	var _labTestResultsReq = __webpack_require__(1298);
	
	var _labTestResultsReq2 = _interopRequireDefault(_labTestResultsReq);
	
	var _resultsDetailsReq = __webpack_require__(1304);
	
	var _resultsDetailsReq2 = _interopRequireDefault(_resultsDetailsReq);
	
	var _loggingActionReq = __webpack_require__(663);
	
	var _loggingActionReq2 = _interopRequireDefault(_loggingActionReq);
	
	var _socialHistoryReq = __webpack_require__(1307);
	
	var _socialHistoryReq2 = _interopRequireDefault(_socialHistoryReq);
	
	var _shareToEmailReq = __webpack_require__(849);
	
	var _shareToEmailReq2 = _interopRequireDefault(_shareToEmailReq);
	
	var _immunizationsReq = __webpack_require__(1295);
	
	var _immunizationsReq2 = _interopRequireDefault(_immunizationsReq);
	
	var _healthRecordReq = __webpack_require__(1294);
	
	var _healthRecordReq2 = _interopRequireDefault(_healthRecordReq);
	
	var _shareToChatReq = __webpack_require__(664);
	
	var _shareToChatReq2 = _interopRequireDefault(_shareToChatReq);
	
	var _familyHistory = __webpack_require__(1293);
	
	var _familyHistory2 = _interopRequireDefault(_familyHistory);
	
	var _activityLogReq = __webpack_require__(845);
	
	var _activityLogReq2 = _interopRequireDefault(_activityLogReq);
	
	var _medicationsReq = __webpack_require__(1299);
	
	var _medicationsReq2 = _interopRequireDefault(_medicationsReq);
	
	var _proceduresReq = __webpack_require__(1301);
	
	var _proceduresReq2 = _interopRequireDefault(_proceduresReq);
	
	var _encountersReq = __webpack_require__(1292);
	
	var _encountersReq2 = _interopRequireDefault(_encountersReq);
	
	var _conditionsReq = __webpack_require__(1291);
	
	var _conditionsReq2 = _interopRequireDefault(_conditionsReq);
	
	var _allergiesReq = __webpack_require__(1288);
	
	var _allergiesReq2 = _interopRequireDefault(_allergiesReq);
	
	var _virtualAppointmentsHistoryReq = __webpack_require__(859);
	
	var _virtualAppointmentsHistoryReq2 = _interopRequireDefault(_virtualAppointmentsHistoryReq);
	
	var _virtualAppointmentsUpcommingReq = __webpack_require__(670);
	
	var _virtualAppointmentsUpcommingReq2 = _interopRequireDefault(_virtualAppointmentsUpcommingReq);
	
	var _appointmentUpcomingFilters = __webpack_require__(1887);
	
	var _appointmentUpcomingFilters2 = _interopRequireDefault(_appointmentUpcomingFilters);
	
	var _confirmVisitByPatientReq = __webpack_require__(666);
	
	var _confirmVisitByPatientReq2 = _interopRequireDefault(_confirmVisitByPatientReq);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var _signAppointmentConsentReq2 = _interopRequireDefault(_signAppointmentConsentReq);
	
	var _appointmentsHistoryReq = __webpack_require__(347);
	
	var _appointmentsHistoryReq2 = _interopRequireDefault(_appointmentsHistoryReq);
	
	var _appointmentsUpcommingReq = __webpack_require__(348);
	
	var _appointmentsUpcommingReq2 = _interopRequireDefault(_appointmentsUpcommingReq);
	
	var _checkInAppointmentReq = __webpack_require__(533);
	
	var _checkInAppointmentReq2 = _interopRequireDefault(_checkInAppointmentReq);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var _cancelAppointmentReq2 = _interopRequireDefault(_cancelAppointmentReq);
	
	var _couponVerificationReq = __webpack_require__(418);
	
	var _couponVerificationReq2 = _interopRequireDefault(_couponVerificationReq);
	
	var _couponPriceCalculationReq = __webpack_require__(667);
	
	var _couponPriceCalculationReq2 = _interopRequireDefault(_couponPriceCalculationReq);
	
	var _getGeoLocationsReq = __webpack_require__(1308);
	
	var _getGeoLocationsReq2 = _interopRequireDefault(_getGeoLocationsReq);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var _statusChangeReq2 = _interopRequireDefault(_statusChangeReq);
	
	var _statusUrgentVisitChangeReq = __webpack_require__(669);
	
	var _statusUrgentVisitChangeReq2 = _interopRequireDefault(_statusUrgentVisitChangeReq);
	
	var _networkTestCredentialsReq = __webpack_require__(856);
	
	var _networkTestCredentialsReq2 = _interopRequireDefault(_networkTestCredentialsReq);
	
	var _roomInvitationJoinReq = __webpack_require__(1310);
	
	var _roomInvitationJoinReq2 = _interopRequireDefault(_roomInvitationJoinReq);
	
	var _roomInvitationInfoReq = __webpack_require__(858);
	
	var _roomInvitationInfoReq2 = _interopRequireDefault(_roomInvitationInfoReq);
	
	var _joinByVisitCodeReq = __webpack_require__(668);
	
	var _joinByVisitCodeReq2 = _interopRequireDefault(_joinByVisitCodeReq);
	
	var _connectionRoomJoinReq = __webpack_require__(854);
	
	var _connectionRoomJoinReq2 = _interopRequireDefault(_connectionRoomJoinReq);
	
	var _paymentOrderReq = __webpack_require__(857);
	
	var _paymentOrderReq2 = _interopRequireDefault(_paymentOrderReq);
	
	var _paymentVerificationsReq = __webpack_require__(419);
	
	var _paymentVerificationsReq2 = _interopRequireDefault(_paymentVerificationsReq);
	
	var _scheduledTasksUpcomingReq = __webpack_require__(303);
	
	var _scheduledTasksUpcomingReq2 = _interopRequireDefault(_scheduledTasksUpcomingReq);
	
	var _scheduledTasksCompletedReq = __webpack_require__(534);
	
	var _scheduledTasksCompletedReq2 = _interopRequireDefault(_scheduledTasksCompletedReq);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	var _appointmentConsentModal2 = _interopRequireDefault(_appointmentConsentModal);
	
	var _appointmentSurveyAssignment = __webpack_require__(844);
	
	var _appointmentSurveyAssignment2 = _interopRequireDefault(_appointmentSurveyAssignment);
	
	var _managePendingRequest = __webpack_require__(263);
	
	var _managePendingRequest2 = _interopRequireDefault(_managePendingRequest);
	
	var _payaRedirectionReq = __webpack_require__(1309);
	
	var _payaRedirectionReq2 = _interopRequireDefault(_payaRedirectionReq);
	
	var _uploadDocumentReq = __webpack_require__(304);
	
	var _uploadDocumentReq2 = _interopRequireDefault(_uploadDocumentReq);
	
	var _deleteDocumentReq = __webpack_require__(302);
	
	var _deleteDocumentReq2 = _interopRequireDefault(_deleteDocumentReq);
	
	var _completeTaskReq = __webpack_require__(665);
	
	var _completeTaskReq2 = _interopRequireDefault(_completeTaskReq);
	
	var _completeTaskCustomReq = __webpack_require__(853);
	
	var _completeTaskCustomReq2 = _interopRequireDefault(_completeTaskCustomReq);
	
	var _editPaymentReq = __webpack_require__(349);
	
	var _editPaymentReq2 = _interopRequireDefault(_editPaymentReq);
	
	var _completeCarePlanTaskReq = __webpack_require__(852);
	
	var _completeCarePlanTaskReq2 = _interopRequireDefault(_completeCarePlanTaskReq);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _appointmentDetails2 = _interopRequireDefault(_appointmentDetails);
	
	var _virtualVisit = __webpack_require__(305);
	
	var _virtualVisit2 = _interopRequireDefault(_virtualVisit);
	
	var _activeTodo = __webpack_require__(843);
	
	var _activeTodo2 = _interopRequireDefault(_activeTodo);
	
	var _inviteGuestToVirtualRoomReq = __webpack_require__(855);
	
	var _inviteGuestToVirtualRoomReq2 = _interopRequireDefault(_inviteGuestToVirtualRoomReq);
	
	var _root = __webpack_require__(1311);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _devicePermissions = __webpack_require__(1287);
	
	var _devicePermissions2 = _interopRequireDefault(_devicePermissions);
	
	var _testCall = __webpack_require__(535);
	
	var _testCall2 = _interopRequireDefault(_testCall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Provider appointments */
	
	
	/** Patient Portal */
	exports.default = (0, _redux.combineReducers)({
	  patientPortal: (0, _redux.combineReducers)({
	    refills: (0, _redux.combineReducers)({
	      setPreferredPharmacy: _setPreferredPharmacyReq2.default,
	      medicationRefillRequest: _medicationRefillReq2.default,
	      refillsAvailableMedications: _refillsAvailableMedicationsReq2.default,
	      refillsHistory: _medicationRefillsHistory2.default
	    }),
	    labResultHistoryRequest: _labResultHistoryReq2.default,
	    patientChannelsForShare: _patientChannelsForShare2.default,
	    socialChannelsForShare: _socialChannelsForShare2.default,
	    labResultHistoryModal: _labResultHistoryModal2.default,
	    resultsDetailsModal: _resultsDetailsModal2.default,
	    availableCategories: _availableCategories2.default,
	    shareToEmailModal: _shareToEmailModal2.default,
	    shareToChatModal: _shareToChatModal2.default,
	    chatMembersModal: _chatMembersModal2.default,
	    resultsDetails: _resultsDetailsReq2.default,
	    labTestResults: _labTestResultsReq2.default,
	    socialHistory: _socialHistoryReq2.default,
	    familyHistory: _familyHistory2.default,
	    immunizations: _immunizationsReq2.default,
	    loggingAction: _loggingActionReq2.default,
	    healthRecord: _healthRecordReq2.default,
	    shareToEmail: _shareToEmailReq2.default,
	    activityLog: _activityLogReq2.default,
	    shareToChat: _shareToChatReq2.default,
	    medications: _medicationsReq2.default,
	    procedures: _proceduresReq2.default,
	    encounters: _encountersReq2.default,
	    conditions: _conditionsReq2.default,
	    allergies: _allergiesReq2.default
	  }),
	  inviteUserToVirtualRoom: _inviteGuestToVirtualRoomReq2.default,
	  signAppointmentConsent: _signAppointmentConsentReq2.default,
	  appointmentConsentsModal: _appointmentConsentModal2.default,
	  providerHistoryAppointments: _virtualAppointmentsHistoryReq2.default,
	  providerUpcomingAppointments: _virtualAppointmentsUpcommingReq2.default,
	  providerFilterUpcomingAppointments: _appointmentUpcomingFilters2.default,
	  historyAppointments: _appointmentsHistoryReq2.default,
	  upcomingAppointments: _appointmentsUpcommingReq2.default,
	  managePendingRequest: _managePendingRequest2.default,
	  geoLocations: _getGeoLocationsReq2.default,
	  checkinAppointment: _checkInAppointmentReq2.default,
	  cancelAppointment: _cancelAppointmentReq2.default,
	  appointmentDetails: _appointmentDetails2.default,
	  couponVerification: _couponVerificationReq2.default,
	  couponCalculation: _couponPriceCalculationReq2.default,
	  paymentOrder: _paymentOrderReq2.default,
	  editPayment: _editPaymentReq2.default,
	  uploadDocument: _uploadDocumentReq2.default,
	  deleteDocument: _deleteDocumentReq2.default,
	  paymentVerifications: _paymentVerificationsReq2.default,
	  payaRedirection: _payaRedirectionReq2.default,
	  scheduledTasks: _scheduledTasksUpcomingReq2.default,
	  completedTasks: _scheduledTasksCompletedReq2.default,
	  statusChanges: _statusChangeReq2.default,
	  statusUrgentVisitChanges: _statusUrgentVisitChangeReq2.default,
	  networkTestCredentials: _networkTestCredentialsReq2.default,
	  roomInvitationJoin: _roomInvitationJoinReq2.default,
	  roomInvitationInfo: _roomInvitationInfoReq2.default,
	  joinByVisitCode: _joinByVisitCodeReq2.default,
	  connectionRoomJoin: _connectionRoomJoinReq2.default,
	  virtualVisit: _virtualVisit2.default,
	  completeTaskCustom: _completeTaskCustomReq2.default,
	  completeCarePlanTask: _completeCarePlanTaskReq2.default,
	  completeTask: _completeTaskReq2.default,
	  activeTodo: _activeTodo2.default,
	  root: _root2.default,
	  confirmVisitByPatient: _confirmVisitByPatientReq2.default,
	  devicePermissions: _devicePermissions2.default,
	  testCall: _testCall2.default,
	  appointmentSurveyAssignment: _appointmentSurveyAssignment2.default
	});
	/** Patient appointments */

/***/ }),
/* 4089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = handleShareToChatSaga;
	
	var _effects = __webpack_require__(14);
	
	var _shareToChatModal = __webpack_require__(848);
	
	var _shareToChatReq = __webpack_require__(664);
	
	var shareToChat = _interopRequireWildcard(_shareToChatReq);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleShareToChatWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleShareToChatSaga);
	
	function handleShareToChatWorker(_ref) {
	  var _ref$payload = _ref.payload,
	      userId = _ref$payload.userId,
	      documentUid = _ref$payload.documentUid,
	      channelName = _ref$payload.channelName,
	      roomId = _ref$payload.roomId;
	
	  var _ref2, succeedShareToChat;
	
	  return _regenerator2.default.wrap(function handleShareToChatWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(shareToChat.actions.send({
	            userId: userId,
	            document_uid: documentUid,
	            roomId: roomId,
	            channelName: channelName
	          }));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.race)({
	            succeedShareToChat: (0, _effects.take)(shareToChat.consts.SUCCEED),
	            rejectedShareToChat: (0, _effects.take)(shareToChat.consts.REJECTED)
	          });
	
	        case 4:
	          _ref2 = _context.sent;
	          succeedShareToChat = _ref2.succeedShareToChat;
	          _context.next = 8;
	          return (0, _effects.put)(_shareToChatModal.shareToChatModalActions.close());
	
	        case 8:
	          if (!succeedShareToChat) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: shareToChat.consts.SUCCEED,
	            values: { recipient: channelName }
	          });
	
	        case 11:
	          _context.next = 15;
	          break;
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'errors.common' }
	          });
	
	        case 15:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleShareToChatSaga() {
	  return _regenerator2.default.wrap(function handleShareToChatSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(shareToChat.actions.init, handleShareToChatWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4090 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = handleAcceptedConsentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(23);
	
	var _getMainConsent = __webpack_require__(875);
	
	var fetchMainConsent = _interopRequireWildcard(_getMainConsent);
	
	var _selectors2 = __webpack_require__(56);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleShowMainConsent),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleAcceptedConsentSaga);
	
	function handleShowMainConsent() {
	  var mainConsentEntity, userId, organizationName;
	  return _regenerator2.default.wrap(function handleShowMainConsent$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors2.selectMainConsent);
	
	        case 2:
	          mainConsentEntity = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 5:
	          userId = _context.sent;
	
	          if (!(mainConsentEntity && mainConsentEntity.length > 0)) {
	            _context.next = 10;
	            break;
	          }
	
	          organizationName = mainConsentEntity[0].organization.name;
	          _context.next = 10;
	          return (0, _effects.put)(_appointmentConsentModal.appointmentConsentsModalActions.open({
	            consent: mainConsentEntity[0],
	            organizationName: organizationName,
	            allConsents: mainConsentEntity,
	            isMainConsentView: true,
	            patientUserInfoId: userId
	          }));
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleAcceptedConsentSaga() {
	  return _regenerator2.default.wrap(function handleAcceptedConsentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(fetchMainConsent.actions.succeed, handleShowMainConsent);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4091 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = activityLogLoadMoreSaga;
	
	var _effects = __webpack_require__(14);
	
	var _activityLogReq = __webpack_require__(845);
	
	var _selectors = __webpack_require__(157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMoreWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(activityLogLoadMoreSaga);
	
	function loadMoreWorker(action) {
	  var payload, userId, withPagination, limit, currentOffset, newOffset, isLastPage;
	  return _regenerator2.default.wrap(function loadMoreWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          userId = payload.userId, withPagination = payload.withPagination;
	          limit = 15;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectActivityLogEntityOffset);
	
	        case 5:
	          currentOffset = _context.sent;
	          newOffset = withPagination ? currentOffset + limit : currentOffset;
	          _context.next = 9;
	          return (0, _effects.select)(_selectors.selectActivityLogEntityIsLastPage);
	
	        case 9:
	          isLastPage = _context.sent;
	
	          if (isLastPage) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.put)(_activityLogReq.actions.send({
	            limit: limit,
	            userId: userId,
	            offset: newOffset
	          }));
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function activityLogLoadMoreSaga() {
	  return _regenerator2.default.wrap(function activityLogLoadMoreSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_activityLogReq.consts.LOAD_MORE], loadMoreWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _targetData;
	
	exports.default = appointmentListPagination;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _appointmentsUpcommingReq = __webpack_require__(348);
	
	var upcomingAppointments = _interopRequireWildcard(_appointmentsUpcommingReq);
	
	var _appointmentsHistoryReq = __webpack_require__(347);
	
	var historyAppointments = _interopRequireWildcard(_appointmentsHistoryReq);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMoreAppointments),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(appointmentListPagination);
	
	var targetData = (_targetData = {}, (0, _defineProperty3.default)(_targetData, upcomingAppointments.consts.LOAD_MORE, {
	  selectors: {
	    pagination: _selectors.selectUpcomingPagination,
	    list: _selectors.selectUpcomingAppointmentList,
	    counter: _selectors.selectUpcomingCount
	  },
	  fetch: upcomingAppointments.paginationActions.send
	}), (0, _defineProperty3.default)(_targetData, historyAppointments.consts.LOAD_MORE, {
	  selectors: {
	    pagination: _selectors.selectHistoryPagination,
	    list: _selectors.selectHistoryAppointmentList,
	    counter: _selectors.selectHistoryCount
	  },
	  fetch: historyAppointments.paginationActions.send
	}), _targetData);
	
	function loadMoreAppointments(_ref) {
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  var _targetData$type, selectors, fetch, pagination, counter, list, listSize;
	
	  return _regenerator2.default.wrap(function loadMoreAppointments$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _targetData$type = targetData[type], selectors = _targetData$type.selectors, fetch = _targetData$type.fetch;
	          _context.next = 3;
	          return (0, _effects.select)(selectors.pagination);
	
	        case 3:
	          pagination = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(selectors.counter);
	
	        case 6:
	          counter = _context.sent;
	          _context.next = 9;
	          return (0, _effects.select)(selectors.list);
	
	        case 9:
	          list = _context.sent;
	          listSize = (0, _size2.default)(list);
	
	          if (!(counter <= listSize)) {
	            _context.next = 14;
	            break;
	          }
	
	          _context.next = 14;
	          return (0, _effects.cancel)();
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.put)(fetch((0, _extends3.default)({}, payload, pagination, { offset: listSize })));
	
	        case 16:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function appointmentListPagination() {
	  return _regenerator2.default.wrap(function appointmentListPagination$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([upcomingAppointments.consts.LOAD_MORE, historyAppointments.consts.LOAD_MORE], loadMoreAppointments);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4093 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.healthboardCancelSaga = healthboardCancelSaga;
	exports.messagesAppointmentCancelSaga = messagesAppointmentCancelSaga;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _virtualAppointmentsUpcommingReq = __webpack_require__(670);
	
	var providerUpcomingAppointments = _interopRequireWildcard(_virtualAppointmentsUpcommingReq);
	
	var _appointmentsUpcommingReq = __webpack_require__(348);
	
	var upcomingAppointments = _interopRequireWildcard(_appointmentsUpcommingReq);
	
	var _appointmentsHistoryReq = __webpack_require__(347);
	
	var historyAppointments = _interopRequireWildcard(_appointmentsHistoryReq);
	
	var _cancelAppointmentReq = __webpack_require__(200);
	
	var cancelAppointment = _interopRequireWildcard(_cancelAppointmentReq);
	
	var _managePendingRequest = __webpack_require__(263);
	
	var managePendingRequest = _interopRequireWildcard(_managePendingRequest);
	
	var _routes = __webpack_require__(37);
	
	var _selectors = __webpack_require__(115);
	
	var _selectors2 = __webpack_require__(64);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _selectors3 = __webpack_require__(23);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchPatientAppointments),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchProviderAppointments),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(sliceAppointmentForPatient),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleCancelOfficeVisit),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(cancelOfficeVisitAsProvider),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(sliceAppointmentAsProvider),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(declineAppointmentAsProvider),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(healthboardCancelSaga),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(messagesAppointmentCancelSaga);
	
	var cancelledStatuses = [_constants.VIRTUAL_VISIT_EVENTS.BREAK_VISIT, _constants.VIRTUAL_VISIT_EVENTS.DECLINE_VISIT];
	var FIRST_REQUEST_LIMIT = 10;
	
	function fetchPatientAppointments(userId) {
	  var location, counter, upcomingList, historyList, isHomeLocation;
	  return _regenerator2.default.wrap(function fetchPatientAppointments$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.currentLocationSelector);
	
	        case 2:
	          location = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors2.selectUpcomingCount);
	
	        case 5:
	          counter = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors2.selectUpcomingAppointmentList);
	
	        case 8:
	          upcomingList = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors2.selectHistoryAppointmentList);
	
	        case 11:
	          historyList = _context.sent;
	          isHomeLocation = location.includes('/' + userId + '/' + _routes.HEALTHBOARD_HOME);
	          _context.next = 15;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.setAppointmentId(undefined));
	
	        case 15:
	          if (!(counter >= FIRST_REQUEST_LIMIT || isHomeLocation)) {
	            _context.next = 18;
	            break;
	          }
	
	          _context.next = 18;
	          return (0, _effects.put)(upcomingAppointments.paginationActions.send({
	            limit: 1,
	            id: userId,
	            offset: (0, _size2.default)(upcomingList)
	          }));
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.put)(historyAppointments.actions.send({
	            silent: true,
	            id: userId,
	            offset: 0,
	            limit: (0, _size2.default)(historyList) < FIRST_REQUEST_LIMIT ? FIRST_REQUEST_LIMIT : (0, _size2.default)(historyList)
	          }));
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function fetchProviderAppointments(userId) {
	  var counter, upcomingList, isFilterToday, isFilterByTypeVisit, todayDate;
	  return _regenerator2.default.wrap(function fetchProviderAppointments$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors2.selectProviderUpcomingCount);
	
	        case 2:
	          counter = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_selectors2.selectProviderUpcomingAppointmentList);
	
	        case 5:
	          upcomingList = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.setAppointmentId(undefined));
	
	        case 8:
	          if (!(counter >= FIRST_REQUEST_LIMIT)) {
	            _context2.next = 18;
	            break;
	          }
	
	          _context2.next = 11;
	          return (0, _effects.select)(_selectors2.selectProviderUpcomingFilterToday);
	
	        case 11:
	          isFilterToday = _context2.sent;
	          _context2.next = 14;
	          return (0, _effects.select)(_selectors2.selectProviderUpcomingFilterByTypeVisit);
	
	        case 14:
	          isFilterByTypeVisit = _context2.sent;
	          todayDate = (0, _moment2.default)().format('YYYY-MM-DD');
	          _context2.next = 18;
	          return (0, _effects.put)(providerUpcomingAppointments.paginationActions.send((0, _extends3.default)({
	            limit: 1,
	            id: userId
	          }, isFilterToday && { date: todayDate }, isFilterByTypeVisit && {
	            visit_type_code: _constants.VIRTUAL_VISIT_TYPE_CODE
	          }, {
	            offset: (0, _size2.default)(upcomingList)
	          })));
	
	        case 18:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	/**
	 *  PATIENT BEHAVIOUR
	 * */
	
	function sliceAppointmentForPatient(_ref) {
	  var payload = _ref.payload;
	  var userId;
	  return _regenerator2.default.wrap(function sliceAppointmentForPatient$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          userId = payload.userId;
	          _context3.next = 3;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.setAppointmentId(undefined));
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.call)(fetchPatientAppointments, userId);
	
	        case 5:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function handleCancelOfficeVisit(_ref2) {
	  var payload = _ref2.payload;
	  var userId;
	  return _regenerator2.default.wrap(function handleCancelOfficeVisit$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          userId = payload.userId;
	          _context4.next = 3;
	          return (0, _effects.take)(cancelAppointment.consts.SUCCEED);
	
	        case 3:
	          _context4.next = 5;
	          return (0, _effects.call)(fetchPatientAppointments, userId);
	
	        case 5:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	/**
	 *  PROVIDER BEHAVIOUR
	 * */
	
	function cancelOfficeVisitAsProvider(_ref3) {
	  var payload = _ref3.payload;
	  var userId;
	  return _regenerator2.default.wrap(function cancelOfficeVisitAsProvider$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          userId = payload.userId;
	          _context5.next = 3;
	          return (0, _effects.take)(cancelAppointment.consts.SUCCEED);
	
	        case 3:
	          _context5.next = 5;
	          return (0, _effects.call)(fetchProviderAppointments, userId);
	
	        case 5:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function sliceAppointmentAsProvider(_ref4) {
	  var payload = _ref4.payload;
	  var userId;
	  return _regenerator2.default.wrap(function sliceAppointmentAsProvider$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          userId = payload.userId;
	          _context6.next = 3;
	          return (0, _effects.call)(fetchProviderAppointments, userId);
	
	        case 3:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function declineAppointmentAsProvider(_ref5) {
	  var payload = _ref5.payload;
	  var id, appointmentId, event;
	  return _regenerator2.default.wrap(function declineAppointmentAsProvider$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          id = payload.id, appointmentId = payload.appointmentId, event = payload.event;
	          _context7.next = 3;
	          return (0, _effects.take)(managePendingRequest.actions.succeed);
	
	        case 3:
	          if (!cancelledStatuses.includes(event)) {
	            _context7.next = 6;
	            break;
	          }
	
	          _context7.next = 6;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.sliceUpcomingAppointment({
	            id: appointmentId,
	            userId: id
	          }));
	
	        case 6:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function healthboardCancelSaga() {
	  var isProvider;
	  return _regenerator2.default.wrap(function healthboardCancelSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.select)(_selectors3.hasProviderProfileSelector);
	
	        case 2:
	          isProvider = _context8.sent;
	
	          if (!isProvider) {
	            _context8.next = 12;
	            break;
	          }
	
	          _context8.next = 6;
	          return (0, _effects.takeLatest)(cancelAppointment.consts.SEND, cancelOfficeVisitAsProvider);
	
	        case 6:
	          _context8.next = 8;
	          return (0, _effects.takeLatest)(managePendingRequest.actions.send, declineAppointmentAsProvider);
	
	        case 8:
	          _context8.next = 10;
	          return (0, _effects.takeLatest)(_appointmentDetails.APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT, sliceAppointmentAsProvider);
	
	        case 10:
	          _context8.next = 16;
	          break;
	
	        case 12:
	          _context8.next = 14;
	          return (0, _effects.takeLatest)(_appointmentDetails.APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT, sliceAppointmentForPatient);
	
	        case 14:
	          _context8.next = 16;
	          return (0, _effects.takeLatest)(cancelAppointment.consts.SEND, handleCancelOfficeVisit);
	
	        case 16:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function messagesAppointmentCancelSaga() {
	  return _regenerator2.default.wrap(function messagesAppointmentCancelSaga$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _effects.takeLatest)(_appointmentDetails.APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT, sliceAppointmentForPatient);
	
	        case 2:
	          _context9.next = 4;
	          return (0, _effects.takeLatest)(managePendingRequest.actions.send, declineAppointmentAsProvider);
	
	        case 4:
	          _context9.next = 6;
	          return (0, _effects.takeLatest)(cancelAppointment.consts.SEND, handleCancelOfficeVisit);
	
	        case 6:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}

/***/ }),
/* 4094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = cancelInvitationSaga;
	
	var _effects = __webpack_require__(14);
	
	var _cancelInvitationToVirtualRoomReq = __webpack_require__(851);
	
	var cancelInvitation = _interopRequireWildcard(_cancelInvitationToVirtualRoomReq);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(cancelInvitationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(cancelInvitationSaga);
	
	function cancelInvitationWorker() {
	  var _ref, succeed, failed;
	
	  return _regenerator2.default.wrap(function cancelInvitationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(cancelInvitation.actions.succeed),
	            failed: (0, _effects.take)([cancelInvitation.actions.rejected, cancelInvitation.actions.errorEncountered])
	          });
	
	        case 2:
	          _ref = _context.sent;
	          succeed = _ref.succeed;
	          failed = _ref.failed;
	
	          if (!succeed) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 8;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'virtualVisit.room.invitationRemoved' }
	          });
	
	        case 8:
	          if (!failed) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'errors.common' }
	          });
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function cancelInvitationSaga() {
	  return _regenerator2.default.wrap(function cancelInvitationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(cancelInvitation.actions.send, cancelInvitationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4095 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = changeAppointmentStatusSaga;
	
	var _effects = __webpack_require__(14);
	
	var _constants = __webpack_require__(17);
	
	var _finishVirtualVisitSaga = __webpack_require__(4100);
	
	var _declineVirtualVisitSaga = __webpack_require__(4098);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var changeAppointmentStatus = _interopRequireWildcard(_statusChangeReq);
	
	var _startVirtualVisitSaga = __webpack_require__(4110);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleStatusChange),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(changeAppointmentStatusSaga);
	
	function handleStatusChange(_ref) {
	  var payload = _ref.payload;
	  var event;
	  return _regenerator2.default.wrap(function handleStatusChange$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          event = payload.event;
	          _context.t0 = event;
	          _context.next = _context.t0 === _constants.VIRTUAL_VISIT_EVENTS.START_VISIT ? 4 : _context.t0 === _constants.VIRTUAL_VISIT_EVENTS.DECLINE_VISIT ? 7 : _context.t0 === _constants.VIRTUAL_VISIT_EVENTS.BREAK_VISIT ? 7 : _context.t0 === _constants.VIRTUAL_VISIT_EVENTS.FINISH_VISIT ? 10 : 13;
	          break;
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.call)(_startVirtualVisitSaga.startVirtualVisit, payload);
	
	        case 6:
	          return _context.abrupt('break', 13);
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.call)(_declineVirtualVisitSaga.declineVirtualVisit, payload);
	
	        case 9:
	          return _context.abrupt('break', 13);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.call)(_finishVirtualVisitSaga.finishVirtualVisit, payload);
	
	        case 12:
	          return _context.abrupt('break', 13);
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function changeAppointmentStatusSaga() {
	  return _regenerator2.default.wrap(function changeAppointmentStatusSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_appointmentDetails.APPOINTMENT_DETAILS_TYPES.CHANGE_STATUS, handleStatusChange);
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.takeLatest)([changeAppointmentStatus.consts.REJECTED, changeAppointmentStatus.consts.ERROR_ENCOUNTERED], _startVirtualVisitSaga.handleFailedChangeStatus);
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4096 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = scheduledTasksPagination;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _scheduledTasksCompletedReq = __webpack_require__(534);
	
	var scheduledCompletedTasks = _interopRequireWildcard(_scheduledTasksCompletedReq);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMoreCompletedTasks),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(scheduledTasksPagination);
	
	function loadMoreCompletedTasks(_ref) {
	  var payload = _ref.payload;
	  var paginationSending, pagination, counter, list, listSize;
	  return _regenerator2.default.wrap(function loadMoreCompletedTasks$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectScheduledCompletedTasksPaginationSending);
	
	        case 2:
	          paginationSending = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectScheduledCompletedTasksPagination);
	
	        case 5:
	          pagination = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectScheduledCompletedTasksCount);
	
	        case 8:
	          counter = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors.selectScheduledCompletedTasks);
	
	        case 11:
	          list = _context.sent;
	          listSize = (0, _size2.default)(list);
	
	          if (!(counter <= listSize || paginationSending)) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 16;
	          return (0, _effects.cancel)();
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.put)(scheduledCompletedTasks.paginationActions.send((0, _extends3.default)({}, payload, pagination, {
	            offset: listSize
	          })));
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function scheduledTasksPagination() {
	  return _regenerator2.default.wrap(function scheduledTasksPagination$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([scheduledCompletedTasks.consts.LOAD_MORE], loadMoreCompletedTasks);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.confirmVisitByPatientSagaWorker = confirmVisitByPatientSagaWorker;
	exports.default = confirmVisitByPatientSaga;
	
	var _effects = __webpack_require__(14);
	
	var _confirmVisitByPatientReq = __webpack_require__(666);
	
	var confirmlVisit = _interopRequireWildcard(_confirmVisitByPatientReq);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(confirmVisitByPatientSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(confirmVisitByPatientSaga);
	
	function confirmVisitByPatientSagaWorker(_ref) {
	  var payload = _ref.payload;
	
	  var _ref2, succeed, failed;
	
	  return _regenerator2.default.wrap(function confirmVisitByPatientSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(confirmlVisit.actions.send(payload));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(confirmlVisit.actions.succeed),
	            failed: (0, _effects.take)([confirmlVisit.actions.rejected, confirmlVisit.actions.errorEncountered])
	          });
	
	        case 4:
	          _ref2 = _context.sent;
	          succeed = _ref2.succeed;
	          failed = _ref2.failed;
	
	          if (!succeed) {
	            _context.next = 10;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'appointment.visitConfirmed' }
	          });
	
	        case 10:
	          if (!failed) {
	            _context.next = 13;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'errors.common' }
	          });
	
	        case 13:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function confirmVisitByPatientSaga() {
	  return _regenerator2.default.wrap(function confirmVisitByPatientSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(confirmlVisit.actions.init, confirmVisitByPatientSagaWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4098 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.declineVirtualVisit = declineVirtualVisit;
	
	var _effects = __webpack_require__(14);
	
	var _virtualVisit = __webpack_require__(305);
	
	var _constants = __webpack_require__(17);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var changeStatus = _interopRequireWildcard(_statusChangeReq);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _popup = __webpack_require__(76);
	
	var _appointmentDetailsReq = __webpack_require__(259);
	
	var appointmentDetails = _interopRequireWildcard(_appointmentDetailsReq);
	
	var _statusUrgentVisitChangeReq = __webpack_require__(669);
	
	var changeUrgentVisitStatus = _interopRequireWildcard(_statusUrgentVisitChangeReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleChangeRequest),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(defineChangeRequestByCode),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(declineVirtualVisit);
	
	function handleChangeRequest(request, payload) {
	  var _ref, result;
	
	  return _regenerator2.default.wrap(function handleChangeRequest$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(request.actions.send(payload));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.take)(request.consts.SUCCEED);
	
	        case 4:
	          _ref = _context.sent;
	          result = _ref.payload;
	          return _context.abrupt('return', { result: result });
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function defineChangeRequestByCode(_ref2) {
	  var code = _ref2.code,
	      payload = (0, _objectWithoutProperties3.default)(_ref2, ['code']);
	  return _regenerator2.default.wrap(function defineChangeRequestByCode$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.t0 = code;
	          _context2.next = _context2.t0 === _constants.URGENT_VISIT_TYPE_CODE ? 3 : 8;
	          break;
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.put)(_virtualVisit.virtualVisitActions.reset());
	
	        case 5:
	          _context2.next = 7;
	          return handleChangeRequest(changeUrgentVisitStatus, payload);
	
	        case 7:
	          return _context2.abrupt('return', _context2.sent);
	
	        case 8:
	          _context2.next = 10;
	          return handleChangeRequest(changeStatus, payload);
	
	        case 10:
	          return _context2.abrupt('return', _context2.sent);
	
	        case 11:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function declineVirtualVisit(_ref3) {
	  var id = _ref3.id,
	      event = _ref3.event,
	      reason = _ref3.reason,
	      appointment = _ref3.appointment;
	
	  var appointmentId, code, _ref4, result;
	
	  return _regenerator2.default.wrap(function declineVirtualVisit$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          appointmentId = appointment.id;
	          code = appointment.visitType.code;
	          _context3.next = 4;
	          return (0, _effects.put)((0, _popup.showLoaderInPopup)());
	
	        case 4:
	          _context3.next = 6;
	          return defineChangeRequestByCode({
	            id: id,
	            code: code,
	            event: event,
	            reason: reason,
	            appointmentId: appointmentId
	          });
	
	        case 6:
	          _ref4 = _context3.sent;
	          result = _ref4.result;
	          _context3.next = 10;
	          return (0, _effects.put)((0, _popup.hideLoaderInPopup)());
	
	        case 10:
	          _context3.next = 12;
	          return (0, _effects.put)(appointmentDetails.actions.succeed(result));
	
	        case 12:
	          _context3.next = 14;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.sliceUpcomingAppointment((0, _extends3.default)({}, result, {
	            userId: id
	          })));
	
	        case 14:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = deleteDocumentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	var _deleteDocumentReq = __webpack_require__(302);
	
	var deleteDocument = _interopRequireWildcard(_deleteDocumentReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleDeleteDocument),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(deleteDocumentSaga);
	
	function handleDeleteDocument(_ref) {
	  var _ref$payload = _ref.payload,
	      appointmentId = _ref$payload.appointmentId,
	      documentId = _ref$payload.documentId;
	
	  var _ref2, success;
	
	  return _regenerator2.default.wrap(function handleDeleteDocument$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.race)({
	            success: (0, _effects.take)(deleteDocument.consts.SUCCEED),
	            error: (0, _effects.take)(deleteDocument.consts.REJECTED)
	          });
	
	        case 2:
	          _ref2 = _context.sent;
	          success = _ref2.success;
	
	          if (!success) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)(deleteDocument.actions.update({
	            documentId: documentId,
	            appointmentId: appointmentId
	          }));
	
	        case 7:
	          _context.next = 11;
	          break;
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'errors.common' }
	          });
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function deleteDocumentSaga() {
	  return _regenerator2.default.wrap(function deleteDocumentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(deleteDocument.actions.send, handleDeleteDocument);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.finishVirtualVisit = finishVirtualVisit;
	
	var _effects = __webpack_require__(14);
	
	var _constants = __webpack_require__(17);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var changeStatus = _interopRequireWildcard(_statusChangeReq);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _appointmentDetailsReq = __webpack_require__(259);
	
	var appointmentDetails = _interopRequireWildcard(_appointmentDetailsReq);
	
	var _statusUrgentVisitChangeReq = __webpack_require__(669);
	
	var changeUrgentVisitStatus = _interopRequireWildcard(_statusUrgentVisitChangeReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleChangeRequest),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(defineChangeRequestByCode),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(finishVirtualVisit);
	
	function handleChangeRequest(request, payload) {
	  var _ref, result;
	
	  return _regenerator2.default.wrap(function handleChangeRequest$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(request.actions.send(payload));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.take)(request.consts.SUCCEED);
	
	        case 4:
	          _ref = _context.sent;
	          result = _ref.payload;
	          return _context.abrupt('return', { result: result });
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function defineChangeRequestByCode(_ref2) {
	  var code = _ref2.code,
	      payload = (0, _objectWithoutProperties3.default)(_ref2, ['code']);
	  return _regenerator2.default.wrap(function defineChangeRequestByCode$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.t0 = code;
	          _context2.next = _context2.t0 === _constants.URGENT_VISIT_TYPE_CODE ? 3 : 6;
	          break;
	
	        case 3:
	          _context2.next = 5;
	          return handleChangeRequest(changeUrgentVisitStatus, payload);
	
	        case 5:
	          return _context2.abrupt('return', _context2.sent);
	
	        case 6:
	          _context2.next = 8;
	          return handleChangeRequest(changeStatus, payload);
	
	        case 8:
	          return _context2.abrupt('return', _context2.sent);
	
	        case 9:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function finishVirtualVisit(_ref3) {
	  var id = _ref3.id,
	      event = _ref3.event,
	      appointment = _ref3.appointment;
	
	  var appointmentId, code, _ref4, result;
	
	  return _regenerator2.default.wrap(function finishVirtualVisit$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          appointmentId = appointment.id;
	          code = appointment.visitType.code;
	          _context3.next = 4;
	          return defineChangeRequestByCode({
	            id: id,
	            code: code,
	            event: event,
	            appointmentId: appointmentId
	          });
	
	        case 4:
	          _ref4 = _context3.sent;
	          result = _ref4.result;
	          _context3.next = 8;
	          return (0, _effects.put)(appointmentDetails.actions.succeed(result));
	
	        case 8:
	          _context3.next = 10;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.sliceUpcomingAppointment((0, _extends3.default)({}, result, {
	            userId: id
	          })));
	
	        case 10:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.inviteGuestSagaWorker = inviteGuestSagaWorker;
	exports.default = inviteGuestSaga;
	
	var _effects = __webpack_require__(14);
	
	var _inviteGuestToVirtualRoomReq = __webpack_require__(855);
	
	var inviteGuest = _interopRequireWildcard(_inviteGuestToVirtualRoomReq);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(inviteGuestSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(inviteGuestSaga);
	
	function inviteGuestSagaWorker(_ref) {
	  var payload = _ref.payload;
	
	  var close, params, _ref2, succeed;
	
	  return _regenerator2.default.wrap(function inviteGuestSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          close = payload.close, params = (0, _objectWithoutProperties3.default)(payload, ['close']);
	          _context.next = 3;
	          return (0, _effects.put)(inviteGuest.actions.send(params));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(inviteGuest.actions.succeed),
	            failed: (0, _effects.take)([inviteGuest.actions.rejected, inviteGuest.actions.errorEncountered])
	          });
	
	        case 5:
	          _ref2 = _context.sent;
	          succeed = _ref2.succeed;
	
	          if (!succeed) {
	            _context.next = 11;
	            break;
	          }
	
	          close();
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'virtualVisit.room.sentInvitation' }
	          });
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function inviteGuestSaga() {
	  return _regenerator2.default.wrap(function inviteGuestSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(inviteGuest.actions.init, inviteGuestSagaWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = handleAcceptedConsentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _managePendingRequest = __webpack_require__(263);
	
	var managePendingRequest = _interopRequireWildcard(_managePendingRequest);
	
	var _assignmentPendingReq = __webpack_require__(528);
	
	var pendingAssignments = _interopRequireWildcard(_assignmentPendingReq);
	
	var _assignmentReviewedReq = __webpack_require__(529);
	
	var pendingReviewed = _interopRequireWildcard(_assignmentReviewedReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleManagePendingRequest),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleAcceptedConsentSaga);
	
	function handleManagePendingRequest() {
	  return _regenerator2.default.wrap(function handleManagePendingRequest$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(pendingAssignments.actions.send({ offset: 0, limit: 10 }));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)(pendingReviewed.actions.send({ offset: 0, limit: 10 }));
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleAcceptedConsentSaga() {
	  return _regenerator2.default.wrap(function handleAcceptedConsentSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(managePendingRequest.actions.succeed, handleManagePendingRequest);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _ACTIONS_MAP;
	
	exports.default = manageTodoSaga;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _acceptInviteToFamilyCircle = __webpack_require__(408);
	
	var acceptFamilyInvite = _interopRequireWildcard(_acceptInviteToFamilyCircle);
	
	var _declineInviteToFamilyCircle = __webpack_require__(411);
	
	var declineFamilyInvite = _interopRequireWildcard(_declineInviteToFamilyCircle);
	
	var _acceptCaregiverRole = __webpack_require__(407);
	
	var acceptCareInvite = _interopRequireWildcard(_acceptCaregiverRole);
	
	var _declineCaregiverRole = __webpack_require__(410);
	
	var declineCareInvite = _interopRequireWildcard(_declineCaregiverRole);
	
	var _acceptGuardianRole = __webpack_require__(406);
	
	var acceptGuardianInvite = _interopRequireWildcard(_acceptGuardianRole);
	
	var _declineGuardianRole = __webpack_require__(409);
	
	var declineGuardianInvite = _interopRequireWildcard(_declineGuardianRole);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var upcomingSurveyCompletions = _interopRequireWildcard(_upcomingSurveyCompletions);
	
	var _scheduledTasksUpcomingReq = __webpack_require__(303);
	
	var scheduledTasks = _interopRequireWildcard(_scheduledTasksUpcomingReq);
	
	var _scheduledTasksCompletedReq = __webpack_require__(534);
	
	var scheduledCompletedTasks = _interopRequireWildcard(_scheduledTasksCompletedReq);
	
	var _completeTaskCustomReq = __webpack_require__(853);
	
	var competeTaskCustom = _interopRequireWildcard(_completeTaskCustomReq);
	
	var _completeTaskReq = __webpack_require__(665);
	
	var competeTask = _interopRequireWildcard(_completeTaskReq);
	
	var _completeCarePlanTaskReq = __webpack_require__(852);
	
	var completeCarePlanTask = _interopRequireWildcard(_completeCarePlanTaskReq);
	
	var _selectors = __webpack_require__(64);
	
	var _routes = __webpack_require__(37);
	
	var _signAppointmentConsentReq = __webpack_require__(201);
	
	var acceptedConsent = _interopRequireWildcard(_signAppointmentConsentReq);
	
	var _getLoggedUser = __webpack_require__(539);
	
	var getLoggedUser = _interopRequireWildcard(_getLoggedUser);
	
	var _selectors2 = __webpack_require__(115);
	
	var _selectors3 = __webpack_require__(23);
	
	var _constants = __webpack_require__(17);
	
	var _activeTodo = __webpack_require__(843);
	
	var _error = __webpack_require__(101);
	
	var errorUI = _interopRequireWildcard(_error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadOneScheduleTask),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchCompletedTodo),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleInvitationSaga),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(removeCompletedSurvey),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(toggleSurveyVisibility),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(handleStartCompletion),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(handleTaskSaga),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(handleTaskCustomSaga),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(handleCarePlanTaskSaga),
	    _marked10 = /*#__PURE__*/_regenerator2.default.mark(handleAcceptedConsent),
	    _marked11 = /*#__PURE__*/_regenerator2.default.mark(manageTodoSaga);
	
	var FIRST_REQUEST_LIMIT = 20;
	
	var ACTIONS_MAP = (_ACTIONS_MAP = {}, (0, _defineProperty3.default)(_ACTIONS_MAP, acceptFamilyInvite.consts.SEND, acceptFamilyInvite.consts.SUCCEED), (0, _defineProperty3.default)(_ACTIONS_MAP, declineFamilyInvite.consts.SEND, declineFamilyInvite.consts.SUCCEED), (0, _defineProperty3.default)(_ACTIONS_MAP, acceptCareInvite.consts.SEND, acceptCareInvite.consts.SUCCEED), (0, _defineProperty3.default)(_ACTIONS_MAP, declineCareInvite.consts.SEND, declineCareInvite.consts.SUCCEED), (0, _defineProperty3.default)(_ACTIONS_MAP, acceptGuardianInvite.consts.SEND, acceptGuardianInvite.consts.SUCCEED), (0, _defineProperty3.default)(_ACTIONS_MAP, declineGuardianInvite.consts.SEND, declineGuardianInvite.consts.SUCCEED), _ACTIONS_MAP);
	
	function loadOneScheduleTask() {
	  var location, id, isHomeLocation, counter, list;
	  return _regenerator2.default.wrap(function loadOneScheduleTask$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors2.currentLocationSelector);
	
	        case 2:
	          location = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors3.targetUserIdSelector);
	
	        case 5:
	          id = _context.sent;
	          isHomeLocation = location.includes('/' + id + '/' + _routes.HEALTHBOARD_HOME);
	          _context.next = 9;
	          return (0, _effects.select)(_selectors.selectScheduledTasksCount);
	
	        case 9:
	          counter = _context.sent;
	          _context.next = 12;
	          return (0, _effects.select)(_selectors.selectScheduledTasks);
	
	        case 12:
	          list = _context.sent;
	
	          if (!(counter >= FIRST_REQUEST_LIMIT || isHomeLocation)) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 16;
	          return (0, _effects.put)(scheduledTasks.paginationActions.send({
	            limit: 1,
	            offset: (0, _size2.default)(list),
	            id: id
	          }));
	
	        case 16:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function fetchCompletedTodo() {
	  var id, count;
	  return _regenerator2.default.wrap(function fetchCompletedTodo$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors3.targetUserIdSelector);
	
	        case 2:
	          id = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_selectors.selectScheduledCompletedTasksCount);
	
	        case 5:
	          count = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.put)(scheduledCompletedTasks.actions.send({
	            limit: FIRST_REQUEST_LIMIT,
	            offset: 0,
	            id: id,
	            silent: true,
	            count: count
	          }));
	
	        case 8:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	// Invitation
	
	function handleInvitationSaga(_ref) {
	  var type = _ref.type,
	      id = _ref.payload.id;
	  var succeedAction;
	  return _regenerator2.default.wrap(function handleInvitationSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          succeedAction = ACTIONS_MAP[type];
	          _context3.next = 3;
	          return (0, _effects.take)(succeedAction);
	
	        case 3:
	          _context3.next = 5;
	          return (0, _effects.put)(scheduledTasks.actions.removeEntity({
	            type: _constants.TODO_TYPES.INVITATION,
	            id: id
	          }));
	
	        case 5:
	          _context3.next = 7;
	          return (0, _effects.call)(loadOneScheduleTask);
	
	        case 7:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	// Survey
	
	function removeCompletedSurvey(assignmentId) {
	  return _regenerator2.default.wrap(function removeCompletedSurvey$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.call)(fetchCompletedTodo);
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.put)(scheduledTasks.actions.removeEntity({
	            type: _constants.TODO_TYPES.SURVEY,
	            matchParam: 'assignmentId',
	            id: assignmentId,
	            keepCount: true
	          }));
	
	        case 4:
	          _context4.next = 6;
	          return (0, _effects.call)(loadOneScheduleTask);
	
	        case 6:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function toggleSurveyVisibility(id, visible) {
	  return _regenerator2.default.wrap(function toggleSurveyVisibility$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.put)(scheduledTasks.actions.toggleVisibility({
	            type: _constants.TODO_TYPES.SURVEY,
	            matchParam: 'assignmentId',
	            id: id,
	            visible: visible
	          }));
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function handleStartCompletion(_ref2) {
	  var assignmentId = _ref2.payload.assignmentId;
	
	  var _ref3, succeed;
	
	  return _regenerator2.default.wrap(function handleStartCompletion$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.call)(toggleSurveyVisibility, assignmentId, false);
	
	        case 2:
	          _context6.next = 4;
	          return (0, _effects.put)(_activeTodo.activeTodoActions.setActiveItem(null));
	
	        case 4:
	          _context6.next = 6;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(upcomingSurveyCompletions.consts.SUCCEED),
	            failed: (0, _effects.take)([upcomingSurveyCompletions.consts.REJECTED, upcomingSurveyCompletions.consts.ERROR_ENCOUNTERED])
	          });
	
	        case 6:
	          _ref3 = _context6.sent;
	          succeed = _ref3.succeed;
	
	          if (!succeed) {
	            _context6.next = 13;
	            break;
	          }
	
	          _context6.next = 11;
	          return (0, _effects.call)(removeCompletedSurvey, assignmentId);
	
	        case 11:
	          _context6.next = 17;
	          break;
	
	        case 13:
	          _context6.next = 15;
	          return (0, _effects.call)(toggleSurveyVisibility, assignmentId, true);
	
	        case 15:
	          _context6.next = 17;
	          return (0, _effects.put)(errorUI.actions.update({ id: 'errors.common' }));
	
	        case 17:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	// Task
	
	function handleTaskSaga(_ref4) {
	  var payload = _ref4.payload;
	
	  var status, id, outcomeId, attachments, attachmentRequired, formData, _ref5, failed, succeed, textId;
	
	  return _regenerator2.default.wrap(function handleTaskSaga$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          status = payload.status, id = payload.id, outcomeId = payload.outcomeId, attachments = payload.attachments, attachmentRequired = payload.attachmentRequired;
	          formData = new FormData();
	
	          formData.append('status', status);
	          formData.append('id', id);
	
	          if (outcomeId) {
	            formData.append('chosen_outcome', outcomeId);
	          }
	
	          if ((0, _size2.default)(attachments) && attachmentRequired) {
	            attachments.map(function (item) {
	              return formData.append('outcome_attachments[]', item.file);
	            });
	          }
	
	          _context7.next = 8;
	          return (0, _effects.put)(competeTask.actions.send(formData));
	
	        case 8:
	          _context7.next = 10;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(competeTask.consts.SUCCEED),
	            failed: (0, _effects.take)(competeTask.consts.ERROR_ENCOUNTERED)
	          });
	
	        case 10:
	          _ref5 = _context7.sent;
	          failed = _ref5.failed;
	          succeed = _ref5.succeed;
	
	          if (!failed) {
	            _context7.next = 17;
	            break;
	          }
	
	          textId = attachmentRequired ? 'task.error.uploadFailed' : 'errors.common';
	          _context7.next = 17;
	          return (0, _effects.put)(errorUI.actions.update({ id: textId }));
	
	        case 17:
	          if (!succeed) {
	            _context7.next = 24;
	            break;
	          }
	
	          _context7.next = 20;
	          return (0, _effects.call)(fetchCompletedTodo);
	
	        case 20:
	          _context7.next = 22;
	          return (0, _effects.put)(scheduledTasks.actions.removeEntity({
	            type: _constants.TODO_TYPES.TASK,
	            matchParam: 'taskAssignmentId',
	            id: id
	          }));
	
	        case 22:
	          _context7.next = 24;
	          return (0, _effects.call)(loadOneScheduleTask);
	
	        case 24:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function handleTaskCustomSaga(_ref6) {
	  var payload = _ref6.payload;
	
	  var id, status, userId, formData, _ref7, failed, succeed;
	
	  return _regenerator2.default.wrap(function handleTaskCustomSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          id = payload.id, status = payload.status, userId = payload.userId;
	          formData = new FormData();
	
	          formData.append('id', id);
	          formData.append('status', status);
	          formData.append('user_id', userId);
	
	          _context8.next = 7;
	          return (0, _effects.put)(competeTaskCustom.actions.send(formData));
	
	        case 7:
	          _context8.next = 9;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(competeTaskCustom.consts.SUCCEED),
	            failed: (0, _effects.take)(competeTaskCustom.consts.ERROR_ENCOUNTERED)
	          });
	
	        case 9:
	          _ref7 = _context8.sent;
	          failed = _ref7.failed;
	          succeed = _ref7.succeed;
	
	          if (!failed) {
	            _context8.next = 15;
	            break;
	          }
	
	          _context8.next = 15;
	          return (0, _effects.put)(errorUI.actions.update({ id: 'errors.common' }));
	
	        case 15:
	          if (!succeed) {
	            _context8.next = 22;
	            break;
	          }
	
	          _context8.next = 18;
	          return (0, _effects.call)(fetchCompletedTodo);
	
	        case 18:
	          _context8.next = 20;
	          return (0, _effects.put)(scheduledTasks.actions.removeEntity({
	            type: _constants.TODO_TYPES.TASK_CUSTOM,
	            matchParam: 'id',
	            id: id
	          }));
	
	        case 20:
	          _context8.next = 22;
	          return (0, _effects.call)(loadOneScheduleTask);
	
	        case 22:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function handleCarePlanTaskSaga(_ref8) {
	  var payload = _ref8.payload;
	
	  var id, itemId, userId, outcomeId, attachments, formData, _ref10, failed, succeed;
	
	  return _regenerator2.default.wrap(function handleCarePlanTaskSaga$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          id = payload.id, itemId = payload.itemId, userId = payload.userId, outcomeId = payload.outcomeId, attachments = payload.attachments;
	          formData = new FormData();
	
	          formData.append('task_id', itemId);
	          formData.append('user_id', userId);
	          formData.append('chosen_outcome', outcomeId);
	
	          attachments.forEach(function (_ref9) {
	            var file = _ref9.file;
	            return formData.append('outcome_attachments[]', file);
	          });
	
	          _context9.next = 8;
	          return (0, _effects.put)(completeCarePlanTask.actions.send(formData));
	
	        case 8:
	          _context9.next = 10;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(completeCarePlanTask.consts.SUCCEED),
	            failed: (0, _effects.take)(completeCarePlanTask.consts.ERROR_ENCOUNTERED)
	          });
	
	        case 10:
	          _ref10 = _context9.sent;
	          failed = _ref10.failed;
	          succeed = _ref10.succeed;
	
	          if (!failed) {
	            _context9.next = 16;
	            break;
	          }
	
	          _context9.next = 16;
	          return (0, _effects.put)(errorUI.actions.update({ id: 'errors.common' }));
	
	        case 16:
	          if (!succeed) {
	            _context9.next = 23;
	            break;
	          }
	
	          _context9.next = 19;
	          return (0, _effects.call)(fetchCompletedTodo);
	
	        case 19:
	          _context9.next = 21;
	          return (0, _effects.put)(scheduledTasks.actions.removeEntity({
	            type: _constants.TODO_TYPES.CARE_PLAN_TASK,
	            matchParam: 'id',
	            id: id
	          }));
	
	        case 21:
	          _context9.next = 23;
	          return (0, _effects.call)(loadOneScheduleTask);
	
	        case 23:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}
	
	// Consent
	function handleAcceptedConsent() {
	  var userId;
	  return _regenerator2.default.wrap(function handleAcceptedConsent$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return (0, _effects.select)(_selectors3.loggedUserIdSelector);
	
	        case 2:
	          userId = _context10.sent;
	          _context10.next = 5;
	          return (0, _effects.call)(fetchCompletedTodo);
	
	        case 5:
	          _context10.next = 7;
	          return (0, _effects.call)(loadOneScheduleTask);
	
	        case 7:
	          _context10.next = 9;
	          return (0, _effects.put)(getLoggedUser.actions.send({ id: userId }));
	
	        case 9:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this);
	}
	
	function manageTodoSaga() {
	  var actionsToListen;
	  return _regenerator2.default.wrap(function manageTodoSaga$(_context11) {
	    while (1) {
	      switch (_context11.prev = _context11.next) {
	        case 0:
	          actionsToListen = (0, _keys2.default)(ACTIONS_MAP);
	          _context11.next = 3;
	          return (0, _effects.takeLatest)([actionsToListen], handleInvitationSaga);
	
	        case 3:
	          _context11.next = 5;
	          return (0, _effects.takeLatest)([upcomingSurveyCompletions.consts.SEND], handleStartCompletion);
	
	        case 5:
	          _context11.next = 7;
	          return (0, _effects.takeLatest)([competeTask.consts.START], handleTaskSaga);
	
	        case 7:
	          _context11.next = 9;
	          return (0, _effects.takeLatest)([competeTaskCustom.consts.START], handleTaskCustomSaga);
	
	        case 9:
	          _context11.next = 11;
	          return (0, _effects.takeLatest)(acceptedConsent.actions.succeed, handleAcceptedConsent);
	
	        case 11:
	          _context11.next = 13;
	          return (0, _effects.takeLatest)([completeCarePlanTask.consts.START], handleCarePlanTaskSaga);
	
	        case 13:
	        case 'end':
	          return _context11.stop();
	      }
	    }
	  }, _marked11, this);
	}

/***/ }),
/* 4104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = medicationRefillsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _medicationRefillReq = __webpack_require__(846);
	
	var _setPreferredPharmacyReq = __webpack_require__(532);
	
	var _medicationRefillsHistory = __webpack_require__(847);
	
	var _getUser = __webpack_require__(202);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	var _popup = __webpack_require__(76);
	
	var _selectors = __webpack_require__(23);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleUpdateUSerProfile),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(medicationRefillsSagaWorker),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(medicationRefillsSaga);
	
	function handleUpdateUSerProfile() {
	  var targetUserId, loggedUserId, safeUserId;
	  return _regenerator2.default.wrap(function handleUpdateUSerProfile$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 2:
	          targetUserId = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 5:
	          loggedUserId = _context.sent;
	          safeUserId = targetUserId || loggedUserId;
	          _context.next = 9;
	          return (0, _effects.put)(_getUser.actions.send({ id: safeUserId }));
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function medicationRefillsSagaWorker(_ref) {
	  var payload = _ref.payload;
	
	  var _ref2, succeed, rejected, thirdPartyError;
	
	  return _regenerator2.default.wrap(function medicationRefillsSagaWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)(_medicationRefillReq.actions.send(payload));
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(_medicationRefillReq.consts.SUCCEED),
	            rejected: (0, _effects.take)(_medicationRefillReq.consts.REJECTED)
	          });
	
	        case 4:
	          _ref2 = _context2.sent;
	          succeed = _ref2.succeed;
	          rejected = _ref2.rejected;
	
	          if (!succeed) {
	            _context2.next = 16;
	            break;
	          }
	
	          _context2.next = 10;
	          return (0, _effects.put)(_popup.actions.hide());
	
	        case 10:
	          _context2.next = 12;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: {
	              id: 'patient.portal.requestRefillNotification'
	            },
	            isStaticFlow: true,
	            infoErrorIcon: 'information'
	          });
	
	        case 12:
	          _context2.next = 14;
	          return (0, _effects.put)(_medicationRefillsHistory.actions.send({ userId: payload.userId }));
	
	        case 14:
	          _context2.next = 20;
	          break;
	
	        case 16:
	          thirdPartyError = (0, _get2.default)(rejected, 'payload.error.code', '') === 'third_party_error';
	
	          if (!thirdPartyError) {
	            _context2.next = 20;
	            break;
	          }
	
	          _context2.next = 20;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: {
	              id: 'errors.common'
	            }
	          });
	
	        case 20:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function medicationRefillsSaga() {
	  return _regenerator2.default.wrap(function medicationRefillsSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_medicationRefillReq.actions.init, medicationRefillsSagaWorker);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.takeLatest)(_setPreferredPharmacyReq.actions.succeed, handleUpdateUSerProfile);
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = payaAccountFormSaga;
	
	var _effects = __webpack_require__(14);
	
	var _popup = __webpack_require__(76);
	
	var popup = _interopRequireWildcard(_popup);
	
	var _routes = __webpack_require__(37);
	
	var _constants = __webpack_require__(17);
	
	var _payaPaymentSaga = __webpack_require__(1888);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(264);
	
	var _paymentInfoModal = __webpack_require__(541);
	
	var _accountVaults = __webpack_require__(688);
	
	var _props = __webpack_require__(41);
	
	var _refetchPaymentMethods = __webpack_require__(1897);
	
	var _selectors3 = __webpack_require__(50);
	
	var _selectors4 = __webpack_require__(43);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(payaAccountFormSagaPaymentTimeout),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(payaAccountFormSaga);
	
	var PAYA_POSTBACK_DELAY = 3000;
	
	function payaAccountFormSagaPaymentTimeout() {
	  var delaySeconds;
	  return _regenerator2.default.wrap(function payaAccountFormSagaPaymentTimeout$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors3.selectPaymentDelaySeconds);
	
	        case 2:
	          delaySeconds = _context.sent;
	          _context.next = 5;
	          return (0, _effects.delay)(delaySeconds * 1000);
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)(popup.actions.show({
	            contentType: _props.UI_POPUP_TYPES.MESSAGE,
	            contentOptions: {
	              message: { id: 'appointment.payment.errorMessage' },
	              title: { id: 'payment.accountForm.cardNotPermitted' }
	            }
	          }));
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function payaAccountFormSaga() {
	  var postMessageChannel, mainUserId, programId, isAppointmentPaymentInfoModalOpened, modalProps, isPatientPaymentMethodsPage, _ref, userId, locationId, result;
	
	  return _regenerator2.default.wrap(function payaAccountFormSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.call)(_payaPaymentSaga.handlePostMessage);
	
	        case 2:
	          postMessageChannel = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 5:
	          mainUserId = _context2.sent;
	          _context2.next = 8;
	          return (0, _effects.select)(_selectors2.selectPaymentInfoModalProgramId);
	
	        case 8:
	          programId = _context2.sent;
	          _context2.next = 11;
	          return (0, _effects.select)(_selectors4.selectAppointmentPaymentInfoModalOpened);
	
	        case 11:
	          isAppointmentPaymentInfoModalOpened = _context2.sent;
	          _context2.next = 14;
	          return (0, _effects.select)(_selectors4.selectAppointmentPaymentInfoModalProps);
	
	        case 14:
	          modalProps = _context2.sent;
	          isPatientPaymentMethodsPage = window.location.pathname.includes(_routes.PROFILE_PAYMENT_METHODS);
	          _ref = modalProps || {}, userId = _ref.userId, locationId = _ref.locationId;
	          _context2.next = 19;
	          return (0, _effects.fork)(payaAccountFormSagaPaymentTimeout);
	
	        case 19:
	          _context2.prev = 19;
	
	        case 20:
	          if (false) {
	            _context2.next = 47;
	            break;
	          }
	
	          _context2.next = 23;
	          return (0, _effects.take)(postMessageChannel);
	
	        case 23:
	          result = _context2.sent;
	
	          if (!result) {
	            _context2.next = 45;
	            break;
	          }
	
	          _context2.next = 27;
	          return (0, _effects.delay)(PAYA_POSTBACK_DELAY);
	
	        case 27:
	          _context2.next = 29;
	          return (0, _effects.put)(_paymentInfoModal.paymentInfoModalActions.clearPayaForm());
	
	        case 29:
	          _context2.next = 31;
	          return (0, _effects.delay)(PAYA_POSTBACK_DELAY);
	
	        case 31:
	          if (!isAppointmentPaymentInfoModalOpened) {
	            _context2.next = 36;
	            break;
	          }
	
	          _context2.next = 34;
	          return (0, _effects.put)(_accountVaults.actions.send({
	            userId: userId,
	            subjectId: locationId,
	            subjectType: _constants.SUBSCRIBABLE_TYPE.LOCATION
	          }));
	
	        case 34:
	          _context2.next = 43;
	          break;
	
	        case 36:
	          if (!isPatientPaymentMethodsPage) {
	            _context2.next = 41;
	            break;
	          }
	
	          _context2.next = 39;
	          return (0, _effects.call)(_refetchPaymentMethods.handleRefetchPaymentMethods);
	
	        case 39:
	          _context2.next = 43;
	          break;
	
	        case 41:
	          _context2.next = 43;
	          return (0, _effects.put)(_accountVaults.actions.send({
	            userId: mainUserId,
	            subjectId: programId,
	            subjectType: _constants.SUBSCRIBABLE_TYPE.PROGRAM
	          }));
	
	        case 43:
	          _context2.next = 45;
	          return (0, _effects.put)(popup.actions.hide());
	
	        case 45:
	          _context2.next = 20;
	          break;
	
	        case 47:
	          _context2.prev = 47;
	          _context2.next = 50;
	          return (0, _effects.cancelled)();
	
	        case 50:
	          if (!_context2.sent) {
	            _context2.next = 52;
	            break;
	          }
	
	          postMessageChannel.close();
	
	        case 52:
	          return _context2.finish(47);
	
	        case 53:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this, [[19,, 47, 53]]);
	}

/***/ }),
/* 4106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = paymentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _paymentUrgentVisit = __webpack_require__(1868);
	
	var _couponPriceCalculationReq = __webpack_require__(667);
	
	var couponCalculation = _interopRequireWildcard(_couponPriceCalculationReq);
	
	var _paymentOrderReq = __webpack_require__(857);
	
	var paymentOrder = _interopRequireWildcard(_paymentOrderReq);
	
	var _payaRedirectionReq = __webpack_require__(1309);
	
	var payaRedirection = _interopRequireWildcard(_payaRedirectionReq);
	
	var _paymentVerificationsReq = __webpack_require__(419);
	
	var paymentVerification = _interopRequireWildcard(_paymentVerificationsReq);
	
	var _couponVerificationReq = __webpack_require__(418);
	
	var couponVerification = _interopRequireWildcard(_couponVerificationReq);
	
	var _popup = __webpack_require__(76);
	
	var popup = _interopRequireWildcard(_popup);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	var _selectors = __webpack_require__(294);
	
	var _selectors2 = __webpack_require__(43);
	
	var _selectors3 = __webpack_require__(64);
	
	var _props = __webpack_require__(41);
	
	var _paymentMethods = __webpack_require__(3901);
	
	var _constants = __webpack_require__(17);
	
	var _accountVaultsForm = __webpack_require__(354);
	
	var _selectors4 = __webpack_require__(23);
	
	var _accountVaults = __webpack_require__(688);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _appointmentPaymentInfoModal = __webpack_require__(1220);
	
	var _appointmentAccountFormPaymentReq = __webpack_require__(339);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(82);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleAccountFormPaymentSaga),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleCouponCalculationSaga),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(runPayaPaymentFlow),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleFreePayment),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(handleStartingPaymentProcess),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(handleFailedPayment),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(handleSuccessPayment),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(handleNotAvailableCouponPayment),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(handleAppointmentAccountFormPaymentSuccess),
	    _marked10 = /*#__PURE__*/_regenerator2.default.mark(paymentSaga);
	
	var START_PAYMENT_PROCESS = _appointmentDetails.APPOINTMENT_DETAILS_TYPES.START_PAYMENT_PROCESS,
	    PAYMENT_FAIL = _appointmentDetails.APPOINTMENT_DETAILS_TYPES.PAYMENT_FAIL,
	    PAYMENT_SUCCESS = _appointmentDetails.APPOINTMENT_DETAILS_TYPES.PAYMENT_SUCCESS,
	    PAYMENT_TIMEOUT = _appointmentDetails.APPOINTMENT_DETAILS_TYPES.PAYMENT_TIMEOUT;
	
	
	function handleAccountFormPaymentSaga(payload) {
	  var _ref, location, paymentOrderId, loggedInUserId, roomInvitationUserId, userId, _ref2, locationId, _ref3, successAccountVaults, errorAccountVaults, isAtLeastOneVaultExists, props;
	
	  return _regenerator2.default.wrap(function handleAccountFormPaymentSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _ref = payload || {}, location = _ref.location, paymentOrderId = _ref.paymentOrderId;
	          _context.next = 3;
	          return (0, _effects.select)(_selectors4.loggedUserIdSelector);
	
	        case 3:
	          loggedInUserId = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(_selectors3.selectRoomInvitationInfoUserId);
	
	        case 6:
	          roomInvitationUserId = _context.sent;
	          userId = loggedInUserId || roomInvitationUserId;
	          _ref2 = location || {}, locationId = _ref2.id;
	          _context.next = 11;
	          return (0, _effects.put)(_accountVaults.actions.send({
	            userId: userId,
	            subjectId: locationId,
	            subjectType: _constants.SUBSCRIBABLE_TYPE.LOCATION
	          }));
	
	        case 11:
	          _context.next = 13;
	          return (0, _effects.race)({
	            successAccountVaults: (0, _effects.take)(_accountVaults.consts.SUCCEED),
	            errorAccountVaults: (0, _effects.take)(_accountVaults.consts.REJECTED)
	          });
	
	        case 13:
	          _ref3 = _context.sent;
	          successAccountVaults = _ref3.successAccountVaults;
	          errorAccountVaults = _ref3.errorAccountVaults;
	
	          if (!errorAccountVaults) {
	            _context.next = 21;
	            break;
	          }
	
	          _context.next = 19;
	          return (0, _effects.put)(error.actions.update({
	            id: 'errors.common'
	          }));
	
	        case 19:
	          _context.next = 30;
	          break;
	
	        case 21:
	          isAtLeastOneVaultExists = Boolean((0, _get2.default)(successAccountVaults, 'payload.length', 0));
	          props = {
	            locationId: locationId,
	            userId: userId
	          };
	          _context.next = 25;
	          return (0, _effects.put)(_appointmentPaymentInfoModal.appointmentPaymentInfoModalActions.open((0, _extends3.default)({}, props, {
	            paymentOrderId: paymentOrderId
	          })));
	
	        case 25:
	          if (isAtLeastOneVaultExists) {
	            _context.next = 30;
	            break;
	          }
	
	          _context.next = 28;
	          return (0, _effects.put)(_accountVaultsForm.actions.send(props));
	
	        case 28:
	          _context.next = 30;
	          return (0, _effects.put)({
	            type: popup.consts.SHOW,
	            payload: {
	              contentType: _props.UI_POPUP_TYPES.PAYA_ACCOUNT_FORM,
	              contentOptions: {
	                noCards: true
	              }
	            }
	          });
	
	        case 30:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleCouponCalculationSaga(_ref4) {
	  var payload = _ref4.payload;
	  var coupon;
	  return _regenerator2.default.wrap(function handleCouponCalculationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          coupon = payload.coupon;
	          _context2.next = 3;
	          return (0, _effects.take)(couponCalculation.consts.SUCCEED);
	
	        case 3:
	          _context2.next = 5;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.setCoupon(coupon));
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function runPayaPaymentFlow(paymentOrderId) {
	  var _ref5, payload, url;
	
	  return _regenerator2.default.wrap(function runPayaPaymentFlow$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)(payaRedirection.actions.send({ paymentOrderId: paymentOrderId }));
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.take)(payaRedirection.consts.SUCCEED);
	
	        case 4:
	          _ref5 = _context3.sent;
	          payload = _ref5.payload;
	          url = payload.url;
	          _context3.next = 9;
	          return (0, _effects.put)(popup.actions.show({
	            contentType: _props.UI_POPUP_TYPES.PAYA_PAYMENT,
	            contentOptions: { url: url }
	          }));
	
	        case 9:
	          _context3.next = 11;
	          return (0, _effects.take)([PAYMENT_SUCCESS, PAYMENT_FAIL]);
	
	        case 11:
	          _context3.next = 13;
	          return (0, _effects.put)(paymentVerification.actions.send({ paymentOrderId: paymentOrderId }));
	
	        case 13:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function handleFreePayment(_ref6) {
	  var paymentStatus = _ref6.paymentStatus,
	      paidAmount = _ref6.paidAmount;
	  var appointment;
	  return _regenerator2.default.wrap(function handleFreePayment$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (!(paymentStatus === _constants.PAYMENT_STATUSES.PAID)) {
	            _context4.next = 12;
	            break;
	          }
	
	          _context4.next = 3;
	          return (0, _effects.select)(_selectors3.selectActiveAppointment);
	
	        case 3:
	          appointment = _context4.sent;
	          _context4.next = 6;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.replaceAppointment((0, _extends3.default)({}, appointment, {
	            paymentStatus: paymentStatus,
	            paidAmount: paidAmount
	          })));
	
	        case 6:
	          _context4.next = 8;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.confirmVisit());
	
	        case 8:
	          _context4.next = 10;
	          return (0, _effects.put)(couponVerification.actions.clear());
	
	        case 10:
	          _context4.next = 12;
	          return (0, _effects.cancel)();
	
	        case 12:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function handleStartingPaymentProcess(_ref7) {
	  var appointmentId = _ref7.payload.id;
	
	  var coupon, _ref8, succeed, payload, paymentOrderId, payable, paymentMethod;
	
	  return _regenerator2.default.wrap(function handleStartingPaymentProcess$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.select)(_selectors3.selectActiveAppointmentCoupon);
	
	        case 2:
	          coupon = _context5.sent;
	          _context5.next = 5;
	          return (0, _effects.put)(paymentOrder.actions.send({ appointmentId: appointmentId, coupon: coupon }));
	
	        case 5:
	          _context5.next = 7;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(paymentOrder.consts.SUCCEED),
	            rejected: (0, _effects.take)(paymentOrder.consts.REJECTED)
	          });
	
	        case 7:
	          _ref8 = _context5.sent;
	          succeed = _ref8.succeed;
	
	          if (!succeed) {
	            _context5.next = 25;
	            break;
	          }
	
	          payload = succeed.payload;
	          paymentOrderId = payload.id, payable = payload.payable, paymentMethod = payload.paymentMethod;
	          _context5.next = 14;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.setOrderId(paymentOrderId));
	
	        case 14:
	          _context5.next = 16;
	          return (0, _effects.call)(handleFreePayment, payable);
	
	        case 16:
	          if (!(paymentMethod === _paymentMethods.PAYMENT_METHODS.HOSTED_PAYMENT_PAGE)) {
	            _context5.next = 21;
	            break;
	          }
	
	          _context5.next = 19;
	          return (0, _effects.call)(runPayaPaymentFlow, paymentOrderId);
	
	        case 19:
	          _context5.next = 23;
	          break;
	
	        case 21:
	          _context5.next = 23;
	          return (0, _effects.call)(handleAccountFormPaymentSaga, (0, _extends3.default)({ paymentOrderId: paymentOrderId }, payable));
	
	        case 23:
	          _context5.next = 27;
	          break;
	
	        case 25:
	          _context5.next = 27;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'appointment.payment.errorProvider' }
	          });
	
	        case 27:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function handleFailedPayment() {
	  var isAccountFormModalOpen, appointmentId, coupon, _ref9, succeed, newPaymentOrderId;
	
	  return _regenerator2.default.wrap(function handleFailedPayment$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.delay)(0);
	
	        case 2:
	          _context6.next = 4;
	          return (0, _effects.select)(_selectors2.selectAppointmentPaymentInfoModalOpened);
	
	        case 4:
	          isAccountFormModalOpen = _context6.sent;
	
	          if (!isAccountFormModalOpen) {
	            _context6.next = 25;
	            break;
	          }
	
	          _context6.next = 8;
	          return (0, _effects.select)(_selectors3.selectActiveAppointmentId);
	
	        case 8:
	          appointmentId = _context6.sent;
	          _context6.next = 11;
	          return (0, _effects.select)(_selectors3.selectActiveAppointmentCoupon);
	
	        case 11:
	          coupon = _context6.sent;
	
	          if (!appointmentId) {
	            _context6.next = 25;
	            break;
	          }
	
	          _context6.next = 15;
	          return (0, _effects.put)(paymentOrder.actions.send({ appointmentId: appointmentId, coupon: coupon }));
	
	        case 15:
	          _context6.next = 17;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(paymentOrder.consts.SUCCEED),
	            rejected: (0, _effects.take)(paymentOrder.consts.REJECTED)
	          });
	
	        case 17:
	          _ref9 = _context6.sent;
	          succeed = _ref9.succeed;
	
	          if (!succeed) {
	            _context6.next = 25;
	            break;
	          }
	
	          newPaymentOrderId = (0, _get2.default)(succeed, 'payload.id');
	          _context6.next = 23;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.setOrderId(newPaymentOrderId));
	
	        case 23:
	          _context6.next = 25;
	          return (0, _effects.put)(_appointmentPaymentInfoModal.appointmentPaymentInfoModalActions.updatePaymentOrderId(newPaymentOrderId));
	
	        case 25:
	          _context6.next = 27;
	          return (0, _effects.put)(popup.actions.show({
	            contentType: _props.UI_POPUP_TYPES.MESSAGE,
	            contentOptions: {
	              message: { id: 'appointment.payment.errorMessage' },
	              title: { id: 'appointment.payment.errorTitle' }
	            }
	          }));
	
	        case 27:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function handleSuccessPayment() {
	  var appointment, code;
	  return _regenerator2.default.wrap(function handleSuccessPayment$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)(_selectors.selectCurrentAppointment);
	
	        case 2:
	          appointment = _context7.sent;
	          code = (0, _get2.default)(appointment, 'visitType.code');
	          _context7.next = 6;
	          return (0, _effects.put)(success.actions.update({
	            id: 'appointment.payment.charged',
	            title: 'appointment.payment.submitted'
	          }));
	
	        case 6:
	          if (!(code !== _constants.URGENT_VISIT_TYPE_CODE)) {
	            _context7.next = 9;
	            break;
	          }
	
	          _context7.next = 9;
	          return (0, _effects.put)(couponVerification.actions.clear());
	
	        case 9:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function handleNotAvailableCouponPayment(_ref10) {
	  var _ref10$payload = _ref10.payload;
	  _ref10$payload = _ref10$payload === undefined ? {} : _ref10$payload;
	  var couponsAvailable = _ref10$payload.couponsAvailable,
	      automaticCouponAvailable = _ref10$payload.automaticCouponAvailable;
	  var id, paperworkAppointmentId, isUrgentVisitFlow;
	  return _regenerator2.default.wrap(function handleNotAvailableCouponPayment$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.select)(_selectors3.selectActiveAppointmentId);
	
	        case 2:
	          id = _context8.sent;
	          _context8.next = 5;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails.selectPaperworkAppointmentId);
	
	        case 5:
	          paperworkAppointmentId = _context8.sent;
	          _context8.next = 8;
	          return (0, _effects.select)(_selectors2.selectProgressIsUrgentVisitFlow);
	
	        case 8:
	          isUrgentVisitFlow = _context8.sent;
	
	          if (!(!automaticCouponAvailable && !couponsAvailable && isUrgentVisitFlow)) {
	            _context8.next = 11;
	            break;
	          }
	
	          return _context8.abrupt('return');
	
	        case 11:
	          if (!(id && automaticCouponAvailable)) {
	            _context8.next = 16;
	            break;
	          }
	
	          _context8.next = 14;
	          return (0, _effects.put)(couponCalculation.actions.send({ appointmentId: id }));
	
	        case 14:
	          _context8.next = 16;
	          return (0, _effects.fork)(_paymentUrgentVisit.handlePriceCalculations);
	
	        case 16:
	          if (!(couponsAvailable === false && !automaticCouponAvailable)) {
	            _context8.next = 19;
	            break;
	          }
	
	          _context8.next = 19;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.startPaymentProcess({
	            id: id || paperworkAppointmentId
	          }));
	
	        case 19:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function handleAppointmentAccountFormPaymentSuccess(_ref11) {
	  var payload = _ref11.payload;
	  var paymentStatus, isFailedPaymentStatus, isRoomInvitationPayment;
	  return _regenerator2.default.wrap(function handleAppointmentAccountFormPaymentSuccess$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          paymentStatus = (0, _get2.default)(payload, 'payable.paymentStatus');
	          isFailedPaymentStatus = !paymentStatus || _constants.FAILED_PAYMENT_STATUSES.includes(paymentStatus);
	          _context9.next = 4;
	          return (0, _effects.select)(_selectors3.selectRoomInvitationInfoAppointmentId);
	
	        case 4:
	          isRoomInvitationPayment = _context9.sent;
	
	          if (!isFailedPaymentStatus) {
	            _context9.next = 10;
	            break;
	          }
	
	          _context9.next = 8;
	          return (0, _effects.call)(handleFailedPayment);
	
	        case 8:
	          _context9.next = 17;
	          break;
	
	        case 10:
	          if (!isRoomInvitationPayment) {
	            _context9.next = 15;
	            break;
	          }
	
	          _context9.next = 13;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.paymentSuccess());
	
	        case 13:
	          _context9.next = 17;
	          break;
	
	        case 15:
	          _context9.next = 17;
	          return (0, _effects.call)(handleSuccessPayment);
	
	        case 17:
	          _context9.next = 19;
	          return (0, _effects.put)(_appointmentPaymentInfoModal.appointmentPaymentInfoModalActions.close());
	
	        case 19:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}
	
	function paymentSaga() {
	  return _regenerator2.default.wrap(function paymentSaga$(_context10) {
	    while (1) {
	      switch (_context10.prev = _context10.next) {
	        case 0:
	          _context10.next = 2;
	          return (0, _effects.takeLatest)(couponCalculation.consts.SEND, handleCouponCalculationSaga);
	
	        case 2:
	          _context10.next = 4;
	          return (0, _effects.takeLatest)(START_PAYMENT_PROCESS, handleStartingPaymentProcess);
	
	        case 4:
	          _context10.next = 6;
	          return (0, _effects.takeLatest)([PAYMENT_FAIL, PAYMENT_TIMEOUT, _appointmentAccountFormPaymentReq.consts.REJECTED, _appointmentAccountFormPaymentReq.consts.ERROR_ENCOUNTERED], handleFailedPayment);
	
	        case 6:
	          _context10.next = 8;
	          return (0, _effects.takeLatest)(PAYMENT_SUCCESS, handleSuccessPayment);
	
	        case 8:
	          _context10.next = 10;
	          return (0, _effects.takeLatest)(couponVerification.consts.SUCCEED, handleNotAvailableCouponPayment);
	
	        case 10:
	          _context10.next = 12;
	          return (0, _effects.takeLatest)([_appointmentAccountFormPaymentReq.consts.SUCCEED], handleAppointmentAccountFormPaymentSuccess);
	
	        case 12:
	        case 'end':
	          return _context10.stop();
	      }
	    }
	  }, _marked10, this);
	}

/***/ }),
/* 4107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _targetData;
	
	exports.default = providerAppointmentListPagination;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _virtualAppointmentsUpcommingReq = __webpack_require__(670);
	
	var providerUpcomingAppointments = _interopRequireWildcard(_virtualAppointmentsUpcommingReq);
	
	var _virtualAppointmentsHistoryReq = __webpack_require__(859);
	
	var providerHistoryAppointments = _interopRequireWildcard(_virtualAppointmentsHistoryReq);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMoreProviderAppointments),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(providerAppointmentListPagination);
	
	var targetData = (_targetData = {}, (0, _defineProperty3.default)(_targetData, providerUpcomingAppointments.consts.LOAD_MORE, {
	  selectors: {
	    pagination: _selectors.selectProviderUpcomingPagination,
	    list: _selectors.selectProviderUpcomingAppointmentList,
	    counter: _selectors.selectProviderUpcomingCount
	  },
	  fetch: providerUpcomingAppointments.paginationActions.send
	}), (0, _defineProperty3.default)(_targetData, providerHistoryAppointments.consts.LOAD_MORE, {
	  selectors: {
	    pagination: _selectors.selectProviderHistoryPagination,
	    list: _selectors.selectProviderHistoryAppointmentList,
	    counter: _selectors.selectProviderHistoryCount
	  },
	  fetch: providerHistoryAppointments.paginationActions.send
	}), _targetData);
	
	function loadMoreProviderAppointments(_ref) {
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  var _targetData$type, selectors, fetch, pagination, counter, list, listSize;
	
	  return _regenerator2.default.wrap(function loadMoreProviderAppointments$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _targetData$type = targetData[type], selectors = _targetData$type.selectors, fetch = _targetData$type.fetch;
	          _context.next = 3;
	          return (0, _effects.select)(selectors.pagination);
	
	        case 3:
	          pagination = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(selectors.counter);
	
	        case 6:
	          counter = _context.sent;
	          _context.next = 9;
	          return (0, _effects.select)(selectors.list);
	
	        case 9:
	          list = _context.sent;
	          listSize = (0, _size2.default)(list);
	
	          if (!(counter <= listSize)) {
	            _context.next = 14;
	            break;
	          }
	
	          _context.next = 14;
	          return (0, _effects.cancel)();
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.put)(fetch((0, _extends3.default)({}, payload, pagination, { offset: listSize })));
	
	        case 16:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function providerAppointmentListPagination() {
	  return _regenerator2.default.wrap(function providerAppointmentListPagination$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([providerUpcomingAppointments.consts.LOAD_MORE, providerHistoryAppointments.consts.LOAD_MORE], loadMoreProviderAppointments);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = roomInvitationJoinSaga;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _effects = __webpack_require__(14);
	
	var _storageKeys = __webpack_require__(215);
	
	var _virtualVisit = __webpack_require__(305);
	
	var _index = __webpack_require__(17);
	
	var _roomInvitationJoinReq = __webpack_require__(1310);
	
	var roomInvitationJoin = _interopRequireWildcard(_roomInvitationJoinReq);
	
	var _roomInvitationInfoReq = __webpack_require__(858);
	
	var roomInvitationInfo = _interopRequireWildcard(_roomInvitationInfoReq);
	
	var _connectionRoomJoinReq = __webpack_require__(854);
	
	var connectionRoomJoin = _interopRequireWildcard(_connectionRoomJoinReq);
	
	var _joinByVisitCodeReq = __webpack_require__(668);
	
	var joinByVisitCode = _interopRequireWildcard(_joinByVisitCodeReq);
	
	var _selectors = __webpack_require__(64);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _checkPermission = __webpack_require__(1312);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(roomInvitationJoinSuccessRequest),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleConnectionRoomJoin),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(initiateJoinVisitByCode),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleRoomInvitationInfoSuccess),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(roomInvitationJoinSaga);
	
	/**
	 * Handle join to virtual room by link
	 * as PATIENT or GUEST (Invite Call)
	 * */
	function roomInvitationJoinSuccessRequest(_ref) {
	  var meta = _ref.payload;
	  var data, status, roomName, roomNumber, visitTypeName, completed, consents, allSigned, isPatientInvitatin, shouldSignConsent, type, config;
	  return _regenerator2.default.wrap(function roomInvitationJoinSuccessRequest$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectRoomInvitationJoinData);
	
	        case 2:
	          data = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectRoomInvitationJoinStatus);
	
	        case 5:
	          status = _context.sent;
	          roomName = (0, _get2.default)(data, 'patientUserInfo.displayableName', '');
	          roomNumber = 'VV-' + (0, _get2.default)(data, 'id', '');
	          visitTypeName = (0, _get2.default)(data, 'visitType.name', '');
	          completed = _index.COMPLETED_APPOINTMENT_STATUSES.includes(status);
	          consents = (0, _get2.default)(data, 'consentsAssignment.consents') || [];
	          allSigned = consents.every(function (consent) {
	            return consent.accepted;
	          });
	          isPatientInvitatin = Boolean((0, _get2.default)(meta, 'patientProfile'));
	          shouldSignConsent = !allSigned && isPatientInvitatin;
	          type = isPatientInvitatin ? _index.VIRTUAL_VISIT_INVITE_TYPE.PATIENT : _index.VIRTUAL_VISIT_INVITE_TYPE.GUEST;
	
	          if (completed) {
	            _context.next = 26;
	            break;
	          }
	
	          config = (0, _extends3.default)({}, meta, {
	            type: type,
	            roomName: roomName,
	            roomNumber: roomNumber,
	            visitTypeName: visitTypeName,
	            shouldSignConsent: shouldSignConsent,
	            appointmentId: (0, _get2.default)(data, 'id')
	          });
	          _context.next = 19;
	          return (0, _effects.call)(function () {
	            return (0, _checkPermission.checkPermission)(true);
	          });
	
	        case 19:
	          _context.next = 21;
	          return (0, _effects.put)(_virtualVisit.virtualVisitActions.setConfig(config));
	
	        case 21:
	          if (!shouldSignConsent) {
	            _context.next = 24;
	            break;
	          }
	
	          _context.next = 24;
	          return (0, _effects.cancel)();
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.put)(_virtualVisit.virtualVisitActions.setVisibility(true));
	
	        case 26:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	/**
	 * Handle join to virtual room by link
	 * as GUEST (Direct Call)
	 * */
	function handleConnectionRoomJoin() {
	  var connectionRoomData, config;
	  return _regenerator2.default.wrap(function handleConnectionRoomJoin$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors.selectConnectionRoomJoinData);
	
	        case 2:
	          connectionRoomData = _context2.sent;
	          config = {
	            roomNumber: (0, _get2.default)(connectionRoomData, 'chatRoomId', ''),
	            room: (0, _get2.default)(connectionRoomData, 'credentials.room', ''),
	            token: (0, _get2.default)(connectionRoomData, 'credentials.token', ''),
	            apiKey: (0, _get2.default)(connectionRoomData, 'credentials.apiKey', ''),
	            connectionRoom: true,
	            type: _index.VIRTUAL_VISIT_INVITE_TYPE.CONNECTION_ROOM
	          };
	          _context2.next = 6;
	          return (0, _effects.call)(function () {
	            return (0, _checkPermission.checkPermission)(true);
	          });
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.put)(_virtualVisit.virtualVisitActions.setConfig(config));
	
	        case 8:
	          _context2.next = 10;
	          return (0, _effects.put)(_virtualVisit.virtualVisitActions.setVisibility(true));
	
	        case 10:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	/**
	 * Handle join to virtual room by visit code
	 * as PATIENT (in office visit)
	 * */
	function initiateJoinVisitByCode(_ref2) {
	  var visitCode = _ref2.payload;
	
	  var _ref3, meta, data, consents, allSigned, roomName, roomNumber, shouldSignConsent, config;
	
	  return _regenerator2.default.wrap(function initiateJoinVisitByCode$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)(joinByVisitCode.actions.send({ visitCode: visitCode }));
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.take)(joinByVisitCode.consts.ADD_META);
	
	        case 4:
	          _ref3 = _context3.sent;
	          meta = _ref3.payload;
	          _context3.next = 8;
	          return (0, _effects.select)(_selectors.selectVirtualRoomByCodeData);
	
	        case 8:
	          data = _context3.sent;
	          consents = (0, _get2.default)(data, 'consentsAssignment.consents') || [];
	          allSigned = consents.every(function (consent) {
	            return consent.accepted;
	          });
	          roomName = (0, _get2.default)(data, 'patientUserInfo.displayableName', '');
	          roomNumber = 'VV-' + (0, _get2.default)(data, 'id', '');
	          shouldSignConsent = !allSigned;
	          config = (0, _extends3.default)({}, meta, {
	            roomNumber: roomNumber,
	            roomName: roomName,
	            shouldSignConsent: shouldSignConsent,
	            appointmentId: (0, _get2.default)(data, 'id'),
	            type: _index.VIRTUAL_VISIT_INVITE_TYPE.IN_OFFICE
	          });
	          _context3.next = 17;
	          return (0, _effects.call)(function () {
	            return (0, _checkPermission.checkPermission)(true);
	          });
	
	        case 17:
	          _context3.next = 19;
	          return (0, _effects.put)(_virtualVisit.virtualVisitActions.setConfig(config));
	
	        case 19:
	          if (!shouldSignConsent) {
	            _context3.next = 22;
	            break;
	          }
	
	          _context3.next = 22;
	          return (0, _effects.cancel)();
	
	        case 22:
	          _context3.next = 24;
	          return (0, _effects.put)(_virtualVisit.virtualVisitActions.setVisibility(true));
	
	        case 24:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function handleRoomInvitationInfoSuccess(_ref4) {
	  var meta = _ref4.payload;
	  var isRequiredPayment, inviteCode;
	  return _regenerator2.default.wrap(function handleRoomInvitationInfoSuccess$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          isRequiredPayment = (0, _get2.default)(meta, 'isRequiredPayment', false);
	          inviteCode = (0, _get2.default)(window.location, 'hash', '').slice(1);
	
	          if (isRequiredPayment) {
	            _context4.next = 6;
	            break;
	          }
	
	          _context4.next = 5;
	          return (0, _effects.put)(roomInvitationJoin.actions.send({ inviteCode: inviteCode }));
	
	        case 5:
	          return _context4.abrupt('return');
	
	        case 6:
	
	          window.storage.setItem(_storageKeys.ROOM_INVITATION_TOKEN, inviteCode);
	
	          _context4.next = 9;
	          return (0, _effects.take)(_appointmentDetails.APPOINTMENT_DETAILS_TYPES.PAYMENT_SUCCESS);
	
	        case 9:
	
	          window.storage.removeItem(_storageKeys.ROOM_INVITATION_TOKEN);
	          _context4.next = 12;
	          return (0, _effects.put)(roomInvitationJoin.actions.send({ inviteCode: inviteCode }));
	
	        case 12:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function roomInvitationJoinSaga() {
	  return _regenerator2.default.wrap(function roomInvitationJoinSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)([roomInvitationInfo.consts.ADD_META], handleRoomInvitationInfoSuccess);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.takeLatest)([roomInvitationJoin.consts.ADD_META], roomInvitationJoinSuccessRequest);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.takeLatest)([connectionRoomJoin.consts.SUCCEED], handleConnectionRoomJoin);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.takeLatest)([joinByVisitCode.consts.INIT], initiateJoinVisitByCode);
	
	        case 8:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 4109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = scheduledTasksPagination;
	
	var _effects = __webpack_require__(14);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _scheduledTasksUpcomingReq = __webpack_require__(303);
	
	var scheduledTasks = _interopRequireWildcard(_scheduledTasksUpcomingReq);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(loadMoreScheduledTasks),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(scheduledTasksPagination);
	
	function loadMoreScheduledTasks(_ref) {
	  var payload = _ref.payload;
	  var paginationSending, pagination, counter, list, listSize;
	  return _regenerator2.default.wrap(function loadMoreScheduledTasks$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectScheduledTasksPaginationSending);
	
	        case 2:
	          paginationSending = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectScheduledTasksPagination);
	
	        case 5:
	          pagination = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectScheduledTasksCount);
	
	        case 8:
	          counter = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_selectors.selectScheduledTasks);
	
	        case 11:
	          list = _context.sent;
	          listSize = (0, _size2.default)(list);
	
	          if (!(counter <= listSize || paginationSending)) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 16;
	          return (0, _effects.cancel)();
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.put)(scheduledTasks.paginationActions.send((0, _extends3.default)({}, payload, pagination, {
	            offset: listSize
	          })));
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function scheduledTasksPagination() {
	  return _regenerator2.default.wrap(function scheduledTasksPagination$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([scheduledTasks.consts.LOAD_MORE], loadMoreScheduledTasks);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.startVirtualVisit = startVirtualVisit;
	exports.handleFailedChangeStatus = handleFailedChangeStatus;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _checkForIsSignedAllConsents = __webpack_require__(767);
	
	var _popup = __webpack_require__(76);
	
	var _selectors = __webpack_require__(23);
	
	var _success2 = __webpack_require__(104);
	
	var sucessUI = _interopRequireWildcard(_success2);
	
	var _constants = __webpack_require__(17);
	
	var _appointmentConsentModal = __webpack_require__(262);
	
	var _selectors2 = __webpack_require__(50);
	
	var _appointmentDetails = __webpack_require__(102);
	
	var _statusChangeReq = __webpack_require__(217);
	
	var changeStatus = _interopRequireWildcard(_statusChangeReq);
	
	var _statusUrgentVisitChangeReq = __webpack_require__(669);
	
	var changeUrgentVisitStatus = _interopRequireWildcard(_statusUrgentVisitChangeReq);
	
	var _appointmentDetailsReq = __webpack_require__(259);
	
	var appointmentDetails = _interopRequireWildcard(_appointmentDetailsReq);
	
	var _error = __webpack_require__(101);
	
	var _virtualVisit = __webpack_require__(305);
	
	var _selectors3 = __webpack_require__(64);
	
	var _appStateReq = __webpack_require__(526);
	
	var appState = _interopRequireWildcard(_appStateReq);
	
	var _checkPermission = __webpack_require__(1312);
	
	var _gtag = __webpack_require__(182);
	
	var _appointmentSurveyAssignment = __webpack_require__(844);
	
	var _constants2 = __webpack_require__(493);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleChangeRequest),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(defineChangeRequestByCode),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(startVirtualVisit),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleFailedChangeStatus);
	
	function alreadyStartedCall() {
	  return {
	    type: sucessUI.consts.UPDATE,
	    payload: { id: 'virtualVisit.error.alreadyInCall' },
	    iconType: 'info-active'
	  };
	}
	
	function handleChangeRequest(request, payload) {
	  var _ref, error, _ref$success, success, _success, _success$, result, _success$2, meta;
	
	  return _regenerator2.default.wrap(function handleChangeRequest$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(request.actions.send(payload));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.race)({
	            error: (0, _effects.take)(request.consts.REJECTED),
	            success: (0, _effects.all)([(0, _effects.take)(request.consts.SUCCEED), (0, _effects.take)(request.consts.ADD_META)])
	          });
	
	        case 4:
	          _ref = _context.sent;
	          error = _ref.error;
	          _ref$success = _ref.success;
	          success = _ref$success === undefined ? [] : _ref$success;
	          _success = (0, _slicedToArray3.default)(success, 2), _success$ = _success[0];
	          _success$ = _success$ === undefined ? {} : _success$;
	          result = _success$.payload, _success$2 = _success[1];
	          _success$2 = _success$2 === undefined ? {} : _success$2;
	          meta = _success$2.payload;
	          return _context.abrupt('return', { error: error, result: result, meta: meta });
	
	        case 14:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function defineChangeRequestByCode(_ref2) {
	  var code = _ref2.code,
	      payload = (0, _objectWithoutProperties3.default)(_ref2, ['code']);
	  return _regenerator2.default.wrap(function defineChangeRequestByCode$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.t0 = code;
	          _context2.next = _context2.t0 === _constants.URGENT_VISIT_TYPE_CODE ? 3 : 6;
	          break;
	
	        case 3:
	          _context2.next = 5;
	          return handleChangeRequest(changeUrgentVisitStatus, payload);
	
	        case 5:
	          return _context2.abrupt('return', _context2.sent);
	
	        case 6:
	          _context2.next = 8;
	          return handleChangeRequest(changeStatus, payload);
	
	        case 8:
	          return _context2.abrupt('return', _context2.sent);
	
	        case 9:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function startVirtualVisit(_ref3) {
	  var id = _ref3.id,
	      appointment = _ref3.appointment,
	      event = _ref3.event,
	      flow = _ref3.flow;
	
	  var currentUserId, isActive, isProvider, appointmentId, code, consentsEntity, isSignedAllConsents, isPreVisitFormRequired, allPrePreVisitForm, notSignedPreVisitForms, allConsents, notSignedConsent, userId, organizationName, serviceName, dateTime, nextUnsignedPreVisitForm, _ref4, error, result, meta, visitTestCallPerformed;
	
	  return _regenerator2.default.wrap(function startVirtualVisit$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 2:
	          currentUserId = _context3.sent;
	          _context3.next = 5;
	          return (0, _effects.select)(_selectors3.selectVirtualVisitActive);
	
	        case 5:
	          isActive = _context3.sent;
	          _context3.next = 8;
	          return (0, _effects.select)(_selectors.hasProviderProfileSelector);
	
	        case 8:
	          isProvider = _context3.sent;
	          appointmentId = appointment.id;
	          code = appointment.visitType.code;
	          consentsEntity = appointment.consentsAssignment;
	          isSignedAllConsents = (0, _checkForIsSignedAllConsents.checkForIsSignedAllConsents)(appointment);
	          isPreVisitFormRequired = (0, _get2.default)(appointment, 'requiredSurveys', false);
	          allPrePreVisitForm = (0, _get2.default)(appointment, 'surveyAssignments', []);
	          notSignedPreVisitForms = allPrePreVisitForm.filter(function (form) {
	            return ![_constants2.STATUS_SURVEY.COMPLETED, _constants2.STATUS_SURVEY.EXPIRED].includes(form.status) && !!form.survey.required;
	          });
	
	          if (!(consentsEntity && !isSignedAllConsents && !isProvider)) {
	            _context3.next = 27;
	            break;
	          }
	
	          allConsents = consentsEntity ? consentsEntity.consents : [];
	          notSignedConsent = allConsents.filter(function (item) {
	            return !item.accepted;
	          });
	          userId = (0, _get2.default)(appointment, 'userId');
	          organizationName = consentsEntity.userAppointment.organization.name;
	          serviceName = consentsEntity.userAppointment.service.name;
	          dateTime = consentsEntity.userAppointment.startTime;
	          _context3.next = 25;
	          return (0, _effects.put)(_appointmentConsentModal.appointmentConsentsModalActions.open({
	            consent: notSignedConsent[0],
	            organizationName: organizationName,
	            serviceName: serviceName,
	            allConsents: allConsents,
	            startTime: dateTime,
	            patientUserInfoId: userId || currentUserId
	          }));
	
	        case 25:
	          _context3.next = 27;
	          return (0, _effects.cancel)();
	
	        case 27:
	          if (!(isPreVisitFormRequired && notSignedPreVisitForms.length > 0)) {
	            _context3.next = 36;
	            break;
	          }
	
	          nextUnsignedPreVisitForm = notSignedPreVisitForms.find(function (form) {
	            return ![_constants2.STATUS_SURVEY.COMPLETED, _constants2.STATUS_SURVEY.EXPIRED].includes(form.status) && !!form.survey.required;
	          }) || {};
	
	          if (!nextUnsignedPreVisitForm.assignmentId) {
	            _context3.next = 36;
	            break;
	          }
	
	          _context3.next = 32;
	          return (0, _effects.put)(_appointmentSurveyAssignment.preVisitConsentsModalActions.setAssignmentId(nextUnsignedPreVisitForm.assignmentId));
	
	        case 32:
	          _context3.next = 34;
	          return (0, _effects.put)(_appointmentSurveyAssignment.preVisitConsentsModalActions.setSurveys(notSignedPreVisitForms));
	
	        case 34:
	          _context3.next = 36;
	          return (0, _effects.cancel)();
	
	        case 36:
	          if (!isActive) {
	            _context3.next = 41;
	            break;
	          }
	
	          _context3.next = 39;
	          return (0, _effects.put)(alreadyStartedCall());
	
	        case 39:
	          _context3.next = 41;
	          return (0, _effects.cancel)();
	
	        case 41:
	          _context3.next = 43;
	          return (0, _effects.call)(_checkPermission.checkPermission);
	
	        case 43:
	          _context3.next = 45;
	          return (0, _effects.put)((0, _popup.showLoaderInPopup)());
	
	        case 45:
	          _context3.next = 47;
	          return defineChangeRequestByCode({
	            id: id,
	            code: code,
	            event: event,
	            appointmentId: appointmentId
	          });
	
	        case 47:
	          _ref4 = _context3.sent;
	          error = _ref4.error;
	          result = _ref4.result;
	          meta = _ref4.meta;
	
	          if (!error) {
	            _context3.next = 58;
	            break;
	          }
	
	          _context3.next = 54;
	          return (0, _effects.put)((0, _popup.hideLoaderInPopup)());
	
	        case 54:
	          _context3.next = 56;
	          return (0, _effects.put)(_error.actions.update({ id: 'errors.common' }));
	
	        case 56:
	          _context3.next = 58;
	          return (0, _effects.cancel)();
	
	        case 58:
	          _context3.next = 60;
	          return (0, _effects.select)(_selectors2.selectVisitTestCallPerformed);
	
	        case 60:
	          visitTestCallPerformed = _context3.sent;
	
	          if (visitTestCallPerformed) {
	            _context3.next = 64;
	            break;
	          }
	
	          _context3.next = 64;
	          return (0, _effects.put)(appState.actions.changeTestCallPerformedStatus());
	
	        case 64:
	          _context3.next = 66;
	          return (0, _effects.put)(_appointmentDetails.appointmentDetailsActions.replaceAppointment((0, _extends3.default)({}, appointment, {
	            room: result.room,
	            status: result.status
	          })));
	
	        case 66:
	          _context3.next = 68;
	          return (0, _effects.put)(_virtualVisit.virtualVisitActions.setConfig((0, _extends3.default)({}, meta, {
	            roomPendingInvitations: (0, _get2.default)(result, 'roomPendingInvitations'),
	            typeCode: (0, _get2.default)(appointment, 'visitType.code'),
	            roomName: (0, _get2.default)(appointment, 'patientUserInfo.displayableName', ''),
	            roomNumber: 'VV-' + appointmentId
	          })));
	
	        case 68:
	          _context3.next = 70;
	          return (0, _effects.put)(appointmentDetails.actions.succeed(result));
	
	        case 70:
	          _context3.next = 72;
	          return (0, _effects.put)(_virtualVisit.virtualVisitActions.setVisibility(true));
	
	        case 72:
	          if (!(flow === 'get-care')) {
	            _context3.next = 75;
	            break;
	          }
	
	          _context3.next = 75;
	          return (0, _effects.call)(function () {
	            return (0, _gtag.GATrackCustomEvent)(_gtag.CustomEvents.GET_CARE_COMPLETE, {
	              visitCode: code
	            });
	          });
	
	        case 75:
	          _context3.next = 77;
	          return (0, _effects.put)((0, _popup.hideLoaderInPopup)());
	
	        case 77:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function handleFailedChangeStatus() {
	  return _regenerator2.default.wrap(function handleFailedChangeStatus$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.put)((0, _popup.hideLoaderInPopup)());
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}

/***/ }),
/* 4111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.watchTestCallModalOpen = watchTestCallModalOpen;
	
	var _effects = __webpack_require__(14);
	
	var _testCall = __webpack_require__(535);
	
	var _checkPermission = __webpack_require__(1312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleTestCallInPopup),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchTestCallModalOpen);
	
	function handleTestCallInPopup(_ref) {
	  var payload = _ref.payload;
	  return _regenerator2.default.wrap(function handleTestCallInPopup$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(_checkPermission.checkPermission);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)(_testCall.testCallActions.open(payload));
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function watchTestCallModalOpen() {
	  return _regenerator2.default.wrap(function watchTestCallModalOpen$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_testCall.TEST_CALL_ACTION_TYPES.INIT, handleTestCallInPopup);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = uploadDocumentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectors = __webpack_require__(23);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	var _uploadDocumentReq = __webpack_require__(304);
	
	var uploadDocument = _interopRequireWildcard(_uploadDocumentReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleUploadDocument),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleSuccessUpload),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleErrorUpload),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(uploadDocumentSaga);
	
	function handleUploadDocument(_ref) {
	  var _ref$payload = _ref.payload,
	      category = _ref$payload.category,
	      documents = _ref$payload.documents,
	      subCategory = _ref$payload.subCategory,
	      appointmentId = _ref$payload.appointmentId;
	  var userId, formData;
	  return _regenerator2.default.wrap(function handleUploadDocument$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 2:
	          userId = _context.sent;
	          formData = new FormData();
	
	
	          formData.append('document_category_id', category);
	          formData.append('document_subcategory_id', subCategory);
	          formData.append('appointmentId', appointmentId);
	          formData.append('userId', userId);
	          formData.append('file', documents);
	
	          _context.prev = 9;
	          _context.next = 12;
	          return (0, _effects.put)(uploadDocument.actions.send(formData));
	
	        case 12:
	          _context.next = 19;
	          break;
	
	        case 14:
	          _context.prev = 14;
	          _context.t0 = _context['catch'](9);
	
	          console.error('Error during upload visit documents', _context.t0);
	
	          _context.next = 19;
	          return (0, _effects.cancel)();
	
	        case 19:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[9, 14]]);
	}
	
	function handleSuccessUpload() {
	  return _regenerator2.default.wrap(function handleSuccessUpload$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)({
	            type: success.consts.UPDATE,
	            payload: { id: 'appointment.documents.successUpload' }
	          });
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleErrorUpload() {
	  return _regenerator2.default.wrap(function handleErrorUpload$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)({
	            type: error.consts.UPDATE,
	            payload: { id: 'errors.common' }
	          });
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function uploadDocumentSaga() {
	  return _regenerator2.default.wrap(function uploadDocumentSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)(uploadDocument.actions.startUpload, handleUploadDocument);
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.takeLatest)(uploadDocument.actions.rejected, handleErrorUpload);
	
	        case 4:
	          _context4.next = 6;
	          return (0, _effects.takeLatest)(uploadDocument.actions.succeed, handleSuccessUpload);
	
	        case 6:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}

/***/ }),
/* 4113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = validateHealthBoardSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _head = __webpack_require__(378);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _selectors = __webpack_require__(23);
	
	var _redirectUtils = __webpack_require__(77);
	
	var _practiceProvidersReq = __webpack_require__(1362);
	
	var practiceProvidersReq = _interopRequireWildcard(_practiceProvidersReq);
	
	var _caregiver = __webpack_require__(297);
	
	var caregiverCircle = _interopRequireWildcard(_caregiver);
	
	var _appStateReq = __webpack_require__(526);
	
	var appState = _interopRequireWildcard(_appStateReq);
	
	var _root = __webpack_require__(1311);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(validateHealthBoardSaga);
	
	function validateHealthBoardSaga() {
	  var providerId, isProvider, isTeam, _ref, practiceProviders, targetId, hasInList, id;
	
	  return _regenerator2.default.wrap(function validateHealthBoardSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.providerProfileIdSelector);
	
	        case 2:
	          providerId = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.hasProviderProfileSelector);
	
	        case 5:
	          isProvider = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectIsLoggedTeam);
	
	        case 8:
	          isTeam = _context.sent;
	
	          if (isProvider) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 12;
	          return (0, _effects.put)(caregiverCircle.actions.send());
	
	        case 12:
	          if (!isProvider) {
	            _context.next = 17;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)(practiceProvidersReq.actions.send({ id: providerId }));
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.put)(appState.actions.send());
	
	        case 17:
	          if (!isTeam) {
	            _context.next = 38;
	            break;
	          }
	
	          _context.next = 20;
	          return (0, _effects.take)(practiceProvidersReq.consts.SUCCEED);
	
	        case 20:
	          _ref = _context.sent;
	          practiceProviders = _ref.payload;
	          _context.next = 24;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 24:
	          targetId = _context.sent;
	
	          if (!(practiceProviders.length > 0)) {
	            _context.next = 34;
	            break;
	          }
	
	          hasInList = practiceProviders.some(function (_ref2) {
	            var id = _ref2.id;
	            return id === targetId;
	          });
	          id = hasInList ? targetId : (0, _get2.default)((0, _head2.default)(practiceProviders), 'id');
	          _context.next = 30;
	          return (0, _effects.call)(_redirectUtils.redirectToHealthBoard, id);
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.put)(_root.healthBoardActions.toggleValidation(false));
	
	        case 32:
	          _context.next = 36;
	          break;
	
	        case 34:
	          _context.next = 36;
	          return (0, _effects.call)(_redirectUtils.redirectToHealthBoardEmpty);
	
	        case 36:
	          _context.next = 38;
	          return (0, _effects.cancel)();
	
	        case 38:
	          _context.next = 40;
	          return (0, _effects.put)(_root.healthBoardActions.toggleValidation(false));
	
	        case 40:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _caregiver = __webpack_require__(861);
	
	var _caregiver2 = _interopRequireDefault(_caregiver);
	
	var _familyMember = __webpack_require__(862);
	
	var _familyMember2 = _interopRequireDefault(_familyMember);
	
	var _guardian = __webpack_require__(863);
	
	var _guardian2 = _interopRequireDefault(_guardian);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// current user invitations to circles
	exports.default = (0, _redux.combineReducers)({
	  caregiver: _caregiver2.default,
	  familyMember: _familyMember2.default,
	  guardian: _guardian2.default
	});

/***/ }),
/* 4115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _common = __webpack_require__(4116);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _updatePatientInsurance = __webpack_require__(350);
	
	var _updatePatientInsurance2 = _interopRequireDefault(_updatePatientInsurance);
	
	var _deletePatientInsurance = __webpack_require__(1314);
	
	var _deletePatientInsurance2 = _interopRequireDefault(_deletePatientInsurance);
	
	var _createPatientInsurance = __webpack_require__(536);
	
	var _createPatientInsurance2 = _interopRequireDefault(_createPatientInsurance);
	
	var _getPatientInsurancesList = __webpack_require__(537);
	
	var _getPatientInsurancesList2 = _interopRequireDefault(_getPatientInsurancesList);
	
	var _checkUploadedInsuranceCardOcr = __webpack_require__(1313);
	
	var _checkUploadedInsuranceCardOcr2 = _interopRequireDefault(_checkUploadedInsuranceCardOcr);
	
	var _exportPatientInsuranceEhrDocuments = __webpack_require__(1315);
	
	var _exportPatientInsuranceEhrDocuments2 = _interopRequireDefault(_exportPatientInsuranceEhrDocuments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  common: _common2.default,
	
	  checkUploadedInsuranceCardOCR: _checkUploadedInsuranceCardOcr2.default,
	  exportPatientInsuranceEhrDocuments: _exportPatientInsuranceEhrDocuments2.default,
	  createPatientInsurance: _createPatientInsurance2.default,
	  deletePatientInsurance: _deletePatientInsurance2.default,
	  getPatientInsurancesList: _getPatientInsurancesList2.default,
	  updatePatientInsurance: _updatePatientInsurance2.default
	});

/***/ }),
/* 4116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  pending: false,
	  isInsuranceToDoTaskCompleting: false,
	  uploadInsuranceCardModal: {
	    isOpened: false,
	    cardType: null
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.SET_INSURANCE_RELATED_DATA_FETCHING:
	      {
	        return (0, _extends3.default)({}, state, {
	          pending: payload
	        });
	      }
	
	    case _manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.SET_UPLOAD_INSURANCE_CARD_MODAL_DATA:
	      {
	        return (0, _extends3.default)({}, state, {
	          uploadInsuranceCardModal: payload
	        });
	      }
	
	    case _manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.SET_INSURANCE_TO_DO_TASK_COMPLETING:
	      {
	        return (0, _extends3.default)({}, state, {
	          isInsuranceToDoTaskCompleting: payload
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 4117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.clearManageInsuranceRelatedData = clearManageInsuranceRelatedData;
	
	var _effects = __webpack_require__(14);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _editUser = __webpack_require__(136);
	
	var _getUserDocuments = __webpack_require__(425);
	
	var _getPatientInsurancesList = __webpack_require__(537);
	
	var _checkInsuranceEligibility = __webpack_require__(292);
	
	var _latestCheckInsuranceReq = __webpack_require__(626);
	
	var _insuranceEligibilityManualActivations = __webpack_require__(427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(clearManageInsuranceRelatedDataWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(clearManageInsuranceRelatedData);
	
	function clearManageInsuranceRelatedDataWorker() {
	  return _regenerator2.default.wrap(function clearManageInsuranceRelatedDataWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_editUser.actions.clear());
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)(_insuranceEligibilityManualActivations.actions.clear());
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.put)(_getUserDocuments.actions.clear());
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.put)(_checkInsuranceEligibility.actions.clear());
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.put)(_latestCheckInsuranceReq.actions.clear());
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.put)(_getPatientInsurancesList.actions.clear());
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function clearManageInsuranceRelatedData() {
	  return _regenerator2.default.wrap(function clearManageInsuranceRelatedData$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.CLEAR_MANAGE_INSURANCE_RELATED_DATA, clearManageInsuranceRelatedDataWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.downloadPatientInsuranceData = downloadPatientInsuranceData;
	
	var _effects = __webpack_require__(14);
	
	var _getPatientInsurancesList = __webpack_require__(537);
	
	var _getUserDocuments = __webpack_require__(425);
	
	var _latestCheckInsuranceReq = __webpack_require__(626);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(downloadPatientInsuranceDataWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(downloadPatientInsuranceData);
	
	var TIMEOUT = 30000;
	
	function downloadPatientInsuranceDataWorker(_ref) {
	  var payload = _ref.payload;
	
	  var userId, _ref2, _ref3, latestInsuranceCheckData, patientDocuments;
	
	  return _regenerator2.default.wrap(function downloadPatientInsuranceDataWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setInsuranceRelatedDataFetching(true));
	
	        case 2:
	          userId = payload.userId;
	          _context.next = 5;
	          return (0, _effects.all)([(0, _effects.put)(_latestCheckInsuranceReq.actions.send({ userId: userId })), (0, _effects.put)(_getUserDocuments.actions.send({ userId: userId }))]);
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.all)([(0, _effects.race)({
	            success: (0, _effects.take)(_latestCheckInsuranceReq.consts.SUCCEED),
	            failure: (0, _effects.take)([_latestCheckInsuranceReq.consts.REJECTED, _latestCheckInsuranceReq.consts.ERROR_ENCOUNTERED]),
	            timeout: (0, _effects.delay)(TIMEOUT)
	          }), (0, _effects.race)({
	            success: (0, _effects.take)(_getUserDocuments.consts.SUCCEED)
	          })]);
	
	        case 7:
	          _ref2 = _context.sent;
	          _ref3 = (0, _slicedToArray3.default)(_ref2, 2);
	          latestInsuranceCheckData = _ref3[0];
	          patientDocuments = _ref3[1];
	          _context.next = 13;
	          return (0, _effects.put)(_getPatientInsurancesList.actions.send({ userId: userId }));
	
	        case 13:
	          _context.next = 15;
	          return (0, _effects.take)(_getPatientInsurancesList.consts.SUCCEED);
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setInsuranceRelatedDataFetching(false));
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function downloadPatientInsuranceData() {
	  return _regenerator2.default.wrap(function downloadPatientInsuranceData$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.DOWNLOAD_PATIENT_INSURANCES_DATA, downloadPatientInsuranceDataWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.downloadToDoTaskInsurancesData = downloadToDoTaskInsurancesData;
	
	var _effects = __webpack_require__(14);
	
	var _getPatientInsurancesList = __webpack_require__(537);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(downloadToDoTaskInsurancesDataWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(downloadToDoTaskInsurancesData);
	
	function downloadToDoTaskInsurancesDataWorker(_ref) {
	  var payload = _ref.payload;
	  var userId, todoTaskAssignmentId;
	  return _regenerator2.default.wrap(function downloadToDoTaskInsurancesDataWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setInsuranceRelatedDataFetching(true));
	
	        case 2:
	          userId = payload.userId, todoTaskAssignmentId = payload.todoTaskAssignmentId;
	          _context.next = 5;
	          return (0, _effects.put)(_getPatientInsurancesList.actions.send({ userId: userId, todoTaskAssignmentId: todoTaskAssignmentId }));
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.take)(_getPatientInsurancesList.consts.SUCCEED);
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setInsuranceRelatedDataFetching(false));
	
	        case 9:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function downloadToDoTaskInsurancesData() {
	  return _regenerator2.default.wrap(function downloadToDoTaskInsurancesData$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.DOWNLOAD_TO_DO_TASK_INSURANCES_DATA, downloadToDoTaskInsurancesDataWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = manageInsurancesRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _saveInsurancesData = __webpack_require__(4122);
	
	var _uploadInsuranceCard = __webpack_require__(4124);
	
	var _saveToDoInsurancesData = __webpack_require__(4123);
	
	var _uploadMainInsuranceCard = __webpack_require__(4125);
	
	var _downloadPatientInsurancesData = __webpack_require__(4118);
	
	var _runManualEligibilityActivation = __webpack_require__(4121);
	
	var _downloadToDoTaskInsurancesData = __webpack_require__(4119);
	
	var _clearManageInsuranceRelatedData = __webpack_require__(4117);
	
	var _updatePatientInsurance = __webpack_require__(350);
	
	var _deletePatientInsurance = __webpack_require__(1314);
	
	var _createPatientInsurance = __webpack_require__(536);
	
	var _getPatientInsurancesList = __webpack_require__(537);
	
	var _checkUploadedInsuranceCardOcr = __webpack_require__(1313);
	
	var _exportPatientInsuranceEhrDocuments = __webpack_require__(1315);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(manageInsurancesRootSaga);
	
	function manageInsurancesRootSaga() {
	  return _regenerator2.default.wrap(function manageInsurancesRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_saveInsurancesData.saveInsurancesData);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(_uploadInsuranceCard.uploadInsuranceCard);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(_saveToDoInsurancesData.saveToDoInsurancesData);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(_uploadMainInsuranceCard.uploadMainInsuranceCard);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(_downloadPatientInsurancesData.downloadPatientInsuranceData);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(_runManualEligibilityActivation.runManualEligibilityActivation);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_clearManageInsuranceRelatedData.clearManageInsuranceRelatedData);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(_downloadToDoTaskInsurancesData.downloadToDoTaskInsurancesData);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(_updatePatientInsurance.watcher);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(_deletePatientInsurance.watcher);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.fork)(_createPatientInsurance.watcher);
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.fork)(_getPatientInsurancesList.watcher);
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.fork)(_checkUploadedInsuranceCardOcr.watcher);
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.fork)(_exportPatientInsuranceEhrDocuments.watcher);
	
	        case 28:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.runManualEligibilityActivation = runManualEligibilityActivation;
	
	var _effects = __webpack_require__(14);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _editUserAfterInsuranceUpdate = __webpack_require__(1891);
	
	var _handleInsuranceErrorModal = __webpack_require__(502);
	
	var _insuranceEligibilityManualActivations = __webpack_require__(427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(runManualEligibilityActivationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(runManualEligibilityActivation);
	
	function runManualEligibilityActivationWorker(_ref) {
	  var payload = _ref.payload;
	  var userId, insuranceEligibilityResultId, skipInsurance, finishAction, flowType;
	  return _regenerator2.default.wrap(function runManualEligibilityActivationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          userId = payload.userId, insuranceEligibilityResultId = payload.insuranceEligibilityResultId, skipInsurance = payload.skipInsurance, finishAction = payload.finishAction, flowType = payload.flowType;
	          _context.next = 3;
	          return (0, _effects.put)(_insuranceEligibilityManualActivations.actions.send({
	            userId: userId,
	            insuranceEligibilityResultId: insuranceEligibilityResultId
	          }));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.put)(_handleInsuranceErrorModal.insuranceErrorModalActions.close());
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.call)(_editUserAfterInsuranceUpdate.editUserAfterInsuranceUpdate, {
	            userId: userId,
	            skipInsurance: skipInsurance,
	            finishAction: finishAction,
	            flowType: flowType
	          });
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function runManualEligibilityActivation() {
	  return _regenerator2.default.wrap(function runManualEligibilityActivation$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.RUN_MANUAL_ELIGIBILITY_ACTIVATION, runManualEligibilityActivationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.saveInsurancesData = saveInsurancesData;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _formFields = __webpack_require__(38);
	
	var _insuranceFlowType = __webpack_require__(133);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _exportPatientInsuranceEhrDocuments = __webpack_require__(1315);
	
	var _editUserAfterInsuranceUpdate = __webpack_require__(1891);
	
	var _checkInsuranceEligibility = __webpack_require__(292);
	
	var _createPatientInsurance = __webpack_require__(536);
	
	var _updatePatientInsurance = __webpack_require__(350);
	
	var _getPatientInsurancesList = __webpack_require__(671);
	
	var _getRequestPayloadFromFormState = __webpack_require__(1930);
	
	var _convertInsuranceFormDataToFormData = __webpack_require__(1929);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleAdditionalInsuranceAction),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(saveInsurancesDataWorker),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(saveInsurancesData);
	
	var DO_NOT_HAVE_INSURANCE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DO_NOT_HAVE_INSURANCE;
	
	
	function handleAdditionalInsuranceAction(insuranceFormState, userId) {
	  var insuranceFormData, insuranceId, data;
	  return _regenerator2.default.wrap(function handleAdditionalInsuranceAction$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(_getRequestPayloadFromFormState.getRequestPayloadFromFormState, insuranceFormState);
	
	        case 2:
	          insuranceFormData = _context.sent;
	          insuranceId = (0, _get2.default)(insuranceFormState, 'id');
	          _context.next = 6;
	          return (0, _effects.call)(_convertInsuranceFormDataToFormData.convertInsuranceFormDataToFormData, {
	            insuranceFormData: insuranceFormData,
	            userId: userId,
	            insuranceId: insuranceId
	          });
	
	        case 6:
	          data = _context.sent;
	
	          if (!insuranceId) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.put)(_updatePatientInsurance.actions.send(data));
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.take)(_updatePatientInsurance.consts.SUCCEED);
	
	        case 12:
	          _context.next = 14;
	          return;
	
	        case 14:
	          _context.next = 20;
	          break;
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.put)(_createPatientInsurance.actions.send(data));
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.take)(_createPatientInsurance.consts.SUCCEED);
	
	        case 20:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function saveInsurancesDataWorker(_ref) {
	  var payload = _ref.payload;
	
	  var userId, mainInsuranceFormState, _payload$additionalIn, additionalInsurancesFormState, finishAction, flowType, mainInsuranceFormData, healthPlan, isPlanNotListedSelected, isAdditionalInsurancesEnabled, skipInsurance, checkSucceed, _ref2, succeed;
	
	  return _regenerator2.default.wrap(function saveInsurancesDataWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          userId = payload.userId, mainInsuranceFormState = payload.mainInsuranceFormState, _payload$additionalIn = payload.additionalInsurancesFormState, additionalInsurancesFormState = _payload$additionalIn === undefined ? [] : _payload$additionalIn, finishAction = payload.finishAction, flowType = payload.flowType;
	          _context2.next = 3;
	          return (0, _effects.call)(_getRequestPayloadFromFormState.getRequestPayloadFromFormState, mainInsuranceFormState);
	
	        case 3:
	          mainInsuranceFormData = _context2.sent;
	          healthPlan = (0, _get2.default)(mainInsuranceFormState, 'healthPlan', null);
	          isPlanNotListedSelected = Boolean(healthPlan && !healthPlan.id);
	          _context2.next = 8;
	          return (0, _effects.select)(_getPatientInsurancesList.selectIsAdditionalInsurancesEnabled);
	
	        case 8:
	          isAdditionalInsurancesEnabled = _context2.sent;
	          skipInsurance = Boolean(mainInsuranceFormState[DO_NOT_HAVE_INSURANCE]);
	          checkSucceed = true;
	
	          if (!(!isPlanNotListedSelected && !skipInsurance)) {
	            _context2.next = 19;
	            break;
	          }
	
	          _context2.next = 14;
	          return (0, _effects.put)(_checkInsuranceEligibility.actions.send((0, _extends3.default)({}, mainInsuranceFormData, { userId: userId })));
	
	        case 14:
	          _context2.next = 16;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(_checkInsuranceEligibility.consts.SUCCEED),
	            failed: (0, _effects.take)([_checkInsuranceEligibility.consts.REJECTED, _checkInsuranceEligibility.consts.ERROR_ENCOUNTERED])
	          });
	
	        case 16:
	          _ref2 = _context2.sent;
	          succeed = _ref2.succeed;
	
	
	          checkSucceed = succeed;
	
	        case 19:
	          if (!(additionalInsurancesFormState.length && isAdditionalInsurancesEnabled && !skipInsurance)) {
	            _context2.next = 22;
	            break;
	          }
	
	          _context2.next = 22;
	          return (0, _effects.all)(additionalInsurancesFormState.map(function (insuranceFormState) {
	            var additionalInsurancesHealthPlan = (0, _get2.default)(insuranceFormState, 'healthPlan', null);
	            var additionalInsurancesIsPlanNotListedSelected = Boolean(additionalInsurancesHealthPlan && !additionalInsurancesHealthPlan.id);
	
	            if (additionalInsurancesIsPlanNotListedSelected) {
	              return;
	            }
	
	            return (0, _effects.spawn)(handleAdditionalInsuranceAction, insuranceFormState, userId);
	          }));
	
	        case 22:
	          if (!(checkSucceed && !isPlanNotListedSelected)) {
	            _context2.next = 27;
	            break;
	          }
	
	          _context2.next = 25;
	          return (0, _effects.call)(_editUserAfterInsuranceUpdate.editUserAfterInsuranceUpdate, {
	            userId: userId,
	            skipInsurance: skipInsurance,
	            finishAction: finishAction,
	            flowType: flowType
	          });
	
	        case 25:
	          _context2.next = 30;
	          break;
	
	        case 27:
	          if (!finishAction) {
	            _context2.next = 30;
	            break;
	          }
	
	          _context2.next = 30;
	          return (0, _effects.call)(finishAction);
	
	        case 30:
	          if (!(flowType === _insuranceFlowType.INSURANCE_FLOW_TYPE.PROFILE && !skipInsurance)) {
	            _context2.next = 33;
	            break;
	          }
	
	          _context2.next = 33;
	          return (0, _effects.put)(_exportPatientInsuranceEhrDocuments.actions.send({ userId: userId }));
	
	        case 33:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function saveInsurancesData() {
	  return _regenerator2.default.wrap(function saveInsurancesData$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.SAVE_PATIENT_INSURANCES, saveInsurancesDataWorker);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(1395);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.saveToDoInsurancesDataWorker = saveToDoInsurancesDataWorker;
	exports.saveToDoInsurancesData = saveToDoInsurancesData;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _constants = __webpack_require__(17);
	
	var _formFields = __webpack_require__(38);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _completeTaskReq = __webpack_require__(665);
	
	var _handleInsuranceErrorModal = __webpack_require__(502);
	
	var _createPatientInsurance = __webpack_require__(536);
	
	var _updatePatientInsurance = __webpack_require__(350);
	
	var _getRequestPayloadFromFormState = __webpack_require__(1930);
	
	var _convertInsuranceFormDataToFormData = __webpack_require__(1929);
	
	var _getPatientInsurancesList = __webpack_require__(671);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(sendAndAwait),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(buildMainInsurancePayload),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(buildAdditionalInsurancePayload),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(upsertInsurance),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(handleAdditionalInsuranceAction),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(saveToDoInsurancesDataWorker),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(saveToDoInsurancesData);
	
	var DO_NOT_HAVE_INSURANCE = _formFields.INSURANCE_ELIGIBILITY_FIELDS_TYPES.DO_NOT_HAVE_INSURANCE;
	
	
	var UPDATE_PATIENT_INSURANCE = {
	  SUCCEED: [_updatePatientInsurance.consts.SUCCEED],
	  FAIL: [_updatePatientInsurance.consts.REJECTED, _updatePatientInsurance.consts.ERROR_ENCOUNTERED]
	};
	
	var CREATE_PATIENT_INSURANCE = {
	  SUCCEED: [_createPatientInsurance.consts.SUCCEED],
	  FAIL: [_createPatientInsurance.consts.REJECTED, _createPatientInsurance.consts.ERROR_ENCOUNTERED]
	};
	
	function sendAndAwait(_ref) {
	  var sendAction = _ref.sendAction,
	      succeedTypes = _ref.succeedTypes,
	      failTypes = _ref.failTypes;
	
	  var _ref2, succeed, failed;
	
	  return _regenerator2.default.wrap(function sendAndAwait$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(sendAction);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(succeedTypes),
	            failed: (0, _effects.take)(failTypes)
	          });
	
	        case 4:
	          _ref2 = _context.sent;
	          succeed = _ref2.succeed;
	          failed = _ref2.failed;
	          return _context.abrupt('return', { succeed: succeed, failed: failed });
	
	        case 8:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function buildMainInsurancePayload(_ref3) {
	  var mainInsuranceFormState = _ref3.mainInsuranceFormState,
	      userId = _ref3.userId,
	      taskAssignmentId = _ref3.taskAssignmentId,
	      saveAnyway = _ref3.saveAnyway;
	  var mainInsuranceFormData, skipInsurance, insuranceId;
	  return _regenerator2.default.wrap(function buildMainInsurancePayload$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.call)(_getRequestPayloadFromFormState.getRequestPayloadFromFormState, mainInsuranceFormState);
	
	        case 2:
	          mainInsuranceFormData = _context2.sent;
	          skipInsurance = Boolean(mainInsuranceFormState[DO_NOT_HAVE_INSURANCE]);
	          insuranceId = (0, _get2.default)(mainInsuranceFormState, 'id');
	          return _context2.abrupt('return', {
	            data: (0, _extends3.default)({}, mainInsuranceFormData, {
	              userId: userId,
	              skipInsurance: skipInsurance,
	              context: _constants.TODO_TYPES.TASK,
	              todoTaskAssignmentId: taskAssignmentId,
	              skipEligibilityCheck: Boolean(saveAnyway),
	              patientInsuranceId: insuranceId,
	              status: 'completed'
	            }),
	            insuranceId: insuranceId,
	            skipInsurance: skipInsurance
	          });
	
	        case 6:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function buildAdditionalInsurancePayload(_ref4) {
	  var insuranceFormState = _ref4.insuranceFormState,
	      userId = _ref4.userId,
	      taskAssignmentId = _ref4.taskAssignmentId;
	  var insuranceFormData, insuranceId, formData;
	  return _regenerator2.default.wrap(function buildAdditionalInsurancePayload$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.call)(_getRequestPayloadFromFormState.getRequestPayloadFromFormState, insuranceFormState);
	
	        case 2:
	          insuranceFormData = _context3.sent;
	          insuranceId = (0, _get2.default)(insuranceFormState, 'id');
	          _context3.next = 6;
	          return (0, _effects.call)(_convertInsuranceFormDataToFormData.convertInsuranceFormDataToFormData, {
	            insuranceFormData: insuranceFormData,
	            userId: userId,
	            insuranceId: insuranceId
	          });
	
	        case 6:
	          formData = _context3.sent;
	
	
	          formData['context'] = _constants.TODO_TYPES.TASK;
	          formData['todo_task_assignment_id'] = taskAssignmentId;
	
	          return _context3.abrupt('return', { payload: formData, insuranceId: insuranceId });
	
	        case 10:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function upsertInsurance(_ref5) {
	  var hasId = _ref5.hasId,
	      payload = _ref5.payload;
	  return _regenerator2.default.wrap(function upsertInsurance$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          if (!hasId) {
	            _context4.next = 4;
	            break;
	          }
	
	          _context4.next = 3;
	          return (0, _effects.call)(sendAndAwait, {
	            sendAction: _updatePatientInsurance.actions.send(payload),
	            succeedTypes: UPDATE_PATIENT_INSURANCE.SUCCEED,
	            failTypes: UPDATE_PATIENT_INSURANCE.FAIL
	          });
	
	        case 3:
	          return _context4.abrupt('return', _context4.sent);
	
	        case 4:
	          _context4.next = 6;
	          return (0, _effects.call)(sendAndAwait, {
	            sendAction: _createPatientInsurance.actions.send(payload),
	            succeedTypes: CREATE_PATIENT_INSURANCE.SUCCEED,
	            failTypes: CREATE_PATIENT_INSURANCE.FAIL
	          });
	
	        case 6:
	          return _context4.abrupt('return', _context4.sent);
	
	        case 7:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function handleAdditionalInsuranceAction(_ref6) {
	  var insuranceFormState = _ref6.insuranceFormState,
	      userId = _ref6.userId,
	      todoTaskAssignmentId = _ref6.todoTaskAssignmentId;
	
	  var _ref7, payload, addId;
	
	  return _regenerator2.default.wrap(function handleAdditionalInsuranceAction$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.call)(buildAdditionalInsurancePayload, {
	            insuranceFormState: insuranceFormState,
	            userId: userId,
	            taskAssignmentId: todoTaskAssignmentId
	          });
	
	        case 2:
	          _ref7 = _context5.sent;
	          payload = _ref7.payload;
	          addId = _ref7.insuranceId;
	          _context5.next = 7;
	          return (0, _effects.call)(upsertInsurance, { hasId: Boolean(addId), payload: payload });
	
	        case 7:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function saveToDoInsurancesDataWorker(_ref8) {
	  var payload = _ref8.payload;
	
	  var isAdditionalInsurancesEnabled, userId, mainInsuranceFormState, _payload$additionalIn, additionalInsurancesFormState, finishAction, taskAssignmentId, _payload$saveAnyway, saveAnyway, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, insuranceFormState, _ref9, data, insuranceId, _ref10, failed;
	
	  return _regenerator2.default.wrap(function saveToDoInsurancesDataWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setInsuranceToDoTaskCompleting(true));
	
	        case 2:
	          _context6.next = 4;
	          return (0, _effects.select)(_getPatientInsurancesList.selectIsAdditionalInsurancesEnabled);
	
	        case 4:
	          isAdditionalInsurancesEnabled = _context6.sent;
	          _context6.prev = 5;
	          userId = payload.userId, mainInsuranceFormState = payload.mainInsuranceFormState, _payload$additionalIn = payload.additionalInsurancesFormState, additionalInsurancesFormState = _payload$additionalIn === undefined ? [] : _payload$additionalIn, finishAction = payload.finishAction, taskAssignmentId = payload.taskAssignmentId, _payload$saveAnyway = payload.saveAnyway, saveAnyway = _payload$saveAnyway === undefined ? false : _payload$saveAnyway;
	
	          if (!saveAnyway) {
	            _context6.next = 10;
	            break;
	          }
	
	          _context6.next = 10;
	          return (0, _effects.put)(_handleInsuranceErrorModal.insuranceErrorModalActions.close());
	
	        case 10:
	          if (!(additionalInsurancesFormState.length && isAdditionalInsurancesEnabled)) {
	            _context6.next = 37;
	            break;
	          }
	
	          _iteratorNormalCompletion = true;
	          _didIteratorError = false;
	          _iteratorError = undefined;
	          _context6.prev = 14;
	          _iterator = (0, _getIterator3.default)(additionalInsurancesFormState);
	
	        case 16:
	          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	            _context6.next = 23;
	            break;
	          }
	
	          insuranceFormState = _step.value;
	          _context6.next = 20;
	          return (0, _effects.call)(handleAdditionalInsuranceAction, {
	            insuranceFormState: insuranceFormState,
	            userId: userId,
	            todoTaskAssignmentId: taskAssignmentId
	          });
	
	        case 20:
	          _iteratorNormalCompletion = true;
	          _context6.next = 16;
	          break;
	
	        case 23:
	          _context6.next = 29;
	          break;
	
	        case 25:
	          _context6.prev = 25;
	          _context6.t0 = _context6['catch'](14);
	          _didIteratorError = true;
	          _iteratorError = _context6.t0;
	
	        case 29:
	          _context6.prev = 29;
	          _context6.prev = 30;
	
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	
	        case 32:
	          _context6.prev = 32;
	
	          if (!_didIteratorError) {
	            _context6.next = 35;
	            break;
	          }
	
	          throw _iteratorError;
	
	        case 35:
	          return _context6.finish(32);
	
	        case 36:
	          return _context6.finish(29);
	
	        case 37:
	          _context6.next = 39;
	          return (0, _effects.call)(buildMainInsurancePayload, {
	            mainInsuranceFormState: mainInsuranceFormState,
	            userId: userId,
	            taskAssignmentId: taskAssignmentId,
	            saveAnyway: saveAnyway
	          });
	
	        case 39:
	          _ref9 = _context6.sent;
	          data = _ref9.data;
	          insuranceId = _ref9.insuranceId;
	          _context6.next = 44;
	          return (0, _effects.call)(upsertInsurance, {
	            hasId: Boolean(insuranceId),
	            payload: data
	          });
	
	        case 44:
	          _ref10 = _context6.sent;
	          failed = _ref10.failed;
	
	          if (!failed) {
	            _context6.next = 50;
	            break;
	          }
	
	          _context6.next = 49;
	          return (0, _effects.cancel)();
	
	        case 49:
	          return _context6.abrupt('return');
	
	        case 50:
	          _context6.next = 52;
	          return (0, _effects.put)(_completeTaskReq.actions.start({
	            status: 'completed',
	            id: taskAssignmentId,
	            userId: userId
	          }));
	
	        case 52:
	          _context6.next = 54;
	          return (0, _effects.take)(_completeTaskReq.consts.SUCCEED);
	
	        case 54:
	          if (!finishAction) {
	            _context6.next = 57;
	            break;
	          }
	
	          _context6.next = 57;
	          return (0, _effects.call)(finishAction);
	
	        case 57:
	          _context6.prev = 57;
	          _context6.next = 60;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setInsuranceToDoTaskCompleting(false));
	
	        case 60:
	          return _context6.finish(57);
	
	        case 61:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this, [[5,, 57, 61], [14, 25, 29, 37], [30,, 32, 36]]);
	}
	
	function saveToDoInsurancesData() {
	  return _regenerator2.default.wrap(function saveToDoInsurancesData$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.takeLatest)(_manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.SAVE_TO_DO_INSURANCES_DATA, saveToDoInsurancesDataWorker);
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}

/***/ }),
/* 4124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.uploadInsuranceCard = uploadInsuranceCard;
	
	var _effects = __webpack_require__(14);
	
	var _camelCase = __webpack_require__(322);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _constants = __webpack_require__(17);
	
	var _insuranceCardKeysMapper = __webpack_require__(1853);
	
	var _initialInsuranceCardState = __webpack_require__(1208);
	
	var _checkInsuranceCardOcr = __webpack_require__(1890);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _updatePatientInsurance = __webpack_require__(350);
	
	var _createPatientInsurance = __webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(uploadInsuranceCardWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(uploadInsuranceCard);
	
	var isFrontSideKey = function isFrontSideKey(key) {
	  return key.endsWith('_1');
	};
	
	function uploadInsuranceCardWorker(_ref) {
	  var payload = _ref.payload;
	
	  var fieldName, imgValue, imgId, patientInsuranceId, userId, handleAdditionalInsuranceFormChange, taskAssignmentId, additionalDataToUpdate, createdInsuranceId, _imgValue, _imgValue$deleted, deleted, _imgValue$file, file, data, isCardFrontSide, key, camelCasedKey, result, resultPayload, dataToUpdate, _handleAdditionalInsu, _result, _resultPayload, additionalSideKey, camelCasedAdditionalSideKey;
	
	  return _regenerator2.default.wrap(function uploadInsuranceCardWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          fieldName = payload.fieldName, imgValue = payload.imgValue, imgId = payload.imgId, patientInsuranceId = payload.patientInsuranceId, userId = payload.userId, handleAdditionalInsuranceFormChange = payload.handleAdditionalInsuranceFormChange, taskAssignmentId = payload.taskAssignmentId;
	          additionalDataToUpdate = {};
	          createdInsuranceId = void 0;
	          _imgValue = (0, _extends3.default)({}, imgValue), _imgValue$deleted = _imgValue.deleted, deleted = _imgValue$deleted === undefined ? false : _imgValue$deleted, _imgValue$file = _imgValue.file, file = _imgValue$file === undefined ? '' : _imgValue$file;
	          data = new FormData();
	          isCardFrontSide = isFrontSideKey(fieldName);
	          key = isCardFrontSide ? _constants.INSURANCE_CARD_SIDE.FRONT : _constants.INSURANCE_CARD_SIDE.BACK;
	
	
	          data.append('userId', userId);
	
	          data.append(key, file);
	
	          data.append('skip_insurance', false);
	
	          if (taskAssignmentId) {
	            data.append('todo_task_assignment_id', taskAssignmentId);
	            data.append('context', _constants.TODO_TYPES.TASK);
	          }
	
	          camelCasedKey = (0, _camelCase2.default)(key);
	
	          if (!(file && !imgId)) {
	            _context.next = 41;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setUploadInsuranceCardModalData({
	            isOpened: true,
	            cardType: _insuranceCardKeysMapper.INSURANCES_CARD_KEYS_MAPPER.get(key)
	          }));
	
	        case 15:
	          if (!patientInsuranceId) {
	            _context.next = 28;
	            break;
	          }
	
	          data.append('patientInsuranceId', patientInsuranceId);
	          _context.next = 19;
	          return (0, _effects.put)(_updatePatientInsurance.actions.send(data));
	
	        case 19:
	          _context.next = 21;
	          return (0, _effects.take)(_updatePatientInsurance.consts.SUCCEED);
	
	        case 21:
	          result = _context.sent;
	          resultPayload = result.payload;
	          dataToUpdate = (0, _defineProperty3.default)({}, camelCasedKey, resultPayload[camelCasedKey]);
	
	
	          additionalDataToUpdate = dataToUpdate;
	
	          handleAdditionalInsuranceFormChange(dataToUpdate);
	          _context.next = 38;
	          break;
	
	        case 28:
	          _context.next = 30;
	          return (0, _effects.put)(_createPatientInsurance.actions.send(data));
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.take)(_createPatientInsurance.consts.SUCCEED);
	
	        case 32:
	          _result = _context.sent;
	          _resultPayload = _result.payload;
	          additionalSideKey = key === _constants.INSURANCE_CARD_SIDE.FRONT ? _constants.INSURANCE_CARD_SIDE.BACK : _constants.INSURANCE_CARD_SIDE.FRONT;
	          camelCasedAdditionalSideKey = (0, _camelCase2.default)(additionalSideKey);
	
	
	          createdInsuranceId = _resultPayload.id;
	
	          handleAdditionalInsuranceFormChange((_handleAdditionalInsu = {}, (0, _defineProperty3.default)(_handleAdditionalInsu, camelCasedKey, _resultPayload[camelCasedKey]), (0, _defineProperty3.default)(_handleAdditionalInsu, camelCasedAdditionalSideKey, _resultPayload[camelCasedAdditionalSideKey]), (0, _defineProperty3.default)(_handleAdditionalInsu, 'id', createdInsuranceId), _handleAdditionalInsu));
	
	        case 38:
	          if (!isCardFrontSide) {
	            _context.next = 41;
	            break;
	          }
	
	          _context.next = 41;
	          return (0, _effects.call)(_checkInsuranceCardOcr.checkInsuranceCardOcr, {
	            recordId: patientInsuranceId || createdInsuranceId,
	            userId: userId,
	            handleFormChange: handleAdditionalInsuranceFormChange,
	            recordType: _constants.RECORD_TYPE.PATIENT_INSURANCE,
	            additionalDataToUpdate: additionalDataToUpdate
	          });
	
	        case 41:
	          if (!deleted) {
	            _context.next = 48;
	            break;
	          }
	
	          data.append('patientInsuranceId', patientInsuranceId);
	
	          _context.next = 45;
	          return (0, _effects.put)(_updatePatientInsurance.actions.send(data));
	
	        case 45:
	          _context.next = 47;
	          return (0, _effects.take)(_updatePatientInsurance.consts.SUCCEED);
	
	        case 47:
	
	          handleAdditionalInsuranceFormChange((0, _defineProperty3.default)({}, camelCasedKey, _initialInsuranceCardState.INITIAL_INSURANCE_CARD_STATE));
	
	        case 48:
	          _context.next = 50;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setUploadInsuranceCardModalData({
	            isOpened: false,
	            cardType: null
	          }));
	
	        case 50:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function uploadInsuranceCard() {
	  return _regenerator2.default.wrap(function uploadInsuranceCard$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.UPLOAD_INSURANCE_CARD, uploadInsuranceCardWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.uploadMainInsuranceCard = uploadMainInsuranceCard;
	
	var _effects = __webpack_require__(14);
	
	var _camelCase = __webpack_require__(322);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _constants = __webpack_require__(17);
	
	var _insuranceCardKeysMapper = __webpack_require__(1853);
	
	var _initialInsuranceCardState = __webpack_require__(1208);
	
	var _checkInsuranceCardOcr = __webpack_require__(1890);
	
	var _deleteUserDocuments = __webpack_require__(422);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _uploadUserDocuments = __webpack_require__(429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(uploadMainInsuranceCardWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(uploadMainInsuranceCard);
	
	function uploadMainInsuranceCardWorker(_ref) {
	  var payload = _ref.payload;
	
	  var fieldName, imgValue, imgId, userId, handleFormChange, _imgValue, _imgValue$deleted, deleted, _imgValue$file, file, isCardFrontSide, formStateCardKey, camelCasedKey, data, result, resultPayload;
	
	  return _regenerator2.default.wrap(function uploadMainInsuranceCardWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          fieldName = payload.fieldName, imgValue = payload.imgValue, imgId = payload.imgId, userId = payload.userId, handleFormChange = payload.handleFormChange;
	          _imgValue = (0, _extends3.default)({}, imgValue), _imgValue$deleted = _imgValue.deleted, deleted = _imgValue$deleted === undefined ? false : _imgValue$deleted, _imgValue$file = _imgValue.file, file = _imgValue$file === undefined ? '' : _imgValue$file;
	          isCardFrontSide = fieldName === _constants.DOCUMENTATION_TYPES.CARD_1;
	          formStateCardKey = isCardFrontSide ? _constants.INSURANCE_CARD_SIDE.FRONT : _constants.INSURANCE_CARD_SIDE.BACK;
	          camelCasedKey = (0, _camelCase2.default)(formStateCardKey);
	          data = new FormData();
	
	          data.append('attachment', file);
	          data.append('userId', userId);
	
	          if (!(deleted && imgId)) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 11;
	          return (0, _effects.put)(_deleteUserDocuments.actions.send({ userId: userId, id: imgId }));
	
	        case 11:
	
	          handleFormChange((0, _defineProperty3.default)({}, camelCasedKey, _initialInsuranceCardState.INITIAL_INSURANCE_CARD_STATE));
	
	        case 12:
	          if (!(file && !imgId)) {
	            _context.next = 25;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setUploadInsuranceCardModalData({
	            isOpened: true,
	            cardType: _insuranceCardKeysMapper.INSURANCES_CARD_KEYS_MAPPER.get(formStateCardKey)
	          }));
	
	        case 15:
	
	          data.append('key', fieldName);
	
	          _context.next = 18;
	          return (0, _effects.put)(_uploadUserDocuments.actions.send(data));
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.take)(_uploadUserDocuments.consts.SUCCEED);
	
	        case 20:
	          result = _context.sent;
	          resultPayload = result.payload;
	
	          if (!isCardFrontSide) {
	            _context.next = 25;
	            break;
	          }
	
	          _context.next = 25;
	          return (0, _effects.call)(_checkInsuranceCardOcr.checkInsuranceCardOcr, {
	            recordId: resultPayload.id,
	            userId: userId,
	            handleFormChange: handleFormChange,
	            recordType: _constants.RECORD_TYPE.DOCUMENT
	          });
	
	        case 25:
	          _context.next = 27;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.setUploadInsuranceCardModalData({
	            isOpened: false,
	            cardType: null
	          }));
	
	        case 27:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function uploadMainInsuranceCard() {
	  return _regenerator2.default.wrap(function uploadMainInsuranceCard$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_manageInsurancesActions.MANAGE_INSURANCES_ACTION_TYPES.UPLOAD_MAIN_INSURANCE_CARD, uploadMainInsuranceCardWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectUpdatePatientInsuranceError = exports.selectRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'managePatientInsurances.updatePatientInsurance');
	};
	
	var selectUpdatePatientInsuranceError = exports.selectUpdatePatientInsuranceError = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'error');
	});

/***/ }),
/* 4127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OTCore = undefined;
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(266);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _signal = __webpack_require__(1893);
	
	var _session = __webpack_require__(4129);
	
	var _publisher = __webpack_require__(4128);
	
	var _reduxEmitter = __webpack_require__(865);
	
	var _eventManager = __webpack_require__(1316);
	
	var _sentryMethods = __webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable lines-between-class-members */
	
	var OTCore = exports.OTCore = function (_ReduxEmitter) {
	  (0, _inherits3.default)(OTCore, _ReduxEmitter);
	
	  function OTCore(options) {
	    (0, _classCallCheck3.default)(this, OTCore);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (OTCore.__proto__ || (0, _getPrototypeOf2.default)(OTCore)).call(this, options.dispatch));
	
	    _this.scheduledReconnectPublisher = false;
	    _this.scheduledReconnectSession = false;
	    _this.isOnline = true;
	
	    _this.displayError = function () {};
	
	    _this.handleException = function (event) {
	      if (event.code === 1500) {
	        event.preventDefault();
	        (0, _sentryMethods.trackAppAction)('[ot-core] exception code:1500; -> reconnect publisher', _sentryMethods.UserActionSeverity.Error);
	        console.warn('1500 RECONNECT HERE', event);
	        _this.reconnectPublisher();
	        return;
	      }
	
	      if (event.code === 1004) {
	        console.warn('1004 SESSION EXPIRED HERE', event);
	        (0, _sentryMethods.trackAppAction)('[ot-core] exception code:1004; -> destroy', _sentryMethods.UserActionSeverity.Error);
	        return;
	      }
	
	      (0, _sentryMethods.trackError)(event);
	      (0, _sentryMethods.sentryCaptureError)('[ERROR] OT EXCEPTION');
	      console.error(' UNHADLED EXCEPTION', event);
	    };
	
	    _this.credentials = options.config;
	    _this.isOnline = options.isOnline;
	    _this.user = options.user;
	    _this.displayError = options.handleGlobalError;
	
	    _this.otSession = new _session.OTSession({
	      config: _this.credentials,
	      dispatch: options.dispatch
	    });
	    _this.otPublisher = new _publisher.OTPublisher({
	      user: _this.user,
	      dispatch: options.dispatch,
	      otSession: _this.otSession
	    });
	    _this.otSignal = new _signal.OTSignal({
	      dispatch: options.dispatch,
	      otSession: _this.otSession
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(OTCore, [{
	    key: 'setupListeners',
	    value: function setupListeners() {
	      var _this2 = this;
	
	      _eventManager.otEventManager.onReconnect(function () {
	        return _this2.reconnectPublisher();
	      });
	      _eventManager.otEventManager.onRestart(function () {
	        return _this2.reconnectToSession();
	      });
	      OT.on('exception', this.handleException);
	    }
	  }, {
	    key: 'clearListeners',
	    value: function clearListeners() {
	      _eventManager.otEventManager.offReconnect();
	      _eventManager.otEventManager.offRestart();
	      OT.off('exception', this.handleException);
	    }
	  }, {
	    key: 'updateOnlineStatus',
	    value: function updateOnlineStatus(isOnline) {
	      console.warn('internet connection ', isOnline ? 'online' : 'offline');
	      this.isOnline = isOnline;
	      if (isOnline) {
	        if (this.scheduledReconnectPublisher) {
	          return this.reconnectPublisher();
	        }
	
	        if (this.scheduledReconnectSession) {
	          return this.reconnectToSession();
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'initiateModels',
	    value: function initiateModels() {
	      this.setupListeners();
	      this.otSession.init();
	      this.otSignal.init();
	    }
	  }, {
	    key: 'startVideoCall',
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                (0, _sentryMethods.trackAppAction)('[ot-core] start virtual call');
	                _context.prev = 1;
	
	                console.info('============== S T A R T    C A L L =============');
	                this.dispatchToggleLoading(true);
	                this.initiateModels();
	                _context.next = 7;
	                return this.otPublisher.setupPublisher();
	
	              case 7:
	                _context.next = 9;
	                return this.otSession.connect();
	
	              case 9:
	                _context.next = 11;
	                return this.otPublisher.publishIntoSession();
	
	              case 11:
	                this.otSession.setTargetStreamIdOnSessionInit();
	                (0, _sentryMethods.trackAppAction)('[ot-core] connected');
	                console.info('============== C A L L   S T A R T E D  =============');
	                _context.next = 23;
	                break;
	
	              case 16:
	                _context.prev = 16;
	                _context.t0 = _context['catch'](1);
	
	                console.error('[ot-core] error during start virtual call', _context.t0);
	                (0, _sentryMethods.trackAppAction)('[ot-core] error during start virtual call', _sentryMethods.UserActionSeverity.Error);
	                (0, _sentryMethods.trackError)(_context.t0);
	                (0, _sentryMethods.sentryCaptureError)('[ERROR] START VISIT');
	                this.displayError(_context.t0 && _context.t0.name);
	
	              case 23:
	                _context.prev = 23;
	
	                this.dispatchToggleLoading(false);
	                return _context.finish(23);
	
	              case 26:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 16, 23, 26]]);
	      }));
	
	      function startVideoCall() {
	        return _ref.apply(this, arguments);
	      }
	
	      return startVideoCall;
	    }()
	  }, {
	    key: 'reconnectPublisher',
	    value: function () {
	      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (this.isOnline) {
	                  _context2.next = 4;
	                  break;
	                }
	
	                this.scheduledReconnectPublisher = true;
	                console.warn('app is offline ---> schedule reconnect publisher after connection to network');
	                return _context2.abrupt('return');
	
	              case 4:
	                (0, _sentryMethods.trackAppAction)('[ot-core] reconnect publisher');
	
	                _context2.prev = 5;
	
	                console.info('== R E C O N N E C T I N G    P U B L I S H E R ===');
	                this.dispatchToggleLoading(true);
	                this.otPublisher.destroy();
	                _context2.next = 11;
	                return this.otPublisher.setupPublisher();
	
	              case 11:
	                _context2.next = 13;
	                return this.otPublisher.publishIntoSession();
	
	              case 13:
	                this.otSession.setTargetStreamIdOnSessionInit();
	                (0, _sentryMethods.trackAppAction)('[ot-core] connected');
	                console.info('= F I N I S H    R E C O N N E C T   P U B L I S H E R =');
	                _context2.next = 24;
	                break;
	
	              case 18:
	                _context2.prev = 18;
	                _context2.t0 = _context2['catch'](5);
	
	                console.error('error during reconnect PUBLISHER', _context2.t0);
	                (0, _sentryMethods.trackAppAction)('[ot-core] error during reconnect publisher', _sentryMethods.UserActionSeverity.Error);
	                (0, _sentryMethods.trackError)(_context2.t0);
	                (0, _sentryMethods.sentryCaptureError)('[ERROR] RECONNECT PUBLISHER');
	
	              case 24:
	                _context2.prev = 24;
	
	                this.dispatchToggleLoading(false);
	                this.scheduledReconnectPublisher = false;
	                return _context2.finish(24);
	
	              case 28:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[5, 18, 24, 28]]);
	      }));
	
	      function reconnectPublisher() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return reconnectPublisher;
	    }()
	  }, {
	    key: 'reconnectToSession',
	    value: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (this.isOnline) {
	                  _context3.next = 4;
	                  break;
	                }
	
	                this.scheduledReconnectSession = true;
	                console.warn('app is offline ---> schedule reconnect SESSION after connection to network');
	                return _context3.abrupt('return');
	
	              case 4:
	
	                console.info('== R E C O N N E C T I N G    S E S S I O N ===');
	                (0, _sentryMethods.trackAppAction)('[ot-core] reconnect to session');
	                _context3.prev = 6;
	
	                this.destroy();
	                _context3.next = 10;
	                return this.startVideoCall();
	
	              case 10:
	                _context3.next = 18;
	                break;
	
	              case 12:
	                _context3.prev = 12;
	                _context3.t0 = _context3['catch'](6);
	
	                console.error('error during reconnect SESSION', _context3.t0);
	                (0, _sentryMethods.trackAppAction)('[ot-core] error during reconnect to session', _sentryMethods.UserActionSeverity.Error);
	                (0, _sentryMethods.trackError)(_context3.t0);
	                (0, _sentryMethods.sentryCaptureError)('[ERROR] RECONNECT SESSION');
	
	              case 18:
	                _context3.prev = 18;
	
	                this.scheduledReconnectSession = false;
	                return _context3.finish(18);
	
	              case 21:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[6, 12, 18, 21]]);
	      }));
	
	      function reconnectToSession() {
	        return _ref3.apply(this, arguments);
	      }
	
	      return reconnectToSession;
	    }()
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      console.info('-------- D E S T R O Y I N G --------');
	      this.dispatchReset();
	      this.clearListeners();
	      this.otPublisher.destroy();
	      this.otSignal.destroy();
	      this.otSession.destroy();
	      console.info('-------- D E S T R O Y E D --------');
	    }
	  }, {
	    key: 'currentMediaDevices',
	    get: function get() {
	      return this.otPublisher.initialMediaDevices;
	    }
	  }]);
	  return OTCore;
	}(_reduxEmitter.ReduxEmitter);

/***/ }),
/* 4128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OTPublisher = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _setImmediate2 = __webpack_require__(4299);
	
	var _setImmediate3 = _interopRequireDefault(_setImmediate2);
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _asyncToGenerator2 = __webpack_require__(266);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _debounce = __webpack_require__(176);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _reduxEmitter = __webpack_require__(865);
	
	var _eventManager = __webpack_require__(1316);
	
	var _constants = __webpack_require__(420);
	
	var _notifications = __webpack_require__(672);
	
	var _utils = __webpack_require__(307);
	
	var _sentryMethods = __webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable consistent-return,no-unused-expressions */
	var OTPublisher = exports.OTPublisher = function (_ReduxEmitter) {
	  (0, _inherits3.default)(OTPublisher, _ReduxEmitter);
	
	  function OTPublisher(_ref) {
	    var _this2 = this;
	
	    var user = _ref.user,
	        dispatch = _ref.dispatch,
	        otSession = _ref.otSession;
	    (0, _classCallCheck3.default)(this, OTPublisher);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (OTPublisher.__proto__ || (0, _getPrototypeOf2.default)(OTPublisher)).call(this, dispatch));
	
	    _this.id = _constants.PUB_KEY;
	    _this.handleDeviceChange = (0, _debounce2.default)((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _this$initialMediaDev, videoSourceList, audioSourceList, _videoSourceList, defaultVideoDevice, _audioSourceList, defaultAudioDevice, activeVideoSource, activeAudioSource, activeAudioDeviceId, isVideoEnded, isAudioEnded, videoDeviceExist, audioDeviceExist, message, _message;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              console.log('[ot-publisher] media device change');
	              _context.next = 3;
	              return _this.updateDeviceList();
	
	            case 3:
	              _this$initialMediaDev = _this.initialMediaDevices, videoSourceList = _this$initialMediaDev.videoSourceList, audioSourceList = _this$initialMediaDev.audioSourceList;
	              _videoSourceList = (0, _slicedToArray3.default)(videoSourceList, 1), defaultVideoDevice = _videoSourceList[0];
	              _audioSourceList = (0, _slicedToArray3.default)(audioSourceList, 1), defaultAudioDevice = _audioSourceList[0];
	              activeVideoSource = _this.publisher.getVideoSource();
	              activeAudioSource = _this.publisher.getAudioSource();
	              activeAudioDeviceId = void 0;
	
	
	              if (activeAudioSource && activeAudioSource.getCapabilities) {
	                activeAudioDeviceId = (0, _get3.default)(activeAudioSource.getCapabilities(), 'deviceId');
	              }
	
	              isVideoEnded = (0, _get3.default)(activeVideoSource, 'track.readyState') === 'ended';
	              isAudioEnded = (0, _get3.default)(activeAudioSource, 'readyState') === 'ended';
	              videoDeviceExist = videoSourceList.some(function (_ref3) {
	                var deviceId = _ref3.deviceId;
	                return deviceId === activeVideoSource.deviceId;
	              });
	              audioDeviceExist = audioSourceList.some(function (_ref4) {
	                var deviceId = _ref4.deviceId;
	                return deviceId === activeAudioDeviceId;
	              });
	
	              /** VIDEO FALLBACK */
	
	              if (!(defaultVideoDevice && (!videoDeviceExist || isVideoEnded))) {
	                _context.next = 20;
	                break;
	              }
	
	              message = !videoDeviceExist ? 'does not exist' : 'has ENDED state';
	
	              console.warn('actual video device ' + message);
	              _context.next = 19;
	              return _this.changeVideoSource(defaultVideoDevice.deviceId);
	
	            case 19:
	              (0, _notifications.emitForceUpdate)();
	
	            case 20:
	              if (!(defaultAudioDevice && (!audioDeviceExist || isAudioEnded))) {
	                _context.next = 26;
	                break;
	              }
	
	              _message = !audioDeviceExist ? 'does not exist' : 'has ENDED state';
	
	              console.warn('actual video device  ' + _message);
	              _context.next = 25;
	              return _this.changeAudioSource(defaultAudioDevice.deviceId);
	
	            case 25:
	              (0, _notifications.emitForceUpdate)();
	
	            case 26:
	
	              (0, _notifications.emitForceUpdate)();
	
	            case 27:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    })), 300);
	
	    _this.user = user;
	    _this.otSession = otSession;
	    _this.publisher = null;
	    _this.initialMediaDevices = null;
	    _this.ready = false;
	    return _this;
	  }
	
	  (0, _createClass3.default)(OTPublisher, [{
	    key: 'updateDeviceList',
	    value: function () {
	      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.prev = 0;
	                _context2.next = 3;
	                return (0, _utils.getMediaDevices)();
	
	              case 3:
	                this.initialMediaDevices = _context2.sent;
	                _context2.next = 12;
	                break;
	
	              case 6:
	                _context2.prev = 6;
	                _context2.t0 = _context2['catch'](0);
	
	                console.error('[ot-publisher] |updateDeviceList|', _context2.t0);
	                (0, _sentryMethods.trackError)(_context2.t0);
	                (0, _sentryMethods.sentryCaptureError)('[ERROR] MEDIA DEVICE LIST');
	                throw _context2.t0;
	
	              case 12:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[0, 6]]);
	      }));
	
	      function updateDeviceList() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return updateDeviceList;
	    }()
	  }, {
	    key: 'initiatePublisher',
	    value: function initiatePublisher() {
	      var _this3 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        console.time('init-publisher');
	        var publisher = OT.initPublisher('', _this3.publisherOptions, function (error) {
	          if (error) {
	            console.error('[ot-publisher] |initiatePublisher|', error);
	            console.timeEnd('init-publisher');
	            return reject(error);
	          }
	          console.timeEnd('init-publisher');
	          return resolve(publisher);
	        });
	      });
	    }
	  }, {
	    key: 'setupListeners',
	    value: function setupListeners() {
	      var _this4 = this;
	
	      if (!this.publisher) throw new Error('No Publisher defined');
	
	      console.log('[ot-publisher] setup listeners');
	      this.publisher.on(_constants.OT_EVENTS.STREAM_CREATED, function (_ref6) {
	        var stream = _ref6.stream;
	
	        if (_this4.otSession) {
	          _this4.otSession.setPublisherStreamId(stream.streamId);
	        }
	        _this4.dispatchUpdateConnection({ stream: stream, id: _this4.id });
	      });
	
	      this.publisher.on(_constants.OT_EVENTS.STREAM_DESTROYED, function (event) {
	        (0, _sentryMethods.trackAppAction)('[ot-publisher] stream destroyed ' + event.reason);
	        if (event.reason === 'mediaStopped') {
	          console.warn('[ot-publisher] |STREAM_DESTROYED| mediaStopped');
	          _this4.ready = false;
	          _eventManager.otEventManager.emitReconnect();
	          return;
	        }
	        if (event.reason === 'networkDisconnected') {
	          console.warn('[ot-publisher] |STREAM_DESTROYED| networkDisconnected');
	          return;
	        }
	        if (event.reason === 'clientDisconnected') {
	          console.warn('[ot-publisher] |STREAM_DESTROYED| clientDisconnected');
	          _this4.ready = false;
	          _eventManager.otEventManager.emitReconnect();
	          return;
	        }
	
	        console.warn('[ot-publisher] TODO: HANDLE DESTROY PUBLISHER STREAM ', event.reason, event);
	      });
	
	      if (navigator.mediaDevices) {
	        navigator.mediaDevices.addEventListener('devicechange', this.handleDeviceChange);
	      }
	    }
	  }, {
	    key: 'clearListeners',
	    value: function clearListeners() {
	      if (this.publisher) {
	        console.log('[ot-publisher] clear listeners');
	        this.publisher.off();
	      }
	
	      if (navigator.mediaDevices) {
	        navigator.mediaDevices.removeEventListener('devicechange', this.handleDeviceChange);
	      }
	    }
	  }, {
	    key: 'changeVideoSource',
	    value: function () {
	      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(deviceId) {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (this.publisher) {
	                  _context3.next = 2;
	                  break;
	                }
	
	                throw new Error('no Publisher');
	
	              case 2:
	                if (this.ready) {
	                  _context3.next = 5;
	                  break;
	                }
	
	                console.warn('[ot-publisher] |changeVideoSource| SKIP, cause publisher is not ready');
	                return _context3.abrupt('return');
	
	              case 5:
	
	                (0, _sentryMethods.trackAppAction)('[ot-publisher] change video source ' + deviceId);
	
	                _context3.prev = 6;
	
	                console.time('change-video-source');
	                _context3.next = 10;
	                return this.publisher.setVideoSource(deviceId);
	
	              case 10:
	                console.info('[ot-publisher] VIDEO CHANGED');
	                _context3.next = 18;
	                break;
	
	              case 13:
	                _context3.prev = 13;
	                _context3.t0 = _context3['catch'](6);
	
	                console.error('[ot-publisher] ERROR DURING VIDEO CHANGE', _context3.t0);
	                (0, _sentryMethods.trackError)(_context3.t0);
	                (0, _sentryMethods.sentryCaptureError)('[ERROR] CHANGE VIDEO DEVICE');
	
	              case 18:
	                _context3.prev = 18;
	
	                console.timeEnd('change-video-source');
	                return _context3.finish(18);
	
	              case 21:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[6, 13, 18, 21]]);
	      }));
	
	      function changeVideoSource(_x) {
	        return _ref7.apply(this, arguments);
	      }
	
	      return changeVideoSource;
	    }()
	  }, {
	    key: 'changeAudioSource',
	    value: function () {
	      var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(deviceId) {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                if (this.publisher) {
	                  _context4.next = 2;
	                  break;
	                }
	
	                throw new Error('no Publisher');
	
	              case 2:
	                if (this.ready) {
	                  _context4.next = 5;
	                  break;
	                }
	
	                console.warn('[ot-publisher] |changeAudioSource| SKIP, cause publisher is not ready');
	                return _context4.abrupt('return');
	
	              case 5:
	
	                (0, _sentryMethods.trackAppAction)('[ot-publisher] change audio source ' + deviceId);
	
	                _context4.prev = 6;
	
	                console.time('change-audio-source');
	                _context4.next = 10;
	                return this.publisher.setAudioSource(deviceId);
	
	              case 10:
	                console.info('[ot-publisher] AUDIO CHANGED');
	                _context4.next = 18;
	                break;
	
	              case 13:
	                _context4.prev = 13;
	                _context4.t0 = _context4['catch'](6);
	
	                console.error('[ot-publisher] ERROR DURING AUDIO CHANGE', _context4.t0);
	                (0, _sentryMethods.trackError)(_context4.t0);
	                (0, _sentryMethods.sentryCaptureError)('[ERROR] CHANGE AUDIO DEVICE');
	
	              case 18:
	                _context4.prev = 18;
	
	                console.timeEnd('change-audio-source');
	                return _context4.finish(18);
	
	              case 21:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this, [[6, 13, 18, 21]]);
	      }));
	
	      function changeAudioSource(_x2) {
	        return _ref8.apply(this, arguments);
	      }
	
	      return changeAudioSource;
	    }()
	  }, {
	    key: 'setupPublisher',
	    value: function () {
	      var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
	        var _this5 = this;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                _context5.prev = 0;
	                _context5.next = 3;
	                return this.updateDeviceList();
	
	              case 3:
	                _context5.next = 5;
	                return this.initiatePublisher();
	
	              case 5:
	                this.publisher = _context5.sent;
	
	                this.dispatchAddConnection({
	                  entity: this.publisher,
	                  user: this.user,
	                  ready: false,
	                  id: this.id
	                });
	
	                (0, _setImmediate3.default)(function () {
	                  var video = _this5.publisher.videoElement();
	                  _this5.dispatchUpdateConnection({ ready: true, video: video, id: _this5.id });
	                });
	
	                this.setupListeners();
	                _context5.next = 17;
	                break;
	
	              case 11:
	                _context5.prev = 11;
	                _context5.t0 = _context5['catch'](0);
	
	                console.error('[ot-publisher] |setupPublisher|', _context5.t0);
	                (0, _sentryMethods.trackError)(_context5.t0);
	                (0, _sentryMethods.sentryCaptureError)('[ERROR] SETUP PUBLISHER');
	                throw _context5.t0;
	
	              case 17:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this, [[0, 11]]);
	      }));
	
	      function setupPublisher() {
	        return _ref9.apply(this, arguments);
	      }
	
	      return setupPublisher;
	    }()
	  }, {
	    key: 'updateUser',
	    value: function updateUser() {
	      if (this.user.id) return;
	
	      try {
	        var user = (0, _utils.parseUserPayload)(this.session.connection.data);
	        this.dispatchUpdateConnection({ id: this.id, user: user });
	      } catch (e) {
	        console.log('error during update user', e);
	      }
	    }
	  }, {
	    key: 'publishIntoSession',
	    value: function publishIntoSession() {
	      var _this6 = this;
	
	      this.updateUser();
	      return new _promise2.default(function (resolve, reject) {
	        if (!_this6.session) return reject(new Error('No Session'));
	        if (!_this6.publisher) return reject(new Error('No Publisher'));
	
	        console.time('publish-into-session');
	        _this6.session.publish(_this6.publisher, function (error) {
	          if (error) {
	            console.error('[ot-publisher] |session.publish|', error);
	            _this6.destroy();
	            console.timeEnd('publish-into-session');
	            return reject(error);
	          }
	
	          console.timeEnd('publish-into-session');
	          _this6.ready = true;
	          resolve(true);
	        });
	      });
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.ready = false;
	      this.clearListeners();
	      if (this.publisher) {
	        this.publisher.destroy();
	      }
	      if (this.session && this.publisher) {
	        console.info('[ot-publisher] unpublish publisher from session');
	        this.session.unpublish(this.publisher);
	      }
	      console.log('[ot-publisher] destroyed');
	    }
	  }, {
	    key: 'publisherOptions',
	    get: function get() {
	      return (0, _extends3.default)({
	        insertDefaultUI: false,
	        showControls: true,
	        resolution: '640x480'
	      }, this.initialMediaDevices && {
	        videoSource: (0, _get3.default)(this.initialMediaDevices, 'videoSourceList[0].deviceId'),
	        audioSource: (0, _get3.default)(this.initialMediaDevices, 'audioSourceList[0].deviceId')
	      });
	    }
	  }, {
	    key: 'session',
	    get: function get() {
	      if (!this.otSession || !this.otSession.session) {
	        console.warn('[ot-publisher] no session');
	        return null;
	      }
	
	      return this.otSession.session;
	    }
	  }]);
	  return OTPublisher;
	}(_reduxEmitter.ReduxEmitter);

/***/ }),
/* 4129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OTSession = undefined;
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _reduxEmitter = __webpack_require__(865);
	
	var _eventManager = __webpack_require__(1316);
	
	var _constants = __webpack_require__(420);
	
	var _utils = __webpack_require__(307);
	
	var _notifications = __webpack_require__(672);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OTSession = exports.OTSession = function (_ReduxEmitter) {
	  (0, _inherits3.default)(OTSession, _ReduxEmitter);
	
	  function OTSession(_ref) {
	    var config = _ref.config,
	        dispatch = _ref.dispatch;
	    (0, _classCallCheck3.default)(this, OTSession);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (OTSession.__proto__ || (0, _getPrototypeOf2.default)(OTSession)).call(this, dispatch));
	
	    _this.handleStreamCreate = function (_ref2) {
	      var stream = _ref2.stream;
	
	      if (!_this.session) throw new Error('No Session');
	
	      var id = stream.streamId,
	          connection = stream.connection;
	
	      var user = (0, _utils.parseUserPayload)(connection.data);
	      (0, _notifications.emitNotification)({ type: _notifications.NOTIFICATION_TYPES.JOIN, name: user.name });
	      _this.dispatchAddConnection({ id: id, stream: stream, ready: false, user: user });
	      _this.addSubscriber(stream);
	    };
	
	    _this.handleStreamDestroy = function (_ref3) {
	      var stream = _ref3.stream;
	
	      var id = stream.streamId;
	      _this.dispatchRemoveConnection({ id: id });
	      _this.dispatchRemoveVideoWarningId({ id: id });
	
	      if (stream.videoType === _constants.SCREEN_SHARING_VIDEO_TYPE) {
	        _this.dispatchFindScreenSharing(); // if exist other screen sharing set it active
	      }
	    };
	
	    _this.handleStreamPropChange = function (_ref4) {
	      var stream = _ref4.stream;
	
	      var id = _this.getStreamId(stream);
	      _this.dispatchUpdateConnection({ id: id, stream: stream });
	    };
	
	    _this.sessionID = config.sessionID;
	    _this.token = config.token;
	    _this.apiKey = config.apiKey;
	    _this.session = OT.initSession(_this.apiKey, _this.sessionID);
	    _this.publisherStreamId = '';
	    return _this;
	  }
	
	  (0, _createClass3.default)(OTSession, [{
	    key: 'addSubscriber',
	    value: function addSubscriber(stream) {
	      var _this2 = this;
	
	      if (!this.session) throw new Error('No Session');
	
	      var id = stream.streamId;
	
	
	      var subscriber = this.session.subscribe(stream, '', {
	        insertDefaultUI: false
	      });
	
	      subscriber.on(_constants.OT_EVENTS.VIDEO_DISABLED_WARNING, function (e) {
	        console.warn(_constants.OT_EVENTS.VIDEO_DISABLED_WARNING, e);
	        if (e.target.stream) {
	          _this2.dispatchAddVideoWarningId({ id: e.target.stream.streamId });
	        }
	      });
	
	      subscriber.on(_constants.OT_EVENTS.VIDEO_DISABLED_WARNING_LIFTED, function (e) {
	        console.warn(_constants.OT_EVENTS.VIDEO_DISABLED_WARNING_LIFTED, e);
	        if (e.target.stream) {
	          _this2.dispatchRemoveVideoWarningId({ id: e.target.stream.streamId });
	        }
	      });
	
	      subscriber.once(_constants.OT_EVENTS.VIDEO_ELEMENT_CREATED, function (_ref5) {
	        var entity = _ref5.target,
	            video = _ref5.element;
	
	        _this2.dispatchUpdateConnection({
	          ready: true,
	          entity: entity,
	          video: video,
	          id: id
	        });
	      });
	
	      (0, _utils.SpeakerDetection)(subscriber, function (e) {
	        return _this2.dispatchAddActiveSpeaker(e.streamId);
	      }, function (e) {
	        return _this2.dispatchRemoveActiveSpeaker(e.streamId);
	      });
	    }
	  }, {
	    key: 'setupListeners',
	    value: function setupListeners() {
	      if (!this.session) {
	        console.warn('[ot-session] |setupListeners| no session ');
	        return;
	      }
	      console.log('[ot-session] setup listeners');
	      this.session.on(_constants.OT_EVENTS.STREAM_CREATED, this.handleStreamCreate);
	      this.session.on(_constants.OT_EVENTS.STREAM_DESTROYED, this.handleStreamDestroy);
	      this.session.on(_constants.OT_EVENTS.STREAM_PROPERTY_CHANGE, this.handleStreamPropChange);
	      this.session.on(_constants.OT_EVENTS.SESSION_DISCONNECTED, function (event) {
	        if (event.reason === 'networkDisconnected') {
	          _eventManager.otEventManager.emitRestart();
	        }
	
	        console.warn('[ot-session] SESSION DISCONNECTED: todo: reconnect to session', event.reason, event);
	      });
	    }
	  }, {
	    key: 'clearListeners',
	    value: function clearListeners() {
	      if (!this.session) {
	        console.warn('[ot-session] |clearListeners| no session ');
	        return;
	      }
	      console.log('[ot-session] clear listeners');
	      this.session.off(_constants.OT_EVENTS.STREAM_CREATED, this.handleStreamCreate);
	      this.session.off(_constants.OT_EVENTS.STREAM_DESTROYED, this.handleStreamDestroy);
	      this.session.off(_constants.OT_EVENTS.STREAM_PROPERTY_CHANGE, this.handleStreamPropChange);
	      this.session.off(_constants.OT_EVENTS.SESSION_DISCONNECTED);
	    }
	  }, {
	    key: 'setPublisherStreamId',
	    value: function setPublisherStreamId(streamId) {
	      this.publisherStreamId = streamId;
	    }
	  }, {
	    key: 'setTargetStreamIdOnSessionInit',
	    value: function setTargetStreamIdOnSessionInit() {
	      var _this3 = this;
	
	      if (!this.session) {
	        console.warn('[ot-session] |setupListeners| no session ');
	        return;
	      }
	      var streams = this.session.streams;
	
	      var targetId = streams.map(function (_ref6) {
	        var id = _ref6.id;
	        return id;
	      }).filter(function (id) {
	        return id !== _this3.publisherStreamId;
	      })[0] || _constants.PUB_KEY;
	
	      this.dispatchSetActiveId(targetId);
	    }
	  }, {
	    key: 'getStreamId',
	    value: function getStreamId(_ref7) {
	      var streamId = _ref7.streamId;
	
	      return streamId === this.publisherStreamId ? _constants.PUB_KEY : streamId;
	    }
	  }, {
	    key: 'connect',
	    value: function connect() {
	      var _this4 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        if (!_this4.session) return reject(new Error('No Session'));
	        console.time('connect-to-session');
	        _this4.session.connect(_this4.token, function (error) {
	          if (error) {
	            console.timeEnd('connect-to-session');
	            console.error('[ot-session] connect', error);
	
	            return reject(error);
	          }
	          console.timeEnd('connect-to-session');
	          console.log('[ot-session] successfully connected');
	          resolve();
	        });
	      });
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      this.setupListeners();
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.clearListeners();
	      this.session.disconnect();
	      console.log('[ot-session] destroyed');
	    }
	  }]);
	  return OTSession;
	}(_reduxEmitter.ReduxEmitter); /* eslint-disable consistent-return */

/***/ }),
/* 4130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useForceUpdate = useForceUpdate;
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useForceUpdate() {
	  // eslint-disable-next-line no-unused-vars
	  var _useState = (0, _react.useState)(0),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      _ = _useState2[0],
	      setValue = _useState2[1];
	
	  return function () {
	    setValue(function (value) {
	      return value + 1;
	    });
	  };
	}

/***/ }),
/* 4131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useInterval = useInterval;
	
	var _react = __webpack_require__(1);
	
	function useInterval(callback, delay) {
	  var savedCallback = (0, _react.useRef)();
	
	  (0, _react.useEffect)(function () {
	    savedCallback.current = callback;
	  }, [callback]);
	
	  (0, _react.useEffect)(function () {
	    function tick() {
	      savedCallback.current();
	    }
	    tick();
	    var id = setInterval(tick, delay);
	    return function () {
	      return clearInterval(id);
	    };
	  }, [delay]);
	}

/***/ }),
/* 4132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(266);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.useTestConnection = useTestConnection;
	
	var _react = __webpack_require__(1);
	
	var _noop = __webpack_require__(465);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactRedux = __webpack_require__(6);
	
	var _networkTestCredentialsReq = __webpack_require__(856);
	
	var getTestCredentials = _interopRequireWildcard(_networkTestCredentialsReq);
	
	var _selectors = __webpack_require__(64);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable consistent-return */
	var TEST_DURATION_MS = 10 * 1000;
	var TOTAL_DURATION_SEC = TEST_DURATION_MS / 1000 + 3;
	var getSessionInfo = function getSessionInfo(config) {
	  if (!config || (0, _isEmpty2.default)(config)) return null;
	
	  return {
	    apiKey: config.apiKey,
	    token: config.token,
	    sessionId: config.room
	  };
	};
	
	function useTestConnection(_ref) {
	  var _this = this;
	
	  var userId = _ref.userId;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
	      testOpened = _useState2[0],
	      setOpenedTest = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
	      finished = _useState4[0],
	      setFinished = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(0),
	      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
	      progress = _useState6[0],
	      setProgress = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(null),
	      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
	      result = _useState8[0],
	      setResult = _useState8[1];
	
	  var otNetworkTest = (0, _react.useRef)(null);
	  var intervalRef = (0, _react.useRef)(null);
	  var connectionProgress = (0, _react.useRef)(0);
	
	  var loading = (0, _reactRedux.useSelector)(_selectors.selectNetworkTestCredentialsPending);
	  var testCredentials = (0, _reactRedux.useSelector)(_selectors.selectNetworkTestCredentials);
	
	  (0, _react.useEffect)(function () {
	    return function () {
	      return clearInterval(intervalRef.current);
	    };
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (testCredentials) {
	      var credentials = getSessionInfo(testCredentials);
	      if (credentials) {
	        startTesting(credentials);
	      }
	    }
	  }, [testCredentials]);
	
	  var reset = function reset() {
	    setFinished(false);
	    setProgress(0);
	  };
	
	  var trackConnectionProgress = (0, _react.useCallback)(function () {
	    intervalRef.current = setInterval(function () {
	      return setProgress(function (prevProgress) {
	        var newProgress = prevProgress + 1;
	        connectionProgress.current = newProgress;
	        return newProgress;
	      });
	    }, 1000);
	  }, []);
	
	  var testConnection = function () {
	    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              trackConnectionProgress();
	              _context.next = 3;
	              return otNetworkTest.current.testConnectivity();
	
	            case 3:
	              clearInterval(intervalRef.current);
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }));
	
	    return function testConnection() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var testQuality = function () {
	    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	      var delta, k, res;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              delta = Math.abs(TOTAL_DURATION_SEC - connectionProgress.current);
	              k = delta / (TEST_DURATION_MS / 1000);
	              _context2.next = 4;
	              return otNetworkTest.current.testQuality(function (stats) {
	                setProgress(function (prevProgress) {
	                  return prevProgress + k;
	                });
	                (0, _noop2.default)(stats);
	              });
	
	            case 4:
	              res = _context2.sent;
	
	              setResult(res);
	              setFinished(true);
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }));
	
	    return function testQuality() {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var fetchTestCredentials = (0, _react.useCallback)(function () {
	    setOpenedTest(true);
	    reset();
	    dispatch(getTestCredentials.actions.send({ id: userId }));
	  }, [userId]);
	
	  var startTesting = (0, _react.useCallback)(function () {
	    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(credentials) {
	      var options;
	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              options = { timeout: TEST_DURATION_MS };
	
	              otNetworkTest.current = new OpenTokNetworkConnectivity.default(OT, credentials, options);
	              _context3.next = 5;
	              return testConnection();
	
	            case 5:
	              _context3.next = 7;
	              return testQuality();
	
	            case 7:
	              _context3.next = 14;
	              break;
	
	            case 9:
	              _context3.prev = 9;
	              _context3.t0 = _context3['catch'](0);
	
	              console.log('ERROR DURING TEST CONNECTION', _context3.t0);
	              setOpenedTest(false);
	              reset();
	
	            case 14:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this, [[0, 9]]);
	    }));
	
	    return function (_x) {
	      return _ref4.apply(this, arguments);
	    };
	  }(), []);
	
	  var stopTesting = (0, _react.useCallback)(function () {
	    setOpenedTest(false);
	    reset();
	    if (otNetworkTest.current) {
	      otNetworkTest.current.stop();
	      otNetworkTest.current = null;
	    }
	  }, []);
	
	  var buttonProps = (0, _react.useMemo)(function () {
	    if (!testOpened) {
	      return {
	        title: 'virtualVisit.test.test',
	        onClick: fetchTestCredentials,
	        color: 'primary'
	      };
	    }
	
	    if (!finished) {
	      return {
	        title: 'virtualVisit.test.cancel',
	        onClick: stopTesting,
	        color: 'danger-white'
	      };
	    }
	
	    return {
	      title: 'virtualVisit.test.retest',
	      onClick: fetchTestCredentials,
	      color: 'accent'
	    };
	  }, [testOpened, finished]);
	
	  return {
	    startTesting: startTesting,
	    stopTesting: stopTesting,
	    buttonProps: buttonProps,
	    disabled: loading,
	    progress: progress * 100 / TOTAL_DURATION_SEC,
	    testOpened: testOpened,
	    finished: finished,
	    result: result
	  };
	}

/***/ }),
/* 4133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _values = __webpack_require__(168);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	exports.reducer = reducer;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _head = __webpack_require__(378);
	
	var _head2 = _interopRequireDefault(_head);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _actions = __webpack_require__(1318);
	
	var _constants = __webpack_require__(420);
	
	var _camelCaseKeys = __webpack_require__(4190);
	
	var _camelCaseKeys2 = _interopRequireDefault(_camelCaseKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  loading: false,
	  activeId: null,
	  pinnedId: null,
	  speakers: [],
	  videoWarningIds: [],
	  lastActiveSpeaker: null,
	  connectionTime: null,
	  durationData: {},
	  connections: {},
	  invitations: []
	};
	
	function reducer(state, _ref) {
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _actions.OPENTOK_TYPES.TOGGLE_LOADING:
	      {
	        return (0, _extends5.default)({}, state, { loading: payload });
	      }
	
	    case _actions.OPENTOK_TYPES.SET_ACTIVE_ID:
	      {
	        return (0, _extends5.default)({}, state, { activeId: payload });
	      }
	
	    case _actions.OPENTOK_TYPES.SET_START_CALL_TIME:
	      {
	        return (0, _extends5.default)({}, state, { connectionTime: payload });
	      }
	
	    case _actions.OPENTOK_TYPES.SET_DURATION_DATA:
	      {
	        return (0, _extends5.default)({}, state, { durationData: (0, _camelCaseKeys2.default)(payload) });
	      }
	
	    case _actions.OPENTOK_TYPES.SET_PIN:
	      {
	        var pinnedId = state.pinnedId === payload ? null : payload;
	        return (0, _extends5.default)({}, state, { pinnedId: pinnedId });
	      }
	
	    case _actions.OPENTOK_TYPES.FIND_SCREEN_SHARING:
	      {
	        var sharingConnection = (0, _values2.default)(state.connections).find(function (connection) {
	          return (0, _get2.default)(connection, 'stream.videoType') === _constants.SCREEN_SHARING_VIDEO_TYPE;
	        });
	
	        var _pinnedId = (0, _get2.default)(sharingConnection, 'id') ? (0, _get2.default)(sharingConnection, 'id') : null;
	
	        return (0, _extends5.default)({}, state, { pinnedId: _pinnedId });
	      }
	
	    case _actions.OPENTOK_TYPES.ADD_SPEAKER:
	      {
	        return (0, _extends5.default)({}, state, {
	          speakers: [].concat((0, _toConsumableArray3.default)(state.speakers), [payload]),
	          lastActiveSpeaker: payload
	        });
	      }
	
	    case _actions.OPENTOK_TYPES.REMOVE_SPEAKER:
	      {
	        return (0, _extends5.default)({}, state, {
	          speakers: state.speakers.filter(function (id) {
	            return id !== payload;
	          })
	        });
	      }
	
	    case _actions.OPENTOK_TYPES.ADD_VIDEO_WARNING_ID:
	      {
	        return (0, _extends5.default)({}, state, {
	          videoWarningIds: [].concat((0, _toConsumableArray3.default)(state.videoWarningIds), [payload.id])
	        });
	      }
	
	    case _actions.OPENTOK_TYPES.REMOVE_VIDEO_WARNING_ID:
	      {
	        return (0, _extends5.default)({}, state, {
	          videoWarningIds: state.videoWarningIds.filter(function (id) {
	            return id !== payload.id;
	          })
	        });
	      }
	
	    case _actions.OPENTOK_TYPES.ADD_CONNECTION:
	      {
	        var activeId = state.activeId;
	
	
	        if (payload.id !== _constants.PUB_KEY && activeId === _constants.PUB_KEY) {
	          activeId = payload.id;
	        }
	
	        return (0, _extends5.default)({}, state, {
	          activeId: activeId,
	          connections: (0, _extends5.default)({}, state.connections, (0, _defineProperty3.default)({}, payload.id, (0, _extends5.default)({}, payload)))
	        });
	      }
	
	    case _actions.OPENTOK_TYPES.UPDATE_CONNECTION:
	      {
	        var current = (0, _get2.default)(state, 'connections[' + payload.id + ']', {});
	        return (0, _extends5.default)({}, state, {
	          connections: (0, _extends5.default)({}, state.connections, (0, _defineProperty3.default)({}, payload.id, (0, _extends5.default)({}, current, payload)))
	        });
	      }
	
	    case _actions.OPENTOK_TYPES.REMOVE_CONNECTION:
	      {
	        var _state$connections = state.connections,
	            toremove = _state$connections[payload.id],
	            connections = (0, _objectWithoutProperties3.default)(_state$connections, [payload.id]);
	
	        var _pinnedId2 = payload.id === state.pinnedId ? null : state.pinnedId;
	        var speakers = state.speakers.filter(function (id) {
	          return id !== payload.id;
	        });
	        var _activeId = getActiveIdOnConnectionRemove(state.activeId, connections, payload);
	
	        return (0, _extends5.default)({}, state, { connections: connections, activeId: _activeId, speakers: speakers, pinnedId: _pinnedId2 });
	      }
	
	    case _actions.OPENTOK_TYPES.UPDATE_INVITATIONS:
	      {
	        return (0, _extends5.default)({}, state, { invitations: payload });
	      }
	
	    case _actions.OPENTOK_TYPES.RESET:
	      {
	        return (0, _extends5.default)({}, initialState);
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}
	
	function getActiveIdOnConnectionRemove(activeId, connections, payload) {
	  if (activeId === payload.id) {
	    var publisher = connections[_constants.PUB_KEY],
	        subscribers = (0, _objectWithoutProperties3.default)(connections, [_constants.PUB_KEY]);
	
	    return !(0, _isEmpty2.default)(subscribers) ? (0, _head2.default)((0, _keys2.default)(subscribers)) : _constants.PUB_KEY;
	  }
	  return activeId;
	}

/***/ }),
/* 4134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _paperworkVerifyDob = __webpack_require__(676);
	
	var _paperworkVerifyDob2 = _interopRequireDefault(_paperworkVerifyDob);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(675);
	
	var _paperworkGetAppointmentDetails2 = _interopRequireDefault(_paperworkGetAppointmentDetails);
	
	var _paperworkGetUserDetails = __webpack_require__(866);
	
	var _paperworkGetUserDetails2 = _interopRequireDefault(_paperworkGetUserDetails);
	
	var _paperworkSubmitAppointment = __webpack_require__(867);
	
	var _paperworkSubmitAppointment2 = _interopRequireDefault(_paperworkSubmitAppointment);
	
	var _paperworkAppointmentSession = __webpack_require__(673);
	
	var _paperworkAppointmentSession2 = _interopRequireDefault(_paperworkAppointmentSession);
	
	var _paperworkGetAdditionalInfo = __webpack_require__(674);
	
	var _paperworkGetAdditionalInfo2 = _interopRequireDefault(_paperworkGetAdditionalInfo);
	
	var _common = __webpack_require__(4135);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  common: _common2.default,
	  paperworkAdditionalInfo: _paperworkGetAdditionalInfo2.default,
	  paperworkAppointmentDetails: _paperworkGetAppointmentDetails2.default,
	  paperworkAppointmentSession: _paperworkAppointmentSession2.default,
	  paperworkSubmitAppointment: _paperworkSubmitAppointment2.default,
	  paperworkUserDetails: _paperworkGetUserDetails2.default,
	  paperworkVerifyDob: _paperworkVerifyDob2.default
	});

/***/ }),
/* 4135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _common = __webpack_require__(239);
	
	var _insuranceEligibilityManualActivations = __webpack_require__(427);
	
	var _checkInsuranceEligibility = __webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @typedef {Object} QuestionAnswer
	 * @property {string|boolean} answer
	 * @property {string} question
	 * @property {QuestionAnswer[]|undefined} childAnswers
	 * */
	
	/**
	 * @typedef {Object} AdditionalInfoFormData
	 * @property {QuestionAnswer} questionAnswers
	 * */
	
	/**
	 * @typedef {Object} PaperworkCommonState
	 * @property {boolean} pending
	 * @property {Object} pages
	 * @property {string[]} pages.formSteps
	 * @property {Object[]} pages.allPages
	 * @property {Object} data
	 * @property {Object|null} data.pcpFormData
	 * @property {number|null} data.insuranceEligibilityResultId
	 * @property {boolean} data.isPlanNotListedSelected
	 * @property {Object|null} data.additionalInfoFormData
	 * */
	var initialState = {
	  pending: false,
	  validating: true,
	  pages: {
	    formSteps: [],
	    allPages: []
	  },
	  data: {
	    pcpFormData: null,
	    insuranceEligibilityResultId: null,
	    isPlanNotListedSelected: false,
	    additionalInfoFormData: null
	  },
	  isCameFromSubmitPage: false // used to show success confirmation on the complete paperwork page
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var _ref = arguments[1];
	  var type = _ref.type,
	      payload = _ref.payload;
	
	  switch (type) {
	    case _common.PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_ADDITIONAL_INFO_FORM_DATA:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: (0, _extends3.default)({}, state.data, {
	            additionalInfoFormData: payload
	          })
	        });
	      }
	
	    case _common.PAPERWORK_COMMON_ACTION_TYPES.GLOBAL_PAPERWORK_PENDING:
	      {
	        return (0, _extends3.default)({}, state, {
	          pending: payload
	        });
	      }
	
	    case _common.PAPERWORK_COMMON_ACTION_TYPES.PAPERWORK_PAGE_INFO:
	      {
	        return (0, _extends3.default)({}, state, {
	          pages: (0, _extends3.default)({}, state.pages, payload)
	        });
	      }
	
	    case _common.PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_PCP_FORM_DATA:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: (0, _extends3.default)({}, state.data, {
	            pcpFormData: payload
	          })
	        });
	      }
	
	    case _insuranceEligibilityManualActivations.consts.SUCCEED:
	    case _checkInsuranceEligibility.consts.SUCCEED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: (0, _extends3.default)({}, state.data, {
	            insuranceEligibilityResultId: payload.id
	          })
	        });
	      }
	    case _common.PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_INSURANCE_IS_PLAN_NOT_LISTED_SELECTED:
	      {
	        return (0, _extends3.default)({}, state, {
	          data: (0, _extends3.default)({}, state.data, {
	            isPlanNotListedSelected: payload
	          })
	        });
	      }
	
	    case _common.PAPERWORK_COMMON_ACTION_TYPES.SET_PAPERWORK_CAME_FROM_SUBMIT_PAGE:
	      {
	        return (0, _extends3.default)({}, state, {
	          isCameFromSubmitPage: payload
	        });
	      }
	
	    case _common.PAPERWORK_COMMON_ACTION_TYPES.GLOBAL_PAPERWORK_VALIDATING:
	      {
	        return (0, _extends3.default)({}, state, {
	          validating: payload
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	};

/***/ }),
/* 4136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.determinePaperworkFlowRoutes = determinePaperworkFlowRoutes;
	
	var _effects = __webpack_require__(14);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _common = __webpack_require__(239);
	
	var _paperwork = __webpack_require__(265);
	
	var _paperworkAdditionalInfo = __webpack_require__(421);
	
	var _selectors = __webpack_require__(50);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(82);
	
	var _paperworkGetAdditionalInfo = __webpack_require__(674);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(determineRoutes),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(determinePaperworkFlowRoutes);
	
	function determineRoutes() {
	  var uuid, requestContactInfo, isConsentsSigned, showPaperworkAppointmentQuestionStep, paperworkAppointmentQuestionAnswers, includesAdditionalInfoQuestions, skipInsurance, payload, formSteps, allPages;
	  return _regenerator2.default.wrap(function determineRoutes$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.call)(_paperwork.getAppointmentId);
	
	        case 2:
	          uuid = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectAppRequestEmergencyContactInfo);
	
	        case 5:
	          requestContactInfo = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails.selectPaperworkAppointmentIsAllConsentsSigned);
	
	        case 8:
	          isConsentsSigned = _context.sent;
	          _context.next = 11;
	          return (0, _effects.select)(_paperworkAdditionalInfo.selectShowPaperworkAppointmentQuestionStep);
	
	        case 11:
	          showPaperworkAppointmentQuestionStep = _context.sent;
	          _context.next = 14;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails.selectPaperworkAppointmentQuestionAnswers);
	
	        case 14:
	          paperworkAppointmentQuestionAnswers = _context.sent;
	          includesAdditionalInfoQuestions = !(0, _isEmpty2.default)(paperworkAppointmentQuestionAnswers) || Boolean(showPaperworkAppointmentQuestionStep);
	          _context.next = 18;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails.selectPaperworkAppointmentTenantSkipInsurance);
	
	        case 18:
	          skipInsurance = _context.sent;
	          payload = {
	            id: uuid,
	            requestContactInfo: requestContactInfo,
	            isConsentsSigned: isConsentsSigned,
	            includesAdditionalInfoQuestions: includesAdditionalInfoQuestions,
	            skipInsurance: skipInsurance
	          };
	          _context.next = 22;
	          return (0, _effects.call)(_paperwork.getPaperworkFormSteps, payload);
	
	        case 22:
	          formSteps = _context.sent;
	          _context.next = 25;
	          return (0, _effects.call)(_paperwork.getAllPaperworkSteps, payload);
	
	        case 25:
	          allPages = _context.sent;
	          _context.next = 28;
	          return (0, _effects.put)(_common.paperworkCommonActions.setPaperworkPageInfo({ allPages: allPages, formSteps: formSteps }));
	
	        case 28:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function determinePaperworkFlowRoutes() {
	  return _regenerator2.default.wrap(function determinePaperworkFlowRoutes$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_common.PAPERWORK_COMMON_ACTION_TYPES.DETERMINE_PAPERWORK_FLOW_ROUTES, determineRoutes);
	
	        case 2:
	          _context2.next = 4;
	          return (0, _effects.takeLatest)(_paperworkGetAdditionalInfo.consts.SUCCEED, determineRoutes);
	
	        case 4:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = paperworkRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _paperworkVerifyDob = __webpack_require__(676);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(675);
	
	var _paperworkGetUserDetails = __webpack_require__(866);
	
	var _paperworkSubmitAppointment = __webpack_require__(867);
	
	var _paperworkAppointmentSession = __webpack_require__(673);
	
	var _paperworkGetAdditionalInfo = __webpack_require__(674);
	
	var _setPaperworkFlowVerifiedUserData = __webpack_require__(4138);
	
	var _validateInitialPaperworkPage = __webpack_require__(4139);
	
	var _determinePaperworkFlowRoutes = __webpack_require__(4136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(paperworkRootSaga);
	
	function paperworkRootSaga() {
	  return _regenerator2.default.wrap(function paperworkRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_paperworkVerifyDob.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(_paperworkGetAppointmentDetails.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(_paperworkGetUserDetails.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(_paperworkSubmitAppointment.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(_paperworkAppointmentSession.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(_paperworkGetAdditionalInfo.watcher);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_setPaperworkFlowVerifiedUserData.selectPaperworkFlowVerifiedUserDataSaga);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(_validateInitialPaperworkPage.validateInitialPaperworkPage);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(_determinePaperworkFlowRoutes.determinePaperworkFlowRoutes);
	
	        case 18:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _stringify = __webpack_require__(914);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.selectPaperworkFlowVerifiedUserDataSaga = selectPaperworkFlowVerifiedUserDataSaga;
	
	var _effects = __webpack_require__(14);
	
	var _common = __webpack_require__(239);
	
	var _redirectUtils = __webpack_require__(1931);
	
	var _loggedUser = __webpack_require__(523);
	
	var _paperworkVerifyDob = __webpack_require__(676);
	
	var _paperworkAppointmentSession = __webpack_require__(673);
	
	var _paperwork = __webpack_require__(265);
	
	var _storageKeys = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(selectPaperworkFlowVerifiedUserDataSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(selectPaperworkFlowVerifiedUserDataSaga);
	
	function selectPaperworkFlowVerifiedUserDataSagaWorker(_ref) {
	  var payload = _ref.payload;
	
	  var uuid, _ref2, authenticationToken;
	
	  return _regenerator2.default.wrap(function selectPaperworkFlowVerifiedUserDataSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          uuid = (0, _paperwork.getAppointmentId)();
	          _ref2 = payload || {}, authenticationToken = _ref2.authenticationToken;
	
	
	          if (authenticationToken) {
	            window.storage.setItem(_storageKeys.PAPERWORK_TOKEN, (0, _stringify2.default)(authenticationToken));
	          }
	
	          _context.next = 5;
	          return (0, _effects.put)(_common.paperworkCommonActions.setGlobalPaperworkPending(false));
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)(_loggedUser.actions.add(payload));
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.call)(_redirectUtils.redirectToPaperworkVisitDetails, uuid);
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)(_common.paperworkCommonActions.validate());
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function selectPaperworkFlowVerifiedUserDataSaga() {
	  return _regenerator2.default.wrap(function selectPaperworkFlowVerifiedUserDataSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_paperworkVerifyDob.actions.succeed, _paperworkAppointmentSession.actions.succeed], selectPaperworkFlowVerifiedUserDataSagaWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.validateInitialPaperworkPage = validateInitialPaperworkPage;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _paperwork = __webpack_require__(265);
	
	var _redirectUtils = __webpack_require__(1931);
	
	var _common = __webpack_require__(239);
	
	var _permissions = __webpack_require__(832);
	
	var _manageInsurancesActions = __webpack_require__(152);
	
	var _paperworkGetUserDetails = __webpack_require__(866);
	
	var _paperworkGetAppointmentDetails = __webpack_require__(675);
	
	var _paperworkGetAdditionalInfo = __webpack_require__(674);
	
	var _selectors = __webpack_require__(93);
	
	var _selectors2 = __webpack_require__(23);
	
	var _paperworkGetAppointmentDetails2 = __webpack_require__(82);
	
	var _logout = __webpack_require__(198);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleValidateOnMount),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(clearGlobalPaperworkValidating),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(validateInitialPaperworkPage);
	
	function handleValidateOnMount() {
	  var isLoggedIn, appointmentUUID, userId, loggedUserId, loggedUser, isAppointmentPaperworkCompleted, organizationId, serviceId, patientUserId, hasUserAndLoggedUser;
	  return _regenerator2.default.wrap(function handleValidateOnMount$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectAuthLoggedInStatus);
	
	        case 2:
	          isLoggedIn = _context.sent;
	
	          if (isLoggedIn) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 6;
	          return (0, _effects.cancel)();
	
	        case 6:
	          return _context.abrupt('return');
	
	        case 7:
	          _context.next = 9;
	          return (0, _effects.call)(_paperwork.getAppointmentId);
	
	        case 9:
	          appointmentUUID = _context.sent;
	          _context.next = 12;
	          return (0, _effects.put)(_paperworkGetAppointmentDetails.actions.send({
	            appointmentUUID: appointmentUUID
	          }));
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.take)(_paperworkGetAppointmentDetails.consts.SUCCEED);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails2.selectPaperworkAppointmentUserId);
	
	        case 16:
	          userId = _context.sent;
	          _context.next = 19;
	          return (0, _effects.select)(_selectors2.loggedUserIdSelector);
	
	        case 19:
	          loggedUserId = _context.sent;
	          _context.next = 22;
	          return (0, _effects.select)(_selectors2.loggedUserSelector);
	
	        case 22:
	          loggedUser = _context.sent;
	          _context.next = 25;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails2.selectPaperworkAppointmentPaperworkCompleted);
	
	        case 25:
	          isAppointmentPaperworkCompleted = _context.sent;
	          _context.next = 28;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails2.selectPaperworkAppointmentOrgId);
	
	        case 28:
	          organizationId = _context.sent;
	          _context.next = 31;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails2.selectPaperworkAppointmentServiceId);
	
	        case 31:
	          serviceId = _context.sent;
	          _context.next = 34;
	          return (0, _effects.select)(_paperworkGetAppointmentDetails2.selectPaperworkAppointmentUserId);
	
	        case 34:
	          patientUserId = _context.sent;
	          _context.next = 37;
	          return (0, _effects.put)(_paperworkGetAdditionalInfo.actions.clear());
	
	        case 37:
	          _context.next = 39;
	          return (0, _effects.put)(_common.paperworkCommonActions.setPaperworkAdditionalInfoFormData(null));
	
	        case 39:
	          _context.next = 41;
	          return (0, _effects.put)(_paperworkGetAdditionalInfo.actions.send({
	            serviceId: serviceId,
	            organizationId: organizationId,
	            patientUserId: patientUserId
	          }));
	
	        case 41:
	          hasUserAndLoggedUser = userId && loggedUserId;
	
	          if (!hasUserAndLoggedUser) {
	            _context.next = 54;
	            break;
	          }
	
	          if (!(userId !== loggedUserId)) {
	            _context.next = 52;
	            break;
	          }
	
	          _context.next = 46;
	          return (0, _effects.put)(_paperworkGetUserDetails.actions.send({ id: userId }));
	
	        case 46:
	          _context.next = 48;
	          return (0, _effects.put)(_permissions.actions.update({ targetUserId: userId }));
	
	        case 48:
	          _context.next = 50;
	          return (0, _effects.take)([_paperworkGetUserDetails.consts.SUCCEED, _paperworkGetUserDetails.consts.REJECTED, _paperworkGetUserDetails.consts.ERROR_ENCOUNTERED]);
	
	        case 50:
	          _context.next = 54;
	          break;
	
	        case 52:
	          _context.next = 54;
	          return (0, _effects.put)(_paperworkGetUserDetails.actions.setUserDetails(loggedUser));
	
	        case 54:
	          _context.next = 56;
	          return (0, _effects.put)(_manageInsurancesActions.manageInsurancesActions.downloadPatientInsurancesData({
	            userId: userId
	          }));
	
	        case 56:
	          if (!isAppointmentPaperworkCompleted) {
	            _context.next = 61;
	            break;
	          }
	
	          _context.next = 59;
	          return (0, _effects.call)(_redirectUtils.redirectToPaperworkCompletedVisitDetails, appointmentUUID);
	
	        case 59:
	          _context.next = 63;
	          break;
	
	        case 61:
	          _context.next = 63;
	          return (0, _effects.call)(_redirectUtils.redirectToPaperworkVisitDetails, appointmentUUID);
	
	        case 63:
	          _context.next = 65;
	          return (0, _effects.put)(_common.paperworkCommonActions.determinePaperworkFlowRoutes());
	
	        case 65:
	          _context.next = 67;
	          return (0, _effects.delay)(200);
	
	        case 67:
	          _context.next = 69;
	          return (0, _effects.put)(_common.paperworkCommonActions.setGlobalPaperworkValidating(false));
	
	        case 69:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function clearGlobalPaperworkValidating(action) {
	  var appointmentUUID;
	  return _regenerator2.default.wrap(function clearGlobalPaperworkValidating$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (!((0, _get2.default)(action, 'payload.error.status') === 403)) {
	            _context2.next = 5;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _effects.put)(_logout.actions.send());
	
	        case 3:
	          _context2.next = 10;
	          break;
	
	        case 5:
	          _context2.next = 7;
	          return (0, _effects.call)(_paperwork.getAppointmentId);
	
	        case 7:
	          appointmentUUID = _context2.sent;
	          _context2.next = 10;
	          return (0, _effects.call)(_redirectUtils.redirectToPaperworkVisitDetails, appointmentUUID);
	
	        case 10:
	          _context2.next = 12;
	          return (0, _effects.delay)(200);
	
	        case 12:
	          _context2.next = 14;
	          return (0, _effects.put)(_common.paperworkCommonActions.setGlobalPaperworkValidating(false));
	
	        case 14:
	          _context2.next = 16;
	          return (0, _effects.put)(_common.paperworkCommonActions.setGlobalPaperworkPending(false));
	
	        case 16:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function validateInitialPaperworkPage() {
	  return _regenerator2.default.wrap(function validateInitialPaperworkPage$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(_common.PAPERWORK_COMMON_ACTION_TYPES.VALIDATE, handleValidateOnMount);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.takeLatest)([_paperworkGetAppointmentDetails.consts.REJECTED, _paperworkGetAppointmentDetails.consts.ERROR_ENCOUNTERED], clearGlobalPaperworkValidating);
	
	        case 4:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4140 */,
/* 4141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.selectPaperworkVerifyDobError = exports.selectPaperworkVerifyDobPending = exports.selectRootState = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reselect = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectRootState = exports.selectRootState = function selectRootState(state) {
	  return (0, _get2.default)(state, 'paperwork.paperworkVerifyDob');
	};
	
	var selectPaperworkVerifyDobPending = exports.selectPaperworkVerifyDobPending = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'sending', false);
	});
	
	var selectPaperworkVerifyDobError = exports.selectPaperworkVerifyDobError = (0, _reselect.createSelector)(selectRootState, function (state) {
	  return (0, _get2.default)(state, 'error');
	});

/***/ }),
/* 4142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _organizationsReq = __webpack_require__(1320);
	
	var _organizationsReq2 = _interopRequireDefault(_organizationsReq);
	
	var _locationsReq = __webpack_require__(1319);
	
	var _locationsReq2 = _interopRequireDefault(_locationsReq);
	
	var _paymentsReq = __webpack_require__(868);
	
	var _paymentsReq2 = _interopRequireDefault(_paymentsReq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  organizationList: _organizationsReq2.default,
	  locationList: _locationsReq2.default,
	  paymentList: _paymentsReq2.default
	});

/***/ }),
/* 4143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = paymentMethodsRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _organizationsReq = __webpack_require__(1320);
	
	var organizations = _interopRequireWildcard(_organizationsReq);
	
	var _locationsReq = __webpack_require__(1319);
	
	var locations = _interopRequireWildcard(_locationsReq);
	
	var _paymentsReq = __webpack_require__(868);
	
	var payments = _interopRequireWildcard(_paymentsReq);
	
	var _deleteCardReq = __webpack_require__(677);
	
	var deleteCard = _interopRequireWildcard(_deleteCardReq);
	
	var _refetchPaymentMethods = __webpack_require__(1897);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(paymentMethodsRootSaga);
	
	function paymentMethodsRootSaga() {
	  return _regenerator2.default.wrap(function paymentMethodsRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(organizations.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(locations.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(payments.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(deleteCard.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(_refetchPaymentMethods.refetchPaymentMethods);
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4144 */,
/* 4145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _createPatient = __webpack_require__(679);
	
	var _createPatient2 = _interopRequireDefault(_createPatient);
	
	var _getUser = __webpack_require__(202);
	
	var _getUser2 = _interopRequireDefault(_getUser);
	
	var _getLoggedUser = __webpack_require__(539);
	
	var _getLoggedUser2 = _interopRequireDefault(_getLoggedUser);
	
	var _getTeamUser = __webpack_require__(876);
	
	var _getTeamUser2 = _interopRequireDefault(_getTeamUser);
	
	var _getProvider = __webpack_require__(1328);
	
	var _getProvider2 = _interopRequireDefault(_getProvider);
	
	var _getProviderMember = __webpack_require__(1327);
	
	var _getProviderMember2 = _interopRequireDefault(_getProviderMember);
	
	var _getParentProvider = __webpack_require__(680);
	
	var _getParentProvider2 = _interopRequireDefault(_getParentProvider);
	
	var _getFamilyMember = __webpack_require__(874);
	
	var _getFamilyMember2 = _interopRequireDefault(_getFamilyMember);
	
	var _editUser = __webpack_require__(136);
	
	var _editUser2 = _interopRequireDefault(_editUser);
	
	var _editAvatar = __webpack_require__(873);
	
	var _editAvatar2 = _interopRequireDefault(_editAvatar);
	
	var _editPatient = __webpack_require__(218);
	
	var _editPatient2 = _interopRequireDefault(_editPatient);
	
	var _editPatientByProvider = __webpack_require__(423);
	
	var _editPatientByProvider2 = _interopRequireDefault(_editPatientByProvider);
	
	var _editProvider = __webpack_require__(424);
	
	var _editProvider2 = _interopRequireDefault(_editProvider);
	
	var _editEmail = __webpack_require__(1323);
	
	var _editEmail2 = _interopRequireDefault(_editEmail);
	
	var _editMobilePhone = __webpack_require__(1324);
	
	var _editMobilePhone2 = _interopRequireDefault(_editMobilePhone);
	
	var _confirmMobilePhone = __webpack_require__(678);
	
	var _confirmMobilePhone2 = _interopRequireDefault(_confirmMobilePhone);
	
	var _changeSettings = __webpack_require__(538);
	
	var _changeSettings2 = _interopRequireDefault(_changeSettings);
	
	var _changeProfileReq = __webpack_require__(870);
	
	var _changeProfileReq2 = _interopRequireDefault(_changeProfileReq);
	
	var _addPatientByProvider = __webpack_require__(308);
	
	var _addPatientByProvider2 = _interopRequireDefault(_addPatientByProvider);
	
	var _getAccessLevels = __webpack_require__(426);
	
	var _getAccessLevels2 = _interopRequireDefault(_getAccessLevels);
	
	var _publicProfile = __webpack_require__(889);
	
	var _publicProfile2 = _interopRequireDefault(_publicProfile);
	
	var _getUserDocuments = __webpack_require__(425);
	
	var _getUserDocuments2 = _interopRequireDefault(_getUserDocuments);
	
	var _getUserAttachment = __webpack_require__(877);
	
	var _getUserAttachment2 = _interopRequireDefault(_getUserAttachment);
	
	var _uploadUserDocuments = __webpack_require__(429);
	
	var _uploadUserDocuments2 = _interopRequireDefault(_uploadUserDocuments);
	
	var _updateUserDocuments = __webpack_require__(540);
	
	var _updateUserDocuments2 = _interopRequireDefault(_updateUserDocuments);
	
	var _deleteUserDocuments = __webpack_require__(422);
	
	var _deleteUserDocuments2 = _interopRequireDefault(_deleteUserDocuments);
	
	var _deleteUserAttachment = __webpack_require__(871);
	
	var _deleteUserAttachment2 = _interopRequireDefault(_deleteUserAttachment);
	
	var _deleteUserOutcomeAttachment = __webpack_require__(872);
	
	var _deleteUserOutcomeAttachment2 = _interopRequireDefault(_deleteUserOutcomeAttachment);
	
	var _getGuardianDependents = __webpack_require__(353);
	
	var _getGuardianDependents2 = _interopRequireDefault(_getGuardianDependents);
	
	var _handleDocumentsErrorSaga = __webpack_require__(1899);
	
	var _handleDocumentsErrorSaga2 = _interopRequireDefault(_handleDocumentsErrorSaga);
	
	var _profileEditableReq = __webpack_require__(686);
	
	var _profileEditableReq2 = _interopRequireDefault(_profileEditableReq);
	
	var _getMainConsent = __webpack_require__(875);
	
	var _getMainConsent2 = _interopRequireDefault(_getMainConsent);
	
	var _addPatientData = __webpack_require__(1321);
	
	var _addPatientData2 = _interopRequireDefault(_addPatientData);
	
	var _editWorkingHours = __webpack_require__(1326);
	
	var _editWorkingHours2 = _interopRequireDefault(_editWorkingHours);
	
	var _countryCode = __webpack_require__(1322);
	
	var _countryCode2 = _interopRequireDefault(_countryCode);
	
	var _currentHealthboardOptions = __webpack_require__(1338);
	
	var _currentHealthboardOptions2 = _interopRequireDefault(_currentHealthboardOptions);
	
	var _vitalsActivityReq = __webpack_require__(887);
	
	var _vitalsActivityReq2 = _interopRequireDefault(_vitalsActivityReq);
	
	var _historicMeasurementsReq = __webpack_require__(428);
	
	var _historicMeasurementsReq2 = _interopRequireDefault(_historicMeasurementsReq);
	
	var _stepsMeasurementsReq = __webpack_require__(1353);
	
	var _stepsMeasurementsReq2 = _interopRequireDefault(_stepsMeasurementsReq);
	
	var _stepsMeasurementsModalReq = __webpack_require__(1352);
	
	var _stepsMeasurementsModalReq2 = _interopRequireDefault(_stepsMeasurementsModalReq);
	
	var _distanceMeasurementsReq = __webpack_require__(1340);
	
	var _distanceMeasurementsReq2 = _interopRequireDefault(_distanceMeasurementsReq);
	
	var _distanceMeasurementsModalReq = __webpack_require__(1339);
	
	var _distanceMeasurementsModalReq2 = _interopRequireDefault(_distanceMeasurementsModalReq);
	
	var _bmiMeasurementsReq = __webpack_require__(882);
	
	var _bmiMeasurementsReq2 = _interopRequireDefault(_bmiMeasurementsReq);
	
	var _bmiMeasurementsModalReq = __webpack_require__(1333);
	
	var _bmiMeasurementsModalReq2 = _interopRequireDefault(_bmiMeasurementsModalReq);
	
	var _bloodGlucoseMeasurementsReq = __webpack_require__(1331);
	
	var _bloodGlucoseMeasurementsReq2 = _interopRequireDefault(_bloodGlucoseMeasurementsReq);
	
	var _bloodGlucoseMeasurementsModalReq = __webpack_require__(1330);
	
	var _bloodGlucoseMeasurementsModalReq2 = _interopRequireDefault(_bloodGlucoseMeasurementsModalReq);
	
	var _weightMeasurementsReq = __webpack_require__(888);
	
	var _weightMeasurementsReq2 = _interopRequireDefault(_weightMeasurementsReq);
	
	var _weightMeasurementsModalReq = __webpack_require__(1354);
	
	var _weightMeasurementsModalReq2 = _interopRequireDefault(_weightMeasurementsModalReq);
	
	var _heightMeasurementsReq = __webpack_require__(1344);
	
	var _heightMeasurementsReq2 = _interopRequireDefault(_heightMeasurementsReq);
	
	var _heightMeasurementsModalReq = __webpack_require__(1343);
	
	var _heightMeasurementsModalReq2 = _interopRequireDefault(_heightMeasurementsModalReq);
	
	var _saturationMeasurementsReq = __webpack_require__(1349);
	
	var _saturationMeasurementsReq2 = _interopRequireDefault(_saturationMeasurementsReq);
	
	var _saturationMeasurementsModalReq = __webpack_require__(1348);
	
	var _saturationMeasurementsModalReq2 = _interopRequireDefault(_saturationMeasurementsModalReq);
	
	var _heartRateMeasurementsReq = __webpack_require__(1342);
	
	var _heartRateMeasurementsReq2 = _interopRequireDefault(_heartRateMeasurementsReq);
	
	var _heartRateMeasurementsModalReq = __webpack_require__(1341);
	
	var _heartRateMeasurementsModalReq2 = _interopRequireDefault(_heartRateMeasurementsModalReq);
	
	var _bodySurfaceAreaMeasurementsReq = __webpack_require__(1335);
	
	var _bodySurfaceAreaMeasurementsReq2 = _interopRequireDefault(_bodySurfaceAreaMeasurementsReq);
	
	var _bodySurfaceAreaMeasurementsModalReq = __webpack_require__(1334);
	
	var _bodySurfaceAreaMeasurementsModalReq2 = _interopRequireDefault(_bodySurfaceAreaMeasurementsModalReq);
	
	var _bloodPressureMeasurementsReq = __webpack_require__(881);
	
	var _bloodPressureMeasurementsReq2 = _interopRequireDefault(_bloodPressureMeasurementsReq);
	
	var _bloodPressureMeasurementsModalReq = __webpack_require__(1332);
	
	var _bloodPressureMeasurementsModalReq2 = _interopRequireDefault(_bloodPressureMeasurementsModalReq);
	
	var _respiratoryRateMeasurementsReq = __webpack_require__(886);
	
	var _respiratoryRateMeasurementsReq2 = _interopRequireDefault(_respiratoryRateMeasurementsReq);
	
	var _respiratoryRateMeasurementsModalReq = __webpack_require__(1347);
	
	var _respiratoryRateMeasurementsModalReq2 = _interopRequireDefault(_respiratoryRateMeasurementsModalReq);
	
	var _bodyTemperatureMeasurementsReq = __webpack_require__(1337);
	
	var _bodyTemperatureMeasurementsReq2 = _interopRequireDefault(_bodyTemperatureMeasurementsReq);
	
	var _bodyTemperatureMeasurementsModalReq = __webpack_require__(1336);
	
	var _bodyTemperatureMeasurementsModalReq2 = _interopRequireDefault(_bodyTemperatureMeasurementsModalReq);
	
	var _singleDayGrafModal = __webpack_require__(1350);
	
	var _singleDayGrafModal2 = _interopRequireDefault(_singleDayGrafModal);
	
	var _singlePointValuesModal = __webpack_require__(1351);
	
	var _singlePointValuesModal2 = _interopRequireDefault(_singlePointValuesModal);
	
	var _addWeightData = __webpack_require__(684);
	
	var _addWeightData2 = _interopRequireDefault(_addWeightData);
	
	var _addHeightData = __webpack_require__(683);
	
	var _addHeightData2 = _interopRequireDefault(_addHeightData);
	
	var _addDataModal = __webpack_require__(880);
	
	var _addDataModal2 = _interopRequireDefault(_addDataModal);
	
	var _connectedDevices = __webpack_require__(883);
	
	var _connectedDevices2 = _interopRequireDefault(_connectedDevices);
	
	var _providerAuthentications = __webpack_require__(685);
	
	var _providerAuthentications2 = _interopRequireDefault(_providerAuthentications);
	
	var _providerList = __webpack_require__(1345);
	
	var _providerList2 = _interopRequireDefault(_providerList);
	
	var _removeAccount = __webpack_require__(885);
	
	var _removeAccount2 = _interopRequireDefault(_removeAccount);
	
	var _googleFitModal = __webpack_require__(884);
	
	var _googleFitModal2 = _interopRequireDefault(_googleFitModal);
	
	var _insuranceEligibilityManualActivations = __webpack_require__(427);
	
	var _insuranceEligibilityManualActivations2 = _interopRequireDefault(_insuranceEligibilityManualActivations);
	
	var _editPatientEmergencyContact = __webpack_require__(1325);
	
	var _editPatientEmergencyContact2 = _interopRequireDefault(_editPatientEmergencyContact);
	
	var _mfaEnable = __webpack_require__(879);
	
	var _mfaEnable2 = _interopRequireDefault(_mfaEnable);
	
	var _mfaDisable = __webpack_require__(878);
	
	var _mfaDisable2 = _interopRequireDefault(_mfaDisable);
	
	var _mfaConfirmations = __webpack_require__(681);
	
	var _mfaConfirmations2 = _interopRequireDefault(_mfaConfirmations);
	
	var _mfaNotice = __webpack_require__(1329);
	
	var _mfaNotice2 = _interopRequireDefault(_mfaNotice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// MFA
	exports.default = (0, _redux.combineReducers)({
	  addPatientByProvider: _addPatientByProvider2.default,
	  addPatientData: _addPatientData2.default,
	  changeSettings: _changeSettings2.default,
	  confirmMobilePhone: _confirmMobilePhone2.default,
	  countryCode: _countryCode2.default,
	  createPatient: _createPatient2.default,
	  deleteUserAttachment: _deleteUserAttachment2.default,
	  deleteUserDocuments: _deleteUserDocuments2.default,
	  deleteUserOutcomeAttachment: _deleteUserOutcomeAttachment2.default,
	  disableMfa: _mfaDisable2.default,
	  editAvatar: _editAvatar2.default,
	  editEmail: _editEmail2.default,
	  editMobilePhone: _editMobilePhone2.default,
	  editPatient: _editPatient2.default,
	  editPatientByProvider: _editPatientByProvider2.default,
	  editProvider: _editProvider2.default,
	  editUser: _editUser2.default,
	  editWorkingHours: _editWorkingHours2.default,
	  enableMfa: _mfaEnable2.default,
	  getAccessLevels: _getAccessLevels2.default,
	  getFamilyMember: _getFamilyMember2.default,
	  getGuardianDependent: _getGuardianDependents2.default,
	  getLoggedUser: _getLoggedUser2.default,
	  getMainConsent: _getMainConsent2.default,
	  getParentMember: _getParentProvider2.default,
	  getProvider: _getProvider2.default,
	  getProviderMember: _getProviderMember2.default,
	  getTeamUser: _getTeamUser2.default,
	  getUser: _getUser2.default,
	  getUserAttachments: _getUserAttachment2.default,
	  getUserDocuments: _getUserDocuments2.default,
	  handleDocumentsErrors: _handleDocumentsErrorSaga2.default,
	  manualActivateInsuranceEligibility: _insuranceEligibilityManualActivations2.default,
	  mfaConfirmation: _mfaConfirmations2.default,
	  mfaNotice: _mfaNotice2.default,
	  profileEditable: _profileEditableReq2.default,
	  publicProfile: _publicProfile2.default,
	  updateUserDocuments: _updateUserDocuments2.default,
	  uploadUserDocuments: _uploadUserDocuments2.default,
	  editPatientEmergencyContact: _editPatientEmergencyContact2.default,
	  patientHealthboard: (0, _redux.combineReducers)({
	    googleFitModal: _googleFitModal2.default,
	    currentHealthboardOptions: _currentHealthboardOptions2.default,
	    addDataModal: _addDataModal2.default,
	    addHeightData: _addHeightData2.default,
	    addWeightData: _addWeightData2.default,
	    vitalsActivity: _vitalsActivityReq2.default,
	    historicMeasurements: _historicMeasurementsReq2.default,
	    stepsMeasurement: _stepsMeasurementsReq2.default,
	    stepsMeasurementModal: _stepsMeasurementsModalReq2.default,
	    distanceMeasurement: _distanceMeasurementsReq2.default,
	    distanceMeasurementModal: _distanceMeasurementsModalReq2.default,
	    bmiMeasurement: _bmiMeasurementsReq2.default,
	    bmiMeasurementModal: _bmiMeasurementsModalReq2.default,
	    bloodGlucoseMeasurement: _bloodGlucoseMeasurementsReq2.default,
	    bloodGlucoseMeasurementModal: _bloodGlucoseMeasurementsModalReq2.default,
	    weightMeasurement: _weightMeasurementsReq2.default,
	    weightMeasurementModal: _weightMeasurementsModalReq2.default,
	    heightMeasurement: _heightMeasurementsReq2.default,
	    heightMeasurementModal: _heightMeasurementsModalReq2.default,
	    singleDayGrafModal: _singleDayGrafModal2.default,
	    singlePointValuesModal: _singlePointValuesModal2.default,
	    connectedDevices: _connectedDevices2.default,
	    providerAuthentications: _providerAuthentications2.default,
	    providerList: _providerList2.default,
	    removeAccount: _removeAccount2.default,
	    saturationMeasurement: _saturationMeasurementsReq2.default,
	    saturationMeasurementModal: _saturationMeasurementsModalReq2.default,
	    changeProfileReq: _changeProfileReq2.default,
	    heartRateMeasurement: _heartRateMeasurementsReq2.default,
	    heartRateMeasurementModal: _heartRateMeasurementsModalReq2.default,
	    bodySurfaceAreaMeasurement: _bodySurfaceAreaMeasurementsReq2.default,
	    bodySurfaceAreaMeasurementModal: _bodySurfaceAreaMeasurementsModalReq2.default,
	    bloodPressureMeasurement: _bloodPressureMeasurementsReq2.default,
	    bloodPressureMeasurementModal: _bloodPressureMeasurementsModalReq2.default,
	    respiratoryRateMeasurement: _respiratoryRateMeasurementsReq2.default,
	    respiratoryRateMeasurementModal: _respiratoryRateMeasurementsModalReq2.default,
	    bodyTemperatureMeasurement: _bodyTemperatureMeasurementsReq2.default,
	    bodyTemperatureMeasurementModal: _bodyTemperatureMeasurementsModalReq2.default
	  })
	});
	
	// Patient Portal

/***/ }),
/* 4146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.handleAddWeightHeightSaga = handleAddWeightHeightSaga;
	
	var _effects = __webpack_require__(14);
	
	var _addHeightData = __webpack_require__(683);
	
	var _addWeightData = __webpack_require__(684);
	
	var _historicMeasurementsReq = __webpack_require__(428);
	
	var _weightMeasurementsReq = __webpack_require__(888);
	
	var _bmiMeasurementsReq = __webpack_require__(882);
	
	var _vitalsActivityReq = __webpack_require__(887);
	
	var _addDataModal = __webpack_require__(880);
	
	var _constants = __webpack_require__(54);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleAddWeightHeightWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleAddWeightHeightSaga);
	
	function handleAddWeightHeightWorker(_ref) {
	  var type = _ref.type;
	  var requestDataType, targetUserId, userId, safeId, currentDataType, currentChartPeriod;
	  return _regenerator2.default.wrap(function handleAddWeightHeightWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          requestDataType = type.includes(_constants.VITALS_ACTIVITY_TYPE.WEIGHT) ? _constants.VITALS_ACTIVITY_TYPE.WEIGHT : _constants.VITALS_ACTIVITY_TYPE.HEIGHT;
	          _context.next = 3;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 3:
	          targetUserId = _context.sent;
	          _context.next = 6;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 6:
	          userId = _context.sent;
	          safeId = targetUserId || userId;
	          _context.next = 10;
	          return (0, _effects.select)(_selectors2.selectCurrentHealthboardOptionsDataType);
	
	        case 10:
	          currentDataType = _context.sent;
	          _context.next = 13;
	          return (0, _effects.select)(_selectors2.selectCurrentHealthboardOptionsChartPeriod);
	
	        case 13:
	          currentChartPeriod = _context.sent;
	          _context.next = 16;
	          return (0, _effects.put)({
	            type: _historicMeasurementsReq.consts.CLEAR
	          });
	
	        case 16:
	          if (!(requestDataType === _constants.VITALS_ACTIVITY_TYPE.WEIGHT)) {
	            _context.next = 19;
	            break;
	          }
	
	          _context.next = 19;
	          return (0, _effects.put)({
	            type: _historicMeasurementsReq.consts.SEND,
	            payload: {
	              typeMeasurements: currentDataType,
	              userId: safeId
	            }
	          });
	
	        case 19:
	          if (!(currentDataType === requestDataType || requestDataType !== _constants.VITALS_ACTIVITY_TYPE.HEIGHT)) {
	            _context.next = 22;
	            break;
	          }
	
	          _context.next = 22;
	          return (0, _effects.put)({
	            type: _vitalsActivityReq.consts.SEND,
	            payload: {
	              userId: safeId
	            }
	          });
	
	        case 22:
	          if (!(requestDataType === _constants.VITALS_ACTIVITY_TYPE.WEIGHT && currentDataType !== _constants.VITALS_ACTIVITY_TYPE.BMI)) {
	            _context.next = 25;
	            break;
	          }
	
	          _context.next = 25;
	          return (0, _effects.put)({
	            type: _weightMeasurementsReq.consts.SEND,
	            payload: {
	              userId: safeId,
	              period: currentChartPeriod
	            }
	          });
	
	        case 25:
	          if (!(currentDataType === _constants.VITALS_ACTIVITY_TYPE.BMI && requestDataType !== _constants.VITALS_ACTIVITY_TYPE.HEIGHT)) {
	            _context.next = 28;
	            break;
	          }
	
	          _context.next = 28;
	          return (0, _effects.put)({
	            type: _bmiMeasurementsReq.consts.SEND,
	            payload: {
	              userId: safeId,
	              period: currentChartPeriod
	            }
	          });
	
	        case 28:
	          _context.next = 30;
	          return (0, _effects.put)({
	            type: _addDataModal.ADD_DATA_MODAL.CLOSE
	          });
	
	        case 30:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleAddWeightHeightSaga() {
	  return _regenerator2.default.wrap(function handleAddWeightHeightSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_addWeightData.consts.SUCCEED, _addHeightData.consts.SUCCEED], handleAddWeightHeightWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.manageDeviceAccountSaga = manageDeviceAccountSaga;
	
	var _effects = __webpack_require__(14);
	
	var _providerAuthentications = __webpack_require__(685);
	
	var _connectedDevices = __webpack_require__(883);
	
	var _removeAccount = __webpack_require__(885);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleRemoveAccountWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(manageDeviceAccountSaga);
	
	function handleRemoveAccountWorker() {
	  return _regenerator2.default.wrap(function handleRemoveAccountWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_providerAuthentications.actions.send());
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)(_connectedDevices.actions.send());
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function manageDeviceAccountSaga() {
	  return _regenerator2.default.wrap(function manageDeviceAccountSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_removeAccount.consts.SUCCEED], handleRemoveAccountWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4148 */,
/* 4149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.sagas = sagas;
	
	var _effects = __webpack_require__(14);
	
	var _createPatient = __webpack_require__(679);
	
	var _getUser = __webpack_require__(202);
	
	var _getLoggedUser = __webpack_require__(539);
	
	var _getTeamUser = __webpack_require__(876);
	
	var _getProvider = __webpack_require__(1328);
	
	var _getProviderMember = __webpack_require__(1327);
	
	var _getFamilyMember = __webpack_require__(874);
	
	var _editUser = __webpack_require__(136);
	
	var _editAvatar = __webpack_require__(873);
	
	var _editPatient = __webpack_require__(218);
	
	var _editPatientByProvider = __webpack_require__(423);
	
	var _editProvider = __webpack_require__(424);
	
	var _editEmail = __webpack_require__(1323);
	
	var _editMobilePhone = __webpack_require__(1324);
	
	var _handleDocumentsErrorSaga = __webpack_require__(1899);
	
	var _handleDocumentsErrorSaga2 = _interopRequireDefault(_handleDocumentsErrorSaga);
	
	var _confirmMobilePhone = __webpack_require__(678);
	
	var _updateAvatarSaga = __webpack_require__(4152);
	
	var _getParentProvider = __webpack_require__(680);
	
	var _changeSettings = __webpack_require__(538);
	
	var _changeProfileReq = __webpack_require__(870);
	
	var _updateProfileSaga = __webpack_require__(4154);
	
	var _addPatientByProvider = __webpack_require__(308);
	
	var _getAccessLevels = __webpack_require__(426);
	
	var _publicProfile = __webpack_require__(889);
	
	var _getUserDocuments = __webpack_require__(425);
	
	var _getUserAttachment = __webpack_require__(877);
	
	var _updateUserDocuments = __webpack_require__(540);
	
	var _uploadUserDocuments = __webpack_require__(429);
	
	var _deleteUserDocuments = __webpack_require__(422);
	
	var _deleteUserAttachment = __webpack_require__(871);
	
	var _deleteUserOutcomeAttachment = __webpack_require__(872);
	
	var _updateDocumentsSaga = __webpack_require__(4153);
	
	var _updateAttachmentsSaga = __webpack_require__(4151);
	
	var _getGuardianDependents = __webpack_require__(353);
	
	var _editWorkingHours = __webpack_require__(1326);
	
	var _myProfileRedirect = __webpack_require__(682);
	
	var _publicProfileRedirect = __webpack_require__(1355);
	
	var _getMainConsent = __webpack_require__(875);
	
	var _vitalsActivityReq = __webpack_require__(887);
	
	var _historicMeasurementsReq = __webpack_require__(428);
	
	var _stepsMeasurementsReq = __webpack_require__(1353);
	
	var _stepsMeasurementsModalReq = __webpack_require__(1352);
	
	var _distanceMeasurementsReq = __webpack_require__(1340);
	
	var _distanceMeasurementsModalReq = __webpack_require__(1339);
	
	var _bmiMeasurementsReq = __webpack_require__(882);
	
	var _bmiMeasurementsModalReq = __webpack_require__(1333);
	
	var _bloodGlucoseMeasurementsReq = __webpack_require__(1331);
	
	var _bloodGlucoseMeasurementsModalReq = __webpack_require__(1330);
	
	var _weightMeasurementsReq = __webpack_require__(888);
	
	var _weightMeasurementsModalReq = __webpack_require__(1354);
	
	var _heightMeasurementsReq = __webpack_require__(1344);
	
	var _heightMeasurementsModalReq = __webpack_require__(1343);
	
	var _saturationMeasurementsReq = __webpack_require__(1349);
	
	var _saturationMeasurementsModalReq = __webpack_require__(1348);
	
	var _bodySurfaceAreaMeasurementsReq = __webpack_require__(1335);
	
	var _bodySurfaceAreaMeasurementsModalReq = __webpack_require__(1334);
	
	var _heartRateMeasurementsReq = __webpack_require__(1342);
	
	var _heartRateMeasurementsModalReq = __webpack_require__(1341);
	
	var _bloodPressureMeasurementsReq = __webpack_require__(881);
	
	var _bloodPressureMeasurementsModalReq = __webpack_require__(1332);
	
	var _respiratoryRateMeasurementsReq = __webpack_require__(886);
	
	var _respiratoryRateMeasurementsModalReq = __webpack_require__(1347);
	
	var _bodyTemperatureMeasurementsReq = __webpack_require__(1337);
	
	var _bodyTemperatureMeasurementsModalReq = __webpack_require__(1336);
	
	var _addWeightData = __webpack_require__(684);
	
	var _addHeightData = __webpack_require__(683);
	
	var _connectedDevices = __webpack_require__(883);
	
	var _providerAuthentications = __webpack_require__(685);
	
	var _providerList = __webpack_require__(1345);
	
	var _removeAccount = __webpack_require__(885);
	
	var _handleAddWeightHeightSaga = __webpack_require__(4146);
	
	var _manageDeviceAccountSaga = __webpack_require__(4147);
	
	var _insuranceEligibilityManualActivations = __webpack_require__(427);
	
	var _patientInsuranceCard = __webpack_require__(4150);
	
	var _editPatientEmergencyContact = __webpack_require__(1325);
	
	var _mfaConfirmations = __webpack_require__(681);
	
	var _mfaEnable = __webpack_require__(879);
	
	var _mfaDisable = __webpack_require__(878);
	
	var _mfaNotice = __webpack_require__(1329);
	
	var _profileEditableReq = __webpack_require__(686);
	
	var profileEditable = _interopRequireWildcard(_profileEditableReq);
	
	var _userSaga = __webpack_require__(4155);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(sagas);
	// Patient Portal
	
	
	// MFA
	
	
	function sagas() {
	  return _regenerator2.default.wrap(function sagas$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_createPatient.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(_getUser.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(_getLoggedUser.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(_getTeamUser.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(_getProvider.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(_getProviderMember.watcher);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(_getFamilyMember.watcher);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(_getMainConsent.watcher);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(_editUser.watcher);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(_editAvatar.watcher);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.fork)(_editPatient.watcher);
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.fork)(_editPatientByProvider.watcher);
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.fork)(_editWorkingHours.watcher);
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.fork)(_editProvider.watcher);
	
	        case 28:
	          _context.next = 30;
	          return (0, _effects.fork)(_editEmail.watcher);
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.fork)(_editMobilePhone.watcher);
	
	        case 32:
	          _context.next = 34;
	          return (0, _effects.fork)(_confirmMobilePhone.watcher);
	
	        case 34:
	          _context.next = 36;
	          return (0, _effects.fork)(_updateAvatarSaga.updateAvatarSaga);
	
	        case 36:
	          _context.next = 38;
	          return (0, _effects.fork)(_getParentProvider.watcher);
	
	        case 38:
	          _context.next = 40;
	          return (0, _effects.fork)(_changeSettings.watcher);
	
	        case 40:
	          _context.next = 42;
	          return (0, _effects.fork)(_updateProfileSaga.updateProfileSaga);
	
	        case 42:
	          _context.next = 44;
	          return (0, _effects.fork)(_addPatientByProvider.watcher);
	
	        case 44:
	          _context.next = 46;
	          return (0, _effects.fork)(_getAccessLevels.watcher);
	
	        case 46:
	          _context.next = 48;
	          return (0, _effects.fork)(_publicProfile.watcher);
	
	        case 48:
	          _context.next = 50;
	          return (0, _effects.fork)(_getUserDocuments.watcher);
	
	        case 50:
	          _context.next = 52;
	          return (0, _effects.fork)(_getUserAttachment.watcher);
	
	        case 52:
	          _context.next = 54;
	          return (0, _effects.fork)(_uploadUserDocuments.watcher);
	
	        case 54:
	          _context.next = 56;
	          return (0, _effects.fork)(_updateUserDocuments.watcher);
	
	        case 56:
	          _context.next = 58;
	          return (0, _effects.fork)(_deleteUserDocuments.watcher);
	
	        case 58:
	          _context.next = 60;
	          return (0, _effects.fork)(_updateDocumentsSaga.updateDocumentsSaga);
	
	        case 60:
	          _context.next = 62;
	          return (0, _effects.fork)(_updateAttachmentsSaga.updateAttachmentsSaga);
	
	        case 62:
	          _context.next = 64;
	          return (0, _effects.fork)(_getGuardianDependents.watcher);
	
	        case 64:
	          _context.next = 66;
	          return (0, _effects.fork)(_myProfileRedirect.profileRedirectSaga);
	
	        case 66:
	          _context.next = 68;
	          return (0, _effects.fork)(_handleDocumentsErrorSaga2.default);
	
	        case 68:
	          _context.next = 70;
	          return (0, _effects.fork)(_publicProfileRedirect.publicProfileRedirectSaga);
	
	        case 70:
	          _context.next = 72;
	          return (0, _effects.fork)(profileEditable.watcher);
	
	        case 72:
	          _context.next = 74;
	          return (0, _effects.fork)(_userSaga.userSaga);
	
	        case 74:
	          _context.next = 76;
	          return (0, _effects.fork)(_mfaConfirmations.watcher);
	
	        case 76:
	          _context.next = 78;
	          return (0, _effects.fork)(_mfaEnable.watcher);
	
	        case 78:
	          _context.next = 80;
	          return (0, _effects.fork)(_mfaDisable.watcher);
	
	        case 80:
	          _context.next = 82;
	          return (0, _effects.fork)(_mfaNotice.watcher);
	
	        case 82:
	          _context.next = 84;
	          return (0, _effects.fork)(_vitalsActivityReq.watcher);
	
	        case 84:
	          _context.next = 86;
	          return (0, _effects.fork)(_bodyTemperatureMeasurementsReq.watcher);
	
	        case 86:
	          _context.next = 88;
	          return (0, _effects.fork)(_bodyTemperatureMeasurementsModalReq.watcher);
	
	        case 88:
	          _context.next = 90;
	          return (0, _effects.fork)(_bodySurfaceAreaMeasurementsReq.watcher);
	
	        case 90:
	          _context.next = 92;
	          return (0, _effects.fork)(_bodySurfaceAreaMeasurementsModalReq.watcher);
	
	        case 92:
	          _context.next = 94;
	          return (0, _effects.fork)(_heartRateMeasurementsReq.watcher);
	
	        case 94:
	          _context.next = 96;
	          return (0, _effects.fork)(_heartRateMeasurementsModalReq.watcher);
	
	        case 96:
	          _context.next = 98;
	          return (0, _effects.fork)(_saturationMeasurementsReq.watcher);
	
	        case 98:
	          _context.next = 100;
	          return (0, _effects.fork)(_saturationMeasurementsModalReq.watcher);
	
	        case 100:
	          _context.next = 102;
	          return (0, _effects.fork)(_bloodPressureMeasurementsReq.watcher);
	
	        case 102:
	          _context.next = 104;
	          return (0, _effects.fork)(_bloodPressureMeasurementsModalReq.watcher);
	
	        case 104:
	          _context.next = 106;
	          return (0, _effects.fork)(_respiratoryRateMeasurementsReq.watcher);
	
	        case 106:
	          _context.next = 108;
	          return (0, _effects.fork)(_respiratoryRateMeasurementsModalReq.watcher);
	
	        case 108:
	          _context.next = 110;
	          return (0, _effects.fork)(_distanceMeasurementsReq.watcher);
	
	        case 110:
	          _context.next = 112;
	          return (0, _effects.fork)(_distanceMeasurementsModalReq.watcher);
	
	        case 112:
	          _context.next = 114;
	          return (0, _effects.fork)(_stepsMeasurementsReq.watcher);
	
	        case 114:
	          _context.next = 116;
	          return (0, _effects.fork)(_stepsMeasurementsModalReq.watcher);
	
	        case 116:
	          _context.next = 118;
	          return (0, _effects.fork)(_bmiMeasurementsReq.watcher);
	
	        case 118:
	          _context.next = 120;
	          return (0, _effects.fork)(_bmiMeasurementsModalReq.watcher);
	
	        case 120:
	          _context.next = 122;
	          return (0, _effects.fork)(_bloodGlucoseMeasurementsReq.watcher);
	
	        case 122:
	          _context.next = 124;
	          return (0, _effects.fork)(_bloodGlucoseMeasurementsModalReq.watcher);
	
	        case 124:
	          _context.next = 126;
	          return (0, _effects.fork)(_weightMeasurementsReq.watcher);
	
	        case 126:
	          _context.next = 128;
	          return (0, _effects.fork)(_weightMeasurementsModalReq.watcher);
	
	        case 128:
	          _context.next = 130;
	          return (0, _effects.fork)(_heightMeasurementsReq.watcher);
	
	        case 130:
	          _context.next = 132;
	          return (0, _effects.fork)(_heightMeasurementsModalReq.watcher);
	
	        case 132:
	          _context.next = 134;
	          return (0, _effects.fork)(_historicMeasurementsReq.watcher);
	
	        case 134:
	          _context.next = 136;
	          return (0, _effects.fork)(_addWeightData.watcher);
	
	        case 136:
	          _context.next = 138;
	          return (0, _effects.fork)(_addHeightData.watcher);
	
	        case 138:
	          _context.next = 140;
	          return (0, _effects.fork)(_handleAddWeightHeightSaga.handleAddWeightHeightSaga);
	
	        case 140:
	          _context.next = 142;
	          return (0, _effects.fork)(_connectedDevices.watcher);
	
	        case 142:
	          _context.next = 144;
	          return (0, _effects.fork)(_providerAuthentications.watcher);
	
	        case 144:
	          _context.next = 146;
	          return (0, _effects.fork)(_providerList.watcher);
	
	        case 146:
	          _context.next = 148;
	          return (0, _effects.fork)(_removeAccount.watcher);
	
	        case 148:
	          _context.next = 150;
	          return (0, _effects.fork)(_manageDeviceAccountSaga.manageDeviceAccountSaga);
	
	        case 150:
	          _context.next = 152;
	          return (0, _effects.fork)(_changeProfileReq.watcher);
	
	        case 152:
	          _context.next = 154;
	          return (0, _effects.fork)(_deleteUserAttachment.watcher);
	
	        case 154:
	          _context.next = 156;
	          return (0, _effects.fork)(_deleteUserOutcomeAttachment.watcher);
	
	        case 156:
	          _context.next = 158;
	          return (0, _effects.fork)(_insuranceEligibilityManualActivations.watcher);
	
	        case 158:
	          _context.next = 160;
	          return (0, _effects.fork)(_editPatientEmergencyContact.watcher);
	
	        case 160:
	          _context.next = 162;
	          return (0, _effects.fork)(_patientInsuranceCard.watchChangePatientInsuranceCard);
	
	        case 162:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.watchChangePatientInsuranceCard = watchChangePatientInsuranceCard;
	
	var _effects = __webpack_require__(14);
	
	var _constants = __webpack_require__(17);
	
	var _updatePatientInsurance = __webpack_require__(350);
	
	var _scheduledTasksUpcomingReq = __webpack_require__(303);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleChangePatientInsuranceCard),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchChangePatientInsuranceCard);
	
	function handleChangePatientInsuranceCard(_ref) {
	  var payload = _ref.payload;
	  var status, frontSide, backSide, id;
	  return _regenerator2.default.wrap(function handleChangePatientInsuranceCard$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          status = payload.status, frontSide = payload.frontSide, backSide = payload.backSide, id = payload.id;
	
	          if (!(status === _constants.PATIENT_INSURANCE_STATUS.DRAFT)) {
	            _context.next = 4;
	            break;
	          }
	
	          _context.next = 4;
	          return (0, _effects.put)(_scheduledTasksUpcomingReq.actions.updateInsuranceCardForToDoTask({
	            id: id,
	            frontSide: frontSide,
	            backSide: backSide
	          }));
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function watchChangePatientInsuranceCard() {
	  return _regenerator2.default.wrap(function watchChangePatientInsuranceCard$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_updatePatientInsurance.actions.succeed, handleChangePatientInsuranceCard);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.updateAttachmentsSaga = updateAttachmentsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _getUserAttachment = __webpack_require__(877);
	
	var _deleteUserAttachment = __webpack_require__(871);
	
	var _deleteUserOutcomeAttachment = __webpack_require__(872);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateDocumentsWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateAttachmentsSaga);
	
	function updateDocumentsWorker(action) {
	  var payload, uniqId;
	  return _regenerator2.default.wrap(function updateDocumentsWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          uniqId = payload.uniqId;
	          _context.next = 4;
	          return (0, _effects.put)(_getUserAttachment.actions.deleteItem({ uniqId: uniqId }));
	
	        case 4:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateAttachmentsSaga() {
	  return _regenerator2.default.wrap(function updateAttachmentsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_deleteUserAttachment.consts.SEND, _deleteUserOutcomeAttachment.consts.SEND], updateDocumentsWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.updateAvatarSaga = updateAvatarSaga;
	
	var _effects = __webpack_require__(14);
	
	var _editAvatar = __webpack_require__(873);
	
	var _editUser = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateAvatarWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateAvatarSaga);
	
	function updateAvatarWorker(action) {
	  return _regenerator2.default.wrap(function updateAvatarWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)({
	            type: _editUser.consts.SUCCEED,
	            payload: action.payload
	          });
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateAvatarSaga() {
	  return _regenerator2.default.wrap(function updateAvatarSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_editAvatar.consts.SUCCEED], updateAvatarWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.updateDocumentsSaga = updateDocumentsSaga;
	
	var _effects = __webpack_require__(14);
	
	var _getUserDocuments = __webpack_require__(425);
	
	var _deleteUserDocuments = __webpack_require__(422);
	
	var _updateUserDocuments = __webpack_require__(540);
	
	var _uploadUserDocuments = __webpack_require__(429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateDocumentsWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateDocumentsSaga);
	
	function updateDocumentsWorker(action) {
	  var type, payload, id;
	  return _regenerator2.default.wrap(function updateDocumentsWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          type = action.type, payload = action.payload;
	          id = payload.id;
	
	          if (!(type === _deleteUserDocuments.consts.SEND)) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 5;
	          return (0, _effects.take)(_deleteUserDocuments.consts.SUCCEED);
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)(_getUserDocuments.actions.deleteItem({ id: id }));
	
	        case 7:
	          _context.next = 11;
	          break;
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)(_getUserDocuments.actions.updateList(payload));
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateDocumentsSaga() {
	  return _regenerator2.default.wrap(function updateDocumentsSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_uploadUserDocuments.consts.SUCCEED, _updateUserDocuments.consts.SUCCEED, _deleteUserDocuments.consts.SEND], updateDocumentsWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.updateProfileSaga = updateProfileSaga;
	
	var _effects = __webpack_require__(14);
	
	var _confirmMobilePhone = __webpack_require__(678);
	
	var _selectors = __webpack_require__(23);
	
	var _getUser = __webpack_require__(202);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateProfileWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updateProfileSaga);
	
	function updateProfileWorker() {
	  var id;
	  return _regenerator2.default.wrap(function updateProfileWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 2:
	          id = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)({
	            type: _getUser.consts.SEND,
	            payload: { id: id }
	          });
	
	        case 5:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updateProfileSaga() {
	  return _regenerator2.default.wrap(function updateProfileSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)([_confirmMobilePhone.consts.SUCCEED], updateProfileWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.userSaga = userSaga;
	
	var _effects = __webpack_require__(14);
	
	var _getUser = __webpack_require__(202);
	
	var getUser = _interopRequireWildcard(_getUser);
	
	var _profileEditableReq = __webpack_require__(686);
	
	var profileEditable = _interopRequireWildcard(_profileEditableReq);
	
	var _getAccessLevels = __webpack_require__(426);
	
	var getAccessLevel = _interopRequireWildcard(_getAccessLevels);
	
	var _selectors = __webpack_require__(115);
	
	var _routes = __webpack_require__(37);
	
	var _loggedUser = __webpack_require__(523);
	
	var _targetUser = __webpack_require__(415);
	
	var _mfaConfirmations = __webpack_require__(681);
	
	var _mfaEnable = __webpack_require__(879);
	
	var enableMfa = _interopRequireWildcard(_mfaEnable);
	
	var _mfaDisable = __webpack_require__(878);
	
	var disableMfa = _interopRequireWildcard(_mfaDisable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(userSagaWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleMfaCleanup),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(userSaga),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleMfaChange);
	
	function userSagaWorker(_ref) {
	  var payload = _ref.payload;
	  var currentLocation;
	  return _regenerator2.default.wrap(function userSagaWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(profileEditable.actions.send({ userId: payload.id }));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.select)(_selectors.currentLocationSelector);
	
	        case 4:
	          currentLocation = _context.sent;
	
	          if (!(currentLocation === '/' + _routes.MESSAGES)) {
	            _context.next = 8;
	            break;
	          }
	
	          _context.next = 8;
	          return (0, _effects.put)(getAccessLevel.actions.send({ id: payload.id }));
	
	        case 8:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleMfaCleanup(_ref2) {
	  var payload = _ref2.payload;
	  return _regenerator2.default.wrap(function handleMfaCleanup$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          if (!payload.mfaEnabled) {
	            _context2.next = 3;
	            break;
	          }
	
	          _context2.next = 3;
	          return (0, _effects.put)(_mfaConfirmations.actions.clear());
	
	        case 3:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function userSaga() {
	  return _regenerator2.default.wrap(function userSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)(getUser.consts.SUCCEED, userSagaWorker);
	
	        case 2:
	          _context3.next = 4;
	          return (0, _effects.takeLatest)(getUser.consts.SUCCEED, handleMfaCleanup);
	
	        case 4:
	          _context3.next = 6;
	          return (0, _effects.takeLatest)([enableMfa.consts.SUCCEED, disableMfa.consts.SUCCEED], handleMfaChange);
	
	        case 6:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function handleMfaChange(_ref3) {
	  var payload = _ref3.payload;
	  return _regenerator2.default.wrap(function handleMfaChange$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.put)(_loggedUser.actions.update(payload));
	
	        case 2:
	          _context4.next = 4;
	          return (0, _effects.put)(_targetUser.actions.update(payload));
	
	        case 4:
	          _context4.next = 6;
	          return (0, _effects.put)(_mfaConfirmations.actions.clear());
	
	        case 6:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}

/***/ }),
/* 4156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _joinedPrograms = __webpack_require__(891);
	
	var _joinedPrograms2 = _interopRequireDefault(_joinedPrograms);
	
	var _invitations = __webpack_require__(1901);
	
	var _invitations2 = _interopRequireDefault(_invitations);
	
	var _acceptConsent = __webpack_require__(890);
	
	var _acceptConsent2 = _interopRequireDefault(_acceptConsent);
	
	var _declineInvitation = __webpack_require__(689);
	
	var _declineInvitation2 = _interopRequireDefault(_declineInvitation);
	
	var _acceptInvitation = __webpack_require__(687);
	
	var _acceptInvitation2 = _interopRequireDefault(_acceptInvitation);
	
	var _leaveProgram = __webpack_require__(892);
	
	var _leaveProgram2 = _interopRequireDefault(_leaveProgram);
	
	var _availablePrograms = __webpack_require__(1900);
	
	var _availablePrograms2 = _interopRequireDefault(_availablePrograms);
	
	var _assignPrograms = __webpack_require__(1356);
	
	var _assignPrograms2 = _interopRequireDefault(_assignPrograms);
	
	var _accountVaults = __webpack_require__(688);
	
	var _accountVaults2 = _interopRequireDefault(_accountVaults);
	
	var _paymentInfoModal = __webpack_require__(541);
	
	var _paymentInfoModal2 = _interopRequireDefault(_paymentInfoModal);
	
	var _accountVaultsForm = __webpack_require__(354);
	
	var _accountVaultsForm2 = _interopRequireDefault(_accountVaultsForm);
	
	var _submitPaymentProgram = __webpack_require__(893);
	
	var _submitPaymentProgram2 = _interopRequireDefault(_submitPaymentProgram);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  joinedPrograms: _joinedPrograms2.default,
	  invitations: _invitations2.default,
	  acceptConsent: _acceptConsent2.default,
	  acceptInvitation: _acceptInvitation2.default,
	  declineInvitation: _declineInvitation2.default,
	  leaveProgram: _leaveProgram2.default,
	  availablePrograms: _availablePrograms2.default,
	  assignPrograms: _assignPrograms2.default,
	  accountVaults: _accountVaults2.default,
	  accountVaultsForm: _accountVaultsForm2.default,
	  paymentInfoModal: _paymentInfoModal2.default,
	  submitPaymentProgram: _submitPaymentProgram2.default
	});

/***/ }),
/* 4157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.updateTodos = updateTodos;
	exports.updatePrograms = updatePrograms;
	exports.handleError = handleError;
	exports.programSagas = programSagas;
	
	var _get2 = __webpack_require__(4);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _reactRouter = __webpack_require__(42);
	
	var _effects = __webpack_require__(14);
	
	var _updateDeep = __webpack_require__(1941);
	
	var _errors = __webpack_require__(120);
	
	var _index = __webpack_require__(17);
	
	var _programs = __webpack_require__(618);
	
	var _selectors = __webpack_require__(23);
	
	var _selectors2 = __webpack_require__(64);
	
	var _accountVaults = __webpack_require__(688);
	
	var _accountVaultsForm = __webpack_require__(354);
	
	var _selectors3 = __webpack_require__(264);
	
	var _error = __webpack_require__(101);
	
	var _success = __webpack_require__(104);
	
	var _activeTodo = __webpack_require__(843);
	
	var _paymentInfoModal = __webpack_require__(541);
	
	var _joinedPrograms = __webpack_require__(891);
	
	var _scheduledTasksUpcomingReq = __webpack_require__(303);
	
	var _leaveProgram = __webpack_require__(892);
	
	var _acceptConsent = __webpack_require__(890);
	
	var _acceptInvitation = __webpack_require__(687);
	
	var _declineInvitation = __webpack_require__(689);
	
	var _popup = __webpack_require__(76);
	
	var _props = __webpack_require__(41);
	
	var _submitPaymentProgram = __webpack_require__(893);
	
	var _selectors4 = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(updateTodos),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(updatePrograms),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleError),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(leaveProgramWorker),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(acceptInvitationWorker),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(declineInvitationWorker),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(acceptConsentWorker),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(payaProgramPaymentSaga),
	    _marked9 = /*#__PURE__*/_regenerator2.default.mark(programSagas);
	
	var ACTIVE = _programs.PROGRAM_COUNTERS[_programs.PROGRAM_TYPE.ACTIVE];
	var HISTORY = _programs.PROGRAM_COUNTERS[_programs.PROGRAM_TYPE.HISTORY];
	var INVITES = _programs.PROGRAM_COUNTERS[_programs.PROGRAM_TYPE.INVITES];
	var ALREADY_COMPLETED = _errors.PROGRAM_ERRORS.ALREADY_COMPLETED,
	    INVITATION_REMOVED = _errors.PROGRAM_ERRORS.INVITATION_REMOVED;
	
	/** ============================================
	 *  COMMON
	 *  ============================================ */
	
	function updateTodos(id) {
	  var payload;
	  return _regenerator2.default.wrap(function updateTodos$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = { id: id, type: _index.TODO_TYPES.PROGRAM };
	          _context.next = 3;
	          return (0, _effects.put)(_scheduledTasksUpcomingReq.actions.removeEntity(payload));
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.put)(_activeTodo.activeTodoActions.setActiveItem(null));
	
	        case 5:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function updatePrograms(id, _ref) {
	  var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	      from = _ref2[0],
	      into = _ref2[1];
	
	  var programs, counters, list, meta;
	  return _regenerator2.default.wrap(function updatePrograms$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors3.joinedProgramsListSelector);
	
	        case 2:
	          programs = _context2.sent;
	          _context2.next = 5;
	          return (0, _effects.select)(_selectors3.joinedProgramsMetaSelector);
	
	        case 5:
	          counters = _context2.sent;
	          list = programs.filter(function (program) {
	            return program.id !== id;
	          });
	          meta = (0, _extends3.default)({}, counters, into && (0, _defineProperty3.default)({}, into, counters[into] + 1), from && (0, _defineProperty3.default)({}, from, counters[from] - 1));
	          _context2.next = 10;
	          return (0, _effects.put)(_joinedPrograms.actions.succeed(list));
	
	        case 10:
	          _context2.next = 12;
	          return (0, _effects.put)(_joinedPrograms.actions.addMeta(meta));
	
	        case 12:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleError(_ref5) {
	  var error = _ref5.error,
	      payload = _ref5.payload,
	      purchaseAgain = _ref5.purchaseAgain;
	
	  var _get, code, todoId, programId, invitationId;
	
	  return _regenerator2.default.wrap(function handleError$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _get = (0, _extends3.default)({}, (0, _get3.default)(error, 'payload.error')), code = _get.code;
	          todoId = payload.todoId, programId = payload.programId, invitationId = payload.invitationId;
	
	          if (!(code === ALREADY_COMPLETED)) {
	            _context3.next = 12;
	            break;
	          }
	
	          if (!todoId) {
	            _context3.next = 8;
	            break;
	          }
	
	          _context3.next = 6;
	          return updateTodos(invitationId);
	
	        case 6:
	          _context3.next = 10;
	          break;
	
	        case 8:
	          _context3.next = 10;
	          return updatePrograms(programId, [purchaseAgain ? HISTORY : INVITES, ACTIVE]);
	
	        case 10:
	          _context3.next = 12;
	          return (0, _effects.put)(_error.actions.update({
	            id: 'program.invite.notification.completed'
	          }));
	
	        case 12:
	          if (!(code === INVITATION_REMOVED)) {
	            _context3.next = 22;
	            break;
	          }
	
	          if (!todoId) {
	            _context3.next = 18;
	            break;
	          }
	
	          _context3.next = 16;
	          return updateTodos(invitationId);
	
	        case 16:
	          _context3.next = 20;
	          break;
	
	        case 18:
	          _context3.next = 20;
	          return updatePrograms(programId, [INVITES]);
	
	        case 20:
	          _context3.next = 22;
	          return (0, _effects.put)(_error.actions.update({
	            id: 'program.invite.notification.removed'
	          }));
	
	        case 22:
	          if (code) {
	            _context3.next = 25;
	            break;
	          }
	
	          _context3.next = 25;
	          return (0, _effects.put)(_error.actions.update({
	            id: 'errors.common'
	          }));
	
	        case 25:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	/** ============================================
	 *  LEAVE
	 *  ============================================ */
	
	function leaveProgramWorker(_ref6) {
	  var payload = _ref6.payload;
	  var programId, mainUserId, targetUser;
	  return _regenerator2.default.wrap(function leaveProgramWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          programId = payload.programId;
	          _context4.next = 3;
	          return (0, _effects.put)(_leaveProgram.actions.send(payload));
	
	        case 3:
	          _context4.next = 5;
	          return (0, _effects.take)(_leaveProgram.consts.SUCCEED);
	
	        case 5:
	          _context4.next = 7;
	          return updatePrograms(programId, [ACTIVE, HISTORY]);
	
	        case 7:
	          _context4.next = 9;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 9:
	          mainUserId = _context4.sent;
	          _context4.next = 12;
	          return (0, _effects.select)(_selectors.targetUserSelector);
	
	        case 12:
	          targetUser = _context4.sent;
	          _context4.next = 15;
	          return (0, _effects.put)((0, _extends3.default)({
	            type: _success.consts.UPDATE
	          }, mainUserId === targetUser.id ? {
	            payload: {
	              id: 'programs.remove.message'
	            }
	          } : {
	            payload: {
	              id: 'programs.remove.message.ar'
	            },
	            values: {
	              dependentName: targetUser.displayableName
	            }
	          }));
	
	        case 15:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	/** ============================================
	 *  ACCEPT
	 *  ============================================ */
	
	function acceptInvitationWorker(_ref7) {
	  var payload = _ref7.payload;
	
	  var userId, todoId, programId, prepayFlow, programName, invitationId, purchaseAgain, duePaymentDate, organizationId, withSubscription, prepaidByProvider, subscriptionsSetting, mainUserId, targetUser, _ref8, successAccountVaults, errorAccountVaults, _ref9, error;
	
	  return _regenerator2.default.wrap(function acceptInvitationWorker$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          userId = payload.userId, todoId = payload.todoId, programId = payload.programId, prepayFlow = payload.prepayFlow, programName = payload.programName, invitationId = payload.invitationId, purchaseAgain = payload.purchaseAgain, duePaymentDate = payload.duePaymentDate, organizationId = payload.organizationId, withSubscription = payload.withSubscription, prepaidByProvider = payload.prepaidByProvider, subscriptionsSetting = payload.subscriptionsSetting;
	          _context5.next = 3;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 3:
	          mainUserId = _context5.sent;
	          _context5.next = 6;
	          return (0, _effects.select)(_selectors.targetUserSelector);
	
	        case 6:
	          targetUser = _context5.sent;
	
	          if (!(withSubscription && !prepaidByProvider)) {
	            _context5.next = 30;
	            break;
	          }
	
	          _context5.next = 10;
	          return (0, _effects.put)(_accountVaults.actions.send({
	            userId: mainUserId,
	            subjectId: programId,
	            subjectType: _index.SUBSCRIBABLE_TYPE.PROGRAM
	          }));
	
	        case 10:
	          _context5.next = 12;
	          return (0, _effects.race)({
	            successAccountVaults: (0, _effects.take)(_accountVaults.consts.SUCCEED),
	            errorAccountVaults: (0, _effects.take)(_accountVaults.consts.REJECTED)
	          });
	
	        case 12:
	          _ref8 = _context5.sent;
	          successAccountVaults = _ref8.successAccountVaults;
	          errorAccountVaults = _ref8.errorAccountVaults;
	
	          if (!(successAccountVaults && successAccountVaults.payload.length !== 0)) {
	            _context5.next = 18;
	            break;
	          }
	
	          _context5.next = 18;
	          return (0, _effects.put)(_paymentInfoModal.paymentInfoModalActions.open({
	            subscriptionsSetting: subscriptionsSetting,
	            programId: programId,
	            userId: userId,
	            todoId: todoId,
	            prepayFlow: prepayFlow,
	            mainUserId: mainUserId,
	            programName: programName,
	            invitationId: invitationId,
	            organizationId: organizationId,
	            purchaseAgain: purchaseAgain,
	            duePaymentDate: duePaymentDate
	          }));
	
	        case 18:
	          if (!(successAccountVaults && successAccountVaults.payload.length === 0)) {
	            _context5.next = 25;
	            break;
	          }
	
	          _context5.next = 21;
	          return (0, _effects.put)(_accountVaultsForm.actions.send({ userId: mainUserId, programId: programId }));
	
	        case 21:
	          _context5.next = 23;
	          return (0, _effects.put)(_paymentInfoModal.paymentInfoModalActions.open({
	            subscriptionsSetting: subscriptionsSetting,
	            programName: programName,
	            programId: programId,
	            userId: userId,
	            todoId: todoId,
	            prepayFlow: prepayFlow,
	            mainUserId: mainUserId,
	            invitationId: invitationId,
	            organizationId: organizationId,
	            purchaseAgain: purchaseAgain,
	            duePaymentDate: duePaymentDate
	          }));
	
	        case 23:
	          _context5.next = 25;
	          return (0, _effects.put)({
	            type: _popup.consts.SHOW,
	            payload: {
	              contentType: _props.UI_POPUP_TYPES.PAYA_ACCOUNT_FORM,
	              contentOptions: {
	                noCards: true
	              }
	            }
	          });
	
	        case 25:
	          if (!errorAccountVaults) {
	            _context5.next = 28;
	            break;
	          }
	
	          _context5.next = 28;
	          return (0, _effects.put)(_error.actions.update({
	            id: 'errors.common'
	          }));
	
	        case 28:
	          _context5.next = 32;
	          break;
	
	        case 30:
	          _context5.next = 32;
	          return (0, _effects.put)(_acceptInvitation.actions.send(payload));
	
	        case 32:
	          _context5.next = 34;
	          return (0, _effects.race)({
	            error: (0, _effects.take)(_acceptInvitation.consts.REJECTED),
	            success: (0, _effects.take)(_acceptInvitation.consts.SUCCEED)
	          });
	
	        case 34:
	          _ref9 = _context5.sent;
	          error = _ref9.error;
	
	          if (!error) {
	            _context5.next = 40;
	            break;
	          }
	
	          _context5.next = 39;
	          return handleError({ error: error, payload: payload, purchaseAgain: purchaseAgain });
	
	        case 39:
	          return _context5.abrupt('return');
	
	        case 40:
	          if (!todoId) {
	            _context5.next = 45;
	            break;
	          }
	
	          _context5.next = 43;
	          return updateTodos(invitationId);
	
	        case 43:
	          _context5.next = 47;
	          break;
	
	        case 45:
	          _context5.next = 47;
	          return updatePrograms(programId, [purchaseAgain ? HISTORY : INVITES, ACTIVE]);
	
	        case 47:
	          _context5.next = 49;
	          return (0, _effects.put)((0, _extends3.default)({
	            type: _success.consts.UPDATE
	          }, mainUserId === userId ? {
	            payload: {
	              id: 'program.invite.notification.joined'
	            }
	          } : {
	            payload: {
	              id: 'program.invite.notification.joinedAR'
	            },
	            values: {
	              dependentName: targetUser.displayableName
	            }
	          }));
	
	        case 49:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	/** ============================================
	 *  DECLINE
	 *  ============================================ */
	
	function declineInvitationWorker(_ref10) {
	  var payload = _ref10.payload;
	
	  var todoId, programId, invitationId, _ref11, error;
	
	  return _regenerator2.default.wrap(function declineInvitationWorker$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          todoId = payload.todoId, programId = payload.programId, invitationId = payload.invitationId;
	          _context6.next = 3;
	          return (0, _effects.put)(_declineInvitation.actions.send(payload));
	
	        case 3:
	          _context6.next = 5;
	          return (0, _effects.race)({
	            error: (0, _effects.take)(_declineInvitation.consts.REJECTED),
	            success: (0, _effects.take)(_declineInvitation.consts.SUCCEED)
	          });
	
	        case 5:
	          _ref11 = _context6.sent;
	          error = _ref11.error;
	
	          if (!error) {
	            _context6.next = 11;
	            break;
	          }
	
	          _context6.next = 10;
	          return handleError({ error: error, payload: payload });
	
	        case 10:
	          return _context6.abrupt('return');
	
	        case 11:
	          if (!todoId) {
	            _context6.next = 16;
	            break;
	          }
	
	          _context6.next = 14;
	          return updateTodos(invitationId);
	
	        case 14:
	          _context6.next = 18;
	          break;
	
	        case 16:
	          _context6.next = 18;
	          return updatePrograms(programId, [INVITES]);
	
	        case 18:
	          _context6.next = 20;
	          return (0, _effects.put)(_error.actions.update({
	            id: 'program.invite.notification.declined'
	          }));
	
	        case 20:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	/** ============================================
	 *  CONSENTS
	 *  ============================================ */
	
	function acceptConsentWorker(_ref12) {
	  var payload = _ref12.payload;
	
	  var userId, tId, pId, cId, _ref13, consent, todos, path, list, programs, counters, _path, _list;
	
	  return _regenerator2.default.wrap(function acceptConsentWorker$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 2:
	          userId = _context7.sent;
	          tId = payload.todoId, pId = payload.programId, cId = payload.consentId;
	          _context7.next = 6;
	          return (0, _effects.put)(_acceptConsent.actions.send((0, _extends3.default)({}, payload, { userId: userId })));
	
	        case 6:
	          _context7.next = 8;
	          return (0, _effects.take)(_acceptConsent.consts.SUCCEED);
	
	        case 8:
	          _ref13 = _context7.sent;
	          consent = _ref13.payload;
	
	          if (!tId) {
	            _context7.next = 20;
	            break;
	          }
	
	          _context7.next = 13;
	          return (0, _effects.select)(_selectors2.selectScheduledTasks);
	
	        case 13:
	          todos = _context7.sent;
	          path = [{ id: tId }, 'payload', 'consents', { id: cId }];
	          list = (0, _updateDeep.updateDeep)(todos, path, function () {
	            return consent;
	          });
	          _context7.next = 18;
	          return (0, _effects.put)(_scheduledTasksUpcomingReq.actions.succeed(list));
	
	        case 18:
	          _context7.next = 32;
	          break;
	
	        case 20:
	          _context7.next = 22;
	          return (0, _effects.select)(_selectors3.joinedProgramsListSelector);
	
	        case 22:
	          programs = _context7.sent;
	          _context7.next = 25;
	          return (0, _effects.select)(_selectors3.joinedProgramsMetaSelector);
	
	        case 25:
	          counters = _context7.sent;
	          _path = [{ id: pId }, 'patientInvitation', 'consents', { id: cId }];
	          _list = (0, _updateDeep.updateDeep)(programs, _path, function () {
	            return consent;
	          });
	          _context7.next = 30;
	          return (0, _effects.put)(_joinedPrograms.actions.succeed(_list));
	
	        case 30:
	          _context7.next = 32;
	          return (0, _effects.put)(_joinedPrograms.actions.addMeta(counters));
	
	        case 32:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	/** ============================================
	 *  PAYA PAYMENT SAGA
	 *  ============================================ */
	
	function payaProgramPaymentSaga() {
	  var mainUserId, targetUser, _ref14, success, error, todoId, programId, userId, invitationId, purchaseAgain, prepayFlow, pathname, _ref15, succeed, rejected, programName;
	
	  return _regenerator2.default.wrap(function payaProgramPaymentSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.select)(_selectors.loggedUserIdSelector);
	
	        case 2:
	          mainUserId = _context8.sent;
	          _context8.next = 5;
	          return (0, _effects.select)(_selectors.targetUserSelector);
	
	        case 5:
	          targetUser = _context8.sent;
	          _context8.next = 8;
	          return (0, _effects.race)({
	            success: (0, _effects.take)(_submitPaymentProgram.consts.SUCCEED),
	            error: (0, _effects.take)([_submitPaymentProgram.consts.REJECTED, _submitPaymentProgram.consts.ERROR_ENCOUNTERED])
	          });
	
	        case 8:
	          _ref14 = _context8.sent;
	          success = _ref14.success;
	          error = _ref14.error;
	          _context8.next = 13;
	          return (0, _effects.select)(_selectors3.selectPaymentInfoModalToDoId);
	
	        case 13:
	          todoId = _context8.sent;
	          _context8.next = 16;
	          return (0, _effects.select)(_selectors3.selectPaymentInfoModalProgramId);
	
	        case 16:
	          programId = _context8.sent;
	          _context8.next = 19;
	          return (0, _effects.select)(_selectors3.selectPaymentInfoModalUserId);
	
	        case 19:
	          userId = _context8.sent;
	          _context8.next = 22;
	          return (0, _effects.select)(_selectors3.selectPaymentInfoModalInvitationId);
	
	        case 22:
	          invitationId = _context8.sent;
	          _context8.next = 25;
	          return (0, _effects.select)(_selectors3.selectPaymentInfoModalPurchaseAgain);
	
	        case 25:
	          purchaseAgain = _context8.sent;
	          _context8.next = 28;
	          return (0, _effects.select)(_selectors3.selectPaymentInfoModalPrepayFlow);
	
	        case 28:
	          prepayFlow = _context8.sent;
	          _context8.next = 31;
	          return (0, _effects.select)(_selectors4.currentLocationSelector);
	
	        case 31:
	          pathname = _context8.sent;
	
	          if (!error) {
	            _context8.next = 38;
	            break;
	          }
	
	          _context8.next = 35;
	          return handleError({ error: error, payload: { programId: programId, userId: userId, todoId: todoId } });
	
	        case 35:
	          _context8.next = 37;
	          return (0, _effects.put)(_paymentInfoModal.paymentInfoModalActions.clearWaitingPayaPaymentResponse());
	
	        case 37:
	          return _context8.abrupt('return');
	
	        case 38:
	          if (!success) {
	            _context8.next = 74;
	            break;
	          }
	
	          _context8.next = 41;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(_paymentInfoModal.PAYMENT_INFO_MODAL.RECEIVED_PAYA_PAYMENT_SUCCESS_RESPONSE),
	            rejected: (0, _effects.take)(_paymentInfoModal.PAYMENT_INFO_MODAL.RECEIVED_PAYA_PAYMENT_ERROR_RESPONSE)
	          });
	
	        case 41:
	          _ref15 = _context8.sent;
	          succeed = _ref15.succeed;
	          rejected = _ref15.rejected;
	          _context8.next = 46;
	          return (0, _effects.put)(_paymentInfoModal.paymentInfoModalActions.clearWaitingPayaPaymentResponse());
	
	        case 46:
	          if (!succeed) {
	            _context8.next = 72;
	            break;
	          }
	
	          _context8.next = 49;
	          return (0, _effects.select)(_selectors3.selectPaymentInfoModalProgramName);
	
	        case 49:
	          programName = _context8.sent;
	
	          if (!todoId) {
	            _context8.next = 55;
	            break;
	          }
	
	          _context8.next = 53;
	          return updateTodos(invitationId);
	
	        case 53:
	          _context8.next = 58;
	          break;
	
	        case 55:
	          if (prepayFlow) {
	            _context8.next = 58;
	            break;
	          }
	
	          _context8.next = 58;
	          return updatePrograms(programId, [purchaseAgain ? HISTORY : INVITES, ACTIVE]);
	
	        case 58:
	
	          if (purchaseAgain) _reactRouter.browserHistory.push({ pathname: pathname, search: '?tab=active' });
	
	          _context8.next = 61;
	          return (0, _effects.put)(_paymentInfoModal.paymentInfoModalActions.close());
	
	        case 61:
	          if (!prepayFlow) {
	            _context8.next = 68;
	            break;
	          }
	
	          _context8.next = 64;
	          return (0, _effects.put)(_joinedPrograms.actions.send({
	            id: userId,
	            filterBy: _programs.PROGRAM_TYPE.ACTIVE
	          }));
	
	        case 64:
	          _context8.next = 66;
	          return (0, _effects.put)((0, _extends3.default)({
	            type: _success.consts.UPDATE
	          }, mainUserId === userId ? {
	            payload: {
	              id: 'program.membership.prepay.success'
	            }
	          } : {
	            payload: {
	              id: 'program.membership.prepay.dependent.success'
	            },
	            values: {
	              dependentName: targetUser.displayableName
	            }
	          }));
	
	        case 66:
	          _context8.next = 70;
	          break;
	
	        case 68:
	          _context8.next = 70;
	          return (0, _effects.put)({
	            type: _popup.consts.SHOW,
	            payload: {
	              contentType: _props.UI_POPUP_TYPES.PAYA_PAYMENT_HANDLE_RESPONSE,
	              contentOptions: (0, _extends3.default)({
	                success: true,
	                programName: programName
	              }, userId !== mainUserId && {
	                dependentName: targetUser.displayableName
	              })
	            }
	          });
	
	        case 70:
	          _context8.next = 74;
	          break;
	
	        case 72:
	          _context8.next = 74;
	          return (0, _effects.put)({
	            type: _popup.consts.SHOW,
	            payload: {
	              contentType: _props.UI_POPUP_TYPES.PAYA_PAYMENT_HANDLE_RESPONSE,
	              contentOptions: {
	                success: false,
	                errorMessage: rejected.payload.errorMessage
	              }
	            }
	          });
	
	        case 74:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}
	
	function programSagas() {
	  return _regenerator2.default.wrap(function programSagas$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _effects.takeLatest)([_leaveProgram.consts.INIT], leaveProgramWorker);
	
	        case 2:
	          _context9.next = 4;
	          return (0, _effects.takeLatest)([_acceptConsent.consts.INIT], acceptConsentWorker);
	
	        case 4:
	          _context9.next = 6;
	          return (0, _effects.takeLatest)([_acceptInvitation.consts.INIT], acceptInvitationWorker);
	
	        case 6:
	          _context9.next = 8;
	          return (0, _effects.takeLatest)([_declineInvitation.consts.INIT], declineInvitationWorker);
	
	        case 8:
	          _context9.next = 10;
	          return (0, _effects.takeLatest)([_submitPaymentProgram.actions.send], payaProgramPaymentSaga);
	
	        case 10:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked9, this);
	}

/***/ }),
/* 4158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _getIterator2 = __webpack_require__(1395);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = _callee;
	
	var _effects = __webpack_require__(14);
	
	var _rootSaga = __webpack_require__(3952);
	
	var _rootSaga2 = _interopRequireDefault(_rootSaga);
	
	var _reqAllUsers = __webpack_require__(637);
	
	var _reqRelatedUsers = __webpack_require__(813);
	
	var _reqNewChannel = __webpack_require__(812);
	
	var _reqSocialChannel = __webpack_require__(295);
	
	var _reqAssignPatient = __webpack_require__(638);
	
	var _reqAssignProvider = __webpack_require__(639);
	
	var _reqCircleOfCare = __webpack_require__(404);
	
	var _reqRelationshipPriority = __webpack_require__(814);
	
	var _reqFilters = __webpack_require__(811);
	
	var _reqInvitePatient = __webpack_require__(508);
	
	var _reqChangeChatName = __webpack_require__(809);
	
	var _reqMetadata = __webpack_require__(1250);
	
	var _reqChannels = __webpack_require__(1249);
	
	var _reqChannelParticipants = __webpack_require__(640);
	
	var _reqAddParticipants = __webpack_require__(1248);
	
	var _reqRemoveParticipant = __webpack_require__(1251);
	
	var _reqChannel = __webpack_require__(810);
	
	var _reqBlockUser = __webpack_require__(507);
	
	var _reqUnblockUser = __webpack_require__(509);
	
	var _createChatInboxTaskReq = __webpack_require__(1245);
	
	var _blockUserForDependent = __webpack_require__(633);
	
	var _unblockUserForDependent = __webpack_require__(642);
	
	var _dependentChannelParticipants = __webpack_require__(1246);
	
	var _sagas = __webpack_require__(3962);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _sagas3 = __webpack_require__(3986);
	
	var _sagas4 = _interopRequireDefault(_sagas3);
	
	var _downloadAttachment = __webpack_require__(3984);
	
	var _downloadAttachment2 = _interopRequireDefault(_downloadAttachment);
	
	var _uploadAttachment = __webpack_require__(3996);
	
	var _uploadAttachment2 = _interopRequireDefault(_uploadAttachment);
	
	var _sendMessage = __webpack_require__(1254);
	
	var _urlPreview = __webpack_require__(413);
	
	var _appStateReq = __webpack_require__(526);
	
	var _caregiver = __webpack_require__(297);
	
	var _memberFamilyCircle = __webpack_require__(647);
	
	var _myFamilyCircle = __webpack_require__(514);
	
	var _inviteToFamilyCircle = __webpack_require__(412);
	
	var _leaveFamilyCircle = __webpack_require__(298);
	
	var _acceptInviteToFamilyCircle = __webpack_require__(408);
	
	var _declineInviteToFamilyCircle = __webpack_require__(411);
	
	var _inviteCaregiver = __webpack_require__(513);
	
	var _inviteCaregiverFamily = __webpack_require__(646);
	
	var _removeCaregiver = __webpack_require__(649);
	
	var _acceptCaregiverRole = __webpack_require__(407);
	
	var _declineCaregiverRole = __webpack_require__(410);
	
	var _getGuardianCircle = __webpack_require__(644);
	
	var _removeAssignedProvider = __webpack_require__(515);
	
	var _inviteGuardian = __webpack_require__(645);
	
	var _removeGuardianRole = __webpack_require__(648);
	
	var _acceptGuardianRole = __webpack_require__(406);
	
	var _declineGuardianRole = __webpack_require__(409);
	
	var _cancelFamilyMemberInvitation = __webpack_require__(511);
	
	var _cancelCaregiverInvitation = __webpack_require__(510);
	
	var _cancelGuardianInvitationReq = __webpack_require__(816);
	
	var _circlesSaga = __webpack_require__(3998);
	
	var _circlesSaga2 = _interopRequireDefault(_circlesSaga);
	
	var _rootSaga3 = __webpack_require__(4002);
	
	var _rootSaga4 = _interopRequireDefault(_rootSaga3);
	
	var _loggedUserSagas = __webpack_require__(4045);
	
	var _targetUserSagas = __webpack_require__(4047);
	
	var _permissionsSaga = __webpack_require__(4046);
	
	var _teamUserSaga = __webpack_require__(4048);
	
	var _constants = __webpack_require__(1278);
	
	var _privacyPolicies = __webpack_require__(1281);
	
	var _caregiver2 = __webpack_require__(861);
	
	var _familyMember = __webpack_require__(862);
	
	var _guardian = __webpack_require__(863);
	
	var _declineInvitation = __webpack_require__(689);
	
	var _acceptInvitation = __webpack_require__(687);
	
	var _saga = __webpack_require__(4149);
	
	var _joinedPrograms = __webpack_require__(891);
	
	var _leaveProgram = __webpack_require__(892);
	
	var _accountVaults = __webpack_require__(688);
	
	var _accountVaultsForm = __webpack_require__(354);
	
	var _submitPaymentProgram = __webpack_require__(893);
	
	var _availablePrograms = __webpack_require__(1900);
	
	var _assignPrograms = __webpack_require__(1356);
	
	var _programSagas = __webpack_require__(4157);
	
	var _answered = __webpack_require__(355);
	
	var _submit = __webpack_require__(691);
	
	var _upcoming = __webpack_require__(309);
	
	var _forms = __webpack_require__(1367);
	
	var _sendSurvey = __webpack_require__(901);
	
	var _exportToPDF = __webpack_require__(899);
	
	var _submitReferralForm = __webpack_require__(692);
	
	var _reqReferralForms = __webpack_require__(1369);
	
	var _reqFormResult = __webpack_require__(1368);
	
	var _upcomingSurvey = __webpack_require__(433);
	
	var _upcomingSurveyProceed = __webpack_require__(694);
	
	var _upcomingSurveyAnswers = __webpack_require__(546);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _upcomingSurveyCancelFilling = __webpack_require__(693);
	
	var _appointmentConsentReq = __webpack_require__(898);
	
	var _getIncomingSurveysSaga = __webpack_require__(4173);
	
	var _submitReferralFormSaga = __webpack_require__(4179);
	
	var _sagas5 = __webpack_require__(4176);
	
	var _sagas6 = _interopRequireDefault(_sagas5);
	
	var _userCommunities = __webpack_require__(414);
	
	var _currentCommunityInfo = __webpack_require__(344);
	
	var _communityPreview = __webpack_require__(1258);
	
	var _communityPostsPreview = __webpack_require__(822);
	
	var _reqDiscoverCommunities = __webpack_require__(520);
	
	var _deletePost = __webpack_require__(826);
	
	var _communityPosts = __webpack_require__(650);
	
	var _communityMembers = __webpack_require__(516);
	
	var _membersListSaga = __webpack_require__(4020);
	
	var _communityModerators = __webpack_require__(517);
	
	var _moderatorsListSaga = __webpack_require__(4021);
	
	var _postDetails = __webpack_require__(238);
	
	var _createPost = __webpack_require__(823);
	
	var _editPost = __webpack_require__(827);
	
	var _leaveCommunity = __webpack_require__(651);
	
	var _removeUserCommunity = __webpack_require__(653);
	
	var _editComment = __webpack_require__(1878);
	
	var _postDetailsSaga = __webpack_require__(4022);
	
	var _currentCommunitySaga = __webpack_require__(4018);
	
	var _postsListSagas = __webpack_require__(4023);
	
	var _postsPreviewListSagas = __webpack_require__(4024);
	
	var _postComment = __webpack_require__(1264);
	
	var _deleteComment = __webpack_require__(1877);
	
	var _commentsListFetch = __webpack_require__(1257);
	
	var _likePost = __webpack_require__(1263);
	
	var _dislikePost = __webpack_require__(1260);
	
	var _reqJoinCommunity = __webpack_require__(521);
	
	var _getUserProfile = __webpack_require__(828);
	
	var _communitiesJoinRequests = __webpack_require__(343);
	
	var _acceptJoinRequest = __webpack_require__(818);
	
	var _declineJoinRequest = __webpack_require__(825);
	
	var _reqMemberInvitation = __webpack_require__(654);
	
	var _commentsListSagas = __webpack_require__(4017);
	
	var _sagas7 = __webpack_require__(4028);
	
	var _sagas8 = _interopRequireDefault(_sagas7);
	
	var _notificationCounters = __webpack_require__(300);
	
	var _removeNotificationsCounters = __webpack_require__(345);
	
	var _usersJoinRequests = __webpack_require__(830);
	
	var _communityImageUpdate = __webpack_require__(820);
	
	var _communityImageRemove = __webpack_require__(819);
	
	var _communityInfoUpdate = __webpack_require__(821);
	
	var _invitationUserSearch = __webpack_require__(1261);
	
	var _invitationUserToCommunity = __webpack_require__(1262);
	
	var _acceptInvitation2 = __webpack_require__(342);
	
	var _declineInvitation2 = __webpack_require__(518);
	
	var _rootSaga5 = __webpack_require__(4066);
	
	var _rootSaga6 = _interopRequireDefault(_rootSaga5);
	
	var _success = __webpack_require__(104);
	
	var _error = __webpack_require__(101);
	
	var _locationsSaga = __webpack_require__(4016);
	
	var _locationsSaga2 = _interopRequireDefault(_locationsSaga);
	
	var _reqSendReport = __webpack_require__(1267);
	
	var _sagas9 = __webpack_require__(4041);
	
	var _sagas10 = _interopRequireDefault(_sagas9);
	
	var _rootSaga7 = __webpack_require__(4181);
	
	var _rootSaga8 = _interopRequireDefault(_rootSaga7);
	
	var _rootSaga9 = __webpack_require__(4079);
	
	var _rootSaga10 = _interopRequireDefault(_rootSaga9);
	
	var _rootSaga11 = __webpack_require__(1885);
	
	var _rootSaga12 = __webpack_require__(860);
	
	var _rootSaga13 = _interopRequireDefault(_rootSaga12);
	
	var _rootSaga14 = __webpack_require__(3921);
	
	var _rootSaga15 = _interopRequireDefault(_rootSaga14);
	
	var _rootSaga16 = __webpack_require__(4063);
	
	var _rootSaga17 = _interopRequireDefault(_rootSaga16);
	
	var _rootSaga18 = __webpack_require__(4160);
	
	var _rootSaga19 = _interopRequireDefault(_rootSaga18);
	
	var _appointmentDetailsReq = __webpack_require__(259);
	
	var _acceptConsent = __webpack_require__(890);
	
	var _sagas11 = __webpack_require__(4137);
	
	var _sagas12 = _interopRequireDefault(_sagas11);
	
	var _sagas13 = __webpack_require__(4120);
	
	var _sagas14 = _interopRequireDefault(_sagas13);
	
	var _rootSaga20 = __webpack_require__(3942);
	
	var _rootSaga21 = _interopRequireDefault(_rootSaga20);
	
	var _rootSaga22 = __webpack_require__(4143);
	
	var _rootSaga23 = _interopRequireDefault(_rootSaga22);
	
	var _rootSaga24 = __webpack_require__(4084);
	
	var _rootSaga25 = _interopRequireDefault(_rootSaga24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(_callee); /* eslint-disable no-restricted-syntax */
	
	
	// auth
	
	
	// board
	
	
	// chat connection
	
	
	// common
	
	// circles
	// TODO use circles root saga
	
	// context
	
	// data constants
	
	// invitations
	
	// profiles
	
	// programs: TURN IT OFF until we have program invites
	
	
	// surveys
	
	
	// communities
	
	// ui
	
	
	// teams
	
	
	// consents
	
	
	// paperwork
	
	
	// manage insurances
	
	
	// appointments
	
	// payment-methods
	
	// guarantor-information
	
	
	var watchers = [_rootSaga2.default, _removeUserCommunity.watcher, _leaveCommunity.watcher, _caregiver.watcher, _memberFamilyCircle.watcher, _myFamilyCircle.watcher, _inviteToFamilyCircle.watcher, _leaveFamilyCircle.watcher, _acceptInviteToFamilyCircle.watcher, _declineInviteToFamilyCircle.watcher, _getGuardianCircle.watcher, _inviteGuardian.watcher, _removeGuardianRole.watcher, _acceptGuardianRole.watcher, _declineGuardianRole.watcher, _loggedUserSagas.addLoggedUserSaga, _teamUserSaga.addTeamUserSaga, _loggedUserSagas.fetchLoggedUserSaga, _loggedUserSagas.updateLoggedUserSaga, _loggedUserSagas.changeLoggedUserDataSaga, _loggedUserSagas.createLoggedUserSaga, _targetUserSagas.updateTargetUserSaga, _targetUserSagas.fetchTargetUserSaga, _targetUserSagas.setTargetUserSaga, _permissionsSaga.updateCaregiverCirclesSaga, _permissionsSaga.updateDependentsListSaga, _permissionsSaga.updateLoggedUserIdSaga, _permissionsSaga.updateTargetUserIdSaga, _constants.watcher, _privacyPolicies.watcher, _caregiver2.watcher, _familyMember.watcher, _guardian.watcher, _acceptConsent.watcher, _acceptInvitation.watcher, _declineInvitation.watcher, _saga.sagas, _joinedPrograms.watcher, _answered.watcher, _answered.paginatedWatcher, _submit.watcher, _upcoming.watcher, _upcoming.paginatedWatcher, _upcomingSurvey.watcher, _upcomingSurveyProceed.watcher, _upcomingSurveyAnswers.watcher, _upcomingSurveyCompletions.watcher, _upcomingSurveyCancelFilling.watcher, _appointmentConsentReq.watcher, _sagas6.default, _sendSurvey.watcher, _forms.watcher, _exportToPDF.watcher, _submitReferralForm.watcher, _reqReferralForms.watcher, _reqFormResult.watcher, _getIncomingSurveysSaga.getIncomingSurveysSaga, _submitReferralFormSaga.submitReferralFormSaga, _inviteCaregiver.watcher, _inviteCaregiverFamily.watcher, _removeCaregiver.watcher, _acceptCaregiverRole.watcher, _declineCaregiverRole.watcher, _cancelFamilyMemberInvitation.watcher, _cancelCaregiverInvitation.watcher, _cancelGuardianInvitationReq.watcher, _circlesSaga2.default, _rootSaga4.default, _sagas8.default, _userCommunities.watcher, _userCommunities.paginatedWatcher, _reqDiscoverCommunities.watcher, _reqDiscoverCommunities.paginatedWatcher, _currentCommunityInfo.watcher, _communityPreview.watcher, _communityPostsPreview.watcher, _communityPosts.watcher, _postDetails.watcher, _createPost.watcher, _editPost.watcher, _editPost.editedPostSaga, _deletePost.watcher, _deletePost.deletedPostSaga, _postsListSagas.createdPostSaga, _postsPreviewListSagas.getPostsPreviewSaga, _postsListSagas.getPostsSaga, _postDetailsSaga.postDetailsSaga, _postComment.watcher, _postComment.postCommentSaga, _commentsListFetch.watcher, _commentsListSagas.getCommentsSaga, _currentCommunitySaga.currentCommunitySaga, _urlPreview.watcher, _appStateReq.watcher, _likePost.watcher, _likePost.postLikedSaga, _dislikePost.watcher, _dislikePost.postDislikedSaga, _deleteComment.watcher, _deleteComment.deletedCommentSaga, _editComment.watcher, _editComment.editedCommentSaga, _postDetailsSaga.postCommentsSaga, _reqJoinCommunity.watcher, _communitiesJoinRequests.watcher, _communitiesJoinRequests.paginatedWatcher, _acceptJoinRequest.watcher, _declineJoinRequest.watcher, _notificationCounters.watcher, _usersJoinRequests.watcher, _usersJoinRequests.paginatedWatcher, _removeNotificationsCounters.watcher, _communityImageUpdate.watcher, _communityImageRemove.watcher, _communityInfoUpdate.watcher, _invitationUserSearch.watcher, _invitationUserToCommunity.watcher, _acceptInvitation2.watcher, _declineInvitation2.watcher, _reqMemberInvitation.watcher, _getUserProfile.watcher, _reqRemoveParticipant.watcher, _programSagas.programSagas, _assignPrograms.watcher, _availablePrograms.watcher, _leaveProgram.watcher, _reqChangeChatName.watcher, _reqAssignPatient.watcher, _reqSocialChannel.watcher, _reqNewChannel.watcher, _reqRelatedUsers.watcher, _reqAllUsers.watcher, _reqCircleOfCare.watcher, _reqFilters.watcher, _reqInvitePatient.watcher, _reqMetadata.watcher, _reqChannels.watcher, _reqChannel.watcher, _reqChannelParticipants.watcher, _dependentChannelParticipants.watcher, _reqAddParticipants.watcher, _sagas2.default, _sagas4.default, _downloadAttachment2.default, _uploadAttachment2.default, _sendMessage.watcher, _reqBlockUser.watcher, _reqUnblockUser.watcher, _blockUserForDependent.watcher, _unblockUserForDependent.watcher, _createChatInboxTaskReq.watcher, _locationsSaga2.default, _error.updateErrorMsgSaga, _success.updateSuccessMsgSaga, _membersListSaga.getMembersListSaga, _communityMembers.watcher, _moderatorsListSaga.getModeratorsListSaga, _reqSendReport.watcher, _communityModerators.watcher, _sagas10.default, _rootSaga6.default, _rootSaga10.default, _rootSaga8.default, _rootSaga11.dashboardSaga, _rootSaga17.default, _rootSaga13.default, _rootSaga15.default, _rootSaga23.default, _rootSaga25.default, _rootSaga19.default, _reqAssignProvider.watcher, _removeAssignedProvider.watcher, _appointmentDetailsReq.watcher, _reqRelationshipPriority.watcher, _accountVaults.watcher, _accountVaultsForm.watcher, _submitPaymentProgram.watcher, _sagas12.default, _sagas14.default, _rootSaga21.default];
	
	function _callee() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, watcher;
	
	  return _regenerator2.default.wrap(function _callee$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _iteratorNormalCompletion = true;
	          _didIteratorError = false;
	          _iteratorError = undefined;
	          _context.prev = 3;
	          _iterator = (0, _getIterator3.default)(watchers);
	
	        case 5:
	          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	            _context.next = 12;
	            break;
	          }
	
	          watcher = _step.value;
	          _context.next = 9;
	          return _effects.fork.apply(undefined, [watcher].concat(args));
	
	        case 9:
	          _iteratorNormalCompletion = true;
	          _context.next = 5;
	          break;
	
	        case 12:
	          _context.next = 18;
	          break;
	
	        case 14:
	          _context.prev = 14;
	          _context.t0 = _context['catch'](3);
	          _didIteratorError = true;
	          _iteratorError = _context.t0;
	
	        case 18:
	          _context.prev = 18;
	          _context.prev = 19;
	
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	
	        case 21:
	          _context.prev = 21;
	
	          if (!_didIteratorError) {
	            _context.next = 24;
	            break;
	          }
	
	          throw _iteratorError;
	
	        case 24:
	          return _context.finish(21);
	
	        case 25:
	          return _context.finish(18);
	
	        case 26:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[3, 14, 18, 26], [19,, 21, 25]]);
	}

/***/ }),
/* 4159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _providerLocationsReq = __webpack_require__(1363);
	
	var _providerLocationsReq2 = _interopRequireDefault(_providerLocationsReq);
	
	var _providerServicesReq = __webpack_require__(897);
	
	var _providerServicesReq2 = _interopRequireDefault(_providerServicesReq);
	
	var _intersectionCountsReq = __webpack_require__(896);
	
	var _intersectionCountsReq2 = _interopRequireDefault(_intersectionCountsReq);
	
	var _practiceProvidersReq = __webpack_require__(1362);
	
	var _practiceProvidersReq2 = _interopRequireDefault(_practiceProvidersReq);
	
	var _workslotInsertReq = __webpack_require__(431);
	
	var _workslotInsertReq2 = _interopRequireDefault(_workslotInsertReq);
	
	var _workslotRemoveReq = __webpack_require__(544);
	
	var _workslotRemoveReq2 = _interopRequireDefault(_workslotRemoveReq);
	
	var _blockslotInsertReq = __webpack_require__(430);
	
	var _blockslotInsertReq2 = _interopRequireDefault(_blockslotInsertReq);
	
	var _blockslotRemoveReq = __webpack_require__(542);
	
	var _blockslotRemoveReq2 = _interopRequireDefault(_blockslotRemoveReq);
	
	var _blockslotUpdateReq = __webpack_require__(543);
	
	var _blockslotUpdateReq2 = _interopRequireDefault(_blockslotUpdateReq);
	
	var _scheduleSearchReq = __webpack_require__(690);
	
	var _scheduleSearchReq2 = _interopRequireDefault(_scheduleSearchReq);
	
	var _patientTypeReq = __webpack_require__(1360);
	
	var _patientTypeReq2 = _interopRequireDefault(_patientTypeReq);
	
	var _workslotUpdateReq = __webpack_require__(545);
	
	var _workslotUpdateReq2 = _interopRequireDefault(_workslotUpdateReq);
	
	var _createApppointmentReq = __webpack_require__(895);
	
	var _createApppointmentReq2 = _interopRequireDefault(_createApppointmentReq);
	
	var _appointmentInspectorReq = __webpack_require__(1359);
	
	var _appointmentInspectorReq2 = _interopRequireDefault(_appointmentInspectorReq);
	
	var _patientsByProviderReq = __webpack_require__(1361);
	
	var _patientsByProviderReq2 = _interopRequireDefault(_patientsByProviderReq);
	
	var _visitTypeByLocationReq = __webpack_require__(1365);
	
	var _visitTypeByLocationReq2 = _interopRequireDefault(_visitTypeByLocationReq);
	
	var _scheduleDefaultsReq = __webpack_require__(1364);
	
	var _scheduleDefaultsReq2 = _interopRequireDefault(_scheduleDefaultsReq);
	
	var _appointmentGuard = __webpack_require__(1358);
	
	var _appointmentGuard2 = _interopRequireDefault(_appointmentGuard);
	
	var _selectedPopover = __webpack_require__(432);
	
	var _selectedPopover2 = _interopRequireDefault(_selectedPopover);
	
	var _validate = __webpack_require__(143);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _filter = __webpack_require__(894);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  providerLocations: _providerLocationsReq2.default,
	  providerServices: _providerServicesReq2.default,
	  intersections: _intersectionCountsReq2.default,
	  practiceProviders: _practiceProvidersReq2.default,
	  workslotInsert: _workslotInsertReq2.default,
	  workslotRemove: _workslotRemoveReq2.default,
	  workslotUpdate: _workslotUpdateReq2.default,
	  blockslotInsert: _blockslotInsertReq2.default,
	  blockslotRemove: _blockslotRemoveReq2.default,
	  blockslotUpdate: _blockslotUpdateReq2.default,
	  createAppointment: _createApppointmentReq2.default,
	  inspectAppointment: _appointmentInspectorReq2.default,
	  patientList: _patientsByProviderReq2.default,
	  visitTypes: _visitTypeByLocationReq2.default,
	  scheduleDefaults: _scheduleDefaultsReq2.default,
	  patientTypes: _patientTypeReq2.default,
	  scheduleList: _scheduleSearchReq2.default,
	  selectedPopover: _selectedPopover2.default,
	  appointmentGuard: _appointmentGuard2.default,
	  validate: _validate2.default,
	  filter: _filter2.default
	});

/***/ }),
/* 4160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = scheduleRootSaga;
	
	var _effects = __webpack_require__(14);
	
	var _providerLocationsReq = __webpack_require__(1363);
	
	var providerLocations = _interopRequireWildcard(_providerLocationsReq);
	
	var _providerServicesReq = __webpack_require__(897);
	
	var providerServices = _interopRequireWildcard(_providerServicesReq);
	
	var _practiceProvidersReq = __webpack_require__(1362);
	
	var practiceProviders = _interopRequireWildcard(_practiceProvidersReq);
	
	var _intersectionCountsReq = __webpack_require__(896);
	
	var intersections = _interopRequireWildcard(_intersectionCountsReq);
	
	var _workslotInsertReq = __webpack_require__(431);
	
	var workslotInsert = _interopRequireWildcard(_workslotInsertReq);
	
	var _workslotRemoveReq = __webpack_require__(544);
	
	var workslotRemove = _interopRequireWildcard(_workslotRemoveReq);
	
	var _workslotUpdateReq = __webpack_require__(545);
	
	var workslotUpdate = _interopRequireWildcard(_workslotUpdateReq);
	
	var _blockslotInsertReq = __webpack_require__(430);
	
	var blockslotInsert = _interopRequireWildcard(_blockslotInsertReq);
	
	var _blockslotRemoveReq = __webpack_require__(542);
	
	var blockslotRemove = _interopRequireWildcard(_blockslotRemoveReq);
	
	var _blockslotUpdateReq = __webpack_require__(543);
	
	var blockslotUpdate = _interopRequireWildcard(_blockslotUpdateReq);
	
	var _scheduleSearchReq = __webpack_require__(690);
	
	var scheduleList = _interopRequireWildcard(_scheduleSearchReq);
	
	var _patientTypeReq = __webpack_require__(1360);
	
	var patientTypes = _interopRequireWildcard(_patientTypeReq);
	
	var _createApppointmentReq = __webpack_require__(895);
	
	var createAppointment = _interopRequireWildcard(_createApppointmentReq);
	
	var _appointmentInspectorReq = __webpack_require__(1359);
	
	var inspectAppointment = _interopRequireWildcard(_appointmentInspectorReq);
	
	var _patientsByProviderReq = __webpack_require__(1361);
	
	var patientList = _interopRequireWildcard(_patientsByProviderReq);
	
	var _visitTypeByLocationReq = __webpack_require__(1365);
	
	var visitTypes = _interopRequireWildcard(_visitTypeByLocationReq);
	
	var _scheduleDefaultsReq = __webpack_require__(1364);
	
	var scheduleDefaults = _interopRequireWildcard(_scheduleDefaultsReq);
	
	var _errorHandlingSaga = __webpack_require__(4166);
	
	var _errorHandlingSaga2 = _interopRequireDefault(_errorHandlingSaga);
	
	var _onRemoveScheduleSaga = __webpack_require__(4167);
	
	var _onRemoveScheduleSaga2 = _interopRequireDefault(_onRemoveScheduleSaga);
	
	var _blockslotInsertSaga = __webpack_require__(4162);
	
	var _blockslotInsertSaga2 = _interopRequireDefault(_blockslotInsertSaga);
	
	var _workslotInsertSaga = __webpack_require__(4170);
	
	var _workslotInsertSaga2 = _interopRequireDefault(_workslotInsertSaga);
	
	var _fetchScheduleSaga = __webpack_require__(1902);
	
	var _fetchScheduleSaga2 = _interopRequireDefault(_fetchScheduleSaga);
	
	var _validateOnMountSaga = __webpack_require__(4169);
	
	var _validateOnMountSaga2 = _interopRequireDefault(_validateOnMountSaga);
	
	var _editWorkRecursionSaga = __webpack_require__(4165);
	
	var _editWorkRecursionSaga2 = _interopRequireDefault(_editWorkRecursionSaga);
	
	var _editBlockRecursionSaga = __webpack_require__(4164);
	
	var _editBlockRecursionSaga2 = _interopRequireDefault(_editBlockRecursionSaga);
	
	var _popoverHoverSaga = __webpack_require__(4168);
	
	var _popoverHoverSaga2 = _interopRequireDefault(_popoverHoverSaga);
	
	var _createAppointmentSaga = __webpack_require__(4163);
	
	var _createAppointmentSaga2 = _interopRequireDefault(_createAppointmentSaga);
	
	var _appointmentGuardSaga = __webpack_require__(4161);
	
	var _appointmentGuardSaga2 = _interopRequireDefault(_appointmentGuardSaga);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(scheduleRootSaga);
	
	function scheduleRootSaga() {
	  return _regenerator2.default.wrap(function scheduleRootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(providerLocations.watcher);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(providerServices.watcher);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(practiceProviders.watcher);
	
	        case 6:
	          _context.next = 8;
	          return (0, _effects.fork)(intersections.watcher);
	
	        case 8:
	          _context.next = 10;
	          return (0, _effects.fork)(blockslotInsert.watcher);
	
	        case 10:
	          _context.next = 12;
	          return (0, _effects.fork)(blockslotRemove.watcher);
	
	        case 12:
	          _context.next = 14;
	          return (0, _effects.fork)(blockslotUpdate.watcher);
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.fork)(workslotInsert.watcher);
	
	        case 16:
	          _context.next = 18;
	          return (0, _effects.fork)(workslotRemove.watcher);
	
	        case 18:
	          _context.next = 20;
	          return (0, _effects.fork)(workslotUpdate.watcher);
	
	        case 20:
	          _context.next = 22;
	          return (0, _effects.fork)(scheduleList.watcher);
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.fork)(patientTypes.watcher);
	
	        case 24:
	          _context.next = 26;
	          return (0, _effects.fork)(createAppointment.watcher);
	
	        case 26:
	          _context.next = 28;
	          return (0, _effects.fork)(inspectAppointment.watcher);
	
	        case 28:
	          _context.next = 30;
	          return (0, _effects.fork)(patientList.watcher);
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.fork)(visitTypes.watcher);
	
	        case 32:
	          _context.next = 34;
	          return (0, _effects.fork)(scheduleDefaults.watcher);
	
	        case 34:
	          _context.next = 36;
	          return (0, _effects.fork)(_appointmentGuardSaga2.default);
	
	        case 36:
	          _context.next = 38;
	          return (0, _effects.fork)(_errorHandlingSaga2.default);
	
	        case 38:
	          _context.next = 40;
	          return (0, _effects.fork)(_blockslotInsertSaga2.default);
	
	        case 40:
	          _context.next = 42;
	          return (0, _effects.fork)(_workslotInsertSaga2.default);
	
	        case 42:
	          _context.next = 44;
	          return (0, _effects.fork)(_editBlockRecursionSaga2.default);
	
	        case 44:
	          _context.next = 46;
	          return (0, _effects.fork)(_editWorkRecursionSaga2.default);
	
	        case 46:
	          _context.next = 48;
	          return (0, _effects.fork)(_onRemoveScheduleSaga2.default);
	
	        case 48:
	          _context.next = 50;
	          return (0, _effects.fork)(_fetchScheduleSaga2.default);
	
	        case 50:
	          _context.next = 52;
	          return (0, _effects.fork)(_validateOnMountSaga2.default);
	
	        case 52:
	          _context.next = 54;
	          return (0, _effects.fork)(_popoverHoverSaga2.default);
	
	        case 54:
	          _context.next = 56;
	          return (0, _effects.fork)(_createAppointmentSaga2.default);
	
	        case 56:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = appointmentGuardSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _appointmentGuard = __webpack_require__(1358);
	
	var _selectors = __webpack_require__(88);
	
	var _providerServicesReq = __webpack_require__(897);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleAppointmentGuard),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(appointmentGuardSaga);
	
	function handleAppointmentGuard() {
	  var id, locations, schedule, locationId, serviceId, hasLocation, _ref, services, hasService;
	
	  return _regenerator2.default.wrap(function handleAppointmentGuard$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectScheduleTargerProviderId);
	
	        case 2:
	          id = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectScheduleLocations);
	
	        case 5:
	          locations = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 8:
	          schedule = _context.sent;
	          locationId = (0, _get2.default)(schedule, 'location.id');
	          serviceId = (0, _get2.default)(schedule, 'service.id');
	          hasLocation = locations.some(function (location) {
	            return locationId === location.id;
	          });
	
	          if (hasLocation) {
	            _context.next = 17;
	            break;
	          }
	
	          _context.next = 15;
	          return (0, _effects.put)(_appointmentGuard.calendarAppointmentGuardActions.finish(false));
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.cancel)();
	
	        case 17:
	          _context.next = 19;
	          return (0, _effects.put)(_providerServicesReq.actions.send({ id: id, locationId: locationId }));
	
	        case 19:
	          _context.next = 21;
	          return (0, _effects.take)(_providerServicesReq.actions.succeed);
	
	        case 21:
	          _ref = _context.sent;
	          services = _ref.payload;
	          hasService = services.some(function (service) {
	            return serviceId === service.id;
	          });
	          _context.next = 26;
	          return (0, _effects.put)(_appointmentGuard.calendarAppointmentGuardActions.finish(hasService));
	
	        case 26:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function appointmentGuardSaga() {
	  return _regenerator2.default.wrap(function appointmentGuardSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)([_appointmentGuard.CALENDAR_APPOINTMENT_GUARD.START], handleAppointmentGuard);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = blockslotInsertSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _blockslotInsertReq = __webpack_require__(430);
	
	var blockslotInsert = _interopRequireWildcard(_blockslotInsertReq);
	
	var _blockslotUpdateReq = __webpack_require__(543);
	
	var blockslotUpdate = _interopRequireWildcard(_blockslotUpdateReq);
	
	var _validate = __webpack_require__(143);
	
	var _selectors = __webpack_require__(88);
	
	var _constants = __webpack_require__(105);
	
	var _repeatScheduleAdapter = __webpack_require__(698);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(insertOrUpdateBlockedSlot),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleRecursion),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleBlockslotInsert),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(blockslotInsertSaga);
	
	function insertOrUpdateBlockedSlot(payload) {
	  return _regenerator2.default.wrap(function insertOrUpdateBlockedSlot$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(blockslotInsert.actions.send(payload));
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleRecursion(_ref) {
	  var payload = _ref.payload;
	
	  var selectedSchedule, scheduleFormData, restPayload, _ref2, recursionOption, formattedData;
	
	  return _regenerator2.default.wrap(function handleRecursion$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 2:
	          selectedSchedule = _context2.sent;
	          scheduleFormData = payload.blockedSlot, restPayload = (0, _objectWithoutProperties3.default)(payload, ['blockedSlot']);
	          _context2.next = 6;
	          return (0, _effects.put)(_validate.scheduleValidateActions.toggleRecursionModal({
	            type: _constants.RECURSION_MODAL_TYPES.EDIT_BLOCK_SLOT,
	            lastDay: (0, _repeatScheduleAdapter.isLastDayOfRepeat)(selectedSchedule),
	            opened: true
	          }));
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.take)(_validate.SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION);
	
	        case 8:
	          _ref2 = _context2.sent;
	          recursionOption = _ref2.payload.option;
	          formattedData = (0, _repeatScheduleAdapter.repeatScheduleAdapter)(recursionOption, selectedSchedule, scheduleFormData);
	
	          if (formattedData) {
	            _context2.next = 14;
	            break;
	          }
	
	          _context2.next = 14;
	          return (0, _effects.cancel)();
	
	        case 14:
	          _context2.next = 16;
	          return (0, _effects.call)(insertOrUpdateBlockedSlot, (0, _extends3.default)({}, restPayload, {
	            blockedSlot: formattedData
	          }));
	
	        case 16:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleBlockslotInsert(action) {
	  var selectedSchedule, isRepeatable;
	  return _regenerator2.default.wrap(function handleBlockslotInsert$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 2:
	          selectedSchedule = _context3.sent;
	          isRepeatable = (0, _get2.default)(selectedSchedule, 'isRepeatable');
	
	          if (!isRepeatable) {
	            _context3.next = 9;
	            break;
	          }
	
	          _context3.next = 7;
	          return (0, _effects.call)(handleRecursion, action);
	
	        case 7:
	          _context3.next = 9;
	          return (0, _effects.cancel)();
	
	        case 9:
	          _context3.next = 11;
	          return (0, _effects.call)(insertOrUpdateBlockedSlot, action.payload);
	
	        case 11:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function blockslotInsertSaga() {
	  return _regenerator2.default.wrap(function blockslotInsertSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)([blockslotInsert.consts.START], handleBlockslotInsert);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}

/***/ }),
/* 4163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = createAppointmentSaga;
	
	var _effects = __webpack_require__(14);
	
	var _validate = __webpack_require__(143);
	
	var _createApppointmentReq = __webpack_require__(895);
	
	var createAppointment = _interopRequireWildcard(_createApppointmentReq);
	
	var _appointmentInspectorReq = __webpack_require__(1359);
	
	var inspectAppointment = _interopRequireWildcard(_appointmentInspectorReq);
	
	var _events = __webpack_require__(360);
	
	var _fetchScheduleSaga = __webpack_require__(1902);
	
	var _success = __webpack_require__(104);
	
	var success = _interopRequireWildcard(_success);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(inspectAppointmentCreation),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleCreateAppointmnet),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(createAppointmentSaga);
	
	var ERROR_CODES = {
	  PROVIDER_UNAVAILABLE: 'appointment_provider_unavailable',
	  NOT_MATCHED_PATIENT_TYPE: 'appointment_not_matching_patient_type',
	  OVERLAP: 'appointment_overlapping'
	};
	
	function getSchedulableError(fieldList) {
	  if (fieldList.find(function (_ref) {
	    var code = _ref.code;
	    return code === ERROR_CODES.PROVIDER_UNAVAILABLE;
	  })) {
	    return 'calendar.errors.appointment.unavailableProvider';
	  }
	
	  if (fieldList.find(function (_ref2) {
	    var code = _ref2.code;
	    return code === ERROR_CODES.NOT_MATCHED_PATIENT_TYPE;
	  })) {
	    return 'calendar.errors.appointment.patientTypeMismatch';
	  }
	
	  return 'calendar.errors.appointment.common';
	}
	
	function inspectAppointmentCreation(payload) {
	  var _ref3, succeed, failed, inspection, _inspection, params, schedulable, fieldList, isOverlap, errorI18n;
	
	  return _regenerator2.default.wrap(function inspectAppointmentCreation$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(inspectAppointment.actions.send(payload));
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(inspectAppointment.actions.succeed),
	            failed: (0, _effects.take)([inspectAppointment.actions.rejected, inspectAppointment.actions.errorEncountered])
	          });
	
	        case 4:
	          _ref3 = _context.sent;
	          succeed = _ref3.succeed;
	          failed = _ref3.failed;
	
	          if (!failed) {
	            _context.next = 11;
	            break;
	          }
	
	          _context.next = 10;
	          return (0, _effects.put)(error.actions.update({ id: 'errors.common' }));
	
	        case 10:
	          return _context.abrupt('return', false);
	
	        case 11:
	          inspection = succeed.payload;
	          _inspection = (0, _slicedToArray3.default)(inspection, 2), params = _inspection[0], schedulable = _inspection[1];
	
	          if (params.completed) {
	            _context.next = 16;
	            break;
	          }
	
	          console.log('>__TODO: handle this error::: ', params);
	          return _context.abrupt('return', false);
	
	        case 16:
	          if (schedulable.completed) {
	            _context.next = 29;
	            break;
	          }
	
	          fieldList = schedulable.fieldList;
	          isOverlap = fieldList.find(function (_ref4) {
	            var code = _ref4.code;
	            return code === ERROR_CODES.OVERLAP;
	          });
	
	          if (!isOverlap) {
	            _context.next = 25;
	            break;
	          }
	
	          _context.next = 22;
	          return (0, _effects.put)(_validate.scheduleValidateActions.toggleOverlapAppointment(true));
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.take)(_validate.SCHEDULE_VALIDATE_TYPES.FORCE_OVERLAP);
	
	        case 24:
	          return _context.abrupt('return', true);
	
	        case 25:
	          errorI18n = getSchedulableError(fieldList);
	          _context.next = 28;
	          return (0, _effects.put)(error.actions.update({ id: errorI18n }));
	
	        case 28:
	          return _context.abrupt('return', false);
	
	        case 29:
	          return _context.abrupt('return', true);
	
	        case 30:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleCreateAppointmnet(action) {
	  var payload, canCreate;
	  return _regenerator2.default.wrap(function handleCreateAppointmnet$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          payload = action.payload;
	          _context2.next = 3;
	          return (0, _effects.call)(inspectAppointmentCreation, payload);
	
	        case 3:
	          canCreate = _context2.sent;
	
	          if (!canCreate) {
	            _context2.next = 17;
	            break;
	          }
	
	          _context2.next = 7;
	          return (0, _effects.put)(createAppointment.actions.send(action.payload));
	
	        case 7:
	          _context2.next = 9;
	          return (0, _effects.take)(createAppointment.actions.succeed);
	
	        case 9:
	          _context2.next = 11;
	          return (0, _effects.call)(_events.emitClearSelectionEvent);
	
	        case 11:
	          _context2.next = 13;
	          return (0, _effects.call)(_fetchScheduleSaga.loadScheduleSearchSlots);
	
	        case 13:
	          _context2.next = 15;
	          return (0, _effects.delay)(150);
	
	        case 15:
	          _context2.next = 17;
	          return (0, _effects.put)(success.actions.update({ id: 'virtualVisit.details.visitScheduled' }));
	
	        case 17:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function createAppointmentSaga() {
	  return _regenerator2.default.wrap(function createAppointmentSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)([createAppointment.consts.START], handleCreateAppointmnet);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = editBlockRecursionSaga;
	
	var _effects = __webpack_require__(14);
	
	var _validate = __webpack_require__(143);
	
	var _selectors = __webpack_require__(88);
	
	var _constants = __webpack_require__(105);
	
	var _repeatScheduleAdapter = __webpack_require__(698);
	
	var _blockslotInsertReq = __webpack_require__(430);
	
	var blockslotInsert = _interopRequireWildcard(_blockslotInsertReq);
	
	var _blockslotRemoveReq = __webpack_require__(542);
	
	var blockslotRemove = _interopRequireWildcard(_blockslotRemoveReq);
	
	var _blockslotUpdateReq = __webpack_require__(543);
	
	var blockslotUpdate = _interopRequireWildcard(_blockslotUpdateReq);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(displayRecursionModal),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(proceedNonRepeatableChange),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(proceedCustomRepeatWithFollowingOption),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(proceedCustomRepeatWithAllOption),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(proceedNoRepeatWithFollowingOption),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(proceedNoRepeatWithAllOption),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(handleEditBlockRecursion),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(editBlockRecursionSaga);
	
	function displayRecursionModal(recursionFlow) {
	  var selectedSchedule, _ref, recursionOption;
	
	  return _regenerator2.default.wrap(function displayRecursionModal$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 2:
	          selectedSchedule = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)(_validate.scheduleValidateActions.toggleRecursionModal({
	            type: _constants.RECURSION_MODAL_TYPES.EDIT_BLOCK_SLOT,
	            lastDay: (0, _repeatScheduleAdapter.isLastDayOfRepeat)(selectedSchedule),
	            opened: true,
	            recursionFlow: recursionFlow
	          }));
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.take)(_validate.SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION);
	
	        case 7:
	          _ref = _context.sent;
	          recursionOption = _ref.payload.option;
	          return _context.abrupt('return', recursionOption);
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function proceedNonRepeatableChange(_ref2) {
	  var selectedSchedule = _ref2.selectedSchedule,
	      repeatData = _ref2.repeatData,
	      id = _ref2.id;
	  var attrs, scheduleSettingAttributes, updatePayload;
	  return _regenerator2.default.wrap(function proceedNonRepeatableChange$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          attrs = (0, _repeatScheduleAdapter.scheduleOriginDaySettingsAttrsAdapter)(selectedSchedule);
	          scheduleSettingAttributes = (0, _extends3.default)({}, attrs, repeatData, {
	            endOn: repeatData.endOn || null
	          });
	          updatePayload = {
	            slotId: selectedSchedule.id,
	            blockedSlot: { scheduleSettingAttributes: scheduleSettingAttributes },
	            id: id
	          };
	          _context2.next = 5;
	          return (0, _effects.put)(blockslotUpdate.actions.send(updatePayload));
	
	        case 5:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function proceedCustomRepeatWithFollowingOption(_ref3) {
	  var selectedSchedule = _ref3.selectedSchedule,
	      repeatData = _ref3.repeatData,
	      id = _ref3.id;
	  var attrs, updatePayload, insertPayload;
	  return _regenerator2.default.wrap(function proceedCustomRepeatWithFollowingOption$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          attrs = (0, _repeatScheduleAdapter.scheduleCurrentDaySettingsAttrsAdapter)(selectedSchedule);
	          updatePayload = {
	            slotId: selectedSchedule.id,
	            blockedSlot: (0, _extends3.default)({}, (0, _repeatScheduleAdapter.getPrevDayRepeatableAdapter)(selectedSchedule)),
	            id: id
	          };
	          insertPayload = {
	            blockedSlot: {
	              scheduleSettingAttributes: (0, _extends3.default)({}, attrs, repeatData)
	            },
	            id: id
	          };
	          _context3.next = 5;
	          return (0, _effects.put)(blockslotUpdate.actions.send(updatePayload));
	
	        case 5:
	          _context3.next = 7;
	          return (0, _effects.take)(blockslotUpdate.actions.succeed);
	
	        case 7:
	          _context3.next = 9;
	          return (0, _effects.put)(blockslotInsert.actions.send(insertPayload));
	
	        case 9:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function proceedCustomRepeatWithAllOption(_ref4) {
	  var selectedSchedule = _ref4.selectedSchedule,
	      repeatData = _ref4.repeatData,
	      id = _ref4.id;
	  var attrs, updatePayload;
	  return _regenerator2.default.wrap(function proceedCustomRepeatWithAllOption$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          attrs = (0, _repeatScheduleAdapter.scheduleOriginDaySettingsAttrsAdapter)(selectedSchedule);
	          updatePayload = {
	            slotId: selectedSchedule.id,
	            blockedSlot: {
	              scheduleSettingAttributes: (0, _extends3.default)({}, attrs, repeatData)
	            },
	            id: id
	          };
	          _context4.next = 4;
	          return (0, _effects.put)(blockslotUpdate.actions.send(updatePayload));
	
	        case 4:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function proceedNoRepeatWithFollowingOption(_ref5) {
	  var selectedSchedule = _ref5.selectedSchedule,
	      id = _ref5.id;
	  var removedSlot;
	  return _regenerator2.default.wrap(function proceedNoRepeatWithFollowingOption$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          removedSlot = (0, _repeatScheduleAdapter.noRepeatScheduleAdapter)(selectedSchedule);
	          _context5.next = 3;
	          return (0, _effects.put)(blockslotRemove.actions.send({ id: id, removedSlot: removedSlot }));
	
	        case 3:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function proceedNoRepeatWithAllOption(_ref6) {
	  var selectedSchedule = _ref6.selectedSchedule,
	      id = _ref6.id;
	  var removedSlot, scheduleSettingAttributes, blockedSlot;
	  return _regenerator2.default.wrap(function proceedNoRepeatWithAllOption$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          removedSlot = (0, _repeatScheduleAdapter.removeRepeatScheduleAdapter)(_constants.RECURSION_OPTIONS.ALL_DAYS, selectedSchedule);
	          scheduleSettingAttributes = (0, _repeatScheduleAdapter.removeRepeatScheduleAdapter)(_constants.RECURSION_OPTIONS.CURRENT_DAY, selectedSchedule);
	          blockedSlot = (0, _extends3.default)({}, scheduleSettingAttributes);
	          _context6.next = 5;
	          return (0, _effects.put)(blockslotRemove.actions.send({ id: id, removedSlot: removedSlot }));
	
	        case 5:
	          _context6.next = 7;
	          return (0, _effects.take)(blockslotRemove.actions.succeed);
	
	        case 7:
	          _context6.next = 9;
	          return (0, _effects.put)(blockslotInsert.actions.send({ id: id, blockedSlot: blockedSlot }));
	
	        case 9:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function handleEditBlockRecursion(_ref7) {
	  var payload = _ref7.payload;
	  var id, selectedSchedule, repeatData, repeatValue, recursionFlow, shared, recursionOption;
	  return _regenerator2.default.wrap(function handleEditBlockRecursion$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)(_selectors.selectScheduleTargerProviderId);
	
	        case 2:
	          id = _context7.sent;
	          _context7.next = 5;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 5:
	          selectedSchedule = _context7.sent;
	          repeatData = payload.repeatData, repeatValue = payload.repeatValue;
	          recursionFlow = (0, _repeatScheduleAdapter.getRepeatFlow)(repeatValue);
	          shared = { id: id, selectedSchedule: selectedSchedule, repeatData: repeatData };
	
	          if (selectedSchedule.isRepeatable) {
	            _context7.next = 14;
	            break;
	          }
	
	          _context7.next = 12;
	          return (0, _effects.call)(proceedNonRepeatableChange, shared);
	
	        case 12:
	          _context7.next = 14;
	          return (0, _effects.cancel)();
	
	        case 14:
	          if (!(0, _repeatScheduleAdapter.isOnlyEndRepeatDateChange)(selectedSchedule, payload)) {
	            _context7.next = 19;
	            break;
	          }
	
	          _context7.next = 17;
	          return (0, _effects.call)(proceedCustomRepeatWithAllOption, shared);
	
	        case 17:
	          _context7.next = 19;
	          return (0, _effects.cancel)();
	
	        case 19:
	          if (!(0, _repeatScheduleAdapter.isFirstDayOfCustomRepeatChange)(selectedSchedule, recursionFlow)) {
	            _context7.next = 24;
	            break;
	          }
	
	          _context7.next = 22;
	          return (0, _effects.call)(proceedCustomRepeatWithAllOption, shared);
	
	        case 22:
	          _context7.next = 24;
	          return (0, _effects.cancel)();
	
	        case 24:
	          _context7.next = 26;
	          return (0, _effects.call)(displayRecursionModal, recursionFlow);
	
	        case 26:
	          recursionOption = _context7.sent;
	          _context7.t0 = recursionOption;
	          _context7.next = _context7.t0 === _constants.RECURSION_OPTIONS.UPDATE_CUSTOM_FOLOWING ? 30 : _context7.t0 === _constants.RECURSION_OPTIONS.UPDATE_CUSTOM_ALL ? 35 : _context7.t0 === _constants.RECURSION_OPTIONS.NO_REPEAT_FOLOWING ? 40 : _context7.t0 === _constants.RECURSION_OPTIONS.NO_REPEAT_ALL ? 45 : 50;
	          break;
	
	        case 30:
	          _context7.next = 32;
	          return (0, _effects.call)(proceedCustomRepeatWithFollowingOption, shared);
	
	        case 32:
	          _context7.next = 34;
	          return (0, _effects.cancel)();
	
	        case 34:
	          return _context7.abrupt('break', 53);
	
	        case 35:
	          _context7.next = 37;
	          return (0, _effects.call)(proceedCustomRepeatWithAllOption, shared);
	
	        case 37:
	          _context7.next = 39;
	          return (0, _effects.cancel)();
	
	        case 39:
	          return _context7.abrupt('break', 53);
	
	        case 40:
	          _context7.next = 42;
	          return (0, _effects.call)(proceedNoRepeatWithFollowingOption, shared);
	
	        case 42:
	          _context7.next = 44;
	          return (0, _effects.cancel)();
	
	        case 44:
	          return _context7.abrupt('break', 53);
	
	        case 45:
	          _context7.next = 47;
	          return (0, _effects.call)(proceedNoRepeatWithAllOption, shared);
	
	        case 47:
	          _context7.next = 49;
	          return (0, _effects.cancel)();
	
	        case 49:
	          return _context7.abrupt('break', 53);
	
	        case 50:
	          console.log('unhandled recursion option', recursionOption);
	          _context7.next = 53;
	          return (0, _effects.cancel)();
	
	        case 53:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function editBlockRecursionSaga() {
	  return _regenerator2.default.wrap(function editBlockRecursionSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.takeLatest)([_validate.SCHEDULE_VALIDATE_TYPES.EDIT_BLOCK_RECURSION], handleEditBlockRecursion);
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}

/***/ }),
/* 4165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = editWorkRecursionSaga;
	
	var _effects = __webpack_require__(14);
	
	var _validate = __webpack_require__(143);
	
	var _selectors = __webpack_require__(88);
	
	var _constants = __webpack_require__(105);
	
	var _repeatScheduleAdapter = __webpack_require__(698);
	
	var _workslotUpdateReq = __webpack_require__(545);
	
	var workslotUpdate = _interopRequireWildcard(_workslotUpdateReq);
	
	var _workslotRemoveReq = __webpack_require__(544);
	
	var workslotRemove = _interopRequireWildcard(_workslotRemoveReq);
	
	var _workslotInsertReq = __webpack_require__(431);
	
	var workslotInsert = _interopRequireWildcard(_workslotInsertReq);
	
	var _findIntersectionsSaga = __webpack_require__(1903);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(displayRecursionModal),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(proceedNonRepeatableChange),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(proceedCustomRepeatWithFollowingOption),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(proceedCustomRepeatWithAllOption),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(proceedNoRepeatWithFollowingOption),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(proceedNoRepeatWithAllOption),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(handleEditWorkRecursion),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(editWorkRecursionSaga);
	
	function displayRecursionModal(recursionFlow) {
	  var selectedSchedule, _ref, recursionOption;
	
	  return _regenerator2.default.wrap(function displayRecursionModal$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 2:
	          selectedSchedule = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)(_validate.scheduleValidateActions.toggleRecursionModal({
	            type: _constants.RECURSION_MODAL_TYPES.EDIT_WORK_SLOT,
	            lastDay: (0, _repeatScheduleAdapter.isLastDayOfRepeat)(selectedSchedule),
	            opened: true,
	            recursionFlow: recursionFlow
	          }));
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.take)(_validate.SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION);
	
	        case 7:
	          _ref = _context.sent;
	          recursionOption = _ref.payload.option;
	          return _context.abrupt('return', recursionOption);
	
	        case 10:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	/**
	 *      CHANGE WORK SLOT REPEAT HANDLERS
	 * */
	function proceedNonRepeatableChange(_ref2) {
	  var selectedSchedule = _ref2.selectedSchedule,
	      repeatData = _ref2.repeatData,
	      id = _ref2.id;
	  var scheduleFormData, attrs, updatePayload, canInsert;
	  return _regenerator2.default.wrap(function proceedNonRepeatableChange$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          scheduleFormData = (0, _repeatScheduleAdapter.scheduleFormAdapter)(selectedSchedule);
	          attrs = (0, _repeatScheduleAdapter.scheduleOriginDaySettingsAttrsAdapter)(selectedSchedule);
	          updatePayload = {
	            slotId: selectedSchedule.id,
	            workSlot: (0, _extends3.default)({}, scheduleFormData, {
	              scheduleSettingAttributes: (0, _extends3.default)({}, attrs, repeatData, {
	                endOn: repeatData.endOn || null
	              })
	            }),
	            id: id
	          };
	          _context2.next = 5;
	          return (0, _effects.call)(_findIntersectionsSaga.findIntersections, updatePayload);
	
	        case 5:
	          canInsert = _context2.sent;
	
	          if (!canInsert) {
	            _context2.next = 9;
	            break;
	          }
	
	          _context2.next = 9;
	          return (0, _effects.put)(workslotUpdate.actions.send(updatePayload));
	
	        case 9:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function proceedCustomRepeatWithFollowingOption(_ref3) {
	  var selectedSchedule = _ref3.selectedSchedule,
	      repeatData = _ref3.repeatData,
	      id = _ref3.id;
	  var scheduleFormData, attrs, updatePayload, insertPayload, canInsert;
	  return _regenerator2.default.wrap(function proceedCustomRepeatWithFollowingOption$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          scheduleFormData = (0, _repeatScheduleAdapter.scheduleFormAdapter)(selectedSchedule);
	          attrs = (0, _repeatScheduleAdapter.scheduleCurrentDaySettingsAttrsAdapter)(selectedSchedule);
	          updatePayload = {
	            slotId: selectedSchedule.id,
	            workSlot: (0, _extends3.default)({}, scheduleFormData, (0, _repeatScheduleAdapter.getPrevDayRepeatableAdapter)(selectedSchedule)),
	            id: id
	          };
	          insertPayload = {
	            id: id,
	            workSlot: (0, _extends3.default)({}, scheduleFormData, {
	              scheduleSettingAttributes: (0, _extends3.default)({}, attrs, repeatData)
	            })
	          };
	          _context3.next = 6;
	          return (0, _effects.call)(_findIntersectionsSaga.findIntersections, insertPayload);
	
	        case 6:
	          canInsert = _context3.sent;
	
	          if (!canInsert) {
	            _context3.next = 14;
	            break;
	          }
	
	          _context3.next = 10;
	          return (0, _effects.put)(workslotUpdate.actions.send(updatePayload));
	
	        case 10:
	          _context3.next = 12;
	          return (0, _effects.take)(workslotUpdate.actions.succeed);
	
	        case 12:
	          _context3.next = 14;
	          return (0, _effects.put)(workslotInsert.actions.send(insertPayload));
	
	        case 14:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function proceedCustomRepeatWithAllOption(_ref4) {
	  var selectedSchedule = _ref4.selectedSchedule,
	      repeatData = _ref4.repeatData,
	      id = _ref4.id;
	  var scheduleFormData, attrs, updatePayload, canInsert;
	  return _regenerator2.default.wrap(function proceedCustomRepeatWithAllOption$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          scheduleFormData = (0, _repeatScheduleAdapter.scheduleFormAdapter)(selectedSchedule);
	          attrs = (0, _repeatScheduleAdapter.scheduleOriginDaySettingsAttrsAdapter)(selectedSchedule);
	          updatePayload = {
	            slotId: selectedSchedule.id,
	            workSlot: (0, _extends3.default)({}, scheduleFormData, {
	              scheduleSettingAttributes: (0, _extends3.default)({}, attrs, repeatData)
	            }),
	            id: id
	          };
	          _context4.next = 5;
	          return (0, _effects.call)(_findIntersectionsSaga.findIntersections, updatePayload);
	
	        case 5:
	          canInsert = _context4.sent;
	
	          if (!canInsert) {
	            _context4.next = 9;
	            break;
	          }
	
	          _context4.next = 9;
	          return (0, _effects.put)(workslotUpdate.actions.send(updatePayload));
	
	        case 9:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function proceedNoRepeatWithFollowingOption(_ref5) {
	  var selectedSchedule = _ref5.selectedSchedule,
	      id = _ref5.id;
	  var removedSlot;
	  return _regenerator2.default.wrap(function proceedNoRepeatWithFollowingOption$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          removedSlot = (0, _repeatScheduleAdapter.noRepeatScheduleAdapter)(selectedSchedule);
	          _context5.next = 3;
	          return (0, _effects.put)(workslotRemove.actions.send({ id: id, removedSlot: removedSlot }));
	
	        case 3:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function proceedNoRepeatWithAllOption(_ref6) {
	  var selectedSchedule = _ref6.selectedSchedule,
	      id = _ref6.id;
	  var removedSlot, scheduleSettingAttributes, scheduleFormData, workSlot;
	  return _regenerator2.default.wrap(function proceedNoRepeatWithAllOption$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          removedSlot = (0, _repeatScheduleAdapter.removeRepeatScheduleAdapter)(_constants.RECURSION_OPTIONS.ALL_DAYS, selectedSchedule);
	          scheduleSettingAttributes = (0, _repeatScheduleAdapter.removeRepeatScheduleAdapter)(_constants.RECURSION_OPTIONS.CURRENT_DAY, selectedSchedule);
	          scheduleFormData = (0, _repeatScheduleAdapter.scheduleFormAdapter)(selectedSchedule);
	          workSlot = (0, _extends3.default)({}, scheduleFormData, scheduleSettingAttributes);
	          _context6.next = 6;
	          return (0, _effects.put)(workslotRemove.actions.send({ id: id, removedSlot: removedSlot }));
	
	        case 6:
	          _context6.next = 8;
	          return (0, _effects.take)(workslotRemove.actions.succeed);
	
	        case 8:
	          _context6.next = 10;
	          return (0, _effects.put)(workslotInsert.actions.send({ id: id, workSlot: workSlot }));
	
	        case 10:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	/**
	 *      ROOT RECURSION HANDLER
	 * */
	function handleEditWorkRecursion(_ref7) {
	  var payload = _ref7.payload;
	  var id, selectedSchedule, repeatData, repeatValue, recursionFlow, shared, recursionOption;
	  return _regenerator2.default.wrap(function handleEditWorkRecursion$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)(_selectors.selectScheduleTargerProviderId);
	
	        case 2:
	          id = _context7.sent;
	          _context7.next = 5;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 5:
	          selectedSchedule = _context7.sent;
	          repeatData = payload.repeatData, repeatValue = payload.repeatValue;
	          recursionFlow = (0, _repeatScheduleAdapter.getRepeatFlow)(repeatValue);
	          shared = { id: id, selectedSchedule: selectedSchedule, repeatData: repeatData };
	
	          if (selectedSchedule.isRepeatable) {
	            _context7.next = 14;
	            break;
	          }
	
	          _context7.next = 12;
	          return (0, _effects.call)(proceedNonRepeatableChange, shared);
	
	        case 12:
	          _context7.next = 14;
	          return (0, _effects.cancel)();
	
	        case 14:
	          if (!(0, _repeatScheduleAdapter.isOnlyEndRepeatDateChange)(selectedSchedule, payload)) {
	            _context7.next = 19;
	            break;
	          }
	
	          _context7.next = 17;
	          return (0, _effects.call)(proceedCustomRepeatWithAllOption, shared);
	
	        case 17:
	          _context7.next = 19;
	          return (0, _effects.cancel)();
	
	        case 19:
	          if (!(0, _repeatScheduleAdapter.isFirstDayOfCustomRepeatChange)(selectedSchedule, recursionFlow)) {
	            _context7.next = 24;
	            break;
	          }
	
	          _context7.next = 22;
	          return (0, _effects.call)(proceedCustomRepeatWithAllOption, shared);
	
	        case 22:
	          _context7.next = 24;
	          return (0, _effects.cancel)();
	
	        case 24:
	          _context7.next = 26;
	          return (0, _effects.call)(displayRecursionModal, recursionFlow);
	
	        case 26:
	          recursionOption = _context7.sent;
	          _context7.t0 = recursionOption;
	          _context7.next = _context7.t0 === _constants.RECURSION_OPTIONS.UPDATE_CUSTOM_FOLOWING ? 30 : _context7.t0 === _constants.RECURSION_OPTIONS.UPDATE_CUSTOM_ALL ? 35 : _context7.t0 === _constants.RECURSION_OPTIONS.NO_REPEAT_FOLOWING ? 40 : _context7.t0 === _constants.RECURSION_OPTIONS.NO_REPEAT_ALL ? 45 : 50;
	          break;
	
	        case 30:
	          _context7.next = 32;
	          return (0, _effects.call)(proceedCustomRepeatWithFollowingOption, shared);
	
	        case 32:
	          _context7.next = 34;
	          return (0, _effects.cancel)();
	
	        case 34:
	          return _context7.abrupt('break', 53);
	
	        case 35:
	          _context7.next = 37;
	          return (0, _effects.call)(proceedCustomRepeatWithAllOption, shared);
	
	        case 37:
	          _context7.next = 39;
	          return (0, _effects.cancel)();
	
	        case 39:
	          return _context7.abrupt('break', 53);
	
	        case 40:
	          _context7.next = 42;
	          return (0, _effects.call)(proceedNoRepeatWithFollowingOption, shared);
	
	        case 42:
	          _context7.next = 44;
	          return (0, _effects.cancel)();
	
	        case 44:
	          return _context7.abrupt('break', 53);
	
	        case 45:
	          _context7.next = 47;
	          return (0, _effects.call)(proceedNoRepeatWithAllOption, shared);
	
	        case 47:
	          _context7.next = 49;
	          return (0, _effects.cancel)();
	
	        case 49:
	          return _context7.abrupt('break', 53);
	
	        case 50:
	          console.log('unhandled recursion option', recursionOption, recursionFlow);
	          _context7.next = 53;
	          return (0, _effects.cancel)();
	
	        case 53:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function editWorkRecursionSaga() {
	  return _regenerator2.default.wrap(function editWorkRecursionSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.takeLatest)([_validate.SCHEDULE_VALIDATE_TYPES.EDIT_WORK_RECURSION], handleEditWorkRecursion);
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}

/***/ }),
/* 4166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = scheduleErrorHandlingSaga;
	
	var _effects = __webpack_require__(14);
	
	var _workslotInsertReq = __webpack_require__(431);
	
	var workslotInsert = _interopRequireWildcard(_workslotInsertReq);
	
	var _workslotUpdateReq = __webpack_require__(545);
	
	var workslotUpdate = _interopRequireWildcard(_workslotUpdateReq);
	
	var _blockslotInsertReq = __webpack_require__(430);
	
	var blockslotInsert = _interopRequireWildcard(_blockslotInsertReq);
	
	var _scheduleSearchReq = __webpack_require__(690);
	
	var scheduleSearch = _interopRequireWildcard(_scheduleSearchReq);
	
	var _workslotRemoveReq = __webpack_require__(544);
	
	var workslotRemove = _interopRequireWildcard(_workslotRemoveReq);
	
	var _blockslotRemoveReq = __webpack_require__(542);
	
	var blockslotRemove = _interopRequireWildcard(_blockslotRemoveReq);
	
	var _blockslotUpdateReq = __webpack_require__(543);
	
	var blockslotUpdate = _interopRequireWildcard(_blockslotUpdateReq);
	
	var _error = __webpack_require__(101);
	
	var error = _interopRequireWildcard(_error);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleScheduleInsertError),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleScheduleRemoveError),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleScheduleSearchError),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(handleScheduleUpdateError),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(scheduleErrorHandlingSaga);
	
	function takeErrorConstants(target) {
	  return [target.consts.ERROR_ENCOUNTERED, target.consts.REJECTED];
	}
	
	function handleScheduleInsertError() {
	  return _regenerator2.default.wrap(function handleScheduleInsertError$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(error.actions.update({ id: 'calendar.errors.insert.common' }));
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleScheduleRemoveError() {
	  return _regenerator2.default.wrap(function handleScheduleRemoveError$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)(error.actions.update({ id: 'calendar.errors.remove.common' }));
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleScheduleSearchError() {
	  return _regenerator2.default.wrap(function handleScheduleSearchError$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.put)(error.actions.update({ id: 'calendar.errors.search.common' }));
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	function handleScheduleUpdateError() {
	  return _regenerator2.default.wrap(function handleScheduleUpdateError$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.put)(error.actions.update({ id: 'calendar.errors.update.common' }));
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function scheduleErrorHandlingSaga() {
	  return _regenerator2.default.wrap(function scheduleErrorHandlingSaga$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return (0, _effects.takeLatest)([].concat((0, _toConsumableArray3.default)(takeErrorConstants(workslotInsert)), (0, _toConsumableArray3.default)(takeErrorConstants(blockslotInsert))), handleScheduleInsertError);
	
	        case 2:
	          _context5.next = 4;
	          return (0, _effects.takeLatest)([].concat((0, _toConsumableArray3.default)(takeErrorConstants(workslotRemove)), (0, _toConsumableArray3.default)(takeErrorConstants(blockslotRemove))), handleScheduleRemoveError);
	
	        case 4:
	          _context5.next = 6;
	          return (0, _effects.takeLatest)(takeErrorConstants(scheduleSearch), handleScheduleSearchError);
	
	        case 6:
	          _context5.next = 8;
	          return (0, _effects.takeLatest)([].concat((0, _toConsumableArray3.default)(takeErrorConstants(workslotUpdate)), (0, _toConsumableArray3.default)(takeErrorConstants(blockslotUpdate))), handleScheduleUpdateError);
	
	        case 8:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}

/***/ }),
/* 4167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _removeMethodMap;
	
	exports.default = onRemoveScheduleSaga;
	
	var _effects = __webpack_require__(14);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _workslotRemoveReq = __webpack_require__(544);
	
	var workslotRemove = _interopRequireWildcard(_workslotRemoveReq);
	
	var _blockslotRemoveReq = __webpack_require__(542);
	
	var blockslotRemove = _interopRequireWildcard(_blockslotRemoveReq);
	
	var _validate = __webpack_require__(143);
	
	var _constants = __webpack_require__(105);
	
	var _repeatScheduleAdapter = __webpack_require__(698);
	
	var _selectors = __webpack_require__(88);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(removeSchedule),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleRemoveSchedule),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(onRemoveScheduleSaga);
	
	var removeMethodMap = (_removeMethodMap = {}, (0, _defineProperty3.default)(_removeMethodMap, _constants.SCHEDULE_TYPES.WORK, {
	  method: workslotRemove.actions.send,
	  modalType: _constants.RECURSION_MODAL_TYPES.REMOVE_WORK_SLOT
	}), (0, _defineProperty3.default)(_removeMethodMap, _constants.SCHEDULE_TYPES.BLOCK, {
	  method: blockslotRemove.actions.send,
	  modalType: _constants.RECURSION_MODAL_TYPES.REMOVE_BLOCK_SLOT
	}), _removeMethodMap);
	
	function removeSchedule(_ref) {
	  var schedule = _ref.schedule,
	      recursionOption = _ref.recursionOption;
	
	  var id, type, removedSlot, _ref2, method;
	
	  return _regenerator2.default.wrap(function removeSchedule$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectScheduleTargerProviderId);
	
	        case 2:
	          id = _context.sent;
	          type = (0, _get2.default)(schedule, '__type');
	          removedSlot = (0, _repeatScheduleAdapter.removeRepeatScheduleAdapter)(recursionOption, schedule);
	          _ref2 = removeMethodMap[type] || {}, method = _ref2.method;
	
	          if (!(!removedSlot || !method)) {
	            _context.next = 9;
	            break;
	          }
	
	          _context.next = 9;
	          return (0, _effects.cancel)();
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)(method({ id: id, removedSlot: removedSlot }));
	
	        case 11:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleRemoveSchedule(_ref3) {
	  var schedule = _ref3.payload;
	
	  var isRepeatable, type, _ref4, modalType, _ref5, recursionOption;
	
	  return _regenerator2.default.wrap(function handleRemoveSchedule$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          isRepeatable = (0, _get2.default)(schedule, 'isRepeatable');
	          type = (0, _get2.default)(schedule, '__type');
	          _ref4 = removeMethodMap[type] || {}, modalType = _ref4.modalType;
	
	          if (!isRepeatable) {
	            _context2.next = 14;
	            break;
	          }
	
	          _context2.next = 6;
	          return (0, _effects.put)(_validate.scheduleValidateActions.toggleRecursionModal({
	            type: modalType,
	            lastDay: (0, _repeatScheduleAdapter.isLastDayOfRepeat)(schedule),
	            opened: true
	          }));
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.take)(_validate.SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION);
	
	        case 8:
	          _ref5 = _context2.sent;
	          recursionOption = _ref5.payload.option;
	          _context2.next = 12;
	          return (0, _effects.call)(removeSchedule, { schedule: schedule, recursionOption: recursionOption });
	
	        case 12:
	          _context2.next = 14;
	          return (0, _effects.cancel)();
	
	        case 14:
	          _context2.next = 16;
	          return (0, _effects.call)(removeSchedule, {
	            recursionOption: _constants.RECURSION_OPTIONS.CURRENT_DAY,
	            schedule: schedule
	          });
	
	        case 16:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function onRemoveScheduleSaga() {
	  return _regenerator2.default.wrap(function onRemoveScheduleSaga$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.takeLatest)([_validate.SCHEDULE_VALIDATE_TYPES.REMOVE_SCHEDULE], handleRemoveSchedule);
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}

/***/ }),
/* 4168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = popverHoverSaga;
	
	var _effects = __webpack_require__(14);
	
	var _selectedPopover = __webpack_require__(432);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleOptimizedPopoverSetPosition),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(popverHoverSaga);
	
	function handleOptimizedPopoverSetPosition(_ref) {
	  var payload = _ref.payload;
	  return _regenerator2.default.wrap(function handleOptimizedPopoverSetPosition$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(_selectedPopover.selectedPopoverActions.setOptimizedPosition(payload));
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	var DEFAULT_VAL = 250;
	var fromParams = Number(location.hash.replace('#debounce=', '') || DEFAULT_VAL);
	var DEBOUNCE_VALUE = isNaN(fromParams) ? DEFAULT_VAL : fromParams;
	
	function popverHoverSaga() {
	  return _regenerator2.default.wrap(function popverHoverSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.debounce)(DEBOUNCE_VALUE, _selectedPopover.SELECTED_POPOVER_TYPES.SET_POSITION, handleOptimizedPopoverSetPosition);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = validateOnMount;
	
	var _effects = __webpack_require__(14);
	
	var _isNumber = __webpack_require__(1558);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isNaN = __webpack_require__(5507);
	
	var _isNaN2 = _interopRequireDefault(_isNaN);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRouter = __webpack_require__(42);
	
	var _validate = __webpack_require__(143);
	
	var _getParentProvider = __webpack_require__(680);
	
	var _selectors = __webpack_require__(23);
	
	var _routes = __webpack_require__(37);
	
	var _selectors2 = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(handleValidation),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(validateOnMount);
	
	function redirect() {
	  _reactRouter.browserHistory.replace('/' + _routes.HEALTHBOARD);
	}
	
	var MIN_CALENDAR_WIDTH = 768;
	
	function handleValidation(_ref) {
	  var _ref$payload = _ref.payload,
	      payload = _ref$payload === undefined ? {} : _ref$payload;
	
	  var hasAccess, isProvider, loggedId, id, providerId, scheduleAdmin, _ref2, failed, newAccess, providerProfile, sameId;
	
	  return _regenerator2.default.wrap(function handleValidation$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors2.selectProviderCalendarManageAccess);
	
	        case 2:
	          hasAccess = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.hasProviderProfileSelector);
	
	        case 5:
	          isProvider = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.providerProfileIdSelector);
	
	        case 8:
	          loggedId = _context.sent;
	          id = payload.id, providerId = payload.providerId;
	          scheduleAdmin = Number(loggedId) !== Number(providerId);
	
	          if (!(window.innerWidth < MIN_CALENDAR_WIDTH)) {
	            _context.next = 15;
	            break;
	          }
	
	          _reactRouter.browserHistory.replace(_routes.CALENDAR_MOB);
	
	          _context.next = 15;
	          return (0, _effects.cancel)();
	
	        case 15:
	          if (!(!isProvider || !checkParams(id, providerId))) {
	            _context.next = 19;
	            break;
	          }
	
	          redirect();
	          _context.next = 19;
	          return (0, _effects.cancel)();
	
	        case 19:
	          if (hasAccess) {
	            _context.next = 41;
	            break;
	          }
	
	          _context.next = 22;
	          return (0, _effects.put)(_getParentProvider.actions.send({ id: id }));
	
	        case 22:
	          _context.next = 24;
	          return (0, _effects.race)({
	            succeed: (0, _effects.take)(_getParentProvider.actions.succeed),
	            failed: (0, _effects.take)([_getParentProvider.actions.rejected, _getParentProvider.actions.errorEncountered])
	          });
	
	        case 24:
	          _ref2 = _context.sent;
	          failed = _ref2.failed;
	
	          if (!failed) {
	            _context.next = 30;
	            break;
	          }
	
	          redirect();
	          _context.next = 30;
	          return (0, _effects.cancel)();
	
	        case 30:
	          _context.next = 32;
	          return (0, _effects.select)(_selectors2.selectProviderCalendarManageAccess);
	
	        case 32:
	          newAccess = _context.sent;
	          _context.next = 35;
	          return (0, _effects.select)(_selectors2.selectProviderProfile);
	
	        case 35:
	          providerProfile = _context.sent;
	          sameId = (0, _get2.default)(providerProfile, 'primaryProviderProfile.id') === Number(providerId);
	
	          if (!(!newAccess || !sameId)) {
	            _context.next = 41;
	            break;
	          }
	
	          redirect();
	          _context.next = 41;
	          return (0, _effects.cancel)();
	
	        case 41:
	          _context.next = 43;
	          return (0, _effects.put)(_validate.scheduleValidateActions.finishValidate({ id: id, providerId: providerId, scheduleAdmin: scheduleAdmin }));
	
	        case 43:
	          _context.next = 45;
	          return (0, _effects.cancel)();
	
	        case 45:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function validateOnMount() {
	  return _regenerator2.default.wrap(function validateOnMount$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_validate.SCHEDULE_VALIDATE_TYPES.VALIDATE, handleValidation);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function checkNumber(value) {
	  var number = Number(value);
	  return (0, _isNumber2.default)(number) && !(0, _isNaN2.default)(number);
	}
	
	function checkParams(id, providerId) {
	  return checkNumber(id) && checkNumber(providerId);
	}

/***/ }),
/* 4170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = workslotInsertSaga;
	
	var _effects = __webpack_require__(14);
	
	var _isEmpty = __webpack_require__(51);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _workslotInsertReq = __webpack_require__(431);
	
	var workslotInsert = _interopRequireWildcard(_workslotInsertReq);
	
	var _workslotUpdateReq = __webpack_require__(545);
	
	var workslotUpdate = _interopRequireWildcard(_workslotUpdateReq);
	
	var _intersectionCountsReq = __webpack_require__(896);
	
	var intersections = _interopRequireWildcard(_intersectionCountsReq);
	
	var _validate = __webpack_require__(143);
	
	var _selectors = __webpack_require__(88);
	
	var _constants = __webpack_require__(105);
	
	var _repeatScheduleAdapter = __webpack_require__(698);
	
	var _findIntersectionsSaga = __webpack_require__(1903);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(insertOrUpdateWorkSlot),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(handleRecursion),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(handleStartWorkslotInserting),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(workslotInsertSaga);
	
	function insertOrUpdateWorkSlot(payload) {
	  return _regenerator2.default.wrap(function insertOrUpdateWorkSlot$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.put)(workslotInsert.actions.send(payload));
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function handleRecursion(_ref) {
	  var payload = _ref.payload;
	
	  var scheduleFormData, id, selectedSchedule, _ref2, recursionOption, formattedData, slotData, canInsert;
	
	  return _regenerator2.default.wrap(function handleRecursion$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          scheduleFormData = payload.workSlot, id = payload.id;
	          _context2.next = 3;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 3:
	          selectedSchedule = _context2.sent;
	          _context2.next = 6;
	          return (0, _effects.put)(_validate.scheduleValidateActions.toggleRecursionModal({
	            opened: true,
	            lastDay: (0, _repeatScheduleAdapter.isLastDayOfRepeat)(selectedSchedule),
	            type: _constants.RECURSION_MODAL_TYPES.EDIT_WORK_SLOT
	          }));
	
	        case 6:
	          _context2.next = 8;
	          return (0, _effects.take)(_validate.SCHEDULE_VALIDATE_TYPES.APPLY_RECURSION);
	
	        case 8:
	          _ref2 = _context2.sent;
	          recursionOption = _ref2.payload.option;
	          formattedData = (0, _repeatScheduleAdapter.repeatScheduleAdapter)(recursionOption, selectedSchedule, scheduleFormData);
	
	          if (formattedData) {
	            _context2.next = 14;
	            break;
	          }
	
	          _context2.next = 14;
	          return (0, _effects.cancel)();
	
	        case 14:
	          slotData = { id: id, workSlot: formattedData };
	          _context2.next = 17;
	          return (0, _effects.call)(_findIntersectionsSaga.findIntersections, slotData);
	
	        case 17:
	          canInsert = _context2.sent;
	
	          if (!canInsert) {
	            _context2.next = 21;
	            break;
	          }
	
	          _context2.next = 21;
	          return (0, _effects.call)(insertOrUpdateWorkSlot, slotData);
	
	        case 21:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function handleStartWorkslotInserting(action) {
	  var selectedSchedule, isRepeatable, canInsert;
	  return _regenerator2.default.wrap(function handleStartWorkslotInserting$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return (0, _effects.select)(_selectors.selectSchedulePopoverData);
	
	        case 2:
	          selectedSchedule = _context3.sent;
	          isRepeatable = (0, _get2.default)(selectedSchedule, 'isRepeatable');
	
	          if (!isRepeatable) {
	            _context3.next = 9;
	            break;
	          }
	
	          _context3.next = 7;
	          return (0, _effects.call)(handleRecursion, action);
	
	        case 7:
	          _context3.next = 9;
	          return (0, _effects.cancel)();
	
	        case 9:
	          _context3.next = 11;
	          return (0, _effects.call)(_findIntersectionsSaga.findIntersections, action.payload);
	
	        case 11:
	          canInsert = _context3.sent;
	
	          if (!canInsert) {
	            _context3.next = 15;
	            break;
	          }
	
	          _context3.next = 15;
	          return (0, _effects.call)(insertOrUpdateWorkSlot, action.payload);
	
	        case 15:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function workslotInsertSaga() {
	  return _regenerator2.default.wrap(function workslotInsertSaga$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeLatest)([workslotInsert.consts.START], handleStartWorkslotInserting);
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}

/***/ }),
/* 4171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runRootSaga = undefined;
	
	var _redux = __webpack_require__(98);
	
	var _reduxSaga = __webpack_require__(485);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _reduxThunk = __webpack_require__(6469);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _browserHistory = __webpack_require__(97);
	
	var _reactRouterRedux = __webpack_require__(1037);
	
	var _env = __webpack_require__(103);
	
	var _reducers = __webpack_require__(1357);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _sagas = __webpack_require__(4158);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routingMiddleware = (0, _reactRouterRedux.routerMiddleware)(_browserHistory.browserHistory);
	var sagaMiddleware = (0, _reduxSaga2.default)();
	var middlewares = [_reduxThunk2.default, sagaMiddleware, routingMiddleware];
	var composeEnhancers = _env.DEV_ENV && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
	
	var runRootSaga = exports.runRootSaga = function runRootSaga(store) {
	  sagaMiddleware.run(_sagas2.default, { dispatch: store.dispatch });
	};
	
	var create = function create() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (_env.DEV_ENV) {
	    /* eslint-disable global-require, import/no-extraneous-dependencies */
	    var createLogger = __webpack_require__(6468);
	    /* eslint-enable global-require, import/no-extraneous-dependencies */
	    var logger = createLogger({
	      level: 'info',
	      duration: true,
	      collapsed: true,
	      diff: true
	    });
	    if (!_env.DISABLE_LOGS) {
	      middlewares.push(logger);
	    }
	  }
	
	  var store = (0, _redux.createStore)((0, _reducers2.default)(), state, composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));
	
	  store.runSaga = sagaMiddleware.run;
	  store.injectedReducers = {}; // Reducer registry
	  store.injectedSagas = {}; // Sag
	
	  return store;
	};
	
	exports.default = create;

/***/ }),
/* 4172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.surveyActions = undefined;
	
	var _createAction = __webpack_require__(68);
	
	var _constants = __webpack_require__(1366);
	
	var surveyActions = exports.surveyActions = {
	  linkConsent: (0, _createAction.createAction)(_constants.SURVEYS_TYPES.LINK_CONSENT)
	};

/***/ }),
/* 4173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.getIncomingSurveysSaga = getIncomingSurveysSaga;
	
	var _effects = __webpack_require__(14);
	
	var _saved = __webpack_require__(900);
	
	var _submit = __webpack_require__(691);
	
	var _upcoming = __webpack_require__(309);
	
	var _answered = __webpack_require__(355);
	
	var _selectors = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(getIncomingSurveysWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getIncomingSurveysSaga);
	
	function getIncomingSurveysWorker(action) {
	  var id, _action$payload, userId, surveyId;
	
	  return _regenerator2.default.wrap(function getIncomingSurveysWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.take)(_submit.consts.SUCCEED);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.put)({
	            type: _submit.consts.MESSAGE,
	            payload: action.payload.message
	          });
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.select)(_selectors.targetUserIdSelector);
	
	        case 6:
	          id = _context.sent;
	          _context.next = 9;
	          return (0, _effects.put)({
	            type: _upcoming.consts.DELETE_ANSWERED_ITEM,
	            payload: action.payload.surveyId
	          });
	
	        case 9:
	          _context.next = 11;
	          return (0, _effects.put)({
	            type: _upcoming.paginatedConsts.LOAD_NEXT_REQUESTS,
	            payload: { limit: 1, id: action.payload.userId }
	          });
	
	        case 11:
	          _action$payload = action.payload, userId = _action$payload.userId, surveyId = _action$payload.surveyId;
	          _context.next = 14;
	          return (0, _effects.put)({
	            type: _saved.consts.REMOVE_SURVEY,
	            payload: { userId: userId, surveyId: surveyId }
	          });
	
	        case 14:
	          _context.next = 16;
	          return (0, _effects.put)({
	            type: _answered.consts.SEND,
	            payload: { id: id }
	          });
	
	        case 16:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function getIncomingSurveysSaga() {
	  return _regenerator2.default.wrap(function getIncomingSurveysSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_submit.consts.SEND, getIncomingSurveysWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _answered = __webpack_require__(355);
	
	var _answered2 = _interopRequireDefault(_answered);
	
	var _saved = __webpack_require__(900);
	
	var _saved2 = _interopRequireDefault(_saved);
	
	var _submit = __webpack_require__(691);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _upcoming = __webpack_require__(309);
	
	var _upcoming2 = _interopRequireDefault(_upcoming);
	
	var _forms = __webpack_require__(1367);
	
	var _forms2 = _interopRequireDefault(_forms);
	
	var _sendSurvey = __webpack_require__(901);
	
	var _sendSurvey2 = _interopRequireDefault(_sendSurvey);
	
	var _exportToPDF = __webpack_require__(899);
	
	var _exportToPDF2 = _interopRequireDefault(_exportToPDF);
	
	var _submitReferralForm = __webpack_require__(692);
	
	var _submitReferralForm2 = _interopRequireDefault(_submitReferralForm);
	
	var _reqReferralForms = __webpack_require__(1369);
	
	var _reqReferralForms2 = _interopRequireDefault(_reqReferralForms);
	
	var _reqFormResult = __webpack_require__(1368);
	
	var _reqFormResult2 = _interopRequireDefault(_reqFormResult);
	
	var _upcomingSurvey = __webpack_require__(433);
	
	var _upcomingSurvey2 = _interopRequireDefault(_upcomingSurvey);
	
	var _upcomingSurveyAnswers = __webpack_require__(546);
	
	var _upcomingSurveyAnswers2 = _interopRequireDefault(_upcomingSurveyAnswers);
	
	var _upcomingSurveyProceed = __webpack_require__(694);
	
	var _upcomingSurveyProceed2 = _interopRequireDefault(_upcomingSurveyProceed);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _upcomingSurveyCompletions2 = _interopRequireDefault(_upcomingSurveyCompletions);
	
	var _upcomingSurveyCancelFilling = __webpack_require__(693);
	
	var _upcomingSurveyCancelFilling2 = _interopRequireDefault(_upcomingSurveyCancelFilling);
	
	var _appointmentConsentReq = __webpack_require__(898);
	
	var _appointmentConsentReq2 = _interopRequireDefault(_appointmentConsentReq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  answered: _answered2.default,
	  saved: _saved2.default,
	  submit: _submit2.default,
	  upcoming: _upcoming2.default,
	  forms: _forms2.default,
	  sendSurvey: _sendSurvey2.default,
	  pdfExport: _exportToPDF2.default,
	  submitReferralForm: _submitReferralForm2.default,
	  reqReferralForms: _reqReferralForms2.default,
	  reqFormResult: _reqFormResult2.default,
	  upcomingSurvey: _upcomingSurvey2.default,
	  upcomingSurveyAnswers: _upcomingSurveyAnswers2.default,
	  upcomingSurveyProceed: _upcomingSurveyProceed2.default,
	  upcomingSurveyCompletions: _upcomingSurveyCompletions2.default,
	  upcomingSurveyCancelFilling: _upcomingSurveyCancelFilling2.default,
	  appointmentConsent: _appointmentConsentReq2.default
	});

/***/ }),
/* 4175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = answeredSurveysPaginationSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _answered = __webpack_require__(355);
	
	var _selectors = __webpack_require__(158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(answeredSurveysPaginationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(answeredSurveysPaginationSaga);
	
	function answeredSurveysPaginationWorker(_ref) {
	  var _ref$payload = _ref.payload;
	  _ref$payload = _ref$payload === undefined ? {} : _ref$payload;
	  var limit = _ref$payload.limit,
	      id = _ref$payload.id;
	  var paginationOptions, requestsTotal, existingRequests, params;
	  return _regenerator2.default.wrap(function answeredSurveysPaginationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.select)(_selectors.selectAnsweredPagination);
	
	        case 2:
	          paginationOptions = _context.sent;
	          _context.next = 5;
	          return (0, _effects.select)(_selectors.selectAnsweredListCounter);
	
	        case 5:
	          requestsTotal = _context.sent;
	          _context.next = 8;
	          return (0, _effects.select)(_selectors.selectAnsweredList);
	
	        case 8:
	          existingRequests = _context.sent;
	
	          if (!(requestsTotal <= existingRequests.length)) {
	            _context.next = 12;
	            break;
	          }
	
	          _context.next = 12;
	          return (0, _effects.cancel)();
	
	        case 12:
	          params = (0, _lodash.merge)({}, paginationOptions, {
	            offset: existingRequests.length,
	            limit: limit,
	            id: id
	          });
	          _context.next = 15;
	          return (0, _effects.put)(_answered.paginatedActions.updatePaginationParameters(params));
	
	        case 15:
	          _context.next = 17;
	          return (0, _effects.put)({
	            type: _answered.paginatedConsts.SEND,
	            payload: params
	          });
	
	        case 17:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function answeredSurveysPaginationSaga() {
	  return _regenerator2.default.wrap(function answeredSurveysPaginationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_answered.paginatedConsts.LOAD_NEXT_REQUESTS, answeredSurveysPaginationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _upcomingSurveysPaginationSaga = __webpack_require__(4178);
	
	var _upcomingSurveysPaginationSaga2 = _interopRequireDefault(_upcomingSurveysPaginationSaga);
	
	var _answeredSurveysPaginationSaga = __webpack_require__(4175);
	
	var _answeredSurveysPaginationSaga2 = _interopRequireDefault(_answeredSurveysPaginationSaga);
	
	var _sequentialSurveySaga = __webpack_require__(4177);
	
	var _sequentialSurveySaga2 = _interopRequireDefault(_sequentialSurveySaga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_answeredSurveysPaginationSaga2.default);
	
	        case 2:
	          _context.next = 4;
	          return (0, _effects.fork)(_upcomingSurveysPaginationSaga2.default);
	
	        case 4:
	          _context.next = 6;
	          return (0, _effects.fork)(_sequentialSurveySaga2.default);
	
	        case 6:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = upcomingSurveyProceedSaga;
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _findIndex = __webpack_require__(979);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _upcomingSurveyCancelFilling = __webpack_require__(693);
	
	var _upcomingSurveyCompletions = __webpack_require__(203);
	
	var _upcomingSurveyProceed = __webpack_require__(694);
	
	var _upcomingSurveyAnswers = __webpack_require__(546);
	
	var _upcomingSurvey = __webpack_require__(433);
	
	var _answered = __webpack_require__(355);
	
	var _upcoming = __webpack_require__(309);
	
	var _popup = __webpack_require__(76);
	
	var _props = __webpack_require__(41);
	
	var _selectors = __webpack_require__(158);
	
	var _selectors2 = __webpack_require__(23);
	
	var _selectors3 = __webpack_require__(115);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(upcomingSurveyProceedSucceedWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(upcomingSurveyCancelFillingSucceedWorker),
	    _marked3 = /*#__PURE__*/_regenerator2.default.mark(upcomingSurveyProceedRejectedWorker),
	    _marked4 = /*#__PURE__*/_regenerator2.default.mark(upcomingSurveyAnswersWorker),
	    _marked5 = /*#__PURE__*/_regenerator2.default.mark(finishingSurvey),
	    _marked6 = /*#__PURE__*/_regenerator2.default.mark(showScoreDescription),
	    _marked7 = /*#__PURE__*/_regenerator2.default.mark(upcomingSurveyCompletionsWorker),
	    _marked8 = /*#__PURE__*/_regenerator2.default.mark(upcomingSurveyProceedSaga);
	
	function upcomingSurveyProceedSucceedWorker(_ref) {
	  var payload = _ref.payload;
	  var meta;
	  return _regenerator2.default.wrap(function upcomingSurveyProceedSucceedWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.take)(_upcomingSurveyProceed.consts.ADD_META);
	
	        case 2:
	          meta = _context.sent;
	          _context.next = 5;
	          return (0, _effects.put)({
	            type: _upcomingSurvey.consts.SUCCEED,
	            payload: (0, _extends3.default)({}, payload, { meta: (0, _get2.default)(meta, 'payload') })
	          });
	
	        case 5:
	          _context.next = 7;
	          return (0, _effects.put)({
	            type: _upcoming.consts.UPDATE_ITEM,
	            payload: payload
	          });
	
	        case 7:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function upcomingSurveyCancelFillingSucceedWorker(_ref2) {
	  var payload = _ref2.payload;
	  return _regenerator2.default.wrap(function upcomingSurveyCancelFillingSucceedWorker$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.put)({
	            type: _upcoming.consts.UPDATE_ITEM,
	            payload: payload
	          });
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}
	
	function upcomingSurveyProceedRejectedWorker(_ref3) {
	  var payload = _ref3.payload;
	  var isStarted, messageId, titleId;
	  return _regenerator2.default.wrap(function upcomingSurveyProceedRejectedWorker$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          isStarted = (0, _get2.default)(payload, 'error.code') === 'already_started';
	          messageId = isStarted ? 'surveys.isStartedMessage' : 'surveys.inProgressMessage';
	          titleId = isStarted ? 'surveys.isStarted' : 'surveys.inProgress';
	          _context3.next = 5;
	          return (0, _effects.put)({
	            type: _popup.consts.SHOW,
	            payload: {
	              contentType: _props.UI_POPUP_TYPES.MESSAGE,
	              contentOptions: {
	                message: { id: messageId },
	                title: { id: titleId }
	              }
	            }
	          });
	
	        case 5:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked3, this);
	}
	
	function upcomingSurveyAnswersWorker(_ref4) {
	  var payload = _ref4.payload;
	  var meta, upcomingSurvey, answers, answerIndex, updatedAnswers, updatedSurvey;
	  return _regenerator2.default.wrap(function upcomingSurveyAnswersWorker$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.take)(_upcomingSurveyAnswers.consts.ADD_META);
	
	        case 2:
	          meta = _context4.sent;
	          _context4.next = 5;
	          return (0, _effects.select)(_selectors.selectUpcomingSurvey);
	
	        case 5:
	          upcomingSurvey = _context4.sent;
	          answers = (0, _get2.default)(upcomingSurvey, 'answers', []);
	          answerIndex = (0, _findIndex2.default)(answers, function (item) {
	            return item.id === payload.id;
	          });
	          updatedAnswers = [].concat((0, _toConsumableArray3.default)(answers));
	
	
	          if (answerIndex !== -1) updatedAnswers.splice(answerIndex, 1, payload);else updatedAnswers.push(payload);
	
	          updatedSurvey = (0, _extends3.default)({}, upcomingSurvey, {
	            answers: updatedAnswers,
	            meta: (0, _get2.default)(meta, 'payload'),
	            status: (0, _get2.default)(meta, 'payload.status')
	          });
	          _context4.next = 13;
	          return (0, _effects.put)({
	            type: _upcomingSurvey.consts.SUCCEED,
	            payload: updatedSurvey
	          });
	
	        case 13:
	          _context4.next = 15;
	          return (0, _effects.put)({
	            type: _upcoming.consts.UPDATE_ITEM,
	            payload: updatedSurvey
	          });
	
	        case 15:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked4, this);
	}
	
	function finishingSurvey(_ref5) {
	  var _ref5$payload = _ref5.payload,
	      token = _ref5$payload.token,
	      statusSurvey = _ref5$payload.statusSurvey,
	      assignmentId = _ref5$payload.assignmentId,
	      withAnswer = _ref5$payload.withAnswer;
	  return _regenerator2.default.wrap(function finishingSurvey$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          if (!withAnswer) {
	            _context5.next = 3;
	            break;
	          }
	
	          _context5.next = 3;
	          return (0, _effects.take)(_upcomingSurveyAnswers.consts.SUCCEED);
	
	        case 3:
	          _context5.next = 5;
	          return (0, _effects.put)({
	            type: _upcomingSurveyCompletions.consts.SEND,
	            payload: {
	              token: token,
	              assignmentId: assignmentId,
	              status: statusSurvey
	            }
	          });
	
	        case 5:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked5, this);
	}
	
	function showScoreDescription(scoreRangeDescription) {
	  return _regenerator2.default.wrap(function showScoreDescription$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.put)(_popup.actions.show({
	            contentType: _props.UI_POPUP_TYPES.MESSAGE,
	            contentOptions: {
	              icon: 'information',
	              message: scoreRangeDescription,
	              buttonTitle: { id: 'submit.expiredToken' }
	            }
	          }));
	
	        case 2:
	          _context6.next = 4;
	          return (0, _effects.take)(_popup.consts.HIDE);
	
	        case 4:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked6, this);
	}
	
	function upcomingSurveyCompletionsWorker(_ref6) {
	  var payload = _ref6.payload;
	  var location, message, scoreRangeDescription, assignmentId, targetUserId, loggedUserId, safeUserId;
	  return _regenerator2.default.wrap(function upcomingSurveyCompletionsWorker$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return (0, _effects.select)(_selectors3.currentLocationSelector);
	
	        case 2:
	          location = _context7.sent;
	          message = (0, _get2.default)(payload, 'survey.responseMessage');
	          scoreRangeDescription = (0, _get2.default)(payload, 'scoreRangeDescription.description', null);
	          _context7.next = 7;
	          return (0, _effects.select)(_selectors.selectUpcomingSurveyAssignmentId);
	
	        case 7:
	          assignmentId = _context7.sent;
	          _context7.next = 10;
	          return (0, _effects.select)(_selectors2.targetUserIdSelector);
	
	        case 10:
	          targetUserId = _context7.sent;
	          _context7.next = 13;
	          return (0, _effects.select)(_selectors2.loggedUserIdSelector);
	
	        case 13:
	          loggedUserId = _context7.sent;
	          safeUserId = targetUserId || loggedUserId;
	
	          if (!location.includes(_routes.HEALTHBOARD)) {
	            _context7.next = 23;
	            break;
	          }
	
	          _context7.next = 18;
	          return (0, _effects.put)({ type: _upcomingSurvey.consts.CLEAR });
	
	        case 18:
	          if (!scoreRangeDescription) {
	            _context7.next = 21;
	            break;
	          }
	
	          _context7.next = 21;
	          return (0, _effects.call)(showScoreDescription, scoreRangeDescription);
	
	        case 21:
	          _context7.next = 23;
	          return (0, _effects.cancel)();
	
	        case 23:
	          _context7.next = 25;
	          return (0, _effects.put)({
	            type: _upcoming.consts.REMOVE_ITEMS,
	            payload: [assignmentId]
	          });
	
	        case 25:
	          _context7.next = 27;
	          return (0, _effects.put)({
	            type: _upcomingSurvey.consts.CLEAR
	          });
	
	        case 27:
	          if (!scoreRangeDescription) {
	            _context7.next = 32;
	            break;
	          }
	
	          _context7.next = 30;
	          return (0, _effects.call)(showScoreDescription, scoreRangeDescription);
	
	        case 30:
	          _context7.next = 34;
	          break;
	
	        case 32:
	          _context7.next = 34;
	          return (0, _effects.put)({
	            type: _upcomingSurveyCompletions.consts.MESSAGE,
	            payload: message
	          });
	
	        case 34:
	          _context7.next = 36;
	          return (0, _effects.put)({
	            type: _upcoming.paginatedConsts.LOAD_NEXT_REQUESTS,
	            payload: { id: safeUserId, limit: 1 }
	          });
	
	        case 36:
	          _context7.next = 38;
	          return (0, _effects.put)({
	            type: _answered.consts.SEND,
	            payload: { id: safeUserId }
	          });
	
	        case 38:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked7, this);
	}
	
	function upcomingSurveyProceedSaga() {
	  return _regenerator2.default.wrap(function upcomingSurveyProceedSaga$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.takeLatest)(_upcomingSurveyProceed.consts.SUCCEED, upcomingSurveyProceedSucceedWorker);
	
	        case 2:
	          _context8.next = 4;
	          return (0, _effects.takeLatest)(_upcomingSurveyCancelFilling.consts.SUCCEED, upcomingSurveyCancelFillingSucceedWorker);
	
	        case 4:
	          _context8.next = 6;
	          return (0, _effects.takeLatest)(_upcomingSurveyProceed.consts.REJECTED, upcomingSurveyProceedRejectedWorker);
	
	        case 6:
	          _context8.next = 8;
	          return (0, _effects.takeLatest)(_upcomingSurveyAnswers.consts.SUCCEED, upcomingSurveyAnswersWorker);
	
	        case 8:
	          _context8.next = 10;
	          return (0, _effects.takeEvery)([_upcomingSurveyCompletions.consts.SUCCEED, _upcomingSurveyCompletions.consts.REJECTED], upcomingSurveyCompletionsWorker);
	
	        case 10:
	          _context8.next = 12;
	          return (0, _effects.takeEvery)(_upcomingSurvey.consts.FINISH, finishingSurvey);
	
	        case 12:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked8, this);
	}

/***/ }),
/* 4178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = upcomingSurveysPaginationSaga;
	
	var _effects = __webpack_require__(14);
	
	var _lodash = __webpack_require__(58);
	
	var _upcoming = __webpack_require__(309);
	
	var _selectors = __webpack_require__(158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(upcomingSurveysPaginationWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(upcomingSurveysPaginationSaga);
	
	function upcomingSurveysPaginationWorker(action) {
	  var payload, limit, id, paginationOptions, requestsTotal, existingRequests, params;
	  return _regenerator2.default.wrap(function upcomingSurveysPaginationWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          payload = action.payload;
	          limit = payload.limit, id = payload.id;
	          _context.next = 4;
	          return (0, _effects.select)(_selectors.upcomingPaginationSelector);
	
	        case 4:
	          paginationOptions = _context.sent;
	          _context.next = 7;
	          return (0, _effects.select)(_selectors.selectUpcomingListCounter);
	
	        case 7:
	          requestsTotal = _context.sent;
	          _context.next = 10;
	          return (0, _effects.select)(_selectors.selectUpcomingList);
	
	        case 10:
	          existingRequests = _context.sent;
	
	          if (!(requestsTotal <= existingRequests.length)) {
	            _context.next = 14;
	            break;
	          }
	
	          _context.next = 14;
	          return (0, _effects.cancel)();
	
	        case 14:
	          params = (0, _lodash.merge)({}, paginationOptions, {
	            offset: existingRequests.length,
	            limit: limit,
	            id: id
	          });
	          _context.next = 17;
	          return (0, _effects.put)(_upcoming.paginatedActions.updatePaginationParameters(params));
	
	        case 17:
	          _context.next = 19;
	          return (0, _effects.put)({
	            type: _upcoming.paginatedConsts.SEND,
	            payload: params
	          });
	
	        case 19:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function upcomingSurveysPaginationSaga() {
	  return _regenerator2.default.wrap(function upcomingSurveysPaginationSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeLatest)(_upcoming.paginatedConsts.LOAD_NEXT_REQUESTS, upcomingSurveysPaginationWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.submitReferralFormSaga = submitReferralFormSaga;
	
	var _effects = __webpack_require__(14);
	
	var _submitReferralForm = __webpack_require__(692);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(submitReferralFormWorker),
	    _marked2 = /*#__PURE__*/_regenerator2.default.mark(submitReferralFormSaga);
	
	function submitReferralFormWorker(action) {
	  var message;
	  return _regenerator2.default.wrap(function submitReferralFormWorker$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          message = action.payload.message;
	          _context.next = 3;
	          return (0, _effects.take)(_submitReferralForm.consts.SUCCEED);
	
	        case 3:
	          _context.next = 5;
	          return (0, _effects.put)({
	            type: _submitReferralForm.consts.MESSAGE,
	            payload: message
	          });
	
	        case 5:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}
	
	function submitReferralFormSaga() {
	  return _regenerator2.default.wrap(function submitReferralFormSaga$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)(_submitReferralForm.consts.SEND, submitReferralFormWorker);
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked2, this);
	}

/***/ }),
/* 4180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _getTeamReq = __webpack_require__(1371);
	
	var _getTeamReq2 = _interopRequireDefault(_getTeamReq);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  getTeamReq: _getTeamReq2.default
	});

/***/ }),
/* 4181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = root;
	
	var _effects = __webpack_require__(14);
	
	var _getTeamReq = __webpack_require__(1371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(root);
	
	function root() {
	  return _regenerator2.default.wrap(function root$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.fork)(_getTeamReq.watcher);
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this);
	}

/***/ }),
/* 4182 */,
/* 4183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(98);
	
	var _drawer = __webpack_require__(185);
	
	var _drawer2 = _interopRequireDefault(_drawer);
	
	var _overlay = __webpack_require__(1905);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _popup = __webpack_require__(76);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _sidebar = __webpack_require__(219);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _createchat = __webpack_require__(902);
	
	var _createchat2 = _interopRequireDefault(_createchat);
	
	var _contextbar = __webpack_require__(695);
	
	var _contextbar2 = _interopRequireDefault(_contextbar);
	
	var _online = __webpack_require__(1904);
	
	var _online2 = _interopRequireDefault(_online);
	
	var _formInProgress = __webpack_require__(1373);
	
	var _formInProgress2 = _interopRequireDefault(_formInProgress);
	
	var _pdfViewer = __webpack_require__(4184);
	
	var _pdfViewer2 = _interopRequireDefault(_pdfViewer);
	
	var _imageViewer = __webpack_require__(903);
	
	var _imageViewer2 = _interopRequireDefault(_imageViewer);
	
	var _locale = __webpack_require__(1374);
	
	var _locale2 = _interopRequireDefault(_locale);
	
	var _success = __webpack_require__(104);
	
	var _success2 = _interopRequireDefault(_success);
	
	var _error = __webpack_require__(101);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _theme = __webpack_require__(1375);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _defaultTab = __webpack_require__(1372);
	
	var _defaultTab2 = _interopRequireDefault(_defaultTab);
	
	var _videoCallEndPopup = __webpack_require__(1376);
	
	var _videoCallEndPopup2 = _interopRequireDefault(_videoCallEndPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  drawer: _drawer2.default,
	  overlay: _overlay2.default,
	  popup: _popup2.default,
	  sidebar: _sidebar2.default,
	  online: _online2.default,
	  formInProgress: _formInProgress2.default,
	  pdfViewer: _pdfViewer2.default,
	  imageViewer: _imageViewer2.default,
	  locale: _locale2.default,
	  success: _success2.default,
	  error: _error2.default,
	  contextbar: _contextbar2.default,
	  createChat: _createchat2.default,
	  theme: _theme2.default,
	  defaultTab: _defaultTab2.default,
	  videoCallEndPopup: _videoCallEndPopup2.default
	});

/***/ }),
/* 4184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actions = exports.consts = undefined;
	
	var _redux = __webpack_require__(7);
	
	var supportedActions = ['OPEN_VIEWER', 'CLOSE'];
	
	var consts = exports.consts = _redux.createConsts.apply(undefined, ['ui', 'pdfViewer'].concat(supportedActions));
	var actions = exports.actions = (0, _redux.createActions)(consts);
	
	var initialState = {
	  opened: false,
	  pdf: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case consts.OPEN_VIEWER:
	      return { opened: true, pdf: action.payload.binary };
	    case consts.CLOSE:
	      return initialState;
	    default:
	      return state;
	  }
	};

/***/ }),
/* 4185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeInsuranceErrorMessage = undefined;
	
	var _errors = __webpack_require__(120);
	
	var makeInsuranceErrorMessage = exports.makeInsuranceErrorMessage = function makeInsuranceErrorMessage(code, formatMessage) {
	  switch (code) {
	    case _errors.INSURANCE_ERROR_CODES.COPAY_NOT_RECEIVED:
	      return {
	        title: formatMessage({ id: 'appointment.form.copayIsNotReceived' }),
	        message: formatMessage({ id: 'appointment.form.verifyInformation' })
	      };
	    case _errors.INSURANCE_ERROR_CODES.INSURANCE_REQUEST_FAILED:
	      return {
	        title: formatMessage({ id: 'appointments.form.noCoverage' }),
	        message: formatMessage({ id: 'appointments.form.noCoverage.tryAgain' })
	      };
	    default:
	      return {
	        title: formatMessage({ id: 'appointments.form.noCoverage' }),
	        message: formatMessage({ id: 'appointment.form.verifyInformation' })
	      };
	  }
	};

/***/ }),
/* 4186 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var makeSafePharmacyAddress = exports.makeSafePharmacyAddress = function makeSafePharmacyAddress(_ref) {
	  var address = _ref.address,
	      city = _ref.city,
	      state = _ref.state;
	  return [address, [city, state].filter(Boolean).join(', ')].filter(Boolean).join(',\n');
	};

/***/ }),
/* 4187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validateForm = __webpack_require__(1911);
	
	var _validateForm2 = _interopRequireDefault(_validateForm);
	
	var _requiredValidator = __webpack_require__(1394);
	
	var _requiredValidator2 = _interopRequireDefault(_requiredValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VALIDATIONS = {
	  requiredFields: {
	    fields: ['password'],
	    handler: _requiredValidator2.default
	  }
	};
	
	exports.default = function (form) {
	  return (0, _validateForm2.default)(form, VALIDATIONS);
	};

/***/ }),
/* 4188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validateForm = __webpack_require__(1911);
	
	var _validateForm2 = _interopRequireDefault(_validateForm);
	
	var _requiredValidator = __webpack_require__(1394);
	
	var _requiredValidator2 = _interopRequireDefault(_requiredValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VALIDATIONS = {
	  requiredFields: {
	    fields: ['password', 'passwordConfirmation'],
	    handler: _requiredValidator2.default
	  }
	};
	
	exports.default = function (form) {
	  return (0, _validateForm2.default)(form, VALIDATIONS);
	};

/***/ }),
/* 4189 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dataURItoBlob = dataURItoBlob;
	function dataURItoBlob(dataURI) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$filename = _ref.filename,
	      filename = _ref$filename === undefined ? 'filename' : _ref$filename;
	
	  var byteString = atob(dataURI.split(',')[1]);
	
	  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
	
	  var ab = new ArrayBuffer(byteString.length);
	
	  var ia = new Uint8Array(ab);
	
	  for (var i = 0; i < byteString.length; i += 1) {
	    ia[i] = byteString.charCodeAt(i);
	  }
	
	  return new File([ab], filename + '.' + mimeString.split('/')[1], {
	    type: mimeString
	  });
	}

/***/ }),
/* 4190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _camelCase = __webpack_require__(322);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var camelCaseKeys = function camelCaseKeys(obj) {
	  return (0, _keys2.default)(obj).reduce(function (acc, key) {
	    acc[(0, _camelCase2.default)(key)] = obj[key];
	
	    return acc;
	  }, {});
	};
	
	exports.default = camelCaseKeys;

/***/ }),
/* 4191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileUploader = function () {
	  function FileUploader(uploadUrl) {
	    (0, _classCallCheck3.default)(this, FileUploader);
	
	    this.url = uploadUrl;
	  }
	
	  (0, _createClass3.default)(FileUploader, [{
	    key: 'upload',
	    value: function upload(_ref) {
	      var _ref$token = _ref.token,
	          token = _ref$token === undefined ? '' : _ref$token,
	          _ref$channelId = _ref.channelId,
	          channelId = _ref$channelId === undefined ? '' : _ref$channelId,
	          _ref$message = _ref.message,
	          message = _ref$message === undefined ? '' : _ref$message,
	          onError = _ref.onError,
	          onProgress = _ref.onProgress,
	          onSuccess = _ref.onSuccess,
	          teamId = _ref.teamId,
	          teamUserId = _ref.teamUserId,
	          _ref$attachments = _ref.attachments,
	          attachments = _ref$attachments === undefined ? null : _ref$attachments,
	          _ref$important = _ref.important,
	          important = _ref$important === undefined ? false : _ref$important,
	          _ref$inboxTaskId = _ref.inboxTaskId,
	          inboxTaskId = _ref$inboxTaskId === undefined ? null : _ref$inboxTaskId,
	          _ref$quoteMessageId = _ref.quoteMessageId,
	          quoteMessageId = _ref$quoteMessageId === undefined ? null : _ref$quoteMessageId;
	
	      var xhr = new XMLHttpRequest();
	      var formData = new FormData();
	
	      formData.append('token', token);
	      formData.append('channelId', channelId);
	      formData.append('channel', channelId); // temp
	      formData.append('message', message);
	      if (teamId) formData.append('team_id', teamId);
	      if (teamUserId) formData.append('user_id', teamUserId);
	      if (important) formData.append('important', important);
	      if (inboxTaskId) formData.append('inbox_task_id', inboxTaskId);
	      if (quoteMessageId) formData.append('quote_message_id', quoteMessageId);
	
	      function arrayToFormData(arr) {
	        arr.forEach(function (object, i) {
	          (0, _keys2.default)(object).forEach(function (key) {
	            return formData.append('attachments[' + i + '][' + key + ']', object[key]);
	          });
	        });
	      }
	
	      arrayToFormData(attachments);
	
	      xhr.open('POST', this.url, true);
	      xhr.setRequestHeader('platform', 'P_WEB');
	
	      if (xhr.upload && onProgress) {
	        xhr.upload.onprogress = onProgress;
	      }
	
	      xhr.onerror = handleError;
	
	      xhr.onload = function () {
	        if (xhr.status === 404) return handleError();
	        onSuccess && onSuccess(xhr.responseBody, xhr); // eslint-disable-line no-unused-expressions
	      };
	      xhr.send(formData);
	
	      // helper
	      function handleError() {
	        onError && onError(new Error(xhr.responseBody)); // eslint-disable-line no-unused-expressions
	      }
	
	      return xhr.abort.bind(xhr);
	    }
	  }]);
	  return FileUploader;
	}();
	
	exports.default = FileUploader;

/***/ }),
/* 4192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _phoenix = __webpack_require__(2664);
	
	var _env = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable immutable/no-mutation */
	/* eslint-disable no-param-reassign,class-methods-use-this */
	var AbstractChannel = function () {
	  function AbstractChannel() {
	    (0, _classCallCheck3.default)(this, AbstractChannel);
	  }
	
	  (0, _createClass3.default)(AbstractChannel, [{
	    key: '_joinChannel',
	    value: function _joinChannel(socket, channelId) {
	      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60000;
	
	      this.channelId = channelId;
	      this.channel = socket.channel(this.channelId);
	
	      this._addListeners();
	      this._handleJoin(this.channel.join(timeout));
	    }
	  }, {
	    key: '_handleJoin',
	    value: function _handleJoin(joining) {
	      var _this = this;
	
	      joining.receive('ignor', function () {
	        if (_env.DISABLE_LOGS) {
	          return;
	        }
	
	        console.error('-- JOIN ' + _this.channelId + '... Auth error!');
	      });
	      joining.receive('ok', function () {
	        if (_env.DISABLE_LOGS) {
	          return;
	        }
	        console.log('-- JOIN ' + _this.channelId + '... OK!');
	      });
	    }
	  }, {
	    key: '_logAction',
	    value: function _logAction(action, payload) {
	      if (_env.DISABLE_LOGS) {
	        return;
	      }
	      console.log('--', action, this.channelId, payload);
	    }
	  }, {
	    key: '_trackPresence',
	    value: function _trackPresence() {
	      var _this2 = this;
	
	      this.channel.on('presence_state', function (data) {
	        return _this2._onRecievePresenceState(data);
	      });
	      this.channel.on('presence_diff', function (data) {
	        return _this2._onRecievePresenceDiff(data);
	      });
	    }
	  }, {
	    key: '_onRecievePresenceState',
	    value: function _onRecievePresenceState(data) {
	      this.presence = _phoenix.Presence.syncState(this.presence, data);
	      this._render();
	    }
	  }, {
	    key: '_onRecievePresenceDiff',
	    value: function _onRecievePresenceDiff(data) {
	      this.presence = _phoenix.Presence.syncDiff(this.presence, data);
	      this._render();
	    }
	  }, {
	    key: '_listBy',
	    value: function _listBy(id, _ref) {
	      var _ref$metas = (0, _slicedToArray3.default)(_ref.metas, 1),
	          first = _ref$metas[0];
	
	      first.username = first.name;
	      first.id = id;
	
	      return first;
	    }
	  }, {
	    key: '_render',
	    value: function _render() {
	      var _this3 = this;
	
	      _phoenix.Presence.list(this.presence, this._listBy).each(function (user) {
	        return user.username + ' @ ' + _this3.channelId + ' get online!';
	      });
	    }
	  }]);
	  return AbstractChannel;
	}();
	/* eslint-enable immutable/no-mutation */
	
	
	exports.default = AbstractChannel;

/***/ }),
/* 4193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _camelize = __webpack_require__(364);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _last = __webpack_require__(463);
	
	var _last2 = _interopRequireDefault(_last);
	
	var _size = __webpack_require__(59);
	
	var _size2 = _interopRequireDefault(_size);
	
	var _uniqBy = __webpack_require__(989);
	
	var _uniqBy2 = _interopRequireDefault(_uniqBy);
	
	var _chat = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable immutable/no-mutation,no-nested-ternary */
	var EXCLUDED_FOR_PROVIDER_NOTIFICATIONS = [_chat.NOTIFICATION_TYPES.UPCOMING_SURVEY, _chat.NOTIFICATION_TYPES.ASSIGN_TO_PROGRAM, _chat.NOTIFICATION_TYPES.REMOVE_FROM_PROGRAM, _chat.NOTIFICATION_TYPES.PROVIDER_ASSIGNED, _chat.NOTIFICATION_TYPES.PROVIDER_REMOVED];
	
	var CircleOfCareChannel = function () {
	  function CircleOfCareChannel(channelId, _ref, _ref2) {
	    var emit = _ref.emit,
	        push = _ref.push;
	    var userId = _ref2.userId,
	        _ref2$unreadCount = _ref2.unreadCount,
	        unreadCount = _ref2$unreadCount === undefined ? 0 : _ref2$unreadCount,
	        lastMessageAt = _ref2.lastMessageAt,
	        isProvider = _ref2.isProvider;
	    (0, _classCallCheck3.default)(this, CircleOfCareChannel);
	
	    // data
	    this.channelId = channelId;
	    this.isProvider = isProvider;
	    this.currentPage = 0;
	    this.messages = [];
	    this.unreadCount = unreadCount;
	    this.lastMessageAt = lastMessageAt;
	    this.userId = userId;
	    this.masterUserId = null;
	    this.totalPages = 0;
	    this.inboxTaskId = null;
	
	    // actions
	    this.emit = emit;
	    this.push = push;
	
	    // update lastMessageAt channel data for empty initialized channels
	    if (lastMessageAt) {
	      this.emit('conversation_changed', this);
	    }
	  }
	
	  (0, _createClass3.default)(CircleOfCareChannel, [{
	    key: 'getMessages',
	    value: function getMessages() {
	      return this.messages;
	    }
	  }, {
	    key: 'sendMessage',
	    value: function sendMessage(_ref3) {
	      var message = _ref3.message,
	          important = _ref3.important,
	          quoteMessageId = _ref3.quoteMessageId,
	          linkPayload = _ref3.linkPayload,
	          inboxTaskId = _ref3.inboxTaskId;
	
	      this.push('conversations:send_message', {
	        channel_id: this.channelId,
	        important: important,
	        message: message,
	        quote_message_id: quoteMessageId,
	        link_payload: linkPayload,
	        inbox_task_id: inboxTaskId
	      });
	    }
	  }, {
	    key: 'bumpActivity',
	    value: function bumpActivity() {
	      this.unreadCount = 0;
	      this.push('conversations:bump_activity', {
	        channel_id: this.channelId
	      });
	      this.emit('bump_activity', this);
	    }
	  }, {
	    key: 'loadNextHistoryPage',
	    value: function loadNextHistoryPage() {
	      var _this = this;
	
	      this.push('conversations:paginated_history', {
	        channel_id: this.channelId,
	        page: this.currentPage + 1
	      }).receive('ok', function (response) {
	        return _this._loadHistory(response);
	      });
	    }
	  }, {
	    key: 'setUnreadCount',
	    value: function setUnreadCount(unreadCount) {
	      this.unreadCount = unreadCount;
	    }
	  }, {
	    key: 'setMasterUserId',
	    value: function setMasterUserId(id) {
	      this.masterUserId = id;
	    }
	  }, {
	    key: '_onRecieveRemoveMessages',
	    value: function _onRecieveRemoveMessages(data) {
	      var ids = data.ids.map(Number);
	
	      var _messages$reduce = this.messages.reduce(function (acc, msg) {
	        var type = ids.includes(msg.id) ? 'removed' : 'unchanged';
	        acc[type].push(msg);
	
	        return acc;
	      }, { unchanged: [], removed: [] }),
	          unchanged = _messages$reduce.unchanged,
	          removed = _messages$reduce.removed;
	
	      this.messages = unchanged;
	      // decrease counters on message delete event
	      // this.unreadCount = get(data, 'unreadCount', this.unreadCount);
	      this.lastMessageAt = (0, _get2.default)((0, _last2.default)(this.messages), 'insertedAt');
	
	      this.emit('remove_messages', { channel: this, removed: removed });
	    }
	  }, {
	    key: '_onRecieveNewMessage',
	    value: function _onRecieveNewMessage(data) {
	      var isLoggedUserMessage = this.userId === (0, _get2.default)(data, 'message.authorUid');
	      var notificationType = (0, _get2.default)(data, 'message.payload.data.type');
	      var excludeNotifications = this.isProvider && EXCLUDED_FOR_PROVIDER_NOTIFICATIONS.includes(notificationType);
	      var hasTriggeredMessage = (0, _size2.default)((0, _get2.default)(data, 'message.payload.data.triggerMessages')) > 0;
	      var excludedCompletedSurvey = this.isProvider && notificationType === _chat.NOTIFICATION_TYPES.ANSWERED_SURVEY && !hasTriggeredMessage;
	
	      if (!isLoggedUserMessage && !excludeNotifications && !excludedCompletedSurvey) {
	        // increase counters on new message event
	        this.unreadCount++;
	      }
	      this.messages.push(data.message);
	      this.lastMessageAt = (0, _get2.default)(data.message, 'insertedAt');
	      this.masterUserId = (0, _get2.default)(data, 'message.masterUserId');
	      this.inboxTaskId = (0, _get2.default)(data, 'message.inboxTaskId');
	
	      this.emit('conversation_changed', this);
	    }
	  }, {
	    key: '_loadHistory',
	    value: function _loadHistory(response) {
	      this.currentPage++;
	      this.totalPages = (0, _get2.default)(response.messages, 'total_pages');
	      var entries = (0, _get2.default)(response, 'messages.entries', []);
	      this.messages = (0, _camelize2.default)(entries).concat(this.messages);
	      this.messages = (0, _uniqBy2.default)(this.messages, 'id');
	      this._sortAllMessages();
	      this.emit('conversation_changed', this);
	    }
	  }, {
	    key: '_sortAllMessages',
	    value: function _sortAllMessages() {
	      var sortById = function sortById(a, b) {
	        return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
	      };
	
	      this.messages = this.messages.sort(sortById);
	    }
	  }]);
	  return CircleOfCareChannel;
	}();
	
	exports.default = CircleOfCareChannel;

/***/ }),
/* 4194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _camelize = __webpack_require__(364);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	var _abstract_channel = __webpack_require__(4192);
	
	var _abstract_channel2 = _interopRequireDefault(_abstract_channel);
	
	var _chat = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UPDATE_CHAT_NOTIFICATION = [_chat.NOTIFICATION_TYPES.PARTICIPANT_REMOVED, _chat.NOTIFICATION_TYPES.PARTICIPANT_ADDED];
	
	var SystemChannel = function (_AbstractChannel) {
	  (0, _inherits3.default)(SystemChannel, _AbstractChannel);
	
	  function SystemChannel(connection) {
	    (0, _classCallCheck3.default)(this, SystemChannel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SystemChannel.__proto__ || (0, _getPrototypeOf2.default)(SystemChannel)).call(this));
	
	    _this._joinChannel(connection.socket, 'users:' + connection.userId);
	
	    _this.connection = connection;
	    return _this;
	  }
	
	  (0, _createClass3.default)(SystemChannel, [{
	    key: '_addListeners',
	    value: function _addListeners() {
	      var _this2 = this;
	
	      this.channel.on('users:self_info', function (data) {
	        return _this2._onRecieveSelfInfo(data);
	      });
	
	      this.channel.on('conversations:new_message', function (data) {
	        return _this2._onRecieveNewMessage(data);
	      });
	      this.channel.on('conversations:remove_messages', function (data) {
	        return _this2._onRecieveRemoveMessages(data);
	      });
	      this.channel.on('conversations:remove_chatroom', function (data) {
	        return _this2._onRemoveChatroom(data);
	      });
	      this.channel.on('conversations:remove_context_user', function (data) {
	        return _this2._onRemoveContextUser(data);
	      });
	      this.channel.on('conversations:blocked_channels', function (data) {
	        return _this2._onBlockChannel(data);
	      });
	      this.channel.on('conversations:unblocked_channels', function (data) {
	        return _this2._onBlockChannel(data);
	      });
	      this.channel.on('communities:notification', function (data) {
	        return _this2._onReceiveCommunitiesNotification(data);
	      });
	      this.channel.on('system:notification', function (data) {
	        return _this2._onReceiveSystemNotification(data);
	      });
	      this.channel.on('event:inbox_task_completed', function (data) {
	        _this2._emitFormattedEvent('event:inbox_task_completed', data.data);
	      });
	      this.channel.on('appointsments:change_status', function (data) {
	        _this2._emitFormattedEvent('appointsments:change_status', data.data);
	      });
	      this.channel.on('appointsments:change_room', function (data) {
	        _this2._emitFormattedEvent('appointsments:change_room', data.data);
	      });
	      this.channel.on('appointsments:remove_from_dashboard', function (data) {
	        _this2._emitFormattedEvent('appointsments:remove_from_dashboard', data.data);
	      });
	      this.channel.on('appointsments:pin', function (data) {
	        _this2._emitFormattedEvent('appointsments:pin', data.data);
	      });
	      this.channel.on('appointsments:create', function (data) {
	        _this2._emitFormattedEvent('appointsments:create', data.data);
	      });
	      this.channel.on('appointsments:update_copay', function (data) {
	        _this2._emitFormattedEvent('appointsments:update_copay', data.data);
	      });
	      this.channel.on('appointsments:change_payment_status', function (data) {
	        _this2._emitFormattedEvent('appointsments:change_payment_status', data.data);
	      });
	      this.channel.on('event:paya_accountvault_form_url', function (data) {
	        _this2._emitFormattedEvent('event:paya_accountvault_form_url', data.data);
	      });
	      this.channel.on('event:paya_transaction_successful', function (data) {
	        _this2._emitFormattedEvent('event:paya_transaction_successful', data.data);
	      });
	      this.channel.on('event:paya_transaction_declined', function (data) {
	        _this2._emitFormattedEvent('event:paya_transaction_declined', data.data);
	      });
	      this.channel.on('phx_reply', function (data) {
	        _this2._emitFormattedEvent('phx_reply', data);
	      });
	    }
	  }, {
	    key: '_onRecieveSelfInfo',
	    value: function _onRecieveSelfInfo(data) {
	      this.connection.emit('connection_ready', this);
	      this._logAction('SELF DATA', (0, _get2.default)(data, 'current_entity'));
	
	      var _connection = this.connection,
	          teamId = _connection.teamId,
	          teamUserId = _connection.teamUserId;
	
	
	      if (teamId) {
	        this.channel.push('conversations:mask', {
	          tid: teamId,
	          fid: teamUserId
	        });
	      }
	    }
	  }, {
	    key: '_onRecieveNewMessage',
	    value: function _onRecieveNewMessage(payload) {
	      var data = (0, _camelize2.default)(payload);
	
	      var message = (0, _get2.default)(data, 'message');
	      var updateChat = UPDATE_CHAT_NOTIFICATION.includes((0, _get2.default)(message, 'payload.data.type'));
	      var channel = this._getChannel(data);
	
	      if (channel) {
	        channel._onRecieveNewMessage(data);
	      } else {
	        this.connection.emit('new_channel_activity', data);
	      }
	
	      if (updateChat) {
	        this.connection.emit('update_chat', data);
	      }
	    }
	  }, {
	    key: '_onRemoveChatroom',
	    value: function _onRemoveChatroom(payload) {
	      var data = (0, _camelize2.default)(payload);
	      this.connection.removeChannel(data.channelId);
	      this.connection.emit('remove_chatroom', data);
	    }
	  }, {
	    key: '_onRemoveContextUser',
	    value: function _onRemoveContextUser(payload) {
	      var data = (0, _camelize2.default)(payload);
	      this.connection.emit('remove_context_user', data);
	    }
	  }, {
	    key: '_onRecieveRemoveMessages',
	    value: function _onRecieveRemoveMessages(payload) {
	      var data = (0, _camelize2.default)(payload);
	      var channel = this._getChannel(data);
	
	      if (channel) {
	        channel._onRecieveRemoveMessages(data);
	      }
	    }
	  }, {
	    key: '_getChannel',
	    value: function _getChannel(data) {
	      var channelId = parseInt((0, _get2.default)(data, 'channelId'), 10);
	
	      return (0, _get2.default)(this.connection, ['circles', channelId]);
	    }
	  }, {
	    key: '_onBlockChannel',
	    value: function _onBlockChannel(payload) {
	      var data = (0, _camelize2.default)(payload);
	
	      this.connection.emit('blocked_channels', data);
	    }
	  }, {
	    key: '_onReceiveCommunitiesNotification',
	    value: function _onReceiveCommunitiesNotification(payload) {
	      var data = (0, _camelize2.default)(payload);
	      var message = (0, _get2.default)(data, 'message');
	      var notificationType = (0, _get2.default)(message, 'payload.data.type');
	
	      this.connection.emit(notificationType, data);
	    }
	  }, {
	    key: '_onReceiveSystemNotification',
	    value: function _onReceiveSystemNotification(payload) {
	      var data = (0, _camelize2.default)(payload);
	      var error = (0, _get2.default)(data, 'data.error');
	      if (error) {
	        var notificationErrorCode = (0, _get2.default)(error, 'code');
	        this.connection.emit(notificationErrorCode, data);
	      }
	    }
	  }, {
	    key: '_emitFormattedEvent',
	    value: function _emitFormattedEvent(event, payload) {
	      var data = (0, _camelize2.default)(payload);
	      this.connection.emit(event, data);
	    }
	  }]);
	  return SystemChannel;
	}(_abstract_channel2.default);
	
	exports.default = SystemChannel;

/***/ }),
/* 4195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _phoenix = __webpack_require__(2664);
	
	var _events = __webpack_require__(2238);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _omit = __webpack_require__(177);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _system_channel = __webpack_require__(4194);
	
	var _system_channel2 = _interopRequireDefault(_system_channel);
	
	var _circle_of_care_channel = __webpack_require__(4193);
	
	var _circle_of_care_channel2 = _interopRequireDefault(_circle_of_care_channel);
	
	var _file_uploader = __webpack_require__(4191);
	
	var _file_uploader2 = _interopRequireDefault(_file_uploader);
	
	var _env = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Connection = function (_EventEmitter) {
	  (0, _inherits3.default)(Connection, _EventEmitter);
	
	  function Connection(_ref) {
	    var authToken = _ref.authToken,
	        userId = _ref.userId,
	        socketUrl = _ref.socketUrl,
	        attachmentsUploadUrl = _ref.attachmentsUploadUrl,
	        teamId = _ref.teamId,
	        teamUserId = _ref.teamUserId,
	        isProvider = _ref.isProvider;
	    (0, _classCallCheck3.default)(this, Connection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Connection.__proto__ || (0, _getPrototypeOf2.default)(Connection)).call(this));
	
	    _this.uploader = new _file_uploader2.default(attachmentsUploadUrl);
	
	    _this.authToken = authToken;
	    _this.userId = userId;
	    _this.teamId = teamId;
	    _this.teamUserId = teamUserId;
	    _this.isProvider = isProvider;
	
	    _this.circles = {};
	    _this.connected = false;
	
	    _this.socket = new _phoenix.Socket(socketUrl, {
	      logger: _this._logger,
	      params: {
	        token: _this.authToken,
	        platform: 'P_WEB'
	      }
	    });
	    return _this;
	  }
	
	  (0, _createClass3.default)(Connection, [{
	    key: 'connect',
	    value: function connect() {
	      this.socket.connect();
	      this._handleConnection();
	    }
	  }, {
	    key: 'disconnect',
	    value: function disconnect() {
	      this.socket.disconnect();
	
	      this.authToken = null;
	      this.userId = null;
	      this.circles = {};
	      this.connected = false;
	      this.teamId = null;
	      this.teamUserId = null;
	      this.isProvider = false;
	
	      console.log('--- Chat connection closed.');
	    }
	  }, {
	    key: '_handleConnection',
	    value: function _handleConnection() {
	      this.systemChannel = new _system_channel2.default(this);
	      this.connected = true;
	
	      this.emit('connection_opened', this);
	    }
	  }, {
	    key: 'getUploader',
	    value: function getUploader() {
	      return this.uploader;
	    }
	  }, {
	    key: 'getCircle',
	    value: function getCircle(channelId) {
	      if (!this.connected) {
	        console.error('Connect before!');
	        return null;
	      }
	
	      return this.circles[channelId];
	    }
	  }, {
	    key: 'createChannel',
	    value: function createChannel(channelId, options) {
	      var _this2 = this;
	
	      var _ref2 = options || {},
	          _ref2$unreadCount = _ref2.unreadCount,
	          unreadCount = _ref2$unreadCount === undefined ? 0 : _ref2$unreadCount,
	          lastMessageAt = _ref2.lastMessageAt;
	
	      if (!this.connected) {
	        console.error('Connect before!');
	        return null;
	      }
	
	      if (!this.circles[channelId]) {
	        var actions = {
	          emit: function emit() {
	            return _this2.emit.apply(_this2, arguments);
	          },
	          push: function push() {
	            var _systemChannel$channe;
	
	            return (_systemChannel$channe = _this2.systemChannel.channel).push.apply(_systemChannel$channe, arguments);
	          }
	        };
	
	        var circle = new _circle_of_care_channel2.default(channelId, actions, {
	          userId: this.userId,
	          unreadCount: unreadCount,
	          lastMessageAt: lastMessageAt,
	          isProvider: this.isProvider
	        });
	
	        this.circles[channelId] = circle;
	      }
	
	      return this.circles[channelId];
	    }
	  }, {
	    key: 'removeChannel',
	    value: function removeChannel(channelId) {
	      this.circles = (0, _omit2.default)(this.circles, [channelId]);
	    }
	  }, {
	    key: '_logger',
	    value: function _logger(kind, msg, data) {
	      if (!_env.DISABLE_LOGS) {
	        console.log(kind, ': ', msg, data);
	      }
	    }
	  }]);
	  return Connection;
	}(_events2.default); /* eslint-disable no-console,class-methods-use-this */
	
	
	exports.default = Connection;

/***/ }),
/* 4196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkState = undefined;
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkState = exports.checkState = function checkState(state) {
	  if (!state) return '';
	  if ((typeof state === 'undefined' ? 'undefined' : (0, _typeof3.default)(state)) === 'object') return state.label;
	  return state;
	};

/***/ }),
/* 4197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeGuardianOption = exports.assignRoleToDependentOption = exports.cancelCaregiverInvitation = exports.removeCaregiverOption = exports.assignCaregiverOption = exports.removeFromCircleOption = undefined;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _strings = __webpack_require__(15);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var removeFromCircleOption = exports.removeFromCircleOption = function removeFromCircleOption(action, params, formatMessage) {
	  return {
	    text: formatMessage(_strings.CIRCLES.actionTitles.removeFromCircle),
	    onClick: function onClick() {
	      return action(params);
	    },
	    icon: 'log-out'
	  };
	};
	
	var assignCaregiverOption = exports.assignCaregiverOption = function assignCaregiverOption(action, familyMember, formatMessage) {
	  return {
	    text: formatMessage(_strings.CIRCLES.assignCaregiver),
	    onClick: function onClick() {
	      return action(familyMember);
	    },
	    icon: 'heart'
	  };
	};
	
	var removeCaregiverOption = exports.removeCaregiverOption = function removeCaregiverOption(action, params, formatMessage) {
	  return {
	    text: formatMessage(_strings.CIRCLES.removeCaregiver),
	    onClick: function onClick() {
	      return action(params);
	    },
	    icon: 'remove'
	  };
	};
	
	var cancelCaregiverInvitation = exports.cancelCaregiverInvitation = function cancelCaregiverInvitation(action, params, formatMessage) {
	  return {
	    text: formatMessage(_strings.CANCEL_INVITATION),
	    onClick: function onClick() {
	      return action(params);
	    },
	    icon: 'heart'
	  };
	};
	
	var assignRoleToDependentOption = exports.assignRoleToDependentOption = function assignRoleToDependentOption(action, familyMember, formatMessage) {
	  return {
	    text: formatMessage({ id: 'circles.actions.assignRole' }),
	    onClick: function onClick() {
	      return action(familyMember);
	    },
	    icon: 'heart'
	  };
	};
	
	var removeGuardianOption = exports.removeGuardianOption = function removeGuardianOption(action, params, formatMessage, isLastGuardian) {
	  return {
	    text: formatMessage(_strings.CIRCLES.removeGuardian),
	    onClick: function onClick() {
	      return action(params, isLastGuardian);
	    },
	    icon: 'remove'
	  };
	};
	
	exports.default = function (_ref) {
	  var formatMessage = _ref.formatMessage,
	      isLoggedUser = _ref.isLoggedUser,
	      isCaregiver = _ref.isCaregiver,
	      isVerifiedDependent = _ref.isVerifiedDependent,
	      loggedUserId = _ref.loggedUserId,
	      item = _ref.item,
	      type = _ref.type,
	      removeFromCircle = _ref.removeFromCircle,
	      openCancelCaregiverInvitePopup = _ref.openCancelCaregiverInvitePopup,
	      removeCaregiverRole = _ref.removeCaregiverRole,
	      targetUserId = _ref.targetUserId,
	      removeGuardianRole = _ref.removeGuardianRole,
	      openLeaveCirclePopup = _ref.openLeaveCirclePopup,
	      isLastGuardian = _ref.isLastGuardian,
	      onOpenSimpleFormPopup = _ref.onOpenSimpleFormPopup;
	
	  var menu = [];
	  var caregiver = (0, _get2.default)(item, [_props.CARE_ROLE.CAREGIVER], false);
	  var isGuardian = (0, _get2.default)(item, [_props.CARE_ROLE.GUARDIAN], false) || (0, _get2.default)(item, [_props.CARE_ROLE.PROXY], false) || (0, _get2.default)(item, [_props.CARE_ROLE.PARENT], false);
	
	  var hasGlobalPermissions = isLoggedUser || isVerifiedDependent;
	  var hasPermissions = hasGlobalPermissions || isCaregiver;
	
	  // user can remove anyone except himself
	  var canRemoveFromCircle = (hasGlobalPermissions || isCaregiver && !isGuardian) && loggedUserId !== item.id;
	
	  // user can remove caregiver role if role is assigned
	  var canRemoveCaregiver = hasPermissions && caregiver;
	
	  // user can cancel caregiver invitation if invitation is sent
	  var canCancelCaregiverInvitation = hasPermissions && item.pendingCaregiver;
	
	  // logged user can assign caregiver role if role wasn't assign previously
	  var isFamilyCircle = type === _strings.CIRCLE_FAMILY;
	  var caregiverIsNotAssigned = !caregiver && !item.pendingCaregiver;
	
	  var canAssignCaregiver = isLoggedUser && isFamilyCircle && caregiverIsNotAssigned;
	
	  var canRemoveGuardianRole = isVerifiedDependent && isGuardian;
	
	  // can assign role to dependent
	  if (isVerifiedDependent) {
	    menu.push(assignRoleToDependentOption(onOpenSimpleFormPopup, item, formatMessage));
	  }
	
	  if (canRemoveFromCircle) {
	    var params = { userId: targetUserId, memberId: item.id };
	
	    menu.push(removeFromCircleOption(removeFromCircle, params, formatMessage));
	  }
	
	  if (canAssignCaregiver) {
	    menu.push(assignCaregiverOption(onOpenSimpleFormPopup, item, formatMessage));
	  }
	
	  if (canRemoveCaregiver) {
	    var _params = { userId: targetUserId, memberId: item.id };
	
	    menu.push(removeCaregiverOption(removeCaregiverRole, _params, formatMessage));
	  }
	
	  if (canCancelCaregiverInvitation) {
	    menu.push(cancelCaregiverInvitation(openCancelCaregiverInvitePopup, item, formatMessage));
	  }
	
	  if (canRemoveGuardianRole) {
	    var action = isLastGuardian ? openLeaveCirclePopup : removeGuardianRole;
	    var _params2 = { userId: targetUserId, memberId: item.id };
	    menu.push(removeGuardianOption(action, _params2, formatMessage, isLastGuardian));
	  }
	
	  return menu;
	};

/***/ }),
/* 4198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(17);
	
	var _strings = __webpack_require__(15);
	
	// returns only read only string or empty string otherwise
	exports.default = function (accessLevel, formatMessage) {
	  if (accessLevel === _constants.COMMUNITIES_ACCESS_LEVELS.READ_ONLY) {
	    return formatMessage(_strings.COMMUNITY_ACCESS_READ_ONLY);
	  }
	
	  if (accessLevel === _constants.COMMUNITIES_ACCESS_LEVELS.READ_AND_POST_WITH_APPROVAL) {
	    return formatMessage({ id: 'community.access.withApproval' });
	  }
	
	  return formatMessage({ id: 'community.access.readAndPost' });
	};

/***/ }),
/* 4199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _strings = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCommunityTypeText = function getCommunityTypeText(type, formatMessage) {
	  var communityType = _strings.COMMUNITY_TYPE_STRINGS.find(function (item) {
	    return item.type === type;
	  });
	
	  if (communityType && (0, _get2.default)(communityType, 'text.id')) {
	    return formatMessage(communityType.text);
	  }
	
	  return type;
	};
	
	exports.default = getCommunityTypeText;

/***/ }),
/* 4200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.abbrNum = undefined;
	
	var _strings = __webpack_require__(15);
	
	var abbrNum = exports.abbrNum = function abbrNum(number, decPlaces) {
	  var abbrev = ['K', 'M', 'B', 'T'];
	
	  // 2 decimal places => 100, 3 => 1000, etc
	  decPlaces = window.Math.pow(10, decPlaces);
	
	  for (var i = abbrev.length - 1; i >= 0; i--) {
	    var size = window.Math.pow(10, (i + 1) * 3);
	
	    if (size <= number) {
	      number = window.Math.round(number * decPlaces / size) / decPlaces;
	
	      // Case where we round up to the next abbreviation
	      var isSpecificCase = number === 1000 && i < abbrev.length - 1;
	
	      if (isSpecificCase) {
	        number = 1;
	        i++;
	      }
	
	      number += abbrev[i];
	
	      break;
	    }
	  }
	
	  return number;
	}; /* eslint-disable no-param-reassign */
	
	
	var getMembersText = function getMembersText(count, formatMessage) {
	  var prettifiedCount = abbrNum(count, 0);
	  var text = formatMessage(_strings.COMMUNITY_MEMBERS);
	
	  return prettifiedCount + ' ' + text;
	};
	
	exports.default = getMembersText;

/***/ }),
/* 4201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _strings = __webpack_require__(15);
	
	var _constants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (author, formatMessage) {
	  if ((0, _get2.default)(author, 'role') === _constants.COMMUNITIES_USER_ROLES.MODERATOR) {
	    return formatMessage(_strings.COMMUNITY_AUTHOR_ROLE.moderator);
	  }
	
	  return '';
	};

/***/ }),
/* 4202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFamilyMemberRole = undefined;
	
	var _strings = __webpack_require__(15);
	
	var getFamilyMemberRole = exports.getFamilyMemberRole = function getFamilyMemberRole(_ref, formatMessage) {
	  var caregiver = _ref.caregiver,
	      guardian = _ref.guardian,
	      proxy = _ref.proxy,
	      parent = _ref.parent;
	
	  var roleList = [];
	  if (caregiver) roleList.push(formatMessage(_strings.CIRCLES.titles.caregiverRole));
	  if (guardian) roleList.push(formatMessage(_strings.CIRCLES.titles.guardianRole));
	  if (proxy) roleList.push(formatMessage(_strings.CIRCLES.titles.proxyRole));
	  if (parent) roleList.push(formatMessage(_strings.CIRCLES.titles.parentRole));
	  return roleList.filter(Boolean).join(', ');
	};

/***/ }),
/* 4203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _strings = __webpack_require__(15);
	
	// profile navigation
	var pathToTitle = function pathToTitle(path) {
	  var parts = path.split('/');
	  var endsWith = parts[parts.length - 1];
	  var slug = isNaN(endsWith) ? endsWith : parts[parts.length - 2];
	
	  return _strings.SCREEN_TITLES[slug];
	}; /* eslint-disable */
	exports.default = pathToTitle;

/***/ }),
/* 4204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatPhone = undefined;
	
	var _googleLibphonenumber = __webpack_require__(5319);
	
	var _googleLibphonenumber2 = _interopRequireDefault(_googleLibphonenumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatPhone = exports.formatPhone = function formatPhone(phone) {
	  if (phone && phone.length < 9) return phone;
	  var PNF = _googleLibphonenumber2.default.PhoneNumberFormat;
	  var phoneUtil = _googleLibphonenumber2.default.PhoneNumberUtil.getInstance();
	
	  var parsedPhone = phoneUtil.parse(phone, 'US');
	  return phoneUtil.format(parsedPhone, PNF.INTERNATIONAL);
	};

/***/ }),
/* 4205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _snakeCase = __webpack_require__(467);
	
	var _snakeCase2 = _interopRequireDefault(_snakeCase);
	
	var _snakecaseKeys = __webpack_require__(1391);
	
	var _snakecaseKeys2 = _interopRequireDefault(_snakecaseKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createPayloadForFeatureToggle = function createPayloadForFeatureToggle(arrConfig) {
	  return {
	    configurationFor: arrConfig.map(function (_ref) {
	      var action = _ref.action,
	          options = _ref.options;
	      return {
	        action: (0, _snakeCase2.default)(action),
	        options: (0, _snakecaseKeys2.default)(options)
	      };
	    })
	  };
	};
	
	exports.default = createPayloadForFeatureToggle;

/***/ }),
/* 4206 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var formatCurrencyUSD = exports.formatCurrencyUSD = function formatCurrencyUSD(value) {
	  return new Intl.NumberFormat('en-US', {
	    style: 'currency',
	    currency: 'USD',
	    minimumFractionDigits: 2,
	    maximumFractionDigits: 2
	  }).format(value);
	};

/***/ }),
/* 4207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.formatAppointmentList = formatAppointmentList;
	exports.sortAppointmentList = sortAppointmentList;
	exports.markOverdueAppointmentList = markOverdueAppointmentList;
	exports.transformTimeAdapter = transformTimeAdapter;
	exports.formatAppointmentStartTime = formatAppointmentStartTime;
	exports.markOverdueAppointment = markOverdueAppointment;
	exports.toggleHighlightStatus = toggleHighlightStatus;
	exports.findAndReplace = findAndReplace;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sortByStartTime = makeDescSorting('startTime');
	var sortByCreatedTime = makeDescSorting('createdAt');
	
	function formatAppointmentList(list) {
	  var timeFormattedList = formatAppointmentStartTime(list);
	  var marked = markOverdueAppointmentList(timeFormattedList);
	  return sortAppointmentList(marked);
	}
	
	function sortAppointmentList(list) {
	  return list.sort(sortByCreatedTime).sort(sortByStartTime).sort(sortByPinnedTime);
	}
	
	function markOverdueAppointmentList(list) {
	  return list.map(markOverdueAppointment);
	}
	
	function convertToLocalUTCTime(time) {
	  return _moment2.default.utc(time).subtract((0, _moment2.default)().utcOffset(), 'm').toISOString();
	}
	
	function transformTimeAdapter(item) {
	  if (item._timeFormatted) {
	    return item;
	  }
	  var startTime = item.startTime;
	
	
	  return (0, _extends3.default)({}, item, {
	    _timeFormatted: true,
	    startTime: startTime
	  });
	}
	
	function formatAppointmentStartTime(list) {
	  return list.map(transformTimeAdapter);
	}
	
	function makeTS(date) {
	  return new Date(date).getTime();
	}
	
	function makeDescSorting(sortBy) {
	  return function (current, next) {
	    var currentTS = makeTS(current[sortBy]);
	    var nextTS = makeTS(next[sortBy]);
	
	    if (currentTS < nextTS) {
	      return -1;
	    }
	
	    if (currentTS > nextTS) {
	      return 1;
	    }
	
	    return 0;
	  };
	}
	
	function sortByPinnedTime(current, next) {
	  var currentTS = makeTS(current.pinnedAt);
	  var nextTS = makeTS(next.pinnedAt);
	
	  if (currentTS > nextTS) {
	    return -1;
	  }
	
	  if (currentTS < nextTS) {
	    return 1;
	  }
	
	  return 0;
	}
	
	function markOverdueAppointment(item) {
	  var timeNow = (0, _moment2.default)();
	
	  var isOverdue = (0, _moment2.default)(item.startTime).add(15, 'm').isBefore(timeNow);
	
	  return (0, _extends3.default)({}, item, { isOverdue: isOverdue });
	}
	
	function toggleHighlightStatus(list, matchId, isnew) {
	  var result = [].concat((0, _toConsumableArray3.default)(list));
	  var index = list.findIndex(function (_ref) {
	    var id = _ref.id;
	    return id === matchId;
	  });
	  if (index >= 0) {
	    var item = list[index];
	    result[index] = (0, _extends3.default)({}, item, { isnew: isnew });
	  }
	
	  return result;
	}
	
	function findAndReplace(list, item) {
	  var addIfEmpty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var result = [].concat((0, _toConsumableArray3.default)(list));
	
	  var index = list.findIndex(function (_ref2) {
	    var id = _ref2.id;
	    return id === item.id;
	  });
	
	  if (item.status && item.status.displayableOnDashboard === false) {
	    result.splice(index, 1);
	  } else if (index >= 0) {
	    result[index] = item;
	  } else if (addIfEmpty) {
	    result.push(item);
	  }
	
	  return result;
	}

/***/ }),
/* 4208 */,
/* 4209 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var fixFullscreen = function fixFullscreen(e) {
	  return e.target.scrollIntoView && e.target.scrollIntoView();
	};
	
	exports.default = function () {
	  ['', 'webkit', 'moz', 'ms'].forEach(function (prefix) {
	    document.addEventListener(prefix + 'fullscreenchange', fixFullscreen);
	  });
	};

/***/ }),
/* 4210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.adaptRelationValue = undefined;
	
	var _upperFirst = __webpack_require__(147);
	
	var _upperFirst2 = _interopRequireDefault(_upperFirst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var adaptRelationValue = exports.adaptRelationValue = function adaptRelationValue(name, list) {
	  var target = list.find(function (label) {
	    return label === name;
	  });
	
	  return target ? {
	    label: (0, _upperFirst2.default)(target),
	    value: target
	  } : null;
	};

/***/ }),
/* 4211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.normalizeRelationList = undefined;
	
	var _upperFirst = __webpack_require__(147);
	
	var _upperFirst2 = _interopRequireDefault(_upperFirst);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var normalizeRelationList = exports.normalizeRelationList = function normalizeRelationList() {
	  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return list.map(function (relation) {
	    return {
	      label: (0, _upperFirst2.default)(relation),
	      value: relation
	    };
	  });
	};

/***/ }),
/* 4212 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	var connect = function connect(i, s, o, g, r, a, m) {
	  i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
	    (i[r].q = i[r].q || []).push(arguments);
	  }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
	};
	
	exports.default = function (analyticsId) {
	  connect(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	  ga('create', analyticsId, 'auto');
	  ga('send', 'pageview');
	};

/***/ }),
/* 4213 */,
/* 4214 */,
/* 4215 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getVisitTypeIdWithCode = exports.getVisitTypeIdWithCode = function getVisitTypeIdWithCode(codeVisitType, visitTypeList) {
	  var visitType = visitTypeList.find(function (_ref) {
	    var code = _ref.code;
	    return code === codeVisitType;
	  });
	  return visitType ? visitType.id : null;
	};

/***/ }),
/* 4216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactRouter = __webpack_require__(42);
	
	var _logout = __webpack_require__(198);
	
	var _routes = __webpack_require__(37);
	
	var _storageKeys = __webpack_require__(215);
	
	var _paperwork = __webpack_require__(265);
	
	var handleBgTabState = function handleBgTabState(e, focused, store) {
	  var _checkIsPaperworkRout = (0, _paperwork.checkIsPaperworkRoute)(),
	      isPaperworkRoute = _checkIsPaperworkRout.isPaperworkRoute;
	
	  // Paperwork tabs use a separate paperworkToken and must not react to
	  // regular-app auth events — and regular-app tabs must not react to
	  // paperwork auth events. Each session type manages itself independently.
	
	
	  if (isPaperworkRoute) {
	    return;
	  }
	
	  var authTokenRemoved = e.key === _storageKeys.AUTHENTICATION_TOKEN && !!e.oldValue && e.oldValue !== e.newValue;
	
	  // Set regardless of focus: a tab that had its auth token wiped by another
	  // tab must not reload when that other tab later logs in, even if this tab
	  // was focused (and therefore didn't dispatch logout) at the time of removal.
	  if (authTokenRemoved) {
	    sessionStorage.setItem(_storageKeys.KICKED_TO_LOGIN, 'true');
	  }
	
	  // prevent event firing in current active tab [IE]
	  if (!focused) {
	    if (authTokenRemoved) {
	      store.dispatch(_logout.actions.clear());
	      _reactRouter.browserHistory.push(_routes.LOGIN);
	    }
	
	    var loggedIn = e.key === _storageKeys.LOGGED_IN && e.newValue && e.newValue.length && JSON.parse(e.newValue) && (!e.oldValue || !e.oldValue.length || !JSON.parse(e.oldValue));
	
	    if (loggedIn && !sessionStorage.getItem(_storageKeys.KICKED_TO_LOGIN)) {
	      window.location.reload();
	    }
	  }
	};
	
	exports.default = handleBgTabState;

/***/ }),
/* 4217 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var hexToRgba = exports.hexToRgba = function hexToRgba(hex) {
	  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var r = parseInt(hex.slice(1, 3), 16);
	  var g = parseInt(hex.slice(3, 5), 16);
	  var b = parseInt(hex.slice(5, 7), 16);
	  return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
	};

/***/ }),
/* 4218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HttpError = undefined;
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.trackHttpError = trackHttpError;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _sentryMethods = __webpack_require__(437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HttpError = exports.HttpError = function (_Error) {
	  (0, _inherits3.default)(HttpError, _Error);
	
	  function HttpError(err) {
	    (0, _classCallCheck3.default)(this, HttpError);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HttpError.__proto__ || (0, _getPrototypeOf2.default)(HttpError)).call(this, err.message));
	
	    _this.name = 'HTTP ERROR';
	    return _this;
	  }
	
	  return HttpError;
	}(Error);
	
	function trackHttpError(err) {
	  var apiURL = (0, _get2.default)(err, 'response.config.url');
	  var reqData = (0, _get2.default)(err, 'response.config.data');
	  var status = (0, _get2.default)(err, 'response.status');
	  var response = (0, _get2.default)(err, 'response.data.data');
	
	  (0, _sentryMethods.sentryCaptureException)(new HttpError(err), {
	    extra: {
	      API_URL: apiURL,
	      REQUEST_PAYLOAD: reqData,
	      STATUS_CODE: status,
	      RESPONSE_PAYLOAD: response
	    },
	    tags: {
	      ERROR_TYPE: 'API_ERROR'
	    }
	  });
	}

/***/ }),
/* 4219 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isElementVisible = function isElementVisible(el, wrapper) {
	  var elRect = el.getBoundingClientRect();
	  var wrapperRect = wrapper.getBoundingClientRect();
	
	  return elRect.top >= wrapperRect.top && elRect.bottom <= wrapperRect.bottom;
	};
	
	exports.default = isElementVisible;

/***/ }),
/* 4220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValidUrlByRegex = isValidUrlByRegex;
	
	var _validations = __webpack_require__(81);
	
	function isValidUrlByRegex(input) {
	  if (typeof input !== 'string') return false;
	
	  var value = input.trim();
	  if (value.length === 0) return false;
	
	  var re = new RegExp('^(?:' + _validations.PATTERNS.URL.source + ')$', _validations.PATTERNS.URL.flags);
	
	  return re.test(value);
	}

/***/ }),
/* 4221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.makeAsyncScriptLoader = makeAsyncScriptLoader;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {};
	
	function loadJS(src, scriptId) {
	  return new _promise2.default(function (resolve, reject) {
	    var script = document.createElement('script');
	    script.src = src;
	    script.id = scriptId;
	    document.head.appendChild(script);
	    script.onload = resolve;
	    script.onerror = reject;
	  });
	}
	
	function makeAsyncScriptLoader(urls, scriptId) {
	  return function () {
	    var onReady = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    var existingScript = document.getElementById(scriptId);
	    if (existingScript) return onReady();
	
	    _promise2.default.all(urls.map(function (url) {
	      return loadJS(url, scriptId);
	    })).then(function () {
	      onReady();
	    });
	  };
	}

/***/ }),
/* 4222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initializeOfflineHandling = undefined;
	
	var _online = __webpack_require__(1904);
	
	var initializeOfflineHandling = exports.initializeOfflineHandling = function initializeOfflineHandling(store) {
	  window.onoffline = function () {
	    return store.dispatch(_online.actions.setOnline(false));
	  };
	  window.ononline = function () {
	    return store.dispatch(_online.actions.setOnline(true));
	  };
	};

/***/ }),
/* 4223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkIsPaperworkRoute = undefined;
	
	var _routes = __webpack_require__(37);
	
	var checkIsPaperworkRoute = exports.checkIsPaperworkRoute = function checkIsPaperworkRoute() {
	  var pathname = window.location.pathname;
	
	
	  return { isPaperworkRoute: pathname.includes(_routes.PAPERWORK), route: pathname };
	};

/***/ }),
/* 4224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAppointmentId = undefined;
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAppointmentId = exports.getAppointmentId = function getAppointmentId() {
	  var pathname = window.location.pathname;
	
	  var match = pathname.match(/paperwork\/([a-zA-Z0-9-]+)/);
	
	  if (match && Array.isArray(match)) {
	    var _match = (0, _slicedToArray3.default)(match, 2),
	        _ = _match[0],
	        uuid = _match[1];
	
	    return uuid;
	  }
	
	  return null;
	};

/***/ }),
/* 4225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAllPaperworkSteps = exports.getPaperworkFormSteps = undefined;
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _routes = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getPaperworkFormSteps = exports.getPaperworkFormSteps = function getPaperworkFormSteps(_ref) {
	  var id = _ref.id,
	      requestContactInfo = _ref.requestContactInfo,
	      isConsentsSigned = _ref.isConsentsSigned,
	      includesAdditionalInfoQuestions = _ref.includesAdditionalInfoQuestions,
	      skipInsurance = _ref.skipInsurance;
	  return [].concat((0, _toConsumableArray3.default)(skipInsurance ? [] : [_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_INSURANCE_DETAILS]), (0, _toConsumableArray3.default)(requestContactInfo ? [_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_COMPLETE_YOUR_PROFILE] : []), [_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_GUARANTOR_INFORMATION, _routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_PREFERRED_PHARMACY, _routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_PRIMARY_CARE_PROVIDER], (0, _toConsumableArray3.default)(includesAdditionalInfoQuestions ? [_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_ADDITIONAL_INFORMATION] : []), (0, _toConsumableArray3.default)(isConsentsSigned ? [] : [_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_SIGN_CONSENT]), [_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_SUBMIT]);
	};
	
	var getAllPaperworkSteps = exports.getAllPaperworkSteps = function getAllPaperworkSteps(_ref2) {
	  var id = _ref2.id,
	      requestContactInfo = _ref2.requestContactInfo,
	      isConsentsSigned = _ref2.isConsentsSigned,
	      includesAdditionalInfoQuestions = _ref2.includesAdditionalInfoQuestions,
	      skipInsurance = _ref2.skipInsurance;
	  return [_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_VISIT_DETAILS].concat((0, _toConsumableArray3.default)(getPaperworkFormSteps({
	    id: id,
	    requestContactInfo: requestContactInfo,
	    isConsentsSigned: isConsentsSigned,
	    includesAdditionalInfoQuestions: includesAdditionalInfoQuestions,
	    skipInsurance: skipInsurance
	  })), [_routes.PAPERWORK + '/' + id + '/' + _routes.PAPERWORK_COMPLETE_VISIT_DETAILS]);
	};

/***/ }),
/* 4226 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var pipe = exports.pipe = function pipe() {
	  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  return function (x) {
	    return fns.reduce(function (v, f) {
	      return f(v);
	    }, x);
	  };
	};

/***/ }),
/* 4227 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preloaderImage = undefined;
	
	var _promise = __webpack_require__(221);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preloaderImage = exports.preloaderImage = function preloaderImage(image) {
	  return new _promise2.default(function (resolve) {
	    var url = window.URL.createObjectURL(image);
	    var img = new Image();
	
	    img.src = url;
	    img.onload = function () {
	      resolve(url);
	    };
	  });
	};

/***/ }),
/* 4228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reqReducer = __webpack_require__(1390);
	
	var _reqReducer2 = _interopRequireDefault(_reqReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var consts = _ref.consts,
	      paginationConsts = _ref.paginationConsts,
	      counterKey = _ref.counterKey;
	
	  var initialState = (0, _extends3.default)({}, _reqReducer.initialState, {
	    count: 0,
	    list: [],
	    meta: null,
	    paginationSending: false,
	    pagination: { offset: 0, limit: 10 }
	  });
	
	  var defaultRequestReducer = (0, _reqReducer2.default)(consts);
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	      case consts.SEND:
	        {
	          return (0, _extends3.default)({}, state, {
	            succeed: null,
	            rejected: null,
	            error: null,
	            count: action.payload.count || 0,
	            sending: !action.payload.silent
	          });
	        }
	
	      case consts.SUCCEED:
	        {
	          return (0, _extends3.default)({}, state, {
	            succeed: true,
	            sending: false,
	            list: action.payload
	          });
	        }
	
	      case paginationConsts.SEND:
	        {
	          return (0, _extends3.default)({}, state, {
	            paginationSending: true
	          });
	        }
	
	      case paginationConsts.SUCCEED:
	        {
	          return (0, _extends3.default)({}, state, {
	            paginationSending: false,
	            list: [].concat((0, _toConsumableArray3.default)(state.list), (0, _toConsumableArray3.default)(action.payload))
	          });
	        }
	
	      case paginationConsts.REJECTED:
	      case paginationConsts.ERROR_ENCOUNTERED:
	        {
	          return (0, _extends3.default)({}, state, {
	            paginationSending: false
	          });
	        }
	
	      case paginationConsts.ADD_META:
	      case consts.ADD_META:
	        {
	          return (0, _extends3.default)({}, state, {
	            meta: action.payload,
	            count: (0, _get2.default)(action.payload, counterKey, 0)
	          });
	        }
	
	      case consts.CLEAR:
	        {
	          return initialState;
	        }
	
	      default:
	        return defaultRequestReducer(state, action);
	    }
	  };
	};

/***/ }),
/* 4229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _effects = __webpack_require__(14);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactRouter = __webpack_require__(42);
	
	var _env = __webpack_require__(103);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	var _routes = __webpack_require__(37);
	
	var _paperwork = __webpack_require__(265);
	
	var _selectors = __webpack_require__(93);
	
	var _storageKeys = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/_regenerator2.default.mark(manageResponse);
	
	// Hardcode logout succeed const as it isn't available at this point.
	var LOGOUT_SUCCEED = 'auth/logout/SUCCEED';
	var LOGIN_API_URI = 'users/sessions';
	var ACCEPT_INVITATION_URI = 'invite_confirmations/';
	var UNAUTHORIZED = 401;
	var REQUEST_TIMEOUT = 408;
	var BAD_GATEWAY = 502;
	var GATEWAY_TIMEOUT = 504;
	
	/*
	 * The worker that intercepts API HTTP requests. The actions MUST follow such naming convention:
	 * const actions = {
	 *   succeed,
	 *   rejected,
	 *   errorEncountered,
	 * };
	 * The actions itself must be a plain object, contains action creators for
	 * `succeed` (>= 200 and < 400 HTTP responses),
	 * `rejected` (>= 400 and < 500)
	 * and `errorEncountered` actions (for any errors, both server (>= 500) and client) accordingly
	 * */
	
	function manageResponse(actions, api, payload) {
	  var succeed, rejected, errorEncountered, addMeta, response, status, responseBody, getEntity, c, errorData, communityId, COMMUNITY_PREVIEW, exceptions, exceptionUrl, isLoggedIn, _checkIsPaperworkRout, isPaperworkRoute, route, requestAuthHeader, requestTokenMatch, requestToken, currentAuthToken, currentPaperworkToken, isPaperworkApiRequest;
	
	  return _regenerator2.default.wrap(function manageResponse$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          succeed = actions.succeed, rejected = actions.rejected, errorEncountered = actions.errorEncountered, addMeta = actions.addMeta;
	          _context.prev = 1;
	          _context.next = 4;
	          return (0, _effects.call)(api.send, payload);
	
	        case 4:
	          response = _context.sent;
	          status = (0, _get2.default)(response, 'status');
	          responseBody = (0, _get2.default)(response, 'data');
	          getEntity = _get2.default.bind(null, responseBody);
	          c = ['data', 'meta', 'error'].reduce(function (acc, x) {
	            acc[x] = getEntity(x); // eslint-disable-line no-param-reassign
	            return acc;
	          }, {});
	
	          // fallback for file responses
	
	          if (!c.data && !c.error) {
	            c.blob = { blob: responseBody };
	          }
	
	          if (!(status >= 200 && status < 400)) {
	            _context.next = 18;
	            break;
	          }
	
	          _context.next = 13;
	          return (0, _effects.put)(succeed(c.data || c.blob, c.meta));
	
	        case 13:
	          if (!c.meta) {
	            _context.next = 16;
	            break;
	          }
	
	          _context.next = 16;
	          return (0, _effects.put)(addMeta(c.meta));
	
	        case 16:
	          _context.next = 64;
	          break;
	
	        case 18:
	          if (!(status >= 400 && status < 500)) {
	            _context.next = 56;
	            break;
	          }
	
	          if (_env.DEV_ENV) console.warn(c.error);
	
	          errorData = (0, _extends3.default)({}, (0, _get2.default)(c, 'error', {}), {
	            code: (0, _get2.default)(c, 'data.error.code', null),
	            description: (0, _get2.default)(c, 'data.error.description', null),
	            meta: (0, _get2.default)(c, 'data.meta', null),
	            status: status
	          });
	          _context.next = 23;
	          return (0, _effects.put)(rejected({ error: errorData }, c.meta));
	
	        case 23:
	          if (!(status === UNAUTHORIZED)) {
	            _context.next = 51;
	            break;
	          }
	
	          communityId = response.config.url.split('/')[5];
	          COMMUNITY_PREVIEW = 'api/communities/' + communityId + '/member_invitations';
	          exceptions = [LOGIN_API_URI, ACCEPT_INVITATION_URI, COMMUNITY_PREVIEW];
	          exceptionUrl = exceptions.find(function (key) {
	            return response.config.url.indexOf(key) > -1;
	          });
	
	          if (exceptionUrl) {
	            _context.next = 51;
	            break;
	          }
	
	          _context.next = 31;
	          return (0, _effects.select)(_selectors.selectAuthLoggedInStatus);
	
	        case 31:
	          isLoggedIn = _context.sent;
	
	          if (isLoggedIn) {
	            _context.next = 34;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 34:
	          _checkIsPaperworkRout = (0, _paperwork.checkIsPaperworkRoute)(), isPaperworkRoute = _checkIsPaperworkRout.isPaperworkRoute, route = _checkIsPaperworkRout.route;
	          requestAuthHeader = (0, _get2.default)(response, 'config.headers.Authorization', '');
	
	          // If no Authorization header was sent, this was an unauthenticated request.
	          // Don't clear localStorage — a tokenless tab must not wipe another tab's session.
	
	          if (requestAuthHeader) {
	            _context.next = 38;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 38:
	
	          // Extract the raw token value from the Authorization header.
	          // Handles: "Token token=<value>" and "Bearer token=<value>, token_type=..."
	          requestTokenMatch = requestAuthHeader.match(/token=([^,\s]+)/i);
	          requestToken = requestTokenMatch ? requestTokenMatch[1] : '';
	          currentAuthToken = window.storage.getItem(_storageKeys.AUTHENTICATION_TOKEN);
	          currentPaperworkToken = window.storage.getItem(_storageKeys.PAPERWORK_TOKEN);
	          // If the request was made with a token that no longer matches what is stored
	          // (stale in-flight request from this tab or another tab with an old session),
	          // do not invalidate the current session.
	
	          if (!(requestToken && (currentAuthToken || currentPaperworkToken) && requestToken !== currentAuthToken && requestToken !== currentPaperworkToken)) {
	            _context.next = 44;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 44:
	
	          // On the paperwork route, only logout when a paperwork API endpoint
	          // itself returned 401. Non-paperwork endpoints (e.g. insurance_eligibility)
	          // may reject the paperwork-scoped token by design — that must not
	          // invalidate the active paperwork session.
	          // PAPERWORK constant has a leading slash (frontend route) but axios
	          // response.config.url is a relative path without one, so strip it.
	          isPaperworkApiRequest = response.config.url.includes(_routes.PAPERWORK.replace(/^\//, '') + '/');
	
	          if (!(isPaperworkRoute && !isPaperworkApiRequest)) {
	            _context.next = 47;
	            break;
	          }
	
	          return _context.abrupt('return');
	
	        case 47:
	          _context.next = 49;
	          return (0, _effects.put)({ type: LOGOUT_SUCCEED });
	
	        case 49:
	          _context.next = 51;
	          return (0, _effects.call)(function () {
	            return _reactRouter.browserHistory.push(isPaperworkRoute ? route : _routes.LOGIN);
	          });
	
	        case 51:
	          if (!(status === REQUEST_TIMEOUT)) {
	            _context.next = 54;
	            break;
	          }
	
	          _context.next = 54;
	          return (0, _effects.put)({
	            type: (0, _consts2.default)('ui', 'error', ['UPDATE']).UPDATE,
	            payload: { id: 'errors.longRequest.408' }
	          });
	
	        case 54:
	          _context.next = 64;
	          break;
	
	        case 56:
	          if (![BAD_GATEWAY, GATEWAY_TIMEOUT].includes(status)) {
	            _context.next = 63;
	            break;
	          }
	
	          _context.next = 59;
	          return (0, _effects.put)(rejected({ error: c.error }, c.meta));
	
	        case 59:
	          _context.next = 61;
	          return (0, _effects.put)({
	            type: (0, _consts2.default)('ui', 'error', ['UPDATE']).UPDATE,
	            payload: { id: 'errors.longRequest.502.504' }
	          });
	
	        case 61:
	          _context.next = 64;
	          break;
	
	        case 63:
	          throw response;
	
	        case 64:
	          _context.next = 71;
	          break;
	
	        case 66:
	          _context.prev = 66;
	          _context.t0 = _context['catch'](1);
	
	          if (_env.DEV_ENV) console.error(_context.t0);
	          _context.next = 71;
	          return (0, _effects.put)(errorEncountered(_context.t0));
	
	        case 71:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[1, 66]]);
	}
	
	exports.default = manageResponse;

/***/ }),
/* 4230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _consts = __webpack_require__(123);
	
	var _consts2 = _interopRequireDefault(_consts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REQUEST_CONSTS = ['SEND', 'SUCCEED', 'REJECTED', 'ERROR_ENCOUNTERED', 'ADD_META', 'CLEAR'];
	
	exports.default = function (module, submodule) {
	  var additionalConstants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  return _consts2.default.apply(undefined, [module, submodule].concat(REQUEST_CONSTS, (0, _toConsumableArray3.default)(additionalConstants)));
	};

/***/ }),
/* 4231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(12);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = function (constants, actions, _ref, isLatest) {
	  var endpoint = _ref.endpoint,
	      options = _ref.options,
	      slug = _ref.slug,
	      type = _ref.type;
	
	  return (/*#__PURE__*/_regenerator2.default.mark(function watcher() {
	      var lastTask, headerOptions, isProvider, organizationCode, _ref2, payload, querySeparator, fullEndpoint, selectedTeamId, authenticationToken, roomInvitationToken, paperworkToken, offset, timeOffset, _checkIsPaperworkRout, isPaperworkRoute, resolvedPaperworkToken, commonHeaders, headers, opts;
	
	      return _regenerator2.default.wrap(function watcher$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              lastTask = void 0;
	              headerOptions = {};
	
	            case 2:
	              if (false) {
	                _context.next = 37;
	                break;
	              }
	
	              _context.next = 5;
	              return (0, _effects.select)(_selectors.hasProviderProfileSelector);
	
	            case 5:
	              isProvider = _context.sent;
	              _context.next = 8;
	              return (0, _effects.select)(_selectors.selectLoggedProviderOrganizationCode);
	
	            case 8:
	              organizationCode = _context.sent;
	              _context.next = 11;
	              return (0, _effects.take)(constants.SEND);
	
	            case 11:
	              _ref2 = _context.sent;
	              payload = _ref2.payload;
	              querySeparator = '?';
	              fullEndpoint = '' + endpoint + getSlug(slug, payload, querySeparator);
	              selectedTeamId = window.storage.getItem('selectedTeamId');
	              authenticationToken = window.storage.getItem('authenticationToken');
	              roomInvitationToken = window.storage.getItem(_storageKeys.ROOM_INVITATION_TOKEN);
	              paperworkToken = window.storage.getItem(_storageKeys.PAPERWORK_TOKEN);
	              offset = (0, _moment2.default)().utcOffset() / 60;
	              timeOffset = (offset < 0 ? '' : '+') + offset;
	
	
	              if (selectedTeamId) headerOptions[_constants.REQUEST_HEADERS_OPTIONS.SELECTED_TEAM] = selectedTeamId;
	              if (isProvider && organizationCode) headerOptions[_constants.REQUEST_HEADERS_OPTIONS.ORGANIZATION_CODE] = organizationCode;
	
	              _checkIsPaperworkRout = (0, _paperwork.checkIsPaperworkRoute)(), isPaperworkRoute = _checkIsPaperworkRout.isPaperworkRoute;
	              resolvedPaperworkToken = isPaperworkRoute && (paperworkToken || authenticationToken);
	              commonHeaders = (0, _extends3.default)({
	                TimeZone: timeOffset,
	                TimeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
	                platform: 'P_WEB'
	              }, headerOptions);
	              headers = void 0;
	
	
	              if (roomInvitationToken) {
	                headers = (0, _extends3.default)({
	                  Authorization: 'Token token=' + roomInvitationToken + ', token_type=room_invitation'
	                }, commonHeaders);
	              } else if (resolvedPaperworkToken) {
	                headers = {
	                  headers: (0, _extends3.default)({
	                    Authorization: 'Bearer token=' + resolvedPaperworkToken + ', token_type=paperwork'
	                  }, commonHeaders)
	                };
	              } else if (authenticationToken) {
	                headers = {
	                  headers: (0, _extends3.default)({
	                    Authorization: 'Token token=' + authenticationToken
	                  }, commonHeaders)
	                };
	              } else {
	                headers = { headers: { platform: 'P_WEB' } };
	              }
	
	              opts = (0, _extends3.default)({}, options, headers);
	
	              if (!(lastTask && isLatest)) {
	                _context.next = 32;
	                break;
	              }
	
	              _context.next = 32;
	              return (0, _effects.cancel)(lastTask);
	
	            case 32:
	              _context.next = 34;
	              return (0, _effects.fork)(_manageResponse2.default, actions, (0, _api2.default)(fullEndpoint, opts, type), payload);
	
	            case 34:
	              lastTask = _context.sent;
	              _context.next = 2;
	              break;
	
	            case 37:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, watcher, this);
	    })
	  );
	};
	
	var _effects = __webpack_require__(14);
	
	var _isPlainObject = __webpack_require__(248);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isString = __webpack_require__(981);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isNil = __webpack_require__(2351);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectors = __webpack_require__(23);
	
	var _manageResponse = __webpack_require__(4229);
	
	var _manageResponse2 = _interopRequireDefault(_manageResponse);
	
	var _api = __webpack_require__(1906);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _constants = __webpack_require__(17);
	
	var _storageKeys = __webpack_require__(215);
	
	var _paperwork = __webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getByKey(data, key) {
	  if (data instanceof FormData) {
	    return data.get(key);
	  }
	  return data[key];
	} /* eslint-disable no-param-reassign,import/no-named-as-default */
	
	
	var getSlug = function getSlug(slug, payload, querySeparator) {
	  if (!Array.isArray(slug)) {
	    return '';
	  }
	
	  return slug.reduce(function (acc, s) {
	    if ((0, _isPlainObject2.default)(s)) {
	      switch (s.type) {
	        case 'payload':
	          acc += '/' + s.selector.map(function (key) {
	            return getByKey(payload, key);
	          }).join('/');
	          break;
	        case 'payload.query':
	          if (payload && !(0, _isNil2.default)(payload[s.selector])) {
	            var value = payload[s.selector];
	
	            if (Array.isArray(value)) {
	              value.forEach(function (item) {
	                acc += '' + querySeparator + s.queryParameter + '[]=' + item;
	                querySeparator = '&';
	              });
	            } else {
	              acc += '' + querySeparator + s.queryParameter + '=' + payload[s.selector];
	              querySeparator = '&';
	            }
	          }
	          if (s.value) {
	            acc += '' + querySeparator + s.queryParameter + '=' + s.value;
	            querySeparator = '&';
	          }
	
	          break;
	        case 'localStorage':
	          acc += '/' + s.selector.map(function (key) {
	            return window.storage.getItem(key);
	          }).join('/');
	          break;
	        default:
	          return acc;
	      }
	    } else if ((0, _isString2.default)(s)) {
	      acc += '/' + s;
	    }
	
	    return acc;
	  }, '');
	};

/***/ }),
/* 4232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeNonNumeric = undefined;
	
	var _validations = __webpack_require__(81);
	
	var removeNonNumeric = exports.removeNonNumeric = function removeNonNumeric(str) {
	  return str.replace(_validations.PATTERNS.ONLY_NUMERIC, '');
	};

/***/ }),
/* 4233 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var updateViewportHeight = exports.updateViewportHeight = function updateViewportHeight() {
	  var contentSelector = '.g-content';
	  var contentElement = document.querySelector(contentSelector);
	  var contentHeight = contentElement.clientHeight;
	
	  var windowHeight = window.innerHeight;
	
	  if (windowHeight < contentHeight) {
	    contentElement.setAttribute('style', 'bottom: ' + (contentHeight - windowHeight) + 'px');
	    window.scrollTo(0, 0);
	  } else {
	    contentElement.removeAttribute('style');
	  }
	};
	
	var setViewportHeight = exports.setViewportHeight = function setViewportHeight() {
	  setTimeout(updateViewportHeight, 300);
	};

/***/ }),
/* 4234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateOffsetTop = calculateOffsetTop;
	
	var _moment = __webpack_require__(24);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_OFFSET = 8 * 4 * _constants.CELL_HEIGHT;
	
	function calculateOffsetTop() {
	  var slots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (slots.length === 0) return DEFAULT_OFFSET;
	
	  var minStartTime = slots[0].scheduleSetting.startTime;
	
	  slots.forEach(function (_ref) {
	    var startTime = _ref.scheduleSetting.startTime;
	
	    if (_moment2.default.utc(startTime).isSameOrBefore(_moment2.default.utc(minStartTime))) {
	      minStartTime = startTime;
	    }
	  });
	
	  var diff = _moment2.default.utc(_moment2.default.utc(minStartTime).format('HH:mm'), 'HH:mm').diff(_moment2.default.utc('00:00', 'HH:mm'));
	
	  if (diff < 0) return DEFAULT_OFFSET;
	
	  return diff / (1000 * 60 * _constants.ONE_MIN_OFFSET);
	}

/***/ }),
/* 4235 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extractHostname = extractHostname;
	/* eslint-disable */
	function extractHostname(url) {
	  if (!url) return '';
	
	  var hostname = void 0;
	  // find & remove protocol (http, ftp, etc.) and get hostname
	  if (url.indexOf('//') > -1) {
	    hostname = url.split('/')[2];
	  } else {
	    hostname = url.split('/')[0];
	  }
	
	  // find & remove port number
	  hostname = hostname.split(':')[0];
	  // find & remove "?"
	  hostname = hostname.split('?')[0];
	
	  return hostname;
	}

/***/ }),
/* 4236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1067);
	
	var Sentry = _interopRequireWildcard(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _tracing = __webpack_require__(2953);
	
	var _browserHistory = __webpack_require__(97);
	
	var _browserHistory2 = _interopRequireDefault(_browserHistory);
	
	var _extractHostname = __webpack_require__(4235);
	
	var _env = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var isDevelopment = _env.DEV_ENV;
	// const isDevelopment = false;
	
	if (!isDevelopment) {
	  console.log('INITIATE SENTRY!');
	  Sentry.init({
	    dsn: _env.SENTRY_CLIENT_DNS,
	    environment: _env.ENV_NAME,
	    integrations: [new _tracing.Integrations.BrowserTracing({
	      tracingOrigins: [(0, _extractHostname.extractHostname)(_env.API_URI)],
	      routingInstrumentation: Sentry.reactRouterV5Instrumentation(_browserHistory2.default)
	    })],
	    tracesSampleRate: 1.0,
	    normalizeDepth: 5,
	    beforeBreadcrumb: function beforeBreadcrumb(breadcrumb) {
	      if (breadcrumb.category === 'fetch') return null;
	      if (breadcrumb.category === 'xhr') {
	        var url = (0, _get2.default)(breadcrumb, 'data.url', '') || '';
	        return url.includes(_env.API_URI) ? breadcrumb : null;
	      }
	      if (breadcrumb.category === 'ui.click') return null;
	      if (breadcrumb.category === 'ui.input') return null;
	      if (breadcrumb.category === 'console') return null;
	
	      return breadcrumb;
	    }
	  });
	}

/***/ }),
/* 4237 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// API constants
	var sortArrayByPriority = function sortArrayByPriority(array, priority) {
	  priority.reverse().forEach(function (priorityItem) {
	    var index = array.findIndex(function (item) {
	      return item.value.toLowerCase() === priorityItem;
	    });
	    var entity = array[index];
	    array.splice(index, 1);
	    array.unshift(entity);
	  });
	
	  return array;
	};
	
	// array of objects
	var sortByPriority = exports.sortByPriority = function sortByPriority(array, key, priority) {
	  priority.reverse().forEach(function (priorityItem) {
	    var index = array.findIndex(function (item) {
	      return item[key] === priorityItem;
	    });
	
	    if (index > -1) {
	      var entity = array[index];
	      array.splice(index, 1);
	      array.unshift(entity);
	    }
	  });
	
	  return array;
	};
	
	exports.default = sortArrayByPriority;

/***/ }),
/* 4238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _props = __webpack_require__(41);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (question) {
	  return (0, _get2.default)(question, 'settings.name') === _props.QUESTION_TYPES.comment;
	};

/***/ }),
/* 4239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dateConverters = __webpack_require__(83);
	
	exports.default = function (sentAt, formatMessage) {
	  var dateStr = sentAt ? (0, _dateConverters.convertDateToUIFormat)(sentAt, formatMessage) : null;
	  return dateStr ? '(' + dateStr + ')' : '';
	};

/***/ }),
/* 4240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _handleExpirationTime = __webpack_require__(1925);
	
	var _handleExpirationTime2 = _interopRequireDefault(_handleExpirationTime);
	
	var _constants = __webpack_require__(17);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (survey, formatMessage) {
	  var showStatus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  var expiredAt = survey.expiredAt,
	      status = survey.status,
	      userAppointment = survey.userAppointment,
	      dueDescription = survey.survey.dueDescription;
	
	  var dateTime = (0, _get2.default)(userAppointment, 'dateTime');
	  var expirationTime = expiredAt || dateTime;
	
	  var expiredAtMessage = '';
	  var statusMessage = '';
	
	  if (expirationTime) {
	    expiredAtMessage = (0, _handleExpirationTime2.default)(expirationTime, false);
	  }
	
	  if (dueDescription) {
	    expiredAtMessage = dueDescription;
	  }
	
	  if (status === _constants.SURVEYS_STATUS_TYPE.STARTED) {
	    statusMessage = formatMessage({ id: 'surveys.isStarted' }).toLowerCase();
	  }
	  if (status === _constants.SURVEYS_STATUS_TYPE.IN_PROGRESS) {
	    statusMessage = formatMessage({ id: 'surveys.inProgress' }).toLowerCase();
	  }
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    statusMessage && showStatus && _react2.default.createElement(
	      'span',
	      {
	        style: {
	          color: _styles.COLORS.blueAccentPlus
	        }
	      },
	      statusMessage
	    ),
	    expiredAtMessage && _react2.default.createElement(
	      'span',
	      null,
	      expiredAtMessage
	    )
	  );
	};

/***/ }),
/* 4241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getServerErrorText = getServerErrorText;
	
	var _get = __webpack_require__(4);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getServerErrorText(payload) {
	  return (0, _get2.default)(payload, 'error.meta.validationErrors.attachment[0].code') || 'Something went wrong';
	}

/***/ }),
/* 4242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.makeToast = makeToast;
	
	var _reactToastify = __webpack_require__(2827);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOAST_CLASSES = {
	  error: 'g-bg--error',
	  success: 'g-bg--error--success'
	};
	
	function getClass(type) {
	  return TOAST_CLASSES[type];
	}
	
	function makeToast(type, message) {
	  var additionalClass = getClass(type);
	
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  return _reactToastify.toast[type](message, (0, _extends3.default)({
	    className: 'toast ' + additionalClass,
	    position: 'bottom-right',
	    autoClose: 4000,
	    hideProgressBar: true,
	    closeOnClick: true,
	    pauseOnHover: true,
	    draggable: true
	  }, rest));
	}

/***/ }),
/* 4243 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var updateIntercom = function updateIntercom(data) {
	  if (window && window.Intercom) {
	    window.Intercom('update', data);
	  }
	};
	
	exports.default = updateIntercom;

/***/ }),
/* 4244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _is_future = __webpack_require__(4707);
	
	var _is_future2 = _interopRequireDefault(_is_future);
	
	var _validateDate = __webpack_require__(1942);
	
	var _validateDate2 = _interopRequireDefault(_validateDate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Validates that the input string is a valid date formatted as "mm-dd-yyyy"
	var validateInputDOB = function validateInputDOB(dateString) {
	  // Check for the pattern
	  var invalidPattern = !/^\d{1,2}-\d{1,2}-\d{4}$/.test(dateString);
	  if (invalidPattern) return false;
	
	  // Check the ranges of year/month/day
	  // Parse the date parts to integers
	  var parts = dateString.split('-');
	  var day = parseInt(parts[1], 10);
	  var month = parseInt(parts[0], 10);
	  var year = parseInt(parts[2], 10);
	  var invalidDate = !(0, _validateDate2.default)(year, month, day);
	  if (invalidDate) return false;
	
	  // Check if entered dob is not in the future
	  var date = new Date(year, month - 1, day);
	  return !(0, _is_future2.default)(date);
	};
	
	exports.default = validateInputDOB;

/***/ }),
/* 4245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validations = __webpack_require__(81);
	
	var SSN_MASK = '***-**-';
	var SSN_MASK_LENGTH = 7;
	
	exports.default = function (value, _ref) {
	  var expectedLengthShort = _ref.expectedLengthShort,
	      expectedLengthFull = _ref.expectedLengthFull;
	
	  if (!value || value.substr(0, SSN_MASK_LENGTH) === SSN_MASK) return true;
	
	  var valueLength = String(value).length;
	  var isValidSSN = !value || valueLength === 0 ? true : _validations.PATTERNS.SSN.test(value);
	  if (expectedLengthShort && expectedLengthFull) {
	    return valueLength === 0 ? true : isValidSSN && (valueLength === expectedLengthShort || valueLength === expectedLengthFull);
	  }
	  return valueLength === 0 ? true : isValidSSN && valueLength === expectedLengthShort;
	};

/***/ }),
/* 4246 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var allowedSymbols = /^[0-9a-zA-Z_-]+$/;
	
	exports.default = function (alias) {
	  return !alias || allowedSymbols.test(alias);
	};

/***/ }),
/* 4247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parse = __webpack_require__(715);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _isValid = __webpack_require__(208);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _format = __webpack_require__(370);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _isBefore = __webpack_require__(2213);
	
	var _isBefore2 = _interopRequireDefault(_isBefore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FORMAT = 'MM-dd-yyyy';
	var MIN_DATE_STRING = '01-01-1900';
	var MIN_DATE = (0, _parse2.default)(MIN_DATE_STRING, FORMAT, new Date());
	
	function isDateNotBeforeMinValidator(value) {
	  var parsed = (0, _parse2.default)(value, FORMAT, new Date());
	
	  if (!(0, _isValid2.default)(parsed)) {
	    return false;
	  }
	
	  if ((0, _format2.default)(parsed, FORMAT) !== value) {
	    return false;
	  }
	
	  if ((0, _isBefore2.default)(parsed, MIN_DATE)) {
	    return false;
	  }
	
	  return true;
	}
	
	exports.default = isDateNotBeforeMinValidator;

/***/ }),
/* 4248 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value, _ref) {
	  var length = _ref.length;
	  return String(value).length < length;
	};

/***/ }),
/* 4249 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value, _ref) {
	  var length = _ref.length;
	
	  var valueLength = String(value).length;
	  return valueLength === 0 ? true : valueLength >= length;
	};

/***/ }),
/* 4250 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var allowedSymbols = /^[+]?[-0-9]+$/;
	
	exports.default = function (phone) {
	  return !phone || allowedSymbols.test(phone);
	};

/***/ }),
/* 4251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validations = __webpack_require__(81);
	
	exports.default = function (value) {
	  var ssnLong = new RegExp('(^[0-9]{' + _validations.LENGTH_VALUES.SSN + '}$)|(^[0-9]{' + _validations.LENGTH_VALUES.SSN_LAST_4 + '}$)');
	
	  return !value || ssnLong.test(value);
	};

/***/ }),
/* 4252 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ruleForUserName = function ruleForUserName(value) {
	  return value && !/^\s+$/.test(value);
	};
	
	exports.default = ruleForUserName;

/***/ }),
/* 4253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validations = __webpack_require__(81);
	
	var _defaultValidator = __webpack_require__(700);
	
	exports.default = function (value) {
	  return !value || (0, _defaultValidator.defaultValidator)(_validations.PATTERNS.USERNAME, value);
	};

/***/ }),
/* 4254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _compact = __webpack_require__(226);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (value) {
	  if ((0, _compact2.default)(value)) {
	    var safeArr = (0, _compact2.default)([].concat((0, _toConsumableArray3.default)(value)));
	    var isPresentTimeZone = safeArr.some(function (item) {
	      return item ? item.value : false;
	    });
	    return isPresentTimeZone && safeArr.length === 3 || safeArr.length === 0 ? true : null;
	  }
	
	  return value;
	};

/***/ }),
/* 4255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'aayuwell-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Aayu Well',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: '',
	  email: 'support@aayuwell.com',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'ascension-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Ascension Saint Thomas Urgent Care',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1 - 615 - 933 - 7030,
	  email: 'support@asturgentcare.com',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'baycare-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'BayCare Concierge Medicine',
	  fillColor: '',
	  welcomeText: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1,
	  email: '@',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'bf-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'BMH Care Anywhere',
	  fillColor: '',
	  welcomeText: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1, // ToDo
	  email: '@', // ToDo
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'bh-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Baptist Health Urgent Care',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1 - 615 - 988 - 2000,
	  email: 'support@baptisthealthurgentcare.net',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'blewm-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Blewm',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 833 - 932 - 5396,
	  email: 'support@blewm.com',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'buc-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Baptist Urgent Care',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1 - 615 - 988 - 2000,
	  email: 'support@baptisturgentcare.net',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'canyon-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Canyon Family Health',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 5077673226,
	  email: 'support@canyonfamilyhealth.com',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'chrysalis-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'CHRYS Counseling',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 8885870335,
	  email: 'support@chryscounseling.com',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'dug-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Doctor’s United Group',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 18773846337,
	  email: 'support@dughealth.org',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	var _styles = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'flagler-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Flagler Health+ Anywhere',
	  welcomeText: 'Already have an account?',
	  fillColor: _styles.COLORS.blueBrighten,
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 9048194475,
	  email: 'appsupport@flaglerhealth.org',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'garnet-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Garnet Healthcare',
	  fillColor: '',
	  welcomeText: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 8028762300,
	  email: 'support@healthfully.app',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'goodwill-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Goodwill Nurse Health Coach',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 8004592003,
	  email: 'support@goodwillhealth.org',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'healthfully-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Healthfully',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 8004592003,
	  email: 'support@healthfully.io',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'healthspark-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Health Spark',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 8004592003,
	  email: 'support@healthspark.net',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'hitech-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'HiTech Health Solutions',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 205 - 447 - 2764,
	  email: 'support@hitechhealthsolutions.com',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'huntsville-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Huntsville Hospital Urgent Care',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1 - 615 - 988 - 2000,
	  email: 'support@hhurgentcare.org',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'iowa-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'ISU Student Health Patient Portal',
	  fillColor: '',
	  welcomeText: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1,
	  email: '@',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'linc-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'LINC me',
	  fillColor: '',
	  welcomeText: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 3863199483,
	  email: 'linc@flaglercares.org',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'marionhealth-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'MyMCPHDChart',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 371 - 221 - 2000,
	  email: 'support@marionhealth.org',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'mdf-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'MDF',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 800 - 459 - 2003,
	  email: 'support@mdfix.com',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'membershealth-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: "Member's Health",
	  fillColor: '',
	  welcomeText: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 8004840152,
	  email: 'support@membershealth.ca',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'myze-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'MYZE',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 2489637933,
	  email: 'support@myze.com',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'pcw-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Physicians Care Walk-In Clinic',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1 - 615 - 988 - 2000,
	  email: 'support@phycare.net',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'pdr-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Persona Doctors',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 8885771570,
	  email: 'support@persona-doctors.com',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'preptimize-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Preptimize',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 18773846337,
	  email: 'support@preptimize.health',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'pw-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Pathways Health Partners',
	  fillColor: '',
	  welcomeText: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1,
	  email: '@',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'pwell-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'PartneredWell',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: '',
	  email: 'support@partneredwell.com',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'sherwood-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Sherwood Urgent Care Arkansas',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1 - 615 - 988 - 2000,
	  email: 'support@sherwoodurgentcare.com',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'synergy-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Synergy Healthcare',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 9805058401,
	  email: 'support@synergyhealthcare.net',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'telewell-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Telewell',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 18773846337,
	  email: 'support@telewell.care',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'uptiv-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Uptiv Health',
	  fillColor: '',
	  welcomeText: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1,
	  email: '@',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'urgentteam-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Urgent Team',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 615 - 988 - 2000,
	  email: 'support@urgentteam.net',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'weber-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Weber County School District',
	  fillColor: '',
	  welcomeText: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 8014767800,
	  email: 'support@healthfully.co',
	  poweredByLogo: true
	};
	
	exports.default = config;

/***/ }),
/* 4289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getBrandLogo = __webpack_require__(86);
	
	var _getBrandLogo2 = _interopRequireDefault(_getBrandLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  logo: 'wr-logo',
	  logoPath: (0, _getBrandLogo2.default)(),
	  logoSize: 44,
	  name: 'Washington Regional Urgent Care',
	  welcomeText: '',
	  fillColor: '',
	  registrationLinkTitle: 'auth.haveAccount.text',
	  phoneNumber: 1 - 615 - 988 - 2008,
	  email: 'support@wregionalurgentcare.com',
	  poweredByLogo: false
	};
	
	exports.default = config;

/***/ }),
/* 4290 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(61);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;(function (root, factory, undef) {
		if (( false ? "undefined" : (0, _typeof3.default)(exports)) === "object") {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(48), __webpack_require__(363), __webpack_require__(1954), __webpack_require__(1952), __webpack_require__(188), __webpack_require__(1951), __webpack_require__(189), __webpack_require__(912), __webpack_require__(549), __webpack_require__(1970), __webpack_require__(913), __webpack_require__(1972), __webpack_require__(1971), __webpack_require__(1969), __webpack_require__(548), __webpack_require__(1965), __webpack_require__(159), __webpack_require__(84), __webpack_require__(1955), __webpack_require__(1957), __webpack_require__(1956), __webpack_require__(1959), __webpack_require__(1958), __webpack_require__(1960), __webpack_require__(1961), __webpack_require__(1962), __webpack_require__(1964), __webpack_require__(1963), __webpack_require__(1953), __webpack_require__(1949), __webpack_require__(1973), __webpack_require__(1968), __webpack_require__(1967), __webpack_require__(1966), __webpack_require__(1950));
		} else if (true) {
			// AMD
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(48), __webpack_require__(363), __webpack_require__(1954), __webpack_require__(1952), __webpack_require__(188), __webpack_require__(1951), __webpack_require__(189), __webpack_require__(912), __webpack_require__(549), __webpack_require__(1970), __webpack_require__(913), __webpack_require__(1972), __webpack_require__(1971), __webpack_require__(1969), __webpack_require__(548), __webpack_require__(1965), __webpack_require__(159), __webpack_require__(84), __webpack_require__(1955), __webpack_require__(1957), __webpack_require__(1956), __webpack_require__(1959), __webpack_require__(1958), __webpack_require__(1960), __webpack_require__(1961), __webpack_require__(1962), __webpack_require__(1964), __webpack_require__(1963), __webpack_require__(1953), __webpack_require__(1949), __webpack_require__(1973), __webpack_require__(1968), __webpack_require__(1967), __webpack_require__(1966), __webpack_require__(1950)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			// Global (browser)
			root.CryptoJS = factory(root.CryptoJS);
		}
	})(undefined, function (CryptoJS) {
	
		return CryptoJS;
	});

/***/ }),
/* 4291 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(4606);
	
	__webpack_require__(4292);
	
	__webpack_require__(4332);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4292 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4293 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4335), __esModule: true };

/***/ }),
/* 4294 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4338), __esModule: true };

/***/ }),
/* 4295 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4339), __esModule: true };

/***/ }),
/* 4296 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4341), __esModule: true };

/***/ }),
/* 4297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4349), __esModule: true };

/***/ }),
/* 4298 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4352), __esModule: true };

/***/ }),
/* 4299 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4353), __esModule: true };

/***/ }),
/* 4300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4355), __esModule: true };

/***/ }),
/* 4301 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(4356), __esModule: true };

/***/ }),
/* 4302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(550);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ }),
/* 4303 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(4304);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 4304 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 4305 */
/***/ (function(module, exports) {

	function createBroadcast (initialState) {
	  var listeners = {};
	  var id = 1;
	  var _state = initialState;
	
	  function getState () {
	    return _state
	  }
	
	  function setState (state) {
	    _state = state;
	    var keys = Object.keys(listeners);
	    var i = 0;
	    var len = keys.length;
	    for (; i < len; i++) {
	      // if a listener gets unsubscribed during setState we just skip it
	      if (listeners[keys[i]]) { listeners[keys[i]](state); }
	    }
	  }
	
	  // subscribe to changes and return the subscriptionId
	  function subscribe (listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('listener must be a function.')
	    }
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    return currentId
	  }
	
	  // remove subscription by removing the listener function
	  function unsubscribe (id) {
	    listeners[id] = undefined;
	  }
	
	  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
	}
	
	module.exports = createBroadcast;


/***/ }),
/* 4306 */,
/* 4307 */,
/* 4308 */,
/* 4309 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1978,
		"./af.js": 1978,
		"./ar": 1985,
		"./ar-dz": 1979,
		"./ar-dz.js": 1979,
		"./ar-kw": 1980,
		"./ar-kw.js": 1980,
		"./ar-ly": 1981,
		"./ar-ly.js": 1981,
		"./ar-ma": 1982,
		"./ar-ma.js": 1982,
		"./ar-sa": 1983,
		"./ar-sa.js": 1983,
		"./ar-tn": 1984,
		"./ar-tn.js": 1984,
		"./ar.js": 1985,
		"./az": 1986,
		"./az.js": 1986,
		"./be": 1987,
		"./be.js": 1987,
		"./bg": 1988,
		"./bg.js": 1988,
		"./bm": 1989,
		"./bm.js": 1989,
		"./bn": 1991,
		"./bn-bd": 1990,
		"./bn-bd.js": 1990,
		"./bn.js": 1991,
		"./bo": 1992,
		"./bo.js": 1992,
		"./br": 1993,
		"./br.js": 1993,
		"./bs": 1994,
		"./bs.js": 1994,
		"./ca": 1995,
		"./ca.js": 1995,
		"./cs": 1996,
		"./cs.js": 1996,
		"./cv": 1997,
		"./cv.js": 1997,
		"./cy": 1998,
		"./cy.js": 1998,
		"./da": 1999,
		"./da.js": 1999,
		"./de": 2002,
		"./de-at": 2000,
		"./de-at.js": 2000,
		"./de-ch": 2001,
		"./de-ch.js": 2001,
		"./de.js": 2002,
		"./dv": 2003,
		"./dv.js": 2003,
		"./el": 2004,
		"./el.js": 2004,
		"./en-au": 2005,
		"./en-au.js": 2005,
		"./en-ca": 2006,
		"./en-ca.js": 2006,
		"./en-gb": 2007,
		"./en-gb.js": 2007,
		"./en-ie": 2008,
		"./en-ie.js": 2008,
		"./en-il": 2009,
		"./en-il.js": 2009,
		"./en-in": 2010,
		"./en-in.js": 2010,
		"./en-nz": 2011,
		"./en-nz.js": 2011,
		"./en-sg": 2012,
		"./en-sg.js": 2012,
		"./eo": 2013,
		"./eo.js": 2013,
		"./es": 2017,
		"./es-do": 2014,
		"./es-do.js": 2014,
		"./es-mx": 2015,
		"./es-mx.js": 2015,
		"./es-us": 2016,
		"./es-us.js": 2016,
		"./es.js": 2017,
		"./et": 2018,
		"./et.js": 2018,
		"./eu": 2019,
		"./eu.js": 2019,
		"./fa": 2020,
		"./fa.js": 2020,
		"./fi": 2021,
		"./fi.js": 2021,
		"./fil": 2022,
		"./fil.js": 2022,
		"./fo": 2023,
		"./fo.js": 2023,
		"./fr": 2026,
		"./fr-ca": 2024,
		"./fr-ca.js": 2024,
		"./fr-ch": 2025,
		"./fr-ch.js": 2025,
		"./fr.js": 2026,
		"./fy": 2027,
		"./fy.js": 2027,
		"./ga": 2028,
		"./ga.js": 2028,
		"./gd": 2029,
		"./gd.js": 2029,
		"./gl": 2030,
		"./gl.js": 2030,
		"./gom-deva": 2031,
		"./gom-deva.js": 2031,
		"./gom-latn": 2032,
		"./gom-latn.js": 2032,
		"./gu": 2033,
		"./gu.js": 2033,
		"./he": 2034,
		"./he.js": 2034,
		"./hi": 2035,
		"./hi.js": 2035,
		"./hr": 2036,
		"./hr.js": 2036,
		"./hu": 2037,
		"./hu.js": 2037,
		"./hy-am": 2038,
		"./hy-am.js": 2038,
		"./id": 2039,
		"./id.js": 2039,
		"./is": 2040,
		"./is.js": 2040,
		"./it": 2042,
		"./it-ch": 2041,
		"./it-ch.js": 2041,
		"./it.js": 2042,
		"./ja": 2043,
		"./ja.js": 2043,
		"./jv": 2044,
		"./jv.js": 2044,
		"./ka": 2045,
		"./ka.js": 2045,
		"./kk": 2046,
		"./kk.js": 2046,
		"./km": 2047,
		"./km.js": 2047,
		"./kn": 2048,
		"./kn.js": 2048,
		"./ko": 2049,
		"./ko.js": 2049,
		"./ku": 2050,
		"./ku.js": 2050,
		"./ky": 2051,
		"./ky.js": 2051,
		"./lb": 2052,
		"./lb.js": 2052,
		"./lo": 2053,
		"./lo.js": 2053,
		"./lt": 2054,
		"./lt.js": 2054,
		"./lv": 2055,
		"./lv.js": 2055,
		"./me": 2056,
		"./me.js": 2056,
		"./mi": 2057,
		"./mi.js": 2057,
		"./mk": 2058,
		"./mk.js": 2058,
		"./ml": 2059,
		"./ml.js": 2059,
		"./mn": 2060,
		"./mn.js": 2060,
		"./mr": 2061,
		"./mr.js": 2061,
		"./ms": 2063,
		"./ms-my": 2062,
		"./ms-my.js": 2062,
		"./ms.js": 2063,
		"./mt": 2064,
		"./mt.js": 2064,
		"./my": 2065,
		"./my.js": 2065,
		"./nb": 2066,
		"./nb.js": 2066,
		"./ne": 2067,
		"./ne.js": 2067,
		"./nl": 2069,
		"./nl-be": 2068,
		"./nl-be.js": 2068,
		"./nl.js": 2069,
		"./nn": 2070,
		"./nn.js": 2070,
		"./oc-lnc": 2071,
		"./oc-lnc.js": 2071,
		"./pa-in": 2072,
		"./pa-in.js": 2072,
		"./pl": 2073,
		"./pl.js": 2073,
		"./pt": 2075,
		"./pt-br": 2074,
		"./pt-br.js": 2074,
		"./pt.js": 2075,
		"./ro": 2076,
		"./ro.js": 2076,
		"./ru": 2077,
		"./ru.js": 2077,
		"./sd": 2078,
		"./sd.js": 2078,
		"./se": 2079,
		"./se.js": 2079,
		"./si": 2080,
		"./si.js": 2080,
		"./sk": 2081,
		"./sk.js": 2081,
		"./sl": 2082,
		"./sl.js": 2082,
		"./sq": 2083,
		"./sq.js": 2083,
		"./sr": 2085,
		"./sr-cyrl": 2084,
		"./sr-cyrl.js": 2084,
		"./sr.js": 2085,
		"./ss": 2086,
		"./ss.js": 2086,
		"./sv": 2087,
		"./sv.js": 2087,
		"./sw": 2088,
		"./sw.js": 2088,
		"./ta": 2089,
		"./ta.js": 2089,
		"./te": 2090,
		"./te.js": 2090,
		"./tet": 2091,
		"./tet.js": 2091,
		"./tg": 2092,
		"./tg.js": 2092,
		"./th": 2093,
		"./th.js": 2093,
		"./tk": 2094,
		"./tk.js": 2094,
		"./tl-ph": 2095,
		"./tl-ph.js": 2095,
		"./tlh": 2096,
		"./tlh.js": 2096,
		"./tr": 2097,
		"./tr.js": 2097,
		"./tzl": 2098,
		"./tzl.js": 2098,
		"./tzm": 2100,
		"./tzm-latn": 2099,
		"./tzm-latn.js": 2099,
		"./tzm.js": 2100,
		"./ug-cn": 2101,
		"./ug-cn.js": 2101,
		"./uk": 2102,
		"./uk.js": 2102,
		"./ur": 2103,
		"./ur.js": 2103,
		"./uz": 2105,
		"./uz-latn": 2104,
		"./uz-latn.js": 2104,
		"./uz.js": 2105,
		"./vi": 2106,
		"./vi.js": 2106,
		"./x-pseudo": 2107,
		"./x-pseudo.js": 2107,
		"./yo": 2108,
		"./yo.js": 2108,
		"./zh-cn": 2109,
		"./zh-cn.js": 2109,
		"./zh-hk": 2110,
		"./zh-hk.js": 2110,
		"./zh-mo": 2111,
		"./zh-mo.js": 2111,
		"./zh-tw": 2112,
		"./zh-tw.js": 2112
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 4309;


/***/ }),
/* 4310 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(Chart) {
		var chartHelpers = Chart.helpers;
	
		var helpers = __webpack_require__(915)(Chart);
		var events = __webpack_require__(4312)(Chart);
	
		var annotationTypes = Chart.Annotation.types;
	
		function setAfterDataLimitsHook(axisOptions) {
			helpers.decorate(axisOptions, 'afterDataLimits', function(previous, scale) {
				if (previous) previous(scale);
				helpers.adjustScaleRange(scale);
			});
		}
	
		function draw(drawTime) {
			return function(chartInstance, easingDecimal) {
				var defaultDrawTime = chartInstance.annotation.options.drawTime;
	
				helpers.elements(chartInstance)
					.filter(function(element) {
						return drawTime === (element.options.drawTime || defaultDrawTime);
					})
					.forEach(function(element) {
						element.transition(easingDecimal).draw();
					});
			};
		}
	
		return {
			beforeInit: function(chartInstance) {
				var chartOptions = chartInstance.options;
	
				// Initialize chart instance plugin namespace
				var ns = chartInstance.annotation = {
					elements: {},
					options: helpers.initConfig(chartOptions.annotation || {}),
					onDestroy: [],
					firstRun: true,
					supported: false
				};
	
				// Add the annotation scale adjuster to each scale's afterDataLimits hook
				chartInstance.ensureScalesHaveIDs();
				if (chartOptions.scales) {
					ns.supported = true;
					chartHelpers.each(chartOptions.scales.xAxes, setAfterDataLimitsHook);
					chartHelpers.each(chartOptions.scales.yAxes, setAfterDataLimitsHook);
				}
			},
			beforeUpdate: function(chartInstance) {
				var ns = chartInstance.annotation;
	
				if (!ns.supported) {
					return;
				}
	
				if (!ns.firstRun) {
					ns.options = helpers.initConfig(chartInstance.options.annotation || {});
				} else {
					ns.firstRun = false;
				}
	
				var elementIds = [];
	
				// Add new elements, or update existing ones
				ns.options.annotations.forEach(function(annotation) {
					var id = annotation.id || helpers.objectId();
					
					// No element with that ID exists, and it's a valid annotation type
					if (!ns.elements[id] && annotationTypes[annotation.type]) {
						var cls = annotationTypes[annotation.type];
						var element = new cls({
							id: id,
							options: annotation,
							chartInstance: chartInstance,
						});
						element.initialize();
						ns.elements[id] = element;
						annotation.id = id;
						elementIds.push(id);
					} else if (ns.elements[id]) {
						// Nothing to do for update, since the element config references
						// the same object that exists in the chart annotation config
						elementIds.push(id);
					}
				});
	
				// Delete removed elements
				Object.keys(ns.elements).forEach(function(id) {
					if (elementIds.indexOf(id) === -1) {
						ns.elements[id].destroy();
						delete ns.elements[id];
					}
				});
			},
			afterScaleUpdate: function(chartInstance) {
				helpers.elements(chartInstance).forEach(function(element) {
					element.configure();
				});
			},
			beforeDatasetsDraw: draw('beforeDatasetsDraw'),
			afterDatasetsDraw: draw('afterDatasetsDraw'),
			afterDraw: draw('afterDraw'),
			afterInit: function(chartInstance) {
				// Detect and intercept events that happen on an annotation element
				var watchFor = chartInstance.annotation.options.events;
				if (chartHelpers.isArray(watchFor) && watchFor.length > 0) {
					var canvas = chartInstance.chart.canvas;
					var eventHandler = events.dispatcher.bind(chartInstance);
					events.collapseHoverEvents(watchFor).forEach(function(eventName) {
						chartHelpers.addEvent(canvas, eventName, eventHandler);
						chartInstance.annotation.onDestroy.push(function() {
							chartHelpers.removeEvent(canvas, eventName, eventHandler);
						});
					});
				}
			},
			destroy: function(chartInstance) {
				var deregisterers = chartInstance.annotation.onDestroy;
				while (deregisterers.length > 0) {
					deregisterers.pop()();
				}
			}
		};
	};


/***/ }),
/* 4311 */
/***/ (function(module, exports) {

	module.exports = function(Chart) {
		var chartHelpers = Chart.helpers;
		
		var AnnotationElement = Chart.Element.extend({
			initialize: function() {
				this.hidden = false;
				this.hovering = false;
				this._model = chartHelpers.clone(this._model) || {};
				this.setDataLimits();
			},
			destroy: function() {},
			setDataLimits: function() {},
			configure: function() {},
			inRange: function() {},
			getCenterPoint: function() {},
			getWidth: function() {},
			getHeight: function() {},
			getArea: function() {},
			draw: function() {}
		});
	
		return AnnotationElement;
	};


/***/ }),
/* 4312 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function(Chart) {
		var chartHelpers = Chart.helpers;
		var helpers = __webpack_require__(915)(Chart);
	
		function collapseHoverEvents(events) {
			var hover = false;
			var filteredEvents = events.filter(function(eventName) {
				switch (eventName) {
					case 'mouseenter':
					case 'mouseover':
					case 'mouseout':
					case 'mouseleave':
						hover = true;
						return false;
	
					default:
						return true;
				}
			});
			if (hover && filteredEvents.indexOf('mousemove') === -1) {
				filteredEvents.push('mousemove');
			}
			return filteredEvents;
		}
	
		function dispatcher(e) {
			var ns = this.annotation;
			var elements = helpers.elements(this);
			var position = chartHelpers.getRelativePosition(e, this.chart);
			var element = helpers.getNearestItems(elements, position);
			var events = collapseHoverEvents(ns.options.events);
			var dblClickSpeed = ns.options.dblClickSpeed;
			var eventHandlers = [];
			var eventHandlerName = helpers.getEventHandlerName(e.type);
			var options = (element || {}).options;
	
			// Detect hover events
			if (e.type === 'mousemove') {
				if (element && !element.hovering) {
					// hover started
					['mouseenter', 'mouseover'].forEach(function(eventName) {
						var eventHandlerName = helpers.getEventHandlerName(eventName);
						var hoverEvent = helpers.createMouseEvent(eventName, e); // recreate the event to match the handler
						element.hovering = true;
						if (typeof options[eventHandlerName] === 'function') {
							eventHandlers.push([ options[eventHandlerName], hoverEvent, element ]);
						}
					});
				} else if (!element) {
					// hover ended
					elements.forEach(function(element) {
						if (element.hovering) {
							element.hovering = false;
							var options = element.options;
							['mouseout', 'mouseleave'].forEach(function(eventName) {
								var eventHandlerName = helpers.getEventHandlerName(eventName);
								var hoverEvent = helpers.createMouseEvent(eventName, e); // recreate the event to match the handler
								if (typeof options[eventHandlerName] === 'function') {
									eventHandlers.push([ options[eventHandlerName], hoverEvent, element ]);
								}
							});
						}
					});
				}
			}
	
			// Suppress duplicate click events during a double click
			// 1. click -> 2. click -> 3. dblclick
			//
			// 1: wait dblClickSpeed ms, then fire click
			// 2: cancel (1) if it is waiting then wait dblClickSpeed ms then fire click, else fire click immediately
			// 3: cancel (1) or (2) if waiting, then fire dblclick 
			if (element && events.indexOf('dblclick') > -1 && typeof options.onDblclick === 'function') {
				if (e.type === 'click' && typeof options.onClick === 'function') {
					clearTimeout(element.clickTimeout);
					element.clickTimeout = setTimeout(function() {
						delete element.clickTimeout;
						options.onClick.call(element, e);
					}, dblClickSpeed);
					e.stopImmediatePropagation();
					e.preventDefault();
					return;
				} else if (e.type === 'dblclick' && element.clickTimeout) {
					clearTimeout(element.clickTimeout);
					delete element.clickTimeout;
				}
			}
	
			// Dispatch the event to the usual handler, but only if we haven't substituted it
			if (element && typeof options[eventHandlerName] === 'function' && eventHandlers.length === 0) {
				eventHandlers.push([ options[eventHandlerName], e, element ]);
			}
	
			if (eventHandlers.length > 0) {
				e.stopImmediatePropagation();
				e.preventDefault();
				eventHandlers.forEach(function(eventHandler) {
					// [handler, event, element]
					eventHandler[0].call(eventHandler[2], eventHandler[1]);
				});
			}
		}
	
		return {
			dispatcher: dispatcher,
			collapseHoverEvents: collapseHoverEvents
		};
	};


/***/ }),
/* 4313 */
/***/ (function(module, exports, __webpack_require__) {

	// Box Annotation implementation
	module.exports = function(Chart) {
		var helpers = __webpack_require__(915)(Chart);
		
		var BoxAnnotation = Chart.Annotation.Element.extend({
			setDataLimits: function() {
				var model = this._model;
				var options = this.options;
				var chartInstance = this.chartInstance;
	
				var xScale = chartInstance.scales[options.xScaleID];
				var yScale = chartInstance.scales[options.yScaleID];
				var chartArea = chartInstance.chartArea;
	
				// Set the data range for this annotation
				model.ranges = {};
				
				if (!chartArea) {
					return;
				}
				
				var min = 0;
				var max = 0;
				
				if (xScale) {
					min = helpers.isValid(options.xMin) ? options.xMin : xScale.getPixelForValue(chartArea.left);
					max = helpers.isValid(options.xMax) ? options.xMax : xScale.getPixelForValue(chartArea.right);
	
					model.ranges[options.xScaleID] = {
						min: Math.min(min, max),
						max: Math.max(min, max)
					};
				}
	
				if (yScale) {
					min = helpers.isValid(options.yMin) ? options.yMin : yScale.getPixelForValue(chartArea.bottom);
					max = helpers.isValid(options.yMax) ? options.yMax : yScale.getPixelForValue(chartArea.top);
	
					model.ranges[options.yScaleID] = {
						min: Math.min(min, max),
						max: Math.max(min, max)
					};
				}
			},
			configure: function() {
				var model = this._model;
				var options = this.options;
				var chartInstance = this.chartInstance;
	
				var xScale = chartInstance.scales[options.xScaleID];
				var yScale = chartInstance.scales[options.yScaleID];
				var chartArea = chartInstance.chartArea;
	
				// clip annotations to the chart area
				model.clip = {
					x1: chartArea.left,
					x2: chartArea.right,
					y1: chartArea.top,
					y2: chartArea.bottom
				};
	
				var left = chartArea.left, 
					top = chartArea.top, 
					right = chartArea.right, 
					bottom = chartArea.bottom;
	
				var min, max;
	
				if (xScale) {
					min = helpers.isValid(options.xMin) ? xScale.getPixelForValue(options.xMin) : chartArea.left;
					max = helpers.isValid(options.xMax) ? xScale.getPixelForValue(options.xMax) : chartArea.right;
					left = Math.min(min, max);
					right = Math.max(min, max);
				}
	
				if (yScale) {
					min = helpers.isValid(options.yMin) ? yScale.getPixelForValue(options.yMin) : chartArea.bottom;
					max = helpers.isValid(options.yMax) ? yScale.getPixelForValue(options.yMax) : chartArea.top;
					top = Math.min(min, max);
					bottom = Math.max(min, max);
				}
	
				// Ensure model has rect coordinates
				model.left = left;
				model.top = top;
				model.right = right;
				model.bottom = bottom;
	
				// Stylistic options
				model.borderColor = options.borderColor;
				model.borderWidth = options.borderWidth;
				model.backgroundColor = options.backgroundColor;
			},
			inRange: function(mouseX, mouseY) {
				var model = this._model;
				return model &&
					mouseX >= model.left && 
					mouseX <= model.right && 
					mouseY >= model.top && 
					mouseY <= model.bottom;
			},
			getCenterPoint: function() {
				var model = this._model;
				return {
					x: (model.right + model.left) / 2,
					y: (model.bottom + model.top) / 2
				};
			},
			getWidth: function() {
				var model = this._model;
				return Math.abs(model.right - model.left);
			},
			getHeight: function() {
				var model = this._model;
				return Math.abs(model.bottom - model.top);
			},
			getArea: function() {
				return this.getWidth() * this.getHeight();
			},
			draw: function() {
				var view = this._view;
				var ctx = this.chartInstance.chart.ctx;
	
				ctx.save();
	
				// Canvas setup
				ctx.beginPath();
				ctx.rect(view.clip.x1, view.clip.y1, view.clip.x2 - view.clip.x1, view.clip.y2 - view.clip.y1);
				ctx.clip();
	
				ctx.lineWidth = view.borderWidth;
				ctx.strokeStyle = view.borderColor;
				ctx.fillStyle = view.backgroundColor;
	
				// Draw
				var width = view.right - view.left,
					height = view.bottom - view.top;
				ctx.fillRect(view.left, view.top, width, height);
				ctx.strokeRect(view.left, view.top, width, height);
	
				ctx.restore();
			}
		});
	
		return BoxAnnotation;
	};


/***/ }),
/* 4314 */
/***/ (function(module, exports, __webpack_require__) {

	// Line Annotation implementation
	module.exports = function(Chart) {
		var chartHelpers = Chart.helpers;
		var helpers = __webpack_require__(915)(Chart);
	
		var horizontalKeyword = 'horizontal';
		var verticalKeyword = 'vertical';
	
		var LineAnnotation = Chart.Annotation.Element.extend({
			setDataLimits: function() {
				var model = this._model;
				var options = this.options;
	
				// Set the data range for this annotation
				model.ranges = {};
				model.ranges[options.scaleID] = {
					min: options.value,
					max: options.endValue || options.value
				};
			},
			configure: function() {
				var model = this._model;
				var options = this.options;
				var chartInstance = this.chartInstance;
				var ctx = chartInstance.chart.ctx;
	
				var scale = chartInstance.scales[options.scaleID];
				var pixel, endPixel;
				if (scale) {
					pixel = helpers.isValid(options.value) ? scale.getPixelForValue(options.value) : NaN;
					endPixel = helpers.isValid(options.endValue) ? scale.getPixelForValue(options.endValue) : pixel;
				}
	
				if (isNaN(pixel)) {
					return;
				}
	
				var chartArea = chartInstance.chartArea;
	
				// clip annotations to the chart area
				model.clip = {
					x1: chartArea.left,
					x2: chartArea.right,
					y1: chartArea.top,
					y2: chartArea.bottom
				};
	
				if (this.options.mode == horizontalKeyword) {
					model.x1 = chartArea.left;
					model.x2 = chartArea.right;
					model.y1 = pixel;
					model.y2 = endPixel;
				} else {
					model.y1 = chartArea.top;
					model.y2 = chartArea.bottom;
					model.x1 = pixel;
					model.x2 = endPixel;
				}
	
				model.line = new LineFunction(model);
				model.mode = options.mode;
	
				// Figure out the label:
				model.labelBackgroundColor = options.label.backgroundColor;
				model.labelFontFamily = options.label.fontFamily;
				model.labelFontSize = options.label.fontSize;
				model.labelFontStyle = options.label.fontStyle;
				model.labelFontColor = options.label.fontColor;
				model.labelXPadding = options.label.xPadding;
				model.labelYPadding = options.label.yPadding;
				model.labelCornerRadius = options.label.cornerRadius;
				model.labelPosition = options.label.position;
				model.labelXAdjust = options.label.xAdjust;
				model.labelYAdjust = options.label.yAdjust;
				model.labelEnabled = options.label.enabled;
				model.labelContent = options.label.content;
	
				ctx.font = chartHelpers.fontString(model.labelFontSize, model.labelFontStyle, model.labelFontFamily);
				var textWidth = ctx.measureText(model.labelContent).width;
				var textHeight = ctx.measureText('M').width;
				var labelPosition = calculateLabelPosition(model, textWidth, textHeight, model.labelXPadding, model.labelYPadding);
				model.labelX = labelPosition.x - model.labelXPadding;
				model.labelY = labelPosition.y - model.labelYPadding;
				model.labelWidth = textWidth + (2 * model.labelXPadding);
				model.labelHeight = textHeight + (2 * model.labelYPadding);
	
				model.borderColor = options.borderColor;
				model.borderWidth = options.borderWidth;
				model.borderDash = options.borderDash || [];
				model.borderDashOffset = options.borderDashOffset || 0;
			},
			inRange: function(mouseX, mouseY) {
				var model = this._model;
				
				return (
					// On the line
					model.line &&
					model.line.intersects(mouseX, mouseY, this.getHeight())
				) || (
					// On the label
					model.labelEnabled &&
					model.labelContent &&
					mouseX >= model.labelX && 
					mouseX <= model.labelX + model.labelWidth && 
					mouseY >= model.labelY && 
					mouseY <= model.labelY + model.labelHeight
				);
			},
			getCenterPoint: function() {
				return {
					x: (this._model.x2 + this._model.x1) / 2,
					y: (this._model.y2 + this._model.y1) / 2
				};
			},
			getWidth: function() {
				return Math.abs(this._model.right - this._model.left);
			},
			getHeight: function() {
				return this._model.borderWidth || 1;
			},
			getArea: function() {
				return Math.sqrt(Math.pow(this.getWidth(), 2) + Math.pow(this.getHeight(), 2));
			},
			draw: function() {
				var view = this._view;
				var ctx = this.chartInstance.chart.ctx;
	
				if (!view.clip) {
					return;
				}
	
				ctx.save();
	
				// Canvas setup
				ctx.beginPath();
				ctx.rect(view.clip.x1, view.clip.y1, view.clip.x2 - view.clip.x1, view.clip.y2 - view.clip.y1);
				ctx.clip();
	
				ctx.lineWidth = view.borderWidth;
				ctx.strokeStyle = view.borderColor;
	
				if (ctx.setLineDash) {
					ctx.setLineDash(view.borderDash);
				}
				ctx.lineDashOffset = view.borderDashOffset;
	
				// Draw
				ctx.beginPath();
				ctx.moveTo(view.x1, view.y1);
				ctx.lineTo(view.x2, view.y2);
				ctx.stroke();
	
				if (view.labelEnabled && view.labelContent) {
					ctx.beginPath();
					ctx.rect(view.clip.x1, view.clip.y1, view.clip.x2 - view.clip.x1, view.clip.y2 - view.clip.y1);
					ctx.clip();
	
					ctx.fillStyle = view.labelBackgroundColor;
					// Draw the tooltip
					chartHelpers.drawRoundedRectangle(
						ctx,
						view.labelX, // x
						view.labelY, // y
						view.labelWidth, // width
						view.labelHeight, // height
						view.labelCornerRadius // radius
					);
					ctx.fill();
	
					// Draw the text
					ctx.font = chartHelpers.fontString(
						view.labelFontSize,
						view.labelFontStyle,
						view.labelFontFamily
					);
					ctx.fillStyle = view.labelFontColor;
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.fillText(
						view.labelContent,
						view.labelX + (view.labelWidth / 2),
						view.labelY + (view.labelHeight / 2)
					);
				}
	
				ctx.restore();
			}
		});
	
		function LineFunction(view) {
			// Describe the line in slope-intercept form (y = mx + b).
			// Note that the axes are rotated 90° CCW, which causes the
			// x- and y-axes to be swapped.
			var m = (view.x2 - view.x1) / (view.y2 - view.y1);
			var b = view.x1 || 0;
	
			this.m = m;
			this.b = b;
	
			this.getX = function(y) {
				// Coordinates are relative to the origin of the canvas
				return m * (y - view.y1) + b;
			};
	
			this.getY = function(x) {
				return ((x - b) / m) + view.y1;
			};
	
			this.intersects = function(x, y, epsilon) {
				epsilon = epsilon || 0.001;
				var dy = this.getY(x),
					dx = this.getX(y);
				return (
					(!isFinite(dy) || Math.abs(y - dy) < epsilon) &&
					(!isFinite(dx) || Math.abs(x - dx) < epsilon)
				);
			};
		}
	
		function calculateLabelPosition(view, width, height, padWidth, padHeight) {
			var line = view.line;
			var ret = {}, xa = 0, ya = 0;
	
			switch (true) {
				// top align
				case view.mode == verticalKeyword && view.labelPosition == "top":
					ya = padHeight + view.labelYAdjust;
					xa = (width / 2) + view.labelXAdjust;
					ret.y = view.y1 + ya;
					ret.x = (isFinite(line.m) ? line.getX(ret.y) : view.x1) - xa;
				break;
	
				// bottom align
				case view.mode == verticalKeyword && view.labelPosition == "bottom":
					ya = height + padHeight + view.labelYAdjust;
					xa = (width / 2) + view.labelXAdjust;
					ret.y = view.y2 - ya;
					ret.x = (isFinite(line.m) ? line.getX(ret.y) : view.x1) - xa;
				break;
	
				// left align
				case view.mode == horizontalKeyword && view.labelPosition == "left":
					xa = padWidth + view.labelXAdjust;
					ya = -(height / 2) + view.labelYAdjust;
					ret.x = view.x1 + xa;
					ret.y = line.getY(ret.x) + ya;
				break;
	
				// right align
				case view.mode == horizontalKeyword && view.labelPosition == "right":
					xa = width + padWidth + view.labelXAdjust;
					ya = -(height / 2) + view.labelYAdjust;
					ret.x = view.x2 - xa;
					ret.y = line.getY(ret.x) + ya;
				break;
	
				// center align
				default:
					ret.x = ((view.x1 + view.x2 - width) / 2) + view.labelXAdjust;
					ret.y = ((view.y1 + view.y2 - height) / 2) + view.labelYAdjust;
			}
	
			return ret;
		}
	
		return LineAnnotation;
	};


/***/ }),
/* 4315 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * chartjs-plugin-style v0.5.0
	 * https://nagix.github.io/chartjs-plugin-style
	 * (c) 2019 Akihiko Kusanagi
	 * Released under the MIT license
	 */
	(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__(702)) :
	typeof define === 'function' && define.amd ? define(['chart.js'], factory) :
	(global = global || self, global.ChartStyle = factory(global.Chart));
	}(this, function (Chart) { 'use strict';
	
	Chart = Chart && Chart.hasOwnProperty('default') ? Chart['default'] : Chart;
	
	var helpers = Chart.helpers;
	var optionsHelpers = helpers.options || {};
	
	var optionsHelpers$1 = helpers.extend(optionsHelpers, {
	
		// For Chart.js 2.6.0 backward compatibility
		resolve: optionsHelpers.resolve || function(inputs, context, index) {
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
				}
				if (index !== undefined && helpers.isArray(value)) {
					value = value[index];
				}
				if (value !== undefined) {
					return value;
				}
			}
		}
	});
	
	var helpers$1 = Chart.helpers;
	
	var resolve = optionsHelpers$1.resolve;
	
	var OFFSET = 1000000;
	
	function isColorOption(key) {
		return key.indexOf('Color') !== -1;
	}
	
	var styleHelpers = {
	
		styleKeys: [
			'shadowOffsetX',
			'shadowOffsetY',
			'shadowBlur',
			'shadowColor',
			'bevelWidth',
			'bevelHighlightColor',
			'bevelShadowColor',
			'innerGlowWidth',
			'innerGlowColor',
			'outerGlowWidth',
			'outerGlowColor',
			'backgroundOverlayColor',
			'backgroundOverlayMode'
		],
	
		lineStyleKeys: [
			'shadowOffsetX',
			'shadowOffsetY',
			'shadowBlur',
			'shadowColor',
			'outerGlowWidth',
			'outerGlowColor'
		],
	
		pointStyleKeys: [
			'pointShadowOffsetX',
			'pointShadowOffsetY',
			'pointShadowBlur',
			'pointShadowColor',
			'pointBevelWidth',
			'pointBevelHighlightColor',
			'pointBevelShadowColor',
			'pointInnerGlowWidth',
			'pointInnerGlowColor',
			'pointOuterGlowWidth',
			'pointOuterGlowColor',
			'pointBackgroundOverlayColor',
			'pointBackgroundOverlayMode'
		],
	
		hoverStyleKeys: [
			'hoverShadowOffsetX',
			'hoverShadowOffsetY',
			'hoverShadowBlur',
			'hoverShadowColor',
			'hoverBevelWidth',
			'hoverBevelHighlightColor',
			'hoverBevelShadowColor',
			'hoverInnerGlowWidth',
			'hoverInnerGlowColor',
			'hoverOuterGlowWidth',
			'hoverOuterGlowColor',
			'hoverBackgroundOverlayColor',
			'hoverBackgroundOverlayMode'
		],
	
		pointHoverStyleKeys: [
			'pointHoverShadowOffsetX',
			'pointHoverShadowOffsetY',
			'pointHoverShadowBlur',
			'pointHoverShadowColor',
			'pointHoverBevelWidth',
			'pointHoverBevelHighlightColor',
			'pointHoverBevelShadowColor',
			'pointHoverInnerGlowWidth',
			'pointHoverInnerGlowColor',
			'pointHoverOuterGlowWidth',
			'pointHoverOuterGlowColor',
			'pointHoverBackgroundOverlayColor',
			'pointHoverBackgroundOverlayMode'
		],
	
		drawBackground: function(view, drawCallback) {
			var borderWidth = view.borderWidth;
	
			view.borderWidth = 0;
			drawCallback();
			view.borderWidth = borderWidth;
		},
	
		drawBorder: function(view, drawCallback) {
			var backgroundColor = view.backgroundColor;
	
			if (view.borderWidth) {
				view.backgroundColor = 'rgba(0, 0, 0, 0)';
				drawCallback();
				view.backgroundColor = backgroundColor;
			}
		},
	
		drawShadow: function(chart, options, drawCallback, backmost) {
			var ctx = chart.ctx;
			var pixelRatio = chart.currentDevicePixelRatio;
	
			ctx.save();
	
			ctx.shadowOffsetX = (options.shadowOffsetX + OFFSET) * pixelRatio;
			ctx.shadowOffsetY = options.shadowOffsetY * pixelRatio;
			ctx.shadowBlur = options.shadowBlur * pixelRatio;
			ctx.shadowColor = options.shadowColor;
			if (backmost) {
				ctx.globalCompositeOperation = 'destination-over';
			}
			ctx.translate(-OFFSET, 0);
	
			drawCallback();
	
			ctx.restore();
		},
	
		setPath: function(ctx, drawCallback) {
			ctx.save();
			ctx.beginPath();
			ctx.clip();
			drawCallback();
			ctx.restore();
		},
	
		drawBevel: function(chart, options, drawCallback) {
			var ctx = chart.ctx;
			var pixelRatio = chart.currentDevicePixelRatio;
			var shadowWidthFactor = pixelRatio * 5 / 6;
			var width = options.bevelWidth * shadowWidthFactor;
			var borderWidth = options.borderWidth;
			var parsedBorderWidth = options.parsedBorderWidth;
			var shadowOffset, offset;
	
			if (!width) {
				return;
			}
	
			if (!this.opaque(options.borderColor)) {
				shadowOffset = {top: width, left: width, bottom: width, right: width};
			} else if (parsedBorderWidth) {
				shadowOffset = {
					top: width + parsedBorderWidth.top * pixelRatio,
					left: width + parsedBorderWidth.left * pixelRatio,
					bottom: width + parsedBorderWidth.bottom * pixelRatio,
					right: width + parsedBorderWidth.right * pixelRatio
				};
			} else {
				offset = width + (borderWidth > 0 ? borderWidth : 0) * pixelRatio / 2;
				shadowOffset = {top: offset, left: offset, bottom: offset, right: offset};
			}
	
			ctx.save();
	
			this.setPath(ctx, drawCallback);
			ctx.clip();
	
			// Make stencil
			ctx.translate(-OFFSET, 0);
			this.setPath(ctx, drawCallback);
			ctx.rect(0, 0, chart.width, chart.height);
	
			// Draw bevel shadow
			ctx.fillStyle = 'black';
			ctx.shadowOffsetX = OFFSET * pixelRatio - shadowOffset.right;
			ctx.shadowOffsetY = -shadowOffset.bottom;
			ctx.shadowBlur = width;
			ctx.shadowColor = options.bevelShadowColor;
			// Workaround for the issue on Windows version of FireFox
			// https://bugzilla.mozilla.org/show_bug.cgi?id=1333090
			// If the destination has transparency, the result will be different
			if (!(navigator && navigator.userAgent.match('Windows.+Firefox'))) {
				ctx.globalCompositeOperation = 'source-atop';
			}
			ctx.fill('evenodd');
	
			// Draw Bevel highlight
			ctx.shadowOffsetX = OFFSET * pixelRatio + shadowOffset.left;
			ctx.shadowOffsetY = shadowOffset.top;
			ctx.shadowColor = options.bevelHighlightColor;
			ctx.fill('evenodd');
	
			ctx.restore();
		},
	
		drawGlow: function(chart, options, drawCallback, isOuter) {
			var ctx = chart.ctx;
			var width = isOuter ? options.outerGlowWidth : options.innerGlowWidth;
			var borderWidth = options.borderWidth;
			var pixelRatio = chart.currentDevicePixelRatio;
	
			if (!width) {
				return;
			}
	
			ctx.save();
	
			// Clip inner or outer area
			this.setPath(ctx, drawCallback);
			if (isOuter) {
				ctx.rect(0, 0, chart.width, chart.height);
			}
			ctx.clip('evenodd');
	
			// Set path
			ctx.translate(-OFFSET, 0);
			this.setPath(ctx, drawCallback);
			if (!isOuter) {
				ctx.rect(0, 0, chart.width, chart.height);
			}
	
			// Draw glow
			ctx.lineWidth = borderWidth;
			ctx.strokeStyle = 'black';
			ctx.fillStyle = 'black';
			ctx.shadowOffsetX = OFFSET * pixelRatio;
			ctx.shadowBlur = width * pixelRatio;
			ctx.shadowColor = isOuter ? options.outerGlowColor : options.innerGlowColor;
			ctx.fill('evenodd');
			if (borderWidth) {
				ctx.stroke();
			}
	
			ctx.restore();
		},
	
		drawInnerGlow: function(chart, options, drawCallback) {
			this.drawGlow(chart, options, drawCallback);
		},
	
		drawOuterGlow: function(chart, options, drawCallback) {
			this.drawGlow(chart, options, drawCallback, true);
		},
	
		drawBackgroundOverlay: function(chart, options, drawCallback) {
			var ctx = chart.ctx;
			var color = options.backgroundOverlayColor;
	
			if (!color) {
				return;
			}
	
			ctx.save();
			this.setPath(ctx, drawCallback);
			ctx.fillStyle = color;
			ctx.globalCompositeOperation = options.backgroundOverlayMode;
			ctx.fill();
			ctx.restore();
		},
	
		opaque: function(color) {
			return helpers$1.color(color).alpha() > 0;
		},
	
		getHoverColor: function(color) {
			return color !== undefined ? helpers$1.getHoverColor(color) : color;
		},
	
		mergeStyle: function(target, source) {
			if (target === undefined || source === undefined) {
				return;
			}
			this.styleKeys.forEach(function(key) {
				target[key] = source[key];
			});
			return target;
		},
	
		setHoverStyle: function(target, source) {
			var keys = this.styleKeys;
			var hoverKeys = this.hoverStyleKeys;
			var i, ilen;
	
			if (target === undefined || source === undefined) {
				return;
			}
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				target[keys[i]] = source[hoverKeys[i]];
			}
			return target;
		},
	
		saveStyle: function(element) {
			var model = element._model;
			var previousStyle = element.$previousStyle;
	
			if (previousStyle) {
				this.mergeStyle(previousStyle, model);
			}
		},
	
		resolveStyle: function(controller, element, index, options) {
			var me = this;
			var chart = controller.chart;
			var dataset = chart.data.datasets[controller.index];
			var custom = element.custom || {};
			var keys = me.styleKeys;
			var hoverKeys = me.hoverStyleKeys;
			var values = {};
			var i, ilen, key, value;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: element._datasetIndex
			};
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = value = resolve([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
	
				key = hoverKeys[i];
				values[key] = resolve([
					custom[key],
					dataset[key],
					options[key],
					isColorOption(key) ? me.getHoverColor(value) : value
				], context, index);
			}
	
			return values;
		},
	
		resolveLineStyle: function(controller, element, options) {
			var chart = controller.chart;
			var dataset = chart.data.datasets[controller.index];
			var custom = element.custom || {};
			var keys = this.lineStyleKeys;
			var values = {};
			var i, ilen, key;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataset: dataset,
				datasetIndex: element._datasetIndex
			};
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([custom[key], dataset[key], options[key]], context);
			}
	
			return values;
		},
	
		resolvePointStyle: function(controller, element, index, options) {
			var me = this;
			var chart = controller.chart;
			var dataset = chart.data.datasets[controller.index];
			var custom = element.custom || {};
			var keys = me.styleKeys;
			var hoverKeys = me.hoverStyleKeys;
			var pointKeys = me.pointStyleKeys;
			var pointHoverKeys = me.pointHoverStyleKeys;
			var values = {};
			var i, ilen, key, value;
	
			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: element._datasetIndex
			};
	
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = value = resolve([
					custom[key],
					dataset[pointKeys[i]],
					dataset[key],
					options[key]
				], context, index);
	
				key = hoverKeys[i];
				values[key] = resolve([
					custom[key],
					dataset[pointHoverKeys[i]],
					options[key],
					isColorOption(key) ? me.getHoverColor(value) : value
				], context, index);
			}
	
			return values;
		}
	};
	
	var helpers$2 = Chart.helpers;
	
	/**
	 * Ported from Chart.js 2.7.3.
	 *
	 * Helper method to merge the opacity into a color
	 * For Chart.js 2.7.3 backward compatibility
	 */
	function mergeOpacity(colorString, opacity) {
		// opacity is not used in Chart.js 2.8 or later
		if (opacity === undefined) {
			return colorString;
		}
		var color = helpers$2.color(colorString);
		return color.alpha(opacity * color.alpha()).rgbaString();
	}
	
	var Tooltip = Chart.Tooltip;
	
	var StyleTooltip = Tooltip.extend({
	
		initialize: function() {
			var me = this;
	
			Tooltip.prototype.initialize.apply(me, arguments);
	
			styleHelpers.mergeStyle(me._model, me._options);
		},
	
		update: function() {
			var me = this;
	
			Tooltip.prototype.update.apply(me, arguments);
	
			styleHelpers.mergeStyle(me._model, me._options);
	
			return me;
		},
	
		drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
			var me = this;
			var args = arguments;
			var chart = me._chart;
			var options = helpers$2.extend({}, vm, {
				bevelHighlightColor: mergeOpacity(vm.bevelHighlightColor, opacity),
				bevelShadowColor: mergeOpacity(vm.bevelShadowColor, opacity),
				innerGlowColor: mergeOpacity(vm.innerGlowColor, opacity),
				outerGlowColor: mergeOpacity(vm.outerGlowColor, opacity)
			});
	
			var drawCallback = function() {
				Tooltip.prototype.drawBackground.apply(me, args);
			};
	
			styleHelpers.drawShadow(chart, vm, drawCallback);
	
			if (styleHelpers.opaque(vm.backgroundColor)) {
				styleHelpers.drawBackground(vm, drawCallback);
				styleHelpers.drawBevel(chart, options, drawCallback);
			}
	
			styleHelpers.drawInnerGlow(chart, options, drawCallback);
			styleHelpers.drawOuterGlow(chart, options, drawCallback);
	
			styleHelpers.drawBorder(vm, drawCallback);
		}
	});
	
	var Rectangle = Chart.elements.Rectangle;
	
	var StyleRectangle = Rectangle.extend({
	
		draw: function() {
			var me = this;
			var args = arguments;
			var chart = me._chart;
			var vm = me._view;
	
			var drawCallback = function() {
				Rectangle.prototype.draw.apply(me, args);
			};
			var setPathCallback = function() {
				me.setPath();
			};
	
			styleHelpers.drawShadow(chart, vm, drawCallback, true);
	
			if (styleHelpers.opaque(vm.backgroundColor)) {
				styleHelpers.drawBackground(vm, drawCallback);
				styleHelpers.drawBackgroundOverlay(chart, vm, setPathCallback);
				styleHelpers.drawBevel(chart, vm, setPathCallback);
			}
	
			styleHelpers.drawInnerGlow(chart, vm, setPathCallback);
			styleHelpers.drawOuterGlow(chart, vm, setPathCallback);
	
			styleHelpers.drawBorder(vm, drawCallback);
		},
	
		setPath: function() {
			var me = this;
			var ctx = me._chart.ctx;
			var vm = me._view;
			var x, y, width, height;
	
			if (vm.width !== undefined) {
				x = vm.x - vm.width / 2;
				width = vm.width;
				y = Math.min(vm.y, vm.base);
				height = Math.abs(vm.y - vm.base);
			} else {
				x = Math.min(vm.x, vm.base);
				width = Math.abs(vm.x - vm.base);
				y = vm.y - vm.height / 2;
				height = vm.height;
			}
	
			ctx.rect(x, y, width, height);
		}
	});
	
	var helpers$3 = Chart.helpers;
	
	var extend = helpers$3.extend;
	
	// Ported from Chart.js 2.8.0
	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}
	
	// Ported from Chart.js 2.8.0
	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};
	
		if (!edge) {
			return res;
		}
	
		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}
	
		res[edge] = true;
		return res;
	}
	
	// Ported from Chart.js 2.8.0. Modified for style bar.
	function parseBorderWidth(vm) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var maxW, maxH, t, r, b, l;
	
		if (vm.width !== undefined) {
			maxW = vm.width / 2;
			maxH = Math.abs(vm.y - vm.base) / 2;
		} else {
			maxW = Math.abs(vm.x - vm.base) / 2;
			maxH = vm.height / 2;
		}
	
		if (value !== null && Object.prototype.toString.call(value) === '[object Object]') {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}
	
		return {
			top: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
			right: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
			bottom: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
			left: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
		};
	}
	
	var BarController = Chart.controllers.bar;
	
	var StyleBarController = BarController.extend({
	
		dataElementType: StyleRectangle,
	
		updateElement: function(rectangle, index) {
			var me = this;
			var options = styleHelpers.resolveStyle(me, rectangle, index, me.chart.options.elements.rectangle);
			var model = {};
	
			Object.defineProperty(rectangle, '_model', {
				configurable: true,
				get: function() {
					return model;
				},
				set: function(value) {
					extend(model, value, options);
				}
			});
	
			BarController.prototype.updateElement.apply(me, arguments);
	
			delete rectangle._model;
			rectangle._model = extend(model, {
				parsedBorderWidth: parseBorderWidth(model)
			});
			rectangle._styleOptions = options;
		},
	
		setHoverStyle: function(element) {
			var me = this;
	
			BarController.prototype.setHoverStyle.apply(me, arguments);
	
			styleHelpers.saveStyle(element);
			styleHelpers.setHoverStyle(element._model, element._styleOptions);
		},
	
		removeHoverStyle: function(element) {
			var me = this;
	
			// For Chart.js 2.7.2 backward compatibility
			if (!element.$previousStyle) {
				styleHelpers.mergeStyle(element._model, element._styleOptions);
			}
	
			BarController.prototype.removeHoverStyle.apply(me, arguments);
		}
	});
	
	var helpers$4 = Chart.helpers;
	
	// For Chart.js 2.7.3 backward compatibility
	var isPointInArea = helpers$4.canvas._isPointInArea || function(point, area) {
		var epsilon = 1e-6;
	
		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	};
	
	var Point = Chart.elements.Point;
	
	var StylePoint = Point.extend({
	
		draw: function(chartArea) {
			var me = this;
			var args = arguments;
			var chart = me._chart;
			var vm = me._view;
	
			var drawCallback = function() {
				Point.prototype.draw.apply(me, args);
			};
	
			if (vm.skip || chartArea !== undefined && !isPointInArea(vm, chartArea)) {
				return;
			}
	
			styleHelpers.drawShadow(chart, vm, drawCallback, true);
	
			if (styleHelpers.opaque(vm.backgroundColor)) {
				styleHelpers.drawBackground(vm, drawCallback);
				styleHelpers.drawBackgroundOverlay(chart, vm, drawCallback);
				styleHelpers.drawBevel(chart, vm, drawCallback);
			}
	
			styleHelpers.drawInnerGlow(chart, vm, drawCallback);
			styleHelpers.drawOuterGlow(chart, vm, drawCallback);
	
			styleHelpers.drawBorder(vm, drawCallback);
		}
	});
	
	var helpers$5 = Chart.helpers;
	
	var extend$1 = helpers$5.extend;
	
	var BubbleController = Chart.controllers.bubble;
	
	var StyleBubbleController = BubbleController.extend({
	
		dataElementType: StylePoint,
	
		updateElement: function(point, index) {
			var me = this;
			var options = styleHelpers.resolveStyle(me, point, index, me.chart.options.elements.point);
			var model = {};
	
			Object.defineProperty(point, '_model', {
				configurable: true,
				get: function() {
					return model;
				},
				set: function(value) {
					extend$1(model, value, options);
				}
			});
	
			BubbleController.prototype.updateElement.apply(me, arguments);
	
			delete point._model;
			point._model = model;
			point._styleOptions = options;
		},
	
		/**
		 * @protected
		 */
		setHoverStyle: function(element) {
			var me = this;
	
			BubbleController.prototype.setHoverStyle.apply(me, arguments);
	
			styleHelpers.saveStyle(element);
			styleHelpers.setHoverStyle(element._model, element._styleOptions);
		},
	
		/**
		 * @protected
		 */
		removeHoverStyle: function(element) {
			var me = this;
	
			// For Chart.js 2.7.2 backward compatibility
			if (!element.$previousStyle) {
				styleHelpers.mergeStyle(element._model, element._styleOptions);
			}
	
			BubbleController.prototype.removeHoverStyle.apply(me, arguments);
		}
	});
	
	var helpers$6 = Chart.helpers;
	
	var Arc = Chart.elements.Arc;
	
	var StyleArc = Arc.extend({
	
		draw: function() {
			var me = this;
			var args = arguments;
			var chart = me._chart;
			var vm = me._view;
	
			var drawCallback = function() {
				Arc.prototype.draw.apply(me, args);
			};
	
			styleHelpers.drawShadow(chart, vm, drawCallback, true);
	
			if (styleHelpers.opaque(vm.backgroundColor)) {
				styleHelpers.drawBackground(vm, drawCallback);
				styleHelpers.drawBackgroundOverlay(chart, vm, drawCallback);
				styleHelpers.drawBevel(chart, vm.borderAlign === 'inner' ? helpers$6.extend({}, vm, {
					borderWidth: vm.borderWidth * 2
				}) : vm, drawCallback);
			}
	
			styleHelpers.drawInnerGlow(chart, vm, drawCallback);
			styleHelpers.drawOuterGlow(chart, vm, drawCallback);
	
			styleHelpers.drawBorder(vm, drawCallback);
		}
	});
	
	var defaults = Chart.defaults;
	var helpers$7 = Chart.helpers;
	
	var extend$2 = helpers$7.extend;
	var resolve$1 = optionsHelpers$1.resolve;
	
	// Ported from Chart.js 2.8.0. Modified for style doughnut.
	defaults.doughnut.legend.labels.generateLabels = defaults.pie.legend.labels.generateLabels = function(chart) {
		var data = chart.data;
		if (data.labels.length && data.datasets.length) {
			return data.labels.map(function(label, i) {
				var meta = chart.getDatasetMeta(0);
				var ds = data.datasets[0];
				var arc = meta.data[i] || {};
				var custom = arc.custom || {};
				var arcOpts = chart.options.elements.arc;
				var fill = resolve$1([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
				var stroke = resolve$1([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
				var bw = resolve$1([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);
	
				return extend$2({
					text: label,
					fillStyle: fill,
					strokeStyle: stroke,
					lineWidth: bw,
					hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
					// Extra data used for toggling the correct item
					index: i
				}, styleHelpers.resolveStyle(meta.controller, arc, i, arcOpts));
			});
		}
		return [];
	};
	
	var DoughnutController = Chart.controllers.doughnut;
	
	var StyleDoughnutController = DoughnutController.extend({
	
		dataElementType: StyleArc,
	
		updateElement: function(arc, index) {
			var me = this;
			var options = styleHelpers.resolveStyle(me, arc, index, me.chart.options.elements.arc);
			var model = {};
	
			Object.defineProperty(arc, '_model', {
				configurable: true,
				get: function() {
					return model;
				},
				set: function(value) {
					extend$2(model, value, options);
				}
			});
	
			DoughnutController.prototype.updateElement.apply(me, arguments);
	
			delete arc._model;
			arc._model = model;
			arc._styleOptions = options;
		},
	
		setHoverStyle: function(element) {
			var me = this;
	
			DoughnutController.prototype.setHoverStyle.apply(me, arguments);
	
			styleHelpers.saveStyle(element);
			styleHelpers.setHoverStyle(element._model, element._styleOptions);
		},
	
		removeHoverStyle: function(element) {
			var me = this;
	
			// For Chart.js 2.7.2 backward compatibility
			if (!element.$previousStyle) {
				styleHelpers.mergeStyle(element._model, element._styleOptions);
			}
	
			DoughnutController.prototype.removeHoverStyle.apply(me, arguments);
		}
	});
	
	var StyleHorizontalBarController = StyleBarController.extend({
		/**
		 * @private
		 */
		_getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * @private
		 */
		_getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		},
	
		/**
		 * For Chart.js 2.7.2 backward compatibility
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},
	
		/**
		 * For Chart.js 2.7.2 backward compatibility
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
	
	var Line = Chart.elements.Line;
	
	var StyleLine = Line.extend({
	
		draw: function() {
			var me = this;
			var args = arguments;
			var chart = me._chart;
			var vm = me._view;
	
			var drawCallback = function() {
				Line.prototype.draw.apply(me, args);
			};
	
			styleHelpers.drawShadow(chart, vm, drawCallback);
	
			// For outer glow
			styleHelpers.drawShadow(chart, {
				shadowOffsetX: 0,
				shadowOffsetY: 0,
				shadowBlur: vm.outerGlowWidth,
				shadowColor: vm.outerGlowColor
			}, drawCallback);
	
			styleHelpers.drawBorder(vm, drawCallback);
		}
	});
	
	var helpers$8 = Chart.helpers;
	
	var extend$3 = helpers$8.extend;
	
	var LineController = Chart.controllers.line;
	
	var StyleLineController = LineController.extend({
	
		datasetElementType: StyleLine,
	
		dataElementType: StylePoint,
	
		update: function() {
			var me = this;
			var line = me.getMeta().dataset;
			var options = styleHelpers.resolveLineStyle(me, line, me.chart.options.elements.line);
			var model = {};
	
			Object.defineProperty(line, '_model', {
				configurable: true,
				get: function() {
					return model;
				},
				set: function(value) {
					extend$3(model, value, options);
				}
			});
	
			LineController.prototype.update.apply(me, arguments);
	
			delete line._model;
			line._model = model;
			line._styleOptions = options;
		},
	
		updateElement: function(point, index) {
			var me = this;
			var options = styleHelpers.resolvePointStyle(me, point, index, me.chart.options.elements.point);
	
			LineController.prototype.updateElement.apply(me, arguments);
	
			extend$3(point._model, options);
			point._styleOptions = options;
		},
	
		setHoverStyle: function(element) {
			// Point
			var me = this;
	
			LineController.prototype.setHoverStyle.apply(me, arguments);
	
			styleHelpers.saveStyle(element);
			styleHelpers.setHoverStyle(element._model, element._styleOptions);
		},
	
		removeHoverStyle: function(element) {
			var me = this;
	
			// For Chart.js 2.7.2 backward compatibility
			if (!element.$previousStyle) {
				styleHelpers.mergeStyle(element._model, element._styleOptions);
			}
	
			LineController.prototype.removeHoverStyle.apply(me, arguments);
		}
	});
	
	var helpers$9 = Chart.helpers;
	
	var extend$4 = helpers$9.extend;
	var resolve$2 = optionsHelpers$1.resolve;
	
	// Ported from Chart.js 2.8.0. Modified for style polarArea.
	Chart.defaults.polarArea.legend.labels.generateLabels = function(chart) {
		var data = chart.data;
		if (data.labels.length && data.datasets.length) {
			return data.labels.map(function(label, i) {
				var meta = chart.getDatasetMeta(0);
				var ds = data.datasets[0];
				var arc = meta.data[i] || {};
				var custom = arc.custom || {};
				var arcOpts = chart.options.elements.arc;
				var fill = resolve$2([custom.backgroundColor, ds.backgroundColor, arcOpts.backgroundColor], undefined, i);
				var stroke = resolve$2([custom.borderColor, ds.borderColor, arcOpts.borderColor], undefined, i);
				var bw = resolve$2([custom.borderWidth, ds.borderWidth, arcOpts.borderWidth], undefined, i);
	
				return extend$4({
					text: label,
					fillStyle: fill,
					strokeStyle: stroke,
					lineWidth: bw,
					hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
					// Extra data used for toggling the correct item
					index: i
				}, styleHelpers.resolveStyle(meta.controller, arc, i, arcOpts));
			});
		}
		return [];
	};
	
	var PolarAreaController = Chart.controllers.polarArea;
	
	var StylePolarAreaController = PolarAreaController.extend({
	
		dataElementType: StyleArc,
	
		updateElement: function(arc, index) {
			var me = this;
			var options = styleHelpers.resolveStyle(me, arc, index, me.chart.options.elements.arc);
			var model = {};
	
			Object.defineProperty(arc, '_model', {
				configurable: true,
				get: function() {
					return model;
				},
				set: function(value) {
					extend$4(model, value, options);
				}
			});
	
			PolarAreaController.prototype.updateElement.apply(me, arguments);
	
			delete arc._model;
			arc._model = model;
			arc._styleOptions = options;
		},
	
		setHoverStyle: function(element) {
			var me = this;
	
			PolarAreaController.prototype.setHoverStyle.apply(me, arguments);
	
			styleHelpers.saveStyle(element);
			styleHelpers.setHoverStyle(element._model, element._styleOptions);
		},
	
		removeHoverStyle: function(element) {
			var me = this;
	
			// For Chart.js 2.7.2 backward compatibility
			if (!element.$previousStyle) {
				styleHelpers.mergeStyle(element._model, element._styleOptions);
			}
	
			PolarAreaController.prototype.removeHoverStyle.apply(me, arguments);
		}
	});
	
	var helpers$a = Chart.helpers;
	
	var extend$5 = helpers$a.extend;
	
	var RadarController = Chart.controllers.radar;
	
	var StyleRadarController = RadarController.extend({
	
		datasetElementType: StyleLine,
	
		dataElementType: StylePoint,
	
		update: function() {
			var me = this;
			var line = me.getMeta().dataset;
			var options = styleHelpers.resolveLineStyle(me, line, me.chart.options.elements.line);
			var model = {};
	
			Object.defineProperty(line, '_model', {
				configurable: true,
				get: function() {
					return model;
				},
				set: function(value) {
					extend$5(model, value, options);
				}
			});
	
			RadarController.prototype.update.apply(me, arguments);
	
			delete line._model;
			line._model = model;
			line._styleOptions = options;
		},
	
		updateElement: function(point, index) {
			var me = this;
			var options = styleHelpers.resolvePointStyle(me, point, index, me.chart.options.elements.point);
	
			RadarController.prototype.updateElement.apply(me, arguments);
	
			extend$5(point._model, options);
			point._styleOptions = options;
		},
	
		setHoverStyle: function(element) {
			// Point
			var me = this;
	
			RadarController.prototype.setHoverStyle.apply(me, arguments);
	
			styleHelpers.saveStyle(element);
			styleHelpers.setHoverStyle(element._model, element._styleOptions);
		},
	
		removeHoverStyle: function(element) {
			var me = this;
	
			// For Chart.js 2.7.2 backward compatibility
			if (!element.$previousStyle) {
				styleHelpers.mergeStyle(element._model, element._styleOptions);
			}
	
			RadarController.prototype.removeHoverStyle.apply(me, arguments);
		}
	});
	
	var defaults$1 = Chart.defaults;
	var helpers$b = Chart.helpers;
	
	// For Chart.js 2.7.1 backward compatibility
	var layouts = Chart.layouts || Chart.layoutService;
	
	// For Chart.js 2.6.0 backward compatibility
	var valueOrDefault = helpers$b.valueOrDefault || helpers$b.getValueOrDefault;
	
	// For Chart.js 2.6.0 backward compatibility
	var valueAtIndexOrDefault = helpers$b.valueAtIndexOrDefault || helpers$b.getValueAtIndexOrDefault;
	
	// For Chart.js 2.6.0 backward compatibility
	var mergeIf = helpers$b.mergeIf || function(target, source) {
		return helpers$b.configMerge.call(this, source, target);
	};
	
	var extend$6 = helpers$b.extend;
	
	// Ported from Chart.js 2.8.0. Modified for style legend.
	// Generates labels shown in the legend
	defaults$1.global.legend.labels.generateLabels = function(chart) {
		var data = chart.data;
		var options = chart.options.legend || {};
		var usePointStyle = options.labels && options.labels.usePointStyle;
	
		return helpers$b.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
			var meta = chart.getDatasetMeta(i);
			var controller = meta.controller;
			var elementOpts = chart.options.elements;
			var element, styleOptions;
	
			if (usePointStyle) {
				element = meta.data[0] || {};
				styleOptions = styleHelpers.resolvePointStyle(controller, element, i, elementOpts.point);
			} else if (meta.dataset) {
				element = meta.dataset;
				styleOptions = styleHelpers.resolveLineStyle(controller, element, elementOpts.line);
			} else {
				element = meta.data[0] || {};
				styleOptions = styleHelpers.resolveStyle(controller, element, i, meta.bar ? elementOpts.rectangle : elementOpts.point);
			}
	
			return extend$6({
				text: dataset.label,
				fillStyle: valueAtIndexOrDefault(dataset.backgroundColor, 0),
				hidden: !chart.isDatasetVisible(i),
				lineCap: dataset.borderCapStyle,
				lineDash: dataset.borderDash,
				lineDashOffset: dataset.borderDashOffset,
				lineJoin: dataset.borderJoinStyle,
				lineWidth: dataset.borderWidth,
				strokeStyle: dataset.borderColor,
				pointStyle: dataset.pointStyle,
	
				// Below is extra data used for toggling the datasets
				datasetIndex: i
			}, styleOptions);
		}, this) : [];
	};
	
	function drawLegendBox(chart, options, drawCallback) {
		var ctx = chart.ctx;
	
		styleHelpers.drawShadow(chart, options, drawCallback, true);
	
		if (styleHelpers.opaque(ctx.fillStyle)) {
			ctx.save();
	
			ctx.strokeStyle = 'rgba(0, 0, 0, 0)';
			drawCallback();
	
			styleHelpers.drawBackgroundOverlay(chart, options, drawCallback);
			styleHelpers.drawBevel(chart, options, drawCallback);
	
			ctx.restore();
		}
	
		styleHelpers.drawInnerGlow(chart, options, drawCallback);
		styleHelpers.drawOuterGlow(chart, options, drawCallback);
	
		ctx.fillStyle = 'rgba(0, 0, 0, 0)';
		drawCallback();
	
		ctx.restore();
	}
	
	var StyleLegend = Chart.Legend.extend({
	
		draw: function() {
			var me = this;
			var chart = me.chart;
			var globalDefaults = defaults$1.global;
			var each = helpers$b.each;
			var drawPoint = helpers$b.canvas.drawPoint;
			var ctx = me.ctx;
			var options;
	
			helpers$b.each = function(loopable, fn) {
				each(loopable, function(legendItem) {
					var keys = Object.keys(legendItem);
					var i, ilen;
	
					options = {};
					for (i = 0, ilen = keys.length; i < ilen; i++) {
						options[keys[i]] = legendItem[keys[i]];
					}
					options.borderColor = valueOrDefault(legendItem.strokeStyle, globalDefaults.defaultColor);
					options.borderWidth = valueOrDefault(legendItem.lineWidth, globalDefaults.elements.line.borderWidth);
	
					fn.apply(null, arguments);
				});
			};
	
			helpers$b.canvas.drawPoint = function() {
				var args = arguments;
				var drawCallback = function() {
					drawPoint.apply(null, args);
				};
	
				drawLegendBox(chart, options, drawCallback);
			};
	
			ctx.strokeRect = function() {
				// noop
			};
	
			ctx.fillRect = function(x, y, width, height) {
				var drawCallback = function() {
					ctx.beginPath();
					ctx.rect(x, y, width, height);
					ctx.fill();
					if (options.borderWidth !== 0) {
						ctx.stroke();
					}
				};
	
				drawLegendBox(chart, options, drawCallback);
			};
	
			Chart.Legend.prototype.draw.apply(me, arguments);
	
			helpers$b.each = each;
			helpers$b.canvas.drawPoint = drawPoint;
			delete ctx.fillRect;
			delete ctx.strokeRect;
		}
	});
	
	// Ported from Chart.js 2.8.0. Modified for style legend.
	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new StyleLegend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});
	
		layouts.configure(chart, legend, legendOpts);
		layouts.addBox(chart, legend);
		chart.legend = legend;
	}
	
	var StyleLegendPlugin = {
		id: 'legend',
	
		_element: StyleLegend,
	
		// Ported from Chart.js 2.8.0.
		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;
	
			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},
	
		// Ported from Chart.js 2.8.0.
		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;
	
			if (legendOpts) {
				mergeIf(legendOpts, defaults$1.global.legend);
	
				if (legend) {
					layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},
	
		// Ported from Chart.js 2.8.0.
		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
	
	var helpers$c = Chart.helpers;
	
	// For Chart.js 2.7.1 backward compatibility
	var layouts$1 = Chart.layouts || Chart.layoutService;
	
	var plugins = Chart.plugins;
	
	var styleControllers = {
		bar: StyleBarController,
		bubble: StyleBubbleController,
		doughnut: StyleDoughnutController,
		horizontalBar: StyleHorizontalBarController,
		line: StyleLineController,
		polarArea: StylePolarAreaController,
		pie: StyleDoughnutController,
		radar: StyleRadarController,
		scatter: StyleLineController
	};
	
	// Ported from Chart.js 2.8.0. Modified for style controllers.
	function buildOrUpdateControllers() {
		var me = this;
		var newControllers = [];
	
		helpers$c.each(me.data.datasets, function(dataset, datasetIndex) {
			var meta = me.getDatasetMeta(datasetIndex);
			var type = dataset.type || me.config.type;
	
			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(datasetIndex);
				meta = me.getDatasetMeta(datasetIndex);
			}
			meta.type = type;
	
			if (meta.controller) {
				meta.controller.updateIndex(datasetIndex);
				meta.controller.linkScales();
			} else {
				var ControllerClass = styleControllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}
	
				meta.controller = new ControllerClass(me, datasetIndex);
				newControllers.push(meta.controller);
			}
		}, me);
	
		return newControllers;
	}
	
	// Ported from Chart.js 2.8.0. Modified for style tooltip.
	function initToolTip() {
		var me = this;
		me.tooltip = new StyleTooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	}
	
	var descriptors = plugins.descriptors;
	
	plugins.descriptors = function(chart) {
		var style = chart._style;
	
		// Replace legend plugin with style legend plugin
		if (style) {
			// chart._plugins for Chart.js 2.7.1 backward compatibility
			var cache = chart.$plugins || chart._plugins || (chart.$plugins = chart._plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}
	
			var p = this._plugins;
			var result;
	
			this._plugins = p.map(function(plugin) {
				if (plugin.id === 'legend') {
					return StyleLegendPlugin;
				}
				return plugin;
			});
		}
	
		result = descriptors.apply(this, arguments);
	
		if (style) {
			this._plugins = p;
		}
	
		return result;
	};
	
	var StylePlugin = {
		id: 'style',
	
		beforeInit: function(chart) {
			chart._style = {};
	
			chart.buildOrUpdateControllers = buildOrUpdateControllers;
			chart.initToolTip = initToolTip;
	
			// Remove the existing legend if exists
			if (chart.legend) {
				layouts$1.removeBox(chart, chart.legend);
				delete chart.legend;
			}
	
			// Invalidate plugin cache and create new one
			delete chart.$plugins;
			// For Chart.js 2.7.1 backward compatibility
			delete chart._plugins;
			plugins.descriptors(chart);
		}
	};
	
	Chart.plugins.register(StylePlugin);
	
	return StylePlugin;
	
	}));


/***/ }),
/* 4316 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = applyDecorators;
	var defineProperty = Object.defineProperty;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	function applyDecorators(Class, props) {
	  var prototype = Class.prototype;
	
	  for (var key in props) {
	    var decorators = props[key];
	
	    for (var i = 0, l = decorators.length; i < l; i++) {
	      var decorator = decorators[i];
	
	      defineProperty(prototype, key, decorator(prototype, key, getOwnPropertyDescriptor(prototype, key)));
	    }
	  }
	
	  return Class;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 4317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = autobind;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _privateUtils = __webpack_require__(161);
	
	var defineProperty = Object.defineProperty;
	var getPrototypeOf = Object.getPrototypeOf;
	
	function bind(fn, context) {
	  if (fn.bind) {
	    return fn.bind(context);
	  } else {
	    return function __autobind__() {
	      return fn.apply(context, arguments);
	    };
	  }
	}
	
	var mapStore = undefined;
	
	function getBoundSuper(obj, fn) {
	  if (typeof WeakMap === 'undefined') {
	    throw new Error('Using @autobind on ' + fn.name + '() requires WeakMap support due to its use of super.' + fn.name + '()\n      See https://github.com/jayphelps/core-decorators.js/issues/20');
	  }
	
	  if (!mapStore) {
	    mapStore = new WeakMap();
	  }
	
	  if (mapStore.has(obj) === false) {
	    mapStore.set(obj, new WeakMap());
	  }
	
	  var superStore = mapStore.get(obj);
	
	  if (superStore.has(fn) === false) {
	    superStore.set(fn, bind(fn, obj));
	  }
	
	  return superStore.get(fn);
	}
	
	function autobindClass(klass) {
	  var descs = (0, _privateUtils.getOwnPropertyDescriptors)(klass.prototype);
	  var keys = (0, _privateUtils.getOwnKeys)(descs);
	
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    var desc = descs[key];
	
	    if (typeof desc.value !== 'function' || key === 'constructor') {
	      continue;
	    }
	
	    defineProperty(klass.prototype, key, autobindMethod(klass.prototype, key, desc));
	  }
	}
	
	function autobindMethod(target, key, _ref) {
	  var fn = _ref.value;
	  var configurable = _ref.configurable;
	  var enumerable = _ref.enumerable;
	
	  if (typeof fn !== 'function') {
	    throw new SyntaxError('@autobind can only be used on functions, not: ' + fn);
	  }
	
	  var constructor = target.constructor;
	
	  return {
	    configurable: configurable,
	    enumerable: enumerable,
	
	    get: function get() {
	      // Class.prototype.key lookup
	      // Someone accesses the property directly on the prototype on which it is
	      // actually defined on, i.e. Class.prototype.hasOwnProperty(key)
	      if (this === target) {
	        return fn;
	      }
	
	      // Class.prototype.key lookup
	      // Someone accesses the property directly on a prototype but it was found
	      // up the chain, not defined directly on it
	      // i.e. Class.prototype.hasOwnProperty(key) == false && key in Class.prototype
	      if (this.constructor !== constructor && getPrototypeOf(this).constructor === constructor) {
	        return fn;
	      }
	
	      // Autobound method calling super.sameMethod() which is also autobound and so on.
	      if (this.constructor !== constructor && key in this.constructor.prototype) {
	        return getBoundSuper(this, fn);
	      }
	
	      var boundFn = bind(fn, this);
	
	      defineProperty(this, key, {
	        configurable: true,
	        writable: true,
	        // NOT enumerable when it's a bound method
	        enumerable: false,
	        value: boundFn
	      });
	
	      return boundFn;
	    },
	    set: (0, _privateUtils.createDefaultSetter)(key)
	  };
	}
	
	function handle(args) {
	  if (args.length === 1) {
	    return autobindClass.apply(undefined, _toConsumableArray(args));
	  } else {
	    return autobindMethod.apply(undefined, _toConsumableArray(args));
	  }
	}
	
	function autobind() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  if (args.length === 0) {
	    return function () {
	      return handle(arguments);
	    };
	  } else {
	    return handle(args);
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = debounce;
	
	var _privateUtils = __webpack_require__(161);
	
	var DEFAULT_TIMEOUT = 300;
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var _ref2$0 = _ref2[0];
	  var wait = _ref2$0 === undefined ? DEFAULT_TIMEOUT : _ref2$0;
	  var _ref2$1 = _ref2[1];
	  var immediate = _ref2$1 === undefined ? false : _ref2$1;
	
	  var callback = descriptor.value;
	
	  if (typeof callback !== 'function') {
	    throw new SyntaxError('Only functions can be debounced');
	  }
	
	  return _extends({}, descriptor, {
	    value: function value() {
	      var _this = this;
	
	      var _metaFor = (0, _privateUtils.metaFor)(this);
	
	      var debounceTimeoutIds = _metaFor.debounceTimeoutIds;
	
	      var timeout = debounceTimeoutIds[key];
	      var callNow = immediate && !timeout;
	      var args = arguments;
	
	      clearTimeout(timeout);
	
	      debounceTimeoutIds[key] = setTimeout(function () {
	        delete debounceTimeoutIds[key];
	        if (!immediate) {
	          callback.apply(_this, args);
	        }
	      }, wait);
	
	      if (callNow) {
	        callback.apply(this, args);
	      }
	    }
	  });
	}
	
	function debounce() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = decorate;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var _privateUtils = __webpack_require__(161);
	
	var defineProperty = Object.defineProperty;
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _toArray(_ref);
	
	  var decorator = _ref2[0];
	
	  var args = _ref2.slice(1);
	
	  var configurable = descriptor.configurable;
	  var enumerable = descriptor.enumerable;
	  var writable = descriptor.writable;
	
	  var originalGet = descriptor.get;
	  var originalSet = descriptor.set;
	  var originalValue = descriptor.value;
	  var isGetter = !!originalGet;
	
	  return {
	    configurable: configurable,
	    enumerable: enumerable,
	    get: function get() {
	      var fn = isGetter ? originalGet.call(this) : originalValue;
	      var value = decorator.call.apply(decorator, [this, fn].concat(_toConsumableArray(args)));
	
	      if (isGetter) {
	        return value;
	      } else {
	        var desc = {
	          configurable: configurable,
	          enumerable: enumerable
	        };
	
	        desc.value = value;
	        desc.writable = writable;
	
	        defineProperty(this, key, desc);
	
	        return value;
	      }
	    },
	    set: isGetter ? originalSet : (0, _privateUtils.createDefaultSetter)()
	  };
	}
	
	function decorate() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = deprecate;
	
	var _privateUtils = __webpack_require__(161);
	
	var DEFAULT_MSG = 'This function will be removed in future versions.';
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var _ref2$0 = _ref2[0];
	  var msg = _ref2$0 === undefined ? DEFAULT_MSG : _ref2$0;
	  var _ref2$1 = _ref2[1];
	  var options = _ref2$1 === undefined ? {} : _ref2$1;
	
	  if (typeof descriptor.value !== 'function') {
	    throw new SyntaxError('Only functions can be marked as deprecated');
	  }
	
	  var methodSignature = target.constructor.name + '#' + key;
	
	  if (options.url) {
	    msg += '\n\n    See ' + options.url + ' for more details.\n\n';
	  }
	
	  return _extends({}, descriptor, {
	    value: function deprecationWrapper() {
	      console.warn('DEPRECATION ' + methodSignature + ': ' + msg);
	      return descriptor.value.apply(this, arguments);
	    }
	  });
	}
	
	function deprecate() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = enumerable;
	
	var _privateUtils = __webpack_require__(161);
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.enumerable = true;
	  return descriptor;
	}
	
	function enumerable() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = extendDescriptor;
	
	var _privateUtils = __webpack_require__(161);
	
	var getPrototypeOf = Object.getPrototypeOf;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	function handleDescriptor(target, key, descriptor) {
	  var superKlass = getPrototypeOf(target);
	  var superDesc = getOwnPropertyDescriptor(superKlass, key);
	
	  return _extends({}, superDesc, {
	    value: descriptor.value,
	    initializer: descriptor.initializer,
	    get: descriptor.get || superDesc.get,
	    set: descriptor.set || superDesc.set
	  });
	}
	
	function extendDescriptor() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = memoize;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _privateUtils = __webpack_require__(161);
	
	function toObject(cache, value) {
	  if (value === Object(value)) {
	    return value;
	  }
	  return cache[value] || (cache[value] = {});
	}
	
	function applyAndCache(context, fn, args, cache, signature) {
	  var ret = fn.apply(context, args);
	  cache[signature] = ret;
	  return ret;
	}
	
	function metaForDescriptor(descriptor) {
	  var fn = undefined,
	      wrapKey = undefined;
	
	  // This is ugly code, but way faster than other
	  // ways I tried that *looked* pretty
	
	  if (descriptor.value) {
	    fn = descriptor.value;
	    wrapKey = 'value';
	  } else if (descriptor.get) {
	    fn = descriptor.get;
	    wrapKey = 'get';
	  } else if (descriptor.set) {
	    fn = descriptor.set;
	    wrapKey = 'set';
	  }
	
	  return { fn: fn, wrapKey: wrapKey };
	}
	
	function handleDescriptor(target, key, descriptor) {
	  console.warn('DEPRECATION: @memoize is deprecated and will be removed shortly. Use @decorate with lodash\'s memoize helper.\n\n  https://github.com/jayphelps/core-decorators.js#decorate');
	
	  var _metaForDescriptor = metaForDescriptor(descriptor);
	
	  var fn = _metaForDescriptor.fn;
	  var wrapKey = _metaForDescriptor.wrapKey;
	
	  var argumentCache = new WeakMap();
	  var signatureCache = Object.create(null);
	  var primativeRefCache = Object.create(null);
	  var argumentIdCounter = 0;
	
	  return _extends({}, descriptor, _defineProperty({}, wrapKey, function memoizeWrapper() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var signature = '0';
	
	    for (var i = 0, l = args.length; i < l; i++) {
	      var arg = args[i];
	      var argRef = toObject(primativeRefCache, arg);
	      var argKey = argumentCache.get(argRef);
	
	      if (argKey === undefined) {
	        argKey = ++argumentIdCounter;
	        argumentCache.set(argRef, argKey);
	      }
	
	      signature += argKey;
	    }
	
	    return signatureCache[signature] || applyAndCache(this, fn, arguments, signatureCache, signature);
	  }));
	}
	
	function memoize() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = mixin;
	
	var _privateUtils = __webpack_require__(161);
	
	var defineProperty = Object.defineProperty;
	var getPrototypeOf = Object.getPrototypeOf;
	
	function buggySymbol(symbol) {
	  return Object.prototype.toString.call(symbol) === '[object Symbol]' && typeof symbol === 'object';
	}
	
	function hasProperty(prop, obj) {
	  // We have to traverse manually prototypes' chain for polyfilled ES6 Symbols
	  // like "in" operator does.
	  // I.e.: Babel 5 Symbol polyfill stores every created symbol in Object.prototype.
	  // That's why we cannot use construction like "prop in obj" to check, if needed
	  // prop actually exists in given object/prototypes' chain.
	  if (buggySymbol(prop)) {
	    do {
	      if (obj === Object.prototype) {
	        // Polyfill assigns undefined as value for stored symbol key.
	        // We can assume in this special case if there is nothing assigned it doesn't exist.
	        return typeof obj[prop] !== 'undefined';
	      }
	      if (obj.hasOwnProperty(prop)) {
	        return true;
	      }
	    } while (obj = getPrototypeOf(obj));
	    return false;
	  } else {
	    return prop in obj;
	  }
	}
	
	function handleClass(target, mixins) {
	  if (!mixins.length) {
	    throw new SyntaxError('@mixin() class ' + target.name + ' requires at least one mixin as an argument');
	  }
	
	  for (var i = 0, l = mixins.length; i < l; i++) {
	    var descs = (0, _privateUtils.getOwnPropertyDescriptors)(mixins[i]);
	    var keys = (0, _privateUtils.getOwnKeys)(descs);
	
	    for (var j = 0, k = keys.length; j < k; j++) {
	      var key = keys[j];
	
	      if (!hasProperty(key, target.prototype)) {
	        defineProperty(target.prototype, key, descs[key]);
	      }
	    }
	  }
	}
	
	function mixin() {
	  for (var _len = arguments.length, mixins = Array(_len), _key = 0; _key < _len; _key++) {
	    mixins[_key] = arguments[_key];
	  }
	
	  if (typeof mixins[0] === 'function') {
	    return handleClass(mixins[0], []);
	  } else {
	    return function (target) {
	      return handleClass(target, mixins);
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = nonconfigurable;
	
	var _privateUtils = __webpack_require__(161);
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.configurable = false;
	  return descriptor;
	}
	
	function nonconfigurable() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = nonenumerable;
	
	var _privateUtils = __webpack_require__(161);
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.enumerable = false;
	  return descriptor;
	}
	
	function nonenumerable() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = override;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _privateUtils = __webpack_require__(161);
	
	var GENERIC_FUNCTION_ERROR = '{child} does not properly override {parent}';
	var FUNCTION_REGEXP = /^function ([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?(\([^\)]*\))[\s\S]+$/;
	
	var SyntaxErrorReporter = (function () {
	  _createClass(SyntaxErrorReporter, [{
	    key: '_getTopic',
	    value: function _getTopic(descriptor) {
	      if (descriptor === undefined) {
	        return null;
	      }
	
	      if ('value' in descriptor) {
	        return descriptor.value;
	      }
	
	      if ('get' in descriptor) {
	        return descriptor.get;
	      }
	
	      if ('set' in descriptor) {
	        return descriptor.set;
	      }
	    }
	  }, {
	    key: '_extractTopicSignature',
	    value: function _extractTopicSignature(topic) {
	      switch (typeof topic) {
	        case 'function':
	          return this._extractFunctionSignature(topic);
	        default:
	          return this.key;
	      }
	    }
	  }, {
	    key: '_extractFunctionSignature',
	    value: function _extractFunctionSignature(fn) {
	      var _this = this;
	
	      return fn.toString().replace(FUNCTION_REGEXP, function (match, name, params) {
	        if (name === undefined) name = _this.key;
	        return name + params;
	      });
	    }
	  }, {
	    key: 'key',
	    get: function get() {
	      return this.childDescriptor.key;
	    }
	  }, {
	    key: 'parentNotation',
	    get: function get() {
	      return this.parentKlass.constructor.name + '#' + this.parentPropertySignature;
	    }
	  }, {
	    key: 'childNotation',
	    get: function get() {
	      return this.childKlass.constructor.name + '#' + this.childPropertySignature;
	    }
	  }, {
	    key: 'parentTopic',
	    get: function get() {
	      return this._getTopic(this.parentDescriptor);
	    }
	  }, {
	    key: 'childTopic',
	    get: function get() {
	      return this._getTopic(this.childDescriptor);
	    }
	  }, {
	    key: 'parentPropertySignature',
	    get: function get() {
	      return this._extractTopicSignature(this.parentTopic);
	    }
	  }, {
	    key: 'childPropertySignature',
	    get: function get() {
	      return this._extractTopicSignature(this.childTopic);
	    }
	  }]);
	
	  function SyntaxErrorReporter(parentKlass, childKlass, parentDescriptor, childDescriptor) {
	    _classCallCheck(this, SyntaxErrorReporter);
	
	    this.parentKlass = parentKlass;
	    this.childKlass = childKlass;
	    this.parentDescriptor = parentDescriptor;
	    this.childDescriptor = childDescriptor;
	  }
	
	  _createClass(SyntaxErrorReporter, [{
	    key: 'assert',
	    value: function assert(condition) {
	      var msg = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	      if (condition !== true) {
	        this.error(GENERIC_FUNCTION_ERROR + msg);
	      }
	    }
	  }, {
	    key: 'error',
	    value: function error(msg) {
	      var _this2 = this;
	
	      msg = msg
	      // Replace lazily, because they actually might not
	      // be available in all cases
	      .replace('{parent}', function (m) {
	        return _this2.parentNotation;
	      }).replace('{child}', function (m) {
	        return _this2.childNotation;
	      });
	      throw new SyntaxError(msg);
	    }
	  }]);
	
	  return SyntaxErrorReporter;
	})();
	
	function getDescriptorType(descriptor) {
	  if (descriptor.hasOwnProperty('value')) {
	    return 'data';
	  }
	
	  if (descriptor.hasOwnProperty('get') || descriptor.hasOwnProperty('set')) {
	    return 'accessor';
	  }
	
	  // If none of them exist, browsers treat it as
	  // a data descriptor with a value of `undefined`
	  return 'data';
	}
	
	function checkFunctionSignatures(parent, child, reporter) {
	  reporter.assert(parent.length === child.length);
	}
	
	function checkDataDescriptors(parent, child, reporter) {
	  var parentValueType = typeof parent.value;
	  var childValueType = typeof child.value;
	
	  if (parentValueType === 'undefined' && childValueType === 'undefined') {
	    // class properties can be any expression, which isn't ran until the
	    // the instance is created, so we can't reliably get type information
	    // for them yet (per spec). Perhaps when Babel includes flow-type info
	    // in runtime? Tried regex solutions, but super hacky and only feasible
	    // on primitives, which is confusing for usage...
	    reporter.error('descriptor values are both undefined. (class properties are are not currently supported)\'');
	  }
	
	  if (parentValueType !== childValueType) {
	    var isFunctionOverUndefined = childValueType === 'function' && parentValueType === undefined;
	    // Even though we don't support class properties, this
	    // will still handle more than just functions, just in case.
	    // Shadowing an undefined value is an error if the inherited
	    // value was undefined (usually a class property, not a method)
	    if (isFunctionOverUndefined || parentValueType !== undefined) {
	      reporter.error('value types do not match. {parent} is "' + parentValueType + '", {child} is "' + childValueType + '"');
	    }
	  }
	
	  // Switch, in preparation for supporting more types
	  switch (childValueType) {
	    case 'function':
	      checkFunctionSignatures(parent.value, child.value, reporter);
	      break;
	
	    default:
	      reporter.error('Unexpected error. Please file a bug with: {parent} is "' + parentValueType + '", {child} is "' + childValueType + '"');
	      break;
	  }
	}
	
	function checkAccessorDescriptors(parent, child, reporter) {
	  var parentHasGetter = typeof parent.get === 'function';
	  var childHasGetter = typeof child.get === 'function';
	  var parentHasSetter = typeof parent.set === 'function';
	  var childHasSetter = typeof child.set === 'function';
	
	  if (parentHasGetter || childHasGetter) {
	    if (!parentHasGetter && parentHasSetter) {
	      reporter.error('{parent} is setter but {child} is getter');
	    }
	
	    if (!childHasGetter && childHasSetter) {
	      reporter.error('{parent} is getter but {child} is setter');
	    }
	
	    checkFunctionSignatures(parent.get, child.get, reporter);
	  }
	
	  if (parentHasSetter || childHasSetter) {
	    if (!parentHasSetter && parentHasGetter) {
	      reporter.error('{parent} is getter but {child} is setter');
	    }
	
	    if (!childHasSetter && childHasGetter) {
	      reporter.error('{parent} is setter but {child} is getter');
	    }
	
	    checkFunctionSignatures(parent.set, child.set, reporter);
	  }
	}
	
	function checkDescriptors(parent, child, reporter) {
	  var parentType = getDescriptorType(parent);
	  var childType = getDescriptorType(child);
	
	  if (parentType !== childType) {
	    reporter.error('descriptor types do not match. {parent} is "' + parentType + '", {child} is "' + childType + '"');
	  }
	
	  switch (childType) {
	    case 'data':
	      checkDataDescriptors(parent, child, reporter);
	      break;
	
	    case 'accessor':
	      checkAccessorDescriptors(parent, child, reporter);
	      break;
	  }
	}
	
	var suggestionTransforms = [function (key) {
	  return key.toLowerCase();
	}, function (key) {
	  return key.toUpperCase();
	}, function (key) {
	  return key + 's';
	}, function (key) {
	  return key.slice(0, -1);
	}, function (key) {
	  return key.slice(1, key.length);
	}];
	
	function findPossibleAlternatives(superKlass, key) {
	  for (var i = 0, l = suggestionTransforms.length; i < l; i++) {
	    var fn = suggestionTransforms[i];
	    var suggestion = fn(key);
	
	    if (suggestion in superKlass) {
	      return suggestion;
	    }
	  }
	
	  return null;
	}
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.key = key;
	  var superKlass = Object.getPrototypeOf(target);
	  var superDescriptor = Object.getOwnPropertyDescriptor(superKlass, key);
	  var reporter = new SyntaxErrorReporter(superKlass, target, superDescriptor, descriptor);
	
	  if (superDescriptor === undefined) {
	    var suggestedKey = findPossibleAlternatives(superKlass, key);
	    var suggestion = suggestedKey ? '\n\n  Did you mean "' + suggestedKey + '"?' : '';
	    reporter.error('No descriptor matching {child} was found on the prototype chain.' + suggestion);
	  }
	
	  checkDescriptors(superDescriptor, descriptor, reporter);
	
	  return descriptor;
	}
	
	function override() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = readonly;
	
	var _privateUtils = __webpack_require__(161);
	
	function handleDescriptor(target, key, descriptor) {
	  descriptor.writable = false;
	  return descriptor;
	}
	
	function readonly() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = suppressWarnings;
	
	var _privateUtils = __webpack_require__(161);
	
	function suppressedWarningNoop() {
	  // Warnings are currently suppressed via @suppressWarnings
	}
	
	function applyWithoutWarnings(context, fn, args) {
	  if (typeof console === 'object') {
	    var nativeWarn = console.warn;
	    console.warn = suppressedWarningNoop;
	    var ret = fn.apply(context, args);
	    console.warn = nativeWarn;
	    return ret;
	  } else {
	    return fn.apply(context, args);
	  }
	}
	
	function handleDescriptor(target, key, descriptor) {
	  return _extends({}, descriptor, {
	    value: function suppressWarningsWrapper() {
	      return applyWithoutWarnings(this, descriptor.value, arguments);
	    }
	  });
	}
	
	function suppressWarnings() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = throttle;
	
	var _privateUtils = __webpack_require__(161);
	
	var DEFAULT_TIMEOUT = 300;
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var _ref2$0 = _ref2[0];
	  var wait = _ref2$0 === undefined ? DEFAULT_TIMEOUT : _ref2$0;
	  var _ref2$1 = _ref2[1];
	  var options = _ref2$1 === undefined ? {} : _ref2$1;
	
	  var callback = descriptor.value;
	
	  if (typeof callback !== 'function') {
	    throw new SyntaxError('Only functions can be throttled');
	  }
	
	  if (options.leading !== false) {
	    options.leading = true;
	  }
	
	  if (options.trailing !== false) {
	    options.trailing = true;
	  }
	
	  return _extends({}, descriptor, {
	    value: function value() {
	      var _this = this;
	
	      var meta = (0, _privateUtils.metaFor)(this);
	      var throttleTimeoutIds = meta.throttleTimeoutIds;
	      var throttlePreviousTimestamps = meta.throttlePreviousTimestamps;
	
	      var timeout = throttleTimeoutIds[key];
	      // last execute timestamp
	      var previous = throttlePreviousTimestamps[key] || 0;
	      var now = Date.now();
	
	      if (options.trailing) {
	        meta.throttleTrailingArgs = arguments;
	      }
	
	      // if first be called and disable the execution on the leading edge
	      // set last execute timestamp to now
	      if (!previous && options.leading === false) {
	        previous = now;
	      }
	
	      var remaining = wait - (now - previous);
	
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        delete throttleTimeoutIds[key];
	        throttlePreviousTimestamps[key] = now;
	        callback.apply(this, arguments);
	      } else if (!timeout && options.trailing) {
	        throttleTimeoutIds[key] = setTimeout(function () {
	          throttlePreviousTimestamps[key] = options.leading === false ? 0 : Date.now();
	          delete throttleTimeoutIds[key];
	          callback.apply(_this, meta.throttleTrailingArgs);
	          // don't leak memory!
	          meta.throttleTrailingArgs = null;
	        }, remaining);
	      }
	    }
	  });
	}
	
	function throttle() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}
	
	module.exports = exports['default'];

/***/ }),
/* 4331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = time;
	
	var _privateUtils = __webpack_require__(161);
	
	var labels = {};
	
	// Exported for mocking in tests
	var defaultConsole = {
	  time: console.time ? console.time.bind(console) : function (label) {
	    labels[label] = new Date();
	  },
	  timeEnd: console.timeEnd ? console.timeEnd.bind(console) : function (label) {
	    var timeNow = new Date();
	    var timeTaken = timeNow - labels[label];
	    delete labels[label];
	    console.log(label + ': ' + timeTaken + 'ms');
	  }
	};
	
	exports.defaultConsole = defaultConsole;
	var count = 0;
	
	function handleDescriptor(target, key, descriptor, _ref) {
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var _ref2$0 = _ref2[0];
	  var prefix = _ref2$0 === undefined ? null : _ref2$0;
	  var _ref2$1 = _ref2[1];
	  var console = _ref2$1 === undefined ? defaultConsole : _ref2$1;
	
	  var fn = descriptor.value;
	
	  if (prefix === null) {
	    prefix = target.constructor.name + '.' + key;
	  }
	
	  if (typeof fn !== 'function') {
	    throw new SyntaxError('@time can only be used on functions, not: ' + fn);
	  }
	
	  return _extends({}, descriptor, {
	    value: function value() {
	      var label = prefix + '-' + count;
	      count++;
	      console.time(label);
	
	      try {
	        return fn.apply(this, arguments);
	      } finally {
	        console.timeEnd(label);
	      }
	    }
	  });
	}
	
	function time() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return (0, _privateUtils.decorate)(handleDescriptor, args);
	}

/***/ }),
/* 4332 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4414);
	module.exports = __webpack_require__(270).RegExp.escape;


/***/ }),
/* 4333 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(440);
	__webpack_require__(4377);
	module.exports = __webpack_require__(100).Array.from;


/***/ }),
/* 4334 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(555);
	__webpack_require__(440);
	module.exports = __webpack_require__(4375);


/***/ }),
/* 4335 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(555);
	__webpack_require__(440);
	module.exports = __webpack_require__(4376);


/***/ }),
/* 4336 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(100);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 4337 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(921);
	__webpack_require__(440);
	__webpack_require__(555);
	__webpack_require__(4379);
	__webpack_require__(4397);
	__webpack_require__(4396);
	__webpack_require__(4395);
	module.exports = __webpack_require__(100).Map;


/***/ }),
/* 4338 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4380);
	module.exports = __webpack_require__(100).Number.isFinite;


/***/ }),
/* 4339 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4381);
	module.exports = __webpack_require__(100).Number.isInteger;


/***/ }),
/* 4340 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4382);
	module.exports = __webpack_require__(100).Number.isNaN;


/***/ }),
/* 4341 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4383);
	module.exports = -0x1fffffffffffff;


/***/ }),
/* 4342 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4384);
	module.exports = __webpack_require__(100).Object.assign;


/***/ }),
/* 4343 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4385);
	var $Object = __webpack_require__(100).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 4344 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4386);
	var $Object = __webpack_require__(100).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 4345 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4398);
	module.exports = __webpack_require__(100).Object.entries;


/***/ }),
/* 4346 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4387);
	var $Object = __webpack_require__(100).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 4347 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4388);
	module.exports = __webpack_require__(100).Object.getPrototypeOf;


/***/ }),
/* 4348 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4389);
	module.exports = __webpack_require__(100).Object.keys;


/***/ }),
/* 4349 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4390);
	module.exports = __webpack_require__(100).Object.setPrototypeOf;


/***/ }),
/* 4350 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4399);
	module.exports = __webpack_require__(100).Object.values;


/***/ }),
/* 4351 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(921);
	__webpack_require__(440);
	__webpack_require__(555);
	__webpack_require__(4391);
	__webpack_require__(4400);
	__webpack_require__(4401);
	module.exports = __webpack_require__(100).Promise;


/***/ }),
/* 4352 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4392);
	module.exports = __webpack_require__(100).Reflect.has;


/***/ }),
/* 4353 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4407);
	module.exports = __webpack_require__(100).setImmediate;


/***/ }),
/* 4354 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(921);
	__webpack_require__(440);
	__webpack_require__(555);
	__webpack_require__(4393);
	__webpack_require__(4404);
	__webpack_require__(4403);
	__webpack_require__(4402);
	module.exports = __webpack_require__(100).Set;


/***/ }),
/* 4355 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4394);
	__webpack_require__(921);
	__webpack_require__(4405);
	__webpack_require__(4406);
	module.exports = __webpack_require__(100).Symbol;


/***/ }),
/* 4356 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(440);
	__webpack_require__(555);
	module.exports = __webpack_require__(1417).f('iterator');


/***/ }),
/* 4357 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 4358 */
[6541, 705],
/* 4359 */
[6542, 366, 919, 4374],
/* 4360 */
[6543, 315, 1402, 554, 919, 4362],
/* 4361 */
[6544, 222, 2121, 170],
/* 4362 */
[6545, 4361],
/* 4363 */
[6549, 241, 707],
/* 4364 */
[6553, 553, 1407, 706],
/* 4365 */
2146,
/* 4366 */
[6561, 222],
/* 4367 */
[6563, 918, 707, 708, 365, 170],
/* 4368 */
[6567, 169, 1412, 704],
/* 4369 */
[6569, 553, 1407, 706, 554, 1402, 438],
/* 4370 */
[6572, 241, 267, 553, 268],
/* 4371 */
[6574, 366, 2125],
/* 4372 */
[6584, 222, 267, 315, 1406],
/* 4373 */
[6589, 1413, 1399],
/* 4374 */
[6591, 1413],
/* 4375 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(267);
	var get = __webpack_require__(1418);
	module.exports = __webpack_require__(100).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 4376 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(916);
	var ITERATOR = __webpack_require__(170)('iterator');
	var Iterators = __webpack_require__(552);
	module.exports = __webpack_require__(100).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 4377 */
[6601, 315, 110, 554, 2122, 2120, 919, 4363, 1418, 2123],
/* 4378 */
[6602, 4357, 2124, 552, 366, 1403],
/* 4379 */
[6603, 2115, 1415, 2117],
/* 4380 */
[6604, 110, 169],
/* 4381 */
[6605, 110, 4366],
/* 4382 */
[6606, 110],
/* 4383 */
[6607, 110],
/* 4384 */
[6608, 110, 4369],
/* 4385 */
[6609, 110, 918],
/* 4386 */
[6610, 110, 268, 241],
/* 4387 */
[6611, 366, 1406, 1408],
/* 4388 */
[6612, 554, 2126, 1408],
/* 4389 */
[6613, 554, 553, 1408],
/* 4390 */
[6614, 110, 4372],
/* 4391 */
[6615, 917, 169, 315, 916, 110, 222, 703, 1398, 705, 2135, 1412, 4368, 1405, 2129, 2130, 170, 1409, 708, 2134, 100, 2123],
/* 4392 */
[6616, 110],
/* 4393 */
[6617, 2115, 1415, 2117],
/* 4394 */
[6619, 169, 439, 268, 110, 2131, 1404, 438, 1411, 708, 920, 170, 1417, 1416, 4364, 2121, 267, 222, 366, 1414, 707, 918, 4371, 1406, 241, 553, 2125, 706, 1407, 917, 365],
/* 4395 */
[6620, 2132],
/* 4396 */
[6621, 2133],
/* 4397 */
[6622, 110, 2116],
/* 4398 */
[6623, 110, 2128],
/* 4399 */
[6624, 110, 2128],
/* 4400 */
[6625, 110, 100, 169, 2135, 2130],
/* 4401 */
[6626, 110, 1405, 2129],
/* 4402 */
[6627, 2132],
/* 4403 */
[6628, 2133],
/* 4404 */
[6629, 110, 2116],
/* 4405 */
[6630, 1416],
/* 4406 */
[6631, 1416],
/* 4407 */
[6632, 110, 1412],
/* 4408 */
[6544, 99, 926, 106],
/* 4409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(95);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 4410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(85);
	var toPrimitive = __webpack_require__(274);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 4411 */
[6553, 446, 930, 711],
/* 4412 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 4413 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 4414 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(32);
	var $re = __webpack_require__(4412)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 4415 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(32);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(2137) });
	
	__webpack_require__(367)('copyWithin');


/***/ }),
/* 4416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $every = __webpack_require__(269)(4);
	
	$export($export.P + $export.F * !__webpack_require__(244)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 4417 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(32);
	
	$export($export.P, 'Array', { fill: __webpack_require__(1419) });
	
	__webpack_require__(367)('fill');


/***/ }),
/* 4418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $filter = __webpack_require__(269)(2);
	
	$export($export.P + $export.F * !__webpack_require__(244)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 4419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(32);
	var $find = __webpack_require__(269)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(367)(KEY);


/***/ }),
/* 4420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(32);
	var $find = __webpack_require__(269)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(367)(KEY);


/***/ }),
/* 4421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $forEach = __webpack_require__(269)(0);
	var STRICT = __webpack_require__(244)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 4422 */
[6601, 243, 32, 146, 2148, 1427, 126, 1421, 1444, 928],
/* 4423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $indexOf = __webpack_require__(922)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(244)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 4424 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(926) });


/***/ }),
/* 4425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(32);
	var toIObject = __webpack_require__(225);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(710) != Object || !__webpack_require__(244)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 4426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var toIObject = __webpack_require__(225);
	var toInteger = __webpack_require__(273);
	var toLength = __webpack_require__(126);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(244)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 4427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $map = __webpack_require__(269)(1);
	
	$export($export.P + $export.F * !__webpack_require__(244)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 4428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var createProperty = __webpack_require__(1421);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(95)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 4429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $reduce = __webpack_require__(2139);
	
	$export($export.P + $export.F * !__webpack_require__(244)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 4430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $reduce = __webpack_require__(2139);
	
	$export($export.P + $export.F * !__webpack_require__(244)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 4431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var html = __webpack_require__(1425);
	var cof = __webpack_require__(242);
	var toAbsoluteIndex = __webpack_require__(450);
	var toLength = __webpack_require__(126);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(95)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 4432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $some = __webpack_require__(269)(3);
	
	$export($export.P + $export.F * !__webpack_require__(244)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 4433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var aFunction = __webpack_require__(171);
	var toObject = __webpack_require__(146);
	var fails = __webpack_require__(95);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(244)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 4434 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(449)('Array');


/***/ }),
/* 4435 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 4436 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(32);
	var toISOString = __webpack_require__(4409);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 4437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var toObject = __webpack_require__(146);
	var toPrimitive = __webpack_require__(274);
	
	$export($export.P + $export.F * __webpack_require__(95)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 4438 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(106)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(205)(proto, TO_PRIMITIVE, __webpack_require__(4410));


/***/ }),
/* 4439 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(206)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 4440 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(32);
	
	$export($export.P, 'Function', { bind: __webpack_require__(2140) });


/***/ }),
/* 4441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(99);
	var getPrototypeOf = __webpack_require__(224);
	var HAS_INSTANCE = __webpack_require__(106)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(125).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 4442 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(125).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(124) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 4443 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(32);
	var log1p = __webpack_require__(2151);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 4444 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(32);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 4445 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(32);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 4446 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(32);
	var sign = __webpack_require__(1431);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 4447 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 4448 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(32);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 4449 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(32);
	var $expm1 = __webpack_require__(1430);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 4450 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', { fround: __webpack_require__(2150) });


/***/ }),
/* 4451 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(32);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 4452 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(32);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(95)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 4453 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 4454 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(2151) });


/***/ }),
/* 4455 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 4456 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', { sign: __webpack_require__(1431) });


/***/ }),
/* 4457 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(32);
	var expm1 = __webpack_require__(1430);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(95)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 4458 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(32);
	var expm1 = __webpack_require__(1430);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 4459 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 4460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(89);
	var has = __webpack_require__(204);
	var cof = __webpack_require__(242);
	var inheritIfRequired = __webpack_require__(1426);
	var toPrimitive = __webpack_require__(274);
	var fails = __webpack_require__(95);
	var gOPN = __webpack_require__(445).f;
	var gOPD = __webpack_require__(223).f;
	var dP = __webpack_require__(125).f;
	var $trim = __webpack_require__(558).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(444)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(124) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(206)(global, NUMBER, $Number);
	}


/***/ }),
/* 4461 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 4462 */
[6604, 32, 89],
/* 4463 */
[6605, 32, 2147],
/* 4464 */
[6606, 32],
/* 4465 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(32);
	var isInteger = __webpack_require__(2147);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 4466 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 4467 */
[6607, 32],
/* 4468 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	var $parseFloat = __webpack_require__(2159);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 4469 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	var $parseInt = __webpack_require__(2160);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 4470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var toInteger = __webpack_require__(273);
	var aNumberValue = __webpack_require__(2136);
	var repeat = __webpack_require__(1438);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(95)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 4471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $fails = __webpack_require__(95);
	var aNumberValue = __webpack_require__(2136);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 4472 */
[6608, 32, 2153],
/* 4473 */
[6609, 32, 444],
/* 4474 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(124), 'Object', { defineProperties: __webpack_require__(2154) });


/***/ }),
/* 4475 */
[6610, 32, 124, 125],
/* 4476 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(99);
	var meta = __webpack_require__(368).onFreeze;
	
	__webpack_require__(272)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 4477 */
[6611, 225, 223, 272],
/* 4478 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(272)('getOwnPropertyNames', function () {
	  return __webpack_require__(2155).f;
	});


/***/ }),
/* 4479 */
[6612, 146, 224, 272],
/* 4480 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(99);
	
	__webpack_require__(272)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 4481 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(99);
	
	__webpack_require__(272)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 4482 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(99);
	
	__webpack_require__(272)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 4483 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(32);
	$export($export.S, 'Object', { is: __webpack_require__(4413) });


/***/ }),
/* 4484 */
[6613, 146, 446, 272],
/* 4485 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(99);
	var meta = __webpack_require__(368).onFreeze;
	
	__webpack_require__(272)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 4486 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(99);
	var meta = __webpack_require__(368).onFreeze;
	
	__webpack_require__(272)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 4487 */
[6614, 32, 1434],
/* 4488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(709);
	var test = {};
	test[__webpack_require__(106)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(206)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 4489 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	var $parseFloat = __webpack_require__(2159);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 4490 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	var $parseInt = __webpack_require__(2160);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 4491 */
[6615, 443, 89, 243, 709, 32, 99, 171, 441, 442, 934, 1440, 1432, 1433, 2161, 2162, 106, 448, 557, 449, 270, 928],
/* 4492 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(32);
	var aFunction = __webpack_require__(171);
	var anObject = __webpack_require__(85);
	var rApply = (__webpack_require__(89).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(95)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 4493 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(32);
	var create = __webpack_require__(444);
	var aFunction = __webpack_require__(171);
	var anObject = __webpack_require__(85);
	var isObject = __webpack_require__(99);
	var fails = __webpack_require__(95);
	var bind = __webpack_require__(2140);
	var rConstruct = (__webpack_require__(89).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 4494 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(125);
	var $export = __webpack_require__(32);
	var anObject = __webpack_require__(85);
	var toPrimitive = __webpack_require__(274);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(95)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 4495 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(32);
	var gOPD = __webpack_require__(223).f;
	var anObject = __webpack_require__(85);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 4496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(32);
	var anObject = __webpack_require__(85);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(1428)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 4497 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(223);
	var $export = __webpack_require__(32);
	var anObject = __webpack_require__(85);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 4498 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(32);
	var getProto = __webpack_require__(224);
	var anObject = __webpack_require__(85);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 4499 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(223);
	var getPrototypeOf = __webpack_require__(224);
	var has = __webpack_require__(204);
	var $export = __webpack_require__(32);
	var isObject = __webpack_require__(99);
	var anObject = __webpack_require__(85);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 4500 */
[6616, 32],
/* 4501 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(32);
	var anObject = __webpack_require__(85);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 4502 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(2158) });


/***/ }),
/* 4503 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(32);
	var anObject = __webpack_require__(85);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 4504 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(32);
	var setProto = __webpack_require__(1434);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 4505 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(125);
	var gOPD = __webpack_require__(223);
	var getPrototypeOf = __webpack_require__(224);
	var has = __webpack_require__(204);
	var $export = __webpack_require__(32);
	var createDesc = __webpack_require__(447);
	var anObject = __webpack_require__(85);
	var isObject = __webpack_require__(99);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 4506 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(89);
	var inheritIfRequired = __webpack_require__(1426);
	var dP = __webpack_require__(125).f;
	var gOPN = __webpack_require__(445).f;
	var isRegExp = __webpack_require__(927);
	var $flags = __webpack_require__(925);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(124) && (!CORRECT_NEW || __webpack_require__(95)(function () {
	  re2[__webpack_require__(106)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(206)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(449)('RegExp');


/***/ }),
/* 4507 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(924)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 4508 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(924)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 4509 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(924)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 4510 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(924)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(927);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 4511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(2167);
	var anObject = __webpack_require__(85);
	var $flags = __webpack_require__(925);
	var DESCRIPTORS = __webpack_require__(124);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(206)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(95)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 4512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(207)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 4513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(207)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 4514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(207)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 4515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(207)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 4516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $at = __webpack_require__(1436)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 4517 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(32);
	var toLength = __webpack_require__(126);
	var context = __webpack_require__(1437);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(1424)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 4518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(207)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 4519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(207)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 4520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(207)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 4521 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	var toAbsoluteIndex = __webpack_require__(450);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 4522 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(32);
	var context = __webpack_require__(1437);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(1424)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 4523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(207)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 4524 */
[6618, 1436, 1429],
/* 4525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(207)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 4526 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	var toIObject = __webpack_require__(225);
	var toLength = __webpack_require__(126);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 4527 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(1438)
	});


/***/ }),
/* 4528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(207)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 4529 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(32);
	var toLength = __webpack_require__(126);
	var context = __webpack_require__(1437);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(1424)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 4530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(207)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 4531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(207)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 4532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(207)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 4533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(558)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 4534 */
[6619, 89, 204, 124, 32, 206, 368, 95, 933, 557, 451, 106, 2165, 1443, 4411, 926, 85, 99, 225, 274, 447, 444, 2155, 223, 125, 446, 445, 711, 930, 443, 205],
/* 4535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var $typed = __webpack_require__(935);
	var buffer = __webpack_require__(1441);
	var anObject = __webpack_require__(85);
	var toAbsoluteIndex = __webpack_require__(450);
	var toLength = __webpack_require__(126);
	var isObject = __webpack_require__(99);
	var ArrayBuffer = __webpack_require__(89).ArrayBuffer;
	var speciesConstructor = __webpack_require__(934);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(95)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(449)(ARRAY_BUFFER);


/***/ }),
/* 4536 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	$export($export.G + $export.W + $export.F * !__webpack_require__(935).ABV, {
	  DataView: __webpack_require__(1441).DataView
	});


/***/ }),
/* 4537 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 4538 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 4539 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 4540 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 4541 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 4542 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 4543 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 4544 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 4545 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(317)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 4546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(2143);
	var validate = __webpack_require__(559);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(923)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 4547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(32);
	var flattenIntoArray = __webpack_require__(2144);
	var toObject = __webpack_require__(146);
	var toLength = __webpack_require__(126);
	var aFunction = __webpack_require__(171);
	var arraySpeciesCreate = __webpack_require__(1420);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(367)('flatMap');


/***/ }),
/* 4548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(32);
	var flattenIntoArray = __webpack_require__(2144);
	var toObject = __webpack_require__(146);
	var toLength = __webpack_require__(126);
	var toInteger = __webpack_require__(273);
	var arraySpeciesCreate = __webpack_require__(1420);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(367)('flatten');


/***/ }),
/* 4549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(32);
	var $includes = __webpack_require__(922)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(367)('includes');


/***/ }),
/* 4550 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(32);
	var microtask = __webpack_require__(1432)();
	var process = __webpack_require__(89).process;
	var isNode = __webpack_require__(242)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 4551 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(32);
	var cof = __webpack_require__(242);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 4552 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(32);
	
	$export($export.G, { global: __webpack_require__(89) });


/***/ }),
/* 4553 */
[6620, 931],
/* 4554 */
[6621, 932],
/* 4555 */
[6622, 32, 2142],
/* 4556 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 4557 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 4558 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(32);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 4559 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(32);
	var scale = __webpack_require__(2152);
	var fround = __webpack_require__(2150);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 4560 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 4561 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 4562 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 4563 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 4564 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(32);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 4565 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', { scale: __webpack_require__(2152) });


/***/ }),
/* 4566 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 4567 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(32);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 4568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var toObject = __webpack_require__(146);
	var aFunction = __webpack_require__(171);
	var $defineProperty = __webpack_require__(125);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(124) && $export($export.P + __webpack_require__(929), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 4569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var toObject = __webpack_require__(146);
	var aFunction = __webpack_require__(171);
	var $defineProperty = __webpack_require__(125);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(124) && $export($export.P + __webpack_require__(929), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 4570 */
[6623, 32, 2157],
/* 4571 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(32);
	var ownKeys = __webpack_require__(2158);
	var toIObject = __webpack_require__(225);
	var gOPD = __webpack_require__(223);
	var createProperty = __webpack_require__(1421);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 4572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var toObject = __webpack_require__(146);
	var toPrimitive = __webpack_require__(274);
	var getPrototypeOf = __webpack_require__(224);
	var getOwnPropertyDescriptor = __webpack_require__(223).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(124) && $export($export.P + __webpack_require__(929), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 4573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(32);
	var toObject = __webpack_require__(146);
	var toPrimitive = __webpack_require__(274);
	var getPrototypeOf = __webpack_require__(224);
	var getOwnPropertyDescriptor = __webpack_require__(223).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(124) && $export($export.P + __webpack_require__(929), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 4574 */
[6624, 32, 2157],
/* 4575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(32);
	var global = __webpack_require__(89);
	var core = __webpack_require__(270);
	var microtask = __webpack_require__(1432)();
	var OBSERVABLE = __webpack_require__(106)('observable');
	var aFunction = __webpack_require__(171);
	var anObject = __webpack_require__(85);
	var anInstance = __webpack_require__(441);
	var redefineAll = __webpack_require__(448);
	var hide = __webpack_require__(205);
	var forOf = __webpack_require__(442);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(449)('Observable');


/***/ }),
/* 4576 */
[6625, 32, 270, 89, 934, 2162],
/* 4577 */
[6626, 32, 1433, 2161],
/* 4578 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(316);
	var anObject = __webpack_require__(85);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 4579 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(316);
	var anObject = __webpack_require__(85);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 4580 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(2168);
	var from = __webpack_require__(2138);
	var metadata = __webpack_require__(316);
	var anObject = __webpack_require__(85);
	var getPrototypeOf = __webpack_require__(224);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 4581 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(316);
	var anObject = __webpack_require__(85);
	var getPrototypeOf = __webpack_require__(224);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 4582 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(316);
	var anObject = __webpack_require__(85);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 4583 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(316);
	var anObject = __webpack_require__(85);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 4584 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(316);
	var anObject = __webpack_require__(85);
	var getPrototypeOf = __webpack_require__(224);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 4585 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(316);
	var anObject = __webpack_require__(85);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 4586 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(316);
	var anObject = __webpack_require__(85);
	var aFunction = __webpack_require__(171);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 4587 */
[6627, 931],
/* 4588 */
[6628, 932],
/* 4589 */
[6629, 32, 2142],
/* 4590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(32);
	var $at = __webpack_require__(1436)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 4591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(32);
	var defined = __webpack_require__(271);
	var toLength = __webpack_require__(126);
	var isRegExp = __webpack_require__(927);
	var getFlags = __webpack_require__(925);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(1428)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 4592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(32);
	var $pad = __webpack_require__(2163);
	var userAgent = __webpack_require__(1442);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 4593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(32);
	var $pad = __webpack_require__(2163);
	var userAgent = __webpack_require__(1442);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 4594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(558)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 4595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(558)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 4596 */
[6630, 1443],
/* 4597 */
[6631, 1443],
/* 4598 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(32);
	
	$export($export.S, 'System', { global: __webpack_require__(89) });


/***/ }),
/* 4599 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(931)('WeakMap');


/***/ }),
/* 4600 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(932)('WeakMap');


/***/ }),
/* 4601 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(931)('WeakSet');


/***/ }),
/* 4602 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(932)('WeakSet');


/***/ }),
/* 4603 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(1445);
	var getKeys = __webpack_require__(446);
	var redefine = __webpack_require__(206);
	var global = __webpack_require__(89);
	var hide = __webpack_require__(205);
	var Iterators = __webpack_require__(556);
	var wks = __webpack_require__(106);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 4604 */
[6632, 32, 1440],
/* 4605 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(89);
	var $export = __webpack_require__(32);
	var userAgent = __webpack_require__(1442);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 4606 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4534);
	__webpack_require__(4473);
	__webpack_require__(4475);
	__webpack_require__(4474);
	__webpack_require__(4477);
	__webpack_require__(4479);
	__webpack_require__(4484);
	__webpack_require__(4478);
	__webpack_require__(4476);
	__webpack_require__(4486);
	__webpack_require__(4485);
	__webpack_require__(4481);
	__webpack_require__(4482);
	__webpack_require__(4480);
	__webpack_require__(4472);
	__webpack_require__(4483);
	__webpack_require__(4487);
	__webpack_require__(4488);
	__webpack_require__(4440);
	__webpack_require__(4442);
	__webpack_require__(4441);
	__webpack_require__(4490);
	__webpack_require__(4489);
	__webpack_require__(4460);
	__webpack_require__(4470);
	__webpack_require__(4471);
	__webpack_require__(4461);
	__webpack_require__(4462);
	__webpack_require__(4463);
	__webpack_require__(4464);
	__webpack_require__(4465);
	__webpack_require__(4466);
	__webpack_require__(4467);
	__webpack_require__(4468);
	__webpack_require__(4469);
	__webpack_require__(4443);
	__webpack_require__(4444);
	__webpack_require__(4445);
	__webpack_require__(4446);
	__webpack_require__(4447);
	__webpack_require__(4448);
	__webpack_require__(4449);
	__webpack_require__(4450);
	__webpack_require__(4451);
	__webpack_require__(4452);
	__webpack_require__(4453);
	__webpack_require__(4454);
	__webpack_require__(4455);
	__webpack_require__(4456);
	__webpack_require__(4457);
	__webpack_require__(4458);
	__webpack_require__(4459);
	__webpack_require__(4521);
	__webpack_require__(4526);
	__webpack_require__(4533);
	__webpack_require__(4524);
	__webpack_require__(4516);
	__webpack_require__(4517);
	__webpack_require__(4522);
	__webpack_require__(4527);
	__webpack_require__(4529);
	__webpack_require__(4512);
	__webpack_require__(4513);
	__webpack_require__(4514);
	__webpack_require__(4515);
	__webpack_require__(4518);
	__webpack_require__(4519);
	__webpack_require__(4520);
	__webpack_require__(4523);
	__webpack_require__(4525);
	__webpack_require__(4528);
	__webpack_require__(4530);
	__webpack_require__(4531);
	__webpack_require__(4532);
	__webpack_require__(4435);
	__webpack_require__(4437);
	__webpack_require__(4436);
	__webpack_require__(4439);
	__webpack_require__(4438);
	__webpack_require__(4424);
	__webpack_require__(4422);
	__webpack_require__(4428);
	__webpack_require__(4425);
	__webpack_require__(4431);
	__webpack_require__(4433);
	__webpack_require__(4421);
	__webpack_require__(4427);
	__webpack_require__(4418);
	__webpack_require__(4432);
	__webpack_require__(4416);
	__webpack_require__(4430);
	__webpack_require__(4429);
	__webpack_require__(4423);
	__webpack_require__(4426);
	__webpack_require__(4415);
	__webpack_require__(4417);
	__webpack_require__(4420);
	__webpack_require__(4419);
	__webpack_require__(4434);
	__webpack_require__(1445);
	__webpack_require__(4506);
	__webpack_require__(4511);
	__webpack_require__(2167);
	__webpack_require__(4507);
	__webpack_require__(4508);
	__webpack_require__(4509);
	__webpack_require__(4510);
	__webpack_require__(4491);
	__webpack_require__(2166);
	__webpack_require__(2168);
	__webpack_require__(2169);
	__webpack_require__(4546);
	__webpack_require__(4535);
	__webpack_require__(4536);
	__webpack_require__(4541);
	__webpack_require__(4544);
	__webpack_require__(4545);
	__webpack_require__(4539);
	__webpack_require__(4542);
	__webpack_require__(4540);
	__webpack_require__(4543);
	__webpack_require__(4537);
	__webpack_require__(4538);
	__webpack_require__(4492);
	__webpack_require__(4493);
	__webpack_require__(4494);
	__webpack_require__(4495);
	__webpack_require__(4496);
	__webpack_require__(4499);
	__webpack_require__(4497);
	__webpack_require__(4498);
	__webpack_require__(4500);
	__webpack_require__(4501);
	__webpack_require__(4502);
	__webpack_require__(4503);
	__webpack_require__(4505);
	__webpack_require__(4504);
	__webpack_require__(4549);
	__webpack_require__(4547);
	__webpack_require__(4548);
	__webpack_require__(4590);
	__webpack_require__(4593);
	__webpack_require__(4592);
	__webpack_require__(4594);
	__webpack_require__(4595);
	__webpack_require__(4591);
	__webpack_require__(4596);
	__webpack_require__(4597);
	__webpack_require__(4571);
	__webpack_require__(4574);
	__webpack_require__(4570);
	__webpack_require__(4568);
	__webpack_require__(4569);
	__webpack_require__(4572);
	__webpack_require__(4573);
	__webpack_require__(4555);
	__webpack_require__(4589);
	__webpack_require__(4554);
	__webpack_require__(4588);
	__webpack_require__(4600);
	__webpack_require__(4602);
	__webpack_require__(4553);
	__webpack_require__(4587);
	__webpack_require__(4599);
	__webpack_require__(4601);
	__webpack_require__(4552);
	__webpack_require__(4598);
	__webpack_require__(4551);
	__webpack_require__(4556);
	__webpack_require__(4557);
	__webpack_require__(4558);
	__webpack_require__(4559);
	__webpack_require__(4560);
	__webpack_require__(4562);
	__webpack_require__(4561);
	__webpack_require__(4563);
	__webpack_require__(4564);
	__webpack_require__(4565);
	__webpack_require__(4567);
	__webpack_require__(4566);
	__webpack_require__(4576);
	__webpack_require__(4577);
	__webpack_require__(4578);
	__webpack_require__(4579);
	__webpack_require__(4581);
	__webpack_require__(4580);
	__webpack_require__(4583);
	__webpack_require__(4582);
	__webpack_require__(4584);
	__webpack_require__(4585);
	__webpack_require__(4586);
	__webpack_require__(4550);
	__webpack_require__(4575);
	__webpack_require__(4605);
	__webpack_require__(4604);
	__webpack_require__(4603);
	module.exports = __webpack_require__(270);


/***/ }),
/* 4607 */,
/* 4608 */,
/* 4609 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Cropper.js v1.5.4
	 * https://fengyuanchen.github.io/cropperjs
	 *
	 * Copyright 2015-present Chen Fengyuan
	 * Released under the MIT license
	 *
	 * Date: 2019-08-03T08:38:42.128Z
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, global.Cropper = factory());
	}(this, function () { 'use strict';
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _toConsumableArray(arr) {
	    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
	  }
	
	  function _arrayWithoutHoles(arr) {
	    if (Array.isArray(arr)) {
	      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	      return arr2;
	    }
	  }
	
	  function _iterableToArray(iter) {
	    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	  }
	
	  function _nonIterableSpread() {
	    throw new TypeError("Invalid attempt to spread non-iterable instance");
	  }
	
	  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
	  var WINDOW = IS_BROWSER ? window : {};
	  var IS_TOUCH_DEVICE = IS_BROWSER ? 'ontouchstart' in WINDOW.document.documentElement : false;
	  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
	  var NAMESPACE = 'cropper'; // Actions
	
	  var ACTION_ALL = 'all';
	  var ACTION_CROP = 'crop';
	  var ACTION_MOVE = 'move';
	  var ACTION_ZOOM = 'zoom';
	  var ACTION_EAST = 'e';
	  var ACTION_WEST = 'w';
	  var ACTION_SOUTH = 's';
	  var ACTION_NORTH = 'n';
	  var ACTION_NORTH_EAST = 'ne';
	  var ACTION_NORTH_WEST = 'nw';
	  var ACTION_SOUTH_EAST = 'se';
	  var ACTION_SOUTH_WEST = 'sw'; // Classes
	
	  var CLASS_CROP = "".concat(NAMESPACE, "-crop");
	  var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
	  var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
	  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
	  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
	  var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
	  var CLASS_MOVE = "".concat(NAMESPACE, "-move"); // Data keys
	
	  var DATA_ACTION = "".concat(NAMESPACE, "Action");
	  var DATA_PREVIEW = "".concat(NAMESPACE, "Preview"); // Drag modes
	
	  var DRAG_MODE_CROP = 'crop';
	  var DRAG_MODE_MOVE = 'move';
	  var DRAG_MODE_NONE = 'none'; // Events
	
	  var EVENT_CROP = 'crop';
	  var EVENT_CROP_END = 'cropend';
	  var EVENT_CROP_MOVE = 'cropmove';
	  var EVENT_CROP_START = 'cropstart';
	  var EVENT_DBLCLICK = 'dblclick';
	  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
	  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
	  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
	  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
	  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
	  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
	  var EVENT_READY = 'ready';
	  var EVENT_RESIZE = 'resize';
	  var EVENT_WHEEL = 'wheel';
	  var EVENT_ZOOM = 'zoom'; // Mime types
	
	  var MIME_TYPE_JPEG = 'image/jpeg'; // RegExps
	
	  var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
	  var REGEXP_DATA_URL = /^data:/;
	  var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
	  var REGEXP_TAG_NAME = /^img|canvas$/i; // Misc
	  // Inspired by the default width and height of a canvas element.
	
	  var MIN_CONTAINER_WIDTH = 200;
	  var MIN_CONTAINER_HEIGHT = 100;
	
	  var DEFAULTS = {
	    // Define the view mode of the cropper
	    viewMode: 0,
	    // 0, 1, 2, 3
	    // Define the dragging mode of the cropper
	    dragMode: DRAG_MODE_CROP,
	    // 'crop', 'move' or 'none'
	    // Define the initial aspect ratio of the crop box
	    initialAspectRatio: NaN,
	    // Define the aspect ratio of the crop box
	    aspectRatio: NaN,
	    // An object with the previous cropping result data
	    data: null,
	    // A selector for adding extra containers to preview
	    preview: '',
	    // Re-render the cropper when resize the window
	    responsive: true,
	    // Restore the cropped area after resize the window
	    restore: true,
	    // Check if the current image is a cross-origin image
	    checkCrossOrigin: true,
	    // Check the current image's Exif Orientation information
	    checkOrientation: true,
	    // Show the black modal
	    modal: true,
	    // Show the dashed lines for guiding
	    guides: true,
	    // Show the center indicator for guiding
	    center: true,
	    // Show the white modal to highlight the crop box
	    highlight: true,
	    // Show the grid background
	    background: true,
	    // Enable to crop the image automatically when initialize
	    autoCrop: true,
	    // Define the percentage of automatic cropping area when initializes
	    autoCropArea: 0.8,
	    // Enable to move the image
	    movable: true,
	    // Enable to rotate the image
	    rotatable: true,
	    // Enable to scale the image
	    scalable: true,
	    // Enable to zoom the image
	    zoomable: true,
	    // Enable to zoom the image by dragging touch
	    zoomOnTouch: true,
	    // Enable to zoom the image by wheeling mouse
	    zoomOnWheel: true,
	    // Define zoom ratio when zoom the image by wheeling mouse
	    wheelZoomRatio: 0.1,
	    // Enable to move the crop box
	    cropBoxMovable: true,
	    // Enable to resize the crop box
	    cropBoxResizable: true,
	    // Toggle drag mode between "crop" and "move" when click twice on the cropper
	    toggleDragModeOnDblclick: true,
	    // Size limitation
	    minCanvasWidth: 0,
	    minCanvasHeight: 0,
	    minCropBoxWidth: 0,
	    minCropBoxHeight: 0,
	    minContainerWidth: 200,
	    minContainerHeight: 100,
	    // Shortcuts of events
	    ready: null,
	    cropstart: null,
	    cropmove: null,
	    cropend: null,
	    crop: null,
	    zoom: null
	  };
	
	  var TEMPLATE = '<div class="cropper-container" touch-action="none">' + '<div class="cropper-wrap-box">' + '<div class="cropper-canvas"></div>' + '</div>' + '<div class="cropper-drag-box"></div>' + '<div class="cropper-crop-box">' + '<span class="cropper-view-box"></span>' + '<span class="cropper-dashed dashed-h"></span>' + '<span class="cropper-dashed dashed-v"></span>' + '<span class="cropper-center"></span>' + '<span class="cropper-face"></span>' + '<span class="cropper-line line-e" data-cropper-action="e"></span>' + '<span class="cropper-line line-n" data-cropper-action="n"></span>' + '<span class="cropper-line line-w" data-cropper-action="w"></span>' + '<span class="cropper-line line-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-e" data-cropper-action="e"></span>' + '<span class="cropper-point point-n" data-cropper-action="n"></span>' + '<span class="cropper-point point-w" data-cropper-action="w"></span>' + '<span class="cropper-point point-s" data-cropper-action="s"></span>' + '<span class="cropper-point point-ne" data-cropper-action="ne"></span>' + '<span class="cropper-point point-nw" data-cropper-action="nw"></span>' + '<span class="cropper-point point-sw" data-cropper-action="sw"></span>' + '<span class="cropper-point point-se" data-cropper-action="se"></span>' + '</div>' + '</div>';
	
	  /**
	   * Check if the given value is not a number.
	   */
	
	  var isNaN = Number.isNaN || WINDOW.isNaN;
	  /**
	   * Check if the given value is a number.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
	   */
	
	  function isNumber(value) {
	    return typeof value === 'number' && !isNaN(value);
	  }
	  /**
	   * Check if the given value is a positive number.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
	   */
	
	  var isPositiveNumber = function isPositiveNumber(value) {
	    return value > 0 && value < Infinity;
	  };
	  /**
	   * Check if the given value is undefined.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
	   */
	
	  function isUndefined(value) {
	    return typeof value === 'undefined';
	  }
	  /**
	   * Check if the given value is an object.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
	   */
	
	  function isObject(value) {
	    return _typeof(value) === 'object' && value !== null;
	  }
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  /**
	   * Check if the given value is a plain object.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
	   */
	
	  function isPlainObject(value) {
	    if (!isObject(value)) {
	      return false;
	    }
	
	    try {
	      var _constructor = value.constructor;
	      var prototype = _constructor.prototype;
	      return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
	    } catch (error) {
	      return false;
	    }
	  }
	  /**
	   * Check if the given value is a function.
	   * @param {*} value - The value to check.
	   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
	   */
	
	  function isFunction(value) {
	    return typeof value === 'function';
	  }
	  var slice = Array.prototype.slice;
	  /**
	   * Convert array-like or iterable object to an array.
	   * @param {*} value - The value to convert.
	   * @returns {Array} Returns a new array.
	   */
	
	  function toArray(value) {
	    return Array.from ? Array.from(value) : slice.call(value);
	  }
	  /**
	   * Iterate the given data.
	   * @param {*} data - The data to iterate.
	   * @param {Function} callback - The process function for each element.
	   * @returns {*} The original data.
	   */
	
	  function forEach(data, callback) {
	    if (data && isFunction(callback)) {
	      if (Array.isArray(data) || isNumber(data.length)
	      /* array-like */
	      ) {
	          toArray(data).forEach(function (value, key) {
	            callback.call(data, value, key, data);
	          });
	        } else if (isObject(data)) {
	        Object.keys(data).forEach(function (key) {
	          callback.call(data, data[key], key, data);
	        });
	      }
	    }
	
	    return data;
	  }
	  /**
	   * Extend the given object.
	   * @param {*} target - The target object to extend.
	   * @param {*} args - The rest objects for merging to the target object.
	   * @returns {Object} The extended object.
	   */
	
	  var assign = Object.assign || function assign(target) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (isObject(target) && args.length > 0) {
	      args.forEach(function (arg) {
	        if (isObject(arg)) {
	          Object.keys(arg).forEach(function (key) {
	            target[key] = arg[key];
	          });
	        }
	      });
	    }
	
	    return target;
	  };
	  var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
	  /**
	   * Normalize decimal number.
	   * Check out {@link http://0.30000000000000004.com/}
	   * @param {number} value - The value to normalize.
	   * @param {number} [times=100000000000] - The times for normalizing.
	   * @returns {number} Returns the normalized number.
	   */
	
	  function normalizeDecimalNumber(value) {
	    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
	    return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
	  }
	  var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
	  /**
	   * Apply styles to the given element.
	   * @param {Element} element - The target element.
	   * @param {Object} styles - The styles for applying.
	   */
	
	  function setStyle(element, styles) {
	    var style = element.style;
	    forEach(styles, function (value, property) {
	      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
	        value = "".concat(value, "px");
	      }
	
	      style[property] = value;
	    });
	  }
	  /**
	   * Check if the given element has a special class.
	   * @param {Element} element - The element to check.
	   * @param {string} value - The class to search.
	   * @returns {boolean} Returns `true` if the special class was found.
	   */
	
	  function hasClass(element, value) {
	    return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
	  }
	  /**
	   * Add classes to the given element.
	   * @param {Element} element - The target element.
	   * @param {string} value - The classes to be added.
	   */
	
	  function addClass(element, value) {
	    if (!value) {
	      return;
	    }
	
	    if (isNumber(element.length)) {
	      forEach(element, function (elem) {
	        addClass(elem, value);
	      });
	      return;
	    }
	
	    if (element.classList) {
	      element.classList.add(value);
	      return;
	    }
	
	    var className = element.className.trim();
	
	    if (!className) {
	      element.className = value;
	    } else if (className.indexOf(value) < 0) {
	      element.className = "".concat(className, " ").concat(value);
	    }
	  }
	  /**
	   * Remove classes from the given element.
	   * @param {Element} element - The target element.
	   * @param {string} value - The classes to be removed.
	   */
	
	  function removeClass(element, value) {
	    if (!value) {
	      return;
	    }
	
	    if (isNumber(element.length)) {
	      forEach(element, function (elem) {
	        removeClass(elem, value);
	      });
	      return;
	    }
	
	    if (element.classList) {
	      element.classList.remove(value);
	      return;
	    }
	
	    if (element.className.indexOf(value) >= 0) {
	      element.className = element.className.replace(value, '');
	    }
	  }
	  /**
	   * Add or remove classes from the given element.
	   * @param {Element} element - The target element.
	   * @param {string} value - The classes to be toggled.
	   * @param {boolean} added - Add only.
	   */
	
	  function toggleClass(element, value, added) {
	    if (!value) {
	      return;
	    }
	
	    if (isNumber(element.length)) {
	      forEach(element, function (elem) {
	        toggleClass(elem, value, added);
	      });
	      return;
	    } // IE10-11 doesn't support the second parameter of `classList.toggle`
	
	
	    if (added) {
	      addClass(element, value);
	    } else {
	      removeClass(element, value);
	    }
	  }
	  var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
	  /**
	   * Transform the given string from camelCase to kebab-case
	   * @param {string} value - The value to transform.
	   * @returns {string} The transformed value.
	   */
	
	  function toParamCase(value) {
	    return value.replace(REGEXP_CAMEL_CASE, '$1-$2').toLowerCase();
	  }
	  /**
	   * Get data from the given element.
	   * @param {Element} element - The target element.
	   * @param {string} name - The data key to get.
	   * @returns {string} The data value.
	   */
	
	  function getData(element, name) {
	    if (isObject(element[name])) {
	      return element[name];
	    }
	
	    if (element.dataset) {
	      return element.dataset[name];
	    }
	
	    return element.getAttribute("data-".concat(toParamCase(name)));
	  }
	  /**
	   * Set data to the given element.
	   * @param {Element} element - The target element.
	   * @param {string} name - The data key to set.
	   * @param {string} data - The data value.
	   */
	
	  function setData(element, name, data) {
	    if (isObject(data)) {
	      element[name] = data;
	    } else if (element.dataset) {
	      element.dataset[name] = data;
	    } else {
	      element.setAttribute("data-".concat(toParamCase(name)), data);
	    }
	  }
	  /**
	   * Remove data from the given element.
	   * @param {Element} element - The target element.
	   * @param {string} name - The data key to remove.
	   */
	
	  function removeData(element, name) {
	    if (isObject(element[name])) {
	      try {
	        delete element[name];
	      } catch (error) {
	        element[name] = undefined;
	      }
	    } else if (element.dataset) {
	      // #128 Safari not allows to delete dataset property
	      try {
	        delete element.dataset[name];
	      } catch (error) {
	        element.dataset[name] = undefined;
	      }
	    } else {
	      element.removeAttribute("data-".concat(toParamCase(name)));
	    }
	  }
	  var REGEXP_SPACES = /\s\s*/;
	
	  var onceSupported = function () {
	    var supported = false;
	
	    if (IS_BROWSER) {
	      var once = false;
	
	      var listener = function listener() {};
	
	      var options = Object.defineProperty({}, 'once', {
	        get: function get() {
	          supported = true;
	          return once;
	        },
	
	        /**
	         * This setter can fix a `TypeError` in strict mode
	         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
	         * @param {boolean} value - The value to set
	         */
	        set: function set(value) {
	          once = value;
	        }
	      });
	      WINDOW.addEventListener('test', listener, options);
	      WINDOW.removeEventListener('test', listener, options);
	    }
	
	    return supported;
	  }();
	  /**
	   * Remove event listener from the target element.
	   * @param {Element} element - The event target.
	   * @param {string} type - The event type(s).
	   * @param {Function} listener - The event listener.
	   * @param {Object} options - The event options.
	   */
	
	
	  function removeListener(element, type, listener) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var handler = listener;
	    type.trim().split(REGEXP_SPACES).forEach(function (event) {
	      if (!onceSupported) {
	        var listeners = element.listeners;
	
	        if (listeners && listeners[event] && listeners[event][listener]) {
	          handler = listeners[event][listener];
	          delete listeners[event][listener];
	
	          if (Object.keys(listeners[event]).length === 0) {
	            delete listeners[event];
	          }
	
	          if (Object.keys(listeners).length === 0) {
	            delete element.listeners;
	          }
	        }
	      }
	
	      element.removeEventListener(event, handler, options);
	    });
	  }
	  /**
	   * Add event listener to the target element.
	   * @param {Element} element - The event target.
	   * @param {string} type - The event type(s).
	   * @param {Function} listener - The event listener.
	   * @param {Object} options - The event options.
	   */
	
	  function addListener(element, type, listener) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	    var _handler = listener;
	    type.trim().split(REGEXP_SPACES).forEach(function (event) {
	      if (options.once && !onceSupported) {
	        var _element$listeners = element.listeners,
	            listeners = _element$listeners === void 0 ? {} : _element$listeners;
	
	        _handler = function handler() {
	          delete listeners[event][listener];
	          element.removeEventListener(event, _handler, options);
	
	          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          listener.apply(element, args);
	        };
	
	        if (!listeners[event]) {
	          listeners[event] = {};
	        }
	
	        if (listeners[event][listener]) {
	          element.removeEventListener(event, listeners[event][listener], options);
	        }
	
	        listeners[event][listener] = _handler;
	        element.listeners = listeners;
	      }
	
	      element.addEventListener(event, _handler, options);
	    });
	  }
	  /**
	   * Dispatch event on the target element.
	   * @param {Element} element - The event target.
	   * @param {string} type - The event type(s).
	   * @param {Object} data - The additional event data.
	   * @returns {boolean} Indicate if the event is default prevented or not.
	   */
	
	  function dispatchEvent(element, type, data) {
	    var event; // Event and CustomEvent on IE9-11 are global objects, not constructors
	
	    if (isFunction(Event) && isFunction(CustomEvent)) {
	      event = new CustomEvent(type, {
	        detail: data,
	        bubbles: true,
	        cancelable: true
	      });
	    } else {
	      event = document.createEvent('CustomEvent');
	      event.initCustomEvent(type, true, true, data);
	    }
	
	    return element.dispatchEvent(event);
	  }
	  /**
	   * Get the offset base on the document.
	   * @param {Element} element - The target element.
	   * @returns {Object} The offset data.
	   */
	
	  function getOffset(element) {
	    var box = element.getBoundingClientRect();
	    return {
	      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
	      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
	    };
	  }
	  var location = WINDOW.location;
	  var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
	  /**
	   * Check if the given URL is a cross origin URL.
	   * @param {string} url - The target URL.
	   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
	   */
	
	  function isCrossOriginURL(url) {
	    var parts = url.match(REGEXP_ORIGINS);
	    return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
	  }
	  /**
	   * Add timestamp to the given URL.
	   * @param {string} url - The target URL.
	   * @returns {string} The result URL.
	   */
	
	  function addTimestamp(url) {
	    var timestamp = "timestamp=".concat(new Date().getTime());
	    return url + (url.indexOf('?') === -1 ? '?' : '&') + timestamp;
	  }
	  /**
	   * Get transforms base on the given object.
	   * @param {Object} obj - The target object.
	   * @returns {string} A string contains transform values.
	   */
	
	  function getTransforms(_ref) {
	    var rotate = _ref.rotate,
	        scaleX = _ref.scaleX,
	        scaleY = _ref.scaleY,
	        translateX = _ref.translateX,
	        translateY = _ref.translateY;
	    var values = [];
	
	    if (isNumber(translateX) && translateX !== 0) {
	      values.push("translateX(".concat(translateX, "px)"));
	    }
	
	    if (isNumber(translateY) && translateY !== 0) {
	      values.push("translateY(".concat(translateY, "px)"));
	    } // Rotate should come first before scale to match orientation transform
	
	
	    if (isNumber(rotate) && rotate !== 0) {
	      values.push("rotate(".concat(rotate, "deg)"));
	    }
	
	    if (isNumber(scaleX) && scaleX !== 1) {
	      values.push("scaleX(".concat(scaleX, ")"));
	    }
	
	    if (isNumber(scaleY) && scaleY !== 1) {
	      values.push("scaleY(".concat(scaleY, ")"));
	    }
	
	    var transform = values.length ? values.join(' ') : 'none';
	    return {
	      WebkitTransform: transform,
	      msTransform: transform,
	      transform: transform
	    };
	  }
	  /**
	   * Get the max ratio of a group of pointers.
	   * @param {string} pointers - The target pointers.
	   * @returns {number} The result ratio.
	   */
	
	  function getMaxZoomRatio(pointers) {
	    var pointers2 = assign({}, pointers);
	    var ratios = [];
	    forEach(pointers, function (pointer, pointerId) {
	      delete pointers2[pointerId];
	      forEach(pointers2, function (pointer2) {
	        var x1 = Math.abs(pointer.startX - pointer2.startX);
	        var y1 = Math.abs(pointer.startY - pointer2.startY);
	        var x2 = Math.abs(pointer.endX - pointer2.endX);
	        var y2 = Math.abs(pointer.endY - pointer2.endY);
	        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
	        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
	        var ratio = (z2 - z1) / z1;
	        ratios.push(ratio);
	      });
	    });
	    ratios.sort(function (a, b) {
	      return Math.abs(a) < Math.abs(b);
	    });
	    return ratios[0];
	  }
	  /**
	   * Get a pointer from an event object.
	   * @param {Object} event - The target event object.
	   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
	   * @returns {Object} The result pointer contains start and/or end point coordinates.
	   */
	
	  function getPointer(_ref2, endOnly) {
	    var pageX = _ref2.pageX,
	        pageY = _ref2.pageY;
	    var end = {
	      endX: pageX,
	      endY: pageY
	    };
	    return endOnly ? end : assign({
	      startX: pageX,
	      startY: pageY
	    }, end);
	  }
	  /**
	   * Get the center point coordinate of a group of pointers.
	   * @param {Object} pointers - The target pointers.
	   * @returns {Object} The center point coordinate.
	   */
	
	  function getPointersCenter(pointers) {
	    var pageX = 0;
	    var pageY = 0;
	    var count = 0;
	    forEach(pointers, function (_ref3) {
	      var startX = _ref3.startX,
	          startY = _ref3.startY;
	      pageX += startX;
	      pageY += startY;
	      count += 1;
	    });
	    pageX /= count;
	    pageY /= count;
	    return {
	      pageX: pageX,
	      pageY: pageY
	    };
	  }
	  /**
	   * Get the max sizes in a rectangle under the given aspect ratio.
	   * @param {Object} data - The original sizes.
	   * @param {string} [type='contain'] - The adjust type.
	   * @returns {Object} The result sizes.
	   */
	
	  function getAdjustedSizes(_ref4) // or 'cover'
	  {
	    var aspectRatio = _ref4.aspectRatio,
	        height = _ref4.height,
	        width = _ref4.width;
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'contain';
	    var isValidWidth = isPositiveNumber(width);
	    var isValidHeight = isPositiveNumber(height);
	
	    if (isValidWidth && isValidHeight) {
	      var adjustedWidth = height * aspectRatio;
	
	      if (type === 'contain' && adjustedWidth > width || type === 'cover' && adjustedWidth < width) {
	        height = width / aspectRatio;
	      } else {
	        width = height * aspectRatio;
	      }
	    } else if (isValidWidth) {
	      height = width / aspectRatio;
	    } else if (isValidHeight) {
	      width = height * aspectRatio;
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  }
	  /**
	   * Get the new sizes of a rectangle after rotated.
	   * @param {Object} data - The original sizes.
	   * @returns {Object} The result sizes.
	   */
	
	  function getRotatedSizes(_ref5) {
	    var width = _ref5.width,
	        height = _ref5.height,
	        degree = _ref5.degree;
	    degree = Math.abs(degree) % 180;
	
	    if (degree === 90) {
	      return {
	        width: height,
	        height: width
	      };
	    }
	
	    var arc = degree % 90 * Math.PI / 180;
	    var sinArc = Math.sin(arc);
	    var cosArc = Math.cos(arc);
	    var newWidth = width * cosArc + height * sinArc;
	    var newHeight = width * sinArc + height * cosArc;
	    return degree > 90 ? {
	      width: newHeight,
	      height: newWidth
	    } : {
	      width: newWidth,
	      height: newHeight
	    };
	  }
	  /**
	   * Get a canvas which drew the given image.
	   * @param {HTMLImageElement} image - The image for drawing.
	   * @param {Object} imageData - The image data.
	   * @param {Object} canvasData - The canvas data.
	   * @param {Object} options - The options.
	   * @returns {HTMLCanvasElement} The result canvas.
	   */
	
	  function getSourceCanvas(image, _ref6, _ref7, _ref8) {
	    var imageAspectRatio = _ref6.aspectRatio,
	        imageNaturalWidth = _ref6.naturalWidth,
	        imageNaturalHeight = _ref6.naturalHeight,
	        _ref6$rotate = _ref6.rotate,
	        rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate,
	        _ref6$scaleX = _ref6.scaleX,
	        scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX,
	        _ref6$scaleY = _ref6.scaleY,
	        scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
	    var aspectRatio = _ref7.aspectRatio,
	        naturalWidth = _ref7.naturalWidth,
	        naturalHeight = _ref7.naturalHeight;
	    var _ref8$fillColor = _ref8.fillColor,
	        fillColor = _ref8$fillColor === void 0 ? 'transparent' : _ref8$fillColor,
	        _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled,
	        imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE,
	        _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality,
	        imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? 'low' : _ref8$imageSmoothingQ,
	        _ref8$maxWidth = _ref8.maxWidth,
	        maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth,
	        _ref8$maxHeight = _ref8.maxHeight,
	        maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight,
	        _ref8$minWidth = _ref8.minWidth,
	        minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth,
	        _ref8$minHeight = _ref8.minHeight,
	        minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
	    var canvas = document.createElement('canvas');
	    var context = canvas.getContext('2d');
	    var maxSizes = getAdjustedSizes({
	      aspectRatio: aspectRatio,
	      width: maxWidth,
	      height: maxHeight
	    });
	    var minSizes = getAdjustedSizes({
	      aspectRatio: aspectRatio,
	      width: minWidth,
	      height: minHeight
	    }, 'cover');
	    var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
	    var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)); // Note: should always use image's natural sizes for drawing as
	    // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
	
	    var destMaxSizes = getAdjustedSizes({
	      aspectRatio: imageAspectRatio,
	      width: maxWidth,
	      height: maxHeight
	    });
	    var destMinSizes = getAdjustedSizes({
	      aspectRatio: imageAspectRatio,
	      width: minWidth,
	      height: minHeight
	    }, 'cover');
	    var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
	    var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
	    var params = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
	    canvas.width = normalizeDecimalNumber(width);
	    canvas.height = normalizeDecimalNumber(height);
	    context.fillStyle = fillColor;
	    context.fillRect(0, 0, width, height);
	    context.save();
	    context.translate(width / 2, height / 2);
	    context.rotate(rotate * Math.PI / 180);
	    context.scale(scaleX, scaleY);
	    context.imageSmoothingEnabled = imageSmoothingEnabled;
	    context.imageSmoothingQuality = imageSmoothingQuality;
	    context.drawImage.apply(context, [image].concat(_toConsumableArray(params.map(function (param) {
	      return Math.floor(normalizeDecimalNumber(param));
	    }))));
	    context.restore();
	    return canvas;
	  }
	  var fromCharCode = String.fromCharCode;
	  /**
	   * Get string from char code in data view.
	   * @param {DataView} dataView - The data view for read.
	   * @param {number} start - The start index.
	   * @param {number} length - The read length.
	   * @returns {string} The read result.
	   */
	
	  function getStringFromCharCode(dataView, start, length) {
	    var str = '';
	    length += start;
	
	    for (var i = start; i < length; i += 1) {
	      str += fromCharCode(dataView.getUint8(i));
	    }
	
	    return str;
	  }
	  var REGEXP_DATA_URL_HEAD = /^data:.*,/;
	  /**
	   * Transform Data URL to array buffer.
	   * @param {string} dataURL - The Data URL to transform.
	   * @returns {ArrayBuffer} The result array buffer.
	   */
	
	  function dataURLToArrayBuffer(dataURL) {
	    var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, '');
	    var binary = atob(base64);
	    var arrayBuffer = new ArrayBuffer(binary.length);
	    var uint8 = new Uint8Array(arrayBuffer);
	    forEach(uint8, function (value, i) {
	      uint8[i] = binary.charCodeAt(i);
	    });
	    return arrayBuffer;
	  }
	  /**
	   * Transform array buffer to Data URL.
	   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
	   * @param {string} mimeType - The mime type of the Data URL.
	   * @returns {string} The result Data URL.
	   */
	
	  function arrayBufferToDataURL(arrayBuffer, mimeType) {
	    var chunks = []; // Chunk Typed Array for better performance (#435)
	
	    var chunkSize = 8192;
	    var uint8 = new Uint8Array(arrayBuffer);
	
	    while (uint8.length > 0) {
	      // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
	      // eslint-disable-next-line prefer-spread
	      chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
	      uint8 = uint8.subarray(chunkSize);
	    }
	
	    return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join('')));
	  }
	  /**
	   * Get orientation value from given array buffer.
	   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
	   * @returns {number} The read orientation value.
	   */
	
	  function resetAndGetOrientation(arrayBuffer) {
	    var dataView = new DataView(arrayBuffer);
	    var orientation; // Ignores range error when the image does not have correct Exif information
	
	    try {
	      var littleEndian;
	      var app1Start;
	      var ifdStart; // Only handle JPEG image (start by 0xFFD8)
	
	      if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
	        var length = dataView.byteLength;
	        var offset = 2;
	
	        while (offset + 1 < length) {
	          if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
	            app1Start = offset;
	            break;
	          }
	
	          offset += 1;
	        }
	      }
	
	      if (app1Start) {
	        var exifIDCode = app1Start + 4;
	        var tiffOffset = app1Start + 10;
	
	        if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
	          var endianness = dataView.getUint16(tiffOffset);
	          littleEndian = endianness === 0x4949;
	
	          if (littleEndian || endianness === 0x4D4D
	          /* bigEndian */
	          ) {
	              if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
	                var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
	
	                if (firstIFDOffset >= 0x00000008) {
	                  ifdStart = tiffOffset + firstIFDOffset;
	                }
	              }
	            }
	        }
	      }
	
	      if (ifdStart) {
	        var _length = dataView.getUint16(ifdStart, littleEndian);
	
	        var _offset;
	
	        var i;
	
	        for (i = 0; i < _length; i += 1) {
	          _offset = ifdStart + i * 12 + 2;
	
	          if (dataView.getUint16(_offset, littleEndian) === 0x0112
	          /* Orientation */
	          ) {
	              // 8 is the offset of the current tag's value
	              _offset += 8; // Get the original orientation value
	
	              orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value
	
	              dataView.setUint16(_offset, 1, littleEndian);
	              break;
	            }
	        }
	      }
	    } catch (error) {
	      orientation = 1;
	    }
	
	    return orientation;
	  }
	  /**
	   * Parse Exif Orientation value.
	   * @param {number} orientation - The orientation to parse.
	   * @returns {Object} The parsed result.
	   */
	
	  function parseOrientation(orientation) {
	    var rotate = 0;
	    var scaleX = 1;
	    var scaleY = 1;
	
	    switch (orientation) {
	      // Flip horizontal
	      case 2:
	        scaleX = -1;
	        break;
	      // Rotate left 180°
	
	      case 3:
	        rotate = -180;
	        break;
	      // Flip vertical
	
	      case 4:
	        scaleY = -1;
	        break;
	      // Flip vertical and rotate right 90°
	
	      case 5:
	        rotate = 90;
	        scaleY = -1;
	        break;
	      // Rotate right 90°
	
	      case 6:
	        rotate = 90;
	        break;
	      // Flip horizontal and rotate right 90°
	
	      case 7:
	        rotate = 90;
	        scaleX = -1;
	        break;
	      // Rotate left 90°
	
	      case 8:
	        rotate = -90;
	        break;
	
	      default:
	    }
	
	    return {
	      rotate: rotate,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	
	  var render = {
	    render: function render() {
	      this.initContainer();
	      this.initCanvas();
	      this.initCropBox();
	      this.renderCanvas();
	
	      if (this.cropped) {
	        this.renderCropBox();
	      }
	    },
	    initContainer: function initContainer() {
	      var element = this.element,
	          options = this.options,
	          container = this.container,
	          cropper = this.cropper;
	      addClass(cropper, CLASS_HIDDEN);
	      removeClass(element, CLASS_HIDDEN);
	      var containerData = {
	        width: Math.max(container.offsetWidth, Number(options.minContainerWidth) || 200),
	        height: Math.max(container.offsetHeight, Number(options.minContainerHeight) || 100)
	      };
	      this.containerData = containerData;
	      setStyle(cropper, {
	        width: containerData.width,
	        height: containerData.height
	      });
	      addClass(element, CLASS_HIDDEN);
	      removeClass(cropper, CLASS_HIDDEN);
	    },
	    // Canvas (image wrapper)
	    initCanvas: function initCanvas() {
	      var containerData = this.containerData,
	          imageData = this.imageData;
	      var viewMode = this.options.viewMode;
	      var rotated = Math.abs(imageData.rotate) % 180 === 90;
	      var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
	      var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
	      var aspectRatio = naturalWidth / naturalHeight;
	      var canvasWidth = containerData.width;
	      var canvasHeight = containerData.height;
	
	      if (containerData.height * aspectRatio > containerData.width) {
	        if (viewMode === 3) {
	          canvasWidth = containerData.height * aspectRatio;
	        } else {
	          canvasHeight = containerData.width / aspectRatio;
	        }
	      } else if (viewMode === 3) {
	        canvasHeight = containerData.width / aspectRatio;
	      } else {
	        canvasWidth = containerData.height * aspectRatio;
	      }
	
	      var canvasData = {
	        aspectRatio: aspectRatio,
	        naturalWidth: naturalWidth,
	        naturalHeight: naturalHeight,
	        width: canvasWidth,
	        height: canvasHeight
	      };
	      canvasData.left = (containerData.width - canvasWidth) / 2;
	      canvasData.top = (containerData.height - canvasHeight) / 2;
	      canvasData.oldLeft = canvasData.left;
	      canvasData.oldTop = canvasData.top;
	      this.canvasData = canvasData;
	      this.limited = viewMode === 1 || viewMode === 2;
	      this.limitCanvas(true, true);
	      this.initialImageData = assign({}, imageData);
	      this.initialCanvasData = assign({}, canvasData);
	    },
	    limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
	      var options = this.options,
	          containerData = this.containerData,
	          canvasData = this.canvasData,
	          cropBoxData = this.cropBoxData;
	      var viewMode = options.viewMode;
	      var aspectRatio = canvasData.aspectRatio;
	      var cropped = this.cropped && cropBoxData;
	
	      if (sizeLimited) {
	        var minCanvasWidth = Number(options.minCanvasWidth) || 0;
	        var minCanvasHeight = Number(options.minCanvasHeight) || 0;
	
	        if (viewMode > 1) {
	          minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
	          minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
	
	          if (viewMode === 3) {
	            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
	              minCanvasWidth = minCanvasHeight * aspectRatio;
	            } else {
	              minCanvasHeight = minCanvasWidth / aspectRatio;
	            }
	          }
	        } else if (viewMode > 0) {
	          if (minCanvasWidth) {
	            minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
	          } else if (minCanvasHeight) {
	            minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
	          } else if (cropped) {
	            minCanvasWidth = cropBoxData.width;
	            minCanvasHeight = cropBoxData.height;
	
	            if (minCanvasHeight * aspectRatio > minCanvasWidth) {
	              minCanvasWidth = minCanvasHeight * aspectRatio;
	            } else {
	              minCanvasHeight = minCanvasWidth / aspectRatio;
	            }
	          }
	        }
	
	        var _getAdjustedSizes = getAdjustedSizes({
	          aspectRatio: aspectRatio,
	          width: minCanvasWidth,
	          height: minCanvasHeight
	        });
	
	        minCanvasWidth = _getAdjustedSizes.width;
	        minCanvasHeight = _getAdjustedSizes.height;
	        canvasData.minWidth = minCanvasWidth;
	        canvasData.minHeight = minCanvasHeight;
	        canvasData.maxWidth = Infinity;
	        canvasData.maxHeight = Infinity;
	      }
	
	      if (positionLimited) {
	        if (viewMode > (cropped ? 0 : 1)) {
	          var newCanvasLeft = containerData.width - canvasData.width;
	          var newCanvasTop = containerData.height - canvasData.height;
	          canvasData.minLeft = Math.min(0, newCanvasLeft);
	          canvasData.minTop = Math.min(0, newCanvasTop);
	          canvasData.maxLeft = Math.max(0, newCanvasLeft);
	          canvasData.maxTop = Math.max(0, newCanvasTop);
	
	          if (cropped && this.limited) {
	            canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
	            canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
	            canvasData.maxLeft = cropBoxData.left;
	            canvasData.maxTop = cropBoxData.top;
	
	            if (viewMode === 2) {
	              if (canvasData.width >= containerData.width) {
	                canvasData.minLeft = Math.min(0, newCanvasLeft);
	                canvasData.maxLeft = Math.max(0, newCanvasLeft);
	              }
	
	              if (canvasData.height >= containerData.height) {
	                canvasData.minTop = Math.min(0, newCanvasTop);
	                canvasData.maxTop = Math.max(0, newCanvasTop);
	              }
	            }
	          }
	        } else {
	          canvasData.minLeft = -canvasData.width;
	          canvasData.minTop = -canvasData.height;
	          canvasData.maxLeft = containerData.width;
	          canvasData.maxTop = containerData.height;
	        }
	      }
	    },
	    renderCanvas: function renderCanvas(changed, transformed) {
	      var canvasData = this.canvasData,
	          imageData = this.imageData;
	
	      if (transformed) {
	        var _getRotatedSizes = getRotatedSizes({
	          width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
	          height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
	          degree: imageData.rotate || 0
	        }),
	            naturalWidth = _getRotatedSizes.width,
	            naturalHeight = _getRotatedSizes.height;
	
	        var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
	        var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
	        canvasData.left -= (width - canvasData.width) / 2;
	        canvasData.top -= (height - canvasData.height) / 2;
	        canvasData.width = width;
	        canvasData.height = height;
	        canvasData.aspectRatio = naturalWidth / naturalHeight;
	        canvasData.naturalWidth = naturalWidth;
	        canvasData.naturalHeight = naturalHeight;
	        this.limitCanvas(true, false);
	      }
	
	      if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
	        canvasData.left = canvasData.oldLeft;
	      }
	
	      if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
	        canvasData.top = canvasData.oldTop;
	      }
	
	      canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
	      canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
	      this.limitCanvas(false, true);
	      canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
	      canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
	      canvasData.oldLeft = canvasData.left;
	      canvasData.oldTop = canvasData.top;
	      setStyle(this.canvas, assign({
	        width: canvasData.width,
	        height: canvasData.height
	      }, getTransforms({
	        translateX: canvasData.left,
	        translateY: canvasData.top
	      })));
	      this.renderImage(changed);
	
	      if (this.cropped && this.limited) {
	        this.limitCropBox(true, true);
	      }
	    },
	    renderImage: function renderImage(changed) {
	      var canvasData = this.canvasData,
	          imageData = this.imageData;
	      var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
	      var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
	      assign(imageData, {
	        width: width,
	        height: height,
	        left: (canvasData.width - width) / 2,
	        top: (canvasData.height - height) / 2
	      });
	      setStyle(this.image, assign({
	        width: imageData.width,
	        height: imageData.height
	      }, getTransforms(assign({
	        translateX: imageData.left,
	        translateY: imageData.top
	      }, imageData))));
	
	      if (changed) {
	        this.output();
	      }
	    },
	    initCropBox: function initCropBox() {
	      var options = this.options,
	          canvasData = this.canvasData;
	      var aspectRatio = options.aspectRatio || options.initialAspectRatio;
	      var autoCropArea = Number(options.autoCropArea) || 0.8;
	      var cropBoxData = {
	        width: canvasData.width,
	        height: canvasData.height
	      };
	
	      if (aspectRatio) {
	        if (canvasData.height * aspectRatio > canvasData.width) {
	          cropBoxData.height = cropBoxData.width / aspectRatio;
	        } else {
	          cropBoxData.width = cropBoxData.height * aspectRatio;
	        }
	      }
	
	      this.cropBoxData = cropBoxData;
	      this.limitCropBox(true, true); // Initialize auto crop area
	
	      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
	      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight); // The width/height of auto crop area must large than "minWidth/Height"
	
	      cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
	      cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
	      cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
	      cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
	      cropBoxData.oldLeft = cropBoxData.left;
	      cropBoxData.oldTop = cropBoxData.top;
	      this.initialCropBoxData = assign({}, cropBoxData);
	    },
	    limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
	      var options = this.options,
	          containerData = this.containerData,
	          canvasData = this.canvasData,
	          cropBoxData = this.cropBoxData,
	          limited = this.limited;
	      var aspectRatio = options.aspectRatio;
	
	      if (sizeLimited) {
	        var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
	        var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
	        var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
	        var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height; // The min/maxCropBoxWidth/Height must be less than container's width/height
	
	        minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
	        minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
	
	        if (aspectRatio) {
	          if (minCropBoxWidth && minCropBoxHeight) {
	            if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
	              minCropBoxHeight = minCropBoxWidth / aspectRatio;
	            } else {
	              minCropBoxWidth = minCropBoxHeight * aspectRatio;
	            }
	          } else if (minCropBoxWidth) {
	            minCropBoxHeight = minCropBoxWidth / aspectRatio;
	          } else if (minCropBoxHeight) {
	            minCropBoxWidth = minCropBoxHeight * aspectRatio;
	          }
	
	          if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
	            maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
	          } else {
	            maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
	          }
	        } // The minWidth/Height must be less than maxWidth/Height
	
	
	        cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
	        cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
	        cropBoxData.maxWidth = maxCropBoxWidth;
	        cropBoxData.maxHeight = maxCropBoxHeight;
	      }
	
	      if (positionLimited) {
	        if (limited) {
	          cropBoxData.minLeft = Math.max(0, canvasData.left);
	          cropBoxData.minTop = Math.max(0, canvasData.top);
	          cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
	          cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
	        } else {
	          cropBoxData.minLeft = 0;
	          cropBoxData.minTop = 0;
	          cropBoxData.maxLeft = containerData.width - cropBoxData.width;
	          cropBoxData.maxTop = containerData.height - cropBoxData.height;
	        }
	      }
	    },
	    renderCropBox: function renderCropBox() {
	      var options = this.options,
	          containerData = this.containerData,
	          cropBoxData = this.cropBoxData;
	
	      if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
	        cropBoxData.left = cropBoxData.oldLeft;
	      }
	
	      if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
	        cropBoxData.top = cropBoxData.oldTop;
	      }
	
	      cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
	      cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
	      this.limitCropBox(false, true);
	      cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
	      cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
	      cropBoxData.oldLeft = cropBoxData.left;
	      cropBoxData.oldTop = cropBoxData.top;
	
	      if (options.movable && options.cropBoxMovable) {
	        // Turn to move the canvas when the crop box is equal to the container
	        setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
	      }
	
	      setStyle(this.cropBox, assign({
	        width: cropBoxData.width,
	        height: cropBoxData.height
	      }, getTransforms({
	        translateX: cropBoxData.left,
	        translateY: cropBoxData.top
	      })));
	
	      if (this.cropped && this.limited) {
	        this.limitCanvas(true, true);
	      }
	
	      if (!this.disabled) {
	        this.output();
	      }
	    },
	    output: function output() {
	      this.preview();
	      dispatchEvent(this.element, EVENT_CROP, this.getData());
	    }
	  };
	
	  var preview = {
	    initPreview: function initPreview() {
	      var element = this.element,
	          crossOrigin = this.crossOrigin;
	      var preview = this.options.preview;
	      var url = crossOrigin ? this.crossOriginUrl : this.url;
	      var alt = element.alt || 'The image to preview';
	      var image = document.createElement('img');
	
	      if (crossOrigin) {
	        image.crossOrigin = crossOrigin;
	      }
	
	      image.src = url;
	      image.alt = alt;
	      this.viewBox.appendChild(image);
	      this.viewBoxImage = image;
	
	      if (!preview) {
	        return;
	      }
	
	      var previews = preview;
	
	      if (typeof preview === 'string') {
	        previews = element.ownerDocument.querySelectorAll(preview);
	      } else if (preview.querySelector) {
	        previews = [preview];
	      }
	
	      this.previews = previews;
	      forEach(previews, function (el) {
	        var img = document.createElement('img'); // Save the original size for recover
	
	        setData(el, DATA_PREVIEW, {
	          width: el.offsetWidth,
	          height: el.offsetHeight,
	          html: el.innerHTML
	        });
	
	        if (crossOrigin) {
	          img.crossOrigin = crossOrigin;
	        }
	
	        img.src = url;
	        img.alt = alt;
	        /**
	         * Override img element styles
	         * Add `display:block` to avoid margin top issue
	         * Add `height:auto` to override `height` attribute on IE8
	         * (Occur only when margin-top <= -height)
	         */
	
	        img.style.cssText = 'display:block;' + 'width:100%;' + 'height:auto;' + 'min-width:0!important;' + 'min-height:0!important;' + 'max-width:none!important;' + 'max-height:none!important;' + 'image-orientation:0deg!important;"';
	        el.innerHTML = '';
	        el.appendChild(img);
	      });
	    },
	    resetPreview: function resetPreview() {
	      forEach(this.previews, function (element) {
	        var data = getData(element, DATA_PREVIEW);
	        setStyle(element, {
	          width: data.width,
	          height: data.height
	        });
	        element.innerHTML = data.html;
	        removeData(element, DATA_PREVIEW);
	      });
	    },
	    preview: function preview() {
	      var imageData = this.imageData,
	          canvasData = this.canvasData,
	          cropBoxData = this.cropBoxData;
	      var cropBoxWidth = cropBoxData.width,
	          cropBoxHeight = cropBoxData.height;
	      var width = imageData.width,
	          height = imageData.height;
	      var left = cropBoxData.left - canvasData.left - imageData.left;
	      var top = cropBoxData.top - canvasData.top - imageData.top;
	
	      if (!this.cropped || this.disabled) {
	        return;
	      }
	
	      setStyle(this.viewBoxImage, assign({
	        width: width,
	        height: height
	      }, getTransforms(assign({
	        translateX: -left,
	        translateY: -top
	      }, imageData))));
	      forEach(this.previews, function (element) {
	        var data = getData(element, DATA_PREVIEW);
	        var originalWidth = data.width;
	        var originalHeight = data.height;
	        var newWidth = originalWidth;
	        var newHeight = originalHeight;
	        var ratio = 1;
	
	        if (cropBoxWidth) {
	          ratio = originalWidth / cropBoxWidth;
	          newHeight = cropBoxHeight * ratio;
	        }
	
	        if (cropBoxHeight && newHeight > originalHeight) {
	          ratio = originalHeight / cropBoxHeight;
	          newWidth = cropBoxWidth * ratio;
	          newHeight = originalHeight;
	        }
	
	        setStyle(element, {
	          width: newWidth,
	          height: newHeight
	        });
	        setStyle(element.getElementsByTagName('img')[0], assign({
	          width: width * ratio,
	          height: height * ratio
	        }, getTransforms(assign({
	          translateX: -left * ratio,
	          translateY: -top * ratio
	        }, imageData))));
	      });
	    }
	  };
	
	  var events = {
	    bind: function bind() {
	      var element = this.element,
	          options = this.options,
	          cropper = this.cropper;
	
	      if (isFunction(options.cropstart)) {
	        addListener(element, EVENT_CROP_START, options.cropstart);
	      }
	
	      if (isFunction(options.cropmove)) {
	        addListener(element, EVENT_CROP_MOVE, options.cropmove);
	      }
	
	      if (isFunction(options.cropend)) {
	        addListener(element, EVENT_CROP_END, options.cropend);
	      }
	
	      if (isFunction(options.crop)) {
	        addListener(element, EVENT_CROP, options.crop);
	      }
	
	      if (isFunction(options.zoom)) {
	        addListener(element, EVENT_ZOOM, options.zoom);
	      }
	
	      addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
	
	      if (options.zoomable && options.zoomOnWheel) {
	        addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
	          passive: false,
	          capture: true
	        });
	      }
	
	      if (options.toggleDragModeOnDblclick) {
	        addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
	      }
	
	      addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
	      addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
	
	      if (options.responsive) {
	        addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
	      }
	    },
	    unbind: function unbind() {
	      var element = this.element,
	          options = this.options,
	          cropper = this.cropper;
	
	      if (isFunction(options.cropstart)) {
	        removeListener(element, EVENT_CROP_START, options.cropstart);
	      }
	
	      if (isFunction(options.cropmove)) {
	        removeListener(element, EVENT_CROP_MOVE, options.cropmove);
	      }
	
	      if (isFunction(options.cropend)) {
	        removeListener(element, EVENT_CROP_END, options.cropend);
	      }
	
	      if (isFunction(options.crop)) {
	        removeListener(element, EVENT_CROP, options.crop);
	      }
	
	      if (isFunction(options.zoom)) {
	        removeListener(element, EVENT_ZOOM, options.zoom);
	      }
	
	      removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
	
	      if (options.zoomable && options.zoomOnWheel) {
	        removeListener(cropper, EVENT_WHEEL, this.onWheel, {
	          passive: false,
	          capture: true
	        });
	      }
	
	      if (options.toggleDragModeOnDblclick) {
	        removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
	      }
	
	      removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
	      removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
	
	      if (options.responsive) {
	        removeListener(window, EVENT_RESIZE, this.onResize);
	      }
	    }
	  };
	
	  var handlers = {
	    resize: function resize() {
	      var options = this.options,
	          container = this.container,
	          containerData = this.containerData;
	      var minContainerWidth = Number(options.minContainerWidth) || MIN_CONTAINER_WIDTH;
	      var minContainerHeight = Number(options.minContainerHeight) || MIN_CONTAINER_HEIGHT;
	
	      if (this.disabled || containerData.width <= minContainerWidth || containerData.height <= minContainerHeight) {
	        return;
	      }
	
	      var ratio = container.offsetWidth / containerData.width; // Resize when width changed or height changed
	
	      if (ratio !== 1 || container.offsetHeight !== containerData.height) {
	        var canvasData;
	        var cropBoxData;
	
	        if (options.restore) {
	          canvasData = this.getCanvasData();
	          cropBoxData = this.getCropBoxData();
	        }
	
	        this.render();
	
	        if (options.restore) {
	          this.setCanvasData(forEach(canvasData, function (n, i) {
	            canvasData[i] = n * ratio;
	          }));
	          this.setCropBoxData(forEach(cropBoxData, function (n, i) {
	            cropBoxData[i] = n * ratio;
	          }));
	        }
	      }
	    },
	    dblclick: function dblclick() {
	      if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
	        return;
	      }
	
	      this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
	    },
	    wheel: function wheel(event) {
	      var _this = this;
	
	      var ratio = Number(this.options.wheelZoomRatio) || 0.1;
	      var delta = 1;
	
	      if (this.disabled) {
	        return;
	      }
	
	      event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)
	
	      if (this.wheeling) {
	        return;
	      }
	
	      this.wheeling = true;
	      setTimeout(function () {
	        _this.wheeling = false;
	      }, 50);
	
	      if (event.deltaY) {
	        delta = event.deltaY > 0 ? 1 : -1;
	      } else if (event.wheelDelta) {
	        delta = -event.wheelDelta / 120;
	      } else if (event.detail) {
	        delta = event.detail > 0 ? 1 : -1;
	      }
	
	      this.zoom(-delta * ratio, event);
	    },
	    cropStart: function cropStart(event) {
	      var buttons = event.buttons,
	          button = event.button;
	
	      if (this.disabled // No primary button (Usually the left button)
	      // Note that touch events have no `buttons` or `button` property
	      || isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
	      || event.ctrlKey) {
	        return;
	      }
	
	      var options = this.options,
	          pointers = this.pointers;
	      var action;
	
	      if (event.changedTouches) {
	        // Handle touch event
	        forEach(event.changedTouches, function (touch) {
	          pointers[touch.identifier] = getPointer(touch);
	        });
	      } else {
	        // Handle mouse event and pointer event
	        pointers[event.pointerId || 0] = getPointer(event);
	      }
	
	      if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) {
	        action = ACTION_ZOOM;
	      } else {
	        action = getData(event.target, DATA_ACTION);
	      }
	
	      if (!REGEXP_ACTIONS.test(action)) {
	        return;
	      }
	
	      if (dispatchEvent(this.element, EVENT_CROP_START, {
	        originalEvent: event,
	        action: action
	      }) === false) {
	        return;
	      } // This line is required for preventing page zooming in iOS browsers
	
	
	      event.preventDefault();
	      this.action = action;
	      this.cropping = false;
	
	      if (action === ACTION_CROP) {
	        this.cropping = true;
	        addClass(this.dragBox, CLASS_MODAL);
	      }
	    },
	    cropMove: function cropMove(event) {
	      var action = this.action;
	
	      if (this.disabled || !action) {
	        return;
	      }
	
	      var pointers = this.pointers;
	      event.preventDefault();
	
	      if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
	        originalEvent: event,
	        action: action
	      }) === false) {
	        return;
	      }
	
	      if (event.changedTouches) {
	        forEach(event.changedTouches, function (touch) {
	          // The first parameter should not be undefined (#432)
	          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
	        });
	      } else {
	        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
	      }
	
	      this.change(event);
	    },
	    cropEnd: function cropEnd(event) {
	      if (this.disabled) {
	        return;
	      }
	
	      var action = this.action,
	          pointers = this.pointers;
	
	      if (event.changedTouches) {
	        forEach(event.changedTouches, function (touch) {
	          delete pointers[touch.identifier];
	        });
	      } else {
	        delete pointers[event.pointerId || 0];
	      }
	
	      if (!action) {
	        return;
	      }
	
	      event.preventDefault();
	
	      if (!Object.keys(pointers).length) {
	        this.action = '';
	      }
	
	      if (this.cropping) {
	        this.cropping = false;
	        toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
	      }
	
	      dispatchEvent(this.element, EVENT_CROP_END, {
	        originalEvent: event,
	        action: action
	      });
	    }
	  };
	
	  var change = {
	    change: function change(event) {
	      var options = this.options,
	          canvasData = this.canvasData,
	          containerData = this.containerData,
	          cropBoxData = this.cropBoxData,
	          pointers = this.pointers;
	      var action = this.action;
	      var aspectRatio = options.aspectRatio;
	      var left = cropBoxData.left,
	          top = cropBoxData.top,
	          width = cropBoxData.width,
	          height = cropBoxData.height;
	      var right = left + width;
	      var bottom = top + height;
	      var minLeft = 0;
	      var minTop = 0;
	      var maxWidth = containerData.width;
	      var maxHeight = containerData.height;
	      var renderable = true;
	      var offset; // Locking aspect ratio in "free mode" by holding shift key
	
	      if (!aspectRatio && event.shiftKey) {
	        aspectRatio = width && height ? width / height : 1;
	      }
	
	      if (this.limited) {
	        minLeft = cropBoxData.minLeft;
	        minTop = cropBoxData.minTop;
	        maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
	        maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
	      }
	
	      var pointer = pointers[Object.keys(pointers)[0]];
	      var range = {
	        x: pointer.endX - pointer.startX,
	        y: pointer.endY - pointer.startY
	      };
	
	      var check = function check(side) {
	        switch (side) {
	          case ACTION_EAST:
	            if (right + range.x > maxWidth) {
	              range.x = maxWidth - right;
	            }
	
	            break;
	
	          case ACTION_WEST:
	            if (left + range.x < minLeft) {
	              range.x = minLeft - left;
	            }
	
	            break;
	
	          case ACTION_NORTH:
	            if (top + range.y < minTop) {
	              range.y = minTop - top;
	            }
	
	            break;
	
	          case ACTION_SOUTH:
	            if (bottom + range.y > maxHeight) {
	              range.y = maxHeight - bottom;
	            }
	
	            break;
	
	          default:
	        }
	      };
	
	      switch (action) {
	        // Move crop box
	        case ACTION_ALL:
	          left += range.x;
	          top += range.y;
	          break;
	        // Resize crop box
	
	        case ACTION_EAST:
	          if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
	            renderable = false;
	            break;
	          }
	
	          check(ACTION_EAST);
	          width += range.x;
	
	          if (width < 0) {
	            action = ACTION_WEST;
	            width = -width;
	            left -= width;
	          }
	
	          if (aspectRatio) {
	            height = width / aspectRatio;
	            top += (cropBoxData.height - height) / 2;
	          }
	
	          break;
	
	        case ACTION_NORTH:
	          if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
	            renderable = false;
	            break;
	          }
	
	          check(ACTION_NORTH);
	          height -= range.y;
	          top += range.y;
	
	          if (height < 0) {
	            action = ACTION_SOUTH;
	            height = -height;
	            top -= height;
	          }
	
	          if (aspectRatio) {
	            width = height * aspectRatio;
	            left += (cropBoxData.width - width) / 2;
	          }
	
	          break;
	
	        case ACTION_WEST:
	          if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
	            renderable = false;
	            break;
	          }
	
	          check(ACTION_WEST);
	          width -= range.x;
	          left += range.x;
	
	          if (width < 0) {
	            action = ACTION_EAST;
	            width = -width;
	            left -= width;
	          }
	
	          if (aspectRatio) {
	            height = width / aspectRatio;
	            top += (cropBoxData.height - height) / 2;
	          }
	
	          break;
	
	        case ACTION_SOUTH:
	          if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
	            renderable = false;
	            break;
	          }
	
	          check(ACTION_SOUTH);
	          height += range.y;
	
	          if (height < 0) {
	            action = ACTION_NORTH;
	            height = -height;
	            top -= height;
	          }
	
	          if (aspectRatio) {
	            width = height * aspectRatio;
	            left += (cropBoxData.width - width) / 2;
	          }
	
	          break;
	
	        case ACTION_NORTH_EAST:
	          if (aspectRatio) {
	            if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
	              renderable = false;
	              break;
	            }
	
	            check(ACTION_NORTH);
	            height -= range.y;
	            top += range.y;
	            width = height * aspectRatio;
	          } else {
	            check(ACTION_NORTH);
	            check(ACTION_EAST);
	
	            if (range.x >= 0) {
	              if (right < maxWidth) {
	                width += range.x;
	              } else if (range.y <= 0 && top <= minTop) {
	                renderable = false;
	              }
	            } else {
	              width += range.x;
	            }
	
	            if (range.y <= 0) {
	              if (top > minTop) {
	                height -= range.y;
	                top += range.y;
	              }
	            } else {
	              height -= range.y;
	              top += range.y;
	            }
	          }
	
	          if (width < 0 && height < 0) {
	            action = ACTION_SOUTH_WEST;
	            height = -height;
	            width = -width;
	            top -= height;
	            left -= width;
	          } else if (width < 0) {
	            action = ACTION_NORTH_WEST;
	            width = -width;
	            left -= width;
	          } else if (height < 0) {
	            action = ACTION_SOUTH_EAST;
	            height = -height;
	            top -= height;
	          }
	
	          break;
	
	        case ACTION_NORTH_WEST:
	          if (aspectRatio) {
	            if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
	              renderable = false;
	              break;
	            }
	
	            check(ACTION_NORTH);
	            height -= range.y;
	            top += range.y;
	            width = height * aspectRatio;
	            left += cropBoxData.width - width;
	          } else {
	            check(ACTION_NORTH);
	            check(ACTION_WEST);
	
	            if (range.x <= 0) {
	              if (left > minLeft) {
	                width -= range.x;
	                left += range.x;
	              } else if (range.y <= 0 && top <= minTop) {
	                renderable = false;
	              }
	            } else {
	              width -= range.x;
	              left += range.x;
	            }
	
	            if (range.y <= 0) {
	              if (top > minTop) {
	                height -= range.y;
	                top += range.y;
	              }
	            } else {
	              height -= range.y;
	              top += range.y;
	            }
	          }
	
	          if (width < 0 && height < 0) {
	            action = ACTION_SOUTH_EAST;
	            height = -height;
	            width = -width;
	            top -= height;
	            left -= width;
	          } else if (width < 0) {
	            action = ACTION_NORTH_EAST;
	            width = -width;
	            left -= width;
	          } else if (height < 0) {
	            action = ACTION_SOUTH_WEST;
	            height = -height;
	            top -= height;
	          }
	
	          break;
	
	        case ACTION_SOUTH_WEST:
	          if (aspectRatio) {
	            if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
	              renderable = false;
	              break;
	            }
	
	            check(ACTION_WEST);
	            width -= range.x;
	            left += range.x;
	            height = width / aspectRatio;
	          } else {
	            check(ACTION_SOUTH);
	            check(ACTION_WEST);
	
	            if (range.x <= 0) {
	              if (left > minLeft) {
	                width -= range.x;
	                left += range.x;
	              } else if (range.y >= 0 && bottom >= maxHeight) {
	                renderable = false;
	              }
	            } else {
	              width -= range.x;
	              left += range.x;
	            }
	
	            if (range.y >= 0) {
	              if (bottom < maxHeight) {
	                height += range.y;
	              }
	            } else {
	              height += range.y;
	            }
	          }
	
	          if (width < 0 && height < 0) {
	            action = ACTION_NORTH_EAST;
	            height = -height;
	            width = -width;
	            top -= height;
	            left -= width;
	          } else if (width < 0) {
	            action = ACTION_SOUTH_EAST;
	            width = -width;
	            left -= width;
	          } else if (height < 0) {
	            action = ACTION_NORTH_WEST;
	            height = -height;
	            top -= height;
	          }
	
	          break;
	
	        case ACTION_SOUTH_EAST:
	          if (aspectRatio) {
	            if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
	              renderable = false;
	              break;
	            }
	
	            check(ACTION_EAST);
	            width += range.x;
	            height = width / aspectRatio;
	          } else {
	            check(ACTION_SOUTH);
	            check(ACTION_EAST);
	
	            if (range.x >= 0) {
	              if (right < maxWidth) {
	                width += range.x;
	              } else if (range.y >= 0 && bottom >= maxHeight) {
	                renderable = false;
	              }
	            } else {
	              width += range.x;
	            }
	
	            if (range.y >= 0) {
	              if (bottom < maxHeight) {
	                height += range.y;
	              }
	            } else {
	              height += range.y;
	            }
	          }
	
	          if (width < 0 && height < 0) {
	            action = ACTION_NORTH_WEST;
	            height = -height;
	            width = -width;
	            top -= height;
	            left -= width;
	          } else if (width < 0) {
	            action = ACTION_SOUTH_WEST;
	            width = -width;
	            left -= width;
	          } else if (height < 0) {
	            action = ACTION_NORTH_EAST;
	            height = -height;
	            top -= height;
	          }
	
	          break;
	        // Move canvas
	
	        case ACTION_MOVE:
	          this.move(range.x, range.y);
	          renderable = false;
	          break;
	        // Zoom canvas
	
	        case ACTION_ZOOM:
	          this.zoom(getMaxZoomRatio(pointers), event);
	          renderable = false;
	          break;
	        // Create crop box
	
	        case ACTION_CROP:
	          if (!range.x || !range.y) {
	            renderable = false;
	            break;
	          }
	
	          offset = getOffset(this.cropper);
	          left = pointer.startX - offset.left;
	          top = pointer.startY - offset.top;
	          width = cropBoxData.minWidth;
	          height = cropBoxData.minHeight;
	
	          if (range.x > 0) {
	            action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
	          } else if (range.x < 0) {
	            left -= width;
	            action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
	          }
	
	          if (range.y < 0) {
	            top -= height;
	          } // Show the crop box if is hidden
	
	
	          if (!this.cropped) {
	            removeClass(this.cropBox, CLASS_HIDDEN);
	            this.cropped = true;
	
	            if (this.limited) {
	              this.limitCropBox(true, true);
	            }
	          }
	
	          break;
	
	        default:
	      }
	
	      if (renderable) {
	        cropBoxData.width = width;
	        cropBoxData.height = height;
	        cropBoxData.left = left;
	        cropBoxData.top = top;
	        this.action = action;
	        this.renderCropBox();
	      } // Override
	
	
	      forEach(pointers, function (p) {
	        p.startX = p.endX;
	        p.startY = p.endY;
	      });
	    }
	  };
	
	  var methods = {
	    // Show the crop box manually
	    crop: function crop() {
	      if (this.ready && !this.cropped && !this.disabled) {
	        this.cropped = true;
	        this.limitCropBox(true, true);
	
	        if (this.options.modal) {
	          addClass(this.dragBox, CLASS_MODAL);
	        }
	
	        removeClass(this.cropBox, CLASS_HIDDEN);
	        this.setCropBoxData(this.initialCropBoxData);
	      }
	
	      return this;
	    },
	    // Reset the image and crop box to their initial states
	    reset: function reset() {
	      if (this.ready && !this.disabled) {
	        this.imageData = assign({}, this.initialImageData);
	        this.canvasData = assign({}, this.initialCanvasData);
	        this.cropBoxData = assign({}, this.initialCropBoxData);
	        this.renderCanvas();
	
	        if (this.cropped) {
	          this.renderCropBox();
	        }
	      }
	
	      return this;
	    },
	    // Clear the crop box
	    clear: function clear() {
	      if (this.cropped && !this.disabled) {
	        assign(this.cropBoxData, {
	          left: 0,
	          top: 0,
	          width: 0,
	          height: 0
	        });
	        this.cropped = false;
	        this.renderCropBox();
	        this.limitCanvas(true, true); // Render canvas after crop box rendered
	
	        this.renderCanvas();
	        removeClass(this.dragBox, CLASS_MODAL);
	        addClass(this.cropBox, CLASS_HIDDEN);
	      }
	
	      return this;
	    },
	
	    /**
	     * Replace the image's src and rebuild the cropper
	     * @param {string} url - The new URL.
	     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
	     * @returns {Cropper} this
	     */
	    replace: function replace(url) {
	      var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!this.disabled && url) {
	        if (this.isImg) {
	          this.element.src = url;
	        }
	
	        if (hasSameSize) {
	          this.url = url;
	          this.image.src = url;
	
	          if (this.ready) {
	            this.viewBoxImage.src = url;
	            forEach(this.previews, function (element) {
	              element.getElementsByTagName('img')[0].src = url;
	            });
	          }
	        } else {
	          if (this.isImg) {
	            this.replaced = true;
	          }
	
	          this.options.data = null;
	          this.uncreate();
	          this.load(url);
	        }
	      }
	
	      return this;
	    },
	    // Enable (unfreeze) the cropper
	    enable: function enable() {
	      if (this.ready && this.disabled) {
	        this.disabled = false;
	        removeClass(this.cropper, CLASS_DISABLED);
	      }
	
	      return this;
	    },
	    // Disable (freeze) the cropper
	    disable: function disable() {
	      if (this.ready && !this.disabled) {
	        this.disabled = true;
	        addClass(this.cropper, CLASS_DISABLED);
	      }
	
	      return this;
	    },
	
	    /**
	     * Destroy the cropper and remove the instance from the image
	     * @returns {Cropper} this
	     */
	    destroy: function destroy() {
	      var element = this.element;
	
	      if (!element[NAMESPACE]) {
	        return this;
	      }
	
	      element[NAMESPACE] = undefined;
	
	      if (this.isImg && this.replaced) {
	        element.src = this.originalUrl;
	      }
	
	      this.uncreate();
	      return this;
	    },
	
	    /**
	     * Move the canvas with relative offsets
	     * @param {number} offsetX - The relative offset distance on the x-axis.
	     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
	     * @returns {Cropper} this
	     */
	    move: function move(offsetX) {
	      var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
	      var _this$canvasData = this.canvasData,
	          left = _this$canvasData.left,
	          top = _this$canvasData.top;
	      return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
	    },
	
	    /**
	     * Move the canvas to an absolute point
	     * @param {number} x - The x-axis coordinate.
	     * @param {number} [y=x] - The y-axis coordinate.
	     * @returns {Cropper} this
	     */
	    moveTo: function moveTo(x) {
	      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
	      var canvasData = this.canvasData;
	      var changed = false;
	      x = Number(x);
	      y = Number(y);
	
	      if (this.ready && !this.disabled && this.options.movable) {
	        if (isNumber(x)) {
	          canvasData.left = x;
	          changed = true;
	        }
	
	        if (isNumber(y)) {
	          canvasData.top = y;
	          changed = true;
	        }
	
	        if (changed) {
	          this.renderCanvas(true);
	        }
	      }
	
	      return this;
	    },
	
	    /**
	     * Zoom the canvas with a relative ratio
	     * @param {number} ratio - The target ratio.
	     * @param {Event} _originalEvent - The original event if any.
	     * @returns {Cropper} this
	     */
	    zoom: function zoom(ratio, _originalEvent) {
	      var canvasData = this.canvasData;
	      ratio = Number(ratio);
	
	      if (ratio < 0) {
	        ratio = 1 / (1 - ratio);
	      } else {
	        ratio = 1 + ratio;
	      }
	
	      return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
	    },
	
	    /**
	     * Zoom the canvas to an absolute ratio
	     * @param {number} ratio - The target ratio.
	     * @param {Object} pivot - The zoom pivot point coordinate.
	     * @param {Event} _originalEvent - The original event if any.
	     * @returns {Cropper} this
	     */
	    zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
	      var options = this.options,
	          canvasData = this.canvasData;
	      var width = canvasData.width,
	          height = canvasData.height,
	          naturalWidth = canvasData.naturalWidth,
	          naturalHeight = canvasData.naturalHeight;
	      ratio = Number(ratio);
	
	      if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
	        var newWidth = naturalWidth * ratio;
	        var newHeight = naturalHeight * ratio;
	
	        if (dispatchEvent(this.element, EVENT_ZOOM, {
	          ratio: ratio,
	          oldRatio: width / naturalWidth,
	          originalEvent: _originalEvent
	        }) === false) {
	          return this;
	        }
	
	        if (_originalEvent) {
	          var pointers = this.pointers;
	          var offset = getOffset(this.cropper);
	          var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
	            pageX: _originalEvent.pageX,
	            pageY: _originalEvent.pageY
	          }; // Zoom from the triggering point of the event
	
	          canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
	          canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
	        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
	          canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
	          canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
	        } else {
	          // Zoom from the center of the canvas
	          canvasData.left -= (newWidth - width) / 2;
	          canvasData.top -= (newHeight - height) / 2;
	        }
	
	        canvasData.width = newWidth;
	        canvasData.height = newHeight;
	        this.renderCanvas(true);
	      }
	
	      return this;
	    },
	
	    /**
	     * Rotate the canvas with a relative degree
	     * @param {number} degree - The rotate degree.
	     * @returns {Cropper} this
	     */
	    rotate: function rotate(degree) {
	      return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
	    },
	
	    /**
	     * Rotate the canvas to an absolute degree
	     * @param {number} degree - The rotate degree.
	     * @returns {Cropper} this
	     */
	    rotateTo: function rotateTo(degree) {
	      degree = Number(degree);
	
	      if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
	        this.imageData.rotate = degree % 360;
	        this.renderCanvas(true, true);
	      }
	
	      return this;
	    },
	
	    /**
	     * Scale the image on the x-axis.
	     * @param {number} scaleX - The scale ratio on the x-axis.
	     * @returns {Cropper} this
	     */
	    scaleX: function scaleX(_scaleX) {
	      var scaleY = this.imageData.scaleY;
	      return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
	    },
	
	    /**
	     * Scale the image on the y-axis.
	     * @param {number} scaleY - The scale ratio on the y-axis.
	     * @returns {Cropper} this
	     */
	    scaleY: function scaleY(_scaleY) {
	      var scaleX = this.imageData.scaleX;
	      return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
	    },
	
	    /**
	     * Scale the image
	     * @param {number} scaleX - The scale ratio on the x-axis.
	     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
	     * @returns {Cropper} this
	     */
	    scale: function scale(scaleX) {
	      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
	      var imageData = this.imageData;
	      var transformed = false;
	      scaleX = Number(scaleX);
	      scaleY = Number(scaleY);
	
	      if (this.ready && !this.disabled && this.options.scalable) {
	        if (isNumber(scaleX)) {
	          imageData.scaleX = scaleX;
	          transformed = true;
	        }
	
	        if (isNumber(scaleY)) {
	          imageData.scaleY = scaleY;
	          transformed = true;
	        }
	
	        if (transformed) {
	          this.renderCanvas(true, true);
	        }
	      }
	
	      return this;
	    },
	
	    /**
	     * Get the cropped area position and size data (base on the original image)
	     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
	     * @returns {Object} The result cropped data.
	     */
	    getData: function getData() {
	      var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var options = this.options,
	          imageData = this.imageData,
	          canvasData = this.canvasData,
	          cropBoxData = this.cropBoxData;
	      var data;
	
	      if (this.ready && this.cropped) {
	        data = {
	          x: cropBoxData.left - canvasData.left,
	          y: cropBoxData.top - canvasData.top,
	          width: cropBoxData.width,
	          height: cropBoxData.height
	        };
	        var ratio = imageData.width / imageData.naturalWidth;
	        forEach(data, function (n, i) {
	          data[i] = n / ratio;
	        });
	
	        if (rounded) {
	          // In case rounding off leads to extra 1px in right or bottom border
	          // we should round the top-left corner and the dimension (#343).
	          var bottom = Math.round(data.y + data.height);
	          var right = Math.round(data.x + data.width);
	          data.x = Math.round(data.x);
	          data.y = Math.round(data.y);
	          data.width = right - data.x;
	          data.height = bottom - data.y;
	        }
	      } else {
	        data = {
	          x: 0,
	          y: 0,
	          width: 0,
	          height: 0
	        };
	      }
	
	      if (options.rotatable) {
	        data.rotate = imageData.rotate || 0;
	      }
	
	      if (options.scalable) {
	        data.scaleX = imageData.scaleX || 1;
	        data.scaleY = imageData.scaleY || 1;
	      }
	
	      return data;
	    },
	
	    /**
	     * Set the cropped area position and size with new data
	     * @param {Object} data - The new data.
	     * @returns {Cropper} this
	     */
	    setData: function setData(data) {
	      var options = this.options,
	          imageData = this.imageData,
	          canvasData = this.canvasData;
	      var cropBoxData = {};
	
	      if (this.ready && !this.disabled && isPlainObject(data)) {
	        var transformed = false;
	
	        if (options.rotatable) {
	          if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
	            imageData.rotate = data.rotate;
	            transformed = true;
	          }
	        }
	
	        if (options.scalable) {
	          if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
	            imageData.scaleX = data.scaleX;
	            transformed = true;
	          }
	
	          if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
	            imageData.scaleY = data.scaleY;
	            transformed = true;
	          }
	        }
	
	        if (transformed) {
	          this.renderCanvas(true, true);
	        }
	
	        var ratio = imageData.width / imageData.naturalWidth;
	
	        if (isNumber(data.x)) {
	          cropBoxData.left = data.x * ratio + canvasData.left;
	        }
	
	        if (isNumber(data.y)) {
	          cropBoxData.top = data.y * ratio + canvasData.top;
	        }
	
	        if (isNumber(data.width)) {
	          cropBoxData.width = data.width * ratio;
	        }
	
	        if (isNumber(data.height)) {
	          cropBoxData.height = data.height * ratio;
	        }
	
	        this.setCropBoxData(cropBoxData);
	      }
	
	      return this;
	    },
	
	    /**
	     * Get the container size data.
	     * @returns {Object} The result container data.
	     */
	    getContainerData: function getContainerData() {
	      return this.ready ? assign({}, this.containerData) : {};
	    },
	
	    /**
	     * Get the image position and size data.
	     * @returns {Object} The result image data.
	     */
	    getImageData: function getImageData() {
	      return this.sized ? assign({}, this.imageData) : {};
	    },
	
	    /**
	     * Get the canvas position and size data.
	     * @returns {Object} The result canvas data.
	     */
	    getCanvasData: function getCanvasData() {
	      var canvasData = this.canvasData;
	      var data = {};
	
	      if (this.ready) {
	        forEach(['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'], function (n) {
	          data[n] = canvasData[n];
	        });
	      }
	
	      return data;
	    },
	
	    /**
	     * Set the canvas position and size with new data.
	     * @param {Object} data - The new canvas data.
	     * @returns {Cropper} this
	     */
	    setCanvasData: function setCanvasData(data) {
	      var canvasData = this.canvasData;
	      var aspectRatio = canvasData.aspectRatio;
	
	      if (this.ready && !this.disabled && isPlainObject(data)) {
	        if (isNumber(data.left)) {
	          canvasData.left = data.left;
	        }
	
	        if (isNumber(data.top)) {
	          canvasData.top = data.top;
	        }
	
	        if (isNumber(data.width)) {
	          canvasData.width = data.width;
	          canvasData.height = data.width / aspectRatio;
	        } else if (isNumber(data.height)) {
	          canvasData.height = data.height;
	          canvasData.width = data.height * aspectRatio;
	        }
	
	        this.renderCanvas(true);
	      }
	
	      return this;
	    },
	
	    /**
	     * Get the crop box position and size data.
	     * @returns {Object} The result crop box data.
	     */
	    getCropBoxData: function getCropBoxData() {
	      var cropBoxData = this.cropBoxData;
	      var data;
	
	      if (this.ready && this.cropped) {
	        data = {
	          left: cropBoxData.left,
	          top: cropBoxData.top,
	          width: cropBoxData.width,
	          height: cropBoxData.height
	        };
	      }
	
	      return data || {};
	    },
	
	    /**
	     * Set the crop box position and size with new data.
	     * @param {Object} data - The new crop box data.
	     * @returns {Cropper} this
	     */
	    setCropBoxData: function setCropBoxData(data) {
	      var cropBoxData = this.cropBoxData;
	      var aspectRatio = this.options.aspectRatio;
	      var widthChanged;
	      var heightChanged;
	
	      if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
	        if (isNumber(data.left)) {
	          cropBoxData.left = data.left;
	        }
	
	        if (isNumber(data.top)) {
	          cropBoxData.top = data.top;
	        }
	
	        if (isNumber(data.width) && data.width !== cropBoxData.width) {
	          widthChanged = true;
	          cropBoxData.width = data.width;
	        }
	
	        if (isNumber(data.height) && data.height !== cropBoxData.height) {
	          heightChanged = true;
	          cropBoxData.height = data.height;
	        }
	
	        if (aspectRatio) {
	          if (widthChanged) {
	            cropBoxData.height = cropBoxData.width / aspectRatio;
	          } else if (heightChanged) {
	            cropBoxData.width = cropBoxData.height * aspectRatio;
	          }
	        }
	
	        this.renderCropBox();
	      }
	
	      return this;
	    },
	
	    /**
	     * Get a canvas drawn the cropped image.
	     * @param {Object} [options={}] - The config options.
	     * @returns {HTMLCanvasElement} - The result canvas.
	     */
	    getCroppedCanvas: function getCroppedCanvas() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (!this.ready || !window.HTMLCanvasElement) {
	        return null;
	      }
	
	      var canvasData = this.canvasData;
	      var source = getSourceCanvas(this.image, this.imageData, canvasData, options); // Returns the source canvas if it is not cropped.
	
	      if (!this.cropped) {
	        return source;
	      }
	
	      var _this$getData = this.getData(),
	          initialX = _this$getData.x,
	          initialY = _this$getData.y,
	          initialWidth = _this$getData.width,
	          initialHeight = _this$getData.height;
	
	      var ratio = source.width / Math.floor(canvasData.naturalWidth);
	
	      if (ratio !== 1) {
	        initialX *= ratio;
	        initialY *= ratio;
	        initialWidth *= ratio;
	        initialHeight *= ratio;
	      }
	
	      var aspectRatio = initialWidth / initialHeight;
	      var maxSizes = getAdjustedSizes({
	        aspectRatio: aspectRatio,
	        width: options.maxWidth || Infinity,
	        height: options.maxHeight || Infinity
	      });
	      var minSizes = getAdjustedSizes({
	        aspectRatio: aspectRatio,
	        width: options.minWidth || 0,
	        height: options.minHeight || 0
	      }, 'cover');
	
	      var _getAdjustedSizes = getAdjustedSizes({
	        aspectRatio: aspectRatio,
	        width: options.width || (ratio !== 1 ? source.width : initialWidth),
	        height: options.height || (ratio !== 1 ? source.height : initialHeight)
	      }),
	          width = _getAdjustedSizes.width,
	          height = _getAdjustedSizes.height;
	
	      width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
	      height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
	      var canvas = document.createElement('canvas');
	      var context = canvas.getContext('2d');
	      canvas.width = normalizeDecimalNumber(width);
	      canvas.height = normalizeDecimalNumber(height);
	      context.fillStyle = options.fillColor || 'transparent';
	      context.fillRect(0, 0, width, height);
	      var _options$imageSmoothi = options.imageSmoothingEnabled,
	          imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi,
	          imageSmoothingQuality = options.imageSmoothingQuality;
	      context.imageSmoothingEnabled = imageSmoothingEnabled;
	
	      if (imageSmoothingQuality) {
	        context.imageSmoothingQuality = imageSmoothingQuality;
	      } // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
	
	
	      var sourceWidth = source.width;
	      var sourceHeight = source.height; // Source canvas parameters
	
	      var srcX = initialX;
	      var srcY = initialY;
	      var srcWidth;
	      var srcHeight; // Destination canvas parameters
	
	      var dstX;
	      var dstY;
	      var dstWidth;
	      var dstHeight;
	
	      if (srcX <= -initialWidth || srcX > sourceWidth) {
	        srcX = 0;
	        srcWidth = 0;
	        dstX = 0;
	        dstWidth = 0;
	      } else if (srcX <= 0) {
	        dstX = -srcX;
	        srcX = 0;
	        srcWidth = Math.min(sourceWidth, initialWidth + srcX);
	        dstWidth = srcWidth;
	      } else if (srcX <= sourceWidth) {
	        dstX = 0;
	        srcWidth = Math.min(initialWidth, sourceWidth - srcX);
	        dstWidth = srcWidth;
	      }
	
	      if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
	        srcY = 0;
	        srcHeight = 0;
	        dstY = 0;
	        dstHeight = 0;
	      } else if (srcY <= 0) {
	        dstY = -srcY;
	        srcY = 0;
	        srcHeight = Math.min(sourceHeight, initialHeight + srcY);
	        dstHeight = srcHeight;
	      } else if (srcY <= sourceHeight) {
	        dstY = 0;
	        srcHeight = Math.min(initialHeight, sourceHeight - srcY);
	        dstHeight = srcHeight;
	      }
	
	      var params = [srcX, srcY, srcWidth, srcHeight]; // Avoid "IndexSizeError"
	
	      if (dstWidth > 0 && dstHeight > 0) {
	        var scale = width / initialWidth;
	        params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
	      } // All the numerical parameters should be integer for `drawImage`
	      // https://github.com/fengyuanchen/cropper/issues/476
	
	
	      context.drawImage.apply(context, [source].concat(_toConsumableArray(params.map(function (param) {
	        return Math.floor(normalizeDecimalNumber(param));
	      }))));
	      return canvas;
	    },
	
	    /**
	     * Change the aspect ratio of the crop box.
	     * @param {number} aspectRatio - The new aspect ratio.
	     * @returns {Cropper} this
	     */
	    setAspectRatio: function setAspectRatio(aspectRatio) {
	      var options = this.options;
	
	      if (!this.disabled && !isUndefined(aspectRatio)) {
	        // 0 -> NaN
	        options.aspectRatio = Math.max(0, aspectRatio) || NaN;
	
	        if (this.ready) {
	          this.initCropBox();
	
	          if (this.cropped) {
	            this.renderCropBox();
	          }
	        }
	      }
	
	      return this;
	    },
	
	    /**
	     * Change the drag mode.
	     * @param {string} mode - The new drag mode.
	     * @returns {Cropper} this
	     */
	    setDragMode: function setDragMode(mode) {
	      var options = this.options,
	          dragBox = this.dragBox,
	          face = this.face;
	
	      if (this.ready && !this.disabled) {
	        var croppable = mode === DRAG_MODE_CROP;
	        var movable = options.movable && mode === DRAG_MODE_MOVE;
	        mode = croppable || movable ? mode : DRAG_MODE_NONE;
	        options.dragMode = mode;
	        setData(dragBox, DATA_ACTION, mode);
	        toggleClass(dragBox, CLASS_CROP, croppable);
	        toggleClass(dragBox, CLASS_MOVE, movable);
	
	        if (!options.cropBoxMovable) {
	          // Sync drag mode to crop box when it is not movable
	          setData(face, DATA_ACTION, mode);
	          toggleClass(face, CLASS_CROP, croppable);
	          toggleClass(face, CLASS_MOVE, movable);
	        }
	      }
	
	      return this;
	    }
	  };
	
	  var AnotherCropper = WINDOW.Cropper;
	
	  var Cropper =
	  /*#__PURE__*/
	  function () {
	    /**
	     * Create a new Cropper.
	     * @param {Element} element - The target element for cropping.
	     * @param {Object} [options={}] - The configuration options.
	     */
	    function Cropper(element) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _classCallCheck(this, Cropper);
	
	      if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
	        throw new Error('The first argument is required and must be an <img> or <canvas> element.');
	      }
	
	      this.element = element;
	      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
	      this.cropped = false;
	      this.disabled = false;
	      this.pointers = {};
	      this.ready = false;
	      this.reloading = false;
	      this.replaced = false;
	      this.sized = false;
	      this.sizing = false;
	      this.init();
	    }
	
	    _createClass(Cropper, [{
	      key: "init",
	      value: function init() {
	        var element = this.element;
	        var tagName = element.tagName.toLowerCase();
	        var url;
	
	        if (element[NAMESPACE]) {
	          return;
	        }
	
	        element[NAMESPACE] = this;
	
	        if (tagName === 'img') {
	          this.isImg = true; // e.g.: "img/picture.jpg"
	
	          url = element.getAttribute('src') || '';
	          this.originalUrl = url; // Stop when it's a blank image
	
	          if (!url) {
	            return;
	          } // e.g.: "http://example.com/img/picture.jpg"
	
	
	          url = element.src;
	        } else if (tagName === 'canvas' && window.HTMLCanvasElement) {
	          url = element.toDataURL();
	        }
	
	        this.load(url);
	      }
	    }, {
	      key: "load",
	      value: function load(url) {
	        var _this = this;
	
	        if (!url) {
	          return;
	        }
	
	        this.url = url;
	        this.imageData = {};
	        var element = this.element,
	            options = this.options;
	
	        if (!options.rotatable && !options.scalable) {
	          options.checkOrientation = false;
	        } // Only IE10+ supports Typed Arrays
	
	
	        if (!options.checkOrientation || !window.ArrayBuffer) {
	          this.clone();
	          return;
	        } // Detect the mime type of the image directly if it is a Data URL
	
	
	        if (REGEXP_DATA_URL.test(url)) {
	          // Read ArrayBuffer from Data URL of JPEG images directly for better performance
	          if (REGEXP_DATA_URL_JPEG.test(url)) {
	            this.read(dataURLToArrayBuffer(url));
	          } else {
	            // Only a JPEG image may contains Exif Orientation information,
	            // the rest types of Data URLs are not necessary to check orientation at all.
	            this.clone();
	          }
	
	          return;
	        } // 1. Detect the mime type of the image by a XMLHttpRequest.
	        // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.
	
	
	        var xhr = new XMLHttpRequest();
	        var clone = this.clone.bind(this);
	        this.reloading = true;
	        this.xhr = xhr; // 1. Cross origin requests are only supported for protocol schemes:
	        // http, https, data, chrome, chrome-extension.
	        // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
	        // in some browsers as IE11 and Safari.
	
	        xhr.onabort = clone;
	        xhr.onerror = clone;
	        xhr.ontimeout = clone;
	
	        xhr.onprogress = function () {
	          // Abort the request directly if it not a JPEG image for better performance
	          if (xhr.getResponseHeader('content-type') !== MIME_TYPE_JPEG) {
	            xhr.abort();
	          }
	        };
	
	        xhr.onload = function () {
	          _this.read(xhr.response);
	        };
	
	        xhr.onloadend = function () {
	          _this.reloading = false;
	          _this.xhr = null;
	        }; // Bust cache when there is a "crossOrigin" property to avoid browser cache error
	
	
	        if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) {
	          url = addTimestamp(url);
	        }
	
	        xhr.open('GET', url);
	        xhr.responseType = 'arraybuffer';
	        xhr.withCredentials = element.crossOrigin === 'use-credentials';
	        xhr.send();
	      }
	    }, {
	      key: "read",
	      value: function read(arrayBuffer) {
	        var options = this.options,
	            imageData = this.imageData; // Reset the orientation value to its default value 1
	        // as some iOS browsers will render image with its orientation
	
	        var orientation = resetAndGetOrientation(arrayBuffer);
	        var rotate = 0;
	        var scaleX = 1;
	        var scaleY = 1;
	
	        if (orientation > 1) {
	          // Generate a new URL which has the default orientation value
	          this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
	
	          var _parseOrientation = parseOrientation(orientation);
	
	          rotate = _parseOrientation.rotate;
	          scaleX = _parseOrientation.scaleX;
	          scaleY = _parseOrientation.scaleY;
	        }
	
	        if (options.rotatable) {
	          imageData.rotate = rotate;
	        }
	
	        if (options.scalable) {
	          imageData.scaleX = scaleX;
	          imageData.scaleY = scaleY;
	        }
	
	        this.clone();
	      }
	    }, {
	      key: "clone",
	      value: function clone() {
	        var element = this.element,
	            url = this.url;
	        var crossOrigin = element.crossOrigin;
	        var crossOriginUrl = url;
	
	        if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
	          if (!crossOrigin) {
	            crossOrigin = 'anonymous';
	          } // Bust cache when there is not a "crossOrigin" property (#519)
	
	
	          crossOriginUrl = addTimestamp(url);
	        }
	
	        this.crossOrigin = crossOrigin;
	        this.crossOriginUrl = crossOriginUrl;
	        var image = document.createElement('img');
	
	        if (crossOrigin) {
	          image.crossOrigin = crossOrigin;
	        }
	
	        image.src = crossOriginUrl || url;
	        image.alt = element.alt || 'The image to crop';
	        this.image = image;
	        image.onload = this.start.bind(this);
	        image.onerror = this.stop.bind(this);
	        addClass(image, CLASS_HIDE);
	        element.parentNode.insertBefore(image, element.nextSibling);
	      }
	    }, {
	      key: "start",
	      value: function start() {
	        var _this2 = this;
	
	        var image = this.image;
	        image.onload = null;
	        image.onerror = null;
	        this.sizing = true; // Match all browsers that use WebKit as the layout engine in iOS devices,
	        // such as Safari for iOS, Chrome for iOS, and in-app browsers.
	
	        var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
	
	        var done = function done(naturalWidth, naturalHeight) {
	          assign(_this2.imageData, {
	            naturalWidth: naturalWidth,
	            naturalHeight: naturalHeight,
	            aspectRatio: naturalWidth / naturalHeight
	          });
	          _this2.sizing = false;
	          _this2.sized = true;
	
	          _this2.build();
	        }; // Most modern browsers (excepts iOS WebKit)
	
	
	        if (image.naturalWidth && !isIOSWebKit) {
	          done(image.naturalWidth, image.naturalHeight);
	          return;
	        }
	
	        var sizingImage = document.createElement('img');
	        var body = document.body || document.documentElement;
	        this.sizingImage = sizingImage;
	
	        sizingImage.onload = function () {
	          done(sizingImage.width, sizingImage.height);
	
	          if (!isIOSWebKit) {
	            body.removeChild(sizingImage);
	          }
	        };
	
	        sizingImage.src = image.src; // iOS WebKit will convert the image automatically
	        // with its orientation once append it into DOM (#279)
	
	        if (!isIOSWebKit) {
	          sizingImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
	          body.appendChild(sizingImage);
	        }
	      }
	    }, {
	      key: "stop",
	      value: function stop() {
	        var image = this.image;
	        image.onload = null;
	        image.onerror = null;
	        image.parentNode.removeChild(image);
	        this.image = null;
	      }
	    }, {
	      key: "build",
	      value: function build() {
	        if (!this.sized || this.ready) {
	          return;
	        }
	
	        var element = this.element,
	            options = this.options,
	            image = this.image; // Create cropper elements
	
	        var container = element.parentNode;
	        var template = document.createElement('div');
	        template.innerHTML = TEMPLATE;
	        var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
	        var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
	        var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
	        var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
	        var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
	        this.container = container;
	        this.cropper = cropper;
	        this.canvas = canvas;
	        this.dragBox = dragBox;
	        this.cropBox = cropBox;
	        this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
	        this.face = face;
	        canvas.appendChild(image); // Hide the original image
	
	        addClass(element, CLASS_HIDDEN); // Inserts the cropper after to the current image
	
	        container.insertBefore(cropper, element.nextSibling); // Show the image if is hidden
	
	        if (!this.isImg) {
	          removeClass(image, CLASS_HIDE);
	        }
	
	        this.initPreview();
	        this.bind();
	        options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
	        options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
	        options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
	        addClass(cropBox, CLASS_HIDDEN);
	
	        if (!options.guides) {
	          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
	        }
	
	        if (!options.center) {
	          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
	        }
	
	        if (options.background) {
	          addClass(cropper, "".concat(NAMESPACE, "-bg"));
	        }
	
	        if (!options.highlight) {
	          addClass(face, CLASS_INVISIBLE);
	        }
	
	        if (options.cropBoxMovable) {
	          addClass(face, CLASS_MOVE);
	          setData(face, DATA_ACTION, ACTION_ALL);
	        }
	
	        if (!options.cropBoxResizable) {
	          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
	          addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
	        }
	
	        this.render();
	        this.ready = true;
	        this.setDragMode(options.dragMode);
	
	        if (options.autoCrop) {
	          this.crop();
	        }
	
	        this.setData(options.data);
	
	        if (isFunction(options.ready)) {
	          addListener(element, EVENT_READY, options.ready, {
	            once: true
	          });
	        }
	
	        dispatchEvent(element, EVENT_READY);
	      }
	    }, {
	      key: "unbuild",
	      value: function unbuild() {
	        if (!this.ready) {
	          return;
	        }
	
	        this.ready = false;
	        this.unbind();
	        this.resetPreview();
	        this.cropper.parentNode.removeChild(this.cropper);
	        removeClass(this.element, CLASS_HIDDEN);
	      }
	    }, {
	      key: "uncreate",
	      value: function uncreate() {
	        if (this.ready) {
	          this.unbuild();
	          this.ready = false;
	          this.cropped = false;
	        } else if (this.sizing) {
	          this.sizingImage.onload = null;
	          this.sizing = false;
	          this.sized = false;
	        } else if (this.reloading) {
	          this.xhr.onabort = null;
	          this.xhr.abort();
	        } else if (this.image) {
	          this.stop();
	        }
	      }
	      /**
	       * Get the no conflict cropper class.
	       * @returns {Cropper} The cropper class.
	       */
	
	    }], [{
	      key: "noConflict",
	      value: function noConflict() {
	        window.Cropper = AnotherCropper;
	        return Cropper;
	      }
	      /**
	       * Change the default options.
	       * @param {Object} options - The new default options.
	       */
	
	    }, {
	      key: "setDefaults",
	      value: function setDefaults(options) {
	        assign(DEFAULTS, isPlainObject(options) && options);
	      }
	    }]);
	
	    return Cropper;
	  }();
	
	  assign(Cropper.prototype, render, preview, events, handlers, change, methods);
	
	  return Cropper;
	
	}));


/***/ }),
/* 4610 */,
/* 4611 */,
/* 4612 */,
/* 4613 */,
/* 4614 */,
/* 4615 */,
/* 4616 */,
/* 4617 */,
/* 4618 */,
/* 4619 */,
/* 4620 */,
/* 4621 */,
/* 4622 */,
/* 4623 */,
/* 4624 */,
/* 4625 */,
/* 4626 */,
/* 4627 */,
/* 4628 */,
/* 4629 */,
/* 4630 */,
/* 4631 */,
/* 4632 */,
/* 4633 */,
/* 4634 */,
/* 4635 */,
/* 4636 */,
/* 4637 */,
/* 4638 */,
/* 4639 */,
/* 4640 */,
/* 4641 */,
/* 4642 */,
/* 4643 */,
/* 4644 */,
/* 4645 */,
/* 4646 */,
/* 4647 */,
/* 4648 */,
/* 4649 */,
/* 4650 */,
/* 4651 */,
/* 4652 */,
/* 4653 */,
/* 4654 */,
/* 4655 */,
/* 4656 */,
/* 4657 */,
/* 4658 */,
/* 4659 */,
/* 4660 */,
/* 4661 */,
/* 4662 */,
/* 4663 */,
/* 4664 */,
/* 4665 */,
/* 4666 */,
/* 4667 */,
/* 4668 */,
/* 4669 */,
/* 4670 */,
/* 4671 */,
/* 4672 */,
/* 4673 */,
/* 4674 */,
/* 4675 */,
/* 4676 */,
/* 4677 */,
/* 4678 */,
/* 4679 */,
/* 4680 */,
/* 4681 */,
/* 4682 */,
/* 4683 */,
/* 4684 */,
/* 4685 */,
/* 4686 */,
/* 4687 */,
/* 4688 */,
/* 4689 */,
/* 4690 */,
/* 4691 */,
/* 4692 */,
/* 4693 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = camelize;
	var regExp = /[-\s]+(.)?/g;
	
	/**
	 * Convert dash separated strings to camel cased.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}

/***/ }),
/* 4694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;
	
	var _prefix = __webpack_require__(1466);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	var _supportedProperty = __webpack_require__(4695);
	
	var _supportedProperty2 = _interopRequireDefault(_supportedProperty);
	
	var _supportedValue = __webpack_require__(4696);
	
	var _supportedValue2 = _interopRequireDefault(_supportedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  prefix: _prefix2['default'],
	  supportedProperty: _supportedProperty2['default'],
	  supportedValue: _supportedValue2['default']
	}; /**
	    * CSS Vendor prefix detection and property feature testing.
	    *
	    * @copyright Oleg Slobodskoi 2015
	    * @website https://github.com/jsstyles/css-vendor
	    * @license MIT
	    */
	
	exports.prefix = _prefix2['default'];
	exports.supportedProperty = _supportedProperty2['default'];
	exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 4695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = supportedProperty;
	
	var _isInBrowser = __webpack_require__(965);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _prefix = __webpack_require__(1466);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	var _camelize = __webpack_require__(4693);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var el = void 0;
	var cache = {};
	
	if (_isInBrowser2['default']) {
	  el = document.createElement('p');
	
	  /**
	   * We test every property on vendor prefix requirement.
	   * Once tested, result is cached. It gives us up to 70% perf boost.
	   * http://jsperf.com/element-style-object-access-vs-plain-object
	   *
	   * Prefill cache with known css properties to reduce amount of
	   * properties we need to feature test at runtime.
	   * http://davidwalsh.name/vendor-prefix
	   */
	  var computed = window.getComputedStyle(document.documentElement, '');
	  for (var key in computed) {
	    if (!isNaN(key)) cache[computed[key]] = computed[key];
	  }
	}
	
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @return {String|Boolean}
	 * @api public
	 */
	function supportedProperty(prop) {
	  // For server-side rendering.
	  if (!el) return prop;
	
	  // We have not tested this prop yet, lets do the test.
	  if (cache[prop] != null) return cache[prop];
	
	  // Camelization is required because we can't test using
	  // css syntax for e.g. in FF.
	  // Test if property is supported as it is.
	  if ((0, _camelize2['default'])(prop) in el.style) {
	    cache[prop] = prop;
	  }
	  // Test if property is supported with vendor prefix.
	  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
	      cache[prop] = _prefix2['default'].css + prop;
	    } else {
	      cache[prop] = false;
	    }
	
	  return cache[prop];
	}

/***/ }),
/* 4696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = supportedValue;
	
	var _isInBrowser = __webpack_require__(965);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _prefix = __webpack_require__(1466);
	
	var _prefix2 = _interopRequireDefault(_prefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var cache = {};
	var el = void 0;
	
	if (_isInBrowser2['default']) el = document.createElement('p');
	
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	function supportedValue(property, value) {
	  // For server-side rendering.
	  if (!el) return value;
	
	  // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;
	
	  var cacheKey = property + value;
	
	  if (cache[cacheKey] != null) return cache[cacheKey];
	
	  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
	  try {
	    // Test value as it is.
	    el.style[property] = value;
	  } catch (err) {
	    cache[cacheKey] = false;
	    return false;
	  }
	
	  // Value is supported as it is.
	  if (el.style[property] !== '') {
	    cache[cacheKey] = value;
	  } else {
	    // Test value with vendor prefix.
	    value = _prefix2['default'].css + value;
	
	    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	    if (value === '-ms-flex') value = '-ms-flexbox';
	
	    el.style[property] = value;
	
	    // Value is supported with vendor prefix.
	    if (el.style[property] !== '') cache[cacheKey] = value;
	  }
	
	  if (!cache[cacheKey]) cache[cacheKey] = false;
	
	  // Reset style value.
	  el.style[property] = '';
	
	  return cache[cacheKey];
	}

/***/ }),
/* 4697 */
/***/ (function(module, exports) {

	var MILLISECONDS_IN_MINUTE = 60000
	
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
	  var date = new Date(dirtyDate.getTime())
	  var baseTimezoneOffset = date.getTimezoneOffset()
	  date.setSeconds(0, 0)
	  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE
	
	  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
	}


/***/ }),
/* 4698 */
/***/ (function(module, exports, __webpack_require__) {

	var addMilliseconds = __webpack_require__(4699)
	
	var MILLISECONDS_IN_HOUR = 3600000
	
	/**
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added
	 * @returns {Date} the new date with the hours added
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	function addHours (dirtyDate, dirtyAmount) {
	  var amount = Number(dirtyAmount)
	  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
	}
	
	module.exports = addHours


/***/ }),
/* 4699 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	
	/**
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added
	 * @returns {Date} the new date with the milliseconds added
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds (dirtyDate, dirtyAmount) {
	  var timestamp = parse(dirtyDate).getTime()
	  var amount = Number(dirtyAmount)
	  return new Date(timestamp + amount)
	}
	
	module.exports = addMilliseconds


/***/ }),
/* 4700 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	
	/**
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
	  var dateLeft = parse(dirtyDateLeft)
	  var dateRight = parse(dirtyDateRight)
	
	  return dateLeft.getFullYear() - dateRight.getFullYear()
	}
	
	module.exports = differenceInCalendarYears


/***/ }),
/* 4701 */
/***/ (function(module, exports, __webpack_require__) {

	var differenceInMilliseconds = __webpack_require__(2173)
	
	var MILLISECONDS_IN_HOUR = 3600000
	
	/**
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of hours
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * var result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	function differenceInHours (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInHours


/***/ }),
/* 4702 */
/***/ (function(module, exports, __webpack_require__) {

	var differenceInMilliseconds = __webpack_require__(2173)
	
	var MILLISECONDS_IN_MINUTE = 60000
	
	/**
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the number of minutes between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of minutes
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * var result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 */
	function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInMinutes


/***/ }),
/* 4703 */
/***/ (function(module, exports, __webpack_require__) {

	var differenceInDays = __webpack_require__(2172)
	
	/**
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between the given dates.
	 *
	 * @param {Date|String|Number} dateLeft - the later date
	 * @param {Date|String|Number} dateRight - the earlier date
	 * @returns {Number} the number of full weeks
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 2
	 */
	function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
	  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
	}
	
	module.exports = differenceInWeeks


/***/ }),
/* 4704 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	var startOfYear = __webpack_require__(4715)
	var differenceInCalendarDays = __webpack_require__(2171)
	
	/**
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the day of year
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * var result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear (dirtyDate) {
	  var date = parse(dirtyDate)
	  var diff = differenceInCalendarDays(date, startOfYear(date))
	  var dayOfYear = diff + 1
	  return dayOfYear
	}
	
	module.exports = getDayOfYear


/***/ }),
/* 4705 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	var startOfISOWeek = __webpack_require__(1467)
	var startOfISOYear = __webpack_require__(4713)
	
	var MILLISECONDS_IN_WEEK = 604800000
	
	/**
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the given date
	 * @returns {Number} the ISO week
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * var result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	function getISOWeek (dirtyDate) {
	  var date = parse(dirtyDate)
	  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
	}
	
	module.exports = getISOWeek


/***/ }),
/* 4706 */,
/* 4707 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	
	/**
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * @param {Date|String|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * var result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture (dirtyDate) {
	  return parse(dirtyDate).getTime() > new Date().getTime()
	}
	
	module.exports = isFuture


/***/ }),
/* 4708 */
/***/ (function(module, exports, __webpack_require__) {

	var isDate = __webpack_require__(2176)
	
	/**
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {Date} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} argument must be an instance of Date
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid (dirtyDate) {
	  if (isDate(dirtyDate)) {
	    return !isNaN(dirtyDate)
	  } else {
	    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
	  }
	}
	
	module.exports = isValid


/***/ }),
/* 4709 */
/***/ (function(module, exports) {

	var commonFormatterKeys = [
	  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
	  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
	  'H', 'HH', 'h', 'hh', 'm', 'mm',
	  's', 'ss', 'S', 'SS', 'SSS',
	  'Z', 'ZZ', 'X', 'x'
	]
	
	function buildFormattingTokensRegExp (formatters) {
	  var formatterKeys = []
	  for (var key in formatters) {
	    if (formatters.hasOwnProperty(key)) {
	      formatterKeys.push(key)
	    }
	  }
	
	  var formattingTokens = commonFormatterKeys
	    .concat(formatterKeys)
	    .sort()
	    .reverse()
	  var formattingTokensRegExp = new RegExp(
	    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
	  )
	
	  return formattingTokensRegExp
	}
	
	module.exports = buildFormattingTokensRegExp


/***/ }),
/* 4710 */
/***/ (function(module, exports) {

	function buildDistanceInWordsLocale () {
	  var distanceInWordsLocale = {
	    lessThanXSeconds: {
	      one: 'less than a second',
	      other: 'less than {{count}} seconds'
	    },
	
	    xSeconds: {
	      one: '1 second',
	      other: '{{count}} seconds'
	    },
	
	    halfAMinute: 'half a minute',
	
	    lessThanXMinutes: {
	      one: 'less than a minute',
	      other: 'less than {{count}} minutes'
	    },
	
	    xMinutes: {
	      one: '1 minute',
	      other: '{{count}} minutes'
	    },
	
	    aboutXHours: {
	      one: 'about 1 hour',
	      other: 'about {{count}} hours'
	    },
	
	    xHours: {
	      one: '1 hour',
	      other: '{{count}} hours'
	    },
	
	    xDays: {
	      one: '1 day',
	      other: '{{count}} days'
	    },
	
	    aboutXMonths: {
	      one: 'about 1 month',
	      other: 'about {{count}} months'
	    },
	
	    xMonths: {
	      one: '1 month',
	      other: '{{count}} months'
	    },
	
	    aboutXYears: {
	      one: 'about 1 year',
	      other: 'about {{count}} years'
	    },
	
	    xYears: {
	      one: '1 year',
	      other: '{{count}} years'
	    },
	
	    overXYears: {
	      one: 'over 1 year',
	      other: 'over {{count}} years'
	    },
	
	    almostXYears: {
	      one: 'almost 1 year',
	      other: 'almost {{count}} years'
	    }
	  }
	
	  function localize (token, count, options) {
	    options = options || {}
	
	    var result
	    if (typeof distanceInWordsLocale[token] === 'string') {
	      result = distanceInWordsLocale[token]
	    } else if (count === 1) {
	      result = distanceInWordsLocale[token].one
	    } else {
	      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
	    }
	
	    if (options.addSuffix) {
	      if (options.comparison > 0) {
	        return 'in ' + result
	      } else {
	        return result + ' ago'
	      }
	    }
	
	    return result
	  }
	
	  return {
	    localize: localize
	  }
	}
	
	module.exports = buildDistanceInWordsLocale


/***/ }),
/* 4711 */
/***/ (function(module, exports, __webpack_require__) {

	var buildFormattingTokensRegExp = __webpack_require__(4709)
	
	function buildFormatLocale () {
	  // Note: in English, the names of days of the week and months are capitalized.
	  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
	  // Generally, formatted dates should look like they are in the middle of a sentence,
	  // e.g. in Spanish language the weekdays and months should be in the lowercase.
	  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
	  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
	  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
	  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	  var meridiemUppercase = ['AM', 'PM']
	  var meridiemLowercase = ['am', 'pm']
	  var meridiemFull = ['a.m.', 'p.m.']
	
	  var formatters = {
	    // Month: Jan, Feb, ..., Dec
	    'MMM': function (date) {
	      return months3char[date.getMonth()]
	    },
	
	    // Month: January, February, ..., December
	    'MMMM': function (date) {
	      return monthsFull[date.getMonth()]
	    },
	
	    // Day of week: Su, Mo, ..., Sa
	    'dd': function (date) {
	      return weekdays2char[date.getDay()]
	    },
	
	    // Day of week: Sun, Mon, ..., Sat
	    'ddd': function (date) {
	      return weekdays3char[date.getDay()]
	    },
	
	    // Day of week: Sunday, Monday, ..., Saturday
	    'dddd': function (date) {
	      return weekdaysFull[date.getDay()]
	    },
	
	    // AM, PM
	    'A': function (date) {
	      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
	    },
	
	    // am, pm
	    'a': function (date) {
	      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
	    },
	
	    // a.m., p.m.
	    'aa': function (date) {
	      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
	    }
	  }
	
	  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
	  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
	  ordinalFormatters.forEach(function (formatterToken) {
	    formatters[formatterToken + 'o'] = function (date, formatters) {
	      return ordinal(formatters[formatterToken](date))
	    }
	  })
	
	  return {
	    formatters: formatters,
	    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
	  }
	}
	
	function ordinal (number) {
	  var rem100 = number % 100
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st'
	      case 2:
	        return number + 'nd'
	      case 3:
	        return number + 'rd'
	    }
	  }
	  return number + 'th'
	}
	
	module.exports = buildFormatLocale


/***/ }),
/* 4712 */
/***/ (function(module, exports, __webpack_require__) {

	var buildDistanceInWordsLocale = __webpack_require__(4710)
	var buildFormatLocale = __webpack_require__(4711)
	
	/**
	 * @category Locales
	 * @summary English locale.
	 */
	module.exports = {
	  distanceInWords: buildDistanceInWordsLocale(),
	  format: buildFormatLocale()
	}


/***/ }),
/* 4713 */
/***/ (function(module, exports, __webpack_require__) {

	var getISOYear = __webpack_require__(2175)
	var startOfISOWeek = __webpack_require__(1467)
	
	/**
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of an ISO year
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * var result = startOfISOYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOYear (dirtyDate) {
	  var year = getISOYear(dirtyDate)
	  var fourthOfJanuary = new Date(0)
	  fourthOfJanuary.setFullYear(year, 0, 4)
	  fourthOfJanuary.setHours(0, 0, 0, 0)
	  var date = startOfISOWeek(fourthOfJanuary)
	  return date
	}
	
	module.exports = startOfISOYear


/***/ }),
/* 4714 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	
	/**
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {Object} [options] - the object with options
	 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek (dirtyDate, dirtyOptions) {
	  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
	
	  var date = parse(dirtyDate)
	  var day = date.getDay()
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn
	
	  date.setDate(date.getDate() - diff)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfWeek


/***/ }),
/* 4715 */
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(162)
	
	/**
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @returns {Date} the start of a year
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear (dirtyDate) {
	  var cleanDate = parse(dirtyDate)
	  var date = new Date(0)
	  date.setFullYear(cleanDate.getFullYear(), 0, 1)
	  date.setHours(0, 0, 0, 0)
	  return date
	}
	
	module.exports = startOfYear


/***/ }),
/* 4716 */
[6633, 2181, 4717, 2183, 2184, 2185, 1468, 560],
/* 4717 */
[6635, 31, 20],
/* 4718 */
[6640, 53, 31, 20],
/* 4719 */
[6641, 53, 31, 20],
/* 4720 */
[6642, 53, 31, 2183, 20],
/* 4721 */
[6643, 53, 31, 2185, 20],
/* 4722 */
[6645, 2184, 938, 20],
/* 4723 */
[6647, 53, 1468, 939, 20],
/* 4724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = add;
	
	var _index = _interopRequireDefault(__webpack_require__(369));
	
	var _index2 = _interopRequireDefault(__webpack_require__(713));
	
	var _index3 = _interopRequireDefault(__webpack_require__(31));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	var _index5 = _interopRequireDefault(__webpack_require__(53));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name add
	 * @category Common Helpers
	 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @description
	 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 *
	 * | Key            | Description                        |
	 * |----------------|------------------------------------|
	 * | years          | Amount of years to be added        |
	 * | months         | Amount of months to be added       |
	 * | weeks          | Amount of weeks to be added       |
	 * | days           | Amount of days to be added         |
	 * | hours          | Amount of hours to be added        |
	 * | minutes        | Amount of minutes to be added      |
	 * | seconds        | Amount of seconds to be added      |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add the following duration to 1 September 2014, 10:19:50
	 * var result = add(new Date(2014, 8, 1, 10, 19, 50), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30,
	 * })
	 * //=> Thu Jun 15 2017 15:29:20
	 */
	function add(dirtyDate, duration) {
	  (0, _index4.default)(2, arguments);
	  if (!duration || typeof duration !== 'object') return new Date(NaN);
	  var years = 'years' in duration ? (0, _index5.default)(duration.years) : 0;
	  var months = 'months' in duration ? (0, _index5.default)(duration.months) : 0;
	  var weeks = 'weeks' in duration ? (0, _index5.default)(duration.weeks) : 0;
	  var days = 'days' in duration ? (0, _index5.default)(duration.days) : 0;
	  var hours = 'hours' in duration ? (0, _index5.default)(duration.hours) : 0;
	  var minutes = 'minutes' in duration ? (0, _index5.default)(duration.minutes) : 0;
	  var seconds = 'seconds' in duration ? (0, _index5.default)(duration.seconds) : 0; // Add years and months
	
	  var date = (0, _index3.default)(dirtyDate);
	  var dateWithMonths = months || years ? (0, _index2.default)(date, months + years * 12) : date; // Add weeks and days
	
	  var dateWithDays = days || weeks ? (0, _index.default)(dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds
	
	  var minutesToAdd = minutes + hours * 60;
	  var secondsToAdd = seconds + minutesToAdd * 60;
	  var msToAdd = secondsToAdd * 1000;
	  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
	  return finalDate;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areIntervalsOverlapping;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name areIntervalsOverlapping
	 * @category Interval Helpers
	 * @summary Is the given time interval overlapping with another time interval?
	 *
	 * @description
	 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `areRangesOverlapping` to `areIntervalsOverlapping`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   areRangesOverlapping(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   areIntervalsOverlapping(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/types/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/types/Interval}
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
	 * @returns {Boolean} whether the time intervals are overlapping
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // For adjacent time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // Using the inclusive option:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
	 * )
	 * //=> false
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
	 *   { inclusive: true }
	 * )
	 * //=> true
	 */
	function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  if (options.inclusive) {
	    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
	  }
	
	  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestIndexTo;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestIndexTo
	 * @category Common Helpers
	 * @summary Return an index of the closest date from the array comparing to the given date.
	 *
	 * @description
	 * Return an index of the closest date from the array comparing to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestIndexTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @param {Date[]|Number[]} datesArray - the array to search
	 * @returns {Number} an index of the date closest to the given date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var datesArray = [
	 *   new Date(2015, 0, 1),
	 *   new Date(2016, 0, 1),
	 *   new Date(2017, 0, 1)
	 * ]
	 * var result = closestIndexTo(dateToCompare, datesArray)
	 * //=> 1
	 */
	function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	
	  if (isNaN(dateToCompare)) {
	    return NaN;
	  }
	
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate, index) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(currentDate)) {
	      result = NaN;
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < minDistance) {
	      result = index;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestTo;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name closestTo
	 * @category Common Helpers
	 * @summary Return a date from the array closest to the given date.
	 *
	 * @description
	 * Return a date from the array closest to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now, `closestTo` doesn't throw an exception
	 *   when the second argument is not an array, and returns Invalid Date instead.
	 *
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @param {Date[]|Number[]} datesArray - the array to search
	 * @returns {Date} the date from the array closest to the given date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
	 * var dateToCompare = new Date(2015, 8, 6)
	 * var result = closestTo(dateToCompare, [
	 *   new Date(2000, 0, 1),
	 *   new Date(2030, 0, 1)
	 * ])
	 * //=> Tue Jan 01 2030 00:00:00
	 */
	function closestTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	
	  if (isNaN(dateToCompare)) {
	    return new Date(NaN);
	  }
	
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray; // `dirtyDatesArray` is undefined or null
	
	  if (dirtyDatesArray == null) {
	    datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (isNaN(currentDate)) {
	      result = new Date(NaN);
	      minDistance = NaN;
	      return;
	    }
	
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	
	    if (result == null || distance < minDistance) {
	      result = currentDate;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4728 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareDesc;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name compareDesc
	 * @category Common Helpers
	 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return -1 if the first date is after the second,
	 * 1 if the first date is before the second or 0 if dates are equal.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
	 * var result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> 1
	 *
	 * @example
	 * // Sort the array of dates in reverse chronological order:
	 * var result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareDesc)
	 * //=> [
	 * //   Sun Jul 02 1995 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Wed Feb 11 1987 00:00:00
	 * // ]
	 */
	function compareDesc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	
	  if (diff > 0) {
	    return -1;
	  } else if (diff < 0) {
	    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 4729 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.minTime = exports.maxTime = void 0;
	
	/**
	 *  Maximum allowed time.
	 *  @constant
	 *  @type {number}
	 *  @default
	 */
	var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
	/**
	 *  Minimum allowed time.
	 *  @constant
	 *  @type {number}
	 *  @default
	 */
	
	exports.maxTime = maxTime;
	var minTime = -maxTime;
	exports.minTime = minTime;

/***/ }),
/* 4730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(208));
	
	var _index2 = _interopRequireDefault(__webpack_require__(944));
	
	var _index3 = _interopRequireDefault(__webpack_require__(31));
	
	var _index4 = _interopRequireDefault(__webpack_require__(453));
	
	var _index5 = _interopRequireDefault(__webpack_require__(369));
	
	var _index6 = _interopRequireDefault(__webpack_require__(714));
	
	var _index7 = _interopRequireDefault(__webpack_require__(53));
	
	var _index8 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInBusinessDays
	 * @category Day Helpers
	 * @summary Get the number of business days between the given dates.
	 *
	 * @description
	 * Get the number of business day periods between the given dates.
	 * Business days being days that arent in the weekend.
	 * Like `differenceInCalendarDays`, the function removes the times from
	 * the dates before calculating the difference.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of business days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many business days are between
	 * // 10 January 2014 and 20 July 2014?
	 * var result = differenceInBusinessDays(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 0, 10)
	 * )
	 * //=> 136
	 */
	function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index8.default)(2, arguments);
	  var dateLeft = (0, _index3.default)(dirtyDateLeft);
	  var dateRight = (0, _index3.default)(dirtyDateRight);
	  if (!(0, _index.default)(dateLeft) || !(0, _index.default)(dateRight)) return new Date(NaN);
	  var calendarDifference = (0, _index4.default)(dateLeft, dateRight);
	  var sign = calendarDifference < 0 ? -1 : 1;
	  var weeks = (0, _index7.default)(calendarDifference / 7);
	  var result = weeks * 5;
	  dateRight = (0, _index5.default)(dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
	
	  while (!(0, _index6.default)(dateLeft, dateRight)) {
	    // sign is used to account for both negative and positive differences
	    result += (0, _index2.default)(dateRight) ? 0 : sign;
	    dateRight = (0, _index5.default)(dateRight, sign);
	  }
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(320));
	
	var _index2 = _interopRequireDefault(__webpack_require__(455));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarISOWeeks
	 * @category ISO Week Helpers
	 * @summary Get the number of calendar ISO weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO weeks between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
	 * var result = differenceInCalendarISOWeeks(
	 *   new Date(2014, 6, 21),
	 *   new Date(2014, 6, 6)
	 * )
	 * //=> 3
	 */
	
	function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfISOWeekLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfISOWeekRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfISOWeekLeft.getTime() - (0, _index.default)(startOfISOWeekLeft);
	  var timestampRight = startOfISOWeekRight.getTime() - (0, _index.default)(startOfISOWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(2209));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of calendar quarters between the given dates.
	 *
	 * @description
	 * Get the number of calendar quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInCalendarQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index2.default)(dirtyDateLeft);
	  var dateRight = (0, _index2.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var quarterDiff = (0, _index.default)(dateLeft) - (0, _index.default)(dateRight);
	  return yearDiff * 4 + quarterDiff;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInISOWeekYears;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2192));
	
	var _index3 = _interopRequireDefault(__webpack_require__(452));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2230));
	
	var _index5 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of full ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of full ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `differenceInISOYears` to `differenceInISOWeekYears`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
	 * var result = differenceInISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 1
	 */
	function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index5.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft = (0, _index4.default)(dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
	  // if last calendar ISO year is not full
	  // If so, result must be decreased by 1 in absolute value
	
	  var isLastISOWeekYearNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero
	
	  return result === 0 ? 0 : result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(942));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of full quarters between the given dates.
	 *
	 * @description
	 * Get the number of full quarters between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full quarters are between 31 December 2013 and 2 July 2014?
	 * var result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
	 * //=> 2
	 */
	function differenceInQuarters(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / 3;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(1471));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInWeeks
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between two dates. Fractional weeks are
	 * truncated towards zero.
	 *
	 * One "full week" is the distance between a local time in one day to the same
	 * local time 7 days earlier or later. A full week can sometimes be less than
	 * or more than 7*24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
	 *
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
	 * //=> 2
	 *
	 * // How many full weeks are between
	 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 8 weeks (54 days),
	 * // even if DST starts and the period has
	 * // only 54*24-1 hours.
	 * var result = differenceInWeeks(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 6)
	 * )
	 * //=> 8
	 */
	function differenceInWeeks(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / 7;
	  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachHourOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(1469));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachHourOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of hours within the specified time interval.
	 *
	 * @description
	 * Return the array of hours within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each hour between 6 October 2014, 12:00 and 10 October 2014, 15:00
	 * var result = eachHourOfInterval({
	 *   start: new Date(2014, 9, 6, 12),
	 *   end: new Date(2014, 9, 6, 15)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 12:00:00,
	 * //   Mon Oct 06 2014 13:00:00,
	 * //   Mon Oct 06 2014 14:00:00,
	 * //   Mon Oct 06 2014 15:00:00
	 * // ]
	 */
	function eachHourOfInterval(dirtyInterval, options) {
	  (0, _index3.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index2.default)(interval.start);
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setMinutes(0, 0, 0);
	  var step = options && 'step' in options ? Number(options.step) : 1;
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMonthOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachMonthOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of months within the specified time interval.
	 *
	 * @description
	 * Return the array of months within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each month between 6 February 2014 and 10 August 2014:
	 * var result = eachMonthOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Sat Feb 01 2014 00:00:00,
	 * //   Sat Mar 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Thu May 01 2014 00:00:00,
	 * //   Sun Jun 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * //   Fri Aug 01 2014 00:00:00
	 * // ]
	 */
	function eachMonthOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setDate(1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setMonth(currentDate.getMonth() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachQuarterOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(1470));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1479));
	
	var _index3 = _interopRequireDefault(__webpack_require__(31));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachQuarterOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of quarters within the specified time interval.
	 *
	 * @description
	 * Return the array of quarters within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each quarter within interval 6 February 2014 - 10 August 2014:
	 * var result = eachQuarterOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * // ]
	 */
	function eachQuarterOfInterval(dirtyInterval) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateQuarter = (0, _index2.default)(startDate);
	  var endDateQuarter = (0, _index2.default)(endDate);
	  endTime = endDateQuarter.getTime();
	  var quarters = [];
	  var currentQuarter = startDateQuarter;
	
	  while (currentQuarter.getTime() <= endTime) {
	    quarters.push((0, _index3.default)(currentQuarter));
	    currentQuarter = (0, _index.default)(currentQuarter, 1);
	  }
	
	  return quarters;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(940));
	
	var _index2 = _interopRequireDefault(__webpack_require__(371));
	
	var _index3 = _interopRequireDefault(__webpack_require__(31));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of weeks within the specified time interval.
	 *
	 * @description
	 * Return the array of weeks within the specified time interval.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each week within interval 6 October 2014 - 23 November 2014:
	 * var result = eachWeekOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 10, 23)
	 * })
	 * //=> [
	 * //   Sun Oct 05 2014 00:00:00,
	 * //   Sun Oct 12 2014 00:00:00,
	 * //   Sun Oct 19 2014 00:00:00,
	 * //   Sun Oct 26 2014 00:00:00,
	 * //   Sun Nov 02 2014 00:00:00,
	 * //   Sun Nov 09 2014 00:00:00,
	 * //   Sun Nov 16 2014 00:00:00,
	 * //   Sun Nov 23 2014 00:00:00
	 * // ]
	 */
	function eachWeekOfInterval(dirtyInterval, options) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var startDateWeek = (0, _index2.default)(startDate, options);
	  var endDateWeek = (0, _index2.default)(endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
	
	  startDateWeek.setHours(15);
	  endDateWeek.setHours(15);
	  endTime = endDateWeek.getTime();
	  var weeks = [];
	  var currentWeek = startDateWeek;
	
	  while (currentWeek.getTime() <= endTime) {
	    currentWeek.setHours(0);
	    weeks.push((0, _index3.default)(currentWeek));
	    currentWeek = (0, _index.default)(currentWeek, 1);
	    currentWeek.setHours(15);
	  }
	
	  return weeks;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(1472));
	
	var _index2 = _interopRequireDefault(__webpack_require__(946));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1474));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfMonth
	 * @category Month Helpers
	 * @summary List all the Saturdays and Sundays in the given month.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given month.
	 *
	 * @param {Date|Number} date - the given month
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given month
	 * var result = eachWeekendOfMonth(new Date(2022, 1, 1))
	 * //=> [
	 * //   Sat Feb 05 2022 00:00:00,
	 * //   Sun Feb 06 2022 00:00:00,
	 * //   Sat Feb 12 2022 00:00:00,
	 * //   Sun Feb 13 2022 00:00:00,
	 * //   Sat Feb 19 2022 00:00:00,
	 * //   Sun Feb 20 2022 00:00:00,
	 * //   Sat Feb 26 2022 00:00:00,
	 * //   Sun Feb 27 2022 00:00:00
	 * // ]
	 */
	function eachWeekendOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate)) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 4741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(1472));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1481));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2201));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachWeekendOfYear
	 * @category Year Helpers
	 * @summary List all the Saturdays and Sundays in the year.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the year.
	 *
	 * @param {Date|Number} date - the given year
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the year
	 * var result = eachWeekendOfYear(new Date(2020, 1, 1))
	 * //=> [
	 * //   Sat Jan 03 2020 00:00:00,
	 * //   Sun Jan 04 2020 00:00:00,
	 * //   ...
	 * //   Sun Dec 27 2020 00:00:00
	 * // ]
	 * ]
	 */
	function eachWeekendOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate)) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 4742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachYearOfInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name eachYearOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of yearly timestamps within the specified time interval.
	 *
	 * @description
	 * Return the array of yearly timestamps within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
	 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each year between 6 February 2014 and 10 August 2017:
	 * var result = eachYearOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2017, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Thu Jan 01 2015 00:00:00,
	 * //   Fri Jan 01 2016 00:00:00,
	 * //   Sun Jan 01 2017 00:00:00
	 * // ]
	 */
	function eachYearOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setMonth(0, 1);
	
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setFullYear(currentDate.getFullYear() + 1);
	  }
	
	  return dates;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDecade
	 * @category Decade Helpers
	 * @summary Return the end of a decade for the given date.
	 *
	 * @description
	 * Return the end of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a decade
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a decade for 12 May 1984 00:00:00:
	 * var result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
	 * //=> Dec 31 1989 23:59:59.999
	 */
	function endOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 11, 31);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4744 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfHour;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfHour
	 * @category Hour Helpers
	 * @summary Return the end of an hour for the given date.
	 *
	 * @description
	 * Return the end of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an hour for 2 September 2014 11:55:00:
	 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:59:59.999
	 */
	function endOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(2200));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the end of an ISO week for the given date.
	 *
	 * @description
	 * Return the end of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week for 2 September 2014 11:55:00:
	 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 4746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(561));
	
	var _index2 = _interopRequireDefault(__webpack_require__(455));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the end of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the end of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `endOfISOYear` to `endOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week-numbering year for 2 July 2005:
	 * var result = endOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 23:59:59.999
	 */
	function endOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  date.setMilliseconds(date.getMilliseconds() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMinute
	 * @category Minute Helpers
	 * @summary Return the end of a minute for the given date.
	 *
	 * @description
	 * Return the end of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a minute for 1 December 2014 22:15:45.400:
	 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:59.999
	 */
	function endOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the end of a year quarter for the given date.
	 *
	 * @description
	 * Return the end of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a quarter for 2 September 2014 11:55:00:
	 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfSecond
	 * @category Second Helpers
	 * @summary Return the end of a second for the given date.
	 *
	 * @description
	 * Return the end of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a second for 1 December 2014 22:15:45.400:
	 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.999
	 */
	function endOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(1473));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfToday
	 * @category Day Helpers
	 * @summary Return the end of today.
	 * @pure false
	 *
	 * @description
	 * Return the end of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfToday()
	 * //=> Mon Oct 6 2014 23:59:59.999
	 */
	function endOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 4751 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfTomorrow;
	
	/**
	 * @name endOfTomorrow
	 * @category Day Helpers
	 * @summary Return the end of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the end of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfTomorrow()
	 * //=> Tue Oct 7 2014 23:59:59.999
	 */
	function endOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4752 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYesterday;
	
	/**
	 * @name endOfYesterday
	 * @category Day Helpers
	 * @summary Return the end of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the end of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the end of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = endOfYesterday()
	 * //=> Sun Oct 5 2014 23:59:59.999
	 */
	function endOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNow;
	
	var _index = _interopRequireDefault(__webpack_require__(2202));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNow
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given date and now in words.
	 *
	 * | Distance to now                                                   | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance to now     | Result               |
	 * |---------------------|----------------------|
	 * | 0 secs ... 5 secs   | less than 5 seconds  |
	 * | 5 secs ... 10 secs  | less than 10 seconds |
	 * | 10 secs ... 20 secs | less than 20 seconds |
	 * | 20 secs ... 40 secs | half a minute        |
	 * | 40 secs ... 60 secs | less than a minute   |
	 * | 60 secs ... 90 secs | 1 minute             |
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `distanceInWordsToNow ` to `formatDistanceToNow`
	 *   to make its name consistent with `format` and `formatRelative`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   distanceInWordsToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *
	 *   // v2.0.0 onward
	 *
	 *   formatDistanceToNow(new Date(2014, 6, 2), { addSuffix: true })
	 *   //=> 'in 6 months'
	 *   ```
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNow(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNow(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in about 1 year'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNow(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function formatDistanceToNow(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNowStrict;
	
	var _index = _interopRequireDefault(__webpack_require__(2203));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatDistanceToNowStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15)
	 * )
	 * //=> '20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in 1 year'
	 *
	 * @example
	 * // If today is 28 January 2015,
	 * // what is the distance to 1 January 2015, in months, rounded up??
	 * var result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * var eoLocale = require('date-fns/locale/eo')
	 * var result = formatDistanceToNowStrict(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> '1 jaro'
	 */
	function formatDistanceToNowStrict(dirtyDate, dirtyOptions) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), dirtyOptions);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(454));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
	/**
	 * @name formatDuration
	 * @category Common Helpers
	 * @summary Formats a duration in human-readable format
	 *
	 * @description
	 * Return human-readable duration string i.e. "9 months 2 days"
	 *
	 * @param {Duration} duration - the duration to format
	 * @param {Object} [options] - an object with options.
	
	 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
	 * @param {boolean} [options.zero=false] - should be zeros be included in the output?
	 * @param {string} [options.delimiter=' '] - delimiter string
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {string} the formatted date string
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Format full duration
	 * formatDuration({
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds
	 *
	 * @example
	 * // Format partial duration
	 * formatDuration({ months: 9, days: 2 })
	 * //=> '9 months 2 days'
	 *
	 * @example
	 * // Customize the format
	 * formatDuration(
	 *   {
	 *     years: 2,
	 *     months: 9,
	 *     weeks: 1,
	 *     days: 7,
	 *     hours: 5,
	 *     minutes: 9,
	 *     seconds: 30
	 *   },
	 *   { format: ['months', 'weeks'] }
	 * ) === '9 months 1 week'
	 *
	 * @example
	 * // Customize the zeros presence
	 * formatDuration({ years: 0, months: 9 })
	 * //=> '9 months'
	 * formatDuration({ years: 0, months: 9 }, null, { zero: true })
	 * //=> '0 years 9 months'
	 *
	 * @example
	 * // Customize the delimiter
	 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
	 * //=> '2 years, 9 months, 3 weeks'
	 */
	
	function formatDuration(duration) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var format = options.format || defaultFormat;
	  var locale = options.locale || _index.default;
	  var zero = options.zero || false;
	  var delimiter = options.delimiter || ' ';
	  var result = format.reduce(function (acc, unit) {
	    var token = "x".concat(unit.replace(/(^.)/, function (m) {
	      return m.toUpperCase();
	    }));
	    var addChunk = typeof duration[unit] === 'number' && (zero || duration[unit]);
	    return addChunk ? acc.concat(locale.formatDistance(token, duration[unit])) : acc;
	  }, []).join(delimiter);
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(560));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 8601 standard (http://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
	 *
	 * @description
	 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with time zone, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format (UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601, short format (UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918T190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, date only:
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, time only (UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52Z'
	 */
	function formatISO(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var format = options.format == null ? 'extended' : String(options.format);
	  var representation = options.representation == null ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var tzOffset = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    // Add the timezone.
	    var offset = originalDate.getTimezoneOffset();
	
	    if (offset !== 0) {
	      var absoluteOffset = Math.abs(offset);
	      var hourOffset = (0, _index3.default)(Math.floor(absoluteOffset / 60), 2);
	      var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	      var sign = offset < 0 ? '+' : '-';
	      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	    } else {
	      tzOffset = 'Z';
	    }
	
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'
	
	    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
	
	    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO9075;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(560));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISO9075
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
	 *
	 * @description
	 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18 19:00:52'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075, short format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918 190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, date only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, time only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52'
	 */
	function formatISO9075(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var format = options.format == null ? 'extended' : String(options.format);
	  var representation = options.representation == null ? 'complete' : String(options.representation);
	
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	
	  var result = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'
	
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.
	
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  } // Representation is either 'time' or 'complete'
	
	
	  if (representation !== 'date') {
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2); // If there's also date, separate it with time with a space
	
	    var separator = result === '' ? '' : ' '; // HHmmss or HH:mm:ss.
	
	    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISODuration;
	
	var _index = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatISODuration
	 * @category Common Helpers
	 * @summary Format a duration object according as ISO 8601 duration string
	 *
	 * @description
	 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
	 *
	 * @param {Duration} duration - the duration to format
	 *
	 * @returns {String} The ISO 8601 duration string
	 * @throws {TypeError} Requires 1 argument
	 * @throws {Error} Argument must be an object
	 *
	 * @example
	 * // Format the given duration as ISO 8601 string
	 * formatISODuration({
	 *   years: 39,
	 *   months: 2,
	 *   days: 20,
	 *   hours: 7,
	 *   minutes: 5,
	 *   seconds: 0
	 * })
	 * //=> 'P39Y2M20DT0H0M0S'
	 */
	function formatISODuration(duration) {
	  (0, _index.default)(1, arguments);
	  if (typeof duration !== 'object') throw new Error('Duration must be an object');
	  var _duration$years = duration.years,
	      years = _duration$years === void 0 ? 0 : _duration$years,
	      _duration$months = duration.months,
	      months = _duration$months === void 0 ? 0 : _duration$months,
	      _duration$days = duration.days,
	      days = _duration$days === void 0 ? 0 : _duration$days,
	      _duration$hours = duration.hours,
	      hours = _duration$hours === void 0 ? 0 : _duration$hours,
	      _duration$minutes = duration.minutes,
	      minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
	      _duration$seconds = duration.seconds,
	      seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
	  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
	}
	
	module.exports = exports.default;

/***/ }),
/* 4759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC3339;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(560));
	
	var _index4 = _interopRequireDefault(__webpack_require__(53));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRFC3339
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
	 *
	 * @description
	 * Return the formatted date string in ISO 3339 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 3339 format:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 3339 format, 2 digits of second fraction:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
	 * //=> '2019-09-18T19:00:52.23Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 3339 format, 3 digits of second fraction
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
	 * //=> '2019-09-18T19:00:52.234Z'
	 */
	function formatRFC3339(dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var options = dirtyOptions || {};
	  var fractionDigits = options.fractionDigits == null ? 0 : (0, _index4.default)(options.fractionDigits); // Test if fractionDigits is between 0 and 3 _and_ is not NaN
	
	  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
	    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
	  }
	
	  var day = (0, _index3.default)(originalDate.getDate(), 2);
	  var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	  var year = originalDate.getFullYear();
	  var hour = (0, _index3.default)(originalDate.getHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getSeconds(), 2);
	  var fractionalSecond = '';
	
	  if (fractionDigits > 0) {
	    var milliseconds = originalDate.getMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
	    fractionalSecond = '.' + (0, _index3.default)(fractionalSeconds, fractionDigits);
	  }
	
	  var offset = '';
	  var tzOffset = originalDate.getTimezoneOffset();
	
	  if (tzOffset !== 0) {
	    var absoluteOffset = Math.abs(tzOffset);
	    var hourOffset = (0, _index3.default)((0, _index4.default)(absoluteOffset / 60), 2);
	    var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.
	
	    var sign = tzOffset < 0 ? '+' : '-';
	    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	  } else {
	    offset = 'Z';
	  }
	
	  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC7231;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(560));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	/**
	 * @name formatRFC7231
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
	 *
	 * @description
	 * Return the formatted date string in RFC 7231 format.
	 * The result will always be in UTC timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 7231 format:
	 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
	 */
	
	function formatRFC7231(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var dayName = days[originalDate.getUTCDay()];
	  var dayOfMonth = (0, _index3.default)(originalDate.getUTCDate(), 2);
	  var monthName = months[originalDate.getUTCMonth()];
	  var year = originalDate.getUTCFullYear();
	  var hour = (0, _index3.default)(originalDate.getUTCHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getUTCMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getUTCSeconds(), 2); // Result variables.
	
	  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
	}
	
	module.exports = exports.default;

/***/ }),
/* 4761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	
	var _index = _interopRequireDefault(__webpack_require__(453));
	
	var _index2 = _interopRequireDefault(__webpack_require__(370));
	
	var _index3 = _interopRequireDefault(__webpack_require__(454));
	
	var _index4 = _interopRequireDefault(__webpack_require__(717));
	
	var _index5 = _interopRequireDefault(__webpack_require__(31));
	
	var _index6 = _interopRequireDefault(__webpack_require__(320));
	
	var _index7 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name formatRelative
	 * @category Common Helpers
	 * @summary Represent the date in words relative to the given base date.
	 *
	 * @description
	 * Represent the date in words relative to the given base date.
	 *
	 * | Distance to the base date | Result                    |
	 * |---------------------------|---------------------------|
	 * | Previous 6 days           | last Sunday at 04:30 AM   |
	 * | Last day                  | yesterday at 04:30 AM     |
	 * | Same day                  | today at 04:30 AM         |
	 * | Next day                  | tomorrow at 04:30 AM      |
	 * | Next 6 days               | Sunday at 04:30 AM        |
	 * | Other                     | 12/31/2017                |
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to format
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {String} the date in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.locale` must contain `formatRelative` property
	 */
	function formatRelative(dirtyDate, dirtyBaseDate, dirtyOptions) {
	  (0, _index7.default)(2, arguments);
	  var date = (0, _index5.default)(dirtyDate);
	  var baseDate = (0, _index5.default)(dirtyBaseDate);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index3.default;
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  if (!locale.formatRelative) {
	    throw new RangeError('locale must contain formatRelative property');
	  }
	
	  var diff = (0, _index.default)(date, baseDate);
	
	  if (isNaN(diff)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  var token;
	
	  if (diff < -6) {
	    token = 'other';
	  } else if (diff < -1) {
	    token = 'lastWeek';
	  } else if (diff < 0) {
	    token = 'yesterday';
	  } else if (diff < 1) {
	    token = 'today';
	  } else if (diff < 2) {
	    token = 'tomorrow';
	  } else if (diff < 7) {
	    token = 'nextWeek';
	  } else {
	    token = 'other';
	  }
	
	  var utcDate = (0, _index4.default)(date, (0, _index6.default)(date));
	  var utcBaseDate = (0, _index4.default)(baseDate, (0, _index6.default)(baseDate));
	  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, options);
	  return (0, _index2.default)(date, formatStr, options);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fromUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(53));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name fromUnixTime
	 * @category Timestamp Helpers
	 * @summary Create a date from a Unix timestamp.
	 *
	 * @description
	 * Create a date from a Unix timestamp.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Number} unixTime - the given Unix timestamp
	 * @returns {Date} the date
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Create the date 29 February 2012 11:45:05:
	 * var result = fromUnixTime(1330515905)
	 * //=> Wed Feb 29 2012 11:45:05
	 */
	function fromUnixTime(dirtyUnixTime) {
	  (0, _index3.default)(1, arguments);
	  var unixTime = (0, _index2.default)(dirtyUnixTime);
	  return (0, _index.default)(unixTime * 1000);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1481));
	
	var _index3 = _interopRequireDefault(__webpack_require__(453));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDayOfYear
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * var result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index3.default)(date, (0, _index2.default)(date));
	  var dayOfYear = diff + 1;
	  return dayOfYear;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2214));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInYear
	 * @category Year Helpers
	 * @summary Get the number of days in a year of the given date.
	 *
	 * @description
	 * Get the number of days in a year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in 2012?
	 * var result = getDaysInYear(new Date(2012, 0, 1))
	 * //=> 366
	 */
	function getDaysInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	
	  if (isNaN(date)) {
	    return NaN;
	  }
	
	  return (0, _index2.default)(date) ? 366 : 365;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDecade
	 * @category Decade Helpers
	 * @summary Get the decade of the given date.
	 *
	 * @description
	 * Get the decade of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year of decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which decade belongs 27 November 1942?
	 * var result = getDecade(new Date(1942, 10, 27))
	 * //=> 1940
	 */
	function getDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  return decade;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4766 */
[6657, 31, 20],
/* 4767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeeksInYear;
	
	var _index = _interopRequireDefault(__webpack_require__(716));
	
	var _index2 = _interopRequireDefault(__webpack_require__(940));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name getISOWeeksInYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of ISO weeks in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many weeks are in ISO week-numbering year 2015?
	 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
	 * //=> 53
	 */
	
	function getISOWeeksInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var thisYear = (0, _index.default)(dirtyDate);
	  var nextYear = (0, _index.default)((0, _index2.default)(thisYear, 60));
	  var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the milliseconds of the given date.
	 *
	 * @description
	 * Get the milliseconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the milliseconds of 29 February 2012 11:45:05.123:
	 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 123
	 */
	function getMilliseconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var milliseconds = date.getMilliseconds();
	  return milliseconds;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4769 */
[6658, 31, 20],
/* 4770 */
[6659, 31, 20],
/* 4771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverlappingDaysInIntervals;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
	/**
	 * @name getOverlappingDaysInIntervals
	 * @category Interval Helpers
	 * @summary Get the number of days that overlap in two time intervals
	 *
	 * @description
	 * Get the number of days that overlap in two time intervals
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `getOverlappingDaysInRanges` to `getOverlappingDaysInIntervals`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   getOverlappingDaysInRanges(
	 *     new Date(2014, 0, 10), new Date(2014, 0, 20),
	 *     new Date(2014, 0, 17), new Date(2014, 0, 21)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   getOverlappingDaysInIntervals(
	 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 *   )
	 *   ```
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
	 * @returns {Number} the number of days that overlap in two time intervals
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals adds 1 for each started overlapping day:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> 3
	 *
	 * @example
	 * // For non-overlapping time intervals returns 0:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> 0
	 */
	
	function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	
	  if (!isOverlapping) {
	    return 0;
	  }
	
	  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
	  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
	  var differenceInMs = overlapEndDate - overlapStartDate;
	  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4772 */
[6661, 31, 20],
/* 4773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUnixTime;
	
	var _index = _interopRequireDefault(__webpack_require__(2210));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getUnixTime
	 * @category Timestamp Helpers
	 * @summary Get the seconds timestamp of the given date.
	 *
	 * @description
	 * Get the seconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05 CET:
	 * var result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 1330512305
	 */
	function getUnixTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return Math.floor((0, _index.default)(dirtyDate) / 1000);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(2204));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2205));
	
	var _index3 = _interopRequireDefault(__webpack_require__(946));
	
	var _index4 = _interopRequireDefault(__webpack_require__(53));
	
	var _index5 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeekOfMonth
	 * @category Week Helpers
	 * @summary Get the week of the month of the given date.
	 *
	 * @description
	 * Get the week of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the week of month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Which week of the month is 9 November 2017?
	 * var result = getWeekOfMonth(new Date(2017, 10, 9))
	 * //=> 2
	 */
	function getWeekOfMonth(date, dirtyOptions) {
	  (0, _index5.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index4.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index4.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var currentDayOfMonth = (0, _index.default)(date);
	
	  if (isNaN(currentDayOfMonth)) {
	    return currentDayOfMonth;
	  }
	
	  var startWeekDay = (0, _index2.default)((0, _index3.default)(date));
	  var lastDayOfFirstWeek = 0;
	
	  if (startWeekDay >= weekStartsOn) {
	    lastDayOfFirstWeek = weekStartsOn + 7 - startWeekDay;
	  } else {
	    lastDayOfFirstWeek = weekStartsOn - startWeekDay;
	  }
	
	  var weekNumber = 1;
	
	  if (currentDayOfMonth > lastDayOfFirstWeek) {
	    var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
	    weekNumber = weekNumber + Math.ceil(remainingDaysAfterFirstWeek / 7);
	  }
	
	  return weekNumber;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeeksInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(2194));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2223));
	
	var _index3 = _interopRequireDefault(__webpack_require__(946));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getWeeksInMonth
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks a month spans.
	 *
	 * @description
	 * Get the number of calendar weeks the month in the given date spans.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks does February 2015 span?
	 * var result = getWeeksInMonth(new Date(2015, 1, 8))
	 * //=> 4
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks does July 2017 span?
	 * var result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
	 * //=> 6
	 */
	function getWeeksInMonth(date, options) {
	  (0, _index4.default)(1, arguments);
	  return (0, _index.default)((0, _index2.default)(date), (0, _index3.default)(date), options) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4776 */
[6663, 31, 20],
/* 4777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intervalToDuration;
	
	var _index = _interopRequireDefault(__webpack_require__(452));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2198));
	
	var _index3 = _interopRequireDefault(__webpack_require__(942));
	
	var _index4 = _interopRequireDefault(__webpack_require__(1471));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2196));
	
	var _index6 = _interopRequireDefault(__webpack_require__(2197));
	
	var _index7 = _interopRequireDefault(__webpack_require__(943));
	
	var _index8 = _interopRequireDefault(__webpack_require__(208));
	
	var _index9 = _interopRequireDefault(__webpack_require__(20));
	
	var _index10 = _interopRequireDefault(__webpack_require__(31));
	
	var _index11 = _interopRequireDefault(__webpack_require__(2229));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name intervalToDuration
	 * @category Common Helpers
	 * @summary Convert interval to duration
	 *
	 * @description
	 * Convert a interval object to a duration object.
	 *
	 * @param {Interval} interval - the interval to convert to duration
	 *
	 * @returns {Duration} The duration Object
	 * @throws {TypeError} Requires 2 arguments
	 * @throws {RangeError} `start` must not be Invalid Date
	 * @throws {RangeError} `end` must not be Invalid Date
	 *
	 * @example
	 * // Get the duration between January 15, 1929 and April 4, 1968.
	 * intervalToDuration({
	 *   start: new Date(1929, 0, 15, 12, 0, 0),
	 *   end: new Date(1968, 3, 4, 19, 5, 0)
	 * })
	 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
	 */
	function intervalToDuration(_ref) {
	  var start = _ref.start,
	      end = _ref.end;
	  (0, _index9.default)(1, arguments);
	  var dateLeft = (0, _index10.default)(start);
	  var dateRight = (0, _index10.default)(end);
	
	  if (!(0, _index8.default)(dateLeft)) {
	    throw new RangeError('Start Date is invalid');
	  }
	
	  if (!(0, _index8.default)(dateRight)) {
	    throw new RangeError('End Date is invalid');
	  }
	
	  var duration = {
	    years: 0,
	    months: 0,
	    days: 0,
	    hours: 0,
	    minutes: 0,
	    seconds: 0
	  };
	  var sign = (0, _index.default)(dateLeft, dateRight);
	  duration.years = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var remainingMonths = (0, _index11.default)(dateLeft, {
	    years: sign * duration.years
	  });
	  duration.months = Math.abs((0, _index3.default)(remainingMonths, dateRight));
	  var remainingDays = (0, _index11.default)(remainingMonths, {
	    months: sign * duration.months
	  });
	  duration.days = Math.abs((0, _index4.default)(remainingDays, dateRight));
	  var remainingHours = (0, _index11.default)(remainingDays, {
	    days: sign * duration.days
	  });
	  duration.hours = Math.abs((0, _index5.default)(remainingHours, dateRight));
	  var remainingMinutes = (0, _index11.default)(remainingHours, {
	    hours: sign * duration.hours
	  });
	  duration.minutes = Math.abs((0, _index6.default)(remainingMinutes, dateRight));
	  var remainingSeconds = (0, _index11.default)(remainingMinutes, {
	    minutes: sign * duration.minutes
	  });
	  duration.seconds = Math.abs((0, _index7.default)(remainingSeconds, dateRight));
	  return duration;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4778 */
[6664, 31, 20],
/* 4779 */
[6666, 20],
/* 4780 */
[6667, 31, 20],
/* 4781 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isExists;
	
	/**
	 * @name isExists
	 * @category Common Helpers
	 * @summary Is the given date exists?
	 *
	 * @description
	 * Checks if the given arguments convert to an existing date.
	 *
	 * @param {Number} year of the date to check
	 * @param {Number} month of the date to check
	 * @param {Number} day of the date to check
	 * @returns {Boolean} the date exists
	 * @throws {TypeError} 3 arguments required
	 *
	 * @example
	 * // For the valid date:
	 * var result = isExists(2018, 0, 31)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isExists(2018, 1, 31)
	 * //=> false
	 */
	function isExists(year, month, day) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
	  }
	
	  var date = new Date(year, month, day);
	  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFirstDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFirstDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the first day of a month?
	 *
	 * @description
	 * Is the given date the first day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the first day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2014 the first day of a month?
	 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
	 * //=> true
	 */
	function isFirstDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDate() === 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFriday;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFriday
	 * @category Weekday Helpers
	 * @summary Is the given date Friday?
	 *
	 * @description
	 * Is the given date Friday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 26 September 2014 Friday?
	 * var result = isFriday(new Date(2014, 8, 26))
	 * //=> true
	 */
	function isFriday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 5;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFuture;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isFuture
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * var result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() > Date.now();
	}
	
	module.exports = exports.default;

/***/ }),
/* 4785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLastDayOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1473));
	
	var _index3 = _interopRequireDefault(__webpack_require__(1474));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isLastDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the last day of a month?
	 *
	 * @description
	 * Is the given date the last day of a month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 28 February 2014 the last day of a month?
	 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
	 * //=> true
	 */
	function isLastDayOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  return (0, _index2.default)(date).getTime() === (0, _index3.default)(date).getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 4786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMatch;
	
	var _index = _interopRequireDefault(__webpack_require__(715));
	
	var _index2 = _interopRequireDefault(__webpack_require__(208));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isMatch
	 * @category Common Helpers
	 * @summary validates the date string against given formats
	 *
	 * @description
	 * Return the true if given date is string correct against the given format else
	 * will return false.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * isMatch('23 AM', 'HH a')
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `isMatch('50', 'yy') //=> true`
	 *
	 *    `isMatch('75', 'yy') //=> true`
	 *
	 *    while `uu` will use the year as is:
	 *
	 *    `isMatch('50', 'uu') //=> true`
	 *
	 *    `isMatch('75', 'uu') //=> true`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be checked in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
	 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 *
	 *
	 * @param {String} dateString - the date string to verify
	 * @param {String} formatString - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Boolean}
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Match 11 February 2014 from middle-endian format:
	 * var result = isMatch('02/11/2014', 'MM/dd/yyyy')
	 * //=> true
	 *
	 * @example
	 * // Match 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = isMatch('28-a de februaro', "do 'de' MMMM", {
	 *   locale: eo
	 * })
	 * //=> true
	 */
	function isMatch(dateString, formatString, dirtyOptions) {
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)((0, _index.default)(dateString, formatString, new Date(), dirtyOptions));
	}
	
	module.exports = exports.default;

/***/ }),
/* 4787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMonday;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isMonday
	 * @category Weekday Helpers
	 * @summary Is the given date Monday?
	 *
	 * @description
	 * Is the given date Monday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 22 September 2014 Monday?
	 * var result = isMonday(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isMonday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPast;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isPast
	 * @category Common Helpers
	 * @summary Is the given date in the past?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the past?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the past
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 2 July 2014 in the past?
	 * var result = isPast(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isPast(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() < Date.now();
	}
	
	module.exports = exports.default;

/***/ }),
/* 4789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(716));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Are the given dates in the same ISO week-numbering year?
	 *
	 * @description
	 * Are the given dates in the same ISO week-numbering year?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isSameISOYear` to `isSameISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week-numbering year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
	 * var result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
	 * //=> true
	 */
	function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfYear = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfYear = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 4790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisHour;
	
	var _index = _interopRequireDefault(__webpack_require__(2215));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisHour
	 * @category Hour Helpers
	 * @summary Is the given date in the same hour as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same hour as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:00:00 in this hour?
	 * var result = isThisHour(new Date(2014, 8, 25, 18))
	 * //=> true
	 */
	function isThisHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(2216));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisISOWeek
	 * @category ISO Week Helpers
	 * @summary Is the given date in the same ISO week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same ISO week as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
	 * var result = isThisISOWeek(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isThisISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 4792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMinute;
	
	var _index = _interopRequireDefault(__webpack_require__(2217));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMinute
	 * @category Minute Helpers
	 * @summary Is the given date in the same minute as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same minute as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:00 in this minute?
	 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
	 * //=> true
	 */
	function isThisMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(2218));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisMonth
	 * @category Month Helpers
	 * @summary Is the given date in the same month as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same month as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 15 September 2014 in this month?
	 * var result = isThisMonth(new Date(2014, 8, 15))
	 * //=> true
	 */
	function isThisMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(2219));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisQuarter
	 * @category Quarter Helpers
	 * @summary Is the given date in the same quarter as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same quarter as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
	 * var result = isThisQuarter(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisSecond;
	
	var _index = _interopRequireDefault(__webpack_require__(2220));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisSecond
	 * @category Second Helpers
	 * @summary Is the given date in the same second as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same second as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:15.000 in this second?
	 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
	 * //=> true
	 */
	function isThisSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(1475));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisWeek
	 * @category Week Helpers
	 * @summary Is the given date in the same week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same week as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Object} [options] - the object with options
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the date is in this week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // If today is 25 September 2014, is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21))
	 * //=> true
	 *
	 * @example
	 * // If today is 25 September 2014 and week starts with Monday
	 * // is 21 September 2014 in this week?
	 * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
	 * //=> false
	 */
	function isThisWeek(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisYear;
	
	var _index = _interopRequireDefault(__webpack_require__(2221));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThisYear
	 * @category Year Helpers
	 * @summary Is the given date in the same year as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same year as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this year?
	 * var result = isThisYear(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 4798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThursday;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isThursday
	 * @category Weekday Helpers
	 * @summary Is the given date Thursday?
	 *
	 * @description
	 * Is the given date Thursday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 25 September 2014 Thursday?
	 * var result = isThursday(new Date(2014, 8, 25))
	 * //=> true
	 */
	function isThursday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 4;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isToday;
	
	var _index = _interopRequireDefault(__webpack_require__(714));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isToday
	 * @category Day Helpers
	 * @summary Is the given date today?
	 * @pure false
	 *
	 * @description
	 * Is the given date today?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * var result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 4800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTomorrow;
	
	var _index = _interopRequireDefault(__webpack_require__(369));
	
	var _index2 = _interopRequireDefault(__webpack_require__(714));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTomorrow
	 * @category Day Helpers
	 * @summary Is the given date tomorrow?
	 * @pure false
	 *
	 * @description
	 * Is the given date tomorrow?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is tomorrow
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
	 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
	 * //=> true
	 */
	function isTomorrow(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index2.default)(dirtyDate, (0, _index.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ }),
/* 4801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTuesday;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isTuesday
	 * @category Weekday Helpers
	 * @summary Is the given date Tuesday?
	 *
	 * @description
	 * Is the given date Tuesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 23 September 2014 Tuesday?
	 * var result = isTuesday(new Date(2014, 8, 23))
	 * //=> true
	 */
	function isTuesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 2;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWednesday;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWednesday
	 * @category Weekday Helpers
	 * @summary Is the given date Wednesday?
	 *
	 * @description
	 * Is the given date Wednesday?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 24 September 2014 Wednesday?
	 * var result = isWednesday(new Date(2014, 8, 24))
	 * //=> true
	 */
	function isWednesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 3;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4803 */
[6673, 31, 20],
/* 4804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isYesterday;
	
	var _index = _interopRequireDefault(__webpack_require__(714));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1482));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isYesterday
	 * @category Day Helpers
	 * @summary Is the given date yesterday?
	 * @pure false
	 *
	 * @description
	 * Is the given date yesterday?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is yesterday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
	 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
	 * //=> true
	 */
	function isYesterday(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, (0, _index2.default)(Date.now(), 1));
	}
	
	module.exports = exports.default;

/***/ }),
/* 4805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfDecade
	 * @category Decade Helpers
	 * @summary Return the last day of a decade for the given date.
	 *
	 * @description
	 * Return the last day of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a decade for 21 December 2012 21:12:00:
	 * var result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
	 * //=> Wed Dec 31 2019 00:00:00
	 */
	function lastDayOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(2224));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the last day of an ISO week for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week for 2 September 2014 11:55:00:
	 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	
	module.exports = exports.default;

/***/ }),
/* 4807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(561));
	
	var _index2 = _interopRequireDefault(__webpack_require__(455));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the last day of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `lastDayOfISOYear` to `lastDayOfISOWeekYear`.
	 *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
	 *   This change makes the name consistent with
	 *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week-numbering year for 2 July 2005:
	 * var result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 00:00:00
	 */
	function lastDayOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year + 1, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  date.setDate(date.getDate() - 1);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the last day of a year quarter for the given date.
	 *
	 * @description
	 * Return the last day of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the last day of a quarter
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The last day of a quarter for 2 September 2014 11:55:00:
	 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name lastDayOfYear
	 * @category Year Helpers
	 * @summary Return the last day of a year for the given date.
	 *
	 * @description
	 * Return the last day of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a year for 2 September 2014 11:55:00:
	 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 00:00:00
	 */
	function lastDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lightFormat;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2181));
	
	var _index3 = _interopRequireDefault(__webpack_require__(320));
	
	var _index4 = _interopRequireDefault(__webpack_require__(208));
	
	var _index5 = _interopRequireDefault(__webpack_require__(717));
	
	var _index6 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name lightFormat
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. Unlike `format`,
	 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
	 *
	 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   |
	 * |---------------------------------|---------|-----------------------------------|
	 * | AM, PM                          | a..aaa  | AM, PM                            |
	 * |                                 | aaaa    | a.m., p.m.                        |
	 * |                                 | aaaaa   | a, p                              |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
	 * |                                 | yy      | 44, 01, 00, 17                    |
	 * |                                 | yyy     | 044, 001, 000, 017                |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
	 * |                                 | MM      | 01, 02, ..., 12                   |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |
	 * |                                 | dd      | 01, 02, ..., 31                   |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |
	 * | Minute                          | m       | 0, 1, ..., 59                     |
	 * |                                 | mm      | 00, 01, ..., 59                   |
	 * | Second                          | s       | 0, 1, ..., 59                     |
	 * |                                 | ss      | 00, 01, ..., 59                   |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |
	 * |                                 | SS      | 00, 01, ..., 99                   |
	 * |                                 | SSS     | 000, 0001, ..., 999               |
	 * |                                 | SSSS    | ...                               |
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * var result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
	 * //=> '2014-02-11'
	 */
	
	function lightFormat(dirtyDate, dirtyFormatStr) {
	  (0, _index6.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var originalDate = (0, _index.default)(dirtyDate);
	
	  if (!(0, _index4.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index3.default)(originalDate);
	  var utcDate = (0, _index5.default)(originalDate, timezoneOffset);
	  var result = formatStr.match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index2.default[firstCharacter];
	
	    if (formatter) {
	      return formatter(utcDate, substring, null, {});
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 4811 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	
	function buildFormatLongFn(args) {
	  return function (dirtyOptions) {
	    var options = dirtyOptions || {};
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 4812 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var context = options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	
	      var _width = options.width ? String(options.width) : args.defaultWidth;
	
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
	    return valuesArray[index];
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 4813 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	
	function buildMatchFn(args) {
	  return function (dirtyString, dirtyOptions) {
	    var string = String(dirtyString);
	    var options = dirtyOptions || {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var value;
	
	    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
	      value = findIndex(parsePatterns, function (pattern) {
	        return pattern.test(matchedString);
	      });
	    } else {
	      value = findKey(parsePatterns, function (pattern) {
	        return pattern.test(matchedString);
	      });
	    }
	
	    value = args.valueCallback ? args.valueCallback(value) : value;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    return {
	      value: value,
	      rest: string.slice(matchedString.length)
	    };
	  };
	}
	
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	}
	
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 4814 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	
	function buildMatchPatternFn(args) {
	  return function (dirtyString, dirtyOptions) {
	    var string = String(dirtyString);
	    var options = dirtyOptions || {};
	    var matchResult = string.match(args.matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	
	    if (!parseResult) {
	      return null;
	    }
	
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    return {
	      value: value,
	      rest: string.slice(matchedString.length)
	    };
	  };
	}
	
	module.exports = exports.default;

/***/ }),
/* 4815 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4816 */
[6674, 4811],
/* 4817 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	
	function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	}
	
	module.exports = exports.default;

/***/ }),
/* 4818 */
[6675, 4812],
/* 4819 */
[6676, 4814, 4813],
/* 4820 */
[6678, 31, 20],
/* 4821 */
[6679, 31, 20],
/* 4822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1468));
	
	var _index2 = _interopRequireDefault(__webpack_require__(4718));
	
	var _index3 = _interopRequireDefault(__webpack_require__(4719));
	
	var _index4 = _interopRequireDefault(__webpack_require__(4720));
	
	var _index5 = _interopRequireDefault(__webpack_require__(4721));
	
	var _index6 = _interopRequireDefault(__webpack_require__(938));
	
	var _index7 = _interopRequireDefault(__webpack_require__(939));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_SECOND = 1000;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	
	};
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	
	function parseNumericPattern(pattern, string, valueCallback) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  }
	
	  var value = parseInt(matchResult[0], 10);
	  return {
	    value: valueCallback ? valueCallback(value) : value,
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseTimezonePattern(pattern, string) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  } // Input is 'Z'
	
	
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: string.slice(1)
	    };
	  }
	
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseAnyDigitsSigned(string, valueCallback) {
	  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
	}
	
	function parseNDigits(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function parseNDigitsSigned(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function dayPeriodEnumToHours(enumValue) {
	  switch (enumValue) {
	    case 'morning':
	      return 4;
	
	    case 'evening':
	      return 17;
	
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0; // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	
	  return isCommonEra ? result : 1 - result;
	}
	
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	
	
	var parsers = {
	  // Era
	  G: {
	    priority: 140,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	        // A, B
	
	        case 'GGGGG':
	          return match.era(string, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	
	        case 'GGGG':
	        default:
	          return match.era(string, {
	            width: 'wide'
	          }) || match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	      }
	    },
	    set: function (date, flags, value, _options) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['R', 'u', 't', 'T']
	  },
	  // Year
	  y: {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	
	      switch (token) {
	        case 'y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, _options) {
	      var currentYear = date.getUTCFullYear();
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week-numbering year
	  Y: {
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	
	      switch (token) {
	        case 'Y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'Yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index7.default)(date, options);
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index7.default)(date, options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week-numbering year
	  R: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'R') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (_date, _flags, value, _options) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index6.default)(firstWeekOfYear);
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Extended year
	  u: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'u') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Quarter
	  Q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'Qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'QQQ':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'QQQQQ':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'QQQQ':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone quarter
	  q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'qqq':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'qqqqq':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'qqqq':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Month
	  M: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'MM':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Mo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'MMM':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	
	        case 'MMMMM':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	
	        case 'MMMM':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone month
	  L: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'LL':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Lo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'LLL':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	
	        case 'LLLLL':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	
	        case 'LLLL':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week of year
	  w: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'w':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'wo':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index7.default)((0, _index5.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week of year
	  I: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'I':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'Io':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index6.default)((0, _index4.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Day of the month
	  d: {
	    priority: 90,
	    subPriority: 1,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'd':
	          return parseNumericPattern(numericPatterns.date, string);
	
	        case 'do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	      var month = date.getUTCMonth();
	
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of year
	  D: {
	    priority: 90,
	    subPriority: 1,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return parseNumericPattern(numericPatterns.dayOfYear, string);
	
	        case 'Do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of week
	  E: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'EEEEE':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'EEEEEE':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'EEEE':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local day of week
	  e: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'eo':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'eee':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'eeeee':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'eeeeee':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'eeee':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
	  },
	  // Stand-alone local day of week
	  c: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'co':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'ccc':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	
	        case 'ccccc':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	
	        case 'cccccc':
	          return match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	
	        case 'cccc':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
	  },
	  // ISO day of week
	  i: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        if (value === 0) {
	          return 7;
	        }
	
	        return value;
	      };
	
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return parseNDigits(token.length, string);
	        // 2nd
	
	        case 'io':
	          return match.ordinalNumber(string, {
	            unit: 'day'
	          });
	        // Tue
	
	        case 'iii':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // T
	
	        case 'iiiii':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tu
	
	        case 'iiiiii':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tuesday
	
	        case 'iiii':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 7;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index3.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
	  },
	  // AM or PM
	  a: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaaa':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaa':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // AM, PM, midnight
	  b: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbbb':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbb':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBBB':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBB':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 't', 'T']
	  },
	  // Hour [1-12]
	  h: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'h':
	          return parseNumericPattern(numericPatterns.hour12h, string);
	
	        case 'ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 12;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-23]
	  H: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'H':
	          return parseNumericPattern(numericPatterns.hour23h, string);
	
	        case 'Ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 23;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-11]
	  K: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'K':
	          return parseNumericPattern(numericPatterns.hour11h, string);
	
	        case 'Ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
	  },
	  // Hour [1-24]
	  k: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'k':
	          return parseNumericPattern(numericPatterns.hour24h, string);
	
	        case 'ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 24;
	    },
	    set: function (date, _flags, value, _options) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
	  },
	  // Minute
	  m: {
	    priority: 60,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'm':
	          return parseNumericPattern(numericPatterns.minute, string);
	
	        case 'mo':
	          return match.ordinalNumber(string, {
	            unit: 'minute'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Second
	  s: {
	    priority: 50,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 's':
	          return parseNumericPattern(numericPatterns.second, string);
	
	        case 'so':
	          return match.ordinalNumber(string, {
	            unit: 'second'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Fraction of second
	  S: {
	    priority: 30,
	    parse: function (string, token, _match, _options) {
	      var valueCallback = function (value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	
	      return parseNDigits(token.length, string, valueCallback);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMilliseconds(value);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Timezone (ISO-8601. +00:00 is `'Z'`)
	  X: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'X':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'XX':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'XXXX':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'XXXXX':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'XXX':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'x']
	  },
	  // Timezone (ISO-8601)
	  x: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'x':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'xx':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'xxxx':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'xxxxx':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'xxx':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'X']
	  },
	  // Seconds timestamp
	  t: {
	    priority: 40,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  },
	  // Milliseconds timestamp
	  T: {
	    priority: 20,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  }
	};
	var _default = parsers;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 4823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseJSON;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name parseJSON
	 * @category Common Helpers
	 * @summary Parse a JSON date string
	 *
	 * @description
	 * Converts a complete ISO date string in UTC time, the typical format for transmitting
	 * a date in JSON, to a JavaScript `Date` instance.
	 *
	 * This is a minimal implementation for converting dates retrieved from a JSON API to
	 * a `Date` instance which can be used with other functions in the `date-fns` library.
	 * The following formats are supported:
	 *
	 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
	 * - `2000-03-15T05:20:10Z`: Without milliseconds
	 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
	 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
	 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
	 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
	 *
	 * For convenience and ease of use these other input types are also supported
	 * via [toDate]{@link https://date-fns.org/docs/toDate}:
	 *
	 * - A `Date` instance will be cloned
	 * - A `number` will be treated as a timestamp
	 *
	 * Any other input type or invalid date strings will return an `Invalid Date`.
	 *
	 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 */
	function parseJSON(argument) {
	  (0, _index2.default)(1, arguments);
	
	  if (typeof argument === 'string') {
	    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|\+00:?00)?/);
	
	    if (parts) {
	      return new Date(Date.UTC(+parts[1], parts[2] - 1, +parts[3], +parts[4], +parts[5], +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
	    }
	
	    return new Date(NaN);
	  }
	
	  return (0, _index.default)(argument);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = roundToNearestMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(53));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name roundToNearestMinutes
	 * @category Minute Helpers
	 * @summary Rounds the given date to the nearest minute
	 *
	 * @description
	 * Rounds the given date to the nearest minute (or number of minutes).
	 * Rounds up when the given date is exactly between the nearest round minutes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to round
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
	 * @returns {Date} the new date rounded to the closest minute
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
	 *
	 * @example
	 * // Round 10 July 2014 12:12:34 to nearest minute:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
	 * //=> Thu Jul 10 2014 12:13:00
	 *
	 * @example
	 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
	 * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
	 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
	 * //=> Thu Jul 10 2014 12:15:00
	 */
	function roundToNearestMinutes(dirtyDate, options) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only none provided present');
	  }
	
	  var nearestTo = options && 'nearestTo' in options ? (0, _index2.default)(options.nearestTo) : 1;
	
	  if (nearestTo < 1 || nearestTo > 30) {
	    throw new RangeError('`options.nearestTo` must be between 1 and 30');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
	
	  var minutes = date.getMinutes() + seconds / 60;
	  var roundedMinutes = Math.floor(minutes / nearestTo) * nearestTo;
	  var remainderMinutes = minutes % nearestTo;
	  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4825 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = set;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1478));
	
	var _index3 = _interopRequireDefault(__webpack_require__(53));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name set
	 * @category Common Helpers
	 * @summary Set date values to a given date.
	 *
	 * @description
	 * Set date values to a given date.
	 *
	 * Sets time values to date from object `values`.
	 * A value is not set if it is undefined or null or doesn't exist in `values`.
	 *
	 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
	 * to use native `Date#setX` methods. If you use this function, you may not want to include the
	 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Object} values - an object with options
	 * @param {Number} [values.year] - the number of years to be set
	 * @param {Number} [values.month] - the number of months to be set
	 * @param {Number} [values.date] - the number of days to be set
	 * @param {Number} [values.hours] - the number of hours to be set
	 * @param {Number} [values.minutes] - the number of minutes to be set
	 * @param {Number} [values.seconds] - the number of seconds to be set
	 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
	 * @returns {Date} the new date with options set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `values` must be an object
	 *
	 * @example
	 * // Transform 1 September 2014 into 20 October 2015 in a single line:
	 * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
	 * //=> Tue Oct 20 2015 00:00:00
	 *
	 * @example
	 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
	 * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
	 * //=> Mon Sep 01 2014 12:23:45
	 */
	function set(dirtyDate, values) {
	  (0, _index4.default)(2, arguments);
	
	  if (typeof values !== 'object' || values === null) {
	    throw new RangeError('values parameter must be an object');
	  }
	
	  var date = (0, _index.default)(dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  }
	
	  if (values.year != null) {
	    date.setFullYear(values.year);
	  }
	
	  if (values.month != null) {
	    date = (0, _index2.default)(date, values.month);
	  }
	
	  if (values.date != null) {
	    date.setDate((0, _index3.default)(values.date));
	  }
	
	  if (values.hours != null) {
	    date.setHours((0, _index3.default)(values.hours));
	  }
	
	  if (values.minutes != null) {
	    date.setMinutes((0, _index3.default)(values.minutes));
	  }
	
	  if (values.seconds != null) {
	    date.setSeconds((0, _index3.default)(values.seconds));
	  }
	
	  if (values.milliseconds != null) {
	    date.setMilliseconds((0, _index3.default)(values.milliseconds));
	  }
	
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDate;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDate
	 * @category Day Helpers
	 * @summary Set the day of the month to the given date.
	 *
	 * @description
	 * Set the day of the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfMonth - the day of the month of the new date
	 * @returns {Date} the new date with the day of the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 30th day of the month to 1 September 2014:
	 * var result = setDate(new Date(2014, 8, 1), 30)
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function setDate(dirtyDate, dirtyDayOfMonth) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfMonth = (0, _index.default)(dirtyDayOfMonth);
	  date.setDate(dayOfMonth);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDay;
	
	var _index = _interopRequireDefault(__webpack_require__(369));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(53));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDay
	 * @category Weekday Helpers
	 * @summary Set the day of the week to the given date.
	 *
	 * @description
	 * Set the day of the week to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the new date with the day of the week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
	 * var result = setDay(new Date(2014, 8, 1), 0)
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Set week day to Sunday, with a weekStartsOn of Monday:
	 * var result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index4.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index3.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index3.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate, options);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var delta = 7 - weekStartsOn;
	  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
	  return (0, _index.default)(date, diff, options);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setDayOfYear
	 * @category Day Helpers
	 * @summary Set the day of the year to the given date.
	 *
	 * @description
	 * Set the day of the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfYear - the day of the year of the new date
	 * @returns {Date} the new date with the day of the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd day of the year to 2 July 2014:
	 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
	 * //=> Thu Jan 02 2014 00:00:00
	 */
	function setDayOfYear(dirtyDate, dirtyDayOfYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfYear = (0, _index.default)(dirtyDayOfYear);
	  date.setMonth(0);
	  date.setDate(dayOfYear);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4829 */
[6680, 53, 31, 20],
/* 4830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(369));
	
	var _index4 = _interopRequireDefault(__webpack_require__(2207));
	
	var _index5 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISODay
	 * @category Weekday Helpers
	 * @summary Set the day of the ISO week to the given date.
	 *
	 * @description
	 * Set the day of the ISO week to the given date.
	 * ISO week starts with Monday.
	 * 7 is the index of Sunday, 1 is the index of Monday etc.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the ISO week of the new date
	 * @returns {Date} the new date with the day of the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * var result = setISODay(new Date(2014, 8, 1), 7)
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setISODay(dirtyDate, dirtyDay) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = (0, _index4.default)(date);
	  var diff = day - currentDay;
	  return (0, _index3.default)(date, diff);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2208));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setISOWeek
	 * @category ISO Week Helpers
	 * @summary Set the ISO week to the given date.
	 *
	 * @description
	 * Set the ISO week to the given date, saving the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeek - the ISO week of the new date
	 * @returns {Date} the new date with the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 53rd ISO week to 7 August 2004:
	 * var result = setISOWeek(new Date(2004, 7, 7), 53)
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMilliseconds;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMilliseconds
	 * @category Millisecond Helpers
	 * @summary Set the milliseconds to the given date.
	 *
	 * @description
	 * Set the milliseconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} milliseconds - the milliseconds of the new date
	 * @returns {Date} the new date with the milliseconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
	 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
	 * //=> Mon Sep 01 2014 11:30:40.300
	 */
	function setMilliseconds(dirtyDate, dirtyMilliseconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var milliseconds = (0, _index.default)(dirtyMilliseconds);
	  date.setMilliseconds(milliseconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4833 */
[6681, 53, 31, 20],
/* 4834 */
[6683, 53, 31, 1478, 20],
/* 4835 */
[6684, 53, 31, 20],
/* 4836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(2211));
	
	var _index2 = _interopRequireDefault(__webpack_require__(31));
	
	var _index3 = _interopRequireDefault(__webpack_require__(53));
	
	var _index4 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeek
	 * @category Week Helpers
	 * @summary Set the local week to the given date.
	 *
	 * @description
	 * Set the local week to the given date, saving the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} week - the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005 with default options:
	 * var result = setWeek(new Date(2005, 0, 2), 1)
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January:
	 * var result = setWeek(new Date(2005, 0, 2), 1, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sun Jan 4 2004 00:00:00
	 */
	function setWeek(dirtyDate, dirtyWeek, dirtyOptions) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index3.default)(dirtyWeek);
	  var diff = (0, _index.default)(date, dirtyOptions) - week;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(453));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1480));
	
	var _index3 = _interopRequireDefault(__webpack_require__(31));
	
	var _index4 = _interopRequireDefault(__webpack_require__(53));
	
	var _index5 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Set the local week-numbering year to the given date.
	 *
	 * @description
	 * Set the local week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} weekYear - the local week-numbering year of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004)
	 * //=> Sat Jan 03 2004 00:00:00
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010,
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setWeekYear(dirtyDate, dirtyWeekYear, dirtyOptions) {
	  (0, _index5.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index4.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index4.default)(options.firstWeekContainsDate);
	  var date = (0, _index3.default)(dirtyDate);
	  var weekYear = (0, _index4.default)(dirtyWeekYear);
	  var diff = (0, _index.default)(date, (0, _index2.default)(date, dirtyOptions));
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  date = (0, _index2.default)(firstWeek, dirtyOptions);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4838 */
[6685, 53, 31, 20],
/* 4839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDecade;
	
	var _index = _interopRequireDefault(__webpack_require__(31));
	
	var _index2 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDecade
	 * @category Decade Helpers
	 * @summary Return the start of a decade for the given date.
	 *
	 * @description
	 * Return the start of a decade for the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a decade for 21 October 2015 00:00:00:
	 * var result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
	 * //=> Jan 01 2010 00:00:00
	 */
	function startOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfToday;
	
	var _index = _interopRequireDefault(__webpack_require__(945));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfToday
	 * @category Day Helpers
	 * @summary Return the start of today.
	 * @pure false
	 *
	 * @description
	 * Return the start of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfToday()
	 * //=> Mon Oct 6 2014 00:00:00
	 */
	function startOfToday() {
	  return (0, _index.default)(Date.now());
	}
	
	module.exports = exports.default;

/***/ }),
/* 4841 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfTomorrow;
	
	/**
	 * @name startOfTomorrow
	 * @category Day Helpers
	 * @summary Return the start of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the start of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfTomorrow()
	 * //=> Tue Oct 7 2014 00:00:00
	 */
	function startOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4842 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYesterday;
	
	/**
	 * @name startOfYesterday
	 * @category Day Helpers
	 * @summary Return the start of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the start of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @returns {Date} the start of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * var result = startOfYesterday()
	 * //=> Sun Oct 5 2014 00:00:00
	 */
	function startOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 4843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subBusinessDays;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2187));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subBusinessDays
	 * @category Day Helpers
	 * @summary Substract the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Substract 10 business days from 1 September 2014:
	 * var result = subBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
	 */
	function subBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1469));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2189));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subQuarters;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1470));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subQuarters
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * var result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2190));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subSeconds
	 * @category Second Helpers
	 * @summary Subtract the specified number of seconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of seconds from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 seconds from 10 July 2014 12:45:00:
	 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:44:30
	 */
	function subSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(940));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * var result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	
	var _index = _interopRequireDefault(__webpack_require__(53));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2191));
	
	var _index3 = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * var result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 4850 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 4851 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(4853);
	var isArguments = __webpack_require__(4852);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 4852 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 4853 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 4854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _redux = __webpack_require__(98);
	
	var _reducers = _interopRequireDefault(__webpack_require__(4869));
	
	var _dragDrop = _interopRequireDefault(__webpack_require__(948));
	
	var _DragDropMonitorImpl = _interopRequireDefault(__webpack_require__(4855));
	
	var _HandlerRegistryImpl = _interopRequireDefault(__webpack_require__(4856));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function makeStoreInstance(debugMode) {
	  // TODO: if we ever make a react-native version of this,
	  // we'll need to consider how to pull off dev-tooling
	  var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
	  return (0, _redux.createStore)(_reducers.default, debugMode && reduxDevTools && reduxDevTools({
	    name: 'dnd-core',
	    instanceId: 'dnd-core'
	  }));
	}
	
	var DragDropManagerImpl =
	/*#__PURE__*/
	function () {
	  function DragDropManagerImpl() {
	    var _this = this;
	
	    var debugMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    _classCallCheck(this, DragDropManagerImpl);
	
	    this.isSetUp = false;
	
	    this.handleRefCountChange = function () {
	      var shouldSetUp = _this.store.getState().refCount > 0;
	
	      if (_this.backend) {
	        if (shouldSetUp && !_this.isSetUp) {
	          _this.backend.setup();
	
	          _this.isSetUp = true;
	        } else if (!shouldSetUp && _this.isSetUp) {
	          _this.backend.teardown();
	
	          _this.isSetUp = false;
	        }
	      }
	    };
	
	    var store = makeStoreInstance(debugMode);
	    this.store = store;
	    this.monitor = new _DragDropMonitorImpl.default(store, new _HandlerRegistryImpl.default(store));
	    store.subscribe(this.handleRefCountChange);
	  }
	
	  _createClass(DragDropManagerImpl, [{
	    key: "receiveBackend",
	    value: function receiveBackend(backend) {
	      this.backend = backend;
	    }
	  }, {
	    key: "getMonitor",
	    value: function getMonitor() {
	      return this.monitor;
	    }
	  }, {
	    key: "getBackend",
	    value: function getBackend() {
	      return this.backend;
	    }
	  }, {
	    key: "getRegistry",
	    value: function getRegistry() {
	      return this.monitor.registry;
	    }
	  }, {
	    key: "getActions",
	    value: function getActions() {
	      /* eslint-disable-next-line @typescript-eslint/no-this-alias */
	      var manager = this;
	      var dispatch = this.store.dispatch;
	
	      function bindActionCreator(actionCreator) {
	        return function () {
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          var action = actionCreator.apply(manager, args);
	
	          if (typeof action !== 'undefined') {
	            dispatch(action);
	          }
	        };
	      }
	
	      var actions = (0, _dragDrop.default)(this);
	      return Object.keys(actions).reduce(function (boundActions, key) {
	        var action = actions[key];
	        boundActions[key] = bindActionCreator(action);
	        return boundActions;
	      }, {});
	    }
	  }, {
	    key: "dispatch",
	    value: function dispatch(action) {
	      this.store.dispatch(action);
	    }
	  }]);
	
	  return DragDropManagerImpl;
	}();
	
	exports.default = DragDropManagerImpl;

/***/ }),
/* 4855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _invariant = __webpack_require__(129);
	
	var _matchesType = _interopRequireDefault(__webpack_require__(2235));
	
	var _coords = __webpack_require__(4872);
	
	var _dirtiness = __webpack_require__(2233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var DragDropMonitorImpl =
	/*#__PURE__*/
	function () {
	  function DragDropMonitorImpl(store, registry) {
	    _classCallCheck(this, DragDropMonitorImpl);
	
	    this.store = store;
	    this.registry = registry;
	  }
	
	  _createClass(DragDropMonitorImpl, [{
	    key: "subscribeToStateChange",
	    value: function subscribeToStateChange(listener) {
	      var _this = this;
	
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	        handlerIds: undefined
	      };
	      var handlerIds = options.handlerIds;
	      (0, _invariant.invariant)(typeof listener === 'function', 'listener must be a function.');
	      (0, _invariant.invariant)(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
	      var prevStateId = this.store.getState().stateId;
	
	      var handleChange = function handleChange() {
	        var state = _this.store.getState();
	
	        var currentStateId = state.stateId;
	
	        try {
	          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtiness.areDirty)(state.dirtyHandlerIds, handlerIds);
	
	          if (!canSkipListener) {
	            listener();
	          }
	        } finally {
	          prevStateId = currentStateId;
	        }
	      };
	
	      return this.store.subscribe(handleChange);
	    }
	  }, {
	    key: "subscribeToOffsetChange",
	    value: function subscribeToOffsetChange(listener) {
	      var _this2 = this;
	
	      (0, _invariant.invariant)(typeof listener === 'function', 'listener must be a function.');
	      var previousState = this.store.getState().dragOffset;
	
	      var handleChange = function handleChange() {
	        var nextState = _this2.store.getState().dragOffset;
	
	        if (nextState === previousState) {
	          return;
	        }
	
	        previousState = nextState;
	        listener();
	      };
	
	      return this.store.subscribe(handleChange);
	    }
	  }, {
	    key: "canDragSource",
	    value: function canDragSource(sourceId) {
	      if (!sourceId) {
	        return false;
	      }
	
	      var source = this.registry.getSource(sourceId);
	      (0, _invariant.invariant)(source, 'Expected to find a valid source.');
	
	      if (this.isDragging()) {
	        return false;
	      }
	
	      return source.canDrag(this, sourceId);
	    }
	  }, {
	    key: "canDropOnTarget",
	    value: function canDropOnTarget(targetId) {
	      // undefined on initial render
	      if (!targetId) {
	        return false;
	      }
	
	      var target = this.registry.getTarget(targetId);
	      (0, _invariant.invariant)(target, 'Expected to find a valid target.');
	
	      if (!this.isDragging() || this.didDrop()) {
	        return false;
	      }
	
	      var targetType = this.registry.getTargetType(targetId);
	      var draggedItemType = this.getItemType();
	      return (0, _matchesType.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
	    }
	  }, {
	    key: "isDragging",
	    value: function isDragging() {
	      return Boolean(this.getItemType());
	    }
	  }, {
	    key: "isDraggingSource",
	    value: function isDraggingSource(sourceId) {
	      // undefined on initial render
	      if (!sourceId) {
	        return false;
	      }
	
	      var source = this.registry.getSource(sourceId, true);
	      (0, _invariant.invariant)(source, 'Expected to find a valid source.');
	
	      if (!this.isDragging() || !this.isSourcePublic()) {
	        return false;
	      }
	
	      var sourceType = this.registry.getSourceType(sourceId);
	      var draggedItemType = this.getItemType();
	
	      if (sourceType !== draggedItemType) {
	        return false;
	      }
	
	      return source.isDragging(this, sourceId);
	    }
	  }, {
	    key: "isOverTarget",
	    value: function isOverTarget(targetId) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	        shallow: false
	      };
	
	      // undefined on initial render
	      if (!targetId) {
	        return false;
	      }
	
	      var shallow = options.shallow;
	
	      if (!this.isDragging()) {
	        return false;
	      }
	
	      var targetType = this.registry.getTargetType(targetId);
	      var draggedItemType = this.getItemType();
	
	      if (draggedItemType && !(0, _matchesType.default)(targetType, draggedItemType)) {
	        return false;
	      }
	
	      var targetIds = this.getTargetIds();
	
	      if (!targetIds.length) {
	        return false;
	      }
	
	      var index = targetIds.indexOf(targetId);
	
	      if (shallow) {
	        return index === targetIds.length - 1;
	      } else {
	        return index > -1;
	      }
	    }
	  }, {
	    key: "getItemType",
	    value: function getItemType() {
	      return this.store.getState().dragOperation.itemType;
	    }
	  }, {
	    key: "getItem",
	    value: function getItem() {
	      return this.store.getState().dragOperation.item;
	    }
	  }, {
	    key: "getSourceId",
	    value: function getSourceId() {
	      return this.store.getState().dragOperation.sourceId;
	    }
	  }, {
	    key: "getTargetIds",
	    value: function getTargetIds() {
	      return this.store.getState().dragOperation.targetIds;
	    }
	  }, {
	    key: "getDropResult",
	    value: function getDropResult() {
	      return this.store.getState().dragOperation.dropResult;
	    }
	  }, {
	    key: "didDrop",
	    value: function didDrop() {
	      return this.store.getState().dragOperation.didDrop;
	    }
	  }, {
	    key: "isSourcePublic",
	    value: function isSourcePublic() {
	      return this.store.getState().dragOperation.isSourcePublic;
	    }
	  }, {
	    key: "getInitialClientOffset",
	    value: function getInitialClientOffset() {
	      return this.store.getState().dragOffset.initialClientOffset;
	    }
	  }, {
	    key: "getInitialSourceClientOffset",
	    value: function getInitialSourceClientOffset() {
	      return this.store.getState().dragOffset.initialSourceClientOffset;
	    }
	  }, {
	    key: "getClientOffset",
	    value: function getClientOffset() {
	      return this.store.getState().dragOffset.clientOffset;
	    }
	  }, {
	    key: "getSourceClientOffset",
	    value: function getSourceClientOffset() {
	      return (0, _coords.getSourceClientOffset)(this.store.getState().dragOffset);
	    }
	  }, {
	    key: "getDifferenceFromInitialOffset",
	    value: function getDifferenceFromInitialOffset() {
	      return (0, _coords.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
	    }
	  }]);
	
	  return DragDropMonitorImpl;
	}();
	
	exports.default = DragDropMonitorImpl;

/***/ }),
/* 4856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _invariant = __webpack_require__(129);
	
	var _registry = __webpack_require__(949);
	
	var _getNextUniqueId = _interopRequireDefault(__webpack_require__(4873));
	
	var _interfaces = __webpack_require__(2232);
	
	var _contracts = __webpack_require__(4863);
	
	var _asap = __webpack_require__(2905);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function getNextHandlerId(role) {
	  var id = (0, _getNextUniqueId.default)().toString();
	
	  switch (role) {
	    case _interfaces.HandlerRole.SOURCE:
	      return "S".concat(id);
	
	    case _interfaces.HandlerRole.TARGET:
	      return "T".concat(id);
	
	    default:
	      throw new Error("Unknown Handler Role: ".concat(role));
	  }
	}
	
	function parseRoleFromHandlerId(handlerId) {
	  switch (handlerId[0]) {
	    case 'S':
	      return _interfaces.HandlerRole.SOURCE;
	
	    case 'T':
	      return _interfaces.HandlerRole.TARGET;
	
	    default:
	      (0, _invariant.invariant)(false, "Cannot parse handler ID: ".concat(handlerId));
	  }
	}
	
	function mapContainsValue(map, searchValue) {
	  var entries = map.entries();
	  var isDone = false;
	
	  do {
	    var _entries$next = entries.next(),
	        done = _entries$next.done,
	        _entries$next$value = _slicedToArray(_entries$next.value, 2),
	        value = _entries$next$value[1];
	
	    if (value === searchValue) {
	      return true;
	    }
	
	    isDone = !!done;
	  } while (!isDone);
	
	  return false;
	}
	
	var HandlerRegistryImpl =
	/*#__PURE__*/
	function () {
	  function HandlerRegistryImpl(store) {
	    _classCallCheck(this, HandlerRegistryImpl);
	
	    this.types = new Map();
	    this.dragSources = new Map();
	    this.dropTargets = new Map();
	    this.pinnedSourceId = null;
	    this.pinnedSource = null;
	    this.store = store;
	  }
	
	  _createClass(HandlerRegistryImpl, [{
	    key: "addSource",
	    value: function addSource(type, source) {
	      (0, _contracts.validateType)(type);
	      (0, _contracts.validateSourceContract)(source);
	      var sourceId = this.addHandler(_interfaces.HandlerRole.SOURCE, type, source);
	      this.store.dispatch((0, _registry.addSource)(sourceId));
	      return sourceId;
	    }
	  }, {
	    key: "addTarget",
	    value: function addTarget(type, target) {
	      (0, _contracts.validateType)(type, true);
	      (0, _contracts.validateTargetContract)(target);
	      var targetId = this.addHandler(_interfaces.HandlerRole.TARGET, type, target);
	      this.store.dispatch((0, _registry.addTarget)(targetId));
	      return targetId;
	    }
	  }, {
	    key: "containsHandler",
	    value: function containsHandler(handler) {
	      return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
	    }
	  }, {
	    key: "getSource",
	    value: function getSource(sourceId) {
	      var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      (0, _invariant.invariant)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	      var isPinned = includePinned && sourceId === this.pinnedSourceId;
	      var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
	      return source;
	    }
	  }, {
	    key: "getTarget",
	    value: function getTarget(targetId) {
	      (0, _invariant.invariant)(this.isTargetId(targetId), 'Expected a valid target ID.');
	      return this.dropTargets.get(targetId);
	    }
	  }, {
	    key: "getSourceType",
	    value: function getSourceType(sourceId) {
	      (0, _invariant.invariant)(this.isSourceId(sourceId), 'Expected a valid source ID.');
	      return this.types.get(sourceId);
	    }
	  }, {
	    key: "getTargetType",
	    value: function getTargetType(targetId) {
	      (0, _invariant.invariant)(this.isTargetId(targetId), 'Expected a valid target ID.');
	      return this.types.get(targetId);
	    }
	  }, {
	    key: "isSourceId",
	    value: function isSourceId(handlerId) {
	      var role = parseRoleFromHandlerId(handlerId);
	      return role === _interfaces.HandlerRole.SOURCE;
	    }
	  }, {
	    key: "isTargetId",
	    value: function isTargetId(handlerId) {
	      var role = parseRoleFromHandlerId(handlerId);
	      return role === _interfaces.HandlerRole.TARGET;
	    }
	  }, {
	    key: "removeSource",
	    value: function removeSource(sourceId) {
	      var _this = this;
	
	      (0, _invariant.invariant)(this.getSource(sourceId), 'Expected an existing source.');
	      this.store.dispatch((0, _registry.removeSource)(sourceId));
	      (0, _asap.asap)(function () {
	        _this.dragSources.delete(sourceId);
	
	        _this.types.delete(sourceId);
	      });
	    }
	  }, {
	    key: "removeTarget",
	    value: function removeTarget(targetId) {
	      (0, _invariant.invariant)(this.getTarget(targetId), 'Expected an existing target.');
	      this.store.dispatch((0, _registry.removeTarget)(targetId));
	      this.dropTargets.delete(targetId);
	      this.types.delete(targetId);
	    }
	  }, {
	    key: "pinSource",
	    value: function pinSource(sourceId) {
	      var source = this.getSource(sourceId);
	      (0, _invariant.invariant)(source, 'Expected an existing source.');
	      this.pinnedSourceId = sourceId;
	      this.pinnedSource = source;
	    }
	  }, {
	    key: "unpinSource",
	    value: function unpinSource() {
	      (0, _invariant.invariant)(this.pinnedSource, 'No source is pinned at the time.');
	      this.pinnedSourceId = null;
	      this.pinnedSource = null;
	    }
	  }, {
	    key: "addHandler",
	    value: function addHandler(role, type, handler) {
	      var id = getNextHandlerId(role);
	      this.types.set(id, type);
	
	      if (role === _interfaces.HandlerRole.SOURCE) {
	        this.dragSources.set(id, handler);
	      } else if (role === _interfaces.HandlerRole.TARGET) {
	        this.dropTargets.set(id, handler);
	      }
	
	      return id;
	    }
	  }]);
	
	  return HandlerRegistryImpl;
	}();
	
	exports.default = HandlerRegistryImpl;

/***/ }),
/* 4857 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBeginDrag;
	
	var _invariant = __webpack_require__(129);
	
	var _setClientOffset = __webpack_require__(4861);
	
	var _js_utils = __webpack_require__(562);
	
	var _types = __webpack_require__(456);
	
	var ResetCoordinatesAction = {
	  type: _types.INIT_COORDS,
	  payload: {
	    clientOffset: null,
	    sourceClientOffset: null
	  }
	};
	
	function createBeginDrag(manager) {
	  return function beginDrag() {
	    var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
	      publishSource: true
	    };
	    var _options$publishSourc = options.publishSource,
	        publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc,
	        clientOffset = options.clientOffset,
	        getSourceClientOffset = options.getSourceClientOffset;
	    var monitor = manager.getMonitor();
	    var registry = manager.getRegistry(); // Initialize the coordinates using the client offset
	
	    manager.dispatch((0, _setClientOffset.setClientOffset)(clientOffset));
	    verifyInvariants(sourceIds, monitor, registry); // Get the draggable source
	
	    var sourceId = getDraggableSource(sourceIds, monitor);
	
	    if (sourceId === null) {
	      manager.dispatch(ResetCoordinatesAction);
	      return;
	    } // Get the source client offset
	
	
	    var sourceClientOffset = null;
	
	    if (clientOffset) {
	      verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
	      sourceClientOffset = getSourceClientOffset(sourceId);
	    } // Initialize the full coordinates
	
	
	    manager.dispatch((0, _setClientOffset.setClientOffset)(clientOffset, sourceClientOffset));
	    var source = registry.getSource(sourceId);
	    var item = source.beginDrag(monitor, sourceId);
	    verifyItemIsObject(item);
	    registry.pinSource(sourceId);
	    var itemType = registry.getSourceType(sourceId);
	    return {
	      type: _types.BEGIN_DRAG,
	      payload: {
	        itemType: itemType,
	        item: item,
	        sourceId: sourceId,
	        clientOffset: clientOffset || null,
	        sourceClientOffset: sourceClientOffset || null,
	        isSourcePublic: !!publishSource
	      }
	    };
	  };
	}
	
	function verifyInvariants(sourceIds, monitor, registry) {
	  (0, _invariant.invariant)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	  sourceIds.forEach(function (sourceId) {
	    (0, _invariant.invariant)(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
	  });
	}
	
	function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
	  (0, _invariant.invariant)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
	}
	
	function verifyItemIsObject(item) {
	  (0, _invariant.invariant)((0, _js_utils.isObject)(item), 'Item must be an object.');
	}
	
	function getDraggableSource(sourceIds, monitor) {
	  var sourceId = null;
	
	  for (var i = sourceIds.length - 1; i >= 0; i--) {
	    if (monitor.canDragSource(sourceIds[i])) {
	      sourceId = sourceIds[i];
	      break;
	    }
	  }
	
	  return sourceId;
	}

/***/ }),
/* 4858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createDrop;
	
	var _invariant = __webpack_require__(129);
	
	var _types = __webpack_require__(456);
	
	var _js_utils = __webpack_require__(562);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function createDrop(manager) {
	  return function drop() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var monitor = manager.getMonitor();
	    var registry = manager.getRegistry();
	    verifyInvariants(monitor);
	    var targetIds = getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action
	
	    targetIds.forEach(function (targetId, index) {
	      var dropResult = determineDropResult(targetId, index, registry, monitor);
	      var action = {
	        type: _types.DROP,
	        payload: {
	          dropResult: _objectSpread({}, options, {}, dropResult)
	        }
	      };
	      manager.dispatch(action);
	    });
	  };
	}
	
	function verifyInvariants(monitor) {
	  (0, _invariant.invariant)(monitor.isDragging(), 'Cannot call drop while not dragging.');
	  (0, _invariant.invariant)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	}
	
	function determineDropResult(targetId, index, registry, monitor) {
	  var target = registry.getTarget(targetId);
	  var dropResult = target ? target.drop(monitor, targetId) : undefined;
	  verifyDropResultType(dropResult);
	
	  if (typeof dropResult === 'undefined') {
	    dropResult = index === 0 ? {} : monitor.getDropResult();
	  }
	
	  return dropResult;
	}
	
	function verifyDropResultType(dropResult) {
	  (0, _invariant.invariant)(typeof dropResult === 'undefined' || (0, _js_utils.isObject)(dropResult), 'Drop result must either be an object or undefined.');
	}
	
	function getDroppableTargets(monitor) {
	  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	  targetIds.reverse();
	  return targetIds;
	}

/***/ }),
/* 4859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createEndDrag;
	
	var _invariant = __webpack_require__(129);
	
	var _types = __webpack_require__(456);
	
	function createEndDrag(manager) {
	  return function endDrag() {
	    var monitor = manager.getMonitor();
	    var registry = manager.getRegistry();
	    verifyIsDragging(monitor);
	    var sourceId = monitor.getSourceId();
	    var source = registry.getSource(sourceId, true);
	    source.endDrag(monitor, sourceId);
	    registry.unpinSource();
	    return {
	      type: _types.END_DRAG
	    };
	  };
	}
	
	function verifyIsDragging(monitor) {
	  (0, _invariant.invariant)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	}

/***/ }),
/* 4860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createHover;
	
	var _invariant = __webpack_require__(129);
	
	var _matchesType = _interopRequireDefault(__webpack_require__(2235));
	
	var _types = __webpack_require__(456);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createHover(manager) {
	  return function hover(targetIdsArg) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        clientOffset = _ref.clientOffset;
	
	    verifyTargetIdsIsArray(targetIdsArg);
	    var targetIds = targetIdsArg.slice(0);
	    var monitor = manager.getMonitor();
	    var registry = manager.getRegistry();
	    checkInvariants(targetIds, monitor, registry);
	    var draggedItemType = monitor.getItemType();
	    removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
	    hoverAllTargets(targetIds, monitor, registry);
	    return {
	      type: _types.HOVER,
	      payload: {
	        targetIds: targetIds,
	        clientOffset: clientOffset || null
	      }
	    };
	  };
	}
	
	function verifyTargetIdsIsArray(targetIdsArg) {
	  (0, _invariant.invariant)(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
	}
	
	function checkInvariants(targetIds, monitor, registry) {
	  (0, _invariant.invariant)(monitor.isDragging(), 'Cannot call hover while not dragging.');
	  (0, _invariant.invariant)(!monitor.didDrop(), 'Cannot call hover after drop.');
	
	  for (var i = 0; i < targetIds.length; i++) {
	    var targetId = targetIds[i];
	    (0, _invariant.invariant)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	    var target = registry.getTarget(targetId);
	    (0, _invariant.invariant)(target, 'Expected targetIds to be registered.');
	  }
	}
	
	function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
	  // Remove those targetIds that don't match the targetType.  This
	  // fixes shallow isOver which would only be non-shallow because of
	  // non-matching targets.
	  for (var i = targetIds.length - 1; i >= 0; i--) {
	    var targetId = targetIds[i];
	    var targetType = registry.getTargetType(targetId);
	
	    if (!(0, _matchesType.default)(targetType, draggedItemType)) {
	      targetIds.splice(i, 1);
	    }
	  }
	}
	
	function hoverAllTargets(targetIds, monitor, registry) {
	  // Finally call hover on all matching targets.
	  targetIds.forEach(function (targetId) {
	    var target = registry.getTarget(targetId);
	    target.hover(monitor, targetId);
	  });
	}

/***/ }),
/* 4861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setClientOffset = setClientOffset;
	
	var _types = __webpack_require__(456);
	
	function setClientOffset(clientOffset, sourceClientOffset) {
	  return {
	    type: _types.INIT_COORDS,
	    payload: {
	      sourceClientOffset: sourceClientOffset || null,
	      clientOffset: clientOffset || null
	    }
	  };
	}

/***/ }),
/* 4862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPublishDragSource;
	
	var _types = __webpack_require__(456);
	
	function createPublishDragSource(manager) {
	  return function publishDragSource() {
	    var monitor = manager.getMonitor();
	
	    if (monitor.isDragging()) {
	      return {
	        type: _types.PUBLISH_DRAG_SOURCE
	      };
	    }
	  };
	}

/***/ }),
/* 4863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateSourceContract = validateSourceContract;
	exports.validateTargetContract = validateTargetContract;
	exports.validateType = validateType;
	
	var _invariant = __webpack_require__(129);
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function validateSourceContract(source) {
	  (0, _invariant.invariant)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	  (0, _invariant.invariant)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	  (0, _invariant.invariant)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
	}
	
	function validateTargetContract(target) {
	  (0, _invariant.invariant)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	  (0, _invariant.invariant)(typeof target.hover === 'function', 'Expected hover to be a function.');
	  (0, _invariant.invariant)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
	}
	
	function validateType(type, allowArray) {
	  if (allowArray && Array.isArray(type)) {
	    type.forEach(function (t) {
	      return validateType(t, false);
	    });
	    return;
	  }
	
	  (0, _invariant.invariant)(typeof type === 'string' || _typeof(type) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
	}

/***/ }),
/* 4864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createDragDropManager = createDragDropManager;
	
	var _DragDropManagerImpl = _interopRequireDefault(__webpack_require__(4854));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDragDropManager(backendFactory, globalContext, backendOptions, debugMode) {
	  var manager = new _DragDropManagerImpl.default(debugMode);
	  var backend = backendFactory(manager, globalContext, backendOptions);
	  manager.receiveBackend(backend);
	  return manager;
	}

/***/ }),
/* 4865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _interfaces = __webpack_require__(2232);
	
	Object.keys(_interfaces).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _interfaces[key];
	    }
	  });
	});
	
	var _factories = __webpack_require__(4864);
	
	Object.keys(_factories).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _factories[key];
	    }
	  });
	});

/***/ }),
/* 4866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dirtyHandlerIds;
	
	var _dragDrop = __webpack_require__(948);
	
	var _registry = __webpack_require__(949);
	
	var _equality = __webpack_require__(2234);
	
	var _dirtiness = __webpack_require__(2233);
	
	var _js_utils = __webpack_require__(562);
	
	function dirtyHandlerIds() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _dirtiness.NONE;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	
	  switch (action.type) {
	    case _dragDrop.HOVER:
	      break;
	
	    case _registry.ADD_SOURCE:
	    case _registry.ADD_TARGET:
	    case _registry.REMOVE_TARGET:
	    case _registry.REMOVE_SOURCE:
	      return _dirtiness.NONE;
	
	    case _dragDrop.BEGIN_DRAG:
	    case _dragDrop.PUBLISH_DRAG_SOURCE:
	    case _dragDrop.END_DRAG:
	    case _dragDrop.DROP:
	    default:
	      return _dirtiness.ALL;
	  }
	
	  var _action$payload = action.payload,
	      _action$payload$targe = _action$payload.targetIds,
	      targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe,
	      _action$payload$prevT = _action$payload.prevTargetIds,
	      prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
	  var result = (0, _js_utils.xor)(targetIds, prevTargetIds);
	  var didChange = result.length > 0 || !(0, _equality.areArraysEqual)(targetIds, prevTargetIds);
	
	  if (!didChange) {
	    return _dirtiness.NONE;
	  } // Check the target ids at the innermost position. If they are valid, add them
	  // to the result
	
	
	  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	  var innermostTargetId = targetIds[targetIds.length - 1];
	
	  if (prevInnermostTargetId !== innermostTargetId) {
	    if (prevInnermostTargetId) {
	      result.push(prevInnermostTargetId);
	    }
	
	    if (innermostTargetId) {
	      result.push(innermostTargetId);
	    }
	  }
	
	  return result;
	}

/***/ }),
/* 4867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dragOffset;
	
	var _dragDrop = __webpack_require__(948);
	
	var _equality = __webpack_require__(2234);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  initialSourceClientOffset: null,
	  initialClientOffset: null,
	  clientOffset: null
	};
	
	function dragOffset() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	  var payload = action.payload;
	
	  switch (action.type) {
	    case _dragDrop.INIT_COORDS:
	    case _dragDrop.BEGIN_DRAG:
	      return {
	        initialSourceClientOffset: payload.sourceClientOffset,
	        initialClientOffset: payload.clientOffset,
	        clientOffset: payload.clientOffset
	      };
	
	    case _dragDrop.HOVER:
	      if ((0, _equality.areCoordsEqual)(state.clientOffset, payload.clientOffset)) {
	        return state;
	      }
	
	      return _objectSpread({}, state, {
	        clientOffset: payload.clientOffset
	      });
	
	    case _dragDrop.END_DRAG:
	    case _dragDrop.DROP:
	      return initialState;
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 4868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dragOperation;
	
	var _dragDrop = __webpack_require__(948);
	
	var _registry = __webpack_require__(949);
	
	var _js_utils = __webpack_require__(562);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  itemType: null,
	  item: null,
	  sourceId: null,
	  targetIds: [],
	  dropResult: null,
	  didDrop: false,
	  isSourcePublic: null
	};
	
	function dragOperation() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	  var payload = action.payload;
	
	  switch (action.type) {
	    case _dragDrop.BEGIN_DRAG:
	      return _objectSpread({}, state, {
	        itemType: payload.itemType,
	        item: payload.item,
	        sourceId: payload.sourceId,
	        isSourcePublic: payload.isSourcePublic,
	        dropResult: null,
	        didDrop: false
	      });
	
	    case _dragDrop.PUBLISH_DRAG_SOURCE:
	      return _objectSpread({}, state, {
	        isSourcePublic: true
	      });
	
	    case _dragDrop.HOVER:
	      return _objectSpread({}, state, {
	        targetIds: payload.targetIds
	      });
	
	    case _registry.REMOVE_TARGET:
	      if (state.targetIds.indexOf(payload.targetId) === -1) {
	        return state;
	      }
	
	      return _objectSpread({}, state, {
	        targetIds: (0, _js_utils.without)(state.targetIds, payload.targetId)
	      });
	
	    case _dragDrop.DROP:
	      return _objectSpread({}, state, {
	        dropResult: payload.dropResult,
	        didDrop: true,
	        targetIds: []
	      });
	
	    case _dragDrop.END_DRAG:
	      return _objectSpread({}, state, {
	        itemType: null,
	        item: null,
	        sourceId: null,
	        dropResult: null,
	        didDrop: false,
	        isSourcePublic: null,
	        targetIds: []
	      });
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 4869 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = reduce;
	
	var _dragOffset = _interopRequireDefault(__webpack_require__(4867));
	
	var _dragOperation = _interopRequireDefault(__webpack_require__(4868));
	
	var _refCount = _interopRequireDefault(__webpack_require__(4870));
	
	var _dirtyHandlerIds = _interopRequireDefault(__webpack_require__(4866));
	
	var _stateId = _interopRequireDefault(__webpack_require__(4871));
	
	var _js_utils = __webpack_require__(562);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function reduce() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	  return {
	    dirtyHandlerIds: (0, _dirtyHandlerIds.default)(state.dirtyHandlerIds, {
	      type: action.type,
	      payload: _objectSpread({}, action.payload, {
	        prevTargetIds: (0, _js_utils.get)(state, 'dragOperation.targetIds', [])
	      })
	    }),
	    dragOffset: (0, _dragOffset.default)(state.dragOffset, action),
	    refCount: (0, _refCount.default)(state.refCount, action),
	    dragOperation: (0, _dragOperation.default)(state.dragOperation, action),
	    stateId: (0, _stateId.default)(state.stateId)
	  };
	}

/***/ }),
/* 4870 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = refCount;
	
	var _registry = __webpack_require__(949);
	
	function refCount() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var action = arguments.length > 1 ? arguments[1] : undefined;
	
	  switch (action.type) {
	    case _registry.ADD_SOURCE:
	    case _registry.ADD_TARGET:
	      return state + 1;
	
	    case _registry.REMOVE_SOURCE:
	    case _registry.REMOVE_TARGET:
	      return state - 1;
	
	    default:
	      return state;
	  }
	}

/***/ }),
/* 4871 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stateId;
	
	function stateId() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  return state + 1;
	}

/***/ }),
/* 4872 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.add = add;
	exports.subtract = subtract;
	exports.getSourceClientOffset = getSourceClientOffset;
	exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
	
	/**
	 * Coordinate addition
	 * @param a The first coordinate
	 * @param b The second coordinate
	 */
	function add(a, b) {
	  return {
	    x: a.x + b.x,
	    y: a.y + b.y
	  };
	}
	/**
	 * Coordinate subtraction
	 * @param a The first coordinate
	 * @param b The second coordinate
	 */
	
	
	function subtract(a, b) {
	  return {
	    x: a.x - b.x,
	    y: a.y - b.y
	  };
	}
	/**
	 * Returns the cartesian distance of the drag source component's position, based on its position
	 * at the time when the current drag operation has started, and the movement difference.
	 *
	 * Returns null if no item is being dragged.
	 *
	 * @param state The offset state to compute from
	 */
	
	
	function getSourceClientOffset(state) {
	  var clientOffset = state.clientOffset,
	      initialClientOffset = state.initialClientOffset,
	      initialSourceClientOffset = state.initialSourceClientOffset;
	
	  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
	    return null;
	  }
	
	  return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
	}
	/**
	 * Determines the x,y offset between the client offset and the initial client offset
	 *
	 * @param state The offset state to compute from
	 */
	
	
	function getDifferenceFromInitialOffset(state) {
	  var clientOffset = state.clientOffset,
	      initialClientOffset = state.initialClientOffset;
	
	  if (!clientOffset || !initialClientOffset) {
	    return null;
	  }
	
	  return subtract(clientOffset, initialClientOffset);
	}

/***/ }),
/* 4873 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getNextUniqueId;
	var nextUniqueId = 0;
	
	function getNextUniqueId() {
	  return nextUniqueId++;
	}

/***/ }),
/* 4874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(4875);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	module.exports = exports['default'];

/***/ }),
/* 4875 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ }),
/* 4876 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 4877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerWindow;
	
	var _ownerDocument = __webpack_require__(372);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  return doc && doc.defaultView || doc.parentWindow;
	}
	module.exports = exports['default'];

/***/ }),
/* 4878 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ }),
/* 4879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = __webpack_require__(2237);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _camelizeStyle2.default)(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 4880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = style;
	
	var _camelizeStyle = __webpack_require__(2237);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	var _hyphenateStyle = __webpack_require__(4886);
	
	var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);
	
	var _getComputedStyle2 = __webpack_require__(4879);
	
	var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);
	
	var _removeStyle = __webpack_require__(4881);
	
	var _removeStyle2 = _interopRequireDefault(_removeStyle);
	
	var _properties = __webpack_require__(4883);
	
	var _isTransform = __webpack_require__(4882);
	
	var _isTransform2 = _interopRequireDefault(_isTransform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	    if (!value && value !== 0) {
	      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
	    } else if ((0, _isTransform2.default)(key)) {
	      transforms += key + '(' + value + ') ';
	    } else {
	      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ': ' + transforms + ';';
	  }
	
	  node.style.cssText += ';' + css;
	}
	module.exports = exports['default'];

/***/ }),
/* 4881 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeStyle;
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	module.exports = exports['default'];

/***/ }),
/* 4882 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	module.exports = exports["default"];

/***/ }),
/* 4883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(951);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ }),
/* 4884 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	module.exports = exports["default"];

/***/ }),
/* 4885 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenate;
	
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	module.exports = exports['default'];

/***/ }),
/* 4886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateStyleName;
	
	var _hyphenate = __webpack_require__(4885);
	
	var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^ms-/; /**
	                         * Copyright 2013-2014, Facebook, Inc.
	                         * All rights reserved.
	                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	                         */
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
	}
	module.exports = exports['default'];

/***/ }),
/* 4887 */
/***/ (function(module, exports, __webpack_require__) {

	// This file should be ES5 compatible
	/* eslint prefer-spread:0, no-var:0, prefer-reflect:0, no-magic-numbers:0 */
	'use strict'
	
	module.exports = (function () {
		// Import Events
		var events = __webpack_require__(2238)
	
		// Export Domain
		var domain = {}
		domain.createDomain = domain.create = function () {
			var d = new events.EventEmitter()
	
			function emitError (e) {
				d.emit('error', e)
			}
	
			d.add = function (emitter) {
				emitter.on('error', emitError)
			}
			d.remove = function (emitter) {
				emitter.removeListener('error', emitError)
			}
			d.bind = function (fn) {
				return function () {
					var args = Array.prototype.slice.call(arguments)
					try {
						fn.apply(null, args)
					}
					catch (err) {
						emitError(err)
					}
				}
			}
			d.intercept = function (fn) {
				return function (err) {
					if ( err ) {
						emitError(err)
					}
					else {
						var args = Array.prototype.slice.call(arguments, 1)
						try {
							fn.apply(null, args)
						}
						catch (err) {
							emitError(err)
						}
					}
				}
			}
			d.run = function (fn) {
				try {
					fn()
				}
				catch (err) {
					emitError(err)
				}
				return this
			}
			d.dispose = function () {
				this.removeAllListeners()
				return this
			}
			d.enter = d.exit = function () {
				return this
			}
			return d
		}
		return domain
	}).call(this)


/***/ }),
/* 4888 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
	
	    var debug = false;
	
	    var root = this;
	
	    var EXIF = function(obj) {
	        if (obj instanceof EXIF) return obj;
	        if (!(this instanceof EXIF)) return new EXIF(obj);
	        this.EXIFwrapped = obj;
	    };
	
	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = EXIF;
	        }
	        exports.EXIF = EXIF;
	    } else {
	        root.EXIF = EXIF;
	    }
	
	    var ExifTags = EXIF.Tags = {
	
	        // version tags
	        0x9000 : "ExifVersion",             // EXIF version
	        0xA000 : "FlashpixVersion",         // Flashpix format version
	
	        // colorspace tags
	        0xA001 : "ColorSpace",              // Color space information tag
	
	        // image configuration
	        0xA002 : "PixelXDimension",         // Valid width of meaningful image
	        0xA003 : "PixelYDimension",         // Valid height of meaningful image
	        0x9101 : "ComponentsConfiguration", // Information about channels
	        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel
	
	        // user information
	        0x927C : "MakerNote",               // Any desired information written by the manufacturer
	        0x9286 : "UserComment",             // Comments by user
	
	        // related file
	        0xA004 : "RelatedSoundFile",        // Name of related sound file
	
	        // date and time
	        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
	        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
	        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
	        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
	        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized
	
	        // picture-taking conditions
	        0x829A : "ExposureTime",            // Exposure time (in seconds)
	        0x829D : "FNumber",                 // F number
	        0x8822 : "ExposureProgram",         // Exposure program
	        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
	        0x8827 : "ISOSpeedRatings",         // ISO speed rating
	        0x8828 : "OECF",                    // Optoelectric conversion factor
	        0x9201 : "ShutterSpeedValue",       // Shutter speed
	        0x9202 : "ApertureValue",           // Lens aperture
	        0x9203 : "BrightnessValue",         // Value of brightness
	        0x9204 : "ExposureBias",            // Exposure bias
	        0x9205 : "MaxApertureValue",        // Smallest F number of lens
	        0x9206 : "SubjectDistance",         // Distance to subject in meters
	        0x9207 : "MeteringMode",            // Metering mode
	        0x9208 : "LightSource",             // Kind of light source
	        0x9209 : "Flash",                   // Flash status
	        0x9214 : "SubjectArea",             // Location and area of main subject
	        0x920A : "FocalLength",             // Focal length of the lens in mm
	        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
	        0xA20C : "SpatialFrequencyResponse",    //
	        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
	        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
	        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
	        0xA214 : "SubjectLocation",         // Location of subject in image
	        0xA215 : "ExposureIndex",           // Exposure index selected on camera
	        0xA217 : "SensingMethod",           // Image sensor type
	        0xA300 : "FileSource",              // Image source (3 == DSC)
	        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
	        0xA302 : "CFAPattern",              // Color filter array geometric pattern
	        0xA401 : "CustomRendered",          // Special processing
	        0xA402 : "ExposureMode",            // Exposure mode
	        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
	        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
	        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
	        0xA406 : "SceneCaptureType",        // Type of scene
	        0xA407 : "GainControl",             // Degree of overall image gain adjustment
	        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
	        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
	        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
	        0xA40B : "DeviceSettingDescription",    //
	        0xA40C : "SubjectDistanceRange",    // Distance to subject
	
	        // other tags
	        0xA005 : "InteroperabilityIFDPointer",
	        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
	    };
	
	    var TiffTags = EXIF.TiffTags = {
	        0x0100 : "ImageWidth",
	        0x0101 : "ImageHeight",
	        0x8769 : "ExifIFDPointer",
	        0x8825 : "GPSInfoIFDPointer",
	        0xA005 : "InteroperabilityIFDPointer",
	        0x0102 : "BitsPerSample",
	        0x0103 : "Compression",
	        0x0106 : "PhotometricInterpretation",
	        0x0112 : "Orientation",
	        0x0115 : "SamplesPerPixel",
	        0x011C : "PlanarConfiguration",
	        0x0212 : "YCbCrSubSampling",
	        0x0213 : "YCbCrPositioning",
	        0x011A : "XResolution",
	        0x011B : "YResolution",
	        0x0128 : "ResolutionUnit",
	        0x0111 : "StripOffsets",
	        0x0116 : "RowsPerStrip",
	        0x0117 : "StripByteCounts",
	        0x0201 : "JPEGInterchangeFormat",
	        0x0202 : "JPEGInterchangeFormatLength",
	        0x012D : "TransferFunction",
	        0x013E : "WhitePoint",
	        0x013F : "PrimaryChromaticities",
	        0x0211 : "YCbCrCoefficients",
	        0x0214 : "ReferenceBlackWhite",
	        0x0132 : "DateTime",
	        0x010E : "ImageDescription",
	        0x010F : "Make",
	        0x0110 : "Model",
	        0x0131 : "Software",
	        0x013B : "Artist",
	        0x8298 : "Copyright"
	    };
	
	    var GPSTags = EXIF.GPSTags = {
	        0x0000 : "GPSVersionID",
	        0x0001 : "GPSLatitudeRef",
	        0x0002 : "GPSLatitude",
	        0x0003 : "GPSLongitudeRef",
	        0x0004 : "GPSLongitude",
	        0x0005 : "GPSAltitudeRef",
	        0x0006 : "GPSAltitude",
	        0x0007 : "GPSTimeStamp",
	        0x0008 : "GPSSatellites",
	        0x0009 : "GPSStatus",
	        0x000A : "GPSMeasureMode",
	        0x000B : "GPSDOP",
	        0x000C : "GPSSpeedRef",
	        0x000D : "GPSSpeed",
	        0x000E : "GPSTrackRef",
	        0x000F : "GPSTrack",
	        0x0010 : "GPSImgDirectionRef",
	        0x0011 : "GPSImgDirection",
	        0x0012 : "GPSMapDatum",
	        0x0013 : "GPSDestLatitudeRef",
	        0x0014 : "GPSDestLatitude",
	        0x0015 : "GPSDestLongitudeRef",
	        0x0016 : "GPSDestLongitude",
	        0x0017 : "GPSDestBearingRef",
	        0x0018 : "GPSDestBearing",
	        0x0019 : "GPSDestDistanceRef",
	        0x001A : "GPSDestDistance",
	        0x001B : "GPSProcessingMethod",
	        0x001C : "GPSAreaInformation",
	        0x001D : "GPSDateStamp",
	        0x001E : "GPSDifferential"
	    };
	
	     // EXIF 2.3 Spec
	    var IFD1Tags = EXIF.IFD1Tags = {
	        0x0100: "ImageWidth",
	        0x0101: "ImageHeight",
	        0x0102: "BitsPerSample",
	        0x0103: "Compression",
	        0x0106: "PhotometricInterpretation",
	        0x0111: "StripOffsets",
	        0x0112: "Orientation",
	        0x0115: "SamplesPerPixel",
	        0x0116: "RowsPerStrip",
	        0x0117: "StripByteCounts",
	        0x011A: "XResolution",
	        0x011B: "YResolution",
	        0x011C: "PlanarConfiguration",
	        0x0128: "ResolutionUnit",
	        0x0201: "JpegIFOffset",    // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
	        0x0202: "JpegIFByteCount", // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
	        0x0211: "YCbCrCoefficients",
	        0x0212: "YCbCrSubSampling",
	        0x0213: "YCbCrPositioning",
	        0x0214: "ReferenceBlackWhite"
	    };
	
	    var StringValues = EXIF.StringValues = {
	        ExposureProgram : {
	            0 : "Not defined",
	            1 : "Manual",
	            2 : "Normal program",
	            3 : "Aperture priority",
	            4 : "Shutter priority",
	            5 : "Creative program",
	            6 : "Action program",
	            7 : "Portrait mode",
	            8 : "Landscape mode"
	        },
	        MeteringMode : {
	            0 : "Unknown",
	            1 : "Average",
	            2 : "CenterWeightedAverage",
	            3 : "Spot",
	            4 : "MultiSpot",
	            5 : "Pattern",
	            6 : "Partial",
	            255 : "Other"
	        },
	        LightSource : {
	            0 : "Unknown",
	            1 : "Daylight",
	            2 : "Fluorescent",
	            3 : "Tungsten (incandescent light)",
	            4 : "Flash",
	            9 : "Fine weather",
	            10 : "Cloudy weather",
	            11 : "Shade",
	            12 : "Daylight fluorescent (D 5700 - 7100K)",
	            13 : "Day white fluorescent (N 4600 - 5400K)",
	            14 : "Cool white fluorescent (W 3900 - 4500K)",
	            15 : "White fluorescent (WW 3200 - 3700K)",
	            17 : "Standard light A",
	            18 : "Standard light B",
	            19 : "Standard light C",
	            20 : "D55",
	            21 : "D65",
	            22 : "D75",
	            23 : "D50",
	            24 : "ISO studio tungsten",
	            255 : "Other"
	        },
	        Flash : {
	            0x0000 : "Flash did not fire",
	            0x0001 : "Flash fired",
	            0x0005 : "Strobe return light not detected",
	            0x0007 : "Strobe return light detected",
	            0x0009 : "Flash fired, compulsory flash mode",
	            0x000D : "Flash fired, compulsory flash mode, return light not detected",
	            0x000F : "Flash fired, compulsory flash mode, return light detected",
	            0x0010 : "Flash did not fire, compulsory flash mode",
	            0x0018 : "Flash did not fire, auto mode",
	            0x0019 : "Flash fired, auto mode",
	            0x001D : "Flash fired, auto mode, return light not detected",
	            0x001F : "Flash fired, auto mode, return light detected",
	            0x0020 : "No flash function",
	            0x0041 : "Flash fired, red-eye reduction mode",
	            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
	            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
	            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
	            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
	            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
	            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
	            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
	            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
	        },
	        SensingMethod : {
	            1 : "Not defined",
	            2 : "One-chip color area sensor",
	            3 : "Two-chip color area sensor",
	            4 : "Three-chip color area sensor",
	            5 : "Color sequential area sensor",
	            7 : "Trilinear sensor",
	            8 : "Color sequential linear sensor"
	        },
	        SceneCaptureType : {
	            0 : "Standard",
	            1 : "Landscape",
	            2 : "Portrait",
	            3 : "Night scene"
	        },
	        SceneType : {
	            1 : "Directly photographed"
	        },
	        CustomRendered : {
	            0 : "Normal process",
	            1 : "Custom process"
	        },
	        WhiteBalance : {
	            0 : "Auto white balance",
	            1 : "Manual white balance"
	        },
	        GainControl : {
	            0 : "None",
	            1 : "Low gain up",
	            2 : "High gain up",
	            3 : "Low gain down",
	            4 : "High gain down"
	        },
	        Contrast : {
	            0 : "Normal",
	            1 : "Soft",
	            2 : "Hard"
	        },
	        Saturation : {
	            0 : "Normal",
	            1 : "Low saturation",
	            2 : "High saturation"
	        },
	        Sharpness : {
	            0 : "Normal",
	            1 : "Soft",
	            2 : "Hard"
	        },
	        SubjectDistanceRange : {
	            0 : "Unknown",
	            1 : "Macro",
	            2 : "Close view",
	            3 : "Distant view"
	        },
	        FileSource : {
	            3 : "DSC"
	        },
	
	        Components : {
	            0 : "",
	            1 : "Y",
	            2 : "Cb",
	            3 : "Cr",
	            4 : "R",
	            5 : "G",
	            6 : "B"
	        }
	    };
	
	    function addEvent(element, event, handler) {
	        if (element.addEventListener) {
	            element.addEventListener(event, handler, false);
	        } else if (element.attachEvent) {
	            element.attachEvent("on" + event, handler);
	        }
	    }
	
	    function imageHasData(img) {
	        return !!(img.exifdata);
	    }
	
	
	    function base64ToArrayBuffer(base64, contentType) {
	        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
	        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
	        var binary = atob(base64);
	        var len = binary.length;
	        var buffer = new ArrayBuffer(len);
	        var view = new Uint8Array(buffer);
	        for (var i = 0; i < len; i++) {
	            view[i] = binary.charCodeAt(i);
	        }
	        return buffer;
	    }
	
	    function objectURLToBlob(url, callback) {
	        var http = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.responseType = "blob";
	        http.onload = function(e) {
	            if (this.status == 200 || this.status === 0) {
	                callback(this.response);
	            }
	        };
	        http.send();
	    }
	
	    function getImageData(img, callback) {
	        function handleBinaryFile(binFile) {
	            var data = findEXIFinJPEG(binFile);
	            img.exifdata = data || {};
	            var iptcdata = findIPTCinJPEG(binFile);
	            img.iptcdata = iptcdata || {};
	            if (EXIF.isXmpEnabled) {
	               var xmpdata= findXMPinJPEG(binFile);
	               img.xmpdata = xmpdata || {};               
	            }
	            if (callback) {
	                callback.call(img);
	            }
	        }
	
	        if (img.src) {
	            if (/^data\:/i.test(img.src)) { // Data URI
	                var arrayBuffer = base64ToArrayBuffer(img.src);
	                handleBinaryFile(arrayBuffer);
	
	            } else if (/^blob\:/i.test(img.src)) { // Object URL
	                var fileReader = new FileReader();
	                fileReader.onload = function(e) {
	                    handleBinaryFile(e.target.result);
	                };
	                objectURLToBlob(img.src, function (blob) {
	                    fileReader.readAsArrayBuffer(blob);
	                });
	            } else {
	                var http = new XMLHttpRequest();
	                http.onload = function() {
	                    if (this.status == 200 || this.status === 0) {
	                        handleBinaryFile(http.response);
	                    } else {
	                        throw "Could not load image";
	                    }
	                    http = null;
	                };
	                http.open("GET", img.src, true);
	                http.responseType = "arraybuffer";
	                http.send(null);
	            }
	        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
	            var fileReader = new FileReader();
	            fileReader.onload = function(e) {
	                if (debug) console.log("Got file of length " + e.target.result.byteLength);
	                handleBinaryFile(e.target.result);
	            };
	
	            fileReader.readAsArrayBuffer(img);
	        }
	    }
	
	    function findEXIFinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            marker;
	
	        while (offset < length) {
	            if (dataView.getUint8(offset) != 0xFF) {
	                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
	                return false; // not a valid marker, something is wrong
	            }
	
	            marker = dataView.getUint8(offset + 1);
	            if (debug) console.log(marker);
	
	            // we could implement handling for other markers here,
	            // but we're only looking for 0xFFE1 for EXIF data
	
	            if (marker == 225) {
	                if (debug) console.log("Found 0xFFE1 marker");
	
	                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);
	
	                // offset += 2 + file.getShortAt(offset+2, true);
	
	            } else {
	                offset += 2 + dataView.getUint16(offset+2);
	            }
	
	        }
	
	    }
	
	    function findIPTCinJPEG(file) {
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength;
	
	
	        var isFieldSegmentStart = function(dataView, offset){
	            return (
	                dataView.getUint8(offset) === 0x38 &&
	                dataView.getUint8(offset+1) === 0x42 &&
	                dataView.getUint8(offset+2) === 0x49 &&
	                dataView.getUint8(offset+3) === 0x4D &&
	                dataView.getUint8(offset+4) === 0x04 &&
	                dataView.getUint8(offset+5) === 0x04
	            );
	        };
	
	        while (offset < length) {
	
	            if ( isFieldSegmentStart(dataView, offset )){
	
	                // Get the length of the name header (which is padded to an even number of bytes)
	                var nameHeaderLength = dataView.getUint8(offset+7);
	                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
	                // Check for pre photoshop 6 format
	                if(nameHeaderLength === 0) {
	                    // Always 4
	                    nameHeaderLength = 4;
	                }
	
	                var startOffset = offset + 8 + nameHeaderLength;
	                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
	
	                return readIPTCData(file, startOffset, sectionLength);
	
	                break;
	
	            }
	
	
	            // Not the marker, continue searching
	            offset++;
	
	        }
	
	    }
	    var IptcFieldMap = {
	        0x78 : 'caption',
	        0x6E : 'credit',
	        0x19 : 'keywords',
	        0x37 : 'dateCreated',
	        0x50 : 'byline',
	        0x55 : 'bylineTitle',
	        0x7A : 'captionWriter',
	        0x69 : 'headline',
	        0x74 : 'copyright',
	        0x0F : 'category'
	    };
	    function readIPTCData(file, startOffset, sectionLength){
	        var dataView = new DataView(file);
	        var data = {};
	        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
	        var segmentStartPos = startOffset;
	        while(segmentStartPos < startOffset+sectionLength) {
	            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
	                segmentType = dataView.getUint8(segmentStartPos+2);
	                if(segmentType in IptcFieldMap) {
	                    dataSize = dataView.getInt16(segmentStartPos+3);
	                    segmentSize = dataSize + 5;
	                    fieldName = IptcFieldMap[segmentType];
	                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
	                    // Check if we already stored a value with this name
	                    if(data.hasOwnProperty(fieldName)) {
	                        // Value already stored with this name, create multivalue field
	                        if(data[fieldName] instanceof Array) {
	                            data[fieldName].push(fieldValue);
	                        }
	                        else {
	                            data[fieldName] = [data[fieldName], fieldValue];
	                        }
	                    }
	                    else {
	                        data[fieldName] = fieldValue;
	                    }
	                }
	
	            }
	            segmentStartPos++;
	        }
	        return data;
	    }
	
	
	
	    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
	        var entries = file.getUint16(dirStart, !bigEnd),
	            tags = {},
	            entryOffset, tag,
	            i;
	
	        for (i=0;i<entries;i++) {
	            entryOffset = dirStart + i*12 + 2;
	            tag = strings[file.getUint16(entryOffset, !bigEnd)];
	            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
	            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
	        }
	        return tags;
	    }
	
	
	    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
	        var type = file.getUint16(entryOffset+2, !bigEnd),
	            numValues = file.getUint32(entryOffset+4, !bigEnd),
	            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
	            offset,
	            vals, val, n,
	            numerator, denominator;
	
	        switch (type) {
	            case 1: // byte, 8-bit unsigned int
	            case 7: // undefined, 8-bit byte, value depending on field
	                if (numValues == 1) {
	                    return file.getUint8(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint8(offset + n);
	                    }
	                    return vals;
	                }
	
	            case 2: // ascii, 8-bit byte
	                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                return getStringFromDB(file, offset, numValues-1);
	
	            case 3: // short, 16 bit int
	                if (numValues == 1) {
	                    return file.getUint16(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 4: // long, 32 bit int
	                if (numValues == 1) {
	                    return file.getUint32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 5:    // rational = two long values, first is numerator, second is denominator
	                if (numValues == 1) {
	                    numerator = file.getUint32(valueOffset, !bigEnd);
	                    denominator = file.getUint32(valueOffset+4, !bigEnd);
	                    val = new Number(numerator / denominator);
	                    val.numerator = numerator;
	                    val.denominator = denominator;
	                    return val;
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
	                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
	                        vals[n] = new Number(numerator / denominator);
	                        vals[n].numerator = numerator;
	                        vals[n].denominator = denominator;
	                    }
	                    return vals;
	                }
	
	            case 9: // slong, 32 bit signed int
	                if (numValues == 1) {
	                    return file.getInt32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
	                    }
	                    return vals;
	                }
	
	            case 10: // signed rational, two slongs, first is numerator, second is denominator
	                if (numValues == 1) {
	                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n=0;n<numValues;n++) {
	                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
	                    }
	                    return vals;
	                }
	        }
	    }
	
	    /**
	    * Given an IFD (Image File Directory) start offset
	    * returns an offset to next IFD or 0 if it's the last IFD.
	    */
	    function getNextIFDOffset(dataView, dirStart, bigEnd){
	        //the first 2bytes means the number of directory entries contains in this IFD
	        var entries = dataView.getUint16(dirStart, !bigEnd);
	
	        // After last directory entry, there is a 4bytes of data,
	        // it means an offset to next IFD.
	        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.
	
	        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
	    }
	
	    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd){
	        // get the IFD1 offset
	        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart+firstIFDOffset, bigEnd);
	
	        if (!IFD1OffsetPointer) {
	            // console.log('******** IFD1Offset is empty, image thumb not found ********');
	            return {};
	        }
	        else if (IFD1OffsetPointer > dataView.byteLength) { // this should not happen
	            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
	            return {};
	        }
	        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);
	
	        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd)
	
	        // EXIF 2.3 specification for JPEG format thumbnail
	
	        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
	        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
	        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
	        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
	        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.
	
	        if (thumbTags['Compression']) {
	            // console.log('Thumbnail image found!');
	
	            switch (thumbTags['Compression']) {
	                case 6:
	                    // console.log('Thumbnail image format is JPEG');
	                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
	                    // extract the thumbnail
	                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
	                        var tLength = thumbTags.JpegIFByteCount;
	                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
	                            type: 'image/jpeg'
	                        });
	                    }
	                break;
	
	            case 1:
	                console.log("Thumbnail image format is TIFF, which is not implemented.");
	                break;
	            default:
	                console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
	            }
	        }
	        else if (thumbTags['PhotometricInterpretation'] == 2) {
	            console.log("Thumbnail image format is RGB, which is not implemented.");
	        }
	        return thumbTags;
	    }
	
	    function getStringFromDB(buffer, start, length) {
	        var outstr = "";
	        for (n = start; n < start+length; n++) {
	            outstr += String.fromCharCode(buffer.getUint8(n));
	        }
	        return outstr;
	    }
	
	    function readEXIFData(file, start) {
	        if (getStringFromDB(file, start, 4) != "Exif") {
	            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
	            return false;
	        }
	
	        var bigEnd,
	            tags, tag,
	            exifData, gpsData,
	            tiffOffset = start + 6;
	
	        // test for TIFF validity and endianness
	        if (file.getUint16(tiffOffset) == 0x4949) {
	            bigEnd = false;
	        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
	            bigEnd = true;
	        } else {
	            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
	            return false;
	        }
	
	        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
	            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
	            return false;
	        }
	
	        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);
	
	        if (firstIFDOffset < 0x00000008) {
	            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
	            return false;
	        }
	
	        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);
	
	        if (tags.ExifIFDPointer) {
	            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
	            for (tag in exifData) {
	                switch (tag) {
	                    case "LightSource" :
	                    case "Flash" :
	                    case "MeteringMode" :
	                    case "ExposureProgram" :
	                    case "SensingMethod" :
	                    case "SceneCaptureType" :
	                    case "SceneType" :
	                    case "CustomRendered" :
	                    case "WhiteBalance" :
	                    case "GainControl" :
	                    case "Contrast" :
	                    case "Saturation" :
	                    case "Sharpness" :
	                    case "SubjectDistanceRange" :
	                    case "FileSource" :
	                        exifData[tag] = StringValues[tag][exifData[tag]];
	                        break;
	
	                    case "ExifVersion" :
	                    case "FlashpixVersion" :
	                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
	                        break;
	
	                    case "ComponentsConfiguration" :
	                        exifData[tag] =
	                            StringValues.Components[exifData[tag][0]] +
	                            StringValues.Components[exifData[tag][1]] +
	                            StringValues.Components[exifData[tag][2]] +
	                            StringValues.Components[exifData[tag][3]];
	                        break;
	                }
	                tags[tag] = exifData[tag];
	            }
	        }
	
	        if (tags.GPSInfoIFDPointer) {
	            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
	            for (tag in gpsData) {
	                switch (tag) {
	                    case "GPSVersionID" :
	                        gpsData[tag] = gpsData[tag][0] +
	                            "." + gpsData[tag][1] +
	                            "." + gpsData[tag][2] +
	                            "." + gpsData[tag][3];
	                        break;
	                }
	                tags[tag] = gpsData[tag];
	            }
	        }
	
	        // extract thumbnail
	        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);
	
	        return tags;
	    }
	
	   function findXMPinJPEG(file) {
	
	        if (!('DOMParser' in self)) {
	            // console.warn('XML parsing not supported without DOMParser');
	            return;
	        }
	        var dataView = new DataView(file);
	
	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	           if (debug) console.log("Not a valid JPEG");
	           return false; // not a valid jpeg
	        }
	
	        var offset = 2,
	            length = file.byteLength,
	            dom = new DOMParser();
	
	        while (offset < (length-4)) {
	            if (getStringFromDB(dataView, offset, 4) == "http") {
	                var startOffset = offset - 1;
	                var sectionLength = dataView.getUint16(offset - 2) - 1;
	                var xmpString = getStringFromDB(dataView, startOffset, sectionLength)
	                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
	                xmpString = xmpString.substring( xmpString.indexOf( '<x:xmpmeta' ), xmpEndIndex );
	
	                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10
	                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
	                //Without these namespaces, XML is thought to be invalid by parsers
	                xmpString = xmpString.slice(0, indexOfXmp)
	                            + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" '
	                            + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
	                            + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" '
	                            + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" '
	                            + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" '
	                            + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" '
	                            + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" '
	                            + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" '
	                            + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" '
	                            + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" '
	                            + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '
	                            + xmpString.slice(indexOfXmp)
	
	                var domDocument = dom.parseFromString( xmpString, 'text/xml' );
	                return xml2Object(domDocument);
	            } else{
	             offset++;
	            }
	        }
	    }
	
	    function xml2json(xml) {
	        var json = {};
	      
	        if (xml.nodeType == 1) { // element node
	          if (xml.attributes.length > 0) {
	            json['@attributes'] = {};
	            for (var j = 0; j < xml.attributes.length; j++) {
	              var attribute = xml.attributes.item(j);
	              json['@attributes'][attribute.nodeName] = attribute.nodeValue;
	            }
	          }
	        } else if (xml.nodeType == 3) { // text node
	          return xml.nodeValue;
	        }
	      
	        // deal with children
	        if (xml.hasChildNodes()) {
	          for(var i = 0; i < xml.childNodes.length; i++) {
	            var child = xml.childNodes.item(i);
	            var nodeName = child.nodeName;
	            if (json[nodeName] == null) {
	              json[nodeName] = xml2json(child);
	            } else {
	              if (json[nodeName].push == null) {
	                var old = json[nodeName];
	                json[nodeName] = [];
	                json[nodeName].push(old);
	              }
	              json[nodeName].push(xml2json(child));
	            }
	          }
	        }
	        
	        return json;
	    }
	
	    function xml2Object(xml) {
	        try {
	            var obj = {};
	            if (xml.children.length > 0) {
	              for (var i = 0; i < xml.children.length; i++) {
	                var item = xml.children.item(i);
	                var attributes = item.attributes;
	                for(var idx in attributes) {
	                    var itemAtt = attributes[idx];
	                    var dataKey = itemAtt.nodeName;
	                    var dataValue = itemAtt.nodeValue;
	
	                    if(dataKey !== undefined) {
	                        obj[dataKey] = dataValue;
	                    }
	                }
	                var nodeName = item.nodeName;
	
	                if (typeof (obj[nodeName]) == "undefined") {
	                  obj[nodeName] = xml2json(item);
	                } else {
	                  if (typeof (obj[nodeName].push) == "undefined") {
	                    var old = obj[nodeName];
	
	                    obj[nodeName] = [];
	                    obj[nodeName].push(old);
	                  }
	                  obj[nodeName].push(xml2json(item));
	                }
	              }
	            } else {
	              obj = xml.textContent;
	            }
	            return obj;
	          } catch (e) {
	              console.log(e.message);
	          }
	    }
	
	    EXIF.enableXmp = function() {
	        EXIF.isXmpEnabled = true;
	    }
	
	    EXIF.disableXmp = function() {
	        EXIF.isXmpEnabled = false;
	    }
	
	    EXIF.getData = function(img, callback) {
	        if (((self.Image && img instanceof self.Image)
	            || (self.HTMLImageElement && img instanceof self.HTMLImageElement))
	            && !img.complete)
	            return false;
	
	        if (!imageHasData(img)) {
	            getImageData(img, callback);
	        } else {
	            if (callback) {
	                callback.call(img);
	            }
	        }
	        return true;
	    }
	
	    EXIF.getTag = function(img, tag) {
	        if (!imageHasData(img)) return;
	        return img.exifdata[tag];
	    }
	    
	    EXIF.getIptcTag = function(img, tag) {
	        if (!imageHasData(img)) return;
	        return img.iptcdata[tag];
	    }
	
	    EXIF.getAllTags = function(img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.exifdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    }
	    
	    EXIF.getAllIptcTags = function(img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.iptcdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    }
	
	    EXIF.pretty = function(img) {
	        if (!imageHasData(img)) return "";
	        var a,
	            data = img.exifdata,
	            strPretty = "";
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                if (typeof data[a] == "object") {
	                    if (data[a] instanceof Number) {
	                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
	                    } else {
	                        strPretty += a + " : [" + data[a].length + " values]\r\n";
	                    }
	                } else {
	                    strPretty += a + " : " + data[a] + "\r\n";
	                }
	            }
	        }
	        return strPretty;
	    }
	
	    EXIF.readFromBinaryFile = function(file) {
	        return findEXIFinJPEG(file);
	    }
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return EXIF;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}.call(this));
	


/***/ }),
/* 4889 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 4890 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_94faa222","outerContainer":"_18b0a306","secondaryToolbar":"e268f0ad","doorHangerRight":"_4fa2b2a4","toolbarContainer":"a092f5dc","toolbarViewerMiddle":"_7681b705","progressBar":"aa6d7420","back-to-application":"b8741de1","consent":"bdee2624","consent__text":"_68daab86","consent__actions":"ac15138c"};

/***/ }),
/* 4891 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"cefaf8b2","outerContainer":"_00b9bd8f","secondaryToolbar":"d55d0c13","doorHangerRight":"b499b9b0","toolbarContainer":"_246618b8","toolbarViewerMiddle":"f87678e2","progressBar":"_81d159c6","back-to-application":"_7537e745","questions":"f4ec80b7","list":"_814bf2df"};

/***/ }),
/* 4892 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7b66d183","outerContainer":"a75d82eb","secondaryToolbar":"_8cdec53f","doorHangerRight":"_4204a8a0","toolbarContainer":"_98c9ace1","toolbarViewerMiddle":"_72e142f9","progressBar":"_9de4ebac","back-to-application":"_608c6413","questions":"f91bd237"};

/***/ }),
/* 4893 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"location":"e1535e77","pointer":"f6b1b69b"};

/***/ }),
/* 4894 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_22a95fdf","outerContainer":"_6990caec","secondaryToolbar":"b5ac9c96","doorHangerRight":"_334cbb32","toolbarContainer":"_25b552f1","toolbarViewerMiddle":"a7dcf3b9","progressBar":"d67a69cc","back-to-application":"_2e587fe3","root":"cb2b98ee","header":"b70ac254","title":"_1629832f","actionButton":"_168af7c3","loader":"d90370d2","providerList":"eda17a55","providerInfo":"_2c41f4b8","providerName":"ce48aa9e","hidden":"_0cf21be5","paginationLoader":"a6dec059","backButton":"e11fb965"};

/***/ }),
/* 4895 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e6cf33a0","outerContainer":"_05d87805","secondaryToolbar":"_67aef389","doorHangerRight":"_26efd72e","toolbarContainer":"ace5161a","toolbarViewerMiddle":"b5fec3fe","progressBar":"_0d57fe0f","back-to-application":"c564c751","inlineVisitBtns":"b84c8dfc"};

/***/ }),
/* 4896 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_0448823d"};

/***/ }),
/* 4897 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a7516198","outerContainer":"bf061dc4","secondaryToolbar":"_15246927","doorHangerRight":"_6a2e9466","toolbarContainer":"_3bd6296a","toolbarViewerMiddle":"_14709895","progressBar":"b53a5479","back-to-application":"_2a100d9c","payment":"_92f7111f","content":"_22068303","form":"f3113baa"};

/***/ }),
/* 4898 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ae208505","outerContainer":"_7f9a390b","secondaryToolbar":"_70226cd4","doorHangerRight":"_96e29987","toolbarContainer":"cefd4ebc","toolbarViewerMiddle":"ec78a5da","progressBar":"deb76550","back-to-application":"_673d5dab","location":"_802fc7e4","buttonsBlock":"f56eea7b","hide":"_484a0f31","address":"_751798ae"};

/***/ }),
/* 4899 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f8346fb8","outerContainer":"_3d8c1c87","secondaryToolbar":"ae442b49","doorHangerRight":"c62b412f","toolbarContainer":"_31192d1e","toolbarViewerMiddle":"_83340985","progressBar":"a6007dbd","back-to-application":"a04a5ad0","searchBlock":"c1956cdf","searchPharmacy":"_9bdc8742","inputStyles":"_5cde6397","confirmBtn":"_804923df","checkboxStyles":"eb88a3e3","withoutMailOrder":"_8506a788"};

/***/ }),
/* 4900 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4482606b","outerContainer":"c33cad2b","secondaryToolbar":"_43c432dd","doorHangerRight":"_8dee45c9","toolbarContainer":"_52e31257","toolbarViewerMiddle":"e8e54ceb","progressBar":"_173ae0eb","back-to-application":"_51afa032","popupRoot":"_49d581b9","popupContent":"fa5839a8","popupPadding":"_05ca8c0f","popupWidth":"bbad4d45","emptyContent":"b45708f4","searchPharmacy":"caa8bcbf","searchBlock":"_6b81950e","pharmacyItemsWrapper":"_633431b2","pharmacyItem":"_5d79b595","pharmacySelectItem":"a645c9b3","labelStyles":"_4683f282","pharmacyCount":"_45f666a8","hideIcon":"_7e09c7d8","showIcon":"e3c9abc4","extraContent":"fae8c04a"};

/***/ }),
/* 4901 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_00355a70","outerContainer":"_8209b281","secondaryToolbar":"_8fcbbd0a","doorHangerRight":"_4fd8c399","toolbarContainer":"ef117a4c","toolbarViewerMiddle":"_322e78df","progressBar":"c6662dbf","back-to-application":"_43457f88","root":"af6464bf","left":"aab6e76d","right":"_5a7187d5","time-title":"_38f462ed","locationWrapper":"_9964abea","content":"c8629f88","locationName":"_91776101","locationAddress":"_8de9c60c","emptyList":"_48054220","locationHeader":"db97f2e8"};

/***/ }),
/* 4902 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_872de770","outerContainer":"_517de78e","secondaryToolbar":"_8099660b","doorHangerRight":"_71b33de5","toolbarContainer":"_3b75ce00","toolbarViewerMiddle":"b2e46f48","progressBar":"_9f2d0f9a","back-to-application":"_80bab454","root":"_939ea65f","row":"e1511463","align-top":"_2240a19e","right":"bd8ea29d","logo":"_4610d9ae","meta":"_25a24a2e","info-block":"_23a2db8b","info-title":"b38da132","description":"d86f0f30"};

/***/ }),
/* 4903 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c9821ef4","outerContainer":"efca6a04","secondaryToolbar":"_3790c05d","doorHangerRight":"bcc093e1","toolbarContainer":"_20c33f3a","toolbarViewerMiddle":"_24723b50","progressBar":"a84320c1","back-to-application":"_240d80b0","root":"c1ac2718","toggle":"cb1237c6","button":"da931072","activeButton":"bb17a186","notification":"_8d4ef192","closeBtn":"f3ba55a4"};

/***/ }),
/* 4904 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_81d15767","outerContainer":"_8f9bc62d","secondaryToolbar":"_411b4360","doorHangerRight":"_9b6d2013","toolbarContainer":"_6666326b","toolbarViewerMiddle":"_4474ca36","progressBar":"_85937271","back-to-application":"_7b5fdc3a","root":"_3c5578b5","disabled":"f659fd82","DateFilter":"_8efe0144","DateFilterInput":"_6e6ffc7a"};

/***/ }),
/* 4905 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d8715d9c","outerContainer":"_6b16c96c","secondaryToolbar":"_661dbe29","doorHangerRight":"fa2a1b72","toolbarContainer":"_88dc504c","toolbarViewerMiddle":"a37968b4","progressBar":"aac0bed3","back-to-application":"f0233546","infoWrapper":"b7a15f4d","info":"ad7a0e66","button":"_0d2186bf"};

/***/ }),
/* 4906 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"_6f7e269d","loader":"c3d16308"};

/***/ }),
/* 4907 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_64208f15","outerContainer":"_782ed7ed","secondaryToolbar":"_6de18cf6","doorHangerRight":"_57197c9c","toolbarContainer":"b2859e8b","toolbarViewerMiddle":"_7deb5d3c","progressBar":"_223b0b34","back-to-application":"c747997b","emptyBlock":"_02377922","modalWrapper":"_10e17c15","buttonsWrapper":"_639c31b2","modalTitle":"_9f7e138b","description":"_119a9604","title":"ffadb772"};

/***/ }),
/* 4908 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d9ad48d9","outerContainer":"f666a297","secondaryToolbar":"a1f1e6cd","doorHangerRight":"_4ffee312","toolbarContainer":"_7ada1492","toolbarViewerMiddle":"b585175d","progressBar":"_59044e34","back-to-application":"_9c2afd56","header":"_4f9e55d7","content":"_781b0570"};

/***/ }),
/* 4909 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e511502e","outerContainer":"_8ae78b1e","secondaryToolbar":"_2add3f3f","doorHangerRight":"_95bb34ee","toolbarContainer":"c3006b36","toolbarViewerMiddle":"ec15a464","progressBar":"a5dd26b9","back-to-application":"_543eca13","root":"_961da3da","title":"_99aea20a","message":"_23741310","button":"_0e47ff4e"};

/***/ }),
/* 4910 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1c932fbd","outerContainer":"_9261f513","secondaryToolbar":"f55b0fd9","doorHangerRight":"_54854dd1","toolbarContainer":"_7ca10421","toolbarViewerMiddle":"_84e82f99","progressBar":"c2463bcd","back-to-application":"_030069ac","header":"f1b2c70f","title":"_730d52ec","subTitle":"e9c6cc4d","titleWrap":"_3ce987f8","backBtn":"b1b33513"};

/***/ }),
/* 4911 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0e8da8ee","outerContainer":"bacbe079","secondaryToolbar":"_81a49706","doorHangerRight":"db92e9c5","toolbarContainer":"_8ed2759b","toolbarViewerMiddle":"b6b7246e","progressBar":"_04544c77","back-to-application":"_522d21df","root":"_88e26ede","backBtn":"e1c363e6","content":"_257ebc89","loading":"_9a550108","title":"e2bb8575","mainTitle":"_3a6cb34a","description":"d626ac60","cellTitle":"a2d15898","cellText":"_6058e9da","card":"d0480956","btnAdd":"cedd372b","transactionDescription":"_52d81889","btnSubmit":"_047b5af4","icon":"f66ba1d9","loaderWrapper":"_05644a85","headerDescription":"c8b17df9"};

/***/ }),
/* 4912 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7d8bc715","outerContainer":"cb371735","secondaryToolbar":"ec1af2ee","doorHangerRight":"_7a1d5f7d","toolbarContainer":"_56403ef0","toolbarViewerMiddle":"af49f07c","progressBar":"_2310c62f","back-to-application":"ec926921","DayPicker":"e725efae","disabled":"_3effca89","DayPickerContainer":"a53e6828","DayPickerCarousel":"_35218ae7","DayPickerBack":"af21dbc4","DayPickerNext":"a3876d11","DayItem":"_6926e606","DayItemWrapper":"_2a785a06","active":"_302ac461","DayItemDate":"cfef4e48","DayItemDay":"b67a4875"};

/***/ }),
/* 4913 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_3ca4ada2","outerContainer":"_57a182f2","secondaryToolbar":"_0b3c75cd","doorHangerRight":"d785e81c","toolbarContainer":"_8702b0d5","toolbarViewerMiddle":"_873a2675","progressBar":"_4cf3b799","back-to-application":"cd07287c","modal-body":"_95a42fd7"};

/***/ }),
/* 4914 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_2f80d80c","outerContainer":"_026f991b","secondaryToolbar":"_4c499a4a","doorHangerRight":"ae3fbb2d","toolbarContainer":"c1843909","toolbarViewerMiddle":"_556819ed","progressBar":"a4e2f13f","back-to-application":"_49bdfd33","LocationPicker":"_51936cae","LocationPickerTrigger":"_2fcc1e73","left-icon":"_96dbfacd","right-icon":"_5aa83475","fill":"_90f1da2b","LocationPickerRow":"_47a53191","LocationPickerInfo":"fac88ebf","strong":"_78e3d603","meta":"_674b6d55"};

/***/ }),
/* 4915 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a9b5ab62","outerContainer":"_2cc5192c","secondaryToolbar":"d9c1ad97","doorHangerRight":"e00f833c","toolbarContainer":"ac2b053e","toolbarViewerMiddle":"_980213d2","progressBar":"_9c142f1a","back-to-application":"aa5cdd36","root":"c963603d","row":"d9d62b84","right":"_5a7e56bc","content":"d3d40b3f","link":"_30c4638d","separator":"_0082a5e3"};

/***/ }),
/* 4916 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_8f0f1899","outerContainer":"_73f07663","secondaryToolbar":"_5fd7426d","doorHangerRight":"_151bb01a","toolbarContainer":"d793f3ea","toolbarViewerMiddle":"_497db53a","progressBar":"c959f685","back-to-application":"ef1cb564","root":"_74463180","name":"_3f5572ea","strong":"_03474a41","meta":"_93238f7f"};

/***/ }),
/* 4917 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0288994d","outerContainer":"e25fe44a","secondaryToolbar":"ebfa210e","doorHangerRight":"_3b0ade63","toolbarContainer":"_6bba37c0","toolbarViewerMiddle":"d7a3df31","progressBar":"fc8c9208","back-to-application":"_9b42dff6","root":"_99574443","md":"_85418565","slot":"d94b62c2","sm":"_0c1b7d57","emptyList":"dcff2d7e","active-slot":"_9844ff80"};

/***/ }),
/* 4918 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_759e90f8","outerContainer":"_2bb2ff7f","secondaryToolbar":"a44f25ca","doorHangerRight":"_7af3ec1c","toolbarContainer":"_017b1ca9","toolbarViewerMiddle":"_4da84a38","progressBar":"_92eaee9b","back-to-application":"cd2ca020","Overview":"beace78b","Overview--topPosition":"_8d272633","loading":"f27fc1f0","OverviewRow":"f2c4d8da","loader":"db39474a","fullWidthRow":"_5b9b66e0","OverviewHeader":"_1bc23144","inlineVisit":"_56aa299c","OverviewCell":"e195bd92","OverviewCell-title":"f30eb9d8","OverviewCell-text":"b5f106e1","OverviewCell-extra":"d850b67a","OverviewCell-location":"f551e12a"};

/***/ }),
/* 4919 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_2c6e49a8","outerContainer":"a4562925","secondaryToolbar":"_939ecb00","doorHangerRight":"_6df8c83e","toolbarContainer":"_886379b5","toolbarViewerMiddle":"_5cc1e07a","progressBar":"_1bc063b5","back-to-application":"a7e4fe21","root":"b3751f8a","root--wide":"_77450c04","content":"_8ebb9617","content--wide":"bd12af3e","wrapper":"e3e5dd0c","form":"b7551748","form--wide":"_85b5ce9e","form--squeeze":"_436c14c1","btnBack":"_23e8d949","formPaper":"aa5537e4","formWrapper":"_27b20569","withPadding":"_939b3dce","formTitle":"_30b74e72","welcomeText":"fe5b9835","formHeading":"f68b7a85","formText":"baf9efc9","links":"_02ebd542","link":"_0505d219","hidden":"_84045913","recoverLink":"a5db50c5","acceptBtn":"e6a6dfc9","cancelBtn":"_080c902e","signupLink":"_673a2f98","errorBlock":"_57f85f2b","fieldsList":"_0896d2b6","inputField":"c8dfd579","labelField":"_2309378e","checkboxConfirm":"_585ed669","selectField":"_47de0149","ssnField":"d8f079d3","subDescription":"_9cca9531","description":"_71b361fd","text":"_300ccf2c","appBtn":"_0d86b85d","loginAzureWrapper":"b56733bd","dividerOr":"_66dec665","microsoftLogo":"_8f114218","microsoftButton":"bcceb736","signUpAzureWrapper":"_18007845","signUpAzureDescription":"_6d34a28f","signUpAzureProceed":"b98fc345","poweredByHealthfully":"c6faeedd"};

/***/ }),
/* 4920 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_5a56f6b7","outerContainer":"e53f90c2","secondaryToolbar":"ba47ed22","doorHangerRight":"_70a4780f","toolbarContainer":"ffd83e41","toolbarViewerMiddle":"_9325fd6d","progressBar":"_60172739","back-to-application":"_5a8bca7c","image":"_848967a9","image--bordered":"_06f775ac"};

/***/ }),
/* 4921 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_01da928d","outerContainer":"_18e2f993","secondaryToolbar":"_2fbe8de6","doorHangerRight":"_0fe662d2","toolbarContainer":"_232cf6e4","toolbarViewerMiddle":"_1a9ce496","progressBar":"_7966c6ab","back-to-application":"ce80cb3d","root":"_24fbe635","image":"_6296cded","image--bordered":"_371c7d1e","image--not-transparent":"_879499af","edit-button":"_2b86b8d7","actions":"d09110f3","action":"a2cf2639","avatar-input-label":"d040c08e"};

/***/ }),
/* 4922 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d0ddcffd","outerContainer":"b0acfc6e","secondaryToolbar":"_9d4b4a07","doorHangerRight":"_9c3a6108","toolbarContainer":"_17908803","toolbarViewerMiddle":"f8524cb4","progressBar":"f5c68d33","back-to-application":"b7b6ea71","root":"bafa7aa6","root--large":"_49f7c065","text":"_2e97bf01","root--colored":"_2d1c832d"};

/***/ }),
/* 4923 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bf9499fd","outerContainer":"_94e70c38","secondaryToolbar":"ac6495c6","doorHangerRight":"f6685f03","toolbarContainer":"_54ffa8bb","toolbarViewerMiddle":"_67bc2d3f","progressBar":"_95079b09","back-to-application":"f9aae30b","description":"_9c4da19b","completed":"_3df902e4","section":"_80bc91c7","title":"c21dc948","link":"d9b68ed1"};

/***/ }),
/* 4924 */,
/* 4925 */,
/* 4926 */,
/* 4927 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_04247af0","outerContainer":"_9ce2d079","secondaryToolbar":"_310016d5","doorHangerRight":"e2be9780","toolbarContainer":"_97fba090","toolbarViewerMiddle":"_1706a44f","progressBar":"a7a634f9","back-to-application":"_801de4ba","root":"_3e267461","title":"_1cda5981","item":"_20b8a471","item--danger":"eededa45"};

/***/ }),
/* 4928 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_6d9e80f0","outerContainer":"a29dfe3e","secondaryToolbar":"ab6d24b7","doorHangerRight":"_799fe530","toolbarContainer":"d3f0623f","toolbarViewerMiddle":"_4982c940","progressBar":"_2076e84a","back-to-application":"_182c90de","root":"a377a3e4","disabled":"_587e15d8","root--hoverable":"_89ad6edd"};

/***/ }),
/* 4929 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d42405eb","outerContainer":"_8e9ca70c","secondaryToolbar":"_2b269a09","doorHangerRight":"_9836a061","toolbarContainer":"_7058a0bf","toolbarViewerMiddle":"_1bf1c0a6","progressBar":"a31c0720","back-to-application":"_4949553a","list-wrapper":"db56cccc","list":"_4baf6747","title":"_917c3002"};

/***/ }),
/* 4930 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0a630202","outerContainer":"_1d303e81","secondaryToolbar":"c8b1ab5d","doorHangerRight":"be04d751","toolbarContainer":"_3c5922de","toolbarViewerMiddle":"_6d2b68bd","progressBar":"da67026c","back-to-application":"_53998c19","Card":"_00d4421c","CardLogo":"_8cc56460","CardWrapper":"c5314ffc","CardContent":"_45ff7201","CardBody":"_7e23377d","CardActions":"_06908063","CardTitle":"b192c523","CardSubTitle":"_5175738f","CardSubContent":"_96651079","CardText":"_3fcb0af1","CardInfo":"_184eaca2","CardInfo-item":"c6ab2f28"};

/***/ }),
/* 4931 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"de023ec6","outerContainer":"a6dff90c","secondaryToolbar":"de4ae97d","doorHangerRight":"_0e4b33a3","toolbarContainer":"_2084e73f","toolbarViewerMiddle":"_1a2b4263","progressBar":"eb6b60d0","back-to-application":"a6d66b61","card":"_0a5db05f","wrapper":"_10c2e35c","content":"e3b2086b","avatar":"_460fee5e","title":"_78e8565e","subtitle":"e64c04ca","badge":"f522c49d","badge-text":"_038fd6e3"};

/***/ }),
/* 4932 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"cd403170","outerContainer":"f831f724","secondaryToolbar":"_1ebda30a","doorHangerRight":"bc589138","toolbarContainer":"c9812e86","toolbarViewerMiddle":"aec9426d","progressBar":"_148db2cf","back-to-application":"_60283d1a","root":"_10aa1a40","item":"_2949829a","item-text":"_89771e1a","item-text--danger":"_8199a50f","root--column":"add7851d"};

/***/ }),
/* 4933 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_96d72f93","outerContainer":"cc9e8232","secondaryToolbar":"_36aa8524","doorHangerRight":"ed90fe8c","toolbarContainer":"_5935c591","toolbarViewerMiddle":"_0d0f9019","progressBar":"c974b411","back-to-application":"f7288db2","Report":"ea420eda","ReportLogo":"_4a6a46be","ReportWrapper":"_58f99238","ReportBody":"_93d7e9cc","ReportActions":"_52521187","ReportTitle":"_28805891","ReportText":"_405554ea","ReportInfo":"_4e27e6f3","ReportInfo-item":"_0579b14e"};

/***/ }),
/* 4934 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bb00d05b","outerContainer":"b38f67e7","secondaryToolbar":"a9467b64","doorHangerRight":"_1757a851","toolbarContainer":"ecfad133","toolbarViewerMiddle":"_5a36e5fe","progressBar":"_95f5dd10","back-to-application":"e55d3575","root":"_75d2efde","grid":"b283f4ce","avatar":"d464dd23","content":"_7b9abc7f","images":"_38b03719","images-item":"_1c116080"};

/***/ }),
/* 4935 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ef836e05","outerContainer":"_009aa36e","secondaryToolbar":"e0e414de","doorHangerRight":"_1adb0110","toolbarContainer":"f35064e4","toolbarViewerMiddle":"_8e033d5f","progressBar":"_01eb9694","back-to-application":"a5e3f4b1","root":"_564dc41b","loading":"e1326476"};

/***/ }),
/* 4936 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_6106781d","outerContainer":"_2fa3652a","secondaryToolbar":"a1625f16","doorHangerRight":"_54f77e34","toolbarContainer":"_7a3ffb7e","toolbarViewerMiddle":"be086ee2","progressBar":"b6c1eda7","back-to-application":"_8ddbbe64","consent":"_58ae94e7","title":"ab5a4a28","name":"f8a5e99e","idx":"fa040782","total":"_512d2edb","subtitle":"aa42d115","content":"_0eb1db50","footer":"_11f31136","button":"f3294bb1"};

/***/ }),
/* 4937 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_2cf95da9","outerContainer":"_07a01333","secondaryToolbar":"_019f1158","doorHangerRight":"a5daf168","toolbarContainer":"ac82aec6","toolbarViewerMiddle":"_6d4a8a17","progressBar":"_29a5c477","back-to-application":"_6fbf0e0c","content":"_3905c1b4","contentHeader":"_559eb183","mainTitle":"_833863ea","consentTitle":"f6a5d803","consentSubTitle":"_191f2905","text":"_4fb0a628","counter":"_30c71cff","nonSanitizedContent":"_980a8b26"};

/***/ }),
/* 4938 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_730611dd","outerContainer":"_623b42e0","secondaryToolbar":"b7a6d3d5","doorHangerRight":"a4103a7a","toolbarContainer":"_2678bbed","toolbarViewerMiddle":"_1750c8d3","progressBar":"_05290f17","back-to-application":"_872ba97f","consent":"_5d26ee4c","info":"b4bcd7fd","icon":"_3e69cc5a","title":"_88abcf3a","subtitle":"a761abc7","assignment":"f69de8b8","status":"a0aaec6c"};

/***/ }),
/* 4939 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_223b90c1","outerContainer":"_3d97740a","secondaryToolbar":"be942888","doorHangerRight":"dbe45458","toolbarContainer":"d9dbda8e","toolbarViewerMiddle":"_3538f75d","progressBar":"f29f03fc","back-to-application":"ea3876db","bar":"_6a0e4487","barTitle":"_168dcaf5","text-wrapper":"_5d48d6a5","title":"f16405b4","subtitle":"_093e09f1","transparent":"_9d7d2061"};

/***/ }),
/* 4940 */,
/* 4941 */,
/* 4942 */,
/* 4943 */,
/* 4944 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0b5ff574","outerContainer":"_2062d934","secondaryToolbar":"b66a4ae5","doorHangerRight":"_550c1ba6","toolbarContainer":"da343745","toolbarViewerMiddle":"_919cb4b4","progressBar":"f0108f78","back-to-application":"_3bf2820d","content":"c2a758ee"};

/***/ }),
/* 4945 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_8ea3013f","outerContainer":"f6b96e46","secondaryToolbar":"ab5df7ac","doorHangerRight":"_98c99761","toolbarContainer":"bcee3077","toolbarViewerMiddle":"_6da9f621","progressBar":"_043035ff","back-to-application":"_23a9ada4","root":"_0376cb08","hideEllipsis":"affa2961","definition":"_2de767c3","root--multiline":"d5fb5c9f","description":"_76a4c72b"};

/***/ }),
/* 4946 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4b30dc28","outerContainer":"f10ccf25","secondaryToolbar":"_8bfe1b15","doorHangerRight":"ec6abebf","toolbarContainer":"_07183c16","toolbarViewerMiddle":"_0a21bd5d","progressBar":"_19f50aed","back-to-application":"a687154a","root":"_9a10aa55","disabled":"_55dfdba6","row":"_65b0fb0c","title":"_58f88124","text":"_70c9fd7c"};

/***/ }),
/* 4947 */,
/* 4948 */,
/* 4949 */,
/* 4950 */,
/* 4951 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_362c58c9","outerContainer":"c276b9d2","secondaryToolbar":"e26d9fa5","doorHangerRight":"_68a5c2f0","toolbarContainer":"fb10fcaf","toolbarViewerMiddle":"_3572eed9","progressBar":"_9e707d36","back-to-application":"a57189af","root":"_15f5dd43","fadeIn":"_15e408fd","title":"_5f08c887","content":"d7911a35","image":"_97c34585","button":"_39cc3893","dialog":"_2d63cb64"};

/***/ }),
/* 4952 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_00acdbce","outerContainer":"_74a0b3da","secondaryToolbar":"cf76a040","doorHangerRight":"_0ec1bc57","toolbarContainer":"_50132722","toolbarViewerMiddle":"fe124f48","progressBar":"_18216de8","back-to-application":"_8a363002","root":"_5c3089ef","marker":"_7ce3310e","head--default":"_149966ee","head":"_193bcc08","head--locked":"_3a3cacf5","head--closed":"_20a9bd26","head--large":"d1a42e1d"};

/***/ }),
/* 4953 */,
/* 4954 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_40f078c0","outerContainer":"ae5990ff","secondaryToolbar":"d205a79b","doorHangerRight":"_3702e4b0","toolbarContainer":"a2aa4247","toolbarViewerMiddle":"b75f2a7d","progressBar":"_44272edb","back-to-application":"b0dc502c","root":"_32db1e0e","title":"_1269c81b","content":"_919d35df","row":"_54d59f7d","dayOfWeek":"_74bee0c2","workingHours":"_25f49926","toggleStateView":"_81db92bf","currentDay":"_546be518"};

/***/ }),
/* 4955 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4c287ba5","outerContainer":"_9c490dac","secondaryToolbar":"c4b96b2e","doorHangerRight":"f62d3c8d","toolbarContainer":"e9875471","toolbarViewerMiddle":"a5ab079a","progressBar":"_782a0b34","back-to-application":"_369a358a","root":"_199fc723","popup":"_34c77f43","headerPopup":"f5d85fe4","closeBtn":"_4da6cfaf","wrapper":"ada4a953","divider":"faff004c","titleLocation":"c767e006","description":"_354e72da","title":"f161b284"};

/***/ }),
/* 4956 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4eae5a25","outerContainer":"_83e52b70","secondaryToolbar":"a54d48c7","doorHangerRight":"_8a155db8","toolbarContainer":"_3b712b69","toolbarViewerMiddle":"db888938","progressBar":"_49b82547","back-to-application":"c8b232d8","wrapper":"c3749196","titleLocation":"ae5403db","description":"c0cc8735"};

/***/ }),
/* 4957 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_853c074e","outerContainer":"b88dfa0d","secondaryToolbar":"c221072e","doorHangerRight":"e80b13e0","toolbarContainer":"_5c443774","toolbarViewerMiddle":"_49b697f4","progressBar":"_975d0092","back-to-application":"_6afa638c","testBtn":"_127d31e7"};

/***/ }),
/* 4958 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4edaef3e","outerContainer":"_0c123f37","secondaryToolbar":"d66df8c8","doorHangerRight":"_4a3c0f1e","toolbarContainer":"_32aa6cd4","toolbarViewerMiddle":"_6ec8b218","progressBar":"_2e4b8e7b","back-to-application":"_22badb00","footer":"_18d7d2ed","btn":"_179d840d","confirmationRow":"_35f42e59","paymentRow":"_3972c4a0","paymentTitle":"ece1b026","paymentValue":"_373296a6","contactProvider":"_0805faa4","btn--wide":"_5d8ad2d4","btn--offset":"_66df8f38"};

/***/ }),
/* 4959 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7652bfe2","outerContainer":"_1497ea13","secondaryToolbar":"_8e4980a2","doorHangerRight":"_27f9b319","toolbarContainer":"_6ad3d4c0","toolbarViewerMiddle":"_97447809","progressBar":"_40c09906","back-to-application":"_8b4d5783","durationWrapper":"d9c6c659","durationTitle":"_55346964","durationValue":"d2d965ba","status":"_923d9bca","btn":"_90ed900f","in-progress":"_61f0c842"};

/***/ }),
/* 4960 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_733ecd1d","outerContainer":"_5540b98b","secondaryToolbar":"d5360776","doorHangerRight":"_57afac72","toolbarContainer":"c3d9e100","toolbarViewerMiddle":"_8520cf2a","progressBar":"cc0a5dd0","back-to-application":"b3d6d622","Payment":"_75b4b5af","fadeout":"a13c7a8a","PaymentHeader":"aff5b18b","PaymentContent":"_4ff91fea","PaymentContentFullWidth":"_255668d3","PaymentInfo":"_8d44ee11","PaymentRow":"_54f82882","blue":"_1598d155","bold":"_20695206","PaymentSeparator":"dac41e08","PaymentBtn":"_22638794"};

/***/ }),
/* 4961 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_878bf5c7","outerContainer":"_005460dc","secondaryToolbar":"_23c72c51","doorHangerRight":"e18885a4","toolbarContainer":"a3eec854","toolbarViewerMiddle":"_829f763a","progressBar":"_17cb2a88","back-to-application":"c333ba5c","icon":"b617d756","confirmedStatusTitle":"_5d928cb1"};

/***/ }),
/* 4962 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c534afb8","outerContainer":"f46b687b","secondaryToolbar":"_9ab55f74","doorHangerRight":"_4d2552bf","toolbarContainer":"_756b01cf","toolbarViewerMiddle":"_3cf9730d","progressBar":"_9cd10ea5","back-to-application":"_15aa7cbb","Discount":"_47fc5df4","DiscountTitle":"_960fd691","DiscountText":"cc132be9","DiscountInput":"ed70dcdd","DiscountInput-control":"_4bbc458d","DiscountError":"_8128f753"};

/***/ }),
/* 4963 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"_18f23e50","titles":"_9e766f3e","title":"_9fad2c08","subtitle":"_0113fe21"};

/***/ }),
/* 4964 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e69a859f","outerContainer":"_40aa4151","secondaryToolbar":"_9ac10b0b","doorHangerRight":"_43b7f001","toolbarContainer":"_6d6356ed","toolbarViewerMiddle":"_156f9ddd","progressBar":"a4f0b7ba","back-to-application":"ef4f8c8a","root":"_60e7d3f2","btn":"_53c801bd","btnVirtualVisit":"_6da65969","enabledBtn":"_3dca3b3e","icon":"_452f74bc","clearBtn":"ce2c1447"};

/***/ }),
/* 4965 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"_9f66f868","noMargin":"e87ce420","paginationLoader":"bdcf7744"};

/***/ }),
/* 4966 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_15e3bad0","outerContainer":"ae8ecd59","secondaryToolbar":"_380523f8","doorHangerRight":"_41f16c86","toolbarContainer":"_6e981637","toolbarViewerMiddle":"_0de40a90","progressBar":"_063df7bc","back-to-application":"_03a25863","root":"_32dfe9f4","content":"_5fe893de"};

/***/ }),
/* 4967 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ef7f2365","outerContainer":"_25f5589a","secondaryToolbar":"_99baa78b","doorHangerRight":"_20660f38","toolbarContainer":"_55eb2401","toolbarViewerMiddle":"f5a40d65","progressBar":"fef4ebba","back-to-application":"cdc0b9aa","root":"_40269e9a","disableModal":"_48e9e177","header":"f2a97b20","consent":"e988f811"};

/***/ }),
/* 4968 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f2013b6e","outerContainer":"_037e70f8","secondaryToolbar":"_5c274680","doorHangerRight":"_3503731c","toolbarContainer":"_6fea4631","toolbarViewerMiddle":"_5150a6da","progressBar":"_85b2a33d","back-to-application":"_939fa4be","root":"caa1157e","content":"_63ce3a27","text":"_19753fff","title":"ffca292e"};

/***/ }),
/* 4969 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"eabb6c38","outerContainer":"b8bc4553","secondaryToolbar":"f65f81c3","doorHangerRight":"_3275e8e1","toolbarContainer":"_87481a77","toolbarViewerMiddle":"d08ea716","progressBar":"f5b54b33","back-to-application":"d494df5a","content":"_3de570b5","descriptionSection":"_65d9999f"};

/***/ }),
/* 4970 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ddcd5072","outerContainer":"_55b0c324","secondaryToolbar":"_0c7101ad","doorHangerRight":"_09538a27","toolbarContainer":"_5fbe9c34","toolbarViewerMiddle":"a35561ae","progressBar":"_9eac9c02","back-to-application":"_210907a7","content":"_8c3728ad","checkBox":"fc1280e0","insuranceCards":"f02e63a2","generalInfo":"_6020bec8","primarySubscriber":"c9359707","section":"dc43925b","buttonLoading":"_27e1b573","descriptionSection":"_8e5e8741"};

/***/ }),
/* 4971 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d499adc5","outerContainer":"e18fd8e4","secondaryToolbar":"_40909c56","doorHangerRight":"_06b3d5d6","toolbarContainer":"_6e2e06b6","toolbarViewerMiddle":"_95652f6d","progressBar":"a4a6fb1e","back-to-application":"cec14ec8","section":"_656d7a38","link":"fe620c2e"};

/***/ }),
/* 4972 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_228c6447","outerContainer":"_18c06e3c","secondaryToolbar":"_122b7198","doorHangerRight":"eee4abd1","toolbarContainer":"_39ba0863","toolbarViewerMiddle":"_14ae4cde","progressBar":"b13392a3","back-to-application":"_4bdaef31","root":"_33a5075d","content":"d1ce73cc","pending":"e97cdffa","details":"fe45e0b2","info":"_6a1eb60a","invitator":"_922ff907","terms":"_00830ae1","loader":"_93203695","header":"_06574c92"};

/***/ }),
/* 4973 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_57dd5e47","outerContainer":"_95a04caa","secondaryToolbar":"_4173517a","doorHangerRight":"_902d21f8","toolbarContainer":"_62ac13ac","toolbarViewerMiddle":"_884e70b2","progressBar":"a9617c26","back-to-application":"_770abee6","root":"d05c41ed","left":"fdc123d2","right":"_40796bc1","strong":"_380d5468","meta":"e3f851d3"};

/***/ }),
/* 4974 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a84c6f53","outerContainer":"ac415981","secondaryToolbar":"_40d1899e","doorHangerRight":"cd4dfbf6","toolbarContainer":"e2ce7342","toolbarViewerMiddle":"_8e411e4c","progressBar":"_79519565","back-to-application":"_2a301a57","root":"_36951189","header":"_6afa43f1","title":"c120b880","text":"d12dec84","link":"_37cea1a4","content":"ab6e8595"};

/***/ }),
/* 4975 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c4467f5f","outerContainer":"_6bd506e9","secondaryToolbar":"c82dd4e9","doorHangerRight":"cf5a8ead","toolbarContainer":"_977742fa","toolbarViewerMiddle":"_1f6126f1","progressBar":"_1f09159b","back-to-application":"cbd0d9ac","root":"_4232ef76","name":"_9ab77171","strong":"_88385c3b","meta":"c2b624c2","noAvatar":"_91a1a974","noMeta":"d8e847fd"};

/***/ }),
/* 4976 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7828539c","outerContainer":"_51fa8022","secondaryToolbar":"fa9fb14c","doorHangerRight":"_1f7baa0b","toolbarContainer":"_9b2f0372","toolbarViewerMiddle":"d126cffb","progressBar":"_2fd1033e","back-to-application":"_3f459bc6","root":"_7cb93d4e","backBtn":"e7713200","paymentView":"_29fe3e47","paymentViewLoading":"_490eb9b5","header":"c2dc98a2","headerTitle":"a6638b42","loader":"a6cabca6","headerDescription":"_66506e10"};

/***/ }),
/* 4977 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_82b43b37","outerContainer":"_7e2b578d","secondaryToolbar":"_37183907","doorHangerRight":"c1b87036","toolbarContainer":"b12813e3","toolbarViewerMiddle":"_6f639268","progressBar":"_1ad05613","back-to-application":"_03f3ba1b","root":"b51adc31","back-btn":"a98f6bf1","payment-view":"_4474ec69","loading":"_5918d8af","header":"_468a6771","header--title":"_48353c35"};

/***/ }),
/* 4978 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_846b5381","outerContainer":"_527816bc","secondaryToolbar":"_4da2fe35","doorHangerRight":"_22690c37","toolbarContainer":"_2585d2b7","toolbarViewerMiddle":"_731b5beb","progressBar":"_3eb650a7","back-to-application":"_1a347dd6","root":"_0ad0bb4e","title":"_221cbe2e","staticMessage":"f80502ab","button":"bec4971e"};

/***/ }),
/* 4979 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_19410836","outerContainer":"_56b0afd3","secondaryToolbar":"_88554b70","doorHangerRight":"f167ccab","toolbarContainer":"_5a28d24b","toolbarViewerMiddle":"_681eba91","progressBar":"_147e6f4b","back-to-application":"_421c0258","root":"_6a27bc07","paymentTitleWrapper":"ca9a776d","paymentTitle":"_652cc57f","paymentEditButton":"_59167f28","paymentAmountInput":"_698b66ca","paymentButtonWrapper":"_1fa88ff2","paymentButton":"_4e6fb6b3","paymentButtonInDashboard":"_4b72a952","paymentInfo":"fb9fff67"};

/***/ }),
/* 4980 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c35b5ffb","outerContainer":"_4e34e1bc","secondaryToolbar":"f3b828c7","doorHangerRight":"_68b70e02","toolbarContainer":"_3bbfc037","toolbarViewerMiddle":"d60d62c6","progressBar":"cb800b3c","back-to-application":"_4be6ccab","description":"_53f42e78","organization":"_39800f4c","completed":"_77dc3236","section":"_5fa23711","invite":"_11ffb0ec","title":"_3cf13fdf","buttonWrapper":"b5a7d0e1","button":"_05216277"};

/***/ }),
/* 4981 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f4f2dd9d","outerContainer":"_123932ad","secondaryToolbar":"ccb73397","doorHangerRight":"_34a85fee","toolbarContainer":"_64a2e323","toolbarViewerMiddle":"_8d462fee","progressBar":"_14c05bde","back-to-application":"_884e59e2","root":"_66e2b9f4","left":"_110eda7f","right":"_1c832c0c","strong":"_86fdb868","meta":"_67dab3a9"};

/***/ }),
/* 4982 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"_46caa564","button":"_568b78e9"};

/***/ }),
/* 4983 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_06ac37ae","outerContainer":"f9bd1b50","secondaryToolbar":"b57fd0aa","doorHangerRight":"bef5efa6","toolbarContainer":"_1acaa91b","toolbarViewerMiddle":"_6745d5d1","progressBar":"_0f0c1299","back-to-application":"_841ef838","content":"_961e800d","section":"_87e45203","list":"bf9384b9","title":"_5ed9bfc6","width":"cb0df6c7","link":"_9bd5da00","actionButton":"e7530abf"};

/***/ }),
/* 4984 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1b5abcf4","outerContainer":"_1639a124","secondaryToolbar":"_412fa10a","doorHangerRight":"_4db1322d","toolbarContainer":"_43ff5d24","toolbarViewerMiddle":"_8f50666c","progressBar":"_398410e3","back-to-application":"_8aea4f06","video-btn":"_2d0d9f7b","primary":"fe9eb74b","disabled":"b92d269c","accent":"_788da6e1"};

/***/ }),
/* 4985 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_55b174ff","outerContainer":"_0876744a","secondaryToolbar":"be4383e1","doorHangerRight":"_6500579a","toolbarContainer":"_2f60b442","toolbarViewerMiddle":"_09e86d8c","progressBar":"c393db5a","back-to-application":"ef98ea01","wrapper":"_77172b84","menuList":"_91bb8944","listItem":"e7ea063d","title":"_7cd79a95","icon":"c88b4765","disableButton":"db39bb3a"};

/***/ }),
/* 4986 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"acceptButton":"_64eef5e0"};

/***/ }),
/* 4987 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_96f8a8d5","outerContainer":"_170f5392","secondaryToolbar":"_1ec971cb","doorHangerRight":"_809ec53d","toolbarContainer":"_56529214","toolbarViewerMiddle":"a1a03674","progressBar":"_65ea834c","back-to-application":"_315b133f","root":"b908a1a8"};

/***/ }),
/* 4988 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_85fa0e53","outerContainer":"_84c08cd1","secondaryToolbar":"cbf66995","doorHangerRight":"_82868ad4","toolbarContainer":"_406915c4","toolbarViewerMiddle":"c2f2ebab","progressBar":"_42613a4b","back-to-application":"_1132bd04","root":"_64252c74"};

/***/ }),
/* 4989 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_6511c27b","outerContainer":"_1aec88f2","secondaryToolbar":"a89f2d5d","doorHangerRight":"fb80e928","toolbarContainer":"b7d83980","toolbarViewerMiddle":"daf338be","progressBar":"_2c649baf","back-to-application":"f2c0bbf7","root":"aa492ad4","patientMessage":"_20755856","patientMessageLink":"_9a650955"};

/***/ }),
/* 4990 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_239a6cfe","outerContainer":"c0ec8037","secondaryToolbar":"b87b3cd9","doorHangerRight":"_69d6cb6c","toolbarContainer":"a8cf44ca","toolbarViewerMiddle":"a050a0fc","progressBar":"b86e8815","back-to-application":"_2093989c","root":"a377d95c","description":"_746e0c0a","buttonWrapper":"b39703b4","buttonAction":"_6f396d8b"};

/***/ }),
/* 4991 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"edf2b49a","outerContainer":"cf52bb24","secondaryToolbar":"_643a0147","doorHangerRight":"b31f0d12","toolbarContainer":"_3e54f8b8","toolbarViewerMiddle":"ed2a7d07","progressBar":"_5a9d9f7d","back-to-application":"_622545bf","root":"a092373d","viewAttachmentWrapper":"_960169b4","documentWrapper":"_7512ed10","icon":"_4a2eef26","addButtonTitle":"_5c502c09","addActionWrapper":"d639e33c","disabled":"fb0c269f"};

/***/ }),
/* 4992 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_30d8c2c8","outerContainer":"_194daff5","secondaryToolbar":"ff4c6b73","doorHangerRight":"_179bb043","toolbarContainer":"c7df8881","toolbarViewerMiddle":"c994f814","progressBar":"a66d9e5b","back-to-application":"cfad9f86","root":"_04d40ac7","viewAttachmentWrapper":"_11861319","documentWrapper":"_8eac03b1","fileInfoWrapper":"_215aac13","icon":"_5be4eecb","removeIcon":"a003f3b6","fileTitle":"_2888f4b7","fileCategory":"_7258291c","uploadFileTitle":"_2ada7784"};

/***/ }),
/* 4993 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"aaccfe92","outerContainer":"_0e35f26f","secondaryToolbar":"cfffeb5d","doorHangerRight":"_2883492c","toolbarContainer":"fe13cb05","toolbarViewerMiddle":"_73f99913","progressBar":"d581725b","back-to-application":"_6ff11dcd","root":"_66da94ed","visitDocumentsHeader":"_824991e6","visitDocumentsTitle":"_2cfec340","addActionWrapper":"aa8c285f"};

/***/ }),
/* 4994 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1fec9c93","outerContainer":"_696c0e01","secondaryToolbar":"a7c06c80","doorHangerRight":"_9f31cca6","toolbarContainer":"b32f44d9","toolbarViewerMiddle":"b6490ddd","progressBar":"d8ac4b4e","back-to-application":"d756cd73","empty":"_6483159a"};

/***/ }),
/* 4995 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_86b6fa7c","outerContainer":"_4e1f444d","secondaryToolbar":"_43c00cc3","doorHangerRight":"_5d10dbb6","toolbarContainer":"_0b7326c7","toolbarViewerMiddle":"d47fb61e","progressBar":"d3609604","back-to-application":"_6f6a65db","root":"f02ce30f","header":"_5317e43d","title":"fb30655b","text":"_2151fe2a","link":"_15d746c7","content":"dda6d4db","buttonsSection":"_929ceaba","mobileButtonsSection":"_31b00dd0","getCareButton":"cd838e95","mobileButton":"a3bf6216","mobileCustomButtons":"b031852e"};

/***/ }),
/* 4996 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7d08005e","outerContainer":"_8dc1efbd","secondaryToolbar":"_21bfeac3","doorHangerRight":"_5c753089","toolbarContainer":"_5384bba1","toolbarViewerMiddle":"_815bd9e2","progressBar":"_3810ef41","back-to-application":"_52057d88","menuButton":"_38d3e242","buttonContainer":"f18963c2","dropdownMenu":"b87fd86c","dropdownMenuFullWidth":"_81409af6","dropdownItem":"_3fef4408","listItems":"_85947984","mobileList":"_733c0c19","listButton":"_16ce8059","mobileButton":"_0d7c1d2f"};

/***/ }),
/* 4997 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"calendar":"_640f781b","calendarActive":"_13a87c4f"};

/***/ }),
/* 4998 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_9889e94b","outerContainer":"fd4b59b4","secondaryToolbar":"_80c1dc9a","doorHangerRight":"f9bbec03","toolbarContainer":"d0ffc928","toolbarViewerMiddle":"c036993d","progressBar":"_86a2ab63","back-to-application":"_6013ac9f","root":"_904904aa","content":"_4309ed26"};

/***/ }),
/* 4999 */,
/* 5000 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e2f89902","outerContainer":"f70ea821","secondaryToolbar":"_2f587f2f","doorHangerRight":"_5300ac20","toolbarContainer":"c4aa4651","toolbarViewerMiddle":"b5d7d6c2","progressBar":"_274b500a","back-to-application":"adfb4702","root":"c0f473a8"};

/***/ }),
/* 5001 */,
/* 5002 */,
/* 5003 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e9bc4d55","outerContainer":"f536a667","secondaryToolbar":"f0ef293d","doorHangerRight":"_321a47b8","toolbarContainer":"_519945c4","toolbarViewerMiddle":"_3aef9382","progressBar":"_07d49e20","back-to-application":"_5d9622d4","root":"_16498551","header":"_431b1f3b"};

/***/ }),
/* 5004 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"fab0f14e","outerContainer":"_2bc5521a","secondaryToolbar":"_7b3f113f","doorHangerRight":"b9ef0bd5","toolbarContainer":"e6fffd94","toolbarViewerMiddle":"ef452173","progressBar":"bd8dae98","back-to-application":"ba82aeb5","content":"_31619a31","close":"_0071ba5e","row":"_7f198e1d","item":"_54c469ea","title":"a38ea828","subtitle":"b7783303"};

/***/ }),
/* 5005 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d5621296","outerContainer":"_06be663e","secondaryToolbar":"_71a87c4d","doorHangerRight":"_51e09554","toolbarContainer":"_7adfeae4","toolbarViewerMiddle":"_5dc98cfc","progressBar":"_4d0091ab","back-to-application":"e7e71a93","title":"cd80608c","images":"f611a915","empty":"eabf6dd0"};

/***/ }),
/* 5006 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_5093b4e0","outerContainer":"_7b9d8713","secondaryToolbar":"c85028be","doorHangerRight":"_5b7ff28b","toolbarContainer":"e2af0122","toolbarViewerMiddle":"_2b313902","progressBar":"_36cc64c2","back-to-application":"_03d347c1","section":"_0c9494a8","primarySubscriberTitle":"_74bb30a5","additionalInsurancesTitle":"c592cf77","icon":"_70d71b00","divider":"_68fa7b6c","toggleBtn":"c0a74ff8","withoutAdditionalInsurances":"cb8681f8","title":"_2083179b"};

/***/ }),
/* 5007 */,
/* 5008 */,
/* 5009 */,
/* 5010 */,
/* 5011 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_3b839aee","outerContainer":"_7e55e513","secondaryToolbar":"_14fd5787","doorHangerRight":"_8b6ca804","toolbarContainer":"_65dffa0b","toolbarViewerMiddle":"_7e3eeb6d","progressBar":"_40b39d7d","back-to-application":"_08fc13b2","item--minimized":"f99847ca","item--active":"_844368b8","avatar__wrapper":"_1ea53b7b","badge__wrapper":"dcaf3128","card":"_2ac57c0a","card--active":"_037dc3df"};

/***/ }),
/* 5012 */,
/* 5013 */,
/* 5014 */,
/* 5015 */,
/* 5016 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_3c5e57e3","outerContainer":"_3c1ef264","secondaryToolbar":"_359196a9","doorHangerRight":"_21886d87","toolbarContainer":"_3581fb54","toolbarViewerMiddle":"_98cba5e5","progressBar":"_607fe905","back-to-application":"_0840ea82","wrapper":"_9490746b","resend":"_63258f37"};

/***/ }),
/* 5017 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7b875d6f","outerContainer":"ab79bbbc","secondaryToolbar":"_4fee0440","doorHangerRight":"cf1ddedb","toolbarContainer":"_4d26c224","toolbarViewerMiddle":"ba8e3827","progressBar":"adc5410a","back-to-application":"_21605035","modalWrapper":"cc81d6ee","title":"_79dae50f","contentText":"e52e154c","label":"_8cdd3fb7","errorBlock":"_7c37060c","marginZero":"_073b1a9b","actions":"_2bd6ceb6","submitButton":"_7a85bdae"};

/***/ }),
/* 5018 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bff71326","outerContainer":"ba11f466","secondaryToolbar":"_89ed1352","doorHangerRight":"b5da688d","toolbarContainer":"e19175b0","toolbarViewerMiddle":"_33e8c0e1","progressBar":"_1d9396d5","back-to-application":"_3d78e068","iconWrapper":"d1ad3bd4","title":"_9ec2e69e","contentText":"_074cdbcc","actions":"f3e83d19","button":"a43732c6"};

/***/ }),
/* 5019 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"fdb59905"};

/***/ }),
/* 5020 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0a80d293","outerContainer":"_94bf7b89","secondaryToolbar":"ac550739","doorHangerRight":"_9119aecf","toolbarContainer":"_86b576cc","toolbarViewerMiddle":"_67033daf","progressBar":"_333ed74f","back-to-application":"d0f6eb7a","root":"_1dbd12a1","wrapper":"_0f0f72d7","label":"_0ae12af0","select":"_5204c281","input":"_8f9523f6"};

/***/ }),
/* 5021 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_9d7b1418","outerContainer":"_2bf7ef4b","secondaryToolbar":"f03914be","doorHangerRight":"c8885158","toolbarContainer":"b123e600","toolbarViewerMiddle":"_5abf2db1","progressBar":"_1dcba7de","back-to-application":"_49ca8eed","modalWrapper":"_107abe40","loader":"_00ada363","title":"_9794b9d7","contentText":"cb43fe2a","textField":"_81d36b36","errorBlock":"b2f0452a","getPasscodeBtn":"_4a05f381","cancelBtn":"_8e47151e"};

/***/ }),
/* 5022 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"eec1b9dd","outerContainer":"bdbd31d8","secondaryToolbar":"b6be20c4","doorHangerRight":"c445d97a","toolbarContainer":"_8c53d4ec","toolbarViewerMiddle":"_3889321d","progressBar":"_1999c24e","back-to-application":"fb1241e8","root":"a5effd67","root--visible":"_8b635dd8"};

/***/ }),
/* 5023 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7cf8c15e","outerContainer":"_0d163155","secondaryToolbar":"f64eb6ce","doorHangerRight":"_6bedd3e8","toolbarContainer":"_1daee7fb","toolbarViewerMiddle":"_6d6feba7","progressBar":"_6ccb7e7b","back-to-application":"_55be25f8","root":"d75fa3d8","root--gray":"b1bac72d","root--unstyled":"c1d752bd","root--transparent":"dc0a9a32","root--column":"e748adac","root--overflow-visible":"_92515990"};

/***/ }),
/* 5024 */,
/* 5025 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a4247245","outerContainer":"_9cd9a809","secondaryToolbar":"b00c45d3","doorHangerRight":"_6db73a75","toolbarContainer":"_6af0ed46","toolbarViewerMiddle":"_50b80d48","progressBar":"c75b2ea3","back-to-application":"_6be30f96","section":"dc49dd82","content":"_14fafa1f","message":"e42d251b"};

/***/ }),
/* 5026 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_5580c550","outerContainer":"e37b2767","secondaryToolbar":"c33ee131","doorHangerRight":"_97dd5093","toolbarContainer":"a683f04f","toolbarViewerMiddle":"_94a585da","progressBar":"_250f5d51","back-to-application":"a33665e8","section":"bd5dcf52","content":"_4c69c87e","title":"d76b2e72"};

/***/ }),
/* 5027 */,
/* 5028 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_035821a6","outerContainer":"abdd34ec","secondaryToolbar":"_5adcf4e9","doorHangerRight":"_93193d86","toolbarContainer":"_66d1e5d9","toolbarViewerMiddle":"_4f47f1ed","progressBar":"b8b46c69","back-to-application":"b6fec554","entries":"_91536de6","entryTitle":"_45d49a6c","entryValue":"_54a92c6a"};

/***/ }),
/* 5029 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"eeeb60c1","outerContainer":"_1fd95a12","secondaryToolbar":"d4e6cb5e","doorHangerRight":"_05486b7b","toolbarContainer":"cc85da16","toolbarViewerMiddle":"_78acd660","progressBar":"_9e0669dd","back-to-application":"_80e6612d","form":"_054a2b03","root":"_9950f9c4","title":"_3858a8db","text":"d02aeb8d","button":"_8c25c6b7","inputWrapper":"_91d35997","termsAndPoliciesWrapper":"_4c421c3a","termsAndPolicies":"_5986a594","error":"_83ae2581"};

/***/ }),
/* 5030 */,
/* 5031 */,
/* 5032 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d491fe24","outerContainer":"b2035fc7","secondaryToolbar":"d85eadeb","doorHangerRight":"a22f851a","toolbarContainer":"_5adad432","toolbarViewerMiddle":"_5c1a993c","progressBar":"_9e629e10","back-to-application":"c80e47a7","header":"_310e1da8","backgroundImage":"ffbdce0f","link":"_963e29af","root":"_42657f4e","loader":"_776b599d","progress":"fff3ea48","content":"afab0917","freeze":"_77d34453","visitTitle":"_0b81df4c","icon":"_54e0b293"};

/***/ }),
/* 5033 */,
/* 5034 */,
/* 5035 */,
/* 5036 */,
/* 5037 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_56c954d4","outerContainer":"_8c7cb96e","secondaryToolbar":"c1a4967f","doorHangerRight":"_25dbfd2f","toolbarContainer":"e4f63a79","toolbarViewerMiddle":"bdb9bb4e","progressBar":"_056b7740","back-to-application":"_98b99ec4","root":"_71c52200"};

/***/ }),
/* 5038 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_383e5ff4","outerContainer":"eb80e2ce","secondaryToolbar":"_7442c382","doorHangerRight":"_6ec02b0d","toolbarContainer":"_52c5a763","toolbarViewerMiddle":"e12b561a","progressBar":"_4814be7b","back-to-application":"_2fc1b86f","root":"_4fcc251d","item":"_085ca541","activeItem":"_1554bdec"};

/***/ }),
/* 5039 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"fc9e2d15","outerContainer":"aeacf403","secondaryToolbar":"bb483ca9","doorHangerRight":"_6d6a14d0","toolbarContainer":"_3a4aafae","toolbarViewerMiddle":"e359d1b0","progressBar":"dc400124","back-to-application":"_4a9f9e74","root":"d604d6b5","itemWrapper":"e876f237","activeItem":"_670fa079","itemTitle":"b95f6265","itemDisableTitle":"b819288a","itemTitleActive":"_42cc2909","itemColor":"_20944c12","disabled":"_82419178","icon":"_9b00765e","activeItemNoAction":"_67c7d758"};

/***/ }),
/* 5040 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ded4d222","outerContainer":"ccc3525b","secondaryToolbar":"f1d97ffd","doorHangerRight":"be0ac8fb","toolbarContainer":"_15ff3572","toolbarViewerMiddle":"d5cf961c","progressBar":"_72d38ea4","back-to-application":"da949962","root":"_1e3fb8f2","singleMonthRoot":"_217fd7ad","valueWrapper":"_0d36a5d0","metric":"_7065e185","value":"a2b90ca0","rightSideWrapper":"a217e05c","date":"cb3ce360","dataSourceTitle":"_399a8fb1","dataHistoricList":"a8fc5d25"};

/***/ }),
/* 5041 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b031726c","outerContainer":"_43901271","secondaryToolbar":"_51d46d06","doorHangerRight":"_0d956602","toolbarContainer":"f27fba6a","toolbarViewerMiddle":"_20f37ab1","progressBar":"a60a7b16","back-to-application":"eb3c1aa0","root":"_23fd2313","singleDayPadding":"a6b1f78b","grafWrapperPadding":"ff483a23","header":"e76e5db4","averageValueWrapper":"d1650d89","averageValue":"_2a186746","averageMetric":"cfea8bcf","averageDate":"_41d455de","grafWrapper":"aa581101","rightSideWrapper":"fabd532a","emptyStateWrapper":"_13978c35","emptyStateDescription":"fc784f67","singleDayRoot":"e9adbc5a","valueWrapper":"_445db539","date":"_7c83d845","dataSourceTitle":"ad06e891","metric":"_87769129","value":"_484c3fe7"};

/***/ }),
/* 5042 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_89311a53","outerContainer":"_567dac82","secondaryToolbar":"_58d75662","doorHangerRight":"caca3f56","toolbarContainer":"c3c0393d","toolbarViewerMiddle":"d2e37c00","progressBar":"_901f4e74","back-to-application":"_9b237c5b","root":"f4495179","rootWrapperForOneDay":"_4466e000","title":"_8df0de1d","cardWrapper":"ed8b7f49","heightDataCard":"bd299e9a","cardForOneDay":"e408e6b2","valueWrapper":"_14822e6c","date":"a858ffae","metric":"f7bad35b","value":"_73a6a47c","loadMore":"a27e5656","disableLoadMore":"_0204dc1b","dataDescription":"_8478b19f","rightSideWrapper":"_78c11f27","dataSource":"_4ddde8e8"};

/***/ }),
/* 5043 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a3f7045f","outerContainer":"_99740b40","secondaryToolbar":"_2199fd18","doorHangerRight":"_761e3efe","toolbarContainer":"_2a2d7bc7","toolbarViewerMiddle":"b43891ce","progressBar":"_50208613","back-to-application":"_5fbbaa56","root":"_6d339425","emptyStateDescription":"_99ce6ded","emptyStateDescriptionAccount":"_0c86cb0f","addDataButton":"c1e0fe62","capitalize":"c4dce09c"};

/***/ }),
/* 5044 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_2c3e10ab","outerContainer":"_9285242b","secondaryToolbar":"_3c773e0b","doorHangerRight":"a15a6716","toolbarContainer":"_7376eb7e","toolbarViewerMiddle":"c6137d79","progressBar":"e5e48ca0","back-to-application":"_366f059b","root":"_876f0925","panel":"_5558c7a1","panelPrimary":"d54d14ae","panelContainer":"_51af7b50","panelSecondary":"_76016d53","tabWrapper":"_987e2b9d","tab":"_82046f15","tabIcon":"_9d56c558","tabActive":"_96f097b3"};

/***/ }),
/* 5045 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7852ba31","outerContainer":"_2f0c4afd","secondaryToolbar":"_56b2f2de","doorHangerRight":"_069b6189","toolbarContainer":"b9e58388","toolbarViewerMiddle":"_332e021e","progressBar":"_3aa2c4ba","back-to-application":"d0cfc788","root":"_495f1c8c","leftSideWrapper":"c365deb7","avatar":"_13c3425d","description":"_6756b474","date":"_65445967","actionButton":"_08a55dc0"};

/***/ }),
/* 5046 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"file":"_7477952b","filename":"_55bb99f9","card":"d6e46b14","meta":"bb499e3b","content":"_81557cca"};

/***/ }),
/* 5047 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_9cb13c87","outerContainer":"_633c09c4","secondaryToolbar":"_91d75c3d","doorHangerRight":"_80b84d6d","toolbarContainer":"_7ad9807b","toolbarViewerMiddle":"_8eabda9e","progressBar":"_07a965ab","back-to-application":"_1450a88b","root":"_2f7ef285","leftSideWrapper":"c0b0694b","contentCard":"da9e3e68","title":"_6e29c1c6","date":"db4443e8","rightSideWrapper":"fdea140d","iconDownload":"b20992f8","iconView":"_108f25a1","titleWrapper":"c1c3d2da","privacyIcon":"_75697b18"};

/***/ }),
/* 5048 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"c84addea","arrowRight":"d878b3cf"};

/***/ }),
/* 5049 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_67952280","outerContainer":"_2df0f760","secondaryToolbar":"c895823a","doorHangerRight":"a7a17383","toolbarContainer":"d47044f6","toolbarViewerMiddle":"bb49b5fc","progressBar":"_55da2f37","back-to-application":"_820a1f65","root":"_8af859a4","markerValue":"_2a98b44a","markerLine":"d8ab2a93"};

/***/ }),
/* 5050 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_8f80b68e","outerContainer":"_4a1b7fc0","secondaryToolbar":"_08e545f9","doorHangerRight":"_58e74f0f","toolbarContainer":"_35a93258","toolbarViewerMiddle":"cfcb5237","progressBar":"_908bf43b","back-to-application":"a2d51624","root":"_649a6fc5","scale":"ed3ab4dc","rangeEndPointContainer":"_997786fd","rangeEndPointTextContainer":"c125e68b","rangeEndPointText":"_6d635064","pointContainer":"_6a44d380","bottom":"e942a357","top":"fdb810d9","subscriptionContainer":"bea86fde"};

/***/ }),
/* 5051 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c6d0c11d","outerContainer":"_21dcc595","secondaryToolbar":"_97ce8eb5","doorHangerRight":"e5ba6288","toolbarContainer":"_4acc8a42","toolbarViewerMiddle":"_8df35bd4","progressBar":"_4daef37d","back-to-application":"_734272f4","root":"_57ea0cc1","header":"bd99860d","leftSideWrapper":"_1a9942d5","iconType":"e524d4e2","contentWrapper":"_757cb68a","title":"_0e0f7330","description":"_698c4d3e","rightBlock":"_2d69fc7d","date":"a6533b09","icon":"_30f8899a","activeDrugRoot":"_18461333","activeContent":"c0c57488","drugName":"be5ef78b","privacyIcon":"_94a51890"};

/***/ }),
/* 5052 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_6f07a8b5","outerContainer":"_3f061dc5","secondaryToolbar":"_0aa698b0","doorHangerRight":"d58a7b15","toolbarContainer":"b093c89d","toolbarViewerMiddle":"_72d0a265","progressBar":"_215e25a9","back-to-application":"c8d991b9","root":"b24eb86e","header":"e85c52c3","leftSideWrapper":"_1af8c25a","avatar":"a9151c4e","title":"_0e3301c6","date":"d94b2a65","contentWrapper":"_99ef012c","memberCard":"b00d14c8","role":"_4d11b424","description":"_31ca488a"};

/***/ }),
/* 5053 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_87132074","outerContainer":"e5ef0dc1","secondaryToolbar":"_990235d7","doorHangerRight":"bd5dbfee","toolbarContainer":"f7fbfdd5","toolbarViewerMiddle":"bc5583eb","progressBar":"fc875436","back-to-application":"_560cf604","root":"_3425eafc","title":"bea2ba2e","searchWrapper":"_9394a35f","searchBox":"bc2933d0","date":"_4cb819b3","searchButton":"_8851cdc4","clearDate":"_6c9b754a","wrapperCalendar":"_02336f4c"};

/***/ }),
/* 5054 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c24266d2","outerContainer":"_2e7fb93a","secondaryToolbar":"_936d335e","doorHangerRight":"fa8d68bb","toolbarContainer":"_15040e13","toolbarViewerMiddle":"aef05698","progressBar":"_1c0b1444","back-to-application":"bec7da0d","medicationListWrapper":"ab537628","showDiscontinued":"_7bad36e1","buttonStyles":"acb6a25b","fullWidth":"_60c6b2c5","paginationRoot":"d02b1ef1"};

/***/ }),
/* 5055 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1d20da4b","outerContainer":"_31427ee1","secondaryToolbar":"e21e2260","doorHangerRight":"_4436bd84","toolbarContainer":"_4fa43253","toolbarViewerMiddle":"_77236aef","progressBar":"bafb11c3","back-to-application":"_78e706d9","root":"c4db3207","chatRoot":"_3f2cd0d9","avatar":"_73825302","title":"d0a7cfe4","content":"b65ba3af"};

/***/ }),
/* 5056 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bf73561e","outerContainer":"d6efe3ee","secondaryToolbar":"_67379ce7","doorHangerRight":"e168d56b","toolbarContainer":"_17335ae3","toolbarViewerMiddle":"ee432648","progressBar":"_28fa4a45","back-to-application":"_1e9a9328","root":"a0e83130","description":"d43cabc7","inputEmail":"_28cf8f4c","errorBlock":"ae5167a9","actionButtonWrapper":"_731d3ba1","actionButton":"_170cee2b","confirmationView":"_5e73c129","confirmationContentWrapper":"_564614b3","confirmationContent":"a6d3a925","confirmationButtonWrapper":"fe068a60"};

/***/ }),
/* 5057 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_3f8edbc4","outerContainer":"aa28e363","secondaryToolbar":"_9dccc5b5","doorHangerRight":"_1dca1dc5","toolbarContainer":"_3dd14c6f","toolbarViewerMiddle":"_9621fb81","progressBar":"e303674b","back-to-application":"_6bc82b25","canvas":"_3995c3f0","info":"_29d3a85c","empty":"_52a5d015","description":"_8a9b9b7a"};

/***/ }),
/* 5058 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"ba5852a3"};

/***/ }),
/* 5059 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a73856da","outerContainer":"f9fbe7e0","secondaryToolbar":"_1119a0f7","doorHangerRight":"_4c8cc88f","toolbarContainer":"f362909c","toolbarViewerMiddle":"_2c64f1e4","progressBar":"_04abe9b5","back-to-application":"_7edda404","wrapper":"cced3bfb","left":"d24484c9","right":"_19c8b0fa","rightTop":"_148f60d3","rightBottom":"dcb6ae02"};

/***/ }),
/* 5060 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_57ffe40b","outerContainer":"d96689bd","secondaryToolbar":"d056de99","doorHangerRight":"_6bfaa98c","toolbarContainer":"_6f2ad3f4","toolbarViewerMiddle":"_2ec0c56a","progressBar":"_65491335","back-to-application":"_8c3d8905","wrapper":"c4d5a79a","unit":"f56dfa20","textWrapper":"f400322a"};

/***/ }),
/* 5061 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_8719dd88","outerContainer":"_495a9640","secondaryToolbar":"efac136e","doorHangerRight":"fe9506fc","toolbarContainer":"_7c743c5c","toolbarViewerMiddle":"e50d8656","progressBar":"_7cba0d6b","back-to-application":"_22502297","wrapper":"_09a9d39b","item":"_824eda14","redText":"bdd713e5","left":"_22cb2785","right":"_661b6f50"};

/***/ }),
/* 5062 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bb7c43d8","outerContainer":"_1e521e85","secondaryToolbar":"dd506dfa","doorHangerRight":"_44cd141b","toolbarContainer":"_1048c00e","toolbarViewerMiddle":"_602af2fe","progressBar":"cfffd645","back-to-application":"df969417","wrapper":"_8b5e5940","selector":"f3110f4b","selectorWrapper":"b70d0c8c","selectorLabel":"_9f742fcc","ranger":"e5e0e7ff"};

/***/ }),
/* 5063 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_10ca0602","outerContainer":"bacd8626","secondaryToolbar":"c68b4699","doorHangerRight":"a61e0c39","toolbarContainer":"_27bd6766","toolbarViewerMiddle":"_7253b36e","progressBar":"_9732446c","back-to-application":"_1099d9da","wrapper":"_696d3e44"};

/***/ }),
/* 5064 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ebd952c9","outerContainer":"_7287502c","secondaryToolbar":"_71e94014","doorHangerRight":"_691b4da4","toolbarContainer":"b27eac85","toolbarViewerMiddle":"_7e576827","progressBar":"_835cc229","back-to-application":"_37460465","root":"_4b5830c0","locationWrapper":"_0abf6e9c","location":"_77ef58be","button":"_8e029799","address":"_511045d3","unavailablePharmacy":"_0800082f"};

/***/ }),
/* 5065 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_18353320","outerContainer":"_0a76596a","secondaryToolbar":"_7b9bece5","doorHangerRight":"_3d544156","toolbarContainer":"_0dbb719c","toolbarViewerMiddle":"_53652f98","progressBar":"_4b32c3f4","back-to-application":"_6174d462","root":"c78e15e1","backBtn":"ae577627","header":"_3da4af24","headerTitle":"dbcc8898","refillList":"_30e73d3a","requestContainer":"_34a13d07","medicationContainer":"_9c100ee5","medication":"_7e053000","medicationName":"_51eca81b","title":"dc870b01","medicationWrapper":"_9ff6b280","list":"_62a91d78","confirmButton":"_29d6ff28","emptyStateRoot":"_00c0f16b","noDataMessage":"_345de4c3","opacity":"_10e11317","requestLoader":"_70c88678","maskHeader":"c6e83438"};

/***/ }),
/* 5066 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"df710841","outerContainer":"_4e4bbe66","secondaryToolbar":"_8fc4622f","doorHangerRight":"df963634","toolbarContainer":"_83551528","toolbarViewerMiddle":"_14cfccd6","progressBar":"_16a0afc2","back-to-application":"_4764aa14","root":"_048de029","boxShadow":"_7df534ee","content":"_34f0cd70"};

/***/ }),
/* 5067 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4203c1f8","outerContainer":"_7bcb2da1","secondaryToolbar":"_1194ced8","doorHangerRight":"_079d7ac3","toolbarContainer":"_721e8b30","toolbarViewerMiddle":"_7d5d3c06","progressBar":"a0259d70","back-to-application":"_7c9dbfb8","root":"cf8b7a50"};

/***/ }),
/* 5068 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a5796b14","outerContainer":"c7733882","secondaryToolbar":"df11b9bf","doorHangerRight":"_9cca5742","toolbarContainer":"_725dd925","toolbarViewerMiddle":"f9839119","progressBar":"_7448975c","back-to-application":"a26ea301","title":"_4cc5bf8e","selectWrapper":"b08f37c4","select":"d1f0543e","counter":"_46727d16"};

/***/ }),
/* 5069 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_476b130c","outerContainer":"_131b9fba","secondaryToolbar":"_804de7b2","doorHangerRight":"_070e787a","toolbarContainer":"_8ee2086f","toolbarViewerMiddle":"_192cd4b7","progressBar":"_44f44e37","back-to-application":"_8691cf82","root":"_7ff276c0"};

/***/ }),
/* 5070 */,
/* 5071 */,
/* 5072 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a58de937","outerContainer":"_842ca82c","secondaryToolbar":"a0df652a","doorHangerRight":"fad6fd83","toolbarContainer":"_61f758c7","toolbarViewerMiddle":"_8c292105","progressBar":"_14641dd1","back-to-application":"b27a0037","deleteAccount":"_94f58ef1","modalWrapper":"_9e2b6f52","modalTitle":"_2fc7061e","description":"_23340b56","field":"_5eb342d5","title":"fa687d8f","content":"_2eed760c"};

/***/ }),
/* 5073 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a8b68604","outerContainer":"_434bcf79","secondaryToolbar":"_7f1b3eae","doorHangerRight":"fa5e7a0f","toolbarContainer":"_1e8b3f7d","toolbarViewerMiddle":"_9d789f03","progressBar":"e214d658","back-to-application":"_9e0bf4dc","root":"_148ec9e1","headerWrapper":"ad9b43a3","nameAccount":"f956d260","removeAccount":"fdf9e9af","content":"_9e5a8dfc","noDevices":"_51520c22","noPermission":"_42fc2e64","iconNoPermission":"_0350c029","noPermissionDescription":"_816caf4d","noPermissionAnnotation":"_28c769ad","googleFitWrapper":"_2e8cb090","email":"_24f9ef94","syncedDate":"_182c7b8e"};

/***/ }),
/* 5074 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_2b993769","outerContainer":"ce6ee004","secondaryToolbar":"efe600a0","doorHangerRight":"a727237c","toolbarContainer":"_0b09708f","toolbarViewerMiddle":"bf33f9d9","progressBar":"ead055da","back-to-application":"_7775ba08","root":"_7fcb5c09","header":"d6c06916","content":"a1e090da","iconInfo":"cb686989","description":"e00b7068"};

/***/ }),
/* 5075 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0209c626","outerContainer":"_8c2f2ec5","secondaryToolbar":"_86d504fa","doorHangerRight":"dd3a073c","toolbarContainer":"_0664e03e","toolbarViewerMiddle":"efe84d41","progressBar":"_4f8c8845","back-to-application":"e52f3cfb","root":"_40ba5b15","title":"f6ef8d0e","capitalize":"_9e277435","syncedDate":"_158721fd"};

/***/ }),
/* 5076 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c08eccb8","outerContainer":"_9665cc52","secondaryToolbar":"_9a08a64e","doorHangerRight":"aeb6f1e8","toolbarContainer":"_27666134","toolbarViewerMiddle":"f8d669c3","progressBar":"_7a09bc64","back-to-application":"_12902ade","root":"_7730bd53","sectionTitle":"efe79922","addDeviceBtn":"_818000af","noAccount":"be6bbd40","noAccountDescription":"_875ba7bb","removeConfirmationTitle":"dc1b7e9e"};

/***/ }),
/* 5077 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b5fe63ae","outerContainer":"b73840c4","secondaryToolbar":"ba2a2ad8","doorHangerRight":"_50c7323e","toolbarContainer":"e1c8e6e2","toolbarViewerMiddle":"aa527812","progressBar":"b8ac9804","back-to-application":"_0e2eea06","root":"c5782736","titleWrapper":"a0895514","title":"_088bcca2","editButton":"_097f04c1","fieldsetContent":"_16fe3aff","withColumns":"eb7cfe03","fieldWrapper":"d0468cf2","fieldsetContent__empty":"_3af66f55","titleEntity":"_46d7a4c6","contentEntity":"_1e0aa3f4"};

/***/ }),
/* 5078 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_778904d7","outerContainer":"_553416f8","secondaryToolbar":"_8bebe8c6","doorHangerRight":"d3dca6d2","toolbarContainer":"_1b6ab0ab","toolbarViewerMiddle":"_115c1c1d","progressBar":"d0912933","back-to-application":"ad950f54","root":"_10dad30e","titleWrapper":"_7bc94070","title":"e1b95c7d","editButton":"_07e67035","fieldsetContent":"_3fe482bf","withColumns":"_3932e00e","fieldWrapper":"_6b2b295f","fieldsetContent__empty":"_33dacbea","titleEntity":"_3be868cf","contentEntity":"_23f97e29"};

/***/ }),
/* 5079 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e9a289c9","outerContainer":"_52b923d1","secondaryToolbar":"_6c5c6f37","doorHangerRight":"f9e57ec4","toolbarContainer":"_71c60637","toolbarViewerMiddle":"_0159a444","progressBar":"_09d07608","back-to-application":"ea275edb","root":"afd1bda5","title":"_95be4d77","message":"_70c03288","error":"bcf011eb","button":"_47f53963","textCenter":"_06072cdc","actionButtonWrapper":"_6948695b"};

/***/ }),
/* 5080 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_8a8c257a","outerContainer":"a3b87854","secondaryToolbar":"_7cbb5f61","doorHangerRight":"_0c78fdc1","toolbarContainer":"_8d2f42a3","toolbarViewerMiddle":"_9bf3eac0","progressBar":"_86e25c24","back-to-application":"_86af72a1","section":"_12c7d1fb","healthPlanSelect":"e7392dee"};

/***/ }),
/* 5081 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c6940059","outerContainer":"_30747873","secondaryToolbar":"_8326cdad","doorHangerRight":"_4fc2c6fd","toolbarContainer":"_0628b04b","toolbarViewerMiddle":"be777077","progressBar":"b43d0e4c","back-to-application":"adae8143","section":"_970412d6","selectField":"_85db7534","error":"_4fe865a9","datePickerIcon":"_87dacce7"};

/***/ }),
/* 5082 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_56356346","outerContainer":"fb31e3a5","secondaryToolbar":"_9bc56d5a","doorHangerRight":"e45181c0","toolbarContainer":"_1ca3336c","toolbarViewerMiddle":"_17e06d80","progressBar":"a491a7e5","back-to-application":"f1a41fd4","root":"_6aca0cb2","title":"_27a6605a","message":"_59dd1191"};

/***/ }),
/* 5083 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d99b26aa","outerContainer":"_5160e417","secondaryToolbar":"c9ba9df2","doorHangerRight":"_87818091","toolbarContainer":"bf844f4b","toolbarViewerMiddle":"_8f028c54","progressBar":"_7bc1c715","back-to-application":"df09b0a3","root":"_3e3911c1","titleWrapper":"_7ff32671","title":"bf0d24fb","editButton":"a8e19867","profileDocWrapper":"_237cf59d","emptyInsurance":"d9933afa"};

/***/ }),
/* 5084 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_39f4ea3a","outerContainer":"b183a8cd","secondaryToolbar":"e124eee4","doorHangerRight":"cc71f53d","toolbarContainer":"ccf69703","toolbarViewerMiddle":"a8793654","progressBar":"fd0dc560","back-to-application":"_455fd81c","wrapper":"e11a4adb","textarea":"_1a0734a7","button":"c1817734"};

/***/ }),
/* 5085 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c50d8a5e","outerContainer":"_7e285340","secondaryToolbar":"_52abddf9","doorHangerRight":"_6c40bdf6","toolbarContainer":"f157f795","toolbarViewerMiddle":"a33775b5","progressBar":"_73d81050","back-to-application":"_63bd6544","wrapper":"d26880cb","documentWrapper":"_16bc3ec9","icon":"_4f602c37","image":"f88366e5","removeIcon":"_8f59c816","fileTitle":"e32d0a6e","fileCategory":"_6a2cb470"};

/***/ }),
/* 5086 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"fe5d7024","outerContainer":"_80a890db","secondaryToolbar":"_9e9bac7b","doorHangerRight":"ac3d6139","toolbarContainer":"_33006308","toolbarViewerMiddle":"_078c7f97","progressBar":"_696b6609","back-to-application":"_1ba6de44","wrapper":"d50508b6","sectionTitle":"_89594383"};

/***/ }),
/* 5087 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_45b9bbc3","outerContainer":"_7ca2edeb","secondaryToolbar":"be23767c","doorHangerRight":"_84615531","toolbarContainer":"_6add41d1","toolbarViewerMiddle":"_1460457f","progressBar":"_336f9f49","back-to-application":"_8757a1cf","wrapper":"_035d57bc","sectionTitle":"_21ddf360","content":"_33fe1f30","organizationName":"_83590560"};

/***/ }),
/* 5088 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_8dbe26e1","outerContainer":"_08a2948e","secondaryToolbar":"_53c263b7","doorHangerRight":"e54331c0","toolbarContainer":"_1c8a0408","toolbarViewerMiddle":"f17cfb6b","progressBar":"_51978009","back-to-application":"_87eb9246","wrapper":"_10c80a9c","content":"_772bed69","sectionTitle":"_301dd0a3"};

/***/ }),
/* 5089 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ddd096d0","outerContainer":"_19383066","secondaryToolbar":"_13c85f78","doorHangerRight":"ebd67a37","toolbarContainer":"_333d396c","toolbarViewerMiddle":"_6d0e3e67","progressBar":"_13a8eb67","back-to-application":"_80453320","consentItem":"_664cf8be","consentInfoWrapper":"_56c3e44c","icon":"_6b676d86","consentTitle":"_90901ef4","consentSubtitleRow":"_732b6128","consentSubTitle":"d5264715"};

/***/ }),
/* 5090 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"consentsWrapper":"d4c6ed5b","column":"_274d2190"};

/***/ }),
/* 5091 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_68fdd489","icon":"_2f7db928","title":"_7ea51d8f"};

/***/ }),
/* 5092 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_016f95c1","outerContainer":"d8cfa951","secondaryToolbar":"_668a1724","doorHangerRight":"a23f0272","toolbarContainer":"_2696f894","toolbarViewerMiddle":"aa5358b5","progressBar":"a961bbd3","back-to-application":"f65bd681","container":"_57345323","title":"d14ebfbf"};

/***/ }),
/* 5093 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f9ff8580","outerContainer":"b381e9ff","secondaryToolbar":"_84ea74ff","doorHangerRight":"_5745ab14","toolbarContainer":"_70658242","toolbarViewerMiddle":"_29dd7dcf","progressBar":"ea4fc4c2","back-to-application":"_97810f3c","content":"ea69cb9a","description":"b561803c","buttonWrapper":"_6ded15a4","button":"ccb1ee4b","warning":"_3147353d"};

/***/ }),
/* 5094 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_9e0219d5","outerContainer":"c2e459e5","secondaryToolbar":"_11f085a2","doorHangerRight":"_5e3ce0f3","toolbarContainer":"_1317b435","toolbarViewerMiddle":"a4c591f4","progressBar":"c54247ae","back-to-application":"be513938","infoIcon":"_3fb6eb4b","hintText":"_028c0759"};

/***/ }),
/* 5095 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_809f696c","outerContainer":"_6c0e8600","secondaryToolbar":"c4e325ac","doorHangerRight":"f072ffc0","toolbarContainer":"_51a8cd3e","toolbarViewerMiddle":"a046c8be","progressBar":"_22960117","back-to-application":"_4537cec8","container":"_65818733","containerError":"_6ddcba65","row":"a0f1a3a9","cardNumber":"_1f624ffb","icon":"_26b4af50","popperCard":"_7bd88188","expDate":"c024d4de","expDateExpired":"_0f77c421","accountType":"e0593505","expired":"_3fbba6d1","unknownAccountType":"ea702104","menuItem":"_874d6b1d"};

/***/ }),
/* 5096 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4f46acb9","outerContainer":"b1b8ce7c","secondaryToolbar":"cf2aca58","doorHangerRight":"_64939cc1","toolbarContainer":"_8d7dd790","toolbarViewerMiddle":"_1488091f","progressBar":"f1726fd9","back-to-application":"a070646b","buttonWrapper":"be43f00d","button":"_8ecf4935"};

/***/ }),
/* 5097 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e50a3875","outerContainer":"b436a56a","secondaryToolbar":"_0ae4e78a","doorHangerRight":"_187d90a5","toolbarContainer":"_6dc40704","toolbarViewerMiddle":"b2d2ad75","progressBar":"_2aafa67e","back-to-application":"e6f9ce60","content":"_38892b70","info":"_3288c36b","infoText":"_45ce1aae","locations":"_60163684","location":"_04130da9","infoWithBoxShadow":"_2a5752d7","footer":"_5df28f65","footerWithTopBorder":"e96561d8","button":"_96f80af8"};

/***/ }),
/* 5098 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f1c36cf0","outerContainer":"_5faa3d42","secondaryToolbar":"_8515ea63","doorHangerRight":"_605249f1","toolbarContainer":"_7c6eeb86","toolbarViewerMiddle":"_53d935bf","progressBar":"_16efe7ba","back-to-application":"_294c03d2","content":"_3956dfb3","info":"_68ed0aec","message":"_9b37d104","footer":"a64f1737","button":"ce207370"};

/***/ }),
/* 5099 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e739dc09","outerContainer":"_8da3d693","secondaryToolbar":"af246d4a","doorHangerRight":"_7ec71b59","toolbarContainer":"_54ec38c9","toolbarViewerMiddle":"_8e10b200","progressBar":"e76d16a8","back-to-application":"e51b9687","container":"_33e03414","section":"_5382a145","cards":"_0fc0471c","header":"_12c1ce9a","title":"d2b7fc21"};

/***/ }),
/* 5100 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_65857740","outerContainer":"_652e2dd3","secondaryToolbar":"f3e4a72f","doorHangerRight":"_4b447345","toolbarContainer":"_30aaae54","toolbarViewerMiddle":"_0bc80cb7","progressBar":"d67dea04","back-to-application":"_1cbe134e","container":"_43fa00a6","content":"_0fadc26c","header":"_4606ba42","title":"_6aca34ca","description":"_8c3a01a2","containerWithoutOrganizations":"d44f20f2"};

/***/ }),
/* 5101 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_064c46f2","outerContainer":"_3a718886","secondaryToolbar":"_313b908d","doorHangerRight":"_15e2103b","toolbarContainer":"_1eb10320","toolbarViewerMiddle":"_3a75f089","progressBar":"_70f0508f","back-to-application":"ac8150d7","unit":"_6c02a230","unitTitle":"e6dbf401","unitValue":"_8a28dfaa"};

/***/ }),
/* 5102 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_019fdc3f","outerContainer":"_8d9a6980","secondaryToolbar":"_7a07cffd","doorHangerRight":"d3f957af","toolbarContainer":"_4b997cdd","toolbarViewerMiddle":"_950f40d0","progressBar":"_96d69ec2","back-to-application":"_0d2483e6","titleWrapper":"_3eb0fdc1","title":"fcd39248","unitsWrapper":"_22210416"};

/***/ }),
/* 5103 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_6f1ccc62","outerContainer":"_455fbe2c","secondaryToolbar":"_02a50731","doorHangerRight":"_07e77f4b","toolbarContainer":"_159d6de0","toolbarViewerMiddle":"_54f85bfd","progressBar":"bae079a0","back-to-application":"_88abfd39","heading":"_55f7fa35","title":"_0a49a518","subtitle":"_8e1e8b92","block":"_23a2f110","blockTitle":"b36add94","blockContent":"_3699f2f8","invitation":"_7934f847","image":"fce6d287","contentWrapper":"_320f62b4","checkboxWrapper":"c8acde2c","link":"f66882bf"};

/***/ }),
/* 5104 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7a3cf9a9","outerContainer":"ab0e92d2","secondaryToolbar":"f6d72afc","doorHangerRight":"_19925ce6","toolbarContainer":"e3ee5b52","toolbarViewerMiddle":"_60e8e629","progressBar":"c0a6d761","back-to-application":"_8a97f946","root":"_10c48639","backButton":"_49c4de24","content":"d426cff3","loading":"ea1efc9d","title":"_037f2ced","description":"_413233cc","cellTitle":"ea363b80","cellText":"_7e4beccd","card":"_080e7c05","btnAdd":"_7964fdf1","transactionDescription":"f6574308","btnSubmit":"_41b17b36","loaderWrapper":"_51e041fd"};

/***/ }),
/* 5105 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_3a3572ad","outerContainer":"_8d781bc0","secondaryToolbar":"_70df1b4b","doorHangerRight":"_699d0ef3","toolbarContainer":"_8fe84c5f","toolbarViewerMiddle":"_66be7152","progressBar":"_9074cd2e","back-to-application":"_99d6b1e1","card":"_022158b6","section":"d75fb935","title":"e21a55a3","subtitle":"f6776db3","button":"ac1c332f","description":"c65f4674","programCostWrapper":"_0f540d76","programCost":"eea80159","costValue":"_0891937b","paidProgramInfo":"d65b4f09","columnWrapper":"c6a5a299","activeProgramCost":"fdec58b2","purchaseAgainButton":"_20ea811c","prepayButton":"cd04aa3a"};

/***/ }),
/* 5106 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_23081500","outerContainer":"ac26492c","secondaryToolbar":"d5fd7058","doorHangerRight":"b44aaef7","toolbarContainer":"_8faeb92d","toolbarViewerMiddle":"_19407313","progressBar":"_0bcc211c","back-to-application":"bd8aa1ce","section":"_9e4d15c6","wrapper":"_8e99fe3f","programCost":"e8e2d372","costValue":"_77f2a2a3","radioButtonWrapper":"_62043545","radioItem":"_281f3e09","radioItemLabel":"_0e6c0b92","costDescription":"abf47fbf"};

/***/ }),
/* 5107 */,
/* 5108 */,
/* 5109 */,
/* 5110 */,
/* 5111 */,
/* 5112 */,
/* 5113 */,
/* 5114 */,
/* 5115 */,
/* 5116 */,
/* 5117 */,
/* 5118 */,
/* 5119 */,
/* 5120 */,
/* 5121 */,
/* 5122 */,
/* 5123 */,
/* 5124 */,
/* 5125 */,
/* 5126 */,
/* 5127 */,
/* 5128 */,
/* 5129 */,
/* 5130 */,
/* 5131 */,
/* 5132 */,
/* 5133 */,
/* 5134 */,
/* 5135 */,
/* 5136 */,
/* 5137 */,
/* 5138 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_744745c2","outerContainer":"b4d02a46","secondaryToolbar":"_8c4e888e","doorHangerRight":"_46fbf370","toolbarContainer":"_3a385835","toolbarViewerMiddle":"_2cfa5904","progressBar":"_21201ada","back-to-application":"_612cc722","ssnDescription":"e455756d","noMarginBottom":"ce10d100"};

/***/ }),
/* 5139 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0ae30669","outerContainer":"_6b127adc","secondaryToolbar":"f9545502","doorHangerRight":"_6f1ab31e","toolbarContainer":"_48234718","toolbarViewerMiddle":"_31c186b5","progressBar":"_8950ac86","back-to-application":"_82adbe11","root":"_519a9c77","root--readOnly":"_0e06fd0b","label":"b952b587","required":"af749a9a"};

/***/ }),
/* 5140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d415fe8d","outerContainer":"c9610ab1","secondaryToolbar":"b8a5a991","doorHangerRight":"_3a16acca","toolbarContainer":"fabb2b34","toolbarViewerMiddle":"e842b67a","progressBar":"_0a55c4be","back-to-application":"_9ca6487e","text":"c41832e2","text--comment":"_2913b42e","description":"_15530199","optional":"f0581df3"};

/***/ }),
/* 5141 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"dc0711b4","outerContainer":"_99771181","secondaryToolbar":"_3b474d4e","doorHangerRight":"_0a6955c1","toolbarContainer":"_894a16a0","toolbarViewerMiddle":"_9b3edbaa","progressBar":"_4bb23371","back-to-application":"_4c2a815f","root":"da78d8ed","root--wide":"d4406623","root--no-bg":"fa82f3d1","wrapper":"_11996293","btnGroup":"_034b7780","answer":"_0b8a2d54","answer__popover":"_649fd4cd","link":"_0a8bd315","question__text":"_063e9616"};

/***/ }),
/* 5142 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1bdb3bb6","outerContainer":"_1fe672d7","secondaryToolbar":"_77357ddc","doorHangerRight":"_273c4b27","toolbarContainer":"_4cab69c6","toolbarViewerMiddle":"_78222110","progressBar":"_0c6de057","back-to-application":"_62ca2e9d","survey-card":"_1cd009f4","survey-card--active":"_263becae","header":"_1995e359","headerSub":"_030aaf19","container":"_1f0817b6","content":"_4456c40c","heading":"f0c7b53b","icon":"a1e940c8","text--title":"a29699db","text--heading":"_9df0e9e9","text--subtitle":"_1d8aa89c","text--date":"ffad8b40"};

/***/ }),
/* 5143 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"c8a7e0f6","outerContainer":"_047138a2","secondaryToolbar":"_6e563817","doorHangerRight":"_568020b4","toolbarContainer":"_08f1becc","toolbarViewerMiddle":"_786077f9","progressBar":"f0d8f165","back-to-application":"b8a84390","wrapper":"_1514a4ac","title":"_42b7871c","list":"d898b146"};

/***/ }),
/* 5144 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"da077ed3","outerContainer":"_81479c35","secondaryToolbar":"_89f43496","doorHangerRight":"_9a571c51","toolbarContainer":"_5efa2933","toolbarViewerMiddle":"daa145ab","progressBar":"b6fbeca1","back-to-application":"f86bdfe4","toggler":"fbf6c087","toggler--expanded":"_63dbfd6b"};

/***/ }),
/* 5145 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d2d66ee1","outerContainer":"d8a677fa","secondaryToolbar":"_518e10fd","doorHangerRight":"_1e9b469b","toolbarContainer":"_4fe51cda","toolbarViewerMiddle":"_893aa9c4","progressBar":"_01b971c6","back-to-application":"_6b72d163","wrapper":"_4a47ef77","wrapper--forNarrow":"be86dafb","row":"_11b1e518","row--no-border":"f06d5652","row--primary":"b9033d95","row--bold":"f257ff3d","cell":"ca41048a","cell--data":"cd941d55","cell--header":"_7d471e8f","cell--danger":"_61c1d24f","cell--primary":"fc50ed17","cell--bold":"a1fa3140","col--danger":"_5ba3432d","cell--header__danger":"a0316ad6","cell--header__text":"_9aa25538","table--expanded":"fb12e0c2","text":"a90a167c","comment":"_79be08e7","exportButton":"d365eb18"};

/***/ }),
/* 5146 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e6a5b633","outerContainer":"_3b94860d","secondaryToolbar":"_39ccfb99","doorHangerRight":"a9337f6f","toolbarContainer":"_07209c8e","toolbarViewerMiddle":"f9fcae58","progressBar":"_664fe649","back-to-application":"dad277bd","root":"b622e5a7"};

/***/ }),
/* 5147 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_560272db","outerContainer":"c7682762","secondaryToolbar":"dff88617","doorHangerRight":"c1eabd41","toolbarContainer":"db4d996b","toolbarViewerMiddle":"_7e819822","progressBar":"_0ad685ec","back-to-application":"a3ce0d56","root":"_63ef9a72","title":"cb2e9575","meta":"f1cbd1c4","socialApps":"_564590c8","btn":"_11810233"};

/***/ }),
/* 5148 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_8edffb91","outerContainer":"_4577b4dc","secondaryToolbar":"f490d103","doorHangerRight":"_4d11ecac","toolbarContainer":"_897f47b3","toolbarViewerMiddle":"c88bcef1","progressBar":"e314d5c2","back-to-application":"_7ccd8e56","root":"ee064d9a","title":"_20c2733b","message":"_6def2a82","button":"ebd844af"};

/***/ }),
/* 5149 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7bbf52b8","outerContainer":"_447646a4","secondaryToolbar":"ff005ce0","doorHangerRight":"_25dbaae1","toolbarContainer":"ad4f284f","toolbarViewerMiddle":"_34e607ff","progressBar":"_6608b08b","back-to-application":"fad36f0d","card":"_797483ef","title":"_8e35f2aa","description":"c4e41413","cost":"b2bf2662","costLabel":"_881721d7","costAmount":"da31263d"};

/***/ }),
/* 5150 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4b6bb4d4","outerContainer":"f227a815","secondaryToolbar":"c28ea8ef","doorHangerRight":"_7b0a8d58","toolbarContainer":"c6469d32","toolbarViewerMiddle":"_99f33cac","progressBar":"d294f089","back-to-application":"a7d5d242","root":"da2745a6","container":"b06e089c","info":"ed864082","consent":"_584e766a","header":"_99138b43","headerLeft":"ad2fd6df","headerIcon":"fb7ba85f","consentTypeName":"ea862cd7","headerDate":"_54c6e2ca","consentBody":"abc1023a","footer":"_1b3f195b","button":"_7e1a37fb"};

/***/ }),
/* 5151 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_57c154fb","outerContainer":"_5b74d305","secondaryToolbar":"a3466813","doorHangerRight":"f1341770","toolbarContainer":"_8124da40","toolbarViewerMiddle":"a2b2f841","progressBar":"_87524cbc","back-to-application":"_12c20330","wrapper":"_842aa153","content":"fe57e890","icon":"_3e1baa13","text":"fd20b901"};

/***/ }),
/* 5152 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_9a658f09","outerContainer":"_4c13d810","secondaryToolbar":"_91ffc75e","doorHangerRight":"e9fb967c","toolbarContainer":"_9d3a725d","toolbarViewerMiddle":"daa4b1fe","progressBar":"f94253bf","back-to-application":"_78b7bb04","placeholder":"b4bcbbdb","title":"_3897e7f9","subtitle":"_144e1b59"};

/***/ }),
/* 5153 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1f724023","outerContainer":"_8af6079c","secondaryToolbar":"da5cf80a","doorHangerRight":"_2913db81","toolbarContainer":"_2b03fddb","toolbarViewerMiddle":"a06bebb9","progressBar":"e1c1f0c5","back-to-application":"_33e1fd8d","subscriber":"_8887596f","loader":"_31d9ec0e","noVideo":"a2dda023","fullView":"_05242f18","collapsed":"_06dac689","me":"adb7a960","isDragging":"_0fa2448f","fullScreenView":"_5b0b1a13"};

/***/ }),
/* 5154 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_2ef4e24b","outerContainer":"_8a9ae041","secondaryToolbar":"_390b84d0","doorHangerRight":"_3b601446","toolbarContainer":"_522a4cfd","toolbarViewerMiddle":"_3553bde9","progressBar":"_3caea5c4","back-to-application":"_6cf8df5e","root":"_2ea1f1bd","name":"_22945290","icon":"_3373598f"};

/***/ }),
/* 5155 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1211ba92","outerContainer":"f4622fa8","secondaryToolbar":"_4457a539","doorHangerRight":"_239c66aa","toolbarContainer":"_36db58da","toolbarViewerMiddle":"ae54b097","progressBar":"e5bfca81","back-to-application":"d7d9017a","invitePopup":"b6394d24"};

/***/ }),
/* 5156 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a9395f09","outerContainer":"_217c7d91","secondaryToolbar":"_086dc1af","doorHangerRight":"d0d75d48","toolbarContainer":"ba35433c","toolbarViewerMiddle":"_0da187b7","progressBar":"_223fb7cf","back-to-application":"e9162c66","root":"bf16469e","avatar":"b4d2ad5f","preview":"_547c2374","info":"_53c768d3","status":"_39d73c35","truncate":"_5411a3f4"};

/***/ }),
/* 5157 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bc02f923","outerContainer":"_1fc9d70b","secondaryToolbar":"_9d069037","doorHangerRight":"_38a82b45","toolbarContainer":"_5e6debee","toolbarViewerMiddle":"_9ff5485e","progressBar":"d5d5d930","back-to-application":"_1ed297b6","root":"_6b8b9014"};

/***/ }),
/* 5158 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"dd0a6401"};

/***/ }),
/* 5159 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"db440e9e","outerContainer":"_44addca9","secondaryToolbar":"_8914faa6","doorHangerRight":"_383de3be","toolbarContainer":"_784ff711","toolbarViewerMiddle":"_7713ce9c","progressBar":"_45e6eff4","back-to-application":"c3eaa40b","root":"_84c1abba","pinned":"_8622c59a","active":"b00eaa0a","pinnedBtn":"_70038b85","speak":"_582a0302","loader":"_2b089c91","info":"_83815e86","video":"_7b55a86c","me":"bd22faff","noVideo":"e93cd306","controls":"_94f44868","slowConnection":"_0528ad23"};

/***/ }),
/* 5160 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bc864167","outerContainer":"_21f98398","secondaryToolbar":"_3cafe406","doorHangerRight":"_18a7e6ea","toolbarContainer":"_279bf409","toolbarViewerMiddle":"_3c116b87","progressBar":"_6381257f","back-to-application":"_6dabd333","root":"_92e66350","closeBtn":"_3a753187","head":"_67aef122","content":"_34888bbb","mobOpened":"a7acc40d"};

/***/ }),
/* 5161 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f335c458","outerContainer":"_32a19612","secondaryToolbar":"b220858b","doorHangerRight":"a10e36b1","toolbarContainer":"_97181125","toolbarViewerMiddle":"_167735dc","progressBar":"_7786521f","back-to-application":"_72618b13","root":"_33c5044a","hasWarning":"_979f19f5","slowConnection":"a716dac2"};

/***/ }),
/* 5162 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_5f4d4bfd","outerContainer":"_44cb57ba","secondaryToolbar":"_5d8058d5","doorHangerRight":"_19fcc62e","toolbarContainer":"e8b53dda","toolbarViewerMiddle":"_47ce0fc1","progressBar":"c54db4e6","back-to-application":"_85d92bfb","root":"bb1c4480","fullScreenMode":"b9d5848c"};

/***/ }),
/* 5163 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1b31b59a","outerContainer":"_608abfda","secondaryToolbar":"_833b941f","doorHangerRight":"b2d485d1","toolbarContainer":"_8b0415ac","toolbarViewerMiddle":"e4f7b46d","progressBar":"d145d77d","back-to-application":"_6949b2b9","root":"_96737cbc","disabled":"d98a49c4","btn":"_539a7975","endCall":"_7ff81da2","collapseBtn":"_532c6e7f","hideOnMobView":"_8f70b7ef"};

/***/ }),
/* 5164 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b7b39944","outerContainer":"cdd79955","secondaryToolbar":"_501c162b","doorHangerRight":"ea1603d6","toolbarContainer":"_87f859ff","toolbarViewerMiddle":"c8934cfb","progressBar":"f37046d4","back-to-application":"_58fe1950","root":"_3963c0a4","description":"b7e97b42","btnsSubmit":"daa012dd"};

/***/ }),
/* 5165 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"aafae1c1","outerContainer":"_76511f85","secondaryToolbar":"b4a856d8","doorHangerRight":"_69da45c8","toolbarContainer":"_794e8db1","toolbarViewerMiddle":"cf8fc20c","progressBar":"_17863524","back-to-application":"_2dc86cd2","cancelPopup":"b7d2b6fc"};

/***/ }),
/* 5166 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7644438b","outerContainer":"e5823785","secondaryToolbar":"_0eaef895","doorHangerRight":"ef7edde9","toolbarContainer":"_539cc938","toolbarViewerMiddle":"_2f1a04e8","progressBar":"_63f5b4ca","back-to-application":"df7be095","root":"b444e753","full":"f58ffa60","collapsed":"d4aa7e23","disabled":"_8b4921e1","main":"_12d2a4a2","title":"cf447437","logo":"cde8869d","info":"_7578d8e3","text":"_584274cf","infoBtn":"_99a88e11","btn":"_287f91db","desc":"_3e4dc02c","descText":"c5c07f4e","descLink":"f26c4f21","deviceSettings":"ddbebd7d"};

/***/ }),
/* 5167 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"video":"_1a542cc1","noVideo":"_90f768bf"};

/***/ }),
/* 5168 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bcb9a3b9","outerContainer":"fcb7c650","secondaryToolbar":"_34f0f2c5","doorHangerRight":"b106128b","toolbarContainer":"_7a1d08c6","toolbarViewerMiddle":"_09ad0738","progressBar":"_9ab4c93b","back-to-application":"_22de348b","root":"ce6e72d8","subscribers":"_4cc6ab9f","active":"a3b9824f","me":"_8f3199cb","mobileMode":"bdf3eb9d"};

/***/ }),
/* 5169 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_010c285f","outerContainer":"_13aec3c2","secondaryToolbar":"_610b7843","doorHangerRight":"_4c7f0142","toolbarContainer":"_5ecf7410","toolbarViewerMiddle":"ba922e34","progressBar":"_2ded16a0","back-to-application":"_3d5693fc","hidden":"c7af3e06","root":"_6450ee66","fullScreenContainer":"_4250fe02"};

/***/ }),
/* 5170 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a566101e","outerContainer":"_7a5feaec","secondaryToolbar":"cd5d94a9","doorHangerRight":"_96534b98","toolbarContainer":"fe090f4d","toolbarViewerMiddle":"_8a135053","progressBar":"_0dacba1f","back-to-application":"_5ce68565","paperStyles":"_87bd9d35","iconStyles":"_61f7cc79","buttonStyles":"_7ab2cf22"};

/***/ }),
/* 5171 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a44b2a24","outerContainer":"_41850a02","secondaryToolbar":"_7e284e6b","doorHangerRight":"_1c764a29","toolbarContainer":"_5eae4aa1","toolbarViewerMiddle":"d32b406a","progressBar":"_069e709c","back-to-application":"b0632bfa","root":"cdcd60c7","collapsed":"_3f2101a0","dragging":"_135fa2c4","loader":"_1281f5fe"};

/***/ }),
/* 5172 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_04f1897e","outerContainer":"c9fa04a6","secondaryToolbar":"_8b071dc2","doorHangerRight":"e50e446f","toolbarContainer":"_1e68f0e4","toolbarViewerMiddle":"_0564d0f6","progressBar":"_0482badc","back-to-application":"_6cbb4c96","root":"_96679f52","title":"_9381d5c4","subtitle":"_8d6f2b7a","desc":"_9f88c419"};

/***/ }),
/* 5173 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_424e8cc8","outerContainer":"cb222611","secondaryToolbar":"_12b14a35","doorHangerRight":"d097ab98","toolbarContainer":"_365d0978","toolbarViewerMiddle":"d5c7eb21","progressBar":"cbd89e4d","back-to-application":"_80ff2b53","root":"b1258c8d","header":"a5edd4ea","title":"bea4527e","titleDanger":"eeba37a7","progress":"_8d84fae4"};

/***/ }),
/* 5174 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_564b8d13","outerContainer":"deb93621","secondaryToolbar":"_151ea18a","doorHangerRight":"_2ca939f0","toolbarContainer":"_99f6fbe5","toolbarViewerMiddle":"_32bcedbc","progressBar":"ad4ab07a","back-to-application":"_1351ac14","root":"_9df2b425","content":"f5b673c4","details":"_91e4201d","detailsEmpty":"_123cbf14","title":"cdc18b1e","titleDanger":"_8c5dfb7c","subtitle":"_42e6763a"};

/***/ }),
/* 5175 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"_49ce4734"};

/***/ }),
/* 5176 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loaderWrapper":"_477163b1","loader":"ab34c629","spinning":"ddb8eb22"};

/***/ }),
/* 5177 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_923e6b1b","outerContainer":"_85cd7c63","secondaryToolbar":"_447133f3","doorHangerRight":"_37e5d6f7","toolbarContainer":"_492980cb","toolbarViewerMiddle":"_459bf609","progressBar":"_9c5517e6","back-to-application":"bc728a9e","highlighted":"_07aa4f70"};

/***/ }),
/* 5178 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_5e161944","outerContainer":"cd2c5560","secondaryToolbar":"_4920c737","doorHangerRight":"_723cb53c","toolbarContainer":"eb45ec7b","toolbarViewerMiddle":"d7fa50f7","progressBar":"d4b00754","back-to-application":"c4273b6b","label":"e5917726"};

/***/ }),
/* 5179 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_95c6bac9","outerContainer":"_2aa97d8d","secondaryToolbar":"_5cd897b8","doorHangerRight":"f27b09c2","toolbarContainer":"ca8cbb63","toolbarViewerMiddle":"_71ad0cdb","progressBar":"_337a20fd","back-to-application":"_404db5d9","root":"_562c0443"};

/***/ }),
/* 5180 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_8f2d095b","outerContainer":"_4c9f8f39","secondaryToolbar":"e1777be4","doorHangerRight":"_022e56c6","toolbarContainer":"a97614c1","toolbarViewerMiddle":"_569d8408","progressBar":"_17a8d331","back-to-application":"_99053198","back":"_377d0cd8","disabled":"ab2e8503","back__title":"a5ed50fd"};

/***/ }),
/* 5181 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0cb5ab1e","outerContainer":"_46c47a53","secondaryToolbar":"_7ec32642","doorHangerRight":"_17ec602e","toolbarContainer":"_85e7958c","toolbarViewerMiddle":"_881b82c1","progressBar":"d29573a6","back-to-application":"_8420babf","root":"_60bba348"};

/***/ }),
/* 5182 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_38cc33f3","outerContainer":"b7baac84","secondaryToolbar":"_0a37bedb","doorHangerRight":"_3dddc909","toolbarContainer":"a05f046b","toolbarViewerMiddle":"_88da30cd","progressBar":"_0201b681","back-to-application":"_4f3fb7a8","root":"_20123085","withBg":"_272a9e14","container":"_13e603c2","desc":"_57bf9e1d","heading":"b2186c1f","subtitle":"bfa22bae","title":"d72447de","info":"_6b118490"};

/***/ }),
/* 5183 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7a27cc2c","outerContainer":"_1f639163","secondaryToolbar":"f84831dc","doorHangerRight":"efdd927d","toolbarContainer":"c6a49fa5","toolbarViewerMiddle":"_3a2b9404","progressBar":"cdc3ee58","back-to-application":"_4794d915","canvas":"_56f54d81","info":"c82ec91f","empty":"_2b7b8e34","description":"d08273f4"};

/***/ }),
/* 5184 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_11cb670f","outerContainer":"af9d1ae1","secondaryToolbar":"_083a958a","doorHangerRight":"_2c12ad64","toolbarContainer":"_3a472d60","toolbarViewerMiddle":"_081cdddc","progressBar":"_85424950","back-to-application":"ff5b6d40","container":"_7f447fa5","groups":"ff0b6d9c","item":"_2f72677c","sub":"_19579334","dates":"dfa1d150","label":"_15e279ab"};

/***/ }),
/* 5185 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_6091a280","outerContainer":"a99d708d","secondaryToolbar":"e2e5d193","doorHangerRight":"b887fcdb","toolbarContainer":"_819b5ca1","toolbarViewerMiddle":"_8f5be589","progressBar":"cc5f5906","back-to-application":"_5e0ed52e","periods":"ac89a81b","period":"_0038263e","active":"a2131944"};

/***/ }),
/* 5186 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"e43ab633","outerContainer":"_8de5fbf0","secondaryToolbar":"_50197e2f","doorHangerRight":"_2491b3b2","toolbarContainer":"_687ca44c","toolbarViewerMiddle":"_4ce62175","progressBar":"_4bc28fea","back-to-application":"_0a24a4ca","header":"a0a94a39","info":"a1c941bc","sub":"_3a9260c2","light":"_03707f49"};

/***/ }),
/* 5187 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_8bede52e","outerContainer":"_397db753","secondaryToolbar":"_220a30a1","doorHangerRight":"_778c5817","toolbarContainer":"_1d64a1f3","toolbarViewerMiddle":"c03e89d3","progressBar":"_991e0239","back-to-application":"ab273c80","legend":"f1ed372e","item":"_5a60f90b","active":"_84af2969","disabled":"d0160d32","noclick":"_2cdbf4ac"};

/***/ }),
/* 5188 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_4ecbc44a","wrapper":"c6e57346","footer":"_8e0b98cf"};

/***/ }),
/* 5189 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f3d22d60","outerContainer":"_5e93dc28","secondaryToolbar":"_1169c864","doorHangerRight":"_011802fc","toolbarContainer":"_964b1aea","toolbarViewerMiddle":"_1dff4301","progressBar":"bbb13a38","back-to-application":"_7dfe1001","history":"_27d7f682","modal":"_9aef638d","item":"b75d3ea2","pure":"_5e477cc4","info":"f51a214f","sub":"e218968e","light":"_1d0091df","load":"f927f100","loader":"_71087c01"};

/***/ }),
/* 5190 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"_21e4d189","header":"da05143c","subtitle":"e3e499c0","content":"_713d8810"};

/***/ }),
/* 5191 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ac18e71e","outerContainer":"_49e00b42","secondaryToolbar":"_4690a453","doorHangerRight":"_9afb3817","toolbarContainer":"d1d76658","toolbarViewerMiddle":"e597a93f","progressBar":"_10d55e66","back-to-application":"_00d2372e","modal":"_69d9678e"};

/***/ }),
/* 5192 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b5961e3a","outerContainer":"_2c4f699e","secondaryToolbar":"c7bff9f4","doorHangerRight":"_53a99b19","toolbarContainer":"_10ab95c5","toolbarViewerMiddle":"_8b606e71","progressBar":"_087001b3","back-to-application":"c0f2e227","root":"f873ddd2","root--bottomLine":"_7b53afca","heading":"ad1e0d6a","sendMessage":"_37bb1b43","sendMessage__text":"a64809df"};

/***/ }),
/* 5193 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_767fefc4","outerContainer":"c558b34b","secondaryToolbar":"a691096f","doorHangerRight":"_92a25f8f","toolbarContainer":"_3ec3697b","toolbarViewerMiddle":"ad048f29","progressBar":"_8ca778da","back-to-application":"cebc9102","root":"_4165f6fb","content":"bfa13e87","input":"_716d56bb"};

/***/ }),
/* 5194 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0b5be2b4","outerContainer":"_9f873bea","secondaryToolbar":"e5407b19","doorHangerRight":"d4fbde76","toolbarContainer":"_0e60e04e","toolbarViewerMiddle":"_34bdc339","progressBar":"_070b6b9b","back-to-application":"_8ba671a8","picker-wrapper":"ae9a331e","label":"_60dde8fb","required":"_7a43ed0d"};

/***/ }),
/* 5195 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_118342cf","outerContainer":"_95161bcd","secondaryToolbar":"c672288e","doorHangerRight":"_7e37536e","toolbarContainer":"_3a61358a","toolbarViewerMiddle":"f8302d1d","progressBar":"_70860c08","back-to-application":"_85c1ba9f","button":"_93f94d3c"};

/***/ }),
/* 5196 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d8a7a621","outerContainer":"_7a157be0","secondaryToolbar":"_3b46e870","doorHangerRight":"_88652e2c","toolbarContainer":"_6287bbb0","toolbarViewerMiddle":"_30224d4b","progressBar":"dbd113a6","back-to-application":"bd539ef7","body":"_38bc6d01","wrapper":"b759d947"};

/***/ }),
/* 5197 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"ea465d24","outerContainer":"_9ec0b3d1","secondaryToolbar":"a891cdb7","doorHangerRight":"d6026577","toolbarContainer":"c96f8425","toolbarViewerMiddle":"_80f87dc8","progressBar":"b6e6baef","back-to-application":"_2d060804","mainDobInput":"_937548a1","absoluteInput":"_4b317560","calendarIcon":"_204ab0f1","disabledIcon":"_9d26003b","errorText":"fac2df1c","input":"acea170a","disabled":"_91dc8e25","inputElement":"_20524dd5","label":"_7251b295","header":"_6b08759e","calendarWrapper":"e6a4daa5","calendar":"d1ce0c10","years":"_7dc910bf","active":"e997b6a0","week":"_83901517","day":"_8089d45c"};

/***/ }),
/* 5198 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d0b292e5","outerContainer":"edb17311","secondaryToolbar":"_9c460eda","doorHangerRight":"_4d36940d","toolbarContainer":"_5fa24cc0","toolbarViewerMiddle":"_6abcb1fe","progressBar":"_87d9ad96","back-to-application":"_2ae78dd4","root":"_855e8aad","root--overflow-visible":"_9fd0d39c","content":"bfd41ffb","root--width--medium":"_6a95cde8","root--width--postCommunity":"_75ee11da","root--width--small":"fd001b5e","root--width--xsmall":"_6ba8768c","root--width--auto":"b78c0321","root--width--rubber":"f0377f09","root--width--notification":"f8355357","header":"_9ad72694","footer":"b765d8bc","footer--centered":"_2efe5ea8","footer--end":"f2e5f0ac","title":"e9b54d30","subTitle":"_8a50c43a","content--white":"_6afa36d9","content--noPadding":"b9b0a134","content--auto-height":"_91ea3b97","content--full-height":"_75f95940","root--nonAdaptive":"_23a8ba7a","contentWithoutAdaptive":"_8cc09340"};

/***/ }),
/* 5199 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_078a9d18","outerContainer":"a3d4ea06","secondaryToolbar":"_1943aaa5","doorHangerRight":"e9d4cf2d","toolbarContainer":"b96ac786","toolbarViewerMiddle":"_21793d68","progressBar":"f6e41f01","back-to-application":"_5b429a16","wrapper":"c7621031","infoWrapper":"c373dfd7","pointer":"bdae9707","info":"_542530dc","icon":"f6720f75","title":"aaabbaf0","titleAccent":"_484ee0ae","subtitle":"_93d373b5","removeIcon":"_47471f24"};

/***/ }),
/* 5200 */,
/* 5201 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_2a70c1ae","outerContainer":"ba13855c","secondaryToolbar":"f77d786e","doorHangerRight":"_6d6ca28d","toolbarContainer":"_84e020e1","toolbarViewerMiddle":"d5a74ede","progressBar":"_372ce2ab","back-to-application":"_68d4a1b3","infoIcon":"_912a705e","hintText":"a4c1c468"};

/***/ }),
/* 5202 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d3a26e1f","outerContainer":"_1334cc25","secondaryToolbar":"b6bacc06","doorHangerRight":"b9f1fe7a","toolbarContainer":"ec4b98e0","toolbarViewerMiddle":"bc50c898","progressBar":"_51acd759","back-to-application":"_8bff742c","menu-item":"_21efd139","menu-item--danger":"_5d48cf56","menu-item--border-top":"_2260faa1"};

/***/ }),
/* 5203 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_5cb86410","outerContainer":"df20e035","secondaryToolbar":"_1f145885","doorHangerRight":"fcd524da","toolbarContainer":"b8a3a388","toolbarViewerMiddle":"_39dc031f","progressBar":"_7a7748a7","back-to-application":"_5820ceb9","root":"a0dd79ba"};

/***/ }),
/* 5204 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a2f1e53d","outerContainer":"_4df4b796","secondaryToolbar":"f7f17ceb","doorHangerRight":"d5f46b2d","toolbarContainer":"_6ddf08dd","toolbarViewerMiddle":"c01d3506","progressBar":"_982bef88","back-to-application":"_49d4f40c","root":"_00387c74","button":"_527dddd5"};

/***/ }),
/* 5205 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_520b50e4","outerContainer":"_793bf77e","secondaryToolbar":"_5202ef95","doorHangerRight":"_948a39ac","toolbarContainer":"_77b54913","toolbarViewerMiddle":"ee6a2796","progressBar":"b7aee7ab","back-to-application":"_3e3e1a97","root":"_0265ba96","title":"a73c1b09","placeholder":"_6322e3cf","placeholder--disabled":"_3c7dd5dc","label":"_90efb069"};

/***/ }),
/* 5206 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"bab7d7ec","backdrop":"_4b56932e"};

/***/ }),
/* 5207 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b40940f7","outerContainer":"_254f2b06","secondaryToolbar":"_780f3761","doorHangerRight":"_49cb7a9b","toolbarContainer":"_3665198b","toolbarViewerMiddle":"_287eede7","progressBar":"ac3c55a9","back-to-application":"_4f5db67c","root":"_5aba9f5c","root--uppercase":"a07541e5"};

/***/ }),
/* 5208 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_5b6f0072","outerContainer":"_36f2ebdc","secondaryToolbar":"_19fed597","doorHangerRight":"eeb0f397","toolbarContainer":"a08edd5b","toolbarViewerMiddle":"_7836276b","progressBar":"d82f2c1a","back-to-application":"_6d52e89c","root":"e5618f45","wrapper":"_532ba455","outer":"_387fb1fb","inner":"f562e9b8","outer--active":"_93f83848","light":"a3ea7eab","burst":"ee227c35"};

/***/ }),
/* 5209 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_504e73aa","outerContainer":"bd5036b3","secondaryToolbar":"_4bdec02c","doorHangerRight":"_4a46f6ac","toolbarContainer":"_23f18ef8","toolbarViewerMiddle":"_191eb32a","progressBar":"d17b5962","back-to-application":"ae4ce28e","root":"_7b152db2"};

/***/ }),
/* 5210 */,
/* 5211 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"a70681b0","outerContainer":"_0c79b068","secondaryToolbar":"daa76535","doorHangerRight":"_19031f58","toolbarContainer":"_19b532df","toolbarViewerMiddle":"d5e22e22","progressBar":"_89505853","back-to-application":"e3b26532","list":"_003bed87","list--white":"_5311896c","counter":"_147e7d06","item":"_33cff5c1","wrapper":"_0aeeb640","title":"_6f4438e2","title--primary":"_84e0800a","title--secondary":"_05e7d70e","title--left":"b047221f","avatar":"dbfe27b2","role":"c821dfb0","subtitle":"_69f8a578","content":"e7bfb31c","role-content":"b6851d5e","provider":"d9b95edd"};

/***/ }),
/* 5212 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7383d980","outerContainer":"a56fb3d2","secondaryToolbar":"_0d5637e7","doorHangerRight":"b08c65d3","toolbarContainer":"ad3505d6","toolbarViewerMiddle":"_9c2e7f81","progressBar":"_0000331f","back-to-application":"ec0516a7","root":"_0c955ffc","spinner":"eccfc175","spinning":"_9614b47e","spinner--white":"_269a9135"};

/***/ }),
/* 5213 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"fb0edebb","outerContainer":"e9ae1c4f","secondaryToolbar":"_559ac0a3","doorHangerRight":"_06dd23b6","toolbarContainer":"b06606da","toolbarViewerMiddle":"e08acdc9","progressBar":"_10e3b238","back-to-application":"_9ad4488c","root":"d26c2833"};

/***/ }),
/* 5214 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"da42e7f4","outerContainer":"_22571f84","secondaryToolbar":"bd6b8df9","doorHangerRight":"_55f58af0","toolbarContainer":"_2b69adf0","toolbarViewerMiddle":"_7a658042","progressBar":"_7992cd3f","back-to-application":"_45f46d28","navLink":"da12e093","navLink--active":"_9e224c44","grey":"fd9f77e0"};

/***/ }),
/* 5215 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"_1c743ba9"};

/***/ }),
/* 5216 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menu":"_8c1abf85","menu--small":"_8b7133c9","menu--medium":"_78e014b5","menu--large":"_376e49b9"};

/***/ }),
/* 5217 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_5bad7f99","outerContainer":"cc94864d","secondaryToolbar":"_9c7f9331","doorHangerRight":"c219b497","toolbarContainer":"_0ab8a360","toolbarViewerMiddle":"d956e884","progressBar":"c042614e","back-to-application":"_69f3829e","root":"a0667255","root--overflow-visible":"c837a060","root--disableFillBackground":"_4026fb03","root--centered":"_1439819c"};

/***/ }),
/* 5218 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1fc05859","outerContainer":"_00968f00","secondaryToolbar":"_2bea0ae0","doorHangerRight":"d601c680","toolbarContainer":"a47f68e4","toolbarViewerMiddle":"dde4b005","progressBar":"_7d6eff77","back-to-application":"a49031d4","placeholder":"f7a2bf87"};

/***/ }),
/* 5219 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_2c958f9d","outerContainer":"_51ccb4ac","secondaryToolbar":"a9493c27","doorHangerRight":"bafc99c4","toolbarContainer":"_03fe099d","toolbarViewerMiddle":"_97634965","progressBar":"b310edde","back-to-application":"_3c4d3d37","root":"_609ff670","root-line":"_2824dec1"};

/***/ }),
/* 5220 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f733c17b","outerContainer":"_440efaba","secondaryToolbar":"b1065f28","doorHangerRight":"_4f2b0ae8","toolbarContainer":"_200d75d1","toolbarViewerMiddle":"f30d5ca2","progressBar":"ec1e41e3","back-to-application":"_033aa12f","root":"c6f95c85","label":"a8025f19","wrapper":"_4df0b63f","radio":"_5eeaed85","radioLabelWrapper":"d8231abb","radioLabelWrapperHeader":"_44fec313","radioAccountType":"e38ba6fc","expDate":"_05b177c9","expired":"fc9265f6","expDateExpired":"_57496ac4","expiredLabel":"_3c63143b","unknownAccountType":"c040e204"};

/***/ }),
/* 5221 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_734dc2a4","outerContainer":"_5882d699","secondaryToolbar":"c6e52b02","doorHangerRight":"_6b78d8b5","toolbarContainer":"_8c92570f","toolbarViewerMiddle":"e8ba31b6","progressBar":"b8a6d88a","back-to-application":"c68d2b1d","root":"_901286e6","cell":"a075e825","cell--start":"f8be32c7","cell--colored":"_1fa313e0","cell--selected":"_0154bd6d","mark":"b8d32a74"};

/***/ }),
/* 5222 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_3127f8e7","outerContainer":"b9c93dc8","secondaryToolbar":"a0f4af84","doorHangerRight":"_1ddd003a","toolbarContainer":"_5907530e","toolbarViewerMiddle":"a91cbd46","progressBar":"_401d7942","back-to-application":"_0cde244c","root":"_6225cc44"};

/***/ }),
/* 5223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b3b8c508","outerContainer":"_4bf911fd","secondaryToolbar":"a016e9e5","doorHangerRight":"_3885f33e","toolbarContainer":"c420cbaa","toolbarViewerMiddle":"e52db1af","progressBar":"_58935b56","back-to-application":"_26427f77","root":"_57d8648c","root--white":"cee12ba1","text":"_6da4ff27"};

/***/ }),
/* 5224 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_1e4fe88f","outerContainer":"_8257334f","secondaryToolbar":"_39a6d2ea","doorHangerRight":"c1cd7aa5","toolbarContainer":"d2679a8f","toolbarViewerMiddle":"_200abdad","progressBar":"a1e2efb4","back-to-application":"_2f392a63","root":"_81372e33","content":"_9fccb92d"};

/***/ }),
/* 5225 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_524c0c36","outerContainer":"_5758782a","secondaryToolbar":"c6893244","doorHangerRight":"_576c408f","toolbarContainer":"_2919aa3f","toolbarViewerMiddle":"b24acfa3","progressBar":"_15db0dd0","back-to-application":"_4dc4157a","form":"_0b86fc52","form-content":"b28cd7ec","form-selects":"_02eb12d7","form-select":"_7e1238ad","form-label":"_6c901bfa"};

/***/ }),
/* 5226 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_7eec80c9","outerContainer":"_1bb8ee76","secondaryToolbar":"_332235bc","doorHangerRight":"_024412c0","toolbarContainer":"_0dfd156a","toolbarViewerMiddle":"_9faaf956","progressBar":"_488c6463","back-to-application":"_99542623","text-field":"_4784301c","root":"_76741e1f","chip":"_92519f48","chip--primary":"c3c204b7","text-wrapper":"_01a020a8","text":"f2219e79","icon":"_771e70db","icon--right":"_63067fb9","search-icon":"b93175d6"};

/***/ }),
/* 5227 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4ae54bb5","outerContainer":"_233847ad","secondaryToolbar":"_68130714","doorHangerRight":"e50ae7da","toolbarContainer":"c43e078a","toolbarViewerMiddle":"_1c00983a","progressBar":"_0d36716d","back-to-application":"_6768b7aa","Shape":"_3862b633","Shape--withoutMargin":"c3965d73","active":"a14a65a5","pointer":"_3807c3d4","ShapeRow":"a1725a2a","ShapeRowDetails":"_362ef629","ShapeLeft":"bce263bd","ShapeContent":"_500e6fa8","ShapeContent-primary":"_3aafc073","ShapeContent-secondary":"b77b374a","ShapeContent-right":"e1cc7bb5"};

/***/ }),
/* 5228 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"d3ede95c","outerContainer":"_61aacf9e","secondaryToolbar":"_5e64f56d","doorHangerRight":"_21919cd2","toolbarContainer":"_96997755","toolbarViewerMiddle":"_12face53","progressBar":"_0ba6cecc","back-to-application":"_646067bf","content":"_9aa63008","button":"_8b0d257c"};

/***/ }),
/* 5229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"f1c3ad10","outerContainer":"_681ea0c2","secondaryToolbar":"_06cc2613","doorHangerRight":"_845833ce","toolbarContainer":"_4124ab27","toolbarViewerMiddle":"_5607ef0f","progressBar":"_665729e1","back-to-application":"_203c6e2e","root":"_6174333a","root--bordered":"_22e4370b","root--opaque":"c8b47af7","root--white":"_66ce3283","image":"_0a303434","image--disabled":"_9c91c754","iconWaiting":"_3d8e098e"};

/***/ }),
/* 5230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"_6678db40","root--small":"b3650ce3","icon-close":"c05b4e26"};

/***/ }),
/* 5231 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_096c74f6","outerContainer":"_662de50f","secondaryToolbar":"b9833d43","doorHangerRight":"e70ff45f","toolbarContainer":"c31ba3c8","toolbarViewerMiddle":"cb61dbb1","progressBar":"_2cefe499","back-to-application":"f9281e88","root":"db7e609e","item":"_0550dd7b"};

/***/ }),
/* 5232 */,
/* 5233 */,
/* 5234 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_0de77d20","outerContainer":"cedf2316","secondaryToolbar":"f497fa5c","doorHangerRight":"a031ff60","toolbarContainer":"_2062cd75","toolbarViewerMiddle":"_9a1f8606","progressBar":"_98571aef","back-to-application":"_75150cca","rootText":"dec13050"};

/***/ }),
/* 5235 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4ba83050","outerContainer":"_0d4c1935","secondaryToolbar":"_9c59cfc4","doorHangerRight":"_0293ea0b","toolbarContainer":"_3132a087","toolbarViewerMiddle":"d136faf7","progressBar":"_0c4553a4","back-to-application":"_57102986","root":"d20fe8b6","text":"aa7dc81e","textLink":"c4c1b918"};

/***/ }),
/* 5236 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bdb26552","outerContainer":"f5cd0288","secondaryToolbar":"ae0f15f7","doorHangerRight":"a5aaf702","toolbarContainer":"_0012a32e","toolbarViewerMiddle":"_4f0221a5","progressBar":"ac97aae9","back-to-application":"d5f28f86","root":"d08066c5"};

/***/ }),
/* 5237 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_51f63d09","outerContainer":"_5899f041","secondaryToolbar":"ed3324f9","doorHangerRight":"_2f3e7bc1","toolbarContainer":"_9df9e10b","toolbarViewerMiddle":"_911b78a9","progressBar":"_4f8cf5ad","back-to-application":"df66acc4","error":"_94d89b42"};

/***/ }),
/* 5238 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_4c92e4d0","outerContainer":"_99b9d227","secondaryToolbar":"_6d4a535a","doorHangerRight":"c5cd3109","toolbarContainer":"_21fd33a7","toolbarViewerMiddle":"_7dd30c58","progressBar":"_0ca76e2f","back-to-application":"e97eaf02","root":"_15ac24dd","icon":"_5db0b67e"};

/***/ }),
/* 5239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_454f2b15","outerContainer":"_5708bd97","secondaryToolbar":"_31cfc679","doorHangerRight":"d617a01d","toolbarContainer":"d7b1d160","toolbarViewerMiddle":"_8172c691","progressBar":"dfb0decb","back-to-application":"_2ad94489","root":"_06dbaa7c","label":"_728eec1b","textInputWrapper":"_22290152","iconReset":"_32190c2f","validationError":"e9e3cc82"};

/***/ }),
/* 5240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"cc4e1cd4","outerContainer":"_9cdf3836","secondaryToolbar":"_23c5dd0d","doorHangerRight":"_67fea0dd","toolbarContainer":"_5875c3c9","toolbarViewerMiddle":"_69e067a4","progressBar":"_209bfc0e","back-to-application":"db5d334b","root":"f1ed18fe","text":"_07219edd"};

/***/ }),
/* 5241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_06bdc28a","outerContainer":"_060c6336","secondaryToolbar":"c0493f7e","doorHangerRight":"_2a81598a","toolbarContainer":"a3219f6a","toolbarViewerMiddle":"af6a9cf4","progressBar":"_7c1ff6b0","back-to-application":"_8630c178","tooltip":"_73164ae4","tooltip--open":"_7f01d99a","tooltip--close":"f1bc8dda"};

/***/ }),
/* 5242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_038cd2c1","outerContainer":"d4965216","secondaryToolbar":"cc522333","doorHangerRight":"d12f3346","toolbarContainer":"bd20ad66","toolbarViewerMiddle":"_23e4f544","progressBar":"_9d5327be","back-to-application":"b8a4c3d9","error":"_048dec1b"};

/***/ }),
/* 5243 */,
/* 5244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"bee3ffd7","outerContainer":"bbfe060e","secondaryToolbar":"e8275fe6","doorHangerRight":"_41c9ba5b","toolbarContainer":"a9ca1d3f","toolbarViewerMiddle":"_1ac33060","progressBar":"b01c2cf0","back-to-application":"_23348f24","section":"dfae7be5","section_opened":"_6befe8e2","section_additionalStyles":"_999b6c38","icon":"_3e392d2b","divider":"_5142db7e","endSection":"_9645bd37"};

/***/ }),
/* 5245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_37036eb5","outerContainer":"f3df3255","secondaryToolbar":"_1a7b5b9e","doorHangerRight":"f80a2cbc","toolbarContainer":"_7250408a","toolbarViewerMiddle":"be09619b","progressBar":"_98df6d0d","back-to-application":"dad1868e","wrapper":"_3e6528c7","additionalInsurance":"f741a3bb","additionalInsuranceTitle":"_2c30324c","addInsuranceButton":"_6dd68d3d","additionalInsuranceFormWrapper":"_85b22796","additionalInsuranceFormWrapper_additionalStyles":"_23ee13d6","deleteInsuranceButton":"_5f67e3f5","deleteInsuranceButtonWrapper":"_75aa1197","deleteInsuranceButtonWrapper_additionalStyles":"c1ca7023","primarySubscriberCheckbox":"_772f80dd","errorBlock":"_0fbfe976"};

/***/ }),
/* 5246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_00bf1610","outerContainer":"_73333039","secondaryToolbar":"_3ba1632f","doorHangerRight":"ca916fde","toolbarContainer":"e399c1be","toolbarViewerMiddle":"a9bc39ee","progressBar":"ff347142","back-to-application":"b766aa7a","content":"bdbc1cca","title":"_87875574","buttonWrapper":"f2444a4f","loader":"_24b1922e"};

/***/ }),
/* 5247 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_43c6f2e1","outerContainer":"feb1be33","secondaryToolbar":"_8a9580b8","doorHangerRight":"efd6c039","toolbarContainer":"_3d7b6031","toolbarViewerMiddle":"_78e8e66a","progressBar":"bd3b8b83","back-to-application":"_67aa1d89","title":"_108016a9","images":"_66585133","error":"fe303a87"};

/***/ }),
/* 5248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_37b3cefe","outerContainer":"_800d2efa","secondaryToolbar":"_8f62e706","doorHangerRight":"c69f185a","toolbarContainer":"_97a3f74f","toolbarViewerMiddle":"_890dfade","progressBar":"c156cd9b","back-to-application":"b2be1591","profileFlowButtonWrapper":"f0c56ba4","profileFlowButton":"_762e95e1","paperworkFlowButtonWrapper":"_972f468c","paperworkFlowButton":"_10415404","toDoFlowButtonsWrapper":"_544b827a","toDoFlowButton":"dda076aa","toDoFlowLoader":"d3c04b9c"};

/***/ }),
/* 5249 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"fedd0c50","outerContainer":"_933bb504","secondaryToolbar":"_33df4dde","doorHangerRight":"_824cb041","toolbarContainer":"f63825b6","toolbarViewerMiddle":"_5958c75f","progressBar":"ebb30825","back-to-application":"_5d691421","wrapper":"_62b9bb60","icon":"a4db24da"};

/***/ }),
/* 5250 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"_089ebc43","outerContainer":"_9850044a","secondaryToolbar":"_33a4b946","doorHangerRight":"d2f2a3df","toolbarContainer":"_230d08af","toolbarViewerMiddle":"_71b27cc9","progressBar":"f5ade355","back-to-application":"_217e3f14","checkbox":"_1cf3f21a","primarySubscriberCheckbox":"dd637664","section":"bb9dd955","patientInsuranceCheckbox":"_8235521d","patientInsuranceCheckbox_profile":"_262d275e","driverLicenseSection":"_69a4e0c0","driverLicenseSectionTitle":"_6eccd772","insuranceDocumentsSectionTitle":"bd89f0a3","insuranceFormSection":"_7fb92e61","insuranceFormSection_additionalStyles":"f6743717"};

/***/ }),
/* 5251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"list":"d3b8dfb1","button":"_4b57a1fc"};

/***/ }),
/* 5252 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pdfjs":"b69db119","outerContainer":"_456cdd39","secondaryToolbar":"_2f3c49e9","doorHangerRight":"dbd31b9b","toolbarContainer":"_11f0d8ec","toolbarViewerMiddle":"c1ce3a45","progressBar":"_54a92eaa","back-to-application":"f8f91689","root":"_6f68221b","radioButtonItem":"b5666727","textField":"_5211740f","selectField":"a9966454","hideTextField":"_069f313c"};

/***/ }),
/* 5253 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"_24a48708","rippleWrapper":"_0500ce16","squared":"_57de7fa6","icon":"_30977412","solid":"afc1d629","raised":"c32c8326 _24a48708 _57de7fa6 afc1d629","flat":"f7243650 _24a48708 _57de7fa6","floating":"dee26284 _24a48708 afc1d629","mini":"c27a3552","toggle":"_35544ef1 _24a48708","primary":"c1982a21","accent":"ac8b6519","neutral":"_411a2676","inverse":"e92b3af8"};

/***/ }),
/* 5254 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"input":"d5f48ad9","disabled":"fb73654b","inputElement":"d579c134","header":"_17c32619","year":"_6567a6fc","date":"_2cff35da","calendarWrapper":"_4b4657b0","yearsDisplay":"_8d00f025","monthsDisplay":"_168cb85a","dialog":"f93995c2","button":"cf411f23","calendar":"b7f911fa","prev":"dab6c856","next":"_19151d5d","title":"_11ae29b5","years":"_0242cb62","active":"c73a14f5","week":"b2b3963b","days":"_6c290aa0","day":"_8189066a","month":"a313c48b","slideRightEnter":"e1785da3","slideRightLeave":"d6628e2c","slideRightEnterActive":"_14b8255e","slideRightLeaveActive":"_44455e2f","slideLeftEnter":"_079b5764","slideLeftLeave":"_7f2c221f","slideLeftEnterActive":"_99cfdc96","slideLeftLeaveActive":"cd7d9331"};

/***/ }),
/* 5255 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wrapper":"_83895b49","dialog":"_0c687eda","active":"_8e78e12f","small":"_8f312f8d","normal":"_3c5c3e8d","large":"_727468b2","fullscreen":"_26758518","title":"_7971d262","body":"f7f3fd3d","navigation":"_6742d89b","button":"_4bb9d825"};

/***/ }),
/* 5256 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"input":"c7217ce7","withIcon":"a3f71b46","icon":"c5fda7b3","inputElement":"_90bcfd9d","bar":"_24b196c1","label":"f20559e4","fixed":"cd16c445","required":"_3dcc0680","hint":"fd806e3c","filled":"df894199","error":"f00115ee","counter":"f292b061","disabled":"_37e03b25","errored":"_18005126","hidden":"_098afd69"};

/***/ }),
/* 5257 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"overlay":"bb37574a","active":"fc236625"};

/***/ }),
/* 5258 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"rippleWrapper":"_57d29118","ripple":"d1a1b1ae","rippleRestarting":"_17e5183c","rippleActive":"_3e58c4af"};

/***/ }),
/* 5259 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 5260 */,
/* 5261 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-e91bd4b4.png";

/***/ }),
/* 5262 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-832c3502.png";

/***/ }),
/* 5263 */,
/* 5264 */,
/* 5265 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-4a4ff174.png";

/***/ }),
/* 5266 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-b2c29bd4.png";

/***/ }),
/* 5267 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-328b51bd.png";

/***/ }),
/* 5268 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-45b69ce7.gif";

/***/ }),
/* 5269 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-cd5936ae.gif";

/***/ }),
/* 5270 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-a03025e0.gif";

/***/ }),
/* 5271 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-4ea624ee.gif";

/***/ }),
/* 5272 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-0830d46b.gif";

/***/ }),
/* 5273 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-bdeadeb1.gif";

/***/ }),
/* 5274 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-e129c6ea.png";

/***/ }),
/* 5275 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-23f99a50.png";

/***/ }),
/* 5276 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-db3fc21f.png";

/***/ }),
/* 5277 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-7883d29a.png";

/***/ }),
/* 5278 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-eabde58a.png";

/***/ }),
/* 5279 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-6e049aa6.png";

/***/ }),
/* 5280 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-da157cae.png";

/***/ }),
/* 5281 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-f3b8fb2e.png";

/***/ }),
/* 5282 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-ffc0e2f0.png";

/***/ }),
/* 5283 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-795b4590.png";

/***/ }),
/* 5284 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-0025a19b.png";

/***/ }),
/* 5285 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-dd06a814.png";

/***/ }),
/* 5286 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-aa844fd8.png";

/***/ }),
/* 5287 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-3c16c0d8.png";

/***/ }),
/* 5288 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-1b1618e8.png";

/***/ }),
/* 5289 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-c6f946a9.png";

/***/ }),
/* 5290 */
5289,
/* 5291 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-307afe2e.png";

/***/ }),
/* 5292 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-680b0217.png";

/***/ }),
/* 5293 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-8273c39e.png";

/***/ }),
/* 5294 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-e1c25a78.png";

/***/ }),
/* 5295 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-0b53296b.png";

/***/ }),
/* 5296 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-af67e586.png";

/***/ }),
/* 5297 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-473f086d.png";

/***/ }),
/* 5298 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-ca57aec8.png";

/***/ }),
/* 5299 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-685a51cb.png";

/***/ }),
/* 5300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-0d7c9b12.png";

/***/ }),
/* 5301 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-3908208e.png";

/***/ }),
/* 5302 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-1fff5f1b.png";

/***/ }),
/* 5303 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-9147129a.png";

/***/ }),
/* 5304 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-df7a67c7.png";

/***/ }),
/* 5305 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-0bcb6888.png";

/***/ }),
/* 5306 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-d2e92a00.png";

/***/ }),
/* 5307 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-0c90fd9f.png";

/***/ }),
/* 5308 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/img-26419d96.png";

/***/ }),
/* 5309 */,
/* 5310 */,
/* 5311 */,
/* 5312 */,
/* 5313 */,
/* 5314 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self)["format-string-by-pattern"]=t()}(this,(function(){"use strict";function e(e,t,n){return e.length+1===t.length&&t.endsWith(n)}function t(t,n){if(!n)return n;var r=String(n).replace(/[^\da-zA-Z\n|]/g,""),l=t.split(/[^\da-zA-Z\n|]/g).filter(Boolean).map((function(e){return e.length})),u=t.split(/[\da-zA-Z\n|]/g).filter(Boolean),i=u[0],a=u[u.length-1];if(t.startsWith(i)){var o=u.reduce((function(e,t,n){var r=l[n],u=e.value.slice(0,r),i=e.value.slice(r);return{result:u?e.result.concat(t,u):e.result,value:i}}),{result:"",value:r}).result.slice(0,t.length);return e(o,t,a)?o.concat(a):o}var c=l.reduce((function(e,t,n){var r=u[n]||"",l="$1"+r+"$2",i=t+e.prevSlice+e.prevSeparator.length,a=new RegExp("(.{"+i+"})(.)");return{prevSeparator:r,prevSlice:i,value:e.value.replace(a,l)}}),{prevSeparator:"",prevSlice:0,value:r}).value.slice(0,t.length);return e(c,t,a)?c.concat(a):c}return function(e,n){return void 0===n?function(n){return t(e,n)}:t(e,n)}}));
	//# sourceMappingURL=format-string-by-pattern.umd.js.map


/***/ }),
/* 5315 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 5316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getCloneDimensions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _getMargin = __webpack_require__(2287);
	
	var _getMargin2 = _interopRequireDefault(_getMargin);
	
	function getCloneDimensions(node, options) {
	  var parentNode = node.parentNode;
	
	  var context = document.createElement('div');
	  var clone = node.cloneNode(true);
	  var style = getComputedStyle(node);
	  var rect = undefined,
	      width = undefined,
	      height = undefined,
	      margin = undefined;
	
	  // give the node some context to measure off of
	  // no height and hidden overflow hide node copy
	  context.style.height = 0;
	  context.style.overflow = 'hidden';
	
	  // clean up any attributes that might cause a conflict with the original node
	  // i.e. inputs that should focus or submit data
	  clone.setAttribute('id', '');
	  clone.setAttribute('name', '');
	
	  // set props to get a true dimension calculation
	  if (options.display || style.getPropertyValue('display') === 'none') {
	    clone.style.display = options.display || 'block';
	  }
	  if (options.width || !parseInt(style.getPropertyValue('width'))) {
	    clone.style.width = options.width || 'auto';
	  }
	  if (options.height || !parseInt(style.getPropertyValue('height'))) {
	    clone.style.height = options.height || 'auto';
	  }
	
	  // append copy to context
	  context.appendChild(clone);
	
	  // append context to DOM so we can measure
	  parentNode.appendChild(context);
	
	  // get accurate dimensions
	  rect = clone.getBoundingClientRect();
	  width = clone.offsetWidth;
	  height = clone.offsetHeight;
	
	  // destroy clone
	  parentNode.removeChild(context);
	
	  return {
	    rect: {
	      width: width,
	      height: height,
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left
	    },
	    margin: (0, _getMargin2['default'])(style)
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 5317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = getNodeDimensions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _getCloneDimensions = __webpack_require__(5316);
	
	var _getCloneDimensions2 = _interopRequireDefault(_getCloneDimensions);
	
	var _getMargin = __webpack_require__(2287);
	
	var _getMargin2 = _interopRequireDefault(_getMargin);
	
	function getNodeDimensions(node) {
	  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var rect = node.getBoundingClientRect();
	  var width = undefined,
	      height = undefined,
	      margin = undefined;
	
	  // determine if we need to clone the element to get proper dimensions or not
	  if (!rect.width || !rect.height || options.clone) {
	    var cloneDimensions = (0, _getCloneDimensions2['default'])(node, options);
	    rect = cloneDimensions.rect;
	    margin = cloneDimensions.margin;
	  }
	  // if no cloning needed, we need to determine if margin should be accounted for
	  else if (options.margin) {
	      margin = (0, _getMargin2['default'])(getComputedStyle(node));
	    }
	
	  // include margin in width/height calculation if desired
	  if (options.margin) {
	    width = margin.left + rect.width + margin.right;
	    height = margin.top + rect.height + margin.bottom;
	  } else {
	    width = rect.width;
	    height = rect.height;
	  }
	
	  return {
	    width: width,
	    height: height,
	    top: rect.top,
	    right: rect.right,
	    bottom: rect.bottom,
	    left: rect.left
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 5318 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5319 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.libphonenumber = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
	var COMPILED = !0, goog = goog || {};
	goog.global = this;
	goog.isDef = function(a) {
	  return void 0 !== a;
	};
	goog.isString = function(a) {
	  return "string" == typeof a;
	};
	goog.isBoolean = function(a) {
	  return "boolean" == typeof a;
	};
	goog.isNumber = function(a) {
	  return "number" == typeof a;
	};
	goog.exportPath_ = function(a, b, c) {
	  a = a.split(".");
	  c = c || goog.global;
	  a[0] in c || !c.execScript || c.execScript("var " + a[0]);
	  for (var d; a.length && (d = a.shift());) {
	    !a.length && goog.isDef(b) ? c[d] = b : c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {};
	  }
	};
	goog.define = function(a, b) {
	  var c = b;
	  COMPILED || (goog.global.CLOSURE_UNCOMPILED_DEFINES && void 0 === goog.global.CLOSURE_UNCOMPILED_DEFINES.nodeType && Object.prototype.hasOwnProperty.call(goog.global.CLOSURE_UNCOMPILED_DEFINES, a) ? c = goog.global.CLOSURE_UNCOMPILED_DEFINES[a] : goog.global.CLOSURE_DEFINES && void 0 === goog.global.CLOSURE_DEFINES.nodeType && Object.prototype.hasOwnProperty.call(goog.global.CLOSURE_DEFINES, a) && (c = goog.global.CLOSURE_DEFINES[a]));
	  goog.exportPath_(a, c);
	};
	goog.DEBUG = !0;
	goog.LOCALE = "en";
	goog.TRUSTED_SITE = !0;
	goog.STRICT_MODE_COMPATIBLE = !1;
	goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
	goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
	goog.provide = function(a) {
	  if (goog.isInModuleLoader_()) {
	    throw Error("goog.provide can not be used within a goog.module.");
	  }
	  if (!COMPILED && goog.isProvided_(a)) {
	    throw Error('Namespace "' + a + '" already declared.');
	  }
	  goog.constructNamespace_(a);
	};
	goog.constructNamespace_ = function(a, b) {
	  if (!COMPILED) {
	    delete goog.implicitNamespaces_[a];
	    for (var c = a; (c = c.substring(0, c.lastIndexOf("."))) && !goog.getObjectByName(c);) {
	      goog.implicitNamespaces_[c] = !0;
	    }
	  }
	  goog.exportPath_(a, b);
	};
	goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
	goog.module = function(a) {
	  if (!goog.isString(a) || !a || -1 == a.search(goog.VALID_MODULE_RE_)) {
	    throw Error("Invalid module identifier");
	  }
	  if (!goog.isInModuleLoader_()) {
	    throw Error("Module " + a + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
	  }
	  if (goog.moduleLoaderState_.moduleName) {
	    throw Error("goog.module may only be called once per module.");
	  }
	  goog.moduleLoaderState_.moduleName = a;
	  if (!COMPILED) {
	    if (goog.isProvided_(a)) {
	      throw Error('Namespace "' + a + '" already declared.');
	    }
	    delete goog.implicitNamespaces_[a];
	  }
	};
	goog.module.get = function(a) {
	  return goog.module.getInternal_(a);
	};
	goog.module.getInternal_ = function(a) {
	  if (!COMPILED) {
	    if (a in goog.loadedModules_) {
	      return goog.loadedModules_[a];
	    }
	    if (!goog.implicitNamespaces_[a]) {
	      return a = goog.getObjectByName(a), null != a ? a : null;
	    }
	  }
	  return null;
	};
	goog.moduleLoaderState_ = null;
	goog.isInModuleLoader_ = function() {
	  return null != goog.moduleLoaderState_;
	};
	goog.module.declareLegacyNamespace = function() {
	  if (!COMPILED && !goog.isInModuleLoader_()) {
	    throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
	  }
	  if (!COMPILED && !goog.moduleLoaderState_.moduleName) {
	    throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
	  }
	  goog.moduleLoaderState_.declareLegacyNamespace = !0;
	};
	goog.setTestOnly = function(a) {
	  if (goog.DISALLOW_TEST_ONLY_CODE) {
	    throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
	  }
	};
	goog.forwardDeclare = function(a) {
	};
	COMPILED || (goog.isProvided_ = function(a) {
	  return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && goog.isDefAndNotNull(goog.getObjectByName(a));
	}, goog.implicitNamespaces_ = {"goog.module":!0});
	goog.getObjectByName = function(a, b) {
	  for (var c = a.split("."), d = b || goog.global, e = 0; e < c.length; e++) {
	    if (d = d[c[e]], !goog.isDefAndNotNull(d)) {
	      return null;
	    }
	  }
	  return d;
	};
	goog.globalize = function(a, b) {
	  var c = b || goog.global, d;
	  for (d in a) {
	    c[d] = a[d];
	  }
	};
	goog.addDependency = function(a, b, c, d) {
	  if (goog.DEPENDENCIES_ENABLED) {
	    var e = goog.getLoader_();
	    e && e.addDependency(a, b, c, d);
	  }
	};
	goog.ENABLE_DEBUG_LOADER = !0;
	goog.logToConsole_ = function(a) {
	  goog.global.console && goog.global.console.error(a);
	};
	goog.require = function(a) {
	  goog.ENABLE_DEBUG_LOADER && goog.debugLoader_ && goog.getLoader_().earlyProcessLoad(a);
	  if (!COMPILED) {
	    if (goog.isProvided_(a)) {
	      if (goog.isInModuleLoader_()) {
	        return goog.module.getInternal_(a);
	      }
	    } else {
	      if (goog.ENABLE_DEBUG_LOADER) {
	        var b = goog.moduleLoaderState_;
	        goog.moduleLoaderState_ = null;
	        try {
	          var c = goog.getLoader_();
	          c ? c.load(a) : goog.logToConsole_("Could not load " + a + " because there is no debug loader.");
	        } finally {
	          goog.moduleLoaderState_ = b;
	        }
	      }
	    }
	    return null;
	  }
	};
	goog.basePath = "";
	goog.nullFunction = function() {
	};
	goog.abstractMethod = function() {
	  throw Error("unimplemented abstract method");
	};
	goog.addSingletonGetter = function(a) {
	  a.instance_ = void 0;
	  a.getInstance = function() {
	    if (a.instance_) {
	      return a.instance_;
	    }
	    goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
	    return a.instance_ = new a;
	  };
	};
	goog.instantiatedSingletons_ = [];
	goog.LOAD_MODULE_USING_EVAL = !0;
	goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
	goog.loadedModules_ = {};
	goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
	goog.TRANSPILE = "detect";
	goog.TRANSPILER = "transpile.js";
	goog.DEBUG_LOADER = "";
	goog.hasBadLetScoping = null;
	goog.useSafari10Workaround = function() {
	  if (null == goog.hasBadLetScoping) {
	    try {
	      var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
	    } catch (b) {
	      a = !1;
	    }
	    goog.hasBadLetScoping = a;
	  }
	  return goog.hasBadLetScoping;
	};
	goog.workaroundSafari10EvalBug = function(a) {
	  return "(function(){" + a + "\n;})();\n";
	};
	goog.loadModule = function(a) {
	  var b = goog.moduleLoaderState_;
	  try {
	    goog.moduleLoaderState_ = {moduleName:void 0, declareLegacyNamespace:!1};
	    if (goog.isFunction(a)) {
	      var c = a.call(void 0, {});
	    } else {
	      if (goog.isString(a)) {
	        goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), c = goog.loadModuleFromSource_.call(void 0, a);
	      } else {
	        throw Error("Invalid module definition");
	      }
	    }
	    var d = goog.moduleLoaderState_.moduleName;
	    if (!goog.isString(d) || !d) {
	      throw Error('Invalid module name "' + d + '"');
	    }
	    goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, c) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof c && null != c && Object.seal(c);
	    goog.loadedModules_[d] = c;
	  } finally {
	    goog.moduleLoaderState_ = b;
	  }
	};
	goog.loadModuleFromSource_ = function(a) {
	  eval(a);
	  return {};
	};
	goog.normalizePath_ = function(a) {
	  a = a.split("/");
	  for (var b = 0; b < a.length;) {
	    "." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
	  }
	  return a.join("/");
	};
	goog.loadFileSync_ = function(a) {
	  if (goog.global.CLOSURE_LOAD_FILE_SYNC) {
	    return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
	  }
	  try {
	    var b = new goog.global.XMLHttpRequest;
	    b.open("get", a, !1);
	    b.send();
	    return 0 == b.status || 200 == b.status ? b.responseText : null;
	  } catch (c) {
	    return null;
	  }
	};
	goog.transpile_ = function(a, b) {
	  var c = goog.global.$jscomp;
	  c || (goog.global.$jscomp = c = {});
	  var d = c.transpile;
	  if (!d) {
	    var e = goog.basePath + goog.TRANSPILER, f = goog.loadFileSync_(e);
	    if (f) {
	      (function() {
	        eval(f + "\n//# sourceURL=" + e);
	      }).call(goog.global);
	      if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) {
	        throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
	      }
	      goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
	      c = goog.global.$jscomp;
	      d = c.transpile;
	    }
	  }
	  d || (d = c.transpile = function(a, b) {
	    goog.logToConsole_(b + " requires transpilation but no transpiler was found.");
	    return a;
	  });
	  return d(a, b);
	};
	goog.typeOf = function(a) {
	  var b = typeof a;
	  if ("object" == b) {
	    if (a) {
	      if (a instanceof Array) {
	        return "array";
	      }
	      if (a instanceof Object) {
	        return b;
	      }
	      var c = Object.prototype.toString.call(a);
	      if ("[object Window]" == c) {
	        return "object";
	      }
	      if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) {
	        return "array";
	      }
	      if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) {
	        return "function";
	      }
	    } else {
	      return "null";
	    }
	  } else {
	    if ("function" == b && "undefined" == typeof a.call) {
	      return "object";
	    }
	  }
	  return b;
	};
	goog.isNull = function(a) {
	  return null === a;
	};
	goog.isDefAndNotNull = function(a) {
	  return null != a;
	};
	goog.isArray = function(a) {
	  return "array" == goog.typeOf(a);
	};
	goog.isArrayLike = function(a) {
	  var b = goog.typeOf(a);
	  return "array" == b || "object" == b && "number" == typeof a.length;
	};
	goog.isDateLike = function(a) {
	  return goog.isObject(a) && "function" == typeof a.getFullYear;
	};
	goog.isFunction = function(a) {
	  return "function" == goog.typeOf(a);
	};
	goog.isObject = function(a) {
	  var b = typeof a;
	  return "object" == b && null != a || "function" == b;
	};
	goog.getUid = function(a) {
	  return a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
	};
	goog.hasUid = function(a) {
	  return !!a[goog.UID_PROPERTY_];
	};
	goog.removeUid = function(a) {
	  null !== a && "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);
	  try {
	    delete a[goog.UID_PROPERTY_];
	  } catch (b) {
	  }
	};
	goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0);
	goog.uidCounter_ = 0;
	goog.getHashCode = goog.getUid;
	goog.removeHashCode = goog.removeUid;
	goog.cloneObject = function(a) {
	  var b = goog.typeOf(a);
	  if ("object" == b || "array" == b) {
	    if (a.clone) {
	      return a.clone();
	    }
	    b = "array" == b ? [] : {};
	    for (var c in a) {
	      b[c] = goog.cloneObject(a[c]);
	    }
	    return b;
	  }
	  return a;
	};
	goog.bindNative_ = function(a, b, c) {
	  return a.call.apply(a.bind, arguments);
	};
	goog.bindJs_ = function(a, b, c) {
	  if (!a) {
	    throw Error();
	  }
	  if (2 < arguments.length) {
	    var d = Array.prototype.slice.call(arguments, 2);
	    return function() {
	      var c = Array.prototype.slice.call(arguments);
	      Array.prototype.unshift.apply(c, d);
	      return a.apply(b, c);
	    };
	  }
	  return function() {
	    return a.apply(b, arguments);
	  };
	};
	goog.bind = function(a, b, c) {
	  Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
	  return goog.bind.apply(null, arguments);
	};
	goog.partial = function(a, b) {
	  var c = Array.prototype.slice.call(arguments, 1);
	  return function() {
	    var b = c.slice();
	    b.push.apply(b, arguments);
	    return a.apply(this, b);
	  };
	};
	goog.mixin = function(a, b) {
	  for (var c in b) {
	    a[c] = b[c];
	  }
	};
	goog.now = goog.TRUSTED_SITE && Date.now || function() {
	  return +new Date;
	};
	goog.globalEval = function(a) {
	  if (goog.global.execScript) {
	    goog.global.execScript(a, "JavaScript");
	  } else {
	    if (goog.global.eval) {
	      if (null == goog.evalWorksForGlobals_) {
	        try {
	          goog.global.eval("var _evalTest_ = 1;");
	        } catch (d) {
	        }
	        if ("undefined" != typeof goog.global._evalTest_) {
	          try {
	            delete goog.global._evalTest_;
	          } catch (d) {
	          }
	          goog.evalWorksForGlobals_ = !0;
	        } else {
	          goog.evalWorksForGlobals_ = !1;
	        }
	      }
	      if (goog.evalWorksForGlobals_) {
	        goog.global.eval(a);
	      } else {
	        var b = goog.global.document, c = b.createElement("SCRIPT");
	        c.type = "text/javascript";
	        c.defer = !1;
	        c.appendChild(b.createTextNode(a));
	        b.head.appendChild(c);
	        b.head.removeChild(c);
	      }
	    } else {
	      throw Error("goog.globalEval not available");
	    }
	  }
	};
	goog.evalWorksForGlobals_ = null;
	goog.getCssName = function(a, b) {
	  if ("." == String(a).charAt(0)) {
	    throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
	  }
	  var c = function(a) {
	    return goog.cssNameMapping_[a] || a;
	  }, d = function(a) {
	    a = a.split("-");
	    for (var b = [], d = 0; d < a.length; d++) {
	      b.push(c(a[d]));
	    }
	    return b.join("-");
	  };
	  d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(a) {
	    return a;
	  };
	  d = b ? a + "-" + d(b) : d(a);
	  return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(d) : d;
	};
	goog.setCssNameMapping = function(a, b) {
	  goog.cssNameMapping_ = a;
	  goog.cssNameMappingStyle_ = b;
	};
	!COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
	goog.getMsg = function(a, b) {
	  b && (a = a.replace(/\{\$([^}]+)}/g, function(a, d) {
	    return null != b && d in b ? b[d] : a;
	  }));
	  return a;
	};
	goog.getMsgWithFallback = function(a, b) {
	  return a;
	};
	goog.exportSymbol = function(a, b, c) {
	  goog.exportPath_(a, b, c);
	};
	goog.exportProperty = function(a, b, c) {
	  a[b] = c;
	};
	goog.inherits = function(a, b) {
	  function c() {
	  }
	  c.prototype = b.prototype;
	  a.superClass_ = b.prototype;
	  a.prototype = new c;
	  a.prototype.constructor = a;
	  a.base = function(a, c, f) {
	    for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) {
	      d[e - 2] = arguments[e];
	    }
	    return b.prototype[c].apply(a, d);
	  };
	};
	goog.base = function(a, b, c) {
	  var d = arguments.callee.caller;
	  if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !d) {
	    throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
	  }
	  if (d.superClass_) {
	    for (var e = Array(arguments.length - 1), f = 1; f < arguments.length; f++) {
	      e[f - 1] = arguments[f];
	    }
	    return d.superClass_.constructor.apply(a, e);
	  }
	  e = Array(arguments.length - 2);
	  for (f = 2; f < arguments.length; f++) {
	    e[f - 2] = arguments[f];
	  }
	  f = !1;
	  for (var g = a.constructor; g; g = g.superClass_ && g.superClass_.constructor) {
	    if (g.prototype[b] === d) {
	      f = !0;
	    } else {
	      if (f) {
	        return g.prototype[b].apply(a, e);
	      }
	    }
	  }
	  if (a[b] === d) {
	    return a.constructor.prototype[b].apply(a, e);
	  }
	  throw Error("goog.base called from a method of one name to a method of a different name");
	};
	goog.scope = function(a) {
	  if (goog.isInModuleLoader_()) {
	    throw Error("goog.scope is not supported within a goog.module.");
	  }
	  a.call(goog.global);
	};
	COMPILED || (goog.global.COMPILED = COMPILED);
	goog.defineClass = function(a, b) {
	  var c = b.constructor, d = b.statics;
	  c && c != Object.prototype.constructor || (c = function() {
	    throw Error("cannot instantiate an interface (no constructor defined).");
	  });
	  c = goog.defineClass.createSealingConstructor_(c, a);
	  a && goog.inherits(c, a);
	  delete b.constructor;
	  delete b.statics;
	  goog.defineClass.applyProperties_(c.prototype, b);
	  null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
	  return c;
	};
	goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
	goog.defineClass.createSealingConstructor_ = function(a, b) {
	  if (!goog.defineClass.SEAL_CLASS_INSTANCES) {
	    return a;
	  }
	  var c = !goog.defineClass.isUnsealable_(b), d = function() {
	    var b = a.apply(this, arguments) || this;
	    b[goog.UID_PROPERTY_] = b[goog.UID_PROPERTY_];
	    this.constructor === d && c && Object.seal instanceof Function && Object.seal(b);
	    return b;
	  };
	  return d;
	};
	goog.defineClass.isUnsealable_ = function(a) {
	  return a && a.prototype && a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
	};
	goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	goog.defineClass.applyProperties_ = function(a, b) {
	  for (var c in b) {
	    Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
	  }
	  for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++) {
	    c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
	  }
	};
	goog.tagUnsealableClass = function(a) {
	  !COMPILED && goog.defineClass.SEAL_CLASS_INSTANCES && (a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_] = !0);
	};
	goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable";
	goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function() {
	  var a = goog.global.document;
	  return null != a && "write" in a;
	}, goog.findBasePath_ = function() {
	  if (goog.isDef(goog.global.CLOSURE_BASE_PATH) && goog.isString(goog.global.CLOSURE_BASE_PATH)) {
	    goog.basePath = goog.global.CLOSURE_BASE_PATH;
	  } else {
	    if (goog.inHtmlDocument_()) {
	      var a = goog.global.document, b = a.currentScript;
	      a = b ? [b] : a.getElementsByTagName("SCRIPT");
	      for (b = a.length - 1; 0 <= b; --b) {
	        var c = a[b].src, d = c.lastIndexOf("?");
	        d = -1 == d ? c.length : d;
	        if ("base.js" == c.substr(d - 7, 7)) {
	          goog.basePath = c.substr(0, d - 7);
	          break;
	        }
	      }
	    }
	  }
	}, goog.findBasePath_(), goog.Transpiler = function() {
	  this.requiresTranspilation_ = null;
	}, goog.Transpiler.prototype.createRequiresTranspilation_ = function() {
	  function a(a, b) {
	    d ? c[a] = !0 : b() ? c[a] = !1 : d = c[a] = !0;
	  }
	  function b(a) {
	    try {
	      return !!eval(a);
	    } catch (g) {
	      return !1;
	    }
	  }
	  var c = {es3:!1}, d = !1, e = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
	  a("es5", function() {
	    return b("[1,].length==1");
	  });
	  a("es6", function() {
	    var a = e.match(/Edge\/(\d+)(\.\d)*/i);
	    return a && 15 > Number(a[1]) ? !1 : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
	  });
	  a("es6-impl", function() {
	    return !0;
	  });
	  a("es7", function() {
	    return b("2 ** 2 == 4");
	  });
	  a("es8", function() {
	    return b("async () => 1, true");
	  });
	  return c;
	}, goog.Transpiler.prototype.needsTranspile = function(a) {
	  if ("always" == goog.TRANSPILE) {
	    return !0;
	  }
	  if ("never" == goog.TRANSPILE) {
	    return !1;
	  }
	  this.requiresTranspilation_ || (this.requiresTranspilation_ = this.createRequiresTranspilation_());
	  if (a in this.requiresTranspilation_) {
	    return this.requiresTranspilation_[a];
	  }
	  throw Error("Unknown language mode: " + a);
	}, goog.Transpiler.prototype.transpile = function(a, b) {
	  return goog.transpile_(a, b);
	}, goog.transpiler_ = new goog.Transpiler, goog.DebugLoader = function() {
	  this.dependencies_ = {loadFlags:{}, nameToPath:{}, requires:{}, visited:{}, written:{}, deferred:{}};
	  this.oldIeWaiting_ = !1;
	  this.queuedModules_ = [];
	  this.lastNonModuleScriptIndex_ = 0;
	}, goog.DebugLoader.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader.prototype.earlyProcessLoad = function(a) {
	  goog.DebugLoader.IS_OLD_IE_ && this.maybeProcessDeferredDep_(a);
	}, goog.DebugLoader.prototype.load = function(a) {
	  var b = this.getPathFromDeps_(a);
	  if (b) {
	    var c = function(a) {
	      if (!(a in f.written || a in f.visited)) {
	        f.visited[a] = !0;
	        if (a in f.requires) {
	          for (var b in f.requires[a]) {
	            if (!g.isProvided(b)) {
	              if (b in f.nameToPath) {
	                c(f.nameToPath[b]);
	              } else {
	                throw Error("Undefined nameToPath for " + b);
	              }
	            }
	          }
	        }
	        a in e || (e[a] = !0, d.push(a));
	      }
	    }, d = [], e = {}, f = this.dependencies_, g = this;
	    c(b);
	    for (a = 0; a < d.length; a++) {
	      b = d[a], this.dependencies_.written[b] = !0;
	    }
	    for (a = 0; a < d.length; a++) {
	      if (b = d[a]) {
	        var h = f.loadFlags[b] || {}, k = h.lang || "es3";
	        k = this.getTranspiler().needsTranspile(k);
	        "goog" == h.module || k ? this.importProcessedScript_(goog.basePath + b, "goog" == h.module, k) : this.importScript_(goog.basePath + b);
	      } else {
	        throw Error("Undefined script input");
	      }
	    }
	  } else {
	    throw a = "goog.require could not find: " + a, this.logToConsole(a), Error(a);
	  }
	}, goog.DebugLoader.prototype.addDependency = function(a, b, c, d) {
	  var e;
	  a = a.replace(/\\/g, "/");
	  var f = this.dependencies_;
	  d && "boolean" !== typeof d || (d = d ? {module:"goog"} : {});
	  for (var g = 0; e = b[g]; g++) {
	    f.nameToPath[e] = a, f.loadFlags[a] = d;
	  }
	  for (d = 0; b = c[d]; d++) {
	    a in f.requires || (f.requires[a] = {}), f.requires[a][b] = !0;
	  }
	}, goog.DebugLoader.prototype.importScript_ = function(a, b) {
	  (goog.global.CLOSURE_IMPORT_SCRIPT || goog.bind(this.writeScriptTag_, this))(a, b) && (this.dependencies_.written[a] = !0);
	}, goog.DebugLoader.prototype.importProcessedScript_ = function(a, b, c) {
	  this.importScript_("", 'goog.debugLoader_.retrieveAndExec_("' + a + '", ' + b + ", " + c + ");");
	}, goog.DebugLoader.prototype.retrieveAndExec_ = function(a, b, c) {
	  if (!COMPILED) {
	    var d = a;
	    a = this.normalizePath(a);
	    var e = goog.global.CLOSURE_IMPORT_SCRIPT || goog.bind(this.writeScriptTag_, this), f = this.loadFileSync(a);
	    if (null == f) {
	      throw Error('Load of "' + a + '" failed');
	    }
	    c && (f = this.getTranspiler().transpile(f, a));
	    f = b ? this.wrapModule_(a, f) : f + ("\n//# sourceURL=" + a);
	    goog.DebugLoader.IS_OLD_IE_ && this.oldIeWaiting_ ? (this.dependencies_.deferred[d] = f, this.queuedModules_.push(d)) : e(a, f);
	  }
	}, goog.DebugLoader.prototype.wrapModule_ = function(a, b) {
	  return goog.LOAD_MODULE_USING_EVAL && goog.isDef(goog.global.JSON) ? "goog.loadModule(" + goog.global.JSON.stringify(b + "\n//# sourceURL=" + a + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + b + "\n;return exports});\n//# sourceURL=" + a + "\n";
	}, goog.DebugLoader.prototype.loadQueuedModules_ = function() {
	  var a = this.queuedModules_.length;
	  if (0 < a) {
	    var b = this.queuedModules_;
	    this.queuedModules_ = [];
	    for (var c = 0; c < a; c++) {
	      this.maybeProcessDeferredPath_(b[c]);
	    }
	  }
	  this.oldIeWaiting_ = !1;
	}, goog.DebugLoader.prototype.maybeProcessDeferredDep_ = function(a) {
	  this.isDeferredModule_(a) && this.allDepsAreAvailable_(a) && (a = this.getPathFromDeps_(a), this.maybeProcessDeferredPath_(goog.basePath + a));
	}, goog.DebugLoader.prototype.isDeferredModule_ = function(a) {
	  var b = (a = this.getPathFromDeps_(a)) && this.dependencies_.loadFlags[a] || {}, c = b.lang || "es3";
	  return a && ("goog" == b.module || this.getTranspiler().needsTranspile(c)) ? goog.basePath + a in this.dependencies_.deferred : !1;
	}, goog.DebugLoader.prototype.allDepsAreAvailable_ = function(a) {
	  if ((a = this.getPathFromDeps_(a)) && a in this.dependencies_.requires) {
	    for (var b in this.dependencies_.requires[a]) {
	      if (!this.isProvided(b) && !this.isDeferredModule_(b)) {
	        return !1;
	      }
	    }
	  }
	  return !0;
	}, goog.DebugLoader.prototype.maybeProcessDeferredPath_ = function(a) {
	  if (a in this.dependencies_.deferred) {
	    var b = this.dependencies_.deferred[a];
	    delete this.dependencies_.deferred[a];
	    goog.globalEval(b);
	  }
	}, goog.DebugLoader.prototype.writeScriptSrcNode_ = function(a) {
	  goog.global.document.write('<script type="text/javascript" src="' + a + '">\x3c/script>');
	}, goog.DebugLoader.prototype.appendScriptSrcNode_ = function(a) {
	  var b = goog.global.document, c = b.createElement("script");
	  c.type = "text/javascript";
	  c.src = a;
	  c.defer = !1;
	  c.async = !1;
	  b.head.appendChild(c);
	}, goog.DebugLoader.prototype.writeScriptTag_ = function(a, b) {
	  if (this.inHtmlDocument()) {
	    var c = goog.global.document;
	    if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && "complete" == c.readyState) {
	      if (/\bdeps.js$/.test(a)) {
	        return !1;
	      }
	      throw Error('Cannot write "' + a + '" after document load');
	    }
	    if (void 0 === b) {
	      if (goog.DebugLoader.IS_OLD_IE_) {
	        this.oldIeWaiting_ = !0;
	        var d = " onreadystatechange='goog.debugLoader_.onScriptLoad_(this, " + ++this.lastNonModuleScriptIndex_ + ")' ";
	        c.write('<script type="text/javascript" src="' + a + '"' + d + ">\x3c/script>");
	      } else {
	        goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING ? this.appendScriptSrcNode_(a) : this.writeScriptSrcNode_(a);
	      }
	    } else {
	      c.write('<script type="text/javascript">' + this.protectScriptTag_(b) + "\x3c/script>");
	    }
	    return !0;
	  }
	  return !1;
	}, goog.DebugLoader.prototype.protectScriptTag_ = function(a) {
	  return a.replace(/<\/(SCRIPT)/ig, "\\x3c/$1");
	}, goog.DebugLoader.prototype.onScriptLoad_ = function(a, b) {
	  "complete" == a.readyState && this.lastNonModuleScriptIndex_ == b && this.loadQueuedModules_();
	  return !0;
	}, goog.DebugLoader.prototype.getPathFromDeps_ = function(a) {
	  return a in this.dependencies_.nameToPath ? this.dependencies_.nameToPath[a] : null;
	}, goog.DebugLoader.prototype.getTranspiler = function() {
	  return goog.transpiler_;
	}, goog.DebugLoader.prototype.isProvided = function(a) {
	  return goog.isProvided_(a);
	}, goog.DebugLoader.prototype.inHtmlDocument = function() {
	  return goog.inHtmlDocument_();
	}, goog.DebugLoader.prototype.logToConsole = function(a) {
	  goog.logToConsole_(a);
	}, goog.DebugLoader.prototype.loadFileSync = function(a) {
	  return goog.loadFileSync_(a);
	}, goog.DebugLoader.prototype.normalizePath = function(a) {
	  return goog.normalizePath_(a);
	}, goog.debugLoader_ = null, goog.registerDebugLoader = function(a) {
	  if (goog.debugLoader_) {
	    throw Error("Debug loader already registered!");
	  }
	  if (!(a instanceof goog.DebugLoader)) {
	    throw Error("Not a goog.DebugLoader.");
	  }
	  goog.debugLoader_ = a;
	}, goog.getLoader_ = function() {
	  if (!goog.debugLoader_ && goog.DEBUG_LOADER) {
	    throw Error("Loaded debug loader file but no loader was registered!");
	  }
	  goog.debugLoader_ || (goog.debugLoader_ = new goog.DebugLoader);
	  return goog.debugLoader_;
	}, function() {
	  if (goog.DEBUG_LOADER) {
	    var a = new goog.DebugLoader;
	    a.importScript_(goog.basePath + goog.DEBUG_LOADER);
	  }
	  goog.global.CLOSURE_NO_DEPS || (a = a || new goog.DebugLoader, goog.DEBUG_LOADER || goog.registerDebugLoader(a), a.importScript_(goog.basePath + "deps.js"));
	}());
	goog.string = {};
	goog.string.StringBuffer = function(a, b) {
	  null != a && this.append.apply(this, arguments);
	};
	goog.string.StringBuffer.prototype.buffer_ = "";
	goog.string.StringBuffer.prototype.set = function(a) {
	  this.buffer_ = "" + a;
	};
	goog.string.StringBuffer.prototype.append = function(a, b, c) {
	  this.buffer_ += String(a);
	  if (null != b) {
	    for (var d = 1; d < arguments.length; d++) {
	      this.buffer_ += arguments[d];
	    }
	  }
	  return this;
	};
	goog.string.StringBuffer.prototype.clear = function() {
	  this.buffer_ = "";
	};
	goog.string.StringBuffer.prototype.getLength = function() {
	  return this.buffer_.length;
	};
	goog.string.StringBuffer.prototype.toString = function() {
	  return this.buffer_;
	};
	goog.debug = {};
	goog.debug.Error = function(a) {
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, goog.debug.Error);
	  } else {
	    var b = Error().stack;
	    b && (this.stack = b);
	  }
	  a && (this.message = String(a));
	  this.reportErrorToServer = !0;
	};
	goog.inherits(goog.debug.Error, Error);
	goog.debug.Error.prototype.name = "CustomError";
	goog.dom = {};
	goog.dom.NodeType = {ELEMENT:1, ATTRIBUTE:2, TEXT:3, CDATA_SECTION:4, ENTITY_REFERENCE:5, ENTITY:6, PROCESSING_INSTRUCTION:7, COMMENT:8, DOCUMENT:9, DOCUMENT_TYPE:10, DOCUMENT_FRAGMENT:11, NOTATION:12};
	goog.asserts = {};
	goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
	goog.asserts.AssertionError = function(a, b) {
	  goog.debug.Error.call(this, goog.asserts.subs_(a, b));
	  this.messagePattern = a;
	};
	goog.inherits(goog.asserts.AssertionError, goog.debug.Error);
	goog.asserts.AssertionError.prototype.name = "AssertionError";
	goog.asserts.DEFAULT_ERROR_HANDLER = function(a) {
	  throw a;
	};
	goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
	goog.asserts.subs_ = function(a, b) {
	  for (var c = a.split("%s"), d = "", e = c.length - 1, f = 0; f < e; f++) {
	    d += c[f] + (f < b.length ? b[f] : "%s");
	  }
	  return d + c[e];
	};
	goog.asserts.doAssertFailure_ = function(a, b, c, d) {
	  var e = "Assertion failed";
	  if (c) {
	    e += ": " + c;
	    var f = d;
	  } else {
	    a && (e += ": " + a, f = b);
	  }
	  a = new goog.asserts.AssertionError("" + e, f || []);
	  goog.asserts.errorHandler_(a);
	};
	goog.asserts.setErrorHandler = function(a) {
	  goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
	};
	goog.asserts.assert = function(a, b, c) {
	  goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
	  return a;
	};
	goog.asserts.fail = function(a, b) {
	  goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1)));
	};
	goog.asserts.assertNumber = function(a, b, c) {
	  goog.asserts.ENABLE_ASSERTS && !goog.isNumber(a) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
	  return a;
	};
	goog.asserts.assertString = function(a, b, c) {
	  goog.asserts.ENABLE_ASSERTS && !goog.isString(a) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
	  return a;
	};
	goog.asserts.assertFunction = function(a, b, c) {
	  goog.asserts.ENABLE_ASSERTS && !goog.isFunction(a) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
	  return a;
	};
	goog.asserts.assertObject = function(a, b, c) {
	  goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
	  return a;
	};
	goog.asserts.assertArray = function(a, b, c) {
	  goog.asserts.ENABLE_ASSERTS && !goog.isArray(a) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
	  return a;
	};
	goog.asserts.assertBoolean = function(a, b, c) {
	  goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(a) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
	  return a;
	};
	goog.asserts.assertElement = function(a, b, c) {
	  !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(a), a], b, Array.prototype.slice.call(arguments, 2));
	  return a;
	};
	goog.asserts.assertInstanceof = function(a, b, c, d) {
	  !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(b), goog.asserts.getType_(a)], c, Array.prototype.slice.call(arguments, 3));
	  return a;
	};
	goog.asserts.assertFinite = function(a, b, c) {
	  !goog.asserts.ENABLE_ASSERTS || "number" == typeof a && isFinite(a) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [a], b, Array.prototype.slice.call(arguments, 2));
	  return a;
	};
	goog.asserts.assertObjectPrototypeIsIntact = function() {
	  for (var a in Object.prototype) {
	    goog.asserts.fail(a + " should not be enumerable in Object.prototype.");
	  }
	};
	goog.asserts.getType_ = function(a) {
	  return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : typeof a;
	};
	goog.array = {};
	goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
	goog.array.ASSUME_NATIVE_FUNCTIONS = !1;
	goog.array.peek = function(a) {
	  return a[a.length - 1];
	};
	goog.array.last = goog.array.peek;
	goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a, b, c) {
	  goog.asserts.assert(null != a.length);
	  return Array.prototype.indexOf.call(a, b, c);
	} : function(a, b, c) {
	  c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
	  if (goog.isString(a)) {
	    return goog.isString(b) && 1 == b.length ? a.indexOf(b, c) : -1;
	  }
	  for (; c < a.length; c++) {
	    if (c in a && a[c] === b) {
	      return c;
	    }
	  }
	  return -1;
	};
	goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a, b, c) {
	  goog.asserts.assert(null != a.length);
	  return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
	} : function(a, b, c) {
	  c = null == c ? a.length - 1 : c;
	  0 > c && (c = Math.max(0, a.length + c));
	  if (goog.isString(a)) {
	    return goog.isString(b) && 1 == b.length ? a.lastIndexOf(b, c) : -1;
	  }
	  for (; 0 <= c; c--) {
	    if (c in a && a[c] === b) {
	      return c;
	    }
	  }
	  return -1;
	};
	goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a, b, c) {
	  goog.asserts.assert(null != a.length);
	  Array.prototype.forEach.call(a, b, c);
	} : function(a, b, c) {
	  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
	    f in e && b.call(c, e[f], f, a);
	  }
	};
	goog.array.forEachRight = function(a, b, c) {
	  var d = a.length, e = goog.isString(a) ? a.split("") : a;
	  for (--d; 0 <= d; --d) {
	    d in e && b.call(c, e[d], d, a);
	  }
	};
	goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a, b, c) {
	  goog.asserts.assert(null != a.length);
	  return Array.prototype.filter.call(a, b, c);
	} : function(a, b, c) {
	  for (var d = a.length, e = [], f = 0, g = goog.isString(a) ? a.split("") : a, h = 0; h < d; h++) {
	    if (h in g) {
	      var k = g[h];
	      b.call(c, k, h, a) && (e[f++] = k);
	    }
	  }
	  return e;
	};
	goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a, b, c) {
	  goog.asserts.assert(null != a.length);
	  return Array.prototype.map.call(a, b, c);
	} : function(a, b, c) {
	  for (var d = a.length, e = Array(d), f = goog.isString(a) ? a.split("") : a, g = 0; g < d; g++) {
	    g in f && (e[g] = b.call(c, f[g], g, a));
	  }
	  return e;
	};
	goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a, b, c, d) {
	  goog.asserts.assert(null != a.length);
	  d && (b = goog.bind(b, d));
	  return Array.prototype.reduce.call(a, b, c);
	} : function(a, b, c, d) {
	  var e = c;
	  goog.array.forEach(a, function(c, g) {
	    e = b.call(d, e, c, g, a);
	  });
	  return e;
	};
	goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a, b, c, d) {
	  goog.asserts.assert(null != a.length);
	  goog.asserts.assert(null != b);
	  d && (b = goog.bind(b, d));
	  return Array.prototype.reduceRight.call(a, b, c);
	} : function(a, b, c, d) {
	  var e = c;
	  goog.array.forEachRight(a, function(c, g) {
	    e = b.call(d, e, c, g, a);
	  });
	  return e;
	};
	goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a, b, c) {
	  goog.asserts.assert(null != a.length);
	  return Array.prototype.some.call(a, b, c);
	} : function(a, b, c) {
	  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
	    if (f in e && b.call(c, e[f], f, a)) {
	      return !0;
	    }
	  }
	  return !1;
	};
	goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a, b, c) {
	  goog.asserts.assert(null != a.length);
	  return Array.prototype.every.call(a, b, c);
	} : function(a, b, c) {
	  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
	    if (f in e && !b.call(c, e[f], f, a)) {
	      return !1;
	    }
	  }
	  return !0;
	};
	goog.array.count = function(a, b, c) {
	  var d = 0;
	  goog.array.forEach(a, function(a, f, g) {
	    b.call(c, a, f, g) && ++d;
	  }, c);
	  return d;
	};
	goog.array.find = function(a, b, c) {
	  b = goog.array.findIndex(a, b, c);
	  return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
	};
	goog.array.findIndex = function(a, b, c) {
	  for (var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++) {
	    if (f in e && b.call(c, e[f], f, a)) {
	      return f;
	    }
	  }
	  return -1;
	};
	goog.array.findRight = function(a, b, c) {
	  b = goog.array.findIndexRight(a, b, c);
	  return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
	};
	goog.array.findIndexRight = function(a, b, c) {
	  var d = a.length, e = goog.isString(a) ? a.split("") : a;
	  for (--d; 0 <= d; d--) {
	    if (d in e && b.call(c, e[d], d, a)) {
	      return d;
	    }
	  }
	  return -1;
	};
	goog.array.contains = function(a, b) {
	  return 0 <= goog.array.indexOf(a, b);
	};
	goog.array.isEmpty = function(a) {
	  return 0 == a.length;
	};
	goog.array.clear = function(a) {
	  if (!goog.isArray(a)) {
	    for (var b = a.length - 1; 0 <= b; b--) {
	      delete a[b];
	    }
	  }
	  a.length = 0;
	};
	goog.array.insert = function(a, b) {
	  goog.array.contains(a, b) || a.push(b);
	};
	goog.array.insertAt = function(a, b, c) {
	  goog.array.splice(a, c, 0, b);
	};
	goog.array.insertArrayAt = function(a, b, c) {
	  goog.partial(goog.array.splice, a, c, 0).apply(null, b);
	};
	goog.array.insertBefore = function(a, b, c) {
	  var d;
	  2 == arguments.length || 0 > (d = goog.array.indexOf(a, c)) ? a.push(b) : goog.array.insertAt(a, b, d);
	};
	goog.array.remove = function(a, b) {
	  var c = goog.array.indexOf(a, b), d;
	  (d = 0 <= c) && goog.array.removeAt(a, c);
	  return d;
	};
	goog.array.removeLast = function(a, b) {
	  var c = goog.array.lastIndexOf(a, b);
	  return 0 <= c ? (goog.array.removeAt(a, c), !0) : !1;
	};
	goog.array.removeAt = function(a, b) {
	  goog.asserts.assert(null != a.length);
	  return 1 == Array.prototype.splice.call(a, b, 1).length;
	};
	goog.array.removeIf = function(a, b, c) {
	  b = goog.array.findIndex(a, b, c);
	  return 0 <= b ? (goog.array.removeAt(a, b), !0) : !1;
	};
	goog.array.removeAllIf = function(a, b, c) {
	  var d = 0;
	  goog.array.forEachRight(a, function(e, f) {
	    b.call(c, e, f, a) && goog.array.removeAt(a, f) && d++;
	  });
	  return d;
	};
	goog.array.concat = function(a) {
	  return Array.prototype.concat.apply([], arguments);
	};
	goog.array.join = function(a) {
	  return Array.prototype.concat.apply([], arguments);
	};
	goog.array.toArray = function(a) {
	  var b = a.length;
	  if (0 < b) {
	    for (var c = Array(b), d = 0; d < b; d++) {
	      c[d] = a[d];
	    }
	    return c;
	  }
	  return [];
	};
	goog.array.clone = goog.array.toArray;
	goog.array.extend = function(a, b) {
	  for (var c = 1; c < arguments.length; c++) {
	    var d = arguments[c];
	    if (goog.isArrayLike(d)) {
	      var e = a.length || 0, f = d.length || 0;
	      a.length = e + f;
	      for (var g = 0; g < f; g++) {
	        a[e + g] = d[g];
	      }
	    } else {
	      a.push(d);
	    }
	  }
	};
	goog.array.splice = function(a, b, c, d) {
	  goog.asserts.assert(null != a.length);
	  return Array.prototype.splice.apply(a, goog.array.slice(arguments, 1));
	};
	goog.array.slice = function(a, b, c) {
	  goog.asserts.assert(null != a.length);
	  return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
	};
	goog.array.removeDuplicates = function(a, b, c) {
	  b = b || a;
	  var d = function(a) {
	    return goog.isObject(a) ? "o" + goog.getUid(a) : (typeof a).charAt(0) + a;
	  };
	  c = c || d;
	  d = {};
	  for (var e = 0, f = 0; f < a.length;) {
	    var g = a[f++], h = c(g);
	    Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
	  }
	  b.length = e;
	};
	goog.array.binarySearch = function(a, b, c) {
	  return goog.array.binarySearch_(a, c || goog.array.defaultCompare, !1, b);
	};
	goog.array.binarySelect = function(a, b, c) {
	  return goog.array.binarySearch_(a, b, !0, void 0, c);
	};
	goog.array.binarySearch_ = function(a, b, c, d, e) {
	  for (var f = 0, g = a.length, h; f < g;) {
	    var k = f + g >> 1;
	    var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
	    0 < l ? f = k + 1 : (g = k, h = !l);
	  }
	  return h ? f : ~f;
	};
	goog.array.sort = function(a, b) {
	  a.sort(b || goog.array.defaultCompare);
	};
	goog.array.stableSort = function(a, b) {
	  for (var c = Array(a.length), d = 0; d < a.length; d++) {
	    c[d] = {index:d, value:a[d]};
	  }
	  var e = b || goog.array.defaultCompare;
	  goog.array.sort(c, function(a, b) {
	    return e(a.value, b.value) || a.index - b.index;
	  });
	  for (d = 0; d < a.length; d++) {
	    a[d] = c[d].value;
	  }
	};
	goog.array.sortByKey = function(a, b, c) {
	  var d = c || goog.array.defaultCompare;
	  goog.array.sort(a, function(a, c) {
	    return d(b(a), b(c));
	  });
	};
	goog.array.sortObjectsByKey = function(a, b, c) {
	  goog.array.sortByKey(a, function(a) {
	    return a[b];
	  }, c);
	};
	goog.array.isSorted = function(a, b, c) {
	  b = b || goog.array.defaultCompare;
	  for (var d = 1; d < a.length; d++) {
	    var e = b(a[d - 1], a[d]);
	    if (0 < e || 0 == e && c) {
	      return !1;
	    }
	  }
	  return !0;
	};
	goog.array.equals = function(a, b, c) {
	  if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length) {
	    return !1;
	  }
	  var d = a.length;
	  c = c || goog.array.defaultCompareEquality;
	  for (var e = 0; e < d; e++) {
	    if (!c(a[e], b[e])) {
	      return !1;
	    }
	  }
	  return !0;
	};
	goog.array.compare3 = function(a, b, c) {
	  c = c || goog.array.defaultCompare;
	  for (var d = Math.min(a.length, b.length), e = 0; e < d; e++) {
	    var f = c(a[e], b[e]);
	    if (0 != f) {
	      return f;
	    }
	  }
	  return goog.array.defaultCompare(a.length, b.length);
	};
	goog.array.defaultCompare = function(a, b) {
	  return a > b ? 1 : a < b ? -1 : 0;
	};
	goog.array.inverseDefaultCompare = function(a, b) {
	  return -goog.array.defaultCompare(a, b);
	};
	goog.array.defaultCompareEquality = function(a, b) {
	  return a === b;
	};
	goog.array.binaryInsert = function(a, b, c) {
	  c = goog.array.binarySearch(a, b, c);
	  return 0 > c ? (goog.array.insertAt(a, b, -(c + 1)), !0) : !1;
	};
	goog.array.binaryRemove = function(a, b, c) {
	  b = goog.array.binarySearch(a, b, c);
	  return 0 <= b ? goog.array.removeAt(a, b) : !1;
	};
	goog.array.bucket = function(a, b, c) {
	  for (var d = {}, e = 0; e < a.length; e++) {
	    var f = a[e], g = b.call(c, f, e, a);
	    goog.isDef(g) && (d[g] || (d[g] = [])).push(f);
	  }
	  return d;
	};
	goog.array.toObject = function(a, b, c) {
	  var d = {};
	  goog.array.forEach(a, function(e, f) {
	    d[b.call(c, e, f, a)] = e;
	  });
	  return d;
	};
	goog.array.range = function(a, b, c) {
	  var d = [], e = 0, f = a;
	  c = c || 1;
	  void 0 !== b && (e = a, f = b);
	  if (0 > c * (f - e)) {
	    return [];
	  }
	  if (0 < c) {
	    for (a = e; a < f; a += c) {
	      d.push(a);
	    }
	  } else {
	    for (a = e; a > f; a += c) {
	      d.push(a);
	    }
	  }
	  return d;
	};
	goog.array.repeat = function(a, b) {
	  for (var c = [], d = 0; d < b; d++) {
	    c[d] = a;
	  }
	  return c;
	};
	goog.array.flatten = function(a) {
	  for (var b = [], c = 0; c < arguments.length; c++) {
	    var d = arguments[c];
	    if (goog.isArray(d)) {
	      for (var e = 0; e < d.length; e += 8192) {
	        var f = goog.array.slice(d, e, e + 8192);
	        f = goog.array.flatten.apply(null, f);
	        for (var g = 0; g < f.length; g++) {
	          b.push(f[g]);
	        }
	      }
	    } else {
	      b.push(d);
	    }
	  }
	  return b;
	};
	goog.array.rotate = function(a, b) {
	  goog.asserts.assert(null != a.length);
	  a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
	  return a;
	};
	goog.array.moveItem = function(a, b, c) {
	  goog.asserts.assert(0 <= b && b < a.length);
	  goog.asserts.assert(0 <= c && c < a.length);
	  b = Array.prototype.splice.call(a, b, 1);
	  Array.prototype.splice.call(a, c, 0, b[0]);
	};
	goog.array.zip = function(a) {
	  if (!arguments.length) {
	    return [];
	  }
	  for (var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++) {
	    arguments[d].length < c && (c = arguments[d].length);
	  }
	  for (d = 0; d < c; d++) {
	    for (var e = [], f = 0; f < arguments.length; f++) {
	      e.push(arguments[f][d]);
	    }
	    b.push(e);
	  }
	  return b;
	};
	goog.array.shuffle = function(a, b) {
	  for (var c = b || Math.random, d = a.length - 1; 0 < d; d--) {
	    var e = Math.floor(c() * (d + 1)), f = a[d];
	    a[d] = a[e];
	    a[e] = f;
	  }
	};
	goog.array.copyByIndex = function(a, b) {
	  var c = [];
	  goog.array.forEach(b, function(b) {
	    c.push(a[b]);
	  });
	  return c;
	};
	goog.array.concatMap = function(a, b, c) {
	  return goog.array.concat.apply([], goog.array.map(a, b, c));
	};
	goog.object = {};
	goog.object.is = function(a, b) {
	  return a === b ? 0 !== a || 1 / a === 1 / b : a !== a && b !== b;
	};
	goog.object.forEach = function(a, b, c) {
	  for (var d in a) {
	    b.call(c, a[d], d, a);
	  }
	};
	goog.object.filter = function(a, b, c) {
	  var d = {}, e;
	  for (e in a) {
	    b.call(c, a[e], e, a) && (d[e] = a[e]);
	  }
	  return d;
	};
	goog.object.map = function(a, b, c) {
	  var d = {}, e;
	  for (e in a) {
	    d[e] = b.call(c, a[e], e, a);
	  }
	  return d;
	};
	goog.object.some = function(a, b, c) {
	  for (var d in a) {
	    if (b.call(c, a[d], d, a)) {
	      return !0;
	    }
	  }
	  return !1;
	};
	goog.object.every = function(a, b, c) {
	  for (var d in a) {
	    if (!b.call(c, a[d], d, a)) {
	      return !1;
	    }
	  }
	  return !0;
	};
	goog.object.getCount = function(a) {
	  var b = 0, c;
	  for (c in a) {
	    b++;
	  }
	  return b;
	};
	goog.object.getAnyKey = function(a) {
	  for (var b in a) {
	    return b;
	  }
	};
	goog.object.getAnyValue = function(a) {
	  for (var b in a) {
	    return a[b];
	  }
	};
	goog.object.contains = function(a, b) {
	  return goog.object.containsValue(a, b);
	};
	goog.object.getValues = function(a) {
	  var b = [], c = 0, d;
	  for (d in a) {
	    b[c++] = a[d];
	  }
	  return b;
	};
	goog.object.getKeys = function(a) {
	  var b = [], c = 0, d;
	  for (d in a) {
	    b[c++] = d;
	  }
	  return b;
	};
	goog.object.getValueByKeys = function(a, b) {
	  var c = goog.isArrayLike(b), d = c ? b : arguments;
	  for (c = c ? 0 : 1; c < d.length; c++) {
	    if (null == a) {
	      return;
	    }
	    a = a[d[c]];
	  }
	  return a;
	};
	goog.object.containsKey = function(a, b) {
	  return null !== a && b in a;
	};
	goog.object.containsValue = function(a, b) {
	  for (var c in a) {
	    if (a[c] == b) {
	      return !0;
	    }
	  }
	  return !1;
	};
	goog.object.findKey = function(a, b, c) {
	  for (var d in a) {
	    if (b.call(c, a[d], d, a)) {
	      return d;
	    }
	  }
	};
	goog.object.findValue = function(a, b, c) {
	  return (b = goog.object.findKey(a, b, c)) && a[b];
	};
	goog.object.isEmpty = function(a) {
	  for (var b in a) {
	    return !1;
	  }
	  return !0;
	};
	goog.object.clear = function(a) {
	  for (var b in a) {
	    delete a[b];
	  }
	};
	goog.object.remove = function(a, b) {
	  var c;
	  (c = b in a) && delete a[b];
	  return c;
	};
	goog.object.add = function(a, b, c) {
	  if (null !== a && b in a) {
	    throw Error('The object already contains the key "' + b + '"');
	  }
	  goog.object.set(a, b, c);
	};
	goog.object.get = function(a, b, c) {
	  return null !== a && b in a ? a[b] : c;
	};
	goog.object.set = function(a, b, c) {
	  a[b] = c;
	};
	goog.object.setIfUndefined = function(a, b, c) {
	  return b in a ? a[b] : a[b] = c;
	};
	goog.object.setWithReturnValueIfNotSet = function(a, b, c) {
	  if (b in a) {
	    return a[b];
	  }
	  c = c();
	  return a[b] = c;
	};
	goog.object.equals = function(a, b) {
	  for (var c in a) {
	    if (!(c in b) || a[c] !== b[c]) {
	      return !1;
	    }
	  }
	  for (c in b) {
	    if (!(c in a)) {
	      return !1;
	    }
	  }
	  return !0;
	};
	goog.object.clone = function(a) {
	  var b = {}, c;
	  for (c in a) {
	    b[c] = a[c];
	  }
	  return b;
	};
	goog.object.unsafeClone = function(a) {
	  var b = goog.typeOf(a);
	  if ("object" == b || "array" == b) {
	    if (goog.isFunction(a.clone)) {
	      return a.clone();
	    }
	    b = "array" == b ? [] : {};
	    for (var c in a) {
	      b[c] = goog.object.unsafeClone(a[c]);
	    }
	    return b;
	  }
	  return a;
	};
	goog.object.transpose = function(a) {
	  var b = {}, c;
	  for (c in a) {
	    b[a[c]] = c;
	  }
	  return b;
	};
	goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	goog.object.extend = function(a, b) {
	  for (var c, d, e = 1; e < arguments.length; e++) {
	    d = arguments[e];
	    for (c in d) {
	      a[c] = d[c];
	    }
	    for (var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++) {
	      c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
	    }
	  }
	};
	goog.object.create = function(a) {
	  var b = arguments.length;
	  if (1 == b && goog.isArray(arguments[0])) {
	    return goog.object.create.apply(null, arguments[0]);
	  }
	  if (b % 2) {
	    throw Error("Uneven number of arguments");
	  }
	  for (var c = {}, d = 0; d < b; d += 2) {
	    c[arguments[d]] = arguments[d + 1];
	  }
	  return c;
	};
	goog.object.createSet = function(a) {
	  var b = arguments.length;
	  if (1 == b && goog.isArray(arguments[0])) {
	    return goog.object.createSet.apply(null, arguments[0]);
	  }
	  for (var c = {}, d = 0; d < b; d++) {
	    c[arguments[d]] = !0;
	  }
	  return c;
	};
	goog.object.createImmutableView = function(a) {
	  var b = a;
	  Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
	  return b;
	};
	goog.object.isImmutableView = function(a) {
	  return !!Object.isFrozen && Object.isFrozen(a);
	};
	goog.object.getAllPropertyNames = function(a, b, c) {
	  if (!a) {
	    return [];
	  }
	  if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) {
	    return goog.object.getKeys(a);
	  }
	  for (var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);) {
	    for (var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++) {
	      d[e[f]] = !0;
	    }
	    a = Object.getPrototypeOf(a);
	  }
	  return goog.object.getKeys(d);
	};
	goog.string.DETECT_DOUBLE_ESCAPING = !1;
	goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
	goog.string.Unicode = {NBSP:"\u00a0"};
	goog.string.startsWith = function(a, b) {
	  return 0 == a.lastIndexOf(b, 0);
	};
	goog.string.endsWith = function(a, b) {
	  var c = a.length - b.length;
	  return 0 <= c && a.indexOf(b, c) == c;
	};
	goog.string.caseInsensitiveStartsWith = function(a, b) {
	  return 0 == goog.string.caseInsensitiveCompare(b, a.substr(0, b.length));
	};
	goog.string.caseInsensitiveEndsWith = function(a, b) {
	  return 0 == goog.string.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
	};
	goog.string.caseInsensitiveEquals = function(a, b) {
	  return a.toLowerCase() == b.toLowerCase();
	};
	goog.string.subs = function(a, b) {
	  for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
	    d += c.shift() + e.shift();
	  }
	  return d + c.join("%s");
	};
	goog.string.collapseWhitespace = function(a) {
	  return a.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
	};
	goog.string.isEmptyOrWhitespace = function(a) {
	  return /^[\s\xa0]*$/.test(a);
	};
	goog.string.isEmptyString = function(a) {
	  return 0 == a.length;
	};
	goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
	goog.string.isEmptyOrWhitespaceSafe = function(a) {
	  return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
	};
	goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
	goog.string.isBreakingWhitespace = function(a) {
	  return !/[^\t\n\r ]/.test(a);
	};
	goog.string.isAlpha = function(a) {
	  return !/[^a-zA-Z]/.test(a);
	};
	goog.string.isNumeric = function(a) {
	  return !/[^0-9]/.test(a);
	};
	goog.string.isAlphaNumeric = function(a) {
	  return !/[^a-zA-Z0-9]/.test(a);
	};
	goog.string.isSpace = function(a) {
	  return " " == a;
	};
	goog.string.isUnicodeChar = function(a) {
	  return 1 == a.length && " " <= a && "~" >= a || "\u0080" <= a && "\ufffd" >= a;
	};
	goog.string.stripNewlines = function(a) {
	  return a.replace(/(\r\n|\r|\n)+/g, " ");
	};
	goog.string.canonicalizeNewlines = function(a) {
	  return a.replace(/(\r\n|\r|\n)/g, "\n");
	};
	goog.string.normalizeWhitespace = function(a) {
	  return a.replace(/\xa0|\s/g, " ");
	};
	goog.string.normalizeSpaces = function(a) {
	  return a.replace(/\xa0|[ \t]+/g, " ");
	};
	goog.string.collapseBreakingSpaces = function(a) {
	  return a.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
	};
	goog.string.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a) {
	  return a.trim();
	} : function(a) {
	  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
	};
	goog.string.trimLeft = function(a) {
	  return a.replace(/^[\s\xa0]+/, "");
	};
	goog.string.trimRight = function(a) {
	  return a.replace(/[\s\xa0]+$/, "");
	};
	goog.string.caseInsensitiveCompare = function(a, b) {
	  var c = String(a).toLowerCase(), d = String(b).toLowerCase();
	  return c < d ? -1 : c == d ? 0 : 1;
	};
	goog.string.numberAwareCompare_ = function(a, b, c) {
	  if (a == b) {
	    return 0;
	  }
	  if (!a) {
	    return -1;
	  }
	  if (!b) {
	    return 1;
	  }
	  for (var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++) {
	    c = d[g];
	    var h = e[g];
	    if (c != h) {
	      return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
	    }
	  }
	  return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
	};
	goog.string.intAwareCompare = function(a, b) {
	  return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
	};
	goog.string.floatAwareCompare = function(a, b) {
	  return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
	};
	goog.string.numerateCompare = goog.string.floatAwareCompare;
	goog.string.urlEncode = function(a) {
	  return encodeURIComponent(String(a));
	};
	goog.string.urlDecode = function(a) {
	  return decodeURIComponent(a.replace(/\+/g, " "));
	};
	goog.string.newLineToBr = function(a, b) {
	  return a.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
	};
	goog.string.htmlEscape = function(a, b) {
	  if (b) {
	    a = a.replace(goog.string.AMP_RE_, "&amp;").replace(goog.string.LT_RE_, "&lt;").replace(goog.string.GT_RE_, "&gt;").replace(goog.string.QUOT_RE_, "&quot;").replace(goog.string.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.NULL_RE_, "&#0;"), goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, "&#101;"));
	  } else {
	    if (!goog.string.ALL_RE_.test(a)) {
	      return a;
	    }
	    -1 != a.indexOf("&") && (a = a.replace(goog.string.AMP_RE_, "&amp;"));
	    -1 != a.indexOf("<") && (a = a.replace(goog.string.LT_RE_, "&lt;"));
	    -1 != a.indexOf(">") && (a = a.replace(goog.string.GT_RE_, "&gt;"));
	    -1 != a.indexOf('"') && (a = a.replace(goog.string.QUOT_RE_, "&quot;"));
	    -1 != a.indexOf("'") && (a = a.replace(goog.string.SINGLE_QUOTE_RE_, "&#39;"));
	    -1 != a.indexOf("\x00") && (a = a.replace(goog.string.NULL_RE_, "&#0;"));
	    goog.string.DETECT_DOUBLE_ESCAPING && -1 != a.indexOf("e") && (a = a.replace(goog.string.E_RE_, "&#101;"));
	  }
	  return a;
	};
	goog.string.AMP_RE_ = /&/g;
	goog.string.LT_RE_ = /</g;
	goog.string.GT_RE_ = />/g;
	goog.string.QUOT_RE_ = /"/g;
	goog.string.SINGLE_QUOTE_RE_ = /'/g;
	goog.string.NULL_RE_ = /\x00/g;
	goog.string.E_RE_ = /e/g;
	goog.string.ALL_RE_ = goog.string.DETECT_DOUBLE_ESCAPING ? /[\x00&<>"'e]/ : /[\x00&<>"']/;
	goog.string.unescapeEntities = function(a) {
	  return goog.string.contains(a, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
	};
	goog.string.unescapeEntitiesWithDocument = function(a, b) {
	  return goog.string.contains(a, "&") ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
	};
	goog.string.unescapeEntitiesUsingDom_ = function(a, b) {
	  var c = {"&amp;":"&", "&lt;":"<", "&gt;":">", "&quot;":'"'};
	  var d = b ? b.createElement("div") : goog.global.document.createElement("div");
	  return a.replace(goog.string.HTML_ENTITY_PATTERN_, function(a, b) {
	    var e = c[a];
	    if (e) {
	      return e;
	    }
	    if ("#" == b.charAt(0)) {
	      var f = Number("0" + b.substr(1));
	      isNaN(f) || (e = String.fromCharCode(f));
	    }
	    e || (d.innerHTML = a + " ", e = d.firstChild.nodeValue.slice(0, -1));
	    return c[a] = e;
	  });
	};
	goog.string.unescapePureXmlEntities_ = function(a) {
	  return a.replace(/&([^;]+);/g, function(a, c) {
	    switch(c) {
	      case "amp":
	        return "&";
	      case "lt":
	        return "<";
	      case "gt":
	        return ">";
	      case "quot":
	        return '"';
	      default:
	        if ("#" == c.charAt(0)) {
	          var b = Number("0" + c.substr(1));
	          if (!isNaN(b)) {
	            return String.fromCharCode(b);
	          }
	        }
	        return a;
	    }
	  });
	};
	goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
	goog.string.whitespaceEscape = function(a, b) {
	  return goog.string.newLineToBr(a.replace(/  /g, " &#160;"), b);
	};
	goog.string.preserveSpaces = function(a) {
	  return a.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
	};
	goog.string.stripQuotes = function(a, b) {
	  for (var c = b.length, d = 0; d < c; d++) {
	    var e = 1 == c ? b : b.charAt(d);
	    if (a.charAt(0) == e && a.charAt(a.length - 1) == e) {
	      return a.substring(1, a.length - 1);
	    }
	  }
	  return a;
	};
	goog.string.truncate = function(a, b, c) {
	  c && (a = goog.string.unescapeEntities(a));
	  a.length > b && (a = a.substring(0, b - 3) + "...");
	  c && (a = goog.string.htmlEscape(a));
	  return a;
	};
	goog.string.truncateMiddle = function(a, b, c, d) {
	  c && (a = goog.string.unescapeEntities(a));
	  if (d && a.length > b) {
	    d > b && (d = b);
	    var e = a.length - d;
	    a = a.substring(0, b - d) + "..." + a.substring(e);
	  } else {
	    a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + "..." + a.substring(e));
	  }
	  c && (a = goog.string.htmlEscape(a));
	  return a;
	};
	goog.string.specialEscapeChars_ = {"\x00":"\\0", "\b":"\\b", "\f":"\\f", "\n":"\\n", "\r":"\\r", "\t":"\\t", "\x0B":"\\x0B", '"':'\\"', "\\":"\\\\", "<":"<"};
	goog.string.jsEscapeCache_ = {"'":"\\'"};
	goog.string.quote = function(a) {
	  a = String(a);
	  for (var b = ['"'], c = 0; c < a.length; c++) {
	    var d = a.charAt(c), e = d.charCodeAt(0);
	    b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
	  }
	  b.push('"');
	  return b.join("");
	};
	goog.string.escapeString = function(a) {
	  for (var b = [], c = 0; c < a.length; c++) {
	    b[c] = goog.string.escapeChar(a.charAt(c));
	  }
	  return b.join("");
	};
	goog.string.escapeChar = function(a) {
	  if (a in goog.string.jsEscapeCache_) {
	    return goog.string.jsEscapeCache_[a];
	  }
	  if (a in goog.string.specialEscapeChars_) {
	    return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
	  }
	  var b = a.charCodeAt(0);
	  if (31 < b && 127 > b) {
	    var c = a;
	  } else {
	    if (256 > b) {
	      if (c = "\\x", 16 > b || 256 < b) {
	        c += "0";
	      }
	    } else {
	      c = "\\u", 4096 > b && (c += "0");
	    }
	    c += b.toString(16).toUpperCase();
	  }
	  return goog.string.jsEscapeCache_[a] = c;
	};
	goog.string.contains = function(a, b) {
	  return -1 != a.indexOf(b);
	};
	goog.string.caseInsensitiveContains = function(a, b) {
	  return goog.string.contains(a.toLowerCase(), b.toLowerCase());
	};
	goog.string.countOf = function(a, b) {
	  return a && b ? a.split(b).length - 1 : 0;
	};
	goog.string.removeAt = function(a, b, c) {
	  var d = a;
	  0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
	  return d;
	};
	goog.string.remove = function(a, b) {
	  return a.replace(b, "");
	};
	goog.string.removeAll = function(a, b) {
	  var c = new RegExp(goog.string.regExpEscape(b), "g");
	  return a.replace(c, "");
	};
	goog.string.replaceAll = function(a, b, c) {
	  b = new RegExp(goog.string.regExpEscape(b), "g");
	  return a.replace(b, c.replace(/\$/g, "$$$$"));
	};
	goog.string.regExpEscape = function(a) {
	  return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
	};
	goog.string.repeat = String.prototype.repeat ? function(a, b) {
	  return a.repeat(b);
	} : function(a, b) {
	  return Array(b + 1).join(a);
	};
	goog.string.padNumber = function(a, b, c) {
	  a = goog.isDef(c) ? a.toFixed(c) : String(a);
	  c = a.indexOf(".");
	  -1 == c && (c = a.length);
	  return goog.string.repeat("0", Math.max(0, b - c)) + a;
	};
	goog.string.makeSafe = function(a) {
	  return null == a ? "" : String(a);
	};
	goog.string.buildString = function(a) {
	  return Array.prototype.join.call(arguments, "");
	};
	goog.string.getRandomString = function() {
	  return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
	};
	goog.string.compareVersions = function(a, b) {
	  for (var c = 0, d = goog.string.trim(String(a)).split("."), e = goog.string.trim(String(b)).split("."), f = Math.max(d.length, e.length), g = 0; 0 == c && g < f; g++) {
	    var h = d[g] || "", k = e[g] || "";
	    do {
	      h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];
	      k = /(\d*)(\D*)(.*)/.exec(k) || ["", "", "", ""];
	      if (0 == h[0].length && 0 == k[0].length) {
	        break;
	      }
	      c = 0 == h[1].length ? 0 : parseInt(h[1], 10);
	      var l = 0 == k[1].length ? 0 : parseInt(k[1], 10);
	      c = goog.string.compareElements_(c, l) || goog.string.compareElements_(0 == h[2].length, 0 == k[2].length) || goog.string.compareElements_(h[2], k[2]);
	      h = h[3];
	      k = k[3];
	    } while (0 == c);
	  }
	  return c;
	};
	goog.string.compareElements_ = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : 0;
	};
	goog.string.hashCode = function(a) {
	  for (var b = 0, c = 0; c < a.length; ++c) {
	    b = 31 * b + a.charCodeAt(c) >>> 0;
	  }
	  return b;
	};
	goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
	goog.string.createUniqueString = function() {
	  return "goog_" + goog.string.uniqueStringCounter_++;
	};
	goog.string.toNumber = function(a) {
	  var b = Number(a);
	  return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
	};
	goog.string.isLowerCamelCase = function(a) {
	  return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
	};
	goog.string.isUpperCamelCase = function(a) {
	  return /^([A-Z][a-z]*)+$/.test(a);
	};
	goog.string.toCamelCase = function(a) {
	  return String(a).replace(/\-([a-z])/g, function(a, c) {
	    return c.toUpperCase();
	  });
	};
	goog.string.toSelectorCase = function(a) {
	  return String(a).replace(/([A-Z])/g, "-$1").toLowerCase();
	};
	goog.string.toTitleCase = function(a, b) {
	  var c = goog.isString(b) ? goog.string.regExpEscape(b) : "\\s";
	  return a.replace(new RegExp("(^" + (c ? "|[" + c + "]+" : "") + ")([a-z])", "g"), function(a, b, c) {
	    return b + c.toUpperCase();
	  });
	};
	goog.string.capitalize = function(a) {
	  return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
	};
	goog.string.parseInt = function(a) {
	  isFinite(a) && (a = String(a));
	  return goog.isString(a) ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
	};
	goog.string.splitLimit = function(a, b, c) {
	  a = a.split(b);
	  for (var d = []; 0 < c && a.length;) {
	    d.push(a.shift()), c--;
	  }
	  a.length && d.push(a.join(b));
	  return d;
	};
	goog.string.lastComponent = function(a, b) {
	  if (b) {
	    "string" == typeof b && (b = [b]);
	  } else {
	    return a;
	  }
	  for (var c = -1, d = 0; d < b.length; d++) {
	    if ("" != b[d]) {
	      var e = a.lastIndexOf(b[d]);
	      e > c && (c = e);
	    }
	  }
	  return -1 == c ? a : a.slice(c + 1);
	};
	goog.string.editDistance = function(a, b) {
	  var c = [], d = [];
	  if (a == b) {
	    return 0;
	  }
	  if (!a.length || !b.length) {
	    return Math.max(a.length, b.length);
	  }
	  for (var e = 0; e < b.length + 1; e++) {
	    c[e] = e;
	  }
	  for (e = 0; e < a.length; e++) {
	    d[0] = e + 1;
	    for (var f = 0; f < b.length; f++) {
	      d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
	    }
	    for (f = 0; f < c.length; f++) {
	      c[f] = d[f];
	    }
	  }
	  return d[b.length];
	};
	goog.proto2 = {};
	goog.proto2.FieldDescriptor = function(a, b, c) {
	  this.parent_ = a;
	  goog.asserts.assert(goog.string.isNumeric(b));
	  this.tag_ = b;
	  this.name_ = c.name;
	  this.isPacked_ = !!c.packed;
	  this.isRepeated_ = !!c.repeated;
	  this.isRequired_ = !!c.required;
	  this.fieldType_ = c.fieldType;
	  this.nativeType_ = c.type;
	  this.deserializationConversionPermitted_ = !1;
	  switch(this.fieldType_) {
	    case goog.proto2.FieldDescriptor.FieldType.INT64:
	    case goog.proto2.FieldDescriptor.FieldType.UINT64:
	    case goog.proto2.FieldDescriptor.FieldType.FIXED64:
	    case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
	    case goog.proto2.FieldDescriptor.FieldType.SINT64:
	    case goog.proto2.FieldDescriptor.FieldType.FLOAT:
	    case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
	      this.deserializationConversionPermitted_ = !0;
	  }
	  this.defaultValue_ = c.defaultValue;
	};
	goog.proto2.FieldDescriptor.FieldType = {DOUBLE:1, FLOAT:2, INT64:3, UINT64:4, INT32:5, FIXED64:6, FIXED32:7, BOOL:8, STRING:9, GROUP:10, MESSAGE:11, BYTES:12, UINT32:13, ENUM:14, SFIXED32:15, SFIXED64:16, SINT32:17, SINT64:18};
	goog.proto2.FieldDescriptor.prototype.getTag = function() {
	  return this.tag_;
	};
	goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
	  return this.parent_.prototype.getDescriptor();
	};
	goog.proto2.FieldDescriptor.prototype.getName = function() {
	  return this.name_;
	};
	goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
	  if (void 0 === this.defaultValue_) {
	    var a = this.nativeType_;
	    if (a === Boolean) {
	      this.defaultValue_ = !1;
	    } else {
	      if (a === Number) {
	        this.defaultValue_ = 0;
	      } else {
	        if (a === String) {
	          this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
	        } else {
	          return new a;
	        }
	      }
	    }
	  }
	  return this.defaultValue_;
	};
	goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
	  return this.fieldType_;
	};
	goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
	  return this.nativeType_;
	};
	goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
	  return this.deserializationConversionPermitted_;
	};
	goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
	  return this.nativeType_.prototype.getDescriptor();
	};
	goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
	  return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
	};
	goog.proto2.FieldDescriptor.prototype.isPacked = function() {
	  return this.isPacked_;
	};
	goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
	  return this.isRepeated_;
	};
	goog.proto2.FieldDescriptor.prototype.isRequired = function() {
	  return this.isRequired_;
	};
	goog.proto2.FieldDescriptor.prototype.isOptional = function() {
	  return !this.isRepeated_ && !this.isRequired_;
	};
	goog.proto2.Descriptor = function(a, b, c) {
	  this.messageType_ = a;
	  this.name_ = b.name || null;
	  this.fullName_ = b.fullName || null;
	  this.containingType_ = b.containingType;
	  this.fields_ = {};
	  for (a = 0; a < c.length; a++) {
	    b = c[a], this.fields_[b.getTag()] = b;
	  }
	};
	goog.proto2.Descriptor.prototype.getName = function() {
	  return this.name_;
	};
	goog.proto2.Descriptor.prototype.getFullName = function() {
	  return this.fullName_;
	};
	goog.proto2.Descriptor.prototype.getContainingType = function() {
	  return this.containingType_ ? this.containingType_.getDescriptor() : null;
	};
	goog.proto2.Descriptor.prototype.getFields = function() {
	  var a = goog.object.getValues(this.fields_);
	  goog.array.sort(a, function(a, c) {
	    return a.getTag() - c.getTag();
	  });
	  return a;
	};
	goog.proto2.Descriptor.prototype.getFieldsMap = function() {
	  return this.fields_;
	};
	goog.proto2.Descriptor.prototype.findFieldByName = function(a) {
	  return goog.object.findValue(this.fields_, function(b, c, d) {
	    return b.getName() == a;
	  }) || null;
	};
	goog.proto2.Descriptor.prototype.findFieldByTag = function(a) {
	  goog.asserts.assert(goog.string.isNumeric(a));
	  return this.fields_[parseInt(a, 10)] || null;
	};
	goog.proto2.Descriptor.prototype.createMessageInstance = function() {
	  return new this.messageType_;
	};
	goog.proto2.Message = function() {
	  this.values_ = {};
	  this.fields_ = this.getDescriptor().getFieldsMap();
	  this.deserializedFields_ = this.lazyDeserializer_ = null;
	};
	goog.proto2.Message.FieldType = {DOUBLE:1, FLOAT:2, INT64:3, UINT64:4, INT32:5, FIXED64:6, FIXED32:7, BOOL:8, STRING:9, GROUP:10, MESSAGE:11, BYTES:12, UINT32:13, ENUM:14, SFIXED32:15, SFIXED64:16, SINT32:17, SINT64:18};
	goog.proto2.Message.prototype.initializeForLazyDeserializer = function(a, b) {
	  this.lazyDeserializer_ = a;
	  this.values_ = b;
	  this.deserializedFields_ = {};
	};
	goog.proto2.Message.prototype.setUnknown = function(a, b) {
	  goog.asserts.assert(!this.fields_[a], "Field is not unknown in this message");
	  goog.asserts.assert(1 <= a, "Tag " + a + ' has value "' + b + '" in descriptor ' + this.getDescriptor().getName());
	  goog.asserts.assert(null !== b, "Value cannot be null");
	  this.values_[a] = b;
	  this.deserializedFields_ && delete this.deserializedFields_[a];
	};
	goog.proto2.Message.prototype.forEachUnknown = function(a, b) {
	  var c = b || this, d;
	  for (d in this.values_) {
	    var e = Number(d);
	    this.fields_[e] || a.call(c, e, this.values_[d]);
	  }
	};
	goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod;
	goog.proto2.Message.prototype.has = function(a) {
	  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
	  return this.has$Value(a.getTag());
	};
	goog.proto2.Message.prototype.arrayOf = function(a) {
	  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
	  return this.array$Values(a.getTag());
	};
	goog.proto2.Message.prototype.countOf = function(a) {
	  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
	  return this.count$Values(a.getTag());
	};
	goog.proto2.Message.prototype.get = function(a, b) {
	  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
	  return this.get$Value(a.getTag(), b);
	};
	goog.proto2.Message.prototype.getOrDefault = function(a, b) {
	  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
	  return this.get$ValueOrDefault(a.getTag(), b);
	};
	goog.proto2.Message.prototype.set = function(a, b) {
	  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
	  this.set$Value(a.getTag(), b);
	};
	goog.proto2.Message.prototype.add = function(a, b) {
	  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
	  this.add$Value(a.getTag(), b);
	};
	goog.proto2.Message.prototype.clear = function(a) {
	  goog.asserts.assert(a.getContainingType() == this.getDescriptor(), "The current message does not contain the given field");
	  this.clear$Field(a.getTag());
	};
	goog.proto2.Message.prototype.equals = function(a) {
	  if (!a || this.constructor != a.constructor) {
	    return !1;
	  }
	  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
	    var d = b[c], e = d.getTag();
	    if (this.has$Value(e) != a.has$Value(e)) {
	      return !1;
	    }
	    if (this.has$Value(e)) {
	      var f = d.isCompositeType(), g = this.getValueForTag_(e);
	      e = a.getValueForTag_(e);
	      if (d.isRepeated()) {
	        if (g.length != e.length) {
	          return !1;
	        }
	        for (d = 0; d < g.length; d++) {
	          var h = g[d], k = e[d];
	          if (f ? !h.equals(k) : h != k) {
	            return !1;
	          }
	        }
	      } else {
	        if (f ? !g.equals(e) : g != e) {
	          return !1;
	        }
	      }
	    }
	  }
	  return !0;
	};
	goog.proto2.Message.prototype.copyFrom = function(a) {
	  goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
	  this != a && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(a));
	};
	goog.proto2.Message.prototype.mergeFrom = function(a) {
	  goog.asserts.assert(this.constructor == a.constructor, "The source message must have the same type.");
	  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
	    var d = b[c], e = d.getTag();
	    if (a.has$Value(e)) {
	      this.deserializedFields_ && delete this.deserializedFields_[d.getTag()];
	      var f = d.isCompositeType();
	      if (d.isRepeated()) {
	        d = a.array$Values(e);
	        for (var g = 0; g < d.length; g++) {
	          this.add$Value(e, f ? d[g].clone() : d[g]);
	        }
	      } else {
	        d = a.getValueForTag_(e), f ? (f = this.getValueForTag_(e)) ? f.mergeFrom(d) : this.set$Value(e, d.clone()) : this.set$Value(e, d);
	      }
	    }
	  }
	};
	goog.proto2.Message.prototype.clone = function() {
	  var a = new this.constructor;
	  a.copyFrom(this);
	  return a;
	};
	goog.proto2.Message.prototype.initDefaults = function(a) {
	  for (var b = this.getDescriptor().getFields(), c = 0; c < b.length; c++) {
	    var d = b[c], e = d.getTag(), f = d.isCompositeType();
	    this.has$Value(e) || d.isRepeated() || (f ? this.values_[e] = new (d.getNativeType()) : a && (this.values_[e] = d.getDefaultValue()));
	    if (f) {
	      if (d.isRepeated()) {
	        for (d = this.array$Values(e), e = 0; e < d.length; e++) {
	          d[e].initDefaults(a);
	        }
	      } else {
	        this.get$Value(e).initDefaults(a);
	      }
	    }
	  }
	};
	goog.proto2.Message.prototype.has$Value = function(a) {
	  return null != this.values_[a];
	};
	goog.proto2.Message.prototype.getValueForTag_ = function(a) {
	  var b = this.values_[a];
	  return goog.isDefAndNotNull(b) ? this.lazyDeserializer_ ? a in this.deserializedFields_ ? this.deserializedFields_[a] : (b = this.lazyDeserializer_.deserializeField(this, this.fields_[a], b), this.deserializedFields_[a] = b) : b : null;
	};
	goog.proto2.Message.prototype.get$Value = function(a, b) {
	  var c = this.getValueForTag_(a);
	  if (this.fields_[a].isRepeated()) {
	    var d = b || 0;
	    goog.asserts.assert(0 <= d && d < c.length, "Given index %s is out of bounds.  Repeated field length: %s", d, c.length);
	    return c[d];
	  }
	  return c;
	};
	goog.proto2.Message.prototype.get$ValueOrDefault = function(a, b) {
	  return this.has$Value(a) ? this.get$Value(a, b) : this.fields_[a].getDefaultValue();
	};
	goog.proto2.Message.prototype.array$Values = function(a) {
	  return this.getValueForTag_(a) || [];
	};
	goog.proto2.Message.prototype.count$Values = function(a) {
	  return this.fields_[a].isRepeated() ? this.has$Value(a) ? this.values_[a].length : 0 : this.has$Value(a) ? 1 : 0;
	};
	goog.proto2.Message.prototype.set$Value = function(a, b) {
	  goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
	  this.values_[a] = b;
	  this.deserializedFields_ && (this.deserializedFields_[a] = b);
	};
	goog.proto2.Message.prototype.add$Value = function(a, b) {
	  goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[a], b);
	  this.values_[a] || (this.values_[a] = []);
	  this.values_[a].push(b);
	  this.deserializedFields_ && delete this.deserializedFields_[a];
	};
	goog.proto2.Message.prototype.checkFieldType_ = function(a, b) {
	  a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(b) : goog.asserts.assert(Object(b).constructor == a.getNativeType());
	};
	goog.proto2.Message.prototype.clear$Field = function(a) {
	  delete this.values_[a];
	  this.deserializedFields_ && delete this.deserializedFields_[a];
	};
	goog.proto2.Message.createDescriptor = function(a, b) {
	  var c = [], d = b[0], e;
	  for (e in b) {
	    0 != e && c.push(new goog.proto2.FieldDescriptor(a, e, b[e]));
	  }
	  return new goog.proto2.Descriptor(a, d, c);
	};
	goog.proto2.Serializer = function() {
	};
	goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1;
	goog.proto2.Serializer.prototype.serialize = goog.abstractMethod;
	goog.proto2.Serializer.prototype.getSerializedValue = function(a, b) {
	  return a.isCompositeType() ? this.serialize(b) : goog.isNumber(b) && !isFinite(b) ? b.toString() : b;
	};
	goog.proto2.Serializer.prototype.deserialize = function(a, b) {
	  var c = a.createMessageInstance();
	  this.deserializeTo(c, b);
	  goog.asserts.assert(c instanceof goog.proto2.Message);
	  return c;
	};
	goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod;
	goog.proto2.Serializer.prototype.getDeserializedValue = function(a, b) {
	  if (a.isCompositeType()) {
	    return b instanceof goog.proto2.Message ? b : this.deserialize(a.getFieldMessageType(), b);
	  }
	  if (a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) {
	    if (goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && goog.isString(b)) {
	      var c = a.getNativeType();
	      if (c.hasOwnProperty(b)) {
	        return c[b];
	      }
	    }
	    return goog.isString(b) && goog.proto2.Serializer.INTEGER_REGEX.test(b) && (c = Number(b), 0 < c) ? c : b;
	  }
	  if (!a.deserializationConversionPermitted()) {
	    return b;
	  }
	  c = a.getNativeType();
	  if (c === String) {
	    if (goog.isNumber(b)) {
	      return String(b);
	    }
	  } else {
	    if (c === Number && goog.isString(b) && ("Infinity" === b || "-Infinity" === b || "NaN" === b || goog.proto2.Serializer.INTEGER_REGEX.test(b))) {
	      return Number(b);
	    }
	  }
	  return b;
	};
	goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/;
	goog.proto2.LazyDeserializer = function() {
	};
	goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer);
	goog.proto2.LazyDeserializer.prototype.deserialize = function(a, b) {
	  var c = a.createMessageInstance();
	  c.initializeForLazyDeserializer(this, b);
	  goog.asserts.assert(c instanceof goog.proto2.Message);
	  return c;
	};
	goog.proto2.LazyDeserializer.prototype.deserializeTo = function(a, b) {
	  throw Error("Unimplemented");
	};
	goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod;
	goog.proto2.PbLiteSerializer = function() {
	};
	goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer);
	goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1;
	goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(a) {
	  this.zeroIndexing_ = a;
	};
	goog.proto2.PbLiteSerializer.prototype.serialize = function(a) {
	  for (var b = a.getDescriptor().getFields(), c = [], d = this.zeroIndexing_, e = 0; e < b.length; e++) {
	    var f = b[e];
	    if (a.has(f)) {
	      var g = f.getTag();
	      g = d ? g - 1 : g;
	      if (f.isRepeated()) {
	        c[g] = [];
	        for (var h = 0; h < a.countOf(f); h++) {
	          c[g][h] = this.getSerializedValue(f, a.get(f, h));
	        }
	      } else {
	        c[g] = this.getSerializedValue(f, a.get(f));
	      }
	    }
	  }
	  a.forEachUnknown(function(a, b) {
	    c[d ? a - 1 : a] = b;
	  });
	  return c;
	};
	goog.proto2.PbLiteSerializer.prototype.deserializeField = function(a, b, c) {
	  if (null == c) {
	    return c;
	  }
	  if (b.isRepeated()) {
	    a = [];
	    goog.asserts.assert(goog.isArray(c), "Value must be array: %s", c);
	    for (var d = 0; d < c.length; d++) {
	      a[d] = this.getDeserializedValue(b, c[d]);
	    }
	    return a;
	  }
	  return this.getDeserializedValue(b, c);
	};
	goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(a, b) {
	  return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? b ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
	};
	goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(a, b) {
	  return a.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert(goog.isNumber(b) || goog.isBoolean(b), "Value is expected to be a number or boolean"), !!b) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
	};
	goog.proto2.PbLiteSerializer.prototype.deserialize = function(a, b) {
	  var c = b;
	  if (this.zeroIndexing_) {
	    c = [];
	    for (var d in b) {
	      c[parseInt(d, 10) + 1] = b[d];
	    }
	  }
	  return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, a, c);
	};
	/*
	
	 Protocol Buffer 2 Copyright 2008 Google Inc.
	 All other code copyright its respective owners.
	 Copyright (C) 2010 The Libphonenumber Authors
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	var i18n = {phonenumbers:{}};
	i18n.phonenumbers.NumberFormat = function() {
	  goog.proto2.Message.call(this);
	};
	goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message);
	i18n.phonenumbers.NumberFormat.descriptor_ = null;
	i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
	  return this.get$Value(1);
	};
	i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
	  return this.get$ValueOrDefault(1);
	};
	i18n.phonenumbers.NumberFormat.prototype.setPattern = function(a) {
	  this.set$Value(1, a);
	};
	i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
	  return this.has$Value(1);
	};
	i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
	  return this.count$Values(1);
	};
	i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
	  this.clear$Field(1);
	};
	i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
	  return this.get$Value(2);
	};
	i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
	  return this.get$ValueOrDefault(2);
	};
	i18n.phonenumbers.NumberFormat.prototype.setFormat = function(a) {
	  this.set$Value(2, a);
	};
	i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
	  return this.has$Value(2);
	};
	i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
	  return this.count$Values(2);
	};
	i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
	  this.clear$Field(2);
	};
	i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(a) {
	  return this.get$Value(3, a);
	};
	i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(a) {
	  return this.get$ValueOrDefault(3, a);
	};
	i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(a) {
	  this.add$Value(3, a);
	};
	i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
	  return this.array$Values(3);
	};
	i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
	  return this.has$Value(3);
	};
	i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
	  return this.count$Values(3);
	};
	i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
	  this.clear$Field(3);
	};
	i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
	  return this.get$Value(4);
	};
	i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
	  return this.get$ValueOrDefault(4);
	};
	i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(a) {
	  this.set$Value(4, a);
	};
	i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
	  return this.has$Value(4);
	};
	i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
	  return this.count$Values(4);
	};
	i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
	  this.clear$Field(4);
	};
	i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
	  return this.get$Value(6);
	};
	i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
	  return this.get$ValueOrDefault(6);
	};
	i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(a) {
	  this.set$Value(6, a);
	};
	i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
	  return this.has$Value(6);
	};
	i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
	  return this.count$Values(6);
	};
	i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
	  this.clear$Field(6);
	};
	i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
	  return this.get$Value(5);
	};
	i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
	  return this.get$ValueOrDefault(5);
	};
	i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(a) {
	  this.set$Value(5, a);
	};
	i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
	  return this.has$Value(5);
	};
	i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
	  return this.count$Values(5);
	};
	i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
	  this.clear$Field(5);
	};
	i18n.phonenumbers.PhoneNumberDesc = function() {
	  goog.proto2.Message.call(this);
	};
	goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message);
	i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null;
	i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
	  return this.get$Value(2);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
	  return this.get$ValueOrDefault(2);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(a) {
	  this.set$Value(2, a);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
	  return this.has$Value(2);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
	  return this.count$Values(2);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
	  this.clear$Field(2);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(a) {
	  return this.get$Value(9, a);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(a) {
	  return this.get$ValueOrDefault(9, a);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(a) {
	  this.add$Value(9, a);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
	  return this.array$Values(9);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
	  return this.has$Value(9);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
	  return this.count$Values(9);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
	  this.clear$Field(9);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(a) {
	  return this.get$Value(10, a);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(a) {
	  return this.get$ValueOrDefault(10, a);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(a) {
	  this.add$Value(10, a);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
	  return this.array$Values(10);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
	  return this.has$Value(10);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
	  return this.count$Values(10);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
	  this.clear$Field(10);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
	  return this.get$Value(6);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
	  return this.get$ValueOrDefault(6);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(a) {
	  this.set$Value(6, a);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
	  return this.has$Value(6);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
	  return this.count$Values(6);
	};
	i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
	  this.clear$Field(6);
	};
	i18n.phonenumbers.PhoneMetadata = function() {
	  goog.proto2.Message.call(this);
	};
	goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message);
	i18n.phonenumbers.PhoneMetadata.descriptor_ = null;
	i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
	  return this.get$Value(1);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
	  return this.get$ValueOrDefault(1);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(a) {
	  this.set$Value(1, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
	  return this.has$Value(1);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
	  return this.count$Values(1);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
	  this.clear$Field(1);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
	  return this.get$Value(2);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
	  return this.get$ValueOrDefault(2);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(a) {
	  this.set$Value(2, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
	  return this.has$Value(2);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
	  return this.count$Values(2);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
	  this.clear$Field(2);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
	  return this.get$Value(3);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
	  return this.get$ValueOrDefault(3);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(a) {
	  this.set$Value(3, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
	  return this.has$Value(3);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
	  return this.count$Values(3);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
	  this.clear$Field(3);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
	  return this.get$Value(4);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
	  return this.get$ValueOrDefault(4);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(a) {
	  this.set$Value(4, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
	  return this.has$Value(4);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
	  return this.count$Values(4);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
	  this.clear$Field(4);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
	  return this.get$Value(5);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
	  return this.get$ValueOrDefault(5);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(a) {
	  this.set$Value(5, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
	  return this.has$Value(5);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
	  return this.count$Values(5);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
	  this.clear$Field(5);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
	  return this.get$Value(6);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
	  return this.get$ValueOrDefault(6);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(a) {
	  this.set$Value(6, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
	  return this.has$Value(6);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
	  return this.count$Values(6);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
	  this.clear$Field(6);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
	  return this.get$Value(7);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
	  return this.get$ValueOrDefault(7);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(a) {
	  this.set$Value(7, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
	  return this.has$Value(7);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
	  return this.count$Values(7);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
	  this.clear$Field(7);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
	  return this.get$Value(8);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
	  return this.get$ValueOrDefault(8);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(a) {
	  this.set$Value(8, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
	  return this.has$Value(8);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
	  return this.count$Values(8);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
	  this.clear$Field(8);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
	  return this.get$Value(21);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
	  return this.get$ValueOrDefault(21);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(a) {
	  this.set$Value(21, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
	  return this.has$Value(21);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
	  return this.count$Values(21);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
	  this.clear$Field(21);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
	  return this.get$Value(25);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
	  return this.get$ValueOrDefault(25);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(a) {
	  this.set$Value(25, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
	  return this.has$Value(25);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
	  return this.count$Values(25);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
	  this.clear$Field(25);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
	  return this.get$Value(27);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
	  return this.get$ValueOrDefault(27);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(a) {
	  this.set$Value(27, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
	  return this.has$Value(27);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
	  return this.count$Values(27);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
	  this.clear$Field(27);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
	  return this.get$Value(28);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
	  return this.get$ValueOrDefault(28);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(a) {
	  this.set$Value(28, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
	  return this.has$Value(28);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
	  return this.count$Values(28);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
	  this.clear$Field(28);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
	  return this.get$Value(24);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
	  return this.get$ValueOrDefault(24);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(a) {
	  this.set$Value(24, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
	  return this.has$Value(24);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
	  return this.count$Values(24);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
	  this.clear$Field(24);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
	  return this.get$Value(9);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
	  return this.get$ValueOrDefault(9);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setId = function(a) {
	  this.set$Value(9, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
	  return this.has$Value(9);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
	  return this.count$Values(9);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
	  this.clear$Field(9);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
	  return this.get$Value(10);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
	  return this.get$ValueOrDefault(10);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(a) {
	  this.set$Value(10, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
	  return this.has$Value(10);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
	  return this.count$Values(10);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
	  this.clear$Field(10);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
	  return this.get$Value(11);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
	  return this.get$ValueOrDefault(11);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(a) {
	  this.set$Value(11, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
	  return this.has$Value(11);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
	  return this.count$Values(11);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
	  this.clear$Field(11);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
	  return this.get$Value(17);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
	  return this.get$ValueOrDefault(17);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(a) {
	  this.set$Value(17, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
	  return this.has$Value(17);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
	  return this.count$Values(17);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
	  this.clear$Field(17);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
	  return this.get$Value(12);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
	  return this.get$ValueOrDefault(12);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(a) {
	  this.set$Value(12, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
	  return this.has$Value(12);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
	  return this.count$Values(12);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
	  this.clear$Field(12);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
	  return this.get$Value(13);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
	  return this.get$ValueOrDefault(13);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(a) {
	  this.set$Value(13, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
	  return this.has$Value(13);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
	  return this.count$Values(13);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
	  this.clear$Field(13);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
	  return this.get$Value(15);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
	  return this.get$ValueOrDefault(15);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(a) {
	  this.set$Value(15, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
	  return this.has$Value(15);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
	  return this.count$Values(15);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
	  this.clear$Field(15);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
	  return this.get$Value(16);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
	  return this.get$ValueOrDefault(16);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(a) {
	  this.set$Value(16, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
	  return this.has$Value(16);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
	  return this.count$Values(16);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
	  this.clear$Field(16);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
	  return this.get$Value(18);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
	  return this.get$ValueOrDefault(18);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(a) {
	  this.set$Value(18, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
	  return this.has$Value(18);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
	  return this.count$Values(18);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
	  this.clear$Field(18);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(a) {
	  return this.get$Value(19, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(a) {
	  return this.get$ValueOrDefault(19, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(a) {
	  this.add$Value(19, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
	  return this.array$Values(19);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
	  return this.has$Value(19);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
	  return this.count$Values(19);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
	  this.clear$Field(19);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(a) {
	  return this.get$Value(20, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(a) {
	  return this.get$ValueOrDefault(20, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(a) {
	  this.add$Value(20, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
	  return this.array$Values(20);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
	  return this.has$Value(20);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
	  return this.count$Values(20);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
	  this.clear$Field(20);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
	  return this.get$Value(22);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
	  return this.get$ValueOrDefault(22);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(a) {
	  this.set$Value(22, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
	  return this.has$Value(22);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
	  return this.count$Values(22);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
	  this.clear$Field(22);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
	  return this.get$Value(23);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
	  return this.get$ValueOrDefault(23);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(a) {
	  this.set$Value(23, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
	  return this.has$Value(23);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
	  return this.count$Values(23);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
	  this.clear$Field(23);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossible = function() {
	  return this.get$Value(26);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.getLeadingZeroPossibleOrDefault = function() {
	  return this.get$ValueOrDefault(26);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.setLeadingZeroPossible = function(a) {
	  this.set$Value(26, a);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingZeroPossible = function() {
	  return this.has$Value(26);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.leadingZeroPossibleCount = function() {
	  return this.count$Values(26);
	};
	i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingZeroPossible = function() {
	  this.clear$Field(26);
	};
	i18n.phonenumbers.PhoneMetadataCollection = function() {
	  goog.proto2.Message.call(this);
	};
	goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message);
	i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null;
	i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(a) {
	  return this.get$Value(1, a);
	};
	i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(a) {
	  return this.get$ValueOrDefault(1, a);
	};
	i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(a) {
	  this.add$Value(1, a);
	};
	i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
	  return this.array$Values(1);
	};
	i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
	  return this.has$Value(1);
	};
	i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
	  return this.count$Values(1);
	};
	i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
	  this.clear$Field(1);
	};
	i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
	  var a = i18n.phonenumbers.NumberFormat.descriptor_;
	  a || (i18n.phonenumbers.NumberFormat.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, {0:{name:"NumberFormat", fullName:"i18n.phonenumbers.NumberFormat"}, 1:{name:"pattern", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 2:{name:"format", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 3:{name:"leading_digits_pattern", repeated:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 4:{name:"national_prefix_formatting_rule", 
	  fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 6:{name:"national_prefix_optional_when_formatting", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 5:{name:"domestic_carrier_code_formatting_rule", fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
	  return a;
	};
	i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor;
	i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
	  var a = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
	  a || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {0:{name:"PhoneNumberDesc", fullName:"i18n.phonenumbers.PhoneNumberDesc"}, 2:{name:"national_number_pattern", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 9:{name:"possible_length", repeated:!0, fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 10:{name:"possible_length_local_only", repeated:!0, fieldType:goog.proto2.Message.FieldType.INT32, 
	  type:Number}, 6:{name:"example_number", fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
	  return a;
	};
	i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor;
	i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
	  var a = i18n.phonenumbers.PhoneMetadata.descriptor_;
	  a || (i18n.phonenumbers.PhoneMetadata.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {0:{name:"PhoneMetadata", fullName:"i18n.phonenumbers.PhoneMetadata"}, 1:{name:"general_desc", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 2:{name:"fixed_line", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 3:{name:"mobile", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 
	  4:{name:"toll_free", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 5:{name:"premium_rate", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 6:{name:"shared_cost", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 7:{name:"personal_number", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 8:{name:"voip", fieldType:goog.proto2.Message.FieldType.MESSAGE, 
	  type:i18n.phonenumbers.PhoneNumberDesc}, 21:{name:"pager", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 25:{name:"uan", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 27:{name:"emergency", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 28:{name:"voicemail", fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 24:{name:"no_international_dialling", 
	  fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneNumberDesc}, 9:{name:"id", required:!0, fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 10:{name:"country_code", fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 11:{name:"international_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 17:{name:"preferred_international_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 12:{name:"national_prefix", fieldType:goog.proto2.Message.FieldType.STRING, 
	  type:String}, 13:{name:"preferred_extn_prefix", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 15:{name:"national_prefix_for_parsing", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 16:{name:"national_prefix_transform_rule", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 18:{name:"same_mobile_and_fixed_line_pattern", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 19:{name:"number_format", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, 
	  type:i18n.phonenumbers.NumberFormat}, 20:{name:"intl_number_format", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.NumberFormat}, 22:{name:"main_country_for_code", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}, 23:{name:"leading_digits", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 26:{name:"leading_zero_possible", fieldType:goog.proto2.Message.FieldType.BOOL, defaultValue:!1, type:Boolean}}));
	  return a;
	};
	i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor;
	i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
	  var a = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
	  a || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, {0:{name:"PhoneMetadataCollection", fullName:"i18n.phonenumbers.PhoneMetadataCollection"}, 1:{name:"metadata", repeated:!0, fieldType:goog.proto2.Message.FieldType.MESSAGE, type:i18n.phonenumbers.PhoneMetadata}}));
	  return a;
	};
	i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor;
	i18n.phonenumbers.PhoneNumber = function() {
	  goog.proto2.Message.call(this);
	};
	goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message);
	i18n.phonenumbers.PhoneNumber.descriptor_ = null;
	i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
	  return this.get$Value(1);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
	  return this.get$ValueOrDefault(1);
	};
	i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(a) {
	  this.set$Value(1, a);
	};
	i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
	  return this.has$Value(1);
	};
	i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
	  return this.count$Values(1);
	};
	i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
	  this.clear$Field(1);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
	  return this.get$Value(2);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
	  return this.get$ValueOrDefault(2);
	};
	i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(a) {
	  this.set$Value(2, a);
	};
	i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
	  return this.has$Value(2);
	};
	i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
	  return this.count$Values(2);
	};
	i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
	  this.clear$Field(2);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
	  return this.get$Value(3);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
	  return this.get$ValueOrDefault(3);
	};
	i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(a) {
	  this.set$Value(3, a);
	};
	i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
	  return this.has$Value(3);
	};
	i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
	  return this.count$Values(3);
	};
	i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
	  this.clear$Field(3);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
	  return this.get$Value(4);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
	  return this.get$ValueOrDefault(4);
	};
	i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(a) {
	  this.set$Value(4, a);
	};
	i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
	  return this.has$Value(4);
	};
	i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
	  return this.count$Values(4);
	};
	i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
	  this.clear$Field(4);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
	  return this.get$Value(8);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
	  return this.get$ValueOrDefault(8);
	};
	i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(a) {
	  this.set$Value(8, a);
	};
	i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
	  return this.has$Value(8);
	};
	i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
	  return this.count$Values(8);
	};
	i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
	  this.clear$Field(8);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
	  return this.get$Value(5);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
	  return this.get$ValueOrDefault(5);
	};
	i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(a) {
	  this.set$Value(5, a);
	};
	i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
	  return this.has$Value(5);
	};
	i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
	  return this.count$Values(5);
	};
	i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
	  this.clear$Field(5);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
	  return this.get$Value(6);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
	  return this.get$ValueOrDefault(6);
	};
	i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(a) {
	  this.set$Value(6, a);
	};
	i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
	  return this.has$Value(6);
	};
	i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
	  return this.count$Values(6);
	};
	i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
	  this.clear$Field(6);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
	  return this.get$Value(7);
	};
	i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
	  return this.get$ValueOrDefault(7);
	};
	i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(a) {
	  this.set$Value(7, a);
	};
	i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
	  return this.has$Value(7);
	};
	i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
	  return this.count$Values(7);
	};
	i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
	  this.clear$Field(7);
	};
	i18n.phonenumbers.PhoneNumber.CountryCodeSource = {UNSPECIFIED:0, FROM_NUMBER_WITH_PLUS_SIGN:1, FROM_NUMBER_WITH_IDD:5, FROM_NUMBER_WITHOUT_PLUS_SIGN:10, FROM_DEFAULT_COUNTRY:20};
	i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
	  var a = i18n.phonenumbers.PhoneNumber.descriptor_;
	  a || (i18n.phonenumbers.PhoneNumber.descriptor_ = a = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {0:{name:"PhoneNumber", fullName:"i18n.phonenumbers.PhoneNumber"}, 1:{name:"country_code", required:!0, fieldType:goog.proto2.Message.FieldType.INT32, type:Number}, 2:{name:"national_number", required:!0, fieldType:goog.proto2.Message.FieldType.UINT64, type:Number}, 3:{name:"extension", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 4:{name:"italian_leading_zero", 
	  fieldType:goog.proto2.Message.FieldType.BOOL, type:Boolean}, 8:{name:"number_of_leading_zeros", fieldType:goog.proto2.Message.FieldType.INT32, defaultValue:1, type:Number}, 5:{name:"raw_input", fieldType:goog.proto2.Message.FieldType.STRING, type:String}, 6:{name:"country_code_source", fieldType:goog.proto2.Message.FieldType.ENUM, defaultValue:i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED, type:i18n.phonenumbers.PhoneNumber.CountryCodeSource}, 7:{name:"preferred_domestic_carrier_code", 
	  fieldType:goog.proto2.Message.FieldType.STRING, type:String}}));
	  return a;
	};
	i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber;
	i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor;
	/*
	
	 Copyright (C) 2010 The Libphonenumber Authors
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	i18n.phonenumbers.metadata = {};
	i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {1:"US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "), 7:["RU", "KZ"], 20:["EG"], 27:["ZA"], 30:["GR"], 31:["NL"], 32:["BE"], 33:["FR"], 34:["ES"], 36:["HU"], 39:["IT", "VA"], 40:["RO"], 41:["CH"], 43:["AT"], 44:["GB", "GG", "IM", "JE"], 45:["DK"], 46:["SE"], 47:["NO", "SJ"], 48:["PL"], 49:["DE"], 51:["PE"], 52:["MX"], 53:["CU"], 54:["AR"], 55:["BR"], 56:["CL"], 57:["CO"], 58:["VE"], 60:["MY"], 61:["AU", 
	"CC", "CX"], 62:["ID"], 63:["PH"], 64:["NZ"], 65:["SG"], 66:["TH"], 81:["JP"], 82:["KR"], 84:["VN"], 86:["CN"], 90:["TR"], 91:["IN"], 92:["PK"], 93:["AF"], 94:["LK"], 95:["MM"], 98:["IR"], 211:["SS"], 212:["MA", "EH"], 213:["DZ"], 216:["TN"], 218:["LY"], 220:["GM"], 221:["SN"], 222:["MR"], 223:["ML"], 224:["GN"], 225:["CI"], 226:["BF"], 227:["NE"], 228:["TG"], 229:["BJ"], 230:["MU"], 231:["LR"], 232:["SL"], 233:["GH"], 234:["NG"], 235:["TD"], 236:["CF"], 237:["CM"], 238:["CV"], 239:["ST"], 240:["GQ"], 
	241:["GA"], 242:["CG"], 243:["CD"], 244:["AO"], 245:["GW"], 246:["IO"], 247:["AC"], 248:["SC"], 249:["SD"], 250:["RW"], 251:["ET"], 252:["SO"], 253:["DJ"], 254:["KE"], 255:["TZ"], 256:["UG"], 257:["BI"], 258:["MZ"], 260:["ZM"], 261:["MG"], 262:["RE", "YT"], 263:["ZW"], 264:["NA"], 265:["MW"], 266:["LS"], 267:["BW"], 268:["SZ"], 269:["KM"], 290:["SH", "TA"], 291:["ER"], 297:["AW"], 298:["FO"], 299:["GL"], 350:["GI"], 351:["PT"], 352:["LU"], 353:["IE"], 354:["IS"], 355:["AL"], 356:["MT"], 357:["CY"], 
	358:["FI", "AX"], 359:["BG"], 370:["LT"], 371:["LV"], 372:["EE"], 373:["MD"], 374:["AM"], 375:["BY"], 376:["AD"], 377:["MC"], 378:["SM"], 380:["UA"], 381:["RS"], 382:["ME"], 385:["HR"], 386:["SI"], 387:["BA"], 389:["MK"], 420:["CZ"], 421:["SK"], 423:["LI"], 500:["FK"], 501:["BZ"], 502:["GT"], 503:["SV"], 504:["HN"], 505:["NI"], 506:["CR"], 507:["PA"], 508:["PM"], 509:["HT"], 590:["GP", "BL", "MF"], 591:["BO"], 592:["GY"], 593:["EC"], 594:["GF"], 595:["PY"], 596:["MQ"], 597:["SR"], 598:["UY"], 599:["CW", 
	"BQ"], 670:["TL"], 672:["NF"], 673:["BN"], 674:["NR"], 675:["PG"], 676:["TO"], 677:["SB"], 678:["VU"], 679:["FJ"], 680:["PW"], 681:["WF"], 682:["CK"], 683:["NU"], 685:["WS"], 686:["KI"], 687:["NC"], 688:["TV"], 689:["PF"], 690:["TK"], 691:["FM"], 692:["MH"], 800:["001"], 808:["001"], 850:["KP"], 852:["HK"], 853:["MO"], 855:["KH"], 856:["LA"], 870:["001"], 878:["001"], 880:["BD"], 881:["001"], 882:["001"], 883:["001"], 886:["TW"], 888:["001"], 960:["MV"], 961:["LB"], 962:["JO"], 963:["SY"], 964:["IQ"], 
	965:["KW"], 966:["SA"], 967:["YE"], 968:["OM"], 970:["PS"], 971:["AE"], 972:["IL"], 973:["BH"], 974:["QA"], 975:["BT"], 976:["MN"], 977:["NP"], 979:["001"], 992:["TJ"], 993:["TM"], 994:["AZ"], 995:["GE"], 996:["KG"], 998:["UZ"]};
	i18n.phonenumbers.metadata.countryToMetadata = {AC:[, [, , "[46]\\d{4}|[01589]\\d{5}", , , , , , , [5, 6]], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[01589]\\d{5}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]], AD:[, 
	[, , "[16]\\d{5,8}|[37-9]\\d{5}", , , , , , , [6, 8, 9]], [, , "[78]\\d{5}", , , , "712345", , , [6]], [, , "(?:3\\d|6(?:[0-8]|90\\d{2}))\\d{4}", , , , "312345", , , [6, 9]], [, , "180[02]\\d{4}", , , , "18001234", , , [8]], [, , "[19]\\d{5}", , , , "912345", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AD", 376, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[137-9]|6[0-8]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["180", "180[02]"]], [, "(\\d{3})(\\d{3})(\\d{3})", 
	"$1 $2 $3", ["690"]]], , [, , , , , , , , , [-1]], , , [, , "1800\\d{4}", , , , "18000000", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AE:[, [, , "[2-79]\\d{7,8}|800\\d{2,9}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]], [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]], [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]], [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"], [, , "900[02]\\d{5}", , , , "900234567", , , [9]], [, , "700[05]\\d{5}", , , , "700012345", , , 
	[9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AE", 971, "00", "0", , , "0", , , , [[, "([2-4679])(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-4679][2-8]"], "0$1"], [, "(5\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "([479]00)(\\d)(\\d{5})", "$1 $2 $3", ["[479]00"], "$1"], [, "([68]00)(\\d{2,9})", "$1 $2", ["[68]00"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "600[25]\\d{5}", , , , "600212345", , , [9]], , , [, , , , , , , , , [-1]]], AF:[, [, , "[2-7]\\d{8}", 
	, , , , , , [9], [7]], [, , "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}", , , , "234567890", , , , [7]], [, , "7(?:[014-9]\\d|2[89]|30)\\d{6}", , , , "701234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "([2-7]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , 
	[-1]]], AG:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}", , , , "2684601234", , , , [7]], [, , "268(?:464|7(?:1[3-9]|2\\d|3[246]|64|7[0-689]|8[02-68]))\\d{4}", , , , "2684641234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]], "AG", 
	1, "011", "1", , , "1", , , , , , [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]], , "268", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AI:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "2644(?:6[12]|9[78])\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|476|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, 
	, , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AL:[, [, , "[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}", , , , , , , [6, 7, 8, 9], [5]], [, , "(?:[2358](?:[16-9]\\d[2-9]|[2-5][2-9]\\d)|4(?:[2-57-9][2-9]\\d|6\\d{2}))\\d{4}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[689][2-9]|7[2-6])\\d{6}", 
	, , , "662123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "900[1-9]\\d{2}", , , , "900123", , , [6]], [, , "808[1-9]\\d{2}", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(4)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[0-6]"], "0$1"], [, "(6\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4[7-9]"], "0$1"], [, "(\\d{3})(\\d{3,5})", 
	"$1 $2", ["[235][16-9]|[79]|8[016-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AM:[, [, , "[1-9]\\d{7}", , , , , , , [8], [5, 6]], [, , "(?:1[0-2]\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2|47\\d)\\d{5}", , , , "10123456", , , , [5, 6]], [, , "(?:4[1349]|55|77|88|9[1-9])\\d{6}", , , , "77123456"], [, , "800\\d{5}", , , , "80012345"], [, , "90[016]\\d{5}", , , , "90012345"], [, , "80[1-4]\\d{5}", , 
	, , "80112345"], [, , , , , , , , , [-1]], [, , "60(?:2[078]|[3-7]\\d|8[0-5])\\d{4}", , , , "60271234"], "AM", 374, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["4[1349]|[5-7]|88|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23]"], "(0$1)"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8|90"], "0 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AO:[, [, 
	, "[29]\\d{8}", , , , , , , [9]], [, , "2\\d(?:[26-9]\\d|\\d[26-9])\\d{5}", , , , "222123456"], [, , "9[1-49]\\d{7}", , , , "923123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AO", 244, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AR:[, [, , "11\\d{8}|[2368]\\d{9}|9\\d{10}", 
	, , , , , , [10, 11], [6, 7, 8]], [, , "11\\d{8}|(?:2(?:2(?:[013]\\d|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[067]\\d)|4(?:7[3-8]|9\\d)|6(?:[01346]\\d|2[24-6]|5[15-8])|80\\d|9(?:[0124789]\\d|3[1-6]|5[234]|6[2-46]))|3(?:3(?:2[79]|6\\d|8[2578])|4(?:[78]\\d|0[0124-9]|[1-35]\\d|4[24-7]|6[02-9]|9[123678])|5(?:[138]\\d|2[1245]|4[1-9]|6[2-4]|7[1-6])|6[24]\\d|7(?:[0469]\\d|1[1568]|2[013-9]|3[145]|5[14-8]|7[2-57]|8[0-24-9])|8(?:[013578]\\d|2[15-7]|4[13-6]|6[1-357-9]|9[124]))|670\\d)\\d{6}", 
	, , , "1123456789", , , [10], [6, 7, 8]], [, , "675\\d{7}|9(?:11[2-9]\\d{7}|(?:2(?:2[013]|3[067]|49|6[01346]|80|9[147-9])|3(?:36|4[12358]|5[138]|6[24]|7[069]|8[013578]))[2-9]\\d{6}|\\d{4}[2-9]\\d{5})", , , , "91123456789", , , , [6, 7, 8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AR", 54, "00", "0", , , "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?", 
	"9$1", , , [[, "([68]\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{2})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9]"], "$1"], [, "(9)(11)(\\d{4})(\\d{4})", "$2 15-$3-$4", ["911"], "0$1"], [, "(9)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-4689]|3[3-8])", "9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))", 
	"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"], "0$1"], [, "(9)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9[23]"], "0$1"], [, "(11)(\\d{4})(\\d{4})", "$1 $2-$3", ["11"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))", 
	"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"], "0$1", , 1], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [, "(\\d{3})", "$1", ["1[0-2]|911"], "$1"]], [[, "([68]\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(9)(11)(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["911"]], [, "(9)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9(?:2[2-4689]|3[3-8])", 
	"9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))", "9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"]], [, "(9)(\\d{4})(\\d{2})(\\d{4})", 
	"$1 $2 $3-$4", ["9[23]"]], [, "(11)(\\d{4})(\\d{4})", "$1 $2-$3", ["11"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))", "2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"], 
	"0$1", , 1], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "810\\d{7}", , , , "8101234567", , , [10]], [, , "810\\d{7}", , , , "8101234567", , , [10]], , , [, , , , , , , , , [-1]]], AS:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:5[2468]|72)|7(?:3[13]|70))\\d{4}", , , , "6847331234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , 
	"8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AT:[, [, , "[1-9]\\d{3,12}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [3]], [, , "1\\d{3,12}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-8]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|63|7[1368]|8[2457])|5(?:12|2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[1-35-8]|5[468]|62)|7(?:2[1-8]|3[25]|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{3,10}", 
	, , , "1234567890", , , , [3]], [, , "6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", , , , "664123456", , , [7, 8, 9, 10, 11, 12, 13]], [, , "800\\d{6,10}", , , , "800123456", , , [9, 10, 11, 12, 13]], [, , "9(?:0[01]|3[019])\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10\\d|2(?:[01]\\d|8\\d?))\\d{5,9}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "780\\d{6,10}", , , , "780123456", , , [9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , 
	[[, "(116\\d{3})", "$1", ["116"], "$1"], [, "(1)(\\d{3,12})", "$1 $2", ["1"], "0$1"], [, "(5\\d)(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], [, "(5\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5[079]"], "0$1"], [, "(5\\d)(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5[079]"], "0$1"], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:[28]0|32)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:[24][1-8]|35|[5-79])"], "0$1"]], , 
	[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5(?:(?:0[1-9]|17)\\d{2,10}|[79]\\d{3,11})|720\\d{6,10}", , , , "50123", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], , , [, , , , , , , , , [-1]]], AU:[, [, , "1\\d{4,9}|[2-578]\\d{8}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "[237]\\d{8}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|[6-8]\\d{4}|9(?:[02-9]\\d{3}|1(?:[0-57-9]\\d{2}|6[0135-9]\\d)))\\d{3}", , , , "212345678", , , [9], [8]], [, , "14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12457-9]|9[017-9])\\d{6}", 
	, , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "19(?:0[0126]\\d|[679])\\d{5}", , , , "1900123456", , , [8, 10]], [, , "13(?:00\\d{3}|45[0-4]|\\d)\\d{3}", , , , "1300123456", , , [6, 8, 10]], [, , "500\\d{6}", , , , "500123456", , , [9]], [, , "550\\d{6}", , , , "550123456", , , [9]], "AU", 61, "(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011)|001[14-689]", "0", , , "0", , "0011", , [[, "([2378])(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], [, 
	"(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|[45]"], "0$1"], [, "(16)(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(16)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(1[389]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[389]0", "1(?:[38]0|9)0"]], [, "(180)(2\\d{3})", "$1 $2", ["180", "1802"]], [, "(19\\d)(\\d{3})", "$1 $2", ["19[13]"]], [, "(19\\d{2})(\\d{4})", "$1 $2", ["19[679]"]], [, "(13)(\\d{2})(\\d{2})", "$1 $2 $3", ["13[1-9]"]]], , [, , "16\\d{3,7}", , , , "1612345", , , [5, 6, 7, 8, 9]], 1, 
	, [, , "1(?:3(?:00\\d{3}|45[0-4]|\\d)\\d{3}|80(?:0\\d{6}|2\\d{3}))", , , , "1300123456", , , [6, 7, 8, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AW:[, [, , "[25-9]\\d{6}", , , , , , , [7]], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, 
	, "28\\d{5}|501\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], AX:[, [, , "[13]\\d{5,9}|2\\d{4,9}|4\\d{6,10}|5\\d{6,9}|[67]\\d{7,9}|8\\d{7,8}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "18[1-8]\\d{4,6}", , , , "181234567", , , [7, 8, 9]], [, , "4(?:[0-8]\\d{5,8}|9\\d{9})|50\\d{6,8}", , , , "412345678", , , [7, 8, 9, 10]], [, , "800\\d{5,6}", 
	, , , "800123456", , , [8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[02469]|5(?:11|33|5[59]|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , , [, , "100\\d{4,6}|20(?:0\\d{4,6}|2[023]\\d{4,5}|9[89]\\d{1,6})|300\\d{3,7}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})", , , , "1001234"], [, , "10(?:0\\d{4,6}|[1-37-9]\\d{5,7}|[46]\\d{3,7}|5\\d{4,7})|2(?:0(?:0\\d{4,6}|[1346-8]\\d{5,7}|2(?:[023]\\d{4,5}|[14-9]\\d{4,6})|5(?:\\d{3}|\\d{5,7})|9(?:[0-7]\\d{4,6}|[89]\\d{1,6}))|9\\d{5,8})|3(?:0(?:0\\d{3,7}|[1-57-9]\\d{5,7}|6(?:\\d{3}|\\d{5,7}))|44\\d{3}|93\\d{5,7})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})", 
	, , , "10112345"], , , [, , , , , , , , , [-1]]], AZ:[, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "(?:1[28]\\d{3}|2(?:02|1[24]|2[2-4]|33|[45]2|6[23])\\d{2}|365(?:[0-46-9]\\d|5[0-35-9]))\\d{4}", , , , "123123456", , , , [7]], [, , "(?:36554|(?:4[04]|5[015]|60|7[07])\\d{3})\\d{4}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, 
	"(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2(?:[0-36]|[45]2)|365"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[4-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BA:[, [, , "[3-9]\\d{7,8}", , , , , , , [8, 9], [6]], [, , "(?:[35]\\d|49)\\d{6}", , , , "30123456", , , [8], [6]], [, , "6(?:0(?:3\\d|40)|[1-356]\\d|44[0-6]|71[137])\\d{5}", 
	, , , "61123456"], [, , "8[08]\\d{6}", , , , "80123456", , , [8]], [, , "9[0246]\\d{6}", , , , "90123456", , , [8]], [, , "8[12]\\d{6}", , , , "82123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BA", 387, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-356]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6[047]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , 
	, , , , , , [-1]], [, , "70[23]\\d{5}", , , , "70223456", , , [8]], , , [, , , , , , , , , [-1]]], BB:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7(?:37|57)|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:2(?:[356]\\d|4[0-57-9]|8[0-79])|45\\d|69[5-7]|8(?:[2-5]\\d|83))\\d{4}", , , , "2462501234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900\\d{7}|246976\\d{4}", 
	, , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [, , "246(?:292|367|4(?:1[7-9]|3[01]|44|67)|736)\\d{4}", , , , "2464301234", , , , [7]], , , [, , , , , , , , , [-1]]], BD:[, [, , "[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}", , , , , , , [6, 7, 8, 9, 10]], [, , "2(?:[45]\\d{3}|7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|[139][1-6]|2[0157-9]|41|6[1-35]|7[1-5]|8[1-8]|90)|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0167]|7[15]|8[0146-9]))\\d{4}|3(?:12?[5-7]\\d{2}|0(?:2(?:[025-79]\\d|[348]\\d{1,2})|3(?:[2-4]\\d|[56]\\d?))|2(?:1\\d{2}|2(?:[12]\\d|[35]\\d{1,2}|4\\d?))|3(?:1\\d{2}|2(?:[2356]\\d|4\\d{1,2}))|4(?:1\\d{2}|2(?:2\\d{1,2}|[47]|5\\d{2}))|5(?:1\\d{2}|29)|[67]1\\d{2}|8(?:1\\d{2}|2(?:2\\d{2}|3|4\\d)))\\d{3}|4(?:0(?:2(?:[09]\\d|7)|33\\d{2})|1\\d{3}|2(?:1\\d{2}|2(?:[25]\\d?|[348]\\d|[67]\\d{1,2}))|3(?:1\\d{2}(?:\\d{2})?|2(?:[045]\\d|[236-9]\\d{1,2})|32\\d{2})|4(?:[18]\\d{2}|2(?:[2-46]\\d{2}|3)|5[25]\\d{2})|5(?:1\\d{2}|2(?:3\\d|5))|6(?:[18]\\d{2}|2(?:3(?:\\d{2})?|[46]\\d{1,2}|5\\d{2}|7\\d)|5(?:3\\d?|4\\d|[57]\\d{1,2}|6\\d{2}|8))|71\\d{2}|8(?:[18]\\d{2}|23\\d{2}|54\\d{2})|9(?:[18]\\d{2}|2[2-5]\\d{2}|53\\d{1,2}))\\d{3}|5(?:02[03489]\\d{2}|1\\d{2}|2(?:1\\d{2}|2(?:2(?:\\d{2})?|[457]\\d{2}))|3(?:1\\d{2}|2(?:[37](?:\\d{2})?|[569]\\d{2}))|4(?:1\\d{2}|2[46]\\d{2})|5(?:1\\d{2}|26\\d{1,2})|6(?:[18]\\d{2}|2|53\\d{2})|7(?:1|24)\\d{2}|8(?:1|26)\\d{2}|91\\d{2})\\d{3}|6(?:0(?:1\\d{2}|2(?:3\\d{2}|4\\d{1,2}))|2(?:2[2-5]\\d{2}|5(?:[3-5]\\d{2}|7)|8\\d{2})|3(?:1|2[3478])\\d{2}|4(?:1|2[34])\\d{2}|5(?:1|2[47])\\d{2}|6(?:[18]\\d{2}|6(?:2(?:2\\d|[34]\\d{2})|5(?:[24]\\d{2}|3\\d|5\\d{1,2})))|72[2-5]\\d{2}|8(?:1\\d{2}|2[2-5]\\d{2})|9(?:1\\d{2}|2[2-6]\\d{2}))\\d{3}|7(?:(?:02|[3-589]1|6[12]|72[24])\\d{2}|21\\d{3}|32)\\d{3}|8(?:(?:4[12]|[5-7]2|1\\d?)|(?:0|3[12]|[5-7]1|217)\\d)\\d{4}|9(?:[35]1|(?:[024]2|81)\\d|(?:1|[24]1)\\d{2})\\d{3}", 
	, , , "27111234", , , [6, 7, 8, 9]], [, , "(?:1[13-9]\\d|(?:3[78]|44)[02-9]|6(?:44|6[02-9]))\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[49]|1[0-4]|6[69])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(2)(\\d{7,8})", "$1-$2", ["2"], "0$1"], [, "(\\d{2})(\\d{4,6})", "$1-$2", ["[3-79]1"], "0$1"], [, "(\\d{4})(\\d{3,6})", "$1-$2", 
	["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1-$2", ["[3-79][2-9]|8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BE:[, [, , "[1-9]\\d{7,8}", , , , , , , [8, 9]], [, , "(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}|80[2-8]\\d{5}", , , , "12345678", , 
	, [8]], [, , "4(?:6[0135-8]|[79]\\d|8[3-9])\\d{6}", , , , "470123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "(?:70[2-467]|90[0-79])\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4[6-9]"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|4[23]|9[2-4]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
	"$1 $2 $3 $4", ["[156]|7[018]|8(?:0[1-9]|[1-79])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78\\d{6}", , , , "78123456", , , [8]], , , [, , , , , , , , , [-1]]], BF:[, [, , "[25-7]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:49|5[23]|6[56]|9[016-9])|4(?:4[569]|5[4-6]|6[56]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:5[15-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , 
	[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BG:[, [, , "[23567]\\d{5,7}|[489]\\d{6,8}", , , , , , , [6, 7, 8, 9], [4, 5]], [, , "2\\d{5,7}|(?:[36]\\d|5[1-9]|8[1-6]|9[1-7])\\d{5,6}|(?:4(?:[124-7]\\d|3[1-6])|7(?:0[1-9]|[1-9]\\d))\\d{4,5}", 
	, , , "2123456", , , [6, 7, 8], [4, 5]], [, , "(?:8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}|4(?:3[0789]|8\\d)\\d{5}", , , , "48123456", , , [8, 9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , "700\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], "BG", 359, "00", "0", , , "0", , , , [[, "(2)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [, "(2)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{4})", 
	"$1 $2", ["43[124-7]|70[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[124-7]|70[1-9]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[78]00"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["99[69]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["48|8[7-9]|9[08]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , 
	, , , , , , , [-1]]], BH:[, [, , "[136-9]\\d{7}", , , , , , , [8]], [, , "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9])|9[69][69])|7(?:1(?:11|78)|7\\d{2}))\\d{4}", , , , "17001234"], [, , "(?:3(?:[1-4679]\\d|5[013-69]|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:[69]\\d|3[03-9]|7[0-6])))\\d{4}", , , , "36001234"], [, , "80\\d{6}", , , , "80123456"], [, , "(?:87|9[014578])\\d{6}", , , , "90123456"], [, , "84\\d{6}", , , , "84123456"], [, , , , , , , , , [-1]], [, , , , , , , 
	, , [-1]], "BH", 973, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BI:[, [, , "[267]\\d{7}", , , , , , , [8]], [, , "22\\d{6}", , , , "22201234"], [, , "(?:29|6[189]|7[124-9])\\d{6}", , , , "79561234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
	"$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BJ:[, [, , "[2689]\\d{7}", , , , , , , [8]], [, , "2(?:02|1[037]|2[45]|3[68])\\d{5}", , , , "20211234"], [, , "(?:6[1-8]|9[03-9])\\d{6}", , , , "90011234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "857[58]\\d{4}", , , , "85751234"], "BJ", 229, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
	"$1 $2 $3 $4", ["[2689]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "81\\d{6}", , , , "81123456"], , , [, , , , , , , , , [-1]]], BL:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "590(?:2[7-9]|5[12]|87)\\d{4}", , , , "590271234"], [, , "690(?:0[05-9]|[1-9]\\d)\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BL", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , 
	[-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BM:[, [, , "[4589]\\d{9}", , , , , , , [10], [7]], [, , "441(?:2(?:02|23|61|[3479]\\d)|[46]\\d{2}|5(?:4\\d|60|89)|824)\\d{4}", , , , "4412345678", , , , [7]], [, , "441(?:[37]\\d|5[0-39])\\d{5}", , , , "4413701234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", 
	, , , "5002345678"], [, , , , , , , , , [-1]], "BM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "441", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BN:[, [, , "[2-578]\\d{6}", , , , , , , [7]], [, , "2(?:[013-9]\\d|2[0-7])\\d{4}|[3-5]\\d{6}", , , , "2345678"], [, , "22[89]\\d{4}|[78]\\d{6}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BN", 
	673, "00", , , , , , , , [[, "([2-578]\\d{2})(\\d{4})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BO:[, [, , "[23467]\\d{7}|8\\d{8}", , , , , , , [8, 9], [7]], [, , "(?:2(?:2\\d{2}|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d{2}|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:2\\d|3[234]|4[248]|5[24]|6[2-6]|7\\d))|4(?:4\\d{2}|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , 
	[8], [7]], [, , "[67]\\d{7}", , , , "71234567", , , [8]], [, , "80017\\d{4}", , , , "800171234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BO", 591, "00(1\\d)?", "0", , , "0(1\\d)?", , , , [[, "([234])(\\d{7})", "$1 $2", ["[2-4]"], , "0$CC $1"], [, "([67]\\d{7})", "$1", ["[67]"], , "0$CC $1"], [, "(800)(\\d{2})(\\d{4})", "$1 $2 $3", ["800"], , "0$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , 
	, , , , [-1]], , , [, , , , , , , , , [-1]]], BQ:[, [, , "[347]\\d{6}", , , , , , , [7]], [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}", , , , "7151234"], [, , "(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BQ", 599, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , 
	, , , , , [-1]], , , [, , , , , , , , , [-1]]], BR:[, [, , "[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[189][1-9]|2[12478])(?:7|9\\d)\\d{7}|(?:3[1-578]|[46][1-9]|5[13-5]|7[13-579])(?:[6-8]|9\\d?)\\d{7}", , , , "11961234567", , , [10, 11], [8]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "(?:300|[59]00\\d?)\\d{6}", , 
	, , "300123456", , , [9, 10]], [, , "(?:300\\d(?:\\d{2})?|40(?:0\\d|20))\\d{4}", , , , "40041234", , , [8, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|40[02]", "300|40(?:0|20)"]], [, "([3589]00)(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"], [, "(\\d{3,5})", "$1", ["1[125689]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-9](?:0[1-9]|[1-9])"]], 
	[, "(\\d{5})(\\d{4})", "$1-$2", ["9(?:0[1-9]|[1-9])"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]9"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|40[02]", "300|40(?:0|20)"]], [, "([3589]00)(\\d{2,3})(\\d{4})", "$1 $2 $3", ["[3589]00"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[1-9][1-9]9"], 
	"($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "(?:300\\d|40(?:0\\d|20))\\d{4}", , , , "40041234", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BS:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, , "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-4]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}", , , , "2423456789", , , , [7]], [, , "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}", 
	, , , "2423591234", , , , [7]], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "BS", 1, "011?", "1", , , "1", , "011", , , , [, , , , , , , , , [-1]], , "242", [, , , , , , , , , [-1]], [, , "242225[0-46-9]\\d{3}", , , , "2422250123"], , , [, , , , , , , , , [-1]]], BT:[, [, , "[1-8]\\d{6,7}", , 
	, , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|77)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1|77"]], [, "([2-8])(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]]], , [, , , , , , , , , [-1]], , , [, , 
	, , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BW:[, [, , "[2-79]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[01])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[0389]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}", , , , "2401234", , , [7]], [, , "7(?:[1-6]\\d|7[014-8])\\d{5}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , 
	, , , [-1]], [, , "79[12][01]\\d{4}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-6]"]], [, "(7\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(90)(\\d{5})", "$1 $2", ["90"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BY:[, [, , "[1-4]\\d{8}|8(?:0(?:0\\d{3,7}|[13]\\d{7})|(?:10|20\\d)\\d{7})|9\\d{9,10}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d{2})|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", 
	, , , "152450911", , , [9], [5, 6, 7]], [, , "(?:2(?:5[5679]|9[1-9])|33\\d|44\\d)\\d{6}", , , , "294911911", , , [9]], [, , "8(?:0[13]|20\\d)\\d{7}|800\\d{3,7}", , , , "8011234567"], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "8?0?", , "8~10", , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["17[0-3589]|2[4-9]|[34]", "17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"], 
	"8 0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])", "1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"], "8 0$1"], [, "(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], [, "([89]\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8[01]|9"], "8 $1"], [, "(82\\d)(\\d{4})(\\d{4})", 
	"$1 $2 $3", ["82"], "8 $1"], [, "(800)(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(800)(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "8(?:0[13]|10|20\\d)\\d{7}|800\\d{3,7}|902\\d{7}", , , , "82012345678"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], BZ:[, [, , "[2-8]\\d{6}|0\\d{10}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36)|[3-58][02]\\d|7(?:[02]\\d|32))\\d{4}", , , , "2221234", , , [7]], [, , "6[0-35-7]\\d{5}", , , , "6221234", , , [7]], 
	[, , "0800\\d{7}", , , , "08001234123", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(0)(800)(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["080", "0800"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CA:[, [, , "[2-9]\\d{9}", , , , , , , [10], [7]], [, , "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", 
	, , , "2042345678", , , , [7]], [, , "(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", , , , "2042345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "CA", 1, "011", "1", , , "1", 
	, , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CC:[, [, , "[1458]\\d{5,9}", , , , , , , [6, 7, 8, 9, 10]], [, , "89162\\d{4}", , , , "891621234", , , [9], [8]], [, , "14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}", , , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "19(?:0[0126]\\d|[679])\\d{5}", , , , "1900123456", , , [8, 10]], 
	[, , "13(?:00\\d{2})?\\d{4}", , , , "1300123456", , , [6, 10]], [, , "500\\d{6}", , , , "500123456", , , [9]], [, , "550\\d{6}", , , , "550123456", , , [9]], "CC", 61, "(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]", "0", , , "0", , "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CD:[, [, , "[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}", , , , , , , [7, 9]], [, , "1(?:2\\d{7}|\\d{6})|[2-6]\\d{6}", , , , "1234567"], [, , "8(?:[0-2459]\\d{2}|8)\\d{5}|9[017-9]\\d{7}", 
	, , , "991234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["12"], "0$1"], [, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[0-2459]|9"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , 
	, , , [-1]], , , [, , , , , , , , , [-1]]], CF:[, [, , "[278]\\d{7}", , , , , , , [8]], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[0257]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , 
	, , [-1]]], CG:[, [, , "[028]\\d{8}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [, , "0[14-6]\\d{7}", , , , "061234567"], [, , , , , , , , , [-1]], [, , "80(?:0\\d{2}|11[01])\\d{4}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["801"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["800"]]], 
	, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CH:[, [, , "[2-9]\\d{8}|860\\d{9}", , , , , , , [9, 12]], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]], [, , "7[5-9]\\d{7}", , , , "781234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[016]\\d{6}", , , , "900123456", , , [9]], [, , "84[0248]\\d{6}", , , , "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , 
	, [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]|[89]1"], "0$1"], [, "([89]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["860"], "0$1"]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "5[18]\\d{7}", , , , "581234567", , , [9]], , , [, , "860\\d{9}", , , , "860123456789", , , [12]]], CI:[, [, 
	, "[02-8]\\d{7}", , , , , , , [8]], [, , "(?:2(?:0[023]|1[02357]|[23][045]|4[03-5])|3(?:0[06]|1[069]|[2-4][07]|5[09]|6[08]))\\d{5}", , , , "21234567"], [, , "(?:0[1-9]|4\\d|5[14-9]|6[015-79]|[78][4-9])\\d{6}", , , , "01234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
	[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CK:[, [, , "[2-8]\\d{4}", , , , , , , [5]], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[5-8]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
	CL:[, [, , "1230\\d{7}|[2-46-9]\\d{8,10}|5[1-3578]\\d{7}", , , , , , , [9, 10, 11], [7, 8]], [, , "2(?:1962\\d{4}|2\\d{7}|32[0-467]\\d{5})|(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|9[3-9])\\d{7}", , , , "221234567", , , [9], [7, 8]], [, , "2(?:1962\\d{4}|2\\d{7}|32[0-467]\\d{5})|(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|9[3-9])\\d{7}", , , , "961234567", , , [9], [8]], [, , "800\\d{6}|1230\\d{7}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [, , "600\\d{7,8}", , , , "6001234567", , , [10, 
	11]], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0", "0", , , "0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))", , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[23]"], "($1)", "$CC ($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[357]|4[1-35]|6[13-57]"], "($1)", "$CC ($1)"], [, "(9)(\\d{4})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(44)(\\d{3})(\\d{4})", "$1 $2 $3", ["44"], "0$1"], [, "([68]00)(\\d{3})(\\d{3,4})", 
	"$1 $2 $3", ["[68]00"], "$1"], [, "(600)(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["600"], "$1"], [, "(1230)(\\d{3})(\\d{4})", "$1 $2 $3", ["123", "1230"], "$1"], [, "(\\d{5})(\\d{4})", "$1 $2", ["219"], "($1)", "$CC ($1)"], [, "(\\d{4,5})", "$1", ["[1-9]"], "$1"]], [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[23]"], "($1)", "$CC ($1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[357]|4[1-35]|6[13-57]"], "($1)", "$CC ($1)"], [, "(9)(\\d{4})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(44)(\\d{3})(\\d{4})", 
	"$1 $2 $3", ["44"], "0$1"], [, "([68]00)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[68]00"], "$1"], [, "(600)(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["600"], "$1"], [, "(1230)(\\d{3})(\\d{4})", "$1 $2 $3", ["123", "1230"], "$1"], [, "(\\d{5})(\\d{4})", "$1 $2", ["219"], "($1)", "$CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CM:[, [, , "[2368]\\d{7,8}", , , , , , , [8, 9]], [, , "2(?:22|33|4[23])\\d{6}", 
	, , , "222123456", , , [9]], [, , "6[5-9]\\d{7}", , , , "671234567", , , [9]], [, , "88\\d{6}", , , , "88012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[, "([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , 
	, , , , [-1]]], CN:[, [, , "[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , "21(?:100\\d{2}|95\\d{3,4}|\\d{8,10})|(?:10|2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:31|5[457]|6[09]|91)|8(?:[57]1|98))(?:100\\d{2}|95\\d{3,4}|\\d{8})|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[3-9]|5[2-9]|6[4789]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-4689]|6[2368]|9[02-9])|8(?:078|1[236-8]|2[5-7]|3\\d|5[1-9]|7[02-9]|8[3678]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100\\d{2}|95\\d{3,4}|\\d{7})|80(?:29|6[03578]|7[018]|81)\\d{4}", 
	, , , "1012345678", , , , [5, 6]], [, , "1(?:[38]\\d{3}|4[57]\\d{2}|5[0-35-9]\\d{2}|66\\d{2}|7(?:[0-35-8]\\d{2}|40[0-5])|99\\d{2})\\d{6}", , , , "13123456789", , , [11]], [, , "(?:10)?800\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [, , "400\\d{7}|950\\d{7,8}|(?:10|2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[4789]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[3678]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", 
	, , , "4001234567", , , [7, 8, 9, 10, 11], [5, 6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "(1(?:[129]\\d{3}|79\\d{2}))?00", "0", , , "(1(?:[129]\\d{3}|79\\d{2}))|0", , "00", , [[, "(80\\d{2})(\\d{4})", "$1 $2", ["80[26-8]"], "0$1", "$CC $1", 1], [, "([48]00)(\\d{3})(\\d{4})", "$1 $2 $3", ["[48]00"]], [, "(\\d{5,6})", "$1", ["100|95"]], [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2\\d)[19]", "(?:10|2\\d)(?:10|9[56])", "(?:10|2\\d)(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{5,6})", 
	"$1 $2", ["[3-9]", "[3-9]\\d\\d[19]", "[3-9]\\d\\d(?:10|9[56])"], "0$1", "$CC $1"], [, "(\\d{3,4})(\\d{4})", "$1 $2", ["[2-9]"]], [, "(21)(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1], [, "([12]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["10[1-9]|2[02-9]", "10[1-9]|2[02-9]", "10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"], 
	"0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"], "0$1", "$CC $1", 1], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["807", "8078"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1(?:[3-57-9]|66)"], , "$CC $1"], [, "(10800)(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]], [[, "(80\\d{2})(\\d{4})", "$1 $2", 
	["80[26-8]"], "0$1", "$CC $1", 1], [, "([48]00)(\\d{3})(\\d{4})", "$1 $2 $3", ["[48]00"]], [, "(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2\\d)[19]", "(?:10|2\\d)(?:10|9[56])", "(?:10|2\\d)(?:100|9[56])"], "0$1", "$CC $1"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[3-9]", "[3-9]\\d\\d[19]", "[3-9]\\d\\d(?:10|9[56])"], "0$1", "$CC $1"], [, "(21)(\\d{4})(\\d{4,6})", "$1 $2 $3", ["21"], "0$1", "$CC $1", 1], [, "([12]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["10[1-9]|2[02-9]", "10[1-9]|2[02-9]", "10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"], 
	"0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"], 
	"0$1", "$CC $1", 1], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["807", "8078"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1(?:[3-57-9]|66)"], , "$CC $1"], [, "(10800)(\\d{3})(\\d{4})", "$1 $2 $3", ["108", "1080", "10800"]], [, "(\\d{3})(\\d{7,8})", "$1 $2", ["950"]]], [, , , , , , , , , [-1]], , , [, , "(?:4|(?:10)?8)00\\d{7}|950\\d{7,8}", , , , "4001234567", , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CO:[, [, , "(?:[13]\\d{0,3}|[24-8])\\d{7}", 
	, , , , , , [8, 10, 11], [7]], [, , "[124-8][2-9]\\d{6}", , , , "12345678", , , [8], [7]], [, , "3(?:0[0-5]|1\\d|2[0-3]|5[01])\\d{7}", , , , "3211234567", , , [10]], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "19(?:0[01]|4[78])\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:44|56))?", , , , [[, "(\\d)(\\d{7})", "$1 $2", ["1(?:[2-7]|8[2-9]|9[0-3])|[24-8]", 
	"1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"], [, "(1)(\\d{3})(\\d{7})", "$1-$2-$3", ["1(?:80|9[04])", "1(?:800|9(?:0[01]|4[78]))"], "0$1"]], [[, "(\\d)(\\d{7})", "$1 $2", ["1(?:[2-7]|8[2-9]|9[0-3])|[24-8]", "1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], , "0$CC $1"], [, "(1)(\\d{3})(\\d{7})", "$1 $2 $3", ["1(?:80|9[04])", "1(?:800|9(?:0[01]|4[78]))"]]], [, , , , , , , , , [-1]], 
	, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CR:[, [, , "[24-9]\\d{7,9}", , , , , , , [8, 10]], [, , "2(?:[024-7]\\d{2}|1(?:0[7-9]|[1-9]\\d))\\d{4}", , , , "22123456", , , [8]], [, , "5(?:0[01]|7[0-3])\\d{5}|6(?:[0-4]\\d{3}|500[01])\\d{3}|(?:7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "210[0-6]\\d{4}|4\\d{7}|5100\\d{4}", 
	, , , "40001234", , , [8]], "CR", 506, "00", , , , "(19(?:0[012468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[24-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]0"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CU:[, [, , "[2-57]\\d{5,7}", , , , , , , [6, 7, 8], [4, 5]], [, , "2[1-4]\\d{5,6}|3(?:1\\d{6}|[23]\\d{4,6})|4(?:[125]\\d{5,6}|[36]\\d{6}|[78]\\d{4,6})|7\\d{6,7}", 
	, , , "71234567", , , , [4, 5]], [, , "5\\d{7}", , , , "51234567", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], [, "(\\d{2})(\\d{4,6})", "$1 $2", ["[2-4]"], "(0$1)"], [, "(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
	CV:[, [, , "[259]\\d{6}", , , , , , , [7]], [, , "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}", , , , "2211234"], [, , "(?:9\\d|59)\\d{5}", , , , "9911234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CV", 238, "0", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CW:[, [, 
	, "[134679]\\d{6,7}", , , , , , , [7, 8]], [, , "9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}", , , , "94151234", , , [8]], [, , "9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}", , , , "95181234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[13-7]"]], [, "(9)(\\d{3})(\\d{4})", "$1 $2 $3", 
	["9"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CX:[, [, , "[1458]\\d{5,9}", , , , , , , [6, 7, 8, 9, 10]], [, , "89164\\d{4}", , , , "891641234", , , [9], [8]], [, , "14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}", , , , "412345678", , , [9]], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "19(?:0[0126]\\d|[679])\\d{5}", , , , "1900123456", 
	, , [8, 10]], [, , "13(?:00\\d{2})?\\d{4}", , , , "1300123456", , , [6, 8, 10]], [, , "500\\d{6}", , , , "500123456", , , [9]], [, , "550\\d{6}", , , , "550123456", , , [9]], "CX", 61, "(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]", "0", , , "0", , "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], CY:[, [, , "[257-9]\\d{7}", , , , , , , [8]], [, , "2[2-6]\\d{6}", , , , "22345678"], [, , "9[4-79]\\d{6}", , , , "96123456"], 
	[, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]], CZ:[, [, , "[2-8]\\d{8}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [, , "2\\d{8}|(?:3[1257-9]|4[16-9]|5[13-9])\\d{7}", , , 
	, "212345678", , , [9]], [, , "(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", , , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 420, "00", , , , , , , , [[, "([2-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(96\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", 
	["96"]], [, "(9\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9[36]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[234])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]], DE:[, [, , "[1-35-9]\\d{3,14}|4(?:[0-8]\\d{3,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [3]], [, , "2\\d{5,13}|3(?:0\\d{3,13}|2\\d{9}|[3-9]\\d{4,13})|4(?:0\\d{3,12}|[1-8]\\d{4,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})|5(?:0[2-8]|[1256]\\d|[38][0-8]|4\\d{0,2}|[79][0-7])\\d{3,11}|6(?:\\d{5,13}|9\\d{3,12})|7(?:0[2-8]|[1-9]\\d)\\d{3,10}|8(?:0[2-9]|[1-8]\\d|9\\d?)\\d{3,10}|9(?:0[6-9]\\d{3,10}|1\\d{4,12}|[2-9]\\d{4,11})", 
	, , , "30123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [3, 4]], [, , "1(?:5[0-25-9]\\d{8}|6[023]\\d{7,8}|7\\d{8,9})", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "137[7-9]\\d{6}|900(?:[135]\\d{6}|9\\d{7})", , , , "9001234567", , , [10, 11]], [, , "1(?:3(?:7[1-6]\\d{6}|8\\d{4})|80\\d{5,11})", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], 
	"DE", 49, "00", "0", , , "0", , , , [[, "(1\\d{2})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], [, "(15\\d{3})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], [, "(1\\d{3})(\\d{7})", "$1 $2", ["15"], "0$1"], [, "(\\d{2})(\\d{3,11})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], [, "(\\d{3})(\\d{3,11})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)"], "0$1"], [, "(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|[7-9](?:0[1-9]|[1-9])", 
	"[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[1346]|8[13568])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|[7-9](?:0[1-9]|[1-9])"], "0$1"], [, "(3\\d{4})(\\d{1,10})", "$1 $2", ["3"], 
	"0$1"], [, "(800)(\\d{7,12})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:37|80)|900", "1(?:37|80)|900[1359]"], "0$1"], [, "(1\\d{2})(\\d{5,11})", "$1 $2", ["181"], "0$1"], [, "(18\\d{3})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], [, "(18\\d{2})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], [, "(18\\d)(\\d{8})", "$1 $2", ["18[2-579]"], "0$1"], [, "(700)(\\d{4})(\\d{4})", "$1 $2 $3", ["700"], "0$1"], [, "(138)(\\d{4})", "$1 $2", ["138"], "0$1"], [, "(15[013-68])(\\d{2})(\\d{8})", 
	"$1 $2 $3", ["15[013-68]"], "0$1"], [, "(15[279]\\d)(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], [, "(1[67]\\d)(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"]], , [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [, , "1(?:5(?:(?:2\\d55|7\\d99|9\\d33)\\d{7}|(?:[034568]00|113)\\d{8})|6(?:013|255|399)\\d{7,8}|7(?:[015]13|[234]55|[69]33|[78]99)\\d{7,8})", 
	, , , "177991234567", , , [12, 13]]], DJ:[, [, , "[27]\\d{7}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
	DK:[, [, , "[2-9]\\d{7}", , , , , , , [8]], [, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "32123456"], [, , "(?:[2-7]\\d|8[126-9]|9[1-36-9])\\d{6}", , , , "20123456"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , 1, [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, 
	, , , , , , , , [-1]]], DM:[, [, , "[57-9]\\d{9}", , , , , , , [10], [7]], [, , "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4]|70[1-3])\\d{4}", , , , "7674201234", , , , [7]], [, , "767(?:2(?:[234689]5|7[5-7])|31[5-7]|61[1-7])\\d{4}", , , , "7672251234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DM", 
	1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "767", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DO:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "8(?:[04]9[2-9]\\d{6}|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d{2}|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9]))\\d{4})", 
	, , , "8092345678", , , , [7]], [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "DO", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "8[024]9", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], DZ:[, [, , "(?:[1-4]|[5-9]\\d)\\d{7}", 
	, , , , , , [8, 9]], [, , "(?:1\\d|2[013-79]|3[0-8]|4[0135689])\\d{6}|9619\\d{5}", , , , "12345678"], [, , "(?:5[4-6]|7[7-9])\\d{7}|6(?:[569]\\d|7[0-6])\\d{6}", , , , "551234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]], [, , "80[12]1\\d{5}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , "98[23]\\d{6}", , , , "983123456", , , [9]], "DZ", 213, "00", "0", , , "0", , , , [[, "([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", 
	["[1-4]"], "0$1"], [, "([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"], [, "(9\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EC:[, [, , "1\\d{9,10}|[2-8]\\d{7}|9\\d{8}", , , , , , , [8, 9, 10, 11], [7]], [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]], [, , "9(?:(?:39|[45][89]|7[7-9]|[89]\\d)\\d{2}|6(?:[017-9]\\d{2}|2(?:[0-47-9]\\d|5[1-9]|60)|30\\d))\\d{4}", 
	, , , "991234567", , , [9]], [, , "1800\\d{6,7}", , , , "18001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]], "EC", 593, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[247]|[356][2-8]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(1800)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["180", "1800"], "$1"]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[247]|[356][2-8]"]], 
	[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(1800)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["180", "1800"], "$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EE:[, [, , "[3-9]\\d{6,7}|800\\d{6,7}", , , , , , , [7, 8, 10]], [, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]], [, , "(?:5\\d|8[1-5])\\d{6}|5(?:[02]\\d{2}|1(?:[0-8]\\d|95)|5[0-478]\\d|64[0-4]|65[1-589])\\d{3}", , , , "51234567", , , 
	[7, 8]], [, , "800(?:0\\d{3}|1\\d|[2-9])\\d{3}", , , , "80012345"], [, , "(?:40\\d{2}|900)\\d{4}", , , , "9001234", , , [7, 8]], [, , , , , , , , , [-1]], [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], "EE", 372, "00", , , , , , , , [[, "([3-79]\\d{2})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]], [, "(70)(\\d{2})(\\d{4})", "$1 $2 $3", ["70"]], [, "(8000)(\\d{3})(\\d{3})", 
	"$1 $2 $3", ["800", "8000"]], [, "([458]\\d{3})(\\d{3,4})", "$1 $2", ["40|5|8(?:00|[1-5])", "40|5|8(?:00[1-9]|[1-5])"]]], , [, , , , , , , , , [-1]], , , [, , "800[2-9]\\d{3}", , , , "8002123", , , [7]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EG:[, [, , "1\\d{4,9}|[24-6]\\d{8}|3\\d{7}|[89]\\d{8,9}", , , , , , , [8, 9, 10], [7]], [, , "(?:1(?:3[23]\\d|5(?:[23]|9\\d))|2[2-4]\\d{2}|3\\d{2}|4(?:0[2-5]|[578][23]|64)\\d|5(?:0[2-7]|5\\d|7[23])\\d|6[24-689]3\\d|8(?:2[2-57]|4[26]|6[237]|8[2-4])\\d|9(?:2[27]|3[24]|52|6[2356]|7[2-4])\\d)\\d{5}", 
	, , , "234567890", , , [8, 9], [7]], [, , "1[0125]\\d{8}", , , , "1001234567", , , [10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "EG", 20, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1(?:3|5[239])|[4-6]|[89][2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1[0-25]|[89]00"], "0$1"]], 
	, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], EH:[, [, , "[5-9]\\d{8}", , , , , , , [9]], [, , "528[89]\\d{5}", , , , "528812345"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[07]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5924[01]\\d{4}", , , , "592401234"], "EH", 212, "00", "0", , , "0", , , , , , 
	[, , , , , , , , , [-1]], , "528[89]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ER:[, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "1(?:1[12568]|20|40|55|6[146])\\d{4}|8\\d{6}", , , , "8370362", , , , [6]], [, , "17[1-3]\\d{4}|7\\d{6}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", 
	, "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ES:[, [, , "[5-9]\\d{8}", , , , , , , [9]], [, , "8(?:[1356]\\d|[28][0-8]|[47][1-9])\\d{6}|9(?:[135]\\d{7}|[28][0-8]\\d{6}|4[1-9]\\d{6}|6(?:[0-8]\\d{6}|9(?:0(?:[0-57-9]\\d{4}|6(?:0[0-8]|1[1-9]|[2-9]\\d)\\d{2})|[1-9]\\d{5}))|7(?:[124-9]\\d{2}|3(?:[0-8]\\d|9[1-9]))\\d{4})", , , , "810123456"], [, , "(?:6\\d{6}|7[1-48]\\d{5}|9(?:6906(?:09|10)|7390\\d{2}))\\d{2}", , , , "612345678"], 
	[, , "[89]00\\d{6}", , , , "800123456"], [, , "80[367]\\d{6}", , , , "803123456"], [, , "90[12]\\d{6}", , , , "901123456"], [, , "70\\d{7}", , , , "701234567"], [, , , , , , , , , [-1]], "ES", 34, "00", , , , , , , , [[, "([89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[568]|[79][0-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "51\\d{7}", , , , "511234567"], , , [, , , , , , , , , [-1]]], ET:[, [, , "[1-59]\\d{8}", 
	, , , , , , [9], [7]], [, , "(?:11(?:1(?:1[124]|2[2-57]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:18|2[69]|39|4[5-7]|5[1-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|22[0-6]|33[0134689]|44[04]|55[0-6]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:11[1-9]|22[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}", 
	, , , "111112345", , , , [7]], [, , "9(?:[1-46-8]\\d|5[89])\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "([1-59]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FI:[, [, , "1\\d{5,9}|2\\d{4,9}|[35]\\d{5,9}|4\\d{5,10}|6\\d{6,9}|7\\d{7,9}|8\\d{6,8}|9\\d{4,8}", 
	, , , , , , [5, 6, 7, 8, 9, 10, 11]], [, , "1[3-79][1-8]\\d{4,6}|[23568][1-8]\\d{5,7}|9[1-8]\\d{3,7}", , , , "131234567", , , [5, 6, 7, 8, 9]], [, , "4[0-8]\\d{5,8}|50\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10, 11]], [, , "800\\d{5,6}", , , , "800123456", , , [8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FI", 358, "00|99(?:[02469]|5(?:11|33|5[59]|88|9[09]))", "0", , , "0", , "00", , [[, "(\\d{3})(\\d{3,7})", 
	"$1 $2", ["(?:[1-3]0|[6-8])0"], "0$1"], [, "(116\\d{3})", "$1", ["116"], "$1"], [, "(\\d{2})(\\d{3,9})", "$1 $2", ["1(?:0[1-9]|[3-9])|2(?:0[1-9]|9)|30[1-9]|4|50|7(?:[13]|5[03-9])"], "0$1"], [, "(75\\d{3})", "$1", ["75[12]"], "0$1"], [, "(\\d)(\\d{4})", "$1 $2", ["9[1-8]"], "0$1"], [, "(\\d)(\\d{5,9})", "$1 $2", ["[235689][1-8]"], "0$1"], [, "(39\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["39"], "0$1"]], [[, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[6-8])0"], "0$1"], [, "(116\\d{3})", "$1", ["116"], "$1"], 
	[, "(\\d{2})(\\d{3,9})", "$1 $2", ["1(?:0[1-9]|[3-9])|2(?:0[1-9]|9)|30[1-9]|4|50|7(?:[13]|5[03-9])"], "0$1"], [, "(\\d)(\\d{4})", "$1 $2", ["9[1-8]"], "0$1"], [, "(\\d)(\\d{5,9})", "$1 $2", ["[235689][1-8]"], "0$1"], [, "(39\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["39"], "0$1"]], [, , , , , , , , , [-1]], 1, , [, , "100\\d{4,6}|20(?:0\\d{4,6}|2[023]\\d{4,5}|9[89]\\d{1,6})|300\\d{3,7}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})", , , , "1001234", , , [5, 6, 7, 8, 9, 10]], [, , "10(?:0\\d{4,6}|[1-37-9]\\d{5,7}|[46]\\d{3,7}|5\\d{4,7})|2(?:0(?:0\\d{4,6}|[1346-8]\\d{5,7}|2(?:[023]\\d{4,5}|[14-9]\\d{4,6})|5(?:\\d{3}|\\d{5,7})|9(?:[0-7]\\d{4,6}|[89]\\d{1,6}))|9\\d{5,8})|3(?:0(?:0\\d{3,7}|[1-57-9]\\d{5,7}|6(?:\\d{3}|\\d{5,7}))|44\\d{3}|93\\d{5,7})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})", 
	, , , "10112345", , , [5, 6, 7, 8, 9, 10]], , , [, , , , , , , , , [-1]]], FJ:[, [, , "[2-9]\\d{6}|0\\d{10}", , , , , , , [7, 11]], [, , "(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]], [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]], [, , "0800\\d{7}", , , , "08001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FJ", 679, "0(?:0|52)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", 
	["[2-9]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FK:[, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , 
	, , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FM:[, [, , "[39]\\d{6}", , , , , , , [7]], [, , "3[2357]0[1-9]\\d{3}|9[2-6]\\d{5}", , , , "3201234"], [, , "3[2357]0[1-9]\\d{3}|9[2-7]\\d{5}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , 
	, , [-1]], , , [, , , , , , , , , [-1]]], FO:[, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[3-4]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d)\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [, , "90(?:[1345][15-7]|2[125-7]|99)\\d{2}", , , , "901123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", , , "$CC $1"]], , [, , , , , , , , , 
	[-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], FR:[, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "[1-5]\\d{8}", , , , "123456789"], [, , "(?:6\\d|7[3-9])\\d{7}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[0-29]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
	"$1 $2 $3 $4 $5", ["[1-79]"], "0$1"], [, "(1\\d{2})(\\d{3})", "$1 $2", ["11"], "$1"], [, "(8\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]], [[, "([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"], [, "(8\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]], GA:[, [, , "0?\\d{7}", , , , , , , [7, 8]], [, , "01\\d{6}", 
	, , , "01441234", , , [8]], [, , "0?[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , , , , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GB:[, [, , "\\d{7,10}", 
	, , , , , , [7, 9, 10], [4, 5, 6, 8]], [, , "2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d)\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}", 
	, , , "1212345678", , , [9, 10], [4, 5, 6, 7, 8]], [, , "7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}", , , , "7400123456", , , [10]], [, , "80(?:0(?:1111|\\d{6,7})|8\\d{7})", , , , "8001234567"], [, , "(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}", , , , "9012345678", , , [10]], [, , "8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})", 
	, , , "8431234567", , , [7, 10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GB", 44, "00", "0", " x", , "0", , , , [[, "(7\\d{3})(\\d{6})", "$1 $2", ["7(?:[1-57-9]|62)", "7(?:[1-57-9]|624)"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2|5[56]|7[06]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:[02-9]1|1)|3|9[018]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", 
	"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(1\\d{3})(\\d{5,6})", "$1 $2", ["1"], "0$1"], [, "(800)(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(845)(46)(4\\d)", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(8\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8(?:4[2-5]|7[0-3])"], "0$1"], [, "(80\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1"], [, "(800)(\\d{6})", "$1 $2", ["800"], "0$1"]], , [, , "76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", 
	, , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]], GD:[, [, , "[4589]\\d{9}", , , , , , , [10], [7]], [, , "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|68|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}", , , , "4732691234", , , , [7]], [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
	, , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GD", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "473", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GE:[, [, , "[34578]\\d{8}", , , , , , , [9], [6]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", 
	, , , [6]], [, , "5(?:[14]4|5[0157-9]|68|7[0147-9]|9[0-35-9])\\d{6}", , , , "555123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "706\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5"]]], , [, , , , , , , , , [-1]], 
	, , [, , "706\\d{6}", , , , "706123456"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GF:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "594(?:10|2[012457-9]|3[0-57-9]|4[3-9]|5[7-9]|6[0-3]|9[014])\\d{4}", , , , "594101234"], [, , "694(?:[0249]\\d|1[2-9]|3[0-48])\\d{4}", , , , "694201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", 
	"$1 $2 $3 $4", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GG:[, [, , "[135789]\\d{6,9}", , , , , , , [7, 9, 10], [6]], [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]], [, , "7(?:781\\d|839\\d|911[17])\\d{5}", , , , "7781123456", , , [10]], [, , "80(?:0(?:1111|\\d{6,7})|8\\d{7})", , , , "8001234567"], [, , "(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}", , , , "9012345678", , , [10]], [, , "8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})", 
	, , , "8431234567", , , [7, 10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , "56\\d{8}", , , , "5612345678", , , [10]], "GG", 44, "00", "0", , , "0", , , , , , [, , "76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456", , , [10]], , , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]], GH:[, [, , "[235]\\d{8}|8\\d{7}", , , , , , , [8, 9], [7]], [, , "3(?:0(?:[237]\\d|80)|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", 
	, , , "302345678", , , [9], [7]], [, , "(?:2[034678]\\d|5(?:[0457]\\d|6[01]))\\d{6}", , , , "231234567", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , "80012345", , , [8]], [, , , , , 
	, , , , [-1]], , , [, , , , , , , , , [-1]]], GI:[, [, , "[256]\\d{7}", , , , , , , [8]], [, , "2(?:00\\d{2}|1(?:6[24-7]\\d|90[0-2])|2(?:2[2457]\\d|50[0-2]))\\d{3}", , , , "20012345"], [, , "(?:5[46-8]|62)\\d{6}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , 
	, , , , , , [-1]], , , [, , , , , , , , , [-1]]], GL:[, [, , "[1-689]\\d{5}", , , , , , , [6]], [, , "(?:19|3[1-7]|6[14689]|8[14-79]|9\\d)\\d{4}", , , , "321000"], [, , "(?:[25][1-9]|4[2-9])\\d{4}", , , , "221234"], [, , "80\\d{4}", , , , "801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[89]\\d{4}", , , , "381234"], "GL", 299, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, 
	, , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GM:[, [, , "[2-9]\\d{6}", , , , , , , [7]], [, , "(?:4(?:[23]\\d{2}|4(?:1[024679]|[6-9]\\d))|5(?:54[0-7]|6(?:[67]\\d)|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}", , , , "5661234"], [, , "[23679]\\d{6}", , , , "3012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GM", 220, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , 
	, [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GN:[, [, , "[367]\\d{7,8}", , , , , , , [8, 9]], [, , "30(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])\\d{4}", , , , "30241234", , , [8]], [, , "6[02356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "722\\d{6}", , , , "722123456", , , [9]], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", 
	"$1 $2 $3 $4", ["3"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GP:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "590(?:0[13468]|1[012]|2[0-68]|3[28]|4[0-8]|5[579]|6[0189]|70|8[0-689]|9\\d)\\d{4}", , , , "590201234"], [, , "690(?:0[05-9]|[1-9]\\d)\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , 
	, , , , , [-1]], [, , , , , , , , , [-1]], "GP", 590, "00", "0", , , "0", , , , [[, "([56]90)(\\d{2})(\\d{4})", "$1 $2-$3", ["[56]90"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GQ:[, [, , "[23589]\\d{8}", , , , , , , [9]], [, , "3(?:3(?:3\\d[7-9]|[0-24-9]\\d[46])|5\\d{2}[7-9])\\d{4}", , , , "333091234"], [, , "(?:222|55[15])\\d{6}", , , , "222123456"], [, , "80\\d[1-9]\\d{5}", , , , "800123456"], [, , "90\\d[1-9]\\d{5}", 
	, , , "900123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GQ", 240, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GR:[, [, , "[26-9]\\d{9}", , , , , , , [10]], [, , "2(?:1\\d{2}|2(?:2[1-46-9]|3[1-8]|4[1-7]|5[1-4]|6[1-8]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|3[1245]|4[1-7]|5[13-9]|[269][1-6]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", 
	, , , "2123456789"], [, , "69\\d{8}", , , , "6912345678"], [, , "800\\d{7}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567"], [, , "8(?:0[16]|12|25)\\d{7}", , , , "8011234567"], [, , "70\\d{8}", , , , "7012345678"], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "([27]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[2-9]1|[689]"]], [, "(2\\d{3})(\\d{6})", "$1 $2", ["2[2-9][02-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , 
	, , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GT:[, [, , "[2-7]\\d{7}|1[89]\\d{9}", , , , , , , [8, 11]], [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]], [, , "[345]\\d{7}", , , , "51234567", , , [8]], [, , "18[01]\\d{8}", , , , "18001112222", , , [11]], [, , "19\\d{9}", , , , "19001112222", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GT", 502, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], [, "(\\d{4})(\\d{3})(\\d{4})", 
	"$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GU:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[079]7|2[0167]|3[45]|47|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [, , "671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[0236-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[079]7|2[0167]|3[45]|47|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", 
	, , , "6713001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], GW:[, [, , "(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})", , , , , , , [7, 9]], [, , "443\\d{6}", 
	, , , "443201234", , , [9]], [, , "9(?:5(?:5\\d|6[0-2])|6(?:5[0-2]|6\\d|9[012])|77\\d)\\d{5}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["44|9[5-7]"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["40"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , 
	, , , , , [-1]]], GY:[, [, , "[2-46-9]\\d{6}", , , , , , , [7]], [, , "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}", , , , "2201234"], [, , "6\\d{6}", , , , "6091234"], [, , "(?:289|862)\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , 
	, , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HK:[, [, , "[2-7]\\d{7}|8[0-3]\\d{6,7}|9\\d{4,10}", , , , , , , [5, 6, 7, 8, 9, 11]], [, , "(?:2(?:[13-8]\\d|2[013-9]|9[0-24-9])|3(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69]|89)|58[01])\\d{5}", , , , "21234567", , , [8]], [, , "(?:464|5(?:[1-59][0-46-9]|6[0-4689]|7[0-469])|6(?:0[1-9]|[1459]\\d|[2368][0-57-9]|7[0-79])|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", , , , "51234567", , , [8]], [, , "800\\d{6}", , , , "800123456", 
	, , [9]], [, , "900(?:[0-24-9]\\d{7}|3\\d{1,4})", , , , "90012345678", , , [5, 6, 7, 8, 11]], [, , , , , , , , , [-1]], [, , "8(?:1[1-4679]|2[0-367]|3[02-47])\\d{5}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:[126-9]|30|5[09])?", , , , , , "00", , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|[89](?:0[1-9]|[1-9])"]], [, "(800)(\\d{3})(\\d{3})", "$1 $2 $3", ["800"]], [, "(900)(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["900"]], [, "(900)(\\d{2,5})", "$1 $2", ["900"]]], , [, 
	, "7(?:1[0-369]|[23][0-37-9]|47|5[1578]|6[0235]|7[278]|8[236-9]|9[025-9])\\d{5}", , , , "71234567", , , [8]], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]], HN:[, [, , "[237-9]\\d{7}", , , , , , , [8]], [, , "2(?:2(?:0[019]|1[1-36]|[23]\\d|4[04-6]|5[57]|7[013689]|8[0146-9]|9[012])|4(?:07|2[3-59]|3[13-689]|4[0-68]|5[1-35])|5(?:16|4[03-5]|5\\d|6[4-6]|74)|6(?:[056]\\d|17|3[04]|4[0-378]|[78][0-8]|9[01])|7(?:6[46-9]|7[02-9]|8[034])|8(?:79|8[0-35789]|9[1-57-9]))\\d{4}", 
	, , , "22123456"], [, , "[37-9]\\d{7}", , , , "91234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HR:[, [, , "[1-7]\\d{5,8}|[89]\\d{6,8}", , , , , , , [6, 7, 8, 9]], [, , "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", , , 
	, "12345678", , , [8, 9], [6, 7]], [, , "9(?:01\\d|[1259]\\d{2}|7(?:[0679]\\d|51)|8\\d{1,2})\\d{5}", , , , "921234567", , , [8, 9]], [, , "80[01]\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "6(?:[01]\\d{0,2}|[459]\\d{2})\\d{4}", , , , "611234", , , [6, 7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(1)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [, "([2-5]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", 
	["[2-5]"], "0$1"], [, "(9\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(6[01])(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "([67]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], [, "(80[01])(\\d{2})(\\d{2,3})", "$1 $2 $3", ["80[01]"], "0$1"], [, "(80[01])(\\d{3})(\\d{3})", "$1 $2 $3", ["80[01]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:62\\d?|72)\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]], HT:[, [, , "[2-489]\\d{7}", 
	, , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "[34]\\d{7}", , , , "34101234"], [, , "8\\d{7}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:9(?:[67][0-4]|8[0-3589]|9\\d))\\d{5}", , , , "98901234"], "HT", 509, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], HU:[, [, , "[1-9]\\d{7,8}", 
	, , , , , , [8, 9], [6]], [, , "(?:1\\d|2[2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|7[2-9]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6]], [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]], [, , "[48]0\\d{6}", , , , "80123456", , , [8]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "21\\d{7}", , , , "211234567", , , [9]], "HU", 36, "00", "06", , , "06", , , , [[, "(1)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "($1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", 
	"$1 $2 $3", ["[2-9]"], "($1)"]], , [, , , , , , , , , [-1]], , , [, , "[48]0\\d{6}", , , , "80123456", , , [8]], [, , "38\\d{7}", , , , "381234567", , , [9]], , , [, , , , , , , , , [-1]]], ID:[, [, , "(?:[1-79]\\d{6,10}|8\\d{7,11})", , , , , , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , "2(?:1(?:14\\d{3}|[0-8]\\d{6,7}|500\\d{3}|9\\d{6})|2\\d{6,8}|4\\d{7,8})|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:19?|[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", 
	, , , "612345678", , , [7, 8, 9, 10, 11], [5, 6]], [, , "(?:2(?:1(?:3[145]|4[01]|5[1-469]|60|8[0359]|9\\d)|2(?:88|9[1256])|3[1-4]9|4(?:36|91)|5(?:1[349]|[2-4]9)|6[0-7]9|7(?:[1-36]9|4[39])|8[1-5]9|9[1-48]9)|3(?:19[1-3]|2[12]9|3[13]9|4(?:1[69]|39)|5[14]9|6(?:1[69]|2[89])|709)|4[13]19|5(?:1(?:19|8[39])|4[129]9|6[12]9)|6(?:19[12]|2(?:[23]9|77))|7(?:1[13]9|2[15]9|419|5(?:1[89]|29)|6[15]9|7[178]9))\\d{5,6}|8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "177\\d{6,8}|800\\d{5,7}", , , 
	, "8001234567", , , [8, 9, 10, 11]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "0(?:0[1789]|10(?:00|1[67]))", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,8})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["2[035-9]|[36][02-9]|[4579]"], "(0$1)"], [, "(8\\d{2})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(8\\d{2})(\\d{4})(\\d{4,5})", "$1-$2-$3", 
	["8[1-35-9]"], "0$1"], [, "(1)(500)(\\d{3})", "$1 $2 $3", ["150", "1500"], "$1"], [, "(177)(\\d{6,8})", "$1 $2", ["177"], "0$1"], [, "(800)(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(804)(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(80\\d)(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80[79]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "8071\\d{6}", , , , "8071123456", , , [10]], [, , "1500\\d{3}|8071\\d{6}", , , , "8071123456", , , [7, 10]], , , [, , , , , , , , , [-1]]], IE:[, [, , "[124-9]\\d{6,9}", 
	, , , , , , [7, 8, 9, 10], [5, 6]], [, , "1\\d{7,8}|2(?:1\\d{6,7}|3\\d{7}|[24-9]\\d{5})|4(?:0[24]\\d{5}|[1-469]\\d{7}|5\\d{6}|7\\d{5}|8[0-46-9]\\d{7})|5(?:0[45]\\d{5}|1\\d{6}|[23679]\\d{7}|8\\d{5})|6(?:1\\d{6}|[237-9]\\d{5}|[4-6]\\d{7})|7[14]\\d{7}|9(?:1\\d{6}|[04]\\d{7}|[35-9]\\d{5})", , , , "2212345", , , , [5, 6]], [, , "8(?:22\\d{6}|[35-9]\\d{7})", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "15(?:1[2-8]|[2-8]0|9[089])\\d{6}", , , , "1520123456", , , [10]], 
	[, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(1)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["40[24]|50[45]"], "(0$1)"], [, "(48)(\\d{4})(\\d{4})", "$1 $2 $3", ["48"], "(0$1)"], [, "(818)(\\d{3})(\\d{3})", "$1 $2 $3", ["818"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", 
	"$1 $2 $3", ["[24-69]|7[14]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["76|8[35-9]"], "0$1"], [, "(8\\d)(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8[35-9]5"], "0$1"], [, "(700)(\\d{3})(\\d{3})", "$1 $2 $3", ["700"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:5|8[059])", "1(?:5|8[059]0)"], "$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "8[35-9]5\\d{7}", , , , "8551234567", 
	, , [10]]], IL:[, [, , "1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}", , , , , , , [4, 7, 8, 9, 10, 11, 12]], [, , "(?:153\\d{1,2}|[2-489])\\d{7}", , , , "21234567", , , [8, 11, 12], [7]], [, , "5(?:[0-47-9]\\d{2}|5(?:01|2[23]|3[2-4]|4[45]|5[5689]|6[6-8]|7[0178]|8[6-9]|9[2-9])|6[2-9]\\d)\\d{5}", , , , "501234567", , , [9]], [, , "1(?:80[019]\\d{3}|255)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1(?:212|(?:9(?:0[01]|19)|200)\\d{2})\\d{4}", , , , "1919123456", , , [8, 9, 10]], [, , 
	"1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , "7(?:18\\d|2[23]\\d|3[237]\\d|47\\d|6[58]\\d|7\\d{2}|8(?:2\\d|33|55|77|81)|9[2579]\\d)\\d{5}", , , , "771234567", , , [9]], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "([2-489])(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "([57]\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(153)(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["153"]], [, "(1)([7-9]\\d{2})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], 
	[, "(1255)(\\d{3})", "$1-$2", ["125", "1255"]], [, "(1200)(\\d{3})(\\d{3})", "$1-$2-$3", ["120", "1200"]], [, "(1212)(\\d{2})(\\d{2})", "$1-$2-$3", ["121", "1212"]], [, "(1599)(\\d{6})", "$1-$2", ["159", "1599"]], [, "(151)(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["151"]], [, "(\\d{4})", "*$1", ["[2-689]"]]], , [, , , , , , , , , [-1]], , , [, , "1700\\d{6}|[2-689]\\d{3}", , , , "1700123456", , , [4, 10]], [, , "[2-689]\\d{3}|1599\\d{6}", , , , "1599123456", , , [4, 10]], , , [, , "151\\d{8,9}", 
	, , , "15112340000", , , [11, 12]]], IM:[, [, , "[135789]\\d{6,9}", , , , , , , [10], [6]], [, , "1624[5-8]\\d{5}", , , , "1624756789", , , , [6]], [, , "7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"], [, , "808162\\d{4}", , , , "8081624567"], [, , "(?:872299|90[0167]624)\\d{4}", , , , "9016247890"], [, , "8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}", , , , "8456247890"], [, , "70\\d{8}", , , , "7012345678"], [, , "56\\d{8}", , , , "5612345678"], "IM", 44, "00", "0", , , "0", , , , , , 
	[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}", , , , "5512345678"], , , [, , , , , , , , , [-1]]], IN:[, [, , "008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [, , "(?:11|2[02]|33|4[04]|79|80)[2-7]\\d{7}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|[36][25]|22|4[28]|5[12]|[78]1|9[15])|6(?:12|[2345]1|57|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[13-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1-5]|4[25-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|[57][2-689]|6[24-578]|8[1-6])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d|7(?:(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|9\\d)\\d|8(?:2[0-6]|[013-8]\\d)))[2-7]\\d{5}", 
	, , , "1123456789", , , [10], [6, 7, 8]], [, , "(?:6(?:00[1-3]\\d|28[0-2]\\d|3(?:5(?:0[0-6]|1\\d)|[89]0\\d)|900\\d)|7(?:0\\d{3}|19[0-5]\\d|2(?:[0235679]\\d{2}|[14][017-9]\\d|8(?:[0-59]\\d|[678][089]))|3(?:[05-8]\\d{2}|1(?:[089]\\d|11|7[5-8])|2(?:[0-49][089]|[5-8]\\d)|3[017-9]\\d|4(?:[07-9]\\d|11)|9(?:[016-9]\\d|[2-5][089]))|4(?:0\\d{2}|1(?:[015-9]\\d|[23][089]|4[089])|2(?:0[089]|[1-7][089]|[89]\\d)|3(?:[0-8][089]|9\\d)|4(?:[089]\\d|11|7[02-8])|[56]\\d[089]|7(?:[089]\\d|11|7[02-8])|8(?:[0-24-7][089]|[389]\\d)|9(?:[0-6][089]|7[089]|[89]\\d))|5(?:[0346-8]\\d{2}|1(?:[07-9]\\d|11)|2(?:[04-9]\\d|[123][089])|5[017-9]\\d|9(?:[0-6][089]|[7-9]\\d))|6(?:0(?:[0-47]\\d|[5689][089])|(?:1[0-257-9]|[6-9]\\d)\\d|2(?:[0-4]\\d|[5-9][089])|3(?:[02-8][089]|[19]\\d)|4\\d[089]|5(?:[0-367][089]|[4589]\\d))|7(?:0(?:0[02-9]|[13-7][089]|[289]\\d)|[1-9]\\d{2})|8(?:[0-79]\\d{2}|8(?:[089]\\d|11|7[02-9]))|9(?:[089]\\d{2}|313|7(?:[02-8]\\d|9[07-9])))|8(?:0(?:[01589]\\d{2}|6[67]\\d|7(?:[02-8]\\d|9[05-9]))|1(?:[02-57-9]\\d{2}|1(?:[0-35-9]\\d|4[0-46-9])|6(?:[089]\\d|7[02-8]))|2(?:0(?:[089]\\d|7[02])|[14](?:[089]\\d|7[02-8])|[235-9]\\d{2})|3(?:[0357-9]\\d{2}|1(?:[089]\\d|7[02-6])|2(?:[09]\\d|77|8[0-689])|4\\d{2}|6(?:[089]\\d|7[02-7]))|[45]\\d{3}|6(?:[02457-9]\\d{2}|1(?:[089]\\d|7[02-8])|3(?:[089]\\d|7[02-8])|6(?:[08]\\d|7[02-8]|9\\d))|7(?:0[07-9]\\d|[1-69]\\d{2}|[78](?:[089]\\d|7[02-8]))|8(?:[0-25-9]\\d{2}|3(?:[089]\\d|7[02-8])|4(?:[0489]\\d|7[02-68]))|9(?:[02-9]\\d{2}|1(?:[0289]\\d|7[2-6])))|9\\d{4})\\d{5}", 
	, , , "8123456789", , , [10]], [, , "00800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{8})", "$1", ["561", "5616", "56161"], "$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["6(?:[09]0|28|3[589])|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9", "6(?:[09]0|28[0-2]|3(?:5[01]|[89]0))|7(?:[07]|19[0-5]|2(?:[0235-9]|[14][017-9])|3(?:[025-9]|[134][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02-46-9]|[15][017-9])|6(?:[02-9]|1[0-257-9])|8(?:[0-79]|8[0189])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:[014][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9", 
	"6(?:[09]0|28[0-2]|3(?:5(?:0[0-6]|1)|[89]0))|7(?:0|19[0-5]|2(?:[0235-79]|[14][017-9]|8(?:[0-69]|[78][089]))|3(?:[05-8]|1(?:[0189]|7[5-9])|2(?:[0-49][089]|[5-8])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2-5][089]|7[0189]))|4(?:[056]|1(?:[0135-9]|[24][089])|[29](?:[0-7][089]|[89])|3(?:[0-8][089]|9)|[47](?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389]))|5(?:[0346-9]|[15][017-9]|2(?:[03-9]|[12][089]))|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[05-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:0(?:[089]|7[02])|[14](?:[089]|7[02-8])|[235-9])|3(?:[03-57-9]|1(?:[089]|7[02-6])|2(?:[09]|77|8[0-689])|6(?:[089]|7[02-7]))|[45]|6(?:[02457-9]|[136](?:[089]|7[02-8]))|7(?:0[07-9]|[1-69]|[78](?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-68]))|9(?:[02-9]|1(?:[0289]|7[2-6])))|9"], 
	"0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-9]|80[2-46]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68][1-9]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"], 
	"0$1", , 1], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[23579]|[468][1-9])|[2-8]"], "0$1", , 1], [, "(\\d{2})(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3 $4", ["008"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], "$1", , 1], [, "(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["160", "1600"], "$1", , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], "$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["180", "1800"], "$1", , 1], [, "(\\d{4})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["186", 
	"1860"], "$1", , 1], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18[06]"], "$1", , 1]], , [, , , , , , , , , [-1]], , , [, , "00800\\d{7}|1(?:600\\d{6}|8(?:0(?:0\\d{4,9}|3\\d{9})|6(?:0\\d{7}|[12]\\d{9})))", , , , "1800123456"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]], IO:[, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , 
	[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IQ:[, [, , "[1-7]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , 
	[-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(1)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "([2-6]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IR:[, [, , "[1-8]\\d{5,9}|9(?:[0-4]\\d{8}|9\\d{8})", , , , , , , [6, 7, 10], [4, 5, 
	8]], [, , "(?:(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:\\d{8}|(?:[16]|[289]\\d?)\\d{3}))|94(?:000|11[0-7]|2\\d{2}|30[01]|440)\\d{5}", , , , "2123456789", , , , [4, 5, 8]], [, , "9(?:0(?:[1-3]\\d{2}|44\\d)|[13]\\d{3}|2[0-2]\\d{2}|9(?:[01]\\d{2}|44\\d|810|9(?:0[013]|1[134]|21|9[89])))\\d{5}", , , , "9123456789", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:[2-6]0\\d|993)\\d{7}", , , , "9932123456", 
	, , [10]], "IR", 98, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["[1-8]"], "0$1"], [, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:9411[1-7]|94440)\\d{5}", , , , "9411110000", , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], IS:[, [, , "[4-9]\\d{6}|38\\d{7}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-245]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-79]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|87[23])\\d{4}", 
	, , , "4101234", , , [7]], [, , "38[589]\\d{6}|(?:6(?:1[1-8]|2[0-6]|3[027-9]|4[014679]|5[0159]|[67][0-69]|9\\d)|7(?:5[057]|[6-8]\\d)|8(?:2[0-59]|3[0-4]|[469]\\d|5[1-9]|88))\\d{4}", , , , "6111234"], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "90\\d{5}", , , , "9011234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49\\d{5}", , , , "4921234", , , [7]], "IS", 354, "1(?:0(?:01|10|20)|100)|00", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(3\\d{2})(\\d{3})(\\d{3})", 
	"$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:6(?:2[78]|8\\d)|8(?:7[0189]|80)|95[48])\\d{4}", , , , "6271234", , , [7]]], IT:[, [, , "[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})", , , , , , , [6, 7, 8, 9, 10, 11]], [, , "0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})", 
	, , , "0212345678"], [, , "3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})", , , , "3123456789", , , [9, 10, 11]], [, , "80(?:0\\d{6}|3\\d{3})", , , , "800123456", , , [6, 9]], [, , "0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{6}|[17]\\d{3})", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], 
	"IT", 39, "00", , , , , , , , [[, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|55"]], [, "(0[26])(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(0[26])(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(0\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], [, "(0\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["0[13-57-9][2-46-8]"]], [, "(0\\d{3})(\\d{2,6})", "$1 $2", ["0[13-57-9][2-46-8]"]], 
	[, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13]|8(?:00|4[08]|9[59])", "[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894", "894[5-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , "848123456", , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], JE:[, [, , "[135789]\\d{6,9}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [, , "7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}", 
	, , , "7797712345"], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , "8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}", , , , "8447034567"], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "0", , , , , , [, , "76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [, , "3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}", 
	, , , "5512345678"], , , [, , , , , , , , , [-1]]], JM:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "876(?:5(?:0[12]|1[0-468]|2[35]|63)|6(?:0[1-3579]|1[0237-9]|[23]\\d|40|5[06]|6[2-589]|7[05]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468]))\\d{4}", , , , "8765123456", , , , [7]], [, , "876(?:2[14-9]\\d|[348]\\d{2}|5(?:0[3-9]|[2-57-9]\\d|6[0-24-9])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579]))\\d{4}", , , , "8762101234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
	, , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], JO:[, [, , "[235-9]\\d{7,8}", , , , , , , [8, 9]], [, , "(?:2(?:6(?:2[0-35-9]|3[0-57-8]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[57][023]|6[03])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2[50]0|3(?:00|33)|4(?:0[0125]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[17-8]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[02-39]))|87(?:[02]0|7[08]|90))\\d{4}", 
	, , , "62001234", , , [8]], [, , "7(?:55[0-49]|7[025-9]\\d|8[0-25-9]\\d|9[0-25-9]\\d)\\d{5}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(7)(\\d{4})(\\d{4})", "$1 $2 $3", ["7[457-9]"], "0$1"], [, "(\\d{2})(\\d{7})", 
	"$1 $2", ["70"], "0$1"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["8[0158]|9"], "0$1"]], , [, , "74(?:66|77)\\d{5}", , , , "746612345", , , [9]], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]], JP:[, [, , "[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|2[2-9]\\d|[36][1-9]\\d|4(?:6[02-8]|[2-578]\\d|9[2-59])|5(?:6[1-9]|7[2-8]|[2-589]\\d)|7(?:3[4-9]|4[02-9]|[25-9]\\d)|8(?:3[2-9]|4[5-9]|5[1-9]|8[03-9]|[2679]\\d)|9(?:[679][1-9]|[2-58]\\d))\\d{6}", 
	, , , "312345678", , , [9]], [, , "[7-9]0[1-9]\\d{7}", , , , "9012345678", , , [10]], [, , "120\\d{6}|800\\d{7}|00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})", , , , "120123456"], [, , "990\\d{6}", , , , "990123456", , , [9]], [, , , , , , , , , [-1]], [, , "60\\d{7}", , , , "601234567", , , [9]], [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]], "JP", 81, "010", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", 
	"$1-$2-$3", ["800"], "0$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077"], "$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"], "$1"], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008", "0088"], "$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["00[36]", "00(?:37|66)"], "$1"], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["00[36]", "00(?:37|66)"], "$1"], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["00[36]", "00(?:37|66)"], "$1"], [, "(\\d{4})(\\d{6})(\\d{6,7})", "$1-$2-$3", 
	["00[36]", "00(?:37|66)"], "$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]0|80[1-9]"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"], 
	"0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])", "1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))", 
	"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))", 
	"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"], 
	"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)", "1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])", "1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", 
	"$1-$2-$3", ["2(?:[34]7|[56]9|74|9[14-79])|82|993"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2479][1-9]"], "0$1"]], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[2579]0|80[1-9]"], "0$1"], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", 
	"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))", "1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])", 
	"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))", 
	"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))", 
	"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"], 
	"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)", "1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])", "1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{4})", 
	"$1-$2-$3", ["2(?:[34]7|[56]9|74|9[14-79])|82|993"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2479][1-9]"], "0$1"]], [, , "20\\d{8}", , , , "2012345678", , , [10]], , , [, , "00(?:37\\d{6,13}|66\\d{6,13}|777(?:[01]\\d{2}|5\\d{3}|8\\d{4})|882[1245]\\d{4})", , , , "00777012"], [, , "570\\d{6}", , , , "570123456", , , [9]], , , [, , , , , , , , , [-1]]], KE:[, [, , "20\\d{6,7}|[4-9]\\d{6,9}", , , , , , , [7, 
	8, 9, 10]], [, , "20\\d{6,7}|4(?:0\\d{6,7}|[136]\\d{7}|[245]\\d{5,7})|5(?:[08]\\d{7}|[1-79]\\d{5,7})|6(?:[01457-9]\\d{5,7}|2\\d{7}|6\\d{6,7})", , , , "202012345", , , [7, 8, 9]], [, , "7(?:[0-3679]\\d|4[0-46-9]|5[0-6]|8[0-25-9])\\d{6}", , , , "712123456", , , [9]], [, , "800[24-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "005|0", , , , [[, 
	"(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KG:[, [, , "[235-8]\\d{8,9}", , , , , , , [9, 10], [5, 6]], [, , "(?:3(?:1(?:[256]\\d|3[1-9]|47)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", 
	, , , "312123456", , , [9], [5, 6]], [, , "(?:20[0-35]|5[0-24-7]\\d|7[07]\\d)\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[25-7]|31[25]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[36]|[2-9])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, 
	, , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KH:[, [, , "[1-9]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]], [, , "(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:[237-9]|4[56]|5\\d|6\\d?)\\d{5}|23(?:4[234]|8\\d{2})\\d{4}", , , , "23756789", , , [8, 9], [6, 7]], [, , "(?:1(?:[013-79]\\d|[28]\\d{1,2})|2[3-6]48|3(?:[18]\\d{2}|[2-6]48)|4[2-4]48|5[2-5]48|6(?:[016-9]\\d|[2-5]48)|7(?:[07-9]\\d|[16]\\d{2}|[2-5]48)|8(?:[013-79]\\d|8\\d{2})|9(?:6\\d{2}|7\\d{1,2}|[0-589]\\d))\\d{5}", 
	, , , "91234567", , , [8, 9]], [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]], [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KH", 855, "00[14-9]", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1\\d[1-9]|[2-9]"], "0$1"], [, "(1[89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[89]0", "1[89]00"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , 
	[-1]], , , [, , , , , , , , , [-1]]], KI:[, [, , "[2458]\\d{4}|3\\d{4,7}|[67]\\d{7}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|8[0-5])\\d{3}|(?:65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d{2}|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500)))\\d{3}", , , , "31234"], [, , "(?:6(?:200[01]|30[01]\\d)|7(?:200[01]|3(?:0[0-5]\\d|140)))\\d{3}", , , , "72001234", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d{2}|12(?:11|20))\\d{2}", 
	, , , "30010000", , , [8]], "KI", 686, "00", , , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KM:[, [, , "[3478]\\d{6}", , , , , , , [7]], [, , "7[4-7]\\d{5}", , , , "7712345"], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})", 
	"$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KN:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70))\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:5(?:5[6-8]|6[5-7])|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", 
	, , , "5002345678"], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KP:[, [, , "1\\d{9}|[28]\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "2\\d{7}|85\\d{6}", , , , "21234567", , , [8], [6, 7]], [, , "19[123]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , 
	, , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "2(?:[0-24-9]\\d{2}|3(?:[0-79]\\d|8[02-9]))\\d{4}", , , , "23821234", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KR:[, [, , "00(?:3\\d{8,9}|7\\d{9,11})|[1-7]\\d{4,9}|8\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 
	14], [3, 7]], [, , "2[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])(?:1\\d{2,3}|[1-9]\\d{6,7})", , , , "22123456", , , [5, 6, 8, 9, 10], [3, 7]], [, , "1[0-26-9]\\d{7,8}", , , , "1000000000", , , [9, 10]], [, , "(?:00(?:3(?:08|68\\d)|798\\d{1,3})|80\\d)\\d{6}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8}", , , , "5012345678", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[1259]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", 
	"0", , , "0(8[1-46-8]|85\\d{2})?", , , , [[, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1(?:5[246-9]|6[046-8]|8[03579])", "1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"], "$1", "0$CC-$1"], [, "(\\d{5})", "$1", ["1[016-9]1", "1[016-9]11", "1[016-9]114"], "0$1", "0$CC-$1"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60[2-9]|80"], 
	"0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]0"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030", "00308"], "$1", "0$CC-$1"], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["00[37]", "00(?:36|79)", "00(?:36|79)8"], "$1", "0$CC-$1"], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["007", "0079", "00798"], "$1", "0$CC-$1"]], [[, "(\\d{2})(\\d{3,4})", 
	"$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1(?:5[246-9]|6[046-8]|8[03579])", "1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"], "$1", "0$CC-$1"], [, "(\\d{5})", "$1", ["1[016-9]1", "1[016-9]11", "1[016-9]114"], "0$1", "0$CC-$1"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2[1-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60[2-9]|80"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", 
	["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]0"], "0$1", "0$CC-$1"]], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08|68\\d)|798\\d{1,3})\\d{6}", , , , "007981234567", , , [11, 12, 13, 14]], [, , "1(?:5(?:22|44|66|77|88|99)|6(?:00|44|6[16]|70|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]], KW:[, [, , "[12569]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:18\\d|2(?:[23]\\d{2}|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7])))\\d{4}", 
	, , , "22345678"], [, , "(?:5(?:[05]\\d{2}|1[0-7]\\d|2(?:22|5[25])|6[56]\\d)|6(?:0[034679]\\d|222|5[015-9]\\d|6\\d{2}|7(?:0[013-9]|[67]\\d)|9(?:[069]\\d|3[039]))|9(?:0[09]\\d|22\\d|4[01479]\\d|55\\d|6[0679]\\d|7(?:02|[1-9]\\d)|8[057-9]\\d|9\\d{2}))\\d{4}", , , , "50012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[16]|2(?:[0-35-9]|4[0-35-9])|52[25]|9[024-9]"]], 
	[, "(\\d{3})(\\d{5})", "$1 $2", ["244|5(?:[015]|6[56])"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KY:[, [, , "[3589]\\d{9}", , , , , , , [10], [7]], [, , "345(?:2(?:22|44)|444|6(?:23|38|40)|7(?:4[35-79]|6[6-9]|77)|8(?:00|1[45]|25|[48]8)|9(?:14|4[035-9]))\\d{4}", , , , "3452221234", , , , [7]], [, , "345(?:32[1-9]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|9(?:1[67]|2[2-9]|3[689]))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
	, , , "8002345678"], [, , "900[2-9]\\d{6}|345976\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "1", , , , , , [, , "345849\\d{4}", , , , "3458491234"], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], KZ:[, [, , "(?:33\\d|7\\d{2}|80[089])\\d{7}", , , , , , , [10]], [, , "33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}", 
	, , , "7123456789"], [, , "7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}", , , , "7710009998"], [, , "800\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567"], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567"], [, , "751\\d{7}", , , , "7511234567"], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , , [, , "751\\d{7}", , , , "7511234567"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LA:[, [, , "[2-8]\\d{7,9}", , , , , , , [8, 9, 10], [6]], 
	[, , "(?:2[13]|3(?:0\\d|[14])|[5-7][14]|41|8[1468])\\d{6}", , , , "21212862", , , [8, 9], [6]], [, , "20(?:2[2389]|5[24-689]|7[6-8]|9[125-9])\\d{6}", , , , "2023123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(20)(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["20"], "0$1"], [, "([2-8]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(30)(\\d{2})(\\d{2})(\\d{3})", 
	"$1 $2 $3 $4", ["30"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LB:[, [, , "[13-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:[14-6]\\d{2}|7(?:[2-57]\\d|62|8[0-7]|9[04-9])|8[02-9]\\d|9\\d{2})\\d{4}", , , , "1123456", , , [7]], [, , "(?:3\\d|7(?:[01]\\d|6[013-9]|8[89]|9[1-3])|81\\d)\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , 
	, [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], [, "([7-9]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["7(?:[01]|6[013-9]|8[89]|9[1-3])|[89][01]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LC:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "758(?:4(?:30|5[0-9]|6[2-9]|8[0-2])|57[0-2]|638)\\d{4}", 
	, , , "7584305678", , , , [7]], [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[01]))\\d{4}", , , , "7582845678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "LC", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "758", [, , , , , , , , , [-1]], [, , , , , , , , 
	, [-1]], , , [, , , , , , , , , [-1]]], LI:[, [, , "6\\d{8}|[23789]\\d{6}", , , , , , , [7, 9]], [, , "(?:2(?:01|1[27]|3\\d|6[02-578]|96)|3(?:7[0135-7]|8[048]|9[0269]))\\d{4}", , , , "2345678", , , [7]], [, , "6(?:5(?:09|1\\d|20)|6(?:0[0-6]|10|2[06-9]|39))\\d{5}|7(?:[37-9]\\d|42|56)\\d{4}", , , , "660234567"], [, , "80(?:02[28]|9\\d{2})\\d{2}", , , , "8002222", , , [7]], [, , "90(?:02[258]|1(?:23|3[14])|66[136])\\d{2}", , , , "9002222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
	[, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "0|10(?:01|20|66)", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[237-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[56]"]], [, "(69)(7\\d{2})(\\d{4})", "$1 $2 $3", ["697"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d{2}", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]], LK:[, [, , "[1-9]\\d{8}", , , , , , , [9], [7]], [, , "1(?:1[2-57]\\d{6}|973\\d{5})|(?:2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7]|[89]1)[2-57]\\d{6}", 
	, , , "112345678", , , , [7]], [, , "7[0125-8]\\d{7}", , , , "712345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LK", 94, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LR:[, [, , "2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}", 
	, , , , , , [7, 8, 9]], [, , "(?:2\\d{3}|33333)\\d{4}", , , , "21234567", , , [8, 9]], [, , "(?:20\\d{2}|330\\d|4[67]|5(?:55)?\\d|77\\d{2}|88\\d{2})\\d{5}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "332(?:02|[2-5]\\d)\\d{4}", , , , "332021234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(2\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "([4-5])(\\d{3})(\\d{3})", "$1 $2 $3", ["[45]"], 
	"0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LS:[, [, , "[2568]\\d{7}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", 
	"$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LT:[, [, , "[3-9]\\d{7}", , , , , , , [8]], [, , "(?:3[1478]|4[124-6]|52)\\d{6}", , , , "31234567"], [, , "6\\d{7}", , , , "61234567"], [, , "800\\d{5}", , , , "80012345"], [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "LT", 370, "00", "8", , , "[08]", , , , [[, "([34]\\d)(\\d{6})", 
	"$1 $2", ["37|4(?:1|5[45]|6[2-4])"], "(8-$1)", , 1], [, "([3-6]\\d{2})(\\d{5})", "$1 $2", ["3[148]|4(?:[24]|6[09])|528|6"], "(8-$1)", , 1], [, "([7-9]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", , 1], [, "(5)(2\\d{2})(\\d{4})", "$1 $2 $3", ["52[0-79]"], "(8-$1)", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "70[67]\\d{5}", , , , "70712345"], , , [, , , , , , , , , [-1]]], LU:[, [, , "[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})", , , , , , , [4, 5, 6, 
	7, 8, 9, 10, 11]], [, , "(?:2[2-9]\\d{2,9}|(?:3(?:[0-46-9]\\d|5[013-9])|[457]\\d{2}|8(?:0[2-9]|[13-9]\\d)|9(?:0[89]|[2-579]\\d))\\d{1,8})", , , , "27123456"], [, , "6[25-79][18]\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [, , "20(?:1\\d{5}|[2-689]\\d{1,7})", , , , "20201234", , , [4, 5, 6, 7, 8, 9, 10]], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)", 
	, , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], 
	, "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})", "$1 $2 $3 $4", ["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:0[2-9]|[1-9])|9(?:0[2-46-9]|[1-9])"], , "$CC $1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["70|80[01]|90[015]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LV:[, [, , "[2689]\\d{7}", , , , , , , [8]], [, , "6\\d{7}", , , , "63123456"], [, , 
	"2\\d{7}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[, "([2689]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2689]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], LY:[, [, , "[25679]\\d{8}", , , , , , , [9], [7]], [, , "(?:2[1345]|5[1347]|6[123479]|71)\\d{7}", , , , 
	"212345678", , , , [7]], [, , "9[1-6]\\d{7}", , , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LY", 218, "00", "0", , , "0", , , , [[, "([25-79]\\d)(\\d{7})", "$1-$2", ["[25-79]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MA:[, [, , "[5-9]\\d{8}", , , , , , , [9]], [, , "5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}", 
	, , , "520123456"], [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[07]))\\d{6}", , , , "650123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5924[01]\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "([5-7]\\d{2})(\\d{6})", "$1-$2", ["5(?:2[015-7]|3[0-4])|[67]"], "0$1"], [, "([58]\\d{3})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|92)|892", "5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"], 
	"0$1"], [, "(5\\d{4})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]"], "0$1"], [, "([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:4[067]|5[03])"], "0$1"], [, "(8[09])(\\d{7})", "$1-$2", ["8(?:0|9[013-9])"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MC:[, [, , "[34689]\\d{7,8}", , , , , , , [8, 9]], [, , "870\\d{5}|9[2-47-9]\\d{6}", , , , "99123456", , , [8]], [, , "3\\d{7}|4(?:4\\d|5[1-9])\\d{5}|6\\d{8}", 
	, , , "612345678"], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[39]"], "$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["8"], "$1"]], , [, , , , , , , , , [-1]], , , 
	[, , "870\\d{5}", , , , "87012345", , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MD:[, [, , "[235-9]\\d{7}", , , , , , , [8]], [, , "(?:2[1-9]\\d|3[1-79]\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"], [, , "(?:562|6\\d{2}|7(?:[189]\\d|6[07]|7[457-9]))\\d{5}", , , , "62112345"], [, , "800\\d{5}", , , , "80012345"], [, , "90[056]\\d{5}", , , , "90012345"], [, , "808\\d{5}", , , , "80812345"], [, , , , , , , , , [-1]], [, , "3[08]\\d{6}", , , , "30123456"], "MD", 373, "00", "0", 
	, , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "([25-7]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["2[13-9]|[5-7]"], "0$1"], [, "([89]\\d{2})(\\d{5})", "$1 $2", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "803\\d{5}", , , , "80312345"], , , [, , , , , , , , , [-1]]], ME:[, [, , "[2-9]\\d{7,8}", , , , , , , [8], [6]], [, , "(?:20[2-8]|3(?:0[2-7]|[12][235-7]|3[24-7])|4(?:0[2-467]|1[267])|5(?:0[2467]|1[267]|2[2367]))\\d{5}", , , , "30234567", 
	, , , [6]], [, , "6(?:00\\d|3[024]\\d|6[0-25]\\d|[7-9]\\d{2})\\d{4}", , , , "67622901"], [, , "80[0-258]\\d{5}", , , , "80080002"], [, , "(?:9(?:4[1568]|5[178]))\\d{5}", , , , "94515151"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780"], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]|6[036-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012"], , , [, 
	, , , , , , , , [-1]]], MF:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "590(?:[02][79]|13|5[0-268]|[78]7)\\d{4}", , , , "590271234"], [, , "690(?:0[05-9]|[1-9]\\d)\\d{4}", , , , "690001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MF", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MG:[, [, , "[23]\\d{8}", 
	, , , , , , [9], [7]], [, , "20(?:2\\d{2}|4[47]\\d|5[3467]\\d|6[279]\\d|7(?:2[29]|[35]\\d)|8[268]\\d|9[245]\\d)\\d{4}", , , , "202123456", , , , [7]], [, , "3[2-49]\\d{7}", , , , "321234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "0", , , , [[, "([23]\\d)(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], 
	[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MH:[, [, , "[2-6]\\d{6}", , , , , , , [7]], [, , "(?:247|528|625)\\d{4}", , , , "2471234"], [, , "(?:235|329|45[56]|545)\\d{4}", , , , "2351234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "635\\d{4}", , , , "6351234"], "MH", 692, "011", "1", , , "1", , , , [[, "(\\d{3})(\\d{4})", "$1-$2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
	, , [, , , , , , , , , [-1]]], MK:[, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:2(?:[23]\\d|5[124578]|6[01])|3(?:1[3-6]|[23][2-6]|4[2356])|4(?:[23][2-6]|4[3-6]|5[256]|6[25-8]|7[24-6]|8[4-6]))\\d{5}", , , , "22212345", , , , [6, 7]], [, , "7(?:[0-25-8]\\d{2}|32\\d|421|9[23]\\d)\\d{4}", , , , "72345678"], [, , "800\\d{5}", , , , "80012345"], [, , "5[02-9]\\d{6}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
	"MK", 389, "00", "0", , , "0", , , , [[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "([347]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "([58]\\d{2})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ML:[, [, , "[246-9]\\d{7}", , , , , , , [8]], [, , "(?:2(?:0(?:2\\d|7[0-8])|1(?:2[5-7]|[3-689]\\d))|44[1239]\\d)\\d{4}", , , , "20212345"], [, , "(?:2(?:079|17\\d)|[679]\\d{3}|8[239]\\d{2})\\d{4}", 
	, , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[246-9]"]], [, "(\\d{4})", "$1", ["67|74"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[246-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MM:[, [, , "[178]\\d{5,7}|[24-6]\\d{5,8}|9(?:[279]\\d{0,2}|5|[34]\\d{1,2}|6(?:\\d{1,2})?|8(?:\\d{2})?)\\d{6}", 
	, , , , , , [6, 7, 8, 9, 10], [5]], [, , "1(?:2\\d{1,2}|[35]\\d|4(?:\\d|2[236]|39)|6\\d?|[89][0-6]\\d)\\d{4}|2(?:2(?:000\\d{3}|\\d{4})|3\\d{4}|4(?:0\\d{5}|26\\d{4}|39\\d{4}|\\d{4})|5(?:1\\d{3,6}|[02-9]\\d{3,5})|[6-9]\\d{4})|4(?:2[245-8]|3(?:2(?:02)?|[346]|56?)|[46][2-6]|5[3-5])\\d{4}|5(?:2(?:2(?:\\d{1,2})?|[3-8])|3[2-68]|4(?:21?|[4-8])|5[23]|6[2-4]|7[2-8]|8[24-7]|9[2-7])\\d{4}|6(?:0[23]|1(?:2(?:0|4\\d)?|[356])|2[2-6]|3[24-6]|4(?:2(?:4\\d)?|[3-6])|5[2-4]|6[2-8]|7(?:[2367]|4(?:\\d|39)|5\\d?|8[145]\\d)|8[245]|9(?:20?|4))\\d{4}|7(?:[04][24-8]|1(?:20?|[3-7])|22|3[2-4]|5[2-7])\\d{4}|8(?:1(?:2\\d{1,2}|[3-689]\\d)|2(?:2\\d|3(?:\\d|20)|[4-8]\\d)|3[24]\\d|4[24-7]\\d|5[245]\\d|6[23]\\d)\\d{3}", 
	, , , "1234567", , , [6, 7, 8, 9], [5]], [, , "17[01]\\d{4}|9(?:2(?:[0-4]|5\\d{2}|6[0-5]\\d)|3(?:[0-36]|4[069])\\d|4(?:0[0-4]\\d|[1379]\\d|2\\d{2}|4[0-589]\\d|5\\d{2}|88)|5[0-6]|6(?:1\\d|9\\d{2}|\\d)|7(?:3\\d|[6-9]\\d{2})|8(?:\\d|9\\d{2})|9(?:1\\d|[5-7]\\d{2}|[089]))\\d{5}", , , , "92123456", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1333\\d{4}", , , , "13331234", , , [8]], "MM", 95, "00", "0", , , "0", , , , 
	[[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1|2[245]"], "0$1"], [, "(2)(\\d{4})(\\d{4})", "$1 $2 $3", ["251"], "0$1"], [, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["432|67|81"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3,4})", "$1 $2 $3", ["[4-8]"], "0$1"], [, "(9)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(9)([34]\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:3[0-36]|4[0-57-9])"], "0$1"], [, "(9)(\\d{3})(\\d{3})(\\d{3})", 
	"$1 $2 $3 $4", ["92[56]"], "0$1"], [, "(9)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["93"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MN:[, [, , "[12]\\d{7,9}|[57-9]\\d{7}", , , , , , , [8, 9, 10], [6, 7]], [, , "[12](?:1\\d|2(?:[1-3]\\d?|7\\d)|3[2-8]\\d{1,2}|4[2-68]\\d{1,2}|5[1-4689]\\d{1,2})\\d{5}|5[0568]\\d{6}", , , , "50123456", , , , [6, 7]], [, , "(?:8(?:[05689]\\d|3[01])|9[013-9]\\d)\\d{5}", , , , "88123456", 
	, , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "7[05-8]\\d{6}", , , , "75123456", , , [8]], "MN", 976, "001", "0", , , "0", , , , [[, "([12]\\d)(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "([12]2\\d)(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "([12]\\d{3})(\\d{5})", "$1 $2", ["[12](?:27|[3-5])", "[12](?:27|[3-5]\\d)2"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"], "$1"], [, "([12]\\d{4})(\\d{4,5})", "$1 $2", 
	["[12](?:27|[3-5])", "[12](?:27|[3-5]\\d)[4-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MO:[, [, , "[268]\\d{7}", , , , , , , [8]], [, , "(?:28[2-57-9]|8(?:11|[2-57-9]\\d))\\d{5}", , , , "28212345"], [, , "6(?:[2356]\\d|8[158])\\d{5}", , , , "66123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , 
	[[, "([268]\\d{3})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MP:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "670(?:2(?:3[3-7]|56|8[5-8])|32[1238]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", 
	, , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MQ:[, [, , "[56]\\d{8}", , , , , , , [9]], [, , "596(?:0[2-5]|[12]0|3[05-9]|4[024-8]|[5-7]\\d|89|9[4-8])\\d{4}", 
	, , , "596301234"], [, , "696(?:[0-47-9]\\d|5[0-6]|6[0-4])\\d{4}", , , , "696201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MQ", 596, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MR:[, [, , "[2-48]\\d{7}", , , , , , , [8]], [, , "25[08]\\d{5}|35\\d{6}|45[1-7]\\d{5}", 
	, , , "35123456"], [, , "[234][0-46-9]\\d{6}", , , , "22123456"], [, , "800\\d{5}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MR", 222, "00", , , , , , , , [[, "([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MS:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "664491\\d{4}", , , 
	, "6644912345", , , , [7]], [, , "66449[2-6]\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MT:[, [, , "[2357-9]\\d{7}", , 
	, , , , , [8]], [, , "2(?:0(?:[169]\\d|3[1-4])|[1-357]\\d{2})\\d{4}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d{2})|9(?:2(?:1[01]|31)|69[67]|8(?:1[1-3]|89|97)|9\\d{2}))\\d{4}", , , , "96961234"], [, , "800[3467]\\d{4}", , , , "80071234"], [, , "5(?:0(?:0(?:37|43)|6\\d{2}|70\\d|9[0168]\\d)|[12]\\d0[1-5])\\d{3}", , , , "50037123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , "7117\\d{4}", 
	, , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]], MU:[, [, , "[2-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:2(?:[03478]\\d|1[0-7]|6[1-69])|4(?:[013568]\\d|2[4-7])|5(?:44\\d|471)|6\\d{2}|8(?:14|3[129]))\\d{4}", , , , "2012345"], [, , "5(?:2[59]\\d|4(?:2[1-389]|4\\d|7[1-9]|9\\d)|7\\d{2}|8(?:[0-25689]\\d|4[3479]|7[15-8])|9[0-8]\\d)\\d{4}", , , , "52512345", , , [8]], [, , "80[012]\\d{4}", , , , "8001234", , , [7]], [, , "30\\d{5}", , 
	, , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[2-7]0|33)", , , , , , "020", , [[, "([2-46-9]\\d{2})(\\d{4})", "$1 $2", ["[2-46-9]"]], [, "(5\\d{3})(\\d{4})", "$1 $2", ["5"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MV:[, [, , "[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})", , , , , , , [7, 10]], [, , "(?:3(?:0[0-3]|3[0-59])|6(?:[57][02468]|6[024568]|8[024689]))\\d{4}", 
	, , , "6701234", , , [7]], [, , "(?:46[46]|7[2-9]\\d|9[15-9]\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9(?:0[1-9]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]00"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , 
	"4[05]0\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]], MW:[, [, , "(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}", , , , , , , [7, 9]], [, , "(?:1[2-9]|21\\d{2})\\d{5}", , , , "1234567"], [, , "(?:111|77\\d|88\\d|99\\d)\\d{6}", , , , "991234567", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MW", 265, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [, "(2\\d{2})(\\d{3})(\\d{3})", 
	"$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[17-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MX:[, [, , "[1-9]\\d{9,10}", , , , , , , [10, 11], [7, 8]], [, , "(?:33|55|81)\\d{8}|(?:2(?:0[01]|2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[234][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7}", 
	, , , "2221234567", , , [10], [7, 8]], [, , "1(?:(?:33|55|81)\\d{8}|(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-6][1-9]|[37][1-8]|8[1-35-9]|9[2-689])|5(?:88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[12457-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2[1-8]|5[13-9]|8[1-69]|9[17])|8(?:2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))\\d{7})", , , , "12221234567", 
	, , [11]], [, , "8(?:00|88)\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , "300\\d{7}", , , , "3001234567", , , [10]], [, , "500\\d{7}", , , , "5001234567", , , [10]], [, , , , , , , , , [-1]], "MX", 52, "0[09]", "01", , , "0[12]|04[45](\\d{10})", "1$1", , , [[, "([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["33|55|81"], "01 $1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"], "01 $1", , 1], [, "(1)([358]\\d)(\\d{4})(\\d{4})", 
	"044 $2 $3 $4", ["1(?:33|55|81)"], "$1", , 1], [, "(1)(\\d{3})(\\d{3})(\\d{4})", "044 $2 $3 $4", ["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"], "$1", , 1]], [[, "([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["33|55|81"], "01 $1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"], "01 $1", , 1], [, "(1)([358]\\d)(\\d{4})(\\d{4})", "$1 $2 $3 $4", ["1(?:33|55|81)"]], [, "(1)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"]]], 
	[, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MY:[, [, , "[13-9]\\d{7,9}", , , , , , , [8, 9, 10], [6, 7]], [, , "(?:3(?:2(?:0(?:11|2[0-8]|3[0-24-79]|[579]\\d|8[0-57-9])|1(?:0[6-9]|1[03-9]|[467]\\d|8[0-2]|9[13])|2(?:0[1-3]|2[2-4]|4[0-25-7]|6[0-8]|7[02-689]|8\\d|9[5-9])|3(?:0[0-3]|3[0-36]|8[0-35-9]|9[1-3])|6(?:0[0-5]|[139]\\d|8[15-8])|7(?:1\\d|2[0-7]|3[0-3]|42|7[0-356]|8[0-35-8])|8(?:00|4[78]|5[6-9])|93[58])|3(?:0(?:0[0-35-9]|10|5[01]|8[0-6]|9[39])|1(?:0[1-39]|10|2[02-469]|3[245]|4[0-3589]|6[0-35-9]|7[067]|8[0-57]|9[0-278])|2(?:1[3467]|2[45]|4[1-3]|5[0689]|6[04589]|7[0-3579]|8[0-489]|9[0-27])|3(?:1[7-9]|2[1-6]|4[1-689]|5[89]|6[1-3]|7\\d|8[125]|9[236])|6(?:[12]0|3[01]|5[0-256]|6[08]|8[45]))|4(?:0(?:09|[14]\\d|2[0-8]|3[12]|5[01]|65)|1(?:0[0-8]|31|4\\d|6[12])|2(?:17|5[0-35-9]|6[024-6]|7[0189]|8[057-9]|9\\d)|770|8(?:0[0-2]|1[0-3569]|2[01]))|5(?:0(?:2[0-2]|3[0-35-9])|1(?:0[1-3]|1[05]|2[0-6]|31|6[1-7]|9[1258])|270|48[0-5]|5(?:1\\d|2[0-6]|4[0-589]|6[125-9]|9[01])|6(?:1[1-4]|2[0-589]|3\\d|5[0-3])|7(?:21|40)|8(?:7[06-9]|8[025-9]|9[12]))|6(?:0(?:2[0-28]|3[24-9]|4[246-9]|5[57]|6[13-6]|7[358]|8[1247]|9[0-59])|1(?:[04][0-58]|15|2[02-8]|3[015-9]|5[016-8]|7[7-9]|8[14-9]|9[1-356])|2(?:[05]\\d|11|[46][1-3]|7[02-79]|8[015-7])|303|4(?:1[129]|2[01]|3[36]|6[0-2])|690|7(?:3\\d|89))|7(?:118|2(?:0[02]|6[01])|4(?:[59]\\d|8[01])|6(?:1[01]|2\\d|5[0-2]|6[0-69])|7(?:1[0-37-9]|[28]\\d|3[1-5]|7[0-3])|8(?:[04]\\d|3[129]|59|6[1-356]|7[02-79]|8[02-7]|90)|9(?:10|3[1-3]|4[016-9]|[56]\\d|7[12]|8\\d))|8(?:0(?:0[08]|11|2[0-7]|5[12]|6\\d|7[013-69]|8[0-24]|9[0-5])|100|21[0-36]|3(?:08|1\\d|2[0-589]|31)|408|5(?:2[0-35-79]|88)|6(?:0[0-259]|5[5-79]|6[01]|8[46-9]|9[019])|7(?:0[35-8]|2[3-7]|3\\d|4[0149]|5[0-2]|6[016-9]|7[5-9]|8[037]|90)|8(?:00|61|7[0-3]|8\\d|9[0-4])|9(?:1[1-3]|[2-5]\\d|6[1-4689]|8[89]|9[0-689]))|9(?:0(?:1[0-289]|2[15]|5[014-9]|7[04-68]|8[0-256])|1(?:0[0-356]|3[0-49]|4[015]|7[0-59]|9[15])|2(?:0[0-25-7]|12|2[1-6]|3[1256]|7[14]|8\\d)|3[68]8|41[01]|5(?:14|2[01]|4[03-9]|6[5-79]|7[0-2569])))\\d|4(?:2(?:0[01]|1[07-9]|2[02-46-9]|38|4[0-28]|5[0-589]|6[0-47-9]|8[0-389]|9[0-38])\\d|3(?:0[5-9]|[12][034]|3[0-37]|47|5[168]|6[7-9]|7[0135-8]|8\\d|9[0-27-9])\\d|4(?:[02-9]\\d{2}|1(?:[02-9]\\d|10))|5(?:[07]\\d{2}|1[0-358]\\d|2[1246]\\d|3[06-9]\\d|4[0589]\\d|5[12457-9]\\d|6[0-689]\\d|8(?:[0-57-9]\\d|60)|9(?:[2-57-9]\\d|60))|6(?:0[79]|1[0-689]|2[0135-9]|[3-5]\\d|6[07-9]|7[23]|8[03-9]|99)\\d|7(?:0[0-59]\\d|1[04679]\\d|2(?:[02-9]\\d|10)|[37]\\d{2}|4(?:[0178]\\d|5[0-6])|5(?:[0-57-9]\\d|60)|6[024-689]\\d|8[0-79]\\d|9(?:[0479]\\d|3[01]))|8(?:1[0189]\\d|2[046-9]\\d|3[058]\\d|5[029]\\d|6(?:[0689]\\d|40)|8[14568]\\d|9[0-389]\\d)|9(?:0[1368]\\d|1[13-9]\\d|[27]\\d{2}|3(?:[0-368]\\d|7[0-3])|4[013-79]\\d|5[0-35689]\\d|6[0-46-9]\\d|8[0-24-9]\\d|97\\d))|5(?:2(?:0[13589]\\d|1[0-2]\\d|2[056]\\d|3(?:[067]\\d|2[01])|4[0-69]\\d|5[3-6]\\d|8[0-25-9]\\d|9[0-469]\\d)|3(?:[12][0-38]|3[0-37]|4[89]|5[01346-9]|[67]\\d|8[01589]|95)\\d|4(?:0[1346]\\d|1[02-35-9]\\d|2[1379]\\d|3[0-46-9]\\d|4[013689]\\d|[59]\\d{2}|6(?:[15-9]\\d|20)|7[036-9]\\d|8[015-8]\\d)|5(?:0[167]\\d|17\\d|2[025-9]\\d|3[035-7]\\d|4[0-35-9]\\d|8[13]\\d|9(?:[124-9]\\d|31))|6(?:0[89]\\d|1[02-46-8]\\d|2[0-69]\\d|3(?:[1-367]\\d|40)|4[0-689]\\d|5(?:[0-24-9]\\d|30)|6[1457-9]\\d|7\\d{2}|8[0-57-9]\\d|9[0-389]\\d)|7(?:1(?:[024679]\\d|80)|2[0-35-8]\\d|3[23]\\d|4[34]\\d|5[0-36-9]\\d|6[356-9]\\d|7\\d{2}|8(?:[23]\\d|[01]1)|9(?:[1-689]\\d|70))|8(?:0[145-9]\\d|1[0-2]\\d|2[09]\\d|3(?:[058]\\d|0[017])|4[016-9]\\d|5[02-9]\\d|7(?:10|2\\d)|8[013589]\\d|9[0-57-9]\\d)|9[23]0\\d)|6(?:2(?:2[1246-9]\\d|3[0-5]\\d|4[02]\\d|5[1-3]\\d|[68]\\d{2}|7(?:[04-8]\\d|10)|9[2-5]\\d)|3(?:1(?:[125-9]\\d|3[01])|3[0-7]\\d|5[0-478]\\d|79\\d|8[3-578]\\d|9[018]\\d)|4(?:1[015]|[2-689]\\d|7[1-79])\\d|5(?:09\\d|1(?:10|[2479]\\d)|2[1-579]\\d|3(?:[0-467]\\d|50)|4[0-24-9]\\d|5\\d{2}|60\\d)|6(?:0[13]\\d|1[0-57]\\d|2[03]\\d|3[0-478]\\d|4[0-8]\\d|5[013-689]\\d|6[0-467]\\d|[78]\\d{2}|9(?:[13-9]\\d|20))|7(?:01|2[06-9]|3[367]|5[7-9]|6\\d|7[0156]|8[12]|9[0-47-9])\\d|85[0-26]\\d|9(?:0[167]|10|[57]\\d|6[02-9]|8[013-9])\\d)|7(?:2(?:0[7-9]|1[016-9]|2[0-8]|[39]\\d|4[014]|5[0-79]|6[125-8]|7[1246-9]|8[37-9])\\d|3(?:0[0-5]|[35]\\d|40|5[0-478]|6[0-5]|8[0-26-8])\\d|4(?:0[07-9]|[1-35]\\d|6[7-9]|7[57]|8[1-68])\\d|5(?:0[04-9]|1[0-68]|2[0-378]|3[0-3]|5\\d|6[0-2]|7[018]|8[5-7]|9[05-9])\\d|6(?:5[0-24-9]|6[0-3568]|7[0457-9]|8[02-9]|9\\d)\\d|7(?:0[25-8]\\d|1(?:[01]\\d|20)|2[0-2]\\d|3[489]\\d|[457-9]\\d{2}|6(?:[0-8]\\d|90))|8(?:01[01]|10\\d|[289]\\d{2}|3(?:[028]\\d|10)|50\\d|6[0-357-9]\\d|7(?:[0235-9]\\d|[14]0))|9(?:0(?:[0246-8]\\d|10)|[1-4]\\d{2}|50\\d|6[014589]\\d|[7-9]0\\d))|8(?:2(?:2(?:[013-5]\\d|[28][0-8]|6[01]|7[0-589]|9[0-49])|3(?:[02][0-689]|1[1-59]|[3-7]\\d|8[0-389]|9[13])|4(?:0[1-3]|[1-8]\\d|9[1-359])|5(?:0[1-7]|[17]\\d|20|3[0-26-9]|4[1-9]|5[0-35]|8[0-689]|9[02367])|6(?:[147]\\d|2[0-25-9]|39|5[014-9]|6[1-9]|8[1-8]|9[089])|7(?:0[017-9]|1[1-356]|20|3[01457-9]|4[15]|5[0-25]|6[0-6]|70|8[0-2]|9[01378])|8(?:0[3-57-9]|[15]0|2[124-9]|3[01]|4[02-6]|6[02-578]|7\\d|8[25-8]|9[04-689]))|3(?:220|3(?:0[089]|10|2[0-7]|3[7-9]|4[0-48])|4(?:0[68]|1[0-478]|2[5-79]|3[024-9]|50|6\\d|7[0-57]|8[05]|96)|5(?:4[4578]|55|6[2-9]|70|8[459]|92))|4(?:2(?:[15]\\d|2[0-489]|3[124-9])|3(?:0[1-8]|[1-4]\\d|5[0-3]|6[1-7]|7[56]|8[0-4]|9[1-578])|4(?:05|80)|555|6(?:1[0-3]|20|3[1-4]|4[0-24-7]|5\\d|6[0-2]|71|8[0-47-9]|9[0-689])|7(02|1[79]|21|3[0-2468]|5[0-5]|6[0256]|7[0-8]|8[01589]|9[026-9])|8(?:0[1-9]|1[0-3568]|2[0138]|3[0-4]|4[046-9]|5[06]|6\\d|7[0-579]|80|9[0-8]))|5(?:2(?:0[0-26]|1\\d|2[0-5]|3[18]|4[0-2]|6[3-68]|70|8[025-9]|9[05-9])|3(?:10|2\\d|31|95)|4(?:0[1-7]|[1-4]\\d|5[02-6]|6[0-3]|7[0-245]|8[125]|9[1-6])|5(?:40|55)|6(?:0[1459]|1[0-8]|2[0-36-8]|3[0-35-8]|[45]\\d|6[0-8]|80)|7(?:1[07-9]|20|3[3-9]|4[02-4]|5[05689]|6[015-9]|7\\d|8[045]|9[0-6]))|6(?:2(?:01|3[12]|5[1-7]|60|8[1-6]|9[0-8])|3(?:0[0137]|[134]\\d|2[0-8]|[59][01]|60|[78]1)|4(?:2[2-4]|49|5[17]|6\\d|7[0-46-9]|8[0-689])|5(?:0[6-8]|55|8[0149]|90)|8(?:5\\d|[68]0)|9(?:5[12]|81))|7(?:2(?:0[189]|[12][1-9]|3[0-47]|50)|3(?:[01][1-9]|3\\d|4[0-245]|6[4-9]|7[237-9]|9[12])|4(?:[0-2]\\d|3[167-9]|[45][0-3]|6[0-8]|7[25-9]|8[0-6]|90)|5(?:0[1-9]|[89]\\d)|7(?:1[89]|[27]\\d|3[013-9]|4[0-8]|50|6[01568]|82)|8(?:[03][1-3]|1[0-28]|2[0-38]|48|5[0-4]|6[1-3]|7[124]|8[013-57-9]|9[07]))|8(?:2(?:0[13-7]|[1-9]\\d)|3(?:0[1-47-9]|[128]\\d|3[0-4]|4[1-9]|5[0-35-7]|6[0-46-9]|9[3-7])|4(?:0[1-58]|1[1-5]|[2-57-9]\\d|69)|5(?:1[1-35-9]|2\\d|3[2-8]|52)|6(?:0[2-9]|1[1-8]|[23]\\d|41|5[12367]|6[1-9]|7[14-9]|8[02-8]|9[05])|7(?:0[1-589]|[1-35-8]\\d|4[0-7]|9[0-46-9])|8(?:01|30|5[0-48]|6[13]|7\\d|8[013-689]|9[24-9])|9(?:0[2-4689]|1\\d|2[08]|3[18]|4[03]|59|6[0-36-9]|7[0-35-79]|8[1235]))|9(?:2(?:[057][1-9]|[1-3]\\d|4[0-8]|6[1-5]|8[015-9]|9[04-6])|300|4(?:01|36|6[1-6]|[89][12])|5(?:0[25689]|1\\d|2[0134]|3[1-8]|5[17]|6[0-35-9]|7[0-7]|91)|6(?:1[1-9]|2[23]|3[0-4]|6[03-9]|7[0-7])|7(?:0[1-68]|1[1-8]|2[25-9]|3[056]|4[4-9]|[5-8]\\d|9[0-46-9])|8(?:0[1-7]|[189]\\d|2[1-46]|4[1-689]|5[0-79]|6[1-9]|71)|9(?:0[1-3]|1\\d|2[0-35-7]|3[67]|4[12]|5[0-249]|6[5-9]|75|8[1-6])))|9(?:2(?:0[458]\\d|1[2-57]\\d|2[0-589]\\d|[39]\\d{2}|4(?:[02-9]\\d|10)|5(?:[024-6]\\d|[7-9]0)|6(?:[03-9]\\d|20)|7[0-26-9]\\d|8(?:[0-24-68]\\d|7[01]))|3(?:0[0-2689]\\d|1(?:[0235]\\d|1[0-2]|4[01])|2(?:0[01]|[1-57-9]\\d|6[0-2])|3(?:00|1[0-4]|2\\d)|4[05]\\d|5[0-3568]\\d|6(?:[1-357-9]\\d|60)|[78]0\\d)|4(?:0[24578]\\d|1[02-57-9]\\d|2\\d{2}|3(?:[0278]\\d|1[01]|60)|4[013579]\\d|5[0-8]\\d|6[0678]\\d|7[013-9]\\d|8[01569]\\d)|5(0(?:[589]\\d|7[01])|1\\d{2}|2[0159]\\d|3[14689]\\d|4[0-46-9]\\d|5[0-35-9]\\d|6[0156-8]\\d|7[0-35]\\d|8[0-7]\\d|9[0-3589]\\d)|6(?:0[269]\\d|[12]\\d{2}|3[0-57-9]\\d|44[0-2]|5[01379]\\d|6[02-9]\\d|7[69]\\d|8(?:[0-24-8]\\d|30)|9(?:[0-24-9]\\d|3[01]))|7(?:0[0136-8]|1[02-4]|2[156]|3[258]|[489]\\d|5[0-589]|6[024-9]|7[0-689])\\d|8(?:0(?:0[01]|1\\d)|1[3-9]\\d|[23]\\d{2}|4[0-24-689]\\d|5[0-689]\\d|6[02-9]\\d|7(?:[01]0|[2-4]\\d)|888)|9(?:00\\d|1[2-57-9]\\d|2(?:00|1[01]|[238]\\d)|3(?:[2-467]\\d|50)|4[4-9]\\d|5(?:[0-2457-9]\\d|60)|6[0156]\\d|7[04-9]\\d|8[01]\\d)))\\d{3}", 
	, , , "323856789", , , [8, 9], [6, 7]], [, , "1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])\\d|1(?:[1-5]\\d{2}|6(?:0[5-9]|[1-9]\\d))\\d|[23679][2-9]\\d{2}|4(?:[235-9]\\d{2}|400)|59\\d{3}|8(?:1[23]\\d|[236]\\d{2}|4(?:[06]\\d|7[0-4])\\d|5[7-9]\\d|7[016-9]\\d|8(?:[01]\\d|[27][0-4])|9[0-8]\\d))\\d{4}", , , , "123456789", , , [9, 10]], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "154(?:6(?:0\\d|1[0-3])|8(?:[25]1|4[0189]|7[0-4679]))\\d{4}", 
	, , , "1546012345", , , [10]], "MY", 60, "00", "0", , , "0", , , , [[, "([4-79])(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(3)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], [, "([18]\\d)(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1[02-46-9][1-9]|8"], "0$1"], [, "(1)([36-8]00)(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]0", "1[36-8]00"]], [, "(11)(\\d{4})(\\d{4})", "$1-$2 $3", ["11"], "0$1"], [, "(15[49])(\\d{3})(\\d{4})", "$1-$2 $3", ["15[49]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , 
	, , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], MZ:[, [, , "[28]\\d{7,8}", , , , , , , [8, 9]], [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]], [, , "8[2-7]\\d{7}", , , , "821234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MZ", 258, "00", , , , , , , , [[, "([28]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-7]"]], [, "(80\\d)(\\d{3})(\\d{3})", 
	"$1 $2 $3", ["80"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NA:[, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [, , "6(?:1(?:17|2(?:[0189]\\d|[2-6]|7\\d?)|3(?:[01378]|2\\d)|4(?:[024]|10?|3[15]?)|69|7[014])|2(?:17|5(?:[0-36-8]|4\\d?)|69|70)|3(?:17|2(?:[0237]\\d?|[14-689])|34|6[289]|7[01]|81)|4(?:17|2(?:[012]|7\\d?)|4(?:[06]|1\\d?)|5(?:[01357]|[25]\\d?)|69|7[01])|5(?:17|2(?:[0459]|[23678]\\d?)|69|7[01])|6(?:17|2(?:5|6\\d?)|38|42|69|7[01])|7(?:17|2(?:[569]|[234]\\d?)|3(?:0\\d?|[13])|6[89]|7[01]))\\d{4}", 
	, , , "61221234"], [, , "(?:60|8[125])\\d{7}", , , , "811234567", , , [9]], [, , , , , , , , , [-1]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d{2}|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(8\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["8[1-35]"], "0$1"], [, "(6\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(88)(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(870)(\\d{3})(\\d{3})", "$1 $2 $3", 
	["870"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NC:[, [, , "[2-57-9]\\d{5}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:5[0-4]|[79]\\d|8[0-79])\\d{4}", , , , "751234"], [, , , , , , , , , [-1]], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", 
	["[2-46-9]|5[0-4]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NE:[, [, , "[0289]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:20|3[1-7]|4[134]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"], [, , "(?:8[089]|9\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
	"NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["09|[289]"]], [, "(08)(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NF:[, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[012]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "3[58]\\d{4}", , , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , 
	, , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , , , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1"]], [, "(\\d)(\\d{5})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NG:[, [, , "[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}", , , , , , , [7, 8, 10, 11, 12, 13, 14], [5, 6]], [, , "[12]\\d{6,7}|9(?:0[3-9]|[1-9]\\d)\\d{5}|(?:3\\d|4[023568]|5[02368]|6[02-469]|7[4-69]|8[2-9])\\d{6}|(?:4[47]|5[14579]|6[1578]|7[0-357])\\d{5,6}|(?:78|41)\\d{5}", 
	, , , "12345678", , , [7, 8], [5, 6]], [, , "(?:1(?:7[34]\\d|8(?:04|[124579]\\d|8[0-3])|95\\d)|287[0-7]|3(?:18[1-8]|88[0-7]|9(?:8[5-9]|6[1-5]))|4(?:28[0-2]|6(?:7[1-9]|8[02-47])|88[0-2])|5(?:2(?:7[7-9]|8\\d)|38[1-79]|48[0-7]|68[4-7])|6(?:2(?:7[7-9]|8\\d)|4(?:3[7-9]|[68][129]|7[04-69]|9[1-8])|58[0-2]|98[7-9])|7(?:38[0-7]|69[1-8]|78[2-4])|8(?:28[3-9]|38[0-2]|4(?:2[12]|3[147-9]|5[346]|7[4-9]|8[014-689]|90)|58[1-8]|78[2-9]|88[5-7])|98[07]\\d)\\d{4}|(?:70(?:[1-689]\\d|7[0-3])|8(?:0(?:1[01]|[2-9]\\d)|1(?:[0-8]\\d|9[01]))|90[235-9]\\d)\\d{6}", 
	, , , "8021234567", , , [8, 10]], [, , "800\\d{7,11}", , , , "80017591759", , , [10, 11, 12, 13, 14]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-6]|7(?:0[1-9]|[1-79])|8[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["70|8[01]|90[235-9]"], "0$1"], [, "([78]00)(\\d{4})(\\d{4,5})", 
	"$1 $2 $3", ["[78]00"], "0$1"], [, "([78]00)(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]00"], "0$1"], [, "(78)(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567", , , [10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]]], NI:[, [, , "[125-8]\\d{7}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|7[5-8]\\d|8\\d{2})\\d{5}", , , , "81234567"], 
	[, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NL:[, [, , "1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:1[0135-8]|2[02-69]|3[0-68]|4[0135-9]|[57]\\d|8[478])\\d{7}", , , , "101234567", , , [9]], 
	[, , "6[1-58]\\d{7}", , , , "612345678", , , [9]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6760|85\\d{2})\\d{5}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "([1-578]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"], "0$1"], [, "([1-5]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], 
	"0$1"], [, "(6)(\\d{8})", "$1 $2", ["6[0-57-9]"], "0$1"], [, "(66)(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(14)(\\d{3,4})", "$1 $2", ["14"], "$1"], [, "([89]0\\d)(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"]], , [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])", , , , "14023", , , [5, 6]], [, , "140(?:1(?:[035]|[16-8]\\d)|2(?:[0346]|[259]\\d)|3(?:[03568]|[124]\\d)|4(?:[0356]|[17-9]\\d)|5(?:[0358]|[124679]\\d)|7\\d|8[458])", 
	, , , "14020", , , [5, 6]], , , [, , , , , , , , , [-1]]], NO:[, [, , "0\\d{4}|[2-9]\\d{7}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [, , "(?:4[015-8]|5[89]|87|9\\d)\\d{6}", , , , "40612345", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", 
	, , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "([489]\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]"]], [, "([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , "0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}", , , , "01234"], , , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]], NP:[, [, , "[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})", , , , , , , [8, 10], [6, 7]], [, , "(?:1[0-6]\\d|2[13-79][2-6]|3[135-8][2-6]|4[146-9][2-6]|5[135-7][2-6]|6[13-9][2-6]|7[15-9][2-6]|8[1-46-9][2-6]|9[1-79][2-6])\\d{5}", 
	, , , "14567890", , , [8], [6, 7]], [, , "9(?:6[013]|7[245]|8[0-24-6])\\d{7}", , , , "9841234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(1)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-69]|7[15-9])"], "0$1"], [, "(9\\d{2})(\\d{7})", "$1-$2", ["9(?:6[013]|7[245]|8)"], "$1"]], , [, , , , , , , , , [-1]], , , 
	[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NR:[, [, , "[458]\\d{6}", , , , , , , [7]], [, , "(?:444|888)\\d{4}", , , , "4441234"], [, , "55[4-9]\\d{4}", , , , "5551234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , 
	, , , , , , [-1]]], NU:[, [, , "[1-5]\\d{3}", , , , , , , [4]], [, , "[34]\\d{3}", , , , "4002"], [, , "[125]\\d{3}", , , , "1234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NU", 683, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], NZ:[, [, , "6[235-9]\\d{6}|[2-57-9]\\d{7,9}", , , , , , , [8, 9, 10], [7]], [, , "(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}|24099\\d{3}", 
	, , , "32345678", , , [8], [7]], [, , "2(?:[028]\\d{7,8}|1(?:[03]\\d{5,7}|[12457]\\d{5,6}|[689]\\d{5})|[79]\\d{7})", , , , "211234567"], [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456"], [, , "90\\d{6,7}", , , , "900123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , "70\\d{7}", , , , "701234567", , , [9]], [, , , , , , , , , [-1]], "NZ", 64, "0(?:0|161)", "0", , , "0", , "00", , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["240|[346]|7[2-57-9]|9[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", 
	["21"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:1[1-9]|[69]|7[0-35-9])|70|86"], "0$1"], [, "(2\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["2[028]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["90"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|5|[89]0"], "0$1"]], , [, , "[28]6\\d{6,7}", , , , "26123456", , , [8, 9]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], OM:[, [, , "(?:5|[279]\\d)\\d{6}|800\\d{5,6}", , , , 
	, , , [7, 8, 9]], [, , "2[2-6]\\d{6}", , , , "23123456", , , [8]], [, , "7[19]\\d{6}|9(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "92123456", , , [8]], [, , "8007\\d{4,5}|500\\d{4}", , , , "80071234"], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "OM", 968, "00", , , , , , , , [[, "(2\\d)(\\d{6})", "$1 $2", ["2"]], [, "([79]\\d{3})(\\d{4})", "$1 $2", ["[79]"]], [, "([58]00)(\\d{4,6})", "$1 $2", ["[58]00"]]], , [, , , , , , , , , 
	[-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PA:[, [, , "[1-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:1(?:0[0-8]|1[49]|2[37]|3[0137]|4[147]|5[05]|6[58]|7[0167]|8[58]|9[139])|2(?:[0235679]\\d|1[0-7]|4[04-9]|8[028])|3(?:[09]\\d|1[014-7]|2[0-3]|3[03]|4[03-57]|55|6[068]|7[06-8]|8[06-9])|4(?:3[013-69]|4\\d|7[0-589])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-267]|3[06]|[469]0|5[06-9]|7[0-24-79]|8[7-9])|8(?:09|[34]\\d|5[0134]|8[02])|9(?:0[6-9]|1[016-8]|2[036-8]|3[3679]|40|5[0489]|6[06-9]|7[046-9]|8[36-8]|9[1-9]))\\d{4}", 
	, , , "2001234", , , [7]], [, , "(?:1[16]1|21[89]|8(?:1[01]|7[23]))\\d{4}|6(?:[024-9]\\d|1[0-5]|3[0-24-9])\\d{5}", , , , "61234567"], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "(?:8(?:55|60|7[78])|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["6"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , 
	[-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PE:[, [, , "[14-9]\\d{7,8}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|4[1-4]|5[1-46]|6[1-7]|7[2-46]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "19(?:1[124]|77|90)00", 
	"0", " Anexo ", , "0", , , , [[, "(1)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "([4-8]\\d)(\\d{6})", "$1 $2", ["[4-7]|8[2-4]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], [, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PF:[, [, , "4\\d{5,7}|8\\d{7}", , , , , , , [6, 8]], [, , "4(?:[09][45689]\\d|4)\\d{4}", , , , "40412345"], [, , "8[79]\\d{6}", , , , "87123456", 
	, , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PF", 689, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4[09]|8[79]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]]], , [, , , , , , , , , [-1]], , , [, , "44\\d{4}", , , , "441234", , , [6]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PG:[, [, , "[1-9]\\d{6,7}", , , , , , , [7, 8]], [, , "(?:3[0-2]\\d|4[257]\\d|5[34]\\d|64[1-9]|77(?:[0-24]\\d|30)|85[02-46-9]|9[78]\\d)\\d{4}", 
	, , , "3123456", , , [7]], [, , "7(?:[0-689]\\d|75)\\d{5}", , , , "70123456", , , [8]], [, , "180\\d{4}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-47]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "140[1-3]|00", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[13-689]|27"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["20|7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, 
	, , , , , , , , [-1]]], PH:[, [, , "1\\d{10,12}|2\\d{5,7}|[3-7]\\d{8}|8\\d{7,9}|9\\d{9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [5, 7]], [, , "2\\d{5}(?:\\d{2})?|(?:3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578]|8[2-8])\\d{7}|88(?:22\\d{6}|42\\d{4})", , , , "21234567", , , [6, 8, 9, 10], [5, 7]], [, , "(?:81[37]|9(?:0[5-9]|1[024-9]|2[0-35-9]|3[02-9]|4[235-9]|5[056]|6[5-7]|7[34-79]|89|9[4-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , 
	, , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(2)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", 
	"3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "([3-8]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["81|9"], "0$1"], [, "(1800)(\\d{3})(\\d{4})", "$1 $2 $3", ["180", "1800"]], [, "(1800)(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["180", "1800"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PK:[, [, , "1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,10}|2\\d(?:111\\d{6}|\\d{3,7}))", 
	, , , , , , [8, 9, 10, 11, 12], [6, 7]], [, , "(?:21|42)[2-9]\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}|58[126]\\d{7}", , , , "2123456789", , , [9, 10], [6, 7, 8]], [, , "3(?:[014]\\d|2[0-5]|3[0-7]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "900\\d{5}", , , , 
	"90012345", , , [8]], [, , , , , , , , , [-1]], [, , "122\\d{6}", , , , "122044444", , , [9]], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "([89]00)(\\d{3})(\\d{2})", "$1 $2 $3", ["[89]00"], "0$1"], [, "(1\\d{3})(\\d{5})", "$1 $2", ["1"], "$1"], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{3})(\\d{6,7})", "$1 $2", ["2[349]|45|54|60|72|8[2-5]|9[2-469]", "(?:2[349]|45|54|60|72|8[2-5]|9[2-469])\\d[2-9]"], "(0$1)"], 
	[, "(58\\d{3})(\\d{5})", "$1 $2", ["58[126]"], "(0$1)"], [, "(3\\d{2})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(111)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1", "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11", "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"], "(0$1)"], [, "(\\d{3})(111)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[349]|45|54|60|72|8[2-5]|9[2-9]", "(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1", "(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11", 
	"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:[1-8]|0[468])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", , , , "21111825888", , , [11, 12]], , , [, , , , , , , , , [-1]]], PL:[, [, , "[1-57-9]\\d{6,8}|6\\d{5,8}", , , , , , , [6, 7, 8, 9]], [, , "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:\\d{7}|19\\d{3})", 
	, , , "123456789", , , [7, 9]], [, , "(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [, , "801\\d{6}", , , , "801234567", , , [9]], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["11[68]|64"]], [, "(\\d{5})", "$1", ["19"]], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]], 
	[, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["26|39|45|5[0137]|6[0469]|7[02389]|8[08]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]]], , [, , "64\\d{4,7}", , , , "641234567"], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]], PM:[, [, , "[45]\\d{5}", , , , , , , [6]], [, , "41\\d{4}", , , , "411234"], [, , "(?:40|55)\\d{4}", 
	, , , "551234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PM", 508, "00", "0", , , "0", , , , [[, "([45]\\d)(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PR:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", 
	, , , "7872345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PS:[, [, , "1\\d{9}|[24589]\\d{7,8}", , , , , , , [8, 9, 10], [7]], [, , "(?:22[234789]|42[45]|82[01458]|92[369])\\d{5}", 
	, , , "22234567", , , [8], [7]], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "([2489])(2\\d{2})(\\d{4})", "$1 $2 $3", ["[2489]2"], "0$1"], [, "(5[69]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["5[69]"], "0$1"], [, "(1[78]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[78]0", "1[78]00"], "$1"]], 
	, [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PT:[, [, , "[2-46-9]\\d{8}", , , , , , , [9]], [, , "2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}", , , , "212345678"], [, , "9(?:[1236]\\d{2}|480)\\d{5}", , , , "912345678"], [, , "80[02]\\d{6}", , , , "800123456"], [, , "6(?:0[178]|4[68])\\d{6}|76(?:0[1-57]|1[2-47]|2[237])\\d{5}", , , , "760123456"], [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"], [, 
	, "884[0-4689]\\d{5}", , , , "884123456"], [, , "30\\d{7}", , , , "301234567"], "PT", 351, "00", , , , , , , , [[, "(2\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], [, "([2-46-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[3-9]|[346-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7(?:0(?:7\\d|8[17]))\\d{5}", , , , "707123456"], , , [, , "600\\d{6}", , , , "600110000"]], PW:[, [, , "[2-8]\\d{6}", , , , , , , [7]], [, , "2552255|(?:277|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76))\\d{4}", 
	, , , "2771234"], [, , "(?:6[234689]0|77[45789])\\d{4}", , , , "6201234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], PY:[, [, , "5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}", , , , , , , [6, 7, 8, 9], [5]], [, , "(?:[26]1|3[289]|4[124678]|7[123]|8[1236])\\d{5,7}|(?:2(?:2[4568]|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51)|4(?:18|2[45]|3[12]|5[13]|64|71|9[1-47])|5(?:[1-4]\\d|5[0234])|6(?:3[1-3]|44|7[1-4678])|7(?:17|4[0-4]|6[1-578]|75|8[0-8])|858)\\d{5,6}", 
	, , , "212345678", , , [7, 8, 9], [5, 6]], [, , "9(?:6[12]|[78][1-6]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{3,6})", 
	"$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["9[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["870", "8700"]], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["[2-8][1-9]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8][1-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567"], , , [, , , , , , , , , [-1]]], QA:[, [, , "[2-8]\\d{6,7}", , , , , , , [7, 8]], [, , "4[04]\\d{6}", , , , "44123456", , , [8]], [, 
	, "[3567]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "([28]\\d{2})(\\d{4})", "$1 $2", ["[28]"]], [, "([3-7]\\d{3})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2(?:[12]\\d|61)\\d{4}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RE:[, [, , "[268]\\d{8}", , , , 
	, , , [9]], [, , "262\\d{6}", , , , "262161234"], [, , "69(?:2\\d{2}|3(?:0[0-46]|1[013]|2[0-2]|3[039]|4[0-7]|5[05]|6[06]|7[07]|8[0-38]|9[0-479]))\\d{4}", , , , "692123456"], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RE", 262, "00", "0", , , "0", , , , [[, "([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[268]"], "0$1"]], , [, , , , , , , 
	, , [-1]], 1, "262|69|8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RO:[, [, , "[23]\\d{5,8}|[7-9]\\d{8}", , , , , , , [6, 9]], [, , "2(?:1(?:\\d{7}|9\\d{3})|[3-6](?:\\d{7}|\\d9\\d{2}))|3(?:1\\d{4}(?:\\d{3})?|[3-6]\\d{7})", , , , "211234567"], [, , "7(?:[0-8]\\d{2}|99\\d)\\d{5}", , , , "712345678", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[036]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , 
	, , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["[23]1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23][3-7]|[7-9]"], "0$1"], [, "(2\\d{2})(\\d{3})", "$1 $2", ["2[3-6]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "37\\d{7}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]], RS:[, [, , "[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})", 
	, , , , , , [6, 7, 8, 9, 10, 11, 12], [5]], [, , "(?:1(?:[02-9][2-9]|1[1-9])\\d|2(?:[0-24-7][2-9]\\d|[389](?:0[2-9]|[2-9]\\d))|3(?:[0-8][2-9]\\d|9(?:[2-9]\\d|0[2-9])))\\d{3,8}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [, , "800\\d{3,9}", , , , "80012345"], [, , "(?:90[0169]|78\\d)\\d{3,7}", , , , "90012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", 
	, , , [[, "([23]\\d{2})(\\d{4,9})", "$1 $2", ["(?:2[389]|39)0"], "0$1"], [, "([1-3]\\d)(\\d{5,10})", "$1 $2", ["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"], "0$1"], [, "(6\\d)(\\d{6,8})", "$1 $2", ["6"], "0$1"], [, "([89]\\d{2})(\\d{3,9})", "$1 $2", ["[89]"], "0$1"], [, "(7[26])(\\d{4,9})", "$1 $2", ["7[26]"], "0$1"], [, "(7[08]\\d)(\\d{4,9})", "$1 $2", ["7[08]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , 
	, [-1]]], RU:[, [, , "[347-9]\\d{9}", , , , , , , [10]], [, , "(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", , , , "3011234567"], [, , "9\\d{9}", , , , "9123456789"], [, , "80[04]\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567"], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567"], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", 
	, [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[1-79]"], "$1", , 1], [, "([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], "8 ($1)", , 1], [, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1]], [[, "([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], "8 ($1)", , 1], [, "(7\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], RW:[, 
	[, , "[027-9]\\d{7,8}", , , , , , , [8, 9]], [, , "2[258]\\d{7}|06\\d{6}", , , , "250123456"], [, , "7[238]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "900\\d{6}", , , , "900123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(2\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "([7-9]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(0\\d)(\\d{2})(\\d{2})(\\d{2})", 
	"$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SA:[, [, , "1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}", , , , , , , [8, 9, 10], [7]], [, , "11\\d{7}|1?(?:2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [8, 9], [7]], [, , "(?:5(?:[013-689]\\d|7[0-36-8])|811\\d)\\d{6}", , , , "512345678", , , [9, 10]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , 
	"92[05]\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "([1-467])(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-467]"], "0$1"], [, "(1\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1[1-467]"], "0$1"], [, "(5\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(92\\d{2})(\\d{5})", "$1 $2", ["92"], "$1"], [, "(800)(\\d{3})(\\d{4})", "$1 $2 $3", ["800"], "$1"], [, "(811)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["811"], "0$1"]], , [, , , , , , , 
	, , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SB:[, [, , "[1-9]\\d{4,6}", , , , , , , [5, 7]], [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]], [, , "48\\d{3}|7(?:30|[46-8]\\d|5[025-9]|9[0-5])\\d{4}|8[4-9]\\d{5}|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8])\\d{4}", , , , "7421234"], [, , "1[38]\\d{3}", , , , "18123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , 
	, , , [-1]], [, , "5[12]\\d{3}", , , , "51123", , , [5]], "SB", 677, "0[01]", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["[7-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SC:[, [, , "[24689]\\d{5,6}", , , , , , , [7]], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[5-8]\\d{5}", , , , "2510123"], [, , "8000\\d{3}", , , , "8000000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:64\\d|971)\\d{4}", 
	, , , "6412345"], "SC", 248, "0(?:[02]|10?)", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SD:[, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1(?:[125]\\d|8[3567])\\d{6}", , , , "121231234"], [, , "9[0-3569]\\d{7}", , , , "911231234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], 
	"SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SE:[, [, , "[1-35-9]\\d{5,11}|4\\d{6,8}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "1(?:0[1-8]\\d{6}|[136]\\d{5,7}|(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)\\d{5,6})|2(?:[136]\\d{5,7}|(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])\\d{5,6})|3(?:[356]\\d{5,7}|(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])\\d{5,6})|4(?:[0246]\\d{5,7}|(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])\\d{5,6})|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])\\d{5,6}|6(?:[03]\\d{5,7}|(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])\\d{5,6})|8\\d{6,8}|9(?:0[1-9]\\d{4,6}|(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8])\\d{5,6})", 
	, , , "8123456", , , [7, 8, 9]], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77(?:0\\d{3}(?:\\d{3})?|[1-7]\\d{6})", , , , "771234567", , , [6, 9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(8)(\\d{2,3})(\\d{2,3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})", 
	"$1-$2 $3 $4", ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"], "0$1"], [, "([1-469]\\d)(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"], 
	"0$1"], [, "(7\\d)(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["7"], "0$1"], [, "(77)(\\d{2})(\\d{2})", "$1-$2$3", ["77"], "0$1"], [, "(20)(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9[034]"], "0$1"], [, "(9[034]\\d)(\\d{4})", "$1-$2", ["9[034]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["25[245]|67[3-6]"], "0$1"]], [[, "(8)(\\d{2,3})(\\d{2,3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})", 
	"$1 $2 $3 $4", ["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"]], [, "([1-469]\\d)(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"]], [, "(7\\d)(\\d{3})(\\d{2})(\\d{2})", 
	"$1 $2 $3 $4", ["7"]], [, "(77)(\\d{2})(\\d{2})", "$1 $2 $3", ["77"]], [, "(20)(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9[034]"]], [, "(9[034]\\d)(\\d{4})", "$1 $2", ["9[034]"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["25[245]|67[3-6]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "(?:25[245]|67[3-6])\\d{9}", , , , "254123456789", , , [12]]], 
	SG:[, [, , "[36]\\d{7}|[17-9]\\d{7,10}", , , , , , , [8, 10, 11]], [, , "6[1-9]\\d{6}", , , , "61234567", , , [8]], [, , "(?:8[1-8]|9[0-8])\\d{6}", , , , "81234567", , , [8]], [, , "1?800\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[12]\\d{6}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "([3689]\\d{3})(\\d{4})", "$1 $2", ["[369]|8[1-9]"]], [, "(1[89]00)(\\d{3})(\\d{4})", 
	"$1 $2 $3", ["1[89]0", "1[89]00"]], [, "(7000)(\\d{4})(\\d{3})", "$1 $2 $3", ["700", "7000"]], [, "(800)(\\d{3})(\\d{4})", "$1 $2 $3", ["800"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]], SH:[, [, , "[256]\\d{4}|8\\d{3}", , , , , , , [4, 5]], [, , "2(?:[0-57-9]\\d|6[4-9])\\d{2}", , , , "22158"], [, , "[56]\\d{4}", , , , "51234", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , 
	, , , , [-1]], [, , , , , , , , , [-1]], [, , "262\\d{2}", , , , "26212", , , [5]], "SH", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SI:[, [, , "[1-7]\\d{6,7}|[89]\\d{4,7}", , , , , , , [5, 6, 7, 8]], [, , "(?:1\\d|[25][2-8]|3[24-8]|4[24-8]|7[3-8])\\d{6}", , , , "11234567", , , [8], [7]], [, , "(?:[37][01]\\d|4[0139]\\d|51\\d|6(?:[48]\\d|9[69]))\\d{5}", , , , "31234567", , , [8]], [, , "80\\d{4,6}", 
	, , , "80123456", , , [6, 7, 8]], [, , "90\\d{4,6}|89[1-3]\\d{2,5}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:59|8[1-3])\\d{6}", , , , "59012345", , , [8]], "SI", 386, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[12]|[34][24-8]|5[2-8]|7[3-8]"], "(0$1)"], [, "([3-7]\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "([89][09])(\\d{3,6})", "$1 $2", ["[89][09]"], "0$1"], [, "([58]\\d{2})(\\d{5})", "$1 $2", 
	["59|8[1-3]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SJ:[, [, , "0\\d{4}|[45789]\\d{7}", , , , , , , [5, 8]], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|5[89]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", 
	, , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}", , , , "01234"], , , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]], SK:[, [, , "(?:[2-68]\\d{5,8}|9\\d{6,8})", , , , , , , [6, 7, 9]], [, , "2(?:1(?:6\\d{3,4}|7\\d{3})|[2-9]\\d{7})|[3-5][1-8](?:1(?:6\\d{2,3}|7\\d{3})|\\d{7})", , , , "221234567"], [, , "9(?:0(?:[1-8]\\d|9[1-9])|(?:1[0-24-9]|[45]\\d)\\d)\\d{5}", 
	, , , "912123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:[78]\\d{7}|00\\d{6})", , , , "900123456", , , [9]], [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]], [, , , , , , , , , [-1]], [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]], "SK", 421, "00", "0", , , "0", , , , [[, "(2)(1[67])(\\d{3,4})", "$1 $2 $3", ["21[67]"], "0$1"], [, "([3-5]\\d)(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5]"], "0$1"], [, "(2)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], 
	[, "([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"], [, "([689]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(9090)(\\d{3})", "$1 $2", ["909", "9090"], "0$1"]], , [, , "9090\\d{3}", , , , "9090123", , , [7]], , , [, , "(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}|9090\\d{3}", , , , "800123456", , , [7, 9]], [, , "96\\d{7}", , , , "961234567", , , [9]], , , [, , , , , , , , , [-1]]], SL:[, [, , "[2-9]\\d{7}", , , , , , , [8], [6]], [, , "[235]2[2-4][2-9]\\d{4}", 
	, , , "22221234", , , , [6]], [, , "(?:2[15]|3[03-5]|4[04]|5[05]|66|7[6-9]|8[08]|99)\\d{6}", , , , "25123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", , "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SM:[, [, , "[05-7]\\d{7,9}", , , , , , , [8, 10], [6]], [, , 
	"0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]], [, , "6[16]\\d{6}", , , , "66661212", , , [8]], [, , , , , , , , , [-1]], [, , "7[178]\\d{6}", , , , "71123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[158]\\d{6}", , , , "58001110", , , [8]], "SM", 378, "00", , , , "([89]\\d{5})", "0549$1", , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(0549)(\\d{6})", "$1 $2", ["054", "0549"]], [, "(\\d{6})", "0549 $1", ["[89]"]]], [[, 
	"(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(0549)(\\d{6})", "($1) $2", ["054", "0549"]], [, "(\\d{6})", "(0549) $1", ["[89]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SN:[, [, , "[3789]\\d{8}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [, , "7(?:[06-8]\\d|21|90)\\d{6}", , , , "701234567"], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", 
	, , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "39[01]\\d{6}|3392\\d{5}|93330\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SO:[, [, , "[1-9]\\d{5,8}", , , , , , , [6, 7, 8, 9]], [, , "(?:1\\d{1,2}|2[0-79]\\d|3[0-46-8]?\\d|4[0-7]?\\d|59\\d|8[125])\\d{4}", 
	, , , "4012345", , , [6, 7]], [, , "(?:15\\d|2(?:4\\d|8)|3[59]\\d{2}|4[89]\\d{2}|6[1-9]?\\d{2}|7(?:[1-8]\\d|9\\d{1,2})|8[08]\\d{2}|9(?:0[67]|[2-9])\\d)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[13-5]|2[0-79]"]], [, "(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], [, "(\\d{2})(\\d{4})", 
	"$1 $2", ["8[125]"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["15|28|6[1-35-9]|799|9[2-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3[59]|4[89]|6[24-6]|79|8[08]|90"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SR:[, [, , "[2-8]\\d{5,6}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|4\\d|5[2-58]|68\\d)\\d{4}", , , , "211234"], [, , "(?:7[124-7]|8[125-9])\\d{5}", , , , "7412345", , , [7]], [, , , , , , , , , [-1]], [, , , , 
	, , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "56\\d{4}", , , , "561234", , , [6]], "SR", 597, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-4]|5[2-58]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SS:[, [, , "[19]\\d{8}", , , , , , , [9]], [, , "18\\d{7}", , , , "181234567"], [, , "(?:12|9[1257])\\d{7}", 
	, , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", , "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ST:[, [, , "[29]\\d{6}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "9(?:0(?:0[5-9]|[1-9]\\d)|[89]\\d{2})\\d{3}", , , , "9812345"], 
	[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SV:[, [, , "[267]\\d{7}|[89]\\d{6}(?:\\d{4})?", , , , , , , [7, 8, 11]], [, , "2[1-6]\\d{6}", , , , "21234567", , , [8]], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{4}(?:\\d{4})?", 
	, , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SX:[, [, , "[5789]\\d{9}", , , , , , , [10], 
	[7]], [, , "7215(?:4[2-8]|8[239]|9[056])\\d{4}", , , , "7215425678", , , , [7]], [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "SX", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "721", [, , , , , , , , , [-1]], [, , , 
	, , , , , , [-1]], , , [, , , , , , , , , [-1]]], SY:[, [, , "[1-59]\\d{7,8}", , , , , , , [8, 9], [6, 7]], [, , "(?:1(?:1\\d?|4\\d|[2356])|2(?:1\\d?|[235])|3(?:[13]\\d|4)|4[13]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "9(?:22|[3-589]\\d|6[024-9])\\d{6}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", 
	["[1-5]"], "0$1", , 1], [, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], SZ:[, [, , "[027]\\d{7}", , , , , , , [8]], [, , "2[2-9]\\d{6}", , , , "22171234"], [, , "7[6-9]\\d{6}", , , , "76123456"], [, , "0800\\d{4}", , , , "08001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SZ", 268, "00", , , , , , , , 
	[[, "(\\d{4})(\\d{4})", "$1 $2", ["[027]"]]], , [, , , , , , , , , [-1]], , , [, , "0800\\d{4}", , , , "08001234"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TA:[, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , 
	, , , , [-1]], , , [, , , , , , , , , [-1]]], TC:[, [, , "[5689]\\d{9}", , , , , , , [10], [7]], [, , "649(?:712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]], [, , "649(?:2(?:3[129]|4[1-7])|3(?:3[1-389]|4[1-8])|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "64971[01]\\d{4}", , , 
	, "6497101234", , , , [7]], "TC", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "649", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TD:[, [, , "[2679]\\d{7}", , , , , , , [8]], [, , "22(?:[3789]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:6[023568]\\d|77\\d|9\\d{2})\\d{5}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", 
	, , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TG:[, [, , "[29]\\d{7}", , , , , , , [8]], [, , "2(?:2[2-7]|3[23]|44|55|66|77)\\d{5}", , , , "22212345"], [, , "9[0-36-9]\\d{6}", , , , "90112345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, 
	"(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TH:[, [, , "1\\d{8,9}|[2-9]\\d{7,8}", , , , , , , [8, 9, 10]], [, , "(?:2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [, , "(?:14|6[1-6]|[89]\\d)\\d{7}", , , , "812345678", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , 
	, [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00", "0", , , "0", , , , [[, "(2)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "([13-9]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["14|[3-9]"], "0$1"], [, "(1[89]00)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[89]0", "1[89]00"], "$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TJ:[, [, , "[3-57-9]\\d{8}", , , , , , , [9], [3, 5, 7]], [, , "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}", 
	, , , "372123456", , , , [3, 5, 7]], [, , "(?:41[18]|(?:5[05]|77|88|9[0-35-9])\\d)\\d{6}", , , , "917123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TJ", 992, "810", "8", , , "8", , "8~10", , [[, "([349]\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"], , , 1], [, "([457-9]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[148]|[578]|9(?:[0235-9]|1[59])"], , , 1], [, "(331700)(\\d)(\\d{2})", "$1 $2 $3", ["331", 
	"3317", "33170", "331700"], , , 1], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]", "3(?:[1245]|3(?:[02-9]|1[0-589]))"], , , 1]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TK:[, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , 
	, , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TL:[, [, , "[2-489]\\d{6}|7\\d{6,7}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [, , "7[3-8]\\d{6}", , , , "77212345", , , [8]], [, , "80\\d{5}", , , , "8012345", , , [7]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], 
	[, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7[3-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TM:[, [, , "[1-6]\\d{7}", , , , , , , [8]], [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"], [, , "6[1-9]\\d{6}", , , , "66123456"], [, , , , 
	, , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TM", 993, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["13|[2-5]"], "(8 $1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TN:[, [, , "[2-57-9]\\d{7}", 
	, , , , , , [8]], [, , "3(?:[012]\\d|6[0-4]|91)\\d{5}|7\\d{7}|81200\\d{3}", , , , "71234567"], [, , "(?:[259]\\d|4[0-6])\\d{6}", , , , "20123456"], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 
	TO:[, [, , "[02-8]\\d{4,6}", , , , , , , [5, 7]], [, , "(?:2\\d|3[1-8]|4[1-4]|[56]0|7[0149]|8[05])\\d{3}", , , , "20123", , , [5]], [, , "(?:7[578]|8[47-9])\\d{5}", , , , "7715123", , , [7]], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[1-6]|7[0-4]|8[05]"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["7[5-9]|8[47-9]"]], [, "(\\d{4})(\\d{3})", 
	"$1 $2", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TR:[, [, , "[2-589]\\d{9}|444\\d{4}", , , , , , , [7, 10]], [, , "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", , , , "2123456789", , , [10]], [, , "5(?:(?:0[1-7]|22|[34]\\d|5[1-59]|9[246])\\d{2}|6161)\\d{5}", , , , "5012345678", , , [10]], [, , "800\\d{7}", , , , "8001234567", , 
	, [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TR", 90, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[23]|4(?:[0-35-9]|4[0-35-9])"], "(0$1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[02-69]"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["51|[89]"], "0$1", , 1], [, "(444)(\\d{1})(\\d{3})", "$1 $2 $3", ["444"], , , 1]], , [, , "512\\d{7}", 
	, , , "5123456789", , , [10]], , , [, , "444\\d{4}", , , , "4441444", , , [7]], [, , "444\\d{4}|850\\d{7}", , , , "4441444"], , , [, , , , , , , , , [-1]]], TT:[, [, , "[589]\\d{9}", , , , , , , [10], [7]], [, , "868(?:2(?:01|[23]\\d)|6(?:0[79]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [, , "868(?:2(?:6[6-9]|[789]\\d)|3(?:0[1-9]|1[02-9]|[2-9]\\d)|4[6-9]\\d|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}", , , , "8682911234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", 
	, , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]], TV:[, [, , "[279]\\d{4,6}", , , , , , , [5, 6, 7]], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:70\\d|90)\\d{4}", , , , "901234", 
	, , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], TW:[, [, , "2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}", , , , , , , [7, 8, 9, 10]], [, , "(?:2(?:[235-8]\\d{3}|4\\d{2,3})|3[2-9]\\d{2}|4(?:[239]\\d|[78])\\d{2}|5[2-8]\\d{2}|6[235-79]\\d{2}|7[1-9]\\d{2}|8(?:2(?:3\\d|66)|[7-9]\\d{2}))\\d{4}", 
	, , , "221234567", , , [8, 9]], [, , "9[0-8]\\d{7}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}", , , , "800123456", , , [9]], [, , "20(?:2|[013-9]\\d{2})\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "TW", 886, "0(?:0[25679]|19)", "0", "#", , "0", , , , [[, "(20)(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "([258]0)(\\d{3})(\\d{4})", "$1 $2 $3", ["20[013-9]|50[0-46-9]|80[0-79]"], 
	"0$1"], [, "([2-8])(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[25][2-8]|[346]|[78][1-9]"], "0$1"], [, "(9\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(70)(\\d{4})(\\d{4})", "$1 $2 $3", ["70"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]], TZ:[, [, , "\\d{9}", , , , , , , [7, 9]], [, , "2[2-8]\\d{7}", , , , "222345678"], [, , "(?:6[2-9]|7[13-9])\\d{7}", , , , "621234567", , , [9]], [, , "80[08]\\d{6}", 
	, , , "800123456", , , [9]], [, , "90\\d{7}", , , , "900123456", , , [9]], [, , "8(?:40|6[01])\\d{6}", , , , "840123456", , , [9]], [, , , , , , , , , [-1]], [, , "41\\d{7}", , , , "412345678", , , [9]], "TZ", 255, "00[056]", "0", , , "0", , , , [[, "([24]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "([67]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"], [, "([89]\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}", 
	, , , "800123456", , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UA:[, [, , "[3-9]\\d{8}", , , , , , , [9], [5, 6, 7]], [, , "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", , , , "311234567", , , , [5, 6, 7]], [, , "(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", , , , "391234567"], [, , "800\\d{6}", , , , "800123456"], [, , "900[2-49]\\d{5}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567"], "UA", 380, "00", "0", , , "0", 
	, "0~0", , [[, "([3-9]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[38]9|4(?:[45][0-5]|87)|5(?:0|[67][37])|6[36-8]|7|9[1-9]", "[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"], "0$1"], [, "([3-689]\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90", "3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90"], "0$1"], [, "([3-6]\\d{3})(\\d{5})", "$1 $2", ["3(?:[1-46-8]|5[013-9])|4(?:[137][013-9]|[45][6-9]|6|8[4-6])|5(?:[1245][013-9]|3|6[0135689]|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])", 
	"3(?:[1-46-8](?:[013-9]|22)|5[013-9])|4(?:[137][013-9]|[45][6-9]|6(?:[013-9]|22)|8[4-6])|5(?:[1245][013-9]|3|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UG:[, [, , "\\d{9}", , , , , , , [9], [5, 6, 7]], [, , "20(?:[0147]\\d{3}|2(?:40|[5-9]\\d)\\d|3(?:0[0-4]|[2367]\\d)\\d|5[0-4]\\d{2}|6(?:00[0-2]|30[0-4]|[5-9]\\d{2})|8[0-2]\\d{2})\\d{3}|[34]\\d{8}", 
	, , , "312345678", , , , [5, 6, 7]], [, , "7(?:0[0-7]\\d|[1578]\\d{2}|2(?:[03]\\d|60)|30\\d|4[0-4]\\d|9(?:[0-6]\\d|74))\\d{5}", , , , "712345678"], [, , "800[123]\\d{5}", , , , "800123456"], [, , "90[123]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{3})(\\d{6})", "$1 $2", ["20[0-8]|4(?:6[45]|[7-9])|[7-9]", "20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", 
	["3|4(?:[1-5]|6[0-36-9])"], "0$1"], [, "(2024)(\\d{5})", "$1 $2", ["202", "2024"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], US:[, [, , "[2-9]\\d{9}", , , , , , , [10], [7]], [, , "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}", 
	, , , "2015550123", , , , [7]], [, , "(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}", 
	, , , "2015550123", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "US", 1, "011", "1", , , "1", , , 1, [[, "(\\d{3})(\\d{4})", "$1-$2", , , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", , , , 1]], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3"]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, 
	, , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UY:[, [, , "[2489]\\d{6,7}", , , , , , , [7, 8]], [, , "2\\d{7}|4[2-7]\\d{6}", , , , "21231234", , , [8], [7]], [, , "9[1-9]\\d{6}", , , , "94231234", , , [8]], [, , "80[05]\\d{4}", , , , "8001234", , , [7]], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:1[3-9]\\d|0)", "0", " int. ", , "0", , "00", , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[24]"]], [, "(\\d{2})(\\d{3})(\\d{3})", 
	"$1 $2 $3", ["9[1-9]"], "0$1"], [, "(\\d{3})(\\d{4})", "$1 $2", ["[89]0"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], UZ:[, [, , "[679]\\d{8}", , , , , , , [9], [7]], [, , "(?:6(?:1(?:22|3[124]|4[1-4]|5[123578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d{2}|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[12456]|9[135-8])|1[12]\\d|2(?:22|3[1345789]|4[123579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}", 
	, , , "662345678", , , , [7]], [, , "6(?:1(?:2(?:98|2[01])|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:11\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4])|7\\d{2})|5(?:19[01]|2(?:27|9[26])|30\\d|59\\d|7\\d{2})|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|3[79]\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79])|9[0-3]\\d)|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|5\\d|3[01]|7[0-4])|5[67]\\d|6(?:2[0-26]|8\\d)|7\\d{2}))\\d{4}|7(?:0\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|33\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078])|9[4-6]\\d)|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0127]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[05629]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07])))\\d{4}|9[0-57-9]\\d{7}", 
	, , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UZ", 998, "810", "8", , , "8", , "8~10", , [[, "([679]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[679]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VA:[, [, , "(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))", , , , , , , [6, 8, 9, 
	10, 11]], [, , "06698\\d{5}", , , , "0669812345", , , [10]], [, , "3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})", , , , "3123456789", , , [9, 10, 11]], [, , "80(?:0\\d{6}|3\\d{3})", , , , "800123456", , , [6, 9]], [, , "0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{6}|[17]\\d{3})", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, 
	, "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , "848\\d{6}", , , , "848123456", , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VC:[, [, , "[5789]\\d{9}", , , , , , , [10], [7]], [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-24-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]], [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-58])|5(?:2[6-9]|3[0-4]))\\d{4}", , , , "7844301234", , , , [7]], [, 
	, "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VC", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "784", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VE:[, [, , "[24589]\\d{9}", , , , , , , [10], [7]], [, , "(?:2(?:12|3[457-9]|[58][1-9]|[467]\\d|9[1-6])|50[01])\\d{7}", 
	, , , "2121234567", , , , [7]], [, , "4(?:1[24-8]|2[46])\\d{7}", , , , "4121234567"], [, , "800\\d{7}", , , , "8001234567"], [, , "900\\d{7}", , , , "9001234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "VE", 58, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{7})", "$1-$2", , "0$1", "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VG:[, [, , "[2589]\\d{9}", , , , , , , [10], [7]], [, 
	, "284(?:(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}|496[0-5]\\d{3})", , , , "2842291234", , , , [7]], [, , "284(?:(?:3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|99)|54[0-57])\\d{4}|496[6-9]\\d{3})", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "1", , , , , , 
	[, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VI:[, [, , "[3589]\\d{9}", , , , , , , [10], [7]], [, , "340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "340(?:2(?:01|2[0678]|44|77)|3(?:32|44)|4(?:22|7[34])|5(?:1[34]|55)|6(?:26|4[23]|77|9[023])|7(?:1[2-589]|27|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], 
	[, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "5(?:00|22|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], VN:[, [, , "1\\d{6,9}|2\\d{9}|6\\d{6,7}|7\\d{6}|8\\d{6,8}|9\\d{8}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|3[2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|8[2-7]|9[0-4679])\\d{7}", 
	, , , "2101234567", , , [10]], [, , "(?:9\\d|1(?:2\\d|6[2-9]|8[68]|99))\\d{7}|8(?:6[89]|8\\d|9[89])\\d{6}", , , , "912345678", , , [9, 10]], [, , "1800\\d{4,6}", , , , "1800123456", , , [8, 9, 10]], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "VN", 84, "00", "0", , , "0", , , , [[, "([17]99)(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(80)(\\d{5})", 
	"$1 $2", ["80"], "0$1", , 1], [, "(69\\d)(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2[0-35-79]"], "0$1", , 1], [, "([89]\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8(?:8|9[89])|9"], "0$1", , 1], [, "(1[2689]\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:[26]|8[68]|99)"], "0$1", , 1], [, "(86[89])(\\d{3})(\\d{3})", "$1 $2 $3", ["86[89]"], "0$1", , 1], [, "(1[89]00)(\\d{4,6})", "$1 $2", ["1[89]0", "1[89]00"], "$1", , 1]], , [, , , , , , , , , [-1]], , , [, 
	, "[17]99\\d{4}|69\\d{5,6}", , , , "1992000", , , [7, 8]], [, , "[17]99\\d{4}|69\\d{5,6}|80\\d{5}", , , , "1992000", , , [7, 8]], , , [, , , , , , , , , [-1]]], VU:[, [, , "[2-57-9]\\d{4,6}", , , , , , , [5, 7]], [, , "(?:2[02-9]\\d|3(?:[5-7]\\d|8[0-8])|48[4-9]|88\\d)\\d{2}", , , , "22123", , , [5]], [, , "(?:5(?:7[2-5]|[0-689]\\d)|7[013-7]\\d)\\d{4}", , , , "5912345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , 
	, , [-1]], "VU", 678, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[579]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "3[03]\\d{3}|900\\d{4}", , , , "30123"], , , [, , , , , , , , , [-1]]], WF:[, [, , "[4-8]\\d{5}", , , , , , , [6]], [, , "(?:50|68|72)\\d{4}", , , , "501234"], [, , "(?:50|68|72|8[23])\\d{4}", , , , "501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "WF", 681, 
	"00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234"]], WS:[, [, , "[2-8]\\d{4,6}", , , , , , , [5, 6, 7]], [, , "(?:[2-5]\\d|6[1-9]|84\\d{2})\\d{3}", , , , "22123", , , [5, 7]], [, , "(?:60|7[25-7]\\d)\\d{4}", , , , "601234", , , [6, 7]], [, , "800\\d{3}", , , , "800123", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, 
	, , , , , , , , [-1]], "WS", 685, "0", , , , , , , , [[, "(8\\d{2})(\\d{3,4})", "$1 $2", ["8"]], [, "(7\\d)(\\d{5})", "$1 $2", ["7"]], [, "(\\d{5})", "$1", ["[2-6]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], YE:[, [, , "[1-7]\\d{6,8}", , , , , , , [7, 8, 9], [6]], [, , "(?:1(?:7\\d|[2-68])|2[2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-68])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[0137]\\d{7}", , , , "712345678", , 
	, [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "([1-7])(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], [, "(7\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["7[0137]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], YT:[, [, , "[268]\\d{8}", , , , , , , [9]], [, , "269(?:6[0-4]|50)\\d{4}", 
	, , , "269601234"], [, , "639(?:0[0-79]|1[019]|[26]\\d|3[09]|[45]0|7[06]|9[04-79])\\d{4}", , , , "639012345"], [, , "80\\d{7}", , , , "801234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YT", 262, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , "269|63", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZA:[, [, , "[1-79]\\d{8}|8\\d{4,8}", , , , , , , [5, 6, 7, 8, 9]], [, , "(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", 
	, , , "101234567", , , [9]], [, , "(?:6\\d|7[0-46-9])\\d{7}|8(?:[1-4]\\d{1,5}|5\\d{5})\\d{2}", , , , "711234567"], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "86[2-9]\\d{6}|9[0-2]\\d{7}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [, , "87\\d{7}", , , , "871234567", , , [9]], "ZA", 27, "00", "0", , , "0", , , , [[, "(860)(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", 
	"$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-79]|8(?:[0-57]|6[1-9])"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6}", , , , "861123456", , , [9]], , , [, , , , , , , , , [-1]]], ZM:[, [, , "[289]\\d{8}", , , , , , , [9]], [, , "21[1-8]\\d{6}", , , , "211234567"], [, , "9[4-9]\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , 
	, , , , , , [-1]], "ZM", 260, "00", "0", , , "0", , , , [[, "([29]\\d)(\\d{7})", "$1 $2", ["[29]"], "0$1"], [, "(800)(\\d{3})(\\d{3})", "$1 $2 $3", ["800"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], ZW:[, [, , "2(?:[0-57-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-79]\\d{4,9}|8[06]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [, , "(?:2(?:0(?:4\\d|5\\d{2})|2[278]\\d|48\\d|7(?:[1-7]\\d|[089]\\d{2})|8(?:[2-57-9]|[146]\\d{2})|98)|3(?:08|17|3[78]|7(?:[19]|[56]\\d)|8[37]|98)|5[15][78]|6(?:28\\d{2}|37|6[78]|75\\d|98|8(?:7\\d|8)))\\d{3}|(?:2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329)\\d{7}|(?:1(?:3\\d{2}|[4-8]|9\\d)|2(?:0\\d{2}|12|292|[569]\\d)|3(?:[26]|[013459]\\d)|5(?:0|1[2-4]|26|[37]2|5\\d{2}|[689]\\d)|6(?:[39]|[01246]\\d|[78]\\d{2}))\\d{3}|(?:29\\d|39|54)\\d{6}|(?:(?:25|54)83\\d|2582\\d{2}|65[2-8])\\d{2}|(?:4\\d{6,7}|9[2-9]\\d{4,5})", 
	, , , "1312345", , , , [3, 4]], [, , "(?:7(?:1[2-8]|3[2-9]|7[1-9]|8[2-5])|8644)\\d{6}", , , , "712345678", , , [9, 10]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|30|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [[, "([49])(\\d{3})(\\d{2,4})", "$1 $2 $3", ["4|9[2-9]"], "0$1"], [, "(7\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["7"], "0$1"], [, 
	"(86\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["86[24]"], "0$1"], [, "([2356]\\d{2})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|7[1569]|8[37])|5[15][78]|6(?:[29]8|37|[68][78]|75)"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"], "0$1"], [, "([1-356]\\d)(\\d{3,5})", "$1 $2", ["1[3-9]|2[02569]|3[0-69]|5[05689]|6"], "0$1"], [, "([235]\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[23]9|54"], "0$1"], [, "([25]\\d{3})(\\d{3,5})", "$1 $2", 
	["(?:25|54)8", "258[23]|5483"], "0$1"], [, "(8\\d{3})(\\d{6})", "$1 $2", ["86"], "0$1"], [, "(80\\d)(\\d{4})", "$1 $2", ["80"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 800:[, [, , "\\d{8}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{8}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 800, , , , , 
	, , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 808:[, [, , "\\d{8}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{8}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , 
	, [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 870:[, [, , "[35-7]\\d{8}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , "(?:[356]\\d|7[6-8])\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , 
	, [-1]]], 878:[, [, , "1\\d{11}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 881:[, [, , "[67]\\d{8}", , , , , , , [9]], [, , , , , , , , 
	, [-1]], [, , "[67]\\d{8}", , , , "612345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 882:[, [, , "[13]\\d{6,11}", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , "3(?:2\\d{3}|37\\d{2}|4(?:2|7\\d{3}))\\d{4}", 
	, , , "3421234", , , [7, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15678]|9[0689])\\d{4}|6\\d{5,10})|3(?:45|9\\d{3})\\d{7}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], [, "(\\d{3})(\\d{4})(\\d{4})", 
	"$1 $2 $3", ["348"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["16|39"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]], 883:[, [, , "51\\d{7}(?:\\d{3})?", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , 
	, , , [-1]], [, , , , , , , , , [-1]], [, , "51(?:00\\d{5}(?:\\d{3})?|[13]0\\d{8})", , , , "510012345"], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]], 888:[, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , 
	, , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]], 979:[, [, , "\\d{9}", , , , , , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "\\d{9}", , , , "123456789"], 
	[, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]};
	/*
	
	 Copyright (C) 2010 The Libphonenumber Authors.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	 http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	i18n.phonenumbers.PhoneNumberUtil = function() {
	  this.regionToMetadataMap = {};
	};
	goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil);
	i18n.phonenumbers.Error = {INVALID_COUNTRY_CODE:"Invalid country calling code", NOT_A_NUMBER:"The string supplied did not seem to be a phone number", TOO_SHORT_AFTER_IDD:"Phone number too short after IDD", TOO_SHORT_NSN:"The string supplied is too short to be a phone number", TOO_LONG:"The string supplied is too long to be a phone number"};
	i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1;
	i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2;
	i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17;
	i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3;
	i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250;
	i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ";
	i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_ = "3";
	i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = {52:"1", 54:"9"};
	i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [52, 54, 55];
	i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+";
	i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*";
	i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=";
	i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:";
	i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=";
	i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=";
	i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "\uff10":"0", "\uff11":"1", "\uff12":"2", "\uff13":"3", "\uff14":"4", "\uff15":"5", "\uff16":"6", "\uff17":"7", "\uff18":"8", "\uff19":"9", "\u0660":"0", "\u0661":"1", "\u0662":"2", "\u0663":"3", "\u0664":"4", "\u0665":"5", "\u0666":"6", "\u0667":"7", "\u0668":"8", "\u0669":"9", "\u06f0":"0", "\u06f1":"1", "\u06f2":"2", "\u06f3":"3", "\u06f4":"4", "\u06f5":"5", "\u06f6":"6", "\u06f7":"7", 
	"\u06f8":"8", "\u06f9":"9"};
	i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "+":i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN, "*":"*", "#":"#"};
	i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = {A:"2", B:"2", C:"2", D:"3", E:"3", F:"3", G:"4", H:"4", I:"4", J:"5", K:"5", L:"5", M:"6", N:"6", O:"6", P:"7", Q:"7", R:"7", S:"7", T:"8", U:"8", V:"8", W:"9", X:"9", Y:"9", Z:"9"};
	i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", "\uff10":"0", "\uff11":"1", "\uff12":"2", "\uff13":"3", "\uff14":"4", "\uff15":"5", "\uff16":"6", "\uff17":"7", "\uff18":"8", "\uff19":"9", "\u0660":"0", "\u0661":"1", "\u0662":"2", "\u0663":"3", "\u0664":"4", "\u0665":"5", "\u0666":"6", "\u0667":"7", "\u0668":"8", "\u0669":"9", "\u06f0":"0", "\u06f1":"1", "\u06f2":"2", "\u06f3":"3", "\u06f4":"4", "\u06f5":"5", "\u06f6":"6", 
	"\u06f7":"7", "\u06f8":"8", "\u06f9":"9", A:"2", B:"2", C:"2", D:"3", E:"3", F:"3", G:"4", H:"4", I:"4", J:"5", K:"5", L:"5", M:"6", N:"6", O:"6", P:"7", Q:"7", R:"7", S:"7", T:"8", U:"8", V:"8", W:"9", X:"9", Y:"9", Z:"9"};
	i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {0:"0", 1:"1", 2:"2", 3:"3", 4:"4", 5:"5", 6:"6", 7:"7", 8:"8", 9:"9", A:"A", B:"B", C:"C", D:"D", E:"E", F:"F", G:"G", H:"H", I:"I", J:"J", K:"K", L:"L", M:"M", N:"N", O:"O", P:"P", Q:"Q", R:"R", S:"S", T:"T", U:"U", V:"V", W:"W", X:"X", Y:"Y", Z:"Z", a:"A", b:"B", c:"C", d:"D", e:"E", f:"F", g:"G", h:"H", i:"I", j:"J", k:"K", l:"L", m:"M", n:"N", o:"O", p:"P", q:"Q", r:"R", s:"S", t:"T", u:"U", v:"V", w:"W", x:"X", y:"Y", z:"Z", 
	"-":"-", "\uff0d":"-", "\u2010":"-", "\u2011":"-", "\u2012":"-", "\u2013":"-", "\u2014":"-", "\u2015":"-", "\u2212":"-", "/":"/", "\uff0f":"/", " ":" ", "\u3000":" ", "\u2060":" ", ".":".", "\uff0e":"."};
	i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;
	i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x\u2010-\u2015\u2212\u30fc\uff0d-\uff0f \u00a0\u00ad\u200b\u2060\u3000()\uff08\uff09\uff3b\uff3d.\\[\\]/~\u2053\u223c\uff5e";
	i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9";
	i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z";
	i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+\uff0b";
	i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
	i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+");
	i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+";
	i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])");
	i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]");
	i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/;
	i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$");
	i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/;
	i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}";
	i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*";
	i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ";
	i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1,7})";
	i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ + "|[ \u00a0\\t,]*(?:e?xt(?:ensi(?:o\u0301?|\u00f3))?n?|\uff45?\uff58\uff54\uff4e?|[;,x\uff58#\uff03~\uff5e]|int|anexo|\uff49\uff4e\uff54)[:\\.\uff0e]?[ \u00a0\\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.CAPTURING_EXTN_DIGITS_ + "#?|[- ]+([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1,5})#";
	i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ + ")$", "i");
	i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERNS_FOR_PARSING_ + ")?$", "i");
	i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/;
	i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/;
	i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/;
	i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/;
	i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/;
	i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/;
	i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001";
	i18n.phonenumbers.PhoneNumberFormat = {E164:0, INTERNATIONAL:1, NATIONAL:2, RFC3966:3};
	i18n.phonenumbers.PhoneNumberType = {FIXED_LINE:0, MOBILE:1, FIXED_LINE_OR_MOBILE:2, TOLL_FREE:3, PREMIUM_RATE:4, SHARED_COST:5, VOIP:6, PERSONAL_NUMBER:7, PAGER:8, UAN:9, VOICEMAIL:10, UNKNOWN:-1};
	i18n.phonenumbers.PhoneNumberUtil.MatchType = {NOT_A_NUMBER:0, NO_MATCH:1, SHORT_NSN_MATCH:2, NSN_MATCH:3, EXACT_MATCH:4};
	i18n.phonenumbers.PhoneNumberUtil.ValidationResult = {IS_POSSIBLE:0, IS_POSSIBLE_LOCAL_ONLY:4, INVALID_COUNTRY_CODE:1, TOO_SHORT:2, INVALID_LENGTH:5, TOO_LONG:3};
	i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(a) {
	  var b = a.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
	  0 <= b ? (a = a.substring(b), a = a.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), b = a.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= b && (a = a.substring(0, b))) : a = "";
	  return a;
	};
	i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(a) {
	  return a.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, a);
	};
	i18n.phonenumbers.PhoneNumberUtil.normalize = function(a) {
	  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
	};
	i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(a) {
	  var b = i18n.phonenumbers.PhoneNumberUtil.normalize(a.toString());
	  a.clear();
	  a.append(b);
	};
	i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(a) {
	  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
	};
	i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(a) {
	  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
	};
	i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(a) {
	  return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(a, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(a) {
	  var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
	  return null != b && (b.hasNationalPrefix() || a.hasItalianLeadingZero()) && this.isNumberGeographical(a) ? this.getLengthOfNationalDestinationCode(a) : 0;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(a) {
	  if (a.hasExtension()) {
	    var b = a.clone();
	    b.clearExtension();
	  } else {
	    b = a;
	  }
	  b = this.format(b, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_);
	  0 == b[0].length && b.shift();
	  return 2 >= b.length ? 0 : this.getNumberType(a) == i18n.phonenumbers.PhoneNumberType.MOBILE && (a = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(a.getCountryCodeOrDefault()), "" != a) ? b[2].length + a.length : b[1].length;
	};
	i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(a) {
	  return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[a] || "";
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
	  return goog.array.filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function(a) {
	    return isNaN(a);
	  });
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
	  var a = goog.array.filter(Object.keys(i18n.phonenumbers.metadata.countryToMetadata), function(a) {
	    return !isNaN(a);
	  });
	  return goog.array.map(a, function(a) {
	    return parseInt(a, 10);
	  });
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
	  var a = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
	  return goog.array.join(this.getSupportedGlobalNetworkCallingCodes(), goog.array.map(a, function(a) {
	    return parseInt(a, 10);
	  }));
	};
	i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(a) {
	  return null != a && (1 != a.possibleLengthCount() || -1 != a.possibleLengthArray()[0]);
	};
	i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(a) {
	  return null != a && (a.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(a) || a.hasNationalNumberPattern());
	};
	i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(a) {
	  var b = [];
	  goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(c) {
	    if (c != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && c != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
	      var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(a, c);
	      i18n.phonenumbers.PhoneNumberUtil.descHasData_(d) && b.push(c);
	    }
	  });
	  return b;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(a) {
	  return this.isValidRegionCode_(a) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(a)) : [];
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(a) {
	  a = this.getMetadataForNonGeographicalRegion(a);
	  return null == a ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(a);
	};
	i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(a, b, c) {
	  for (var d = new goog.string.StringBuffer, e, f, g = a.length, h = 0; h < g; ++h) {
	    e = a.charAt(h), f = b[e.toUpperCase()], null != f ? d.append(f) : c || d.append(e);
	  }
	  return d.toString();
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(a) {
	  return 0 == a.length || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(a);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(a) {
	  var b = this.getNumberType(a);
	  return b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || b == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || goog.array.contains(i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_, a.getCountryCodeOrDefault()) && b == i18n.phonenumbers.PhoneNumberType.MOBILE;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(a) {
	  return null != a && isNaN(a) && a.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(a) {
	  return a in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(a, b) {
	  if (0 == a.getNationalNumber() && a.hasRawInput()) {
	    var c = a.getRawInputOrDefault();
	    if (0 < c.length) {
	      return c;
	    }
	  }
	  c = a.getCountryCodeOrDefault();
	  var d = this.getNationalSignificantNumber(a);
	  if (b == i18n.phonenumbers.PhoneNumberFormat.E164) {
	    return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.E164, d, "");
	  }
	  if (!this.hasValidCountryCallingCode_(c)) {
	    return d;
	  }
	  var e = this.getRegionCodeForCountryCode(c), f = this.getMetadataForRegionOrCallingCode_(c, e);
	  e = this.maybeGetFormattedExtension_(a, f, b);
	  d = this.formatNsn_(d, f, b);
	  return this.prefixNumberWithCountryCallingCode_(c, b, d, e);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(a, b, c) {
	  var d = a.getCountryCodeOrDefault(), e = this.getNationalSignificantNumber(a);
	  if (!this.hasValidCountryCallingCode_(d)) {
	    return e;
	  }
	  var f = this.getRegionCodeForCountryCode(d);
	  f = this.getMetadataForRegionOrCallingCode_(d, f);
	  var g = this.chooseFormattingPatternForNumber_(c, e);
	  if (null != g) {
	    c = g.clone();
	    g = g.getNationalPrefixFormattingRuleOrDefault();
	    if (0 < g.length) {
	      var h = f.getNationalPrefixOrDefault();
	      0 < h.length ? (g = g.replace(i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_, h).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), c.setNationalPrefixFormattingRule(g)) : c.clearNationalPrefixFormattingRule();
	    }
	    e = this.formatNsnUsingPattern_(e, c, b);
	  }
	  a = this.maybeGetFormattedExtension_(a, f, b);
	  return this.prefixNumberWithCountryCallingCode_(d, b, e, a);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(a, b) {
	  var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
	  if (!this.hasValidCountryCallingCode_(c)) {
	    return d;
	  }
	  var e = this.getRegionCodeForCountryCode(c), f = this.getMetadataForRegionOrCallingCode_(c, e);
	  e = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
	  d = this.formatNsn_(d, f, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, b);
	  return this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, d, e);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(a, b) {
	  return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == b ? this.getMetadataForNonGeographicalRegion(a) : this.getMetadataForRegion(b);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(a, b) {
	  return this.formatNationalNumberWithCarrierCode(a, 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? a.getPreferredDomesticCarrierCodeOrDefault() : b);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(a, b, c) {
	  var d = a.getCountryCodeOrDefault();
	  if (!this.hasValidCountryCallingCode_(d)) {
	    return a.hasRawInput() ? a.getRawInputOrDefault() : "";
	  }
	  var e = "";
	  a = a.clone();
	  a.clearExtension();
	  var f = this.getRegionCodeForCountryCode(d), g = this.getNumberType(a), h = g != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
	  if (b == f) {
	    e = g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || g == i18n.phonenumbers.PhoneNumberType.MOBILE || g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, "CO" == f && g == i18n.phonenumbers.PhoneNumberType.FIXED_LINE ? e = this.formatNationalNumberWithCarrierCode(a, i18n.phonenumbers.PhoneNumberUtil.COLOMBIA_MOBILE_TO_FIXED_LINE_PREFIX_) : "BR" == f && e ? e = 0 < a.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(a, "") : "" : 
	    h && "HU" == f ? e = this.getNddPrefixForRegion(f, !0) + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL) : d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (b = this.getMetadataForRegion(b), e = this.canBeInternationallyDialled(a) && this.testNumberLength_(this.getNationalSignificantNumber(a), b) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : 
	    e = (f == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || ("MX" == f || "CL" == f) && e) && this.canBeInternationallyDialled(a) ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
	  } else {
	    if (h && this.canBeInternationallyDialled(a)) {
	      return c ? this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(a, i18n.phonenumbers.PhoneNumberFormat.E164);
	    }
	  }
	  return c ? e : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(a, b) {
	  if (!this.isValidRegionCode_(b)) {
	    return this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
	  }
	  var c = a.getCountryCodeOrDefault(), d = this.getNationalSignificantNumber(a);
	  if (!this.hasValidCountryCallingCode_(c)) {
	    return d;
	  }
	  if (c == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
	    if (this.isNANPACountry(b)) {
	      return c + " " + this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
	    }
	  } else {
	    if (c == this.getCountryCodeForValidRegion_(b)) {
	      return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
	    }
	  }
	  var e = this.getMetadataForRegion(b), f = e.getInternationalPrefixOrDefault(), g = "";
	  i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, f) ? g = f : e.hasPreferredInternationalPrefix() && (g = e.getPreferredInternationalPrefixOrDefault());
	  e = this.getRegionCodeForCountryCode(c);
	  e = this.getMetadataForRegionOrCallingCode_(c, e);
	  d = this.formatNsn_(d, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
	  e = this.maybeGetFormattedExtension_(a, e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
	  return 0 < g.length ? g + " " + c + " " + d + e : this.prefixNumberWithCountryCallingCode_(c, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, d, e);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(a, b) {
	  if (a.hasRawInput() && !this.hasFormattingPatternForNumber_(a)) {
	    return a.getRawInputOrDefault();
	  }
	  if (!a.hasCountryCodeSource()) {
	    return this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
	  }
	  switch(a.getCountryCodeSource()) {
	    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
	      var c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
	      break;
	    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
	      c = this.formatOutOfCountryCallingNumber(a, b);
	      break;
	    case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
	      c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
	      break;
	    default:
	      var d = this.getRegionCodeForCountryCode(a.getCountryCodeOrDefault()), e = this.getNddPrefixForRegion(d, !0);
	      c = this.format(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
	      if (null != e && 0 != e.length && !this.rawInputContainsNationalPrefix_(a.getRawInputOrDefault(), e, d) && (d = this.getMetadataForRegion(d), e = this.getNationalSignificantNumber(a), d = this.chooseFormattingPatternForNumber_(d.numberFormatArray(), e), null != d)) {
	        e = d.getNationalPrefixFormattingRuleOrDefault();
	        var f = e.indexOf("$1");
	        0 >= f || (e = e.substring(0, f), e = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e), 0 != e.length && (c = d.clone(), c.clearNationalPrefixFormattingRule(), c = this.formatByPattern(a, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [c])));
	      }
	  }
	  d = a.getRawInputOrDefault();
	  null != c && 0 < d.length && (e = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(c), f = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(d), e != f && (c = d));
	  return c;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(a, b, c) {
	  a = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(a);
	  if (goog.string.startsWith(a, b)) {
	    try {
	      return this.isValidNumber(this.parse(a.substring(b.length), c));
	    } catch (d) {
	    }
	  }
	  return !1;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(a) {
	  var b = a.getCountryCodeOrDefault(), c = this.getRegionCodeForCountryCode(b);
	  b = this.getMetadataForRegionOrCallingCode_(b, c);
	  if (null == b) {
	    return !1;
	  }
	  a = this.getNationalSignificantNumber(a);
	  return null != this.chooseFormattingPatternForNumber_(b.numberFormatArray(), a);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(a, b) {
	  var c = a.getRawInputOrDefault();
	  if (0 == c.length) {
	    return this.formatOutOfCountryCallingNumber(a, b);
	  }
	  var d = a.getCountryCodeOrDefault();
	  if (!this.hasValidCountryCallingCode_(d)) {
	    return c;
	  }
	  c = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(c, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0);
	  var e = this.getNationalSignificantNumber(a);
	  if (3 < e.length) {
	    var f = c.indexOf(e.substring(0, 3));
	    -1 != f && (c = c.substring(f));
	  }
	  f = this.getMetadataForRegion(b);
	  if (d == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
	    if (this.isNANPACountry(b)) {
	      return d + " " + c;
	    }
	  } else {
	    if (null != f && d == this.getCountryCodeForValidRegion_(b)) {
	      d = this.chooseFormattingPatternForNumber_(f.numberFormatArray(), e);
	      if (null == d) {
	        return c;
	      }
	      d = d.clone();
	      d.setPattern("(\\d+)(.*)");
	      d.setFormat("$1$2");
	      return this.formatNsnUsingPattern_(c, d, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
	    }
	  }
	  e = "";
	  null != f && (e = f.getInternationalPrefixOrDefault(), e = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, e) ? e : f.getPreferredInternationalPrefixOrDefault());
	  f = this.getRegionCodeForCountryCode(d);
	  f = this.getMetadataForRegionOrCallingCode_(d, f);
	  f = this.maybeGetFormattedExtension_(a, f, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
	  return 0 < e.length ? e + " " + d + " " + c + f : this.prefixNumberWithCountryCallingCode_(d, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, c, f);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(a) {
	  if (!a.hasNationalNumber()) {
	    return "";
	  }
	  var b = "" + a.getNationalNumber();
	  return a.hasItalianLeadingZero() && a.getItalianLeadingZero() && 0 < a.getNumberOfLeadingZerosOrDefault() ? Array(a.getNumberOfLeadingZerosOrDefault() + 1).join("0") + b : b;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(a, b, c, d) {
	  switch(b) {
	    case i18n.phonenumbers.PhoneNumberFormat.E164:
	      return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + c + d;
	    case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
	      return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + " " + c + d;
	    case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
	      return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + a + "-" + c + d;
	    default:
	      return c + d;
	  }
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(a, b, c, d) {
	  b = 0 == b.intlNumberFormatArray().length || c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? b.numberFormatArray() : b.intlNumberFormatArray();
	  b = this.chooseFormattingPatternForNumber_(b, a);
	  return null == b ? a : this.formatNsnUsingPattern_(a, b, c, d);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(a, b) {
	  for (var c, d = a.length, e = 0; e < d; ++e) {
	    c = a[e];
	    var f = c.leadingDigitsPatternCount();
	    if (0 == f || 0 == b.search(c.getLeadingDigitsPattern(f - 1))) {
	      if (f = new RegExp(c.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(f, b)) {
	        return c;
	      }
	    }
	  }
	  return null;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(a, b, c, d) {
	  var e = b.getFormatOrDefault(), f = new RegExp(b.getPattern()), g = b.getDomesticCarrierCodeFormattingRuleOrDefault();
	  c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != d && 0 < d.length && 0 < g.length ? (b = g.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, d), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b), a = a.replace(f, e)) : (b = b.getNationalPrefixFormattingRuleOrDefault(), a = c == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && null != b && 0 < b.length ? a.replace(f, e.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, b)) : a.replace(f, e));
	  c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (a = a.replace(new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), a = a.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-"));
	  return a;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(a) {
	  return this.getExampleNumberForType(a, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(a, b) {
	  if (!this.isValidRegionCode_(a)) {
	    return null;
	  }
	  var c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(a), b);
	  try {
	    if (c.hasExampleNumber()) {
	      return this.parse(c.getExampleNumber(), a);
	    }
	  } catch (d) {
	  }
	  return null;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(a) {
	  var b = this.getMetadataForNonGeographicalRegion(a);
	  if (null != b && (b = goog.array.find([b.getMobile(), b.getTollFree(), b.getSharedCost(), b.getVoip(), b.getVoicemail(), b.getUan(), b.getPremiumRate()], function(a, b) {
	    return a.hasExampleNumber();
	  }), null != b)) {
	    try {
	      return this.parse("+" + a + b.getExampleNumber(), "ZZ");
	    } catch (c) {
	    }
	  }
	  return null;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(a, b, c) {
	  return a.hasExtension() && 0 != a.getExtension().length ? c == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + a.getExtension() : b.hasPreferredExtnPrefix() ? b.getPreferredExtnPrefix() + a.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + a.getExtensionOrDefault() : "";
	};
	i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(a, b) {
	  switch(b) {
	    case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
	      return a.getPremiumRate();
	    case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
	      return a.getTollFree();
	    case i18n.phonenumbers.PhoneNumberType.MOBILE:
	      return a.getMobile();
	    case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
	    case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
	      return a.getFixedLine();
	    case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
	      return a.getSharedCost();
	    case i18n.phonenumbers.PhoneNumberType.VOIP:
	      return a.getVoip();
	    case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
	      return a.getPersonalNumber();
	    case i18n.phonenumbers.PhoneNumberType.PAGER:
	      return a.getPager();
	    case i18n.phonenumbers.PhoneNumberType.UAN:
	      return a.getUan();
	    case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
	      return a.getVoicemail();
	    default:
	      return a.getGeneralDesc();
	  }
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(a) {
	  var b = this.getRegionCodeForNumber(a);
	  b = this.getMetadataForRegionOrCallingCode_(a.getCountryCodeOrDefault(), b);
	  if (null == b) {
	    return i18n.phonenumbers.PhoneNumberType.UNKNOWN;
	  }
	  a = this.getNationalSignificantNumber(a);
	  return this.getNumberTypeHelper_(a, b);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(a, b) {
	  return this.isNumberMatchingDesc_(a, b.getGeneralDesc()) ? this.isNumberMatchingDesc_(a, b.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(a, b.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(a, b.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(a, b.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(a, b.getPersonalNumber()) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : 
	  this.isNumberMatchingDesc_(a, b.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(a, b.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(a, b.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(a, b.getFixedLine()) ? b.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : 
	  !b.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(a, b.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(a) {
	  if (null == a) {
	    return null;
	  }
	  a = a.toUpperCase();
	  var b = this.regionToMetadataMap[a];
	  if (null == b) {
	    b = new goog.proto2.PbLiteSerializer;
	    var c = i18n.phonenumbers.metadata.countryToMetadata[a];
	    if (null == c) {
	      return null;
	    }
	    b = b.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), c);
	    this.regionToMetadataMap[a] = b;
	  }
	  return b;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(a) {
	  return this.getMetadataForRegion("" + a);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(a, b) {
	  var c = a.length;
	  return 0 < b.possibleLengthCount() && -1 == goog.array.indexOf(b.possibleLengthArray(), c) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(b.getNationalNumberPatternOrDefault(), a);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(a) {
	  var b = this.getRegionCodeForNumber(a);
	  return this.isValidNumberForRegion(a, b);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(a, b) {
	  var c = a.getCountryCodeOrDefault(), d = this.getMetadataForRegionOrCallingCode_(c, b);
	  if (null == d || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != b && c != this.getCountryCodeForValidRegion_(b)) {
	    return !1;
	  }
	  c = this.getNationalSignificantNumber(a);
	  return this.getNumberTypeHelper_(c, d) != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(a) {
	  if (null == a) {
	    return null;
	  }
	  var b = a.getCountryCodeOrDefault();
	  b = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[b];
	  return null == b ? null : 1 == b.length ? b[0] : this.getRegionCodeForNumberFromRegionList_(a, b);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(a, b) {
	  for (var c = this.getNationalSignificantNumber(a), d, e = b.length, f = 0; f < e; f++) {
	    d = b[f];
	    var g = this.getMetadataForRegion(d);
	    if (g.hasLeadingDigits()) {
	      if (0 == c.search(g.getLeadingDigits())) {
	        return d;
	      }
	    } else {
	      if (this.getNumberTypeHelper_(c, g) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
	        return d;
	      }
	    }
	  }
	  return null;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(a) {
	  a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
	  return null == a ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : a[0];
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(a) {
	  a = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[a];
	  return null == a ? [] : a;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(a) {
	  return this.isValidRegionCode_(a) ? this.getCountryCodeForValidRegion_(a) : 0;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(a) {
	  var b = this.getMetadataForRegion(a);
	  if (null == b) {
	    throw Error("Invalid region code: " + a);
	  }
	  return b.getCountryCodeOrDefault();
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(a, b) {
	  var c = this.getMetadataForRegion(a);
	  if (null == c) {
	    return null;
	  }
	  c = c.getNationalPrefixOrDefault();
	  if (0 == c.length) {
	    return null;
	  }
	  b && (c = c.replace("~", ""));
	  return c;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(a) {
	  return null != a && goog.array.contains(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_], a.toUpperCase());
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(a) {
	  if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(a)) {
	    return !1;
	  }
	  a = new goog.string.StringBuffer(a);
	  this.maybeStripExtension(a);
	  return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, a.toString());
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(a) {
	  a = this.isPossibleNumberWithReason(a);
	  return a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || a == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(a, b) {
	  var c = this.isPossibleNumberForTypeWithReason(a, b);
	  return c == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || c == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(a, b) {
	  return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(a, b, c) {
	  var d = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, c), e = 0 == d.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : d.possibleLengthArray();
	  d = d.possibleLengthLocalOnlyArray();
	  if (c == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) {
	    if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) {
	      c = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(b, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(c) && (e = e.concat(0 == c.possibleLengthCount() ? b.getGeneralDesc().possibleLengthArray() : c.possibleLengthArray()), goog.array.sort(e), 0 == d.length ? d = c.possibleLengthLocalOnlyArray() : (d = d.concat(c.possibleLengthLocalOnlyArray()), goog.array.sort(d)));
	    } else {
	      return this.testNumberLengthForType_(a, b, i18n.phonenumbers.PhoneNumberType.MOBILE);
	    }
	  }
	  if (-1 == e[0]) {
	    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
	  }
	  a = a.length;
	  if (-1 < goog.array.indexOf(d, a)) {
	    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
	  }
	  b = e[0];
	  return b == a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : b > a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : e[e.length - 1] < a ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < goog.array.indexOf(e, a, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(a) {
	  return this.isPossibleNumberForTypeWithReason(a, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(a, b) {
	  var c = this.getNationalSignificantNumber(a), d = a.getCountryCodeOrDefault();
	  if (!this.hasValidCountryCallingCode_(d)) {
	    return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
	  }
	  var e = this.getRegionCodeForCountryCode(d);
	  d = this.getMetadataForRegionOrCallingCode_(d, e);
	  return this.testNumberLengthForType_(c, d, b);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(a, b) {
	  try {
	    return this.isPossibleNumber(this.parse(a, b));
	  } catch (c) {
	    return !1;
	  }
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(a) {
	  if (this.isValidNumber(a)) {
	    return !0;
	  }
	  var b = a.clone(), c = a.getNationalNumberOrDefault();
	  do {
	    if (c = Math.floor(c / 10), b.setNationalNumber(c), 0 == c || this.isPossibleNumberWithReason(b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) {
	      return !1;
	    }
	  } while (!this.isValidNumber(b));
	  a.setNationalNumber(c);
	  return !0;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(a, b) {
	  var c = a.toString();
	  if (0 == c.length || "0" == c.charAt(0)) {
	    return 0;
	  }
	  for (var d, e = c.length, f = 1; f <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && f <= e; ++f) {
	    if (d = parseInt(c.substring(0, f), 10), d in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) {
	      return b.append(c.substring(f)), d;
	    }
	  }
	  return 0;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(a, b, c, d, e) {
	  if (0 == a.length) {
	    return 0;
	  }
	  a = new goog.string.StringBuffer(a);
	  var f;
	  null != b && (f = b.getInternationalPrefix());
	  null == f && (f = "NonMatch");
	  f = this.maybeStripInternationalPrefixAndNormalize(a, f);
	  d && e.setCountryCodeSource(f);
	  if (f != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
	    if (a.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
	      throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
	    }
	    b = this.extractCountryCode(a, c);
	    if (0 != b) {
	      return e.setCountryCode(b), b;
	    }
	    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
	  }
	  if (null != b) {
	    f = b.getCountryCodeOrDefault();
	    var g = "" + f, h = a.toString();
	    if (goog.string.startsWith(h, g) && (g = new goog.string.StringBuffer(h.substring(g.length)), h = b.getGeneralDesc(), h = new RegExp(h.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(g, b, null), g = g.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(h, a.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(h, g) || this.testNumberLength_(a.toString(), b) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) {
	      return c.append(g), d && e.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), e.setCountryCode(f), f;
	    }
	  }
	  e.setCountryCode(0);
	  return 0;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(a, b) {
	  var c = b.toString();
	  if (0 == c.search(a)) {
	    var d = c.match(a)[0].length, e = c.substring(d).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
	    if (e && null != e[1] && 0 < e[1].length && "0" == i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e[1])) {
	      return !1;
	    }
	    b.clear();
	    b.append(c.substring(d));
	    return !0;
	  }
	  return !1;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(a, b) {
	  var c = a.toString();
	  if (0 == c.length) {
	    return i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
	  }
	  if (i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_.test(c)) {
	    return c = c.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_, ""), a.clear(), a.append(i18n.phonenumbers.PhoneNumberUtil.normalize(c)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN;
	  }
	  c = new RegExp(b);
	  i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(a);
	  return this.parsePrefixAsIdd_(c, a) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(a, b, c) {
	  var d = a.toString(), e = d.length, f = b.getNationalPrefixForParsing();
	  if (0 == e || null == f || 0 == f.length) {
	    return !1;
	  }
	  var g = new RegExp("^(?:" + f + ")");
	  if (e = g.exec(d)) {
	    f = new RegExp(b.getGeneralDesc().getNationalNumberPatternOrDefault());
	    var h = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(f, d), k = e.length - 1;
	    b = b.getNationalPrefixTransformRule();
	    if (null == b || 0 == b.length || null == e[k] || 0 == e[k].length) {
	      if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(f, d.substring(e[0].length))) {
	        return !1;
	      }
	      null != c && 0 < k && null != e[k] && c.append(e[1]);
	      a.set(d.substring(e[0].length));
	    } else {
	      d = d.replace(g, b);
	      if (h && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_(f, d)) {
	        return !1;
	      }
	      null != c && 0 < k && c.append(e[1]);
	      a.set(d);
	    }
	    return !0;
	  }
	  return !1;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(a) {
	  var b = a.toString(), c = b.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
	  if (0 <= c && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(b.substring(0, c))) {
	    for (var d = b.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), e = d.length, f = 1; f < e; ++f) {
	      if (null != d[f] && 0 < d[f].length) {
	        return a.clear(), a.append(b.substring(0, c)), d[f];
	      }
	    }
	  }
	  return "";
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(a, b) {
	  return this.isValidRegionCode_(b) || null != a && 0 < a.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_.test(a);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(a, b) {
	  return this.parseHelper_(a, b, !1, !0);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(a, b) {
	  if (!this.isValidRegionCode_(b) && 0 < a.length && a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
	    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
	  }
	  return this.parseHelper_(a, b, !0, !0);
	};
	i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(a, b) {
	  if (1 < a.length && "0" == a.charAt(0)) {
	    b.setItalianLeadingZero(!0);
	    for (var c = 1; c < a.length - 1 && "0" == a.charAt(c);) {
	      c++;
	    }
	    1 != c && b.setNumberOfLeadingZeros(c);
	  }
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(a, b, c, d) {
	  if (null == a) {
	    throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
	  }
	  if (a.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) {
	    throw Error(i18n.phonenumbers.Error.TOO_LONG);
	  }
	  var e = new goog.string.StringBuffer;
	  this.buildNationalNumberForParsing_(a, e);
	  if (!i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e.toString())) {
	    throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
	  }
	  if (d && !this.checkRegionForParsing_(e.toString(), b)) {
	    throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
	  }
	  d = new i18n.phonenumbers.PhoneNumber;
	  c && d.setRawInput(a);
	  a = this.maybeStripExtension(e);
	  0 < a.length && d.setExtension(a);
	  var f = this.getMetadataForRegion(b);
	  a = new goog.string.StringBuffer;
	  var g = 0, h = e.toString();
	  try {
	    g = this.maybeExtractCountryCode(h, f, a, c, d);
	  } catch (k) {
	    if (k.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_.test(h)) {
	      if (h = h.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN_, ""), g = this.maybeExtractCountryCode(h, f, a, c, d), 0 == g) {
	        throw k;
	      }
	    } else {
	      throw k;
	    }
	  }
	  0 != g ? (e = this.getRegionCodeForCountryCode(g), e != b && (f = this.getMetadataForRegionOrCallingCode_(g, e))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), a.append(e.toString()), null != b ? (g = f.getCountryCodeOrDefault(), d.setCountryCode(g)) : c && d.clearCountryCodeSource());
	  if (a.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
	    throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
	  }
	  null != f && (b = new goog.string.StringBuffer, e = new goog.string.StringBuffer(a.toString()), this.maybeStripNationalPrefixAndCarrierCode(e, f, b), f = this.testNumberLength_(e.toString(), f), f != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT && f != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY && f != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH && (a = e, c && 0 < b.toString().length && d.setPreferredDomesticCarrierCode(b.toString())));
	  c = a.toString();
	  b = c.length;
	  if (b < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) {
	    throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
	  }
	  if (b > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) {
	    throw Error(i18n.phonenumbers.Error.TOO_LONG);
	  }
	  i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(c, d);
	  d.setNationalNumber(parseInt(c, 10));
	  return d;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(a, b) {
	  var c = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
	  if (0 <= c) {
	    var d = c + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length;
	    if (a.charAt(d) == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
	      var e = a.indexOf(";", d);
	      0 < e ? b.append(a.substring(d, e)) : b.append(a.substring(d));
	    }
	    d = a.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_);
	    b.append(a.substring(0 <= d ? d + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0, c));
	  } else {
	    b.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(a));
	  }
	  c = b.toString();
	  d = c.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_);
	  0 < d && (b.clear(), b.append(c.substring(0, d)));
	};
	i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(a) {
	  var b = new i18n.phonenumbers.PhoneNumber;
	  b.setCountryCode(a.getCountryCodeOrDefault());
	  b.setNationalNumber(a.getNationalNumberOrDefault());
	  0 < a.getExtensionOrDefault().length && b.setExtension(a.getExtensionOrDefault());
	  a.getItalianLeadingZero() && (b.setItalianLeadingZero(!0), b.setNumberOfLeadingZeros(a.getNumberOfLeadingZerosOrDefault()));
	  return b;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(a, b) {
	  if ("string" == typeof a) {
	    try {
	      var c = this.parse(a, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
	    } catch (g) {
	      if (g.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) {
	        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
	      }
	      if ("string" != typeof b) {
	        var d = this.getRegionCodeForCountryCode(b.getCountryCodeOrDefault());
	        if (d != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
	          try {
	            c = this.parse(a, d);
	          } catch (h) {
	            return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
	          }
	          c = this.isNumberMatch(c, b);
	          return c == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : c;
	        }
	      }
	      try {
	        c = this.parseHelper_(a, null, !1, !1);
	      } catch (h) {
	        return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
	      }
	    }
	  } else {
	    c = a.clone();
	  }
	  if ("string" == typeof b) {
	    try {
	      var e = this.parse(b, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
	      return this.isNumberMatch(a, e);
	    } catch (g) {
	      return g.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(b, c);
	    }
	  } else {
	    e = b.clone();
	  }
	  c = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(c);
	  e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(e);
	  if (c.hasExtension() && e.hasExtension() && c.getExtension() != e.getExtension()) {
	    return i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
	  }
	  d = c.getCountryCodeOrDefault();
	  var f = e.getCountryCodeOrDefault();
	  if (0 != d && 0 != f) {
	    return c.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : d == f && this.isNationalNumberSuffixOfTheOther_(c, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
	  }
	  c.setCountryCode(0);
	  e.setCountryCode(0);
	  return c.equals(e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(c, e) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH;
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(a, b) {
	  var c = "" + a.getNationalNumber(), d = "" + b.getNationalNumber();
	  return goog.string.endsWith(c, d) || goog.string.endsWith(d, c);
	};
	i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(a) {
	  var b = this.getMetadataForRegion(this.getRegionCodeForNumber(a));
	  if (null == b) {
	    return !0;
	  }
	  a = this.getNationalSignificantNumber(a);
	  return !this.isNumberMatchingDesc_(a, b.getNoInternationalDialling());
	};
	i18n.phonenumbers.PhoneNumberUtil.matchesEntirely_ = function(a, b) {
	  var c = "string" == typeof a ? b.match("^(?:" + a + ")$") : b.match(a);
	  return c && c[0].length == b.length ? !0 : !1;
	};
	i18n.phonenumbers.AsYouTypeFormatter = function(a) {
	  this.DIGIT_PLACEHOLDER_ = "\u2008";
	  this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_);
	  this.currentOutput_ = "";
	  this.formattingTemplate_ = new goog.string.StringBuffer;
	  this.currentFormattingPattern_ = "";
	  this.accruedInput_ = new goog.string.StringBuffer;
	  this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer;
	  this.ableToFormat_ = !0;
	  this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1;
	  this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance();
	  this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0;
	  this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer;
	  this.shouldAddSpaceAfterNationalPrefix_ = !1;
	  this.extractedNationalPrefix_ = "";
	  this.nationalNumber_ = new goog.string.StringBuffer;
	  this.possibleFormats_ = [];
	  this.defaultCountry_ = a;
	  this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
	};
	i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ";
	i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata;
	i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA");
	i18n.phonenumbers.AsYouTypeFormatter.CHARACTER_CLASS_PATTERN_ = /\[([^\[\]])*\]/g;
	i18n.phonenumbers.AsYouTypeFormatter.STANDALONE_DIGIT_PATTERN_ = /\d(?=[^,}][^,}])/g;
	i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)+$");
	i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/;
	i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3;
	i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(a) {
	  a = this.phoneUtil_.getCountryCodeForRegion(a);
	  a = this.phoneUtil_.getRegionCodeForCountryCode(a);
	  a = this.phoneUtil_.getMetadataForRegion(a);
	  return null != a ? a : i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
	  for (var a = this.possibleFormats_.length, b = 0; b < a; ++b) {
	    var c = this.possibleFormats_[b], d = c.getPatternOrDefault();
	    if (this.currentFormattingPattern_ == d) {
	      return !1;
	    }
	    if (this.createFormattingTemplate_(c)) {
	      return this.currentFormattingPattern_ = d, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(c.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
	    }
	  }
	  return this.ableToFormat_ = !1;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(a) {
	  for (var b = this.isCompleteNumber_ && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), c = b.length, d = 0; d < c; ++d) {
	    var e = b[d];
	    (!this.currentMetadata_.hasNationalPrefix() || this.isCompleteNumber_ || e.getNationalPrefixOptionalWhenFormatting() || this.phoneUtil_.formattingRuleHasFirstGroupOnly(e.getNationalPrefixFormattingRuleOrDefault())) && this.isFormatEligible_(e.getFormatOrDefault()) && this.possibleFormats_.push(e);
	  }
	  this.narrowDownPossibleFormats_(a);
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.isFormatEligible_ = function(a) {
	  return i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(a);
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(a) {
	  for (var b = [], c = a.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, d = this.possibleFormats_.length, e = 0; e < d; ++e) {
	    var f = this.possibleFormats_[e];
	    if (0 == f.leadingDigitsPatternCount()) {
	      b.push(this.possibleFormats_[e]);
	    } else {
	      var g = Math.min(c, f.leadingDigitsPatternCount() - 1);
	      f = f.getLeadingDigitsPattern(g);
	      0 == a.search(f) && b.push(this.possibleFormats_[e]);
	    }
	  }
	  this.possibleFormats_ = b;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(a) {
	  var b = a.getPatternOrDefault();
	  if (-1 != b.indexOf("|")) {
	    return !1;
	  }
	  b = b.replace(i18n.phonenumbers.AsYouTypeFormatter.CHARACTER_CLASS_PATTERN_, "\\d");
	  b = b.replace(i18n.phonenumbers.AsYouTypeFormatter.STANDALONE_DIGIT_PATTERN_, "\\d");
	  this.formattingTemplate_.clear();
	  a = this.getFormattingTemplate_(b, a.getFormatOrDefault());
	  return 0 < a.length ? (this.formattingTemplate_.append(a), !0) : !1;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(a, b) {
	  var c = "999999999999999".match(a)[0];
	  if (c.length < this.nationalNumber_.getLength()) {
	    return "";
	  }
	  c = c.replace(new RegExp(a, "g"), b);
	  return c = c.replace(RegExp("9", "g"), this.DIGIT_PLACEHOLDER_);
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
	  this.currentOutput_ = "";
	  this.accruedInput_.clear();
	  this.accruedInputWithoutFormatting_.clear();
	  this.formattingTemplate_.clear();
	  this.lastMatchPosition_ = 0;
	  this.currentFormattingPattern_ = "";
	  this.prefixBeforeNationalNumber_.clear();
	  this.extractedNationalPrefix_ = "";
	  this.nationalNumber_.clear();
	  this.ableToFormat_ = !0;
	  this.inputHasFormatting_ = !1;
	  this.originalPosition_ = this.positionToRemember_ = 0;
	  this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1;
	  this.possibleFormats_ = [];
	  this.shouldAddSpaceAfterNationalPrefix_ = !1;
	  this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(a) {
	  return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !1);
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(a) {
	  return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(a, !0);
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(a, b) {
	  this.accruedInput_.append(a);
	  b && (this.originalPosition_ = this.accruedInput_.getLength());
	  this.isDigitOrLeadingPlusSign_(a) ? a = this.normalizeAndAccrueDigitsAndPlusSign_(a, b) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0);
	  if (!this.ableToFormat_) {
	    if (!this.inputHasFormatting_) {
	      if (this.attemptToExtractIdd_()) {
	        if (this.attemptToExtractCountryCallingCode_()) {
	          return this.attemptToChoosePatternWithPrefixExtracted_();
	        }
	      } else {
	        if (this.ableToExtractLongerNdd_()) {
	          return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
	        }
	      }
	    }
	    return this.accruedInput_.toString();
	  }
	  switch(this.accruedInputWithoutFormatting_.getLength()) {
	    case 0:
	    case 1:
	    case 2:
	      return this.accruedInput_.toString();
	    case 3:
	      if (this.attemptToExtractIdd_()) {
	        this.isExpectingCountryCallingCode_ = !0;
	      } else {
	        return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
	      }
	    default:
	      if (this.isExpectingCountryCallingCode_) {
	        return this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString();
	      }
	      if (0 < this.possibleFormats_.length) {
	        var c = this.inputDigitHelper_(a), d = this.attemptToFormatAccruedDigits_();
	        if (0 < d.length) {
	          return d;
	        }
	        this.narrowDownPossibleFormats_(this.nationalNumber_.toString());
	        return this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
	      }
	      return this.attemptToChooseFormattingPattern_();
	  }
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
	  this.ableToFormat_ = !0;
	  this.isExpectingCountryCallingCode_ = !1;
	  this.possibleFormats_ = [];
	  this.lastMatchPosition_ = 0;
	  this.formattingTemplate_.clear();
	  this.currentFormattingPattern_ = "";
	  return this.attemptToChooseFormattingPattern_();
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
	  return this.extractedNationalPrefix_;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
	  if (0 < this.extractedNationalPrefix_.length) {
	    var a = this.nationalNumber_.toString();
	    this.nationalNumber_.clear();
	    this.nationalNumber_.append(this.extractedNationalPrefix_);
	    this.nationalNumber_.append(a);
	    a = this.prefixBeforeNationalNumber_.toString();
	    var b = a.lastIndexOf(this.extractedNationalPrefix_);
	    this.prefixBeforeNationalNumber_.clear();
	    this.prefixBeforeNationalNumber_.append(a.substring(0, b));
	  }
	  return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(a) {
	  return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(a) || 1 == this.accruedInput_.getLength() && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(a);
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
	  for (var a = this.nationalNumber_.toString(), b = this.possibleFormats_.length, c = 0; c < b; ++c) {
	    var d = this.possibleFormats_[c], e = d.getPatternOrDefault();
	    if ((new RegExp("^(?:" + e + ")$")).test(a)) {
	      return this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(d.getNationalPrefixFormattingRule()), a = a.replace(new RegExp(e, "g"), d.getFormat()), this.appendNationalNumber_(a);
	    }
	  }
	  return "";
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(a) {
	  var b = this.prefixBeforeNationalNumber_.getLength();
	  return this.shouldAddSpaceAfterNationalPrefix_ && 0 < b && this.prefixBeforeNationalNumber_.toString().charAt(b - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + a : this.prefixBeforeNationalNumber_ + a;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
	  if (!this.ableToFormat_) {
	    return this.originalPosition_;
	  }
	  for (var a = 0, b = 0, c = this.accruedInputWithoutFormatting_.toString(), d = this.currentOutput_.toString(); a < this.positionToRemember_ && b < d.length;) {
	    c.charAt(a) == d.charAt(b) && a++, b++;
	  }
	  return b;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
	  var a = this.nationalNumber_.toString();
	  return a.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(a), a = this.attemptToFormatAccruedDigits_(), 0 < a.length ? a : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(a);
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
	  var a = this.nationalNumber_.toString(), b = a.length;
	  if (0 < b) {
	    for (var c = "", d = 0; d < b; d++) {
	      c = this.inputDigitHelper_(a.charAt(d));
	    }
	    return this.ableToFormat_ ? this.appendNationalNumber_(c) : this.accruedInput_.toString();
	  }
	  return this.prefixBeforeNationalNumber_.toString();
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
	  if (1 != this.currentMetadata_.getCountryCode()) {
	    return !1;
	  }
	  var a = this.nationalNumber_.toString();
	  return "1" == a.charAt(0) && "0" != a.charAt(1) && "1" != a.charAt(1);
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
	  var a = this.nationalNumber_.toString(), b = 0;
	  if (this.isNanpaNumberWithNationalPrefix_()) {
	    b = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
	  } else {
	    if (this.currentMetadata_.hasNationalPrefixForParsing()) {
	      var c = new RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")");
	      c = a.match(c);
	      null != c && null != c[0] && 0 < c[0].length && (this.isCompleteNumber_ = !0, b = c[0].length, this.prefixBeforeNationalNumber_.append(a.substring(0, b)));
	    }
	  }
	  this.nationalNumber_.clear();
	  this.nationalNumber_.append(a.substring(b));
	  return a.substring(0, b);
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
	  var a = this.accruedInputWithoutFormatting_.toString(), b = new RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")");
	  b = a.match(b);
	  return null != b && null != b[0] && 0 < b[0].length ? (this.isCompleteNumber_ = !0, b = b[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(a.substring(b)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(a.substring(0, b)), a.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
	  if (0 == this.nationalNumber_.getLength()) {
	    return !1;
	  }
	  var a = new goog.string.StringBuffer, b = this.phoneUtil_.extractCountryCode(this.nationalNumber_, a);
	  if (0 == b) {
	    return !1;
	  }
	  this.nationalNumber_.clear();
	  this.nationalNumber_.append(a.toString());
	  a = this.phoneUtil_.getRegionCodeForCountryCode(b);
	  i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == a ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(b) : a != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(a));
	  this.prefixBeforeNationalNumber_.append("" + b).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_);
	  this.extractedNationalPrefix_ = "";
	  return !0;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(a, b) {
	  if (a == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
	    var c = a;
	    this.accruedInputWithoutFormatting_.append(a);
	  } else {
	    c = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[a], this.accruedInputWithoutFormatting_.append(c), this.nationalNumber_.append(c);
	  }
	  b && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength());
	  return c;
	};
	i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(a) {
	  var b = this.formattingTemplate_.toString();
	  if (0 <= b.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
	    var c = b.search(this.DIGIT_PATTERN_);
	    a = b.replace(this.DIGIT_PATTERN_, a);
	    this.formattingTemplate_.clear();
	    this.formattingTemplate_.append(a);
	    this.lastMatchPosition_ = c;
	    return a.substring(0, this.lastMatchPosition_ + 1);
	  }
	  1 == this.possibleFormats_.length && (this.ableToFormat_ = !1);
	  this.currentFormattingPattern_ = "";
	  return this.accruedInput_.toString();
	};
	Object.defineProperty(exports, "__esModule", {value:!0});
	exports["default"] = i18n.phonenumbers;
	module.exports = exports["default"];
	
	
	},{}]},{},[1])(1)
	});

/***/ }),
/* 5320 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(1517);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 5322 */,
/* 5323 */,
/* 5324 */,
/* 5325 */,
/* 5326 */,
/* 5327 */,
/* 5328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(964);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(1522);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 5329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(964);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 5330 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 5331 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 5332 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 5333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(964);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(1522);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 5334 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return { position: ['-webkit-sticky', 'sticky'] };
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 5335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(964);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 5336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(5340);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(2292);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(1522);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(2291);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ }),
/* 5337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(2291);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(2292);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _sortPrefixedStyle = __webpack_require__(5339);
	
	var _sortPrefixedStyle2 = _interopRequireDefault(_sortPrefixedStyle);
	
	var _position = __webpack_require__(5334);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _calc = __webpack_require__(5328);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(5329);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(5330);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(5335);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(5333);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(5336);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(5331);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(5332);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_position2.default, _calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return (0, _sortPrefixedStyle2.default)(styles);
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ }),
/* 5338 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  return property.match(/^(Webkit|Moz|O|ms)/) !== null;
	};
	
	module.exports = exports["default"];

/***/ }),
/* 5339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortPrefixedStyle;
	
	var _isPrefixedProperty = __webpack_require__(5338);
	
	var _isPrefixedProperty2 = _interopRequireDefault(_isPrefixedProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortPrefixedStyle(style) {
	  return Object.keys(style).sort(function (left, right) {
	    if ((0, _isPrefixedProperty2.default)(left) && !(0, _isPrefixedProperty2.default)(right)) {
	      return -1;
	    } else if (!(0, _isPrefixedProperty2.default)(left) && (0, _isPrefixedProperty2.default)(right)) {
	      return 1;
	    }
	    return 0;
	  }).reduce(function (sortedStyle, prop) {
	    sortedStyle[prop] = style[prop];
	    return sortedStyle;
	  }, {});
	}
	module.exports = exports['default'];

/***/ }),
/* 5340 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 5341 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5337)


/***/ }),
/* 5342 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2016 Google Inc. All Rights Reserved.
	 *
	 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
	 *
	 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
	 *
	 */
	
	(function(window, document) {
	'use strict';
	
	
	// Exits early if all IntersectionObserver and IntersectionObserverEntry
	// features are natively supported.
	if ('IntersectionObserver' in window &&
	    'IntersectionObserverEntry' in window &&
	    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
	
	  // Minimal polyfill for Edge 15's lack of `isIntersecting`
	  // See: https://github.com/w3c/IntersectionObserver/issues/211
	  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
	    Object.defineProperty(window.IntersectionObserverEntry.prototype,
	      'isIntersecting', {
	      get: function () {
	        return this.intersectionRatio > 0;
	      }
	    });
	  }
	  return;
	}
	
	
	/**
	 * An IntersectionObserver registry. This registry exists to hold a strong
	 * reference to IntersectionObserver instances currently observering a target
	 * element. Without this registry, instances without another reference may be
	 * garbage collected.
	 */
	var registry = [];
	
	
	/**
	 * Creates the global IntersectionObserverEntry constructor.
	 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
	 * @param {Object} entry A dictionary of instance properties.
	 * @constructor
	 */
	function IntersectionObserverEntry(entry) {
	  this.time = entry.time;
	  this.target = entry.target;
	  this.rootBounds = entry.rootBounds;
	  this.boundingClientRect = entry.boundingClientRect;
	  this.intersectionRect = entry.intersectionRect || getEmptyRect();
	  this.isIntersecting = !!entry.intersectionRect;
	
	  // Calculates the intersection ratio.
	  var targetRect = this.boundingClientRect;
	  var targetArea = targetRect.width * targetRect.height;
	  var intersectionRect = this.intersectionRect;
	  var intersectionArea = intersectionRect.width * intersectionRect.height;
	
	  // Sets intersection ratio.
	  if (targetArea) {
	    this.intersectionRatio = intersectionArea / targetArea;
	  } else {
	    // If area is zero and is intersecting, sets to 1, otherwise to 0
	    this.intersectionRatio = this.isIntersecting ? 1 : 0;
	  }
	}
	
	
	/**
	 * Creates the global IntersectionObserver constructor.
	 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
	 * @param {Function} callback The function to be invoked after intersection
	 *     changes have queued. The function is not invoked if the queue has
	 *     been emptied by calling the `takeRecords` method.
	 * @param {Object=} opt_options Optional configuration options.
	 * @constructor
	 */
	function IntersectionObserver(callback, opt_options) {
	
	  var options = opt_options || {};
	
	  if (typeof callback != 'function') {
	    throw new Error('callback must be a function');
	  }
	
	  if (options.root && options.root.nodeType != 1) {
	    throw new Error('root must be an Element');
	  }
	
	  // Binds and throttles `this._checkForIntersections`.
	  this._checkForIntersections = throttle(
	      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
	
	  // Private properties.
	  this._callback = callback;
	  this._observationTargets = [];
	  this._queuedEntries = [];
	  this._rootMarginValues = this._parseRootMargin(options.rootMargin);
	
	  // Public properties.
	  this.thresholds = this._initThresholds(options.threshold);
	  this.root = options.root || null;
	  this.rootMargin = this._rootMarginValues.map(function(margin) {
	    return margin.value + margin.unit;
	  }).join(' ');
	}
	
	
	/**
	 * The minimum interval within which the document will be checked for
	 * intersection changes.
	 */
	IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
	
	
	/**
	 * The frequency in which the polyfill polls for intersection changes.
	 * this can be updated on a per instance basis and must be set prior to
	 * calling `observe` on the first target.
	 */
	IntersectionObserver.prototype.POLL_INTERVAL = null;
	
	/**
	 * Use a mutation observer on the root element
	 * to detect intersection changes.
	 */
	IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
	
	
	/**
	 * Starts observing a target element for intersection changes based on
	 * the thresholds values.
	 * @param {Element} target The DOM element to observe.
	 */
	IntersectionObserver.prototype.observe = function(target) {
	  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
	    return item.element == target;
	  });
	
	  if (isTargetAlreadyObserved) {
	    return;
	  }
	
	  if (!(target && target.nodeType == 1)) {
	    throw new Error('target must be an Element');
	  }
	
	  this._registerInstance();
	  this._observationTargets.push({element: target, entry: null});
	  this._monitorIntersections();
	  this._checkForIntersections();
	};
	
	
	/**
	 * Stops observing a target element for intersection changes.
	 * @param {Element} target The DOM element to observe.
	 */
	IntersectionObserver.prototype.unobserve = function(target) {
	  this._observationTargets =
	      this._observationTargets.filter(function(item) {
	
	    return item.element != target;
	  });
	  if (!this._observationTargets.length) {
	    this._unmonitorIntersections();
	    this._unregisterInstance();
	  }
	};
	
	
	/**
	 * Stops observing all target elements for intersection changes.
	 */
	IntersectionObserver.prototype.disconnect = function() {
	  this._observationTargets = [];
	  this._unmonitorIntersections();
	  this._unregisterInstance();
	};
	
	
	/**
	 * Returns any queue entries that have not yet been reported to the
	 * callback and clears the queue. This can be used in conjunction with the
	 * callback to obtain the absolute most up-to-date intersection information.
	 * @return {Array} The currently queued entries.
	 */
	IntersectionObserver.prototype.takeRecords = function() {
	  var records = this._queuedEntries.slice();
	  this._queuedEntries = [];
	  return records;
	};
	
	
	/**
	 * Accepts the threshold value from the user configuration object and
	 * returns a sorted array of unique threshold values. If a value is not
	 * between 0 and 1 and error is thrown.
	 * @private
	 * @param {Array|number=} opt_threshold An optional threshold value or
	 *     a list of threshold values, defaulting to [0].
	 * @return {Array} A sorted list of unique and valid threshold values.
	 */
	IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
	  var threshold = opt_threshold || [0];
	  if (!Array.isArray(threshold)) threshold = [threshold];
	
	  return threshold.sort().filter(function(t, i, a) {
	    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
	      throw new Error('threshold must be a number between 0 and 1 inclusively');
	    }
	    return t !== a[i - 1];
	  });
	};
	
	
	/**
	 * Accepts the rootMargin value from the user configuration object
	 * and returns an array of the four margin values as an object containing
	 * the value and unit properties. If any of the values are not properly
	 * formatted or use a unit other than px or %, and error is thrown.
	 * @private
	 * @param {string=} opt_rootMargin An optional rootMargin value,
	 *     defaulting to '0px'.
	 * @return {Array<Object>} An array of margin objects with the keys
	 *     value and unit.
	 */
	IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
	  var marginString = opt_rootMargin || '0px';
	  var margins = marginString.split(/\s+/).map(function(margin) {
	    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
	    if (!parts) {
	      throw new Error('rootMargin must be specified in pixels or percent');
	    }
	    return {value: parseFloat(parts[1]), unit: parts[2]};
	  });
	
	  // Handles shorthand.
	  margins[1] = margins[1] || margins[0];
	  margins[2] = margins[2] || margins[0];
	  margins[3] = margins[3] || margins[1];
	
	  return margins;
	};
	
	
	/**
	 * Starts polling for intersection changes if the polling is not already
	 * happening, and if the page's visibilty state is visible.
	 * @private
	 */
	IntersectionObserver.prototype._monitorIntersections = function() {
	  if (!this._monitoringIntersections) {
	    this._monitoringIntersections = true;
	
	    // If a poll interval is set, use polling instead of listening to
	    // resize and scroll events or DOM mutations.
	    if (this.POLL_INTERVAL) {
	      this._monitoringInterval = setInterval(
	          this._checkForIntersections, this.POLL_INTERVAL);
	    }
	    else {
	      addEvent(window, 'resize', this._checkForIntersections, true);
	      addEvent(document, 'scroll', this._checkForIntersections, true);
	
	      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
	        this._domObserver = new MutationObserver(this._checkForIntersections);
	        this._domObserver.observe(document, {
	          attributes: true,
	          childList: true,
	          characterData: true,
	          subtree: true
	        });
	      }
	    }
	  }
	};
	
	
	/**
	 * Stops polling for intersection changes.
	 * @private
	 */
	IntersectionObserver.prototype._unmonitorIntersections = function() {
	  if (this._monitoringIntersections) {
	    this._monitoringIntersections = false;
	
	    clearInterval(this._monitoringInterval);
	    this._monitoringInterval = null;
	
	    removeEvent(window, 'resize', this._checkForIntersections, true);
	    removeEvent(document, 'scroll', this._checkForIntersections, true);
	
	    if (this._domObserver) {
	      this._domObserver.disconnect();
	      this._domObserver = null;
	    }
	  }
	};
	
	
	/**
	 * Scans each observation target for intersection changes and adds them
	 * to the internal entries queue. If new entries are found, it
	 * schedules the callback to be invoked.
	 * @private
	 */
	IntersectionObserver.prototype._checkForIntersections = function() {
	  var rootIsInDom = this._rootIsInDom();
	  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
	
	  this._observationTargets.forEach(function(item) {
	    var target = item.element;
	    var targetRect = getBoundingClientRect(target);
	    var rootContainsTarget = this._rootContainsTarget(target);
	    var oldEntry = item.entry;
	    var intersectionRect = rootIsInDom && rootContainsTarget &&
	        this._computeTargetAndRootIntersection(target, rootRect);
	
	    var newEntry = item.entry = new IntersectionObserverEntry({
	      time: now(),
	      target: target,
	      boundingClientRect: targetRect,
	      rootBounds: rootRect,
	      intersectionRect: intersectionRect
	    });
	
	    if (!oldEntry) {
	      this._queuedEntries.push(newEntry);
	    } else if (rootIsInDom && rootContainsTarget) {
	      // If the new entry intersection ratio has crossed any of the
	      // thresholds, add a new entry.
	      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
	        this._queuedEntries.push(newEntry);
	      }
	    } else {
	      // If the root is not in the DOM or target is not contained within
	      // root but the previous entry for this target had an intersection,
	      // add a new record indicating removal.
	      if (oldEntry && oldEntry.isIntersecting) {
	        this._queuedEntries.push(newEntry);
	      }
	    }
	  }, this);
	
	  if (this._queuedEntries.length) {
	    this._callback(this.takeRecords(), this);
	  }
	};
	
	
	/**
	 * Accepts a target and root rect computes the intersection between then
	 * following the algorithm in the spec.
	 * TODO(philipwalton): at this time clip-path is not considered.
	 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
	 * @param {Element} target The target DOM element
	 * @param {Object} rootRect The bounding rect of the root after being
	 *     expanded by the rootMargin value.
	 * @return {?Object} The final intersection rect object or undefined if no
	 *     intersection is found.
	 * @private
	 */
	IntersectionObserver.prototype._computeTargetAndRootIntersection =
	    function(target, rootRect) {
	
	  // If the element isn't displayed, an intersection can't happen.
	  if (window.getComputedStyle(target).display == 'none') return;
	
	  var targetRect = getBoundingClientRect(target);
	  var intersectionRect = targetRect;
	  var parent = getParentNode(target);
	  var atRoot = false;
	
	  while (!atRoot) {
	    var parentRect = null;
	    var parentComputedStyle = parent.nodeType == 1 ?
	        window.getComputedStyle(parent) : {};
	
	    // If the parent isn't displayed, an intersection can't happen.
	    if (parentComputedStyle.display == 'none') return;
	
	    if (parent == this.root || parent == document) {
	      atRoot = true;
	      parentRect = rootRect;
	    } else {
	      // If the element has a non-visible overflow, and it's not the <body>
	      // or <html> element, update the intersection rect.
	      // Note: <body> and <html> cannot be clipped to a rect that's not also
	      // the document rect, so no need to compute a new intersection.
	      if (parent != document.body &&
	          parent != document.documentElement &&
	          parentComputedStyle.overflow != 'visible') {
	        parentRect = getBoundingClientRect(parent);
	      }
	    }
	
	    // If either of the above conditionals set a new parentRect,
	    // calculate new intersection data.
	    if (parentRect) {
	      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
	
	      if (!intersectionRect) break;
	    }
	    parent = getParentNode(parent);
	  }
	  return intersectionRect;
	};
	
	
	/**
	 * Returns the root rect after being expanded by the rootMargin value.
	 * @return {Object} The expanded root rect.
	 * @private
	 */
	IntersectionObserver.prototype._getRootRect = function() {
	  var rootRect;
	  if (this.root) {
	    rootRect = getBoundingClientRect(this.root);
	  } else {
	    // Use <html>/<body> instead of window since scroll bars affect size.
	    var html = document.documentElement;
	    var body = document.body;
	    rootRect = {
	      top: 0,
	      left: 0,
	      right: html.clientWidth || body.clientWidth,
	      width: html.clientWidth || body.clientWidth,
	      bottom: html.clientHeight || body.clientHeight,
	      height: html.clientHeight || body.clientHeight
	    };
	  }
	  return this._expandRectByRootMargin(rootRect);
	};
	
	
	/**
	 * Accepts a rect and expands it by the rootMargin value.
	 * @param {Object} rect The rect object to expand.
	 * @return {Object} The expanded rect.
	 * @private
	 */
	IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
	  var margins = this._rootMarginValues.map(function(margin, i) {
	    return margin.unit == 'px' ? margin.value :
	        margin.value * (i % 2 ? rect.width : rect.height) / 100;
	  });
	  var newRect = {
	    top: rect.top - margins[0],
	    right: rect.right + margins[1],
	    bottom: rect.bottom + margins[2],
	    left: rect.left - margins[3]
	  };
	  newRect.width = newRect.right - newRect.left;
	  newRect.height = newRect.bottom - newRect.top;
	
	  return newRect;
	};
	
	
	/**
	 * Accepts an old and new entry and returns true if at least one of the
	 * threshold values has been crossed.
	 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
	 *    particular target element or null if no previous entry exists.
	 * @param {IntersectionObserverEntry} newEntry The current entry for a
	 *    particular target element.
	 * @return {boolean} Returns true if a any threshold has been crossed.
	 * @private
	 */
	IntersectionObserver.prototype._hasCrossedThreshold =
	    function(oldEntry, newEntry) {
	
	  // To make comparing easier, an entry that has a ratio of 0
	  // but does not actually intersect is given a value of -1
	  var oldRatio = oldEntry && oldEntry.isIntersecting ?
	      oldEntry.intersectionRatio || 0 : -1;
	  var newRatio = newEntry.isIntersecting ?
	      newEntry.intersectionRatio || 0 : -1;
	
	  // Ignore unchanged ratios
	  if (oldRatio === newRatio) return;
	
	  for (var i = 0; i < this.thresholds.length; i++) {
	    var threshold = this.thresholds[i];
	
	    // Return true if an entry matches a threshold or if the new ratio
	    // and the old ratio are on the opposite sides of a threshold.
	    if (threshold == oldRatio || threshold == newRatio ||
	        threshold < oldRatio !== threshold < newRatio) {
	      return true;
	    }
	  }
	};
	
	
	/**
	 * Returns whether or not the root element is an element and is in the DOM.
	 * @return {boolean} True if the root element is an element and is in the DOM.
	 * @private
	 */
	IntersectionObserver.prototype._rootIsInDom = function() {
	  return !this.root || containsDeep(document, this.root);
	};
	
	
	/**
	 * Returns whether or not the target element is a child of root.
	 * @param {Element} target The target element to check.
	 * @return {boolean} True if the target element is a child of root.
	 * @private
	 */
	IntersectionObserver.prototype._rootContainsTarget = function(target) {
	  return containsDeep(this.root || document, target);
	};
	
	
	/**
	 * Adds the instance to the global IntersectionObserver registry if it isn't
	 * already present.
	 * @private
	 */
	IntersectionObserver.prototype._registerInstance = function() {
	  if (registry.indexOf(this) < 0) {
	    registry.push(this);
	  }
	};
	
	
	/**
	 * Removes the instance from the global IntersectionObserver registry.
	 * @private
	 */
	IntersectionObserver.prototype._unregisterInstance = function() {
	  var index = registry.indexOf(this);
	  if (index != -1) registry.splice(index, 1);
	};
	
	
	/**
	 * Returns the result of the performance.now() method or null in browsers
	 * that don't support the API.
	 * @return {number} The elapsed time since the page was requested.
	 */
	function now() {
	  return window.performance && performance.now && performance.now();
	}
	
	
	/**
	 * Throttles a function and delays its executiong, so it's only called at most
	 * once within a given time period.
	 * @param {Function} fn The function to throttle.
	 * @param {number} timeout The amount of time that must pass before the
	 *     function can be called again.
	 * @return {Function} The throttled function.
	 */
	function throttle(fn, timeout) {
	  var timer = null;
	  return function () {
	    if (!timer) {
	      timer = setTimeout(function() {
	        fn();
	        timer = null;
	      }, timeout);
	    }
	  };
	}
	
	
	/**
	 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
	 * @param {Node} node The DOM node to add the event handler to.
	 * @param {string} event The event name.
	 * @param {Function} fn The event handler to add.
	 * @param {boolean} opt_useCapture Optionally adds the even to the capture
	 *     phase. Note: this only works in modern browsers.
	 */
	function addEvent(node, event, fn, opt_useCapture) {
	  if (typeof node.addEventListener == 'function') {
	    node.addEventListener(event, fn, opt_useCapture || false);
	  }
	  else if (typeof node.attachEvent == 'function') {
	    node.attachEvent('on' + event, fn);
	  }
	}
	
	
	/**
	 * Removes a previously added event handler from a DOM node.
	 * @param {Node} node The DOM node to remove the event handler from.
	 * @param {string} event The event name.
	 * @param {Function} fn The event handler to remove.
	 * @param {boolean} opt_useCapture If the event handler was added with this
	 *     flag set to true, it should be set to true here in order to remove it.
	 */
	function removeEvent(node, event, fn, opt_useCapture) {
	  if (typeof node.removeEventListener == 'function') {
	    node.removeEventListener(event, fn, opt_useCapture || false);
	  }
	  else if (typeof node.detatchEvent == 'function') {
	    node.detatchEvent('on' + event, fn);
	  }
	}
	
	
	/**
	 * Returns the intersection between two rect objects.
	 * @param {Object} rect1 The first rect.
	 * @param {Object} rect2 The second rect.
	 * @return {?Object} The intersection rect or undefined if no intersection
	 *     is found.
	 */
	function computeRectIntersection(rect1, rect2) {
	  var top = Math.max(rect1.top, rect2.top);
	  var bottom = Math.min(rect1.bottom, rect2.bottom);
	  var left = Math.max(rect1.left, rect2.left);
	  var right = Math.min(rect1.right, rect2.right);
	  var width = right - left;
	  var height = bottom - top;
	
	  return (width >= 0 && height >= 0) && {
	    top: top,
	    bottom: bottom,
	    left: left,
	    right: right,
	    width: width,
	    height: height
	  };
	}
	
	
	/**
	 * Shims the native getBoundingClientRect for compatibility with older IE.
	 * @param {Element} el The element whose bounding rect to get.
	 * @return {Object} The (possibly shimmed) rect of the element.
	 */
	function getBoundingClientRect(el) {
	  var rect;
	
	  try {
	    rect = el.getBoundingClientRect();
	  } catch (err) {
	    // Ignore Windows 7 IE11 "Unspecified error"
	    // https://github.com/w3c/IntersectionObserver/pull/205
	  }
	
	  if (!rect) return getEmptyRect();
	
	  // Older IE
	  if (!(rect.width && rect.height)) {
	    rect = {
	      top: rect.top,
	      right: rect.right,
	      bottom: rect.bottom,
	      left: rect.left,
	      width: rect.right - rect.left,
	      height: rect.bottom - rect.top
	    };
	  }
	  return rect;
	}
	
	
	/**
	 * Returns an empty rect object. An empty rect is returned when an element
	 * is not in the DOM.
	 * @return {Object} The empty rect.
	 */
	function getEmptyRect() {
	  return {
	    top: 0,
	    bottom: 0,
	    left: 0,
	    right: 0,
	    width: 0,
	    height: 0
	  };
	}
	
	/**
	 * Checks to see if a parent element contains a child elemnt (including inside
	 * shadow DOM).
	 * @param {Node} parent The parent element.
	 * @param {Node} child The child element.
	 * @return {boolean} True if the parent node contains the child node.
	 */
	function containsDeep(parent, child) {
	  var node = child;
	  while (node) {
	    if (node == parent) return true;
	
	    node = getParentNode(node);
	  }
	  return false;
	}
	
	
	/**
	 * Gets the parent node of an element or its host element if the parent node
	 * is a shadow root.
	 * @param {Node} node The node whose parent to get.
	 * @return {Node|null} The parent node or null if no parent exists.
	 */
	function getParentNode(node) {
	  var parent = node.parentNode;
	
	  if (parent && parent.nodeType == 11 && parent.host) {
	    // If the parent is a shadow root, return the host element.
	    return parent.host;
	  }
	  return parent;
	}
	
	
	// Exposes the constructors globally.
	window.IntersectionObserver = IntersectionObserver;
	window.IntersectionObserverEntry = IntersectionObserverEntry;
	
	}(window, document));


/***/ }),
/* 5343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var types_1 = __webpack_require__(1524);
	var parser_1 = __webpack_require__(1523);
	var PLURAL_HASHTAG_REGEX = /(^|[^\\])#/g;
	/**
	 * Whether to convert `#` in plural rule options
	 * to `{var, number}`
	 * @param el AST Element
	 * @param pluralStack current plural stack
	 */
	function normalizeHashtagInPlural(els) {
	    els.forEach(function (el) {
	        // If we're encountering a plural el
	        if (!types_1.isPluralElement(el) && !types_1.isSelectElement(el)) {
	            return;
	        }
	        // Go down the options and search for # in any literal element
	        Object.keys(el.options).forEach(function (id) {
	            var _a;
	            var opt = el.options[id];
	            // If we got a match, we have to split this
	            // and inject a NumberElement in the middle
	            var matchingLiteralElIndex = -1;
	            var literalEl = undefined;
	            for (var i = 0; i < opt.value.length; i++) {
	                var el_1 = opt.value[i];
	                if (types_1.isLiteralElement(el_1) && PLURAL_HASHTAG_REGEX.test(el_1.value)) {
	                    matchingLiteralElIndex = i;
	                    literalEl = el_1;
	                    break;
	                }
	            }
	            if (literalEl) {
	                var newValue = literalEl.value.replace(PLURAL_HASHTAG_REGEX, "$1{" + el.value + ", number}");
	                var newEls = parser_1.pegParse(newValue);
	                (_a = opt.value).splice.apply(_a, __spreadArrays([matchingLiteralElIndex, 1], newEls));
	            }
	            normalizeHashtagInPlural(opt.value);
	        });
	    });
	}
	exports.normalizeHashtagInPlural = normalizeHashtagInPlural;


/***/ }),
/* 5344 */
/***/ (function(module, exports) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
	 * with some tweaks
	 */
	var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	/**
	 * Parse Date time skeleton into Intl.DateTimeFormatOptions
	 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * @public
	 * @param skeleton skeleton string
	 */
	function parseDateTimeSkeleton(skeleton) {
	    var result = {};
	    skeleton.replace(DATE_TIME_REGEX, function (match) {
	        var len = match.length;
	        switch (match[0]) {
	            // Era
	            case 'G':
	                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
	                break;
	            // Year
	            case 'y':
	                result.year = len === 2 ? '2-digit' : 'numeric';
	                break;
	            case 'Y':
	            case 'u':
	            case 'U':
	            case 'r':
	                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
	            // Quarter
	            case 'q':
	            case 'Q':
	                throw new RangeError('`q/Q` (quarter) patterns are not supported');
	            // Month
	            case 'M':
	            case 'L':
	                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
	                break;
	            // Week
	            case 'w':
	            case 'W':
	                throw new RangeError('`w/W` (week) patterns are not supported');
	            case 'd':
	                result.day = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'D':
	            case 'F':
	            case 'g':
	                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
	            // Weekday
	            case 'E':
	                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
	                break;
	            case 'e':
	                if (len < 4) {
	                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
	                }
	                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                break;
	            case 'c':
	                if (len < 4) {
	                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
	                }
	                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
	                break;
	            // Period
	            case 'a': // AM, PM
	                result.hour12 = true;
	                break;
	            case 'b': // am, pm, noon, midnight
	            case 'B': // flexible day periods
	                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
	            // Hour
	            case 'h':
	                result.hourCycle = 'h12';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'H':
	                result.hourCycle = 'h23';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'K':
	                result.hourCycle = 'h11';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'k':
	                result.hourCycle = 'h24';
	                result.hour = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'j':
	            case 'J':
	            case 'C':
	                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
	            // Minute
	            case 'm':
	                result.minute = ['numeric', '2-digit'][len - 1];
	                break;
	            // Second
	            case 's':
	                result.second = ['numeric', '2-digit'][len - 1];
	                break;
	            case 'S':
	            case 'A':
	                throw new RangeError('`S/A` (second) pattenrs are not supported, use `s` instead');
	            // Zone
	            case 'z': // 1..3, 4: specific non-location format
	                result.timeZoneName = len < 4 ? 'short' : 'long';
	                break;
	            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	            case 'O': // 1, 4: miliseconds in day short, long
	            case 'v': // 1, 4: generic non-location format
	            case 'V': // 1, 2, 3, 4: time zone ID or city
	            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
	                throw new RangeError('`Z/O/v/V/X/x` (timeZone) pattenrs are not supported, use `z` instead');
	        }
	        return '';
	    });
	    return result;
	}
	exports.parseDateTimeSkeleton = parseDateTimeSkeleton;
	function icuUnitToEcma(unit) {
	    return unit.replace(/^(.*?)-/, '');
	}
	var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\+|#+)?)?$/g;
	var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?$/g;
	function parseSignificantPrecision(str) {
	    var result = {};
	    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
	        // @@@ case
	        if (typeof g2 !== 'string') {
	            result.minimumSignificantDigits = g1.length;
	            result.maximumSignificantDigits = g1.length;
	        }
	        // @@@+ case
	        else if (g2 === '+') {
	            result.minimumSignificantDigits = g1.length;
	        }
	        // .### case
	        else if (g1[0] === '#') {
	            result.maximumSignificantDigits = g1.length;
	        }
	        // .@@## or .@@@ case
	        else {
	            result.minimumSignificantDigits = g1.length;
	            result.maximumSignificantDigits =
	                g1.length + (typeof g2 === 'string' ? g2.length : 0);
	        }
	        return '';
	    });
	    return result;
	}
	function parseSign(str) {
	    switch (str) {
	        case 'sign-auto':
	            return {
	                signDisplay: 'auto',
	            };
	        case 'sign-accounting':
	            return {
	                currencySign: 'accounting',
	            };
	        case 'sign-always':
	            return {
	                signDisplay: 'always',
	            };
	        case 'sign-accounting-always':
	            return {
	                signDisplay: 'always',
	                currencySign: 'accounting',
	            };
	        case 'sign-except-zero':
	            return {
	                signDisplay: 'exceptZero',
	            };
	        case 'sign-accounting-except-zero':
	            return {
	                signDisplay: 'exceptZero',
	                currencySign: 'accounting',
	            };
	        case 'sign-never':
	            return {
	                signDisplay: 'never',
	            };
	    }
	}
	function parseNotationOptions(opt) {
	    var result = {};
	    var signOpts = parseSign(opt);
	    if (signOpts) {
	        return signOpts;
	    }
	    return result;
	}
	/**
	 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
	 */
	function convertNumberSkeletonToNumberFormatOptions(tokens) {
	    var result = {};
	    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
	        var token = tokens_1[_i];
	        switch (token.stem) {
	            case 'percent':
	                result.style = 'percent';
	                continue;
	            case 'currency':
	                result.style = 'currency';
	                result.currency = token.options[0];
	                continue;
	            case 'group-off':
	                result.useGrouping = false;
	                continue;
	            case 'precision-integer':
	                result.maximumFractionDigits = 0;
	                continue;
	            case 'measure-unit':
	                result.style = 'unit';
	                result.unit = icuUnitToEcma(token.options[0]);
	                continue;
	            case 'compact-short':
	                result.notation = 'compact';
	                result.compactDisplay = 'short';
	                continue;
	            case 'compact-long':
	                result.notation = 'compact';
	                result.compactDisplay = 'long';
	                continue;
	            case 'scientific':
	                result = __assign(__assign(__assign({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
	                continue;
	            case 'engineering':
	                result = __assign(__assign(__assign({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
	                continue;
	            case 'notation-simple':
	                result.notation = 'standard';
	                continue;
	            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
	            case 'unit-width-narrow':
	                result.currencyDisplay = 'narrowSymbol';
	                result.unitDisplay = 'narrow';
	                continue;
	            case 'unit-width-short':
	                result.currencyDisplay = 'code';
	                result.unitDisplay = 'short';
	                continue;
	            case 'unit-width-full-name':
	                result.currencyDisplay = 'name';
	                result.unitDisplay = 'long';
	                continue;
	            case 'unit-width-iso-code':
	                result.currencyDisplay = 'symbol';
	                continue;
	        }
	        // Precision
	        // https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#fraction-precision
	        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
	            if (token.options.length > 1) {
	                throw new RangeError('Fraction-precision stems only accept a single optional option');
	            }
	            token.stem.replace(FRACTION_PRECISION_REGEX, function (match, g1, g2) {
	                // precision-integer case
	                if (match === '.') {
	                    result.maximumFractionDigits = 0;
	                }
	                // .000+ case
	                else if (g2 === '+') {
	                    result.minimumFractionDigits = g2.length;
	                }
	                // .### case
	                else if (g1[0] === '#') {
	                    result.maximumFractionDigits = g1.length;
	                }
	                // .00## or .000 case
	                else {
	                    result.minimumFractionDigits = g1.length;
	                    result.maximumFractionDigits =
	                        g1.length + (typeof g2 === 'string' ? g2.length : 0);
	                }
	                return '';
	            });
	            if (token.options.length) {
	                result = __assign(__assign({}, result), parseSignificantPrecision(token.options[0]));
	            }
	            continue;
	        }
	        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
	            result = __assign(__assign({}, result), parseSignificantPrecision(token.stem));
	            continue;
	        }
	        var signOpts = parseSign(token.stem);
	        if (signOpts) {
	            result = __assign(__assign({}, result), signOpts);
	        }
	    }
	    return result;
	}
	exports.convertNumberSkeletonToNumberFormatOptions = convertNumberSkeletonToNumberFormatOptions;


/***/ }),
/* 5345 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
	global.IntlPolyfill = __webpack_require__(5346);
	
	// Require all locale data for `Intl`. This module will be
	// ignored when bundling for the browser with Browserify/Webpack.
	__webpack_require__(6494);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = global.IntlPolyfill;
	    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = global.IntlPolyfill;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5346 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	};
	
	var jsx = function () {
	  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
	  return function createRawReactElement(type, props, key, children) {
	    var defaultProps = type && type.defaultProps;
	    var childrenLength = arguments.length - 3;
	
	    if (!props && childrenLength !== 0) {
	      props = {};
	    }
	
	    if (props && defaultProps) {
	      for (var propName in defaultProps) {
	        if (props[propName] === void 0) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    } else if (!props) {
	      props = defaultProps || {};
	    }
	
	    if (childrenLength === 1) {
	      props.children = children;
	    } else if (childrenLength > 1) {
	      var childArray = Array(childrenLength);
	
	      for (var i = 0; i < childrenLength; i++) {
	        childArray[i] = arguments[i + 3];
	      }
	
	      props.children = childArray;
	    }
	
	    return {
	      $$typeof: REACT_ELEMENT_TYPE,
	      type: type,
	      key: key === undefined ? null : '' + key,
	      ref: null,
	      props: props,
	      _owner: null
	    };
	  };
	}();
	
	var asyncToGenerator = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new Promise(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }
	
	        if (info.done) {
	          resolve(value);
	        } else {
	          return Promise.resolve(value).then(function (value) {
	            return step("next", value);
	          }, function (err) {
	            return step("throw", err);
	          });
	        }
	      }
	
	      return step("next");
	    });
	  };
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var defineEnumerableProperties = function (obj, descs) {
	  for (var key in descs) {
	    var desc = descs[key];
	    desc.configurable = desc.enumerable = true;
	    if ("value" in desc) desc.writable = true;
	    Object.defineProperty(obj, key, desc);
	  }
	
	  return obj;
	};
	
	var defaults = function (obj, defaults) {
	  var keys = Object.getOwnPropertyNames(defaults);
	
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var value = Object.getOwnPropertyDescriptor(defaults, key);
	
	    if (value && value.configurable && obj[key] === undefined) {
	      Object.defineProperty(obj, key, value);
	    }
	  }
	
	  return obj;
	};
	
	var defineProperty$1 = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var get = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var _instanceof = function (left, right) {
	  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
	    return right[Symbol.hasInstance](left);
	  } else {
	    return left instanceof right;
	  }
	};
	
	var interopRequireDefault = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    default: obj
	  };
	};
	
	var interopRequireWildcard = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};
	
	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }
	
	    newObj.default = obj;
	    return newObj;
	  }
	};
	
	var newArrowCheck = function (innerThis, boundThis) {
	  if (innerThis !== boundThis) {
	    throw new TypeError("Cannot instantiate an arrow function");
	  }
	};
	
	var objectDestructuringEmpty = function (obj) {
	  if (obj == null) throw new TypeError("Cannot destructure undefined");
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var selfGlobal = typeof global === "undefined" ? self : global;
	
	var set = function set(object, property, value, receiver) {
	  var desc = Object.getOwnPropertyDescriptor(object, property);
	
	  if (desc === undefined) {
	    var parent = Object.getPrototypeOf(object);
	
	    if (parent !== null) {
	      set(parent, property, value, receiver);
	    }
	  } else if ("value" in desc && desc.writable) {
	    desc.value = value;
	  } else {
	    var setter = desc.set;
	
	    if (setter !== undefined) {
	      setter.call(receiver, value);
	    }
	  }
	
	  return value;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var slicedToArrayLoose = function (arr, i) {
	  if (Array.isArray(arr)) {
	    return arr;
	  } else if (Symbol.iterator in Object(arr)) {
	    var _arr = [];
	
	    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
	      _arr.push(_step.value);
	
	      if (i && _arr.length === i) break;
	    }
	
	    return _arr;
	  } else {
	    throw new TypeError("Invalid attempt to destructure non-iterable instance");
	  }
	};
	
	var taggedTemplateLiteral = function (strings, raw) {
	  return Object.freeze(Object.defineProperties(strings, {
	    raw: {
	      value: Object.freeze(raw)
	    }
	  }));
	};
	
	var taggedTemplateLiteralLoose = function (strings, raw) {
	  strings.raw = raw;
	  return strings;
	};
	
	var temporalRef = function (val, name, undef) {
	  if (val === undef) {
	    throw new ReferenceError(name + " is not defined - temporal dead zone");
	  } else {
	    return val;
	  }
	};
	
	var temporalUndefined = {};
	
	var toArray = function (arr) {
	  return Array.isArray(arr) ? arr : Array.from(arr);
	};
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	
	
	var babelHelpers$1 = Object.freeze({
	  jsx: jsx,
	  asyncToGenerator: asyncToGenerator,
	  classCallCheck: classCallCheck,
	  createClass: createClass,
	  defineEnumerableProperties: defineEnumerableProperties,
	  defaults: defaults,
	  defineProperty: defineProperty$1,
	  get: get,
	  inherits: inherits,
	  interopRequireDefault: interopRequireDefault,
	  interopRequireWildcard: interopRequireWildcard,
	  newArrowCheck: newArrowCheck,
	  objectDestructuringEmpty: objectDestructuringEmpty,
	  objectWithoutProperties: objectWithoutProperties,
	  possibleConstructorReturn: possibleConstructorReturn,
	  selfGlobal: selfGlobal,
	  set: set,
	  slicedToArray: slicedToArray,
	  slicedToArrayLoose: slicedToArrayLoose,
	  taggedTemplateLiteral: taggedTemplateLiteral,
	  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
	  temporalRef: temporalRef,
	  temporalUndefined: temporalUndefined,
	  toArray: toArray,
	  toConsumableArray: toConsumableArray,
	  typeof: _typeof,
	  extends: _extends,
	  instanceof: _instanceof
	});
	
	var realDefineProp = function () {
	    var sentinel = function sentinel() {};
	    try {
	        Object.defineProperty(sentinel, 'a', {
	            get: function get() {
	                return 1;
	            }
	        });
	        Object.defineProperty(sentinel, 'prototype', { writable: false });
	        return sentinel.a === 1 && sentinel.prototype instanceof Object;
	    } catch (e) {
	        return false;
	    }
	}();
	
	// Need a workaround for getters in ES3
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	// We use this a lot (and need it for proto-less objects)
	var hop = Object.prototype.hasOwnProperty;
	
	// Naive defineProperty for compatibility
	var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
	};
	
	// Array.prototype.indexOf, as good as we need it to be
	var arrIndexOf = Array.prototype.indexOf || function (search) {
	    /*jshint validthis:true */
	    var t = this;
	    if (!t.length) return -1;
	
	    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	        if (t[i] === search) return i;
	    }
	
	    return -1;
	};
	
	// Create an object with the specified prototype (2nd arg required for Record)
	var objCreate = Object.create || function (proto, props) {
	    var obj = void 0;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (var k in props) {
	        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
	    }
	
	    return obj;
	};
	
	// Snapshot some (hopefully still) native built-ins
	var arrSlice = Array.prototype.slice;
	var arrConcat = Array.prototype.concat;
	var arrPush = Array.prototype.push;
	var arrJoin = Array.prototype.join;
	var arrShift = Array.prototype.shift;
	
	// Naive Function.prototype.bind for compatibility
	var fnBind = Function.prototype.bind || function (thisObj) {
	    var fn = this,
	        args = arrSlice.call(arguments, 1);
	
	    // All our (presently) bound functions have either 1 or 0 arguments. By returning
	    // different function signatures, we can pass some tests in ES3 environments
	    if (fn.length === 1) {
	        return function () {
	            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	        };
	    }
	    return function () {
	        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	    };
	};
	
	// Object housing internal properties for constructors
	var internals = objCreate(null);
	
	// Keep internal properties internal
	var secret = Math.random();
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor(n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	function Record(obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	Record.prototype = objCreate(null);
	
	/**
	 * An ordered list
	 */
	function List() {
	    defineProperty(this, 'length', { writable: true, value: 0 });
	
	    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
	}
	List.prototype = objCreate(null);
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore() {
	    if (internals.disableRegExpRestore) {
	        return function () {/* no-op */};
	    }
	
	    var regExpCache = {
	        lastMatch: RegExp.lastMatch || '',
	        leftContext: RegExp.leftContext,
	        multiline: RegExp.multiline,
	        input: RegExp.input
	    },
	        has = false;
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++) {
	        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
	    }return function () {
	        // Now we've snapshotted some properties, escape the lastMatch string
	        var esc = /[.?*+^$[\]\\(){}|-]/g,
	            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
	            reg = new List();
	
	        // If any of the captured strings were non-empty, iterate over them all
	        if (has) {
	            for (var _i = 1; _i <= 9; _i++) {
	                var m = regExpCache['$' + _i];
	
	                // If it's empty, add an empty capturing group
	                if (!m) lm = '()' + lm;
	
	                // Else find the string in lm and escape & wrap it to capture it
	                else {
	                        m = m.replace(esc, '\\$&');
	                        lm = lm.replace(m, '(' + m + ')');
	                    }
	
	                // Push it to the reg and chop lm to make sure further groups come after
	                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	                lm = lm.slice(lm.indexOf('(') + 1);
	            }
	        }
	
	        var exprStr = arrJoin.call(reg, '') + lm;
	
	        // Shorten the regex by replacing each part of the expression with a match
	        // for a string of that exact length.  This is safe for the type of
	        // expressions generated above, because the expression matches the whole
	        // match string, so we know each group and each segment between capturing
	        // groups can be matched by its length alone.
	        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
	            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
	        });
	
	        // Create the regular expression that will reconstruct the RegExp properties
	        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');
	
	        // Set the lastIndex of the generated expression to ensure that the match
	        // is found in the correct index.
	        expr.lastIndex = regExpCache.leftContext.length;
	
	        expr.exec(regExpCache.input);
	    };
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject(arg) {
	    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');
	
	    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
	    return Object(arg);
	}
	
	function toNumber(arg) {
	    if (typeof arg === 'number') return arg;
	    return Number(arg);
	}
	
	function toInteger(arg) {
	    var number = toNumber(arg);
	    if (isNaN(number)) return 0;
	    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
	    if (number < 0) return Math.floor(Math.abs(number)) * -1;
	    return Math.floor(Math.abs(number));
	}
	
	function toLength(arg) {
	    var len = toInteger(arg);
	    if (len <= 0) return 0;
	    if (len === Infinity) return Math.pow(2, 53) - 1;
	    return Math.min(len, Math.pow(2, 53) - 1);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties(obj) {
	    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);
	
	    return objCreate(null);
	}
	
	/**
	* Defines regular expressions for various operations related to the BCP 47 syntax,
	* as defined at http://tools.ietf.org/html/bcp47#section-2.1
	*/
	
	// extlang       = 3ALPHA              ; selected ISO 639 codes
	//                 *2("-" 3ALPHA)      ; permanently reserved
	var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';
	
	// language      = 2*3ALPHA            ; shortest ISO 639 code
	//                 ["-" extlang]       ; sometimes followed by
	//                                     ; extended language subtags
	//               / 4ALPHA              ; or reserved for future use
	//               / 5*8ALPHA            ; or registered language subtag
	var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';
	
	// script        = 4ALPHA              ; ISO 15924 code
	var script = '[a-z]{4}';
	
	// region        = 2ALPHA              ; ISO 3166-1 code
	//               / 3DIGIT              ; UN M.49 code
	var region = '(?:[a-z]{2}|\\d{3})';
	
	// variant       = 5*8alphanum         ; registered variants
	//               / (DIGIT 3alphanum)
	var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';
	
	//                                     ; Single alphanumerics
	//                                     ; "x" reserved for private use
	// singleton     = DIGIT               ; 0 - 9
	//               / %x41-57             ; A - W
	//               / %x59-5A             ; Y - Z
	//               / %x61-77             ; a - w
	//               / %x79-7A             ; y - z
	var singleton = '[0-9a-wy-z]';
	
	// extension     = singleton 1*("-" (2*8alphanum))
	var extension = singleton + '(?:-[a-z0-9]{2,8})+';
	
	// privateuse    = "x" 1*("-" (1*8alphanum))
	var privateuse = 'x(?:-[a-z0-9]{1,8})+';
	
	// irregular     = "en-GB-oed"         ; irregular tags do not match
	//               / "i-ami"             ; the 'langtag' production and
	//               / "i-bnn"             ; would not otherwise be
	//               / "i-default"         ; considered 'well-formed'
	//               / "i-enochian"        ; These tags are all valid,
	//               / "i-hak"             ; but most are deprecated
	//               / "i-klingon"         ; in favor of more modern
	//               / "i-lux"             ; subtags or subtag
	//               / "i-mingo"           ; combination
	//               / "i-navajo"
	//               / "i-pwn"
	//               / "i-tao"
	//               / "i-tay"
	//               / "i-tsu"
	//               / "sgn-BE-FR"
	//               / "sgn-BE-NL"
	//               / "sgn-CH-DE"
	var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';
	
	// regular       = "art-lojban"        ; these tags match the 'langtag'
	//               / "cel-gaulish"       ; production, but their subtags
	//               / "no-bok"            ; are not extended language
	//               / "no-nyn"            ; or variant subtags: their meaning
	//               / "zh-guoyu"          ; is defined by their registration
	//               / "zh-hakka"          ; and all of these are deprecated
	//               / "zh-min"            ; in favor of a more modern
	//               / "zh-min-nan"        ; subtag or sequence of subtags
	//               / "zh-xiang"
	var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';
	
	// grandfathered = irregular           ; non-redundant tags registered
	//               / regular             ; during the RFC 3066 era
	var grandfathered = '(?:' + irregular + '|' + regular + ')';
	
	// langtag       = language
	//                 ["-" script]
	//                 ["-" region]
	//                 *("-" variant)
	//                 *("-" extension)
	//                 ["-" privateuse]
	var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	// Language-Tag  = langtag             ; normal language tags
	//               / privateuse          ; private use tag
	//               / grandfathered       ; grandfathered tags
	var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');
	
	// Match duplicate variants in a language tag
	var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	// Match duplicate singletons in a language tag (except in private use)
	var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	// Match all extension sequences
	var expExtSequences = RegExp('-' + extension, 'ig');
	
	// Default locale is the first-added locale data for us
	var defaultLocale = void 0;
	function setDefaultLocale(locale) {
	    defaultLocale = locale;
	}
	
	// IANA Subtag Registry redundant tag and subtag maps
	var redundantTags = {
	    tags: {
	        "art-lojban": "jbo",
	        "i-ami": "ami",
	        "i-bnn": "bnn",
	        "i-hak": "hak",
	        "i-klingon": "tlh",
	        "i-lux": "lb",
	        "i-navajo": "nv",
	        "i-pwn": "pwn",
	        "i-tao": "tao",
	        "i-tay": "tay",
	        "i-tsu": "tsu",
	        "no-bok": "nb",
	        "no-nyn": "nn",
	        "sgn-BE-FR": "sfb",
	        "sgn-BE-NL": "vgt",
	        "sgn-CH-DE": "sgg",
	        "zh-guoyu": "cmn",
	        "zh-hakka": "hak",
	        "zh-min-nan": "nan",
	        "zh-xiang": "hsn",
	        "sgn-BR": "bzs",
	        "sgn-CO": "csn",
	        "sgn-DE": "gsg",
	        "sgn-DK": "dsl",
	        "sgn-ES": "ssp",
	        "sgn-FR": "fsl",
	        "sgn-GB": "bfi",
	        "sgn-GR": "gss",
	        "sgn-IE": "isg",
	        "sgn-IT": "ise",
	        "sgn-JP": "jsl",
	        "sgn-MX": "mfs",
	        "sgn-NI": "ncs",
	        "sgn-NL": "dse",
	        "sgn-NO": "nsl",
	        "sgn-PT": "psr",
	        "sgn-SE": "swl",
	        "sgn-US": "ase",
	        "sgn-ZA": "sfs",
	        "zh-cmn": "cmn",
	        "zh-cmn-Hans": "cmn-Hans",
	        "zh-cmn-Hant": "cmn-Hant",
	        "zh-gan": "gan",
	        "zh-wuu": "wuu",
	        "zh-yue": "yue"
	    },
	    subtags: {
	        BU: "MM",
	        DD: "DE",
	        FX: "FR",
	        TP: "TL",
	        YD: "YE",
	        ZR: "CD",
	        heploc: "alalc97",
	        'in': "id",
	        iw: "he",
	        ji: "yi",
	        jw: "jv",
	        mo: "ro",
	        ayx: "nun",
	        bjd: "drl",
	        ccq: "rki",
	        cjr: "mom",
	        cka: "cmr",
	        cmk: "xch",
	        drh: "khk",
	        drw: "prs",
	        gav: "dev",
	        hrr: "jal",
	        ibi: "opa",
	        kgh: "kml",
	        lcq: "ppr",
	        mst: "mry",
	        myt: "mry",
	        sca: "hle",
	        tie: "ras",
	        tkk: "twm",
	        tlw: "weo",
	        tnf: "prs",
	        ybd: "rki",
	        yma: "lrr"
	    },
	    extLang: {
	        aao: ["aao", "ar"],
	        abh: ["abh", "ar"],
	        abv: ["abv", "ar"],
	        acm: ["acm", "ar"],
	        acq: ["acq", "ar"],
	        acw: ["acw", "ar"],
	        acx: ["acx", "ar"],
	        acy: ["acy", "ar"],
	        adf: ["adf", "ar"],
	        ads: ["ads", "sgn"],
	        aeb: ["aeb", "ar"],
	        aec: ["aec", "ar"],
	        aed: ["aed", "sgn"],
	        aen: ["aen", "sgn"],
	        afb: ["afb", "ar"],
	        afg: ["afg", "sgn"],
	        ajp: ["ajp", "ar"],
	        apc: ["apc", "ar"],
	        apd: ["apd", "ar"],
	        arb: ["arb", "ar"],
	        arq: ["arq", "ar"],
	        ars: ["ars", "ar"],
	        ary: ["ary", "ar"],
	        arz: ["arz", "ar"],
	        ase: ["ase", "sgn"],
	        asf: ["asf", "sgn"],
	        asp: ["asp", "sgn"],
	        asq: ["asq", "sgn"],
	        asw: ["asw", "sgn"],
	        auz: ["auz", "ar"],
	        avl: ["avl", "ar"],
	        ayh: ["ayh", "ar"],
	        ayl: ["ayl", "ar"],
	        ayn: ["ayn", "ar"],
	        ayp: ["ayp", "ar"],
	        bbz: ["bbz", "ar"],
	        bfi: ["bfi", "sgn"],
	        bfk: ["bfk", "sgn"],
	        bjn: ["bjn", "ms"],
	        bog: ["bog", "sgn"],
	        bqn: ["bqn", "sgn"],
	        bqy: ["bqy", "sgn"],
	        btj: ["btj", "ms"],
	        bve: ["bve", "ms"],
	        bvl: ["bvl", "sgn"],
	        bvu: ["bvu", "ms"],
	        bzs: ["bzs", "sgn"],
	        cdo: ["cdo", "zh"],
	        cds: ["cds", "sgn"],
	        cjy: ["cjy", "zh"],
	        cmn: ["cmn", "zh"],
	        coa: ["coa", "ms"],
	        cpx: ["cpx", "zh"],
	        csc: ["csc", "sgn"],
	        csd: ["csd", "sgn"],
	        cse: ["cse", "sgn"],
	        csf: ["csf", "sgn"],
	        csg: ["csg", "sgn"],
	        csl: ["csl", "sgn"],
	        csn: ["csn", "sgn"],
	        csq: ["csq", "sgn"],
	        csr: ["csr", "sgn"],
	        czh: ["czh", "zh"],
	        czo: ["czo", "zh"],
	        doq: ["doq", "sgn"],
	        dse: ["dse", "sgn"],
	        dsl: ["dsl", "sgn"],
	        dup: ["dup", "ms"],
	        ecs: ["ecs", "sgn"],
	        esl: ["esl", "sgn"],
	        esn: ["esn", "sgn"],
	        eso: ["eso", "sgn"],
	        eth: ["eth", "sgn"],
	        fcs: ["fcs", "sgn"],
	        fse: ["fse", "sgn"],
	        fsl: ["fsl", "sgn"],
	        fss: ["fss", "sgn"],
	        gan: ["gan", "zh"],
	        gds: ["gds", "sgn"],
	        gom: ["gom", "kok"],
	        gse: ["gse", "sgn"],
	        gsg: ["gsg", "sgn"],
	        gsm: ["gsm", "sgn"],
	        gss: ["gss", "sgn"],
	        gus: ["gus", "sgn"],
	        hab: ["hab", "sgn"],
	        haf: ["haf", "sgn"],
	        hak: ["hak", "zh"],
	        hds: ["hds", "sgn"],
	        hji: ["hji", "ms"],
	        hks: ["hks", "sgn"],
	        hos: ["hos", "sgn"],
	        hps: ["hps", "sgn"],
	        hsh: ["hsh", "sgn"],
	        hsl: ["hsl", "sgn"],
	        hsn: ["hsn", "zh"],
	        icl: ["icl", "sgn"],
	        ils: ["ils", "sgn"],
	        inl: ["inl", "sgn"],
	        ins: ["ins", "sgn"],
	        ise: ["ise", "sgn"],
	        isg: ["isg", "sgn"],
	        isr: ["isr", "sgn"],
	        jak: ["jak", "ms"],
	        jax: ["jax", "ms"],
	        jcs: ["jcs", "sgn"],
	        jhs: ["jhs", "sgn"],
	        jls: ["jls", "sgn"],
	        jos: ["jos", "sgn"],
	        jsl: ["jsl", "sgn"],
	        jus: ["jus", "sgn"],
	        kgi: ["kgi", "sgn"],
	        knn: ["knn", "kok"],
	        kvb: ["kvb", "ms"],
	        kvk: ["kvk", "sgn"],
	        kvr: ["kvr", "ms"],
	        kxd: ["kxd", "ms"],
	        lbs: ["lbs", "sgn"],
	        lce: ["lce", "ms"],
	        lcf: ["lcf", "ms"],
	        liw: ["liw", "ms"],
	        lls: ["lls", "sgn"],
	        lsg: ["lsg", "sgn"],
	        lsl: ["lsl", "sgn"],
	        lso: ["lso", "sgn"],
	        lsp: ["lsp", "sgn"],
	        lst: ["lst", "sgn"],
	        lsy: ["lsy", "sgn"],
	        ltg: ["ltg", "lv"],
	        lvs: ["lvs", "lv"],
	        lzh: ["lzh", "zh"],
	        max: ["max", "ms"],
	        mdl: ["mdl", "sgn"],
	        meo: ["meo", "ms"],
	        mfa: ["mfa", "ms"],
	        mfb: ["mfb", "ms"],
	        mfs: ["mfs", "sgn"],
	        min: ["min", "ms"],
	        mnp: ["mnp", "zh"],
	        mqg: ["mqg", "ms"],
	        mre: ["mre", "sgn"],
	        msd: ["msd", "sgn"],
	        msi: ["msi", "ms"],
	        msr: ["msr", "sgn"],
	        mui: ["mui", "ms"],
	        mzc: ["mzc", "sgn"],
	        mzg: ["mzg", "sgn"],
	        mzy: ["mzy", "sgn"],
	        nan: ["nan", "zh"],
	        nbs: ["nbs", "sgn"],
	        ncs: ["ncs", "sgn"],
	        nsi: ["nsi", "sgn"],
	        nsl: ["nsl", "sgn"],
	        nsp: ["nsp", "sgn"],
	        nsr: ["nsr", "sgn"],
	        nzs: ["nzs", "sgn"],
	        okl: ["okl", "sgn"],
	        orn: ["orn", "ms"],
	        ors: ["ors", "ms"],
	        pel: ["pel", "ms"],
	        pga: ["pga", "ar"],
	        pks: ["pks", "sgn"],
	        prl: ["prl", "sgn"],
	        prz: ["prz", "sgn"],
	        psc: ["psc", "sgn"],
	        psd: ["psd", "sgn"],
	        pse: ["pse", "ms"],
	        psg: ["psg", "sgn"],
	        psl: ["psl", "sgn"],
	        pso: ["pso", "sgn"],
	        psp: ["psp", "sgn"],
	        psr: ["psr", "sgn"],
	        pys: ["pys", "sgn"],
	        rms: ["rms", "sgn"],
	        rsi: ["rsi", "sgn"],
	        rsl: ["rsl", "sgn"],
	        sdl: ["sdl", "sgn"],
	        sfb: ["sfb", "sgn"],
	        sfs: ["sfs", "sgn"],
	        sgg: ["sgg", "sgn"],
	        sgx: ["sgx", "sgn"],
	        shu: ["shu", "ar"],
	        slf: ["slf", "sgn"],
	        sls: ["sls", "sgn"],
	        sqk: ["sqk", "sgn"],
	        sqs: ["sqs", "sgn"],
	        ssh: ["ssh", "ar"],
	        ssp: ["ssp", "sgn"],
	        ssr: ["ssr", "sgn"],
	        svk: ["svk", "sgn"],
	        swc: ["swc", "sw"],
	        swh: ["swh", "sw"],
	        swl: ["swl", "sgn"],
	        syy: ["syy", "sgn"],
	        tmw: ["tmw", "ms"],
	        tse: ["tse", "sgn"],
	        tsm: ["tsm", "sgn"],
	        tsq: ["tsq", "sgn"],
	        tss: ["tss", "sgn"],
	        tsy: ["tsy", "sgn"],
	        tza: ["tza", "sgn"],
	        ugn: ["ugn", "sgn"],
	        ugy: ["ugy", "sgn"],
	        ukl: ["ukl", "sgn"],
	        uks: ["uks", "sgn"],
	        urk: ["urk", "ms"],
	        uzn: ["uzn", "uz"],
	        uzs: ["uzs", "uz"],
	        vgt: ["vgt", "sgn"],
	        vkk: ["vkk", "ms"],
	        vkt: ["vkt", "ms"],
	        vsi: ["vsi", "sgn"],
	        vsl: ["vsl", "sgn"],
	        vsv: ["vsv", "sgn"],
	        wuu: ["wuu", "zh"],
	        xki: ["xki", "sgn"],
	        xml: ["xml", "sgn"],
	        xmm: ["xmm", "ms"],
	        xms: ["xms", "sgn"],
	        yds: ["yds", "sgn"],
	        ysl: ["ysl", "sgn"],
	        yue: ["yue", "zh"],
	        zib: ["zib", "sgn"],
	        zlm: ["zlm", "ms"],
	        zmi: ["zmi", "ms"],
	        zsl: ["zsl", "sgn"],
	        zsm: ["zsm", "ms"]
	    }
	};
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase(str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
	    }
	
	    return str;
	}
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!expBCP47Syntax.test(locale)) return false;
	
	    // does not include duplicate variant subtags, and
	    if (expVariantDupes.test(locale)) return false;
	
	    // does not include duplicate singleton subtags.
	    if (expSingletonDupes.test(locale)) return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
	    var match = void 0,
	        parts = void 0;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	            // Is it a singleton?
	            else if (parts[i].length === 1 && parts[i] !== 'x') break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
	        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
	            parts[_i] = redundantTags.extLang[parts[_i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, _i++);
	                _max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale() {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	var expCurrencyCode = /^[A-Z]{3}$/;
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    // 1. Let `c` be ToString(currency)
	    var c = String(currency);
	
	    // 2. Let `normalized` be the result of mapping c to upper case as described
	    //    in 6.1.
	    var normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false) return false;
	
	    // 5. Return true
	    return true;
	}
	
	var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below
	
	function /* 9.2.1 */CanonicalizeLocaleList(locales) {
	    // The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined) return new List();
	
	    // 2. Let seen be a new empty List.
	    var seen = new List();
	
	    // 3. If locales is a String value, then
	    //    a. Let locales be a new array created as if by the expression new
	    //    Array(locales) where Array is the standard built-in constructor with
	    //    that name and locales is the value of locales.
	    locales = typeof locales === 'string' ? [locales] : locales;
	
	    // 4. Let O be ToObject(locales).
	    var O = toObject(locales);
	
	    // 5. Let lenValue be the result of calling the [[Get]] internal method of
	    //    O with the argument "length".
	    // 6. Let len be ToUint32(lenValue).
	    var len = toLength(O.length);
	
	    // 7. Let k be 0.
	    var k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        // a. Let Pk be ToString(k).
	        var Pk = String(k);
	
	        // b. Let kPresent be the result of calling the [[HasProperty]] internal
	        //    method of O with argument Pk.
	        var kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            // i. Let kValue be the result of calling the [[Get]] internal
	            //     method of O with argument Pk.
	            var kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');
	
	            // iii. Let tag be ToString(kValue).
	            var tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
	    // 1. Let candidate be locale
	    var candidate = locale;
	
	    // 2. Repeat
	    while (candidate) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;
	
	        // b. Let pos be the character index of the last occurrence of "-"
	        // (U+002D) within candidate. If that character does not occur, return
	        // undefined.
	        var pos = candidate.lastIndexOf('-');
	
	        if (pos < 0) return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
	    // 1. Let i be 0.
	    var i = 0;
	
	    // 2. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	
	    // 3. Let availableLocale be undefined.
	    var availableLocale = void 0;
	
	    var locale = void 0,
	        noExtensionsLocale = void 0;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position i.
	        locale = requestedLocales[i];
	
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    // 5. Let result be a new Record.
	    var result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            // i. Let extension be the String value consisting of the first
	            //    substring of locale that is a Unicode locale extension sequence.
	            var extension = locale.match(expUnicodeExSeq)[0];
	
	            // ii. Let extensionIndex be the character position of the initial
	            //     "-" of the first Unicode locale extension sequence within locale.
	            var extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    // 1. Let matcher be the value of options.[[localeMatcher]].
	    var matcher = options['[[localeMatcher]]'];
	
	    var r = void 0;
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        // a. Let r be the result of calling the LookupMatcher abstract operation
	        //    (defined in 9.2.3) with arguments availableLocales and
	        //    requestedLocales.
	        r = LookupMatcher(availableLocales, requestedLocales);
	
	        // 3. Else
	    else
	        // a. Let r be the result of calling the BestFitMatcher abstract
	        //    operation (defined in 9.2.4) with arguments availableLocales and
	        //    requestedLocales.
	        r = BestFitMatcher(availableLocales, requestedLocales);
	
	    // 4. Let foundLocale be the value of r.[[locale]].
	    var foundLocale = r['[[locale]]'];
	
	    var extensionSubtags = void 0,
	        extensionSubtagsLength = void 0;
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]')) {
	        // a. Let extension be the value of r.[[extension]].
	        var extension = r['[[extension]]'];
	        // b. Let split be the standard built-in function object defined in ES5,
	        //    15.5.4.14.
	        var split = String.prototype.split;
	        // c. Let extensionSubtags be the result of calling the [[Call]] internal
	        //    method of split with extension as the this value and an argument
	        //    list containing the single item "-".
	        extensionSubtags = split.call(extension, '-');
	        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
	        //    internal method of extensionSubtags with argument "length".
	        extensionSubtagsLength = extensionSubtags.length;
	    }
	
	    // 6. Let result be a new Record.
	    var result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    // 8. Let supportedExtension be "-u".
	    var supportedExtension = '-u';
	    // 9. Let i be 0.
	    var i = 0;
	    // 10. Let len be the result of calling the [[Get]] internal method of
	    //     relevantExtensionKeys with argument "length".
	    var len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        // a. Let key be the result of calling the [[Get]] internal method of
	        //    relevantExtensionKeys with argument ToString(i).
	        var key = relevantExtensionKeys[i];
	        // b. Let foundLocaleData be the result of calling the [[Get]] internal
	        //    method of localeData with the argument foundLocale.
	        var foundLocaleData = localeData[foundLocale];
	        // c. Let keyLocaleData be the result of calling the [[Get]] internal
	        //    method of foundLocaleData with the argument key.
	        var keyLocaleData = foundLocaleData[key];
	        // d. Let value be the result of calling the [[Get]] internal method of
	        //    keyLocaleData with argument "0".
	        var value = keyLocaleData['0'];
	        // e. Let supportedExtensionAddition be "".
	        var supportedExtensionAddition = '';
	        // f. Let indexOf be the standard built-in function object defined in
	        //    ES5, 15.4.4.14.
	        var indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            // i. Let keyPos be the result of calling the [[Call]] internal
	            //    method of indexOf with extensionSubtags as the this value and
	            // an argument list containing the single item key.
	            var keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
	                    // a. Let requestedValue be the result of calling the [[Get]]
	                    //    internal method of extensionSubtags with argument
	                    //    ToString(keyPos + 1).
	                    var requestedValue = extensionSubtags[keyPos + 1];
	                    // b. Let valuePos be the result of calling the [[Call]]
	                    //    internal method of indexOf with keyLocaleData as the
	                    //    this value and an argument list containing the single
	                    //    item requestedValue.
	                    var valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1) {
	                        // i. Let value be requestedValue.
	                        value = requestedValue,
	                        // ii. Let supportedExtensionAddition be the
	                        //     concatenation of "-", key, "-", and value.
	                        supportedExtensionAddition = '-' + key + '-' + value;
	                    }
	                }
	                // 2. Else
	                else {
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        var _valuePos = indexOf(keyLocaleData, 'true');
	
	                        // b. If valuePos ≠ -1, then
	                        if (_valuePos !== -1)
	                            // i. Let value be "true".
	                            value = 'true';
	                    }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            // i. Let optionsValue be the value of options.[[<key>]].
	            var optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        // a.
	        var privateIndex = foundLocale.indexOf("-x-");
	        // b.
	        if (privateIndex === -1) {
	            // i.
	            foundLocale = foundLocale + supportedExtension;
	        }
	        // c.
	        else {
	                // i.
	                var preExtension = foundLocale.substring(0, privateIndex);
	                // ii.
	                var postExtension = foundLocale.substring(privateIndex);
	                // iii.
	                foundLocale = preExtension + supportedExtension + postExtension;
	            }
	        // d. asserting - skipping
	        // e.
	        foundLocale = CanonicalizeLanguageTag(foundLocale);
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
	    // 1. Let len be the number of elements in requestedLocales.
	    var len = requestedLocales.length;
	    // 2. Let subset be a new empty List.
	    var subset = new List();
	    // 3. Let k be 0.
	    var k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        // a. Let locale be the element of requestedLocales at 0-origined list
	        //    position k.
	        var locale = requestedLocales[k];
	        // b. Let noExtensionsLocale be the String value that is locale with all
	        //    Unicode locale extension sequences removed.
	        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
	        // c. Let availableLocale be the result of calling the
	        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	        //    arguments availableLocales and noExtensionsLocale.
	        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined) arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    // 5. Let subsetArray be a new Array object whose elements are the same
	    //    values in the same order as the elements of subset.
	    var subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
	    var matcher = void 0,
	        subset = void 0;
	
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        // a. Let options be ToObject(options).
	        options = new Record(toObject(options));
	        // b. Let matcher be the result of calling the [[Get]] internal method of
	        //    options with argument "localeMatcher".
	        matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        // a. Let subset be the result of calling the BestFitSupportedLocales
	        //    abstract operation (defined in 9.2.7) with arguments
	        //    availableLocales and requestedLocales.
	        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	        // 3. Else
	    else
	        // a. Let subset be the result of calling the LookupSupportedLocales
	        //    abstract operation (defined in 9.2.6) with arguments
	        //    availableLocales and requestedLocales.
	        subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P)) continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption(options, property, type, values, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
	    // 1. Let value be the result of calling the [[Get]] internal method of
	    //    options with argument property.
	    var value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 8 The Intl Object
	var Intl = {};
	
	// 8.2 Function Properties of the Intl Object
	
	// 8.2.1
	// @spec[tc39/ecma402/master/spec/intl.html]
	// @clause[sec-intl.getcanonicallocales]
	function getCanonicalLocales(locales) {
	    // 1. Let ll be ? CanonicalizeLocaleList(locales).
	    var ll = CanonicalizeLocaleList(locales);
	    // 2. Return CreateArrayFromList(ll).
	    {
	        var result = [];
	
	        var len = ll.length;
	        var k = 0;
	
	        while (k < len) {
	            result[k] = ll[k];
	            k++;
	        }
	        return result;
	    }
	}
	
	Object.defineProperty(Intl, 'getCanonicalLocales', {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: getCanonicalLocales
	});
	
	// Currency minor units output from get-4217 grunt task, formatted
	var currencyMinorUnits = {
	    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
	    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	};
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(numberFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	        // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    // 6. Let opt be a new Record.
	    var opt = new Record(),
	
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	    var localeData = internals.NumberFormat['[[localeData]]'];
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	    var c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');
	
	    var cDigits = void 0;
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	        cDigits = CurrencyDigits(c);
	    }
	
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;
	
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	    var mnfdDefault = s === 'currency' ? cDigits : 0;
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	    var mnsd = options.minimumSignificantDigits;
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	    var mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	    var patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	    var stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */
	defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 11.3_b
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this NumberFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 1, that takes the argument value and
	        //    performs the following steps:
	        var F = function F(value) {
	            // i. If value is not provided, then let value be undefined.
	            // ii. Let x be ToNumber(value).
	            // iii. Return the result of calling the FormatNumber abstract
	            //      operation (defined below) with arguments this and x.
	            return FormatNumber(this, /* x = */Number(value));
	        };
	
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts() {
	    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');
	
	    var x = Number(value);
	    return FormatNumberToParts(this, x);
	}
	
	Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
	    configurable: true,
	    enumerable: false,
	    writable: true,
	    value: formatToParts
	});
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumbertoparts]
	 */
	function FormatNumberToParts(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be ArrayCreate(0).
	    var result = [];
	    // 3. Let n be 0.
	    var n = 0;
	    // 4. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Let O be ObjectCreate(%ObjectPrototype%).
	        var O = {};
	        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
	        O.type = part['[[type]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
	        O.value = part['[[value]]'];
	        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
	        result[n] = O;
	        // a. Increment n by 1.
	        n += 1;
	    }
	    // 5. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-partitionnumberpattern]
	 */
	function PartitionNumberPattern(numberFormat, x) {
	
	    var internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums = internal['[[numberingSystem]]'],
	        data = internals.NumberFormat['[[localeData]]'][locale],
	        ild = data.symbols[nums] || data.symbols.latn,
	        pattern = void 0;
	
	    // 1. If x is not NaN and x < 0, then:
	    if (!isNaN(x) && x < 0) {
	        // a. Let x be -x.
	        x = -x;
	        // a. Let pattern be the value of numberFormat.[[negativePattern]].
	        pattern = internal['[[negativePattern]]'];
	    }
	    // 2. Else,
	    else {
	            // a. Let pattern be the value of numberFormat.[[positivePattern]].
	            pattern = internal['[[positivePattern]]'];
	        }
	    // 3. Let result be a new empty List.
	    var result = new List();
	    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
	    var beginIndex = pattern.indexOf('{', 0);
	    // 5. Let endIndex be 0.
	    var endIndex = 0;
	    // 6. Let nextIndex be 0.
	    var nextIndex = 0;
	    // 7. Let length be the number of code units in pattern.
	    var length = pattern.length;
	    // 8. Repeat while beginIndex is an integer index into pattern:
	    while (beginIndex > -1 && beginIndex < length) {
	        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
	        endIndex = pattern.indexOf('}', beginIndex);
	        // a. If endIndex = -1, throw new Error exception.
	        if (endIndex === -1) throw new Error();
	        // a. If beginIndex is greater than nextIndex, then:
	        if (beginIndex > nextIndex) {
	            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
	            var literal = pattern.substring(nextIndex, beginIndex);
	            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
	        }
	        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // a. If p is equal "number", then:
	        if (p === "number") {
	            // i. If x is NaN,
	            if (isNaN(x)) {
	                // 1. Let n be an ILD String value indicating the NaN value.
	                var n = ild.nan;
	                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
	            }
	            // ii. Else if isFinite(x) is false,
	            else if (!isFinite(x)) {
	                    // 1. Let n be an ILD String value indicating infinity.
	                    var _n = ild.infinity;
	                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
	                }
	                // iii. Else,
	                else {
	                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
	                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;
	
	                        var _n2 = void 0;
	                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
	                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
	                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
	                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
	                        }
	                        // 3. Else,
	                        else {
	                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
	                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
	                            }
	                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
	                        if (numSys[nums]) {
	                            (function () {
	                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
	                                var digits = numSys[nums];
	                                // a. Replace each digit in n with the value of digits[digit].
	                                _n2 = String(_n2).replace(/\d/g, function (digit) {
	                                    return digits[digit];
	                                });
	                            })();
	                        }
	                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
	                        else _n2 = String(_n2); // ###TODO###
	
	                        var integer = void 0;
	                        var fraction = void 0;
	                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
	                        var decimalSepIndex = _n2.indexOf('.', 0);
	                        // 7. If decimalSepIndex > 0, then:
	                        if (decimalSepIndex > 0) {
	                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
	                            integer = _n2.substring(0, decimalSepIndex);
	                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
	                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
	                        }
	                        // 8. Else:
	                        else {
	                                // a. Let integer be n.
	                                integer = _n2;
	                                // a. Let fraction be undefined.
	                                fraction = undefined;
	                            }
	                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
	                        if (internal['[[useGrouping]]'] === true) {
	                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
	                            var groupSepSymbol = ild.group;
	                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
	                            var groups = [];
	                            // ----> implementation:
	                            // Primary group represents the group closest to the decimal
	                            var pgSize = data.patterns.primaryGroupSize || 3;
	                            // Secondary group is every other group
	                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
	                            // Group only if necessary
	                            if (integer.length > pgSize) {
	                                // Index of the primary grouping separator
	                                var end = integer.length - pgSize;
	                                // Starting index for our loop
	                                var idx = end % sgSize;
	                                var start = integer.slice(0, idx);
	                                if (start.length) arrPush.call(groups, start);
	                                // Loop to separate into secondary grouping digits
	                                while (idx < end) {
	                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
	                                    idx += sgSize;
	                                }
	                                // Add the primary grouping digits
	                                arrPush.call(groups, integer.slice(end));
	                            } else {
	                                arrPush.call(groups, integer);
	                            }
	                            // a. Assert: The number of elements in groups List is greater than 0.
	                            if (groups.length === 0) throw new Error();
	                            // a. Repeat, while groups List is not empty:
	                            while (groups.length) {
	                                // i. Remove the first element from groups and let integerGroup be the value of that element.
	                                var integerGroup = arrShift.call(groups);
	                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
	                                // iii. If groups List is not empty, then:
	                                if (groups.length) {
	                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
	                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
	                                }
	                            }
	                        }
	                        // 10. Else,
	                        else {
	                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
	                            }
	                        // 11. If fraction is not undefined, then:
	                        if (fraction !== undefined) {
	                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
	                            var decimalSepSymbol = ild.decimal;
	                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
	                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
	                        }
	                    }
	        }
	        // a. Else if p is equal "plusSign", then:
	        else if (p === "plusSign") {
	                // i. Let plusSignSymbol be the ILND String representing the plus sign.
	                var plusSignSymbol = ild.plusSign;
	                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
	                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
	            }
	            // a. Else if p is equal "minusSign", then:
	            else if (p === "minusSign") {
	                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
	                    var minusSignSymbol = ild.minusSign;
	                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
	                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
	                }
	                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
	                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
	                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
	                        var percentSignSymbol = ild.percentSign;
	                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
	                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
	                    }
	                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
	                    else if (p === "currency" && internal['[[style]]'] === "currency") {
	                            // i. Let currency be the value of numberFormat.[[currency]].
	                            var currency = internal['[[currency]]'];
	
	                            var cd = void 0;
	
	                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
	                            if (internal['[[currencyDisplay]]'] === "code") {
	                                // 1. Let cd be currency.
	                                cd = currency;
	                            }
	                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
	                            else if (internal['[[currencyDisplay]]'] === "symbol") {
	                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
	                                    cd = data.currencies[currency] || currency;
	                                }
	                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
	                                else if (internal['[[currencyDisplay]]'] === "name") {
	                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
	                                        cd = currency;
	                                    }
	                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
	                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
	                        }
	                        // a. Else,
	                        else {
	                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
	                                var _literal = pattern.substring(beginIndex, endIndex);
	                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
	                            }
	        // a. Set nextIndex to endIndex + 1.
	        nextIndex = endIndex + 1;
	        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
	        beginIndex = pattern.indexOf('{', nextIndex);
	    }
	    // 9. If nextIndex is less than length, then:
	    if (nextIndex < length) {
	        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
	        var _literal2 = pattern.substring(nextIndex, length);
	        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
	        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
	    }
	    // 10. Return result.
	    return result;
	}
	
	/*
	 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
	 * @clause[sec-formatnumber]
	 */
	function FormatNumber(numberFormat, x) {
	    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
	    var parts = PartitionNumberPattern(numberFormat, x);
	    // 2. Let result be an empty String.
	    var result = '';
	    // 3. For each part in parts, do:
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        // a. Set result to a String value produced by concatenating result and part.[[value]].
	        result += part['[[value]]'];
	    }
	    // 4. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision(x, minPrecision, maxPrecision) {
	    // 1. Let p be maxPrecision.
	    var p = maxPrecision;
	
	    var m = void 0,
	        e = void 0;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        // a. Let m be the String consisting of p occurrences of the character "0".
	        m = arrJoin.call(Array(p + 1), '0');
	        // b. Let e be 0.
	        e = 0;
	    }
	    // 3. Else
	    else {
	            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	            //    possible. If there are two such sets of e and n, pick the e and n for
	            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	            e = log10Floor(Math.abs(x));
	
	            // Easier to get to m from here
	            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));
	
	            // b. Let m be the String consisting of the digits of the decimal
	            //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	        }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e - p + 1 + 1), '0');
	
	        // 5. If e = p-1, then
	    else if (e === p - 1)
	            // a. Return m.
	            return m;
	
	            // 6. If e ≥ 0, then
	        else if (e >= 0)
	                // a. Let m be the concatenation of the first e+1 characters of m, the character
	                //    ".", and the remaining p–(e+1) characters of m.
	                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	                // 7. If e < 0, then
	            else if (e < 0)
	                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	                    //    character "0", and the string m.
	                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        // a. Let cut be maxPrecision – minPrecision.
	        var cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length - 1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length - 1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * @spec[tc39/ecma402/master/spec/numberformat.html]
	 * @clause[sec-torawfixed]
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed(x, minInteger, minFraction, maxFraction) {
	    // 1. Let f be maxFraction.
	    var f = maxFraction;
	    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
	    var n = Math.pow(10, f) * x; // diverging...
	    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
	    var m = n === 0 ? "0" : n.toFixed(0); // divering...
	
	    {
	        // this diversion is needed to take into consideration big numbers, e.g.:
	        // 1.2344501e+37 -> 12344501000000000000000000000000000000
	        var idx = void 0;
	        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	        if (exp) {
	            m = m.slice(0, idx).replace('.', '');
	            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
	        }
	    }
	
	    var int = void 0;
	    // 4. If f ≠ 0, then
	    if (f !== 0) {
	        // a. Let k be the number of characters in m.
	        var k = m.length;
	        // a. If k ≤ f, then
	        if (k <= f) {
	            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
	            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
	            // ii. Let m be the concatenation of Strings z and m.
	            m = z + m;
	            // iii. Let k be f+1.
	            k = f + 1;
	        }
	        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
	        var a = m.substring(0, k - f),
	            b = m.substring(k - f, m.length);
	        // a. Let m be the concatenation of the three Strings a, ".", and b.
	        m = a + "." + b;
	        // a. Let int be the number of characters in a.
	        int = a.length;
	    }
	    // 5. Else, let int be the number of characters in m.
	    else int = m.length;
	    // 6. Let cut be maxFraction – minFraction.
	    var cut = maxFraction - minFraction;
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	        // a. Decrease cut by 1.
	        cut--;
	    }
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	    }
	    // 9. If int < minInteger, then
	    if (int < minInteger) {
	        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
	        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
	        // a. Let m be the concatenation of Strings z and m.
	        m = _z + m;
	    }
	    // 10. Return m.
	    return m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
	    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
	    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
	    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
	    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
	    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
	    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
	    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
	    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
	    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
	    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
	    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
	    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
	    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
	    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
	    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
	    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
	    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
	    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
	    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
	    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
	    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	/* jslint esnext: true */
	
	// Match these datetime components in a CLDR pattern, except those in single quotes
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	// trim patterns after transformations
	var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	// Skip over patterns with these datetime components because we don't have data
	// to back them up:
	// timezone, weekday, amoung others
	var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string
	
	var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
	var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
	    var o = { _: {} };
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (dateFormatObj[dtKeys[i]]) {
	            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
	        }
	        if (dateFormatObj._[dtKeys[i]]) {
	            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
	        }
	    }
	    for (var j = 0; j < tmKeys.length; j += 1) {
	        if (timeFormatObj[tmKeys[j]]) {
	            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
	        }
	        if (timeFormatObj._[tmKeys[j]]) {
	            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
	        }
	    }
	    return o;
	}
	
	function computeFinalPatterns(formatObj) {
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
	    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
	    return formatObj;
	}
	
	function expDTComponentsMeta($0, formatObj) {
	    switch ($0.charAt(0)) {
	        // --- Era
	        case 'G':
	            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{era}';
	
	        // --- Year
	        case 'y':
	        case 'Y':
	        case 'u':
	        case 'U':
	        case 'r':
	            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{year}';
	
	        // --- Quarter (not supported in this polyfill)
	        case 'Q':
	        case 'q':
	            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{quarter}';
	
	        // --- Month
	        case 'M':
	        case 'L':
	            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
	            return '{month}';
	
	        // --- Week (not supported in this polyfill)
	        case 'w':
	            // week of the year
	            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{weekday}';
	        case 'W':
	            // week of the month
	            formatObj.week = 'numeric';
	            return '{weekday}';
	
	        // --- Day
	        case 'd':
	            // day of the month
	            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{day}';
	        case 'D': // day of the year
	        case 'F': // day of the week
	        case 'g':
	            // 1..n: Modified Julian day
	            formatObj.day = 'numeric';
	            return '{day}';
	
	        // --- Week Day
	        case 'E':
	            // day of the week
	            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'e':
	            // local day of the week
	            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	        case 'c':
	            // stand alone local day of the week
	            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
	            return '{weekday}';
	
	        // --- Period
	        case 'a': // AM, PM
	        case 'b': // am, pm, noon, midnight
	        case 'B':
	            // flexible day periods
	            formatObj.hour12 = true;
	            return '{ampm}';
	
	        // --- Hour
	        case 'h':
	        case 'H':
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	        case 'k':
	        case 'K':
	            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
	            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{hour}';
	
	        // --- Minute
	        case 'm':
	            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{minute}';
	
	        // --- Second
	        case 's':
	            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	            return '{second}';
	        case 'S':
	        case 'A':
	            formatObj.second = 'numeric';
	            return '{second}';
	
	        // --- Timezone
	        case 'z': // 1..3, 4: specific non-location format
	        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
	        case 'O': // 1, 4: miliseconds in day short, long
	        case 'v': // 1, 4: generic non-location format
	        case 'V': // 1, 2, 3, 4: time zone ID or city
	        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
	        case 'x':
	            // 1, 2, 3, 4: The ISO8601 varios formats
	            // this polyfill only supports much, for now, we are just doing something dummy
	            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	            return '{timeZoneName}';
	    }
	}
	
	/**
	 * Converts the CLDR availableFormats into the objects and patterns required by
	 * the ECMAScript Internationalization API specification.
	 */
	function createDateTimeFormat(skeleton, pattern) {
	    // we ignore certain patterns that are unsupported to avoid this expensive op.
	    if (unwantedDTCs.test(pattern)) return undefined;
	
	    var formatObj = {
	        originalPattern: pattern,
	        _: {}
	    };
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj._);
	    });
	
	    // Match the skeleton string with the one required by the specification
	    // this implementation is based on the Date Field Symbol Table:
	    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	    // Note: we are adding extra data to the formatObject even though this polyfill
	    //       might not support it.
	    skeleton.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        return expDTComponentsMeta($0, formatObj);
	    });
	
	    return computeFinalPatterns(formatObj);
	}
	
	/**
	 * Processes DateTime formats from CLDR to an easier-to-parse format.
	 * the result of this operation should be cached the first time a particular
	 * calendar is analyzed.
	 *
	 * The specification requires we support at least the following subsets of
	 * date/time components:
	 *
	 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
	 *   - 'weekday', 'year', 'month', 'day'
	 *   - 'year', 'month', 'day'
	 *   - 'year', 'month'
	 *   - 'month', 'day'
	 *   - 'hour', 'minute', 'second'
	 *   - 'hour', 'minute'
	 *
	 * We need to cherry pick at least these subsets from the CLDR data and convert
	 * them into the pattern objects used in the ECMA-402 API.
	 */
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var result = [];
	    var skeleton = void 0,
	        pattern = void 0,
	        computed = void 0,
	        i = void 0,
	        j = void 0;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (skeleton in availableFormats) {
	        if (availableFormats.hasOwnProperty(skeleton)) {
	            pattern = availableFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(computed);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(computed);
	                }
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (skeleton in timeFormats) {
	        if (timeFormats.hasOwnProperty(skeleton)) {
	            pattern = timeFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                timeRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (skeleton in dateFormats) {
	        if (dateFormats.hasOwnProperty(skeleton)) {
	            pattern = dateFormats[skeleton];
	            computed = createDateTimeFormat(skeleton, pattern);
	            if (computed) {
	                result.push(computed);
	                dateRelatedFormats.push(computed);
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by CLDR.
	    // This Algo is based on section "Missing Skeleton Fields" from:
	    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            if (dateRelatedFormats[j].month === 'long') {
	                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
	            } else if (dateRelatedFormats[j].month === 'short') {
	                pattern = formats.medium;
	            } else {
	                pattern = formats.short;
	            }
	            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
	            computed.originalPattern = pattern;
	            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
	            result.push(computeFinalPatterns(computed));
	        }
	    }
	
	    return result;
	}
	
	// this represents the exceptions of the rule that are not covered by CLDR availableFormats
	// for single property configurations, they play no role when using multiple properties, and
	// those that are not in this table, are not exceptions or are not covered by the data we
	// provide.
	var validSyntheticProps = {
	    second: {
	        numeric: 's',
	        '2-digit': 'ss'
	    },
	    minute: {
	        numeric: 'm',
	        '2-digit': 'mm'
	    },
	    year: {
	        numeric: 'y',
	        '2-digit': 'yy'
	    },
	    day: {
	        numeric: 'd',
	        '2-digit': 'dd'
	    },
	    month: {
	        numeric: 'L',
	        '2-digit': 'LL',
	        narrow: 'LLLLL',
	        short: 'LLL',
	        long: 'LLLL'
	    },
	    weekday: {
	        narrow: 'ccccc',
	        short: 'ccc',
	        long: 'cccc'
	    }
	};
	
	function generateSyntheticFormat(propName, propValue) {
	    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
	        var _ref2;
	
	        return _ref2 = {
	            originalPattern: validSyntheticProps[propName][propValue],
	            _: defineProperty$1({}, propName, propValue),
	            extendedPattern: "{" + propName + "}"
	        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
	    }
	}
	
	// An object map of date component keys, saves using a regex later
	var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],
	
	
	    // "sideways" inheritance resolves strings when a key doesn't exist
	    alts = {
	        narrow: ['short', 'long'],
	        short: ['long', 'narrow'],
	        long: ['short', 'narrow']
	    },
	
	
	    //
	    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key !== null ? resolved[key] : resolved;
	}
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor() {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
	    // This will be a internal properties object if we're not already initialized
	    var internal = getInternalProperties(dateTimeFormat);
	
	    // Create an object whose props can be used to restore the values of RegExp props
	    var regexpRestore = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function value() {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret) return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	    var requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	    options = ToDateTimeOptions(options, 'any', 'date');
	
	    // 5. Let opt be a new Record.
	    var opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	    var localeData = DateTimeFormat['[[localeData]]'];
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	    var dataLocale = r['[[dataLocale]]'];
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	    var tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop)) continue;
	
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[[' + prop + ']]'] = value;
	    }
	
	    // Assigned a value below
	    var bestFormat = void 0;
	
	    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	    var dataLocaleData = localeData[dataLocale];
	
	    // 24. Let formats be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "formats".
	    //     Note: we process the CLDR formats into the spec'd structure
	    var formats = ToDateTimeFormats(dataLocaleData.formats);
	
	    // 25. Let matcher be the result of calling the GetOption abstract operation with
	    //     arguments options, "formatMatcher", "string", a List containing the two String
	    //     values "basic" and "best fit", and "best fit".
	    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic') {
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	        // 28. Else
	    } else {
	        {
	            // diverging
	            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
	        }
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	    }
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var _prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, _prop)) continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, _prop)) {
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	            var p = bestFormat[_prop];
	            {
	                // diverging
	                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
	            }
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[[' + _prop + ']]'] = p;
	        }
	    }
	
	    var pattern = void 0; // Assigned a value below
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	            var hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpRestore();
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	    weekday: ["narrow", "short", "long"],
	    era: ["narrow", "short", "long"],
	    year: ["2-digit", "numeric"],
	    month: ["2-digit", "numeric", "narrow", "short", "long"],
	    day: ["2-digit", "numeric"],
	    hour: ["2-digit", "numeric"],
	    minute: ["2-digit", "numeric"],
	    second: ["2-digit", "numeric"],
	    timeZoneName: ["short", "long"]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions(options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined) options = null;else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2) {
	            options[k] = opt2[k];
	        }
	    }
	
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	    var create = objCreate;
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	    options = create(options);
	
	    // 4. Let needDefaults be true.
	    var needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	        // i. If the result of calling the [[Get]] internal method of options with the
	        //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	        // i. Call the [[DefineOwnProperty]] internal method of options with the
	        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher(options, formats) {
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        // 5. If delta = 2, decrease score by longMorePenalty.
	                        if (delta === 2) score -= longMorePenalty;
	
	                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                        else if (delta === 1) score -= shortMorePenalty;
	
	                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                            else if (delta === -1) score -= shortLessPenalty;
	
	                                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                                else if (delta === -2) score -= longLessPenalty;
	                    }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * This algo relies on the concept of closest distance matching described here:
	 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
	 * Typically a “best match” is found using a closest distance match, such as:
	 *
	 * Symbols requesting a best choice for the locale are replaced.
	 *      j → one of {H, k, h, K}; C → one of {a, b, B}
	 * -> Covered by cldr.js matching process
	 *
	 * For fields with symbols representing the same type (year, month, day, etc):
	 *     Most symbols have a small distance from each other.
	 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
	 *     -> Covered by cldr.js matching process
	 *
	 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
	 *         MMM ≅ MMMM
	 *         MM ≅ M
	 *     Numeric and text fields are given a larger distance from each other.
	 *         MMM ≈ MM
	 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
	 *         d ≋ D; ...
	 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
	 *
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher(options, formats) {
	    /** Diverging: this block implements the hack for single property configuration, eg.:
	     *
	     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
	     *
	     * should produce a single digit with the day of the month. This is needed because
	     * CLDR `availableFormats` data structure doesn't cover these cases.
	     */
	    {
	        var optionsPropNames = [];
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property)) continue;
	
	            if (options['[[' + property + ']]'] !== undefined) {
	                optionsPropNames.push(property);
	            }
	        }
	        if (optionsPropNames.length === 1) {
	            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
	            if (_bestFormat) {
	                return _bestFormat;
	            }
	        }
	    }
	
	    // 1. Let removalPenalty be 120.
	    var removalPenalty = 120;
	
	    // 2. Let additionPenalty be 20.
	    var additionPenalty = 20;
	
	    // 3. Let longLessPenalty be 8.
	    var longLessPenalty = 8;
	
	    // 4. Let longMorePenalty be 6.
	    var longMorePenalty = 6;
	
	    // 5. Let shortLessPenalty be 6.
	    var shortLessPenalty = 6;
	
	    // 6. Let shortMorePenalty be 3.
	    var shortMorePenalty = 3;
	
	    var patternPenalty = 2;
	
	    var hour12Penalty = 1;
	
	    // 7. Let bestScore be -Infinity.
	    var bestScore = -Infinity;
	
	    // 8. Let bestFormat be undefined.
	    var bestFormat = void 0;
	
	    // 9. Let i be 0.
	    var i = 0;
	
	    // 10. Assert: formats is an Array object.
	
	    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	    var len = formats.length;
	
	    // 12. Repeat while i < len:
	    while (i < len) {
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	        var format = formats[i];
	
	        // b. Let score be 0.
	        var score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var _property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, _property)) continue;
	
	            // i. Let optionsProp be options.[[<property>]].
	            var optionsProp = options['[[' + _property + ']]'];
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	            var formatProp = hop.call(format, _property) ? format[_property] : undefined;
	
	            // Diverging: using the default properties produced by the pattern/skeleton
	            // to match it with user options, and apply a penalty
	            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
	            if (optionsProp !== patternProp) {
	                score -= patternPenalty;
	            }
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;
	
	                // vi. Else
	                else {
	                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                        //    "long"].
	                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];
	
	                        // 2. Let optionsPropIndex be the index of optionsProp within values.
	                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);
	
	                        // 3. Let formatPropIndex be the index of formatProp within values.
	                        var formatPropIndex = arrIndexOf.call(values, formatProp);
	
	                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                        {
	                            // diverging from spec
	                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
	                            } else {
	                                // 5. If delta = 2, decrease score by longMorePenalty.
	                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
	                            }
	                        }
	                    }
	        }
	
	        {
	            // diverging to also take into consideration differences between 12 or 24 hours
	            // which is special for the best fit only.
	            if (format._.hour12 !== options.hour12) {
	                score -= hour12Penalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 13. Return bestFormat.
	    return bestFormat;
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */
	defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(function (locales) {
	        // Bound functions only have the `this` value altered if being used as a constructor,
	        // this lets us imitate a native function that has no constructor
	        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');
	
	        // Create an object whose props can be used to restore the values of RegExp props
	        var regexpRestore = createRegExpRestore(),
	
	
	        // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	
	        // 2. Let availableLocales be the value of the [[availableLocales]] internal
	        //    property of the standard built-in object that is the initial value of
	        //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	
	        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	        //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	        // Restore the RegExp properties
	        regexpRestore();
	
	        // 4. Return the result of calling the SupportedLocales abstract operation
	        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	        //    and options.
	        return SupportedLocales(availableLocales, requestedLocales, options);
	    }, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	        var F = function F() {
	            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	            //   i. If date is not provided or is undefined, then let x be the
	            //      result as if by the expression Date.now() where Date.now is
	            //      the standard built-in function defined in ES5, 15.9.4.4.
	            //  ii. Else let x be ToNumber(date).
	            // iii. Return the result of calling the FormatDateTime abstract
	            //      operation (defined below) with arguments this and x.
	            var x = date === undefined ? Date.now() : toNumber(date);
	            return FormatDateTime(this, x);
	        };
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	        var bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	function formatToParts$1() {
	    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];
	
	    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');
	
	    var x = date === undefined ? Date.now() : toNumber(date);
	    return FormatToPartsDateTime(this, x);
	}
	
	Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
	    enumerable: false,
	    writable: true,
	    configurable: true,
	    value: formatToParts$1
	});
	
	function CreateDateTimeParts(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');
	
	    var internal = dateTimeFormat.__getInternalProperties(secret);
	
	    // Creating restore point for properties on the RegExp object... please wait
	    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	    var locale = internal['[[locale]]'];
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    var nf = new Intl.NumberFormat([locale], { useGrouping: false });
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	    var pattern = internal['[[pattern]]'];
	
	    // 7.
	    var result = new List();
	
	    // 8.
	    var index = 0;
	
	    // 9.
	    var beginIndex = pattern.indexOf('{');
	
	    // 10.
	    var endIndex = 0;
	
	    // Need the locale minus any extensions
	    var dataLocale = internal['[[dataLocale]]'];
	
	    // Need the calendar data from CLDR
	    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
	    var ca = internal['[[calendar]]'];
	
	    // 11.
	    while (beginIndex !== -1) {
	        var fv = void 0;
	        // a.
	        endIndex = pattern.indexOf('}', beginIndex);
	        // b.
	        if (endIndex === -1) {
	            throw new Error('Unclosed pattern');
	        }
	        // c.
	        if (beginIndex > index) {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(index, beginIndex)
	            });
	        }
	        // d.
	        var p = pattern.substring(beginIndex + 1, endIndex);
	        // e.
	        if (dateTimeComponents.hasOwnProperty(p)) {
	            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	            var f = internal['[[' + p + ']]'];
	            //  ii. Let v be the value of tm.[[<p>]].
	            var v = tm['[[' + p + ']]'];
	            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0) {
	                v = 1 - v;
	            }
	            //  iv. If p is "month", then increase v by 1.
	            else if (p === 'month') {
	                    v++;
	                }
	                //   v. If p is "hour" and the value of the [[hour12]] internal property of
	                //      dateTimeFormat is true, then
	                else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                        // 1. Let v be v modulo 12.
	                        v = v % 12;
	                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
	                        //    dateTimeFormat is true, then let v be 12.
	                        if (v === 0 && internal['[[hourNo0]]'] === true) {
	                            v = 12;
	                        }
	                    }
	
	            //  vi. If f is "numeric", then
	            if (f === 'numeric') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	            }
	            // vii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                    // 1. Let fv be the result of calling the FormatNumber abstract operation
	                    //    with arguments nf2 and v.
	                    fv = FormatNumber(nf2, v);
	                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                    //    containing the last two characters.
	                    if (fv.length > 2) {
	                        fv = fv.slice(-2);
	                    }
	                }
	                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
	                //     value representing f in the desired form; the String value depends upon
	                //     the implementation and the effective locale and calendar of
	                //     dateTimeFormat. If p is "month", then the String value may also depend
	                //     on whether dateTimeFormat has a [[day]] internal property. If p is
	                //     "timeZoneName", then the String value may also depend on the value of
	                //     the [[inDST]] field of tm.
	                else if (f in dateWidths) {
	                        switch (p) {
	                            case 'month':
	                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
	                                break;
	
	                            case 'weekday':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
	                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                                } catch (e) {
	                                    throw new Error('Could not find weekday data for locale ' + locale);
	                                }
	                                break;
	
	                            case 'timeZoneName':
	                                fv = ''; // ###TODO
	                                break;
	
	                            case 'era':
	                                try {
	                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
	                                } catch (e) {
	                                    throw new Error('Could not find era data for locale ' + locale);
	                                }
	                                break;
	
	                            default:
	                                fv = tm['[[' + p + ']]'];
	                        }
	                    }
	            // ix
	            arrPush.call(result, {
	                type: p,
	                value: fv
	            });
	            // f.
	        } else if (p === 'ampm') {
	            // i.
	            var _v = tm['[[hour]]'];
	            // ii./iii.
	            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
	            // iv.
	            arrPush.call(result, {
	                type: 'dayPeriod',
	                value: fv
	            });
	            // g.
	        } else {
	            arrPush.call(result, {
	                type: 'literal',
	                value: pattern.substring(beginIndex, endIndex + 1)
	            });
	        }
	        // h.
	        index = endIndex + 1;
	        // i.
	        beginIndex = pattern.indexOf('{', index);
	    }
	    // 12.
	    if (endIndex < pattern.length - 1) {
	        arrPush.call(result, {
	            type: 'literal',
	            value: pattern.substr(endIndex + 1)
	        });
	    }
	    // 13.
	    return result;
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = '';
	
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result += part.value;
	    }
	    return result;
	}
	
	function FormatToPartsDateTime(dateTimeFormat, x) {
	    var parts = CreateDateTimeParts(dateTimeFormat, x);
	    var result = [];
	    for (var i = 0; parts.length > i; i++) {
	        var part = parts[i];
	        result.push({
	            type: part.type,
	            value: part.value
	        });
	    }
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]': +(d[m + 'FullYear']() >= 0),
	        '[[year]]': d[m + 'FullYear'](),
	        '[[month]]': d[m + 'Month'](),
	        '[[day]]': d[m + 'Date'](),
	        '[[hour]]': d[m + 'Hours'](),
	        '[[minute]]': d[m + 'Minutes'](),
	        '[[second]]': d[m + 'Seconds'](),
	        '[[inDST]]': false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        var prop = void 0,
	            descs = new Record(),
	            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
	            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date: {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	    options = ToDateTimeOptions(options, 'any', 'all');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0],
	
	
	    // 4. If options is not provided, then let options be undefined.
	    options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	    options = ToDateTimeOptions(options, 'date', 'date');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	    var x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x)) return 'Invalid Date';
	
	    // 3. If locales is not provided, then let locales be undefined.
	    var locales = arguments[0];
	
	    // 4. If options is not provided, then let options be undefined.
	    var options = arguments[1];
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	    options = ToDateTimeOptions(options, 'time', 'time');
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function value() {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	        // Need this here for IE 8, to avoid the _DontEnum_ bug
	        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function value(data) {
	        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData(data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale = void 0,
	        locales = [tag],
	        parts = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined) setDefaultLocale(tag);
	}
	
	defineProperty(Intl, '__disableRegExpRestore', {
	    value: function value() {
	        internals.disableRegExpRestore = true;
	    }
	});
	
	module.exports = Intl;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5347 */
/***/ (function(module, exports) {

	IntlPolyfill.__addLocaleData({locale:"en",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:true,formats:{short:"{1}, {0}",medium:"{1}, {0}",full:"{1} 'at' {0}",long:"{1} 'at' {0}",availableFormats:{"d":"d","E":"ccc",Ed:"d E",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"MMM d, y G",GyMMMEd:"E, MMM d, y G","h":"h a","H":"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v","M":"L",Md:"M/d",MEd:"E, M/d",MMM:"LLL",MMMd:"MMM d",MMMEd:"E, MMM d",MMMMd:"MMMM d",ms:"mm:ss","y":"y",yM:"M/y",yMd:"M/d/y",yMEd:"E, M/d/y",yMMM:"MMM y",yMMMd:"MMM d, y",yMMMEd:"E, MMM d, y",yMMMM:"MMMM y",yQQQ:"QQQ y",yQQQQ:"QQQQ y"},dateFormats:{yMMMMEEEEd:"EEEE, MMMM d, y",yMMMMd:"MMMM d, y",yMMMd:"MMM d, y",yMd:"M/d/yy"},timeFormats:{hmmsszzzz:"h:mm:ss a zzzz",hmsz:"h:mm:ss a z",hms:"h:mm:ss a",hm:"h:mm a"}},calendars:{buddhist:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"AM",pm:"PM"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"AM",pm:"PM"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},gregory:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["B","A","BCE","CE"],short:["BC","AD","BCE","CE"],long:["Before Christ","Anno Domini","Before Common Era","Common Era"]},dayPeriods:{am:"AM",pm:"PM"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"AM",pm:"PM"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"AM",pm:"PM"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},japanese:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"AM",pm:"PM"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"AM",pm:"PM"}},roc:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Before R.O.C.","Minguo"],short:["Before R.O.C.","Minguo"],long:["Before R.O.C.","Minguo"]},dayPeriods:{am:"AM",pm:"PM"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{currency}{number}",negativePattern:"{minusSign}{currency}{number}"},percent:{positivePattern:"{number}{percentSign}",negativePattern:"{minusSign}{number}{percentSign}"}},symbols:{latn:{decimal:".",group:",",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{AUD:"A$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",TWD:"NT$",USD:"$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF"}}});

/***/ }),
/* 5348 */
/***/ (function(module, exports) {

	IntlPolyfill.__addLocaleData({locale:"es",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:false,formats:{short:"{1} {0}",medium:"{1} {0}",full:"{1}, {0}",long:"{1}, {0}",availableFormats:{"d":"d","E":"ccc",Ed:"E d",Ehm:"E, h:mm a",EHm:"E, H:mm",Ehms:"E, h:mm:ss a",EHms:"E, H:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"d MMM y G",GyMMMEd:"E, d MMM y G",GyMMMM:"MMMM 'de' y G",GyMMMMd:"d 'de' MMMM 'de' y G",GyMMMMEd:"E, d 'de' MMMM 'de' y G","h":"h a","H":"H",hm:"h:mm a",Hm:"H:mm",hms:"h:mm:ss a",Hms:"H:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"H:mm:ss v",hmsvvvv:"h:mm:ss a (vvvv)",Hmsvvvv:"H:mm:ss (vvvv)",hmv:"h:mm a v",Hmv:"H:mm v","M":"L",Md:"d/M",MEd:"E, d/M",MMd:"d/M",MMdd:"d/M",MMM:"LLL",MMMd:"d MMM",MMMEd:"E, d MMM",MMMMd:"d 'de' MMMM",MMMMEd:"E, d 'de' MMMM",ms:"mm:ss","y":"y",yM:"M/y",yMd:"d/M/y",yMEd:"EEE, d/M/y",yMM:"M/y",yMMM:"MMM y",yMMMd:"d MMM y",yMMMEd:"EEE, d MMM y",yMMMM:"MMMM 'de' y",yMMMMd:"d 'de' MMMM 'de' y",yMMMMEd:"EEE, d 'de' MMMM 'de' y",yQQQ:"QQQ y",yQQQQ:"QQQQ 'de' y"},dateFormats:{yMMMMEEEEd:"EEEE, d 'de' MMMM 'de' y",yMMMMd:"d 'de' MMMM 'de' y",yMMMd:"d MMM y",yMd:"d/M/yy"},timeFormats:{hmmsszzzz:"H:mm:ss (zzzz)",hmsz:"H:mm:ss z",hms:"H:mm:ss",hm:"H:mm"}},calendars:{buddhist:{months:{narrow:["E","F","M","A","M","J","J","A","S","O","N","D"],short:["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sept.","oct.","nov.","dic."],long:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"a. m.",pm:"p. m."}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},dayPeriods:{am:"a. m.",pm:"p. m."}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"a. m.",pm:"p. m."}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},dayPeriods:{am:"a. m.",pm:"p. m."}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"a. m.",pm:"p. m."}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"a. m.",pm:"p. m."}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"a. m.",pm:"p. m."}},gregory:{months:{narrow:["E","F","M","A","M","J","J","A","S","O","N","D"],short:["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sept.","oct.","nov.","dic."],long:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["a. C.","d. C.","a. e. c.","e. c."],short:["a. C.","d. C.","a. e. c.","e. c."],long:["antes de Cristo","después de Cristo","antes de la era común","era común"]},dayPeriods:{am:"a. m.",pm:"p. m."}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"a. m.",pm:"p. m."}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"a. m.",pm:"p. m."}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"a. m.",pm:"p. m."}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"a. m.",pm:"p. m."}},japanese:{months:{narrow:["E","F","M","A","M","J","J","A","S","O","N","D"],short:["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sept.","oct.","nov.","dic."],long:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"a. m.",pm:"p. m."}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"a. m.",pm:"p. m."}},roc:{months:{narrow:["E","F","M","A","M","J","J","A","S","O","N","D"],short:["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sept.","oct.","nov.","dic."],long:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]},days:{narrow:["D","L","M","X","J","V","S"],short:["dom.","lun.","mar.","mié.","jue.","vie.","sáb."],long:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"]},eras:{narrow:["antes de R.O.C.","R.O.C."],short:["antes de R.O.C.","R.O.C."],long:["antes de R.O.C.","R.O.C."]},dayPeriods:{am:"a. m.",pm:"p. m."}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{number} {currency}",negativePattern:"{minusSign}{number} {currency}"},percent:{positivePattern:"{number} {percentSign}",negativePattern:"{minusSign}{number} {percentSign}"}},symbols:{latn:{decimal:",",group:".",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{CAD:"CA$",ESP:"₧",EUR:"€",THB:"฿",USD:"$",VND:"₫",XPF:"CFPF"}}});

/***/ }),
/* 5349 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	var toStr = Object.prototype.toString;
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return toStr.call(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value) !== '[object Array]' &&
			toStr.call(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 5350 */
/***/ (function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ }),
/* 5351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(5321);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ }),
/* 5352 */,
/* 5353 */
/***/ (function(module, exports) {

	module.exports = {
		"version": "2023c",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
			"Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6",
			"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5",
			"Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
			"Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
			"Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
			"America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
			"America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
			"America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
			"America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
			"America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
			"America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5",
			"America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
			"America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|",
			"America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
			"America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
			"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|01212134121212121212121212121512121212121212121212125212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|01212134121212121212121212121212156565212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
			"America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
			"America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5",
			"America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5",
			"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|012121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0|",
			"America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
			"America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
			"America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
			"America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
			"America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
			"Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
			"Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4",
			"Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|01212121212121212121212121212121212343434343434343434343434343434312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5",
			"Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5",
			"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
			"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
			"Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
			"Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
			"Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"EST|EST|50|0||",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Etc/GMT-0|GMT|0|0||",
			"Etc/GMT-1|+01|-10|0||",
			"Etc/GMT-10|+10|-a0|0||",
			"Etc/GMT-11|+11|-b0|0||",
			"Etc/GMT-12|+12|-c0|0||",
			"Etc/GMT-13|+13|-d0|0||",
			"Etc/GMT-14|+14|-e0|0||",
			"Etc/GMT-2|+02|-20|0||",
			"Etc/GMT-3|+03|-30|0||",
			"Etc/GMT-4|+04|-40|0||",
			"Etc/GMT-5|+05|-50|0||",
			"Etc/GMT-6|+06|-60|0||",
			"Etc/GMT-7|+07|-70|0||",
			"Etc/GMT-8|+08|-80|0||",
			"Etc/GMT-9|+09|-90|0||",
			"Etc/GMT+1|-01|10|0||",
			"Etc/GMT+10|-10|a0|0||",
			"Etc/GMT+11|-11|b0|0||",
			"Etc/GMT+12|-12|c0|0||",
			"Etc/GMT+2|-02|20|0||",
			"Etc/GMT+3|-03|30|0||",
			"Etc/GMT+4|-04|40|0||",
			"Etc/GMT+5|-05|50|0||",
			"Etc/GMT+6|-06|60|0||",
			"Etc/GMT+7|-07|70|0||",
			"Etc/GMT+8|-08|80|0||",
			"Etc/GMT+9|-09|90|0||",
			"Etc/UTC|UTC|0|0||",
			"Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
			"Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
			"Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
			"Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
			"Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
			"Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
			"Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
			"Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
			"Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
			"HST|HST|a0|0||",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"MST|MST|70|0||",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
			"Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
			"Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
			"Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
			"Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
			"Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
			"Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
			"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
			"Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
			"Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
			"Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"
		],
		"links": [
			"Africa/Abidjan|Africa/Accra",
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/Reykjavik",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Abidjan|Iceland",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Chicago|US/Central",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|America/Yellowknife",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Godthab|America/Nuuk",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Iqaluit|America/Pangnirtung",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Atikokan",
			"America/Panama|America/Cayman",
			"America/Panama|America/Coral_Harbour",
			"America/Phoenix|America/Creston",
			"America/Phoenix|US/Arizona",
			"America/Puerto_Rico|America/Anguilla",
			"America/Puerto_Rico|America/Antigua",
			"America/Puerto_Rico|America/Aruba",
			"America/Puerto_Rico|America/Blanc-Sablon",
			"America/Puerto_Rico|America/Curacao",
			"America/Puerto_Rico|America/Dominica",
			"America/Puerto_Rico|America/Grenada",
			"America/Puerto_Rico|America/Guadeloupe",
			"America/Puerto_Rico|America/Kralendijk",
			"America/Puerto_Rico|America/Lower_Princes",
			"America/Puerto_Rico|America/Marigot",
			"America/Puerto_Rico|America/Montserrat",
			"America/Puerto_Rico|America/Port_of_Spain",
			"America/Puerto_Rico|America/St_Barthelemy",
			"America/Puerto_Rico|America/St_Kitts",
			"America/Puerto_Rico|America/St_Lucia",
			"America/Puerto_Rico|America/St_Thomas",
			"America/Puerto_Rico|America/St_Vincent",
			"America/Puerto_Rico|America/Tortola",
			"America/Puerto_Rico|America/Virgin",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|America/Nassau",
			"America/Toronto|America/Nipigon",
			"America/Toronto|America/Thunder_Bay",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|America/Rainy_River",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Bangkok|Indian/Christmas",
			"Asia/Brunei|Asia/Kuching",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Dubai|Indian/Mahe",
			"Asia/Dubai|Indian/Reunion",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Rangoon|Indian/Cocos",
			"Asia/Riyadh|Antarctica/Syowa",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Antarctica/Vostok",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Currie",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT-0|Etc/GMT",
			"Etc/GMT-0|Etc/GMT+0",
			"Etc/GMT-0|Etc/GMT0",
			"Etc/GMT-0|Etc/Greenwich",
			"Etc/GMT-0|GMT",
			"Etc/GMT-0|GMT+0",
			"Etc/GMT-0|GMT-0",
			"Etc/GMT-0|GMT0",
			"Etc/GMT-0|Greenwich",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Berlin|Arctic/Longyearbyen",
			"Europe/Berlin|Atlantic/Jan_Mayen",
			"Europe/Berlin|Europe/Copenhagen",
			"Europe/Berlin|Europe/Oslo",
			"Europe/Berlin|Europe/Stockholm",
			"Europe/Brussels|Europe/Amsterdam",
			"Europe/Brussels|Europe/Luxembourg",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Kiev|Europe/Kyiv",
			"Europe/Kiev|Europe/Uzhgorod",
			"Europe/Kiev|Europe/Zaporozhye",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Paris|Europe/Monaco",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Maldives|Indian/Kerguelen",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Enderbury|Pacific/Kanton",
			"Pacific/Guadalcanal|Pacific/Pohnpei",
			"Pacific/Guadalcanal|Pacific/Ponape",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Port_Moresby|Antarctica/DumontDUrville",
			"Pacific/Port_Moresby|Pacific/Chuuk",
			"Pacific/Port_Moresby|Pacific/Truk",
			"Pacific/Port_Moresby|Pacific/Yap",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Majuro",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		],
		"countries": [
			"AD|Europe/Andorra",
			"AE|Asia/Dubai",
			"AF|Asia/Kabul",
			"AG|America/Puerto_Rico America/Antigua",
			"AI|America/Puerto_Rico America/Anguilla",
			"AL|Europe/Tirane",
			"AM|Asia/Yerevan",
			"AO|Africa/Lagos Africa/Luanda",
			"AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok",
			"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
			"AS|Pacific/Pago_Pago",
			"AT|Europe/Vienna",
			"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
			"AW|America/Puerto_Rico America/Aruba",
			"AX|Europe/Helsinki Europe/Mariehamn",
			"AZ|Asia/Baku",
			"BA|Europe/Belgrade Europe/Sarajevo",
			"BB|America/Barbados",
			"BD|Asia/Dhaka",
			"BE|Europe/Brussels",
			"BF|Africa/Abidjan Africa/Ouagadougou",
			"BG|Europe/Sofia",
			"BH|Asia/Qatar Asia/Bahrain",
			"BI|Africa/Maputo Africa/Bujumbura",
			"BJ|Africa/Lagos Africa/Porto-Novo",
			"BL|America/Puerto_Rico America/St_Barthelemy",
			"BM|Atlantic/Bermuda",
			"BN|Asia/Kuching Asia/Brunei",
			"BO|America/La_Paz",
			"BQ|America/Puerto_Rico America/Kralendijk",
			"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
			"BS|America/Toronto America/Nassau",
			"BT|Asia/Thimphu",
			"BW|Africa/Maputo Africa/Gaborone",
			"BY|Europe/Minsk",
			"BZ|America/Belize",
			"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
			"CC|Asia/Yangon Indian/Cocos",
			"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
			"CF|Africa/Lagos Africa/Bangui",
			"CG|Africa/Lagos Africa/Brazzaville",
			"CH|Europe/Zurich",
			"CI|Africa/Abidjan",
			"CK|Pacific/Rarotonga",
			"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
			"CM|Africa/Lagos Africa/Douala",
			"CN|Asia/Shanghai Asia/Urumqi",
			"CO|America/Bogota",
			"CR|America/Costa_Rica",
			"CU|America/Havana",
			"CV|Atlantic/Cape_Verde",
			"CW|America/Puerto_Rico America/Curacao",
			"CX|Asia/Bangkok Indian/Christmas",
			"CY|Asia/Nicosia Asia/Famagusta",
			"CZ|Europe/Prague",
			"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
			"DJ|Africa/Nairobi Africa/Djibouti",
			"DK|Europe/Berlin Europe/Copenhagen",
			"DM|America/Puerto_Rico America/Dominica",
			"DO|America/Santo_Domingo",
			"DZ|Africa/Algiers",
			"EC|America/Guayaquil Pacific/Galapagos",
			"EE|Europe/Tallinn",
			"EG|Africa/Cairo",
			"EH|Africa/El_Aaiun",
			"ER|Africa/Nairobi Africa/Asmara",
			"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
			"ET|Africa/Nairobi Africa/Addis_Ababa",
			"FI|Europe/Helsinki",
			"FJ|Pacific/Fiji",
			"FK|Atlantic/Stanley",
			"FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
			"FO|Atlantic/Faroe",
			"FR|Europe/Paris",
			"GA|Africa/Lagos Africa/Libreville",
			"GB|Europe/London",
			"GD|America/Puerto_Rico America/Grenada",
			"GE|Asia/Tbilisi",
			"GF|America/Cayenne",
			"GG|Europe/London Europe/Guernsey",
			"GH|Africa/Abidjan Africa/Accra",
			"GI|Europe/Gibraltar",
			"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
			"GM|Africa/Abidjan Africa/Banjul",
			"GN|Africa/Abidjan Africa/Conakry",
			"GP|America/Puerto_Rico America/Guadeloupe",
			"GQ|Africa/Lagos Africa/Malabo",
			"GR|Europe/Athens",
			"GS|Atlantic/South_Georgia",
			"GT|America/Guatemala",
			"GU|Pacific/Guam",
			"GW|Africa/Bissau",
			"GY|America/Guyana",
			"HK|Asia/Hong_Kong",
			"HN|America/Tegucigalpa",
			"HR|Europe/Belgrade Europe/Zagreb",
			"HT|America/Port-au-Prince",
			"HU|Europe/Budapest",
			"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
			"IE|Europe/Dublin",
			"IL|Asia/Jerusalem",
			"IM|Europe/London Europe/Isle_of_Man",
			"IN|Asia/Kolkata",
			"IO|Indian/Chagos",
			"IQ|Asia/Baghdad",
			"IR|Asia/Tehran",
			"IS|Africa/Abidjan Atlantic/Reykjavik",
			"IT|Europe/Rome",
			"JE|Europe/London Europe/Jersey",
			"JM|America/Jamaica",
			"JO|Asia/Amman",
			"JP|Asia/Tokyo",
			"KE|Africa/Nairobi",
			"KG|Asia/Bishkek",
			"KH|Asia/Bangkok Asia/Phnom_Penh",
			"KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
			"KM|Africa/Nairobi Indian/Comoro",
			"KN|America/Puerto_Rico America/St_Kitts",
			"KP|Asia/Pyongyang",
			"KR|Asia/Seoul",
			"KW|Asia/Riyadh Asia/Kuwait",
			"KY|America/Panama America/Cayman",
			"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
			"LA|Asia/Bangkok Asia/Vientiane",
			"LB|Asia/Beirut",
			"LC|America/Puerto_Rico America/St_Lucia",
			"LI|Europe/Zurich Europe/Vaduz",
			"LK|Asia/Colombo",
			"LR|Africa/Monrovia",
			"LS|Africa/Johannesburg Africa/Maseru",
			"LT|Europe/Vilnius",
			"LU|Europe/Brussels Europe/Luxembourg",
			"LV|Europe/Riga",
			"LY|Africa/Tripoli",
			"MA|Africa/Casablanca",
			"MC|Europe/Paris Europe/Monaco",
			"MD|Europe/Chisinau",
			"ME|Europe/Belgrade Europe/Podgorica",
			"MF|America/Puerto_Rico America/Marigot",
			"MG|Africa/Nairobi Indian/Antananarivo",
			"MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
			"MK|Europe/Belgrade Europe/Skopje",
			"ML|Africa/Abidjan Africa/Bamako",
			"MM|Asia/Yangon",
			"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
			"MO|Asia/Macau",
			"MP|Pacific/Guam Pacific/Saipan",
			"MQ|America/Martinique",
			"MR|Africa/Abidjan Africa/Nouakchott",
			"MS|America/Puerto_Rico America/Montserrat",
			"MT|Europe/Malta",
			"MU|Indian/Mauritius",
			"MV|Indian/Maldives",
			"MW|Africa/Maputo Africa/Blantyre",
			"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
			"MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
			"MZ|Africa/Maputo",
			"NA|Africa/Windhoek",
			"NC|Pacific/Noumea",
			"NE|Africa/Lagos Africa/Niamey",
			"NF|Pacific/Norfolk",
			"NG|Africa/Lagos",
			"NI|America/Managua",
			"NL|Europe/Brussels Europe/Amsterdam",
			"NO|Europe/Berlin Europe/Oslo",
			"NP|Asia/Kathmandu",
			"NR|Pacific/Nauru",
			"NU|Pacific/Niue",
			"NZ|Pacific/Auckland Pacific/Chatham",
			"OM|Asia/Dubai Asia/Muscat",
			"PA|America/Panama",
			"PE|America/Lima",
			"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
			"PG|Pacific/Port_Moresby Pacific/Bougainville",
			"PH|Asia/Manila",
			"PK|Asia/Karachi",
			"PL|Europe/Warsaw",
			"PM|America/Miquelon",
			"PN|Pacific/Pitcairn",
			"PR|America/Puerto_Rico",
			"PS|Asia/Gaza Asia/Hebron",
			"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
			"PW|Pacific/Palau",
			"PY|America/Asuncion",
			"QA|Asia/Qatar",
			"RE|Asia/Dubai Indian/Reunion",
			"RO|Europe/Bucharest",
			"RS|Europe/Belgrade",
			"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
			"RW|Africa/Maputo Africa/Kigali",
			"SA|Asia/Riyadh",
			"SB|Pacific/Guadalcanal",
			"SC|Asia/Dubai Indian/Mahe",
			"SD|Africa/Khartoum",
			"SE|Europe/Berlin Europe/Stockholm",
			"SG|Asia/Singapore",
			"SH|Africa/Abidjan Atlantic/St_Helena",
			"SI|Europe/Belgrade Europe/Ljubljana",
			"SJ|Europe/Berlin Arctic/Longyearbyen",
			"SK|Europe/Prague Europe/Bratislava",
			"SL|Africa/Abidjan Africa/Freetown",
			"SM|Europe/Rome Europe/San_Marino",
			"SN|Africa/Abidjan Africa/Dakar",
			"SO|Africa/Nairobi Africa/Mogadishu",
			"SR|America/Paramaribo",
			"SS|Africa/Juba",
			"ST|Africa/Sao_Tome",
			"SV|America/El_Salvador",
			"SX|America/Puerto_Rico America/Lower_Princes",
			"SY|Asia/Damascus",
			"SZ|Africa/Johannesburg Africa/Mbabane",
			"TC|America/Grand_Turk",
			"TD|Africa/Ndjamena",
			"TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
			"TG|Africa/Abidjan Africa/Lome",
			"TH|Asia/Bangkok",
			"TJ|Asia/Dushanbe",
			"TK|Pacific/Fakaofo",
			"TL|Asia/Dili",
			"TM|Asia/Ashgabat",
			"TN|Africa/Tunis",
			"TO|Pacific/Tongatapu",
			"TR|Europe/Istanbul",
			"TT|America/Puerto_Rico America/Port_of_Spain",
			"TV|Pacific/Tarawa Pacific/Funafuti",
			"TW|Asia/Taipei",
			"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
			"UA|Europe/Simferopol Europe/Kyiv",
			"UG|Africa/Nairobi Africa/Kampala",
			"UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
			"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
			"UY|America/Montevideo",
			"UZ|Asia/Samarkand Asia/Tashkent",
			"VA|Europe/Rome Europe/Vatican",
			"VC|America/Puerto_Rico America/St_Vincent",
			"VE|America/Caracas",
			"VG|America/Puerto_Rico America/Tortola",
			"VI|America/Puerto_Rico America/St_Thomas",
			"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
			"VU|Pacific/Efate",
			"WF|Pacific/Tarawa Pacific/Wallis",
			"WS|Pacific/Apia",
			"YE|Asia/Riyadh Asia/Aden",
			"YT|Africa/Nairobi Indian/Mayotte",
			"ZA|Africa/Johannesburg",
			"ZM|Africa/Maputo Africa/Lusaka",
			"ZW|Africa/Maputo Africa/Harare"
		]
	};

/***/ }),
/* 5354 */
/***/ (function(module, exports) {

	module.exports = {
		"nm": "Main Scene",
		"ddd": 0,
		"h": 500,
		"w": 500,
		"meta": {
			"g": "@lottiefiles/creator 1.46.2"
		},
		"layers": [
			{
				"ty": 0,
				"nm": "Nested Scene 1",
				"sr": 1,
				"st": 0,
				"op": 120,
				"ip": 0,
				"hd": false,
				"ddd": 0,
				"bm": 0,
				"hasMask": false,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							11.820571184158332,
							11.429060041904457
						]
					},
					"s": {
						"a": 0,
						"k": [
							574.5165,
							574.5165
						]
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							248,
							248
						]
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 0,
						"k": 100
					}
				},
				"w": 500,
				"h": 500,
				"refId": "precomp_Shape Layer - SVG_1ed0d1da-9c9f-4fe0-a05d-eb083511d2c0_40257d22-1dfb-4abd-b6ae-4a767322eaa9",
				"ind": 1
			},
			{
				"ty": 4,
				"nm": "Ellipse 1",
				"sr": 1,
				"st": 0,
				"op": 120,
				"ip": 0,
				"hd": false,
				"ddd": 0,
				"bm": 0,
				"hasMask": false,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							0,
							0
						]
					},
					"s": {
						"a": 0,
						"k": [
							80,
							80
						]
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							246,
							247
						]
					},
					"r": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									160
								],
								"t": 0
							},
							{
								"s": [
									-200
								],
								"t": 119
							}
						]
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 0,
						"k": 100
					}
				},
				"shapes": [
					{
						"ty": "sh",
						"bm": 0,
						"hd": false,
						"nm": "Ellipse Path 1",
						"d": 1,
						"ks": {
							"a": 0,
							"k": {
								"c": true,
								"i": [
									[
										-73.9546,
										0
									],
									[
										0,
										-73.9546
									],
									[
										73.9546,
										0
									],
									[
										0,
										73.9546
									]
								],
								"o": [
									[
										73.9546,
										0
									],
									[
										0,
										73.9546
									],
									[
										-73.9546,
										0
									],
									[
										0,
										-73.9546
									]
								],
								"v": [
									[
										0,
										-134
									],
									[
										134,
										0
									],
									[
										0,
										134
									],
									[
										-134,
										0
									]
								]
							}
						}
					},
					{
						"ty": "tm",
						"bm": 0,
						"hd": false,
						"nm": "Trim Path",
						"e": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.65,
										"y": 0
									},
									"i": {
										"x": 0.36,
										"y": 1
									},
									"s": [
										100
									],
									"t": 4
								},
								{
									"s": [
										0
									],
									"t": 120
								}
							]
						},
						"o": {
							"a": 0,
							"k": 0
						},
						"s": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.55,
										"y": 0.06
									},
									"i": {
										"x": 0.36,
										"y": 1
									},
									"s": [
										100
									],
									"t": 0
								},
								{
									"s": [
										0
									],
									"t": 116
								}
							]
						},
						"m": 1
					},
					{
						"ty": "st",
						"bm": 0,
						"hd": false,
						"nm": "Stroke",
						"lc": 2,
						"lj": 2,
						"ml": 1,
						"o": {
							"a": 0,
							"k": 100
						},
						"w": {
							"a": 0,
							"k": 28
						},
						"c": {
							"a": 0,
							"k": [
								0.3569,
								0.5373,
								0.7843
							]
						}
					}
				],
				"ind": 2
			},
			{
				"ty": 4,
				"nm": "Ellipse 1",
				"sr": 1,
				"st": 0,
				"op": 120,
				"ip": 0,
				"hd": false,
				"ddd": 0,
				"bm": 0,
				"hasMask": false,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							0,
							0
						]
					},
					"s": {
						"a": 0,
						"k": [
							80,
							80
						]
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							246,
							247
						]
					},
					"r": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									60
								],
								"t": 0
							},
							{
								"s": [
									-300
								],
								"t": 119
							}
						]
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 0,
						"k": 100
					}
				},
				"shapes": [
					{
						"ty": "sh",
						"bm": 0,
						"hd": false,
						"nm": "Ellipse Path 1",
						"d": 1,
						"ks": {
							"a": 0,
							"k": {
								"c": true,
								"i": [
									[
										-73.9546,
										0
									],
									[
										0,
										-73.9546
									],
									[
										73.9546,
										0
									],
									[
										0,
										73.9546
									]
								],
								"o": [
									[
										73.9546,
										0
									],
									[
										0,
										73.9546
									],
									[
										-73.9546,
										0
									],
									[
										0,
										-73.9546
									]
								],
								"v": [
									[
										0,
										-134
									],
									[
										134,
										0
									],
									[
										0,
										134
									],
									[
										-134,
										0
									]
								]
							}
						}
					},
					{
						"ty": "tm",
						"bm": 0,
						"hd": false,
						"nm": "Trim Path",
						"e": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.65,
										"y": 0
									},
									"i": {
										"x": 0.36,
										"y": 1
									},
									"s": [
										100
									],
									"t": 26
								},
								{
									"s": [
										0
									],
									"t": 120
								}
							]
						},
						"o": {
							"a": 0,
							"k": 0
						},
						"s": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.55,
										"y": 0.06
									},
									"i": {
										"x": 0.36,
										"y": 1
									},
									"s": [
										100
									],
									"t": 0
								},
								{
									"s": [
										0
									],
									"t": 96
								}
							]
						},
						"m": 1
					},
					{
						"ty": "st",
						"bm": 0,
						"hd": false,
						"nm": "Stroke",
						"lc": 2,
						"lj": 2,
						"ml": 1,
						"o": {
							"a": 0,
							"k": 100
						},
						"w": {
							"a": 0,
							"k": 28
						},
						"c": {
							"a": 0,
							"k": [
								0.3569,
								0.5373,
								0.7843
							]
						}
					}
				],
				"ind": 3
			},
			{
				"ty": 4,
				"nm": "Ellipse 1",
				"sr": 1,
				"st": 0,
				"op": 122,
				"ip": 0,
				"hd": false,
				"ddd": 0,
				"bm": 0,
				"hasMask": false,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							0,
							0
						]
					},
					"s": {
						"a": 0,
						"k": [
							100,
							100
						]
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							246,
							247
						]
					},
					"r": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									0
								],
								"t": 0
							},
							{
								"s": [
									-359
								],
								"t": 120
							}
						]
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 0,
						"k": 100
					}
				},
				"shapes": [
					{
						"ty": "sh",
						"bm": 0,
						"hd": false,
						"nm": "Ellipse Path 1",
						"d": 1,
						"ks": {
							"a": 0,
							"k": {
								"c": true,
								"i": [
									[
										-73.9546,
										0
									],
									[
										0,
										-73.9546
									],
									[
										73.9546,
										0
									],
									[
										0,
										73.9546
									]
								],
								"o": [
									[
										73.9546,
										0
									],
									[
										0,
										73.9546
									],
									[
										-73.9546,
										0
									],
									[
										0,
										-73.9546
									]
								],
								"v": [
									[
										0,
										-134
									],
									[
										134,
										0
									],
									[
										0,
										134
									],
									[
										-134,
										0
									]
								]
							}
						}
					},
					{
						"ty": "tm",
						"bm": 0,
						"hd": false,
						"nm": "Trim Path",
						"e": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.65,
										"y": 0
									},
									"i": {
										"x": 0.36,
										"y": 1
									},
									"s": [
										100
									],
									"t": 26
								},
								{
									"s": [
										0
									],
									"t": 120
								}
							]
						},
						"o": {
							"a": 0,
							"k": 0
						},
						"s": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.55,
										"y": 0.06
									},
									"i": {
										"x": 0.36,
										"y": 1
									},
									"s": [
										100
									],
									"t": 0
								},
								{
									"s": [
										0
									],
									"t": 96
								}
							]
						},
						"m": 1
					},
					{
						"ty": "st",
						"bm": 0,
						"hd": false,
						"nm": "Stroke",
						"lc": 2,
						"lj": 2,
						"ml": 1,
						"o": {
							"a": 0,
							"k": 100
						},
						"w": {
							"a": 0,
							"k": 10
						},
						"c": {
							"a": 0,
							"k": [
								0.5176,
								0.6549,
								0.8392
							]
						}
					}
				],
				"ind": 4
			}
		],
		"v": "5.7.0",
		"fr": 60,
		"op": 120,
		"ip": 0,
		"assets": [
			{
				"nm": "Nested Scene 1",
				"id": "precomp_Shape Layer - SVG_1ed0d1da-9c9f-4fe0-a05d-eb083511d2c0_40257d22-1dfb-4abd-b6ae-4a767322eaa9",
				"fr": 60,
				"layers": [
					{
						"ty": 4,
						"nm": "Shape Layer - SVG",
						"sr": 1,
						"st": 0,
						"op": 120,
						"ip": 0,
						"hd": false,
						"ddd": 0,
						"bm": 0,
						"hasMask": false,
						"ao": 0,
						"ks": {
							"a": {
								"a": 0,
								"k": [
									11.820571184158325,
									11.42906004190445
								]
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								]
							},
							"sk": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [
									11.820571184158325,
									11.42906004190445
								]
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							},
							"o": {
								"a": 0,
								"k": 100
							}
						},
						"shapes": [
							{
								"ty": "gr",
								"bm": 0,
								"hd": false,
								"nm": "Group 1",
								"it": [
									{
										"ty": "sh",
										"bm": 0,
										"hd": false,
										"nm": "Path 1",
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0.5866000000000007,
														0.5658799999999999
													],
													[
														0.8145000000000007,
														-0.029886999999999886
													],
													[
														0,
														0
													],
													[
														0.5866300000000004,
														-0.5658799999999999
													],
													[
														-0.0005500000000004945,
														-0.81508
													],
													[
														0,
														0
													],
													[
														-0.32714000000000043,
														-2.170159999999999
													],
													[
														0,
														0
													],
													[
														-2.3636100000000004,
														0.054299999999997794
													],
													[
														0,
														0
													],
													[
														-0.45660000000000167,
														2.319700000000001
													],
													[
														0,
														0
													],
													[
														2.084699999999998,
														0.7176799999999997
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0.0005999999999986017,
														-0.81508
													],
													[
														-0.5865999999999989,
														-0.5658799999999999
													],
													[
														0,
														0
													],
													[
														-0.8145199999999999,
														-0.029886999999999886
													],
													[
														-0.5866300000000004,
														0.5658799999999999
													],
													[
														0,
														0
													],
													[
														-2.06881,
														0.7325999999999997
													],
													[
														0,
														0
													],
													[
														0.4566600000000003,
														2.319700000000001
													],
													[
														0,
														0
													],
													[
														2.3636,
														0.054299999999997794
													],
													[
														0,
														0
													],
													[
														0.3222999999999985,
														-2.1811100000000003
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														16.5515,
														7.12202
													],
													[
														16.5515,
														4.00202
													],
													[
														15.6343,
														1.84084
													],
													[
														13.4415,
														1.00202
													],
													[
														10.1615,
														1.00202
													],
													[
														7.96872,
														1.84084
													],
													[
														7.05151,
														4.00202
													],
													[
														7.05151,
														7.12202
													],
													[
														4.05151,
														12.122
													],
													[
														5.00151,
														17.892
													],
													[
														9.88151,
														21.812
													],
													[
														13.7615,
														21.812
													],
													[
														18.6415,
														17.892
													],
													[
														19.5915,
														12.122
													],
													[
														16.5515,
														7.12202
													]
												]
											}
										}
									},
									{
										"ty": "sh",
										"bm": 0,
										"hd": false,
										"nm": "Path 2",
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0.17360000000000042,
														-0.24269999999999925
													],
													[
														0.29829999999999934,
														-0.0045000000000001705
													],
													[
														0,
														0
													],
													[
														0.17360000000000042,
														0.24259999999999948
													],
													[
														-0.09210000000000029,
														0.28380000000000116
													],
													[
														0,
														0
													],
													[
														0.25489999999999924,
														0.26559999999999917
													],
													[
														-0.6397100000000009,
														0.6042000000000005
													],
													[
														-0.639800000000001,
														-0.6042000000000005
													],
													[
														0.5667000000000009,
														-0.6731999999999996
													],
													[
														-0.11320000000000086,
														-0.35020000000000095
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0.09210000000000029,
														0.28380000000000116
													],
													[
														-0.17360000000000042,
														0.24259999999999948
													],
													[
														0,
														0
													],
													[
														-0.2983000000000011,
														-0.0045000000000001705
													],
													[
														-0.17360000000000042,
														-0.24269999999999925
													],
													[
														0,
														0
													],
													[
														0.11319999999999908,
														-0.35020000000000095
													],
													[
														-0.5666399999999996,
														-0.6731999999999996
													],
													[
														0.6397999999999993,
														-0.6042000000000005
													],
													[
														0.6396999999999995,
														0.6042000000000005
													],
													[
														-0.25489999999999924,
														0.26559999999999917
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														12.8015,
														14.932
													],
													[
														13.0115,
														15.552
													],
													[
														12.8819,
														16.3891
													],
													[
														12.1315,
														16.782
													],
													[
														11.3915,
														16.782
													],
													[
														10.6411,
														16.3891
													],
													[
														10.5115,
														15.552
													],
													[
														10.7215,
														14.932
													],
													[
														10.4915,
														13.932
													],
													[
														10.6217,
														11.6562
													],
													[
														12.9013,
														11.6562
													],
													[
														13.0315,
														13.932
													],
													[
														12.8015,
														14.932
													]
												]
											}
										}
									},
									{
										"ty": "sh",
										"bm": 0,
										"hd": false,
										"nm": "Path 3",
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0.8526000000000007,
														-0.033869999999999845
													],
													[
														0,
														0
													],
													[
														0.03786000000000023,
														-0.8523700000000001
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-0.03780000000000072,
														-0.8523700000000001
													],
													[
														0,
														0
													],
													[
														-0.8525200000000002,
														-0.033869999999999845
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														8.55151,
														6.78202
													],
													[
														8.91151,
														6.78202
													],
													[
														8.91151,
														6.79202
													],
													[
														15.0515,
														6.79202
													],
													[
														15.0515,
														4.00202
													],
													[
														13.4415,
														2.52202
													],
													[
														10.1615,
														2.52202
													],
													[
														8.55151,
														4.00202
													],
													[
														8.55151,
														6.78202
													]
												]
											}
										}
									},
									{
										"ty": "fl",
										"bm": 0,
										"hd": false,
										"nm": "Fill",
										"c": {
											"a": 0,
											"k": [
												0.1961,
												0.4235,
												0.7294
											]
										},
										"r": 2,
										"o": {
											"a": 0,
											"k": 100
										}
									},
									{
										"ty": "tr",
										"a": {
											"a": 0,
											"k": [
												0,
												0
											]
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											]
										},
										"sk": {
											"a": 0,
											"k": 0
										},
										"p": {
											"a": 0,
											"k": [
												0,
												0
											]
										},
										"r": {
											"a": 0,
											"k": 0
										},
										"sa": {
											"a": 0,
											"k": 0
										},
										"o": {
											"a": 0,
											"k": 100
										}
									}
								]
							}
						],
						"ind": 1
					}
				]
			}
		]
	};

/***/ }),
/* 5355 */
/***/ (function(module, exports) {

	module.exports = {
		"nm": "Loader Payment",
		"ddd": 0,
		"h": 500,
		"w": 500,
		"meta": {
			"g": "@lottiefiles/toolkit-js 0.33.2"
		},
		"layers": [
			{
				"ty": 4,
				"nm": "credit card",
				"sr": 1,
				"st": 0,
				"op": 240,
				"ip": 0,
				"hd": false,
				"ddd": 0,
				"bm": 0,
				"hasMask": false,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							11.207,
							21.121,
							0
						],
						"ix": 1
					},
					"s": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.834,
									"y": 0
								},
								"i": {
									"x": 0.579,
									"y": 1.077
								},
								"s": [
									100,
									100,
									100
								],
								"t": 0
							},
							{
								"o": {
									"x": 0.439,
									"y": 0.095
								},
								"i": {
									"x": 0.202,
									"y": 1
								},
								"s": [
									86,
									86,
									100
								],
								"t": 52.984
							},
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									100,
									100,
									100
								],
								"t": 107.797
							},
							{
								"o": {
									"x": 0.834,
									"y": 0
								},
								"i": {
									"x": 0.579,
									"y": 1.077
								},
								"s": [
									100,
									100,
									100
								],
								"t": 121.018
							},
							{
								"o": {
									"x": 0.439,
									"y": 0.095
								},
								"i": {
									"x": 0.202,
									"y": 1
								},
								"s": [
									86,
									86,
									100
								],
								"t": 174.002
							},
							{
								"s": [
									100,
									100,
									100
								],
								"t": 228.814453125
							}
						],
						"ix": 6
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							250,
							250,
							0
						],
						"ix": 2
					},
					"r": {
						"a": 0,
						"k": 0,
						"ix": 10
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 11
					}
				},
				"ef": [],
				"shapes": [
					{
						"ty": "gr",
						"bm": 0,
						"hd": false,
						"mn": "ADBE Vector Group",
						"nm": "Rectangle 2",
						"ix": 1,
						"cix": 2,
						"np": 3,
						"it": [
							{
								"ty": "rc",
								"bm": 0,
								"hd": false,
								"mn": "ADBE Vector Shape - Rect",
								"nm": "Rectangle Path 1",
								"d": 1,
								"p": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 3
								},
								"r": {
									"a": 0,
									"k": 0,
									"ix": 4
								},
								"s": {
									"a": 0,
									"k": [
										200,
										0.1
									],
									"ix": 2
								}
							},
							{
								"ty": "st",
								"bm": 0,
								"hd": false,
								"mn": "ADBE Vector Graphic - Stroke",
								"nm": "Stroke 1",
								"lc": 1,
								"lj": 1,
								"ml": 4,
								"o": {
									"a": 0,
									"k": 100,
									"ix": 4
								},
								"w": {
									"a": 0,
									"k": 15,
									"ix": 5
								},
								"c": {
									"a": 0,
									"k": [
										0.1961,
										0.4235,
										0.7294
									],
									"ix": 3
								}
							},
							{
								"ty": "tr",
								"a": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 1
								},
								"s": {
									"a": 0,
									"k": [
										100,
										100
									],
									"ix": 3
								},
								"sk": {
									"a": 0,
									"k": 0,
									"ix": 4
								},
								"p": {
									"a": 0,
									"k": [
										11.207,
										3.017
									],
									"ix": 2
								},
								"r": {
									"a": 0,
									"k": 0,
									"ix": 6
								},
								"sa": {
									"a": 0,
									"k": 0,
									"ix": 5
								},
								"o": {
									"a": 0,
									"k": 100,
									"ix": 7
								}
							}
						]
					},
					{
						"ty": "gr",
						"bm": 0,
						"hd": false,
						"mn": "ADBE Vector Group",
						"nm": "Rectangle 1",
						"ix": 2,
						"cix": 2,
						"np": 3,
						"it": [
							{
								"ty": "rc",
								"bm": 0,
								"hd": false,
								"mn": "ADBE Vector Shape - Rect",
								"nm": "Rectangle Path 1",
								"d": 1,
								"p": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 3
								},
								"r": {
									"a": 0,
									"k": 20,
									"ix": 4
								},
								"s": {
									"a": 0,
									"k": [
										200,
										126.724
									],
									"ix": 2
								}
							},
							{
								"ty": "st",
								"bm": 0,
								"hd": false,
								"mn": "ADBE Vector Graphic - Stroke",
								"nm": "Stroke 1",
								"lc": 1,
								"lj": 1,
								"ml": 4,
								"o": {
									"a": 0,
									"k": 100,
									"ix": 4
								},
								"w": {
									"a": 0,
									"k": 15,
									"ix": 5
								},
								"c": {
									"a": 0,
									"k": [
										0.1961,
										0.4235,
										0.7294
									],
									"ix": 3
								}
							},
							{
								"ty": "tr",
								"a": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 1
								},
								"s": {
									"a": 0,
									"k": [
										100,
										100
									],
									"ix": 3
								},
								"sk": {
									"a": 0,
									"k": 0,
									"ix": 4
								},
								"p": {
									"a": 0,
									"k": [
										11.207,
										21.121
									],
									"ix": 2
								},
								"r": {
									"a": 0,
									"k": 0,
									"ix": 6
								},
								"sa": {
									"a": 0,
									"k": 0,
									"ix": 5
								},
								"o": {
									"a": 0,
									"k": 100,
									"ix": 7
								}
							}
						]
					}
				],
				"ind": 1
			},
			{
				"ty": 4,
				"nm": "loader",
				"sr": 1,
				"st": 0,
				"op": 240,
				"ip": 0,
				"hd": false,
				"ddd": 0,
				"bm": 0,
				"hasMask": false,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							0,
							0,
							0
						],
						"ix": 1
					},
					"s": {
						"a": 0,
						"k": [
							100,
							100,
							100
						],
						"ix": 6
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							250,
							250,
							0
						],
						"ix": 2
					},
					"r": {
						"a": 0,
						"k": 0,
						"ix": 10
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 11
					}
				},
				"ef": [],
				"shapes": [
					{
						"ty": "gr",
						"bm": 0,
						"hd": false,
						"mn": "ADBE Vector Group",
						"nm": "Ellipse 1",
						"ix": 1,
						"cix": 2,
						"np": 3,
						"it": [
							{
								"ty": "el",
								"bm": 0,
								"hd": false,
								"mn": "ADBE Vector Shape - Ellipse",
								"nm": "Ellipse Path 1",
								"d": 1,
								"p": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 3
								},
								"s": {
									"a": 0,
									"k": [
										338,
										338
									],
									"ix": 2
								}
							},
							{
								"ty": "st",
								"bm": 0,
								"hd": false,
								"mn": "ADBE Vector Graphic - Stroke",
								"nm": "Stroke 1",
								"lc": 2,
								"lj": 2,
								"ml": 1,
								"o": {
									"a": 0,
									"k": 100,
									"ix": 4
								},
								"w": {
									"a": 0,
									"k": 15,
									"ix": 5
								},
								"c": {
									"a": 0,
									"k": [
										0.1961,
										0.4235,
										0.7294
									],
									"ix": 3
								}
							},
							{
								"ty": "tr",
								"a": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 1
								},
								"s": {
									"a": 0,
									"k": [
										100,
										100
									],
									"ix": 3
								},
								"sk": {
									"a": 0,
									"k": 0,
									"ix": 4
								},
								"p": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 2
								},
								"r": {
									"a": 0,
									"k": 0,
									"ix": 6
								},
								"sa": {
									"a": 0,
									"k": 0,
									"ix": 5
								},
								"o": {
									"a": 0,
									"k": 100,
									"ix": 7
								}
							}
						]
					},
					{
						"ty": "tm",
						"bm": 0,
						"hd": false,
						"mn": "ADBE Vector Filter - Trim",
						"nm": "Trim Paths 1",
						"ix": 2,
						"e": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.512,
										"y": 0
									},
									"i": {
										"x": 0.256,
										"y": 1
									},
									"s": [
										0.1
									],
									"t": 0
								},
								{
									"o": {
										"x": 0.333,
										"y": 0
									},
									"i": {
										"x": 0.833,
										"y": 1
									},
									"s": [
										100
									],
									"t": 79.551
								},
								{
									"o": {
										"x": 0.167,
										"y": 0
									},
									"i": {
										"x": 0.667,
										"y": 1
									},
									"s": [
										100
									],
									"t": 120
								},
								{
									"o": {
										"x": 0.512,
										"y": 0
									},
									"i": {
										"x": 0.256,
										"y": 1
									},
									"s": [
										0.1
									],
									"t": 121.018
								},
								{
									"o": {
										"x": 0.333,
										"y": 0
									},
									"i": {
										"x": 0.833,
										"y": 1
									},
									"s": [
										100
									],
									"t": 200.568
								},
								{
									"s": [
										100
									],
									"t": 238.982421875
								}
							],
							"ix": 2
						},
						"o": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"s": [
										0
									],
									"t": 0
								},
								{
									"s": [
										360
									],
									"t": 238.982421875
								}
							],
							"ix": 3
						},
						"s": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.167,
										"y": 0
									},
									"i": {
										"x": 0.667,
										"y": 1
									},
									"s": [
										0
									],
									"t": 0
								},
								{
									"o": {
										"x": 0.512,
										"y": 0
									},
									"i": {
										"x": 0.256,
										"y": 1
									},
									"s": [
										0
									],
									"t": 40.449
								},
								{
									"o": {
										"x": 0.333,
										"y": 0
									},
									"i": {
										"x": 0.833,
										"y": 1
									},
									"s": [
										99.9
									],
									"t": 120
								},
								{
									"o": {
										"x": 0.167,
										"y": 0
									},
									"i": {
										"x": 0.667,
										"y": 1
									},
									"s": [
										0
									],
									"t": 121.018
								},
								{
									"o": {
										"x": 0.512,
										"y": 0
									},
									"i": {
										"x": 0.256,
										"y": 1
									},
									"s": [
										0
									],
									"t": 161.467
								},
								{
									"s": [
										99.9
									],
									"t": 238.982421875
								}
							],
							"ix": 1
						},
						"m": 1
					}
				],
				"ind": 2
			}
		],
		"v": "5.12.1",
		"fr": 60,
		"op": 240,
		"ip": 0,
		"assets": []
	};

/***/ }),
/* 5356 */
/***/ (function(module, exports) {

	module.exports = {
		"nm": "image upload",
		"h": 1200,
		"w": 1200,
		"meta": {
			"g": "@lottiefiles/toolkit-js 0.33.2"
		},
		"layers": [
			{
				"ty": 4,
				"nm": "tick",
				"sr": 1,
				"st": 0,
				"op": 150,
				"ip": 150,
				"hasMask": false,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							256,
							256,
							0
						],
						"ix": 1
					},
					"s": {
						"a": 0,
						"k": [
							100,
							100,
							100
						],
						"ix": 6
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							600,
							600,
							0
						],
						"ix": 2
					},
					"r": {
						"a": 0,
						"k": 0,
						"ix": 10
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									0
								],
								"t": 80
							},
							{
								"s": [
									100
								],
								"t": 90
							}
						],
						"ix": 11
					}
				},
				"ef": [],
				"shapes": [
					{
						"ty": "gr",
						"nm": "tick",
						"ix": 1,
						"cix": 2,
						"it": [
							{
								"ty": "sh",
								"nm": "Path 1",
								"ix": 1,
								"d": 1,
								"ks": {
									"a": 0,
									"k": {
										"c": false,
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												118.858,
												-107.5
											],
											[
												-50.33,
												107.5
											],
											[
												-118.857,
												20.442
											]
										]
									},
									"ix": 2
								}
							},
							{
								"ty": "st",
								"nm": "Stroke 1",
								"lc": 2,
								"lj": 2,
								"ml": 1,
								"o": {
									"a": 0,
									"k": 100,
									"ix": 4
								},
								"w": {
									"a": 0,
									"k": 40,
									"ix": 5
								},
								"c": {
									"a": 0,
									"k": [
										0.161,
										0.835,
										0.604
									],
									"ix": 3
								}
							},
							{
								"ty": "tr",
								"a": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 1
								},
								"s": {
									"a": 0,
									"k": [
										100,
										100
									],
									"ix": 3
								},
								"sk": {
									"a": 0,
									"k": 0,
									"ix": 4
								},
								"p": {
									"a": 0,
									"k": [
										258.857,
										267.611
									],
									"ix": 2
								},
								"r": {
									"a": 0,
									"k": 0,
									"ix": 6
								},
								"sa": {
									"a": 0,
									"k": 0,
									"ix": 5
								},
								"o": {
									"a": 0,
									"k": 100,
									"ix": 7
								}
							}
						]
					}
				],
				"ind": 1
			},
			{
				"ty": 4,
				"nm": "Shape Layer 1",
				"sr": 1,
				"st": 0,
				"op": 150,
				"ip": 0,
				"hasMask": false,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							0,
							0,
							0
						],
						"ix": 1
					},
					"s": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									0,
									100,
									100
								],
								"t": 0
							},
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									120,
									100,
									100
								],
								"t": 10
							},
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									120,
									100,
									100
								],
								"t": 65
							},
							{
								"s": [
									0,
									100,
									100
								],
								"t": 80
							}
						],
						"ix": 6
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									600,
									808,
									0
								],
								"t": 10,
								"ti": [
									0,
									66.5,
									0
								],
								"to": [
									0,
									-66.5,
									0
								]
							},
							{
								"s": [
									600,
									409,
									0
								],
								"t": 60
							}
						],
						"ix": 2
					},
					"r": {
						"a": 0,
						"k": 0,
						"ix": 10
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									100
								],
								"t": 65
							},
							{
								"s": [
									0
								],
								"t": 80
							}
						],
						"ix": 11
					}
				},
				"ef": [],
				"shapes": [
					{
						"ty": "gr",
						"nm": "Rectangle 1",
						"ix": 1,
						"cix": 2,
						"it": [
							{
								"ty": "rc",
								"nm": "Rectangle Path 1",
								"d": 1,
								"p": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 3
								},
								"r": {
									"a": 0,
									"k": 20,
									"ix": 4
								},
								"s": {
									"a": 0,
									"k": [
										562.727,
										33.344
									],
									"ix": 2
								}
							},
							{
								"ty": "fl",
								"nm": "Fill 1",
								"c": {
									"a": 0,
									"k": [
										0.471,
										0.878,
										0.561
									],
									"ix": 4,
									"x": "var $bm_rt;\n$bm_rt = thisComp.layer('image ready').content('image frame').content('sun').content('Fill 1').color;"
								},
								"r": 1,
								"o": {
									"a": 0,
									"k": 100,
									"ix": 5
								}
							},
							{
								"ty": "tr",
								"a": {
									"a": 0,
									"k": [
										0,
										0
									],
									"ix": 1
								},
								"s": {
									"a": 0,
									"k": [
										100,
										100
									],
									"ix": 3
								},
								"sk": {
									"a": 0,
									"k": 0,
									"ix": 4
								},
								"p": {
									"a": 0,
									"k": [
										-0.637,
										-9.328
									],
									"ix": 2
								},
								"r": {
									"a": 0,
									"k": 0,
									"ix": 6
								},
								"sa": {
									"a": 0,
									"k": 0,
									"ix": 5
								},
								"o": {
									"a": 0,
									"k": 100,
									"ix": 7
								}
							}
						]
					}
				],
				"ind": 2
			},
			{
				"ty": 4,
				"nm": "image ready",
				"sr": 1,
				"st": 0,
				"op": 150,
				"ip": 0,
				"hasMask": true,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							256,
							256,
							0
						],
						"ix": 1
					},
					"s": {
						"a": 0,
						"k": [
							100,
							100,
							100
						],
						"ix": 6
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							600,
							600,
							0
						],
						"ix": 2
					},
					"r": {
						"a": 0,
						"k": 0,
						"ix": 10
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									100
								],
								"t": 80
							},
							{
								"s": [
									0
								],
								"t": 90
							}
						],
						"ix": 11
					}
				},
				"ef": [],
				"masksProperties": [
					{
						"nm": "Mask 1",
						"inv": false,
						"mode": "a",
						"x": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 3
						},
						"pt": {
							"a": 1,
							"k": [
								{
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"s": [
										{
											"c": true,
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													476
												],
												[
													0,
													476.001
												],
												[
													512,
													476.001
												],
												[
													512,
													476
												]
											]
										}
									],
									"t": 10
								},
								{
									"s": [
										{
											"c": true,
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													0,
													36
												],
												[
													0,
													476.001
												],
												[
													512,
													476.001
												],
												[
													512,
													36
												]
											]
										}
									],
									"t": 60
								}
							],
							"ix": 1
						}
					}
				],
				"shapes": [
					{
						"ty": "gr",
						"nm": "image frame",
						"ix": 1,
						"cix": 2,
						"it": [
							{
								"ty": "gr",
								"nm": "sun",
								"ix": 1,
								"cix": 2,
								"it": [
									{
										"ty": "sh",
										"nm": "Path 1",
										"ix": 1,
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														-11.028,
														0
													],
													[
														0,
														-11.028
													],
													[
														11.028,
														0
													],
													[
														0,
														11.028
													]
												],
												"o": [
													[
														11.028,
														0
													],
													[
														0,
														11.028
													],
													[
														-11.028,
														0
													],
													[
														0,
														-11.028
													]
												],
												"v": [
													[
														0,
														-20
													],
													[
														20,
														0
													],
													[
														0,
														20
													],
													[
														-20,
														0
													]
												]
											},
											"ix": 2
										}
									},
									{
										"ty": "sh",
										"nm": "Path 2",
										"ix": 2,
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														-33.084,
														0
													],
													[
														0,
														33.084
													],
													[
														33.084,
														0
													],
													[
														0,
														-33.084
													]
												],
												"o": [
													[
														33.084,
														0
													],
													[
														0,
														-33.084
													],
													[
														-33.084,
														0
													],
													[
														0,
														33.084
													]
												],
												"v": [
													[
														0,
														60
													],
													[
														60,
														0
													],
													[
														0,
														-60
													],
													[
														-60,
														0
													]
												]
											},
											"ix": 2
										}
									},
									{
										"ty": "mm",
										"nm": "Merge Paths 1",
										"mm": 1
									},
									{
										"ty": "fl",
										"nm": "Fill 1",
										"c": {
											"a": 0,
											"k": [
												0.161,
												0.835,
												0.604
											],
											"ix": 4
										},
										"r": 1,
										"o": {
											"a": 0,
											"k": 100,
											"ix": 5
										}
									},
									{
										"ty": "tr",
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"p": {
											"a": 0,
											"k": [
												140,
												168
											],
											"ix": 2
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										}
									}
								]
							},
							{
								"ty": "gr",
								"nm": "image",
								"ix": 2,
								"cix": 2,
								"it": [
									{
										"ty": "sh",
										"nm": "Path 1",
										"ix": 1,
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														0,
														0
													],
													[
														0,
														22.056
													],
													[
														0,
														0
													],
													[
														-22.056,
														0
													],
													[
														0,
														0
													],
													[
														0,
														-22.056
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														6.037,
														-0.091
													],
													[
														3.723,
														-4.736
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														6.202,
														0
													],
													[
														0,
														0
													],
													[
														3.784,
														-4.919
													],
													[
														0,
														0
													],
													[
														-8.755,
														-6.735
													],
													[
														-6.734,
														8.755
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														-22.056,
														0
													],
													[
														0,
														0
													],
													[
														0,
														-22.056
													],
													[
														0,
														0
													],
													[
														22.056,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-3.87,
														-4.618
													],
													[
														-6.024,
														0.094
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-3.786,
														-4.913
													],
													[
														0,
														0
													],
													[
														-6.206,
														0.003
													],
													[
														0,
														0
													],
													[
														-6.734,
														8.755
													],
													[
														8.757,
														6.735
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-176,
														180
													],
													[
														-216,
														140
													],
													[
														-216,
														-140
													],
													[
														-176,
														-180
													],
													[
														176,
														-180
													],
													[
														216,
														-140
													],
													[
														216,
														-14.993
													],
													[
														137.327,
														-108.848
													],
													[
														121.687,
														-115.998
													],
													[
														106.278,
														-108.362
													],
													[
														-47.84,
														87.664
													],
													[
														-100.16,
														19.789
													],
													[
														-116,
														11.999
													],
													[
														-116.01,
														11.999
													],
													[
														-131.853,
														19.805
													],
													[
														-175.868,
														77.023
													],
													[
														-172.21,
														105.07
													],
													[
														-144.163,
														101.413
													],
													[
														-115.984,
														64.78
													],
													[
														-27.168,
														180
													]
												]
											},
											"ix": 2
										}
									},
									{
										"ty": "sh",
										"nm": "Path 2",
										"ix": 2,
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														11.046,
														0
													],
													[
														0,
														-11.046
													],
													[
														22.056,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-0.205,
														-0.226
													],
													[
														0,
														0
													],
													[
														-0.025,
														-0.027
													],
													[
														-2.315,
														-1.079
													],
													[
														-2.776,
														-0.092
													],
													[
														-0.051,
														-0.001
													],
													[
														-0.008,
														-0.001
													],
													[
														-1.413,
														0.27
													],
													[
														0,
														0
													],
													[
														-0.064,
														0.013
													],
													[
														-0.026,
														0.005
													],
													[
														-0.054,
														0.012
													],
													[
														-0.03,
														0.007
													],
													[
														-0.049,
														0.011
													],
													[
														-0.034,
														0.009
													],
													[
														-0.043,
														0.01
													],
													[
														-0.038,
														0.009
													],
													[
														-0.041,
														0.01
													],
													[
														-0.038,
														0.01
													],
													[
														-0.042,
														0.011
													],
													[
														-0.038,
														0.01
													],
													[
														0,
														0
													],
													[
														-0.04,
														0.011
													],
													[
														-0.039,
														0.011
													],
													[
														-0.033,
														0.01
													],
													[
														-0.048,
														0.015
													],
													[
														-0.026,
														0.008
													],
													[
														-0.05,
														0.016
													],
													[
														-0.03,
														0.01
													],
													[
														-0.049,
														0.016
													],
													[
														-0.023,
														0.007
													],
													[
														-0.055,
														0.018
													],
													[
														-0.021,
														0.008
													],
													[
														-0.056,
														0.021
													],
													[
														-0.018,
														0.007
													],
													[
														-0.061,
														0.023
													],
													[
														0,
														0
													],
													[
														-0.068,
														0.027
													],
													[
														-0.004,
														0.002
													],
													[
														-0.073,
														0.031
													],
													[
														-0.844,
														0.499
													],
													[
														-0.012,
														0.007
													],
													[
														-0.057,
														0.035
													],
													[
														-0.932,
														0.842
													],
													[
														-0.017,
														0.015
													],
													[
														-0.015,
														0.013
													],
													[
														-1.085,
														2.33
													],
													[
														-0.088,
														2.788
													],
													[
														-0.001,
														0.036
													],
													[
														0,
														0.022
													],
													[
														-0.001,
														0.068
													],
													[
														0,
														0
													],
													[
														0,
														0.106
													],
													[
														0,
														0
													],
													[
														44.112,
														0
													],
													[
														0,
														0
													],
													[
														0,
														-44.113
													],
													[
														0,
														0
													],
													[
														-44.112,
														0
													],
													[
														0,
														0
													],
													[
														-0.047,
														0
													],
													[
														-0.063,
														0.001
													],
													[
														0,
														0
													],
													[
														0,
														44.112
													]
												],
												"o": [
													[
														-11.046,
														0
													],
													[
														0,
														22.056
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0.195,
														0.236
													],
													[
														0,
														0
													],
													[
														0.024,
														0.027
													],
													[
														1.821,
														1.989
													],
													[
														2.378,
														1.112
													],
													[
														0.051,
														0.002
													],
													[
														0.009,
														0
													],
													[
														1.429,
														0.036
													],
													[
														0,
														0
													],
													[
														0.063,
														-0.012
													],
													[
														0.024,
														-0.005
													],
													[
														0.054,
														-0.011
													],
													[
														0.03,
														-0.007
													],
													[
														0.05,
														-0.011
													],
													[
														0.035,
														-0.008
													],
													[
														0.044,
														-0.01
													],
													[
														0.038,
														-0.009
													],
													[
														0.041,
														-0.01
													],
													[
														0.038,
														-0.01
													],
													[
														0.042,
														-0.011
													],
													[
														0.038,
														-0.01
													],
													[
														0,
														0
													],
													[
														0.041,
														-0.012
													],
													[
														0.04,
														-0.011
													],
													[
														0.032,
														-0.009
													],
													[
														0.049,
														-0.015
													],
													[
														0.027,
														-0.008
													],
													[
														0.05,
														-0.015
													],
													[
														0.03,
														-0.01
													],
													[
														0.049,
														-0.016
													],
													[
														0.023,
														-0.008
													],
													[
														0.055,
														-0.019
													],
													[
														0.021,
														-0.007
													],
													[
														0.057,
														-0.019
													],
													[
														0.018,
														-0.007
													],
													[
														0.062,
														-0.023
													],
													[
														0,
														0
													],
													[
														0.068,
														-0.026
													],
													[
														0.004,
														-0.001
													],
													[
														0.073,
														-0.029
													],
													[
														0.889,
														-0.362
													],
													[
														0.012,
														-0.007
													],
													[
														0.057,
														-0.034
													],
													[
														1.078,
														-0.654
													],
													[
														0.017,
														-0.014
													],
													[
														0.015,
														-0.014
													],
													[
														2.005,
														-1.829
													],
													[
														1.115,
														-2.387
													],
													[
														0.001,
														-0.037
													],
													[
														0,
														-0.023
													],
													[
														0.001,
														-0.068
													],
													[
														0,
														0
													],
													[
														0.001,
														-0.105
													],
													[
														0,
														0
													],
													[
														0,
														-44.112
													],
													[
														0,
														0
													],
													[
														-44.112,
														0
													],
													[
														0,
														0
													],
													[
														0,
														44.112
													],
													[
														0,
														0
													],
													[
														0.047,
														0
													],
													[
														0.063,
														0
													],
													[
														0,
														0
													],
													[
														44.112,
														0
													],
													[
														0,
														-11.047
													]
												],
												"v": [
													[
														236,
														120
													],
													[
														216,
														140
													],
													[
														176,
														180
													],
													[
														23.335,
														180
													],
													[
														-22.65,
														120.344
													],
													[
														122.497,
														-64.274
													],
													[
														220.563,
														52.717
													],
													[
														221.163,
														53.411
													],
													[
														221.184,
														53.435
													],
													[
														221.258,
														53.516
													],
													[
														227.534,
														58.125
													],
													[
														235.322,
														59.987
													],
													[
														235.475,
														59.992
													],
													[
														235.501,
														59.992
													],
													[
														239.777,
														59.643
													],
													[
														239.83,
														59.633
													],
													[
														240.018,
														59.596
													],
													[
														240.094,
														59.58
													],
													[
														240.256,
														59.546
													],
													[
														240.346,
														59.526
													],
													[
														240.493,
														59.492
													],
													[
														240.597,
														59.468
													],
													[
														240.729,
														59.437
													],
													[
														240.842,
														59.409
													],
													[
														240.966,
														59.378
													],
													[
														241.079,
														59.348
													],
													[
														241.204,
														59.315
													],
													[
														241.318,
														59.284
													],
													[
														241.436,
														59.252
													],
													[
														241.558,
														59.217
													],
													[
														241.676,
														59.182
													],
													[
														241.773,
														59.154
													],
													[
														241.92,
														59.109
													],
													[
														242,
														59.083
													],
													[
														242.149,
														59.036
													],
													[
														242.239,
														59.007
													],
													[
														242.387,
														58.958
													],
													[
														242.456,
														58.935
													],
													[
														242.622,
														58.878
													],
													[
														242.685,
														58.855
													],
													[
														242.854,
														58.794
													],
													[
														242.908,
														58.775
													],
													[
														243.092,
														58.706
													],
													[
														243.123,
														58.694
													],
													[
														243.327,
														58.615
													],
													[
														243.339,
														58.609
													],
													[
														243.558,
														58.521
													],
													[
														246.161,
														57.229
													],
													[
														246.197,
														57.208
													],
													[
														246.368,
														57.105
													],
													[
														249.389,
														54.855
													],
													[
														249.439,
														54.811
													],
													[
														249.484,
														54.77
													],
													[
														254.127,
														48.458
													],
													[
														255.988,
														40.641
													],
													[
														255.991,
														40.534
													],
													[
														255.992,
														40.466
													],
													[
														255.996,
														40.26
													],
													[
														255.996,
														40.255
													],
													[
														255.997,
														39.939
													],
													[
														255.997,
														-140
													],
													[
														175.997,
														-220
													],
													[
														-176,
														-220
													],
													[
														-256,
														-140
													],
													[
														-256,
														140
													],
													[
														-176,
														220
													],
													[
														13.374,
														220
													],
													[
														13.515,
														220.001
													],
													[
														13.703,
														220
													],
													[
														176,
														220
													],
													[
														256,
														140
													]
												]
											},
											"ix": 2
										}
									},
									{
										"ty": "mm",
										"nm": "Merge Paths 1",
										"mm": 1
									},
									{
										"ty": "fl",
										"nm": "Fill 1",
										"c": {
											"a": 0,
											"k": [
												0.161,
												0.835,
												0.604
											],
											"ix": 4,
											"x": "var $bm_rt;\n$bm_rt = content('image frame').content('sun').content('Fill 1').color;"
										},
										"r": 1,
										"o": {
											"a": 0,
											"k": 100,
											"ix": 5
										}
									},
									{
										"ty": "tr",
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"p": {
											"a": 0,
											"k": [
												256,
												256
											],
											"ix": 2
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										}
									}
								]
							},
							{
								"ty": "tr",
								"a": {
									"a": 0,
									"k": [
										256,
										256.001
									],
									"ix": 1
								},
								"s": {
									"a": 0,
									"k": [
										100,
										100
									],
									"ix": 3
								},
								"sk": {
									"a": 0,
									"k": 0,
									"ix": 4
								},
								"p": {
									"a": 0,
									"k": [
										256,
										256.001
									],
									"ix": 2
								},
								"r": {
									"a": 0,
									"k": 0,
									"ix": 6
								},
								"sa": {
									"a": 0,
									"k": 0,
									"ix": 5
								},
								"o": {
									"a": 0,
									"k": 100,
									"ix": 7
								}
							}
						]
					}
				],
				"ind": 3
			},
			{
				"ty": 4,
				"nm": "image",
				"sr": 1,
				"st": 0,
				"op": 150,
				"ip": 0,
				"hasMask": false,
				"ao": 0,
				"ks": {
					"a": {
						"a": 0,
						"k": [
							256,
							256,
							0
						],
						"ix": 1
					},
					"s": {
						"a": 0,
						"k": [
							100,
							100,
							100
						],
						"ix": 6
					},
					"sk": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [
							600,
							600,
							0
						],
						"ix": 2
					},
					"r": {
						"a": 0,
						"k": 0,
						"ix": 10
					},
					"sa": {
						"a": 0,
						"k": 0
					},
					"o": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.167,
									"y": 0.167
								},
								"i": {
									"x": 0.833,
									"y": 0.833
								},
								"s": [
									15
								],
								"t": 80
							},
							{
								"s": [
									5
								],
								"t": 90
							}
						],
						"ix": 11
					}
				},
				"ef": [],
				"shapes": [
					{
						"ty": "gr",
						"nm": "image frame",
						"ix": 1,
						"cix": 2,
						"it": [
							{
								"ty": "gr",
								"nm": "sun",
								"ix": 1,
								"cix": 2,
								"it": [
									{
										"ty": "sh",
										"nm": "Path 1",
										"ix": 1,
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														-11.028,
														0
													],
													[
														0,
														-11.028
													],
													[
														11.028,
														0
													],
													[
														0,
														11.028
													]
												],
												"o": [
													[
														11.028,
														0
													],
													[
														0,
														11.028
													],
													[
														-11.028,
														0
													],
													[
														0,
														-11.028
													]
												],
												"v": [
													[
														0,
														-20
													],
													[
														20,
														0
													],
													[
														0,
														20
													],
													[
														-20,
														0
													]
												]
											},
											"ix": 2
										}
									},
									{
										"ty": "sh",
										"nm": "Path 2",
										"ix": 2,
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														-33.084,
														0
													],
													[
														0,
														33.084
													],
													[
														33.084,
														0
													],
													[
														0,
														-33.084
													]
												],
												"o": [
													[
														33.084,
														0
													],
													[
														0,
														-33.084
													],
													[
														-33.084,
														0
													],
													[
														0,
														33.084
													]
												],
												"v": [
													[
														0,
														60
													],
													[
														60,
														0
													],
													[
														0,
														-60
													],
													[
														-60,
														0
													]
												]
											},
											"ix": 2
										}
									},
									{
										"ty": "mm",
										"nm": "Merge Paths 1",
										"mm": 1
									},
									{
										"ty": "fl",
										"nm": "Fill 1",
										"c": {
											"a": 0,
											"k": [
												0.11,
												0.11,
												0.11
											],
											"ix": 4
										},
										"r": 1,
										"o": {
											"a": 0,
											"k": 100,
											"ix": 5
										}
									},
									{
										"ty": "tr",
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"p": {
											"a": 0,
											"k": [
												140,
												168
											],
											"ix": 2
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										}
									}
								]
							},
							{
								"ty": "gr",
								"nm": "image",
								"ix": 2,
								"cix": 2,
								"it": [
									{
										"ty": "sh",
										"nm": "Path 1",
										"ix": 1,
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														0,
														0
													],
													[
														0,
														22.056
													],
													[
														0,
														0
													],
													[
														-22.056,
														0
													],
													[
														0,
														0
													],
													[
														0,
														-22.056
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														6.037,
														-0.091
													],
													[
														3.723,
														-4.736
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														6.202,
														0
													],
													[
														0,
														0
													],
													[
														3.784,
														-4.919
													],
													[
														0,
														0
													],
													[
														-8.755,
														-6.735
													],
													[
														-6.734,
														8.755
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"o": [
													[
														-22.056,
														0
													],
													[
														0,
														0
													],
													[
														0,
														-22.056
													],
													[
														0,
														0
													],
													[
														22.056,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-3.87,
														-4.618
													],
													[
														-6.024,
														0.094
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-3.786,
														-4.913
													],
													[
														0,
														0
													],
													[
														-6.206,
														0.003
													],
													[
														0,
														0
													],
													[
														-6.734,
														8.755
													],
													[
														8.757,
														6.735
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													]
												],
												"v": [
													[
														-176,
														180
													],
													[
														-216,
														140
													],
													[
														-216,
														-140
													],
													[
														-176,
														-180
													],
													[
														176,
														-180
													],
													[
														216,
														-140
													],
													[
														216,
														-14.993
													],
													[
														137.327,
														-108.848
													],
													[
														121.687,
														-115.998
													],
													[
														106.278,
														-108.362
													],
													[
														-47.84,
														87.664
													],
													[
														-100.16,
														19.789
													],
													[
														-116,
														11.999
													],
													[
														-116.01,
														11.999
													],
													[
														-131.853,
														19.805
													],
													[
														-175.868,
														77.023
													],
													[
														-172.21,
														105.07
													],
													[
														-144.163,
														101.413
													],
													[
														-115.984,
														64.78
													],
													[
														-27.168,
														180
													]
												]
											},
											"ix": 2
										}
									},
									{
										"ty": "sh",
										"nm": "Path 2",
										"ix": 2,
										"d": 1,
										"ks": {
											"a": 0,
											"k": {
												"c": true,
												"i": [
													[
														11.046,
														0
													],
													[
														0,
														-11.046
													],
													[
														22.056,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														-0.205,
														-0.226
													],
													[
														0,
														0
													],
													[
														-0.025,
														-0.027
													],
													[
														-2.315,
														-1.079
													],
													[
														-2.776,
														-0.092
													],
													[
														-0.051,
														-0.001
													],
													[
														-0.008,
														-0.001
													],
													[
														-1.413,
														0.27
													],
													[
														0,
														0
													],
													[
														-0.064,
														0.013
													],
													[
														-0.026,
														0.005
													],
													[
														-0.054,
														0.012
													],
													[
														-0.03,
														0.007
													],
													[
														-0.049,
														0.011
													],
													[
														-0.034,
														0.009
													],
													[
														-0.043,
														0.01
													],
													[
														-0.038,
														0.009
													],
													[
														-0.041,
														0.01
													],
													[
														-0.038,
														0.01
													],
													[
														-0.042,
														0.011
													],
													[
														-0.038,
														0.01
													],
													[
														0,
														0
													],
													[
														-0.04,
														0.011
													],
													[
														-0.039,
														0.011
													],
													[
														-0.033,
														0.01
													],
													[
														-0.048,
														0.015
													],
													[
														-0.026,
														0.008
													],
													[
														-0.05,
														0.016
													],
													[
														-0.03,
														0.01
													],
													[
														-0.049,
														0.016
													],
													[
														-0.023,
														0.007
													],
													[
														-0.055,
														0.018
													],
													[
														-0.021,
														0.008
													],
													[
														-0.056,
														0.021
													],
													[
														-0.018,
														0.007
													],
													[
														-0.061,
														0.023
													],
													[
														0,
														0
													],
													[
														-0.068,
														0.027
													],
													[
														-0.004,
														0.002
													],
													[
														-0.073,
														0.031
													],
													[
														-0.844,
														0.499
													],
													[
														-0.012,
														0.007
													],
													[
														-0.057,
														0.035
													],
													[
														-0.932,
														0.842
													],
													[
														-0.017,
														0.015
													],
													[
														-0.015,
														0.013
													],
													[
														-1.085,
														2.33
													],
													[
														-0.088,
														2.788
													],
													[
														-0.001,
														0.036
													],
													[
														0,
														0.022
													],
													[
														-0.001,
														0.068
													],
													[
														0,
														0
													],
													[
														0,
														0.106
													],
													[
														0,
														0
													],
													[
														44.112,
														0
													],
													[
														0,
														0
													],
													[
														0,
														-44.113
													],
													[
														0,
														0
													],
													[
														-44.112,
														0
													],
													[
														0,
														0
													],
													[
														-0.047,
														0
													],
													[
														-0.063,
														0.001
													],
													[
														0,
														0
													],
													[
														0,
														44.112
													]
												],
												"o": [
													[
														-11.046,
														0
													],
													[
														0,
														22.056
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0,
														0
													],
													[
														0.195,
														0.236
													],
													[
														0,
														0
													],
													[
														0.024,
														0.027
													],
													[
														1.821,
														1.989
													],
													[
														2.378,
														1.112
													],
													[
														0.051,
														0.002
													],
													[
														0.009,
														0
													],
													[
														1.429,
														0.036
													],
													[
														0,
														0
													],
													[
														0.063,
														-0.012
													],
													[
														0.024,
														-0.005
													],
													[
														0.054,
														-0.011
													],
													[
														0.03,
														-0.007
													],
													[
														0.05,
														-0.011
													],
													[
														0.035,
														-0.008
													],
													[
														0.044,
														-0.01
													],
													[
														0.038,
														-0.009
													],
													[
														0.041,
														-0.01
													],
													[
														0.038,
														-0.01
													],
													[
														0.042,
														-0.011
													],
													[
														0.038,
														-0.01
													],
													[
														0,
														0
													],
													[
														0.041,
														-0.012
													],
													[
														0.04,
														-0.011
													],
													[
														0.032,
														-0.009
													],
													[
														0.049,
														-0.015
													],
													[
														0.027,
														-0.008
													],
													[
														0.05,
														-0.015
													],
													[
														0.03,
														-0.01
													],
													[
														0.049,
														-0.016
													],
													[
														0.023,
														-0.008
													],
													[
														0.055,
														-0.019
													],
													[
														0.021,
														-0.007
													],
													[
														0.057,
														-0.019
													],
													[
														0.018,
														-0.007
													],
													[
														0.062,
														-0.023
													],
													[
														0,
														0
													],
													[
														0.068,
														-0.026
													],
													[
														0.004,
														-0.001
													],
													[
														0.073,
														-0.029
													],
													[
														0.889,
														-0.362
													],
													[
														0.012,
														-0.007
													],
													[
														0.057,
														-0.034
													],
													[
														1.078,
														-0.654
													],
													[
														0.017,
														-0.014
													],
													[
														0.015,
														-0.014
													],
													[
														2.005,
														-1.829
													],
													[
														1.115,
														-2.387
													],
													[
														0.001,
														-0.037
													],
													[
														0,
														-0.023
													],
													[
														0.001,
														-0.068
													],
													[
														0,
														0
													],
													[
														0.001,
														-0.105
													],
													[
														0,
														0
													],
													[
														0,
														-44.112
													],
													[
														0,
														0
													],
													[
														-44.112,
														0
													],
													[
														0,
														0
													],
													[
														0,
														44.112
													],
													[
														0,
														0
													],
													[
														0.047,
														0
													],
													[
														0.063,
														0
													],
													[
														0,
														0
													],
													[
														44.112,
														0
													],
													[
														0,
														-11.047
													]
												],
												"v": [
													[
														236,
														120
													],
													[
														216,
														140
													],
													[
														176,
														180
													],
													[
														23.335,
														180
													],
													[
														-22.65,
														120.344
													],
													[
														122.497,
														-64.274
													],
													[
														220.563,
														52.717
													],
													[
														221.163,
														53.411
													],
													[
														221.184,
														53.435
													],
													[
														221.258,
														53.516
													],
													[
														227.534,
														58.125
													],
													[
														235.322,
														59.987
													],
													[
														235.475,
														59.992
													],
													[
														235.501,
														59.992
													],
													[
														239.777,
														59.643
													],
													[
														239.83,
														59.633
													],
													[
														240.018,
														59.596
													],
													[
														240.094,
														59.58
													],
													[
														240.256,
														59.546
													],
													[
														240.346,
														59.526
													],
													[
														240.493,
														59.492
													],
													[
														240.597,
														59.468
													],
													[
														240.729,
														59.437
													],
													[
														240.842,
														59.409
													],
													[
														240.966,
														59.378
													],
													[
														241.079,
														59.348
													],
													[
														241.204,
														59.315
													],
													[
														241.318,
														59.284
													],
													[
														241.436,
														59.252
													],
													[
														241.558,
														59.217
													],
													[
														241.676,
														59.182
													],
													[
														241.773,
														59.154
													],
													[
														241.92,
														59.109
													],
													[
														242,
														59.083
													],
													[
														242.149,
														59.036
													],
													[
														242.239,
														59.007
													],
													[
														242.387,
														58.958
													],
													[
														242.456,
														58.935
													],
													[
														242.622,
														58.878
													],
													[
														242.685,
														58.855
													],
													[
														242.854,
														58.794
													],
													[
														242.908,
														58.775
													],
													[
														243.092,
														58.706
													],
													[
														243.123,
														58.694
													],
													[
														243.327,
														58.615
													],
													[
														243.339,
														58.609
													],
													[
														243.558,
														58.521
													],
													[
														246.161,
														57.229
													],
													[
														246.197,
														57.208
													],
													[
														246.368,
														57.105
													],
													[
														249.389,
														54.855
													],
													[
														249.439,
														54.811
													],
													[
														249.484,
														54.77
													],
													[
														254.127,
														48.458
													],
													[
														255.988,
														40.641
													],
													[
														255.991,
														40.534
													],
													[
														255.992,
														40.466
													],
													[
														255.996,
														40.26
													],
													[
														255.996,
														40.255
													],
													[
														255.997,
														39.939
													],
													[
														255.997,
														-140
													],
													[
														175.997,
														-220
													],
													[
														-176,
														-220
													],
													[
														-256,
														-140
													],
													[
														-256,
														140
													],
													[
														-176,
														220
													],
													[
														13.374,
														220
													],
													[
														13.515,
														220.001
													],
													[
														13.703,
														220
													],
													[
														176,
														220
													],
													[
														256,
														140
													]
												]
											},
											"ix": 2
										}
									},
									{
										"ty": "mm",
										"nm": "Merge Paths 1",
										"mm": 1
									},
									{
										"ty": "fl",
										"nm": "Fill 1",
										"c": {
											"a": 0,
											"k": [
												0.11,
												0.11,
												0.11
											],
											"ix": 4
										},
										"r": 1,
										"o": {
											"a": 0,
											"k": 100,
											"ix": 5
										}
									},
									{
										"ty": "tr",
										"a": {
											"a": 0,
											"k": [
												0,
												0
											],
											"ix": 1
										},
										"s": {
											"a": 0,
											"k": [
												100,
												100
											],
											"ix": 3
										},
										"sk": {
											"a": 0,
											"k": 0,
											"ix": 4
										},
										"p": {
											"a": 0,
											"k": [
												256,
												256
											],
											"ix": 2
										},
										"r": {
											"a": 0,
											"k": 0,
											"ix": 6
										},
										"sa": {
											"a": 0,
											"k": 0,
											"ix": 5
										},
										"o": {
											"a": 0,
											"k": 100,
											"ix": 7
										}
									}
								]
							},
							{
								"ty": "tr",
								"a": {
									"a": 0,
									"k": [
										256,
										256.001
									],
									"ix": 1
								},
								"s": {
									"a": 0,
									"k": [
										100,
										100
									],
									"ix": 3
								},
								"sk": {
									"a": 0,
									"k": 0,
									"ix": 4
								},
								"p": {
									"a": 0,
									"k": [
										256,
										256.001
									],
									"ix": 2
								},
								"r": {
									"a": 0,
									"k": 0,
									"ix": 6
								},
								"sa": {
									"a": 0,
									"k": 0,
									"ix": 5
								},
								"o": {
									"a": 0,
									"k": 100,
									"ix": 7
								}
							}
						]
					}
				],
				"ind": 4
			}
		],
		"v": "5.3.4",
		"fr": 60,
		"op": 90,
		"ip": 0,
		"assets": []
	};

/***/ }),
/* 5357 */
/***/ (function(module, exports) {

	module.exports = {
		"general.formats.dayFormattingPattern": "MMMM DD, YYYY",
		"general.formats.datePatternAPI": "YYYY-MM-DD",
		"general.formats.datePatternUI": "MM-DD-YYYY",
		"general.formats.shortDatePattern": "MMM DD",
		"general.formats.fullShortDatePattern": "MMM DD, YYYY",
		"general.formats.timePattern": "hh:mm a",
		"general.title": "{brandName}",
		"general.description": "Healthcare delivery outside of hospital",
		"general.slogan.primary": "The global network for patient engagement",
		"general.slogan.secondary": "Patient engagement - anywhere, anytime",
		"general.labels.you": "(You)",
		"general.labels.or": "or",
		"general.labels.me": "Me",
		"general.labels.YO": "y.o.",
		"general.labels.noInternet": "No internet connection",
		"general.labels.myProfile": "My profile",
		"general.labels.profile": "Profile",
		"general.labels.profiles": "Profiles",
		"general.labels.backToInvitation": "Back to invitation process",
		"general.labels.userNameExample": "JohnDoe_123 or Wolverine",
		"general.labels.userNameExplanation": "Nickname is an alias that will be used to identify yourself in your postings. Be creative if you prefer to be anonymous.",
		"general.labels.pickItemLeft": "Pick an item you’d like to view in the left sidebar",
		"general.errors.404": "Oops! There is nothing to see here.",
		"general.toTop": "Go to the top",
		"general.success": "Success",
		"general.completed": "Completed",
		"general.todo": "To Do",
		"general.removedFromChat": "You’ve been deleted from this chat",
		"general.viewOnMap": "View on the map",
		"general.addToCalendar": "Add to calendar",
		"general.search.placeholder": "Search...",
		"general.search.patients": "Search patients...",
		"general.search.tabs.people": "Add People",
		"general.search.tabs.teams": "Add Teams",
		"general.search.tabs.providers": "Add Proiders",
		"general.search.searchByPeopleUsername": "Search people by their username…",
		"general.search.noOneFound": "No one found",
		"pages.title.messages": "Messaging",
		"pages.title.virtualRoom": "Virtual Room",
		"pages.title.accessDenied": "Access Denied",
		"pages.title.expiredToken": "Expired Token",
		"pages.title.expiredLink": "Expired Link",
		"pages.title.expiredConfirmation": "Expired Confirmation",
		"pages.title.login": "Login",
		"pages.title.signup": "Sign Up",
		"pages.title.signupInvite": "Sign Up Invitation",
		"pages.title.signupAzure": "Sign Up (Azure)",
		"pages.title.recoverPassword": "Recover Password",
		"pages.title.changePassword": "Change Password",
		"pages.title.createPassword": "Create Password",
		"pages.title.circleOfCare": "Circle of Care",
		"pages.title.programs": "Programs",
		"pages.title.surveys": "Surveys",
		"pages.title.circles": "Circles",
		"pages.title.notifications": "Notifications",
		"pages.title.communities": "Communities",
		"pages.title.publicProfile": "Public Profile",
		"pages.title.healthboard": "Healthboard",
		"pages.title.home": "Home",
		"pages.title.homeTodos": "Home | Todo List",
		"pages.title.homeAppointments": "Home | Appointment List",
		"pages.title.dependentRole": "Add Dependent | Role",
		"pages.title.dependentPersonal": "Add Dependent | Personal Info",
		"pages.title.dependentGeneral": "Add Dependent | General Info",
		"pages.title.dependentDocuments": "Add Dependent | Documents",
		"pages.title.dependentRelation": "Add Dependent | Relationship",
		"pages.title.getCare.users": "Get Care | Who needs care?",
		"pages.title.getCare.organization": "Get Care | Choose Organization",
		"pages.title.getCare.visitType": "Get Care | Visit Type",
		"pages.title.getCare.publix": "Get Care | Publix",
		"pages.title.getCare.servces": "Get Care | Services",
		"pages.title.getCare.locations": "Get Care | Locations",
		"pages.title.getCare.consent": "Get Care | Sign Consent Form",
		"pages.title.getCare.pharm": "Get Care | Preferred Pharmacy",
		"pages.title.getCare.health": "Get Care | Health Information",
		"pages.title.getCare.payment": "Get Care | Payment",
		"pages.title.getCare.patientInfo": "Get Care | Patient Info",
		"pages.title.getCare.insurance": "Get Care | Insurance",
		"pages.title.getCare.documents": "Get Care | Documents",
		"pages.title.getCare.details": "Get Care | Visit Details",
		"pages.title.getCare.providers": "Get Care | Available Providers",
		"pages.title.getCare.timeSlots": "Get Care | Available Time Slots",
		"pages.title.getCare.providerInfo": "Get Care | Provider Details",
		"pages.title.getCare.overview": "Get Care | Appointment Overview",
		"pages.title.getCare.emergencyContact": "Get Care | Emergency Contact",
		"pages.title.getCare.guarantorInformation": "Get Care | Guarantor information",
		"pages.title.getCare.additionalInfo": "Get Care | Additional Information",
		"pages.title.visitDetails": "Visit Details",
		"pages.title.profile.surveys": "Profile | Surveys",
		"pages.title.profile.documents": "Profile | Documentation",
		"pages.title.profile.settings": "Profile | Settings",
		"pages.title.profile.payment": "Profile | Payment Methods",
		"pages.title.profile.support": "Profile | Support",
		"pages.title.profile.patientInfo": "Profile | Patient Info",
		"pages.title.profile.details": "Profile | Details",
		"common.blank": " ",
		"common.patient": "Patient",
		"common.settings": "Settings",
		"common.remove": "Remove",
		"common.apply": "Apply",
		"common.joinVisit": "Join Visit",
		"common.addPatient": "Add patient",
		"common.unassign": "Unassign",
		"common.assign": "Assign",
		"common.accept": "Accept",
		"common.decline": "Decline",
		"common.back": "Back",
		"common.cancel": "Cancel",
		"common.confirm": "Confirm",
		"common.save": "Save",
		"common.invite": "Send invitation",
		"common.send": "Send",
		"common.terms": "Terms and conditions",
		"common.termOfUse": "Terms of Use",
		"common.yes": "Yes",
		"common.gotIt": "Got it",
		"common.saveAnyway": "Save anyway",
		"common.ok": "Ok",
		"common.add": "Add",
		"common.no": "No",
		"common.preferNotToSay": "Prefer not to say",
		"common.close": "Close",
		"common.clear": "Clear",
		"common.tryAgain": "Try again",
		"common.collapse": "Collapse",
		"common.readMore": "Read more",
		"common.myMessages": "My Messages",
		"common.myCommunities": "My Communities",
		"common.myHealthboard": "My Healthboard",
		"common.discover": "Discover",
		"common.activities": "Activities",
		"common.reports": "Reports",
		"common.optional": "(optional)",
		"common.privacy": "Privacy Policy",
		"common.currentMedications": "Current medications",
		"common.from": "From",
		"common.to": "To",
		"common.notifications": "Notifications",
		"common.allow": "Allow",
		"common.deny": "Deny",
		"common.by": "by",
		"common.denied": "Denied",
		"common.verified": "Verified",
		"common.copy": "Copy",
		"common.likes": "Likes",
		"common.comments": "Comments",
		"common.resolve": "Resolve",
		"common.new": "New",
		"common.leave": "Leave",
		"common.emptySection": "Section is empty.",
		"common.next": "Next",
		"common.description": "Description",
		"common.complete": "Complete",
		"common.goBack": "Go back",
		"common.changeRole": "Change Role",
		"common.removeMember": "Remove member",
		"common.today": "Today",
		"common.confirmed": "Confirmed",
		"common.other": "Other",
		"common.searchByName": "Search by Name",
		"common.date": "Date",
		"common.phone": "Phone",
		"common.documents": "Documents",
		"common.my": "My",
		"common.pending": "Pending",
		"common.category": "Category",
		"common.subCategory": "Subcategory",
		"common.delete": "Delete",
		"common.hours": "Hours",
		"common.skip": "Skip",
		"common.ID": "ID",
		"common.resendCode": "Resend code",
		"common.resendInvite": "Resend Invite",
		"common.overlap": "Overlap",
		"common.seeDetails": "See details.",
		"common.hidden": "Hidden",
		"common.onlyVisibleToYou": "Only visible to you",
		"common.connect": "Connect",
		"common.join": "Join",
		"common.version": "Version",
		"common.program": "Program",
		"common.for": "for",
		"common.none": "None",
		"common.expired": "Expired",
		"common.moreInfo": "More info",
		"common.important": "Important",
		"common.changeTime": "Change time",
		"common.visit": "Visit",
		"common.call": "Call",
		"common.prescriptions": "Prescriptions",
		"common.showInactiveMedictions": "Show Inactive",
		"common.phoneNumber": "Phone Number",
		"common.urgentCareVisit": "Urgent Care Visit",
		"common.submit": "Submit",
		"common.selfPay": "Self-pay",
		"common.selectOption": "Select an option",
		"common.addInsurance": "Add insurance",
		"common.deleteInsurance": "Delete insurance",
		"common.startTyping": "Start typing",
		"common.myPcpNotListed": "My PCP isn't listed",
		"common.myEmployerNotListed": "Employer isn't listed",
		"common.expDate": "Exp Date",
		"common.saving": "Saving...",
		"common.seeLessDetails": "See less details",
		"common.seeMoreDetails": "See more details",
		"common.requiredInformationMissing": "Required information is missing",
		"menu.healthboard": "Healthboard",
		"menu.myCircles": "My Circles",
		"menu.communities": "Communities",
		"menu.dashboard": "Dashboard",
		"menu.messages": "Messaging",
		"menu.home": "Home",
		"messages.chat.enterUsernameOrName": "Enter the username or name of a user you’d like to begin a conversation with",
		"messages.chat.searchForUser": "Search for user or team you’d like to begin a conversation with.",
		"messages.chat.newChat": "New chat",
		"messages.chat.findAMember": "Find a member",
		"messages.chat.youAddedMembers": "You added {counter} {counter, plural, one {member} other {members}}",
		"messages.chat.counterMembers": "{counter} {counter, plural, one {member} other {members}}",
		"messages.chat.startANewConversationInTheContextOf": "Start a new conversation in the context of {user}",
		"messages.chat.startANewConversationInTheContextOfDesc": "People listed below are in the Circle of Care and you can add others not in Circles by searching",
		"messages.chat.startANewConversation": "Start a new conversation",
		"messages.chat.start": "Start",
		"messages.chat.noOneFound": "No one found",
		"messages.chat.empty.messages": "You have no messages",
		"messages.chat.empty.users": "No users to chat",
		"messages.chat.empty.channels": "No channels to connect",
		"messages.chat.searchAUser": "Search for a user...",
		"messages.chat.defaultUser": "ENTER THE USERNAME OR NAME OF A USER YOU’D LIKE TO ADD TO THE CHAT",
		"messages.userProfile.familyMembers": "Family members",
		"messages.userProfile.programServiceProviders": "Program/Service providers",
		"messages.userProfile.singleProvider": "Single care provider",
		"messages.userProfile.mainProvider": "Main care provider",
		"messages.userProfile.memberProviderCircle": "Member",
		"messages.titles.familyTitleWithCounter": "Family Circle ({counter})",
		"messages.titles.providerTitleWithCounter": "Provider Circle ({counter})",
		"messages.nav.tabs.patient": "General User",
		"messages.nav.tabs.provider": "Provider",
		"messages.filterOptions.allPatients": "All Patients",
		"messages.filterOptions.myPatients": "My Patients",
		"messages.statusFilterOptions.all": "All",
		"messages.statusFilterOptions.joined": "Joined",
		"messages.statusFilterOptions.notJoined": "Not Joined",
		"messages.patientNotJoined.message": "Patient has not joined yet.",
		"messages.patientOrGuardianNotJoined": "Patient or Guardian has not joined yet.",
		"messages.patientNotJoined.resend": "Resend an Invitation",
		"messages.patientNotJoined.invite": "Send an Invitation",
		"messages.patientNotJoined.inviteSent": "Invitation sent",
		"messages.patientNotJoined.checkContactInformationText": "Please confirm patient's contact details before sending invite",
		"messages.patientNotJoined.inviteTitle": "Invite Patient",
		"messages.patientNotJoined.errors.emailAlreadyTaken": "Email already used, please provide another",
		"messages.patientNotJoined.errors.emailInvalid": "Email is invalid, please provide another",
		"messages.patientNotJoined.errors.emailBlank": "Email can't be blank",
		"messages.patientNotJoined.errors.phoneNumberAlreadyTaken": "Phone number already used, please provide another",
		"messages.patientNotJoined.errors.phoneNumberBlank": "Phone number can't be blank",
		"messages.patientNotJoined.errors.phoneNumberInvalid": "Phone number is invalid",
		"messages.titles.accessLevel": "Access level",
		"messages.titles.accessLevelTooltip": "Temporary Access will be kept within current session only. Session timeout is 30 minutes since the last activity.",
		"messages.titles.reasonForAssignment": "Reason for assignment",
		"messages.titles.selectReasonForAssignment": "Select a reason for assignment",
		"messages.titles.practiceRemoved": "You can’t message because Practice has been removed",
		"messages.titles.practiceEmpty": "You can’t message because Practice has no assigned Providers",
		"messages.titles.archivedChat": "You can’t message because chat has been archived",
		"messages.titles.hasPractice": "You can’t message because Patient has been removed from Practice",
		"messages.call.missedCall": "Missed Call",
		"messages.call.outgoingCall": "Outgoing Call",
		"messages.call.declinedCall": "Declined Call",
		"messages.call.cancelledCall": "Canceled Call",
		"messages.call.incomingCall": "Incoming Call",
		"relationshipPriority.title": "Assign the relationship priority",
		"relationshipPriority.subtitle": "Select a relationship priority",
		"circles.circle": "Circle",
		"circles.circleOfCare": "Circle of Care",
		"circles.circle.typedCircle": "{type} circle",
		"circle.assigned": "Provider/team has been assigned successfully",
		"circle.unassigned": "Provider/team has been unassigned successfully",
		"circle.confirmUnassigned": "Sorry, but you have been unassigned from this patient and have no more permissions to access this page.",
		"circle.notInCircle": "Not in {contextUser}’s Provider Circle",
		"circles.empty": "You have no circles",
		"circles.empty.navigation": "No circles to browse",
		"circles.invites.cancelInvite": "Cancel invitation",
		"circles.invites.confirmCancel": "Yes, I'm sure",
		"circles.invites.declineCancel": "No",
		"circles.invites.inviteSent": "Invitation sent",
		"circles.invites.invitedCaregiver": "Caregiver (pending)",
		"circles.invites.roleChanged": "The role has been changed",
		"circles.invites.family.success": "Family member invitation has been sent",
		"circles.invites.caregiver.success": "Caregiver invitation has been sent",
		"circles.invites.common.success": "Your invitation has been sent",
		"circles.invites.provider.success": "Provider/team has been assigned successfully",
		"circles.invites.family.accept": "You've joined family circle",
		"circles.invites.family.decline": "You've declined family circle invitation",
		"circles.invites.caregiver.accept": "You've accepted caregiver role",
		"circles.invites.caregiver.decline": "You've declined caregiver role",
		"circles.invites.guardian.accept": "You've accepted guardian/proxy role",
		"circles.invites.guardian.decline": "You've declined guardian/proxy role",
		"circles.invites.provider.leave.success": "Provider/team has been unassigned successfully",
		"circles.provider.remove": "Provider was removed from your provider circle",
		"circles.provider.leave": "You left provider circle",
		"circles.provider.alreadyAssigned": "Patient already assigned",
		"circles.invites.caregiver.error": "Invited user is already a Caregiver of the Patient",
		"circles.invites.guardian.error": "Invited user is already a Guardian of this Patient",
		"circles.invites.member.error": "Invited user is already a Family member of this Patient",
		"circles.invites.cares.error": "Invited user already Cares for this Patient",
		"circles.invites.title": "Invite member",
		"circles.invites.subtitle": "by email or phone",
		"circles.invites.text.family": "has consented to invite you to their Family Circle. As a member of Family Circle you will receive access to personal health information and will be able to communicate with other members in the family circle and also with healthcare providers.",
		"circles.invites.text.provider": "has consented to invite you to their Provider Circle. As a member of Provider Circle you will receive access to personal health information and will be able to communicate with other members in the provider circle and also with family members.",
		"circles.invites.text.caregiver": "wants to assign you a Caregiver role. As a Caregiver you will be able to answer surveys within {patient}'s programs, edit the profile and use the app on behalf of {patient}.",
		"circles.invites.text.ProviderInvitesCaregiver": "has invited you to be the caregiver for {patientName} in {brandName}. As a Caregiver you will be able to answer surveys on behalf of {patientName} and use {brandName} on behalf of {patientName}. You consent to be Caregiver for {patientName}.",
		"circles.invites.text.guardian": "wants to assign you as a Guardian. As a Guardian, you will be able to respond to surveys, edit the patient's profile, and use the system on behalf of {patient} (Patient).",
		"circles.invites.makeInviteToFamilyText": "As a member of your Family Circle the family member you are inviting will see all your health information and will be able to communicate with your family and Provider Circle.",
		"circles.invites.makeInviteToFamilyCommon": "Inviting a family member to join this Family Circle allows them to view Health Information and communicate within the Circle of Care.",
		"circles.invites.makeInviteProviderText": "As a member of your Provider Circle the provider member you are inviting will receive access to personal health information and will be able to communicate with other members in the provider circle and also with family members.",
		"circles.invites.makeInviteCaregiverText": "A Caregiver is given access to answering surveys, editing a profile, and using the system on a patient's behalf.",
		"circles.invites.makeInviteGuardianText": "Guardian/proxy is able to respond surveys within of patient`s programs, edit patient`s profile, use the system on behalf of the patient and manage patient`s insurance information.",
		"circles.invites.makeAssignRoleDescription": "The role assigned to this user will determine their Privacy and Security Settings within the Circle of Care.",
		"circles.invites.makeChangeRoleDescription": "Changing the role for this user may alter their Privacy and Security Settings within the Circle of Care.",
		"circles.invites.pending": "pending invitations",
		"circles.invites.caregiver": "Caregiver is able to respond surveys within of Patient's programs, edit Patient's profile and use system on behalf of Patient.",
		"circles.invites.invitePerson": "Inviting a person to join this Family Circle allows them to view Health Information and communicate within the Circle of Care.",
		"circles.titles.invitations": "Invitations",
		"circles.titles.listCaregiver": "You are caregiver for",
		"circles.titles.guardianFor": "You are guardian for",
		"circles.titles.familyMemberingCircle": "Your family circles",
		"circles.titles.listFamilyCircleMember": "Family circles",
		"circles.titles.listProviderMember": "You are provider circle member",
		"circles.titles.familyCircle": "",
		"circles.titles.providerCircle": "Provider circles",
		"circles.titles.primaryProviderProfileTitle": "My provider circle",
		"circles.titles.primaryPatientProfileTitle": "My family circle",
		"circles.titles.caregiverRole": "Caregiver",
		"circles.titles.careProvider": "Care Provider",
		"circles.titles.removeRole": "Remove role",
		"circles.titles.provider.assign": "Assign new Provider or Team to the Circle",
		"circles.family.removeQuestion": "Are you sure you want to remove this member?",
		"circles.family.remove": "User was removed from your family circle",
		"circles.family.leave": "You left family circle",
		"circles.family.cancelInvite.title": "Are you sure you want to cancel invitation to the family circle?",
		"circles.family.cancelInvite.text": "You are about to cancel the invitation to the family circle sent on email {login}. Once you cancel it, this person won't be able to accept it and join your family circle.",
		"circles.caregiver.cancelInvite.title": "Are you sure you want to cancel invitation to be a caregiver?",
		"circles.caregiver.cancelInvite.text": "You are about to cancel invitation of your {role} to be a caregiver. Once you cancel it, this person won't be able to accept it and become a caregiver.",
		"circles.actions.leave": "Leave the circle",
		"circles.actions.leaveBtn": "Leave circle",
		"circles.actions.makeCaregiver": "Assign caregiver role",
		"circles.actions.removeCaregiver": "Remove caregiver role",
		"circles.actions.removeFromCircle": "Remove from circle",
		"circles.actions.inviteProvider": "Invite provider member",
		"circles.actions.inviteFamily": "Invite family member",
		"circles.actions.assignGuardian": "Assign guardian/proxy role",
		"circles.actions.removeGuardian": "Remove guardian/proxy role",
		"circles.actions.assignRole": "Assign Role",
		"circles.leave.family.title": "Are you sure you want to leave circle?",
		"circles.leave.family.body": "You are about to leave {patient} Family circle. Also once you leave the circle you will no longer have access to or be able to view the healthboard of {patient}.",
		"circles.leave.provider.title": "Are you sure you want to leave circle?",
		"circles.leave.provider.body": "You are about to leave {provider} Provider circle. Also once you leave the circle you will no longer have access to personal health information of {provider}.",
		"circles.leave.guardian.title": "You were the one who can manage the {patient} account. Are you sure you want to remove the role?",
		"circles.leave.guardian.body": "If you want to be a Guardian/Proxy again please ask the Provider to assign you.",
		"circles.roles.spouse": "Spouse",
		"circles.roles.daughter": "Daughter",
		"circles.roles.son": "Son",
		"circles.roles.sister": "Sister",
		"circles.roles.brother": "Brother",
		"circles.roles.mother": "Mother",
		"circles.roles.father": "Father",
		"circles.roles.granddaughter": "Granddaughter",
		"circles.roles.grandson": "Grandson",
		"circles.roles.grandmother": "Grandmother",
		"circles.roles.grandfather": "Grandfather",
		"circles.roles.partner": "Partner",
		"circles.roles.guardian": "Guardian",
		"circles.roles.relative": "Relative",
		"circles.roles.friend": "Friend",
		"circles.roles.power_of_attorney": "Power Of Attorney",
		"circles.roles.patient": "Patient",
		"circles.roles.caregiver": "Caregiver",
		"circles.roles.left_the_circle": "Left the Circle",
		"circles.roles.single_care_provider": "Single Care Provider",
		"circles.roles.family_member": "Family Member",
		"circles.roles.proxy": "Proxy",
		"circles.roles.parent": "Parent",
		"circles.roles.guardianProxy": "Guardian/Proxy role",
		"circles.roles.guardianProxyShort": "Guardian/Proxy",
		"circles.roles.none": "None",
		"circles.roles.description.family_member": "A Family Member is able to view your health information and communicate with the Family Members and Providers in your Circle of Care.",
		"circles.roles.description.caregiver": "A Caregiver is able to view your health information, communicate with the Circle of Care, answer surveys, schedule visits, and edit a Patient’s profile.",
		"circles.roles.description.guardian": "A Guardian is given full access to a Patient’s profile to act and manage the system on the Patient’s Behalf. This role requires proper legal documentation to be reviewed and verified.",
		"circles.roles.description.proxy": "A Guardian is given full access to a Patient’s profile to act and manage the system on the Patient’s Behalf. This role requires proper legal documentation to be reviewed and verified.",
		"circles.roles.description.parent": "A parent is given full access to a Patient’s profile to act and manage the system on the Patient’s behalf. Access levels change dependent on age according to Federal Regulations.",
		"circles.roles.description.patient": "A patient is given full access to their profile to act and manage the system. Patient have the ability to invite other members to access the system on their behalf.",
		"circles.addProviderReason.temporaryTitle": "Temporary Access",
		"circles.addProviderReason.permanentTitle": "Permanent Assignment",
		"circles.addProviderReason.temporary.emergencyAccess": "Emergency access",
		"circles.addProviderReason.temporary.temporarilyAssigned": "Temporarily assigned to patient",
		"circles.addProviderReason.temporary.patientConsultation": "Patient consultation",
		"circles.addProviderReason.permanent.underTreatment": "Current patient under treatment",
		"circles.addProviderReason.permanent.patientRequest": "Patient request",
		"communities.empty.navigation": "No communities to browse",
		"communities.empty": "You have no communities",
		"communities.empty.activities": "You have no activities",
		"communities.title.member": "My Communities",
		"communities.title.moderator": "I am Moderator",
		"communities.title.fromOrganization": "From my Organizations",
		"communities.title.otherCommunities": "Other communities",
		"communities.title.seeAll": "See all",
		"communities.title.posts": "posts",
		"communities.title.joinRequests": "Join Requests",
		"communities.title.invites": "Invites",
		"communities.title.share": "Share this community",
		"communities.title.join": "Join {brandName} right away",
		"communities.title.signUpToJoin": "Sign up to join this community",
		"communities.title.seeNewPosts": "See new posts",
		"communities.title.requested": "Requested",
		"community.type.public": "Public",
		"community.type.private": "Private",
		"community.type.global": "Global",
		"community.access.readOnly": "Read Only",
		"community.pinnedPost": "Pinned post",
		"community.access.withApproval": "Read, Comment & Post with approval",
		"community.access.readAndPost": "Read and post",
		"community.actions.createPost": "New post",
		"community.empty": "There's no such community",
		"community.description": "About",
		"community.posts": "Most recent posts",
		"community.posts.empty": "There are no posts yet",
		"community.posts.private": "This community is private",
		"community.posts.privateSubtitle": "{name} is where you can share your experiences",
		"community.members": "members",
		"community.membersList": "Members ({count})",
		"community.moderatorsList": "Moderators ({count})",
		"community.postUpdated": "updated",
		"community.communityName": "Community Name",
		"community.menu.report": "Report",
		"community.menu.leave": "Leave",
		"community.menu.leaveCommunity": "Leave community",
		"community.menu.invitePeople": "Invite People",
		"community.menu.invite": "Invite",
		"community.menu.inviteDefault": "SEARCH FOR USER OR TEAM YOU'D LIKE TO INVITE TO COMMUNITY",
		"community.menu.leaveMessage": "Are you sure you want to leave the community?",
		"community.menu.shareLink": "Invitation URL",
		"community.menu.removeMember": "Remove from community",
		"community.menu.removeMemberMessage": "Are you sure you want to remove the user?",
		"community.menu.removeMemberFromCommunity": "Remove a user from community",
		"community.menu.editCommunity": "Edit community",
		"community.menu.removeLastCommunityModerator": "Sorry, you are the only one moderator who can manage the community. Ask the organization admin to handle it.",
		"community.activity.total": "You have {posts} new post(s) and {comments} new comment(s)",
		"community.activity.posts": "You have {posts} new post(s)",
		"community.activity.comments": "You have {comments} new comment(s)",
		"community.activity.sentRequest": "Sent the request to join the {communityName} community",
		"community.activity.invite": "Invited you to join {communityName} community",
		"community.activity.fromOrganization": "From {organization}",
		"community.activity.requestAccepted": "Your join request to {communityName} has been accepted by moderator",
		"community.activity.requestDeclined": "Your join request to {communityName} has been declined",
		"community.activity.inviteAccepted": "Accepted your invite to {communityName}",
		"community.activity.inviteDeclined": "Declined your invite to {communityName}",
		"community.activity.postApproved": "Your post for {communityName} community has been approved",
		"community.activity.postDeclined": "Your post for {communityName} community has been declined",
		"community.activity.openPost": "Open the post",
		"community.activity.leave": "Leave community",
		"community.reports.unresolved": "Unresolved",
		"community.reports.resolved": "Resolved",
		"community.reports.reported": "reported this community",
		"reports.community.type": "community",
		"reports.comment.type": "comment",
		"reports.post.type": "post",
		"reports.status": "Status",
		"reports.type": "Type",
		"reports.reason": "Reason",
		"reports.seeDetails": "See details",
		"reports.time": "Time",
		"reports.details": "Report Details",
		"reports.emptyMessage": "No user reports at the moment ",
		"reports.history": "Actions history",
		"reports.history.messageSent": "Message sent to the originator",
		"reports.history.wasDeleted": "was deleted",
		"reports.history.originatorRemoved": "The originator is removed from the community",
		"reports.community.info": "{user} reported this community",
		"reports.comment.info": "{user}'s comment from {community} was reported",
		"reports.post.info": "{user}'s post from {community} was reported",
		"post.title": "Post comments",
		"post.back": "Back to posts list",
		"post.comments": "Comments",
		"post.comments.add": "Add comment",
		"post.actions.createComment": "Post comment",
		"post.actions.reply": "Reply",
		"post.actions.discardPost": "Discard Post",
		"post.comment.description": "commented the post",
		"post.replies": "replies",
		"post.reply.description": "replied to {name}'s comment",
		"post.reply.placeholder": "Reply to the comment...",
		"post.comments.empty": "There are no comments yet",
		"community.newPost.title": "New post to {name} community",
		"community.newPost.edit.title": "Edit post in {name} community",
		"community.newPost.caption": "Caption",
		"community.newPost.attachImage": "Attach Image",
		"community.newPost.attachURL": "Attach URL",
		"community.newPost.addPost": "Add Post",
		"community.newPost.editPost": "Edit Post",
		"community.newPost.fileError": "Only images under {size}mb are allowed.",
		"community.newPost.urlError": "This link is not valid",
		"community.newPost.noPreview": "No Preview",
		"community.newPost.enterUrl": "Enter URL here...",
		"community.newPost.addPhoto": "Add photo",
		"community.newPost.maxAttachmentNumber": "You can only upload 10 files at the same time",
		"community.newPost.allowedFormatError": "Invalid file format. You can only upload jpg, jpeg and jpeg files.",
		"community.newPost.cancelPost": "All info will be removed. Are you sure? ",
		"community.newPost.sendForApproval": "Send for approval",
		"community.newPost.needsApproval": "In this community, publications must be approved by a moderator. ",
		"community.newPost.notification": "We will notify you when the moderator finishes reviewing your post",
		"community.postMenu.editPost": "Edit Post",
		"community.postMenu.deletePost": "Delete Post",
		"community.postMenu.confirmDeleteMessage": "Are you sure you want to delete this post? This cannot be undone.",
		"community.postMenu.report": "Report",
		"community.commentMenu.editComment": "Edit Comment",
		"community.commentMenu.deleteComment": "Delete Comment",
		"community.commentMenu.confirmDeleteComment": "Are you sure you want to delete this comment? This cannot be undone.",
		"community.commentMenu.report": "Report",
		"community.commentMenu.shareLink": "Invitation URL",
		"community.comments.commentWasDeleted": "Comment was deleted",
		"community.comments.commentWasDeletedByModerator": "Comment was deleted by moderator",
		"community.roles.moderator": "Moderator",
		"community.roles.member": "Member",
		"community.logo.cropTitle": "Update logo",
		"community.banner.cropTitle": "Update banner",
		"community.banner.cropTip": "1:4 ratio recommended.",
		"community.banner.removeTitle": "Are you sure you want to remove banner?",
		"community.logo.removeTitle": "Are you sure you want to remove this logo?",
		"profile.fieldSet.empty": "Section is empty. Edit section to add information.",
		"profiles.updated": "Profile has been updated",
		"settings.updated": "Settings has been updated",
		"profile.employee.workingHours.startTime.error": "The time of a start should be earlier then end time",
		"profile.employee.workingHours.endTime.error": "The time of a end should be later then start time",
		"programs.title": "Programs",
		"programs.emptyState": "is not assigned to any Program yet",
		"programs.invitation.emptyState": "There are no available Programs for the",
		"programs.invitation.addPatient": "Add Patient to a Program",
		"programs.invitation.invitationText": "invites you to join the Program/Service",
		"programs.invitation.title": "Program/Service Invitations for {user}",
		"programs.invitation.empty": "You have no program/service invitations",
		"programs.invitation.success": "Patient is successfully added to the Programs",
		"programs.actions.request": "Program/Service Invitations",
		"programs.actions.title": "Program/Service Details for {user}",
		"programs.actions.followup": "Visit followup for {user}",
		"programs.actions.subtitle": "About the program/service",
		"programs.actions.showMore": "Read More",
		"programs.actions.showLess": "Read Less",
		"programs.actions.more": "More",
		"programs.actions.leave": "Leave Program/Service",
		"programs.actions.aboutProgram": "About the program",
		"programs.remove.confirmRemove": "Are you sure you want to remove {patientName} from the {program}?",
		"programs.remove.success": "Patient has been successfully removed from the Program",
		"programs.remove.title": "Remove Patient from the Program",
		"programs.remove.subtitle": "Remove from Program",
		"programs.remove.message": "You left the program",
		"programs.remove.message.ar": "{dependentName} left the program",
		"programs.tabs.active": "Active",
		"programs.tabs.invites": "Invites",
		"programs.tabs.history": "History",
		"programs.tabs.invites.placeholder": "{name} has no invites",
		"programs.tabs.active.placeholder": "{name} has no active programs",
		"programs.tabs.history.placeholder": "{name} has no programs history",
		"helpCenter.support": "Support",
		"surveys.noUpcomingSurveys": "You have no upcoming surveys",
		"surveys.noSurveysResults": "There are no results to display",
		"surveys.sent": "Survey has been sent",
		"surveys.answer": "Survey has been answered",
		"surveys.completion": "Survey has been completed",
		"surveys.actions.answer": "Answer",
		"surveys.actions.save": "Save draft",
		"surveys.actions.proceed": "Proceed",
		"surveys.actions.general": "Service Satisfaction Info",
		"surveys.actions.review": "Review",
		"surveys.actions.submit": "Submit answers",
		"surveys.actions.submitOne": "Submit answer",
		"surveys.actions.upcoming": "Upcoming Surveys",
		"surveys.actions.upcomingTitle": "Upcoming",
		"surveys.actions.resultsTitle": "Results",
		"surveys.actions.upcomingHeading": "Upcoming Surveys for {user}",
		"surveys.actions.exportToPDF": "Export to PDF",
		"surveys.sendSurvey.noSurveys": "There is no surveys to send",
		"surveys.title": "Surveys",
		"surveys.title.data": "Data",
		"surveys.countSurveys": "{count} surveys",
		"surveys.results": "Survey Results",
		"surveys.single": "Survey",
		"surveys.totalScore": "Total Score:",
		"surveys.selectedChatDesc": "The survey will be available to all members of selected chat",
		"surveys.answeredBy": "Answered by",
		"surveys.answerForm": "Form has been answered",
		"surveys.noAvailableForms": "There is no available forms",
		"surveys.inProgress": "In progress",
		"surveys.inProgressMessage": "Someone has started this task already. When it’s done, you’ll see it in the Results section.",
		"surveys.isStarted": "Is started",
		"surveys.isStartedMessage": "Someone else has started working on this task. When it’s completed, you can view it in the Results section.",
		"surveys.program": "program",
		"surveys.scale.description": "Increasing severity:",
		"surveys.appointmentConsent.accept": "Do you accept",
		"surveys.preVisit.serviceType": "Service type",
		"surveys.preVisit.visitType": "Visit type",
		"surveys.preVisit.preVisitForm": "Pre-visit Form",
		"surveys.method.program": "Assigned via {name} Program",
		"surveys.method.provider": "Assigned by {name}, Provider",
		"surveys.method.system": "Assigned by System",
		"surveys.method.employer": "Assigned by Employer",
		"surveys.method.referralForm": "Referral form",
		"surveys.assignedBy": "Assigned by",
		"surveys.desc.program": "{name} Program",
		"surveys.desc.provider": "{name}, Provider",
		"surveys.desc.system": "system",
		"surveys.message.respond": "Please respond to",
		"surveys.formResults": "Form Results",
		"carePlan.assignedBy.provider": "Assigned Care Plan To Do, assigned by {displayableName} (Provider)",
		"profile.actions.cancel": "Discard",
		"profile.actions.details": "See detailed profile",
		"profile.actions.submit": "Save changes",
		"profile.actions.provider": "Provider",
		"profile.actions.patient": "Patient was added",
		"profile.actions.back": "Patient's healthboard",
		"profile.avatar.remove": "Remove",
		"profile.avatar.upload": "Upload photo",
		"profile.avatar.update": "Update photo",
		"profile.insurance": "Insurance",
		"profile.insurance.additional": "Additional insurance",
		"profile.insurance.skipInsurance": "Skip insurance",
		"profile.tabType.team": "Team profile",
		"profile.tabType.patient": "User profile",
		"profile.tabType.provider": "Provider profile",
		"profile.tabType.detailedProfile": "Detailed profile",
		"profile.tabType.surveys": "General surveys",
		"profile.section.emergencyContact": "Emergency contact",
		"profile.section.guarantorInformation": "Guarantor information",
		"profile.section.profileInfo": "Profile Info",
		"profile.section.general": "General information",
		"profile.section.personal": "Personal information",
		"profile.section.contacts": "Contact/login information",
		"profile.section.health": "Health information",
		"profile.section.insurance": "Insurance Details",
		"profile.section.insurance.empty": "No Insurance",
		"profile.section.insuranceAndId": "Insurance and ID details",
		"profile.section.prof": "professional information",
		"profile.section.mrns": "Medical Record Numbers",
		"profile.section.empinf": "Employment information",
		"profile.section.affiliations": "Affiliations",
		"profile.section.address": "Home Address",
		"profile.section.notificationSettings": "Notification Settings",
		"profile.section.privacySettings": "Privacy Settings",
		"profile.section.languageSettings": "Language Settings",
		"profile.section.workingHours": "Working hours",
		"profile.section.mfaSettings": "Multi-Factor Authentication",
		"profile.section.mfaSettings.label.active": "Active",
		"profile.section.mfaSettings.label.inActive": "Inactive",
		"profile.section.mfaSettings.label.helperText": "A verification code will be sent to authenticate the user",
		"profile.section.mfaSettings.button.activate": "Activate Multi-Factor Authentication",
		"profile.section.mfaSettings.button.inActivate": "Inactivate Multi-Factor Authentication",
		"profile.section.mfaSettings.confirmModal.inActivate.title": "Are you sure you want to inactivate Multi-Factor Authentication?",
		"profile.section.mfaSettings.confirmModal.inActivate.button": "Inactivate",
		"profile.section.deviceSetup": "Device Setup",
		"profile.section.deviceSetup.addDeviceAccount": "Add New Device Account",
		"profile.section.deviceSetup.noAccount": "No Accounts Connected",
		"profile.section.deviceSetup.addAccountDescription": " (Tap Add New Device Account to Set up a device and upload your Health data)",
		"profile.section.deviceSetup.removeAccount": "Remove Account",
		"profile.section.deviceSetup.detailsAccount": "{name} Account",
		"profile.section.deviceSetup.noDevices": "No Connected Devices",
		"profile.section.deviceSetup.synced": "Synced ",
		"profile.section.deviceSetup.removeConfirmation": "Are you sure you want to remove account?",
		"profile.section.deviceSetup.chooseDeviceAccount": "Choose Device Account",
		"profile.section.deviceSetup.noPermission": "No access to {type} account",
		"profile.section.deviceSetup.noPermissionAnnotation": " (Please allow access during login or add another account to set up devices.)",
		"profile.section.deviceSetup.accountIsAdded": "Account is added",
		"profile.section.deviceSetup.noPermissionNotification": "No access to account",
		"profile.section.deviceSetup.manageDataFromMobile": "Apple Health can be connected and managed from iOS mobile app.",
		"profile.section.deviceSetup.appleHealth": "Apple Health",
		"profile.section.deviceSetup.connectToGoogleFit": "Connect to Google Fit",
		"profile.section.deviceSetup.googleFit.description": "Using “{brandName}” with Google Fit on your device empowers you to better manage your health. “{brandName}” will read and store your data so that you, your family, and your Care Team can view it at any time.",
		"profile.section.deviceSetup.googleFit.signIn": "Sign in with Google",
		"profile.section.deleteAccount.title": "Delete Account",
		"profile.section.deleteAccount.description": "Please send a request to our Support Team in order to delete account.",
		"profile.section.unitsSettings.title": "Units",
		"profile.section.unitsSettings.weight": "Weight",
		"profile.section.unitsSettings.weight.metric.pounds": "lbs",
		"profile.section.unitsSettings.weight.metric.kilograms": "kg",
		"profile.section.unitsSettings.height": "Height",
		"profile.section.unitsSettings.height.metric.meters": "cm",
		"profile.section.unitsSettings.height.metric.feet_and_inches": "ft",
		"profile.section.unitsSettings.temperature": "Body temperature",
		"profile.section.unitsSettings.temperature.metric.celsius": "°C",
		"profile.section.unitsSettings.temperature.metric.fahrenheit": "°F",
		"profile.section.unitsSettings.glucose": "Blood glucose",
		"profile.section.unitsSettings.glucose.metric.mmol/L": "mmol/L",
		"profile.section.unitsSettings.glucose.metric.mg/dL": "mg/dL",
		"profile.section.insurance.healthPlan": "Health Plan",
		"profile.section.insurance.verificationDate": "Eligibility Verification Date",
		"profile.error.viewDetailedProfile": "You should be a member of Patient` Provider circle to view detailed profile.",
		"mfa.dialog.title": "Multi-Factor Authentication",
		"mfa.dialog.button.verify": "Verify",
		"mfa.dialog.error.message": "The code entered is invalid",
		"mfa.dialog.input.label": "Confirm code",
		"mfa.dialog.phoneConfirmation": "A confirmation code was sent to your phone {phone}",
		"mfa.dialog.emailConfirmation": "A confirmation code was sent to your email {email}",
		"mfa.dialog.phoneAndEmailConfirmation": "A confirmation code was sent to your phone or your email",
		"mfa.dialog.constPhoneAndEmailConfirmation": "A confirmation code was sent to your phone {phone} and your email {email}",
		"mfa.dialog.resendCode": "Wait {counter} sec.",
		"mfa.dialog.activate.bodyText": "A verification code will be sent to authenticate the user.",
		"mfa.dialog.activate.button": "Activate",
		"mfa.dialog.advert.title": "Protect your account by using Multi-Factor Authentication",
		"mfa.dialog.advert.contentText": "A verification code will be sent to authenticate the user.",
		"otp.dialog.title": "One-time Passcode Authentication",
		"otp.dialog.contentText": "Enter your email or phone number and we'll send you back one-time passcode authentication instruction. Please use the email/phone number where you received your invitation or placed in Contact info.",
		"otp.dialog.getPasscode": "Get passcode",
		"otp.dialog.error.tooManyRequests": "Too many attempts, try again later",
		"fields.dob": "Date of Birth",
		"fields.patientType": "Patient Type",
		"fields.email": "Email",
		"fields.emailAddress": "Email address",
		"fields.address1": "Address 1",
		"fields.address2": "Address 2",
		"fields.city": "City",
		"fields.state": "State",
		"fields.postalCode": "Postal / ZIP code",
		"fields.gender": "Gender",
		"fields.firstname": "First Name",
		"fields.lastname": "Last Name",
		"fields.password": "Password",
		"fields.username": "Nickname",
		"fields.login": "Login",
		"fields.login.placeholder": "Email, Phone Number or Username",
		"fields.phoneNumber": "Phone Number",
		"fields.reasonType": "Appointment Type",
		"fields.reasonType.placeholder": "Appointment Type",
		"fields.reasonVisit": "Reason for Visit",
		"fields.reasonNote": "Reason for Visit",
		"fields.reasonNote.placeholder": "Add reason for visit",
		"fields.chatName": "Chat name",
		"fields.chatName.placeholder": "Enter chat name",
		"fields.insurance.memberId": "Member ID",
		"fields.insurance.groupNumber": "Group Number",
		"fields.insurance.primarySubscriber": "{name} is the Primary Subscriber",
		"fields.insurance.mainPrimarySubscriber": "I am the Primary Subscriber",
		"fields.insurance.primarySubscriber.title": "Primary Subscriber Details",
		"fields.insurance.search.emptyState": "No results found",
		"fields.insurance.haveNotInsurance": "I don't have insurance",
		"fields.insurance.patientHaveNotInsurance": "{name} doesn't have insurance",
		"fields.emailPhoneNumber": "Email or Phone number",
		"fields.pcpName": "Enter your PCP's name",
		"fields.pcpName.selectPcpName": "Select your PCP's name",
		"fields.doYouConsiderUsAsYourPCP": "Do you consider us as your PCP?",
		"fields.enterEmployerName": "Enter employer name",
		"profile.loadingPopup": "Scanning your insurance details,\nplease wait...",
		"profile.insuranceCard.uploading": "Uploading...",
		"profile.fields.unit": "Units",
		"profile.fields.weight": "Weight",
		"profile.fields.height": "Height",
		"profile.fields.workingHours.startTime": "Start time",
		"profile.fields.workingHours.endTime": "End time",
		"profile.fields.workingHours.timeZone": "Time zone",
		"profile.fields.description": "Description",
		"profile.fields.relationship": "Relationship",
		"profile.fields.relationship.placeholder": "Select relationship",
		"profile.fields.role": "Role",
		"profile.fields.role.placeholder": "Select role",
		"profile.fields.relation": "Relation",
		"profile.fields.bio": "Bio",
		"profile.fields.location": "Location",
		"profile.fields.phones": "Phones",
		"profile.fields.healthInterests": "Health interests",
		"profile.fields.name": "Name",
		"profile.fields.firstName": "First Name",
		"profile.fields.middleName": "Middle Name",
		"profile.fields.lastName": "Last Name",
		"profile.fields.nameSuffix": "Name suffix",
		"profile.fields.gender": "Gender",
		"profile.fields.genderIdentity": "Gender identity",
		"profile.fields.dob": "Date of birth",
		"profile.fields.age": "Age",
		"profile.fields.race": "Race",
		"profile.fields.mStatus": "Marital status",
		"profile.fields.ethnic": "Ethnicity",
		"profile.fields.language": "Language",
		"profile.fields.prefLanguage": "Preferred language",
		"profile.fields.languages": "Languages",
		"profile.fields.religion": "Religion",
		"profile.fields.email": "Email",
		"profile.fields.homeAddress": "Home Address",
		"profile.fields.address1": "Address 1",
		"profile.fields.address2": "Address 2",
		"profile.fields.address2Optional": "Address 2 (Optional)",
		"profile.fields.city": "City",
		"profile.fields.state": "State / Province",
		"profile.fields.onlyState": "State",
		"profile.fields.postalCode": "Postal / ZIP code",
		"profile.fields.isHomeLocationDifferent": "My current location is different from their home address",
		"profile.fields.country": "Country",
		"profile.fields.homePhone": "Home phone number",
		"profile.fields.mobilePhone": "Mobile phone number",
		"profile.fields.phone": "Phone number",
		"profile.fields.localUid": "Medical Record Number (MRN)",
		"profile.fields.allergies": "Allergies",
		"profile.fields.medicationAllergies": "Medications allergies",
		"profile.fields.healthConditions": "Health conditions",
		"profile.fields.doYouHavePCP": "Do you have a primary care provider (PCP)?",
		"profile.fields.helpFindProvider": "Can we help you find primary care provider?",
		"profile.fields.medicine": "Medications",
		"profile.fields.healthGoals": "Health Goals",
		"profile.fields.mrns": "Medical Record Numbers",
		"profile.fields.localUidProvider": "Provider ID",
		"profile.fields.npi": "Provider NPI",
		"profile.fields.title": "Title",
		"profile.fields.specialty": "Speciality",
		"profile.fields.primaryPracticeAddress": "Primary Practice Address",
		"profile.fields.primaryPracticeAddress1": "Primary Practice Address 1",
		"profile.fields.primaryPracticeAddress2": "Primary Practice Address 2",
		"profile.fields.primaryPracticeCity": "Primary Practice City",
		"profile.fields.primaryPracticeState": "Primary Practice State",
		"profile.fields.primaryPracticeCountry": "Primary Practice Country",
		"profile.fields.officePhone": "Office Phone Number",
		"profile.fields.username": "Username",
		"profile.fields.username.hint": "Used for account Sign In",
		"profile.fields.aliasName": "Alias",
		"profile.fields.aliasName.hint": "Alias is used as community nickname",
		"profile.fields.phoneNumber": "Mobile Phone",
		"profile.fields.day": "Day",
		"profile.fields.year": "Year",
		"profile.fields.month": "Month",
		"profile.fields.organizations": "Organizations",
		"profile.fields.employers": "Employers",
		"profile.fields.ssn": "SSN",
		"profile.fields.educationLevel": "Highest level of education",
		"profile.fields.veteranStatus": "Veteran status",
		"profile.fields.citizenship": "Country of citizenship",
		"profile.fields.ssnLong": "Social Security Number (SSN)",
		"profile.fields.ssnPlaceHolder": "Social Security Number",
		"profile.fields.ssnDescription": "Social Security Number should have full 9 digits (e.g. 123456789) or last 4 digits (e.g. 6789)",
		"profile.fields.emailOrPhone": "Email or Phone",
		"profile.fields.insuranceCard": "Insurance card",
		"profile.fields.driverLicense": "Patient/Guardian ID",
		"profile.fields.removeItem": "This item won`t be able to select any more. Are you sure you want to remove it?",
		"profile.fields.ssnFull": "Social Security Number (SSN)",
		"profile.fields.mobilePhone.validation.short": "Phone is too short",
		"profile.fields.mobilePhone.validation.long": "Phone is too long",
		"profile.edit.emailConfirmationTitle": "Confirm contact information",
		"profile.edit.emailConfirmationText": "A verification email has been sent to {email}. The old email will continue to be used until you verify the new one.",
		"profile.edit.confirmCode": "Confirm code",
		"profile.edit.invalidCode": "You've entered invalid code",
		"profile.edit.phoneConfirmationText": "To start using the new mobile phone number it will need to be verified. We have sent an SMS with a confirmation code to {phone}. Please enter this code below.",
		"profile.notificationSettings.label": "Notify by {type} ({value})",
		"profile.notificationSettings.labels.email": "email",
		"profile.notificationSettings.labels.sms": "SMS",
		"profile.privacySettings.labels.nickname": "Use my nickname",
		"profile.privacySettings.labels.nicknameExtra": "(Your real name and profile photo will be hidden except from your Circle of Care)",
		"profile.list.gender.M": "Male",
		"profile.list.gender.F": "Female",
		"profile.list.gender.O": "Other",
		"profile.list.gender.U": "Unknown/Prefer not to say",
		"profile.list.marital.S": "Single",
		"profile.list.marital.M": "Married",
		"profile.list.marital.O": "Other",
		"profile.list.marital.U": "Unknown",
		"profile.list.marital.W": "Widowed",
		"profile.list.marital.D": "Divorced",
		"chat.common.removeFromChat": "Remove from chat",
		"chat.actions.downloadAttachment": "Download attachment",
		"chat.actions.editMessage": "Edit message",
		"chat.actions.deleteMessage": "Delete message",
		"chat.actions.confirmDeleteMessage": "Are you sure you want to delete this message? This cannot be undone.",
		"chat.actions.confirmLeaveChat": "Are you sure you want to leave this chat?",
		"chat.actions.reply": "Reply",
		"chat.actions.blockMessaging": "Block Messaging",
		"chat.actions.unblockMessaging": "Unblock Messaging",
		"chat.actions.blockForMe": "for me",
		"chat.actions.blockForDependent": "for dependent",
		"chat.actions.unblockUser": "Unblock User",
		"chat.actions.leaveChat": "Leave Chat",
		"chat.actions.sendMessage": "Send Message",
		"chat.titles.uploadingFile": "You are uploading a file {name}",
		"chat.titles.generalChatTab": "All Members",
		"chat.titles.familyChatTab": "Family Only",
		"chat.titles.customChannel": "Custom channel",
		"chat.titles.providersChatTab": "Providers Only",
		"chat.titles.activitiesChatTab": "To do",
		"chat.titles.notificationsChatTab": "Notifications/Alerts",
		"chat.titles.healthAlert": "Health Alert",
		"chat.titles.providerAssignment": "Provider Assignment",
		"chat.titles.providerRemoved": "Provider Unassigned",
		"chat.titles.memberAssignment": "Member Assignment",
		"chat.titles.notification": "Notification",
		"chat.titles.surveyReminder": "Reminder",
		"chat.titles.addedAttachment": "added an attachment",
		"chat.titles.provider": "Provider",
		"chat.titles.providers": "Providers",
		"chat.titles.family": "Family",
		"chat.title.chatInContextOf": "Chat in context of",
		"chat.title.inContextOf": "In context of",
		"chat.title.conversationInfo": "Conversation Info",
		"chat.title.chatName": "Chat Name",
		"chat.title.userBlocked": "You can’t message this contact because you’ve been blocked",
		"chat.title.newChatError": "You do not have permission to create this chat",
		"chat.title.blockedUserError": "Sorry, you can’t block this user",
		"chat.title.membersCounter": "{counter} members",
		"chat.title.chatDetails": "Chat details",
		"chat.title.editChatName": "Edit Chat Name",
		"chat.title.disclaimerInforming": "Send a non-urgent message to your care team. If this is a medical emergency, call 911.",
		"chat.placeholders.messageTo": "Message To",
		"chat.placeholders.default": "Type a message",
		"chat.placeholders.surveyExpired": "This survey expired",
		"chat.notifications.patientAssignedToProgram": "{providerName} from {organizationName} has enrolled {patientName} into the {programName} program/service",
		"chat.notifications.patientRemovedFromProgram": "{patientName} has been removed from the {programName} program/service",
		"chat.sorting.byUnread": "By Number of Unread",
		"chat.sorting.byLastMessage": "By Most Recent",
		"chat.errors.tooLong": "Maximum {length} symbols",
		"chat.errors.minLength": "Minimum {length} symbols",
		"chat.errors.maxAttachmentSize": "Max size 50Mb",
		"chat.errors.maxAttachmentSizeNextPart": "{files} is/are too large",
		"chat.errors.notAllowedFormat": "You can only upload jpg, png, pdf, docx, xlsx, pptx, rtf, txt, xml, mov, mp4 and vcf files",
		"chat.errors.uploadError": "Error occured during file upload. Please try again",
		"chat.errors.maxAttachmentNumber": "You can only upload 20 files at the same time",
		"chat.errors.invalidName": "Name is invalid",
		"chat.moreAttachments.sendSurvey": "Send Survey",
		"chat.moreAttachments.answerForm": "Answer Form",
		"chat.moreAttachments.attachFile": "Attach File",
		"chat.notification.newMessage": "new message",
		"auth.accessDenied.text": "Sorry, but you have no permissions to access this page.",
		"auth.createPassword.text": "Please enter your new password",
		"auth.expiredToken.text": "Sign up link expires after 7 days, and can only be used once.",
		"auth.expiredConfirmation.text": "Confirmation link expires after 7 days, and can only be used once.",
		"auth.expiredLink.text": "Your invitation link is invalid. If you completed the invitation process, go to {link} to login. If you need a new invitation, contact the person who sent you this invitation",
		"auth.expiredLinkDefault.text": "This link is expired.\nThe file you are trying to access is no longer available.\nAsk the owner to send it again.",
		"auth.recoverConfirm.email.title": "We've sent you an email with instructions to",
		"auth.recoverConfirm.email.confirmText": "Please check your email.",
		"auth.recoverConfirm.phone.title": "We've sent you a message with instructions to",
		"auth.recoverConfirm.phone.confirmText": "Please check your phone.",
		"auth.recoverPassword.textTitle": "Enter your email and we'll send you back password recovery instructions. Please use the email/phone number where you received your invitation or placed in Contact info.",
		"auth.recoverPassword.textLink": "Forgot password?",
		"auth.recoverPassword.primaryContacts.textTitle": "Enter your username, and we'll send password recovery instructions to your email or phone number associated with your account.",
		"auth.recoverPassword.primaryContacts.username": "Username",
		"auth.haveAccount.text": "First time user?",
		"auth.userNotFound.text": "The user with this email/phone does not exist",
		"auth.signup.title": "Don't have an account?",
		"auth.signup.textLink": "Sign up for {brandName}",
		"auth.signup.matchPassword": "Password and confirm password do not match",
		"auth.signup.confirmationPassword": "Confirm password",
		"auth.signup.setNewPassword": "Set new password",
		"auth.signup.newPassword": "New password",
		"auth.signup.text.emailPhone": "The email/phone number below is your login ID.",
		"auth.signup.text.email": "The email below is your login ID.",
		"auth.signup.text.username": "Username is used for account Sign In",
		"auth.signup.popover.title": "Username requirements:",
		"auth.signup.popover.li1": "use letters, numbers, or (. - _)",
		"auth.signup.popover.li2": "(+) and (@) allowed only once",
		"auth.signup.popover.li3": "no spaces",
		"auth.signup.text.phone": "The phone number below is your login ID.",
		"auth.tnc.title": "I have read and accept",
		"auth.tnc.textLink": "Terms and Conditions",
		"auth.logout.text": "Logout",
		"auth.signup.invitationLinkDesc": "You’ll receive an invitation link on your email or phone.",
		"auth.signup.personalInfoDesc": "Please review the data below to complete your registration.",
		"auth.signup.azure.description": "The e-mail/phone number below is your login ID.",
		"auth.signup.sentEmailVerification": "Verification link has been sent. Check your email please",
		"auth.signup.sentPhoneVerification": "Verification link has been sent. Check your phone please",
		"auth.signup.registrationInvitation": "Your invitation has been sent. Check your phone or email please",
		"auth.expire.multipleDevice": "Your’ve signed in to another device. You can use your account only at one device at a time",
		"auth.expire.expiredSession": "Your session has expired. \nPlease sign in again.",
		"auth.changePassword.text": "Your logged in with a temporary \npassword. To finish logging in, Please \ncreate new password.",
		"auth.login.text": "If you have an account, please \nenter the email, phone number or \nusername you previously provided. ",
		"auth.login.flagler.text": "Enter the email or phone number you previously used to set up your account.",
		"auth.login.flagler.subDescription": "You can also download the Flagler Health+ Anywhere app on your smart phone or tablet.",
		"auth.login.flagler.description": "Log in to Flagler Health+ Anywhere to schedule an appointment, view your health information and more.",
		"auth.nextStep": "Next Step",
		"auth.next": "Next",
		"auth.info.inviteEmailNotConfirmed": "You’ve already been invited to {brandName} \n Health App via this email address. \n \nPlease check your inbox and follow the \n link to complete your registration.",
		"auth.info.invitePhoneNotConfirmed": "You’ve already been invited to {brandName} \n Health App via this phone number. \n \nPlease check your SMS inbox and follow the \n link to complete your registration.",
		"auth.info.title.invitePhoneNotConfirmed": "Check your SMS inbox \nfor an invitation",
		"auth.info.title.inviteEmailNotConfirmed": "Check your email \nfor an invitation",
		"auth.info.inviteExpired": "The invitation that was sent to your email has \nexpired. Please ask your provider to invite you again.",
		"auth.info.inviteNotConfirmed": "An invitation was sent to your email. \nPlease accept the invitation and register.",
		"auth.info.signUpInviteNotConfirmed": "Your invitation has been sent. Check your phone or email please.",
		"auth.description": "Login, as Phone number should contain '+' and your country code, for example: +1234567890",
		"auth.browser.notSupport": "Your browser is not supported",
		"auth.browser.newVersion": "Please try a latest version of Google Chrome, or other modern browser",
		"auth.browser.getChrome": "Get Google Chrome",
		"auth.work-school.account": "to use Work/School account",
		"auth.forCommunityCollege": "for St. Louis Community College",
		"auth.otherLoginOptions": "Other login options",
		"auth.errors.notFound": "User Login not found. Please make sure you are using the email you have registered with.",
		"auth.errors.notConfirmed": "Your email is not confirmed. Please, check your inbox to confirm and complete registration.",
		"auth.errors.userDisabled": "An active user account was not found. Please contact support.",
		"auth.errors.gotIt": "Got it!",
		"auth.poweredByHealthfully.label": "Powered by Healthfully",
		"auth.sendOtp.title": "Send one-time passcode",
		"auth.sendOtp.inviteNotConfirmed": "An invitation was sent to your email. \n Please accept the invitation and login.",
		"auth.signup.description": "Your logged in with a temporary\n password. To finish logging in, Please\n create new password.",
		"errors.common": "Something went wrong...",
		"errors.commonErrorOccured": "An error occured, please try again later",
		"errors.emailError": "Enter valid email address",
		"errors.emailErrorDesription": "Login {error}",
		"errors.emailAndPhoneErrorDescription": "Entered Email or Phone is invalid",
		"errors.invalidDateOfBirth": "Invalid date of birth",
		"errors.login.unauthorized": "The information you entered doesn’t match our records. Please double-check and try again.",
		"errors.login.notFound": "We are unable to locate a registered account with that email/phone number.",
		"errors.login.incorrect": "Incorrect login. Please, try again.",
		"errors.login.registrationNotFinished": "You are not registered yet. Please, check your E-mail/SMS inbox to complete registration first.",
		"errors.login.authenticationLockout": "Authentication is under temporary lockout for this account due to too many failed login attempts. You can login again in 15 mins",
		"errors.nameLength": "First and Last Name should contain up to 40 symbols",
		"errors.requiredFields": "All fields are required",
		"errors.tnc": "Please confirm that you have read and accept the Privacy Policy and Terms and Conditions",
		"errors.cannotAcceptInvite": "You need to have patient profile to accept invitations to family circles",
		"errors.nicknameContainsCommercialAt": "Nickname should not contain @ symbol",
		"errors.password": "Password cannot be blank or contain only spaces",
		"errors.providerFromAnotherOrganization": "Provider is from another organization",
		"errors.providerAlreadyInCircle": "Provider or Team is already in the circle",
		"errors.alreadyUsed": "Entered Email or Phone is already used, please log in.",
		"errors.validation.profile.firstName.required": "First Name should be present",
		"errors.validation.profile.lastName.required": "Last Name should be present",
		"errors.validation.profile.phone.format": "Phone should contain only +, - and digits",
		"errors.validation.profile.phone.required": "Phone is required",
		"errors.validation.profile.phoneHome.required": "Home phone number is required",
		"errors.validation.profile.phoneHome.format": "Phone number should contain between 8 and 14 numbers",
		"errors.validation.profile.phone.short": "Phone is too short",
		"errors.validation.profile.dob.format": "Incorrect date format",
		"errors.validation.profile.dob.required": "Date of birth is required",
		"errors.validation.profile.dob.minDate": "Date of birth cannot be before 01-01-1900.",
		"errors.validation.profile.email.format": "Email is invalid, please provide another",
		"errors.validation.profile.email.required": "Email is required",
		"errors.validation.profile.username.required": "Username is required",
		"errors.validation.profile.aliasName.required": "Alias is required",
		"errors.validation.profile.username.format": "Invalid format. Please use letters, numbers, . - _. Also + and @ allowed only once. No spaces.",
		"errors.validation.profile.aliasName.format": "Please enter a valid alias. Only letters, numbers, underscores and hyphens are allowed",
		"errors.validation.profile.username.minCharacters": "Username must contain at least 3 characters",
		"errors.validation.profile.aliasName.minCharacters": "Alias must contain at least 1 character",
		"errors.validation.profile.postalCode.format": "Please enter valid Postal / ZIP code for you region. For example: {example}",
		"errors.validation.profile.ssn.format": "Allowed formats: full 9 digits (e.g. 123456789) or last 4 digits (e.g. 6789)",
		"errors.validation.profile.workingHours.required": "Please, fill all fields or clear all to save",
		"errors.validation.common": "Record is invalid",
		"errors.username.conflictsWithExistingData": "Username has already been used. Please provide another!",
		"errors.username.alreadyTaken": "This username has already been taken. Please provide another.",
		"errors.username.required": "This field is required",
		"errors.aliasName.alreadyTaken": "This alias has already been taken. Please provide another.",
		"errors.ssn.alreadyTaken": "SSN has already been taken",
		"errors.ssn.alreadyTakenBy": "SSN has already been taken by {name}",
		"errors.fieldAlreadyTaken": "{field} has already been taken by {name}",
		"errors.appointment.timeSlotNotAvailable": "This time slot is no longer available.\nPlease choose another time.",
		"errors.appointment.pricingNotAvailable": "Pricing is not available for current date",
		"errors.appointment.thirdPartyError": "Service in not available",
		"errors.appointment.unavailableVirtualRoom": "The room is not yet available",
		"errors.appointment.mediaAccessDenied": "Can't access your camera\nPlease, give access to your computer's camera and microphone",
		"errors.appointment.copay": "Please enter valid payment amount",
		"errors.validation.invalidLoginEmail": "Invalid format. Please re-enter the email address using the standard format: example@example.com",
		"errors.validation.invalidLoginPhone": "Invalid format. Phone number should contain at least 10 digits and include area code.",
		"errors.validation.invalidLoginUsername": "Username must be 3–70 characters and can include letters, numbers, . - _. Also + and @ allowed only once. No spaces.",
		"errors.validation.alreadyExists": "The user with this email/phone already exists",
		"errors.validation.alreadyTakenByUsers": "Something is wrong with the E-mail AND Phone number. Please check",
		"errors.validation.separator": " or ",
		"errors.longRequest.408": "It takes too long to process the operation. Please check your internet connection and try again later.",
		"errors.longRequest.502.504": "Server is not responding, please, try again later or skip this step",
		"errors.familyMember.invitation": "Couldn't find family member invitation",
		"error.alreadyTakenEmail": "Email is already taken",
		"error.invalidPhoneNumber": "Phone number is invalid or already used, please provide another",
		"errors.formFields.phoneNumber": "Incorrect phone number. Please check and try again.",
		"errors.securityLink": "This link cannot be accessed due to security restrictions. Please try again later.",
		"errors.provideAdditionalInsuranceDetails": "Please provide additional insurance details or delete it to proceed.",
		"submit.signup": "Proceed",
		"submit.login": "Log in",
		"submit.signin": "Sign in",
		"submit.fillProfile": "Confirm",
		"submit.recoverPassword": "Send request",
		"submit.recoverConfirm": "Back to login",
		"submit.createPassword": "Save password",
		"submit.expiredToken": "Got it",
		"submit.signUp": "Sign up",
		"submit.clickHere": "Click here",
		"submit.registerHere": "Register here",
		"submit.login.azure": "Sign in with Microsoft",
		"submit.signUp.azure": "Sign Up with Microsoft",
		"submit.signUp.azure.description": "Please complete registration with Microsoft authentication",
		"submit.getInLine": "Get in line",
		"support.helpCenter": "Help Center",
		"support.needHelp": "Do you need help with {name} app?",
		"support.appVersion": "App version",
		"support.platformVersion": "Platform version",
		"titles.accessDenied": "Access denied",
		"titles.createPassword": "Create new password",
		"titles.expiredToken": "Sign up link expired",
		"titles.expiredConfirmation": "Confirmation link expired",
		"titles.fillProfile": "Personal details",
		"titles.login": "Log in to {brandName}",
		"titles.recoverConfirm": "Recovery link sent",
		"titles.recoverPassword": "Recover password",
		"titles.signup": "Sign up for {brandName}",
		"titles.confirmMyPhoneNumber": "I confirm my number",
		"titles.confirmMyEmail": "I confirm my email",
		"report.title": "Please select a problem to continue",
		"report.danger": "If someone is in immediate danger, call local emergency services.",
		"general.careProvidersTitle": "Care providers",
		"previewableBlock.more": "View more",
		"previewableBlock.less": "View less",
		"generalSurveys.noSurveys": "You have no service satisfaction info",
		"intro.common.logout": "Click here to logout from the app",
		"intro.common.circlesMenu": "Invite someone to the circle",
		"intro.circles.inviteFamilyMember": "Invite someone to join the family circle",
		"intro.circles.assignCaregiver": "Assign someone as caregiver who can act on behalf of patient",
		"intro.circles.inviteProviderMember": "Invite a provider in the organization to join the circle",
		"intro.circles.removeProviderMember": "Remove provider from the provider circle",
		"intro.messages.generalChannel": "Click on tab to chat to all providers and family",
		"intro.messages.providerChannel": "Private chat for providers only",
		"intro.messages.familyChannel": "Private chat for the patient's family only",
		"intro.messages.searchChat": "Search for a chat",
		"intro.messages.selectChat": "Select a chat",
		"intro.messages.selectChannel": "Select a channel",
		"intro.messages.typeFilter": "Select a type of chats",
		"intro.messages.socialChatArchived": "The social chat is archived because providers don't have access to it. Please, write to the practice chat or directly to the provider.",
		"intro.messages.typeMessage": "Type your message here",
		"intro.messages.answerSurvey": "Click to answer the survey",
		"intro.messages.patientName": "Click patient's name to see the providers and programs",
		"intro.messages.patientContext": "Everything you see is related to this patient",
		"intro.messages.patientProgram": "Click to see program surveys",
		"intro.messages.programFilter": "Filter the list of patients",
		"notificationScreen.title": "Notice",
		"notificationScreen.providerWithoutPatients.notification": "Circles are only available for patients and their family members.",
		"notificationScreen.providerWithoutPatients.instructionTitle": "How to become a patient or a family member (caregiver) in {brandName}?",
		"notificationScreen.providerWithoutPatients.instructionBody": "In order to become a patient ask your doctor whether your clinic is already connected to {brandName} and if yes, ask them to enroll you to one of the {brandName} Care Programs available in your clinic. Since enrolled, you will be able to invite family members to your Circle of care. In order to become a family member (caregiver) of a patient ask your relatives who are already enrolled to {brandName} Care Program to invite you to their family circle.",
		"notificationScreen.providerWithoutPatients.commonTitle": "Already a patient or a family member?",
		"notificationScreen.providerWithoutPatients.commonBody": "If you have been already enrolled to a program by your Doctor, but still can't see your Healthboard, try to update your email address.",
		"routes.patientViewProfile": "patient profile",
		"routes.providerViewProfile": "provider profile",
		"routes.userViewProfile": "user profile",
		"routes.providerMemberProfile": "provider circle member profile",
		"routes.familyMemberProfile": "family member profile",
		"routes.generalSurveys": "general surveys",
		"routes.parentProvider": "main care provider",
		"routes.patientInfo": "patient info",
		"routes.patientHealthboard": "patient healthboard",
		"routes.providerInfo": "provider info",
		"routes.settings": "settings",
		"routes.paymentMethods": "payment methods",
		"routes.support": "support",
		"routes.documentation": "documentation",
		"routes.circleOfCare": "circle of care",
		"routes.data": "data",
		"routes.program": "programs",
		"role.admin": "admin",
		"dialog.common.invite": "Invite more people to the chat",
		"dialog.success.joinCircle": "You've joined Patient's Provider Circle",
		"dialog.titles.joinCircle": "Join a Patient’s Provider Circle",
		"dialog.titles.assignProviderToPatient": "Assign new Provider to the Patient",
		"dialog.titles.assignProviderOrTeamToPatient": "Assign new Provider or Team to the Patient",
		"dialog.common.noPatients": "If the Patient doesn’t appear in search they may not be in our system or may already be assigned to you.",
		"dialog.titles.addDependent": "Add Child/Dependent to the System",
		"dialog.common.assign": "Assign",
		"dialog.common.addPatient": "Add Patients to the System",
		"dialog.common.defaultPatient": "ENTER THE USERNAME OR NAME OF A PATIENT WHOSE PROVIDER CIRCLE YOU’D LIKE TO JOIN",
		"dialog.common.addNewPatient": "Add new Patient",
		"dialog.common.patientWasAdded": "Patient has been added to the System",
		"dialog.common.defaultProvider": "ENTER THE USERNAME OR NAME OF A PROVIDER OR TEAM YOU’D LIKE TO ASSIGN TO THE PATIENT.",
		"dialog.common.selectTab": "SELECT A NECESSARY TAB TO MAKE YOUR RESULT MORE PRECIS",
		"dialog.common.assignProvider": "Assign Provider",
		"dialog.common.assignProviderOrTeam": "Assign Provider or Team",
		"dialog.common.inviteCaregiver": "Invite Caregiver",
		"dialog.common.inviteMember": "Invite Member",
		"dialog.common.invitePerson": "Invite Person",
		"dialog.common.reinvite": "Reinvite",
		"dialog.common.searchProvider": "Search for a Provider or Team...",
		"dialog.common.searchPatient": "Search for a Patient...",
		"dialog.common.addAnotherPatient": "Do you want to add another Patient to the System?",
		"dialog.common.alreadyMember": "Already a member?",
		"dialog.common.changesNotSave": "Changes wouldn't be saved. Are you sure?",
		"addPatient.dialog.title": "Add patient to your organization",
		"addPatient.dialog.subtitle": "This patient may be an existing user. Please check the patient details below and add patient if the patient is the correct one. If not please go back and use a different email/phone.",
		"dialog.titles.addPatient": "Add patient",
		"dialog.titles.emergencyContact": "Patient Emergency contact (optional)",
		"dialog.titles.emergencyContactRole": "Please, pay attention! Assigning the role is given full access to a Patient’s profile to act and manage the system on the Patient’s behalf.",
		"dialog.titles.andOr": "and / or",
		"dialog.titles.and": "and",
		"dialog.titles.join": "Join",
		"dialog.titles.accessRequested": "Access requested",
		"dialog.titles.copiedToClipboard": "Copied to clipboard",
		"dialog.titles.shareableLink": "You can past shareable link into another program",
		"documentation.common.frontSide": "front side",
		"documentation.common.backSide": "back side",
		"documentation.common.addPhoto": "Add a photo of the ",
		"documentation.common.title": "Profile Documentation",
		"documentation.attached.title": "Uploaded documents",
		"documentation.paperConsents.title": "Paper consents",
		"document.common.title": "Documentation",
		"documentation.consent.revoked": "Revoked",
		"documentation.consent.active": "Active",
		"documentation.consent.expired": "Expired",
		"dependent.form.selectRoleTitle": "Select your role",
		"dependent.form.addDependentTitle": "Add Dependent",
		"dependent.form.addChildTitle": "Add Child",
		"dependent.form.addDependentSubTitle": "Please, pay attention! All data will be stored in a secure way and won`t be editable anymore.",
		"dependent.form.relationshipSubTitle": "Please specify your relationship.",
		"dependent.form.relationshipExistSubTitle": "This profile already exists. Please specify your relationship.",
		"dependent.form.relationshipLabel": "Relationship",
		"dependent.form.parentTitle": "Parent",
		"dependent.form.guardianTitle": "Guardian",
		"dependent.form.proxyTitle": "Proxy",
		"dependent.form.careUserIdError": "Current user already taken",
		"dependent.form.parentInfo": "You are the Mother or Father of the Person you are adding",
		"dependent.form.guardianInfo": "You are the legal guardian of the Person you are adding ",
		"dependent.form.proxyInfo": "You are the legal Healthcare Proxy of the Person you are adding",
		"dependent.form.createComplete": "Your request is pending verification. \nPlease bring the power of attorney or health proxy documentation to the first visit for verification.",
		"dependent.form.unverifiedRequest": "Your request has not been approved. \nPlease bring the power of attorney or health proxy documentation to the first visit for verification.",
		"dependent.form.profileCreated": "{name}’s profile has been created",
		"dependent.form.becomeParent": "You became the Parent for {name}.",
		"dependent.dependentExists": "This person already has a parent/guardian in their Family Circle. Please ask this person to invite you to join the family circle.",
		"dependent.management.requestPending": "{careUser} wants to be a guardian/proxy for {dependent}. In case if you confirm this relationship all PII and PHI of the {dependent} will be seen and could be managed by {careUser}.",
		"dependent.management.removeConfirm": "Are you sure you want to deny the request?",
		"dependent.management.emptyMessage": "No requests at the moment",
		"dependent.management.appointmentPendingStatus.request": "{visitType} request for {careUser} and {provider}.",
		"dependent.management.appointmentPendingStatus.scheduled": "Scheduled by {scheduleUser}, {role}.",
		"dependent.management.appointmentPendingStatus.confirmed": "Confirmed by {signProvider}",
		"dependent.management.appointmentPendingStatus.declined": "Declined by {signProvider}",
		"dependent.management.appointmentPendingStatus.expired": "Request expired",
		"dashboard.filterResults": "Filter results",
		"dashboard.table.time": "Time",
		"dashboard.table.name_mrn": "Name/ID",
		"dashboard.table.dob_phone": "DOB/Phone",
		"dashboard.table.reason": "Appointment Type",
		"dashboard.table.location_service": "Location/Service",
		"dashboard.table.provider_room": "Provider/Room",
		"dashboard.table.status_payment": "Status/Payment",
		"dashboard.table.moveToFront": "Move to Front",
		"dashboard.table.changeStatus": "Change Status",
		"dashboard.table.assignRoom": "Assign Room",
		"dashboard.table.changePaymentStatus": "Change Payment Status to Paid",
		"dashboard.table.editPaymentAmount": "Edit Payment Amount",
		"dashboard.table.name": "Name",
		"dashboard.filter.filterVisits": "Filter Visits",
		"dashboard.filter.location": "Location",
		"dashboard.filter.service": "Service",
		"dashboard.filter.status": "Status",
		"dashboard.filter.clearAll": "Clear all",
		"dashboard.table.emptyFilterMessage": "No results match the filter criteria.\nPlease try to refine your query using other indicators.",
		"dashboard.table.emptyMessage": "No visits for this day.\nPlease try to refine your query using other indicators.",
		"dashboard.record.addRecord": "Add a Record",
		"dashboard.record.patientInfo": "Patient information",
		"dashboard.record.aboutVisit": "About visit",
		"dashboard.record.visitReason": "Appointment Type",
		"dashboard.record.room": "Room",
		"dashboard.record.paymentStatus": "Payment status",
		"dashboard.record.selectType": "Select the type",
		"dashboard.record.addReason": "Add the reason",
		"dashboard.record.locationExample": "e.g. Murabella; Palencia",
		"dashboard.record.serviceExample": "e.g. Laboratory",
		"dashboard.record.chooseTime": "Choose time",
		"dashboard.record.changeTime": "Change time",
		"dashboard.record.addInLine": "Add in line",
		"dashboard.record.addInLineNow": "Add in line on now",
		"dashboard.record.visitTime": "Visit Time",
		"dashboard.record.visitTime.map": "Visit time",
		"dashboard.record.validTime": "You can get in line only from {startTime} to {endTime}",
		"dashboard.record.updateVisitDetails": "Update visit details",
		"dashboard.record.notWorkingDay": "You can not get in line on a day off. Please, try again on a weekday",
		"dashboard.modal.title": "Do you want to proceed?",
		"appointments.visitType": "Visit Type",
		"appointments.myProviders": "My Providers",
		"appointments.seeAProvider": "Get Care",
		"appointments.pharmacies": "pharmacies",
		"appointments.successScheduleMsg": "Your visit is scheduled",
		"appointments.successSchedulePendingMsg": "Your visit request has been submitted. The Provider will confirm the visit.",
		"appointments.specialization": "Specialization",
		"appointments.emptyProviders": "No Available Providers for this day.",
		"appointments.emptySlots": "No Available slots for this day.",
		"appointments.confirmLeaveMessage": "Yes, start over",
		"appointments.confirmModalTitle": "If you close this page, you will have to start over. \nAre you sure?",
		"appointments.confirmModalText": "However, Patient info will be saved.",
		"appointments.form.book4me": "Book for me",
		"appointments.chooseOrganization": "Choose Organization",
		"appointments.emptyOrganizations": "You cannot schedule visit in your Organization(s) yet.\nPlease contact you Provider.",
		"appointments.emptyVisitTypes": "Sorry, the organization has no visits to schedule.\nPlease contact your Provider.",
		"appointments.form.step1.title": "New Visit",
		"appointments.form.step1.subTitle": "Who needs care?",
		"appointments.form.step2.title": "Get Care",
		"appointments.form.step2.subTitle": "for {user}",
		"appointments.form.step1.addNewPrimary": "Someone else?",
		"appointments.form.step1.addNewSecondary": "Add someone new",
		"appointments.form.consentForm": "Consent Form",
		"appointments.form.patientInfo": "Patient Info",
		"appointments.form.patientInfo.subtitle": "Please complete profile",
		"appointments.form.visitDetails": "Visit Details",
		"appointments.form.insuranceDetails": "Insurance Details",
		"appointments.form.insuranceDetails,success": "Insurance Data successful update",
		"appointments.form.noCoverage": "Insurance not verified",
		"appointments.form.noCoverage.tryAgain": "The insurance data has not been verified. Are you sure you want to save it?",
		"appointments.form.healthPlan": "Health plan",
		"appointments.form.changePlan": "Change plan",
		"appointments.form.searchPlan": "Search plan",
		"appointments.form.planNotListed": "Plan is not listed or Self-pay",
		"appointments.form.searchInsurance": "Search an Accepted Insurance Plan",
		"appointments.form.availableProviders": "Available Providers",
		"appointments.form.noAvailableProviders": "No Available Time Slots",
		"appointments.form.dateFilter": "Pick a day",
		"appointments.form.preferredPharmacy": "Preferred Pharmacy",
		"appointments.form.pharmacyLocation": "Pharmacy Location",
		"appointments.form.changePharmacy": "Change Pharmacy",
		"appointments.form.selectFromMap": "Select from Map",
		"appointments.form.searchForPharmacy": "Search for pharmacy",
		"appointments.form.emptyPharmacyList": "Enter the ZIP code of the pharmacy which you want to select as preferred.",
		"appointments.form.searchByZipCode": "Search by ZIP code",
		"appointments.form.showWithMailOrder": "Show pharmacies with mail order",
		"appointments.form.emergencyContact": "Emergency Contact",
		"appointments.form.guarantorInformation": "Guarantor information",
		"appointments.form.additionalInformation": "Additional Information",
		"appointments.form.completeYourProfile": "Check your profile information",
		"appointments.form.completeYourProfile.description": "Ensure this information is accurate and complete any missing details.",
		"appointment.form.patientDoc": "Patient Demographics",
		"appointment.form.hipaa": "HIPAA Consent",
		"appointment.form.costTitle": "Your Cost",
		"appointment.form.videoVisit": "Video Visit",
		"appointment.form.copayIsNotReceived": "Insurance copay was not found",
		"appointment.form.verifyInformation": "Please verify the insurance information was entered correctly or contact support for assistance",
		"appointment.form.overlap": "There is already an existing appointment at this time. Do you want to continue?",
		"appointment.form.error.notAvailableProvider.forSelectedService": "Provider is not available for selected service in selected location",
		"appointment.form.error.notAvailableProvider.forThisTime": "Provider is not available for this time",
		"appointment.form.error.notAvailableProvider.insuranceNotAccepted": "This insurance is not accepted. Please update the Health plan",
		"appointment.form.error.notAvailableProvider.notAccepted": "Not Accepted",
		"appointment.form.error.notAvailableProvider.combined": "Provider is not available for selected date and time or for selected service in selected location. Please choose other parameter of visit",
		"appointment.details.paymentAmount.title": "Payment amount, USD",
		"appointment.details.paymentStatus.title": "Payment status ",
		"appointment.details.visitDuration.title": "Visit Duration",
		"appointment.details.pendingMessage.visit.title": "Please wait for confirmation from provider",
		"appointment.documents.addDocument.title": "Add document",
		"appointment.documents.description": "Please, select the category and subcategory for the document.",
		"appointment.documents.successUpload": "Document uploaded",
		"appointment.documents.deleteMessage": "Are you sure you want to delete this document?",
		"appointment.surveys.title": "Forms",
		"appointment.surveys.title.upcoming": "Incomplete, Tap to answer",
		"appointment.surveys.notificationProvider": "Pre-visit form must be completed before the visit.",
		"appointment.surveysAndConsent.notificationProvider": "Pre-visit and Consent forms must be completed before the visit.",
		"appointment.programForm": "Program form",
		"appointment.preVisitForm": "Pre-visit form",
		"appointment.postVisitForm": "Post-visit form",
		"appointment.postVisitForm.notificationPatientLink": "Complete form",
		"appointment.consent.title": "Consent forms",
		"appointment.consent.signed": "Signed",
		"appointment.consent.notSigned": "Not signed",
		"appointment.consent.notificationProvider": "Consents should be signed by Patient before the visit.",
		"appointment.consent.notificationPatient": "Consents should be signed before the visit.",
		"appointment.consent.notificationPatientLink": "See consents",
		"appointment.consentAndSurvey.notificationPatientLink": "Complete",
		"appointment.consent.techConnectNotification": "Please note! Tech Connect has live queue on premise, so someone could bein front of you in line.",
		"appointment.consent.inLineNotification": "Please note there is a live queue onsite, so someone could be in front of you in line.",
		"appointment.consent.details.titleProvider": "Consent Form",
		"appointment.consent.details.titlePatient": "Signatures required",
		"appointment.consent.details.type": "Pre-visit Consent (required)",
		"appointment.consent.consentFor": "Consent for {serviceName}/{organizationName}",
		"appointment.consent.consentVersion": "Version",
		"appointment.consent.paper": "Paper consent",
		"appointment.consent.version": "Version {version}",
		"appointment.consent.titleMsg": "Sign Consent before the Visit",
		"appointment.consent.mainConsentTitle": "Please accept the {name} form before starting a conversation with a Provider",
		"appointment.electronicConsent.mainTitle": "Assigned Consent by {name}, Provider",
		"appointment.electronicConsent.details.titlePatient": "Signature required",
		"appointment.visitConfirmed": "Your visit is confirmed",
		"appointment.payment.title": "Payment",
		"appointment.payment.basePrice": "Base price",
		"appointment.payment.copay": "Copay",
		"appointment.payment.discount": "Discount",
		"appointment.payment.total": "Total",
		"appointment.payment.discountTitle": "Do you have a discount coupon?",
		"appointment.payment.discountText": "Enter your coupon code below",
		"appointment.payment.couponCode": "Coupon code",
		"appointment.payment.couponCodeAutomatic": "Coupon has been successfully applied",
		"appointment.payment.apply": "Apply",
		"appointment.payment.discountError": "Invalid Code",
		"appointment.payment.successMessage": "Payment successful",
		"appointment.payment.charged": "Your credit card will not be charged until the visit is completed",
		"appointment.payment.errorTitle": "Payment Error",
		"appointment.payment.errorMessage": "The payment was unsuccessful and your card was not charged. Please try again.",
		"appointment.payment.errorProvider": "This provider does not yet accept online payments",
		"appointment.payment.refunded": "Refunded",
		"appointment.payment.submitted": "Payment Submitted",
		"profile.payment.paymentMethods": "Payment methods",
		"profile.payment.addPaymentMethod": "Add Payment Method",
		"profile.payment.description": "Your cards associated with clinic payment accounts.",
		"profile.payment.hint": "Payment methods are saved separately for different accounts.\nSame card can appear more than once.",
		"profile.payment.noSavedPaymentMethods": "No saved payment methods",
		"profile.payment.expired": "Expired",
		"profile.payment.onlyForOrganizationMessage": "Adding payment methods is available only when an organization is set",
		"profile.payment.subscriptionMessage": "This payment method can't be removed right now because it's being used for an active subscription.",
		"profile.payment.removeMessage": "Are you sure you want to remove this payment method?",
		"profile.payment.removeUnsuccessfullyMessage": "The card removal was unsuccessful. \nPlease try again.",
		"profile.payment.informationAboutTheOrganizationTitle": "Information about the organization",
		"profile.payment.informationAboutTheOrganizationDescription": "To add a card, first choose the organization and location where you will use it.",
		"profile.payment.chooseOrganization": "Choose Organization",
		"profile.payment.chooseLocation": "Choose Location",
		"profile.payment.cardSuccessfullyAdded": "Card successfully added",
		"profile.payment.cardWasNotAdded.": "Card wasn't added. \nPlease try again.",
		"profile.payment.cardMenu.seeAssociatedLocations": "See associated locations",
		"profile.payment.cardMenu.removePaymentMethod": "Remove payment method",
		"profile.payment.popup.locationsInfo": "This payment method is available at the following clinic locations:",
		"profile.payment.removeSuccessfullyMessage": "Payment method removed successfully",
		"profile.payment.removeErrorMessage": "Payment method removal was unsuccessful. Please try again.",
		"profile.payment.fields.location": "Location",
		"profile.payment.fields.organization": "Organization",
		"profile.payment.addingLocationInfo": "Adding this location may also add other locations linked to the same payment account.",
		"profile.payment.addCardForFutureUse": "Add a card for future use.",
		"appointment.list.tabs.addAppointment": "Add Visit",
		"appointment.list.tabs.upcoming": "Upcoming",
		"appointment.list.tabs.inLine": "In Line",
		"appointment.list.tabs.history": "History",
		"appointment.list.card.startVisit": "Start Visit",
		"appointment.list.card.confirm": "Confirm",
		"appointment.list.card.provider": "Provider",
		"appointment.list.card.service": "Service",
		"appointment.list.card.reasonForVisit": "Appointment Type",
		"appointment.list.card.walkIn": "Walk-In",
		"appointment.list.card.yourCost": "Your cost",
		"appointment.list.card.patient": "Patient",
		"appointment.list.card.payment": "Payment",
		"appointment.list.card.videoVisitAW": "Please, join from the mobile app",
		"appointment.list.card.location": "Location",
		"appointment.upcoming.popup.title": "Upcoming {visitType}",
		"appointment.history.popup.title": "{status} {visitType}",
		"appointment.popup.title": "{status} {visitType}",
		"appointment.pending.popup.title": "Pending {visitType}",
		"appointment.actions.availableCheckInTime": "You can check-in one hour before visit",
		"appointment.actions.availableConfirm": "You can confirm 72 hours before the visit",
		"appointment.actions.checkIn": "Check-In",
		"appointment.actions.noShow": "No Show",
		"appointment.actions.complete": "Complete",
		"appointment.actions.cancelVisit": "Cancel Visit",
		"appointment.actions.pay": "Pay",
		"appointment.actions.payForVisit": "Pay for Visit",
		"appointment.actions.checkIn.warning": "Payment is required before check-in",
		"appointment.actions.startVisit.warning": "Payment is required before the visit",
		"appointment.actions.cancelVisitConfirmation": "This visit will be canceled. \nAre you sure?",
		"appointment.actions.cancelUrgentVisitConfirmation": "This visit will be canceled and payment will be refunded. Are you sure?",
		"appointment.actions.yesCancel": "Yes, Cancel",
		"appointment.actions.noGoBack": "No, Go back",
		"appointment.actions.yesChange": "Yes, change",
		"appointment.actions.changePaymentStatus": "Are you sure you want to change the Payment Status to Paid?",
		"appointment.actions.askProviderForCancel": "Contact your provider to cancel this visit",
		"appointment.actions.paymentRequired": "Payment is required",
		"appointment.actions.selectYourSlot": "Select your slot",
		"appointment.info.transactionDate": "Transaction date",
		"appointment.info.transactionId": "Transaction ID",
		"appointment.inlineVisit.status": "In-Line",
		"appointment.inlineVisit.availableTimeSlots": "Today’s Available Time Slots",
		"appointment.inlineVisit.success.inLine.title": "You are now in line",
		"appointment.inlineVisit.success.inLine.description": "Please note there is a live queue onsite, so someone could be in front of you in line",
		"appointment.inlineVisit.error.noAvailableTime": "Sorry, there is no available time today",
		"teams.teamMember": "Team members",
		"teams.teamCircle": "Team circle",
		"teams.teamCommunityEmpty": "please select your individual account to interact with communities",
		"healthboard.invitations.card.subTtitle": "{role} role for {name}",
		"healthboard.invitations.card.title": "Join {name}’s Family Circle",
		"healthboard.invitations.modal.title": "Join Family Circle",
		"healthboard.providersNavTitle": "Practice Providers",
		"healthboard.program.card.type": "Program Invite",
		"healthboard.appointments.mobileAppAvailable": "Available in the mobile app",
		"healthboard.appointments.paymentStatus.paid": "Paid",
		"healthboard.appointments.paymentStatus.unpaid": "Unpaid",
		"healthboard.appointments.paymentStatus.amountPending": "Amount Pending",
		"healthboard.appointments.paymentStatus.paidAmount": "${paidAmount} paid",
		"healthboard.appointments.paymentStatus.refunded": "${paidAmount} refunded",
		"healthboard.appointments.paymentStatus.unpaidAmount": "${price} unpaid",
		"healthboard.appointments.paymentStatus.pendingPaymentInfo": "Pending payment info",
		"healthboard.appointments.paymentStatus.processingPayment": "Processing Payment",
		"healthboard.appointments.paymentStatus.tapToPay": "${price} to pay",
		"healthboard.appointments.paymentStatus.totalToPay": "Total ${price}",
		"healthboard.appointments.paymentStatus.voided": "Payment voided ${paidAmount}",
		"healthboard.appointments.upcoming": "Upcoming Visits",
		"healthboard.appointments.history": "Visits History",
		"healthboard.title.upcomingAppointmentsEmpty": "No upcoming visits",
		"healthboard.text.upcomingAppointmentsEmpty": "Tap Get Care above to schedule a visit.",
		"healthboard.title.historyAppointmentsEmpty": "No history visits",
		"healthboard.text.historyAppointmentsEmpty": "Tap on Get Care button to schedule a visit",
		"healthboard.empty.forPatient": "Ask a provider to schedule a visit.",
		"healthboard.empty.forProviderInContext": "Tap Add Visit to schedule a visit.",
		"healthboard.empty.forProvider": "Go to the Patient's Visits context to schedule a visit.",
		"healthboard.title.appointments": "Visits",
		"healthboard.action.seeCompleted": "See completed",
		"healthboard.title.surveysCompleted": "Great! Keep up the good work!",
		"healthboard.text.surveysCompleted": "To Do List is Complete.",
		"healthboard.title.surveysEmpty": "To Do List is empty",
		"healthboard.title.todoEmpty": "Great Job! To Do List is empty",
		"healthboard.title.todoCompleted": "You have no completed To Dos yet",
		"healthboard.text.surveysEmpty": "Get care to become a patient and see your to do’s here.",
		"healthboard.title.dependentPending": "Your request is pending by provider",
		"healthboard.text.dependentPending": "Please bring your power of attorney or health proxy documentation to the first visit for verification.",
		"healthboard.title.dependentUnverified": "Your request has not been approved",
		"healthboard.text.dependentUnverified": "Please bring your power of attorney or health proxy documentation to the first visit for verification.",
		"healthboard.title.teamPlaceholder": "please select your individual account to interact with healthboard",
		"healthboard.notAvailable": "Not Available\nPlease contact support to setup Healthboard",
		"healthboard.filter.virtualVisit": "Virtual Visit",
		"healthboard.filter.clearFilters": "Clear filters",
		"healthboard.buttons.additionalResources": "See additional resources",
		"password.validation.title": "Password must include:",
		"password.validation.upperCase": "at least one upper case letter;",
		"password.validation.lowerCase": "at least one lower case letter;",
		"password.validation.number": "at least one number;",
		"password.validation.specCharacter": "at least one special character, except space;",
		"password.validation.charactersNumber": "at least 6 characters.",
		"virtualVisit.room.join": "{name} has joined the call",
		"virtualVisit.room.leave": "{name} has left the call",
		"virtualVisit.room.talking": "talking",
		"virtualVisit.room.isTalking": "{name} is talkin",
		"virtualVisit.room.multipleTalking": "{speakersCount} are talking",
		"virtualVisit.room.callMembers": "Call members",
		"virtualVisit.room.pendingInvitation": "(Pending invitation)",
		"virtualVisit.room.sentInvitation": "Invitation(s) Sent",
		"virtualVisit.room.invitationRemoved": "Invitation link is removed",
		"virtualVisit.paymentGate.title": "Complete payment",
		"virtualVisit.paymentGate.description": "Payment is required before the visit. Please complete your payment to join the visit.",
		"virtualVisit.paymentGate.yourCost": "Your Cost:",
		"virtualVisit.paymentGate.total": "Total {amount}",
		"virtualVisit.paymentGate.pay": "Pay",
		"virtualVisit.title": "{visitType} for {name}",
		"virtualVisit.room": "Room",
		"virtualVisit.duration": "Duration",
		"virtualVisit.error.alreadyInCall": "Allready in call",
		"virtualVisit.unstableConnection": "Unstable internet connection",
		"virtualVisit.error.sessionExpired.title": "Connection Issue",
		"virtualVisit.error.sessionExpired": "Failed to connect to session",
		"virtualVisit.error.notConnected": "Couldn't perform action because you are not connected to the network",
		"virtualVisit.error.cameraMicrophoneUnavailable.title": "Camera/microphone unavailable",
		"virtualVisit.error.cameraMicrophoneUnavailable.description": "The camera/microphone is in use by another application. In order to proceed, please close all other applications.",
		"virtualVisit.error.noDevicesFound.title": "No devices",
		"virtualVisit.error.noDevicesFound": "No devices were found to provide the media stream",
		"virtualVisit.error.noValidConstraints.title": "No valid constraints",
		"virtualVisit.error.noValidConstraints": "Video and audio were both disabled. You need to enable at least one",
		"virtualVisit.error.notSupported.title": "Not Supported",
		"virtualVisit.error.notSupported": "Something in the user media request is not supported",
		"virtualVisit.error.expired.title": "Visit Expired",
		"virtualVisit.error.expired": "Access to visit has been expired",
		"virtualVisit.error.invalidLink": "This link is not valid. Please check and try again.",
		"virtualVisit.error.visitCompleted": "The visit has been completed",
		"virtualVisit.error.callCompleted": "The call has been completed",
		"virtualVisit.virtualVisit": "Virtual visit",
		"virtualVisit.regural.placeholder.title": "You have joined the virtual waiting room",
		"virtualVisit.regural.placeholder.subtitle": "Please do not leave this screen. Your provider should be with you shortly.",
		"virtualVisit.placeholder.title": "Your visit will begin shortly",
		"virtualVisit.placeholder.subtitle": "The next available Provider will join the room",
		"virtualVisit.removeInvitationLink.description": "Are you sure you want to remove an invitation link for {email}?",
		"inOfficeVV.join": "Join visit",
		"inOfficeVV.code": "Code",
		"inOfficeVV.enterCode": "Please enter the visit code to join.",
		"inOfficeVV.error.invalid": "The code entered is invalid",
		"inOfficeVV.error.alreadyNotAvailble": "The room already is not available",
		"inOfficeVV.error.noteYetAvailable": "The room is not yet available",
		"virtualVisit.details.title": "Visit Details",
		"virtualVisit.details.appointmentProvider": "Visit provider",
		"virtualVisit.details.paymentAmount": "Payment amount",
		"virtualVisit.details.paymentAmountUsd": "Payment amount, USD",
		"virtualVisit.details.schedule": "Schedule",
		"virtualVisit.details.futureTime": "Please pick future time for the visit",
		"virtualVisit.details.visitScheduled": "Visit is scheduled",
		"virtualVisit.device.mic": "Your microphone:",
		"virtualVisit.device.video": "Your camera:",
		"virtualVisit.inviteGuest.title": "Invite Guest",
		"virtualVisit.inviteGuest.addGuest": "Add another guest",
		"virtualVisit.inviteGuest.description": "You can invite one or more guests to join this visit",
		"virtualVisit.test.cancel": "Cancel test",
		"virtualVisit.test.check": "Check video/audio",
		"virtualVisit.test.retest": "Re-test video/audio",
		"virtualVisit.test.test": "Test video/audio",
		"virtualVisit.test.continue": "or continue to",
		"virtualVisit.test.progress": "Testing in progress…",
		"virtualVisit.test.completed": "Test Complete",
		"virtualVisit.test.connectivity": "Connectivity",
		"virtualVisit.test.startsSoon": "Your visit starts soon",
		"virtualVisit.test.desc": "We recommend you make the system quality test before you start the visit. \nYou can be sure that audio/video quality allows you \nto make the visit without problems.",
		"virtualVisit.test.videoQuality": "Video Quality:",
		"virtualVisit.test.audioQuality": "Audio Quality:",
		"virtualVisit.test.videoSubtitle": "Move something in view of the camera to check that it is working.",
		"virtualVisit.test.audioSubtitle": "Say something in the microphone to check that it is working.",
		"virtualVisit.test.result.excellent": "Excellent",
		"virtualVisit.test.result.good": "Good",
		"virtualVisit.test.result.fair": "Fair",
		"virtualVisit.test.result.poor": "Poor",
		"virtualVisit.test.result.bad": "Bad",
		"virtualVisit.test.result.failure": "Failure",
		"virtualVisit.test.camera": "Camera",
		"virtualVisit.test.mic": "Microphone",
		"virtualVisit.test.description": "If you have audio and video problems, you can always check your devices in settings.",
		"virtualVisit.test.openSettings": "Open settings",
		"virtualVisit.test.deviceNotFound": "Device Not Found",
		"virtualVisit.test.video": "Video",
		"virtualVisit.test.audio": "Audio",
		"virtualVisit.test.noAudio": "Microphone: undefined",
		"virtualVisit.test.noVideo": "Camera: undefined",
		"virtualVisit.canceledByProvider": "The visit was canceled by provider",
		"virtualVisit.complete": "Visit сomplete",
		"virtualVisit.joinVirtualVisit": "You can join the virtual visit only at the office",
		"media.permissions.request.title": "Please give access to your microphone/camera",
		"media.permissions.request.description": "To make this call, we need permission to use your microphone and camera. Click the lock icon in your browser's address bar and allow access.",
		"media.permissions.mob.safari": "To grant permission to access your camera/microphone, go to your device Settings > Safari > Camera/Microphone.",
		"media.permissions.mob.chrome_ios": "To grant permission to access your camera/microphone, go to your device Settings > Privacy > Camera/Microphone > Chrome.",
		"media.permissions.mob.chrome_android": "To grant permission to access your camera/microphone, go to your device Settings > Apps > Chrome > Permissions.",
		"media.permissions.denied.title": "Can’t access your microphone/camera",
		"media.permissions.denied.chrome": "To make this call, we need permission to use your microphone and camera. Click the blocked camera icon in your browser's address bar.",
		"media.permissions.denied.safari": "To make this call, we need permission to use your microphone and camera. Click the Safari menu > Settings for website.",
		"media.permissions.denied.default": "To make this call, we need access to your microphone and camera. Please check the website permissions in your browser settings.",
		"virtualVisit.test.canAccessMicroCamera": "Can't access your microphone/camera",
		"virtualVisit.test.giveAccessMicroCamera": "Please, give access to your computer's microphone/camera to proceed.",
		"calendar.overlapAppointment": "There is already an existing appointment at this time. Do you want to continue?",
		"calendar.overwriteTitile": "You are about to overwrite further overlapping schedule. \nOverwrite it?",
		"calendar.overwrite": "Overwrite",
		"calendar.manageSchedule": "Manage Schedule",
		"calendar.edit.title": "Edit work schedule template",
		"calendar.read.title": "Work schedule",
		"calendar.addSchedule": "Add new schedule",
		"calendar.blockedSlots": "Blocked slots",
		"calendar.blocked": "Blocked",
		"calendar.editSchedule": "Edit schedule",
		"calendar.editBlock": "Edit Block",
		"calendar.blockSchedule": "Block schedule",
		"calendar.colorMarker": "Color marker",
		"calendar.diffSettins": "Selected range has different settings",
		"calendar.tabs.add": "Add schedule",
		"calendar.tabs.block": "Block slot(s)",
		"calendar.tabs.schedule": "Edit schedule",
		"calendar.tabs.repeat": "Edit repeat",
		"calendar.repeat.title": "Repeat",
		"calendar.repeat.noRepeat": "No repeat",
		"calendar.repeat.weekly": "Weekly",
		"calendar.repeat.weeklyOn": "Weekly on",
		"calendar.repeat.until": "until",
		"calendar.repeat.custom": "Custom",
		"calendar.repeat.endDate": "End date",
		"calendar.repeat.everyWeek": "Every week on:",
		"calendar.week.sunday": "Sun",
		"calendar.week.monday": "Mon",
		"calendar.week.tuesday": "Tue",
		"calendar.week.wednesday": "Wed",
		"calendar.week.thursday": "Thu",
		"calendar.week.friday": "Fri",
		"calendar.week.saturday": "Sat",
		"calendar.appointment.restrict": "You cannot schedule visits in {location}: {service}",
		"calendar.mobileWarning": "sorry this resolution is not supported.\nPlease use the device with a higher resolution to interact with calendar.",
		"calendar.repeat.currentDay": "Current day",
		"calendar.repeat.currentAndNext": "Current and following days",
		"calendar.repeat.followingDays": "Following days",
		"calendar.repeat.allDays": "All days",
		"calendar.legend.officeVisit": "Office visit",
		"calendar.legend.virtualVisit": "Virtual visit",
		"calendar.legend.pendingVisit": "Pending visit",
		"calendar.legend.blockedSlot": "Blocked slot",
		"calendar.appointmentForm.patientSearch": "Start typing to see list of Patients",
		"calendar.recursion.editWorkSlot": "Apply recurring schedule for",
		"calendar.recursion.editBlockkSlot": "Apply recurring schedule for",
		"calendar.recursion.removeWorkSlot": "Remove recurring schedule for",
		"calendar.recursion.removeBlockkSlot": "Remove recurring blocked slot for",
		"calendar.errors.insert.common": "Error during insert schedule",
		"calendar.errors.remove.common": "Error during remove schedule",
		"calendar.errors.search.common": "Error during load schedule calendar",
		"calendar.errors.update.common": "Error during update schedule",
		"calendar.errors.appointment.unavailableProvider": "Provider is not available for the whole duration of visit",
		"calendar.errors.appointment.patientTypeMismatch": "Selected Patient doesn't match the specified Patient Type",
		"calendar.errors.appointment.common": "Error during appointment schedule",
		"guarantor.addGuarantor": "Add guarantor",
		"guarantor.addAGuarantor": "Add a guarantor",
		"guarantor.removeMessage": "Are you sure you want to remove  {name} from the list? ",
		"guarantor.role.selfGuarantor": "I am the Guarantor",
		"guarantor.role.userNameGuarantor": "{name} is the Guarantor",
		"guarantor.selectGuarantor.description": "Select or add the person who will be financially responsible for any related charges.",
		"guarantor.selectGuarantor.addressProvide": "Please provide the guardian’s address to proceed.",
		"guarantor.fields.dob": "Date of Birth",
		"guarantor.fields.mobilePhone": "Phone Number",
		"guarantor.fields.email": "Email address",
		"guarantor.fields.gender": "Gender",
		"guarantor.fields.relation": "Relationship",
		"guarantor.fields.address1": "Address 1",
		"guarantor.fields.address2Optional": "Address 2 (Optional)",
		"guarantor.fields.city": "City",
		"guarantor.fields.state": "State",
		"guarantor.fields.postalCode": "Postal / ZIP code",
		"mobile.app.title": "We’re available on your mobile!",
		"mobile.app.getAppText": "Get the {name} app for your mobile device to be connected at any time",
		"task.seeLocations": "See locations",
		"task.upcoming": "Upcoming Task",
		"task.canceled": "Canceled task",
		"task.completed": "Completed Task",
		"task.assigned": "Assigned Task",
		"task.overdue": "Overdue",
		"task.dueToday": "Due Today",
		"task.dueTomorrow": "Due Tomorrow",
		"task.alreadyCompleted": "Task is already completed.",
		"task.selectOutcome": "Select task outcome:",
		"task.outcome": "Task outcome:",
		"task.acceptedFileTypes": "Accepted file types: pdf, jpg, jpeg, png.",
		"task.error.acceptedFileType": "Please choose accepted file type: pdf, jpg, jpeg, png",
		"task.error.acceptedFileSize": "Document should not be larger than 32MB",
		"task.error.uploadFailed": "Documents upload has failed. Please complete the task again",
		"googleMaps.miAway": " mi away",
		"googleMaps.closed": "Closed",
		"googleMaps.location": "Location",
		"googleMaps.about": "About",
		"googleMaps.workingHours": "Working hours",
		"googleMaps.popup.title": "Geo-locations",
		"googleMaps.popup.title.locations": "Locations",
		"patient.healthboard.value": "Value",
		"patient.healthboard.normalRange": "Normal Range",
		"patient.healthboard.title": "Patient Healthboard",
		"patient.healthboard.steps": "Steps",
		"patient.healthboard.steps.metric": "steps",
		"patient.healthboard.vitalsActivity": "Vitals & Activity",
		"patient.healthboard.distance": "Distance",
		"patient.healthboard.distance.metric": "mi",
		"patient.healthboard.bmi": "BMI",
		"patient.healthboard.weight": "Weight",
		"patient.healthboard.weight.metric": "lbs",
		"patient.healthboard.weight.metric.kg": "kg",
		"patient.healthboard.height": "Height",
		"patient.healthboard.height.metric.feet": "ft",
		"patient.healthboard.height.metric.feetAndInch": "ft & in",
		"patient.healthboard.height.metric.inches": "in",
		"patient.healthboard.height.metric.cm": "cm",
		"patient.healthboard.temperature.metric.celsius": "°C",
		"patient.healthboard.temperature.metric.fahrenheit": "°F",
		"patient.healthboard.medications": "Medications",
		"patient.healthboard.labTestResult": "Lab & Test Results",
		"patient.healthboard.vaccines": "Vaccines",
		"patient.healthboard.allergies": "Allergies",
		"patient.healthboard.contextOf": "In context of",
		"patient.healthboard.titleHistoric.bmi": "All BMI Data",
		"patient.healthboard.titleHistoric.blood_glucose": "All Blood Glucose Data",
		"patient.healthboard.titleHistoric.weight": "All Weight Data",
		"patient.healthboard.titleHistoric.height": "All Height Data",
		"patient.healthboard.titleHistoric.steps": "All Steps Data",
		"patient.healthboard.titleHistoric.distance": "All Distance Data",
		"patient.healthboard.titleHistoric.spo2": "All Oxygen Saturation Data",
		"patient.healthboard.titleHistoric.heart_rate": "All Heart Rate Data",
		"patient.healthboard.titleHistoric.all.blood_pressure": "All Blood Pressure Data",
		"patient.healthboard.titleHistoric.blood_pressure": "Blood Pressure Data",
		"patient.healthboard.titleHistoric.all.respiratory_rate": "All Respiratory Rate Data",
		"patient.healthboard.titleHistoric.respiratory_rate": "Respiratory Rate Data",
		"patient.healthboard.titleHistoric.bsa": "All Body Surface Area Data",
		"patient.healthboard.titleHistoric.body_temperature": "All Body Temperature Data",
		"patient.healthboard.average": "Average",
		"patient.healthboard.total": "Total",
		"patient.healthboard.graf.emptyState": "no data",
		"patient.healthboard.list.loadMore": "Load more",
		"patient.healthboard.saturation": "Oxygen Saturation (SpO",
		"patient.healthboard.saturation.index": "2",
		"patient.healthboard.saturation.metric": "%",
		"patient.healthboard.saturation.info": "Info",
		"patient.healthboard.saturation.description": "Oxygen saturation is a measure of the amount of oxygen in the protein (hemoglobin) in your red blood cells. To function properly, your body needs a certain level of oxygen circulating in the blood. Your red blood cells are loaded (saturated) with oxygen in the lungs and carry it throughout your body.",
		"patient.healthboard.saturation.mayoClinic": "Mayo Clinic Staff. (2018, December 1). Mayo Clinic. Hypoxemia Retrieved from ",
		"patient.healthboard.saturation.mayoClinicTitle": "Mayo Clinic",
		"patient.healthboard.myDevices": "My Devices",
		"patient.healthboard.ccd": "Health Record",
		"patient.healthboard.allSources": "All Sources",
		"patient.healthboard.source": "Source",
		"patient.healthboard.minMaxData": "Min-Max data",
		"patient.healthboard.totalData": "Total data",
		"patient.healthboard.averageData": "Average data",
		"patient.healthboard.devices": "Devices",
		"patient.healthboard.minMax": "Min-Max",
		"patient.healthboard.userDevices": "{name}'s Devices",
		"patient.healthboard.blood_pressure": "Blood Pressure",
		"patient.healthboard.blood_pressure.systolic": "Systolic",
		"patient.healthboard.blood_pressure.diastolic": "Diastolic",
		"patient.healthboard.blood_pressure.metric": "mmHg",
		"patient.healthboard.respiratory_rate": "Respiratory Rate",
		"patient.healthboard.respiratory_rate.metric": "breaths/min",
		"patient.healthboard.clickSeeAllData": "Click to see all data",
		"patient.healthboard.heart_rate": "Heart Rate",
		"patient.healthboard.heart_rate.metric": "BPM",
		"patient.healthboard.bsa": "Body Surface Area (BSA)",
		"patient.healthboard.bsa.metric": "m",
		"patient.healthboard.bsa.metricIndex": "2",
		"patient.healthboard.body_temperature": "Body Temperature",
		"patient.healthboard.blood_glucose": "Blood Glucose",
		"patient.healthboard.body_temperature.metric.fahrenheit": "°F",
		"patient.healthboard.body_temperature.metric.celsius": "°C",
		"patient.healthboard.blood_glucose.metric.millimoles_per_liter": "mmol/L",
		"patient.healthboard.blood_glucose.metric.milligrams_per_deciliter": "mg/dL",
		"patient.healthboard.labTestHistory.selector.five": "Last 5 results",
		"patient.healthboard.labTestHistory.selector.ten": "Last 10 results",
		"patient.healthboard.labTestHistory.selector.all": "All results",
		"patient.healthboard.labTestHistory.selector.custom": "Custom",
		"patient.healthboard.labTestHistory.modalTitle": "Test Results Details",
		"patient.healthboard.labTestHistory.range": "Range",
		"patient.healthboard.fitBit": "FitBit",
		"patient.healthboard.withings": "Withings",
		"patient.healthboard.apple": "Apple Health",
		"patient.healthboard.googleFit": "Google Fit",
		"patient.healthboard.tenovi": "Tenovi",
		"patient.healthboard.iHealth": "iHealth",
		"patient.healthboard.local": "Manual Input",
		"patient.portal.vitals_and_activity": "Vitals & Activity",
		"patient.portal.medications": "Medications",
		"patient.portal.immunizations": "Immunizations",
		"patient.portal.lab_and_test_results": "Lab & Test Results",
		"patient.portal.allergies": "Allergies",
		"patient.portal.conditions": "Conditions",
		"patient.portal.social_histories": "Social History",
		"patient.portal.family_histories": "Family History",
		"patient.portal.health_record": "Health Record",
		"patient.portal.encounters": "Encounters",
		"patient.portal.activity_log": "Activity Log",
		"patient.portal.activity_log.emptyState": "Activity",
		"patient.portal.medications.prescribedDate": "Prescribed Date",
		"patient.portal.medications.pharmacy": "Pharmacy",
		"patient.portal.medications.directions": "Directions",
		"patient.portal.medications.address": "Address",
		"patient.portal.medications.startDate": "Start date",
		"patient.portal.medications.selfReported": "Self Reported",
		"patient.portal.allergies.severity": "Severity",
		"patient.portal.allergies.type": "Allergy Type",
		"patient.portal.allergies.effectiveDate": "Effective Date",
		"patient.portal.conditions.active": "Active",
		"patient.portal.conditions.resolved": "Resolved",
		"patient.portal.data.emptyState": "No {type}",
		"patient.portal.data.noActiveMedications": "No Active Medications.",
		"patient.portal.data.noActiveMedications.tap": "Tap Show Inactive to view previous data.",
		"patient.portal.labTestResult.modalTitle": "Test Results Details",
		"patient.portal.labTestResult.result": "Result",
		"patient.portal.labTestResult.noDetected": "No Detected",
		"patient.portal.labTestResult.detected": "Detected",
		"patient.portal.labTestResult.availablePdfIvy": "You will receive a notification when the report is available",
		"patient.portal.labTestResult.normalState": "Normal State",
		"patient.portal.labTestResult.normalRange": "Normal Range",
		"patient.portal.labTestResult.normalRangeState": "Normal Range/State",
		"patient.portal.labTestResult.low": "Low",
		"patient.portal.labTestResult.normal": "Normal",
		"patient.portal.labTestResult.high": "High",
		"patient.portal.emptyState.addData": "Add {type}",
		"patient.portal.emptyState.bodyInfo": "Body Info",
		"patient.portal.emptyState.stepsOrDistance.noData": "No activity data",
		"patient.portal.emptyState.stepsOrDistance.addAccount": "Would you like to add a device account?",
		"patient.portal.emptyState.goToSettings": "Go to Settings",
		"patient.portal.diagnosis": "Diagnosis",
		"patient.portal.errorTime": "Cannot set time to be in the future.",
		"patient.portal.healthRecord.emptyState.nothingFound": "Nothing found",
		"patient.portal.healthRecord.emptyState.tryToChoose": "Try to choose a different period",
		"patient.portal.healthRecord.dateRange": "Date range",
		"patient.portal.healthRecord.search": "Search",
		"patient.portal.healthRecord.openAsCCD": "Open as CCD",
		"patient.portal.healthRecord.openAsPDF": "Open as PDF",
		"patient.portal.healthRecord.openAs": "Open as {fileType}",
		"patient.portal.healthRecord.downloadAsCCD": "Download as CCD",
		"patient.portal.healthRecord.downloadAsPDF": "Download as PDF",
		"patient.portal.healthRecord.downloadAsZIP": "Download as ZIP",
		"patient.portal.healthRecord.downloadAs": "Download as {fileType}",
		"patient.portal.healthRecord.shareToChat": "Share to Chat",
		"patient.portal.healthRecord.shareToEmail": "Share to E-mail",
		"patient.portal.healthRecord.shareToChatSuccess": "You have shared the link to {recipient}",
		"patient.portal.healthRecord.shareToEmailSuccess": "E-mail sent",
		"patient.portal.healthRecord.shareToEmail.description": "Share your health record by emailing a link.",
		"patient.portal.healthRecord.shareToEmailRecipient": "Recipient E-mail",
		"patient.portal.healthRecord.shareToEmail.validationMsg": "Invalid format. Please reenter the email address using the standard format: example@example.com",
		"patient.portal.healthRecord.shareToEmail.confirmTitle": "The e-mail will be sent to {recipient}.",
		"patient.portal.healthRecord.shareToEmail.confirmQuestion": "Are you sure?",
		"patient.portal.healthRecord.shareToEmail.confirmButton": "Yes, send e-mail",
		"patient.portal.healthRecord.activityLog.seeMembers": "See members",
		"patient.portal.healthRecord.activityLog.you": "You",
		"patient.portal.healthRecord.activityLog.guardianProxy": "Guardian/Proxy",
		"patient.portal.healthRecord.activityLog.patient": "Patient",
		"patient.portal.healthRecord.activityLog.viewed": "viewed",
		"patient.portal.healthRecord.activityLog.downloaded": "downloaded",
		"patient.portal.healthRecord.activityLog.transmitted": "transmitted",
		"patient.portal.healthRecord.activityLog.to": "to",
		"patient.portal.healthRecord.activityLog.user": "User",
		"patient.portal.healthRecord.activityLog.chatMembers": "Chat members",
		"patient.portal.procedures": "Procedures",
		"patient.portal.requestRefills": "Request Refill",
		"patient.portal.refillHistory": "Refill History",
		"patient.portal.unavailablePharmacy": "Something went wrong. Please update the data or contact support.",
		"patient.portal.selectMedications": "Select Medications",
		"patient.portal.requestRefillProvider": "Please contact your Provider to request a refill for medications.",
		"patient.portal.requestRefillNotification": "Please allow for 72 hours for this request\n to be processed.",
		"program.card.leave": "Leave Program",
		"program.card.leave.title": "Are you sure you want to leave program?",
		"program.card.leave.body": "You will lose access to the benefits of the program.",
		"program.card.leave.body.ar": "{dependentName} will lose access to the benefits of the program.",
		"program.consent.for": "Consent For {name}",
		"program.consent.subtitle": "Program Consent",
		"program.consent.title": "Sign consent before accept invitation",
		"program.invite.title": "{name} program",
		"program.invite.programCost": "Program Cost:",
		"program.invite.details.title": "Join to Program",
		"program.invite.details.descriptionTitle": "About the program",
		"program.invite.details.titleInvite": "has invited you to join {name} program.",
		"program.invite.notification.removed": "Invite was removed",
		"program.invite.notification.joined": "You have joined the program",
		"program.invite.notification.joinedAR": "{dependentName} has joined the program",
		"program.invite.notification.declined": "Program Invite was declined",
		"program.invite.notification.completed": "Invite is already completed",
		"paya.payment.amount": "Amount",
		"paya.payment.startDate": "Start date",
		"paya.payment.card": "Card",
		"paya.payment.addNewPaymentMethod": "Add Payment Method",
		"paya.payment.submitPayment": "Submit Payment",
		"paya.payment.cardAgreement": "I agree to pay the above total according to my card issuer agreement",
		"paya.payment.automaticallyRenew": "I agree to automatically renew my membership and authorize reoccurring charges to this card until I elect to cancel my membership.",
		"paya.payment.transactionDescription": "By authorizing this transaction, customer agrees that merchant may convert this transaction into an Electronic Funds Transfer (EFT) transaction or paper draft, and to debit this account for the amount of the transaction. Additionally, in the event this draft or EFT is returned unpaid, a service fee, as allowable by law, will be charged to this account via EFT or draft. In the event you choose to revoke this authorization, please do so by contacting the merchant directly. Please note that processing times may not allow for revocation of this authorization.",
		"program.membership.pay": "Pay",
		"program.membership.payaAccountForm.title": "Add Payment Method",
		"program.membership.payaResponse.static": "The payment was unsuccessful and your card was not charged. Please try again.",
		"program.membership.payaResponse.success": "You have joined {programName} program.",
		"program.membership.payaResponse.dependent.success": "{dependentName} has joined {programName} program.",
		"program.membership.title": "Membership",
		"program.membership.nextPayment": "Next payment",
		"program.membership.paymentDue": "Payment due",
		"program.membership.prepaid": "(paid)",
		"program.membership.prepay": "Prepay next period",
		"program.membership.prepay.success": "Your membership has been updated",
		"program.membership.prepay.dependent.success": "{dependentName}`s membership has been updated",
		"visitType.urgentCare.description": "If you think you or a family member is having a medical or psychiatric emergency, call 911. Do not attempt to access emergency care through this app.",
		"visitType.locations": "{name} Locations",
		"visitType.publix": "Publix",
		"visitType.publix.title": "How it works",
		"appointmentForm.appointmentLocations.waitTime": "Wait time",
		"appointmentForm.appointmentLocations.minutes": "minutes",
		"appointmentForm.rescheduleFlow.notification": "This Provider has only virtual visits available.",
		"appointmentForm.rescheduleFlow.notification.onlineVisit": "online visit",
		"appointmentForm.rescheduleFlow.notification.warning": "Please note this visit is an {visit}. You do not need to go the location.",
		"paperwork": "Paperwork",
		"paperwork.dob.title": "Confirm date of birth",
		"paperwork.dob.description": "For the patient's privacy, please confirm their date of birth to continue.",
		"paperwork.dob.fieldLabel": "Patient's date of birth",
		"paperwork.dob.confirm": "Confirm",
		"paperwork.dob.agreeWithTermsAndPolicy": "By clicking “Confirm” you agree to our {terms} and {policy}.",
		"paperwork.error.appointmentUnavailable": "The information you entered doesn't match any upcoming visit.",
		"paperwork.signConsent": "Sign Consent",
		"paperwork.submit": "Submit Paperwork",
		"paperwork.insuranceDetails": "Insurance Details",
		"paperwork.signConsentBeforeVisit": "Sign Consent before the Visit",
		"paperwork.upcomingVisitDetails": "Upcoming Visit Details",
		"paperwork.error.verifyDob.invalidDob": "We couldn't verify the date of birth. Please check the entered date and try again. If this keeps happening, contact support for assistance.",
		"paperwork.button.complete": "Complete Paperwork",
		"paperwork.visitPrepMessage": "This helps your provider prepare and ensures a smoother experience.",
		"paperwork.requiredInfoNote": " Please fill out the required information in ",
		"paperwork.canceledVisit": "Canceled",
		"paperwork.editPaperwork": "Edit Paperwork",
		"paperwork.completed": "Pre-visit paperwork completed",
		"paperwork.completed.label": "Pre-visit paperwork has been successfully saved — you're all set for your visit!",
		"paperwork.completed.info": "You can review/edit your information below or close this page at anytime.",
		"paperwork.section.pcpSectionTitle": "Primary Care Provider",
		"paperwork.section.yourPCPName": "Your PCP's name",
		"paperwork.dialog.resendCode": "Resend code {counter} sec.",
		"paperwork.dialog.verifyingLink": "Verifying your link\n and protecting your data",
		"paperwork.modal.confirmDeleteInsurance": "Are you sure you want to delete this insurance?",
		"paperwork.modal.deleteInsuranceWarning": "The insurance data you entered will not be saved.",
		"payment.accountForm.cardNotPermitted": "Card Not Permitted",
		"other.goToMozzaz": "Portal"
	};

/***/ }),
/* 5358 */
/***/ (function(module, exports) {

	module.exports = {
		"general.formats.dayFormattingPattern": "MMMM DD, YYYY",
		"general.formats.datePatternAPI": "YYYY-MM-DD",
		"general.formats.datePatternUI": "MM-DD-YYYY",
		"general.formats.shortDatePattern": "MMM DD",
		"general.formats.fullShortDatePattern": "MMM DD, YYYY",
		"general.formats.timePattern": "hh:mm a",
		"general.title": "{brandName}",
		"general.description": "Atención de salud fuera del hospital",
		"general.slogan.primary": "La red global para el compromiso del paciente",
		"general.slogan.secondary": "El compromiso del paciente - en cualquier lugar, en cualquier momento",
		"general.labels.you": "(You)",
		"general.labels.YO": "y.o.",
		"general.labels.noInternet": "Sin conexión a Internet",
		"general.labels.myProfile": "Mi perfil",
		"general.labels.profile": "Perfil",
		"general.labels.backToInvitation": "Volver al proceso de invitación",
		"general.labels.userNameExample": "JohnDoe_123 o Wolverine",
		"general.labels.userNameExplanation": "Apodo es un alias que se utilizará para identificarse en sus publicaciones. Sea creativo si prefiere ser anónimo.",
		"general.labels.pickItemLeft": "Elija un artículo que le gustaría ver en la barra lateral izquierda",
		"general.errors.404": "¡Vaya! No hay nada que ver aquí.",
		"general.toTop": "Ir a la cima",
		"general.success": "Éxito",
		"general.removedFromChat": "Has sido borrado de esta conversación.",
		"general.search.placeholder": "Buscar...",
		"general.search.patients": "Buscar pacientes...",
		"common.remove": "Retirar",
		"common.accept": "Aceptar",
		"common.decline": "Disminuir",
		"common.back": "Atrás",
		"common.cancel": "Anular",
		"common.save": "Guardar",
		"common.invite": "Enviar invitación",
		"common.terms": "Términos y Condiciones",
		"common.yes": "sí",
		"common.no": "no",
		"common.close": "Cerrar",
		"common.collapse": "Colapso",
		"common.myMessages": "Mi Consejo de Salud",
		"common.myCommunities": "Mis comunidades",
		"common.add": "Añadir",
		"common.clear": "Borrar",
		"common.optional": "(opcional)",
		"common.unassign": "Desasignar",
		"menu.healthboard": "Consejo de Salud",
		"menu.myCircles": "Mis Círculos",
		"menu.communities": "Comunidades",
		"messages.chat.empty.messages": "No tienes mensajes",
		"messages.chat.empty.users": "No hay usuarios para chatear",
		"messages.chat.empty.channels": "Sin canales para conectarse",
		"messages.chat.defaultUser": "INTRODUZCA EL NOMBRE DE USUARIO O NOMBRE DE UN USUARIO QUE DESEA AÑADIR A LA CONVERSACION",
		"messages.chat.searchAUser": "Buscar un usuario...",
		"messages.userProfile.familyMembers": "Miembros de la familia",
		"messages.userProfile.programServiceProviders": "Proveedores de programas/servicios",
		"messages.userProfile.singleProvider": "Proveedor de cuidado individual",
		"messages.userProfile.mainProvider": "Proveedor de cuidado principal",
		"messages.userProfile.memberProviderCircle": "Miembro",
		"messages.titles.familyTitleWithCounter": "Círculo familiar ({counter})",
		"messages.titles.providerTitleWithCounter": "Círculo de proveedores ({counter})",
		"messages.nav.tabs.patient": "Usuario General",
		"messages.nav.tabs.provider": "Proveedor",
		"messages.filterOptions.allPatients": "Todos los pacientes",
		"messages.filterOptions.myPatients": "Mis pacientes",
		"messages.statusFilterOptions.all": "Todos",
		"messages.statusFilterOptions.joined": "Unido",
		"messages.statusFilterOptions.notJoined": "No Unido",
		"messages.patientNotJoined.message": "El paciente no se ha unido todavía",
		"messages.patientNotJoined.resend": "Reenviar una invitación",
		"messages.patientNotJoined.invite": "Envia una invitacion",
		"messages.patientNotJoined.inviteSent": "Invitación enviada",
		"messages.patientNotJoined.checkContactInformationText": "Por favor confirme los detalles de contacto del paciente antes de enviar una invitación",
		"messages.patientNotJoined.inviteTitle": "Invitar Paciente",
		"messages.patientNotJoined.errors.emailAlreadyTaken": "Correo electrónico ya usado, por favor brinde otro",
		"messages.patientNotJoined.errors.emailInvalid": "El correo electrónico no es válido, por favor proporcione otro",
		"messages.patientNotJoined.errors.emailBlank": "El correo electrónico no puede estar en blanco",
		"messages.patientNotJoined.errors.phoneNumberAlreadyTaken": "Número de teléfono ya usado, por favor proporcione otro",
		"messages.patientNotJoined.errors.phoneNumberBlank": "El número de teléfono no puede estar en blanco",
		"messages.patientNotJoined.errors.phoneNumberInvalid": "El número de teléfono no es válido",
		"messages.titles.accessLevel": "Nivel De Acceso",
		"messages.titles.accessLevelTooltip": "El Acceso temporal se mantendrá únicamente en el período de sesiones en curso. El tiempo de espera de sesión es de 30 minutos desde la Última actividad.",
		"messages.titles.reasonForAssignment": "Motivo de la asignación",
		"messages.titles.selectReasonForAssignment": "Seleccione una razón para la asignación",
		"circle.assigned": "El proveedor ha sido asignado exitosamente",
		"circle.unassigned": "El proveedor ha sido sin asignar con éxito",
		"circle.confirmUnassigned": "Lo sentimos, pero no has sido asignado a este paciente y no tienes más permisos para acceder a esta página",
		"circles.empty": "No tienes círculos",
		"circles.empty.navigation": "No hay círculos para navegar",
		"circles.invites.cancelInvite": "Cancelar invitación",
		"circles.invites.confirmCancel": "Sí estoy seguro",
		"circles.invites.declineCancel": "No",
		"circles.invites.inviteSent": "Invitación enviada",
		"circles.invites.invitedCaregiver": "Cuidador (pendiente)",
		"circles.invites.family.success": "La invitación de miembro de familia ha sido enviada",
		"circles.invites.caregiver.success": "La invitación del cuidador ha sido enviada",
		"circles.invites.provider.success": "Proveedor fue agregado al círculo",
		"circles.invites.family.accept": "Te has unido al círculo familiar",
		"circles.invites.family.decline": "Has rechazado la invitación del círculo familiar",
		"circles.invites.caregiver.accept": "Usted ha aceptado la función de cuidador",
		"circles.invites.caregiver.decline": "Has rechazado la función de cuidador",
		"circles.provider.remove": "El proveedor fue eliminado de su círculo de proveedores",
		"circles.provider.leave": "Saliste del círculo de proveedores",
		"circles.family.remove": "El usuario fue eliminado de tu círculo familiar",
		"circles.family.leave": "Has dejado el círculo familiar",
		"circles.invites.caregiver.error": "El usuario invitado ya es un cuidador del paciente.",
		"circles.invites.text.ProviderInvitesCaregiver": "lo ha invitado a ser el cuidador de {patientName} en {brandName}. Como cuidador, podrá responder encuestas en nombre de {patientName} y utilizar {brandName} en nombre de {patientName}. Usted acepta ser cuidador de {patientName}.",
		"circles.invites.title": "Invitar miembro",
		"circles.invites.subtitle": "por correo electrónico o teléfono",
		"circles.invites.role": "Seleccionar relación",
		"circles.invites.text.family": "ha consentido en invitarlos a su Círculo Familiar. Como miembro de Círculo Familiar usted recibirá acceso a información de salud personal y podrá comunicarse con otros miembros en el círculo familiar y también con los proveedores de atención médica.",
		"circles.invites.text.provider": "ha consentido invitarle a su Círculo de Proveedores. Como miembro de Círculo de Proveedores usted recibirá acceso a información personal de salud y podrá comunicarse con otros miembros en el círculo de proveedores y también con miembros de la familia.",
		"circles.invites.text.caregiver": "quiere asignarle un papel de Cuidador. Como Cuidador podrá responder a las encuestas dentro de los programas de {patient}, editar el perfil y utilizar la aplicación en nombre de {patient}.",
		"circles.invites.makeInviteToFamilyText": "Como miembro de su Círculo Familiar, el miembro de la familia a quien invita verá toda su información de salud y podrá comunicarse con su familia y el Círculo de Proveedores.",
		"circles.invites.makeInviteProviderText": "Como miembro de su Círculo de Proveedores, el miembro proveedor al que invita tendrá acceso a información personal de salud y podrá comunicarse con otros miembros del círculo de proveedores y también con los miembros de la familia.",
		"circles.invites.makeInviteCaregiverText": "El cuidador es capaz de responder encuestas dentro de sus programas, editar su perfil y utilizar el sistema de parte de ti.",
		"circles.invites.pending": "invitaciones pendientes",
		"circles.invites.caregiver": "El cuidador puede responder encuestas dentro de los programas del paciente, editar el perfil del paciente y usar el sistema en nombre del paciente.",
		"circles.circle": "Círculo",
		"circles.circle.typedCircle": "{type} círculo",
		"circles.titles.invitations": "Invitaciones",
		"circles.titles.listCaregiver": "Usted es cuidador de",
		"circles.titles.familyMemberingCircle": "Sus círculos familiares",
		"circles.titles.listFamilyCircleMember": "Círculos Familiares",
		"circles.titles.listProviderMember": "Es miembro del círculo de proveedores",
		"circles.titles.familyCircle": "",
		"circles.titles.providerCircle": "Círculo de proveedor",
		"circles.titles.primaryProviderProfileTitle": "Mi círculo de proveedor",
		"circles.titles.primaryPatientProfileTitle": "Mi círculos familiar",
		"circles.titles.caregiverRole": "Cuidador",
		"circles.titles.careProvider": "Proveedor de cuidado",
		"circles.family.cancelInvite.title": "¿Está seguro que desea cancelar la invitación a su círculo familiar?",
		"circles.family.cancelInvite.text": "Está a punto de cancelar la invitación de su {role} a su círculo familiar enviado por {login}. Una vez que la cancele, esta persona no podrá aceptarla y unirse a su círculo familiar.",
		"circles.caregiver.cancelInvite.title": "¿Está seguro de que quiere cancelar la invitación para ser un cuidador?",
		"circles.caregiver.cancelInvite.text": "Está a punto de cancelar la invitación de su {role} para ser un cuidador. Una vez que lo cancele, esta persona no podrá aceptarlo y convertirse en un cuidador.",
		"circles.actions.leave": "Deja el círculo",
		"circles.actions.leaveBtn": "Deja círculo",
		"circles.actions.makeCaregiver": "Asignar el papel de cuidador",
		"circles.actions.removeCaregiver": "Eliminar el papel de cuidador",
		"circles.actions.removeFromCircle": "Eliminar del círculo",
		"circles.actions.inviteProvider": "Invitar al miembro del proveedor",
		"circles.actions.inviteFamily": "Invitar a un miembro de la familia",
		"circles.leave.family.title": "¿Está seguro de que quiere dejar el círculo?",
		"circles.leave.family.body": "Estás a punto de dejar {patient} Círculos Familiar. Además, una vez que deje el círculo, ya no tendrá acceso ni podrá ver el Consejo de salud del {patient}.",
		"circles.leave.provider.title": "¿Está seguro de que quiere dejar el círculo?",
		"circles.leave.provider.body": "Está a punto de dejar {provider} Círculo de proveedor. Además, una vez que abandone el círculo, ya no tendrá acceso a la información de salud personal de {provider}.",
		"circles.roles.spouse": "Esposo/a",
		"circles.roles.daughter": "Hija",
		"circles.roles.son": "Hijo",
		"circles.roles.sister": "Hermana",
		"circles.roles.brother": "Hermano",
		"circles.roles.mother": "Madre",
		"circles.roles.father": "Padre",
		"circles.roles.granddaughter": "Nieta",
		"circles.roles.grandson": "Nieto",
		"circles.roles.grandmother": "Abuela",
		"circles.roles.grandfather": "Abuelo",
		"circles.roles.partner": "Compañero",
		"circles.roles.guardian": "Guardián",
		"circles.roles.relative": "Pariente",
		"circles.roles.friend": "Amigo",
		"circles.roles.power_of_attorney": "Poder legal",
		"circles.roles.patient": "Paciente",
		"circles.roles.caregiver": "Cuidador",
		"circles.roles.left_the_circle": "Dejó el círculo",
		"circles.roles.family_member": "Miembro de la familia",
		"circles.roles.single_care_provider": "Proveedor de cuidado individual",
		"circles.addProviderReason.temporaryTitle": "Acceso temporal",
		"circles.addProviderReason.permanentTitle": "Asignación permanente",
		"circles.addProviderReason.temporary.emergencyAccess": "Acceso de emergencia",
		"circles.addProviderReason.temporary.temporarilyAssigned": "temporalmente asignado al paciente",
		"circles.addProviderReason.temporary.patientConsultation": "Consulta del paciente",
		"circles.addProviderReason.permanent.underTreatment": "Paciente actual en tratamiento",
		"circles.addProviderReason.permanent.patientRequest": "Solicitud de paciente",
		"communities.empty.navigation": "No hay comunidades para navegar",
		"communities.empty": "No tienes comunidades",
		"communities.title.member": "My Comunidades",
		"communities.title.moderator": "Soy Moderador",
		"community.type.public": "Comunidad Pública",
		"community.type.private": "Comunidad Privada",
		"community.type.global": "Comunidad Global",
		"community.access.readOnly": "Solo lectura",
		"community.actions.createPost": "Nueva Publicación",
		"community.empty": "No hay tal comunidad",
		"community.description": "Sobre",
		"community.posts": "Publicaciones más recientes",
		"community.posts.empty": "No hay publicaciones todavía",
		"community.members": "miembros",
		"community.postUpdated": "actualizado",
		"community.activity.total": "Tienes {posts} publicación(es) nueva(s) y {comments} comentario(s) nuevo(s)",
		"community.activity.posts": "Tienes {posts} publicación(es) nueva(s)",
		"community.activity.comments": "Tienes {comments} comentario(s) nuevo(s)",
		"post.title": "Comentarios de publicación",
		"post.back": "Volver a la lista de publicaciones",
		"post.comments": "Comentarios",
		"post.comments.add": "Agregar comentario",
		"post.actions.createComment": "Publicar comentario",
		"post.actions.reply": "Respuesta",
		"post.comment.description": "comentó la publicación",
		"post.replies": "respuestas",
		"post.reply.description": "respondió al comentario de {name}",
		"post.reply.placeholder": "Responder al comentario...",
		"post.comments.empty": "No hay comentarios todavía",
		"community.newPost.title": "Nueva publicación en la comunidad {name}",
		"community.newPost.edit.title": "Editar publicación en la comunidad {name}",
		"community.newPost.caption": "Subtítulo",
		"community.newPost.attachImage": "Adjuntar imagen",
		"community.newPost.attachURL": "Adjuntar URL",
		"community.newPost.addPost": "Añadir publicación",
		"community.newPost.editPost": "Editar publicación",
		"community.newPost.fileError": "Solo se permiten imágenes de menos de {size}mb",
		"community.newPost.urlError": "Este enlace no es válido",
		"community.newPost.noPreview": "Sin vista previa",
		"community.newPost.enterUrl": "Introduzca aquí el url...",
		"community.postMenu.editPost": "Editar post",
		"community.postMenu.deletePost": "Eliminar mensaje",
		"community.postMenu.confirmDeleteMessage": "¿Seguro que quieres eliminar esta publicación? Esto no se puede deshacer.",
		"community.commentMenu.editComment": "Editar comentario",
		"community.commentMenu.deleteComment": "Eliminar comentario",
		"community.commentMenu.confirmDeleteComment": "¿Seguro que quieres eliminar esta comentario? Esto no se puede deshacer.",
		"community.comments.commentWasDeleted": "El comentario fue eliminado",
		"community.comments.commentWasDeletedByModerator": "El comentario fue eliminado por el moderador",
		"community.roles.moderator": "Moderador",
		"community.roles.member": "Miembro",
		"profile.fieldSet.empty": "La sección está vacía. Editar sección para agregar información.",
		"profiles.updated": "Perfil ha sido actualizado",
		"settings.updated": "La configuración ha sido actualizada",
		"programs.title": "Programas",
		"programs.emptyState": "no se ha asignado a ningún Programa todavía",
		"programs.invitation.emptyState": "No hay Programas disponibles para el",
		"programs.invitation.addPatient": "Añadir un Paciente a un Programa",
		"programs.invitation.invitationText": "le invita a unirse al Programa / Servicio",
		"programs.invitation.title": "Invitaciones de programa / servicio para {user}",
		"programs.invitation.empty": "No tienes invitaciones de programa / servicio",
		"programs.invitation.success": "El paciente se añade con éxito a los Programas",
		"programs.actions.request": "Invitaciones de programa / servicio",
		"programs.actions.title": "Detalles de programa / servicio para {user}",
		"programs.actions.followup": "Seguimiento de la cita para {user}",
		"programs.actions.subtitle": "Sobre programa / servicio",
		"programs.actions.showMore": "Leer Más",
		"programs.actions.showLess": "Leer Menos",
		"programs.actions.leave": "Dejar programa / servicio",
		"programs.actions.aboutProgram": "Acerca del programa",
		"programs.remove.confirmRemove": "¿Está seguro de que desea eliminar {nombre del paciente} del {programa}?",
		"programs.remove.success": "El paciente ha sido retirado con éxito del Programa",
		"programs.remove.title": "Sacar al Paciente del Programa",
		"programs.remove.subtitle": "Eliminar del Programa",
		"surveys.noUpcomingSurveys": "No tienes ninguna encuesta",
		"surveys.noSurveysResults": "No hay resultados para mostrar",
		"surveys.sent": "La encuesta ha sido enviada",
		"surveys.answer": "La encuesta ha sido respondida",
		"surveys.actions.answer": "Responder",
		"surveys.actions.save": "Guardar borrador",
		"surveys.actions.proceed": "Proceder",
		"surveys.actions.general": "Información de satisfacción del servicio",
		"surveys.actions.review": "Revisar",
		"surveys.actions.submit": "Presentar respuestas",
		"surveys.actions.upcoming": "Próximas encuestas",
		"surveys.actions.upcomingHeading": "Próximas encuestas para {user}",
		"surveys.sendSurvey.noSurveys": "No hay encuestas para enviar",
		"surveys.actions.exportToPDF": "Exportar a PDF",
		"surveys.title": "Encuestas",
		"surveys.results": "Resultados De La Encuesta",
		"surveys.single": "Encuesta",
		"surveys.totalScore": "Puntuación Total:",
		"surveys.selectedChatDesc": "La encuesta estará disponible para todos los miembros de la conversación seleccionado",
		"surveys.answeredBy": "Respondida por",
		"surveys.answerForm": "El formulario ha sido contestado",
		"surveys.noAvailableForms": "No hay formularios disponibles",
		"profile.actions.cancel": "Descarte",
		"profile.actions.details": "Ver perfil detallado",
		"profile.actions.submit": "Guardar cambios",
		"profile.actions.provider": "Proveedor",
		"profile.actions.patient": "Paciente",
		"profile.actions.back": "Consejo de salud del paciente",
		"profile.avatar.remove": "Retirar",
		"profile.avatar.upload": "Subir foto",
		"profile.avatar.update": "Actualizar foto",
		"profile.tabType.patient": "Perfil del usuario",
		"profile.tabType.provider": "Perfil del proveedor",
		"profile.tabType.surveys": "Encuestas generales",
		"profile.section.general": "Información general",
		"profile.section.personal": "Información personal",
		"profile.section.contacts": "Información del contacto",
		"profile.section.health": "Información de salud",
		"profile.section.prof": "Información profesional",
		"profile.section.mrns": "Números de registro médico",
		"profile.section.address": "Dirección del domicilio",
		"profile.section.notificationSettings": "Configuración de las notificaciones",
		"profile.section.languageSettings": "Configuración de idioma",
		"profile.fields.bio": "Bio",
		"profile.fields.location": "Ubicación",
		"profile.fields.phones": "Teléfonos",
		"profile.fields.healthInterests": "Intereses de salud",
		"profile.fields.name": "Nombre",
		"profile.fields.firstName": "Primer nombre",
		"profile.fields.middleName": "Segundo nombre",
		"profile.fields.lastName": "Apellido",
		"profile.fields.gender": "Género",
		"profile.fields.dob": "Fecha de nacimiento",
		"profile.fields.race": "Raza",
		"profile.fields.mStatus": "Estado civil",
		"profile.fields.ethnic": "Etnicidad",
		"profile.fields.language": "Idioma",
		"profile.fields.religion": "Religión",
		"profile.fields.email": "Correo electrónico",
		"profile.fields.homeAddress": "Dirección del domicilio",
		"profile.fields.address1": "Dirección 1",
		"profile.fields.address2": "Dirección 2",
		"profile.fields.city": "Ciudad",
		"profile.fields.state": "Estado",
		"profile.fields.postalCode": "Código postal",
		"profile.fields.country": "País",
		"profile.fields.homePhone": "Número de teléfono fijo",
		"profile.fields.mobilePhone": "Número de teléfono móvil",
		"profile.fields.localUid": "Números de Registro Médico",
		"profile.fields.allergies": "Alergias",
		"profile.fields.medicine": "Medicina",
		"profile.fields.healthGoals": "Metas de salud",
		"profile.fields.role": "Papel",
		"profile.fields.mrns": "Números de Registro Médico",
		"profile.fields.localUidProvider": "Proveedor ID",
		"profile.fields.npi": "Proveedor NPI",
		"profile.fields.title": "Título",
		"profile.fields.specialty": "Especialidad",
		"profile.fields.primaryPracticeAddress": "Dirección de Práctica primaria",
		"profile.fields.primaryPracticeAddress1": "Dirección de Práctica primaria 1",
		"profile.fields.primaryPracticeAddress2": "Dirección de Práctica primaria 2",
		"profile.fields.primaryPracticeCity": "Ciudad de Práctica Primaria",
		"profile.fields.primaryPracticeState": "Estado de Práctica Primaria",
		"profile.fields.primaryPracticeCountry": "País de Práctica Primaria",
		"profile.fields.officePhone": "Número de teléfono de la oficina",
		"profile.fields.username": "Usuario",
		"profile.fields.phoneNumber": "Teléfono móvil",
		"profile.fields.day": "Dia",
		"profile.fields.month": "Mes",
		"profile.fields.year": "Año",
		"profile.edit.emailConfirmationTitle": "Confirmar información de contacto",
		"profile.edit.emailConfirmationText": "Nosotros envió un correo electrónico de verificación a {email}. El correo electrónico antiguo se seguirá utilizando hasta que verifique el nuevo.",
		"profile.edit.confirmCode": "Confirmar código",
		"profile.edit.invalidCode": "Has ingresado un código no válido.",
		"profile.edit.phoneConfirmationText": "Para comenzar a usar el nuevo número de celular, necesitamos verificar lo. Hemos enviado un SMS con un código de confirmación a {phone}. Ingrese este código a continuación.",
		"profile.notificationSettings.label": "Notificar por {type} ({value})",
		"profile.notificationSettings.labels.email": "correo electrónico",
		"profile.notificationSettings.labels.sms": "SMS",
		"profile.list.gender.M": "Masculino",
		"profile.list.gender.F": "Femenino",
		"profile.list.gender.O": "Otro",
		"profile.list.gender.U": "Desconocido",
		"profile.list.marital.S": "Soltero",
		"profile.list.marital.M": "Casado",
		"profile.list.marital.O": "Otro",
		"profile.list.marital.U": "Desconocido",
		"chat.common.removeFromChat": "quitar de la conversación",
		"chat.actions.downloadAttachment": "Descargar archivo adjunto",
		"chat.actions.editMessage": "Editar mensaje",
		"chat.actions.deleteMessage": "Borrar mensaje",
		"chat.actions.confirmDeleteMessage": "¿Seguro que quieres borrar este mensaje? Esto no se puede deshacer.",
		"chat.actions.confirmLeaveChat": "¿Estás seguro de que quieres dejar esta conversación?",
		"chat.actions.reply": "Respuesta",
		"chat.actions.blockMessaging": "bloquear mensajes",
		"chat.actions.unblockMessaging": "desbloquear mensajes",
		"chat.actions.unblockUser": "Desbloquear usuario",
		"chat.actions.leaveChat": "dejar la conversación",
		"chat.titles.uploadingFile": "Estás subiendo un archivo {name}",
		"chat.titles.generalChatTab": "Círculo de Cuidado",
		"chat.titles.familyChatTab": "Sólo familia",
		"chat.titles.providersChatTab": "Sólo proveedores",
		"chat.titles.healthAlert": "Alerta de Salud",
		"chat.titles.notification": "Notificación",
		"chat.titles.surveyReminder": "Recordatorio",
		"chat.titles.addedAttachment": "añadido un archivo adjunto",
		"chat.titles.providers": "Proveedores",
		"chat.titles.family": "Familia",
		"chat.titles.memberAssignment": "Asignación de miembros",
		"chat.titles.providerAssignment": "Asignación de proveedor",
		"chat.titles.providerRemoved": "Proveedor sin asignar",
		"chat.title.chatName": "nombre de conversación",
		"chat.title.userBlocked": "No puedes enviar un mensaje a este contacto porque has sido bloqueado",
		"chat.placeholders.messageTo": "Mensaje para",
		"chat.placeholders.default": "Escribir un mensaje",
		"chat.placeholders.surveyExpired": "Esta encuesta expiró",
		"chat.notifications.patientAssignedToProgram": "{providerName} de {organizationName} ha inscrito {patientName} en el {programName} programa/servicio",
		"chat.notifications.patientRemovedFromProgram": "{patientName} se ha eliminado del programa / servicio {programName}",
		"chat.sorting.byUnread": "Por número de no leídos",
		"chat.sorting.byLastMessage": "Por más reciente",
		"chat.errors.tooLong": "Este mensaje es demasiado largo",
		"chat.errors.maxAttachmentSize": "Tamaño Máximo 50Mb",
		"chat.errors.maxAttachmentSizeNextPart": "{archivos} es / son demasiado grandes",
		"chat.errors.notAllowedFormat": "Solo puede subir jpg, png, pdf, docx, xlsx, pptx, rtf, txt, xml, mov, mp4 and vcf files",
		"chat.errors.uploadError": "Se ha producido un error durante la carga del archivo. Por favor, inténtelo de nuevo",
		"chat.errors.maxAttachmentNumber": "Solo puedes subir 20 archivos al mismo tiempo",
		"chat.moreAttachments.sendSurvey": "Enviar encuesta",
		"chat.moreAttachments.answerForm": "Responda el formulario",
		"chat.moreAttachments.attachFile": "Adjuntar archivo",
		"auth.accessDenied.text": "Lo sentimos, pero no tiene permisos para acceder a esta página.",
		"auth.createPassword.text": "Ingrese su nueva contraseña",
		"auth.expiredToken.text": "El enlace de registro caduca después de 7 días, y sólo se puede utilizar una vez.",
		"auth.expiredConfirmation.text": "El enlace de confirmación caduca después de 7 días, y sólo se puede utilizar una vez.",
		"auth.recoverConfirm.title": "Le hemos enviado un correo electrónico con instrucciones para ",
		"auth.recoverConfirm.confirmText": "Comprueba su correo electrónico, por favor",
		"auth.recoverConfirm.email.title": "Le hemos enviado un correo electrónico con instrucciones para ",
		"auth.recoverConfirm.email.confirmText": "Comprueba su correo electrónico, por favor",
		"auth.recoverConfirm.phone.title": "Le hemos enviado un mensaje con instrucciones para ",
		"auth.recoverConfirm.phone.confirmText": "Comprueba su teléfono móvil, por favor",
		"auth.recoverPassword.textTitle": "Ingrese su correo electrónico o número de teléfono y le enviaremos las instrucciones de recuperación de la contraseña.",
		"auth.recoverPassword.textLink": "Se le olvidó su contraseña?",
		"auth.userNotFound.text": "El usuario con este correo electrónico/teléfono no existe",
		"auth.signup.title": "¿No tiene una cuenta?",
		"auth.signup.textLink": "Se registre para {brandName}",
		"auth.tnc.title": "He leido y acepto",
		"auth.tnc.textLink": "Términos y Condiciones",
		"auth.logout.text": "Cerrar sesión",
		"errors.common": "Algo salió mal...",
		"errors.commonErrorOccured": "Se ha producido un error. Vuelve a intentarlo más tarde.",
		"errors.emailError": "Introduce una dirección de correo electrónico válida",
		"errors.emailErrorDesription": "Iniciar sesión {error}",
		"errors.invalidDateOfBirth": "Fecha de nacimiento invalida",
		"errors.login.unauthorized": "Usuario con combinación de inicio de sesión / contraseña no encontrada",
		"errors.login.authenticationLockout": "La autenticación está en bloqueo temporal para esta cuenta debido a demasiados intentos fallidos de inicio de sesión. Puedes volver a iniciar sesión en 15 minutos",
		"errors.nameLength": "El nombre y apellido deben contener hasta 40 símbolos",
		"errors.requiredFields": "Todos los campos son obligatorios",
		"errors.tnc": "Por favor, confirme que ha leído y aceptado los Términos y Condiciones.",
		"errors.cannotAcceptInvite": "Necesita tener un perfil de paciente para aceptar invitaciones a los círculos familiares",
		"errors.nicknameContainsCommercialAt": "El apodo no debe contener @ símbolo",
		"errors.password": "La contraseña no puede estar en blanco o contener sólo espacios",
		"errors.validation.profile.firstName.required": "Primer nombre debe estar presente",
		"errors.validation.profile.lastName.required": "El apellido debe estar presente",
		"errors.validation.profile.phone.format": "El teléfono debe contener solo +, - y dígitos",
		"errors.validation.profile.phone.required": "El teléfono debe estar presente",
		"errors.validation.profile.dob.format": "Formato de fecha incorrecto",
		"errors.validation.profile.dob.required": "Fecha de nacimiento requerida",
		"errors.validation.profile.email.format": "Correo electrónico no es válido, por favor proporcione otro",
		"errors.validation.profile.email.required": "Correo electrónico debe estar presente",
		"errors.validation.profile.username.required": "Usuario debe estar presente",
		"errors.validation.profile.username.format": "El nombre de usuario debe contener caracteres alfabéticos y numéricos",
		"errors.username.alreadyTaken": "Nombre de usuario ya ha sido tomado",
		"fields.dob": "Fecha de nacimiento",
		"fields.email": "Correo electrónico",
		"fields.gender": "Género",
		"fields.firstname": "Nombre",
		"fields.lastname": "Apellido",
		"fields.password": "Contraseña",
		"fields.username": "Apodo",
		"fields.login": "Login",
		"fields.login.placeholder": "Email or Teléfono",
		"fields.phoneNumber": "Teléfono",
		"submit.signup": "Proceder",
		"submit.login": "Iniciar sesión",
		"submit.fillProfile": "Confirmar",
		"submit.recoverPassword": "Enviar solicitud",
		"submit.recoverConfirm": "Volver al inicio de sesión",
		"submit.createPassword": "Guardar contraseña",
		"submit.expiredToken": "Lo tengo",
		"titles.accessDenied": "Acceso denegado",
		"titles.createPassword": "Crear nueva contraseña",
		"titles.expiredToken": "El enlace de registro ha caducado",
		"titles.expiredConfirmation": "El enlace de confirmación ha expirado",
		"titles.fillProfile": "Datos personales",
		"titles.login": "Iniciar sesión en {brandName}",
		"titles.recoverConfirm": "Enlace de recuperación enviado",
		"titles.recoverPassword": "Recuperar contraseña",
		"titles.signup": "Regístrate para {brandName}",
		"titles.confirmMyPhoneNumber": "Confirmo mi número de teléfono",
		"titles.confirmMyPhoneEmail": "Confirmo mi correo electrónico",
		"titles.confirmMyEmail": "Confirmo al correo electrónico",
		"general.careProvidersTitle": "Proveedores de cuidado",
		"previewableBlock.more": "Ver más",
		"previewableBlock.less": "Ver menos",
		"generalSurveys.noSurveys": "No tiene información de satisfacción del servicio",
		"intro.common.logout": "Haga clic aquí para salir de la aplicación",
		"intro.common.circlesMenu": "Invitar a alguien al círculo",
		"intro.circles.inviteFamilyMember": "Invitar a alguien a unirse al círculo familiar",
		"intro.circles.assignCaregiver": "Asignar a alguien como cuidador que puede actuar de parte del paciente",
		"intro.circles.inviteProviderMember": "Invitar a un proveedor de la organización a unirse al círculo",
		"intro.circles.removeProviderMember": "Quitar proveedor del círculo del proveedor",
		"intro.messages.generalChannel": "Haz clic en la pestaña para chatear con todos los proveedores y familiares",
		"intro.messages.providerChannel": "Chat privado sólo para proveedores",
		"intro.messages.familyChannel": "Chat privado solo para la familia del paciente",
		"intro.messages.searchChat": "Buscar un chat",
		"intro.messages.selectChat": "Seleccione un chat",
		"intro.messages.selectChannel": "Seleccione un canal",
		"intro.messages.typeFilter": "Selecciona un tipo de chats",
		"intro.messages.typeMessage": "Escriba su mensaje aquí",
		"intro.messages.answerSurvey": "Haga clic para responder a la encuesta",
		"intro.messages.patientName": "Haga clic en el nombre del paciente para ver los proveedores y programas",
		"intro.messages.patientContext": "Todo lo que ves está relacionado con este paciente",
		"intro.messages.patientProgram": "Haga clic para ver las encuestas del programa",
		"intro.messages.programFilter": "Filtra la lista de pacientes",
		"notificationScreen.title": "Aviso",
		"notificationScreen.providerWithoutPatients.notification": "Los círculos sólo están disponibles para los pacientes y sus familiares.",
		"notificationScreen.providerWithoutPatients.instructionTitle": "¿Cómo convertirse en un paciente o miembro de la familia (cuidador) en {brandName}?",
		"notificationScreen.providerWithoutPatients.instructionBody": "Para convertirse en un paciente, pregúntele a su médico si su clínica ya está conectada con {brandName} y, en caso afirmativo, pídales que lo inscriban en uno de los programas de atención {brandName} disponibles en su clínica. Para poder ser un miembro de la familia (cuidador) de un paciente, pida a sus familiares que ya están inscritos en el Programa de Atención {brandName}, que lo inviten a su círculo familiar.",
		"notificationScreen.providerWithoutPatients.commonTitle": "¿Ya es un paciente o un miembro de la familia?",
		"notificationScreen.providerWithoutPatients.commonBody": "Si ya ha sido inscrito en un programa por su médico, pero todavía no puede ver su tarjeta de salud, intente actualizar su dirección de correo electrónico.",
		"routes.patientViewProfile": "perfil del paciente",
		"routes.providerViewProfile": "perfil del proveedor",
		"routes.userViewProfile": "perfil de usuario",
		"routes.providerMemberProfile": "perfil de miembro de círculo de proveedor",
		"routes.familyMemberProfile": "perfil de miembro de la familia",
		"routes.generalSurveys": "encuestas generales",
		"routes.parentProvider": "proveedor de cuidado principal",
		"routes.patientInfo": "información del paciente",
		"routes.providerInfo": "información del proveedor",
		"routes.settings": "configuración",
		"messages.chat.searchByPeopleUsername": "Buscar por el nombre de usario",
		"messages.chat.enterUsernameOrName": "Ingresar el nombre de usuario de la persona con que desea iniciar una conversación",
		"messages.chat.newChat": "nueva conversación",
		"messages.chat.findAMember": "Encontrar un miemro",
		"messages.chat.youAddedMembers": "Agregó {counter} {counter, plural, one {miembro} other {miembros}}",
		"messages.chat.counterMembers": "{counter} {counter, plural, one {mimebro} other {miembros}}",
		"messages.chat.startANewConversationInTheContextOf": "Comenzar una nueva conversación en el contexto de {user}",
		"messages.chat.startANewConversationInTheContextOfDesc": "Las personas que se enumeran a continuación están en el Círculo de atención y se puede agregar a otros no en Círculos mediante la búsqueda",
		"messages.chat.startANewConversation": "Comenzar una nueva conversación",
		"messages.chat.start": "Comenzar",
		"messages.chat.noOneFound": "nadie encontró",
		"circle.notInCircle": "No en {contextUser}’s provider CÍRCULO",
		"chat.title.chatInContextOf": "Conversar en el contexto de",
		"chat.title.inContextOf": "En el contexto de",
		"chat.title.conversationInfo": "Información de conversación",
		"chat.notification.newMessage": "Nuevo mensaje",
		"chat.titles.activitiesChatTab": "Ocupaciones",
		"chat.titles.notificationsChatTab": "Notificaciones/Alertas",
		"role.admin": "admin",
		"dialog.common.invite": "Invitar a más personas a la conversación",
		"dialog.success.joinCircle": "Te has unido al círculo de Proveedores de Pacientes.",
		"dialog.titles.joinCircle": "Unirse al Círculo de Proveedores de un Paciente",
		"dialog.titles.assignProviderToPatient": "Asignar nuevo Proveedor al Paciente",
		"dialog.common.noPatients": "Si el paciente no aparece en la búsqueda, puede que no esté en nuestro sistema o puede que ya esté asignado a usted.",
		"dialog.common.assign": "Asignar",
		"dialog.common.addPatient": "Añadir pacientes al sistema",
		"dialog.common.defaultPatient": "INGRESE EL NOMBRE DE USUARIO O NOMBRE DE UN PACIENTE CUYO CÍRCULO DE PROVEEDORES DESEA UNIRSE",
		"dialog.common.addNewPatient": "Añadir nuevo paciente",
		"dialog.common.defaultProvider": "INGRESE EL NOMBRE DE USUARIO O NOMBRE DE UN PROVEEDOR QUE LE GUSTARÍA ASIGNAR AL PACIENTE",
		"dialog.common.assignProvider": "Asignar Proveedor",
		"dialog.common.inviteCaregiver": "Invitar Cuidador",
		"dialog.common.searchProvider": "Búsqueda de un Proveedor...",
		"dialog.common.searchPatient": "Búsqueda de un Paciente...",
		"dialog.common.addAnotherPatient": "¿Quieres añadir otro Paciente al sistema?",
		"dialog.titles.addPatient": "Añadir Paciente",
		"dialog.titles.andOr": "y/o"
	};

/***/ }),
/* 5359 */
/***/ (function(module, exports) {

	module.exports = {
		"general.formats.dayFormattingPattern": "MMMM DD, YYYY",
		"general.formats.datePatternAPI": "YYYY-MM-DD",
		"general.formats.datePatternUI": "MM-DD-YYYY",
		"general.formats.shortDatePattern": "MMM DD",
		"general.formats.fullShortDatePattern": "MMM DD, YYYY",
		"general.formats.timePattern": "hh:mm a",
		"general.title": "{brandName}",
		"general.description": "醫院以外的醫療護理",
		"general.slogan.primary": "一個提高患者參與的全球網",
		"general.slogan.secondary": "緊密聯絡 無間合作",
		"general.labels.you": "(你)",
		"general.labels.YO": "歲",
		"general.labels.noInternet": "沒有網絡連接",
		"general.labels.myProfile": "我的個人資訊",
		"general.labels.profile": "個人資訊",
		"general.labels.backToInvitation": "回到邀請階段",
		"general.labels.userNameExample": "JohnDoe_123 or Wolverine",
		"general.labels.userNameExplanation": "暱稱是你發帖的筆名，如果你比較喜歡匿名的話可以挑有創意的",
		"general.labels.pickItemLeft": "在左側欄選一項查看",
		"general.errors.404": "噢! 這沒什麼可看的.",
		"general.toTop": "回到頁頂",
		"general.success": "成功",
		"general.removedFromChat": "你已離開這群組",
		"general.search.placeholder": "找尋...",
		"general.search.patients": "找尋病人...",
		"common.remove": "刪除",
		"common.unassign": "未分派",
		"common.accept": "接受",
		"common.decline": "拒絕",
		"common.back": "回去",
		"common.cancel": "取消",
		"common.save": "保存",
		"common.invite": "送出邀請",
		"common.terms": "服務條款",
		"common.yes": "是",
		"common.add": "加",
		"common.no": "否",
		"common.close": "關閉",
		"common.clear": "清除",
		"common.collapse": "折叠",
		"common.myMessages": "我的主版",
		"common.myCommunities": "我的社區",
		"common.optional": "(非強制性)",
		"menu.healthboard": "主版",
		"menu.myCircles": "我的圈",
		"menu.communities": "社區",
		"messages.chat.searchByPeopleUsername": "以用戶名尋找…",
		"messages.chat.enterUsernameOrName": "輸入用戶名或姓名來開始對話",
		"messages.chat.newChat": "新對話",
		"messages.chat.findAMember": "找成員",
		"messages.chat.youAddedMembers": "你已加了 {counter} {counter, plural, one {位成員} other {位成員}}",
		"messages.chat.counterMembers": "{counter} {counter, plural, one {位成員} other {位成員}}",
		"messages.chat.startANewConversationInTheContextOf": "開始一個圍繞{user}的對話",
		"messages.chat.startANewConversationInTheContextOfDesc": "下列是醫療護理圈成員。你可以尋找並加入新成員",
		"messages.chat.startANewConversation": "開始對話",
		"messages.chat.start": "開始",
		"messages.chat.noOneFound": "沒有你找的人",
		"messages.chat.empty.messages": "你沒有訊息",
		"messages.chat.empty.users": "沒有用戶可以對話",
		"messages.chat.empty.channels": "沒有可連接的渠道",
		"messages.chat.searchAUser": "尋找用戶...",
		"messages.chat.defaultUser": "輸入用戶名或姓名來加入對話",
		"messages.userProfile.familyMembers": "家庭成員",
		"messages.userProfile.programServiceProviders": "計劃/服務提供者",
		"messages.userProfile.singleProvider": "單一醫療護理人員",
		"messages.userProfile.mainProvider": "主要醫療護理人員",
		"messages.userProfile.memberProviderCircle": "成員",
		"messages.titles.familyTitleWithCounter": "家庭圈 ({counter})",
		"messages.titles.providerTitleWithCounter": "醫療護理圈 ({counter})",
		"messages.nav.tabs.patient": "一般 用戶",
		"messages.nav.tabs.provider": "醫療護理人員",
		"messages.filterOptions.allPatients": "所有病人",
		"messages.filterOptions.myPatients": "我的病人",
		"messages.statusFilterOptions.all": "所有",
		"messages.statusFilterOptions.joined": "已加入",
		"messages.statusFilterOptions.notJoined": "未加入",
		"messages.patientNotJoined.message": "病人還未加入",
		"messages.patientNotJoined.resend": "再次邀請",
		"messages.patientNotJoined.invite": "送出邀請",
		"messages.patientNotJoined.inviteSent": "邀請已送出",
		"messages.patientNotJoined.checkContactInformationText": "送出邀請前請確認病人聯絡細節",
		"messages.patientNotJoined.inviteTitle": "邀請病人",
		"messages.patientNotJoined.errors.emailAlreadyTaken": "此電郵地址已被佔用，請另選一個",
		"messages.patientNotJoined.errors.emailInvalid": "此電郵地址並不正確 請另選一個",
		"messages.patientNotJoined.errors.emailBlank": "電郵地址不能空白",
		"messages.patientNotJoined.errors.phoneNumberAlreadyTaken": "電話號碼已被佔用，請另選一個",
		"messages.patientNotJoined.errors.phoneNumberBlank": "電話號碼不能空白",
		"messages.patientNotJoined.errors.phoneNumberInvalid": "此電話號碼並不正確",
		"messages.titles.accessLevel": "使用級別",
		"messages.titles.accessLevelTooltip": "臨時開通使用30分鐘",
		"messages.titles.reasonForAssignment": "分派理由",
		"messages.titles.selectReasonForAssignment": "請選擇分派理由",
		"circle.assigned": "成功分派醫療護理人員",
		"circle.unassigned": "成功取消醫療護理人員分派",
		"circle.confirmUnassigned": "對不起，你不能進入因他已不是你的病人",
		"circle.notInCircle": "不再{contextUser}的醫療護理圈",
		"circles.empty": "你未有圈子",
		"circles.empty.navigation": "沒有圈子可供瀏覽",
		"circles.invites.cancelInvite": "取消邀請",
		"circles.invites.confirmCancel": "是, 確定",
		"circles.invites.declineCancel": "否",
		"circles.invites.inviteSent": "邀請已送出",
		"circles.invites.invitedCaregiver": "護理員 (待定)",
		"circles.invites.family.success": "家庭成員邀請已送出",
		"circles.invites.caregiver.success": "護理人員邀請已送出",
		"circles.invites.provider.success": "醫療護理人員已加入圈子",
		"circles.invites.family.accept": "你已接受加入家庭圈",
		"circles.invites.family.decline": "你拒絕了加入家庭圈的邀請",
		"circles.invites.caregiver.accept": "你已接受成為護理員",
		"circles.invites.caregiver.decline": "你拒絕了成為護理員",
		"circles.provider.remove": "此人已從你的醫療護理圈刪除",
		"circles.provider.leave": "你已離開醫療護理圈",
		"circles.family.remove": "此人已從你的家庭圈刪除",
		"circles.family.leave": "你已離開家庭圈",
		"circles.invites.caregiver.error": "被邀請者已是病人的護理員",
		"circles.invites.title": "邀請成員",
		"circles.invites.subtitle": "通過電郵或電話",
		"circles.invites.role": "選擇關係",
		"circles.invites.text.family": "同意邀請你成為他家庭圈的一份子。身為家庭圈的成員你可以接觸個人健康資料，以及與其他家庭圈成員和醫護人員對話。",
		"circles.invites.text.provider": "同意邀請你成為他醫療護理圈的一份子。身為醫療護理圈的成員你可以接觸個人健康資料，以及與其他醫療護理圈成員和病人家屬對話。",
		"circles.invites.text.caregiver": "邀請你擔任護理員。身為護理員你可以為{patient}答計劃內的問卷，更改個人資料及以{patient}的名義使用系統。",
		"circles.invites.text.ProviderInvitesCaregiver": "邀請你擔任{brandName}病人{patientName}的護理員。身為護理員你可以為{patientName}答問卷，及以{patientName}的名義使用{brandName}. 你同意擔任{patientName}的護理員。",
		"circles.invites.makeInviteToFamilyText": "你所邀請的家庭成員將可以接觸你的個人健康資料，以及與其他家庭圈成員和醫護人員對話。",
		"circles.invites.makeInviteProviderText": "你所邀請的醫護人員將可以接觸個人健康資料，以及與其他醫療護理圈成員和病人家屬對話。",
		"circles.invites.makeInviteCaregiverText": "護理員可以為你答計劃內的問卷, 更改你的個人資料及以你的名義使用系統",
		"circles.invites.pending": "待定邀請",
		"circles.invites.caregiver": "護理員可以為病人答計劃內的問卷, 更改病人資料及以病人名義使用系統",
		"circles.circle": "圈",
		"circles.circle.typedCircle": "{type}圈",
		"circles.titles.invitations": "邀請",
		"circles.titles.listCaregiver": "你是下列病人的護理員",
		"circles.titles.familyMemberingCircle": "你的家庭圈",
		"circles.titles.listFamilyCircleMember": "家庭圈",
		"circles.titles.listProviderMember": "你是下列醫療護理圈成員",
		"circles.titles.familyCircle": "家庭圈",
		"circles.titles.providerCircle": "醫療護理圈",
		"circles.titles.primaryProviderProfileTitle": "我的醫療護理圈",
		"circles.titles.primaryPatientProfileTitle": "我的家庭圈",
		"circles.titles.caregiverRole": "護理員",
		"circles.titles.careProvider": "醫療護理人員",
		"circles.family.cancelInvite.title": "你確定要取消家庭圈的邀請?",
		"circles.family.cancelInvite.text": "你將要取消邀請你{role}加入家庭圈。邀請是在{login}送出. 一旦取消邀請便即作廢。",
		"circles.caregiver.cancelInvite.title": "你確定要取消護理員的邀請?",
		"circles.caregiver.cancelInvite.text": "你將要取消你{role}成為你護理員的邀請。 一旦取消邀請便即作廢。",
		"circles.actions.leave": "離開圈",
		"circles.actions.leaveBtn": "離開圈",
		"circles.actions.makeCaregiver": "分派護理員任務",
		"circles.actions.removeCaregiver": "取消護理員任務",
		"circles.actions.removeFromCircle": "從圈內刪除",
		"circles.actions.inviteProvider": "邀請醫療護理人員",
		"circles.actions.inviteFamily": "邀請家庭成員",
		"circles.leave.family.title": "你確定要離開這圈?",
		"circles.leave.family.body": "你將要離開{patient}的家庭圈. 一旦離開你將不能查看{patient}的個人資料。",
		"circles.leave.provider.title": "你確定要離開這圈?",
		"circles.leave.provider.body": "你將要離開{provider}的醫療護理圈. 一旦離開你將不能查看{provider}的圈內資料。",
		"circles.roles.spouse": "配偶",
		"circles.roles.daughter": "女兒",
		"circles.roles.son": "兒子",
		"circles.roles.sister": "姐妹",
		"circles.roles.brother": "兄弟",
		"circles.roles.mother": "母親",
		"circles.roles.father": "父親",
		"circles.roles.granddaughter": "孫女",
		"circles.roles.grandson": "孫子",
		"circles.roles.grandmother": "祖母/外祖母",
		"circles.roles.grandfather": "祖父/外祖父",
		"circles.roles.partner": "伴侶",
		"circles.roles.guardian": "監護人",
		"circles.roles.relative": "親戚",
		"circles.roles.friend": "朋友",
		"circles.roles.power_of_attorney": "授權人",
		"circles.roles.patient": "病人",
		"circles.roles.caregiver": "護理員",
		"circles.roles.left_the_circle": "已離開圈",
		"circles.roles.single_care_provider": "單一醫療護理人員",
		"circles.roles.family_member": "家庭成員",
		"circles.addProviderReason.temporaryTitle": "臨時使用",
		"circles.addProviderReason.permanentTitle": "永久分派",
		"circles.addProviderReason.temporary.emergencyAccess": "緊急使用",
		"circles.addProviderReason.temporary.temporarilyAssigned": "暫時分派",
		"circles.addProviderReason.temporary.patientConsultation": "會診",
		"circles.addProviderReason.permanent.underTreatment": "接受治療中",
		"circles.addProviderReason.permanent.patientRequest": "病人請求",
		"communities.empty.navigation": "沒有社區可供瀏覽",
		"communities.empty": "你未有社區",
		"communities.title.member": "我的社區",
		"communities.title.moderator": "我是論壇管理",
		"community.type.public": "大眾社區",
		"community.type.private": "私人社區",
		"community.type.global": "全球社區",
		"community.access.readOnly": "只讀",
		"community.actions.createPost": "新帖",
		"community.empty": "沒有這社區",
		"community.description": "關於",
		"community.posts": "新近帖子",
		"community.posts.empty": "還沒有帖子",
		"community.members": "成員",
		"community.postUpdated": "已更新",
		"community.activity.total": "你有{posts}個新帖和{comments}新評語",
		"community.activity.posts": "你有{posts}個新帖",
		"community.activity.comments": "你有{comments}個新評語",
		"post.title": "留下評語",
		"post.back": "返回帖子",
		"post.comments": "評語",
		"post.comments.add": "留下評語",
		"post.actions.createComment": "留下評語",
		"post.actions.reply": "回應",
		"post.comment.description": "已留下評語",
		"post.replies": "回應",
		"post.reply.description": "已回應{name}的評語",
		"post.reply.placeholder": "回應評語...",
		"post.comments.empty": "沒有評語",
		"community.newPost.title": "{name}社區新帖",
		"community.newPost.edit.title": "更改{name}社區帖子",
		"community.newPost.caption": "標題",
		"community.newPost.attachImage": "附帶圖片",
		"community.newPost.attachURL": "附帶連結",
		"community.newPost.addPost": "開帖",
		"community.newPost.editPost": "更改帖子",
		"community.newPost.fileError": "圖片限{size}mb以下",
		"community.newPost.urlError": "連結無效",
		"community.newPost.noPreview": "不能預覽",
		"community.newPost.enterUrl": "輸入網址...",
		"community.postMenu.editPost": "更改帖子",
		"community.postMenu.deletePost": "刪除帖子",
		"community.postMenu.confirmDeleteMessage": "你確定要刪除這帖子? 一旦刪除便不能再收復",
		"community.commentMenu.editComment": "更改評語",
		"community.commentMenu.deleteComment": "刪除評語",
		"community.commentMenu.confirmDeleteComment": "你確定要刪除這評語? 一旦刪除便不能再收復",
		"community.comments.commentWasDeleted": "評語已刪除",
		"community.comments.commentWasDeletedByModerator": "評語被論壇管理刪除",
		"community.roles.moderator": "論壇管理",
		"community.roles.member": "成員",
		"profile.fieldSet.empty": "這欄目沒有資料。 更改欄目加入資料。",
		"profiles.updated": "個人資料已更改",
		"settings.updated": "設定已更改",
		"programs.title": "計劃",
		"programs.emptyState": "還未沒有分派到任何計劃",
		"programs.invitation.emptyState": "沒有任何計劃給",
		"programs.invitation.addPatient": "加病人到計劃",
		"programs.invitation.invitationText": "邀請你加入計劃/服務",
		"programs.invitation.title": "{user}的計劃/服務邀請",
		"programs.invitation.empty": "你沒有計劃/服務的邀請",
		"programs.invitation.success": "病人成功地加入計劃",
		"programs.actions.request": "計劃/服務邀請",
		"programs.actions.title": "{user}的計劃/服務細節",
		"programs.actions.followup": "{user}的預約跟進",
		"programs.actions.subtitle": "關於這計劃/服務",
		"programs.actions.showMore": "顯示更多",
		"programs.actions.showLess": "顯示較少",
		"programs.actions.leave": "離開計劃/服務",
		"programs.actions.aboutProgram": "關於這計劃",
		"programs.remove.confirmRemove": "你確定要從{program}刪除{patientName}?",
		"programs.remove.success": "病人已從計劃中刪除",
		"programs.remove.title": "從計劃中刪除病人",
		"programs.remove.subtitle": "離開這計劃",
		"surveys.noUpcomingSurveys": "你沒有未答的問卷",
		"surveys.noSurveysResults": "沒有問卷結果",
		"surveys.sent": "問卷已送出",
		"surveys.answer": "問卷已答",
		"surveys.actions.answer": "答問卷",
		"surveys.actions.save": "保存草稿",
		"surveys.actions.proceed": "繼續",
		"surveys.actions.general": "服務滿意度",
		"surveys.actions.review": "回顧",
		"surveys.actions.submit": "提交答案",
		"surveys.actions.upcoming": "新問卷",
		"surveys.actions.upcomingHeading": "{user}的新問卷",
		"surveys.sendSurvey.noSurveys": "沒有問卷可送",
		"surveys.actions.exportToPDF": "轉換成PDF",
		"surveys.title": "問卷",
		"surveys.results": "問卷結果",
		"surveys.single": "問卷",
		"surveys.totalScore": "總分",
		"surveys.selectedChatDesc": "所選對話的成員皆可讀這問卷",
		"surveys.answeredBy": "回答者",
		"surveys.answerForm": "問卷已被答",
		"surveys.noAvailableForms": "沒有問卷",
		"profile.actions.cancel": "丟棄",
		"profile.actions.details": "查看個人資料細節",
		"profile.actions.submit": "保存",
		"profile.actions.provider": "醫療護理人員",
		"profile.actions.patient": "病人",
		"profile.actions.back": "病人的主版",
		"profile.avatar.remove": "刪除",
		"profile.avatar.upload": "上傳照片",
		"profile.avatar.update": "更新照片",
		"profile.tabType.patient": "用戶個人資料",
		"profile.tabType.provider": "醫療護理人員資料",
		"profile.tabType.surveys": "一般問卷",
		"profile.section.general": "一般資料",
		"profile.section.personal": "個人資料",
		"profile.section.contacts": "聯絡資料",
		"profile.section.health": "健康資料",
		"profile.section.prof": "職業資料",
		"profile.section.mrns": "病歷號碼",
		"profile.section.address": "住址",
		"profile.section.notificationSettings": "通知設定",
		"profile.section.languageSettings": "語言設定",
		"profile.fields.bio": "個人簡歷",
		"profile.fields.location": "地點",
		"profile.fields.phones": "電話",
		"profile.fields.healthInterests": "健康興趣",
		"profile.fields.name": "姓名",
		"profile.fields.firstName": "名",
		"profile.fields.middleName": "中間名",
		"profile.fields.lastName": "姓",
		"profile.fields.gender": "性別",
		"profile.fields.dob": "出生日期",
		"profile.fields.race": "種族",
		"profile.fields.mStatus": "婚姻狀況",
		"profile.fields.ethnic": "族群",
		"profile.fields.language": "語言",
		"profile.fields.religion": "宗教",
		"profile.fields.email": "電郵地址",
		"profile.fields.homeAddress": "住址",
		"profile.fields.address1": "地址 1",
		"profile.fields.address2": "地址 2",
		"profile.fields.city": "城市",
		"profile.fields.state": "州",
		"profile.fields.postalCode": "郵區",
		"profile.fields.country": "國家",
		"profile.fields.homePhone": "家庭電話號碼",
		"profile.fields.mobilePhone": "手機電話號碼",
		"profile.fields.localUid": "病歷號碼 (MRN)",
		"profile.fields.allergies": "敏感",
		"profile.fields.medicine": "藥物治療",
		"profile.fields.healthGoals": "健康目標",
		"profile.fields.role": "Role",
		"profile.fields.mrns": "病歷號碼",
		"profile.fields.localUidProvider": "醫療護理人員號碼",
		"profile.fields.npi": "醫療護理人員 NPI",
		"profile.fields.title": "Title",
		"profile.fields.specialty": "專業",
		"profile.fields.primaryPracticeAddress": "主要診所地址",
		"profile.fields.primaryPracticeAddress1": "主要診所地址 1",
		"profile.fields.primaryPracticeAddress2": "主要診所地址 2",
		"profile.fields.primaryPracticeCity": "主要診所城市",
		"profile.fields.primaryPracticeState": "主要診所州",
		"profile.fields.primaryPracticeCountry": "主要診所國家",
		"profile.fields.officePhone": "辦公室電話",
		"profile.fields.username": "用戶名",
		"profile.fields.phoneNumber": "手機電話號碼",
		"profile.fields.day": "日",
		"profile.fields.year": "年",
		"profile.fields.month": "月",
		"profile.edit.emailConfirmationTitle": "確定聯絡資料",
		"profile.edit.emailConfirmationText": "驗證電郵已送到{email}. 舊的電郵將繼續生效直至驗證成功為止",
		"profile.edit.confirmCode": "驗證碼",
		"profile.edit.invalidCode": "驗證碼無效",
		"profile.edit.phoneConfirmationText": "新電話號碼需要驗證。 一個含驗證碼的短訊已送到{phone}。請把驗證碼輸入。",
		"profile.notificationSettings.label": "採用{type} ({value})通知",
		"profile.notificationSettings.labels.email": "電郵",
		"profile.notificationSettings.labels.sms": "短訊",
		"profile.list.gender.M": "男",
		"profile.list.gender.F": "女",
		"profile.list.gender.O": "其他",
		"profile.list.gender.U": "不詳",
		"profile.list.marital.S": "單身",
		"profile.list.marital.M": "已婚",
		"profile.list.marital.O": "其他",
		"profile.list.marital.U": "不詳",
		"chat.common.removeFromChat": "從對話中刪除",
		"chat.actions.downloadAttachment": "下載附件",
		"chat.actions.editMessage": "更改訊息",
		"chat.actions.deleteMessage": "刪除訊息",
		"chat.actions.confirmDeleteMessage": "你確定要刪除訊息? 一旦刪除不能收復",
		"chat.actions.confirmLeaveChat": "你確定要離開對話嗎？",
		"chat.actions.reply": "回覆",
		"chat.actions.blockMessaging": "封鎖訊息",
		"chat.actions.unblockMessaging": "解除訊息封鎖",
		"chat.actions.unblockUser": "解除用戶封鎖",
		"chat.actions.leaveChat": "離開對話",
		"chat.titles.uploadingFile": "你在上載檔案 {name}",
		"chat.titles.generalChatTab": "醫療護理圈",
		"chat.titles.familyChatTab": "家庭專用",
		"chat.titles.providersChatTab": "醫護專用",
		"chat.titles.activitiesChatTab": "活動",
		"chat.titles.notificationsChatTab": "通知/警告",
		"chat.titles.healthAlert": "健康警告",
		"chat.titles.providerAssignment": "醫療護理人員分派",
		"chat.titles.providerRemoved": "刪除醫療護理人員分派",
		"chat.titles.memberAssignment": "成員分派",
		"chat.titles.notification": "通知",
		"chat.titles.surveyReminder": "提醒",
		"chat.titles.addedAttachment": "加入附件",
		"chat.titles.providers": "醫療護理人員",
		"chat.titles.family": "家庭",
		"chat.title.chatInContextOf": "對話圍繞著",
		"chat.title.inContextOf": "圍繞著",
		"chat.title.conversationInfo": "對話資料",
		"chat.title.chatName": "對話名",
		"chat.title.userBlocked": "你被對方封鎖，不能與他對話",
		"chat.placeholders.messageTo": "收信人",
		"chat.placeholders.default": "請輸入訊息",
		"chat.placeholders.surveyExpired": "這問卷已過期",
		"chat.notifications.patientAssignedToProgram": "{organizationName}的{providerName}已替{patientName}註冊到{programName}計劃/服務",
		"chat.notifications.patientRemovedFromProgram": "已從{programName}計劃/服務中刪除{patientName}",
		"chat.sorting.byUnread": "以最多未讀訊息排列",
		"chat.sorting.byLastMessage": "以最後訊息排列",
		"chat.errors.tooLong": "限{length}字",
		"chat.errors.maxAttachmentSize": "限50Mb已下",
		"chat.errors.maxAttachmentSizeNextPart": "檔案太大",
		"chat.errors.notAllowedFormat": "只可以上載 jpg, png, pdf, docx, xlsx, pptx, rtf, txt, xml, mov, mp4 和 vcf 檔案",
		"chat.errors.uploadError": "上載失誤。請再嘗試",
		"chat.errors.maxAttachmentNumber": "限每次上載20個檔案",
		"chat.moreAttachments.sendSurvey": "送出問卷",
		"chat.moreAttachments.answerForm": "答問卷",
		"chat.moreAttachments.attachFile": "加附件",
		"chat.notification.newMessage": "新訊息",
		"auth.accessDenied.text": "對不起，你沒有權限進入。",
		"auth.createPassword.text": "請輸入新密碼",
		"auth.expiredToken.text": "註冊連結有七天限期，而且只可用一次。",
		"auth.expiredConfirmation.text": "確認連結有七天限期，而且只可用一次。",
		"auth.recoverConfirm.email.title": "我們已把收復的步驟送到你的電郵。",
		"auth.recoverConfirm.email.confirmText": "請查看你的電郵。",
		"auth.recoverConfirm.phone.title": "我們已把收復的步驟傳送到你的電話。",
		"auth.recoverConfirm.phone.confirmText": "請查看你的電話。",
		"auth.recoverPassword.textTitle": "請輸入你的電郵地址或電話號碼，我們告知收復密碼的方法。",
		"auth.recoverPassword.textLink": "忘記密碼?",
		"auth.userNotFound.text": "沒有用這電郵/電話的用戶",
		"auth.signup.title": "沒有戶口?",
		"auth.signup.textLink": "註冊{brandName}",
		"auth.tnc.title": "我有閱讀並同意",
		"auth.tnc.textLink": "服務條款",
		"auth.logout.text": "登出",
		"errors.common": "有些地方出錯了...",
		"errors.commonErrorOccured": "發生了故障，請稍後再試",
		"errors.emailError": "請輸入正確電郵地址",
		"errors.emailErrorDesription": "登入 {故障}",
		"errors.invalidDateOfBirth": "請輸入正確出生日期",
		"errors.login.unauthorized": "戶口或密碼不符",
		"errors.login.authenticationLockout": "戶口暫時關閉15分鐘。請稍後再試",
		"errors.nameLength": "姓和名各限40字",
		"errors.requiredFields": "必須填寫所有項目",
		"errors.tnc": "請確認你已閱讀並同意所有服務條款。",
		"errors.cannotAcceptInvite": "你需要先輸入個人資料才能加入家庭圈",
		"errors.nicknameContainsCommercialAt": "你才不可以有@符號",
		"errors.password": "密碼不可以空白或全是空格",
		"errors.validation.profile.firstName.required": "必須填寫名",
		"errors.validation.profile.lastName.required": "必須填寫姓",
		"errors.validation.profile.phone.format": "電話號碼只限 +, - 和數字",
		"errors.validation.profile.phone.required": "必須填寫電話號碼",
		"errors.validation.profile.dob.format": "日期格式不對",
		"errors.validation.profile.dob.required": "必須填寫出生日期",
		"errors.validation.profile.email.format": "請填寫正確的電郵地址",
		"errors.validation.profile.email.required": "必須填寫電郵地址",
		"errors.validation.profile.username.required": "必須填寫用戶名",
		"errors.validation.profile.username.format": "用戶名只限字母和數字",
		"errors.username.alreadyTaken": "用戶名已被佔用",
		"fields.dob": "出生日期",
		"fields.email": "電郵",
		"fields.gender": "性別",
		"fields.firstname": "名",
		"fields.lastname": "姓",
		"fields.password": "密碼",
		"fields.username": "暱稱",
		"fields.login": "用戶名",
		"fields.login.placeholder": "電郵地址或電話號碼",
		"fields.phoneNumber": "電話號碼",
		"submit.signup": "繼續",
		"submit.login": "登錄",
		"submit.fillProfile": "確認",
		"submit.recoverPassword": "提交要求",
		"submit.recoverConfirm": "回到登錄",
		"submit.createPassword": "保存密碼",
		"submit.expiredToken": "知道了",
		"titles.accessDenied": "拒絕進入",
		"titles.createPassword": "設定密碼",
		"titles.expiredToken": "注册連結已失效",
		"titles.expiredConfirmation": "確認連結已失效",
		"titles.fillProfile": "個人資料",
		"titles.login": "登錄{brandName}",
		"titles.recoverConfirm": "收復連結已送出",
		"titles.recoverPassword": "收復密碼",
		"titles.signup": "注册{brandName}",
		"titles.confirmMyPhoneNumber": "我確認我的電話號碼",
		"titles.confirmMyEmail": "我確認我的電郵地址",
		"general.careProvidersTitle": "醫療護理人員",
		"previewableBlock.more": "顯示更多",
		"previewableBlock.less": "顯示較少",
		"generalSurveys.noSurveys": "你沒有服務滿意度資料",
		"intro.common.logout": "登出",
		"intro.common.circlesMenu": "邀請別人加入圈內",
		"intro.circles.inviteFamilyMember": "邀請別人加入家庭圈",
		"intro.circles.assignCaregiver": "分派別人為護理員。 護理員能以病人名義使用軟件",
		"intro.circles.inviteProviderMember": "邀請醫療護理人員加入圈內",
		"intro.circles.removeProviderMember": "從醫療護理圈中刪除人員",
		"intro.messages.generalChannel": "點擊標簽來與所有醫護人員和家人對話",
		"intro.messages.providerChannel": "與醫療護理人員的私人對話",
		"intro.messages.familyChannel": "與病人家屬的私人對話",
		"intro.messages.searchChat": "尋找對話",
		"intro.messages.selectChat": "選擇對話",
		"intro.messages.selectChannel": "選擇渠道",
		"intro.messages.typeFilter": "選擇對話了類別",
		"intro.messages.typeMessage": "請輸入訊息",
		"intro.messages.answerSurvey": "點擊然後回答問卷",
		"intro.messages.patientName": "點擊病人名字以查看醫療護理人員和計劃",
		"intro.messages.patientContext": "下列皆是這病人的資料",
		"intro.messages.patientProgram": "點擊以查看病人計劃",
		"intro.messages.programFilter": "篩選病人",
		"notificationScreen.title": "通知",
		"notificationScreen.providerWithoutPatients.notification": "圈子只為病人和家屬而設。",
		"notificationScreen.providerWithoutPatients.instructionTitle": "在{brandName}裡如何成為病人或家屬（護理員）?",
		"notificationScreen.providerWithoutPatients.instructionBody": "若想成為用戶，請詢問你的醫生是否已在{brandName}註冊。若已註冊可請他把你加入{brandName}的護理計劃。然後你可以邀請你的家屬加入你的護理圈。若想成為病人家屬用戶（護理員），請病人現有的家屬用戶邀請你到他的家庭圈。",
		"notificationScreen.providerWithoutPatients.commonTitle": "已經是病人或家屬?",
		"notificationScreen.providerWithoutPatients.commonBody": "如果你的醫生已替你加入了計劃，但你還沒有主版，嘗試更新你的電郵地址。",
		"routes.patientViewProfile": "病人個人資料",
		"routes.providerViewProfile": "醫療護理人員個人資料",
		"routes.userViewProfile": "用戶個人資料",
		"routes.providerMemberProfile": "醫療護理圈成員個人資料",
		"routes.familyMemberProfile": "病人家屬個人資料",
		"routes.generalSurveys": "一般問卷",
		"routes.parentProvider": "主要醫療護理人員",
		"routes.patientInfo": "病人資料",
		"routes.providerInfo": "醫療護理人員資料",
		"routes.settings": "設定",
		"role.admin": "管理",
		"dialog.common.invite": "邀請更多人加入對話",
		"dialog.success.joinCircle": "你已加入病人的醫療護理圈",
		"dialog.titles.joinCircle": "加入病人的醫療護理圈",
		"dialog.titles.assignProviderToPatient": "給病人分派新醫療護理人員",
		"dialog.common.noPatients": "如尋找不到病人，他可能不在系統之中或者已經分派給你。",
		"dialog.common.assign": "分派",
		"dialog.common.addPatient": "加入病人",
		"dialog.common.defaultPatient": "如要加入病人的醫療護理圈，請輸入病人的用戶或姓名",
		"dialog.common.addNewPatient": "加入新病人",
		"dialog.common.defaultProvider": "如要分派醫護人員給病人，請輸入醫護人員的用戶或姓名",
		"dialog.common.assignProvider": "分派醫療護理人員",
		"dialog.common.inviteCaregiver": "邀請護理員",
		"dialog.common.searchProvider": "尋找醫護人員...",
		"dialog.common.searchPatient": "尋找病人...",
		"dialog.common.addAnotherPatient": "你想加另一個病人入系統嗎?",
		"dialog.titles.addPatient": "加病人",
		"dialog.titles.andOr": "和 / 或"
	};

/***/ }),
/* 5360 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = camelCase;
	var regExp = /([A-Z])/g;
	
	/**
	 * Replace a string passed from String#replace.
	 * @param {String} str
	 * @return {String}
	 */
	function replace(str) {
	  return "-" + str.toLowerCase();
	}
	
	/**
	 * Convert camel cased property names to dash separated.
	 *
	 * @param {Object} style
	 * @return {Object}
	 */
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    converted[prop.replace(regExp, replace)] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 *
	 * @param {Rule} rule
	 */
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ }),
/* 5361 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Generated jss-default-unit CSS property units
	 *
	 * @type object
	 */
	exports['default'] = {
	  'animation-delay': 'ms',
	  'animation-duration': 'ms',
	  'background-position': 'px',
	  'background-position-x': 'px',
	  'background-position-y': 'px',
	  'background-size': 'px',
	  border: 'px',
	  'border-bottom': 'px',
	  'border-bottom-left-radius': 'px',
	  'border-bottom-right-radius': 'px',
	  'border-bottom-width': 'px',
	  'border-left': 'px',
	  'border-left-width': 'px',
	  'border-radius': 'px',
	  'border-right': 'px',
	  'border-right-width': 'px',
	  'border-spacing': 'px',
	  'border-top': 'px',
	  'border-top-left-radius': 'px',
	  'border-top-right-radius': 'px',
	  'border-top-width': 'px',
	  'border-width': 'px',
	  'border-after-width': 'px',
	  'border-before-width': 'px',
	  'border-end-width': 'px',
	  'border-horizontal-spacing': 'px',
	  'border-start-width': 'px',
	  'border-vertical-spacing': 'px',
	  bottom: 'px',
	  'box-shadow': 'px',
	  'column-gap': 'px',
	  'column-rule': 'px',
	  'column-rule-width': 'px',
	  'column-width': 'px',
	  'flex-basis': 'px',
	  'font-size': 'px',
	  'font-size-delta': 'px',
	  height: 'px',
	  left: 'px',
	  'letter-spacing': 'px',
	  'logical-height': 'px',
	  'logical-width': 'px',
	  margin: 'px',
	  'margin-after': 'px',
	  'margin-before': 'px',
	  'margin-bottom': 'px',
	  'margin-left': 'px',
	  'margin-right': 'px',
	  'margin-top': 'px',
	  'max-height': 'px',
	  'max-width': 'px',
	  'margin-end': 'px',
	  'margin-start': 'px',
	  'mask-position-x': 'px',
	  'mask-position-y': 'px',
	  'mask-size': 'px',
	  'max-logical-height': 'px',
	  'max-logical-width': 'px',
	  'min-height': 'px',
	  'min-width': 'px',
	  'min-logical-height': 'px',
	  'min-logical-width': 'px',
	  motion: 'px',
	  'motion-offset': 'px',
	  outline: 'px',
	  'outline-offset': 'px',
	  'outline-width': 'px',
	  padding: 'px',
	  'padding-bottom': 'px',
	  'padding-left': 'px',
	  'padding-right': 'px',
	  'padding-top': 'px',
	  'padding-after': 'px',
	  'padding-before': 'px',
	  'padding-end': 'px',
	  'padding-start': 'px',
	  'perspective-origin-x': '%',
	  'perspective-origin-y': '%',
	  perspective: 'px',
	  right: 'px',
	  'shape-margin': 'px',
	  size: 'px',
	  'text-indent': 'px',
	  'text-stroke': 'px',
	  'text-stroke-width': 'px',
	  top: 'px',
	  'transform-origin': '%',
	  'transform-origin-x': '%',
	  'transform-origin-y': '%',
	  'transform-origin-z': '%',
	  'transition-delay': 'ms',
	  'transition-duration': 'ms',
	  'vertical-align': 'px',
	  width: 'px',
	  'word-spacing': 'px',
	  // Not existing properties.
	  // Used to avoid issues with jss-expand intergration.
	  'box-shadow-x': 'px',
	  'box-shadow-y': 'px',
	  'box-shadow-blur': 'px',
	  'box-shadow-spread': 'px',
	  'font-line-height': 'px',
	  'text-shadow-x': 'px',
	  'text-shadow-y': 'px',
	  'text-shadow-blur': 'px'
	};

/***/ }),
/* 5362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports['default'] = defaultUnit;
	
	var _defaultUnits = __webpack_require__(5361);
	
	var _defaultUnits2 = _interopRequireDefault(_defaultUnits);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	  var newObj = {};
	  for (var key in obj) {
	    newObj[key] = obj[key];
	    newObj[key.replace(regExp, replace)] = obj[key];
	  }
	  return newObj;
	}
	
	var units = addCamelCasedVersion(_defaultUnits2['default']);
	
	/**
	 * Recursive deep style passing function
	 *
	 * @param {String} current property
	 * @param {(Object|Array|Number|String)} property value
	 * @param {Object} options
	 * @return {(Object|Array|Number|String)} resulting value
	 */
	function iterate(prop, value, options) {
	  if (!value) return value;
	
	  var convertedValue = value;
	
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  if (type === 'object' && Array.isArray(value)) type = 'array';
	
	  switch (type) {
	    case 'object':
	      if (prop === 'fallbacks') {
	        for (var innerProp in value) {
	          value[innerProp] = iterate(innerProp, value[innerProp], options);
	        }
	        break;
	      }
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
	      }
	      break;
	    case 'array':
	      for (var i = 0; i < value.length; i++) {
	        value[i] = iterate(prop, value[i], options);
	      }
	      break;
	    case 'number':
	      if (value !== 0) {
	        convertedValue = value + (options[prop] || units[prop] || '');
	      }
	      break;
	    default:
	      break;
	  }
	
	  return convertedValue;
	}
	
	/**
	 * Add unit to numeric values.
	 */
	function defaultUnit() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
	}

/***/ }),
/* 5363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports['default'] = jssGlobal;
	
	var _jss = __webpack_require__(2300);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var propKey = '@global';
	var prefixKey = '@global ';
	
	var GlobalContainerRule = function () {
	  function GlobalContainerRule(key, styles, options) {
	    _classCallCheck(this, GlobalContainerRule);
	
	    this.type = 'global';
	
	    this.key = key;
	    this.options = options;
	    this.rules = new _jss.RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector], { selector: selector });
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Get a rule.
	   */
	
	
	  _createClass(GlobalContainerRule, [{
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Create and register rule, run plugins.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, style, options) {
	      var rule = this.rules.add(name, style, options);
	      this.options.jss.plugins.onProcessRule(rule);
	      return rule;
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.rules.toString();
	    }
	  }]);
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule = function () {
	  function GlobalPrefixedRule(name, style, options) {
	    _classCallCheck(this, GlobalPrefixedRule);
	
	    this.name = name;
	    this.options = options;
	    var selector = name.substr(prefixKey.length);
	    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
	      parent: this,
	      selector: selector
	    }));
	  }
	
	  _createClass(GlobalPrefixedRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      return this.rule.toString(options);
	    }
	  }]);
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + ' ' + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	
	  var rules = style[propKey];
	
	  if (!rules) return;
	
	  for (var name in rules) {
	    options.sheet.addRule(name, rules[name], _extends({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[propKey];
	}
	
	function handlePrefixedGlobalRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop.substr(0, propKey.length) !== propKey) continue;
	
	    var selector = addScope(prop.substr(propKey.length), rule.selector);
	    options.sheet.addRule(selector, style[prop], _extends({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (name === propKey) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent.type === 'global') {
	        options.global = true;
	      }
	    }
	
	    if (options.global) options.selector = name;
	
	    return null;
	  }
	
	  function onProcessRule(rule) {
	    if (rule.type !== 'style') return;
	
	    handleNestedGlobalContainerRule(rule);
	    handlePrefixedGlobalRule(rule);
	  }
	
	  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
	}

/***/ }),
/* 5364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = jssNested;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container) {
	    return function (match, key) {
	      var rule = container.getRule(key);
	      if (rule) return rule.selector;
	      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
	      return key;
	    };
	  }
	
	  var hasAnd = function hasAnd(str) {
	    return str.indexOf('&') !== -1;
	  };
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', ';
	        // Replace all & by the parent or prefix & with the parent.
	        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, options) {
	    // Options has been already created, now we only increase index.
	    if (options) return _extends({}, options, { index: options.index + 1 });
	
	    var nestingLevel = rule.options.nestingLevel;
	
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	
	    return _extends({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1
	    });
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	    var container = rule.options.parent;
	    var options = void 0;
	    var replaceRef = void 0;
	    for (var prop in style) {
	      var isNested = hasAnd(prop);
	      var isNestedConditional = prop[0] === '@';
	
	      if (!isNested && !isNestedConditional) continue;
	
	      options = getOptions(rule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, rule.selector
	        // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	        );if (!replaceRef) replaceRef = getReplaceRef(container
	        // Replace all $refs.
	        );selector = selector.replace(refRegExp, replaceRef);
	
	        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
	      } else if (isNestedConditional) {
	        container
	        // Place conditional right after the parent rule to ensure right ordering.
	        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ }),
/* 5365 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = jssPropsSort;
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  function sort(prop0, prop1) {
	    return prop0.length - prop1.length;
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    var newStyle = {};
	    var props = Object.keys(style).sort(sort);
	    for (var prop in props) {
	      newStyle[props[prop]] = style[props[prop]];
	    }
	    return newStyle;
	  }
	
	  return { onProcessStyle: onProcessStyle };
	}

/***/ }),
/* 5366 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = jssVendorPrefixer;
	
	var _cssVendor = __webpack_require__(4694);
	
	var vendor = _interopRequireWildcard(_cssVendor);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 * Add vendor prefix to a property name when needed.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
	    }
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      var value = style[prop];
	
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, value);
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, value);
	  }
	
	  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
	}

/***/ }),
/* 5367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isInBrowser = __webpack_require__(965);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _StyleSheet = __webpack_require__(2299);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _PluginsRegistry = __webpack_require__(5368);
	
	var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);
	
	var _rules = __webpack_require__(5372);
	
	var _rules2 = _interopRequireDefault(_rules);
	
	var _observables = __webpack_require__(5371);
	
	var _observables2 = _interopRequireDefault(_observables);
	
	var _functions = __webpack_require__(5370);
	
	var _functions2 = _interopRequireDefault(_functions);
	
	var _sheets = __webpack_require__(1525);
	
	var _sheets2 = _interopRequireDefault(_sheets);
	
	var _StyleRule = __webpack_require__(567);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _createGenerateClassName = __webpack_require__(2301);
	
	var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);
	
	var _createRule2 = __webpack_require__(966);
	
	var _createRule3 = _interopRequireDefault(_createRule2);
	
	var _DomRenderer = __webpack_require__(5373);
	
	var _DomRenderer2 = _interopRequireDefault(_DomRenderer);
	
	var _VirtualRenderer = __webpack_require__(5374);
	
	var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);
	
	var instanceCounter = 0;
	
	var Jss = function () {
	  function Jss(options) {
	    _classCallCheck(this, Jss);
	
	    this.id = instanceCounter++;
	    this.version = "9.7.0";
	    this.plugins = new _PluginsRegistry2['default']();
	    this.options = {
	      createGenerateClassName: _createGenerateClassName2['default'],
	      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
	      plugins: []
	    };
	    this.generateClassName = (0, _createGenerateClassName2['default'])();
	
	    // eslint-disable-next-line prefer-spread
	    this.use.apply(this, defaultPlugins);
	    this.setup(options);
	  }
	
	  _createClass(Jss, [{
	    key: 'setup',
	    value: function setup() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (options.createGenerateClassName) {
	        this.options.createGenerateClassName = options.createGenerateClassName;
	        // $FlowFixMe
	        this.generateClassName = options.createGenerateClassName();
	      }
	
	      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
	      if (options.virtual || options.Renderer) {
	        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
	      }
	
	      // eslint-disable-next-line prefer-spread
	      if (options.plugins) this.use.apply(this, options.plugins);
	
	      return this;
	    }
	
	    /**
	     * Create a Style Sheet.
	     */
	
	  }, {
	    key: 'createStyleSheet',
	    value: function createStyleSheet(styles) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var index = options.index;
	      if (typeof index !== 'number') {
	        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
	      }
	      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
	        jss: this,
	        generateClassName: options.generateClassName || this.generateClassName,
	        insertionPoint: this.options.insertionPoint,
	        Renderer: this.options.Renderer,
	        index: index
	      }));
	      this.plugins.onProcessSheet(sheet);
	
	      return sheet;
	    }
	
	    /**
	     * Detach the Style Sheet and remove it from the registry.
	     */
	
	  }, {
	    key: 'removeStyleSheet',
	    value: function removeStyleSheet(sheet) {
	      sheet.detach();
	      _sheets2['default'].remove(sheet);
	      return this;
	    }
	
	    /**
	     * Create a rule without a Style Sheet.
	     */
	
	  }, {
	    key: 'createRule',
	    value: function createRule(name) {
	      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      // Enable rule without name for inline styles.
	      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	        options = style;
	        style = name;
	        name = undefined;
	      }
	
	      // Cast from RuleFactoryOptions to RuleOptions
	      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	      var ruleOptions = options;
	
	      ruleOptions.jss = this;
	      ruleOptions.Renderer = this.options.Renderer;
	      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
	      if (!ruleOptions.classes) ruleOptions.classes = {};
	      var rule = (0, _createRule3['default'])(name, style, ruleOptions);
	
	      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
	        rule.selector = '.' + ruleOptions.generateClassName(rule);
	      }
	
	      this.plugins.onProcessRule(rule);
	
	      return rule;
	    }
	
	    /**
	     * Register plugin. Passed function will be invoked with a rule instance.
	     */
	
	  }, {
	    key: 'use',
	    value: function use() {
	      var _this = this;
	
	      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
	        plugins[_key] = arguments[_key];
	      }
	
	      plugins.forEach(function (plugin) {
	        // Avoids applying same plugin twice, at least based on ref.
	        if (_this.options.plugins.indexOf(plugin) === -1) {
	          _this.options.plugins.push(plugin);
	          _this.plugins.use(plugin);
	        }
	      });
	
	      return this;
	    }
	  }]);
	
	  return Jss;
	}();
	
	exports['default'] = Jss;

/***/ }),
/* 5368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PluginsRegistry = function () {
	  function PluginsRegistry() {
	    _classCallCheck(this, PluginsRegistry);
	
	    this.hooks = {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: [],
	      onUpdate: []
	
	      /**
	       * Call `onCreateRule` hooks and return an object if returned by a hook.
	       */
	    };
	  }
	
	  _createClass(PluginsRegistry, [{
	    key: 'onCreateRule',
	    value: function onCreateRule(name, decl, options) {
	      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
	        var rule = this.hooks.onCreateRule[i](name, decl, options);
	        if (rule) return rule;
	      }
	      return null;
	    }
	
	    /**
	     * Call `onProcessRule` hooks.
	     */
	
	  }, {
	    key: 'onProcessRule',
	    value: function onProcessRule(rule) {
	      if (rule.isProcessed) return;
	      var sheet = rule.options.sheet;
	
	      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
	        this.hooks.onProcessRule[i](rule, sheet);
	      }
	
	      // $FlowFixMe
	      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	
	      rule.isProcessed = true;
	    }
	
	    /**
	     * Call `onProcessStyle` hooks.
	     */
	
	  }, {
	    key: 'onProcessStyle',
	    value: function onProcessStyle(style, rule, sheet) {
	      var nextStyle = style;
	
	      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
	        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
	        // $FlowFixMe
	        rule.style = nextStyle;
	      }
	    }
	
	    /**
	     * Call `onProcessSheet` hooks.
	     */
	
	  }, {
	    key: 'onProcessSheet',
	    value: function onProcessSheet(sheet) {
	      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
	        this.hooks.onProcessSheet[i](sheet);
	      }
	    }
	
	    /**
	     * Call `onUpdate` hooks.
	     */
	
	  }, {
	    key: 'onUpdate',
	    value: function onUpdate(data, rule, sheet) {
	      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
	        this.hooks.onUpdate[i](data, rule, sheet);
	      }
	    }
	
	    /**
	     * Call `onChangeValue` hooks.
	     */
	
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(value, prop, rule) {
	      var processedValue = value;
	      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
	        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
	      }
	      return processedValue;
	    }
	
	    /**
	     * Register a plugin.
	     * If function is passed, it is a shortcut for `{onProcessRule}`.
	     */
	
	  }, {
	    key: 'use',
	    value: function use(plugin) {
	      for (var name in plugin) {
	        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
	      }
	    }
	  }]);
	
	  return PluginsRegistry;
	}();
	
	exports['default'] = PluginsRegistry;

/***/ }),
/* 5369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 */
	var SheetsManager = function () {
	  function SheetsManager() {
	    _classCallCheck(this, SheetsManager);
	
	    this.sheets = [];
	    this.refs = [];
	    this.keys = [];
	  }
	
	  _createClass(SheetsManager, [{
	    key: 'get',
	    value: function get(key) {
	      var index = this.keys.indexOf(key);
	      return this.sheets[index];
	    }
	  }, {
	    key: 'add',
	    value: function add(key, sheet) {
	      var sheets = this.sheets,
	          refs = this.refs,
	          keys = this.keys;
	
	      var index = sheets.indexOf(sheet);
	
	      if (index !== -1) return index;
	
	      sheets.push(sheet);
	      refs.push(0);
	      keys.push(key);
	
	      return sheets.length - 1;
	    }
	  }, {
	    key: 'manage',
	    value: function manage(key) {
	      var index = this.keys.indexOf(key);
	      var sheet = this.sheets[index];
	      if (this.refs[index] === 0) sheet.attach();
	      this.refs[index]++;
	      if (!this.keys[index]) this.keys.splice(index, 0, key);
	      return sheet;
	    }
	  }, {
	    key: 'unmanage',
	    value: function unmanage(key) {
	      var index = this.keys.indexOf(key);
	      if (index === -1) {
	        // eslint-ignore-next-line no-console
	        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
	        return;
	      }
	      if (this.refs[index] > 0) {
	        this.refs[index]--;
	        if (this.refs[index] === 0) this.sheets[index].detach();
	      }
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return this.keys.length;
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	exports['default'] = SheetsManager;

/***/ }),
/* 5370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RuleList = __webpack_require__(725);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	var _StyleRule = __webpack_require__(567);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _kebabCase = __webpack_require__(5383);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _createRule = __webpack_require__(966);
	
	var _createRule2 = _interopRequireDefault(_createRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// A symbol replacement.
	var now = Date.now();
	var fnValuesNs = 'fnValues' + now;
	var fnStyleNs = 'fnStyle' + ++now;
	
	exports['default'] = {
	  onCreateRule: function onCreateRule(name, decl, options) {
	    if (typeof decl !== 'function') return null;
	    var rule = (0, _createRule2['default'])(name, {}, options);
	    rule[fnStyleNs] = decl;
	    return rule;
	  },
	  onProcessStyle: function onProcessStyle(style, rule) {
	    var fn = {};
	    for (var prop in style) {
	      var value = style[prop];
	      if (typeof value !== 'function') continue;
	      delete style[prop];
	      fn[(0, _kebabCase2['default'])(prop)] = value;
	    }
	    rule = rule;
	    rule[fnValuesNs] = fn;
	    return style;
	  },
	  onUpdate: function onUpdate(data, rule) {
	    // It is a rules container like for e.g. ConditionalRule.
	    if (rule.rules instanceof _RuleList2['default']) {
	      rule.rules.update(data);
	      return;
	    }
	    if (!(rule instanceof _StyleRule2['default'])) return;
	
	    rule = rule;
	
	    // If we have a fn values map, it is a rule with function values.
	    if (rule[fnValuesNs]) {
	      for (var prop in rule[fnValuesNs]) {
	        rule.prop(prop, rule[fnValuesNs][prop](data));
	      }
	    }
	
	    rule = rule;
	
	    var fnStyle = rule[fnStyleNs];
	
	    // If we have a style function, the entire rule is dynamic and style object
	    // will be returned from that function.
	    if (fnStyle) {
	      var style = fnStyle(data);
	      for (var _prop in style) {
	        rule.prop(_prop, style[_prop]);
	      }
	    }
	  }
	};

/***/ }),
/* 5371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _StyleRule = __webpack_require__(567);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _createRule = __webpack_require__(966);
	
	var _createRule2 = _interopRequireDefault(_createRule);
	
	var _isObservable = __webpack_require__(2302);
	
	var _isObservable2 = _interopRequireDefault(_isObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  onCreateRule: function onCreateRule(name, decl, options) {
	    if (!(0, _isObservable2['default'])(decl)) return null;
	
	    // Cast `decl` to `Observable`, since it passed the type guard.
	    var style$ = decl;
	
	    var rule = (0, _createRule2['default'])(name, {}, options);
	
	    // TODO
	    // Call `stream.subscribe()` returns a subscription, which should be explicitly
	    // unsubscribed from when we know this sheet is no longer needed.
	    style$.subscribe(function (style) {
	      for (var prop in style) {
	        rule.prop(prop, style[prop]);
	      }
	    });
	
	    return rule;
	  },
	  onProcessRule: function onProcessRule(rule) {
	    if (!(rule instanceof _StyleRule2['default'])) return;
	    var styleRule = rule;
	    var style = styleRule.style;
	
	    var _loop = function _loop(prop) {
	      var value = style[prop];
	      if (!(0, _isObservable2['default'])(value)) return 'continue';
	      delete style[prop];
	      value.subscribe({
	        next: function next(nextValue) {
	          styleRule.prop(prop, nextValue);
	        }
	      });
	    };
	
	    for (var prop in style) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	  }
	};

/***/ }),
/* 5372 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleRule = __webpack_require__(5378);
	
	var _SimpleRule2 = _interopRequireDefault(_SimpleRule);
	
	var _KeyframesRule = __webpack_require__(5377);
	
	var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);
	
	var _ConditionalRule = __webpack_require__(5375);
	
	var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);
	
	var _FontFaceRule = __webpack_require__(5376);
	
	var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);
	
	var _ViewportRule = __webpack_require__(5379);
	
	var _ViewportRule2 = _interopRequireDefault(_ViewportRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var classes = {
	  '@charset': _SimpleRule2['default'],
	  '@import': _SimpleRule2['default'],
	  '@namespace': _SimpleRule2['default'],
	  '@keyframes': _KeyframesRule2['default'],
	  '@media': _ConditionalRule2['default'],
	  '@supports': _ConditionalRule2['default'],
	  '@font-face': _FontFaceRule2['default'],
	  '@viewport': _ViewportRule2['default'],
	  '@-ms-viewport': _ViewportRule2['default']
	
	  /**
	   * Generate plugins which will register all rules.
	   */
	};
	exports['default'] = Object.keys(classes).map(function (key) {
	  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
	  var re = new RegExp('^' + key);
	  var onCreateRule = function onCreateRule(name, decl, options) {
	    return re.test(name) ? new classes[key](name, decl, options) : null;
	  };
	  return { onCreateRule: onCreateRule };
	});

/***/ }),
/* 5373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _sheets = __webpack_require__(1525);
	
	var _sheets2 = _interopRequireDefault(_sheets);
	
	var _StyleRule = __webpack_require__(567);
	
	var _StyleRule2 = _interopRequireDefault(_StyleRule);
	
	var _toCssValue = __webpack_require__(967);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Cache the value from the first time a function is called.
	 */
	var memoize = function memoize(fn) {
	  var value = void 0;
	  return function () {
	    if (!value) value = fn();
	    return value;
	  };
	};
	
	/**
	 * Get a style property value.
	 */
	function getPropertyValue(cssRule, prop) {
	  try {
	    return cssRule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	}
	
	/**
	 * Set a style property.
	 */
	function setProperty(cssRule, prop, value) {
	  try {
	    var cssValue = value;
	
	    if (Array.isArray(value)) {
	      cssValue = (0, _toCssValue2['default'])(value, true);
	
	      if (value[value.length - 1] === '!important') {
	        cssRule.style.setProperty(prop, cssValue, 'important');
	        return true;
	      }
	    }
	
	    cssRule.style.setProperty(prop, cssValue);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	  return true;
	}
	
	/**
	 * Remove a style property.
	 */
	function removeProperty(cssRule, prop) {
	  try {
	    cssRule.style.removeProperty(prop);
	  } catch (err) {
	    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
	  }
	}
	
	var CSSRuleTypes = {
	  STYLE_RULE: 1,
	  KEYFRAMES_RULE: 7
	
	  /**
	   * Get the CSS Rule key.
	   */
	
	};var getKey = function () {
	  var extractKey = function extractKey(cssText) {
	    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return cssText.substr(from, cssText.indexOf('{') - 1);
	  };
	
	  return function (cssRule) {
	    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
	    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
	      var name = cssRule.name;
	
	      if (name) return '@keyframes ' + name;
	
	      // There is no rule.name in the following browsers:
	      // - IE 9
	      // - Safari 7.1.8
	      // - Mobile Safari 9.0.0
	      var cssText = cssRule.cssText;
	
	      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
	    }
	
	    // Conditionals.
	    return extractKey(cssRule.cssText);
	  };
	}();
	
	/**
	 * Set the selector.
	 */
	function setSelector(cssRule, selectorText) {
	  cssRule.selectorText = selectorText;
	
	  // Return false if setter was not successful.
	  // Currently works in chrome only.
	  return cssRule.selectorText === selectorText;
	}
	
	/**
	 * Gets the `head` element upon the first call and caches it.
	 */
	var getHead = memoize(function () {
	  return document.head || document.getElementsByTagName('head')[0];
	});
	
	/**
	 * Gets a map of rule keys, where the property is an unescaped key and value
	 * is a potentially escaped one.
	 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
	 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
	 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
	 * and so CSS rule's `selectorText` won't match JSS rule selector.
	 *
	 * https://www.w3.org/International/questions/qa-escapes#cssescapes
	 */
	var getUnescapedKeysMap = function () {
	  var style = void 0;
	  var isAttached = false;
	
	  return function (rules) {
	    var map = {};
	    // https://github.com/facebook/flow/issues/2696
	    if (!style) style = document.createElement('style');
	    for (var i = 0; i < rules.length; i++) {
	      var rule = rules[i];
	      if (!(rule instanceof _StyleRule2['default'])) continue;
	      var selector = rule.selector;
	      // Only unescape selector over CSSOM if it contains a back slash.
	
	      if (selector && selector.indexOf('\\') !== -1) {
	        // Lazilly attach when needed.
	        if (!isAttached) {
	          getHead().appendChild(style);
	          isAttached = true;
	        }
	        style.textContent = selector + ' {}';
	        var _style = style,
	            sheet = _style.sheet;
	
	        if (sheet) {
	          var cssRules = sheet.cssRules;
	
	          if (cssRules) map[cssRules[0].selectorText] = rule.key;
	        }
	      }
	    }
	    if (isAttached) {
	      getHead().removeChild(style);
	      isAttached = false;
	    }
	    return map;
	  };
	}();
	
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find attached sheet with the highest index.
	 */
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find a comment with "jss" inside.
	 */
	function findCommentNode(text) {
	  var head = getHead();
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find a node before which we can insert the sheet.
	 */
	function findPrevNode(options) {
	  var registry = _sheets2['default'].registry;
	
	
	  if (registry.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry, options);
	    if (sheet) return sheet.renderer.element;
	
	    // Otherwise insert after the last attached.
	    sheet = findHighestSheet(registry, options);
	    if (sheet) return sheet.renderer.element.nextElementSibling;
	  }
	
	  // Try to find a comment placeholder if registry is empty.
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	    if (comment) return comment.nextSibling;
	    // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
	  }
	
	  return null;
	}
	
	/**
	 * Insert style element into the DOM.
	 */
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	
	  var prevNode = findPrevNode(options);
	
	  if (prevNode) {
	    var parentNode = prevNode.parentNode;
	
	    if (parentNode) parentNode.insertBefore(style, prevNode);
	    return;
	  }
	
	  // Works with iframes and any node types.
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	    var insertionPointElement = insertionPoint;
	    var _parentNode = insertionPointElement.parentNode;
	
	    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
	    return;
	  }
	
	  getHead().insertBefore(style, prevNode);
	}
	
	/**
	 * Read jss nonce setting from the page if the user has set it.
	 */
	var getNonce = memoize(function () {
	  var node = document.querySelector('meta[property="csp-nonce"]');
	  return node ? node.getAttribute('content') : null;
	});
	
	var DomRenderer = function () {
	  function DomRenderer(sheet) {
	    _classCallCheck(this, DomRenderer);
	
	    this.getPropertyValue = getPropertyValue;
	    this.setProperty = setProperty;
	    this.removeProperty = removeProperty;
	    this.setSelector = setSelector;
	    this.getKey = getKey;
	    this.getUnescapedKeysMap = getUnescapedKeysMap;
	    this.hasInsertedRules = false;
	
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) _sheets2['default'].add(sheet);
	
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || document.createElement('style');
	    this.element.type = 'text/css';
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	    var nonce = getNonce();
	    if (nonce) this.element.setAttribute('nonce', nonce);
	  }
	
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
	
	
	  _createClass(DomRenderer, [{
	    key: 'attach',
	    value: function attach() {
	      // In the case the element node is external and it is already in the DOM.
	      if (this.element.parentNode || !this.sheet) return;
	
	      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	      // browsers remove those rules.
	      // TODO figure out if its a bug and if it is known.
	      // Workaround is to redeploy the sheet before attaching as a string.
	      if (this.hasInsertedRules) {
	        this.deploy();
	        this.hasInsertedRules = false;
	      }
	
	      insertStyle(this.element, this.sheet.options);
	    }
	
	    /**
	     * Remove style element from render tree.
	     */
	
	  }, {
	    key: 'detach',
	    value: function detach() {
	      this.element.parentNode.removeChild(this.element);
	    }
	
	    /**
	     * Inject CSS string into element.
	     */
	
	  }, {
	    key: 'deploy',
	    value: function deploy() {
	      if (!this.sheet) return;
	      this.element.textContent = '\n' + this.sheet.toString() + '\n';
	    }
	
	    /**
	     * Insert a rule into element.
	     */
	
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule, index) {
	      var sheet = this.element.sheet;
	      var cssRules = sheet.cssRules;
	
	      var str = rule.toString();
	      if (!index) index = cssRules.length;
	
	      if (!str) return false;
	
	      try {
	        sheet.insertRule(str, index);
	      } catch (err) {
	        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
	        return false;
	      }
	      this.hasInsertedRules = true;
	
	      return cssRules[index];
	    }
	
	    /**
	     * Delete a rule.
	     */
	
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(cssRule) {
	      var sheet = this.element.sheet;
	
	      var index = this.indexOf(cssRule);
	      if (index === -1) return false;
	      sheet.deleteRule(index);
	      return true;
	    }
	
	    /**
	     * Get index of a CSS Rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(cssRule) {
	      var cssRules = this.element.sheet.cssRules;
	
	      for (var _index = 0; _index < cssRules.length; _index++) {
	        if (cssRule === cssRules[_index]) return _index;
	      }
	      return -1;
	    }
	
	    /**
	     * Generate a new CSS rule and replace the existing one.
	     */
	
	  }, {
	    key: 'replaceRule',
	    value: function replaceRule(cssRule, rule) {
	      var index = this.indexOf(cssRule);
	      var newCssRule = this.insertRule(rule, index);
	      this.element.sheet.deleteRule(index);
	      return newCssRule;
	    }
	
	    /**
	     * Get all rules elements.
	     */
	
	  }, {
	    key: 'getRules',
	    value: function getRules() {
	      return this.element.sheet.cssRules;
	    }
	  }]);
	
	  return DomRenderer;
	}();
	
	exports['default'] = DomRenderer;

/***/ }),
/* 5374 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable class-methods-use-this */
	
	/**
	 * Rendering backend to do nothing in nodejs.
	 */
	var VirtualRenderer = function () {
	  function VirtualRenderer() {
	    _classCallCheck(this, VirtualRenderer);
	  }
	
	  _createClass(VirtualRenderer, [{
	    key: 'setProperty',
	    value: function setProperty() {
	      return true;
	    }
	  }, {
	    key: 'getPropertyValue',
	    value: function getPropertyValue() {
	      return '';
	    }
	  }, {
	    key: 'removeProperty',
	    value: function removeProperty() {}
	  }, {
	    key: 'setSelector',
	    value: function setSelector() {
	      return true;
	    }
	  }, {
	    key: 'getKey',
	    value: function getKey() {
	      return '';
	    }
	  }, {
	    key: 'attach',
	    value: function attach() {}
	  }, {
	    key: 'detach',
	    value: function detach() {}
	  }, {
	    key: 'deploy',
	    value: function deploy() {}
	  }, {
	    key: 'insertRule',
	    value: function insertRule() {
	      return false;
	    }
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule() {
	      return true;
	    }
	  }, {
	    key: 'replaceRule',
	    value: function replaceRule() {
	      return false;
	    }
	  }, {
	    key: 'getRules',
	    value: function getRules() {}
	  }, {
	    key: 'indexOf',
	    value: function indexOf() {
	      return -1;
	    }
	  }]);
	
	  return VirtualRenderer;
	}();
	
	exports['default'] = VirtualRenderer;

/***/ }),
/* 5375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RuleList = __webpack_require__(725);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Conditional rule for @media, @supports
	 */
	var ConditionalRule = function () {
	  function ConditionalRule(key, styles, options) {
	    _classCallCheck(this, ConditionalRule);
	
	    this.type = 'conditional';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.options = options;
	    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Get a rule.
	   */
	
	
	  _createClass(ConditionalRule, [{
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Create and register rule, run plugins.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, style, options) {
	      var rule = this.rules.add(name, style, options);
	      this.options.jss.plugins.onProcessRule(rule);
	      return rule;
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };
	
	      var inner = this.rules.toString(options);
	      return inner ? this.key + ' {\n' + inner + '\n}' : '';
	    }
	  }]);
	
	  return ConditionalRule;
	}();
	
	exports['default'] = ConditionalRule;

/***/ }),
/* 5376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(1526);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FontFaceRule = function () {
	  function FontFaceRule(key, style, options) {
	    _classCallCheck(this, FontFaceRule);
	
	    this.type = 'font-face';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(FontFaceRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      if (Array.isArray(this.style)) {
	        var str = '';
	        for (var index = 0; index < this.style.length; index++) {
	          str += (0, _toCss2['default'])(this.key, this.style[index]);
	          if (this.style[index + 1]) str += '\n';
	        }
	        return str;
	      }
	
	      return (0, _toCss2['default'])(this.key, this.style, options);
	    }
	  }]);
	
	  return FontFaceRule;
	}();
	
	exports['default'] = FontFaceRule;

/***/ }),
/* 5377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RuleList = __webpack_require__(725);
	
	var _RuleList2 = _interopRequireDefault(_RuleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Rule for @keyframes
	 */
	var KeyframesRule = function () {
	  function KeyframesRule(key, frames, options) {
	    _classCallCheck(this, KeyframesRule);
	
	    this.type = 'keyframes';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.options = options;
	    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends({}, this.options, {
	        parent: this,
	        selector: name
	      }));
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(KeyframesRule, [{
	    key: 'toString',
	    value: function toString() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };
	
	      var inner = this.rules.toString(options);
	      if (inner) inner += '\n';
	      return this.key + ' {\n' + inner + '}';
	    }
	  }]);
	
	  return KeyframesRule;
	}();
	
	exports['default'] = KeyframesRule;

/***/ }),
/* 5378 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SimpleRule = function () {
	  function SimpleRule(key, value, options) {
	    _classCallCheck(this, SimpleRule);
	
	    this.type = 'simple';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  _createClass(SimpleRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      if (Array.isArray(this.value)) {
	        var str = '';
	        for (var index = 0; index < this.value.length; index++) {
	          str += this.key + ' ' + this.value[index] + ';';
	          if (this.value[index + 1]) str += '\n';
	        }
	        return str;
	      }
	
	      return this.key + ' ' + this.value + ';';
	    }
	  }]);
	
	  return SimpleRule;
	}();
	
	exports['default'] = SimpleRule;

/***/ }),
/* 5379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(1526);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ViewportRule = function () {
	  function ViewportRule(key, style, options) {
	    _classCallCheck(this, ViewportRule);
	
	    this.type = 'viewport';
	    this.isProcessed = false;
	
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(ViewportRule, [{
	    key: 'toString',
	    value: function toString(options) {
	      return (0, _toCss2['default'])(this.key, this.style, options);
	    }
	  }]);
	
	  return ViewportRule;
	}();
	
	exports['default'] = ViewportRule;

/***/ }),
/* 5380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports['default'] = cloneStyle;
	
	var _isObservable = __webpack_require__(2302);
	
	var _isObservable2 = _interopRequireDefault(_isObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isArray = Array.isArray;
	function cloneStyle(style) {
	  // Support empty values in case user ends up with them by accident.
	  if (style == null) return style;
	
	  // Support string value for SimpleRule.
	  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);
	
	  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
	    return style;
	  }
	
	  // Support array for FontFaceRule.
	  if (isArray(style)) return style.map(cloneStyle);
	
	  // Support Observable styles.  Observables are immutable, so we don't need to
	  // copy them.
	  if ((0, _isObservable2['default'])(style)) return style;
	
	  var newStyle = {};
	  for (var name in style) {
	    var value = style[name];
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      newStyle[name] = cloneStyle(value);
	      continue;
	    }
	    newStyle[name] = value;
	  }
	
	  return newStyle;
	}

/***/ }),
/* 5381 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CSS = global.CSS;
	
	var env = ("production");
	
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;
	
	exports['default'] = function (str) {
	  // We don't need to escape it in production, because we are not using user's
	  // input for selectors, we are generating a valid selector.
	  if (env === 'production') return str;
	
	  if (!CSS || !CSS.escape) {
	    return str.replace(escapeRegex, '\\$1');
	  }
	
	  return CSS.escape(str);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5382 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	exports['default'] = function (styles) {
	  // eslint-disable-next-line no-shadow
	  function extract(styles) {
	    var to = null;
	
	    for (var key in styles) {
	      var value = styles[key];
	      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	      if (type === 'function') {
	        if (!to) to = {};
	        to[key] = value;
	      } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	        var extracted = extract(value);
	        if (extracted) {
	          if (!to) to = {};
	          to[key] = extracted;
	        }
	      }
	    }
	
	    return to;
	  }
	
	  return extract(styles);
	};

/***/ }),
/* 5383 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var regExp = /([A-Z])/g;
	var replace = function replace(str) {
	  return "-" + str.toLowerCase();
	};
	
	exports["default"] = function (str) {
	  return str.replace(regExp, replace);
	};

/***/ }),
/* 5384 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
	if (global[ns] == null) global[ns] = 0;
	
	// Bundle may contain multiple JSS versions at the same time. In order to identify
	// the current version with just one short number and use it for classes generation
	// we use a counter. Also it is more accurate, because user can manually reevaluate
	// the module.
	exports['default'] = global[ns]++;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5385 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5386 */
[6722, 460, 246],
/* 5387 */
[6723, 5457, 5458, 5459, 5460, 5461],
/* 5388 */
[6727, 460, 246],
/* 5389 */
[6733, 460, 246],
/* 5390 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ }),
/* 5391 */,
/* 5392 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(2321);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ }),
/* 5393 */
5823,
/* 5394 */
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),
/* 5395 */
[6708, 377],
/* 5396 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(573),
	    keys = __webpack_require__(249);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 5397 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(573),
	    keysIn = __webpack_require__(734);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 5398 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.conformsTo` which accepts `props` to check.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property predicates to conform to.
	 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	 */
	function baseConformsTo(object, source, props) {
	  var length = props.length;
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (length--) {
	    var key = props[length],
	        predicate = source[key],
	        value = object[key];
	
	    if ((value === undefined && !(key in object)) || !predicate(value)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = baseConformsTo;


/***/ }),
/* 5399 */
[6709, 139],
/* 5400 */,
/* 5401 */
[6739, 377],
/* 5402 */,
/* 5403 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ }),
/* 5404 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ }),
/* 5405 */
5829,
/* 5406 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1530),
	    castPath = __webpack_require__(459),
	    last = __webpack_require__(463),
	    parent = __webpack_require__(2342),
	    toKey = __webpack_require__(461);
	
	/**
	 * The base implementation of `_.invoke` without support for individual
	 * method arguments.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {Array} args The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 */
	function baseInvoke(object, path, args) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  var func = object == null ? object : object[toKey(last(path))];
	  return func == null ? undefined : apply(func, object, args);
	}
	
	module.exports = baseInvoke;


/***/ }),
/* 5407 */
[6746, 321, 227],
/* 5408 */
[6748, 969, 2331, 5451, 5452, 574, 96, 730, 982],
/* 5409 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(574),
	    isObjectLike = __webpack_require__(227);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 5410 */
[6749, 969, 1535],
/* 5411 */
5833,
/* 5412 */
[6750, 731, 5466, 139, 2345],
/* 5413 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(574),
	    isObjectLike = __webpack_require__(227);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 5414 */
[6751, 321, 1557, 227],
/* 5415 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(139),
	    isPrototype = __webpack_require__(976),
	    nativeKeysIn = __webpack_require__(5480);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 5416 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ }),
/* 5417 */
[6754, 5410, 5453, 2339],
/* 5418 */
[6755, 1535, 4, 1556, 1550, 2338, 2339, 461],
/* 5419 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(2322);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/**
	 * The base implementation of `_.mean` and `_.meanBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the mean.
	 */
	function baseMean(array, iteratee) {
	  var length = array == null ? 0 : array.length;
	  return length ? (baseSum(array, iteratee) / length) : NAN;
	}
	
	module.exports = baseMean;


/***/ }),
/* 5420 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(2312),
	    cloneBuffer = __webpack_require__(2326),
	    cloneTypedArray = __webpack_require__(2327),
	    copyArray = __webpack_require__(1545),
	    initCloneObject = __webpack_require__(2337),
	    isArguments = __webpack_require__(729),
	    isArray = __webpack_require__(96),
	    isArrayLikeObject = __webpack_require__(980),
	    isBuffer = __webpack_require__(730),
	    isFunction = __webpack_require__(731),
	    isObject = __webpack_require__(139),
	    isPlainObject = __webpack_require__(248),
	    isTypedArray = __webpack_require__(982),
	    safeGet = __webpack_require__(2343),
	    toPlainObject = __webpack_require__(5522);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 5421 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(458),
	    baseGet = __webpack_require__(571),
	    baseIteratee = __webpack_require__(175),
	    baseMap = __webpack_require__(2318),
	    baseSortBy = __webpack_require__(5429),
	    baseUnary = __webpack_require__(727),
	    compareMultiple = __webpack_require__(5439),
	    identity = __webpack_require__(323),
	    isArray = __webpack_require__(96);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 5422 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(2320),
	    hasIn = __webpack_require__(1556);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 5423 */
[6756, 571],
/* 5424 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),
/* 5425 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ }),
/* 5426 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ }),
/* 5427 */
[6758, 5497, 2330, 323],
/* 5428 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(377);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ }),
/* 5429 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 5430 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(459),
	    last = __webpack_require__(463),
	    parent = __webpack_require__(2342),
	    toKey = __webpack_require__(461);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 5431 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(571),
	    baseSet = __webpack_require__(1537);
	
	/**
	 * The base implementation of `_.update`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to update.
	 * @param {Function} updater The function to produce the updated value.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseUpdate(object, path, updater, customizer) {
	  return baseSet(object, path, updater(baseGet(object, path)), customizer);
	}
	
	module.exports = baseUpdate;


/***/ }),
/* 5432 */
[6760, 458],
/* 5433 */,
/* 5434 */
[6764, 972],
/* 5435 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1544);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 5436 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 5437 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(569);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 5438 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(576);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 5439 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(5438);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 5440 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(573),
	    getSymbols = __webpack_require__(1548);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 5441 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(573),
	    getSymbolsIn = __webpack_require__(2335);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 5442 */
[6767, 246],
/* 5443 */
[6769, 247],
/* 5444 */
5857,
/* 5445 */
[6711, 1543, 1549, 1553, 468],
/* 5446 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(175),
	    isArrayLike = __webpack_require__(247),
	    keys = __webpack_require__(249);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 5447 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(5425),
	    isIterateeCall = __webpack_require__(575),
	    toFinite = __webpack_require__(2356);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ }),
/* 5448 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(2304),
	    noop = __webpack_require__(465),
	    setToArray = __webpack_require__(1552);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 5449 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(248);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 5450 */
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(5424);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),
/* 5451 */
[6772, 569, 2305, 728, 2331, 5477, 1552],
/* 5452 */
[6713, 2334],
/* 5453 */
[6776, 2338, 249],
/* 5454 */
[6778, 569],
/* 5455 */
5865,
/* 5456 */
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),
/* 5457 */
[6782, 977],
/* 5458 */
5869,
/* 5459 */
[6783, 977],
/* 5460 */
[6784, 977],
/* 5461 */
[6785, 977],
/* 5462 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 5463 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(1544),
	    cloneDataView = __webpack_require__(5435),
	    cloneRegExp = __webpack_require__(5436),
	    cloneSymbol = __webpack_require__(5437),
	    cloneTypedArray = __webpack_require__(2327);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 5464 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(569),
	    isArguments = __webpack_require__(729),
	    isArray = __webpack_require__(96);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 5465 */
5874,
/* 5466 */
[6788, 5442],
/* 5467 */
5876,
/* 5468 */
[6790, 971],
/* 5469 */
[6791, 971],
/* 5470 */
[6792, 971],
/* 5471 */
[6793, 971],
/* 5472 */
[6794, 5387, 968, 1527],
/* 5473 */
[6795, 974],
/* 5474 */
[6796, 974],
/* 5475 */
[6797, 974],
/* 5476 */
[6798, 974],
/* 5477 */
5886,
/* 5478 */
[6799, 5511],
/* 5479 */
[6801, 2340],
/* 5480 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 5481 */
5890,
/* 5482 */
5893,
/* 5483 */
5894,
/* 5484 */
5897,
/* 5485 */
[6806, 968],
/* 5486 */
5899,
/* 5487 */
5900,
/* 5488 */
5901,
/* 5489 */
[6807, 968, 1527, 1528],
/* 5490 */
5903,
/* 5491 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiSize = __webpack_require__(5392),
	    hasUnicode = __webpack_require__(1549),
	    unicodeSize = __webpack_require__(5494);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ }),
/* 5492 */
[6715, 5478],
/* 5493 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 5494 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    ++result;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ }),
/* 5495 */
5906,
/* 5496 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),
/* 5497 */
5908,
/* 5498 */
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(5450),
	    toString = __webpack_require__(468);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),
/* 5499 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(1533),
	    baseFlatten = __webpack_require__(570),
	    baseRest = __webpack_require__(572),
	    isArrayLikeObject = __webpack_require__(980),
	    last = __webpack_require__(463);
	
	/**
	 * This method is like `_.difference` except that it accepts `comparator`
	 * which is invoked to compare elements of `array` to `values`. The order and
	 * references of result values are determined by the first array. The comparator
	 * is invoked with two arguments: (arrVal, othVal).
	 *
	 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 *
	 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	 * // => [{ 'x': 2, 'y': 1 }]
	 */
	var differenceWith = baseRest(function(array, values) {
	  var comparator = last(values);
	  if (isArrayLikeObject(comparator)) {
	    comparator = undefined;
	  }
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	    : [];
	});
	
	module.exports = differenceWith;


/***/ }),
/* 5500 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5502);


/***/ }),
/* 5501 */,
/* 5502 */
[6812, 2306, 377, 1542, 96],
/* 5503 */,
/* 5504 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1530),
	    baseEach = __webpack_require__(377),
	    baseInvoke = __webpack_require__(5406),
	    baseRest = __webpack_require__(572),
	    isArrayLike = __webpack_require__(247);
	
	/**
	 * Invokes the method at `path` of each element in `collection`, returning
	 * an array of the results of each invoked method. Any additional arguments
	 * are provided to each invoked method. If `path` is a function, it's invoked
	 * for, and `this` bound to, each element in `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|string} path The path of the method to invoke or
	 *  the function invoked per iteration.
	 * @param {...*} [args] The arguments to invoke each method with.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	 * // => [[1, 5, 7], [1, 2, 3]]
	 *
	 * _.invokeMap([123, 456], String.prototype.split, '');
	 * // => [['1', '2', '3'], ['4', '5', '6']]
	 */
	var invokeMap = baseRest(function(collection, path, args) {
	  var index = -1,
	      isFunc = typeof path == 'function',
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value) {
	    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	  });
	  return result;
	});
	
	module.exports = invokeMap;


/***/ }),
/* 5505 */
[6818, 321, 227],
/* 5506 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(5409),
	    baseUnary = __webpack_require__(727),
	    nodeUtil = __webpack_require__(1551);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 5507 */
/***/ (function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(1558);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ }),
/* 5508 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(5413),
	    baseUnary = __webpack_require__(727),
	    nodeUtil = __webpack_require__(1551);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 5509 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(458),
	    baseIteratee = __webpack_require__(175),
	    baseMap = __webpack_require__(2318),
	    isArray = __webpack_require__(96);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 5510 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMean = __webpack_require__(5419),
	    identity = __webpack_require__(323);
	
	/**
	 * Computes the mean of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the mean.
	 * @example
	 *
	 * _.mean([4, 2, 8, 6]);
	 * // => 5
	 */
	function mean(array) {
	  return baseMean(array, identity);
	}
	
	module.exports = mean;


/***/ }),
/* 5511 */
[6825, 1528],
/* 5512 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(2319),
	    createAssigner = __webpack_require__(2329);
	
	/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined`, merging is handled by the
	 * method instead. The `customizer` is invoked with six arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = { 'a': [1], 'b': [2] };
	 * var other = { 'a': [3], 'b': [4] };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'a': [1, 3], 'b': [2, 4] }
	 */
	var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	  baseMerge(object, source, srcIndex, customizer);
	});
	
	module.exports = mergeWith;


/***/ }),
/* 5513 */
/***/ (function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(2314),
	    baseLt = __webpack_require__(5416),
	    identity = __webpack_require__(323);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ }),
/* 5514 */
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ }),
/* 5515 */
[6718, 246],
/* 5516 */
/***/ (function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(2328);
	
	/**
	 * Creates an array of elements split into two groups, the first of which
	 * contains elements `predicate` returns truthy for, the second of which
	 * contains elements `predicate` returns falsey for. The predicate is
	 * invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of grouped elements.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': false },
	 *   { 'user': 'fred',    'age': 40, 'active': true },
	 *   { 'user': 'pebbles', 'age': 1,  'active': false }
	 * ];
	 *
	 * _.partition(users, function(o) { return o.active; });
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.partition(users, { 'age': 1, 'active': false });
	 * // => objects for [['pebbles'], ['barney', 'fred']]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.partition(users, ['active', false]);
	 * // => objects for [['barney', 'pebbles'], ['fred']]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.partition(users, 'active');
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 */
	var partition = createAggregator(function(result, value, key) {
	  result[key ? 0 : 1].push(value);
	}, function() { return [[], []]; });
	
	module.exports = partition;


/***/ }),
/* 5517 */
[6826, 2321, 5423, 1550, 461],
/* 5518 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(1538),
	    isIterateeCall = __webpack_require__(575),
	    toInteger = __webpack_require__(987);
	
	/**
	 * Creates a slice of `array` from `start` up to, but not including, `end`.
	 *
	 * **Note:** This method is used instead of
	 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	 * returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function slice(array, start, end) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return [];
	  }
	  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	    start = 0;
	    end = length;
	  }
	  else {
	    start = start == null ? 0 : toInteger(start);
	    end = end === undefined ? length : toInteger(end);
	  }
	  return baseSlice(array, start, end);
	}
	
	module.exports = slice;


/***/ }),
/* 5519 */
5919,
/* 5520 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(2322),
	    identity = __webpack_require__(323);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.4.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ }),
/* 5521 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(2323),
	    castFunction = __webpack_require__(1542),
	    toInteger = __webpack_require__(987);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Invokes the iteratee `n` times, returning an array of the results of
	 * each invocation. The iteratee is invoked with one argument; (index).
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.times(3, String);
	 * // => ['0', '1', '2']
	 *
	 *  _.times(4, _.constant(0));
	 * // => [0, 0, 0, 0]
	 */
	function times(n, iteratee) {
	  n = toInteger(n);
	  if (n < 1 || n > MAX_SAFE_INTEGER) {
	    return [];
	  }
	  var index = MAX_ARRAY_LENGTH,
	      length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	  iteratee = castFunction(iteratee);
	  n -= MAX_ARRAY_LENGTH;
	
	  var result = baseTimes(length, iteratee);
	  while (++index < n) {
	    iteratee(index);
	  }
	  return result;
	}
	
	module.exports = times;


/***/ }),
/* 5522 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(573),
	    keysIn = __webpack_require__(734);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 5523 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUpdate = __webpack_require__(5431),
	    castFunction = __webpack_require__(1542);
	
	/**
	 * This method is like `_.set` except that accepts `updater` to produce the
	 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	 * is invoked with one argument: (value).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.6.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {Function} updater The function to produce the updated value.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	 * console.log(object.a[0].b.c);
	 * // => 9
	 *
	 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	 * console.log(object.x[0].y.z);
	 * // => 0
	 */
	function update(object, path, updater) {
	  return object == null ? object : baseUpdate(object, path, castFunction(updater));
	}
	
	module.exports = update;


/***/ }),
/* 5524 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(5394),
	    hasUnicodeWord = __webpack_require__(5456),
	    toString = __webpack_require__(468),
	    unicodeWords = __webpack_require__(5496);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),
/* 5525 */,
/* 5526 */
/***/ (function(module, exports, __webpack_require__) {

	(typeof navigator !== "undefined") && (function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.lottie = factory());
	})(this, (function () { 'use strict';
	
	  var svgNS = 'http://www.w3.org/2000/svg';
	  var locationHref = '';
	  var _useWebWorker = false;
	  var initialDefaultFrame = -999999;
	
	  var setWebWorker = function setWebWorker(flag) {
	    _useWebWorker = !!flag;
	  };
	
	  var getWebWorker = function getWebWorker() {
	    return _useWebWorker;
	  };
	
	  var setLocationHref = function setLocationHref(value) {
	    locationHref = value;
	  };
	
	  var getLocationHref = function getLocationHref() {
	    return locationHref;
	  };
	
	  function createTag(type) {
	    // return {appendChild:function(){},setAttribute:function(){},style:{}}
	    return document.createElement(type);
	  }
	
	  function extendPrototype(sources, destination) {
	    var i;
	    var len = sources.length;
	    var sourcePrototype;
	
	    for (i = 0; i < len; i += 1) {
	      sourcePrototype = sources[i].prototype;
	
	      for (var attr in sourcePrototype) {
	        if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
	      }
	    }
	  }
	
	  function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	  }
	
	  function createProxyFunction(prototype) {
	    function ProxyFunction() {}
	
	    ProxyFunction.prototype = prototype;
	    return ProxyFunction;
	  }
	
	  // import Howl from '../../3rd_party/howler';
	  var audioControllerFactory = function () {
	    function AudioController(audioFactory) {
	      this.audios = [];
	      this.audioFactory = audioFactory;
	      this._volume = 1;
	      this._isMuted = false;
	    }
	
	    AudioController.prototype = {
	      addAudio: function addAudio(audio) {
	        this.audios.push(audio);
	      },
	      pause: function pause() {
	        var i;
	        var len = this.audios.length;
	
	        for (i = 0; i < len; i += 1) {
	          this.audios[i].pause();
	        }
	      },
	      resume: function resume() {
	        var i;
	        var len = this.audios.length;
	
	        for (i = 0; i < len; i += 1) {
	          this.audios[i].resume();
	        }
	      },
	      setRate: function setRate(rateValue) {
	        var i;
	        var len = this.audios.length;
	
	        for (i = 0; i < len; i += 1) {
	          this.audios[i].setRate(rateValue);
	        }
	      },
	      createAudio: function createAudio(assetPath) {
	        if (this.audioFactory) {
	          return this.audioFactory(assetPath);
	        }
	
	        if (window.Howl) {
	          return new window.Howl({
	            src: [assetPath]
	          });
	        }
	
	        return {
	          isPlaying: false,
	          play: function play() {
	            this.isPlaying = true;
	          },
	          seek: function seek() {
	            this.isPlaying = false;
	          },
	          playing: function playing() {},
	          rate: function rate() {},
	          setVolume: function setVolume() {}
	        };
	      },
	      setAudioFactory: function setAudioFactory(audioFactory) {
	        this.audioFactory = audioFactory;
	      },
	      setVolume: function setVolume(value) {
	        this._volume = value;
	
	        this._updateVolume();
	      },
	      mute: function mute() {
	        this._isMuted = true;
	
	        this._updateVolume();
	      },
	      unmute: function unmute() {
	        this._isMuted = false;
	
	        this._updateVolume();
	      },
	      getVolume: function getVolume() {
	        return this._volume;
	      },
	      _updateVolume: function _updateVolume() {
	        var i;
	        var len = this.audios.length;
	
	        for (i = 0; i < len; i += 1) {
	          this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
	        }
	      }
	    };
	    return function () {
	      return new AudioController();
	    };
	  }();
	
	  var createTypedArray = function () {
	    function createRegularArray(type, len) {
	      var i = 0;
	      var arr = [];
	      var value;
	
	      switch (type) {
	        case 'int16':
	        case 'uint8c':
	          value = 1;
	          break;
	
	        default:
	          value = 1.1;
	          break;
	      }
	
	      for (i = 0; i < len; i += 1) {
	        arr.push(value);
	      }
	
	      return arr;
	    }
	
	    function createTypedArrayFactory(type, len) {
	      if (type === 'float32') {
	        return new Float32Array(len);
	      }
	
	      if (type === 'int16') {
	        return new Int16Array(len);
	      }
	
	      if (type === 'uint8c') {
	        return new Uint8ClampedArray(len);
	      }
	
	      return createRegularArray(type, len);
	    }
	
	    if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
	      return createTypedArrayFactory;
	    }
	
	    return createRegularArray;
	  }();
	
	  function createSizedArray(len) {
	    return Array.apply(null, {
	      length: len
	    });
	  }
	
	  function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }
	  var subframeEnabled = true;
	  var expressionsPlugin = null;
	  var expressionsInterfaces = null;
	  var idPrefix$1 = '';
	  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	  var _shouldRoundValues = false;
	  var bmPow = Math.pow;
	  var bmSqrt = Math.sqrt;
	  var bmFloor = Math.floor;
	  var bmMax = Math.max;
	  var bmMin = Math.min;
	  var BMMath = {};
	
	  (function () {
	    var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
	    var i;
	    var len = propertyNames.length;
	
	    for (i = 0; i < len; i += 1) {
	      BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	  })();
	
	  function ProjectInterface$1() {
	    return {};
	  }
	
	  BMMath.random = Math.random;
	
	  BMMath.abs = function (val) {
	    var tOfVal = _typeof$6(val);
	
	    if (tOfVal === 'object' && val.length) {
	      var absArr = createSizedArray(val.length);
	      var i;
	      var len = val.length;
	
	      for (i = 0; i < len; i += 1) {
	        absArr[i] = Math.abs(val[i]);
	      }
	
	      return absArr;
	    }
	
	    return Math.abs(val);
	  };
	
	  var defaultCurveSegments = 150;
	  var degToRads = Math.PI / 180;
	  var roundCorner = 0.5519;
	
	  function roundValues(flag) {
	    _shouldRoundValues = !!flag;
	  }
	
	  function bmRnd(value) {
	    if (_shouldRoundValues) {
	      return Math.round(value);
	    }
	
	    return value;
	  }
	
	  function styleDiv(element) {
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = '0 0';
	    element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility = 'visible';
	    element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = 'preserve-3d';
	    element.style.webkitTransformStyle = 'preserve-3d';
	    element.style.mozTransformStyle = 'preserve-3d';
	  }
	
	  function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
	    this.type = type;
	    this.currentTime = currentTime;
	    this.totalTime = totalTime;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }
	
	  function BMCompleteEvent(type, frameMultiplier) {
	    this.type = type;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }
	
	  function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
	    this.type = type;
	    this.currentLoop = currentLoop;
	    this.totalLoops = totalLoops;
	    this.direction = frameMultiplier < 0 ? -1 : 1;
	  }
	
	  function BMSegmentStartEvent(type, firstFrame, totalFrames) {
	    this.type = type;
	    this.firstFrame = firstFrame;
	    this.totalFrames = totalFrames;
	  }
	
	  function BMDestroyEvent(type, target) {
	    this.type = type;
	    this.target = target;
	  }
	
	  function BMRenderFrameErrorEvent(nativeError, currentTime) {
	    this.type = 'renderFrameError';
	    this.nativeError = nativeError;
	    this.currentTime = currentTime;
	  }
	
	  function BMConfigErrorEvent(nativeError) {
	    this.type = 'configError';
	    this.nativeError = nativeError;
	  }
	
	  function BMAnimationConfigErrorEvent(type, nativeError) {
	    this.type = type;
	    this.nativeError = nativeError;
	  }
	
	  var createElementID = function () {
	    var _count = 0;
	    return function createID() {
	      _count += 1;
	      return idPrefix$1 + '__lottie_element_' + _count;
	    };
	  }();
	
	  function HSVtoRGB(h, s, v) {
	    var r;
	    var g;
	    var b;
	    var i;
	    var f;
	    var p;
	    var q;
	    var t;
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);
	
	    switch (i % 6) {
	      case 0:
	        r = v;
	        g = t;
	        b = p;
	        break;
	
	      case 1:
	        r = q;
	        g = v;
	        b = p;
	        break;
	
	      case 2:
	        r = p;
	        g = v;
	        b = t;
	        break;
	
	      case 3:
	        r = p;
	        g = q;
	        b = v;
	        break;
	
	      case 4:
	        r = t;
	        g = p;
	        b = v;
	        break;
	
	      case 5:
	        r = v;
	        g = p;
	        b = q;
	        break;
	
	      default:
	        break;
	    }
	
	    return [r, g, b];
	  }
	
	  function RGBtoHSV(r, g, b) {
	    var max = Math.max(r, g, b);
	    var min = Math.min(r, g, b);
	    var d = max - min;
	    var h;
	    var s = max === 0 ? 0 : d / max;
	    var v = max / 255;
	
	    switch (max) {
	      case min:
	        h = 0;
	        break;
	
	      case r:
	        h = g - b + d * (g < b ? 6 : 0);
	        h /= 6 * d;
	        break;
	
	      case g:
	        h = b - r + d * 2;
	        h /= 6 * d;
	        break;
	
	      case b:
	        h = r - g + d * 4;
	        h /= 6 * d;
	        break;
	
	      default:
	        break;
	    }
	
	    return [h, s, v];
	  }
	
	  function addSaturationToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[1] += offset;
	
	    if (hsv[1] > 1) {
	      hsv[1] = 1;
	    } else if (hsv[1] <= 0) {
	      hsv[1] = 0;
	    }
	
	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }
	
	  function addBrightnessToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[2] += offset;
	
	    if (hsv[2] > 1) {
	      hsv[2] = 1;
	    } else if (hsv[2] < 0) {
	      hsv[2] = 0;
	    }
	
	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }
	
	  function addHueToRGB(color, offset) {
	    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
	    hsv[0] += offset / 360;
	
	    if (hsv[0] > 1) {
	      hsv[0] -= 1;
	    } else if (hsv[0] < 0) {
	      hsv[0] += 1;
	    }
	
	    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
	  }
	
	  var rgbToHex = function () {
	    var colorMap = [];
	    var i;
	    var hex;
	
	    for (i = 0; i < 256; i += 1) {
	      hex = i.toString(16);
	      colorMap[i] = hex.length === 1 ? '0' + hex : hex;
	    }
	
	    return function (r, g, b) {
	      if (r < 0) {
	        r = 0;
	      }
	
	      if (g < 0) {
	        g = 0;
	      }
	
	      if (b < 0) {
	        b = 0;
	      }
	
	      return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	  }();
	
	  var setSubframeEnabled = function setSubframeEnabled(flag) {
	    subframeEnabled = !!flag;
	  };
	
	  var getSubframeEnabled = function getSubframeEnabled() {
	    return subframeEnabled;
	  };
	
	  var setExpressionsPlugin = function setExpressionsPlugin(value) {
	    expressionsPlugin = value;
	  };
	
	  var getExpressionsPlugin = function getExpressionsPlugin() {
	    return expressionsPlugin;
	  };
	
	  var setExpressionInterfaces = function setExpressionInterfaces(value) {
	    expressionsInterfaces = value;
	  };
	
	  var getExpressionInterfaces = function getExpressionInterfaces() {
	    return expressionsInterfaces;
	  };
	
	  var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
	    defaultCurveSegments = value;
	  };
	
	  var getDefaultCurveSegments = function getDefaultCurveSegments() {
	    return defaultCurveSegments;
	  };
	
	  var setIdPrefix = function setIdPrefix(value) {
	    idPrefix$1 = value;
	  };
	
	  var getIdPrefix = function getIdPrefix() {
	    return idPrefix$1;
	  };
	
	  function createNS(type) {
	    // return {appendChild:function(){},setAttribute:function(){},style:{}}
	    return document.createElementNS(svgNS, type);
	  }
	
	  function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }
	
	  var dataManager = function () {
	    var _counterId = 1;
	    var processes = [];
	    var workerFn;
	    var workerInstance;
	    var workerProxy = {
	      onmessage: function onmessage() {},
	      postMessage: function postMessage(path) {
	        workerFn({
	          data: path
	        });
	      }
	    };
	    var _workerSelf = {
	      postMessage: function postMessage(data) {
	        workerProxy.onmessage({
	          data: data
	        });
	      }
	    };
	
	    function createWorker(fn) {
	      if (window.Worker && window.Blob && getWebWorker()) {
	        var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], {
	          type: 'text/javascript'
	        }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
	
	        var url = URL.createObjectURL(blob);
	        return new Worker(url);
	      }
	
	      workerFn = fn;
	      return workerProxy;
	    }
	
	    function setupWorker() {
	      if (!workerInstance) {
	        workerInstance = createWorker(function workerStart(e) {
	          function dataFunctionManager() {
	            function completeLayers(layers, comps) {
	              var layerData;
	              var i;
	              var len = layers.length;
	              var j;
	              var jLen;
	              var k;
	              var kLen;
	
	              for (i = 0; i < len; i += 1) {
	                layerData = layers[i];
	
	                if ('ks' in layerData && !layerData.completed) {
	                  layerData.completed = true;
	
	                  if (layerData.hasMask) {
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	
	                    for (j = 0; j < jLen; j += 1) {
	                      if (maskProps[j].pt.k.i) {
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                      } else {
	                        kLen = maskProps[j].pt.k.length;
	
	                        for (k = 0; k < kLen; k += 1) {
	                          if (maskProps[j].pt.k[k].s) {
	                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                          }
	
	                          if (maskProps[j].pt.k[k].e) {
	                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                          }
	                        }
	                      }
	                    }
	                  }
	
	                  if (layerData.ty === 0) {
	                    layerData.layers = findCompLayers(layerData.refId, comps);
	                    completeLayers(layerData.layers, comps);
	                  } else if (layerData.ty === 4) {
	                    completeShapes(layerData.shapes);
	                  } else if (layerData.ty === 5) {
	                    completeText(layerData);
	                  }
	                }
	              }
	            }
	
	            function completeChars(chars, assets) {
	              if (chars) {
	                var i = 0;
	                var len = chars.length;
	
	                for (i = 0; i < len; i += 1) {
	                  if (chars[i].t === 1) {
	                    // var compData = findComp(chars[i].data.refId, assets);
	                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
	                    // chars[i].data.op = 99999;
	                    // chars[i].data.st = 0;
	                    // chars[i].data.sr = 1;
	                    // chars[i].w = compData.w;
	                    // chars[i].data.ks = {
	                    //   a: { k: [0, 0, 0], a: 0 },
	                    //   p: { k: [0, -compData.h, 0], a: 0 },
	                    //   r: { k: 0, a: 0 },
	                    //   s: { k: [100, 100], a: 0 },
	                    //   o: { k: 100, a: 0 },
	                    // };
	
	                    completeLayers(chars[i].data.layers, assets);
	                  }
	                }
	              }
	            }
	
	            function findComp(id, comps) {
	              var i = 0;
	              var len = comps.length;
	
	              while (i < len) {
	                if (comps[i].id === id) {
	                  return comps[i];
	                }
	
	                i += 1;
	              }
	
	              return null;
	            }
	
	            function findCompLayers(id, comps) {
	              var comp = findComp(id, comps);
	
	              if (comp) {
	                if (!comp.layers.__used) {
	                  comp.layers.__used = true;
	                  return comp.layers;
	                }
	
	                return JSON.parse(JSON.stringify(comp.layers));
	              }
	
	              return null;
	            }
	
	            function completeShapes(arr) {
	              var i;
	              var len = arr.length;
	              var j;
	              var jLen;
	
	              for (i = len - 1; i >= 0; i -= 1) {
	                if (arr[i].ty === 'sh') {
	                  if (arr[i].ks.k.i) {
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                  } else {
	                    jLen = arr[i].ks.k.length;
	
	                    for (j = 0; j < jLen; j += 1) {
	                      if (arr[i].ks.k[j].s) {
	                        convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                      }
	
	                      if (arr[i].ks.k[j].e) {
	                        convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                      }
	                    }
	                  }
	                } else if (arr[i].ty === 'gr') {
	                  completeShapes(arr[i].it);
	                }
	              }
	            }
	
	            function convertPathsToAbsoluteValues(path) {
	              var i;
	              var len = path.i.length;
	
	              for (i = 0; i < len; i += 1) {
	                path.i[i][0] += path.v[i][0];
	                path.i[i][1] += path.v[i][1];
	                path.o[i][0] += path.v[i][0];
	                path.o[i][1] += path.v[i][1];
	              }
	            }
	
	            function checkVersion(minimum, animVersionString) {
	              var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];
	
	              if (minimum[0] > animVersion[0]) {
	                return true;
	              }
	
	              if (animVersion[0] > minimum[0]) {
	                return false;
	              }
	
	              if (minimum[1] > animVersion[1]) {
	                return true;
	              }
	
	              if (animVersion[1] > minimum[1]) {
	                return false;
	              }
	
	              if (minimum[2] > animVersion[2]) {
	                return true;
	              }
	
	              if (animVersion[2] > minimum[2]) {
	                return false;
	              }
	
	              return null;
	            }
	
	            var checkText = function () {
	              var minimumVersion = [4, 4, 14];
	
	              function updateTextLayer(textLayer) {
	                var documentData = textLayer.t.d;
	                textLayer.t.d = {
	                  k: [{
	                    s: documentData,
	                    t: 0
	                  }]
	                };
	              }
	
	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;
	
	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 5) {
	                    updateTextLayer(layers[i]);
	                  }
	                }
	              }
	
	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);
	
	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;
	
	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            var checkChars = function () {
	              var minimumVersion = [4, 7, 99];
	              return function (animationData) {
	                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
	                  var i;
	                  var len = animationData.chars.length;
	
	                  for (i = 0; i < len; i += 1) {
	                    var charData = animationData.chars[i];
	
	                    if (charData.data && charData.data.shapes) {
	                      completeShapes(charData.data.shapes);
	                      charData.data.ip = 0;
	                      charData.data.op = 99999;
	                      charData.data.st = 0;
	                      charData.data.sr = 1;
	                      charData.data.ks = {
	                        p: {
	                          k: [0, 0],
	                          a: 0
	                        },
	                        s: {
	                          k: [100, 100],
	                          a: 0
	                        },
	                        a: {
	                          k: [0, 0],
	                          a: 0
	                        },
	                        r: {
	                          k: 0,
	                          a: 0
	                        },
	                        o: {
	                          k: 100,
	                          a: 0
	                        }
	                      };
	
	                      if (!animationData.chars[i].t) {
	                        charData.data.shapes.push({
	                          ty: 'no'
	                        });
	                        charData.data.shapes[0].it.push({
	                          p: {
	                            k: [0, 0],
	                            a: 0
	                          },
	                          s: {
	                            k: [100, 100],
	                            a: 0
	                          },
	                          a: {
	                            k: [0, 0],
	                            a: 0
	                          },
	                          r: {
	                            k: 0,
	                            a: 0
	                          },
	                          o: {
	                            k: 100,
	                            a: 0
	                          },
	                          sk: {
	                            k: 0,
	                            a: 0
	                          },
	                          sa: {
	                            k: 0,
	                            a: 0
	                          },
	                          ty: 'tr'
	                        });
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            var checkPathProperties = function () {
	              var minimumVersion = [5, 7, 15];
	
	              function updateTextLayer(textLayer) {
	                var pathData = textLayer.t.p;
	
	                if (typeof pathData.a === 'number') {
	                  pathData.a = {
	                    a: 0,
	                    k: pathData.a
	                  };
	                }
	
	                if (typeof pathData.p === 'number') {
	                  pathData.p = {
	                    a: 0,
	                    k: pathData.p
	                  };
	                }
	
	                if (typeof pathData.r === 'number') {
	                  pathData.r = {
	                    a: 0,
	                    k: pathData.r
	                  };
	                }
	              }
	
	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;
	
	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 5) {
	                    updateTextLayer(layers[i]);
	                  }
	                }
	              }
	
	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);
	
	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;
	
	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            var checkColors = function () {
	              var minimumVersion = [4, 1, 9];
	
	              function iterateShapes(shapes) {
	                var i;
	                var len = shapes.length;
	                var j;
	                var jLen;
	
	                for (i = 0; i < len; i += 1) {
	                  if (shapes[i].ty === 'gr') {
	                    iterateShapes(shapes[i].it);
	                  } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
	                    if (shapes[i].c.k && shapes[i].c.k[0].i) {
	                      jLen = shapes[i].c.k.length;
	
	                      for (j = 0; j < jLen; j += 1) {
	                        if (shapes[i].c.k[j].s) {
	                          shapes[i].c.k[j].s[0] /= 255;
	                          shapes[i].c.k[j].s[1] /= 255;
	                          shapes[i].c.k[j].s[2] /= 255;
	                          shapes[i].c.k[j].s[3] /= 255;
	                        }
	
	                        if (shapes[i].c.k[j].e) {
	                          shapes[i].c.k[j].e[0] /= 255;
	                          shapes[i].c.k[j].e[1] /= 255;
	                          shapes[i].c.k[j].e[2] /= 255;
	                          shapes[i].c.k[j].e[3] /= 255;
	                        }
	                      }
	                    } else {
	                      shapes[i].c.k[0] /= 255;
	                      shapes[i].c.k[1] /= 255;
	                      shapes[i].c.k[2] /= 255;
	                      shapes[i].c.k[3] /= 255;
	                    }
	                  }
	                }
	              }
	
	              function iterateLayers(layers) {
	                var i;
	                var len = layers.length;
	
	                for (i = 0; i < len; i += 1) {
	                  if (layers[i].ty === 4) {
	                    iterateShapes(layers[i].shapes);
	                  }
	                }
	              }
	
	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);
	
	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;
	
	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            var checkShapes = function () {
	              var minimumVersion = [4, 4, 18];
	
	              function completeClosingShapes(arr) {
	                var i;
	                var len = arr.length;
	                var j;
	                var jLen;
	
	                for (i = len - 1; i >= 0; i -= 1) {
	                  if (arr[i].ty === 'sh') {
	                    if (arr[i].ks.k.i) {
	                      arr[i].ks.k.c = arr[i].closed;
	                    } else {
	                      jLen = arr[i].ks.k.length;
	
	                      for (j = 0; j < jLen; j += 1) {
	                        if (arr[i].ks.k[j].s) {
	                          arr[i].ks.k[j].s[0].c = arr[i].closed;
	                        }
	
	                        if (arr[i].ks.k[j].e) {
	                          arr[i].ks.k[j].e[0].c = arr[i].closed;
	                        }
	                      }
	                    }
	                  } else if (arr[i].ty === 'gr') {
	                    completeClosingShapes(arr[i].it);
	                  }
	                }
	              }
	
	              function iterateLayers(layers) {
	                var layerData;
	                var i;
	                var len = layers.length;
	                var j;
	                var jLen;
	                var k;
	                var kLen;
	
	                for (i = 0; i < len; i += 1) {
	                  layerData = layers[i];
	
	                  if (layerData.hasMask) {
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	
	                    for (j = 0; j < jLen; j += 1) {
	                      if (maskProps[j].pt.k.i) {
	                        maskProps[j].pt.k.c = maskProps[j].cl;
	                      } else {
	                        kLen = maskProps[j].pt.k.length;
	
	                        for (k = 0; k < kLen; k += 1) {
	                          if (maskProps[j].pt.k[k].s) {
	                            maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                          }
	
	                          if (maskProps[j].pt.k[k].e) {
	                            maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                          }
	                        }
	                      }
	                    }
	                  }
	
	                  if (layerData.ty === 4) {
	                    completeClosingShapes(layerData.shapes);
	                  }
	                }
	              }
	
	              return function (animationData) {
	                if (checkVersion(minimumVersion, animationData.v)) {
	                  iterateLayers(animationData.layers);
	
	                  if (animationData.assets) {
	                    var i;
	                    var len = animationData.assets.length;
	
	                    for (i = 0; i < len; i += 1) {
	                      if (animationData.assets[i].layers) {
	                        iterateLayers(animationData.assets[i].layers);
	                      }
	                    }
	                  }
	                }
	              };
	            }();
	
	            function completeData(animationData) {
	              if (animationData.__complete) {
	                return;
	              }
	
	              checkColors(animationData);
	              checkText(animationData);
	              checkChars(animationData);
	              checkPathProperties(animationData);
	              checkShapes(animationData);
	              completeLayers(animationData.layers, animationData.assets);
	              completeChars(animationData.chars, animationData.assets);
	              animationData.__complete = true;
	            }
	
	            function completeText(data) {
	              if (data.t.a.length === 0 && !('m' in data.t.p)) {// data.singleShape = true;
	              }
	            }
	
	            var moduleOb = {};
	            moduleOb.completeData = completeData;
	            moduleOb.checkColors = checkColors;
	            moduleOb.checkChars = checkChars;
	            moduleOb.checkPathProperties = checkPathProperties;
	            moduleOb.checkShapes = checkShapes;
	            moduleOb.completeLayers = completeLayers;
	            return moduleOb;
	          }
	
	          if (!_workerSelf.dataManager) {
	            _workerSelf.dataManager = dataFunctionManager();
	          }
	
	          if (!_workerSelf.assetLoader) {
	            _workerSelf.assetLoader = function () {
	              function formatResponse(xhr) {
	                // using typeof doubles the time of execution of this method,
	                // so if available, it's better to use the header to validate the type
	                var contentTypeHeader = xhr.getResponseHeader('content-type');
	
	                if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
	                  return xhr.response;
	                }
	
	                if (xhr.response && _typeof$5(xhr.response) === 'object') {
	                  return xhr.response;
	                }
	
	                if (xhr.response && typeof xhr.response === 'string') {
	                  return JSON.parse(xhr.response);
	                }
	
	                if (xhr.responseText) {
	                  return JSON.parse(xhr.responseText);
	                }
	
	                return null;
	              }
	
	              function loadAsset(path, fullPath, callback, errorCallback) {
	                var response;
	                var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
	
	                try {
	                  // This crashes on Android WebView prior to KitKat
	                  xhr.responseType = 'json';
	                } catch (err) {} // eslint-disable-line no-empty
	
	
	                xhr.onreadystatechange = function () {
	                  if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                      response = formatResponse(xhr);
	                      callback(response);
	                    } else {
	                      try {
	                        response = formatResponse(xhr);
	                        callback(response);
	                      } catch (err) {
	                        if (errorCallback) {
	                          errorCallback(err);
	                        }
	                      }
	                    }
	                  }
	                };
	
	                try {
	                  // Hack to workaround banner validation
	                  xhr.open(['G', 'E', 'T'].join(''), path, true);
	                } catch (error) {
	                  // Hack to workaround banner validation
	                  xhr.open(['G', 'E', 'T'].join(''), fullPath + '/' + path, true);
	                }
	
	                xhr.send();
	              }
	
	              return {
	                load: loadAsset
	              };
	            }();
	          }
	
	          if (e.data.type === 'loadAnimation') {
	            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
	              _workerSelf.dataManager.completeData(data);
	
	              _workerSelf.postMessage({
	                id: e.data.id,
	                payload: data,
	                status: 'success'
	              });
	            }, function () {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                status: 'error'
	              });
	            });
	          } else if (e.data.type === 'complete') {
	            var animation = e.data.animation;
	
	            _workerSelf.dataManager.completeData(animation);
	
	            _workerSelf.postMessage({
	              id: e.data.id,
	              payload: animation,
	              status: 'success'
	            });
	          } else if (e.data.type === 'loadData') {
	            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                payload: data,
	                status: 'success'
	              });
	            }, function () {
	              _workerSelf.postMessage({
	                id: e.data.id,
	                status: 'error'
	              });
	            });
	          }
	        });
	
	        workerInstance.onmessage = function (event) {
	          var data = event.data;
	          var id = data.id;
	          var process = processes[id];
	          processes[id] = null;
	
	          if (data.status === 'success') {
	            process.onComplete(data.payload);
	          } else if (process.onError) {
	            process.onError();
	          }
	        };
	      }
	    }
	
	    function createProcess(onComplete, onError) {
	      _counterId += 1;
	      var id = 'processId_' + _counterId;
	      processes[id] = {
	        onComplete: onComplete,
	        onError: onError
	      };
	      return id;
	    }
	
	    function loadAnimation(path, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'loadAnimation',
	        path: path,
	        fullPath: window.location.origin + window.location.pathname,
	        id: processId
	      });
	    }
	
	    function loadData(path, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'loadData',
	        path: path,
	        fullPath: window.location.origin + window.location.pathname,
	        id: processId
	      });
	    }
	
	    function completeAnimation(anim, onComplete, onError) {
	      setupWorker();
	      var processId = createProcess(onComplete, onError);
	      workerInstance.postMessage({
	        type: 'complete',
	        animation: anim,
	        id: processId
	      });
	    }
	
	    return {
	      loadAnimation: loadAnimation,
	      loadData: loadData,
	      completeAnimation: completeAnimation
	    };
	  }();
	
	  var ImagePreloader = function () {
	    var proxyImage = function () {
	      var canvas = createTag('canvas');
	      canvas.width = 1;
	      canvas.height = 1;
	      var ctx = canvas.getContext('2d');
	      ctx.fillStyle = 'rgba(0,0,0,0)';
	      ctx.fillRect(0, 0, 1, 1);
	      return canvas;
	    }();
	
	    function imageLoaded() {
	      this.loadedAssets += 1;
	
	      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
	        if (this.imagesLoadedCb) {
	          this.imagesLoadedCb(null);
	        }
	      }
	    }
	
	    function footageLoaded() {
	      this.loadedFootagesCount += 1;
	
	      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
	        if (this.imagesLoadedCb) {
	          this.imagesLoadedCb(null);
	        }
	      }
	    }
	
	    function getAssetsPath(assetData, assetsPath, originalPath) {
	      var path = '';
	
	      if (assetData.e) {
	        path = assetData.p;
	      } else if (assetsPath) {
	        var imagePath = assetData.p;
	
	        if (imagePath.indexOf('images/') !== -1) {
	          imagePath = imagePath.split('/')[1];
	        }
	
	        path = assetsPath + imagePath;
	      } else {
	        path = originalPath;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	      }
	
	      return path;
	    }
	
	    function testImageLoaded(img) {
	      var _count = 0;
	      var intervalId = setInterval(function () {
	        var box = img.getBBox();
	
	        if (box.width || _count > 500) {
	          this._imageLoaded();
	
	          clearInterval(intervalId);
	        }
	
	        _count += 1;
	      }.bind(this), 50);
	    }
	
	    function createImageData(assetData) {
	      var path = getAssetsPath(assetData, this.assetsPath, this.path);
	      var img = createNS('image');
	
	      if (isSafari) {
	        this.testImageLoaded(img);
	      } else {
	        img.addEventListener('load', this._imageLoaded, false);
	      }
	
	      img.addEventListener('error', function () {
	        ob.img = proxyImage;
	
	        this._imageLoaded();
	      }.bind(this), false);
	      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
	
	      if (this._elementHelper.append) {
	        this._elementHelper.append(img);
	      } else {
	        this._elementHelper.appendChild(img);
	      }
	
	      var ob = {
	        img: img,
	        assetData: assetData
	      };
	      return ob;
	    }
	
	    function createImgData(assetData) {
	      var path = getAssetsPath(assetData, this.assetsPath, this.path);
	      var img = createTag('img');
	      img.crossOrigin = 'anonymous';
	      img.addEventListener('load', this._imageLoaded, false);
	      img.addEventListener('error', function () {
	        ob.img = proxyImage;
	
	        this._imageLoaded();
	      }.bind(this), false);
	      img.src = path;
	      var ob = {
	        img: img,
	        assetData: assetData
	      };
	      return ob;
	    }
	
	    function createFootageData(data) {
	      var ob = {
	        assetData: data
	      };
	      var path = getAssetsPath(data, this.assetsPath, this.path);
	      dataManager.loadData(path, function (footageData) {
	        ob.img = footageData;
	
	        this._footageLoaded();
	      }.bind(this), function () {
	        ob.img = {};
	
	        this._footageLoaded();
	      }.bind(this));
	      return ob;
	    }
	
	    function loadAssets(assets, cb) {
	      this.imagesLoadedCb = cb;
	      var i;
	      var len = assets.length;
	
	      for (i = 0; i < len; i += 1) {
	        if (!assets[i].layers) {
	          if (!assets[i].t || assets[i].t === 'seq') {
	            this.totalImages += 1;
	            this.images.push(this._createImageData(assets[i]));
	          } else if (assets[i].t === 3) {
	            this.totalFootages += 1;
	            this.images.push(this.createFootageData(assets[i]));
	          }
	        }
	      }
	    }
	
	    function setPath(path) {
	      this.path = path || '';
	    }
	
	    function setAssetsPath(path) {
	      this.assetsPath = path || '';
	    }
	
	    function getAsset(assetData) {
	      var i = 0;
	      var len = this.images.length;
	
	      while (i < len) {
	        if (this.images[i].assetData === assetData) {
	          return this.images[i].img;
	        }
	
	        i += 1;
	      }
	
	      return null;
	    }
	
	    function destroy() {
	      this.imagesLoadedCb = null;
	      this.images.length = 0;
	    }
	
	    function loadedImages() {
	      return this.totalImages === this.loadedAssets;
	    }
	
	    function loadedFootages() {
	      return this.totalFootages === this.loadedFootagesCount;
	    }
	
	    function setCacheType(type, elementHelper) {
	      if (type === 'svg') {
	        this._elementHelper = elementHelper;
	        this._createImageData = this.createImageData.bind(this);
	      } else {
	        this._createImageData = this.createImgData.bind(this);
	      }
	    }
	
	    function ImagePreloaderFactory() {
	      this._imageLoaded = imageLoaded.bind(this);
	      this._footageLoaded = footageLoaded.bind(this);
	      this.testImageLoaded = testImageLoaded.bind(this);
	      this.createFootageData = createFootageData.bind(this);
	      this.assetsPath = '';
	      this.path = '';
	      this.totalImages = 0;
	      this.totalFootages = 0;
	      this.loadedAssets = 0;
	      this.loadedFootagesCount = 0;
	      this.imagesLoadedCb = null;
	      this.images = [];
	    }
	
	    ImagePreloaderFactory.prototype = {
	      loadAssets: loadAssets,
	      setAssetsPath: setAssetsPath,
	      setPath: setPath,
	      loadedImages: loadedImages,
	      loadedFootages: loadedFootages,
	      destroy: destroy,
	      getAsset: getAsset,
	      createImgData: createImgData,
	      createImageData: createImageData,
	      imageLoaded: imageLoaded,
	      footageLoaded: footageLoaded,
	      setCacheType: setCacheType
	    };
	    return ImagePreloaderFactory;
	  }();
	
	  function BaseEvent() {}
	
	  BaseEvent.prototype = {
	    triggerEvent: function triggerEvent(eventName, args) {
	      if (this._cbs[eventName]) {
	        var callbacks = this._cbs[eventName];
	
	        for (var i = 0; i < callbacks.length; i += 1) {
	          callbacks[i](args);
	        }
	      }
	    },
	    addEventListener: function addEventListener(eventName, callback) {
	      if (!this._cbs[eventName]) {
	        this._cbs[eventName] = [];
	      }
	
	      this._cbs[eventName].push(callback);
	
	      return function () {
	        this.removeEventListener(eventName, callback);
	      }.bind(this);
	    },
	    removeEventListener: function removeEventListener(eventName, callback) {
	      if (!callback) {
	        this._cbs[eventName] = null;
	      } else if (this._cbs[eventName]) {
	        var i = 0;
	        var len = this._cbs[eventName].length;
	
	        while (i < len) {
	          if (this._cbs[eventName][i] === callback) {
	            this._cbs[eventName].splice(i, 1);
	
	            i -= 1;
	            len -= 1;
	          }
	
	          i += 1;
	        }
	
	        if (!this._cbs[eventName].length) {
	          this._cbs[eventName] = null;
	        }
	      }
	    }
	  };
	
	  var markerParser = function () {
	    function parsePayloadLines(payload) {
	      var lines = payload.split('\r\n');
	      var keys = {};
	      var line;
	      var keysCount = 0;
	
	      for (var i = 0; i < lines.length; i += 1) {
	        line = lines[i].split(':');
	
	        if (line.length === 2) {
	          keys[line[0]] = line[1].trim();
	          keysCount += 1;
	        }
	      }
	
	      if (keysCount === 0) {
	        throw new Error();
	      }
	
	      return keys;
	    }
	
	    return function (_markers) {
	      var markers = [];
	
	      for (var i = 0; i < _markers.length; i += 1) {
	        var _marker = _markers[i];
	        var markerData = {
	          time: _marker.tm,
	          duration: _marker.dr
	        };
	
	        try {
	          markerData.payload = JSON.parse(_markers[i].cm);
	        } catch (_) {
	          try {
	            markerData.payload = parsePayloadLines(_markers[i].cm);
	          } catch (__) {
	            markerData.payload = {
	              name: _markers[i].cm
	            };
	          }
	        }
	
	        markers.push(markerData);
	      }
	
	      return markers;
	    };
	  }();
	
	  var ProjectInterface = function () {
	    function registerComposition(comp) {
	      this.compositions.push(comp);
	    }
	
	    return function () {
	      function _thisProjectFunction(name) {
	        var i = 0;
	        var len = this.compositions.length;
	
	        while (i < len) {
	          if (this.compositions[i].data && this.compositions[i].data.nm === name) {
	            if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
	              this.compositions[i].prepareFrame(this.currentFrame);
	            }
	
	            return this.compositions[i].compInterface;
	          }
	
	          i += 1;
	        }
	
	        return null;
	      }
	
	      _thisProjectFunction.compositions = [];
	      _thisProjectFunction.currentFrame = 0;
	      _thisProjectFunction.registerComposition = registerComposition;
	      return _thisProjectFunction;
	    };
	  }();
	
	  var renderers = {};
	
	  var registerRenderer = function registerRenderer(key, value) {
	    renderers[key] = value;
	  };
	
	  function getRenderer(key) {
	    return renderers[key];
	  }
	
	  function getRegisteredRenderer() {
	    // Returns canvas by default for compatibility
	    if (renderers.canvas) {
	      return 'canvas';
	    } // Returns any renderer that is registered
	
	
	    for (var key in renderers) {
	      if (renderers[key]) {
	        return key;
	      }
	    }
	
	    return '';
	  }
	
	  function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }
	
	  var AnimationItem = function AnimationItem() {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.firstFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.playCount = 0;
	    this.animationData = {};
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = createElementID();
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.isSubframeEnabled = getSubframeEnabled();
	    this.segments = [];
	    this._idle = true;
	    this._completedLoop = false;
	    this.projectInterface = ProjectInterface();
	    this.imagePreloader = new ImagePreloader();
	    this.audioController = audioControllerFactory();
	    this.markers = [];
	    this.configAnimation = this.configAnimation.bind(this);
	    this.onSetupError = this.onSetupError.bind(this);
	    this.onSegmentComplete = this.onSegmentComplete.bind(this);
	    this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
	    this.expressionsPlugin = getExpressionsPlugin();
	  };
	
	  extendPrototype([BaseEvent], AnimationItem);
	
	  AnimationItem.prototype.setParams = function (params) {
	    if (params.wrapper || params.container) {
	      this.wrapper = params.wrapper || params.container;
	    }
	
	    var animType = 'svg';
	
	    if (params.animType) {
	      animType = params.animType;
	    } else if (params.renderer) {
	      animType = params.renderer;
	    }
	
	    var RendererClass = getRenderer(animType);
	    this.renderer = new RendererClass(this, params.rendererSettings);
	    this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;
	
	    if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) {
	      this.loop = true;
	    } else if (params.loop === false) {
	      this.loop = false;
	    } else {
	      this.loop = parseInt(params.loop, 10);
	    }
	
	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name : '';
	    this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
	    this.assetsPath = params.assetsPath;
	    this.initialSegment = params.initialSegment;
	
	    if (params.audioFactory) {
	      this.audioController.setAudioFactory(params.audioFactory);
	    }
	
	    if (params.animationData) {
	      this.setupAnimation(params.animationData);
	    } else if (params.path) {
	      if (params.path.lastIndexOf('\\') !== -1) {
	        this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
	      } else {
	        this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
	      }
	
	      this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
	      this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
	      dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
	    }
	  };
	
	  AnimationItem.prototype.onSetupError = function () {
	    this.trigger('data_failed');
	  };
	
	  AnimationItem.prototype.setupAnimation = function (data) {
	    dataManager.completeAnimation(data, this.configAnimation);
	  };
	
	  AnimationItem.prototype.setData = function (wrapper, animationData) {
	    if (animationData) {
	      if (_typeof$4(animationData) !== 'object') {
	        animationData = JSON.parse(animationData);
	      }
	    }
	
	    var params = {
	      wrapper: wrapper,
	      animationData: animationData
	    };
	    var wrapperAttributes = wrapper.attributes;
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
	
	    if (loop === 'false') {
	      params.loop = false;
	    } else if (loop === 'true') {
	      params.loop = true;
	    } else if (loop !== '') {
	      params.loop = parseInt(loop, 10);
	    }
	
	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== 'false';
	    params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
	    ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
	
	    if (prerender === 'false') {
	      params.prerender = false;
	    }
	
	    if (!params.path) {
	      this.trigger('destroy');
	    } else {
	      this.setParams(params);
	    }
	  };
	
	  AnimationItem.prototype.includeLayers = function (data) {
	    if (data.op > this.animationData.op) {
	      this.animationData.op = data.op;
	      this.totalFrames = Math.floor(data.op - this.animationData.ip);
	    }
	
	    var layers = this.animationData.layers;
	    var i;
	    var len = layers.length;
	    var newLayers = data.layers;
	    var j;
	    var jLen = newLayers.length;
	
	    for (j = 0; j < jLen; j += 1) {
	      i = 0;
	
	      while (i < len) {
	        if (layers[i].id === newLayers[j].id) {
	          layers[i] = newLayers[j];
	          break;
	        }
	
	        i += 1;
	      }
	    }
	
	    if (data.chars || data.fonts) {
	      this.renderer.globalData.fontManager.addChars(data.chars);
	      this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }
	
	    if (data.assets) {
	      len = data.assets.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.animationData.assets.push(data.assets[i]);
	      }
	    }
	
	    this.animationData.__complete = false;
	    dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
	  };
	
	  AnimationItem.prototype.onSegmentComplete = function (data) {
	    this.animationData = data;
	    var expressionsPlugin = getExpressionsPlugin();
	
	    if (expressionsPlugin) {
	      expressionsPlugin.initExpressions(this);
	    }
	
	    this.loadNextSegment();
	  };
	
	  AnimationItem.prototype.loadNextSegment = function () {
	    var segments = this.animationData.segments;
	
	    if (!segments || segments.length === 0 || !this.autoloadSegments) {
	      this.trigger('data_ready');
	      this.timeCompleted = this.totalFrames;
	      return;
	    }
	
	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
	      this.trigger('data_failed');
	    }.bind(this));
	  };
	
	  AnimationItem.prototype.loadSegments = function () {
	    var segments = this.animationData.segments;
	
	    if (!segments) {
	      this.timeCompleted = this.totalFrames;
	    }
	
	    this.loadNextSegment();
	  };
	
	  AnimationItem.prototype.imagesLoaded = function () {
	    this.trigger('loaded_images');
	    this.checkLoaded();
	  };
	
	  AnimationItem.prototype.preloadImages = function () {
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
	  };
	
	  AnimationItem.prototype.configAnimation = function (animData) {
	    if (!this.renderer) {
	      return;
	    }
	
	    try {
	      this.animationData = animData;
	
	      if (this.initialSegment) {
	        this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
	        this.firstFrame = Math.round(this.initialSegment[0]);
	      } else {
	        this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	        this.firstFrame = Math.round(this.animationData.ip);
	      }
	
	      this.renderer.configAnimation(animData);
	
	      if (!animData.assets) {
	        animData.assets = [];
	      }
	
	      this.assets = this.animationData.assets;
	      this.frameRate = this.animationData.fr;
	      this.frameMult = this.animationData.fr / 1000;
	      this.renderer.searchExtraCompositions(animData.assets);
	      this.markers = markerParser(animData.markers || []);
	      this.trigger('config_ready');
	      this.preloadImages();
	      this.loadSegments();
	      this.updaFrameModifier();
	      this.waitForFontsLoaded();
	
	      if (this.isPaused) {
	        this.audioController.pause();
	      }
	    } catch (error) {
	      this.triggerConfigError(error);
	    }
	  };
	
	  AnimationItem.prototype.waitForFontsLoaded = function () {
	    if (!this.renderer) {
	      return;
	    }
	
	    if (this.renderer.globalData.fontManager.isLoaded) {
	      this.checkLoaded();
	    } else {
	      setTimeout(this.waitForFontsLoaded.bind(this), 20);
	    }
	  };
	
	  AnimationItem.prototype.checkLoaded = function () {
	    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
	      this.isLoaded = true;
	      var expressionsPlugin = getExpressionsPlugin();
	
	      if (expressionsPlugin) {
	        expressionsPlugin.initExpressions(this);
	      }
	
	      this.renderer.initItems();
	      setTimeout(function () {
	        this.trigger('DOMLoaded');
	      }.bind(this), 0);
	      this.gotoFrame();
	
	      if (this.autoplay) {
	        this.play();
	      }
	    }
	  };
	
	  AnimationItem.prototype.resize = function (width, height) {
	    // Adding this validation for backwards compatibility in case an event object was being passed down
	    var _width = typeof width === 'number' ? width : undefined;
	
	    var _height = typeof height === 'number' ? height : undefined;
	
	    this.renderer.updateContainerSize(_width, _height);
	  };
	
	  AnimationItem.prototype.setSubframe = function (flag) {
	    this.isSubframeEnabled = !!flag;
	  };
	
	  AnimationItem.prototype.gotoFrame = function () {
	    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
	
	    if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
	      this.currentFrame = this.timeCompleted;
	    }
	
	    this.trigger('enterFrame');
	    this.renderFrame();
	    this.trigger('drawnFrame');
	  };
	
	  AnimationItem.prototype.renderFrame = function () {
	    if (this.isLoaded === false || !this.renderer) {
	      return;
	    }
	
	    try {
	      if (this.expressionsPlugin) {
	        this.expressionsPlugin.resetFrame();
	      }
	
	      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	    } catch (error) {
	      this.triggerRenderFrameError(error);
	    }
	  };
	
	  AnimationItem.prototype.play = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    if (this.isPaused === true) {
	      this.isPaused = false;
	      this.trigger('_play');
	      this.audioController.resume();
	
	      if (this._idle) {
	        this._idle = false;
	        this.trigger('_active');
	      }
	    }
	  };
	
	  AnimationItem.prototype.pause = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    if (this.isPaused === false) {
	      this.isPaused = true;
	      this.trigger('_pause');
	      this._idle = true;
	      this.trigger('_idle');
	      this.audioController.pause();
	    }
	  };
	
	  AnimationItem.prototype.togglePause = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    if (this.isPaused === true) {
	      this.play();
	    } else {
	      this.pause();
	    }
	  };
	
	  AnimationItem.prototype.stop = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    this.pause();
	    this.playCount = 0;
	    this._completedLoop = false;
	    this.setCurrentRawFrameValue(0);
	  };
	
	  AnimationItem.prototype.getMarkerData = function (markerName) {
	    var marker;
	
	    for (var i = 0; i < this.markers.length; i += 1) {
	      marker = this.markers[i];
	
	      if (marker.payload && marker.payload.name === markerName) {
	        return marker;
	      }
	    }
	
	    return null;
	  };
	
	  AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    var numValue = Number(value);
	
	    if (isNaN(numValue)) {
	      var marker = this.getMarkerData(value);
	
	      if (marker) {
	        this.goToAndStop(marker.time, true);
	      }
	    } else if (isFrame) {
	      this.setCurrentRawFrameValue(value);
	    } else {
	      this.setCurrentRawFrameValue(value * this.frameModifier);
	    }
	
	    this.pause();
	  };
	
	  AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    var numValue = Number(value);
	
	    if (isNaN(numValue)) {
	      var marker = this.getMarkerData(value);
	
	      if (marker) {
	        if (!marker.duration) {
	          this.goToAndStop(marker.time, true);
	        } else {
	          this.playSegments([marker.time, marker.time + marker.duration], true);
	        }
	      }
	    } else {
	      this.goToAndStop(numValue, isFrame, name);
	    }
	
	    this.play();
	  };
	
	  AnimationItem.prototype.advanceTime = function (value) {
	    if (this.isPaused === true || this.isLoaded === false) {
	      return;
	    }
	
	    var nextValue = this.currentRawFrame + value * this.frameModifier;
	    var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
	    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
	
	    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
	      if (!this.loop || this.playCount === this.loop) {
	        if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
	          _isComplete = true;
	          nextValue = this.totalFrames - 1;
	        }
	      } else if (nextValue >= this.totalFrames) {
	        this.playCount += 1;
	
	        if (!this.checkSegments(nextValue % this.totalFrames)) {
	          this.setCurrentRawFrameValue(nextValue % this.totalFrames);
	          this._completedLoop = true;
	          this.trigger('loopComplete');
	        }
	      } else {
	        this.setCurrentRawFrameValue(nextValue);
	      }
	    } else if (nextValue < 0) {
	      if (!this.checkSegments(nextValue % this.totalFrames)) {
	        if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
	          // eslint-disable-line no-plusplus
	          this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
	
	          if (!this._completedLoop) {
	            this._completedLoop = true;
	          } else {
	            this.trigger('loopComplete');
	          }
	        } else {
	          _isComplete = true;
	          nextValue = 0;
	        }
	      }
	    } else {
	      this.setCurrentRawFrameValue(nextValue);
	    }
	
	    if (_isComplete) {
	      this.setCurrentRawFrameValue(nextValue);
	      this.pause();
	      this.trigger('complete');
	    }
	  };
	
	  AnimationItem.prototype.adjustSegment = function (arr, offset) {
	    this.playCount = 0;
	
	    if (arr[1] < arr[0]) {
	      if (this.frameModifier > 0) {
	        if (this.playSpeed < 0) {
	          this.setSpeed(-this.playSpeed);
	        } else {
	          this.setDirection(-1);
	        }
	      }
	
	      this.totalFrames = arr[0] - arr[1];
	      this.timeCompleted = this.totalFrames;
	      this.firstFrame = arr[1];
	      this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
	    } else if (arr[1] > arr[0]) {
	      if (this.frameModifier < 0) {
	        if (this.playSpeed < 0) {
	          this.setSpeed(-this.playSpeed);
	        } else {
	          this.setDirection(1);
	        }
	      }
	
	      this.totalFrames = arr[1] - arr[0];
	      this.timeCompleted = this.totalFrames;
	      this.firstFrame = arr[0];
	      this.setCurrentRawFrameValue(0.001 + offset);
	    }
	
	    this.trigger('segmentStart');
	  };
	
	  AnimationItem.prototype.setSegment = function (init, end) {
	    var pendingFrame = -1;
	
	    if (this.isPaused) {
	      if (this.currentRawFrame + this.firstFrame < init) {
	        pendingFrame = init;
	      } else if (this.currentRawFrame + this.firstFrame > end) {
	        pendingFrame = end - init;
	      }
	    }
	
	    this.firstFrame = init;
	    this.totalFrames = end - init;
	    this.timeCompleted = this.totalFrames;
	
	    if (pendingFrame !== -1) {
	      this.goToAndStop(pendingFrame, true);
	    }
	  };
	
	  AnimationItem.prototype.playSegments = function (arr, forceFlag) {
	    if (forceFlag) {
	      this.segments.length = 0;
	    }
	
	    if (_typeof$4(arr[0]) === 'object') {
	      var i;
	      var len = arr.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.segments.push(arr[i]);
	      }
	    } else {
	      this.segments.push(arr);
	    }
	
	    if (this.segments.length && forceFlag) {
	      this.adjustSegment(this.segments.shift(), 0);
	    }
	
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip, this.animationData.op]);
	
	    if (forceFlag) {
	      this.checkSegments(0);
	    }
	  };
	
	  AnimationItem.prototype.checkSegments = function (offset) {
	    if (this.segments.length) {
	      this.adjustSegment(this.segments.shift(), offset);
	      return true;
	    }
	
	    return false;
	  };
	
	  AnimationItem.prototype.destroy = function (name) {
	    if (name && this.name !== name || !this.renderer) {
	      return;
	    }
	
	    this.renderer.destroy();
	    this.imagePreloader.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = null;
	    this.onLoopComplete = null;
	    this.onComplete = null;
	    this.onSegmentStart = null;
	    this.onDestroy = null;
	    this.renderer = null;
	    this.expressionsPlugin = null;
	    this.imagePreloader = null;
	    this.projectInterface = null;
	  };
	
	  AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
	    this.currentRawFrame = value;
	    this.gotoFrame();
	  };
	
	  AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	  };
	
	  AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	  };
	
	  AnimationItem.prototype.setLoop = function (isLooping) {
	    this.loop = isLooping;
	  };
	
	  AnimationItem.prototype.setVolume = function (val, name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    this.audioController.setVolume(val);
	  };
	
	  AnimationItem.prototype.getVolume = function () {
	    return this.audioController.getVolume();
	  };
	
	  AnimationItem.prototype.mute = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    this.audioController.mute();
	  };
	
	  AnimationItem.prototype.unmute = function (name) {
	    if (name && this.name !== name) {
	      return;
	    }
	
	    this.audioController.unmute();
	  };
	
	  AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	    this.audioController.setRate(this.playSpeed * this.playDirection);
	  };
	
	  AnimationItem.prototype.getPath = function () {
	    return this.path;
	  };
	
	  AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';
	
	    if (assetData.e) {
	      path = assetData.p;
	    } else if (this.assetsPath) {
	      var imagePath = assetData.p;
	
	      if (imagePath.indexOf('images/') !== -1) {
	        imagePath = imagePath.split('/')[1];
	      }
	
	      path = this.assetsPath + imagePath;
	    } else {
	      path = this.path;
	      path += assetData.u ? assetData.u : '';
	      path += assetData.p;
	    }
	
	    return path;
	  };
	
	  AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0;
	    var len = this.assets.length;
	
	    while (i < len) {
	      if (id === this.assets[i].id) {
	        return this.assets[i];
	      }
	
	      i += 1;
	    }
	
	    return null;
	  };
	
	  AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	  };
	
	  AnimationItem.prototype.show = function () {
	    this.renderer.show();
	  };
	
	  AnimationItem.prototype.getDuration = function (isFrame) {
	    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
	  };
	
	  AnimationItem.prototype.updateDocumentData = function (path, documentData, index) {
	    try {
	      var element = this.renderer.getElementByPath(path);
	      element.updateDocumentData(documentData, index);
	    } catch (error) {// TODO: decide how to handle catch case
	    }
	  };
	
	  AnimationItem.prototype.trigger = function (name) {
	    if (this._cbs && this._cbs[name]) {
	      switch (name) {
	        case 'enterFrame':
	          this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
	          break;
	
	        case 'drawnFrame':
	          this.drawnFrameEvent.currentTime = this.currentFrame;
	          this.drawnFrameEvent.totalTime = this.totalFrames;
	          this.drawnFrameEvent.direction = this.frameModifier;
	          this.triggerEvent(name, this.drawnFrameEvent);
	          break;
	
	        case 'loopComplete':
	          this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
	          break;
	
	        case 'complete':
	          this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
	          break;
	
	        case 'segmentStart':
	          this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
	          break;
	
	        case 'destroy':
	          this.triggerEvent(name, new BMDestroyEvent(name, this));
	          break;
	
	        default:
	          this.triggerEvent(name);
	      }
	    }
	
	    if (name === 'enterFrame' && this.onEnterFrame) {
	      this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
	    }
	
	    if (name === 'loopComplete' && this.onLoopComplete) {
	      this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
	    }
	
	    if (name === 'complete' && this.onComplete) {
	      this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
	    }
	
	    if (name === 'segmentStart' && this.onSegmentStart) {
	      this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
	    }
	
	    if (name === 'destroy' && this.onDestroy) {
	      this.onDestroy.call(this, new BMDestroyEvent(name, this));
	    }
	  };
	
	  AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
	    var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);
	
	    if (this.onError) {
	      this.onError.call(this, error);
	    }
	  };
	
	  AnimationItem.prototype.triggerConfigError = function (nativeError) {
	    var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
	    this.triggerEvent('error', error);
	
	    if (this.onError) {
	      this.onError.call(this, error);
	    }
	  };
	
	  var animationManager = function () {
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var playingAnimationsNum = 0;
	    var _stopped = true;
	    var _isFrozen = false;
	
	    function removeElement(ev) {
	      var i = 0;
	      var animItem = ev.target;
	
	      while (i < len) {
	        if (registeredAnimations[i].animation === animItem) {
	          registeredAnimations.splice(i, 1);
	          i -= 1;
	          len -= 1;
	
	          if (!animItem.isPaused) {
	            subtractPlayingCount();
	          }
	        }
	
	        i += 1;
	      }
	    }
	
	    function registerAnimation(element, animationData) {
	      if (!element) {
	        return null;
	      }
	
	      var i = 0;
	
	      while (i < len) {
	        if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
	          return registeredAnimations[i].animation;
	        }
	
	        i += 1;
	      }
	
	      var animItem = new AnimationItem();
	      setupAnimation(animItem, element);
	      animItem.setData(element, animationData);
	      return animItem;
	    }
	
	    function getRegisteredAnimations() {
	      var i;
	      var lenAnims = registeredAnimations.length;
	      var animations = [];
	
	      for (i = 0; i < lenAnims; i += 1) {
	        animations.push(registeredAnimations[i].animation);
	      }
	
	      return animations;
	    }
	
	    function addPlayingCount() {
	      playingAnimationsNum += 1;
	      activate();
	    }
	
	    function subtractPlayingCount() {
	      playingAnimationsNum -= 1;
	    }
	
	    function setupAnimation(animItem, element) {
	      animItem.addEventListener('destroy', removeElement);
	      animItem.addEventListener('_active', addPlayingCount);
	      animItem.addEventListener('_idle', subtractPlayingCount);
	      registeredAnimations.push({
	        elem: element,
	        animation: animItem
	      });
	      len += 1;
	    }
	
	    function loadAnimation(params) {
	      var animItem = new AnimationItem();
	      setupAnimation(animItem, null);
	      animItem.setParams(params);
	      return animItem;
	    }
	
	    function setSpeed(val, animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setSpeed(val, animation);
	      }
	    }
	
	    function setDirection(val, animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setDirection(val, animation);
	      }
	    }
	
	    function play(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.play(animation);
	      }
	    }
	
	    function resume(nowTime) {
	      var elapsedTime = nowTime - initTime;
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.advanceTime(elapsedTime);
	      }
	
	      initTime = nowTime;
	
	      if (playingAnimationsNum && !_isFrozen) {
	        window.requestAnimationFrame(resume);
	      } else {
	        _stopped = true;
	      }
	    }
	
	    function first(nowTime) {
	      initTime = nowTime;
	      window.requestAnimationFrame(resume);
	    }
	
	    function pause(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.pause(animation);
	      }
	    }
	
	    function goToAndStop(value, isFrame, animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
	      }
	    }
	
	    function stop(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.stop(animation);
	      }
	    }
	
	    function togglePause(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.togglePause(animation);
	      }
	    }
	
	    function destroy(animation) {
	      var i;
	
	      for (i = len - 1; i >= 0; i -= 1) {
	        registeredAnimations[i].animation.destroy(animation);
	      }
	    }
	
	    function searchAnimations(animationData, standalone, renderer) {
	      var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
	      var i;
	      var lenAnims = animElements.length;
	
	      for (i = 0; i < lenAnims; i += 1) {
	        if (renderer) {
	          animElements[i].setAttribute('data-bm-type', renderer);
	        }
	
	        registerAnimation(animElements[i], animationData);
	      }
	
	      if (standalone && lenAnims === 0) {
	        if (!renderer) {
	          renderer = 'svg';
	        }
	
	        var body = document.getElementsByTagName('body')[0];
	        body.innerText = '';
	        var div = createTag('div');
	        div.style.width = '100%';
	        div.style.height = '100%';
	        div.setAttribute('data-bm-type', renderer);
	        body.appendChild(div);
	        registerAnimation(div, animationData);
	      }
	    }
	
	    function resize() {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.resize();
	      }
	    }
	
	    function activate() {
	      if (!_isFrozen && playingAnimationsNum) {
	        if (_stopped) {
	          window.requestAnimationFrame(first);
	          _stopped = false;
	        }
	      }
	    }
	
	    function freeze() {
	      _isFrozen = true;
	    }
	
	    function unfreeze() {
	      _isFrozen = false;
	      activate();
	    }
	
	    function setVolume(val, animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.setVolume(val, animation);
	      }
	    }
	
	    function mute(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.mute(animation);
	      }
	    }
	
	    function unmute(animation) {
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        registeredAnimations[i].animation.unmute(animation);
	      }
	    }
	
	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize; // moduleOb.start = start;
	
	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    moduleOb.freeze = freeze;
	    moduleOb.unfreeze = unfreeze;
	    moduleOb.setVolume = setVolume;
	    moduleOb.mute = mute;
	    moduleOb.unmute = unmute;
	    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
	    return moduleOb;
	  }();
	
	  /* eslint-disable */
	  var BezierFactory = function () {
	    /**
	       * BezierEasing - use bezier curve for transition easing function
	       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	       *
	       * Credits: is based on Firefox's nsSMILKeySpline.cpp
	       * Usage:
	       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	       * spline.get(x) => returns the easing value | x must be in [0, 1] range
	       *
	       */
	    var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};
	
	    function getBezierEasing(a, b, c, d, nm) {
	      var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
	
	      if (beziers[str]) {
	        return beziers[str];
	      }
	
	      var bezEasing = new BezierEasing([a, b, c, d]);
	      beziers[str] = bezEasing;
	      return bezEasing;
	    } // These values are established by empiricism with tests (tradeoff: performance VS precision)
	
	
	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	    var float32ArraySupported = typeof Float32Array === 'function';
	
	    function A(aA1, aA2) {
	      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
	    }
	
	    function B(aA1, aA2) {
	      return 3.0 * aA2 - 6.0 * aA1;
	    }
	
	    function C(aA1) {
	      return 3.0 * aA1;
	    } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	
	
	    function calcBezier(aT, aA1, aA2) {
	      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
	    } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	
	
	    function getSlope(aT, aA1, aA2) {
	      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }
	
	    function binarySubdivide(aX, aA, aB, mX1, mX2) {
	      var currentX,
	          currentT,
	          i = 0;
	
	      do {
	        currentT = aA + (aB - aA) / 2.0;
	        currentX = calcBezier(currentT, mX1, mX2) - aX;
	
	        if (currentX > 0.0) {
	          aB = currentT;
	        } else {
	          aA = currentT;
	        }
	      } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	
	      return currentT;
	    }
	
	    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
	      for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	        var currentSlope = getSlope(aGuessT, mX1, mX2);
	        if (currentSlope === 0.0) return aGuessT;
	        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	        aGuessT -= currentX / currentSlope;
	      }
	
	      return aGuessT;
	    }
	    /**
	       * points is an array of [ mX1, mY1, mX2, mY2 ]
	       */
	
	
	    function BezierEasing(points) {
	      this._p = points;
	      this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	      this._precomputed = false;
	      this.get = this.get.bind(this);
	    }
	
	    BezierEasing.prototype = {
	      get: function get(x) {
	        var mX1 = this._p[0],
	            mY1 = this._p[1],
	            mX2 = this._p[2],
	            mY2 = this._p[3];
	        if (!this._precomputed) this._precompute();
	        if (mX1 === mY1 && mX2 === mY2) return x; // linear
	        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	
	        if (x === 0) return 0;
	        if (x === 1) return 1;
	        return calcBezier(this._getTForX(x), mY1, mY2);
	      },
	      // Private part
	      _precompute: function _precompute() {
	        var mX1 = this._p[0],
	            mY1 = this._p[1],
	            mX2 = this._p[2],
	            mY2 = this._p[3];
	        this._precomputed = true;
	
	        if (mX1 !== mY1 || mX2 !== mY2) {
	          this._calcSampleValues();
	        }
	      },
	      _calcSampleValues: function _calcSampleValues() {
	        var mX1 = this._p[0],
	            mX2 = this._p[2];
	
	        for (var i = 0; i < kSplineTableSize; ++i) {
	          this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	        }
	      },
	
	      /**
	           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	           */
	      _getTForX: function _getTForX(aX) {
	        var mX1 = this._p[0],
	            mX2 = this._p[2],
	            mSampleValues = this._mSampleValues;
	        var intervalStart = 0.0;
	        var currentSample = 1;
	        var lastSample = kSplineTableSize - 1;
	
	        for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	          intervalStart += kSampleStepSize;
	        }
	
	        --currentSample; // Interpolate to provide an initial guess for t
	
	        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
	        var guessForT = intervalStart + dist * kSampleStepSize;
	        var initialSlope = getSlope(guessForT, mX1, mX2);
	
	        if (initialSlope >= NEWTON_MIN_SLOPE) {
	          return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	        }
	
	        if (initialSlope === 0.0) {
	          return guessForT;
	        }
	
	        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	      }
	    };
	    return ob;
	  }();
	
	  var pooling = function () {
	    function _double(arr) {
	      return arr.concat(createSizedArray(arr.length));
	    }
	
	    return {
	      "double": _double
	    };
	  }();
	
	  var poolFactory = function () {
	    return function (initialLength, _create, _release) {
	      var _length = 0;
	      var _maxLength = initialLength;
	      var pool = createSizedArray(_maxLength);
	      var ob = {
	        newElement: newElement,
	        release: release
	      };
	
	      function newElement() {
	        var element;
	
	        if (_length) {
	          _length -= 1;
	          element = pool[_length];
	        } else {
	          element = _create();
	        }
	
	        return element;
	      }
	
	      function release(element) {
	        if (_length === _maxLength) {
	          pool = pooling["double"](pool);
	          _maxLength *= 2;
	        }
	
	        if (_release) {
	          _release(element);
	        }
	
	        pool[_length] = element;
	        _length += 1;
	      }
	
	      return ob;
	    };
	  }();
	
	  var bezierLengthPool = function () {
	    function create() {
	      return {
	        addedLength: 0,
	        percents: createTypedArray('float32', getDefaultCurveSegments()),
	        lengths: createTypedArray('float32', getDefaultCurveSegments())
	      };
	    }
	
	    return poolFactory(8, create);
	  }();
	
	  var segmentsLengthPool = function () {
	    function create() {
	      return {
	        lengths: [],
	        totalLength: 0
	      };
	    }
	
	    function release(element) {
	      var i;
	      var len = element.lengths.length;
	
	      for (i = 0; i < len; i += 1) {
	        bezierLengthPool.release(element.lengths[i]);
	      }
	
	      element.lengths.length = 0;
	    }
	
	    return poolFactory(8, create, release);
	  }();
	
	  function bezFunction() {
	    var math = Math;
	
	    function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
	      var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
	      return det1 > -0.001 && det1 < 0.001;
	    }
	
	    function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
	      if (z1 === 0 && z2 === 0 && z3 === 0) {
	        return pointOnLine2D(x1, y1, x2, y2, x3, y3);
	      }
	
	      var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
	      var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
	      var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
	      var diffDist;
	
	      if (dist1 > dist2) {
	        if (dist1 > dist3) {
	          diffDist = dist1 - dist2 - dist3;
	        } else {
	          diffDist = dist3 - dist2 - dist1;
	        }
	      } else if (dist3 > dist2) {
	        diffDist = dist3 - dist2 - dist1;
	      } else {
	        diffDist = dist2 - dist1 - dist3;
	      }
	
	      return diffDist > -0.0001 && diffDist < 0.0001;
	    }
	
	    var getBezierLength = function () {
	      return function (pt1, pt2, pt3, pt4) {
	        var curveSegments = getDefaultCurveSegments();
	        var k;
	        var i;
	        var len;
	        var ptCoord;
	        var perc;
	        var addedLength = 0;
	        var ptDistance;
	        var point = [];
	        var lastPoint = [];
	        var lengthData = bezierLengthPool.newElement();
	        len = pt3.length;
	
	        for (k = 0; k < curveSegments; k += 1) {
	          perc = k / (curveSegments - 1);
	          ptDistance = 0;
	
	          for (i = 0; i < len; i += 1) {
	            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
	            point[i] = ptCoord;
	
	            if (lastPoint[i] !== null) {
	              ptDistance += bmPow(point[i] - lastPoint[i], 2);
	            }
	
	            lastPoint[i] = point[i];
	          }
	
	          if (ptDistance) {
	            ptDistance = bmSqrt(ptDistance);
	            addedLength += ptDistance;
	          }
	
	          lengthData.percents[k] = perc;
	          lengthData.lengths[k] = addedLength;
	        }
	
	        lengthData.addedLength = addedLength;
	        return lengthData;
	      };
	    }();
	
	    function getSegmentsLength(shapeData) {
	      var segmentsLength = segmentsLengthPool.newElement();
	      var closed = shapeData.c;
	      var pathV = shapeData.v;
	      var pathO = shapeData.o;
	      var pathI = shapeData.i;
	      var i;
	      var len = shapeData._length;
	      var lengths = segmentsLength.lengths;
	      var totalLength = 0;
	
	      for (i = 0; i < len - 1; i += 1) {
	        lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
	        totalLength += lengths[i].addedLength;
	      }
	
	      if (closed && len) {
	        lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
	        totalLength += lengths[i].addedLength;
	      }
	
	      segmentsLength.totalLength = totalLength;
	      return segmentsLength;
	    }
	
	    function BezierData(length) {
	      this.segmentLength = 0;
	      this.points = new Array(length);
	    }
	
	    function PointData(partial, point) {
	      this.partialLength = partial;
	      this.point = point;
	    }
	
	    var buildBezierData = function () {
	      var storedData = {};
	      return function (pt1, pt2, pt3, pt4) {
	        var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
	
	        if (!storedData[bezierName]) {
	          var curveSegments = getDefaultCurveSegments();
	          var k;
	          var i;
	          var len;
	          var ptCoord;
	          var perc;
	          var addedLength = 0;
	          var ptDistance;
	          var point;
	          var lastPoint = null;
	
	          if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
	            curveSegments = 2;
	          }
	
	          var bezierData = new BezierData(curveSegments);
	          len = pt3.length;
	
	          for (k = 0; k < curveSegments; k += 1) {
	            point = createSizedArray(len);
	            perc = k / (curveSegments - 1);
	            ptDistance = 0;
	
	            for (i = 0; i < len; i += 1) {
	              ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
	              point[i] = ptCoord;
	
	              if (lastPoint !== null) {
	                ptDistance += bmPow(point[i] - lastPoint[i], 2);
	              }
	            }
	
	            ptDistance = bmSqrt(ptDistance);
	            addedLength += ptDistance;
	            bezierData.points[k] = new PointData(ptDistance, point);
	            lastPoint = point;
	          }
	
	          bezierData.segmentLength = addedLength;
	          storedData[bezierName] = bezierData;
	        }
	
	        return storedData[bezierName];
	      };
	    }();
	
	    function getDistancePerc(perc, bezierData) {
	      var percents = bezierData.percents;
	      var lengths = bezierData.lengths;
	      var len = percents.length;
	      var initPos = bmFloor((len - 1) * perc);
	      var lengthPos = perc * bezierData.addedLength;
	      var lPerc = 0;
	
	      if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
	        return percents[initPos];
	      }
	
	      var dir = lengths[initPos] > lengthPos ? -1 : 1;
	      var flag = true;
	
	      while (flag) {
	        if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
	          lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
	          flag = false;
	        } else {
	          initPos += dir;
	        }
	
	        if (initPos < 0 || initPos >= len - 1) {
	          // FIX for TypedArrays that don't store floating point values with enough accuracy
	          if (initPos === len - 1) {
	            return percents[initPos];
	          }
	
	          flag = false;
	        }
	      }
	
	      return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
	    }
	
	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	      var t1 = getDistancePerc(percent, bezierData);
	      var u1 = 1 - t1;
	      var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
	      var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
	      return [ptX, ptY];
	    }
	
	    var bezierSegmentPoints = createTypedArray('float32', 8);
	
	    function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
	      if (startPerc < 0) {
	        startPerc = 0;
	      } else if (startPerc > 1) {
	        startPerc = 1;
	      }
	
	      var t0 = getDistancePerc(startPerc, bezierData);
	      endPerc = endPerc > 1 ? 1 : endPerc;
	      var t1 = getDistancePerc(endPerc, bezierData);
	      var i;
	      var len = pt1.length;
	      var u0 = 1 - t0;
	      var u1 = 1 - t1;
	      var u0u0u0 = u0 * u0 * u0;
	      var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
	
	      var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
	
	      var t0t0t0 = t0 * t0 * t0; //
	
	      var u0u0u1 = u0 * u0 * u1;
	      var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
	
	      var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
	
	      var t0t0t1 = t0 * t0 * t1; //
	
	      var u0u1u1 = u0 * u1 * u1;
	      var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
	
	      var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
	
	      var t0t1t1 = t0 * t1 * t1; //
	
	      var u1u1u1 = u1 * u1 * u1;
	      var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
	
	      var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
	
	      var t1t1t1 = t1 * t1 * t1;
	
	      for (i = 0; i < len; i += 1) {
	        bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	
	        bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	
	        bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	
	        bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
	      }
	
	      return bezierSegmentPoints;
	    }
	
	    return {
	      getSegmentsLength: getSegmentsLength,
	      getNewSegment: getNewSegment,
	      getPointInSegment: getPointInSegment,
	      buildBezierData: buildBezierData,
	      pointOnLine2D: pointOnLine2D,
	      pointOnLine3D: pointOnLine3D
	    };
	  }
	
	  var bez = bezFunction();
	
	  var initFrame = initialDefaultFrame;
	  var mathAbs = Math.abs;
	
	  function interpolateValue(frameNum, caching) {
	    var offsetTime = this.offsetTime;
	    var newValue;
	
	    if (this.propType === 'multidimensional') {
	      newValue = createTypedArray('float32', this.pv.length);
	    }
	
	    var iterationIndex = caching.lastIndex;
	    var i = iterationIndex;
	    var len = this.keyframes.length - 1;
	    var flag = true;
	    var keyData;
	    var nextKeyData;
	    var keyframeMetadata;
	
	    while (flag) {
	      keyData = this.keyframes[i];
	      nextKeyData = this.keyframes[i + 1];
	
	      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
	        if (keyData.h) {
	          keyData = nextKeyData;
	        }
	
	        iterationIndex = 0;
	        break;
	      }
	
	      if (nextKeyData.t - offsetTime > frameNum) {
	        iterationIndex = i;
	        break;
	      }
	
	      if (i < len - 1) {
	        i += 1;
	      } else {
	        iterationIndex = 0;
	        flag = false;
	      }
	    }
	
	    keyframeMetadata = this.keyframesMetadata[i] || {};
	    var k;
	    var kLen;
	    var perc;
	    var jLen;
	    var j;
	    var fnc;
	    var nextKeyTime = nextKeyData.t - offsetTime;
	    var keyTime = keyData.t - offsetTime;
	    var endValue;
	
	    if (keyData.to) {
	      if (!keyframeMetadata.bezierData) {
	        keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
	      }
	
	      var bezierData = keyframeMetadata.bezierData;
	
	      if (frameNum >= nextKeyTime || frameNum < keyTime) {
	        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
	        kLen = bezierData.points[ind].point.length;
	
	        for (k = 0; k < kLen; k += 1) {
	          newValue[k] = bezierData.points[ind].point[k];
	        } // caching._lastKeyframeIndex = -1;
	
	      } else {
	        if (keyframeMetadata.__fnct) {
	          fnc = keyframeMetadata.__fnct;
	        } else {
	          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
	          keyframeMetadata.__fnct = fnc;
	        }
	
	        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	        var distanceInLine = bezierData.segmentLength * perc;
	        var segmentPerc;
	        var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
	        j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
	        flag = true;
	        jLen = bezierData.points.length;
	
	        while (flag) {
	          addedLength += bezierData.points[j].partialLength;
	
	          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
	            kLen = bezierData.points[j].point.length;
	
	            for (k = 0; k < kLen; k += 1) {
	              newValue[k] = bezierData.points[j].point[k];
	            }
	
	            break;
	          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
	            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
	            kLen = bezierData.points[j].point.length;
	
	            for (k = 0; k < kLen; k += 1) {
	              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
	            }
	
	            break;
	          }
	
	          if (j < jLen - 1) {
	            j += 1;
	          } else {
	            flag = false;
	          }
	        }
	
	        caching._lastPoint = j;
	        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	        caching._lastKeyframeIndex = i;
	      }
	    } else {
	      var outX;
	      var outY;
	      var inX;
	      var inY;
	      var keyValue;
	      len = keyData.s.length;
	      endValue = nextKeyData.s || keyData.e;
	
	      if (this.sh && keyData.h !== 1) {
	        if (frameNum >= nextKeyTime) {
	          newValue[0] = endValue[0];
	          newValue[1] = endValue[1];
	          newValue[2] = endValue[2];
	        } else if (frameNum <= keyTime) {
	          newValue[0] = keyData.s[0];
	          newValue[1] = keyData.s[1];
	          newValue[2] = keyData.s[2];
	        } else {
	          var quatStart = createQuaternion(keyData.s);
	          var quatEnd = createQuaternion(endValue);
	          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
	          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
	        }
	      } else {
	        for (i = 0; i < len; i += 1) {
	          if (keyData.h !== 1) {
	            if (frameNum >= nextKeyTime) {
	              perc = 1;
	            } else if (frameNum < keyTime) {
	              perc = 0;
	            } else {
	              if (keyData.o.x.constructor === Array) {
	                if (!keyframeMetadata.__fnct) {
	                  keyframeMetadata.__fnct = [];
	                }
	
	                if (!keyframeMetadata.__fnct[i]) {
	                  outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
	                  outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
	                  inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
	                  inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
	                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                  keyframeMetadata.__fnct[i] = fnc;
	                } else {
	                  fnc = keyframeMetadata.__fnct[i];
	                }
	              } else if (!keyframeMetadata.__fnct) {
	                outX = keyData.o.x;
	                outY = keyData.o.y;
	                inX = keyData.i.x;
	                inY = keyData.i.y;
	                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
	                keyData.keyframeMetadata = fnc;
	              } else {
	                fnc = keyframeMetadata.__fnct;
	              }
	
	              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
	            }
	          }
	
	          endValue = nextKeyData.s || keyData.e;
	          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
	
	          if (this.propType === 'multidimensional') {
	            newValue[i] = keyValue;
	          } else {
	            newValue = keyValue;
	          }
	        }
	      }
	    }
	
	    caching.lastIndex = iterationIndex;
	    return newValue;
	  } // based on @Toji's https://github.com/toji/gl-matrix/
	
	
	  function slerp(a, b, t) {
	    var out = [];
	    var ax = a[0];
	    var ay = a[1];
	    var az = a[2];
	    var aw = a[3];
	    var bx = b[0];
	    var by = b[1];
	    var bz = b[2];
	    var bw = b[3];
	    var omega;
	    var cosom;
	    var sinom;
	    var scale0;
	    var scale1;
	    cosom = ax * bx + ay * by + az * bz + aw * bw;
	
	    if (cosom < 0.0) {
	      cosom = -cosom;
	      bx = -bx;
	      by = -by;
	      bz = -bz;
	      bw = -bw;
	    }
	
	    if (1.0 - cosom > 0.000001) {
	      omega = Math.acos(cosom);
	      sinom = Math.sin(omega);
	      scale0 = Math.sin((1.0 - t) * omega) / sinom;
	      scale1 = Math.sin(t * omega) / sinom;
	    } else {
	      scale0 = 1.0 - t;
	      scale1 = t;
	    }
	
	    out[0] = scale0 * ax + scale1 * bx;
	    out[1] = scale0 * ay + scale1 * by;
	    out[2] = scale0 * az + scale1 * bz;
	    out[3] = scale0 * aw + scale1 * bw;
	    return out;
	  }
	
	  function quaternionToEuler(out, quat) {
	    var qx = quat[0];
	    var qy = quat[1];
	    var qz = quat[2];
	    var qw = quat[3];
	    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
	    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
	    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
	    out[0] = heading / degToRads;
	    out[1] = attitude / degToRads;
	    out[2] = bank / degToRads;
	  }
	
	  function createQuaternion(values) {
	    var heading = values[0] * degToRads;
	    var attitude = values[1] * degToRads;
	    var bank = values[2] * degToRads;
	    var c1 = Math.cos(heading / 2);
	    var c2 = Math.cos(attitude / 2);
	    var c3 = Math.cos(bank / 2);
	    var s1 = Math.sin(heading / 2);
	    var s2 = Math.sin(attitude / 2);
	    var s3 = Math.sin(bank / 2);
	    var w = c1 * c2 * c3 - s1 * s2 * s3;
	    var x = s1 * s2 * c3 + c1 * c2 * s3;
	    var y = s1 * c2 * c3 + c1 * s2 * s3;
	    var z = c1 * s2 * c3 - s1 * c2 * s3;
	    return [x, y, z, w];
	  }
	
	  function getValueAtCurrentTime() {
	    var frameNum = this.comp.renderedFrame - this.offsetTime;
	    var initTime = this.keyframes[0].t - this.offsetTime;
	    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	
	    if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
	      if (this._caching.lastFrame >= frameNum) {
	        this._caching._lastKeyframeIndex = -1;
	        this._caching.lastIndex = 0;
	      }
	
	      var renderResult = this.interpolateValue(frameNum, this._caching);
	      this.pv = renderResult;
	    }
	
	    this._caching.lastFrame = frameNum;
	    return this.pv;
	  }
	
	  function setVValue(val) {
	    var multipliedValue;
	
	    if (this.propType === 'unidimensional') {
	      multipliedValue = val * this.mult;
	
	      if (mathAbs(this.v - multipliedValue) > 0.00001) {
	        this.v = multipliedValue;
	        this._mdf = true;
	      }
	    } else {
	      var i = 0;
	      var len = this.v.length;
	
	      while (i < len) {
	        multipliedValue = val[i] * this.mult;
	
	        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
	          this.v[i] = multipliedValue;
	          this._mdf = true;
	        }
	
	        i += 1;
	      }
	    }
	  }
	
	  function processEffectsSequence() {
	    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
	      return;
	    }
	
	    if (this.lock) {
	      this.setVValue(this.pv);
	      return;
	    }
	
	    this.lock = true;
	    this._mdf = this._isFirstFrame;
	    var i;
	    var len = this.effectsSequence.length;
	    var finalValue = this.kf ? this.pv : this.data.k;
	
	    for (i = 0; i < len; i += 1) {
	      finalValue = this.effectsSequence[i](finalValue);
	    }
	
	    this.setVValue(finalValue);
	    this._isFirstFrame = false;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	  }
	
	  function addEffect(effectFunction) {
	    this.effectsSequence.push(effectFunction);
	    this.container.addDynamicProperty(this);
	  }
	
	  function ValueProperty(elem, data, mult, container) {
	    this.propType = 'unidimensional';
	    this.mult = mult || 1;
	    this.data = data;
	    this.v = mult ? data.k * mult : data.k;
	    this.pv = data.k;
	    this._mdf = false;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.k = false;
	    this.kf = false;
	    this.vel = 0;
	    this.effectsSequence = [];
	    this._isFirstFrame = true;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.addEffect = addEffect;
	  }
	
	  function MultiDimensionalProperty(elem, data, mult, container) {
	    this.propType = 'multidimensional';
	    this.mult = mult || 1;
	    this.data = data;
	    this._mdf = false;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.k = false;
	    this.kf = false;
	    this.frameId = -1;
	    var i;
	    var len = data.k.length;
	    this.v = createTypedArray('float32', len);
	    this.pv = createTypedArray('float32', len);
	    this.vel = createTypedArray('float32', len);
	
	    for (i = 0; i < len; i += 1) {
	      this.v[i] = data.k[i] * this.mult;
	      this.pv[i] = data.k[i];
	    }
	
	    this._isFirstFrame = true;
	    this.effectsSequence = [];
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.addEffect = addEffect;
	  }
	
	  function KeyframedValueProperty(elem, data, mult, container) {
	    this.propType = 'unidimensional';
	    this.keyframes = data.k;
	    this.keyframesMetadata = [];
	    this.offsetTime = elem.data.st;
	    this.frameId = -1;
	    this._caching = {
	      lastFrame: initFrame,
	      lastIndex: 0,
	      value: 0,
	      _lastKeyframeIndex: -1
	    };
	    this.k = true;
	    this.kf = true;
	    this.data = data;
	    this.mult = mult || 1;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.v = initFrame;
	    this.pv = initFrame;
	    this._isFirstFrame = true;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.interpolateValue = interpolateValue;
	    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	    this.addEffect = addEffect;
	  }
	
	  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
	    this.propType = 'multidimensional';
	    var i;
	    var len = data.k.length;
	    var s;
	    var e;
	    var to;
	    var ti;
	
	    for (i = 0; i < len - 1; i += 1) {
	      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
	        s = data.k[i].s;
	        e = data.k[i + 1].s;
	        to = data.k[i].to;
	        ti = data.k[i].ti;
	
	        if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
	          data.k[i].to = null;
	          data.k[i].ti = null;
	        }
	
	        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
	          if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
	            data.k[i].to = null;
	            data.k[i].ti = null;
	          }
	        }
	      }
	    }
	
	    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
	    this.data = data;
	    this.keyframes = data.k;
	    this.keyframesMetadata = [];
	    this.offsetTime = elem.data.st;
	    this.k = true;
	    this.kf = true;
	    this._isFirstFrame = true;
	    this.mult = mult || 1;
	    this.elem = elem;
	    this.container = container;
	    this.comp = elem.comp;
	    this.getValue = processEffectsSequence;
	    this.setVValue = setVValue;
	    this.interpolateValue = interpolateValue;
	    this.frameId = -1;
	    var arrLen = data.k[0].s.length;
	    this.v = createTypedArray('float32', arrLen);
	    this.pv = createTypedArray('float32', arrLen);
	
	    for (i = 0; i < arrLen; i += 1) {
	      this.v[i] = initFrame;
	      this.pv[i] = initFrame;
	    }
	
	    this._caching = {
	      lastFrame: initFrame,
	      lastIndex: 0,
	      value: createTypedArray('float32', arrLen)
	    };
	    this.addEffect = addEffect;
	  }
	
	  var PropertyFactory = function () {
	    function getProp(elem, data, type, mult, container) {
	      if (data.sid) {
	        data = elem.globalData.slotManager.getProp(data);
	      }
	
	      var p;
	
	      if (!data.k.length) {
	        p = new ValueProperty(elem, data, mult, container);
	      } else if (typeof data.k[0] === 'number') {
	        p = new MultiDimensionalProperty(elem, data, mult, container);
	      } else {
	        switch (type) {
	          case 0:
	            p = new KeyframedValueProperty(elem, data, mult, container);
	            break;
	
	          case 1:
	            p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
	            break;
	
	          default:
	            break;
	        }
	      }
	
	      if (p.effectsSequence.length) {
	        container.addDynamicProperty(p);
	      }
	
	      return p;
	    }
	
	    var ob = {
	      getProp: getProp
	    };
	    return ob;
	  }();
	
	  function DynamicPropertyContainer() {}
	
	  DynamicPropertyContainer.prototype = {
	    addDynamicProperty: function addDynamicProperty(prop) {
	      if (this.dynamicProperties.indexOf(prop) === -1) {
	        this.dynamicProperties.push(prop);
	        this.container.addDynamicProperty(this);
	        this._isAnimated = true;
	      }
	    },
	    iterateDynamicProperties: function iterateDynamicProperties() {
	      this._mdf = false;
	      var i;
	      var len = this.dynamicProperties.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.dynamicProperties[i].getValue();
	
	        if (this.dynamicProperties[i]._mdf) {
	          this._mdf = true;
	        }
	      }
	    },
	    initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
	      this.container = container;
	      this.dynamicProperties = [];
	      this._mdf = false;
	      this._isAnimated = false;
	    }
	  };
	
	  var pointPool = function () {
	    function create() {
	      return createTypedArray('float32', 2);
	    }
	
	    return poolFactory(8, create);
	  }();
	
	  function ShapePath() {
	    this.c = false;
	    this._length = 0;
	    this._maxLength = 8;
	    this.v = createSizedArray(this._maxLength);
	    this.o = createSizedArray(this._maxLength);
	    this.i = createSizedArray(this._maxLength);
	  }
	
	  ShapePath.prototype.setPathData = function (closed, len) {
	    this.c = closed;
	    this.setLength(len);
	    var i = 0;
	
	    while (i < len) {
	      this.v[i] = pointPool.newElement();
	      this.o[i] = pointPool.newElement();
	      this.i[i] = pointPool.newElement();
	      i += 1;
	    }
	  };
	
	  ShapePath.prototype.setLength = function (len) {
	    while (this._maxLength < len) {
	      this.doubleArrayLength();
	    }
	
	    this._length = len;
	  };
	
	  ShapePath.prototype.doubleArrayLength = function () {
	    this.v = this.v.concat(createSizedArray(this._maxLength));
	    this.i = this.i.concat(createSizedArray(this._maxLength));
	    this.o = this.o.concat(createSizedArray(this._maxLength));
	    this._maxLength *= 2;
	  };
	
	  ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
	    var arr;
	    this._length = Math.max(this._length, pos + 1);
	
	    if (this._length >= this._maxLength) {
	      this.doubleArrayLength();
	    }
	
	    switch (type) {
	      case 'v':
	        arr = this.v;
	        break;
	
	      case 'i':
	        arr = this.i;
	        break;
	
	      case 'o':
	        arr = this.o;
	        break;
	
	      default:
	        arr = [];
	        break;
	    }
	
	    if (!arr[pos] || arr[pos] && !replace) {
	      arr[pos] = pointPool.newElement();
	    }
	
	    arr[pos][0] = x;
	    arr[pos][1] = y;
	  };
	
	  ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
	    this.setXYAt(vX, vY, 'v', pos, replace);
	    this.setXYAt(oX, oY, 'o', pos, replace);
	    this.setXYAt(iX, iY, 'i', pos, replace);
	  };
	
	  ShapePath.prototype.reverse = function () {
	    var newPath = new ShapePath();
	    newPath.setPathData(this.c, this._length);
	    var vertices = this.v;
	    var outPoints = this.o;
	    var inPoints = this.i;
	    var init = 0;
	
	    if (this.c) {
	      newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	      init = 1;
	    }
	
	    var cnt = this._length - 1;
	    var len = this._length;
	    var i;
	
	    for (i = init; i < len; i += 1) {
	      newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	      cnt -= 1;
	    }
	
	    return newPath;
	  };
	
	  ShapePath.prototype.length = function () {
	    return this._length;
	  };
	
	  var shapePool = function () {
	    function create() {
	      return new ShapePath();
	    }
	
	    function release(shapePath) {
	      var len = shapePath._length;
	      var i;
	
	      for (i = 0; i < len; i += 1) {
	        pointPool.release(shapePath.v[i]);
	        pointPool.release(shapePath.i[i]);
	        pointPool.release(shapePath.o[i]);
	        shapePath.v[i] = null;
	        shapePath.i[i] = null;
	        shapePath.o[i] = null;
	      }
	
	      shapePath._length = 0;
	      shapePath.c = false;
	    }
	
	    function clone(shape) {
	      var cloned = factory.newElement();
	      var i;
	      var len = shape._length === undefined ? shape.v.length : shape._length;
	      cloned.setLength(len);
	      cloned.c = shape.c;
	
	      for (i = 0; i < len; i += 1) {
	        cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
	      }
	
	      return cloned;
	    }
	
	    var factory = poolFactory(4, create, release);
	    factory.clone = clone;
	    return factory;
	  }();
	
	  function ShapeCollection() {
	    this._length = 0;
	    this._maxLength = 4;
	    this.shapes = createSizedArray(this._maxLength);
	  }
	
	  ShapeCollection.prototype.addShape = function (shapeData) {
	    if (this._length === this._maxLength) {
	      this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
	      this._maxLength *= 2;
	    }
	
	    this.shapes[this._length] = shapeData;
	    this._length += 1;
	  };
	
	  ShapeCollection.prototype.releaseShapes = function () {
	    var i;
	
	    for (i = 0; i < this._length; i += 1) {
	      shapePool.release(this.shapes[i]);
	    }
	
	    this._length = 0;
	  };
	
	  var shapeCollectionPool = function () {
	    var ob = {
	      newShapeCollection: newShapeCollection,
	      release: release
	    };
	    var _length = 0;
	    var _maxLength = 4;
	    var pool = createSizedArray(_maxLength);
	
	    function newShapeCollection() {
	      var shapeCollection;
	
	      if (_length) {
	        _length -= 1;
	        shapeCollection = pool[_length];
	      } else {
	        shapeCollection = new ShapeCollection();
	      }
	
	      return shapeCollection;
	    }
	
	    function release(shapeCollection) {
	      var i;
	      var len = shapeCollection._length;
	
	      for (i = 0; i < len; i += 1) {
	        shapePool.release(shapeCollection.shapes[i]);
	      }
	
	      shapeCollection._length = 0;
	
	      if (_length === _maxLength) {
	        pool = pooling["double"](pool);
	        _maxLength *= 2;
	      }
	
	      pool[_length] = shapeCollection;
	      _length += 1;
	    }
	
	    return ob;
	  }();
	
	  var ShapePropertyFactory = function () {
	    var initFrame = -999999;
	
	    function interpolateShape(frameNum, previousValue, caching) {
	      var iterationIndex = caching.lastIndex;
	      var keyPropS;
	      var keyPropE;
	      var isHold;
	      var j;
	      var k;
	      var jLen;
	      var kLen;
	      var perc;
	      var vertexValue;
	      var kf = this.keyframes;
	
	      if (frameNum < kf[0].t - this.offsetTime) {
	        keyPropS = kf[0].s[0];
	        isHold = true;
	        iterationIndex = 0;
	      } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
	        keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
	        /* if(kf[kf.length - 1].s){
	                  keyPropS = kf[kf.length - 1].s[0];
	              }else{
	                  keyPropS = kf[kf.length - 2].e[0];
	              } */
	
	        isHold = true;
	      } else {
	        var i = iterationIndex;
	        var len = kf.length - 1;
	        var flag = true;
	        var keyData;
	        var nextKeyData;
	        var keyframeMetadata;
	
	        while (flag) {
	          keyData = kf[i];
	          nextKeyData = kf[i + 1];
	
	          if (nextKeyData.t - this.offsetTime > frameNum) {
	            break;
	          }
	
	          if (i < len - 1) {
	            i += 1;
	          } else {
	            flag = false;
	          }
	        }
	
	        keyframeMetadata = this.keyframesMetadata[i] || {};
	        isHold = keyData.h === 1;
	        iterationIndex = i;
	
	        if (!isHold) {
	          if (frameNum >= nextKeyData.t - this.offsetTime) {
	            perc = 1;
	          } else if (frameNum < keyData.t - this.offsetTime) {
	            perc = 0;
	          } else {
	            var fnc;
	
	            if (keyframeMetadata.__fnct) {
	              fnc = keyframeMetadata.__fnct;
	            } else {
	              fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
	              keyframeMetadata.__fnct = fnc;
	            }
	
	            perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
	          }
	
	          keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
	        }
	
	        keyPropS = keyData.s[0];
	      }
	
	      jLen = previousValue._length;
	      kLen = keyPropS.i[0].length;
	      caching.lastIndex = iterationIndex;
	
	      for (j = 0; j < jLen; j += 1) {
	        for (k = 0; k < kLen; k += 1) {
	          vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
	          previousValue.i[j][k] = vertexValue;
	          vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
	          previousValue.o[j][k] = vertexValue;
	          vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
	          previousValue.v[j][k] = vertexValue;
	        }
	      }
	    }
	
	    function interpolateShapeCurrentTime() {
	      var frameNum = this.comp.renderedFrame - this.offsetTime;
	      var initTime = this.keyframes[0].t - this.offsetTime;
	      var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	      var lastFrame = this._caching.lastFrame;
	
	      if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
	        /// /
	        this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
	        this.interpolateShape(frameNum, this.pv, this._caching); /// /
	      }
	
	      this._caching.lastFrame = frameNum;
	      return this.pv;
	    }
	
	    function resetShape() {
	      this.paths = this.localShapeCollection;
	    }
	
	    function shapesEqual(shape1, shape2) {
	      if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
	        return false;
	      }
	
	      var i;
	      var len = shape1._length;
	
	      for (i = 0; i < len; i += 1) {
	        if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    function setVValue(newPath) {
	      if (!shapesEqual(this.v, newPath)) {
	        this.v = shapePool.clone(newPath);
	        this.localShapeCollection.releaseShapes();
	        this.localShapeCollection.addShape(this.v);
	        this._mdf = true;
	        this.paths = this.localShapeCollection;
	      }
	    }
	
	    function processEffectsSequence() {
	      if (this.elem.globalData.frameId === this.frameId) {
	        return;
	      }
	
	      if (!this.effectsSequence.length) {
	        this._mdf = false;
	        return;
	      }
	
	      if (this.lock) {
	        this.setVValue(this.pv);
	        return;
	      }
	
	      this.lock = true;
	      this._mdf = false;
	      var finalValue;
	
	      if (this.kf) {
	        finalValue = this.pv;
	      } else if (this.data.ks) {
	        finalValue = this.data.ks.k;
	      } else {
	        finalValue = this.data.pt.k;
	      }
	
	      var i;
	      var len = this.effectsSequence.length;
	
	      for (i = 0; i < len; i += 1) {
	        finalValue = this.effectsSequence[i](finalValue);
	      }
	
	      this.setVValue(finalValue);
	      this.lock = false;
	      this.frameId = this.elem.globalData.frameId;
	    }
	
	    function ShapeProperty(elem, data, type) {
	      this.propType = 'shape';
	      this.comp = elem.comp;
	      this.container = elem;
	      this.elem = elem;
	      this.data = data;
	      this.k = false;
	      this.kf = false;
	      this._mdf = false;
	      var pathData = type === 3 ? data.pt.k : data.ks.k;
	      this.v = shapePool.clone(pathData);
	      this.pv = shapePool.clone(this.v);
	      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	      this.paths = this.localShapeCollection;
	      this.paths.addShape(this.v);
	      this.reset = resetShape;
	      this.effectsSequence = [];
	    }
	
	    function addEffect(effectFunction) {
	      this.effectsSequence.push(effectFunction);
	      this.container.addDynamicProperty(this);
	    }
	
	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = processEffectsSequence;
	    ShapeProperty.prototype.setVValue = setVValue;
	    ShapeProperty.prototype.addEffect = addEffect;
	
	    function KeyframedShapeProperty(elem, data, type) {
	      this.propType = 'shape';
	      this.comp = elem.comp;
	      this.elem = elem;
	      this.container = elem;
	      this.offsetTime = elem.data.st;
	      this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	      this.keyframesMetadata = [];
	      this.k = true;
	      this.kf = true;
	      var len = this.keyframes[0].s[0].i.length;
	      this.v = shapePool.newElement();
	      this.v.setPathData(this.keyframes[0].s[0].c, len);
	      this.pv = shapePool.clone(this.v);
	      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	      this.paths = this.localShapeCollection;
	      this.paths.addShape(this.v);
	      this.lastFrame = initFrame;
	      this.reset = resetShape;
	      this._caching = {
	        lastFrame: initFrame,
	        lastIndex: 0
	      };
	      this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
	    }
	
	    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	    KeyframedShapeProperty.prototype.setVValue = setVValue;
	    KeyframedShapeProperty.prototype.addEffect = addEffect;
	
	    var EllShapeProperty = function () {
	      var cPoint = roundCorner;
	
	      function EllShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.setPathData(true, 4);
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.localShapeCollection.addShape(this.v);
	        this.d = data.d;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.frameId = -1;
	        this.initDynamicPropertyContainer(elem);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
	
	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertEllToPath();
	        }
	      }
	
	      EllShapePropertyFactory.prototype = {
	        reset: resetShape,
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }
	
	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();
	
	          if (this._mdf) {
	            this.convertEllToPath();
	          }
	        },
	        convertEllToPath: function convertEllToPath() {
	          var p0 = this.p.v[0];
	          var p1 = this.p.v[1];
	          var s0 = this.s.v[0] / 2;
	          var s1 = this.s.v[1] / 2;
	
	          var _cw = this.d !== 3;
	
	          var _v = this.v;
	          _v.v[0][0] = p0;
	          _v.v[0][1] = p1 - s1;
	          _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.v[1][1] = p1;
	          _v.v[2][0] = p0;
	          _v.v[2][1] = p1 + s1;
	          _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.v[3][1] = p1;
	          _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	          _v.i[0][1] = p1 - s1;
	          _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.i[1][1] = p1 - s1 * cPoint;
	          _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	          _v.i[2][1] = p1 + s1;
	          _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.i[3][1] = p1 + s1 * cPoint;
	          _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
	          _v.o[0][1] = p1 - s1;
	          _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
	          _v.o[1][1] = p1 + s1 * cPoint;
	          _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
	          _v.o[2][1] = p1 + s1;
	          _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
	          _v.o[3][1] = p1 - s1 * cPoint;
	        }
	      };
	      extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);
	      return EllShapePropertyFactory;
	    }();
	
	    var StarShapeProperty = function () {
	      function StarShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.setPathData(true, 0);
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.data = data;
	        this.frameId = -1;
	        this.d = data.d;
	        this.initDynamicPropertyContainer(elem);
	
	        if (data.sy === 1) {
	          this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
	          this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
	          this.convertToPath = this.convertStarToPath;
	        } else {
	          this.convertToPath = this.convertPolygonToPath;
	        }
	
	        this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
	        this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
	        this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.localShapeCollection.addShape(this.v);
	        this.paths = this.localShapeCollection;
	
	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertToPath();
	        }
	      }
	
	      StarShapePropertyFactory.prototype = {
	        reset: resetShape,
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }
	
	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();
	
	          if (this._mdf) {
	            this.convertToPath();
	          }
	        },
	        convertStarToPath: function convertStarToPath() {
	          var numPts = Math.floor(this.pt.v) * 2;
	          var angle = Math.PI * 2 / numPts;
	          /* this.v.v.length = numPts;
	                  this.v.i.length = numPts;
	                  this.v.o.length = numPts; */
	
	          var longFlag = true;
	          var longRad = this.or.v;
	          var shortRad = this.ir.v;
	          var longRound = this.os.v;
	          var shortRound = this.is.v;
	          var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
	          var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
	          var i;
	          var rad;
	          var roundness;
	          var perimSegment;
	          var currentAng = -Math.PI / 2;
	          currentAng += this.r.v;
	          var dir = this.data.d === 3 ? -1 : 1;
	          this.v._length = 0;
	
	          for (i = 0; i < numPts; i += 1) {
	            rad = longFlag ? longRad : shortRad;
	            roundness = longFlag ? longRound : shortRound;
	            perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	            var x = rad * Math.cos(currentAng);
	            var y = rad * Math.sin(currentAng);
	            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
	            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
	            x += +this.p.v[0];
	            y += +this.p.v[1];
	            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
	            /* this.v.v[i] = [x,y];
	                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                      this.v._length = numPts; */
	
	            longFlag = !longFlag;
	            currentAng += angle * dir;
	          }
	        },
	        convertPolygonToPath: function convertPolygonToPath() {
	          var numPts = Math.floor(this.pt.v);
	          var angle = Math.PI * 2 / numPts;
	          var rad = this.or.v;
	          var roundness = this.os.v;
	          var perimSegment = 2 * Math.PI * rad / (numPts * 4);
	          var i;
	          var currentAng = -Math.PI * 0.5;
	          var dir = this.data.d === 3 ? -1 : 1;
	          currentAng += this.r.v;
	          this.v._length = 0;
	
	          for (i = 0; i < numPts; i += 1) {
	            var x = rad * Math.cos(currentAng);
	            var y = rad * Math.sin(currentAng);
	            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
	            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
	            x += +this.p.v[0];
	            y += +this.p.v[1];
	            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
	            currentAng += angle * dir;
	          }
	
	          this.paths.length = 0;
	          this.paths[0] = this.v;
	        }
	      };
	      extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);
	      return StarShapePropertyFactory;
	    }();
	
	    var RectShapeProperty = function () {
	      function RectShapePropertyFactory(elem, data) {
	        this.v = shapePool.newElement();
	        this.v.c = true;
	        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
	        this.localShapeCollection.addShape(this.v);
	        this.paths = this.localShapeCollection;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.frameId = -1;
	        this.d = data.d;
	        this.initDynamicPropertyContainer(elem);
	        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
	        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
	        this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
	
	        if (this.dynamicProperties.length) {
	          this.k = true;
	        } else {
	          this.k = false;
	          this.convertRectToPath();
	        }
	      }
	
	      RectShapePropertyFactory.prototype = {
	        convertRectToPath: function convertRectToPath() {
	          var p0 = this.p.v[0];
	          var p1 = this.p.v[1];
	          var v0 = this.s.v[0] / 2;
	          var v1 = this.s.v[1] / 2;
	          var round = bmMin(v0, v1, this.r.v);
	          var cPoint = round * (1 - roundCorner);
	          this.v._length = 0;
	
	          if (this.d === 2 || this.d === 1) {
	            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
	            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
	
	            if (round !== 0) {
	              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
	              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
	              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
	            } else {
	              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
	              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
	            }
	          } else {
	            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
	
	            if (round !== 0) {
	              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
	              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
	              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
	              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
	              this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
	            } else {
	              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
	              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
	              this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
	            }
	          }
	        },
	        getValue: function getValue() {
	          if (this.elem.globalData.frameId === this.frameId) {
	            return;
	          }
	
	          this.frameId = this.elem.globalData.frameId;
	          this.iterateDynamicProperties();
	
	          if (this._mdf) {
	            this.convertRectToPath();
	          }
	        },
	        reset: resetShape
	      };
	      extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);
	      return RectShapePropertyFactory;
	    }();
	
	    function getShapeProp(elem, data, type) {
	      var prop;
	
	      if (type === 3 || type === 4) {
	        var dataProp = type === 3 ? data.pt : data.ks;
	        var keys = dataProp.k;
	
	        if (keys.length) {
	          prop = new KeyframedShapeProperty(elem, data, type);
	        } else {
	          prop = new ShapeProperty(elem, data, type);
	        }
	      } else if (type === 5) {
	        prop = new RectShapeProperty(elem, data);
	      } else if (type === 6) {
	        prop = new EllShapeProperty(elem, data);
	      } else if (type === 7) {
	        prop = new StarShapeProperty(elem, data);
	      }
	
	      if (prop.k) {
	        elem.addDynamicProperty(prop);
	      }
	
	      return prop;
	    }
	
	    function getConstructorFunction() {
	      return ShapeProperty;
	    }
	
	    function getKeyframedConstructorFunction() {
	      return KeyframedShapeProperty;
	    }
	
	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	  }();
	
	  /*!
	   Transformation Matrix v2.0
	   (c) Epistemex 2014-2015
	   www.epistemex.com
	   By Ken Fyrstenberg
	   Contributions by leeoniya.
	   License: MIT, header required.
	   */
	
	  /**
	   * 2D transformation matrix object initialized with identity matrix.
	   *
	   * The matrix can synchronize a canvas context by supplying the context
	   * as an argument, or later apply current absolute transform to an
	   * existing context.
	   *
	   * All values are handled as floating point values.
	   *
	   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	   * @prop {number} a - scale x
	   * @prop {number} b - shear y
	   * @prop {number} c - shear x
	   * @prop {number} d - scale y
	   * @prop {number} e - translate x
	   * @prop {number} f - translate y
	   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	   * @constructor
	   */
	
	  var Matrix = function () {
	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;
	
	    function reset() {
	      this.props[0] = 1;
	      this.props[1] = 0;
	      this.props[2] = 0;
	      this.props[3] = 0;
	      this.props[4] = 0;
	      this.props[5] = 1;
	      this.props[6] = 0;
	      this.props[7] = 0;
	      this.props[8] = 0;
	      this.props[9] = 0;
	      this.props[10] = 1;
	      this.props[11] = 0;
	      this.props[12] = 0;
	      this.props[13] = 0;
	      this.props[14] = 0;
	      this.props[15] = 1;
	      return this;
	    }
	
	    function rotate(angle) {
	      if (angle === 0) {
	        return this;
	      }
	
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
	    }
	
	    function rotateX(angle) {
	      if (angle === 0) {
	        return this;
	      }
	
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateY(angle) {
	      if (angle === 0) {
	        return this;
	      }
	
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
	    }
	
	    function rotateZ(angle) {
	      if (angle === 0) {
	        return this;
	      }
	
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
	    }
	
	    function shear(sx, sy) {
	      return this._t(1, sy, sx, 1, 0, 0);
	    }
	
	    function skew(ax, ay) {
	      return this.shear(_tan(ax), _tan(ay));
	    }
	
	    function skewFromAxis(ax, angle) {
	      var mCos = _cos(angle);
	
	      var mSin = _sin(angle);
	
	      return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }
	
	    function scale(sx, sy, sz) {
	      if (!sz && sz !== 0) {
	        sz = 1;
	      }
	
	      if (sx === 1 && sy === 1 && sz === 1) {
	        return this;
	      }
	
	      return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }
	
	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	      this.props[0] = a;
	      this.props[1] = b;
	      this.props[2] = c;
	      this.props[3] = d;
	      this.props[4] = e;
	      this.props[5] = f;
	      this.props[6] = g;
	      this.props[7] = h;
	      this.props[8] = i;
	      this.props[9] = j;
	      this.props[10] = k;
	      this.props[11] = l;
	      this.props[12] = m;
	      this.props[13] = n;
	      this.props[14] = o;
	      this.props[15] = p;
	      return this;
	    }
	
	    function translate(tx, ty, tz) {
	      tz = tz || 0;
	
	      if (tx !== 0 || ty !== 0 || tz !== 0) {
	        return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
	      }
	
	      return this;
	    }
	
	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	      var _p = this.props;
	
	      if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
	        // NOTE: commenting this condition because TurboFan deoptimizes code when present
	        // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	        _p[12] = _p[12] * a2 + _p[15] * m2;
	        _p[13] = _p[13] * f2 + _p[15] * n2;
	        _p[14] = _p[14] * k2 + _p[15] * o2;
	        _p[15] *= p2; // }
	
	        this._identityCalculated = false;
	        return this;
	      }
	
	      var a1 = _p[0];
	      var b1 = _p[1];
	      var c1 = _p[2];
	      var d1 = _p[3];
	      var e1 = _p[4];
	      var f1 = _p[5];
	      var g1 = _p[6];
	      var h1 = _p[7];
	      var i1 = _p[8];
	      var j1 = _p[9];
	      var k1 = _p[10];
	      var l1 = _p[11];
	      var m1 = _p[12];
	      var n1 = _p[13];
	      var o1 = _p[14];
	      var p1 = _p[15];
	      /* matrix order (canvas compatible):
	           * ace
	           * bdf
	           * 001
	           */
	
	      _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	      _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
	      _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
	      _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
	      _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
	      _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
	      _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
	      _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
	      _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
	      _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
	      _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
	      _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
	      _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
	      _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
	      _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
	      _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
	      this._identityCalculated = false;
	      return this;
	    }
	
	    function multiply(matrix) {
	      var matrixProps = matrix.props;
	      return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
	    }
	
	    function isIdentity() {
	      if (!this._identityCalculated) {
	        this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	        this._identityCalculated = true;
	      }
	
	      return this._identity;
	    }
	
	    function equals(matr) {
	      var i = 0;
	
	      while (i < 16) {
	        if (matr.props[i] !== this.props[i]) {
	          return false;
	        }
	
	        i += 1;
	      }
	
	      return true;
	    }
	
	    function clone(matr) {
	      var i;
	
	      for (i = 0; i < 16; i += 1) {
	        matr.props[i] = this.props[i];
	      }
	
	      return matr;
	    }
	
	    function cloneFromProps(props) {
	      var i;
	
	      for (i = 0; i < 16; i += 1) {
	        this.props[i] = props[i];
	      }
	    }
	
	    function applyToPoint(x, y, z) {
	      return {
	        x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	        y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	        z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	      };
	      /* return {
	           x: x * me.a + y * me.c + me.e,
	           y: x * me.b + y * me.d + me.f
	           }; */
	    }
	
	    function applyToX(x, y, z) {
	      return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }
	
	    function applyToY(x, y, z) {
	      return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }
	
	    function applyToZ(x, y, z) {
	      return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }
	
	    function getInverseMatrix() {
	      var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	      var a = this.props[5] / determinant;
	      var b = -this.props[1] / determinant;
	      var c = -this.props[4] / determinant;
	      var d = this.props[0] / determinant;
	      var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
	      var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
	      var inverseMatrix = new Matrix();
	      inverseMatrix.props[0] = a;
	      inverseMatrix.props[1] = b;
	      inverseMatrix.props[4] = c;
	      inverseMatrix.props[5] = d;
	      inverseMatrix.props[12] = e;
	      inverseMatrix.props[13] = f;
	      return inverseMatrix;
	    }
	
	    function inversePoint(pt) {
	      var inverseMatrix = this.getInverseMatrix();
	      return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
	    }
	
	    function inversePoints(pts) {
	      var i;
	      var len = pts.length;
	      var retPts = [];
	
	      for (i = 0; i < len; i += 1) {
	        retPts[i] = inversePoint(pts[i]);
	      }
	
	      return retPts;
	    }
	
	    function applyToTriplePoints(pt1, pt2, pt3) {
	      var arr = createTypedArray('float32', 6);
	
	      if (this.isIdentity()) {
	        arr[0] = pt1[0];
	        arr[1] = pt1[1];
	        arr[2] = pt2[0];
	        arr[3] = pt2[1];
	        arr[4] = pt3[0];
	        arr[5] = pt3[1];
	      } else {
	        var p0 = this.props[0];
	        var p1 = this.props[1];
	        var p4 = this.props[4];
	        var p5 = this.props[5];
	        var p12 = this.props[12];
	        var p13 = this.props[13];
	        arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
	        arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
	        arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
	        arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
	        arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
	        arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
	      }
	
	      return arr;
	    }
	
	    function applyToPointArray(x, y, z) {
	      var arr;
	
	      if (this.isIdentity()) {
	        arr = [x, y, z];
	      } else {
	        arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12], x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13], x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	      }
	
	      return arr;
	    }
	
	    function applyToPointStringified(x, y) {
	      if (this.isIdentity()) {
	        return x + ',' + y;
	      }
	
	      var _p = this.props;
	      return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
	    }
	
	    function toCSS() {
	      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	
	      /* if(this.isIdentity()) {
	              return '';
	          } */
	      var i = 0;
	      var props = this.props;
	      var cssValue = 'matrix3d(';
	      var v = 10000;
	
	      while (i < 16) {
	        cssValue += _rnd(props[i] * v) / v;
	        cssValue += i === 15 ? ')' : ',';
	        i += 1;
	      }
	
	      return cssValue;
	    }
	
	    function roundMatrixProperty(val) {
	      var v = 10000;
	
	      if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) {
	        return _rnd(val * v) / v;
	      }
	
	      return val;
	    }
	
	    function to2dCSS() {
	      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	
	      /* if(this.isIdentity()) {
	              return '';
	          } */
	      var props = this.props;
	
	      var _a = roundMatrixProperty(props[0]);
	
	      var _b = roundMatrixProperty(props[1]);
	
	      var _c = roundMatrixProperty(props[4]);
	
	      var _d = roundMatrixProperty(props[5]);
	
	      var _e = roundMatrixProperty(props[12]);
	
	      var _f = roundMatrixProperty(props[13]);
	
	      return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
	    }
	
	    return function () {
	      this.reset = reset;
	      this.rotate = rotate;
	      this.rotateX = rotateX;
	      this.rotateY = rotateY;
	      this.rotateZ = rotateZ;
	      this.skew = skew;
	      this.skewFromAxis = skewFromAxis;
	      this.shear = shear;
	      this.scale = scale;
	      this.setTransform = setTransform;
	      this.translate = translate;
	      this.transform = transform;
	      this.multiply = multiply;
	      this.applyToPoint = applyToPoint;
	      this.applyToX = applyToX;
	      this.applyToY = applyToY;
	      this.applyToZ = applyToZ;
	      this.applyToPointArray = applyToPointArray;
	      this.applyToTriplePoints = applyToTriplePoints;
	      this.applyToPointStringified = applyToPointStringified;
	      this.toCSS = toCSS;
	      this.to2dCSS = to2dCSS;
	      this.clone = clone;
	      this.cloneFromProps = cloneFromProps;
	      this.equals = equals;
	      this.inversePoints = inversePoints;
	      this.inversePoint = inversePoint;
	      this.getInverseMatrix = getInverseMatrix;
	      this._t = this.transform;
	      this.isIdentity = isIdentity;
	      this._identity = true;
	      this._identityCalculated = false;
	      this.props = createTypedArray('float32', 16);
	      this.reset();
	    };
	  }();
	
	  function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
	  var lottie = {};
	  var standalone = '__[STANDALONE]__';
	  var animationData = '__[ANIMATIONDATA]__';
	  var renderer = '';
	
	  function setLocation(href) {
	    setLocationHref(href);
	  }
	
	  function searchAnimations() {
	    if (standalone === true) {
	      animationManager.searchAnimations(animationData, standalone, renderer);
	    } else {
	      animationManager.searchAnimations();
	    }
	  }
	
	  function setSubframeRendering(flag) {
	    setSubframeEnabled(flag);
	  }
	
	  function setPrefix(prefix) {
	    setIdPrefix(prefix);
	  }
	
	  function loadAnimation(params) {
	    if (standalone === true) {
	      params.animationData = JSON.parse(animationData);
	    }
	
	    return animationManager.loadAnimation(params);
	  }
	
	  function setQuality(value) {
	    if (typeof value === 'string') {
	      switch (value) {
	        case 'high':
	          setDefaultCurveSegments(200);
	          break;
	
	        default:
	        case 'medium':
	          setDefaultCurveSegments(50);
	          break;
	
	        case 'low':
	          setDefaultCurveSegments(10);
	          break;
	      }
	    } else if (!isNaN(value) && value > 1) {
	      setDefaultCurveSegments(value);
	    }
	
	    if (getDefaultCurveSegments() >= 50) {
	      roundValues(false);
	    } else {
	      roundValues(true);
	    }
	  }
	
	  function inBrowser() {
	    return typeof navigator !== 'undefined';
	  }
	
	  function installPlugin(type, plugin) {
	    if (type === 'expressions') {
	      setExpressionsPlugin(plugin);
	    }
	  }
	
	  function getFactory(name) {
	    switch (name) {
	      case 'propertyFactory':
	        return PropertyFactory;
	
	      case 'shapePropertyFactory':
	        return ShapePropertyFactory;
	
	      case 'matrix':
	        return Matrix;
	
	      default:
	        return null;
	    }
	  }
	
	  lottie.play = animationManager.play;
	  lottie.pause = animationManager.pause;
	  lottie.setLocationHref = setLocation;
	  lottie.togglePause = animationManager.togglePause;
	  lottie.setSpeed = animationManager.setSpeed;
	  lottie.setDirection = animationManager.setDirection;
	  lottie.stop = animationManager.stop;
	  lottie.searchAnimations = searchAnimations;
	  lottie.registerAnimation = animationManager.registerAnimation;
	  lottie.loadAnimation = loadAnimation;
	  lottie.setSubframeRendering = setSubframeRendering;
	  lottie.resize = animationManager.resize; // lottie.start = start;
	
	  lottie.goToAndStop = animationManager.goToAndStop;
	  lottie.destroy = animationManager.destroy;
	  lottie.setQuality = setQuality;
	  lottie.inBrowser = inBrowser;
	  lottie.installPlugin = installPlugin;
	  lottie.freeze = animationManager.freeze;
	  lottie.unfreeze = animationManager.unfreeze;
	  lottie.setVolume = animationManager.setVolume;
	  lottie.mute = animationManager.mute;
	  lottie.unmute = animationManager.unmute;
	  lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
	  lottie.useWebWorker = setWebWorker;
	  lottie.setIDPrefix = setPrefix;
	  lottie.__getFactory = getFactory;
	  lottie.version = '5.12.2';
	
	  function checkReady() {
	    if (document.readyState === 'complete') {
	      clearInterval(readyStateCheckInterval);
	      searchAnimations();
	    }
	  }
	
	  function getQueryVariable(variable) {
	    var vars = queryString.split('&');
	
	    for (var i = 0; i < vars.length; i += 1) {
	      var pair = vars[i].split('=');
	
	      if (decodeURIComponent(pair[0]) == variable) {
	        // eslint-disable-line eqeqeq
	        return decodeURIComponent(pair[1]);
	      }
	    }
	
	    return null;
	  }
	
	  var queryString = '';
	
	  if (standalone) {
	    var scripts = document.getElementsByTagName('script');
	    var index = scripts.length - 1;
	    var myScript = scripts[index] || {
	      src: ''
	    };
	    queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
	
	    renderer = getQueryVariable('renderer');
	  }
	
	  var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
	
	  try {
	    if (!(( false ? "undefined" : _typeof$3(exports)) === 'object' && typeof module !== 'undefined') && !("function" === 'function' && __webpack_require__(2887)) // eslint-disable-line no-undef
	    ) {
	      window.bodymovin = lottie;
	    }
	  } catch (err) {//
	  }
	
	  var ShapeModifiers = function () {
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;
	
	    function registerModifier(nm, factory) {
	      if (!modifiers[nm]) {
	        modifiers[nm] = factory;
	      }
	    }
	
	    function getModifier(nm, elem, data) {
	      return new modifiers[nm](elem, data);
	    }
	
	    return ob;
	  }();
	
	  function ShapeModifier() {}
	
	  ShapeModifier.prototype.initModifierProperties = function () {};
	
	  ShapeModifier.prototype.addShapeToModifier = function () {};
	
	  ShapeModifier.prototype.addShape = function (data) {
	    if (!this.closed) {
	      // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
	      data.sh.container.addDynamicProperty(data.sh);
	      var shapeData = {
	        shape: data.sh,
	        data: data,
	        localShapeCollection: shapeCollectionPool.newShapeCollection()
	      };
	      this.shapes.push(shapeData);
	      this.addShapeToModifier(shapeData);
	
	      if (this._isAnimated) {
	        data.setAsAnimated();
	      }
	    }
	  };
	
	  ShapeModifier.prototype.init = function (elem, data) {
	    this.shapes = [];
	    this.elem = elem;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem, data);
	    this.frameId = initialDefaultFrame;
	    this.closed = false;
	    this.k = false;
	
	    if (this.dynamicProperties.length) {
	      this.k = true;
	    } else {
	      this.getValue(true);
	    }
	  };
	
	  ShapeModifier.prototype.processKeys = function () {
	    if (this.elem.globalData.frameId === this.frameId) {
	      return;
	    }
	
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	  };
	
	  extendPrototype([DynamicPropertyContainer], ShapeModifier);
	
	  function TrimModifier() {}
	
	  extendPrototype([ShapeModifier], TrimModifier);
	
	  TrimModifier.prototype.initModifierProperties = function (elem, data) {
	    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
	    this.sValue = 0;
	    this.eValue = 0;
	    this.getValue = this.processKeys;
	    this.m = data.m;
	    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
	  };
	
	  TrimModifier.prototype.addShapeToModifier = function (shapeData) {
	    shapeData.pathsData = [];
	  };
	
	  TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = [];
	
	    if (e <= 1) {
	      segments.push({
	        s: s,
	        e: e
	      });
	    } else if (s >= 1) {
	      segments.push({
	        s: s - 1,
	        e: e - 1
	      });
	    } else {
	      segments.push({
	        s: s,
	        e: 1
	      });
	      segments.push({
	        s: 0,
	        e: e - 1
	      });
	    }
	
	    var shapeSegments = [];
	    var i;
	    var len = segments.length;
	    var segmentOb;
	
	    for (i = 0; i < len; i += 1) {
	      segmentOb = segments[i];
	
	      if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
	        var shapeS;
	        var shapeE;
	
	        if (segmentOb.s * totalModifierLength <= addedLength) {
	          shapeS = 0;
	        } else {
	          shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	        }
	
	        if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	          shapeE = 1;
	        } else {
	          shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
	        }
	
	        shapeSegments.push([shapeS, shapeE]);
	      }
	    }
	
	    if (!shapeSegments.length) {
	      shapeSegments.push([0, 0]);
	    }
	
	    return shapeSegments;
	  };
	
	  TrimModifier.prototype.releasePathsData = function (pathsData) {
	    var i;
	    var len = pathsData.length;
	
	    for (i = 0; i < len; i += 1) {
	      segmentsLengthPool.release(pathsData[i]);
	    }
	
	    pathsData.length = 0;
	    return pathsData;
	  };
	
	  TrimModifier.prototype.processShapes = function (_isFirstFrame) {
	    var s;
	    var e;
	
	    if (this._mdf || _isFirstFrame) {
	      var o = this.o.v % 360 / 360;
	
	      if (o < 0) {
	        o += 1;
	      }
	
	      if (this.s.v > 1) {
	        s = 1 + o;
	      } else if (this.s.v < 0) {
	        s = 0 + o;
	      } else {
	        s = this.s.v + o;
	      }
	
	      if (this.e.v > 1) {
	        e = 1 + o;
	      } else if (this.e.v < 0) {
	        e = 0 + o;
	      } else {
	        e = this.e.v + o;
	      }
	
	      if (s > e) {
	        var _s = s;
	        s = e;
	        e = _s;
	      }
	
	      s = Math.round(s * 10000) * 0.0001;
	      e = Math.round(e * 10000) * 0.0001;
	      this.sValue = s;
	      this.eValue = e;
	    } else {
	      s = this.sValue;
	      e = this.eValue;
	    }
	
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var pathsData;
	    var pathData;
	    var totalShapeLength;
	    var totalModifierLength = 0;
	
	    if (e === s) {
	      for (i = 0; i < len; i += 1) {
	        this.shapes[i].localShapeCollection.releaseShapes();
	        this.shapes[i].shape._mdf = true;
	        this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
	
	        if (this._mdf) {
	          this.shapes[i].pathsData.length = 0;
	        }
	      }
	    } else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
	      var segments = [];
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
	
	        if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
	          shapeData.shape.paths = shapeData.localShapeCollection;
	        } else {
	          shapePaths = shapeData.shape.paths;
	          jLen = shapePaths._length;
	          totalShapeLength = 0;
	
	          if (!shapeData.shape._mdf && shapeData.pathsData.length) {
	            totalShapeLength = shapeData.totalShapeLength;
	          } else {
	            pathsData = this.releasePathsData(shapeData.pathsData);
	
	            for (j = 0; j < jLen; j += 1) {
	              pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	              pathsData.push(pathData);
	              totalShapeLength += pathData.totalLength;
	            }
	
	            shapeData.totalShapeLength = totalShapeLength;
	            shapeData.pathsData = pathsData;
	          }
	
	          totalModifierLength += totalShapeLength;
	          shapeData.shape._mdf = true;
	        }
	      }
	
	      var shapeS = s;
	      var shapeE = e;
	      var addedLength = 0;
	      var edges;
	
	      for (i = len - 1; i >= 0; i -= 1) {
	        shapeData = this.shapes[i];
	
	        if (shapeData.shape._mdf) {
	          localShapeCollection = shapeData.localShapeCollection;
	          localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
	
	          if (this.m === 2 && len > 1) {
	            edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	            addedLength += shapeData.totalShapeLength;
	          } else {
	            edges = [[shapeS, shapeE]];
	          }
	
	          jLen = edges.length;
	
	          for (j = 0; j < jLen; j += 1) {
	            shapeS = edges[j][0];
	            shapeE = edges[j][1];
	            segments.length = 0;
	
	            if (shapeE <= 1) {
	              segments.push({
	                s: shapeData.totalShapeLength * shapeS,
	                e: shapeData.totalShapeLength * shapeE
	              });
	            } else if (shapeS >= 1) {
	              segments.push({
	                s: shapeData.totalShapeLength * (shapeS - 1),
	                e: shapeData.totalShapeLength * (shapeE - 1)
	              });
	            } else {
	              segments.push({
	                s: shapeData.totalShapeLength * shapeS,
	                e: shapeData.totalShapeLength
	              });
	              segments.push({
	                s: 0,
	                e: shapeData.totalShapeLength * (shapeE - 1)
	              });
	            }
	
	            var newShapesData = this.addShapes(shapeData, segments[0]);
	
	            if (segments[0].s !== segments[0].e) {
	              if (segments.length > 1) {
	                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
	
	                if (lastShapeInCollection.c) {
	                  var lastShape = newShapesData.pop();
	                  this.addPaths(newShapesData, localShapeCollection);
	                  newShapesData = this.addShapes(shapeData, segments[1], lastShape);
	                } else {
	                  this.addPaths(newShapesData, localShapeCollection);
	                  newShapesData = this.addShapes(shapeData, segments[1]);
	                }
	              }
	
	              this.addPaths(newShapesData, localShapeCollection);
	            }
	          }
	
	          shapeData.shape.paths = localShapeCollection;
	        }
	      }
	    } else if (this._mdf) {
	      for (i = 0; i < len; i += 1) {
	        // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
	        // Don't remove this even if it's losing cached info.
	        this.shapes[i].pathsData.length = 0;
	        this.shapes[i].shape._mdf = true;
	      }
	    }
	  };
	
	  TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
	    var i;
	    var len = newPaths.length;
	
	    for (i = 0; i < len; i += 1) {
	      localShapeCollection.addShape(newPaths[i]);
	    }
	  };
	
	  TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
	    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
	    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
	
	    if (newShape) {
	      shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
	    }
	
	    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
	  };
	
	  TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
	    shapePath.setXYAt(points[1], points[5], 'o', pos);
	    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
	
	    if (newShape) {
	      shapePath.setXYAt(points[0], points[4], 'v', pos);
	    }
	
	    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
	  };
	
	  TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i;
	    var len = shapeData.shape.paths._length;
	    var j;
	    var jLen;
	    var addedLength = 0;
	    var currentLengthData;
	    var segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;
	
	    if (!shapePath) {
	      shapePath = shapePool.newElement();
	      segmentCount = 0;
	      initPos = 0;
	    } else {
	      segmentCount = shapePath._length;
	      initPos = shapePath._length;
	    }
	
	    shapes.push(shapePath);
	
	    for (i = 0; i < len; i += 1) {
	      lengths = pathsData[i].lengths;
	      shapePath.c = shapePaths[i].c;
	      jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
	
	      for (j = 1; j < jLen; j += 1) {
	        currentLengthData = lengths[j - 1];
	
	        if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
	          addedLength += currentLengthData.addedLength;
	          shapePath.c = false;
	        } else if (addedLength > shapeSegment.e) {
	          shapePath.c = false;
	          break;
	        } else {
	          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
	            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
	            newShape = false;
	          } else {
	            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
	            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	
	            newShape = false;
	            shapePath.c = false;
	          }
	
	          addedLength += currentLengthData.addedLength;
	          segmentCount += 1;
	        }
	      }
	
	      if (shapePaths[i].c && lengths.length) {
	        currentLengthData = lengths[j - 1];
	
	        if (addedLength <= shapeSegment.e) {
	          var segmentLength = lengths[j - 1].addedLength;
	
	          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
	            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
	            newShape = false;
	          } else {
	            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
	            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
	
	            newShape = false;
	            shapePath.c = false;
	          }
	        } else {
	          shapePath.c = false;
	        }
	
	        addedLength += currentLengthData.addedLength;
	        segmentCount += 1;
	      }
	
	      if (shapePath._length) {
	        shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
	        shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
	      }
	
	      if (addedLength > shapeSegment.e) {
	        break;
	      }
	
	      if (i < len - 1) {
	        shapePath = shapePool.newElement();
	        newShape = true;
	        shapes.push(shapePath);
	        segmentCount = 0;
	      }
	    }
	
	    return shapes;
	  };
	
	  function PuckerAndBloatModifier() {}
	
	  extendPrototype([ShapeModifier], PuckerAndBloatModifier);
	
	  PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
	    this._isAnimated = !!this.amount.effectsSequence.length;
	  };
	
	  PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
	    var percent = amount / 100;
	    var centerPoint = [0, 0];
	    var pathLength = path._length;
	    var i = 0;
	
	    for (i = 0; i < pathLength; i += 1) {
	      centerPoint[0] += path.v[i][0];
	      centerPoint[1] += path.v[i][1];
	    }
	
	    centerPoint[0] /= pathLength;
	    centerPoint[1] /= pathLength;
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	    var vX;
	    var vY;
	    var oX;
	    var oY;
	    var iX;
	    var iY;
	
	    for (i = 0; i < pathLength; i += 1) {
	      vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
	      vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
	      oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
	      oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
	      iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
	      iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
	      clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
	    }
	
	    return clonedPath;
	  };
	
	  PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amount = this.amount.v;
	
	    if (amount !== 0) {
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;
	
	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;
	
	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
	          }
	        }
	
	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }
	
	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };
	
	  var TransformPropertyFactory = function () {
	    var defaultVector = [0, 0];
	
	    function applyToMatrix(mat) {
	      var _mdf = this._mdf;
	      this.iterateDynamicProperties();
	      this._mdf = this._mdf || _mdf;
	
	      if (this.a) {
	        mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	      }
	
	      if (this.s) {
	        mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	      }
	
	      if (this.sk) {
	        mat.skewFromAxis(-this.sk.v, this.sa.v);
	      }
	
	      if (this.r) {
	        mat.rotate(-this.r.v);
	      } else {
	        mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	      }
	
	      if (this.data.p.s) {
	        if (this.data.p.z) {
	          mat.translate(this.px.v, this.py.v, -this.pz.v);
	        } else {
	          mat.translate(this.px.v, this.py.v, 0);
	        }
	      } else {
	        mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	      }
	    }
	
	    function processKeys(forceRender) {
	      if (this.elem.globalData.frameId === this.frameId) {
	        return;
	      }
	
	      if (this._isDirty) {
	        this.precalculateMatrix();
	        this._isDirty = false;
	      }
	
	      this.iterateDynamicProperties();
	
	      if (this._mdf || forceRender) {
	        var frameRate;
	        this.v.cloneFromProps(this.pre.props);
	
	        if (this.appliedTransformations < 1) {
	          this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }
	
	        if (this.appliedTransformations < 2) {
	          this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }
	
	        if (this.sk && this.appliedTransformations < 3) {
	          this.v.skewFromAxis(-this.sk.v, this.sa.v);
	        }
	
	        if (this.r && this.appliedTransformations < 4) {
	          this.v.rotate(-this.r.v);
	        } else if (!this.r && this.appliedTransformations < 4) {
	          this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }
	
	        if (this.autoOriented) {
	          var v1;
	          var v2;
	          frameRate = this.elem.globalData.frameRate;
	
	          if (this.p && this.p.keyframes && this.p.getValueAtTime) {
	            if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
	              v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
	              v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
	            } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	              v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
	              v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
	            } else {
	              v1 = this.p.pv;
	              v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
	            }
	          } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
	            v1 = [];
	            v2 = [];
	            var px = this.px;
	            var py = this.py;
	
	            if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
	              v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
	              v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
	              v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
	              v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
	            } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
	              v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
	              v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
	              v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
	              v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
	            } else {
	              v1 = [px.pv, py.pv];
	              v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
	              v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
	            }
	          } else {
	            v2 = defaultVector;
	            v1 = v2;
	          }
	
	          this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	        }
	
	        if (this.data.p && this.data.p.s) {
	          if (this.data.p.z) {
	            this.v.translate(this.px.v, this.py.v, -this.pz.v);
	          } else {
	            this.v.translate(this.px.v, this.py.v, 0);
	          }
	        } else {
	          this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	      }
	
	      this.frameId = this.elem.globalData.frameId;
	    }
	
	    function precalculateMatrix() {
	      this.appliedTransformations = 0;
	      this.pre.reset();
	
	      if (!this.a.effectsSequence.length) {
	        this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        this.appliedTransformations = 1;
	      } else {
	        return;
	      }
	
	      if (!this.s.effectsSequence.length) {
	        this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        this.appliedTransformations = 2;
	      } else {
	        return;
	      }
	
	      if (this.sk) {
	        if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
	          this.pre.skewFromAxis(-this.sk.v, this.sa.v);
	          this.appliedTransformations = 3;
	        } else {
	          return;
	        }
	      }
	
	      if (this.r) {
	        if (!this.r.effectsSequence.length) {
	          this.pre.rotate(-this.r.v);
	          this.appliedTransformations = 4;
	        }
	      } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
	        this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        this.appliedTransformations = 4;
	      }
	    }
	
	    function autoOrient() {//
	      // var prevP = this.getValueAtTime();
	    }
	
	    function addDynamicProperty(prop) {
	      this._addDynamicProperty(prop);
	
	      this.elem.addDynamicProperty(prop);
	      this._isDirty = true;
	    }
	
	    function TransformProperty(elem, data, container) {
	      this.elem = elem;
	      this.frameId = -1;
	      this.propType = 'transform';
	      this.data = data;
	      this.v = new Matrix(); // Precalculated matrix with non animated properties
	
	      this.pre = new Matrix();
	      this.appliedTransformations = 0;
	      this.initDynamicPropertyContainer(container || elem);
	
	      if (data.p && data.p.s) {
	        this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
	        this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
	
	        if (data.p.z) {
	          this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
	        }
	      } else {
	        this.p = PropertyFactory.getProp(elem, data.p || {
	          k: [0, 0, 0]
	        }, 1, 0, this);
	      }
	
	      if (data.rx) {
	        this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
	        this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
	        this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
	
	        if (data.or.k[0].ti) {
	          var i;
	          var len = data.or.k.length;
	
	          for (i = 0; i < len; i += 1) {
	            data.or.k[i].to = null;
	            data.or.k[i].ti = null;
	          }
	        }
	
	        this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
	
	        this.or.sh = true;
	      } else {
	        this.r = PropertyFactory.getProp(elem, data.r || {
	          k: 0
	        }, 0, degToRads, this);
	      }
	
	      if (data.sk) {
	        this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
	        this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
	      }
	
	      this.a = PropertyFactory.getProp(elem, data.a || {
	        k: [0, 0, 0]
	      }, 1, 0, this);
	      this.s = PropertyFactory.getProp(elem, data.s || {
	        k: [100, 100, 100]
	      }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
	
	      if (data.o) {
	        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
	      } else {
	        this.o = {
	          _mdf: false,
	          v: 1
	        };
	      }
	
	      this._isDirty = true;
	
	      if (!this.dynamicProperties.length) {
	        this.getValue(true);
	      }
	    }
	
	    TransformProperty.prototype = {
	      applyToMatrix: applyToMatrix,
	      getValue: processKeys,
	      precalculateMatrix: precalculateMatrix,
	      autoOrient: autoOrient
	    };
	    extendPrototype([DynamicPropertyContainer], TransformProperty);
	    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
	    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
	
	    function getTransformProperty(elem, data, container) {
	      return new TransformProperty(elem, data, container);
	    }
	
	    return {
	      getTransformProperty: getTransformProperty
	    };
	  }();
	
	  function RepeaterModifier() {}
	
	  extendPrototype([ShapeModifier], RepeaterModifier);
	
	  RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
	    this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
	    this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
	    this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
	    this.data = data;
	
	    if (!this.dynamicProperties.length) {
	      this.getValue(true);
	    }
	
	    this._isAnimated = !!this.dynamicProperties.length;
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	  };
	
	  RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	  };
	
	  RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.frameId = -1;
	    this.initDynamicPropertyContainer(elem);
	    this.initModifierProperties(elem, arr[pos]);
	
	    while (pos > 0) {
	      pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
	
	      this._elements.unshift(arr[pos]);
	    }
	
	    if (this.dynamicProperties.length) {
	      this.k = true;
	    } else {
	      this.getValue(true);
	    }
	  };
	
	  RepeaterModifier.prototype.resetElements = function (elements) {
	    var i;
	    var len = elements.length;
	
	    for (i = 0; i < len; i += 1) {
	      elements[i]._processed = false;
	
	      if (elements[i].ty === 'gr') {
	        this.resetElements(elements[i].it);
	      }
	    }
	  };
	
	  RepeaterModifier.prototype.cloneElements = function (elements) {
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	  };
	
	  RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
	    var i;
	    var len = elements.length;
	
	    for (i = 0; i < len; i += 1) {
	      elements[i]._render = renderFlag;
	
	      if (elements[i].ty === 'gr') {
	        this.changeGroupRender(elements[i].it, renderFlag);
	      }
	    }
	  };
	
	  RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
	    var items;
	    var itemsTransform;
	    var i;
	    var dir;
	    var cont;
	    var hasReloaded = false;
	
	    if (this._mdf || _isFirstFrame) {
	      var copies = Math.ceil(this.c.v);
	
	      if (this._groups.length < copies) {
	        while (this._groups.length < copies) {
	          var group = {
	            it: this.cloneElements(this._elements),
	            ty: 'gr'
	          };
	          group.it.push({
	            a: {
	              a: 0,
	              ix: 1,
	              k: [0, 0]
	            },
	            nm: 'Transform',
	            o: {
	              a: 0,
	              ix: 7,
	              k: 100
	            },
	            p: {
	              a: 0,
	              ix: 2,
	              k: [0, 0]
	            },
	            r: {
	              a: 1,
	              ix: 6,
	              k: [{
	                s: 0,
	                e: 0,
	                t: 0
	              }, {
	                s: 0,
	                e: 0,
	                t: 1
	              }]
	            },
	            s: {
	              a: 0,
	              ix: 3,
	              k: [100, 100]
	            },
	            sa: {
	              a: 0,
	              ix: 5,
	              k: 0
	            },
	            sk: {
	              a: 0,
	              ix: 4,
	              k: 0
	            },
	            ty: 'tr'
	          });
	          this.arr.splice(0, 0, group);
	
	          this._groups.splice(0, 0, group);
	
	          this._currentCopies += 1;
	        }
	
	        this.elem.reloadShapes();
	        hasReloaded = true;
	      }
	
	      cont = 0;
	      var renderFlag;
	
	      for (i = 0; i <= this._groups.length - 1; i += 1) {
	        renderFlag = cont < copies;
	        this._groups[i]._render = renderFlag;
	        this.changeGroupRender(this._groups[i].it, renderFlag);
	
	        if (!renderFlag) {
	          var elems = this.elemsData[i].it;
	          var transformData = elems[elems.length - 1];
	
	          if (transformData.transform.op.v !== 0) {
	            transformData.transform.op._mdf = true;
	            transformData.transform.op.v = 0;
	          } else {
	            transformData.transform.op._mdf = false;
	          }
	        }
	
	        cont += 1;
	      }
	
	      this._currentCopies = copies; /// /
	
	      var offset = this.o.v;
	      var offsetModulo = offset % 1;
	      var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	      var pProps = this.pMatrix.props;
	      var rProps = this.rMatrix.props;
	      var sProps = this.sMatrix.props;
	      this.pMatrix.reset();
	      this.rMatrix.reset();
	      this.sMatrix.reset();
	      this.tMatrix.reset();
	      this.matrix.reset();
	      var iteration = 0;
	
	      if (offset > 0) {
	        while (iteration < roundOffset) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	          iteration += 1;
	        }
	
	        if (offsetModulo) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	          iteration += offsetModulo;
	        }
	      } else if (offset < 0) {
	        while (iteration > roundOffset) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	          iteration -= 1;
	        }
	
	        if (offsetModulo) {
	          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
	          iteration -= offsetModulo;
	        }
	      }
	
	      i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	      dir = this.data.m === 1 ? 1 : -1;
	      cont = this._currentCopies;
	      var j;
	      var jLen;
	
	      while (cont) {
	        items = this.elemsData[i].it;
	        itemsTransform = items[items.length - 1].transform.mProps.v.props;
	        jLen = itemsTransform.length;
	        items[items.length - 1].transform.mProps._mdf = true;
	        items[items.length - 1].transform.op._mdf = true;
	        items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
	
	        if (iteration !== 0) {
	          if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) {
	            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	          }
	
	          this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
	          this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
	          this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
	
	          for (j = 0; j < jLen; j += 1) {
	            itemsTransform[j] = this.matrix.props[j];
	          }
	
	          this.matrix.reset();
	        } else {
	          this.matrix.reset();
	
	          for (j = 0; j < jLen; j += 1) {
	            itemsTransform[j] = this.matrix.props[j];
	          }
	        }
	
	        iteration += 1;
	        cont -= 1;
	        i += dir;
	      }
	    } else {
	      cont = this._currentCopies;
	      i = 0;
	      dir = 1;
	
	      while (cont) {
	        items = this.elemsData[i].it;
	        itemsTransform = items[items.length - 1].transform.mProps.v.props;
	        items[items.length - 1].transform.mProps._mdf = false;
	        items[items.length - 1].transform.op._mdf = false;
	        cont -= 1;
	        i += dir;
	      }
	    }
	
	    return hasReloaded;
	  };
	
	  RepeaterModifier.prototype.addShape = function () {};
	
	  function RoundCornersModifier() {}
	
	  extendPrototype([ShapeModifier], RoundCornersModifier);
	
	  RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
	    this._isAnimated = !!this.rd.effectsSequence.length;
	  };
	
	  RoundCornersModifier.prototype.processPath = function (path, round) {
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	    var i;
	    var len = path._length;
	    var currentV;
	    var currentI;
	    var currentO;
	    var closerV;
	    var distance;
	    var newPosPerc;
	    var index = 0;
	    var vX;
	    var vY;
	    var oX;
	    var oY;
	    var iX;
	    var iY;
	
	    for (i = 0; i < len; i += 1) {
	      currentV = path.v[i];
	      currentO = path.o[i];
	      currentI = path.i[i];
	
	      if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
	        if ((i === 0 || i === len - 1) && !path.c) {
	          clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
	          /* clonedPath.v[index] = currentV;
	                  clonedPath.o[index] = currentO;
	                  clonedPath.i[index] = currentI; */
	
	          index += 1;
	        } else {
	          if (i === 0) {
	            closerV = path.v[len - 1];
	          } else {
	            closerV = path.v[i - 1];
	          }
	
	          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
	          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
	          iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
	          vX = iX;
	          iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
	          vY = iY;
	          oX = vX - (vX - currentV[0]) * roundCorner;
	          oY = vY - (vY - currentV[1]) * roundCorner;
	          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
	          index += 1;
	
	          if (i === len - 1) {
	            closerV = path.v[0];
	          } else {
	            closerV = path.v[i + 1];
	          }
	
	          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
	          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
	          oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
	          vX = oX;
	          oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
	          vY = oY;
	          iX = vX - (vX - currentV[0]) * roundCorner;
	          iY = vY - (vY - currentV[1]) * roundCorner;
	          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
	          index += 1;
	        }
	      } else {
	        clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
	        index += 1;
	      }
	    }
	
	    return clonedPath;
	  };
	
	  RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var rd = this.rd.v;
	
	    if (rd !== 0) {
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;
	
	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;
	
	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
	          }
	        }
	
	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }
	
	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };
	
	  function floatEqual(a, b) {
	    return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
	  }
	
	  function floatZero(f) {
	    return Math.abs(f) <= 0.00001;
	  }
	
	  function lerp(p0, p1, amount) {
	    return p0 * (1 - amount) + p1 * amount;
	  }
	
	  function lerpPoint(p0, p1, amount) {
	    return [lerp(p0[0], p1[0], amount), lerp(p0[1], p1[1], amount)];
	  }
	
	  function quadRoots(a, b, c) {
	    // no root
	    if (a === 0) return [];
	    var s = b * b - 4 * a * c; // Complex roots
	
	    if (s < 0) return [];
	    var singleRoot = -b / (2 * a); // 1 root
	
	    if (s === 0) return [singleRoot];
	    var delta = Math.sqrt(s) / (2 * a); // 2 roots
	
	    return [singleRoot - delta, singleRoot + delta];
	  }
	
	  function polynomialCoefficients(p0, p1, p2, p3) {
	    return [-p0 + 3 * p1 - 3 * p2 + p3, 3 * p0 - 6 * p1 + 3 * p2, -3 * p0 + 3 * p1, p0];
	  }
	
	  function singlePoint(p) {
	    return new PolynomialBezier(p, p, p, p, false);
	  }
	
	  function PolynomialBezier(p0, p1, p2, p3, linearize) {
	    if (linearize && pointEqual(p0, p1)) {
	      p1 = lerpPoint(p0, p3, 1 / 3);
	    }
	
	    if (linearize && pointEqual(p2, p3)) {
	      p2 = lerpPoint(p0, p3, 2 / 3);
	    }
	
	    var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
	    var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
	    this.a = [coeffx[0], coeffy[0]];
	    this.b = [coeffx[1], coeffy[1]];
	    this.c = [coeffx[2], coeffy[2]];
	    this.d = [coeffx[3], coeffy[3]];
	    this.points = [p0, p1, p2, p3];
	  }
	
	  PolynomialBezier.prototype.point = function (t) {
	    return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
	  };
	
	  PolynomialBezier.prototype.derivative = function (t) {
	    return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
	  };
	
	  PolynomialBezier.prototype.tangentAngle = function (t) {
	    var p = this.derivative(t);
	    return Math.atan2(p[1], p[0]);
	  };
	
	  PolynomialBezier.prototype.normalAngle = function (t) {
	    var p = this.derivative(t);
	    return Math.atan2(p[0], p[1]);
	  };
	
	  PolynomialBezier.prototype.inflectionPoints = function () {
	    var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
	    if (floatZero(denom)) return [];
	    var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
	    var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
	    if (square < 0) return [];
	    var root = Math.sqrt(square);
	
	    if (floatZero(root)) {
	      if (root > 0 && root < 1) return [tcusp];
	      return [];
	    }
	
	    return [tcusp - root, tcusp + root].filter(function (r) {
	      return r > 0 && r < 1;
	    });
	  };
	
	  PolynomialBezier.prototype.split = function (t) {
	    if (t <= 0) return [singlePoint(this.points[0]), this];
	    if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
	    var p10 = lerpPoint(this.points[0], this.points[1], t);
	    var p11 = lerpPoint(this.points[1], this.points[2], t);
	    var p12 = lerpPoint(this.points[2], this.points[3], t);
	    var p20 = lerpPoint(p10, p11, t);
	    var p21 = lerpPoint(p11, p12, t);
	    var p3 = lerpPoint(p20, p21, t);
	    return [new PolynomialBezier(this.points[0], p10, p20, p3, true), new PolynomialBezier(p3, p21, p12, this.points[3], true)];
	  };
	
	  function extrema(bez, comp) {
	    var min = bez.points[0][comp];
	    var max = bez.points[bez.points.length - 1][comp];
	
	    if (min > max) {
	      var e = max;
	      max = min;
	      min = e;
	    } // Derivative roots to find min/max
	
	
	    var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
	
	    for (var i = 0; i < f.length; i += 1) {
	      if (f[i] > 0 && f[i] < 1) {
	        var val = bez.point(f[i])[comp];
	        if (val < min) min = val;else if (val > max) max = val;
	      }
	    }
	
	    return {
	      min: min,
	      max: max
	    };
	  }
	
	  PolynomialBezier.prototype.bounds = function () {
	    return {
	      x: extrema(this, 0),
	      y: extrema(this, 1)
	    };
	  };
	
	  PolynomialBezier.prototype.boundingBox = function () {
	    var bounds = this.bounds();
	    return {
	      left: bounds.x.min,
	      right: bounds.x.max,
	      top: bounds.y.min,
	      bottom: bounds.y.max,
	      width: bounds.x.max - bounds.x.min,
	      height: bounds.y.max - bounds.y.min,
	      cx: (bounds.x.max + bounds.x.min) / 2,
	      cy: (bounds.y.max + bounds.y.min) / 2
	    };
	  };
	
	  function intersectData(bez, t1, t2) {
	    var box = bez.boundingBox();
	    return {
	      cx: box.cx,
	      cy: box.cy,
	      width: box.width,
	      height: box.height,
	      bez: bez,
	      t: (t1 + t2) / 2,
	      t1: t1,
	      t2: t2
	    };
	  }
	
	  function splitData(data) {
	    var split = data.bez.split(0.5);
	    return [intersectData(split[0], data.t1, data.t), intersectData(split[1], data.t, data.t2)];
	  }
	
	  function boxIntersect(b1, b2) {
	    return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
	  }
	
	  function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
	    if (!boxIntersect(d1, d2)) return;
	
	    if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
	      intersections.push([d1.t, d2.t]);
	      return;
	    }
	
	    var d1s = splitData(d1);
	    var d2s = splitData(d2);
	    intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
	    intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
	  }
	
	  PolynomialBezier.prototype.intersections = function (other, tolerance, maxRecursion) {
	    if (tolerance === undefined) tolerance = 2;
	    if (maxRecursion === undefined) maxRecursion = 7;
	    var intersections = [];
	    intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
	    return intersections;
	  };
	
	  PolynomialBezier.shapeSegment = function (shapePath, index) {
	    var nextIndex = (index + 1) % shapePath.length();
	    return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
	  };
	
	  PolynomialBezier.shapeSegmentInverted = function (shapePath, index) {
	    var nextIndex = (index + 1) % shapePath.length();
	    return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
	  };
	
	  function crossProduct(a, b) {
	    return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	  }
	
	  function lineIntersection(start1, end1, start2, end2) {
	    var v1 = [start1[0], start1[1], 1];
	    var v2 = [end1[0], end1[1], 1];
	    var v3 = [start2[0], start2[1], 1];
	    var v4 = [end2[0], end2[1], 1];
	    var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
	    if (floatZero(r[2])) return null;
	    return [r[0] / r[2], r[1] / r[2]];
	  }
	
	  function polarOffset(p, angle, length) {
	    return [p[0] + Math.cos(angle) * length, p[1] - Math.sin(angle) * length];
	  }
	
	  function pointDistance(p1, p2) {
	    return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
	  }
	
	  function pointEqual(p1, p2) {
	    return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
	  }
	
	  function ZigZagModifier() {}
	
	  extendPrototype([ShapeModifier], ZigZagModifier);
	
	  ZigZagModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
	    this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
	    this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
	    this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
	  };
	
	  function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
	    var angO = angle - Math.PI / 2;
	    var angI = angle + Math.PI / 2;
	    var px = point[0] + Math.cos(angle) * direction * amplitude;
	    var py = point[1] - Math.sin(angle) * direction * amplitude;
	    outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
	  }
	
	  function getPerpendicularVector(pt1, pt2) {
	    var vector = [pt2[0] - pt1[0], pt2[1] - pt1[1]];
	    var rot = -Math.PI * 0.5;
	    var rotatedVector = [Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1], Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]];
	    return rotatedVector;
	  }
	
	  function getProjectingAngle(path, cur) {
	    var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
	    var nextIndex = (cur + 1) % path.length();
	    var prevPoint = path.v[prevIndex];
	    var nextPoint = path.v[nextIndex];
	    var pVector = getPerpendicularVector(prevPoint, nextPoint);
	    return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
	  }
	
	  function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
	    var angle = getProjectingAngle(path, cur);
	    var point = path.v[cur % path._length];
	    var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
	    var nextPoint = path.v[(cur + 1) % path._length];
	    var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
	    var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
	    setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
	  }
	
	  function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
	    for (var i = 0; i < frequency; i += 1) {
	      var t = (i + 1) / (frequency + 1);
	      var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
	      var angle = segment.normalAngle(t);
	      var point = segment.point(t);
	      setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
	      direction = -direction;
	    }
	
	    return direction;
	  }
	
	  ZigZagModifier.prototype.processPath = function (path, amplitude, frequency, pointType) {
	    var count = path._length;
	    var clonedPath = shapePool.newElement();
	    clonedPath.c = path.c;
	
	    if (!path.c) {
	      count -= 1;
	    }
	
	    if (count === 0) return clonedPath;
	    var direction = -1;
	    var segment = PolynomialBezier.shapeSegment(path, 0);
	    zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
	
	    for (var i = 0; i < count; i += 1) {
	      direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
	
	      if (i === count - 1 && !path.c) {
	        segment = null;
	      } else {
	        segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
	      }
	
	      zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
	    }
	
	    return clonedPath;
	  };
	
	  ZigZagModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amplitude = this.amplitude.v;
	    var frequency = Math.max(0, Math.round(this.frequency.v));
	    var pointType = this.pointsType.v;
	
	    if (amplitude !== 0) {
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;
	
	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;
	
	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
	          }
	        }
	
	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }
	
	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };
	
	  function linearOffset(p1, p2, amount) {
	    var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
	    return [polarOffset(p1, angle, amount), polarOffset(p2, angle, amount)];
	  }
	
	  function offsetSegment(segment, amount) {
	    var p0;
	    var p1a;
	    var p1b;
	    var p2b;
	    var p2a;
	    var p3;
	    var e;
	    e = linearOffset(segment.points[0], segment.points[1], amount);
	    p0 = e[0];
	    p1a = e[1];
	    e = linearOffset(segment.points[1], segment.points[2], amount);
	    p1b = e[0];
	    p2b = e[1];
	    e = linearOffset(segment.points[2], segment.points[3], amount);
	    p2a = e[0];
	    p3 = e[1];
	    var p1 = lineIntersection(p0, p1a, p1b, p2b);
	    if (p1 === null) p1 = p1a;
	    var p2 = lineIntersection(p2a, p3, p1b, p2b);
	    if (p2 === null) p2 = p2a;
	    return new PolynomialBezier(p0, p1, p2, p3);
	  }
	
	  function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
	    var p0 = seg1.points[3];
	    var p1 = seg2.points[0]; // Bevel
	
	    if (lineJoin === 3) return p0; // Connected, they don't need a joint
	
	    if (pointEqual(p0, p1)) return p0; // Round
	
	    if (lineJoin === 2) {
	      var angleOut = -seg1.tangentAngle(1);
	      var angleIn = -seg2.tangentAngle(0) + Math.PI;
	      var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
	      var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
	      var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
	      outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
	      tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
	      outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
	      return p1;
	    } // Miter
	
	
	    var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
	    var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
	    var intersection = lineIntersection(t0, p0, p1, t1);
	
	    if (intersection && pointDistance(intersection, p0) < miterLimit) {
	      outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
	      return intersection;
	    }
	
	    return p0;
	  }
	
	  function getIntersection(a, b) {
	    var intersect = a.intersections(b);
	    if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
	    if (intersect.length) return intersect[0];
	    return null;
	  }
	
	  function pruneSegmentIntersection(a, b) {
	    var outa = a.slice();
	    var outb = b.slice();
	    var intersect = getIntersection(a[a.length - 1], b[0]);
	
	    if (intersect) {
	      outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
	      outb[0] = b[0].split(intersect[1])[1];
	    }
	
	    if (a.length > 1 && b.length > 1) {
	      intersect = getIntersection(a[0], b[b.length - 1]);
	
	      if (intersect) {
	        return [[a[0].split(intersect[0])[0]], [b[b.length - 1].split(intersect[1])[1]]];
	      }
	    }
	
	    return [outa, outb];
	  }
	
	  function pruneIntersections(segments) {
	    var e;
	
	    for (var i = 1; i < segments.length; i += 1) {
	      e = pruneSegmentIntersection(segments[i - 1], segments[i]);
	      segments[i - 1] = e[0];
	      segments[i] = e[1];
	    }
	
	    if (segments.length > 1) {
	      e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
	      segments[segments.length - 1] = e[0];
	      segments[0] = e[1];
	    }
	
	    return segments;
	  }
	
	  function offsetSegmentSplit(segment, amount) {
	    /*
	      We split each bezier segment into smaller pieces based
	      on inflection points, this ensures the control point
	      polygon is convex.
	        (A cubic bezier can have none, one, or two inflection points)
	    */
	    var flex = segment.inflectionPoints();
	    var left;
	    var right;
	    var split;
	    var mid;
	
	    if (flex.length === 0) {
	      return [offsetSegment(segment, amount)];
	    }
	
	    if (flex.length === 1 || floatEqual(flex[1], 1)) {
	      split = segment.split(flex[0]);
	      left = split[0];
	      right = split[1];
	      return [offsetSegment(left, amount), offsetSegment(right, amount)];
	    }
	
	    split = segment.split(flex[0]);
	    left = split[0];
	    var t = (flex[1] - flex[0]) / (1 - flex[0]);
	    split = split[1].split(t);
	    mid = split[0];
	    right = split[1];
	    return [offsetSegment(left, amount), offsetSegment(mid, amount), offsetSegment(right, amount)];
	  }
	
	  function OffsetPathModifier() {}
	
	  extendPrototype([ShapeModifier], OffsetPathModifier);
	
	  OffsetPathModifier.prototype.initModifierProperties = function (elem, data) {
	    this.getValue = this.processKeys;
	    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
	    this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
	    this.lineJoin = data.lj;
	    this._isAnimated = this.amount.effectsSequence.length !== 0;
	  };
	
	  OffsetPathModifier.prototype.processPath = function (inputBezier, amount, lineJoin, miterLimit) {
	    var outputBezier = shapePool.newElement();
	    outputBezier.c = inputBezier.c;
	    var count = inputBezier.length();
	
	    if (!inputBezier.c) {
	      count -= 1;
	    }
	
	    var i;
	    var j;
	    var segment;
	    var multiSegments = [];
	
	    for (i = 0; i < count; i += 1) {
	      segment = PolynomialBezier.shapeSegment(inputBezier, i);
	      multiSegments.push(offsetSegmentSplit(segment, amount));
	    }
	
	    if (!inputBezier.c) {
	      for (i = count - 1; i >= 0; i -= 1) {
	        segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
	        multiSegments.push(offsetSegmentSplit(segment, amount));
	      }
	    }
	
	    multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
	
	    var lastPoint = null;
	    var lastSeg = null;
	
	    for (i = 0; i < multiSegments.length; i += 1) {
	      var multiSegment = multiSegments[i];
	      if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
	      lastSeg = multiSegment[multiSegment.length - 1];
	
	      for (j = 0; j < multiSegment.length; j += 1) {
	        segment = multiSegment[j];
	
	        if (lastPoint && pointEqual(segment.points[0], lastPoint)) {
	          outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
	        } else {
	          outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
	        }
	
	        outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
	        lastPoint = segment.points[3];
	      }
	    }
	
	    if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
	    return outputBezier;
	  };
	
	  OffsetPathModifier.prototype.processShapes = function (_isFirstFrame) {
	    var shapePaths;
	    var i;
	    var len = this.shapes.length;
	    var j;
	    var jLen;
	    var amount = this.amount.v;
	    var miterLimit = this.miterLimit.v;
	    var lineJoin = this.lineJoin;
	
	    if (amount !== 0) {
	      var shapeData;
	      var localShapeCollection;
	
	      for (i = 0; i < len; i += 1) {
	        shapeData = this.shapes[i];
	        localShapeCollection = shapeData.localShapeCollection;
	
	        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
	          localShapeCollection.releaseShapes();
	          shapeData.shape._mdf = true;
	          shapePaths = shapeData.shape.paths.shapes;
	          jLen = shapeData.shape.paths._length;
	
	          for (j = 0; j < jLen; j += 1) {
	            localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
	          }
	        }
	
	        shapeData.shape.paths = shapeData.localShapeCollection;
	      }
	    }
	
	    if (!this.dynamicProperties.length) {
	      this._mdf = false;
	    }
	  };
	
	  function getFontProperties(fontData) {
	    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
	    var fWeight = 'normal';
	    var fStyle = 'normal';
	    var len = styles.length;
	    var styleName;
	
	    for (var i = 0; i < len; i += 1) {
	      styleName = styles[i].toLowerCase();
	
	      switch (styleName) {
	        case 'italic':
	          fStyle = 'italic';
	          break;
	
	        case 'bold':
	          fWeight = '700';
	          break;
	
	        case 'black':
	          fWeight = '900';
	          break;
	
	        case 'medium':
	          fWeight = '500';
	          break;
	
	        case 'regular':
	        case 'normal':
	          fWeight = '400';
	          break;
	
	        case 'light':
	        case 'thin':
	          fWeight = '200';
	          break;
	
	        default:
	          break;
	      }
	    }
	
	    return {
	      style: fStyle,
	      weight: fontData.fWeight || fWeight
	    };
	  }
	
	  var FontManager = function () {
	    var maxWaitingTime = 5000;
	    var emptyChar = {
	      w: 0,
	      size: 0,
	      shapes: [],
	      data: {
	        shapes: []
	      }
	    };
	    var combinedCharacters = []; // Hindi characters
	
	    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
	    var BLACK_FLAG_CODE_POINT = 127988;
	    var CANCEL_TAG_CODE_POINT = 917631;
	    var A_TAG_CODE_POINT = 917601;
	    var Z_TAG_CODE_POINT = 917626;
	    var VARIATION_SELECTOR_16_CODE_POINT = 65039;
	    var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
	    var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
	    var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
	    var surrogateModifiers = ['d83cdffb', 'd83cdffc', 'd83cdffd', 'd83cdffe', 'd83cdfff'];
	
	    function trimFontOptions(font) {
	      var familyArray = font.split(',');
	      var i;
	      var len = familyArray.length;
	      var enabledFamilies = [];
	
	      for (i = 0; i < len; i += 1) {
	        if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
	          enabledFamilies.push(familyArray[i]);
	        }
	      }
	
	      return enabledFamilies.join(',');
	    }
	
	    function setUpNode(font, family) {
	      var parentNode = createTag('span'); // Node is invisible to screen readers.
	
	      parentNode.setAttribute('aria-hidden', true);
	      parentNode.style.fontFamily = family;
	      var node = createTag('span'); // Characters that vary significantly among different fonts
	
	      node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen
	
	      parentNode.style.position = 'absolute';
	      parentNode.style.left = '-10000px';
	      parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious
	
	      parentNode.style.fontSize = '300px'; // Reset any font properties
	
	      parentNode.style.fontVariant = 'normal';
	      parentNode.style.fontStyle = 'normal';
	      parentNode.style.fontWeight = 'normal';
	      parentNode.style.letterSpacing = '0';
	      parentNode.appendChild(node);
	      document.body.appendChild(parentNode); // Remember width with no applied web font
	
	      var width = node.offsetWidth;
	      node.style.fontFamily = trimFontOptions(font) + ', ' + family;
	      return {
	        node: node,
	        w: width,
	        parent: parentNode
	      };
	    }
	
	    function checkLoadedFonts() {
	      var i;
	      var len = this.fonts.length;
	      var node;
	      var w;
	      var loadedCount = len;
	
	      for (i = 0; i < len; i += 1) {
	        if (this.fonts[i].loaded) {
	          loadedCount -= 1;
	        } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
	          this.fonts[i].loaded = true;
	        } else {
	          node = this.fonts[i].monoCase.node;
	          w = this.fonts[i].monoCase.w;
	
	          if (node.offsetWidth !== w) {
	            loadedCount -= 1;
	            this.fonts[i].loaded = true;
	          } else {
	            node = this.fonts[i].sansCase.node;
	            w = this.fonts[i].sansCase.w;
	
	            if (node.offsetWidth !== w) {
	              loadedCount -= 1;
	              this.fonts[i].loaded = true;
	            }
	          }
	
	          if (this.fonts[i].loaded) {
	            this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	            this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	          }
	        }
	      }
	
	      if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
	        setTimeout(this.checkLoadedFontsBinded, 20);
	      } else {
	        setTimeout(this.setIsLoadedBinded, 10);
	      }
	    }
	
	    function createHelper(fontData, def) {
	      var engine = document.body && def ? 'svg' : 'canvas';
	      var helper;
	      var fontProps = getFontProperties(fontData);
	
	      if (engine === 'svg') {
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;
	
	        tHelper.setAttribute('font-family', fontData.fFamily);
	        tHelper.setAttribute('font-style', fontProps.style);
	        tHelper.setAttribute('font-weight', fontProps.weight);
	        tHelper.textContent = '1';
	
	        if (fontData.fClass) {
	          tHelper.style.fontFamily = 'inherit';
	          tHelper.setAttribute('class', fontData.fClass);
	        } else {
	          tHelper.style.fontFamily = fontData.fFamily;
	        }
	
	        def.appendChild(tHelper);
	        helper = tHelper;
	      } else {
	        var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
	        tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
	        helper = tCanvasHelper;
	      }
	
	      function measure(text) {
	        if (engine === 'svg') {
	          helper.textContent = text;
	          return helper.getComputedTextLength();
	        }
	
	        return helper.measureText(text).width;
	      }
	
	      return {
	        measureText: measure
	      };
	    }
	
	    function addFonts(fontData, defs) {
	      if (!fontData) {
	        this.isLoaded = true;
	        return;
	      }
	
	      if (this.chars) {
	        this.isLoaded = true;
	        this.fonts = fontData.list;
	        return;
	      }
	
	      if (!document.body) {
	        this.isLoaded = true;
	        fontData.list.forEach(function (data) {
	          data.helper = createHelper(data);
	          data.cache = {};
	        });
	        this.fonts = fontData.list;
	        return;
	      }
	
	      var fontArr = fontData.list;
	      var i;
	      var len = fontArr.length;
	      var _pendingFonts = len;
	
	      for (i = 0; i < len; i += 1) {
	        var shouldLoadFont = true;
	        var loadedSelector;
	        var j;
	        fontArr[i].loaded = false;
	        fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
	        fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
	
	        if (!fontArr[i].fPath) {
	          fontArr[i].loaded = true;
	          _pendingFonts -= 1;
	        } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
	          loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
	
	          if (loadedSelector.length > 0) {
	            shouldLoadFont = false;
	          }
	
	          if (shouldLoadFont) {
	            var s = createTag('style');
	            s.setAttribute('f-forigin', fontArr[i].fOrigin);
	            s.setAttribute('f-origin', fontArr[i].origin);
	            s.setAttribute('f-family', fontArr[i].fFamily);
	            s.type = 'text/css';
	            s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
	            defs.appendChild(s);
	          }
	        } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
	          loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
	
	          for (j = 0; j < loadedSelector.length; j += 1) {
	            if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
	              // Font is already loaded
	              shouldLoadFont = false;
	            }
	          }
	
	          if (shouldLoadFont) {
	            var l = createTag('link');
	            l.setAttribute('f-forigin', fontArr[i].fOrigin);
	            l.setAttribute('f-origin', fontArr[i].origin);
	            l.type = 'text/css';
	            l.rel = 'stylesheet';
	            l.href = fontArr[i].fPath;
	            document.body.appendChild(l);
	          }
	        } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
	          loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
	
	          for (j = 0; j < loadedSelector.length; j += 1) {
	            if (fontArr[i].fPath === loadedSelector[j].src) {
	              // Font is already loaded
	              shouldLoadFont = false;
	            }
	          }
	
	          if (shouldLoadFont) {
	            var sc = createTag('link');
	            sc.setAttribute('f-forigin', fontArr[i].fOrigin);
	            sc.setAttribute('f-origin', fontArr[i].origin);
	            sc.setAttribute('rel', 'stylesheet');
	            sc.setAttribute('href', fontArr[i].fPath);
	            defs.appendChild(sc);
	          }
	        }
	
	        fontArr[i].helper = createHelper(fontArr[i], defs);
	        fontArr[i].cache = {};
	        this.fonts.push(fontArr[i]);
	      }
	
	      if (_pendingFonts === 0) {
	        this.isLoaded = true;
	      } else {
	        // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
	        // Adding this timeout seems to fix it
	        setTimeout(this.checkLoadedFonts.bind(this), 100);
	      }
	    }
	
	    function addChars(chars) {
	      if (!chars) {
	        return;
	      }
	
	      if (!this.chars) {
	        this.chars = [];
	      }
	
	      var i;
	      var len = chars.length;
	      var j;
	      var jLen = this.chars.length;
	      var found;
	
	      for (i = 0; i < len; i += 1) {
	        j = 0;
	        found = false;
	
	        while (j < jLen) {
	          if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
	            found = true;
	          }
	
	          j += 1;
	        }
	
	        if (!found) {
	          this.chars.push(chars[i]);
	          jLen += 1;
	        }
	      }
	    }
	
	    function getCharData(_char, style, font) {
	      var i = 0;
	      var len = this.chars.length;
	
	      while (i < len) {
	        if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) {
	          return this.chars[i];
	        }
	
	        i += 1;
	      }
	
	      if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
	      && !this._warned) {
	        this._warned = true;
	        console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
	      }
	
	      return emptyChar;
	    }
	
	    function measureText(_char2, fontName, size) {
	      var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
	      // to avoid collisions between equal chars
	
	      var index = _char2;
	
	      if (!fontData.cache[index]) {
	        var tHelper = fontData.helper;
	
	        if (_char2 === ' ') {
	          var doubleSize = tHelper.measureText('|' + _char2 + '|');
	          var singleSize = tHelper.measureText('||');
	          fontData.cache[index] = (doubleSize - singleSize) / 100;
	        } else {
	          fontData.cache[index] = tHelper.measureText(_char2) / 100;
	        }
	      }
	
	      return fontData.cache[index] * size;
	    }
	
	    function getFontByName(name) {
	      var i = 0;
	      var len = this.fonts.length;
	
	      while (i < len) {
	        if (this.fonts[i].fName === name) {
	          return this.fonts[i];
	        }
	
	        i += 1;
	      }
	
	      return this.fonts[0];
	    }
	
	    function getCodePoint(string) {
	      var codePoint = 0;
	      var first = string.charCodeAt(0);
	
	      if (first >= 0xD800 && first <= 0xDBFF) {
	        var second = string.charCodeAt(1);
	
	        if (second >= 0xDC00 && second <= 0xDFFF) {
	          codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	        }
	      }
	
	      return codePoint;
	    } // Skin tone modifiers
	
	
	    function isModifier(firstCharCode, secondCharCode) {
	      var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
	      return surrogateModifiers.indexOf(sum) !== -1;
	    }
	
	    function isZeroWidthJoiner(charCode) {
	      return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
	    } // This codepoint may change the appearance of the preceding character.
	    // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
	    // as a colorful image as compared to a monochrome text variant.
	
	
	    function isVariationSelector(charCode) {
	      return charCode === VARIATION_SELECTOR_16_CODE_POINT;
	    } // The regional indicator symbols are a set of 26 alphabetic Unicode
	    /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
	    // two-letter country codes in a way that allows optional special treatment.
	
	
	    function isRegionalCode(string) {
	      var codePoint = getCodePoint(string);
	
	      if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) {
	        return true;
	      }
	
	      return false;
	    } // Some Emoji implementations represent combinations of
	    // two “regional indicator” letters as a single flag symbol.
	
	
	    function isFlagEmoji(string) {
	      return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
	    }
	
	    function isCombinedCharacter(_char3) {
	      return combinedCharacters.indexOf(_char3) !== -1;
	    } // Regional flags start with a BLACK_FLAG_CODE_POINT
	    // folowed by 5 chars in the TAG range
	    // and end with a CANCEL_TAG_CODE_POINT
	
	
	    function isRegionalFlag(text, index) {
	      var codePoint = getCodePoint(text.substr(index, 2));
	
	      if (codePoint !== BLACK_FLAG_CODE_POINT) {
	        return false;
	      }
	
	      var count = 0;
	      index += 2;
	
	      while (count < 5) {
	        codePoint = getCodePoint(text.substr(index, 2));
	
	        if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) {
	          return false;
	        }
	
	        count += 1;
	        index += 2;
	      }
	
	      return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
	    }
	
	    function setIsLoaded() {
	      this.isLoaded = true;
	    }
	
	    var Font = function Font() {
	      this.fonts = [];
	      this.chars = null;
	      this.typekitLoaded = 0;
	      this.isLoaded = false;
	      this._warned = false;
	      this.initTime = Date.now();
	      this.setIsLoadedBinded = this.setIsLoaded.bind(this);
	      this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
	    };
	
	    Font.isModifier = isModifier;
	    Font.isZeroWidthJoiner = isZeroWidthJoiner;
	    Font.isFlagEmoji = isFlagEmoji;
	    Font.isRegionalCode = isRegionalCode;
	    Font.isCombinedCharacter = isCombinedCharacter;
	    Font.isRegionalFlag = isRegionalFlag;
	    Font.isVariationSelector = isVariationSelector;
	    Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
	    var fontPrototype = {
	      addChars: addChars,
	      addFonts: addFonts,
	      getCharData: getCharData,
	      getFontByName: getFontByName,
	      measureText: measureText,
	      checkLoadedFonts: checkLoadedFonts,
	      setIsLoaded: setIsLoaded
	    };
	    Font.prototype = fontPrototype;
	    return Font;
	  }();
	
	  function SlotManager(animationData) {
	    this.animationData = animationData;
	  }
	
	  SlotManager.prototype.getProp = function (data) {
	    if (this.animationData.slots && this.animationData.slots[data.sid]) {
	      return Object.assign(data, this.animationData.slots[data.sid].p);
	    }
	
	    return data;
	  };
	
	  function slotFactory(animationData) {
	    return new SlotManager(animationData);
	  }
	
	  function RenderableElement() {}
	
	  RenderableElement.prototype = {
	    initRenderable: function initRenderable() {
	      // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
	      this.isInRange = false; // layer's display state
	
	      this.hidden = false; // If layer's transparency equals 0, it can be hidden
	
	      this.isTransparent = false; // list of animated components
	
	      this.renderableComponents = [];
	    },
	    addRenderableComponent: function addRenderableComponent(component) {
	      if (this.renderableComponents.indexOf(component) === -1) {
	        this.renderableComponents.push(component);
	      }
	    },
	    removeRenderableComponent: function removeRenderableComponent(component) {
	      if (this.renderableComponents.indexOf(component) !== -1) {
	        this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
	      }
	    },
	    prepareRenderableFrame: function prepareRenderableFrame(num) {
	      this.checkLayerLimits(num);
	    },
	    checkTransparency: function checkTransparency() {
	      if (this.finalTransform.mProp.o.v <= 0) {
	        if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
	          this.isTransparent = true;
	          this.hide();
	        }
	      } else if (this.isTransparent) {
	        this.isTransparent = false;
	        this.show();
	      }
	    },
	
	    /**
	       * @function
	       * Initializes frame related properties.
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       *
	       */
	    checkLayerLimits: function checkLayerLimits(num) {
	      if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
	        if (this.isInRange !== true) {
	          this.globalData._mdf = true;
	          this._mdf = true;
	          this.isInRange = true;
	          this.show();
	        }
	      } else if (this.isInRange !== false) {
	        this.globalData._mdf = true;
	        this.isInRange = false;
	        this.hide();
	      }
	    },
	    renderRenderable: function renderRenderable() {
	      var i;
	      var len = this.renderableComponents.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.renderableComponents[i].renderFrame(this._isFirstFrame);
	      }
	      /* this.maskManager.renderFrame(this.finalTransform.mat);
	          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */
	
	    },
	    sourceRectAtTime: function sourceRectAtTime() {
	      return {
	        top: 0,
	        left: 0,
	        width: 100,
	        height: 100
	      };
	    },
	    getLayerSize: function getLayerSize() {
	      if (this.data.ty === 5) {
	        return {
	          w: this.data.textData.width,
	          h: this.data.textData.height
	        };
	      }
	
	      return {
	        w: this.data.width,
	        h: this.data.height
	      };
	    }
	  };
	
	  var getBlendMode = function () {
	    var blendModeEnums = {
	      0: 'source-over',
	      1: 'multiply',
	      2: 'screen',
	      3: 'overlay',
	      4: 'darken',
	      5: 'lighten',
	      6: 'color-dodge',
	      7: 'color-burn',
	      8: 'hard-light',
	      9: 'soft-light',
	      10: 'difference',
	      11: 'exclusion',
	      12: 'hue',
	      13: 'saturation',
	      14: 'color',
	      15: 'luminosity'
	    };
	    return function (mode) {
	      return blendModeEnums[mode] || '';
	    };
	  }();
	
	  function SliderEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function AngleEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function ColorEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
	  }
	
	  function PointEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
	  }
	
	  function LayerIndexEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function MaskIndexEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function CheckboxEffect(data, elem, container) {
	    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
	  }
	
	  function NoValueEffect() {
	    this.p = {};
	  }
	
	  function EffectsManager(data, element) {
	    var effects = data.ef || [];
	    this.effectElements = [];
	    var i;
	    var len = effects.length;
	    var effectItem;
	
	    for (i = 0; i < len; i += 1) {
	      effectItem = new GroupEffect(effects[i], element);
	      this.effectElements.push(effectItem);
	    }
	  }
	
	  function GroupEffect(data, element) {
	    this.init(data, element);
	  }
	
	  extendPrototype([DynamicPropertyContainer], GroupEffect);
	  GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
	
	  GroupEffect.prototype.init = function (data, element) {
	    this.data = data;
	    this.effectElements = [];
	    this.initDynamicPropertyContainer(element);
	    var i;
	    var len = this.data.ef.length;
	    var eff;
	    var effects = this.data.ef;
	
	    for (i = 0; i < len; i += 1) {
	      eff = null;
	
	      switch (effects[i].ty) {
	        case 0:
	          eff = new SliderEffect(effects[i], element, this);
	          break;
	
	        case 1:
	          eff = new AngleEffect(effects[i], element, this);
	          break;
	
	        case 2:
	          eff = new ColorEffect(effects[i], element, this);
	          break;
	
	        case 3:
	          eff = new PointEffect(effects[i], element, this);
	          break;
	
	        case 4:
	        case 7:
	          eff = new CheckboxEffect(effects[i], element, this);
	          break;
	
	        case 10:
	          eff = new LayerIndexEffect(effects[i], element, this);
	          break;
	
	        case 11:
	          eff = new MaskIndexEffect(effects[i], element, this);
	          break;
	
	        case 5:
	          eff = new EffectsManager(effects[i], element, this);
	          break;
	        // case 6:
	
	        default:
	          eff = new NoValueEffect(effects[i], element, this);
	          break;
	      }
	
	      if (eff) {
	        this.effectElements.push(eff);
	      }
	    }
	  };
	
	  function BaseElement() {}
	
	  BaseElement.prototype = {
	    checkMasks: function checkMasks() {
	      if (!this.data.hasMask) {
	        return false;
	      }
	
	      var i = 0;
	      var len = this.data.masksProperties.length;
	
	      while (i < len) {
	        if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) {
	          return true;
	        }
	
	        i += 1;
	      }
	
	      return false;
	    },
	    initExpressions: function initExpressions() {
	      var expressionsInterfaces = getExpressionInterfaces();
	
	      if (!expressionsInterfaces) {
	        return;
	      }
	
	      var LayerExpressionInterface = expressionsInterfaces('layer');
	      var EffectsExpressionInterface = expressionsInterfaces('effects');
	      var ShapeExpressionInterface = expressionsInterfaces('shape');
	      var TextExpressionInterface = expressionsInterfaces('text');
	      var CompExpressionInterface = expressionsInterfaces('comp');
	      this.layerInterface = LayerExpressionInterface(this);
	
	      if (this.data.hasMask && this.maskManager) {
	        this.layerInterface.registerMaskInterface(this.maskManager);
	      }
	
	      var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
	      this.layerInterface.registerEffectsInterface(effectsInterface);
	
	      if (this.data.ty === 0 || this.data.xt) {
	        this.compInterface = CompExpressionInterface(this);
	      } else if (this.data.ty === 4) {
	        this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
	        this.layerInterface.content = this.layerInterface.shapeInterface;
	      } else if (this.data.ty === 5) {
	        this.layerInterface.textInterface = TextExpressionInterface(this);
	        this.layerInterface.text = this.layerInterface.textInterface;
	      }
	    },
	    setBlendMode: function setBlendMode() {
	      var blendModeValue = getBlendMode(this.data.bm);
	      var elem = this.baseElement || this.layerElement;
	      elem.style['mix-blend-mode'] = blendModeValue;
	    },
	    initBaseData: function initBaseData(data, globalData, comp) {
	      this.globalData = globalData;
	      this.comp = comp;
	      this.data = data;
	      this.layerId = createElementID(); // Stretch factor for old animations missing this property.
	
	      if (!this.data.sr) {
	        this.data.sr = 1;
	      } // effects manager
	
	
	      this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
	    },
	    getType: function getType() {
	      return this.type;
	    },
	    sourceRectAtTime: function sourceRectAtTime() {}
	  };
	
	  /**
	   * @file
	   * Handles element's layer frame update.
	   * Checks layer in point and out point
	   *
	   */
	  function FrameElement() {}
	
	  FrameElement.prototype = {
	    /**
	       * @function
	       * Initializes frame related properties.
	       *
	       */
	    initFrame: function initFrame() {
	      // set to true when inpoint is rendered
	      this._isFirstFrame = false; // list of animated properties
	
	      this.dynamicProperties = []; // If layer has been modified in current tick this will be true
	
	      this._mdf = false;
	    },
	
	    /**
	       * @function
	       * Calculates all dynamic values
	       *
	       * @param {number} num
	       * current frame number in Layer's time
	       * @param {boolean} isVisible
	       * if layers is currently in range
	       *
	       */
	    prepareProperties: function prepareProperties(num, isVisible) {
	      var i;
	      var len = this.dynamicProperties.length;
	
	      for (i = 0; i < len; i += 1) {
	        if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
	          this.dynamicProperties[i].getValue();
	
	          if (this.dynamicProperties[i]._mdf) {
	            this.globalData._mdf = true;
	            this._mdf = true;
	          }
	        }
	      }
	    },
	    addDynamicProperty: function addDynamicProperty(prop) {
	      if (this.dynamicProperties.indexOf(prop) === -1) {
	        this.dynamicProperties.push(prop);
	      }
	    }
	  };
	
	  function FootageElement(data, globalData, comp) {
	    this.initFrame();
	    this.initRenderable();
	    this.assetData = globalData.getAssetData(data.refId);
	    this.footageData = globalData.imageLoader.getAsset(this.assetData);
	    this.initBaseData(data, globalData, comp);
	  }
	
	  FootageElement.prototype.prepareFrame = function () {};
	
	  extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);
	
	  FootageElement.prototype.getBaseElement = function () {
	    return null;
	  };
	
	  FootageElement.prototype.renderFrame = function () {};
	
	  FootageElement.prototype.destroy = function () {};
	
	  FootageElement.prototype.initExpressions = function () {
	    var expressionsInterfaces = getExpressionInterfaces();
	
	    if (!expressionsInterfaces) {
	      return;
	    }
	
	    var FootageInterface = expressionsInterfaces('footage');
	    this.layerInterface = FootageInterface(this);
	  };
	
	  FootageElement.prototype.getFootageData = function () {
	    return this.footageData;
	  };
	
	  function AudioElement(data, globalData, comp) {
	    this.initFrame();
	    this.initRenderable();
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initBaseData(data, globalData, comp);
	    this._isPlaying = false;
	    this._canPlay = false;
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.audio = this.globalData.audioController.createAudio(assetPath);
	    this._currentTime = 0;
	    this.globalData.audioController.addAudio(this);
	    this._volumeMultiplier = 1;
	    this._volume = 1;
	    this._previousVolume = null;
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	    this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
	      k: [100]
	    }, 1, 0.01, this);
	  }
	
	  AudioElement.prototype.prepareFrame = function (num) {
	    this.prepareRenderableFrame(num, true);
	    this.prepareProperties(num, true);
	
	    if (!this.tm._placeholder) {
	      var timeRemapped = this.tm.v;
	      this._currentTime = timeRemapped;
	    } else {
	      this._currentTime = num / this.data.sr;
	    }
	
	    this._volume = this.lv.v[0];
	    var totalVolume = this._volume * this._volumeMultiplier;
	
	    if (this._previousVolume !== totalVolume) {
	      this._previousVolume = totalVolume;
	      this.audio.volume(totalVolume);
	    }
	  };
	
	  extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);
	
	  AudioElement.prototype.renderFrame = function () {
	    if (this.isInRange && this._canPlay) {
	      if (!this._isPlaying) {
	        this.audio.play();
	        this.audio.seek(this._currentTime / this.globalData.frameRate);
	        this._isPlaying = true;
	      } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) {
	        this.audio.seek(this._currentTime / this.globalData.frameRate);
	      }
	    }
	  };
	
	  AudioElement.prototype.show = function () {// this.audio.play()
	  };
	
	  AudioElement.prototype.hide = function () {
	    this.audio.pause();
	    this._isPlaying = false;
	  };
	
	  AudioElement.prototype.pause = function () {
	    this.audio.pause();
	    this._isPlaying = false;
	    this._canPlay = false;
	  };
	
	  AudioElement.prototype.resume = function () {
	    this._canPlay = true;
	  };
	
	  AudioElement.prototype.setRate = function (rateValue) {
	    this.audio.rate(rateValue);
	  };
	
	  AudioElement.prototype.volume = function (volumeValue) {
	    this._volumeMultiplier = volumeValue;
	    this._previousVolume = volumeValue * this._volume;
	    this.audio.volume(this._previousVolume);
	  };
	
	  AudioElement.prototype.getBaseElement = function () {
	    return null;
	  };
	
	  AudioElement.prototype.destroy = function () {};
	
	  AudioElement.prototype.sourceRectAtTime = function () {};
	
	  AudioElement.prototype.initExpressions = function () {};
	
	  function BaseRenderer() {}
	
	  BaseRenderer.prototype.checkLayers = function (num) {
	    var i;
	    var len = this.layers.length;
	    var data;
	    this.completeLayers = true;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (!this.elements[i]) {
	        data = this.layers[i];
	
	        if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) {
	          this.buildItem(i);
	        }
	      }
	
	      this.completeLayers = this.elements[i] ? this.completeLayers : false;
	    }
	
	    this.checkPendingElements();
	  };
	
	  BaseRenderer.prototype.createItem = function (layer) {
	    switch (layer.ty) {
	      case 2:
	        return this.createImage(layer);
	
	      case 0:
	        return this.createComp(layer);
	
	      case 1:
	        return this.createSolid(layer);
	
	      case 3:
	        return this.createNull(layer);
	
	      case 4:
	        return this.createShape(layer);
	
	      case 5:
	        return this.createText(layer);
	
	      case 6:
	        return this.createAudio(layer);
	
	      case 13:
	        return this.createCamera(layer);
	
	      case 15:
	        return this.createFootage(layer);
	
	      default:
	        return this.createNull(layer);
	    }
	  };
	
	  BaseRenderer.prototype.createCamera = function () {
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	  };
	
	  BaseRenderer.prototype.createAudio = function (data) {
	    return new AudioElement(data, this.globalData, this);
	  };
	
	  BaseRenderer.prototype.createFootage = function (data) {
	    return new FootageElement(data, this.globalData, this);
	  };
	
	  BaseRenderer.prototype.buildAllItems = function () {
	    var i;
	    var len = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.buildItem(i);
	    }
	
	    this.checkPendingElements();
	  };
	
	  BaseRenderer.prototype.includeLayers = function (newLayers) {
	    this.completeLayers = false;
	    var i;
	    var len = newLayers.length;
	    var j;
	    var jLen = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      j = 0;
	
	      while (j < jLen) {
	        if (this.layers[j].id === newLayers[i].id) {
	          this.layers[j] = newLayers[i];
	          break;
	        }
	
	        j += 1;
	      }
	    }
	  };
	
	  BaseRenderer.prototype.setProjectInterface = function (pInterface) {
	    this.globalData.projectInterface = pInterface;
	  };
	
	  BaseRenderer.prototype.initItems = function () {
	    if (!this.globalData.progressiveLoad) {
	      this.buildAllItems();
	    }
	  };
	
	  BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
	    var elements = this.elements;
	    var layers = this.layers;
	    var i = 0;
	    var len = layers.length;
	
	    while (i < len) {
	      if (layers[i].ind == parentName) {
	        // eslint-disable-line eqeqeq
	        if (!elements[i] || elements[i] === true) {
	          this.buildItem(i);
	          this.addPendingElement(element);
	        } else {
	          hierarchy.push(elements[i]);
	          elements[i].setAsParent();
	
	          if (layers[i].parent !== undefined) {
	            this.buildElementParenting(element, layers[i].parent, hierarchy);
	          } else {
	            element.setHierarchy(hierarchy);
	          }
	        }
	      }
	
	      i += 1;
	    }
	  };
	
	  BaseRenderer.prototype.addPendingElement = function (element) {
	    this.pendingElements.push(element);
	  };
	
	  BaseRenderer.prototype.searchExtraCompositions = function (assets) {
	    var i;
	    var len = assets.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (assets[i].xt) {
	        var comp = this.createComp(assets[i]);
	        comp.initExpressions();
	        this.globalData.projectInterface.registerComposition(comp);
	      }
	    }
	  };
	
	  BaseRenderer.prototype.getElementById = function (ind) {
	    var i;
	    var len = this.elements.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i].data.ind === ind) {
	        return this.elements[i];
	      }
	    }
	
	    return null;
	  };
	
	  BaseRenderer.prototype.getElementByPath = function (path) {
	    var pathValue = path.shift();
	    var element;
	
	    if (typeof pathValue === 'number') {
	      element = this.elements[pathValue];
	    } else {
	      var i;
	      var len = this.elements.length;
	
	      for (i = 0; i < len; i += 1) {
	        if (this.elements[i].data.nm === pathValue) {
	          element = this.elements[i];
	          break;
	        }
	      }
	    }
	
	    if (path.length === 0) {
	      return element;
	    }
	
	    return element.getElementByPath(path);
	  };
	
	  BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
	    this.globalData.fontManager = new FontManager();
	    this.globalData.slotManager = slotFactory(animData);
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.imageLoader = this.animationItem.imagePreloader;
	    this.globalData.audioController = this.animationItem.audioController;
	    this.globalData.frameId = 0;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	      w: animData.w,
	      h: animData.h
	    };
	  };
	
	  var effectTypes = {
	    TRANSFORM_EFFECT: 'transformEFfect'
	  };
	
	  function TransformElement() {}
	
	  TransformElement.prototype = {
	    initTransform: function initTransform() {
	      var mat = new Matrix();
	      this.finalTransform = {
	        mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
	          o: 0
	        },
	        _matMdf: false,
	        _localMatMdf: false,
	        _opMdf: false,
	        mat: mat,
	        localMat: mat,
	        localOpacity: 1
	      };
	
	      if (this.data.ao) {
	        this.finalTransform.mProp.autoOriented = true;
	      } // TODO: check TYPE 11: Guided elements
	
	
	      if (this.data.ty !== 11) {// this.createElements();
	      }
	    },
	    renderTransform: function renderTransform() {
	      this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
	      this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
	
	      if (this.hierarchy) {
	        var mat;
	        var finalMat = this.finalTransform.mat;
	        var i = 0;
	        var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
	
	        if (!this.finalTransform._matMdf) {
	          while (i < len) {
	            if (this.hierarchy[i].finalTransform.mProp._mdf) {
	              this.finalTransform._matMdf = true;
	              break;
	            }
	
	            i += 1;
	          }
	        }
	
	        if (this.finalTransform._matMdf) {
	          mat = this.finalTransform.mProp.v.props;
	          finalMat.cloneFromProps(mat);
	
	          for (i = 0; i < len; i += 1) {
	            finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
	          }
	        }
	      }
	
	      if (this.finalTransform._matMdf) {
	        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
	      }
	
	      if (this.finalTransform._opMdf) {
	        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
	      }
	    },
	    renderLocalTransform: function renderLocalTransform() {
	      if (this.localTransforms) {
	        var i = 0;
	        var len = this.localTransforms.length;
	        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
	
	        if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) {
	          while (i < len) {
	            if (this.localTransforms[i]._mdf) {
	              this.finalTransform._localMatMdf = true;
	            }
	
	            if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
	              this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
	              this.finalTransform._opMdf = true;
	            }
	
	            i += 1;
	          }
	        }
	
	        if (this.finalTransform._localMatMdf) {
	          var localMat = this.finalTransform.localMat;
	          this.localTransforms[0].matrix.clone(localMat);
	
	          for (i = 1; i < len; i += 1) {
	            var lmat = this.localTransforms[i].matrix;
	            localMat.multiply(lmat);
	          }
	
	          localMat.multiply(this.finalTransform.mat);
	        }
	
	        if (this.finalTransform._opMdf) {
	          var localOp = this.finalTransform.localOpacity;
	
	          for (i = 0; i < len; i += 1) {
	            localOp *= this.localTransforms[i].opacity * 0.01;
	          }
	
	          this.finalTransform.localOpacity = localOp;
	        }
	      }
	    },
	    searchEffectTransforms: function searchEffectTransforms() {
	      if (this.renderableEffectsManager) {
	        var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
	
	        if (transformEffects.length) {
	          this.localTransforms = [];
	          this.finalTransform.localMat = new Matrix();
	          var i = 0;
	          var len = transformEffects.length;
	
	          for (i = 0; i < len; i += 1) {
	            this.localTransforms.push(transformEffects[i]);
	          }
	        }
	      }
	    },
	    globalToLocal: function globalToLocal(pt) {
	      var transforms = [];
	      transforms.push(this.finalTransform);
	      var flag = true;
	      var comp = this.comp;
	
	      while (flag) {
	        if (comp.finalTransform) {
	          if (comp.data.hasMask) {
	            transforms.splice(0, 0, comp.finalTransform);
	          }
	
	          comp = comp.comp;
	        } else {
	          flag = false;
	        }
	      }
	
	      var i;
	      var len = transforms.length;
	      var ptNew;
	
	      for (i = 0; i < len; i += 1) {
	        ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	
	        pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
	      }
	
	      return pt;
	    },
	    mHelper: new Matrix()
	  };
	
	  function MaskElement(data, element, globalData) {
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties || [];
	    this.maskElement = null;
	    var defs = this.globalData.defs;
	    var i;
	    var len = this.masksProperties ? this.masksProperties.length : 0;
	    this.viewData = createSizedArray(len);
	    this.solidPath = '';
	    var path;
	    var properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j;
	    var jLen;
	    var layerId = createElementID();
	    var rect;
	    var expansor;
	    var feMorph;
	    var x;
	    var maskType = 'clipPath';
	    var maskRef = 'clip-path';
	
	    for (i = 0; i < len; i += 1) {
	      if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
	        maskType = 'mask';
	        maskRef = 'mask';
	      }
	
	      if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
	        rect = createNS('rect');
	        rect.setAttribute('fill', '#ffffff');
	        rect.setAttribute('width', this.element.comp.data.w || 0);
	        rect.setAttribute('height', this.element.comp.data.h || 0);
	        currentMasks.push(rect);
	      } else {
	        rect = null;
	      }
	
	      path = createNS('path');
	
	      if (properties[i].mode === 'n') {
	        // TODO move this to a factory or to a constructor
	        this.viewData[i] = {
	          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
	          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
	          elem: path,
	          lastPath: ''
	        };
	        defs.appendChild(path);
	      } else {
	        count += 1;
	        path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
	        path.setAttribute('clip-rule', 'nonzero');
	        var filterID;
	
	        if (properties[i].x.k !== 0) {
	          maskType = 'mask';
	          maskRef = 'mask';
	          x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
	          filterID = createElementID();
	          expansor = createNS('filter');
	          expansor.setAttribute('id', filterID);
	          feMorph = createNS('feMorphology');
	          feMorph.setAttribute('operator', 'erode');
	          feMorph.setAttribute('in', 'SourceGraphic');
	          feMorph.setAttribute('radius', '0');
	          expansor.appendChild(feMorph);
	          defs.appendChild(expansor);
	          path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
	        } else {
	          feMorph = null;
	          x = null;
	        } // TODO move this to a factory or to a constructor
	
	
	        this.storedData[i] = {
	          elem: path,
	          x: x,
	          expan: feMorph,
	          lastPath: '',
	          lastOperator: '',
	          filterId: filterID,
	          lastRadius: 0
	        };
	
	        if (properties[i].mode === 'i') {
	          jLen = currentMasks.length;
	          var g = createNS('g');
	
	          for (j = 0; j < jLen; j += 1) {
	            g.appendChild(currentMasks[j]);
	          }
	
	          var mask = createNS('mask');
	          mask.setAttribute('mask-type', 'alpha');
	          mask.setAttribute('id', layerId + '_' + count);
	          mask.appendChild(path);
	          defs.appendChild(mask);
	          g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
	          currentMasks.length = 0;
	          currentMasks.push(g);
	        } else {
	          currentMasks.push(path);
	        }
	
	        if (properties[i].inv && !this.solidPath) {
	          this.solidPath = this.createLayerSolidPath();
	        } // TODO move this to a factory or to a constructor
	
	
	        this.viewData[i] = {
	          elem: path,
	          lastPath: '',
	          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
	          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
	          invRect: rect
	        };
	
	        if (!this.viewData[i].prop.k) {
	          this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
	        }
	      }
	    }
	
	    this.maskElement = createNS(maskType);
	    len = currentMasks.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.maskElement.appendChild(currentMasks[i]);
	    }
	
	    if (count > 0) {
	      this.maskElement.setAttribute('id', layerId);
	      this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
	      defs.appendChild(this.maskElement);
	    }
	
	    if (this.viewData.length) {
	      this.element.addRenderableComponent(this);
	    }
	  }
	
	  MaskElement.prototype.getMaskProperty = function (pos) {
	    return this.viewData[pos].prop;
	  };
	
	  MaskElement.prototype.renderFrame = function (isFirstFrame) {
	    var finalMat = this.element.finalTransform.mat;
	    var i;
	    var len = this.masksProperties.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.viewData[i].prop._mdf || isFirstFrame) {
	        this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
	      }
	
	      if (this.viewData[i].op._mdf || isFirstFrame) {
	        this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
	      }
	
	      if (this.masksProperties[i].mode !== 'n') {
	        if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
	          this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
	        }
	
	        if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
	          var feMorph = this.storedData[i].expan;
	
	          if (this.storedData[i].x.v < 0) {
	            if (this.storedData[i].lastOperator !== 'erode') {
	              this.storedData[i].lastOperator = 'erode';
	              this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
	            }
	
	            feMorph.setAttribute('radius', -this.storedData[i].x.v);
	          } else {
	            if (this.storedData[i].lastOperator !== 'dilate') {
	              this.storedData[i].lastOperator = 'dilate';
	              this.storedData[i].elem.setAttribute('filter', null);
	            }
	
	            this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
	          }
	        }
	      }
	    }
	  };
	
	  MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	  };
	
	  MaskElement.prototype.createLayerSolidPath = function () {
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w;
	    path += ' v' + this.globalData.compSize.h;
	    path += ' h-' + this.globalData.compSize.w;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	  };
	
	  MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
	    var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
	    var i;
	    var len;
	    len = pathNodes._length;
	
	    for (i = 1; i < len; i += 1) {
	      // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
	    } // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	
	
	    if (pathNodes.c && len > 1) {
	      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
	    } // pathNodes.__renderedString = pathString;
	
	
	    if (viewData.lastPath !== pathString) {
	      var pathShapeValue = '';
	
	      if (viewData.elem) {
	        if (pathNodes.c) {
	          pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
	        }
	
	        viewData.elem.setAttribute('d', pathShapeValue);
	      }
	
	      viewData.lastPath = pathString;
	    }
	  };
	
	  MaskElement.prototype.destroy = function () {
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	  };
	
	  var filtersFactory = function () {
	    var ob = {};
	    ob.createFilter = createFilter;
	    ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
	
	    function createFilter(filId, skipCoordinates) {
	      var fil = createNS('filter');
	      fil.setAttribute('id', filId);
	
	      if (skipCoordinates !== true) {
	        fil.setAttribute('filterUnits', 'objectBoundingBox');
	        fil.setAttribute('x', '0%');
	        fil.setAttribute('y', '0%');
	        fil.setAttribute('width', '100%');
	        fil.setAttribute('height', '100%');
	      }
	
	      return fil;
	    }
	
	    function createAlphaToLuminanceFilter() {
	      var feColorMatrix = createNS('feColorMatrix');
	      feColorMatrix.setAttribute('type', 'matrix');
	      feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	      feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	      return feColorMatrix;
	    }
	
	    return ob;
	  }();
	
	  var featureSupport = function () {
	    var ob = {
	      maskType: true,
	      svgLumaHidden: true,
	      offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
	    };
	
	    if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
	      ob.maskType = false;
	    }
	
	    if (/firefox/i.test(navigator.userAgent)) {
	      ob.svgLumaHidden = false;
	    }
	
	    return ob;
	  }();
	
	  var registeredEffects$1 = {};
	  var idPrefix = 'filter_result_';
	
	  function SVGEffects(elem) {
	    var i;
	    var source = 'SourceGraphic';
	    var len = elem.data.ef ? elem.data.ef.length : 0;
	    var filId = createElementID();
	    var fil = filtersFactory.createFilter(filId, true);
	    var count = 0;
	    this.filters = [];
	    var filterManager;
	
	    for (i = 0; i < len; i += 1) {
	      filterManager = null;
	      var type = elem.data.ef[i].ty;
	
	      if (registeredEffects$1[type]) {
	        var Effect = registeredEffects$1[type].effect;
	        filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
	        source = idPrefix + count;
	
	        if (registeredEffects$1[type].countsAsEffect) {
	          count += 1;
	        }
	      }
	
	      if (filterManager) {
	        this.filters.push(filterManager);
	      }
	    }
	
	    if (count) {
	      elem.globalData.defs.appendChild(fil);
	      elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	    }
	
	    if (this.filters.length) {
	      elem.addRenderableComponent(this);
	    }
	  }
	
	  SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
	    var i;
	    var len = this.filters.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.filters[i].renderFrame(_isFirstFrame);
	    }
	  };
	
	  SVGEffects.prototype.getEffects = function (type) {
	    var i;
	    var len = this.filters.length;
	    var effects = [];
	
	    for (i = 0; i < len; i += 1) {
	      if (this.filters[i].type === type) {
	        effects.push(this.filters[i]);
	      }
	    }
	
	    return effects;
	  };
	
	  function registerEffect$1(id, effect, countsAsEffect) {
	    registeredEffects$1[id] = {
	      effect: effect,
	      countsAsEffect: countsAsEffect
	    };
	  }
	
	  function SVGBaseElement() {}
	
	  SVGBaseElement.prototype = {
	    initRendererElement: function initRendererElement() {
	      this.layerElement = createNS('g');
	    },
	    createContainerElements: function createContainerElements() {
	      this.matteElement = createNS('g');
	      this.transformedElement = this.layerElement;
	      this.maskedElement = this.layerElement;
	      this._sizeChanged = false;
	      var layerElementParent = null; // If this layer acts as a mask for the following layer
	
	      if (this.data.td) {
	        this.matteMasks = {};
	        var gg = createNS('g');
	        gg.setAttribute('id', this.layerId);
	        gg.appendChild(this.layerElement);
	        layerElementParent = gg;
	        this.globalData.defs.appendChild(gg);
	      } else if (this.data.tt) {
	        this.matteElement.appendChild(this.layerElement);
	        layerElementParent = this.matteElement;
	        this.baseElement = this.matteElement;
	      } else {
	        this.baseElement = this.layerElement;
	      }
	
	      if (this.data.ln) {
	        this.layerElement.setAttribute('id', this.data.ln);
	      }
	
	      if (this.data.cl) {
	        this.layerElement.setAttribute('class', this.data.cl);
	      } // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
	
	
	      if (this.data.ty === 0 && !this.data.hd) {
	        var cp = createNS('clipPath');
	        var pt = createNS('path');
	        pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
	        var clipId = createElementID();
	        cp.setAttribute('id', clipId);
	        cp.appendChild(pt);
	        this.globalData.defs.appendChild(cp);
	
	        if (this.checkMasks()) {
	          var cpGroup = createNS('g');
	          cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
	          cpGroup.appendChild(this.layerElement);
	          this.transformedElement = cpGroup;
	
	          if (layerElementParent) {
	            layerElementParent.appendChild(this.transformedElement);
	          } else {
	            this.baseElement = this.transformedElement;
	          }
	        } else {
	          this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
	        }
	      }
	
	      if (this.data.bm !== 0) {
	        this.setBlendMode();
	      }
	    },
	    renderElement: function renderElement() {
	      if (this.finalTransform._localMatMdf) {
	        this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
	      }
	
	      if (this.finalTransform._opMdf) {
	        this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
	      }
	    },
	    destroyBaseElement: function destroyBaseElement() {
	      this.layerElement = null;
	      this.matteElement = null;
	      this.maskManager.destroy();
	    },
	    getBaseElement: function getBaseElement() {
	      if (this.data.hd) {
	        return null;
	      }
	
	      return this.baseElement;
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new MaskElement(this.data, this, this.globalData);
	      this.renderableEffectsManager = new SVGEffects(this);
	      this.searchEffectTransforms();
	    },
	    getMatte: function getMatte(matteType) {
	      // This should not be a common case. But for backward compatibility, we'll create the matte object.
	      // It solves animations that have two consecutive layers marked as matte masks.
	      // Which is an undefined behavior in AE.
	      if (!this.matteMasks) {
	        this.matteMasks = {};
	      }
	
	      if (!this.matteMasks[matteType]) {
	        var id = this.layerId + '_' + matteType;
	        var filId;
	        var fil;
	        var useElement;
	        var gg;
	
	        if (matteType === 1 || matteType === 3) {
	          var masker = createNS('mask');
	          masker.setAttribute('id', id);
	          masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
	          useElement = createNS('use');
	          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
	          masker.appendChild(useElement);
	          this.globalData.defs.appendChild(masker);
	
	          if (!featureSupport.maskType && matteType === 1) {
	            masker.setAttribute('mask-type', 'luminance');
	            filId = createElementID();
	            fil = filtersFactory.createFilter(filId);
	            this.globalData.defs.appendChild(fil);
	            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	            gg = createNS('g');
	            gg.appendChild(useElement);
	            masker.appendChild(gg);
	            gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	          }
	        } else if (matteType === 2) {
	          var maskGroup = createNS('mask');
	          maskGroup.setAttribute('id', id);
	          maskGroup.setAttribute('mask-type', 'alpha');
	          var maskGrouper = createNS('g');
	          maskGroup.appendChild(maskGrouper);
	          filId = createElementID();
	          fil = filtersFactory.createFilter(filId); /// /
	
	          var feCTr = createNS('feComponentTransfer');
	          feCTr.setAttribute('in', 'SourceGraphic');
	          fil.appendChild(feCTr);
	          var feFunc = createNS('feFuncA');
	          feFunc.setAttribute('type', 'table');
	          feFunc.setAttribute('tableValues', '1.0 0.0');
	          feCTr.appendChild(feFunc); /// /
	
	          this.globalData.defs.appendChild(fil);
	          var alphaRect = createNS('rect');
	          alphaRect.setAttribute('width', this.comp.data.w);
	          alphaRect.setAttribute('height', this.comp.data.h);
	          alphaRect.setAttribute('x', '0');
	          alphaRect.setAttribute('y', '0');
	          alphaRect.setAttribute('fill', '#ffffff');
	          alphaRect.setAttribute('opacity', '0');
	          maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
	          maskGrouper.appendChild(alphaRect);
	          useElement = createNS('use');
	          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
	          maskGrouper.appendChild(useElement);
	
	          if (!featureSupport.maskType) {
	            maskGroup.setAttribute('mask-type', 'luminance');
	            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	            gg = createNS('g');
	            maskGrouper.appendChild(alphaRect);
	            gg.appendChild(this.layerElement);
	            maskGrouper.appendChild(gg);
	          }
	
	          this.globalData.defs.appendChild(maskGroup);
	        }
	
	        this.matteMasks[matteType] = id;
	      }
	
	      return this.matteMasks[matteType];
	    },
	    setMatte: function setMatte(id) {
	      if (!this.matteElement) {
	        return;
	      }
	
	      this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
	    }
	  };
	
	  /**
	   * @file
	   * Handles AE's layer parenting property.
	   *
	   */
	  function HierarchyElement() {}
	
	  HierarchyElement.prototype = {
	    /**
	       * @function
	       * Initializes hierarchy properties
	       *
	       */
	    initHierarchy: function initHierarchy() {
	      // element's parent list
	      this.hierarchy = []; // if element is parent of another layer _isParent will be true
	
	      this._isParent = false;
	      this.checkParenting();
	    },
	
	    /**
	       * @function
	       * Sets layer's hierarchy.
	       * @param {array} hierarch
	       * layer's parent list
	       *
	       */
	    setHierarchy: function setHierarchy(hierarchy) {
	      this.hierarchy = hierarchy;
	    },
	
	    /**
	       * @function
	       * Sets layer as parent.
	       *
	       */
	    setAsParent: function setAsParent() {
	      this._isParent = true;
	    },
	
	    /**
	       * @function
	       * Searches layer's parenting chain
	       *
	       */
	    checkParenting: function checkParenting() {
	      if (this.data.parent !== undefined) {
	        this.comp.buildElementParenting(this, this.data.parent, []);
	      }
	    }
	  };
	
	  function RenderableDOMElement() {}
	
	  (function () {
	    var _prototype = {
	      initElement: function initElement(data, globalData, comp) {
	        this.initFrame();
	        this.initBaseData(data, globalData, comp);
	        this.initTransform(data, globalData, comp);
	        this.initHierarchy();
	        this.initRenderable();
	        this.initRendererElement();
	        this.createContainerElements();
	        this.createRenderableComponents();
	        this.createContent();
	        this.hide();
	      },
	      hide: function hide() {
	        // console.log('HIDE', this);
	        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	          var elem = this.baseElement || this.layerElement;
	          elem.style.display = 'none';
	          this.hidden = true;
	        }
	      },
	      show: function show() {
	        // console.log('SHOW', this);
	        if (this.isInRange && !this.isTransparent) {
	          if (!this.data.hd) {
	            var elem = this.baseElement || this.layerElement;
	            elem.style.display = 'block';
	          }
	
	          this.hidden = false;
	          this._isFirstFrame = true;
	        }
	      },
	      renderFrame: function renderFrame() {
	        // If it is exported as hidden (data.hd === true) no need to render
	        // If it is not visible no need to render
	        if (this.data.hd || this.hidden) {
	          return;
	        }
	
	        this.renderTransform();
	        this.renderRenderable();
	        this.renderLocalTransform();
	        this.renderElement();
	        this.renderInnerContent();
	
	        if (this._isFirstFrame) {
	          this._isFirstFrame = false;
	        }
	      },
	      renderInnerContent: function renderInnerContent() {},
	      prepareFrame: function prepareFrame(num) {
	        this._mdf = false;
	        this.prepareRenderableFrame(num);
	        this.prepareProperties(num, this.isInRange);
	        this.checkTransparency();
	      },
	      destroy: function destroy() {
	        this.innerElem = null;
	        this.destroyBaseElement();
	      }
	    };
	    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
	  })();
	
	  function IImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	
	    if (this.assetData && this.assetData.sid) {
	      this.assetData = globalData.slotManager.getProp(this.assetData);
	    }
	
	    this.initElement(data, globalData, comp);
	    this.sourceRect = {
	      top: 0,
	      left: 0,
	      width: this.assetData.w,
	      height: this.assetData.h
	    };
	  }
	
	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);
	
	  IImageElement.prototype.createContent = function () {
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width', this.assetData.w + 'px');
	    this.innerElem.setAttribute('height', this.assetData.h + 'px');
	    this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
	    this.layerElement.appendChild(this.innerElem);
	  };
	
	  IImageElement.prototype.sourceRectAtTime = function () {
	    return this.sourceRect;
	  };
	
	  function ProcessedElement(element, position) {
	    this.elem = element;
	    this.pos = position;
	  }
	
	  function IShapeElement() {}
	
	  IShapeElement.prototype = {
	    addShapeToModifiers: function addShapeToModifiers(data) {
	      var i;
	      var len = this.shapeModifiers.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.shapeModifiers[i].addShape(data);
	      }
	    },
	    isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
	      var i = 0;
	      var len = this.shapeModifiers.length;
	
	      while (i < len) {
	        if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
	          return true;
	        }
	      }
	
	      return false;
	    },
	    renderModifiers: function renderModifiers() {
	      if (!this.shapeModifiers.length) {
	        return;
	      }
	
	      var i;
	      var len = this.shapes.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.shapes[i].sh.reset();
	      }
	
	      len = this.shapeModifiers.length;
	      var shouldBreakProcess;
	
	      for (i = len - 1; i >= 0; i -= 1) {
	        shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
	        // TODO: find a better solution for this
	
	        if (shouldBreakProcess) {
	          break;
	        }
	      }
	    },
	    searchProcessedElement: function searchProcessedElement(elem) {
	      var elements = this.processedElements;
	      var i = 0;
	      var len = elements.length;
	
	      while (i < len) {
	        if (elements[i].elem === elem) {
	          return elements[i].pos;
	        }
	
	        i += 1;
	      }
	
	      return 0;
	    },
	    addProcessedElement: function addProcessedElement(elem, pos) {
	      var elements = this.processedElements;
	      var i = elements.length;
	
	      while (i) {
	        i -= 1;
	
	        if (elements[i].elem === elem) {
	          elements[i].pos = pos;
	          return;
	        }
	      }
	
	      elements.push(new ProcessedElement(elem, pos));
	    },
	    prepareFrame: function prepareFrame(num) {
	      this.prepareRenderableFrame(num);
	      this.prepareProperties(num, this.isInRange);
	    }
	  };
	
	  var lineCapEnum = {
	    1: 'butt',
	    2: 'round',
	    3: 'square'
	  };
	  var lineJoinEnum = {
	    1: 'miter',
	    2: 'round',
	    3: 'bevel'
	  };
	
	  function SVGShapeData(transformers, level, shape) {
	    this.caches = [];
	    this.styles = [];
	    this.transformers = transformers;
	    this.lStr = '';
	    this.sh = shape;
	    this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
	    // For now, since shapes add up with other shapes. They have to be calculated every time.
	    // One way of finding out is checking if all styles associated to this shape depend only of this shape
	
	    this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
	
	    var i = 0;
	    var len = transformers.length;
	
	    while (i < len) {
	      if (transformers[i].mProps.dynamicProperties.length) {
	        this._isAnimated = true;
	        break;
	      }
	
	      i += 1;
	    }
	  }
	
	  SVGShapeData.prototype.setAsAnimated = function () {
	    this._isAnimated = true;
	  };
	
	  function SVGStyleData(data, level) {
	    this.data = data;
	    this.type = data.ty;
	    this.d = '';
	    this.lvl = level;
	    this._mdf = false;
	    this.closed = data.hd === true;
	    this.pElem = createNS('path');
	    this.msElem = null;
	  }
	
	  SVGStyleData.prototype.reset = function () {
	    this.d = '';
	    this._mdf = false;
	  };
	
	  function DashProperty(elem, data, renderer, container) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = createSizedArray(data.length);
	    this.renderer = renderer;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
	    this.dashoffset = createTypedArray('float32', 1);
	    this.initDynamicPropertyContainer(container);
	    var i;
	    var len = data.length || 0;
	    var prop;
	
	    for (i = 0; i < len; i += 1) {
	      prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
	      this.k = prop.k || this.k;
	      this.dataProps[i] = {
	        n: data[i].n,
	        p: prop
	      };
	    }
	
	    if (!this.k) {
	      this.getValue(true);
	    }
	
	    this._isAnimated = this.k;
	  }
	
	  DashProperty.prototype.getValue = function (forceRender) {
	    if (this.elem.globalData.frameId === this.frameId && !forceRender) {
	      return;
	    }
	
	    this.frameId = this.elem.globalData.frameId;
	    this.iterateDynamicProperties();
	    this._mdf = this._mdf || forceRender;
	
	    if (this._mdf) {
	      var i = 0;
	      var len = this.dataProps.length;
	
	      if (this.renderer === 'svg') {
	        this.dashStr = '';
	      }
	
	      for (i = 0; i < len; i += 1) {
	        if (this.dataProps[i].n !== 'o') {
	          if (this.renderer === 'svg') {
	            this.dashStr += ' ' + this.dataProps[i].p.v;
	          } else {
	            this.dashArray[i] = this.dataProps[i].p.v;
	          }
	        } else {
	          this.dashoffset[0] = this.dataProps[i].p.v;
	        }
	      }
	    }
	  };
	
	  extendPrototype([DynamicPropertyContainer], DashProperty);
	
	  function SVGStrokeStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
	    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
	    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
	    this.style = styleOb;
	    this._isAnimated = !!this._isAnimated;
	  }
	
	  extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
	
	  function SVGFillStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
	    this.style = styleOb;
	  }
	
	  extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
	
	  function SVGNoStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.style = styleOb;
	  }
	
	  extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
	
	  function GradientProperty(elem, data, container) {
	    this.data = data;
	    this.c = createTypedArray('uint8c', data.p * 4);
	    var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
	    this.o = createTypedArray('float32', cLength);
	    this._cmdf = false;
	    this._omdf = false;
	    this._collapsable = this.checkCollapsable();
	    this._hasOpacity = cLength;
	    this.initDynamicPropertyContainer(container);
	    this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
	    this.k = this.prop.k;
	    this.getValue(true);
	  }
	
	  GradientProperty.prototype.comparePoints = function (values, points) {
	    var i = 0;
	    var len = this.o.length / 2;
	    var diff;
	
	    while (i < len) {
	      diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
	
	      if (diff > 0.01) {
	        return false;
	      }
	
	      i += 1;
	    }
	
	    return true;
	  };
	
	  GradientProperty.prototype.checkCollapsable = function () {
	    if (this.o.length / 2 !== this.c.length / 4) {
	      return false;
	    }
	
	    if (this.data.k.k[0].s) {
	      var i = 0;
	      var len = this.data.k.k.length;
	
	      while (i < len) {
	        if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
	          return false;
	        }
	
	        i += 1;
	      }
	    } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
	      return false;
	    }
	
	    return true;
	  };
	
	  GradientProperty.prototype.getValue = function (forceRender) {
	    this.prop.getValue();
	    this._mdf = false;
	    this._cmdf = false;
	    this._omdf = false;
	
	    if (this.prop._mdf || forceRender) {
	      var i;
	      var len = this.data.p * 4;
	      var mult;
	      var val;
	
	      for (i = 0; i < len; i += 1) {
	        mult = i % 4 === 0 ? 100 : 255;
	        val = Math.round(this.prop.v[i] * mult);
	
	        if (this.c[i] !== val) {
	          this.c[i] = val;
	          this._cmdf = !forceRender;
	        }
	      }
	
	      if (this.o.length) {
	        len = this.prop.v.length;
	
	        for (i = this.data.p * 4; i < len; i += 1) {
	          mult = i % 2 === 0 ? 100 : 1;
	          val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
	
	          if (this.o[i - this.data.p * 4] !== val) {
	            this.o[i - this.data.p * 4] = val;
	            this._omdf = !forceRender;
	          }
	        }
	      }
	
	      this._mdf = !forceRender;
	    }
	  };
	
	  extendPrototype([DynamicPropertyContainer], GradientProperty);
	
	  function SVGGradientFillStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.initGradientData(elem, data, styleOb);
	  }
	
	  SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
	    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
	    this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
	    this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
	    this.h = PropertyFactory.getProp(elem, data.h || {
	      k: 0
	    }, 0, 0.01, this);
	    this.a = PropertyFactory.getProp(elem, data.a || {
	      k: 0
	    }, 0, degToRads, this);
	    this.g = new GradientProperty(elem, data.g, this);
	    this.style = styleOb;
	    this.stops = [];
	    this.setGradientData(styleOb.pElem, data);
	    this.setGradientOpacity(data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	  };
	
	  SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
	    var gradientId = createElementID();
	    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	    gfill.setAttribute('id', gradientId);
	    gfill.setAttribute('spreadMethod', 'pad');
	    gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
	    var stops = [];
	    var stop;
	    var j;
	    var jLen;
	    jLen = data.g.p * 4;
	
	    for (j = 0; j < jLen; j += 4) {
	      stop = createNS('stop');
	      gfill.appendChild(stop);
	      stops.push(stop);
	    }
	
	    pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
	    this.gf = gfill;
	    this.cst = stops;
	  };
	
	  SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
	    if (this.g._hasOpacity && !this.g._collapsable) {
	      var stop;
	      var j;
	      var jLen;
	      var mask = createNS('mask');
	      var maskElement = createNS('path');
	      mask.appendChild(maskElement);
	      var opacityId = createElementID();
	      var maskId = createElementID();
	      mask.setAttribute('id', maskId);
	      var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
	      opFill.setAttribute('id', opacityId);
	      opFill.setAttribute('spreadMethod', 'pad');
	      opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
	      jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
	      var stops = this.stops;
	
	      for (j = data.g.p * 4; j < jLen; j += 2) {
	        stop = createNS('stop');
	        stop.setAttribute('stop-color', 'rgb(255,255,255)');
	        opFill.appendChild(stop);
	        stops.push(stop);
	      }
	
	      maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
	
	      if (data.ty === 'gs') {
	        maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
	        maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
	
	        if (data.lj === 1) {
	          maskElement.setAttribute('stroke-miterlimit', data.ml);
	        }
	      }
	
	      this.of = opFill;
	      this.ms = mask;
	      this.ost = stops;
	      this.maskId = maskId;
	      styleOb.msElem = maskElement;
	    }
	  };
	
	  extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
	
	  function SVGGradientStrokeStyleData(elem, data, styleOb) {
	    this.initDynamicPropertyContainer(elem);
	    this.getValue = this.iterateDynamicProperties;
	    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
	    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
	    this.initGradientData(elem, data, styleOb);
	    this._isAnimated = !!this._isAnimated;
	  }
	
	  extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
	
	  function ShapeGroupData() {
	    this.it = [];
	    this.prevViewData = [];
	    this.gr = createNS('g');
	  }
	
	  function SVGTransformData(mProps, op, container) {
	    this.transform = {
	      mProps: mProps,
	      op: op,
	      container: container
	    };
	    this.elements = [];
	    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
	  }
	
	  var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
	    if (length === 0) {
	      return '';
	    }
	
	    var _o = pathNodes.o;
	    var _i = pathNodes.i;
	    var _v = pathNodes.v;
	    var i;
	    var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	
	    for (i = 1; i < length; i += 1) {
	      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
	    }
	
	    if (closed && length) {
	      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
	      shapeString += 'z';
	    }
	
	    return shapeString;
	  };
	
	  var SVGElementsRenderer = function () {
	    var _identityMatrix = new Matrix();
	
	    var _matrixHelper = new Matrix();
	
	    var ob = {
	      createRenderFunction: createRenderFunction
	    };
	
	    function createRenderFunction(data) {
	      switch (data.ty) {
	        case 'fl':
	          return renderFill;
	
	        case 'gf':
	          return renderGradient;
	
	        case 'gs':
	          return renderGradientStroke;
	
	        case 'st':
	          return renderStroke;
	
	        case 'sh':
	        case 'el':
	        case 'rc':
	        case 'sr':
	          return renderPath;
	
	        case 'tr':
	          return renderContentTransform;
	
	        case 'no':
	          return renderNoop;
	
	        default:
	          return null;
	      }
	    }
	
	    function renderContentTransform(styleData, itemData, isFirstFrame) {
	      if (isFirstFrame || itemData.transform.op._mdf) {
	        itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
	      }
	
	      if (isFirstFrame || itemData.transform.mProps._mdf) {
	        itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
	      }
	    }
	
	    function renderNoop() {}
	
	    function renderPath(styleData, itemData, isFirstFrame) {
	      var j;
	      var jLen;
	      var pathStringTransformed;
	      var redraw;
	      var pathNodes;
	      var l;
	      var lLen = itemData.styles.length;
	      var lvl = itemData.lvl;
	      var paths;
	      var mat;
	      var iterations;
	      var k;
	
	      for (l = 0; l < lLen; l += 1) {
	        redraw = itemData.sh._mdf || isFirstFrame;
	
	        if (itemData.styles[l].lvl < lvl) {
	          mat = _matrixHelper.reset();
	          iterations = lvl - itemData.styles[l].lvl;
	          k = itemData.transformers.length - 1;
	
	          while (!redraw && iterations > 0) {
	            redraw = itemData.transformers[k].mProps._mdf || redraw;
	            iterations -= 1;
	            k -= 1;
	          }
	
	          if (redraw) {
	            iterations = lvl - itemData.styles[l].lvl;
	            k = itemData.transformers.length - 1;
	
	            while (iterations > 0) {
	              mat.multiply(itemData.transformers[k].mProps.v);
	              iterations -= 1;
	              k -= 1;
	            }
	          }
	        } else {
	          mat = _identityMatrix;
	        }
	
	        paths = itemData.sh.paths;
	        jLen = paths._length;
	
	        if (redraw) {
	          pathStringTransformed = '';
	
	          for (j = 0; j < jLen; j += 1) {
	            pathNodes = paths.shapes[j];
	
	            if (pathNodes && pathNodes._length) {
	              pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
	            }
	          }
	
	          itemData.caches[l] = pathStringTransformed;
	        } else {
	          pathStringTransformed = itemData.caches[l];
	        }
	
	        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
	        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
	      }
	    }
	
	    function renderFill(styleData, itemData, isFirstFrame) {
	      var styleElem = itemData.style;
	
	      if (itemData.c._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
	      }
	
	      if (itemData.o._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
	      }
	    }
	
	    function renderGradientStroke(styleData, itemData, isFirstFrame) {
	      renderGradient(styleData, itemData, isFirstFrame);
	      renderStroke(styleData, itemData, isFirstFrame);
	    }
	
	    function renderGradient(styleData, itemData, isFirstFrame) {
	      var gfill = itemData.gf;
	      var hasOpacity = itemData.g._hasOpacity;
	      var pt1 = itemData.s.v;
	      var pt2 = itemData.e.v;
	
	      if (itemData.o._mdf || isFirstFrame) {
	        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
	        itemData.style.pElem.setAttribute(attr, itemData.o.v);
	      }
	
	      if (itemData.s._mdf || isFirstFrame) {
	        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
	        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
	        gfill.setAttribute(attr1, pt1[0]);
	        gfill.setAttribute(attr2, pt1[1]);
	
	        if (hasOpacity && !itemData.g._collapsable) {
	          itemData.of.setAttribute(attr1, pt1[0]);
	          itemData.of.setAttribute(attr2, pt1[1]);
	        }
	      }
	
	      var stops;
	      var i;
	      var len;
	      var stop;
	
	      if (itemData.g._cmdf || isFirstFrame) {
	        stops = itemData.cst;
	        var cValues = itemData.g.c;
	        len = stops.length;
	
	        for (i = 0; i < len; i += 1) {
	          stop = stops[i];
	          stop.setAttribute('offset', cValues[i * 4] + '%');
	          stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
	        }
	      }
	
	      if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
	        var oValues = itemData.g.o;
	
	        if (itemData.g._collapsable) {
	          stops = itemData.cst;
	        } else {
	          stops = itemData.ost;
	        }
	
	        len = stops.length;
	
	        for (i = 0; i < len; i += 1) {
	          stop = stops[i];
	
	          if (!itemData.g._collapsable) {
	            stop.setAttribute('offset', oValues[i * 2] + '%');
	          }
	
	          stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
	        }
	      }
	
	      if (styleData.t === 1) {
	        if (itemData.e._mdf || isFirstFrame) {
	          gfill.setAttribute('x2', pt2[0]);
	          gfill.setAttribute('y2', pt2[1]);
	
	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('x2', pt2[0]);
	            itemData.of.setAttribute('y2', pt2[1]);
	          }
	        }
	      } else {
	        var rad;
	
	        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
	          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	          gfill.setAttribute('r', rad);
	
	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('r', rad);
	          }
	        }
	
	        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
	          if (!rad) {
	            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	          }
	
	          var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	          var percent = itemData.h.v;
	
	          if (percent >= 1) {
	            percent = 0.99;
	          } else if (percent <= -1) {
	            percent = -0.99;
	          }
	
	          var dist = rad * percent;
	          var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	          var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	          gfill.setAttribute('fx', x);
	          gfill.setAttribute('fy', y);
	
	          if (hasOpacity && !itemData.g._collapsable) {
	            itemData.of.setAttribute('fx', x);
	            itemData.of.setAttribute('fy', y);
	          }
	        } // gfill.setAttribute('fy','200');
	
	      }
	    }
	
	    function renderStroke(styleData, itemData, isFirstFrame) {
	      var styleElem = itemData.style;
	      var d = itemData.d;
	
	      if (d && (d._mdf || isFirstFrame) && d.dashStr) {
	        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
	        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
	      }
	
	      if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
	        styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
	      }
	
	      if (itemData.o._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
	      }
	
	      if (itemData.w._mdf || isFirstFrame) {
	        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
	
	        if (styleElem.msElem) {
	          styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
	        }
	      }
	    }
	
	    return ob;
	  }();
	
	  function SVGShapeElement(data, globalData, comp) {
	    // List of drawable elements
	    this.shapes = []; // Full shape data
	
	    this.shapesData = data.shapes; // List of styles that will be applied to shapes
	
	    this.stylesList = []; // List of modifiers that will be applied to shapes
	
	    this.shapeModifiers = []; // List of items in shape tree
	
	    this.itemsData = []; // List of items in previous shape tree
	
	    this.processedElements = []; // List of animated components
	
	    this.animatedContents = [];
	    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	
	    this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	  }
	
	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);
	
	  SVGShapeElement.prototype.initSecondaryElement = function () {};
	
	  SVGShapeElement.prototype.identityMatrix = new Matrix();
	
	  SVGShapeElement.prototype.buildExpressionInterface = function () {};
	
	  SVGShapeElement.prototype.createContent = function () {
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	  };
	  /*
	  This method searches for multiple shapes that affect a single element and one of them is animated
	  */
	
	
	  SVGShapeElement.prototype.filterUniqueShapes = function () {
	    var i;
	    var len = this.shapes.length;
	    var shape;
	    var j;
	    var jLen = this.stylesList.length;
	    var style;
	    var tempShapes = [];
	    var areAnimated = false;
	
	    for (j = 0; j < jLen; j += 1) {
	      style = this.stylesList[j];
	      areAnimated = false;
	      tempShapes.length = 0;
	
	      for (i = 0; i < len; i += 1) {
	        shape = this.shapes[i];
	
	        if (shape.styles.indexOf(style) !== -1) {
	          tempShapes.push(shape);
	          areAnimated = shape._isAnimated || areAnimated;
	        }
	      }
	
	      if (tempShapes.length > 1 && areAnimated) {
	        this.setShapesAsAnimated(tempShapes);
	      }
	    }
	  };
	
	  SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
	    var i;
	    var len = shapes.length;
	
	    for (i = 0; i < len; i += 1) {
	      shapes[i].setAsAnimated();
	    }
	  };
	
	  SVGShapeElement.prototype.createStyleElement = function (data, level) {
	    // TODO: prevent drawing of hidden styles
	    var elementData;
	    var styleOb = new SVGStyleData(data, level);
	    var pathElement = styleOb.pElem;
	
	    if (data.ty === 'st') {
	      elementData = new SVGStrokeStyleData(this, data, styleOb);
	    } else if (data.ty === 'fl') {
	      elementData = new SVGFillStyleData(this, data, styleOb);
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	      var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
	      elementData = new GradientConstructor(this, data, styleOb);
	      this.globalData.defs.appendChild(elementData.gf);
	
	      if (elementData.maskId) {
	        this.globalData.defs.appendChild(elementData.ms);
	        this.globalData.defs.appendChild(elementData.of);
	        pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
	      }
	    } else if (data.ty === 'no') {
	      elementData = new SVGNoStyleData(this, data, styleOb);
	    }
	
	    if (data.ty === 'st' || data.ty === 'gs') {
	      pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
	      pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
	      pathElement.setAttribute('fill-opacity', '0');
	
	      if (data.lj === 1) {
	        pathElement.setAttribute('stroke-miterlimit', data.ml);
	      }
	    }
	
	    if (data.r === 2) {
	      pathElement.setAttribute('fill-rule', 'evenodd');
	    }
	
	    if (data.ln) {
	      pathElement.setAttribute('id', data.ln);
	    }
	
	    if (data.cl) {
	      pathElement.setAttribute('class', data.cl);
	    }
	
	    if (data.bm) {
	      pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	
	    this.stylesList.push(styleOb);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };
	
	  SVGShapeElement.prototype.createGroupElement = function (data) {
	    var elementData = new ShapeGroupData();
	
	    if (data.ln) {
	      elementData.gr.setAttribute('id', data.ln);
	    }
	
	    if (data.cl) {
	      elementData.gr.setAttribute('class', data.cl);
	    }
	
	    if (data.bm) {
	      elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
	    }
	
	    return elementData;
	  };
	
	  SVGShapeElement.prototype.createTransformElement = function (data, container) {
	    var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
	    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };
	
	  SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
	    var ty = 4;
	
	    if (data.ty === 'rc') {
	      ty = 5;
	    } else if (data.ty === 'el') {
	      ty = 6;
	    } else if (data.ty === 'sr') {
	      ty = 7;
	    }
	
	    var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
	    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    this.addToAnimatedContents(data, elementData);
	    return elementData;
	  };
	
	  SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
	    var i = 0;
	    var len = this.animatedContents.length;
	
	    while (i < len) {
	      if (this.animatedContents[i].element === element) {
	        return;
	      }
	
	      i += 1;
	    }
	
	    this.animatedContents.push({
	      fn: SVGElementsRenderer.createRenderFunction(data),
	      element: element,
	      data: data
	    });
	  };
	
	  SVGShapeElement.prototype.setElementStyles = function (elementData) {
	    var arr = elementData.styles;
	    var j;
	    var jLen = this.stylesList.length;
	
	    for (j = 0; j < jLen; j += 1) {
	      if (!this.stylesList[j].closed) {
	        arr.push(this.stylesList[j]);
	      }
	    }
	  };
	
	  SVGShapeElement.prototype.reloadShapes = function () {
	    this._isFirstFrame = true;
	    var i;
	    var len = this.itemsData.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.prevViewData[i] = this.itemsData[i];
	    }
	
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
	    this.filterUniqueShapes();
	    len = this.dynamicProperties.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.dynamicProperties[i].getValue();
	    }
	
	    this.renderModifiers();
	  };
	
	  SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
	    var ownTransformers = [].concat(transformers);
	    var i;
	    var len = arr.length - 1;
	    var j;
	    var jLen;
	    var ownStyles = [];
	    var ownModifiers = [];
	    var currentTransform;
	    var modifier;
	    var processedPos;
	
	    for (i = len; i >= 0; i -= 1) {
	      processedPos = this.searchProcessedElement(arr[i]);
	
	      if (!processedPos) {
	        arr[i]._render = render;
	      } else {
	        itemsData[i] = prevViewData[processedPos - 1];
	      }
	
	      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
	        if (!processedPos) {
	          itemsData[i] = this.createStyleElement(arr[i], level);
	        } else {
	          itemsData[i].style.closed = false;
	        }
	
	        if (arr[i]._render) {
	          if (itemsData[i].style.pElem.parentNode !== container) {
	            container.appendChild(itemsData[i].style.pElem);
	          }
	        }
	
	        ownStyles.push(itemsData[i].style);
	      } else if (arr[i].ty === 'gr') {
	        if (!processedPos) {
	          itemsData[i] = this.createGroupElement(arr[i]);
	        } else {
	          jLen = itemsData[i].it.length;
	
	          for (j = 0; j < jLen; j += 1) {
	            itemsData[i].prevViewData[j] = itemsData[i].it[j];
	          }
	        }
	
	        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
	
	        if (arr[i]._render) {
	          if (itemsData[i].gr.parentNode !== container) {
	            container.appendChild(itemsData[i].gr);
	          }
	        }
	      } else if (arr[i].ty === 'tr') {
	        if (!processedPos) {
	          itemsData[i] = this.createTransformElement(arr[i], container);
	        }
	
	        currentTransform = itemsData[i].transform;
	        ownTransformers.push(currentTransform);
	      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
	        if (!processedPos) {
	          itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
	        }
	
	        this.setElementStyles(itemsData[i]);
	      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          modifier.init(this, arr[i]);
	          itemsData[i] = modifier;
	          this.shapeModifiers.push(modifier);
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = false;
	        }
	
	        ownModifiers.push(modifier);
	      } else if (arr[i].ty === 'rp') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          itemsData[i] = modifier;
	          modifier.init(this, arr, i, itemsData);
	          this.shapeModifiers.push(modifier);
	          render = false;
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = true;
	        }
	
	        ownModifiers.push(modifier);
	      }
	
	      this.addProcessedElement(arr[i], i + 1);
	    }
	
	    len = ownStyles.length;
	
	    for (i = 0; i < len; i += 1) {
	      ownStyles[i].closed = true;
	    }
	
	    len = ownModifiers.length;
	
	    for (i = 0; i < len; i += 1) {
	      ownModifiers[i].closed = true;
	    }
	  };
	
	  SVGShapeElement.prototype.renderInnerContent = function () {
	    this.renderModifiers();
	    var i;
	    var len = this.stylesList.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.stylesList[i].reset();
	    }
	
	    this.renderShape();
	
	    for (i = 0; i < len; i += 1) {
	      if (this.stylesList[i]._mdf || this._isFirstFrame) {
	        if (this.stylesList[i].msElem) {
	          this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
	
	          this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
	        }
	
	        this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	      }
	    }
	  };
	
	  SVGShapeElement.prototype.renderShape = function () {
	    var i;
	    var len = this.animatedContents.length;
	    var animatedContent;
	
	    for (i = 0; i < len; i += 1) {
	      animatedContent = this.animatedContents[i];
	
	      if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
	        animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
	      }
	    }
	  };
	
	  SVGShapeElement.prototype.destroy = function () {
	    this.destroyBaseElement();
	    this.shapesData = null;
	    this.itemsData = null;
	  };
	
	  function LetterProps(o, sw, sc, fc, m, p) {
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this._mdf = {
	      o: true,
	      sw: !!sw,
	      sc: !!sc,
	      fc: !!fc,
	      m: true,
	      p: true
	    };
	  }
	
	  LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
	    this._mdf.o = false;
	    this._mdf.sw = false;
	    this._mdf.sc = false;
	    this._mdf.fc = false;
	    this._mdf.m = false;
	    this._mdf.p = false;
	    var updated = false;
	
	    if (this.o !== o) {
	      this.o = o;
	      this._mdf.o = true;
	      updated = true;
	    }
	
	    if (this.sw !== sw) {
	      this.sw = sw;
	      this._mdf.sw = true;
	      updated = true;
	    }
	
	    if (this.sc !== sc) {
	      this.sc = sc;
	      this._mdf.sc = true;
	      updated = true;
	    }
	
	    if (this.fc !== fc) {
	      this.fc = fc;
	      this._mdf.fc = true;
	      updated = true;
	    }
	
	    if (this.m !== m) {
	      this.m = m;
	      this._mdf.m = true;
	      updated = true;
	    }
	
	    if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
	      this.p = p;
	      this._mdf.p = true;
	      updated = true;
	    }
	
	    return updated;
	  };
	
	  function TextProperty(elem, data) {
	    this._frameId = initialDefaultFrame;
	    this.pv = '';
	    this.v = '';
	    this.kf = false;
	    this._isFirstFrame = true;
	    this._mdf = false;
	
	    if (data.d && data.d.sid) {
	      data.d = elem.globalData.slotManager.getProp(data.d);
	    }
	
	    this.data = data;
	    this.elem = elem;
	    this.comp = this.elem.comp;
	    this.keysIndex = 0;
	    this.canResize = false;
	    this.minimumFontSize = 1;
	    this.effectsSequence = [];
	    this.currentData = {
	      ascent: 0,
	      boxWidth: this.defaultBoxWidth,
	      f: '',
	      fStyle: '',
	      fWeight: '',
	      fc: '',
	      j: '',
	      justifyOffset: '',
	      l: [],
	      lh: 0,
	      lineWidths: [],
	      ls: '',
	      of: '',
	      s: '',
	      sc: '',
	      sw: 0,
	      t: 0,
	      tr: 0,
	      sz: 0,
	      ps: null,
	      fillColorAnim: false,
	      strokeColorAnim: false,
	      strokeWidthAnim: false,
	      yOffset: 0,
	      finalSize: 0,
	      finalText: [],
	      finalLineHeight: 0,
	      __complete: false
	    };
	    this.copyData(this.currentData, this.data.d.k[0].s);
	
	    if (!this.searchProperty()) {
	      this.completeTextData(this.currentData);
	    }
	  }
	
	  TextProperty.prototype.defaultBoxWidth = [0, 0];
	
	  TextProperty.prototype.copyData = function (obj, data) {
	    for (var s in data) {
	      if (Object.prototype.hasOwnProperty.call(data, s)) {
	        obj[s] = data[s];
	      }
	    }
	
	    return obj;
	  };
	
	  TextProperty.prototype.setCurrentData = function (data) {
	    if (!data.__complete) {
	      this.completeTextData(data);
	    }
	
	    this.currentData = data;
	    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
	    this._mdf = true;
	  };
	
	  TextProperty.prototype.searchProperty = function () {
	    return this.searchKeyframes();
	  };
	
	  TextProperty.prototype.searchKeyframes = function () {
	    this.kf = this.data.d.k.length > 1;
	
	    if (this.kf) {
	      this.addEffect(this.getKeyframeValue.bind(this));
	    }
	
	    return this.kf;
	  };
	
	  TextProperty.prototype.addEffect = function (effectFunction) {
	    this.effectsSequence.push(effectFunction);
	    this.elem.addDynamicProperty(this);
	  };
	
	  TextProperty.prototype.getValue = function (_finalValue) {
	    if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
	      return;
	    }
	
	    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
	    var currentValue = this.currentData;
	    var currentIndex = this.keysIndex;
	
	    if (this.lock) {
	      this.setCurrentData(this.currentData);
	      return;
	    }
	
	    this.lock = true;
	    this._mdf = false;
	    var i;
	    var len = this.effectsSequence.length;
	    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
	
	    for (i = 0; i < len; i += 1) {
	      // Checking if index changed to prevent creating a new object every time the expression updates.
	      if (currentIndex !== this.keysIndex) {
	        finalValue = this.effectsSequence[i](finalValue, finalValue.t);
	      } else {
	        finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
	      }
	    }
	
	    if (currentValue !== finalValue) {
	      this.setCurrentData(finalValue);
	    }
	
	    this.v = this.currentData;
	    this.pv = this.v;
	    this.lock = false;
	    this.frameId = this.elem.globalData.frameId;
	  };
	
	  TextProperty.prototype.getKeyframeValue = function () {
	    var textKeys = this.data.d.k;
	    var frameNum = this.elem.comp.renderedFrame;
	    var i = 0;
	    var len = textKeys.length;
	
	    while (i <= len - 1) {
	      if (i === len - 1 || textKeys[i + 1].t > frameNum) {
	        break;
	      }
	
	      i += 1;
	    }
	
	    if (this.keysIndex !== i) {
	      this.keysIndex = i;
	    }
	
	    return this.data.d.k[this.keysIndex].s;
	  };
	
	  TextProperty.prototype.buildFinalText = function (text) {
	    var charactersArray = [];
	    var i = 0;
	    var len = text.length;
	    var charCode;
	    var secondCharCode;
	    var shouldCombine = false;
	    var shouldCombineNext = false;
	    var currentChars = '';
	
	    while (i < len) {
	      shouldCombine = shouldCombineNext;
	      shouldCombineNext = false;
	      charCode = text.charCodeAt(i);
	      currentChars = text.charAt(i);
	
	      if (FontManager.isCombinedCharacter(charCode)) {
	        shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
	      } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
	        if (FontManager.isRegionalFlag(text, i)) {
	          currentChars = text.substr(i, 14);
	        } else {
	          secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
	
	          if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
	            if (FontManager.isModifier(charCode, secondCharCode)) {
	              currentChars = text.substr(i, 2);
	              shouldCombine = true;
	            } else if (FontManager.isFlagEmoji(text.substr(i, 4))) {
	              currentChars = text.substr(i, 4);
	            } else {
	              currentChars = text.substr(i, 2);
	            }
	          }
	        }
	      } else if (charCode > 0xDBFF) {
	        secondCharCode = text.charCodeAt(i + 1);
	
	        if (FontManager.isVariationSelector(charCode)) {
	          shouldCombine = true;
	        }
	      } else if (FontManager.isZeroWidthJoiner(charCode)) {
	        shouldCombine = true;
	        shouldCombineNext = true;
	      }
	
	      if (shouldCombine) {
	        charactersArray[charactersArray.length - 1] += currentChars;
	        shouldCombine = false;
	      } else {
	        charactersArray.push(currentChars);
	      }
	
	      i += currentChars.length;
	    }
	
	    return charactersArray;
	  };
	
	  TextProperty.prototype.completeTextData = function (documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i;
	    var len;
	    var newLineFlag;
	    var index = 0;
	    var val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0;
	    var currentPos = 0;
	    var currentLine = 0;
	    var lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j;
	    var jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData;
	    var cLength = 0;
	    var fontProps = getFontProperties(fontData);
	    documentData.fWeight = fontProps.weight;
	    documentData.fStyle = fontProps.style;
	    documentData.finalSize = documentData.s;
	    documentData.finalText = this.buildFinalText(documentData.t);
	    len = documentData.finalText.length;
	    documentData.finalLineHeight = documentData.lh;
	    var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
	    var charCode;
	
	    if (documentData.sz) {
	      var flag = true;
	      var boxWidth = documentData.sz[0];
	      var boxHeight = documentData.sz[1];
	      var currentHeight;
	      var finalText;
	
	      while (flag) {
	        finalText = this.buildFinalText(documentData.t);
	        currentHeight = 0;
	        lineWidth = 0;
	        len = finalText.length;
	        trackingOffset = documentData.tr / 1000 * documentData.finalSize;
	        var lastSpaceIndex = -1;
	
	        for (i = 0; i < len; i += 1) {
	          charCode = finalText[i].charCodeAt(0);
	          newLineFlag = false;
	
	          if (finalText[i] === ' ') {
	            lastSpaceIndex = i;
	          } else if (charCode === 13 || charCode === 3) {
	            lineWidth = 0;
	            newLineFlag = true;
	            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
	          }
	
	          if (fontManager.chars) {
	            charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
	            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
	          } else {
	            // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	            cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
	          }
	
	          if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
	            if (lastSpaceIndex === -1) {
	              len += 1;
	            } else {
	              i = lastSpaceIndex;
	            }
	
	            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
	            finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
	
	            lastSpaceIndex = -1;
	            lineWidth = 0;
	          } else {
	            lineWidth += cLength;
	            lineWidth += trackingOffset;
	          }
	        }
	
	        currentHeight += fontData.ascent * documentData.finalSize / 100;
	
	        if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
	          documentData.finalSize -= 1;
	          documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
	        } else {
	          documentData.finalText = finalText;
	          len = documentData.finalText.length;
	          flag = false;
	        }
	      }
	    }
	
	    lineWidth = -trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;
	
	    for (i = 0; i < len; i += 1) {
	      newLineFlag = false;
	      currentChar = documentData.finalText[i];
	      charCode = currentChar.charCodeAt(0);
	
	      if (charCode === 13 || charCode === 3) {
	        uncollapsedSpaces = 0;
	        lineWidths.push(lineWidth);
	        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	        lineWidth = -2 * trackingOffset;
	        val = '';
	        newLineFlag = true;
	        currentLine += 1;
	      } else {
	        val = currentChar;
	      }
	
	      if (fontManager.chars) {
	        charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
	      } else {
	        // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
	        // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	        cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
	      } //
	
	
	      if (currentChar === ' ') {
	        uncollapsedSpaces += cLength + trackingOffset;
	      } else {
	        lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	        uncollapsedSpaces = 0;
	      }
	
	      letters.push({
	        l: cLength,
	        an: cLength,
	        add: currentSize,
	        n: newLineFlag,
	        anIndexes: [],
	        val: val,
	        line: currentLine,
	        animatorJustifyOffset: 0
	      });
	
	      if (anchorGrouping == 2) {
	        // eslint-disable-line eqeqeq
	        currentSize += cLength;
	
	        if (val === '' || val === ' ' || i === len - 1) {
	          if (val === '' || val === ' ') {
	            currentSize -= cLength;
	          }
	
	          while (currentPos <= i) {
	            letters[currentPos].an = currentSize;
	            letters[currentPos].ind = index;
	            letters[currentPos].extra = cLength;
	            currentPos += 1;
	          }
	
	          index += 1;
	          currentSize = 0;
	        }
	      } else if (anchorGrouping == 3) {
	        // eslint-disable-line eqeqeq
	        currentSize += cLength;
	
	        if (val === '' || i === len - 1) {
	          if (val === '') {
	            currentSize -= cLength;
	          }
	
	          while (currentPos <= i) {
	            letters[currentPos].an = currentSize;
	            letters[currentPos].ind = index;
	            letters[currentPos].extra = cLength;
	            currentPos += 1;
	          }
	
	          currentSize = 0;
	          index += 1;
	        }
	      } else {
	        letters[index].ind = index;
	        letters[index].extra = 0;
	        index += 1;
	      }
	    }
	
	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);
	
	    if (documentData.sz) {
	      documentData.boxWidth = documentData.sz[0];
	      documentData.justifyOffset = 0;
	    } else {
	      documentData.boxWidth = maxLineWidth;
	
	      switch (documentData.j) {
	        case 1:
	          documentData.justifyOffset = -documentData.boxWidth;
	          break;
	
	        case 2:
	          documentData.justifyOffset = -documentData.boxWidth / 2;
	          break;
	
	        default:
	          documentData.justifyOffset = 0;
	      }
	    }
	
	    documentData.lineWidths = lineWidths;
	    var animators = data.a;
	    var animatorData;
	    var letterData;
	    jLen = animators.length;
	    var based;
	    var ind;
	    var indexes = [];
	
	    for (j = 0; j < jLen; j += 1) {
	      animatorData = animators[j];
	
	      if (animatorData.a.sc) {
	        documentData.strokeColorAnim = true;
	      }
	
	      if (animatorData.a.sw) {
	        documentData.strokeWidthAnim = true;
	      }
	
	      if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
	        documentData.fillColorAnim = true;
	      }
	
	      ind = 0;
	      based = animatorData.s.b;
	
	      for (i = 0; i < len; i += 1) {
	        letterData = letters[i];
	        letterData.anIndexes[j] = ind;
	
	        if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
	          // eslint-disable-line eqeqeq
	          if (animatorData.s.rn === 1) {
	            indexes.push(ind);
	          }
	
	          ind += 1;
	        }
	      }
	
	      data.a[j].s.totalChars = ind;
	      var currentInd = -1;
	      var newInd;
	
	      if (animatorData.s.rn === 1) {
	        for (i = 0; i < len; i += 1) {
	          letterData = letters[i];
	
	          if (currentInd != letterData.anIndexes[j]) {
	            // eslint-disable-line eqeqeq
	            currentInd = letterData.anIndexes[j];
	            newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
	          }
	
	          letterData.anIndexes[j] = newInd;
	        }
	      }
	    }
	
	    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent * documentData.finalSize / 100;
	  };
	
	  TextProperty.prototype.updateDocumentData = function (newData, index) {
	    index = index === undefined ? this.keysIndex : index;
	    var dData = this.copyData({}, this.data.d.k[index].s);
	    dData = this.copyData(dData, newData);
	    this.data.d.k[index].s = dData;
	    this.recalculate(index);
	    this.setCurrentData(dData);
	    this.elem.addDynamicProperty(this);
	  };
	
	  TextProperty.prototype.recalculate = function (index) {
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    this.keysIndex = 0;
	    this._isFirstFrame = true;
	    this.getValue(dData);
	  };
	
	  TextProperty.prototype.canResizeFont = function (_canResize) {
	    this.canResize = _canResize;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	  };
	
	  TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
	    this.minimumFontSize = Math.floor(_fontValue) || 1;
	    this.recalculate(this.keysIndex);
	    this.elem.addDynamicProperty(this);
	  };
	
	  var TextSelectorProp = function () {
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;
	
	    function TextSelectorPropFactory(elem, data) {
	      this._currentTextLength = -1;
	      this.k = false;
	      this.data = data;
	      this.elem = elem;
	      this.comp = elem.comp;
	      this.finalS = 0;
	      this.finalE = 0;
	      this.initDynamicPropertyContainer(elem);
	      this.s = PropertyFactory.getProp(elem, data.s || {
	        k: 0
	      }, 0, 0, this);
	
	      if ('e' in data) {
	        this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
	      } else {
	        this.e = {
	          v: 100
	        };
	      }
	
	      this.o = PropertyFactory.getProp(elem, data.o || {
	        k: 0
	      }, 0, 0, this);
	      this.xe = PropertyFactory.getProp(elem, data.xe || {
	        k: 0
	      }, 0, 0, this);
	      this.ne = PropertyFactory.getProp(elem, data.ne || {
	        k: 0
	      }, 0, 0, this);
	      this.sm = PropertyFactory.getProp(elem, data.sm || {
	        k: 100
	      }, 0, 0, this);
	      this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
	
	      if (!this.dynamicProperties.length) {
	        this.getValue();
	      }
	    }
	
	    TextSelectorPropFactory.prototype = {
	      getMult: function getMult(ind) {
	        if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
	          this.getValue();
	        }
	
	        var x1 = 0;
	        var y1 = 0;
	        var x2 = 1;
	        var y2 = 1;
	
	        if (this.ne.v > 0) {
	          x1 = this.ne.v / 100.0;
	        } else {
	          y1 = -this.ne.v / 100.0;
	        }
	
	        if (this.xe.v > 0) {
	          x2 = 1.0 - this.xe.v / 100.0;
	        } else {
	          y2 = 1.0 + this.xe.v / 100.0;
	        }
	
	        var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
	        var mult = 0;
	        var s = this.finalS;
	        var e = this.finalE;
	        var type = this.data.sh;
	
	        if (type === 2) {
	          if (e === s) {
	            mult = ind >= e ? 1 : 0;
	          } else {
	            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	          }
	
	          mult = easer(mult);
	        } else if (type === 3) {
	          if (e === s) {
	            mult = ind >= e ? 0 : 1;
	          } else {
	            mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	          }
	
	          mult = easer(mult);
	        } else if (type === 4) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
	
	            if (mult < 0.5) {
	              mult *= 2;
	            } else {
	              mult = 1 - 2 * (mult - 0.5);
	            }
	          }
	
	          mult = easer(mult);
	        } else if (type === 5) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            var tot = e - s;
	            /* ind += 0.5;
	                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */
	
	            ind = min(max(0, ind + 0.5 - s), e - s);
	            var x = -tot / 2 + ind;
	            var a = tot / 2;
	            mult = Math.sqrt(1 - x * x / (a * a));
	          }
	
	          mult = easer(mult);
	        } else if (type === 6) {
	          if (e === s) {
	            mult = 0;
	          } else {
	            ind = min(max(0, ind + 0.5 - s), e - s);
	            mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
	          }
	
	          mult = easer(mult);
	        } else {
	          if (ind >= floor(s)) {
	            if (ind - s < 0) {
	              mult = max(0, min(min(e, 1) - (s - ind), 1));
	            } else {
	              mult = max(0, min(e - ind, 1));
	            }
	          }
	
	          mult = easer(mult);
	        } // Smoothness implementation.
	        // The smoothness represents a reduced range of the original [0; 1] range.
	        // if smoothness is 25%, the new range will be [0.375; 0.625]
	        // Steps are:
	        // - find the lower value of the new range (threshold)
	        // - if multiplier is smaller than that value, floor it to 0
	        // - if it is larger,
	        //     - subtract the threshold
	        //     - divide it by the smoothness (this will return the range to [0; 1])
	        // Note: If it doesn't work on some scenarios, consider applying it before the easer.
	
	
	        if (this.sm.v !== 100) {
	          var smoothness = this.sm.v * 0.01;
	
	          if (smoothness === 0) {
	            smoothness = 0.00000001;
	          }
	
	          var threshold = 0.5 - smoothness * 0.5;
	
	          if (mult < threshold) {
	            mult = 0;
	          } else {
	            mult = (mult - threshold) / smoothness;
	
	            if (mult > 1) {
	              mult = 1;
	            }
	          }
	        }
	
	        return mult * this.a.v;
	      },
	      getValue: function getValue(newCharsFlag) {
	        this.iterateDynamicProperties();
	        this._mdf = newCharsFlag || this._mdf;
	        this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
	
	        if (newCharsFlag && this.data.r === 2) {
	          this.e.v = this._currentTextLength;
	        }
	
	        var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
	        var o = this.o.v / divisor;
	        var s = this.s.v / divisor + o;
	        var e = this.e.v / divisor + o;
	
	        if (s > e) {
	          var _s = s;
	          s = e;
	          e = _s;
	        }
	
	        this.finalS = s;
	        this.finalE = e;
	      }
	    };
	    extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);
	
	    function getTextSelectorProp(elem, data, arr) {
	      return new TextSelectorPropFactory(elem, data, arr);
	    }
	
	    return {
	      getTextSelectorProp: getTextSelectorProp
	    };
	  }();
	
	  function TextAnimatorDataProperty(elem, animatorProps, container) {
	    var defaultData = {
	      propType: false
	    };
	    var getProp = PropertyFactory.getProp;
	    var textAnimatorAnimatables = animatorProps.a;
	    this.a = {
	      r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
	      rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
	      ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
	      sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
	      sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
	      s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
	      a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
	      o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
	      p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
	      sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
	      sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
	      fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
	      fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
	      fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
	      fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
	      t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
	    };
	    this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
	    this.s.t = animatorProps.s.t;
	  }
	
	  function TextAnimatorProperty(textData, renderType, elem) {
	    this._isFirstFrame = true;
	    this._hasMaskedPath = false;
	    this._frameId = -1;
	    this._textData = textData;
	    this._renderType = renderType;
	    this._elem = elem;
	    this._animatorsData = createSizedArray(this._textData.a.length);
	    this._pathData = {};
	    this._moreOptions = {
	      alignment: {}
	    };
	    this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	    this.initDynamicPropertyContainer(elem);
	  }
	
	  TextAnimatorProperty.prototype.searchProperties = function () {
	    var i;
	    var len = this._textData.a.length;
	    var animatorProps;
	    var getProp = PropertyFactory.getProp;
	
	    for (i = 0; i < len; i += 1) {
	      animatorProps = this._textData.a[i];
	      this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
	    }
	
	    if (this._textData.p && 'm' in this._textData.p) {
	      this._pathData = {
	        a: getProp(this._elem, this._textData.p.a, 0, 0, this),
	        f: getProp(this._elem, this._textData.p.f, 0, 0, this),
	        l: getProp(this._elem, this._textData.p.l, 0, 0, this),
	        r: getProp(this._elem, this._textData.p.r, 0, 0, this),
	        p: getProp(this._elem, this._textData.p.p, 0, 0, this),
	        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	      };
	      this._hasMaskedPath = true;
	    } else {
	      this._hasMaskedPath = false;
	    }
	
	    this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
	  };
	
	  TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
	    this.lettersChangedFlag = lettersChangedFlag;
	
	    if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
	      return;
	    }
	
	    this._isFirstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    var xPos;
	    var yPos;
	    var i;
	    var len;
	    var letters = documentData.l;
	    var pathInfo;
	    var currentLength;
	    var currentPoint;
	    var segmentLength;
	    var flag;
	    var pointInd;
	    var segmentInd;
	    var prevPoint;
	    var points;
	    var segments;
	    var partialLength;
	    var totalLength;
	    var perc;
	    var tanAngle;
	    var mask;
	
	    if (this._hasMaskedPath) {
	      mask = this._pathData.m;
	
	      if (!this._pathData.n || this._pathData._mdf) {
	        var paths = mask.v;
	
	        if (this._pathData.r.v) {
	          paths = paths.reverse();
	        } // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
	
	
	        pathInfo = {
	          tLength: 0,
	          segments: []
	        };
	        len = paths._length - 1;
	        var bezierData;
	        totalLength = 0;
	
	        for (i = 0; i < len; i += 1) {
	          bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
	          pathInfo.tLength += bezierData.segmentLength;
	          pathInfo.segments.push(bezierData);
	          totalLength += bezierData.segmentLength;
	        }
	
	        i = len;
	
	        if (mask.v.c) {
	          bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
	          pathInfo.tLength += bezierData.segmentLength;
	          pathInfo.segments.push(bezierData);
	          totalLength += bezierData.segmentLength;
	        }
	
	        this._pathData.pi = pathInfo;
	      }
	
	      pathInfo = this._pathData.pi;
	      currentLength = this._pathData.f.v;
	      segmentInd = 0;
	      pointInd = 1;
	      segmentLength = 0;
	      flag = true;
	      segments = pathInfo.segments;
	
	      if (currentLength < 0 && mask.v.c) {
	        if (pathInfo.tLength < Math.abs(currentLength)) {
	          currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	        }
	
	        segmentInd = segments.length - 1;
	        points = segments[segmentInd].points;
	        pointInd = points.length - 1;
	
	        while (currentLength < 0) {
	          currentLength += points[pointInd].partialLength;
	          pointInd -= 1;
	
	          if (pointInd < 0) {
	            segmentInd -= 1;
	            points = segments[segmentInd].points;
	            pointInd = points.length - 1;
	          }
	        }
	      }
	
	      points = segments[segmentInd].points;
	      prevPoint = points[pointInd - 1];
	      currentPoint = points[pointInd];
	      partialLength = currentPoint.partialLength;
	    }
	
	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.finalSize * 1.2 * 0.714;
	    var firstLine = true;
	    var animatorProps;
	    var animatorSelector;
	    var j;
	    var jLen;
	    var letterValue;
	    jLen = animators.length;
	    var mult;
	    var ind = -1;
	    var offf;
	    var xPathPos;
	    var yPathPos;
	    var initPathPos = currentLength;
	    var initSegmentInd = segmentInd;
	    var initPointInd = pointInd;
	    var currentLine = -1;
	    var elemOpacity;
	    var sc;
	    var sw;
	    var fc;
	    var k;
	    var letterSw;
	    var letterSc;
	    var letterFc;
	    var letterM = '';
	    var letterP = this.defaultPropsArray;
	    var letterO; //
	
	    if (documentData.j === 2 || documentData.j === 1) {
	      var animatorJustifyOffset = 0;
	      var animatorFirstCharOffset = 0;
	      var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
	      var lastIndex = 0;
	      var isNewLine = true;
	
	      for (i = 0; i < len; i += 1) {
	        if (letters[i].n) {
	          if (animatorJustifyOffset) {
	            animatorJustifyOffset += animatorFirstCharOffset;
	          }
	
	          while (lastIndex < i) {
	            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	            lastIndex += 1;
	          }
	
	          animatorJustifyOffset = 0;
	          isNewLine = true;
	        } else {
	          for (j = 0; j < jLen; j += 1) {
	            animatorProps = animators[j].a;
	
	            if (animatorProps.t.propType) {
	              if (isNewLine && documentData.j === 2) {
	                animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
	              }
	
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	              if (mult.length) {
	                animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
	              } else {
	                animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
	              }
	            }
	          }
	
	          isNewLine = false;
	        }
	      }
	
	      if (animatorJustifyOffset) {
	        animatorJustifyOffset += animatorFirstCharOffset;
	      }
	
	      while (lastIndex < i) {
	        letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
	        lastIndex += 1;
	      }
	    } //
	
	
	    for (i = 0; i < len; i += 1) {
	      matrixHelper.reset();
	      elemOpacity = 1;
	
	      if (letters[i].n) {
	        xPos = 0;
	        yPos += documentData.yOffset;
	        yPos += firstLine ? 1 : 0;
	        currentLength = initPathPos;
	        firstLine = false;
	
	        if (this._hasMaskedPath) {
	          segmentInd = initSegmentInd;
	          pointInd = initPointInd;
	          points = segments[segmentInd].points;
	          prevPoint = points[pointInd - 1];
	          currentPoint = points[pointInd];
	          partialLength = currentPoint.partialLength;
	          segmentLength = 0;
	        }
	
	        letterM = '';
	        letterFc = '';
	        letterSw = '';
	        letterO = '';
	        letterP = this.defaultPropsArray;
	      } else {
	        if (this._hasMaskedPath) {
	          if (currentLine !== letters[i].line) {
	            switch (documentData.j) {
	              case 1:
	                currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                break;
	
	              case 2:
	                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
	                break;
	
	              default:
	                break;
	            }
	
	            currentLine = letters[i].line;
	          }
	
	          if (ind !== letters[i].ind) {
	            if (letters[ind]) {
	              currentLength += letters[ind].extra;
	            }
	
	            currentLength += letters[i].an / 2;
	            ind = letters[i].ind;
	          }
	
	          currentLength += alignment[0] * letters[i].an * 0.005;
	          var animatorOffset = 0;
	
	          for (j = 0; j < jLen; j += 1) {
	            animatorProps = animators[j].a;
	
	            if (animatorProps.p.propType) {
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	              if (mult.length) {
	                animatorOffset += animatorProps.p.v[0] * mult[0];
	              } else {
	                animatorOffset += animatorProps.p.v[0] * mult;
	              }
	            }
	
	            if (animatorProps.a.propType) {
	              animatorSelector = animators[j].s;
	              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	              if (mult.length) {
	                animatorOffset += animatorProps.a.v[0] * mult[0];
	              } else {
	                animatorOffset += animatorProps.a.v[0] * mult;
	              }
	            }
	          }
	
	          flag = true; // Force alignment only works with a single line for now
	
	          if (this._pathData.a.v) {
	            currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
	            currentLength += this._pathData.f.v;
	          }
	
	          while (flag) {
	            if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	              perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	              xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	              yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	              matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
	              flag = false;
	            } else if (points) {
	              segmentLength += currentPoint.partialLength;
	              pointInd += 1;
	
	              if (pointInd >= points.length) {
	                pointInd = 0;
	                segmentInd += 1;
	
	                if (!segments[segmentInd]) {
	                  if (mask.v.c) {
	                    pointInd = 0;
	                    segmentInd = 0;
	                    points = segments[segmentInd].points;
	                  } else {
	                    segmentLength -= currentPoint.partialLength;
	                    points = null;
	                  }
	                } else {
	                  points = segments[segmentInd].points;
	                }
	              }
	
	              if (points) {
	                prevPoint = currentPoint;
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	              }
	            }
	          }
	
	          offf = letters[i].an / 2 - letters[i].add;
	          matrixHelper.translate(-offf, 0, 0);
	        } else {
	          offf = letters[i].an / 2 - letters[i].add;
	          matrixHelper.translate(-offf, 0, 0); // Grouping alignment
	
	          matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	
	          if (animatorProps.t.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
	
	            if (xPos !== 0 || documentData.j !== 0) {
	              if (this._hasMaskedPath) {
	                if (mult.length) {
	                  currentLength += animatorProps.t.v * mult[0];
	                } else {
	                  currentLength += animatorProps.t.v * mult;
	                }
	              } else if (mult.length) {
	                xPos += animatorProps.t.v * mult[0];
	              } else {
	                xPos += animatorProps.t.v * mult;
	              }
	            }
	          }
	        }
	
	        if (documentData.strokeWidthAnim) {
	          sw = documentData.sw || 0;
	        }
	
	        if (documentData.strokeColorAnim) {
	          if (documentData.sc) {
	            sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	          } else {
	            sc = [0, 0, 0];
	          }
	        }
	
	        if (documentData.fillColorAnim && documentData.fc) {
	          fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	
	          if (animatorProps.a.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	            if (mult.length) {
	              matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
	            } else {
	              matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
	            }
	          }
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	
	          if (animatorProps.s.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	            if (mult.length) {
	              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
	            } else {
	              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
	            }
	          }
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	          animatorSelector = animators[j].s;
	          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	          if (animatorProps.sk.propType) {
	            if (mult.length) {
	              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	            } else {
	              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	            }
	          }
	
	          if (animatorProps.r.propType) {
	            if (mult.length) {
	              matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	            } else {
	              matrixHelper.rotateZ(-animatorProps.r.v * mult);
	            }
	          }
	
	          if (animatorProps.ry.propType) {
	            if (mult.length) {
	              matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
	            } else {
	              matrixHelper.rotateY(animatorProps.ry.v * mult);
	            }
	          }
	
	          if (animatorProps.rx.propType) {
	            if (mult.length) {
	              matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
	            } else {
	              matrixHelper.rotateX(animatorProps.rx.v * mult);
	            }
	          }
	
	          if (animatorProps.o.propType) {
	            if (mult.length) {
	              elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
	            } else {
	              elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
	            }
	          }
	
	          if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
	            if (mult.length) {
	              sw += animatorProps.sw.v * mult[0];
	            } else {
	              sw += animatorProps.sw.v * mult;
	            }
	          }
	
	          if (documentData.strokeColorAnim && animatorProps.sc.propType) {
	            for (k = 0; k < 3; k += 1) {
	              if (mult.length) {
	                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
	              } else {
	                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
	              }
	            }
	          }
	
	          if (documentData.fillColorAnim && documentData.fc) {
	            if (animatorProps.fc.propType) {
	              for (k = 0; k < 3; k += 1) {
	                if (mult.length) {
	                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
	                } else {
	                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
	                }
	              }
	            }
	
	            if (animatorProps.fh.propType) {
	              if (mult.length) {
	                fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
	              } else {
	                fc = addHueToRGB(fc, animatorProps.fh.v * mult);
	              }
	            }
	
	            if (animatorProps.fs.propType) {
	              if (mult.length) {
	                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
	              } else {
	                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
	              }
	            }
	
	            if (animatorProps.fb.propType) {
	              if (mult.length) {
	                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
	              } else {
	                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
	              }
	            }
	          }
	        }
	
	        for (j = 0; j < jLen; j += 1) {
	          animatorProps = animators[j].a;
	
	          if (animatorProps.p.propType) {
	            animatorSelector = animators[j].s;
	            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
	
	            if (this._hasMaskedPath) {
	              if (mult.length) {
	                matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	              } else {
	                matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	              }
	            } else if (mult.length) {
	              matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	            } else {
	              matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	            }
	          }
	        }
	
	        if (documentData.strokeWidthAnim) {
	          letterSw = sw < 0 ? 0 : sw;
	        }
	
	        if (documentData.strokeColorAnim) {
	          letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
	        }
	
	        if (documentData.fillColorAnim && documentData.fc) {
	          letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
	        }
	
	        if (this._hasMaskedPath) {
	          matrixHelper.translate(0, -documentData.ls);
	          matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
	
	          if (this._pathData.p.v) {
	            tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	            var rot = Math.atan(tanAngle) * 180 / Math.PI;
	
	            if (currentPoint.point[0] < prevPoint.point[0]) {
	              rot += 180;
	            }
	
	            matrixHelper.rotate(-rot * Math.PI / 180);
	          }
	
	          matrixHelper.translate(xPathPos, yPathPos, 0);
	          currentLength -= alignment[0] * letters[i].an * 0.005;
	
	          if (letters[i + 1] && ind !== letters[i + 1].ind) {
	            currentLength += letters[i].an / 2;
	            currentLength += documentData.tr * 0.001 * documentData.finalSize;
	          }
	        } else {
	          matrixHelper.translate(xPos, yPos, 0);
	
	          if (documentData.ps) {
	            // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	            matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
	          }
	
	          switch (documentData.j) {
	            case 1:
	              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
	              break;
	
	            case 2:
	              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
	              break;
	
	            default:
	              break;
	          }
	
	          matrixHelper.translate(0, -documentData.ls);
	          matrixHelper.translate(offf, 0, 0);
	          matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
	          xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
	        }
	
	        if (renderType === 'html') {
	          letterM = matrixHelper.toCSS();
	        } else if (renderType === 'svg') {
	          letterM = matrixHelper.to2dCSS();
	        } else {
	          letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
	        }
	
	        letterO = elemOpacity;
	      }
	
	      if (renderedLettersCount <= i) {
	        letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
	        this.renderedLetters.push(letterValue);
	        renderedLettersCount += 1;
	        this.lettersChangedFlag = true;
	      } else {
	        letterValue = this.renderedLetters[i];
	        this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	      }
	    }
	  };
	
	  TextAnimatorProperty.prototype.getValue = function () {
	    if (this._elem.globalData.frameId === this._frameId) {
	      return;
	    }
	
	    this._frameId = this._elem.globalData.frameId;
	    this.iterateDynamicProperties();
	  };
	
	  TextAnimatorProperty.prototype.mHelper = new Matrix();
	  TextAnimatorProperty.prototype.defaultPropsArray = [];
	  extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
	
	  function ITextElement() {}
	
	  ITextElement.prototype.initElement = function (data, globalData, comp) {
	    this.lettersChangedFlag = true;
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
	    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	    this.initRenderable();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	    this.createContent();
	    this.hide();
	    this.textAnimator.searchProperties(this.dynamicProperties);
	  };
	
	  ITextElement.prototype.prepareFrame = function (num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	  };
	
	  ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
	    var j;
	    var jLen = shapes.length;
	    var pathNodes;
	    var shapeStr = '';
	
	    for (j = 0; j < jLen; j += 1) {
	      if (shapes[j].ty === 'sh') {
	        pathNodes = shapes[j].ks.k;
	        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	      }
	    }
	
	    return shapeStr;
	  };
	
	  ITextElement.prototype.updateDocumentData = function (newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	  };
	
	  ITextElement.prototype.canResizeFont = function (_canResize) {
	    this.textProperty.canResizeFont(_canResize);
	  };
	
	  ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
	    this.textProperty.setMinimumFontSize(_fontSize);
	  };
	
	  ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if (documentData.ps) {
	      matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
	    }
	
	    matrixHelper.translate(0, -documentData.ls, 0);
	
	    switch (documentData.j) {
	      case 1:
	        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
	        break;
	
	      case 2:
	        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
	        break;
	
	      default:
	        break;
	    }
	
	    matrixHelper.translate(xPos, yPos, 0);
	  };
	
	  ITextElement.prototype.buildColor = function (colorData) {
	    return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
	  };
	
	  ITextElement.prototype.emptyProp = new LetterProps();
	
	  ITextElement.prototype.destroy = function () {};
	
	  ITextElement.prototype.validateText = function () {
	    if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
	      this.buildNewText();
	      this.textProperty._isFirstFrame = false;
	      this.textProperty._mdf = false;
	    }
	  };
	
	  var emptyShapeData = {
	    shapes: []
	  };
	
	  function SVGTextLottieElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);
	
	  SVGTextLottieElement.prototype.createContent = function () {
	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	      this.textContainer = createNS('text');
	    }
	  };
	
	  SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
	    var i = 0;
	    var len = textArray.length;
	    var textContents = [];
	    var currentTextContent = '';
	
	    while (i < len) {
	      if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
	        textContents.push(currentTextContent);
	        currentTextContent = '';
	      } else {
	        currentTextContent += textArray[i];
	      }
	
	      i += 1;
	    }
	
	    textContents.push(currentTextContent);
	    return textContents;
	  };
	
	  SVGTextLottieElement.prototype.buildShapeData = function (data, scale) {
	    // data should probably be cloned to apply scale separately to each instance of a text on different layers
	    // but since text internal content gets only rendered once and then it's never rerendered,
	    // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
	    // Avoiding cloning is preferred since cloning each character shape data is expensive
	    if (data.shapes && data.shapes.length) {
	      var shape = data.shapes[0];
	
	      if (shape.it) {
	        var shapeItem = shape.it[shape.it.length - 1];
	
	        if (shapeItem.s) {
	          shapeItem.s.k[0] = scale;
	          shapeItem.s.k[1] = scale;
	        }
	      }
	    }
	
	    return data;
	  };
	
	  SVGTextLottieElement.prototype.buildNewText = function () {
	    this.addDynamicProperty(this);
	    var i;
	    var len;
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
	
	    if (documentData.fc) {
	      this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    } else {
	      this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	
	    if (documentData.sc) {
	      this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	      this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }
	
	    this.layerElement.setAttribute('font-size', documentData.finalSize);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	
	    if (fontData.fClass) {
	      this.layerElement.setAttribute('class', fontData.fClass);
	    } else {
	      this.layerElement.setAttribute('font-family', fontData.fFamily);
	      var fWeight = documentData.fWeight;
	      var fStyle = documentData.fStyle;
	      this.layerElement.setAttribute('font-style', fStyle);
	      this.layerElement.setAttribute('font-weight', fWeight);
	    }
	
	    this.layerElement.setAttribute('aria-label', documentData.t);
	    var letters = documentData.l || [];
	    var usesGlyphs = !!this.globalData.fontManager.chars;
	    len = letters.length;
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapeStr = '';
	    var singleShape = this.data.singleShape;
	    var xPos = 0;
	    var yPos = 0;
	    var firstLine = true;
	    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
	
	    if (singleShape && !usesGlyphs && !documentData.sz) {
	      var tElement = this.textContainer;
	      var justify = 'start';
	
	      switch (documentData.j) {
	        case 1:
	          justify = 'end';
	          break;
	
	        case 2:
	          justify = 'middle';
	          break;
	
	        default:
	          justify = 'start';
	          break;
	      }
	
	      tElement.setAttribute('text-anchor', justify);
	      tElement.setAttribute('letter-spacing', trackingOffset);
	      var textContent = this.buildTextContents(documentData.finalText);
	      len = textContent.length;
	      yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
	
	      for (i = 0; i < len; i += 1) {
	        tSpan = this.textSpans[i].span || createNS('tspan');
	        tSpan.textContent = textContent[i];
	        tSpan.setAttribute('x', 0);
	        tSpan.setAttribute('y', yPos);
	        tSpan.style.display = 'inherit';
	        tElement.appendChild(tSpan);
	
	        if (!this.textSpans[i]) {
	          this.textSpans[i] = {
	            span: null,
	            glyph: null
	          };
	        }
	
	        this.textSpans[i].span = tSpan;
	        yPos += documentData.finalLineHeight;
	      }
	
	      this.layerElement.appendChild(tElement);
	    } else {
	      var cachedSpansLength = this.textSpans.length;
	      var charData;
	
	      for (i = 0; i < len; i += 1) {
	        if (!this.textSpans[i]) {
	          this.textSpans[i] = {
	            span: null,
	            childSpan: null,
	            glyph: null
	          };
	        }
	
	        if (!usesGlyphs || !singleShape || i === 0) {
	          tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
	
	          if (cachedSpansLength <= i) {
	            tSpan.setAttribute('stroke-linecap', 'butt');
	            tSpan.setAttribute('stroke-linejoin', 'round');
	            tSpan.setAttribute('stroke-miterlimit', '4');
	            this.textSpans[i].span = tSpan;
	
	            if (usesGlyphs) {
	              var childSpan = createNS('g');
	              tSpan.appendChild(childSpan);
	              this.textSpans[i].childSpan = childSpan;
	            }
	
	            this.textSpans[i].span = tSpan;
	            this.layerElement.appendChild(tSpan);
	          }
	
	          tSpan.style.display = 'inherit';
	        }
	
	        matrixHelper.reset();
	
	        if (singleShape) {
	          if (letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	          }
	
	          this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	          xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
	
	          xPos += trackingOffset;
	        }
	
	        if (usesGlyphs) {
	          charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	          var glyphElement; // t === 1 means the character has been replaced with an animated shaped
	
	          if (charData.t === 1) {
	            glyphElement = new SVGCompElement(charData.data, this.globalData, this);
	          } else {
	            var data = emptyShapeData;
	
	            if (charData.data && charData.data.shapes) {
	              data = this.buildShapeData(charData.data, documentData.finalSize);
	            }
	
	            glyphElement = new SVGShapeElement(data, this.globalData, this);
	          }
	
	          if (this.textSpans[i].glyph) {
	            var glyph = this.textSpans[i].glyph;
	            this.textSpans[i].childSpan.removeChild(glyph.layerElement);
	            glyph.destroy();
	          }
	
	          this.textSpans[i].glyph = glyphElement;
	          glyphElement._debug = true;
	          glyphElement.prepareFrame(0);
	          glyphElement.renderFrame();
	          this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
	          // this might have issues with strokes and might need a different solution
	
	          if (charData.t === 1) {
	            this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
	          }
	        } else {
	          if (singleShape) {
	            tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
	          }
	
	          tSpan.textContent = letters[i].val;
	          tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
	        } //
	
	      }
	
	      if (singleShape && tSpan) {
	        tSpan.setAttribute('d', shapeStr);
	      }
	    }
	
	    while (i < this.textSpans.length) {
	      this.textSpans[i].span.style.display = 'none';
	      i += 1;
	    }
	
	    this._sizeChanged = true;
	  };
	
	  SVGTextLottieElement.prototype.sourceRectAtTime = function () {
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderInnerContent();
	
	    if (this._sizeChanged) {
	      this._sizeChanged = false;
	      var textBox = this.layerElement.getBBox();
	      this.bbox = {
	        top: textBox.y,
	        left: textBox.x,
	        width: textBox.width,
	        height: textBox.height
	      };
	    }
	
	    return this.bbox;
	  };
	
	  SVGTextLottieElement.prototype.getValue = function () {
	    var i;
	    var len = this.textSpans.length;
	    var glyphElement;
	    this.renderedFrame = this.comp.renderedFrame;
	
	    for (i = 0; i < len; i += 1) {
	      glyphElement = this.textSpans[i].glyph;
	
	      if (glyphElement) {
	        glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
	
	        if (glyphElement._mdf) {
	          this._mdf = true;
	        }
	      }
	    }
	  };
	
	  SVGTextLottieElement.prototype.renderInnerContent = function () {
	    this.validateText();
	
	    if (!this.data.singleShape || this._mdf) {
	      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	
	      if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
	        this._sizeChanged = true;
	        var i;
	        var len;
	        var renderedLetters = this.textAnimator.renderedLetters;
	        var letters = this.textProperty.currentData.l;
	        len = letters.length;
	        var renderedLetter;
	        var textSpan;
	        var glyphElement;
	
	        for (i = 0; i < len; i += 1) {
	          if (!letters[i].n) {
	            renderedLetter = renderedLetters[i];
	            textSpan = this.textSpans[i].span;
	            glyphElement = this.textSpans[i].glyph;
	
	            if (glyphElement) {
	              glyphElement.renderFrame();
	            }
	
	            if (renderedLetter._mdf.m) {
	              textSpan.setAttribute('transform', renderedLetter.m);
	            }
	
	            if (renderedLetter._mdf.o) {
	              textSpan.setAttribute('opacity', renderedLetter.o);
	            }
	
	            if (renderedLetter._mdf.sw) {
	              textSpan.setAttribute('stroke-width', renderedLetter.sw);
	            }
	
	            if (renderedLetter._mdf.sc) {
	              textSpan.setAttribute('stroke', renderedLetter.sc);
	            }
	
	            if (renderedLetter._mdf.fc) {
	              textSpan.setAttribute('fill', renderedLetter.fc);
	            }
	          }
	        }
	      }
	    }
	  };
	
	  function ISolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([IImageElement], ISolidElement);
	
	  ISolidElement.prototype.createContent = function () {
	    var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
	    /// /rect.style.height = this.data.sh;
	    /// /rect.style.fill = this.data.sc;
	
	    rect.setAttribute('width', this.data.sw);
	    rect.setAttribute('height', this.data.sh);
	    rect.setAttribute('fill', this.data.sc);
	    this.layerElement.appendChild(rect);
	  };
	
	  function NullElement(data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initFrame();
	    this.initTransform(data, globalData, comp);
	    this.initHierarchy();
	  }
	
	  NullElement.prototype.prepareFrame = function (num) {
	    this.prepareProperties(num, true);
	  };
	
	  NullElement.prototype.renderFrame = function () {};
	
	  NullElement.prototype.getBaseElement = function () {
	    return null;
	  };
	
	  NullElement.prototype.destroy = function () {};
	
	  NullElement.prototype.sourceRectAtTime = function () {};
	
	  NullElement.prototype.hide = function () {};
	
	  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
	
	  function SVGRendererBase() {}
	
	  extendPrototype([BaseRenderer], SVGRendererBase);
	
	  SVGRendererBase.prototype.createNull = function (data) {
	    return new NullElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.createShape = function (data) {
	    return new SVGShapeElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.createText = function (data) {
	    return new SVGTextLottieElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.createImage = function (data) {
	    return new IImageElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.createSolid = function (data) {
	    return new ISolidElement(data, this.globalData, this);
	  };
	
	  SVGRendererBase.prototype.configAnimation = function (animData) {
	    this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	    this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
	
	    if (this.renderConfig.viewBoxSize) {
	      this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
	    } else {
	      this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
	    }
	
	    if (!this.renderConfig.viewBoxOnly) {
	      this.svgElement.setAttribute('width', animData.w);
	      this.svgElement.setAttribute('height', animData.h);
	      this.svgElement.style.width = '100%';
	      this.svgElement.style.height = '100%';
	      this.svgElement.style.transform = 'translate3d(0,0,0)';
	      this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
	    }
	
	    if (this.renderConfig.width) {
	      this.svgElement.setAttribute('width', this.renderConfig.width);
	    }
	
	    if (this.renderConfig.height) {
	      this.svgElement.setAttribute('height', this.renderConfig.height);
	    }
	
	    if (this.renderConfig.className) {
	      this.svgElement.setAttribute('class', this.renderConfig.className);
	    }
	
	    if (this.renderConfig.id) {
	      this.svgElement.setAttribute('id', this.renderConfig.id);
	    }
	
	    if (this.renderConfig.focusable !== undefined) {
	      this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
	    }
	
	    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
	    // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	
	    this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
	
	    var defs = this.globalData.defs;
	    this.setupGlobalData(animData, defs);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.data = animData;
	    var maskElement = createNS('clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width', animData.w);
	    rect.setAttribute('height', animData.h);
	    rect.setAttribute('x', 0);
	    rect.setAttribute('y', 0);
	    var maskId = createElementID();
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
	    defs.appendChild(maskElement);
	    this.layers = animData.layers;
	    this.elements = createSizedArray(animData.layers.length);
	  };
	
	  SVGRendererBase.prototype.destroy = function () {
	    if (this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }
	
	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i;
	    var len = this.layers ? this.layers.length : 0;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }
	
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	  };
	
	  SVGRendererBase.prototype.updateContainerSize = function () {};
	
	  SVGRendererBase.prototype.findIndexByInd = function (ind) {
	    var i = 0;
	    var len = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.layers[i].ind === ind) {
	        return i;
	      }
	    }
	
	    return -1;
	  };
	
	  SVGRendererBase.prototype.buildItem = function (pos) {
	    var elements = this.elements;
	
	    if (elements[pos] || this.layers[pos].ty === 99) {
	      return;
	    }
	
	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	    elements[pos] = element;
	
	    if (getExpressionsPlugin()) {
	      if (this.layers[pos].ty === 0) {
	        this.globalData.projectInterface.registerComposition(element);
	      }
	
	      element.initExpressions();
	    }
	
	    this.appendElementInPos(element, pos);
	
	    if (this.layers[pos].tt) {
	      var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
	
	      if (elementIndex === -1) {
	        return;
	      }
	
	      if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
	        this.buildItem(elementIndex);
	        this.addPendingElement(element);
	      } else {
	        var matteElement = elements[elementIndex];
	        var matteMask = matteElement.getMatte(this.layers[pos].tt);
	        element.setMatte(matteMask);
	      }
	    }
	  };
	
	  SVGRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	
	      if (element.data.tt) {
	        var i = 0;
	        var len = this.elements.length;
	
	        while (i < len) {
	          if (this.elements[i] === element) {
	            var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
	            var matteElement = this.elements[elementIndex];
	            var matteMask = matteElement.getMatte(this.layers[i].tt);
	            element.setMatte(matteMask);
	            break;
	          }
	
	          i += 1;
	        }
	      }
	    }
	  };
	
	  SVGRendererBase.prototype.renderFrame = function (num) {
	    if (this.renderedFrame === num || this.destroyed) {
	      return;
	    }
	
	    if (num === null) {
	      num = this.renderedFrame;
	    } else {
	      this.renderedFrame = num;
	    } // console.log('-------');
	    // console.log('FRAME ',num);
	
	
	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    this.globalData._mdf = false;
	    var i;
	    var len = this.layers.length;
	
	    if (!this.completeLayers) {
	      this.checkLayers(num);
	    }
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(num - this.layers[i].st);
	      }
	    }
	
	    if (this.globalData._mdf) {
	      for (i = 0; i < len; i += 1) {
	        if (this.completeLayers || this.elements[i]) {
	          this.elements[i].renderFrame();
	        }
	      }
	    }
	  };
	
	  SVGRendererBase.prototype.appendElementInPos = function (element, pos) {
	    var newElement = element.getBaseElement();
	
	    if (!newElement) {
	      return;
	    }
	
	    var i = 0;
	    var nextElement;
	
	    while (i < pos) {
	      if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
	        nextElement = this.elements[i].getBaseElement();
	      }
	
	      i += 1;
	    }
	
	    if (nextElement) {
	      this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	      this.layerElement.appendChild(newElement);
	    }
	  };
	
	  SVGRendererBase.prototype.hide = function () {
	    this.layerElement.style.display = 'none';
	  };
	
	  SVGRendererBase.prototype.show = function () {
	    this.layerElement.style.display = 'block';
	  };
	
	  function ICompElement() {}
	
	  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);
	
	  ICompElement.prototype.initElement = function (data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initTransform(data, globalData, comp);
	    this.initRenderable();
	    this.initHierarchy();
	    this.initRendererElement();
	    this.createContainerElements();
	    this.createRenderableComponents();
	
	    if (this.data.xt || !globalData.progressiveLoad) {
	      this.buildAllItems();
	    }
	
	    this.hide();
	  };
	  /* ICompElement.prototype.hide = function(){
	      if(!this.hidden){
	          this.hideElement();
	          var i,len = this.elements.length;
	          for( i = 0; i < len; i+=1 ){
	              if(this.elements[i]){
	                  this.elements[i].hide();
	              }
	          }
	      }
	  }; */
	
	
	  ICompElement.prototype.prepareFrame = function (num) {
	    this._mdf = false;
	    this.prepareRenderableFrame(num);
	    this.prepareProperties(num, this.isInRange);
	
	    if (!this.isInRange && !this.data.xt) {
	      return;
	    }
	
	    if (!this.tm._placeholder) {
	      var timeRemapped = this.tm.v;
	
	      if (timeRemapped === this.data.op) {
	        timeRemapped = this.data.op - 1;
	      }
	
	      this.renderedFrame = timeRemapped;
	    } else {
	      this.renderedFrame = num / this.data.sr;
	    }
	
	    var i;
	    var len = this.elements.length;
	
	    if (!this.completeLayers) {
	      this.checkLayers(this.renderedFrame);
	    } // This iteration needs to be backwards because of how expressions connect between each other
	
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
	
	        if (this.elements[i]._mdf) {
	          this._mdf = true;
	        }
	      }
	    }
	  };
	
	  ICompElement.prototype.renderInnerContent = function () {
	    var i;
	    var len = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].renderFrame();
	      }
	    }
	  };
	
	  ICompElement.prototype.setElements = function (elems) {
	    this.elements = elems;
	  };
	
	  ICompElement.prototype.getElements = function () {
	    return this.elements;
	  };
	
	  ICompElement.prototype.destroyElements = function () {
	    var i;
	    var len = this.layers.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i]) {
	        this.elements[i].destroy();
	      }
	    }
	  };
	
	  ICompElement.prototype.destroy = function () {
	    this.destroyElements();
	    this.destroyBaseElement();
	  };
	
	  function SVGCompElement(data, globalData, comp) {
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }
	
	  extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);
	
	  SVGCompElement.prototype.createComp = function (data) {
	    return new SVGCompElement(data, this.globalData, this);
	  };
	
	  function SVGRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.svgElement = createNS('svg');
	    var ariaLabel = '';
	
	    if (config && config.title) {
	      var titleElement = createNS('title');
	      var titleId = createElementID();
	      titleElement.setAttribute('id', titleId);
	      titleElement.textContent = config.title;
	      this.svgElement.appendChild(titleElement);
	      ariaLabel += titleId;
	    }
	
	    if (config && config.description) {
	      var descElement = createNS('desc');
	      var descId = createElementID();
	      descElement.setAttribute('id', descId);
	      descElement.textContent = config.description;
	      this.svgElement.appendChild(descElement);
	      ariaLabel += ' ' + descId;
	    }
	
	    if (ariaLabel) {
	      this.svgElement.setAttribute('aria-labelledby', ariaLabel);
	    }
	
	    var defs = createNS('defs');
	    this.svgElement.appendChild(defs);
	    var maskElement = createNS('g');
	    this.svgElement.appendChild(maskElement);
	    this.layerElement = maskElement;
	    this.renderConfig = {
	      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      contentVisibility: config && config.contentVisibility || 'visible',
	      progressiveLoad: config && config.progressiveLoad || false,
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      viewBoxOnly: config && config.viewBoxOnly || false,
	      viewBoxSize: config && config.viewBoxSize || false,
	      className: config && config.className || '',
	      id: config && config.id || '',
	      focusable: config && config.focusable,
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '100%',
	        height: config && config.filterSize && config.filterSize.height || '100%',
	        x: config && config.filterSize && config.filterSize.x || '0%',
	        y: config && config.filterSize && config.filterSize.y || '0%'
	      },
	      width: config && config.width,
	      height: config && config.height,
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      defs: defs,
	      renderConfig: this.renderConfig
	    };
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	    this.rendererType = 'svg';
	  }
	
	  extendPrototype([SVGRendererBase], SVGRenderer);
	
	  SVGRenderer.prototype.createComp = function (data) {
	    return new SVGCompElement(data, this.globalData, this);
	  };
	
	  function ShapeTransformManager() {
	    this.sequences = {};
	    this.sequenceList = [];
	    this.transform_key_count = 0;
	  }
	
	  ShapeTransformManager.prototype = {
	    addTransformSequence: function addTransformSequence(transforms) {
	      var i;
	      var len = transforms.length;
	      var key = '_';
	
	      for (i = 0; i < len; i += 1) {
	        key += transforms[i].transform.key + '_';
	      }
	
	      var sequence = this.sequences[key];
	
	      if (!sequence) {
	        sequence = {
	          transforms: [].concat(transforms),
	          finalTransform: new Matrix(),
	          _mdf: false
	        };
	        this.sequences[key] = sequence;
	        this.sequenceList.push(sequence);
	      }
	
	      return sequence;
	    },
	    processSequence: function processSequence(sequence, isFirstFrame) {
	      var i = 0;
	      var len = sequence.transforms.length;
	      var _mdf = isFirstFrame;
	
	      while (i < len && !isFirstFrame) {
	        if (sequence.transforms[i].transform.mProps._mdf) {
	          _mdf = true;
	          break;
	        }
	
	        i += 1;
	      }
	
	      if (_mdf) {
	        sequence.finalTransform.reset();
	
	        for (i = len - 1; i >= 0; i -= 1) {
	          sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
	        }
	      }
	
	      sequence._mdf = _mdf;
	    },
	    processSequences: function processSequences(isFirstFrame) {
	      var i;
	      var len = this.sequenceList.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.processSequence(this.sequenceList[i], isFirstFrame);
	      }
	    },
	    getNewKey: function getNewKey() {
	      this.transform_key_count += 1;
	      return '_' + this.transform_key_count;
	    }
	  };
	
	  var lumaLoader = function lumaLoader() {
	    var id = '__lottie_element_luma_buffer';
	    var lumaBuffer = null;
	    var lumaBufferCtx = null;
	    var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
	    // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
	    // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
	    // Naming it solution 2 to mark the extra comment lines.
	
	    /*
	    var svgString = [
	      '<svg xmlns="http://www.w3.org/2000/svg">',
	      '<filter id="' + id + '">',
	      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0, ',
	      '0.3, 0.3, 0.3, 0, 0',
	      '"/>',
	      '</filter>',
	      '</svg>',
	    ].join('');
	    var blob = new Blob([svgString], { type: 'image/svg+xml' });
	    var url = URL.createObjectURL(blob);
	    */
	
	    function createLumaSvgFilter() {
	      var _svg = createNS('svg');
	
	      var fil = createNS('filter');
	      var matrix = createNS('feColorMatrix');
	      fil.setAttribute('id', id);
	      matrix.setAttribute('type', 'matrix');
	      matrix.setAttribute('color-interpolation-filters', 'sRGB');
	      matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
	      fil.appendChild(matrix);
	
	      _svg.appendChild(fil);
	
	      _svg.setAttribute('id', id + '_svg');
	
	      if (featureSupport.svgLumaHidden) {
	        _svg.style.display = 'none';
	      }
	
	      return _svg;
	    }
	
	    function loadLuma() {
	      if (!lumaBuffer) {
	        svg = createLumaSvgFilter();
	        document.body.appendChild(svg);
	        lumaBuffer = createTag('canvas');
	        lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
	
	        lumaBufferCtx.filter = 'url(#' + id + ')';
	        lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
	        lumaBufferCtx.fillRect(0, 0, 1, 1);
	      }
	    }
	
	    function getLuma(canvas) {
	      if (!lumaBuffer) {
	        loadLuma();
	      }
	
	      lumaBuffer.width = canvas.width;
	      lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
	
	      lumaBufferCtx.filter = 'url(#' + id + ')';
	      return lumaBuffer;
	    }
	
	    return {
	      load: loadLuma,
	      get: getLuma
	    };
	  };
	
	  function createCanvas(width, height) {
	    if (featureSupport.offscreenCanvas) {
	      return new OffscreenCanvas(width, height);
	    }
	
	    var canvas = createTag('canvas');
	    canvas.width = width;
	    canvas.height = height;
	    return canvas;
	  }
	
	  var assetLoader = function () {
	    return {
	      loadLumaCanvas: lumaLoader.load,
	      getLumaCanvas: lumaLoader.get,
	      createCanvas: createCanvas
	    };
	  }();
	
	  var registeredEffects = {};
	
	  function CVEffects(elem) {
	    var i;
	    var len = elem.data.ef ? elem.data.ef.length : 0;
	    this.filters = [];
	    var filterManager;
	
	    for (i = 0; i < len; i += 1) {
	      filterManager = null;
	      var type = elem.data.ef[i].ty;
	
	      if (registeredEffects[type]) {
	        var Effect = registeredEffects[type].effect;
	        filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
	      }
	
	      if (filterManager) {
	        this.filters.push(filterManager);
	      }
	    }
	
	    if (this.filters.length) {
	      elem.addRenderableComponent(this);
	    }
	  }
	
	  CVEffects.prototype.renderFrame = function (_isFirstFrame) {
	    var i;
	    var len = this.filters.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.filters[i].renderFrame(_isFirstFrame);
	    }
	  };
	
	  CVEffects.prototype.getEffects = function (type) {
	    var i;
	    var len = this.filters.length;
	    var effects = [];
	
	    for (i = 0; i < len; i += 1) {
	      if (this.filters[i].type === type) {
	        effects.push(this.filters[i]);
	      }
	    }
	
	    return effects;
	  };
	
	  function registerEffect(id, effect) {
	    registeredEffects[id] = {
	      effect: effect
	    };
	  }
	
	  function CVMaskElement(data, element) {
	    this.data = data;
	    this.element = element;
	    this.masksProperties = this.data.masksProperties || [];
	    this.viewData = createSizedArray(this.masksProperties.length);
	    var i;
	    var len = this.masksProperties.length;
	    var hasMasks = false;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.masksProperties[i].mode !== 'n') {
	        hasMasks = true;
	      }
	
	      this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
	    }
	
	    this.hasMasks = hasMasks;
	
	    if (hasMasks) {
	      this.element.addRenderableComponent(this);
	    }
	  }
	
	  CVMaskElement.prototype.renderFrame = function () {
	    if (!this.hasMasks) {
	      return;
	    }
	
	    var transform = this.element.finalTransform.mat;
	    var ctx = this.element.canvasContext;
	    var i;
	    var len = this.masksProperties.length;
	    var pt;
	    var pts;
	    var data;
	    ctx.beginPath();
	
	    for (i = 0; i < len; i += 1) {
	      if (this.masksProperties[i].mode !== 'n') {
	        if (this.masksProperties[i].inv) {
	          ctx.moveTo(0, 0);
	          ctx.lineTo(this.element.globalData.compSize.w, 0);
	          ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
	          ctx.lineTo(0, this.element.globalData.compSize.h);
	          ctx.lineTo(0, 0);
	        }
	
	        data = this.viewData[i].v;
	        pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
	        ctx.moveTo(pt[0], pt[1]);
	        var j;
	        var jLen = data._length;
	
	        for (j = 1; j < jLen; j += 1) {
	          pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
	          ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	        }
	
	        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
	        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
	      }
	    }
	
	    this.element.globalData.renderer.save(true);
	    ctx.clip();
	  };
	
	  CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
	
	  CVMaskElement.prototype.destroy = function () {
	    this.element = null;
	  };
	
	  function CVBaseElement() {}
	
	  var operationsMap = {
	    1: 'source-in',
	    2: 'source-out',
	    3: 'source-in',
	    4: 'source-out'
	  };
	  CVBaseElement.prototype = {
	    createElements: function createElements() {},
	    initRendererElement: function initRendererElement() {},
	    createContainerElements: function createContainerElements() {
	      // If the layer is masked we will use two buffers to store each different states of the drawing
	      // This solution is not ideal for several reason. But unfortunately, because of the recursive
	      // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
	      // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
	      // It might be challenging because the layer most likely is transformed in some way
	      if (this.data.tt >= 1) {
	        this.buffers = [];
	        var canvasContext = this.globalData.canvasContext;
	        var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
	        this.buffers.push(bufferCanvas);
	        var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
	        this.buffers.push(bufferCanvas2);
	
	        if (this.data.tt >= 3 && !document._isProxy) {
	          assetLoader.loadLumaCanvas();
	        }
	      }
	
	      this.canvasContext = this.globalData.canvasContext;
	      this.transformCanvas = this.globalData.transformCanvas;
	      this.renderableEffectsManager = new CVEffects(this);
	      this.searchEffectTransforms();
	    },
	    createContent: function createContent() {},
	    setBlendMode: function setBlendMode() {
	      var globalData = this.globalData;
	
	      if (globalData.blendMode !== this.data.bm) {
	        globalData.blendMode = this.data.bm;
	        var blendModeValue = getBlendMode(this.data.bm);
	        globalData.canvasContext.globalCompositeOperation = blendModeValue;
	      }
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new CVMaskElement(this.data, this);
	      this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
	    },
	    hideElement: function hideElement() {
	      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
	        this.hidden = true;
	      }
	    },
	    showElement: function showElement() {
	      if (this.isInRange && !this.isTransparent) {
	        this.hidden = false;
	        this._isFirstFrame = true;
	        this.maskManager._isFirstFrame = true;
	      }
	    },
	    clearCanvas: function clearCanvas(canvasContext) {
	      canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
	    },
	    prepareLayer: function prepareLayer() {
	      if (this.data.tt >= 1) {
	        var buffer = this.buffers[0];
	        var bufferCtx = buffer.getContext('2d');
	        this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
	
	        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
	        // TODO: Check if there is a way to clear the canvas without resetting the transform
	
	        this.currentTransform = this.canvasContext.getTransform();
	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
	        this.clearCanvas(this.canvasContext);
	        this.canvasContext.setTransform(this.currentTransform);
	      }
	    },
	    exitLayer: function exitLayer() {
	      if (this.data.tt >= 1) {
	        var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
	        // that only contains the content of this layer
	        // (if it is a composition, it also includes the nested layers)
	
	        var bufferCtx = buffer.getContext('2d');
	        this.clearCanvas(bufferCtx);
	        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
	
	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
	        this.clearCanvas(this.canvasContext);
	        this.canvasContext.setTransform(this.currentTransform); // We draw the mask
	
	        var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
	        mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
	
	        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
	        // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
	
	        if (this.data.tt >= 3 && !document._isProxy) {
	          // We copy the painted mask to a buffer that has a color matrix filter applied to it
	          // that applies the rgb values to the alpha channel
	          var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
	          var lumaBufferCtx = lumaBuffer.getContext('2d');
	          lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
	          this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
	
	          this.canvasContext.drawImage(lumaBuffer, 0, 0);
	        }
	
	        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
	        this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
	        // We use destination-over to draw the global drawing below the current layer
	
	        this.canvasContext.globalCompositeOperation = 'destination-over';
	        this.canvasContext.drawImage(this.buffers[0], 0, 0);
	        this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
	
	        this.canvasContext.globalCompositeOperation = 'source-over';
	      }
	    },
	    renderFrame: function renderFrame(forceRender) {
	      if (this.hidden || this.data.hd) {
	        return;
	      }
	
	      if (this.data.td === 1 && !forceRender) {
	        return;
	      }
	
	      this.renderTransform();
	      this.renderRenderable();
	      this.renderLocalTransform();
	      this.setBlendMode();
	      var forceRealStack = this.data.ty === 0;
	      this.prepareLayer();
	      this.globalData.renderer.save(forceRealStack);
	      this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
	      this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
	      this.renderInnerContent();
	      this.globalData.renderer.restore(forceRealStack);
	      this.exitLayer();
	
	      if (this.maskManager.hasMasks) {
	        this.globalData.renderer.restore(true);
	      }
	
	      if (this._isFirstFrame) {
	        this._isFirstFrame = false;
	      }
	    },
	    destroy: function destroy() {
	      this.canvasContext = null;
	      this.data = null;
	      this.globalData = null;
	      this.maskManager.destroy();
	    },
	    mHelper: new Matrix()
	  };
	  CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
	  CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
	
	  function CVShapeData(element, data, styles, transformsManager) {
	    this.styledShapes = [];
	    this.tr = [0, 0, 0, 0, 0, 0];
	    var ty = 4;
	
	    if (data.ty === 'rc') {
	      ty = 5;
	    } else if (data.ty === 'el') {
	      ty = 6;
	    } else if (data.ty === 'sr') {
	      ty = 7;
	    }
	
	    this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
	    var i;
	    var len = styles.length;
	    var styledShape;
	
	    for (i = 0; i < len; i += 1) {
	      if (!styles[i].closed) {
	        styledShape = {
	          transforms: transformsManager.addTransformSequence(styles[i].transforms),
	          trNodes: []
	        };
	        this.styledShapes.push(styledShape);
	        styles[i].elements.push(styledShape);
	      }
	    }
	  }
	
	  CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
	
	  function CVShapeElement(data, globalData, comp) {
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this.transformsManager = new ShapeTransformManager();
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);
	  CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
	  CVShapeElement.prototype.transformHelper = {
	    opacity: 1,
	    _opMdf: false
	  };
	  CVShapeElement.prototype.dashResetter = [];
	
	  CVShapeElement.prototype.createContent = function () {
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
	  };
	
	  CVShapeElement.prototype.createStyleElement = function (data, transforms) {
	    var styleElem = {
	      data: data,
	      type: data.ty,
	      preTransforms: this.transformsManager.addTransformSequence(transforms),
	      transforms: [],
	      elements: [],
	      closed: data.hd === true
	    };
	    var elementData = {};
	
	    if (data.ty === 'fl' || data.ty === 'st') {
	      elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
	
	      if (!elementData.c.k) {
	        styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
	      }
	    } else if (data.ty === 'gf' || data.ty === 'gs') {
	      elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
	      elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
	      elementData.h = PropertyFactory.getProp(this, data.h || {
	        k: 0
	      }, 0, 0.01, this);
	      elementData.a = PropertyFactory.getProp(this, data.a || {
	        k: 0
	      }, 0, degToRads, this);
	      elementData.g = new GradientProperty(this, data.g, this);
	    }
	
	    elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
	
	    if (data.ty === 'st' || data.ty === 'gs') {
	      styleElem.lc = lineCapEnum[data.lc || 2];
	      styleElem.lj = lineJoinEnum[data.lj || 2];
	
	      if (data.lj == 1) {
	        // eslint-disable-line eqeqeq
	        styleElem.ml = data.ml;
	      }
	
	      elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
	
	      if (!elementData.w.k) {
	        styleElem.wi = elementData.w.v;
	      }
	
	      if (data.d) {
	        var d = new DashProperty(this, data.d, 'canvas', this);
	        elementData.d = d;
	
	        if (!elementData.d.k) {
	          styleElem.da = elementData.d.dashArray;
	          styleElem["do"] = elementData.d.dashoffset[0];
	        }
	      }
	    } else {
	      styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }
	
	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	  };
	
	  CVShapeElement.prototype.createGroupElement = function () {
	    var elementData = {
	      it: [],
	      prevViewData: []
	    };
	    return elementData;
	  };
	
	  CVShapeElement.prototype.createTransformElement = function (data) {
	    var elementData = {
	      transform: {
	        opacity: 1,
	        _opMdf: false,
	        key: this.transformsManager.getNewKey(),
	        op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
	        mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
	      }
	    };
	    return elementData;
	  };
	
	  CVShapeElement.prototype.createShapeElement = function (data) {
	    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
	    this.shapes.push(elementData);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	  };
	
	  CVShapeElement.prototype.reloadShapes = function () {
	    this._isFirstFrame = true;
	    var i;
	    var len = this.itemsData.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.prevViewData[i] = this.itemsData[i];
	    }
	
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
	    len = this.dynamicProperties.length;
	
	    for (i = 0; i < len; i += 1) {
	      this.dynamicProperties[i].getValue();
	    }
	
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	  };
	
	  CVShapeElement.prototype.addTransformToStyleList = function (transform) {
	    var i;
	    var len = this.stylesList.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (!this.stylesList[i].closed) {
	        this.stylesList[i].transforms.push(transform);
	      }
	    }
	  };
	
	  CVShapeElement.prototype.removeTransformFromStyleList = function () {
	    var i;
	    var len = this.stylesList.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (!this.stylesList[i].closed) {
	        this.stylesList[i].transforms.pop();
	      }
	    }
	  };
	
	  CVShapeElement.prototype.closeStyles = function (styles) {
	    var i;
	    var len = styles.length;
	
	    for (i = 0; i < len; i += 1) {
	      styles[i].closed = true;
	    }
	  };
	
	  CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
	    var i;
	    var len = arr.length - 1;
	    var j;
	    var jLen;
	    var ownStyles = [];
	    var ownModifiers = [];
	    var processedPos;
	    var modifier;
	    var currentTransform;
	    var ownTransforms = [].concat(transforms);
	
	    for (i = len; i >= 0; i -= 1) {
	      processedPos = this.searchProcessedElement(arr[i]);
	
	      if (!processedPos) {
	        arr[i]._shouldRender = shouldRender;
	      } else {
	        itemsData[i] = prevViewData[processedPos - 1];
	      }
	
	      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
	        if (!processedPos) {
	          itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
	        } else {
	          itemsData[i].style.closed = false;
	        }
	
	        ownStyles.push(itemsData[i].style);
	      } else if (arr[i].ty === 'gr') {
	        if (!processedPos) {
	          itemsData[i] = this.createGroupElement(arr[i]);
	        } else {
	          jLen = itemsData[i].it.length;
	
	          for (j = 0; j < jLen; j += 1) {
	            itemsData[i].prevViewData[j] = itemsData[i].it[j];
	          }
	        }
	
	        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
	      } else if (arr[i].ty === 'tr') {
	        if (!processedPos) {
	          currentTransform = this.createTransformElement(arr[i]);
	          itemsData[i] = currentTransform;
	        }
	
	        ownTransforms.push(itemsData[i]);
	        this.addTransformToStyleList(itemsData[i]);
	      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
	        if (!processedPos) {
	          itemsData[i] = this.createShapeElement(arr[i]);
	        }
	      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          modifier.init(this, arr[i]);
	          itemsData[i] = modifier;
	          this.shapeModifiers.push(modifier);
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = false;
	        }
	
	        ownModifiers.push(modifier);
	      } else if (arr[i].ty === 'rp') {
	        if (!processedPos) {
	          modifier = ShapeModifiers.getModifier(arr[i].ty);
	          itemsData[i] = modifier;
	          modifier.init(this, arr, i, itemsData);
	          this.shapeModifiers.push(modifier);
	          shouldRender = false;
	        } else {
	          modifier = itemsData[i];
	          modifier.closed = true;
	        }
	
	        ownModifiers.push(modifier);
	      }
	
	      this.addProcessedElement(arr[i], i + 1);
	    }
	
	    this.removeTransformFromStyleList();
	    this.closeStyles(ownStyles);
	    len = ownModifiers.length;
	
	    for (i = 0; i < len; i += 1) {
	      ownModifiers[i].closed = true;
	    }
	  };
	
	  CVShapeElement.prototype.renderInnerContent = function () {
	    this.transformHelper.opacity = 1;
	    this.transformHelper._opMdf = false;
	    this.renderModifiers();
	    this.transformsManager.processSequences(this._isFirstFrame);
	    this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
	  };
	
	  CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
	    if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
	      groupTransform.opacity = parentTransform.opacity;
	      groupTransform.opacity *= groupTransform.op.v;
	      groupTransform._opMdf = true;
	    }
	  };
	
	  CVShapeElement.prototype.drawLayer = function () {
	    var i;
	    var len = this.stylesList.length;
	    var j;
	    var jLen;
	    var k;
	    var kLen;
	    var elems;
	    var nodes;
	    var renderer = this.globalData.renderer;
	    var ctx = this.globalData.canvasContext;
	    var type;
	    var currentStyle;
	
	    for (i = 0; i < len; i += 1) {
	      currentStyle = this.stylesList[i];
	      type = currentStyle.type; // Skipping style when
	      // Stroke width equals 0
	      // style should not be rendered (extra unused repeaters)
	      // current opacity equals 0
	      // global opacity equals 0
	
	      if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
	        renderer.save();
	        elems = currentStyle.elements;
	
	        if (type === 'st' || type === 'gs') {
	          renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
	
	          renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
	
	          renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
	
	          renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
	
	          renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
	        } else {
	          renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
	        }
	
	        renderer.ctxOpacity(currentStyle.coOp);
	
	        if (type !== 'st' && type !== 'gs') {
	          ctx.beginPath();
	        }
	
	        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
	        jLen = elems.length;
	
	        for (j = 0; j < jLen; j += 1) {
	          if (type === 'st' || type === 'gs') {
	            ctx.beginPath();
	
	            if (currentStyle.da) {
	              ctx.setLineDash(currentStyle.da);
	              ctx.lineDashOffset = currentStyle["do"];
	            }
	          }
	
	          nodes = elems[j].trNodes;
	          kLen = nodes.length;
	
	          for (k = 0; k < kLen; k += 1) {
	            if (nodes[k].t === 'm') {
	              ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
	            } else if (nodes[k].t === 'c') {
	              ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
	            } else {
	              ctx.closePath();
	            }
	          }
	
	          if (type === 'st' || type === 'gs') {
	            // ctx.stroke();
	            renderer.ctxStroke();
	
	            if (currentStyle.da) {
	              ctx.setLineDash(this.dashResetter);
	            }
	          }
	        }
	
	        if (type !== 'st' && type !== 'gs') {
	          // ctx.fill(currentStyle.r);
	          this.globalData.renderer.ctxFill(currentStyle.r);
	        }
	
	        renderer.restore();
	      }
	    }
	  };
	
	  CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
	    var i;
	    var len = items.length - 1;
	    var groupTransform;
	    groupTransform = parentTransform;
	
	    for (i = len; i >= 0; i -= 1) {
	      if (items[i].ty === 'tr') {
	        groupTransform = data[i].transform;
	        this.renderShapeTransform(parentTransform, groupTransform);
	      } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
	        this.renderPath(items[i], data[i]);
	      } else if (items[i].ty === 'fl') {
	        this.renderFill(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'st') {
	        this.renderStroke(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
	        this.renderGradientFill(items[i], data[i], groupTransform);
	      } else if (items[i].ty === 'gr') {
	        this.renderShape(groupTransform, items[i].it, data[i].it);
	      } else if (items[i].ty === 'tm') {//
	      }
	    }
	
	    if (isMain) {
	      this.drawLayer();
	    }
	  };
	
	  CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
	    if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
	      var shapeNodes = styledShape.trNodes;
	      var paths = shape.paths;
	      var i;
	      var len;
	      var j;
	      var jLen = paths._length;
	      shapeNodes.length = 0;
	      var groupTransformMat = styledShape.transforms.finalTransform;
	
	      for (j = 0; j < jLen; j += 1) {
	        var pathNodes = paths.shapes[j];
	
	        if (pathNodes && pathNodes.v) {
	          len = pathNodes._length;
	
	          for (i = 1; i < len; i += 1) {
	            if (i === 1) {
	              shapeNodes.push({
	                t: 'm',
	                p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	              });
	            }
	
	            shapeNodes.push({
	              t: 'c',
	              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
	            });
	          }
	
	          if (len === 1) {
	            shapeNodes.push({
	              t: 'm',
	              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	            });
	          }
	
	          if (pathNodes.c && len) {
	            shapeNodes.push({
	              t: 'c',
	              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
	            });
	            shapeNodes.push({
	              t: 'z'
	            });
	          }
	        }
	      }
	
	      styledShape.trNodes = shapeNodes;
	    }
	  };
	
	  CVShapeElement.prototype.renderPath = function (pathData, itemData) {
	    if (pathData.hd !== true && pathData._shouldRender) {
	      var i;
	      var len = itemData.styledShapes.length;
	
	      for (i = 0; i < len; i += 1) {
	        this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
	      }
	    }
	  };
	
	  CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	
	    if (itemData.c._mdf || this._isFirstFrame) {
	      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
	    }
	
	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	      styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }
	  };
	
	  CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	    var grd;
	
	    if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
	      var ctx = this.globalData.canvasContext;
	      var pt1 = itemData.s.v;
	      var pt2 = itemData.e.v;
	
	      if (styleData.t === 1) {
	        grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
	      } else {
	        var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
	        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
	        var percent = itemData.h.v;
	
	        if (percent >= 1) {
	          percent = 0.99;
	        } else if (percent <= -1) {
	          percent = -0.99;
	        }
	
	        var dist = rad * percent;
	        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
	        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
	        grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
	      }
	
	      var i;
	      var len = styleData.g.p;
	      var cValues = itemData.g.c;
	      var opacity = 1;
	
	      for (i = 0; i < len; i += 1) {
	        if (itemData.g._hasOpacity && itemData.g._collapsable) {
	          opacity = itemData.g.o[i * 2 + 1];
	        }
	
	        grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
	      }
	
	      styleElem.grd = grd;
	    }
	
	    styleElem.coOp = itemData.o.v * groupTransform.opacity;
	  };
	
	  CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
	    var styleElem = itemData.style;
	    var d = itemData.d;
	
	    if (d && (d._mdf || this._isFirstFrame)) {
	      styleElem.da = d.dashArray;
	      styleElem["do"] = d.dashoffset[0];
	    }
	
	    if (itemData.c._mdf || this._isFirstFrame) {
	      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
	    }
	
	    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
	      styleElem.coOp = itemData.o.v * groupTransform.opacity;
	    }
	
	    if (itemData.w._mdf || this._isFirstFrame) {
	      styleElem.wi = itemData.w.v;
	    }
	  };
	
	  CVShapeElement.prototype.destroy = function () {
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemsData.length = 0;
	  };
	
	  function CVTextElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	      fill: 'rgba(0,0,0,0)',
	      stroke: 'rgba(0,0,0,0)',
	      sWidth: 0,
	      fValue: ''
	    };
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);
	  CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
	
	  CVTextElement.prototype.buildNewText = function () {
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var hasFill = false;
	
	    if (documentData.fc) {
	      hasFill = true;
	      this.values.fill = this.buildColor(documentData.fc);
	    } else {
	      this.values.fill = 'rgba(0,0,0,0)';
	    }
	
	    this.fill = hasFill;
	    var hasStroke = false;
	
	    if (documentData.sc) {
	      hasStroke = true;
	      this.values.stroke = this.buildColor(documentData.sc);
	      this.values.sWidth = documentData.sw;
	    }
	
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i;
	    var len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
	
	    var charData;
	    var shapeData;
	    var k;
	    var kLen;
	    var shapes;
	    var j;
	    var jLen;
	    var pathNodes;
	    var commands;
	    var pathArr;
	    var singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
	    var xPos = 0;
	    var yPos = 0;
	    var firstLine = true;
	    var cnt = 0;
	
	    for (i = 0; i < len; i += 1) {
	      charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	      shapeData = charData && charData.data || {};
	      matrixHelper.reset();
	
	      if (singleShape && letters[i].n) {
	        xPos = -trackingOffset;
	        yPos += documentData.yOffset;
	        yPos += firstLine ? 1 : 0;
	        firstLine = false;
	      }
	
	      shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	      jLen = shapes.length;
	      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	
	      if (singleShape) {
	        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	      }
	
	      commands = createSizedArray(jLen - 1);
	      var commandsCounter = 0;
	
	      for (j = 0; j < jLen; j += 1) {
	        if (shapes[j].ty === 'sh') {
	          kLen = shapes[j].ks.k.i.length;
	          pathNodes = shapes[j].ks.k;
	          pathArr = [];
	
	          for (k = 1; k < kLen; k += 1) {
	            if (k === 1) {
	              pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
	            }
	
	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
	          }
	
	          pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
	          commands[commandsCounter] = pathArr;
	          commandsCounter += 1;
	        }
	      }
	
	      if (singleShape) {
	        xPos += letters[i].l;
	        xPos += trackingOffset;
	      }
	
	      if (this.textSpans[cnt]) {
	        this.textSpans[cnt].elem = commands;
	      } else {
	        this.textSpans[cnt] = {
	          elem: commands
	        };
	      }
	
	      cnt += 1;
	    }
	  };
	
	  CVTextElement.prototype.renderInnerContent = function () {
	    this.validateText();
	    var ctx = this.canvasContext;
	    ctx.font = this.values.fValue;
	    this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';
	
	    this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';
	
	    this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
	
	    if (!this.data.singleShape) {
	      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }
	
	    var i;
	    var len;
	    var j;
	    var jLen;
	    var k;
	    var kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;
	    var letters = this.textProperty.currentData.l;
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null;
	    var lastStroke = null;
	    var lastStrokeW = null;
	    var commands;
	    var pathArr;
	    var renderer = this.globalData.renderer;
	
	    for (i = 0; i < len; i += 1) {
	      if (!letters[i].n) {
	        renderedLetter = renderedLetters[i];
	
	        if (renderedLetter) {
	          renderer.save();
	          renderer.ctxTransform(renderedLetter.p);
	          renderer.ctxOpacity(renderedLetter.o);
	        }
	
	        if (this.fill) {
	          if (renderedLetter && renderedLetter.fc) {
	            if (lastFill !== renderedLetter.fc) {
	              renderer.ctxFillStyle(renderedLetter.fc);
	              lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
	            }
	          } else if (lastFill !== this.values.fill) {
	            lastFill = this.values.fill;
	            renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
	          }
	
	          commands = this.textSpans[i].elem;
	          jLen = commands.length;
	          this.globalData.canvasContext.beginPath();
	
	          for (j = 0; j < jLen; j += 1) {
	            pathArr = commands[j];
	            kLen = pathArr.length;
	            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	
	            for (k = 2; k < kLen; k += 6) {
	              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	            }
	          }
	
	          this.globalData.canvasContext.closePath();
	          renderer.ctxFill(); // this.globalData.canvasContext.fill();
	          /// ctx.fillText(this.textSpans[i].val,0,0);
	        }
	
	        if (this.stroke) {
	          if (renderedLetter && renderedLetter.sw) {
	            if (lastStrokeW !== renderedLetter.sw) {
	              lastStrokeW = renderedLetter.sw;
	              renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
	            }
	          } else if (lastStrokeW !== this.values.sWidth) {
	            lastStrokeW = this.values.sWidth;
	            renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
	          }
	
	          if (renderedLetter && renderedLetter.sc) {
	            if (lastStroke !== renderedLetter.sc) {
	              lastStroke = renderedLetter.sc;
	              renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
	            }
	          } else if (lastStroke !== this.values.stroke) {
	            lastStroke = this.values.stroke;
	            renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
	          }
	
	          commands = this.textSpans[i].elem;
	          jLen = commands.length;
	          this.globalData.canvasContext.beginPath();
	
	          for (j = 0; j < jLen; j += 1) {
	            pathArr = commands[j];
	            kLen = pathArr.length;
	            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	
	            for (k = 2; k < kLen; k += 6) {
	              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	            }
	          }
	
	          this.globalData.canvasContext.closePath();
	          renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
	          /// ctx.strokeText(letters[i].val,0,0);
	        }
	
	        if (renderedLetter) {
	          this.globalData.renderer.restore();
	        }
	      }
	    }
	  };
	
	  function CVImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	    this.img = globalData.imageLoader.getAsset(this.assetData);
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
	  CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	  CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	  CVImageElement.prototype.createContent = function () {
	    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
	      var canvas = createTag('canvas');
	      canvas.width = this.assetData.w;
	      canvas.height = this.assetData.h;
	      var ctx = canvas.getContext('2d');
	      var imgW = this.img.width;
	      var imgH = this.img.height;
	      var imgRel = imgW / imgH;
	      var canvasRel = this.assetData.w / this.assetData.h;
	      var widthCrop;
	      var heightCrop;
	      var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
	
	      if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
	        heightCrop = imgH;
	        widthCrop = heightCrop * canvasRel;
	      } else {
	        widthCrop = imgW;
	        heightCrop = widthCrop / canvasRel;
	      }
	
	      ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
	      this.img = canvas;
	    }
	  };
	
	  CVImageElement.prototype.renderInnerContent = function () {
	    this.canvasContext.drawImage(this.img, 0, 0);
	  };
	
	  CVImageElement.prototype.destroy = function () {
	    this.img = null;
	  };
	
	  function CVSolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
	  CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
	  CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
	
	  CVSolidElement.prototype.renderInnerContent = function () {
	    // var ctx = this.canvasContext;
	    this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
	
	    this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
	    //
	  };
	
	  function CanvasRendererBase() {}
	
	  extendPrototype([BaseRenderer], CanvasRendererBase);
	
	  CanvasRendererBase.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this.globalData, this);
	  };
	
	  CanvasRendererBase.prototype.createText = function (data) {
	    return new CVTextElement(data, this.globalData, this);
	  };
	
	  CanvasRendererBase.prototype.createImage = function (data) {
	    return new CVImageElement(data, this.globalData, this);
	  };
	
	  CanvasRendererBase.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this.globalData, this);
	  };
	
	  CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
	
	  CanvasRendererBase.prototype.ctxTransform = function (props) {
	    if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
	      return;
	    }
	
	    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
	  };
	
	  CanvasRendererBase.prototype.ctxOpacity = function (op) {
	    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	  };
	
	  CanvasRendererBase.prototype.ctxFillStyle = function (value) {
	    this.canvasContext.fillStyle = value;
	  };
	
	  CanvasRendererBase.prototype.ctxStrokeStyle = function (value) {
	    this.canvasContext.strokeStyle = value;
	  };
	
	  CanvasRendererBase.prototype.ctxLineWidth = function (value) {
	    this.canvasContext.lineWidth = value;
	  };
	
	  CanvasRendererBase.prototype.ctxLineCap = function (value) {
	    this.canvasContext.lineCap = value;
	  };
	
	  CanvasRendererBase.prototype.ctxLineJoin = function (value) {
	    this.canvasContext.lineJoin = value;
	  };
	
	  CanvasRendererBase.prototype.ctxMiterLimit = function (value) {
	    this.canvasContext.miterLimit = value;
	  };
	
	  CanvasRendererBase.prototype.ctxFill = function (rule) {
	    this.canvasContext.fill(rule);
	  };
	
	  CanvasRendererBase.prototype.ctxFillRect = function (x, y, w, h) {
	    this.canvasContext.fillRect(x, y, w, h);
	  };
	
	  CanvasRendererBase.prototype.ctxStroke = function () {
	    this.canvasContext.stroke();
	  };
	
	  CanvasRendererBase.prototype.reset = function () {
	    if (!this.renderConfig.clearCanvas) {
	      this.canvasContext.restore();
	      return;
	    }
	
	    this.contextData.reset();
	  };
	
	  CanvasRendererBase.prototype.save = function () {
	    this.canvasContext.save();
	  };
	
	  CanvasRendererBase.prototype.restore = function (actionFlag) {
	    if (!this.renderConfig.clearCanvas) {
	      this.canvasContext.restore();
	      return;
	    }
	
	    if (actionFlag) {
	      this.globalData.blendMode = 'source-over';
	    }
	
	    this.contextData.restore(actionFlag);
	  };
	
	  CanvasRendererBase.prototype.configAnimation = function (animData) {
	    if (this.animationItem.wrapper) {
	      this.animationItem.container = createTag('canvas');
	      var containerStyle = this.animationItem.container.style;
	      containerStyle.width = '100%';
	      containerStyle.height = '100%';
	      var origin = '0px 0px 0px';
	      containerStyle.transformOrigin = origin;
	      containerStyle.mozTransformOrigin = origin;
	      containerStyle.webkitTransformOrigin = origin;
	      containerStyle['-webkit-transform'] = origin;
	      containerStyle.contentVisibility = this.renderConfig.contentVisibility;
	      this.animationItem.wrapper.appendChild(this.animationItem.container);
	      this.canvasContext = this.animationItem.container.getContext('2d');
	
	      if (this.renderConfig.className) {
	        this.animationItem.container.setAttribute('class', this.renderConfig.className);
	      }
	
	      if (this.renderConfig.id) {
	        this.animationItem.container.setAttribute('id', this.renderConfig.id);
	      }
	    } else {
	      this.canvasContext = this.renderConfig.context;
	    }
	
	    this.contextData.setContext(this.canvasContext);
	    this.data = animData;
	    this.layers = animData.layers;
	    this.transformCanvas = {
	      w: animData.w,
	      h: animData.h,
	      sx: 0,
	      sy: 0,
	      tx: 0,
	      ty: 0
	    };
	    this.setupGlobalData(animData, document.body);
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = createSizedArray(animData.layers.length);
	    this.updateContainerSize();
	  };
	
	  CanvasRendererBase.prototype.updateContainerSize = function (width, height) {
	    this.reset();
	    var elementWidth;
	    var elementHeight;
	
	    if (width) {
	      elementWidth = width;
	      elementHeight = height;
	      this.canvasContext.canvas.width = elementWidth;
	      this.canvasContext.canvas.height = elementHeight;
	    } else {
	      if (this.animationItem.wrapper && this.animationItem.container) {
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	      } else {
	        elementWidth = this.canvasContext.canvas.width;
	        elementHeight = this.canvasContext.canvas.height;
	      }
	
	      this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
	      this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
	    }
	
	    var elementRel;
	    var animationRel;
	
	    if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
	      var par = this.renderConfig.preserveAspectRatio.split(' ');
	      var fillType = par[1] || 'meet';
	      var pos = par[0] || 'xMidYMid';
	      var xPos = pos.substr(0, 4);
	      var yPos = pos.substr(4);
	      elementRel = elementWidth / elementHeight;
	      animationRel = this.transformCanvas.w / this.transformCanvas.h;
	
	      if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
	        this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	        this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	      } else {
	        this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	      }
	
	      if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
	        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
	      } else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
	        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
	      } else {
	        this.transformCanvas.tx = 0;
	      }
	
	      if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
	        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
	      } else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
	        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
	      } else {
	        this.transformCanvas.ty = 0;
	      }
	    } else if (this.renderConfig.preserveAspectRatio === 'none') {
	      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
	      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
	      this.transformCanvas.tx = 0;
	      this.transformCanvas.ty = 0;
	    } else {
	      this.transformCanvas.sx = this.renderConfig.dpr;
	      this.transformCanvas.sy = this.renderConfig.dpr;
	      this.transformCanvas.tx = 0;
	      this.transformCanvas.ty = 0;
	    }
	
	    this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
	    /* var i, len = this.elements.length;
	      for(i=0;i<len;i+=1){
	          if(this.elements[i] && this.elements[i].data.ty === 0){
	              this.elements[i].resize(this.globalData.transformCanvas);
	          }
	      } */
	
	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	    this.renderFrame(this.renderedFrame, true);
	  };
	
	  CanvasRendererBase.prototype.destroy = function () {
	    if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }
	
	    var i;
	    var len = this.layers ? this.layers.length : 0;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }
	
	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	  };
	
	  CanvasRendererBase.prototype.renderFrame = function (num, forceRender) {
	    if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) {
	      return;
	    }
	
	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
	    this.globalData.frameId += 1;
	    this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
	    this.globalData.projectInterface.currentFrame = num; // console.log('--------');
	    // console.log('NEW: ',num);
	
	    var i;
	    var len = this.layers.length;
	
	    if (!this.completeLayers) {
	      this.checkLayers(num);
	    }
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].prepareFrame(num - this.layers[i].st);
	      }
	    }
	
	    if (this.globalData._mdf) {
	      if (this.renderConfig.clearCanvas === true) {
	        this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
	      } else {
	        this.save();
	      }
	
	      for (i = len - 1; i >= 0; i -= 1) {
	        if (this.completeLayers || this.elements[i]) {
	          this.elements[i].renderFrame();
	        }
	      }
	
	      if (this.renderConfig.clearCanvas !== true) {
	        this.restore();
	      }
	    }
	  };
	
	  CanvasRendererBase.prototype.buildItem = function (pos) {
	    var elements = this.elements;
	
	    if (elements[pos] || this.layers[pos].ty === 99) {
	      return;
	    }
	
	    var element = this.createItem(this.layers[pos], this, this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    /* if(this.layers[pos].ty === 0){
	          element.resize(this.globalData.transformCanvas);
	      } */
	  };
	
	  CanvasRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	    }
	  };
	
	  CanvasRendererBase.prototype.hide = function () {
	    this.animationItem.container.style.display = 'none';
	  };
	
	  CanvasRendererBase.prototype.show = function () {
	    this.animationItem.container.style.display = 'block';
	  };
	
	  function CanvasContext() {
	    this.opacity = -1;
	    this.transform = createTypedArray('float32', 16);
	    this.fillStyle = '';
	    this.strokeStyle = '';
	    this.lineWidth = '';
	    this.lineCap = '';
	    this.lineJoin = '';
	    this.miterLimit = '';
	    this.id = Math.random();
	  }
	
	  function CVContextData() {
	    this.stack = [];
	    this.cArrPos = 0;
	    this.cTr = new Matrix();
	    var i;
	    var len = 15;
	
	    for (i = 0; i < len; i += 1) {
	      var canvasContext = new CanvasContext();
	      this.stack[i] = canvasContext;
	    }
	
	    this._length = len;
	    this.nativeContext = null;
	    this.transformMat = new Matrix();
	    this.currentOpacity = 1; //
	
	    this.currentFillStyle = '';
	    this.appliedFillStyle = ''; //
	
	    this.currentStrokeStyle = '';
	    this.appliedStrokeStyle = ''; //
	
	    this.currentLineWidth = '';
	    this.appliedLineWidth = ''; //
	
	    this.currentLineCap = '';
	    this.appliedLineCap = ''; //
	
	    this.currentLineJoin = '';
	    this.appliedLineJoin = ''; //
	
	    this.appliedMiterLimit = '';
	    this.currentMiterLimit = '';
	  }
	
	  CVContextData.prototype.duplicate = function () {
	    var newLength = this._length * 2;
	    var i = 0;
	
	    for (i = this._length; i < newLength; i += 1) {
	      this.stack[i] = new CanvasContext();
	    }
	
	    this._length = newLength;
	  };
	
	  CVContextData.prototype.reset = function () {
	    this.cArrPos = 0;
	    this.cTr.reset();
	    this.stack[this.cArrPos].opacity = 1;
	  };
	
	  CVContextData.prototype.restore = function (forceRestore) {
	    this.cArrPos -= 1;
	    var currentContext = this.stack[this.cArrPos];
	    var transform = currentContext.transform;
	    var i;
	    var arr = this.cTr.props;
	
	    for (i = 0; i < 16; i += 1) {
	      arr[i] = transform[i];
	    }
	
	    if (forceRestore) {
	      this.nativeContext.restore();
	      var prevStack = this.stack[this.cArrPos + 1];
	      this.appliedFillStyle = prevStack.fillStyle;
	      this.appliedStrokeStyle = prevStack.strokeStyle;
	      this.appliedLineWidth = prevStack.lineWidth;
	      this.appliedLineCap = prevStack.lineCap;
	      this.appliedLineJoin = prevStack.lineJoin;
	      this.appliedMiterLimit = prevStack.miterLimit;
	    }
	
	    this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
	
	    if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
	      this.nativeContext.globalAlpha = currentContext.opacity;
	      this.currentOpacity = currentContext.opacity;
	    }
	
	    this.currentFillStyle = currentContext.fillStyle;
	    this.currentStrokeStyle = currentContext.strokeStyle;
	    this.currentLineWidth = currentContext.lineWidth;
	    this.currentLineCap = currentContext.lineCap;
	    this.currentLineJoin = currentContext.lineJoin;
	    this.currentMiterLimit = currentContext.miterLimit;
	  };
	
	  CVContextData.prototype.save = function (saveOnNativeFlag) {
	    if (saveOnNativeFlag) {
	      this.nativeContext.save();
	    }
	
	    var props = this.cTr.props;
	
	    if (this._length <= this.cArrPos) {
	      this.duplicate();
	    }
	
	    var currentStack = this.stack[this.cArrPos];
	    var i;
	
	    for (i = 0; i < 16; i += 1) {
	      currentStack.transform[i] = props[i];
	    }
	
	    this.cArrPos += 1;
	    var newStack = this.stack[this.cArrPos];
	    newStack.opacity = currentStack.opacity;
	    newStack.fillStyle = currentStack.fillStyle;
	    newStack.strokeStyle = currentStack.strokeStyle;
	    newStack.lineWidth = currentStack.lineWidth;
	    newStack.lineCap = currentStack.lineCap;
	    newStack.lineJoin = currentStack.lineJoin;
	    newStack.miterLimit = currentStack.miterLimit;
	  };
	
	  CVContextData.prototype.setOpacity = function (value) {
	    this.stack[this.cArrPos].opacity = value;
	  };
	
	  CVContextData.prototype.setContext = function (value) {
	    this.nativeContext = value;
	  };
	
	  CVContextData.prototype.fillStyle = function (value) {
	    if (this.stack[this.cArrPos].fillStyle !== value) {
	      this.currentFillStyle = value;
	      this.stack[this.cArrPos].fillStyle = value;
	    }
	  };
	
	  CVContextData.prototype.strokeStyle = function (value) {
	    if (this.stack[this.cArrPos].strokeStyle !== value) {
	      this.currentStrokeStyle = value;
	      this.stack[this.cArrPos].strokeStyle = value;
	    }
	  };
	
	  CVContextData.prototype.lineWidth = function (value) {
	    if (this.stack[this.cArrPos].lineWidth !== value) {
	      this.currentLineWidth = value;
	      this.stack[this.cArrPos].lineWidth = value;
	    }
	  };
	
	  CVContextData.prototype.lineCap = function (value) {
	    if (this.stack[this.cArrPos].lineCap !== value) {
	      this.currentLineCap = value;
	      this.stack[this.cArrPos].lineCap = value;
	    }
	  };
	
	  CVContextData.prototype.lineJoin = function (value) {
	    if (this.stack[this.cArrPos].lineJoin !== value) {
	      this.currentLineJoin = value;
	      this.stack[this.cArrPos].lineJoin = value;
	    }
	  };
	
	  CVContextData.prototype.miterLimit = function (value) {
	    if (this.stack[this.cArrPos].miterLimit !== value) {
	      this.currentMiterLimit = value;
	      this.stack[this.cArrPos].miterLimit = value;
	    }
	  };
	
	  CVContextData.prototype.transform = function (props) {
	    this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
	
	    var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
	
	    this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
	
	    currentTransform.cloneFromProps(this.transformMat.props);
	    var trProps = currentTransform.props; // Applying the new transform to the canvas
	
	    this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
	  };
	
	  CVContextData.prototype.opacity = function (op) {
	    var currentOpacity = this.stack[this.cArrPos].opacity;
	    currentOpacity *= op < 0 ? 0 : op;
	
	    if (this.stack[this.cArrPos].opacity !== currentOpacity) {
	      if (this.currentOpacity !== op) {
	        this.nativeContext.globalAlpha = op;
	        this.currentOpacity = op;
	      }
	
	      this.stack[this.cArrPos].opacity = currentOpacity;
	    }
	  };
	
	  CVContextData.prototype.fill = function (rule) {
	    if (this.appliedFillStyle !== this.currentFillStyle) {
	      this.appliedFillStyle = this.currentFillStyle;
	      this.nativeContext.fillStyle = this.appliedFillStyle;
	    }
	
	    this.nativeContext.fill(rule);
	  };
	
	  CVContextData.prototype.fillRect = function (x, y, w, h) {
	    if (this.appliedFillStyle !== this.currentFillStyle) {
	      this.appliedFillStyle = this.currentFillStyle;
	      this.nativeContext.fillStyle = this.appliedFillStyle;
	    }
	
	    this.nativeContext.fillRect(x, y, w, h);
	  };
	
	  CVContextData.prototype.stroke = function () {
	    if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
	      this.appliedStrokeStyle = this.currentStrokeStyle;
	      this.nativeContext.strokeStyle = this.appliedStrokeStyle;
	    }
	
	    if (this.appliedLineWidth !== this.currentLineWidth) {
	      this.appliedLineWidth = this.currentLineWidth;
	      this.nativeContext.lineWidth = this.appliedLineWidth;
	    }
	
	    if (this.appliedLineCap !== this.currentLineCap) {
	      this.appliedLineCap = this.currentLineCap;
	      this.nativeContext.lineCap = this.appliedLineCap;
	    }
	
	    if (this.appliedLineJoin !== this.currentLineJoin) {
	      this.appliedLineJoin = this.currentLineJoin;
	      this.nativeContext.lineJoin = this.appliedLineJoin;
	    }
	
	    if (this.appliedMiterLimit !== this.currentMiterLimit) {
	      this.appliedMiterLimit = this.currentMiterLimit;
	      this.nativeContext.miterLimit = this.appliedMiterLimit;
	    }
	
	    this.nativeContext.stroke();
	  };
	
	  function CVCompElement(data, globalData, comp) {
	    this.completeLayers = false;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = createSizedArray(this.layers.length);
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }
	
	  extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement);
	
	  CVCompElement.prototype.renderInnerContent = function () {
	    var ctx = this.canvasContext;
	    ctx.beginPath();
	    ctx.moveTo(0, 0);
	    ctx.lineTo(this.data.w, 0);
	    ctx.lineTo(this.data.w, this.data.h);
	    ctx.lineTo(0, this.data.h);
	    ctx.lineTo(0, 0);
	    ctx.clip();
	    var i;
	    var len = this.layers.length;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.completeLayers || this.elements[i]) {
	        this.elements[i].renderFrame();
	      }
	    }
	  };
	
	  CVCompElement.prototype.destroy = function () {
	    var i;
	    var len = this.layers.length;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      if (this.elements[i]) {
	        this.elements[i].destroy();
	      }
	    }
	
	    this.layers = null;
	    this.elements = null;
	  };
	
	  CVCompElement.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	  };
	
	  function CanvasRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.renderConfig = {
	      clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
	      context: config && config.context || null,
	      progressiveLoad: config && config.progressiveLoad || false,
	      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      contentVisibility: config && config.contentVisibility || 'visible',
	      className: config && config.className || '',
	      id: config && config.id || '',
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.renderConfig.dpr = config && config.dpr || 1;
	
	    if (this.animationItem.wrapper) {
	      this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
	    }
	
	    this.renderedFrame = -1;
	    this.globalData = {
	      frameNum: -1,
	      _mdf: false,
	      renderConfig: this.renderConfig,
	      currentGlobalAlpha: -1
	    };
	    this.contextData = new CVContextData();
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	    this.rendererType = 'canvas';
	
	    if (this.renderConfig.clearCanvas) {
	      this.ctxTransform = this.contextData.transform.bind(this.contextData);
	      this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
	      this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
	      this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
	      this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
	      this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
	      this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
	      this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
	      this.ctxFill = this.contextData.fill.bind(this.contextData);
	      this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
	      this.ctxStroke = this.contextData.stroke.bind(this.contextData);
	      this.save = this.contextData.save.bind(this.contextData);
	    }
	  }
	
	  extendPrototype([CanvasRendererBase], CanvasRenderer);
	
	  CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this.globalData, this);
	  };
	
	  function HBaseElement() {}
	
	  HBaseElement.prototype = {
	    checkBlendMode: function checkBlendMode() {},
	    initRendererElement: function initRendererElement() {
	      this.baseElement = createTag(this.data.tg || 'div');
	
	      if (this.data.hasMask) {
	        this.svgElement = createNS('svg');
	        this.layerElement = createNS('g');
	        this.maskedElement = this.layerElement;
	        this.svgElement.appendChild(this.layerElement);
	        this.baseElement.appendChild(this.svgElement);
	      } else {
	        this.layerElement = this.baseElement;
	      }
	
	      styleDiv(this.baseElement);
	    },
	    createContainerElements: function createContainerElements() {
	      this.renderableEffectsManager = new CVEffects(this);
	      this.transformedElement = this.baseElement;
	      this.maskedElement = this.layerElement;
	
	      if (this.data.ln) {
	        this.layerElement.setAttribute('id', this.data.ln);
	      }
	
	      if (this.data.cl) {
	        this.layerElement.setAttribute('class', this.data.cl);
	      }
	
	      if (this.data.bm !== 0) {
	        this.setBlendMode();
	      }
	    },
	    renderElement: function renderElement() {
	      var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
	
	      if (this.finalTransform._matMdf) {
	        var matrixValue = this.finalTransform.mat.toCSS();
	        transformedElementStyle.transform = matrixValue;
	        transformedElementStyle.webkitTransform = matrixValue;
	      }
	
	      if (this.finalTransform._opMdf) {
	        transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
	      }
	    },
	    renderFrame: function renderFrame() {
	      // If it is exported as hidden (data.hd === true) no need to render
	      // If it is not visible no need to render
	      if (this.data.hd || this.hidden) {
	        return;
	      }
	
	      this.renderTransform();
	      this.renderRenderable();
	      this.renderElement();
	      this.renderInnerContent();
	
	      if (this._isFirstFrame) {
	        this._isFirstFrame = false;
	      }
	    },
	    destroy: function destroy() {
	      this.layerElement = null;
	      this.transformedElement = null;
	
	      if (this.matteElement) {
	        this.matteElement = null;
	      }
	
	      if (this.maskManager) {
	        this.maskManager.destroy();
	        this.maskManager = null;
	      }
	    },
	    createRenderableComponents: function createRenderableComponents() {
	      this.maskManager = new MaskElement(this.data, this, this.globalData);
	    },
	    addEffects: function addEffects() {},
	    setMatte: function setMatte() {}
	  };
	  HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
	  HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
	  HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
	
	  function HSolidElement(data, globalData, comp) {
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);
	
	  HSolidElement.prototype.createContent = function () {
	    var rect;
	
	    if (this.data.hasMask) {
	      rect = createNS('rect');
	      rect.setAttribute('width', this.data.sw);
	      rect.setAttribute('height', this.data.sh);
	      rect.setAttribute('fill', this.data.sc);
	      this.svgElement.setAttribute('width', this.data.sw);
	      this.svgElement.setAttribute('height', this.data.sh);
	    } else {
	      rect = createTag('div');
	      rect.style.width = this.data.sw + 'px';
	      rect.style.height = this.data.sh + 'px';
	      rect.style.backgroundColor = this.data.sc;
	    }
	
	    this.layerElement.appendChild(rect);
	  };
	
	  function HShapeElement(data, globalData, comp) {
	    // List of drawable elements
	    this.shapes = []; // Full shape data
	
	    this.shapesData = data.shapes; // List of styles that will be applied to shapes
	
	    this.stylesList = []; // List of modifiers that will be applied to shapes
	
	    this.shapeModifiers = []; // List of items in shape tree
	
	    this.itemsData = []; // List of items in previous shape tree
	
	    this.processedElements = []; // List of animated components
	
	    this.animatedContents = [];
	    this.shapesContainer = createNS('g');
	    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
	    // List of elements that have been created
	
	    this.prevViewData = [];
	    this.currentBBox = {
	      x: 999999,
	      y: -999999,
	      h: 0,
	      w: 0
	    };
	  }
	
	  extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
	  HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
	
	  HShapeElement.prototype.createContent = function () {
	    var cont;
	    this.baseElement.style.fontSize = 0;
	
	    if (this.data.hasMask) {
	      this.layerElement.appendChild(this.shapesContainer);
	      cont = this.svgElement;
	    } else {
	      cont = createNS('svg');
	      var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	      cont.setAttribute('width', size.w);
	      cont.setAttribute('height', size.h);
	      cont.appendChild(this.shapesContainer);
	      this.layerElement.appendChild(cont);
	    }
	
	    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
	    this.filterUniqueShapes();
	    this.shapeCont = cont;
	  };
	
	  HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
	    var i;
	    var len = transformers.length;
	
	    for (i = 0; i < len; i += 1) {
	      point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
	    }
	
	    return point;
	  };
	
	  HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
	    var shape = item.sh.v;
	    var transformers = item.transformers;
	    var i;
	    var len = shape._length;
	    var vPoint;
	    var oPoint;
	    var nextIPoint;
	    var nextVPoint;
	
	    if (len <= 1) {
	      return;
	    }
	
	    for (i = 0; i < len - 1; i += 1) {
	      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	      nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
	      nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
	      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	
	    if (shape.c) {
	      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
	      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
	      nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
	      nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
	      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
	    }
	  };
	
	  HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
	    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
	    var bounds = this.shapeBoundingBox;
	    boundingBox.x = bmMin(bounds.left, boundingBox.x);
	    boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
	    boundingBox.y = bmMin(bounds.top, boundingBox.y);
	    boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
	  };
	
	  HShapeElement.prototype.shapeBoundingBox = {
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0
	  };
	  HShapeElement.prototype.tempBoundingBox = {
	    x: 0,
	    xMax: 0,
	    y: 0,
	    yMax: 0,
	    width: 0,
	    height: 0
	  };
	
	  HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
	    var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];
	
	    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
	      // eslint-disable-line no-plusplus
	      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	      c = 3 * p1[i] - 3 * p0[i];
	      b |= 0; // eslint-disable-line no-bitwise
	
	      a |= 0; // eslint-disable-line no-bitwise
	
	      c |= 0; // eslint-disable-line no-bitwise
	
	      if (a === 0 && b === 0) {//
	      } else if (a === 0) {
	        t = -c / b;
	
	        if (t > 0 && t < 1) {
	          bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
	        }
	      } else {
	        b2ac = b * b - 4 * c * a;
	
	        if (b2ac >= 0) {
	          t1 = (-b + bmSqrt(b2ac)) / (2 * a);
	          if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
	          t2 = (-b - bmSqrt(b2ac)) / (2 * a);
	          if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
	        }
	      }
	    }
	
	    this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
	    this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
	    this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
	    this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
	  };
	
	  HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
	    return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
	  };
	
	  HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
	    var i;
	    var len = itemsData.length;
	
	    for (i = 0; i < len; i += 1) {
	      if (itemsData[i] && itemsData[i].sh) {
	        this.calculateShapeBoundingBox(itemsData[i], boundingBox);
	      } else if (itemsData[i] && itemsData[i].it) {
	        this.calculateBoundingBox(itemsData[i].it, boundingBox);
	      } else if (itemsData[i] && itemsData[i].style && itemsData[i].w) {
	        this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
	      }
	    }
	  };
	
	  HShapeElement.prototype.expandStrokeBoundingBox = function (widthProperty, boundingBox) {
	    var width = 0;
	
	    if (widthProperty.keyframes) {
	      for (var i = 0; i < widthProperty.keyframes.length; i += 1) {
	        var kfw = widthProperty.keyframes[i].s;
	
	        if (kfw > width) {
	          width = kfw;
	        }
	      }
	
	      width *= widthProperty.mult;
	    } else {
	      width = widthProperty.v * widthProperty.mult;
	    }
	
	    boundingBox.x -= width;
	    boundingBox.xMax += width;
	    boundingBox.y -= width;
	    boundingBox.yMax += width;
	  };
	
	  HShapeElement.prototype.currentBoxContains = function (box) {
	    return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
	  };
	
	  HShapeElement.prototype.renderInnerContent = function () {
	    this._renderShapeFrame();
	
	    if (!this.hidden && (this._isFirstFrame || this._mdf)) {
	      var tempBoundingBox = this.tempBoundingBox;
	      var max = 999999;
	      tempBoundingBox.x = max;
	      tempBoundingBox.xMax = -max;
	      tempBoundingBox.y = max;
	      tempBoundingBox.yMax = -max;
	      this.calculateBoundingBox(this.itemsData, tempBoundingBox);
	      tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
	      tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
	
	      if (this.currentBoxContains(tempBoundingBox)) {
	        return;
	      }
	
	      var changed = false;
	
	      if (this.currentBBox.w !== tempBoundingBox.width) {
	        this.currentBBox.w = tempBoundingBox.width;
	        this.shapeCont.setAttribute('width', tempBoundingBox.width);
	        changed = true;
	      }
	
	      if (this.currentBBox.h !== tempBoundingBox.height) {
	        this.currentBBox.h = tempBoundingBox.height;
	        this.shapeCont.setAttribute('height', tempBoundingBox.height);
	        changed = true;
	      }
	
	      if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
	        this.currentBBox.w = tempBoundingBox.width;
	        this.currentBBox.h = tempBoundingBox.height;
	        this.currentBBox.x = tempBoundingBox.x;
	        this.currentBBox.y = tempBoundingBox.y;
	        this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
	        var shapeStyle = this.shapeCont.style;
	        var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        shapeStyle.transform = shapeTransform;
	        shapeStyle.webkitTransform = shapeTransform;
	      }
	    }
	  };
	
	  function HTextElement(data, globalData, comp) {
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	      x: 999999,
	      y: -999999,
	      h: 0,
	      w: 0
	    };
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);
	
	  HTextElement.prototype.createContent = function () {
	    this.isMasked = this.checkMasks();
	
	    if (this.isMasked) {
	      this.renderType = 'svg';
	      this.compW = this.comp.data.w;
	      this.compH = this.comp.data.h;
	      this.svgElement.setAttribute('width', this.compW);
	      this.svgElement.setAttribute('height', this.compH);
	      var g = createNS('g');
	      this.maskedElement.appendChild(g);
	      this.innerElem = g;
	    } else {
	      this.renderType = 'html';
	      this.innerElem = this.layerElement;
	    }
	
	    this.checkParenting();
	  };
	
	  HTextElement.prototype.buildNewText = function () {
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
	    var innerElemStyle = this.innerElem.style;
	    var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    innerElemStyle.fill = textColor;
	    innerElemStyle.color = textColor;
	
	    if (documentData.sc) {
	      innerElemStyle.stroke = this.buildColor(documentData.sc);
	      innerElemStyle.strokeWidth = documentData.sw + 'px';
	    }
	
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	
	    if (!this.globalData.fontManager.chars) {
	      innerElemStyle.fontSize = documentData.finalSize + 'px';
	      innerElemStyle.lineHeight = documentData.finalSize + 'px';
	
	      if (fontData.fClass) {
	        this.innerElem.className = fontData.fClass;
	      } else {
	        innerElemStyle.fontFamily = fontData.fFamily;
	        var fWeight = documentData.fWeight;
	        var fStyle = documentData.fStyle;
	        innerElemStyle.fontStyle = fStyle;
	        innerElemStyle.fontWeight = fWeight;
	      }
	    }
	
	    var i;
	    var len;
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan;
	    var tParent;
	    var tCont;
	    var matrixHelper = this.mHelper;
	    var shapes;
	    var shapeStr = '';
	    var cnt = 0;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.globalData.fontManager.chars) {
	        if (!this.textPaths[cnt]) {
	          tSpan = createNS('path');
	          tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
	          tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
	          tSpan.setAttribute('stroke-miterlimit', '4');
	        } else {
	          tSpan = this.textPaths[cnt];
	        }
	
	        if (!this.isMasked) {
	          if (this.textSpans[cnt]) {
	            tParent = this.textSpans[cnt];
	            tCont = tParent.children[0];
	          } else {
	            tParent = createTag('div');
	            tParent.style.lineHeight = 0;
	            tCont = createNS('svg');
	            tCont.appendChild(tSpan);
	            styleDiv(tParent);
	          }
	        }
	      } else if (!this.isMasked) {
	        if (this.textSpans[cnt]) {
	          tParent = this.textSpans[cnt];
	          tSpan = this.textPaths[cnt];
	        } else {
	          tParent = createTag('span');
	          styleDiv(tParent);
	          tSpan = createTag('span');
	          styleDiv(tSpan);
	          tParent.appendChild(tSpan);
	        }
	      } else {
	        tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	      } // tSpan.setAttribute('visibility', 'hidden');
	
	
	      if (this.globalData.fontManager.chars) {
	        var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        var shapeData;
	
	        if (charData) {
	          shapeData = charData.data;
	        } else {
	          shapeData = null;
	        }
	
	        matrixHelper.reset();
	
	        if (shapeData && shapeData.shapes && shapeData.shapes.length) {
	          shapes = shapeData.shapes[0].it;
	          matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
	          shapeStr = this.createPathShape(matrixHelper, shapes);
	          tSpan.setAttribute('d', shapeStr);
	        }
	
	        if (!this.isMasked) {
	          this.innerElem.appendChild(tParent);
	
	          if (shapeData && shapeData.shapes) {
	            // document.body.appendChild is needed to get exact measure of shape
	            document.body.appendChild(tCont);
	            var boundingBox = tCont.getBBox();
	            tCont.setAttribute('width', boundingBox.width + 2);
	            tCont.setAttribute('height', boundingBox.height + 2);
	            tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
	            var tContStyle = tCont.style;
	            var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
	            tContStyle.transform = tContTranslation;
	            tContStyle.webkitTransform = tContTranslation;
	            letters[i].yOffset = boundingBox.y - 1;
	          } else {
	            tCont.setAttribute('width', 1);
	            tCont.setAttribute('height', 1);
	          }
	
	          tParent.appendChild(tCont);
	        } else {
	          this.innerElem.appendChild(tSpan);
	        }
	      } else {
	        tSpan.textContent = letters[i].val;
	        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
	
	        if (!this.isMasked) {
	          this.innerElem.appendChild(tParent); //
	
	          var tStyle = tSpan.style;
	          var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
	          tStyle.transform = tSpanTranslation;
	          tStyle.webkitTransform = tSpanTranslation;
	        } else {
	          this.innerElem.appendChild(tSpan);
	        }
	      } //
	
	
	      if (!this.isMasked) {
	        this.textSpans[cnt] = tParent;
	      } else {
	        this.textSpans[cnt] = tSpan;
	      }
	
	      this.textSpans[cnt].style.display = 'block';
	      this.textPaths[cnt] = tSpan;
	      cnt += 1;
	    }
	
	    while (cnt < this.textSpans.length) {
	      this.textSpans[cnt].style.display = 'none';
	      cnt += 1;
	    }
	  };
	
	  HTextElement.prototype.renderInnerContent = function () {
	    this.validateText();
	    var svgStyle;
	
	    if (this.data.singleShape) {
	      if (!this._isFirstFrame && !this.lettersChangedFlag) {
	        return;
	      }
	
	      if (this.isMasked && this.finalTransform._matMdf) {
	        // Todo Benchmark if using this is better than getBBox
	        this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
	        svgStyle = this.svgElement.style;
	        var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	        svgStyle.transform = translation;
	        svgStyle.webkitTransform = translation;
	      }
	    }
	
	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	
	    if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
	      return;
	    }
	
	    var i;
	    var len;
	    var count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;
	    var letters = this.textProperty.currentData.l;
	    len = letters.length;
	    var renderedLetter;
	    var textSpan;
	    var textPath;
	
	    for (i = 0; i < len; i += 1) {
	      if (letters[i].n) {
	        count += 1;
	      } else {
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;
	
	        if (renderedLetter._mdf.m) {
	          if (!this.isMasked) {
	            textSpan.style.webkitTransform = renderedLetter.m;
	            textSpan.style.transform = renderedLetter.m;
	          } else {
	            textSpan.setAttribute('transform', renderedLetter.m);
	          }
	        } /// /textSpan.setAttribute('opacity',renderedLetter.o);
	
	
	        textSpan.style.opacity = renderedLetter.o;
	
	        if (renderedLetter.sw && renderedLetter._mdf.sw) {
	          textPath.setAttribute('stroke-width', renderedLetter.sw);
	        }
	
	        if (renderedLetter.sc && renderedLetter._mdf.sc) {
	          textPath.setAttribute('stroke', renderedLetter.sc);
	        }
	
	        if (renderedLetter.fc && renderedLetter._mdf.fc) {
	          textPath.setAttribute('fill', renderedLetter.fc);
	          textPath.style.color = renderedLetter.fc;
	        }
	      }
	    }
	
	    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
	      var boundingBox = this.innerElem.getBBox();
	
	      if (this.currentBBox.w !== boundingBox.width) {
	        this.currentBBox.w = boundingBox.width;
	        this.svgElement.setAttribute('width', boundingBox.width);
	      }
	
	      if (this.currentBBox.h !== boundingBox.height) {
	        this.currentBBox.h = boundingBox.height;
	        this.svgElement.setAttribute('height', boundingBox.height);
	      }
	
	      var margin = 1;
	
	      if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
	        this.currentBBox.w = boundingBox.width + margin * 2;
	        this.currentBBox.h = boundingBox.height + margin * 2;
	        this.currentBBox.x = boundingBox.x - margin;
	        this.currentBBox.y = boundingBox.y - margin;
	        this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
	        svgStyle = this.svgElement.style;
	        var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        svgStyle.transform = svgTransform;
	        svgStyle.webkitTransform = svgTransform;
	      }
	    }
	  };
	
	  function HCameraElement(data, globalData, comp) {
	    this.initFrame();
	    this.initBaseData(data, globalData, comp);
	    this.initHierarchy();
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this, data.pe, 0, 0, this);
	
	    if (data.ks.p.s) {
	      this.px = getProp(this, data.ks.p.x, 1, 0, this);
	      this.py = getProp(this, data.ks.p.y, 1, 0, this);
	      this.pz = getProp(this, data.ks.p.z, 1, 0, this);
	    } else {
	      this.p = getProp(this, data.ks.p, 1, 0, this);
	    }
	
	    if (data.ks.a) {
	      this.a = getProp(this, data.ks.a, 1, 0, this);
	    }
	
	    if (data.ks.or.k.length && data.ks.or.k[0].to) {
	      var i;
	      var len = data.ks.or.k.length;
	
	      for (i = 0; i < len; i += 1) {
	        data.ks.or.k[i].to = null;
	        data.ks.or.k[i].ti = null;
	      }
	    }
	
	    this.or = getProp(this, data.ks.or, 1, degToRads, this);
	    this.or.sh = true;
	    this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
	    this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
	    this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
	    this.mat = new Matrix();
	    this._prevMat = new Matrix();
	    this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
	
	    this.finalTransform = {
	      mProp: this
	    };
	  }
	
	  extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);
	
	  HCameraElement.prototype.setup = function () {
	    var i;
	    var len = this.comp.threeDElements.length;
	    var comp;
	    var perspectiveStyle;
	    var containerStyle;
	
	    for (i = 0; i < len; i += 1) {
	      // [perspectiveElem,container]
	      comp = this.comp.threeDElements[i];
	
	      if (comp.type === '3d') {
	        perspectiveStyle = comp.perspectiveElem.style;
	        containerStyle = comp.container.style;
	        var perspective = this.pe.v + 'px';
	        var origin = '0px 0px 0px';
	        var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	        perspectiveStyle.perspective = perspective;
	        perspectiveStyle.webkitPerspective = perspective;
	        containerStyle.transformOrigin = origin;
	        containerStyle.mozTransformOrigin = origin;
	        containerStyle.webkitTransformOrigin = origin;
	        perspectiveStyle.transform = matrix;
	        perspectiveStyle.webkitTransform = matrix;
	      }
	    }
	  };
	
	  HCameraElement.prototype.createElements = function () {};
	
	  HCameraElement.prototype.hide = function () {};
	
	  HCameraElement.prototype.renderFrame = function () {
	    var _mdf = this._isFirstFrame;
	    var i;
	    var len;
	
	    if (this.hierarchy) {
	      len = this.hierarchy.length;
	
	      for (i = 0; i < len; i += 1) {
	        _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
	      }
	    }
	
	    if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
	      this.mat.reset();
	
	      if (this.hierarchy) {
	        len = this.hierarchy.length - 1;
	
	        for (i = len; i >= 0; i -= 1) {
	          var mTransf = this.hierarchy[i].finalTransform.mProp;
	          this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
	          this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
	          this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
	          this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
	          this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
	        }
	      }
	
	      if (this.p) {
	        this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
	      } else {
	        this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
	      }
	
	      if (this.a) {
	        var diffVector;
	
	        if (this.p) {
	          diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
	        } else {
	          diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
	        }
	
	        var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	
	        var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
	        var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
	        var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
	        var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
	        this.mat.rotateY(mRotationY).rotateX(-mRotationX);
	      }
	
	      this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	      this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	      this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
	      this.mat.translate(0, 0, this.pe.v);
	      var hasMatrixChanged = !this._prevMat.equals(this.mat);
	
	      if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
	        len = this.comp.threeDElements.length;
	        var comp;
	        var perspectiveStyle;
	        var containerStyle;
	
	        for (i = 0; i < len; i += 1) {
	          comp = this.comp.threeDElements[i];
	
	          if (comp.type === '3d') {
	            if (hasMatrixChanged) {
	              var matValue = this.mat.toCSS();
	              containerStyle = comp.container.style;
	              containerStyle.transform = matValue;
	              containerStyle.webkitTransform = matValue;
	            }
	
	            if (this.pe._mdf) {
	              perspectiveStyle = comp.perspectiveElem.style;
	              perspectiveStyle.perspective = this.pe.v + 'px';
	              perspectiveStyle.webkitPerspective = this.pe.v + 'px';
	            }
	          }
	        }
	
	        this.mat.clone(this._prevMat);
	      }
	    }
	
	    this._isFirstFrame = false;
	  };
	
	  HCameraElement.prototype.prepareFrame = function (num) {
	    this.prepareProperties(num, true);
	  };
	
	  HCameraElement.prototype.destroy = function () {};
	
	  HCameraElement.prototype.getBaseElement = function () {
	    return null;
	  };
	
	  function HImageElement(data, globalData, comp) {
	    this.assetData = globalData.getAssetData(data.refId);
	    this.initElement(data, globalData, comp);
	  }
	
	  extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);
	
	  HImageElement.prototype.createContent = function () {
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();
	
	    if (this.data.hasMask) {
	      this.imageElem = createNS('image');
	      this.imageElem.setAttribute('width', this.assetData.w + 'px');
	      this.imageElem.setAttribute('height', this.assetData.h + 'px');
	      this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
	      this.layerElement.appendChild(this.imageElem);
	      this.baseElement.setAttribute('width', this.assetData.w);
	      this.baseElement.setAttribute('height', this.assetData.h);
	    } else {
	      this.layerElement.appendChild(img);
	    }
	
	    img.crossOrigin = 'anonymous';
	    img.src = assetPath;
	
	    if (this.data.ln) {
	      this.baseElement.setAttribute('id', this.data.ln);
	    }
	  };
	
	  function HybridRendererBase(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	      className: config && config.className || '',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '400%',
	        height: config && config.filterSize && config.filterSize.height || '400%',
	        x: config && config.filterSize && config.filterSize.x || '-100%',
	        y: config && config.filterSize && config.filterSize.y || '-100%'
	      }
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	  }
	
	  extendPrototype([BaseRenderer], HybridRendererBase);
	  HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
	
	  HybridRendererBase.prototype.checkPendingElements = function () {
	    while (this.pendingElements.length) {
	      var element = this.pendingElements.pop();
	      element.checkParenting();
	    }
	  };
	
	  HybridRendererBase.prototype.appendElementInPos = function (element, pos) {
	    var newDOMElement = element.getBaseElement();
	
	    if (!newDOMElement) {
	      return;
	    }
	
	    var layer = this.layers[pos];
	
	    if (!layer.ddd || !this.supports3d) {
	      if (this.threeDElements) {
	        this.addTo3dContainer(newDOMElement, pos);
	      } else {
	        var i = 0;
	        var nextDOMElement;
	        var nextLayer;
	        var tmpDOMElement;
	
	        while (i < pos) {
	          if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
	            nextLayer = this.elements[i];
	            tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	            nextDOMElement = tmpDOMElement || nextDOMElement;
	          }
	
	          i += 1;
	        }
	
	        if (nextDOMElement) {
	          if (!layer.ddd || !this.supports3d) {
	            this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	          }
	        } else if (!layer.ddd || !this.supports3d) {
	          this.layerElement.appendChild(newDOMElement);
	        }
	      }
	    } else {
	      this.addTo3dContainer(newDOMElement, pos);
	    }
	  };
	
	  HybridRendererBase.prototype.createShape = function (data) {
	    if (!this.supports3d) {
	      return new SVGShapeElement(data, this.globalData, this);
	    }
	
	    return new HShapeElement(data, this.globalData, this);
	  };
	
	  HybridRendererBase.prototype.createText = function (data) {
	    if (!this.supports3d) {
	      return new SVGTextLottieElement(data, this.globalData, this);
	    }
	
	    return new HTextElement(data, this.globalData, this);
	  };
	
	  HybridRendererBase.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.globalData, this);
	    return this.camera;
	  };
	
	  HybridRendererBase.prototype.createImage = function (data) {
	    if (!this.supports3d) {
	      return new IImageElement(data, this.globalData, this);
	    }
	
	    return new HImageElement(data, this.globalData, this);
	  };
	
	  HybridRendererBase.prototype.createSolid = function (data) {
	    if (!this.supports3d) {
	      return new ISolidElement(data, this.globalData, this);
	    }
	
	    return new HSolidElement(data, this.globalData, this);
	  };
	
	  HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
	
	  HybridRendererBase.prototype.getThreeDContainerByPos = function (pos) {
	    var i = 0;
	    var len = this.threeDElements.length;
	
	    while (i < len) {
	      if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	        return this.threeDElements[i].perspectiveElem;
	      }
	
	      i += 1;
	    }
	
	    return null;
	  };
	
	  HybridRendererBase.prototype.createThreeDContainer = function (pos, type) {
	    var perspectiveElem = createTag('div');
	    var style;
	    var containerStyle;
	    styleDiv(perspectiveElem);
	    var container = createTag('div');
	    styleDiv(container);
	
	    if (type === '3d') {
	      style = perspectiveElem.style;
	      style.width = this.globalData.compSize.w + 'px';
	      style.height = this.globalData.compSize.h + 'px';
	      var center = '50% 50%';
	      style.webkitTransformOrigin = center;
	      style.mozTransformOrigin = center;
	      style.transformOrigin = center;
	      containerStyle = container.style;
	      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	      containerStyle.transform = matrix;
	      containerStyle.webkitTransform = matrix;
	    }
	
	    perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
	
	    var threeDContainerData = {
	      container: container,
	      perspectiveElem: perspectiveElem,
	      startPos: pos,
	      endPos: pos,
	      type: type
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	  };
	
	  HybridRendererBase.prototype.build3dContainers = function () {
	    var i;
	    var len = this.layers.length;
	    var lastThreeDContainerData;
	    var currentContainer = '';
	
	    for (i = 0; i < len; i += 1) {
	      if (this.layers[i].ddd && this.layers[i].ty !== 3) {
	        if (currentContainer !== '3d') {
	          currentContainer = '3d';
	          lastThreeDContainerData = this.createThreeDContainer(i, '3d');
	        }
	
	        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
	      } else {
	        if (currentContainer !== '2d') {
	          currentContainer = '2d';
	          lastThreeDContainerData = this.createThreeDContainer(i, '2d');
	        }
	
	        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
	      }
	    }
	
	    len = this.threeDElements.length;
	
	    for (i = len - 1; i >= 0; i -= 1) {
	      this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
	    }
	  };
	
	  HybridRendererBase.prototype.addTo3dContainer = function (elem, pos) {
	    var i = 0;
	    var len = this.threeDElements.length;
	
	    while (i < len) {
	      if (pos <= this.threeDElements[i].endPos) {
	        var j = this.threeDElements[i].startPos;
	        var nextElement;
	
	        while (j < pos) {
	          if (this.elements[j] && this.elements[j].getBaseElement) {
	            nextElement = this.elements[j].getBaseElement();
	          }
	
	          j += 1;
	        }
	
	        if (nextElement) {
	          this.threeDElements[i].container.insertBefore(elem, nextElement);
	        } else {
	          this.threeDElements[i].container.appendChild(elem);
	        }
	
	        break;
	      }
	
	      i += 1;
	    }
	  };
	
	  HybridRendererBase.prototype.configAnimation = function (animData) {
	    var resizerElem = createTag('div');
	    var wrapper = this.animationItem.wrapper;
	    var style = resizerElem.style;
	    style.width = animData.w + 'px';
	    style.height = animData.h + 'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    style.transformStyle = 'flat';
	    style.mozTransformStyle = 'flat';
	    style.webkitTransformStyle = 'flat';
	
	    if (this.renderConfig.className) {
	      resizerElem.setAttribute('class', this.renderConfig.className);
	    }
	
	    wrapper.appendChild(resizerElem);
	    style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width', '1');
	    svg.setAttribute('height', '1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.data = animData; // Mask animation
	
	    this.setupGlobalData(animData, svg);
	    this.globalData.defs = defs;
	    this.layers = animData.layers;
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	  };
	
	  HybridRendererBase.prototype.destroy = function () {
	    if (this.animationItem.wrapper) {
	      this.animationItem.wrapper.innerText = '';
	    }
	
	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i;
	    var len = this.layers ? this.layers.length : 0;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.elements[i] && this.elements[i].destroy) {
	        this.elements[i].destroy();
	      }
	    }
	
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	  };
	
	  HybridRendererBase.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth / elementHeight;
	    var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
	    var sx;
	    var sy;
	    var tx;
	    var ty;
	
	    if (animationRel > elementRel) {
	      sx = elementWidth / this.globalData.compSize.w;
	      sy = elementWidth / this.globalData.compSize.w;
	      tx = 0;
	      ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
	    } else {
	      sx = elementHeight / this.globalData.compSize.h;
	      sy = elementHeight / this.globalData.compSize.h;
	      tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
	      ty = 0;
	    }
	
	    var style = this.resizerElem.style;
	    style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
	    style.transform = style.webkitTransform;
	  };
	
	  HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
	
	  HybridRendererBase.prototype.hide = function () {
	    this.resizerElem.style.display = 'none';
	  };
	
	  HybridRendererBase.prototype.show = function () {
	    this.resizerElem.style.display = 'block';
	  };
	
	  HybridRendererBase.prototype.initItems = function () {
	    this.buildAllItems();
	
	    if (this.camera) {
	      this.camera.setup();
	    } else {
	      var cWidth = this.globalData.compSize.w;
	      var cHeight = this.globalData.compSize.h;
	      var i;
	      var len = this.threeDElements.length;
	
	      for (i = 0; i < len; i += 1) {
	        var style = this.threeDElements[i].perspectiveElem.style;
	        style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
	        style.perspective = style.webkitPerspective;
	      }
	    }
	  };
	
	  HybridRendererBase.prototype.searchExtraCompositions = function (assets) {
	    var i;
	    var len = assets.length;
	    var floatingContainer = createTag('div');
	
	    for (i = 0; i < len; i += 1) {
	      if (assets[i].xt) {
	        var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
	        comp.initExpressions();
	        this.globalData.projectInterface.registerComposition(comp);
	      }
	    }
	  };
	
	  function HCompElement(data, globalData, comp) {
	    this.layers = data.layers;
	    this.supports3d = !data.hasMask;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
	    this.initElement(data, globalData, comp);
	    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
	      _placeholder: true
	    };
	  }
	
	  extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement);
	  HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
	
	  HCompElement.prototype.createContainerElements = function () {
	    this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	
	
	    if (this.data.hasMask) {
	      this.svgElement.setAttribute('width', this.data.w);
	      this.svgElement.setAttribute('height', this.data.h);
	      this.transformedElement = this.baseElement;
	    } else {
	      this.transformedElement = this.layerElement;
	    }
	  };
	
	  HCompElement.prototype.addTo3dContainer = function (elem, pos) {
	    var j = 0;
	    var nextElement;
	
	    while (j < pos) {
	      if (this.elements[j] && this.elements[j].getBaseElement) {
	        nextElement = this.elements[j].getBaseElement();
	      }
	
	      j += 1;
	    }
	
	    if (nextElement) {
	      this.layerElement.insertBefore(elem, nextElement);
	    } else {
	      this.layerElement.appendChild(elem);
	    }
	  };
	
	  HCompElement.prototype.createComp = function (data) {
	    if (!this.supports3d) {
	      return new SVGCompElement(data, this.globalData, this);
	    }
	
	    return new HCompElement(data, this.globalData, this);
	  };
	
	  function HybridRenderer(animationItem, config) {
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.renderConfig = {
	      className: config && config.className || '',
	      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
	      hideOnTransparent: !(config && config.hideOnTransparent === false),
	      filterSize: {
	        width: config && config.filterSize && config.filterSize.width || '400%',
	        height: config && config.filterSize && config.filterSize.height || '400%',
	        x: config && config.filterSize && config.filterSize.x || '-100%',
	        y: config && config.filterSize && config.filterSize.y || '-100%'
	      },
	      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
	    };
	    this.globalData = {
	      _mdf: false,
	      frameNum: -1,
	      renderConfig: this.renderConfig
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	    this.rendererType = 'html';
	  }
	
	  extendPrototype([HybridRendererBase], HybridRenderer);
	
	  HybridRenderer.prototype.createComp = function (data) {
	    if (!this.supports3d) {
	      return new SVGCompElement(data, this.globalData, this);
	    }
	
	    return new HCompElement(data, this.globalData, this);
	  };
	
	  var CompExpressionInterface = function () {
	    return function (comp) {
	      function _thisLayerFunction(name) {
	        var i = 0;
	        var len = comp.layers.length;
	
	        while (i < len) {
	          if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
	            return comp.elements[i].layerInterface;
	          }
	
	          i += 1;
	        }
	
	        return null; // return {active:false};
	      }
	
	      Object.defineProperty(_thisLayerFunction, '_name', {
	        value: comp.data.nm
	      });
	      _thisLayerFunction.layer = _thisLayerFunction;
	      _thisLayerFunction.pixelAspect = 1;
	      _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
	      _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
	      _thisLayerFunction.pixelAspect = 1;
	      _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
	      _thisLayerFunction.displayStartTime = 0;
	      _thisLayerFunction.numLayers = comp.layers.length;
	      return _thisLayerFunction;
	    };
	  }();
	
	  function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }
	
	  /* eslint-disable */
	
	  /*
	   Copyright 2014 David Bau.
	
	   Permission is hereby granted, free of charge, to any person obtaining
	   a copy of this software and associated documentation files (the
	   "Software"), to deal in the Software without restriction, including
	   without limitation the rights to use, copy, modify, merge, publish,
	   distribute, sublicense, and/or sell copies of the Software, and to
	   permit persons to whom the Software is furnished to do so, subject to
	   the following conditions:
	
	   The above copyright notice and this permission notice shall be
	   included in all copies or substantial portions of the Software.
	
	   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	   */
	  function seedRandom(pool, math) {
	    //
	    // The following constants are related to IEEE 754 limits.
	    //
	    var global = this,
	        width = 256,
	        // each RC4 output is 0 <= x < 256
	    chunks = 6,
	        // at least six RC4 outputs for each double
	    digits = 52,
	        // there are 52 significant digits in a double
	    rngname = 'random',
	        // rngname: name for Math.random and Math.seedrandom
	    startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto; // node.js crypto module, initialized at the bottom.
	    //
	    // seedrandom()
	    // This is the seedrandom function described above.
	    //
	
	    function seedrandom(seed, options, callback) {
	      var key = [];
	      options = options === true ? {
	        entropy: true
	      } : options || {}; // Flatten the seed string or build one from local entropy if needed.
	
	      var shortseed = mixkey(flatten(options.entropy ? [seed, tostring(pool)] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
	
	      var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
	      // randomness in every bit of the mantissa of the IEEE 754 value.
	
	      var prng = function prng() {
	        var n = arc4.g(chunks),
	            // Start with a numerator n < 2 ^ 48
	        d = startdenom,
	            //   and denominator d = 2 ^ 48.
	        x = 0; //   and no 'extra last byte'.
	
	        while (n < significance) {
	          // Fill up all significant digits by
	          n = (n + x) * width; //   shifting numerator and
	
	          d *= width; //   denominator and generating a
	
	          x = arc4.g(1); //   new least-significant-byte.
	        }
	
	        while (n >= overflow) {
	          // To avoid rounding up, before adding
	          n /= 2; //   last byte, shift everything
	
	          d /= 2; //   right using integer math until
	
	          x >>>= 1; //   we have exactly the desired bits.
	        }
	
	        return (n + x) / d; // Form the number within [0, 1).
	      };
	
	      prng.int32 = function () {
	        return arc4.g(4) | 0;
	      };
	
	      prng.quick = function () {
	        return arc4.g(4) / 0x100000000;
	      };
	
	      prng["double"] = prng; // Mix the randomness into accumulated entropy.
	
	      mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
	
	      return (options.pass || callback || function (prng, seed, is_math_call, state) {
	        if (state) {
	          // Load the arc4 state from the given state if it has an S array.
	          if (state.S) {
	            copy(state, arc4);
	          } // Only provide the .state method if requested via options.state.
	
	
	          prng.state = function () {
	            return copy(arc4, {});
	          };
	        } // If called as a method of Math (Math.seedrandom()), mutate
	        // Math.random because that is how seedrandom.js has worked since v1.0.
	
	
	        if (is_math_call) {
	          math[rngname] = prng;
	          return seed;
	        } // Otherwise, it is a newer calling convention, so return the
	        // prng directly.
	        else return prng;
	      })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
	    }
	
	    math['seed' + rngname] = seedrandom; //
	    // ARC4
	    //
	    // An ARC4 implementation.  The constructor takes a key in the form of
	    // an array of at most (width) integers that should be 0 <= x < (width).
	    //
	    // The g(count) method returns a pseudorandom integer that concatenates
	    // the next (count) outputs from ARC4.  Its return value is a number x
	    // that is in the range 0 <= x < (width ^ count).
	    //
	
	    function ARC4(key) {
	      var t,
	          keylen = key.length,
	          me = this,
	          i = 0,
	          j = me.i = me.j = 0,
	          s = me.S = []; // The empty key [] is treated as [0].
	
	      if (!keylen) {
	        key = [keylen++];
	      } // Set up S using the standard key scheduling algorithm.
	
	
	      while (i < width) {
	        s[i] = i++;
	      }
	
	      for (i = 0; i < width; i++) {
	        s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
	        s[j] = t;
	      } // The "g" method returns the next (count) outputs as one number.
	
	
	      me.g = function (count) {
	        // Using instance members instead of closure state nearly doubles speed.
	        var t,
	            r = 0,
	            i = me.i,
	            j = me.j,
	            s = me.S;
	
	        while (count--) {
	          t = s[i = mask & i + 1];
	          r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
	        }
	
	        me.i = i;
	        me.j = j;
	        return r; // For robust unpredictability, the function call below automatically
	        // discards an initial batch of values.  This is called RC4-drop[256].
	        // See http://google.com/search?q=rsa+fluhrer+response&btnI
	      };
	    } //
	    // copy()
	    // Copies internal state of ARC4 to or from a plain object.
	    //
	
	
	    function copy(f, t) {
	      t.i = f.i;
	      t.j = f.j;
	      t.S = f.S.slice();
	      return t;
	    } //
	    // flatten()
	    // Converts an object tree to nested arrays of strings.
	    //
	
	
	    function flatten(obj, depth) {
	      var result = [],
	          typ = _typeof$2(obj),
	          prop;
	
	      if (depth && typ == 'object') {
	        for (prop in obj) {
	          try {
	            result.push(flatten(obj[prop], depth - 1));
	          } catch (e) {}
	        }
	      }
	
	      return result.length ? result : typ == 'string' ? obj : obj + '\0';
	    } //
	    // mixkey()
	    // Mixes a string seed into a key that is an array of integers, and
	    // returns a shortened string seed that is equivalent to the result key.
	    //
	
	
	    function mixkey(seed, key) {
	      var stringseed = seed + '',
	          smear,
	          j = 0;
	
	      while (j < stringseed.length) {
	        key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
	      }
	
	      return tostring(key);
	    } //
	    // autoseed()
	    // Returns an object for autoseeding, using window.crypto and Node crypto
	    // module if available.
	    //
	
	
	    function autoseed() {
	      try {
	        if (nodecrypto) {
	          return tostring(nodecrypto.randomBytes(width));
	        }
	
	        var out = new Uint8Array(width);
	        (global.crypto || global.msCrypto).getRandomValues(out);
	        return tostring(out);
	      } catch (e) {
	        var browser = global.navigator,
	            plugins = browser && browser.plugins;
	        return [+new Date(), global, plugins, global.screen, tostring(pool)];
	      }
	    } //
	    // tostring()
	    // Converts an array of charcodes to a string
	    //
	
	
	    function tostring(a) {
	      return String.fromCharCode.apply(0, a);
	    } //
	    // When seedrandom.js is loaded, we immediately mix a few bits
	    // from the built-in RNG into the entropy pool.  Because we do
	    // not want to interfere with deterministic PRNG state later,
	    // seedrandom will not call math.random on its own again after
	    // initialization.
	    //
	
	
	    mixkey(math.random(), pool); //
	    // Nodejs and AMD support: export the implementation as a module using
	    // either convention.
	    //
	    // End anonymous scope, and pass initial values.
	  }
	
	  ;
	
	  function initialize$2(BMMath) {
	    seedRandom([], BMMath);
	  }
	
	  var propTypes = {
	    SHAPE: 'shape'
	  };
	
	  function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }
	
	  var ExpressionManager = function () {
	    'use strict';
	
	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	    var XMLHttpRequest = null;
	    var fetch = null;
	    var frames = null;
	    var _lottieGlobal = {};
	    initialize$2(BMMath);
	
	    function resetFrame() {
	      _lottieGlobal = {};
	    }
	
	    function $bm_isInstanceOfArray(arr) {
	      return arr.constructor === Array || arr.constructor === Float32Array;
	    }
	
	    function isNumerable(tOfV, v) {
	      return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
	    }
	
	    function $bm_neg(a) {
	      var tOfA = _typeof$1(a);
	
	      if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') {
	        return -a;
	      }
	
	      if ($bm_isInstanceOfArray(a)) {
	        var i;
	        var lenA = a.length;
	        var retArr = [];
	
	        for (i = 0; i < lenA; i += 1) {
	          retArr[i] = -a[i];
	        }
	
	        return retArr;
	      }
	
	      if (a.propType) {
	        return a.v;
	      }
	
	      return -a;
	    }
	
	    var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
	    var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
	    var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
	
	    function sum(a, b) {
	      var tOfA = _typeof$1(a);
	
	      var tOfB = _typeof$1(b);
	
	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') {
	        return a + b;
	      }
	
	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        a = a.slice(0);
	        a[0] += b;
	        return a;
	      }
	
	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        b = b.slice(0);
	        b[0] = a + b[0];
	        return b;
	      }
	
	      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
	        var i = 0;
	        var lenA = a.length;
	        var lenB = b.length;
	        var retArr = [];
	
	        while (i < lenA || i < lenB) {
	          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
	            retArr[i] = a[i] + b[i];
	          } else {
	            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	          }
	
	          i += 1;
	        }
	
	        return retArr;
	      }
	
	      return 0;
	    }
	
	    var add = sum;
	
	    function sub(a, b) {
	      var tOfA = _typeof$1(a);
	
	      var tOfB = _typeof$1(b);
	
	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        if (tOfA === 'string') {
	          a = parseInt(a, 10);
	        }
	
	        if (tOfB === 'string') {
	          b = parseInt(b, 10);
	        }
	
	        return a - b;
	      }
	
	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        a = a.slice(0);
	        a[0] -= b;
	        return a;
	      }
	
	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        b = b.slice(0);
	        b[0] = a - b[0];
	        return b;
	      }
	
	      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
	        var i = 0;
	        var lenA = a.length;
	        var lenB = b.length;
	        var retArr = [];
	
	        while (i < lenA || i < lenB) {
	          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
	            retArr[i] = a[i] - b[i];
	          } else {
	            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
	          }
	
	          i += 1;
	        }
	
	        return retArr;
	      }
	
	      return 0;
	    }
	
	    function mul(a, b) {
	      var tOfA = _typeof$1(a);
	
	      var tOfB = _typeof$1(b);
	
	      var arr;
	
	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        return a * b;
	      }
	
	      var i;
	      var len;
	
	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        len = a.length;
	        arr = createTypedArray('float32', len);
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = a[i] * b;
	        }
	
	        return arr;
	      }
	
	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        len = b.length;
	        arr = createTypedArray('float32', len);
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = a * b[i];
	        }
	
	        return arr;
	      }
	
	      return 0;
	    }
	
	    function div(a, b) {
	      var tOfA = _typeof$1(a);
	
	      var tOfB = _typeof$1(b);
	
	      var arr;
	
	      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
	        return a / b;
	      }
	
	      var i;
	      var len;
	
	      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
	        len = a.length;
	        arr = createTypedArray('float32', len);
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = a[i] / b;
	        }
	
	        return arr;
	      }
	
	      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
	        len = b.length;
	        arr = createTypedArray('float32', len);
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = a / b[i];
	        }
	
	        return arr;
	      }
	
	      return 0;
	    }
	
	    function mod(a, b) {
	      if (typeof a === 'string') {
	        a = parseInt(a, 10);
	      }
	
	      if (typeof b === 'string') {
	        b = parseInt(b, 10);
	      }
	
	      return a % b;
	    }
	
	    var $bm_sum = sum;
	    var $bm_sub = sub;
	    var $bm_mul = mul;
	    var $bm_div = div;
	    var $bm_mod = mod;
	
	    function clamp(num, min, max) {
	      if (min > max) {
	        var mm = max;
	        max = min;
	        min = mm;
	      }
	
	      return Math.min(Math.max(num, min), max);
	    }
	
	    function radiansToDegrees(val) {
	      return val / degToRads;
	    }
	
	    var radians_to_degrees = radiansToDegrees;
	
	    function degreesToRadians(val) {
	      return val * degToRads;
	    }
	
	    var degrees_to_radians = radiansToDegrees;
	    var helperLengthArray = [0, 0, 0, 0, 0, 0];
	
	    function length(arr1, arr2) {
	      if (typeof arr1 === 'number' || arr1 instanceof Number) {
	        arr2 = arr2 || 0;
	        return Math.abs(arr1 - arr2);
	      }
	
	      if (!arr2) {
	        arr2 = helperLengthArray;
	      }
	
	      var i;
	      var len = Math.min(arr1.length, arr2.length);
	      var addedLength = 0;
	
	      for (i = 0; i < len; i += 1) {
	        addedLength += Math.pow(arr2[i] - arr1[i], 2);
	      }
	
	      return Math.sqrt(addedLength);
	    }
	
	    function normalize(vec) {
	      return div(vec, length(vec));
	    }
	
	    function rgbToHsl(val) {
	      var r = val[0];
	      var g = val[1];
	      var b = val[2];
	      var max = Math.max(r, g, b);
	      var min = Math.min(r, g, b);
	      var h;
	      var s;
	      var l = (max + min) / 2;
	
	      if (max === min) {
	        h = 0; // achromatic
	
	        s = 0; // achromatic
	      } else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	
	        switch (max) {
	          case r:
	            h = (g - b) / d + (g < b ? 6 : 0);
	            break;
	
	          case g:
	            h = (b - r) / d + 2;
	            break;
	
	          case b:
	            h = (r - g) / d + 4;
	            break;
	
	          default:
	            break;
	        }
	
	        h /= 6;
	      }
	
	      return [h, s, l, val[3]];
	    }
	
	    function hue2rgb(p, q, t) {
	      if (t < 0) t += 1;
	      if (t > 1) t -= 1;
	      if (t < 1 / 6) return p + (q - p) * 6 * t;
	      if (t < 1 / 2) return q;
	      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	      return p;
	    }
	
	    function hslToRgb(val) {
	      var h = val[0];
	      var s = val[1];
	      var l = val[2];
	      var r;
	      var g;
	      var b;
	
	      if (s === 0) {
	        r = l; // achromatic
	
	        b = l; // achromatic
	
	        g = l; // achromatic
	      } else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1 / 3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1 / 3);
	      }
	
	      return [r, g, b, val[3]];
	    }
	
	    function linear(t, tMin, tMax, value1, value2) {
	      if (value1 === undefined || value2 === undefined) {
	        value1 = tMin;
	        value2 = tMax;
	        tMin = 0;
	        tMax = 1;
	      }
	
	      if (tMax < tMin) {
	        var _tMin = tMax;
	        tMax = tMin;
	        tMin = _tMin;
	      }
	
	      if (t <= tMin) {
	        return value1;
	      }
	
	      if (t >= tMax) {
	        return value2;
	      }
	
	      var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
	
	      if (!value1.length) {
	        return value1 + (value2 - value1) * perc;
	      }
	
	      var i;
	      var len = value1.length;
	      var arr = createTypedArray('float32', len);
	
	      for (i = 0; i < len; i += 1) {
	        arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
	      }
	
	      return arr;
	    }
	
	    function random(min, max) {
	      if (max === undefined) {
	        if (min === undefined) {
	          min = 0;
	          max = 1;
	        } else {
	          max = min;
	          min = undefined;
	        }
	      }
	
	      if (max.length) {
	        var i;
	        var len = max.length;
	
	        if (!min) {
	          min = createTypedArray('float32', len);
	        }
	
	        var arr = createTypedArray('float32', len);
	        var rnd = BMMath.random();
	
	        for (i = 0; i < len; i += 1) {
	          arr[i] = min[i] + rnd * (max[i] - min[i]);
	        }
	
	        return arr;
	      }
	
	      if (min === undefined) {
	        min = 0;
	      }
	
	      var rndm = BMMath.random();
	      return min + rndm * (max - min);
	    }
	
	    function createPath(points, inTangents, outTangents, closed) {
	      var i;
	      var len = points.length;
	      var path = shapePool.newElement();
	      path.setPathData(!!closed, len);
	      var arrPlaceholder = [0, 0];
	      var inVertexPoint;
	      var outVertexPoint;
	
	      for (i = 0; i < len; i += 1) {
	        inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
	        outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
	        path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
	      }
	
	      return path;
	    }
	
	    function initiateExpression(elem, data, property) {
	      // Bail out if we don't want expressions
	      function noOp(_value) {
	        return _value;
	      }
	
	      if (!elem.globalData.renderConfig.runExpressions) {
	        return noOp;
	      }
	
	      var val = data.x;
	      var needsVelocity = /velocity(?![\w\d])/.test(val);
	
	      var _needsRandom = val.indexOf('random') !== -1;
	
	      var elemType = elem.data.ty;
	      var transform;
	      var $bm_transform;
	      var content;
	      var effect;
	      var thisProperty = property;
	      thisProperty.valueAtTime = thisProperty.getValueAtTime;
	      Object.defineProperty(thisProperty, 'value', {
	        get: function get() {
	          return thisProperty.v;
	        }
	      });
	      elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
	      elem.comp.displayStartTime = 0;
	      var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
	      var outPoint = elem.data.op / elem.comp.globalData.frameRate;
	      var width = elem.data.sw ? elem.data.sw : 0;
	      var height = elem.data.sh ? elem.data.sh : 0;
	      var name = elem.data.nm;
	      var loopIn;
	      var loop_in;
	      var loopOut;
	      var loop_out;
	      var smooth;
	      var toWorld;
	      var fromWorld;
	      var fromComp;
	      var toComp;
	      var fromCompToSurface;
	      var position;
	      var rotation;
	      var anchorPoint;
	      var scale;
	      var thisLayer;
	      var thisComp;
	      var mask;
	      var valueAtTime;
	      var velocityAtTime;
	      var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
	
	      var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
	
	      var numKeys = property.kf ? data.k.length : 0;
	      var active = !this.data || this.data.hd !== true;
	
	      var wiggle = function wiggle(freq, amp) {
	        var iWiggle;
	        var j;
	        var lenWiggle = this.pv.length ? this.pv.length : 1;
	        var addedAmps = createTypedArray('float32', lenWiggle);
	        freq = 5;
	        var iterations = Math.floor(time * freq);
	        iWiggle = 0;
	        j = 0;
	
	        while (iWiggle < iterations) {
	          // var rnd = BMMath.random();
	          for (j = 0; j < lenWiggle; j += 1) {
	            addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
	          }
	
	          iWiggle += 1;
	        } // var rnd2 = BMMath.random();
	
	
	        var periods = time * freq;
	        var perc = periods - Math.floor(periods);
	        var arr = createTypedArray('float32', lenWiggle);
	
	        if (lenWiggle > 1) {
	          for (j = 0; j < lenWiggle; j += 1) {
	            arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	            // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	          }
	
	          return arr;
	        }
	
	        return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
	      }.bind(this);
	
	      if (thisProperty.loopIn) {
	        loopIn = thisProperty.loopIn.bind(thisProperty);
	        loop_in = loopIn;
	      }
	
	      if (thisProperty.loopOut) {
	        loopOut = thisProperty.loopOut.bind(thisProperty);
	        loop_out = loopOut;
	      }
	
	      if (thisProperty.smooth) {
	        smooth = thisProperty.smooth.bind(thisProperty);
	      }
	
	      function loopInDuration(type, duration) {
	        return loopIn(type, duration, true);
	      }
	
	      function loopOutDuration(type, duration) {
	        return loopOut(type, duration, true);
	      }
	
	      if (this.getValueAtTime) {
	        valueAtTime = this.getValueAtTime.bind(this);
	      }
	
	      if (this.getVelocityAtTime) {
	        velocityAtTime = this.getVelocityAtTime.bind(this);
	      }
	
	      var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
	
	      function lookAt(elem1, elem2) {
	        var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
	        var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
	        var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
	        return [yaw, pitch, 0];
	      }
	
	      function easeOut(t, tMin, tMax, val1, val2) {
	        return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
	      }
	
	      function easeIn(t, tMin, tMax, val1, val2) {
	        return applyEase(easeInBez, t, tMin, tMax, val1, val2);
	      }
	
	      function ease(t, tMin, tMax, val1, val2) {
	        return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
	      }
	
	      function applyEase(fn, t, tMin, tMax, val1, val2) {
	        if (val1 === undefined) {
	          val1 = tMin;
	          val2 = tMax;
	        } else {
	          t = (t - tMin) / (tMax - tMin);
	        }
	
	        if (t > 1) {
	          t = 1;
	        } else if (t < 0) {
	          t = 0;
	        }
	
	        var mult = fn(t);
	
	        if ($bm_isInstanceOfArray(val1)) {
	          var iKey;
	          var lenKey = val1.length;
	          var arr = createTypedArray('float32', lenKey);
	
	          for (iKey = 0; iKey < lenKey; iKey += 1) {
	            arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
	          }
	
	          return arr;
	        }
	
	        return (val2 - val1) * mult + val1;
	      }
	
	      function nearestKey(time) {
	        var iKey;
	        var lenKey = data.k.length;
	        var index;
	        var keyTime;
	
	        if (!data.k.length || typeof data.k[0] === 'number') {
	          index = 0;
	          keyTime = 0;
	        } else {
	          index = -1;
	          time *= elem.comp.globalData.frameRate;
	
	          if (time < data.k[0].t) {
	            index = 1;
	            keyTime = data.k[0].t;
	          } else {
	            for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
	              if (time === data.k[iKey].t) {
	                index = iKey + 1;
	                keyTime = data.k[iKey].t;
	                break;
	              } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
	                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
	                  index = iKey + 2;
	                  keyTime = data.k[iKey + 1].t;
	                } else {
	                  index = iKey + 1;
	                  keyTime = data.k[iKey].t;
	                }
	
	                break;
	              }
	            }
	
	            if (index === -1) {
	              index = iKey + 1;
	              keyTime = data.k[iKey].t;
	            }
	          }
	        }
	
	        var obKey = {};
	        obKey.index = index;
	        obKey.time = keyTime / elem.comp.globalData.frameRate;
	        return obKey;
	      }
	
	      function key(ind) {
	        var obKey;
	        var iKey;
	        var lenKey;
	
	        if (!data.k.length || typeof data.k[0] === 'number') {
	          throw new Error('The property has no keyframe at index ' + ind);
	        }
	
	        ind -= 1;
	        obKey = {
	          time: data.k[ind].t / elem.comp.globalData.frameRate,
	          value: []
	        };
	        var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
	        lenKey = arr.length;
	
	        for (iKey = 0; iKey < lenKey; iKey += 1) {
	          obKey[iKey] = arr[iKey];
	          obKey.value[iKey] = arr[iKey];
	        }
	
	        return obKey;
	      }
	
	      function framesToTime(fr, fps) {
	        if (!fps) {
	          fps = elem.comp.globalData.frameRate;
	        }
	
	        return fr / fps;
	      }
	
	      function timeToFrames(t, fps) {
	        if (!t && t !== 0) {
	          t = time;
	        }
	
	        if (!fps) {
	          fps = elem.comp.globalData.frameRate;
	        }
	
	        return t * fps;
	      }
	
	      function seedRandom(seed) {
	        BMMath.seedrandom(randSeed + seed);
	      }
	
	      function sourceRectAtTime() {
	        return elem.sourceRectAtTime();
	      }
	
	      function substring(init, end) {
	        if (typeof value === 'string') {
	          if (end === undefined) {
	            return value.substring(init);
	          }
	
	          return value.substring(init, end);
	        }
	
	        return '';
	      }
	
	      function substr(init, end) {
	        if (typeof value === 'string') {
	          if (end === undefined) {
	            return value.substr(init);
	          }
	
	          return value.substr(init, end);
	        }
	
	        return '';
	      }
	
	      function posterizeTime(framesPerSecond) {
	        time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
	        value = valueAtTime(time);
	      }
	
	      var time;
	      var velocity;
	      var value;
	      var text;
	      var textIndex;
	      var textTotal;
	      var selectorValue;
	      var index = elem.data.ind;
	      var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	      var parent;
	      var randSeed = Math.floor(Math.random() * 1000000);
	      var globalData = elem.globalData;
	
	      function executeExpression(_value) {
	        // globalData.pushExpression();
	        value = _value;
	
	        if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
	          return value;
	        }
	
	        if (this.propType === 'textSelector') {
	          textIndex = this.textIndex;
	          textTotal = this.textTotal;
	          selectorValue = this.selectorValue;
	        }
	
	        if (!thisLayer) {
	          text = elem.layerInterface.text;
	          thisLayer = elem.layerInterface;
	          thisComp = elem.comp.compInterface;
	          toWorld = thisLayer.toWorld.bind(thisLayer);
	          fromWorld = thisLayer.fromWorld.bind(thisLayer);
	          fromComp = thisLayer.fromComp.bind(thisLayer);
	          toComp = thisLayer.toComp.bind(thisLayer);
	          mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
	          fromCompToSurface = fromComp;
	        }
	
	        if (!transform) {
	          transform = elem.layerInterface('ADBE Transform Group');
	          $bm_transform = transform;
	
	          if (transform) {
	            anchorPoint = transform.anchorPoint;
	            /* position = transform.position;
	                      rotation = transform.rotation;
	                      scale = transform.scale; */
	          }
	        }
	
	        if (elemType === 4 && !content) {
	          content = thisLayer('ADBE Root Vectors Group');
	        }
	
	        if (!effect) {
	          effect = thisLayer(4);
	        }
	
	        hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	
	        if (hasParent && !parent) {
	          parent = elem.hierarchy[0].layerInterface;
	        }
	
	        time = this.comp.renderedFrame / this.comp.globalData.frameRate;
	
	        if (_needsRandom) {
	          seedRandom(randSeed + time);
	        }
	
	        if (needsVelocity) {
	          velocity = velocityAtTime(time);
	        }
	
	        expression_function();
	        this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
	        // Changed this to a ternary operation because Rollup failed compiling it correctly
	
	        scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
	        return scoped_bm_rt;
	      } // Bundlers will see these as dead code and unless we reference them
	
	
	      executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData];
	      return executeExpression;
	    }
	
	    ob.initiateExpression = initiateExpression;
	    ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal];
	    ob.resetFrame = resetFrame;
	    return ob;
	  }();
	
	  var Expressions = function () {
	    var ob = {};
	    ob.initExpressions = initExpressions;
	    ob.resetFrame = ExpressionManager.resetFrame;
	
	    function initExpressions(animation) {
	      var stackCount = 0;
	      var registers = [];
	
	      function pushExpression() {
	        stackCount += 1;
	      }
	
	      function popExpression() {
	        stackCount -= 1;
	
	        if (stackCount === 0) {
	          releaseInstances();
	        }
	      }
	
	      function registerExpressionProperty(expression) {
	        if (registers.indexOf(expression) === -1) {
	          registers.push(expression);
	        }
	      }
	
	      function releaseInstances() {
	        var i;
	        var len = registers.length;
	
	        for (i = 0; i < len; i += 1) {
	          registers[i].release();
	        }
	
	        registers.length = 0;
	      }
	
	      animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	      animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	      animation.renderer.globalData.pushExpression = pushExpression;
	      animation.renderer.globalData.popExpression = popExpression;
	      animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
	    }
	
	    return ob;
	  }();
	
	  var MaskManagerInterface = function () {
	    function MaskInterface(mask, data) {
	      this._mask = mask;
	      this._data = data;
	    }
	
	    Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	      get: function get() {
	        if (this._mask.prop.k) {
	          this._mask.prop.getValue();
	        }
	
	        return this._mask.prop;
	      }
	    });
	    Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
	      get: function get() {
	        if (this._mask.op.k) {
	          this._mask.op.getValue();
	        }
	
	        return this._mask.op.v * 100;
	      }
	    });
	
	    var MaskManager = function MaskManager(maskManager) {
	      var _masksInterfaces = createSizedArray(maskManager.viewData.length);
	
	      var i;
	      var len = maskManager.viewData.length;
	
	      for (i = 0; i < len; i += 1) {
	        _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
	      }
	
	      var maskFunction = function maskFunction(name) {
	        i = 0;
	
	        while (i < len) {
	          if (maskManager.masksProperties[i].nm === name) {
	            return _masksInterfaces[i];
	          }
	
	          i += 1;
	        }
	
	        return null;
	      };
	
	      return maskFunction;
	    };
	
	    return MaskManager;
	  }();
	
	  var ExpressionPropertyInterface = function () {
	    var defaultUnidimensionalValue = {
	      pv: 0,
	      v: 0,
	      mult: 1
	    };
	    var defaultMultidimensionalValue = {
	      pv: [0, 0, 0],
	      v: [0, 0, 0],
	      mult: 1
	    };
	
	    function completeProperty(expressionValue, property, type) {
	      Object.defineProperty(expressionValue, 'velocity', {
	        get: function get() {
	          return property.getVelocityAtTime(property.comp.currentFrame);
	        }
	      });
	      expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
	
	      expressionValue.key = function (pos) {
	        if (!expressionValue.numKeys) {
	          return 0;
	        }
	
	        var value = '';
	
	        if ('s' in property.keyframes[pos - 1]) {
	          value = property.keyframes[pos - 1].s;
	        } else if ('e' in property.keyframes[pos - 2]) {
	          value = property.keyframes[pos - 2].e;
	        } else {
	          value = property.keyframes[pos - 2].s;
	        }
	
	        var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
	
	        valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
	        valueProp.value = type === 'unidimensional' ? value[0] : value;
	        return valueProp;
	      };
	
	      expressionValue.valueAtTime = property.getValueAtTime;
	      expressionValue.speedAtTime = property.getSpeedAtTime;
	      expressionValue.velocityAtTime = property.getVelocityAtTime;
	      expressionValue.propertyGroup = property.propertyGroup;
	    }
	
	    function UnidimensionalPropertyInterface(property) {
	      if (!property || !('pv' in property)) {
	        property = defaultUnidimensionalValue;
	      }
	
	      var mult = 1 / property.mult;
	      var val = property.pv * mult;
	      var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
	
	      expressionValue.value = val;
	      completeProperty(expressionValue, property, 'unidimensional');
	      return function () {
	        if (property.k) {
	          property.getValue();
	        }
	
	        val = property.v * mult;
	
	        if (expressionValue.value !== val) {
	          expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
	
	          expressionValue.value = val;
	          completeProperty(expressionValue, property, 'unidimensional');
	        }
	
	        return expressionValue;
	      };
	    }
	
	    function MultidimensionalPropertyInterface(property) {
	      if (!property || !('pv' in property)) {
	        property = defaultMultidimensionalValue;
	      }
	
	      var mult = 1 / property.mult;
	      var len = property.data && property.data.l || property.pv.length;
	      var expressionValue = createTypedArray('float32', len);
	      var arrValue = createTypedArray('float32', len);
	      expressionValue.value = arrValue;
	      completeProperty(expressionValue, property, 'multidimensional');
	      return function () {
	        if (property.k) {
	          property.getValue();
	        }
	
	        for (var i = 0; i < len; i += 1) {
	          arrValue[i] = property.v[i] * mult;
	          expressionValue[i] = arrValue[i];
	        }
	
	        return expressionValue;
	      };
	    } // TODO: try to avoid using this getter
	
	
	    function defaultGetter() {
	      return defaultUnidimensionalValue;
	    }
	
	    return function (property) {
	      if (!property) {
	        return defaultGetter;
	      }
	
	      if (property.propType === 'unidimensional') {
	        return UnidimensionalPropertyInterface(property);
	      }
	
	      return MultidimensionalPropertyInterface(property);
	    };
	  }();
	
	  var TransformExpressionInterface = function () {
	    return function (transform) {
	      function _thisFunction(name) {
	        switch (name) {
	          case 'scale':
	          case 'Scale':
	          case 'ADBE Scale':
	          case 6:
	            return _thisFunction.scale;
	
	          case 'rotation':
	          case 'Rotation':
	          case 'ADBE Rotation':
	          case 'ADBE Rotate Z':
	          case 10:
	            return _thisFunction.rotation;
	
	          case 'ADBE Rotate X':
	            return _thisFunction.xRotation;
	
	          case 'ADBE Rotate Y':
	            return _thisFunction.yRotation;
	
	          case 'position':
	          case 'Position':
	          case 'ADBE Position':
	          case 2:
	            return _thisFunction.position;
	
	          case 'ADBE Position_0':
	            return _thisFunction.xPosition;
	
	          case 'ADBE Position_1':
	            return _thisFunction.yPosition;
	
	          case 'ADBE Position_2':
	            return _thisFunction.zPosition;
	
	          case 'anchorPoint':
	          case 'AnchorPoint':
	          case 'Anchor Point':
	          case 'ADBE AnchorPoint':
	          case 1:
	            return _thisFunction.anchorPoint;
	
	          case 'opacity':
	          case 'Opacity':
	          case 11:
	            return _thisFunction.opacity;
	
	          default:
	            return null;
	        }
	      }
	
	      Object.defineProperty(_thisFunction, 'rotation', {
	        get: ExpressionPropertyInterface(transform.r || transform.rz)
	      });
	      Object.defineProperty(_thisFunction, 'zRotation', {
	        get: ExpressionPropertyInterface(transform.rz || transform.r)
	      });
	      Object.defineProperty(_thisFunction, 'xRotation', {
	        get: ExpressionPropertyInterface(transform.rx)
	      });
	      Object.defineProperty(_thisFunction, 'yRotation', {
	        get: ExpressionPropertyInterface(transform.ry)
	      });
	      Object.defineProperty(_thisFunction, 'scale', {
	        get: ExpressionPropertyInterface(transform.s)
	      });
	
	      var _px;
	
	      var _py;
	
	      var _pz;
	
	      var _transformFactory;
	
	      if (transform.p) {
	        _transformFactory = ExpressionPropertyInterface(transform.p);
	      } else {
	        _px = ExpressionPropertyInterface(transform.px);
	        _py = ExpressionPropertyInterface(transform.py);
	
	        if (transform.pz) {
	          _pz = ExpressionPropertyInterface(transform.pz);
	        }
	      }
	
	      Object.defineProperty(_thisFunction, 'position', {
	        get: function get() {
	          if (transform.p) {
	            return _transformFactory();
	          }
	
	          return [_px(), _py(), _pz ? _pz() : 0];
	        }
	      });
	      Object.defineProperty(_thisFunction, 'xPosition', {
	        get: ExpressionPropertyInterface(transform.px)
	      });
	      Object.defineProperty(_thisFunction, 'yPosition', {
	        get: ExpressionPropertyInterface(transform.py)
	      });
	      Object.defineProperty(_thisFunction, 'zPosition', {
	        get: ExpressionPropertyInterface(transform.pz)
	      });
	      Object.defineProperty(_thisFunction, 'anchorPoint', {
	        get: ExpressionPropertyInterface(transform.a)
	      });
	      Object.defineProperty(_thisFunction, 'opacity', {
	        get: ExpressionPropertyInterface(transform.o)
	      });
	      Object.defineProperty(_thisFunction, 'skew', {
	        get: ExpressionPropertyInterface(transform.sk)
	      });
	      Object.defineProperty(_thisFunction, 'skewAxis', {
	        get: ExpressionPropertyInterface(transform.sa)
	      });
	      Object.defineProperty(_thisFunction, 'orientation', {
	        get: ExpressionPropertyInterface(transform.or)
	      });
	      return _thisFunction;
	    };
	  }();
	
	  var LayerExpressionInterface = function () {
	    function getMatrix(time) {
	      var toWorldMat = new Matrix();
	
	      if (time !== undefined) {
	        var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
	
	        propMatrix.clone(toWorldMat);
	      } else {
	        var transformMat = this._elem.finalTransform.mProp;
	        transformMat.applyToMatrix(toWorldMat);
	      }
	
	      return toWorldMat;
	    }
	
	    function toWorldVec(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      toWorldMat.props[12] = 0;
	      toWorldMat.props[13] = 0;
	      toWorldMat.props[14] = 0;
	      return this.applyPoint(toWorldMat, arr);
	    }
	
	    function toWorld(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      return this.applyPoint(toWorldMat, arr);
	    }
	
	    function fromWorldVec(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      toWorldMat.props[12] = 0;
	      toWorldMat.props[13] = 0;
	      toWorldMat.props[14] = 0;
	      return this.invertPoint(toWorldMat, arr);
	    }
	
	    function fromWorld(arr, time) {
	      var toWorldMat = this.getMatrix(time);
	      return this.invertPoint(toWorldMat, arr);
	    }
	
	    function applyPoint(matrix, arr) {
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;
	
	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
	        }
	      }
	
	      return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
	    }
	
	    function invertPoint(matrix, arr) {
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;
	
	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
	        }
	      }
	
	      return matrix.inversePoint(arr);
	    }
	
	    function fromComp(arr) {
	      var toWorldMat = new Matrix();
	      toWorldMat.reset();
	
	      this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
	
	      if (this._elem.hierarchy && this._elem.hierarchy.length) {
	        var i;
	        var len = this._elem.hierarchy.length;
	
	        for (i = 0; i < len; i += 1) {
	          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	        }
	
	        return toWorldMat.inversePoint(arr);
	      }
	
	      return toWorldMat.inversePoint(arr);
	    }
	
	    function sampleImage() {
	      return [1, 1, 1, 1];
	    }
	
	    return function (elem) {
	      var transformInterface;
	
	      function _registerMaskInterface(maskManager) {
	        _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	      }
	
	      function _registerEffectsInterface(effects) {
	        _thisLayerFunction.effect = effects;
	      }
	
	      function _thisLayerFunction(name) {
	        switch (name) {
	          case 'ADBE Root Vectors Group':
	          case 'Contents':
	          case 2:
	            return _thisLayerFunction.shapeInterface;
	
	          case 1:
	          case 6:
	          case 'Transform':
	          case 'transform':
	          case 'ADBE Transform Group':
	            return transformInterface;
	
	          case 4:
	          case 'ADBE Effect Parade':
	          case 'effects':
	          case 'Effects':
	            return _thisLayerFunction.effect;
	
	          case 'ADBE Text Properties':
	            return _thisLayerFunction.textInterface;
	
	          default:
	            return null;
	        }
	      }
	
	      _thisLayerFunction.getMatrix = getMatrix;
	      _thisLayerFunction.invertPoint = invertPoint;
	      _thisLayerFunction.applyPoint = applyPoint;
	      _thisLayerFunction.toWorld = toWorld;
	      _thisLayerFunction.toWorldVec = toWorldVec;
	      _thisLayerFunction.fromWorld = fromWorld;
	      _thisLayerFunction.fromWorldVec = fromWorldVec;
	      _thisLayerFunction.toComp = toWorld;
	      _thisLayerFunction.fromComp = fromComp;
	      _thisLayerFunction.sampleImage = sampleImage;
	      _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	      _thisLayerFunction._elem = elem;
	      transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
	      var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	      Object.defineProperties(_thisLayerFunction, {
	        hasParent: {
	          get: function get() {
	            return elem.hierarchy.length;
	          }
	        },
	        parent: {
	          get: function get() {
	            return elem.hierarchy[0].layerInterface;
	          }
	        },
	        rotation: getDescriptor(transformInterface, 'rotation'),
	        scale: getDescriptor(transformInterface, 'scale'),
	        position: getDescriptor(transformInterface, 'position'),
	        opacity: getDescriptor(transformInterface, 'opacity'),
	        anchorPoint: anchorPointDescriptor,
	        anchor_point: anchorPointDescriptor,
	        transform: {
	          get: function get() {
	            return transformInterface;
	          }
	        },
	        active: {
	          get: function get() {
	            return elem.isInRange;
	          }
	        }
	      });
	      _thisLayerFunction.startTime = elem.data.st;
	      _thisLayerFunction.index = elem.data.ind;
	      _thisLayerFunction.source = elem.data.refId;
	      _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	      _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	      _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
	      _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
	      _thisLayerFunction._name = elem.data.nm;
	      _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	      _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	      return _thisLayerFunction;
	    };
	  }();
	
	  var propertyGroupFactory = function () {
	    return function (interfaceFunction, parentPropertyGroup) {
	      return function (val) {
	        val = val === undefined ? 1 : val;
	
	        if (val <= 0) {
	          return interfaceFunction;
	        }
	
	        return parentPropertyGroup(val - 1);
	      };
	    };
	  }();
	
	  var PropertyInterface = function () {
	    return function (propertyName, propertyGroup) {
	      var interfaceFunction = {
	        _name: propertyName
	      };
	
	      function _propertyGroup(val) {
	        val = val === undefined ? 1 : val;
	
	        if (val <= 0) {
	          return interfaceFunction;
	        }
	
	        return propertyGroup(val - 1);
	      }
	
	      return _propertyGroup;
	    };
	  }();
	
	  var EffectsExpressionInterface = function () {
	    var ob = {
	      createEffectsInterface: createEffectsInterface
	    };
	
	    function createEffectsInterface(elem, propertyGroup) {
	      if (elem.effectsManager) {
	        var effectElements = [];
	        var effectsData = elem.data.ef;
	        var i;
	        var len = elem.effectsManager.effectElements.length;
	
	        for (i = 0; i < len; i += 1) {
	          effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
	        }
	
	        var effects = elem.data.ef || [];
	
	        var groupInterface = function groupInterface(name) {
	          i = 0;
	          len = effects.length;
	
	          while (i < len) {
	            if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
	              return effectElements[i];
	            }
	
	            i += 1;
	          }
	
	          return null;
	        };
	
	        Object.defineProperty(groupInterface, 'numProperties', {
	          get: function get() {
	            return effects.length;
	          }
	        });
	        return groupInterface;
	      }
	
	      return null;
	    }
	
	    function createGroupInterface(data, elements, propertyGroup, elem) {
	      function groupInterface(name) {
	        var effects = data.ef;
	        var i = 0;
	        var len = effects.length;
	
	        while (i < len) {
	          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
	            if (effects[i].ty === 5) {
	              return effectElements[i];
	            }
	
	            return effectElements[i]();
	          }
	
	          i += 1;
	        }
	
	        throw new Error();
	      }
	
	      var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
	
	      var effectElements = [];
	      var i;
	      var len = data.ef.length;
	
	      for (i = 0; i < len; i += 1) {
	        if (data.ef[i].ty === 5) {
	          effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
	        } else {
	          effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
	        }
	      }
	
	      if (data.mn === 'ADBE Color Control') {
	        Object.defineProperty(groupInterface, 'color', {
	          get: function get() {
	            return effectElements[0]();
	          }
	        });
	      }
	
	      Object.defineProperties(groupInterface, {
	        numProperties: {
	          get: function get() {
	            return data.np;
	          }
	        },
	        _name: {
	          value: data.nm
	        },
	        propertyGroup: {
	          value: _propertyGroup
	        }
	      });
	      groupInterface.enabled = data.en !== 0;
	      groupInterface.active = groupInterface.enabled;
	      return groupInterface;
	    }
	
	    function createValueInterface(element, type, elem, propertyGroup) {
	      var expressionProperty = ExpressionPropertyInterface(element.p);
	
	      function interfaceFunction() {
	        if (type === 10) {
	          return elem.comp.compInterface(element.p.v);
	        }
	
	        return expressionProperty();
	      }
	
	      if (element.p.setGroupProperty) {
	        element.p.setGroupProperty(PropertyInterface('', propertyGroup));
	      }
	
	      return interfaceFunction;
	    }
	
	    return ob;
	  }();
	
	  var ShapePathInterface = function () {
	    return function pathInterfaceFactory(shape, view, propertyGroup) {
	      var prop = view.sh;
	
	      function interfaceFunction(val) {
	        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
	          return interfaceFunction.path;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        path: {
	          get: function get() {
	            if (prop.k) {
	              prop.getValue();
	            }
	
	            return prop;
	          }
	        },
	        shape: {
	          get: function get() {
	            if (prop.k) {
	              prop.getValue();
	            }
	
	            return prop;
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        ix: {
	          value: shape.ix
	        },
	        propertyIndex: {
	          value: shape.ix
	        },
	        mn: {
	          value: shape.mn
	        },
	        propertyGroup: {
	          value: propertyGroup
	        }
	      });
	      return interfaceFunction;
	    };
	  }();
	
	  var ShapeExpressionInterface = function () {
	    function iterateElements(shapes, view, propertyGroup) {
	      var arr = [];
	      var i;
	      var len = shapes ? shapes.length : 0;
	
	      for (i = 0; i < len; i += 1) {
	        if (shapes[i].ty === 'gr') {
	          arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'fl') {
	          arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'st') {
	          arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'tm') {
	          arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'tr') {// arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
	        } else if (shapes[i].ty === 'el') {
	          arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'sr') {
	          arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'sh') {
	          arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rc') {
	          arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rd') {
	          arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'rp') {
	          arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else if (shapes[i].ty === 'gf') {
	          arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
	        } else {
	          arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
	        }
	      }
	
	      return arr;
	    }
	
	    function contentsInterfaceFactory(shape, view, propertyGroup) {
	      var interfaces;
	
	      var interfaceFunction = function _interfaceFunction(value) {
	        var i = 0;
	        var len = interfaces.length;
	
	        while (i < len) {
	          if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
	            return interfaces[i];
	          }
	
	          i += 1;
	        }
	
	        if (typeof value === 'number') {
	          return interfaces[value - 1];
	        }
	
	        return null;
	      };
	
	      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	      interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	      interfaceFunction.numProperties = interfaces.length;
	      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
	      interfaceFunction.transform = transformInterface;
	      interfaceFunction.propertyIndex = shape.cix;
	      interfaceFunction._name = shape.nm;
	      return interfaceFunction;
	    }
	
	    function groupInterfaceFactory(shape, view, propertyGroup) {
	      var interfaceFunction = function _interfaceFunction(value) {
	        switch (value) {
	          case 'ADBE Vectors Group':
	          case 'Contents':
	          case 2:
	            return interfaceFunction.content;
	          // Not necessary for now. Keeping them here in case a new case appears
	          // case 'ADBE Vector Transform Group':
	          // case 3:
	
	          default:
	            return interfaceFunction.transform;
	        }
	      };
	
	      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	      var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
	      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
	      interfaceFunction.content = content;
	      interfaceFunction.transform = transformInterface;
	      Object.defineProperty(interfaceFunction, '_name', {
	        get: function get() {
	          return shape.nm;
	        }
	      }); // interfaceFunction.content = interfaceFunction;
	
	      interfaceFunction.numProperties = shape.np;
	      interfaceFunction.propertyIndex = shape.ix;
	      interfaceFunction.nm = shape.nm;
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function fillInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === 'Color' || val === 'color') {
	          return interfaceFunction.color;
	        }
	
	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }
	
	        return null;
	      }
	
	      Object.defineProperties(interfaceFunction, {
	        color: {
	          get: ExpressionPropertyInterface(view.c)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
	      return interfaceFunction;
	    }
	
	    function gradientFillInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === 'Start Point' || val === 'start point') {
	          return interfaceFunction.startPoint;
	        }
	
	        if (val === 'End Point' || val === 'end point') {
	          return interfaceFunction.endPoint;
	        }
	
	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }
	
	        return null;
	      }
	
	      Object.defineProperties(interfaceFunction, {
	        startPoint: {
	          get: ExpressionPropertyInterface(view.s)
	        },
	        endPoint: {
	          get: ExpressionPropertyInterface(view.e)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        type: {
	          get: function get() {
	            return 'a';
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
	      view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
	      return interfaceFunction;
	    }
	
	    function defaultInterfaceFactory() {
	      function interfaceFunction() {
	        return null;
	      }
	
	      return interfaceFunction;
	    }
	
	    function strokeInterfaceFactory(shape, view, propertyGroup) {
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
	
	      function addPropertyToDashOb(i) {
	        Object.defineProperty(dashOb, shape.d[i].nm, {
	          get: ExpressionPropertyInterface(view.d.dataProps[i].p)
	        });
	      }
	
	      var i;
	      var len = shape.d ? shape.d.length : 0;
	      var dashOb = {};
	
	      for (i = 0; i < len; i += 1) {
	        addPropertyToDashOb(i);
	        view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	      }
	
	      function interfaceFunction(val) {
	        if (val === 'Color' || val === 'color') {
	          return interfaceFunction.color;
	        }
	
	        if (val === 'Opacity' || val === 'opacity') {
	          return interfaceFunction.opacity;
	        }
	
	        if (val === 'Stroke Width' || val === 'stroke width') {
	          return interfaceFunction.strokeWidth;
	        }
	
	        return null;
	      }
	
	      Object.defineProperties(interfaceFunction, {
	        color: {
	          get: ExpressionPropertyInterface(view.c)
	        },
	        opacity: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        strokeWidth: {
	          get: ExpressionPropertyInterface(view.w)
	        },
	        dash: {
	          get: function get() {
	            return dashOb;
	          }
	        },
	        _name: {
	          value: shape.nm
	        },
	        mn: {
	          value: shape.mn
	        }
	      });
	      view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
	      return interfaceFunction;
	    }
	
	    function trimInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(val) {
	        if (val === shape.e.ix || val === 'End' || val === 'end') {
	          return interfaceFunction.end;
	        }
	
	        if (val === shape.s.ix) {
	          return interfaceFunction.start;
	        }
	
	        if (val === shape.o.ix) {
	          return interfaceFunction.offset;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      interfaceFunction.propertyIndex = shape.ix;
	      view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
	      view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
	      view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
	      interfaceFunction.propertyIndex = shape.ix;
	      interfaceFunction.propertyGroup = propertyGroup;
	      Object.defineProperties(interfaceFunction, {
	        start: {
	          get: ExpressionPropertyInterface(view.s)
	        },
	        end: {
	          get: ExpressionPropertyInterface(view.e)
	        },
	        offset: {
	          get: ExpressionPropertyInterface(view.o)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function transformInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.a.ix === value || value === 'Anchor Point') {
	          return interfaceFunction.anchorPoint;
	        }
	
	        if (shape.o.ix === value || value === 'Opacity') {
	          return interfaceFunction.opacity;
	        }
	
	        if (shape.p.ix === value || value === 'Position') {
	          return interfaceFunction.position;
	        }
	
	        if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
	          return interfaceFunction.rotation;
	        }
	
	        if (shape.s.ix === value || value === 'Scale') {
	          return interfaceFunction.scale;
	        }
	
	        if (shape.sk && shape.sk.ix === value || value === 'Skew') {
	          return interfaceFunction.skew;
	        }
	
	        if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') {
	          return interfaceFunction.skewAxis;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
	      view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
	      view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
	
	      if (view.transform.mProps.sk) {
	        view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
	        view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
	      }
	
	      view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        opacity: {
	          get: ExpressionPropertyInterface(view.transform.mProps.o)
	        },
	        position: {
	          get: ExpressionPropertyInterface(view.transform.mProps.p)
	        },
	        anchorPoint: {
	          get: ExpressionPropertyInterface(view.transform.mProps.a)
	        },
	        scale: {
	          get: ExpressionPropertyInterface(view.transform.mProps.s)
	        },
	        rotation: {
	          get: ExpressionPropertyInterface(view.transform.mProps.r)
	        },
	        skew: {
	          get: ExpressionPropertyInterface(view.transform.mProps.sk)
	        },
	        skewAxis: {
	          get: ExpressionPropertyInterface(view.transform.mProps.sa)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.ty = 'tr';
	      interfaceFunction.mn = shape.mn;
	      interfaceFunction.propertyGroup = propertyGroup;
	      return interfaceFunction;
	    }
	
	    function ellipseInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }
	
	        if (shape.s.ix === value) {
	          return interfaceFunction.size;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      interfaceFunction.propertyIndex = shape.ix;
	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        size: {
	          get: ExpressionPropertyInterface(prop.s)
	        },
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function starInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }
	
	        if (shape.r.ix === value) {
	          return interfaceFunction.rotation;
	        }
	
	        if (shape.pt.ix === value) {
	          return interfaceFunction.points;
	        }
	
	        if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
	          return interfaceFunction.outerRadius;
	        }
	
	        if (shape.os.ix === value) {
	          return interfaceFunction.outerRoundness;
	        }
	
	        if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
	          return interfaceFunction.innerRadius;
	        }
	
	        if (shape.is && shape.is.ix === value) {
	          return interfaceFunction.innerRoundness;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
	      prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
	      prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
	
	      if (shape.ir) {
	        prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
	        prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
	      }
	
	      Object.defineProperties(interfaceFunction, {
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        rotation: {
	          get: ExpressionPropertyInterface(prop.r)
	        },
	        points: {
	          get: ExpressionPropertyInterface(prop.pt)
	        },
	        outerRadius: {
	          get: ExpressionPropertyInterface(prop.or)
	        },
	        outerRoundness: {
	          get: ExpressionPropertyInterface(prop.os)
	        },
	        innerRadius: {
	          get: ExpressionPropertyInterface(prop.ir)
	        },
	        innerRoundness: {
	          get: ExpressionPropertyInterface(prop.is)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function rectInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.p.ix === value) {
	          return interfaceFunction.position;
	        }
	
	        if (shape.r.ix === value) {
	          return interfaceFunction.roundness;
	        }
	
	        if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
	          return interfaceFunction.size;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
	      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
	      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        position: {
	          get: ExpressionPropertyInterface(prop.p)
	        },
	        roundness: {
	          get: ExpressionPropertyInterface(prop.r)
	        },
	        size: {
	          get: ExpressionPropertyInterface(prop.s)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function roundedInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.r.ix === value || value === 'Round Corners 1') {
	          return interfaceFunction.radius;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var prop = view;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        radius: {
	          get: ExpressionPropertyInterface(prop.rd)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    function repeaterInterfaceFactory(shape, view, propertyGroup) {
	      function interfaceFunction(value) {
	        if (shape.c.ix === value || value === 'Copies') {
	          return interfaceFunction.copies;
	        }
	
	        if (shape.o.ix === value || value === 'Offset') {
	          return interfaceFunction.offset;
	        }
	
	        return null;
	      }
	
	      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
	
	      var prop = view;
	      interfaceFunction.propertyIndex = shape.ix;
	      prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
	      prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
	      Object.defineProperties(interfaceFunction, {
	        copies: {
	          get: ExpressionPropertyInterface(prop.c)
	        },
	        offset: {
	          get: ExpressionPropertyInterface(prop.o)
	        },
	        _name: {
	          value: shape.nm
	        }
	      });
	      interfaceFunction.mn = shape.mn;
	      return interfaceFunction;
	    }
	
	    return function (shapes, view, propertyGroup) {
	      var interfaces;
	
	      function _interfaceFunction(value) {
	        if (typeof value === 'number') {
	          value = value === undefined ? 1 : value;
	
	          if (value === 0) {
	            return propertyGroup;
	          }
	
	          return interfaces[value - 1];
	        }
	
	        var i = 0;
	        var len = interfaces.length;
	
	        while (i < len) {
	          if (interfaces[i]._name === value) {
	            return interfaces[i];
	          }
	
	          i += 1;
	        }
	
	        return null;
	      }
	
	      function parentGroupWrapper() {
	        return propertyGroup;
	      }
	
	      _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
	      interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
	      _interfaceFunction.numProperties = interfaces.length;
	      _interfaceFunction._name = 'Contents';
	      return _interfaceFunction;
	    };
	  }();
	
	  var TextExpressionInterface = function () {
	    return function (elem) {
	      var _sourceText;
	
	      function _thisLayerFunction(name) {
	        switch (name) {
	          case 'ADBE Text Document':
	            return _thisLayerFunction.sourceText;
	
	          default:
	            return null;
	        }
	      }
	
	      Object.defineProperty(_thisLayerFunction, 'sourceText', {
	        get: function get() {
	          elem.textProperty.getValue();
	          var stringValue = elem.textProperty.currentData.t;
	
	          if (!_sourceText || stringValue !== _sourceText.value) {
	            _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
	            // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
	
	            _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
	
	            Object.defineProperty(_sourceText, 'style', {
	              get: function get() {
	                return {
	                  fillColor: elem.textProperty.currentData.fc
	                };
	              }
	            });
	          }
	
	          return _sourceText;
	        }
	      });
	      return _thisLayerFunction;
	    };
	  }();
	
	  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	  var FootageInterface = function () {
	    var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
	      var currentPropertyName = '';
	      var currentProperty = elem.getFootageData();
	
	      function init() {
	        currentPropertyName = '';
	        currentProperty = elem.getFootageData();
	        return searchProperty;
	      }
	
	      function searchProperty(value) {
	        if (currentProperty[value]) {
	          currentPropertyName = value;
	          currentProperty = currentProperty[value];
	
	          if (_typeof(currentProperty) === 'object') {
	            return searchProperty;
	          }
	
	          return currentProperty;
	        }
	
	        var propertyNameIndex = value.indexOf(currentPropertyName);
	
	        if (propertyNameIndex !== -1) {
	          var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
	          currentProperty = currentProperty[index];
	
	          if (_typeof(currentProperty) === 'object') {
	            return searchProperty;
	          }
	
	          return currentProperty;
	        }
	
	        return '';
	      }
	
	      return init;
	    };
	
	    var dataInterfaceFactory = function dataInterfaceFactory(elem) {
	      function interfaceFunction(value) {
	        if (value === 'Outline') {
	          return interfaceFunction.outlineInterface();
	        }
	
	        return null;
	      }
	
	      interfaceFunction._name = 'Outline';
	      interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
	      return interfaceFunction;
	    };
	
	    return function (elem) {
	      function _interfaceFunction(value) {
	        if (value === 'Data') {
	          return _interfaceFunction.dataInterface;
	        }
	
	        return null;
	      }
	
	      _interfaceFunction._name = 'Data';
	      _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
	      return _interfaceFunction;
	    };
	  }();
	
	  var interfaces = {
	    layer: LayerExpressionInterface,
	    effects: EffectsExpressionInterface,
	    comp: CompExpressionInterface,
	    shape: ShapeExpressionInterface,
	    text: TextExpressionInterface,
	    footage: FootageInterface
	  };
	
	  function getInterface(type) {
	    return interfaces[type] || null;
	  }
	
	  var expressionHelpers = function () {
	    function searchExpressions(elem, data, prop) {
	      if (data.x) {
	        prop.k = true;
	        prop.x = true;
	        prop.initiateExpression = ExpressionManager.initiateExpression;
	        prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
	      }
	    }
	
	    function getValueAtTime(frameNum) {
	      frameNum *= this.elem.globalData.frameRate;
	      frameNum -= this.offsetTime;
	
	      if (frameNum !== this._cachingAtTime.lastFrame) {
	        this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
	        this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
	        this._cachingAtTime.lastFrame = frameNum;
	      }
	
	      return this._cachingAtTime.value;
	    }
	
	    function getSpeedAtTime(frameNum) {
	      var delta = -0.01;
	      var v1 = this.getValueAtTime(frameNum);
	      var v2 = this.getValueAtTime(frameNum + delta);
	      var speed = 0;
	
	      if (v1.length) {
	        var i;
	
	        for (i = 0; i < v1.length; i += 1) {
	          speed += Math.pow(v2[i] - v1[i], 2);
	        }
	
	        speed = Math.sqrt(speed) * 100;
	      } else {
	        speed = 0;
	      }
	
	      return speed;
	    }
	
	    function getVelocityAtTime(frameNum) {
	      if (this.vel !== undefined) {
	        return this.vel;
	      }
	
	      var delta = -0.001; // frameNum += this.elem.data.st;
	
	      var v1 = this.getValueAtTime(frameNum);
	      var v2 = this.getValueAtTime(frameNum + delta);
	      var velocity;
	
	      if (v1.length) {
	        velocity = createTypedArray('float32', v1.length);
	        var i;
	
	        for (i = 0; i < v1.length; i += 1) {
	          // removing frameRate
	          // if needed, don't add it here
	          // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	          velocity[i] = (v2[i] - v1[i]) / delta;
	        }
	      } else {
	        velocity = (v2 - v1) / delta;
	      }
	
	      return velocity;
	    }
	
	    function getStaticValueAtTime() {
	      return this.pv;
	    }
	
	    function setGroupProperty(propertyGroup) {
	      this.propertyGroup = propertyGroup;
	    }
	
	    return {
	      searchExpressions: searchExpressions,
	      getSpeedAtTime: getSpeedAtTime,
	      getVelocityAtTime: getVelocityAtTime,
	      getValueAtTime: getValueAtTime,
	      getStaticValueAtTime: getStaticValueAtTime,
	      setGroupProperty: setGroupProperty
	    };
	  }();
	
	  function addPropertyDecorator() {
	    function loopOut(type, duration, durationFlag) {
	      if (!this.k || !this.keyframes) {
	        return this.pv;
	      }
	
	      type = type ? type.toLowerCase() : '';
	      var currentFrame = this.comp.renderedFrame;
	      var keyframes = this.keyframes;
	      var lastKeyFrame = keyframes[keyframes.length - 1].t;
	
	      if (currentFrame <= lastKeyFrame) {
	        return this.pv;
	      }
	
	      var cycleDuration;
	      var firstKeyFrame;
	
	      if (!durationFlag) {
	        if (!duration || duration > keyframes.length - 1) {
	          duration = keyframes.length - 1;
	        }
	
	        firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	        cycleDuration = lastKeyFrame - firstKeyFrame;
	      } else {
	        if (!duration) {
	          cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
	        } else {
	          cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
	        }
	
	        firstKeyFrame = lastKeyFrame - cycleDuration;
	      }
	
	      var i;
	      var len;
	      var ret;
	
	      if (type === 'pingpong') {
	        var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
	
	        if (iterations % 2 !== 0) {
	          return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	        }
	      } else if (type === 'offset') {
	        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	
	        var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
	
	        if (this.pv.length) {
	          ret = new Array(initV.length);
	          len = ret.length;
	
	          for (i = 0; i < len; i += 1) {
	            ret[i] = (endV[i] - initV[i]) * repeats + current[i];
	          }
	
	          return ret;
	        }
	
	        return (endV - initV) * repeats + current;
	      } else if (type === 'continue') {
	        var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
	
	        if (this.pv.length) {
	          ret = new Array(lastValue.length);
	          len = ret.length;
	
	          for (i = 0; i < len; i += 1) {
	            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
	          }
	
	          return ret;
	        }
	
	        return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
	      }
	
	      return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	    }
	
	    function loopIn(type, duration, durationFlag) {
	      if (!this.k) {
	        return this.pv;
	      }
	
	      type = type ? type.toLowerCase() : '';
	      var currentFrame = this.comp.renderedFrame;
	      var keyframes = this.keyframes;
	      var firstKeyFrame = keyframes[0].t;
	
	      if (currentFrame >= firstKeyFrame) {
	        return this.pv;
	      }
	
	      var cycleDuration;
	      var lastKeyFrame;
	
	      if (!durationFlag) {
	        if (!duration || duration > keyframes.length - 1) {
	          duration = keyframes.length - 1;
	        }
	
	        lastKeyFrame = keyframes[duration].t;
	        cycleDuration = lastKeyFrame - firstKeyFrame;
	      } else {
	        if (!duration) {
	          cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
	        } else {
	          cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
	        }
	
	        lastKeyFrame = firstKeyFrame + cycleDuration;
	      }
	
	      var i;
	      var len;
	      var ret;
	
	      if (type === 'pingpong') {
	        var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
	
	        if (iterations % 2 === 0) {
	          return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	        }
	      } else if (type === 'offset') {
	        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	        var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
	        var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
	
	        if (this.pv.length) {
	          ret = new Array(initV.length);
	          len = ret.length;
	
	          for (i = 0; i < len; i += 1) {
	            ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
	          }
	
	          return ret;
	        }
	
	        return current - (endV - initV) * repeats;
	      } else if (type === 'continue') {
	        var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	        var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
	
	        if (this.pv.length) {
	          ret = new Array(firstValue.length);
	          len = ret.length;
	
	          for (i = 0; i < len; i += 1) {
	            ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
	          }
	
	          return ret;
	        }
	
	        return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
	      }
	
	      return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
	    }
	
	    function smooth(width, samples) {
	      if (!this.k) {
	        return this.pv;
	      }
	
	      width = (width || 0.4) * 0.5;
	      samples = Math.floor(samples || 5);
	
	      if (samples <= 1) {
	        return this.pv;
	      }
	
	      var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
	      var initFrame = currentTime - width;
	      var endFrame = currentTime + width;
	      var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
	      var i = 0;
	      var j = 0;
	      var value;
	
	      if (this.pv.length) {
	        value = createTypedArray('float32', this.pv.length);
	      } else {
	        value = 0;
	      }
	
	      var sampleValue;
	
	      while (i < samples) {
	        sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
	
	        if (this.pv.length) {
	          for (j = 0; j < this.pv.length; j += 1) {
	            value[j] += sampleValue[j];
	          }
	        } else {
	          value += sampleValue;
	        }
	
	        i += 1;
	      }
	
	      if (this.pv.length) {
	        for (j = 0; j < this.pv.length; j += 1) {
	          value[j] /= samples;
	        }
	      } else {
	        value /= samples;
	      }
	
	      return value;
	    }
	
	    function getTransformValueAtTime(time) {
	      if (!this._transformCachingAtTime) {
	        this._transformCachingAtTime = {
	          v: new Matrix()
	        };
	      } /// /
	
	
	      var matrix = this._transformCachingAtTime.v;
	      matrix.cloneFromProps(this.pre.props);
	
	      if (this.appliedTransformations < 1) {
	        var anchor = this.a.getValueAtTime(time);
	        matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
	      }
	
	      if (this.appliedTransformations < 2) {
	        var scale = this.s.getValueAtTime(time);
	        matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
	      }
	
	      if (this.sk && this.appliedTransformations < 3) {
	        var skew = this.sk.getValueAtTime(time);
	        var skewAxis = this.sa.getValueAtTime(time);
	        matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
	      }
	
	      if (this.r && this.appliedTransformations < 4) {
	        var rotation = this.r.getValueAtTime(time);
	        matrix.rotate(-rotation * this.r.mult);
	      } else if (!this.r && this.appliedTransformations < 4) {
	        var rotationZ = this.rz.getValueAtTime(time);
	        var rotationY = this.ry.getValueAtTime(time);
	        var rotationX = this.rx.getValueAtTime(time);
	        var orientation = this.or.getValueAtTime(time);
	        matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
	      }
	
	      if (this.data.p && this.data.p.s) {
	        var positionX = this.px.getValueAtTime(time);
	        var positionY = this.py.getValueAtTime(time);
	
	        if (this.data.p.z) {
	          var positionZ = this.pz.getValueAtTime(time);
	          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
	        } else {
	          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
	        }
	      } else {
	        var position = this.p.getValueAtTime(time);
	        matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
	      }
	
	      return matrix; /// /
	    }
	
	    function getTransformStaticValueAtTime() {
	      return this.v.clone(new Matrix());
	    }
	
	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;
	
	    TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
	      var prop = getTransformProperty(elem, data, container);
	
	      if (prop.dynamicProperties.length) {
	        prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	      } else {
	        prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	      }
	
	      prop.setGroupProperty = expressionHelpers.setGroupProperty;
	      return prop;
	    };
	
	    var propertyGetProp = PropertyFactory.getProp;
	
	    PropertyFactory.getProp = function (elem, data, type, mult, container) {
	      var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
	      // prop.loopOut = loopOut;
	      // prop.loopIn = loopIn;
	
	      if (prop.kf) {
	        prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
	      } else {
	        prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
	      }
	
	      prop.setGroupProperty = expressionHelpers.setGroupProperty;
	      prop.loopOut = loopOut;
	      prop.loopIn = loopIn;
	      prop.smooth = smooth;
	      prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
	      prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
	      prop.numKeys = data.a === 1 ? data.k.length : 0;
	      prop.propertyIndex = data.ix;
	      var value = 0;
	
	      if (type !== 0) {
	        value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
	      }
	
	      prop._cachingAtTime = {
	        lastFrame: initialDefaultFrame,
	        lastIndex: 0,
	        value: value
	      };
	      expressionHelpers.searchExpressions(elem, data, prop);
	
	      if (prop.k) {
	        container.addDynamicProperty(prop);
	      }
	
	      return prop;
	    };
	
	    function getShapeValueAtTime(frameNum) {
	      // For now this caching object is created only when needed instead of creating it when the shape is initialized.
	      if (!this._cachingAtTime) {
	        this._cachingAtTime = {
	          shapeValue: shapePool.clone(this.pv),
	          lastIndex: 0,
	          lastTime: initialDefaultFrame
	        };
	      }
	
	      frameNum *= this.elem.globalData.frameRate;
	      frameNum -= this.offsetTime;
	
	      if (frameNum !== this._cachingAtTime.lastTime) {
	        this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
	        this._cachingAtTime.lastTime = frameNum;
	        this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
	      }
	
	      return this._cachingAtTime.shapeValue;
	    }
	
	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
	
	    function ShapeExpressions() {}
	
	    ShapeExpressions.prototype = {
	      vertices: function vertices(prop, time) {
	        if (this.k) {
	          this.getValue();
	        }
	
	        var shapePath = this.v;
	
	        if (time !== undefined) {
	          shapePath = this.getValueAtTime(time, 0);
	        }
	
	        var i;
	        var len = shapePath._length;
	        var vertices = shapePath[prop];
	        var points = shapePath.v;
	        var arr = createSizedArray(len);
	
	        for (i = 0; i < len; i += 1) {
	          if (prop === 'i' || prop === 'o') {
	            arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
	          } else {
	            arr[i] = [vertices[i][0], vertices[i][1]];
	          }
	        }
	
	        return arr;
	      },
	      points: function points(time) {
	        return this.vertices('v', time);
	      },
	      inTangents: function inTangents(time) {
	        return this.vertices('i', time);
	      },
	      outTangents: function outTangents(time) {
	        return this.vertices('o', time);
	      },
	      isClosed: function isClosed() {
	        return this.v.c;
	      },
	      pointOnPath: function pointOnPath(perc, time) {
	        var shapePath = this.v;
	
	        if (time !== undefined) {
	          shapePath = this.getValueAtTime(time, 0);
	        }
	
	        if (!this._segmentsLength) {
	          this._segmentsLength = bez.getSegmentsLength(shapePath);
	        }
	
	        var segmentsLength = this._segmentsLength;
	        var lengths = segmentsLength.lengths;
	        var lengthPos = segmentsLength.totalLength * perc;
	        var i = 0;
	        var len = lengths.length;
	        var accumulatedLength = 0;
	        var pt;
	
	        while (i < len) {
	          if (accumulatedLength + lengths[i].addedLength > lengthPos) {
	            var initIndex = i;
	            var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
	            var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
	            pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
	            break;
	          } else {
	            accumulatedLength += lengths[i].addedLength;
	          }
	
	          i += 1;
	        }
	
	        if (!pt) {
	          pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
	        }
	
	        return pt;
	      },
	      vectorOnPath: function vectorOnPath(perc, time, vectorType) {
	        // perc doesn't use triple equality because it can be a Number object as well as a primitive.
	        if (perc == 1) {
	          // eslint-disable-line eqeqeq
	          perc = this.v.c;
	        } else if (perc == 0) {
	          // eslint-disable-line eqeqeq
	          perc = 0.999;
	        }
	
	        var pt1 = this.pointOnPath(perc, time);
	        var pt2 = this.pointOnPath(perc + 0.001, time);
	        var xLength = pt2[0] - pt1[0];
	        var yLength = pt2[1] - pt1[1];
	        var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
	
	        if (magnitude === 0) {
	          return [0, 0];
	        }
	
	        var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
	        return unitVector;
	      },
	      tangentOnPath: function tangentOnPath(perc, time) {
	        return this.vectorOnPath(perc, time, 'tangent');
	      },
	      normalOnPath: function normalOnPath(perc, time) {
	        return this.vectorOnPath(perc, time, 'normal');
	      },
	      setGroupProperty: expressionHelpers.setGroupProperty,
	      getValueAtTime: expressionHelpers.getStaticValueAtTime
	    };
	    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
	    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
	
	    ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
	      var prop = propertyGetShapeProp(elem, data, type, arr, trims);
	      prop.propertyIndex = data.ix;
	      prop.lock = false;
	
	      if (type === 3) {
	        expressionHelpers.searchExpressions(elem, data.pt, prop);
	      } else if (type === 4) {
	        expressionHelpers.searchExpressions(elem, data.ks, prop);
	      }
	
	      if (prop.k) {
	        elem.addDynamicProperty(prop);
	      }
	
	      return prop;
	    };
	  }
	
	  function initialize$1() {
	    addPropertyDecorator();
	  }
	
	  function addDecorator() {
	    function searchExpressions() {
	      if (this.data.d.x) {
	        this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
	        this.addEffect(this.getExpressionValue.bind(this));
	        return true;
	      }
	
	      return null;
	    }
	
	    TextProperty.prototype.getExpressionValue = function (currentValue, text) {
	      var newValue = this.calculateExpression(text);
	
	      if (currentValue.t !== newValue) {
	        var newData = {};
	        this.copyData(newData, currentValue);
	        newData.t = newValue.toString();
	        newData.__complete = false;
	        return newData;
	      }
	
	      return currentValue;
	    };
	
	    TextProperty.prototype.searchProperty = function () {
	      var isKeyframed = this.searchKeyframes();
	      var hasExpressions = this.searchExpressions();
	      this.kf = isKeyframed || hasExpressions;
	      return this.kf;
	    };
	
	    TextProperty.prototype.searchExpressions = searchExpressions;
	  }
	
	  function initialize() {
	    addDecorator();
	  }
	
	  function SVGComposableEffect() {}
	
	  SVGComposableEffect.prototype = {
	    createMergeNode: function createMergeNode(resultId, ins) {
	      var feMerge = createNS('feMerge');
	      feMerge.setAttribute('result', resultId);
	      var feMergeNode;
	      var i;
	
	      for (i = 0; i < ins.length; i += 1) {
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in', ins[i]);
	        feMerge.appendChild(feMergeNode);
	        feMerge.appendChild(feMergeNode);
	      }
	
	      return feMerge;
	    }
	  };
	
	  var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
	
	  function SVGTintFilter(filter, filterManager, elem, id, source) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
	    feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
	    this.linearFilter = feColorMatrix;
	    feColorMatrix.setAttribute('result', id + '_tint_1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result', id + '_tint_2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    var feMerge = this.createMergeNode(id, [source, id + '_tint_1', id + '_tint_2']);
	    filter.appendChild(feMerge);
	  }
	
	  extendPrototype([SVGComposableEffect], SVGTintFilter);
	
	  SVGTintFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var colorBlack = this.filterManager.effectElements[0].p.v;
	      var colorWhite = this.filterManager.effectElements[1].p.v;
	      var opacity = this.filterManager.effectElements[2].p.v / 100;
	      this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
	      this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
	    }
	  };
	
	  function SVGFillFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
	    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result', id);
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	  }
	
	  SVGFillFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var color = this.filterManager.effectElements[2].p.v;
	      var opacity = this.filterManager.effectElements[6].p.v;
	      this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
	    }
	  };
	
	  function SVGStrokeEffect(fil, filterManager, elem) {
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	  }
	
	  SVGStrokeEffect.prototype.initialize = function () {
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path;
	    var groupPath;
	    var i;
	    var len;
	
	    if (this.filterManager.effectElements[1].p.v === 1) {
	      len = this.elem.maskManager.masksProperties.length;
	      i = 0;
	    } else {
	      i = this.filterManager.effectElements[0].p.v - 1;
	      len = i + 1;
	    }
	
	    groupPath = createNS('g');
	    groupPath.setAttribute('fill', 'none');
	    groupPath.setAttribute('stroke-linecap', 'round');
	    groupPath.setAttribute('stroke-dashoffset', 1);
	
	    for (i; i < len; i += 1) {
	      path = createNS('path');
	      groupPath.appendChild(path);
	      this.paths.push({
	        p: path,
	        m: i
	      });
	    }
	
	    if (this.filterManager.effectElements[10].p.v === 3) {
	      var mask = createNS('mask');
	      var id = createElementID();
	      mask.setAttribute('id', id);
	      mask.setAttribute('mask-type', 'alpha');
	      mask.appendChild(groupPath);
	      this.elem.globalData.defs.appendChild(mask);
	      var g = createNS('g');
	      g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
	
	      while (elemChildren[0]) {
	        g.appendChild(elemChildren[0]);
	      }
	
	      this.elem.layerElement.appendChild(g);
	      this.masker = mask;
	      groupPath.setAttribute('stroke', '#fff');
	    } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
	      if (this.filterManager.effectElements[10].p.v === 2) {
	        elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	
	        while (elemChildren.length) {
	          this.elem.layerElement.removeChild(elemChildren[0]);
	        }
	      }
	
	      this.elem.layerElement.appendChild(groupPath);
	      this.elem.layerElement.removeAttribute('mask');
	      groupPath.setAttribute('stroke', '#fff');
	    }
	
	    this.initialized = true;
	    this.pathMasker = groupPath;
	  };
	
	  SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
	    if (!this.initialized) {
	      this.initialize();
	    }
	
	    var i;
	    var len = this.paths.length;
	    var mask;
	    var path;
	
	    for (i = 0; i < len; i += 1) {
	      if (this.paths[i].m !== -1) {
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;
	
	        if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
	          path.setAttribute('d', mask.lastPath);
	        }
	
	        if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
	          var dasharrayValue;
	
	          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
	            var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
	            var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
	            var l = path.getTotalLength();
	            dasharrayValue = '0 0 0 ' + l * s + ' ';
	            var lineLength = l * (e - s);
	            var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
	            var units = Math.floor(lineLength / segment);
	            var j;
	
	            for (j = 0; j < units; j += 1) {
	              dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
	            }
	
	            dasharrayValue += '0 ' + l * 10 + ' 0 0';
	          } else {
	            dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
	          }
	
	          path.setAttribute('stroke-dasharray', dasharrayValue);
	        }
	      }
	    }
	
	    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
	      this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
	    }
	
	    if (forceRender || this.filterManager.effectElements[6].p._mdf) {
	      this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
	    }
	
	    if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
	      if (forceRender || this.filterManager.effectElements[3].p._mdf) {
	        var color = this.filterManager.effectElements[3].p.v;
	        this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
	      }
	    }
	  };
	
	  function SVGTritoneFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type', 'matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
	    feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	    feComponentTransfer.setAttribute('result', id);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	    filter.appendChild(feComponentTransfer);
	  }
	
	  SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var color1 = this.filterManager.effectElements[0].p.v;
	      var color2 = this.filterManager.effectElements[1].p.v;
	      var color3 = this.filterManager.effectElements[2].p.v;
	      var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
	      var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
	      var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
	      this.feFuncR.setAttribute('tableValues', tableR);
	      this.feFuncG.setAttribute('tableValues', tableG);
	      this.feFuncB.setAttribute('tableValues', tableB);
	    }
	  };
	
	  function SVGProLevelsFilter(filter, filterManager, elem, id) {
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer'); // Red
	
	    if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
	      this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    } // Green
	
	
	    if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
	      this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    } // Blue
	
	
	    if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
	      this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    } // Alpha
	
	
	    if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
	      this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    } // RGB
	
	
	    if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
	      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	      filter.appendChild(feComponentTransfer);
	    }
	
	    if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
	      feComponentTransfer = createNS('feComponentTransfer');
	      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
	      feComponentTransfer.setAttribute('result', id);
	      filter.appendChild(feComponentTransfer);
	      this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	      this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	      this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	  }
	
	  SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type', 'table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	  };
	
	  SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null, {
	      length: segments
	    });
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack;
	    var inputDelta = inputWhite - inputBlack;
	
	    while (cnt <= 256) {
	      perc = cnt / 256;
	
	      if (perc <= min) {
	        colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	      } else if (perc >= max) {
	        colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	      } else {
	        colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
	      }
	
	      table[pos] = colorValue;
	      pos += 1;
	      cnt += 256 / (segments - 1);
	    }
	
	    return table.join(' ');
	  };
	
	  SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      var val;
	      var effectElements = this.filterManager.effectElements;
	
	      if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
	        val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
	        this.feFuncRComposed.setAttribute('tableValues', val);
	        this.feFuncGComposed.setAttribute('tableValues', val);
	        this.feFuncBComposed.setAttribute('tableValues', val);
	      }
	
	      if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
	        val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
	        this.feFuncR.setAttribute('tableValues', val);
	      }
	
	      if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
	        val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
	        this.feFuncG.setAttribute('tableValues', val);
	      }
	
	      if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
	        val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
	        this.feFuncB.setAttribute('tableValues', val);
	      }
	
	      if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
	        val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
	        this.feFuncA.setAttribute('tableValues', val);
	      }
	    }
	  };
	
	  function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
	    var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
	    var filterSize = filterManager.data.fs || globalFilterSize;
	    filter.setAttribute('x', filterSize.x || globalFilterSize.x);
	    filter.setAttribute('y', filterSize.y || globalFilterSize.y);
	    filter.setAttribute('width', filterSize.width || globalFilterSize.width);
	    filter.setAttribute('height', filterSize.height || globalFilterSize.height);
	    this.filterManager = filterManager;
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in', 'SourceAlpha');
	    feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation', '0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx', '25');
	    feOffset.setAttribute('dy', '0');
	    feOffset.setAttribute('in', id + '_drop_shadow_1');
	    feOffset.setAttribute('result', id + '_drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color', '#00ff00');
	    feFlood.setAttribute('flood-opacity', '1');
	    feFlood.setAttribute('result', id + '_drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in', id + '_drop_shadow_3');
	    feComposite.setAttribute('in2', id + '_drop_shadow_2');
	    feComposite.setAttribute('operator', 'in');
	    feComposite.setAttribute('result', id + '_drop_shadow_4');
	    filter.appendChild(feComposite);
	    var feMerge = this.createMergeNode(id, [id + '_drop_shadow_4', source]);
	    filter.appendChild(feMerge); //
	  }
	
	  extendPrototype([SVGComposableEffect], SVGDropShadowEffect);
	
	  SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      if (forceRender || this.filterManager.effectElements[4].p._mdf) {
	        this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	      }
	
	      if (forceRender || this.filterManager.effectElements[0].p._mdf) {
	        var col = this.filterManager.effectElements[0].p.v;
	        this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
	      }
	
	      if (forceRender || this.filterManager.effectElements[1].p._mdf) {
	        this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
	      }
	
	      if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
	        var distance = this.filterManager.effectElements[3].p.v;
	        var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
	        var x = distance * Math.cos(angle);
	        var y = distance * Math.sin(angle);
	        this.feOffset.setAttribute('dx', x);
	        this.feOffset.setAttribute('dy', y);
	      }
	    }
	  };
	
	  var _svgMatteSymbols = [];
	
	  function SVGMatte3Effect(filterElem, filterManager, elem) {
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	  }
	
	  SVGMatte3Effect.prototype.findSymbol = function (mask) {
	    var i = 0;
	    var len = _svgMatteSymbols.length;
	
	    while (i < len) {
	      if (_svgMatteSymbols[i] === mask) {
	        return _svgMatteSymbols[i];
	      }
	
	      i += 1;
	    }
	
	    return null;
	  };
	
	  SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
	    var parentNode = mask.layerElement.parentNode;
	
	    if (!parentNode) {
	      return;
	    }
	
	    var children = parentNode.children;
	    var i = 0;
	    var len = children.length;
	
	    while (i < len) {
	      if (children[i] === mask.layerElement) {
	        break;
	      }
	
	      i += 1;
	    }
	
	    var nextChild;
	
	    if (i <= len - 2) {
	      nextChild = children[i + 1];
	    }
	
	    var useElem = createNS('use');
	    useElem.setAttribute('href', '#' + symbolId);
	
	    if (nextChild) {
	      parentNode.insertBefore(useElem, nextChild);
	    } else {
	      parentNode.appendChild(useElem);
	    }
	  };
	
	  SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
	    if (!this.findSymbol(mask)) {
	      var symbolId = createElementID();
	      var masker = createNS('mask');
	      masker.setAttribute('id', mask.layerId);
	      masker.setAttribute('mask-type', 'alpha');
	
	      _svgMatteSymbols.push(mask);
	
	      var defs = elem.globalData.defs;
	      defs.appendChild(masker);
	      var symbol = createNS('symbol');
	      symbol.setAttribute('id', symbolId);
	      this.replaceInParent(mask, symbolId);
	      symbol.appendChild(mask.layerElement);
	      defs.appendChild(symbol);
	      var useElem = createNS('use');
	      useElem.setAttribute('href', '#' + symbolId);
	      masker.appendChild(useElem);
	      mask.data.hd = false;
	      mask.show();
	    }
	
	    elem.setMatte(mask.layerId);
	  };
	
	  SVGMatte3Effect.prototype.initialize = function () {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var elements = this.elem.comp.elements;
	    var i = 0;
	    var len = elements.length;
	
	    while (i < len) {
	      if (elements[i] && elements[i].data.ind === ind) {
	        this.setElementAsMask(this.elem, elements[i]);
	      }
	
	      i += 1;
	    }
	
	    this.initialized = true;
	  };
	
	  SVGMatte3Effect.prototype.renderFrame = function () {
	    if (!this.initialized) {
	      this.initialize();
	    }
	  };
	
	  function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
	    // Outset the filter region by 100% on all sides to accommodate blur expansion.
	    filter.setAttribute('x', '-100%');
	    filter.setAttribute('y', '-100%');
	    filter.setAttribute('width', '300%');
	    filter.setAttribute('height', '300%');
	    this.filterManager = filterManager;
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('result', id);
	    filter.appendChild(feGaussianBlur);
	    this.feGaussianBlur = feGaussianBlur;
	  }
	
	  SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
	    if (forceRender || this.filterManager._mdf) {
	      // Empirical value, matching AE's blur appearance.
	      var kBlurrinessToSigma = 0.3;
	      var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
	      //
	      //   1 -> horizontal & vertical
	      //   2 -> horizontal only
	      //   3 -> vertical only
	      //
	
	      var dimensions = this.filterManager.effectElements[1].p.v;
	      var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
	
	      var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
	
	      this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
	      //
	      //   0 -> off -> duplicate
	      //   1 -> on  -> wrap
	
	      var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
	
	      this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
	    }
	  };
	
	  function TransformEffect() {}
	
	  TransformEffect.prototype.init = function (effectsManager) {
	    this.effectsManager = effectsManager;
	    this.type = effectTypes.TRANSFORM_EFFECT;
	    this.matrix = new Matrix();
	    this.opacity = -1;
	    this._mdf = false;
	    this._opMdf = false;
	  };
	
	  TransformEffect.prototype.renderFrame = function (forceFrame) {
	    this._opMdf = false;
	    this._mdf = false;
	
	    if (forceFrame || this.effectsManager._mdf) {
	      var effectElements = this.effectsManager.effectElements;
	      var anchor = effectElements[0].p.v;
	      var position = effectElements[1].p.v;
	      var isUniformScale = effectElements[2].p.v === 1;
	      var scaleHeight = effectElements[3].p.v;
	      var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
	      var skew = effectElements[5].p.v;
	      var skewAxis = effectElements[6].p.v;
	      var rotation = effectElements[7].p.v;
	      this.matrix.reset();
	      this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
	      this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
	      this.matrix.rotate(-rotation * degToRads);
	      this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
	      this.matrix.translate(position[0], position[1], 0);
	      this._mdf = true;
	
	      if (this.opacity !== effectElements[8].p.v) {
	        this.opacity = effectElements[8].p.v;
	        this._opMdf = true;
	      }
	    }
	  };
	
	  function SVGTransformEffect(_, filterManager) {
	    this.init(filterManager);
	  }
	
	  extendPrototype([TransformEffect], SVGTransformEffect);
	
	  function CVTransformEffect(effectsManager) {
	    this.init(effectsManager);
	  }
	
	  extendPrototype([TransformEffect], CVTransformEffect);
	
	  registerRenderer('canvas', CanvasRenderer);
	  registerRenderer('html', HybridRenderer);
	  registerRenderer('svg', SVGRenderer); // Registering shape modifiers
	
	  ShapeModifiers.registerModifier('tm', TrimModifier);
	  ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
	  ShapeModifiers.registerModifier('rp', RepeaterModifier);
	  ShapeModifiers.registerModifier('rd', RoundCornersModifier);
	  ShapeModifiers.registerModifier('zz', ZigZagModifier);
	  ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin
	
	  setExpressionsPlugin(Expressions);
	  setExpressionInterfaces(getInterface);
	  initialize$1();
	  initialize(); // Registering svg effects
	
	  registerEffect$1(20, SVGTintFilter, true);
	  registerEffect$1(21, SVGFillFilter, true);
	  registerEffect$1(22, SVGStrokeEffect, false);
	  registerEffect$1(23, SVGTritoneFilter, true);
	  registerEffect$1(24, SVGProLevelsFilter, true);
	  registerEffect$1(25, SVGDropShadowEffect, true);
	  registerEffect$1(28, SVGMatte3Effect, false);
	  registerEffect$1(29, SVGGaussianBlurEffect, true);
	  registerEffect$1(35, SVGTransformEffect, false);
	  registerEffect(35, CVTransformEffect);
	
	  return lottie;
	
	}));


/***/ }),
/* 5527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Avatar = __webpack_require__(2361);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Avatar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RADIUS = 12;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-flex',
	      // For correct alignment with the text.
	      verticalAlign: 'middle'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: -RADIUS,
	      right: -RADIUS,
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeight,
	      fontSize: theme.typography.pxToRem(RADIUS),
	      width: RADIUS * 2,
	      height: RADIUS * 2,
	      borderRadius: '50%',
	      backgroundColor: theme.palette.color,
	      color: theme.palette.textColor,
	      zIndex: 1 // Render the badge on top of potential ripples.
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	    colorError: {
	      backgroundColor: theme.palette.error.main,
	      color: theme.palette.error.contrastText
	    }
	  };
	};
	
	function Badge(props) {
	  var badgeContent = props.badgeContent,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      ComponentProp = props.component,
	      other = (0, _objectWithoutProperties3.default)(props, ['badgeContent', 'children', 'classes', 'className', 'color', 'component']);
	
	
	  var badgeClassName = (0, _classnames2.default)(classes.badge, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'));
	
	  return _react2.default.createElement(
	    ComponentProp,
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other),
	    children,
	    _react2.default.createElement(
	      'span',
	      { className: badgeClassName },
	      badgeContent
	    )
	  );
	}
	
	Badge.propTypes =  false ? {
	  /**
	   * The content rendered within the badge.
	   */
	  badgeContent: _propTypes2.default.node.isRequired,
	  /**
	   * The badge will be added relative to this node.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes2.default.oneOf(['default', 'primary', 'secondary', 'error']),
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	} : {};
	
	Badge.defaultProps = {
	  color: 'default',
	  component: 'span'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBadge' })(Badge);

/***/ }),
/* 5529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Badge = __webpack_require__(5528);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Badge).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'center',
	      height: 56,
	      backgroundColor: theme.palette.background.paper
	    }
	  };
	};
	
	function BottomNavigation(props) {
	  var childrenProp = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      onChange = props.onChange,
	      showLabels = props.showLabels,
	      value = props.value,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'onChange', 'showLabels', 'value']);
	
	
	  var className = (0, _classnames2.default)(classes.root, classNameProp);
	
	  var children = _react2.default.Children.map(childrenProp, function (child, childIndex) {
	    if (!_react2.default.isValidElement(child)) {
	      return null;
	    }
	
	    var childValue = child.props.value || childIndex;
	    return _react2.default.cloneElement(child, {
	      selected: childValue === value,
	      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
	      value: childValue,
	      onChange: onChange
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: className }, other),
	    children
	  );
	}
	
	BottomNavigation.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {any} value We default to the index of the child
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * If `true`, all `BottomNavigationAction`s will show their labels.
	   * By default, only the selected `BottomNavigationAction` will show its label.
	   */
	  showLabels: _propTypes2.default.bool,
	  /**
	   * The value of the currently selected `BottomNavigationAction`.
	   */
	  value: _propTypes2.default.any
	} : {};
	
	BottomNavigation.defaultProps = {
	  showLabels: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBottomNavigation' })(BottomNavigation);

/***/ }),
/* 5531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ButtonBase = __webpack_require__(278);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      transition: theme.transitions.create(['color', 'padding-top'], {
	        duration: theme.transitions.duration.short
	      }),
	      paddingTop: theme.spacing.unit,
	      paddingBottom: 10,
	      paddingLeft: 12,
	      paddingRight: 12,
	      minWidth: 80,
	      maxWidth: 168,
	      color: theme.palette.text.secondary,
	      flex: '1'
	    },
	    selected: {
	      paddingTop: 6,
	      color: theme.palette.primary.main
	    },
	    selectedIconOnly: {
	      paddingTop: theme.spacing.unit * 2
	    },
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    },
	    label: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 2),
	      opacity: 1,
	      transition: 'font-size 0.2s, opacity 0.2s',
	      transitionDelay: '0.1s'
	    },
	    selectedLabel: {
	      fontSize: theme.typography.pxToRem(theme.typography.fontSize)
	    },
	    hiddenLabel: {
	      opacity: 0,
	      transitionDelay: '0s'
	    }
	  };
	}; // @inheritedComponent ButtonBase
	
	var BottomNavigationAction = function (_React$Component) {
	  (0, _inherits3.default)(BottomNavigationAction, _React$Component);
	
	  function BottomNavigationAction() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, BottomNavigationAction);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BottomNavigationAction.__proto__ || (0, _getPrototypeOf2.default)(BottomNavigationAction)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          value = _this$props.value,
	          onClick = _this$props.onClick;
	
	
	      if (onChange) {
	        onChange(event, value);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(BottomNavigationAction, [{
	    key: 'render',
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _props = this.props,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          icon = _props.icon,
	          label = _props.label,
	          onChange = _props.onChange,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          showLabelProp = _props.showLabel,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'icon', 'label', 'onChange', 'onClick', 'selected', 'showLabel', 'value']);
	
	
	      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.selected, selected), (0, _defineProperty3.default)(_classNames, classes.selectedIconOnly, !showLabelProp && !selected), _classNames), classNameProp);
	
	      var labelClassName = (0, _classnames2.default)(classes.label, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.selectedLabel, selected), (0, _defineProperty3.default)(_classNames2, classes.hiddenLabel, !showLabelProp && !selected), _classNames2));
	
	      return _react2.default.createElement(
	        _ButtonBase2.default,
	        (0, _extends3.default)({ className: className, focusRipple: true, onClick: this.handleChange }, other),
	        _react2.default.createElement(
	          'span',
	          { className: classes.wrapper },
	          icon,
	          _react2.default.createElement(
	            'span',
	            { className: labelClassName },
	            label
	          )
	        )
	      );
	    }
	  }]);
	  return BottomNavigationAction;
	}(_react2.default.Component);
	
	BottomNavigationAction.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The icon element.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * The label element.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * If `true`, the BottomNavigationAction will show its label.
	   */
	  showLabel: _propTypes2.default.bool,
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes2.default.any
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBottomNavigationAction' })(BottomNavigationAction);

/***/ }),
/* 5532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BottomNavigation = __webpack_require__(5530);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BottomNavigation).default;
	  }
	});
	
	var _BottomNavigationAction = __webpack_require__(5531);
	
	Object.defineProperty(exports, 'BottomNavigationAction', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BottomNavigationAction).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _colorManipulator = __webpack_require__(470);
	
	var _ButtonBase = __webpack_require__(278);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	var _helpers = __webpack_require__(127);
	
	var _reactHelpers = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent ButtonBase
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: (0, _extends3.default)({}, theme.typography.button, {
	      lineHeight: '1.4em', // Improve readability for multiline button.
	      boxSizing: 'border-box',
	      minWidth: theme.spacing.unit * 11,
	      minHeight: 36,
	      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 2 + 'px',
	      borderRadius: 2,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create(['background-color', 'box-shadow'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        // Reset on mouse devices
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, 0.12),
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      }
	    }),
	    label: {
	      width: '100%',
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	    flatPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.12),
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    flatSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.12),
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    raised: {
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      boxShadow: theme.shadows[2],
	      '&$keyboardFocused': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[8]
	      },
	      '&$disabled': {
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      },
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        }
	      }
	    },
	    keyboardFocused: {},
	    raisedPrimary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	    raisedSecondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on mouse devices
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	    disabled: {
	      color: theme.palette.action.disabled
	    },
	    fab: {
	      borderRadius: '50%',
	      padding: 0,
	      minWidth: 0,
	      width: 56,
	      fontSize: 24,
	      height: 56,
	      boxShadow: theme.shadows[6],
	      '&:active': {
	        boxShadow: theme.shadows[12]
	      }
	    },
	    mini: {
	      width: 40,
	      height: 40
	    },
	    sizeSmall: {
	      padding: theme.spacing.unit - 1 + 'px ' + theme.spacing.unit + 'px',
	      minWidth: theme.spacing.unit * 8,
	      minHeight: 32,
	      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 1)
	    },
	    sizeLarge: {
	      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 3 + 'px',
	      minWidth: theme.spacing.unit * 14,
	      minHeight: 40,
	      fontSize: theme.typography.pxToRem(theme.typography.fontSize + 1)
	    },
	    fullWidth: {
	      width: '100%'
	    }
	  };
	};
	
	function Button(props) {
	  var _classNames;
	
	  var childrenProp = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      disabled = props.disabled,
	      disableFocusRipple = props.disableFocusRipple,
	      fullWidth = props.fullWidth,
	      mini = props.mini,
	      size = props.size,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'disabled', 'disableFocusRipple', 'fullWidth', 'mini', 'size', 'variant']);
	
	
	  var fab = variant === 'fab';
	  var raised = variant === 'raised';
	  var flat = !raised && !fab;
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.raised, raised || fab), (0, _defineProperty3.default)(_classNames, classes.fab, fab), (0, _defineProperty3.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty3.default)(_classNames, classes.colorInherit, color === 'inherit'), (0, _defineProperty3.default)(_classNames, classes.flatPrimary, flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.flatSecondary, flat && color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes.raisedPrimary, !flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.raisedSecondary, !flat && color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes['size' + (0, _helpers.capitalize)(size)], size !== 'medium'), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames), classNameProp);
	
	  var children = childrenProp;
	
	  if (fab) {
	    children = _react2.default.Children.map(children, function (child) {
	      if ((0, _reactHelpers.isMuiElement)(child, ['Icon', 'SvgIcon'])) {
	        return _react2.default.cloneElement(child, { fontSize: true });
	      }
	      return child;
	    });
	  }
	
	  return _react2.default.createElement(
	    _ButtonBase2.default,
	    (0, _extends3.default)({
	      className: className,
	      disabled: disabled,
	      focusRipple: !disableFocusRipple,
	      keyboardFocusedClassName: classes.keyboardFocused
	    }, other),
	    _react2.default.createElement(
	      'span',
	      { className: classes.label },
	      children
	    )
	  );
	}
	
	Button.propTypes =  false ? {
	  /**
	   * The content of the button.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes2.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * The default value is a `button`.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes2.default.bool,
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes2.default.bool,
	  /**
	   * If `true`, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * If `true`, and `fab` is `true`, will use mini floating action button styling.
	   */
	  mini: _propTypes2.default.bool,
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
	  /**
	   * @ignore
	   */
	  type: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  variant: _propTypes2.default.oneOf(['flat', 'raised', 'fab'])
	} : {};
	
	Button.defaultProps = {
	  color: 'default',
	  disabled: false,
	  disableFocusRipple: false,
	  disableRipple: false,
	  fullWidth: false,
	  mini: false,
	  size: 'medium',
	  type: 'button',
	  variant: 'flat'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButton' })(Button);

/***/ }),
/* 5534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(568);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _keyboardFocus = __webpack_require__(5682);
	
	var _TouchRipple = __webpack_require__(5536);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _createRippleHandler = __webpack_require__(5537);
	
	var _createRippleHandler2 = _interopRequireDefault(_createRippleHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent', // Reset default value
	    outline: 'none',
	    border: 0,
	    margin: 0, // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0, // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none', // Reset
	    '-webkit-appearance': 'none', // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	    }
	  },
	  disabled: {
	    pointerEvents: 'none', // Disable link interactions
	    cursor: 'default'
	  }
	};
	
	// Don't automatically add the role="button" property on these components.
	// It's invalid HTML syntax.
	var INVALID_COMPONENT_ROLE = ['a'];
	
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	var ButtonBase = function (_React$Component) {
	  (0, _inherits3.default)(ButtonBase, _React$Component);
	
	  function ButtonBase() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ButtonBase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonBase.__proto__ || (0, _getPrototypeOf2.default)(ButtonBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      keyboardFocused: false
	    }, _this.onKeyboardFocusHandler = function (event) {
	      _this.keyDown = false;
	      _this.setState({ keyboardFocused: true });
	
	      if (_this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event);
	      }
	    }, _this.onRippleRef = function (node) {
	      _this.ripple = node;
	    }, _this.ripple = null, _this.keyDown = false, _this.button = null, _this.keyboardFocusTimeout = null, _this.keyboardFocusCheckTime = 50, _this.keyboardFocusMaxCheckTimes = 5, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          component = _this$props.component,
	          focusRipple = _this$props.focusRipple,
	          onKeyDown = _this$props.onKeyDown,
	          onClick = _this$props.onClick;
	
	      var key = (0, _keycode2.default)(event);
	
	      // Check if key is already down to avoid repeats being counted as multiple activations
	      if (focusRipple && !_this.keyDown && _this.state.keyboardFocused && _this.ripple && key === 'space') {
	        _this.keyDown = true;
	        event.persist();
	        _this.ripple.stop(event, function () {
	          _this.ripple.start(event);
	        });
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      }
	
	      // Keyboard accessibility for non interactive elements
	      if (event.target === _this.button && onClick && component && component !== 'a' && component !== 'button' && (key === 'space' || key === 'enter')) {
	        event.preventDefault();
	        onClick(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.props.focusRipple && (0, _keycode2.default)(event) === 'space' && _this.ripple && _this.state.keyboardFocused) {
	        _this.keyDown = false;
	        event.persist();
	        _this.ripple.stop(event, function () {
	          return _this.ripple.pulsate(event);
	        });
	      }
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(event);
	      }
	    }, _this.handleMouseDown = (0, _createRippleHandler2.default)(_this, 'MouseDown', 'start', function () {
	      clearTimeout(_this.keyboardFocusTimeout);
	      (0, _keyboardFocus.focusKeyPressed)(false);
	      if (_this.state.keyboardFocused) {
	        _this.setState({ keyboardFocused: false });
	      }
	    }), _this.handleMouseUp = (0, _createRippleHandler2.default)(_this, 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _createRippleHandler2.default)(_this, 'MouseLeave', 'stop', function (event) {
	      if (_this.state.keyboardFocused) {
	        event.preventDefault();
	      }
	    }), _this.handleTouchStart = (0, _createRippleHandler2.default)(_this, 'TouchStart', 'start'), _this.handleTouchEnd = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleTouchMove = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleBlur = (0, _createRippleHandler2.default)(_this, 'Blur', 'stop', function () {
	      clearTimeout(_this.keyboardFocusTimeout);
	      (0, _keyboardFocus.focusKeyPressed)(false);
	      _this.setState({ keyboardFocused: false });
	    }), _this.handleFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      // Fix for https://github.com/facebook/react/issues/7769
	      if (!_this.button) {
	        _this.button = event.currentTarget;
	      }
	
	      event.persist();
	      (0, _keyboardFocus.detectKeyboardFocus)(_this, _this.button, function () {
	        _this.onKeyboardFocusHandler(event);
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ButtonBase, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.button = (0, _reactDom.findDOMNode)(this);
	      (0, _keyboardFocus.listenForFocusKeys)();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // The blur won't fire when the disabled state is set on a focused input.
	      // We need to book keep the focused state manually.
	      if (!this.props.disabled && nextProps.disabled && this.state.keyboardFocused) {
	        this.setState({
	          keyboardFocused: false
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.props.focusRipple && nextState.keyboardFocused && !this.state.keyboardFocused && !this.props.disableRipple) {
	        this.ripple.pulsate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.button = null;
	      clearTimeout(this.keyboardFocusTimeout);
	    } // Used to help track keyboard activation keyDown
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          buttonRef = _props.buttonRef,
	          centerRipple = _props.centerRipple,
	          children = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          component = _props.component,
	          disabled = _props.disabled,
	          disableRipple = _props.disableRipple,
	          focusRipple = _props.focusRipple,
	          keyboardFocusedClassName = _props.keyboardFocusedClassName,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onKeyDown = _props.onKeyDown,
	          onKeyUp = _props.onKeyUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseUp = _props.onMouseUp,
	          onTouchEnd = _props.onTouchEnd,
	          onTouchMove = _props.onTouchMove,
	          onTouchStart = _props.onTouchStart,
	          tabIndex = _props.tabIndex,
	          type = _props.type,
	          other = (0, _objectWithoutProperties3.default)(_props, ['buttonRef', 'centerRipple', 'children', 'classes', 'className', 'component', 'disabled', 'disableRipple', 'focusRipple', 'keyboardFocusedClassName', 'onBlur', 'onFocus', 'onKeyboardFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseLeave', 'onMouseUp', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'tabIndex', 'type']);
	
	
	      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, keyboardFocusedClassName || '', this.state.keyboardFocused), _classNames), classNameProp);
	
	      var buttonProps = {};
	
	      var ComponentProp = component;
	
	      if (!ComponentProp) {
	        if (other.href) {
	          ComponentProp = 'a';
	        } else {
	          ComponentProp = 'button';
	        }
	      }
	
	      if (ComponentProp === 'button') {
	        buttonProps.type = type || 'button';
	        buttonProps.disabled = disabled;
	      } else if (INVALID_COMPONENT_ROLE.indexOf(ComponentProp) === -1) {
	        buttonProps.role = 'button';
	      }
	
	      return _react2.default.createElement(
	        ComponentProp,
	        (0, _extends3.default)({
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseUp: this.handleMouseUp,
	          onTouchEnd: this.handleTouchEnd,
	          onTouchMove: this.handleTouchMove,
	          onTouchStart: this.handleTouchStart,
	          tabIndex: disabled ? -1 : tabIndex,
	          className: className,
	          ref: buttonRef
	        }, buttonProps, other),
	        children,
	        !disableRipple && !disabled ? _react2.default.createElement(_TouchRipple2.default, { innerRef: this.onRippleRef, center: centerRipple }) : null
	      );
	    }
	  }]);
	  return ButtonBase;
	}(_react2.default.Component);
	
	ButtonBase.propTypes =  false ? {
	  /**
	   * Use that property to pass a ref callback to the native button component.
	   */
	  buttonRef: _propTypes2.default.func,
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes2.default.bool,
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * The default value is a `button`.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes2.default.bool,
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   * `disableRipple` must also be `false`.
	   */
	  focusRipple: _propTypes2.default.bool,
	  /**
	   * The CSS class applied while the component is keyboard focused.
	   */
	  keyboardFocusedClassName: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  role: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * @ignore
	   */
	  type: _propTypes2.default.string
	} : {};
	
	ButtonBase.defaultProps = {
	  centerRipple: false,
	  disableRipple: false,
	  focusRipple: false,
	  tabIndex: 0,
	  type: 'button'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButtonBase' })(ButtonBase);

/***/ }),
/* 5535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Transition = __webpack_require__(580);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var Ripple = function (_React$Component) {
	  (0, _inherits3.default)(Ripple, _React$Component);
	
	  function Ripple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Ripple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ripple.__proto__ || (0, _getPrototypeOf2.default)(Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      rippleVisible: false,
	      rippleLeaving: false
	    }, _this.handleEnter = function () {
	      _this.setState({
	        rippleVisible: true
	      });
	    }, _this.handleExit = function () {
	      _this.setState({
	        rippleLeaving: true
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Ripple, [{
	    key: 'render',
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _props = this.props,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          pulsate = _props.pulsate,
	          rippleX = _props.rippleX,
	          rippleY = _props.rippleY,
	          rippleSize = _props.rippleSize,
	          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'pulsate', 'rippleX', 'rippleY', 'rippleSize']);
	      var _state = this.state,
	          rippleVisible = _state.rippleVisible,
	          rippleLeaving = _state.rippleLeaving;
	
	
	      var className = (0, _classnames2.default)(classes.wrapper, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.wrapperLeaving, rippleLeaving), (0, _defineProperty3.default)(_classNames, classes.wrapperPulsating, pulsate), _classNames), classNameProp);
	
	      var rippleClassName = (0, _classnames2.default)(classes.ripple, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.rippleVisible, rippleVisible), (0, _defineProperty3.default)(_classNames2, classes.rippleFast, pulsate), _classNames2));
	
	      var rippleStyles = {
	        width: rippleSize,
	        height: rippleSize,
	        top: -(rippleSize / 2) + rippleY,
	        left: -(rippleSize / 2) + rippleX
	      };
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        (0, _extends3.default)({ onEnter: this.handleEnter, onExit: this.handleExit }, other),
	        _react2.default.createElement(
	          'span',
	          { className: className },
	          _react2.default.createElement('span', { className: rippleClassName, style: rippleStyles })
	        )
	      );
	    }
	  }]);
	  return Ripple;
	}(_react2.default.Component);
	
	Ripple.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes2.default.bool,
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes2.default.number,
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes2.default.number,
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes2.default.number
	} : {};
	
	Ripple.defaultProps = {
	  pulsate: false
	};
	
	exports.default = Ripple;

/***/ }),
/* 5536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = exports.DELAY_RIPPLE = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionGroup = __webpack_require__(5666);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Ripple = __webpack_require__(5535);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DURATION = 550;
	var DELAY_RIPPLE = exports.DELAY_RIPPLE = 80;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'block',
	      position: 'absolute',
	      overflow: 'hidden',
	      borderRadius: 'inherit',
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      pointerEvents: 'none',
	      zIndex: 0
	    },
	    wrapper: {
	      opacity: 1
	    },
	    wrapperLeaving: {
	      opacity: 0,
	      animation: 'mui-ripple-exit ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
	    },
	    wrapperPulsating: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      animation: 'mui-ripple-pulsate 2500ms ' + theme.transitions.easing.easeInOut + ' 200ms infinite'
	    },
	    '@keyframes mui-ripple-enter': {
	      '0%': {
	        transform: 'scale(0)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    },
	    '@keyframes mui-ripple-exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes mui-ripple-pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    },
	    ripple: {
	      width: 50,
	      height: 50,
	      left: 0,
	      top: 0,
	      opacity: 0,
	      position: 'absolute',
	      borderRadius: '50%',
	      background: 'currentColor'
	    },
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: 'mui-ripple-enter ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
	    },
	    rippleFast: {
	      animationDuration: '200ms'
	    }
	  };
	};
	
	/**
	 * @ignore - internal component.
	 */
	
	var TouchRipple = function (_React$Component) {
	  (0, _inherits3.default)(TouchRipple, _React$Component);
	
	  function TouchRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      nextKey: 0,
	      ripples: []
	    }, _this.ignoringMouseDown = false, _this.startTimer = null, _this.startTimerCommit = null, _this.pulsate = function () {
	      _this.start({}, { pulsate: true });
	    }, _this.start = function () {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var cb = arguments[2];
	      var _options$pulsate = options.pulsate,
	          pulsate = _options$pulsate === undefined ? false : _options$pulsate,
	          _options$center = options.center,
	          center = _options$center === undefined ? _this.props.center || options.pulsate : _options$center,
	          _options$fakeElement = options.fakeElement,
	          fakeElement = _options$fakeElement === undefined ? false : _options$fakeElement;
	
	
	      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
	        _this.ignoringMouseDown = false;
	        return;
	      }
	
	      if (event.type === 'touchstart') {
	        _this.ignoringMouseDown = true;
	      }
	
	      var element = fakeElement ? null : _reactDom2.default.findDOMNode(_this);
	      var rect = element ? element.getBoundingClientRect() : {
	        width: 0,
	        height: 0,
	        left: 0,
	        top: 0
	      };
	
	      // Get the size of the ripple
	      var rippleX = void 0;
	      var rippleY = void 0;
	      var rippleSize = void 0;
	
	      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	        rippleX = Math.round(rect.width / 2);
	        rippleY = Math.round(rect.height / 2);
	      } else {
	        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	        rippleX = Math.round(clientX - rect.left);
	        rippleY = Math.round(clientY - rect.top);
	      }
	
	      if (center) {
	        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);
	
	        // For some reason the animation is broken on Mobile Chrome if the size if even.
	        if (rippleSize % 2 === 0) {
	          rippleSize += 1;
	        }
	      } else {
	        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	      }
	
	      // Touche devices
	      if (event.touches) {
	        // Prepare the ripple effect.
	        _this.startTimerCommit = function () {
	          _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
	        };
	        // Deplay the execution of the ripple effect.
	        _this.startTimer = setTimeout(function () {
	          _this.startTimerCommit();
	          _this.startTimerCommit = null;
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      } else {
	        _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
	      }
	    }, _this.startCommit = function (params) {
	      var pulsate = params.pulsate,
	          rippleX = params.rippleX,
	          rippleY = params.rippleY,
	          rippleSize = params.rippleSize,
	          cb = params.cb;
	
	      var ripples = _this.state.ripples;
	
	      // Add a ripple to the ripples array.
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_Ripple2.default, {
	        key: _this.state.nextKey,
	        classes: _this.props.classes,
	        timeout: {
	          exit: DURATION,
	          enter: DURATION
	        },
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	
	      _this.setState({
	        nextKey: _this.state.nextKey + 1,
	        ripples: ripples
	      }, cb);
	    }, _this.stop = function (event, cb) {
	      clearTimeout(_this.startTimer);
	      var ripples = _this.state.ripples;
	
	      // The touch interaction occures to quickly.
	      // We still want to show ripple effect.
	
	      if (event.type === 'touchend' && _this.startTimerCommit) {
	        event.persist();
	        _this.startTimerCommit();
	        _this.startTimerCommit = null;
	        _this.startTimer = setTimeout(function () {
	          _this.stop(event, cb);
	        }, 0);
	        return;
	      }
	
	      _this.startTimerCommit = null;
	
	      if (ripples && ripples.length) {
	        _this.setState({
	          ripples: ripples.slice(1)
	        }, cb);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.startTimer);
	    }
	
	    // Used to filter out mouse emulated events on mobile.
	
	    // We use a timer in order to only show the ripples for touch "click" like events.
	    // We don't want to display the ripple for touch scroll events.
	
	    // This is the hook called once the previous timeout is ready.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          center = _props.center,
	          classes = _props.classes,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['center', 'classes', 'className']);
	
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({
	          component: 'span',
	          enter: true,
	          exit: true,
	          className: (0, _classnames2.default)(classes.root, className)
	        }, other),
	        this.state.ripples
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react2.default.Component);
	
	TouchRipple.propTypes =  false ? {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes2.default.bool,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	TouchRipple.defaultProps = {
	  center: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiTouchRipple' })(TouchRipple);

/***/ }),
/* 5537 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function createRippleHandler(instance, eventName, action, cb) {
	  return function handleEvent(event) {
	    if (cb) {
	      cb.call(instance, event);
	    }
	
	    if (event.defaultPrevented) {
	      return false;
	    }
	
	    if (instance.ripple) {
	      instance.ripple[action](event);
	    }
	
	    if (instance.props && typeof instance.props['on' + eventName] === 'function') {
	      instance.props['on' + eventName](event);
	    }
	
	    return true;
	  };
	}
	
	exports.default = createRippleHandler;

/***/ }),
/* 5538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(279);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Card(props) {
	  var raised = props.raised,
	      other = (0, _objectWithoutProperties3.default)(props, ['raised']);
	
	
	  return _react2.default.createElement(_Paper2.default, (0, _extends3.default)({ elevation: raised ? 8 : 2 }, other));
	} // @inheritedComponent Paper
	
	Card.propTypes =  false ? {
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the card will use raised styling.
	   */
	  raised: _propTypes2.default.bool
	} : {};
	
	Card.defaultProps = {
	  raised: false
	};
	
	exports.default = Card;

/***/ }),
/* 5539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _reactHelpers = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  root: {
	    height: 52,
	    display: 'flex',
	    alignItems: 'center',
	    padding: '2px 4px',
	    boxSizing: 'border-box'
	  },
	  action: {
	    margin: '0 4px'
	  }
	};
	
	function CardActions(props) {
	  var disableActionSpacing = props.disableActionSpacing,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['disableActionSpacing', 'children', 'classes', 'className']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action)
	  );
	}
	
	CardActions.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the card actions do not have additional margin.
	   */
	  disableActionSpacing: _propTypes2.default.bool
	} : {};
	
	CardActions.defaultProps = {
	  disableActionSpacing: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardActions' })(CardActions);

/***/ }),
/* 5540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      padding: theme.spacing.unit * 2,
	      '&:last-child': {
	        paddingBottom: theme.spacing.unit * 3
	      }
	    }
	  };
	};
	
	function CardContent(props) {
	  var classes = props.classes,
	      className = props.className,
	      Component = props.component,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component']);
	
	
	  return _react2.default.createElement(Component, (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other));
	}
	
	CardContent.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	} : {};
	
	CardContent.defaultProps = {
	  component: 'div'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardContent' })(CardContent);

/***/ }),
/* 5541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(326);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      alignItems: 'center',
	      padding: theme.spacing.unit * 2
	    },
	    avatar: {
	      flex: '0 0 auto',
	      marginRight: theme.spacing.unit * 2
	    },
	    action: {
	      flex: '0 0 auto',
	      alignSelf: 'flex-start',
	      marginTop: theme.spacing.unit * -1,
	      marginRight: theme.spacing.unit * -2
	    },
	    content: {
	      flex: '1 1 auto'
	    },
	    title: {},
	    subheader: {}
	  };
	};
	
	function CardHeader(props) {
	  var action = props.action,
	      avatar = props.avatar,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      subheader = props.subheader,
	      title = props.title,
	      other = (0, _objectWithoutProperties3.default)(props, ['action', 'avatar', 'classes', 'className', 'component', 'subheader', 'title']);
	
	
	  return _react2.default.createElement(
	    Component,
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other),
	    avatar && _react2.default.createElement(
	      'div',
	      { className: classes.avatar },
	      avatar
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.content },
	      _react2.default.createElement(
	        _Typography2.default,
	        {
	          variant: avatar ? 'body2' : 'headline',
	          component: 'span',
	          className: classes.title
	        },
	        title
	      ),
	      subheader && _react2.default.createElement(
	        _Typography2.default,
	        {
	          variant: avatar ? 'body2' : 'body1',
	          component: 'span',
	          color: 'textSecondary',
	          className: classes.subheader
	        },
	        subheader
	      )
	    ),
	    action && _react2.default.createElement(
	      'div',
	      { className: classes.action },
	      action
	    )
	  );
	}
	
	CardHeader.propTypes =  false ? {
	  /**
	   * The action to display in the card header.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * The Avatar for the Card Header.
	   */
	  avatar: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * The content of the component.
	   */
	  subheader: _propTypes2.default.node,
	  /**
	   * The content of the Card Title.
	   */
	  title: _propTypes2.default.node
	} : {};
	
	CardHeader.defaultProps = {
	  component: 'div'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardHeader' })(CardHeader);

/***/ }),
/* 5542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  root: {
	    backgroundSize: 'cover',
	    backgroundRepeat: 'no-repeat',
	    backgroundPosition: 'center'
	  },
	  rootMedia: {
	    width: '100%'
	  }
	};
	
	var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
	
	function CardMedia(props) {
	  var _classNames;
	
	  var classes = props.classes,
	      className = props.className,
	      Component = props.component,
	      image = props.image,
	      src = props.src,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'image', 'src', 'style']);
	
	
	   false ? (0, _warning2.default)(Boolean(image || src), 'Material-UI: either `image` or `src` property must be specified.') : void 0;
	
	  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
	  var composedStyle = !isMediaComponent && image ? (0, _extends3.default)({ backgroundImage: 'url(' + image + ')' }, style) : style;
	  var composedClassName = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.root, !isMediaComponent), (0, _defineProperty3.default)(_classNames, classes.rootMedia, isMediaComponent), _classNames), className);
	
	  return _react2.default.createElement(Component, (0, _extends3.default)({
	    className: composedClassName,
	    style: composedStyle,
	    src: isMediaComponent ? image || src : undefined
	  }, other));
	}
	
	CardMedia.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Component for rendering image.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Image to be displayed as a background image.
	   * Either `image` or `src` prop must be specified.
	   * Note that caller must specify height otherwise the image will not be visible.
	   */
	  image: _propTypes2.default.string,
	  /**
	   * An alias for `image` property.
	   * Available only with media components.
	   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
	   */
	  src: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  style: _propTypes2.default.object
	} : {};
	
	CardMedia.defaultProps = {
	  component: 'div'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardMedia' })(CardMedia);

/***/ }),
/* 5543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Card = __webpack_require__(5538);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	
	var _CardContent = __webpack_require__(5540);
	
	Object.defineProperty(exports, 'CardContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardContent).default;
	  }
	});
	
	var _CardActions = __webpack_require__(5539);
	
	Object.defineProperty(exports, 'CardActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardActions).default;
	  }
	});
	
	var _CardMedia = __webpack_require__(5542);
	
	Object.defineProperty(exports, 'CardMedia', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardMedia).default;
	  }
	});
	
	var _CardHeader = __webpack_require__(5541);
	
	Object.defineProperty(exports, 'CardHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CardHeader).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SwitchBase = __webpack_require__(1568);
	
	var _SwitchBase2 = _interopRequireDefault(_SwitchBase);
	
	var _IndeterminateCheckBox = __webpack_require__(5655);
	
	var _IndeterminateCheckBox2 = _interopRequireDefault(_IndeterminateCheckBox);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    default: {
	      color: theme.palette.text.secondary
	    },
	    checked: {
	      color: theme.palette.primary.main
	    },
	    disabled: {
	      color: theme.palette.action.disabled
	    }
	  };
	};
	
	function Checkbox(props) {
	  var checkedIcon = props.checkedIcon,
	      icon = props.icon,
	      indeterminate = props.indeterminate,
	      indeterminateIcon = props.indeterminateIcon,
	      other = (0, _objectWithoutProperties3.default)(props, ['checkedIcon', 'icon', 'indeterminate', 'indeterminateIcon']);
	
	
	  return _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
	    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
	    icon: indeterminate ? indeterminateIcon : icon
	  }, other));
	}
	
	Checkbox.propTypes =  false ? {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes2.default.bool,
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * If `true`, the component appears indeterminate.
	   */
	  indeterminate: _propTypes2.default.bool,
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes2.default.node,
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes2.default.object,
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes2.default.func,
	  /**
	   * The input component property `type`.
	   */
	  inputType: _propTypes2.default.string,
	  /*
	   * @ignore
	   */
	  name: _propTypes2.default.string,
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The value of the component.
	   */
	  value: _propTypes2.default.string
	} : {};
	
	Checkbox.defaultProps = {
	  indeterminate: false,
	  indeterminateIcon: _react2.default.createElement(_IndeterminateCheckBox2.default, null)
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCheckbox' })(Checkbox);

/***/ }),
/* 5545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkbox = __webpack_require__(5544);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkbox).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(568);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Cancel = __webpack_require__(5651);
	
	var _Cancel2 = _interopRequireDefault(_Cancel);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _colorManipulator = __webpack_require__(470);
	
	var _reactHelpers = __webpack_require__(327);
	
	__webpack_require__(2361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// So we don't have any override priority issue.
	
	var styles = exports.styles = function styles(theme) {
	  var height = 32;
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
	
	  return {
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: height,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: height / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      outline: 'none', // No outline on focused element in Chrome (as triggered by tabIndex prop)
	      border: 'none', // Remove `button` border
	      padding: 0 // Remove `button` padding
	    },
	    clickable: {
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1],
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
	      }
	    },
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	    avatar: {
	      marginRight: -4,
	      width: height,
	      height: height,
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      fontSize: theme.typography.pxToRem(16)
	    },
	    avatarChildren: {
	      width: 19,
	      height: 19
	    },
	    label: {
	      display: 'flex',
	      alignItems: 'center',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap',
	      cursor: 'inherit'
	    },
	    deleteIcon: {
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      cursor: 'pointer',
	      height: 'auto',
	      margin: '0 4px 0 -8px',
	      '&:hover': {
	        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
	      }
	    }
	  };
	};
	
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	var Chip = function (_React$Component) {
	  (0, _inherits3.default)(Chip, _React$Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.chipRef = null, _this.handleDeleteIconClick = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      var onDelete = _this.props.onDelete;
	
	      if (onDelete) {
	        onDelete(event);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onDelete = _this$props.onDelete,
	          onKeyDown = _this$props.onKeyDown;
	
	      var key = (0, _keycode2.default)(event);
	
	      if (onClick && (key === 'space' || key === 'enter')) {
	        event.preventDefault();
	        onClick(event);
	      } else if (onDelete && key === 'backspace') {
	        event.preventDefault();
	        onDelete(event);
	      } else if (key === 'esc') {
	        event.preventDefault();
	        if (_this.chipRef) {
	          _this.chipRef.blur();
	        }
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Chip, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          avatarProp = _props.avatar,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          Component = _props.component,
	          deleteIconProp = _props.deleteIcon,
	          label = _props.label,
	          onClick = _props.onClick,
	          onDelete = _props.onDelete,
	          onKeyDown = _props.onKeyDown,
	          tabIndexProp = _props.tabIndex,
	          other = (0, _objectWithoutProperties3.default)(_props, ['avatar', 'classes', 'className', 'component', 'deleteIcon', 'label', 'onClick', 'onDelete', 'onKeyDown', 'tabIndex']);
	
	
	      var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.clickable, onClick), (0, _defineProperty3.default)({}, classes.deletable, onDelete), classNameProp);
	
	      var deleteIcon = null;
	      if (onDelete) {
	        deleteIcon = deleteIconProp ? (0, _reactHelpers.cloneChildrenWithClassName)(deleteIconProp, classes.deleteIcon, {
	          onClick: this.handleDeleteIconClick
	        }) : _react2.default.createElement(_Cancel2.default, { className: classes.deleteIcon, onClick: this.handleDeleteIconClick });
	      }
	
	      var avatar = null;
	      if (avatarProp && _react2.default.isValidElement(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatarProp, {
	          className: (0, _classnames2.default)(classes.avatar, avatarProp.props.className),
	          childrenClassName: (0, _classnames2.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
	        });
	      }
	
	      var tabIndex = tabIndexProp;
	
	      if (!tabIndex) {
	        tabIndex = onClick || onDelete ? 0 : -1;
	      }
	
	      return _react2.default.createElement(
	        Component,
	        (0, _extends3.default)({
	          role: 'button',
	          className: className,
	          tabIndex: tabIndex,
	          onClick: onClick,
	          onKeyDown: this.handleKeyDown,
	          ref: function ref(node) {
	            _this2.chipRef = node;
	          }
	        }, other),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { className: classes.label },
	          label
	        ),
	        deleteIcon
	      );
	    }
	  }]);
	  return Chip;
	}(_react2.default.Component);
	
	Chip.propTypes =  false ? {
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes2.default.element,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes2.default.element,
	  /**
	   * The content of the label.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	} : {};
	
	Chip.defaultProps = {
	  component: 'div'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiChip' })(Chip);

/***/ }),
/* 5547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Chip = __webpack_require__(5546);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chip).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	var _Modal = __webpack_require__(578);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Fade = __webpack_require__(1573);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _transitions = __webpack_require__(381);
	
	var _Paper = __webpack_require__(279);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	    paper: {
	      display: 'flex',
	      margin: theme.spacing.unit * 4,
	      flexDirection: 'column',
	      flex: '0 1 auto',
	      position: 'relative',
	      maxHeight: '90vh',
	      overflowY: 'auto', // Fix IE11 issue, to remove at some point.
	      '&:focus': {
	        outline: 'none'
	      }
	    },
	    paperWidthXs: {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 360)
	    },
	    paperWidthSm: {
	      maxWidth: theme.breakpoints.values.sm
	    },
	    paperWidthMd: {
	      maxWidth: theme.breakpoints.values.md
	    },
	    fullWidth: {
	      width: '100%'
	    },
	    fullScreen: {
	      margin: 0,
	      width: '100%',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: '100%',
	      borderRadius: 0
	    }
	  };
	};
	
	/**
	 * Dialogs are overlaid modal paper based components with a backdrop.
	 */
	// @inheritedComponent Modal
	
	function Dialog(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      fullScreen = props.fullScreen,
	      fullWidth = props.fullWidth,
	      disableBackdropClick = props.disableBackdropClick,
	      disableEscapeKeyDown = props.disableEscapeKeyDown,
	      maxWidth = props.maxWidth,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      PaperProps = props.PaperProps,
	      TransitionProp = props.transition,
	      transitionDuration = props.transitionDuration,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'fullScreen', 'fullWidth', 'disableBackdropClick', 'disableEscapeKeyDown', 'maxWidth', 'onBackdropClick', 'onClose', 'onEnter', 'onEntered', 'onEntering', 'onEscapeKeyDown', 'onExit', 'onExited', 'onExiting', 'open', 'PaperProps', 'transition', 'transitionDuration']);
	
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    (0, _extends3.default)({
	      className: (0, _classnames2.default)(classes.root, className),
	      BackdropProps: {
	        transitionDuration: transitionDuration
	      },
	      disableBackdropClick: disableBackdropClick,
	      disableEscapeKeyDown: disableEscapeKeyDown,
	      onBackdropClick: onBackdropClick,
	      onEscapeKeyDown: onEscapeKeyDown,
	      onClose: onClose,
	      open: open,
	      role: 'dialog'
	    }, other),
	    _react2.default.createElement(
	      TransitionProp,
	      {
	        appear: true,
	        'in': open,
	        timeout: transitionDuration,
	        onEnter: onEnter,
	        onEntering: onEntering,
	        onEntered: onEntered,
	        onExit: onExit,
	        onExiting: onExiting,
	        onExited: onExited
	      },
	      _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({
	          elevation: 24,
	          className: (0, _classnames2.default)(classes.paper, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['paperWidth' + (maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty3.default)(_classNames, classes.fullScreen, fullScreen), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames))
	        }, PaperProps),
	        children
	      )
	    )
	  );
	}
	
	Dialog.propTypes =  false ? {
	  /**
	   * Dialog children, usually the included sub-components.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, clicking the backdrop will not fire the `onClose` callback.
	   */
	  disableBackdropClick: _propTypes2.default.bool,
	  /**
	   * If `true`, hitting escape will not fire the `onClose` callback.
	   */
	  disableEscapeKeyDown: _propTypes2.default.bool,
	  /**
	   * If `true`, it will be full-screen
	   */
	  fullScreen: _propTypes2.default.bool,
	  /**
	   * If specified, stretches dialog to max width.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Determine the max width of the dialog.
	   * The dialog width grows with the size of the screen, this property is useful
	   * on the desktop where you might need some coherent different width size across your
	   * application. Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', false]),
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Callback fired before the dialog enters.
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired when the dialog has entered.
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired when the dialog is entering.
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableKeyboard` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	  /**
	   * Callback fired before the dialog exits.
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired when the dialog has exited.
	   */
	  onExited: _propTypes2.default.func,
	  /**
	   * Callback fired when the dialog is exiting.
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * If `true`, the Dialog is open.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  PaperProps: _propTypes2.default.object,
	  /**
	   * Transition component.
	   */
	  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
	} : {};
	
	Dialog.defaultProps = {
	  fullScreen: false,
	  fullWidth: false,
	  disableBackdropClick: false,
	  disableEscapeKeyDown: false,
	  maxWidth: 'sm',
	  transition: _Fade2.default,
	  transitionDuration: { enter: _transitions.duration.enteringScreen, exit: _transitions.duration.leavingScreen }
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialog' })(Dialog);

/***/ }),
/* 5549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	__webpack_require__(2362);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// So we don't have any override priority issue.
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-end',
	      alignItems: 'center',
	      margin: theme.spacing.unit + 'px ' + theme.spacing.unit / 2 + 'px',
	      flex: '0 0 auto'
	    },
	    action: {
	      margin: '0 ' + theme.spacing.unit / 2 + 'px'
	    },
	    button: {
	      minWidth: 64
	    }
	  };
	};
	
	function DialogActions(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    _react2.default.Children.map(children, function (child) {
	      if (!_react2.default.isValidElement(child)) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes.action },
	        _react2.default.cloneElement(child, {
	          className: (0, _classnames2.default)(classes.button, child.props.className)
	        })
	      );
	    })
	  );
	}
	
	DialogActions.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogActions' })(DialogActions);

/***/ }),
/* 5550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  var spacing = theme.spacing.unit * 3;
	  return {
	    root: {
	      flex: '1 1 auto',
	      overflowY: 'auto',
	      padding: '0 ' + spacing + 'px ' + spacing + 'px ' + spacing + 'px',
	      '&:first-child': {
	        paddingTop: spacing
	      }
	    }
	  };
	};
	
	function DialogContent(props) {
	  var classes = props.classes,
	      children = props.children,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'children', 'className']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    children
	  );
	}
	
	DialogContent.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogContent' })(DialogContent);

/***/ }),
/* 5551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: (0, _extends3.default)({}, theme.typography.subheading, {
	      color: theme.palette.text.secondary,
	      margin: 0
	    })
	  };
	};
	
	function DialogContentText(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);
	
	
	  return _react2.default.createElement(
	    'p',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    children
	  );
	}
	
	DialogContentText.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogContentText' })(DialogContentText);

/***/ }),
/* 5552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(326);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      margin: 0,
	      padding: theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 3 + 'px       20px ' + theme.spacing.unit * 3 + 'px',
	      flex: '0 0 auto'
	    }
	  };
	};
	
	function DialogTitle(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      disableTypography = props.disableTypography,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableTypography']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    disableTypography ? children : _react2.default.createElement(
	      _Typography2.default,
	      { variant: 'title' },
	      children
	    )
	  );
	}
	
	DialogTitle.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, this can be useful to render an h4 instead of the default h2.
	   */
	  disableTypography: _propTypes2.default.bool
	} : {};
	
	DialogTitle.defaultProps = {
	  disableTypography: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogTitle' })(DialogTitle);

/***/ }),
/* 5553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dialog = __webpack_require__(5548);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dialog).default;
	  }
	});
	
	var _DialogActions = __webpack_require__(5549);
	
	Object.defineProperty(exports, 'DialogActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogActions).default;
	  }
	});
	
	var _DialogTitle = __webpack_require__(5552);
	
	Object.defineProperty(exports, 'DialogTitle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogTitle).default;
	  }
	});
	
	var _DialogContent = __webpack_require__(5550);
	
	Object.defineProperty(exports, 'DialogContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogContent).default;
	  }
	});
	
	var _DialogContentText = __webpack_require__(5551);
	
	Object.defineProperty(exports, 'DialogContentText', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DialogContentText).default;
	  }
	});
	
	var _withMobileDialog = __webpack_require__(5554);
	
	Object.defineProperty(exports, 'withMobileDialog', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withMobileDialog).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withWidth = __webpack_require__(1575);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Dialog will responsively be full screen *at or below* the given breakpoint
	 * (defaults to 'sm' for mobile devices).
	 * Notice that this Higher-order Component is incompatible with server side rendering.
	 */
	var withMobileDialog = function withMobileDialog() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$breakpoint = options.breakpoint,
	        breakpoint = _options$breakpoint === undefined ? 'sm' : _options$breakpoint;
	
	
	    function WithMobileDialog(props) {
	      return _react2.default.createElement(Component, (0, _extends3.default)({ fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width) }, props));
	    }
	
	    WithMobileDialog.propTypes =  false ? {
	      width: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
	    } : {};
	
	    return (0, _withWidth2.default)()(WithMobileDialog);
	  };
	};
	
	exports.default = withMobileDialog;

/***/ }),
/* 5555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _colorManipulator = __webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      height: 1,
	      margin: 0, // Reset browser default style.
	      border: 'none',
	      flexShrink: 0
	    },
	    inset: {
	      marginLeft: 72
	    },
	    default: {
	      backgroundColor: theme.palette.divider
	    },
	    light: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
	    },
	    absolute: {
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      width: '100%'
	    }
	  };
	};
	
	function Divider(props) {
	  var _classNames;
	
	  var absolute = props.absolute,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      inset = props.inset,
	      light = props.light,
	      other = (0, _objectWithoutProperties3.default)(props, ['absolute', 'classes', 'className', 'component', 'inset', 'light']);
	
	
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.absolute, absolute), (0, _defineProperty3.default)(_classNames, classes.inset, inset), _classNames), light ? classes.light : classes.default, classNameProp);
	
	  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
	}
	
	Divider.propTypes =  false ? {
	  absolute: _propTypes2.default.bool,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the divider will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * If `true`, the divider will have a lighter color.
	   */
	  light: _propTypes2.default.bool
	} : {};
	
	Divider.defaultProps = {
	  absolute: false,
	  component: 'hr',
	  inset: false,
	  light: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDivider' })(Divider);

/***/ }),
/* 5556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Divider = __webpack_require__(5555);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Divider).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Modal = __webpack_require__(578);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Slide = __webpack_require__(1574);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _Paper = __webpack_require__(279);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _helpers = __webpack_require__(127);
	
	var _transitions = __webpack_require__(381);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSlideDirection(anchor) {
	  if (anchor === 'left') {
	    return 'right';
	  } else if (anchor === 'right') {
	    return 'left';
	  } else if (anchor === 'top') {
	    return 'down';
	  }
	
	  // (anchor === 'bottom')
	  return 'up';
	} // @inheritedComponent Modal
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    docked: {
	      flex: '0 0 auto'
	    },
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100vh',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch', // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      '&:focus': {
	        outline: 'none'
	      }
	    },
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100vh'
	    },
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100vh'
	    },
	    paperAnchorDockedLeft: {
	      borderRight: '1px solid ' + theme.palette.divider
	    },
	    paperAnchorDockedTop: {
	      borderBottom: '1px solid ' + theme.palette.divider
	    },
	    paperAnchorDockedRight: {
	      borderLeft: '1px solid ' + theme.palette.divider
	    },
	    paperAnchorDockedBottom: {
	      borderTop: '1px solid ' + theme.palette.divider
	    },
	    modal: {} // Just here so people can override the style.
	  };
	};
	
	var Drawer = function (_React$Component) {
	  (0, _inherits3.default)(Drawer, _React$Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      // Let's assume that the Drawer will always be rendered on user space.
	      // We use that state is order to skip the appear transition during the
	      // initial mount of the component.
	      firstMount: true
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Drawer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setState({
	        firstMount: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          anchorProp = _props.anchor,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          elevation = _props.elevation,
	          ModalProps = _props.ModalProps,
	          onClose = _props.onClose,
	          open = _props.open,
	          PaperProps = _props.PaperProps,
	          SlideProps = _props.SlideProps,
	          theme = _props.theme,
	          transitionDuration = _props.transitionDuration,
	          variant = _props.variant,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchor', 'children', 'classes', 'className', 'elevation', 'ModalProps', 'onClose', 'open', 'PaperProps', 'SlideProps', 'theme', 'transitionDuration', 'variant']);
	
	
	      var anchor = anchorProp;
	      if (theme.direction === 'rtl' && ['left', 'right'].includes(anchor)) {
	        anchor = anchor === 'left' ? 'right' : 'left';
	      }
	
	      var drawer = _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({
	          elevation: variant === 'temporary' ? elevation : 0,
	          square: true,
	          className: (0, _classnames2.default)(classes.paper, classes['paperAnchor' + (0, _helpers.capitalize)(anchor)], (0, _defineProperty3.default)({}, classes['paperAnchorDocked' + (0, _helpers.capitalize)(anchor)], variant !== 'temporary'))
	        }, PaperProps),
	        children
	      );
	
	      if (variant === 'permanent') {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.docked, className) }, other),
	          drawer
	        );
	      }
	
	      var slidingDrawer = _react2.default.createElement(
	        _Slide2.default,
	        (0, _extends3.default)({
	          'in': open,
	          direction: getSlideDirection(anchor),
	          timeout: transitionDuration,
	          appear: !this.state.firstMount
	        }, SlideProps),
	        drawer
	      );
	
	      if (variant === 'persistent') {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.docked, className) }, other),
	          slidingDrawer
	        );
	      }
	
	      // variant === temporary
	      return _react2.default.createElement(
	        _Modal2.default,
	        (0, _extends3.default)({
	          BackdropProps: {
	            transitionDuration: transitionDuration
	          },
	          className: (0, _classnames2.default)(classes.modal, className),
	          open: open,
	          onClose: onClose
	        }, other, ModalProps),
	        slidingDrawer
	      );
	    }
	  }]);
	  return Drawer;
	}(_react2.default.Component);
	
	Drawer.propTypes =  false ? {
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes2.default.oneOf(['left', 'top', 'right', 'bottom']),
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes2.default.number,
	  /**
	   * Properties applied to the `Modal` element.
	   */
	  ModalProps: _propTypes2.default.object,
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  PaperProps: _propTypes2.default.object,
	  /**
	   * Properties applied to the `Slide` element.
	   */
	  SlideProps: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })]),
	  /**
	   * The type of drawer.
	   */
	  variant: _propTypes2.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : {};
	
	Drawer.defaultProps = {
	  anchor: 'left',
	  elevation: 16,
	  open: false,
	  transitionDuration: { enter: _transitions.duration.enteringScreen, exit: _transitions.duration.leavingScreen },
	  variant: 'temporary' // Mobile first.
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDrawer', flip: false, withTheme: true })(Drawer);

/***/ }),
/* 5558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Collapse = __webpack_require__(1572);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _Paper = __webpack_require__(279);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _reactHelpers = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest,
	    easing: theme.transitions.easing.ease
	  };
	
	  return {
	    root: {
	      position: 'relative',
	      margin: 0,
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        borderTopLeftRadius: 2,
	        borderTopRightRadius: 2,
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&:last-child': {
	        borderBottomLeftRadius: 2,
	        borderBottomRightRadius: 2
	      },
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      }
	    },
	    expanded: {
	      margin: theme.spacing.unit * 2 + 'px 0',
	      '&:first-child': {
	        marginTop: 0
	      },
	      '&:last-child': {
	        marginBottom: 0
	      },
	      '&:before': {
	        opacity: 0
	      }
	    },
	    disabled: {
	      backgroundColor: theme.palette.action.disabledBackground
	    }
	  };
	}; // @inheritedComponent Paper
	
	var ExpansionPanel = function (_React$Component) {
	  (0, _inherits3.default)(ExpansionPanel, _React$Component);
	
	  function ExpansionPanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ExpansionPanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpansionPanel.__proto__ || (0, _getPrototypeOf2.default)(ExpansionPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: false
	    }, _this.isControlled = null, _this.handleChange = function (event) {
	      var onChange = _this.props.onChange;
	
	      var expanded = !_this.state.expanded;
	
	      if (onChange) {
	        onChange(event, expanded);
	      }
	
	      if (!_this.isControlled) {
	        _this.setState({ expanded: expanded });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ExpansionPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          expanded = _props.expanded,
	          defaultExpanded = _props.defaultExpanded;
	
	      this.isControlled = expanded != null;
	      this.setState({
	        expanded: this.isControlled ? expanded : defaultExpanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isControlled) {
	        this.setState({
	          expanded: nextProps.expanded
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _props2 = this.props,
	          childrenProp = _props2.children,
	          classes = _props2.classes,
	          classNameProp = _props2.className,
	          CollapsePropsProp = _props2.CollapseProps,
	          defaultExpanded = _props2.defaultExpanded,
	          disabled = _props2.disabled,
	          expandedProp = _props2.expanded,
	          onChange = _props2.onChange,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'classes', 'className', 'CollapseProps', 'defaultExpanded', 'disabled', 'expanded', 'onChange']);
	      var expanded = this.state.expanded;
	
	
	      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.expanded, expanded), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
	
	      var summary = null;
	
	      var children = _react2.default.Children.map(childrenProp, function (child) {
	        if (!_react2.default.isValidElement(child)) {
	          return null;
	        }
	
	        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
	          summary = _react2.default.cloneElement(child, {
	            disabled: disabled,
	            expanded: expanded,
	            onChange: _this2.handleChange
	          });
	          return null;
	        }
	
	        return child;
	      });
	
	      var CollapseProps = !expanded ? {
	        'aria-hidden': 'true'
	      } : null;
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({ className: className, elevation: 1, square: true }, other),
	        summary,
	        _react2.default.createElement(
	          _Collapse2.default,
	          (0, _extends3.default)({ 'in': expanded, timeout: 'auto' }, CollapseProps, CollapsePropsProp),
	          children
	        )
	      );
	    }
	  }]);
	  return ExpansionPanel;
	}(_react2.default.Component);
	
	ExpansionPanel.propTypes =  false ? {
	  /**
	   * The content of the expansion panel.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Properties applied to the `Collapse` element.
	   */
	  CollapseProps: _propTypes2.default.object,
	  /**
	   * If `true`, expands the panel by default.
	   */
	  defaultExpanded: _propTypes2.default.bool,
	  /**
	   * If `true`, the panel will be displayed in a disabled state.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, expands the panel, otherwise collapse it.
	   * Setting this prop enables control over the panel.
	   */
	  expanded: _propTypes2.default.bool,
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {boolean} expanded The `expanded` state of the panel
	   */
	  onChange: _propTypes2.default.func
	} : {};
	
	ExpansionPanel.defaultProps = {
	  defaultExpanded: false,
	  disabled: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanel' })(ExpansionPanel);

/***/ }),
/* 5559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _reactHelpers = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-end',
	      alignItems: 'center',
	      padding: theme.spacing.unit * 2 + 'px ' + theme.spacing.unit + 'px'
	    },
	    action: {
	      marginLeft: theme.spacing.unit
	    }
	  };
	};
	
	function ExpansionPanelActions(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action)
	  );
	}
	
	ExpansionPanelActions.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelActions' })(ExpansionPanelActions);

/***/ }),
/* 5560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      flexGrow: 1,
	      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 3 + 'px'
	    }
	  };
	};
	
	function ExpansionPanelDetails(props) {
	  var classes = props.classes,
	      children = props.children,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'children', 'className']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    children
	  );
	}
	
	ExpansionPanelDetails.propTypes =  false ? {
	  /**
	   * The content of the expansion panel details.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelDetails' })(ExpansionPanelDetails);

/***/ }),
/* 5561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ButtonBase = __webpack_require__(278);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	var _IconButton = __webpack_require__(990);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent ButtonBase
	
	var styles = exports.styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest,
	    easing: theme.transitions.easing.ease
	  };
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center',
	      minHeight: theme.spacing.unit * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: '0 ' + theme.spacing.unit * 3 + 'px 0 ' + theme.spacing.unit * 3 + 'px',
	      position: 'relative',
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      }
	    },
	    expanded: {
	      minHeight: 64
	    },
	    focused: {
	      backgroundColor: theme.palette.grey[300]
	    },
	    disabled: {
	      opacity: 0.38
	    },
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '& > :last-child': {
	        paddingRight: theme.spacing.unit * 4
	      }
	    },
	    contentExpanded: {
	      margin: '20px 0'
	    },
	    expandIcon: {
	      position: 'absolute',
	      top: '50%',
	      right: theme.spacing.unit,
	      transform: 'translateY(-50%) rotate(0deg)',
	      transition: theme.transitions.create('transform', transition)
	    },
	    expandIconExpanded: {
	      transform: 'translateY(-50%) rotate(180deg)'
	    }
	  };
	};
	
	var ExpansionPanelSummary = function (_React$Component) {
	  (0, _inherits3.default)(ExpansionPanelSummary, _React$Component);
	
	  function ExpansionPanelSummary() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ExpansionPanelSummary);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpansionPanelSummary.__proto__ || (0, _getPrototypeOf2.default)(ExpansionPanelSummary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      focused: false
	    }, _this.handleFocus = function () {
	      _this.setState({
	        focused: true
	      });
	    }, _this.handleBlur = function () {
	      _this.setState({
	        focused: false
	      });
	    }, _this.handleChange = function (event) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onClick = _this$props.onClick;
	
	      if (onChange) {
	        onChange(event);
	      }
	      if (onClick) {
	        onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ExpansionPanelSummary, [{
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          disabled = _props.disabled,
	          expanded = _props.expanded,
	          expandIcon = _props.expandIcon,
	          onChange = _props.onChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'disabled', 'expanded', 'expandIcon', 'onChange']);
	      var focused = this.state.focused;
	
	
	      return _react2.default.createElement(
	        _ButtonBase2.default,
	        (0, _extends3.default)({
	          focusRipple: false,
	          disableRipple: true,
	          disabled: disabled,
	          component: 'div',
	          'aria-expanded': expanded,
	          className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.expanded, expanded), (0, _defineProperty3.default)(_classNames, classes.focused, focused), _classNames), className)
	        }, other, {
	          onKeyboardFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          onClick: this.handleChange
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(classes.content, (0, _defineProperty3.default)({}, classes.contentExpanded, expanded)) },
	          children
	        ),
	        expandIcon && _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: disabled,
	            className: (0, _classnames2.default)(classes.expandIcon, (0, _defineProperty3.default)({}, classes.expandIconExpanded, expanded)),
	            component: 'div',
	            tabIndex: '-1',
	            'aria-hidden': 'true'
	          },
	          expandIcon
	        )
	      );
	    }
	  }]);
	  return ExpansionPanelSummary;
	}(_react2.default.Component);
	
	ExpansionPanelSummary.propTypes =  false ? {
	  /**
	   * The content of the expansion panel summary.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   * If `true`, the summary will be displayed in a disabled state.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * If `true`, expands the summary, otherwise collapse it.
	   */
	  expanded: _propTypes2.default.bool,
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onClick: _propTypes2.default.func
	} : {};
	
	ExpansionPanelSummary.defaultProps = {
	  disabled: false
	};
	
	ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelSummary' })(ExpansionPanelSummary);

/***/ }),
/* 5562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExpansionPanel = __webpack_require__(5558);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpansionPanel).default;
	  }
	});
	
	var _ExpansionPanelActions = __webpack_require__(5559);
	
	Object.defineProperty(exports, 'ExpansionPanelActions', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpansionPanelActions).default;
	  }
	});
	
	var _ExpansionPanelDetails = __webpack_require__(5560);
	
	Object.defineProperty(exports, 'ExpansionPanelDetails', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpansionPanelDetails).default;
	  }
	});
	
	var _ExpansionPanelSummary = __webpack_require__(5561);
	
	Object.defineProperty(exports, 'ExpansionPanelSummary', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpansionPanelSummary).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(326);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      cursor: 'pointer',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      marginLeft: -14,
	      marginRight: theme.spacing.unit * 2 // used for row presentation of radio/checkbox
	    },
	    disabled: {
	      color: theme.palette.text.disabled,
	      cursor: 'default'
	    },
	    label: {}
	  };
	};
	
	/**
	 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
	 * Use this component if you want to display an extra label.
	 */
	/* eslint-disable jsx-a11y/label-has-for */
	
	function FormControlLabel(props, context) {
	  var checked = props.checked,
	      classes = props.classes,
	      classNameProp = props.className,
	      control = props.control,
	      disabledProp = props.disabled,
	      inputRef = props.inputRef,
	      label = props.label,
	      name = props.name,
	      onChange = props.onChange,
	      value = props.value,
	      other = (0, _objectWithoutProperties3.default)(props, ['checked', 'classes', 'className', 'control', 'disabled', 'inputRef', 'label', 'name', 'onChange', 'value']);
	  var muiFormControl = context.muiFormControl;
	
	  var disabled = disabledProp;
	
	  if (typeof control.props.disabled !== 'undefined') {
	    if (typeof disabled === 'undefined') {
	      disabled = control.props.disabled;
	    }
	  }
	
	  if (muiFormControl) {
	    if (typeof disabled === 'undefined') {
	      disabled = muiFormControl.disabled;
	    }
	  }
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp);
	
	  return _react2.default.createElement(
	    'label',
	    (0, _extends3.default)({ className: className }, other),
	    _react2.default.cloneElement(control, {
	      disabled: disabled,
	      checked: typeof control.props.checked === 'undefined' ? checked : control.props.checked,
	      name: control.props.name || name,
	      onChange: control.props.onChange || onChange,
	      value: control.props.value || value,
	      inputRef: control.props.inputRef || inputRef
	    }),
	    _react2.default.createElement(
	      _Typography2.default,
	      { component: 'span', className: classes.label },
	      label
	    )
	  );
	}
	
	FormControlLabel.propTypes =  false ? {
	  /**
	   * If `true`, the component appears selected.
	   */
	  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
	   */
	  control: _propTypes2.default.element,
	  /**
	   * If `true`, the control will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes2.default.func,
	  /**
	   * The text to be used in an enclosing label element.
	   */
	  label: _propTypes2.default.node,
	  /*
	   * @ignore
	   */
	  name: _propTypes2.default.string,
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * The value of the component.
	   */
	  value: _propTypes2.default.string
	} : {};
	
	FormControlLabel.contextTypes = {
	  muiFormControl: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormControlLabel' })(FormControlLabel);

/***/ }),
/* 5564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      color: theme.palette.text.secondary,
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: 1,
	      padding: 0
	    },
	    focused: {
	      color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
	    },
	    error: {
	      color: theme.palette.error.main
	    },
	    disabled: {
	      color: theme.palette.text.disabled
	    }
	  };
	};
	
	function FormLabel(props, context) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      disabledProp = props.disabled,
	      errorProp = props.error,
	      focusedProp = props.focused,
	      requiredProp = props.required,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'component', 'disabled', 'error', 'focused', 'required']);
	  var muiFormControl = context.muiFormControl;
	
	
	  var required = requiredProp;
	  var focused = focusedProp;
	  var disabled = disabledProp;
	  var error = errorProp;
	
	  if (muiFormControl) {
	    if (typeof required === 'undefined') {
	      required = muiFormControl.required;
	    }
	    if (typeof focused === 'undefined') {
	      focused = muiFormControl.focused;
	    }
	    if (typeof disabled === 'undefined') {
	      disabled = muiFormControl.disabled;
	    }
	    if (typeof error === 'undefined') {
	      error = muiFormControl.error;
	    }
	  }
	
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.focused, focused), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), _classNames), classNameProp);
	
	  var asteriskClassName = (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.error, error));
	
	  return _react2.default.createElement(
	    Component,
	    (0, _extends3.default)({ className: className }, other),
	    children,
	    required && _react2.default.createElement(
	      'span',
	      { className: asteriskClassName },
	      '\u2009*'
	    )
	  );
	}
	
	FormLabel.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the label should be displayed in a disabled state.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * If `true`, the input of this label is focused (used by `FormGroup` components).
	   */
	  focused: _propTypes2.default.bool,
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes2.default.bool
	} : {};
	
	FormLabel.defaultProps = {
	  component: 'label'
	};
	
	FormLabel.contextTypes = {
	  muiFormControl: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormLabel' })(FormLabel);

/***/ }),
/* 5565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _createBreakpoints = __webpack_require__(736);
	
	var _requirePropFactory = __webpack_require__(5683);
	
	var _requirePropFactory2 = _interopRequireDefault(_requirePropFactory);
	
	var _Hidden = __webpack_require__(2368);
	
	var _Hidden2 = _interopRequireDefault(_Hidden);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GUTTERS = [0, 8, 16, 24, 40]; // A grid component using the following libs as inspiration.
	//
	// For the implementation:
	// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
	// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
	// - https://github.com/roylee0704/react-flexbox-grid
	// - https://material.angularjs.org/latest/layout/introduction
	//
	// Follow this flexbox Guide to better understand the underlying model:
	// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
	
	var GRID_SIZES = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	
	function generateGrid(globalStyles, theme, breakpoint) {
	  // For the auto layouting
	  var styles = (0, _defineProperty3.default)({}, 'grid-' + breakpoint, {
	    flexBasis: 0,
	    flexGrow: 1,
	    maxWidth: '100%'
	  });
	
	  GRID_SIZES.forEach(function (size) {
	    if (typeof size === 'boolean') {
	      // Skip the first one as handle above.
	      return;
	    }
	
	    // Only keep 6 significant numbers.
	    var width = Math.round(size / 12 * Math.pow(10, 6)) / Math.pow(10, 4) + '%';
	
	    /* eslint-disable max-len */
	    // Close to the bootstrap implementation:
	    // https://github.com/twbs/bootstrap/blob/b0508a975d711d6b24c01f57dd5445c22699fac4/scss/mixins/_grid.scss#L69
	    /* eslint-enable max-len */
	    styles['grid-' + breakpoint + '-' + size] = {
	      flexBasis: width,
	      maxWidth: width
	    };
	  });
	
	  // No need for a media query for the first size.
	  if (breakpoint === 'xs') {
	    (0, _extends3.default)(globalStyles, styles);
	  } else {
	    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
	  }
	}
	
	function generateGutter(theme, breakpoint) {
	  var styles = {};
	
	  GUTTERS.forEach(function (spacing, index) {
	    if (index === 0) {
	      // Skip the default style.
	      return;
	    }
	
	    styles['spacing-' + breakpoint + '-' + spacing] = {
	      margin: -spacing / 2,
	      width: 'calc(100% + ' + spacing + 'px)',
	      '& > $typeItem': {
	        padding: spacing / 2
	      }
	    };
	  });
	
	  return styles;
	}
	
	// Default CSS values
	// flex: '0 1 auto',
	// flexDirection: 'row',
	// alignItems: 'flex-start',
	// flexWrap: 'nowrap',
	// justifyContent: 'flex-start',
	var styles = exports.styles = function styles(theme) {
	  return (0, _extends3.default)({
	    typeContainer: {
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexWrap: 'wrap',
	      width: '100%'
	    },
	    typeItem: {
	      boxSizing: 'border-box',
	      flex: '0 0 auto',
	      margin: '0' // For instance, it's useful when used with a `figure` element.
	    },
	    zeroMinWidth: {
	      minWidth: 0
	    },
	    'direction-xs-column': {
	      flexDirection: 'column'
	    },
	    'direction-xs-column-reverse': {
	      flexDirection: 'column-reverse'
	    },
	    'direction-xs-row-reverse': {
	      flexDirection: 'row-reverse'
	    },
	    'wrap-xs-nowrap': {
	      flexWrap: 'nowrap'
	    },
	    'wrap-xs-wrap-reverse': {
	      flexWrap: 'wrap-reverse'
	    },
	    'align-items-xs-center': {
	      alignItems: 'center'
	    },
	    'align-items-xs-flex-start': {
	      alignItems: 'flex-start'
	    },
	    'align-items-xs-flex-end': {
	      alignItems: 'flex-end'
	    },
	    'align-items-xs-baseline': {
	      alignItems: 'baseline'
	    },
	    'align-content-xs-center': {
	      alignContent: 'center'
	    },
	    'align-content-xs-flex-start': {
	      alignContent: 'flex-start'
	    },
	    'align-content-xs-flex-end': {
	      alignContent: 'flex-end'
	    },
	    'align-content-xs-space-between': {
	      alignContent: 'space-between'
	    },
	    'align-content-xs-space-around': {
	      alignContent: 'space-around'
	    },
	    'justify-xs-center': {
	      justifyContent: 'center'
	    },
	    'justify-xs-flex-end': {
	      justifyContent: 'flex-end'
	    },
	    'justify-xs-space-between': {
	      justifyContent: 'space-between'
	    },
	    'justify-xs-space-around': {
	      justifyContent: 'space-around'
	    }
	  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
	    // Use side effect over immutability for better performance.
	    generateGrid(accumulator, theme, key);
	    return accumulator;
	  }, {}));
	};
	
	function Grid(props) {
	  var _classNames;
	
	  var alignContent = props.alignContent,
	      alignItems = props.alignItems,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      container = props.container,
	      direction = props.direction,
	      hidden = props.hidden,
	      item = props.item,
	      justify = props.justify,
	      lg = props.lg,
	      md = props.md,
	      zeroMinWidth = props.zeroMinWidth,
	      sm = props.sm,
	      spacing = props.spacing,
	      wrap = props.wrap,
	      xl = props.xl,
	      xs = props.xs,
	      other = (0, _objectWithoutProperties3.default)(props, ['alignContent', 'alignItems', 'classes', 'className', 'component', 'container', 'direction', 'hidden', 'item', 'justify', 'lg', 'md', 'zeroMinWidth', 'sm', 'spacing', 'wrap', 'xl', 'xs']);
	
	
	  var className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.typeContainer, container), (0, _defineProperty3.default)(_classNames, classes.typeItem, item), (0, _defineProperty3.default)(_classNames, classes.zeroMinWidth, zeroMinWidth), (0, _defineProperty3.default)(_classNames, classes['spacing-xs-' + String(spacing)], container && spacing !== 0), (0, _defineProperty3.default)(_classNames, classes['direction-xs-' + String(direction)], direction !== Grid.defaultProps.direction), (0, _defineProperty3.default)(_classNames, classes['wrap-xs-' + String(wrap)], wrap !== Grid.defaultProps.wrap), (0, _defineProperty3.default)(_classNames, classes['align-items-xs-' + String(alignItems)], alignItems !== Grid.defaultProps.alignItems), (0, _defineProperty3.default)(_classNames, classes['align-content-xs-' + String(alignContent)], alignContent !== Grid.defaultProps.alignContent), (0, _defineProperty3.default)(_classNames, classes['justify-xs-' + String(justify)], justify !== Grid.defaultProps.justify), (0, _defineProperty3.default)(_classNames, classes['grid-xs'], xs === true), (0, _defineProperty3.default)(_classNames, classes['grid-xs-' + String(xs)], xs && xs !== true), (0, _defineProperty3.default)(_classNames, classes['grid-sm'], sm === true), (0, _defineProperty3.default)(_classNames, classes['grid-sm-' + String(sm)], sm && sm !== true), (0, _defineProperty3.default)(_classNames, classes['grid-md'], md === true), (0, _defineProperty3.default)(_classNames, classes['grid-md-' + String(md)], md && md !== true), (0, _defineProperty3.default)(_classNames, classes['grid-lg'], lg === true), (0, _defineProperty3.default)(_classNames, classes['grid-lg-' + String(lg)], lg && lg !== true), (0, _defineProperty3.default)(_classNames, classes['grid-xl'], xl === true), (0, _defineProperty3.default)(_classNames, classes['grid-xl-' + String(xl)], xl && xl !== true), _classNames), classNameProp);
	  var gridProps = (0, _extends3.default)({ className: className }, other);
	
	  if (hidden) {
	    return _react2.default.createElement(
	      _Hidden2.default,
	      hidden,
	      _react2.default.createElement(Component, gridProps)
	    );
	  }
	
	  return _react2.default.createElement(Component, gridProps);
	}
	
	Grid.propTypes =  false ? {
	  /**
	   * Defines the `align-content` style property.
	   * It's applied for all screen sizes.
	   */
	  alignContent: _propTypes2.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
	  /**
	   * Defines the `align-items` style property.
	   * It's applied for all screen sizes.
	   */
	  alignItems: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the component will have the flex *container* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  container: _propTypes2.default.bool,
	  /**
	   * Defines the `flex-direction` style property.
	   * It is applied for all screen sizes.
	   */
	  direction: _propTypes2.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	  /**
	   * If provided, will wrap with [Hidden](/api/hidden) component and given properties.
	   */
	  hidden: _propTypes2.default.object,
	  /**
	   * If `true`, the component will have the flex *item* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  item: _propTypes2.default.bool,
	  /**
	   * Defines the `justify-content` style property.
	   * It is applied for all screen sizes.
	   */
	  justify: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `lg` breakpoint and wider screens if not overridden.
	   */
	  lg: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `md` breakpoint and wider screens if not overridden.
	   */
	  md: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `sm` breakpoint and wider screens if not overridden.
	   */
	  sm: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	  /**
	   * Defines the space between the type `item` component.
	   * It can only be used on a type `container` component.
	   */
	  spacing: _propTypes2.default.oneOf(GUTTERS),
	  /**
	   * Defines the `flex-wrap` style property.
	   * It's applied for all screen sizes.
	   */
	  wrap: _propTypes2.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `xl` breakpoint and wider screens.
	   */
	  xl: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for all the screen sizes with the lowest priority.
	   */
	  xs: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	  /**
	   * If `true`, it sets `min-width: 0` on the item.
	   * Refer to the limitations section of the documentation to better understand the use case.
	   */
	  zeroMinWidth: _propTypes2.default.bool
	} : {};
	
	Grid.defaultProps = {
	  alignContent: 'stretch',
	  alignItems: 'stretch',
	  component: 'div',
	  container: false,
	  direction: 'row',
	  item: false,
	  justify: 'flex-start',
	  zeroMinWidth: false,
	  spacing: 16,
	  wrap: 'wrap'
	};
	
	// Add a wrapper component to generate some helper messages in the development
	// environment.
	/* eslint-disable react/no-multi-comp */
	// eslint-disable-next-line import/no-mutable-exports
	var GridWrapper = Grid;
	
	if (false) {
	  GridWrapper = function GridWrapper(props) {
	    return _react2.default.createElement(Grid, props);
	  };
	
	  var requireProp = (0, _requirePropFactory2.default)('Grid');
	  GridWrapper.propTypes = {
	    alignContent: requireProp('container'),
	    alignItems: requireProp('container'),
	    direction: requireProp('container'),
	    justify: requireProp('container'),
	    lg: requireProp('item'),
	    md: requireProp('item'),
	    sm: requireProp('item'),
	    spacing: requireProp('container'),
	    wrap: requireProp('container'),
	    xs: requireProp('item'),
	    zeroMinWidth: requireProp('zeroMinWidth')
	  };
	}
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGrid' })(GridWrapper);

/***/ }),
/* 5566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Grid = __webpack_require__(5565);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  root: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    overflowY: 'auto',
	    listStyle: 'none',
	    padding: 0,
	    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	  }
	};
	
	function GridList(props) {
	  var cellHeight = props.cellHeight,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      cols = props.cols,
	      Component = props.component,
	      spacing = props.spacing,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['cellHeight', 'children', 'classes', 'className', 'cols', 'component', 'spacing', 'style']);
	
	
	  return _react2.default.createElement(
	    Component,
	    (0, _extends3.default)({
	      className: (0, _classnames2.default)(classes.root, classNameProp),
	      style: (0, _extends3.default)({ margin: -spacing / 2 }, style)
	    }, other),
	    _react2.default.Children.map(children, function (currentChild) {
	      var childCols = currentChild.props.cols || 1;
	      var childRows = currentChild.props.rows || 1;
	
	      return _react2.default.cloneElement(currentChild, {
	        style: (0, _extends3.default)({
	          width: 100 / cols * childCols + '%',
	          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
	          padding: spacing / 2
	        }, currentChild.props.style)
	      });
	    })
	  );
	}
	
	GridList.propTypes =  false ? {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Number of px for the spacing between tiles.
	   */
	  spacing: _propTypes2.default.number,
	  /**
	   * @ignore
	   */
	  style: _propTypes2.default.object
	} : {};
	
	GridList.defaultProps = {
	  cellHeight: 180,
	  cols: 2,
	  component: 'ul',
	  spacing: 4
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGridList' })(GridList);

/***/ }),
/* 5568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _debounce = __webpack_require__(469);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  root: {
	    boxSizing: 'border-box',
	    flexShrink: 0
	  },
	  tile: {
	    position: 'relative',
	    display: 'block', // In case it's not renderd with a div.
	    height: '100%',
	    overflow: 'hidden'
	  },
	  imgFullHeight: {
	    height: '100%',
	    transform: 'translateX(-50%)',
	    position: 'relative',
	    left: '50%'
	  },
	  imgFullWidth: {
	    width: '100%',
	    position: 'relative',
	    transform: 'translateY(-50%)',
	    top: '50%'
	  }
	};
	
	var GridListTile = function (_React$Component) {
	  (0, _inherits3.default)(GridListTile, _React$Component);
	
	  function GridListTile() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, GridListTile);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GridListTile.__proto__ || (0, _getPrototypeOf2.default)(GridListTile)).call.apply(_ref, [this].concat(args))), _this), _this.imgElement = null, _this.handleResize = (0, _debounce2.default)(function () {
	      _this.fit();
	    }, 166), _this.fit = function () {
	      var imgElement = _this.imgElement;
	
	      if (!imgElement) {
	        return;
	      }
	
	      if (!imgElement.complete) {
	        return;
	      }
	
	      if (imgElement.width / imgElement.height > imgElement.parentNode.offsetWidth / imgElement.parentNode.offsetHeight) {
	        var _imgElement$classList, _imgElement$classList2;
	
	        (_imgElement$classList = imgElement.classList).remove.apply(_imgElement$classList, (0, _toConsumableArray3.default)(_this.props.classes.imgFullWidth.split(' ')));
	        (_imgElement$classList2 = imgElement.classList).add.apply(_imgElement$classList2, (0, _toConsumableArray3.default)(_this.props.classes.imgFullHeight.split(' ')));
	      } else {
	        var _imgElement$classList3, _imgElement$classList4;
	
	        (_imgElement$classList3 = imgElement.classList).remove.apply(_imgElement$classList3, (0, _toConsumableArray3.default)(_this.props.classes.imgFullHeight.split(' ')));
	        (_imgElement$classList4 = imgElement.classList).add.apply(_imgElement$classList4, (0, _toConsumableArray3.default)(_this.props.classes.imgFullWidth.split(' ')));
	      }
	
	      imgElement.removeEventListener('load', _this.fit);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(GridListTile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	    }
	  }, {
	    key: 'ensureImageCover',
	    value: function ensureImageCover() {
	      if (!this.imgElement) {
	        return;
	      }
	
	      if (this.imgElement.complete) {
	        this.fit();
	      } else {
	        this.imgElement.addEventListener('load', this.fit);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          cols = _props.cols,
	          Component = _props.component,
	          rows = _props.rows,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'cols', 'component', 'rows']);
	
	
	      return _react2.default.createElement(
	        Component,
	        (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement(
	          'div',
	          { className: classes.tile },
	          _react2.default.Children.map(children, function (child) {
	            if (child.type === 'img') {
	              return _react2.default.cloneElement(child, {
	                key: 'img',
	                ref: function ref(node) {
	                  _this2.imgElement = node;
	                }
	              });
	            }
	
	            return child;
	          })
	        )
	      );
	    }
	  }]);
	  return GridListTile;
	}(_react2.default.Component);
	
	GridListTile.propTypes =  false ? {
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in which case GridListTile takes care of making the image "cover" available space
	   * (similar to `background-size: cover` or to `object-fit: cover`).
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes2.default.number
	} : {};
	
	GridListTile.defaultProps = {
	  cols: 1,
	  component: 'li',
	  rows: 1
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGridListTile' })(GridListTile);

/***/ }),
/* 5569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: 48,
	      background: 'rgba(0, 0, 0, 0.4)',
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: theme.typography.fontFamily
	    },
	    rootBottom: {
	      bottom: 0
	    },
	    rootTop: {
	      top: 0
	    },
	    rootWithSubtitle: {
	      height: 68
	    },
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: theme.mixins.gutters({}).paddingLeft,
	      marginRight: theme.mixins.gutters({}).paddingRight,
	      color: theme.palette.common.white,
	      overflow: 'hidden'
	    },
	    titleWrapActionLeft: {
	      marginLeft: 0
	    },
	    titleWrapActionRight: {
	      marginRight: 0
	    },
	    title: {
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '24px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1,
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIconPositionLeft: {
	      order: -1
	    },
	    childImg: {
	      height: '100%',
	      transform: 'translateX(-50%)',
	      position: 'relative',
	      left: '50%'
	    }
	  };
	};
	
	function GridListTileBar(props) {
	  var _classNames, _classNames2;
	
	  var actionIcon = props.actionIcon,
	      actionPosition = props.actionPosition,
	      classes = props.classes,
	      classNameProp = props.className,
	      subtitle = props.subtitle,
	      title = props.title,
	      titlePosition = props.titlePosition,
	      other = (0, _objectWithoutProperties3.default)(props, ['actionIcon', 'actionPosition', 'classes', 'className', 'subtitle', 'title', 'titlePosition']);
	
	
	  var actionPos = actionIcon && actionPosition;
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.rootBottom, titlePosition === 'bottom'), (0, _defineProperty3.default)(_classNames, classes.rootTop, titlePosition === 'top'), (0, _defineProperty3.default)(_classNames, classes.rootWithSubtitle, subtitle), _classNames), classNameProp);
	
	  // Remove the margin between the title / subtitle wrapper, and the Action Icon
	  var titleWrapClassName = (0, _classnames2.default)(classes.titleWrap, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.titleWrapActionLeft, actionPos === 'left'), (0, _defineProperty3.default)(_classNames2, classes.titleWrapActionRight, actionPos === 'right'), _classNames2));
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: className }, other),
	    _react2.default.createElement(
	      'div',
	      { className: titleWrapClassName },
	      _react2.default.createElement(
	        'div',
	        { className: classes.title },
	        title
	      ),
	      subtitle ? _react2.default.createElement(
	        'div',
	        { className: classes.subtitle },
	        subtitle
	      ) : null
	    ),
	    actionIcon ? _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.actionIconPositionLeft, actionPos === 'left')) },
	      actionIcon
	    ) : null
	  );
	}
	
	GridListTileBar.propTypes =  false ? {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes2.default.node,
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Position of the title bar.
	   */
	  titlePosition: _propTypes2.default.oneOf(['top', 'bottom'])
	} : {};
	
	GridListTileBar.defaultProps = {
	  actionPosition: 'right',
	  titlePosition: 'bottom'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGridListTileBar' })(GridListTileBar);

/***/ }),
/* 5570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _GridList = __webpack_require__(5567);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridList).default;
	  }
	});
	
	var _GridListTile = __webpack_require__(5568);
	
	Object.defineProperty(exports, 'GridListTile', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridListTile).default;
	  }
	});
	
	var _GridListTileBar = __webpack_require__(5569);
	
	Object.defineProperty(exports, 'GridListTileBar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridListTileBar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _HiddenJs = __webpack_require__(5573);
	
	var _HiddenJs2 = _interopRequireDefault(_HiddenJs);
	
	var _HiddenCss = __webpack_require__(5572);
	
	var _HiddenCss2 = _interopRequireDefault(_HiddenCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Responsively hides children based on the selected implementation.
	 */
	function Hidden(props) {
	  var implementation = props.implementation,
	      other = (0, _objectWithoutProperties3.default)(props, ['implementation']);
	
	
	  if (implementation === 'js') {
	    return _react2.default.createElement(_HiddenJs2.default, other);
	  }
	
	  return _react2.default.createElement(_HiddenCss2.default, other);
	}
	
	Hidden.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for server
	   * side rendering.
	   */
	  implementation: _propTypes2.default.oneOf(['js', 'css']),
	  /**
	   * You can use this property when choosing the `js` implementation with server side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty componenent during the first mount.
	   * In some situation you might want to use an heristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * http://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes2.default.bool,
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  smDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  smUp: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes2.default.bool
	} : {};
	
	Hidden.defaultProps = {
	  implementation: 'js',
	  lgDown: false,
	  lgUp: false,
	  mdDown: false,
	  mdUp: false,
	  smDown: false,
	  smUp: false,
	  xlDown: false,
	  xlUp: false,
	  xsDown: false,
	  xsUp: false
	};
	
	exports.default = Hidden;

/***/ }),
/* 5572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _createBreakpoints = __webpack_require__(736);
	
	var _helpers = __webpack_require__(127);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var hidden = {
	    display: 'none'
	  };
	
	  return _createBreakpoints.keys.reduce(function (acc, key) {
	    acc['only' + (0, _helpers.capitalize)(key)] = (0, _defineProperty3.default)({}, theme.breakpoints.only(key), hidden);
	    acc[key + 'Up'] = (0, _defineProperty3.default)({}, theme.breakpoints.up(key), hidden);
	    acc[key + 'Down'] = (0, _defineProperty3.default)({}, theme.breakpoints.down(key), hidden);
	
	    return acc;
	  }, {});
	};
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenCss(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      lgDown = props.lgDown,
	      lgUp = props.lgUp,
	      mdDown = props.mdDown,
	      mdUp = props.mdUp,
	      only = props.only,
	      smDown = props.smDown,
	      smUp = props.smUp,
	      xlDown = props.xlDown,
	      xlUp = props.xlUp,
	      xsDown = props.xsDown,
	      xsUp = props.xsUp,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'lgDown', 'lgUp', 'mdDown', 'mdUp', 'only', 'smDown', 'smUp', 'xlDown', 'xlUp', 'xsDown', 'xsUp']);
	
	
	   false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0 || (0, _keys2.default)(other).length === 1 && other.hasOwnProperty('ref'), 'Material-UI: unsupported properties received ' + (0, _keys2.default)(other).join(', ') + ' by `<Hidden />`.') : void 0;
	
	  var classNames = [];
	
	  if (className) {
	    classNames.push(className);
	  }
	
	  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
	    var breakpoint = _createBreakpoints.keys[i];
	    var breakpointUp = props[breakpoint + 'Up'];
	    var breakpointDown = props[breakpoint + 'Down'];
	
	    if (breakpointUp) {
	      classNames.push(classes[breakpoint + 'Up']);
	    }
	    if (breakpointDown) {
	      classNames.push(classes[breakpoint + 'Down']);
	    }
	  }
	
	  if (only) {
	    var onlyBreakpoints = Array.isArray(only) ? only : [only];
	    onlyBreakpoints.forEach(function (breakpoint) {
	      classNames.push(classes['only' + (0, _helpers.capitalize)(breakpoint)]);
	    });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: classNames.join(' ') },
	    children
	  );
	}
	
	HiddenCss.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for server
	   * side rendering.
	   */
	  implementation: _propTypes2.default.oneOf(['js', 'css']),
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes2.default.bool,
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  smDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  smUp: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes2.default.bool
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiHiddenCss' })(HiddenCss);

/***/ }),
/* 5573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBreakpoints = __webpack_require__(736);
	
	var _withWidth = __webpack_require__(1575);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _exactProp = __webpack_require__(738);
	
	var _exactProp2 = _interopRequireDefault(_exactProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenJs(props) {
	  var children = props.children,
	      only = props.only,
	      width = props.width;
	
	
	  var visible = true;
	
	  // `only` check is faster to get out sooner if used.
	  if (only) {
	    if (Array.isArray(only)) {
	      for (var i = 0; i < only.length; i += 1) {
	        var breakpoint = only[i];
	        if (width === breakpoint) {
	          visible = false;
	          break;
	        }
	      }
	    } else if (only && width === only) {
	      visible = false;
	    }
	  }
	
	  // Allow `only` to be combined with other props. If already hidden, no need to check others.
	  if (visible) {
	    // determine visibility based on the smallest size up
	    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
	      var _breakpoint = _createBreakpoints.keys[_i];
	      var breakpointUp = props[_breakpoint + 'Up'];
	      var breakpointDown = props[_breakpoint + 'Down'];
	      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
	        visible = false;
	        break;
	      }
	    }
	  }
	
	  if (!visible) {
	    return null;
	  }
	
	  return children;
	}
	
	HiddenJs.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for server
	   * side rendering.
	   */
	  implementation: _propTypes2.default.oneOf(['js', 'css']),
	  /**
	   * You can use this property when choosing the `js` implementation with server side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty componenent during the first mount.
	   * In some situation you might want to use an heristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * http://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes2.default.bool,
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  smDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  smUp: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * width prop provided by withWidth decorator.
	   */
	  width: _propTypes2.default.string.isRequired,
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes2.default.bool,
	  /**
	   * If true, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes2.default.bool
	};
	
	HiddenJs.propTypes = (0, _exactProp2.default)(HiddenJs.propTypes, 'HiddenJs');
	
	exports.default = (0, _withWidth2.default)()(HiddenJs);

/***/ }),
/* 5574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      userSelect: 'none'
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	    colorAction: {
	      color: theme.palette.action.active
	    },
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	    colorError: {
	      color: theme.palette.error.main
	    },
	    fontSize: {
	      width: '1em',
	      height: '1em'
	    }
	  };
	};
	
	function Icon(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      fontSize = props.fontSize,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'fontSize']);
	
	
	  var className = (0, _classnames2.default)('material-icons', classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), (0, _defineProperty3.default)(_classNames, classes.fontSize, fontSize), _classNames), classNameProp);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ className: className, 'aria-hidden': 'true' }, other),
	    children
	  );
	}
	
	Icon.propTypes =  false ? {
	  /**
	   * The name of the icon font ligature.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes2.default.oneOf(['inherit', 'secondary', 'action', 'disabled', 'error', 'primary']),
	  /**
	   * If `true`, the icon size will be determined by the font-size.
	   */
	  fontSize: _propTypes2.default.bool
	} : {};
	
	Icon.defaultProps = {
	  color: 'inherit',
	  fontSize: false
	};
	
	Icon.muiName = 'Icon';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIcon' })(Icon);

/***/ }),
/* 5575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Icon = __webpack_require__(5574);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ButtonBase = __webpack_require__(278);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	var _helpers = __webpack_require__(127);
	
	var _reactHelpers = __webpack_require__(327);
	
	__webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Ensure CSS specificity
	
	// @inheritedComponent ButtonBase
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      width: theme.spacing.unit * 6,
	      height: theme.spacing.unit * 6,
	      padding: 0,
	      borderRadius: '50%',
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      })
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	    disabled: {
	      color: theme.palette.action.disabled
	    },
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	
	/**
	 * Refer to the [Icons](/style/icons) section of the documentation
	 * regarding the available icon options.
	 */
	function IconButton(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      disabled = props.disabled,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'disabled']);
	
	
	  return _react2.default.createElement(
	    _ButtonBase2.default,
	    (0, _extends3.default)({
	      className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), className),
	      centerRipple: true,
	      focusRipple: true,
	      disabled: disabled
	    }, other),
	    _react2.default.createElement(
	      'span',
	      { className: classes.label },
	      _react2.default.Children.map(children, function (child) {
	        if ((0, _reactHelpers.isMuiElement)(child, ['Icon', 'SvgIcon'])) {
	          return _react2.default.cloneElement(child, { fontSize: true });
	        }
	        return child;
	      })
	    )
	  );
	}
	
	IconButton.propTypes =  false ? {
	  /**
	   * The icon element.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes2.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the ripple will be disabled.
	   */
	  disableRipple: _propTypes2.default.bool
	} : {};
	
	IconButton.defaultProps = {
	  color: 'default',
	  disabled: false,
	  disableRipple: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIconButton' })(IconButton);

/***/ }),
/* 5577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Typography = __webpack_require__(326);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      maxHeight: '2em',
	      alignItems: 'center'
	    },
	    positionStart: {
	      marginRight: theme.spacing.unit
	    },
	    positionEnd: {
	      marginLeft: theme.spacing.unit
	    }
	  };
	};
	
	function InputAdornment(props) {
	  var _classNames;
	
	  var children = props.children,
	      Component = props.component,
	      classes = props.classes,
	      className = props.className,
	      disableTypography = props.disableTypography,
	      position = props.position,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'component', 'classes', 'className', 'disableTypography', 'position']);
	
	
	  return _react2.default.createElement(
	    Component,
	    (0, _extends3.default)({
	      className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty3.default)(_classNames, classes.positionEnd, position === 'end'), _classNames), className)
	    }, other),
	    typeof children === 'string' && !disableTypography ? _react2.default.createElement(
	      _Typography2.default,
	      { color: 'textSecondary' },
	      children
	    ) : children
	  );
	}
	
	InputAdornment.propTypes =  false ? {
	  /**
	   * The content of the component, normally an `IconButton` or string.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If children is a string then disable wrapping in a Typography component.
	   */
	  disableTypography: _propTypes2.default.bool,
	  /**
	   * The position this adornment should appear relative to the `Input`.
	   */
	  position: _propTypes2.default.oneOf(['start', 'end'])
	} : {};
	
	InputAdornment.defaultProps = {
	  component: 'div',
	  disableTypography: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInputAdornment' })(InputAdornment);

/***/ }),
/* 5578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Form = __webpack_require__(2367);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      transformOrigin: 'top left'
	    },
	    formControl: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      // slight alteration to spec spacing to match visual spec result
	      transform: 'translate(0, ' + theme.spacing.unit * 3 + 'px) scale(1)'
	    },
	    labelDense: {
	      // Compensation for the `Input.inputDense` style.
	      transform: 'translate(0, ' + (theme.spacing.unit * 2.5 + 1) + 'px) scale(1)'
	    },
	    shrink: {
	      transform: 'translate(0, 1.5px) scale(0.75)',
	      transformOrigin: 'top left'
	    },
	    animated: {
	      transition: theme.transitions.create('transform', {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	    disabled: {
	      color: theme.palette.text.disabled
	    }
	  };
	};
	
	function InputLabel(props, context) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableAnimation = props.disableAnimation,
	      disabled = props.disabled,
	      FormControlClasses = props.FormControlClasses,
	      marginProp = props.margin,
	      shrinkProp = props.shrink,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableAnimation', 'disabled', 'FormControlClasses', 'margin', 'shrink']);
	  var muiFormControl = context.muiFormControl;
	
	  var shrink = shrinkProp;
	
	  if (typeof shrink === 'undefined' && muiFormControl) {
	    shrink = muiFormControl.dirty || muiFormControl.focused || muiFormControl.adornedStart;
	  }
	
	  var margin = marginProp;
	  if (typeof margin === 'undefined' && muiFormControl) {
	    margin = muiFormControl.margin;
	  }
	
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty3.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty3.default)(_classNames, classes.shrink, shrink), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.labelDense, margin === 'dense'), _classNames), classNameProp);
	
	  return _react2.default.createElement(
	    _Form.FormLabel,
	    (0, _extends3.default)({ 'data-shrink': shrink, className: className, classes: FormControlClasses }, other),
	    children
	  );
	}
	
	InputLabel.propTypes =  false ? {
	  /**
	   * The contents of the `InputLabel`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the transition animation is disabled.
	   */
	  disableAnimation: _propTypes2.default.bool,
	  /**
	   * If `true`, apply disabled class.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * If `true`, the input of this label is focused.
	   */
	  focused: _propTypes2.default.bool,
	  /**
	   * `classes` property applied to the `FormControl` element.
	   */
	  FormControlClasses: _propTypes2.default.object,
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes2.default.oneOf(['dense']),
	  /**
	   * if `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes2.default.bool,
	  /**
	   * If `true`, the label is shrunk.
	   */
	  shrink: _propTypes2.default.bool
	} : {};
	
	InputLabel.defaultProps = {
	  disabled: false,
	  disableAnimation: false
	};
	
	InputLabel.contextTypes = {
	  muiFormControl: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInputLabel' })(InputLabel);

/***/ }),
/* 5579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _debounce = __webpack_require__(469);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROWS_HEIGHT = 24;
	
	var styles = exports.styles = {
	  root: {
	    position: 'relative', // because the shadow has position: 'absolute',
	    width: '100%'
	  },
	  textarea: {
	    width: '100%',
	    height: '100%',
	    resize: 'none',
	    font: 'inherit',
	    padding: 0,
	    cursor: 'inherit',
	    boxSizing: 'border-box',
	    lineHeight: 'inherit',
	    border: 'none',
	    outline: 'none',
	    background: 'transparent'
	  },
	  shadow: {
	    resize: 'none',
	    // Overflow also needed to here to remove the extra row
	    // added to textareas in Firefox.
	    overflow: 'hidden',
	    // Visibility needed to hide the extra text area on ipads
	    visibility: 'hidden',
	    position: 'absolute',
	    height: 'auto',
	    whiteSpace: 'pre-wrap'
	  }
	};
	
	/**
	 * @ignore - internal component.
	 */
	
	var Textarea = function (_React$Component) {
	  (0, _inherits3.default)(Textarea, _React$Component);
	
	  function Textarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Textarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Textarea.__proto__ || (0, _getPrototypeOf2.default)(Textarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.shadow = null, _this.singlelineShadow = null, _this.input = null, _this.value = null, _this.handleResize = (0, _debounce2.default)(function (event) {
	      _this.syncHeightWithShadow(event);
	    }, 166), _this.handleRefInput = function (node) {
	      _this.input = node;
	      if (_this.props.textareaRef) {
	        _this.props.textareaRef(node);
	      }
	    }, _this.handleRefSinglelineShadow = function (node) {
	      _this.singlelineShadow = node;
	    }, _this.handleRefShadow = function (node) {
	      _this.shadow = node;
	    }, _this.handleChange = function (event) {
	      _this.value = event.target.value;
	
	      if (typeof _this.props.value === 'undefined' && _this.shadow) {
	        // The component is not controlled, we need to update the shallow value.
	        _this.shadow.value = _this.value;
	        _this.syncHeightWithShadow(event);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Textarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // <Input> expects the components it renders to respond to 'value'
	      // so that it can check whether they are dirty
	      this.value = this.props.value || this.props.defaultValue || '';
	      this.setState({
	        height: Number(this.props.rows) * ROWS_HEIGHT
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow(null);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value || Number(nextProps.rowsMax) !== Number(this.props.rowsMax)) {
	        this.syncHeightWithShadow(null, nextProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(event) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	
	      if (this.shadow && this.singlelineShadow) {
	        // The component is controlled, we need to update the shallow value.
	        if (typeof this.props.value !== 'undefined') {
	          this.shadow.value = props.value == null ? '' : String(props.value);
	        }
	
	        var lineHeight = this.singlelineShadow.scrollHeight;
	        var newHeight = this.shadow.scrollHeight;
	
	        // Guarding for jsdom, where scrollHeight isn't present.
	        // See https://github.com/tmpvar/jsdom/issues/1013
	        if (newHeight === undefined) {
	          return;
	        }
	
	        if (Number(props.rowsMax) >= Number(props.rows)) {
	          newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
	        }
	
	        newHeight = Math.max(newHeight, lineHeight);
	
	        if (this.state.height !== newHeight) {
	          this.setState({
	            height: newHeight
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          className = _props.className,
	          defaultValue = _props.defaultValue,
	          onChange = _props.onChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          textareaRef = _props.textareaRef,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'defaultValue', 'onChange', 'rows', 'rowsMax', 'textareaRef', 'value']);
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes.root, style: { height: this.state.height } },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: this.handleRefSinglelineShadow,
	          className: (0, _classnames2.default)(classes.shadow, classes.textarea),
	          tabIndex: -1,
	          rows: '1',
	          readOnly: true,
	          'aria-hidden': 'true',
	          value: ''
	        }),
	        _react2.default.createElement('textarea', {
	          ref: this.handleRefShadow,
	          className: (0, _classnames2.default)(classes.shadow, classes.textarea),
	          tabIndex: -1,
	          rows: rows,
	          'aria-hidden': 'true',
	          readOnly: true,
	          defaultValue: defaultValue,
	          value: value
	        }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({
	          rows: rows,
	          className: (0, _classnames2.default)(classes.textarea, className),
	          defaultValue: defaultValue,
	          value: value,
	          onChange: this.handleChange,
	          ref: this.handleRefInput
	        }, other))
	      );
	    }
	  }]);
	  return Textarea;
	}(_react2.default.Component);
	
	Textarea.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * @ignore
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Use that property to pass a ref callback to the native textarea element.
	   */
	  textareaRef: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	} : {};
	
	Textarea.defaultProps = {
	  rows: 1
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTextarea' })(Textarea);

/***/ }),
/* 5580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      flex: '1 1 auto',
	      listStyle: 'none',
	      margin: 0,
	      padding: 0,
	      position: 'relative'
	    },
	    padding: {
	      paddingTop: theme.spacing.unit,
	      paddingBottom: theme.spacing.unit
	    },
	    dense: {
	      paddingTop: theme.spacing.unit / 2,
	      paddingBottom: theme.spacing.unit / 2
	    },
	    subheader: {
	      paddingTop: 0
	    }
	  };
	};
	
	var List = function (_React$Component) {
	  (0, _inherits3.default)(List, _React$Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          Component = _props.component,
	          dense = _props.dense,
	          disablePadding = _props.disablePadding,
	          subheader = _props.subheader,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'component', 'dense', 'disablePadding', 'subheader']);
	
	      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty3.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty3.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);
	
	      return _react2.default.createElement(
	        Component,
	        (0, _extends3.default)({ className: className }, other),
	        subheader,
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react2.default.Component);
	
	List.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items. The property is available to descendant components as the
	   * `dense` context.
	   */
	  dense: _propTypes2.default.bool,
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes2.default.bool,
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes2.default.node
	} : {};
	
	List.defaultProps = {
	  component: 'ul',
	  dense: false,
	  disablePadding: false
	};
	
	List.childContextTypes = {
	  dense: _propTypes2.default.bool
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiList' })(List);

/***/ }),
/* 5581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      width: 36,
	      height: 36,
	      fontSize: theme.typography.pxToRem(18),
	      marginRight: 4
	    },
	    icon: {
	      width: 20,
	      height: 20,
	      fontSize: theme.typography.pxToRem(20)
	    }
	  };
	};
	
	/**
	 * It's a simple wrapper to apply the `dense` mode styles to `Avatar`.
	 */
	function ListItemAvatar(props, context) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);
	
	
	  if (context.dense === undefined) {
	     false ? (0, _warning2.default)(false, 'Material-UI: <ListItemAvatar> is a simple wrapper to apply the dense styles\n      to <Avatar>. You do not need it unless you are controlling the <List> dense property.') : void 0;
	    return props.children;
	  }
	
	  return _react2.default.cloneElement(children, (0, _extends3.default)({
	    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.root, context.dense), classNameProp, children.props.className),
	    childrenClassName: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.icon, context.dense), children.props.childrenClassName)
	  }, other));
	}
	
	ListItemAvatar.propTypes =  false ? {
	  /**
	   * The content of the component, normally `Avatar`.
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	ListItemAvatar.contextTypes = {
	  dense: _propTypes2.default.bool
	};
	
	ListItemAvatar.muiName = 'ListItemAvatar';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemAvatar' })(ListItemAvatar);

/***/ }),
/* 5582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      height: 24,
	      marginRight: theme.spacing.unit * 2,
	      width: 24,
	      color: theme.palette.action.active,
	      flexShrink: 0
	    }
	  };
	};
	
	/**
	 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
	 */
	function ListItemIcon(props) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);
	
	
	  return _react2.default.cloneElement(children, (0, _extends3.default)({
	    className: (0, _classnames2.default)(classes.root, classNameProp, children.props.className)
	  }, other));
	}
	
	ListItemIcon.propTypes =  false ? {
	  /**
	   * The content of the component, normally `Icon`, `SvgIcon`,
	   * or a `material-ui-icons` SVG icon component.
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemIcon' })(ListItemIcon);

/***/ }),
/* 5583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      right: 4,
	      top: '50%',
	      marginTop: -theme.spacing.unit * 3
	    }
	  };
	};
	
	function ListItemSecondaryAction(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);
	
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	    children
	  );
	}
	
	ListItemSecondaryAction.propTypes =  false ? {
	  /**
	   * The content of the component, normally an `IconButton` or selection control.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string
	} : {};
	
	ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemSecondaryAction' })(ListItemSecondaryAction);

/***/ }),
/* 5584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(326);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      flex: '1 1 auto',
	      minWidth: 0,
	      padding: '0 16px',
	      '&:first-child': {
	        paddingLeft: 0
	      }
	    },
	    inset: {
	      '&:first-child': {
	        paddingLeft: theme.spacing.unit * 7
	      }
	    },
	    dense: {
	      fontSize: theme.typography.pxToRem(13)
	    },
	    primary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    secondary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    textDense: {}
	  };
	};
	
	function ListItemText(props, context) {
	  var _classNames;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      disableTypography = props.disableTypography,
	      inset = props.inset,
	      primary = props.primary,
	      secondary = props.secondary,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'disableTypography', 'inset', 'primary', 'secondary']);
	  var dense = context.dense;
	
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.dense, dense), (0, _defineProperty3.default)(_classNames, classes.inset, inset), _classNames), classNameProp);
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: className }, other),
	    primary && (disableTypography ? primary : _react2.default.createElement(
	      _Typography2.default,
	      {
	        variant: 'subheading',
	        className: (0, _classnames2.default)(classes.primary, (0, _defineProperty3.default)({}, classes.textDense, dense))
	      },
	      primary
	    )),
	    secondary && (disableTypography ? secondary : _react2.default.createElement(
	      _Typography2.default,
	      {
	        variant: 'body1',
	        className: (0, _classnames2.default)(classes.secondary, (0, _defineProperty3.default)({}, classes.textDense, dense)),
	        color: 'textSecondary'
	      },
	      secondary
	    ))
	  );
	}
	
	ListItemText.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, that can be useful to can render an h4 instead of a
	   */
	  disableTypography: _propTypes2.default.bool,
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes2.default.bool,
	  primary: _propTypes2.default.node,
	  secondary: _propTypes2.default.node
	} : {};
	
	ListItemText.defaultProps = {
	  disableTypography: false,
	  inset: false,
	  primary: false,
	  secondary: false
	};
	
	ListItemText.contextTypes = {
	  dense: _propTypes2.default.bool
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemText' })(ListItemText);

/***/ }),
/* 5585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      boxSizing: 'border-box',
	      lineHeight: '48px',
	      listStyle: 'none',
	      paddingLeft: theme.spacing.unit * 2,
	      paddingRight: theme.spacing.unit * 2,
	      color: theme.palette.text.secondary,
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(theme.typography.fontSize)
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    inset: {
	      paddingLeft: theme.spacing.unit * 9
	    },
	    sticky: {
	      position: 'sticky',
	      top: 0,
	      zIndex: 1,
	      backgroundColor: 'inherit'
	    }
	  };
	};
	
	function ListSubheader(props) {
	  var _classNames;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      Component = props.component,
	      disableSticky = props.disableSticky,
	      inset = props.inset,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'component', 'disableSticky', 'inset']);
	
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.inset, inset), (0, _defineProperty3.default)(_classNames, classes.sticky, !disableSticky), _classNames), classNameProp);
	
	  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
	}
	
	ListSubheader.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes2.default.oneOf(['default', 'primary', 'inherit']),
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the List Subheader will not stick to the top during scroll.
	   */
	  disableSticky: _propTypes2.default.bool,
	  /**
	   * If `true`, the List Subheader will be indented.
	   */
	  inset: _propTypes2.default.bool
	} : {};
	
	ListSubheader.defaultProps = {
	  color: 'default',
	  component: 'li',
	  disableSticky: false,
	  inset: false
	};
	
	ListSubheader.muiName = 'ListSubheader';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListSubheader' })(ListSubheader);

/***/ }),
/* 5586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ListItem = __webpack_require__(2369);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: (0, _extends3.default)({}, theme.typography.subheading, {
	      height: theme.spacing.unit * 3,
	      boxSizing: 'content-box',
	      width: 'auto',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      '&$selected': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&:hover': {
	        backgroundColor: theme.palette.action.hover
	      }
	    }),
	    selected: {}
	  };
	}; // @inheritedComponent ListItem
	
	function MenuItem(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      component = props.component,
	      selected = props.selected,
	      role = props.role,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'selected', 'role']);
	
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.selected, selected), classNameProp);
	
	  return _react2.default.createElement(_ListItem2.default, (0, _extends3.default)({
	    button: true,
	    role: role,
	    tabIndex: -1,
	    className: className,
	    component: component
	  }, other));
	}
	
	MenuItem.propTypes =  false ? {
	  /**
	   * Menu item contents.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * @ignore
	   */
	  role: _propTypes2.default.string,
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes2.default.bool
	} : {};
	
	MenuItem.defaultProps = {
	  component: 'li',
	  role: 'menuitem',
	  selected: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMenuItem' })(MenuItem);

/***/ }),
/* 5587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Paper = __webpack_require__(279);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _helpers = __webpack_require__(127);
	
	var _Progress = __webpack_require__(2376);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      alignItems: 'center',
	      background: theme.palette.background.default,
	      padding: theme.spacing.unit
	    },
	    positionBottom: {
	      position: 'fixed',
	      bottom: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	    positionTop: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	    positionStatic: {},
	    dots: {
	      display: 'flex',
	      flexDirection: 'row'
	    },
	    dot: {
	      backgroundColor: theme.palette.action.disabled,
	      borderRadius: '50%',
	      width: theme.spacing.unit,
	      height: theme.spacing.unit,
	      margin: '0 2px'
	    },
	    dotActive: {
	      backgroundColor: theme.palette.primary.main
	    },
	    progress: {
	      width: '50%'
	    }
	  };
	}; // @inheritedComponent Paper
	
	function MobileStepper(props) {
	  var activeStep = props.activeStep,
	      backButton = props.backButton,
	      classes = props.classes,
	      classNameProp = props.className,
	      nextButton = props.nextButton,
	      position = props.position,
	      steps = props.steps,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties3.default)(props, ['activeStep', 'backButton', 'classes', 'className', 'nextButton', 'position', 'steps', 'variant']);
	
	
	  var className = (0, _classnames2.default)(classes.root, classes['position' + (0, _helpers.capitalize)(position)], classNameProp);
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    (0, _extends3.default)({ square: true, elevation: 0, className: className }, other),
	    backButton,
	    variant === 'dots' && _react2.default.createElement(
	      'div',
	      { className: classes.dots },
	      [].concat((0, _toConsumableArray3.default)(new Array(steps))).map(function (_, step) {
	        var dotClassName = (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.dotActive, step === activeStep), classes.dot);
	        // eslint-disable-next-line react/no-array-index-key
	        return _react2.default.createElement('div', { key: step, className: dotClassName });
	      })
	    ),
	    variant === 'progress' && _react2.default.createElement(
	      'div',
	      { className: classes.progress },
	      _react2.default.createElement(_Progress.LinearProgress, { mode: 'determinate', value: Math.ceil(activeStep / (steps - 1) * 100) })
	    ),
	    nextButton
	  );
	}
	
	MobileStepper.propTypes =  false ? {
	  /**
	   * Set the active step (zero based index).
	   * Defines which dot is highlighted when the variant is 'dots'.
	   */
	  activeStep: _propTypes2.default.number,
	  /**
	   * A back button element. For instance, it can be be a `Button` or a `IconButton`.
	   */
	  backButton: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * A next button element. For instance, it can be be a `Button` or a `IconButton`.
	   */
	  nextButton: _propTypes2.default.node,
	  /**
	   * Set the positioning type.
	   */
	  position: _propTypes2.default.oneOf(['bottom', 'top', 'static']),
	  /**
	   * The total steps.
	   */
	  steps: _propTypes2.default.number.isRequired,
	  /**
	   * The type of mobile stepper to use.
	   */
	  variant: _propTypes2.default.oneOf(['text', 'dots', 'progress'])
	} : {};
	
	MobileStepper.defaultProps = {
	  activeStep: 0,
	  position: 'bottom',
	  variant: 'dots'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMobileStepper' })(MobileStepper);

/***/ }),
/* 5588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MobileStepper = __webpack_require__(5587);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MobileStepper).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _keycode = __webpack_require__(568);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _activeElement = __webpack_require__(2236);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(950);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(951);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _ownerDocument = __webpack_require__(372);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _RefHolder = __webpack_require__(2389);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _Portal = __webpack_require__(2375);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _addEventListener = __webpack_require__(2401);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _helpers = __webpack_require__(127);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ModalManager = __webpack_require__(2374);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Backdrop = __webpack_require__(2373);
	
	var _Backdrop2 = _interopRequireDefault(_Backdrop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	} // @inheritedComponent Portal
	
	function getOwnerDocument(element) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	}
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      width: '100%',
	      height: '100%',
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      top: 0,
	      left: 0
	    },
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3.default)(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props, context));
	
	    _this.dialog = null;
	    _this.mounted = false;
	    _this.mountNode = null;
	
	    _this.handleRendered = function () {
	      _this.autoFocus();
	
	      if (_this.props.onRendered) {
	        _this.props.onRendered();
	      }
	    };
	
	    _this.handleOpen = function () {
	      var doc = getOwnerDocument(_this);
	      var container = getContainer(_this.props.container, doc.body);
	
	      _this.props.manager.add(_this, container);
	      _this.onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this.handleDocumentKeyDown);
	      _this.onFocusinListener = (0, _addEventListener2.default)(document, 'focus', _this.enforceFocus, true);
	    };
	
	    _this.handleClose = function () {
	      _this.props.manager.remove(_this);
	      _this.onDocumentKeydownListener.remove();
	      _this.onFocusinListener.remove();
	      _this.restoreLastFocus();
	    };
	
	    _this.handleExited = function () {
	      _this.setState({ exited: true });
	      _this.handleClose();
	    };
	
	    _this.handleBackdropClick = function (event) {
	      if (event.target !== event.currentTarget) {
	        return;
	      }
	
	      if (_this.props.onBackdropClick) {
	        _this.props.onBackdropClick(event);
	      }
	
	      if (!_this.props.disableBackdropClick && _this.props.onClose) {
	        _this.props.onClose(event, 'backdropClick');
	      }
	    };
	
	    _this.handleDocumentKeyDown = function (event) {
	      if (!_this.isTopModal() || (0, _keycode2.default)(event) !== 'esc') {
	        return;
	      }
	
	      if (_this.props.onEscapeKeyDown) {
	        _this.props.onEscapeKeyDown(event);
	      }
	
	      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
	        _this.props.onClose(event, 'escapeKeyDown');
	      }
	    };
	
	    _this.checkForFocus = function () {
	      if (_inDOM2.default) {
	        _this.lastFocus = (0, _activeElement2.default)();
	      }
	    };
	
	    _this.enforceFocus = function () {
	      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
	        return;
	      }
	
	      var dialogElement = _this.getDialogElement();
	      var currentActiveElement = (0, _activeElement2.default)(getOwnerDocument(_this));
	
	      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	        dialogElement.focus();
	      }
	    };
	
	    _this.state = {
	      exited: !_this.props.open
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      if (this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open) {
	        this.setState({ exited: false });
	      } else if (!getHasTransition(nextProps)) {
	        // Otherwise let handleExited take care of marking exited.
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      if (!this.props.open && nextProps.open) {
	        this.checkForFocus();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
	        // Otherwise handleExited will call this.
	        this.handleClose();
	      } else if (!prevProps.open && this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
	        this.handleClose();
	      }
	    }
	  }, {
	    key: 'getDialogElement',
	    value: function getDialogElement() {
	      return _reactDom2.default.findDOMNode(this.dialog);
	    }
	  }, {
	    key: 'autoFocus',
	    value: function autoFocus() {
	      if (this.props.disableAutoFocus) {
	        return;
	      }
	
	      var dialogElement = this.getDialogElement();
	      var currentActiveElement = (0, _activeElement2.default)(getOwnerDocument(this));
	
	      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	        this.lastFocus = currentActiveElement;
	
	        if (!dialogElement.hasAttribute('tabIndex')) {
	           false ? (0, _warning2.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
	          dialogElement.setAttribute('tabIndex', -1);
	        }
	
	        dialogElement.focus();
	      }
	    }
	  }, {
	    key: 'restoreLastFocus',
	    value: function restoreLastFocus() {
	      if (this.props.disableRestoreFocus) {
	        return;
	      }
	
	      if (this.lastFocus) {
	        this.lastFocus.focus();
	        this.lastFocus = null;
	      }
	    }
	  }, {
	    key: 'isTopModal',
	    value: function isTopModal() {
	      return this.props.manager.isTopModal(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          BackdropComponent = _props.BackdropComponent,
	          BackdropProps = _props.BackdropProps,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          container = _props.container,
	          disableAutoFocus = _props.disableAutoFocus,
	          disableBackdropClick = _props.disableBackdropClick,
	          disableEnforceFocus = _props.disableEnforceFocus,
	          disableEscapeKeyDown = _props.disableEscapeKeyDown,
	          disableRestoreFocus = _props.disableRestoreFocus,
	          hideBackdrop = _props.hideBackdrop,
	          keepMounted = _props.keepMounted,
	          onBackdropClick = _props.onBackdropClick,
	          onClose = _props.onClose,
	          onEscapeKeyDown = _props.onEscapeKeyDown,
	          onRendered = _props.onRendered,
	          open = _props.open,
	          manager = _props.manager,
	          other = (0, _objectWithoutProperties3.default)(_props, ['BackdropComponent', 'BackdropProps', 'children', 'classes', 'className', 'container', 'disableAutoFocus', 'disableBackdropClick', 'disableEnforceFocus', 'disableEscapeKeyDown', 'disableRestoreFocus', 'hideBackdrop', 'keepMounted', 'onBackdropClick', 'onClose', 'onEscapeKeyDown', 'onRendered', 'open', 'manager']);
	      var exited = this.state.exited;
	
	      var hasTransition = getHasTransition(this.props);
	      var childProps = {};
	
	      if (!keepMounted && !open && (!hasTransition || exited)) {
	        return null;
	      }
	
	      // It's a Transition like component
	      if (hasTransition) {
	        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
	      }
	
	      if (children.props.role === undefined) {
	        childProps.role = children.props.role || 'document';
	      }
	
	      if (children.props.tabIndex === undefined) {
	        childProps.tabIndex = children.props.tabIndex || '-1';
	      }
	
	      return _react2.default.createElement(
	        _Portal2.default,
	        {
	          ref: function ref(node) {
	            _this2.mountNode = node ? node.getMountNode() : node;
	          },
	          container: container,
	          onRendered: this.handleRendered
	        },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({
	            className: (0, _classnames2.default)(classes.root, className, (0, _defineProperty3.default)({}, classes.hidden, exited))
	          }, other),
	          hideBackdrop ? null : _react2.default.createElement(BackdropComponent, (0, _extends3.default)({ open: open, onClick: this.handleBackdropClick }, BackdropProps)),
	          _react2.default.createElement(
	            _RefHolder2.default,
	            {
	              ref: function ref(node) {
	                _this2.dialog = node;
	              }
	            },
	            _react2.default.cloneElement(children, childProps)
	          )
	        )
	      );
	    }
	  }]);
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes =  false ? {
	  /**
	   * A backdrop component. Useful for custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Properties applied to the `Backdrop` element.
	   */
	  BackdropProps: _propTypes2.default.object,
	  /**
	   * A single child content element.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes2.default.bool,
	  /**
	   * If `true`, clicking the backdrop will not fire any callback.
	   */
	  disableBackdropClick: _propTypes2.default.bool,
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes2.default.bool,
	  /**
	   * If `true`, hitting escape will not fire any callback.
	   */
	  disableEscapeKeyDown: _propTypes2.default.bool,
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes2.default.bool,
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes2.default.bool,
	  /**
	   * Always keep the children in the DOM.
	   * This property can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes2.default.bool,
	  /**
	   * A modal manager used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container.
	   */
	  manager: _propTypes2.default.object,
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback
	   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` property took effect.
	   */
	  onRendered: _propTypes2.default.func,
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes2.default.bool.isRequired
	} : {};
	
	Modal.defaultProps = {
	  disableAutoFocus: false,
	  disableBackdropClick: false,
	  disableEnforceFocus: false,
	  disableEscapeKeyDown: false,
	  disableRestoreFocus: false,
	  hideBackdrop: false,
	  keepMounted: false,
	  // Modals don't open on the server so this won't conflict with concurrent requests.
	  manager: new _ModalManager2.default(),
	  BackdropComponent: _Backdrop2.default
	};
	
	exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiModal' })(Modal);

/***/ }),
/* 5590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isBody = isBody;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(4878);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(372);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	// Do we have a scroll bar?
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument2.default)(container);
	  var win = (0, _isWindow2.default)(doc);
	
	  /* istanbul ignore next */
	  if (!win && !isBody(container)) {
	    return container.scrollHeight > container.clientHeight;
	  }
	
	  // Takes in account potential non zero margin on the body.
	  var style = window.getComputedStyle(doc.body);
	  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
	  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
	
	  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
	}

/***/ }),
/* 5591 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	var BLACKLIST = ['template', 'script', 'style'];
	
	function isHidable(node) {
	  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
	}
	
	function siblings(container, mount, callback) {
	  mount = [].concat(mount); // eslint-disable-line no-param-reassign
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      callback(node);
	    }
	  });
	}
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),
/* 5592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  var shadows = {};
	  theme.shadows.forEach(function (shadow, index) {
	    shadows['shadow' + index] = {
	      boxShadow: shadow
	    };
	  });
	
	  return (0, _extends3.default)({
	    root: {
	      backgroundColor: theme.palette.background.paper
	    },
	    rounded: {
	      borderRadius: 2
	    }
	  }, shadows);
	};
	
	function Paper(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      square = props.square,
	      elevation = props.elevation,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'square', 'elevation']);
	
	
	   false ? (0, _warning2.default)(elevation >= 0 && elevation < 25, 'Material-UI: this elevation `' + elevation + '` is not implemented.') : void 0;
	
	  var className = (0, _classnames2.default)(classes.root, classes['shadow' + (elevation >= 0 ? elevation : 0)], (0, _defineProperty3.default)({}, classes.rounded, !square), classNameProp);
	
	  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
	}
	
	Paper.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It's accepting values between 0 and 24 inclusive.
	   */
	  elevation: _propTypes2.default.number,
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes2.default.bool
	} : {};
	
	Paper.defaultProps = {
	  component: 'div',
	  elevation: 2,
	  square: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPaper' })(Paper);

/***/ }),
/* 5593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _contains = __webpack_require__(950);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _ownerDocument = __webpack_require__(372);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _ownerWindow = __webpack_require__(4877);
	
	var _ownerWindow2 = _interopRequireDefault(_ownerWindow);
	
	var _debounce = __webpack_require__(469);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Modal = __webpack_require__(578);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Grow = __webpack_require__(2399);
	
	var _Grow2 = _interopRequireDefault(_Grow);
	
	var _Paper = __webpack_require__(279);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getOffsetTop(rect, vertical) {
	  var offset = 0;
	
	  if (typeof vertical === 'number') {
	    offset = vertical;
	  } else if (vertical === 'center') {
	    offset = rect.height / 2;
	  } else if (vertical === 'bottom') {
	    offset = rect.height;
	  }
	
	  return offset;
	} // @inheritedComponent Modal
	
	function getOffsetLeft(rect, horizontal) {
	  var offset = 0;
	
	  if (typeof horizontal === 'number') {
	    offset = horizontal;
	  } else if (horizontal === 'center') {
	    offset = rect.width / 2;
	  } else if (horizontal === 'right') {
	    offset = rect.width;
	  }
	
	  return offset;
	}
	
	function getTransformOriginValue(transformOrigin) {
	  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
	    return typeof n === 'number' ? n + 'px' : n;
	  }).join(' ');
	}
	
	// Sum the scrollTop between two elements.
	function getScrollParent(parent, child) {
	  var element = child;
	  var scrollTop = 0;
	
	  while (element && element !== parent) {
	    element = element.parentNode;
	    scrollTop += element.scrollTop;
	  }
	  return scrollTop;
	}
	
	var styles = exports.styles = {
	  paper: {
	    position: 'absolute',
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    // So we see the popover when it's empty.
	    // It's most likely on issue on userland.
	    minWidth: 16,
	    minHeight: 16,
	    maxWidth: 'calc(100vw - 32px)',
	    maxHeight: 'calc(100vh - 32px)',
	    '&:focus': {
	      outline: 'none'
	    }
	  }
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3.default)(Popover, _React$Component);
	
	  function Popover() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Popover);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillUnmount = function () {
	      _this.handleResize.cancel();
	    }, _this.setPositioningStyles = function (element) {
	      if (element && element.style) {
	        var positioning = _this.getPositioningStyle(element);
	        element.style.top = positioning.top;
	        element.style.left = positioning.left;
	        element.style.transformOrigin = positioning.transformOrigin;
	      }
	    }, _this.getPositioningStyle = function (element) {
	      var _this$props = _this.props,
	          anchorEl = _this$props.anchorEl,
	          marginThreshold = _this$props.marginThreshold;
	
	      // Check if the parent has requested anchoring on an inner content node
	
	      var contentAnchorOffset = _this.getContentAnchorOffset(element);
	      // Get the offset of of the anchoring element
	      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset);
	
	      var elemRect = {
	        width: element.clientWidth,
	        height: element.clientHeight
	      };
	      // Get the transform origin point on the element itself
	      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);
	
	      // Calculate element positioning
	      var top = anchorOffset.top - transformOrigin.vertical;
	      var left = anchorOffset.left - transformOrigin.horizontal;
	      var bottom = top + elemRect.height;
	      var right = left + elemRect.width;
	
	      // Use the parent window of the anchorEl if provided
	      var containerWindow = (0, _ownerWindow2.default)(anchorEl);
	
	      // Window thresholds taking required margin into account
	      var heightThreshold = containerWindow.innerHeight - marginThreshold;
	      var widthThreshold = containerWindow.innerWidth - marginThreshold;
	
	      // Check if the vertical axis needs shifting
	      if (top < marginThreshold) {
	        var diff = top - marginThreshold;
	        top -= diff;
	        transformOrigin.vertical += diff;
	      } else if (bottom > heightThreshold) {
	        var _diff = bottom - heightThreshold;
	        top -= _diff;
	        transformOrigin.vertical += _diff;
	      }
	
	       false ? (0, _warning2.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', 'Some part of it can not be seen on the screen (' + (elemRect.height - heightThreshold) + 'px).', 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0;
	
	      // Check if the horizontal axis needs shifting
	      if (left < marginThreshold) {
	        var _diff2 = left - marginThreshold;
	        left -= _diff2;
	        transformOrigin.horizontal += _diff2;
	      } else if (right > widthThreshold) {
	        var _diff3 = right - widthThreshold;
	        left -= _diff3;
	        transformOrigin.horizontal += _diff3;
	      }
	
	      return {
	        top: top + 'px',
	        left: left + 'px',
	        transformOrigin: getTransformOriginValue(transformOrigin)
	      };
	    }, _this.transitionEl = undefined, _this.handleGetOffsetTop = getOffsetTop, _this.handleGetOffsetLeft = getOffsetLeft, _this.handleEnter = function (element) {
	      if (_this.props.onEnter) {
	        _this.props.onEnter(element);
	      }
	
	      _this.setPositioningStyles(element);
	    }, _this.handleResize = (0, _debounce2.default)(function () {
	      var element = _reactDom2.default.findDOMNode(_this.transitionEl);
	      _this.setPositioningStyles(element);
	    }, 166), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.action) {
	        this.props.action({
	          updatePosition: this.handleResize
	        });
	      }
	    }
	  }, {
	    key: 'getAnchorOffset',
	
	
	    // Returns the top/left offset of the position
	    // to attach to on the anchor element (or body if none is provided)
	    value: function getAnchorOffset(contentAnchorOffset) {
	      var _props = this.props,
	          anchorEl = _props.anchorEl,
	          anchorOrigin = _props.anchorOrigin,
	          anchorReference = _props.anchorReference,
	          anchorPosition = _props.anchorPosition;
	
	
	      if (anchorReference === 'anchorPosition') {
	        return anchorPosition;
	      }
	
	      var anchorElement = anchorEl || document.body;
	      var anchorRect = anchorElement.getBoundingClientRect();
	      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
	
	      return {
	        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
	        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
	      };
	    }
	
	    // Returns the vertical offset of inner content to anchor the transform on if provided
	
	  }, {
	    key: 'getContentAnchorOffset',
	    value: function getContentAnchorOffset(element) {
	      var _props2 = this.props,
	          getContentAnchorEl = _props2.getContentAnchorEl,
	          anchorReference = _props2.anchorReference;
	
	      var contentAnchorOffset = 0;
	
	      if (getContentAnchorEl && anchorReference === 'anchorEl') {
	        var contentAnchorEl = getContentAnchorEl(element);
	
	        if (contentAnchorEl && (0, _contains2.default)(element, contentAnchorEl)) {
	          var scrollTop = getScrollParent(element, contentAnchorEl);
	          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
	        }
	
	        // != the default value
	         false ? (0, _warning2.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to null or left `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
	      }
	
	      return contentAnchorOffset;
	    }
	
	    // Return the base transform origin using the element
	    // and taking the content anchor offset into account if in use
	
	  }, {
	    key: 'getTransformOrigin',
	    value: function getTransformOrigin(elemRect) {
	      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	      var transformOrigin = this.props.transformOrigin;
	
	      return {
	        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
	        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          anchorEl = _props3.anchorEl,
	          anchorOrigin = _props3.anchorOrigin,
	          anchorPosition = _props3.anchorPosition,
	          anchorReference = _props3.anchorReference,
	          children = _props3.children,
	          classes = _props3.classes,
	          containerProp = _props3.container,
	          elevation = _props3.elevation,
	          getContentAnchorEl = _props3.getContentAnchorEl,
	          marginThreshold = _props3.marginThreshold,
	          onEnter = _props3.onEnter,
	          onEntered = _props3.onEntered,
	          onEntering = _props3.onEntering,
	          onExit = _props3.onExit,
	          onExited = _props3.onExited,
	          onExiting = _props3.onExiting,
	          open = _props3.open,
	          PaperProps = _props3.PaperProps,
	          role = _props3.role,
	          transformOrigin = _props3.transformOrigin,
	          TransitionProp = _props3.transition,
	          transitionDuration = _props3.transitionDuration,
	          action = _props3.action,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['anchorEl', 'anchorOrigin', 'anchorPosition', 'anchorReference', 'children', 'classes', 'container', 'elevation', 'getContentAnchorEl', 'marginThreshold', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExited', 'onExiting', 'open', 'PaperProps', 'role', 'transformOrigin', 'transition', 'transitionDuration', 'action']);
	
	      // If the container prop is provided, use that
	      // If the anchorEl prop is provided, use its parent body element as the container
	      // If neither are provided let the Modal take care of choosing the container
	
	      var container = containerProp || (anchorEl ? (0, _ownerDocument2.default)(anchorEl).body : undefined);
	
	      var transitionProps = {};
	      // The provided transition might not support the auto timeout value.
	      if (TransitionProp === _Grow2.default) {
	        transitionProps.timeout = transitionDuration;
	      }
	
	      return _react2.default.createElement(
	        _Modal2.default,
	        (0, _extends3.default)({ container: container, open: open, BackdropProps: { invisible: true } }, other),
	        _react2.default.createElement(
	          TransitionProp,
	          (0, _extends3.default)({
	            appear: true,
	            'in': open,
	            onEnter: this.handleEnter,
	            onEntered: onEntered,
	            onEntering: onEntering,
	            onExit: onExit,
	            onExited: onExited,
	            onExiting: onExiting,
	            role: role,
	            ref: function ref(node) {
	              _this2.transitionEl = node;
	            }
	          }, transitionProps),
	          _react2.default.createElement(
	            _Paper2.default,
	            (0, _extends3.default)({
	              className: classes.paper,
	
	              elevation: elevation
	            }, PaperProps),
	            _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return Popover;
	}(_react2.default.Component);
	
	Popover.propTypes =  false ? {
	  /**
	   * This is callback property. It's called by the component on mount.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports updatePosition() action.
	   *
	   * @param {object} actions This object contains all posible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes2.default.func,
	  /**
	   * This is the DOM element that may be used
	   * to set the position of the popover.
	   */
	  anchorEl: _propTypes2.default.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `anchorEl` will attach to. This is not used when the
	   * anchorReference is 'anchorPosition'.
	   *
	   * Options:
	   * vertical: [top, center, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes2.default.shape({
	    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
	    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
	  }),
	  /**
	   * This is the position that may be used
	   * to set the position of the popover.
	   * The coordinates are relative to
	   * the application's client area.
	   */
	  anchorPosition: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	  /*
	   * This determines which anchor prop to refer to to set
	   * the position of the popover.
	   */
	  anchorReference: _propTypes2.default.oneOf(['anchorEl', 'anchorPosition']),
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   * By default, it's using the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	  /**
	   * The elevation of the popover.
	   */
	  elevation: _propTypes2.default.number,
	  /**
	   * This function is called in order to retrieve the content anchor element.
	   * It's the opposite of the `anchorEl` property.
	   * The content anchor element should be an element inside the popover.
	   * It's used to correctly scroll and set the position of the popover.
	   * The positioning strategy tries to make the content anchor element just above the
	   * anchor element.
	   */
	  getContentAnchorEl: _propTypes2.default.func,
	  /**
	   * Specifies how close to the edge of the window the popover can appear.
	   */
	  marginThreshold: _propTypes2.default.number,
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Callback fired before the component is entering.
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired when the component has entered.
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired when the component is entering.
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired before the component is exiting.
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired when the component has exited.
	   */
	  onExited: _propTypes2.default.func,
	  /**
	   * Callback fired when the component is exiting.
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * If `true`, the popover is visible.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  PaperProps: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  role: _propTypes2.default.string,
	  /**
	   * This is the point on the popover which
	   * will attach to the anchor's origin.
	   *
	   * Options:
	   * vertical: [top, center, bottom, x(px)];
	   * horizontal: [left, center, right, x(px)].
	   */
	  transformOrigin: _propTypes2.default.shape({
	    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
	    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
	  }),
	  /**
	   * Transition component.
	   */
	  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
	} : {};
	
	Popover.defaultProps = {
	  anchorReference: 'anchorEl',
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  elevation: 8,
	  marginThreshold: 16,
	  transformOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  transition: _Grow2.default,
	  transitionDuration: 'auto'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPopover' })(Popover);

/***/ }),
/* 5594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ownerDocument = __webpack_require__(372);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _exactProp = __webpack_require__(738);
	
	var _exactProp2 = _interopRequireDefault(_exactProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	
	function getOwnerDocument(element) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
	}
	
	/**
	 * @ignore - internal component.
	 *
	 * This module will soon be gone. We should drop it as soon as React@15.x support stop.
	 */
	
	var LegacyPortal = function (_React$Component) {
	  (0, _inherits3.default)(LegacyPortal, _React$Component);
	
	  function LegacyPortal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, LegacyPortal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LegacyPortal.__proto__ || (0, _getPrototypeOf2.default)(LegacyPortal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
	      return _this.mountNode;
	    }, _this.mountOverlayTarget = function () {
	      if (!_this.overlayTarget) {
	        _this.overlayTarget = document.createElement('div');
	        _this.mountNode = getContainer(_this.props.container, getOwnerDocument(_this).body);
	        _this.mountNode.appendChild(_this.overlayTarget);
	      }
	    }, _this.unmountOverlayTarget = function () {
	      if (_this.overlayTarget) {
	        _this.mountNode.removeChild(_this.overlayTarget);
	        _this.overlayTarget = null;
	      }
	      _this.mountNode = null;
	    }, _this.unrenderOverlay = function () {
	      if (_this.overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this.overlayTarget);
	        _this.overlayInstance = null;
	      }
	    }, _this.renderOverlay = function () {
	      var overlay = _this.props.children;
	      _this.mountOverlayTarget();
	      var initialRender = !_this.overlayInstance;
	      _this.overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this.overlayTarget, function () {
	        if (initialRender && _this.props.onRendered) {
	          _this.props.onRendered();
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(LegacyPortal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	      this.renderOverlay();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.overlayTarget && nextProps.container !== this.props.container) {
	        this.mountNode.removeChild(this.overlayTarget);
	        this.mountNode = getContainer(nextProps.container, getOwnerDocument(this).body);
	        this.mountNode.appendChild(this.overlayTarget);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderOverlay();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	      this.unrenderOverlay();
	      this.unmountOverlayTarget();
	    }
	
	    /**
	     * @public
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return LegacyPortal;
	}(_react2.default.Component);
	
	LegacyPortal.propTypes =  false ? {
	  children: _propTypes2.default.element.isRequired,
	  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	  onRendered: _propTypes2.default.func
	} : {};
	
	LegacyPortal.propTypes =  false ? (0, _exactProp2.default)(LegacyPortal.propTypes, 'LegacyPortal') : {};
	
	exports.default = LegacyPortal;

/***/ }),
/* 5595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ownerDocument = __webpack_require__(372);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _exactProp = __webpack_require__(738);
	
	var _exactProp2 = _interopRequireDefault(_exactProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	
	function getOwnerDocument(element) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
	}
	
	/**
	 * This component shares many concepts with
	 * [react-overlays](https://react-bootstrap.github.io/react-overlays/#portals)
	 * But has been forked in order to fix some bugs, reduce the number of dependencies
	 * and take the control of our destiny.
	 */
	
	var Portal = function (_React$Component) {
	  (0, _inherits3.default)(Portal, _React$Component);
	
	  function Portal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Portal.__proto__ || (0, _getPrototypeOf2.default)(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
	      return _this.mountNode;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setContainer(this.props.container);
	      this.forceUpdate(this.props.onRendered);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.container !== this.props.container) {
	        this.setContainer(nextProps.container);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mountNode = null;
	    }
	  }, {
	    key: 'setContainer',
	    value: function setContainer(container) {
	      this.mountNode = getContainer(container, getOwnerDocument(this).body);
	    }
	
	    /**
	     * @public
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return this.mountNode ? _reactDom2.default.createPortal(children, this.mountNode) : null;
	    }
	  }]);
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes =  false ? {
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   * By default, it's using the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   */
	  onRendered: _propTypes2.default.func
	} : {};
	
	Portal.propTypes =  false ? (0, _exactProp2.default)(Portal.propTypes, 'Portal') : {};
	
	exports.default = Portal;

/***/ }),
/* 5596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SIZE = 50;
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return (clampedValue - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1);
	  // https://gist.github.com/gre/1650294
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-block'
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	    svgIndeterminate: {
	      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
	    },
	    svgDeterminate: {},
	    circle: {
	      stroke: 'currentColor',
	      strokeLinecap: 'round'
	    },
	    circleIndeterminate: {
	      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	    },
	    '@keyframes mui-progress-circular-rotate': {
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes mui-progress-circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-120px'
	      }
	    }
	  };
	};
	
	/**
	 * ## ARIA
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	function CircularProgress(props) {
	  var _classNames2;
	
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      max = props.max,
	      min = props.min,
	      size = props.size,
	      style = props.style,
	      thickness = props.thickness,
	      value = props.value,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'max', 'min', 'size', 'style', 'thickness', 'value', 'variant']);
	
	
	  var circleStyle = {};
	  var rootStyle = { width: size, height: size };
	  var rootProps = {};
	
	  if (variant === 'determinate') {
	    var relVal = getRelativeValue(value, min, max) * 100;
	    var circumference = 2 * Math.PI * (SIZE / 2 - 5);
	
	    circleStyle.strokeDashoffset = (easeIn((100 - relVal) / 100) * circumference).toFixed(3) + 'px';
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootStyle.transform = 'rotate(' + (easeOut(relVal / 70) * 270).toFixed(3) + 'deg)';
	    rootProps['aria-valuenow'] = Math.round(relVal);
	  }
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({
	      className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), className),
	      style: (0, _extends3.default)({}, rootStyle, style),
	      role: 'progressbar'
	    }, rootProps, other),
	    _react2.default.createElement(
	      'svg',
	      {
	        className: (0, _classnames2.default)((_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.svgIndeterminate, variant === 'indeterminate'), (0, _defineProperty3.default)(_classNames2, classes.svgDeterminate, variant === 'determinate'), _classNames2)),
	        viewBox: '0 0 ' + SIZE + ' ' + SIZE
	      },
	      _react2.default.createElement('circle', {
	        className: (0, _classnames2.default)(classes.circle, (0, _defineProperty3.default)({}, classes.circleIndeterminate, variant === 'indeterminate')),
	        style: circleStyle,
	        cx: SIZE / 2,
	        cy: SIZE / 2,
	        r: SIZE / 2 - 5,
	        fill: 'none',
	        strokeWidth: thickness
	      })
	    )
	  );
	}
	
	CircularProgress.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes2.default.oneOf(['primary', 'secondary', 'inherit']),
	  /**
	   * The max value of progress in determinate variant.
	   */
	  max: _propTypes2.default.number,
	  /**
	   * The min value of progress in determinate variant.
	   */
	  min: _propTypes2.default.number,
	  /**
	   * The size of the circle.
	   */
	  size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * @ignore
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes2.default.number,
	  /**
	   * The value of the progress indicator for the determinate variant.
	   * Value between 0 and 100.
	   */
	  value: _propTypes2.default.number,
	  /**
	   * The variant of progress indicator. Use indeterminate
	   * when there is no progress value.
	   */
	  variant: _propTypes2.default.oneOf(['determinate', 'indeterminate'])
	} : {};
	
	CircularProgress.defaultProps = {
	  color: 'primary',
	  max: 100,
	  min: 0,
	  size: 40,
	  thickness: 3.6,
	  value: 0,
	  variant: 'indeterminate'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCircularProgress', flip: false })(CircularProgress);

/***/ }),
/* 5597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SwitchBase = __webpack_require__(1568);
	
	var _SwitchBase2 = _interopRequireDefault(_SwitchBase);
	
	var _RadioButtonChecked = __webpack_require__(5656);
	
	var _RadioButtonChecked2 = _interopRequireDefault(_RadioButtonChecked);
	
	var _RadioButtonUnchecked = __webpack_require__(5657);
	
	var _RadioButtonUnchecked2 = _interopRequireDefault(_RadioButtonUnchecked);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    default: {
	      color: theme.palette.text.secondary
	    },
	    checked: {
	      color: theme.palette.primary.main
	    },
	    disabled: {
	      color: theme.palette.action.disabled
	    }
	  };
	};
	
	var _ref = _react2.default.createElement(_RadioButtonUnchecked2.default, null);
	
	var _ref2 = _react2.default.createElement(_RadioButtonChecked2.default, null);
	
	function Radio(props) {
	  return _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
	    inputType: 'radio',
	    icon: _ref,
	    checkedIcon: _ref2
	  }, props));
	}
	
	Radio.propTypes =  false ? {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes2.default.bool,
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes2.default.object,
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes2.default.func,
	  /**
	   * The input component property `type`.
	   */
	  inputType: _propTypes2.default.string,
	  /*
	   * @ignore
	   */
	  name: _propTypes2.default.string,
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The value of the component.
	   */
	  value: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiRadio' })(Radio);

/***/ }),
/* 5598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FormGroup = __webpack_require__(2365);
	
	var _FormGroup2 = _interopRequireDefault(_FormGroup);
	
	var _helpers = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent FormGroup
	
	var RadioGroup = function (_React$Component) {
	  (0, _inherits3.default)(RadioGroup, _React$Component);
	
	  function RadioGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioGroup)).call.apply(_ref, [this].concat(args))), _this), _this.radios = [], _this.focus = function () {
	      if (!_this.radios || !_this.radios.length) {
	        return;
	      }
	
	      var focusRadios = _this.radios.filter(function (n) {
	        return !n.disabled;
	      });
	
	      if (!focusRadios.length) {
	        return;
	      }
	
	      var selectedRadio = (0, _helpers.find)(focusRadios, function (n) {
	        return n.checked;
	      });
	
	      if (selectedRadio) {
	        selectedRadio.focus();
	        return;
	      }
	
	      focusRadios[0].focus();
	    }, _this.handleRadioChange = function (event, checked) {
	      if (checked && _this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RadioGroup, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          value = _props.value,
	          onChange = _props.onChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'name', 'value', 'onChange']);
	
	
	      this.radios = [];
	
	      return _react2.default.createElement(
	        _FormGroup2.default,
	        (0, _extends3.default)({ role: 'radiogroup' }, other),
	        _react2.default.Children.map(children, function (child, index) {
	          if (!_react2.default.isValidElement(child)) {
	            return null;
	          }
	
	          return _react2.default.cloneElement(child, {
	            key: index,
	            name: name,
	            inputRef: function inputRef(node) {
	              if (node) {
	                _this2.radios.push(node);
	              }
	            },
	            checked: value === child.props.value,
	            onChange: _this2.handleRadioChange
	          });
	        })
	      );
	    }
	  }]);
	  return RadioGroup;
	}(_react2.default.Component);
	
	RadioGroup.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The name used to reference the value of the control.
	   */
	  name: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback fired when a radio button is selected.
	   *
	   * @param {object} event The event source of the callback
	   * @param {string} value The `value` of the selected radio button
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Value of the selected radio button.
	   */
	  value: _propTypes2.default.string
	} : {};
	
	exports.default = RadioGroup;

/***/ }),
/* 5599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Radio = __webpack_require__(5597);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Radio).default;
	  }
	});
	
	var _RadioGroup = __webpack_require__(5598);
	
	Object.defineProperty(exports, 'RadioGroup', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RadioGroup).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(581);
	
	var _exactProp = __webpack_require__(738);
	
	var _exactProp2 = _interopRequireDefault(_exactProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: {
	        WebkitFontSmoothing: 'antialiased', // Antialiasing.
	        MozOsxFontSmoothing: 'grayscale', // Antialiasing.
	        // Change from `box-sizing: content-box` so that `width`
	        // is not affected by `padding` or `border`.
	        boxSizing: 'border-box'
	      },
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      body: {
	        margin: 0, // Remove the margin in all browsers.
	        backgroundColor: theme.palette.background.default,
	        '@media print': {
	          // Save printer ink.
	          backgroundColor: theme.palette.common.white
	        }
	      }
	    }
	  };
	};
	
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	var Reboot = function (_React$Component) {
	  (0, _inherits3.default)(Reboot, _React$Component);
	
	  function Reboot() {
	    (0, _classCallCheck3.default)(this, Reboot);
	    return (0, _possibleConstructorReturn3.default)(this, (Reboot.__proto__ || (0, _getPrototypeOf2.default)(Reboot)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Reboot, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return Reboot;
	}(_react2.default.Component);
	
	Reboot.propTypes =  false ? {
	  /**
	   * You can only provide a single element with react@15, a node with react@16.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  classes: _propTypes2.default.object.isRequired
	} : {};
	
	Reboot.propTypes =  false ? (0, _exactProp2.default)(Reboot.propTypes, 'Reboot') : {};
	
	Reboot.defaultProps = {
	  children: null
	};
	
	exports.default = (0, _styles.withStyles)(styles, { name: 'MuiReboot' })(Reboot);

/***/ }),
/* 5601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Reboot = __webpack_require__(5600);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Reboot).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(36);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(568);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ArrowDropDown = __webpack_require__(5650);
	
	var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);
	
	var _Menu = __webpack_require__(2371);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Input = __webpack_require__(1564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var SelectInput = function (_React$Component) {
	  (0, _inherits3.default)(SelectInput, _React$Component);
	
	  function SelectInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SelectInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectInput.__proto__ || (0, _getPrototypeOf2.default)(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      open: false
	    }, _this.ignoreNextBlur = false, _this.isControlled = _this.props.open !== undefined, _this.update = _this.isControlled ? function (_ref2) {
	      var event = _ref2.event,
	          open = _ref2.open,
	          anchorEl = _ref2.anchorEl;
	
	      if (open) {
	        _this.props.onOpen(event);
	      } else {
	        _this.props.onClose(event);
	      }
	      _this.setState({ anchorEl: anchorEl });
	    } : function (_ref3) {
	      var open = _ref3.open,
	          anchorEl = _ref3.anchorEl;
	      return _this.setState({ open: open, anchorEl: anchorEl });
	    }, _this.handleClick = function (event) {
	      // Opening the menu is going to blur the. It will be focused back when closed.
	      _this.ignoreNextBlur = true;
	      _this.update({
	        open: true,
	        anchorEl: event.currentTarget,
	        event: event
	      });
	    }, _this.handleClose = function (event) {
	      _this.update({
	        open: false,
	        event: event
	      });
	    }, _this.handleItemClick = function (child) {
	      return function (event) {
	        if (!_this.props.multiple) {
	          _this.update({
	            open: false,
	            event: event
	          });
	        }
	
	        if (_this.props.onChange) {
	          var _this$props = _this.props,
	              onChange = _this$props.onChange,
	              name = _this$props.name;
	
	          var value = void 0;
	          var target = void 0;
	
	          if (event.target) {
	            target = event.target;
	          }
	
	          if (_this.props.multiple) {
	            value = Array.isArray(_this.props.value) ? [].concat((0, _toConsumableArray3.default)(_this.props.value)) : [];
	            var itemIndex = value.indexOf(child.props.value);
	            if (itemIndex === -1) {
	              value.push(child.props.value);
	            } else {
	              value.splice(itemIndex, 1);
	            }
	          } else {
	            value = child.props.value;
	          }
	
	          event.persist();
	          event.target = (0, _extends3.default)({}, target, { value: value, name: name });
	
	          onChange(event, child);
	        }
	      };
	    }, _this.handleBlur = function (event) {
	      if (_this.ignoreNextBlur === true) {
	        // The parent components are relying on the bubbling of the event.
	        event.stopPropagation();
	        _this.ignoreNextBlur = false;
	        return;
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.readOnly) {
	        return;
	      }
	
	      if (['space', 'up', 'down'].includes((0, _keycode2.default)(event))) {
	        event.preventDefault();
	        // Opening the menu is going to blur the. It will be focused back when closed.
	        _this.ignoreNextBlur = true;
	        _this.update({
	          open: true,
	          anchorEl: event.currentTarget,
	          event: event
	        });
	      }
	    }, _this.handleSelectRef = function (node) {
	      if (!_this.props.inputRef) {
	        return;
	      }
	
	      _this.props.inputRef({
	        node: node,
	        // By pass the native input as we expose a rich object (array).
	        value: _this.props.value
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SelectInput, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          disabled = _props.disabled,
	          displayEmpty = _props.displayEmpty,
	          inputRef = _props.inputRef,
	          _props$MenuProps = _props.MenuProps,
	          MenuProps = _props$MenuProps === undefined ? {} : _props$MenuProps,
	          multiple = _props.multiple,
	          name = _props.name,
	          native = _props.native,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          onClose = _props.onClose,
	          onFocus = _props.onFocus,
	          onOpen = _props.onOpen,
	          open = _props.open,
	          readOnly = _props.readOnly,
	          renderValue = _props.renderValue,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'classes', 'className', 'disabled', 'displayEmpty', 'inputRef', 'MenuProps', 'multiple', 'name', 'native', 'onBlur', 'onChange', 'onClose', 'onFocus', 'onOpen', 'open', 'readOnly', 'renderValue', 'value']);
	
	
	      if (native) {
	         false ? (0, _warning2.default)(multiple === false, 'Material-UI: you can not use the `native` and `multiple` properties ' + 'at the same time on a `Select` component.') : void 0;
	         false ? (0, _warning2.default)(!renderValue, 'Material-UI: the `renderValue` property is not used by the native implementation.') : void 0;
	         false ? (0, _warning2.default)(!displayEmpty, 'Material-UI: the `displayEmpty` property is not used by the native implementation.') : void 0;
	
	        return _react2.default.createElement(
	          'div',
	          { className: classes.root },
	          _react2.default.createElement(
	            'select',
	            (0, _extends3.default)({
	              className: (0, _classnames2.default)(classes.select, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp),
	              name: name,
	              disabled: disabled,
	              onBlur: onBlur,
	              onChange: onChange,
	              onFocus: onFocus,
	              value: value,
	              readOnly: readOnly,
	              ref: inputRef
	            }, other),
	            children
	          ),
	          _react2.default.createElement(_ArrowDropDown2.default, { className: classes.icon })
	        );
	      }
	
	      if (value === undefined) {
	        throw new Error('Material-UI: the `value` property is required ' + 'when using the `Select` component with `native=false`.');
	      }
	
	      var display = void 0;
	      var displaySingle = '';
	      var displayMultiple = [];
	      var computeDisplay = false;
	
	      // No need to display any value if the field is empty.
	      if ((0, _Input.isDirty)(this.props) || displayEmpty) {
	        if (renderValue) {
	          display = renderValue(value);
	        } else {
	          computeDisplay = true;
	        }
	      }
	
	      var items = _react2.default.Children.map(children, function (child) {
	        if (!_react2.default.isValidElement(child)) {
	          return null;
	        }
	        var selected = void 0;
	
	        if (multiple) {
	          if (!Array.isArray(value)) {
	            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
	          }
	
	          selected = value.indexOf(child.props.value) !== -1;
	          if (selected && computeDisplay) {
	            displayMultiple.push(child.props.children);
	          }
	        } else {
	          selected = value === child.props.value;
	          if (selected && computeDisplay) {
	            displaySingle = child.props.children;
	          }
	        }
	
	        return _react2.default.cloneElement(child, {
	          role: 'option',
	          selected: selected,
	          onClick: _this2.handleItemClick(child)
	        });
	      });
	
	      if (computeDisplay) {
	        display = multiple ? displayMultiple.join(', ') : displaySingle;
	      }
	
	      var minimumMenuWidth = this.state.anchorEl != null && !autoWidth ? this.state.anchorEl.clientWidth : undefined;
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes.root },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)(classes.select, classes.selectMenu, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp),
	
	            'aria-pressed': this.state.open ? 'true' : 'false',
	            tabIndex: disabled ? null : 0,
	            role: 'button',
	            'aria-owns': this.state.open ? 'menu-' + (name || '') : null,
	            'aria-haspopup': 'true',
	            onKeyDown: this.handleKeyDown,
	            onBlur: this.handleBlur,
	            onClick: disabled || readOnly ? null : this.handleClick,
	            onFocus: onFocus
	          },
	          display
	        ),
	        _react2.default.createElement('input', (0, _extends3.default)({
	          value: Array.isArray(value) ? value.join(',') : value,
	          name: name,
	          readOnly: readOnly,
	          ref: this.handleSelectRef
	        }, other, {
	          type: 'hidden'
	        })),
	        _react2.default.createElement(_ArrowDropDown2.default, { className: classes.icon }),
	        _react2.default.createElement(
	          _Menu2.default,
	          (0, _extends3.default)({
	            id: 'menu-' + (name || ''),
	            anchorEl: this.state.anchorEl,
	            open: this.isControlled ? open : this.state.open,
	            onClose: this.handleClose
	          }, MenuProps, {
	            MenuListProps: (0, _extends3.default)({}, MenuProps.MenuListProps, {
	              role: 'listbox'
	            }),
	            PaperProps: (0, _extends3.default)({}, MenuProps.PaperProps, {
	              style: (0, _extends3.default)({
	                minWidth: minimumMenuWidth
	              }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
	            })
	          }),
	          items
	        )
	      );
	    }
	  }]);
	  return SelectInput;
	}(_react2.default.Component);
	
	SelectInput.propTypes =  false ? {
	  /**
	   * If true, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  displayEmpty: _propTypes2.default.bool,
	  /**
	   * Use that property to pass a ref callback to the native select element.
	   */
	  inputRef: _propTypes2.default.func,
	  /**
	   * Properties applied to the `Menu` element.
	   */
	  MenuProps: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support multiple selections.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes2.default.string,
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback
	   * @param {object} child The react element that was selected
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback fired when the component requests to be closed.
	   * Useful in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback fired when the component requests to be opened.
	   * Useful in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback
	   */
	  onOpen: _propTypes2.default.func,
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  readOnly: _propTypes2.default.bool,
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` property is `false` (default).
	   */
	  renderValue: _propTypes2.default.func,
	  /**
	   * The value of the component, required for a controlled component.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
	} : {};
	
	exports.default = SelectInput;

/***/ }),
/* 5603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends8 = __webpack_require__(3);
	
	var _extends9 = _interopRequireDefault(_extends8);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _transitions = __webpack_require__(381);
	
	var _ClickAwayListener = __webpack_require__(2400);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _helpers = __webpack_require__(127);
	
	var _Slide = __webpack_require__(1574);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _SnackbarContent = __webpack_require__(2379);
	
	var _SnackbarContent2 = _interopRequireDefault(_SnackbarContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  var gutter = theme.spacing.unit * 3;
	  var top = { top: 0 };
	  var bottom = { bottom: 0 };
	  var right = { justifyContent: 'flex-end' };
	  var left = { justifyContent: 'flex-start' };
	  var topSpace = { top: gutter };
	  var bottomSpace = { bottom: gutter };
	  var rightSpace = { right: gutter };
	  var leftSpace = { left: gutter };
	  var center = {
	    left: '50%',
	    right: 'auto',
	    transform: 'translateX(-50%)'
	  };
	
	  return {
	    root: {
	      zIndex: theme.zIndex.snackbar,
	      position: 'fixed',
	      display: 'flex',
	      left: 0,
	      right: 0,
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	    anchorTopCenter: (0, _extends9.default)({}, top, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({}, center))),
	    anchorBottomCenter: (0, _extends9.default)({}, bottom, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({}, center))),
	    anchorTopRight: (0, _extends9.default)({}, top, right, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
	      left: 'auto'
	    }, topSpace, rightSpace))),
	    anchorBottomRight: (0, _extends9.default)({}, bottom, right, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
	      left: 'auto'
	    }, bottomSpace, rightSpace))),
	    anchorTopLeft: (0, _extends9.default)({}, top, left, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
	      right: 'auto'
	    }, topSpace, leftSpace))),
	    anchorBottomLeft: (0, _extends9.default)({}, bottom, left, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
	      right: 'auto'
	    }, bottomSpace, leftSpace)))
	  };
	};
	
	var Snackbar = function (_React$Component) {
	  (0, _inherits3.default)(Snackbar, _React$Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      // Used to only render active snackbars.
	      exited: false
	    }, _this.timerAutoHide = null, _this.handleMouseEnter = function (event) {
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	      _this.handlePause();
	    }, _this.handleMouseLeave = function (event) {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	      _this.handleResume();
	    }, _this.handleClickAway = function (event) {
	      if (_this.props.onClose) {
	        _this.props.onClose(event, 'clickaway');
	      }
	    }, _this.handlePause = function () {
	      clearTimeout(_this.timerAutoHide);
	    }, _this.handleResume = function () {
	      if (_this.props.autoHideDuration != null) {
	        if (_this.props.resumeHideDuration !== undefined) {
	          _this.setAutoHideTimer(_this.props.resumeHideDuration);
	          return;
	        }
	        _this.setAutoHideTimer((_this.props.autoHideDuration || 0) * 0.5);
	      }
	    }, _this.handleExited = function () {
	      _this.setState({ exited: true });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.open) {
	        this.setState({ exited: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.open) {
	        this.setAutoHideTimer();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open) {
	        this.setState({ exited: false });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.open !== this.props.open) {
	        if (this.props.open) {
	          this.setAutoHideTimer();
	        } else {
	          clearTimeout(this.timerAutoHide);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHide);
	    }
	
	    // Timer that controls delay before snackbar auto hides
	
	  }, {
	    key: 'setAutoHideTimer',
	    value: function setAutoHideTimer() {
	      var _this2 = this;
	
	      var autoHideDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      if (!this.props.onClose || this.props.autoHideDuration == null) {
	        return;
	      }
	
	      clearTimeout(this.timerAutoHide);
	      this.timerAutoHide = setTimeout(function () {
	        if (!_this2.props.onClose || _this2.props.autoHideDuration == null) {
	          return;
	        }
	
	        _this2.props.onClose(null, 'timeout');
	      }, autoHideDuration || this.props.autoHideDuration || 0);
	    }
	
	    // Pause the timer when the user is interacting with the Snackbar
	    // or when the user hide the window.
	
	
	    // Restart the timer when the user is no longer interacting with the Snackbar
	    // or when the window is shown back.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          action = _props.action,
	          _props$anchorOrigin = _props.anchorOrigin,
	          vertical = _props$anchorOrigin.vertical,
	          horizontal = _props$anchorOrigin.horizontal,
	          autoHideDuration = _props.autoHideDuration,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          message = _props.message,
	          onClose = _props.onClose,
	          onEnter = _props.onEnter,
	          onEntered = _props.onEntered,
	          onEntering = _props.onEntering,
	          onExit = _props.onExit,
	          onExited = _props.onExited,
	          onExiting = _props.onExiting,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          open = _props.open,
	          resumeHideDuration = _props.resumeHideDuration,
	          SnackbarContentProps = _props.SnackbarContentProps,
	          TransitionProp = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'anchorOrigin', 'autoHideDuration', 'children', 'classes', 'className', 'message', 'onClose', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExited', 'onExiting', 'onMouseEnter', 'onMouseLeave', 'open', 'resumeHideDuration', 'SnackbarContentProps', 'transition', 'transitionDuration']);
	
	
	      if (!open && this.state.exited) {
	        return null;
	      }
	
	      var transitionProps = {};
	
	      // The provided transition might not support the direction property.
	      if (TransitionProp === _Slide2.default) {
	        transitionProps.direction = vertical === 'top' ? 'down' : 'up';
	      }
	
	      return _react2.default.createElement(
	        _reactEventListener2.default,
	        { target: 'window', onFocus: this.handleResume, onBlur: this.handlePause },
	        _react2.default.createElement(
	          _ClickAwayListener2.default,
	          { onClickAway: this.handleClickAway },
	          _react2.default.createElement(
	            'div',
	            (0, _extends9.default)({
	              className: (0, _classnames2.default)(classes.root, classes['anchor' + (0, _helpers.capitalize)(vertical) + (0, _helpers.capitalize)(horizontal)], className),
	              onMouseEnter: this.handleMouseEnter,
	              onMouseLeave: this.handleMouseLeave
	            }, other),
	            _react2.default.createElement(
	              TransitionProp,
	              (0, _extends9.default)({
	                appear: true,
	                'in': open,
	                onEnter: onEnter,
	                onEntered: onEntered,
	                onEntering: onEntering,
	                onExit: onExit,
	                onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
	                onExiting: onExiting,
	                timeout: transitionDuration
	              }, transitionProps),
	              children || _react2.default.createElement(_SnackbarContent2.default, (0, _extends9.default)({ message: message, action: action }, SnackbarContentProps))
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return Snackbar;
	}(_react2.default.Component);
	
	Snackbar.propTypes =  false ? {
	  /**
	   * The action to display.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * The anchor of the `Snackbar`.
	   */
	  anchorOrigin: _propTypes2.default.shape({
	    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
	    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
	  }),
	  /**
	   * The number of milliseconds to wait before automatically calling the
	   * `onClose` function. `onClose` should then set the state of the `open`
	   * prop to hide the Snackbar. This behavior is disabled by default with
	   * the `null` value.
	   */
	  autoHideDuration: _propTypes2.default.number,
	  /**
	   * If you wish the take control over the children of the component you can use this property.
	   * When used, you replace the `SnackbarContent` component with the children.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * When displaying multiple consecutive Snackbars from a parent rendering a single
	   * <Snackbar/>, add the key property to ensure independent treatment of each message.
	   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
	   * features such as autoHideDuration may be canceled.
	   */
	  key: _propTypes2.default.any,
	  /**
	   * The message to display.
	   */
	  message: _propTypes2.default.node,
	  /**
	   * Callback fired when the component requests to be closed.
	   * Typically `onClose` is used to set state in the parent component,
	   * which is used to control the `Snackbar` `open` prop.
	   * The `reason` parameter can optionally be used to control the response to `onClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {object} event The event source of the callback
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Callback fired before the transition is entering.
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired when the transition has entered.
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired when the transition is entering.
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired before the transition is exiting.
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired when the transition has exited.
	   */
	  onExited: _propTypes2.default.func,
	  /**
	   * Callback fired when the transition is exiting.
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseEnter: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * If true, `Snackbar` is open.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * The number of milliseconds to wait before dismissing after user interaction.
	   * If `autoHideDuration` property isn't specified, it does nothing.
	   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
	   * we default to `autoHideDuration / 2` ms.
	   */
	  resumeHideDuration: _propTypes2.default.number,
	  /**
	   * Properties applied to the `SnackbarContent` element.
	   */
	  SnackbarContentProps: _propTypes2.default.object,
	  /**
	   * Transition component.
	   */
	  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
	} : {};
	
	Snackbar.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'center'
	  },
	  transition: _Slide2.default,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiSnackbar' })(Snackbar);

/***/ }),
/* 5604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Snackbar = __webpack_require__(5603);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Snackbar).default;
	  }
	});
	
	var _SnackbarContent = __webpack_require__(2379);
	
	Object.defineProperty(exports, 'SnackbarContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SnackbarContent).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {},
	    horizontal: {
	      paddingLeft: theme.spacing.unit,
	      paddingRight: theme.spacing.unit,
	      '&:first-child': {
	        paddingLeft: 0
	      },
	      '&:last-child': {
	        paddingRight: 0
	      }
	    },
	    alternativeLabel: {
	      flex: 1,
	      position: 'relative',
	      marginLeft: 0
	    }
	  };
	};
	
	function Step(props) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      completed = props.completed,
	      connector = props.connector,
	      disabled = props.disabled,
	      index = props.index,
	      last = props.last,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'connector', 'disabled', 'index', 'last', 'orientation']);
	
	
	  var className = (0, _classnames2.default)(classes.root, classes[orientation], (0, _defineProperty3.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: className }, other),
	    _react2.default.Children.map(children, function (child) {
	      return _react2.default.cloneElement(child, (0, _extends3.default)({
	        active: active,
	        alternativeLabel: alternativeLabel,
	        completed: completed,
	        disabled: disabled,
	        icon: index + 1,
	        last: last,
	        orientation: orientation
	      }, child.props));
	    }),
	    connector && alternativeLabel && !last && _react2.default.cloneElement(connector, { orientation: orientation, alternativeLabel: alternativeLabel })
	  );
	}
	
	Step.propTypes =  false ? {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes2.default.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Passed down from Stepper if alternativeLabel is also set.
	   */
	  connector: _propTypes2.default.element,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _propTypes2.default.number,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
	} : {};
	
	Step.defaultProps = {
	  active: false,
	  completed: false,
	  disabled: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStep' })(Step);

/***/ }),
/* 5606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ButtonBase = __webpack_require__(278);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	var _StepLabel = __webpack_require__(2381);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	var _reactHelpers = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = {
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    paddingLeft: 0,
	    paddingRight: 0,
	    background: 'none'
	  },
	  alternativeLabel: {
	    margin: '0 auto'
	  }
	}; // @inheritedComponent ButtonBase
	
	function StepButton(props) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'disabled', 'icon', 'last', 'optional', 'orientation']);
	
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
	  var childProps = {
	    active: active,
	    alternativeLabel: alternativeLabel,
	    completed: completed,
	    disabled: disabled,
	    icon: icon,
	    optional: optional,
	    orientation: orientation
	  };
	  var child = (0, _reactHelpers.isMuiElement)(children, ['StepLabel']) ? _react2.default.cloneElement(children, childProps) : _react2.default.createElement(
	    _StepLabel2.default,
	    childProps,
	    children
	  );
	
	  return _react2.default.createElement(
	    _ButtonBase2.default,
	    (0, _extends3.default)({ disabled: disabled, className: className }, other),
	    child
	  );
	}
	
	StepButton.propTypes =  false ? {
	  /**
	   * @ignore
	   * Passed in via `Step` - passed through to `StepLabel`.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes2.default.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepButton' })(StepButton);

/***/ }),
/* 5607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	    rootVertical: {
	      marginLeft: 12, // half icon
	      padding: '0 0 ' + theme.spacing.unit + 'px'
	    },
	    lineHorizontal: {
	      borderTopStyle: 'solid',
	      borderTopWidth: 1
	    },
	    lineVertical: {
	      borderLeftStyle: 'solid',
	      borderLeftWidth: 1,
	      minHeight: 24
	    },
	    alternativeLabelRoot: {
	      position: 'absolute',
	      top: theme.spacing.unit + 4,
	      left: 'calc(50% + 20px)',
	      right: 'calc(-50% + 20px)'
	    },
	    alternativeLabelLine: {
	      marginLeft: 0
	    }
	  };
	};
	
	/**
	 * @ignore - internal component.
	 */
	function StepConnector(props) {
	  var _classNames, _classNames2;
	
	  var alternativeLabel = props.alternativeLabel,
	      classNameProp = props.className,
	      classes = props.classes,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties3.default)(props, ['alternativeLabel', 'className', 'classes', 'orientation']);
	
	
	  var className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.root, !alternativeLabel), (0, _defineProperty3.default)(_classNames, classes.rootVertical, orientation === 'vertical'), (0, _defineProperty3.default)(_classNames, classes.alternativeLabelRoot, alternativeLabel), _classNames), classNameProp);
	  var lineClassName = (0, _classnames2.default)(classes.line, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.lineHorizontal, orientation === 'horizontal'), (0, _defineProperty3.default)(_classNames2, classes.lineVertical, orientation === 'vertical'), (0, _defineProperty3.default)(_classNames2, classes.alternativeLabelLine, alternativeLabel), _classNames2));
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: className }, other),
	    _react2.default.createElement('span', { className: lineClassName })
	  );
	}
	
	StepConnector.propTypes =  false ? {
	  /**
	   * @ignore
	   * Set internally by Step when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes2.default.bool,
	  /**
	   * Useful to extend the style applied to the component.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
	} : {};
	
	StepConnector.defaultProps = {
	  alternativeLabel: false,
	  orientation: 'horizontal'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepConnector' })(StepConnector);

/***/ }),
/* 5608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Collapse = __webpack_require__(1572);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      marginTop: theme.spacing.unit,
	      marginLeft: 12, // half icon
	      paddingLeft: theme.spacing.unit + 12, // margin + half icon
	      paddingRight: theme.spacing.unit,
	      borderLeft: '1px solid ' + (theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
	    },
	    last: {
	      borderLeft: 'none'
	    },
	    transition: {}
	  };
	};
	
	function StepContent(props) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      completed = props.completed,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      Transition = props.transition,
	      transitionDuration = props.transitionDuration,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'last', 'optional', 'orientation', 'transition', 'transitionDuration']);
	
	
	   false ? (0, _warning2.default)(orientation === 'vertical', 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.last, last), classNameProp);
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: className }, other),
	    _react2.default.createElement(
	      Transition,
	      {
	        'in': active,
	        className: classes.transition,
	        timeout: transitionDuration,
	        unmountOnExit: true
	      },
	      children
	    )
	  );
	}
	
	StepContent.propTypes =  false ? {
	  /**
	   * @ignore
	   * Expands the content.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Set internally by Step when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes2.default.bool,
	  /**
	   * Step content.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Set internally by Step when it's supplied with the optional property.
	   */
	  optional: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /**
	   * Collapse component.
	   */
	  transition: _propTypes2.default.func,
	  /**
	   * Adjust the duration of the content expand transition.
	   * Passed as a property to the transition component.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
	} : {};
	
	StepContent.defaultProps = {
	  transition: _Collapse2.default,
	  transitionDuration: 'auto'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepContent' })(StepContent);

/***/ }),
/* 5609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      color: theme.palette.action.disabled
	    },
	    active: {
	      color: theme.palette.primary.main
	    },
	    text: {
	      fill: theme.palette.primary.contrastText,
	      fontSize: theme.typography.caption.fontSize,
	      fontFamily: theme.typography.fontFamily
	    }
	  };
	};
	
	/**
	 * @ignore - internal component.
	 */
	
	var _ref = _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' });
	
	function StepPositionIcon(props) {
	  var position = props.position,
	      classes = props.classes,
	      classNameProp = props.className,
	      active = props.active;
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.active, active), classNameProp);
	
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    { className: className },
	    _ref,
	    _react2.default.createElement(
	      'text',
	      { className: classes.text, x: '12', y: '16', textAnchor: 'middle' },
	      position
	    )
	  );
	}
	
	StepPositionIcon.propTypes =  false ? {
	  /**
	   * Whether this step is active.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Classses for component style customizations.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The step position as a number.
	   */
	  position: _propTypes2.default.node
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepPosition' })(StepPositionIcon);

/***/ }),
/* 5610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Paper = __webpack_require__(279);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _StepConnector = __webpack_require__(5607);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent Paper
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      padding: theme.spacing.unit * 3
	    },
	    horizontal: {
	      flexDirection: 'row',
	      alignItems: 'center'
	    },
	    vertical: {
	      flexDirection: 'column'
	    }
	  };
	};
	
	function Stepper(props) {
	  var activeStep = props.activeStep,
	      alternativeLabel = props.alternativeLabel,
	      classes = props.classes,
	      classNameProp = props.className,
	      children = props.children,
	      connectorProp = props.connector,
	      nonLinear = props.nonLinear,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties3.default)(props, ['activeStep', 'alternativeLabel', 'classes', 'className', 'children', 'connector', 'nonLinear', 'orientation']);
	
	
	  var className = (0, _classnames2.default)(classes.root, classNameProp, alternativeLabel ? null : classes[orientation]);
	
	  var connector = connectorProp ? _react2.default.cloneElement(connectorProp, { orientation: orientation }) : null;
	  var childrenArray = _react2.default.Children.toArray(children);
	  var steps = childrenArray.map(function (step, index) {
	    var controlProps = {
	      index: index,
	      orientation: orientation,
	      active: false,
	      completed: false,
	      disabled: false,
	      last: index + 1 === childrenArray.length,
	      alternativeLabel: alternativeLabel,
	      connector: connectorProp
	    };
	
	    if (activeStep === index) {
	      controlProps.active = true;
	    } else if (!nonLinear && activeStep > index) {
	      controlProps.completed = true;
	    } else if (!nonLinear && activeStep < index) {
	      controlProps.disabled = true;
	    }
	
	    return [!alternativeLabel && connector && index > 0 && _react2.default.cloneElement(connector, {
	      key: 'connect-' + (index - 1) + '-to-' + index // eslint-disable-line react/no-array-index-key
	    }), _react2.default.cloneElement(step, (0, _extends3.default)({}, controlProps, step.props))];
	  });
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    (0, _extends3.default)({ square: true, elevation: 0, className: className }, other),
	    steps
	  );
	}
	
	Stepper.propTypes =  false ? {
	  /**
	   * Set the active step (zero based index).
	   */
	  activeStep: _propTypes2.default.number,
	  /**
	   * If set to 'true' and orientation is horizontal,
	   * then the step label will be positioned under the icon.
	   */
	  alternativeLabel: _propTypes2.default.bool,
	  /**
	   * Two or more `<Step />` components.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _propTypes2.default.element,
	  /**
	   * If set the `Stepper` will not assist in controlling steps for linear flow.
	   */
	  nonLinear: _propTypes2.default.bool,
	  /**
	   * The stepper orientation (layout flow direction).
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
	} : {};
	
	Stepper.defaultProps = {
	  activeStep: 0,
	  alternativeLabel: false,
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  nonLinear: false,
	  orientation: 'horizontal'
	};
	
	Stepper.muiName = 'Stepper';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepper' })(Stepper);

/***/ }),
/* 5611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Stepper = __webpack_require__(5610);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Stepper).default;
	  }
	});
	
	var _Step = __webpack_require__(5605);
	
	Object.defineProperty(exports, 'Step', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Step).default;
	  }
	});
	
	var _StepButton = __webpack_require__(5606);
	
	Object.defineProperty(exports, 'StepButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepButton).default;
	  }
	});
	
	var _StepContent = __webpack_require__(5608);
	
	Object.defineProperty(exports, 'StepContent', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepContent).default;
	  }
	});
	
	var _StepIcon = __webpack_require__(2380);
	
	Object.defineProperty(exports, 'StepIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepIcon).default;
	  }
	});
	
	var _StepLabel = __webpack_require__(2381);
	
	Object.defineProperty(exports, 'StepLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_StepLabel).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-block',
	      fill: 'currentColor',
	      height: 24,
	      width: 24,
	      userSelect: 'none',
	      flexShrink: 0,
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	    colorAction: {
	      color: theme.palette.action.active
	    },
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	    colorError: {
	      color: theme.palette.error.main
	    },
	    fontSize: {
	      width: '1em',
	      height: '1em'
	    }
	  };
	};
	
	function SvgIcon(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      fontSize = props.fontSize,
	      nativeColor = props.nativeColor,
	      titleAccess = props.titleAccess,
	      viewBox = props.viewBox,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'fontSize', 'nativeColor', 'titleAccess', 'viewBox']);
	
	
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), (0, _defineProperty3.default)(_classNames, classes.fontSize, fontSize), _classNames), classNameProp);
	
	  return _react2.default.createElement(
	    'svg',
	    (0, _extends3.default)({
	      className: className,
	      focusable: 'false',
	      viewBox: viewBox,
	      color: nativeColor,
	      'aria-hidden': titleAccess ? 'false' : 'true'
	    }, other),
	    titleAccess ? _react2.default.createElement(
	      'title',
	      null,
	      titleAccess
	    ) : null,
	    children
	  );
	}
	
	SvgIcon.propTypes =  false ? {
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
	   */
	  color: _propTypes2.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
	  /**
	   * If `true`, the icon size will be determined by the font-size.
	   */
	  fontSize: _propTypes2.default.bool,
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  nativeColor: _propTypes2.default.string,
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes2.default.string,
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes2.default.string
	} : {};
	
	SvgIcon.defaultProps = {
	  color: 'inherit',
	  fontSize: false,
	  viewBox: '0 0 24 24'
	};
	
	SvgIcon.muiName = 'SvgIcon';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSvgIcon' })(SvgIcon);

/***/ }),
/* 5613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _SwitchBase = __webpack_require__(1568);
	
	var _SwitchBase2 = _interopRequireDefault(_SwitchBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-flex',
	      width: 62,
	      position: 'relative',
	      flexShrink: 0,
	      // For correct alignment with the text.
	      verticalAlign: 'middle'
	    },
	    bar: {
	      borderRadius: 7,
	      display: 'block',
	      position: 'absolute',
	      width: 34,
	      height: 14,
	      top: '50%',
	      marginTop: -7,
	      left: '50%',
	      marginLeft: -17,
	      transition: theme.transitions.create(['opacity', 'background-color'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
	      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
	    },
	    icon: {
	      boxShadow: theme.shadows[1],
	      backgroundColor: 'currentColor',
	      width: 20,
	      height: 20,
	      borderRadius: '50%'
	    },
	    // For SwitchBase
	    default: {
	      zIndex: 1,
	      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
	      transition: theme.transitions.create('transform', {
	        duration: theme.transitions.duration.shortest
	      })
	    },
	    checked: {
	      color: theme.palette.primary.main,
	      transform: 'translateX(14px)',
	      '& + $bar': {
	        backgroundColor: theme.palette.primary.main,
	        opacity: 0.5
	      }
	    },
	    disabled: {
	      color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800],
	      '& + $bar': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
	        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
	      }
	    }
	  };
	};
	
	function Switch(props) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className']);
	
	  var icon = _react2.default.createElement('span', { className: classes.icon });
	
	  return _react2.default.createElement(
	    'span',
	    { className: (0, _classnames2.default)(classes.root, className) },
	    _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
	      icon: icon,
	      classes: {
	        default: classes.default,
	        checked: classes.checked,
	        disabled: classes.disabled
	      },
	      checkedIcon: icon
	    }, other)),
	    _react2.default.createElement('span', { className: classes.bar })
	  );
	}
	
	Switch.propTypes =  false ? {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes2.default.bool,
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Properties applied to the `input` element.
	   */
	  inputProps: _propTypes2.default.object,
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes2.default.func,
	  /**
	   * The input component property `type`.
	   */
	  inputType: _propTypes2.default.string,
	  /*
	   * @ignore
	   */
	  name: _propTypes2.default.string,
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {boolean} checked The `checked` value of the switch
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The value of the component.
	   */
	  value: _propTypes2.default.string
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSwitch' })(Switch);

/***/ }),
/* 5614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Switch = __webpack_require__(5613);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Switch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      overflow: 'hidden'
	    }
	  };
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3.default)(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3.default)(this, Table);
	    return (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      // eslint-disable-line class-methods-use-this
	      return {
	        table: {}
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          Component = _props.component,
	          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'component']);
	
	
	      return _react2.default.createElement(Component, (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other));
	    }
	  }]);
	  return Table;
	}(_react2.default.Component);
	
	Table.propTypes =  false ? {
	  /**
	   * The content of the table, normally `TableHeader` and `TableBody`.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	} : {};
	
	Table.defaultProps = {
	  component: 'table'
	};
	
	Table.childContextTypes = {
	  table: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTable' })(Table);

/***/ }),
/* 5616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableBody = function (_React$Component) {
	  (0, _inherits3.default)(TableBody, _React$Component);
	
	  function TableBody() {
	    (0, _classCallCheck3.default)(this, TableBody);
	    return (0, _possibleConstructorReturn3.default)(this, (TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableBody, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      // eslint-disable-line class-methods-use-this
	      return {
	        table: {
	          body: true
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          other = (0, _objectWithoutProperties3.default)(_props, ['component']);
	
	
	      return _react2.default.createElement(Component, other);
	    }
	  }]);
	  return TableBody;
	}(_react2.default.Component);
	
	TableBody.propTypes =  false ? {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	} : {};
	
	TableBody.defaultProps = {
	  component: 'tbody'
	};
	
	TableBody.childContextTypes = {
	  table: _propTypes2.default.object
	};
	
	exports.default = TableBody;

/***/ }),
/* 5617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableFooter = function (_React$Component) {
	  (0, _inherits3.default)(TableFooter, _React$Component);
	
	  function TableFooter() {
	    (0, _classCallCheck3.default)(this, TableFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableFooter, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      // eslint-disable-line class-methods-use-this
	      return {
	        table: {
	          footer: true
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          other = (0, _objectWithoutProperties3.default)(_props, ['component']);
	
	
	      return _react2.default.createElement(Component, other);
	    }
	  }]);
	  return TableFooter;
	}(_react2.default.Component);
	
	TableFooter.propTypes =  false ? {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	} : {};
	
	TableFooter.defaultProps = {
	  component: 'tfoot'
	};
	
	TableFooter.childContextTypes = {
	  table: _propTypes2.default.object
	};
	
	exports.default = TableFooter;

/***/ }),
/* 5618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableHead = function (_React$Component) {
	  (0, _inherits3.default)(TableHead, _React$Component);
	
	  function TableHead() {
	    (0, _classCallCheck3.default)(this, TableHead);
	    return (0, _possibleConstructorReturn3.default)(this, (TableHead.__proto__ || (0, _getPrototypeOf2.default)(TableHead)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableHead, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      // eslint-disable-line class-methods-use-this
	      return {
	        table: {
	          head: true
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.component,
	          other = (0, _objectWithoutProperties3.default)(_props, ['component']);
	
	
	      return _react2.default.createElement(Component, other);
	    }
	  }]);
	  return TableHead;
	}(_react2.default.Component);
	
	TableHead.propTypes =  false ? {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	} : {};
	
	TableHead.defaultProps = {
	  component: 'thead'
	};
	
	TableHead.childContextTypes = {
	  table: _propTypes2.default.object
	};
	
	exports.default = TableHead;

/***/ }),
/* 5619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Input = __webpack_require__(991);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Menu = __webpack_require__(1565);
	
	var _Select = __webpack_require__(2378);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _TableCell = __webpack_require__(2382);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _Toolbar = __webpack_require__(2384);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _Typography = __webpack_require__(326);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _TablePaginationActions = __webpack_require__(5620);
	
	var _TablePaginationActions2 = _interopRequireDefault(_TablePaginationActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent TableCell
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      // Increase the specificity to override TableCell.
	      '&:last-child': {
	        padding: 0
	      }
	    },
	    toolbar: {
	      height: 56,
	      minHeight: 56,
	      paddingRight: 2
	    },
	    spacer: {
	      flex: '1 1 100%'
	    },
	    caption: {
	      flexShrink: 0
	    },
	    input: {
	      fontSize: 'inherit',
	      flexShrink: 0
	    },
	    selectRoot: {
	      marginRight: theme.spacing.unit * 4,
	      marginLeft: theme.spacing.unit,
	      color: theme.palette.text.secondary
	    },
	    select: {
	      paddingLeft: theme.spacing.unit,
	      paddingRight: theme.spacing.unit * 2
	    },
	    selectIcon: {
	      top: 1
	    },
	    actions: {
	      flexShrink: 0,
	      color: theme.palette.text.secondary,
	      marginLeft: theme.spacing.unit * 2.5
	    }
	  };
	};
	
	/**
	 * A `TableCell` based component for placing inside `TableFooter` for pagination.
	 */
	
	var TablePagination = function (_React$Component) {
	  (0, _inherits3.default)(TablePagination, _React$Component);
	
	  function TablePagination() {
	    (0, _classCallCheck3.default)(this, TablePagination);
	    return (0, _possibleConstructorReturn3.default)(this, (TablePagination.__proto__ || (0, _getPrototypeOf2.default)(TablePagination)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TablePagination, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var count = nextProps.count,
	          onChangePage = nextProps.onChangePage,
	          rowsPerPage = nextProps.rowsPerPage;
	
	      var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
	      if (this.props.page > newLastPage) {
	        onChangePage(null, newLastPage);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Actions = _props.Actions,
	          backIconButtonProps = _props.backIconButtonProps,
	          classes = _props.classes,
	          colSpanProp = _props.colSpan,
	          Component = _props.component,
	          count = _props.count,
	          labelDisplayedRows = _props.labelDisplayedRows,
	          labelRowsPerPage = _props.labelRowsPerPage,
	          nextIconButtonProps = _props.nextIconButtonProps,
	          onChangePage = _props.onChangePage,
	          onChangeRowsPerPage = _props.onChangeRowsPerPage,
	          page = _props.page,
	          rowsPerPage = _props.rowsPerPage,
	          rowsPerPageOptions = _props.rowsPerPageOptions,
	          other = (0, _objectWithoutProperties3.default)(_props, ['Actions', 'backIconButtonProps', 'classes', 'colSpan', 'component', 'count', 'labelDisplayedRows', 'labelRowsPerPage', 'nextIconButtonProps', 'onChangePage', 'onChangeRowsPerPage', 'page', 'rowsPerPage', 'rowsPerPageOptions']);
	
	
	      var colSpan = void 0;
	
	      if (Component === _TableCell2.default || Component === 'td') {
	        colSpan = colSpanProp || 1000; // col-span over everything
	      }
	
	      return _react2.default.createElement(
	        Component,
	        (0, _extends3.default)({ className: classes.root, colSpan: colSpan }, other),
	        _react2.default.createElement(
	          _Toolbar2.default,
	          { className: classes.toolbar },
	          _react2.default.createElement('div', { className: classes.spacer }),
	          rowsPerPageOptions.length > 1 && _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'caption', className: classes.caption },
	            labelRowsPerPage
	          ),
	          rowsPerPageOptions.length > 1 && _react2.default.createElement(
	            _Select2.default,
	            {
	              classes: {
	                root: classes.selectRoot,
	                select: classes.select,
	                icon: classes.selectIcon
	              },
	              input: _react2.default.createElement(_Input2.default, {
	                classes: {
	                  root: classes.input
	                },
	                disableUnderline: true
	              }),
	              value: rowsPerPage,
	              onChange: onChangeRowsPerPage
	            },
	            rowsPerPageOptions.map(function (rowsPerPageOption) {
	              return _react2.default.createElement(
	                _Menu.MenuItem,
	                { key: rowsPerPageOption, value: rowsPerPageOption },
	                rowsPerPageOption
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'caption', className: classes.caption },
	            labelDisplayedRows({
	              from: count === 0 ? 0 : page * rowsPerPage + 1,
	              to: Math.min(count, (page + 1) * rowsPerPage),
	              count: count,
	              page: page
	            })
	          ),
	          _react2.default.createElement(Actions, {
	            backIconButtonProps: backIconButtonProps,
	            count: count,
	            nextIconButtonProps: nextIconButtonProps,
	            onChangePage: onChangePage,
	            page: page,
	            rowsPerPage: rowsPerPage
	          })
	        )
	      );
	    }
	  }]);
	  return TablePagination;
	}(_react2.default.Component);
	
	TablePagination.propTypes =  false ? {
	  /**
	   * The component used for displaying the actions.
	   * Either a string to use a DOM element or a component.
	   */
	  Actions: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * Properties applied to the back arrow `IconButton` component.
	   */
	  backIconButtonProps: _propTypes2.default.object,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  colSpan: _propTypes2.default.number,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes2.default.number.isRequired,
	  /**
	   * Useful to customize the displayed rows label.
	   */
	  labelDisplayedRows: _propTypes2.default.func,
	  /**
	   * Useful to customize the rows per page label. Invoked with a `{ from, to, count, page }`
	   * object.
	   */
	  labelRowsPerPage: _propTypes2.default.node,
	  /**
	   * Properties applied to the next arrow `IconButton` component.
	   */
	  nextIconButtonProps: _propTypes2.default.object,
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {number} page The page selected
	   */
	  onChangePage: _propTypes2.default.func.isRequired,
	  /**
	   * Callback fired when the number of rows per page is changed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onChangeRowsPerPage: _propTypes2.default.func,
	  /**
	   * The zero-based index of the current page.
	   */
	  page: _propTypes2.default.number.isRequired,
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes2.default.number.isRequired,
	  /**
	   * Customizes the options of the rows per page select field. If less than two options are
	   * available, no select field will be displayed.
	   */
	  rowsPerPageOptions: _propTypes2.default.array
	} : {};
	
	TablePagination.defaultProps = {
	  Actions: _TablePaginationActions2.default,
	  component: _TableCell2.default,
	  labelDisplayedRows: function labelDisplayedRows(_ref) {
	    var from = _ref.from,
	        to = _ref.to,
	        count = _ref.count;
	    return from + '-' + to + ' of ' + count;
	  },
	  labelRowsPerPage: 'Rows per page:',
	  rowsPerPageOptions: [5, 10, 25]
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTablePagination' })(TablePagination);

/***/ }),
/* 5620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyboardArrowLeft = __webpack_require__(2390);
	
	var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);
	
	var _KeyboardArrowRight = __webpack_require__(2391);
	
	var _KeyboardArrowRight2 = _interopRequireDefault(_KeyboardArrowRight);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _IconButton = __webpack_require__(990);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      flexShrink: 0,
	      color: theme.palette.text.secondary,
	      marginLeft: theme.spacing.unit * 2.5
	    }
	  };
	};
	
	/**
	 * @ignore - internal component.
	 */
	
	var _ref2 = _react2.default.createElement(_KeyboardArrowRight2.default, null);
	
	var _ref3 = _react2.default.createElement(_KeyboardArrowLeft2.default, null);
	
	var _ref4 = _react2.default.createElement(_KeyboardArrowLeft2.default, null);
	
	var _ref5 = _react2.default.createElement(_KeyboardArrowRight2.default, null);
	
	var TablePaginationActions = function (_React$Component) {
	  (0, _inherits3.default)(TablePaginationActions, _React$Component);
	
	  function TablePaginationActions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TablePaginationActions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TablePaginationActions.__proto__ || (0, _getPrototypeOf2.default)(TablePaginationActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleBackButtonClick = function (event) {
	      _this.props.onChangePage(event, _this.props.page - 1);
	    }, _this.handleNextButtonClick = function (event) {
	      _this.props.onChangePage(event, _this.props.page + 1);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TablePaginationActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backIconButtonProps = _props.backIconButtonProps,
	          classes = _props.classes,
	          count = _props.count,
	          nextIconButtonProps = _props.nextIconButtonProps,
	          onChangePage = _props.onChangePage,
	          page = _props.page,
	          rowsPerPage = _props.rowsPerPage,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backIconButtonProps', 'classes', 'count', 'nextIconButtonProps', 'onChangePage', 'page', 'rowsPerPage', 'theme']);
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ className: classes.root }, other),
	        _react2.default.createElement(
	          _IconButton2.default,
	          (0, _extends3.default)({
	            onClick: this.handleBackButtonClick,
	            disabled: page === 0
	          }, backIconButtonProps),
	          theme.direction === 'rtl' ? _ref2 : _ref3
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          (0, _extends3.default)({
	            onClick: this.handleNextButtonClick,
	            disabled: page >= Math.ceil(count / rowsPerPage) - 1
	          }, nextIconButtonProps),
	          theme.direction === 'rtl' ? _ref4 : _ref5
	        )
	      );
	    }
	  }]);
	  return TablePaginationActions;
	}(_react2.default.Component);
	
	TablePaginationActions.propTypes =  false ? {
	  /**
	   * Properties applied to the back arrow `IconButton` component.
	   */
	  backIconButtonProps: _propTypes2.default.object,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes2.default.number.isRequired,
	  /**
	   * Properties applied to the next arrow `IconButton` component.
	   */
	  nextIconButtonProps: _propTypes2.default.object,
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback
	   * @param {number} page The page selected
	   */
	  onChangePage: _propTypes2.default.func.isRequired,
	  /**
	   * The zero-based index of the current page.
	   */
	  page: _propTypes2.default.number.isRequired,
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes2.default.number.isRequired,
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTablePaginationActions', withTheme: true })(TablePaginationActions);

/***/ }),
/* 5621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      color: 'inherit',
	      display: 'table-row',
	      height: 48,
	      '&:focus': {
	        outline: 'none'
	      },
	      verticalAlign: 'middle'
	    },
	    typeHead: {
	      height: 56
	    },
	    typeFooter: {
	      height: 56
	    },
	    selected: {
	      backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
	      : 'rgba(255, 255, 255, 0.08)'
	    },
	    hover: {
	      '&:hover': {
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
	        : 'rgba(255, 255, 255, 0.14)'
	      }
	    }
	  };
	};
	
	/**
	 * Will automatically set dynamic row height
	 * based on the material table element parent (head, body, etc).
	 */
	function TableRow(props, context) {
	  var _classNames;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      hover = props.hover,
	      selected = props.selected,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'hover', 'selected']);
	  var table = context.table;
	
	
	  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.typeHead, table && table.head), (0, _defineProperty3.default)(_classNames, classes.typeFooter, table && table.footer), (0, _defineProperty3.default)(_classNames, classes.hover, table && hover), (0, _defineProperty3.default)(_classNames, classes.selected, table && selected), _classNames), classNameProp);
	
	  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
	}
	
	TableRow.propTypes =  false ? {
	  /**
	   * Should be valid `<tr>` children such as `TableCell`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the table row will shade on hover.
	   */
	  hover: _propTypes2.default.bool,
	  /**
	   * If `true`, the table row will have the selected shading.
	   */
	  selected: _propTypes2.default.bool
	} : {};
	
	TableRow.defaultProps = {
	  component: 'tr',
	  hover: false,
	  selected: false
	};
	
	TableRow.contextTypes = {
	  table: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableRow' })(TableRow);

/***/ }),
/* 5622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ArrowDownward = __webpack_require__(5649);
	
	var _ArrowDownward2 = _interopRequireDefault(_ArrowDownward);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ButtonBase = __webpack_require__(278);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent ButtonBase
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      cursor: 'pointer',
	      display: 'inline-flex',
	      justifyContent: 'flex-start',
	      flexDirection: 'inherit',
	      alignItems: 'center',
	      '&:hover': {
	        color: theme.palette.text.primary
	      },
	      '&:focus': {
	        color: theme.palette.text.primary
	      }
	    },
	    active: {
	      color: theme.palette.text.primary,
	      '& $icon': {
	        opacity: 1
	      }
	    },
	    icon: {
	      height: 16,
	      marginRight: 4,
	      marginLeft: 4,
	      opacity: 0,
	      transition: theme.transitions.create(['opacity', 'transform'], {
	        duration: theme.transitions.duration.shorter
	      }),
	      userSelect: 'none',
	      width: 16
	    },
	    desc: {
	      transform: 'rotate(0deg)'
	    },
	    asc: {
	      transform: 'rotate(180deg)'
	    }
	  };
	};
	
	/**
	 * A button based label for placing inside `TableCell` for column sorting.
	 */
	function TableSortLabel(props) {
	  var active = props.active,
	      classes = props.classes,
	      classNameProp = props.className,
	      children = props.children,
	      direction = props.direction,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'classes', 'className', 'children', 'direction']);
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.active, active), classNameProp);
	
	  var iconClassName = (0, _classnames2.default)(classes.icon, (0, _defineProperty3.default)({}, classes[direction], !!direction));
	
	  return _react2.default.createElement(
	    _ButtonBase2.default,
	    (0, _extends3.default)({ className: className, component: 'span', disableRipple: true }, other),
	    children,
	    _react2.default.createElement(_ArrowDownward2.default, { className: iconClassName })
	  );
	}
	
	TableSortLabel.propTypes =  false ? {
	  /**
	   * If `true`, the label will have the active styling (should be true for the sorted column).
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Label contents, the arrow will be appended automatically.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The current sort direction.
	   */
	  direction: _propTypes2.default.oneOf(['asc', 'desc'])
	} : {};
	
	TableSortLabel.defaultProps = {
	  active: false,
	  direction: 'desc'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableSortLabel' })(TableSortLabel);

/***/ }),
/* 5623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Table = __webpack_require__(5615);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Table).default;
	  }
	});
	
	var _TableBody = __webpack_require__(5616);
	
	Object.defineProperty(exports, 'TableBody', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableBody).default;
	  }
	});
	
	var _TableCell = __webpack_require__(2382);
	
	Object.defineProperty(exports, 'TableCell', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableCell).default;
	  }
	});
	
	var _TableFooter = __webpack_require__(5617);
	
	Object.defineProperty(exports, 'TableFooter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableFooter).default;
	  }
	});
	
	var _TableHead = __webpack_require__(5618);
	
	Object.defineProperty(exports, 'TableHead', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableHead).default;
	  }
	});
	
	var _TablePagination = __webpack_require__(5619);
	
	Object.defineProperty(exports, 'TablePagination', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TablePagination).default;
	  }
	});
	
	var _TableRow = __webpack_require__(5621);
	
	Object.defineProperty(exports, 'TableRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableRow).default;
	  }
	});
	
	var _TableSortLabel = __webpack_require__(5622);
	
	Object.defineProperty(exports, 'TableSortLabel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TableSortLabel).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      height: 2,
	      bottom: 0,
	      width: '100%',
	      transition: theme.transitions.create(),
	      willChange: 'left, width'
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    }
	  };
	};
	
	/**
	 * @ignore - internal component.
	 */
	function TabIndicator(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      styleProp = props.style;
	
	  var colorPredefined = ['primary', 'secondary'].indexOf(color) !== -1;
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], colorPredefined), classNameProp);
	
	  var style = colorPredefined ? styleProp : (0, _extends3.default)({}, styleProp, {
	    backgroundColor: color
	  });
	
	  return _react2.default.createElement('span', { className: className, style: style });
	}
	
	TabIndicator.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   * The color of the tab indicator.
	   */
	  color: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(['primary', 'secondary'])]),
	  /**
	   * @ignore
	   * The style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTabIndicator' })(TabIndicator);

/***/ }),
/* 5625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _KeyboardArrowLeft = __webpack_require__(2390);
	
	var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);
	
	var _KeyboardArrowRight = __webpack_require__(2391);
	
	var _KeyboardArrowRight2 = _interopRequireDefault(_KeyboardArrowRight);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _ButtonBase = __webpack_require__(278);
	
	var _ButtonBase2 = _interopRequireDefault(_ButtonBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      color: 'inherit',
	      flex: '0 0 ' + theme.spacing.unit * 7 + 'px'
	    }
	  };
	};
	
	/**
	 * @ignore - internal component.
	 */
	
	var _ref = _react2.default.createElement(_KeyboardArrowLeft2.default, null);
	
	var _ref2 = _react2.default.createElement(_KeyboardArrowRight2.default, null);
	
	function TabScrollButton(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      direction = props.direction,
	      onClick = props.onClick,
	      visible = props.visible,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'direction', 'onClick', 'visible']);
	
	
	  var className = (0, _classnames2.default)(classes.root, classNameProp);
	
	  if (!visible) {
	    return _react2.default.createElement('div', { className: className });
	  }
	
	  return _react2.default.createElement(
	    _ButtonBase2.default,
	    (0, _extends3.default)({ className: className, onClick: onClick, tabIndex: -1 }, other),
	    direction === 'left' ? _ref : _ref2
	  );
	}
	
	TabScrollButton.propTypes =  false ? {
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Which direction should the button indicate?
	   */
	  direction: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Callback to execute for button press.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Should the button be present or just consume space.
	   */
	  visible: _propTypes2.default.bool
	} : {};
	
	TabScrollButton.defaultProps = {
	  visible: true
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTabScrollButton' })(TabScrollButton);

/***/ }),
/* 5626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Input = __webpack_require__(991);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _FormControl = __webpack_require__(2364);
	
	var _FormControl2 = _interopRequireDefault(_FormControl);
	
	var _FormHelperText = __webpack_require__(2366);
	
	var _FormHelperText2 = _interopRequireDefault(_FormHelperText);
	
	var _Select = __webpack_require__(2377);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `TextField` is a convenience wrapper for the most common cases (80%).
	 * It cannot be all things to all people, otherwise the API would grow out of control.
	 *
	 * ## Advanced Configuration
	 *
	 * It's important to understand that the text field is a simple abstraction
	 * on top of the following components:
	 * - [FormControl](/api/form-control)
	 * - [InputLabel](/api/input-label)
	 * - [Input](/api/input)
	 * - [FormHelperText](/api/form-helper-text)
	 *
	 * If you wish to alter the properties applied to the native input, you can do as follow:
	 *
	 * ```jsx
	 * const inputProps = {
	 *   step: 300,
	 * };
	 *
	 * return <TextField id="time" type="time" inputProps={inputProps} />;
	 * ```
	 *
	 * For advanced cases, please look at the source of TextField by clicking on the
	 * "Edit this page" button above. Consider either:
	 * - using the upper case props for passing values direct to the components.
	 * - using the underlying components directly as shown in the demos.
	 */
	function TextField(props) {
	  var autoComplete = props.autoComplete,
	      autoFocus = props.autoFocus,
	      children = props.children,
	      className = props.className,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      error = props.error,
	      FormHelperTextProps = props.FormHelperTextProps,
	      fullWidth = props.fullWidth,
	      helperText = props.helperText,
	      helperTextClassName = props.helperTextClassName,
	      id = props.id,
	      InputLabelProps = props.InputLabelProps,
	      inputProps = props.inputProps,
	      InputProps = props.InputProps,
	      inputRef = props.inputRef,
	      label = props.label,
	      labelClassName = props.labelClassName,
	      multiline = props.multiline,
	      name = props.name,
	      onChange = props.onChange,
	      placeholder = props.placeholder,
	      required = props.required,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      select = props.select,
	      SelectProps = props.SelectProps,
	      type = props.type,
	      value = props.value,
	      other = (0, _objectWithoutProperties3.default)(props, ['autoComplete', 'autoFocus', 'children', 'className', 'defaultValue', 'disabled', 'error', 'FormHelperTextProps', 'fullWidth', 'helperText', 'helperTextClassName', 'id', 'InputLabelProps', 'inputProps', 'InputProps', 'inputRef', 'label', 'labelClassName', 'multiline', 'name', 'onChange', 'placeholder', 'required', 'rows', 'rowsMax', 'select', 'SelectProps', 'type', 'value']);
	
	
	   false ? (0, _warning2.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;
	
	  var helperTextId = helperText && id ? id + '-helper-text' : undefined;
	  var InputComponent = _react2.default.createElement(_Input2.default, (0, _extends3.default)({
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    disabled: disabled,
	    fullWidth: fullWidth,
	    multiline: multiline,
	    name: name,
	    rows: rows,
	    rowsMax: rowsMax,
	    type: type,
	    value: value,
	    id: id,
	    inputRef: inputRef,
	    onChange: onChange,
	    placeholder: placeholder,
	    inputProps: inputProps
	  }, InputProps));
	
	  return _react2.default.createElement(
	    _FormControl2.default,
	    (0, _extends3.default)({
	      'aria-describedby': helperTextId,
	      className: className,
	      error: error,
	      fullWidth: fullWidth,
	      required: required
	    }, other),
	    label && _react2.default.createElement(
	      _Input.InputLabel,
	      (0, _extends3.default)({ htmlFor: id, className: labelClassName }, InputLabelProps),
	      label
	    ),
	    select ? _react2.default.createElement(
	      _Select2.default,
	      (0, _extends3.default)({ value: value, input: InputComponent }, SelectProps),
	      children
	    ) : InputComponent,
	    helperText && _react2.default.createElement(
	      _FormHelperText2.default,
	      (0, _extends3.default)({ className: helperTextClassName, id: helperTextId }, FormHelperTextProps),
	      helperText
	    )
	  );
	} // @inheritedComponent FormControl
	
	TextField.propTypes =  false ? {
	  /**
	   * This property helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it here:
	   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
	   */
	  autoComplete: _propTypes2.default.string,
	  /**
	   * If `true`, the input will be focused during the first mount.
	   */
	  autoFocus: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The default value of the `Input` element.
	   */
	  defaultValue: _propTypes2.default.string,
	  /**
	   * If `true`, the input will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * Properties applied to the `FormHelperText` element.
	   */
	  FormHelperTextProps: _propTypes2.default.object,
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The helper text content.
	   */
	  helperText: _propTypes2.default.node,
	  /**
	   * The CSS class name of the helper text element.
	   */
	  helperTextClassName: _propTypes2.default.string,
	  /**
	   * The id of the `input` element.
	   * Use that property to make `label` and `helperText` accessible for screen readers.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Properties applied to the `InputLabel` element.
	   */
	  InputLabelProps: _propTypes2.default.object,
	  /**
	   * Properties applied to the `Input` element.
	   */
	  InputProps: _propTypes2.default.object,
	  /**
	   * Properties applied to the native `input` element.
	   */
	  inputProps: _propTypes2.default.object,
	  /**
	   * Use that property to pass a ref callback to the native input component.
	   */
	  inputRef: _propTypes2.default.func,
	  /**
	   * The label content.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * The CSS class name of the label element.
	   */
	  labelClassName: _propTypes2.default.string,
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes2.default.oneOf(['none', 'dense', 'normal']),
	  /**
	   * If `true`, a textarea element will be rendered instead of an input.
	   */
	  multiline: _propTypes2.default.bool,
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes2.default.string,
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes2.default.string,
	  /**
	   * If `true`, the label is displayed as required.
	   */
	  required: _propTypes2.default.bool,
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
	   * If this option is set you must pass the options of the select as children.
	   */
	  select: _propTypes2.default.bool,
	  /**
	   * Properties applied to the `Select` element.
	   */
	  SelectProps: _propTypes2.default.object,
	  /**
	   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
	   */
	  type: _propTypes2.default.string,
	  /**
	   * The value of the `Input` element, required for a controlled component.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
	} : {};
	
	TextField.defaultProps = {
	  required: false,
	  select: false
	};
	
	exports.default = TextField;

/***/ }),
/* 5627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TextField = __webpack_require__(5626);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextField).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: (0, _extends3.default)({
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center'
	    }, theme.mixins.toolbar),
	    gutters: theme.mixins.gutters({})
	  };
	};
	
	function Toolbar(props) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableGutters = props.disableGutters,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableGutters']);
	
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.gutters, !disableGutters), classNameProp);
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({ className: className }, other),
	    children
	  );
	}
	
	Toolbar.propTypes =  false ? {
	  /**
	   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If `true`, disables gutter padding.
	   */
	  disableGutters: _propTypes2.default.bool
	} : {};
	
	Toolbar.defaultProps = {
	  disableGutters: false
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiToolbar' })(Toolbar);

/***/ }),
/* 5629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _debounce = __webpack_require__(469);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactPopper = __webpack_require__(6243);
	
	var _helpers = __webpack_require__(127);
	
	var _RefHolder = __webpack_require__(2389);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _common = __webpack_require__(1567);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable react/no-multi-comp, no-underscore-dangle */
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline',
	      flexDirection: 'inherit' // Makes the wrapper more transparent.
	    },
	    popper: {
	      zIndex: theme.zIndex.tooltip
	    },
	    popperClose: {
	      pointerEvents: 'none'
	    },
	    tooltip: (0, _defineProperty3.default)({
	      backgroundColor: theme.palette.grey[700],
	      borderRadius: 2,
	      color: _common2.default.white,
	      fontFamily: theme.typography.fontFamily,
	      opacity: 0,
	      transform: 'scale(0)',
	      transition: theme.transitions.create(['opacity', 'transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      minHeight: 0,
	      padding: theme.spacing.unit,
	      fontSize: theme.typography.pxToRem(14),
	      lineHeight: theme.typography.round(16 / 14) + 'em'
	    }, theme.breakpoints.up('sm'), {
	      padding: theme.spacing.unit / 2 + 'px ' + theme.spacing.unit + 'px',
	      fontSize: theme.typography.pxToRem(10),
	      lineHeight: theme.typography.round(14 / 10) + 'em'
	    }),
	    tooltipLeft: (0, _defineProperty3.default)({
	      transformOrigin: 'right center',
	      margin: '0 ' + theme.spacing.unit * 3 + 'px'
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	    tooltipRight: (0, _defineProperty3.default)({
	      transformOrigin: 'left center',
	      margin: '0 ' + theme.spacing.unit * 3 + 'px'
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	    tooltipTop: (0, _defineProperty3.default)({
	      transformOrigin: 'center bottom',
	      margin: theme.spacing.unit * 3 + 'px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    }),
	    tooltipBottom: (0, _defineProperty3.default)({
	      transformOrigin: 'center top',
	      margin: theme.spacing.unit * 3 + 'px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    }),
	    tooltipOpen: {
	      opacity: 0.9,
	      transform: 'scale(1)'
	    }
	  };
	};
	
	function flipPlacement(placement) {
	  switch (placement) {
	    case 'bottom-end':
	      return 'bottom-start';
	    case 'bottom-start':
	      return 'bottom-end';
	    case 'top-end':
	      return 'top-start';
	    case 'top-start':
	      return 'top-end';
	    default:
	      return placement;
	  }
	}
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3.default)(Tooltip, _React$Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.enterTimer = null, _this.leaveTimer = null, _this.touchTimer = null, _this.isControlled = null, _this.popper = null, _this.children = null, _this.ignoreNonTouchEvents = false, _this.handleResize = (0, _debounce2.default)(function () {
	      if (_this.popper) {
	        _this.popper._popper.scheduleUpdate();
	      }
	    }, 166), _this.handleRequestOpen = function (event) {
	      var children = _this.props.children;
	
	      var childrenProps = children.props;
	
	      if (event.type === 'focus' && childrenProps.onFocus) {
	        childrenProps.onFocus(event);
	      }
	
	      if (event.type === 'mouseover' && childrenProps.onMouseOver) {
	        childrenProps.onMouseOver(event);
	      }
	
	      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
	        return;
	      }
	
	      clearTimeout(_this.leaveTimer);
	      if (_this.props.enterDelay > 0) {
	        _this.leaveTimer = setTimeout(function () {
	          _this.requestOpen(event);
	        }, _this.props.enterDelay);
	      } else {
	        _this.requestOpen(event);
	      }
	    }, _this.requestOpen = function (event) {
	      if (!_this.isControlled) {
	        _this.setState({ open: true });
	      }
	
	      if (_this.props.onOpen) {
	        _this.props.onOpen(event, true);
	      }
	    }, _this.handleClose = function (event) {
	      var children = _this.props.children;
	
	      var childrenProps = children.props;
	
	      if (event.type === 'blur' && childrenProps.onBlur) {
	        childrenProps.onBlur(event);
	      }
	
	      if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
	        childrenProps.onMouseLeave(event);
	      }
	
	      clearTimeout(_this.leaveTimer);
	      if (_this.props.leaveDelay) {
	        _this.leaveTimer = setTimeout(function () {
	          _this.requestClose(event);
	        }, _this.props.leaveDelay);
	      } else {
	        _this.requestClose(event);
	      }
	    }, _this.requestClose = function (event) {
	      _this.ignoreNonTouchEvents = false;
	
	      if (!_this.isControlled) {
	        _this.setState({ open: false });
	      }
	
	      if (_this.props.onClose) {
	        _this.props.onClose(event, false);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.ignoreNonTouchEvents = true;
	      var children = _this.props.children;
	
	      var childrenProps = children.props;
	
	      if (childrenProps.onTouchStart) {
	        childrenProps.onTouchStart(event);
	      }
	
	      clearTimeout(_this.touchTimer);
	      event.persist();
	      _this.touchTimer = setTimeout(function () {
	        _this.handleRequestOpen(event);
	      }, 1e3);
	    }, _this.handleTouchEnd = function (event) {
	      var children = _this.props.children;
	
	      var childrenProps = children.props;
	
	      if (childrenProps.onTouchEnd) {
	        childrenProps.onTouchEnd(event);
	      }
	
	      clearTimeout(_this.touchTimer);
	      clearTimeout(_this.leaveTimer);
	      event.persist();
	      _this.leaveTimer = setTimeout(function () {
	        _this.requestClose(event);
	      }, 1500 + _this.props.leaveDelay);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var props = this.props;
	
	
	      this.isControlled = props.open != null;
	
	      if (!this.isControlled) {
	        // not controlled, use internal state
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.children || !this.children.disabled || !this.children.tagName.toLowerCase() === 'button', ['Material-UI: you are providing a disabled button children to the Tooltip component.', 'A disabled element do not fire events.', 'But the Tooltip needs to listen to the children element events to display the title.', '', 'Place a `div` over top of the element.'].join('\n')) : void 0;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	      this.handleResize.cancel();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          disableTriggerFocus = _props.disableTriggerFocus,
	          disableTriggerHover = _props.disableTriggerHover,
	          disableTriggerTouch = _props.disableTriggerTouch,
	          enterDelay = _props.enterDelay,
	          id = _props.id,
	          leaveDelay = _props.leaveDelay,
	          onClose = _props.onClose,
	          onOpen = _props.onOpen,
	          openProp = _props.open,
	          rawPlacement = _props.placement,
	          _props$PopperProps = _props.PopperProps;
	      _props$PopperProps = _props$PopperProps === undefined ? {} : _props$PopperProps;
	      var PopperClassName = _props$PopperProps.PopperClassName,
	          PopperOther = (0, _objectWithoutProperties3.default)(_props$PopperProps, ['PopperClassName']),
	          theme = _props.theme,
	          title = _props.title,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'disableTriggerFocus', 'disableTriggerHover', 'disableTriggerTouch', 'enterDelay', 'id', 'leaveDelay', 'onClose', 'onOpen', 'open', 'placement', 'PopperProps', 'theme', 'title']);
	
	
	      var placement = theme.direction === 'rtl' ? flipPlacement(rawPlacement) : rawPlacement;
	      var open = this.isControlled ? openProp : this.state.open;
	      var childrenProps = {};
	
	      if (title === '') {
	        open = false;
	      }
	
	      childrenProps['aria-describedby'] = id;
	
	      if (!disableTriggerTouch) {
	        childrenProps.onTouchStart = this.handleTouchStart;
	        childrenProps.onTouchEnd = this.handleTouchEnd;
	      }
	
	      if (!disableTriggerHover) {
	        childrenProps.onMouseOver = this.handleRequestOpen;
	        childrenProps.onMouseLeave = this.handleClose;
	      }
	
	      if (!disableTriggerFocus) {
	        childrenProps.onFocus = this.handleRequestOpen;
	        childrenProps.onBlur = this.handleClose;
	      }
	
	       false ? (0, _warning2.default)(!childrenProp.props.title, ['Material-UI: you have been providing a `title` property to the child of <Tooltip />.', 'Remove this title property `' + childrenProp.props.title + '` or the Tooltip component.'].join('\n')) : void 0;
	
	      return _react2.default.createElement(
	        _reactEventListener2.default,
	        { target: 'window', onResize: this.handleResize },
	        _react2.default.createElement(
	          _reactPopper.Manager,
	          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
	          _react2.default.createElement(
	            _reactPopper.Target,
	            null,
	            function (_ref2) {
	              var targetProps = _ref2.targetProps;
	              return _react2.default.createElement(
	                _RefHolder2.default,
	                {
	                  ref: function ref(node) {
	                    _this2.children = (0, _reactDom.findDOMNode)(node);
	                    targetProps.ref(_this2.children);
	                  }
	                },
	                _react2.default.cloneElement(childrenProp, childrenProps)
	              );
	            }
	          ),
	          _react2.default.createElement(
	            _reactPopper.Popper,
	            (0, _extends3.default)({
	              placement: placement,
	              eventsEnabled: open,
	              className: (0, _classnames2.default)(classes.popper, (0, _defineProperty3.default)({}, classes.popperClose, !open), PopperClassName)
	            }, PopperOther, {
	              ref: function ref(node) {
	                _this2.popper = node;
	              }
	            }),
	            function (_ref3) {
	              var popperProps = _ref3.popperProps,
	                  restProps = _ref3.restProps;
	
	              var actualPlacement = popperProps['data-placement'] || placement;
	              return _react2.default.createElement(
	                'div',
	                (0, _extends3.default)({}, popperProps, restProps, {
	                  style: (0, _extends3.default)({}, popperProps.style, {
	                    top: popperProps.style.top || 0,
	                    left: popperProps.style.left || 0
	                  }, restProps.style)
	                }),
	                _react2.default.createElement(
	                  'div',
	                  {
	                    id: id,
	                    role: 'tooltip',
	                    'aria-hidden': !open,
	                    className: (0, _classnames2.default)(classes.tooltip, (0, _defineProperty3.default)({}, classes.tooltipOpen, open), classes['tooltip' + (0, _helpers.capitalize)(actualPlacement.split('-')[0])])
	                  },
	                  title
	                )
	              );
	            }
	          )
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react2.default.Component);
	
	Tooltip.propTypes =  false ? {
	  /**
	   * Tooltip reference element.
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Do not respond to focus events.
	   */
	  disableTriggerFocus: _propTypes2.default.bool,
	  /**
	   * Do not respond to hover events.
	   */
	  disableTriggerHover: _propTypes2.default.bool,
	  /**
	   * Do not respond to long press touch events.
	   */
	  disableTriggerTouch: _propTypes2.default.bool,
	  /**
	   * The number of milliseconds to wait before showing the tooltip.
	   */
	  enterDelay: _propTypes2.default.number,
	  /**
	   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
	   * By providing this property, we can use aria-describedby to solve the accessibility issue.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * The number of milliseconds to wait before hidding the tooltip.
	   */
	  leaveDelay: _propTypes2.default.number,
	  /**
	   * Callback fired when the tooltip requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Callback fired when the tooltip requests to be open.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onOpen: _propTypes2.default.func,
	  /**
	   * If `true`, the tooltip is shown.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Tooltip placement
	   */
	  placement: _propTypes2.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	  /**
	   * Properties applied to the `Popper` element.
	   */
	  PopperProps: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * Tooltip title. Zero-length titles string are never displayed.
	   */
	  title: _propTypes2.default.node.isRequired
	} : {};
	
	Tooltip.defaultProps = {
	  disableTriggerFocus: false,
	  disableTriggerHover: false,
	  disableTriggerTouch: false,
	  enterDelay: 0,
	  leaveDelay: 0,
	  placement: 'bottom'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTooltip', withTheme: true })(Tooltip);

/***/ }),
/* 5630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Tooltip = __webpack_require__(5629);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tooltip).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(39);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      display: 'block',
	      margin: 0
	    },
	    display4: theme.typography.display4,
	    display3: theme.typography.display3,
	    display2: theme.typography.display2,
	    display1: theme.typography.display1,
	    headline: theme.typography.headline,
	    title: theme.typography.title,
	    subheading: theme.typography.subheading,
	    body2: theme.typography.body2,
	    body1: theme.typography.body1,
	    caption: theme.typography.caption,
	    button: theme.typography.button,
	    alignLeft: {
	      textAlign: 'left'
	    },
	    alignCenter: {
	      textAlign: 'center'
	    },
	    alignRight: {
	      textAlign: 'right'
	    },
	    alignJustify: {
	      textAlign: 'justify'
	    },
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	    paragraph: {
	      marginBottom: theme.spacing.unit * 2
	    },
	    colorInherit: {
	      color: 'inherit'
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	    colorTextSecondary: {
	      color: theme.palette.text.secondary
	    },
	    colorError: {
	      color: theme.palette.error.main
	    }
	  };
	};
	
	function Typography(props) {
	  var _classNames;
	
	  var align = props.align,
	      classes = props.classes,
	      classNameProp = props.className,
	      componentProp = props.component,
	      color = props.color,
	      gutterBottom = props.gutterBottom,
	      headlineMapping = props.headlineMapping,
	      noWrap = props.noWrap,
	      paragraph = props.paragraph,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties3.default)(props, ['align', 'classes', 'className', 'component', 'color', 'gutterBottom', 'headlineMapping', 'noWrap', 'paragraph', 'variant']);
	
	
	  var className = (0, _classnames2.default)(classes.root, classes[variant], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty3.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty3.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty3.default)(_classNames, classes['align' + (0, _helpers.capitalize)(align)], align !== 'inherit'), _classNames), classNameProp);
	
	  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant]) || 'span';
	
	  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
	}
	
	Typography.propTypes =  false ? {
	  /**
	   * Set the text-align on the component.
	   */
	  align: _propTypes2.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	  /**
	   * The content of the component.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes2.default.oneOf(['inherit', 'primary', 'textSecondary', 'secondary', 'error', 'default']),
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it maps the variant to a good default headline component.
	   */
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  gutterBottom: _propTypes2.default.bool,
	  /**
	   * We are empirically mapping the variant property to a range of different DOM element types.
	   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
	   * Alternatively, you can use the `component` property.
	   */
	  headlineMapping: _propTypes2.default.object,
	  /**
	   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
	   */
	  noWrap: _propTypes2.default.bool,
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  paragraph: _propTypes2.default.bool,
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes2.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
	} : {};
	
	Typography.defaultProps = {
	  align: 'inherit',
	  color: 'default',
	  gutterBottom: false,
	  headlineMapping: {
	    display4: 'h1',
	    display3: 'h1',
	    display2: 'h1',
	    display1: 'h1',
	    headline: 'h1',
	    title: 'h2',
	    subheading: 'h3',
	    body2: 'aside',
	    body1: 'p'
	  },
	  noWrap: false,
	  paragraph: false,
	  variant: 'body1'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTypography' })(Typography);

/***/ }),
/* 5632 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var amber = {
	  50: '#fff8e1',
	  100: '#ffecb3',
	  200: '#ffe082',
	  300: '#ffd54f',
	  400: '#ffca28',
	  500: '#ffc107',
	  600: '#ffb300',
	  700: '#ffa000',
	  800: '#ff8f00',
	  900: '#ff6f00',
	  A100: '#ffe57f',
	  A200: '#ffd740',
	  A400: '#ffc400',
	  A700: '#ffab00'
	};
	
	exports.default = amber;

/***/ }),
/* 5633 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var blue = {
	  50: '#e3f2fd',
	  100: '#bbdefb',
	  200: '#90caf9',
	  300: '#64b5f6',
	  400: '#42a5f5',
	  500: '#2196f3',
	  600: '#1e88e5',
	  700: '#1976d2',
	  800: '#1565c0',
	  900: '#0d47a1',
	  A100: '#82b1ff',
	  A200: '#448aff',
	  A400: '#2979ff',
	  A700: '#2962ff'
	};
	
	exports.default = blue;

/***/ }),
/* 5634 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var blueGrey = {
	  50: '#eceff1',
	  100: '#cfd8dc',
	  200: '#b0bec5',
	  300: '#90a4ae',
	  400: '#78909c',
	  500: '#607d8b',
	  600: '#546e7a',
	  700: '#455a64',
	  800: '#37474f',
	  900: '#263238',
	  A100: '#cfd8dc',
	  A200: '#b0bec5',
	  A400: '#78909c',
	  A700: '#455a64'
	};
	
	exports.default = blueGrey;

/***/ }),
/* 5635 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var brown = {
	  50: '#efebe9',
	  100: '#d7ccc8',
	  200: '#bcaaa4',
	  300: '#a1887f',
	  400: '#8d6e63',
	  500: '#795548',
	  600: '#6d4c41',
	  700: '#5d4037',
	  800: '#4e342e',
	  900: '#3e2723',
	  A100: '#d7ccc8',
	  A200: '#bcaaa4',
	  A400: '#8d6e63',
	  A700: '#5d4037'
	};
	
	exports.default = brown;

/***/ }),
/* 5636 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var cyan = {
	  50: '#e0f7fa',
	  100: '#b2ebf2',
	  200: '#80deea',
	  300: '#4dd0e1',
	  400: '#26c6da',
	  500: '#00bcd4',
	  600: '#00acc1',
	  700: '#0097a7',
	  800: '#00838f',
	  900: '#006064',
	  A100: '#84ffff',
	  A200: '#18ffff',
	  A400: '#00e5ff',
	  A700: '#00b8d4'
	};
	
	exports.default = cyan;

/***/ }),
/* 5637 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var deepOrange = {
	  50: '#fbe9e7',
	  100: '#ffccbc',
	  200: '#ffab91',
	  300: '#ff8a65',
	  400: '#ff7043',
	  500: '#ff5722',
	  600: '#f4511e',
	  700: '#e64a19',
	  800: '#d84315',
	  900: '#bf360c',
	  A100: '#ff9e80',
	  A200: '#ff6e40',
	  A400: '#ff3d00',
	  A700: '#dd2c00'
	};
	
	exports.default = deepOrange;

/***/ }),
/* 5638 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var deepPurple = {
	  50: '#ede7f6',
	  100: '#d1c4e9',
	  200: '#b39ddb',
	  300: '#9575cd',
	  400: '#7e57c2',
	  500: '#673ab7',
	  600: '#5e35b1',
	  700: '#512da8',
	  800: '#4527a0',
	  900: '#311b92',
	  A100: '#b388ff',
	  A200: '#7c4dff',
	  A400: '#651fff',
	  A700: '#6200ea'
	};
	
	exports.default = deepPurple;

/***/ }),
/* 5639 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var green = {
	  50: '#e8f5e9',
	  100: '#c8e6c9',
	  200: '#a5d6a7',
	  300: '#81c784',
	  400: '#66bb6a',
	  500: '#4caf50',
	  600: '#43a047',
	  700: '#388e3c',
	  800: '#2e7d32',
	  900: '#1b5e20',
	  A100: '#b9f6ca',
	  A200: '#69f0ae',
	  A400: '#00e676',
	  A700: '#00c853'
	};
	
	exports.default = green;

/***/ }),
/* 5640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(1567);
	
	Object.defineProperty(exports, 'common', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_common).default;
	  }
	});
	
	var _red = __webpack_require__(2388);
	
	Object.defineProperty(exports, 'red', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_red).default;
	  }
	});
	
	var _pink = __webpack_require__(2387);
	
	Object.defineProperty(exports, 'pink', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_pink).default;
	  }
	});
	
	var _purple = __webpack_require__(5645);
	
	Object.defineProperty(exports, 'purple', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_purple).default;
	  }
	});
	
	var _deepPurple = __webpack_require__(5638);
	
	Object.defineProperty(exports, 'deepPurple', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_deepPurple).default;
	  }
	});
	
	var _indigo = __webpack_require__(2386);
	
	Object.defineProperty(exports, 'indigo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_indigo).default;
	  }
	});
	
	var _blue = __webpack_require__(5633);
	
	Object.defineProperty(exports, 'blue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_blue).default;
	  }
	});
	
	var _lightBlue = __webpack_require__(5641);
	
	Object.defineProperty(exports, 'lightBlue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lightBlue).default;
	  }
	});
	
	var _cyan = __webpack_require__(5636);
	
	Object.defineProperty(exports, 'cyan', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cyan).default;
	  }
	});
	
	var _teal = __webpack_require__(5646);
	
	Object.defineProperty(exports, 'teal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_teal).default;
	  }
	});
	
	var _green = __webpack_require__(5639);
	
	Object.defineProperty(exports, 'green', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_green).default;
	  }
	});
	
	var _lightGreen = __webpack_require__(5642);
	
	Object.defineProperty(exports, 'lightGreen', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lightGreen).default;
	  }
	});
	
	var _lime = __webpack_require__(5643);
	
	Object.defineProperty(exports, 'lime', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_lime).default;
	  }
	});
	
	var _yellow = __webpack_require__(5647);
	
	Object.defineProperty(exports, 'yellow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_yellow).default;
	  }
	});
	
	var _amber = __webpack_require__(5632);
	
	Object.defineProperty(exports, 'amber', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_amber).default;
	  }
	});
	
	var _orange = __webpack_require__(5644);
	
	Object.defineProperty(exports, 'orange', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_orange).default;
	  }
	});
	
	var _deepOrange = __webpack_require__(5637);
	
	Object.defineProperty(exports, 'deepOrange', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_deepOrange).default;
	  }
	});
	
	var _brown = __webpack_require__(5635);
	
	Object.defineProperty(exports, 'brown', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_brown).default;
	  }
	});
	
	var _grey = __webpack_require__(2385);
	
	Object.defineProperty(exports, 'grey', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_grey).default;
	  }
	});
	
	var _blueGrey = __webpack_require__(5634);
	
	Object.defineProperty(exports, 'blueGrey', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_blueGrey).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5641 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var lightBlue = {
	  50: '#e1f5fe',
	  100: '#b3e5fc',
	  200: '#81d4fa',
	  300: '#4fc3f7',
	  400: '#29b6f6',
	  500: '#03a9f4',
	  600: '#039be5',
	  700: '#0288d1',
	  800: '#0277bd',
	  900: '#01579b',
	  A100: '#80d8ff',
	  A200: '#40c4ff',
	  A400: '#00b0ff',
	  A700: '#0091ea'
	};
	
	exports.default = lightBlue;

/***/ }),
/* 5642 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var lightGreen = {
	  50: '#f1f8e9',
	  100: '#dcedc8',
	  200: '#c5e1a5',
	  300: '#aed581',
	  400: '#9ccc65',
	  500: '#8bc34a',
	  600: '#7cb342',
	  700: '#689f38',
	  800: '#558b2f',
	  900: '#33691e',
	  A100: '#ccff90',
	  A200: '#b2ff59',
	  A400: '#76ff03',
	  A700: '#64dd17'
	};
	
	exports.default = lightGreen;

/***/ }),
/* 5643 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var lime = {
	  50: '#f9fbe7',
	  100: '#f0f4c3',
	  200: '#e6ee9c',
	  300: '#dce775',
	  400: '#d4e157',
	  500: '#cddc39',
	  600: '#c0ca33',
	  700: '#afb42b',
	  800: '#9e9d24',
	  900: '#827717',
	  A100: '#f4ff81',
	  A200: '#eeff41',
	  A400: '#c6ff00',
	  A700: '#aeea00'
	};
	
	exports.default = lime;

/***/ }),
/* 5644 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var orange = {
	  50: '#fff3e0',
	  100: '#ffe0b2',
	  200: '#ffcc80',
	  300: '#ffb74d',
	  400: '#ffa726',
	  500: '#ff9800',
	  600: '#fb8c00',
	  700: '#f57c00',
	  800: '#ef6c00',
	  900: '#e65100',
	  A100: '#ffd180',
	  A200: '#ffab40',
	  A400: '#ff9100',
	  A700: '#ff6d00'
	};
	
	exports.default = orange;

/***/ }),
/* 5645 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var purple = {
	  50: '#f3e5f5',
	  100: '#e1bee7',
	  200: '#ce93d8',
	  300: '#ba68c8',
	  400: '#ab47bc',
	  500: '#9c27b0',
	  600: '#8e24aa',
	  700: '#7b1fa2',
	  800: '#6a1b9a',
	  900: '#4a148c',
	  A100: '#ea80fc',
	  A200: '#e040fb',
	  A400: '#d500f9',
	  A700: '#aa00ff'
	};
	
	exports.default = purple;

/***/ }),
/* 5646 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var teal = {
	  50: '#e0f2f1',
	  100: '#b2dfdb',
	  200: '#80cbc4',
	  300: '#4db6ac',
	  400: '#26a69a',
	  500: '#009688',
	  600: '#00897b',
	  700: '#00796b',
	  800: '#00695c',
	  900: '#004d40',
	  A100: '#a7ffeb',
	  A200: '#64ffda',
	  A400: '#1de9b6',
	  A700: '#00bfa5'
	};
	
	exports.default = teal;

/***/ }),
/* 5647 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var yellow = {
	  50: '#fffde7',
	  100: '#fff9c4',
	  200: '#fff59d',
	  300: '#fff176',
	  400: '#ffee58',
	  500: '#ffeb3b',
	  600: '#fdd835',
	  700: '#fbc02d',
	  800: '#f9a825',
	  900: '#f57f17',
	  A100: '#ffff8d',
	  A200: '#ffff00',
	  A400: '#ffea00',
	  A700: '#ffd600'
	};
	
	exports.default = yellow;

/***/ }),
/* 5648 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license Material-UI v1.0.0-beta.32
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withWidth = undefined;
	exports.Zoom = exports.Collapse = exports.Fade = exports.Grow = exports.Slide = exports.Tooltip = exports.Toolbar = exports.TextField = exports.Typography = exports.Tab = exports.Tabs = exports.TableSortLabel = exports.TableRow = exports.TablePagination = exports.TableHead = exports.TableFooter = exports.TableCell = exports.TableBody = exports.Table = exports.Switch = exports.SvgIcon = exports.colors = exports.jssPreset = exports.createMuiTheme = exports.withTheme = exports.withStyles = exports.MuiThemeProvider = exports.StepLabel = exports.StepContent = exports.StepIcon = exports.StepButton = exports.Step = exports.Stepper = exports.SnackbarContent = exports.Snackbar = exports.Select = exports.Reboot = exports.RadioGroup = exports.Radio = exports.LinearProgress = exports.CircularProgress = exports.Portal = exports.Popover = exports.Paper = exports.ModalManager = exports.Backdrop = exports.Modal = exports.MobileStepper = exports.MenuList = exports.MenuItem = exports.Menu = exports.ListSubheader = exports.ListItemText = exports.ListItemSecondaryAction = exports.ListItemIcon = exports.ListItemAvatar = exports.ListItem = exports.List = exports.GridListTileBar = exports.GridListTile = exports.GridList = exports.Grid = exports.InputAdornment = exports.InputLabel = exports.Input = exports.IconButton = exports.Icon = exports.Hidden = exports.FormControlLabel = exports.FormHelperText = exports.FormLabel = exports.FormGroup = exports.FormControl = exports.ExpansionPanelSummary = exports.ExpansionPanelDetails = exports.ExpansionPanelActions = exports.ExpansionPanel = exports.Drawer = exports.Divider = exports.withMobileDialog = exports.DialogTitle = exports.DialogContentText = exports.DialogContent = exports.DialogActions = exports.Dialog = exports.ClickAwayListener = exports.Chip = exports.Checkbox = exports.CardMedia = exports.CardHeader = exports.CardContent = exports.CardActions = exports.Card = exports.ButtonBase = exports.Button = exports.BottomNavigationAction = exports.BottomNavigation = exports.Badge = exports.Avatar = exports.AppBar = undefined;
	
	var _AppBar = __webpack_require__(1563);
	
	Object.defineProperty(exports, 'AppBar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AppBar).default;
	  }
	});
	
	var _Avatar = __webpack_require__(5527);
	
	Object.defineProperty(exports, 'Avatar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Avatar).default;
	  }
	});
	
	var _Badge = __webpack_require__(5529);
	
	Object.defineProperty(exports, 'Badge', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Badge).default;
	  }
	});
	
	var _BottomNavigation = __webpack_require__(5532);
	
	Object.defineProperty(exports, 'BottomNavigation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BottomNavigation).default;
	  }
	});
	Object.defineProperty(exports, 'BottomNavigationAction', {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.BottomNavigationAction;
	  }
	});
	
	var _Button = __webpack_require__(2362);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	var _ButtonBase = __webpack_require__(278);
	
	Object.defineProperty(exports, 'ButtonBase', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ButtonBase).default;
	  }
	});
	
	var _Card = __webpack_require__(5543);
	
	Object.defineProperty(exports, 'Card', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Card).default;
	  }
	});
	Object.defineProperty(exports, 'CardActions', {
	  enumerable: true,
	  get: function get() {
	    return _Card.CardActions;
	  }
	});
	Object.defineProperty(exports, 'CardContent', {
	  enumerable: true,
	  get: function get() {
	    return _Card.CardContent;
	  }
	});
	Object.defineProperty(exports, 'CardHeader', {
	  enumerable: true,
	  get: function get() {
	    return _Card.CardHeader;
	  }
	});
	Object.defineProperty(exports, 'CardMedia', {
	  enumerable: true,
	  get: function get() {
	    return _Card.CardMedia;
	  }
	});
	
	var _Checkbox = __webpack_require__(5545);
	
	Object.defineProperty(exports, 'Checkbox', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkbox).default;
	  }
	});
	
	var _Chip = __webpack_require__(5547);
	
	Object.defineProperty(exports, 'Chip', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chip).default;
	  }
	});
	
	var _ClickAwayListener = __webpack_require__(2400);
	
	Object.defineProperty(exports, 'ClickAwayListener', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ClickAwayListener).default;
	  }
	});
	
	var _Dialog = __webpack_require__(5553);
	
	Object.defineProperty(exports, 'Dialog', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Dialog).default;
	  }
	});
	Object.defineProperty(exports, 'DialogActions', {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.DialogActions;
	  }
	});
	Object.defineProperty(exports, 'DialogContent', {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.DialogContent;
	  }
	});
	Object.defineProperty(exports, 'DialogContentText', {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.DialogContentText;
	  }
	});
	Object.defineProperty(exports, 'DialogTitle', {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.DialogTitle;
	  }
	});
	Object.defineProperty(exports, 'withMobileDialog', {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.withMobileDialog;
	  }
	});
	
	var _Divider = __webpack_require__(5556);
	
	Object.defineProperty(exports, 'Divider', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Divider).default;
	  }
	});
	
	var _Drawer = __webpack_require__(2363);
	
	Object.defineProperty(exports, 'Drawer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Drawer).default;
	  }
	});
	
	var _ExpansionPanel = __webpack_require__(5562);
	
	Object.defineProperty(exports, 'ExpansionPanel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ExpansionPanel).default;
	  }
	});
	Object.defineProperty(exports, 'ExpansionPanelActions', {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.ExpansionPanelActions;
	  }
	});
	Object.defineProperty(exports, 'ExpansionPanelDetails', {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.ExpansionPanelDetails;
	  }
	});
	Object.defineProperty(exports, 'ExpansionPanelSummary', {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.ExpansionPanelSummary;
	  }
	});
	
	var _Form = __webpack_require__(2367);
	
	Object.defineProperty(exports, 'FormControl', {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormControl;
	  }
	});
	Object.defineProperty(exports, 'FormGroup', {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormGroup;
	  }
	});
	Object.defineProperty(exports, 'FormLabel', {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormLabel;
	  }
	});
	Object.defineProperty(exports, 'FormHelperText', {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormHelperText;
	  }
	});
	Object.defineProperty(exports, 'FormControlLabel', {
	  enumerable: true,
	  get: function get() {
	    return _Form.FormControlLabel;
	  }
	});
	
	var _Hidden = __webpack_require__(2368);
	
	Object.defineProperty(exports, 'Hidden', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hidden).default;
	  }
	});
	
	var _Icon = __webpack_require__(5575);
	
	Object.defineProperty(exports, 'Icon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Icon).default;
	  }
	});
	
	var _IconButton = __webpack_require__(990);
	
	Object.defineProperty(exports, 'IconButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IconButton).default;
	  }
	});
	
	var _Input = __webpack_require__(991);
	
	Object.defineProperty(exports, 'Input', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Input).default;
	  }
	});
	Object.defineProperty(exports, 'InputLabel', {
	  enumerable: true,
	  get: function get() {
	    return _Input.InputLabel;
	  }
	});
	Object.defineProperty(exports, 'InputAdornment', {
	  enumerable: true,
	  get: function get() {
	    return _Input.InputAdornment;
	  }
	});
	
	var _Grid = __webpack_require__(5566);
	
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	var _GridList = __webpack_require__(5570);
	
	Object.defineProperty(exports, 'GridList', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GridList).default;
	  }
	});
	Object.defineProperty(exports, 'GridListTile', {
	  enumerable: true,
	  get: function get() {
	    return _GridList.GridListTile;
	  }
	});
	Object.defineProperty(exports, 'GridListTileBar', {
	  enumerable: true,
	  get: function get() {
	    return _GridList.GridListTileBar;
	  }
	});
	
	var _List = __webpack_require__(2370);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	Object.defineProperty(exports, 'ListItem', {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItem;
	  }
	});
	Object.defineProperty(exports, 'ListItemAvatar', {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItemAvatar;
	  }
	});
	Object.defineProperty(exports, 'ListItemIcon', {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItemIcon;
	  }
	});
	Object.defineProperty(exports, 'ListItemSecondaryAction', {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItemSecondaryAction;
	  }
	});
	Object.defineProperty(exports, 'ListItemText', {
	  enumerable: true,
	  get: function get() {
	    return _List.ListItemText;
	  }
	});
	Object.defineProperty(exports, 'ListSubheader', {
	  enumerable: true,
	  get: function get() {
	    return _List.ListSubheader;
	  }
	});
	
	var _Menu = __webpack_require__(1565);
	
	Object.defineProperty(exports, 'Menu', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Menu).default;
	  }
	});
	Object.defineProperty(exports, 'MenuItem', {
	  enumerable: true,
	  get: function get() {
	    return _Menu.MenuItem;
	  }
	});
	Object.defineProperty(exports, 'MenuList', {
	  enumerable: true,
	  get: function get() {
	    return _Menu.MenuList;
	  }
	});
	
	var _MobileStepper = __webpack_require__(5588);
	
	Object.defineProperty(exports, 'MobileStepper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MobileStepper).default;
	  }
	});
	
	var _Modal = __webpack_require__(578);
	
	Object.defineProperty(exports, 'Modal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Modal).default;
	  }
	});
	Object.defineProperty(exports, 'Backdrop', {
	  enumerable: true,
	  get: function get() {
	    return _Modal.Backdrop;
	  }
	});
	Object.defineProperty(exports, 'ModalManager', {
	  enumerable: true,
	  get: function get() {
	    return _Modal.ModalManager;
	  }
	});
	
	var _Paper = __webpack_require__(279);
	
	Object.defineProperty(exports, 'Paper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Paper).default;
	  }
	});
	
	var _Popover = __webpack_require__(250);
	
	Object.defineProperty(exports, 'Popover', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Popover).default;
	  }
	});
	
	var _Portal = __webpack_require__(2375);
	
	Object.defineProperty(exports, 'Portal', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Portal).default;
	  }
	});
	
	var _Progress = __webpack_require__(2376);
	
	Object.defineProperty(exports, 'CircularProgress', {
	  enumerable: true,
	  get: function get() {
	    return _Progress.CircularProgress;
	  }
	});
	Object.defineProperty(exports, 'LinearProgress', {
	  enumerable: true,
	  get: function get() {
	    return _Progress.LinearProgress;
	  }
	});
	
	var _Radio = __webpack_require__(5599);
	
	Object.defineProperty(exports, 'Radio', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Radio).default;
	  }
	});
	Object.defineProperty(exports, 'RadioGroup', {
	  enumerable: true,
	  get: function get() {
	    return _Radio.RadioGroup;
	  }
	});
	
	var _Reboot = __webpack_require__(5601);
	
	Object.defineProperty(exports, 'Reboot', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Reboot).default;
	  }
	});
	
	var _Select = __webpack_require__(2378);
	
	Object.defineProperty(exports, 'Select', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Select).default;
	  }
	});
	
	var _Snackbar = __webpack_require__(5604);
	
	Object.defineProperty(exports, 'Snackbar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Snackbar).default;
	  }
	});
	Object.defineProperty(exports, 'SnackbarContent', {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.SnackbarContent;
	  }
	});
	
	var _Stepper = __webpack_require__(5611);
	
	Object.defineProperty(exports, 'Stepper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Stepper).default;
	  }
	});
	Object.defineProperty(exports, 'Step', {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.Step;
	  }
	});
	Object.defineProperty(exports, 'StepButton', {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.StepButton;
	  }
	});
	Object.defineProperty(exports, 'StepIcon', {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.StepIcon;
	  }
	});
	Object.defineProperty(exports, 'StepContent', {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.StepContent;
	  }
	});
	Object.defineProperty(exports, 'StepLabel', {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.StepLabel;
	  }
	});
	
	var _styles = __webpack_require__(581);
	
	Object.defineProperty(exports, 'MuiThemeProvider', {
	  enumerable: true,
	  get: function get() {
	    return _styles.MuiThemeProvider;
	  }
	});
	Object.defineProperty(exports, 'withStyles', {
	  enumerable: true,
	  get: function get() {
	    return _styles.withStyles;
	  }
	});
	Object.defineProperty(exports, 'withTheme', {
	  enumerable: true,
	  get: function get() {
	    return _styles.withTheme;
	  }
	});
	Object.defineProperty(exports, 'createMuiTheme', {
	  enumerable: true,
	  get: function get() {
	    return _styles.createMuiTheme;
	  }
	});
	Object.defineProperty(exports, 'jssPreset', {
	  enumerable: true,
	  get: function get() {
	    return _styles.jssPreset;
	  }
	});
	
	var _SvgIcon = __webpack_require__(190);
	
	Object.defineProperty(exports, 'SvgIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SvgIcon).default;
	  }
	});
	
	var _Switch = __webpack_require__(5614);
	
	Object.defineProperty(exports, 'Switch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Switch).default;
	  }
	});
	
	var _Table = __webpack_require__(5623);
	
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Table).default;
	  }
	});
	Object.defineProperty(exports, 'TableBody', {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableBody;
	  }
	});
	Object.defineProperty(exports, 'TableCell', {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableCell;
	  }
	});
	Object.defineProperty(exports, 'TableFooter', {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableFooter;
	  }
	});
	Object.defineProperty(exports, 'TableHead', {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableHead;
	  }
	});
	Object.defineProperty(exports, 'TablePagination', {
	  enumerable: true,
	  get: function get() {
	    return _Table.TablePagination;
	  }
	});
	Object.defineProperty(exports, 'TableRow', {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableRow;
	  }
	});
	Object.defineProperty(exports, 'TableSortLabel', {
	  enumerable: true,
	  get: function get() {
	    return _Table.TableSortLabel;
	  }
	});
	
	var _Tabs = __webpack_require__(1566);
	
	Object.defineProperty(exports, 'Tabs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tabs).default;
	  }
	});
	Object.defineProperty(exports, 'Tab', {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.Tab;
	  }
	});
	
	var _Typography = __webpack_require__(326);
	
	Object.defineProperty(exports, 'Typography', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Typography).default;
	  }
	});
	
	var _TextField = __webpack_require__(5627);
	
	Object.defineProperty(exports, 'TextField', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextField).default;
	  }
	});
	
	var _Toolbar = __webpack_require__(2384);
	
	Object.defineProperty(exports, 'Toolbar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Toolbar).default;
	  }
	});
	
	var _Tooltip = __webpack_require__(5630);
	
	Object.defineProperty(exports, 'Tooltip', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Tooltip).default;
	  }
	});
	
	var _transitions = __webpack_require__(5681);
	
	Object.defineProperty(exports, 'Slide', {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Slide;
	  }
	});
	Object.defineProperty(exports, 'Grow', {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Grow;
	  }
	});
	Object.defineProperty(exports, 'Fade', {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Fade;
	  }
	});
	Object.defineProperty(exports, 'Collapse', {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Collapse;
	  }
	});
	Object.defineProperty(exports, 'Zoom', {
	  enumerable: true,
	  get: function get() {
	    return _transitions.Zoom;
	  }
	});
	
	var _withWidth = __webpack_require__(1575);
	
	Object.defineProperty(exports, 'withWidth', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_withWidth).default;
	  }
	});
	
	var _colors = __webpack_require__(5640);
	
	var colors = _interopRequireWildcard(_colors);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/first
	
	
	exports.colors = colors;

/***/ }),
/* 5649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' });
	
	var ArrowDownward = function ArrowDownward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	
	ArrowDownward = (0, _pure2.default)(ArrowDownward);
	ArrowDownward.muiName = 'SvgIcon';
	
	exports.default = ArrowDownward;

/***/ }),
/* 5650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' });
	
	var ArrowDropDown = function ArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	
	ArrowDropDown = (0, _pure2.default)(ArrowDropDown);
	ArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = ArrowDropDown;

/***/ }),
/* 5651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' });
	
	var Cancel = function Cancel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	Cancel = (0, _pure2.default)(Cancel);
	Cancel.muiName = 'SvgIcon';
	
	exports.default = Cancel;

/***/ }),
/* 5652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' });
	
	var CheckBox = function CheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	CheckBox = (0, _pure2.default)(CheckBox);
	CheckBox.muiName = 'SvgIcon';
	
	exports.default = CheckBox;

/***/ }),
/* 5653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' });
	
	var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	CheckBoxOutlineBlank = (0, _pure2.default)(CheckBoxOutlineBlank);
	CheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = CheckBoxOutlineBlank;

/***/ }),
/* 5654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' });
	
	var CheckCircle = function CheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	CheckCircle = (0, _pure2.default)(CheckCircle);
	CheckCircle.muiName = 'SvgIcon';
	
	exports.default = CheckCircle;

/***/ }),
/* 5655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' });
	
	var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	IndeterminateCheckBox = (0, _pure2.default)(IndeterminateCheckBox);
	IndeterminateCheckBox.muiName = 'SvgIcon';
	
	exports.default = IndeterminateCheckBox;

/***/ }),
/* 5656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' });
	
	var RadioButtonChecked = function RadioButtonChecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	RadioButtonChecked = (0, _pure2.default)(RadioButtonChecked);
	RadioButtonChecked.muiName = 'SvgIcon';
	
	exports.default = RadioButtonChecked;

/***/ }),
/* 5657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(251);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(190);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @ignore - internal component.
	 */
	var _ref = _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' });
	
	var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _ref
	  );
	};
	RadioButtonUnchecked = (0, _pure2.default)(RadioButtonUnchecked);
	RadioButtonUnchecked.muiName = 'SvgIcon';
	
	exports.default = RadioButtonUnchecked;

/***/ }),
/* 5658 */
[6744, 2392, 5660, 5661],
/* 5659 */
2696,
/* 5660 */
[6778, 2392],
/* 5661 */
5890,
/* 5662 */
474,
/* 5663 */
[6822, 5658, 5662],
/* 5664 */
[6718, 2393],
/* 5665 */
[6829, 2394, 5663],
/* 5666 */
[6721, 5667],
/* 5667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 5668 */
2848,
/* 5669 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ }),
/* 5670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(959);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 5671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(2396);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(735);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ }),
/* 5672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _brcast = __webpack_require__(4305);
	
	var _brcast2 = _interopRequireDefault(_brcast);
	
	var _themeListener = __webpack_require__(1571);
	
	var _themeListener2 = _interopRequireDefault(_themeListener);
	
	var _exactProp = __webpack_require__(738);
	
	var _exactProp2 = _interopRequireDefault(_exactProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This component takes a `theme` property.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	var MuiThemeProvider = function (_React$Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _React$Component);
	
	  function MuiThemeProvider(props, context) {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	
	    // Get the outer theme from the context, can be null
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).call(this, props, context));
	
	    _this.broadcast = (0, _brcast2.default)();
	    _this.unsubscribeId = null;
	    _this.outerTheme = null;
	    _this.outerTheme = _themeListener2.default.initial(context);
	    // Propagate the theme so it can be accessed by the children
	    _this.broadcast.setState(_this.mergeOuterLocalTheme(_this.props.theme));
	    return _this;
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, (0, _defineProperty3.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty3.default)(_ref, 'muiThemeProviderOptions', {
	        sheetsManager: this.props.sheetsManager,
	        disableStylesGeneration: this.props.disableStylesGeneration
	      }), _ref;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Subscribe on the outer theme, if present
	      this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (outerTheme) {
	        _this2.outerTheme = outerTheme;
	        // Forward the parent theme update to the children
	        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // Propagate a local theme update
	      if (this.props.theme !== nextProps.theme) {
	        this.broadcast.setState(this.mergeOuterLocalTheme(nextProps.theme));
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.unsubscribeId !== null) {
	        _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
	      }
	    }
	    // We are not using the React state in order to avoid unnecessary rerender.
	
	  }, {
	    key: 'mergeOuterLocalTheme',
	
	
	    // Simple merge between the outer theme and the local theme
	    value: function mergeOuterLocalTheme(localTheme) {
	      // To support composition of theme.
	      if (typeof localTheme === 'function') {
	         false ? (0, _warning2.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
	        return localTheme(this.outerTheme);
	      }
	
	      if (!this.outerTheme) {
	        return localTheme;
	      }
	
	      return (0, _extends3.default)({}, this.outerTheme, localTheme);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react2.default.Component);
	
	MuiThemeProvider.propTypes =  false ? {
	  /**
	   * You can only provide a single element with react@15, a node with react@16.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server side.
	   * You can significantly speed up the traversal with this property.
	   */
	  disableStylesGeneration: _propTypes2.default.bool,
	  /**
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes2.default.object,
	  /**
	   * A theme object.
	   */
	  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired
	} : {};
	
	MuiThemeProvider.propTypes =  false ? (0, _exactProp2.default)(MuiThemeProvider.propTypes, 'MuiThemeProvider') : {};
	
	MuiThemeProvider.defaultProps = {
	  disableStylesGeneration: false,
	  sheetsManager: null
	};
	
	MuiThemeProvider.childContextTypes = (0, _extends3.default)({}, _themeListener2.default.contextTypes, {
	  muiThemeProviderOptions: _propTypes2.default.object
	});
	
	MuiThemeProvider.contextTypes = _themeListener2.default.contextTypes;
	
	exports.default = MuiThemeProvider;

/***/ }),
/* 5673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	exports.default = createMixins;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMixins(breakpoints, spacing, mixins) {
	  var _toolbar;
	
	  return (0, _extends4.default)({
	    gutters: function gutters(styles) {
	      return (0, _extends4.default)({
	        paddingLeft: spacing.unit * 2,
	        paddingRight: spacing.unit * 2
	      }, styles, (0, _defineProperty3.default)({}, breakpoints.up('sm'), (0, _extends4.default)({
	        paddingLeft: spacing.unit * 3,
	        paddingRight: spacing.unit * 3
	      }, styles[breakpoints.up('sm')])));
	    },
	    toolbar: (_toolbar = {
	      minHeight: 56
	    }, (0, _defineProperty3.default)(_toolbar, breakpoints.up('xs') + ' and (orientation: landscape)', {
	      minHeight: 48
	    }), (0, _defineProperty3.default)(_toolbar, breakpoints.up('sm'), {
	      minHeight: 64
	    }), _toolbar)
	  }, mixins);
	}

/***/ }),
/* 5674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dark = exports.light = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = createPalette;
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepmerge = __webpack_require__(947);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _indigo = __webpack_require__(2386);
	
	var _indigo2 = _interopRequireDefault(_indigo);
	
	var _pink = __webpack_require__(2387);
	
	var _pink2 = _interopRequireDefault(_pink);
	
	var _grey = __webpack_require__(2385);
	
	var _grey2 = _interopRequireDefault(_grey);
	
	var _red = __webpack_require__(2388);
	
	var _red2 = _interopRequireDefault(_red);
	
	var _common = __webpack_require__(1567);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _colorManipulator = __webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	var light = exports.light = {
	  // The colors used to style the text.
	  text: {
	    // The most important text.
	    primary: 'rgba(0, 0, 0, 0.87)',
	    // Secondary text.
	    secondary: 'rgba(0, 0, 0, 0.54)',
	    // Disabled text have even lower visual prominence.
	    disabled: 'rgba(0, 0, 0, 0.38)',
	    // Text hints.
	    hint: 'rgba(0, 0, 0, 0.38)'
	  },
	  // The color used to divide different elements.
	  divider: 'rgba(0, 0, 0, 0.12)',
	  // The background colors used to style the surfaces.
	  // Consistency between these values is important.
	  background: {
	    paper: _common2.default.white,
	    default: _grey2.default[50]
	  },
	  // The colors used to style the action elements.
	  action: {
	    // The color of an active action like an icon button.
	    active: 'rgba(0, 0, 0, 0.54)',
	    // The color of an hovered action.
	    hover: 'rgba(0, 0, 0, 0.14)',
	    // The color of a selected action.
	    selected: 'rgba(0, 0, 0, 0.08)',
	    // The color of a disabled action.
	    disabled: 'rgba(0, 0, 0, 0.26)',
	    // The background color of a disabled action.
	    disabledBackground: 'rgba(0, 0, 0, 0.12)'
	  }
	};
	
	var dark = exports.dark = {
	  text: {
	    primary: _common2.default.white,
	    secondary: 'rgba(255, 255, 255, 0.7)',
	    disabled: 'rgba(255, 255, 255, 0.5)',
	    hint: 'rgba(255, 255, 255, 0.5)',
	    icon: 'rgba(255, 255, 255, 0.5)'
	  },
	  divider: 'rgba(255, 255, 255, 0.12)',
	  background: {
	    paper: _grey2.default[800],
	    default: '#303030'
	  },
	  action: {
	    active: _common2.default.white,
	    hover: 'rgba(255, 255, 255, 0.2)',
	    selected: 'rgba(255, 255, 255, 0.1)',
	    disabled: 'rgba(255, 255, 255, 0.3)',
	    disabledBackground: 'rgba(255, 255, 255, 0.12)'
	  }
	};
	
	function addLightOrDark(intent, direction, shade, tonalOffset) {
	  if (!intent[direction]) {
	    if (intent.hasOwnProperty(shade)) {
	      intent[direction] = intent[shade];
	    } else if (direction === 'light') {
	      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
	    } else if (direction === 'dark') {
	      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
	    }
	  }
	}
	
	function createPalette(palette) {
	  var _palette$primary = palette.primary,
	      primary = _palette$primary === undefined ? {
	    light: _indigo2.default[300],
	    main: _indigo2.default[500],
	    dark: _indigo2.default[700]
	  } : _palette$primary,
	      _palette$secondary = palette.secondary,
	      secondary = _palette$secondary === undefined ? {
	    light: _pink2.default.A200,
	    main: _pink2.default.A400,
	    dark: _pink2.default.A700
	  } : _palette$secondary,
	      _palette$error = palette.error,
	      error = _palette$error === undefined ? {
	    light: _red2.default[300],
	    main: _red2.default[500],
	    dark: _red2.default[700]
	  } : _palette$error,
	      _palette$type = palette.type,
	      type = _palette$type === undefined ? 'light' : _palette$type,
	      _palette$contrastThre = palette.contrastThreshold,
	      contrastThreshold = _palette$contrastThre === undefined ? 3 : _palette$contrastThre,
	      _palette$tonalOffset = palette.tonalOffset,
	      tonalOffset = _palette$tonalOffset === undefined ? 0.2 : _palette$tonalOffset,
	      other = (0, _objectWithoutProperties3.default)(palette, ['primary', 'secondary', 'error', 'type', 'contrastThreshold', 'tonalOffset']);
	
	
	  function getContrastText(background) {
	    // Use the same logic as
	    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
	    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
	    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
	
	    if (false) {
	      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(contrast >= 3, ['Material-UI: the contrast ratio of ' + contrast + ':1 for ' + contrastText + ' on ' + background, 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
	    }
	
	    return contrastText;
	  }
	
	  function augmentColor(color, mainShade, lightShade, darkShade) {
	    if (!color.main && color[mainShade]) {
	      color.main = color[mainShade];
	    }
	    addLightOrDark(color, 'light', lightShade, tonalOffset);
	    addLightOrDark(color, 'dark', darkShade, tonalOffset);
	    if (!color.contrastText) {
	      color.contrastText = getContrastText(color.main);
	    }
	  }
	
	  augmentColor(primary, 500, 300, 700);
	  augmentColor(secondary, 'A400', 'A200', 'A700');
	  augmentColor(error, 500, 300, 700);
	
	  var types = { dark: dark, light: light };
	
	   false ? (0, _warning2.default)(types[type], 'Material-UI: the palette type `' + type + '` is not supported.') : void 0;
	
	  var paletteOutput = (0, _deepmerge2.default)((0, _extends3.default)({
	    // A collection of common colors.
	    common: _common2.default,
	    // The palette type, can be light or dark.
	    type: type,
	    // The colors used to represent primary interface elements for a user.
	    primary: primary,
	    // The colors used to represent secondary interface elements for a user.
	    secondary: secondary,
	    // The colors used to represent interface elements that the user should be made aware of.
	    error: error,
	    // The grey colors.
	    grey: _grey2.default,
	    // Used by `getContrastText()` to maximize the contrast between the background and
	    // the text.
	    contrastThreshold: contrastThreshold,
	    // Take a background color and return the color of the text to maximize the contrast.
	    getContrastText: getContrastText,
	    // Used by the functions below to shift a color's luminance by approximately
	    // two indexes within its tonal palette.
	    // E.g., shift from Red 500 to Red 300 or Red 700.
	    tonalOffset: tonalOffset
	  }, types[type]), other, {
	    clone: false // No need to clone deep
	  });
	
	  return paletteOutput;
	}

/***/ }),
/* 5675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	exports.default = createTypography;
	
	var _deepmerge = __webpack_require__(947);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	function createTypography(palette, typography) {
	  var _ref = typeof typography === 'function' ? typography(palette) : typography,
	      _ref$fontFamily = _ref.fontFamily,
	      fontFamily = _ref$fontFamily === undefined ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
	      _ref$fontSize = _ref.fontSize,
	      fontSize = _ref$fontSize === undefined ? 14 : _ref$fontSize,
	      _ref$fontWeightLight = _ref.fontWeightLight,
	      fontWeightLight = _ref$fontWeightLight === undefined ? 300 : _ref$fontWeightLight,
	      _ref$fontWeightRegula = _ref.fontWeightRegular,
	      fontWeightRegular = _ref$fontWeightRegula === undefined ? 400 : _ref$fontWeightRegula,
	      _ref$fontWeightMedium = _ref.fontWeightMedium,
	      fontWeightMedium = _ref$fontWeightMedium === undefined ? 500 : _ref$fontWeightMedium,
	      _ref$htmlFontSize = _ref.htmlFontSize,
	      htmlFontSize = _ref$htmlFontSize === undefined ? 16 : _ref$htmlFontSize,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['fontFamily', 'fontSize', 'fontWeightLight', 'fontWeightRegular', 'fontWeightMedium', 'htmlFontSize']);
	
	  function pxToRem(value) {
	    return value / htmlFontSize + 'rem';
	  }
	
	  return (0, _deepmerge2.default)({
	    pxToRem: pxToRem,
	    round: round,
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontWeightLight: fontWeightLight,
	    fontWeightRegular: fontWeightRegular,
	    fontWeightMedium: fontWeightMedium,
	    display4: {
	      fontSize: pxToRem(112),
	      fontWeight: fontWeightLight,
	      fontFamily: fontFamily,
	      letterSpacing: '-.04em',
	      lineHeight: round(128 / 112) + 'em',
	      marginLeft: '-.06em',
	      color: palette.text.secondary
	    },
	    display3: {
	      fontSize: pxToRem(56),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      letterSpacing: '-.02em',
	      lineHeight: round(73 / 56) + 'em',
	      marginLeft: '-.04em',
	      color: palette.text.secondary
	    },
	    display2: {
	      fontSize: pxToRem(45),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: round(48 / 45) + 'em',
	      marginLeft: '-.04em',
	      color: palette.text.secondary
	    },
	    display1: {
	      fontSize: pxToRem(34),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: round(41 / 34) + 'em',
	      marginLeft: '-.04em',
	      color: palette.text.secondary
	    },
	    headline: {
	      fontSize: pxToRem(24),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: round(32.5 / 24) + 'em',
	      color: palette.text.primary
	    },
	    title: {
	      fontSize: pxToRem(21),
	      fontWeight: fontWeightMedium,
	      fontFamily: fontFamily,
	      lineHeight: round(24.5 / 21) + 'em',
	      color: palette.text.primary
	    },
	    subheading: {
	      fontSize: pxToRem(16),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: round(24 / 16) + 'em',
	      color: palette.text.primary
	    },
	    body2: {
	      fontSize: pxToRem(14),
	      fontWeight: fontWeightMedium,
	      fontFamily: fontFamily,
	      lineHeight: round(24 / 14) + 'em',
	      color: palette.text.primary
	    },
	    body1: {
	      fontSize: pxToRem(14),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: round(20.5 / 14) + 'em',
	      color: palette.text.primary
	    },
	    caption: {
	      fontSize: pxToRem(12),
	      fontWeight: fontWeightRegular,
	      fontFamily: fontFamily,
	      lineHeight: round(16.5 / 12) + 'em',
	      color: palette.text.secondary
	    },
	    button: {
	      fontSize: pxToRem(fontSize),
	      textTransform: 'uppercase',
	      fontWeight: fontWeightMedium,
	      fontFamily: fontFamily
	    }
	  }, other, {
	    clone: false // No need to clone deep
	  });
	}

/***/ }),
/* 5676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepmerge = __webpack_require__(947);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// < 1kb payload overhead when lodash/merge is > 3kb.
	
	function getStylesCreator(stylesOrCreator) {
	  var themingEnabled = typeof stylesOrCreator === 'function';
	
	  function create(theme, name) {
	    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
	
	    if (!theme.overrides || !name || !theme.overrides[name]) {
	      return styles;
	    }
	
	    var overrides = theme.overrides[name];
	    var stylesWithOverrides = (0, _extends3.default)({}, styles);
	
	    (0, _keys2.default)(overrides).forEach(function (key) {
	       false ? (0, _warning2.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', 'Fix the `' + key + '` key of `theme.overrides.' + name + '`.'].join('\n')) : void 0;
	      stylesWithOverrides[key] = (0, _deepmerge2.default)(stylesWithOverrides[key], overrides[key]);
	    });
	
	    return stylesWithOverrides;
	  }
	
	  return {
	    create: create,
	    options: {},
	    themingEnabled: themingEnabled
	  };
	}
	
	exports.default = getStylesCreator;

/***/ }),
/* 5677 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shadowKeyUmbraOpacity = 0.2;
	var shadowKeyPenumbraOpacity = 0.14;
	var shadowAmbientShadowOpacity = 0.12;
	
	function createShadow() {
	  return [(arguments.length <= 0 ? undefined : arguments[0]) + 'px ' + (arguments.length <= 1 ? undefined : arguments[1]) + 'px ' + (arguments.length <= 2 ? undefined : arguments[2]) + 'px ' + (arguments.length <= 3 ? undefined : arguments[3]) + 'px rgba(0, 0, 0, ' + shadowKeyUmbraOpacity + ')', (arguments.length <= 4 ? undefined : arguments[4]) + 'px ' + (arguments.length <= 5 ? undefined : arguments[5]) + 'px ' + (arguments.length <= 6 ? undefined : arguments[6]) + 'px ' + (arguments.length <= 7 ? undefined : arguments[7]) + 'px rgba(0, 0, 0, ' + shadowKeyPenumbraOpacity + ')', (arguments.length <= 8 ? undefined : arguments[8]) + 'px ' + (arguments.length <= 9 ? undefined : arguments[9]) + 'px ' + (arguments.length <= 10 ? undefined : arguments[10]) + 'px ' + (arguments.length <= 11 ? undefined : arguments[11]) + 'px rgba(0, 0, 0, ' + shadowAmbientShadowOpacity + ')'].join(',');
	}
	
	var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
	
	exports.default = shadows;

/***/ }),
/* 5678 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
	  // https://material.io/guidelines/layout/metrics-keylines.html#metrics-keylines-baseline-grids
	  unit: 8
	};

/***/ }),
/* 5679 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// We need to centralize the zIndex definitions as they work
	// like global values in the browser.
	var zIndex = {
	  mobileStepper: 1000,
	  appBar: 1100,
	  drawer: 1200,
	  modal: 1300,
	  snackbar: 1400,
	  tooltip: 1500
	};
	
	exports.default = zIndex;

/***/ }),
/* 5680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(580);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _transitions = __webpack_require__(381);
	
	var _withTheme = __webpack_require__(582);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	var _utils = __webpack_require__(737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @inheritedComponent Transition
	
	var styles = {
	  entering: {
	    transform: 'scale(1)'
	  },
	  entered: {
	    transform: 'scale(1)'
	  }
	};
	
	/**
	 * The Zoom transition is used by the SpeedDial component.
	 * It's using [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Zoom = function (_React$Component) {
	  (0, _inherits3.default)(Zoom, _React$Component);
	
	  function Zoom() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Zoom);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Zoom.__proto__ || (0, _getPrototypeOf2.default)(Zoom)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = function (node) {
	      var theme = _this.props.theme;
	
	      (0, _utils.reflow)(node); // So the animation always start from the start.
	
	      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      }),
	          transitionDuration = _getTransitionProps.duration,
	          delay = _getTransitionProps.delay;
	
	      node.style.transition = theme.transitions.create('transform', {
	        duration: transitionDuration,
	        delay: delay
	      });
	      node.style.webkitTransition = theme.transitions.create('transform', {
	        duration: transitionDuration,
	        delay: delay
	      });
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.handleExit = function (node) {
	      var theme = _this.props.theme;
	
	      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      }),
	          transitionDuration = _getTransitionProps2.duration,
	          delay = _getTransitionProps2.delay;
	
	      node.style.transition = theme.transitions.create('transform', {
	        duration: transitionDuration,
	        delay: delay
	      });
	      node.style.webkitTransition = theme.transitions.create('transform', {
	        duration: transitionDuration,
	        delay: delay
	      });
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Zoom, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          onEnter = _props.onEnter,
	          onExit = _props.onExit,
	          styleProp = _props.style,
	          theme = _props.theme,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onExit', 'style', 'theme']);
	
	
	      var style = (0, _extends3.default)({}, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        (0, _extends3.default)({ appear: true, onEnter: this.handleEnter, onExit: this.handleExit }, other),
	        function (state, childProps) {
	          return _react2.default.cloneElement(children, (0, _extends3.default)({
	            style: (0, _extends3.default)({
	              transform: 'scale(0)'
	            }, styles[state], style)
	          }, childProps));
	        }
	      );
	    }
	  }]);
	  return Zoom;
	}(_react2.default.Component);
	
	Zoom.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  theme: _propTypes2.default.object.isRequired,
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
	} : {};
	
	Zoom.defaultProps = {
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	exports.default = (0, _withTheme2.default)()(Zoom);

/***/ }),
/* 5681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Slide = __webpack_require__(1574);
	
	Object.defineProperty(exports, 'Slide', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slide).default;
	  }
	});
	
	var _Grow = __webpack_require__(2399);
	
	Object.defineProperty(exports, 'Grow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grow).default;
	  }
	});
	
	var _Fade = __webpack_require__(1573);
	
	Object.defineProperty(exports, 'Fade', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fade).default;
	  }
	});
	
	var _Collapse = __webpack_require__(1572);
	
	Object.defineProperty(exports, 'Collapse', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Collapse).default;
	  }
	});
	
	var _Zoom = __webpack_require__(5680);
	
	Object.defineProperty(exports, 'Zoom', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Zoom).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 5682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.focusKeyPressed = focusKeyPressed;
	exports.detectKeyboardFocus = detectKeyboardFocus;
	exports.listenForFocusKeys = listenForFocusKeys;
	
	var _keycode = __webpack_require__(568);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _contains = __webpack_require__(950);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(2401);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	var internal = {
	  listening: false,
	  focusKeyPressed: false
	};
	
	function focusKeyPressed(pressed) {
	  if (typeof pressed !== 'undefined') {
	    internal.focusKeyPressed = Boolean(pressed);
	  }
	
	  return internal.focusKeyPressed;
	}
	
	function detectKeyboardFocus(instance, element, callback) {
	  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	   false ? (0, _warning2.default)(instance.keyboardFocusCheckTime, 'Material-UI: missing instance.keyboardFocusCheckTime') : void 0;
	   false ? (0, _warning2.default)(instance.keyboardFocusMaxCheckTimes, 'Material-UI: missing instance.keyboardFocusMaxCheckTimes') : void 0;
	
	  instance.keyboardFocusTimeout = setTimeout(function () {
	    if (focusKeyPressed() && (document.activeElement === element || (0, _contains2.default)(element, document.activeElement))) {
	      callback();
	    } else if (attempt < instance.keyboardFocusMaxCheckTimes) {
	      detectKeyboardFocus(instance, element, callback, attempt + 1);
	    }
	  }, instance.keyboardFocusCheckTime);
	}
	
	var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];
	
	function isFocusKey(event) {
	  return FOCUS_KEYS.indexOf((0, _keycode2.default)(event)) !== -1;
	}
	
	function listenForFocusKeys() {
	  // It's a singleton, we only need to listen once.
	  // Also, this logic is client side only, we don't need a teardown.
	  if (!internal.listening) {
	    (0, _addEventListener2.default)(window, 'keyup', function (event) {
	      if (isFocusKey(event)) {
	        internal.focusKeyPressed = true;
	      }
	    });
	    internal.listening = true;
	  }
	}

/***/ }),
/* 5683 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//  weak
	
	var requirePropFactory = function requirePropFactory(componentNameInError) {
	  var requireProp = function requireProp(requiredProp) {
	    return function (props, propName, componentName, location, propFullName) {
	      var propFullNameSafe = propFullName || propName;
	
	      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
	        return new Error('The property `' + propFullNameSafe + '` of ' + ('`' + componentNameInError + '` must be used on `' + requiredProp + '`.'));
	      }
	
	      return null;
	    };
	  };
	  return requireProp;
	};
	
	exports.default = requirePropFactory;

/***/ }),
/* 5684 */,
/* 5685 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.43
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(29)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(29)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.43",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Country object
		************************************/
	
		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
	
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function getCountryNames () {
			return Object.keys(countries);
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) return;
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}
	
		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}
	
		function zonesForCountry(country, with_offset) {
			country = getCountry(country);
	
			if (!country) return null;
	
			var zones = country.zones.sort();
	
			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}
	
			return zones;
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ }),
/* 5686 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 2404,
		"./af.js": 2404,
		"./ar": 2411,
		"./ar-dz": 2405,
		"./ar-dz.js": 2405,
		"./ar-kw": 2406,
		"./ar-kw.js": 2406,
		"./ar-ly": 2407,
		"./ar-ly.js": 2407,
		"./ar-ma": 2408,
		"./ar-ma.js": 2408,
		"./ar-sa": 2409,
		"./ar-sa.js": 2409,
		"./ar-tn": 2410,
		"./ar-tn.js": 2410,
		"./ar.js": 2411,
		"./az": 2412,
		"./az.js": 2412,
		"./be": 2413,
		"./be.js": 2413,
		"./bg": 2414,
		"./bg.js": 2414,
		"./bm": 2415,
		"./bm.js": 2415,
		"./bn": 2417,
		"./bn-bd": 2416,
		"./bn-bd.js": 2416,
		"./bn.js": 2417,
		"./bo": 2418,
		"./bo.js": 2418,
		"./br": 2419,
		"./br.js": 2419,
		"./bs": 2420,
		"./bs.js": 2420,
		"./ca": 2421,
		"./ca.js": 2421,
		"./cs": 2422,
		"./cs.js": 2422,
		"./cv": 2423,
		"./cv.js": 2423,
		"./cy": 2424,
		"./cy.js": 2424,
		"./da": 2425,
		"./da.js": 2425,
		"./de": 2428,
		"./de-at": 2426,
		"./de-at.js": 2426,
		"./de-ch": 2427,
		"./de-ch.js": 2427,
		"./de.js": 2428,
		"./dv": 2429,
		"./dv.js": 2429,
		"./el": 2430,
		"./el.js": 2430,
		"./en-au": 2431,
		"./en-au.js": 2431,
		"./en-ca": 2432,
		"./en-ca.js": 2432,
		"./en-gb": 2433,
		"./en-gb.js": 2433,
		"./en-ie": 2434,
		"./en-ie.js": 2434,
		"./en-il": 2435,
		"./en-il.js": 2435,
		"./en-in": 2436,
		"./en-in.js": 2436,
		"./en-nz": 2437,
		"./en-nz.js": 2437,
		"./en-sg": 2438,
		"./en-sg.js": 2438,
		"./eo": 2439,
		"./eo.js": 2439,
		"./es": 2443,
		"./es-do": 2440,
		"./es-do.js": 2440,
		"./es-mx": 2441,
		"./es-mx.js": 2441,
		"./es-us": 2442,
		"./es-us.js": 2442,
		"./es.js": 2443,
		"./et": 2444,
		"./et.js": 2444,
		"./eu": 2445,
		"./eu.js": 2445,
		"./fa": 2446,
		"./fa.js": 2446,
		"./fi": 2447,
		"./fi.js": 2447,
		"./fil": 2448,
		"./fil.js": 2448,
		"./fo": 2449,
		"./fo.js": 2449,
		"./fr": 2452,
		"./fr-ca": 2450,
		"./fr-ca.js": 2450,
		"./fr-ch": 2451,
		"./fr-ch.js": 2451,
		"./fr.js": 2452,
		"./fy": 2453,
		"./fy.js": 2453,
		"./ga": 2454,
		"./ga.js": 2454,
		"./gd": 2455,
		"./gd.js": 2455,
		"./gl": 2456,
		"./gl.js": 2456,
		"./gom-deva": 2457,
		"./gom-deva.js": 2457,
		"./gom-latn": 2458,
		"./gom-latn.js": 2458,
		"./gu": 2459,
		"./gu.js": 2459,
		"./he": 2460,
		"./he.js": 2460,
		"./hi": 2461,
		"./hi.js": 2461,
		"./hr": 2462,
		"./hr.js": 2462,
		"./hu": 2463,
		"./hu.js": 2463,
		"./hy-am": 2464,
		"./hy-am.js": 2464,
		"./id": 2465,
		"./id.js": 2465,
		"./is": 2466,
		"./is.js": 2466,
		"./it": 2468,
		"./it-ch": 2467,
		"./it-ch.js": 2467,
		"./it.js": 2468,
		"./ja": 2469,
		"./ja.js": 2469,
		"./jv": 2470,
		"./jv.js": 2470,
		"./ka": 2471,
		"./ka.js": 2471,
		"./kk": 2472,
		"./kk.js": 2472,
		"./km": 2473,
		"./km.js": 2473,
		"./kn": 2474,
		"./kn.js": 2474,
		"./ko": 2475,
		"./ko.js": 2475,
		"./ku": 2476,
		"./ku.js": 2476,
		"./ky": 2477,
		"./ky.js": 2477,
		"./lb": 2478,
		"./lb.js": 2478,
		"./lo": 2479,
		"./lo.js": 2479,
		"./lt": 2480,
		"./lt.js": 2480,
		"./lv": 2481,
		"./lv.js": 2481,
		"./me": 2482,
		"./me.js": 2482,
		"./mi": 2483,
		"./mi.js": 2483,
		"./mk": 2484,
		"./mk.js": 2484,
		"./ml": 2485,
		"./ml.js": 2485,
		"./mn": 2486,
		"./mn.js": 2486,
		"./mr": 2487,
		"./mr.js": 2487,
		"./ms": 2489,
		"./ms-my": 2488,
		"./ms-my.js": 2488,
		"./ms.js": 2489,
		"./mt": 2490,
		"./mt.js": 2490,
		"./my": 2491,
		"./my.js": 2491,
		"./nb": 2492,
		"./nb.js": 2492,
		"./ne": 2493,
		"./ne.js": 2493,
		"./nl": 2495,
		"./nl-be": 2494,
		"./nl-be.js": 2494,
		"./nl.js": 2495,
		"./nn": 2496,
		"./nn.js": 2496,
		"./oc-lnc": 2497,
		"./oc-lnc.js": 2497,
		"./pa-in": 2498,
		"./pa-in.js": 2498,
		"./pl": 2499,
		"./pl.js": 2499,
		"./pt": 2501,
		"./pt-br": 2500,
		"./pt-br.js": 2500,
		"./pt.js": 2501,
		"./ro": 2502,
		"./ro.js": 2502,
		"./ru": 2503,
		"./ru.js": 2503,
		"./sd": 2504,
		"./sd.js": 2504,
		"./se": 2505,
		"./se.js": 2505,
		"./si": 2506,
		"./si.js": 2506,
		"./sk": 2507,
		"./sk.js": 2507,
		"./sl": 2508,
		"./sl.js": 2508,
		"./sq": 2509,
		"./sq.js": 2509,
		"./sr": 2511,
		"./sr-cyrl": 2510,
		"./sr-cyrl.js": 2510,
		"./sr.js": 2511,
		"./ss": 2512,
		"./ss.js": 2512,
		"./sv": 2513,
		"./sv.js": 2513,
		"./sw": 2514,
		"./sw.js": 2514,
		"./ta": 2515,
		"./ta.js": 2515,
		"./te": 2516,
		"./te.js": 2516,
		"./tet": 2517,
		"./tet.js": 2517,
		"./tg": 2518,
		"./tg.js": 2518,
		"./th": 2519,
		"./th.js": 2519,
		"./tk": 2520,
		"./tk.js": 2520,
		"./tl-ph": 2521,
		"./tl-ph.js": 2521,
		"./tlh": 2522,
		"./tlh.js": 2522,
		"./tr": 2523,
		"./tr.js": 2523,
		"./tzl": 2524,
		"./tzl.js": 2524,
		"./tzm": 2526,
		"./tzm-latn": 2525,
		"./tzm-latn.js": 2525,
		"./tzm.js": 2526,
		"./ug-cn": 2527,
		"./ug-cn.js": 2527,
		"./uk": 2528,
		"./uk.js": 2528,
		"./ur": 2529,
		"./ur.js": 2529,
		"./uz": 2531,
		"./uz-latn": 2530,
		"./uz-latn.js": 2530,
		"./uz.js": 2531,
		"./vi": 2532,
		"./vi.js": 2532,
		"./x-pseudo": 2533,
		"./x-pseudo.js": 2533,
		"./yo": 2534,
		"./yo.js": 2534,
		"./zh-cn": 2535,
		"./zh-cn.js": 2535,
		"./zh-hk": 2536,
		"./zh-hk.js": 2536,
		"./zh-mo": 2537,
		"./zh-mo.js": 2537,
		"./zh-tw": 2538,
		"./zh-tw.js": 2538
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 5686;


/***/ }),
/* 5687 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 2539,
		"./af.js": 2539,
		"./ar": 2546,
		"./ar-dz": 2540,
		"./ar-dz.js": 2540,
		"./ar-kw": 2541,
		"./ar-kw.js": 2541,
		"./ar-ly": 2542,
		"./ar-ly.js": 2542,
		"./ar-ma": 2543,
		"./ar-ma.js": 2543,
		"./ar-sa": 2544,
		"./ar-sa.js": 2544,
		"./ar-tn": 2545,
		"./ar-tn.js": 2545,
		"./ar.js": 2546,
		"./az": 2547,
		"./az.js": 2547,
		"./be": 2548,
		"./be.js": 2548,
		"./bg": 2549,
		"./bg.js": 2549,
		"./bm": 2550,
		"./bm.js": 2550,
		"./bn": 2551,
		"./bn.js": 2551,
		"./bo": 2552,
		"./bo.js": 2552,
		"./br": 2553,
		"./br.js": 2553,
		"./bs": 2554,
		"./bs.js": 2554,
		"./ca": 2555,
		"./ca.js": 2555,
		"./cs": 2556,
		"./cs.js": 2556,
		"./cv": 2557,
		"./cv.js": 2557,
		"./cy": 2558,
		"./cy.js": 2558,
		"./da": 2559,
		"./da.js": 2559,
		"./de": 2562,
		"./de-at": 2560,
		"./de-at.js": 2560,
		"./de-ch": 2561,
		"./de-ch.js": 2561,
		"./de.js": 2562,
		"./dv": 2563,
		"./dv.js": 2563,
		"./el": 2564,
		"./el.js": 2564,
		"./en-au": 2565,
		"./en-au.js": 2565,
		"./en-ca": 2566,
		"./en-ca.js": 2566,
		"./en-gb": 2567,
		"./en-gb.js": 2567,
		"./en-ie": 2568,
		"./en-ie.js": 2568,
		"./en-il": 2569,
		"./en-il.js": 2569,
		"./en-nz": 2570,
		"./en-nz.js": 2570,
		"./eo": 2571,
		"./eo.js": 2571,
		"./es": 2574,
		"./es-do": 2572,
		"./es-do.js": 2572,
		"./es-us": 2573,
		"./es-us.js": 2573,
		"./es.js": 2574,
		"./et": 2575,
		"./et.js": 2575,
		"./eu": 2576,
		"./eu.js": 2576,
		"./fa": 2577,
		"./fa.js": 2577,
		"./fi": 2578,
		"./fi.js": 2578,
		"./fo": 2579,
		"./fo.js": 2579,
		"./fr": 2582,
		"./fr-ca": 2580,
		"./fr-ca.js": 2580,
		"./fr-ch": 2581,
		"./fr-ch.js": 2581,
		"./fr.js": 2582,
		"./fy": 2583,
		"./fy.js": 2583,
		"./gd": 2584,
		"./gd.js": 2584,
		"./gl": 2585,
		"./gl.js": 2585,
		"./gom-latn": 2586,
		"./gom-latn.js": 2586,
		"./gu": 2587,
		"./gu.js": 2587,
		"./he": 2588,
		"./he.js": 2588,
		"./hi": 2589,
		"./hi.js": 2589,
		"./hr": 2590,
		"./hr.js": 2590,
		"./hu": 2591,
		"./hu.js": 2591,
		"./hy-am": 2592,
		"./hy-am.js": 2592,
		"./id": 2593,
		"./id.js": 2593,
		"./is": 2594,
		"./is.js": 2594,
		"./it": 2595,
		"./it.js": 2595,
		"./ja": 2596,
		"./ja.js": 2596,
		"./jv": 2597,
		"./jv.js": 2597,
		"./ka": 2598,
		"./ka.js": 2598,
		"./kk": 2599,
		"./kk.js": 2599,
		"./km": 2600,
		"./km.js": 2600,
		"./kn": 2601,
		"./kn.js": 2601,
		"./ko": 2602,
		"./ko.js": 2602,
		"./ky": 2603,
		"./ky.js": 2603,
		"./lb": 2604,
		"./lb.js": 2604,
		"./lo": 2605,
		"./lo.js": 2605,
		"./lt": 2606,
		"./lt.js": 2606,
		"./lv": 2607,
		"./lv.js": 2607,
		"./me": 2608,
		"./me.js": 2608,
		"./mi": 2609,
		"./mi.js": 2609,
		"./mk": 2610,
		"./mk.js": 2610,
		"./ml": 2611,
		"./ml.js": 2611,
		"./mn": 2612,
		"./mn.js": 2612,
		"./mr": 2613,
		"./mr.js": 2613,
		"./ms": 2615,
		"./ms-my": 2614,
		"./ms-my.js": 2614,
		"./ms.js": 2615,
		"./mt": 2616,
		"./mt.js": 2616,
		"./my": 2617,
		"./my.js": 2617,
		"./nb": 2618,
		"./nb.js": 2618,
		"./ne": 2619,
		"./ne.js": 2619,
		"./nl": 2621,
		"./nl-be": 2620,
		"./nl-be.js": 2620,
		"./nl.js": 2621,
		"./nn": 2622,
		"./nn.js": 2622,
		"./pa-in": 2623,
		"./pa-in.js": 2623,
		"./pl": 2624,
		"./pl.js": 2624,
		"./pt": 2626,
		"./pt-br": 2625,
		"./pt-br.js": 2625,
		"./pt.js": 2626,
		"./ro": 2627,
		"./ro.js": 2627,
		"./ru": 2628,
		"./ru.js": 2628,
		"./sd": 2629,
		"./sd.js": 2629,
		"./se": 2630,
		"./se.js": 2630,
		"./si": 2631,
		"./si.js": 2631,
		"./sk": 2632,
		"./sk.js": 2632,
		"./sl": 2633,
		"./sl.js": 2633,
		"./sq": 2634,
		"./sq.js": 2634,
		"./sr": 2636,
		"./sr-cyrl": 2635,
		"./sr-cyrl.js": 2635,
		"./sr.js": 2636,
		"./ss": 2637,
		"./ss.js": 2637,
		"./sv": 2638,
		"./sv.js": 2638,
		"./sw": 2639,
		"./sw.js": 2639,
		"./ta": 2640,
		"./ta.js": 2640,
		"./te": 2641,
		"./te.js": 2641,
		"./tet": 2642,
		"./tet.js": 2642,
		"./tg": 2643,
		"./tg.js": 2643,
		"./th": 2644,
		"./th.js": 2644,
		"./tl-ph": 2645,
		"./tl-ph.js": 2645,
		"./tlh": 2646,
		"./tlh.js": 2646,
		"./tr": 2647,
		"./tr.js": 2647,
		"./tzl": 2648,
		"./tzl.js": 2648,
		"./tzm": 2650,
		"./tzm-latn": 2649,
		"./tzm-latn.js": 2649,
		"./tzm.js": 2650,
		"./ug-cn": 2651,
		"./ug-cn.js": 2651,
		"./uk": 2652,
		"./uk.js": 2652,
		"./ur": 2653,
		"./ur.js": 2653,
		"./uz": 2655,
		"./uz-latn": 2654,
		"./uz-latn.js": 2654,
		"./uz.js": 2655,
		"./vi": 2656,
		"./vi.js": 2656,
		"./x-pseudo": 2657,
		"./x-pseudo.js": 2657,
		"./yo": 2658,
		"./yo.js": 2658,
		"./zh-cn": 2659,
		"./zh-cn.js": 2659,
		"./zh-hk": 2660,
		"./zh-hk.js": 2660,
		"./zh-tw": 2661,
		"./zh-tw.js": 2661
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 5687;


/***/ }),
/* 5688 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
	var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	var cachedType;
	function _setScrollType(type) {
	    cachedType = type;
	}
	exports._setScrollType = _setScrollType;
	// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
	function detectScrollType() {
	    if (cachedType) {
	        return cachedType;
	    }
	    if (!inDOM || !window.document.body) {
	        return 'indeterminate';
	    }
	    var dummy = window.document.createElement('div');
	    dummy.appendChild(document.createTextNode('ABCD'));
	    dummy.dir = 'rtl';
	    dummy.style.fontSize = '14px';
	    dummy.style.width = '4px';
	    dummy.style.height = '1px';
	    dummy.style.position = 'absolute';
	    dummy.style.top = '-1000px';
	    dummy.style.overflow = 'scroll';
	    document.body.appendChild(dummy);
	    cachedType = 'reverse';
	    if (dummy.scrollLeft > 0) {
	        cachedType = 'default';
	    }
	    else {
	        dummy.scrollLeft = 1;
	        if (dummy.scrollLeft === 0) {
	            cachedType = 'negative';
	        }
	    }
	    document.body.removeChild(dummy);
	    return cachedType;
	}
	exports.detectScrollType = detectScrollType;
	// Based on https://stackoverflow.com/a/24394376
	function getNormalizedScrollLeft(element, direction) {
	    var scrollLeft = element.scrollLeft;
	    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	    if (direction !== 'rtl') {
	        return scrollLeft;
	    }
	    var type = detectScrollType();
	    if (type === 'indeterminate') {
	        return Number.NaN;
	    }
	    switch (type) {
	        case 'negative':
	            return element.scrollWidth - element.clientWidth + scrollLeft;
	        case 'reverse':
	            return element.scrollWidth - element.clientWidth - scrollLeft;
	    }
	    return scrollLeft;
	}
	exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
	function setNormalizedScrollLeft(element, scrollLeft, direction) {
	    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	    if (direction !== 'rtl') {
	        element.scrollLeft = scrollLeft;
	        return;
	    }
	    var type = detectScrollType();
	    if (type === 'indeterminate') {
	        return;
	    }
	    switch (type) {
	        case 'negative':
	            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
	            break;
	        case 'reverse':
	            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
	            break;
	        default:
	            element.scrollLeft = scrollLeft;
	            break;
	    }
	}
	exports.setNormalizedScrollLeft = setNormalizedScrollLeft;


/***/ }),
/* 5689 */
/***/ (function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 5690 */
/***/ (function(module, exports) {

	"use strict";
	
	/* https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.is */
	
	var NumberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		} else if (a === b) {
			return true;
		} else if (NumberIsNaN(a) && NumberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ }),
/* 5691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(2663); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 5692 */,
/* 5693 */
/***/ (function(module, exports) {

	var appCacheIframe;
	
	function hasSW() {
	  return 'serviceWorker' in navigator &&
	    // This is how I block Chrome 40 and detect Chrome 41, because first has
	    // bugs with history.pustState and/or hashchange
	    (window.fetch || 'imageRendering' in document.documentElement.style) &&
	    (window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname.indexOf('127.') === 0)
	}
	
	function install(options) {
	  options || (options = {});
	
	  
	    if (hasSW()) {
	      var registration = navigator.serviceWorker
	        .register(
	          "/sw.js"
	          
	        );
	
	      
	        var handleUpdating = function(registration) {
	          var sw = registration.installing || registration.waiting;
	          var ignoreInstalling;
	          var ignoreWaiting;
	
	          // No SW or already handled
	          if (!sw || sw.onstatechange) return;
	
	          var stateChangeHandler;
	
	          // Already has SW
	          if (registration.active) {
	            onUpdateStateChange();
	            stateChangeHandler = onUpdateStateChange;
	          } else {
	            onInstallStateChange();
	            stateChangeHandler = onInstallStateChange;
	          }
	
	          ignoreInstalling = true;
	          if (registration.waiting) {
	            ignoreWaiting = true;
	          }
	
	          sw.onstatechange = stateChangeHandler;
	
	          function onUpdateStateChange() {
	            switch (sw.state) {
	              case 'redundant': {
	                sendEvent('onUpdateFailed');
	                sw.onstatechange = null;
	              } break;
	
	              case 'installing': {
	                if (!ignoreInstalling) {
	                  sendEvent('onUpdating');
	                }
	              } break;
	
	              case 'installed': {
	                if (!ignoreWaiting) {
	                  sendEvent('onUpdateReady');
	                }
	              } break;
	
	              case 'activated': {
	                sendEvent('onUpdated');
	                sw.onstatechange = null;
	              } break;
	            }
	          }
	
	          function onInstallStateChange() {
	            switch (sw.state) {
	              case 'redundant': {
	                // Failed to install, ignore
	                sw.onstatechange = null;
	              } break;
	
	              case 'installing': {
	                // Installing, ignore
	              } break;
	
	              case 'installed': {
	                // Installed, wait activation
	              } break;
	
	              case 'activated': {
	                sendEvent('onInstalled');
	                sw.onstatechange = null;
	              } break;
	            }
	          }
	        };
	
	        var sendEvent = function(event) {
	          if (typeof options[event] === 'function') {
	            options[event]({
	              source: 'ServiceWorker'
	            });
	          }
	        };
	
	        registration.then(function(reg) {
	          // WTF no reg?
	          if (!reg) return;
	
	          // Installed but Shift-Reloaded (page is not controller by SW),
	          // update might be ready at this point (more than one tab opened).
	          // Anyway, if page is hard-reloaded, then it probably already have latest version
	          // but it's not controlled by SW yet. Applying update will claim this page
	          // to be controlled by SW. Maybe set flag to not reload it?
	          // if (!navigator.serviceWorker.controller) return;
	
	          handleUpdating(reg);
	          reg.onupdatefound = function() {
	            handleUpdating(reg);
	          };
	        }).catch(function(err) {
	          sendEvent('onError');
	          return Promise.reject(err);
	        });
	      
	
	      return;
	    }
	  
	
	  
	}
	
	function applyUpdate(callback, errback) {
	  
	    if (hasSW()) {
	      navigator.serviceWorker.getRegistration().then(function(registration) {
	        if (!registration || !registration.waiting) {
	          errback && errback();
	          return;
	        }
	
	        registration.waiting.postMessage({
	          action: 'skipWaiting'
	        });
	
	        callback && callback();
	      });
	
	      return;
	    }
	  
	
	  
	}
	
	function update() {
	  
	    if (hasSW()) {
	      navigator.serviceWorker.getRegistration().then(function(registration) {
	        if (!registration) return;
	        return registration.update();
	      });
	    }
	  
	
	  
	}
	
	
	
	exports.install = install;
	exports.applyUpdate = applyUpdate;
	exports.update = update;


/***/ }),
/* 5694 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.12.9
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  // NOTE: 1 DOM access here
	  var offsetParent = element && element.offsetParent;
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    if (element) {
	      return element.ownerDocument.documentElement;
	    }
	
	    return document.documentElement;
	  }
	
	  // .offsetParent will return the closest TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	/**
	 * Tells if you are running Internet Explorer 10
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean} isIE10
	 */
	var isIE10 = undefined;
	
	var isIE10$1 = function () {
	  if (isIE10 === undefined) {
	    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
	  }
	  return isIE10;
	};
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
	}
	
	function getWindowSizes() {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE10$1() && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  if (isIE10$1()) {
	    try {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } catch (err) {}
	  } else {
	    rect = element.getBoundingClientRect();
	  }
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var isIE10 = isIE10$1();
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = getScroll(html);
	  var scrollLeft = getScroll(html, 'left');
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  // NOTE: 1 DOM access here
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  boundaries.left += padding;
	  boundaries.top += padding;
	  boundaries.right -= padding;
	  boundaries.bottom -= padding;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var commonOffsetParent = findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var styles = getComputedStyle(element);
	  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	  data.offsets.popper.position = 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length - 1; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroy the popper
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.left = '';
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger onUpdate callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper.
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  // floor sides to avoid blurry text
	  var offsets = {
	    left: Math.floor(popper.left),
	    top: Math.floor(popper.top),
	    bottom: Math.floor(popper.bottom),
	    right: Math.floor(popper.right)
	  };
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    top = -offsetParentRect.height + offsets.bottom;
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    left = -offsetParentRect.width + offsets.right;
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjuction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-right` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unitless, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the height.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * An scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper this makes sure the popper has always a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier, can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near eachothers
	   * without leaving any gap between the two. Expecially useful when the arrow is
	   * enabled and you want to assure it to point to its reference element.
	   * It cares only about the first axis, you can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjuction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations).
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position,
	     * the popper will never be placed outside of the defined boundaries
	     * (except if keepTogether is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define you own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the informations used by Popper.js
	 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overriden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass as 3rd argument an object with the same
	 * structure of this object, example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Whether events (resize, scroll) are initially enabled
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated, this callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Create a new Popper.js instance
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as popper.
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedule an update, it will run on the next UI update available
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(2665);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ }),
/* 5696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(2665);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ }),
/* 5697 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(5259);
	var invariant = __webpack_require__(2284);
	var ReactPropTypesSecret = __webpack_require__(5698);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 5698 */
6261,
/* 5699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(5701);
	var parse = __webpack_require__(5700);
	var formats = __webpack_require__(2666);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 5700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1577);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	var parseArrayValue = function (val, options) {
	    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	        return val.split(',');
	    }
	
	    return val;
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset, 'key');
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
	            val = utils.maybeMap(
	                parseArrayValue(part.slice(pos + 1), options),
	                function (encodedVal) {
	                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
	                }
	            );
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(val);
	        }
	
	        if (part.indexOf('[]=') > -1) {
	            val = isArray(val) ? [val] : val;
	        }
	
	        if (has.call(obj, key)) {
	            obj[key] = utils.combine(obj[key], val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options, valuesParsed) {
	    var leaf = valuesParsed ? val : parseArrayValue(val, options);
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (!options.parseArrays && cleanRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj; // eslint-disable-line no-param-reassign
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = options.depth > 0 && brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options, valuesParsed);
	};
	
	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	
	    return {
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (str, opts) {
	    var options = normalizeParseOptions(opts);
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 5701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1577);
	var formats = __webpack_require__(2666);
	var has = Object.prototype.hasOwnProperty;
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaultFormat = formats['default'];
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    format: defaultFormat,
	    formatter: formats.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint';
	};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly,
	    charset
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        obj = utils.maybeMap(obj, function (value) {
	            if (value instanceof Date) {
	                return serializeDate(value);
	            }
	            return value;
	        }).join(',');
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	        var value = obj[key];
	
	        if (skipNulls && value === null) {
	            continue;
	        }
	
	        var keyPrefix = isArray(obj)
	            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
	            : prefix + (allowDots ? '.' + key : '[' + key + ']');
	
	        pushToArray(values, stringify(
	            value,
	            keyPrefix,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encoder,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly,
	            charset
	        ));
	    }
	
	    return values;
	};
	
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var charset = opts.charset || defaults.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    var format = formats['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has.call(formats.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats.formatters[format];
	
	    var filter = defaults.filter;
	    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
	        filter = opts.filter;
	    }
	
	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
	        filter: filter,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);
	
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = opts.arrayFormat;
	    } else if (opts && 'indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (options.skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset
	        ));
	    }
	
	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ }),
/* 5702 */,
/* 5703 */,
/* 5704 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5318)
	
	/**
	 * `requestAnimationFrame()`
	 */
	
	var request = global.requestAnimationFrame
	  || global.webkitRequestAnimationFrame
	  || global.mozRequestAnimationFrame
	  || fallback
	
	var prev = +new Date
	function fallback (fn) {
	  var curr = +new Date
	  var ms = Math.max(0, 16 - (curr - prev))
	  var req = setTimeout(fn, ms)
	  return prev = curr, req
	}
	
	/**
	 * `cancelAnimationFrame()`
	 */
	
	var cancel = global.cancelAnimationFrame
	  || global.webkitCancelAnimationFrame
	  || global.mozCancelAnimationFrame
	  || clearTimeout
	
	if (Function.prototype.bind) {
	  request = request.bind(global)
	  cancel = cancel.bind(global)
	}
	
	exports = module.exports = request
	exports.cancel = cancel


/***/ }),
/* 5705 */,
/* 5706 */
[6722, 471, 328],
/* 5707 */
[6723, 5755, 5756, 5757, 5758, 5759],
/* 5708 */
[6727, 471, 328],
/* 5709 */
[6728, 471, 328],
/* 5710 */
[6729, 1580, 5779, 5780],
/* 5711 */
[6732, 328],
/* 5712 */
[6733, 471, 328],
/* 5713 */
5390,
/* 5714 */
2685,
/* 5715 */
[6734, 5737, 2677, 329, 2679, 2672, 2681],
/* 5716 */
2686,
/* 5717 */
5821,
/* 5718 */
5822,
/* 5719 */
[6708, 5721],
/* 5720 */
[6737, 5745],
/* 5721 */
[6738, 5723, 5743],
/* 5722 */
[6740, 5744],
/* 5723 */
[6741, 5722, 1586],
/* 5724 */
[6743, 5717, 329],
/* 5725 */
5829,
/* 5726 */
[6746, 739, 740],
/* 5727 */
[6748, 2667, 2670, 5746, 5747, 5752, 329, 2679, 2681],
/* 5728 */
[6749, 2667, 1581],
/* 5729 */
[6750, 2680, 5761, 1584, 2675],
/* 5730 */
[6751, 739, 1583, 740],
/* 5731 */
[6752, 5733, 5734, 5790, 329, 5794],
/* 5732 */
[6753, 5762, 5775],
/* 5733 */
[6754, 5728, 5749, 2674],
/* 5734 */
[6755, 1581, 5788, 5789, 1582, 2673, 2674, 1000],
/* 5735 */
5840,
/* 5736 */
[6756, 2668],
/* 5737 */
5845,
/* 5738 */
[6759, 996, 5716, 329, 1585],
/* 5739 */
5846,
/* 5740 */
5848,
/* 5741 */
[6767, 328],
/* 5742 */
[6710, 5713, 5719, 5731, 329],
/* 5743 */
[6769, 2678],
/* 5744 */
5857,
/* 5745 */
[6770, 471],
/* 5746 */
[6772, 996, 5711, 2676, 2670, 5773, 5781],
/* 5747 */
[6713, 5748],
/* 5748 */
[6774, 5724, 5751, 1586],
/* 5749 */
[6776, 2673, 1586],
/* 5750 */
[6778, 996],
/* 5751 */
[6779, 5714, 5795],
/* 5752 */
[6780, 5706, 1579, 5708, 5709, 5712, 739, 2675],
/* 5753 */
5865,
/* 5754 */
[6781, 2669, 2677, 329, 2672, 1583, 1000],
/* 5755 */
[6782, 999],
/* 5756 */
5869,
/* 5757 */
[6783, 999],
/* 5758 */
[6784, 999],
/* 5759 */
[6785, 999],
/* 5760 */
5874,
/* 5761 */
[6788, 5741],
/* 5762 */
2697,
/* 5763 */
5876,
/* 5764 */
[6790, 997],
/* 5765 */
[6791, 997],
/* 5766 */
[6792, 997],
/* 5767 */
[6793, 997],
/* 5768 */
[6794, 5707, 995, 1579],
/* 5769 */
[6795, 998],
/* 5770 */
[6796, 998],
/* 5771 */
[6797, 998],
/* 5772 */
[6798, 998],
/* 5773 */
5886,
/* 5774 */
[6799, 5793],
/* 5775 */
[6801, 5778],
/* 5776 */
[6714, 2671],
/* 5777 */
5890,
/* 5778 */
2873,
/* 5779 */
5893,
/* 5780 */
5894,
/* 5781 */
5895,
/* 5782 */
[6806, 995],
/* 5783 */
5899,
/* 5784 */
5900,
/* 5785 */
5901,
/* 5786 */
[6807, 995, 1579, 1580],
/* 5787 */
[6715, 5774],
/* 5788 */
[6813, 2668],
/* 5789 */
[6814, 5725, 5754],
/* 5790 */
1009,
/* 5791 */
[6717, 1581],
/* 5792 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(5720),
	    createAggregator = __webpack_require__(5742);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ }),
/* 5793 */
[6825, 1580],
/* 5794 */
[6826, 5735, 5736, 1582, 1000],
/* 5795 */
5918,
/* 5796 */
5919,
/* 5797 */
[6830, 5738],
/* 5798 */
[6835, 5800],
/* 5799 */
[6836, 5798],
/* 5800 */
6261,
/* 5801 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 5802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _cropperjs = _interopRequireDefault(__webpack_require__(4609));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var optionProps = ['dragMode', 'aspectRatio', 'data', 'crop', // unchangeable props start from here
	'viewMode', 'preview', 'responsive', 'restore', 'checkCrossOrigin', 'checkOrientation', 'modal', 'guides', 'center', 'highlight', 'background', 'autoCrop', 'autoCropArea', 'movable', 'rotatable', 'scalable', 'zoomable', 'zoomOnTouch', 'zoomOnWheel', 'wheelZoomRatio', 'cropBoxMovable', 'cropBoxResizable', 'toggleDragModeOnDblclick', 'minContainerWidth', 'minContainerHeight', 'minCanvasWidth', 'minCanvasHeight', 'minCropBoxWidth', 'minCropBoxHeight', 'ready', 'cropstart', 'cropmove', 'cropend', 'zoom'];
	var unchangeableProps = optionProps.slice(4);
	
	var ReactCropper =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ReactCropper, _Component);
	
	  function ReactCropper() {
	    _classCallCheck(this, ReactCropper);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReactCropper).apply(this, arguments));
	  }
	
	  _createClass(ReactCropper, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this = this;
	
	      var options = Object.keys(this.props).filter(function (propKey) {
	        return optionProps.indexOf(propKey) !== -1;
	      }).reduce(function (prevOptions, propKey) {
	        return _extends({}, prevOptions, _defineProperty({}, propKey, _this.props[propKey]));
	      }, {});
	      this.cropper = new _cropperjs.default(this.img, options);
	    }
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.src !== this.props.src) {
	        this.cropper.reset().clear().replace(nextProps.src);
	      }
	
	      if (nextProps.aspectRatio !== this.props.aspectRatio) {
	        this.setAspectRatio(nextProps.aspectRatio);
	      }
	
	      if (nextProps.data !== this.props.data) {
	        this.setData(nextProps.data);
	      }
	
	      if (nextProps.dragMode !== this.props.dragMode) {
	        this.setDragMode(nextProps.dragMode);
	      }
	
	      if (nextProps.cropBoxData !== this.props.cropBoxData) {
	        this.setCropBoxData(nextProps.cropBoxData);
	      }
	
	      if (nextProps.canvasData !== this.props.canvasData) {
	        this.setCanvasData(nextProps.canvasData);
	      }
	
	      if (nextProps.moveTo !== this.props.moveTo) {
	        if (nextProps.moveTo.length > 1) {
	          this.moveTo(nextProps.moveTo[0], nextProps.moveTo[1]);
	        } else {
	          this.moveTo(nextProps.moveTo[0]);
	        }
	      }
	
	      if (nextProps.zoomTo !== this.props.zoomTo) {
	        this.zoomTo(nextProps.zoomTo);
	      }
	
	      if (nextProps.rotateTo !== this.props.rotateTo) {
	        this.rotateTo(nextProps.rotateTo);
	      }
	
	      if (nextProps.scaleX !== this.props.scaleX) {
	        this.scaleX(nextProps.scaleX);
	      }
	
	      if (nextProps.scaleY !== this.props.scaleY) {
	        this.scaleY(nextProps.scaleY);
	      }
	
	      if (nextProps.enable !== this.props.enable) {
	        if (nextProps.enable) {
	          this.enable();
	        } else {
	          this.disable();
	        }
	      }
	
	      Object.keys(nextProps).forEach(function (propKey) {
	        var isDifferentVal = nextProps[propKey] !== _this2.props[propKey];
	        var isUnchangeableProps = unchangeableProps.indexOf(propKey) !== -1;
	
	        if (typeof nextProps[propKey] === 'function' && typeof _this2.props[propKey] === 'function') {
	          isDifferentVal = nextProps[propKey].toString() !== _this2.props[propKey].toString();
	        }
	
	        if (isDifferentVal && isUnchangeableProps) {
	          throw new Error("prop: ".concat(propKey, " can't be change after componentDidMount"));
	        }
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.img) {
	        // Destroy the cropper, this makes sure events such as resize are cleaned up and do not leak
	        this.cropper.destroy();
	        delete this.img;
	        delete this.cropper;
	      }
	    }
	  }, {
	    key: "setDragMode",
	    value: function setDragMode(mode) {
	      return this.cropper.setDragMode(mode);
	    }
	  }, {
	    key: "setAspectRatio",
	    value: function setAspectRatio(aspectRatio) {
	      return this.cropper.setAspectRatio(aspectRatio);
	    }
	  }, {
	    key: "getCroppedCanvas",
	    value: function getCroppedCanvas(options) {
	      return this.cropper.getCroppedCanvas(options);
	    }
	  }, {
	    key: "setCropBoxData",
	    value: function setCropBoxData(data) {
	      return this.cropper.setCropBoxData(data);
	    }
	  }, {
	    key: "getCropBoxData",
	    value: function getCropBoxData() {
	      return this.cropper.getCropBoxData();
	    }
	  }, {
	    key: "setCanvasData",
	    value: function setCanvasData(data) {
	      return this.cropper.setCanvasData(data);
	    }
	  }, {
	    key: "getCanvasData",
	    value: function getCanvasData() {
	      return this.cropper.getCanvasData();
	    }
	  }, {
	    key: "getImageData",
	    value: function getImageData() {
	      return this.cropper.getImageData();
	    }
	  }, {
	    key: "getContainerData",
	    value: function getContainerData() {
	      return this.cropper.getContainerData();
	    }
	  }, {
	    key: "setData",
	    value: function setData(data) {
	      return this.cropper.setData(data);
	    }
	  }, {
	    key: "getData",
	    value: function getData(rounded) {
	      return this.cropper.getData(rounded);
	    }
	  }, {
	    key: "crop",
	    value: function crop() {
	      return this.cropper.crop();
	    }
	  }, {
	    key: "move",
	    value: function move(offsetX, offsetY) {
	      return this.cropper.move(offsetX, offsetY);
	    }
	  }, {
	    key: "moveTo",
	    value: function moveTo(x, y) {
	      return this.cropper.moveTo(x, y);
	    }
	  }, {
	    key: "zoom",
	    value: function zoom(ratio) {
	      return this.cropper.zoom(ratio);
	    }
	  }, {
	    key: "zoomTo",
	    value: function zoomTo(ratio) {
	      return this.cropper.zoomTo(ratio);
	    }
	  }, {
	    key: "rotate",
	    value: function rotate(degree) {
	      return this.cropper.rotate(degree);
	    }
	  }, {
	    key: "rotateTo",
	    value: function rotateTo(degree) {
	      return this.cropper.rotateTo(degree);
	    }
	  }, {
	    key: "enable",
	    value: function enable() {
	      return this.cropper.enable();
	    }
	  }, {
	    key: "disable",
	    value: function disable() {
	      return this.cropper.disable();
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      return this.cropper.reset();
	    }
	  }, {
	    key: "clear",
	    value: function clear() {
	      return this.cropper.clear();
	    }
	  }, {
	    key: "replace",
	    value: function replace(url, onlyColorChanged) {
	      return this.cropper.replace(url, onlyColorChanged);
	    }
	  }, {
	    key: "scale",
	    value: function scale(scaleX, scaleY) {
	      return this.cropper.scale(scaleX, scaleY);
	    }
	  }, {
	    key: "scaleX",
	    value: function scaleX(_scaleX) {
	      return this.cropper.scaleX(_scaleX);
	    }
	  }, {
	    key: "scaleY",
	    value: function scaleY(_scaleY) {
	      return this.cropper.scaleY(_scaleY);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _this$props = this.props,
	          src = _this$props.src,
	          alt = _this$props.alt,
	          crossOrigin = _this$props.crossOrigin,
	          style = _this$props.style,
	          className = _this$props.className;
	      return _react.default.createElement("div", {
	        style: style,
	        className: className
	      }, _react.default.createElement("img", {
	        crossOrigin: crossOrigin,
	        ref: function ref(img) {
	          _this3.img = img;
	        },
	        src: src,
	        alt: alt === undefined ? 'picture' : alt,
	        style: {
	          opacity: 0
	        }
	      }));
	    }
	  }]);
	
	  return ReactCropper;
	}(_react.Component);
	
	ReactCropper.propTypes = {
	  style: _propTypes.default.object,
	  // eslint-disable-line react/forbid-prop-types
	  className: _propTypes.default.string,
	  // react cropper options
	  crossOrigin: _propTypes.default.string,
	  src: _propTypes.default.string,
	  alt: _propTypes.default.string,
	  // props of option can be changed after componentDidmount
	  aspectRatio: _propTypes.default.number,
	  dragMode: _propTypes.default.oneOf(['crop', 'move', 'none']),
	  data: _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number,
	    rotate: _propTypes.default.number,
	    scaleX: _propTypes.default.number,
	    scaleY: _propTypes.default.number
	  }),
	  scaleX: _propTypes.default.number,
	  scaleY: _propTypes.default.number,
	  enable: _propTypes.default.bool,
	  cropBoxData: _propTypes.default.shape({
	    left: _propTypes.default.number,
	    top: _propTypes.default.number,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  }),
	  canvasData: _propTypes.default.shape({
	    left: _propTypes.default.number,
	    top: _propTypes.default.number,
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  }),
	  zoomTo: _propTypes.default.number,
	  moveTo: _propTypes.default.arrayOf(_propTypes.default.number),
	  rotateTo: _propTypes.default.number,
	  // cropperjs options
	  // https://github.com/fengyuanchen/cropperjs#options
	  // aspectRatio, dragMode, data
	  viewMode: _propTypes.default.oneOf([0, 1, 2, 3]),
	  preview: _propTypes.default.string,
	  responsive: _propTypes.default.bool,
	  restore: _propTypes.default.bool,
	  checkCrossOrigin: _propTypes.default.bool,
	  checkOrientation: _propTypes.default.bool,
	  modal: _propTypes.default.bool,
	  guides: _propTypes.default.bool,
	  center: _propTypes.default.bool,
	  highlight: _propTypes.default.bool,
	  background: _propTypes.default.bool,
	  autoCrop: _propTypes.default.bool,
	  autoCropArea: _propTypes.default.number,
	  movable: _propTypes.default.bool,
	  rotatable: _propTypes.default.bool,
	  scalable: _propTypes.default.bool,
	  zoomable: _propTypes.default.bool,
	  zoomOnTouch: _propTypes.default.bool,
	  zoomOnWheel: _propTypes.default.bool,
	  wheelZoomRatio: _propTypes.default.number,
	  cropBoxMovable: _propTypes.default.bool,
	  cropBoxResizable: _propTypes.default.bool,
	  toggleDragModeOnDblclick: _propTypes.default.bool,
	  minContainerWidth: _propTypes.default.number,
	  minContainerHeight: _propTypes.default.number,
	  minCanvasWidth: _propTypes.default.number,
	  minCanvasHeight: _propTypes.default.number,
	  minCropBoxWidth: _propTypes.default.number,
	  minCropBoxHeight: _propTypes.default.number,
	  ready: _propTypes.default.func,
	  cropstart: _propTypes.default.func,
	  cropmove: _propTypes.default.func,
	  cropend: _propTypes.default.func,
	  crop: _propTypes.default.func,
	  zoom: _propTypes.default.func
	};
	ReactCropper.defaultProps = {
	  src: null,
	  dragMode: 'crop',
	  data: null,
	  scaleX: 1,
	  scaleY: 1,
	  enable: true,
	  zoomTo: 1,
	  rotateTo: 0
	};
	var _default = ReactCropper;
	exports.default = _default;


/***/ }),
/* 5803 */,
/* 5804 */,
/* 5805 */,
/* 5806 */,
/* 5807 */,
/* 5808 */,
/* 5809 */,
/* 5810 */,
/* 5811 */,
/* 5812 */,
/* 5813 */,
/* 5814 */,
/* 5815 */,
/* 5816 */,
/* 5817 */,
/* 5818 */,
/* 5819 */,
/* 5820 */,
/* 5821 */,
/* 5822 */,
/* 5823 */,
/* 5824 */,
/* 5825 */,
/* 5826 */,
/* 5827 */,
/* 5828 */,
/* 5829 */,
/* 5830 */,
/* 5831 */,
/* 5832 */,
/* 5833 */,
/* 5834 */,
/* 5835 */,
/* 5836 */,
/* 5837 */,
/* 5838 */,
/* 5839 */,
/* 5840 */,
/* 5841 */,
/* 5842 */,
/* 5843 */,
/* 5844 */,
/* 5845 */,
/* 5846 */,
/* 5847 */,
/* 5848 */,
/* 5849 */,
/* 5850 */,
/* 5851 */,
/* 5852 */,
/* 5853 */,
/* 5854 */,
/* 5855 */,
/* 5856 */,
/* 5857 */,
/* 5858 */,
/* 5859 */,
/* 5860 */,
/* 5861 */,
/* 5862 */,
/* 5863 */,
/* 5864 */,
/* 5865 */,
/* 5866 */,
/* 5867 */,
/* 5868 */,
/* 5869 */,
/* 5870 */,
/* 5871 */,
/* 5872 */,
/* 5873 */,
/* 5874 */,
/* 5875 */,
/* 5876 */,
/* 5877 */,
/* 5878 */,
/* 5879 */,
/* 5880 */,
/* 5881 */,
/* 5882 */,
/* 5883 */,
/* 5884 */,
/* 5885 */,
/* 5886 */,
/* 5887 */,
/* 5888 */,
/* 5889 */,
/* 5890 */,
/* 5891 */,
/* 5892 */,
/* 5893 */,
/* 5894 */,
/* 5895 */,
/* 5896 */,
/* 5897 */,
/* 5898 */,
/* 5899 */,
/* 5900 */,
/* 5901 */,
/* 5902 */,
/* 5903 */,
/* 5904 */,
/* 5905 */,
/* 5906 */,
/* 5907 */,
/* 5908 */,
/* 5909 */,
/* 5910 */,
/* 5911 */,
/* 5912 */,
/* 5913 */,
/* 5914 */,
/* 5915 */,
/* 5916 */,
/* 5917 */,
/* 5918 */,
/* 5919 */,
/* 5920 */,
/* 5921 */,
/* 5922 */,
/* 5923 */,
/* 5924 */,
/* 5925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _themrShape = __webpack_require__(5927);
	
	var _themrShape2 = _interopRequireDefault(_themrShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ThemeProvider = (_temp = _class = function (_Component) {
	  _inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    _classCallCheck(this, ThemeProvider);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    return {
	      themr: {
	        theme: this.props.theme
	      }
	    };
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.element.isRequired,
	  theme: _propTypes2.default.object.isRequired
	}, _class.defaultProps = {
	  theme: {}
	}, _class.childContextTypes = {
	  themr: _themrShape2.default.isRequired
	}, _temp);
	exports.default = ThemeProvider;

/***/ }),
/* 5926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.themeable = themeable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(5928);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(5929);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * @typedef {Object.<string, TReactCSSThemrTheme>} TReactCSSThemrTheme
	 */
	
	/**
	 * @typedef {{}} TReactCSSThemrOptions
	 * @property {String|Boolean} [composeTheme=COMPOSE_DEEPLY]
	 */
	
	var COMPOSE_DEEPLY = 'deeply';
	var COMPOSE_SOFTLY = 'softly';
	var DONT_COMPOSE = false;
	
	var DEFAULT_OPTIONS = {
	  composeTheme: COMPOSE_DEEPLY,
	  mapThemrProps: defaultMapThemrProps
	};
	
	var THEMR_CONFIG = typeof Symbol !== 'undefined' ? Symbol('THEMR_CONFIG') : '__REACT_CSS_THEMR_CONFIG__';
	
	/**
	 * Themr decorator
	 * @param {String|Number|Symbol} componentName - Component name
	 * @param {TReactCSSThemrTheme} [localTheme] - Base theme
	 * @param {{}} [options] - Themr options
	 * @returns {function(ThemedComponent:Function):Function} - ThemedComponent
	 */
	
	exports.default = function (componentName, localTheme) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  return function (ThemedComponent) {
	    var _class, _temp;
	
	    var _DEFAULT_OPTIONS$opti = _extends({}, DEFAULT_OPTIONS, options),
	        optionComposeTheme = _DEFAULT_OPTIONS$opti.composeTheme,
	        optionMapThemrProps = _DEFAULT_OPTIONS$opti.mapThemrProps;
	
	    validateComposeOption(optionComposeTheme);
	
	    var config = ThemedComponent[THEMR_CONFIG];
	    if (config && config.componentName === componentName) {
	      config.localTheme = themeable(config.localTheme, localTheme);
	      return ThemedComponent;
	    }
	
	    config = {
	      componentName: componentName,
	      localTheme: localTheme
	    };
	
	    /**
	     * @property {{wrappedInstance: *}} refs
	     */
	    var Themed = (_temp = _class = function (_Component) {
	      _inherits(Themed, _Component);
	
	      function Themed() {
	        _classCallCheck(this, Themed);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var _this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args)));
	
	        _this.theme_ = _this.calcTheme(_this.props);
	        return _this;
	      }
	
	      Themed.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(true, 'DEPRECATED: To access the wrapped instance, you have to pass ' + '{ innerRef: fn } and retrieve with a callback ref style.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Themed.prototype.getNamespacedTheme = function getNamespacedTheme(props) {
	        var themeNamespace = props.themeNamespace,
	            theme = props.theme;
	
	        if (!themeNamespace) return theme;
	        if (themeNamespace && !theme) throw new Error('Invalid themeNamespace use in react-css-themr. ' + 'themeNamespace prop should be used only with theme prop.');
	
	        return Object.keys(theme).filter(function (key) {
	          return key.startsWith(themeNamespace);
	        }).reduce(function (result, key) {
	          var _extends2;
	
	          return _extends({}, result, (_extends2 = {}, _extends2[removeNamespace(key, themeNamespace)] = theme[key], _extends2));
	        }, {});
	      };
	
	      Themed.prototype.getThemeNotComposed = function getThemeNotComposed(props) {
	        if (props.theme) return this.getNamespacedTheme(props);
	        if (config.localTheme) return config.localTheme;
	        return this.getContextTheme();
	      };
	
	      Themed.prototype.getContextTheme = function getContextTheme() {
	        return this.context.themr ? this.context.themr.theme[config.componentName] : {};
	      };
	
	      Themed.prototype.getTheme = function getTheme(props) {
	        return props.composeTheme === COMPOSE_SOFTLY ? _extends({}, this.getContextTheme(), config.localTheme, this.getNamespacedTheme(props)) : themeable(themeable(this.getContextTheme(), config.localTheme), this.getNamespacedTheme(props));
	      };
	
	      Themed.prototype.calcTheme = function calcTheme(props) {
	        var composeTheme = props.composeTheme;
	
	        return composeTheme ? this.getTheme(props) : this.getThemeNotComposed(props);
	      };
	
	      Themed.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (nextProps.composeTheme !== this.props.composeTheme || nextProps.theme !== this.props.theme || nextProps.themeNamespace !== this.props.themeNamespace) {
	          this.theme_ = this.calcTheme(nextProps);
	        }
	      };
	
	      Themed.prototype.render = function render() {
	        return _react2.default.createElement(ThemedComponent, this.props.mapThemrProps(this.props, this.theme_));
	      };
	
	      return Themed;
	    }(_react.Component), _class.displayName = 'Themed' + ThemedComponent.name, _class.contextTypes = {
	      themr: _propTypes2.default.object
	    }, _class.propTypes = _extends({}, ThemedComponent.propTypes, {
	      composeTheme: _propTypes2.default.oneOf([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE]),
	      innerRef: _propTypes2.default.func,
	      theme: _propTypes2.default.object,
	      themeNamespace: _propTypes2.default.string,
	      mapThemrProps: _propTypes2.default.func
	    }), _class.defaultProps = _extends({}, ThemedComponent.defaultProps, {
	      composeTheme: optionComposeTheme,
	      mapThemrProps: optionMapThemrProps
	    }), _temp);
	
	
	    Themed[THEMR_CONFIG] = config;
	
	    return (0, _hoistNonReactStatics2.default)(Themed, ThemedComponent);
	  };
	};
	
	/**
	 * Merges passed themes by concatenating string keys and processing nested themes
	 *
	 * @param {...TReactCSSThemrTheme} themes - Themes
	 * @returns {TReactCSSThemrTheme} - Resulting theme
	 */
	
	
	function themeable() {
	  for (var _len2 = arguments.length, themes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    themes[_key2] = arguments[_key2];
	  }
	
	  return themes.reduce(function (acc, theme) {
	    return merge(acc, theme);
	  }, {});
	}
	
	/**
	 * @param {TReactCSSThemrTheme} [original] - Original theme
	 * @param {TReactCSSThemrTheme} [mixin] - Mixin theme
	 * @returns {TReactCSSThemrTheme} - resulting theme
	 */
	function merge() {
	  var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var mixin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  //make a copy to avoid mutations of nested objects
	  //also strip all functions injected by isomorphic-style-loader
	  var result = Object.keys(original).reduce(function (acc, key) {
	    var value = original[key];
	    if (typeof value !== 'function') {
	      acc[key] = value;
	    }
	    return acc;
	  }, {});
	
	  //traverse mixin keys and merge them to resulting theme
	  Object.keys(mixin).forEach(function (key) {
	    //there's no need to set any defaults here
	    var originalValue = result[key];
	    var mixinValue = mixin[key];
	
	    switch (typeof mixinValue === 'undefined' ? 'undefined' : _typeof(mixinValue)) {
	      case 'object':
	        {
	          //possibly nested theme object
	          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
	            case 'object':
	              {
	                //exactly nested theme object - go recursive
	                result[key] = merge(originalValue, mixinValue);
	                break;
	              }
	
	            case 'undefined':
	              {
	                //original does not contain this nested key - just take it as is
	                result[key] = mixinValue;
	                break;
	              }
	
	            default:
	              {
	                //can't merge an object with a non-object
	                throw new Error('You are merging object ' + key + ' with a non-object ' + originalValue);
	              }
	          }
	          break;
	        }
	
	      case 'undefined': //fallthrough - handles accidentally unset values which may come from props
	      case 'function':
	        {
	          //this handles issue when isomorphic-style-loader addes helper functions to css-module
	          break; //just skip
	        }
	
	      default:
	        {
	          //plain values
	          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof(originalValue)) {
	            case 'object':
	              {
	                //can't merge a non-object with an object
	                throw new Error('You are merging non-object ' + mixinValue + ' with an object ' + key);
	              }
	
	            case 'undefined':
	              {
	                //mixin key is new to original theme - take it as is
	                result[key] = mixinValue;
	                break;
	              }
	            case 'function':
	              {
	                //this handles issue when isomorphic-style-loader addes helper functions to css-module
	                break; //just skip
	              }
	
	            default:
	              {
	                //finally we can merge
	                result[key] = originalValue.split(' ').concat(mixinValue.split(' ')).filter(function (item, pos, self) {
	                  return self.indexOf(item) === pos && item !== '';
	                }).join(' ');
	                break;
	              }
	          }
	          break;
	        }
	    }
	  });
	
	  return result;
	}
	
	/**
	 * Validates compose option
	 *
	 * @param {String|Boolean} composeTheme - Compose them option
	 * @throws
	 * @returns {undefined}
	 */
	function validateComposeOption(composeTheme) {
	  if ([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE].indexOf(composeTheme) === -1) {
	    throw new Error('Invalid composeTheme option for react-css-themr. Valid composition options are ' + COMPOSE_DEEPLY + ', ' + COMPOSE_SOFTLY + ' and ' + DONT_COMPOSE + '. The given option was ' + composeTheme);
	  }
	}
	
	/**
	 * Removes namespace from key
	 *
	 * @param {String} key - Key
	 * @param {String} themeNamespace - Theme namespace
	 * @returns {String} - Key
	 */
	function removeNamespace(key, themeNamespace) {
	  var capitalized = key.substr(themeNamespace.length);
	  return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
	}
	
	/**
	 * Maps props and theme to an object that will be used to pass down props to the
	 * decorated component.
	 *
	 * @param {Object} ownProps - All props given to the decorated component
	 * @param {Object} theme - Calculated then that should be passed down
	 * @returns {Object} - Props that will be passed down to the decorated component
	 */
	function defaultMapThemrProps(ownProps, theme) {
	  var composeTheme = ownProps.composeTheme,
	      innerRef = ownProps.innerRef,
	      themeNamespace = ownProps.themeNamespace,
	      mapThemrProps = ownProps.mapThemrProps,
	      rest = _objectWithoutProperties(ownProps, ['composeTheme', 'innerRef', 'themeNamespace', 'mapThemrProps']);
	
	  return _extends({}, rest, {
	    ref: innerRef,
	    theme: theme
	  });
	}

/***/ }),
/* 5927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	  theme: _propTypes2.default.object.isRequired
	});

/***/ }),
/* 5928 */
5801,
/* 5929 */
281,
/* 5930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(382));
	
	var _classnames = _interopRequireDefault(__webpack_require__(475));
	
	var _dateFns = __webpack_require__(275);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DateInput =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DateInput, _PureComponent);
	
	  function DateInput(props, context) {
	    var _this;
	
	    _classCallCheck(this, DateInput);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateInput).call(this, props, context));
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
	      var value = _this.state.value;
	
	      if (e.key === 'Enter') {
	        _this.update(value);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
	      _this.setState({
	        value: e.target.value,
	        changed: true,
	        invalid: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
	      var value = _this.state.value;
	
	      _this.update(value);
	    });
	
	    _this.state = {
	      invalid: false,
	      changed: false,
	      value: _this.formatDate(props)
	    };
	    return _this;
	  }
	
	  _createClass(DateInput, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var value = prevProps.value;
	
	      if (!(0, _dateFns.isEqual)(value, this.props.value)) {
	        this.setState({
	          value: this.formatDate(this.props)
	        });
	      }
	    }
	  }, {
	    key: "formatDate",
	    value: function formatDate(_ref) {
	      var value = _ref.value,
	          dateDisplayFormat = _ref.dateDisplayFormat,
	          dateOptions = _ref.dateOptions;
	
	      if (value && (0, _dateFns.isValid)(value)) {
	        return (0, _dateFns.format)(value, dateDisplayFormat, dateOptions);
	      }
	
	      return '';
	    }
	  }, {
	    key: "update",
	    value: function update(value) {
	      var _this$state = this.state,
	          invalid = _this$state.invalid,
	          changed = _this$state.changed;
	
	      if (invalid || !changed || !value) {
	        return;
	      }
	
	      var _this$props = this.props,
	          onChange = _this$props.onChange,
	          dateDisplayFormat = _this$props.dateDisplayFormat,
	          dateOptions = _this$props.dateOptions;
	      var parsed = (0, _dateFns.parse)(value, dateDisplayFormat, new Date(), dateOptions);
	
	      if ((0, _dateFns.isValid)(parsed)) {
	        this.setState({
	          changed: false
	        }, function () {
	          return onChange(parsed);
	        });
	      } else {
	        this.setState({
	          invalid: true
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          readOnly = _this$props2.readOnly,
	          placeholder = _this$props2.placeholder,
	          disabled = _this$props2.disabled,
	          onFocus = _this$props2.onFocus;
	      var _this$state2 = this.state,
	          value = _this$state2.value,
	          invalid = _this$state2.invalid;
	      return _react["default"].createElement("span", {
	        className: (0, _classnames["default"])('rdrDateInput', className)
	      }, _react["default"].createElement("input", {
	        readOnly: readOnly,
	        disabled: disabled,
	        value: value,
	        placeholder: placeholder,
	        onKeyDown: this.onKeyDown,
	        onChange: this.onChange,
	        onBlur: this.onBlur,
	        onFocus: onFocus
	      }), invalid && _react["default"].createElement("span", {
	        className: "rdrWarning"
	      }, "\u26A0"));
	    }
	  }]);
	
	  return DateInput;
	}(_react.PureComponent);
	
	DateInput.propTypes = {
	  value: _propTypes["default"].object,
	  placeholder: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  readOnly: _propTypes["default"].bool,
	  dateOptions: _propTypes["default"].object,
	  dateDisplayFormat: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  onFocus: _propTypes["default"].func.isRequired,
	  onChange: _propTypes["default"].func.isRequired
	};
	DateInput.defaultProps = {
	  readOnly: true,
	  disabled: false,
	  dateDisplayFormat: 'MMM D, YYYY'
	};
	var _default = DateInput;
	exports["default"] = _default;

/***/ }),
/* 5931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(382));
	
	var _DateRange = _interopRequireDefault(__webpack_require__(2707));
	
	var _DefinedRange = _interopRequireDefault(__webpack_require__(2708));
	
	var _utils = __webpack_require__(1014);
	
	var _classnames = _interopRequireDefault(__webpack_require__(475));
	
	var _styles = _interopRequireDefault(__webpack_require__(1013));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var DateRangePicker =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(DateRangePicker, _Component);
	
	  function DateRangePicker(props) {
	    var _this;
	
	    _classCallCheck(this, DateRangePicker);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePicker).call(this, props));
	    _this.state = {
	      focusedRange: [(0, _utils.findNextRangeIndex)(props.ranges), 0]
	    };
	    _this.styles = (0, _utils.generateStyles)([_styles["default"], props.classNames]);
	    return _this;
	  }
	
	  _createClass(DateRangePicker, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var focusedRange = this.state.focusedRange;
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])(this.styles.dateRangePickerWrapper, this.props.className)
	      }, _react["default"].createElement(_DefinedRange["default"], _extends({
	        focusedRange: focusedRange,
	        onPreviewChange: function onPreviewChange(value) {
	          return _this2.dateRange.updatePreview(value ? _this2.dateRange.calcNewSelection(value, typeof value === 'string') : null);
	        }
	      }, this.props, {
	        range: this.props.ranges[focusedRange[0]],
	        className: undefined
	      })), _react["default"].createElement(_DateRange["default"], _extends({
	        onRangeFocusChange: function onRangeFocusChange(focusedRange) {
	          return _this2.setState({
	            focusedRange: focusedRange
	          });
	        },
	        focusedRange: focusedRange
	      }, this.props, {
	        ref: function ref(t) {
	          return _this2.dateRange = t;
	        },
	        className: undefined
	      })));
	    }
	  }]);
	
	  return DateRangePicker;
	}(_react.Component);
	
	DateRangePicker.defaultProps = {};
	DateRangePicker.propTypes = _objectSpread({}, _DateRange["default"].propTypes, {}, _DefinedRange["default"].propTypes, {
	  className: _propTypes["default"].string
	});
	var _default = DateRangePicker;
	exports["default"] = _default;

/***/ }),
/* 5932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(382));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MIN = 0;
	var MAX = 99999;
	
	var InputRangeField =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(InputRangeField, _Component);
	
	  function InputRangeField(props, context) {
	    var _this;
	
	    _classCallCheck(this, InputRangeField);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputRangeField).call(this, props, context));
	
	    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
	      var onChange = _this.props.onChange;
	      var value = parseInt(e.target.value, 10);
	      value = isNaN(value) ? 0 : Math.max(Math.min(MAX, value), MIN);
	      onChange(value);
	    });
	
	    return _this;
	  }
	
	  _createClass(InputRangeField, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      var _this$props = this.props,
	          value = _this$props.value,
	          label = _this$props.label,
	          placeholder = _this$props.placeholder;
	      return value !== nextProps.value || label !== nextProps.label || placeholder !== nextProps.placeholder;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          label = _this$props2.label,
	          placeholder = _this$props2.placeholder,
	          value = _this$props2.value,
	          styles = _this$props2.styles,
	          onBlur = _this$props2.onBlur,
	          onFocus = _this$props2.onFocus;
	      return _react["default"].createElement("div", {
	        className: styles.inputRange
	      }, _react["default"].createElement("input", {
	        className: styles.inputRangeInput,
	        placeholder: placeholder,
	        value: value,
	        min: MIN,
	        max: MAX,
	        onChange: this.onChange,
	        onFocus: onFocus,
	        onBlur: onBlur
	      }), _react["default"].createElement("span", {
	        className: styles.inputRangeLabel
	      }, label));
	    }
	  }]);
	
	  return InputRangeField;
	}(_react.Component);
	
	InputRangeField.propTypes = {
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  label: _propTypes["default"].string.isRequired,
	  placeholder: _propTypes["default"].string,
	  styles: _propTypes["default"].shape({
	    inputRange: _propTypes["default"].string,
	    inputRangeInput: _propTypes["default"].string,
	    inputRangeLabel: _propTypes["default"].string
	  }).isRequired,
	  onBlur: _propTypes["default"].func.isRequired,
	  onFocus: _propTypes["default"].func.isRequired,
	  onChange: _propTypes["default"].func.isRequired
	};
	InputRangeField.defaultProps = {
	  value: '',
	  placeholder: '-'
	};
	var _default = InputRangeField;
	exports["default"] = _default;

/***/ }),
/* 5933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(382));
	
	var _DayCell = _interopRequireWildcard(__webpack_require__(1012));
	
	var _dateFns = __webpack_require__(275);
	
	var _utils = __webpack_require__(1014);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function renderWeekdays(styles, dateOptions, weekdayDisplayFormat) {
	  var now = new Date();
	  return _react["default"].createElement("div", {
	    className: styles.weekDays
	  }, (0, _dateFns.eachDayOfInterval)({
	    start: (0, _dateFns.startOfWeek)(now, dateOptions),
	    end: (0, _dateFns.endOfWeek)(now, dateOptions)
	  }).map(function (day, i) {
	    return _react["default"].createElement("span", {
	      className: styles.weekDay,
	      key: i
	    }, (0, _dateFns.format)(day, weekdayDisplayFormat, dateOptions));
	  }));
	}
	
	var Month =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Month, _PureComponent);
	
	  function Month() {
	    _classCallCheck(this, Month);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Month).apply(this, arguments));
	  }
	
	  _createClass(Month, [{
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var now = new Date();
	      var _this$props = this.props,
	          displayMode = _this$props.displayMode,
	          focusedRange = _this$props.focusedRange,
	          drag = _this$props.drag,
	          styles = _this$props.styles,
	          disabledDates = _this$props.disabledDates,
	          disabledDay = _this$props.disabledDay;
	      var minDate = this.props.minDate && (0, _dateFns.startOfDay)(this.props.minDate);
	      var maxDate = this.props.maxDate && (0, _dateFns.endOfDay)(this.props.maxDate);
	      var monthDisplay = (0, _utils.getMonthDisplayRange)(this.props.month, this.props.dateOptions, this.props.fixedHeight);
	      var ranges = this.props.ranges;
	
	      if (displayMode === 'dateRange' && drag.status) {
	        var _drag$range = drag.range,
	            startDate = _drag$range.startDate,
	            endDate = _drag$range.endDate;
	        ranges = ranges.map(function (range, i) {
	          if (i !== focusedRange[0]) return range;
	          return _objectSpread({}, range, {
	            startDate: startDate,
	            endDate: endDate
	          });
	        });
	      }
	
	      var showPreview = this.props.showPreview && !drag.disablePreview;
	      return _react["default"].createElement("div", {
	        className: styles.month,
	        style: this.props.style
	      }, this.props.showMonthName ? _react["default"].createElement("div", {
	        className: styles.monthName
	      }, (0, _dateFns.format)(this.props.month, this.props.monthDisplayFormat, this.props.dateOptions)) : null, this.props.showWeekDays && renderWeekdays(styles, this.props.dateOptions, this.props.weekdayDisplayFormat), _react["default"].createElement("div", {
	        className: styles.days,
	        onMouseLeave: this.props.onMouseLeave
	      }, (0, _dateFns.eachDayOfInterval)({
	        start: monthDisplay.start,
	        end: monthDisplay.end
	      }).map(function (day, index) {
	        var isStartOfMonth = (0, _dateFns.isSameDay)(day, monthDisplay.startDateOfMonth);
	        var isEndOfMonth = (0, _dateFns.isSameDay)(day, monthDisplay.endDateOfMonth);
	        var isOutsideMinMax = minDate && (0, _dateFns.isBefore)(day, minDate) || maxDate && (0, _dateFns.isAfter)(day, maxDate);
	        var isDisabledSpecifically = disabledDates.some(function (disabledDate) {
	          return (0, _dateFns.isSameDay)(disabledDate, day);
	        });
	        var isDisabledDay = disabledDay(day);
	        return _react["default"].createElement(_DayCell["default"], _extends({}, _this.props, {
	          ranges: ranges,
	          day: day,
	          preview: showPreview ? _this.props.preview : null,
	          isWeekend: (0, _dateFns.isWeekend)(day, _this.props.dateOptions),
	          isToday: (0, _dateFns.isSameDay)(day, now),
	          isStartOfWeek: (0, _dateFns.isSameDay)(day, (0, _dateFns.startOfWeek)(day, _this.props.dateOptions)),
	          isEndOfWeek: (0, _dateFns.isSameDay)(day, (0, _dateFns.endOfWeek)(day, _this.props.dateOptions)),
	          isStartOfMonth: isStartOfMonth,
	          isEndOfMonth: isEndOfMonth,
	          key: index,
	          disabled: isOutsideMinMax || isDisabledSpecifically || isDisabledDay,
	          isPassive: !(0, _dateFns.isWithinInterval)(day, {
	            start: monthDisplay.startDateOfMonth,
	            end: monthDisplay.endDateOfMonth
	          }),
	          styles: styles,
	          onMouseDown: _this.props.onDragSelectionStart,
	          onMouseUp: _this.props.onDragSelectionEnd,
	          onMouseEnter: _this.props.onDragSelectionMove,
	          dragRange: drag.range,
	          drag: drag.status
	        }));
	      })));
	    }
	  }]);
	
	  return Month;
	}(_react.PureComponent);
	
	Month.defaultProps = {};
	Month.propTypes = {
	  style: _propTypes["default"].object,
	  styles: _propTypes["default"].object,
	  month: _propTypes["default"].object,
	  drag: _propTypes["default"].object,
	  dateOptions: _propTypes["default"].object,
	  disabledDates: _propTypes["default"].array,
	  disabledDay: _propTypes["default"].func,
	  preview: _propTypes["default"].shape({
	    startDate: _propTypes["default"].object,
	    endDate: _propTypes["default"].object
	  }),
	  showPreview: _propTypes["default"].bool,
	  displayMode: _propTypes["default"].oneOf(['dateRange', 'date']),
	  minDate: _propTypes["default"].object,
	  maxDate: _propTypes["default"].object,
	  ranges: _propTypes["default"].arrayOf(_DayCell.rangeShape),
	  focusedRange: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  onDragSelectionStart: _propTypes["default"].func,
	  onDragSelectionEnd: _propTypes["default"].func,
	  onDragSelectionMove: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  monthDisplayFormat: _propTypes["default"].string,
	  weekdayDisplayFormat: _propTypes["default"].string,
	  dayDisplayFormat: _propTypes["default"].string,
	  showWeekDays: _propTypes["default"].bool,
	  showMonthName: _propTypes["default"].bool,
	  fixedHeight: _propTypes["default"].bool
	};
	var _default = Month;
	exports["default"] = _default;

/***/ }),
/* 5934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DateRange", {
	  enumerable: true,
	  get: function get() {
	    return _DateRange["default"];
	  }
	});
	Object.defineProperty(exports, "Calendar", {
	  enumerable: true,
	  get: function get() {
	    return _Calendar["default"];
	  }
	});
	Object.defineProperty(exports, "DateRangePicker", {
	  enumerable: true,
	  get: function get() {
	    return _DateRangePicker["default"];
	  }
	});
	Object.defineProperty(exports, "DefinedRange", {
	  enumerable: true,
	  get: function get() {
	    return _DefinedRange["default"];
	  }
	});
	Object.defineProperty(exports, "defaultInputRanges", {
	  enumerable: true,
	  get: function get() {
	    return _defaultRanges.defaultInputRanges;
	  }
	});
	Object.defineProperty(exports, "defaultStaticRanges", {
	  enumerable: true,
	  get: function get() {
	    return _defaultRanges.defaultStaticRanges;
	  }
	});
	Object.defineProperty(exports, "createStaticRanges", {
	  enumerable: true,
	  get: function get() {
	    return _defaultRanges.createStaticRanges;
	  }
	});
	
	var _DateRange = _interopRequireDefault(__webpack_require__(2707));
	
	var _Calendar = _interopRequireDefault(__webpack_require__(2706));
	
	var _DateRangePicker = _interopRequireDefault(__webpack_require__(5931));
	
	var _DefinedRange = _interopRequireDefault(__webpack_require__(2708));
	
	var _defaultRanges = __webpack_require__(2709);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 5935 */
[6835, 5936],
/* 5936 */
6261,
/* 5937 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports,__webpack_require__(1),__webpack_require__(2728),__webpack_require__(5939),__webpack_require__(5971),__webpack_require__(2722),__webpack_require__(5959),__webpack_require__(2718),__webpack_require__(2717),__webpack_require__(1597),__webpack_require__(2719),__webpack_require__(1599),__webpack_require__(2720),__webpack_require__(6001),__webpack_require__(6000),__webpack_require__(5999),__webpack_require__(6003),__webpack_require__(6002),__webpack_require__(6004),__webpack_require__(5966),__webpack_require__(5963),__webpack_require__(5962),__webpack_require__(5961),__webpack_require__(5960),__webpack_require__(5964),__webpack_require__(5965),__webpack_require__(5968),__webpack_require__(5967),__webpack_require__(5995),__webpack_require__(5993),__webpack_require__(5992),__webpack_require__(2724),__webpack_require__(5994),__webpack_require__(5996),__webpack_require__(5988),__webpack_require__(5987),__webpack_require__(5952),__webpack_require__(5953),__webpack_require__(5954),__webpack_require__(5955),__webpack_require__(1600),__webpack_require__(2726),__webpack_require__(5997),__webpack_require__(2725),__webpack_require__(5998),__webpack_require__(5956),__webpack_require__(5958),__webpack_require__(5957),__webpack_require__(5972),__webpack_require__(5973),__webpack_require__(5974),__webpack_require__(5976),__webpack_require__(5975),__webpack_require__(5969),__webpack_require__(5970),__webpack_require__(5977),__webpack_require__(62),__webpack_require__(5990),__webpack_require__(5991),__webpack_require__(6238),__webpack_require__(6011)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addYears","date-fns/subMinutes","date-fns/subHours","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarWeeks","date-fns/differenceInCalendarYears","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-popper"],t):t((e=e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.utils,e.utils$1,e.addMonths,e.addYears,e.subMinutes,e.subHours,e.subDays,e.subWeeks,e.subMonths,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.utils$2,e.utils$3,e.setYear,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,e.differenceInCalendarWeeks,e.differenceInCalendarYears,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,e.endOfWeek,e.endOfMonth,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactPopper)}(this,(function(e,t,r,n,a,o,s,i,p,c,l,d,u,h,f,m,y,D,v,w,g,k,b,C,_,S,M,O,P,E,N,x,T,Y,I,L,q,F,W,A,B,R,j,H,K,Q,V,U,$,z,G,J,X,Z,ee,te,re,ne,ae,oe,se){"use strict";function ie(e){return(ie="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function pe(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function ce(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function le(e,t,r){return t&&ce(e.prototype,t),r&&ce(e,r),e}function de(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function ue(){return(ue=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function he(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function fe(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&ye(e,t)}function me(e){return(me=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function ye(e,t){return(ye=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function De(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ve(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?De(e):t}function we(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function ge(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}t=t&&t.hasOwnProperty("default")?t.default:t,r=r&&r.hasOwnProperty("default")?r.default:r,n=n&&n.hasOwnProperty("default")?n.default:n,a=a&&a.hasOwnProperty("default")?a.default:a,o=o&&o.hasOwnProperty("default")?o.default:o,s=s&&s.hasOwnProperty("default")?s.default:s,i=i&&i.hasOwnProperty("default")?i.default:i,p=p&&p.hasOwnProperty("default")?p.default:p,c=c&&c.hasOwnProperty("default")?c.default:c,l=l&&l.hasOwnProperty("default")?l.default:l,d=d&&d.hasOwnProperty("default")?d.default:d,u=u&&u.hasOwnProperty("default")?u.default:u,h=h&&h.hasOwnProperty("default")?h.default:h,f=f&&f.hasOwnProperty("default")?f.default:f,m=m&&m.hasOwnProperty("default")?m.default:m,y=y&&y.hasOwnProperty("default")?y.default:y,D=D&&D.hasOwnProperty("default")?D.default:D,v=v&&v.hasOwnProperty("default")?v.default:v,w=w&&w.hasOwnProperty("default")?w.default:w,g=g&&g.hasOwnProperty("default")?g.default:g,k=k&&k.hasOwnProperty("default")?k.default:k,b=b&&b.hasOwnProperty("default")?b.default:b,C=C&&C.hasOwnProperty("default")?C.default:C,_=_&&_.hasOwnProperty("default")?_.default:_,S=S&&S.hasOwnProperty("default")?S.default:S,M=M&&M.hasOwnProperty("default")?M.default:M,O=O&&O.hasOwnProperty("default")?O.default:O,P=P&&P.hasOwnProperty("default")?P.default:P,E=E&&E.hasOwnProperty("default")?E.default:E,N=N&&N.hasOwnProperty("default")?N.default:N,x=x&&x.hasOwnProperty("default")?x.default:x,T=T&&T.hasOwnProperty("default")?T.default:T,Y=Y&&Y.hasOwnProperty("default")?Y.default:Y,I=I&&I.hasOwnProperty("default")?I.default:I,L=L&&L.hasOwnProperty("default")?L.default:L,q=q&&q.hasOwnProperty("default")?q.default:q,F=F&&F.hasOwnProperty("default")?F.default:F,W=W&&W.hasOwnProperty("default")?W.default:W,A=A&&A.hasOwnProperty("default")?A.default:A,B=B&&B.hasOwnProperty("default")?B.default:B,R=R&&R.hasOwnProperty("default")?R.default:R,j=j&&j.hasOwnProperty("default")?j.default:j,H=H&&H.hasOwnProperty("default")?H.default:H,K=K&&K.hasOwnProperty("default")?K.default:K,Q=Q&&Q.hasOwnProperty("default")?Q.default:Q,V=V&&V.hasOwnProperty("default")?V.default:V,U=U&&U.hasOwnProperty("default")?U.default:U,$=$&&$.hasOwnProperty("default")?$.default:$,z=z&&z.hasOwnProperty("default")?z.default:z,G=G&&G.hasOwnProperty("default")?G.default:G,J=J&&J.hasOwnProperty("default")?J.default:J,X=X&&X.hasOwnProperty("default")?X.default:X,Z=Z&&Z.hasOwnProperty("default")?Z.default:Z,ee=ee&&ee.hasOwnProperty("default")?ee.default:ee,te=te&&te.hasOwnProperty("default")?te.default:te,re=re&&re.hasOwnProperty("default")?re.default:re,ne=ne&&ne.hasOwnProperty("default")?ne.default:ne,ae=ae&&ae.hasOwnProperty("default")?ae.default:ae,oe=oe&&oe.hasOwnProperty("default")?oe.default:oe;var ke={p:ge,P:function(e,t){var r,n=e.match(/(P+)(p+)?/),a=n[1],o=n[2];if(!o)return we(e,t);switch(a){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",we(a,t)).replace("{{time}}",ge(o,t))}},be=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Ce(e){var t=e?"string"==typeof e||e instanceof String?ae(e):re(e):new Date;return Se(t)?t:null}function _e(e,t,r,n){var a=null,o=Fe(r)||qe(),i=!0;return Array.isArray(t)?(t.forEach((function(t){var r=ne(e,t,new Date,{locale:o});n&&(i=Se(r)&&e===s(r,t,{awareOfUnicodeTokens:!0})),Se(r)&&i&&(a=r)})),a):(a=ne(e,t,new Date,{locale:o}),n?i=Se(a)&&e===s(a,t,{awareOfUnicodeTokens:!0}):Se(a)||(t=t.match(be).map((function(e){var t=e[0];if("p"===t||"P"===t){var r=ke[t];return o?r(e,o.formatLong):t}return e})).join(""),e.length>0&&(a=ne(e,t.slice(0,e.length),new Date)),Se(a)||(a=new Date(e))),Se(a)&&i?a:null)}function Se(e){return o(e)&&Z(e,new Date("1/1/1000"))}function Me(e,t,r){if("en"===r)return s(e,t,{awareOfUnicodeTokens:!0});var n=Fe(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&qe()&&Fe(qe())&&(n=Fe(qe())),s(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Oe(e,t){var r=t.hour,n=void 0===r?0:r,a=t.minute,o=void 0===a?0:a,s=t.second;return N(E(P(e,void 0===s?0:s),o),n)}function Pe(e,t){var r=Fe(t||qe());return R(e,{locale:r})}function Ee(e){return j(e)}function Ne(e,t){return e&&t?J(e,t):!e&&!t}function xe(e,t){return e&&t?G(e,t):!e&&!t}function Te(e,t){return e&&t?X(e,t):!e&&!t}function Ye(e,t){return e&&t?z(e,t):!e&&!t}function Ie(e,t){return e&&t?$(e,t):!e&&!t}function Le(e,t,r){var n,a=B(t),o=Q(r);try{n=te(e,{start:a,end:o})}catch(e){n=!1}return n}function qe(){return("undefined"!=typeof window?window:global).__localeId__}function Fe(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function We(e,t){return Me(x(Ce(),e),"LLL",t)}function Ae(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Ke(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return Ye(e,t)}))||o&&!o.some((function(t){return Ye(e,t)}))||s&&!s(Ce(e))||!1}function Be(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Ke(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return xe(e,t)}))||o&&!o.some((function(t){return xe(e,t)}))||s&&!s(Ce(e))||!1}function Re(e,t,r,n){var a=M(e),o=_(e),s=M(t),i=_(t),p=M(n);return a===s&&a===p?o<=r&&r<=i:a<s?p===a&&o<=r||p===s&&i>=r||p<s&&p>a:void 0}function je(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Ke(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return Te(e,t)}))||o&&!o.some((function(t){return Te(e,t)}))||s&&!s(Ce(e))||!1}function He(e,t,r,n){var a=M(e),o=S(e),s=M(t),i=S(t),p=M(n);return a===s&&a===p?o<=r&&r<=i:a<s?p===a&&o<=r||p===s&&i>=r||p<s&&p>a:void 0}function Ke(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&q(e,r)<0||n&&q(e,n)>0}function Qe(e,t){for(var r=t.length,n=0;n<r;n++)if(k(t[n])===k(e)&&g(t[n])===g(e))return!0;return!1}function Ve(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var a,o=Ce(),s=N(E(o,g(e)),k(e)),i=N(E(o,g(r)),k(r)),p=N(E(o,g(n)),k(n));try{a=!te(s,{start:i,end:p})}catch(e){a=!1}return a}function Ue(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=D(e,1);return r&&F(r,a)>0||n&&n.every((function(e){return F(e,a)>0}))||!1}function $e(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=d(e,1);return r&&F(a,r)>0||n&&n.every((function(e){return F(a,e)>0}))||!1}function ze(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=v(e,1);return r&&A(r,a)>0||n&&n.every((function(e){return A(e,a)>0}))||!1}function Ge(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=u(e,1);return r&&A(a,r)>0||n&&n.every((function(e){return A(a,e)>0}))||!1}function Je(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return q(e,t)>=0}));return I(n)}return r?I(r):t}function Xe(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return q(e,t)<=0}));return L(n)}return r?L(r):t}function Ze(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,n=0,o=e.length;n<o;n++){var s=e[n];if(a(s)){var i=Me(s,"MM.dd.yyyy"),p=r.get(i)||[];p.includes(t)||(p.push(t),r.set(i,p))}else if("object"===ie(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var f=Me(d[u],"MM.dd.yyyy"),m=r.get(f)||[];m.includes(l)||(m.push(l),r.set(f,m))}}}return r}function et(e,t,r,n,a){for(var o=a.length,s=[],c=0;c<o;c++){var l=i(p(e,k(a[c])),g(a[c])),d=i(e,(r+1)*n);Z(l,t)&&ee(l,d)&&s.push(a[c])}return s}function tt(e){return e<10?"0".concat(e):"".concat(e)}function rt(e,t,r,n){for(var a=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=M(r)<=s),n&&i&&(i=M(n)>=s),i&&a.push(s)}return a}var nt=oe(function(e){function r(e){var n;pe(this,r),de(De(n=ve(this,me(r).call(this,e))),"renderOptions",(function(){var e=n.props.year,r=n.state.yearsList.map((function(r){return t.createElement("div",{className:e===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,ref:r,onClick:n.onChange.bind(De(n),r)},e===r?t.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)})),a=n.props.minDate?M(n.props.minDate):null,o=n.props.maxDate?M(n.props.maxDate):null;return o&&n.state.yearsList.find((function(e){return e===o}))||r.unshift(t.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),a&&n.state.yearsList.find((function(e){return e===a}))||r.push(t.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r})),de(De(n),"onChange",(function(e){n.props.onChange(e)})),de(De(n),"handleClickOutside",(function(){n.props.onCancel()})),de(De(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t})})),de(De(n),"incrementYears",(function(){return n.shiftYears(1)})),de(De(n),"decrementYears",(function(){return n.shiftYears(-1)}));var a=e.yearDropdownItemNumber,o=e.scrollableYearDropdown,s=a||(o?10:5);return n.state={yearsList:rt(n.props.year,s,n.props.minDate,n.props.maxDate)},n}return fe(r,e),le(r,[{key:"render",value:function(){var e=n({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),r}(t.Component)),at=function(e){function r(){var e,n;pe(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(De(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),de(De(n),"renderSelectOptions",(function(){for(var e=n.props.minDate?M(n.props.minDate):1900,r=n.props.maxDate?M(n.props.maxDate):2100,a=[],o=e;o<=r;o++)a.push(t.createElement("option",{key:o,value:o},o));return a})),de(De(n),"onSelectChange",(function(e){n.onChange(e.target.value)})),de(De(n),"renderSelectMode",(function(){return t.createElement("select",{value:n.props.year,className:"react-datepicker__year-select",onChange:n.onSelectChange},n.renderSelectOptions())})),de(De(n),"renderReadView",(function(e){return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return n.toggleDropdown(e)}},t.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},n.props.year))})),de(De(n),"renderDropdown",(function(){return t.createElement(nt,{key:"dropdown",ref:"options",year:n.props.year,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})})),de(De(n),"renderScrollMode",(function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t})),de(De(n),"onChange",(function(e){n.toggleDropdown(),e!==n.props.year&&n.props.onChange(e)})),de(De(n),"toggleDropdown",(function(e){n.setState({dropdownVisible:!n.state.dropdownVisible},(function(){n.props.adjustDateOnChange&&n.handleYearChange(n.props.date,e)}))})),de(De(n),"handleYearChange",(function(e,t){n.onSelect(e,t),n.setOpen()})),de(De(n),"onSelect",(function(e,t){n.props.onSelect&&n.props.onSelect(e,t)})),de(De(n),"setOpen",(function(){n.props.setOpen&&n.props.setOpen(!0)})),n}return fe(r,e),le(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(t.Component),ot=oe(function(e){function r(){var e,n;pe(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(De(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"renderOptions",(function(){return n.props.monthNames.map((function(e,r){return t.createElement("div",{className:n.props.month===r?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:e,ref:e,onClick:n.onChange.bind(De(n),r)},n.props.month===r?t.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)}))})),de(De(n),"onChange",(function(e){return n.props.onChange(e)})),de(De(n),"handleClickOutside",(function(){return n.props.onCancel()})),n}return fe(r,e),le(r,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}(t.Component)),st=function(e){function r(){var e,n;pe(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(De(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),de(De(n),"renderSelectOptions",(function(e){return e.map((function(e,r){return t.createElement("option",{key:r,value:r},e)}))})),de(De(n),"renderSelectMode",(function(e){return t.createElement("select",{value:n.props.month,className:"react-datepicker__month-select",onChange:function(e){return n.onChange(e.target.value)}},n.renderSelectOptions(e))})),de(De(n),"renderReadView",(function(e,r){return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:n.toggleDropdown},t.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[n.props.month]))})),de(De(n),"renderDropdown",(function(e){return t.createElement(ot,{key:"dropdown",ref:"options",month:n.props.month,monthNames:e,onChange:n.onChange,onCancel:n.toggleDropdown})})),de(De(n),"renderScrollMode",(function(e){var t=n.state.dropdownVisible,r=[n.renderReadView(!t,e)];return t&&r.unshift(n.renderDropdown(e)),r})),de(De(n),"onChange",(function(e){n.toggleDropdown(),e!==n.props.month&&n.props.onChange(e)})),de(De(n),"toggleDropdown",(function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})})),n}return fe(r,e),le(r,[{key:"render",value:function(){var e,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return We(e,r.props.locale)}:function(e){return t=e,n=r.props.locale,Me(x(Ce(),t),"LLLL",n);var t,n});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(n);break;case"select":e=this.renderSelectMode(n)}return t.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(t.Component);function it(e,t){for(var r=[],n=Ee(e),a=Ee(t);!Z(n,a);)r.push(Ce(n)),n=d(n,1);return r}var pt=oe(function(e){function r(e){var n;return pe(this,r),de(De(n=ve(this,me(r).call(this,e))),"renderOptions",(function(){return n.state.monthYearsList.map((function(e){var r=O(e),a=Ne(n.props.date,e)&&xe(n.props.date,e);return t.createElement("div",{className:a?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:r,ref:r,onClick:n.onChange.bind(De(n),r)},a?t.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Me(e,n.props.dateFormat))}))})),de(De(n),"onChange",(function(e){return n.props.onChange(e)})),de(De(n),"handleClickOutside",(function(){n.props.onCancel()})),n.state={monthYearsList:it(n.props.minDate,n.props.maxDate)},n}return fe(r,e),le(r,[{key:"render",value:function(){var e=n({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),r}(t.Component)),ct=function(e){function r(){var e,n;pe(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(De(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),de(De(n),"renderSelectOptions",(function(){for(var e=Ee(n.props.minDate),r=Ee(n.props.maxDate),a=[];!Z(e,r);){var o=O(e);a.push(t.createElement("option",{key:o,value:o},Me(e,n.props.dateFormat,n.props.locale))),e=d(e,1)}return a})),de(De(n),"onSelectChange",(function(e){n.onChange(e.target.value)})),de(De(n),"renderSelectMode",(function(){return t.createElement("select",{value:O(Ee(n.props.date)),className:"react-datepicker__month-year-select",onChange:n.onSelectChange},n.renderSelectOptions())})),de(De(n),"renderReadView",(function(e){var r=Me(n.props.date,n.props.dateFormat,n.props.locale);return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(e){return n.toggleDropdown(e)}},t.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),de(De(n),"renderDropdown",(function(){return t.createElement(pt,{key:"dropdown",ref:"options",date:n.props.date,dateFormat:n.props.dateFormat,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})})),de(De(n),"renderScrollMode",(function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t})),de(De(n),"onChange",(function(e){n.toggleDropdown();var t=Ce(parseInt(e));Ne(n.props.date,t)&&xe(n.props.date,t)||n.props.onChange(t)})),de(De(n),"toggleDropdown",(function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})})),n}return fe(r,e),le(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(t.Component),lt=function(e){function r(){var e,a;pe(this,r);for(var o=arguments.length,s=new Array(o),i=0;i<o;i++)s[i]=arguments[i];return de(De(a=ve(this,(e=me(r)).call.apply(e,[this].concat(s)))),"dayEl",t.createRef()),de(De(a),"handleClick",(function(e){!a.isDisabled()&&a.props.onClick&&a.props.onClick(e)})),de(De(a),"handleMouseEnter",(function(e){!a.isDisabled()&&a.props.onMouseEnter&&a.props.onMouseEnter(e)})),de(De(a),"handleOnKeyDown",(function(e){" "===e.key&&(e.preventDefault(),e.key="Enter"),a.props.handleOnKeyDown(e)})),de(De(a),"isSameDay",(function(e){return Ye(a.props.day,e)})),de(De(a),"isKeyboardSelected",(function(){return!a.props.disabledKeyboardNavigation&&!a.props.inline&&!a.isSameDay(a.props.selected)&&a.isSameDay(a.props.preSelection)})),de(De(a),"isDisabled",(function(){return Ae(a.props.day,a.props)})),de(De(a),"isExcluded",(function(){return function(e){var t=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).excludeDates;return t&&t.some((function(t){return Ye(e,t)}))||!1}(a.props.day,a.props)})),de(De(a),"getHighLightedClass",(function(e){var t=a.props,r=t.day,n=t.highlightDates;if(!n)return!1;var o=Me(r,"MM.dd.yyyy");return n.get(o)})),de(De(a),"isInRange",(function(){var e=a.props,t=e.day,r=e.startDate,n=e.endDate;return!(!r||!n)&&Le(t,r,n)})),de(De(a),"isInSelectingRange",(function(){var e=a.props,t=e.day,r=e.selectsStart,n=e.selectsEnd,o=e.selectingDate,s=e.startDate,i=e.endDate;return!(!r&&!n||!o||a.isDisabled())&&(r&&i&&(ee(o,i)||Ie(o,i))?Le(t,o,i):!(!n||!s||!Z(o,s)&&!Ie(o,s))&&Le(t,s,o))})),de(De(a),"isSelectingRangeStart",(function(){if(!a.isInSelectingRange())return!1;var e=a.props,t=e.day,r=e.selectingDate,n=e.startDate;return Ye(t,e.selectsStart?r:n)})),de(De(a),"isSelectingRangeEnd",(function(){if(!a.isInSelectingRange())return!1;var e=a.props,t=e.day,r=e.selectingDate,n=e.endDate;return Ye(t,e.selectsEnd?r:n)})),de(De(a),"isRangeStart",(function(){var e=a.props,t=e.day,r=e.startDate,n=e.endDate;return!(!r||!n)&&Ye(r,t)})),de(De(a),"isRangeEnd",(function(){var e=a.props,t=e.day,r=e.startDate,n=e.endDate;return!(!r||!n)&&Ye(n,t)})),de(De(a),"isWeekend",(function(){var e=b(a.props.day);return 0===e||6===e})),de(De(a),"isOutsideMonth",(function(){return void 0!==a.props.month&&a.props.month!==_(a.props.day)})),de(De(a),"getClassNames",(function(e){var t,r=a.props.dayClassName?a.props.dayClassName(e):void 0;return n("react-datepicker__day",r,"react-datepicker__day--"+Me(a.props.day,"ddd",t),{"react-datepicker__day--disabled":a.isDisabled(),"react-datepicker__day--excluded":a.isExcluded(),"react-datepicker__day--selected":a.isSameDay(a.props.selected),"react-datepicker__day--keyboard-selected":a.isKeyboardSelected(),"react-datepicker__day--range-start":a.isRangeStart(),"react-datepicker__day--range-end":a.isRangeEnd(),"react-datepicker__day--in-range":a.isInRange(),"react-datepicker__day--in-selecting-range":a.isInSelectingRange(),"react-datepicker__day--selecting-range-start":a.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":a.isSelectingRangeEnd(),"react-datepicker__day--today":a.isSameDay(Ce()),"react-datepicker__day--weekend":a.isWeekend(),"react-datepicker__day--outside-month":a.isOutsideMonth()},a.getHighLightedClass("react-datepicker__day--highlighted"))})),de(De(a),"getAriaLabel",(function(){var e=a.props,t=e.day,r=e.ariaLabelPrefixWhenEnabled,n=void 0===r?"Choose":r,o=e.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=a.isDisabled()||a.isExcluded()?s:n;return"".concat(i," ").concat(Me(t,"PPPP"))})),de(De(a),"getTabIndex",(function(e,t){var r=e||a.props.selected,n=t||a.props.preSelection;return a.isKeyboardSelected()||a.isSameDay(r)&&Ye(n,r)?0:-1})),de(De(a),"render",(function(){return t.createElement("div",{ref:a.dayEl,className:a.getClassNames(a.props.day),onKeyDown:a.handleOnKeyDown,onClick:a.handleClick,onMouseEnter:a.handleMouseEnter,tabIndex:a.getTabIndex(),"aria-label":a.getAriaLabel(),role:"option","aria-disabled":a.isDisabled()},a.props.renderDayContents?a.props.renderDayContents(C(a.props.day),a.props.day):C(a.props.day))})),a}return fe(r,e),le(r,[{key:"componentDidMount",value:function(){0===this.getTabIndex()&&this.isSameDay(this.props.preSelection)&&(!document.activeElement||document.activeElement===document.body)&&this.dayEl.current.focus()}},{key:"componentDidUpdate",value:function(e){0===this.getTabIndex()&&this.isSameDay(this.props.preSelection)!==this.isSameDay(e.preSelection)&&!e.isInputFocused&&this.dayEl.current.focus()}}]),r}(t.Component),dt=function(e){function r(){var e,t;pe(this,r);for(var n=arguments.length,a=new Array(n),o=0;o<n;o++)a[o]=arguments[o];return de(De(t=ve(this,(e=me(r)).call.apply(e,[this].concat(a)))),"handleClick",(function(e){t.props.onClick&&t.props.onClick(e)})),t}return fe(r,e),le(r,[{key:"render",value:function(){var e=this.props,r=e.weekNumber,a=e.ariaLabelPrefix,o=void 0===a?"week ":a,s={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return t.createElement("div",{className:n(s),"aria-label":"".concat(o," ").concat(this.props.weekNumber),onClick:this.handleClick},r)}}]),r}(t.Component),ut=function(e){function r(){var e,n;pe(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(De(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"handleDayClick",(function(e,t){n.props.onDayClick&&n.props.onDayClick(e,t)})),de(De(n),"handleDayMouseEnter",(function(e){n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e)})),de(De(n),"handleWeekClick",(function(e,t,r){"function"==typeof n.props.onWeekSelect&&n.props.onWeekSelect(e,t,r),n.props.shouldCloseOnSelect&&n.props.setOpen(!1)})),de(De(n),"formatWeekNumber",(function(e){return n.props.formatWeekNumber?n.props.formatWeekNumber(e):function(e){return Ne(V(e),e)?W(e,K(e))+1:1}(e)})),de(De(n),"renderDays",(function(){var e=Pe(n.props.day,n.props.locale),r=[],a=n.formatWeekNumber(e);if(n.props.showWeekNumber){var o=n.props.onWeekSelect?n.handleWeekClick.bind(De(n),e,a):void 0;r.push(t.createElement(dt,{key:"W",weekNumber:a,onClick:o,ariaLabelPrefix:n.props.ariaLabelPrefix}))}return r.concat([0,1,2,3,4,5,6].map((function(r){var a=c(e,r);return t.createElement(lt,{ariaLabelPrefixWhenEnabled:n.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:n.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:n.props.month,onClick:n.handleDayClick.bind(De(n),a),onMouseEnter:n.handleDayMouseEnter.bind(De(n),a),minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,includeDates:n.props.includeDates,inline:n.props.inline,highlightDates:n.props.highlightDates,selectingDate:n.props.selectingDate,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,dayClassName:n.props.dayClassName,renderDayContents:n.props.renderDayContents,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation,handleOnKeyDown:n.props.handleOnKeyDown,isInputFocused:n.props.isInputFocused})})))})),n}return fe(r,e),le(r,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(t.Component),ht=6,ft=function(e){function r(){var e,a;pe(this,r);for(var o=arguments.length,s=new Array(o),i=0;i<o;i++)s[i]=arguments[i];return de(De(a=ve(this,(e=me(r)).call.apply(e,[this].concat(s)))),"handleDayClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t,a.props.orderInDisplay)})),de(De(a),"handleDayMouseEnter",(function(e){a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)})),de(De(a),"handleMouseLeave",(function(){a.props.onMouseLeave&&a.props.onMouseLeave()})),de(De(a),"isRangeStartMonth",(function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&xe(x(r,e),n)})),de(De(a),"isRangeStartQuarter",(function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Te(T(r,e),n)})),de(De(a),"isRangeEndMonth",(function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&xe(x(r,e),o)})),de(De(a),"isRangeEndQuarter",(function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Te(T(r,e),o)})),de(De(a),"isWeekInMonth",(function(e){var t=a.props.day,r=c(e,6);return xe(e,t)||xe(r,t)})),de(De(a),"renderWeeks",(function(){for(var e=[],r=a.props.fixedHeight,n=Pe(Ee(a.props.day),a.props.locale),o=0,s=!1;e.push(t.createElement(ut,{ariaLabelPrefix:a.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,key:o,day:n,month:_(a.props.day),onDayClick:a.handleDayClick,onDayMouseEnter:a.handleDayMouseEnter,onWeekSelect:a.props.onWeekSelect,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,includeDates:a.props.includeDates,inline:a.props.inline,highlightDates:a.props.highlightDates,selectingDate:a.props.selectingDate,filterDate:a.props.filterDate,preSelection:a.props.preSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,showWeekNumber:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,dayClassName:a.props.dayClassName,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderDayContents:a.props.renderDayContents,handleOnKeyDown:a.props.handleOnKeyDown,isInputFocused:a.props.isInputFocused})),!s;){o++,n=l(n,1);var i=r&&o>=ht,p=!r&&!a.isWeekInMonth(n);if(i||p){if(!a.props.peekNextMonth)break;s=!0}}return e})),de(De(a),"onMonthClick",(function(e,t){a.handleDayClick(Ee(x(a.props.day,t)),e)})),de(De(a),"onQuarterClick",(function(e,t){var r;a.handleDayClick((r=T(a.props.day,t),H(r)),e)})),de(De(a),"getMonthClassNames",(function(e){var t=a.props,r=t.day,o=t.startDate,s=t.endDate,i=t.selected,p=t.minDate,c=t.maxDate;return n("react-datepicker__month-text","react-datepicker__month-".concat(e),{"react-datepicker__month--disabled":(p||c)&&Be(x(r,e),a.props),"react-datepicker__month--selected":_(r)===e&&M(r)===M(i),"react-datepicker__month--in-range":Re(o,s,e,r),"react-datepicker__month--range-start":a.isRangeStartMonth(e),"react-datepicker__month--range-end":a.isRangeEndMonth(e)})})),de(De(a),"getQuarterClassNames",(function(e){var t=a.props,r=t.day,o=t.startDate,s=t.endDate,i=t.selected,p=t.minDate,c=t.maxDate;return n("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter--disabled":(p||c)&&je(T(r,e),a.props),"react-datepicker__quarter--selected":S(r)===e&&M(r)===M(i),"react-datepicker__quarter--in-range":He(o,s,e,r),"react-datepicker__quarter--range-start":a.isRangeStartQuarter(e),"react-datepicker__quarter--range-end":a.isRangeEndQuarter(e)})})),de(De(a),"renderMonths",(function(){return[[0,1,2],[3,4,5],[6,7,8],[9,10,11]].map((function(e,r){return t.createElement("div",{className:"react-datepicker__month-wrapper",key:r},e.map((function(e,r){return t.createElement("div",{key:r,onClick:function(t){a.onMonthClick(t,e)},className:a.getMonthClassNames(e)},We(e,a.props.locale))})))}))})),de(De(a),"renderQuarters",(function(){return t.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(e,r){return t.createElement("div",{key:r,onClick:function(t){a.onQuarterClick(t,e)},className:a.getQuarterClassNames(e)},(n=e,o=a.props.locale,Me(T(Ce(),n),"QQQ",o)));var n,o})))})),de(De(a),"getClassNames",(function(){var e=a.props,t=e.selectingDate,r=e.selectsStart,o=e.selectsEnd,s=e.showMonthYearPicker,i=e.showQuarterYearPicker;return n("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(r||o)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":i})})),a}return fe(r,e),le(r,[{key:"render",value:function(){var e=this.props,r=e.showMonthYearPicker,n=e.showQuarterYearPicker,a=e.day,o=e.ariaLabelPrefix,s=void 0===o?"month ":o;return t.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox","aria-label":"".concat(s," ").concat(Me(a,"yyyy-MM"))},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),r}(t.Component),mt=function(e){function r(){var e,n;pe(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(De(n=ve(this,(e=me(r)).call.apply(e,[this].concat(o)))),"state",{height:null}),de(De(n),"handleClick",(function(e){(n.props.minTime||n.props.maxTime)&&Ve(e,n.props)||n.props.excludeTimes&&Qe(e,n.props.excludeTimes)||n.props.includeTimes&&!Qe(e,n.props.includeTimes)||n.props.onChange(e)})),de(De(n),"liClasses",(function(e,t,r){var a=["react-datepicker__time-list-item",n.props.timeClassName?n.props.timeClassName(e,t,r):void 0];return n.props.selected&&t===k(e)&&r===g(e)&&a.push("react-datepicker__time-list-item--selected"),((n.props.minTime||n.props.maxTime)&&Ve(e,n.props)||n.props.excludeTimes&&Qe(e,n.props.excludeTimes)||n.props.includeTimes&&!Qe(e,n.props.includeTimes))&&a.push("react-datepicker__time-list-item--disabled"),n.props.injectTimes&&(60*k(e)+g(e))%n.props.intervals!=0&&a.push("react-datepicker__time-list-item--injected"),a.join(" ")})),de(De(n),"renderTimes",(function(){for(var e,r=[],a=n.props.format?n.props.format:"p",o=n.props.intervals,s=n.props.selected||n.props.openToDate||Ce(),p=k(s),c=g(s),l=(e=Ce(),B(e)),d=1440/o,u=n.props.injectTimes&&n.props.injectTimes.sort((function(e,t){return e-t})),h=0;h<d;h++){var f=i(l,h*o);if(r.push(f),u){var m=et(l,f,h,o,u);r=r.concat(m)}}return r.map((function(e,r){return t.createElement("li",{key:r,onClick:n.handleClick.bind(De(n),e),className:n.liClasses(e,p,c),ref:function(t){p===k(e)&&c>=g(e)&&(n.centerLi=t)}},Me(e,a,n.props.locale))}))})),n}return fe(r,e),le(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,r=this.state.height;return t.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},t.createElement("div",{className:"react-datepicker__header react-datepicker__header--time",ref:function(t){e.header=t}},t.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),t.createElement("div",{className:"react-datepicker__time"},t.createElement("div",{className:"react-datepicker__time-box"},t.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:r?{height:r}:{}},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}(t.Component);de(mt,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var yt=function(e){function r(e){var n;return pe(this,r),de(De(n=ve(this,me(r).call(this,e))),"onTimeChange",(function(e){n.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),n.props.onChange(t)})),de(De(n),"renderTimeInput",(function(){var e=n.state.time,r=n.props,a=r.timeString,o=r.customTimeInput;return o?t.cloneElement(o,{value:e,onChange:n.onTimeChange}):t.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){n.onTimeChange(e.target.value||a)}})})),n.state={time:n.props.timeString},n}return fe(r,e),le(r,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__input-time-container"},t.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),t.createElement("div",{className:"react-datepicker-time__input-container"},t.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}]),r}(t.Component);function Dt(e){var r=e.className,n=e.children,a=e.showPopperArrow,o=e.arrowProps,s=void 0===o?{}:o;return t.createElement("div",{className:r},a&&t.createElement("div",ue({className:"react-datepicker__triangle"},s)),n)}var vt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],wt=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return vt.some((function(e){return t.indexOf(e)>=0}))},gt=function(e){function r(e){var n;return pe(this,r),de(De(n=ve(this,me(r).call(this,e))),"handleClickOutside",(function(e){n.props.onClickOutside(e)})),de(De(n),"setClickOutsideRef",(function(){return n.containerRef.current})),de(De(n),"handleDropdownFocus",(function(e){wt(e.target)&&n.props.onDropdownFocus()})),de(De(n),"getDateInView",(function(){var e=n.props,t=e.preSelection,r=e.selected,a=e.openToDate,o=Je(n.props),s=Xe(n.props),i=Ce(),p=a||r||t;return p||(o&&ee(i,o)?o:s&&Z(i,s)?s:i)})),de(De(n),"increaseMonth",(function(){n.setState((function(e){var t=e.date;return{date:d(t,1)}}),(function(){return n.handleMonthChange(n.state.date)}))})),de(De(n),"decreaseMonth",(function(){n.setState((function(e){var t=e.date;return{date:D(t,1)}}),(function(){return n.handleMonthChange(n.state.date)}))})),de(De(n),"handleDayClick",(function(e,t,r){return n.props.onSelect(e,t,r)})),de(De(n),"handleDayMouseEnter",(function(e){n.setState({selectingDate:e}),n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e)})),de(De(n),"handleMonthMouseLeave",(function(){n.setState({selectingDate:null}),n.props.onMonthMouseLeave&&n.props.onMonthMouseLeave()})),de(De(n),"handleYearChange",(function(e){n.props.onYearChange&&n.props.onYearChange(e)})),de(De(n),"handleMonthChange",(function(e){n.props.onMonthChange&&n.props.onMonthChange(e),n.props.adjustDateOnChange&&(n.props.onSelect&&n.props.onSelect(e),n.props.setOpen&&n.props.setOpen(!0))})),de(De(n),"handleMonthYearChange",(function(e){n.handleYearChange(e),n.handleMonthChange(e)})),de(De(n),"changeYear",(function(e){n.setState((function(t){var r=t.date;return{date:Y(r,e)}}),(function(){return n.handleYearChange(n.state.date)}))})),de(De(n),"changeMonth",(function(e){n.setState((function(t){var r=t.date;return{date:x(r,e)}}),(function(){return n.handleMonthChange(n.state.date)}))})),de(De(n),"changeMonthYear",(function(e){n.setState((function(t){var r=t.date;return{date:Y(x(r,_(e)),M(e))}}),(function(){return n.handleMonthYearChange(n.state.date)}))})),de(De(n),"header",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,r=Pe(e,n.props.locale),a=[];return n.props.showWeekNumbers&&a.push(t.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),a.concat([0,1,2,3,4,5,6].map((function(e){var a=c(r,e),o=n.formatWeekday(a,n.props.locale);return t.createElement("div",{key:e,className:"react-datepicker__day-name"},o)})))})),de(De(n),"formatWeekday",(function(e,t){return n.props.formatWeekDay?function(e,t,r){return t(Me(e,"EEEE",r))}(e,n.props.formatWeekDay,t):n.props.useWeekdaysShort?function(e,t){return Me(e,"EEE",t)}(e,t):function(e,t){return Me(e,"EEEEEE",t)}(e,t)})),de(De(n),"decreaseYear",(function(){n.setState((function(e){var t=e.date;return{date:v(t,1)}}),(function(){return n.handleYearChange(n.state.date)}))})),de(De(n),"renderPreviousButton",(function(){if(!n.props.renderCustomHeader){var e=n.props.showMonthYearPicker?ze(n.state.date,n.props):Ue(n.state.date,n.props);if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],a=n.decreaseMonth;(n.props.showMonthYearPicker||n.props.showQuarterYearPicker)&&(a=n.decreaseYear),e&&n.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),a=null);var o=n.props.showMonthYearPicker||n.props.showQuarterYearPicker,s=n.props,i=s.previousMonthAriaLabel,p=void 0===i?"Previous Month":i,c=s.previousYearAriaLabel,l=void 0===c?"Previous Year":c;return t.createElement("button",{type:"button",className:r.join(" "),onClick:a,"aria-label":o?l:p},o?n.props.previousYearButtonLabel:n.props.previousMonthButtonLabel)}}})),de(De(n),"increaseYear",(function(){n.setState((function(e){var t=e.date;return{date:u(t,1)}}),(function(){return n.handleYearChange(n.state.date)}))})),de(De(n),"renderNextButton",(function(){if(!n.props.renderCustomHeader){var e=n.props.showMonthYearPicker?Ge(n.state.date,n.props):$e(n.state.date,n.props);if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];n.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),n.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var a=n.increaseMonth;(n.props.showMonthYearPicker||n.props.showQuarterYearPicker)&&(a=n.increaseYear),e&&n.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),a=null);var o=n.props.showMonthYearPicker||n.props.showQuarterYearPicker,s=n.props,i=s.nextMonthAriaLabel,p=void 0===i?"Previous Month":i,c=s.nextYearAriaLabel,l=void 0===c?"Previous Year":c;return t.createElement("button",{type:"button",className:r.join(" "),onClick:a,"aria-label":o?l:p},o?n.props.nextYearButtonLabel:n.props.nextMonthButtonLabel)}}})),de(De(n),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,r=["react-datepicker__current-month"];return n.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),n.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),t.createElement("div",{className:r.join(" ")},Me(e,n.props.dateFormat,n.props.locale))})),de(De(n),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return t.createElement(at,{adjustDateOnChange:n.props.adjustDateOnChange,date:n.state.date,onSelect:n.props.onSelect,setOpen:n.props.setOpen,dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:M(n.state.date),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})})),de(De(n),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown&&!e)return t.createElement(st,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,onChange:n.changeMonth,month:_(n.state.date),useShortMonthInDropdown:n.props.useShortMonthInDropdown})})),de(De(n),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthYearDropdown&&!e)return t.createElement(ct,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonthYear,minDate:n.props.minDate,maxDate:n.props.maxDate,date:n.state.date,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})})),de(De(n),"renderTodayButton",(function(){if(n.props.todayButton&&!n.props.showTimeSelectOnly)return t.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect(B(Ce()),e)}},n.props.todayButton)})),de(De(n),"renderDefaultHeader",(function(e){var r=e.monthDate,a=e.i;return t.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(r),t.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode),onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==a),n.renderMonthYearDropdown(0!==a),n.renderYearDropdown(0!==a)),t.createElement("div",{className:"react-datepicker__day-names"},n.header(r)))})),de(De(n),"renderCustomHeader",(function(e){var r=e.monthDate;if(0!==e.i)return null;var a=Ue(n.state.date,n.props),o=$e(n.state.date,n.props),s=ze(n.state.date,n.props),i=Ge(n.state.date,n.props);return t.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:n.props.onDropdownFocus},n.props.renderCustomHeader(function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?he(Object(r),!0).forEach((function(t){de(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):he(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({},n.state,{changeMonth:n.changeMonth,changeYear:n.changeYear,decreaseMonth:n.decreaseMonth,increaseMonth:n.increaseMonth,decreaseYear:n.decreaseYear,increaseYear:n.increaseYear,prevMonthButtonDisabled:a,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),t.createElement("div",{className:"react-datepicker__day-names"},n.header(r)))})),de(De(n),"renderYearHeader",(function(){return t.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},M(n.state.date))})),de(De(n),"renderHeader",(function(e){switch(!0){case void 0!==n.props.renderCustomHeader:return n.renderCustomHeader(e);case n.props.showMonthYearPicker||n.props.showQuarterYearPicker:return n.renderYearHeader(e);default:return n.renderDefaultHeader(e)}})),de(De(n),"renderMonths",(function(){if(!n.props.showTimeSelectOnly){for(var e=[],r=n.props.showPreviousMonths?n.props.monthsShown-1:0,a=D(n.state.date,r),o=0;o<n.props.monthsShown;++o){var s=o-n.props.monthSelectedIn,i=d(a,s),p="month-".concat(o);e.push(t.createElement("div",{key:p,ref:function(e){n.monthContainer=e},className:"react-datepicker__month-container"},n.renderHeader({monthDate:i,i:o}),t.createElement(ft,{chooseDayAriaLabelPrefix:n.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:n.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:n.props.weekAriaLabelPrefix,onChange:n.changeMonthYear,day:i,dayClassName:n.props.dayClassName,monthClassName:n.props.monthClassName,onDayClick:n.handleDayClick,handleOnKeyDown:n.props.handleOnKeyDown,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,orderInDisplay:o,formatWeekNumber:n.props.formatWeekNumber,locale:n.props.locale,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,setOpen:n.props.setOpen,shouldCloseOnSelect:n.props.shouldCloseOnSelect,renderDayContents:n.props.renderDayContents,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation,showMonthYearPicker:n.props.showMonthYearPicker,showQuarterYearPicker:n.props.showQuarterYearPicker,isInputFocused:n.props.isInputFocused})))}return e}})),de(De(n),"renderTimeSection",(function(){if(n.props.showTimeSelect&&(n.state.monthContainer||n.props.showTimeSelectOnly))return t.createElement(mt,{selected:n.props.selected,openToDate:n.props.openToDate,onChange:n.props.onTimeChange,timeClassName:n.props.timeClassName,format:n.props.timeFormat,includeTimes:n.props.includeTimes,intervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,timeCaption:n.props.timeCaption,todayButton:n.props.todayButton,showMonthDropdown:n.props.showMonthDropdown,showMonthYearDropdown:n.props.showMonthYearDropdown,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,monthRef:n.state.monthContainer,injectTimes:n.props.injectTimes,locale:n.props.locale})})),de(De(n),"renderInputTimeSection",(function(){var e=new Date(n.props.selected),r="".concat(tt(e.getHours()),":").concat(tt(e.getMinutes()));if(n.props.showTimeInput)return t.createElement(yt,{timeString:r,timeInputLabel:n.props.timeInputLabel,onChange:n.props.onTimeChange,customTimeInput:n.props.customTimeInput})})),n.containerRef=t.createRef(),n.state={date:n.getDateInView(),selectingDate:null,monthContainer:null},n}return fe(r,e),le(r,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null}}}]),le(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Ye(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Ye(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||Dt;return t.createElement("div",{ref:this.containerRef},t.createElement(e,{className:n("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}]),r}(t.Component),kt="[tabindex], a, button, input, select, textarea",bt=function(e){return!e.disabled&&-1!==e.tabIndex},Ct=function(e){function r(e){var n;return pe(this,r),de(De(n=ve(this,me(r).call(this,e))),"getTabChildren",(function(){return Array.prototype.slice.call(n.tabLoopRef.current.querySelectorAll(kt),1,-1).filter(bt)})),de(De(n),"handleFocusStart",(function(e){var t=n.getTabChildren();t&&t.length>1&&t[t.length-1].focus()})),de(De(n),"handleFocusEnd",(function(e){var t=n.getTabChildren();t&&t.length>1&&t[0].focus()})),n.tabLoopRef=t.createRef(),n}return fe(r,e),le(r,null,[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),le(r,[{key:"render",value:function(){return this.props.enableTabLoop?t.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},t.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,t.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}]),r}(t.Component),_t=function(e){function r(){return pe(this,r),ve(this,me(r).apply(this,arguments))}return fe(r,e),le(r,[{key:"render",value:function(){var e,r=this.props,a=r.className,o=r.wrapperClassName,s=r.hidePopper,i=r.popperComponent,p=r.popperModifiers,c=r.popperPlacement,l=r.popperProps,d=r.targetComponent,u=r.enableTabLoop,h=r.popperOnKeyDown;if(!s){var f=n("react-datepicker-popper",a);e=t.createElement(se.Popper,ue({modifiers:p,placement:c},l),(function(e){var r=e.ref,n=e.style,a=e.placement,o=e.arrowProps;return t.createElement(Ct,{enableTabLoop:u},t.createElement("div",ue({ref:r,style:n},{className:f,"data-placement":a,onKeyDown:h}),t.cloneElement(i,{arrowProps:o})))}))}this.props.popperContainer&&(e=t.createElement(this.props.popperContainer,{},e));var m=n("react-datepicker-wrapper",o);return t.createElement(se.Manager,{className:"react-datepicker-manager"},t.createElement(se.Reference,null,(function(e){var r=e.ref;return t.createElement("div",{ref:r,className:m},d)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),r}(t.Component),St="react-datepicker-ignore-onclickoutside",Mt=oe(gt);var Ot="Date input not valid.",Pt=function(e){function r(e){var o;return pe(this,r),de(De(o=ve(this,me(r).call(this,e))),"getPreSelection",(function(){return o.props.openToDate?o.props.openToDate:o.props.selectsEnd&&o.props.startDate?o.props.startDate:o.props.selectsStart&&o.props.endDate?o.props.endDate:Ce()})),de(De(o),"calcInitialState",(function(){var e=o.getPreSelection(),t=Je(o.props),r=Xe(o.props),n=t&&ee(e,t)?t:r&&Z(e,r)?r:e;return{open:o.props.startOpen||!1,preventFocus:!1,preSelection:o.props.selected?o.props.selected:n,highlightDates:Ze(o.props.highlightDates),focused:!1}})),de(De(o),"clearPreventFocusTimeout",(function(){o.preventFocusTimeout&&clearTimeout(o.preventFocusTimeout)})),de(De(o),"setFocus",(function(){o.input&&o.input.focus&&o.input.focus()})),de(De(o),"setBlur",(function(){o.input&&o.input.blur&&o.input.blur(),o.cancelFocusInput()})),de(De(o),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];o.setState({open:e,preSelection:e&&o.state.open?o.state.preSelection:o.calcInitialState().preSelection,lastPreSelectChange:Nt},(function(){e||o.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&o.setBlur(),o.setState({inputValue:null})}))}))})),de(De(o),"inputOk",(function(){return a(o.state.preSelection)})),de(De(o),"isCalendarOpen",(function(){return void 0===o.props.open?o.state.open&&!o.props.disabled&&!o.props.readOnly:o.props.open})),de(De(o),"handleFocus",(function(e){o.state.preventFocus||(o.props.onFocus(e),o.props.preventOpenOnFocus||o.props.readOnly||o.setOpen(!0)),o.setState({focused:!0})})),de(De(o),"cancelFocusInput",(function(){clearTimeout(o.inputFocusTimeout),o.inputFocusTimeout=null})),de(De(o),"deferFocusInput",(function(){o.cancelFocusInput(),o.inputFocusTimeout=setTimeout((function(){return o.setFocus()}),1)})),de(De(o),"handleDropdownFocus",(function(){o.cancelFocusInput()})),de(De(o),"handleBlur",(function(e){(!o.state.open||o.props.withPortal||o.props.showTimeInput)&&o.props.onBlur(e),o.setState({focused:!1})})),de(De(o),"handleCalendarClickOutside",(function(e){o.props.inline||o.setOpen(!1),o.props.onClickOutside(e),o.props.withPortal&&e.preventDefault()})),de(De(o),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!o.props.onChangeRaw||(o.props.onChangeRaw.apply(De(o),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){o.setState({inputValue:n.target.value,lastPreSelectChange:Et});var a=_e(n.target.value,o.props.dateFormat,o.props.locale,o.props.strictParsing);!a&&n.target.value||o.setSelected(a,n,!0)}})),de(De(o),"handleSelect",(function(e,t,r){o.setState({preventFocus:!0},(function(){return o.preventFocusTimeout=setTimeout((function(){return o.setState({preventFocus:!1})}),50),o.preventFocusTimeout})),o.setSelected(e,t,void 0,r),!o.props.shouldCloseOnSelect||o.props.showTimeSelect?o.setPreSelection(e):o.props.inline||o.setOpen(!1)})),de(De(o),"setSelected",(function(e,t,r,n){var a=e;if(null===a||!Ae(a,o.props)){if(!Ie(o.props.selected,a)||o.props.allowSameDay){if(null!==a){if(o.props.selected){var s=o.props.selected;r&&(s=Ce(a)),a=Oe(a,{hour:k(s),minute:g(s),second:w(s)})}o.props.inline||o.setState({preSelection:a}),o.props.inline&&o.props.monthsShown>1&&!o.props.inlineFocusSelectedMonth&&o.setState({monthSelectedIn:n})}o.props.onChange(a,t)}o.props.onSelect(a,t),r||o.setState({inputValue:null})}})),de(De(o),"setPreSelection",(function(e){var t=void 0!==o.props.minDate,r=void 0!==o.props.maxDate,n=!0;e&&(t&&r?n=Le(e,o.props.minDate,o.props.maxDate):t?n=Z(e,o.props.minDate):r&&(n=ee(e,o.props.maxDate))),n&&o.setState({preSelection:e})})),de(De(o),"handleTimeChange",(function(e){var t=Oe(o.props.selected?o.props.selected:o.getPreSelection(),{hour:k(e),minute:g(e)});o.setState({preSelection:t}),o.props.onChange(t),o.props.shouldCloseOnSelect&&o.setOpen(!1),o.props.showTimeInput&&o.setOpen(!0),o.setState({inputValue:null})})),de(De(o),"onInputClick",(function(){o.props.disabled||o.props.readOnly||o.setOpen(!0),o.props.onInputClick()})),de(De(o),"onInputKeyDown",(function(e){o.props.onKeyDown(e);var t=e.key;if(o.state.open||o.props.inline||o.props.preventOpenOnFocus){if(o.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=o.calendar.componentNode&&o.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus())}var n=Ce(o.state.preSelection);"Enter"===t?(e.preventDefault(),o.inputOk()&&o.state.lastPreSelectChange===Nt?(o.handleSelect(n,e),!o.props.shouldCloseOnSelect&&o.setPreSelection(n)):o.setOpen(!1)):"Escape"===t&&(e.preventDefault(),o.setOpen(!1)),o.inputOk()||o.props.onInputError({code:1,msg:Ot})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||o.onInputClick()})),de(De(o),"onDayKeyDown",(function(e){o.props.onKeyDown(e);var t=e.key,r=Ce(o.state.preSelection);if("Enter"===t)e.preventDefault(),o.handleSelect(r,e),!o.props.shouldCloseOnSelect&&o.setPreSelection(r);else if("Escape"===t)e.preventDefault(),o.setOpen(!1),o.inputOk()||o.props.onInputError({code:1,msg:Ot});else if(!o.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=m(r,1);break;case"ArrowRight":n=c(r,1);break;case"ArrowUp":n=y(r,1);break;case"ArrowDown":n=l(r,1);break;case"PageUp":n=D(r,1);break;case"PageDown":n=d(r,1);break;case"Home":n=v(r,1);break;case"End":n=u(r,1)}if(!n)return void(o.props.onInputError&&o.props.onInputError({code:1,msg:Ot}));e.preventDefault(),o.setState({lastPreSelectChange:Nt}),o.props.adjustDateOnChange&&o.setSelected(n),o.setPreSelection(n)}})),de(De(o),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),o.setState({preventFocus:!0},(function(){o.setOpen(!1),setTimeout(o.setFocus)})))})),de(De(o),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),o.props.onChange(null,e),o.setState({inputValue:null})})),de(De(o),"clear",(function(){o.onClearClick()})),de(De(o),"renderCalendar",(function(){return o.props.inline||o.isCalendarOpen()?t.createElement(Mt,{ref:function(e){o.calendar=e},locale:o.props.locale,chooseDayAriaLabelPrefix:o.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:o.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:o.props.weekAriaLabelPrefix,adjustDateOnChange:o.props.adjustDateOnChange,setOpen:o.setOpen,shouldCloseOnSelect:o.props.shouldCloseOnSelect,dateFormat:o.props.dateFormatCalendar,useWeekdaysShort:o.props.useWeekdaysShort,formatWeekDay:o.props.formatWeekDay,dropdownMode:o.props.dropdownMode,selected:o.props.selected,preSelection:o.state.preSelection,onSelect:o.handleSelect,onWeekSelect:o.props.onWeekSelect,openToDate:o.props.openToDate,minDate:o.props.minDate,maxDate:o.props.maxDate,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,startDate:o.props.startDate,endDate:o.props.endDate,excludeDates:o.props.excludeDates,filterDate:o.props.filterDate,onClickOutside:o.handleCalendarClickOutside,formatWeekNumber:o.props.formatWeekNumber,highlightDates:o.state.highlightDates,includeDates:o.props.includeDates,includeTimes:o.props.includeTimes,injectTimes:o.props.injectTimes,inline:o.props.inline,peekNextMonth:o.props.peekNextMonth,showMonthDropdown:o.props.showMonthDropdown,showPreviousMonths:o.props.showPreviousMonths,useShortMonthInDropdown:o.props.useShortMonthInDropdown,showMonthYearDropdown:o.props.showMonthYearDropdown,showWeekNumbers:o.props.showWeekNumbers,showYearDropdown:o.props.showYearDropdown,withPortal:o.props.withPortal,forceShowMonthNavigation:o.props.forceShowMonthNavigation,showDisabledMonthNavigation:o.props.showDisabledMonthNavigation,scrollableYearDropdown:o.props.scrollableYearDropdown,scrollableMonthYearDropdown:o.props.scrollableMonthYearDropdown,todayButton:o.props.todayButton,weekLabel:o.props.weekLabel,outsideClickIgnoreClass:St,fixedHeight:o.props.fixedHeight,monthsShown:o.props.monthsShown,monthSelectedIn:o.state.monthSelectedIn,onDropdownFocus:o.handleDropdownFocus,onMonthChange:o.props.onMonthChange,onYearChange:o.props.onYearChange,dayClassName:o.props.dayClassName,monthClassName:o.props.monthClassName,timeClassName:o.props.timeClassName,showTimeSelect:o.props.showTimeSelect,showTimeSelectOnly:o.props.showTimeSelectOnly,onTimeChange:o.handleTimeChange,timeFormat:o.props.timeFormat,timeIntervals:o.props.timeIntervals,minTime:o.props.minTime,maxTime:o.props.maxTime,excludeTimes:o.props.excludeTimes,timeCaption:o.props.timeCaption,className:o.props.calendarClassName,container:o.props.calendarContainer,yearDropdownItemNumber:o.props.yearDropdownItemNumber,previousMonthButtonLabel:o.props.previousMonthButtonLabel,nextMonthButtonLabel:o.props.nextMonthButtonLabel,previousYearButtonLabel:o.props.previousYearButtonLabel,nextYearButtonLabel:o.props.nextYearButtonLabel,timeInputLabel:o.props.timeInputLabel,disabledKeyboardNavigation:o.props.disabledKeyboardNavigation,renderCustomHeader:o.props.renderCustomHeader,popperProps:o.props.popperProps,renderDayContents:o.props.renderDayContents,onDayMouseEnter:o.props.onDayMouseEnter,onMonthMouseLeave:o.props.onMonthMouseLeave,showTimeInput:o.props.showTimeInput,showMonthYearPicker:o.props.showMonthYearPicker,showQuarterYearPicker:o.props.showQuarterYearPicker,showPopperArrow:o.props.showPopperArrow,excludeScrollbar:o.props.excludeScrollbar,handleOnKeyDown:o.onDayKeyDown,isInputFocused:o.state.focused,customTimeInput:o.props.customTimeInput},o.props.children):null})),de(De(o),"renderDateInput",(function(){var e,r,a,s,i,p=n(o.props.className,de({},St,o.state.open)),c=o.props.customInput||t.createElement("input",{type:"text"}),l=o.props.customInputRef||"ref",d="string"==typeof o.props.value?o.props.value:"string"==typeof o.state.inputValue?o.state.inputValue:(r=o.props.selected,a=o.props,s=a.dateFormat,i=a.locale,r&&Me(r,Array.isArray(s)?s[0]:s,i)||"");return t.cloneElement(c,(de(e={},l,(function(e){o.input=e})),de(e,"value",d),de(e,"onBlur",o.handleBlur),de(e,"onChange",o.handleChange),de(e,"onClick",o.onInputClick),de(e,"onFocus",o.handleFocus),de(e,"onKeyDown",o.onInputKeyDown),de(e,"id",o.props.id),de(e,"name",o.props.name),de(e,"autoFocus",o.props.autoFocus),de(e,"placeholder",o.props.placeholderText),de(e,"disabled",o.props.disabled),de(e,"autoComplete",o.props.autoComplete),de(e,"className",n(c.props.className,p)),de(e,"title",o.props.title),de(e,"readOnly",o.props.readOnly),de(e,"required",o.props.required),de(e,"tabIndex",o.props.tabIndex),de(e,"aria-labelledby",o.props.ariaLabelledBy),e))})),de(De(o),"renderClearButton",(function(){var e=o.props,r=e.isClearable,n=e.selected,a=e.clearButtonTitle,s=e.ariaLabelClose,i=void 0===s?"Close":s;return r&&null!=n?t.createElement("button",{type:"button",className:"react-datepicker__close-icon","aria-label":i,onClick:o.onClearClick,title:a,tabIndex:-1}):null})),o.state=o.calcInitialState(),o}return fe(r,e),le(r,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,renderDayContents:function(e){return e},inlineFocusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),le(r,[{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?_(r)!==_(n)||M(r)!==M(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Ze(this.props.highlightDates)}),t.focused||Ie(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?t.createElement("div",null,this.props.inline?null:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?t.createElement("div",{className:"react-datepicker__portal"},e):null):t.createElement(_t,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),popperModifiers:this.props.popperModifiers,targetComponent:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}]),r}(t.Component),Et="input",Nt="navigate";e.CalendarContainer=Dt,e.default=Pt,e.getDefaultLocale=qe,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:global).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 5938 */
1620,
/* 5939 */
475,
/* 5940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2728);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(5320);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(2730);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ }),
/* 5941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(5940);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ }),
/* 5942 */
2179,
/* 5943 */
[6633, 5944, 5945, 2713, 2714, 2715, 1596, 2711],
/* 5944 */
[6634, 2711],
/* 5945 */
[6635, 62, 47],
/* 5946 */
[6640, 92, 62, 47],
/* 5947 */
[6641, 92, 62, 47],
/* 5948 */
[6642, 92, 62, 2713, 47],
/* 5949 */
[6643, 92, 62, 2715, 47],
/* 5950 */
[6645, 2714, 1017, 47],
/* 5951 */
[6647, 92, 1596, 1018, 47],
/* 5952 */
[6648, 743, 1600, 47],
/* 5953 */
[6649, 62, 47],
/* 5954 */
[6650, 2726, 743, 47],
/* 5955 */
[6651, 62, 47],
/* 5956 */
[6652, 62, 47],
/* 5957 */
[6653, 62, 47],
/* 5958 */
[6654, 62, 92, 47],
/* 5959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	
	var _index = _interopRequireDefault(__webpack_require__(2722));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2723));
	
	var _index3 = _interopRequireDefault(__webpack_require__(2727));
	
	var _index4 = _interopRequireDefault(__webpack_require__(62));
	
	var _index5 = _interopRequireDefault(__webpack_require__(5943));
	
	var _index6 = _interopRequireDefault(__webpack_require__(2712));
	
	var _index7 = _interopRequireDefault(__webpack_require__(743));
	
	var _index8 = __webpack_require__(2716);
	
	var _index9 = _interopRequireDefault(__webpack_require__(92));
	
	var _index10 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | AM, PM                          | a..aaa  | AM, PM                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 05/29/1453                        | 7     |
	 * |                                 | PP      | May 29, 1453                      | 7     |
	 * |                                 | PPP     | May 29th, 1453                    | 7     |
	 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
	 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The second argument is now required for the sake of explicitness.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   format(new Date(2016, 0, 1))
	 *
	 *   // v2.0.0 onward
	 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
	 *   ```
	 *
	 * - New format string API for `format` function
	 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
	 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
	 *
	 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
	  (0, _index10.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index2.default;
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	
	  var originalDate = (0, _index4.default)(dirtyDate);
	
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	
	
	  var timezoneOffset = (0, _index7.default)(originalDate);
	  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index6.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, formatterOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	
	    var formatter = _index5.default[firstCharacter];
	
	    if (formatter) {
	      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring);
	      }
	
	      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
	        (0, _index8.throwProtectedError)(substring);
	      }
	
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	
	    return substring;
	  }).join('');
	  return result;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 5960 */
[6655, 62, 47],
/* 5961 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	
	var _index = _interopRequireDefault(__webpack_require__(62));
	
	var _index2 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * var result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	
	module.exports = exports.default;

/***/ }),
/* 5962 */
[6657, 62, 47],
/* 5963 */
[6658, 62, 47],
/* 5964 */
[6659, 62, 47],
/* 5965 */
[6660, 62, 47],
/* 5966 */
[6661, 62, 47],
/* 5967 */
[6662, 62, 47],
/* 5968 */
[6663, 62, 47],
/* 5969 */
[6664, 62, 47],
/* 5970 */
[6665, 62, 47],
/* 5971 */
[6666, 47],
/* 5972 */
[6667, 62, 47],
/* 5973 */
[6668, 1600, 47],
/* 5974 */
[6669, 62, 47],
/* 5975 */
[6670, 2725, 47],
/* 5976 */
[6671, 62, 47],
/* 5977 */
[6673, 62, 47],
/* 5978 */
4811,
/* 5979 */
4812,
/* 5980 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	
	function buildMatchFn(args) {
	  return function (dirtyString, dirtyOptions) {
	    var string = String(dirtyString);
	    var options = dirtyOptions || {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	
	    if (!matchResult) {
	      return null;
	    }
	
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var value;
	
	    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
	      value = findIndex(parsePatterns, function (pattern) {
	        return pattern.test(string);
	      });
	    } else {
	      value = findKey(parsePatterns, function (pattern) {
	        return pattern.test(string);
	      });
	    }
	
	    value = args.valueCallback ? args.valueCallback(value) : value;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    return {
	      value: value,
	      rest: string.slice(matchedString.length)
	    };
	  };
	}
	
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	}
	
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 5981 */
4814,
/* 5982 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	function formatDistance(token, count, options) {
	  options = options || {};
	  var result;
	
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	
	  return result;
	}
	
	module.exports = exports.default;

/***/ }),
/* 5983 */
[6674, 5978],
/* 5984 */
4817,
/* 5985 */
[6675, 5979],
/* 5986 */
[6676, 5981, 5980],
/* 5987 */
[6678, 62, 47],
/* 5988 */
[6679, 62, 47],
/* 5989 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(1596));
	
	var _index2 = _interopRequireDefault(__webpack_require__(5946));
	
	var _index3 = _interopRequireDefault(__webpack_require__(5947));
	
	var _index4 = _interopRequireDefault(__webpack_require__(5948));
	
	var _index5 = _interopRequireDefault(__webpack_require__(5949));
	
	var _index6 = _interopRequireDefault(__webpack_require__(1017));
	
	var _index7 = _interopRequireDefault(__webpack_require__(1018));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_SECOND = 1000;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	
	};
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	
	function parseNumericPattern(pattern, string, valueCallback) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  }
	
	  var value = parseInt(matchResult[0], 10);
	  return {
	    value: valueCallback ? valueCallback(value) : value,
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseTimezonePattern(pattern, string) {
	  var matchResult = string.match(pattern);
	
	  if (!matchResult) {
	    return null;
	  } // Input is 'Z'
	
	
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: string.slice(1)
	    };
	  }
	
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
	    rest: string.slice(matchResult[0].length)
	  };
	}
	
	function parseAnyDigitsSigned(string, valueCallback) {
	  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
	}
	
	function parseNDigits(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function parseNDigitsSigned(n, string, valueCallback) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);
	
	    case 2:
	      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);
	
	    case 3:
	      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);
	
	    case 4:
	      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);
	
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
	  }
	}
	
	function dayPeriodEnumToHours(enumValue) {
	  switch (enumValue) {
	    case 'morning':
	      return 4;
	
	    case 'evening':
	      return 17;
	
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0; // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	
	  return isCommonEra ? result : 1 - result;
	}
	
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	
	
	var parsers = {
	  // Era
	  G: {
	    priority: 140,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	        // A, B
	
	        case 'GGGGG':
	          return match.era(string, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	
	        case 'GGGG':
	        default:
	          return match.era(string, {
	            width: 'wide'
	          }) || match.era(string, {
	            width: 'abbreviated'
	          }) || match.era(string, {
	            width: 'narrow'
	          });
	      }
	    },
	    set: function (date, flags, value, _options) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['R', 'u', 't', 'T']
	  },
	  // Year
	  y: {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	
	      switch (token) {
	        case 'y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, _options) {
	      var currentYear = date.getUTCFullYear();
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week-numbering year
	  Y: {
	    priority: 130,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	
	      switch (token) {
	        case 'Y':
	          return parseNDigits(4, string, valueCallback);
	
	        case 'Yo':
	          return match.ordinalNumber(string, {
	            unit: 'year',
	            valueCallback: valueCallback
	          });
	
	        default:
	          return parseNDigits(token.length, string, valueCallback);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value.isTwoDigitYear || value.year > 0;
	    },
	    set: function (date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index7.default)(date, options);
	      }
	
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index7.default)(date, options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week-numbering year
	  R: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'R') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (_date, _flags, value, _options) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index6.default)(firstWeekOfYear);
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Extended year
	  u: {
	    priority: 130,
	    parse: function (string, token, _match, _options) {
	      if (token === 'u') {
	        return parseNDigitsSigned(4, string);
	      }
	
	      return parseNDigitsSigned(token.length, string);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
	  },
	  // Quarter
	  Q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'Qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'QQQ':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'QQQQQ':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'QQQQ':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone quarter
	  q: {
	    priority: 120,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return parseNDigits(token.length, string);
	        // 1st, 2nd, 3rd, 4th
	
	        case 'qo':
	          return match.ordinalNumber(string, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	
	        case 'qqq':
	          return match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	        case 'qqqqq':
	          return match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	
	        case 'qqqq':
	        default:
	          return match.quarter(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 4;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Month
	  M: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'MM':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Mo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'MMM':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	
	        case 'MMMMM':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	
	        case 'MMMM':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Stand-alone month
	  L: {
	    priority: 110,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        return value - 1;
	      };
	
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return parseNumericPattern(numericPatterns.month, string, valueCallback);
	        // 01, 02, ..., 12
	
	        case 'LL':
	          return parseNDigits(2, string, valueCallback);
	        // 1st, 2nd, ..., 12th
	
	        case 'Lo':
	          return match.ordinalNumber(string, {
	            unit: 'month',
	            valueCallback: valueCallback
	          });
	        // Jan, Feb, ..., Dec
	
	        case 'LLL':
	          return match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	
	        case 'LLLLL':
	          return match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	
	        case 'LLLL':
	        default:
	          return match.month(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local week of year
	  w: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'w':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'wo':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index7.default)((0, _index5.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
	  },
	  // ISO week of year
	  I: {
	    priority: 100,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'I':
	          return parseNumericPattern(numericPatterns.week, string);
	
	        case 'Io':
	          return match.ordinalNumber(string, {
	            unit: 'week'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 53;
	    },
	    set: function (date, _flags, value, options) {
	      return (0, _index6.default)((0, _index4.default)(date, value, options), options);
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
	  },
	  // Day of the month
	  d: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'd':
	          return parseNumericPattern(numericPatterns.date, string);
	
	        case 'do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	      var month = date.getUTCMonth();
	
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of year
	  D: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return parseNumericPattern(numericPatterns.dayOfYear, string);
	
	        case 'Do':
	          return match.ordinalNumber(string, {
	            unit: 'date'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (date, value, _options) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = isLeapYearIndex(year);
	
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
	  },
	  // Day of week
	  E: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'EEEEE':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'EEEEEE':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'EEEE':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
	  },
	  // Local day of week
	  e: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'eo':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'eee':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	
	        case 'eeeee':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	
	        case 'eeeeee':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	
	        case 'eeee':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
	  },
	  // Stand-alone local day of week
	  c: {
	    priority: 90,
	    parse: function (string, token, match, options) {
	      var valueCallback = function (value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return parseNDigits(token.length, string, valueCallback);
	        // 3rd
	
	        case 'co':
	          return match.ordinalNumber(string, {
	            unit: 'day',
	            valueCallback: valueCallback
	          });
	        // Tue
	
	        case 'ccc':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	
	        case 'ccccc':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	
	        case 'cccccc':
	          return match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	
	        case 'cccc':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 6;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index2.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
	  },
	  // ISO day of week
	  i: {
	    priority: 90,
	    parse: function (string, token, match, _options) {
	      var valueCallback = function (value) {
	        if (value === 0) {
	          return 7;
	        }
	
	        return value;
	      };
	
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return parseNDigits(token.length, string);
	        // 2nd
	
	        case 'io':
	          return match.ordinalNumber(string, {
	            unit: 'day'
	          });
	        // Tue
	
	        case 'iii':
	          return match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // T
	
	        case 'iiiii':
	          return match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tu
	
	        case 'iiiiii':
	          return match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	        // Tuesday
	
	        case 'iiii':
	        default:
	          return match.day(string, {
	            width: 'wide',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'abbreviated',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'short',
	            context: 'formatting',
	            valueCallback: valueCallback
	          }) || match.day(string, {
	            width: 'narrow',
	            context: 'formatting',
	            valueCallback: valueCallback
	          });
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 7;
	    },
	    set: function (date, _flags, value, options) {
	      date = (0, _index3.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
	  },
	  // AM or PM
	  a: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaaa':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'aaaa':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // AM, PM, midnight
	  b: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbbb':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'bbbb':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: {
	    priority: 80,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBBB':
	          return match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	
	        case 'BBBB':
	        default:
	          return match.dayPeriod(string, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(string, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 't', 'T']
	  },
	  // Hour [1-12]
	  h: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'h':
	          return parseNumericPattern(numericPatterns.hour12h, string);
	
	        case 'ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 12;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-23]
	  H: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'H':
	          return parseNumericPattern(numericPatterns.hour23h, string);
	
	        case 'Ho':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 23;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
	  },
	  // Hour [0-11]
	  K: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'K':
	          return parseNumericPattern(numericPatterns.hour11h, string);
	
	        case 'Ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 11;
	    },
	    set: function (date, _flags, value, _options) {
	      var isPM = date.getUTCHours() >= 12;
	
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
	  },
	  // Hour [1-24]
	  k: {
	    priority: 70,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'k':
	          return parseNumericPattern(numericPatterns.hour24h, string);
	
	        case 'ko':
	          return match.ordinalNumber(string, {
	            unit: 'hour'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 1 && value <= 24;
	    },
	    set: function (date, _flags, value, _options) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
	  },
	  // Minute
	  m: {
	    priority: 60,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 'm':
	          return parseNumericPattern(numericPatterns.minute, string);
	
	        case 'mo':
	          return match.ordinalNumber(string, {
	            unit: 'minute'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Second
	  s: {
	    priority: 50,
	    parse: function (string, token, match, _options) {
	      switch (token) {
	        case 's':
	          return parseNumericPattern(numericPatterns.second, string);
	
	        case 'so':
	          return match.ordinalNumber(string, {
	            unit: 'second'
	          });
	
	        default:
	          return parseNDigits(token.length, string);
	      }
	    },
	    validate: function (_date, value, _options) {
	      return value >= 0 && value <= 59;
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Fraction of second
	  S: {
	    priority: 30,
	    parse: function (string, token, _match, _options) {
	      var valueCallback = function (value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	
	      return parseNDigits(token.length, string, valueCallback);
	    },
	    set: function (date, _flags, value, _options) {
	      date.setUTCMilliseconds(value);
	      return date;
	    },
	    incompatibleTokens: ['t', 'T']
	  },
	  // Timezone (ISO-8601. +00:00 is `'Z'`)
	  X: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'X':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'XX':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'XXXX':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'XXXXX':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'XXX':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'x']
	  },
	  // Timezone (ISO-8601)
	  x: {
	    priority: 10,
	    parse: function (string, token, _match, _options) {
	      switch (token) {
	        case 'x':
	          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);
	
	        case 'xx':
	          return parseTimezonePattern(timezonePatterns.basic, string);
	
	        case 'xxxx':
	          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);
	
	        case 'xxxxx':
	          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);
	
	        case 'xxx':
	        default:
	          return parseTimezonePattern(timezonePatterns.extended, string);
	      }
	    },
	    set: function (date, flags, value, _options) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	
	      return new Date(date.getTime() - value);
	    },
	    incompatibleTokens: ['t', 'T', 'X']
	  },
	  // Seconds timestamp
	  t: {
	    priority: 40,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  },
	  // Milliseconds timestamp
	  T: {
	    priority: 20,
	    parse: function (string, _token, _match, _options) {
	      return parseAnyDigitsSigned(string);
	    },
	    set: function (_date, _flags, value, _options) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    },
	    incompatibleTokens: '*'
	  }
	};
	var _default = parsers;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 5990 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	
	var _index = _interopRequireDefault(__webpack_require__(2723));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2727));
	
	var _index3 = _interopRequireDefault(__webpack_require__(62));
	
	var _index4 = _interopRequireDefault(__webpack_require__(5942));
	
	var _index5 = _interopRequireDefault(__webpack_require__(2712));
	
	var _index6 = _interopRequireDefault(__webpack_require__(743));
	
	var _index7 = __webpack_require__(2716);
	
	var _index8 = _interopRequireDefault(__webpack_require__(92));
	
	var _index9 = _interopRequireDefault(__webpack_require__(5989));
	
	var _index10 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://git.io/fxCyr
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `backupDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `backupDate` which works as a context of parsing.
	 *
	 * `backupDate` must be passed for correct work of the function.
	 * If you're not sure which `backupDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `backupDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `backupDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Old `parse` was renamed to `toDate`.
	 *   Now `parse` is a new function which parses a string using a provided format.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   toDate('2016-01-01')
	 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
	 *   ```
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} backupDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://git.io/fxCyr
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://git.io/fxCyr
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	
	function parse(dirtyDateString, dirtyFormatString, dirtyBackupDate, dirtyOptions) {
	  (0, _index10.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var options = dirtyOptions || {};
	  var locale = options.locale || _index.default;
	
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	
	  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index8.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index8.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index8.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index8.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyBackupDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale // If timezone isn't specified, it will be set to the system timezone
	
	  };
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    set: dateToSystemTimezone,
	    index: 0
	  }];
	  var i;
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong, subFnOptions);
	    }
	
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	
	  for (i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (!options.useAdditionalWeekYearTokens && (0, _index7.isProtectedWeekYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token);
	    }
	
	    if (!options.useAdditionalDayOfYearTokens && (0, _index7.isProtectedDayOfYearToken)(token)) {
	      (0, _index7.throwProtectedError)(token);
	    }
	
	    var firstCharacter = token[0];
	    var parser = _index9.default[firstCharacter];
	
	    if (parser) {
	      var incompatibleTokens = parser.incompatibleTokens;
	
	      if (Array.isArray(incompatibleTokens)) {
	        var incompatibleToken = void 0;
	
	        for (var _i = 0; _i < usedTokens.length; _i++) {
	          var usedToken = usedTokens[_i].token;
	
	          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
	            incompatibleToken = usedTokens[_i];
	            break;
	          }
	        }
	
	        if (incompatibleToken) {
	          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	        }
	      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
	        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	      }
	
	      usedTokens.push({
	        token: firstCharacter,
	        fullToken: token
	      });
	      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);
	
	      if (!parseResult) {
	        return new Date(NaN);
	      }
	
	      setters.push({
	        priority: parser.priority,
	        set: parser.set,
	        validate: parser.validate,
	        value: parseResult.value,
	        index: setters.length
	      });
	      dateString = parseResult.rest;
	    } else {
	      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	      } // Replace two single quote characters with one single quote character
	
	
	      if (token === "''") {
	        token = "'";
	      } else if (firstCharacter === "'") {
	        token = cleanEscapedString(token);
	      } // Cut token from string, or, if string doesn't match the token, return Invalid Date
	
	
	      if (dateString.indexOf(token) === 0) {
	        dateString = dateString.slice(token.length);
	      } else {
	        return new Date(NaN);
	      }
	    }
	  } // Check if the remaining input contains something other than whitespace
	
	
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).reverse();
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyBackupDate);
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	
	
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	
	  for (i = 0; i < uniquePrioritySetters.length; i++) {
	    var setter = uniquePrioritySetters[i];
	
	    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
	      return new Date(NaN);
	    }
	
	    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
	
	    if (result[0]) {
	      utcDate = result[0];
	      (0, _index4.default)(flags, result[1]); // Result is date
	    } else {
	      utcDate = result;
	    }
	  }
	
	  return utcDate;
	}
	
	function dateToSystemTimezone(date, flags) {
	  if (flags.timestampIsSet) {
	    return date;
	  }
	
	  var convertedDate = new Date(0);
	  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	  return convertedDate;
	}
	
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	
	module.exports = exports.default;

/***/ }),
/* 5991 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(743));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The previous `parse` implementation was renamed to `parseISO`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   parse('2016-01-01')
	 *
	 *   // v2.0.0 onward
	 *   parseISO('2016-01-01')
	 *   ```
	 *
	 * - `parseISO` now validates separate date and time values in ISO-8601 strings
	 *   and returns `Invalid Date` if the date is invalid.
	 *
	 *   ```javascript
	 *   parseISO('2018-13-32')
	 *   //=> Invalid Date
	 *   ```
	 *
	 * - `parseISO` now doesn't fall back to `new Date` constructor
	 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	
	function parseISO(argument, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);
	
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	
	  var dateStrings = splitDateString(argument);
	  var date;
	
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	
	  if (isNaN(date) || !date) {
	    return new Date(NaN);
	  }
	
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	
	    if (isNaN(time) || time === null) {
	      return new Date(NaN);
	    }
	  }
	
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var fullTime = timestamp + time;
	    var fullTimeDate = new Date(fullTime);
	    offset = (0, _index2.default)(fullTimeDate); // Adjust time when it's coming from DST
	
	    var fullTimeDateDiffDay = new Date(fullTime);
	
	    if (offset > 0) {
	      fullTimeDateDiffDay.setDate(fullTimeDate.getDate() + 1);
	    } else {
	      fullTimeDateDiffDay.setDate(fullTimeDate.getDate() - 1);
	    }
	
	    var offsetDiff = (0, _index2.default)(fullTimeDateDiffDay) - offset;
	
	    if (offsetDiff > 0) {
	      offset += offsetDiff;
	    }
	  }
	
	  return new Date(timestamp + time + offset);
	}
	
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString;
	
	  if (/:/.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings;
	}
	
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex); // Invalid ISO-formatted year
	
	  if (!captures) return {
	    year: null
	  };
	  var year = captures[1] && parseInt(captures[1]);
	  var century = captures[2] && parseInt(captures[2]);
	  return {
	    year: century == null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return null;
	  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string
	
	  if (!captures) return null;
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return null; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	
	  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
	}
	
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	
	  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
	}
	
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	} // Validation functions
	// February is null to handle the leap year (using ||)
	
	
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100;
	}
	
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	
	module.exports = exports.default;

/***/ }),
/* 5992 */
[6680, 92, 62, 47],
/* 5993 */
[6681, 92, 62, 47],
/* 5994 */
[6683, 92, 62, 2724, 47],
/* 5995 */
[6684, 92, 62, 47],
/* 5996 */
[6685, 92, 62, 47],
/* 5997 */
[6687, 62, 47],
/* 5998 */
[6690, 62, 47],
/* 5999 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1597));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * var result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6000 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2717));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6001 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2718));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6002 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(1599));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * var result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6003 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2719));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * var result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6004 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	
	var _index = _interopRequireDefault(__webpack_require__(92));
	
	var _index2 = _interopRequireDefault(__webpack_require__(2720));
	
	var _index3 = _interopRequireDefault(__webpack_require__(47));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * var result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6005 */
/***/ (function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(2662);
	var isArguments = __webpack_require__(5349);
	var is = __webpack_require__(5690);
	var isRegex = __webpack_require__(5351);
	var flags = __webpack_require__(6470);
	var isDate = __webpack_require__(5350);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ }),
/* 6006 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6007 */
[6835, 6008],
/* 6008 */
6261,
/* 6009 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(1016);
	
	var _interopRequireDefault = __webpack_require__(1015);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(5938));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(2710));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(1593));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(1595));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(1594));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(6005));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _popper = _interopRequireDefault(__webpack_require__(6006));
	
	var _Manager = __webpack_require__(1601);
	
	var _utils = __webpack_require__(2729);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.setRef)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqual.default)(this.props.modifiers, prevProps.modifiers, {
	      strict: true
	    })) {
	      // develop only check that modifiers isn't being updated needlessly
	      if (false) {
	        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) {
	          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
	        }
	      }
	
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ }),
/* 6010 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(1016);
	
	var _interopRequireDefault = __webpack_require__(1015);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(2710));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(1593));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(1595));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(1594));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(2730));
	
	var _Manager = __webpack_require__(1601);
	
	var _utils = __webpack_require__(2729);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refHandler", function (node) {
	      (0, _utils.setRef)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ }),
/* 6011 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1015);
	
	var _interopRequireWildcard = __webpack_require__(1016);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(6009));
	
	var _Manager = _interopRequireDefault(__webpack_require__(1601));
	
	var _Reference = _interopRequireDefault(__webpack_require__(6010));

/***/ }),
/* 6012 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _js_utils = __webpack_require__(2732);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var EnterLeaveCounter =
	/*#__PURE__*/
	function () {
	  function EnterLeaveCounter(isNodeInDocument) {
	    _classCallCheck(this, EnterLeaveCounter);
	
	    this.entered = [];
	    this.isNodeInDocument = isNodeInDocument;
	  }
	
	  _createClass(EnterLeaveCounter, [{
	    key: "enter",
	    value: function enter(enteringNode) {
	      var _this = this;
	
	      var previousLength = this.entered.length;
	
	      var isNodeEntered = function isNodeEntered(node) {
	        return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
	      };
	
	      this.entered = (0, _js_utils.union)(this.entered.filter(isNodeEntered), [enteringNode]);
	      return previousLength === 0 && this.entered.length > 0;
	    }
	  }, {
	    key: "leave",
	    value: function leave(leavingNode) {
	      var previousLength = this.entered.length;
	      this.entered = (0, _js_utils.without)(this.entered.filter(this.isNodeInDocument), leavingNode);
	      return previousLength > 0 && this.entered.length === 0;
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.entered = [];
	    }
	  }]);
	
	  return EnterLeaveCounter;
	}();
	
	exports.default = EnterLeaveCounter;

/***/ }),
/* 6013 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _EnterLeaveCounter = _interopRequireDefault(__webpack_require__(6012));
	
	var _BrowserDetector = __webpack_require__(2731);
	
	var _OffsetUtils = __webpack_require__(6019);
	
	var _NativeDragSources = __webpack_require__(6017);
	
	var NativeTypes = _interopRequireWildcard(__webpack_require__(1602));
	
	var _OptionsReader = __webpack_require__(6020);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var HTML5Backend =
	/*#__PURE__*/
	function () {
	  function HTML5Backend(manager, globalContext) {
	    var _this = this;
	
	    _classCallCheck(this, HTML5Backend);
	
	    this.sourcePreviewNodes = new Map();
	    this.sourcePreviewNodeOptions = new Map();
	    this.sourceNodes = new Map();
	    this.sourceNodeOptions = new Map();
	    this.dragStartSourceIds = null;
	    this.dropTargetIds = [];
	    this.dragEnterTargetIds = [];
	    this.currentNativeSource = null;
	    this.currentNativeHandle = null;
	    this.currentDragSourceNode = null;
	    this.altKeyPressed = false;
	    this.mouseMoveTimeoutTimer = null;
	    this.asyncEndDragFrameId = null;
	    this.dragOverTargetIds = null;
	
	    this.getSourceClientOffset = function (sourceId) {
	      return (0, _OffsetUtils.getNodeClientOffset)(_this.sourceNodes.get(sourceId));
	    };
	
	    this.endDragNativeItem = function () {
	      if (!_this.isDraggingNativeItem()) {
	        return;
	      }
	
	      _this.actions.endDrag();
	
	      _this.registry.removeSource(_this.currentNativeHandle);
	
	      _this.currentNativeHandle = null;
	      _this.currentNativeSource = null;
	    };
	
	    this.isNodeInDocument = function (node) {
	      // Check the node either in the main document or in the current context
	      return _this.document && _this.document.body && document.body.contains(node);
	    };
	
	    this.endDragIfSourceWasRemovedFromDOM = function () {
	      var node = _this.currentDragSourceNode;
	
	      if (_this.isNodeInDocument(node)) {
	        return;
	      }
	
	      if (_this.clearCurrentDragSourceNode()) {
	        _this.actions.endDrag();
	      }
	    };
	
	    this.handleTopDragStartCapture = function () {
	      _this.clearCurrentDragSourceNode();
	
	      _this.dragStartSourceIds = [];
	    };
	
	    this.handleTopDragStart = function (e) {
	      if (e.defaultPrevented) {
	        return;
	      }
	
	      var dragStartSourceIds = _this.dragStartSourceIds;
	      _this.dragStartSourceIds = null;
	      var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e); // Avoid crashing if we missed a drop event or our previous drag died
	
	      if (_this.monitor.isDragging()) {
	        _this.actions.endDrag();
	      } // Don't publish the source just yet (see why below)
	
	
	      _this.actions.beginDrag(dragStartSourceIds || [], {
	        publishSource: false,
	        getSourceClientOffset: _this.getSourceClientOffset,
	        clientOffset: clientOffset
	      });
	
	      var dataTransfer = e.dataTransfer;
	      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
	      if (_this.monitor.isDragging()) {
	        if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
	          // Use custom drag image if user specifies it.
	          // If child drag source refuses drag but parent agrees,
	          // use parent's node as drag image. Neither works in IE though.
	          var sourceId = _this.monitor.getSourceId();
	
	          var sourceNode = _this.sourceNodes.get(sourceId);
	
	          var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;
	
	          if (dragPreview) {
	            var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(),
	                anchorX = _this$getCurrentSourc.anchorX,
	                anchorY = _this$getCurrentSourc.anchorY,
	                offsetX = _this$getCurrentSourc.offsetX,
	                offsetY = _this$getCurrentSourc.offsetY;
	
	            var anchorPoint = {
	              anchorX: anchorX,
	              anchorY: anchorY
	            };
	            var offsetPoint = {
	              offsetX: offsetX,
	              offsetY: offsetY
	            };
	            var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
	            dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
	          }
	        }
	
	        try {
	          // Firefox won't drag without setting data
	          dataTransfer.setData('application/json', {});
	        } catch (err) {} // IE doesn't support MIME types in setData
	        // Store drag source node so we can check whether
	        // it is removed from DOM and trigger endDrag manually.
	
	
	        _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?
	
	
	        var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(),
	            captureDraggingState = _this$getCurrentSourc2.captureDraggingState;
	
	        if (!captureDraggingState) {
	          // Usually we want to publish it in the next tick so that browser
	          // is able to screenshot the current (not yet dragging) state.
	          //
	          // It also neatly avoids a situation where render() returns null
	          // in the same tick for the source element, and browser freaks out.
	          setTimeout(function () {
	            return _this.actions.publishDragSource();
	          }, 0);
	        } else {
	          // In some cases the user may want to override this behavior, e.g.
	          // to work around IE not supporting custom drag previews.
	          //
	          // When using a custom drag layer, the only way to prevent
	          // the default drag preview from drawing in IE is to screenshot
	          // the dragging state in which the node itself has zero opacity
	          // and height. In this case, though, returning null from render()
	          // will abruptly end the dragging, which is not obvious.
	          //
	          // This is the reason such behavior is strictly opt-in.
	          _this.actions.publishDragSource();
	        }
	      } else if (nativeType) {
	        // A native item (such as URL) dragged from inside the document
	        _this.beginDragNativeItem(nativeType);
	      } else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
	        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
	        // Just let it drag. It's a native type (URL or text) and will be picked up in
	        // dragenter handler.
	        return;
	      } else {
	        // If by this time no drag source reacted, tell browser not to drag.
	        e.preventDefault();
	      }
	    };
	
	    this.handleTopDragEndCapture = function () {
	      if (_this.clearCurrentDragSourceNode()) {
	        // Firefox can dispatch this event in an infinite loop
	        // if dragend handler does something like showing an alert.
	        // Only proceed if we have not handled it already.
	        _this.actions.endDrag();
	      }
	    };
	
	    this.handleTopDragEnterCapture = function (e) {
	      _this.dragEnterTargetIds = [];
	
	      var isFirstEnter = _this.enterLeaveCounter.enter(e.target);
	
	      if (!isFirstEnter || _this.monitor.isDragging()) {
	        return;
	      }
	
	      var dataTransfer = e.dataTransfer;
	      var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);
	
	      if (nativeType) {
	        // A native item (such as file or URL) dragged from outside the document
	        _this.beginDragNativeItem(nativeType, dataTransfer);
	      }
	    };
	
	    this.handleTopDragEnter = function (e) {
	      var dragEnterTargetIds = _this.dragEnterTargetIds;
	      _this.dragEnterTargetIds = [];
	
	      if (!_this.monitor.isDragging()) {
	        // This is probably a native item type we don't understand.
	        return;
	      }
	
	      _this.altKeyPressed = e.altKey;
	
	      if (!(0, _BrowserDetector.isFirefox)()) {
	        // Don't emit hover in `dragenter` on Firefox due to an edge case.
	        // If the target changes position as the result of `dragenter`, Firefox
	        // will still happily dispatch `dragover` despite target being no longer
	        // there. The easy solution is to only fire `hover` in `dragover` on FF.
	        _this.actions.hover(dragEnterTargetIds, {
	          clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
	        });
	      }
	
	      var canDrop = dragEnterTargetIds.some(function (targetId) {
	        return _this.monitor.canDropOnTarget(targetId);
	      });
	
	      if (canDrop) {
	        // IE requires this to fire dragover events
	        e.preventDefault();
	
	        if (e.dataTransfer) {
	          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
	        }
	      }
	    };
	
	    this.handleTopDragOverCapture = function () {
	      _this.dragOverTargetIds = [];
	    };
	
	    this.handleTopDragOver = function (e) {
	      var dragOverTargetIds = _this.dragOverTargetIds;
	      _this.dragOverTargetIds = [];
	
	      if (!_this.monitor.isDragging()) {
	        // This is probably a native item type we don't understand.
	        // Prevent default "drop and blow away the whole document" action.
	        e.preventDefault();
	
	        if (e.dataTransfer) {
	          e.dataTransfer.dropEffect = 'none';
	        }
	
	        return;
	      }
	
	      _this.altKeyPressed = e.altKey;
	
	      _this.actions.hover(dragOverTargetIds || [], {
	        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
	      });
	
	      var canDrop = (dragOverTargetIds || []).some(function (targetId) {
	        return _this.monitor.canDropOnTarget(targetId);
	      });
	
	      if (canDrop) {
	        // Show user-specified drop effect.
	        e.preventDefault();
	
	        if (e.dataTransfer) {
	          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
	        }
	      } else if (_this.isDraggingNativeItem()) {
	        // Don't show a nice cursor but still prevent default
	        // "drop and blow away the whole document" action.
	        e.preventDefault();
	      } else {
	        e.preventDefault();
	
	        if (e.dataTransfer) {
	          e.dataTransfer.dropEffect = 'none';
	        }
	      }
	    };
	
	    this.handleTopDragLeaveCapture = function (e) {
	      if (_this.isDraggingNativeItem()) {
	        e.preventDefault();
	      }
	
	      var isLastLeave = _this.enterLeaveCounter.leave(e.target);
	
	      if (!isLastLeave) {
	        return;
	      }
	
	      if (_this.isDraggingNativeItem()) {
	        _this.endDragNativeItem();
	      }
	    };
	
	    this.handleTopDropCapture = function (e) {
	      _this.dropTargetIds = [];
	      e.preventDefault();
	
	      if (_this.isDraggingNativeItem()) {
	        _this.currentNativeSource.loadDataTransfer(e.dataTransfer);
	      }
	
	      _this.enterLeaveCounter.reset();
	    };
	
	    this.handleTopDrop = function (e) {
	      var dropTargetIds = _this.dropTargetIds;
	      _this.dropTargetIds = [];
	
	      _this.actions.hover(dropTargetIds, {
	        clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
	      });
	
	      _this.actions.drop({
	        dropEffect: _this.getCurrentDropEffect()
	      });
	
	      if (_this.isDraggingNativeItem()) {
	        _this.endDragNativeItem();
	      } else {
	        _this.endDragIfSourceWasRemovedFromDOM();
	      }
	    };
	
	    this.handleSelectStart = function (e) {
	      var target = e.target; // Only IE requires us to explicitly say
	      // we want drag drop operation to start
	
	      if (typeof target.dragDrop !== 'function') {
	        return;
	      } // Inputs and textareas should be selectable
	
	
	      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
	        return;
	      } // For other targets, ask IE
	      // to enable drag and drop
	
	
	      e.preventDefault();
	      target.dragDrop();
	    };
	
	    this.options = new _OptionsReader.OptionsReader(globalContext);
	    this.actions = manager.getActions();
	    this.monitor = manager.getMonitor();
	    this.registry = manager.getRegistry();
	    this.enterLeaveCounter = new _EnterLeaveCounter.default(this.isNodeInDocument);
	  } // public for test
	
	
	  _createClass(HTML5Backend, [{
	    key: "setup",
	    value: function setup() {
	      if (this.window === undefined) {
	        return;
	      }
	
	      if (this.window.__isReactDndBackendSetUp) {
	        throw new Error('Cannot have two HTML5 backends at the same time.');
	      }
	
	      this.window.__isReactDndBackendSetUp = true;
	      this.addEventListeners(this.window);
	    }
	  }, {
	    key: "teardown",
	    value: function teardown() {
	      if (this.window === undefined) {
	        return;
	      }
	
	      this.window.__isReactDndBackendSetUp = false;
	      this.removeEventListeners(this.window);
	      this.clearCurrentDragSourceNode();
	
	      if (this.asyncEndDragFrameId) {
	        this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
	      }
	    }
	  }, {
	    key: "connectDragPreview",
	    value: function connectDragPreview(sourceId, node, options) {
	      var _this2 = this;
	
	      this.sourcePreviewNodeOptions.set(sourceId, options);
	      this.sourcePreviewNodes.set(sourceId, node);
	      return function () {
	        _this2.sourcePreviewNodes.delete(sourceId);
	
	        _this2.sourcePreviewNodeOptions.delete(sourceId);
	      };
	    }
	  }, {
	    key: "connectDragSource",
	    value: function connectDragSource(sourceId, node, options) {
	      var _this3 = this;
	
	      this.sourceNodes.set(sourceId, node);
	      this.sourceNodeOptions.set(sourceId, options);
	
	      var handleDragStart = function handleDragStart(e) {
	        return _this3.handleDragStart(e, sourceId);
	      };
	
	      var handleSelectStart = function handleSelectStart(e) {
	        return _this3.handleSelectStart(e);
	      };
	
	      node.setAttribute('draggable', 'true');
	      node.addEventListener('dragstart', handleDragStart);
	      node.addEventListener('selectstart', handleSelectStart);
	      return function () {
	        _this3.sourceNodes.delete(sourceId);
	
	        _this3.sourceNodeOptions.delete(sourceId);
	
	        node.removeEventListener('dragstart', handleDragStart);
	        node.removeEventListener('selectstart', handleSelectStart);
	        node.setAttribute('draggable', 'false');
	      };
	    }
	  }, {
	    key: "connectDropTarget",
	    value: function connectDropTarget(targetId, node) {
	      var _this4 = this;
	
	      var handleDragEnter = function handleDragEnter(e) {
	        return _this4.handleDragEnter(e, targetId);
	      };
	
	      var handleDragOver = function handleDragOver(e) {
	        return _this4.handleDragOver(e, targetId);
	      };
	
	      var handleDrop = function handleDrop(e) {
	        return _this4.handleDrop(e, targetId);
	      };
	
	      node.addEventListener('dragenter', handleDragEnter);
	      node.addEventListener('dragover', handleDragOver);
	      node.addEventListener('drop', handleDrop);
	      return function () {
	        node.removeEventListener('dragenter', handleDragEnter);
	        node.removeEventListener('dragover', handleDragOver);
	        node.removeEventListener('drop', handleDrop);
	      };
	    }
	  }, {
	    key: "addEventListeners",
	    value: function addEventListeners(target) {
	      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
	      if (!target.addEventListener) {
	        return;
	      }
	
	      target.addEventListener('dragstart', this.handleTopDragStart);
	      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
	      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
	      target.addEventListener('dragenter', this.handleTopDragEnter);
	      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
	      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	      target.addEventListener('dragover', this.handleTopDragOver);
	      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
	      target.addEventListener('drop', this.handleTopDrop);
	      target.addEventListener('drop', this.handleTopDropCapture, true);
	    }
	  }, {
	    key: "removeEventListeners",
	    value: function removeEventListeners(target) {
	      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
	      if (!target.removeEventListener) {
	        return;
	      }
	
	      target.removeEventListener('dragstart', this.handleTopDragStart);
	      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
	      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
	      target.removeEventListener('dragenter', this.handleTopDragEnter);
	      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
	      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	      target.removeEventListener('dragover', this.handleTopDragOver);
	      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
	      target.removeEventListener('drop', this.handleTopDrop);
	      target.removeEventListener('drop', this.handleTopDropCapture, true);
	    }
	  }, {
	    key: "getCurrentSourceNodeOptions",
	    value: function getCurrentSourceNodeOptions() {
	      var sourceId = this.monitor.getSourceId();
	      var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
	      return _objectSpread({
	        dropEffect: this.altKeyPressed ? 'copy' : 'move'
	      }, sourceNodeOptions || {});
	    }
	  }, {
	    key: "getCurrentDropEffect",
	    value: function getCurrentDropEffect() {
	      if (this.isDraggingNativeItem()) {
	        // It makes more sense to default to 'copy' for native resources
	        return 'copy';
	      }
	
	      return this.getCurrentSourceNodeOptions().dropEffect;
	    }
	  }, {
	    key: "getCurrentSourcePreviewNodeOptions",
	    value: function getCurrentSourcePreviewNodeOptions() {
	      var sourceId = this.monitor.getSourceId();
	      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
	      return _objectSpread({
	        anchorX: 0.5,
	        anchorY: 0.5,
	        captureDraggingState: false
	      }, sourcePreviewNodeOptions || {});
	    }
	  }, {
	    key: "isDraggingNativeItem",
	    value: function isDraggingNativeItem() {
	      var itemType = this.monitor.getItemType();
	      return Object.keys(NativeTypes).some(function (key) {
	        return NativeTypes[key] === itemType;
	      });
	    }
	  }, {
	    key: "beginDragNativeItem",
	    value: function beginDragNativeItem(type, dataTransfer) {
	      this.clearCurrentDragSourceNode();
	      this.currentNativeSource = (0, _NativeDragSources.createNativeDragSource)(type, dataTransfer);
	      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
	      this.actions.beginDrag([this.currentNativeHandle]);
	    }
	  }, {
	    key: "setCurrentDragSourceNode",
	    value: function setCurrentDragSourceNode(node) {
	      var _this5 = this;
	
	      this.clearCurrentDragSourceNode();
	      this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
	      // See:
	      //   * https://github.com/react-dnd/react-dnd/pull/928
	      //   * https://github.com/react-dnd/react-dnd/issues/869
	
	      var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
	      // means it has ended and the drag source node disappeared from DOM,
	      // so the browser didn't dispatch the dragend event.
	      //
	      // We need to wait before we start listening for mousemove events.
	      // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
	      // immediately in some browsers.
	      //
	      // See:
	      //   * https://github.com/react-dnd/react-dnd/pull/928
	      //   * https://github.com/react-dnd/react-dnd/issues/869
	      //
	
	      this.mouseMoveTimeoutTimer = setTimeout(function () {
	        return _this5.window && _this5.window.addEventListener('mousemove', _this5.endDragIfSourceWasRemovedFromDOM, true);
	      }, MOUSE_MOVE_TIMEOUT);
	    }
	  }, {
	    key: "clearCurrentDragSourceNode",
	    value: function clearCurrentDragSourceNode() {
	      if (this.currentDragSourceNode) {
	        this.currentDragSourceNode = null;
	
	        if (this.window) {
	          this.window.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
	          this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
	        }
	
	        this.mouseMoveTimeoutTimer = null;
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "handleDragStart",
	    value: function handleDragStart(e, sourceId) {
	      if (e.defaultPrevented) {
	        return;
	      }
	
	      if (!this.dragStartSourceIds) {
	        this.dragStartSourceIds = [];
	      }
	
	      this.dragStartSourceIds.unshift(sourceId);
	    }
	  }, {
	    key: "handleDragEnter",
	    value: function handleDragEnter(e, targetId) {
	      this.dragEnterTargetIds.unshift(targetId);
	    }
	  }, {
	    key: "handleDragOver",
	    value: function handleDragOver(e, targetId) {
	      if (this.dragOverTargetIds === null) {
	        this.dragOverTargetIds = [];
	      }
	
	      this.dragOverTargetIds.unshift(targetId);
	    }
	  }, {
	    key: "handleDrop",
	    value: function handleDrop(e, targetId) {
	      this.dropTargetIds.unshift(targetId);
	    }
	  }, {
	    key: "window",
	    get: function get() {
	      return this.options.window;
	    }
	  }, {
	    key: "document",
	    get: function get() {
	      return this.options.document;
	    }
	  }]);
	
	  return HTML5Backend;
	}();
	
	exports.default = HTML5Backend;

/***/ }),
/* 6014 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var MonotonicInterpolant =
	/*#__PURE__*/
	function () {
	  function MonotonicInterpolant(xs, ys) {
	    _classCallCheck(this, MonotonicInterpolant);
	
	    var length = xs.length; // Rearrange xs and ys so that xs is sorted
	
	    var indexes = [];
	
	    for (var i = 0; i < length; i++) {
	      indexes.push(i);
	    }
	
	    indexes.sort(function (a, b) {
	      return xs[a] < xs[b] ? -1 : 1;
	    }); // Get consecutive differences and slopes
	
	    var dys = [];
	    var dxs = [];
	    var ms = [];
	    var dx;
	    var dy;
	
	    for (var _i = 0; _i < length - 1; _i++) {
	      dx = xs[_i + 1] - xs[_i];
	      dy = ys[_i + 1] - ys[_i];
	      dxs.push(dx);
	      dys.push(dy);
	      ms.push(dy / dx);
	    } // Get degree-1 coefficients
	
	
	    var c1s = [ms[0]];
	
	    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
	      var m2 = ms[_i2];
	      var mNext = ms[_i2 + 1];
	
	      if (m2 * mNext <= 0) {
	        c1s.push(0);
	      } else {
	        dx = dxs[_i2];
	        var dxNext = dxs[_i2 + 1];
	        var common = dx + dxNext;
	        c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
	      }
	    }
	
	    c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients
	
	    var c2s = [];
	    var c3s = [];
	    var m;
	
	    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
	      m = ms[_i3];
	      var c1 = c1s[_i3];
	      var invDx = 1 / dxs[_i3];
	
	      var _common = c1 + c1s[_i3 + 1] - m - m;
	
	      c2s.push((m - c1 - _common) * invDx);
	      c3s.push(_common * invDx * invDx);
	    }
	
	    this.xs = xs;
	    this.ys = ys;
	    this.c1s = c1s;
	    this.c2s = c2s;
	    this.c3s = c3s;
	  }
	
	  _createClass(MonotonicInterpolant, [{
	    key: "interpolate",
	    value: function interpolate(x) {
	      var xs = this.xs,
	          ys = this.ys,
	          c1s = this.c1s,
	          c2s = this.c2s,
	          c3s = this.c3s; // The rightmost point in the dataset should give an exact result
	
	      var i = xs.length - 1;
	
	      if (x === xs[i]) {
	        return ys[i];
	      } // Search for the interval x is in, returning the corresponding y if x is one of the original xs
	
	
	      var low = 0;
	      var high = c3s.length - 1;
	      var mid;
	
	      while (low <= high) {
	        mid = Math.floor(0.5 * (low + high));
	        var xHere = xs[mid];
	
	        if (xHere < x) {
	          low = mid + 1;
	        } else if (xHere > x) {
	          high = mid - 1;
	        } else {
	          return ys[mid];
	        }
	      }
	
	      i = Math.max(0, high); // Interpolate
	
	      var diff = x - xs[i];
	      var diffSq = diff * diff;
	      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
	    }
	  }]);
	
	  return MonotonicInterpolant;
	}();
	
	exports.default = MonotonicInterpolant;

/***/ }),
/* 6015 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NativeDragSource = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var NativeDragSource =
	/*#__PURE__*/
	function () {
	  function NativeDragSource(config) {
	    _classCallCheck(this, NativeDragSource);
	
	    this.config = config;
	    this.item = {};
	    this.initializeExposedProperties();
	  }
	
	  _createClass(NativeDragSource, [{
	    key: "initializeExposedProperties",
	    value: function initializeExposedProperties() {
	      var _this = this;
	
	      Object.keys(this.config.exposeProperties).forEach(function (property) {
	        Object.defineProperty(_this.item, property, {
	          configurable: true,
	          enumerable: true,
	          get: function get() {
	            // eslint-disable-next-line no-console
	            console.warn("Browser doesn't allow reading \"".concat(property, "\" until the drop event."));
	            return null;
	          }
	        });
	      });
	    }
	  }, {
	    key: "loadDataTransfer",
	    value: function loadDataTransfer(dataTransfer) {
	      var _this2 = this;
	
	      if (dataTransfer) {
	        var newProperties = {};
	        Object.keys(this.config.exposeProperties).forEach(function (property) {
	          newProperties[property] = {
	            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes),
	            configurable: true,
	            enumerable: true
	          };
	        });
	        Object.defineProperties(this.item, newProperties);
	      }
	    }
	  }, {
	    key: "canDrag",
	    value: function canDrag() {
	      return true;
	    }
	  }, {
	    key: "beginDrag",
	    value: function beginDrag() {
	      return this.item;
	    }
	  }, {
	    key: "isDragging",
	    value: function isDragging(monitor, handle) {
	      return handle === monitor.getSourceId();
	    }
	  }, {
	    key: "endDrag",
	    value: function endDrag() {// empty
	    }
	  }]);
	
	  return NativeDragSource;
	}();
	
	exports.NativeDragSource = NativeDragSource;

/***/ }),
/* 6016 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDataFromDataTransfer = getDataFromDataTransfer;
	
	function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
	  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
	    return resultSoFar || dataTransfer.getData(typeToTry);
	  }, '');
	  return result != null ? result : defaultValue;
	}

/***/ }),
/* 6017 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createNativeDragSource = createNativeDragSource;
	exports.matchNativeItemType = matchNativeItemType;
	
	var _nativeTypesConfig = __webpack_require__(6018);
	
	var _NativeDragSource = __webpack_require__(6015);
	
	function createNativeDragSource(type, dataTransfer) {
	  var result = new _NativeDragSource.NativeDragSource(_nativeTypesConfig.nativeTypesConfig[type]);
	  result.loadDataTransfer(dataTransfer);
	  return result;
	}
	
	function matchNativeItemType(dataTransfer) {
	  if (!dataTransfer) {
	    return null;
	  }
	
	  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	  return Object.keys(_nativeTypesConfig.nativeTypesConfig).filter(function (nativeItemType) {
	    var matchesTypes = _nativeTypesConfig.nativeTypesConfig[nativeItemType].matchesTypes;
	    return matchesTypes.some(function (t) {
	      return dataTransferTypes.indexOf(t) > -1;
	    });
	  })[0] || null;
	}

/***/ }),
/* 6018 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.nativeTypesConfig = void 0;
	
	var NativeTypes = _interopRequireWildcard(__webpack_require__(1602));
	
	var _getDataFromDataTransfer = __webpack_require__(6016);
	
	var _nativeTypesConfig;
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
	  exposeProperties: {
	    files: function files(dataTransfer) {
	      return Array.prototype.slice.call(dataTransfer.files);
	    },
	    items: function items(dataTransfer) {
	      return dataTransfer.items;
	    }
	  },
	  matchesTypes: ['Files']
	}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
	  exposeProperties: {
	    urls: function urls(dataTransfer, matchesTypes) {
	      return (0, _getDataFromDataTransfer.getDataFromDataTransfer)(dataTransfer, matchesTypes, '').split('\n');
	    }
	  },
	  matchesTypes: ['Url', 'text/uri-list']
	}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
	  exposeProperties: {
	    text: function text(dataTransfer, matchesTypes) {
	      return (0, _getDataFromDataTransfer.getDataFromDataTransfer)(dataTransfer, matchesTypes, '');
	    }
	  },
	  matchesTypes: ['Text', 'text/plain']
	}), _nativeTypesConfig);
	exports.nativeTypesConfig = nativeTypesConfig;

/***/ }),
/* 6019 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getNodeClientOffset = getNodeClientOffset;
	exports.getEventClientOffset = getEventClientOffset;
	exports.getDragPreviewOffset = getDragPreviewOffset;
	
	var _BrowserDetector = __webpack_require__(2731);
	
	var _MonotonicInterpolant = _interopRequireDefault(__webpack_require__(6014));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ELEMENT_NODE = 1;
	
	function getNodeClientOffset(node) {
	  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
	  if (!el) {
	    return null;
	  }
	
	  var _el$getBoundingClient = el.getBoundingClientRect(),
	      top = _el$getBoundingClient.top,
	      left = _el$getBoundingClient.left;
	
	  return {
	    x: left,
	    y: top
	  };
	}
	
	function getEventClientOffset(e) {
	  return {
	    x: e.clientX,
	    y: e.clientY
	  };
	}
	
	function isImageNode(node) {
	  return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
	}
	
	function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
	  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
	  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers
	
	  if ((0, _BrowserDetector.isSafari)() && isImage) {
	    dragPreviewHeight /= window.devicePixelRatio;
	    dragPreviewWidth /= window.devicePixelRatio;
	  }
	
	  return {
	    dragPreviewWidth: dragPreviewWidth,
	    dragPreviewHeight: dragPreviewHeight
	  };
	}
	
	function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
	  // The browsers will use the image intrinsic size under different conditions.
	  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
	  var isImage = isImageNode(dragPreview);
	  var dragPreviewNode = isImage ? sourceNode : dragPreview;
	  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
	  var offsetFromDragPreview = {
	    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
	    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
	  };
	  var sourceWidth = sourceNode.offsetWidth,
	      sourceHeight = sourceNode.offsetHeight;
	  var anchorX = anchorPoint.anchorX,
	      anchorY = anchorPoint.anchorY;
	
	  var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
	      dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
	      dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
	
	  var calculateYOffset = function calculateYOffset() {
	    var interpolantY = new _MonotonicInterpolant.default([0, 0.5, 1], [// Dock to the top
	    offsetFromDragPreview.y, // Align at the center
	    offsetFromDragPreview.y / sourceHeight * dragPreviewHeight, // Dock to the bottom
	    offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
	    var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug
	
	    if ((0, _BrowserDetector.isSafari)() && isImage) {
	      // We'll have to wait for @3x to see if this is entirely correct
	      y += (window.devicePixelRatio - 1) * dragPreviewHeight;
	    }
	
	    return y;
	  };
	
	  var calculateXOffset = function calculateXOffset() {
	    // Interpolate coordinates depending on anchor point
	    // If you know a simpler way to do this, let me know
	    var interpolantX = new _MonotonicInterpolant.default([0, 0.5, 1], [// Dock to the left
	    offsetFromDragPreview.x, // Align at the center
	    offsetFromDragPreview.x / sourceWidth * dragPreviewWidth, // Dock to the right
	    offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
	    return interpolantX.interpolate(anchorX);
	  }; // Force offsets if specified in the options.
	
	
	  var offsetX = offsetPoint.offsetX,
	      offsetY = offsetPoint.offsetY;
	  var isManualOffsetX = offsetX === 0 || offsetX;
	  var isManualOffsetY = offsetY === 0 || offsetY;
	  return {
	    x: isManualOffsetX ? offsetX : calculateXOffset(),
	    y: isManualOffsetY ? offsetY : calculateYOffset()
	  };
	}

/***/ }),
/* 6020 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptionsReader = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var OptionsReader =
	/*#__PURE__*/
	function () {
	  function OptionsReader(globalContext) {
	    _classCallCheck(this, OptionsReader);
	
	    this.globalContext = globalContext;
	  }
	
	  _createClass(OptionsReader, [{
	    key: "window",
	    get: function get() {
	      if (this.globalContext) {
	        return this.globalContext;
	      } else if (typeof window !== 'undefined') {
	        return window;
	      }
	
	      return undefined;
	    }
	  }, {
	    key: "document",
	    get: function get() {
	      if (this.window) {
	        return this.window.document;
	      }
	
	      return undefined;
	    }
	  }]);
	
	  return OptionsReader;
	}();
	
	exports.OptionsReader = OptionsReader;

/***/ }),
/* 6021 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEmptyImage = getEmptyImage;
	var emptyImage;
	
	function getEmptyImage() {
	  if (!emptyImage) {
	    emptyImage = new Image();
	    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	  }
	
	  return emptyImage;
	}

/***/ }),
/* 6022 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getEmptyImage", {
	  enumerable: true,
	  get: function get() {
	    return _getEmptyImage.getEmptyImage;
	  }
	});
	exports.NativeTypes = exports.default = void 0;
	
	var _HTML5Backend = _interopRequireDefault(__webpack_require__(6013));
	
	var NativeTypes = _interopRequireWildcard(__webpack_require__(1602));
	
	exports.NativeTypes = NativeTypes;
	
	var _getEmptyImage = __webpack_require__(6021);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createBackend = function createBackend(manager, context) {
	  return new _HTML5Backend.default(manager, context);
	};
	
	var _default = createBackend;
	exports.default = _default;

/***/ }),
/* 6023 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DndProvider = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _DndContext = __webpack_require__(1603);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var refCount = 0;
	/**
	 * A React component that provides the React-DnD context
	 */
	
	var DndProvider = (0, React.memo)(function (_ref) {
	  var children = _ref.children,
	      props = _objectWithoutProperties(_ref, ["children"]);
	
	  var _getDndContextValue = getDndContextValue(props),
	      _getDndContextValue2 = _slicedToArray(_getDndContextValue, 2),
	      manager = _getDndContextValue2[0],
	      isGlobalInstance = _getDndContextValue2[1]; // memoized from props
	
	  /**
	   * If the global context was used to store the DND context
	   * then where theres no more references to it we should
	   * clean it up to avoid memory leaks
	   */
	
	
	  React.useEffect(function () {
	    if (isGlobalInstance) {
	      refCount++;
	    }
	
	    return function () {
	      if (isGlobalInstance) {
	        refCount--;
	
	        if (refCount === 0) {
	          var context = getGlobalContext();
	          context[instanceSymbol] = null;
	        }
	      }
	    };
	  }, []);
	  return React.createElement(_DndContext.DndContext.Provider, {
	    value: manager
	  }, children);
	});
	exports.DndProvider = DndProvider;
	DndProvider.displayName = 'DndProvider';
	
	function getDndContextValue(props) {
	  if ('manager' in props) {
	    var _manager = {
	      dragDropManager: props.manager
	    };
	    return [_manager, false];
	  }
	
	  var manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
	  var isGlobalInstance = !props.context;
	  return [manager, isGlobalInstance];
	}
	
	var instanceSymbol = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
	
	function createSingletonDndContext(backend) {
	  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlobalContext();
	  var options = arguments.length > 2 ? arguments[2] : undefined;
	  var debugMode = arguments.length > 3 ? arguments[3] : undefined;
	  var ctx = context;
	
	  if (!ctx[instanceSymbol]) {
	    ctx[instanceSymbol] = (0, _DndContext.createDndContext)(backend, context, options, debugMode);
	  }
	
	  return ctx[instanceSymbol];
	}
	
	function getGlobalContext() {
	  return typeof global !== 'undefined' ? global : window;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6024 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DragPreviewImage = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	/*
	 * A utility for rendering a drag preview image
	 */
	var DragPreviewImage = React.memo(function (_ref) {
	  var connect = _ref.connect,
	      src = _ref.src;
	
	  if (typeof Image !== 'undefined') {
	    var img = new Image();
	    img.src = src;
	
	    img.onload = function () {
	      return connect(img);
	    };
	  }
	
	  return null;
	});
	exports.DragPreviewImage = DragPreviewImage;
	DragPreviewImage.displayName = 'DragPreviewImage';

/***/ }),
/* 6025 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DndContext = __webpack_require__(1603);
	
	Object.keys(_DndContext).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DndContext[key];
	    }
	  });
	});
	
	var _DndProvider = __webpack_require__(6023);
	
	Object.keys(_DndProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DndProvider[key];
	    }
	  });
	});
	
	var _DragPreviewImage = __webpack_require__(6024);
	
	Object.keys(_DragPreviewImage).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DragPreviewImage[key];
	    }
	  });
	});

/***/ }),
/* 6026 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DragLayer = DragLayer;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _shallowequal = __webpack_require__(599);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(963));
	
	var _invariant = __webpack_require__(129);
	
	var _index = __webpack_require__(1020);
	
	var _js_utils = __webpack_require__(476);
	
	var _utils = __webpack_require__(584);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function DragLayer(collect) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (0, _utils.checkDecoratorArguments)('DragLayer', 'collect[, options]', collect, options);
	  (0, _invariant.invariant)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', collect);
	  (0, _invariant.invariant)((0, _js_utils.isPlainObject)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-layer', options);
	  return function decorateLayer(DecoratedComponent) {
	    var Decorated = DecoratedComponent;
	    var _options$arePropsEqua = options.arePropsEqual,
	        arePropsEqual = _options$arePropsEqua === void 0 ? _shallowequal.shallowEqual : _options$arePropsEqua;
	    var displayName = Decorated.displayName || Decorated.name || 'Component';
	
	    var DragLayerContainer =
	    /*#__PURE__*/
	    function (_React$Component) {
	      _inherits(DragLayerContainer, _React$Component);
	
	      function DragLayerContainer() {
	        var _this;
	
	        _classCallCheck(this, DragLayerContainer);
	
	        _this = _possibleConstructorReturn(this, _getPrototypeOf(DragLayerContainer).apply(this, arguments));
	        _this.isCurrentlyMounted = false;
	        _this.ref = React.createRef();
	
	        _this.handleChange = function () {
	          if (!_this.isCurrentlyMounted) {
	            return;
	          }
	
	          var nextState = _this.getCurrentState();
	
	          if (!(0, _shallowequal.shallowEqual)(nextState, _this.state)) {
	            _this.setState(nextState);
	          }
	        };
	
	        return _this;
	      }
	
	      _createClass(DragLayerContainer, [{
	        key: "getDecoratedComponentInstance",
	        value: function getDecoratedComponentInstance() {
	          (0, _invariant.invariant)(this.ref.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
	          return this.ref.current;
	        }
	      }, {
	        key: "shouldComponentUpdate",
	        value: function shouldComponentUpdate(nextProps, nextState) {
	          return !arePropsEqual(nextProps, this.props) || !(0, _shallowequal.shallowEqual)(nextState, this.state);
	        }
	      }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          this.isCurrentlyMounted = true;
	          this.handleChange();
	        }
	      }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          this.isCurrentlyMounted = false;
	
	          if (this.unsubscribeFromOffsetChange) {
	            this.unsubscribeFromOffsetChange();
	            this.unsubscribeFromOffsetChange = undefined;
	          }
	
	          if (this.unsubscribeFromStateChange) {
	            this.unsubscribeFromStateChange();
	            this.unsubscribeFromStateChange = undefined;
	          }
	        }
	      }, {
	        key: "render",
	        value: function render() {
	          var _this2 = this;
	
	          return React.createElement(_index.DndContext.Consumer, null, function (_ref) {
	            var dragDropManager = _ref.dragDropManager;
	
	            if (dragDropManager === undefined) {
	              return null;
	            }
	
	            _this2.receiveDragDropManager(dragDropManager); // Let componentDidMount fire to initialize the collected state
	
	
	            if (!_this2.isCurrentlyMounted) {
	              return null;
	            }
	
	            return React.createElement(Decorated, Object.assign({}, _this2.props, _this2.state, {
	              ref: (0, _utils.isRefable)(Decorated) ? _this2.ref : null
	            }));
	          });
	        }
	      }, {
	        key: "receiveDragDropManager",
	        value: function receiveDragDropManager(dragDropManager) {
	          if (this.manager !== undefined) {
	            return;
	          }
	
	          this.manager = dragDropManager;
	          (0, _invariant.invariant)(_typeof(dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to render a DndProvider component in your top-level component. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/troubleshooting#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	          var monitor = this.manager.getMonitor();
	          this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
	          this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);
	        }
	      }, {
	        key: "getCurrentState",
	        value: function getCurrentState() {
	          if (!this.manager) {
	            return {};
	          }
	
	          var monitor = this.manager.getMonitor();
	          return collect(monitor, this.props);
	        }
	      }]);
	
	      return DragLayerContainer;
	    }(React.Component);
	
	    DragLayerContainer.displayName = "DragLayer(".concat(displayName, ")");
	    DragLayerContainer.DecoratedComponent = DecoratedComponent;
	    return (0, _hoistNonReactStatics.default)(DragLayerContainer, DecoratedComponent);
	  };
	}

/***/ }),
/* 6027 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DragSource = DragSource;
	
	var _invariant = __webpack_require__(129);
	
	var _js_utils = __webpack_require__(476);
	
	var _utils = __webpack_require__(584);
	
	var _decorateHandler = _interopRequireDefault(__webpack_require__(2738));
	
	var _registration = __webpack_require__(1019);
	
	var _DragSourceMonitorImpl = __webpack_require__(2733);
	
	var _SourceConnector = __webpack_require__(2735);
	
	var _isValidType = __webpack_require__(2742);
	
	var _createSourceFactory = _interopRequireDefault(__webpack_require__(6029));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Decorates a component as a dragsource
	 * @param type The dragsource type
	 * @param spec The drag source specification
	 * @param collect The props collector function
	 * @param options DnD options
	 */
	function DragSource(type, spec, collect) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  (0, _utils.checkDecoratorArguments)('DragSource', 'type, spec, collect[, options]', type, spec, collect, options);
	  var getType = type;
	
	  if (typeof type !== 'function') {
	    (0, _invariant.invariant)((0, _isValidType.isValidType)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', type);
	
	    getType = function getType() {
	      return type;
	    };
	  }
	
	  (0, _invariant.invariant)((0, _js_utils.isPlainObject)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', spec);
	  var createSource = (0, _createSourceFactory.default)(spec);
	  (0, _invariant.invariant)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
	  (0, _invariant.invariant)((0, _js_utils.isPlainObject)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', collect);
	  return function decorateSource(DecoratedComponent) {
	    return (0, _decorateHandler.default)({
	      containerDisplayName: 'DragSource',
	      createHandler: createSource,
	      registerHandler: _registration.registerSource,
	      createConnector: function createConnector(backend) {
	        return new _SourceConnector.SourceConnector(backend);
	      },
	      createMonitor: function createMonitor(manager) {
	        return new _DragSourceMonitorImpl.DragSourceMonitorImpl(manager);
	      },
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}

/***/ }),
/* 6028 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropTarget = DropTarget;
	
	var _invariant = __webpack_require__(129);
	
	var _js_utils = __webpack_require__(476);
	
	var _registration = __webpack_require__(1019);
	
	var _isValidType = __webpack_require__(2742);
	
	var _TargetConnector = __webpack_require__(2736);
	
	var _DropTargetMonitorImpl = __webpack_require__(2734);
	
	var _utils = __webpack_require__(584);
	
	var _decorateHandler = _interopRequireDefault(__webpack_require__(2738));
	
	var _createTargetFactory = _interopRequireDefault(__webpack_require__(6030));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DropTarget(type, spec, collect) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  (0, _utils.checkDecoratorArguments)('DropTarget', 'type, spec, collect[, options]', type, spec, collect, options);
	  var getType = type;
	
	  if (typeof type !== 'function') {
	    (0, _invariant.invariant)((0, _isValidType.isValidType)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', type);
	
	    getType = function getType() {
	      return type;
	    };
	  }
	
	  (0, _invariant.invariant)((0, _js_utils.isPlainObject)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', spec);
	  var createTarget = (0, _createTargetFactory.default)(spec);
	  (0, _invariant.invariant)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
	  (0, _invariant.invariant)((0, _js_utils.isPlainObject)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', collect);
	  return function decorateTarget(DecoratedComponent) {
	    return (0, _decorateHandler.default)({
	      containerDisplayName: 'DropTarget',
	      createHandler: createTarget,
	      registerHandler: _registration.registerTarget,
	      createMonitor: function createMonitor(manager) {
	        return new _DropTargetMonitorImpl.DropTargetMonitorImpl(manager);
	      },
	      createConnector: function createConnector(backend) {
	        return new _TargetConnector.TargetConnector(backend);
	      },
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}

/***/ }),
/* 6029 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSourceFactory;
	
	var _invariant = __webpack_require__(129);
	
	var _js_utils = __webpack_require__(476);
	
	var _utils = __webpack_require__(584);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
	var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
	var SourceImpl =
	/*#__PURE__*/
	function () {
	  function SourceImpl(spec, monitor, ref) {
	    var _this = this;
	
	    _classCallCheck(this, SourceImpl);
	
	    this.props = null;
	
	    this.beginDrag = function () {
	      if (!_this.props) {
	        return;
	      }
	
	      var item = _this.spec.beginDrag(_this.props, _this.monitor, _this.ref.current);
	
	      if (false) {
	        (0, _invariant.invariant)((0, _js_utils.isPlainObject)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', item);
	      }
	
	      return item;
	    };
	
	    this.spec = spec;
	    this.monitor = monitor;
	    this.ref = ref;
	  }
	
	  _createClass(SourceImpl, [{
	    key: "receiveProps",
	    value: function receiveProps(props) {
	      this.props = props;
	    }
	  }, {
	    key: "canDrag",
	    value: function canDrag() {
	      if (!this.props) {
	        return false;
	      }
	
	      if (!this.spec.canDrag) {
	        return true;
	      }
	
	      return this.spec.canDrag(this.props, this.monitor);
	    }
	  }, {
	    key: "isDragging",
	    value: function isDragging(globalMonitor, sourceId) {
	      if (!this.props) {
	        return false;
	      }
	
	      if (!this.spec.isDragging) {
	        return sourceId === globalMonitor.getSourceId();
	      }
	
	      return this.spec.isDragging(this.props, this.monitor);
	    }
	  }, {
	    key: "endDrag",
	    value: function endDrag() {
	      if (!this.props) {
	        return;
	      }
	
	      if (!this.spec.endDrag) {
	        return;
	      }
	
	      this.spec.endDrag(this.props, this.monitor, (0, _utils.getDecoratedComponent)(this.ref));
	    }
	  }]);
	
	  return SourceImpl;
	}();
	
	function createSourceFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    (0, _invariant.invariant)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', ALLOWED_SPEC_METHODS.join(', '), key);
	    (0, _invariant.invariant)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
	  });
	  REQUIRED_SPEC_METHODS.forEach(function (key) {
	    (0, _invariant.invariant)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source', key, key, spec[key]);
	  });
	  return function createSource(monitor, ref) {
	    return new SourceImpl(spec, monitor, ref);
	  };
	}

/***/ }),
/* 6030 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTargetFactory;
	
	var _invariant = __webpack_require__(129);
	
	var _js_utils = __webpack_require__(476);
	
	var _utils = __webpack_require__(584);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
	var TargetImpl =
	/*#__PURE__*/
	function () {
	  function TargetImpl(spec, monitor, ref) {
	    _classCallCheck(this, TargetImpl);
	
	    this.props = null;
	    this.spec = spec;
	    this.monitor = monitor;
	    this.ref = ref;
	  }
	
	  _createClass(TargetImpl, [{
	    key: "receiveProps",
	    value: function receiveProps(props) {
	      this.props = props;
	    }
	  }, {
	    key: "receiveMonitor",
	    value: function receiveMonitor(monitor) {
	      this.monitor = monitor;
	    }
	  }, {
	    key: "canDrop",
	    value: function canDrop() {
	      if (!this.spec.canDrop) {
	        return true;
	      }
	
	      return this.spec.canDrop(this.props, this.monitor);
	    }
	  }, {
	    key: "hover",
	    value: function hover() {
	      if (!this.spec.hover) {
	        return;
	      }
	
	      this.spec.hover(this.props, this.monitor, (0, _utils.getDecoratedComponent)(this.ref));
	    }
	  }, {
	    key: "drop",
	    value: function drop() {
	      if (!this.spec.drop) {
	        return undefined;
	      }
	
	      var dropResult = this.spec.drop(this.props, this.monitor, this.ref.current);
	
	      if (false) {
	        (0, _invariant.invariant)(typeof dropResult === 'undefined' || (0, _js_utils.isPlainObject)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', dropResult);
	      }
	
	      return dropResult;
	    }
	  }]);
	
	  return TargetImpl;
	}();
	
	function createTargetFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    (0, _invariant.invariant)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', ALLOWED_SPEC_METHODS.join(', '), key);
	    (0, _invariant.invariant)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target', key, key, spec[key]);
	  });
	  return function createTarget(monitor, ref) {
	    return new TargetImpl(spec, monitor, ref);
	  };
	}

/***/ }),
/* 6031 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SerialDisposable = exports.CompositeDisposable = exports.Disposable = void 0;
	
	var _js_utils = __webpack_require__(476);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	/**
	 * Provides a set of static methods for creating Disposables.
	 * @param {Function} action Action to run during the first call to dispose.
	 * The action is guaranteed to be run at most once.
	 */
	var Disposable =
	/*#__PURE__*/
	function () {
	  function Disposable(action) {
	    _classCallCheck(this, Disposable);
	
	    this.isDisposed = false;
	    this.action = (0, _js_utils.isFunction)(action) ? action : _js_utils.noop;
	  }
	  /**
	   * Validates whether the given object is a disposable
	   * @param {Object} Object to test whether it has a dispose method
	   * @returns {Boolean} true if a disposable object, else false.
	   */
	
	
	  _createClass(Disposable, [{
	    key: "dispose",
	
	    /** Performs the task of cleaning up resources. */
	    value: function dispose() {
	      if (!this.isDisposed) {
	        this.action();
	        this.isDisposed = true;
	      }
	    }
	  }], [{
	    key: "isDisposable",
	    value: function isDisposable(d) {
	      return d && (0, _js_utils.isFunction)(d.dispose);
	    }
	  }, {
	    key: "_fixup",
	    value: function _fixup(result) {
	      return Disposable.isDisposable(result) ? result : Disposable.empty;
	    }
	    /**
	     * Creates a disposable object that invokes the specified action when disposed.
	     * @param {Function} dispose Action to run during the first call to dispose.
	     * The action is guaranteed to be run at most once.
	     * @return {Disposable} The disposable object that runs the given action upon disposal.
	     */
	
	  }, {
	    key: "create",
	    value: function create(action) {
	      return new Disposable(action);
	    }
	  }]);
	
	  return Disposable;
	}();
	/**
	 * Gets the disposable that does nothing when disposed.
	 */
	
	
	exports.Disposable = Disposable;
	Disposable.empty = {
	  dispose: _js_utils.noop
	};
	/**
	 * Represents a group of disposable resources that are disposed together.
	 * @constructor
	 */
	
	var CompositeDisposable =
	/*#__PURE__*/
	function () {
	  function CompositeDisposable() {
	    _classCallCheck(this, CompositeDisposable);
	
	    this.isDisposed = false;
	
	    for (var _len = arguments.length, disposables = new Array(_len), _key = 0; _key < _len; _key++) {
	      disposables[_key] = arguments[_key];
	    }
	
	    this.disposables = disposables;
	  }
	  /**
	   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
	   * @param {Any} item Disposable to add.
	   */
	
	
	  _createClass(CompositeDisposable, [{
	    key: "add",
	    value: function add(item) {
	      if (this.isDisposed) {
	        item.dispose();
	      } else {
	        this.disposables.push(item);
	      }
	    }
	    /**
	     * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
	     * @param {Any} item Disposable to remove.
	     * @returns {Boolean} true if found; false otherwise.
	     */
	
	  }, {
	    key: "remove",
	    value: function remove(item) {
	      var shouldDispose = false;
	
	      if (!this.isDisposed) {
	        var idx = this.disposables.indexOf(item);
	
	        if (idx !== -1) {
	          shouldDispose = true;
	          this.disposables.splice(idx, 1);
	          item.dispose();
	        }
	      }
	
	      return shouldDispose;
	    }
	    /**
	     *  Disposes all disposables in the group and removes them from the group but
	     *  does not dispose the CompositeDisposable.
	     */
	
	  }, {
	    key: "clear",
	    value: function clear() {
	      if (!this.isDisposed) {
	        var len = this.disposables.length;
	        var currentDisposables = new Array(len);
	
	        for (var i = 0; i < len; i++) {
	          currentDisposables[i] = this.disposables[i];
	        }
	
	        this.disposables = [];
	
	        for (var _i = 0; _i < len; _i++) {
	          currentDisposables[_i].dispose();
	        }
	      }
	    }
	    /**
	     *  Disposes all disposables in the group and removes them from the group.
	     */
	
	  }, {
	    key: "dispose",
	    value: function dispose() {
	      if (!this.isDisposed) {
	        this.isDisposed = true;
	        var len = this.disposables.length;
	        var currentDisposables = new Array(len);
	
	        for (var i = 0; i < len; i++) {
	          currentDisposables[i] = this.disposables[i];
	        }
	
	        this.disposables = [];
	
	        for (var _i2 = 0; _i2 < len; _i2++) {
	          currentDisposables[_i2].dispose();
	        }
	      }
	    }
	  }]);
	
	  return CompositeDisposable;
	}();
	/**
	 * Represents a disposable resource whose underlying disposable resource can
	 * be replaced by another disposable resource, causing automatic disposal of
	 * the previous underlying disposable resource.
	 */
	
	
	exports.CompositeDisposable = CompositeDisposable;
	
	var SerialDisposable =
	/*#__PURE__*/
	function () {
	  function SerialDisposable() {
	    _classCallCheck(this, SerialDisposable);
	
	    this.isDisposed = false;
	  }
	  /**
	   * Gets the underlying disposable.
	   * @returns {Any} the underlying disposable.
	   */
	
	
	  _createClass(SerialDisposable, [{
	    key: "getDisposable",
	    value: function getDisposable() {
	      return this.current;
	    }
	  }, {
	    key: "setDisposable",
	    value: function setDisposable(value) {
	      var shouldDispose = this.isDisposed;
	
	      if (!shouldDispose) {
	        var old = this.current;
	        this.current = value;
	
	        if (old) {
	          old.dispose();
	        }
	      }
	
	      if (shouldDispose && value) {
	        value.dispose();
	      }
	    }
	    /** Performs the task of cleaning up resources. */
	
	  }, {
	    key: "dispose",
	    value: function dispose() {
	      if (!this.isDisposed) {
	        this.isDisposed = true;
	        var old = this.current;
	        this.current = undefined;
	
	        if (old) {
	          old.dispose();
	        }
	      }
	    }
	  }]);
	
	  return SerialDisposable;
	}();
	
	exports.SerialDisposable = SerialDisposable;

/***/ }),
/* 6032 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DragSource = __webpack_require__(6027);
	
	Object.keys(_DragSource).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DragSource[key];
	    }
	  });
	});
	
	var _DropTarget = __webpack_require__(6028);
	
	Object.keys(_DropTarget).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DropTarget[key];
	    }
	  });
	});
	
	var _DragLayer = __webpack_require__(6026);
	
	Object.keys(_DragLayer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DragLayer[key];
	    }
	  });
	});

/***/ }),
/* 6033 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _useDrag = __webpack_require__(6036);
	
	Object.keys(_useDrag).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useDrag[key];
	    }
	  });
	});
	
	var _useDrop = __webpack_require__(6038);
	
	Object.keys(_useDrop).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useDrop[key];
	    }
	  });
	});
	
	var _useDragLayer = __webpack_require__(6037);
	
	Object.keys(_useDragLayer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useDragLayer[key];
	    }
	  });
	});

/***/ }),
/* 6034 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useDragSourceMonitor = useDragSourceMonitor;
	exports.useDragHandler = useDragHandler;
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(129);
	
	var _registration = __webpack_require__(1019);
	
	var _useDragDropManager = __webpack_require__(1604);
	
	var _DragSourceMonitorImpl = __webpack_require__(2733);
	
	var _SourceConnector = __webpack_require__(2735);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(585);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function useDragSourceMonitor() {
	  var manager = (0, _useDragDropManager.useDragDropManager)();
	  var monitor = (0, _react.useMemo)(function () {
	    return new _DragSourceMonitorImpl.DragSourceMonitorImpl(manager);
	  }, [manager]);
	  var connector = (0, _react.useMemo)(function () {
	    return new _SourceConnector.SourceConnector(manager.getBackend());
	  }, [manager]);
	  return [monitor, connector];
	}
	
	function useDragHandler(spec, monitor, connector) {
	  var manager = (0, _useDragDropManager.useDragDropManager)();
	  var handler = (0, _react.useMemo)(function () {
	    return {
	      beginDrag: function beginDrag() {
	        var _spec$current = spec.current,
	            begin = _spec$current.begin,
	            item = _spec$current.item;
	
	        if (begin) {
	          var beginResult = begin(monitor);
	          (0, _invariant.invariant)(beginResult == null || _typeof(beginResult) === 'object', 'dragSpec.begin() must either return an object, undefined, or null');
	          return beginResult || item || {};
	        }
	
	        return item || {};
	      },
	      canDrag: function canDrag() {
	        if (typeof spec.current.canDrag === 'boolean') {
	          return spec.current.canDrag;
	        } else if (typeof spec.current.canDrag === 'function') {
	          return spec.current.canDrag(monitor);
	        } else {
	          return true;
	        }
	      },
	      isDragging: function isDragging(globalMonitor, target) {
	        var isDragging = spec.current.isDragging;
	        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
	      },
	      endDrag: function endDrag() {
	        var end = spec.current.end;
	
	        if (end) {
	          end(monitor.getItem(), monitor);
	        }
	
	        connector.reconnect();
	      }
	    };
	  }, []);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function registerHandler() {
	    var _registerSource = (0, _registration.registerSource)(spec.current.item.type, handler, manager),
	        _registerSource2 = _slicedToArray(_registerSource, 2),
	        handlerId = _registerSource2[0],
	        unregister = _registerSource2[1];
	
	    monitor.receiveHandlerId(handlerId);
	    connector.receiveHandlerId(handlerId);
	    return unregister;
	  }, []);
	}

/***/ }),
/* 6035 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useDropTargetMonitor = useDropTargetMonitor;
	exports.useDropHandler = useDropHandler;
	
	var _react = __webpack_require__(1);
	
	var _registration = __webpack_require__(1019);
	
	var _useDragDropManager = __webpack_require__(1604);
	
	var _TargetConnector = __webpack_require__(2736);
	
	var _DropTargetMonitorImpl = __webpack_require__(2734);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(585);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function useDropTargetMonitor() {
	  var manager = (0, _useDragDropManager.useDragDropManager)();
	  var monitor = (0, _react.useMemo)(function () {
	    return new _DropTargetMonitorImpl.DropTargetMonitorImpl(manager);
	  }, [manager]);
	  var connector = (0, _react.useMemo)(function () {
	    return new _TargetConnector.TargetConnector(manager.getBackend());
	  }, [manager]);
	  return [monitor, connector];
	}
	
	function useDropHandler(spec, monitor, connector) {
	  var manager = (0, _useDragDropManager.useDragDropManager)();
	  var handler = (0, _react.useMemo)(function () {
	    return {
	      canDrop: function canDrop() {
	        var canDrop = spec.current.canDrop;
	        return canDrop ? canDrop(monitor.getItem(), monitor) : true;
	      },
	      hover: function hover() {
	        var hover = spec.current.hover;
	
	        if (hover) {
	          hover(monitor.getItem(), monitor);
	        }
	      },
	      drop: function drop() {
	        var drop = spec.current.drop;
	
	        if (drop) {
	          return drop(monitor.getItem(), monitor);
	        }
	      }
	    };
	  }, [monitor]);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function registerHandler() {
	    var _registerTarget = (0, _registration.registerTarget)(spec.current.accept, handler, manager),
	        _registerTarget2 = _slicedToArray(_registerTarget, 2),
	        handlerId = _registerTarget2[0],
	        unregister = _registerTarget2[1];
	
	    monitor.receiveHandlerId(handlerId);
	    connector.receiveHandlerId(handlerId);
	    return unregister;
	  }, [monitor, connector]);
	}

/***/ }),
/* 6036 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useDrag = useDrag;
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(129);
	
	var _useMonitorOutput = __webpack_require__(2740);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(585);
	
	var _drag = __webpack_require__(6034);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	/**
	 * useDragSource hook
	 * @param sourceSpec The drag source specification *
	 */
	function useDrag(spec) {
	  var specRef = (0, _react.useRef)(spec);
	  specRef.current = spec; // TODO: wire options into createSourceConnector
	
	  (0, _invariant.invariant)(spec.item != null, 'item must be defined');
	  (0, _invariant.invariant)(spec.item.type != null, 'item type must be defined');
	
	  var _useDragSourceMonitor = (0, _drag.useDragSourceMonitor)(),
	      _useDragSourceMonitor2 = _slicedToArray(_useDragSourceMonitor, 2),
	      monitor = _useDragSourceMonitor2[0],
	      connector = _useDragSourceMonitor2[1];
	
	  (0, _drag.useDragHandler)(specRef, monitor, connector);
	  var result = (0, _useMonitorOutput.useMonitorOutput)(monitor, specRef.current.collect || function () {
	    return {};
	  }, function () {
	    return connector.reconnect();
	  });
	  var connectDragSource = (0, _react.useMemo)(function () {
	    return connector.hooks.dragSource();
	  }, [connector]);
	  var connectDragPreview = (0, _react.useMemo)(function () {
	    return connector.hooks.dragPreview();
	  }, [connector]);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    connector.dragSourceOptions = specRef.current.options || null;
	    connector.reconnect();
	  }, [connector]);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    connector.dragPreviewOptions = specRef.current.previewOptions || null;
	    connector.reconnect();
	  }, [connector]);
	  return [result, connectDragSource, connectDragPreview];
	}

/***/ }),
/* 6037 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useDragLayer = useDragLayer;
	
	var _react = __webpack_require__(1);
	
	var _useDragDropManager = __webpack_require__(1604);
	
	var _useCollector3 = __webpack_require__(2739);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	/**
	 * useDragLayer Hook
	 * @param collector The property collector
	 */
	function useDragLayer(collect) {
	  var dragDropManager = (0, _useDragDropManager.useDragDropManager)();
	  var monitor = dragDropManager.getMonitor();
	
	  var _useCollector = (0, _useCollector3.useCollector)(monitor, collect),
	      _useCollector2 = _slicedToArray(_useCollector, 2),
	      collected = _useCollector2[0],
	      updateCollected = _useCollector2[1];
	
	  (0, _react.useEffect)(function () {
	    return monitor.subscribeToOffsetChange(updateCollected);
	  });
	  (0, _react.useEffect)(function () {
	    return monitor.subscribeToStateChange(updateCollected);
	  });
	  return collected;
	}

/***/ }),
/* 6038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useDrop = useDrop;
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(129);
	
	var _useMonitorOutput = __webpack_require__(2740);
	
	var _useIsomorphicLayoutEffect = __webpack_require__(585);
	
	var _drop = __webpack_require__(6035);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	/**
	 * useDropTarget Hook
	 * @param spec The drop target specification
	 */
	function useDrop(spec) {
	  var specRef = (0, _react.useRef)(spec);
	  specRef.current = spec;
	  (0, _invariant.invariant)(spec.accept != null, 'accept must be defined');
	
	  var _useDropTargetMonitor = (0, _drop.useDropTargetMonitor)(),
	      _useDropTargetMonitor2 = _slicedToArray(_useDropTargetMonitor, 2),
	      monitor = _useDropTargetMonitor2[0],
	      connector = _useDropTargetMonitor2[1];
	
	  (0, _drop.useDropHandler)(specRef, monitor, connector);
	  var result = (0, _useMonitorOutput.useMonitorOutput)(monitor, specRef.current.collect || function () {
	    return {};
	  }, function () {
	    return connector.reconnect();
	  });
	  var connectDropTarget = (0, _react.useMemo)(function () {
	    return connector.hooks.dropTarget();
	  }, [connector]);
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    connector.dropTargetOptions = spec.options || null;
	    connector.reconnect();
	  }, [spec.options]);
	  return [result, connectDropTarget];
	}

/***/ }),
/* 6039 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cloneWithRef = cloneWithRef;
	
	var _react = __webpack_require__(1);
	
	var _invariant = __webpack_require__(129);
	
	function setRef(ref, node) {
	  if (typeof ref === 'function') {
	    ref(node);
	  } else {
	    ref.current = node;
	  }
	}
	
	function cloneWithRef(element, newRef) {
	  var previousRef = element.ref;
	  (0, _invariant.invariant)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
	  if (!previousRef) {
	    // When there is no ref on the element, use the new ref directly
	    return (0, _react.cloneElement)(element, {
	      ref: newRef
	    });
	  } else {
	    return (0, _react.cloneElement)(element, {
	      ref: function ref(node) {
	        setRef(previousRef, node);
	        setRef(newRef, node);
	      }
	    });
	  }
	}

/***/ }),
/* 6040 */,
/* 6041 */,
/* 6042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = undefined;
	
	var _defineProperty = __webpack_require__(551);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defineProperty(object, property, attr) {
	  return (0, _defineProperty2.default)(object, property, attr);
	}
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, defineProperty({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (err) {
	      //
	    }
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();
	
	exports.default = {};

/***/ }),
/* 6043 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.BicyclingLayer = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.BicyclingLayer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
	   */
	  function BicyclingLayer(props, context) {
	    ;(0, _classCallCheck3.default)(this, BicyclingLayer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (
	        BicyclingLayer.__proto__ ||
	        (0, _getPrototypeOf2.default)(BicyclingLayer)
	      ).call(this, props, context)
	    )
	
	    var bicyclingLayer = new google.maps.BicyclingLayer()
	    ;(0, _MapChildHelper.construct)(
	      BicyclingLayer.propTypes,
	      updaterMap,
	      _this.props,
	      bicyclingLayer
	    )
	    bicyclingLayer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.BICYCLING_LAYER,
	      bicyclingLayer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(BicyclingLayer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.BICYCLING_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.BICYCLING_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
	        if (bicyclingLayer) {
	          bicyclingLayer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	    },
	  ])
	  return BicyclingLayer
	})(_react2.default.PureComponent))
	
	BicyclingLayer.propTypes = {}
	BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = BicyclingLayer
	
	var eventMap = {}
	
	var updaterMap = {}


/***/ }),
/* 6044 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Circle = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Circle`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var Circle = (exports.Circle = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Circle, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
	   */
	  function Circle(props, context) {
	    ;(0, _classCallCheck3.default)(this, Circle)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Circle.__proto__ || (0, _getPrototypeOf2.default)(Circle)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var circle = new google.maps.Circle()
	    ;(0, _MapChildHelper.construct)(
	      Circle.propTypes,
	      updaterMap,
	      _this.props,
	      circle
	    )
	    circle.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)({}, _constants.CIRCLE, circle)
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Circle, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.CIRCLE],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.CIRCLE],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var circle = this.state[_constants.CIRCLE]
	        if (circle) {
	          circle.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	       * Gets the `LatLngBounds` of this Circle.
	       * @type LatLngBoundsLatLngBounds
	       * @public
	       */
	    },
	    {
	      key: "getBounds",
	      value: function getBounds() {
	        return this.state[_constants.CIRCLE].getBounds()
	      },
	
	      /**
	       * Returns the center of this circle.
	       * @type LatLng
	       * @public
	       */
	    },
	    {
	      key: "getCenter",
	      value: function getCenter() {
	        return this.state[_constants.CIRCLE].getCenter()
	      },
	
	      /**
	       * Returns whether this circle can be dragged by the user.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.CIRCLE].getDraggable()
	      },
	
	      /**
	       * Returns whether this circle can be edited by the user.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getEditable",
	      value: function getEditable() {
	        return this.state[_constants.CIRCLE].getEditable()
	      },
	
	      /**
	       * Returns the radius of this circle (in meters).
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getRadius",
	      value: function getRadius() {
	        return this.state[_constants.CIRCLE].getRadius()
	      },
	
	      /**
	       * Returns whether this circle is visible on the map.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.CIRCLE].getVisible()
	      },
	    },
	  ])
	  return Circle
	})(_react2.default.PureComponent))
	
	Circle.propTypes = {
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultCenter: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  defaultEditable: _propTypes2.default.bool,
	
	  /**
	   * @type CircleOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultRadius: _propTypes2.default.number,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  center: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  editable: _propTypes2.default.bool,
	
	  /**
	   * @type CircleOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  radius: _propTypes2.default.number,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onCenterChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRadiusChanged: _propTypes2.default.func,
	}
	Circle.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = Circle
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onCenterChanged: "center_changed",
	  onClick: "click",
	  onDrag: "drag",
	  onRadiusChanged: "radius_changed",
	}
	
	var updaterMap = {
	  center: function center(instance, _center) {
	    instance.setCenter(_center)
	  },
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  editable: function editable(instance, _editable) {
	    instance.setEditable(_editable)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  radius: function radius(instance, _radius) {
	    instance.setRadius(_radius)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	}


/***/ }),
/* 6045 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.DirectionsRenderer = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.DirectionsRenderer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var DirectionsRenderer = (exports.DirectionsRenderer = (function(
	  _React$PureComponent
	) {
	  ;(0, _inherits3.default)(DirectionsRenderer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
	   */
	  function DirectionsRenderer(props, context) {
	    ;(0, _classCallCheck3.default)(this, DirectionsRenderer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (
	        DirectionsRenderer.__proto__ ||
	        (0, _getPrototypeOf2.default)(DirectionsRenderer)
	      ).call(this, props, context)
	    )
	
	    var directionsRenderer = new google.maps.DirectionsRenderer()
	    ;(0, _MapChildHelper.construct)(
	      DirectionsRenderer.propTypes,
	      updaterMap,
	      _this.props,
	      directionsRenderer
	    )
	    directionsRenderer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.DIRECTIONS_RENDERER,
	      directionsRenderer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(DirectionsRenderer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.DIRECTIONS_RENDERER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.DIRECTIONS_RENDERER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var directionsRenderer = this.state[_constants.DIRECTIONS_RENDERER]
	        if (directionsRenderer) {
	          directionsRenderer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	       * Returns the renderer's current set of directions.
	       * @type DirectionsResult
	       * @public
	       */
	    },
	    {
	      key: "getDirections",
	      value: function getDirections() {
	        return this.state[_constants.DIRECTIONS_RENDERER].getDirections()
	      },
	
	      /**
	       * Returns the panel `<div>` in which the `DirectionsResult` is rendered.
	       * @type Node<div>DirectionsResult
	       * @public
	       */
	    },
	    {
	      key: "getPanel",
	      value: function getPanel() {
	        return this.state[_constants.DIRECTIONS_RENDERER].getPanel()
	      },
	
	      /**
	       * Returns the current (zero-based) route index in use by this `DirectionsRenderer` object.
	       * @type numberDirectionsRenderer
	       * @public
	       */
	    },
	    {
	      key: "getRouteIndex",
	      value: function getRouteIndex() {
	        return this.state[_constants.DIRECTIONS_RENDERER].getRouteIndex()
	      },
	    },
	  ])
	  return DirectionsRenderer
	})(_react2.default.PureComponent))
	
	DirectionsRenderer.propTypes = {
	  /**
	   * @type DirectionsResult
	   */
	  defaultDirections: _propTypes2.default.any,
	
	  /**
	   * @type DirectionsRendererOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type Node
	   */
	  defaultPanel: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultRouteIndex: _propTypes2.default.number,
	
	  /**
	   * @type DirectionsResult
	   */
	  directions: _propTypes2.default.any,
	
	  /**
	   * @type DirectionsRendererOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type Node
	   */
	  panel: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  routeIndex: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDirectionsChanged: _propTypes2.default.func,
	}
	DirectionsRenderer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = DirectionsRenderer
	
	var eventMap = {
	  onDirectionsChanged: "directions_changed",
	}
	
	var updaterMap = {
	  directions: function directions(instance, _directions) {
	    instance.setDirections(_directions)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  panel: function panel(instance, _panel) {
	    instance.setPanel(_panel)
	  },
	  routeIndex: function routeIndex(instance, _routeIndex) {
	    instance.setRouteIndex(_routeIndex)
	  },
	}


/***/ }),
/* 6046 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.FusionTablesLayer = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.FusionTablesLayer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var FusionTablesLayer = (exports.FusionTablesLayer = (function(
	  _React$PureComponent
	) {
	  ;(0, _inherits3.default)(FusionTablesLayer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
	   */
	  function FusionTablesLayer(props, context) {
	    ;(0, _classCallCheck3.default)(this, FusionTablesLayer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (
	        FusionTablesLayer.__proto__ ||
	        (0, _getPrototypeOf2.default)(FusionTablesLayer)
	      ).call(this, props, context)
	    )
	
	    var fusionTablesLayer = new google.maps.FusionTablesLayer()
	    ;(0, _MapChildHelper.construct)(
	      FusionTablesLayer.propTypes,
	      updaterMap,
	      _this.props,
	      fusionTablesLayer
	    )
	    fusionTablesLayer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.FUSION_TABLES_LAYER,
	      fusionTablesLayer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(FusionTablesLayer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.FUSION_TABLES_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.FUSION_TABLES_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var fusionTablesLayer = this.state[_constants.FUSION_TABLES_LAYER]
	        if (fusionTablesLayer) {
	          fusionTablesLayer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	    },
	  ])
	  return FusionTablesLayer
	})(_react2.default.PureComponent))
	
	FusionTablesLayer.propTypes = {
	  /**
	   * @type FusionTablesLayerOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type FusionTablesLayerOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	}
	FusionTablesLayer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = FusionTablesLayer
	
	var eventMap = {
	  onClick: "click",
	}
	
	var updaterMap = {
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	}


/***/ }),
/* 6047 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.GoogleMap = exports.Map = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _toConsumableArray2 = __webpack_require__(36)
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _invariant = __webpack_require__(586)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Map`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	 */
	var Map = (exports.Map = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Map, _React$PureComponent)
	  ;(0, _createClass3.default)(Map, [
	    {
	      key: "fitBounds",
	
	      /**
	       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	       * @public
	       */
	      value: function fitBounds() {
	        var _context$MAP
	
	        return (_context$MAP = this.context[_constants.MAP]).fitBounds.apply(
	          _context$MAP,
	          arguments
	        )
	      },
	
	      /**
	       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	       * @public
	       */
	    },
	    {
	      key: "panBy",
	      value: function panBy() {
	        var _context$MAP2
	
	        return (_context$MAP2 = this.context[_constants.MAP]).panBy.apply(
	          _context$MAP2,
	          arguments
	        )
	      },
	
	      /**
	       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	       * @public
	       */
	    },
	    {
	      key: "panTo",
	      value: function panTo() {
	        var _context$MAP3
	
	        return (_context$MAP3 = this.context[_constants.MAP]).panTo.apply(
	          _context$MAP3,
	          arguments
	        )
	      },
	
	      /**
	       * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	       * @public
	       */
	    },
	    {
	      key: "panToBounds",
	      value: function panToBounds() {
	        var _context$MAP4
	
	        return (_context$MAP4 = this.context[_constants.MAP]).panToBounds.apply(
	          _context$MAP4,
	          arguments
	        )
	      },
	
	      /*
	     * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	     */
	    },
	  ])
	
	  function Map(props, context) {
	    ;(0, _classCallCheck3.default)(this, Map)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Map.__proto__ || (0, _getPrototypeOf2.default)(Map)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    ;(0, _invariant2.default)(
	      !!_this.context[_constants.MAP],
	      "Did you wrap <GoogleMap> component with withGoogleMap() HOC?"
	    )
	    ;(0, _MapChildHelper.construct)(
	      GoogleMap.propTypes,
	      updaterMap,
	      _this.props,
	      _this.context[_constants.MAP]
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Map, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.context[_constants.MAP],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.context[_constants.MAP],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        var children = this.props.children
	
	        return _react2.default.createElement("div", null, children)
	      },
	
	      /**
	       * Returns the lat/lng bounds of the current viewport. If more than one copy of the world is visible, the bounds range in longitude from -180 to 180 degrees inclusive. If the map is not yet initialized (i.e. the mapType is still null), or center and zoom have not been set then the result is `null` or `undefined`.
	       * @type LatLngBoundsnullundefined
	       * @public
	       */
	    },
	    {
	      key: "getBounds",
	      value: function getBounds() {
	        return this.context[_constants.MAP].getBounds()
	      },
	
	      /**
	       * Returns the position displayed at the center of the map. Note that this `LatLng` object is _not_ wrapped. See `[LatLng](#LatLng)` for more information.
	       * @type LatLngLatLngLatLng
	       * @public
	       */
	    },
	    {
	      key: "getCenter",
	      value: function getCenter() {
	        return this.context[_constants.MAP].getCenter()
	      },
	
	      /**
	       * Returns the clickability of the map icons. A map icon represents a point of interest, also known as a POI. If the returned value is true, then the icons are clickable on the map.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getClickableIcons",
	      value: function getClickableIcons() {
	        return this.context[_constants.MAP].getClickableIcons()
	      },
	
	      /**
	       *
	       * @type Element
	       * @public
	       */
	    },
	    {
	      key: "getDiv",
	      value: function getDiv() {
	        return this.context[_constants.MAP].getDiv()
	      },
	
	      /**
	       * Returns the compass heading of aerial imagery. The heading value is measured in degrees (clockwise) from cardinal direction North.
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getHeading",
	      value: function getHeading() {
	        return this.context[_constants.MAP].getHeading()
	      },
	
	      /**
	       *
	       * @type MapTypeId|string
	       * @public
	       */
	    },
	    {
	      key: "getMapTypeId",
	      value: function getMapTypeId() {
	        return this.context[_constants.MAP].getMapTypeId()
	      },
	
	      /**
	       * Returns the current `Projection`. If the map is not yet initialized (i.e. the mapType is still null) then the result is null. Listen to `projection_changed` and check its value to ensure it is not null.
	       * @type ProjectionProjectionprojection_changed
	       * @public
	       */
	    },
	    {
	      key: "getProjection",
	      value: function getProjection() {
	        return this.context[_constants.MAP].getProjection()
	      },
	
	      /**
	       * Returns the default `StreetViewPanorama` bound to the map, which may be a default panorama embedded within the map, or the panorama set using `setStreetView()`. Changes to the map's `streetViewControl` will be reflected in the display of such a bound panorama.
	       * @type StreetViewPanoramaStreetViewPanoramasetStreetView()streetViewControl
	       * @public
	       */
	    },
	    {
	      key: "getStreetView",
	      value: function getStreetView() {
	        return this.context[_constants.MAP].getStreetView()
	      },
	
	      /**
	       * Returns the current angle of incidence of the map, in degrees from the viewport plane to the map plane. The result will be `0` for imagery taken directly overhead or `45` for 45° imagery. 45° imagery is only available for `satellite` and `hybrid` map types, within some locations, and at some zoom levels. **Note:** This method does not return the value set by `setTilt`. See `setTilt` for details.
	       * @type number045satellitehybridsetTiltsetTilt
	       * @public
	       */
	    },
	    {
	      key: "getTilt",
	      value: function getTilt() {
	        return this.context[_constants.MAP].getTilt()
	      },
	
	      /**
	       *
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getZoom",
	      value: function getZoom() {
	        return this.context[_constants.MAP].getZoom()
	      },
	    },
	  ])
	  return Map
	})(
	  _react2.default.PureComponent
	)) /*
	                                   * -----------------------------------------------------------------------------
	                                   * This file is auto-generated from the corresponding file at `src/macros/`.
	                                   * Please **DO NOT** edit this file directly when creating PRs.
	                                   * -----------------------------------------------------------------------------
	                                   */
	
	Map.displayName = "GoogleMap"
	Map.propTypes = {
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapTypeRegistry
	   * @type Array<[id:string, mapType:MapType|*]>
	   */
	  defaultExtraMapTypes: _propTypes2.default.arrayOf(
	    _propTypes2.default.arrayOf(_propTypes2.default.any)
	  ),
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultCenter: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultClickableIcons: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  defaultHeading: _propTypes2.default.number,
	
	  /**
	   * @type MapTypeId|string
	   */
	  defaultMapTypeId: _propTypes2.default.any,
	
	  /**
	   * @type MapOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type StreetViewPanorama
	   */
	  defaultStreetView: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultTilt: _propTypes2.default.number,
	
	  /**
	   * @type number
	   */
	  defaultZoom: _propTypes2.default.number,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  center: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  clickableIcons: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  heading: _propTypes2.default.number,
	
	  /**
	   * @type MapTypeId|string
	   */
	  mapTypeId: _propTypes2.default.any,
	
	  /**
	   * @type MapOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type StreetViewPanorama
	   */
	  streetView: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  tilt: _propTypes2.default.number,
	
	  /**
	   * @type number
	   */
	  zoom: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMapTypeIdChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onTilesLoaded: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onBoundsChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onCenterChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onHeadingChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onIdle: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onProjectionChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onResize: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onTiltChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onZoomChanged: _propTypes2.default.func,
	}
	Map.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	var GoogleMap = (exports.GoogleMap = Map)
	
	exports.default = Map
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMapTypeIdChanged: "maptypeid_changed",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onRightClick: "rightclick",
	  onTilesLoaded: "tilesloaded",
	  onBoundsChanged: "bounds_changed",
	  onCenterChanged: "center_changed",
	  onClick: "click",
	  onDrag: "drag",
	  onHeadingChanged: "heading_changed",
	  onIdle: "idle",
	  onProjectionChanged: "projection_changed",
	  onResize: "resize",
	  onTiltChanged: "tilt_changed",
	  onZoomChanged: "zoom_changed",
	}
	
	var updaterMap = {
	  extraMapTypes: function extraMapTypes(instance, extra) {
	    extra.forEach(function(it) {
	      var _instance$mapTypes
	
	      return (_instance$mapTypes = instance.mapTypes).set.apply(
	        _instance$mapTypes,
	        (0, _toConsumableArray3.default)(it)
	      )
	    })
	  },
	  center: function center(instance, _center) {
	    instance.setCenter(_center)
	  },
	  clickableIcons: function clickableIcons(instance, _clickableIcons) {
	    instance.setClickableIcons(_clickableIcons)
	  },
	  heading: function heading(instance, _heading) {
	    instance.setHeading(_heading)
	  },
	  mapTypeId: function mapTypeId(instance, _mapTypeId) {
	    instance.setMapTypeId(_mapTypeId)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  streetView: function streetView(instance, _streetView) {
	    instance.setStreetView(_streetView)
	  },
	  tilt: function tilt(instance, _tilt) {
	    instance.setTilt(_tilt)
	  },
	  zoom: function zoom(instance, _zoom) {
	    instance.setZoom(_zoom)
	  },
	}


/***/ }),
/* 6048 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.GroundOverlay = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _warning = __webpack_require__(74)
	
	var _warning2 = _interopRequireDefault(_warning)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.GroundOverlay`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
	 */
	var GroundOverlay = (exports.GroundOverlay = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(GroundOverlay, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#GroundOverlay
	   */
	  function GroundOverlay(props, context) {
	    ;(0, _classCallCheck3.default)(this, GroundOverlay)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (
	        GroundOverlay.__proto__ || (0, _getPrototypeOf2.default)(GroundOverlay)
	      ).call(this, props, context)
	    )
	
	    ;(0, _warning2.default)(
	      !props.url || !props.bounds,
	      "\nFor GroundOveray, url and bounds are passed in to constructor and are immutable\n after iinstantiated. This is the behavior of Google Maps JavaScript API v3 (\n See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay)\n Hence, use the corresponding two props provided by `react-google-maps`.\n They're prefixed with _default_ (defaultUrl, defaultBounds).\n\n In some cases, you'll need the GroundOverlay component to reflect the changes\n of url and bounds. You can leverage the React's key property to remount the\n component. Typically, just `key={url}` would serve your need.\n See https://github.com/tomchentw/react-google-maps/issues/655\n"
	    )
	    var groundOverlay = new google.maps.GroundOverlay(
	      props.defaultUrl || props.url,
	      props.defaultBounds || props.bounds
	    )
	    ;(0, _MapChildHelper.construct)(
	      GroundOverlay.propTypes,
	      updaterMap,
	      _this.props,
	      groundOverlay
	    )
	    groundOverlay.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.GROUND_LAYER,
	      groundOverlay
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(GroundOverlay, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.GROUND_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.GROUND_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var GroundOverlay = this.state[_constants.GROUND_LAYER]
	        if (GroundOverlay) {
	          GroundOverlay.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	       * Gets the `LatLngBounds` of this overlay.
	       * @type LatLngBoundsLatLngBounds
	       * @public
	       */
	    },
	    {
	      key: "getBounds",
	      value: function getBounds() {
	        return this.state[_constants.GROUND_LAYER].getBounds()
	      },
	
	      /**
	       * Returns the opacity of this ground overlay.
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getOpacity",
	      value: function getOpacity() {
	        return this.state[_constants.GROUND_LAYER].getOpacity()
	      },
	
	      /**
	       * Gets the url of the projected image.
	       * @type string
	       * @public
	       */
	    },
	    {
	      key: "getUrl",
	      value: function getUrl() {
	        return this.state[_constants.GROUND_LAYER].getUrl()
	      },
	    },
	  ])
	  return GroundOverlay
	})(
	  _react2.default.PureComponent
	)) /*
	                                   * -----------------------------------------------------------------------------
	                                   * This file is auto-generated from the corresponding file at `src/macros/`.
	                                   * Please **DO NOT** edit this file directly when creating PRs.
	                                   * -----------------------------------------------------------------------------
	                                   */
	/* global google */
	
	GroundOverlay.propTypes = {
	  /**
	   * @type string
	   */
	  defaultUrl: _propTypes2.default.string /* v10.0.0 .isRequired */ /**
	   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
	   */,
	
	  defaultBounds: _propTypes2.default.object /* v10.0.0 .isRequired */ /**
	   * @type string
	   * @deprecated use `defaultUrl` instead. It will be removed in v10.0.0
	   */,
	
	  url: _propTypes2.default.string,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay
	   * @deprecated use `defaultBounds` instead. It will be removed in v10.0.0
	   */
	  bounds: _propTypes2.default.object,
	
	  /**
	   * @type number
	   */
	  defaultOpacity: _propTypes2.default.number,
	
	  /**
	   * @type number
	   */
	  opacity: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	}
	GroundOverlay.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = GroundOverlay
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onClick: "click",
	}
	
	var updaterMap = {
	  opacity: function opacity(instance, _opacity) {
	    instance.setOpacity(_opacity)
	  },
	}


/***/ }),
/* 6049 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.InfoWindow = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _InfoWindow$contextTy /*
	                            * -----------------------------------------------------------------------------
	                            * This file is auto-generated from the corresponding file at `src/macros/`.
	                            * Please **DO NOT** edit this file directly when creating PRs.
	                            * -----------------------------------------------------------------------------
	                            */
	/* global google */
	
	var _invariant = __webpack_require__(586)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _canUseDom = __webpack_require__(1976)
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _reactDom = __webpack_require__(71)
	
	var _reactDom2 = _interopRequireDefault(_reactDom)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.InfoWindow`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	 */
	var InfoWindow = (exports.InfoWindow = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(InfoWindow, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
	   */
	  function InfoWindow(props, context) {
	    ;(0, _classCallCheck3.default)(this, InfoWindow)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (InfoWindow.__proto__ || (0, _getPrototypeOf2.default)(InfoWindow)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var infoWindow = new google.maps.InfoWindow()
	    ;(0, _MapChildHelper.construct)(
	      InfoWindow.propTypes,
	      updaterMap,
	      _this.props,
	      infoWindow
	    )
	    infoWindow.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.INFO_WINDOW,
	      infoWindow
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(InfoWindow, [
	    {
	      key: "componentWillMount",
	      value: function componentWillMount() {
	        if (!_canUseDom2.default || this.containerElement) {
	          return
	        }
	        if (_react2.default.version.match(/^16/)) {
	          this.containerElement = document.createElement("div")
	        }
	      },
	    },
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.INFO_WINDOW],
	          eventMap
	        )
	        if (_react2.default.version.match(/^16/)) {
	          this.state[_constants.INFO_WINDOW].setContent(this.containerElement)
	          open(
	            this.state[_constants.INFO_WINDOW],
	            this.context[_constants.ANCHOR]
	          )
	          return
	        }
	        var content = document.createElement("div")
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(
	          this,
	          _react2.default.Children.only(this.props.children),
	          content
	        )
	        this.state[_constants.INFO_WINDOW].setContent(content)
	        open(
	          this.state[_constants.INFO_WINDOW],
	          this.context[_constants.ANCHOR]
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.INFO_WINDOW],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	        if (_react2.default.version.match(/^16/)) {
	          return
	        }
	        if (this.props.children !== prevProps.children) {
	          _reactDom2.default.unstable_renderSubtreeIntoContainer(
	            this,
	            _react2.default.Children.only(this.props.children),
	            this.state[_constants.INFO_WINDOW].getContent()
	          )
	        }
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var infoWindow = this.state[_constants.INFO_WINDOW]
	        if (infoWindow) {
	          if (
	            !_react2.default.version.match(/^16/) &&
	            infoWindow.getContent()
	          ) {
	            _reactDom2.default.unmountComponentAtNode(infoWindow.getContent())
	          }
	          infoWindow.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        if (_react2.default.version.match(/^16/)) {
	          return _reactDom2.default.createPortal(
	            _react2.default.Children.only(this.props.children),
	            this.containerElement
	          )
	        }
	        return false
	      },
	
	      /**
	       *
	       * @type LatLng
	       * @public
	       */
	    },
	    {
	      key: "getPosition",
	      value: function getPosition() {
	        return this.state[_constants.INFO_WINDOW].getPosition()
	      },
	
	      /**
	       *
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getZIndex",
	      value: function getZIndex() {
	        return this.state[_constants.INFO_WINDOW].getZIndex()
	      },
	    },
	  ])
	  return InfoWindow
	})(_react2.default.PureComponent))
	
	InfoWindow.propTypes = {
	  /**
	   * @type InfoWindowOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultPosition: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultZIndex: _propTypes2.default.number,
	
	  /**
	   * @type InfoWindowOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  position: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  zIndex: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onCloseClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDomReady: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onContentChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPositionChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onZindexChanged: _propTypes2.default.func,
	}
	InfoWindow.contextTypes = ((_InfoWindow$contextTy = {}),
	(0, _defineProperty3.default)(
	  _InfoWindow$contextTy,
	  _constants.MAP,
	  _propTypes2.default.object
	),
	(0, _defineProperty3.default)(
	  _InfoWindow$contextTy,
	  _constants.ANCHOR,
	  _propTypes2.default.object
	),
	_InfoWindow$contextTy)
	exports.default = InfoWindow
	
	var open = function open(infoWindow, anchor) {
	  if (anchor) {
	    infoWindow.open(infoWindow.getMap(), anchor)
	  } else if (infoWindow.getPosition()) {
	    infoWindow.open(infoWindow.getMap())
	  } else {
	    ;(0, _invariant2.default)(
	      false,
	      "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>."
	    )
	  }
	}
	
	var eventMap = {
	  onCloseClick: "closeclick",
	  onDomReady: "domready",
	  onContentChanged: "content_changed",
	  onPositionChanged: "position_changed",
	  onZindexChanged: "zindex_changed",
	}
	
	var updaterMap = {
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  position: function position(instance, _position) {
	    instance.setPosition(_position)
	  },
	  zIndex: function zIndex(instance, _zIndex) {
	    instance.setZIndex(_zIndex)
	  },
	}


/***/ }),
/* 6050 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.KmlLayer = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.KmlLayer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var KmlLayer = (exports.KmlLayer = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(KmlLayer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
	   */
	  function KmlLayer(props, context) {
	    ;(0, _classCallCheck3.default)(this, KmlLayer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (KmlLayer.__proto__ || (0, _getPrototypeOf2.default)(KmlLayer)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var kmlLayer = new google.maps.KmlLayer()
	    ;(0, _MapChildHelper.construct)(
	      KmlLayer.propTypes,
	      updaterMap,
	      _this.props,
	      kmlLayer
	    )
	    kmlLayer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.KML_LAYER,
	      kmlLayer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(KmlLayer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.KML_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.KML_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var kmlLayer = this.state[_constants.KML_LAYER]
	        if (kmlLayer) {
	          kmlLayer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	       * Get the default viewport for the layer being displayed.
	       * @type LatLngBounds
	       * @public
	       */
	    },
	    {
	      key: "getDefaultViewport",
	      value: function getDefaultViewport() {
	        return this.state[_constants.KML_LAYER].getDefaultViewport()
	      },
	
	      /**
	       * Get the metadata associated with this layer, as specified in the layer markup.
	       * @type KmlLayerMetadata
	       * @public
	       */
	    },
	    {
	      key: "getMetadata",
	      value: function getMetadata() {
	        return this.state[_constants.KML_LAYER].getMetadata()
	      },
	
	      /**
	       * Get the status of the layer, set once the requested document has loaded.
	       * @type KmlLayerStatus
	       * @public
	       */
	    },
	    {
	      key: "getStatus",
	      value: function getStatus() {
	        return this.state[_constants.KML_LAYER].getStatus()
	      },
	
	      /**
	       * Gets the URL of the KML file being displayed.
	       * @type string
	       * @public
	       */
	    },
	    {
	      key: "getUrl",
	      value: function getUrl() {
	        return this.state[_constants.KML_LAYER].getUrl()
	      },
	
	      /**
	       * Gets the z-index of the KML Layer.
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getZIndex",
	      value: function getZIndex() {
	        return this.state[_constants.KML_LAYER].getZIndex()
	      },
	    },
	  ])
	  return KmlLayer
	})(_react2.default.PureComponent))
	
	KmlLayer.propTypes = {
	  /**
	   * @type KmlLayerOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  defaultUrl: _propTypes2.default.string,
	
	  /**
	   * @type number
	   */
	  defaultZIndex: _propTypes2.default.number,
	
	  /**
	   * @type KmlLayerOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  url: _propTypes2.default.string,
	
	  /**
	   * @type number
	   */
	  zIndex: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDefaultViewportChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onStatusChanged: _propTypes2.default.func,
	}
	KmlLayer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = KmlLayer
	
	var eventMap = {
	  onDefaultViewportChanged: "defaultviewport_changed",
	  onClick: "click",
	  onStatusChanged: "status_changed",
	}
	
	var updaterMap = {
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  url: function url(instance, _url) {
	    instance.setUrl(_url)
	  },
	  zIndex: function zIndex(instance, _zIndex) {
	    instance.setZIndex(_zIndex)
	  },
	}


/***/ }),
/* 6051 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Marker = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _Marker$contextTypes /*
	                           * -----------------------------------------------------------------------------
	                           * This file is auto-generated from the corresponding file at `src/macros/`.
	                           * Please **DO NOT** edit this file directly when creating PRs.
	                           * -----------------------------------------------------------------------------
	                           */
	/* global google */
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Marker`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	 */
	var Marker = (exports.Marker = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Marker, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
	   */
	  function Marker(props, context) {
	    ;(0, _classCallCheck3.default)(this, Marker)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Marker.__proto__ || (0, _getPrototypeOf2.default)(Marker)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var marker = new google.maps.Marker()
	    ;(0, _MapChildHelper.construct)(
	      Marker.propTypes,
	      updaterMap,
	      _this.props,
	      marker
	    )
	    var markerClusterer = _this.context[_constants.MARKER_CLUSTERER]
	    if (markerClusterer) {
	      markerClusterer.addMarker(marker, !!_this.props.noRedraw)
	    } else {
	      marker.setMap(_this.context[_constants.MAP])
	    }
	    _this.state = (0, _defineProperty3.default)({}, _constants.MARKER, marker)
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Marker, [
	    {
	      key: "getChildContext",
	      value: function getChildContext() {
	        return (0, _defineProperty3.default)(
	          {},
	          _constants.ANCHOR,
	          this.context[_constants.ANCHOR] || this.state[_constants.MARKER]
	        )
	      },
	    },
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.MARKER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.MARKER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var marker = this.state[_constants.MARKER]
	        if (marker) {
	          var markerClusterer = this.context[_constants.MARKER_CLUSTERER]
	          if (markerClusterer) {
	            markerClusterer.removeMarker(marker, !!this.props.noRedraw)
	          }
	          marker.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        var children = this.props.children
	
	        return _react2.default.createElement("div", null, children)
	      },
	
	      /**
	       *
	       * @type Animation
	       * @public
	       */
	    },
	    {
	      key: "getAnimation",
	      value: function getAnimation() {
	        return this.state[_constants.MARKER].getAnimation()
	      },
	
	      /**
	       *
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getClickable",
	      value: function getClickable() {
	        return this.state[_constants.MARKER].getClickable()
	      },
	
	      /**
	       *
	       * @type string
	       * @public
	       */
	    },
	    {
	      key: "getCursor",
	      value: function getCursor() {
	        return this.state[_constants.MARKER].getCursor()
	      },
	
	      /**
	       *
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.MARKER].getDraggable()
	      },
	
	      /**
	       *
	       * @type string|Icon|Symbol
	       * @public
	       */
	    },
	    {
	      key: "getIcon",
	      value: function getIcon() {
	        return this.state[_constants.MARKER].getIcon()
	      },
	
	      /**
	       *
	       * @type MarkerLabel
	       * @public
	       */
	    },
	    {
	      key: "getLabel",
	      value: function getLabel() {
	        return this.state[_constants.MARKER].getLabel()
	      },
	
	      /**
	       *
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getOpacity",
	      value: function getOpacity() {
	        return this.state[_constants.MARKER].getOpacity()
	      },
	
	      /**
	       *
	       * @type MarkerPlace
	       * @public
	       */
	    },
	    {
	      key: "getPlace",
	      value: function getPlace() {
	        return this.state[_constants.MARKER].getPlace()
	      },
	
	      /**
	       *
	       * @type LatLng
	       * @public
	       */
	    },
	    {
	      key: "getPosition",
	      value: function getPosition() {
	        return this.state[_constants.MARKER].getPosition()
	      },
	
	      /**
	       *
	       * @type MarkerShape
	       * @public
	       */
	    },
	    {
	      key: "getShape",
	      value: function getShape() {
	        return this.state[_constants.MARKER].getShape()
	      },
	
	      /**
	       *
	       * @type string
	       * @public
	       */
	    },
	    {
	      key: "getTitle",
	      value: function getTitle() {
	        return this.state[_constants.MARKER].getTitle()
	      },
	
	      /**
	       *
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.MARKER].getVisible()
	      },
	
	      /**
	       *
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getZIndex",
	      value: function getZIndex() {
	        return this.state[_constants.MARKER].getZIndex()
	      },
	    },
	  ])
	  return Marker
	})(_react2.default.PureComponent))
	
	Marker.propTypes = {
	  /**
	   * For the 2nd argument of `MarkerCluster#addMarker`
	   * @see https://github.com/mikesaidani/marker-clusterer-plus
	   */
	  noRedraw: _propTypes2.default.bool,
	
	  /**
	   * @type Animation
	   */
	  defaultAnimation: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultClickable: _propTypes2.default.bool,
	
	  /**
	   * @type string
	   */
	  defaultCursor: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type string|Icon|Symbol
	   */
	  defaultIcon: _propTypes2.default.any,
	
	  /**
	   * @type string|MarkerLabel
	   */
	  defaultLabel: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  defaultOpacity: _propTypes2.default.number,
	
	  /**
	   * @type MarkerOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type MarkerPlace
	   */
	  defaultPlace: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultPosition: _propTypes2.default.any,
	
	  /**
	   * @type MarkerShape
	   */
	  defaultShape: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  defaultTitle: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  defaultZIndex: _propTypes2.default.number,
	
	  /**
	   * @type Animation
	   */
	  animation: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  clickable: _propTypes2.default.bool,
	
	  /**
	   * @type string
	   */
	  cursor: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type string|Icon|Symbol
	   */
	  icon: _propTypes2.default.any,
	
	  /**
	   * @type string|MarkerLabel
	   */
	  label: _propTypes2.default.any,
	
	  /**
	   * @type number
	   */
	  opacity: _propTypes2.default.number,
	
	  /**
	   * @type MarkerOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type MarkerPlace
	   */
	  place: _propTypes2.default.any,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  position: _propTypes2.default.any,
	
	  /**
	   * @type MarkerShape
	   */
	  shape: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  title: _propTypes2.default.string,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  zIndex: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onAnimationChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClickableChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onCursorChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDraggableChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onFlatChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onIconChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPositionChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onShapeChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onTitleChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onVisibleChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onZindexChanged: _propTypes2.default.func,
	}
	Marker.contextTypes = ((_Marker$contextTypes = {}),
	(0, _defineProperty3.default)(
	  _Marker$contextTypes,
	  _constants.MAP,
	  _propTypes2.default.object
	),
	(0, _defineProperty3.default)(
	  _Marker$contextTypes,
	  _constants.MARKER_CLUSTERER,
	  _propTypes2.default.object
	),
	_Marker$contextTypes)
	Marker.childContextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.ANCHOR,
	  _propTypes2.default.object
	)
	exports.default = Marker
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onAnimationChanged: "animation_changed",
	  onClick: "click",
	  onClickableChanged: "clickable_changed",
	  onCursorChanged: "cursor_changed",
	  onDrag: "drag",
	  onDraggableChanged: "draggable_changed",
	  onFlatChanged: "flat_changed",
	  onIconChanged: "icon_changed",
	  onPositionChanged: "position_changed",
	  onShapeChanged: "shape_changed",
	  onTitleChanged: "title_changed",
	  onVisibleChanged: "visible_changed",
	  onZindexChanged: "zindex_changed",
	}
	
	var updaterMap = {
	  animation: function animation(instance, _animation) {
	    instance.setAnimation(_animation)
	  },
	  clickable: function clickable(instance, _clickable) {
	    instance.setClickable(_clickable)
	  },
	  cursor: function cursor(instance, _cursor) {
	    instance.setCursor(_cursor)
	  },
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  icon: function icon(instance, _icon) {
	    instance.setIcon(_icon)
	  },
	  label: function label(instance, _label) {
	    instance.setLabel(_label)
	  },
	  opacity: function opacity(instance, _opacity) {
	    instance.setOpacity(_opacity)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  place: function place(instance, _place) {
	    instance.setPlace(_place)
	  },
	  position: function position(instance, _position) {
	    instance.setPosition(_position)
	  },
	  shape: function shape(instance, _shape) {
	    instance.setShape(_shape)
	  },
	  title: function title(instance, _title) {
	    instance.setTitle(_title)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	  zIndex: function zIndex(instance, _zIndex) {
	    instance.setZIndex(_zIndex)
	  },
	}


/***/ }),
/* 6052 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.OverlayView = undefined
	
	var _extends2 = __webpack_require__(3)
	
	var _extends3 = _interopRequireDefault(_extends2)
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _delay2 = __webpack_require__(6172)
	
	var _delay3 = _interopRequireDefault(_delay2)
	
	var _assign2 = __webpack_require__(6170)
	
	var _assign3 = _interopRequireDefault(_assign2)
	
	var _bind2 = __webpack_require__(1030)
	
	var _bind3 = _interopRequireDefault(_bind2)
	
	var _OverlayView$contextT /*
	                            * -----------------------------------------------------------------------------
	                            * This file is auto-generated from the corresponding file at `src/macros/`.
	                            * Please **DO NOT** edit this file directly when creating PRs.
	                            * -----------------------------------------------------------------------------
	                            */
	/* global google */
	
	var _invariant = __webpack_require__(586)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _reactDom = __webpack_require__(71)
	
	var _reactDom2 = _interopRequireDefault(_reactDom)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _OverlayViewHelper = __webpack_require__(6058)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.OverlayView`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	 */
	var OverlayView = (exports.OverlayView = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(OverlayView, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  function OverlayView(props, context) {
	    ;(0, _classCallCheck3.default)(this, OverlayView)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (
	        OverlayView.__proto__ || (0, _getPrototypeOf2.default)(OverlayView)
	      ).call(this, props, context)
	    )
	
	    var overlayView = new google.maps.OverlayView()
	    // You must implement three methods: onAdd(), draw(), and onRemove().
	    overlayView.onAdd = (0, _bind3.default)(_this.onAdd, _this)
	    overlayView.draw = (0, _bind3.default)(_this.draw, _this)
	    overlayView.onRemove = (0, _bind3.default)(_this.onRemove, _this)
	    _this.onPositionElement = (0, _bind3.default)(
	      _this.onPositionElement,
	      _this
	    )
	    // You must call setMap() with a valid Map object to trigger the call to
	    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
	    overlayView.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.OVERLAY_VIEW,
	      overlayView
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(OverlayView, [
	    {
	      key: "onAdd",
	      value: function onAdd() {
	        this.containerElement = document.createElement("div")
	        this.containerElement.style.position = "absolute"
	      },
	    },
	    {
	      key: "draw",
	      value: function draw() {
	        var mapPaneName = this.props.mapPaneName
	
	        ;(0, _invariant2.default)(
	          !!mapPaneName,
	          "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s",
	          mapPaneName
	        )
	        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
	        var mapPanes = this.state[_constants.OVERLAY_VIEW].getPanes()
	        mapPanes[mapPaneName].appendChild(this.containerElement)
	
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(
	          this,
	          _react2.default.Children.only(this.props.children),
	          this.containerElement,
	          this.onPositionElement
	        )
	      },
	    },
	    {
	      key: "onPositionElement",
	      value: function onPositionElement() {
	        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
	        var mapCanvasProjection = this.state[
	          _constants.OVERLAY_VIEW
	        ].getProjection()
	
	        var offset = (0, _extends3.default)(
	          {
	            x: 0,
	            y: 0,
	          },
	          (0, _OverlayViewHelper.getOffsetOverride)(
	            this.containerElement,
	            this.props
	          )
	        )
	        var layoutStyles = (0, _OverlayViewHelper.getLayoutStyles)(
	          mapCanvasProjection,
	          offset,
	          this.props
	        )
	        ;(0, _assign3.default)(this.containerElement.style, layoutStyles)
	      },
	    },
	    {
	      key: "onRemove",
	      value: function onRemove() {
	        this.containerElement.parentNode.removeChild(this.containerElement)
	        _reactDom2.default.unmountComponentAtNode(this.containerElement)
	        this.containerElement = null
	      },
	    },
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.OVERLAY_VIEW],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.OVERLAY_VIEW],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	        ;(0, _delay3.default)(this.state[_constants.OVERLAY_VIEW].draw)
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var overlayView = this.state[_constants.OVERLAY_VIEW]
	        if (overlayView) {
	          overlayView.setMap(null)
	          // You must implement three methods: onAdd(), draw(), and onRemove().
	          overlayView.onAdd = null
	          overlayView.draw = null
	          overlayView.onRemove = null
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	       * Returns the panes in which this OverlayView can be rendered. The panes are not initialized until `onAdd` is called by the API.
	       * @type MapPanesonAdd
	       * @public
	       */
	    },
	    {
	      key: "getPanes",
	      value: function getPanes() {
	        return this.state[_constants.OVERLAY_VIEW].getPanes()
	      },
	
	      /**
	       * Returns the `MapCanvasProjection` object associated with this `OverlayView`. The projection is not initialized until `onAdd` is called by the API.
	       * @type MapCanvasProjectionMapCanvasProjectionOverlayViewonAdd
	       * @public
	       */
	    },
	    {
	      key: "getProjection",
	      value: function getProjection() {
	        return this.state[_constants.OVERLAY_VIEW].getProjection()
	      },
	    },
	  ])
	  return OverlayView
	})(_react2.default.PureComponent))
	
	OverlayView.FLOAT_PANE = "floatPane"
	OverlayView.MAP_PANE = "mapPane"
	OverlayView.MARKER_LAYER = "markerLayer"
	OverlayView.OVERLAY_LAYER = "overlayLayer"
	OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget"
	OverlayView.propTypes = {
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  mapPaneName: _propTypes2.default.string,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  position: _propTypes2.default.object,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  bounds: _propTypes2.default.object,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  children: _propTypes2.default.node.isRequired,
	
	  /**
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
	   */
	  getPixelPositionOffset: _propTypes2.default.func,
	}
	OverlayView.contextTypes = ((_OverlayView$contextT = {}),
	(0, _defineProperty3.default)(
	  _OverlayView$contextT,
	  _constants.MAP,
	  _propTypes2.default.object
	),
	(0, _defineProperty3.default)(
	  _OverlayView$contextT,
	  _constants.ANCHOR,
	  _propTypes2.default.object
	),
	_OverlayView$contextT)
	exports.default = OverlayView
	
	var eventMap = {}
	
	var updaterMap = {}


/***/ }),
/* 6053 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Polygon = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Polygon`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var Polygon = (exports.Polygon = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Polygon, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
	   */
	  function Polygon(props, context) {
	    ;(0, _classCallCheck3.default)(this, Polygon)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Polygon.__proto__ || (0, _getPrototypeOf2.default)(Polygon)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var polygon = new google.maps.Polygon()
	    ;(0, _MapChildHelper.construct)(
	      Polygon.propTypes,
	      updaterMap,
	      _this.props,
	      polygon
	    )
	    polygon.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)({}, _constants.POLYGON, polygon)
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Polygon, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.POLYGON],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.POLYGON],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var polygon = this.state[_constants.POLYGON]
	        if (polygon) {
	          polygon.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	       * Returns whether this shape can be dragged by the user.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.POLYGON].getDraggable()
	      },
	
	      /**
	       * Returns whether this shape can be edited by the user.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getEditable",
	      value: function getEditable() {
	        return this.state[_constants.POLYGON].getEditable()
	      },
	
	      /**
	       * Retrieves the first path.
	       * @type MVCArray<LatLng>
	       * @public
	       */
	    },
	    {
	      key: "getPath",
	      value: function getPath() {
	        return this.state[_constants.POLYGON].getPath()
	      },
	
	      /**
	       * Retrieves the paths for this polygon.
	       * @type MVCArray<MVCArray<LatLng>>
	       * @public
	       */
	    },
	    {
	      key: "getPaths",
	      value: function getPaths() {
	        return this.state[_constants.POLYGON].getPaths()
	      },
	
	      /**
	       * Returns whether this poly is visible on the map.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.POLYGON].getVisible()
	      },
	    },
	  ])
	  return Polygon
	})(_react2.default.PureComponent))
	
	Polygon.propTypes = {
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  defaultEditable: _propTypes2.default.bool,
	
	  /**
	   * @type PolygonOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
	   */
	  defaultPath: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
	   */
	  defaultPaths: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  editable: _propTypes2.default.bool,
	
	  /**
	   * @type PolygonOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
	   */
	  path: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<MVCArray<LatLng>>|MVCArray<LatLng>|Array<Array<LatLng|LatLngLiteral>>|Array<LatLng|LatLngLiteral>
	   */
	  paths: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	}
	Polygon.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = Polygon
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onClick: "click",
	  onDrag: "drag",
	}
	
	var updaterMap = {
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  editable: function editable(instance, _editable) {
	    instance.setEditable(_editable)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  path: function path(instance, _path) {
	    instance.setPath(_path)
	  },
	  paths: function paths(instance, _paths) {
	    instance.setPaths(_paths)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	}


/***/ }),
/* 6054 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Polyline = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Polyline`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var Polyline = (exports.Polyline = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Polyline, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
	   */
	  function Polyline(props, context) {
	    ;(0, _classCallCheck3.default)(this, Polyline)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Polyline.__proto__ || (0, _getPrototypeOf2.default)(Polyline)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var polyline = new google.maps.Polyline()
	    ;(0, _MapChildHelper.construct)(
	      Polyline.propTypes,
	      updaterMap,
	      _this.props,
	      polyline
	    )
	    polyline.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.POLYLINE,
	      polyline
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Polyline, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.POLYLINE],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.POLYLINE],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var polyline = this.state[_constants.POLYLINE]
	        if (polyline) {
	          polyline.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	       * Returns whether this shape can be dragged by the user.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.POLYLINE].getDraggable()
	      },
	
	      /**
	       * Returns whether this shape can be edited by the user.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getEditable",
	      value: function getEditable() {
	        return this.state[_constants.POLYLINE].getEditable()
	      },
	
	      /**
	       * Retrieves the path.
	       * @type MVCArray<LatLng>
	       * @public
	       */
	    },
	    {
	      key: "getPath",
	      value: function getPath() {
	        return this.state[_constants.POLYLINE].getPath()
	      },
	
	      /**
	       * Returns whether this poly is visible on the map.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.POLYLINE].getVisible()
	      },
	    },
	  ])
	  return Polyline
	})(_react2.default.PureComponent))
	
	Polyline.propTypes = {
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  defaultEditable: _propTypes2.default.bool,
	
	  /**
	   * @type PolylineOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
	   */
	  defaultPath: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  editable: _propTypes2.default.bool,
	
	  /**
	   * @type PolylineOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type MVCArray<LatLng>|Array<LatLng|LatLngLiteral>
	   */
	  path: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	}
	Polyline.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = Polyline
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onClick: "click",
	  onDrag: "drag",
	}
	
	var updaterMap = {
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  editable: function editable(instance, _editable) {
	    instance.setEditable(_editable)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  path: function path(instance, _path) {
	    instance.setPath(_path)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	}


/***/ }),
/* 6055 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.Rectangle = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.Rectangle`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var Rectangle = (exports.Rectangle = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(Rectangle, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
	   */
	  function Rectangle(props, context) {
	    ;(0, _classCallCheck3.default)(this, Rectangle)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (Rectangle.__proto__ || (0, _getPrototypeOf2.default)(Rectangle)).call(
	        this,
	        props,
	        context
	      )
	    )
	
	    var rectangle = new google.maps.Rectangle()
	    ;(0, _MapChildHelper.construct)(
	      Rectangle.propTypes,
	      updaterMap,
	      _this.props,
	      rectangle
	    )
	    rectangle.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.RECTANGLE,
	      rectangle
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(Rectangle, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.RECTANGLE],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.RECTANGLE],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var rectangle = this.state[_constants.RECTANGLE]
	        if (rectangle) {
	          rectangle.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	
	      /**
	       * Returns the bounds of this rectangle.
	       * @type LatLngBounds
	       * @public
	       */
	    },
	    {
	      key: "getBounds",
	      value: function getBounds() {
	        return this.state[_constants.RECTANGLE].getBounds()
	      },
	
	      /**
	       * Returns whether this rectangle can be dragged by the user.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getDraggable",
	      value: function getDraggable() {
	        return this.state[_constants.RECTANGLE].getDraggable()
	      },
	
	      /**
	       * Returns whether this rectangle can be edited by the user.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getEditable",
	      value: function getEditable() {
	        return this.state[_constants.RECTANGLE].getEditable()
	      },
	
	      /**
	       * Returns whether this rectangle is visible on the map.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.state[_constants.RECTANGLE].getVisible()
	      },
	    },
	  ])
	  return Rectangle
	})(_react2.default.PureComponent))
	
	Rectangle.propTypes = {
	  /**
	   * @type LatLngBounds|LatLngBoundsLiteral
	   */
	  defaultBounds: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultDraggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  defaultEditable: _propTypes2.default.bool,
	
	  /**
	   * @type RectangleOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type LatLngBounds|LatLngBoundsLiteral
	   */
	  bounds: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  draggable: _propTypes2.default.bool,
	
	  /**
	   * @type boolean
	   */
	  editable: _propTypes2.default.bool,
	
	  /**
	   * @type RectangleOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * function
	   */
	  onDblClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragEnd: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseDown: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseMove: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOut: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onMouseUp: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onRightClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onBoundsChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onDrag: _propTypes2.default.func,
	}
	Rectangle.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = Rectangle
	
	var eventMap = {
	  onDblClick: "dblclick",
	  onDragEnd: "dragend",
	  onDragStart: "dragstart",
	  onMouseDown: "mousedown",
	  onMouseMove: "mousemove",
	  onMouseOut: "mouseout",
	  onMouseOver: "mouseover",
	  onMouseUp: "mouseup",
	  onRightClick: "rightclick",
	  onBoundsChanged: "bounds_changed",
	  onClick: "click",
	  onDrag: "drag",
	}
	
	var updaterMap = {
	  bounds: function bounds(instance, _bounds) {
	    instance.setBounds(_bounds)
	  },
	  draggable: function draggable(instance, _draggable) {
	    instance.setDraggable(_draggable)
	  },
	  editable: function editable(instance, _editable) {
	    instance.setEditable(_editable)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	}


/***/ }),
/* 6056 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.StreetViewPanorama = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _invariant = __webpack_require__(586)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.StreetViewPanorama`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
	 */
	var StreetViewPanorama = (exports.StreetViewPanorama = (function(
	  _React$PureComponent
	) {
	  ;(0, _inherits3.default)(StreetViewPanorama, _React$PureComponent)
	
	  function StreetViewPanorama(props, context) {
	    ;(0, _classCallCheck3.default)(this, StreetViewPanorama)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (
	        StreetViewPanorama.__proto__ ||
	        (0, _getPrototypeOf2.default)(StreetViewPanorama)
	      ).call(this, props, context)
	    )
	
	    ;(0, _invariant2.default)(
	      !!_this.context[_constants.MAP],
	      "Did you render <StreetViewPanorama> as a child of <GoogleMap> with withGoogleMap() HOC?"
	    )
	    ;(0, _MapChildHelper.construct)(
	      StreetViewPanorama.propTypes,
	      updaterMap,
	      _this.props,
	      _this.context[_constants.MAP].getStreetView()
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(StreetViewPanorama, [
	    {
	      key: "getChildContext",
	      value: function getChildContext() {
	        return (0, _defineProperty3.default)(
	          {},
	          _constants.MAP,
	          this.context[_constants.MAP].getStreetView()
	        )
	      },
	    },
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.context[_constants.MAP].getStreetView(),
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.context[_constants.MAP].getStreetView(),
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var streetViewPanorama = this.context[_constants.MAP].getStreetView()
	        if (streetViewPanorama) {
	          streetViewPanorama.setVisible(false)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        var children = this.props.children
	
	        return _react2.default.createElement("div", null, children)
	      },
	
	      /**
	       * Returns the set of navigation links for the Street View panorama.
	       * @type Array<StreetViewLink>
	       * @public
	       */
	    },
	    {
	      key: "getLinks",
	      value: function getLinks() {
	        return this.context[_constants.MAP].getLinks()
	      },
	
	      /**
	       * Returns the StreetViewLocation of the current panorama.
	       * @type StreetViewLocation
	       * @public
	       */
	    },
	    {
	      key: "getLocation",
	      value: function getLocation() {
	        return this.context[_constants.MAP].getLocation()
	      },
	
	      /**
	       * Returns the state of motion tracker. If true when the user physically moves the device and the browser supports it, the Street View Panorama tracks the physical movements.
	       * @type boolean
	       * @public
	       */
	    },
	    {
	      key: "getMotionTracking",
	      value: function getMotionTracking() {
	        return this.context[_constants.MAP].getMotionTracking()
	      },
	
	      /**
	       * Returns the current panorama ID for the Street View panorama. This id is stable within the browser's current session only.
	       * @type string
	       * @public
	       */
	    },
	    {
	      key: "getPano",
	      value: function getPano() {
	        return this.context[_constants.MAP].getPano()
	      },
	
	      /**
	       * Returns the heading and pitch of the photographer when this panorama was taken. For Street View panoramas on the road, this also reveals in which direction the car was travelling. This data is available after the `pano_changed` event.
	       * @type StreetViewPovpano_changed
	       * @public
	       */
	    },
	    {
	      key: "getPhotographerPov",
	      value: function getPhotographerPov() {
	        return this.context[_constants.MAP].getPhotographerPov()
	      },
	
	      /**
	       * Returns the current `LatLng` position for the Street View panorama.
	       * @type LatLngLatLng
	       * @public
	       */
	    },
	    {
	      key: "getPosition",
	      value: function getPosition() {
	        return this.context[_constants.MAP].getPosition()
	      },
	
	      /**
	       * Returns the current point of view for the Street View panorama.
	       * @type StreetViewPov
	       * @public
	       */
	    },
	    {
	      key: "getPov",
	      value: function getPov() {
	        return this.context[_constants.MAP].getPov()
	      },
	
	      /**
	       * Returns the status of the panorama on completion of the `setPosition()` or `setPano()` request.
	       * @type StreetViewStatussetPosition()setPano()
	       * @public
	       */
	    },
	    {
	      key: "getStatus",
	      value: function getStatus() {
	        return this.context[_constants.MAP].getStatus()
	      },
	
	      /**
	       * Returns `true` if the panorama is visible. It does not specify whether Street View imagery is available at the specified position.
	       * @type booleantrue
	       * @public
	       */
	    },
	    {
	      key: "getVisible",
	      value: function getVisible() {
	        return this.context[_constants.MAP].getVisible()
	      },
	
	      /**
	       * Returns the zoom level of the panorama. Fully zoomed-out is level 0, where the field of view is 180 degrees. Zooming in increases the zoom level.
	       * @type number
	       * @public
	       */
	    },
	    {
	      key: "getZoom",
	      value: function getZoom() {
	        return this.context[_constants.MAP].getZoom()
	      },
	    },
	  ])
	  return StreetViewPanorama
	})(
	  _react2.default.PureComponent
	)) /*
	                                   * -----------------------------------------------------------------------------
	                                   * This file is auto-generated from the corresponding file at `src/macros/`.
	                                   * Please **DO NOT** edit this file directly when creating PRs.
	                                   * -----------------------------------------------------------------------------
	                                   */
	
	StreetViewPanorama.propTypes = {
	  /**
	   * @type Array<StreetViewLink>
	   */
	  defaultLinks: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultMotionTracking: _propTypes2.default.bool,
	
	  /**
	   * @type StreetViewPanoramaOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  defaultPano: _propTypes2.default.string,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  defaultPosition: _propTypes2.default.any,
	
	  /**
	   * @type StreetViewPov
	   */
	  defaultPov: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  defaultVisible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  defaultZoom: _propTypes2.default.number,
	
	  /**
	   * @type Array<StreetViewLink>
	   */
	  links: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  motionTracking: _propTypes2.default.bool,
	
	  /**
	   * @type StreetViewPanoramaOptions
	   */
	  options: _propTypes2.default.any,
	
	  /**
	   * @type string
	   */
	  pano: _propTypes2.default.string,
	
	  /**
	   * @type LatLng|LatLngLiteral
	   */
	  position: _propTypes2.default.any,
	
	  /**
	   * @type StreetViewPov
	   */
	  pov: _propTypes2.default.any,
	
	  /**
	   * @type boolean
	   */
	  visible: _propTypes2.default.bool,
	
	  /**
	   * @type number
	   */
	  zoom: _propTypes2.default.number,
	
	  /**
	   * function
	   */
	  onCloseClick: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPanoChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPositionChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onPovChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onResize: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onStatusChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onVisibleChanged: _propTypes2.default.func,
	
	  /**
	   * function
	   */
	  onZoomChanged: _propTypes2.default.func,
	}
	StreetViewPanorama.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	StreetViewPanorama.childContextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = StreetViewPanorama
	
	var eventMap = {
	  onCloseClick: "closeclick",
	  onPanoChanged: "pano_changed",
	  onPositionChanged: "position_changed",
	  onPovChanged: "pov_changed",
	  onResize: "resize",
	  onStatusChanged: "status_changed",
	  onVisibleChanged: "visible_changed",
	  onZoomChanged: "zoom_changed",
	}
	
	var updaterMap = {
	  links: function links(instance, _links) {
	    instance.setLinks(_links)
	  },
	  motionTracking: function motionTracking(instance, _motionTracking) {
	    instance.setMotionTracking(_motionTracking)
	  },
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	  pano: function pano(instance, _pano) {
	    instance.setPano(_pano)
	  },
	  position: function position(instance, _position) {
	    instance.setPosition(_position)
	  },
	  pov: function pov(instance, _pov) {
	    instance.setPov(_pov)
	  },
	  visible: function visible(instance, _visible) {
	    instance.setVisible(_visible)
	  },
	  zoom: function zoom(instance, _zoom) {
	    instance.setZoom(_zoom)
	  },
	}


/***/ }),
/* 6057 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	exports.TrafficLayer = undefined
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _MapChildHelper = __webpack_require__(179)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/**
	 * A wrapper around `google.maps.TrafficLayer`
	 *
	 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
	 */
	/*
	 * -----------------------------------------------------------------------------
	 * This file is auto-generated from the corresponding file at `src/macros/`.
	 * Please **DO NOT** edit this file directly when creating PRs.
	 * -----------------------------------------------------------------------------
	 */
	/* global google */
	var TrafficLayer = (exports.TrafficLayer = (function(_React$PureComponent) {
	  ;(0, _inherits3.default)(TrafficLayer, _React$PureComponent)
	
	  /*
	   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
	   */
	  function TrafficLayer(props, context) {
	    ;(0, _classCallCheck3.default)(this, TrafficLayer)
	
	    var _this = (0, _possibleConstructorReturn3.default)(
	      this,
	      (
	        TrafficLayer.__proto__ || (0, _getPrototypeOf2.default)(TrafficLayer)
	      ).call(this, props, context)
	    )
	
	    var trafficLayer = new google.maps.TrafficLayer()
	    ;(0, _MapChildHelper.construct)(
	      TrafficLayer.propTypes,
	      updaterMap,
	      _this.props,
	      trafficLayer
	    )
	    trafficLayer.setMap(_this.context[_constants.MAP])
	    _this.state = (0, _defineProperty3.default)(
	      {},
	      _constants.TRAFFIC_LAYER,
	      trafficLayer
	    )
	    return _this
	  }
	
	  ;(0, _createClass3.default)(TrafficLayer, [
	    {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        ;(0, _MapChildHelper.componentDidMount)(
	          this,
	          this.state[_constants.TRAFFIC_LAYER],
	          eventMap
	        )
	      },
	    },
	    {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        ;(0, _MapChildHelper.componentDidUpdate)(
	          this,
	          this.state[_constants.TRAFFIC_LAYER],
	          eventMap,
	          updaterMap,
	          prevProps
	        )
	      },
	    },
	    {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        ;(0, _MapChildHelper.componentWillUnmount)(this)
	        var trafficLayer = this.state[_constants.TRAFFIC_LAYER]
	        if (trafficLayer) {
	          trafficLayer.setMap(null)
	        }
	      },
	    },
	    {
	      key: "render",
	      value: function render() {
	        return false
	      },
	    },
	  ])
	  return TrafficLayer
	})(_react2.default.PureComponent))
	
	TrafficLayer.propTypes = {
	  /**
	   * @type TrafficLayerOptions
	   */
	  defaultOptions: _propTypes2.default.any,
	
	  /**
	   * @type TrafficLayerOptions
	   */
	  options: _propTypes2.default.any,
	}
	TrafficLayer.contextTypes = (0, _defineProperty3.default)(
	  {},
	  _constants.MAP,
	  _propTypes2.default.object
	)
	exports.default = TrafficLayer
	
	var eventMap = {}
	
	var updaterMap = {
	  options: function options(instance, _options) {
	    instance.setOptions(_options)
	  },
	}


/***/ }),
/* 6058 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _isFunction2 = __webpack_require__(1033)
	
	var _isFunction3 = _interopRequireDefault(_isFunction2)
	
	exports.getOffsetOverride = getOffsetOverride
	exports.getLayoutStyles = getLayoutStyles
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/* global google */
	function getOffsetOverride(containerElement, props) {
	  var getPixelPositionOffset = props.getPixelPositionOffset
	  //
	  // Allows the component to control the visual position of the OverlayView
	  // relative to the LatLng pixel position.
	  //
	
	  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
	    return getPixelPositionOffset(
	      containerElement.offsetWidth,
	      containerElement.offsetHeight
	    )
	  } else {
	    return {}
	  }
	}
	
	function createLatLng(inst, Type) {
	  return new Type(inst.lat, inst.lng)
	}
	
	function createLatLngBounds(inst, Type) {
	  return new Type(
	    new google.maps.LatLng(inst.ne.lat, inst.ne.lng),
	    new google.maps.LatLng(inst.sw.lat, inst.sw.lng)
	  )
	}
	
	function ensureOfType(inst, type, factory) {
	  if (inst instanceof type) {
	    return inst
	  } else {
	    return factory(inst, type)
	  }
	}
	
	function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
	  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast())
	  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest())
	  if (ne && sw) {
	    return {
	      left: sw.x + offset.x + "px",
	      top: ne.y + offset.y + "px",
	      width: ne.x - sw.x - offset.x + "px",
	      height: sw.y - ne.y - offset.y + "px",
	    }
	  }
	  return {
	    left: "-9999px",
	    top: "-9999px",
	  }
	}
	
	function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
	  var point = mapCanvasProjection.fromLatLngToDivPixel(position)
	  if (point) {
	    var x = point.x,
	      y = point.y
	
	    return {
	      left: x + offset.x + "px",
	      top: y + offset.y + "px",
	    }
	  }
	  return {
	    left: "-9999px",
	    top: "-9999px",
	  }
	}
	
	function getLayoutStyles(mapCanvasProjection, offset, props) {
	  if (props.bounds) {
	    var bounds = ensureOfType(
	      props.bounds,
	      google.maps.LatLngBounds,
	      createLatLngBounds
	    )
	    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds)
	  } else {
	    var position = ensureOfType(
	      props.position,
	      google.maps.LatLng,
	      createLatLng
	    )
	    return getLayoutStylesByPosition(mapCanvasProjection, offset, position)
	  }
	}


/***/ }),
/* 6059 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _objectWithoutProperties2 = __webpack_require__(28)
	
	var _objectWithoutProperties3 = _interopRequireDefault(
	  _objectWithoutProperties2
	)
	
	var _defineProperty2 = __webpack_require__(9)
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _bind2 = __webpack_require__(1030)
	
	var _bind3 = _interopRequireDefault(_bind2)
	
	exports.withGoogleMap = withGoogleMap
	
	var _warning = __webpack_require__(74)
	
	var _warning2 = _interopRequireDefault(_warning)
	
	var _invariant = __webpack_require__(586)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _recompose = __webpack_require__(2780)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	var _constants = __webpack_require__(163)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	/* global google */
	function withGoogleMap(BaseComponent) {
	  var factory = _react2.default.createFactory(BaseComponent)
	
	  var Container = (function(_React$PureComponent) {
	    ;(0, _inherits3.default)(Container, _React$PureComponent)
	
	    function Container() {
	      var _ref
	
	      var _temp, _this, _ret
	
	      ;(0, _classCallCheck3.default)(this, Container)
	
	      for (
	        var _len = arguments.length, args = Array(_len), _key = 0;
	        _key < _len;
	        _key++
	      ) {
	        args[_key] = arguments[_key]
	      }
	
	      return (
	        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
	          this,
	          (_ref =
	            Container.__proto__ ||
	            (0, _getPrototypeOf2.default)(Container)).call.apply(
	            _ref,
	            [this].concat(args)
	          )
	        )),
	        _this)),
	        (_this.state = {
	          map: null,
	        }),
	        (_this.handleComponentMount = (0, _bind3.default)(
	          _this.handleComponentMount,
	          _this
	        )),
	        _temp)),
	        (0, _possibleConstructorReturn3.default)(_this, _ret)
	      )
	    }
	
	    ;(0, _createClass3.default)(Container, [
	      {
	        key: "getChildContext",
	        value: function getChildContext() {
	          return (0, _defineProperty3.default)(
	            {},
	            _constants.MAP,
	            this.state.map
	          )
	        },
	      },
	      {
	        key: "componentWillMount",
	        value: function componentWillMount() {
	          var _props = this.props,
	            containerElement = _props.containerElement,
	            mapElement = _props.mapElement
	
	          ;(0, _invariant2.default)(
	            !!containerElement && !!mapElement,
	            "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized."
	          )
	        },
	      },
	      {
	        key: "handleComponentMount",
	        value: function handleComponentMount(node) {
	          if (this.state.map || node === null) {
	            return
	          }
	          ;(0, _warning2.default)(
	            "undefined" !== typeof google,
	            "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168"
	          )
	          // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
	          var map = new google.maps.Map(node)
	          this.setState({ map: map })
	        },
	      },
	      {
	        key: "render",
	        value: function render() {
	          var _props2 = this.props,
	            containerElement = _props2.containerElement,
	            mapElement = _props2.mapElement,
	            restProps = (0, _objectWithoutProperties3.default)(_props2, [
	              "containerElement",
	              "mapElement",
	            ])
	          var map = this.state.map
	
	          if (map) {
	            return _react2.default.cloneElement(
	              containerElement,
	              {},
	              _react2.default.cloneElement(mapElement, {
	                ref: this.handleComponentMount,
	              }),
	              _react2.default.createElement("div", null, factory(restProps))
	            )
	          } else {
	            return _react2.default.cloneElement(
	              containerElement,
	              {},
	              _react2.default.cloneElement(mapElement, {
	                ref: this.handleComponentMount,
	              }),
	              _react2.default.createElement("div", null)
	            )
	          }
	        },
	      },
	    ])
	    return Container
	  })(_react2.default.PureComponent)
	
	  Container.displayName =
	    "withGoogleMap(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
	  Container.propTypes = {
	    containerElement: _propTypes2.default.node.isRequired,
	    mapElement: _propTypes2.default.node.isRequired,
	  }
	  Container.childContextTypes = (0, _defineProperty3.default)(
	    {},
	    _constants.MAP,
	    _propTypes2.default.object
	  )
	
	  return Container
	}
	
	exports.default = withGoogleMap


/***/ }),
/* 6060 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	
	Object.defineProperty(exports, "__esModule", {
	  value: true,
	})
	
	var _objectWithoutProperties2 = __webpack_require__(28)
	
	var _objectWithoutProperties3 = _interopRequireDefault(
	  _objectWithoutProperties2
	)
	
	var _getPrototypeOf = __webpack_require__(25)
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)
	
	var _classCallCheck2 = __webpack_require__(19)
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)
	
	var _createClass2 = __webpack_require__(21)
	
	var _createClass3 = _interopRequireDefault(_createClass2)
	
	var _possibleConstructorReturn2 = __webpack_require__(27)
	
	var _possibleConstructorReturn3 = _interopRequireDefault(
	  _possibleConstructorReturn2
	)
	
	var _inherits2 = __webpack_require__(26)
	
	var _inherits3 = _interopRequireDefault(_inherits2)
	
	var _bind2 = __webpack_require__(1030)
	
	var _bind3 = _interopRequireDefault(_bind2)
	
	exports.withScriptjs = withScriptjs
	
	var _invariant = __webpack_require__(586)
	
	var _invariant2 = _interopRequireDefault(_invariant)
	
	var _canUseDom = __webpack_require__(1976)
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom)
	
	var _recompose = __webpack_require__(2780)
	
	var _propTypes = __webpack_require__(2)
	
	var _propTypes2 = _interopRequireDefault(_propTypes)
	
	var _react = __webpack_require__(1)
	
	var _react2 = _interopRequireDefault(_react)
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj }
	}
	
	var LOADING_STATE_NONE = "NONE"
	var LOADING_STATE_BEGIN = "BEGIN"
	var LOADING_STATE_LOADED = "LOADED"
	
	function withScriptjs(BaseComponent) {
	  var factory = _react2.default.createFactory(BaseComponent)
	
	  var Container = (function(_React$PureComponent) {
	    ;(0, _inherits3.default)(Container, _React$PureComponent)
	
	    function Container() {
	      var _ref
	
	      var _temp, _this, _ret
	
	      ;(0, _classCallCheck3.default)(this, Container)
	
	      for (
	        var _len = arguments.length, args = Array(_len), _key = 0;
	        _key < _len;
	        _key++
	      ) {
	        args[_key] = arguments[_key]
	      }
	
	      return (
	        (_ret = ((_temp = ((_this = (0, _possibleConstructorReturn3.default)(
	          this,
	          (_ref =
	            Container.__proto__ ||
	            (0, _getPrototypeOf2.default)(Container)).call.apply(
	            _ref,
	            [this].concat(args)
	          )
	        )),
	        _this)),
	        (_this.state = {
	          loadingState: LOADING_STATE_NONE,
	        }),
	        (_this.isUnmounted = false),
	        (_this.handleLoaded = (0, _bind3.default)(_this.handleLoaded, _this)),
	        _temp)),
	        (0, _possibleConstructorReturn3.default)(_this, _ret)
	      )
	    }
	
	    ;(0, _createClass3.default)(Container, [
	      {
	        key: "handleLoaded",
	        value: function handleLoaded() {
	          if (this.isUnmounted) {
	            return
	          }
	          this.setState({
	            loadingState: LOADING_STATE_LOADED,
	          })
	        },
	      },
	      {
	        key: "componentWillMount",
	        value: function componentWillMount() {
	          var _props = this.props,
	            loadingElement = _props.loadingElement,
	            googleMapURL = _props.googleMapURL
	
	          ;(0, _invariant2.default)(
	            !!loadingElement && !!googleMapURL,
	            "Required props loadingElement or googleMapURL is missing. You need to provide both of them."
	          )
	        },
	      },
	      {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	          var loadingState = this.state.loadingState
	
	          if (loadingState !== LOADING_STATE_NONE || !_canUseDom2.default) {
	            return
	          }
	          this.setState({
	            loadingState: LOADING_STATE_BEGIN,
	          })
	          // Don't load scriptjs as a dependency since we do not want this module be used on server side.
	          // eslint-disable-next-line global-require
	          var scriptjs = __webpack_require__(6479)
	          var googleMapURL = this.props.googleMapURL
	
	          scriptjs(googleMapURL, this.handleLoaded)
	        },
	      },
	      {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	          this.isUnmounted = true
	        },
	      },
	      {
	        key: "render",
	        value: function render() {
	          var _props2 = this.props,
	            loadingElement = _props2.loadingElement,
	            googleMapURL = _props2.googleMapURL,
	            restProps = (0, _objectWithoutProperties3.default)(_props2, [
	              "loadingElement",
	              "googleMapURL",
	            ])
	          var loadingState = this.state.loadingState
	
	          if (loadingState === LOADING_STATE_LOADED) {
	            return factory(restProps)
	          } else {
	            return loadingElement
	          }
	        },
	      },
	    ])
	    return Container
	  })(_react2.default.PureComponent)
	
	  Container.displayName =
	    "withScriptjs(" + (0, _recompose.getDisplayName)(BaseComponent) + ")"
	  Container.propTypes = {
	    loadingElement: _propTypes2.default.node.isRequired,
	    googleMapURL: _propTypes2.default.string.isRequired,
	  }
	
	  return Container
	}
	
	exports.default = withScriptjs


/***/ }),
/* 6061 */
6274,
/* 6062 */
[6722, 477, 210],
/* 6063 */
[6723, 6126, 6127, 6128, 6129, 6130],
/* 6064 */
[6727, 477, 210],
/* 6065 */
[6728, 477, 210],
/* 6066 */
[6729, 1607, 6156, 6157],
/* 6067 */
[6732, 210],
/* 6068 */
2685,
/* 6069 */
[6707, 6083],
/* 6070 */
[6734, 6099, 2775, 252, 2776, 1026, 2777],
/* 6071 */
2686,
/* 6072 */
5821,
/* 6073 */
2310,
/* 6074 */
5822,
/* 6075 */
5823,
/* 6076 */
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The base implementation of `_.delay` and `_.defer` which accepts `args`
	 * to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {Array} args The arguments to provide to `func`.
	 * @returns {number|Object} Returns the timer id or timeout object.
	 */
	function baseDelay(func, wait, args) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return setTimeout(function() { func.apply(undefined, args); }, wait);
	}
	
	module.exports = baseDelay;


/***/ }),
/* 6077 */
5825,
/* 6078 */
[6740, 6110],
/* 6079 */
[6741, 6078, 1035],
/* 6080 */
[6743, 6072, 252],
/* 6081 */
5404,
/* 6082 */
5829,
/* 6083 */
[6745, 6077, 6087, 6164],
/* 6084 */
[6746, 744, 587],
/* 6085 */
[6748, 2745, 2761, 6116, 6117, 6123, 252, 2776, 2777],
/* 6086 */
[6749, 2745, 2752],
/* 6087 */
5833,
/* 6088 */
[6750, 1033, 6135, 478, 2774],
/* 6089 */
[6751, 744, 1614, 587],
/* 6090 */
[6752, 6092, 6093, 745, 252, 6180],
/* 6091 */
[6753, 2766, 6149],
/* 6092 */
[6754, 6086, 6120, 2768],
/* 6093 */
[6755, 2752, 6174, 6176, 1613, 2767, 2768, 1029],
/* 6094 */
5840,
/* 6095 */
[6756, 2751],
/* 6096 */
5426,
/* 6097 */
[6758, 6171, 2760, 745],
/* 6098 */
5844,
/* 6099 */
5845,
/* 6100 */
[6759, 1022, 6071, 252, 1034],
/* 6101 */
5846,
/* 6102 */
5848,
/* 6103 */
[6761, 745],
/* 6104 */
[6763, 6098],
/* 6105 */
[6766, 2748, 2749],
/* 6106 */
[6767, 210],
/* 6107 */
/***/ (function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ }),
/* 6108 */
[6768, 1611, 6132],
/* 6109 */
[6769, 1032],
/* 6110 */
5857,
/* 6111 */
/***/ (function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(1024),
	    root = __webpack_require__(210);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ }),
/* 6112 */
[6711, 6104, 2765, 6165, 2779],
/* 6113 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1608),
	    createCtor = __webpack_require__(1024),
	    createHybrid = __webpack_require__(2758),
	    createRecurry = __webpack_require__(2759),
	    getHolder = __webpack_require__(1612),
	    replaceHolders = __webpack_require__(1028),
	    root = __webpack_require__(210);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ }),
/* 6114 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1608),
	    createCtor = __webpack_require__(1024),
	    root = __webpack_require__(210);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ }),
/* 6115 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(2753),
	    createBind = __webpack_require__(6111),
	    createCurry = __webpack_require__(6113),
	    createHybrid = __webpack_require__(2758),
	    createPartial = __webpack_require__(6114),
	    getData = __webpack_require__(2763),
	    mergeData = __webpack_require__(6148),
	    setData = __webpack_require__(2770),
	    setWrapToString = __webpack_require__(2772),
	    toInteger = __webpack_require__(6185);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ }),
/* 6116 */
[6772, 1022, 6067, 1031, 2761, 6146, 6158],
/* 6117 */
[6773, 6118],
/* 6118 */
[6774, 6080, 6122, 1035],
/* 6119 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(6154);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 6120 */
[6776, 2767, 1035],
/* 6121 */
[6778, 1022],
/* 6122 */
[6779, 6068, 6182],
/* 6123 */
[6780, 6062, 1606, 6064, 6065, 2746, 744, 2774],
/* 6124 */
5865,
/* 6125 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ }),
/* 6126 */
[6782, 1027],
/* 6127 */
5869,
/* 6128 */
[6783, 1027],
/* 6129 */
[6784, 1027],
/* 6130 */
[6785, 1027],
/* 6131 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ }),
/* 6132 */
[6786, 1031, 1032, 1026, 478],
/* 6133 */
5874,
/* 6134 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(1605),
	    getData = __webpack_require__(2763),
	    getFuncName = __webpack_require__(6119),
	    lodash = __webpack_require__(6186);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 6135 */
[6788, 6106],
/* 6136 */
5876,
/* 6137 */
[6790, 1023],
/* 6138 */
[6791, 1023],
/* 6139 */
[6792, 1023],
/* 6140 */
[6793, 1023],
/* 6141 */
[6794, 6063, 1021, 1606],
/* 6142 */
[6795, 1025],
/* 6143 */
[6796, 1025],
/* 6144 */
[6797, 1025],
/* 6145 */
[6798, 1025],
/* 6146 */
5886,
/* 6147 */
[6799, 6178],
/* 6148 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(2755),
	    composeArgsRight = __webpack_require__(2756),
	    replaceHolders = __webpack_require__(1028);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ }),
/* 6149 */
[6801, 6152],
/* 6150 */
[6802, 2762],
/* 6151 */
5890,
/* 6152 */
2873,
/* 6153 */
[6803, 1608],
/* 6154 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 6155 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(2757),
	    isIndex = __webpack_require__(1026);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ }),
/* 6156 */
5893,
/* 6157 */
5894,
/* 6158 */
5895,
/* 6159 */
[6806, 1021],
/* 6160 */
5899,
/* 6161 */
5900,
/* 6162 */
5901,
/* 6163 */
[6807, 1021, 1606, 1607],
/* 6164 */
5903,
/* 6165 */
[6808, 6075, 2765, 6167],
/* 6166 */
[6809, 6147],
/* 6167 */
5906,
/* 6168 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(2747),
	    arrayIncludes = __webpack_require__(6069);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ }),
/* 6169 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(1605),
	    LodashWrapper = __webpack_require__(2744),
	    copyArray = __webpack_require__(2757);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 6170 */
[6811, 2748, 6105, 6108, 1032, 2766, 1035],
/* 6171 */
5908,
/* 6172 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(6076),
	    baseRest = __webpack_require__(1611),
	    toNumber = __webpack_require__(2778);
	
	/**
	 * Invokes `func` after `wait` milliseconds. Any additional arguments are
	 * provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {...*} [args] The arguments to invoke `func` with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.delay(function(text) {
	 *   console.log(text);
	 * }, 1000, 'later');
	 * // => Logs 'later' after one second.
	 */
	var delay = baseRest(function(func, wait, args) {
	  return baseDelay(func, toNumber(wait) || 0, args);
	});
	
	module.exports = delay;


/***/ }),
/* 6173 */
[6812, 2747, 2750, 6103, 252],
/* 6174 */
[6813, 2751],
/* 6175 */
[6716, 6081, 2764],
/* 6176 */
[6814, 6082, 2764],
/* 6177 */
/***/ (function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(6112);
	
	/**
	 * Converts the first character of `string` to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.lowerFirst('Fred');
	 * // => 'fred'
	 *
	 * _.lowerFirst('FRED');
	 * // => 'fRED'
	 */
	var lowerFirst = createCaseFirst('toLowerCase');
	
	module.exports = lowerFirst;


/***/ }),
/* 6178 */
[6825, 1607],
/* 6179 */
465,
/* 6180 */
[6826, 6094, 6095, 1613, 1029],
/* 6181 */
[6719, 6073, 2750, 6090, 6096, 252],
/* 6182 */
5918,
/* 6183 */
5919,
/* 6184 */
[6827, 2778],
/* 6185 */
[6828, 6184],
/* 6186 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(1605),
	    LodashWrapper = __webpack_require__(2744),
	    baseLodash = __webpack_require__(1610),
	    isArray = __webpack_require__(252),
	    isObjectLike = __webpack_require__(587),
	    wrapperClone = __webpack_require__(6169);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 6187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6188);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(2781);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6188 */
4608,
/* 6189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(389);
	
	var _theme = __webpack_require__(479);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(588);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Container(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var props = _objectWithoutProperties(_ref, []);
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement('div', _extends({ id: 'lightboxBackdrop',
			className: (0, _noImportant.css)(classes.container)
		}, props));
	}
	
	Container.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		container: {
			alignItems: 'center',
			backgroundColor: _theme2.default.container.background,
			boxSizing: 'border-box',
			display: 'flex',
			height: '100%',
			justifyContent: 'center',
			left: 0,
			paddingBottom: _theme2.default.container.gutter.vertical,
			paddingLeft: _theme2.default.container.gutter.horizontal,
			paddingRight: _theme2.default.container.gutter.horizontal,
			paddingTop: _theme2.default.container.gutter.vertical,
			position: 'fixed',
			top: 0,
			width: '100%',
			zIndex: _theme2.default.container.zIndex
		}
	};
	
	exports.default = Container;

/***/ }),
/* 6190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(389);
	
	var _theme = __webpack_require__(479);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(588);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Footer(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var caption = _ref.caption,
		    countCurrent = _ref.countCurrent,
		    countSeparator = _ref.countSeparator,
		    countTotal = _ref.countTotal,
		    showCount = _ref.showCount,
		    props = _objectWithoutProperties(_ref, ['caption', 'countCurrent', 'countSeparator', 'countTotal', 'showCount']);
	
		if (!caption && !showCount) return null;
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		var imageCount = showCount ? _react2.default.createElement(
			'div',
			{ className: (0, _noImportant.css)(classes.footerCount) },
			countCurrent,
			countSeparator,
			countTotal
		) : _react2.default.createElement('span', null);
	
		return _react2.default.createElement(
			'div',
			_extends({ className: (0, _noImportant.css)(classes.footer) }, props),
			caption ? _react2.default.createElement(
				'figcaption',
				{ className: (0, _noImportant.css)(classes.footerCaption) },
				caption
			) : _react2.default.createElement('span', null),
			imageCount
		);
	}
	
	Footer.propTypes = {
		caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
		countCurrent: _propTypes2.default.number,
		countSeparator: _propTypes2.default.string,
		countTotal: _propTypes2.default.number,
		showCount: _propTypes2.default.bool
	};
	Footer.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		footer: {
			boxSizing: 'border-box',
			color: _theme2.default.footer.color,
			cursor: 'auto',
			display: 'flex',
			justifyContent: 'space-between',
			left: 0,
			lineHeight: 1.3,
			paddingBottom: _theme2.default.footer.gutter.vertical,
			paddingLeft: _theme2.default.footer.gutter.horizontal,
			paddingRight: _theme2.default.footer.gutter.horizontal,
			paddingTop: _theme2.default.footer.gutter.vertical
		},
		footerCount: {
			color: _theme2.default.footer.count.color,
			fontSize: _theme2.default.footer.count.fontSize,
			paddingLeft: '1em' // add a small gutter for the caption
		},
		footerCaption: {
			flex: '1 1 0'
		}
	};
	
	exports.default = Footer;

/***/ }),
/* 6191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(389);
	
	var _theme = __webpack_require__(479);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(588);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	var _Icon = __webpack_require__(2784);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Header(_ref, _ref2) {
		var theme = _ref2.theme;
	
		var customControls = _ref.customControls,
		    onClose = _ref.onClose,
		    showCloseButton = _ref.showCloseButton,
		    closeButtonTitle = _ref.closeButtonTitle,
		    props = _objectWithoutProperties(_ref, ['customControls', 'onClose', 'showCloseButton', 'closeButtonTitle']);
	
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement(
			'div',
			_extends({ className: (0, _noImportant.css)(classes.header) }, props),
			customControls ? customControls : _react2.default.createElement('span', null),
			!!showCloseButton && _react2.default.createElement(
				'button',
				{
					title: closeButtonTitle,
					className: (0, _noImportant.css)(classes.close),
					onClick: onClose
				},
				_react2.default.createElement(_Icon2.default, { fill: !!theme.close && theme.close.fill || _theme2.default.close.fill, type: 'close' })
			)
		);
	}
	
	Header.propTypes = {
		customControls: _propTypes2.default.array,
		onClose: _propTypes2.default.func.isRequired,
		showCloseButton: _propTypes2.default.bool
	};
	Header.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		header: {
			display: 'flex',
			justifyContent: 'space-between',
			height: _theme2.default.header.height
		},
		close: {
			background: 'none',
			border: 'none',
			cursor: 'pointer',
			outline: 'none',
			position: 'relative',
			top: 0,
			verticalAlign: 'bottom',
			zIndex: 1,
	
			// increase hit area
			height: 40,
			marginRight: -10,
			padding: 10,
			width: 40
		}
	};
	
	exports.default = Header;

/***/ }),
/* 6192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(389);
	
	var _Thumbnail = __webpack_require__(6196);
	
	var _Thumbnail2 = _interopRequireDefault(_Thumbnail);
	
	var _Arrow = __webpack_require__(2783);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	var _theme = __webpack_require__(479);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var classes = _noImportant.StyleSheet.create({
		paginatedThumbnails: {
			bottom: _theme2.default.container.gutter.vertical,
			height: _theme2.default.thumbnail.size,
			padding: '0 50px',
			position: 'absolute',
			textAlign: 'center',
			whiteSpace: 'nowrap',
			left: '50%',
			transform: 'translateX(-50%)'
		}
	});
	
	var arrowStyles = {
		height: _theme2.default.thumbnail.size + _theme2.default.thumbnail.gutter * 2,
		width: 40
	};
	
	var PaginatedThumbnails = function (_Component) {
		_inherits(PaginatedThumbnails, _Component);
	
		function PaginatedThumbnails(props) {
			_classCallCheck(this, PaginatedThumbnails);
	
			var _this = _possibleConstructorReturn(this, (PaginatedThumbnails.__proto__ || Object.getPrototypeOf(PaginatedThumbnails)).call(this, props));
	
			_this.state = {
				hasCustomPage: false
			};
	
			_this.gotoPrev = _this.gotoPrev.bind(_this);
			_this.gotoNext = _this.gotoNext.bind(_this);
			return _this;
		}
	
		_createClass(PaginatedThumbnails, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				// Component should be controlled, flush state when currentImage changes
				if (nextProps.currentImage !== this.props.currentImage) {
					this.setState({
						hasCustomPage: false
					});
				}
			}
	
			// ==============================
			// METHODS
			// ==============================
	
		}, {
			key: 'getFirst',
			value: function getFirst() {
				var _props = this.props,
				    currentImage = _props.currentImage,
				    offset = _props.offset;
	
				if (this.state.hasCustomPage) {
					return this.clampFirst(this.state.first);
				}
				return this.clampFirst(currentImage - offset);
			}
		}, {
			key: 'setFirst',
			value: function setFirst(event, newFirst) {
				var first = this.state.first;
	
	
				if (event) {
					event.preventDefault();
					event.stopPropagation();
				}
	
				if (first === newFirst) return;
	
				this.setState({
					hasCustomPage: true,
					first: newFirst
				});
			}
		}, {
			key: 'gotoPrev',
			value: function gotoPrev(event) {
				this.setFirst(event, this.getFirst() - this.props.offset);
			}
		}, {
			key: 'gotoNext',
			value: function gotoNext(event) {
				this.setFirst(event, this.getFirst() + this.props.offset);
			}
		}, {
			key: 'clampFirst',
			value: function clampFirst(value) {
				var _props2 = this.props,
				    images = _props2.images,
				    offset = _props2.offset;
	
	
				var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
	
				if (value < 0) {
					return 0;
				} else if (value + totalCount > images.length) {
					// Too far
					return images.length - totalCount;
				} else {
					return value;
				}
			}
	
			// ==============================
			// RENDERERS
			// ==============================
	
		}, {
			key: 'renderArrowPrev',
			value: function renderArrowPrev() {
				if (this.getFirst() <= 0) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'left',
					size: 'small',
					icon: 'arrowLeft',
					onClick: this.gotoPrev,
					style: arrowStyles,
					title: 'Previous (Left arrow key)',
					type: 'button'
				});
			}
		}, {
			key: 'renderArrowNext',
			value: function renderArrowNext() {
				var _props3 = this.props,
				    offset = _props3.offset,
				    images = _props3.images;
	
				var totalCount = 2 * offset + 1;
				if (this.getFirst() + totalCount >= images.length) return null;
	
				return _react2.default.createElement(_Arrow2.default, {
					direction: 'right',
					size: 'small',
					icon: 'arrowRight',
					onClick: this.gotoNext,
					style: arrowStyles,
					title: 'Next (Right arrow key)',
					type: 'button'
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _props4 = this.props,
				    images = _props4.images,
				    currentImage = _props4.currentImage,
				    onClickThumbnail = _props4.onClickThumbnail,
				    offset = _props4.offset;
	
	
				var totalCount = 2 * offset + 1; // show $offset extra thumbnails on each side
				var thumbnails = [];
				var baseOffset = 0;
				if (images.length <= totalCount) {
					thumbnails = images;
				} else {
					// Try to center current image in list
					baseOffset = this.getFirst();
					thumbnails = images.slice(baseOffset, baseOffset + totalCount);
				}
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _noImportant.css)(classes.paginatedThumbnails) },
					this.renderArrowPrev(),
					thumbnails.map(function (img, idx) {
						return _react2.default.createElement(_Thumbnail2.default, _extends({ key: baseOffset + idx
						}, img, {
							index: baseOffset + idx,
							onClick: onClickThumbnail,
							active: baseOffset + idx === currentImage }));
					}),
					this.renderArrowNext()
				);
			}
		}]);
	
		return PaginatedThumbnails;
	}(_react.Component);
	
	exports.default = PaginatedThumbnails;
	
	
	PaginatedThumbnails.propTypes = {
		currentImage: _propTypes2.default.number,
		images: _propTypes2.default.array,
		offset: _propTypes2.default.number,
		onClickThumbnail: _propTypes2.default.func.isRequired
	};

/***/ }),
/* 6193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Pass the Lightbox context through to the Portal's descendents
	// StackOverflow discussion http://goo.gl/oclrJ9
	
	var PassContext = function (_Component) {
		_inherits(PassContext, _Component);
	
		function PassContext() {
			_classCallCheck(this, PassContext);
	
			return _possibleConstructorReturn(this, (PassContext.__proto__ || Object.getPrototypeOf(PassContext)).apply(this, arguments));
		}
	
		_createClass(PassContext, [{
			key: 'getChildContext',
			value: function getChildContext() {
				return this.props.context;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react.Children.only(this.props.children);
			}
		}]);
	
		return PassContext;
	}(_react.Component);
	
	PassContext.propTypes = {
		context: _propTypes2.default.object.isRequired
	};
	PassContext.childContextTypes = {
		theme: _propTypes2.default.object
	};
	
	exports.default = PassContext;

/***/ }),
/* 6194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTransitionGroup = __webpack_require__(6208);
	
	var _reactDom = __webpack_require__(71);
	
	var _PassContext = __webpack_require__(6193);
	
	var _PassContext2 = _interopRequireDefault(_PassContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_Component) {
		_inherits(Portal, _Component);
	
		function Portal() {
			_classCallCheck(this, Portal);
	
			var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
	
			_this.portalElement = null;
			return _this;
		}
	
		_createClass(Portal, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var p = document.createElement('div');
				document.body.appendChild(p);
				this.portalElement = p;
				this.componentDidUpdate();
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				// Animate fade on mount/unmount
				var duration = 200;
				var styles = '\n\t\t\t\t.fade-enter { opacity: 0.01; }\n\t\t\t\t.fade-enter.fade-enter-active { opacity: 1; transition: opacity ' + duration + 'ms; }\n\t\t\t\t.fade-leave { opacity: 1; }\n\t\t\t\t.fade-leave.fade-leave-active { opacity: 0.01; transition: opacity ' + duration + 'ms; }\n\t\t';
	
				(0, _reactDom.render)(_react2.default.createElement(
					_PassContext2.default,
					{ context: this.context },
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'style',
							null,
							styles
						),
						_react2.default.createElement(
							_reactTransitionGroup.TransitionGroup,
							this.props,
							_react2.default.createElement(
								_reactTransitionGroup.CSSTransition,
								{ timeout: { enter: duration, exit: duration }, classNames: 'fade' },
								this.props.children
							)
						)
					)
				), this.portalElement);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				(0, _reactDom.unmountComponentAtNode)(this.portalElement);
				document.body.removeChild(this.portalElement);
			}
		}, {
			key: 'render',
			value: function render() {
				return null;
			}
		}]);
	
		return Portal;
	}(_react.Component);
	
	exports.default = Portal;
	
	
	Portal.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};

/***/ }),
/* 6195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(389);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = function Spinner(props) {
		var classes = _noImportant.StyleSheet.create(styles(props));
	
		return _react2.default.createElement(
			'div',
			{ className: (0, _noImportant.css)(classes.spinner) },
			_react2.default.createElement('div', { className: (0, _noImportant.css)(classes.ripple) })
		);
	};
	
	Spinner.propTypes = {
		color: _propTypes2.default.string,
		size: _propTypes2.default.number
	};
	
	var rippleKeyframes = {
		'0%': {
			top: '50%',
			left: '50%',
			width: 0,
			height: 0,
			opacity: 1
		},
		'100%': {
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			opacity: 0
		}
	};
	
	var styles = function styles(_ref) {
		var color = _ref.color,
		    size = _ref.size;
		return {
			spinner: {
				display: 'inline-block',
				position: 'relative',
				width: size,
				height: size
			},
			ripple: {
				position: 'absolute',
				border: '4px solid ' + color,
				opacity: 1,
				borderRadius: '50%',
				animationName: rippleKeyframes,
				animationDuration: '1s',
				animationTimingFunction: 'cubic-bezier(0, 0.2, 0.8, 1)',
				animationIterationCount: 'infinite'
			}
		};
	};
	
	exports.default = Spinner;

/***/ }),
/* 6196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _noImportant = __webpack_require__(389);
	
	var _theme = __webpack_require__(479);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _deepMerge = __webpack_require__(588);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Thumbnail(_ref, _ref2) {
		var index = _ref.index,
		    src = _ref.src,
		    thumbnail = _ref.thumbnail,
		    active = _ref.active,
		    _onClick = _ref.onClick;
		var theme = _ref2.theme;
	
		var url = thumbnail ? thumbnail : src;
		var classes = _noImportant.StyleSheet.create((0, _deepMerge2.default)(defaultStyles, theme));
	
		return _react2.default.createElement('div', {
			className: (0, _noImportant.css)(classes.thumbnail, active && classes.thumbnail__active),
			onClick: function onClick(e) {
				e.preventDefault();
				e.stopPropagation();
				_onClick(index);
			},
			style: { backgroundImage: 'url("' + url + '")' }
		});
	}
	
	Thumbnail.propTypes = {
		active: _propTypes2.default.bool,
		index: _propTypes2.default.number,
		onClick: _propTypes2.default.func.isRequired,
		src: _propTypes2.default.string,
		thumbnail: _propTypes2.default.string
	};
	
	Thumbnail.contextTypes = {
		theme: _propTypes2.default.object.isRequired
	};
	
	var defaultStyles = {
		thumbnail: {
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			borderRadius: 2,
			boxShadow: 'inset 0 0 0 1px hsla(0,0%,100%,.2)',
			cursor: 'pointer',
			display: 'inline-block',
			height: _theme2.default.thumbnail.size,
			margin: _theme2.default.thumbnail.gutter,
			overflow: 'hidden',
			width: _theme2.default.thumbnail.size
		},
		thumbnail__active: {
			boxShadow: 'inset 0 0 0 2px ' + _theme2.default.thumbnail.activeBorderColor
		}
	};
	
	exports.default = Thumbnail;

/***/ }),
/* 6197 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z\"/>\n\t</svg>";
	};

/***/ }),
/* 6198 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" xml:space=\"preserve\">\n\t\t<path d=\"M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z\"/>\n\t</svg>";
	};

/***/ }),
/* 6199 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (fill) {
		return "<svg fill=\"" + fill + "\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"100%\" height=\"100%\" viewBox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\">\n\t\t<path d=\"M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z\"/>\n\t</svg>";
	};

/***/ }),
/* 6200 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = bindFunctions;
	/**
		Bind multiple component methods:
	
		* @param {this} context
		* @param {Array} functions
	
		constructor() {
			...
			bindFunctions.call(this, ['handleClick', 'handleOther']);
		}
	*/
	
	function bindFunctions(functions) {
		var _this = this;
	
		functions.forEach(function (f) {
			return _this[f] = _this[f].bind(_this);
		});
	};

/***/ }),
/* 6201 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	// Return true if window + document
	
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 6202 */
1015,
/* 6203 */
[6832, 6202, 6204],
/* 6204 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 6205 */
4876,
/* 6206 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(746));
	
	var _addClass = _interopRequireDefault(__webpack_require__(6203));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(6205));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(2785));
	
	var _PropTypes = __webpack_require__(2787);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation. After the animation,
	 * matching `done` class names are applied to persist the animation state.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var _this$getClassNames3 = _this.getClassNames('enter'),
	          doneClassName = _this$getClassNames3.doneClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          className = _this$getClassNames4.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames5.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames6 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames6.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames7 = this.getClassNames(type),
	        className = _this$getClassNames7.className,
	        activeClassName = _this$getClassNames7.activeClassName,
	        doneClassName = _this$getClassNames7.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or has finished the transition.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply spread
	   * them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 6207 */
[6833, 746, 2786],
/* 6208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(6206));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(6207));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(2786));
	
	var _Transition = _interopRequireDefault(__webpack_require__(2785));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ }),
/* 6209 */
[6835, 6210],
/* 6210 */
6261,
/* 6211 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),
/* 6212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _intersection = __webpack_require__(6213);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Monitors scroll, and triggers the children function with updated props
	 *
	 <Observer>
	 {inView => (
	   <h1>{`${inView}`}</h1>
	 )}
	 </Observer>
	 */
	var Observer = function (_React$Component) {
	  _inherits(Observer, _React$Component);
	
	  function Observer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Observer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Observer.__proto__ || Object.getPrototypeOf(Observer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inView: false
	    }, _this.node = null, _this.handleNode = function (node) {
	      if (_this.node) (0, _intersection.unobserve)(_this.node);
	      _this.node = node;
	      _this.observeNode();
	
	      if (_this.props.innerRef) {
	        _this.props.innerRef(node);
	      }
	    }, _this.handleChange = function (inView) {
	      return _this.setState({ inView: inView });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Observer, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (!!this.props.onChange && nextState !== this.state) {
	        this.props.onChange(nextState.inView);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // If a IntersectionObserver option changed, reinit the observer
	      if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold) {
	        (0, _intersection.unobserve)(this.node);
	        this.observeNode();
	      }
	
	      if (prevState.inView !== this.state.inView) {
	        if (this.state.inView && this.props.triggerOnce) {
	          (0, _intersection.unobserve)(this.node);
	          this.node = null;
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.node) {
	        (0, _intersection.unobserve)(this.node);
	        this.node = null;
	      }
	    }
	  }, {
	    key: 'observeNode',
	    value: function observeNode() {
	      if (!this.node) return;
	      var _props = this.props,
	          threshold = _props.threshold,
	          root = _props.root,
	          rootMargin = _props.rootMargin,
	          rootId = _props.rootId;
	
	      (0, _intersection.observe)(this.node, this.handleChange, {
	        threshold: threshold,
	        root: root,
	        rootMargin: rootMargin
	      }, rootId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          render = _props2.render,
	          tag = _props2.tag,
	          innerRef = _props2.innerRef,
	          triggerOnce = _props2.triggerOnce,
	          threshold = _props2.threshold,
	          root = _props2.root,
	          rootId = _props2.rootId,
	          rootMargin = _props2.rootMargin,
	          props = _objectWithoutProperties(_props2, ['children', 'render', 'tag', 'innerRef', 'triggerOnce', 'threshold', 'root', 'rootId', 'rootMargin']);
	
	      var inView = this.state.inView;
	
	
	      return React.createElement(tag, _extends({}, props, {
	        ref: this.handleNode
	      }),
	      // If render is a function, use it to render content when in view
	      inView && typeof render === 'function' ? render() : null,
	      // // If children is a function, render it with the current inView status.
	      // // Otherwise always render children. Assume onChange is being used outside, to control the the state of children.
	      typeof children === 'function' ? children(inView) : children);
	    }
	  }]);
	
	  return Observer;
	}(React.Component);
	
	Observer.defaultProps = {
	  tag: 'div',
	  threshold: 0,
	  triggerOnce: false
	};
	exports.default = Observer;

/***/ }),
/* 6213 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.observe = observe;
	exports.unobserve = unobserve;
	exports.destroy = destroy;
	var INSTANCE_MAP = new Map();
	var OBSERVER_MAP = new Map();
	
	/**
	 * Monitor element, and trigger callback when element becomes visible
	 * @param element {HTMLElement}
	 * @param callback {Function} Called with inView
	 * @param options {Object} InterSection observer options
	 * @param options.threshold {Number} Number between 0 and 1, indicating how much of the element should be visible before triggering
	 * @param options.root {HTMLElement} It should have a unique id or data-intersection-id in order for the Observer to reused.
	 * @param options.rootMargin {String} The CSS margin to apply to the root element.
	 * @param rootId {String} Unique identifier for the root element, to enable reusing the IntersectionObserver
	 */
	function observe(element, callback) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    threshold: 0
	  };
	  var rootId = arguments[3];
	  var root = options.root,
	      rootMargin = options.rootMargin;
	
	  var threshold = options.threshold || 0;
	  if (!element || !callback) return;
	  var observerId = rootMargin ? threshold.toString() + "_" + rootMargin : "" + threshold.toString();
	
	  if (root) {
	    observerId = rootId ? rootId + "_" + observerId : null;
	  }
	
	  var observerInstance = observerId ? OBSERVER_MAP.get(observerId) : null;
	  if (!observerInstance) {
	    observerInstance = new IntersectionObserver(onChange, options);
	    if (observerId) OBSERVER_MAP.set(observerId, observerInstance);
	  }
	
	  var instance = {
	    callback: callback,
	    visible: false,
	    options: options,
	    observerId: observerId,
	    observer: !observerId ? observerInstance : undefined
	  };
	
	  INSTANCE_MAP.set(element, instance);
	
	  observerInstance.observe(element);
	
	  return instance;
	}
	
	/**
	 * Stop observing an element. If an element is removed from the DOM or otherwise destroyed,
	 * make sure to call this method.
	 * @param element {HTMLElement}
	 */
	function unobserve(element) {
	  if (!element) return;
	  var instance = INSTANCE_MAP.get(element);
	
	  if (instance) {
	    var _observerId = instance.observerId,
	        _observer = instance.observer;
	
	    var observerInstance = _observerId ? OBSERVER_MAP.get(_observerId) : _observer;
	
	    if (observerInstance) {
	      // $FlowFixMe - the interface in bom.js is wrong. Spec should accept the element.
	      observerInstance.unobserve(element);
	    }
	
	    // Check if we are still observing any elements with the same threshold.
	    var itemsLeft = false;
	    if (_observerId) {
	      INSTANCE_MAP.forEach(function (item, key) {
	        if (item && item.observerId === _observerId && key !== element) {
	          itemsLeft = true;
	        }
	      });
	    }
	
	    if (observerInstance && !itemsLeft) {
	      // No more elements to observe for threshold, disconnect observer
	      observerInstance.disconnect();
	      OBSERVER_MAP.delete(_observerId);
	    }
	
	    // Remove reference to element
	    INSTANCE_MAP.delete(element);
	  }
	}
	
	/**
	 * Destroy all IntersectionObservers currently connected
	 **/
	function destroy() {
	  OBSERVER_MAP.forEach(function (observer) {
	    observer.disconnect();
	  });
	
	  OBSERVER_MAP.clear();
	  INSTANCE_MAP.clear();
	}
	
	function onChange(changes) {
	  changes.forEach(function (intersection) {
	    var isIntersecting = intersection.isIntersecting,
	        intersectionRatio = intersection.intersectionRatio,
	        target = intersection.target;
	
	    var instance = INSTANCE_MAP.get(target);
	    if (instance) {
	      var _options = instance.options;
	
	      var _inView = false;
	
	      if (Array.isArray(_options.threshold)) {
	        // If threshold is an array, check if any of them intersects. This just triggers the onChange event multiple times.
	        _inView = _options.threshold.some(function (threshold) {
	          return instance.visible ? intersectionRatio > threshold : intersectionRatio >= threshold;
	        });
	      } else if (_options.threshold !== undefined) {
	        // Trigger on 0 ratio only when not visible. This is fallback for browsers without isIntersecting support
	        _inView = instance.visible ? intersectionRatio > _options.threshold : intersectionRatio >= _options.threshold;
	      }
	
	      if (isIntersecting !== undefined) {
	        // If isIntersecting is defined, ensure that the element is actually intersecting.
	        // Otherwise it reports a threshold of 0
	        _inView = _inView && isIntersecting;
	      }
	
	      // Update the visible value on the instance
	      instance.visible = _inView;
	
	      if (instance.callback) {
	        instance.callback(_inView);
	      }
	    }
	  });
	}
	
	exports.default = {
	  observe: observe,
	  unobserve: unobserve,
	  destroy: destroy
	};

/***/ }),
/* 6214 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var message_1 = __webpack_require__(2790);
	var injectIntl_1 = __webpack_require__(383);
	var utils_1 = __webpack_require__(180);
	var FormattedHTMLMessage = /** @class */ (function (_super) {
	    __extends(FormattedHTMLMessage, _super);
	    function FormattedHTMLMessage() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    FormattedHTMLMessage.prototype.render = function () {
	        var _this = this;
	        return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	            if (!_this.props.defaultMessage) {
	                utils_1.invariantIntlContext(intl);
	            }
	            var formatHTMLMessage = intl.formatHTMLMessage, textComponent = intl.textComponent;
	            var _a = _this.props, id = _a.id, description = _a.description, defaultMessage = _a.defaultMessage, rawValues = _a.values, children = _a.children;
	            var Component = _this.props.tagName;
	            // This is bc of TS3.3 doesn't recognize `defaultProps`
	            if (!Component) {
	                Component = textComponent || 'span';
	            }
	            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	            if (typeof children === 'function') {
	                return children(formattedHTMLMessage);
	            }
	            // Since the message presumably has HTML in it, we need to set
	            // `innerHTML` in order for it to be rendered and not escaped by React.
	            // To be safe, all string prop values were escaped when formatting the
	            // message. It is assumed that the message is not UGC, and came from the
	            // developer making it more like a template.
	            //
	            // Note: There's a perf impact of using this component since there's no
	            // way for React to do its virtual DOM diffing.
	            var html = { __html: formattedHTMLMessage };
	            return React.createElement(Component, { dangerouslySetInnerHTML: html });
	        }));
	    };
	    FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	    FormattedHTMLMessage.defaultProps = __assign(__assign({}, message_1.default.defaultProps), { tagName: 'span' });
	    return FormattedHTMLMessage;
	}(message_1.default));
	exports.default = FormattedHTMLMessage;


/***/ }),
/* 6215 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(383);
	var FormattedPlural = function (props) {
	    var value = props.value, other = props.other, children = props.children, _a = props.intl, formatPlural = _a.formatPlural, Text = _a.textComponent;
	    var pluralCategory = formatPlural(value, props);
	    var formattedPlural = props[pluralCategory] || other;
	    if (typeof children === 'function') {
	        return children(formattedPlural);
	    }
	    if (Text) {
	        return React.createElement(Text, null, formattedPlural);
	    }
	    // Work around @types/react where React.FC cannot return string
	    return formattedPlural;
	};
	FormattedPlural.defaultProps = {
	    type: 'cardinal',
	};
	FormattedPlural.displayName = 'FormattedPlural';
	exports.default = injectIntl_1.default(FormattedPlural);


/***/ }),
/* 6216 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(383);
	var utils_1 = __webpack_require__(180);
	var number_1 = __webpack_require__(6222);
	var relativeTime_1 = __webpack_require__(6224);
	var dateTime_1 = __webpack_require__(6219);
	var plural_1 = __webpack_require__(6223);
	var message_1 = __webpack_require__(2791);
	var shallowEquals_ = __webpack_require__(2885);
	var list_1 = __webpack_require__(6221);
	var displayName_1 = __webpack_require__(6220);
	var shallowEquals = shallowEquals_.default || shallowEquals_;
	function processIntlConfig(config) {
	    return {
	        locale: config.locale,
	        timeZone: config.timeZone,
	        formats: config.formats,
	        textComponent: config.textComponent,
	        messages: config.messages,
	        defaultLocale: config.defaultLocale,
	        defaultFormats: config.defaultFormats,
	        onError: config.onError,
	    };
	}
	/**
	 * Create intl object
	 * @param config intl config
	 * @param cache cache for formatter instances to prevent memory leak
	 */
	function createIntl(config, cache) {
	    var formatters = utils_1.createFormatters(cache);
	    var resolvedConfig = __assign(__assign({}, utils_1.DEFAULT_INTL_CONFIG), config);
	    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
	    if (!locale) {
	        if (onError) {
	            onError(utils_1.createError("\"locale\" was not configured, using \"" + defaultLocale + "\" as fallback. See https://github.com/formatjs/react-intl/blob/master/docs/API.md#intlshape for more details"));
	        }
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
	    }
	    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
	        onError(utils_1.createError("Missing locale data for locale: \"" + locale + "\" in Intl.NumberFormat. Using default locale: \"" + defaultLocale + "\" as fallback. See https://github.com/formatjs/react-intl/blob/master/docs/Getting-Started.md#runtime-requirements for more details"));
	    }
	    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
	        onError) {
	        onError(utils_1.createError("Missing locale data for locale: \"" + locale + "\" in Intl.DateTimeFormat. Using default locale: \"" + defaultLocale + "\" as fallback. See https://github.com/formatjs/react-intl/blob/master/docs/Getting-Started.md#runtime-requirements for more details"));
	    }
	    return __assign(__assign({}, resolvedConfig), { formatters: formatters, formatNumber: number_1.formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: number_1.formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: relativeTime_1.formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: dateTime_1.formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: dateTime_1.formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: dateTime_1.formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: dateTime_1.formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: plural_1.formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), formatMessage: message_1.formatMessage.bind(null, resolvedConfig, formatters), formatHTMLMessage: message_1.formatHTMLMessage.bind(null, resolvedConfig, formatters), formatList: list_1.formatList.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: displayName_1.formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
	}
	exports.createIntl = createIntl;
	var IntlProvider = /** @class */ (function (_super) {
	    __extends(IntlProvider, _super);
	    function IntlProvider() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.cache = utils_1.createIntlCache();
	        _this.state = {
	            cache: _this.cache,
	            intl: createIntl(processIntlConfig(_this.props), _this.cache),
	            prevConfig: processIntlConfig(_this.props),
	        };
	        return _this;
	    }
	    IntlProvider.getDerivedStateFromProps = function (props, _a) {
	        var prevConfig = _a.prevConfig, cache = _a.cache;
	        var config = processIntlConfig(props);
	        if (!shallowEquals(prevConfig, config)) {
	            return {
	                intl: createIntl(config, cache),
	                prevConfig: config,
	            };
	        }
	        return null;
	    };
	    IntlProvider.prototype.render = function () {
	        utils_1.invariantIntlContext(this.state.intl);
	        return React.createElement(injectIntl_1.Provider, { value: this.state.intl }, this.props.children);
	    };
	    IntlProvider.displayName = 'IntlProvider';
	    IntlProvider.defaultProps = utils_1.DEFAULT_INTL_CONFIG;
	    return IntlProvider;
	}(React.PureComponent));
	exports.default = IntlProvider;


/***/ }),
/* 6217 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var React = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(383);
	var utils_1 = __webpack_require__(180);
	var intl_utils_1 = __webpack_require__(1058);
	var MINUTE = 60;
	var HOUR = 60 * 60;
	var DAY = 60 * 60 * 24;
	function selectUnit(seconds) {
	    var absValue = Math.abs(seconds);
	    if (absValue < MINUTE) {
	        return 'second';
	    }
	    if (absValue < HOUR) {
	        return 'minute';
	    }
	    if (absValue < DAY) {
	        return 'hour';
	    }
	    return 'day';
	}
	function getDurationInSeconds(unit) {
	    switch (unit) {
	        case 'second':
	            return 1;
	        case 'minute':
	            return MINUTE;
	        case 'hour':
	            return HOUR;
	        default:
	            return DAY;
	    }
	}
	function valueToSeconds(value, unit) {
	    if (!value) {
	        return 0;
	    }
	    switch (unit) {
	        case 'second':
	            return value;
	        case 'minute':
	            return value * MINUTE;
	        default:
	            return value * HOUR;
	    }
	}
	var INCREMENTABLE_UNITS = ['second', 'minute', 'hour'];
	function canIncrement(unit) {
	    if (unit === void 0) { unit = 'second'; }
	    return INCREMENTABLE_UNITS.includes(unit);
	}
	var FormattedRelativeTime = /** @class */ (function (_super) {
	    __extends(FormattedRelativeTime, _super);
	    function FormattedRelativeTime(props) {
	        var _this = _super.call(this, props) || this;
	        // Public for testing
	        _this._updateTimer = null;
	        _this.state = {
	            prevUnit: _this.props.unit,
	            prevValue: _this.props.value,
	            currentValueInSeconds: canIncrement(_this.props.unit)
	                ? valueToSeconds(_this.props.value, _this.props.unit)
	                : 0,
	        };
	        intl_utils_1.invariant(!props.updateIntervalInSeconds ||
	            !!(props.updateIntervalInSeconds && canIncrement(props.unit)), 'Cannot schedule update with unit longer than hour');
	        return _this;
	    }
	    FormattedRelativeTime.prototype.scheduleNextUpdate = function (_a, _b) {
	        var _this = this;
	        var updateIntervalInSeconds = _a.updateIntervalInSeconds, unit = _a.unit;
	        var currentValueInSeconds = _b.currentValueInSeconds;
	        clearTimeout(this._updateTimer);
	        this._updateTimer = null;
	        // If there's no interval and we cannot increment this unit, do nothing
	        if (!updateIntervalInSeconds || !canIncrement(unit)) {
	            return;
	        }
	        // Figure out the next interesting time
	        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
	        var nextUnit = selectUnit(nextValueInSeconds);
	        // We've reached the max auto incrementable unit, don't schedule another update
	        if (nextUnit === 'day') {
	            return;
	        }
	        var unitDuration = getDurationInSeconds(nextUnit);
	        var remainder = nextValueInSeconds % unitDuration;
	        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
	        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds
	            ? prevInterestingValueInSeconds - unitDuration
	            : prevInterestingValueInSeconds;
	        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
	        this._updateTimer = setTimeout(function () {
	            return _this.setState({
	                currentValueInSeconds: nextInterestingValueInSeconds,
	            });
	        }, delayInSeconds * 1e3);
	    };
	    FormattedRelativeTime.prototype.componentDidMount = function () {
	        this.scheduleNextUpdate(this.props, this.state);
	    };
	    FormattedRelativeTime.prototype.componentDidUpdate = function () {
	        this.scheduleNextUpdate(this.props, this.state);
	    };
	    FormattedRelativeTime.prototype.componentWillUnmount = function () {
	        clearTimeout(this._updateTimer);
	        this._updateTimer = null;
	    };
	    FormattedRelativeTime.getDerivedStateFromProps = function (props, state) {
	        if (props.unit !== state.prevUnit || props.value !== state.prevValue) {
	            return {
	                prevValue: props.value,
	                prevUnit: props.unit,
	                currentValueInSeconds: canIncrement(props.unit)
	                    ? valueToSeconds(props.value, props.unit)
	                    : 0,
	            };
	        }
	        return null;
	    };
	    FormattedRelativeTime.prototype.render = function () {
	        var _this = this;
	        return (React.createElement(injectIntl_1.Context.Consumer, null, function (intl) {
	            utils_1.invariantIntlContext(intl);
	            var formatRelativeTime = intl.formatRelativeTime, Text = intl.textComponent;
	            var _a = _this.props, children = _a.children, value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds;
	            var currentValueInSeconds = _this.state.currentValueInSeconds;
	            var currentValue = value || 0;
	            var currentUnit = unit;
	            if (canIncrement(unit) &&
	                typeof currentValueInSeconds === 'number' &&
	                updateIntervalInSeconds) {
	                currentUnit = selectUnit(currentValueInSeconds);
	                var unitDuration = getDurationInSeconds(currentUnit);
	                currentValue = Math.round(currentValueInSeconds / unitDuration);
	            }
	            var formattedRelativeTime = formatRelativeTime(currentValue, currentUnit, __assign({}, _this.props));
	            if (typeof children === 'function') {
	                return children(formattedRelativeTime);
	            }
	            if (Text) {
	                return React.createElement(Text, null, formattedRelativeTime);
	            }
	            return formattedRelativeTime;
	        }));
	    };
	    FormattedRelativeTime.displayName = 'FormattedRelativeTime';
	    FormattedRelativeTime.defaultProps = {
	        value: 0,
	        unit: 'second',
	    };
	    return FormattedRelativeTime;
	}(React.PureComponent));
	exports.FormattedRelativeTime = FormattedRelativeTime;
	exports.default = FormattedRelativeTime;


/***/ }),
/* 6218 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __webpack_require__(1);
	var injectIntl_1 = __webpack_require__(383);
	var utils_1 = __webpack_require__(180);
	function useIntl() {
	    var intl = react_1.useContext(injectIntl_1.Context);
	    utils_1.invariantIntlContext(intl);
	    return intl;
	}
	exports.default = useIntl;


/***/ }),
/* 6219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(180);
	var DATE_TIME_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'formatMatcher',
	    'timeZone',
	    'hour12',
	    'weekday',
	    'era',
	    'year',
	    'month',
	    'day',
	    'hour',
	    'minute',
	    'second',
	    'timeZoneName',
	];
	function getFormatter(_a, type, getDateTimeFormat, options) {
	    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
	    if (options === void 0) { options = {}; }
	    var format = options.format;
	    var defaults = __assign(__assign({}, (timeZone && { timeZone: timeZone })), (format && utils_1.getNamedFormat(formats, type, format, onError)));
	    var filteredOptions = utils_1.filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
	    if (type === 'time' &&
	        !filteredOptions.hour &&
	        !filteredOptions.minute &&
	        !filteredOptions.second) {
	        // Add default formatting options if hour, minute, or second isn't defined.
	        filteredOptions = __assign(__assign({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
	    }
	    return getDateTimeFormat(locale, filteredOptions);
	}
	exports.getFormatter = getFormatter;
	function formatDate(config, getDateTimeFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'date', getDateTimeFormat, options).format(date);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting date.', e));
	    }
	    return String(date);
	}
	exports.formatDate = formatDate;
	function formatTime(config, getDateTimeFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'time', getDateTimeFormat, options).format(date);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting time.', e));
	    }
	    return String(date);
	}
	exports.formatTime = formatTime;
	function formatDateToParts(config, getDateTimeFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting date.', e));
	    }
	    return [];
	}
	exports.formatDateToParts = formatDateToParts;
	function formatTimeToParts(config, getDateTimeFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    var date = typeof value === 'string' ? new Date(value || 0) : value;
	    try {
	        return getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting time.', e));
	    }
	    return [];
	}
	exports.formatTimeToParts = formatTimeToParts;


/***/ }),
/* 6220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(180);
	var DISPLAY_NAMES_OPTONS = [
	    'localeMatcher',
	    'style',
	    'type',
	    'fallback',
	];
	function formatDisplayName(_a, getDisplayNames, value, options) {
	    var locale = _a.locale, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var DisplayNames = Intl.DisplayNames;
	    if (!DisplayNames) {
	        onError(utils_1.createError("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n"));
	    }
	    var filteredOptions = utils_1.filterProps(options, DISPLAY_NAMES_OPTONS);
	    try {
	        return getDisplayNames(locale, filteredOptions).of(value);
	    }
	    catch (e) {
	        onError(utils_1.createError('Error formatting display name.', e));
	    }
	}
	exports.formatDisplayName = formatDisplayName;


/***/ }),
/* 6221 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(180);
	var LIST_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'type',
	    'style',
	];
	var now = Date.now();
	function generateToken(i) {
	    return now + "_" + i + "_" + now;
	}
	function formatList(_a, getListFormat, values, options) {
	    var locale = _a.locale, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var ListFormat = Intl.ListFormat;
	    if (!ListFormat) {
	        onError(utils_1.createError("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n"));
	    }
	    var filteredOptions = utils_1.filterProps(options, LIST_FORMAT_OPTIONS);
	    try {
	        var richValues_1 = {};
	        var serializedValues = values.map(function (v, i) {
	            if (typeof v === 'object') {
	                var id = generateToken(i);
	                richValues_1[id] = v;
	                return id;
	            }
	            return String(v);
	        });
	        if (!Object.keys(richValues_1).length) {
	            return getListFormat(locale, filteredOptions).format(serializedValues);
	        }
	        var parts = getListFormat(locale, filteredOptions).formatToParts(serializedValues);
	        return parts.reduce(function (all, el) {
	            var val = el.value;
	            if (richValues_1[val]) {
	                all.push(richValues_1[val]);
	            }
	            else if (typeof all[all.length - 1] === 'string') {
	                all[all.length - 1] += val;
	            }
	            else {
	                all.push(val);
	            }
	            return all;
	        }, []);
	    }
	    catch (e) {
	        onError(utils_1.createError('Error formatting list.', e));
	    }
	    return values;
	}
	exports.formatList = formatList;


/***/ }),
/* 6222 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(180);
	var NUMBER_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'style',
	    'currency',
	    'currencyDisplay',
	    'unit',
	    'unitDisplay',
	    'useGrouping',
	    'minimumIntegerDigits',
	    'minimumFractionDigits',
	    'maximumFractionDigits',
	    'minimumSignificantDigits',
	    'maximumSignificantDigits',
	    // Unified NumberFormat (Stage 3 as of 10/22/19)
	    'compactDisplay',
	    'currencyDisplay',
	    'currencySign',
	    'notation',
	    'signDisplay',
	    'unit',
	    'unitDisplay',
	];
	function getFormatter(_a, getNumberFormat, options) {
	    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var format = options.format;
	    var defaults = ((format &&
	        utils_1.getNamedFormat(formats, 'number', format, onError)) ||
	        {});
	    var filteredOptions = utils_1.filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
	    return getNumberFormat(locale, filteredOptions);
	}
	exports.getFormatter = getFormatter;
	function formatNumber(config, getNumberFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    try {
	        return getFormatter(config, getNumberFormat, options).format(value);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting number.', e));
	    }
	    return String(value);
	}
	exports.formatNumber = formatNumber;
	function formatNumberToParts(config, getNumberFormat, value, options) {
	    if (options === void 0) { options = {}; }
	    try {
	        return getFormatter(config, getNumberFormat, options).formatToParts(value);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting number.', e));
	    }
	    return [];
	}
	exports.formatNumberToParts = formatNumberToParts;


/***/ }),
/* 6223 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(180);
	var PLURAL_FORMAT_OPTIONS = [
	    'localeMatcher',
	    'type',
	];
	function formatPlural(_a, getPluralRules, value, options) {
	    var locale = _a.locale, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    if (!Intl.PluralRules) {
	        onError(utils_1.createError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n"));
	    }
	    var filteredOptions = utils_1.filterProps(options, PLURAL_FORMAT_OPTIONS);
	    try {
	        return getPluralRules(locale, filteredOptions).select(value);
	    }
	    catch (e) {
	        onError(utils_1.createError('Error formatting plural.', e));
	    }
	    return 'other';
	}
	exports.formatPlural = formatPlural;


/***/ }),
/* 6224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var utils_1 = __webpack_require__(180);
	var RELATIVE_TIME_FORMAT_OPTIONS = [
	    'numeric',
	    'style',
	];
	function getFormatter(_a, getRelativeTimeFormat, options) {
	    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
	    if (options === void 0) { options = {}; }
	    var format = options.format;
	    var defaults = (!!format && utils_1.getNamedFormat(formats, 'relative', format, onError)) || {};
	    var filteredOptions = utils_1.filterProps(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
	    return getRelativeTimeFormat(locale, filteredOptions);
	}
	function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
	    if (options === void 0) { options = {}; }
	    if (!unit) {
	        unit = 'second';
	    }
	    var RelativeTimeFormat = Intl.RelativeTimeFormat;
	    if (!RelativeTimeFormat) {
	        config.onError(utils_1.createError("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n"));
	    }
	    try {
	        return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
	    }
	    catch (e) {
	        config.onError(utils_1.createError('Error formatting relative time.', e));
	    }
	    return String(value);
	}
	exports.formatRelativeTime = formatRelativeTime;


/***/ }),
/* 6225 */
1068,
/* 6226 */,
/* 6227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ns$jss$ns$sheetOptio;
	
	var _propTypes = __webpack_require__(2);
	
	var _ns = __webpack_require__(2792);
	
	var ns = _interopRequireWildcard(_ns);
	
	var _propTypes2 = __webpack_require__(6228);
	
	var _propTypes3 = _interopRequireDefault(_propTypes2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 6228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	exports['default'] = {
	  jss: (0, _propTypes.shape)({
	    options: (0, _propTypes.shape)({
	      createGenerateClassName: _propTypes.func.isRequired
	    }).isRequired,
	    createStyleSheet: _propTypes.func.isRequired,
	    removeStyleSheet: _propTypes.func.isRequired
	  }),
	  registry: (0, _propTypes.shape)({
	    add: _propTypes.func.isRequired,
	    toString: _propTypes.func.isRequired
	  })
	};

/***/ }),
/* 6229 */
[6835, 6231],
/* 6230 */
[6836, 6229],
/* 6231 */
6261,
/* 6232 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6230), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(require("prop-types"), require("react"));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(global.PropTypes, global.React);
	    global.ReactList = mod.exports;
	  }
	})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_propTypes, _react) {
	  "use strict";
	
	  _propTypes = _interopRequireDefault(_propTypes);
	  _react = _interopRequireWildcard(_react);
	
	  var _class, _temp;
	
	  function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	  var CLIENT_SIZE_KEYS = {
	    x: 'clientWidth',
	    y: 'clientHeight'
	  };
	  var CLIENT_START_KEYS = {
	    x: 'clientTop',
	    y: 'clientLeft'
	  };
	  var INNER_SIZE_KEYS = {
	    x: 'innerWidth',
	    y: 'innerHeight'
	  };
	  var OFFSET_SIZE_KEYS = {
	    x: 'offsetWidth',
	    y: 'offsetHeight'
	  };
	  var OFFSET_START_KEYS = {
	    x: 'offsetLeft',
	    y: 'offsetTop'
	  };
	  var OVERFLOW_KEYS = {
	    x: 'overflowX',
	    y: 'overflowY'
	  };
	  var SCROLL_SIZE_KEYS = {
	    x: 'scrollWidth',
	    y: 'scrollHeight'
	  };
	  var SCROLL_START_KEYS = {
	    x: 'scrollLeft',
	    y: 'scrollTop'
	  };
	  var SIZE_KEYS = {
	    x: 'width',
	    y: 'height'
	  };
	
	  var NOOP = function NOOP() {}; // If a browser doesn't support the `options` argument to
	  // add/removeEventListener, we need to check, otherwise we will
	  // accidentally set `capture` with a truthy value.
	
	
	  var PASSIVE = function () {
	    if (typeof window === 'undefined') return false;
	    var hasSupport = false;
	
	    try {
	      document.createElement('div').addEventListener('test', NOOP, {
	        get passive() {
	          hasSupport = true;
	          return false;
	        }
	
	      });
	    } catch (e) {// noop
	    }
	
	    return hasSupport;
	  }() ? {
	    passive: true
	  } : false;
	  var UNSTABLE_MESSAGE = 'ReactList failed to reach a stable state.';
	  var MAX_SYNC_UPDATES = 40;
	
	  var isEqualSubset = function isEqualSubset(a, b) {
	    for (var key in b) {
	      if (a[key] !== b[key]) return false;
	    }
	
	    return true;
	  };
	
	  var defaultScrollParentGetter = function defaultScrollParentGetter(component) {
	    var axis = component.props.axis;
	    var el = component.getEl();
	    var overflowKey = OVERFLOW_KEYS[axis];
	
	    while (el = el.parentElement) {
	      switch (window.getComputedStyle(el)[overflowKey]) {
	        case 'auto':
	        case 'scroll':
	        case 'overlay':
	          return el;
	      }
	    }
	
	    return window;
	  };
	
	  var defaultScrollParentViewportSizeGetter = function defaultScrollParentViewportSizeGetter(component) {
	    var axis = component.props.axis;
	    var scrollParent = component.scrollParent;
	    return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
	  };
	
	  var constrain = function constrain(props, state) {
	    var length = props.length,
	        minSize = props.minSize,
	        type = props.type;
	    var from = state.from,
	        size = state.size,
	        itemsPerRow = state.itemsPerRow;
	    size = Math.max(size, minSize);
	    var mod = size % itemsPerRow;
	    if (mod) size += itemsPerRow - mod;
	    if (size > length) size = length;
	    from = type === 'simple' || !from ? 0 : Math.max(Math.min(from, length - size), 0);
	
	    if (mod = from % itemsPerRow) {
	      from -= mod;
	      size += mod;
	    }
	
	    if (from === state.from && size == state.size) return state;
	    return _objectSpread(_objectSpread({}, state), {}, {
	      from: from,
	      size: size
	    });
	  };
	
	  module.exports = (_temp = _class = /*#__PURE__*/function (_Component) {
	    _inherits(ReactList, _Component);
	
	    var _super = _createSuper(ReactList);
	
	    _createClass(ReactList, null, [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(props, state) {
	        var newState = constrain(props, state);
	        return newState === state ? null : newState;
	      }
	    }]);
	
	    function ReactList(props) {
	      var _this;
	
	      _classCallCheck(this, ReactList);
	
	      _this = _super.call(this, props);
	      _this.state = constrain(props, {
	        itemsPerRow: 1,
	        from: props.initialIndex,
	        size: 0
	      });
	      _this.cache = {};
	      _this.cachedScrollPosition = null;
	      _this.prevPrevState = {};
	      _this.unstable = false;
	      _this.updateCounter = 0;
	      return _this;
	    }
	
	    _createClass(ReactList, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this);
	        window.addEventListener('resize', this.updateFrameAndClearCache);
	        this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        var _this2 = this;
	
	        // Viewport scroll is no longer useful if axis changes
	        if (this.props.axis !== prevProps.axis) this.clearSizeCache(); // If the list has reached an unstable state, prevent an infinite loop.
	
	        if (this.unstable) return;
	
	        if (++this.updateCounter > MAX_SYNC_UPDATES) {
	          this.unstable = true;
	          return console.error(UNSTABLE_MESSAGE);
	        }
	
	        if (!this.updateCounterTimeoutId) {
	          this.updateCounterTimeoutId = setTimeout(function () {
	            _this2.updateCounter = 0;
	            delete _this2.updateCounterTimeoutId;
	          }, 0);
	        }
	
	        this.updateFrame();
	      }
	    }, {
	      key: "maybeSetState",
	      value: function maybeSetState(b, cb) {
	        if (isEqualSubset(this.state, b)) return cb();
	        this.setState(b, cb);
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.updateFrameAndClearCache);
	        this.scrollParent.removeEventListener('scroll', this.updateFrameAndClearCache, PASSIVE);
	        this.scrollParent.removeEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: "getOffset",
	      value: function getOffset(el) {
	        var axis = this.props.axis;
	        var offset = el[CLIENT_START_KEYS[axis]] || 0;
	        var offsetKey = OFFSET_START_KEYS[axis];
	
	        do {
	          offset += el[offsetKey] || 0;
	        } while (el = el.offsetParent);
	
	        return offset;
	      }
	    }, {
	      key: "getEl",
	      value: function getEl() {
	        return this.el || this.items;
	      }
	    }, {
	      key: "getScrollPosition",
	      value: function getScrollPosition() {
	        // Cache scroll position as this causes a forced synchronous layout.
	        if (typeof this.cachedScrollPosition === 'number') {
	          return this.cachedScrollPosition;
	        }
	
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	        var scrollKey = SCROLL_START_KEYS[axis];
	        var actual = scrollParent === window ? // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
	        // always return document.documentElement[scrollKey] as 0, so take
	        // whichever has a value.
	        document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
	        var max = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this);
	        var scroll = Math.max(0, Math.min(actual, max));
	        var el = this.getEl();
	        this.cachedScrollPosition = this.getOffset(scrollParent) + scroll - this.getOffset(el);
	        return this.cachedScrollPosition;
	      }
	    }, {
	      key: "setScroll",
	      value: function setScroll(offset) {
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	        offset += this.getOffset(this.getEl());
	        if (scrollParent === window) return window.scrollTo(0, offset);
	        offset -= this.getOffset(this.scrollParent);
	        scrollParent[SCROLL_START_KEYS[axis]] = offset;
	      }
	    }, {
	      key: "getScrollSize",
	      value: function getScrollSize() {
	        var scrollParent = this.scrollParent;
	        var _document = document,
	            body = _document.body,
	            documentElement = _document.documentElement;
	        var key = SCROLL_SIZE_KEYS[this.props.axis];
	        return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
	      }
	    }, {
	      key: "hasDeterminateSize",
	      value: function hasDeterminateSize() {
	        var _this$props = this.props,
	            itemSizeGetter = _this$props.itemSizeGetter,
	            type = _this$props.type;
	        return type === 'uniform' || itemSizeGetter;
	      }
	    }, {
	      key: "getStartAndEnd",
	      value: function getStartAndEnd() {
	        var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.threshold;
	        var scroll = this.getScrollPosition();
	        var start = Math.max(0, scroll - threshold);
	        var end = scroll + this.props.scrollParentViewportSizeGetter(this) + threshold;
	
	        if (this.hasDeterminateSize()) {
	          end = Math.min(end, this.getSpaceBefore(this.props.length));
	        }
	
	        return {
	          start: start,
	          end: end
	        };
	      }
	    }, {
	      key: "getItemSizeAndItemsPerRow",
	      value: function getItemSizeAndItemsPerRow() {
	        var _this$props2 = this.props,
	            axis = _this$props2.axis,
	            useStaticSize = _this$props2.useStaticSize;
	        var _this$state = this.state,
	            itemSize = _this$state.itemSize,
	            itemsPerRow = _this$state.itemsPerRow;
	
	        if (useStaticSize && itemSize && itemsPerRow) {
	          return {
	            itemSize: itemSize,
	            itemsPerRow: itemsPerRow
	          };
	        }
	
	        var itemEls = this.items.children;
	        if (!itemEls.length) return {};
	        var firstEl = itemEls[0]; // Firefox has a problem where it will return a *slightly* (less than
	        // thousandths of a pixel) different size for the same element between
	        // renders. This can cause an infinite render loop, so only change the
	        // itemSize when it is significantly different.
	
	        var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
	        var delta = Math.abs(firstElSize - itemSize);
	        if (isNaN(delta) || delta >= 1) itemSize = firstElSize;
	        if (!itemSize) return {};
	        var startKey = OFFSET_START_KEYS[axis];
	        var firstStart = firstEl[startKey];
	        itemsPerRow = 1;
	
	        for (var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow]) {
	          ++itemsPerRow;
	        }
	
	        return {
	          itemSize: itemSize,
	          itemsPerRow: itemsPerRow
	        };
	      }
	    }, {
	      key: "clearSizeCache",
	      value: function clearSizeCache() {
	        this.cachedScrollPosition = null;
	      } // Called by 'scroll' and 'resize' events, clears scroll position cache.
	
	    }, {
	      key: "updateFrameAndClearCache",
	      value: function updateFrameAndClearCache(cb) {
	        this.clearSizeCache();
	        return this.updateFrame(cb);
	      }
	    }, {
	      key: "updateFrame",
	      value: function updateFrame(cb) {
	        this.updateScrollParent();
	        if (typeof cb != 'function') cb = NOOP;
	
	        switch (this.props.type) {
	          case 'simple':
	            return this.updateSimpleFrame(cb);
	
	          case 'variable':
	            return this.updateVariableFrame(cb);
	
	          case 'uniform':
	            return this.updateUniformFrame(cb);
	        }
	      }
	    }, {
	      key: "updateScrollParent",
	      value: function updateScrollParent() {
	        var prev = this.scrollParent;
	        this.scrollParent = this.props.scrollParentGetter(this);
	        if (prev === this.scrollParent) return;
	
	        if (prev) {
	          prev.removeEventListener('scroll', this.updateFrameAndClearCache);
	          prev.removeEventListener('mousewheel', NOOP);
	        } // If we have a new parent, cached parent dimensions are no longer useful.
	
	
	        this.clearSizeCache();
	        this.scrollParent.addEventListener('scroll', this.updateFrameAndClearCache, PASSIVE); // You have to attach mousewheel listener to the scrollable element.
	        // Just an empty listener. After that onscroll events will be fired synchronously.
	
	        this.scrollParent.addEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: "updateSimpleFrame",
	      value: function updateSimpleFrame(cb) {
	        var _this$getStartAndEnd = this.getStartAndEnd(),
	            end = _this$getStartAndEnd.end;
	
	        var itemEls = this.items.children;
	        var elEnd = 0;
	
	        if (itemEls.length) {
	          var axis = this.props.axis;
	          var firstItemEl = itemEls[0];
	          var lastItemEl = itemEls[itemEls.length - 1];
	          elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
	        }
	
	        if (elEnd > end) return cb();
	        var _this$props3 = this.props,
	            pageSize = _this$props3.pageSize,
	            length = _this$props3.length;
	        var size = Math.min(this.state.size + pageSize, length);
	        this.maybeSetState({
	          size: size
	        }, cb);
	      }
	    }, {
	      key: "updateVariableFrame",
	      value: function updateVariableFrame(cb) {
	        if (!this.props.itemSizeGetter) this.cacheSizes();
	
	        var _this$getStartAndEnd2 = this.getStartAndEnd(),
	            start = _this$getStartAndEnd2.start,
	            end = _this$getStartAndEnd2.end;
	
	        var _this$props4 = this.props,
	            length = _this$props4.length,
	            pageSize = _this$props4.pageSize;
	        var space = 0;
	        var from = 0;
	        var size = 0;
	        var maxFrom = length - 1;
	
	        while (from < maxFrom) {
	          var itemSize = this.getSizeOfItem(from);
	          if (itemSize == null || space + itemSize > start) break;
	          space += itemSize;
	          ++from;
	        }
	
	        var maxSize = length - from;
	
	        while (size < maxSize && space < end) {
	          var _itemSize = this.getSizeOfItem(from + size);
	
	          if (_itemSize == null) {
	            size = Math.min(size + pageSize, maxSize);
	            break;
	          }
	
	          space += _itemSize;
	          ++size;
	        }
	
	        this.maybeSetState(constrain(this.props, {
	          from: from,
	          itemsPerRow: 1,
	          size: size
	        }), cb);
	      }
	    }, {
	      key: "updateUniformFrame",
	      value: function updateUniformFrame(cb) {
	        var _this$getItemSizeAndI = this.getItemSizeAndItemsPerRow(),
	            itemSize = _this$getItemSizeAndI.itemSize,
	            itemsPerRow = _this$getItemSizeAndI.itemsPerRow;
	
	        if (!itemSize || !itemsPerRow) return cb();
	
	        var _this$getStartAndEnd3 = this.getStartAndEnd(),
	            start = _this$getStartAndEnd3.start,
	            end = _this$getStartAndEnd3.end;
	
	        var _constrain = constrain(this.props, {
	          from: Math.floor(start / itemSize) * itemsPerRow,
	          size: (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow,
	          itemsPerRow: itemsPerRow
	        }),
	            from = _constrain.from,
	            size = _constrain.size;
	
	        return this.maybeSetState({
	          itemsPerRow: itemsPerRow,
	          from: from,
	          itemSize: itemSize,
	          size: size
	        }, cb);
	      }
	    }, {
	      key: "getSpaceBefore",
	      value: function getSpaceBefore(index) {
	        var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        if (cache[index] != null) return cache[index]; // Try the static itemSize.
	
	        var _this$state2 = this.state,
	            itemSize = _this$state2.itemSize,
	            itemsPerRow = _this$state2.itemsPerRow;
	
	        if (itemSize) {
	          return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
	        } // Find the closest space to index there is a cached value for.
	
	
	        var from = index;
	
	        while (from > 0 && cache[--from] == null) {
	          ;
	        } // Finally, accumulate sizes of items from - index.
	
	
	        var space = cache[from] || 0;
	
	        for (var i = from; i < index; ++i) {
	          cache[i] = space;
	
	          var _itemSize2 = this.getSizeOfItem(i);
	
	          if (_itemSize2 == null) break;
	          space += _itemSize2;
	        }
	
	        return cache[index] = space;
	      }
	    }, {
	      key: "cacheSizes",
	      value: function cacheSizes() {
	        var cache = this.cache;
	        var from = this.state.from;
	        var itemEls = this.items.children;
	        var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
	
	        for (var i = 0, l = itemEls.length; i < l; ++i) {
	          cache[from + i] = itemEls[i][sizeKey];
	        }
	      }
	    }, {
	      key: "getSizeOfItem",
	      value: function getSizeOfItem(index) {
	        var cache = this.cache,
	            items = this.items;
	        var _this$props5 = this.props,
	            axis = _this$props5.axis,
	            itemSizeGetter = _this$props5.itemSizeGetter,
	            itemSizeEstimator = _this$props5.itemSizeEstimator,
	            type = _this$props5.type;
	        var _this$state3 = this.state,
	            from = _this$state3.from,
	            itemSize = _this$state3.itemSize,
	            size = _this$state3.size; // Try the static itemSize.
	
	        if (itemSize) return itemSize; // Try the itemSizeGetter.
	
	        if (itemSizeGetter) return itemSizeGetter(index); // Try the cache.
	
	        if (index in cache) return cache[index]; // Try the DOM.
	
	        if (type === 'simple' && index >= from && index < from + size && items) {
	          var itemEl = items.children[index - from];
	          if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
	        } // Try the itemSizeEstimator.
	
	
	        if (itemSizeEstimator) return itemSizeEstimator(index, cache);
	      }
	    }, {
	      key: "scrollTo",
	      value: function scrollTo(index) {
	        if (index != null) this.setScroll(this.getSpaceBefore(index));
	      }
	    }, {
	      key: "scrollAround",
	      value: function scrollAround(index) {
	        var current = this.getScrollPosition();
	        var bottom = this.getSpaceBefore(index);
	        var top = bottom - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(index);
	        var min = Math.min(top, bottom);
	        var max = Math.max(top, bottom);
	        if (current <= min) return this.setScroll(min);
	        if (current > max) return this.setScroll(max);
	      }
	    }, {
	      key: "getVisibleRange",
	      value: function getVisibleRange() {
	        var _this$state4 = this.state,
	            from = _this$state4.from,
	            size = _this$state4.size;
	
	        var _this$getStartAndEnd4 = this.getStartAndEnd(0),
	            start = _this$getStartAndEnd4.start,
	            end = _this$getStartAndEnd4.end;
	
	        var cache = {};
	        var first, last;
	
	        for (var i = from; i < from + size; ++i) {
	          var itemStart = this.getSpaceBefore(i, cache);
	          var itemEnd = itemStart + this.getSizeOfItem(i);
	          if (first == null && itemEnd > start) first = i;
	          if (first != null && itemStart < end) last = i;
	        }
	
	        return [first, last];
	      }
	    }, {
	      key: "renderItems",
	      value: function renderItems() {
	        var _this3 = this;
	
	        var _this$props6 = this.props,
	            itemRenderer = _this$props6.itemRenderer,
	            itemsRenderer = _this$props6.itemsRenderer;
	        var _this$state5 = this.state,
	            from = _this$state5.from,
	            size = _this$state5.size;
	        var items = [];
	
	        for (var i = 0; i < size; ++i) {
	          items.push(itemRenderer(from + i, i));
	        }
	
	        return itemsRenderer(items, function (c) {
	          return _this3.items = c;
	        });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this4 = this;
	
	        var _this$props7 = this.props,
	            axis = _this$props7.axis,
	            length = _this$props7.length,
	            type = _this$props7.type,
	            useTranslate3d = _this$props7.useTranslate3d;
	        var _this$state6 = this.state,
	            from = _this$state6.from,
	            itemsPerRow = _this$state6.itemsPerRow;
	        var items = this.renderItems();
	        if (type === 'simple') return items;
	        var style = {
	          position: 'relative'
	        };
	        var cache = {};
	        var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
	        var size = this.getSpaceBefore(bottom, cache);
	
	        if (size) {
	          style[SIZE_KEYS[axis]] = size;
	          if (axis === 'x') style.overflowX = 'hidden';
	        }
	
	        var offset = this.getSpaceBefore(from, cache);
	        var x = axis === 'x' ? offset : 0;
	        var y = axis === 'y' ? offset : 0;
	        var transform = useTranslate3d ? "translate3d(".concat(x, "px, ").concat(y, "px, 0)") : "translate(".concat(x, "px, ").concat(y, "px)");
	        var listStyle = {
	          msTransform: transform,
	          WebkitTransform: transform,
	          transform: transform
	        };
	        return /*#__PURE__*/_react["default"].createElement("div", {
	          style: style,
	          ref: function ref(c) {
	            return _this4.el = c;
	          }
	        }, /*#__PURE__*/_react["default"].createElement("div", {
	          style: listStyle
	        }, items));
	      }
	    }]);
	
	    return ReactList;
	  }(_react.Component), _defineProperty(_class, "displayName", 'ReactList'), _defineProperty(_class, "propTypes", {
	    axis: _propTypes["default"].oneOf(['x', 'y']),
	    initialIndex: _propTypes["default"].number,
	    itemRenderer: _propTypes["default"].func,
	    itemSizeEstimator: _propTypes["default"].func,
	    itemSizeGetter: _propTypes["default"].func,
	    itemsRenderer: _propTypes["default"].func,
	    length: _propTypes["default"].number,
	    minSize: _propTypes["default"].number,
	    pageSize: _propTypes["default"].number,
	    scrollParentGetter: _propTypes["default"].func,
	    scrollParentViewportSizeGetter: _propTypes["default"].func,
	    threshold: _propTypes["default"].number,
	    type: _propTypes["default"].oneOf(['simple', 'variable', 'uniform']),
	    useStaticSize: _propTypes["default"].bool,
	    useTranslate3d: _propTypes["default"].bool
	  }), _defineProperty(_class, "defaultProps", {
	    axis: 'y',
	    itemRenderer: function itemRenderer(index, key) {
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        key: key
	      }, index);
	    },
	    itemsRenderer: function itemsRenderer(items, ref) {
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        ref: ref
	      }, items);
	    },
	    length: 0,
	    minSize: 1,
	    pageSize: 10,
	    scrollParentGetter: defaultScrollParentGetter,
	    scrollParentViewportSizeGetter: defaultScrollParentViewportSizeGetter,
	    threshold: 100,
	    type: 'simple',
	    useStaticSize: false,
	    useTranslate3d: false
	  }), _temp);
	});


/***/ }),
/* 6233 */
[6835, 6235],
/* 6234 */
[6836, 6233],
/* 6235 */
6261,
/* 6236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _resizeObserverPolyfill = __webpack_require__(6476);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _getNodeDimensions = __webpack_require__(5317);
	
	var _getNodeDimensions2 = _interopRequireDefault(_getNodeDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Measure = function (_Component) {
	  _inherits(Measure, _Component);
	
	  function Measure(props) {
	    _classCallCheck(this, Measure);
	
	    var _this = _possibleConstructorReturn(this, (Measure.__proto__ || Object.getPrototypeOf(Measure)).call(this, props));
	
	    _this.measure = function () {
	      var includeMargin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.includeMargin;
	      var useClone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.useClone;
	
	      // bail out if we shouldn't measure
	      if (!_this.props.shouldMeasure) return;
	
	      // if no parent available we need to requery the DOM node
	      if (!_this._node.parentNode) {
	        _this._setDOMNode();
	      }
	
	      var dimensions = _this.getDimensions(_this._node, includeMargin, useClone);
	      var isChildFunction = typeof _this.props.children === 'function';
	
	      // determine if we need to update our callback with new dimensions or not
	      _this._propsToMeasure.some(function (prop) {
	        if (dimensions[prop] !== _this._lastDimensions[prop]) {
	          // update our callback if we've found a dimension that has changed
	          _this.props.onMeasure(dimensions);
	
	          // update state to send dimensions to child function
	          if (isChildFunction && typeof _this !== 'undefined') {
	            _this.setState({ dimensions: dimensions });
	          }
	
	          // store last dimensions to compare changes
	          _this._lastDimensions = dimensions;
	
	          // we don't need to look any further, bail out
	          return true;
	        }
	      });
	    };
	
	    _this.state = {
	      dimensions: {
	        width: 0,
	        height: 0,
	        top: 0,
	        right: 0,
	        bottom: 0,
	        left: 0
	      }
	    };
	    _this._node = null;
	    _this._propsToMeasure = _this._getPropsToMeasure(props);
	    _this._lastDimensions = {};
	    return _this;
	  }
	
	  _createClass(Measure, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this._setDOMNode();
	
	      // measure on first render
	      this.measure();
	
	      // add component to resize observer to detect changes on resize
	      this.resizeObserver = new _resizeObserverPolyfill2.default(function () {
	        return _this2.measure();
	      });
	      this.resizeObserver.observe(this._node);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var config = _ref.config,
	          whitelist = _ref.whitelist,
	          blacklist = _ref.blacklist;
	
	      // we store the properties ourselves so we need to update them if the
	      // whitelist or blacklist props have changed
	      if (this.props.whitelist !== whitelist || this.props.blacklist !== blacklist) {
	        this._propsToMeasure = this._getPropsToMeasure({ whitelist: whitelist, blacklist: blacklist });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.resizeObserver.disconnect(this._node);
	      this._node = null;
	    }
	  }, {
	    key: '_setDOMNode',
	    value: function _setDOMNode() {
	      this._node = _reactDom2.default.findDOMNode(this);
	    }
	  }, {
	    key: 'getDimensions',
	    value: function getDimensions() {
	      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._node;
	      var includeMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.includeMargin;
	      var useClone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.useClone;
	      var cloneOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.props.cloneOptions;
	
	      return (0, _getNodeDimensions2.default)(node, _extends({
	        margin: includeMargin,
	        clone: useClone
	      }, cloneOptions));
	    }
	  }, {
	    key: '_getPropsToMeasure',
	    value: function _getPropsToMeasure(_ref2) {
	      var whitelist = _ref2.whitelist,
	          blacklist = _ref2.blacklist;
	
	      return whitelist.filter(function (prop) {
	        return blacklist.indexOf(prop) < 0;
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      return _react.Children.only(typeof children === 'function' ? children(this.state.dimensions) : children);
	    }
	  }]);
	
	  return Measure;
	}(_react.Component);
	
	Measure.propTypes = {
	  whitelist: _propTypes2.default.array,
	  blacklist: _propTypes2.default.array,
	  includeMargin: _propTypes2.default.bool,
	  useClone: _propTypes2.default.bool,
	  cloneOptions: _propTypes2.default.object,
	  shouldMeasure: _propTypes2.default.bool,
	  onMeasure: _propTypes2.default.func
	};
	Measure.defaultProps = {
	  whitelist: ['width', 'height', 'top', 'right', 'bottom', 'left'],
	  blacklist: [],
	  includeMargin: true,
	  useClone: false,
	  cloneOptions: {},
	  shouldMeasure: true,
	  onMeasure: function onMeasure() {
	    return null;
	  }
	};
	exports.default = Measure;
	module.exports = exports['default'];

/***/ }),
/* 6237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Measure = __webpack_require__(6236);
	
	var _Measure2 = _interopRequireDefault(_Measure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Measure2.default;
	module.exports = exports['default'];

/***/ }),
/* 6238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(71);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ }),
/* 6239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Arrow = function Arrow(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'span' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	
	  var popper = context.popper;
	
	  var arrowRef = function arrowRef(node) {
	    popper.setArrowNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	  var arrowStyle = popper.getArrowStyle();
	
	  if (typeof children === 'function') {
	    var arrowProps = {
	      ref: arrowRef,
	      style: arrowStyle
	    };
	    return children({ arrowProps: arrowProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps, {
	    style: _extends({}, arrowStyle, restProps.style)
	  });
	
	  if (typeof component === 'string') {
	    componentProps.ref = arrowRef;
	  } else {
	    componentProps.innerRef = arrowRef;
	  }
	
	  return (0, _react.createElement)(component, componentProps, children);
	};
	
	Arrow.contextTypes = {
	  popper: _propTypes2.default.object.isRequired
	};
	
	Arrow.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	
	exports.default = Arrow;

/***/ }),
/* 6240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manager = function (_Component) {
	  _inherits(Manager, _Component);
	
	  function Manager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Manager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
	      _this._targetNode = node;
	    }, _this._getTargetNode = function () {
	      return _this._targetNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Manager, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popperManager: {
	          setTargetNode: this._setTargetNode,
	          getTargetNode: this._getTargetNode
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          tag = _props.tag,
	          children = _props.children,
	          restProps = _objectWithoutProperties(_props, ['tag', 'children']);
	
	      if (tag !== false) {
	        return (0, _react.createElement)(tag, restProps, children);
	      } else {
	        return children;
	      }
	    }
	  }]);
	
	  return Manager;
	}(_react.Component);
	
	Manager.childContextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	Manager.propTypes = {
	  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
	};
	Manager.defaultProps = {
	  tag: 'div'
	};
	exports.default = Manager;

/***/ }),
/* 6241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _popper = __webpack_require__(5694);
	
	var _popper2 = _interopRequireDefault(_popper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Popper = function (_Component) {
	  _inherits(Popper, _Component);
	
	  function Popper() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Popper);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
	      _this._arrowNode = node;
	    }, _this._getTargetNode = function () {
	      return _this.context.popperManager.getTargetNode();
	    }, _this._getOffsets = function (data) {
	      return Object.keys(data.offsets).map(function (key) {
	        return data.offsets[key];
	      });
	    }, _this._isDataDirty = function (data) {
	      if (_this.state.data) {
	        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
	      } else {
	        return true;
	      }
	    }, _this._updateStateModifier = {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        if (_this._isDataDirty(data)) {
	          _this.setState({ data: data });
	        }
	        return data;
	      }
	    }, _this._getPopperStyle = function () {
	      var data = _this.state.data;
	
	      // If Popper isn't instantiated, hide the popperElement
	      // to avoid flash of unstyled content
	
	      if (!data) {
	        return {
	          position: 'absolute',
	          pointerEvents: 'none',
	          opacity: 0
	        };
	      }
	
	      var _data$offsets$popper = data.offsets.popper,
	          top = _data$offsets$popper.top,
	          left = _data$offsets$popper.left,
	          position = _data$offsets$popper.position;
	
	
	      return _extends({
	        position: position
	      }, data.styles);
	    }, _this._getPopperPlacement = function () {
	      return _this.state.data ? _this.state.data.placement : undefined;
	    }, _this._getPopperHide = function () {
	      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
	    }, _this._getArrowStyle = function () {
	      if (!_this.state.data || !_this.state.data.offsets.arrow) {
	        return {};
	      } else {
	        var _this$state$data$offs = _this.state.data.offsets.arrow,
	            top = _this$state$data$offs.top,
	            left = _this$state$data$offs.left;
	
	        return { top: top, left: left };
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Popper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        popper: {
	          setArrowNode: this._setArrowNode,
	          getArrowStyle: this._getArrowStyle
	        }
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(lastProps) {
	      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
	        this._destroyPopper();
	        this._createPopper();
	      }
	
	      if (lastProps.children !== this.props.children) {
	        this._popper.scheduleUpdate();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroyPopper();
	    }
	  }, {
	    key: '_createPopper',
	    value: function _createPopper() {
	      var _props = this.props,
	          placement = _props.placement,
	          eventsEnabled = _props.eventsEnabled;
	
	      var modifiers = _extends({}, this.props.modifiers, {
	        applyStyle: { enabled: false },
	        updateState: this._updateStateModifier
	      });
	
	      if (this._arrowNode) {
	        modifiers.arrow = {
	          element: this._arrowNode
	        };
	      }
	
	      this._popper = new _popper2.default(this._getTargetNode(), this._node, {
	        placement: placement,
	        eventsEnabled: eventsEnabled,
	        modifiers: modifiers
	      });
	
	      // schedule an update to make sure everything gets positioned correctly
	      // after being instantiated
	      this._popper.scheduleUpdate();
	    }
	  }, {
	    key: '_destroyPopper',
	    value: function _destroyPopper() {
	      if (this._popper) {
	        this._popper.destroy();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          component = _props2.component,
	          innerRef = _props2.innerRef,
	          placement = _props2.placement,
	          eventsEnabled = _props2.eventsEnabled,
	          modifiers = _props2.modifiers,
	          children = _props2.children,
	          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);
	
	      var popperRef = function popperRef(node) {
	        _this2._node = node;
	        if (node) {
	          _this2._createPopper();
	        } else {
	          _this2._destroyPopper();
	        }
	        if (typeof innerRef === 'function') {
	          innerRef(node);
	        }
	      };
	      var popperStyle = this._getPopperStyle();
	      var popperPlacement = this._getPopperPlacement();
	      var popperHide = this._getPopperHide();
	
	      if (typeof children === 'function') {
	        var _popperProps;
	
	        var popperProps = (_popperProps = {
	          ref: popperRef,
	          style: popperStyle
	        }, _defineProperty(_popperProps, 'data-placement', popperPlacement), _defineProperty(_popperProps, 'data-x-out-of-boundaries', popperHide), _popperProps);
	
	        return children({
	          popperProps: popperProps,
	          restProps: restProps,
	          scheduleUpdate: function scheduleUpdate() {
	            // _createPopper will scheduleUpdate,
	            // so calling this before this._popper exists
	            // can be a noop.
	            _this2._popper && _this2._popper.scheduleUpdate();
	          }
	        });
	      }
	
	      var componentProps = _extends({}, restProps, {
	        style: _extends({}, restProps.style, popperStyle),
	        'data-placement': popperPlacement,
	        'data-x-out-of-boundaries': popperHide
	      });
	
	      if (typeof component === 'string') {
	        componentProps.ref = popperRef;
	      } else {
	        componentProps.innerRef = popperRef;
	      }
	
	      return (0, _react.createElement)(component, componentProps, children);
	    }
	  }]);
	
	  return Popper;
	}(_react.Component);
	
	Popper.contextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	Popper.childContextTypes = {
	  popper: _propTypes2.default.object.isRequired
	};
	Popper.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  placement: _propTypes2.default.oneOf(_popper2.default.placements),
	  eventsEnabled: _propTypes2.default.bool,
	  modifiers: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	Popper.defaultProps = {
	  component: 'div',
	  placement: 'bottom',
	  eventsEnabled: true,
	  modifiers: {}
	};
	exports.default = Popper;

/***/ }),
/* 6242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Target = function Target(props, context) {
	  var _props$component = props.component,
	      component = _props$component === undefined ? 'div' : _props$component,
	      innerRef = props.innerRef,
	      children = props.children,
	      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);
	
	  var popperManager = context.popperManager;
	
	  var targetRef = function targetRef(node) {
	    popperManager.setTargetNode(node);
	    if (typeof innerRef === 'function') {
	      innerRef(node);
	    }
	  };
	
	  if (typeof children === 'function') {
	    var targetProps = { ref: targetRef };
	    return children({ targetProps: targetProps, restProps: restProps });
	  }
	
	  var componentProps = _extends({}, restProps);
	
	  if (typeof component === 'string') {
	    componentProps.ref = targetRef;
	  } else {
	    componentProps.innerRef = targetRef;
	  }
	
	  return (0, _react.createElement)(component, componentProps, children);
	};
	
	Target.contextTypes = {
	  popperManager: _propTypes2.default.object.isRequired
	};
	
	Target.propTypes = {
	  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  innerRef: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
	};
	
	exports.default = Target;

/***/ }),
/* 6243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;
	
	var _Manager2 = __webpack_require__(6240);
	
	var _Manager3 = _interopRequireDefault(_Manager2);
	
	var _Target2 = __webpack_require__(6242);
	
	var _Target3 = _interopRequireDefault(_Target2);
	
	var _Popper2 = __webpack_require__(6241);
	
	var _Popper3 = _interopRequireDefault(_Popper2);
	
	var _Arrow2 = __webpack_require__(6239);
	
	var _Arrow3 = _interopRequireDefault(_Arrow2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Manager = _Manager3.default;
	exports.Target = _Target3.default;
	exports.Popper = _Popper3.default;
	exports.Arrow = _Arrow3.default;

/***/ }),
/* 6244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropToggle = __webpack_require__(2793);
	
	var _PropToggle2 = _interopRequireDefault(_PropToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var LifeCycleProvider = function LifeCycleProvider(_ref) {
	  var isActive = _ref.isActive,
	      props = _objectWithoutProperties(_ref, ['isActive']);
	
	  return isActive ? _react2.default.createElement(_PropToggle2.default, props) : null;
	};
	
	LifeCycleProvider.defaultProps = _PropToggle.defaultProps;
	
	exports.default = LifeCycleProvider;

/***/ }),
/* 6245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LifeCycleProvider = __webpack_require__(6244);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LifeCycleProvider).default;
	  }
	});
	
	var _PropToggle = __webpack_require__(2793);
	
	Object.defineProperty(exports, 'SimpleToggle', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PropToggle).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 6246 */,
/* 6247 */,
/* 6248 */,
/* 6249 */,
/* 6250 */,
/* 6251 */,
/* 6252 */,
/* 6253 */,
/* 6254 */,
/* 6255 */,
/* 6256 */,
/* 6257 */,
/* 6258 */,
/* 6259 */,
/* 6260 */,
/* 6261 */,
/* 6262 */,
/* 6263 */,
/* 6264 */,
/* 6265 */,
/* 6266 */,
/* 6267 */,
/* 6268 */,
/* 6269 */,
/* 6270 */,
/* 6271 */,
/* 6272 */,
/* 6273 */,
/* 6274 */,
/* 6275 */,
/* 6276 */,
/* 6277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(280);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _stifle = __webpack_require__(6484);
	
	var _stifle2 = _interopRequireDefault(_stifle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
		width: '100px',
		height: '100px',
		position: 'absolute',
		top: '-100000px',
		overflow: 'scroll',
		msOverflowStyle: 'scrollbar'
	};
	
	var ScrollbarSize = function (_Component) {
		(0, _inherits3.default)(ScrollbarSize, _Component);
	
		function ScrollbarSize() {
			var _ref;
	
			var _temp, _this, _ret;
	
			(0, _classCallCheck3.default)(this, ScrollbarSize);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScrollbarSize.__proto__ || (0, _getPrototypeOf2.default)(ScrollbarSize)).call.apply(_ref, [this].concat(args))), _this), _this.setMeasurements = function () {
				_this.scrollbarHeight = _this.node.offsetHeight - _this.node.clientHeight;
				_this.scrollbarWidth = _this.node.offsetWidth - _this.node.clientWidth;
			}, _this.handleResize = (0, _stifle2.default)(function () {
				var onChange = _this.props.onChange;
	
	
				var prevHeight = _this.scrollbarHeight;
				var prevWidth = _this.scrollbarWidth;
				_this.setMeasurements();
				if (prevHeight !== _this.scrollbarHeight || prevWidth !== _this.scrollbarWidth) {
					onChange({ scrollbarHeight: _this.scrollbarHeight, scrollbarWidth: _this.scrollbarWidth });
				}
			}, 166), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
		}
	
		(0, _createClass3.default)(ScrollbarSize, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var onLoad = this.props.onLoad;
	
	
				if (onLoad) {
					this.setMeasurements();
					onLoad({ scrollbarHeight: this.scrollbarHeight, scrollbarWidth: this.scrollbarWidth });
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.handleResize.cancel();
			}
		}, {
			key: 'render',
			// Corresponds to 10 frames at 60 Hz.
	
			value: function render() {
				var _this2 = this;
	
				var onChange = this.props.onChange;
	
	
				return _react2.default.createElement(
					'div',
					null,
					onChange ? _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }) : null,
					_react2.default.createElement('div', {
						style: styles,
						ref: function ref(node) {
							_this2.node = node;
						}
					})
				);
			}
		}]);
		return ScrollbarSize;
	}(_react.Component);
	
	ScrollbarSize.defaultProps = {
		onLoad: null,
		onChange: null
	};
	exports.default = ScrollbarSize;

/***/ }),
/* 6278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScrollbarSize = __webpack_require__(6277);
	
	var _ScrollbarSize2 = _interopRequireDefault(_ScrollbarSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ScrollbarSize2.default;

/***/ }),
/* 6279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(1484);
	
	var _reactPropToggle = __webpack_require__(6245);
	
	var _utils = __webpack_require__(2816);
	
	var _withTouchListeners = __webpack_require__(6281);
	
	var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LOCK_COUNT = 0;
	
	var ScrollLock = function (_PureComponent) {
	  _inherits(ScrollLock, _PureComponent);
	
	  function ScrollLock() {
	    _classCallCheck(this, ScrollLock);
	
	    return _possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
	  }
	
	  _createClass(ScrollLock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      LOCK_COUNT++;
	      if (_exenv.canUseDOM) {
	        this.initialHeight = window.innerHeight;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      LOCK_COUNT = Math.max(LOCK_COUNT - 1, 0);
	
	      if (_exenv.canUseDOM) {
	        var offset = window.innerHeight - this.initialHeight;
	
	        // adjust scroll if the window has been resized since the lock was engaged
	        if (offset) {
	          window.scrollTo(0, window.pageYOffset + offset);
	        }
	      }
	
	      // reset the initial height in case this scroll lock is used again
	      this.initialHeight = window.innerHeight;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var accountForScrollbars = this.props.accountForScrollbars;
	
	      // avoid overly incrementing padding
	
	      var scrollbarSpacer = accountForScrollbars && LOCK_COUNT < 1 ? { 'padding-right': (0, _utils.getPadding)() + 'px' } : {};
	
	      var height = (0, _utils.getDocumentHeight)() + 'px';
	
	      return _react2.default.createElement(_reactPropToggle.SimpleToggle, {
	        styles: _extends({
	          'box-sizing': 'border-box', // account for possible declaration `width: 100%;` on body
	          overflow: 'hidden',
	          position: 'relative',
	          height: height
	        }, scrollbarSpacer)
	      });
	    }
	  }]);
	
	  return ScrollLock;
	}(_react.PureComponent);
	
	ScrollLock.defaultProps = {
	  accountForScrollbars: true
	};
	exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),
/* 6280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScrollLock = __webpack_require__(6279);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScrollLock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 6281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withTouchListeners;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(1484);
	
	var _utils = __webpack_require__(2816);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withTouchListeners(WrappedComponent) {
	  return function (_PureComponent) {
	    _inherits(TouchProvider, _PureComponent);
	
	    function TouchProvider() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TouchProvider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
	        capture: false,
	        passive: false
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TouchProvider, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // account for touch devices
	        if (target && (0, _utils.isTouchDevice)()) {
	          // Mobile Safari ignores { overflow: hidden } declaration on the body.
	          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          // Allow scroll on provided target
	          if (touchScrollTarget) {
	            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // remove touch listeners
	        if (target && (0, _utils.isTouchDevice)()) {
	          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          if (touchScrollTarget) {
	            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	    }]);
	
	    return TouchProvider;
	  }(_react.PureComponent);
	}

/***/ }),
/* 6282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(1043));
	var _extends = _interopDefault(__webpack_require__(1040));
	var _slicedToArray = _interopDefault(__webpack_require__(2819));
	var _toConsumableArray = _interopDefault(__webpack_require__(2821));
	var _defineProperty = _interopDefault(__webpack_require__(1628));
	var _classCallCheck = _interopDefault(__webpack_require__(1038));
	var _createClass = _interopDefault(__webpack_require__(1039));
	var _assertThisInitialized = _interopDefault(__webpack_require__(1627));
	var _inherits = _interopDefault(__webpack_require__(1042));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(1044));
	var _getPrototypeOf = _interopDefault(__webpack_require__(1041));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var memoizeOne = _interopDefault(__webpack_require__(2402));
	var core = __webpack_require__(1629);
	var reactDom = __webpack_require__(71);
	var index = __webpack_require__(2817);
	var _css = _interopDefault(__webpack_require__(486));
	
	var diacritics = [{
	  base: 'A',
	  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
	}, {
	  base: 'AA',
	  letters: "\uA732"
	}, {
	  base: 'AE',
	  letters: "\xC6\u01FC\u01E2"
	}, {
	  base: 'AO',
	  letters: "\uA734"
	}, {
	  base: 'AU',
	  letters: "\uA736"
	}, {
	  base: 'AV',
	  letters: "\uA738\uA73A"
	}, {
	  base: 'AY',
	  letters: "\uA73C"
	}, {
	  base: 'B',
	  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
	}, {
	  base: 'C',
	  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
	}, {
	  base: 'D',
	  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
	}, {
	  base: 'DZ',
	  letters: "\u01F1\u01C4"
	}, {
	  base: 'Dz',
	  letters: "\u01F2\u01C5"
	}, {
	  base: 'E',
	  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
	}, {
	  base: 'F',
	  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
	}, {
	  base: 'G',
	  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
	}, {
	  base: 'H',
	  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
	}, {
	  base: 'I',
	  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
	}, {
	  base: 'J',
	  letters: "J\u24BF\uFF2A\u0134\u0248"
	}, {
	  base: 'K',
	  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
	}, {
	  base: 'L',
	  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
	}, {
	  base: 'LJ',
	  letters: "\u01C7"
	}, {
	  base: 'Lj',
	  letters: "\u01C8"
	}, {
	  base: 'M',
	  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
	}, {
	  base: 'N',
	  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
	}, {
	  base: 'NJ',
	  letters: "\u01CA"
	}, {
	  base: 'Nj',
	  letters: "\u01CB"
	}, {
	  base: 'O',
	  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
	}, {
	  base: 'OI',
	  letters: "\u01A2"
	}, {
	  base: 'OO',
	  letters: "\uA74E"
	}, {
	  base: 'OU',
	  letters: "\u0222"
	}, {
	  base: 'P',
	  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
	}, {
	  base: 'Q',
	  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
	}, {
	  base: 'R',
	  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
	}, {
	  base: 'S',
	  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
	}, {
	  base: 'T',
	  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
	}, {
	  base: 'TZ',
	  letters: "\uA728"
	}, {
	  base: 'U',
	  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
	}, {
	  base: 'V',
	  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
	}, {
	  base: 'VY',
	  letters: "\uA760"
	}, {
	  base: 'W',
	  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
	}, {
	  base: 'X',
	  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
	}, {
	  base: 'Y',
	  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
	}, {
	  base: 'Z',
	  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
	}, {
	  base: 'a',
	  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
	}, {
	  base: 'aa',
	  letters: "\uA733"
	}, {
	  base: 'ae',
	  letters: "\xE6\u01FD\u01E3"
	}, {
	  base: 'ao',
	  letters: "\uA735"
	}, {
	  base: 'au',
	  letters: "\uA737"
	}, {
	  base: 'av',
	  letters: "\uA739\uA73B"
	}, {
	  base: 'ay',
	  letters: "\uA73D"
	}, {
	  base: 'b',
	  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
	}, {
	  base: 'c',
	  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
	}, {
	  base: 'd',
	  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
	}, {
	  base: 'dz',
	  letters: "\u01F3\u01C6"
	}, {
	  base: 'e',
	  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
	}, {
	  base: 'f',
	  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
	}, {
	  base: 'g',
	  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
	}, {
	  base: 'h',
	  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
	}, {
	  base: 'hv',
	  letters: "\u0195"
	}, {
	  base: 'i',
	  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
	}, {
	  base: 'j',
	  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
	}, {
	  base: 'k',
	  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
	}, {
	  base: 'l',
	  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
	}, {
	  base: 'lj',
	  letters: "\u01C9"
	}, {
	  base: 'm',
	  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
	}, {
	  base: 'n',
	  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
	}, {
	  base: 'nj',
	  letters: "\u01CC"
	}, {
	  base: 'o',
	  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
	}, {
	  base: 'oi',
	  letters: "\u01A3"
	}, {
	  base: 'ou',
	  letters: "\u0223"
	}, {
	  base: 'oo',
	  letters: "\uA74F"
	}, {
	  base: 'p',
	  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
	}, {
	  base: 'q',
	  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
	}, {
	  base: 'r',
	  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
	}, {
	  base: 's',
	  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
	}, {
	  base: 't',
	  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
	}, {
	  base: 'tz',
	  letters: "\uA729"
	}, {
	  base: 'u',
	  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
	}, {
	  base: 'v',
	  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
	}, {
	  base: 'vy',
	  letters: "\uA761"
	}, {
	  base: 'w',
	  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
	}, {
	  base: 'x',
	  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
	}, {
	  base: 'y',
	  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
	}, {
	  base: 'z',
	  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
	}];
	var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
	  return d.letters;
	}).join('') + ']', 'g');
	var diacriticToBase = {};
	
	for (var i = 0; i < diacritics.length; i++) {
	  var diacritic = diacritics[i];
	
	  for (var j = 0; j < diacritic.letters.length; j++) {
	    diacriticToBase[diacritic.letters[j]] = diacritic.base;
	  }
	}
	
	var stripDiacritics = function stripDiacritics(str) {
	  return str.replace(anyDiacritic, function (match) {
	    return diacriticToBase[match];
	  });
	};
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	var trimString = function trimString(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	var defaultStringify = function defaultStringify(option) {
	  return "".concat(option.label, " ").concat(option.value);
	};
	
	var createFilter = function createFilter(config) {
	  return function (option, rawInput) {
	    var _ignoreCase$ignoreAcc = _objectSpread({
	      ignoreCase: true,
	      ignoreAccents: true,
	      stringify: defaultStringify,
	      trim: true,
	      matchFrom: 'any'
	    }, config),
	        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
	        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
	        stringify = _ignoreCase$ignoreAcc.stringify,
	        trim = _ignoreCase$ignoreAcc.trim,
	        matchFrom = _ignoreCase$ignoreAcc.matchFrom;
	
	    var input = trim ? trimString(rawInput) : rawInput;
	    var candidate = trim ? trimString(stringify(option)) : stringify(option);
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	      candidate = candidate.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = stripDiacritics(input);
	      candidate = stripDiacritics(candidate);
	    }
	
	    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
	  };
	};
	
	function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
	
	var _ref =  true ? {
	  name: "1laao21-a11yText",
	  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
	} : {
	  name: "1laao21-a11yText",
	  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFJIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICA8c3BhblxuICAgIGNzcz17e1xuICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICB6SW5kZXg6IDk5OTksXG4gICAgICBib3JkZXI6IDAsXG4gICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgIGhlaWdodDogMSxcbiAgICAgIHdpZHRoOiAxLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgICBwYWRkaW5nOiAwLFxuICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgfX1cbiAgICB7Li4ucHJvcHN9XG4gIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */",
	  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
	};
	
	var A11yText = function A11yText(props) {
	  return core.jsx("span", _extends({
	    css: _ref
	  }, props));
	};
	
	function DummyInput(_ref) {
	  var inProp = _ref.in,
	      out = _ref.out,
	      onExited = _ref.onExited,
	      appear = _ref.appear,
	      enter = _ref.enter,
	      exit = _ref.exit,
	      innerRef = _ref.innerRef,
	      emotion = _ref.emotion,
	      props = _objectWithoutProperties(_ref, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);
	
	  return core.jsx("input", _extends({
	    ref: innerRef
	  }, props, {
	    css: /*#__PURE__*/_css({
	      label: 'dummyInput',
	      // get rid of any default styles
	      background: 0,
	      border: 0,
	      fontSize: 'inherit',
	      outline: 0,
	      padding: 0,
	      // important! without `width` browsers won't allow focus
	      width: 1,
	      // remove cursor on desktop
	      color: 'transparent',
	      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
	      left: -100,
	      opacity: 0,
	      position: 'relative',
	      transform: 'scale(0)'
	    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6IkR1bW15SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGluOiBpblByb3AsXG4gIG91dCxcbiAgb25FeGl0ZWQsXG4gIGFwcGVhcixcbiAgZW50ZXIsXG4gIGV4aXQsXG4gIGlubmVyUmVmLFxuICBlbW90aW9uLFxuICAuLi5wcm9wc1xufTogYW55KSB7XG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLnByb3BzfVxuICAgICAgY3NzPXt7XG4gICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgIC8vIGdldCByaWQgb2YgYW55IGRlZmF1bHQgc3R5bGVzXG4gICAgICAgIGJhY2tncm91bmQ6IDAsXG4gICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgZm9udFNpemU6ICdpbmhlcml0JyxcbiAgICAgICAgb3V0bGluZTogMCxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgLy8gaW1wb3J0YW50ISB3aXRob3V0IGB3aWR0aGAgYnJvd3NlcnMgd29uJ3QgYWxsb3cgZm9jdXNcbiAgICAgICAgd2lkdGg6IDEsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgIGNvbG9yOiAndHJhbnNwYXJlbnQnLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gbW9iaWxlIHdoaWxzdCBtYWludGFpbmluZyBcInNjcm9sbCBpbnRvIHZpZXdcIiBiZWhhdmlvdXJcbiAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgb3BhY2l0eTogMCxcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
	  }));
	}
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	var NodeResolver = /*#__PURE__*/function (_Component) {
	  _inherits(NodeResolver, _Component);
	
	  var _super = _createSuper(NodeResolver);
	
	  function NodeResolver() {
	    _classCallCheck(this, NodeResolver);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(NodeResolver, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.innerRef(reactDom.findDOMNode(this));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.props.innerRef(null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return NodeResolver;
	}(React.Component);
	
	var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
	var LOCK_STYLES = {
	  boxSizing: 'border-box',
	  // account for possible declaration `width: 100%;` on body
	  overflow: 'hidden',
	  position: 'relative',
	  height: '100%'
	};
	
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	} // `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	
	function isTouchDevice() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	var canUseDOM = !!( window.document && window.document.createElement);
	var activeScrollLocks = 0;
	
	var ScrollLock = /*#__PURE__*/function (_Component) {
	  _inherits(ScrollLock, _Component);
	
	  var _super = _createSuper$1(ScrollLock);
	
	  function ScrollLock() {
	    var _this;
	
	    _classCallCheck(this, ScrollLock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	    _this.originalStyles = {};
	    _this.listenerOptions = {
	      capture: false,
	      passive: false
	    };
	    return _this;
	  }
	
	  _createClass(ScrollLock, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!canUseDOM) return;
	      var _this$props = this.props,
	          accountForScrollbars = _this$props.accountForScrollbars,
	          touchScrollTarget = _this$props.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style;
	
	      if (accountForScrollbars) {
	        // store any styles already applied to the body
	        STYLE_KEYS.forEach(function (key) {
	          var val = targetStyle && targetStyle[key];
	          _this2.originalStyles[key] = val;
	        });
	      } // apply the lock styles and padding if this is the first scroll lock
	
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
	        var clientWidth = document.body ? document.body.clientWidth : 0;
	        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	        Object.keys(LOCK_STYLES).forEach(function (key) {
	          var val = LOCK_STYLES[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	
	        if (targetStyle) {
	          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
	        }
	      } // account for touch devices
	
	
	      if (target && isTouchDevice()) {
	        // Mobile Safari ignores { overflow: hidden } declaration on the body.
	        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target
	
	        if (touchScrollTarget) {
	          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
	        }
	      } // increment active scroll locks
	
	
	      activeScrollLocks += 1;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this3 = this;
	
	      if (!canUseDOM) return;
	      var _this$props2 = this.props,
	          accountForScrollbars = _this$props2.accountForScrollbars,
	          touchScrollTarget = _this$props2.touchScrollTarget;
	      var target = document.body;
	      var targetStyle = target && target.style; // safely decrement active scroll locks
	
	      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any
	
	      if (accountForScrollbars && activeScrollLocks < 1) {
	        STYLE_KEYS.forEach(function (key) {
	          var val = _this3.originalStyles[key];
	
	          if (targetStyle) {
	            targetStyle[key] = val;
	          }
	        });
	      } // remove touch listeners
	
	
	      if (target && isTouchDevice()) {
	        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);
	
	        if (touchScrollTarget) {
	          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
	          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ScrollLock;
	}(React.Component);
	
	ScrollLock.defaultProps = {
	  accountForScrollbars: true
	};
	
	function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
	
	function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	var _ref$1 =  true ? {
	  name: "1dsbpcp",
	  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
	} : {
	  name: "1dsbpcp",
	  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
	  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
	};
	
	// NOTE:
	// We shouldn't need this after updating to React v16.3.0, which introduces:
	// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
	// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
	var ScrollBlock = /*#__PURE__*/function (_PureComponent) {
	  _inherits(ScrollBlock, _PureComponent);
	
	  var _super = _createSuper$2(ScrollBlock);
	
	  function ScrollBlock() {
	    var _this;
	
	    _classCallCheck(this, ScrollBlock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	    _this.state = {
	      touchScrollTarget: null
	    };
	
	    _this.getScrollTarget = function (ref) {
	      if (ref === _this.state.touchScrollTarget) return;
	
	      _this.setState({
	        touchScrollTarget: ref
	      });
	    };
	
	    _this.blurSelectInput = function () {
	      if (document.activeElement) {
	        document.activeElement.blur();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(ScrollBlock, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          isEnabled = _this$props.isEnabled;
	      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
	
	      if (!isEnabled) return children;
	      /*
	       * Div
	       * ------------------------------
	       * blocks scrolling on non-body elements behind the menu
	        * NodeResolver
	       * ------------------------------
	       * we need a reference to the scrollable element to "unlock" scroll on
	       * mobile devices
	        * ScrollLock
	       * ------------------------------
	       * actually does the scroll locking
	       */
	
	      return core.jsx("div", null, core.jsx("div", {
	        onClick: this.blurSelectInput,
	        css: _ref$1
	      }), core.jsx(NodeResolver, {
	        innerRef: this.getScrollTarget
	      }, children), touchScrollTarget ? core.jsx(ScrollLock, {
	        touchScrollTarget: touchScrollTarget
	      }) : null);
	    }
	  }]);
	
	  return ScrollBlock;
	}(React.PureComponent);
	
	function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	var ScrollCaptor = /*#__PURE__*/function (_Component) {
	  _inherits(ScrollCaptor, _Component);
	
	  var _super = _createSuper$3(ScrollCaptor);
	
	  function ScrollCaptor() {
	    var _this;
	
	    _classCallCheck(this, ScrollCaptor);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	    _this.isBottom = false;
	    _this.isTop = false;
	    _this.scrollTarget = void 0;
	    _this.touchStart = void 0;
	
	    _this.cancelScroll = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    };
	
	    _this.handleEventDelta = function (event, delta) {
	      var _this$props = _this.props,
	          onBottomArrive = _this$props.onBottomArrive,
	          onBottomLeave = _this$props.onBottomLeave,
	          onTopArrive = _this$props.onTopArrive,
	          onTopLeave = _this$props.onTopLeave;
	      var _this$scrollTarget = _this.scrollTarget,
	          scrollTop = _this$scrollTarget.scrollTop,
	          scrollHeight = _this$scrollTarget.scrollHeight,
	          clientHeight = _this$scrollTarget.clientHeight;
	      var target = _this.scrollTarget;
	      var isDeltaPositive = delta > 0;
	      var availableScroll = scrollHeight - clientHeight - scrollTop;
	      var shouldCancelScroll = false; // reset bottom/top flags
	
	      if (availableScroll > delta && _this.isBottom) {
	        if (onBottomLeave) onBottomLeave(event);
	        _this.isBottom = false;
	      }
	
	      if (isDeltaPositive && _this.isTop) {
	        if (onTopLeave) onTopLeave(event);
	        _this.isTop = false;
	      } // bottom limit
	
	
	      if (isDeltaPositive && delta > availableScroll) {
	        if (onBottomArrive && !_this.isBottom) {
	          onBottomArrive(event);
	        }
	
	        target.scrollTop = scrollHeight;
	        shouldCancelScroll = true;
	        _this.isBottom = true; // top limit
	      } else if (!isDeltaPositive && -delta > scrollTop) {
	        if (onTopArrive && !_this.isTop) {
	          onTopArrive(event);
	        }
	
	        target.scrollTop = 0;
	        shouldCancelScroll = true;
	        _this.isTop = true;
	      } // cancel scroll
	
	
	      if (shouldCancelScroll) {
	        _this.cancelScroll(event);
	      }
	    };
	
	    _this.onWheel = function (event) {
	      _this.handleEventDelta(event, event.deltaY);
	    };
	
	    _this.onTouchStart = function (event) {
	      // set touch start so we can calculate touchmove delta
	      _this.touchStart = event.changedTouches[0].clientY;
	    };
	
	    _this.onTouchMove = function (event) {
	      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
	
	      _this.handleEventDelta(event, deltaY);
	    };
	
	    _this.getScrollTarget = function (ref) {
	      _this.scrollTarget = ref;
	    };
	
	    return _this;
	  }
	
	  _createClass(ScrollCaptor, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListening(this.scrollTarget);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListening(this.scrollTarget);
	    }
	  }, {
	    key: "startListening",
	    value: function startListening(el) {
	      // bail early if no element is available to attach to
	      if (!el) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.addEventListener === 'function') {
	        el.addEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "stopListening",
	    value: function stopListening(el) {
	      if (!el) return; // all the if statements are to appease Flow 😢
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('wheel', this.onWheel, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchstart', this.onTouchStart, false);
	      }
	
	      if (typeof el.removeEventListener === 'function') {
	        el.removeEventListener('touchmove', this.onTouchMove, false);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React__default.createElement(NodeResolver, {
	        innerRef: this.getScrollTarget
	      }, this.props.children);
	    }
	  }]);
	
	  return ScrollCaptor;
	}(React.Component);
	
	function ScrollCaptorSwitch(_ref) {
	  var _ref$isEnabled = _ref.isEnabled,
	      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
	      props = _objectWithoutProperties(_ref, ["isEnabled"]);
	
	  return isEnabled ? /*#__PURE__*/React__default.createElement(ScrollCaptor, props) : props.children;
	}
	
	var instructionsAriaMessage = function instructionsAriaMessage(event) {
	  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var isSearchable = context.isSearchable,
	      isMulti = context.isMulti,
	      label = context.label,
	      isDisabled = context.isDisabled,
	      tabSelectsValue = context.tabSelectsValue;
	
	  switch (event) {
	    case 'menu':
	      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
	
	    case 'input':
	      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
	
	    case 'value':
	      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
	  }
	};
	var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
	  var value = context.value,
	      isDisabled = context.isDisabled;
	  if (!value) return;
	
	  switch (event) {
	    case 'deselect-option':
	    case 'pop-value':
	    case 'remove-value':
	      return "option ".concat(value, ", deselected.");
	
	    case 'select-option':
	      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
	  }
	};
	var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
	  var focusedValue = _ref.focusedValue,
	      getOptionLabel = _ref.getOptionLabel,
	      selectValue = _ref.selectValue;
	  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
	};
	var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
	  var focusedOption = _ref2.focusedOption,
	      getOptionLabel = _ref2.getOptionLabel,
	      options = _ref2.options;
	  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
	};
	var resultsAriaMessage = function resultsAriaMessage(_ref3) {
	  var inputValue = _ref3.inputValue,
	      screenReaderMessage = _ref3.screenReaderMessage;
	  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
	};
	
	var formatGroupLabel = function formatGroupLabel(group) {
	  return group.label;
	};
	var getOptionLabel = function getOptionLabel(option) {
	  return option.label;
	};
	var getOptionValue = function getOptionValue(option) {
	  return option.value;
	};
	var isOptionDisabled = function isOptionDisabled(option) {
	  return !!option.isDisabled;
	};
	
	function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	var defaultStyles = {
	  clearIndicator: index.clearIndicatorCSS,
	  container: index.containerCSS,
	  control: index.css,
	  dropdownIndicator: index.dropdownIndicatorCSS,
	  group: index.groupCSS,
	  groupHeading: index.groupHeadingCSS,
	  indicatorsContainer: index.indicatorsContainerCSS,
	  indicatorSeparator: index.indicatorSeparatorCSS,
	  input: index.inputCSS,
	  loadingIndicator: index.loadingIndicatorCSS,
	  loadingMessage: index.loadingMessageCSS,
	  menu: index.menuCSS,
	  menuList: index.menuListCSS,
	  menuPortal: index.menuPortalCSS,
	  multiValue: index.multiValueCSS,
	  multiValueLabel: index.multiValueLabelCSS,
	  multiValueRemove: index.multiValueRemoveCSS,
	  noOptionsMessage: index.noOptionsMessageCSS,
	  option: index.optionCSS,
	  placeholder: index.placeholderCSS,
	  singleValue: index.css$1,
	  valueContainer: index.valueContainerCSS
	}; // Merge Utility
	// Allows consumers to extend a base Select with additional styles
	
	function mergeStyles(source) {
	  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  // initialize with source styles
	  var styles = _objectSpread$1({}, source); // massage in target styles
	
	
	  Object.keys(target).forEach(function (key) {
	    if (source[key]) {
	      styles[key] = function (rsCss, props) {
	        return target[key](source[key](rsCss, props), props);
	      };
	    } else {
	      styles[key] = target[key];
	    }
	  });
	  return styles;
	}
	
	var colors = {
	  primary: '#2684FF',
	  primary75: '#4C9AFF',
	  primary50: '#B2D4FF',
	  primary25: '#DEEBFF',
	  danger: '#DE350B',
	  dangerLight: '#FFBDAD',
	  neutral0: 'hsl(0, 0%, 100%)',
	  neutral5: 'hsl(0, 0%, 95%)',
	  neutral10: 'hsl(0, 0%, 90%)',
	  neutral20: 'hsl(0, 0%, 80%)',
	  neutral30: 'hsl(0, 0%, 70%)',
	  neutral40: 'hsl(0, 0%, 60%)',
	  neutral50: 'hsl(0, 0%, 50%)',
	  neutral60: 'hsl(0, 0%, 40%)',
	  neutral70: 'hsl(0, 0%, 30%)',
	  neutral80: 'hsl(0, 0%, 20%)',
	  neutral90: 'hsl(0, 0%, 10%)'
	};
	var borderRadius = 4; // Used to calculate consistent margin/padding on elements
	
	var baseUnit = 4; // The minimum height of the control
	
	var controlHeight = 38; // The amount of space between the control and menu */
	
	var menuGutter = baseUnit * 2;
	var spacing = {
	  baseUnit: baseUnit,
	  controlHeight: controlHeight,
	  menuGutter: menuGutter
	};
	var defaultTheme = {
	  borderRadius: borderRadius,
	  colors: colors,
	  spacing: spacing
	};
	
	function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	var defaultProps = {
	  backspaceRemovesValue: true,
	  blurInputOnSelect: index.isTouchCapable(),
	  captureMenuScroll: !index.isTouchCapable(),
	  closeMenuOnSelect: true,
	  closeMenuOnScroll: false,
	  components: {},
	  controlShouldRenderValue: true,
	  escapeClearsValue: false,
	  filterOption: createFilter(),
	  formatGroupLabel: formatGroupLabel,
	  getOptionLabel: getOptionLabel,
	  getOptionValue: getOptionValue,
	  isDisabled: false,
	  isLoading: false,
	  isMulti: false,
	  isRtl: false,
	  isSearchable: true,
	  isOptionDisabled: isOptionDisabled,
	  loadingMessage: function loadingMessage() {
	    return 'Loading...';
	  },
	  maxMenuHeight: 300,
	  minMenuHeight: 140,
	  menuIsOpen: false,
	  menuPlacement: 'bottom',
	  menuPosition: 'absolute',
	  menuShouldBlockScroll: false,
	  menuShouldScrollIntoView: !index.isMobileDevice(),
	  noOptionsMessage: function noOptionsMessage() {
	    return 'No options';
	  },
	  openMenuOnFocus: false,
	  openMenuOnClick: true,
	  options: [],
	  pageSize: 5,
	  placeholder: 'Select...',
	  screenReaderStatus: function screenReaderStatus(_ref) {
	    var count = _ref.count;
	    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
	  },
	  styles: {},
	  tabIndex: '0',
	  tabSelectsValue: true
	};
	var instanceId = 1;
	
	var Select = /*#__PURE__*/function (_Component) {
	  _inherits(Select, _Component);
	
	  var _super = _createSuper$4(Select);
	
	  // Misc. Instance Properties
	  // ------------------------------
	  // TODO
	  // Refs
	  // ------------------------------
	  // Lifecycle
	  // ------------------------------
	  function Select(_props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _super.call(this, _props);
	    _this.state = {
	      ariaLiveSelection: '',
	      ariaLiveContext: '',
	      focusedOption: null,
	      focusedValue: null,
	      inputIsHidden: false,
	      isFocused: false,
	      menuOptions: {
	        render: [],
	        focusable: []
	      },
	      selectValue: []
	    };
	    _this.blockOptionHover = false;
	    _this.isComposing = false;
	    _this.clearFocusValueOnUpdate = false;
	    _this.commonProps = void 0;
	    _this.components = void 0;
	    _this.hasGroups = false;
	    _this.initialTouchX = 0;
	    _this.initialTouchY = 0;
	    _this.inputIsHiddenAfterUpdate = void 0;
	    _this.instancePrefix = '';
	    _this.openAfterFocus = false;
	    _this.scrollToFocusedOptionOnUpdate = false;
	    _this.userIsDragging = void 0;
	    _this.controlRef = null;
	
	    _this.getControlRef = function (ref) {
	      _this.controlRef = ref;
	    };
	
	    _this.focusedOptionRef = null;
	
	    _this.getFocusedOptionRef = function (ref) {
	      _this.focusedOptionRef = ref;
	    };
	
	    _this.menuListRef = null;
	
	    _this.getMenuListRef = function (ref) {
	      _this.menuListRef = ref;
	    };
	
	    _this.inputRef = null;
	
	    _this.getInputRef = function (ref) {
	      _this.inputRef = ref;
	    };
	
	    _this.cacheComponents = function (components) {
	      _this.components = index.defaultComponents({
	        components: components
	      });
	    };
	
	    _this.focus = _this.focusInput;
	    _this.blur = _this.blurInput;
	
	    _this.onChange = function (newValue, actionMeta) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          name = _this$props.name;
	      onChange(newValue, _objectSpread$2(_objectSpread$2({}, actionMeta), {}, {
	        name: name
	      }));
	    };
	
	    _this.setValue = function (newValue) {
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
	      var option = arguments.length > 2 ? arguments[2] : undefined;
	      var _this$props2 = _this.props,
	          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
	          isMulti = _this$props2.isMulti;
	
	      _this.onInputChange('', {
	        action: 'set-value'
	      });
	
	      if (closeMenuOnSelect) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } // when the select value should change, we should reset focusedValue
	
	
	      _this.clearFocusValueOnUpdate = true;
	
	      _this.onChange(newValue, {
	        action: action,
	        option: option
	      });
	    };
	
	    _this.selectOption = function (newValue) {
	      var _this$props3 = _this.props,
	          blurInputOnSelect = _this$props3.blurInputOnSelect,
	          isMulti = _this$props3.isMulti;
	      var selectValue = _this.state.selectValue;
	
	      if (isMulti) {
	        if (_this.isOptionSelected(newValue, selectValue)) {
	          var candidate = _this.getOptionValue(newValue);
	
	          _this.setValue(selectValue.filter(function (i) {
	            return _this.getOptionValue(i) !== candidate;
	          }), 'deselect-option', newValue);
	
	          _this.announceAriaLiveSelection({
	            event: 'deselect-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          if (!_this.isOptionDisabled(newValue, selectValue)) {
	            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);
	
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue)
	              }
	            });
	          } else {
	            // announce that option is disabled
	            _this.announceAriaLiveSelection({
	              event: 'select-option',
	              context: {
	                value: _this.getOptionLabel(newValue),
	                isDisabled: true
	              }
	            });
	          }
	        }
	      } else {
	        if (!_this.isOptionDisabled(newValue, selectValue)) {
	          _this.setValue(newValue, 'select-option');
	
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue)
	            }
	          });
	        } else {
	          // announce that option is disabled
	          _this.announceAriaLiveSelection({
	            event: 'select-option',
	            context: {
	              value: _this.getOptionLabel(newValue),
	              isDisabled: true
	            }
	          });
	        }
	      }
	
	      if (blurInputOnSelect) {
	        _this.blurInput();
	      }
	    };
	
	    _this.removeValue = function (removedValue) {
	      var selectValue = _this.state.selectValue;
	
	      var candidate = _this.getOptionValue(removedValue);
	
	      var newValue = selectValue.filter(function (i) {
	        return _this.getOptionValue(i) !== candidate;
	      });
	
	      _this.onChange(newValue.length ? newValue : null, {
	        action: 'remove-value',
	        removedValue: removedValue
	      });
	
	      _this.announceAriaLiveSelection({
	        event: 'remove-value',
	        context: {
	          value: removedValue ? _this.getOptionLabel(removedValue) : ''
	        }
	      });
	
	      _this.focusInput();
	    };
	
	    _this.clearValue = function () {
	      _this.onChange(null, {
	        action: 'clear'
	      });
	    };
	
	    _this.popValue = function () {
	      var selectValue = _this.state.selectValue;
	      var lastSelectedValue = selectValue[selectValue.length - 1];
	      var newValue = selectValue.slice(0, selectValue.length - 1);
	
	      _this.announceAriaLiveSelection({
	        event: 'pop-value',
	        context: {
	          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
	        }
	      });
	
	      _this.onChange(newValue.length ? newValue : null, {
	        action: 'pop-value',
	        removedValue: lastSelectedValue
	      });
	    };
	
	    _this.getValue = function () {
	      return _this.state.selectValue;
	    };
	
	    _this.cx = function () {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return index.classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
	    };
	
	    _this.getOptionLabel = function (data) {
	      return _this.props.getOptionLabel(data);
	    };
	
	    _this.getOptionValue = function (data) {
	      return _this.props.getOptionValue(data);
	    };
	
	    _this.getStyles = function (key, props) {
	      var base = defaultStyles[key](props);
	      base.boxSizing = 'border-box';
	      var custom = _this.props.styles[key];
	      return custom ? custom(base, props) : base;
	    };
	
	    _this.getElementId = function (element) {
	      return "".concat(_this.instancePrefix, "-").concat(element);
	    };
	
	    _this.getActiveDescendentId = function () {
	      var menuIsOpen = _this.props.menuIsOpen;
	      var _this$state = _this.state,
	          menuOptions = _this$state.menuOptions,
	          focusedOption = _this$state.focusedOption;
	      if (!focusedOption || !menuIsOpen) return undefined;
	      var index = menuOptions.focusable.indexOf(focusedOption);
	      var option = menuOptions.render[index];
	      return option && option.key;
	    };
	
	    _this.announceAriaLiveSelection = function (_ref2) {
	      var event = _ref2.event,
	          context = _ref2.context;
	
	      _this.setState({
	        ariaLiveSelection: valueEventAriaMessage(event, context)
	      });
	    };
	
	    _this.announceAriaLiveContext = function (_ref3) {
	      var event = _ref3.event,
	          context = _ref3.context;
	
	      _this.setState({
	        ariaLiveContext: instructionsAriaMessage(event, _objectSpread$2(_objectSpread$2({}, context), {}, {
	          label: _this.props['aria-label']
	        }))
	      });
	    };
	
	    _this.onMenuMouseDown = function (event) {
	      if (event.button !== 0) {
	        return;
	      }
	
	      event.stopPropagation();
	      event.preventDefault();
	
	      _this.focusInput();
	    };
	
	    _this.onMenuMouseMove = function (event) {
	      _this.blockOptionHover = false;
	    };
	
	    _this.onControlMouseDown = function (event) {
	      var openMenuOnClick = _this.props.openMenuOnClick;
	
	      if (!_this.state.isFocused) {
	        if (openMenuOnClick) {
	          _this.openAfterFocus = true;
	        }
	
	        _this.focusInput();
	      } else if (!_this.props.menuIsOpen) {
	        if (openMenuOnClick) {
	          _this.openMenu('first');
	        }
	      } else {
	        if ( // $FlowFixMe
	        event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
	          _this.onMenuClose();
	        }
	      }
	
	      if ( // $FlowFixMe
	      event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
	        event.preventDefault();
	      }
	    };
	
	    _this.onDropdownIndicatorMouseDown = function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      if (_this.props.isDisabled) return;
	      var _this$props4 = _this.props,
	          isMulti = _this$props4.isMulti,
	          menuIsOpen = _this$props4.menuIsOpen;
	
	      _this.focusInput();
	
	      if (menuIsOpen) {
	        _this.inputIsHiddenAfterUpdate = !isMulti;
	
	        _this.onMenuClose();
	      } else {
	        _this.openMenu('first');
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	    };
	
	    _this.onClearIndicatorMouseDown = function (event) {
	      // ignore mouse events that weren't triggered by the primary button
	      if (event && event.type === 'mousedown' && event.button !== 0) {
	        return;
	      }
	
	      _this.clearValue();
	
	      event.stopPropagation();
	      _this.openAfterFocus = false;
	
	      if (event.type === 'touchend') {
	        _this.focusInput();
	      } else {
	        setTimeout(function () {
	          return _this.focusInput();
	        });
	      }
	    };
	
	    _this.onScroll = function (event) {
	      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
	        if (event.target instanceof HTMLElement && index.isDocumentElement(event.target)) {
	          _this.props.onMenuClose();
	        }
	      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
	        if (_this.props.closeMenuOnScroll(event)) {
	          _this.props.onMenuClose();
	        }
	      }
	    };
	
	    _this.onCompositionStart = function () {
	      _this.isComposing = true;
	    };
	
	    _this.onCompositionEnd = function () {
	      _this.isComposing = false;
	    };
	
	    _this.onTouchStart = function (_ref4) {
	      var touches = _ref4.touches;
	      var touch = touches && touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      _this.initialTouchX = touch.clientX;
	      _this.initialTouchY = touch.clientY;
	      _this.userIsDragging = false;
	    };
	
	    _this.onTouchMove = function (_ref5) {
	      var touches = _ref5.touches;
	      var touch = touches && touches.item(0);
	
	      if (!touch) {
	        return;
	      }
	
	      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
	      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
	      var moveThreshold = 5;
	      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
	    };
	
	    _this.onTouchEnd = function (event) {
	      if (_this.userIsDragging) return; // close the menu if the user taps outside
	      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
	      // on events on child elements, not the document (which we've attached this handler to).
	
	      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
	        _this.blurInput();
	      } // reset move vars
	
	
	      _this.initialTouchX = 0;
	      _this.initialTouchY = 0;
	    };
	
	    _this.onControlTouchEnd = function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onControlMouseDown(event);
	    };
	
	    _this.onClearIndicatorTouchEnd = function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onClearIndicatorMouseDown(event);
	    };
	
	    _this.onDropdownIndicatorTouchEnd = function (event) {
	      if (_this.userIsDragging) return;
	
	      _this.onDropdownIndicatorMouseDown(event);
	    };
	
	    _this.handleInputChange = function (event) {
	      var inputValue = event.currentTarget.value;
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.onInputChange(inputValue, {
	        action: 'input-change'
	      });
	
	      if (!_this.props.menuIsOpen) {
	        _this.onMenuOpen();
	      }
	    };
	
	    _this.onInputFocus = function (event) {
	      var _this$props5 = _this.props,
	          isSearchable = _this$props5.isSearchable,
	          isMulti = _this$props5.isMulti;
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	
	      _this.inputIsHiddenAfterUpdate = false;
	
	      _this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	
	      _this.setState({
	        isFocused: true
	      });
	
	      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
	        _this.openMenu('first');
	      }
	
	      _this.openAfterFocus = false;
	    };
	
	    _this.onInputBlur = function (event) {
	      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
	        _this.inputRef.focus();
	
	        return;
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	
	      _this.onInputChange('', {
	        action: 'input-blur'
	      });
	
	      _this.onMenuClose();
	
	      _this.setState({
	        focusedValue: null,
	        isFocused: false
	      });
	    };
	
	    _this.onOptionHover = function (focusedOption) {
	      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
	        return;
	      }
	
	      _this.setState({
	        focusedOption: focusedOption
	      });
	    };
	
	    _this.shouldHideSelectedOptions = function () {
	      var _this$props6 = _this.props,
	          hideSelectedOptions = _this$props6.hideSelectedOptions,
	          isMulti = _this$props6.isMulti;
	      if (hideSelectedOptions === undefined) return isMulti;
	      return hideSelectedOptions;
	    };
	
	    _this.onKeyDown = function (event) {
	      var _this$props7 = _this.props,
	          isMulti = _this$props7.isMulti,
	          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
	          escapeClearsValue = _this$props7.escapeClearsValue,
	          inputValue = _this$props7.inputValue,
	          isClearable = _this$props7.isClearable,
	          isDisabled = _this$props7.isDisabled,
	          menuIsOpen = _this$props7.menuIsOpen,
	          onKeyDown = _this$props7.onKeyDown,
	          tabSelectsValue = _this$props7.tabSelectsValue,
	          openMenuOnFocus = _this$props7.openMenuOnFocus;
	      var _this$state2 = _this.state,
	          focusedOption = _this$state2.focusedOption,
	          focusedValue = _this$state2.focusedValue,
	          selectValue = _this$state2.selectValue;
	      if (isDisabled) return;
	
	      if (typeof onKeyDown === 'function') {
	        onKeyDown(event);
	
	        if (event.defaultPrevented) {
	          return;
	        }
	      } // Block option hover events when the user has just pressed a key
	
	
	      _this.blockOptionHover = true;
	
	      switch (event.key) {
	        case 'ArrowLeft':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('previous');
	
	          break;
	
	        case 'ArrowRight':
	          if (!isMulti || inputValue) return;
	
	          _this.focusValue('next');
	
	          break;
	
	        case 'Delete':
	        case 'Backspace':
	          if (inputValue) return;
	
	          if (focusedValue) {
	            _this.removeValue(focusedValue);
	          } else {
	            if (!backspaceRemovesValue) return;
	
	            if (isMulti) {
	              _this.popValue();
	            } else if (isClearable) {
	              _this.clearValue();
	            }
	          }
	
	          break;
	
	        case 'Tab':
	          if (_this.isComposing) return;
	
	          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
	          // option is already selected; it breaks the flow of navigation
	          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
	            return;
	          }
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'Enter':
	          if (event.keyCode === 229) {
	            // ignore the keydown event from an Input Method Editor(IME)
	            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
	            break;
	          }
	
	          if (menuIsOpen) {
	            if (!focusedOption) return;
	            if (_this.isComposing) return;
	
	            _this.selectOption(focusedOption);
	
	            break;
	          }
	
	          return;
	
	        case 'Escape':
	          if (menuIsOpen) {
	            _this.inputIsHiddenAfterUpdate = false;
	
	            _this.onInputChange('', {
	              action: 'menu-close'
	            });
	
	            _this.onMenuClose();
	          } else if (isClearable && escapeClearsValue) {
	            _this.clearValue();
	          }
	
	          break;
	
	        case ' ':
	          // space
	          if (inputValue) {
	            return;
	          }
	
	          if (!menuIsOpen) {
	            _this.openMenu('first');
	
	            break;
	          }
	
	          if (!focusedOption) return;
	
	          _this.selectOption(focusedOption);
	
	          break;
	
	        case 'ArrowUp':
	          if (menuIsOpen) {
	            _this.focusOption('up');
	          } else {
	            _this.openMenu('last');
	          }
	
	          break;
	
	        case 'ArrowDown':
	          if (menuIsOpen) {
	            _this.focusOption('down');
	          } else {
	            _this.openMenu('first');
	          }
	
	          break;
	
	        case 'PageUp':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pageup');
	
	          break;
	
	        case 'PageDown':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('pagedown');
	
	          break;
	
	        case 'Home':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('first');
	
	          break;
	
	        case 'End':
	          if (!menuIsOpen) return;
	
	          _this.focusOption('last');
	
	          break;
	
	        default:
	          return;
	      }
	
	      event.preventDefault();
	    };
	
	    _this.buildMenuOptions = function (props, selectValue) {
	      var _props$inputValue = props.inputValue,
	          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
	          options = props.options;
	
	      var toOption = function toOption(option, id) {
	        var isDisabled = _this.isOptionDisabled(option, selectValue);
	
	        var isSelected = _this.isOptionSelected(option, selectValue);
	
	        var label = _this.getOptionLabel(option);
	
	        var value = _this.getOptionValue(option);
	
	        if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
	          label: label,
	          value: value,
	          data: option
	        }, inputValue)) {
	          return;
	        }
	
	        var onHover = isDisabled ? undefined : function () {
	          return _this.onOptionHover(option);
	        };
	        var onSelect = isDisabled ? undefined : function () {
	          return _this.selectOption(option);
	        };
	        var optionId = "".concat(_this.getElementId('option'), "-").concat(id);
	        return {
	          innerProps: {
	            id: optionId,
	            onClick: onSelect,
	            onMouseMove: onHover,
	            onMouseOver: onHover,
	            tabIndex: -1
	          },
	          data: option,
	          isDisabled: isDisabled,
	          isSelected: isSelected,
	          key: optionId,
	          label: label,
	          type: 'option',
	          value: value
	        };
	      };
	
	      return options.reduce(function (acc, item, itemIndex) {
	        if (item.options) {
	          // TODO needs a tidier implementation
	          if (!_this.hasGroups) _this.hasGroups = true;
	          var items = item.options;
	          var children = items.map(function (child, i) {
	            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
	            if (option) acc.focusable.push(child);
	            return option;
	          }).filter(Boolean);
	
	          if (children.length) {
	            var groupId = "".concat(_this.getElementId('group'), "-").concat(itemIndex);
	            acc.render.push({
	              type: 'group',
	              key: groupId,
	              data: item,
	              options: children
	            });
	          }
	        } else {
	          var option = toOption(item, "".concat(itemIndex));
	
	          if (option) {
	            acc.render.push(option);
	            acc.focusable.push(item);
	          }
	        }
	
	        return acc;
	      }, {
	        render: [],
	        focusable: []
	      });
	    };
	
	    var _value = _props.value;
	    _this.cacheComponents = memoizeOne(_this.cacheComponents, index.exportedEqual).bind(_assertThisInitialized(_this));
	
	    _this.cacheComponents(_props.components);
	
	    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
	
	    var _selectValue = index.cleanValue(_value);
	
	    _this.buildMenuOptions = memoizeOne(_this.buildMenuOptions, function (newArgs, lastArgs) {
	      var _ref6 = newArgs,
	          _ref7 = _slicedToArray(_ref6, 2),
	          newProps = _ref7[0],
	          newSelectValue = _ref7[1];
	
	      var _ref8 = lastArgs,
	          _ref9 = _slicedToArray(_ref8, 2),
	          lastProps = _ref9[0],
	          lastSelectValue = _ref9[1];
	
	      return newSelectValue === lastSelectValue && newProps.inputValue === lastProps.inputValue && newProps.options === lastProps.options;
	    }).bind(_assertThisInitialized(_this));
	
	    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
	      render: [],
	      focusable: []
	    };
	
	    _this.state.menuOptions = _menuOptions;
	    _this.state.selectValue = _selectValue;
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.startListeningComposition();
	      this.startListeningToTouch();
	
	      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
	        // Listen to all scroll events, and filter them out inside of 'onScroll'
	        document.addEventListener('scroll', this.onScroll, true);
	      }
	
	      if (this.props.autoFocus) {
	        this.focusInput();
	      }
	    }
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this$props8 = this.props,
	          options = _this$props8.options,
	          value = _this$props8.value,
	          menuIsOpen = _this$props8.menuIsOpen,
	          inputValue = _this$props8.inputValue; // re-cache custom components
	
	      this.cacheComponents(nextProps.components); // rebuild the menu options
	
	      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
	        var selectValue = index.cleanValue(nextProps.value);
	        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
	          render: [],
	          focusable: []
	        };
	        var focusedValue = this.getNextFocusedValue(selectValue);
	        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
	        this.setState({
	          menuOptions: menuOptions,
	          selectValue: selectValue,
	          focusedOption: focusedOption,
	          focusedValue: focusedValue
	        });
	      } // some updates should toggle the state of the input visibility
	
	
	      if (this.inputIsHiddenAfterUpdate != null) {
	        this.setState({
	          inputIsHidden: this.inputIsHiddenAfterUpdate
	        });
	        delete this.inputIsHiddenAfterUpdate;
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props9 = this.props,
	          isDisabled = _this$props9.isDisabled,
	          menuIsOpen = _this$props9.menuIsOpen;
	      var isFocused = this.state.isFocused;
	
	      if ( // ensure focus is restored correctly when the control becomes enabled
	      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
	      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
	        this.focusInput();
	      }
	
	      if (isFocused && isDisabled && !prevProps.isDisabled) {
	        // ensure select state gets blurred in case Select is programatically disabled while focused
	        this.setState({
	          isFocused: false
	        }, this.onMenuClose);
	      } // scroll the focused option into view if necessary
	
	
	      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
	        index.scrollIntoView(this.menuListRef, this.focusedOptionRef);
	        this.scrollToFocusedOptionOnUpdate = false;
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopListeningComposition();
	      this.stopListeningToTouch();
	      document.removeEventListener('scroll', this.onScroll, true);
	    }
	  }, {
	    key: "onMenuOpen",
	    // ==============================
	    // Consumer Handlers
	    // ==============================
	    value: function onMenuOpen() {
	      this.props.onMenuOpen();
	    }
	  }, {
	    key: "onMenuClose",
	    value: function onMenuClose() {
	      var _this$props10 = this.props,
	          isSearchable = _this$props10.isSearchable,
	          isMulti = _this$props10.isMulti;
	      this.announceAriaLiveContext({
	        event: 'input',
	        context: {
	          isSearchable: isSearchable,
	          isMulti: isMulti
	        }
	      });
	      this.onInputChange('', {
	        action: 'menu-close'
	      });
	      this.props.onMenuClose();
	    }
	  }, {
	    key: "onInputChange",
	    value: function onInputChange(newValue, actionMeta) {
	      this.props.onInputChange(newValue, actionMeta);
	    } // ==============================
	    // Methods
	    // ==============================
	
	  }, {
	    key: "focusInput",
	    value: function focusInput() {
	      if (!this.inputRef) return;
	      this.inputRef.focus();
	    }
	  }, {
	    key: "blurInput",
	    value: function blurInput() {
	      if (!this.inputRef) return;
	      this.inputRef.blur();
	    } // aliased for consumers
	
	  }, {
	    key: "openMenu",
	    value: function openMenu(focusOption) {
	      var _this2 = this;
	
	      var _this$state3 = this.state,
	          selectValue = _this$state3.selectValue,
	          isFocused = _this$state3.isFocused;
	      var menuOptions = this.buildMenuOptions(this.props, selectValue);
	      var _this$props11 = this.props,
	          isMulti = _this$props11.isMulti,
	          tabSelectsValue = _this$props11.tabSelectsValue;
	      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;
	
	      if (!isMulti) {
	        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
	
	        if (selectedIndex > -1) {
	          openAtIndex = selectedIndex;
	        }
	      } // only scroll if the menu isn't already open
	
	
	      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
	      this.inputIsHiddenAfterUpdate = false;
	      this.setState({
	        menuOptions: menuOptions,
	        focusedValue: null,
	        focusedOption: menuOptions.focusable[openAtIndex]
	      }, function () {
	        _this2.onMenuOpen();
	
	        _this2.announceAriaLiveContext({
	          event: 'menu',
	          context: {
	            tabSelectsValue: tabSelectsValue
	          }
	        });
	      });
	    }
	  }, {
	    key: "focusValue",
	    value: function focusValue(direction) {
	      var _this$props12 = this.props,
	          isMulti = _this$props12.isMulti,
	          isSearchable = _this$props12.isSearchable;
	      var _this$state4 = this.state,
	          selectValue = _this$state4.selectValue,
	          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
	
	      if (!isMulti) return;
	      this.setState({
	        focusedOption: null
	      });
	      var focusedIndex = selectValue.indexOf(focusedValue);
	
	      if (!focusedValue) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'value'
	        });
	      }
	
	      var lastIndex = selectValue.length - 1;
	      var nextFocus = -1;
	      if (!selectValue.length) return;
	
	      switch (direction) {
	        case 'previous':
	          if (focusedIndex === 0) {
	            // don't cycle from the start to the end
	            nextFocus = 0;
	          } else if (focusedIndex === -1) {
	            // if nothing is focused, focus the last value first
	            nextFocus = lastIndex;
	          } else {
	            nextFocus = focusedIndex - 1;
	          }
	
	          break;
	
	        case 'next':
	          if (focusedIndex > -1 && focusedIndex < lastIndex) {
	            nextFocus = focusedIndex + 1;
	          }
	
	          break;
	      }
	
	      if (nextFocus === -1) {
	        this.announceAriaLiveContext({
	          event: 'input',
	          context: {
	            isSearchable: isSearchable,
	            isMulti: isMulti
	          }
	        });
	      }
	
	      this.setState({
	        inputIsHidden: nextFocus !== -1,
	        focusedValue: selectValue[nextFocus]
	      });
	    }
	  }, {
	    key: "focusOption",
	    value: function focusOption() {
	      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
	      var _this$props13 = this.props,
	          pageSize = _this$props13.pageSize,
	          tabSelectsValue = _this$props13.tabSelectsValue;
	      var _this$state5 = this.state,
	          focusedOption = _this$state5.focusedOption,
	          menuOptions = _this$state5.menuOptions;
	      var options = menuOptions.focusable;
	      if (!options.length) return;
	      var nextFocus = 0; // handles 'first'
	
	      var focusedIndex = options.indexOf(focusedOption);
	
	      if (!focusedOption) {
	        focusedIndex = -1;
	        this.announceAriaLiveContext({
	          event: 'menu',
	          context: {
	            tabSelectsValue: tabSelectsValue
	          }
	        });
	      }
	
	      if (direction === 'up') {
	        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
	      } else if (direction === 'down') {
	        nextFocus = (focusedIndex + 1) % options.length;
	      } else if (direction === 'pageup') {
	        nextFocus = focusedIndex - pageSize;
	        if (nextFocus < 0) nextFocus = 0;
	      } else if (direction === 'pagedown') {
	        nextFocus = focusedIndex + pageSize;
	        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
	      } else if (direction === 'last') {
	        nextFocus = options.length - 1;
	      }
	
	      this.scrollToFocusedOptionOnUpdate = true;
	      this.setState({
	        focusedOption: options[nextFocus],
	        focusedValue: null
	      });
	      this.announceAriaLiveContext({
	        event: 'menu',
	        context: {
	          isDisabled: isOptionDisabled(options[nextFocus]),
	          tabSelectsValue: tabSelectsValue
	        }
	      });
	    }
	  }, {
	    key: "getTheme",
	    // ==============================
	    // Getters
	    // ==============================
	    value: function getTheme() {
	      // Use the default theme if there are no customizations.
	      if (!this.props.theme) {
	        return defaultTheme;
	      } // If the theme prop is a function, assume the function
	      // knows how to merge the passed-in default theme with
	      // its own modifications.
	
	
	      if (typeof this.props.theme === 'function') {
	        return this.props.theme(defaultTheme);
	      } // Otherwise, if a plain theme object was passed in,
	      // overlay it with the default theme.
	
	
	      return _objectSpread$2(_objectSpread$2({}, defaultTheme), this.props.theme);
	    }
	  }, {
	    key: "getCommonProps",
	    value: function getCommonProps() {
	      var clearValue = this.clearValue,
	          cx = this.cx,
	          getStyles = this.getStyles,
	          getValue = this.getValue,
	          setValue = this.setValue,
	          selectOption = this.selectOption,
	          props = this.props;
	      var isMulti = props.isMulti,
	          isRtl = props.isRtl,
	          options = props.options;
	      var hasValue = this.hasValue();
	      return {
	        cx: cx,
	        clearValue: clearValue,
	        getStyles: getStyles,
	        getValue: getValue,
	        hasValue: hasValue,
	        isMulti: isMulti,
	        isRtl: isRtl,
	        options: options,
	        selectOption: selectOption,
	        setValue: setValue,
	        selectProps: props,
	        theme: this.getTheme()
	      };
	    }
	  }, {
	    key: "getNextFocusedValue",
	    value: function getNextFocusedValue(nextSelectValue) {
	      if (this.clearFocusValueOnUpdate) {
	        this.clearFocusValueOnUpdate = false;
	        return null;
	      }
	
	      var _this$state6 = this.state,
	          focusedValue = _this$state6.focusedValue,
	          lastSelectValue = _this$state6.selectValue;
	      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
	
	      if (lastFocusedIndex > -1) {
	        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
	
	        if (nextFocusedIndex > -1) {
	          // the focused value is still in the selectValue, return it
	          return focusedValue;
	        } else if (lastFocusedIndex < nextSelectValue.length) {
	          // the focusedValue is not present in the next selectValue array by
	          // reference, so return the new value at the same index
	          return nextSelectValue[lastFocusedIndex];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: "getNextFocusedOption",
	    value: function getNextFocusedOption(options) {
	      var lastFocusedOption = this.state.focusedOption;
	      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
	    }
	  }, {
	    key: "hasValue",
	    value: function hasValue() {
	      var selectValue = this.state.selectValue;
	      return selectValue.length > 0;
	    }
	  }, {
	    key: "hasOptions",
	    value: function hasOptions() {
	      return !!this.state.menuOptions.render.length;
	    }
	  }, {
	    key: "countOptions",
	    value: function countOptions() {
	      return this.state.menuOptions.focusable.length;
	    }
	  }, {
	    key: "isClearable",
	    value: function isClearable() {
	      var _this$props14 = this.props,
	          isClearable = _this$props14.isClearable,
	          isMulti = _this$props14.isMulti; // single select, by default, IS NOT clearable
	      // multi select, by default, IS clearable
	
	      if (isClearable === undefined) return isMulti;
	      return isClearable;
	    }
	  }, {
	    key: "isOptionDisabled",
	    value: function isOptionDisabled(option, selectValue) {
	      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
	    }
	  }, {
	    key: "isOptionSelected",
	    value: function isOptionSelected(option, selectValue) {
	      var _this3 = this;
	
	      if (selectValue.indexOf(option) > -1) return true;
	
	      if (typeof this.props.isOptionSelected === 'function') {
	        return this.props.isOptionSelected(option, selectValue);
	      }
	
	      var candidate = this.getOptionValue(option);
	      return selectValue.some(function (i) {
	        return _this3.getOptionValue(i) === candidate;
	      });
	    }
	  }, {
	    key: "filterOption",
	    value: function filterOption(option, inputValue) {
	      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
	    }
	  }, {
	    key: "formatOptionLabel",
	    value: function formatOptionLabel(data, context) {
	      if (typeof this.props.formatOptionLabel === 'function') {
	        var inputValue = this.props.inputValue;
	        var selectValue = this.state.selectValue;
	        return this.props.formatOptionLabel(data, {
	          context: context,
	          inputValue: inputValue,
	          selectValue: selectValue
	        });
	      } else {
	        return this.getOptionLabel(data);
	      }
	    }
	  }, {
	    key: "formatGroupLabel",
	    value: function formatGroupLabel(data) {
	      return this.props.formatGroupLabel(data);
	    } // ==============================
	    // Mouse Handlers
	    // ==============================
	
	  }, {
	    key: "startListeningComposition",
	    // ==============================
	    // Composition Handlers
	    // ==============================
	    value: function startListeningComposition() {
	      if (document && document.addEventListener) {
	        document.addEventListener('compositionstart', this.onCompositionStart, false);
	        document.addEventListener('compositionend', this.onCompositionEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningComposition",
	    value: function stopListeningComposition() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('compositionstart', this.onCompositionStart);
	        document.removeEventListener('compositionend', this.onCompositionEnd);
	      }
	    }
	  }, {
	    key: "startListeningToTouch",
	    // ==============================
	    // Touch Handlers
	    // ==============================
	    value: function startListeningToTouch() {
	      if (document && document.addEventListener) {
	        document.addEventListener('touchstart', this.onTouchStart, false);
	        document.addEventListener('touchmove', this.onTouchMove, false);
	        document.addEventListener('touchend', this.onTouchEnd, false);
	      }
	    }
	  }, {
	    key: "stopListeningToTouch",
	    value: function stopListeningToTouch() {
	      if (document && document.removeEventListener) {
	        document.removeEventListener('touchstart', this.onTouchStart);
	        document.removeEventListener('touchmove', this.onTouchMove);
	        document.removeEventListener('touchend', this.onTouchEnd);
	      }
	    }
	  }, {
	    key: "constructAriaLiveMessage",
	    // ==============================
	    // Renderers
	    // ==============================
	    value: function constructAriaLiveMessage() {
	      var _this$state7 = this.state,
	          ariaLiveContext = _this$state7.ariaLiveContext,
	          selectValue = _this$state7.selectValue,
	          focusedValue = _this$state7.focusedValue,
	          focusedOption = _this$state7.focusedOption;
	      var _this$props15 = this.props,
	          options = _this$props15.options,
	          menuIsOpen = _this$props15.menuIsOpen,
	          inputValue = _this$props15.inputValue,
	          screenReaderStatus = _this$props15.screenReaderStatus; // An aria live message representing the currently focused value in the select.
	
	      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
	        focusedValue: focusedValue,
	        getOptionLabel: this.getOptionLabel,
	        selectValue: selectValue
	      }) : ''; // An aria live message representing the currently focused option in the select.
	
	      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
	        focusedOption: focusedOption,
	        getOptionLabel: this.getOptionLabel,
	        options: options
	      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
	
	      var resultsMsg = resultsAriaMessage({
	        inputValue: inputValue,
	        screenReaderMessage: screenReaderStatus({
	          count: this.countOptions()
	        })
	      });
	      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
	    }
	  }, {
	    key: "renderInput",
	    value: function renderInput() {
	      var _this$props16 = this.props,
	          isDisabled = _this$props16.isDisabled,
	          isSearchable = _this$props16.isSearchable,
	          inputId = _this$props16.inputId,
	          inputValue = _this$props16.inputValue,
	          tabIndex = _this$props16.tabIndex,
	          form = _this$props16.form;
	      var Input = this.components.Input;
	      var inputIsHidden = this.state.inputIsHidden;
	      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity
	
	      var ariaAttributes = {
	        'aria-autocomplete': 'list',
	        'aria-label': this.props['aria-label'],
	        'aria-labelledby': this.props['aria-labelledby']
	      };
	
	      if (!isSearchable) {
	        // use a dummy input to maintain focus/blur functionality
	        return /*#__PURE__*/React__default.createElement(DummyInput, _extends({
	          id: id,
	          innerRef: this.getInputRef,
	          onBlur: this.onInputBlur,
	          onChange: index.noop,
	          onFocus: this.onInputFocus,
	          readOnly: true,
	          disabled: isDisabled,
	          tabIndex: tabIndex,
	          form: form,
	          value: ""
	        }, ariaAttributes));
	      }
	
	      var _this$commonProps = this.commonProps,
	          cx = _this$commonProps.cx,
	          theme = _this$commonProps.theme,
	          selectProps = _this$commonProps.selectProps;
	      return /*#__PURE__*/React__default.createElement(Input, _extends({
	        autoCapitalize: "none",
	        autoComplete: "off",
	        autoCorrect: "off",
	        cx: cx,
	        getStyles: this.getStyles,
	        id: id,
	        innerRef: this.getInputRef,
	        isDisabled: isDisabled,
	        isHidden: inputIsHidden,
	        onBlur: this.onInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.onInputFocus,
	        selectProps: selectProps,
	        spellCheck: "false",
	        tabIndex: tabIndex,
	        form: form,
	        theme: theme,
	        type: "text",
	        value: inputValue
	      }, ariaAttributes));
	    }
	  }, {
	    key: "renderPlaceholderOrValue",
	    value: function renderPlaceholderOrValue() {
	      var _this4 = this;
	
	      var _this$components = this.components,
	          MultiValue = _this$components.MultiValue,
	          MultiValueContainer = _this$components.MultiValueContainer,
	          MultiValueLabel = _this$components.MultiValueLabel,
	          MultiValueRemove = _this$components.MultiValueRemove,
	          SingleValue = _this$components.SingleValue,
	          Placeholder = _this$components.Placeholder;
	      var commonProps = this.commonProps;
	      var _this$props17 = this.props,
	          controlShouldRenderValue = _this$props17.controlShouldRenderValue,
	          isDisabled = _this$props17.isDisabled,
	          isMulti = _this$props17.isMulti,
	          inputValue = _this$props17.inputValue,
	          placeholder = _this$props17.placeholder;
	      var _this$state8 = this.state,
	          selectValue = _this$state8.selectValue,
	          focusedValue = _this$state8.focusedValue,
	          isFocused = _this$state8.isFocused;
	
	      if (!this.hasValue() || !controlShouldRenderValue) {
	        return inputValue ? null : /*#__PURE__*/React__default.createElement(Placeholder, _extends({}, commonProps, {
	          key: "placeholder",
	          isDisabled: isDisabled,
	          isFocused: isFocused
	        }), placeholder);
	      }
	
	      if (isMulti) {
	        var selectValues = selectValue.map(function (opt, index) {
	          var isOptionFocused = opt === focusedValue;
	          return /*#__PURE__*/React__default.createElement(MultiValue, _extends({}, commonProps, {
	            components: {
	              Container: MultiValueContainer,
	              Label: MultiValueLabel,
	              Remove: MultiValueRemove
	            },
	            isFocused: isOptionFocused,
	            isDisabled: isDisabled,
	            key: "".concat(_this4.getOptionValue(opt)).concat(index),
	            index: index,
	            removeProps: {
	              onClick: function onClick() {
	                return _this4.removeValue(opt);
	              },
	              onTouchEnd: function onTouchEnd() {
	                return _this4.removeValue(opt);
	              },
	              onMouseDown: function onMouseDown(e) {
	                e.preventDefault();
	                e.stopPropagation();
	              }
	            },
	            data: opt
	          }), _this4.formatOptionLabel(opt, 'value'));
	        });
	        return selectValues;
	      }
	
	      if (inputValue) {
	        return null;
	      }
	
	      var singleValue = selectValue[0];
	      return /*#__PURE__*/React__default.createElement(SingleValue, _extends({}, commonProps, {
	        data: singleValue,
	        isDisabled: isDisabled
	      }), this.formatOptionLabel(singleValue, 'value'));
	    }
	  }, {
	    key: "renderClearIndicator",
	    value: function renderClearIndicator() {
	      var ClearIndicator = this.components.ClearIndicator;
	      var commonProps = this.commonProps;
	      var _this$props18 = this.props,
	          isDisabled = _this$props18.isDisabled,
	          isLoading = _this$props18.isLoading;
	      var isFocused = this.state.isFocused;
	
	      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
	        return null;
	      }
	
	      var innerProps = {
	        onMouseDown: this.onClearIndicatorMouseDown,
	        onTouchEnd: this.onClearIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return /*#__PURE__*/React__default.createElement(ClearIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderLoadingIndicator",
	    value: function renderLoadingIndicator() {
	      var LoadingIndicator = this.components.LoadingIndicator;
	      var commonProps = this.commonProps;
	      var _this$props19 = this.props,
	          isDisabled = _this$props19.isDisabled,
	          isLoading = _this$props19.isLoading;
	      var isFocused = this.state.isFocused;
	      if (!LoadingIndicator || !isLoading) return null;
	      var innerProps = {
	        'aria-hidden': 'true'
	      };
	      return /*#__PURE__*/React__default.createElement(LoadingIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderIndicatorSeparator",
	    value: function renderIndicatorSeparator() {
	      var _this$components2 = this.components,
	          DropdownIndicator = _this$components2.DropdownIndicator,
	          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
	
	      if (!DropdownIndicator || !IndicatorSeparator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      return /*#__PURE__*/React__default.createElement(IndicatorSeparator, _extends({}, commonProps, {
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderDropdownIndicator",
	    value: function renderDropdownIndicator() {
	      var DropdownIndicator = this.components.DropdownIndicator;
	      if (!DropdownIndicator) return null;
	      var commonProps = this.commonProps;
	      var isDisabled = this.props.isDisabled;
	      var isFocused = this.state.isFocused;
	      var innerProps = {
	        onMouseDown: this.onDropdownIndicatorMouseDown,
	        onTouchEnd: this.onDropdownIndicatorTouchEnd,
	        'aria-hidden': 'true'
	      };
	      return /*#__PURE__*/React__default.createElement(DropdownIndicator, _extends({}, commonProps, {
	        innerProps: innerProps,
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }));
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var _this5 = this;
	
	      var _this$components3 = this.components,
	          Group = _this$components3.Group,
	          GroupHeading = _this$components3.GroupHeading,
	          Menu = _this$components3.Menu,
	          MenuList = _this$components3.MenuList,
	          MenuPortal = _this$components3.MenuPortal,
	          LoadingMessage = _this$components3.LoadingMessage,
	          NoOptionsMessage = _this$components3.NoOptionsMessage,
	          Option = _this$components3.Option;
	      var commonProps = this.commonProps;
	      var _this$state9 = this.state,
	          focusedOption = _this$state9.focusedOption,
	          menuOptions = _this$state9.menuOptions;
	      var _this$props20 = this.props,
	          captureMenuScroll = _this$props20.captureMenuScroll,
	          inputValue = _this$props20.inputValue,
	          isLoading = _this$props20.isLoading,
	          loadingMessage = _this$props20.loadingMessage,
	          minMenuHeight = _this$props20.minMenuHeight,
	          maxMenuHeight = _this$props20.maxMenuHeight,
	          menuIsOpen = _this$props20.menuIsOpen,
	          menuPlacement = _this$props20.menuPlacement,
	          menuPosition = _this$props20.menuPosition,
	          menuPortalTarget = _this$props20.menuPortalTarget,
	          menuShouldBlockScroll = _this$props20.menuShouldBlockScroll,
	          menuShouldScrollIntoView = _this$props20.menuShouldScrollIntoView,
	          noOptionsMessage = _this$props20.noOptionsMessage,
	          onMenuScrollToTop = _this$props20.onMenuScrollToTop,
	          onMenuScrollToBottom = _this$props20.onMenuScrollToBottom;
	      if (!menuIsOpen) return null; // TODO: Internal Option Type here
	
	      var render = function render(props) {
	        // for performance, the menu options in state aren't changed when the
	        // focused option changes so we calculate additional props based on that
	        var isFocused = focusedOption === props.data;
	        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
	        return /*#__PURE__*/React__default.createElement(Option, _extends({}, commonProps, props, {
	          isFocused: isFocused
	        }), _this5.formatOptionLabel(props.data, 'menu'));
	      };
	
	      var menuUI;
	
	      if (this.hasOptions()) {
	        menuUI = menuOptions.render.map(function (item) {
	          if (item.type === 'group') {
	            var type = item.type,
	                group = _objectWithoutProperties(item, ["type"]);
	
	            var headingId = "".concat(item.key, "-heading");
	            return /*#__PURE__*/React__default.createElement(Group, _extends({}, commonProps, group, {
	              Heading: GroupHeading,
	              headingProps: {
	                id: headingId,
	                data: item.data
	              },
	              label: _this5.formatGroupLabel(item.data)
	            }), item.options.map(function (option) {
	              return render(option);
	            }));
	          } else if (item.type === 'option') {
	            return render(item);
	          }
	        });
	      } else if (isLoading) {
	        var message = loadingMessage({
	          inputValue: inputValue
	        });
	        if (message === null) return null;
	        menuUI = /*#__PURE__*/React__default.createElement(LoadingMessage, commonProps, message);
	      } else {
	        var _message = noOptionsMessage({
	          inputValue: inputValue
	        });
	
	        if (_message === null) return null;
	        menuUI = /*#__PURE__*/React__default.createElement(NoOptionsMessage, commonProps, _message);
	      }
	
	      var menuPlacementProps = {
	        minMenuHeight: minMenuHeight,
	        maxMenuHeight: maxMenuHeight,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition,
	        menuShouldScrollIntoView: menuShouldScrollIntoView
	      };
	      var menuElement = /*#__PURE__*/React__default.createElement(index.MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref10) {
	        var ref = _ref10.ref,
	            _ref10$placerProps = _ref10.placerProps,
	            placement = _ref10$placerProps.placement,
	            maxHeight = _ref10$placerProps.maxHeight;
	        return /*#__PURE__*/React__default.createElement(Menu, _extends({}, commonProps, menuPlacementProps, {
	          innerRef: ref,
	          innerProps: {
	            onMouseDown: _this5.onMenuMouseDown,
	            onMouseMove: _this5.onMenuMouseMove
	          },
	          isLoading: isLoading,
	          placement: placement
	        }), /*#__PURE__*/React__default.createElement(ScrollCaptorSwitch, {
	          isEnabled: captureMenuScroll,
	          onTopArrive: onMenuScrollToTop,
	          onBottomArrive: onMenuScrollToBottom
	        }, /*#__PURE__*/React__default.createElement(ScrollBlock, {
	          isEnabled: menuShouldBlockScroll
	        }, /*#__PURE__*/React__default.createElement(MenuList, _extends({}, commonProps, {
	          innerRef: _this5.getMenuListRef,
	          isLoading: isLoading,
	          maxHeight: maxHeight
	        }), menuUI))));
	      }); // positioning behaviour is almost identical for portalled and fixed,
	      // so we use the same component. the actual portalling logic is forked
	      // within the component based on `menuPosition`
	
	      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React__default.createElement(MenuPortal, _extends({}, commonProps, {
	        appendTo: menuPortalTarget,
	        controlElement: this.controlRef,
	        menuPlacement: menuPlacement,
	        menuPosition: menuPosition
	      }), menuElement) : menuElement;
	    }
	  }, {
	    key: "renderFormField",
	    value: function renderFormField() {
	      var _this6 = this;
	
	      var _this$props21 = this.props,
	          delimiter = _this$props21.delimiter,
	          isDisabled = _this$props21.isDisabled,
	          isMulti = _this$props21.isMulti,
	          name = _this$props21.name;
	      var selectValue = this.state.selectValue;
	      if (!name || isDisabled) return;
	
	      if (isMulti) {
	        if (delimiter) {
	          var value = selectValue.map(function (opt) {
	            return _this6.getOptionValue(opt);
	          }).join(delimiter);
	          return /*#__PURE__*/React__default.createElement("input", {
	            name: name,
	            type: "hidden",
	            value: value
	          });
	        } else {
	          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
	            return /*#__PURE__*/React__default.createElement("input", {
	              key: "i-".concat(i),
	              name: name,
	              type: "hidden",
	              value: _this6.getOptionValue(opt)
	            });
	          }) : /*#__PURE__*/React__default.createElement("input", {
	            name: name,
	            type: "hidden"
	          });
	          return /*#__PURE__*/React__default.createElement("div", null, input);
	        }
	      } else {
	        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
	
	        return /*#__PURE__*/React__default.createElement("input", {
	          name: name,
	          type: "hidden",
	          value: _value2
	        });
	      }
	    }
	  }, {
	    key: "renderLiveRegion",
	    value: function renderLiveRegion() {
	      if (!this.state.isFocused) return null;
	      return /*#__PURE__*/React__default.createElement(A11yText, {
	        "aria-live": "polite"
	      }, /*#__PURE__*/React__default.createElement("span", {
	        id: "aria-selection-event"
	      }, "\xA0", this.state.ariaLiveSelection), /*#__PURE__*/React__default.createElement("span", {
	        id: "aria-context"
	      }, "\xA0", this.constructAriaLiveMessage()));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$components4 = this.components,
	          Control = _this$components4.Control,
	          IndicatorsContainer = _this$components4.IndicatorsContainer,
	          SelectContainer = _this$components4.SelectContainer,
	          ValueContainer = _this$components4.ValueContainer;
	      var _this$props22 = this.props,
	          className = _this$props22.className,
	          id = _this$props22.id,
	          isDisabled = _this$props22.isDisabled,
	          menuIsOpen = _this$props22.menuIsOpen;
	      var isFocused = this.state.isFocused;
	      var commonProps = this.commonProps = this.getCommonProps();
	      return /*#__PURE__*/React__default.createElement(SelectContainer, _extends({}, commonProps, {
	        className: className,
	        innerProps: {
	          id: id,
	          onKeyDown: this.onKeyDown
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused
	      }), this.renderLiveRegion(), /*#__PURE__*/React__default.createElement(Control, _extends({}, commonProps, {
	        innerRef: this.getControlRef,
	        innerProps: {
	          onMouseDown: this.onControlMouseDown,
	          onTouchEnd: this.onControlTouchEnd
	        },
	        isDisabled: isDisabled,
	        isFocused: isFocused,
	        menuIsOpen: menuIsOpen
	      }), /*#__PURE__*/React__default.createElement(ValueContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React__default.createElement(IndicatorsContainer, _extends({}, commonProps, {
	        isDisabled: isDisabled
	      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
	    }
	  }]);
	
	  return Select;
	}(React.Component);
	
	Select.defaultProps = defaultProps;
	
	exports.Select = Select;
	exports.createFilter = createFilter;
	exports.defaultProps = defaultProps;
	exports.defaultTheme = defaultTheme;
	exports.mergeStyles = mergeStyles;


/***/ }),
/* 6283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _objectWithoutProperties = _interopDefault(__webpack_require__(1043));
	var _extends = _interopDefault(__webpack_require__(1040));
	var _classCallCheck = _interopDefault(__webpack_require__(1038));
	var _createClass = _interopDefault(__webpack_require__(1039));
	var _inherits = _interopDefault(__webpack_require__(1042));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(1044));
	var _getPrototypeOf = _interopDefault(__webpack_require__(1041));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	var defaultProps = {
	  defaultInputValue: '',
	  defaultMenuIsOpen: false,
	  defaultValue: null
	};
	
	var manageState = function manageState(SelectComponent) {
	  var _class, _temp;
	
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inherits(StateManager, _Component);
	
	    var _super = _createSuper(StateManager);
	
	    function StateManager() {
	      var _this;
	
	      _classCallCheck(this, StateManager);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _super.call.apply(_super, [this].concat(args));
	      _this.select = void 0;
	      _this.state = {
	        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
	        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
	        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
	      };
	
	      _this.onChange = function (value, actionMeta) {
	        _this.callProp('onChange', value, actionMeta);
	
	        _this.setState({
	          value: value
	        });
	      };
	
	      _this.onInputChange = function (value, actionMeta) {
	        // TODO: for backwards compatibility, we allow the prop to return a new
	        // value, but now inputValue is a controllable prop we probably shouldn't
	        var newValue = _this.callProp('onInputChange', value, actionMeta);
	
	        _this.setState({
	          inputValue: newValue !== undefined ? newValue : value
	        });
	      };
	
	      _this.onMenuOpen = function () {
	        _this.callProp('onMenuOpen');
	
	        _this.setState({
	          menuIsOpen: true
	        });
	      };
	
	      _this.onMenuClose = function () {
	        _this.callProp('onMenuClose');
	
	        _this.setState({
	          menuIsOpen: false
	        });
	      };
	
	      return _this;
	    }
	
	    _createClass(StateManager, [{
	      key: "focus",
	      value: function focus() {
	        this.select.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.select.blur();
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "getProp",
	      value: function getProp(key) {
	        return this.props[key] !== undefined ? this.props[key] : this.state[key];
	      } // FIXME: untyped flow code, return any
	
	    }, {
	      key: "callProp",
	      value: function callProp(name) {
	        if (typeof this.props[name] === 'function') {
	          var _this$props;
	
	          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	            args[_key2 - 1] = arguments[_key2];
	          }
	
	          return (_this$props = this.props)[name].apply(_this$props, args);
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            defaultInputValue = _this$props2.defaultInputValue,
	            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
	            defaultValue = _this$props2.defaultValue,
	            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);
	
	        return /*#__PURE__*/React__default.createElement(SelectComponent, _extends({}, props, {
	          ref: function ref(_ref) {
	            _this2.select = _ref;
	          },
	          inputValue: this.getProp('inputValue'),
	          menuIsOpen: this.getProp('menuIsOpen'),
	          onChange: this.onChange,
	          onInputChange: this.onInputChange,
	          onMenuClose: this.onMenuClose,
	          onMenuOpen: this.onMenuOpen,
	          value: this.getProp('value')
	        }));
	      }
	    }]);
	
	    return StateManager;
	  }(React.Component), _class.defaultProps = defaultProps, _temp;
	};
	
	exports.manageState = manageState;


/***/ }),
/* 6284 */
/***/ (function(module, exports) {

	function _arrayWithHoles(r) {
	  if (Array.isArray(r)) return r;
	}
	module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6285 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(2818);
	function _arrayWithoutHoles(r) {
	  if (Array.isArray(r)) return arrayLikeToArray(r);
	}
	module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6286 */
/***/ (function(module, exports) {

	function _iterableToArray(r) {
	  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
	}
	module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6287 */
/***/ (function(module, exports) {

	function _iterableToArrayLimit(r, l) {
	  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	  if (null != t) {
	    var e,
	      n,
	      i,
	      u,
	      a = [],
	      f = !0,
	      o = !1;
	    try {
	      if (i = (t = t.call(r)).next, 0 === l) {
	        if (Object(t) !== t) return;
	        f = !1;
	      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
	    } catch (r) {
	      o = !0, n = r;
	    } finally {
	      try {
	        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
	      } finally {
	        if (o) throw n;
	      }
	    }
	    return a;
	  }
	}
	module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6288 */
/***/ (function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6289 */
/***/ (function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6290 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(r, e) {
	  if (null == r) return {};
	  var t = {};
	  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
	    if (-1 !== e.indexOf(n)) continue;
	    t[n] = r[n];
	  }
	  return t;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6291 */
/***/ (function(module, exports) {

	function _setPrototypeOf(t, e) {
	  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6292 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(749)["default"];
	function toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r || "default");
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6293 */
2825,
/* 6294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2824);
	var React = __webpack_require__(1);
	var createCache = __webpack_require__(2825);
	var utils = __webpack_require__(1056);
	var serialize = __webpack_require__(755);
	
	function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }
	
	var createCache__default = /*#__PURE__*/_interopDefault(createCache);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var EmotionCacheContext = /*#__PURE__*/React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache__default['default']() : null);
	var ThemeContext = /*#__PURE__*/React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	var withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return /*#__PURE__*/React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return /*#__PURE__*/React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var createEmotionProps = function createEmotionProps(type, props) {
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  return newProps;
	};
	
	var Noop = function Noop() {
	  return null;
	};
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (typeof props.className === 'string') {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  } else if (props.className != null) {
	    className = props.className + " ";
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = /*#__PURE__*/React.createElement(type, newProps);
	  var possiblyStyleElement = /*#__PURE__*/React.createElement(Noop, null);
	
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, possiblyStyleElement, ele);
	}; // eslint-disable-next-line no-undef
	
	
	var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
	  if (typeof props.css === 'function') {
	    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	}
	
	exports.CacheProvider = CacheProvider;
	exports.Emotion = Emotion;
	exports.ThemeContext = ThemeContext;
	exports.createEmotionProps = createEmotionProps;
	exports.hasOwnProperty = hasOwnProperty;
	exports.withEmotionCache = withEmotionCache;


/***/ }),
/* 6295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(1484);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(6483);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 6296 */
/***/ (function(module, exports) {

	// GENERATED DO NOT EDIT
	module.exports = [
	  "alignContent",
	  "MozAlignContent",
	  "WebkitAlignContent",
	  "MSAlignContent",
	  "OAlignContent",
	  "alignItems",
	  "MozAlignItems",
	  "WebkitAlignItems",
	  "MSAlignItems",
	  "OAlignItems",
	  "alignSelf",
	  "MozAlignSelf",
	  "WebkitAlignSelf",
	  "MSAlignSelf",
	  "OAlignSelf",
	  "all",
	  "MozAll",
	  "WebkitAll",
	  "MSAll",
	  "OAll",
	  "animation",
	  "MozAnimation",
	  "WebkitAnimation",
	  "MSAnimation",
	  "OAnimation",
	  "animationDelay",
	  "MozAnimationDelay",
	  "WebkitAnimationDelay",
	  "MSAnimationDelay",
	  "OAnimationDelay",
	  "animationDirection",
	  "MozAnimationDirection",
	  "WebkitAnimationDirection",
	  "MSAnimationDirection",
	  "OAnimationDirection",
	  "animationDuration",
	  "MozAnimationDuration",
	  "WebkitAnimationDuration",
	  "MSAnimationDuration",
	  "OAnimationDuration",
	  "animationFillMode",
	  "MozAnimationFillMode",
	  "WebkitAnimationFillMode",
	  "MSAnimationFillMode",
	  "OAnimationFillMode",
	  "animationIterationCount",
	  "MozAnimationIterationCount",
	  "WebkitAnimationIterationCount",
	  "MSAnimationIterationCount",
	  "OAnimationIterationCount",
	  "animationName",
	  "MozAnimationName",
	  "WebkitAnimationName",
	  "MSAnimationName",
	  "OAnimationName",
	  "animationPlayState",
	  "MozAnimationPlayState",
	  "WebkitAnimationPlayState",
	  "MSAnimationPlayState",
	  "OAnimationPlayState",
	  "animationTimingFunction",
	  "MozAnimationTimingFunction",
	  "WebkitAnimationTimingFunction",
	  "MSAnimationTimingFunction",
	  "OAnimationTimingFunction",
	  "backfaceVisibility",
	  "MozBackfaceVisibility",
	  "WebkitBackfaceVisibility",
	  "MSBackfaceVisibility",
	  "OBackfaceVisibility",
	  "background",
	  "MozBackground",
	  "WebkitBackground",
	  "MSBackground",
	  "OBackground",
	  "backgroundAttachment",
	  "MozBackgroundAttachment",
	  "WebkitBackgroundAttachment",
	  "MSBackgroundAttachment",
	  "OBackgroundAttachment",
	  "backgroundBlendMode",
	  "MozBackgroundBlendMode",
	  "WebkitBackgroundBlendMode",
	  "MSBackgroundBlendMode",
	  "OBackgroundBlendMode",
	  "backgroundClip",
	  "MozBackgroundClip",
	  "WebkitBackgroundClip",
	  "MSBackgroundClip",
	  "OBackgroundClip",
	  "backgroundColor",
	  "MozBackgroundColor",
	  "WebkitBackgroundColor",
	  "MSBackgroundColor",
	  "OBackgroundColor",
	  "backgroundImage",
	  "MozBackgroundImage",
	  "WebkitBackgroundImage",
	  "MSBackgroundImage",
	  "OBackgroundImage",
	  "backgroundOrigin",
	  "MozBackgroundOrigin",
	  "WebkitBackgroundOrigin",
	  "MSBackgroundOrigin",
	  "OBackgroundOrigin",
	  "backgroundPosition",
	  "MozBackgroundPosition",
	  "WebkitBackgroundPosition",
	  "MSBackgroundPosition",
	  "OBackgroundPosition",
	  "backgroundRepeat",
	  "MozBackgroundRepeat",
	  "WebkitBackgroundRepeat",
	  "MSBackgroundRepeat",
	  "OBackgroundRepeat",
	  "backgroundSize",
	  "MozBackgroundSize",
	  "WebkitBackgroundSize",
	  "MSBackgroundSize",
	  "OBackgroundSize",
	  "blockSize",
	  "MozBlockSize",
	  "WebkitBlockSize",
	  "MSBlockSize",
	  "OBlockSize",
	  "border",
	  "MozBorder",
	  "WebkitBorder",
	  "MSBorder",
	  "OBorder",
	  "borderBlockEnd",
	  "MozBorderBlockEnd",
	  "WebkitBorderBlockEnd",
	  "MSBorderBlockEnd",
	  "OBorderBlockEnd",
	  "borderBlockEndColor",
	  "MozBorderBlockEndColor",
	  "WebkitBorderBlockEndColor",
	  "MSBorderBlockEndColor",
	  "OBorderBlockEndColor",
	  "borderBlockEndStyle",
	  "MozBorderBlockEndStyle",
	  "WebkitBorderBlockEndStyle",
	  "MSBorderBlockEndStyle",
	  "OBorderBlockEndStyle",
	  "borderBlockEndWidth",
	  "MozBorderBlockEndWidth",
	  "WebkitBorderBlockEndWidth",
	  "MSBorderBlockEndWidth",
	  "OBorderBlockEndWidth",
	  "borderBlockStart",
	  "MozBorderBlockStart",
	  "WebkitBorderBlockStart",
	  "MSBorderBlockStart",
	  "OBorderBlockStart",
	  "borderBlockStartColor",
	  "MozBorderBlockStartColor",
	  "WebkitBorderBlockStartColor",
	  "MSBorderBlockStartColor",
	  "OBorderBlockStartColor",
	  "borderBlockStartStyle",
	  "MozBorderBlockStartStyle",
	  "WebkitBorderBlockStartStyle",
	  "MSBorderBlockStartStyle",
	  "OBorderBlockStartStyle",
	  "borderBlockStartWidth",
	  "MozBorderBlockStartWidth",
	  "WebkitBorderBlockStartWidth",
	  "MSBorderBlockStartWidth",
	  "OBorderBlockStartWidth",
	  "borderBottom",
	  "MozBorderBottom",
	  "WebkitBorderBottom",
	  "MSBorderBottom",
	  "OBorderBottom",
	  "borderBottomColor",
	  "MozBorderBottomColor",
	  "WebkitBorderBottomColor",
	  "MSBorderBottomColor",
	  "OBorderBottomColor",
	  "borderBottomLeftRadius",
	  "MozBorderBottomLeftRadius",
	  "WebkitBorderBottomLeftRadius",
	  "MSBorderBottomLeftRadius",
	  "OBorderBottomLeftRadius",
	  "borderBottomRightRadius",
	  "MozBorderBottomRightRadius",
	  "WebkitBorderBottomRightRadius",
	  "MSBorderBottomRightRadius",
	  "OBorderBottomRightRadius",
	  "borderBottomStyle",
	  "MozBorderBottomStyle",
	  "WebkitBorderBottomStyle",
	  "MSBorderBottomStyle",
	  "OBorderBottomStyle",
	  "borderBottomWidth",
	  "MozBorderBottomWidth",
	  "WebkitBorderBottomWidth",
	  "MSBorderBottomWidth",
	  "OBorderBottomWidth",
	  "borderCollapse",
	  "MozBorderCollapse",
	  "WebkitBorderCollapse",
	  "MSBorderCollapse",
	  "OBorderCollapse",
	  "borderColor",
	  "MozBorderColor",
	  "WebkitBorderColor",
	  "MSBorderColor",
	  "OBorderColor",
	  "borderImage",
	  "MozBorderImage",
	  "WebkitBorderImage",
	  "MSBorderImage",
	  "OBorderImage",
	  "borderImageOutset",
	  "MozBorderImageOutset",
	  "WebkitBorderImageOutset",
	  "MSBorderImageOutset",
	  "OBorderImageOutset",
	  "borderImageRepeat",
	  "MozBorderImageRepeat",
	  "WebkitBorderImageRepeat",
	  "MSBorderImageRepeat",
	  "OBorderImageRepeat",
	  "borderImageSlice",
	  "MozBorderImageSlice",
	  "WebkitBorderImageSlice",
	  "MSBorderImageSlice",
	  "OBorderImageSlice",
	  "borderImageSource",
	  "MozBorderImageSource",
	  "WebkitBorderImageSource",
	  "MSBorderImageSource",
	  "OBorderImageSource",
	  "borderImageWidth",
	  "MozBorderImageWidth",
	  "WebkitBorderImageWidth",
	  "MSBorderImageWidth",
	  "OBorderImageWidth",
	  "borderInlineEnd",
	  "MozBorderInlineEnd",
	  "WebkitBorderInlineEnd",
	  "MSBorderInlineEnd",
	  "OBorderInlineEnd",
	  "borderInlineEndColor",
	  "MozBorderInlineEndColor",
	  "WebkitBorderInlineEndColor",
	  "MSBorderInlineEndColor",
	  "OBorderInlineEndColor",
	  "borderInlineEndStyle",
	  "MozBorderInlineEndStyle",
	  "WebkitBorderInlineEndStyle",
	  "MSBorderInlineEndStyle",
	  "OBorderInlineEndStyle",
	  "borderInlineEndWidth",
	  "MozBorderInlineEndWidth",
	  "WebkitBorderInlineEndWidth",
	  "MSBorderInlineEndWidth",
	  "OBorderInlineEndWidth",
	  "borderInlineStart",
	  "MozBorderInlineStart",
	  "WebkitBorderInlineStart",
	  "MSBorderInlineStart",
	  "OBorderInlineStart",
	  "borderInlineStartColor",
	  "MozBorderInlineStartColor",
	  "WebkitBorderInlineStartColor",
	  "MSBorderInlineStartColor",
	  "OBorderInlineStartColor",
	  "borderInlineStartStyle",
	  "MozBorderInlineStartStyle",
	  "WebkitBorderInlineStartStyle",
	  "MSBorderInlineStartStyle",
	  "OBorderInlineStartStyle",
	  "borderInlineStartWidth",
	  "MozBorderInlineStartWidth",
	  "WebkitBorderInlineStartWidth",
	  "MSBorderInlineStartWidth",
	  "OBorderInlineStartWidth",
	  "borderLeft",
	  "MozBorderLeft",
	  "WebkitBorderLeft",
	  "MSBorderLeft",
	  "OBorderLeft",
	  "borderLeftColor",
	  "MozBorderLeftColor",
	  "WebkitBorderLeftColor",
	  "MSBorderLeftColor",
	  "OBorderLeftColor",
	  "borderLeftStyle",
	  "MozBorderLeftStyle",
	  "WebkitBorderLeftStyle",
	  "MSBorderLeftStyle",
	  "OBorderLeftStyle",
	  "borderLeftWidth",
	  "MozBorderLeftWidth",
	  "WebkitBorderLeftWidth",
	  "MSBorderLeftWidth",
	  "OBorderLeftWidth",
	  "borderRadius",
	  "MozBorderRadius",
	  "WebkitBorderRadius",
	  "MSBorderRadius",
	  "OBorderRadius",
	  "borderRight",
	  "MozBorderRight",
	  "WebkitBorderRight",
	  "MSBorderRight",
	  "OBorderRight",
	  "borderRightColor",
	  "MozBorderRightColor",
	  "WebkitBorderRightColor",
	  "MSBorderRightColor",
	  "OBorderRightColor",
	  "borderRightStyle",
	  "MozBorderRightStyle",
	  "WebkitBorderRightStyle",
	  "MSBorderRightStyle",
	  "OBorderRightStyle",
	  "borderRightWidth",
	  "MozBorderRightWidth",
	  "WebkitBorderRightWidth",
	  "MSBorderRightWidth",
	  "OBorderRightWidth",
	  "borderSpacing",
	  "MozBorderSpacing",
	  "WebkitBorderSpacing",
	  "MSBorderSpacing",
	  "OBorderSpacing",
	  "borderStyle",
	  "MozBorderStyle",
	  "WebkitBorderStyle",
	  "MSBorderStyle",
	  "OBorderStyle",
	  "borderTop",
	  "MozBorderTop",
	  "WebkitBorderTop",
	  "MSBorderTop",
	  "OBorderTop",
	  "borderTopColor",
	  "MozBorderTopColor",
	  "WebkitBorderTopColor",
	  "MSBorderTopColor",
	  "OBorderTopColor",
	  "borderTopLeftRadius",
	  "MozBorderTopLeftRadius",
	  "WebkitBorderTopLeftRadius",
	  "MSBorderTopLeftRadius",
	  "OBorderTopLeftRadius",
	  "borderTopRightRadius",
	  "MozBorderTopRightRadius",
	  "WebkitBorderTopRightRadius",
	  "MSBorderTopRightRadius",
	  "OBorderTopRightRadius",
	  "borderTopStyle",
	  "MozBorderTopStyle",
	  "WebkitBorderTopStyle",
	  "MSBorderTopStyle",
	  "OBorderTopStyle",
	  "borderTopWidth",
	  "MozBorderTopWidth",
	  "WebkitBorderTopWidth",
	  "MSBorderTopWidth",
	  "OBorderTopWidth",
	  "borderWidth",
	  "MozBorderWidth",
	  "WebkitBorderWidth",
	  "MSBorderWidth",
	  "OBorderWidth",
	  "bottom",
	  "MozBottom",
	  "WebkitBottom",
	  "MSBottom",
	  "OBottom",
	  "boxDecorationBreak",
	  "MozBoxDecorationBreak",
	  "WebkitBoxDecorationBreak",
	  "MSBoxDecorationBreak",
	  "OBoxDecorationBreak",
	  "boxShadow",
	  "MozBoxShadow",
	  "WebkitBoxShadow",
	  "MSBoxShadow",
	  "OBoxShadow",
	  "boxSizing",
	  "MozBoxSizing",
	  "WebkitBoxSizing",
	  "MSBoxSizing",
	  "OBoxSizing",
	  "breakAfter",
	  "MozBreakAfter",
	  "WebkitBreakAfter",
	  "MSBreakAfter",
	  "OBreakAfter",
	  "breakBefore",
	  "MozBreakBefore",
	  "WebkitBreakBefore",
	  "MSBreakBefore",
	  "OBreakBefore",
	  "breakInside",
	  "MozBreakInside",
	  "WebkitBreakInside",
	  "MSBreakInside",
	  "OBreakInside",
	  "captionSide",
	  "MozCaptionSide",
	  "WebkitCaptionSide",
	  "MSCaptionSide",
	  "OCaptionSide",
	  "caretColor",
	  "MozCaretColor",
	  "WebkitCaretColor",
	  "MSCaretColor",
	  "OCaretColor",
	  "ch",
	  "MozCh",
	  "WebkitCh",
	  "MSCh",
	  "OCh",
	  "clear",
	  "MozClear",
	  "WebkitClear",
	  "MSClear",
	  "OClear",
	  "clip",
	  "MozClip",
	  "WebkitClip",
	  "MSClip",
	  "OClip",
	  "clipPath",
	  "MozClipPath",
	  "WebkitClipPath",
	  "MSClipPath",
	  "OClipPath",
	  "cm",
	  "MozCm",
	  "WebkitCm",
	  "MSCm",
	  "OCm",
	  "color",
	  "MozColor",
	  "WebkitColor",
	  "MSColor",
	  "OColor",
	  "columnCount",
	  "MozColumnCount",
	  "WebkitColumnCount",
	  "MSColumnCount",
	  "OColumnCount",
	  "columnFill",
	  "MozColumnFill",
	  "WebkitColumnFill",
	  "MSColumnFill",
	  "OColumnFill",
	  "columnGap",
	  "MozColumnGap",
	  "WebkitColumnGap",
	  "MSColumnGap",
	  "OColumnGap",
	  "columnRule",
	  "MozColumnRule",
	  "WebkitColumnRule",
	  "MSColumnRule",
	  "OColumnRule",
	  "columnRuleColor",
	  "MozColumnRuleColor",
	  "WebkitColumnRuleColor",
	  "MSColumnRuleColor",
	  "OColumnRuleColor",
	  "columnRuleStyle",
	  "MozColumnRuleStyle",
	  "WebkitColumnRuleStyle",
	  "MSColumnRuleStyle",
	  "OColumnRuleStyle",
	  "columnRuleWidth",
	  "MozColumnRuleWidth",
	  "WebkitColumnRuleWidth",
	  "MSColumnRuleWidth",
	  "OColumnRuleWidth",
	  "columnSpan",
	  "MozColumnSpan",
	  "WebkitColumnSpan",
	  "MSColumnSpan",
	  "OColumnSpan",
	  "columnWidth",
	  "MozColumnWidth",
	  "WebkitColumnWidth",
	  "MSColumnWidth",
	  "OColumnWidth",
	  "columns",
	  "MozColumns",
	  "WebkitColumns",
	  "MSColumns",
	  "OColumns",
	  "content",
	  "MozContent",
	  "WebkitContent",
	  "MSContent",
	  "OContent",
	  "counterIncrement",
	  "MozCounterIncrement",
	  "WebkitCounterIncrement",
	  "MSCounterIncrement",
	  "OCounterIncrement",
	  "counterReset",
	  "MozCounterReset",
	  "WebkitCounterReset",
	  "MSCounterReset",
	  "OCounterReset",
	  "cursor",
	  "MozCursor",
	  "WebkitCursor",
	  "MSCursor",
	  "OCursor",
	  "deg",
	  "MozDeg",
	  "WebkitDeg",
	  "MSDeg",
	  "ODeg",
	  "direction",
	  "MozDirection",
	  "WebkitDirection",
	  "MSDirection",
	  "ODirection",
	  "display",
	  "MozDisplay",
	  "WebkitDisplay",
	  "MSDisplay",
	  "ODisplay",
	  "dpcm",
	  "MozDpcm",
	  "WebkitDpcm",
	  "MSDpcm",
	  "ODpcm",
	  "dpi",
	  "MozDpi",
	  "WebkitDpi",
	  "MSDpi",
	  "ODpi",
	  "dppx",
	  "MozDppx",
	  "WebkitDppx",
	  "MSDppx",
	  "ODppx",
	  "em",
	  "MozEm",
	  "WebkitEm",
	  "MSEm",
	  "OEm",
	  "emptyCells",
	  "MozEmptyCells",
	  "WebkitEmptyCells",
	  "MSEmptyCells",
	  "OEmptyCells",
	  "ex",
	  "MozEx",
	  "WebkitEx",
	  "MSEx",
	  "OEx",
	  "filter",
	  "MozFilter",
	  "WebkitFilter",
	  "MSFilter",
	  "OFilter",
	  "flexBasis",
	  "MozFlexBasis",
	  "WebkitFlexBasis",
	  "MSFlexBasis",
	  "OFlexBasis",
	  "flexDirection",
	  "MozFlexDirection",
	  "WebkitFlexDirection",
	  "MSFlexDirection",
	  "OFlexDirection",
	  "flexFlow",
	  "MozFlexFlow",
	  "WebkitFlexFlow",
	  "MSFlexFlow",
	  "OFlexFlow",
	  "flexGrow",
	  "MozFlexGrow",
	  "WebkitFlexGrow",
	  "MSFlexGrow",
	  "OFlexGrow",
	  "flexShrink",
	  "MozFlexShrink",
	  "WebkitFlexShrink",
	  "MSFlexShrink",
	  "OFlexShrink",
	  "flexWrap",
	  "MozFlexWrap",
	  "WebkitFlexWrap",
	  "MSFlexWrap",
	  "OFlexWrap",
	  "float",
	  "MozFloat",
	  "WebkitFloat",
	  "MSFloat",
	  "OFloat",
	  "font",
	  "MozFont",
	  "WebkitFont",
	  "MSFont",
	  "OFont",
	  "fontFamily",
	  "MozFontFamily",
	  "WebkitFontFamily",
	  "MSFontFamily",
	  "OFontFamily",
	  "fontFeatureSettings",
	  "MozFontFeatureSettings",
	  "WebkitFontFeatureSettings",
	  "MSFontFeatureSettings",
	  "OFontFeatureSettings",
	  "fontKerning",
	  "MozFontKerning",
	  "WebkitFontKerning",
	  "MSFontKerning",
	  "OFontKerning",
	  "fontLanguageOverride",
	  "MozFontLanguageOverride",
	  "WebkitFontLanguageOverride",
	  "MSFontLanguageOverride",
	  "OFontLanguageOverride",
	  "fontSize",
	  "MozFontSize",
	  "WebkitFontSize",
	  "MSFontSize",
	  "OFontSize",
	  "fontSizeAdjust",
	  "MozFontSizeAdjust",
	  "WebkitFontSizeAdjust",
	  "MSFontSizeAdjust",
	  "OFontSizeAdjust",
	  "fontStretch",
	  "MozFontStretch",
	  "WebkitFontStretch",
	  "MSFontStretch",
	  "OFontStretch",
	  "fontStyle",
	  "MozFontStyle",
	  "WebkitFontStyle",
	  "MSFontStyle",
	  "OFontStyle",
	  "fontSynthesis",
	  "MozFontSynthesis",
	  "WebkitFontSynthesis",
	  "MSFontSynthesis",
	  "OFontSynthesis",
	  "fontVariant",
	  "MozFontVariant",
	  "WebkitFontVariant",
	  "MSFontVariant",
	  "OFontVariant",
	  "fontVariantAlternates",
	  "MozFontVariantAlternates",
	  "WebkitFontVariantAlternates",
	  "MSFontVariantAlternates",
	  "OFontVariantAlternates",
	  "fontVariantCaps",
	  "MozFontVariantCaps",
	  "WebkitFontVariantCaps",
	  "MSFontVariantCaps",
	  "OFontVariantCaps",
	  "fontVariantEastAsian",
	  "MozFontVariantEastAsian",
	  "WebkitFontVariantEastAsian",
	  "MSFontVariantEastAsian",
	  "OFontVariantEastAsian",
	  "fontVariantLigatures",
	  "MozFontVariantLigatures",
	  "WebkitFontVariantLigatures",
	  "MSFontVariantLigatures",
	  "OFontVariantLigatures",
	  "fontVariantNumeric",
	  "MozFontVariantNumeric",
	  "WebkitFontVariantNumeric",
	  "MSFontVariantNumeric",
	  "OFontVariantNumeric",
	  "fontVariantPosition",
	  "MozFontVariantPosition",
	  "WebkitFontVariantPosition",
	  "MSFontVariantPosition",
	  "OFontVariantPosition",
	  "fontWeight",
	  "MozFontWeight",
	  "WebkitFontWeight",
	  "MSFontWeight",
	  "OFontWeight",
	  "fr",
	  "MozFr",
	  "WebkitFr",
	  "MSFr",
	  "OFr",
	  "grad",
	  "MozGrad",
	  "WebkitGrad",
	  "MSGrad",
	  "OGrad",
	  "grid",
	  "MozGrid",
	  "WebkitGrid",
	  "MSGrid",
	  "OGrid",
	  "gridArea",
	  "MozGridArea",
	  "WebkitGridArea",
	  "MSGridArea",
	  "OGridArea",
	  "gridAutoColumns",
	  "MozGridAutoColumns",
	  "WebkitGridAutoColumns",
	  "MSGridAutoColumns",
	  "OGridAutoColumns",
	  "gridAutoFlow",
	  "MozGridAutoFlow",
	  "WebkitGridAutoFlow",
	  "MSGridAutoFlow",
	  "OGridAutoFlow",
	  "gridAutoRows",
	  "MozGridAutoRows",
	  "WebkitGridAutoRows",
	  "MSGridAutoRows",
	  "OGridAutoRows",
	  "gridColumn",
	  "MozGridColumn",
	  "WebkitGridColumn",
	  "MSGridColumn",
	  "OGridColumn",
	  "gridColumnEnd",
	  "MozGridColumnEnd",
	  "WebkitGridColumnEnd",
	  "MSGridColumnEnd",
	  "OGridColumnEnd",
	  "gridColumnGap",
	  "MozGridColumnGap",
	  "WebkitGridColumnGap",
	  "MSGridColumnGap",
	  "OGridColumnGap",
	  "gridColumnStart",
	  "MozGridColumnStart",
	  "WebkitGridColumnStart",
	  "MSGridColumnStart",
	  "OGridColumnStart",
	  "gridGap",
	  "MozGridGap",
	  "WebkitGridGap",
	  "MSGridGap",
	  "OGridGap",
	  "gridRow",
	  "MozGridRow",
	  "WebkitGridRow",
	  "MSGridRow",
	  "OGridRow",
	  "gridRowEnd",
	  "MozGridRowEnd",
	  "WebkitGridRowEnd",
	  "MSGridRowEnd",
	  "OGridRowEnd",
	  "gridRowGap",
	  "MozGridRowGap",
	  "WebkitGridRowGap",
	  "MSGridRowGap",
	  "OGridRowGap",
	  "gridRowStart",
	  "MozGridRowStart",
	  "WebkitGridRowStart",
	  "MSGridRowStart",
	  "OGridRowStart",
	  "gridTemplate",
	  "MozGridTemplate",
	  "WebkitGridTemplate",
	  "MSGridTemplate",
	  "OGridTemplate",
	  "gridTemplateAreas",
	  "MozGridTemplateAreas",
	  "WebkitGridTemplateAreas",
	  "MSGridTemplateAreas",
	  "OGridTemplateAreas",
	  "gridTemplateColumns",
	  "MozGridTemplateColumns",
	  "WebkitGridTemplateColumns",
	  "MSGridTemplateColumns",
	  "OGridTemplateColumns",
	  "gridTemplateRows",
	  "MozGridTemplateRows",
	  "WebkitGridTemplateRows",
	  "MSGridTemplateRows",
	  "OGridTemplateRows",
	  "height",
	  "MozHeight",
	  "WebkitHeight",
	  "MSHeight",
	  "OHeight",
	  "hyphens",
	  "MozHyphens",
	  "WebkitHyphens",
	  "MSHyphens",
	  "OHyphens",
	  "hz",
	  "MozHz",
	  "WebkitHz",
	  "MSHz",
	  "OHz",
	  "imageOrientation",
	  "MozImageOrientation",
	  "WebkitImageOrientation",
	  "MSImageOrientation",
	  "OImageOrientation",
	  "imageRendering",
	  "MozImageRendering",
	  "WebkitImageRendering",
	  "MSImageRendering",
	  "OImageRendering",
	  "imageResolution",
	  "MozImageResolution",
	  "WebkitImageResolution",
	  "MSImageResolution",
	  "OImageResolution",
	  "imeMode",
	  "MozImeMode",
	  "WebkitImeMode",
	  "MSImeMode",
	  "OImeMode",
	  "in",
	  "MozIn",
	  "WebkitIn",
	  "MSIn",
	  "OIn",
	  "inherit",
	  "MozInherit",
	  "WebkitInherit",
	  "MSInherit",
	  "OInherit",
	  "initial",
	  "MozInitial",
	  "WebkitInitial",
	  "MSInitial",
	  "OInitial",
	  "inlineSize",
	  "MozInlineSize",
	  "WebkitInlineSize",
	  "MSInlineSize",
	  "OInlineSize",
	  "isolation",
	  "MozIsolation",
	  "WebkitIsolation",
	  "MSIsolation",
	  "OIsolation",
	  "justifyContent",
	  "MozJustifyContent",
	  "WebkitJustifyContent",
	  "MSJustifyContent",
	  "OJustifyContent",
	  "khz",
	  "MozKhz",
	  "WebkitKhz",
	  "MSKhz",
	  "OKhz",
	  "left",
	  "MozLeft",
	  "WebkitLeft",
	  "MSLeft",
	  "OLeft",
	  "letterSpacing",
	  "MozLetterSpacing",
	  "WebkitLetterSpacing",
	  "MSLetterSpacing",
	  "OLetterSpacing",
	  "lineBreak",
	  "MozLineBreak",
	  "WebkitLineBreak",
	  "MSLineBreak",
	  "OLineBreak",
	  "lineHeight",
	  "MozLineHeight",
	  "WebkitLineHeight",
	  "MSLineHeight",
	  "OLineHeight",
	  "listStyle",
	  "MozListStyle",
	  "WebkitListStyle",
	  "MSListStyle",
	  "OListStyle",
	  "listStyleImage",
	  "MozListStyleImage",
	  "WebkitListStyleImage",
	  "MSListStyleImage",
	  "OListStyleImage",
	  "listStylePosition",
	  "MozListStylePosition",
	  "WebkitListStylePosition",
	  "MSListStylePosition",
	  "OListStylePosition",
	  "listStyleType",
	  "MozListStyleType",
	  "WebkitListStyleType",
	  "MSListStyleType",
	  "OListStyleType",
	  "margin",
	  "MozMargin",
	  "WebkitMargin",
	  "MSMargin",
	  "OMargin",
	  "marginBlockEnd",
	  "MozMarginBlockEnd",
	  "WebkitMarginBlockEnd",
	  "MSMarginBlockEnd",
	  "OMarginBlockEnd",
	  "marginBlockStart",
	  "MozMarginBlockStart",
	  "WebkitMarginBlockStart",
	  "MSMarginBlockStart",
	  "OMarginBlockStart",
	  "marginBottom",
	  "MozMarginBottom",
	  "WebkitMarginBottom",
	  "MSMarginBottom",
	  "OMarginBottom",
	  "marginInlineEnd",
	  "MozMarginInlineEnd",
	  "WebkitMarginInlineEnd",
	  "MSMarginInlineEnd",
	  "OMarginInlineEnd",
	  "marginInlineStart",
	  "MozMarginInlineStart",
	  "WebkitMarginInlineStart",
	  "MSMarginInlineStart",
	  "OMarginInlineStart",
	  "marginLeft",
	  "MozMarginLeft",
	  "WebkitMarginLeft",
	  "MSMarginLeft",
	  "OMarginLeft",
	  "marginRight",
	  "MozMarginRight",
	  "WebkitMarginRight",
	  "MSMarginRight",
	  "OMarginRight",
	  "marginTop",
	  "MozMarginTop",
	  "WebkitMarginTop",
	  "MSMarginTop",
	  "OMarginTop",
	  "mask",
	  "MozMask",
	  "WebkitMask",
	  "MSMask",
	  "OMask",
	  "maskClip",
	  "MozMaskClip",
	  "WebkitMaskClip",
	  "MSMaskClip",
	  "OMaskClip",
	  "maskComposite",
	  "MozMaskComposite",
	  "WebkitMaskComposite",
	  "MSMaskComposite",
	  "OMaskComposite",
	  "maskImage",
	  "MozMaskImage",
	  "WebkitMaskImage",
	  "MSMaskImage",
	  "OMaskImage",
	  "maskMode",
	  "MozMaskMode",
	  "WebkitMaskMode",
	  "MSMaskMode",
	  "OMaskMode",
	  "maskOrigin",
	  "MozMaskOrigin",
	  "WebkitMaskOrigin",
	  "MSMaskOrigin",
	  "OMaskOrigin",
	  "maskPosition",
	  "MozMaskPosition",
	  "WebkitMaskPosition",
	  "MSMaskPosition",
	  "OMaskPosition",
	  "maskRepeat",
	  "MozMaskRepeat",
	  "WebkitMaskRepeat",
	  "MSMaskRepeat",
	  "OMaskRepeat",
	  "maskSize",
	  "MozMaskSize",
	  "WebkitMaskSize",
	  "MSMaskSize",
	  "OMaskSize",
	  "maskType",
	  "MozMaskType",
	  "WebkitMaskType",
	  "MSMaskType",
	  "OMaskType",
	  "maxHeight",
	  "MozMaxHeight",
	  "WebkitMaxHeight",
	  "MSMaxHeight",
	  "OMaxHeight",
	  "maxWidth",
	  "MozMaxWidth",
	  "WebkitMaxWidth",
	  "MSMaxWidth",
	  "OMaxWidth",
	  "minBlockSize",
	  "MozMinBlockSize",
	  "WebkitMinBlockSize",
	  "MSMinBlockSize",
	  "OMinBlockSize",
	  "minHeight",
	  "MozMinHeight",
	  "WebkitMinHeight",
	  "MSMinHeight",
	  "OMinHeight",
	  "minInlineSize",
	  "MozMinInlineSize",
	  "WebkitMinInlineSize",
	  "MSMinInlineSize",
	  "OMinInlineSize",
	  "minWidth",
	  "MozMinWidth",
	  "WebkitMinWidth",
	  "MSMinWidth",
	  "OMinWidth",
	  "mixBlendMode",
	  "MozMixBlendMode",
	  "WebkitMixBlendMode",
	  "MSMixBlendMode",
	  "OMixBlendMode",
	  "mm",
	  "MozMm",
	  "WebkitMm",
	  "MSMm",
	  "OMm",
	  "ms",
	  "MozMs",
	  "WebkitMs",
	  "MSMs",
	  "OMs",
	  "objectFit",
	  "MozObjectFit",
	  "WebkitObjectFit",
	  "MSObjectFit",
	  "OObjectFit",
	  "objectPosition",
	  "MozObjectPosition",
	  "WebkitObjectPosition",
	  "MSObjectPosition",
	  "OObjectPosition",
	  "offsetBlockEnd",
	  "MozOffsetBlockEnd",
	  "WebkitOffsetBlockEnd",
	  "MSOffsetBlockEnd",
	  "OOffsetBlockEnd",
	  "offsetBlockStart",
	  "MozOffsetBlockStart",
	  "WebkitOffsetBlockStart",
	  "MSOffsetBlockStart",
	  "OOffsetBlockStart",
	  "offsetInlineEnd",
	  "MozOffsetInlineEnd",
	  "WebkitOffsetInlineEnd",
	  "MSOffsetInlineEnd",
	  "OOffsetInlineEnd",
	  "offsetInlineStart",
	  "MozOffsetInlineStart",
	  "WebkitOffsetInlineStart",
	  "MSOffsetInlineStart",
	  "OOffsetInlineStart",
	  "opacity",
	  "MozOpacity",
	  "WebkitOpacity",
	  "MSOpacity",
	  "OOpacity",
	  "order",
	  "MozOrder",
	  "WebkitOrder",
	  "MSOrder",
	  "OOrder",
	  "orphans",
	  "MozOrphans",
	  "WebkitOrphans",
	  "MSOrphans",
	  "OOrphans",
	  "outline",
	  "MozOutline",
	  "WebkitOutline",
	  "MSOutline",
	  "OOutline",
	  "outlineColor",
	  "MozOutlineColor",
	  "WebkitOutlineColor",
	  "MSOutlineColor",
	  "OOutlineColor",
	  "outlineOffset",
	  "MozOutlineOffset",
	  "WebkitOutlineOffset",
	  "MSOutlineOffset",
	  "OOutlineOffset",
	  "outlineStyle",
	  "MozOutlineStyle",
	  "WebkitOutlineStyle",
	  "MSOutlineStyle",
	  "OOutlineStyle",
	  "outlineWidth",
	  "MozOutlineWidth",
	  "WebkitOutlineWidth",
	  "MSOutlineWidth",
	  "OOutlineWidth",
	  "overflow",
	  "MozOverflow",
	  "WebkitOverflow",
	  "MSOverflow",
	  "OOverflow",
	  "overflowWrap",
	  "MozOverflowWrap",
	  "WebkitOverflowWrap",
	  "MSOverflowWrap",
	  "OOverflowWrap",
	  "overflowX",
	  "MozOverflowX",
	  "WebkitOverflowX",
	  "MSOverflowX",
	  "OOverflowX",
	  "overflowY",
	  "MozOverflowY",
	  "WebkitOverflowY",
	  "MSOverflowY",
	  "OOverflowY",
	  "padding",
	  "MozPadding",
	  "WebkitPadding",
	  "MSPadding",
	  "OPadding",
	  "paddingBlockEnd",
	  "MozPaddingBlockEnd",
	  "WebkitPaddingBlockEnd",
	  "MSPaddingBlockEnd",
	  "OPaddingBlockEnd",
	  "paddingBlockStart",
	  "MozPaddingBlockStart",
	  "WebkitPaddingBlockStart",
	  "MSPaddingBlockStart",
	  "OPaddingBlockStart",
	  "paddingBottom",
	  "MozPaddingBottom",
	  "WebkitPaddingBottom",
	  "MSPaddingBottom",
	  "OPaddingBottom",
	  "paddingInlineEnd",
	  "MozPaddingInlineEnd",
	  "WebkitPaddingInlineEnd",
	  "MSPaddingInlineEnd",
	  "OPaddingInlineEnd",
	  "paddingInlineStart",
	  "MozPaddingInlineStart",
	  "WebkitPaddingInlineStart",
	  "MSPaddingInlineStart",
	  "OPaddingInlineStart",
	  "paddingLeft",
	  "MozPaddingLeft",
	  "WebkitPaddingLeft",
	  "MSPaddingLeft",
	  "OPaddingLeft",
	  "paddingRight",
	  "MozPaddingRight",
	  "WebkitPaddingRight",
	  "MSPaddingRight",
	  "OPaddingRight",
	  "paddingTop",
	  "MozPaddingTop",
	  "WebkitPaddingTop",
	  "MSPaddingTop",
	  "OPaddingTop",
	  "pageBreakAfter",
	  "MozPageBreakAfter",
	  "WebkitPageBreakAfter",
	  "MSPageBreakAfter",
	  "OPageBreakAfter",
	  "pageBreakBefore",
	  "MozPageBreakBefore",
	  "WebkitPageBreakBefore",
	  "MSPageBreakBefore",
	  "OPageBreakBefore",
	  "pageBreakInside",
	  "MozPageBreakInside",
	  "WebkitPageBreakInside",
	  "MSPageBreakInside",
	  "OPageBreakInside",
	  "pc",
	  "MozPc",
	  "WebkitPc",
	  "MSPc",
	  "OPc",
	  "perspective",
	  "MozPerspective",
	  "WebkitPerspective",
	  "MSPerspective",
	  "OPerspective",
	  "perspectiveOrigin",
	  "MozPerspectiveOrigin",
	  "WebkitPerspectiveOrigin",
	  "MSPerspectiveOrigin",
	  "OPerspectiveOrigin",
	  "pointerEvents",
	  "MozPointerEvents",
	  "WebkitPointerEvents",
	  "MSPointerEvents",
	  "OPointerEvents",
	  "position",
	  "MozPosition",
	  "WebkitPosition",
	  "MSPosition",
	  "OPosition",
	  "pt",
	  "MozPt",
	  "WebkitPt",
	  "MSPt",
	  "OPt",
	  "px",
	  "MozPx",
	  "WebkitPx",
	  "MSPx",
	  "OPx",
	  "q",
	  "MozQ",
	  "WebkitQ",
	  "MSQ",
	  "OQ",
	  "quotes",
	  "MozQuotes",
	  "WebkitQuotes",
	  "MSQuotes",
	  "OQuotes",
	  "rad",
	  "MozRad",
	  "WebkitRad",
	  "MSRad",
	  "ORad",
	  "rem",
	  "MozRem",
	  "WebkitRem",
	  "MSRem",
	  "ORem",
	  "resize",
	  "MozResize",
	  "WebkitResize",
	  "MSResize",
	  "OResize",
	  "revert",
	  "MozRevert",
	  "WebkitRevert",
	  "MSRevert",
	  "ORevert",
	  "right",
	  "MozRight",
	  "WebkitRight",
	  "MSRight",
	  "ORight",
	  "rubyAlign",
	  "MozRubyAlign",
	  "WebkitRubyAlign",
	  "MSRubyAlign",
	  "ORubyAlign",
	  "rubyMerge",
	  "MozRubyMerge",
	  "WebkitRubyMerge",
	  "MSRubyMerge",
	  "ORubyMerge",
	  "rubyPosition",
	  "MozRubyPosition",
	  "WebkitRubyPosition",
	  "MSRubyPosition",
	  "ORubyPosition",
	  "s",
	  "MozS",
	  "WebkitS",
	  "MSS",
	  "OS",
	  "scrollBehavior",
	  "MozScrollBehavior",
	  "WebkitScrollBehavior",
	  "MSScrollBehavior",
	  "OScrollBehavior",
	  "scrollSnapCoordinate",
	  "MozScrollSnapCoordinate",
	  "WebkitScrollSnapCoordinate",
	  "MSScrollSnapCoordinate",
	  "OScrollSnapCoordinate",
	  "scrollSnapDestination",
	  "MozScrollSnapDestination",
	  "WebkitScrollSnapDestination",
	  "MSScrollSnapDestination",
	  "OScrollSnapDestination",
	  "scrollSnapType",
	  "MozScrollSnapType",
	  "WebkitScrollSnapType",
	  "MSScrollSnapType",
	  "OScrollSnapType",
	  "shapeImageThreshold",
	  "MozShapeImageThreshold",
	  "WebkitShapeImageThreshold",
	  "MSShapeImageThreshold",
	  "OShapeImageThreshold",
	  "shapeMargin",
	  "MozShapeMargin",
	  "WebkitShapeMargin",
	  "MSShapeMargin",
	  "OShapeMargin",
	  "shapeOutside",
	  "MozShapeOutside",
	  "WebkitShapeOutside",
	  "MSShapeOutside",
	  "OShapeOutside",
	  "tabSize",
	  "MozTabSize",
	  "WebkitTabSize",
	  "MSTabSize",
	  "OTabSize",
	  "tableLayout",
	  "MozTableLayout",
	  "WebkitTableLayout",
	  "MSTableLayout",
	  "OTableLayout",
	  "textAlign",
	  "MozTextAlign",
	  "WebkitTextAlign",
	  "MSTextAlign",
	  "OTextAlign",
	  "textAlignLast",
	  "MozTextAlignLast",
	  "WebkitTextAlignLast",
	  "MSTextAlignLast",
	  "OTextAlignLast",
	  "textCombineUpright",
	  "MozTextCombineUpright",
	  "WebkitTextCombineUpright",
	  "MSTextCombineUpright",
	  "OTextCombineUpright",
	  "textDecoration",
	  "MozTextDecoration",
	  "WebkitTextDecoration",
	  "MSTextDecoration",
	  "OTextDecoration",
	  "textDecorationColor",
	  "MozTextDecorationColor",
	  "WebkitTextDecorationColor",
	  "MSTextDecorationColor",
	  "OTextDecorationColor",
	  "textDecorationLine",
	  "MozTextDecorationLine",
	  "WebkitTextDecorationLine",
	  "MSTextDecorationLine",
	  "OTextDecorationLine",
	  "textDecorationStyle",
	  "MozTextDecorationStyle",
	  "WebkitTextDecorationStyle",
	  "MSTextDecorationStyle",
	  "OTextDecorationStyle",
	  "textEmphasis",
	  "MozTextEmphasis",
	  "WebkitTextEmphasis",
	  "MSTextEmphasis",
	  "OTextEmphasis",
	  "textEmphasisColor",
	  "MozTextEmphasisColor",
	  "WebkitTextEmphasisColor",
	  "MSTextEmphasisColor",
	  "OTextEmphasisColor",
	  "textEmphasisPosition",
	  "MozTextEmphasisPosition",
	  "WebkitTextEmphasisPosition",
	  "MSTextEmphasisPosition",
	  "OTextEmphasisPosition",
	  "textEmphasisStyle",
	  "MozTextEmphasisStyle",
	  "WebkitTextEmphasisStyle",
	  "MSTextEmphasisStyle",
	  "OTextEmphasisStyle",
	  "textIndent",
	  "MozTextIndent",
	  "WebkitTextIndent",
	  "MSTextIndent",
	  "OTextIndent",
	  "textOrientation",
	  "MozTextOrientation",
	  "WebkitTextOrientation",
	  "MSTextOrientation",
	  "OTextOrientation",
	  "textOverflow",
	  "MozTextOverflow",
	  "WebkitTextOverflow",
	  "MSTextOverflow",
	  "OTextOverflow",
	  "textRendering",
	  "MozTextRendering",
	  "WebkitTextRendering",
	  "MSTextRendering",
	  "OTextRendering",
	  "textShadow",
	  "MozTextShadow",
	  "WebkitTextShadow",
	  "MSTextShadow",
	  "OTextShadow",
	  "textTransform",
	  "MozTextTransform",
	  "WebkitTextTransform",
	  "MSTextTransform",
	  "OTextTransform",
	  "textUnderlinePosition",
	  "MozTextUnderlinePosition",
	  "WebkitTextUnderlinePosition",
	  "MSTextUnderlinePosition",
	  "OTextUnderlinePosition",
	  "top",
	  "MozTop",
	  "WebkitTop",
	  "MSTop",
	  "OTop",
	  "touchAction",
	  "MozTouchAction",
	  "WebkitTouchAction",
	  "MSTouchAction",
	  "OTouchAction",
	  "transform",
	  "MozTransform",
	  "WebkitTransform",
	  "msTransform",
	  "OTransform",
	  "transformBox",
	  "MozTransformBox",
	  "WebkitTransformBox",
	  "MSTransformBox",
	  "OTransformBox",
	  "transformOrigin",
	  "MozTransformOrigin",
	  "WebkitTransformOrigin",
	  "MSTransformOrigin",
	  "OTransformOrigin",
	  "transformStyle",
	  "MozTransformStyle",
	  "WebkitTransformStyle",
	  "MSTransformStyle",
	  "OTransformStyle",
	  "transition",
	  "MozTransition",
	  "WebkitTransition",
	  "MSTransition",
	  "OTransition",
	  "transitionDelay",
	  "MozTransitionDelay",
	  "WebkitTransitionDelay",
	  "MSTransitionDelay",
	  "OTransitionDelay",
	  "transitionDuration",
	  "MozTransitionDuration",
	  "WebkitTransitionDuration",
	  "MSTransitionDuration",
	  "OTransitionDuration",
	  "transitionProperty",
	  "MozTransitionProperty",
	  "WebkitTransitionProperty",
	  "MSTransitionProperty",
	  "OTransitionProperty",
	  "transitionTimingFunction",
	  "MozTransitionTimingFunction",
	  "WebkitTransitionTimingFunction",
	  "MSTransitionTimingFunction",
	  "OTransitionTimingFunction",
	  "turn",
	  "MozTurn",
	  "WebkitTurn",
	  "MSTurn",
	  "OTurn",
	  "unicodeBidi",
	  "MozUnicodeBidi",
	  "WebkitUnicodeBidi",
	  "MSUnicodeBidi",
	  "OUnicodeBidi",
	  "unset",
	  "MozUnset",
	  "WebkitUnset",
	  "MSUnset",
	  "OUnset",
	  "verticalAlign",
	  "MozVerticalAlign",
	  "WebkitVerticalAlign",
	  "MSVerticalAlign",
	  "OVerticalAlign",
	  "vh",
	  "MozVh",
	  "WebkitVh",
	  "MSVh",
	  "OVh",
	  "visibility",
	  "MozVisibility",
	  "WebkitVisibility",
	  "MSVisibility",
	  "OVisibility",
	  "vmax",
	  "MozVmax",
	  "WebkitVmax",
	  "MSVmax",
	  "OVmax",
	  "vmin",
	  "MozVmin",
	  "WebkitVmin",
	  "MSVmin",
	  "OVmin",
	  "vw",
	  "MozVw",
	  "WebkitVw",
	  "MSVw",
	  "OVw",
	  "whiteSpace",
	  "MozWhiteSpace",
	  "WebkitWhiteSpace",
	  "MSWhiteSpace",
	  "OWhiteSpace",
	  "widows",
	  "MozWidows",
	  "WebkitWidows",
	  "MSWidows",
	  "OWidows",
	  "width",
	  "MozWidth",
	  "WebkitWidth",
	  "MSWidth",
	  "OWidth",
	  "willChange",
	  "MozWillChange",
	  "WebkitWillChange",
	  "MSWillChange",
	  "OWillChange",
	  "wordBreak",
	  "MozWordBreak",
	  "WebkitWordBreak",
	  "MSWordBreak",
	  "OWordBreak",
	  "wordSpacing",
	  "MozWordSpacing",
	  "WebkitWordSpacing",
	  "MSWordSpacing",
	  "OWordSpacing",
	  "wordWrap",
	  "MozWordWrap",
	  "WebkitWordWrap",
	  "MSWordWrap",
	  "OWordWrap",
	  "writingMode",
	  "MozWritingMode",
	  "WebkitWritingMode",
	  "MSWritingMode",
	  "OWritingMode",
	  "zIndex",
	  "MozZIndex",
	  "WebkitZIndex",
	  "MSZIndex",
	  "OZIndex",
	  "fontSize",
	  "MozFontSize",
	  "WebkitFontSize",
	  "MSFontSize",
	  "OFontSize",
	  "flex",
	  "MozFlex",
	  "WebkitFlex",
	  "MSFlex",
	  "OFlex",
	  "fr",
	  "MozFr",
	  "WebkitFr",
	  "MSFr",
	  "OFr",
	  "overflowScrolling",
	  "MozOverflowScrolling",
	  "WebkitOverflowScrolling",
	  "MSOverflowScrolling",
	  "OOverflowScrolling"
	]


/***/ }),
/* 6297 */
/***/ (function(module, exports, __webpack_require__) {

	var properties = __webpack_require__(6296);
	var PropTypes = __webpack_require__(2);
	
	module.exports = function(props, propName, componentName) {
	  var styles = props[propName];
	  if (!styles) {
	    return;
	  }
	
	  var failures = [];
	  Object.keys(styles).forEach(function(styleKey){
	    if (properties.indexOf(styleKey) === -1) {
	      failures.push(styleKey);
	    }
	  });
	  if (failures.length) {
	    throw new Error('Prop ' + propName + ' passed to ' + componentName + '. Has invalid keys ' + failures.join(', '));
	  }
	};
	
	module.exports.isRequired = function(props, propName, componentName) {
	  if (!props[propName]) {
	    throw new Error('Prop ' + propName + ' passed to ' + componentName + ' is required');
	  }
	  return module.exports(props, propName, componentName);
	};
	
	module.exports.supportingArrays = PropTypes.oneOfType([
	  PropTypes.arrayOf(module.exports),
	  module.exports
	]);


/***/ }),
/* 6298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	var _interopRequireWildcard = __webpack_require__(283);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ClockWrapper;
	
	var _core = __webpack_require__(128);
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactSpring = __webpack_require__(1640);
	
	var _ClockHand = _interopRequireDefault(__webpack_require__(6299));
	
	var _Numbers = __webpack_require__(6303);
	
	var _constants = __webpack_require__(211);
	
	var _utils = __webpack_require__(481);
	
	var _clock = _interopRequireDefault(__webpack_require__(6309));
	
	var _configContext = _interopRequireDefault(__webpack_require__(482));
	
	var _stateContext = _interopRequireDefault(__webpack_require__(483));
	
	function exitPosition(mode) {
	  return (0, _utils.isHourMode)(mode) ? _constants.INITIAL_HOUR_TRANSFORM : _constants.INITIAL_MINUTE_TRANSFORM;
	}
	
	function initialPosition(mode) {
	  return (0, _utils.isMinuteMode)(mode) ? _constants.INITIAL_HOUR_TRANSFORM : _constants.INITIAL_MINUTE_TRANSFORM;
	}
	
	function ClockWrapper(_ref) {
	  var clockEl = _ref.clockEl;
	  var firstTime = (0, _react.useRef)(true);
	
	  var _useConfig = (0, _configContext.default)(),
	      hour24Mode = _useConfig.hour24Mode;
	
	  var _useTimekeeperState = (0, _stateContext.default)(),
	      mode = _useTimekeeperState.mode,
	      time = _useTimekeeperState.time;
	
	  var transitions = (0, _reactSpring.useTransition)(mode, null, {
	    unique: true,
	    from: !firstTime.current && {
	      opacity: 0,
	      translate: initialPosition(mode),
	      translateInner: _constants.INNER_NUMBER_POSITIONING.exit
	    },
	    enter: {
	      opacity: 1,
	      translate: (0, _constants.getOuterNumberPosition)(mode),
	      translateInner: _constants.INNER_NUMBER_POSITIONING.enter
	    },
	    leave: {
	      opacity: 0,
	      translate: exitPosition(mode),
	      translateInner: _constants.INNER_NUMBER_POSITIONING.exit
	    }
	  });
	  (0, _react.useEffect)(function () {
	    // don't show intial animation on first render - ie: {from : ...}
	    firstTime.current = false;
	  }, []);
	  return (0, _core.jsx)("div", {
	    className: "react-timekeeper__clock",
	    css: _clock.default,
	    ref: clockEl
	  }, transitions.map(function (_ref2) {
	    var currentMode = _ref2.item,
	        key = _ref2.key,
	        props = _ref2.props;
	
	    // TODO - weird hot reloading issue, remove during compilation
	    if (!currentMode) {
	      return null;
	    }
	
	    return (0, _utils.isMinuteMode)(currentMode) ? (0, _core.jsx)(_Numbers.MinuteNumbers, {
	      anim: props,
	      key: key
	    }) : (0, _core.jsx)(_Numbers.HourNumbers, {
	      anim: props,
	      key: key,
	      mode: currentMode,
	      hour24Mode: hour24Mode
	    });
	  }), (0, _core.jsx)(_ClockHand.default, {
	    time: time,
	    mode: mode
	  }));
	}

/***/ }),
/* 6299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(283);
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ClockHand;
	
	var _core = __webpack_require__(128);
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1054));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactSpring = __webpack_require__(1640);
	
	var _utils = __webpack_require__(481);
	
	var _constants = __webpack_require__(211);
	
	var _constants2 = __webpack_require__(1641);
	
	var _math = __webpack_require__(1642);
	
	function rotate(r) {
	  return "rotate(".concat(r, " ").concat(_constants.CLOCK_RADIUS, " ").concat(_constants.CLOCK_RADIUS, ")");
	}
	
	function getAngle(mode, time) {
	  var increments = _constants.CLOCK_VALUES[mode].increments;
	  var value = (0, _utils.getTimeValue)(mode, time);
	  return value * (360 / increments);
	}
	
	function ClockHand(_ref) {
	  var mode = _ref.mode,
	      time = _ref.time;
	  var prevState = (0, _react.useRef)({
	    time: time,
	    mode: mode
	  });
	  var dragCount = (0, _react.useRef)(0); // clockhand positioning
	
	  var inner = time.hour > 0 && time.hour <= 12;
	  var handLength = (0, _constants.getClockHandLength)(mode, inner);
	  var circlePosition = (0, _constants.getClockHandCirclePosition)(mode, inner);
	  var circleRadius = (0, _constants.getClockHandCircleRadius)(mode, inner);
	
	  var _useSpring = (0, _reactSpring.useSpring)(function () {
	    return {
	      immediate: true,
	      rotation: getAngle(mode, time),
	      length: handLength,
	      position: circlePosition
	    };
	  }),
	      _useSpring2 = (0, _slicedToArray2.default)(_useSpring, 2),
	      anim = _useSpring2[0],
	      setAnim = _useSpring2[1];
	
	  var rotation = anim.rotation,
	      length = anim.length,
	      position = anim.position;
	  (0, _react.useEffect)(function () {
	    var current = rotation.value;
	    var next = getAngle(mode, time);
	
	    if (prevState.current.mode !== mode) {
	      dragCount.current = 0;
	      prevState.current.mode = mode; // mode changed, animate clockhand to next mode angle
	
	      var finalAngle = (0, _math.calcAnimationAngle)(current, next);
	      setAnim({
	        immediate: false,
	        rotation: finalAngle,
	        length: handLength,
	        position: circlePosition
	      });
	    } else if (!(0, _utils.isSameTime)(prevState.current.time, time)) {
	      // time changed, no animation necessary - just update clockhand
	      prevState.current.time = time;
	      dragCount.current++;
	      /*
	      TODO - consider making this a config option?
	      if on hour mode and `switchToMinuteOnHourSelect` is enabled, don't display
	      change in time, just wait for mode to change
	      */
	      // if (isHourMode(mode) && config.switchToMinuteOnHourSelect && dragCount.current < 2) {
	      // 	return
	      // }
	
	      setAnim({
	        immediate: true,
	        rotation: next,
	        length: handLength,
	        position: circlePosition
	      });
	    }
	  }, [circlePosition, handLength, mode, rotation, setAnim, time]); // mini circle on clockhand between increments on minutes
	
	  var value = (0, _utils.getTimeValue)(mode, time);
	  var showIntermediateValueDisplay;
	
	  if (mode === _constants.MODE.MINUTES && value % 5) {
	    showIntermediateValueDisplay = (0, _core.jsx)("circle", {
	      cx: _constants.CLOCK_RADIUS,
	      cy: _constants.NUMBER_OUTER_POSITION,
	      r: 4,
	      fill: _constants2.CLOCK_HAND_INTERMEDIATE_CIRCLE_BACKGROUND,
	      className: "react-timekeeper__hand-intermediate-circle"
	    });
	  }
	
	  return (0, _core.jsx)("svg", {
	    width: _constants.CLOCK_SIZE,
	    height: _constants.CLOCK_SIZE,
	    viewBox: "0 0 ".concat(_constants.CLOCK_SIZE, " ").concat(_constants.CLOCK_SIZE),
	    xmlns: "http://www.w3.org/2000/svg",
	    className: "react-timekeeper__clock-hand"
	  }, (0, _core.jsx)(_reactSpring.animated.g, {
	    transform: rotation.interpolate(function (a) {
	      return rotate(a);
	    })
	  }, (0, _core.jsx)(_reactSpring.animated.line, {
	    stroke: _constants2.CLOCK_HAND_ARM,
	    x1: _constants.CLOCK_RADIUS,
	    y1: _constants.CLOCK_RADIUS,
	    x2: _constants.CLOCK_RADIUS,
	    y2: length,
	    strokeWidth: "1",
	    className: "react-timekeeper__clock-hand"
	  }), (0, _core.jsx)("circle", {
	    cx: _constants.CLOCK_RADIUS,
	    cy: _constants.CLOCK_RADIUS,
	    r: 1.5,
	    fill: _constants2.CLOCK_HAND_ARM,
	    className: "react-timekeeper__hand-circle-center"
	  }), (0, _core.jsx)(_reactSpring.animated.circle, {
	    fill: _constants2.CLOCK_HAND_CIRCLE_BACKGROUND,
	    cx: _constants.CLOCK_RADIUS,
	    cy: position,
	    r: circleRadius,
	    className: "react-timekeeper__hand-circle-outer"
	  }), showIntermediateValueDisplay));
	}

/***/ }),
/* 6300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(283);
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ClockWrapper;
	
	var _core = __webpack_require__(128);
	
	var _extends2 = _interopRequireDefault(__webpack_require__(1052));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _configContext = _interopRequireDefault(__webpack_require__(482));
	
	var _Clock = _interopRequireDefault(__webpack_require__(6298));
	
	var _Meridiems = _interopRequireDefault(__webpack_require__(6302));
	
	var _clockWrapper = _interopRequireDefault(__webpack_require__(6308));
	
	var _clockEvents = _interopRequireDefault(__webpack_require__(6319));
	
	var _constants = __webpack_require__(211);
	
	var _utils = __webpack_require__(481);
	
	var _stateContext = _interopRequireDefault(__webpack_require__(483));
	
	function ClockWrapper() {
	  var config = (0, _configContext.default)(); // clock events
	
	  var clock = (0, _react.useRef)(null);
	
	  var _useClockEvents = (0, _clockEvents.default)(clock, calculateTimeValue),
	      bind = _useClockEvents.bind;
	
	  var _useTimekeeperState = (0, _stateContext.default)(),
	      mode = _useTimekeeperState.mode,
	      updateTime = _useTimekeeperState.updateTime,
	      setMode = _useTimekeeperState.setMode,
	      getComposedTime = _useTimekeeperState.getComposedTime;
	  /*
	  	LOGIC AROUND COARSE
	  	- on drag, if count < 2, do not force coarse
	  	- on mouseup, if count < 2 do not force coarse
	  	- handlepoint
	  		- if `wasTapped` OR `forceCoarse` config, then coarse it
	  	- coarse is just rounding number to an increment before setting unit
	  		LOGIC AROUND CAN CHANGE UNIT
	  	- on drag, CAN NOT change unit
	  	- on mouseup, can change unit
	  	- AFTER time has been set, then determine if need to change unit
	  		- based on this and user input
	  */
	
	  /*
	  	converts angle into time, also factors in any rounding to the closest increment
	  */
	
	
	  function calculateTimeValue(angle, _ref) {
	    var _ref$canAutoChangeUni = _ref.canAutoChangeUnit,
	        canAutoChangeUnit = _ref$canAutoChangeUni === void 0 ? false : _ref$canAutoChangeUni,
	        _ref$wasTapped = _ref.wasTapped,
	        wasTapped = _ref$wasTapped === void 0 ? false : _ref$wasTapped,
	        _ref$isInnerClick = _ref.isInnerClick,
	        isInnerClick = _ref$isInnerClick === void 0 ? false : _ref$isInnerClick;
	    // total number of allowable increments, 12/24 for hours, 60 for min
	    var totalIncrements = _constants.CLOCK_VALUES[mode].increments; // minimum increment used for rounding
	
	    var minIncrement = 1; // coarse minutes
	
	    if ((0, _utils.isMinuteMode)(mode) && (wasTapped || config.forceCoarseMinutes)) {
	      minIncrement = config.coarseMinutes;
	    }
	
	    var val = angle / 360 * totalIncrements;
	    var selected = Math.round(val / minIncrement) * minIncrement;
	
	    if (mode === _constants.MODE.HOURS_24 && config.hour24Mode) {
	      // fixes 12pm and midnight, both angle -> selected return 0
	      // for midnight need a final selected of 0, and for noon need 12
	      if (!isInnerClick && selected !== 0) {
	        selected += 12;
	      } else if (isInnerClick && selected === 0) {
	        selected += 12;
	      }
	    } // update time officially on timekeeper
	
	
	    updateTime(selected); // handle any unit autochanges on done click
	
	    if (canAutoChangeUnit) {
	      if (config.switchToMinuteOnHourSelect && (0, _utils.isHourMode)(mode)) {
	        setMode(_constants.MODE.MINUTES);
	      } else if (config.closeOnMinuteSelect && (0, _utils.isMinuteMode)(mode)) {
	        config.onDoneClick && config.onDoneClick(getComposedTime());
	      }
	    }
	  }
	
	  return (0, _core.jsx)("div", (0, _extends2.default)({}, bind, {
	    className: "react-timekeeper__clock-wrapper",
	    css: _clockWrapper.default
	  }), (0, _core.jsx)(_Clock.default, {
	    clockEl: clock
	  }), !config.hour24Mode && (0, _core.jsx)(_Meridiems.default, null));
	}

/***/ }),
/* 6301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DoneButton;
	
	var _core = __webpack_require__(128);
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _configContext = _interopRequireDefault(__webpack_require__(482));
	
	var _doneButton = _interopRequireDefault(__webpack_require__(6310));
	
	var _stateContext = _interopRequireDefault(__webpack_require__(483));
	
	function DoneButton() {
	  var _useConfig = (0, _configContext.default)(),
	      onDoneClick = _useConfig.onDoneClick,
	      doneButton = _useConfig.doneButton;
	
	  var _useTimekeeperState = (0, _stateContext.default)(),
	      getComposedTime = _useTimekeeperState.getComposedTime;
	
	  if (doneButton) {
	    return doneButton(getComposedTime());
	  }
	
	  if (onDoneClick) {
	    return (0, _core.jsx)("span", {
	      css: _doneButton.default,
	      onClick: function onClick(e) {
	        return onDoneClick(getComposedTime(), e);
	      },
	      className: "react-timekeeper__done-button"
	    }, "Done");
	  }
	
	  return null;
	}

/***/ }),
/* 6302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	var _interopRequireWildcard = __webpack_require__(283);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Meridiems;
	
	var _core = __webpack_require__(128);
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _meridiems = __webpack_require__(6313);
	
	var _stateContext = _interopRequireDefault(__webpack_require__(483));
	
	var _constants = __webpack_require__(211);
	
	function Meridiems() {
	  var _useTimekeeperState = (0, _stateContext.default)(),
	      time = _useTimekeeperState.time,
	      updateMeridiem = _useTimekeeperState.updateMeridiem;
	
	  var setAM = (0, _react.useCallback)(function () {
	    updateMeridiem(_constants.MERIDIEM.am);
	  }, [updateMeridiem]);
	  var setPM = (0, _react.useCallback)(function () {
	    updateMeridiem(_constants.MERIDIEM.pm);
	  }, [updateMeridiem]);
	  var isPM = time.hour >= 12;
	  return (0, _core.jsx)("div", {
	    css: _meridiems.meridiemWrapper
	  }, (0, _core.jsx)("button", {
	    type: "button",
	    css: (0, _meridiems.meridiem)({
	      isSelected: !isPM
	    }),
	    className: "react-timekeeper-button-reset react-timekeeper__meridiem-toggle",
	    onClick: setAM
	  }, "AM"), (0, _core.jsx)("button", {
	    type: "button",
	    css: (0, _meridiems.meridiem)({
	      isRight: true,
	      isSelected: isPM
	    }),
	    className: "react-timekeeper-button-reset react-timekeeper__meridiem-toggle",
	    onClick: setPM
	  }, "PM"));
	}

/***/ }),
/* 6303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(283);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MinuteNumbers = exports.HourNumbers = void 0;
	
	var _core = __webpack_require__(128);
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactSpring = __webpack_require__(1640);
	
	var _constants = __webpack_require__(211);
	
	var _math = __webpack_require__(1642);
	
	var _numbers = __webpack_require__(6314);
	
	/*
		can memoize components since `anim` object doesn't actually change
	*/
	function hours(_ref) {
	  var anim = _ref.anim,
	      mode = _ref.mode,
	      hour24Mode = _ref.hour24Mode;
	  var opacity = anim.opacity,
	      translate = anim.translate,
	      translateInner = anim.translateInner;
	  var _CLOCK_VALUES$mode = _constants.CLOCK_VALUES[mode],
	      numbersOuter = _CLOCK_VALUES$mode.numbers,
	      numbersInner = _CLOCK_VALUES$mode.numbersInner;
	  return (0, _core.jsx)(_reactSpring.animated.div, {
	    style: {
	      opacity: opacity
	    },
	    css: _numbers.numbersWrapperStyle,
	    className: "react-timekeeper__clock-hours"
	  }, numbersOuter.map(function (val, i) {
	    return (0, _core.jsx)(_reactSpring.animated.span, {
	      css: (0, _numbers.numbersStyle)({
	        hour24Mode: hour24Mode
	      }),
	      key: val,
	      style: {
	        transform: translate.interpolate(function (v) {
	          return (0, _math.transform)(i + 1, v);
	        })
	      }
	    }, val);
	  }), hour24Mode && numbersInner.map(function (val, i) {
	    return (0, _core.jsx)(_reactSpring.animated.span, {
	      css: (0, _numbers.numbersStyle)({
	        hour24Mode: hour24Mode,
	        inner: true
	      }),
	      key: val,
	      style: {
	        transform: translateInner.interpolate(function (v) {
	          return (0, _math.transform)(i + 1, v);
	        })
	      }
	    }, val);
	  }));
	}
	
	var HourNumbers = (0, _react.memo)(hours, function (prev, next) {
	  return prev.mode === next.mode && prev.hour24Mode === next.hour24Mode;
	});
	exports.HourNumbers = HourNumbers;
	
	function minutes(_ref2) {
	  var anim = _ref2.anim;
	  var opacity = anim.opacity,
	      translate = anim.translate;
	  return (0, _core.jsx)(_reactSpring.animated.div, {
	    style: {
	      opacity: opacity
	    },
	    css: _numbers.numbersWrapperStyle,
	    className: "react-timekeeper__clock-minutes"
	  }, _constants.MINUTES.map(function (val, i) {
	    return (0, _core.jsx)(_reactSpring.animated.span, {
	      css: (0, _numbers.numbersStyle)({}),
	      key: val,
	      style: {
	        transform: translate.interpolate(function (v) {
	          return (0, _math.transform)(i + 1, v);
	        })
	      }
	    }, val);
	  }));
	}
	
	var MinuteNumbers = (0, _react.memo)(minutes, function () {
	  return true;
	});
	exports.MinuteNumbers = MinuteNumbers;

/***/ }),
/* 6304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	var _interopRequireWildcard = __webpack_require__(283);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TimeDropdown;
	
	var _core = __webpack_require__(128);
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var styles = _interopRequireWildcard(__webpack_require__(6315));
	
	var _configContext = _interopRequireDefault(__webpack_require__(482));
	
	var _dom = __webpack_require__(2826);
	
	var _utils = __webpack_require__(481);
	
	var _constants = __webpack_require__(211);
	
	var _stateContext = _interopRequireDefault(__webpack_require__(483));
	
	var scrollbarWidth = null;
	
	function TimeDropdown(_ref) {
	  var close = _ref.close;
	
	  var _useConfig = (0, _configContext.default)(),
	      hour24Mode = _useConfig.hour24Mode;
	
	  var _useTimekeeperState = (0, _stateContext.default)(),
	      updateTime = _useTimekeeperState.updateTime,
	      mode = _useTimekeeperState.mode,
	      time = _useTimekeeperState.time;
	
	  var container = (0, _react.useRef)(null);
	  var selectedOption = (0, _react.useRef)(null);
	  var options = _constants.CLOCK_VALUES[mode].dropdown;
	  var selected = (0, _utils.getTimeValue)(mode, time).toString();
	
	  function disableBodyScroll() {
	    document.documentElement.style.paddingRight = scrollbarWidth + 'px';
	    document.documentElement.classList.add('react-timekeeper-noscroll');
	  }
	
	  function enableBodyScroll() {
	    document.documentElement.style.paddingRight = 0;
	    document.documentElement.classList.remove('react-timekeeper-noscroll');
	  }
	
	  var elsewhereClick = (0, _react.useCallback)(function (e) {
	    if (!container.current || !e.target) {
	      return;
	    }
	
	    if (!container.current.contains(e.target)) {
	      close();
	    }
	  }, [close]);
	  (0, _react.useEffect)(function () {
	    // measure scroll bar width for first time
	    if (scrollbarWidth == null) {
	      scrollbarWidth = (0, _dom.getScrollBarWidth)();
	    } // initial scroll in list
	
	
	    if (selectedOption.current && container.current) {
	      container.current.scrollTop = selectedOption.current.offsetTop;
	    } // listener to close if click outside dropdown
	
	
	    document.addEventListener('click', elsewhereClick, false);
	    return function () {
	      document.removeEventListener('click', elsewhereClick, false);
	      enableBodyScroll();
	    };
	  }, [elsewhereClick]); // select a value
	
	  function select(val) {
	    var parsed = parseInt(val, 10);
	
	    if (mode === _constants.MODE.HOURS_12 && parsed === 12) {
	      parsed = 0;
	    }
	
	    updateTime(parsed);
	    close();
	  }
	
	  return (0, _core.jsx)("div", {
	    css: styles.wrapper(hour24Mode, mode),
	    ref: container,
	    onMouseEnter: disableBodyScroll,
	    onMouseLeave: enableBodyScroll,
	    className: "react-timekeeper__time-dropdown"
	  }, (0, _core.jsx)("ul", {
	    css: styles.options,
	    className: "react-timekeeper__dropdown-numbers"
	  }, options.map(function (o) {
	    return (0, _core.jsx)("li", {
	      ref: function ref(el) {
	        return selected === o ? selectedOption.current = el : '';
	      },
	      css: styles.option(selected === o),
	      key: o,
	      onClick: function onClick() {
	        return select(o);
	      }
	    }, o);
	  })));
	}

/***/ }),
/* 6305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TimeKeeper;
	
	var _core = __webpack_require__(128);
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _global = _interopRequireDefault(__webpack_require__(6311));
	
	var _main = _interopRequireDefault(__webpack_require__(6312));
	
	var _TopBar = _interopRequireDefault(__webpack_require__(6307));
	
	var _ClockWrapper = _interopRequireDefault(__webpack_require__(6300));
	
	var _DoneButton = _interopRequireDefault(__webpack_require__(6301));
	
	function TimeKeeper() {
	  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_core.Global, {
	    styles:
	    /*#__PURE__*/
	    (0, _core.css)(_global.default,  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL1RpbWVLZWVwZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVltQiIsImZpbGUiOiIuLi8uLi9zcmMvY29tcG9uZW50cy9UaW1lS2VlcGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCB7IEdsb2JhbCwgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5pbXBvcnQgZ2xvYmFsU3R5bGUgZnJvbSAnLi9zdHlsZXMvZ2xvYmFsJ1xuaW1wb3J0IHN0eWxlIGZyb20gJy4vc3R5bGVzL21haW4nXG5pbXBvcnQgVG9wQmFyIGZyb20gJy4vVG9wQmFyJ1xuaW1wb3J0IENsb2NrV3JhcHBlciBmcm9tICcuL0Nsb2NrV3JhcHBlcidcbmltcG9ydCBEb25lQnV0dG9uIGZyb20gJy4vRG9uZUJ1dHRvbidcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gVGltZUtlZXBlcigpIHtcblx0cmV0dXJuIChcblx0XHQ8PlxuXHRcdFx0PEdsb2JhbCBzdHlsZXM9e2NzcyhnbG9iYWxTdHlsZSl9IC8+XG5cblx0XHRcdDxkaXYgY2xhc3NOYW1lPVwicmVhY3QtdGltZWtlZXBlclwiIGNzcz17c3R5bGV9PlxuXHRcdFx0XHQ8VG9wQmFyIC8+XG5cdFx0XHRcdDxDbG9ja1dyYXBwZXIgLz5cblx0XHRcdFx0PERvbmVCdXR0b24gLz5cblx0XHRcdDwvZGl2PlxuXHRcdDwvPlxuXHQpXG59XG4iXX0= */")
	  }), (0, _core.jsx)("div", {
	    className: "react-timekeeper",
	    css: _main.default
	  }, (0, _core.jsx)(_TopBar.default, null), (0, _core.jsx)(_ClockWrapper.default, null), (0, _core.jsx)(_DoneButton.default, null)));
	}

/***/ }),
/* 6306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TimepickerWithConfig;
	
	var _core = __webpack_require__(128);
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _TimeKeeper = _interopRequireDefault(__webpack_require__(6305));
	
	var _configContext = __webpack_require__(482);
	
	var _stateContext = __webpack_require__(483);
	
	function TimepickerWithConfig(_ref) {
	  var time = _ref.time,
	      onChange = _ref.onChange,
	      coarseMinutes = _ref.coarseMinutes,
	      forceCoarseMinutes = _ref.forceCoarseMinutes,
	      switchToMinuteOnHourSelect = _ref.switchToMinuteOnHourSelect,
	      closeOnMinuteSelect = _ref.closeOnMinuteSelect,
	      hour24Mode = _ref.hour24Mode,
	      onDoneClick = _ref.onDoneClick,
	      doneButton = _ref.doneButton;
	  return (0, _core.jsx)(_configContext.ConfigProvider, {
	    coarseMinutes: coarseMinutes,
	    forceCoarseMinutes: forceCoarseMinutes,
	    switchToMinuteOnHourSelect: switchToMinuteOnHourSelect,
	    closeOnMinuteSelect: closeOnMinuteSelect,
	    hour24Mode: hour24Mode,
	    onDoneClick: onDoneClick,
	    doneButton: doneButton
	  }, (0, _core.jsx)(_stateContext.StateProvider, {
	    onChange: onChange,
	    time: time
	  }, (0, _core.jsx)(_TimeKeeper.default, null)));
	}

/***/ }),
/* 6307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(283);
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = TopBar;
	
	var _core = __webpack_require__(128);
	
	var _css2 = _interopRequireDefault(__webpack_require__(486));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(1054));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _TimeDropdown = _interopRequireDefault(__webpack_require__(6304));
	
	var _stateContext = _interopRequireDefault(__webpack_require__(483));
	
	var _configContext = _interopRequireDefault(__webpack_require__(482));
	
	var styles = _interopRequireWildcard(__webpack_require__(6316));
	
	var _constants = __webpack_require__(211);
	
	var _utils = __webpack_require__(481);
	
	function TopBar() {
	  var _useConfig = (0, _configContext.default)(),
	      hour24Mode = _useConfig.hour24Mode;
	
	  var _useTimekeeperState = (0, _stateContext.default)(),
	      mode = _useTimekeeperState.mode,
	      time = _useTimekeeperState.time,
	      updateMeridiem = _useTimekeeperState.updateMeridiem,
	      setMode = _useTimekeeperState.setMode;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1]; // time clicks
	
	
	  function timeClick(type) {
	    var current = mode === _constants.MODE.MINUTES ? 'minute' : 'hour';
	
	    if (type === current) {
	      setOpen(current);
	    } else {
	      var m = mode === _constants.MODE.MINUTES ? _constants.MODE.HOURS_24 : _constants.MODE.MINUTES;
	      setMode(m);
	    }
	  } // double ternary nastiness
	
	
	  var hour = hour24Mode ? time.hour : time.hour % 12 === 0 ? 12 : time.hour % 12; // meridiem
	
	  var meridiem = time.hour >= 12 ? _constants.MERIDIEM.pm : _constants.MERIDIEM.am;
	
	  function toggleMeridiem() {
	    var m = meridiem === _constants.MERIDIEM.am ? _constants.MERIDIEM.pm : _constants.MERIDIEM.am;
	    updateMeridiem(m);
	  }
	
	  var isHour = (0, _utils.isHourMode)(mode);
	  var formattedMinute = ('0' + time.minute).slice(-2);
	
	  var closeDropdown = function closeDropdown() {
	    return setOpen(null);
	  };
	
	  return (0, _core.jsx)("div", {
	    css: styles.wrapper(hour24Mode),
	    className: "react-timekeeper__top-bar"
	  }, (0, _core.jsx)("div", {
	    css: styles.hourWrapper(hour24Mode),
	    className: "react-timekeeper__tb-minute-wrapper"
	  }, (0, _core.jsx)("span", {
	    css:
	    /*#__PURE__*/
	    (0, _css2.default)([styles.time(isHour)],  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
	    onClick: function onClick() {
	      return timeClick('hour');
	    },
	    "data-type": "hour",
	    className: "react-timekeeper__tb-hour"
	  }, hour), open === 'hour' && (0, _core.jsx)(_TimeDropdown.default, {
	    close: closeDropdown
	  })), (0, _core.jsx)("span", {
	    css: styles.colon,
	    className: "react-timekeeper__tb-colon"
	  }, ":"), (0, _core.jsx)("div", {
	    css: styles.minuteWrapper(hour24Mode),
	    className: "react-timekeeper__tb-hour-wrapper"
	  }, (0, _core.jsx)("span", {
	    css: styles.time(!isHour),
	    onClick: function onClick() {
	      return timeClick('minute');
	    },
	    "data-type": "minute",
	    className: "react-timekeeper__tb-minute"
	  }, formattedMinute), open === 'minute' && (0, _core.jsx)(_TimeDropdown.default, {
	    close: closeDropdown
	  })), !hour24Mode && (0, _core.jsx)("button", {
	    name: "meridiem",
	    type: "button",
	    onClick: toggleMeridiem,
	    css: styles.meridiem,
	    className: "react-timekeeper-button-reset react-timekeeper__tb-meridiem"
	  }, meridiem));
	}

/***/ }),
/* 6308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _core = __webpack_require__(128);
	
	var _constants = __webpack_require__(1641);
	
	var style =
	/*#__PURE__*/
	(0, _core.css)("text-align:center;padding:18px 0 14px;background:", _constants.CLOCK_WRAPPER_BACKGROUND, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9jbG9jay13cmFwcGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdpQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zdHlsZXMvY2xvY2std3JhcHBlci50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IENMT0NLX1dSQVBQRVJfQkFDS0dST1VORCB9IGZyb20gJy4vY29uc3RhbnRzJ1xuXG5jb25zdCBzdHlsZSA9IGNzc2Bcblx0dGV4dC1hbGlnbjogY2VudGVyO1xuXHRwYWRkaW5nOiAxOHB4IDAgMTRweDtcblx0YmFja2dyb3VuZDogJHtDTE9DS19XUkFQUEVSX0JBQ0tHUk9VTkR9O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBzdHlsZVxuIl19 */"));
	var _default = style;
	exports.default = _default;

/***/ }),
/* 6309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _core = __webpack_require__(128);
	
	var _constants = __webpack_require__(211);
	
	var styles =
	/*#__PURE__*/
	(0, _core.css)("display:inline-block;border-radius:200px;background:white;width:", _constants.CLOCK_SIZE, "px;height:", _constants.CLOCK_SIZE, "px;position:relative;cursor:pointer;touch-action:none;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9jbG9jay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHa0IiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc3R5bGVzL2Nsb2NrLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgQ0xPQ0tfU0laRSB9IGZyb20gJy4uLy4uL2hlbHBlcnMvY29uc3RhbnRzJ1xuXG5jb25zdCBzdHlsZXMgPSBjc3NgXG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0Ym9yZGVyLXJhZGl1czogMjAwcHg7XG5cdGJhY2tncm91bmQ6IHdoaXRlO1xuXHR3aWR0aDogJHtDTE9DS19TSVpFfXB4O1xuXHRoZWlnaHQ6ICR7Q0xPQ0tfU0laRX1weDtcblx0cG9zaXRpb246IHJlbGF0aXZlO1xuXHRjdXJzb3I6IHBvaW50ZXI7XG5cdHRvdWNoLWFjdGlvbjogbm9uZTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgc3R5bGVzXG4iXX0= */"));
	var _default = styles;
	exports.default = _default;

/***/ }),
/* 6310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.DONE_BUTTON_BORDER_COLOR = exports.DONE_BUTTON_COLOR = void 0;
	
	var _core = __webpack_require__(128);
	
	var _constants = __webpack_require__(1641);
	
	var DONE_BUTTON_COLOR = '#686868';
	exports.DONE_BUTTON_COLOR = DONE_BUTTON_COLOR;
	var DONE_BUTTON_BORDER_COLOR = '#CCC';
	exports.DONE_BUTTON_BORDER_COLOR = DONE_BUTTON_BORDER_COLOR;
	var doneButton =
	/*#__PURE__*/
	(0, _core.css)("background:", _constants.CLOCK_WRAPPER_BACKGROUND, ";display:block;color:", DONE_BUTTON_COLOR, ";text-transform:uppercase;border-top:1px solid ", DONE_BUTTON_BORDER_COLOR, ";text-align:center;cursor:pointer;padding:16px 0;font-size:13px;letter-spacing:0.5px;line-height:normal;font-weight:500;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9kb25lLWJ1dHRvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNc0IiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc3R5bGVzL2RvbmUtYnV0dG9uLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgQ0xPQ0tfV1JBUFBFUl9CQUNLR1JPVU5EIH0gZnJvbSAnLi9jb25zdGFudHMnXG5cbmV4cG9ydCBjb25zdCBET05FX0JVVFRPTl9DT0xPUiA9ICcjNjg2ODY4J1xuZXhwb3J0IGNvbnN0IERPTkVfQlVUVE9OX0JPUkRFUl9DT0xPUiA9ICcjQ0NDJ1xuXG5jb25zdCBkb25lQnV0dG9uID0gY3NzYFxuXHRiYWNrZ3JvdW5kOiAke0NMT0NLX1dSQVBQRVJfQkFDS0dST1VORH07XG5cdGRpc3BsYXk6IGJsb2NrO1xuXHRjb2xvcjogJHtET05FX0JVVFRPTl9DT0xPUn07XG5cdHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XG5cdGJvcmRlci10b3A6IDFweCBzb2xpZCAke0RPTkVfQlVUVE9OX0JPUkRFUl9DT0xPUn07XG5cdHRleHQtYWxpZ246IGNlbnRlcjtcblx0Y3Vyc29yOiBwb2ludGVyO1xuXHRwYWRkaW5nOiAxNnB4IDA7XG5cdGZvbnQtc2l6ZTogMTNweDtcblx0bGV0dGVyLXNwYWNpbmc6IDAuNXB4O1xuXHRsaW5lLWhlaWdodDogbm9ybWFsO1xuXHRmb250LXdlaWdodDogNTAwO1xuYFxuXG5leHBvcnQgZGVmYXVsdCBkb25lQnV0dG9uXG4iXX0= */"));
	var _default = doneButton;
	exports.default = _default;

/***/ }),
/* 6311 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// TODO - see what's actually used
	var style = "\n\t.react-timekeeper-button-reset {\n\t\tbackground: 0;\n\t\tborder: 0;\n\t\tbox-shadow: none;\n\t\ttext-shadow: none;\n\t\t-webkit-appearance: none;\n\t\t-moz-appearance: none;\n\t\tcursor: pointer;\n\t}\n\t.react-timekeeper-button-reset:hover, .react-timekeeper-button-reset:focus, .react-timekeeper-button-reset:active {\n\t\toutline: none;\n\t}\n\t.react-timekeeper-button-reset::-moz-focus-inner {\n\t\tborder: 0;\n\t\tpadding: 0;\n\t}\n\t.react-timekeeper-noscroll {\n\t\toverflow: hidden;\n\t}\n\t.react-timekeeper-scrollbar-measure {\n\t\twidth: 100px;\n\t\theight: 100px;\n\t\toverflow: scroll;\n\t\tposition: absolute;\n\t\ttop: -9999px;\n\t}\n";
	var _default = style;
	exports.default = _default;

/***/ }),
/* 6312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _core = __webpack_require__(128);
	
	var timepicker =  true ? {
	  name: "1ah46xy",
	  styles: "-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-family:'Roboto',sans-serif;background:white;border-radius:3px;display:inline-block;box-shadow:0 3px 11px rgba(0,0,0,0.1),0 3px 6px rgba(0,0,0,0.15);width:260px;position:relative;user-select:none;"
	} : {
	  name: "1ah46xy",
	  styles: "-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;font-smoothing:antialiased;font-family:'Roboto',sans-serif;background:white;border-radius:3px;display:inline-block;box-shadow:0 3px 11px rgba(0,0,0,0.1),0 3px 6px rgba(0,0,0,0.15);width:260px;position:relative;user-select:none;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9tYWluLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVzQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zdHlsZXMvbWFpbi50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcblxuY29uc3QgdGltZXBpY2tlciA9IGNzc2Bcblx0LXdlYmtpdC10YXAtaGlnaGxpZ2h0LWNvbG9yOiB0cmFuc3BhcmVudDtcblx0LXdlYmtpdC1mb250LXNtb290aGluZzogYW50aWFsaWFzZWQ7XG5cdGZvbnQtc21vb3RoaW5nOiBhbnRpYWxpYXNlZDtcblxuXHRmb250LWZhbWlseTogJ1JvYm90bycsIHNhbnMtc2VyaWY7XG5cdGJhY2tncm91bmQ6IHdoaXRlO1xuXHRib3JkZXItcmFkaXVzOiAzcHg7XG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0Ym94LXNoYWRvdzogMCAzcHggMTFweCByZ2JhKDAsIDAsIDAsIDAuMSksIDAgM3B4IDZweCByZ2JhKDAsIDAsIDAsIDAuMTUpO1xuXHR3aWR0aDogMjYwcHg7XG5cdHBvc2l0aW9uOiByZWxhdGl2ZTtcblx0dXNlci1zZWxlY3Q6IG5vbmU7XG5gXG5cbmV4cG9ydCBkZWZhdWx0IHRpbWVwaWNrZXJcbiJdfQ== */"
	};
	var _default = timepicker;
	exports.default = _default;

/***/ }),
/* 6313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.meridiem = exports.meridiemWrapper = void 0;
	
	var _core = __webpack_require__(128);
	
	var CLOCK_WRAPPER_MERIDIEM_COLOR = '#898989';
	var CLOCK_WRAPPER_MERIDIEM_BACKGROUND_COLOR_SELECTED = '#E1EFF6';
	var CLOCK_WRAPPER_MERIDIEM_TEXT_COLOR_SELECTED = '#898989';
	var MERIDIEM_SELECT_SIZE = 38;
	var meridiemWrapper =  true ? {
	  name: "5kupwr",
	  styles: "text-align:left;padding:0 30px;margin-top:-16px;position:relative;z-index:10;"
	} : {
	  name: "5kupwr",
	  styles: "text-align:left;padding:0 30px;margin-top:-16px;position:relative;z-index:10;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9tZXJpZGllbXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUWtDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9tZXJpZGllbXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5cbmNvbnN0IENMT0NLX1dSQVBQRVJfTUVSSURJRU1fQ09MT1IgPSAnIzg5ODk4OSdcbmNvbnN0IENMT0NLX1dSQVBQRVJfTUVSSURJRU1fQkFDS0dST1VORF9DT0xPUl9TRUxFQ1RFRCA9ICcjRTFFRkY2J1xuY29uc3QgQ0xPQ0tfV1JBUFBFUl9NRVJJRElFTV9URVhUX0NPTE9SX1NFTEVDVEVEID0gJyM4OTg5ODknXG5cbmNvbnN0IE1FUklESUVNX1NFTEVDVF9TSVpFID0gMzhcblxuZXhwb3J0IGNvbnN0IG1lcmlkaWVtV3JhcHBlciA9IGNzc2Bcblx0dGV4dC1hbGlnbjogbGVmdDtcblx0cGFkZGluZzogMCAzMHB4O1xuXHRtYXJnaW4tdG9wOiAtMTZweDtcblx0cG9zaXRpb246IHJlbGF0aXZlO1xuXHR6LWluZGV4OiAxMDtcbmBcblxuaW50ZXJmYWNlIFByb3BzIHtcblx0aXNSaWdodD86IGJvb2xlYW5cblx0aXNTZWxlY3RlZDogYm9vbGVhblxufVxuXG5jb25zdCByaWdodCA9IGBcblx0ZmxvYXQ6IHJpZ2h0O1xuYFxuXG5jb25zdCBzZWxlY3RlZCA9IGBcblx0YmFja2dyb3VuZDogJHtDTE9DS19XUkFQUEVSX01FUklESUVNX0JBQ0tHUk9VTkRfQ09MT1JfU0VMRUNURUR9O1xuXHRjb2xvcjogJHtDTE9DS19XUkFQUEVSX01FUklESUVNX1RFWFRfQ09MT1JfU0VMRUNURUR9O1xuYFxuXG5leHBvcnQgY29uc3QgbWVyaWRpZW0gPSAoeyBpc1JpZ2h0LCBpc1NlbGVjdGVkIH06IFByb3BzKSA9PiBjc3NgXG5cdGJhY2tncm91bmQ6IHdoaXRlO1xuXHRmb250LXNpemU6IDE0cHg7XG5cdGNvbG9yOiAke0NMT0NLX1dSQVBQRVJfTUVSSURJRU1fQ09MT1J9O1xuXHRkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG5cdHBhZGRpbmc6IDA7XG5cdGN1cnNvcjogcG9pbnRlcjtcblx0Ym9yZGVyLXJhZGl1czogOTlweDtcblx0d2lkdGg6ICR7TUVSSURJRU1fU0VMRUNUX1NJWkV9cHg7XG5cdGhlaWdodDogJHtNRVJJRElFTV9TRUxFQ1RfU0laRX1weDtcblx0dGV4dC1hbGlnbjogY2VudGVyO1xuXHRsaW5lLWhlaWdodDogJHtNRVJJRElFTV9TRUxFQ1RfU0laRX1weDtcblx0dHJhbnNpdGlvbjogMC4xNXMgZWFzZS1vdXQ7XG5cblx0Ly8gY29uZGl0aW9uYWxzXG5cdCR7aXNSaWdodCAmJiByaWdodH1cblx0JHtpc1NlbGVjdGVkICYmIHNlbGVjdGVkfVxuYFxuIl19 */"
	};
	exports.meridiemWrapper = meridiemWrapper;
	var right = "\n\tfloat: right;\n";
	var selected = "\n\tbackground: ".concat(CLOCK_WRAPPER_MERIDIEM_BACKGROUND_COLOR_SELECTED, ";\n\tcolor: ").concat(CLOCK_WRAPPER_MERIDIEM_TEXT_COLOR_SELECTED, ";\n");
	
	var meridiem = function meridiem(_ref) {
	  var isRight = _ref.isRight,
	      isSelected = _ref.isSelected;
	  return (
	    /*#__PURE__*/
	    (0, _core.css)("background:white;font-size:14px;color:", CLOCK_WRAPPER_MERIDIEM_COLOR, ";display:inline-block;padding:0;cursor:pointer;border-radius:99px;width:", MERIDIEM_SELECT_SIZE, "px;height:", MERIDIEM_SELECT_SIZE, "px;text-align:center;line-height:", MERIDIEM_SELECT_SIZE, "px;transition:0.15s ease-out;", isRight && right, " ", isSelected && selected,  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9tZXJpZGllbXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEIrRCIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zdHlsZXMvbWVyaWRpZW1zLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5jb25zdCBDTE9DS19XUkFQUEVSX01FUklESUVNX0NPTE9SID0gJyM4OTg5ODknXG5jb25zdCBDTE9DS19XUkFQUEVSX01FUklESUVNX0JBQ0tHUk9VTkRfQ09MT1JfU0VMRUNURUQgPSAnI0UxRUZGNidcbmNvbnN0IENMT0NLX1dSQVBQRVJfTUVSSURJRU1fVEVYVF9DT0xPUl9TRUxFQ1RFRCA9ICcjODk4OTg5J1xuXG5jb25zdCBNRVJJRElFTV9TRUxFQ1RfU0laRSA9IDM4XG5cbmV4cG9ydCBjb25zdCBtZXJpZGllbVdyYXBwZXIgPSBjc3NgXG5cdHRleHQtYWxpZ246IGxlZnQ7XG5cdHBhZGRpbmc6IDAgMzBweDtcblx0bWFyZ2luLXRvcDogLTE2cHg7XG5cdHBvc2l0aW9uOiByZWxhdGl2ZTtcblx0ei1pbmRleDogMTA7XG5gXG5cbmludGVyZmFjZSBQcm9wcyB7XG5cdGlzUmlnaHQ/OiBib29sZWFuXG5cdGlzU2VsZWN0ZWQ6IGJvb2xlYW5cbn1cblxuY29uc3QgcmlnaHQgPSBgXG5cdGZsb2F0OiByaWdodDtcbmBcblxuY29uc3Qgc2VsZWN0ZWQgPSBgXG5cdGJhY2tncm91bmQ6ICR7Q0xPQ0tfV1JBUFBFUl9NRVJJRElFTV9CQUNLR1JPVU5EX0NPTE9SX1NFTEVDVEVEfTtcblx0Y29sb3I6ICR7Q0xPQ0tfV1JBUFBFUl9NRVJJRElFTV9URVhUX0NPTE9SX1NFTEVDVEVEfTtcbmBcblxuZXhwb3J0IGNvbnN0IG1lcmlkaWVtID0gKHsgaXNSaWdodCwgaXNTZWxlY3RlZCB9OiBQcm9wcykgPT4gY3NzYFxuXHRiYWNrZ3JvdW5kOiB3aGl0ZTtcblx0Zm9udC1zaXplOiAxNHB4O1xuXHRjb2xvcjogJHtDTE9DS19XUkFQUEVSX01FUklESUVNX0NPTE9SfTtcblx0ZGlzcGxheTogaW5saW5lLWJsb2NrO1xuXHRwYWRkaW5nOiAwO1xuXHRjdXJzb3I6IHBvaW50ZXI7XG5cdGJvcmRlci1yYWRpdXM6IDk5cHg7XG5cdHdpZHRoOiAke01FUklESUVNX1NFTEVDVF9TSVpFfXB4O1xuXHRoZWlnaHQ6ICR7TUVSSURJRU1fU0VMRUNUX1NJWkV9cHg7XG5cdHRleHQtYWxpZ246IGNlbnRlcjtcblx0bGluZS1oZWlnaHQ6ICR7TUVSSURJRU1fU0VMRUNUX1NJWkV9cHg7XG5cdHRyYW5zaXRpb246IDAuMTVzIGVhc2Utb3V0O1xuXG5cdC8vIGNvbmRpdGlvbmFsc1xuXHQke2lzUmlnaHQgJiYgcmlnaHR9XG5cdCR7aXNTZWxlY3RlZCAmJiBzZWxlY3RlZH1cbmBcbiJdfQ== */")
	  );
	};
	
	exports.meridiem = meridiem;

/***/ }),
/* 6314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.numbersWrapperStyle = exports.numbersStyle = void 0;
	
	var _core = __webpack_require__(128);
	
	var _constants = __webpack_require__(211);
	
	var CLOCK_NUMBER_COLOR = '#999999';
	
	var numbersStyle = function numbersStyle(_ref) {
	  var _ref$hour24Mode = _ref.hour24Mode,
	      hour24Mode = _ref$hour24Mode === void 0 ? false : _ref$hour24Mode,
	      _ref$inner = _ref.inner,
	      inner = _ref$inner === void 0 ? false : _ref$inner;
	  return (
	    /*#__PURE__*/
	    (0, _core.css)("display:inline-block;position:absolute;color:", CLOCK_NUMBER_COLOR, ";pointer-events:none;border-radius:99px;width:", _constants.NUMBER_RADIUS_REGULAR, "px;height:", _constants.NUMBER_RADIUS_REGULAR, "px;text-align:center;line-height:", _constants.NUMBER_RADIUS_REGULAR, "px;z-index:5;font-size:", (0, _constants.getFontSize)(hour24Mode, inner), "px;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9udW1iZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVpRiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zdHlsZXMvbnVtYmVycy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IE5VTUJFUl9SQURJVVNfUkVHVUxBUiwgZ2V0Rm9udFNpemUgfSBmcm9tICcuLi8uLi9oZWxwZXJzL2NvbnN0YW50cydcblxuY29uc3QgQ0xPQ0tfTlVNQkVSX0NPTE9SID0gJyM5OTk5OTknXG5cbmludGVyZmFjZSBQcm9wcyB7XG5cdGhvdXIyNE1vZGU/OiBib29sZWFuXG5cdGlubmVyPzogYm9vbGVhblxufVxuXG5leHBvcnQgY29uc3QgbnVtYmVyc1N0eWxlID0gKHsgaG91cjI0TW9kZSA9IGZhbHNlLCBpbm5lciA9IGZhbHNlIH06IFByb3BzKSA9PiBjc3NgXG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0cG9zaXRpb246IGFic29sdXRlO1xuXHRjb2xvcjogJHtDTE9DS19OVU1CRVJfQ09MT1J9O1xuXHRwb2ludGVyLWV2ZW50czogbm9uZTtcblx0Ym9yZGVyLXJhZGl1czogOTlweDtcblx0d2lkdGg6ICR7TlVNQkVSX1JBRElVU19SRUdVTEFSfXB4O1xuXHRoZWlnaHQ6ICR7TlVNQkVSX1JBRElVU19SRUdVTEFSfXB4O1xuXHR0ZXh0LWFsaWduOiBjZW50ZXI7XG5cdGxpbmUtaGVpZ2h0OiAke05VTUJFUl9SQURJVVNfUkVHVUxBUn1weDtcblx0ei1pbmRleDogNTtcblx0Zm9udC1zaXplOiAke2dldEZvbnRTaXplKGhvdXIyNE1vZGUsIGlubmVyKX1weDtcbmBcblxuLy8gei1pbmRleCByZXF1aXJlZCB0byBiZSBvbiB0b3Agb2YgY2xvY2toYW5kXG5leHBvcnQgY29uc3QgbnVtYmVyc1dyYXBwZXJTdHlsZSA9IGNzc2Bcblx0cG9zaXRpb246IGFic29sdXRlO1xuXHRsZWZ0OiAwO1xuXHR0b3A6IDA7XG5cdHotaW5kZXg6IDI7XG5gXG4iXX0= */"))
	  );
	}; // z-index required to be on top of clockhand
	
	
	exports.numbersStyle = numbersStyle;
	var numbersWrapperStyle =  true ? {
	  name: "av1tj5",
	  styles: "position:absolute;left:0;top:0;z-index:2;"
	} : {
	  name: "av1tj5",
	  styles: "position:absolute;left:0;top:0;z-index:2;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy9udW1iZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCc0MiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc3R5bGVzL251bWJlcnMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBOVU1CRVJfUkFESVVTX1JFR1VMQVIsIGdldEZvbnRTaXplIH0gZnJvbSAnLi4vLi4vaGVscGVycy9jb25zdGFudHMnXG5cbmNvbnN0IENMT0NLX05VTUJFUl9DT0xPUiA9ICcjOTk5OTk5J1xuXG5pbnRlcmZhY2UgUHJvcHMge1xuXHRob3VyMjRNb2RlPzogYm9vbGVhblxuXHRpbm5lcj86IGJvb2xlYW5cbn1cblxuZXhwb3J0IGNvbnN0IG51bWJlcnNTdHlsZSA9ICh7IGhvdXIyNE1vZGUgPSBmYWxzZSwgaW5uZXIgPSBmYWxzZSB9OiBQcm9wcykgPT4gY3NzYFxuXHRkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG5cdHBvc2l0aW9uOiBhYnNvbHV0ZTtcblx0Y29sb3I6ICR7Q0xPQ0tfTlVNQkVSX0NPTE9SfTtcblx0cG9pbnRlci1ldmVudHM6IG5vbmU7XG5cdGJvcmRlci1yYWRpdXM6IDk5cHg7XG5cdHdpZHRoOiAke05VTUJFUl9SQURJVVNfUkVHVUxBUn1weDtcblx0aGVpZ2h0OiAke05VTUJFUl9SQURJVVNfUkVHVUxBUn1weDtcblx0dGV4dC1hbGlnbjogY2VudGVyO1xuXHRsaW5lLWhlaWdodDogJHtOVU1CRVJfUkFESVVTX1JFR1VMQVJ9cHg7XG5cdHotaW5kZXg6IDU7XG5cdGZvbnQtc2l6ZTogJHtnZXRGb250U2l6ZShob3VyMjRNb2RlLCBpbm5lcil9cHg7XG5gXG5cbi8vIHotaW5kZXggcmVxdWlyZWQgdG8gYmUgb24gdG9wIG9mIGNsb2NraGFuZFxuZXhwb3J0IGNvbnN0IG51bWJlcnNXcmFwcGVyU3R5bGUgPSBjc3NgXG5cdHBvc2l0aW9uOiBhYnNvbHV0ZTtcblx0bGVmdDogMDtcblx0dG9wOiAwO1xuXHR6LWluZGV4OiAyO1xuYFxuIl19 */"
	};
	exports.numbersWrapperStyle = numbersWrapperStyle;

/***/ }),
/* 6315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.option = exports.options = exports.wrapper = void 0;
	
	var _taggedTemplateLiteral2 = _interopRequireDefault(__webpack_require__(1662));
	
	var _core = __webpack_require__(128);
	
	var _utils = __webpack_require__(481);
	
	function _templateObject() {
	  var data = (0, _taggedTemplateLiteral2.default)(["\n\t0% { opacity: 0; }\n\t100% { opacity: 1; }\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	var DROPDOWN_BORDER = '#f4f4f4';
	var DROPDOWN_COLOR = '#8c8c8c';
	var DROPDOWN_SELECTED_COLOR = '#EAF8FF';
	var hour = "right: -22px;";
	var minute = "right: -10px;";
	var hour24 = "\n\tleft: 50%;\n\ttransform: translateX(-50%);\n";
	var fadeIn = (0, _core.keyframes)(_templateObject());
	
	var wrapper = function wrapper(hour24Mode, mode) {
	  return (
	    /*#__PURE__*/
	    (0, _core.css)("position:absolute;display:inline-block;background:white;border:1px solid ", DROPDOWN_BORDER, ";border-radius:2px;padding:6px 0;z-index:20;top:62px;height:250px;overflow-y:auto;box-shadow:0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);opacity:0;animation:", fadeIn, " 0.2s ease-out both;", hour24Mode ? hour24 : (0, _utils.isMinuteMode)(mode) ? minute : hour,  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
	  );
	};
	
	exports.wrapper = wrapper;
	var options =  true ? {
	  name: "12v02gb",
	  styles: "position:relative;list-style:none;padding:0;margin:0;"
	} : {
	  name: "12v02gb",
	  styles: "position:relative;list-style:none;padding:0;margin:0;",
	  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy90aW1lLWRyb3Bkb3duLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNDMEIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc3R5bGVzL3RpbWUtZHJvcGRvd24udHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIGpzeCwga2V5ZnJhbWVzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGlzTWludXRlTW9kZSB9IGZyb20gJy4uLy4uL2hlbHBlcnMvdXRpbHMnXG5pbXBvcnQgeyBNT0RFIH0gZnJvbSAnLi4vLi4vaGVscGVycy9jb25zdGFudHMnXG5cbmNvbnN0IERST1BET1dOX0JPUkRFUiA9ICcjZjRmNGY0J1xuY29uc3QgRFJPUERPV05fQ09MT1IgPSAnIzhjOGM4YydcbmNvbnN0IERST1BET1dOX1NFTEVDVEVEX0NPTE9SID0gJyNFQUY4RkYnXG5cbmNvbnN0IGhvdXIgPSBgcmlnaHQ6IC0yMnB4O2BcbmNvbnN0IG1pbnV0ZSA9IGByaWdodDogLTEwcHg7YFxuY29uc3QgaG91cjI0ID0gYFxuXHRsZWZ0OiA1MCU7XG5cdHRyYW5zZm9ybTogdHJhbnNsYXRlWCgtNTAlKTtcbmBcblxuY29uc3QgZmFkZUluID0ga2V5ZnJhbWVzYFxuXHQwJSB7IG9wYWNpdHk6IDA7IH1cblx0MTAwJSB7IG9wYWNpdHk6IDE7IH1cbmBcblxuZXhwb3J0IGNvbnN0IHdyYXBwZXIgPSAoaG91cjI0TW9kZTogYm9vbGVhbiwgbW9kZTogTU9ERSkgPT4gY3NzYFxuXHRwb3NpdGlvbjogYWJzb2x1dGU7XG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0YmFja2dyb3VuZDogd2hpdGU7XG5cdGJvcmRlcjogMXB4IHNvbGlkICR7RFJPUERPV05fQk9SREVSfTtcblx0Ym9yZGVyLXJhZGl1czogMnB4O1xuXHRwYWRkaW5nOiA2cHggMDtcblx0ei1pbmRleDogMjA7XG5cdHRvcDogNjJweDtcblx0aGVpZ2h0OiAyNTBweDtcblx0b3ZlcmZsb3cteTogYXV0bztcblx0Ym94LXNoYWRvdzogMCAxcHggM3B4IHJnYmEoMCwgMCwgMCwgMC4xMiksIDAgMXB4IDJweCByZ2JhKDAsIDAsIDAsIDAuMjQpO1xuXHRvcGFjaXR5OiAwO1xuXHRhbmltYXRpb246ICR7ZmFkZUlufSAwLjJzIGVhc2Utb3V0IGJvdGg7XG5cblx0JHtob3VyMjRNb2RlID8gaG91cjI0IDogaXNNaW51dGVNb2RlKG1vZGUpID8gbWludXRlIDogaG91cn1cbmBcblxuZXhwb3J0IGNvbnN0IG9wdGlvbnMgPSBjc3NgXG5cdHBvc2l0aW9uOiByZWxhdGl2ZTtcblx0bGlzdC1zdHlsZTogbm9uZTtcblx0cGFkZGluZzogMDtcblx0bWFyZ2luOiAwO1xuYFxuXG5jb25zdCBzZWxlY3RlZCA9IGBiYWNrZ3JvdW5kOiAke0RST1BET1dOX1NFTEVDVEVEX0NPTE9SfTtgXG5leHBvcnQgY29uc3Qgb3B0aW9uID0gKGFjdGl2ZTogYm9vbGVhbikgPT4gY3NzYFxuXHRiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcblx0cGFkZGluZzogN3B4IDMwcHg7XG5cdGZvbnQtc2l6ZTogMTZweDtcblx0Y29sb3I6ICR7RFJPUERPV05fQ09MT1J9O1xuXHRjdXJzb3I6IHBvaW50ZXI7XG5cdCY6aG92ZXIge1xuXHRcdGJhY2tncm91bmQ6ICR7RFJPUERPV05fU0VMRUNURURfQ09MT1J9O1xuXHR9XG5cdCR7YWN0aXZlICYmIHNlbGVjdGVkfVxuYFxuIl19 */"
	};
	exports.options = options;
	var selected = "background: ".concat(DROPDOWN_SELECTED_COLOR, ";");
	
	var option = function option(active) {
	  return (
	    /*#__PURE__*/
	    (0, _core.css)("background:transparent;padding:7px 30px;font-size:16px;color:", DROPDOWN_COLOR, ";cursor:pointer;&:hover{background:", DROPDOWN_SELECTED_COLOR, ";}", active && selected,  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
	  );
	};
	
	exports.option = option;

/***/ }),
/* 6316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.meridiem = exports.time = exports.colon = exports.minuteWrapper = exports.hourWrapper = exports.wrapper = void 0;
	
	var _taggedTemplateLiteral2 = _interopRequireDefault(__webpack_require__(1662));
	
	var _core = __webpack_require__(128);
	
	function _templateObject() {
	  var data = (0, _taggedTemplateLiteral2.default)(["\n\tfrom { transform: scale(1); }\n\t30% { transform: scale(0.88); }\n\t60% { transform: scale(1.05); }\n\tto { transform: scale(1); }\n"]);
	
	  _templateObject = function _templateObject() {
	    return data;
	  };
	
	  return data;
	}
	
	var TIME_DEFAULT_COLOR = '#8C8C8C';
	var TIME_SELECTED_COLOR = '#8EDDFD';
	
	var wrapper = function wrapper(is24hr) {
	  return (
	    /*#__PURE__*/
	    (0, _core.css)("background:white;padding:14px 16px;border-radius:3px 3px 0 0;position:relative;", is24hr && "\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t",  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy90b3AtYmFyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUsrQyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zdHlsZXMvdG9wLWJhci50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywganN4LCBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5jb25zdCBUSU1FX0RFRkFVTFRfQ09MT1IgPSAnIzhDOEM4QydcbmNvbnN0IFRJTUVfU0VMRUNURURfQ09MT1IgPSAnIzhFRERGRCdcblxuZXhwb3J0IGNvbnN0IHdyYXBwZXIgPSAoaXMyNGhyOiBib29sZWFuKSA9PiBjc3NgXG5cdGJhY2tncm91bmQ6IHdoaXRlO1xuXHRwYWRkaW5nOiAxNHB4IDE2cHg7XG5cdGJvcmRlci1yYWRpdXM6IDNweCAzcHggMCAwO1xuXHRwb3NpdGlvbjogcmVsYXRpdmU7XG5cblx0JHtpczI0aHIgJiZcblx0XHRgXG5cdFx0ZGlzcGxheTogZmxleDtcblx0XHRqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcblx0YH1cbmBcblxuZXhwb3J0IGNvbnN0IGhvdXJXcmFwcGVyID0gKGlzMjRocjogYm9vbGVhbikgPT4gY3NzYFxuXHR3aWR0aDogNzJweDtcblx0dGV4dC1hbGlnbjogcmlnaHQ7XG5cdHBvc2l0aW9uOiByZWxhdGl2ZTtcblx0ZGlzcGxheTogaW5saW5lLWJsb2NrO1xuXHQkeyFpczI0aHIgJiYgJ21hcmdpbi1sZWZ0OiAyMHB4Oyd9XG5gXG5cbmV4cG9ydCBjb25zdCBtaW51dGVXcmFwcGVyID0gKGlzMjRocjogYm9vbGVhbikgPT4gY3NzYFxuXHRwb3NpdGlvbjogcmVsYXRpdmU7XG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0JHtpczI0aHIgJiYgJ3dpZHRoOiA3MnB4Oyd9XG5gXG5cbmV4cG9ydCBjb25zdCBjb2xvbiA9IGNzc2Bcblx0Y29sb3I6ICR7VElNRV9ERUZBVUxUX0NPTE9SfTtcblx0Zm9udC13ZWlnaHQ6IDUwMDtcblx0ZGlzcGxheTogaW5saW5lLWJsb2NrO1xuXHRmb250LXNpemU6IDQ2cHg7XG5cdHZlcnRpY2FsLWFsaWduOiAycHg7XG5cdG1hcmdpbjogMCA1cHg7XG5cdGxpbmUtaGVpZ2h0OiBub3JtYWw7XG5gXG5cbmNvbnN0IHBvcEluT3V0ID0ga2V5ZnJhbWVzYFxuXHRmcm9tIHsgdHJhbnNmb3JtOiBzY2FsZSgxKTsgfVxuXHQzMCUgeyB0cmFuc2Zvcm06IHNjYWxlKDAuODgpOyB9XG5cdDYwJSB7IHRyYW5zZm9ybTogc2NhbGUoMS4wNSk7IH1cblx0dG8geyB0cmFuc2Zvcm06IHNjYWxlKDEpOyB9XG5gXG5cbmNvbnN0IHRpbWVTZWxlY3RlZCA9IGNzc2Bcblx0Y29sb3I6ICR7VElNRV9TRUxFQ1RFRF9DT0xPUn07XG5cdGFuaW1hdGlvbjogJHtwb3BJbk91dH0gMC42cyBlYXNlLW91dDtcbmBcblxuZXhwb3J0IGNvbnN0IHRpbWUgPSAoaXNBY3RpdmU6IGJvb2xlYW4pID0+IGNzc2Bcblx0Y29sb3I6ICR7VElNRV9ERUZBVUxUX0NPTE9SfTtcblx0ZGlzcGxheTogaW5saW5lLWJsb2NrO1xuXHRmb250LXNpemU6IDQ4cHg7XG5cdGN1cnNvcjogcG9pbnRlcjtcblx0dXNlci1zZWxlY3Q6IG5vbmU7XG5cdGxpbmUtaGVpZ2h0OiBub3JtYWw7XG5cdCR7aXNBY3RpdmUgJiYgdGltZVNlbGVjdGVkfVxuYFxuXG5leHBvcnQgY29uc3QgbWVyaWRpZW0gPSBjc3NgXG5cdGNvbG9yOiAke1RJTUVfREVGQVVMVF9DT0xPUn07XG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0Zm9udC1zaXplOiAxM3B4O1xuXHR0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlO1xuXHRtYXJnaW4tbGVmdDogMnB4O1xuXHRwYWRkaW5nOiAxMHB4IDhweDtcblx0dmVydGljYWwtYWxpZ246IDFweDtcbmBcbiJdfQ== */")
	  );
	};
	
	exports.wrapper = wrapper;
	
	var hourWrapper = function hourWrapper(is24hr) {
	  return (
	    /*#__PURE__*/
	    (0, _core.css)("width:72px;text-align:right;position:relative;display:inline-block;", !is24hr && 'margin-left: 20px;',  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
	  );
	};
	
	exports.hourWrapper = hourWrapper;
	
	var minuteWrapper = function minuteWrapper(is24hr) {
	  return (
	    /*#__PURE__*/
	    (0, _core.css)("position:relative;display:inline-block;", is24hr && 'width: 72px;',  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
	  );
	};
	
	exports.minuteWrapper = minuteWrapper;
	var colon =
	/*#__PURE__*/
	(0, _core.css)("color:", TIME_DEFAULT_COLOR, ";font-weight:500;display:inline-block;font-size:46px;vertical-align:2px;margin:0 5px;line-height:normal;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
	exports.colon = colon;
	var popInOut = (0, _core.keyframes)(_templateObject());
	var timeSelected =
	/*#__PURE__*/
	(0, _core.css)("color:", TIME_SELECTED_COLOR, ";animation:", popInOut, " 0.6s ease-out;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3N0eWxlcy90b3AtYmFyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlEd0IiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc3R5bGVzL3RvcC1iYXIudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIGpzeCwga2V5ZnJhbWVzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcblxuY29uc3QgVElNRV9ERUZBVUxUX0NPTE9SID0gJyM4QzhDOEMnXG5jb25zdCBUSU1FX1NFTEVDVEVEX0NPTE9SID0gJyM4RURERkQnXG5cbmV4cG9ydCBjb25zdCB3cmFwcGVyID0gKGlzMjRocjogYm9vbGVhbikgPT4gY3NzYFxuXHRiYWNrZ3JvdW5kOiB3aGl0ZTtcblx0cGFkZGluZzogMTRweCAxNnB4O1xuXHRib3JkZXItcmFkaXVzOiAzcHggM3B4IDAgMDtcblx0cG9zaXRpb246IHJlbGF0aXZlO1xuXG5cdCR7aXMyNGhyICYmXG5cdFx0YFxuXHRcdGRpc3BsYXk6IGZsZXg7XG5cdFx0anVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cdGB9XG5gXG5cbmV4cG9ydCBjb25zdCBob3VyV3JhcHBlciA9IChpczI0aHI6IGJvb2xlYW4pID0+IGNzc2Bcblx0d2lkdGg6IDcycHg7XG5cdHRleHQtYWxpZ246IHJpZ2h0O1xuXHRwb3NpdGlvbjogcmVsYXRpdmU7XG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0JHshaXMyNGhyICYmICdtYXJnaW4tbGVmdDogMjBweDsnfVxuYFxuXG5leHBvcnQgY29uc3QgbWludXRlV3JhcHBlciA9IChpczI0aHI6IGJvb2xlYW4pID0+IGNzc2Bcblx0cG9zaXRpb246IHJlbGF0aXZlO1xuXHRkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG5cdCR7aXMyNGhyICYmICd3aWR0aDogNzJweDsnfVxuYFxuXG5leHBvcnQgY29uc3QgY29sb24gPSBjc3NgXG5cdGNvbG9yOiAke1RJTUVfREVGQVVMVF9DT0xPUn07XG5cdGZvbnQtd2VpZ2h0OiA1MDA7XG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0Zm9udC1zaXplOiA0NnB4O1xuXHR2ZXJ0aWNhbC1hbGlnbjogMnB4O1xuXHRtYXJnaW46IDAgNXB4O1xuXHRsaW5lLWhlaWdodDogbm9ybWFsO1xuYFxuXG5jb25zdCBwb3BJbk91dCA9IGtleWZyYW1lc2Bcblx0ZnJvbSB7IHRyYW5zZm9ybTogc2NhbGUoMSk7IH1cblx0MzAlIHsgdHJhbnNmb3JtOiBzY2FsZSgwLjg4KTsgfVxuXHQ2MCUgeyB0cmFuc2Zvcm06IHNjYWxlKDEuMDUpOyB9XG5cdHRvIHsgdHJhbnNmb3JtOiBzY2FsZSgxKTsgfVxuYFxuXG5jb25zdCB0aW1lU2VsZWN0ZWQgPSBjc3NgXG5cdGNvbG9yOiAke1RJTUVfU0VMRUNURURfQ09MT1J9O1xuXHRhbmltYXRpb246ICR7cG9wSW5PdXR9IDAuNnMgZWFzZS1vdXQ7XG5gXG5cbmV4cG9ydCBjb25zdCB0aW1lID0gKGlzQWN0aXZlOiBib29sZWFuKSA9PiBjc3NgXG5cdGNvbG9yOiAke1RJTUVfREVGQVVMVF9DT0xPUn07XG5cdGRpc3BsYXk6IGlubGluZS1ibG9jaztcblx0Zm9udC1zaXplOiA0OHB4O1xuXHRjdXJzb3I6IHBvaW50ZXI7XG5cdHVzZXItc2VsZWN0OiBub25lO1xuXHRsaW5lLWhlaWdodDogbm9ybWFsO1xuXHQke2lzQWN0aXZlICYmIHRpbWVTZWxlY3RlZH1cbmBcblxuZXhwb3J0IGNvbnN0IG1lcmlkaWVtID0gY3NzYFxuXHRjb2xvcjogJHtUSU1FX0RFRkFVTFRfQ09MT1J9O1xuXHRkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG5cdGZvbnQtc2l6ZTogMTNweDtcblx0dGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcblx0bWFyZ2luLWxlZnQ6IDJweDtcblx0cGFkZGluZzogMTBweCA4cHg7XG5cdHZlcnRpY2FsLWFsaWduOiAxcHg7XG5gXG4iXX0= */"));
	
	var time = function time(isActive) {
	  return (
	    /*#__PURE__*/
	    (0, _core.css)("color:", TIME_DEFAULT_COLOR, ";display:inline-block;font-size:48px;cursor:pointer;user-select:none;line-height:normal;", isActive && timeSelected,  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
	  );
	};
	
	exports.time = time;
	var meridiem =
	/*#__PURE__*/
	(0, _core.css)("color:", TIME_DEFAULT_COLOR, ";display:inline-block;font-size:13px;text-transform:uppercase;margin-left:2px;padding:10px 8px;vertical-align:1px;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
	exports.meridiem = meridiem;

/***/ }),
/* 6317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseTime = parseTime;
	exports.parseMeridiem = parseMeridiem;
	exports.composeTime = composeTime;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(1663));
	
	var TIME_PARSE_MERIDIEM = new RegExp(/^(\d{1,2}?):(\d{2}?)\s?(am|pm)$/i);
	var TIME_PARSE_24 = new RegExp(/^(\d{1,2}?):(\d{2}?)$/);
	var defaultTime = {
	  hour: 12,
	  minute: 30 // parse and normalize time to 24h
	
	};
	
	function parseTime(time) {
	  if (time == null) {
	    return defaultTime;
	  }
	
	  var hour = 0;
	  var minute = 0;
	  var meridiem = null; // parse basic numbers from string or object
	
	  if (typeof time === 'string') {
	    // if is string
	    var match = time.match(TIME_PARSE_MERIDIEM);
	
	    if (match) {
	      // 12 hr string
	      hour = parseInt(match[1], 10);
	      minute = parseInt(match[2], 10);
	      meridiem = match[3].toLowerCase();
	    } else {
	      // 24 hr string
	      match = time.match(TIME_PARSE_24);
	
	      if (!match) {
	        throw new Error('Could not parse time (string)');
	      }
	
	      hour = parseInt(match[1], 10);
	      minute = parseInt(match[2], 10);
	    }
	  } else if ((0, _typeof2.default)(time) === 'object') {
	    // if is object
	    if (!Number.isInteger(time.hour) || !Number.isInteger(time.minute)) {
	      throw new Error('Time and minute must both be valid integers');
	    }
	
	    hour = time.hour;
	    minute = time.minute;
	
	    if (time.meridiem) {
	      meridiem = time.meridiem.toLowerCase();
	    }
	  }
	
	  if (minute > 60) {
	    throw new Error('Minute out of range (> 60)');
	  } // normalize hours
	
	
	  if (meridiem != null) {
	    if (hour > 12) {
	      throw new Error('Hour out of range (> 12)');
	    } // handling the 12 hr conversion
	
	
	    if (meridiem === 'pm' && hour !== 12) {
	      hour += 12;
	    } else if (meridiem === 'am' && hour === 12) {
	      hour = 0;
	    }
	  } else {
	    // handling the 24 hour conversion
	    if (hour > 24) {
	      throw new Error('Hour out of range (> 24)');
	    }
	
	    if (hour === 24) {
	      hour = 0;
	    }
	  }
	
	  return {
	    hour: hour,
	    minute: minute
	  };
	}
	
	function parseMeridiem(time) {
	  var parsed = parseTime(time); // assumes time is 0 -> 23, where 0 is midnight
	
	  return parsed.hour >= 12 ? 'pm' : 'am';
	} // formats time output to poss to parent
	
	
	function composeTime(hour, minute) {
	  var paddedMinute = ('0' + minute).slice(-2);
	  var hour24 = hour === 24 ? 0 : hour;
	  var meridiem = hour >= 12 ? 'pm' : 'am';
	  var hour12 = hour;
	
	  if (hour > 12) {
	    hour12 = hour - 12;
	  } else if (hour === 0) {
	    hour12 = hour = 12;
	  }
	
	  return {
	    formatted24: "".concat(hour24, ":").concat(paddedMinute),
	    formatted12: "".concat(hour12, ":").concat(paddedMinute, " ").concat(meridiem),
	    formattedSimple: "".concat(hour12, ":").concat(paddedMinute),
	    hour: hour24,
	    hour12: hour12,
	    minute: minute,
	    meridiem: meridiem
	  };
	}

/***/ }),
/* 6318 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 6319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useClockEvents;
	
	var _react = __webpack_require__(1);
	
	var _constants = __webpack_require__(211);
	
	var _dom = __webpack_require__(2826);
	
	var _math = __webpack_require__(1642);
	
	var atan2 = Math.atan2;
	
	/*
		solely responsible for transforming click events into
		angles (which are later converted into time depending
		on current mode and other restrictions)
	*/
	function useClockEvents(clock, handleChange) {
	  var wrapper = (0, _react.useRef)(null);
	  var calcOffsetCache = (0, _react.useRef)(null);
	  var dragCount = (0, _react.useRef)(0);
	  var cleanup = (0, _react.useCallback)(_removeHandlers, []);
	  var disableMouse = (0, _react.useRef)(false); // mouse events
	
	  function handleMouseDown(e) {
	    if (disableMouse.current) {
	      return;
	    }
	
	    dragCount.current = 0; // add listeners
	
	    document.addEventListener('mousemove', handleMouseDrag, false);
	    document.addEventListener('mouseup', handleStopDrag, false);
	    wrapper.current && wrapper.current.addEventListener('mouseleave', handleStopDrag, false);
	
	    if (clock.current) {
	      calcOffsetCache.current = (0, _dom.calcOffset)(clock.current);
	    } // move hand
	
	
	    handleMouseDrag(e); // TODO - fix ts
	  }
	
	  function handleMouseDrag(e) {
	    if (calcOffsetCache.current) {
	      var _calcOffsetCache$curr = calcOffsetCache.current(e.clientX, e.clientY),
	          offsetX = _calcOffsetCache$curr.offsetX,
	          offsetY = _calcOffsetCache$curr.offsetY;
	
	      calculatePoint(offsetX, offsetY, false);
	    }
	
	    dragCount.current++;
	
	    if (dragCount.current === 1 && clock.current) {
	      clock.current.style.cursor = '-webkit-grabbing';
	      clock.current.style.cursor = 'grabbing';
	    }
	
	    e.preventDefault();
	    return false;
	  } // touch events
	
	
	  function handleTouchStart() {
	    // disables mouse events during touch events
	    disableMouse.current = true;
	    dragCount.current = 0; // add listeners
	
	    document.addEventListener('touchmove', touchDragHandler, false);
	    document.addEventListener('touchend', handleStopDrag, false);
	    document.addEventListener('touchcancel', handleStopDrag, false);
	
	    if (clock.current) {
	      calcOffsetCache.current = (0, _dom.calcOffset)(clock.current);
	    }
	  }
	
	  function touchDragHandler(e) {
	    if (calcOffsetCache.current) {
	      var touch = e.targetTouches[0];
	
	      var _calcOffsetCache$curr2 = calcOffsetCache.current(touch.clientX, touch.clientY),
	          offsetX = _calcOffsetCache$curr2.offsetX,
	          offsetY = _calcOffsetCache$curr2.offsetY;
	
	      calculatePoint(offsetX, offsetY, false);
	    }
	
	    dragCount.current++;
	    e.preventDefault();
	    return false;
	  } // stop mouse + touch events
	
	
	  function handleStopDrag(e) {
	    _removeHandlers();
	
	    if (e == null || clock.current == null) {
	      return;
	    }
	
	    if (isMouseEventEnd(e)) {
	      _handleMouseUp(e);
	    } else if (isTouchEventEnd(e)) {
	      _handleTouchEnd(e);
	    }
	
	    function isMouseEventEnd(e) {
	      return e.type === 'mouseup';
	    }
	
	    function isTouchEventEnd(e) {
	      return e.type === 'touchcancel' || e.type === 'touchend';
	    }
	  }
	
	  function _removeHandlers() {
	    document.removeEventListener('mousemove', handleMouseDrag, false);
	    document.removeEventListener('mouseup', handleStopDrag, false);
	    wrapper.current && wrapper.current.removeEventListener('mouseleave', handleStopDrag, false);
	    document.removeEventListener('touchmove', touchDragHandler, false);
	    document.removeEventListener('touchend', handleStopDrag, false);
	    document.removeEventListener('touchcancel', handleStopDrag, false);
	  } // handle mouse + touch changes
	
	
	  function _handleMouseUp(e) {
	    if (!clock.current) {
	      return;
	    }
	
	    clock.current.style.cursor = '';
	
	    var _ref = calcOffsetCache.current(e.clientX, e.clientY),
	        offsetX = _ref.offsetX,
	        offsetY = _ref.offsetY;
	
	    calculatePoint(offsetX, offsetY, true);
	  }
	
	  function _handleTouchEnd(e) {
	    var touch = e.targetTouches[0] || e.changedTouches[0];
	
	    if (touch && calcOffsetCache.current) {
	      var _calcOffsetCache$curr3 = calcOffsetCache.current(touch.clientX, touch.clientY),
	          offsetX = _calcOffsetCache$curr3.offsetX,
	          offsetY = _calcOffsetCache$curr3.offsetY;
	
	      calculatePoint(offsetX, offsetY, true);
	    }
	
	    setTimeout(function () {
	      disableMouse.current = false;
	    }, 10);
	  }
	
	  function calculatePoint(offsetX, offsetY, // determines if change is due to mouseup/touchend in order to
	  // automatically change unit (eg: hour -> minute) if enabled
	  // prevents changing unit if dragging along clock
	  canAutoChangeUnit) {
	    // if user just clicks/taps a number (drag count < 2), then just assume it's a rough tap
	    // and force a rounded/coarse number (ie: 1, 2, 3, 4 is tapped, assume 0 or 5)
	    var wasTapped = dragCount.current < 2;
	    var x = offsetX - _constants.CLOCK_RADIUS;
	    var y = -offsetY + _constants.CLOCK_RADIUS;
	    var a = atan2(y, x);
	    var d = 90 - (0, _math.deg)(a);
	
	    if (d < 0) {
	      d = 360 + d;
	    } // ensure touch doesn't bleed outside of clock radius
	
	
	    if (!(0, _math.isWithinRadius)(x, y, _constants.CLOCK_RADIUS) && wasTapped) {
	      return false;
	    }
	
	    var isInnerClick = (0, _math.isWithinRadius)(x, y, _constants.INNER_NUMBER_RADIUS); // update time on main
	
	    handleChange(d, {
	      canAutoChangeUnit: canAutoChangeUnit,
	      wasTapped: wasTapped,
	      isInnerClick: isInnerClick
	    });
	  } // clean up
	
	
	  (0, _react.useEffect)(function () {
	    return cleanup;
	  }, [cleanup]);
	  return {
	    bind: {
	      onMouseDown: handleMouseDown,
	      onTouchStart: handleTouchStart,
	      ref: wrapper
	    }
	  };
	}

/***/ }),
/* 6320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "TimeInput", {
	  enumerable: true,
	  get: function get() {
	    return _types.TimeInput;
	  }
	});
	Object.defineProperty(exports, "TimeOutput", {
	  enumerable: true,
	  get: function get() {
	    return _types.TimeOutput;
	  }
	});
	exports.default = void 0;
	
	var _TimeKeeperWrapper = _interopRequireDefault(__webpack_require__(6306));
	
	var _types = __webpack_require__(6318);
	
	var _default = _TimeKeeperWrapper.default;
	exports.default = _default;

/***/ }),
/* 6321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var _extends=_interopDefault(__webpack_require__(1052)),_objectWithoutPropertiesLoose=_interopDefault(__webpack_require__(1661)),_inheritsLoose=_interopDefault(__webpack_require__(1053)),React=__webpack_require__(1),React__default=_interopDefault(React),cx=_interopDefault(__webpack_require__(6322)),reactTransitionGroup=__webpack_require__(6331),reactDom=__webpack_require__(71),POSITION={TOP_LEFT:"top-left",TOP_RIGHT:"top-right",TOP_CENTER:"top-center",BOTTOM_LEFT:"bottom-left",BOTTOM_RIGHT:"bottom-right",BOTTOM_CENTER:"bottom-center"},TYPE={INFO:"info",SUCCESS:"success",WARNING:"warning",ERROR:"error",DEFAULT:"default"},ACTION={SHOW:0,CLEAR:1,DID_MOUNT:2,WILL_UNMOUNT:3,ON_CHANGE:4},NOOP=function(){},RT_NAMESPACE="Toastify";function isValidDelay(t){return"number"==typeof t&&!isNaN(t)&&0<t}var canUseDom=!("undefined"==typeof window||!window.document||!window.document.createElement);function withRequired(o){return o.isRequired=function(t,e,n){if(void 0===t[e])return new Error("The prop "+e+" is marked as required in \n      "+n+", but its value is undefined.");o(t,e,n)},o}var falseOrDelay=withRequired(function(t,e,n){var o=t[e];return!1===o||isValidDelay(o)?null:new Error(n+" expect "+e+" \n      to be a valid Number > 0 or equal to false. "+o+" given.")}),eventManager={list:new Map,emitQueue:new Map,on:function(t,e){return this.list.has(t)||this.list.set(t,[]),this.list.get(t).push(e),this},off:function(t){return this.list.delete(t),this},cancelEmit:function(t){var e=this.emitQueue.get(t);return e&&(e.forEach(function(t){return clearTimeout(t)}),this.emitQueue.delete(t)),this},emit:function(n){for(var o=this,t=arguments.length,s=new Array(1<t?t-1:0),e=1;e<t;e++)s[e-1]=arguments[e];this.list.has(n)&&this.list.get(n).forEach(function(t){var e=setTimeout(function(){t.apply(void 0,s)},0);o.emitQueue.has(n)||o.emitQueue.set(n,[]),o.emitQueue.get(n).push(e)})}};function cssTransition(t){var u=t.enter,c=t.exit,e=t.duration,p=void 0===e?750:e,n=t.appendPosition,d=void 0!==n&&n;return function(t){var e,n,o=t.children,s=t.position,a=t.preventExitTransition,r=_objectWithoutPropertiesLoose(t,["children","position","preventExitTransition"]),i=d?u+"--"+s:u,l=d?c+"--"+s:c;Array.isArray(p)&&2===p.length?(e=p[0],n=p[1]):e=n=p;return React__default.createElement(reactTransitionGroup.Transition,_extends({},r,{timeout:a?0:{enter:e,exit:n},onEnter:function(t){t.classList.add(i),t.style.animationFillMode="forwards",t.style.animationDuration=.001*e+"s"},onEntered:function(t){t.classList.remove(i),t.style.cssText=""},onExit:a?NOOP:function(t){t.classList.add(l),t.style.animationFillMode="forwards",t.style.animationDuration=.001*n+"s"}}),o)}}function ProgressBar(t){var e,n,o=t.delay,s=t.isRunning,a=t.closeToast,r=t.type,i=t.hide,l=t.className,u=t.style,c=t.controlledProgress,p=t.progress,d=t.rtl,f=_extends({},u,{animationDuration:o+"ms",animationPlayState:s?"running":"paused",opacity:i?0:1,transform:c?"scaleX("+p+")":null}),g=cx(RT_NAMESPACE+"__progress-bar",c?RT_NAMESPACE+"__progress-bar--controlled":RT_NAMESPACE+"__progress-bar--animated",RT_NAMESPACE+"__progress-bar--"+r,((e={})[RT_NAMESPACE+"__progress-bar--rtl"]=d,e),l),h=((n={})[c&&1<=p?"onTransitionEnd":"onAnimationEnd"]=c&&p<1?null:a,n);return React__default.createElement("div",_extends({className:g,style:f},h))}function getX(t){return t.targetTouches&&1<=t.targetTouches.length?t.targetTouches[0].clientX:t.clientX}function getY(t){return t.targetTouches&&1<=t.targetTouches.length?t.targetTouches[0].clientY:t.clientY}ProgressBar.defaultProps={type:TYPE.DEFAULT,hide:!1};var iLoveInternetExplorer=canUseDom&&/(msie|trident)/i.test(navigator.userAgent),Toast=function(o){function t(){for(var a,t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(a=o.call.apply(o,[this].concat(e))||this).state={isRunning:!0,preventExitTransition:!1},a.flag={canCloseOnClick:!0,canDrag:!1},a.drag={start:0,x:0,y:0,deltaX:0,removalDistance:0},a.boundingRect=null,a.ref=null,a.pauseToast=function(){a.props.autoClose&&a.setState({isRunning:!1})},a.playToast=function(){a.props.autoClose&&a.setState({isRunning:!0})},a.onDragStart=function(t){a.flag.canCloseOnClick=!0,a.flag.canDrag=!0,a.boundingRect=a.ref.getBoundingClientRect(),a.ref.style.transition="",a.drag.start=a.drag.x=getX(t.nativeEvent),a.drag.removalDistance=a.ref.offsetWidth*(a.props.draggablePercent/100)},a.onDragMove=function(t){a.flag.canDrag&&(a.state.isRunning&&a.pauseToast(),a.drag.x=getX(t),a.drag.deltaX=a.drag.x-a.drag.start,a.drag.y=getY(t),a.drag.start!==a.drag.x&&(a.flag.canCloseOnClick=!1),a.ref.style.transform="translateX("+a.drag.deltaX+"px)",a.ref.style.opacity=1-Math.abs(a.drag.deltaX/a.drag.removalDistance))},a.onDragEnd=function(t){if(a.flag.canDrag){if(a.flag.canDrag=!1,Math.abs(a.drag.deltaX)>a.drag.removalDistance)return void a.setState({preventExitTransition:!0},a.props.closeToast);a.ref.style.transition="transform 0.2s, opacity 0.2s",a.ref.style.transform="translateX(0)",a.ref.style.opacity=1}},a.onDragTransitionEnd=function(){if(a.boundingRect){var t=a.boundingRect,e=t.top,n=t.bottom,o=t.left,s=t.right;a.props.pauseOnHover&&a.drag.x>=o&&a.drag.x<=s&&a.drag.y>=e&&a.drag.y<=n?a.pauseToast():a.playToast()}},a.onExitTransitionEnd=function(){if(iLoveInternetExplorer)a.props.onExited();else{var t=a.ref.scrollHeight,e=a.ref.style;requestAnimationFrame(function(){e.minHeight="initial",e.height=t+"px",e.transition="all 0.4s ",requestAnimationFrame(function(){e.height=0,e.padding=0,e.margin=0}),setTimeout(function(){return a.props.onExited()},400)})}},a}_inheritsLoose(t,o);var e=t.prototype;return e.componentDidMount=function(){this.props.onOpen(this.props.children.props),this.props.draggable&&this.bindDragEvents(),this.props.pauseOnFocusLoss&&this.bindFocusEvents()},e.componentDidUpdate=function(t){t.draggable!==this.props.draggable&&(this.props.draggable?this.bindDragEvents():this.unbindDragEvents()),t.pauseOnFocusLoss!==this.props.pauseOnFocusLoss&&(this.props.pauseOnFocusLoss?this.bindFocusEvents():this.unbindFocusEvents())},e.componentWillUnmount=function(){this.props.onClose(this.props.children.props),this.props.draggable&&this.unbindDragEvents(),this.props.pauseOnFocusLoss&&this.unbindFocusEvents()},e.bindFocusEvents=function(){window.addEventListener("focus",this.playToast),window.addEventListener("blur",this.pauseToast)},e.unbindFocusEvents=function(){window.removeEventListener("focus",this.playToast),window.removeEventListener("blur",this.pauseToast)},e.bindDragEvents=function(){document.addEventListener("mousemove",this.onDragMove),document.addEventListener("mouseup",this.onDragEnd),document.addEventListener("touchmove",this.onDragMove),document.addEventListener("touchend",this.onDragEnd)},e.unbindDragEvents=function(){document.removeEventListener("mousemove",this.onDragMove),document.removeEventListener("mouseup",this.onDragEnd),document.removeEventListener("touchmove",this.onDragMove),document.removeEventListener("touchend",this.onDragEnd)},e.render=function(){var t,e=this,n=this.props,o=n.closeButton,s=n.children,a=n.autoClose,r=n.pauseOnHover,i=n.onClick,l=n.closeOnClick,u=n.type,c=n.hideProgressBar,p=n.closeToast,d=n.transition,f=n.position,g=n.className,h=n.bodyClassName,T=n.progressClassName,m=n.progressStyle,E=n.updateId,v=n.role,_=n.progress,C=n.rtl,y={className:cx(RT_NAMESPACE+"__toast",RT_NAMESPACE+"__toast--"+u,((t={})[RT_NAMESPACE+"__toast--rtl"]=C,t),g)};a&&r&&(y.onMouseEnter=this.pauseToast,y.onMouseLeave=this.playToast),l&&(y.onClick=function(t){i&&i(t),e.flag.canCloseOnClick&&p()});var N=parseFloat(_)===_;return React__default.createElement(d,{in:this.props.in,appear:!0,onExited:this.onExitTransitionEnd,position:f,preventExitTransition:this.state.preventExitTransition},React__default.createElement("div",_extends({onClick:i},y,{ref:function(t){return e.ref=t},onMouseDown:this.onDragStart,onTouchStart:this.onDragStart,onMouseUp:this.onDragTransitionEnd,onTouchEnd:this.onDragTransitionEnd}),React__default.createElement("div",_extends({},this.props.in&&{role:v},{className:cx(RT_NAMESPACE+"__toast-body",h)}),s),o&&o,(a||N)&&React__default.createElement(ProgressBar,_extends({},E&&!N?{key:"pb-"+E}:{},{rtl:C,delay:a,isRunning:this.state.isRunning,closeToast:p,hide:c,type:u,style:m,className:T,controlledProgress:N,progress:_}))))},t}(React.Component);function CloseButton(t){var e=t.closeToast,n=t.type,o=t.ariaLabel;return React__default.createElement("button",{className:RT_NAMESPACE+"__close-button "+RT_NAMESPACE+"__close-button--"+n,type:"button",onClick:function(t){t.stopPropagation(),e(t)},"aria-label":o},"✖︎")}Toast.defaultProps={type:TYPE.DEFAULT,in:!0,onOpen:NOOP,onClose:NOOP,className:null,bodyClassName:null,progressClassName:null,updateId:null},CloseButton.defaultProps={ariaLabel:"close"};var Bounce=cssTransition({enter:RT_NAMESPACE+"__bounce-enter",exit:RT_NAMESPACE+"__bounce-exit",appendPosition:!0}),Slide=cssTransition({enter:RT_NAMESPACE+"__slide-enter",exit:RT_NAMESPACE+"__slide-exit",duration:[450,750],appendPosition:!0}),Zoom=cssTransition({enter:RT_NAMESPACE+"__zoom-enter",exit:RT_NAMESPACE+"__zoom-exit"}),Flip=cssTransition({enter:RT_NAMESPACE+"__flip-enter",exit:RT_NAMESPACE+"__flip-exit"}),ToastContainer=function(s){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=s.call.apply(s,[this].concat(n))||this).state={toast:[]},e.toastKey=1,e.collection={},e.isToastActive=function(t){return-1!==e.state.toast.indexOf(t)},e}_inheritsLoose(t,s);var e=t.prototype;return e.componentDidMount=function(){var n=this;eventManager.cancelEmit(ACTION.WILL_UNMOUNT).on(ACTION.SHOW,function(t,e){return n.ref?n.buildToast(t,e):null}).on(ACTION.CLEAR,function(t){return n.ref?null==t?n.clear():n.removeToast(t):null}).emit(ACTION.DID_MOUNT,this)},e.componentWillUnmount=function(){eventManager.emit(ACTION.WILL_UNMOUNT,this)},e.removeToast=function(e){this.setState({toast:this.state.toast.filter(function(t){return t!==e})},this.dispatchChange)},e.dispatchChange=function(){eventManager.emit(ACTION.ON_CHANGE,this.state.toast.length,this.props.containerId)},e.makeCloseButton=function(t,e,n){var o=this,s=this.props.closeButton;return React.isValidElement(t)||!1===t?s=t:!0===t&&(s=this.props.closeButton&&"boolean"!=typeof this.props.closeButton?this.props.closeButton:React__default.createElement(CloseButton,null)),!1!==s&&React.cloneElement(s,{closeToast:function(){return o.removeToast(e)},type:n})},e.getAutoCloseDelay=function(t){return!1===t||isValidDelay(t)?t:this.props.autoClose},e.canBeRendered=function(t){return React.isValidElement(t)||"string"==typeof t||"number"==typeof t||"function"==typeof t},e.parseClassName=function(t){return"string"==typeof t?t:null!==t&&"object"==typeof t&&"toString"in t?t.toString():null},e.belongToContainer=function(t){return t.containerId===this.props.containerId},e.buildToast=function(t,e){var n=this,o=e.delay,s=_objectWithoutPropertiesLoose(e,["delay"]);if(!this.canBeRendered(t))throw new Error("The element you provided cannot be rendered. You provided an element of type "+typeof t);var a=s.toastId,r=s.updateId;if(!(this.props.enableMultiContainer&&!this.belongToContainer(s)||this.isToastActive(a)&&null==r)){var i=function(){return n.removeToast(a)},l={id:a,key:s.key||this.toastKey++,type:s.type,closeToast:i,updateId:s.updateId,rtl:this.props.rtl,position:s.position||this.props.position,transition:s.transition||this.props.transition,className:this.parseClassName(s.className||this.props.toastClassName),bodyClassName:this.parseClassName(s.bodyClassName||this.props.bodyClassName),onClick:s.onClick||this.props.onClick,closeButton:this.makeCloseButton(s.closeButton,a,s.type),pauseOnHover:"boolean"==typeof s.pauseOnHover?s.pauseOnHover:this.props.pauseOnHover,pauseOnFocusLoss:"boolean"==typeof s.pauseOnFocusLoss?s.pauseOnFocusLoss:this.props.pauseOnFocusLoss,draggable:"boolean"==typeof s.draggable?s.draggable:this.props.draggable,draggablePercent:"number"!=typeof s.draggablePercent||isNaN(s.draggablePercent)?this.props.draggablePercent:s.draggablePercent,closeOnClick:"boolean"==typeof s.closeOnClick?s.closeOnClick:this.props.closeOnClick,progressClassName:this.parseClassName(s.progressClassName||this.props.progressClassName),progressStyle:this.props.progressStyle,autoClose:this.getAutoCloseDelay(s.autoClose),hideProgressBar:"boolean"==typeof s.hideProgressBar?s.hideProgressBar:this.props.hideProgressBar,progress:parseFloat(s.progress),role:"string"==typeof s.role?s.role:this.props.role};"function"==typeof s.onOpen&&(l.onOpen=s.onOpen),"function"==typeof s.onClose&&(l.onClose=s.onClose),React.isValidElement(t)&&"string"!=typeof t.type&&"number"!=typeof t.type?t=React.cloneElement(t,{closeToast:i}):"function"==typeof t&&(t=t({closeToast:i})),isValidDelay(o)?setTimeout(function(){n.appendToast(l,t,s.staleToastId)},o):this.appendToast(l,t,s.staleToastId)}},e.appendToast=function(t,e,n){var o,s=t.id,a=t.updateId;this.collection=_extends({},this.collection,((o={})[s]={options:t,content:e,position:t.position},o)),this.setState({toast:(a?[].concat(this.state.toast):[].concat(this.state.toast,[s])).filter(function(t){return t!==n})},this.dispatchChange)},e.clear=function(){this.setState({toast:[]})},e.renderToast=function(){var a=this,r={},t=this.props,s=t.className,i=t.style;return(t.newestOnTop?Object.keys(this.collection).reverse():Object.keys(this.collection)).forEach(function(t){var e=a.collection[t],n=e.position,o=e.options,s=e.content;r[n]||(r[n]=[]),-1!==a.state.toast.indexOf(o.id)?r[n].push(React__default.createElement(Toast,_extends({},o,{isDocumentHidden:a.state.isDocumentHidden,key:"toast-"+o.key}),s)):(r[n].push(null),delete a.collection[t])}),Object.keys(r).map(function(t){var e,n=1===r[t].length&&null===r[t][0],o={className:cx(RT_NAMESPACE+"__toast-container",RT_NAMESPACE+"__toast-container--"+t,((e={})[RT_NAMESPACE+"__toast-container--rtl"]=a.props.rtl,e),a.parseClassName(s)),style:n?_extends({},i,{pointerEvents:"none"}):_extends({},i)};return React__default.createElement(reactTransitionGroup.TransitionGroup,_extends({},o,{key:"container-"+t}),r[t])})},e.render=function(){var e=this;return React__default.createElement("div",{ref:function(t){return e.ref=t},className:""+RT_NAMESPACE},this.renderToast())},t}(React.Component);ToastContainer.defaultProps={position:POSITION.TOP_RIGHT,transition:Bounce,rtl:!1,autoClose:5e3,hideProgressBar:!1,closeButton:React__default.createElement(CloseButton,null),pauseOnHover:!0,pauseOnFocusLoss:!0,closeOnClick:!0,newestOnTop:!1,draggable:!0,draggablePercent:80,className:null,style:null,toastClassName:null,bodyClassName:null,progressClassName:null,progressStyle:null,role:"alert"};var containers=new Map,latestInstance=null,containerDomNode=null,containerConfig={},queue=[],lazy=!1;function isAnyContainerMounted(){return 0<containers.size}function getContainer(t){return isAnyContainerMounted()?t?containers.get(t):containers.get(latestInstance):null}function getToast(t,e){var n=getContainer(e.containerId);if(!n)return null;var o=n.collection[t];return void 0===o?null:o}function mergeOptions(t,e){return _extends({},t,{type:e,toastId:getToastId(t)})}function generateToastId(){return(Math.random().toString(36)+Date.now().toString(36)).substr(2,10)}function getToastId(t){return t&&("string"==typeof t.toastId||"number"==typeof t.toastId&&!isNaN(t.toastId))?t.toastId:generateToastId()}function dispatchToast(t,e){return isAnyContainerMounted()?eventManager.emit(ACTION.SHOW,t,e):(queue.push({action:ACTION.SHOW,content:t,options:e}),lazy&&canUseDom&&(lazy=!1,containerDomNode=document.createElement("div"),document.body.appendChild(containerDomNode),reactDom.render(React__default.createElement(ToastContainer,containerConfig),containerDomNode))),e.toastId}var toast=function(t,e){return dispatchToast(t,mergeOptions(e,e&&e.type||TYPE.DEFAULT))},_loop=function(n){TYPE[n]!==TYPE.DEFAULT&&(toast[TYPE[n].toLowerCase()]=function(t,e){return dispatchToast(t,mergeOptions(e,e&&e.type||TYPE[n]))})};for(var t in TYPE)_loop(t);toast.warn=toast.warning,toast.dismiss=function(t){return void 0===t&&(t=null),isAnyContainerMounted()&&eventManager.emit(ACTION.CLEAR,t)},toast.isActive=function(e){var n=!1;return 0<containers.size&&containers.forEach(function(t){t.isToastActive(e)&&(n=!0)}),n},toast.update=function(a,r){void 0===r&&(r={}),setTimeout(function(){var t=getToast(a,r);if(t){var e=t.options,n=t.content,o=_extends({},e,{},r,{toastId:r.toastId||a});r.toastId&&r.toastId!==a?o.staleToastId=a:o.updateId=generateToastId();var s=void 0!==o.render?o.render:n;delete o.render,dispatchToast(s,o)}},0)},toast.done=function(t){toast.update(t,{progress:1})},toast.onChange=function(t){"function"==typeof t&&eventManager.on(ACTION.ON_CHANGE,t)},toast.configure=function(t){lazy=!0,containerConfig=t},toast.POSITION=POSITION,toast.TYPE=TYPE,eventManager.on(ACTION.DID_MOUNT,function(t){latestInstance=t.props.containerId||t,containers.set(latestInstance,t),queue.forEach(function(t){eventManager.emit(t.action,t.content,t.options)}),queue=[]}).on(ACTION.WILL_UNMOUNT,function(t){t?containers.delete(t.props.containerId||t):containers.clear(),0===containers.size&&eventManager.off(ACTION.SHOW).off(ACTION.CLEAR),canUseDom&&containerDomNode&&document.body.removeChild(containerDomNode)}),exports.Bounce=Bounce,exports.Flip=Flip,exports.Slide=Slide,exports.ToastContainer=ToastContainer,exports.ToastPosition=POSITION,exports.ToastType=TYPE,exports.Zoom=Zoom,exports.cssTransition=cssTransition,exports.toast=toast;


/***/ }),
/* 6322 */
475,
/* 6323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(154);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(6324));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 6324 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 6325 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    ;
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 6326 */
[6835, 6327],
/* 6327 */
6261,
/* 6328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(591));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(6323));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(6325));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(1643));
	
	var _PropTypes = __webpack_require__(2830);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (node, appearing) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    if (type === 'appear' && phase === 'done') {
	      className += " " + this.getClassNames('enter').doneClassName;
	    } // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	    }
	
	    this.appliedClasses[type][phase] = className;
	
	    _addClass(node, className);
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided and it
	   * will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-appear`, `fade-appear-active`,
	   * `fade-appear-done`, `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, and `fade-exit-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 6329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(591));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(71));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(2828));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler](_reactDom.default.findDOMNode(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 6330 */
[6837, 591, 1643, 1644],
/* 6331 */
[6839, 6328, 6329, 6330, 2828, 1643, 2829],
/* 6332 */
6211,
/* 6333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BrowseButton = exports.browseButtonFactory = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(8);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	var _FontIcon = __webpack_require__(592);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Ripple = __webpack_require__(1046);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(ripple, FontIcon) {
	  var SimpleBrowseButton = function (_Component) {
	    _inherits(SimpleBrowseButton, _Component);
	
	    function SimpleBrowseButton() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, SimpleBrowseButton);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleBrowseButton.__proto__ || Object.getPrototypeOf(SimpleBrowseButton)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
	        if (_this.props.primary) return 'primary';
	        if (_this.props.accent) return 'accent';
	        return 'neutral';
	      }, _this.getShape = function () {
	        if (_this.props.raised) return 'raised';
	        if (_this.props.floating) return 'floating';
	        return 'flat';
	      }, _this.handleMouseUp = function (event) {
	        _this.labelNode.blur();
	        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
	      }, _this.handleMouseLeave = function (event) {
	        _this.labelNode.blur();
	        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	      }, _this.handleFileChange = function (event) {
	        if (_this.props.onChange) _this.props.onChange(event);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SimpleBrowseButton, [{
	      key: 'render',
	      value: function render() {
	        var _classnames,
	            _this2 = this;
	
	        var _props = this.props,
	            accent = _props.accent,
	            accept = _props.accept,
	            children = _props.children,
	            className = _props.className,
	            flat = _props.flat,
	            floating = _props.floating,
	            icon = _props.icon,
	            inverse = _props.inverse,
	            label = _props.label,
	            mini = _props.mini,
	            multiple = _props.multiple,
	            neutral = _props.neutral,
	            primary = _props.primary,
	            raised = _props.raised,
	            theme = _props.theme,
	            others = _objectWithoutProperties(_props, ['accent', 'accept', 'children', 'className', 'flat', 'floating', 'icon', 'inverse', 'label', 'mini', 'multiple', 'neutral', 'primary', 'raised', 'theme']);
	
	        var element = 'label';
	        var level = this.getLevel();
	        var shape = this.getShape();
	
	        var classes = (0, _classnames3.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty(_classnames, theme[level], neutral), _defineProperty(_classnames, theme.mini, mini), _defineProperty(_classnames, theme.inverse, inverse), _classnames), className);
	
	        var props = _extends({}, others, {
	          ref: function ref(node) {
	            _this2.labelNode = node;
	          },
	          onChange: null,
	          className: classes,
	          disabled: this.props.disabled,
	          onMouseUp: this.handleMouseUp,
	          onMouseLeave: this.handleMouseLeave,
	          'data-react-toolbox': 'label'
	        });
	
	        return _react2.default.createElement(element, props, icon ? _react2.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, _react2.default.createElement(
	          'span',
	          null,
	          label
	        ), _react2.default.createElement('input', {
	          className: classes,
	          type: 'file',
	          accept: accept,
	          multiple: multiple,
	          onChange: this.handleFileChange
	        }), children);
	      }
	    }]);
	
	    return SimpleBrowseButton;
	  }(_react.Component);
	
	  SimpleBrowseButton.propTypes = {
	    accent: _propTypes2.default.bool,
	    accept: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool,
	    flat: _propTypes2.default.bool,
	    floating: _propTypes2.default.bool,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inverse: _propTypes2.default.bool,
	    label: _propTypes2.default.string,
	    mini: _propTypes2.default.bool,
	    multiple: _propTypes2.default.bool,
	    neutral: _propTypes2.default.bool,
	    onChange: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    primary: _propTypes2.default.bool,
	    raised: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      accent: _propTypes2.default.string,
	      button: _propTypes2.default.string,
	      flat: _propTypes2.default.string,
	      floating: _propTypes2.default.string,
	      icon: _propTypes2.default.string,
	      inverse: _propTypes2.default.string,
	      mini: _propTypes2.default.string,
	      neutral: _propTypes2.default.string,
	      primary: _propTypes2.default.string,
	      raised: _propTypes2.default.string,
	      rippleWrapper: _propTypes2.default.string,
	      toggle: _propTypes2.default.string
	    }),
	    type: _propTypes2.default.string
	  };
	  SimpleBrowseButton.defaultProps = {
	    accent: false,
	    accept: '*/*',
	    className: '',
	    flat: false,
	    floating: false,
	    mini: false,
	    multiple: false,
	    neutral: true,
	    primary: false,
	    raised: false
	  };
	
	
	  return ripple(SimpleBrowseButton);
	};
	
	var BrowseButton = factory((0, _Ripple2.default)({ centered: false }), _FontIcon2.default);
	exports.default = (0, _reactCssThemr.themr)(_identifiers.BUTTON)(BrowseButton);
	exports.browseButtonFactory = factory;
	exports.BrowseButton = BrowseButton;

/***/ }),
/* 6334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(8);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _time = __webpack_require__(750);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Day = function (_Component) {
	  _inherits(Day, _Component);
	
	  function Day() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Day.__proto__ || Object.getPrototypeOf(Day)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
	      if (!_this.props.disabled && _this.props.onClick) {
	        _this.props.onClick(_this.props.day);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Day, [{
	    key: 'dayStyle',
	    value: function dayStyle() {
	      if (this.props.day === 1) {
	        var e = this.props.sundayFirstDayOfWeek ? 0 : 1;
	        var firstDay = _time2.default.getFirstWeekDay(this.props.viewDate) - e;
	        return {
	          marginLeft: (firstDay >= 0 ? firstDay : 6) * (100 / 7) + '%'
	        };
	      }
	      return undefined;
	    }
	  }, {
	    key: 'isSelected',
	    value: function isSelected() {
	      var sameYear = this.props.viewDate.getFullYear() === this.props.selectedDate.getFullYear();
	      var sameMonth = this.props.viewDate.getMonth() === this.props.selectedDate.getMonth();
	      var sameDay = this.props.day === this.props.selectedDate.getDate();
	      return sameYear && sameMonth && sameDay;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var className = (0, _classnames3.default)(this.props.theme.day, (_classnames = {}, _defineProperty(_classnames, this.props.theme.active, this.isSelected()), _defineProperty(_classnames, this.props.theme.disabled, this.props.disabled), _classnames));
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'day', className: className, style: this.dayStyle() },
	        _react2.default.createElement(
	          'span',
	          { onClick: this.handleClick },
	          this.props.day
	        )
	      );
	    }
	  }]);
	
	  return Day;
	}(_react.Component);
	
	Day.propTypes = {
	  day: _propTypes2.default.number,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.instanceOf(Date),
	  sundayFirstDayOfWeek: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    active: _propTypes2.default.string,
	    day: _propTypes2.default.string,
	    disabled: _propTypes2.default.string
	  }),
	  viewDate: _propTypes2.default.instanceOf(Date)
	};
	exports.default = Day;

/***/ }),
/* 6335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(1645);
	
	var _time = __webpack_require__(750);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _CalendarDay = __webpack_require__(6334);
	
	var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Month = function (_Component) {
	  _inherits(Month, _Component);
	
	  function Month() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.handleDayClick = function (day) {
	      if (_this.props.onDayClick) _this.props.onDayClick(day);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Month, [{
	    key: 'isDayDisabled',
	    value: function isDayDisabled(date) {
	      var _props = this.props,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          enabledDates = _props.enabledDates,
	          disabledDates = _props.disabledDates;
	
	      var compareDate = function compareDate(compDate) {
	        return date.getTime() === compDate.getTime();
	      };
	      var dateInDisabled = disabledDates.filter(compareDate).length > 0;
	      var dateInEnabled = enabledDates.filter(compareDate).length > 0;
	      return _time2.default.dateOutOfRange(date, minDate, maxDate) || enabledDates.length > 0 && !dateInEnabled || dateInDisabled;
	    }
	  }, {
	    key: 'renderWeeks',
	    value: function renderWeeks() {
	      var _this2 = this;
	
	      var days = (0, _utils.range)(0, 7).map(function (d) {
	        return _time2.default.getDayOfWeekLetter(d, _this2.props.locale);
	      });
	      var source = this.props.sundayFirstDayOfWeek ? days : [].concat(_toConsumableArray(days.slice(1)), [days[0]]);
	      return source.map(function (day, i) {
	        return _react2.default.createElement(
	          'span',
	          { key: i },
	          day
	        );
	      }); // eslint-disable-line
	    }
	  }, {
	    key: 'renderDays',
	    value: function renderDays() {
	      var _this3 = this;
	
	      return (0, _utils.range)(1, _time2.default.getDaysInMonth(this.props.viewDate) + 1).map(function (i) {
	        var date = new Date(_this3.props.viewDate.getFullYear(), _this3.props.viewDate.getMonth(), i);
	        return _react2.default.createElement(_CalendarDay2.default, {
	          key: i,
	          day: i,
	          disabled: _this3.isDayDisabled(date),
	          onClick: _this3.handleDayClick,
	          selectedDate: _this3.props.selectedDate,
	          theme: _this3.props.theme,
	          viewDate: _this3.props.viewDate,
	          sundayFirstDayOfWeek: _this3.props.sundayFirstDayOfWeek
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var fullMonth = _time2.default.getFullMonth(this.props.viewDate, this.props.locale);
	      var fullYear = this.props.viewDate.getFullYear();
	      return _react2.default.createElement(
	        'div',
	        { 'data-react-toolbox': 'month', className: this.props.theme.month },
	        _react2.default.createElement(
	          'span',
	          { className: this.props.theme.title },
	          fullMonth,
	          ' ',
	          fullYear
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.theme.week },
	          this.renderWeeks()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: this.props.theme.days },
	          this.renderDays()
	        )
	      );
	    }
	  }]);
	
	  return Month;
	}(_react.Component);
	
	Month.propTypes = {
	  disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	  enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	  locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  maxDate: _propTypes2.default.instanceOf(Date),
	  minDate: _propTypes2.default.instanceOf(Date),
	  onDayClick: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.instanceOf(Date),
	  sundayFirstDayOfWeek: _propTypes2.default.bool,
	  theme: _propTypes2.default.shape({
	    days: _propTypes2.default.string,
	    month: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    week: _propTypes2.default.string
	  }),
	  viewDate: _propTypes2.default.instanceOf(Date)
	};
	Month.defaultProps = {
	  disabledDates: [],
	  enabledDates: []
	};
	exports.default = Month;

/***/ }),
/* 6336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DatePicker = exports.Calendar = exports.datePickerFactory = exports.DatePickerDialog = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(8);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	var _events = __webpack_require__(2840);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _time = __webpack_require__(750);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _IconButton = __webpack_require__(2832);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Input = __webpack_require__(2838);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Dialog = __webpack_require__(2837);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Calendar = __webpack_require__(2834);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _DatePickerDialog = __webpack_require__(2835);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var factory = function factory(Input, DatePickerDialog) {
	  var DatePicker = function (_Component) {
	    _inherits(DatePicker, _Component);
	
	    function DatePicker() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, DatePicker);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        active: _this.props.active
	      }, _this.handleDismiss = function () {
	        _this.setState({ active: false });
	        if (_this.props.onDismiss) {
	          _this.props.onDismiss();
	        }
	      }, _this.handleInputFocus = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: true });
	      }, _this.handleInputBlur = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: false });
	      }, _this.handleInputClick = function (event) {
	        _events2.default.pauseEvent(event);
	        _this.setState({ active: true });
	        if (_this.props.onClick) _this.props.onClick(event);
	      }, _this.handleInputKeyPress = function (event) {
	        if (event.charCode === 13) {
	          _events2.default.pauseEvent(event);
	          _this.setState({ active: true });
	        }
	        if (_this.props.onKeyPress) _this.props.onKeyPress(event);
	      }, _this.handleSelect = function (value, event) {
	        if (_this.props.onChange) _this.props.onChange(value, event);
	        _this.setState({ active: false });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(DatePicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (nextProps.active !== this.props.active && this.state.active !== nextProps.active) {
	          this.setState({ active: nextProps.active });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            active = _props.active,
	            onDismiss = _props.onDismiss,
	            autoOk = _props.autoOk,
	            cancelLabel = _props.cancelLabel,
	            enabledDates = _props.enabledDates,
	            disabledDates = _props.disabledDates,
	            inputClassName = _props.inputClassName,
	            inputFormat = _props.inputFormat,
	            locale = _props.locale,
	            maxDate = _props.maxDate,
	            minDate = _props.minDate,
	            okLabel = _props.okLabel,
	            onEscKeyDown = _props.onEscKeyDown,
	            onOverlayClick = _props.onOverlayClick,
	            readonly = _props.readonly,
	            sundayFirstDayOfWeek = _props.sundayFirstDayOfWeek,
	            value = _props.value,
	            others = _objectWithoutProperties(_props, ['active', 'onDismiss', 'autoOk', 'cancelLabel', 'enabledDates', 'disabledDates', 'inputClassName', 'inputFormat', 'locale', 'maxDate', 'minDate', 'okLabel', 'onEscKeyDown', 'onOverlayClick', 'readonly', 'sundayFirstDayOfWeek', 'value']);
	
	        var finalInputFormat = inputFormat || _time2.default.formatDate;
	        var date = Object.prototype.toString.call(value) === '[object Date]' ? value : undefined;
	        var formattedDate = date === undefined ? '' : finalInputFormat(value, locale);
	
	        return _react2.default.createElement(
	          'div',
	          { 'data-react-toolbox': 'date-picker', className: this.props.theme.container },
	          _react2.default.createElement(Input, _extends({}, others, {
	            className: (0, _classnames3.default)(this.props.theme.input, _defineProperty({}, inputClassName, inputClassName)),
	            disabled: readonly,
	            error: this.props.error,
	            icon: this.props.icon,
	            label: this.props.label,
	            name: this.props.name,
	            onFocus: this.handleInputFocus,
	            onKeyPress: this.handleInputKeyPress,
	            onClick: this.handleInputClick,
	            readOnly: true,
	            type: 'text',
	            value: formattedDate
	          })),
	          _react2.default.createElement(DatePickerDialog, {
	            active: this.state.active,
	            autoOk: autoOk,
	            cancelLabel: cancelLabel,
	            className: this.props.className,
	            disabledDates: disabledDates,
	            enabledDates: enabledDates,
	            locale: locale,
	            maxDate: maxDate,
	            minDate: minDate,
	            name: this.props.name,
	            onDismiss: this.handleDismiss,
	            okLabel: okLabel,
	            onEscKeyDown: onEscKeyDown || this.handleDismiss,
	            onOverlayClick: onOverlayClick || this.handleDismiss,
	            onSelect: this.handleSelect,
	            sundayFirstDayOfWeek: sundayFirstDayOfWeek,
	            theme: this.props.theme,
	            value: date
	          })
	        );
	      }
	    }]);
	
	    return DatePicker;
	  }(_react.Component);
	
	  DatePicker.propTypes = {
	    active: _propTypes2.default.bool,
	    autoOk: _propTypes2.default.bool,
	    cancelLabel: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    disabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    enabledDates: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date)),
	    error: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	    inputClassName: _propTypes2.default.string,
	    inputFormat: _propTypes2.default.func,
	    label: _propTypes2.default.string,
	    locale: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	    maxDate: _propTypes2.default.instanceOf(Date),
	    minDate: _propTypes2.default.instanceOf(Date),
	    name: _propTypes2.default.string,
	    okLabel: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onClick: _propTypes2.default.func,
	    onDismiss: _propTypes2.default.func,
	    onEscKeyDown: _propTypes2.default.func,
	    onKeyPress: _propTypes2.default.func,
	    onOverlayClick: _propTypes2.default.func,
	    readonly: _propTypes2.default.bool,
	    sundayFirstDayOfWeek: _propTypes2.default.bool,
	    theme: _propTypes2.default.shape({
	      container: _propTypes2.default.string,
	      input: _propTypes2.default.string
	    }),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.string])
	  };
	  DatePicker.defaultProps = {
	    active: false,
	    locale: 'en',
	    sundayFirstDayOfWeek: false
	  };
	
	
	  return DatePicker;
	};
	
	var Calendar = (0, _Calendar2.default)(_IconButton2.default);
	var DatePickerDialog = (0, _DatePickerDialog2.default)(_Dialog2.default, Calendar);
	var DatePicker = factory(_Input2.default, DatePickerDialog);
	
	exports.default = (0, _reactCssThemr.themr)(_identifiers.DATE_PICKER)(DatePicker);
	exports.DatePickerDialog = DatePickerDialog;
	exports.datePickerFactory = factory;
	exports.Calendar = Calendar;
	exports.DatePicker = DatePicker;

/***/ }),
/* 6337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dialog = undefined;
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	var _Dialog = __webpack_require__(2837);
	
	var _overlay = __webpack_require__(6341);
	
	var _button = __webpack_require__(2833);
	
	var _theme = __webpack_require__(5255);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dialog = (0, _Dialog.dialogFactory)(_overlay.Overlay, _button.Button);
	var ThemedDialog = (0, _reactCssThemr.themr)(_identifiers.DIALOG, _theme2.default)(Dialog);
	
	exports.default = ThemedDialog;
	exports.Dialog = ThemedDialog;

/***/ }),
/* 6338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivableRendererFactory = function ActivableRendererFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { delay: 500 };
	  return function (ActivableComponent) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_Component) {
	      _inherits(ActivableRenderer, _Component);
	
	      function ActivableRenderer() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ActivableRenderer);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivableRenderer.__proto__ || Object.getPrototypeOf(ActivableRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          active: _this.props.active,
	          rendered: _this.props.active
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      _createClass(ActivableRenderer, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          if (nextProps.active && !this.props.active) this.renderAndActivate();
	          if (!nextProps.active && this.props.active) this.deactivateAndUnrender();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.activateTimeout);
	          clearTimeout(this.unrenderTimeout);
	        }
	      }, {
	        key: 'deactivateAndUnrender',
	        value: function deactivateAndUnrender() {
	          var _this2 = this;
	
	          this.setState({ rendered: true, active: false }, function () {
	            _this2.unrenderTimeout = setTimeout(function () {
	              _this2.setState({ rendered: false });
	              _this2.unrenderTimeout = null;
	            }, _this2.props.delay);
	          });
	        }
	      }, {
	        key: 'renderAndActivate',
	        value: function renderAndActivate() {
	          var _this3 = this;
	
	          if (this.unrenderTimeout) clearTimeout(this.unrenderTimeout);
	          this.setState({ rendered: true, active: false }, function () {
	            _this3.activateTimeout = setTimeout(function () {
	              return _this3.setState({ active: true });
	            }, 20);
	          });
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              delay = _props.delay,
	              others = _objectWithoutProperties(_props, ['delay']); // eslint-disable-line no-unused-vars
	
	
	          var _state = this.state,
	              active = _state.active,
	              rendered = _state.rendered;
	
	          return rendered ? _react2.default.createElement(ActivableComponent, _extends({}, others, { active: active })) : null;
	        }
	      }]);
	
	      return ActivableRenderer;
	    }(_react.Component), _class.propTypes = {
	      active: _propTypes2.default.bool.isRequired,
	      children: _propTypes2.default.node,
	      delay: _propTypes2.default.number
	    }, _class.defaultProps = {
	      delay: options.delay
	    }, _temp2;
	  };
	};
	
	exports.default = ActivableRendererFactory;

/***/ }),
/* 6339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactStyleProptype = __webpack_require__(6297);
	
	var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_Component) {
	  _inherits(Portal, _Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._renderOverlay();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this._overlayTarget && nextProps.container !== this.props.container) {
	        this._portalContainerNode.removeChild(this._overlayTarget);
	        this._portalContainerNode = getContainer(nextProps.container);
	        this._portalContainerNode.appendChild(this._overlayTarget);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._renderOverlay();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._unrenderOverlay();
	      this._unmountOverlayTarget();
	    }
	  }, {
	    key: 'getMountNode',
	    value: function getMountNode() {
	      return this._overlayTarget;
	    }
	  }, {
	    key: 'getOverlayDOMNode',
	    value: function getOverlayDOMNode() {
	      if (!this.isMounted()) {
	        // eslint-disable-line
	        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	      }
	
	      if (this._overlayInstance) {
	        if (this._overlayInstance.getWrappedDOMNode) {
	          return this._overlayInstance.getWrappedDOMNode();
	        }
	        return _reactDom2.default.findDOMNode(this._overlayInstance);
	      }
	
	      return null;
	    }
	  }, {
	    key: '_getOverlay',
	    value: function _getOverlay() {
	      if (!this.props.children) return null;
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className, style: this.props.style },
	        this.props.children
	      );
	    }
	  }, {
	    key: '_renderOverlay',
	    value: function _renderOverlay() {
	      var overlay = this._getOverlay();
	      if (overlay !== null) {
	        this._mountOverlayTarget();
	        this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, overlay, this._overlayTarget);
	      } else {
	        this._unrenderOverlay();
	        this._unmountOverlayTarget();
	      }
	    }
	  }, {
	    key: '_unrenderOverlay',
	    value: function _unrenderOverlay() {
	      if (this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(this._overlayTarget);
	        this._overlayInstance = null;
	      }
	    }
	  }, {
	    key: '_mountOverlayTarget',
	    value: function _mountOverlayTarget() {
	      if (!this._overlayTarget) {
	        this._overlayTarget = document.createElement('div');
	        this._portalContainerNode = getContainer(this.props.container);
	        this._portalContainerNode.appendChild(this._overlayTarget);
	      }
	    }
	  }, {
	    key: '_unmountOverlayTarget',
	    value: function _unmountOverlayTarget() {
	      if (this._overlayTarget) {
	        this._portalContainerNode.removeChild(this._overlayTarget);
	        this._overlayTarget = null;
	      }
	      this._portalContainerNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  container: _propTypes2.default.node,
	  style: _reactStyleProptype2.default
	};
	Portal.defaultProps = {
	  className: ''
	};
	
	
	function getContainer(container) {
	  var _container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(_container) || document.body;
	}
	
	exports.default = Portal;

/***/ }),
/* 6340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Input = undefined;
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	var _Input = __webpack_require__(2838);
	
	var _FontIcon = __webpack_require__(592);
	
	var _theme = __webpack_require__(5256);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Input = (0, _Input.inputFactory)(_FontIcon.FontIcon);
	var ThemedInput = (0, _reactCssThemr.themr)(_identifiers.INPUT, _theme2.default, { withRef: true })(Input);
	
	exports.default = ThemedInput;
	exports.Input = ThemedInput;

/***/ }),
/* 6341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Overlay = undefined;
	
	var _reactCssThemr = __webpack_require__(178);
	
	var _identifiers = __webpack_require__(212);
	
	var _Overlay = __webpack_require__(2839);
	
	var _theme = __webpack_require__(5257);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThemedOverlay = (0, _reactCssThemr.themr)(_identifiers.OVERLAY, _theme2.default)(_Overlay.Overlay);
	exports.default = ThemedOverlay;
	exports.Overlay = ThemedOverlay;

/***/ }),
/* 6342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Ripple = __webpack_require__(1046);
	
	var _Ripple2 = _interopRequireDefault(_Ripple);
	
	var _theme = __webpack_require__(5258);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (options) {
	  return (0, _Ripple2.default)(_extends({}, options, { theme: _theme2.default }));
	};

/***/ }),
/* 6343 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasOwnProperty;
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

/***/ }),
/* 6344 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var WEBKIT = 'Webkit';
	var MICROSOFT = 'Ms';
	
	var properties = {
	  transform: [WEBKIT, MICROSOFT]
	};
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.substr(1);
	}
	
	function getPrefixes(property, value) {
	  return properties[property].reduce(function (acc, item) {
	    acc['' + item + capitalize(property)] = value; // eslint-disable-line no-param-reassign
	    return acc;
	  }, {});
	}
	
	function addPrefixesTo(style, property, value) {
	  var vendor = getPrefixes(property, value);
	  for (var prefix in vendor) {
	    // eslint-disable-line no-restricted-syntax
	    if ({}.hasOwnProperty.call(vendor, prefix)) {
	      style[prefix] = vendor[prefix]; // eslint-disable-line no-param-reassign
	    }
	  }
	
	  return style;
	}
	
	function prefixer(style) {
	  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var _style = defaultValue;
	  for (var property in style) {
	    // eslint-disable-line no-restricted-syntax
	    if ({}.hasOwnProperty.call(style, property)) {
	      _style[property] = style[property];
	      if (properties[property]) {
	        addPrefixesTo(_style, property, style[property]);
	      }
	    }
	  }
	
	  return _style;
	}
	
	exports.default = prefixer;

/***/ }),
/* 6345 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry3 = __webpack_require__(1646);
	
	
	/**
	 * Makes a shallow clone of an object, setting or overriding the specified
	 * property with the given value. Note that this copies and flattens prototype
	 * properties onto the new object as well. All non-primitive properties are
	 * copied by reference.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig String -> a -> {k: v} -> {k: v}
	 * @param {String} prop The property name to set
	 * @param {*} val The new value
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original except for the changed property.
	 * @see R.dissoc
	 * @example
	 *
	 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
	 */
	module.exports = _curry3(function assoc(prop, val, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  result[prop] = val;
	  return result;
	});


/***/ }),
/* 6346 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(2841);
	var _curry2 = __webpack_require__(1047);
	
	
	/**
	 * Creates a function that is bound to a context.
	 * Note: `R.bind` does not provide the additional argument-binding capabilities of
	 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	 *
	 * @func
	 * @memberOf R
	 * @since v0.6.0
	 * @category Function
	 * @category Object
	 * @sig (* -> *) -> {*} -> (* -> *)
	 * @param {Function} fn The function to bind to context
	 * @param {Object} thisObj The context to bind `fn` to
	 * @return {Function} A function that will execute in the context of `thisObj`.
	 * @see R.partial
	 * @example
	 *
	 *      var log = R.bind(console.log, console);
	 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
	 *      // logs {a: 2}
	 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
	 */
	module.exports = _curry2(function bind(fn, thisObj) {
	  return _arity(fn.length, function() {
	    return fn.apply(thisObj, arguments);
	  });
	});


/***/ }),
/* 6347 */
/***/ (function(module, exports, __webpack_require__) {

	var pipe = __webpack_require__(6355);
	var reverse = __webpack_require__(6356);
	
	
	/**
	 * Performs right-to-left function composition. The rightmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * **Note:** The result of compose is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} ...functions The functions to compose
	 * @return {Function}
	 * @see R.pipe
	 * @example
	 *
	 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
	 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
	 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
	 *
	 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
	 *
	 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
	 */
	module.exports = function compose() {
	  if (arguments.length === 0) {
	    throw new Error('compose requires at least one argument');
	  }
	  return pipe.apply(this, reverse(arguments));
	};


/***/ }),
/* 6348 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1047);
	
	
	/**
	 * Returns a new object that does not contain a `prop` property.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.10.0
	 * @category Object
	 * @sig String -> {k: v} -> {k: v}
	 * @param {String} prop The name of the property to dissociate
	 * @param {Object} obj The object to clone
	 * @return {Object} A new object equivalent to the original but without the specified property
	 * @see R.assoc
	 * @example
	 *
	 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
	 */
	module.exports = _curry2(function dissoc(prop, obj) {
	  var result = {};
	  for (var p in obj) {
	    result[p] = obj[p];
	  }
	  delete result[prop];
	  return result;
	});


/***/ }),
/* 6349 */
/***/ (function(module, exports, __webpack_require__) {

	var _has = __webpack_require__(2843);
	
	
	module.exports = (function() {
	  var toString = Object.prototype.toString;
	  return toString.call(arguments) === '[object Arguments]' ?
	    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
	    function _isArguments(x) { return _has('callee', x); };
	}());


/***/ }),
/* 6350 */
/***/ (function(module, exports) {

	module.exports = function _pipe(f, g) {
	  return function() {
	    return g.call(this, f.apply(this, arguments));
	  };
	};


/***/ }),
/* 6351 */
/***/ (function(module, exports, __webpack_require__) {

	var _xwrap = __webpack_require__(6352);
	var bind = __webpack_require__(6346);
	var isArrayLike = __webpack_require__(6353);
	
	
	module.exports = (function() {
	  function _arrayReduce(xf, acc, list) {
	    var idx = 0;
	    var len = list.length;
	    while (idx < len) {
	      acc = xf['@@transducer/step'](acc, list[idx]);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      idx += 1;
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _iterableReduce(xf, acc, iter) {
	    var step = iter.next();
	    while (!step.done) {
	      acc = xf['@@transducer/step'](acc, step.value);
	      if (acc && acc['@@transducer/reduced']) {
	        acc = acc['@@transducer/value'];
	        break;
	      }
	      step = iter.next();
	    }
	    return xf['@@transducer/result'](acc);
	  }
	
	  function _methodReduce(xf, acc, obj) {
	    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
	  }
	
	  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
	  return function _reduce(fn, acc, list) {
	    if (typeof fn === 'function') {
	      fn = _xwrap(fn);
	    }
	    if (isArrayLike(list)) {
	      return _arrayReduce(fn, acc, list);
	    }
	    if (typeof list.reduce === 'function') {
	      return _methodReduce(fn, acc, list);
	    }
	    if (list[symIterator] != null) {
	      return _iterableReduce(fn, acc, list[symIterator]());
	    }
	    if (typeof list.next === 'function') {
	      return _iterableReduce(fn, acc, list);
	    }
	    throw new TypeError('reduce: list must be array or iterable');
	  };
	}());


/***/ }),
/* 6352 */
/***/ (function(module, exports) {

	module.exports = (function() {
	  function XWrap(fn) {
	    this.f = fn;
	  }
	  XWrap.prototype['@@transducer/init'] = function() {
	    throw new Error('init not implemented on XWrap');
	  };
	  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
	  XWrap.prototype['@@transducer/step'] = function(acc, x) {
	    return this.f(acc, x);
	  };
	
	  return function _xwrap(fn) { return new XWrap(fn); };
	}());


/***/ }),
/* 6353 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(593);
	var _isArray = __webpack_require__(2844);
	var _isString = __webpack_require__(2845);
	
	
	/**
	 * Tests whether or not an object is similar to an array.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.5.0
	 * @category Type
	 * @category List
	 * @sig * -> Boolean
	 * @param {*} x The object to test.
	 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
	 * @deprecated since v0.23.0
	 * @example
	 *
	 *      R.isArrayLike([]); //=> true
	 *      R.isArrayLike(true); //=> false
	 *      R.isArrayLike({}); //=> false
	 *      R.isArrayLike({length: 10}); //=> false
	 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
	 */
	module.exports = _curry1(function isArrayLike(x) {
	  if (_isArray(x)) { return true; }
	  if (!x) { return false; }
	  if (typeof x !== 'object') { return false; }
	  if (_isString(x)) { return false; }
	  if (x.nodeType === 1) { return !!x.length; }
	  if (x.length === 0) { return true; }
	  if (x.length > 0) {
	    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
	  }
	  return false;
	});


/***/ }),
/* 6354 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry2 = __webpack_require__(1047);
	
	
	/**
	 * Returns a partial copy of an object containing only the keys that satisfy
	 * the supplied predicate.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.8.0
	 * @category Object
	 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
	 * @param {Function} pred A predicate to determine whether or not a key
	 *        should be included on the output object.
	 * @param {Object} obj The object to copy from
	 * @return {Object} A new object with only properties that satisfy `pred`
	 *         on it.
	 * @see R.pick, R.filter
	 * @example
	 *
	 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
	 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
	 */
	module.exports = _curry2(function pickBy(test, obj) {
	  var result = {};
	  for (var prop in obj) {
	    if (test(obj[prop], prop, obj)) {
	      result[prop] = obj[prop];
	    }
	  }
	  return result;
	});


/***/ }),
/* 6355 */
/***/ (function(module, exports, __webpack_require__) {

	var _arity = __webpack_require__(2841);
	var _pipe = __webpack_require__(6350);
	var reduce = __webpack_require__(2847);
	var tail = __webpack_require__(6358);
	
	
	/**
	 * Performs left-to-right function composition. The leftmost function may have
	 * any arity; the remaining functions must be unary.
	 *
	 * In some libraries this function is named `sequence`.
	 *
	 * **Note:** The result of pipe is not automatically curried.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category Function
	 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
	 * @param {...Function} functions
	 * @return {Function}
	 * @see R.compose
	 * @example
	 *
	 *      var f = R.pipe(Math.pow, R.negate, R.inc);
	 *
	 *      f(3, 4); // -(3^4) + 1
	 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
	 */
	module.exports = function pipe() {
	  if (arguments.length === 0) {
	    throw new Error('pipe requires at least one argument');
	  }
	  return _arity(arguments[0].length,
	                reduce(_pipe, arguments[0], tail(arguments)));
	};


/***/ }),
/* 6356 */
/***/ (function(module, exports, __webpack_require__) {

	var _curry1 = __webpack_require__(593);
	var _isString = __webpack_require__(2845);
	
	
	/**
	 * Returns a new list or string with the elements or characters in reverse
	 * order.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {Array|String} list
	 * @return {Array|String}
	 * @example
	 *
	 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
	 *      R.reverse([1, 2]);     //=> [2, 1]
	 *      R.reverse([1]);        //=> [1]
	 *      R.reverse([]);         //=> []
	 *
	 *      R.reverse('abc');      //=> 'cba'
	 *      R.reverse('ab');       //=> 'ba'
	 *      R.reverse('a');        //=> 'a'
	 *      R.reverse('');         //=> ''
	 */
	module.exports = _curry1(function reverse(list) {
	  return _isString(list) ? list.split('').reverse().join('') :
	                           Array.prototype.slice.call(list, 0).reverse();
	});


/***/ }),
/* 6357 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(2842);
	var _curry3 = __webpack_require__(1646);
	
	
	/**
	 * Returns the elements of the given list or string (or object with a `slice`
	 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
	 *
	 * Dispatches to the `slice` method of the third argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.4
	 * @category List
	 * @sig Number -> Number -> [a] -> [a]
	 * @sig Number -> Number -> String -> String
	 * @param {Number} fromIndex The start index (inclusive).
	 * @param {Number} toIndex The end index (exclusive).
	 * @param {*} list
	 * @return {*}
	 * @example
	 *
	 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
	 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
	 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
	 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
	 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
	 */
	module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
	  return Array.prototype.slice.call(list, fromIndex, toIndex);
	}));


/***/ }),
/* 6358 */
/***/ (function(module, exports, __webpack_require__) {

	var _checkForMethod = __webpack_require__(2842);
	var _curry1 = __webpack_require__(593);
	var slice = __webpack_require__(6357);
	
	
	/**
	 * Returns all but the first element of the given list or string (or object
	 * with a `tail` method).
	 *
	 * Dispatches to the `slice` method of the first argument, if present.
	 *
	 * @func
	 * @memberOf R
	 * @since v0.1.0
	 * @category List
	 * @sig [a] -> [a]
	 * @sig String -> String
	 * @param {*} list
	 * @return {*}
	 * @see R.head, R.init, R.last
	 * @example
	 *
	 *      R.tail([1, 2, 3]);  //=> [2, 3]
	 *      R.tail([1, 2]);     //=> [2]
	 *      R.tail([1]);        //=> []
	 *      R.tail([]);         //=> []
	 *
	 *      R.tail('abc');  //=> 'bc'
	 *      R.tail('ab');   //=> 'b'
	 *      R.tail('a');    //=> ''
	 *      R.tail('');     //=> ''
	 */
	module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ }),
/* 6359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _addClass = __webpack_require__(4874);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(4876);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(6360);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PropTypes = __webpack_require__(2848);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	var removeClass = function removeClass(node, classes) {
	  return classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass2.default)(node, c);
	  });
	};
	
	var propTypes = _extends({}, _Transition2.default.propTypes, {
	
	  /**
	   * The animation classNames applied to the component as it enters or exits.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   * }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** from the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	});
	
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 *
	 * ```js
	 * import CSSTransition from 'react-transition-group/CSSTransition';
	 *
	 * const Fade = ({ children, ...props }) => (
	 *  <CSSTransition
	 *    {...props}
	 *    timeout={500}
	 *    classNames="fade"
	 *  >
	 *   {children}
	 *  </CSSTransition>
	 * );
	 *
	 * class FadeInAndOut extends React.Component {
	 *   constructor(...args) {
	 *     super(...args);
	 *     this.state= { show: false }
	 *
	 *     setInterval(() => {
	 *       this.setState({ show: !this.state.show })
	 *     }, 5000)
	 *   }
	 *   render() {
	 *     return (
	 *       <Fade in={this.state.show}>
	 *         <div>Hello world</div>
	 *       </Fade>
	 *     )
	 *   }
	 * }
	 * ```
	 *
	 * And the coorresponding CSS for the `<Fade>` component:
	 *
	 * ```css
	 * .fade-enter {
	 *   opacity: 0.01;
	 * }
	 *
	 * .fade-enter.fade-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 500ms ease-in;
	 * }
	 *
	 * .fade-exit {
	 *   opacity: 1;
	 * }
	 *
	 * .fade-exit.fade-exit-active {
	 *   opacity: 0.01;
	 *   transition: opacity 300ms ease-in;
	 * }
	 * ```
	 */
	
	var CSSTransition = function (_React$Component) {
	  _inherits(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.onEntered = function (node, appearing) {
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	      _this.removeClasses(node, 'enter');
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	
	
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	
	      return { className: className, activeClassName: activeClassName };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
	    var _getClassNames = this.getClassNames(type),
	        className = _getClassNames.className,
	        activeClassName = _getClassNames.activeClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	  };
	
	  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    /* eslint-disable no-unused-expressions */
	    node.scrollTop;
	    /* eslint-enable no-unused-expressions */
	    addClass(node, className);
	  };
	
	  CSSTransition.prototype.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	
	    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react2.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransition;
	module.exports = exports['default'];

/***/ }),
/* 6360 */
[6720, 2848],
/* 6361 */
[6721, 6362],
/* 6362 */
5667,
/* 6363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(594));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(6367));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(6369));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(1648));
	
	var _PropTypes = __webpack_require__(2852);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (node, appearing) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    if (type === 'appear' && phase === 'done') {
	      className += " " + this.getClassNames('enter').doneClassName;
	    } // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	    }
	
	    this.appliedClasses[type][phase] = className;
	
	    _addClass(node, className);
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 6364 */
[6833, 594, 2849],
/* 6365 */
[6837, 594, 1648, 1649],
/* 6366 */
6211,
/* 6367 */
[6832, 6370, 6368],
/* 6368 */
6204,
/* 6369 */
4876,
/* 6370 */
1015,
/* 6371 */
[6835, 6372],
/* 6372 */
6261,
/* 6373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_RenderedSection = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_RenderedSection || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_ScrollIndices = __webpack_require__(6375).babelPluginFlowReactPropTypes_proptype_ScrollIndices || __webpack_require__(2).any;
	
	/**
	 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
	 */
	
	var ArrowKeyStepper = function (_React$PureComponent) {
	  (0, _inherits3.default)(ArrowKeyStepper, _React$PureComponent);
	
	  function ArrowKeyStepper(props) {
	    (0, _classCallCheck3.default)(this, ArrowKeyStepper);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ArrowKeyStepper.__proto__ || (0, _getPrototypeOf2.default)(ArrowKeyStepper)).call(this, props));
	
	    _this._columnStartIndex = 0;
	    _this._columnStopIndex = 0;
	    _this._rowStartIndex = 0;
	    _this._rowStopIndex = 0;
	
	    _this._onKeyDown = function (event) {
	      var _this$props = _this.props,
	          columnCount = _this$props.columnCount,
	          disabled = _this$props.disabled,
	          mode = _this$props.mode,
	          rowCount = _this$props.rowCount;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var _this$_getScrollState = _this._getScrollState(),
	          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
	          scrollToRowPrevious = _this$_getScrollState.scrollToRow;
	
	      var _this$_getScrollState2 = _this._getScrollState(),
	          scrollToColumn = _this$_getScrollState2.scrollToColumn,
	          scrollToRow = _this$_getScrollState2.scrollToRow;
	
	      // The above cases all prevent default event event behavior.
	      // This is to keep the grid from scrolling after the snap-to update.
	
	
	      switch (event.key) {
	        case 'ArrowDown':
	          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
	          break;
	        case 'ArrowLeft':
	          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
	          break;
	        case 'ArrowRight':
	          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
	          break;
	        case 'ArrowUp':
	          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
	          break;
	      }
	
	      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
	        event.preventDefault();
	
	        _this._updateScrollState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
	      }
	    };
	
	    _this._onSectionRendered = function (_ref) {
	      var columnStartIndex = _ref.columnStartIndex,
	          columnStopIndex = _ref.columnStopIndex,
	          rowStartIndex = _ref.rowStartIndex,
	          rowStopIndex = _ref.rowStopIndex;
	
	      _this._columnStartIndex = columnStartIndex;
	      _this._columnStopIndex = columnStopIndex;
	      _this._rowStartIndex = rowStartIndex;
	      _this._rowStopIndex = rowStopIndex;
	    };
	
	    _this.state = {
	      scrollToColumn: props.scrollToColumn,
	      scrollToRow: props.scrollToRow
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ArrowKeyStepper, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.isControlled) {
	        return;
	      }
	
	      var scrollToColumn = nextProps.scrollToColumn,
	          scrollToRow = nextProps.scrollToRow;
	      var _props = this.props,
	          prevScrollToColumn = _props.scrollToColumn,
	          prevScrollToRow = _props.scrollToRow;
	
	
	      if (prevScrollToColumn !== scrollToColumn && prevScrollToRow !== scrollToRow) {
	        this.setState({
	          scrollToColumn: scrollToColumn,
	          scrollToRow: scrollToRow
	        });
	      } else if (prevScrollToColumn !== scrollToColumn) {
	        this.setState({ scrollToColumn: scrollToColumn });
	      } else if (prevScrollToRow !== scrollToRow) {
	        this.setState({ scrollToRow: scrollToRow });
	      }
	    }
	  }, {
	    key: 'setScrollIndexes',
	    value: function setScrollIndexes(_ref2) {
	      var scrollToColumn = _ref2.scrollToColumn,
	          scrollToRow = _ref2.scrollToRow;
	
	      this.setState({
	        scrollToRow: scrollToRow,
	        scrollToColumn: scrollToColumn
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          children = _props2.children;
	
	      var _getScrollState2 = this._getScrollState(),
	          scrollToColumn = _getScrollState2.scrollToColumn,
	          scrollToRow = _getScrollState2.scrollToRow;
	
	      return React.createElement(
	        'div',
	        { className: className, onKeyDown: this._onKeyDown },
	        children({
	          onSectionRendered: this._onSectionRendered,
	          scrollToColumn: scrollToColumn,
	          scrollToRow: scrollToRow
	        })
	      );
	    }
	  }, {
	    key: '_getScrollState',
	    value: function _getScrollState() {
	      return this.props.isControlled ? this.props : this.state;
	    }
	  }, {
	    key: '_updateScrollState',
	    value: function _updateScrollState(_ref3) {
	      var scrollToColumn = _ref3.scrollToColumn,
	          scrollToRow = _ref3.scrollToRow;
	      var _props3 = this.props,
	          isControlled = _props3.isControlled,
	          onScrollToChange = _props3.onScrollToChange;
	
	
	      if (typeof onScrollToChange === 'function') {
	        onScrollToChange({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
	      }
	
	      if (!isControlled) {
	        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
	      }
	    }
	  }]);
	  return ArrowKeyStepper;
	}(React.PureComponent);
	
	ArrowKeyStepper.defaultProps = {
	  disabled: false,
	  isControlled: false,
	  mode: 'edges',
	  scrollToColumn: 0,
	  scrollToRow: 0
	};
	ArrowKeyStepper.propTypes =  true ? null : {
	  children: require('prop-types').func.isRequired,
	  className: require('prop-types').string,
	  columnCount: require('prop-types').number.isRequired,
	  disabled: require('prop-types').bool.isRequired,
	  isControlled: require('prop-types').bool.isRequired,
	  mode: require('prop-types').oneOf(['cells', 'edges']).isRequired,
	  onScrollToChange: require('prop-types').func,
	  rowCount: require('prop-types').number.isRequired,
	  scrollToColumn: require('prop-types').number.isRequired,
	  scrollToRow: require('prop-types').number.isRequired
	};
	exports.default = ArrowKeyStepper;

/***/ }),
/* 6374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ArrowKeyStepper = __webpack_require__(6373);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ArrowKeyStepper).default;
	  }
	});
	Object.defineProperty(exports, 'ArrowKeyStepper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ArrowKeyStepper).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 6375 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var babelPluginFlowReactPropTypes_proptype_ScrollIndices =  true ? null : {
	  scrollToColumn: require("prop-types").number.isRequired,
	  scrollToRow: require("prop-types").number.isRequired
	};
	if (false) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_ScrollIndices", {
	  value: babelPluginFlowReactPropTypes_proptype_ScrollIndices,
	  configurable: true
	});

/***/ }),
/* 6376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _detectElementResize = __webpack_require__(2865);
	
	var _detectElementResize2 = _interopRequireDefault(_detectElementResize);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AutoSizer = function (_React$PureComponent) {
	  (0, _inherits3.default)(AutoSizer, _React$PureComponent);
	
	  function AutoSizer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoSizer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoSizer.__proto__ || (0, _getPrototypeOf2.default)(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: _this.props.defaultHeight || 0,
	      width: _this.props.defaultWidth || 0
	    }, _this._onResize = function () {
	      var _this$props = _this.props,
	          disableHeight = _this$props.disableHeight,
	          disableWidth = _this$props.disableWidth,
	          onResize = _this$props.onResize;
	
	
	      if (_this._parentNode) {
	        // Guard against AutoSizer component being removed from the DOM immediately after being added.
	        // This can result in invalid style values which can result in NaN values if we don't handle them.
	        // See issue #150 for more context.
	
	        var _height = _this._parentNode.offsetHeight || 0;
	        var _width = _this._parentNode.offsetWidth || 0;
	
	        var _style = window.getComputedStyle(_this._parentNode) || {};
	        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
	        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
	        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
	        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
	
	        var newHeight = _height - paddingTop - paddingBottom;
	        var newWidth = _width - paddingLeft - paddingRight;
	
	        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
	          _this.setState({
	            height: _height - paddingTop - paddingBottom,
	            width: _width - paddingLeft - paddingRight
	          });
	
	          onResize({ height: _height, width: _width });
	        }
	      }
	    }, _this._setRef = function (autoSizer) {
	      _this._autoSizer = autoSizer;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoSizer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var nonce = this.props.nonce;
	
	      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
	        // Delay access of parentNode until mount.
	        // This handles edge-cases where the component has already been unmounted before its ref has been set,
	        // As well as libraries like react-lite which have a slightly different lifecycle.
	        this._parentNode = this._autoSizer.parentNode;
	
	        // Defer requiring resize handler in order to support server-side rendering.
	        // See issue #41
	        this._detectElementResize = (0, _detectElementResize2.default)(nonce);
	        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
	
	        this._onResize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._detectElementResize && this._parentNode) {
	        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          disableHeight = _props.disableHeight,
	          disableWidth = _props.disableWidth,
	          style = _props.style;
	      var _state = this.state,
	          height = _state.height,
	          width = _state.width;
	
	      // Outer div should not force width/height since that may prevent containers from shrinking.
	      // Inner component should overflow and use calculated width/height.
	      // See issue #68 for more information.
	
	      var outerStyle = { overflow: 'visible' };
	      var childParams = {};
	
	      if (!disableHeight) {
	        outerStyle.height = 0;
	        childParams.height = height;
	      }
	
	      if (!disableWidth) {
	        outerStyle.width = 0;
	        childParams.width = width;
	      }
	
	      /**
	       * TODO: Avoid rendering children before the initial measurements have been collected.
	       * At best this would just be wasting cycles.
	       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
	       * Note that if default width/height props were provided this would still work with SSR.
	      if (
	        height !== 0 &&
	        width !== 0
	      ) {
	        child = children({ height, width })
	      }
	      */
	
	      return React.createElement(
	        'div',
	        {
	          className: className,
	          ref: this._setRef,
	          style: (0, _extends3.default)({}, outerStyle, style) },
	        children(childParams)
	      );
	    }
	  }]);
	  return AutoSizer;
	}(React.PureComponent);
	
	AutoSizer.defaultProps = {
	  onResize: function onResize() {},
	  disableHeight: false,
	  disableWidth: false,
	  style: {}
	};
	AutoSizer.propTypes =  true ? null : {
	  /** Function responsible for rendering children.*/
	  children: require('prop-types').func.isRequired,
	
	
	  /** Optional custom CSS class name to attach to root AutoSizer element.  */
	  className: require('prop-types').string,
	
	
	  /** Default height to use for initial render; useful for SSR */
	  defaultHeight: require('prop-types').number,
	
	
	  /** Default width to use for initial render; useful for SSR */
	  defaultWidth: require('prop-types').number,
	
	
	  /** Disable dynamic :height property */
	  disableHeight: require('prop-types').bool.isRequired,
	
	
	  /** Disable dynamic :width property */
	  disableWidth: require('prop-types').bool.isRequired,
	
	
	  /** Nonce of the inlined stylesheet for Content Security Policy */
	  nonce: require('prop-types').string,
	
	
	  /** Callback to be invoked on-resize */
	  onResize: require('prop-types').func.isRequired,
	
	
	  /** Optional inline style */
	  style: require('prop-types').object
	};
	exports.default = AutoSizer;

/***/ }),
/* 6377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AutoSizer = __webpack_require__(6376);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoSizer).default;
	  }
	});
	Object.defineProperty(exports, 'AutoSizer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AutoSizer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 6378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _CellMeasurerCache = __webpack_require__(2853);
	
	var _CellMeasurerCache2 = _interopRequireDefault(_CellMeasurerCache);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Wraps a cell and measures its rendered content.
	 * Measurements are stored in a per-cell cache.
	 * Cached-content is not be re-measured.
	 */
	var CellMeasurer = function (_React$PureComponent) {
	  (0, _inherits3.default)(CellMeasurer, _React$PureComponent);
	
	  function CellMeasurer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CellMeasurer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CellMeasurer.__proto__ || (0, _getPrototypeOf2.default)(CellMeasurer)).call.apply(_ref, [this].concat(args))), _this), _this._measure = function () {
	      var _this$props = _this.props,
	          cache = _this$props.cache,
	          _this$props$columnInd = _this$props.columnIndex,
	          columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd,
	          parent = _this$props.parent,
	          _this$props$rowIndex = _this$props.rowIndex,
	          rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;
	
	      var _this$_getCellMeasure = _this._getCellMeasurements(),
	          height = _this$_getCellMeasure.height,
	          width = _this$_getCellMeasure.width;
	
	      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
	        cache.set(rowIndex, columnIndex, width, height);
	
	        if (parent && typeof parent.recomputeGridSize === 'function') {
	          parent.recomputeGridSize({
	            columnIndex: columnIndex,
	            rowIndex: rowIndex
	          });
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CellMeasurer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._maybeMeasureCell();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._maybeMeasureCell();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return typeof children === 'function' ? children({ measure: this._measure }) : children;
	    }
	  }, {
	    key: '_getCellMeasurements',
	    value: function _getCellMeasurements() {
	      var cache = this.props.cache;
	
	
	      var node = (0, _reactDom.findDOMNode)(this);
	
	      // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
	
	      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
	        var styleWidth = node.style.width;
	        var styleHeight = node.style.height;
	
	        // If we are re-measuring a cell that has already been measured,
	        // It will have a hard-coded width/height from the previous measurement.
	        // The fact that we are measuring indicates this measurement is probably stale,
	        // So explicitly clear it out (eg set to "auto") so we can recalculate.
	        // See issue #593 for more info.
	        // Even if we are measuring initially- if we're inside of a MultiGrid component,
	        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
	        // eg top/left Grid renders before bottom/right Grid
	        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
	        if (!cache.hasFixedWidth()) {
	          node.style.width = 'auto';
	        }
	        if (!cache.hasFixedHeight()) {
	          node.style.height = 'auto';
	        }
	
	        var height = Math.ceil(node.offsetHeight);
	        var width = Math.ceil(node.offsetWidth);
	
	        // Reset after measuring to avoid breaking styles; see #660
	        if (styleWidth) {
	          node.style.width = styleWidth;
	        }
	        if (styleHeight) {
	          node.style.height = styleHeight;
	        }
	
	        return { height: height, width: width };
	      } else {
	        return { height: 0, width: 0 };
	      }
	    }
	  }, {
	    key: '_maybeMeasureCell',
	    value: function _maybeMeasureCell() {
	      var _props = this.props,
	          cache = _props.cache,
	          _props$columnIndex = _props.columnIndex,
	          columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex,
	          parent = _props.parent,
	          _props$rowIndex = _props.rowIndex,
	          rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;
	
	
	      if (!cache.has(rowIndex, columnIndex)) {
	        var _getCellMeasurements2 = this._getCellMeasurements(),
	            height = _getCellMeasurements2.height,
	            width = _getCellMeasurements2.width;
	
	        cache.set(rowIndex, columnIndex, width, height);
	
	        // If size has changed, let Grid know to re-render.
	        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
	          parent.invalidateCellSizeAfterRender({
	            columnIndex: columnIndex,
	            rowIndex: rowIndex
	          });
	        }
	      }
	    }
	  }]);
	  return CellMeasurer;
	}(React.PureComponent);
	
	// Used for DEV mode warning check
	
	
	CellMeasurer.__internalCellMeasurerFlag = false;
	CellMeasurer.propTypes =  true ? null : {
	  cache: typeof _CellMeasurerCache2.default === 'function' ? require('prop-types').instanceOf(_CellMeasurerCache2.default).isRequired : require('prop-types').any.isRequired,
	  children: require('prop-types').oneOfType([require('prop-types').func, require('prop-types').node]).isRequired,
	  columnIndex: require('prop-types').number,
	  index: require('prop-types').number,
	  parent: require('prop-types').shape({
	    invalidateCellSizeAfterRender: require('prop-types').func,
	    recomputeGridSize: require('prop-types').func
	  }).isRequired,
	  rowIndex: require('prop-types').number
	};
	exports.default = CellMeasurer;
	if (false) {
	  CellMeasurer.__internalCellMeasurerFlag = true;
	}

/***/ }),
/* 6379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CollectionView = __webpack_require__(6380);
	
	var _CollectionView2 = _interopRequireDefault(_CollectionView);
	
	var _calculateSizeAndPositionData2 = __webpack_require__(6384);
	
	var _calculateSizeAndPositionData3 = _interopRequireDefault(_calculateSizeAndPositionData2);
	
	var _getUpdatedOffsetForIndex = __webpack_require__(6413);
	
	var _getUpdatedOffsetForIndex2 = _interopRequireDefault(_getUpdatedOffsetForIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Renders scattered or non-linear data.
	 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
	 */
	var babelPluginFlowReactPropTypes_proptype_SizeInfo = __webpack_require__(595).babelPluginFlowReactPropTypes_proptype_SizeInfo || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_ScrollPosition = __webpack_require__(595).babelPluginFlowReactPropTypes_proptype_ScrollPosition || __webpack_require__(2).any;
	
	var Collection = function (_PureComponent) {
	  (0, _inherits3.default)(Collection, _PureComponent);
	
	  function Collection(props, context) {
	    (0, _classCallCheck3.default)(this, Collection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Collection.__proto__ || (0, _getPrototypeOf2.default)(Collection)).call(this, props, context));
	
	    _this._cellMetadata = [];
	    _this._lastRenderedCellIndices = [];
	
	    // Cell cache during scroll (for perforamnce)
	    _this._cellCache = [];
	
	    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
	    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Collection, [{
	    key: 'forceUpdate',
	    value: function forceUpdate() {
	      if (this._collectionView !== undefined) {
	        this._collectionView.forceUpdate();
	      }
	    }
	
	    /** See Collection#recomputeCellSizesAndPositions */
	
	  }, {
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this._cellCache = [];
	      this._collectionView.recomputeCellSizesAndPositions();
	    }
	
	    /** React lifecycle methods */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = (0, _objectWithoutProperties3.default)(this.props, []);
	
	
	      return _react2.default.createElement(_CollectionView2.default, (0, _extends3.default)({
	        cellLayoutManager: this,
	        isScrollingChange: this._isScrollingChange,
	        ref: this._setCollectionViewRef
	      }, props));
	    }
	
	    /** CellLayoutManager interface */
	
	  }, {
	    key: 'calculateSizeAndPositionData',
	    value: function calculateSizeAndPositionData() {
	      var _props = this.props,
	          cellCount = _props.cellCount,
	          cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter,
	          sectionSize = _props.sectionSize;
	
	
	      var data = (0, _calculateSizeAndPositionData3.default)({
	        cellCount: cellCount,
	        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
	        sectionSize: sectionSize
	      });
	
	      this._cellMetadata = data.cellMetadata;
	      this._sectionManager = data.sectionManager;
	      this._height = data.height;
	      this._width = data.width;
	    }
	
	    /**
	     * Returns the most recently rendered set of cell indices.
	     */
	
	  }, {
	    key: 'getLastRenderedIndices',
	    value: function getLastRenderedIndices() {
	      return this._lastRenderedCellIndices;
	    }
	
	    /**
	     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
	     */
	
	  }, {
	    key: 'getScrollPositionForCell',
	    value: function getScrollPositionForCell(_ref) {
	      var align = _ref.align,
	          cellIndex = _ref.cellIndex,
	          height = _ref.height,
	          scrollLeft = _ref.scrollLeft,
	          scrollTop = _ref.scrollTop,
	          width = _ref.width;
	      var cellCount = this.props.cellCount;
	
	
	      if (cellIndex >= 0 && cellIndex < cellCount) {
	        var cellMetadata = this._cellMetadata[cellIndex];
	
	        scrollLeft = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.x,
	          cellSize: cellMetadata.width,
	          containerSize: width,
	          currentOffset: scrollLeft,
	          targetIndex: cellIndex
	        });
	
	        scrollTop = (0, _getUpdatedOffsetForIndex2.default)({
	          align: align,
	          cellOffset: cellMetadata.y,
	          cellSize: cellMetadata.height,
	          containerSize: height,
	          currentOffset: scrollTop,
	          targetIndex: cellIndex
	        });
	      }
	
	      return {
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      };
	    }
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      return {
	        height: this._height,
	        width: this._width
	      };
	    }
	  }, {
	    key: 'cellRenderers',
	    value: function cellRenderers(_ref2) {
	      var _this2 = this;
	
	      var height = _ref2.height,
	          isScrolling = _ref2.isScrolling,
	          width = _ref2.width,
	          x = _ref2.x,
	          y = _ref2.y;
	      var _props2 = this.props,
	          cellGroupRenderer = _props2.cellGroupRenderer,
	          cellRenderer = _props2.cellRenderer;
	
	      // Store for later calls to getLastRenderedIndices()
	
	      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
	        height: height,
	        width: width,
	        x: x,
	        y: y
	      });
	
	      return cellGroupRenderer({
	        cellCache: this._cellCache,
	        cellRenderer: cellRenderer,
	        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
	          var index = _ref3.index;
	          return _this2._sectionManager.getCellMetadata({ index: index });
	        },
	        indices: this._lastRenderedCellIndices,
	        isScrolling: isScrolling
	      });
	    }
	  }, {
	    key: '_isScrollingChange',
	    value: function _isScrollingChange(isScrolling) {
	      if (!isScrolling) {
	        this._cellCache = [];
	      }
	    }
	  }, {
	    key: '_setCollectionViewRef',
	    value: function _setCollectionViewRef(ref) {
	      this._collectionView = ref;
	    }
	  }]);
	  return Collection;
	}(_react.PureComponent);
	
	Collection.defaultProps = {
	  'aria-label': 'grid',
	  cellGroupRenderer: defaultCellGroupRenderer
	};
	exports.default = Collection;
	Collection.propTypes =  false ? {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Number of cells in Collection.
	   */
	  cellCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Responsible for rendering a group of cells given their indices.
	   * Should implement the following interface: ({
	   *   cellSizeAndPositionGetter:Function,
	   *   indices: Array<number>,
	   *   cellRenderer: Function
	   * }): Array<PropTypes.node>
	   */
	  cellGroupRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Responsible for rendering a cell given an row and column index.
	   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
	   */
	  cellRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback responsible for returning size and offset/position information for a given cell (index).
	   * ({ index: number }): { height: number, width: number, x: number, y: number }
	   */
	  cellSizeAndPositionGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Optionally override the size of the sections a Collection's cells are split into.
	   */
	  sectionSize: _propTypes2.default.number
	} : {};
	
	
	function defaultCellGroupRenderer(_ref4) {
	  var cellCache = _ref4.cellCache,
	      cellRenderer = _ref4.cellRenderer,
	      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
	      indices = _ref4.indices,
	      isScrolling = _ref4.isScrolling;
	
	  return indices.map(function (index) {
	    var cellMetadata = cellSizeAndPositionGetter({ index: index });
	
	    var cellRendererProps = {
	      index: index,
	      isScrolling: isScrolling,
	      key: index,
	      style: {
	        height: cellMetadata.height,
	        left: cellMetadata.x,
	        position: 'absolute',
	        top: cellMetadata.y,
	        width: cellMetadata.width
	      }
	    };
	
	    // Avoid re-creating cells while scrolling.
	    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
	    // If a scroll is in progress- cache and reuse cells.
	    // This cache will be thrown away once scrolling complets.
	    if (isScrolling) {
	      if (!(index in cellCache)) {
	        cellCache[index] = cellRenderer(cellRendererProps);
	      }
	
	      return cellCache[index];
	    } else {
	      return cellRenderer(cellRendererProps);
	    }
	  }).filter(function (renderedCell) {
	    return !!renderedCell;
	  });
	}

/***/ }),
/* 6380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createCallbackMemoizer = __webpack_require__(1653);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _scrollbarSize = __webpack_require__(952);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @TODO Merge Collection and CollectionView
	
	/**
	 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var IS_SCROLLING_TIMEOUT = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	/**
	 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
	 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
	 */
	
	var CollectionView = function (_PureComponent) {
	  (0, _inherits3.default)(CollectionView, _PureComponent);
	
	  function CollectionView(props, context) {
	    (0, _classCallCheck3.default)(this, CollectionView);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CollectionView.__proto__ || (0, _getPrototypeOf2.default)(CollectionView)).call(this, props, context));
	
	    _this.state = {
	      isScrolling: false,
	      scrollLeft: 0,
	      scrollTop: 0
	    };
	
	    _this._calculateSizeAndPositionDataOnNextUpdate = false;
	
	    // Invokes callbacks only when their values have changed.
	    _this._onSectionRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	
	    // Bind functions to instance so they don't lose context when passed around.
	    _this._invokeOnSectionRenderedHelper = _this._invokeOnSectionRenderedHelper.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._setScrollingContainerRef = _this._setScrollingContainerRef.bind(_this);
	    _this._updateScrollPositionForScrollToCell = _this._updateScrollPositionForScrollToCell.bind(_this);
	    return _this;
	  }
	
	  /**
	   * Forced recompute of cell sizes and positions.
	   * This function should be called if cell sizes have changed but nothing else has.
	   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
	   */
	
	
	  (0, _createClass3.default)(CollectionView, [{
	    key: 'recomputeCellSizesAndPositions',
	    value: function recomputeCellSizesAndPositions() {
	      this._calculateSizeAndPositionDataOnNextUpdate = true;
	      this.forceUpdate();
	    }
	
	    /* ---------------------------- Component lifecycle methods ---------------------------- */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          cellLayoutManager = _props.cellLayoutManager,
	          scrollLeft = _props.scrollLeft,
	          scrollToCell = _props.scrollToCell,
	          scrollTop = _props.scrollTop;
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = (0, _scrollbarSize2.default)();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (scrollToCell >= 0) {
	        this._updateScrollPositionForScrollToCell();
	      } else if (scrollLeft >= 0 || scrollTop >= 0) {
	        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      // Update onSectionRendered callback.
	      this._invokeOnSectionRenderedHelper();
	
	      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
	          totalHeight = _cellLayoutManager$ge.height,
	          totalWidth = _cellLayoutManager$ge.width;
	
	      // Initialize onScroll callback.
	
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalHeight: totalHeight,
	        totalWidth: totalWidth
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _props2 = this.props,
	          height = _props2.height,
	          scrollToAlignment = _props2.scrollToAlignment,
	          scrollToCell = _props2.scrollToCell,
	          width = _props2.width;
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollPositionChangeReason = _state.scrollPositionChangeReason,
	          scrollTop = _state.scrollTop;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Update scroll offsets if the current :scrollToCell values requires it
	      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
	        this._updateScrollPositionForScrollToCell();
	      }
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnSectionRenderedHelper();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var cellLayoutManager = this.props.cellLayoutManager;
	
	
	      cellLayoutManager.calculateSizeAndPositionData();
	
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	      this._scrollbarSize = (0, _scrollbarSize2.default)();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _state2 = this.state,
	          scrollLeft = _state2.scrollLeft,
	          scrollTop = _state2.scrollTop;
	
	
	      if (nextProps.cellCount === 0 && (scrollLeft !== 0 || scrollTop !== 0)) {
	        this._setScrollPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        this._setScrollPosition({
	          scrollLeft: nextProps.scrollLeft,
	          scrollTop: nextProps.scrollTop
	        });
	      }
	
	      if (nextProps.cellCount !== this.props.cellCount || nextProps.cellLayoutManager !== this.props.cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
	        nextProps.cellLayoutManager.calculateSizeAndPositionData();
	      }
	
	      if (this._calculateSizeAndPositionDataOnNextUpdate) {
	        this._calculateSizeAndPositionDataOnNextUpdate = false;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          autoHeight = _props3.autoHeight,
	          cellCount = _props3.cellCount,
	          cellLayoutManager = _props3.cellLayoutManager,
	          className = _props3.className,
	          height = _props3.height,
	          horizontalOverscanSize = _props3.horizontalOverscanSize,
	          id = _props3.id,
	          noContentRenderer = _props3.noContentRenderer,
	          style = _props3.style,
	          verticalOverscanSize = _props3.verticalOverscanSize,
	          width = _props3.width;
	      var _state3 = this.state,
	          isScrolling = _state3.isScrolling,
	          scrollLeft = _state3.scrollLeft,
	          scrollTop = _state3.scrollTop;
	
	      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
	          totalHeight = _cellLayoutManager$ge2.height,
	          totalWidth = _cellLayoutManager$ge2.width;
	
	      // Safely expand the rendered area by the specified overscan amount
	
	
	      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
	      var top = Math.max(0, scrollTop - verticalOverscanSize);
	      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
	      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);
	
	      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
	        height: bottom - top,
	        isScrolling: isScrolling,
	        width: right - left,
	        x: left,
	        y: top
	      }) : [];
	
	      var collectionStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        WebkitOverflowScrolling: 'touch',
	        width: width,
	        willChange: 'transform'
	      };
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: this._setScrollingContainerRef,
	          'aria-label': this.props['aria-label'],
	          className: (0, _classnames2.default)('ReactVirtualized__Collection', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: 'grid',
	          style: (0, _extends3.default)({}, collectionStyle, style),
	          tabIndex: 0 },
	        cellCount > 0 && _react2.default.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Collection__innerScrollContainer',
	            style: {
	              height: totalHeight,
	              maxHeight: totalHeight,
	              maxWidth: totalWidth,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              width: totalWidth
	            } },
	          childrenToDisplay
	        ),
	        cellCount === 0 && noContentRenderer()
	      );
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Collection.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_enablePointerEventsAfterDelay',
	    value: function _enablePointerEventsAfterDelay() {
	      var _this2 = this;
	
	      if (this._disablePointerEventsTimeoutId) {
	        clearTimeout(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = setTimeout(function () {
	        var isScrollingChange = _this2.props.isScrollingChange;
	
	
	        isScrollingChange(false);
	
	        _this2._disablePointerEventsTimeoutId = null;
	        _this2.setState({
	          isScrolling: false
	        });
	      }, IS_SCROLLING_TIMEOUT);
	    }
	  }, {
	    key: '_invokeOnSectionRenderedHelper',
	    value: function _invokeOnSectionRenderedHelper() {
	      var _props4 = this.props,
	          cellLayoutManager = _props4.cellLayoutManager,
	          onSectionRendered = _props4.onSectionRendered;
	
	
	      this._onSectionRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          indices: cellLayoutManager.getLastRenderedIndices()
	        }
	      });
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref) {
	      var _this3 = this;
	
	      var scrollLeft = _ref.scrollLeft,
	          scrollTop = _ref.scrollTop,
	          totalHeight = _ref.totalHeight,
	          totalWidth = _ref.totalWidth;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref2) {
	          var scrollLeft = _ref2.scrollLeft,
	              scrollTop = _ref2.scrollTop;
	          var _props5 = _this3.props,
	              height = _props5.height,
	              onScroll = _props5.onScroll,
	              width = _props5.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_setScrollingContainerRef',
	    value: function _setScrollingContainerRef(ref) {
	      this._scrollingContainer = ref;
	    }
	  }, {
	    key: '_setScrollPosition',
	    value: function _setScrollPosition(_ref3) {
	      var scrollLeft = _ref3.scrollLeft,
	          scrollTop = _ref3.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (scrollLeft >= 0) {
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (scrollTop >= 0) {
	        newState.scrollTop = scrollTop;
	      }
	
	      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_updateScrollPositionForScrollToCell',
	    value: function _updateScrollPositionForScrollToCell() {
	      var _props6 = this.props,
	          cellLayoutManager = _props6.cellLayoutManager,
	          height = _props6.height,
	          scrollToAlignment = _props6.scrollToAlignment,
	          scrollToCell = _props6.scrollToCell,
	          width = _props6.width;
	      var _state4 = this.state,
	          scrollLeft = _state4.scrollLeft,
	          scrollTop = _state4.scrollTop;
	
	
	      if (scrollToCell >= 0) {
	        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
	          align: scrollToAlignment,
	          cellIndex: scrollToCell,
	          height: height,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          width: width
	        });
	
	        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
	          this._setScrollPosition(scrollPosition);
	        }
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target !== this._scrollingContainer) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._enablePointerEventsAfterDelay();
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
	      var _props7 = this.props,
	          cellLayoutManager = _props7.cellLayoutManager,
	          height = _props7.height,
	          isScrollingChange = _props7.isScrollingChange,
	          width = _props7.width;
	
	      var scrollbarSize = this._scrollbarSize;
	
	      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
	          totalHeight = _cellLayoutManager$ge3.height,
	          totalWidth = _cellLayoutManager$ge3.width;
	
	      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
	      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
	        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
	        // All things considered, this seems to be the best current work around that I'm aware of.
	        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
	        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;
	
	        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
	        if (!this.state.isScrolling) {
	          isScrollingChange(true);
	        }
	
	        this.setState({
	          isScrolling: true,
	          scrollLeft: scrollLeft,
	          scrollPositionChangeReason: scrollPositionChangeReason,
	          scrollTop: scrollTop
	        });
	      }
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        totalWidth: totalWidth,
	        totalHeight: totalHeight
	      });
	    }
	  }]);
	  return CollectionView;
	}(_react.PureComponent);
	
	CollectionView.defaultProps = {
	  'aria-label': 'grid',
	  horizontalOverscanSize: 0,
	  noContentRenderer: function noContentRenderer() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  onSectionRendered: function onSectionRendered() {
	    return null;
	  },
	  scrollToAlignment: 'auto',
	  scrollToCell: -1,
	  style: {},
	  verticalOverscanSize: 0
	};
	exports.default = CollectionView;
	CollectionView.propTypes =  false ? {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool,
	
	  /**
	   * Number of cells in collection.
	   */
	  cellCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
	   */
	  cellLayoutManager: _propTypes2.default.object.isRequired,
	
	  /**
	   * Optional custom CSS class name to attach to root Collection element.
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
	   */
	  height: _propTypes2.default.number.isRequired,
	
	  /**
	   * Optional custom id to attach to root Collection element.
	   */
	  id: _propTypes2.default.string,
	
	  /**
	   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  horizontalOverscanSize: _propTypes2.default.number.isRequired,
	
	  isScrollingChange: _propTypes2.default.func,
	
	  /**
	   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
	   */
	  noContentRenderer: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback invoked with information about the section of the Collection that was just rendered.
	   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
	   */
	  onSectionRendered: _propTypes2.default.func.isRequired,
	
	  /**
	   * Horizontal offset.
	   */
	  scrollLeft: _propTypes2.default.number,
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /**
	   * Cell index to ensure visible (by forcefully scrolling if necessary).
	   */
	  scrollToCell: _propTypes2.default.number.isRequired,
	
	  /**
	   * Vertical offset.
	   */
	  scrollTop: _propTypes2.default.number,
	
	  /**
	   * Optional custom inline style to attach to root Collection element.
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
	   * This can reduce flicker around the edges when a user scrolls quickly.
	   */
	  verticalOverscanSize: _propTypes2.default.number.isRequired,
	
	  /**
	   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
	   */
	  width: _propTypes2.default.number.isRequired
	} : {};

/***/ }),
/* 6381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A section of the Window.
	 * Window Sections are used to group nearby cells.
	 * This enables us to more quickly determine which cells to display in a given region of the Window.
	 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
	 */
	var babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo = __webpack_require__(595).babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo || __webpack_require__(2).any; /** @rlow */
	
	
	var babelPluginFlowReactPropTypes_proptype_Index = __webpack_require__(595).babelPluginFlowReactPropTypes_proptype_Index || __webpack_require__(2).any;
	
	var Section = function () {
	  function Section(_ref) {
	    var height = _ref.height,
	        width = _ref.width,
	        x = _ref.x,
	        y = _ref.y;
	    (0, _classCallCheck3.default)(this, Section);
	
	    this.height = height;
	    this.width = width;
	    this.x = x;
	    this.y = y;
	
	    this._indexMap = {};
	    this._indices = [];
	  }
	
	  /** Add a cell to this section. */
	
	
	  (0, _createClass3.default)(Section, [{
	    key: 'addCellIndex',
	    value: function addCellIndex(_ref2) {
	      var index = _ref2.index;
	
	      if (!this._indexMap[index]) {
	        this._indexMap[index] = true;
	        this._indices.push(index);
	      }
	    }
	
	    /** Get all cell indices that have been added to this section. */
	
	  }, {
	    key: 'getCellIndices',
	    value: function getCellIndices() {
	      return this._indices;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
	    }
	  }]);
	  return Section;
	}();
	
	exports.default = Section;

/***/ }),
/* 6382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(44);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Section = __webpack_require__(6381);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo = __webpack_require__(595).babelPluginFlowReactPropTypes_proptype_SizeAndPositionInfo || __webpack_require__(2).any; /**
	                                                                                                                                                                              * Window Sections are used to group nearby cells.
	                                                                                                                                                                              * This enables us to more quickly determine which cells to display in a given region of the Window.
	                                                                                                                                                                              * 
	                                                                                                                                                                              */
	
	
	var babelPluginFlowReactPropTypes_proptype_Index = __webpack_require__(595).babelPluginFlowReactPropTypes_proptype_Index || __webpack_require__(2).any;
	
	var SECTION_SIZE = 100;
	
	/**
	 * Contains 0 to many Sections.
	 * Grows (and adds Sections) dynamically as cells are registered.
	 * Automatically adds cells to the appropriate Section(s).
	 */
	var SectionManager = function () {
	  function SectionManager() {
	    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;
	    (0, _classCallCheck3.default)(this, SectionManager);
	
	    this._sectionSize = sectionSize;
	
	    this._cellMetadata = [];
	    this._sections = {};
	  }
	
	  /**
	   * Gets all cell indices contained in the specified region.
	   * A region may encompass 1 or more Sections.
	   */
	
	
	  (0, _createClass3.default)(SectionManager, [{
	    key: 'getCellIndices',
	    value: function getCellIndices(_ref) {
	      var height = _ref.height,
	          width = _ref.width,
	          x = _ref.x,
	          y = _ref.y;
	
	      var indices = {};
	
	      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
	        return section.getCellIndices().forEach(function (index) {
	          indices[index] = index;
	        });
	      });
	
	      // Object keys are strings; this function returns numbers
	      return (0, _keys2.default)(indices).map(function (index) {
	        return indices[index];
	      });
	    }
	
	    /** Get size and position information for the cell specified. */
	
	  }, {
	    key: 'getCellMetadata',
	    value: function getCellMetadata(_ref2) {
	      var index = _ref2.index;
	
	      return this._cellMetadata[index];
	    }
	
	    /** Get all Sections overlapping the specified region. */
	
	  }, {
	    key: 'getSections',
	    value: function getSections(_ref3) {
	      var height = _ref3.height,
	          width = _ref3.width,
	          x = _ref3.x,
	          y = _ref3.y;
	
	      var sectionXStart = Math.floor(x / this._sectionSize);
	      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
	      var sectionYStart = Math.floor(y / this._sectionSize);
	      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);
	
	      var sections = [];
	
	      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
	        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
	          var key = sectionX + '.' + sectionY;
	
	          if (!this._sections[key]) {
	            this._sections[key] = new _Section2.default({
	              height: this._sectionSize,
	              width: this._sectionSize,
	              x: sectionX * this._sectionSize,
	              y: sectionY * this._sectionSize
	            });
	          }
	
	          sections.push(this._sections[key]);
	        }
	      }
	
	      return sections;
	    }
	
	    /** Total number of Sections based on the currently registered cells. */
	
	  }, {
	    key: 'getTotalSectionCount',
	    value: function getTotalSectionCount() {
	      return (0, _keys2.default)(this._sections).length;
	    }
	
	    /** Intended for debugger/test purposes only */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var _this = this;
	
	      return (0, _keys2.default)(this._sections).map(function (index) {
	        return _this._sections[index].toString();
	      });
	    }
	
	    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */
	
	  }, {
	    key: 'registerCell',
	    value: function registerCell(_ref4) {
	      var cellMetadatum = _ref4.cellMetadatum,
	          index = _ref4.index;
	
	      this._cellMetadata[index] = cellMetadatum;
	
	      this.getSections(cellMetadatum).forEach(function (section) {
	        return section.addCellIndex({ index: index });
	      });
	    }
	  }]);
	  return SectionManager;
	}();
	
	exports.default = SectionManager;

/***/ }),
/* 6383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Collection = undefined;
	
	var _Collection = __webpack_require__(6379);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Collection2.default;
	exports.Collection = _Collection2.default;

/***/ }),
/* 6384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionData;
	
	var _SectionManager = __webpack_require__(6382);
	
	var _SectionManager2 = _interopRequireDefault(_SectionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calculateSizeAndPositionData(_ref) {
	  var cellCount = _ref.cellCount,
	      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
	      sectionSize = _ref.sectionSize;
	
	  var cellMetadata = [];
	  var sectionManager = new _SectionManager2.default(sectionSize);
	  var height = 0;
	  var width = 0;
	
	  for (var index = 0; index < cellCount; index++) {
	    var cellMetadatum = cellSizeAndPositionGetter({ index: index });
	
	    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
	      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
	    }
	
	    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
	    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);
	
	    cellMetadata[index] = cellMetadatum;
	    sectionManager.registerCell({
	      cellMetadatum: cellMetadatum,
	      index: index
	    });
	  }
	
	  return {
	    cellMetadata: cellMetadata,
	    height: height,
	    sectionManager: sectionManager,
	    width: width
	  };
	}

/***/ }),
/* 6385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * High-order component that auto-calculates column-widths for `Grid` cells.
	 */
	var ColumnSizer = function (_PureComponent) {
	  (0, _inherits3.default)(ColumnSizer, _PureComponent);
	
	  function ColumnSizer(props, context) {
	    (0, _classCallCheck3.default)(this, ColumnSizer);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ColumnSizer.__proto__ || (0, _getPrototypeOf2.default)(ColumnSizer)).call(this, props, context));
	
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ColumnSizer, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props = this.props,
	          columnMaxWidth = _props.columnMaxWidth,
	          columnMinWidth = _props.columnMinWidth,
	          columnCount = _props.columnCount,
	          width = _props.width;
	
	
	      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
	        if (this._registeredChild) {
	          this._registeredChild.recomputeGridSize();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          columnMaxWidth = _props2.columnMaxWidth,
	          columnMinWidth = _props2.columnMinWidth,
	          columnCount = _props2.columnCount,
	          width = _props2.width;
	
	
	      var safeColumnMinWidth = columnMinWidth || 1;
	
	      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;
	
	      var columnWidth = width / columnCount;
	      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
	      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
	      columnWidth = Math.floor(columnWidth);
	
	      var adjustedWidth = Math.min(width, columnWidth * columnCount);
	
	      return children({
	        adjustedWidth: adjustedWidth,
	        columnWidth: columnWidth,
	        getColumnWidth: function getColumnWidth() {
	          return columnWidth;
	        },
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(child) {
	      if (child && typeof child.recomputeGridSize !== 'function') {
	        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
	      }
	
	      this._registeredChild = child;
	
	      if (this._registeredChild) {
	        this._registeredChild.recomputeGridSize();
	      }
	    }
	  }]);
	  return ColumnSizer;
	}(_react.PureComponent);
	
	exports.default = ColumnSizer;
	ColumnSizer.propTypes =  false ? {
	  /**
	   * Function responsible for rendering a virtualized Grid.
	   * This function should implement the following signature:
	   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
	   *
	   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
	   * The :registerChild should be passed to the Grid's :ref property.
	   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
	   */
	  children: _propTypes2.default.func.isRequired,
	
	  /** Optional maximum allowed column width */
	  columnMaxWidth: _propTypes2.default.number,
	
	  /** Optional minimum allowed column width */
	  columnMinWidth: _propTypes2.default.number,
	
	  /** Number of columns in Grid or Table child */
	  columnCount: _propTypes2.default.number.isRequired,
	
	  /** Width of Grid or Table child */
	  width: _propTypes2.default.number.isRequired
	} : {};

/***/ }),
/* 6386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColumnSizer = undefined;
	
	var _ColumnSizer = __webpack_require__(6385);
	
	var _ColumnSizer2 = _interopRequireDefault(_ColumnSizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ColumnSizer2.default;
	exports.ColumnSizer = _ColumnSizer2.default;

/***/ }),
/* 6387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset = __webpack_require__(6390);
	
	var _calculateSizeAndPositionDataAndUpdateScrollOffset2 = _interopRequireDefault(_calculateSizeAndPositionDataAndUpdateScrollOffset);
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(1650);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	var _createCallbackMemoizer = __webpack_require__(1653);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	var _defaultOverscanIndicesGetter = __webpack_require__(2856);
	
	var _defaultOverscanIndicesGetter2 = _interopRequireDefault(_defaultOverscanIndicesGetter);
	
	var _updateScrollIndexHelper = __webpack_require__(6392);
	
	var _updateScrollIndexHelper2 = _interopRequireDefault(_updateScrollIndexHelper);
	
	var _defaultCellRangeRenderer = __webpack_require__(2855);
	
	var _defaultCellRangeRenderer2 = _interopRequireDefault(_defaultCellRangeRenderer);
	
	var _scrollbarSize = __webpack_require__(952);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _requestAnimationTimeout = __webpack_require__(752);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_RenderedSection = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_RenderedSection || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_ScrollbarPresenceChange || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Scroll = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_Scroll || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_NoContentRenderer = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_NoContentRenderer || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellSizeGetter = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_CellSizeGetter || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellSize = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_CellSize || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellPosition = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_CellPosition || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellRangeRenderer = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_CellRangeRenderer || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellRenderer = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_CellRenderer || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId = __webpack_require__(752).babelPluginFlowReactPropTypes_proptype_AnimationTimeoutId || __webpack_require__(2).any;
	
	/**
	 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
	 * This improves performance and makes scrolling smoother.
	 */
	var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
	
	/**
	 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
	 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
	 */
	var SCROLL_POSITION_CHANGE_REASONS = {
	  OBSERVED: 'observed',
	  REQUESTED: 'requested'
	};
	
	var renderNull = function renderNull() {
	  return null;
	};
	
	/**
	 * Renders tabular data with virtualization along the vertical and horizontal axes.
	 * Row heights and column widths must be known ahead of time and specified as properties.
	 */
	var Grid = function (_React$PureComponent) {
	  (0, _inherits3.default)(Grid, _React$PureComponent);
	
	  // Invokes onSectionRendered callback only when start/stop row or column indices change
	  function Grid(props) {
	    (0, _classCallCheck3.default)(this, Grid);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, _getPrototypeOf2.default)(Grid)).call(this, props));
	
	    _this.state = {
	      isScrolling: false,
	      scrollDirectionHorizontal: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
	      scrollDirectionVertical: _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollPositionChangeReason: null
	    };
	    _this._onGridRenderedMemoizer = (0, _createCallbackMemoizer2.default)();
	    _this._onScrollMemoizer = (0, _createCallbackMemoizer2.default)(false);
	    _this._deferredInvalidateColumnIndex = null;
	    _this._deferredInvalidateRowIndex = null;
	    _this._recomputeScrollLeftFlag = false;
	    _this._recomputeScrollTopFlag = false;
	    _this._horizontalScrollBarSize = 0;
	    _this._verticalScrollBarSize = 0;
	    _this._scrollbarPresenceChanged = false;
	    _this._cellCache = {};
	    _this._styleCache = {};
	    _this._scrollbarSizeMeasured = false;
	    _this._renderedColumnStartIndex = 0;
	    _this._renderedColumnStopIndex = 0;
	    _this._renderedRowStartIndex = 0;
	    _this._renderedRowStopIndex = 0;
	
	    _this._debounceScrollEndedCallback = function () {
	      _this._disablePointerEventsTimeoutId = null;
	      _this._resetStyleCache();
	    };
	
	    _this._invokeOnGridRenderedHelper = function () {
	      var onSectionRendered = _this.props.onSectionRendered;
	
	
	      _this._onGridRenderedMemoizer({
	        callback: onSectionRendered,
	        indices: {
	          columnOverscanStartIndex: _this._columnStartIndex,
	          columnOverscanStopIndex: _this._columnStopIndex,
	          columnStartIndex: _this._renderedColumnStartIndex,
	          columnStopIndex: _this._renderedColumnStopIndex,
	          rowOverscanStartIndex: _this._rowStartIndex,
	          rowOverscanStopIndex: _this._rowStopIndex,
	          rowStartIndex: _this._renderedRowStartIndex,
	          rowStopIndex: _this._renderedRowStopIndex
	        }
	      });
	    };
	
	    _this._setScrollingContainerRef = function (ref) {
	      _this._scrollingContainer = ref;
	    };
	
	    _this._onScroll = function (event) {
	      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
	      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
	      // See issue #404 for more information.
	      if (event.target === _this._scrollingContainer) {
	        _this.handleScrollEvent(event.target);
	      }
	    };
	
	    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
	    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);
	
	    _this._columnSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.columnCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return _this._columnWidthGetter(params);
	      },
	      estimatedCellSize: _this._getEstimatedColumnSize(props)
	    });
	    _this._rowSizeAndPositionManager = new _ScalingCellSizeAndPositionManager2.default({
	      cellCount: props.rowCount,
	      cellSizeGetter: function cellSizeGetter(params) {
	        return _this._rowHeightGetter(params);
	      },
	      estimatedCellSize: _this._getEstimatedRowSize(props)
	    });
	    return _this;
	  }
	
	  /**
	   * Gets offsets for a given cell and alignment.
	   */
	
	
	  // See defaultCellRangeRenderer() for more information on the usage of these caches
	
	
	  (0, _createClass3.default)(Grid, [{
	    key: 'getOffsetForCell',
	    value: function getOffsetForCell() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$alignment = _ref.alignment,
	          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
	          _ref$columnIndex = _ref.columnIndex,
	          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
	          _ref$rowIndex = _ref.rowIndex,
	          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;
	
	      var offsetProps = (0, _extends3.default)({}, this.props, {
	        scrollToAlignment: alignment,
	        scrollToColumn: columnIndex,
	        scrollToRow: rowIndex
	      });
	
	      return {
	        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
	        scrollTop: this._getCalculatedScrollTop(offsetProps)
	      };
	    }
	
	    /**
	     * This method handles a scroll event originating from an external scroll control.
	     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
	     */
	
	  }, {
	    key: 'handleScrollEvent',
	    value: function handleScrollEvent(_ref2) {
	      var _ref2$scrollLeft = _ref2.scrollLeft,
	          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
	          _ref2$scrollTop = _ref2.scrollTop,
	          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;
	
	      // On iOS, we can arrive at negative offsets by swiping past the start.
	      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
	      if (scrollTopParam < 0) {
	        return;
	      }
	
	      // Prevent pointer events from interrupting a smooth scroll
	      this._debounceScrollEnded();
	
	      var _props = this.props,
	          autoHeight = _props.autoHeight,
	          autoWidth = _props.autoWidth,
	          height = _props.height,
	          width = _props.width;
	
	      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
	      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
	      // This causes a series of rapid renders that is slow for long lists.
	      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
	
	      var scrollbarSize = this._scrollbarSize;
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
	      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
	
	      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
	      // Don't force a re-render if this is the case.
	      // The mouse may move faster then the animation frame does.
	      // Use requestAnimationFrame to avoid over-updating.
	      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
	        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
	        // Don't change direction for an axis unless scroll offset has changed.
	        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
	        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
	
	        var newState = {
	          isScrolling: true,
	          scrollDirectionHorizontal: _scrollDirectionHorizontal,
	          scrollDirectionVertical: _scrollDirectionVertical,
	          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
	        };
	
	        if (!autoHeight) {
	          newState.scrollTop = scrollTop;
	        }
	
	        if (!autoWidth) {
	          newState.scrollLeft = scrollLeft;
	        }
	
	        this.setState(newState);
	      }
	
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        totalColumnsWidth: totalColumnsWidth,
	        totalRowsHeight: totalRowsHeight
	      });
	    }
	
	    /**
	     * Invalidate Grid size and recompute visible cells.
	     * This is a deferred wrapper for recomputeGridSize().
	     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
	     * This method is intended for advanced use-cases like CellMeasurer.
	     */
	    // @TODO (bvaughn) Add automated test coverage for this.
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref3) {
	      var columnIndex = _ref3.columnIndex,
	          rowIndex = _ref3.rowIndex;
	
	      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
	      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
	    }
	
	    /**
	     * Pre-measure all columns and rows in a Grid.
	     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
	     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
	     */
	
	  }, {
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      var _props2 = this.props,
	          columnCount = _props2.columnCount,
	          rowCount = _props2.rowCount;
	
	
	      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
	      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
	    }
	
	    /**
	     * Forced recompute of row heights and column widths.
	     * This function should be called if dynamic column or row sizes have changed but nothing else has.
	     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
	     */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref4$columnIndex = _ref4.columnIndex,
	          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
	          _ref4$rowIndex = _ref4.rowIndex,
	          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;
	
	      var _props3 = this.props,
	          scrollToColumn = _props3.scrollToColumn,
	          scrollToRow = _props3.scrollToRow;
	
	
	      this._columnSizeAndPositionManager.resetCell(columnIndex);
	      this._rowSizeAndPositionManager.resetCell(rowIndex);
	
	      // Cell sizes may be determined by a function property.
	      // In this case the cDU handler can't know if they changed.
	      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
	      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && columnIndex <= scrollToColumn;
	      this._recomputeScrollTopFlag = scrollToRow >= 0 && rowIndex <= scrollToRow;
	
	      // Clear cell cache in case we are scrolling;
	      // Invalid row heights likely mean invalid cached content as well.
	      this._cellCache = {};
	      this._styleCache = {};
	
	      this.forceUpdate();
	    }
	
	    /**
	     * Ensure column and row are visible.
	     */
	
	  }, {
	    key: 'scrollToCell',
	    value: function scrollToCell(_ref5) {
	      var columnIndex = _ref5.columnIndex,
	          rowIndex = _ref5.rowIndex;
	      var columnCount = this.props.columnCount;
	
	
	      var props = this.props;
	
	      // Don't adjust scroll offset for single-column grids (eg List, Table).
	      // This can cause a funky scroll offset because of the vertical scrollbar width.
	      if (columnCount > 1 && columnIndex !== undefined) {
	        this._updateScrollLeftForScrollToColumn((0, _extends3.default)({}, props, {
	          scrollToColumn: columnIndex
	        }));
	      }
	
	      if (rowIndex !== undefined) {
	        this._updateScrollTopForScrollToRow((0, _extends3.default)({}, props, {
	          scrollToRow: rowIndex
	        }));
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props4 = this.props,
	          getScrollbarSize = _props4.getScrollbarSize,
	          height = _props4.height,
	          scrollLeft = _props4.scrollLeft,
	          scrollToColumn = _props4.scrollToColumn,
	          scrollTop = _props4.scrollTop,
	          scrollToRow = _props4.scrollToRow,
	          width = _props4.width;
	
	      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
	      // We must do this at the start of the method as we may calculate and update scroll position below.
	
	      this._handleInvalidatedGridSize();
	
	      // If this component was first rendered server-side, scrollbar size will be undefined.
	      // In that event we need to remeasure.
	      if (!this._scrollbarSizeMeasured) {
	        this._scrollbarSize = getScrollbarSize();
	        this._scrollbarSizeMeasured = true;
	        this.setState({});
	      }
	
	      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
	        this.scrollToPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
	      }
	
	      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
	      // Setting a state may cause us to later thing we've updated the offce when we haven't.
	      var sizeIsBiggerThanZero = height > 0 && width > 0;
	      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
	        this._updateScrollLeftForScrollToColumn();
	      }
	      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
	        this._updateScrollTopForScrollToRow();
	      }
	
	      // Update onRowsRendered callback
	      this._invokeOnGridRenderedHelper();
	
	      // Initialize onScroll callback
	      this._invokeOnScrollMemoizer({
	        scrollLeft: scrollLeft || 0,
	        scrollTop: scrollTop || 0,
	        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
	        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
	      });
	
	      this._maybeCallOnScrollbarPresenceChange();
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) New scroll-to-cell props have been set
	     */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      var _props5 = this.props,
	          autoHeight = _props5.autoHeight,
	          autoWidth = _props5.autoWidth,
	          columnCount = _props5.columnCount,
	          height = _props5.height,
	          rowCount = _props5.rowCount,
	          scrollToAlignment = _props5.scrollToAlignment,
	          scrollToColumn = _props5.scrollToColumn,
	          scrollToRow = _props5.scrollToRow,
	          width = _props5.width;
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollPositionChangeReason = _state.scrollPositionChangeReason,
	          scrollTop = _state.scrollTop;
	
	      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
	      // We must do this at the start of the method as we may calculate and update scroll position below.
	
	      this._handleInvalidatedGridSize();
	
	      // Handle edge case where column or row count has only just increased over 0.
	      // In this case we may have to restore a previously-specified scroll offset.
	      // For more info see bvaughn/react-virtualized/issues/218
	      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
	
	      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
	      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
	      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
	      // So we only set these when we require an adjustment of the scroll position.
	      // See issue #2 for more information.
	      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
	        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
	        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
	        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollLeft = scrollLeft;
	        }
	        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
	          this._scrollingContainer.scrollTop = scrollTop;
	        }
	      }
	
	      // Special case where the previous size was 0:
	      // In this case we don't show any windowed cells at all.
	      // So we should always recalculate offset afterwards.
	      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
	
	      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
	      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
	      if (this._recomputeScrollLeftFlag) {
	        this._recomputeScrollLeftFlag = false;
	        this._updateScrollLeftForScrollToColumn(this.props);
	      } else {
	        (0, _updateScrollIndexHelper2.default)({
	          cellSizeAndPositionManager: this._columnSizeAndPositionManager,
	          previousCellsCount: prevProps.columnCount,
	          previousCellSize: prevProps.columnWidth,
	          previousScrollToAlignment: prevProps.scrollToAlignment,
	          previousScrollToIndex: prevProps.scrollToColumn,
	          previousSize: prevProps.width,
	          scrollOffset: scrollLeft,
	          scrollToAlignment: scrollToAlignment,
	          scrollToIndex: scrollToColumn,
	          size: width,
	          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
	          updateScrollIndexCallback: function updateScrollIndexCallback() {
	            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
	          }
	        });
	      }
	
	      if (this._recomputeScrollTopFlag) {
	        this._recomputeScrollTopFlag = false;
	        this._updateScrollTopForScrollToRow(this.props);
	      } else {
	        (0, _updateScrollIndexHelper2.default)({
	          cellSizeAndPositionManager: this._rowSizeAndPositionManager,
	          previousCellsCount: prevProps.rowCount,
	          previousCellSize: prevProps.rowHeight,
	          previousScrollToAlignment: prevProps.scrollToAlignment,
	          previousScrollToIndex: prevProps.scrollToRow,
	          previousSize: prevProps.height,
	          scrollOffset: scrollTop,
	          scrollToAlignment: scrollToAlignment,
	          scrollToIndex: scrollToRow,
	          size: height,
	          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
	          updateScrollIndexCallback: function updateScrollIndexCallback() {
	            return _this2._updateScrollTopForScrollToRow(_this2.props);
	          }
	        });
	      }
	
	      // Update onRowsRendered callback if start/stop indices have changed
	      this._invokeOnGridRenderedHelper();
	
	      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
	      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
	        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	
	        this._invokeOnScrollMemoizer({
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          totalColumnsWidth: totalColumnsWidth,
	          totalRowsHeight: totalRowsHeight
	        });
	      }
	
	      this._maybeCallOnScrollbarPresenceChange();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var getScrollbarSize = this.props.getScrollbarSize;
	
	      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
	      // We handle this case in componentDidMount()
	
	      this._scrollbarSize = getScrollbarSize();
	      if (this._scrollbarSize === undefined) {
	        this._scrollbarSizeMeasured = false;
	        this._scrollbarSize = 0;
	      } else {
	        this._scrollbarSizeMeasured = true;
	      }
	
	      this._calculateChildrenToRender();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this._disablePointerEventsTimeoutId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
	      }
	    }
	
	    /**
	     * @private
	     * This method updates scrollLeft/scrollTop in state for the following conditions:
	     * 1) Empty content (0 rows or columns)
	     * 2) New scroll props overriding the current state
	     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          scrollLeft = _state2.scrollLeft,
	          scrollTop = _state2.scrollTop;
	
	
	      if (nextProps.columnCount === 0 && scrollLeft !== 0 || nextProps.rowCount === 0 && scrollTop !== 0) {
	        this.scrollToPosition({
	          scrollLeft: 0,
	          scrollTop: 0
	        });
	      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        var newState = {};
	
	        if (nextProps.scrollLeft != null) {
	          newState.scrollLeft = nextProps.scrollLeft;
	        }
	        if (nextProps.scrollTop != null) {
	          newState.scrollTop = nextProps.scrollTop;
	        }
	
	        this.scrollToPosition(newState);
	      }
	
	      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
	        this._styleCache = {};
	      }
	
	      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
	      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);
	
	      this._columnSizeAndPositionManager.configure({
	        cellCount: nextProps.columnCount,
	        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
	      });
	      this._rowSizeAndPositionManager.configure({
	        cellCount: nextProps.rowCount,
	        estimatedCellSize: this._getEstimatedRowSize(nextProps)
	      });
	
	      var _props6 = this.props,
	          columnCount = _props6.columnCount,
	          rowCount = _props6.rowCount;
	
	      // Special case when either cols or rows were 0
	      // This would prevent any cells from rendering
	      // So we need to reset row scroll if cols changed from 0 (and vice versa)
	
	      if (columnCount === 0 || rowCount === 0) {
	        columnCount = 0;
	        rowCount = 0;
	      }
	
	      // If scrolling is controlled outside this component, clear cache when scrolling stops
	      if (nextProps.autoHeight && nextProps.isScrolling === false && this.props.isScrolling === true) {
	        this._resetStyleCache();
	      }
	
	      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: columnCount,
	        cellSize: typeof this.props.columnWidth === 'number' ? this.props.columnWidth : null,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._columnSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.columnCount,
	        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
	        nextScrollToIndex: nextProps.scrollToColumn,
	        scrollToIndex: this.props.scrollToColumn,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollLeftForScrollToColumn(nextProps, _this3.state);
	        }
	      });
	      (0, _calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
	        cellCount: rowCount,
	        cellSize: typeof this.props.rowHeight === 'number' ? this.props.rowHeight : null,
	        computeMetadataCallback: function computeMetadataCallback() {
	          return _this3._rowSizeAndPositionManager.resetCell(0);
	        },
	        computeMetadataCallbackProps: nextProps,
	        nextCellsCount: nextProps.rowCount,
	        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
	        nextScrollToIndex: nextProps.scrollToRow,
	        scrollToIndex: this.props.scrollToRow,
	        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
	          return _this3._updateScrollTopForScrollToRow(nextProps, _this3.state);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this._calculateChildrenToRender(nextProps, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          autoContainerWidth = _props7.autoContainerWidth,
	          autoHeight = _props7.autoHeight,
	          autoWidth = _props7.autoWidth,
	          className = _props7.className,
	          containerProps = _props7.containerProps,
	          containerRole = _props7.containerRole,
	          containerStyle = _props7.containerStyle,
	          height = _props7.height,
	          id = _props7.id,
	          noContentRenderer = _props7.noContentRenderer,
	          role = _props7.role,
	          style = _props7.style,
	          tabIndex = _props7.tabIndex,
	          width = _props7.width;
	
	
	      var isScrolling = this._isScrolling();
	
	      var gridStyle = {
	        boxSizing: 'border-box',
	        direction: 'ltr',
	        height: autoHeight ? 'auto' : height,
	        position: 'relative',
	        width: autoWidth ? 'auto' : width,
	        WebkitOverflowScrolling: 'touch',
	        willChange: 'transform'
	      };
	
	      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	
	      // Force browser to hide scrollbars when we know they aren't necessary.
	      // Otherwise once scrollbars appear they may not disappear again.
	      // For more info see issue #116
	      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
	      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;
	
	      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
	        this._horizontalScrollBarSize = horizontalScrollBarSize;
	        this._verticalScrollBarSize = verticalScrollBarSize;
	        this._scrollbarPresenceChanged = true;
	      }
	
	      // Also explicitly init styles to 'auto' if scrollbars are required.
	      // This works around an obscure edge case where external CSS styles have not yet been loaded,
	      // But an initial scroll index of offset is set as an external prop.
	      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
	      // This was originally reported via clauderic/react-infinite-calendar/issues/23
	      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
	      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
	
	      var childrenToDisplay = this._childrenToDisplay;
	
	      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
	
	      return React.createElement(
	        'div',
	        (0, _extends3.default)({
	          ref: this._setScrollingContainerRef
	        }, containerProps, {
	          'aria-label': this.props['aria-label'],
	          'aria-readonly': this.props['aria-readonly'],
	          className: (0, _classnames2.default)('ReactVirtualized__Grid', className),
	          id: id,
	          onScroll: this._onScroll,
	          role: role,
	          style: (0, _extends3.default)({}, gridStyle, style),
	          tabIndex: tabIndex }),
	        childrenToDisplay.length > 0 && React.createElement(
	          'div',
	          {
	            className: 'ReactVirtualized__Grid__innerScrollContainer',
	            role: containerRole,
	            style: (0, _extends3.default)({
	              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
	              height: totalRowsHeight,
	              maxWidth: totalColumnsWidth,
	              maxHeight: totalRowsHeight,
	              overflow: 'hidden',
	              pointerEvents: isScrolling ? 'none' : '',
	              position: 'relative'
	            }, containerStyle) },
	          childrenToDisplay
	        ),
	        showNoContentRenderer && noContentRenderer()
	      );
	    }
	
	    /* ---------------------------- Helper methods ---------------------------- */
	
	  }, {
	    key: '_calculateChildrenToRender',
	    value: function _calculateChildrenToRender() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var cellRenderer = props.cellRenderer,
	          cellRangeRenderer = props.cellRangeRenderer,
	          columnCount = props.columnCount,
	          deferredMeasurementCache = props.deferredMeasurementCache,
	          height = props.height,
	          overscanColumnCount = props.overscanColumnCount,
	          overscanIndicesGetter = props.overscanIndicesGetter,
	          overscanRowCount = props.overscanRowCount,
	          rowCount = props.rowCount,
	          width = props.width;
	      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
	          scrollDirectionVertical = state.scrollDirectionVertical,
	          scrollLeft = state.scrollLeft,
	          scrollTop = state.scrollTop;
	
	
	      var isScrolling = this._isScrolling(props, state);
	
	      this._childrenToDisplay = [];
	
	      // Render only enough columns and rows to cover the visible area of the grid.
	      if (height > 0 && width > 0) {
	        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: width,
	          offset: scrollLeft
	        });
	        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
	          containerSize: height,
	          offset: scrollTop
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._renderedColumnStartIndex = visibleColumnIndices.start;
	        this._renderedColumnStopIndex = visibleColumnIndices.stop;
	        this._renderedRowStartIndex = visibleRowIndices.start;
	        this._renderedRowStopIndex = visibleRowIndices.stop;
	
	        var overscanColumnIndices = overscanIndicesGetter({
	          direction: 'horizontal',
	          cellCount: columnCount,
	          overscanCellsCount: overscanColumnCount,
	          scrollDirection: scrollDirectionHorizontal,
	          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
	          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
	        });
	
	        var overscanRowIndices = overscanIndicesGetter({
	          direction: 'vertical',
	          cellCount: rowCount,
	          overscanCellsCount: overscanRowCount,
	          scrollDirection: scrollDirectionVertical,
	          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
	          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
	        });
	
	        // Store for _invokeOnGridRenderedHelper()
	        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
	        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
	        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
	        this._rowStopIndex = overscanRowIndices.overscanStopIndex;
	
	        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
	        if (deferredMeasurementCache) {
	          // If rows have a dynamic height, scan the rows we are about to render.
	          // If any have not yet been measured, then we need to render all columns initially,
	          // Because the height of the row is equal to the tallest cell within that row,
	          // (And so we can't know the height without measuring all column-cells first).
	          if (!deferredMeasurementCache.hasFixedHeight()) {
	            for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
	              if (!deferredMeasurementCache.has(rowIndex, 0)) {
	                this._columnStartIndex = 0;
	                this._columnStopIndex = columnCount - 1;
	                break;
	              }
	            }
	          }
	
	          // If columns have a dynamic width, scan the columns we are about to render.
	          // If any have not yet been measured, then we need to render all rows initially,
	          // Because the width of the column is equal to the widest cell within that column,
	          // (And so we can't know the width without measuring all row-cells first).
	          if (!deferredMeasurementCache.hasFixedWidth()) {
	            for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
	              if (!deferredMeasurementCache.has(0, columnIndex)) {
	                this._rowStartIndex = 0;
	                this._rowStopIndex = rowCount - 1;
	                break;
	              }
	            }
	          }
	        }
	
	        this._childrenToDisplay = cellRangeRenderer({
	          cellCache: this._cellCache,
	          cellRenderer: cellRenderer,
	          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
	          columnStartIndex: this._columnStartIndex,
	          columnStopIndex: this._columnStopIndex,
	          deferredMeasurementCache: deferredMeasurementCache,
	          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
	          isScrolling: isScrolling,
	          parent: this,
	          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
	          rowStartIndex: this._rowStartIndex,
	          rowStopIndex: this._rowStopIndex,
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          styleCache: this._styleCache,
	          verticalOffsetAdjustment: verticalOffsetAdjustment,
	          visibleColumnIndices: visibleColumnIndices,
	          visibleRowIndices: visibleRowIndices
	        });
	      }
	    }
	
	    /**
	     * Sets an :isScrolling flag for a small window of time.
	     * This flag is used to disable pointer events on the scrollable portion of the Grid.
	     * This prevents jerky/stuttery mouse-wheel scrolling.
	     */
	
	  }, {
	    key: '_debounceScrollEnded',
	    value: function _debounceScrollEnded() {
	      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
	
	
	      if (this._disablePointerEventsTimeoutId) {
	        (0, _requestAnimationTimeout.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
	      }
	
	      this._disablePointerEventsTimeoutId = (0, _requestAnimationTimeout.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
	    }
	  }, {
	    key: '_getEstimatedColumnSize',
	    value: function _getEstimatedColumnSize(props) {
	      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
	    }
	  }, {
	    key: '_getEstimatedRowSize',
	    value: function _getEstimatedRowSize(props) {
	      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
	    }
	
	    /**
	     * Check for batched CellMeasurer size invalidations.
	     * This will occur the first time one or more previously unmeasured cells are rendered.
	     */
	
	  }, {
	    key: '_handleInvalidatedGridSize',
	    value: function _handleInvalidatedGridSize() {
	      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
	        var columnIndex = this._deferredInvalidateColumnIndex;
	        var rowIndex = this._deferredInvalidateRowIndex;
	
	        this._deferredInvalidateColumnIndex = null;
	        this._deferredInvalidateRowIndex = null;
	
	        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
	      }
	    }
	  }, {
	    key: '_invokeOnScrollMemoizer',
	    value: function _invokeOnScrollMemoizer(_ref6) {
	      var _this4 = this;
	
	      var scrollLeft = _ref6.scrollLeft,
	          scrollTop = _ref6.scrollTop,
	          totalColumnsWidth = _ref6.totalColumnsWidth,
	          totalRowsHeight = _ref6.totalRowsHeight;
	
	      this._onScrollMemoizer({
	        callback: function callback(_ref7) {
	          var scrollLeft = _ref7.scrollLeft,
	              scrollTop = _ref7.scrollTop;
	          var _props8 = _this4.props,
	              height = _props8.height,
	              onScroll = _props8.onScroll,
	              width = _props8.width;
	
	
	          onScroll({
	            clientHeight: height,
	            clientWidth: width,
	            scrollHeight: totalRowsHeight,
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop,
	            scrollWidth: totalColumnsWidth
	          });
	        },
	        indices: {
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop
	        }
	      });
	    }
	  }, {
	    key: '_isScrolling',
	    value: function _isScrolling() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	
	      // If isScrolling is defined in props, use it to override the value in state
	      // This is a performance optimization for WindowScroller + Grid
	      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
	    }
	  }, {
	    key: '_maybeCallOnScrollbarPresenceChange',
	    value: function _maybeCallOnScrollbarPresenceChange() {
	      if (this._scrollbarPresenceChanged) {
	        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
	
	
	        this._scrollbarPresenceChanged = false;
	
	        _onScrollbarPresenceChange({
	          horizontal: this._horizontalScrollBarSize > 0,
	          size: this._scrollbarSize,
	          vertical: this._verticalScrollBarSize > 0
	        });
	      }
	    }
	  }, {
	    key: 'scrollToPosition',
	
	
	    /**
	     * Scroll to the specified offset(s).
	     * Useful for animating position changes.
	     */
	    value: function scrollToPosition(_ref8) {
	      var scrollLeft = _ref8.scrollLeft,
	          scrollTop = _ref8.scrollTop;
	
	      var newState = {
	        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
	      };
	
	      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
	        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollLeft = scrollLeft;
	      }
	
	      if (typeof scrollTop === 'number' && scrollTop >= 0) {
	        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? _defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : _defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
	        newState.scrollTop = scrollTop;
	      }
	
	      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: '_wrapSizeGetter',
	    value: function _wrapSizeGetter(value) {
	      return typeof value === 'function' ? value : function () {
	        return value;
	      };
	    }
	  }, {
	    key: '_getCalculatedScrollLeft',
	    value: function _getCalculatedScrollLeft() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var columnCount = props.columnCount,
	          height = props.height,
	          scrollToAlignment = props.scrollToAlignment,
	          scrollToColumn = props.scrollToColumn,
	          width = props.width;
	      var scrollLeft = state.scrollLeft;
	
	
	      if (columnCount > 0) {
	        var finalColumn = columnCount - 1;
	        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
	        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
	        var scrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
	
	        return this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: width - scrollBarSize,
	          currentOffset: scrollLeft,
	          targetIndex: targetIndex
	        });
	      }
	    }
	  }, {
	    key: '_updateScrollLeftForScrollToColumn',
	    value: function _updateScrollLeftForScrollToColumn() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var scrollLeft = state.scrollLeft;
	
	      var calculatedScrollLeft = this._getCalculatedScrollLeft(props, state);
	
	      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
	        this.scrollToPosition({
	          scrollLeft: calculatedScrollLeft,
	          scrollTop: -1
	        });
	      }
	    }
	  }, {
	    key: '_getCalculatedScrollTop',
	    value: function _getCalculatedScrollTop() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var height = props.height,
	          rowCount = props.rowCount,
	          scrollToAlignment = props.scrollToAlignment,
	          scrollToRow = props.scrollToRow,
	          width = props.width;
	      var scrollTop = state.scrollTop;
	
	
	      if (rowCount > 0) {
	        var finalRow = rowCount - 1;
	        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
	        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
	        var scrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;
	
	        return this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
	          align: scrollToAlignment,
	          containerSize: height - scrollBarSize,
	          currentOffset: scrollTop,
	          targetIndex: targetIndex
	        });
	      }
	    }
	  }, {
	    key: '_resetStyleCache',
	    value: function _resetStyleCache() {
	      var styleCache = this._styleCache;
	
	      // Reset cell and style caches once scrolling stops.
	      // This makes Grid simpler to use (since cells commonly change).
	      // And it keeps the caches from growing too large.
	      // Performance is most sensitive when a user is scrolling.
	      this._cellCache = {};
	      this._styleCache = {};
	
	      // Copy over the visible cell styles so avoid unnecessary re-render.
	      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
	        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
	          var key = rowIndex + '-' + columnIndex;
	          this._styleCache[key] = styleCache[key];
	        }
	      }
	
	      this.setState({
	        isScrolling: false
	      });
	    }
	  }, {
	    key: '_updateScrollTopForScrollToRow',
	    value: function _updateScrollTopForScrollToRow() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
	      var scrollTop = state.scrollTop;
	
	      var calculatedScrollTop = this._getCalculatedScrollTop(props, state);
	
	      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
	        this.scrollToPosition({
	          scrollLeft: -1,
	          scrollTop: calculatedScrollTop
	        });
	      }
	    }
	  }]);
	  return Grid;
	}(React.PureComponent);
	
	Grid.defaultProps = {
	  'aria-label': 'grid',
	  'aria-readonly': true,
	  autoContainerWidth: false,
	  autoHeight: false,
	  autoWidth: false,
	  cellRangeRenderer: _defaultCellRangeRenderer2.default,
	  containerRole: 'rowgroup',
	  containerStyle: {},
	  estimatedColumnSize: 100,
	  estimatedRowSize: 30,
	  getScrollbarSize: _scrollbarSize2.default,
	  noContentRenderer: renderNull,
	  onScroll: function onScroll() {},
	  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
	  onSectionRendered: function onSectionRendered() {},
	  overscanColumnCount: 0,
	  overscanIndicesGetter: _defaultOverscanIndicesGetter2.default,
	  overscanRowCount: 10,
	  role: 'grid',
	  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
	  scrollToAlignment: 'auto',
	  scrollToColumn: -1,
	  scrollToRow: -1,
	  style: {},
	  tabIndex: 0
	};
	Grid.propTypes =  true ? null : {
	  "aria-label": require('prop-types').string.isRequired,
	  "aria-readonly": require('prop-types').bool,
	
	
	  /**
	   * Set the width of the inner scrollable container to 'auto'.
	   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
	   */
	  autoContainerWidth: require('prop-types').bool.isRequired,
	
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
	   * Intended for use with WindowScroller
	   */
	  autoHeight: require('prop-types').bool.isRequired,
	
	
	  /**
	   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
	   * Intended for use with WindowScroller
	   */
	  autoWidth: require('prop-types').bool.isRequired,
	
	
	  /** Responsible for rendering a cell given an row and column index.  */
	  cellRenderer: typeof babelPluginFlowReactPropTypes_proptype_CellRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_CellRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_CellRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_CellRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellRenderer).isRequired,
	
	
	  /** Responsible for rendering a group of cells given their index ranges.  */
	  cellRangeRenderer: typeof babelPluginFlowReactPropTypes_proptype_CellRangeRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_CellRangeRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_CellRangeRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_CellRangeRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellRangeRenderer).isRequired,
	
	
	  /** Optional custom CSS class name to attach to root Grid element.  */
	  className: require('prop-types').string,
	
	
	  /** Number of columns in grid.  */
	  columnCount: require('prop-types').number.isRequired,
	
	
	  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
	  columnWidth: typeof babelPluginFlowReactPropTypes_proptype_CellSize === 'function' ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired : babelPluginFlowReactPropTypes_proptype_CellSize : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellSize).isRequired,
	
	
	  /** Unfiltered props for the Grid container. */
	  containerProps: require('prop-types').object,
	
	
	  /** ARIA role for the cell-container.  */
	  containerRole: require('prop-types').string.isRequired,
	
	
	  /** Optional inline style applied to inner cell-container */
	  containerStyle: require('prop-types').object.isRequired,
	
	
	  /**
	   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
	   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
	   */
	  deferredMeasurementCache: require('prop-types').object,
	
	
	  /**
	   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
	   * The estimated total width is adjusted as columns are rendered.
	   */
	  estimatedColumnSize: require('prop-types').number.isRequired,
	
	
	  /**
	   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: require('prop-types').number.isRequired,
	
	
	  /** Exposed for testing purposes only.  */
	  getScrollbarSize: require('prop-types').func.isRequired,
	
	
	  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
	  height: require('prop-types').number.isRequired,
	
	
	  /** Optional custom id to attach to root Grid element.  */
	  id: require('prop-types').string,
	
	
	  /**
	   * Override internal is-scrolling state tracking.
	   * This property is primarily intended for use with the WindowScroller component.
	   */
	  isScrolling: require('prop-types').bool,
	
	
	  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
	  noContentRenderer: typeof babelPluginFlowReactPropTypes_proptype_NoContentRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_NoContentRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_NoContentRenderer).isRequired,
	
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   */
	  onScroll: require('prop-types').func.isRequired,
	
	
	  /**
	   * Called whenever a horizontal or vertical scrollbar is added or removed.
	   * This prop is not intended for end-user use;
	   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
	   */
	  onScrollbarPresenceChange: require('prop-types').func.isRequired,
	
	
	  /** Callback invoked with information about the section of the Grid that was just rendered.  */
	  onSectionRendered: require('prop-types').func.isRequired,
	
	
	  /**
	   * Number of columns to render before/after the visible section of the grid.
	   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanColumnCount: require('prop-types').number.isRequired,
	
	
	  /**
	   * Calculates the number of cells to overscan before and after a specified range.
	   * This function ensures that overscanning doesn't exceed the available cells.
	   */
	  overscanIndicesGetter: typeof babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter === 'function' ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired : babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter).isRequired,
	
	
	  /**
	   * Number of rows to render above/below the visible section of the grid.
	   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
	   */
	  overscanRowCount: require('prop-types').number.isRequired,
	
	
	  /** ARIA role for the grid element.  */
	  role: require('prop-types').string.isRequired,
	
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * Should implement the following interface: ({ index: number }): number
	   */
	  rowHeight: typeof babelPluginFlowReactPropTypes_proptype_CellSize === 'function' ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired : babelPluginFlowReactPropTypes_proptype_CellSize : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellSize).isRequired,
	
	
	  /** Number of rows in grid.  */
	  rowCount: require('prop-types').number.isRequired,
	
	
	  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
	  scrollingResetTimeInterval: require('prop-types').number.isRequired,
	
	
	  /** Horizontal offset. */
	  scrollLeft: require('prop-types').number,
	
	
	  /**
	   * Controls scroll-to-cell behavior of the Grid.
	   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
	   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
	   */
	  scrollToAlignment: typeof babelPluginFlowReactPropTypes_proptype_Alignment === 'function' ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired : babelPluginFlowReactPropTypes_proptype_Alignment : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Alignment).isRequired,
	
	
	  /** Column index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToColumn: require('prop-types').number.isRequired,
	
	
	  /** Vertical offset. */
	  scrollTop: require('prop-types').number,
	
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToRow: require('prop-types').number.isRequired,
	
	
	  /** Optional inline style */
	  style: require('prop-types').object.isRequired,
	
	
	  /** Tab index for focus */
	  tabIndex: require('prop-types').number,
	
	
	  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
	  width: require('prop-types').number.isRequired
	};
	exports.default = Grid;

/***/ }),
/* 6388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defaultOverscanIndicesGetter;
	
	var babelPluginFlowReactPropTypes_proptype_OverscanIndices = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_OverscanIndices || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetterParams || __webpack_require__(2).any;
	
	var SCROLL_DIRECTION_BACKWARD = exports.SCROLL_DIRECTION_BACKWARD = -1;
	var SCROLL_DIRECTION_FORWARD = exports.SCROLL_DIRECTION_FORWARD = 1;
	
	var SCROLL_DIRECTION_HORIZONTAL = exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
	var SCROLL_DIRECTION_VERTICAL = exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
	
	/**
	 * Calculates the number of cells to overscan before and after a specified range.
	 * This function ensures that overscanning doesn't exceed the available cells.
	 */
	
	function defaultOverscanIndicesGetter(_ref) {
	  var cellCount = _ref.cellCount,
	      overscanCellsCount = _ref.overscanCellsCount,
	      scrollDirection = _ref.scrollDirection,
	      startIndex = _ref.startIndex,
	      stopIndex = _ref.stopIndex;
	
	  // Make sure we render at least 1 cell extra before and after (except near boundaries)
	  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
	  // For more info see issues #625
	  overscanCellsCount = Math.max(1, overscanCellsCount);
	
	  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
	    return {
	      overscanStartIndex: Math.max(0, startIndex - 1),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
	    };
	  } else {
	    return {
	      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
	      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
	    };
	  }
	}

/***/ }),
/* 6389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_VisibleCellRange = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_VisibleCellRange || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellSizeGetter = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_CellSizeGetter || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(2).any;
	
	/**
	 * Just-in-time calculates and caches size and position information for a collection of cells.
	 */
	
	var CellSizeAndPositionManager = function () {
	
	  // Used in deferred mode to track which cells have been queued for measurement.
	
	  // Cache of size and position data for cells, mapped by cell index.
	  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
	  function CellSizeAndPositionManager(_ref) {
	    var cellCount = _ref.cellCount,
	        cellSizeGetter = _ref.cellSizeGetter,
	        estimatedCellSize = _ref.estimatedCellSize;
	    (0, _classCallCheck3.default)(this, CellSizeAndPositionManager);
	    this._cellSizeAndPositionData = {};
	    this._lastMeasuredIndex = -1;
	    this._lastBatchedIndex = -1;
	
	    this._cellSizeGetter = cellSizeGetter;
	    this._cellCount = cellCount;
	    this._estimatedCellSize = estimatedCellSize;
	  }
	
	  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
	
	
	  (0, _createClass3.default)(CellSizeAndPositionManager, [{
	    key: 'areOffsetsAdjusted',
	    value: function areOffsetsAdjusted() {
	      return false;
	    }
	  }, {
	    key: 'configure',
	    value: function configure(_ref2) {
	      var cellCount = _ref2.cellCount,
	          estimatedCellSize = _ref2.estimatedCellSize;
	
	      this._cellCount = cellCount;
	      this._estimatedCellSize = estimatedCellSize;
	    }
	  }, {
	    key: 'getCellCount',
	    value: function getCellCount() {
	      return this._cellCount;
	    }
	  }, {
	    key: 'getEstimatedCellSize',
	    value: function getEstimatedCellSize() {
	      return this._estimatedCellSize;
	    }
	  }, {
	    key: 'getLastMeasuredIndex',
	    value: function getLastMeasuredIndex() {
	      return this._lastMeasuredIndex;
	    }
	  }, {
	    key: 'getOffsetAdjustment',
	    value: function getOffsetAdjustment() {
	      return 0;
	    }
	
	    /**
	     * This method returns the size and position for the cell at the specified index.
	     * It just-in-time calculates (or used cached values) for cells leading up to the index.
	     */
	
	  }, {
	    key: 'getSizeAndPositionOfCell',
	    value: function getSizeAndPositionOfCell(index) {
	      if (index < 0 || index >= this._cellCount) {
	        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
	      }
	
	      if (index > this._lastMeasuredIndex) {
	        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	
	        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
	          var _size = this._cellSizeGetter({ index: i });
	
	          // undefined or NaN probably means a logic error in the size getter.
	          // null means we're using CellMeasurer and haven't yet measured a given index.
	          if (_size === undefined || isNaN(_size)) {
	            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
	          } else if (_size === null) {
	            this._cellSizeAndPositionData[i] = {
	              offset: _offset,
	              size: 0
	            };
	
	            this._lastBatchedIndex = index;
	          } else {
	            this._cellSizeAndPositionData[i] = {
	              offset: _offset,
	              size: _size
	            };
	
	            _offset += _size;
	
	            this._lastMeasuredIndex = index;
	          }
	        }
	      }
	
	      return this._cellSizeAndPositionData[index];
	    }
	  }, {
	    key: 'getSizeAndPositionOfLastMeasuredCell',
	    value: function getSizeAndPositionOfLastMeasuredCell() {
	      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
	        offset: 0,
	        size: 0
	      };
	    }
	
	    /**
	     * Total size of all cells being measured.
	     * This value will be completely estimated initially.
	     * As cells are measured, the estimate will be updated.
	     */
	
	  }, {
	    key: 'getTotalSize',
	    value: function getTotalSize() {
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
	      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
	      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
	      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
	    }
	
	    /**
	     * Determines a new offset that ensures a certain cell is visible, given the current offset.
	     * If the cell is already visible then the current offset will be returned.
	     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	     *
	     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	     * @param containerSize Size (width or height) of the container viewport
	     * @param currentOffset Container's current (x or y) offset
	     * @param totalSize Total size (width or height) of all cells
	     * @return Offset to use to ensure the specified cell is visible
	     */
	
	  }, {
	    key: 'getUpdatedOffsetForIndex',
	    value: function getUpdatedOffsetForIndex(_ref3) {
	      var _ref3$align = _ref3.align,
	          align = _ref3$align === undefined ? 'auto' : _ref3$align,
	          containerSize = _ref3.containerSize,
	          currentOffset = _ref3.currentOffset,
	          targetIndex = _ref3.targetIndex;
	
	      if (containerSize <= 0) {
	        return 0;
	      }
	
	      var datum = this.getSizeAndPositionOfCell(targetIndex);
	      var maxOffset = datum.offset;
	      var minOffset = maxOffset - containerSize + datum.size;
	
	      var idealOffset = void 0;
	
	      switch (align) {
	        case 'start':
	          idealOffset = maxOffset;
	          break;
	        case 'end':
	          idealOffset = minOffset;
	          break;
	        case 'center':
	          idealOffset = maxOffset - (containerSize - datum.size) / 2;
	          break;
	        default:
	          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
	          break;
	      }
	
	      var totalSize = this.getTotalSize();
	
	      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
	    }
	  }, {
	    key: 'getVisibleCellRange',
	    value: function getVisibleCellRange(params) {
	      var containerSize = params.containerSize,
	          offset = params.offset;
	
	
	      var totalSize = this.getTotalSize();
	
	      if (totalSize === 0) {
	        return {};
	      }
	
	      var maxOffset = offset + containerSize;
	      var start = this._findNearestCell(offset);
	
	      var datum = this.getSizeAndPositionOfCell(start);
	      offset = datum.offset + datum.size;
	
	      var stop = start;
	
	      while (offset < maxOffset && stop < this._cellCount - 1) {
	        stop++;
	
	        offset += this.getSizeAndPositionOfCell(stop).size;
	      }
	
	      return {
	        start: start,
	        stop: stop
	      };
	    }
	
	    /**
	     * Clear all cached values for cells after the specified index.
	     * This method should be called for any cell that has changed its size.
	     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
	     */
	
	  }, {
	    key: 'resetCell',
	    value: function resetCell(index) {
	      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
	    }
	  }, {
	    key: '_binarySearch',
	    value: function _binarySearch(high, low, offset) {
	      while (low <= high) {
	        var middle = low + Math.floor((high - low) / 2);
	        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;
	
	        if (_currentOffset === offset) {
	          return middle;
	        } else if (_currentOffset < offset) {
	          low = middle + 1;
	        } else if (_currentOffset > offset) {
	          high = middle - 1;
	        }
	      }
	
	      if (low > 0) {
	        return low - 1;
	      } else {
	        return 0;
	      }
	    }
	  }, {
	    key: '_exponentialSearch',
	    value: function _exponentialSearch(index, offset) {
	      var interval = 1;
	
	      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
	        index += interval;
	        interval *= 2;
	      }
	
	      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
	    }
	
	    /**
	     * Searches for the cell (index) nearest the specified offset.
	     *
	     * If no exact match is found the next lowest cell index will be returned.
	     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
	     */
	
	  }, {
	    key: '_findNearestCell',
	    value: function _findNearestCell(offset) {
	      if (isNaN(offset)) {
	        throw Error('Invalid offset ' + offset + ' specified');
	      }
	
	      // Our search algorithms find the nearest match at or below the specified offset.
	      // So make sure the offset is at least 0 or no match will be found.
	      offset = Math.max(0, offset);
	
	      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
	      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
	
	      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
	        // If we've already measured cells within this range just use a binary search as it's faster.
	        return this._binarySearch(lastMeasuredIndex, 0, offset);
	      } else {
	        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
	        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
	        // The overall complexity for this approach is O(log n).
	        return this._exponentialSearch(lastMeasuredIndex, offset);
	      }
	    }
	  }]);
	  return CellSizeAndPositionManager;
	}();
	
	exports.default = CellSizeAndPositionManager;

/***/ }),
/* 6390 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calculateSizeAndPositionDataAndUpdateScrollOffset;
	function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
	  var cellCount = _ref.cellCount,
	      cellSize = _ref.cellSize,
	      computeMetadataCallback = _ref.computeMetadataCallback,
	      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
	      nextCellsCount = _ref.nextCellsCount,
	      nextCellSize = _ref.nextCellSize,
	      nextScrollToIndex = _ref.nextScrollToIndex,
	      scrollToIndex = _ref.scrollToIndex,
	      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
	
	  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
	  // In that event users should use the manual recompute methods to inform of changes.
	  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
	    computeMetadataCallback(computeMetadataCallbackProps);
	
	    // Updated cell metadata may have hidden the previous scrolled-to item.
	    // In this case we should also update the scrollTop to ensure it stays visible.
	    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
	      updateScrollOffsetForScrollToIndex();
	    }
	  }
	}
	
	/**
	 * Helper method that determines when to recalculate row or column metadata.
	 */

/***/ }),
/* 6391 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
	var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
	
	var isBrowser = function isBrowser() {
	  return typeof window !== 'undefined';
	};
	
	var isChrome = function isChrome() {
	  return !!window.chrome && !!window.chrome.webstore;
	};
	
	var getMaxElementSize = exports.getMaxElementSize = function getMaxElementSize() {
	  if (isBrowser()) {
	    if (isChrome()) {
	      return CHROME_MAX_ELEMENT_SIZE;
	    }
	  }
	  return DEFAULT_MAX_ELEMENT_SIZE;
	};

/***/ }),
/* 6392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateScrollIndexHelper;
	
	var _ScalingCellSizeAndPositionManager = __webpack_require__(1650);
	
	var _ScalingCellSizeAndPositionManager2 = _interopRequireDefault(_ScalingCellSizeAndPositionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_CellSize = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_CellSize || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(111).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(2).any;
	
	/**
	 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
	 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
	 */
	
	function updateScrollIndexHelper(_ref) {
	  var cellSize = _ref.cellSize,
	      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
	      previousCellsCount = _ref.previousCellsCount,
	      previousCellSize = _ref.previousCellSize,
	      previousScrollToAlignment = _ref.previousScrollToAlignment,
	      previousScrollToIndex = _ref.previousScrollToIndex,
	      previousSize = _ref.previousSize,
	      scrollOffset = _ref.scrollOffset,
	      scrollToAlignment = _ref.scrollToAlignment,
	      scrollToIndex = _ref.scrollToIndex,
	      size = _ref.size,
	      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
	      updateScrollIndexCallback = _ref.updateScrollIndexCallback;
	
	  var cellCount = cellSizeAndPositionManager.getCellCount();
	  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
	  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
	
	  // If we have a new scroll target OR if height/row-height has changed,
	  // We should ensure that the scroll target is visible.
	  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
	    updateScrollIndexCallback(scrollToIndex);
	
	    // If we don't have a selected item but list size or number of children have decreased,
	    // Make sure we aren't scrolled too far past the current content.
	  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
	    // We need to ensure that the current scroll offset is still within the collection's range.
	    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
	    // Just check to make sure we're still okay.
	    // Only adjust the scroll position if we've scrolled below the last set of rows.
	    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
	      updateScrollIndexCallback(cellCount - 1);
	    }
	  }
	}

/***/ }),
/* 6393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.isRangeVisible = isRangeVisible;
	exports.scanForUnloadedRanges = scanForUnloadedRanges;
	exports.forceUpdateReactVirtualizedComponent = forceUpdateReactVirtualizedComponent;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createCallbackMemoizer = __webpack_require__(1653);
	
	var _createCallbackMemoizer2 = _interopRequireDefault(_createCallbackMemoizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Higher-order component that manages lazy-loading for "infinite" data.
	 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
	 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
	 */
	var InfiniteLoader = function (_PureComponent) {
	  (0, _inherits3.default)(InfiniteLoader, _PureComponent);
	
	  function InfiniteLoader(props, context) {
	    (0, _classCallCheck3.default)(this, InfiniteLoader);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InfiniteLoader.__proto__ || (0, _getPrototypeOf2.default)(InfiniteLoader)).call(this, props, context));
	
	    _this._loadMoreRowsMemoizer = (0, _createCallbackMemoizer2.default)();
	
	    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
	    _this._registerChild = _this._registerChild.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(InfiniteLoader, [{
	    key: 'resetLoadMoreRowsCache',
	    value: function resetLoadMoreRowsCache(autoReload) {
	      this._loadMoreRowsMemoizer = (0, _createCallbackMemoizer2.default)();
	
	      if (autoReload) {
	        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      return children({
	        onRowsRendered: this._onRowsRendered,
	        registerChild: this._registerChild
	      });
	    }
	  }, {
	    key: '_loadUnloadedRanges',
	    value: function _loadUnloadedRanges(unloadedRanges) {
	      var _this2 = this;
	
	      var loadMoreRows = this.props.loadMoreRows;
	
	
	      unloadedRanges.forEach(function (unloadedRange) {
	        var promise = loadMoreRows(unloadedRange);
	        if (promise) {
	          promise.then(function () {
	            // Refresh the visible rows if any of them have just been loaded.
	            // Otherwise they will remain in their unloaded visual state.
	            if (isRangeVisible({
	              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
	              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
	              startIndex: unloadedRange.startIndex,
	              stopIndex: unloadedRange.stopIndex
	            })) {
	              if (_this2._registeredChild) {
	                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
	              }
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: '_onRowsRendered',
	    value: function _onRowsRendered(_ref) {
	      var startIndex = _ref.startIndex,
	          stopIndex = _ref.stopIndex;
	
	      this._lastRenderedStartIndex = startIndex;
	      this._lastRenderedStopIndex = stopIndex;
	
	      this._doStuff(startIndex, stopIndex);
	    }
	  }, {
	    key: '_doStuff',
	    value: function _doStuff(startIndex, stopIndex) {
	      var _this3 = this;
	
	      var _props = this.props,
	          isRowLoaded = _props.isRowLoaded,
	          minimumBatchSize = _props.minimumBatchSize,
	          rowCount = _props.rowCount,
	          threshold = _props.threshold;
	
	
	      var unloadedRanges = scanForUnloadedRanges({
	        isRowLoaded: isRowLoaded,
	        minimumBatchSize: minimumBatchSize,
	        rowCount: rowCount,
	        startIndex: Math.max(0, startIndex - threshold),
	        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
	      });
	
	      // For memoize comparison
	      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
	        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
	      }, []);
	
	      this._loadMoreRowsMemoizer({
	        callback: function callback() {
	          _this3._loadUnloadedRanges(unloadedRanges);
	        },
	        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
	      });
	    }
	  }, {
	    key: '_registerChild',
	    value: function _registerChild(registeredChild) {
	      this._registeredChild = registeredChild;
	    }
	  }]);
	  return InfiniteLoader;
	}(_react.PureComponent);
	
	/**
	 * Determines if the specified start/stop range is visible based on the most recently rendered range.
	 */
	
	
	InfiniteLoader.defaultProps = {
	  minimumBatchSize: 10,
	  rowCount: 0,
	  threshold: 15
	};
	exports.default = InfiniteLoader;
	InfiniteLoader.propTypes =  false ? {
	  /**
	   * Function responsible for rendering a virtualized component.
	   * This function should implement the following signature:
	   * ({ onRowsRendered, registerChild }) => PropTypes.element
	   *
	   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
	   * The :registerChild callback should be set as the virtualized component's :ref.
	   */
	  children: _propTypes2.default.func.isRequired,
	
	  /**
	   * Function responsible for tracking the loaded state of each row.
	   * It should implement the following signature: ({ index: number }): boolean
	   */
	  isRowLoaded: _propTypes2.default.func.isRequired,
	
	  /**
	   * Callback to be invoked when more rows must be loaded.
	   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
	   * The returned Promise should be resolved once row data has finished loading.
	   * It will be used to determine when to refresh the list with the newly-loaded data.
	   * This callback may be called multiple times in reaction to a single scroll event.
	   */
	  loadMoreRows: _propTypes2.default.func.isRequired,
	
	  /**
	   * Minimum number of rows to be loaded at a time.
	   * This property can be used to batch requests to reduce HTTP requests.
	   */
	  minimumBatchSize: _propTypes2.default.number.isRequired,
	
	  /**
	   * Number of rows in list; can be arbitrary high number if actual number is unknown.
	   */
	  rowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Threshold at which to pre-fetch data.
	   * A threshold X means that data will start loading when a user scrolls within X rows.
	   * This value defaults to 15.
	   */
	  threshold: _propTypes2.default.number.isRequired
	} : {};
	function isRangeVisible(_ref2) {
	  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex,
	      lastRenderedStopIndex = _ref2.lastRenderedStopIndex,
	      startIndex = _ref2.startIndex,
	      stopIndex = _ref2.stopIndex;
	
	  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
	}
	
	/**
	 * Returns all of the ranges within a larger range that contain unloaded rows.
	 */
	function scanForUnloadedRanges(_ref3) {
	  var isRowLoaded = _ref3.isRowLoaded,
	      minimumBatchSize = _ref3.minimumBatchSize,
	      rowCount = _ref3.rowCount,
	      startIndex = _ref3.startIndex,
	      stopIndex = _ref3.stopIndex;
	
	  var unloadedRanges = [];
	
	  var rangeStartIndex = null;
	  var rangeStopIndex = null;
	
	  for (var index = startIndex; index <= stopIndex; index++) {
	    var loaded = isRowLoaded({ index: index });
	
	    if (!loaded) {
	      rangeStopIndex = index;
	      if (rangeStartIndex === null) {
	        rangeStartIndex = index;
	      }
	    } else if (rangeStopIndex !== null) {
	      unloadedRanges.push({
	        startIndex: rangeStartIndex,
	        stopIndex: rangeStopIndex
	      });
	
	      rangeStartIndex = rangeStopIndex = null;
	    }
	  }
	
	  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
	  // Scan forward to try filling our :minimumBatchSize.
	  if (rangeStopIndex !== null) {
	    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);
	
	    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
	      if (!isRowLoaded({ index: _index })) {
	        rangeStopIndex = _index;
	      } else {
	        break;
	      }
	    }
	
	    unloadedRanges.push({
	      startIndex: rangeStartIndex,
	      stopIndex: rangeStopIndex
	    });
	  }
	
	  // Check to see if our first range ended prematurely.
	  // In this case we should scan backwards to try filling our :minimumBatchSize.
	  if (unloadedRanges.length) {
	    var firstUnloadedRange = unloadedRanges[0];
	
	    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
	      var _index2 = firstUnloadedRange.startIndex - 1;
	
	      if (!isRowLoaded({ index: _index2 })) {
	        firstUnloadedRange.startIndex = _index2;
	      } else {
	        break;
	      }
	    }
	  }
	
	  return unloadedRanges;
	}
	
	/**
	 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
	 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
	 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
	 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
	 * Else the inner Grid will not be re-rendered and visuals may be stale.
	 *
	 * Additionally, while a Grid is scrolling the cells can be cached,
	 * So it's important to invalidate that cache by recalculating sizes
	 * before forcing a rerender.
	 */
	function forceUpdateReactVirtualizedComponent(component) {
	  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;
	
	  if (recomputeSize) {
	    recomputeSize.call(component, currentIndex);
	  } else {
	    component.forceUpdate();
	  }
	}

/***/ }),
/* 6394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InfiniteLoader = undefined;
	
	var _InfiniteLoader = __webpack_require__(6393);
	
	var _InfiniteLoader2 = _interopRequireDefault(_InfiniteLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _InfiniteLoader2.default;
	exports.InfiniteLoader = _InfiniteLoader2.default;

/***/ }),
/* 6395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getOwnPropertyDescriptor = __webpack_require__(70);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Grid = __webpack_require__(191);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Scroll = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_Scroll || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellRendererParams = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_CellRendererParams || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_RenderedSection = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_RenderedSection || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellPosition = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_CellPosition || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellSize = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_CellSize || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Alignment = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_Alignment || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_NoContentRenderer = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_NoContentRenderer || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Scroll = __webpack_require__(1651).babelPluginFlowReactPropTypes_proptype_Scroll || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_RenderedRows = __webpack_require__(1651).babelPluginFlowReactPropTypes_proptype_RenderedRows || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_RowRenderer = __webpack_require__(1651).babelPluginFlowReactPropTypes_proptype_RowRenderer || __webpack_require__(2).any;
	
	/**
	 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
	 * if only a few of those elements are visible. The primary purpose of this component is to improve
	 * performance by only rendering the DOM nodes that a user is able to see based on their current
	 * scroll position.
	 *
	 * This component renders a virtualized list of elements with either fixed or dynamic heights.
	 */
	
	var List = function (_React$PureComponent) {
	  (0, _inherits3.default)(List, _React$PureComponent);
	
	  function List() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, List);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, _getPrototypeOf2.default)(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
	      var parent = _ref2.parent,
	          rowIndex = _ref2.rowIndex,
	          style = _ref2.style,
	          isScrolling = _ref2.isScrolling,
	          isVisible = _ref2.isVisible,
	          key = _ref2.key;
	      var rowRenderer = _this.props.rowRenderer;
	
	      // TRICKY The style object is sometimes cached by Grid.
	      // This prevents new style objects from bypassing shallowCompare().
	      // However as of React 16, style props are auto-frozen (at least in dev mode)
	      // Check to make sure we can still modify the style before proceeding.
	      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
	
	      var _Object$getOwnPropert = (0, _getOwnPropertyDescriptor2.default)(style, 'width'),
	          writable = _Object$getOwnPropert.writable;
	
	      if (writable) {
	        // By default, List cells should be 100% width.
	        // This prevents them from flowing under a scrollbar (if present).
	        style.width = '100%';
	      }
	
	      return rowRenderer({
	        index: rowIndex,
	        style: style,
	        isScrolling: isScrolling,
	        isVisible: isVisible,
	        key: key,
	        parent: parent
	      });
	    }, _this._setRef = function (ref) {
	      _this.Grid = ref;
	    }, _this._onScroll = function (_ref3) {
	      var clientHeight = _ref3.clientHeight,
	          scrollHeight = _ref3.scrollHeight,
	          scrollTop = _ref3.scrollTop;
	      var onScroll = _this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }, _this._onSectionRendered = function (_ref4) {
	      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
	          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
	          rowStartIndex = _ref4.rowStartIndex,
	          rowStopIndex = _ref4.rowStopIndex;
	      var onRowsRendered = _this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      if (this.Grid) {
	        this.Grid.forceUpdate();
	      }
	    }
	
	    /** See Grid#getOffsetForCell */
	
	  }, {
	    key: 'getOffsetForRow',
	    value: function getOffsetForRow(_ref5) {
	      var alignment = _ref5.alignment,
	          index = _ref5.index;
	
	      if (this.Grid) {
	        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
	          alignment: alignment,
	          rowIndex: index,
	          columnIndex: 0
	        }),
	            _scrollTop = _Grid$getOffsetForCel.scrollTop;
	
	        return _scrollTop;
	      }
	      return 0;
	    }
	
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref6) {
	      var columnIndex = _ref6.columnIndex,
	          rowIndex = _ref6.rowIndex;
	
	      if (this.Grid) {
	        this.Grid.invalidateCellSizeAfterRender({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      if (this.Grid) {
	        this.Grid.measureAllCells();
	      }
	    }
	
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref7$columnIndex = _ref7.columnIndex,
	          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
	          _ref7$rowIndex = _ref7.rowIndex,
	          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: index,
	          columnIndex: 0
	        });
	      }
	    }
	
	    /** See Grid#scrollToPosition */
	
	  }, {
	    key: 'scrollToPosition',
	    value: function scrollToPosition() {
	      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToPosition({ scrollTop: scrollTop });
	      }
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToCell({
	          columnIndex: 0,
	          rowIndex: index
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          noRowsRenderer = _props.noRowsRenderer,
	          scrollToIndex = _props.scrollToIndex,
	          width = _props.width;
	
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__List', className);
	
	      return React.createElement(_Grid2.default, (0, _extends3.default)({}, this.props, {
	        autoContainerWidth: true,
	        cellRenderer: this._cellRenderer,
	        className: classNames,
	        columnWidth: width,
	        columnCount: 1,
	        noContentRenderer: noRowsRenderer,
	        onScroll: this._onScroll,
	        onSectionRendered: this._onSectionRendered,
	        ref: this._setRef,
	        scrollToRow: scrollToIndex
	      }));
	    }
	  }]);
	  return List;
	}(React.PureComponent);
	
	List.defaultProps = {
	  autoHeight: false,
	  estimatedRowSize: 30,
	  onScroll: function onScroll() {},
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {},
	  overscanIndicesGetter: _Grid.accessibilityOverscanIndicesGetter,
	  overscanRowCount: 10,
	  scrollToAlignment: 'auto',
	  scrollToIndex: -1,
	  style: {}
	};
	List.propTypes =  true ? null : {
	  "aria-label": require('prop-types').string,
	
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: require('prop-types').bool.isRequired,
	
	
	  /** Optional CSS class name */
	  className: require('prop-types').string,
	
	
	  /**
	   * Used to estimate the total height of a List before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: require('prop-types').number.isRequired,
	
	
	  /** Height constraint for list (determines how many actual rows are rendered) */
	  height: require('prop-types').number.isRequired,
	
	
	  /** Optional renderer to be used in place of rows when rowCount is 0 */
	  noRowsRenderer: typeof babelPluginFlowReactPropTypes_proptype_NoContentRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_NoContentRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_NoContentRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_NoContentRenderer).isRequired,
	
	
	  /** Callback invoked with information about the slice of rows that were just rendered.  */
	
	  onRowsRendered: require('prop-types').func.isRequired,
	
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   */
	  onScroll: require('prop-types').func.isRequired,
	
	
	  /** See Grid#overscanIndicesGetter */
	  overscanIndicesGetter: typeof babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter === 'function' ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired ? babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter.isRequired : babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_OverscanIndicesGetter).isRequired,
	
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: require('prop-types').number.isRequired,
	
	
	  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
	  rowHeight: typeof babelPluginFlowReactPropTypes_proptype_CellSize === 'function' ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired ? babelPluginFlowReactPropTypes_proptype_CellSize.isRequired : babelPluginFlowReactPropTypes_proptype_CellSize : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_CellSize).isRequired,
	
	
	  /** Responsible for rendering a row given an index; ({ index: number }): node */
	  rowRenderer: typeof babelPluginFlowReactPropTypes_proptype_RowRenderer === 'function' ? babelPluginFlowReactPropTypes_proptype_RowRenderer.isRequired ? babelPluginFlowReactPropTypes_proptype_RowRenderer.isRequired : babelPluginFlowReactPropTypes_proptype_RowRenderer : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_RowRenderer).isRequired,
	
	
	  /** Number of rows in list. */
	  rowCount: require('prop-types').number.isRequired,
	
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: typeof babelPluginFlowReactPropTypes_proptype_Alignment === 'function' ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired ? babelPluginFlowReactPropTypes_proptype_Alignment.isRequired : babelPluginFlowReactPropTypes_proptype_Alignment : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Alignment).isRequired,
	
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: require('prop-types').number.isRequired,
	
	
	  /** Vertical offset. */
	  scrollTop: require('prop-types').number,
	
	
	  /** Optional inline style */
	  style: require('prop-types').object.isRequired,
	
	
	  /** Tab index for focus */
	  tabIndex: require('prop-types').number,
	
	
	  /** Width of list */
	  width: require('prop-types').number.isRequired
	};
	exports.default = List;

/***/ }),
/* 6396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _List = __webpack_require__(6395);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_List).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 6397 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(11);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _intervalTree = __webpack_require__(6415);
	
	var _intervalTree2 = _interopRequireDefault(_intervalTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Position cache requirements:
	//   O(log(n)) lookup of cells to render for a given viewport size
	//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
	var PositionCache = function () {
	  function PositionCache() {
	    (0, _classCallCheck3.default)(this, PositionCache);
	    this._columnSizeMap = {};
	    this._intervalTree = (0, _intervalTree2.default)();
	    this._leftMap = {};
	  }
	  // Tracks the height of each column
	
	
	  // Store tops and bottoms of each cell for fast intersection lookup.
	
	
	  // Maps cell index to x coordinates for quick lookup.
	
	
	  (0, _createClass3.default)(PositionCache, [{
	    key: 'estimateTotalHeight',
	    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
	      var unmeasuredCellCount = cellCount - this.count;
	      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
	    }
	
	    // Render all cells visible within the viewport range defined.
	
	  }, {
	    key: 'range',
	    value: function range(scrollTop, clientHeight, renderCallback) {
	      var _this = this;
	
	      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
	            top = _ref2[0],
	            _ = _ref2[1],
	            index = _ref2[2];
	
	        return renderCallback(index, _this._leftMap[index], top);
	      });
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(index, left, top, height) {
	      this._intervalTree.insert([top, top + height, index]);
	      this._leftMap[index] = left;
	
	      var columnSizeMap = this._columnSizeMap;
	      var columnHeight = columnSizeMap[left];
	      if (columnHeight === undefined) {
	        columnSizeMap[left] = top + height;
	      } else {
	        columnSizeMap[left] = Math.max(columnHeight, top + height);
	      }
	    }
	  }, {
	    key: 'count',
	    get: function get() {
	      return this._intervalTree.count;
	    }
	  }, {
	    key: 'shortestColumnSize',
	    get: function get() {
	      var columnSizeMap = this._columnSizeMap;
	
	      var size = 0;
	
	      for (var i in columnSizeMap) {
	        var height = columnSizeMap[i];
	        size = size === 0 ? height : Math.min(size, height);
	      }
	
	      return size;
	    }
	  }, {
	    key: 'tallestColumnSize',
	    get: function get() {
	      var columnSizeMap = this._columnSizeMap;
	
	      var size = 0;
	
	      for (var i in columnSizeMap) {
	        var height = columnSizeMap[i];
	        size = Math.max(size, height);
	      }
	
	      return size;
	    }
	  }]);
	  return PositionCache;
	}();
	
	exports.default = PositionCache;

/***/ }),
/* 6398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createCellPositioner;
	
	var babelPluginFlowReactPropTypes_proptype_Positioner = __webpack_require__(1652).babelPluginFlowReactPropTypes_proptype_Positioner || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_CellMeasurerCache = __webpack_require__(1652).babelPluginFlowReactPropTypes_proptype_CellMeasurerCache || __webpack_require__(2).any;
	
	function createCellPositioner(_ref) {
	  var cellMeasurerCache = _ref.cellMeasurerCache,
	      columnCount = _ref.columnCount,
	      columnWidth = _ref.columnWidth,
	      _ref$spacer = _ref.spacer,
	      spacer = _ref$spacer === undefined ? 0 : _ref$spacer;
	
	  var columnHeights = void 0;
	
	  initOrResetDerivedValues();
	
	  function cellPositioner(index) {
	    // Find the shortest column and use it.
	    var columnIndex = 0;
	    for (var i = 1; i < columnHeights.length; i++) {
	      if (columnHeights[i] < columnHeights[columnIndex]) {
	        columnIndex = i;
	      }
	    }
	
	    var left = columnIndex * (columnWidth + spacer);
	    var top = columnHeights[columnIndex] || 0;
	
	    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;
	
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  function initOrResetDerivedValues() {
	    // Track the height of each column.
	    // Layout algorithm below always inserts into the shortest column.
	    columnHeights = [];
	    for (var i = 0; i < columnCount; i++) {
	      columnHeights[i] = 0;
	    }
	  }
	
	  function reset(params) {
	    columnCount = params.columnCount;
	    columnWidth = params.columnWidth;
	    spacer = params.spacer;
	
	    initOrResetDerivedValues();
	  }
	
	  cellPositioner.reset = reset;
	
	  return cellPositioner;
	}

/***/ }),
/* 6399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Masonry = exports.createCellPositioner = undefined;
	
	var _createCellPositioner = __webpack_require__(6398);
	
	var _createCellPositioner2 = _interopRequireDefault(_createCellPositioner);
	
	var _Masonry = __webpack_require__(1652);
	
	var _Masonry2 = _interopRequireDefault(_Masonry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Masonry2.default;
	exports.createCellPositioner = _createCellPositioner2.default;
	exports.Masonry = _Masonry2.default;

/***/ }),
/* 6400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _CellMeasurer = __webpack_require__(2854);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Caches measurements for a given cell.
	 */
	var CellMeasurerCacheDecorator = function () {
	  function CellMeasurerCacheDecorator() {
	    var _this = this;
	
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck3.default)(this, CellMeasurerCacheDecorator);
	
	    this.columnWidth = function (_ref) {
	      var index = _ref.index;
	
	      _this._cellMeasurerCache.columnWidth({
	        index: index + _this._columnIndexOffset
	      });
	    };
	
	    this.rowHeight = function (_ref2) {
	      var index = _ref2.index;
	
	      _this._cellMeasurerCache.rowHeight({
	        index: index + _this._rowIndexOffset
	      });
	    };
	
	    var cellMeasurerCache = params.cellMeasurerCache,
	        _params$columnIndexOf = params.columnIndexOffset,
	        columnIndexOffset = _params$columnIndexOf === undefined ? 0 : _params$columnIndexOf,
	        _params$rowIndexOffse = params.rowIndexOffset,
	        rowIndexOffset = _params$rowIndexOffse === undefined ? 0 : _params$rowIndexOffse;
	
	
	    this._cellMeasurerCache = cellMeasurerCache;
	    this._columnIndexOffset = columnIndexOffset;
	    this._rowIndexOffset = rowIndexOffset;
	  }
	
	  (0, _createClass3.default)(CellMeasurerCacheDecorator, [{
	    key: 'clear',
	    value: function clear(rowIndex, columnIndex) {
	      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
	    }
	  }, {
	    key: 'clearAll',
	    value: function clearAll() {
	      this._cellMeasurerCache.clearAll();
	    }
	  }, {
	    key: 'hasFixedHeight',
	    value: function hasFixedHeight() {
	      return this._cellMeasurerCache.hasFixedHeight();
	    }
	  }, {
	    key: 'hasFixedWidth',
	    value: function hasFixedWidth() {
	      return this._cellMeasurerCache.hasFixedWidth();
	    }
	  }, {
	    key: 'getHeight',
	    value: function getHeight(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
	    }
	  }, {
	    key: 'getWidth',
	    value: function getWidth(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
	    }
	  }, {
	    key: 'has',
	    value: function has(rowIndex) {
	      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
	    }
	  }, {
	    key: 'set',
	    value: function set(rowIndex, columnIndex, width, height) {
	      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
	    }
	  }, {
	    key: 'defaultHeight',
	    get: function get() {
	      return this._cellMeasurerCache.defaultHeight;
	    }
	  }, {
	    key: 'defaultWidth',
	    get: function get() {
	      return this._cellMeasurerCache.defaultWidth;
	    }
	  }]);
	  return CellMeasurerCacheDecorator;
	}();
	
	exports.default = CellMeasurerCacheDecorator;

/***/ }),
/* 6401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(28);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CellMeasurerCacheDecorator = __webpack_require__(6400);
	
	var _CellMeasurerCacheDecorator2 = _interopRequireDefault(_CellMeasurerCacheDecorator);
	
	var _Grid = __webpack_require__(191);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SCROLLBAR_SIZE_BUFFER = 20;
	
	/**
	 * Renders 1, 2, or 4 Grids depending on configuration.
	 * A main (body) Grid will always be rendered.
	 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
	 * If no sticky columns, only 1 sticky header Grid will be rendered.
	 * If sticky columns, 2 sticky header Grids will be rendered.
	 */
	
	var MultiGrid = function (_PureComponent) {
	  (0, _inherits3.default)(MultiGrid, _PureComponent);
	
	  function MultiGrid(props, context) {
	    (0, _classCallCheck3.default)(this, MultiGrid);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (MultiGrid.__proto__ || (0, _getPrototypeOf2.default)(MultiGrid)).call(this, props, context));
	
	    _this.state = {
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollbarSize: 0,
	      showHorizontalScrollbar: false,
	      showVerticalScrollbar: false
	    };
	
	    _this._deferredInvalidateColumnIndex = null;
	    _this._deferredInvalidateRowIndex = null;
	
	    _this._bottomLeftGridRef = _this._bottomLeftGridRef.bind(_this);
	    _this._bottomRightGridRef = _this._bottomRightGridRef.bind(_this);
	    _this._cellRendererBottomLeftGrid = _this._cellRendererBottomLeftGrid.bind(_this);
	    _this._cellRendererBottomRightGrid = _this._cellRendererBottomRightGrid.bind(_this);
	    _this._cellRendererTopRightGrid = _this._cellRendererTopRightGrid.bind(_this);
	    _this._columnWidthRightGrid = _this._columnWidthRightGrid.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onScrollbarPresenceChange = _this._onScrollbarPresenceChange.bind(_this);
	    _this._onScrollLeft = _this._onScrollLeft.bind(_this);
	    _this._onScrollTop = _this._onScrollTop.bind(_this);
	    _this._rowHeightBottomGrid = _this._rowHeightBottomGrid.bind(_this);
	    _this._topLeftGridRef = _this._topLeftGridRef.bind(_this);
	    _this._topRightGridRef = _this._topRightGridRef.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(MultiGrid, [{
	    key: 'forceUpdateGrids',
	    value: function forceUpdateGrids() {
	      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
	      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
	      this._topLeftGrid && this._topLeftGrid.forceUpdate();
	      this._topRightGrid && this._topRightGrid.forceUpdate();
	    }
	
	    /** See Grid#invalidateCellSizeAfterRender */
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$columnIndex = _ref.columnIndex,
	          columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex,
	          _ref$rowIndex = _ref.rowIndex,
	          rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
	
	      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
	      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllCells',
	    value: function measureAllCells() {
	      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
	      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
	      this._topLeftGrid && this._topLeftGrid.measureAllCells();
	      this._topRightGrid && this._topRightGrid.measureAllCells();
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$columnIndex = _ref2.columnIndex,
	          columnIndex = _ref2$columnIndex === undefined ? 0 : _ref2$columnIndex,
	          _ref2$rowIndex = _ref2.rowIndex,
	          rowIndex = _ref2$rowIndex === undefined ? 0 : _ref2$rowIndex;
	
	      var _props = this.props,
	          fixedColumnCount = _props.fixedColumnCount,
	          fixedRowCount = _props.fixedRowCount;
	
	
	      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
	      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);
	
	      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: adjustedRowIndex
	      });
	      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
	        columnIndex: columnIndex,
	        rowIndex: rowIndex
	      });
	      this._topRightGrid && this._topRightGrid.recomputeGridSize({
	        columnIndex: adjustedColumnIndex,
	        rowIndex: rowIndex
	      });
	
	      this._leftGridWidth = null;
	      this._topGridHeight = null;
	      this._maybeCalculateCachedStyles(null, this.props, null, this.state);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props2 = this.props,
	          scrollLeft = _props2.scrollLeft,
	          scrollTop = _props2.scrollTop;
	
	
	      if (scrollLeft > 0 || scrollTop > 0) {
	        var newState = {};
	
	        if (scrollLeft > 0) {
	          newState.scrollLeft = scrollLeft;
	        }
	
	        if (scrollTop > 0) {
	          newState.scrollTop = scrollTop;
	        }
	
	        this.setState(newState);
	      }
	      this._handleInvalidatedGridSize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._handleInvalidatedGridSize();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props3 = this.props,
	          deferredMeasurementCache = _props3.deferredMeasurementCache,
	          fixedColumnCount = _props3.fixedColumnCount,
	          fixedRowCount = _props3.fixedRowCount;
	
	
	      this._maybeCalculateCachedStyles(null, this.props, null, this.state);
	
	      if (deferredMeasurementCache) {
	        this._deferredMeasurementCacheBottomLeftGrid = fixedRowCount > 0 ? new _CellMeasurerCacheDecorator2.default({
	          cellMeasurerCache: deferredMeasurementCache,
	          columnIndexOffset: 0,
	          rowIndexOffset: fixedRowCount
	        }) : deferredMeasurementCache;
	
	        this._deferredMeasurementCacheBottomRightGrid = fixedColumnCount > 0 || fixedRowCount > 0 ? new _CellMeasurerCacheDecorator2.default({
	          cellMeasurerCache: deferredMeasurementCache,
	          columnIndexOffset: fixedColumnCount,
	          rowIndexOffset: fixedRowCount
	        }) : deferredMeasurementCache;
	
	        this._deferredMeasurementCacheTopRightGrid = fixedColumnCount > 0 ? new _CellMeasurerCacheDecorator2.default({
	          cellMeasurerCache: deferredMeasurementCache,
	          columnIndexOffset: fixedColumnCount,
	          rowIndexOffset: 0
	        }) : deferredMeasurementCache;
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextState) {
	      var _props4 = this.props,
	          columnWidth = _props4.columnWidth,
	          fixedColumnCount = _props4.fixedColumnCount,
	          fixedRowCount = _props4.fixedRowCount,
	          rowHeight = _props4.rowHeight;
	
	
	      if (columnWidth !== nextProps.columnWidth || fixedColumnCount !== nextProps.fixedColumnCount) {
	        this._leftGridWidth = null;
	      }
	
	      if (fixedRowCount !== nextProps.fixedRowCount || rowHeight !== nextProps.rowHeight) {
	        this._topGridHeight = null;
	      }
	
	      if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
	        var newState = {};
	
	        if (nextProps.scrollLeft != null && nextProps.scrollLeft >= 0) {
	          newState.scrollLeft = nextProps.scrollLeft;
	        }
	
	        if (nextProps.scrollTop != null && nextProps.scrollTop >= 0) {
	          newState.scrollTop = nextProps.scrollTop;
	        }
	
	        this.setState(newState);
	      }
	
	      this._maybeCalculateCachedStyles(this.props, nextProps, this.state, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          onScroll = _props5.onScroll,
	          onSectionRendered = _props5.onSectionRendered,
	          onScrollbarPresenceChange = _props5.onScrollbarPresenceChange,
	          scrollLeftProp = _props5.scrollLeft,
	          scrollToColumn = _props5.scrollToColumn,
	          scrollTopProp = _props5.scrollTop,
	          scrollToRow = _props5.scrollToRow,
	          rest = (0, _objectWithoutProperties3.default)(_props5, ['onScroll', 'onSectionRendered', 'onScrollbarPresenceChange', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);
	
	      // Don't render any of our Grids if there are no cells.
	      // This mirrors what Grid does,
	      // And prevents us from recording inaccurage measurements when used with CellMeasurer.
	
	      if (this.props.width === 0 || this.props.height === 0) {
	        return null;
	      }
	
	      // scrollTop and scrollLeft props are explicitly filtered out and ignored
	
	      var _state = this.state,
	          scrollLeft = _state.scrollLeft,
	          scrollTop = _state.scrollTop;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: this._containerOuterStyle },
	        _react2.default.createElement(
	          'div',
	          { style: this._containerTopStyle },
	          this._renderTopLeftGrid(rest),
	          this._renderTopRightGrid((0, _extends3.default)({}, rest, {
	            onScroll: onScroll,
	            scrollLeft: scrollLeft
	          }))
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: this._containerBottomStyle },
	          this._renderBottomLeftGrid((0, _extends3.default)({}, rest, {
	            onScroll: onScroll,
	            scrollTop: scrollTop
	          })),
	          this._renderBottomRightGrid((0, _extends3.default)({}, rest, {
	            onScroll: onScroll,
	            onSectionRendered: onSectionRendered,
	            scrollLeft: scrollLeft,
	            scrollToColumn: scrollToColumn,
	            scrollToRow: scrollToRow,
	            scrollTop: scrollTop
	          }))
	        )
	      );
	    }
	  }, {
	    key: '_bottomLeftGridRef',
	    value: function _bottomLeftGridRef(ref) {
	      this._bottomLeftGrid = ref;
	    }
	  }, {
	    key: '_bottomRightGridRef',
	    value: function _bottomRightGridRef(ref) {
	      this._bottomRightGrid = ref;
	    }
	  }, {
	    key: '_cellRendererBottomLeftGrid',
	    value: function _cellRendererBottomLeftGrid(_ref3) {
	      var rowIndex = _ref3.rowIndex,
	          rest = (0, _objectWithoutProperties3.default)(_ref3, ['rowIndex']);
	      var _props6 = this.props,
	          cellRenderer = _props6.cellRenderer,
	          fixedRowCount = _props6.fixedRowCount,
	          rowCount = _props6.rowCount;
	
	
	      if (rowIndex === rowCount - fixedRowCount) {
	        return _react2.default.createElement('div', {
	          key: rest.key,
	          style: (0, _extends3.default)({}, rest.style, {
	            height: SCROLLBAR_SIZE_BUFFER
	          })
	        });
	      } else {
	        return cellRenderer((0, _extends3.default)({}, rest, {
	          parent: this,
	          rowIndex: rowIndex + fixedRowCount
	        }));
	      }
	    }
	  }, {
	    key: '_cellRendererBottomRightGrid',
	    value: function _cellRendererBottomRightGrid(_ref4) {
	      var columnIndex = _ref4.columnIndex,
	          rowIndex = _ref4.rowIndex,
	          rest = (0, _objectWithoutProperties3.default)(_ref4, ['columnIndex', 'rowIndex']);
	      var _props7 = this.props,
	          cellRenderer = _props7.cellRenderer,
	          fixedColumnCount = _props7.fixedColumnCount,
	          fixedRowCount = _props7.fixedRowCount;
	
	
	      return cellRenderer((0, _extends3.default)({}, rest, {
	        columnIndex: columnIndex + fixedColumnCount,
	        parent: this,
	        rowIndex: rowIndex + fixedRowCount
	      }));
	    }
	  }, {
	    key: '_cellRendererTopRightGrid',
	    value: function _cellRendererTopRightGrid(_ref5) {
	      var columnIndex = _ref5.columnIndex,
	          rest = (0, _objectWithoutProperties3.default)(_ref5, ['columnIndex']);
	      var _props8 = this.props,
	          cellRenderer = _props8.cellRenderer,
	          columnCount = _props8.columnCount,
	          fixedColumnCount = _props8.fixedColumnCount;
	
	
	      if (columnIndex === columnCount - fixedColumnCount) {
	        return _react2.default.createElement('div', {
	          key: rest.key,
	          style: (0, _extends3.default)({}, rest.style, {
	            width: SCROLLBAR_SIZE_BUFFER
	          })
	        });
	      } else {
	        return cellRenderer((0, _extends3.default)({}, rest, {
	          columnIndex: columnIndex + fixedColumnCount,
	          parent: this
	        }));
	      }
	    }
	  }, {
	    key: '_columnWidthRightGrid',
	    value: function _columnWidthRightGrid(_ref6) {
	      var index = _ref6.index;
	      var _props9 = this.props,
	          columnCount = _props9.columnCount,
	          fixedColumnCount = _props9.fixedColumnCount,
	          columnWidth = _props9.columnWidth;
	      var _state2 = this.state,
	          scrollbarSize = _state2.scrollbarSize,
	          showHorizontalScrollbar = _state2.showHorizontalScrollbar;
	
	      // An extra cell is added to the count
	      // This gives the smaller Grid extra room for offset,
	      // In case the main (bottom right) Grid has a scrollbar
	      // If no scrollbar, the extra space is overflow:hidden anyway
	
	      if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
	        return scrollbarSize;
	      }
	
	      return typeof columnWidth === 'function' ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
	    }
	  }, {
	    key: '_getBottomGridHeight',
	    value: function _getBottomGridHeight(props) {
	      var height = props.height;
	
	
	      var topGridHeight = this._getTopGridHeight(props);
	
	      return height - topGridHeight;
	    }
	  }, {
	    key: '_getLeftGridWidth',
	    value: function _getLeftGridWidth(props) {
	      var fixedColumnCount = props.fixedColumnCount,
	          columnWidth = props.columnWidth;
	
	
	      if (this._leftGridWidth == null) {
	        if (typeof columnWidth === 'function') {
	          var leftGridWidth = 0;
	
	          for (var index = 0; index < fixedColumnCount; index++) {
	            leftGridWidth += columnWidth({ index: index });
	          }
	
	          this._leftGridWidth = leftGridWidth;
	        } else {
	          this._leftGridWidth = columnWidth * fixedColumnCount;
	        }
	      }
	
	      return this._leftGridWidth;
	    }
	  }, {
	    key: '_getRightGridWidth',
	    value: function _getRightGridWidth(props) {
	      var width = props.width;
	
	
	      var leftGridWidth = this._getLeftGridWidth(props);
	
	      return width - leftGridWidth;
	    }
	  }, {
	    key: '_getTopGridHeight',
	    value: function _getTopGridHeight(props) {
	      var fixedRowCount = props.fixedRowCount,
	          rowHeight = props.rowHeight;
	
	
	      if (this._topGridHeight == null) {
	        if (typeof rowHeight === 'function') {
	          var topGridHeight = 0;
	
	          for (var index = 0; index < fixedRowCount; index++) {
	            topGridHeight += rowHeight({ index: index });
	          }
	
	          this._topGridHeight = topGridHeight;
	        } else {
	          this._topGridHeight = rowHeight * fixedRowCount;
	        }
	      }
	
	      return this._topGridHeight;
	    }
	  }, {
	    key: '_handleInvalidatedGridSize',
	    value: function _handleInvalidatedGridSize() {
	      if (typeof this._deferredInvalidateColumnIndex === 'number') {
	        var columnIndex = this._deferredInvalidateColumnIndex;
	        var rowIndex = this._deferredInvalidateRowIndex;
	
	        this._deferredInvalidateColumnIndex = null;
	        this._deferredInvalidateRowIndex = null;
	
	        this.recomputeGridSize({
	          columnIndex: columnIndex,
	          rowIndex: rowIndex
	        });
	        this.forceUpdate();
	      }
	    }
	
	    /**
	     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
	     * This method recalculates styles only when specific props change.
	     */
	
	  }, {
	    key: '_maybeCalculateCachedStyles',
	    value: function _maybeCalculateCachedStyles(prevProps, props) {
	      var columnWidth = props.columnWidth,
	          enableFixedColumnScroll = props.enableFixedColumnScroll,
	          enableFixedRowScroll = props.enableFixedRowScroll,
	          height = props.height,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          rowHeight = props.rowHeight,
	          style = props.style,
	          styleBottomLeftGrid = props.styleBottomLeftGrid,
	          styleBottomRightGrid = props.styleBottomRightGrid,
	          styleTopLeftGrid = props.styleTopLeftGrid,
	          styleTopRightGrid = props.styleTopRightGrid,
	          width = props.width;
	
	
	      var firstRender = !prevProps;
	      var sizeChange = firstRender || height !== prevProps.height || width !== prevProps.width;
	      var leftSizeChange = firstRender || columnWidth !== prevProps.columnWidth || fixedColumnCount !== prevProps.fixedColumnCount;
	      var topSizeChange = firstRender || fixedRowCount !== prevProps.fixedRowCount || rowHeight !== prevProps.rowHeight;
	
	      if (firstRender || sizeChange || style !== prevProps.style) {
	        this._containerOuterStyle = (0, _extends3.default)({
	          height: height,
	          overflow: 'visible', // Let :focus outline show through
	          width: width
	        }, style);
	      }
	
	      if (firstRender || sizeChange || topSizeChange) {
	        this._containerTopStyle = {
	          height: this._getTopGridHeight(props),
	          position: 'relative',
	          width: width
	        };
	
	        this._containerBottomStyle = {
	          height: height - this._getTopGridHeight(props),
	          overflow: 'visible', // Let :focus outline show through
	          position: 'relative',
	          width: width
	        };
	      }
	
	      if (firstRender || styleBottomLeftGrid !== prevProps.styleBottomLeftGrid) {
	        this._bottomLeftGridStyle = (0, _extends3.default)({
	          left: 0,
	          overflowX: 'hidden',
	          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
	          position: 'absolute'
	        }, styleBottomLeftGrid);
	      }
	
	      if (firstRender || leftSizeChange || styleBottomRightGrid !== prevProps.styleBottomRightGrid) {
	        this._bottomRightGridStyle = (0, _extends3.default)({
	          left: this._getLeftGridWidth(props),
	          position: 'absolute'
	        }, styleBottomRightGrid);
	      }
	
	      if (firstRender || styleTopLeftGrid !== prevProps.styleTopLeftGrid) {
	        this._topLeftGridStyle = (0, _extends3.default)({
	          left: 0,
	          overflowX: 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopLeftGrid);
	      }
	
	      if (firstRender || leftSizeChange || styleTopRightGrid !== prevProps.styleTopRightGrid) {
	        this._topRightGridStyle = (0, _extends3.default)({
	          left: this._getLeftGridWidth(props),
	          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
	          overflowY: 'hidden',
	          position: 'absolute',
	          top: 0
	        }, styleTopRightGrid);
	      }
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(scrollInfo) {
	      var scrollLeft = scrollInfo.scrollLeft,
	          scrollTop = scrollInfo.scrollTop;
	
	      this.setState({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop
	      });
	      var onScroll = this.props.onScroll;
	      if (onScroll) {
	        onScroll(scrollInfo);
	      }
	    }
	  }, {
	    key: '_onScrollbarPresenceChange',
	    value: function _onScrollbarPresenceChange(_ref7) {
	      var horizontal = _ref7.horizontal,
	          size = _ref7.size,
	          vertical = _ref7.vertical;
	      var _state3 = this.state,
	          showHorizontalScrollbar = _state3.showHorizontalScrollbar,
	          showVerticalScrollbar = _state3.showVerticalScrollbar;
	
	
	      if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
	        this.setState({
	          scrollbarSize: size,
	          showHorizontalScrollbar: horizontal,
	          showVerticalScrollbar: vertical
	        });
	
	        var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
	
	        if (typeof onScrollbarPresenceChange === 'function') {
	          onScrollbarPresenceChange({
	            horizontal: horizontal,
	            size: size,
	            vertical: vertical
	          });
	        }
	      }
	    }
	  }, {
	    key: '_onScrollLeft',
	    value: function _onScrollLeft(scrollInfo) {
	      var scrollLeft = scrollInfo.scrollLeft;
	
	      this._onScroll({
	        scrollLeft: scrollLeft,
	        scrollTop: this.state.scrollTop
	      });
	    }
	  }, {
	    key: '_onScrollTop',
	    value: function _onScrollTop(scrollInfo) {
	      var scrollTop = scrollInfo.scrollTop;
	
	      this._onScroll({
	        scrollTop: scrollTop,
	        scrollLeft: this.state.scrollLeft
	      });
	    }
	  }, {
	    key: '_renderBottomLeftGrid',
	    value: function _renderBottomLeftGrid(props) {
	      var enableFixedColumnScroll = props.enableFixedColumnScroll,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          rowCount = props.rowCount,
	          scrollTop = props.scrollTop;
	      var showVerticalScrollbar = this.state.showVerticalScrollbar;
	
	
	      if (!fixedColumnCount) {
	        return null;
	      }
	
	      var additionalRowCount = showVerticalScrollbar ? 1 : 0;
	
	      return _react2.default.createElement(_Grid2.default, (0, _extends3.default)({}, props, {
	        cellRenderer: this._cellRendererBottomLeftGrid,
	        className: this.props.classNameBottomLeftGrid,
	        columnCount: fixedColumnCount,
	        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
	        height: this._getBottomGridHeight(props),
	        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
	        ref: this._bottomLeftGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
	        rowHeight: this._rowHeightBottomGrid,
	        scrollTop: scrollTop,
	        style: this._bottomLeftGridStyle,
	        tabIndex: null,
	        width: this._getLeftGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderBottomRightGrid',
	    value: function _renderBottomRightGrid(props) {
	      var columnCount = props.columnCount,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          rowCount = props.rowCount,
	          scrollToColumn = props.scrollToColumn,
	          scrollToRow = props.scrollToRow;
	
	
	      return _react2.default.createElement(_Grid2.default, (0, _extends3.default)({}, props, {
	        cellRenderer: this._cellRendererBottomRightGrid,
	        className: this.props.classNameBottomRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount),
	        columnWidth: this._columnWidthRightGrid,
	        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
	        height: this._getBottomGridHeight(props),
	        onScroll: this._onScroll,
	        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
	        ref: this._bottomRightGridRef,
	        rowCount: Math.max(0, rowCount - fixedRowCount),
	        rowHeight: this._rowHeightBottomGrid,
	        scrollToColumn: scrollToColumn - fixedColumnCount,
	        scrollToRow: scrollToRow - fixedRowCount,
	        style: this._bottomRightGridStyle,
	        width: this._getRightGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopLeftGrid',
	    value: function _renderTopLeftGrid(props) {
	      var fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount;
	
	
	      if (!fixedColumnCount || !fixedRowCount) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Grid2.default, (0, _extends3.default)({}, props, {
	        className: this.props.classNameTopLeftGrid,
	        columnCount: fixedColumnCount,
	        height: this._getTopGridHeight(props),
	        ref: this._topLeftGridRef,
	        rowCount: fixedRowCount,
	        style: this._topLeftGridStyle,
	        tabIndex: null,
	        width: this._getLeftGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_renderTopRightGrid',
	    value: function _renderTopRightGrid(props) {
	      var columnCount = props.columnCount,
	          enableFixedRowScroll = props.enableFixedRowScroll,
	          fixedColumnCount = props.fixedColumnCount,
	          fixedRowCount = props.fixedRowCount,
	          scrollLeft = props.scrollLeft;
	      var showHorizontalScrollbar = this.state.showHorizontalScrollbar;
	
	
	      if (!fixedRowCount) {
	        return null;
	      }
	
	      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0;
	
	      return _react2.default.createElement(_Grid2.default, (0, _extends3.default)({}, props, {
	        cellRenderer: this._cellRendererTopRightGrid,
	        className: this.props.classNameTopRightGrid,
	        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
	        columnWidth: this._columnWidthRightGrid,
	        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
	        height: this._getTopGridHeight(props),
	        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
	        ref: this._topRightGridRef,
	        rowCount: fixedRowCount,
	        scrollLeft: scrollLeft,
	        style: this._topRightGridStyle,
	        tabIndex: null,
	        width: this._getRightGridWidth(props)
	      }));
	    }
	  }, {
	    key: '_rowHeightBottomGrid',
	    value: function _rowHeightBottomGrid(_ref8) {
	      var index = _ref8.index;
	      var _props10 = this.props,
	          fixedRowCount = _props10.fixedRowCount,
	          rowCount = _props10.rowCount,
	          rowHeight = _props10.rowHeight;
	      var _state4 = this.state,
	          scrollbarSize = _state4.scrollbarSize,
	          showVerticalScrollbar = _state4.showVerticalScrollbar;
	
	      // An extra cell is added to the count
	      // This gives the smaller Grid extra room for offset,
	      // In case the main (bottom right) Grid has a scrollbar
	      // If no scrollbar, the extra space is overflow:hidden anyway
	
	      if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
	        return scrollbarSize;
	      }
	
	      return typeof rowHeight === 'function' ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
	    }
	  }, {
	    key: '_topLeftGridRef',
	    value: function _topLeftGridRef(ref) {
	      this._topLeftGrid = ref;
	    }
	  }, {
	    key: '_topRightGridRef',
	    value: function _topRightGridRef(ref) {
	      this._topRightGrid = ref;
	    }
	  }]);
	  return MultiGrid;
	}(_react.PureComponent);
	
	MultiGrid.defaultProps = {
	  classNameBottomLeftGrid: '',
	  classNameBottomRightGrid: '',
	  classNameTopLeftGrid: '',
	  classNameTopRightGrid: '',
	  enableFixedColumnScroll: false,
	  enableFixedRowScroll: false,
	  fixedColumnCount: 0,
	  fixedRowCount: 0,
	  scrollToColumn: -1,
	  scrollToRow: -1,
	  style: {},
	  styleBottomLeftGrid: {},
	  styleBottomRightGrid: {},
	  styleTopLeftGrid: {},
	  styleTopRightGrid: {}
	};
	exports.default = MultiGrid;
	MultiGrid.propTypes =  false ? {
	  classNameBottomLeftGrid: _propTypes2.default.string.isRequired,
	  classNameBottomRightGrid: _propTypes2.default.string.isRequired,
	  classNameTopLeftGrid: _propTypes2.default.string.isRequired,
	  classNameTopRightGrid: _propTypes2.default.string.isRequired,
	  enableFixedColumnScroll: _propTypes2.default.bool.isRequired,
	  enableFixedRowScroll: _propTypes2.default.bool.isRequired,
	  fixedColumnCount: _propTypes2.default.number.isRequired,
	  fixedRowCount: _propTypes2.default.number.isRequired,
	  onScrollbarPresenceChange: _propTypes2.default.func,
	  style: _propTypes2.default.object.isRequired,
	  styleBottomLeftGrid: _propTypes2.default.object.isRequired,
	  styleBottomRightGrid: _propTypes2.default.object.isRequired,
	  styleTopLeftGrid: _propTypes2.default.object.isRequired,
	  styleTopRightGrid: _propTypes2.default.object.isRequired
	} : {};

/***/ }),
/* 6402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MultiGrid = undefined;
	
	var _MultiGrid = __webpack_require__(6401);
	
	var _MultiGrid2 = _interopRequireDefault(_MultiGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MultiGrid2.default;
	exports.MultiGrid = _MultiGrid2.default;

/***/ }),
/* 6403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
	 */
	var ScrollSync = function (_PureComponent) {
	  (0, _inherits3.default)(ScrollSync, _PureComponent);
	
	  function ScrollSync(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollSync);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollSync.__proto__ || (0, _getPrototypeOf2.default)(ScrollSync)).call(this, props, context));
	
	    _this.state = {
	      clientHeight: 0,
	      clientWidth: 0,
	      scrollHeight: 0,
	      scrollLeft: 0,
	      scrollTop: 0,
	      scrollWidth: 0
	    };
	
	    _this._onScroll = _this._onScroll.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(ScrollSync, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	      var _state = this.state,
	          clientHeight = _state.clientHeight,
	          clientWidth = _state.clientWidth,
	          scrollHeight = _state.scrollHeight,
	          scrollLeft = _state.scrollLeft,
	          scrollTop = _state.scrollTop,
	          scrollWidth = _state.scrollWidth;
	
	
	      return children({
	        clientHeight: clientHeight,
	        clientWidth: clientWidth,
	        onScroll: this._onScroll,
	        scrollHeight: scrollHeight,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        scrollWidth: scrollWidth
	      });
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref) {
	      var clientHeight = _ref.clientHeight,
	          clientWidth = _ref.clientWidth,
	          scrollHeight = _ref.scrollHeight,
	          scrollLeft = _ref.scrollLeft,
	          scrollTop = _ref.scrollTop,
	          scrollWidth = _ref.scrollWidth;
	
	      this.setState({
	        clientHeight: clientHeight,
	        clientWidth: clientWidth,
	        scrollHeight: scrollHeight,
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        scrollWidth: scrollWidth
	      });
	    }
	  }]);
	  return ScrollSync;
	}(_react.PureComponent);
	
	exports.default = ScrollSync;
	ScrollSync.propTypes =  false ? {
	  /**
	   * Function responsible for rendering 2 or more virtualized components.
	   * This function should implement the following signature:
	   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
	   */
	  children: _propTypes2.default.func.isRequired
	} : {};

/***/ }),
/* 6404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScrollSync = undefined;
	
	var _ScrollSync = __webpack_require__(6403);
	
	var _ScrollSync2 = _interopRequireDefault(_ScrollSync);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ScrollSync2.default;
	exports.ScrollSync = _ScrollSync2.default;

/***/ }),
/* 6405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(25);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(19);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(27);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(26);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Column = __webpack_require__(2857);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _Grid2 = __webpack_require__(191);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _defaultRowRenderer = __webpack_require__(2863);
	
	var _defaultRowRenderer2 = _interopRequireDefault(_defaultRowRenderer);
	
	var _defaultHeaderRowRenderer = __webpack_require__(2862);
	
	var _defaultHeaderRowRenderer2 = _interopRequireDefault(_defaultHeaderRowRenderer);
	
	var _SortDirection = __webpack_require__(1048);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_CellPosition = __webpack_require__(191).babelPluginFlowReactPropTypes_proptype_CellPosition || __webpack_require__(2).any;
	
	/**
	 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
	 * This component expects explicit width, height, and padding parameters.
	 */
	var Table = function (_PureComponent) {
	  (0, _inherits3.default)(Table, _PureComponent);
	
	  function Table(props) {
	    (0, _classCallCheck3.default)(this, Table);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call(this, props));
	
	    _this.state = {
	      scrollbarWidth: 0
	    };
	
	    _this._createColumn = _this._createColumn.bind(_this);
	    _this._createRow = _this._createRow.bind(_this);
	    _this._onScroll = _this._onScroll.bind(_this);
	    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
	    _this._setRef = _this._setRef.bind(_this);
	    return _this;
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'forceUpdateGrid',
	    value: function forceUpdateGrid() {
	      if (this.Grid) {
	        this.Grid.forceUpdate();
	      }
	    }
	
	    /** See Grid#getOffsetForCell */
	
	  }, {
	    key: 'getOffsetForRow',
	    value: function getOffsetForRow(_ref) {
	      var alignment = _ref.alignment,
	          index = _ref.index;
	
	      if (this.Grid) {
	        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
	          alignment: alignment,
	          rowIndex: index
	        }),
	            scrollTop = _Grid$getOffsetForCel.scrollTop;
	
	        return scrollTop;
	      }
	      return 0;
	    }
	
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: 'invalidateCellSizeAfterRender',
	    value: function invalidateCellSizeAfterRender(_ref2) {
	      var columnIndex = _ref2.columnIndex,
	          rowIndex = _ref2.rowIndex;
	
	      if (this.Grid) {
	        this.Grid.invalidateCellSizeAfterRender({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	
	    /** See Grid#measureAllCells */
	
	  }, {
	    key: 'measureAllRows',
	    value: function measureAllRows() {
	      if (this.Grid) {
	        this.Grid.measureAllCells();
	      }
	    }
	
	    /** CellMeasurer compatibility */
	
	  }, {
	    key: 'recomputeGridSize',
	    value: function recomputeGridSize() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref3$columnIndex = _ref3.columnIndex,
	          columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex,
	          _ref3$rowIndex = _ref3.rowIndex,
	          rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: rowIndex,
	          columnIndex: columnIndex
	        });
	      }
	    }
	
	    /** See Grid#recomputeGridSize */
	
	  }, {
	    key: 'recomputeRowHeights',
	    value: function recomputeRowHeights() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.recomputeGridSize({
	          rowIndex: index
	        });
	      }
	    }
	
	    /** See Grid#scrollToPosition */
	
	  }, {
	    key: 'scrollToPosition',
	    value: function scrollToPosition() {
	      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToPosition({ scrollTop: scrollTop });
	      }
	    }
	
	    /** See Grid#scrollToCell */
	
	  }, {
	    key: 'scrollToRow',
	    value: function scrollToRow() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this.Grid) {
	        this.Grid.scrollToCell({
	          columnIndex: 0,
	          rowIndex: index
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._setScrollbarWidth();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          disableHeader = _props.disableHeader,
	          gridClassName = _props.gridClassName,
	          gridStyle = _props.gridStyle,
	          headerHeight = _props.headerHeight,
	          headerRowRenderer = _props.headerRowRenderer,
	          height = _props.height,
	          id = _props.id,
	          noRowsRenderer = _props.noRowsRenderer,
	          rowClassName = _props.rowClassName,
	          rowStyle = _props.rowStyle,
	          scrollToIndex = _props.scrollToIndex,
	          style = _props.style,
	          width = _props.width;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var availableRowsHeight = disableHeader ? height : height - headerHeight;
	
	      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: -1 }) : rowClassName;
	      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: -1 }) : rowStyle;
	
	      // Precompute and cache column styles before rendering rows and columns to speed things up
	      this._cachedColumnStyles = [];
	      _react2.default.Children.toArray(children).forEach(function (column, index) {
	        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);
	
	        _this2._cachedColumnStyles[index] = (0, _extends3.default)({}, flexStyles, {
	          overflow: 'hidden'
	        });
	      });
	
	      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
	      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
	      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('ReactVirtualized__Table', className),
	          id: id,
	          role: 'grid',
	          style: style },
	        !disableHeader && headerRowRenderer({
	          className: (0, _classnames2.default)('ReactVirtualized__Table__headerRow', rowClass),
	          columns: this._getHeaderColumns(),
	          style: (0, _extends3.default)({}, rowStyleObject, {
	            height: headerHeight,
	            overflow: 'hidden',
	            paddingRight: scrollbarWidth,
	            width: width
	          })
	        }),
	        _react2.default.createElement(_Grid3.default, (0, _extends3.default)({}, this.props, {
	          autoContainerWidth: true,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__Grid', gridClassName),
	          cellRenderer: this._createRow,
	          columnWidth: width,
	          columnCount: 1,
	          height: availableRowsHeight,
	          id: undefined,
	          noContentRenderer: noRowsRenderer,
	          onScroll: this._onScroll,
	          onSectionRendered: this._onSectionRendered,
	          ref: this._setRef,
	          role: 'rowgroup',
	          scrollbarWidth: scrollbarWidth,
	          scrollToRow: scrollToIndex,
	          style: (0, _extends3.default)({}, gridStyle, {
	            overflowX: 'hidden'
	          })
	        }))
	      );
	    }
	  }, {
	    key: '_createColumn',
	    value: function _createColumn(_ref4) {
	      var column = _ref4.column,
	          columnIndex = _ref4.columnIndex,
	          isScrolling = _ref4.isScrolling,
	          parent = _ref4.parent,
	          rowData = _ref4.rowData,
	          rowIndex = _ref4.rowIndex;
	      var _column$props = column.props,
	          cellDataGetter = _column$props.cellDataGetter,
	          cellRenderer = _column$props.cellRenderer,
	          className = _column$props.className,
	          columnData = _column$props.columnData,
	          dataKey = _column$props.dataKey,
	          id = _column$props.id;
	
	
	      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
	      var renderedCell = cellRenderer({
	        cellData: cellData,
	        columnData: columnData,
	        columnIndex: columnIndex,
	        dataKey: dataKey,
	        isScrolling: isScrolling,
	        parent: parent,
	        rowData: rowData,
	        rowIndex: rowIndex
	      });
	
	      var style = this._cachedColumnStyles[columnIndex];
	
	      var title = typeof renderedCell === 'string' ? renderedCell : null;
	
	      // Avoid using object-spread syntax with multiple objects here,
	      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
	      // See PR https://github.com/bvaughn/react-virtualized/pull/942
	      return _react2.default.createElement(
	        'div',
	        {
	          'aria-describedby': id,
	          className: (0, _classnames2.default)('ReactVirtualized__Table__rowColumn', className),
	          key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
	          role: 'gridcell',
	          style: style,
	          title: title },
	        renderedCell
	      );
	    }
	  }, {
	    key: '_createHeader',
	    value: function _createHeader(_ref5) {
	      var column = _ref5.column,
	          index = _ref5.index;
	      var _props2 = this.props,
	          headerClassName = _props2.headerClassName,
	          headerStyle = _props2.headerStyle,
	          onHeaderClick = _props2.onHeaderClick,
	          sort = _props2.sort,
	          sortBy = _props2.sortBy,
	          sortDirection = _props2.sortDirection;
	      var _column$props2 = column.props,
	          columnData = _column$props2.columnData,
	          dataKey = _column$props2.dataKey,
	          defaultSortDirection = _column$props2.defaultSortDirection,
	          disableSort = _column$props2.disableSort,
	          headerRenderer = _column$props2.headerRenderer,
	          id = _column$props2.id,
	          label = _column$props2.label;
	
	      var sortEnabled = !disableSort && sort;
	
	      var classNames = (0, _classnames2.default)('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
	        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
	      });
	      var style = this._getFlexStyleForColumn(column, (0, _extends3.default)({}, headerStyle, column.props.headerStyle));
	
	      var renderedHeader = headerRenderer({
	        columnData: columnData,
	        dataKey: dataKey,
	        disableSort: disableSort,
	        label: label,
	        sortBy: sortBy,
	        sortDirection: sortDirection
	      });
	
	      var headerOnClick = void 0,
	          headerOnKeyDown = void 0,
	          headerTabIndex = void 0,
	          headerAriaSort = void 0,
	          headerAriaLabel = void 0;
	
	      if (sortEnabled || onHeaderClick) {
	        // If this is a sortable header, clicking it should update the table data's sorting.
	        var isFirstTimeSort = sortBy !== dataKey;
	
	        // If this is the firstTime sort of this column, use the column default sort order.
	        // Otherwise, invert the direction of the sort.
	        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === _SortDirection2.default.DESC ? _SortDirection2.default.ASC : _SortDirection2.default.DESC;
	
	        var onClick = function onClick(event) {
	          sortEnabled && sort({
	            defaultSortDirection: defaultSortDirection,
	            event: event,
	            sortBy: dataKey,
	            sortDirection: newSortDirection
	          });
	          onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey, event: event });
	        };
	
	        var onKeyDown = function onKeyDown(event) {
	          if (event.key === 'Enter' || event.key === ' ') {
	            onClick(event);
	          }
	        };
	
	        headerAriaLabel = column.props['aria-label'] || label || dataKey;
	        headerTabIndex = 0;
	        headerOnClick = onClick;
	        headerOnKeyDown = onKeyDown;
	      }
	
	      if (sortBy === dataKey) {
	        headerAriaSort = sortDirection === _SortDirection2.default.ASC ? 'ascending' : 'descending';
	      }
	
	      // Avoid using object-spread syntax with multiple objects here,
	      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
	      // See PR https://github.com/bvaughn/react-virtualized/pull/942
	      return _react2.default.createElement(
	        'div',
	        {
	          'aria-label': headerAriaLabel,
	          'aria-sort': headerAriaSort,
	          className: classNames,
	          id: id,
	          key: 'Header-Col' + index,
	          onClick: headerOnClick,
	          onKeyDown: headerOnKeyDown,
	          role: 'columnheader',
	          style: style,
	          tabIndex: headerTabIndex },
	        renderedHeader
	      );
	    }
	  }, {
	    key: '_createRow',
	    value: function _createRow(_ref6) {
	      var _this3 = this;
	
	      var index = _ref6.rowIndex,
	          isScrolling = _ref6.isScrolling,
	          key = _ref6.key,
	          parent = _ref6.parent,
	          style = _ref6.style;
	      var _props3 = this.props,
	          children = _props3.children,
	          onRowClick = _props3.onRowClick,
	          onRowDoubleClick = _props3.onRowDoubleClick,
	          onRowRightClick = _props3.onRowRightClick,
	          onRowMouseOver = _props3.onRowMouseOver,
	          onRowMouseOut = _props3.onRowMouseOut,
	          rowClassName = _props3.rowClassName,
	          rowGetter = _props3.rowGetter,
	          rowRenderer = _props3.rowRenderer,
	          rowStyle = _props3.rowStyle;
	      var scrollbarWidth = this.state.scrollbarWidth;
	
	
	      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: index }) : rowClassName;
	      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: index }) : rowStyle;
	      var rowData = rowGetter({ index: index });
	
	      var columns = _react2.default.Children.toArray(children).map(function (column, columnIndex) {
	        return _this3._createColumn({
	          column: column,
	          columnIndex: columnIndex,
	          isScrolling: isScrolling,
	          parent: parent,
	          rowData: rowData,
	          rowIndex: index,
	          scrollbarWidth: scrollbarWidth
	        });
	      });
	
	      var className = (0, _classnames2.default)('ReactVirtualized__Table__row', rowClass);
	      var flattenedStyle = (0, _extends3.default)({}, style, rowStyleObject, {
	        height: this._getRowHeight(index),
	        overflow: 'hidden',
	        paddingRight: scrollbarWidth
	      });
	
	      return rowRenderer({
	        className: className,
	        columns: columns,
	        index: index,
	        isScrolling: isScrolling,
	        key: key,
	        onRowClick: onRowClick,
	        onRowDoubleClick: onRowDoubleClick,
	        onRowRightClick: onRowRightClick,
	        onRowMouseOver: onRowMouseOver,
	        onRowMouseOut: onRowMouseOut,
	        rowData: rowData,
	        style: flattenedStyle
	      });
	    }
	
	    /**
	     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
	     */
	
	  }, {
	    key: '_getFlexStyleForColumn',
	    value: function _getFlexStyleForColumn(column) {
	      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';
	
	      var style = (0, _extends3.default)({}, customStyle, {
	        flex: flexValue,
	        msFlex: flexValue,
	        WebkitFlex: flexValue
	      });
	
	      if (column.props.maxWidth) {
	        style.maxWidth = column.props.maxWidth;
	      }
	
	      if (column.props.minWidth) {
	        style.minWidth = column.props.minWidth;
	      }
	
	      return style;
	    }
	  }, {
	    key: '_getHeaderColumns',
	    value: function _getHeaderColumns() {
	      var _this4 = this;
	
	      var _props4 = this.props,
	          children = _props4.children,
	          disableHeader = _props4.disableHeader;
	
	      var items = disableHeader ? [] : _react2.default.Children.toArray(children);
	
	      return items.map(function (column, index) {
	        return _this4._createHeader({ column: column, index: index });
	      });
	    }
	  }, {
	    key: '_getRowHeight',
	    value: function _getRowHeight(rowIndex) {
	      var rowHeight = this.props.rowHeight;
	
	
	      return typeof rowHeight === 'function' ? rowHeight({ index: rowIndex }) : rowHeight;
	    }
	  }, {
	    key: '_onScroll',
	    value: function _onScroll(_ref7) {
	      var clientHeight = _ref7.clientHeight,
	          scrollHeight = _ref7.scrollHeight,
	          scrollTop = _ref7.scrollTop;
	      var onScroll = this.props.onScroll;
	
	
	      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
	    }
	  }, {
	    key: '_onSectionRendered',
	    value: function _onSectionRendered(_ref8) {
	      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
	          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
	          rowStartIndex = _ref8.rowStartIndex,
	          rowStopIndex = _ref8.rowStopIndex;
	      var onRowsRendered = this.props.onRowsRendered;
	
	
	      onRowsRendered({
	        overscanStartIndex: rowOverscanStartIndex,
	        overscanStopIndex: rowOverscanStopIndex,
	        startIndex: rowStartIndex,
	        stopIndex: rowStopIndex
	      });
	    }
	  }, {
	    key: '_setRef',
	    value: function _setRef(ref) {
	      this.Grid = ref;
	    }
	  }, {
	    key: '_setScrollbarWidth',
	    value: function _setScrollbarWidth() {
	      if (this.Grid) {
	        var _Grid = (0, _reactDom.findDOMNode)(this.Grid);
	        var clientWidth = _Grid.clientWidth || 0;
	        var offsetWidth = _Grid.offsetWidth || 0;
	        var scrollbarWidth = offsetWidth - clientWidth;
	
	        this.setState({ scrollbarWidth: scrollbarWidth });
	      }
	    }
	  }]);
	  return Table;
	}(_react.PureComponent);
	
	Table.defaultProps = {
	  disableHeader: false,
	  estimatedRowSize: 30,
	  headerHeight: 0,
	  headerStyle: {},
	  noRowsRenderer: function noRowsRenderer() {
	    return null;
	  },
	  onRowsRendered: function onRowsRendered() {
	    return null;
	  },
	  onScroll: function onScroll() {
	    return null;
	  },
	  overscanIndicesGetter: _Grid2.accessibilityOverscanIndicesGetter,
	  overscanRowCount: 10,
	  rowRenderer: _defaultRowRenderer2.default,
	  headerRowRenderer: _defaultHeaderRowRenderer2.default,
	  rowStyle: {},
	  scrollToAlignment: 'auto',
	  scrollToIndex: -1,
	  style: {}
	};
	exports.default = Table;
	Table.propTypes =  false ? {
	  'aria-label': _propTypes2.default.string,
	
	  /**
	   * Removes fixed height from the scrollingContainer so that the total height
	   * of rows can stretch the window. Intended for use with WindowScroller
	   */
	  autoHeight: _propTypes2.default.bool,
	
	  /** One or more Columns describing the data displayed in this row */
	  children: function children(props) {
	    var children = _react2.default.Children.toArray(props.children);
	    for (var i = 0; i < children.length; i++) {
	      var childType = children[i].type;
	      if (childType !== _Column2.default && !(childType.prototype instanceof _Column2.default)) {
	        return new Error('Table only accepts children of type Column');
	      }
	    }
	  },
	
	  /** Optional CSS class name */
	  className: _propTypes2.default.string,
	
	  /** Disable rendering the header at all */
	  disableHeader: _propTypes2.default.bool,
	
	  /**
	   * Used to estimate the total height of a Table before all of its rows have actually been measured.
	   * The estimated total height is adjusted as rows are rendered.
	   */
	  estimatedRowSize: _propTypes2.default.number.isRequired,
	
	  /** Optional custom CSS class name to attach to inner Grid element. */
	  gridClassName: _propTypes2.default.string,
	
	  /** Optional inline style to attach to inner Grid element. */
	  gridStyle: _propTypes2.default.object,
	
	  /** Optional CSS class to apply to all column headers */
	  headerClassName: _propTypes2.default.string,
	
	  /** Fixed height of header row */
	  headerHeight: _propTypes2.default.number.isRequired,
	
	  /**
	   * Responsible for rendering a table row given an array of columns:
	   * Should implement the following interface: ({
	   *   className: string,
	   *   columns: any[],
	   *   style: any
	   * }): PropTypes.node
	   */
	  headerRowRenderer: _propTypes2.default.func,
	
	  /** Optional custom inline style to attach to table header columns. */
	  headerStyle: _propTypes2.default.object,
	
	  /** Fixed/available height for out DOM element */
	  height: _propTypes2.default.number.isRequired,
	
	  /** Optional id */
	  id: _propTypes2.default.string,
	
	  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
	  noRowsRenderer: _propTypes2.default.func,
	
	  /**
	   * Optional callback when a column's header is clicked.
	   * ({ columnData: any, dataKey: string }): void
	   */
	  onHeaderClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user double-clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowDoubleClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when the mouse leaves a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOut: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user moves the mouse over a table row.
	   * ({ index: number }): void
	   */
	  onRowMouseOver: _propTypes2.default.func,
	
	  /**
	   * Callback invoked when a user right-clicks on a table row.
	   * ({ index: number }): void
	   */
	  onRowRightClick: _propTypes2.default.func,
	
	  /**
	   * Callback invoked with information about the slice of rows that were just rendered.
	   * ({ startIndex, stopIndex }): void
	   */
	  onRowsRendered: _propTypes2.default.func,
	
	  /**
	   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
	   * This callback can be used to sync scrolling between lists, tables, or grids.
	   * ({ clientHeight, scrollHeight, scrollTop }): void
	   */
	  onScroll: _propTypes2.default.func.isRequired,
	
	  /** See Grid#overscanIndicesGetter */
	  overscanIndicesGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Number of rows to render above/below the visible bounds of the list.
	   * These rows can help for smoother scrolling on touch devices.
	   */
	  overscanRowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Optional CSS class to apply to all table rows (including the header row).
	   * This property can be a CSS class name (string) or a function that returns a class name.
	   * If a function is provided its signature should be: ({ index: number }): string
	   */
	  rowClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	
	  /**
	   * Callback responsible for returning a data row given an index.
	   * ({ index: number }): any
	   */
	  rowGetter: _propTypes2.default.func.isRequired,
	
	  /**
	   * Either a fixed row height (number) or a function that returns the height of a row given its index.
	   * ({ index: number }): number
	   */
	  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  /** Number of rows in table. */
	  rowCount: _propTypes2.default.number.isRequired,
	
	  /**
	   * Responsible for rendering a table row given an array of columns:
	   * Should implement the following interface: ({
	   *   className: string,
	   *   columns: Array,
	   *   index: number,
	   *   isScrolling: boolean,
	   *   onRowClick: ?Function,
	   *   onRowDoubleClick: ?Function,
	   *   onRowMouseOver: ?Function,
	   *   onRowMouseOut: ?Function,
	   *   rowData: any,
	   *   style: any
	   * }): PropTypes.node
	   */
	  rowRenderer: _propTypes2.default.func,
	
	  /** Optional custom inline style to attach to table rows. */
	  rowStyle: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired,
	
	  /** See Grid#scrollToAlignment */
	  scrollToAlignment: _propTypes2.default.oneOf(['auto', 'end', 'start', 'center']).isRequired,
	
	  /** Row index to ensure visible (by forcefully scrolling if necessary) */
	  scrollToIndex: _propTypes2.default.number.isRequired,
	
	  /** Vertical offset. */
	  scrollTop: _propTypes2.default.number,
	
	  /**
	   * Sort function to be called if a sortable header is clicked.
	   * Should implement the following interface: ({
	   *   defaultSortDirection: 'ASC' | 'DESC',
	   *   event: MouseEvent,
	   *   sortBy: string,
	   *   sortDirection: SortDirection
	   * }): void
	   */
	  sort: _propTypes2.default.func,
	
	  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
	  sortBy: _propTypes2.default.string,
	
	  /** Table data is currently sorted in this direction (if it is sorted at all) */
	  sortDirection: _propTypes2.default.oneOf([_SortDirection2.default.ASC, _SortDirection2.default.DESC]),
	
	  /** Optional inline style */
	  style: _propTypes2.default.object,
	
	  /** Tab index for focus */
	  tabIndex: _propTypes2.default.number,
	
	  /** Width of list */
	  width: _propTypes2.default.number.isRequired
	} : {};

/***/ }),
/* 6406 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMultiSort;
	function createMultiSort(sortCallback) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      defaultSortBy = _ref.defaultSortBy,
	      _ref$defaultSortDirec = _ref.defaultSortDirection,
	      defaultSortDirection = _ref$defaultSortDirec === undefined ? {} : _ref$defaultSortDirec;
	
	  if (!sortCallback) {
	    throw Error('Required parameter "sortCallback" not specified');
	  }
	
	  var sortBy = defaultSortBy || [];
	  var sortDirection = {};
	
	  sortBy.forEach(function (dataKey) {
	    sortDirection[dataKey] = defaultSortDirection.hasOwnProperty(dataKey) ? defaultSortDirection[dataKey] : 'ASC';
	  });
	
	  function sort(_ref2) {
	    var defaultSortDirection = _ref2.defaultSortDirection,
	        event = _ref2.event,
	        dataKey = _ref2.sortBy;
	
	    if (event.shiftKey) {
	      // Shift + click appends a column to existing criteria
	      if (sortDirection.hasOwnProperty(dataKey)) {
	        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
	      } else {
	        sortDirection[dataKey] = defaultSortDirection;
	        sortBy.push(dataKey);
	      }
	    } else if (event.ctrlKey || event.metaKey) {
	      // Control + click removes column from sort (if pressent)
	      var index = sortBy.indexOf(dataKey);
	      if (index >= 0) {
	        sortBy.splice(index, 1);
	        delete sortDirection[dataKey];
	      }
	    } else {
	      sortBy.length = 0;
	      sortBy.push(dataKey);
	
	      if (sortDirection.hasOwnProperty(dataKey)) {
	        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
	      } else {
	        sortDirection[dataKey] = defaultSortDirection;
	      }
	    }
	
	    // Notify application code
	    sortCallback({
	      sortBy: sortBy,
	      sortDirection: sortDirection
	    });
	  }
	
	  return {
	    sort: sort,
	    sortBy: sortBy,
	    sortDirection: sortDirection
	  };
	}

/***/ }),
/* 6407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Table = exports.SortIndicator = exports.SortDirection = exports.Column = exports.defaultRowRenderer = exports.defaultHeaderRenderer = exports.defaultHeaderRowRenderer = exports.defaultCellRenderer = exports.defaultCellDataGetter = exports.createMultiSort = undefined;
	
	var _createMultiSort = __webpack_require__(6406);
	
	var _createMultiSort2 = _interopRequireDefault(_createMultiSort);
	
	var _defaultCellDataGetter = __webpack_require__(2859);
	
	var _defaultCellDataGetter2 = _interopRequireDefault(_defaultCellDataGetter);
	
	var _defaultCellRenderer = __webpack_require__(2860);
	
	var _defaultCellRenderer2 = _interopRequireDefault(_defaultCellRenderer);
	
	var _defaultHeaderRowRenderer = __webpack_require__(2862);
	
	var _defaultHeaderRowRenderer2 = _interopRequireDefault(_defaultHeaderRowRenderer);
	
	var _defaultHeaderRenderer = __webpack_require__(2861);
	
	var _defaultHeaderRenderer2 = _interopRequireDefault(_defaultHeaderRenderer);
	
	var _defaultRowRenderer = __webpack_require__(2863);
	
	var _defaultRowRenderer2 = _interopRequireDefault(_defaultRowRenderer);
	
	var _Column = __webpack_require__(2857);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _SortDirection = __webpack_require__(1048);
	
	var _SortDirection2 = _interopRequireDefault(_SortDirection);
	
	var _SortIndicator = __webpack_require__(2858);
	
	var _SortIndicator2 = _interopRequireDefault(_SortIndicator);
	
	var _Table = __webpack_require__(6405);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Table2.default;
	exports.createMultiSort = _createMultiSort2.default;
	exports.defaultCellDataGetter = _defaultCellDataGetter2.default;
	exports.defaultCellRenderer = _defaultCellRenderer2.default;
	exports.defaultHeaderRowRenderer = _defaultHeaderRowRenderer2.default;
	exports.defaultHeaderRenderer = _defaultHeaderRenderer2.default;
	exports.defaultRowRenderer = _defaultRowRenderer2.default;
	exports.Column = _Column2.default;
	exports.SortDirection = _SortDirection2.default;
	exports.SortIndicator = _SortIndicator2.default;
	exports.Table = _Table2.default;

/***/ }),
/* 6408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_SCROLLING_TIMEOUT = exports.WindowScroller = undefined;
	
	var _WindowScroller = __webpack_require__(2864);
	
	var _WindowScroller2 = _interopRequireDefault(_WindowScroller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _WindowScroller2.default;
	exports.WindowScroller = _WindowScroller2.default;
	exports.IS_SCROLLING_TIMEOUT = _WindowScroller.IS_SCROLLING_TIMEOUT;

/***/ }),
/* 6409 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDimensions = getDimensions;
	exports.getPositionOffset = getPositionOffset;
	exports.getScrollOffset = getScrollOffset;
	
	
	/**
	 * Gets the dimensions of the element, accounting for API differences between
	 * `window` and other DOM elements.
	 */
	
	var isWindow = function isWindow(element) {
	  return element === window;
	};
	
	// TODO Move this into WindowScroller and import from there
	
	
	var getBoundingBox = function getBoundingBox(element) {
	  return element.getBoundingClientRect();
	};
	
	function getDimensions(scrollElement, props) {
	  if (!scrollElement) {
	    return {
	      height: props.serverHeight,
	      width: props.serverWidth
	    };
	  } else if (isWindow(scrollElement)) {
	    var _window = window,
	        innerHeight = _window.innerHeight,
	        innerWidth = _window.innerWidth;
	
	    return {
	      height: typeof innerHeight === 'number' ? innerHeight : 0,
	      width: typeof innerWidth === 'number' ? innerWidth : 0
	    };
	  } else {
	    return getBoundingBox(scrollElement);
	  }
	}
	
	/**
	 * Gets the vertical and horizontal position of an element within its scroll container.
	 * Elements that have been “scrolled past” return negative values.
	 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
	 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
	 */
	function getPositionOffset(element, container) {
	  if (isWindow(container) && document.documentElement) {
	    var containerElement = document.documentElement;
	    var elementRect = getBoundingBox(element);
	    var containerRect = getBoundingBox(containerElement);
	    return {
	      top: elementRect.top - containerRect.top,
	      left: elementRect.left - containerRect.left
	    };
	  } else {
	    var scrollOffset = getScrollOffset(container);
	    var _elementRect = getBoundingBox(element);
	    var _containerRect = getBoundingBox(container);
	    return {
	      top: _elementRect.top + scrollOffset.top - _containerRect.top,
	      left: _elementRect.left + scrollOffset.left - _containerRect.left
	    };
	  }
	}
	
	/**
	 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
	 * and API differences between `window` and other DOM elements.
	 */
	function getScrollOffset(element) {
	  if (isWindow(element) && document.documentElement) {
	    return {
	      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
	      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
	    };
	  } else {
	    return {
	      top: element.scrollTop,
	      left: element.scrollLeft
	    };
	  }
	}

/***/ }),
/* 6410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerScrollListener = registerScrollListener;
	exports.unregisterScrollListener = unregisterScrollListener;
	
	var _requestAnimationTimeout = __webpack_require__(752);
	
	var _WindowScroller = __webpack_require__(2864);
	
	var _WindowScroller2 = _interopRequireDefault(_WindowScroller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mountedInstances = [];
	var originalBodyPointerEvents = null;
	var disablePointerEventsTimeoutId = null;
	
	function enablePointerEventsIfDisabled() {
	  if (disablePointerEventsTimeoutId) {
	    disablePointerEventsTimeoutId = null;
	
	    if (document.body && originalBodyPointerEvents != null) {
	      document.body.style.pointerEvents = originalBodyPointerEvents;
	    }
	
	    originalBodyPointerEvents = null;
	  }
	}
	
	function enablePointerEventsAfterDelayCallback() {
	  enablePointerEventsIfDisabled();
	  mountedInstances.forEach(function (instance) {
	    return instance.__resetIsScrolling();
	  });
	}
	
	function enablePointerEventsAfterDelay() {
	  if (disablePointerEventsTimeoutId) {
	    (0, _requestAnimationTimeout.cancelAnimationTimeout)(disablePointerEventsTimeoutId);
	  }
	
	  var maximumTimeout = 0;
	  mountedInstances.forEach(function (instance) {
	    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
	  });
	
	  disablePointerEventsTimeoutId = (0, _requestAnimationTimeout.requestAnimationTimeout)(enablePointerEventsAfterDelayCallback, maximumTimeout);
	}
	
	function onScrollWindow(event) {
	  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
	    originalBodyPointerEvents = document.body.style.pointerEvents;
	
	    document.body.style.pointerEvents = 'none';
	  }
	  enablePointerEventsAfterDelay();
	  mountedInstances.forEach(function (instance) {
	    if (instance.props.scrollElement === event.currentTarget) {
	      instance.__handleWindowScrollEvent();
	    }
	  });
	}
	
	function registerScrollListener(component, element) {
	  if (!mountedInstances.some(function (instance) {
	    return instance.props.scrollElement === element;
	  })) {
	    element.addEventListener('scroll', onScrollWindow);
	  }
	  mountedInstances.push(component);
	}
	
	function unregisterScrollListener(component, element) {
	  mountedInstances = mountedInstances.filter(function (instance) {
	    return instance !== component;
	  });
	  if (!mountedInstances.length) {
	    element.removeEventListener('scroll', onScrollWindow);
	    if (disablePointerEventsTimeoutId) {
	      (0, _requestAnimationTimeout.cancelAnimationTimeout)(disablePointerEventsTimeoutId);
	      enablePointerEventsIfDisabled();
	    }
	  }
	}

/***/ }),
/* 6411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ArrowKeyStepper = __webpack_require__(6374);
	
	Object.defineProperty(exports, 'ArrowKeyStepper', {
	  enumerable: true,
	  get: function get() {
	    return _ArrowKeyStepper.ArrowKeyStepper;
	  }
	});
	
	var _AutoSizer = __webpack_require__(6377);
	
	Object.defineProperty(exports, 'AutoSizer', {
	  enumerable: true,
	  get: function get() {
	    return _AutoSizer.AutoSizer;
	  }
	});
	
	var _CellMeasurer = __webpack_require__(2854);
	
	Object.defineProperty(exports, 'CellMeasurer', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.CellMeasurer;
	  }
	});
	Object.defineProperty(exports, 'CellMeasurerCache', {
	  enumerable: true,
	  get: function get() {
	    return _CellMeasurer.CellMeasurerCache;
	  }
	});
	
	var _Collection = __webpack_require__(6383);
	
	Object.defineProperty(exports, 'Collection', {
	  enumerable: true,
	  get: function get() {
	    return _Collection.Collection;
	  }
	});
	
	var _ColumnSizer = __webpack_require__(6386);
	
	Object.defineProperty(exports, 'ColumnSizer', {
	  enumerable: true,
	  get: function get() {
	    return _ColumnSizer.ColumnSizer;
	  }
	});
	
	var _Grid = __webpack_require__(191);
	
	Object.defineProperty(exports, 'accessibilityOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.accessibilityOverscanIndicesGetter;
	  }
	});
	Object.defineProperty(exports, 'defaultCellRangeRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.defaultCellRangeRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultOverscanIndicesGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.defaultOverscanIndicesGetter;
	  }
	});
	Object.defineProperty(exports, 'Grid', {
	  enumerable: true,
	  get: function get() {
	    return _Grid.Grid;
	  }
	});
	
	var _InfiniteLoader = __webpack_require__(6394);
	
	Object.defineProperty(exports, 'InfiniteLoader', {
	  enumerable: true,
	  get: function get() {
	    return _InfiniteLoader.InfiniteLoader;
	  }
	});
	
	var _List = __webpack_require__(6396);
	
	Object.defineProperty(exports, 'List', {
	  enumerable: true,
	  get: function get() {
	    return _List.List;
	  }
	});
	
	var _Masonry = __webpack_require__(6399);
	
	Object.defineProperty(exports, 'createMasonryCellPositioner', {
	  enumerable: true,
	  get: function get() {
	    return _Masonry.createCellPositioner;
	  }
	});
	Object.defineProperty(exports, 'Masonry', {
	  enumerable: true,
	  get: function get() {
	    return _Masonry.Masonry;
	  }
	});
	
	var _MultiGrid = __webpack_require__(6402);
	
	Object.defineProperty(exports, 'MultiGrid', {
	  enumerable: true,
	  get: function get() {
	    return _MultiGrid.MultiGrid;
	  }
	});
	
	var _ScrollSync = __webpack_require__(6404);
	
	Object.defineProperty(exports, 'ScrollSync', {
	  enumerable: true,
	  get: function get() {
	    return _ScrollSync.ScrollSync;
	  }
	});
	
	var _Table = __webpack_require__(6407);
	
	Object.defineProperty(exports, 'createTableMultiSort', {
	  enumerable: true,
	  get: function get() {
	    return _Table.createMultiSort;
	  }
	});
	Object.defineProperty(exports, 'defaultTableCellDataGetter', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellDataGetter;
	  }
	});
	Object.defineProperty(exports, 'defaultTableCellRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultCellRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableHeaderRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultHeaderRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableHeaderRowRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultHeaderRowRenderer;
	  }
	});
	Object.defineProperty(exports, 'defaultTableRowRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _Table.defaultRowRenderer;
	  }
	});
	Object.defineProperty(exports, 'Table', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Table;
	  }
	});
	Object.defineProperty(exports, 'Column', {
	  enumerable: true,
	  get: function get() {
	    return _Table.Column;
	  }
	});
	Object.defineProperty(exports, 'SortDirection', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortDirection;
	  }
	});
	Object.defineProperty(exports, 'SortIndicator', {
	  enumerable: true,
	  get: function get() {
	    return _Table.SortIndicator;
	  }
	});
	
	var _WindowScroller = __webpack_require__(6408);
	
	Object.defineProperty(exports, 'WindowScroller', {
	  enumerable: true,
	  get: function get() {
	    return _WindowScroller.WindowScroller;
	  }
	});

/***/ }),
/* 6412 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	// Properly handle server-side rendering.
	var win = void 0;
	
	if (typeof window !== 'undefined') {
	  win = window;
	} else if (typeof self !== 'undefined') {
	  win = self;
	} else {
	  win = {};
	}
	
	// requestAnimationFrame() shim by Paul Irish
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
	  return win.setTimeout(callback, 1000 / 60);
	};
	
	var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
	  win.clearTimeout(id);
	};
	
	var raf = exports.raf = request;
	var caf = exports.caf = cancel;

/***/ }),
/* 6413 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUpdatedOffsetForIndex;
	/**
	 * Determines a new offset that ensures a certain cell is visible, given the current offset.
	 * If the cell is already visible then the current offset will be returned.
	 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
	 *
	 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
	 * @param cellOffset Offset (x or y) position for cell
	 * @param cellSize Size (width or height) of cell
	 * @param containerSize Total size (width or height) of the container
	 * @param currentOffset Container's current (x or y) offset
	 * @return Offset to use to ensure the specified cell is visible
	 */
	function getUpdatedOffsetForIndex(_ref) {
	  var _ref$align = _ref.align,
	      align = _ref$align === undefined ? 'auto' : _ref$align,
	      cellOffset = _ref.cellOffset,
	      cellSize = _ref.cellSize,
	      containerSize = _ref.containerSize,
	      currentOffset = _ref.currentOffset;
	
	  var maxOffset = cellOffset;
	  var minOffset = maxOffset - containerSize + cellSize;
	
	  switch (align) {
	    case 'start':
	      return maxOffset;
	    case 'end':
	      return minOffset;
	    case 'center':
	      return maxOffset - (containerSize - cellSize) / 2;
	    default:
	      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
	  }
	}

/***/ }),
/* 6414 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Binary Search Bounds
	 * https://github.com/mikolalysenko/binary-search-bounds
	 * Mikola Lysenko
	 *
	 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
	 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
	 **/
	
	function _GEA(a, l, h, y) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x >= y) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function _GEP(a, l, h, y, c) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) >= 0) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchGE(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _GTA(a, l, h, y) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x > y) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function _GTP(a, l, h, y, c) {
	  var i = h + 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) > 0) {
	      i = m;
	      h = m - 1;
	    } else {
	      l = m + 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchGT(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _LTA(a, l, h, y) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x < y) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function _LTP(a, l, h, y, c) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) < 0) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchLT(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _LEA(a, l, h, y) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x <= y) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function _LEP(a, l, h, y, c) {
	  var i = l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (c(x, y) <= 0) {
	      i = m;
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return i;
	}
	function dispatchBsearchLE(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	function _EQA(a, l, h, y) {
	  l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    if (x === y) {
	      return m;
	    } else if (x <= y) {
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return -1;
	}
	function _EQP(a, l, h, y, c) {
	  l - 1;
	  while (l <= h) {
	    var m = l + h >>> 1,
	        x = a[m];
	    var p = c(x, y);
	    if (p === 0) {
	      return m;
	    } else if (p <= 0) {
	      l = m + 1;
	    } else {
	      h = m - 1;
	    }
	  }
	  return -1;
	}
	function dispatchBsearchEQ(a, y, c, l, h) {
	  if (typeof c === 'function') {
	    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
	  } else {
	    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
	  }
	}
	
	exports.default = {
	  ge: dispatchBsearchGE,
	  gt: dispatchBsearchGT,
	  lt: dispatchBsearchLT,
	  le: dispatchBsearchLE,
	  eq: dispatchBsearchEQ
	};

/***/ }),
/* 6415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createWrapper;
	
	var _binarySearchBounds = __webpack_require__(6414);
	
	var _binarySearchBounds2 = _interopRequireDefault(_binarySearchBounds);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOT_FOUND = 0; /**
	                    * Binary Search Bounds
	                    * https://github.com/mikolalysenko/interval-tree-1d
	                    * Mikola Lysenko
	                    *
	                    * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
	                    * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
	                    **/
	
	var SUCCESS = 1;
	var EMPTY = 2;
	
	function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
	  this.mid = mid;
	  this.left = left;
	  this.right = right;
	  this.leftPoints = leftPoints;
	  this.rightPoints = rightPoints;
	  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
	}
	
	var proto = IntervalTreeNode.prototype;
	
	function copy(a, b) {
	  a.mid = b.mid;
	  a.left = b.left;
	  a.right = b.right;
	  a.leftPoints = b.leftPoints;
	  a.rightPoints = b.rightPoints;
	  a.count = b.count;
	}
	
	function rebuild(node, intervals) {
	  var ntree = createIntervalTree(intervals);
	  node.mid = ntree.mid;
	  node.left = ntree.left;
	  node.right = ntree.right;
	  node.leftPoints = ntree.leftPoints;
	  node.rightPoints = ntree.rightPoints;
	  node.count = ntree.count;
	}
	
	function rebuildWithInterval(node, interval) {
	  var intervals = node.intervals([]);
	  intervals.push(interval);
	  rebuild(node, intervals);
	}
	
	function rebuildWithoutInterval(node, interval) {
	  var intervals = node.intervals([]);
	  var idx = intervals.indexOf(interval);
	  if (idx < 0) {
	    return NOT_FOUND;
	  }
	  intervals.splice(idx, 1);
	  rebuild(node, intervals);
	  return SUCCESS;
	}
	
	proto.intervals = function (result) {
	  result.push.apply(result, this.leftPoints);
	  if (this.left) {
	    this.left.intervals(result);
	  }
	  if (this.right) {
	    this.right.intervals(result);
	  }
	  return result;
	};
	
	proto.insert = function (interval) {
	  var weight = this.count - this.leftPoints.length;
	  this.count += 1;
	  if (interval[1] < this.mid) {
	    if (this.left) {
	      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
	        rebuildWithInterval(this, interval);
	      } else {
	        this.left.insert(interval);
	      }
	    } else {
	      this.left = createIntervalTree([interval]);
	    }
	  } else if (interval[0] > this.mid) {
	    if (this.right) {
	      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
	        rebuildWithInterval(this, interval);
	      } else {
	        this.right.insert(interval);
	      }
	    } else {
	      this.right = createIntervalTree([interval]);
	    }
	  } else {
	    var l = _binarySearchBounds2.default.ge(this.leftPoints, interval, compareBegin);
	    var r = _binarySearchBounds2.default.ge(this.rightPoints, interval, compareEnd);
	    this.leftPoints.splice(l, 0, interval);
	    this.rightPoints.splice(r, 0, interval);
	  }
	};
	
	proto.remove = function (interval) {
	  var weight = this.count - this.leftPoints;
	  if (interval[1] < this.mid) {
	    if (!this.left) {
	      return NOT_FOUND;
	    }
	    var rw = this.right ? this.right.count : 0;
	    if (4 * rw > 3 * (weight - 1)) {
	      return rebuildWithoutInterval(this, interval);
	    }
	    var r = this.left.remove(interval);
	    if (r === EMPTY) {
	      this.left = null;
	      this.count -= 1;
	      return SUCCESS;
	    } else if (r === SUCCESS) {
	      this.count -= 1;
	    }
	    return r;
	  } else if (interval[0] > this.mid) {
	    if (!this.right) {
	      return NOT_FOUND;
	    }
	    var lw = this.left ? this.left.count : 0;
	    if (4 * lw > 3 * (weight - 1)) {
	      return rebuildWithoutInterval(this, interval);
	    }
	    var r = this.right.remove(interval);
	    if (r === EMPTY) {
	      this.right = null;
	      this.count -= 1;
	      return SUCCESS;
	    } else if (r === SUCCESS) {
	      this.count -= 1;
	    }
	    return r;
	  } else {
	    if (this.count === 1) {
	      if (this.leftPoints[0] === interval) {
	        return EMPTY;
	      } else {
	        return NOT_FOUND;
	      }
	    }
	    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
	      if (this.left && this.right) {
	        var p = this;
	        var n = this.left;
	        while (n.right) {
	          p = n;
	          n = n.right;
	        }
	        if (p === this) {
	          n.right = this.right;
	        } else {
	          var l = this.left;
	          var r = this.right;
	          p.count -= n.count;
	          p.right = n.left;
	          n.left = l;
	          n.right = r;
	        }
	        copy(this, n);
	        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
	      } else if (this.left) {
	        copy(this, this.left);
	      } else {
	        copy(this, this.right);
	      }
	      return SUCCESS;
	    }
	    for (var l = _binarySearchBounds2.default.ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
	      if (this.leftPoints[l][0] !== interval[0]) {
	        break;
	      }
	      if (this.leftPoints[l] === interval) {
	        this.count -= 1;
	        this.leftPoints.splice(l, 1);
	        for (var r = _binarySearchBounds2.default.ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
	          if (this.rightPoints[r][1] !== interval[1]) {
	            break;
	          } else if (this.rightPoints[r] === interval) {
	            this.rightPoints.splice(r, 1);
	            return SUCCESS;
	          }
	        }
	      }
	    }
	    return NOT_FOUND;
	  }
	};
	
	function reportLeftRange(arr, hi, cb) {
	  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
	    var r = cb(arr[i]);
	    if (r) {
	      return r;
	    }
	  }
	}
	
	function reportRightRange(arr, lo, cb) {
	  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
	    var r = cb(arr[i]);
	    if (r) {
	      return r;
	    }
	  }
	}
	
	function reportRange(arr, cb) {
	  for (var i = 0; i < arr.length; ++i) {
	    var r = cb(arr[i]);
	    if (r) {
	      return r;
	    }
	  }
	}
	
	proto.queryPoint = function (x, cb) {
	  if (x < this.mid) {
	    if (this.left) {
	      var r = this.left.queryPoint(x, cb);
	      if (r) {
	        return r;
	      }
	    }
	    return reportLeftRange(this.leftPoints, x, cb);
	  } else if (x > this.mid) {
	    if (this.right) {
	      var r = this.right.queryPoint(x, cb);
	      if (r) {
	        return r;
	      }
	    }
	    return reportRightRange(this.rightPoints, x, cb);
	  } else {
	    return reportRange(this.leftPoints, cb);
	  }
	};
	
	proto.queryInterval = function (lo, hi, cb) {
	  if (lo < this.mid && this.left) {
	    var r = this.left.queryInterval(lo, hi, cb);
	    if (r) {
	      return r;
	    }
	  }
	  if (hi > this.mid && this.right) {
	    var r = this.right.queryInterval(lo, hi, cb);
	    if (r) {
	      return r;
	    }
	  }
	  if (hi < this.mid) {
	    return reportLeftRange(this.leftPoints, hi, cb);
	  } else if (lo > this.mid) {
	    return reportRightRange(this.rightPoints, lo, cb);
	  } else {
	    return reportRange(this.leftPoints, cb);
	  }
	};
	
	function compareNumbers(a, b) {
	  return a - b;
	}
	
	function compareBegin(a, b) {
	  var d = a[0] - b[0];
	  if (d) {
	    return d;
	  }
	  return a[1] - b[1];
	}
	
	function compareEnd(a, b) {
	  var d = a[1] - b[1];
	  if (d) {
	    return d;
	  }
	  return a[0] - b[0];
	}
	
	function createIntervalTree(intervals) {
	  if (intervals.length === 0) {
	    return null;
	  }
	  var pts = [];
	  for (var i = 0; i < intervals.length; ++i) {
	    pts.push(intervals[i][0], intervals[i][1]);
	  }
	  pts.sort(compareNumbers);
	
	  var mid = pts[pts.length >> 1];
	
	  var leftIntervals = [];
	  var rightIntervals = [];
	  var centerIntervals = [];
	  for (var i = 0; i < intervals.length; ++i) {
	    var s = intervals[i];
	    if (s[1] < mid) {
	      leftIntervals.push(s);
	    } else if (mid < s[0]) {
	      rightIntervals.push(s);
	    } else {
	      centerIntervals.push(s);
	    }
	  }
	
	  //Split center intervals
	  var leftPoints = centerIntervals;
	  var rightPoints = centerIntervals.slice();
	  leftPoints.sort(compareBegin);
	  rightPoints.sort(compareEnd);
	
	  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
	}
	
	//User friendly wrapper that makes it possible to support empty trees
	function IntervalTree(root) {
	  this.root = root;
	}
	
	var tproto = IntervalTree.prototype;
	
	tproto.insert = function (interval) {
	  if (this.root) {
	    this.root.insert(interval);
	  } else {
	    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
	  }
	};
	
	tproto.remove = function (interval) {
	  if (this.root) {
	    var r = this.root.remove(interval);
	    if (r === EMPTY) {
	      this.root = null;
	    }
	    return r !== NOT_FOUND;
	  }
	  return false;
	};
	
	tproto.queryPoint = function (p, cb) {
	  if (this.root) {
	    return this.root.queryPoint(p, cb);
	  }
	};
	
	tproto.queryInterval = function (lo, hi, cb) {
	  if (lo <= hi && this.root) {
	    return this.root.queryInterval(lo, hi, cb);
	  }
	};
	
	Object.defineProperty(tproto, 'count', {
	  get: function get() {
	    if (this.root) {
	      return this.root.count;
	    }
	    return 0;
	  }
	});
	
	Object.defineProperty(tproto, 'intervals', {
	  get: function get() {
	    if (this.root) {
	      return this.root.intervals([]);
	    }
	    return [];
	  }
	});
	
	function createWrapper(intervals) {
	  if (!intervals || intervals.length === 0) {
	    return new IntervalTree(null);
	  }
	  return new IntervalTree(createIntervalTree(intervals));
	}

/***/ }),
/* 6416 */,
/* 6417 */,
/* 6418 */
1060,
/* 6419 */
6258,
/* 6420 */
1620,
/* 6421 */
6274,
/* 6422 */,
/* 6423 */,
/* 6424 */,
/* 6425 */,
/* 6426 */,
/* 6427 */,
/* 6428 */,
/* 6429 */,
/* 6430 */,
/* 6431 */,
/* 6432 */,
/* 6433 */,
/* 6434 */,
/* 6435 */,
/* 6436 */,
/* 6437 */,
/* 6438 */,
/* 6439 */,
/* 6440 */,
/* 6441 */,
/* 6442 */,
/* 6443 */,
/* 6444 */,
/* 6445 */,
/* 6446 */,
/* 6447 */,
/* 6448 */,
/* 6449 */,
/* 6450 */,
/* 6451 */,
/* 6452 */,
/* 6453 */,
/* 6454 */,
/* 6455 */,
/* 6456 */,
/* 6457 */,
/* 6458 */,
/* 6459 */,
/* 6460 */,
/* 6461 */,
/* 6462 */,
/* 6463 */,
/* 6464 */,
/* 6465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(2881);
	
	var _diff = __webpack_require__(6467);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ }),
/* 6466 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ }),
/* 6467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(4850);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 6468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(6465);
	
	var _helpers = __webpack_require__(2881);
	
	var _defaults = __webpack_require__(6466);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      transformer = loggerOptions.transformer,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n\n\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\n\nconst logger = createLogger({\n  // ...options\n});\n\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = createLogger();
	
	exports.defaults = _defaults2.default;
	exports.logger = defaultLogger;
	exports.default = createLogger;
	module.exports = exports['default'];


/***/ }),
/* 6469 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 6470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(1483);
	var callBind = __webpack_require__(6472);
	
	var implementation = __webpack_require__(2882);
	var getPolyfill = __webpack_require__(2883);
	var shim = __webpack_require__(6475);
	
	var flagsBound = callBind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ }),
/* 6471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* globals
		Atomics,
		SharedArrayBuffer,
	*/
	
	var undefined;
	
	var $TypeError = TypeError;
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () { throw new $TypeError(); };
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(6473)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var generator; // = function * () {};
	var generatorFunction = generator ? getProto(generator) : undefined;
	var asyncFn; // async function() {};
	var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
	var asyncGen; // async function * () {};
	var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
	var asyncGenIterator = asyncGen ? asyncGen() : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%ArrayPrototype%': Array.prototype,
		'%ArrayProto_entries%': Array.prototype.entries,
		'%ArrayProto_forEach%': Array.prototype.forEach,
		'%ArrayProto_keys%': Array.prototype.keys,
		'%ArrayProto_values%': Array.prototype.values,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': asyncFunction,
		'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
		'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
		'%AsyncGeneratorFunction%': asyncGenFunction,
		'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
		'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%Boolean%': Boolean,
		'%BooleanPrototype%': Boolean.prototype,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
		'%Date%': Date,
		'%DatePrototype%': Date.prototype,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%ErrorPrototype%': Error.prototype,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%EvalErrorPrototype%': EvalError.prototype,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
		'%Function%': Function,
		'%FunctionPrototype%': Function.prototype,
		'%Generator%': generator ? getProto(generator()) : undefined,
		'%GeneratorFunction%': generatorFunction,
		'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
		'%Math%': Math,
		'%Number%': Number,
		'%NumberPrototype%': Number.prototype,
		'%Object%': Object,
		'%ObjectPrototype%': Object.prototype,
		'%ObjProto_toString%': Object.prototype.toString,
		'%ObjProto_valueOf%': Object.prototype.valueOf,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
		'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
		'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
		'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
		'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%RangeErrorPrototype%': RangeError.prototype,
		'%ReferenceError%': ReferenceError,
		'%ReferenceErrorPrototype%': ReferenceError.prototype,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%RegExpPrototype%': RegExp.prototype,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%StringPrototype%': String.prototype,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
		'%SyntaxError%': SyntaxError,
		'%SyntaxErrorPrototype%': SyntaxError.prototype,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
		'%TypeError%': $TypeError,
		'%TypeErrorPrototype%': $TypeError.prototype,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
		'%URIError%': URIError,
		'%URIErrorPrototype%': URIError.prototype,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
		'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
	};
	
	var bind = __webpack_require__(1517);
	var $replace = bind.call(Function.call, String.prototype.replace);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		if (!(name in INTRINSICS)) {
			throw new SyntaxError('intrinsic ' + name + ' does not exist!');
		}
	
		// istanbul ignore if // hopefully this is impossible to test :-)
		if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}
	
		return INTRINSICS[name];
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
	
		var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
		for (var i = 1; i < parts.length; i += 1) {
			if (value != null) {
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, parts[i]);
					if (!allowMissing && !(parts[i] in value)) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					value = desc ? (desc.get || desc.value) : value[parts[i]];
				} else {
					value = value[parts[i]];
				}
			}
		}
		return value;
	};


/***/ }),
/* 6472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(1517);
	
	var GetIntrinsic = __webpack_require__(6471);
	
	var $Function = GetIntrinsic('%Function%');
	var $apply = $Function.apply;
	var $call = $Function.call;
	
	module.exports = function callBind() {
		return bind.apply($call, arguments);
	};
	
	module.exports.apply = function applyBind() {
		return bind.apply($apply, arguments);
	};


/***/ }),
/* 6473 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(6474);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6474 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 6475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(1483).supportsDescriptors;
	var getPolyfill = __webpack_require__(2883);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ }),
/* 6476 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6477 */,
/* 6478 */,
/* 6479 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * $script.js JS loader & dependency manager
	  * https://github.com/ded/script.js
	  * (c) Dustin Diaz 2014 | License MIT
	  */
	
	(function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	})('$script', function () {
	  var doc = document
	    , head = doc.getElementsByTagName('head')[0]
	    , s = 'string'
	    , f = false
	    , push = 'push'
	    , readyState = 'readyState'
	    , onreadystatechange = 'onreadystatechange'
	    , list = {}
	    , ids = {}
	    , delay = {}
	    , scripts = {}
	    , scriptpath
	    , urlArgs
	
	  function every(ar, fn) {
	    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	    return 1
	  }
	  function each(ar, fn) {
	    every(ar, function (el) {
	      fn(el)
	      return 1
	    })
	  }
	
	  function $script(paths, idOrDone, optDone) {
	    paths = paths[push] ? paths : [paths]
	    var idOrDoneIsDone = idOrDone && idOrDone.call
	      , done = idOrDoneIsDone ? idOrDone : optDone
	      , id = idOrDoneIsDone ? paths.join('') : idOrDone
	      , queue = paths.length
	    function loopFn(item) {
	      return item.call ? item() : list[item]
	    }
	    function callback() {
	      if (!--queue) {
	        list[id] = 1
	        done && done()
	        for (var dset in delay) {
	          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
	        }
	      }
	    }
	    setTimeout(function () {
	      each(paths, function loading(path, force) {
	        if (path === null) return callback()
	        
	        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
	          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
	        }
	        
	        if (scripts[path]) {
	          if (id) ids[id] = 1
	          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
	        }
	
	        scripts[path] = 1
	        if (id) ids[id] = 1
	        create(path, callback)
	      })
	    }, 0)
	    return $script
	  }
	
	  function create(path, fn) {
	    var el = doc.createElement('script'), loaded
	    el.onload = el.onerror = el[onreadystatechange] = function () {
	      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
	      el.onload = el[onreadystatechange] = null
	      loaded = 1
	      scripts[path] = 2
	      fn()
	    }
	    el.async = 1
	    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	    head.insertBefore(el, head.lastChild)
	  }
	
	  $script.get = create
	
	  $script.order = function (scripts, id, done) {
	    (function callback(s) {
	      s = scripts.shift()
	      !scripts.length ? $script(s, id, done) : $script(s, callback)
	    }())
	  }
	
	  $script.path = function (p) {
	    scriptpath = p
	  }
	  $script.urlArgs = function (str) {
	    urlArgs = str;
	  }
	  $script.ready = function (deps, ready, req) {
	    deps = deps[push] ? deps : [deps]
	    var missing = [];
	    !each(deps, function (dep) {
	      list[dep] || missing[push](dep);
	    }) && every(deps, function (dep) {return list[dep]}) ?
	      ready() : !function (key) {
	      delay[key] = delay[key] || []
	      delay[key][push](ready)
	      req && req(missing)
	    }(deps.join('|'))
	    return $script
	  }
	
	  $script.done = function (idOrDone) {
	    $script([null], idOrDone)
	  }
	
	  return $script
	});


/***/ }),
/* 6480 */
/***/ (function(module, exports, __webpack_require__) {

	var raf = __webpack_require__(5704)
	
	function scroll (prop, element, to, options, callback) {
	  var start = +new Date
	  var from = element[prop]
	  var cancelled = false
	
	  var ease = inOutSine
	  var duration = 350
	
	  if (typeof options === 'function') {
	    callback = options
	  }
	  else {
	    options = options || {}
	    ease = options.ease || ease
	    duration = options.duration || duration
	    callback = callback || function () {}
	  }
	
	  if (from === to) {
	    return callback(
	      new Error('Element already at target scroll position'),
	      element[prop]
	    )
	  }
	
	  function cancel () {
	    cancelled = true
	  }
	
	  function animate (timestamp) {
	    if (cancelled) {
	      return callback(
	        new Error('Scroll cancelled'),
	        element[prop]
	      )
	    }
	
	    var now = +new Date
	    var time = Math.min(1, ((now - start) / duration))
	    var eased = ease(time)
	
	    element[prop] = (eased * (to - from)) + from
	
	    time < 1 ? raf(animate) : raf(function () {
	      callback(null, element[prop])
	    })
	  }
	
	  raf(animate)
	
	  return cancel
	}
	
	function inOutSine (n) {
	  return .5 * (1 - Math.cos(Math.PI * n))
	}
	
	module.exports = {
	  top: function (element, to, options, callback) {
	    return scroll('scrollTop', element, to, options, callback)
	  },
	  left: function (element, to, options, callback) {
	    return scroll('scrollLeft', element, to, options, callback)
	  }
	}


/***/ }),
/* 6481 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(583)))

/***/ }),
/* 6482 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function shallowEqualObjects(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (!objA || !objB) {
	    return false;
	  }
	
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	  var len = aKeys.length;
	
	  if (bKeys.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shallowEqualArrays(arrA, arrB) {
	  if (arrA === arrB) {
	    return true;
	  }
	
	  if (!arrA || !arrB) {
	    return false;
	  }
	
	  var len = arrA.length;
	
	  if (arrB.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (arrA[i] !== arrB[i]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	exports.shallowEqualArrays = shallowEqualArrays;
	exports.shallowEqualObjects = shallowEqualObjects;


/***/ }),
/* 6483 */
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),
/* 6484 */
/***/ (function(module, exports) {

	module.exports = stifle;
	
	
	function stifle (fn, wait) {
	  if (typeof fn !== 'function' || typeof wait !== 'number') {
	    throw new Error('stifle(fn, wait) -- expected a function and number of milliseconds, got (' + typeof fn + ', ' + typeof wait + ')');
	  }
	
	  var timer;    // Timer to fire after `wait` has elapsed
	  var called;   // Keep track if it gets called during the `wait`
	
	  var wrapper = function () {
	
	    // Check if still "cooling down" from a previous call
	    if (timer) {
	      called = true;
	    } else {
	      // Start a timer to fire after the `wait` is over
	      timer = setTimeout(afterWait, wait);
	      // And call the wrapped function
	      fn();
	    }
	  }
	
	  // Add a cancel method, to kill and pending calls
	  wrapper.cancel = function () {
	    // Clear the called flag, or it would fire twice when called again later
	    called = false;
	
	    // Turn off the timer, so it won't fire after the wait expires
	    if (timer) {
	      clearTimeout(timer);
	      timer = undefined;
	    }
	  }
	
	  function afterWait() {
	    // Empty out the timer
	    timer = undefined;
	
	    // If it was called during the `wait`, fire it again
	    if (called) {
	      called = false;
	      wrapper();
	    }
	  }
	
	  return wrapper;
	}


/***/ }),
/* 6485 */,
/* 6486 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(root, factory) {
	     true ? // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return root.svg4everybody = factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory() : root.svg4everybody = factory();
	}(this, function() {
	    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
	    function embed(parent, svg, target) {
	        // if the target exists
	        if (target) {
	            // create a document fragment to hold the contents of the target
	            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
	            // conditionally set the viewBox on the svg
	            viewBox && svg.setAttribute("viewBox", viewBox);
	            // copy the contents of the clone into the fragment
	            for (// clone the target
	            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
	                fragment.appendChild(clone.firstChild);
	            }
	            // append the fragment into the svg
	            parent.appendChild(fragment);
	        }
	    }
	    function loadreadystatechange(xhr) {
	        // listen to changes in the request
	        xhr.onreadystatechange = function() {
	            // if the request is ready
	            if (4 === xhr.readyState) {
	                // get the cached html document
	                var cachedDocument = xhr._cachedDocument;
	                // ensure the cached html document based on the xhr response
	                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
	                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
	                xhr._embeds.splice(0).map(function(item) {
	                    // get the cached target
	                    var target = xhr._cachedTarget[item.id];
	                    // ensure the cached target
	                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
	                    // embed the target into the svg
	                    embed(item.parent, item.svg, target);
	                });
	            }
	        }, // test the ready state change immediately
	        xhr.onreadystatechange();
	    }
	    function svg4everybody(rawopts) {
	        function oninterval() {
	            // while the index exists in the live <use> collection
	            for (// get the cached <use> index
	            var index = 0; index < uses.length; ) {
	                // get the current <use>
	                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
	                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
	                svg && src) {
	                    if (polyfill) {
	                        if (!opts.validate || opts.validate(src, svg, use)) {
	                            // remove the <use> element
	                            parent.removeChild(use);
	                            // parse the src and get the url and id
	                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
	                            // if the link is external
	                            if (url.length) {
	                                // get the cached xhr request
	                                var xhr = requests[url];
	                                // ensure the xhr request exists
	                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
	                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
	                                xhr._embeds.push({
	                                    parent: parent,
	                                    svg: svg,
	                                    id: id
	                                }), // prepare the xhr ready state change event
	                                loadreadystatechange(xhr);
	                            } else {
	                                // embed the local id into the svg
	                                embed(parent, svg, document.getElementById(id));
	                            }
	                        } else {
	                            // increase the index when the previous value was not "valid"
	                            ++index, ++numberOfSvgUseElementsToBypass;
	                        }
	                    }
	                } else {
	                    // increase the index when the previous value was not "valid"
	                    ++index;
	                }
	            }
	            // continue the interval
	            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
	        }
	        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
	        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
	        // create xhr requests object
	        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
	        // conditionally start the interval if the polyfill is active
	        polyfill && oninterval();
	    }
	    function getSVGAncestor(node) {
	        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
	        return svg;
	    }
	    return svg4everybody;
	});

/***/ }),
/* 6487 */,
/* 6488 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(6481);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 6489 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ring2.273b906f.mp3";

/***/ }),
/* 6490 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 6491 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./aayuwell-logo.png": 5274,
		"./ascension-logo.png": 5275,
		"./baycare-logo.png": 5276,
		"./bf-logo.png": 5277,
		"./bh-logo.png": 5278,
		"./blewm-logo.png": 5279,
		"./buc-logo.png": 5280,
		"./canyon-logo.png": 5281,
		"./chrysalis-logo.png": 5282,
		"./dug-logo.png": 5283,
		"./flagler-logo.png": 5284,
		"./garnet-logo.png": 5285,
		"./goodwill-logo.png": 5286,
		"./healthfully-logo.png": 5287,
		"./huntsville-logo.png": 5288,
		"./iowa-logo.png": 5289,
		"./isu-logo.png": 5290,
		"./linc-logo.png": 5291,
		"./marionhealth-logo.png": 5292,
		"./mdf-logo.png": 5293,
		"./membershealth-logo.png": 5294,
		"./myze-logo.png": 5295,
		"./pcw-logo.png": 5296,
		"./pdr-logo.png": 5297,
		"./preptimize-logo.png": 5298,
		"./pw-logo.png": 5299,
		"./pwell-logo.png": 5300,
		"./sherwood-logo.png": 5301,
		"./synergy-logo.png": 5302,
		"./telewell-logo.png": 5303,
		"./up-logo.png": 5304,
		"./urgentteam-logo.png": 5305,
		"./weber-logo.png": 5306,
		"./wr-logo.png": 5307
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 6491;


/***/ }),
/* 6492 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./aayuwell/index.js": 4255,
		"./ascension/index.js": 4256,
		"./baycare/index.js": 4257,
		"./bf/index.js": 4258,
		"./bh/index.js": 4259,
		"./blewm/index.js": 4260,
		"./buc/index.js": 4261,
		"./canyon/index.js": 4262,
		"./chrysalis/index.js": 4263,
		"./dug/index.js": 4264,
		"./flagler/index.js": 4265,
		"./garnet/index.js": 4266,
		"./goodwill/index.js": 4267,
		"./healthfully/index.js": 4268,
		"./healthspark/index.js": 4269,
		"./hitech/index.js": 4270,
		"./huntsville/index.js": 4271,
		"./isu/index.js": 4272,
		"./linc/index.js": 4273,
		"./marionhealth/index.js": 4274,
		"./mdf/index.js": 4275,
		"./membershealth/index.js": 4276,
		"./myze/index.js": 4277,
		"./pcw/index.js": 4278,
		"./pdr/index.js": 4279,
		"./preptimize/index.js": 4280,
		"./pw/index.js": 4281,
		"./pwell/index.js": 4282,
		"./sherwood/index.js": 4283,
		"./synergy/index.js": 4284,
		"./telewell/index.js": 4285,
		"./up/index.js": 4286,
		"./urgentteam/index.js": 4287,
		"./weber/index.js": 4288,
		"./wr/index.js": 4289
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 6492;


/***/ }),
/* 6493 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 6494 */
6493,
/* 6495 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ }),
/* 6496 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 6497 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 6498 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 6499 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 6500 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ }),
/* 6501 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 6502 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 6503 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 6504 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 6505 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 6506 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 6507 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ }),
/* 6508 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 6509 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ }),
/* 6510 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 6511 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ }),
/* 6512 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 6513 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 6514 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ }),
/* 6515 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 6516 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ }),
/* 6517 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 6518 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 6519 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 6520 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 6521 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 6522 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 6523 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 6524 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 6525 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ }),
/* 6526 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 6527 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 6528 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 6529 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 6530 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ }),
/* 6531 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 6532 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 6533 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 6534 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 6535 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 6536 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 6537 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 6538 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ }),
/* 6539 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 6540 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 6541 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var forOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 6542 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 6543 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var IObject = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toLength = __webpack_require__(__webpack_module_template_argument_3__);
	var asc = __webpack_require__(__webpack_module_template_argument_4__);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 6544 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var isArray = __webpack_require__(__webpack_module_template_argument_1__);
	var SPECIES = __webpack_require__(__webpack_module_template_argument_2__)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 6545 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 6546 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 6547 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__) {

	'use strict';
	var dP = __webpack_require__(__webpack_module_template_argument_0__).f;
	var create = __webpack_require__(__webpack_module_template_argument_1__);
	var redefineAll = __webpack_require__(__webpack_module_template_argument_2__);
	var ctx = __webpack_require__(__webpack_module_template_argument_3__);
	var anInstance = __webpack_require__(__webpack_module_template_argument_4__);
	var forOf = __webpack_require__(__webpack_module_template_argument_5__);
	var $iterDefine = __webpack_require__(__webpack_module_template_argument_6__);
	var step = __webpack_require__(__webpack_module_template_argument_7__);
	var setSpecies = __webpack_require__(__webpack_module_template_argument_8__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_9__);
	var fastKey = __webpack_require__(__webpack_module_template_argument_10__).fastKey;
	var validate = __webpack_require__(__webpack_module_template_argument_11__);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 6548 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var from = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 6549 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 6550 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 6551 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 6552 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 6553 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 6554 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var call = __webpack_require__(__webpack_module_template_argument_1__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_2__);
	var anObject = __webpack_require__(__webpack_module_template_argument_3__);
	var toLength = __webpack_require__(__webpack_module_template_argument_4__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_5__);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 6555 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 6556 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 6557 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 6558 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 6559 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 6560 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 6561 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 6562 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 6563 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 6564 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_5__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_6__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_7__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_8__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_9__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 6565 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 6566 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 6567 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var macrotask = __webpack_require__(__webpack_module_template_argument_1__).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(__webpack_module_template_argument_2__)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 6568 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 6569 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	var toObject = __webpack_require__(__webpack_module_template_argument_3__);
	var IObject = __webpack_require__(__webpack_module_template_argument_4__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_5__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 6570 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 6571 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 6572 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 6573 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 6574 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 6575 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 6576 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 6577 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 6578 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 6579 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var fails = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 6580 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var isEnum = __webpack_require__(__webpack_module_template_argument_2__).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 6581 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 6582 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_1__);
	var ctx = __webpack_require__(__webpack_module_template_argument_2__);
	var forOf = __webpack_require__(__webpack_module_template_argument_3__);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 6583 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 6584 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 6585 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 6586 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 6587 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 6588 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_1__);
	var SPECIES = __webpack_require__(__webpack_module_template_argument_2__)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 6589 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 6590 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var invoke = __webpack_require__(__webpack_module_template_argument_1__);
	var html = __webpack_require__(__webpack_module_template_argument_2__);
	var cel = __webpack_require__(__webpack_module_template_argument_3__);
	var global = __webpack_require__(__webpack_module_template_argument_4__);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(__webpack_module_template_argument_5__)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 6591 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 6592 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 6593 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 6594 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 6595 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 6596 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 6597 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 6598 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ }),
/* 6599 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 6600 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 6601 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 6602 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 6603 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	var strong = __webpack_require__(__webpack_module_template_argument_0__);
	var validate = __webpack_require__(__webpack_module_template_argument_1__);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(__webpack_module_template_argument_2__)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 6604 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var _isFinite = __webpack_require__(__webpack_module_template_argument_1__).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 6605 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 6606 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 6607 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 6608 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 6609 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 6610 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', { defineProperty: __webpack_require__(__webpack_module_template_argument_2__).f });


/***/ }),
/* 6611 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getOwnPropertyDescriptor = __webpack_require__(__webpack_module_template_argument_1__).f;
	
	__webpack_require__(__webpack_module_template_argument_2__)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 6612 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getPrototypeOf = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 6613 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 6614 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ }),
/* 6615 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var ctx = __webpack_require__(__webpack_module_template_argument_2__);
	var classof = __webpack_require__(__webpack_module_template_argument_3__);
	var $export = __webpack_require__(__webpack_module_template_argument_4__);
	var isObject = __webpack_require__(__webpack_module_template_argument_5__);
	var aFunction = __webpack_require__(__webpack_module_template_argument_6__);
	var anInstance = __webpack_require__(__webpack_module_template_argument_7__);
	var forOf = __webpack_require__(__webpack_module_template_argument_8__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_9__);
	var task = __webpack_require__(__webpack_module_template_argument_10__).set;
	var microtask = __webpack_require__(__webpack_module_template_argument_11__)();
	var newPromiseCapabilityModule = __webpack_require__(__webpack_module_template_argument_12__);
	var perform = __webpack_require__(__webpack_module_template_argument_13__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_14__);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(__webpack_module_template_argument_15__)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(__webpack_module_template_argument_16__)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(__webpack_module_template_argument_17__)($Promise, PROMISE);
	__webpack_require__(__webpack_module_template_argument_18__)(PROMISE);
	Wrapper = __webpack_require__(__webpack_module_template_argument_19__)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(__webpack_module_template_argument_20__)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 6616 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 6617 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	var strong = __webpack_require__(__webpack_module_template_argument_0__);
	var validate = __webpack_require__(__webpack_module_template_argument_1__);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(__webpack_module_template_argument_2__)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 6618 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 6619 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var isObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_18__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_19__);
	var _create = __webpack_require__(__webpack_module_template_argument_20__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_21__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_22__);
	var $DP = __webpack_require__(__webpack_module_template_argument_23__);
	var $keys = __webpack_require__(__webpack_module_template_argument_24__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_25__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_26__).f = $propertyIsEnumerable;
	  __webpack_require__(__webpack_module_template_argument_27__).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_28__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_29__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 6620 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(__webpack_module_template_argument_0__)('Map');


/***/ }),
/* 6621 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(__webpack_module_template_argument_0__)('Map');


/***/ }),
/* 6622 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(__webpack_module_template_argument_1__)('Map') });


/***/ }),
/* 6623 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $entries = __webpack_require__(__webpack_module_template_argument_1__)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 6624 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $values = __webpack_require__(__webpack_module_template_argument_1__)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 6625 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var global = __webpack_require__(__webpack_module_template_argument_2__);
	var speciesConstructor = __webpack_require__(__webpack_module_template_argument_3__);
	var promiseResolve = __webpack_require__(__webpack_module_template_argument_4__);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 6626 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var newPromiseCapability = __webpack_require__(__webpack_module_template_argument_1__);
	var perform = __webpack_require__(__webpack_module_template_argument_2__);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 6627 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(__webpack_module_template_argument_0__)('Set');


/***/ }),
/* 6628 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(__webpack_module_template_argument_0__)('Set');


/***/ }),
/* 6629 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(__webpack_module_template_argument_1__)('Set') });


/***/ }),
/* 6630 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ }),
/* 6631 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ }),
/* 6632 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var $task = __webpack_require__(__webpack_module_template_argument_1__);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 6633 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	var _index5 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_4__));
	
	var _index6 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_5__));
	
	var _index7 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_6__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	  /*
	   * |     | Unit                           |     | Unit                           |
	   * |-----|--------------------------------|-----|--------------------------------|
	   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	   * |  d  | Day of month                   |  D  | Day of year                    |
	   * |  e  | Local day of week              |  E  | Day of week                    |
	   * |  f  |                                |  F* | Day of week in month           |
	   * |  g* | Modified Julian day            |  G  | Era                            |
	   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	   * |  i! | ISO day of week                |  I! | ISO week of year               |
	   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	   * |  m  | Minute                         |  M  | Month                          |
	   * |  n  |                                |  N  |                                |
	   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	   * |  p! | Long localized time            |  P! | Long localized date            |
	   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	   * |  s  | Second                         |  S  | Fraction of second             |
	   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	   * |  u  | Extended year                  |  U* | Cyclic year                    |
	   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	   * |  w  | Local week of year             |  W* | Week of month                  |
	   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	   *
	   * Letters marked by * are not implemented but reserved by Unicode standard.
	   *
	   * Letters marked by ! are non-standard, but implemented by date-fns:
	   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	   *   i.e. 7 for Sunday, 1 for Monday, etc.
	   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	   *   `R` is supposed to be used in conjunction with `I` and `i`
	   *   for universal ISO week-numbering date, whereas
	   *   `Y` is supposed to be used in conjunction with `w` and `e`
	   *   for week-numbering date specific to the locale.
	   * - `P` is long localized date format
	   * - `p` is long localized time format
	   */
	
	};
	var formatters = {
	  // Era
	  G: function (date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function (date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	
	    return _index.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function (date, token, localize, options) {
	    var signedWeekYear = (0, _index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
	
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index7.default)(twoDigitYear, 2);
	    } // Ordinal number
	
	
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    } // Padding
	
	
	    return (0, _index7.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function (date, token) {
	    var isoWeekYear = (0, _index4.default)(date); // Padding
	
	    return (0, _index7.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function (date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index7.default)(year, token.length);
	  },
	  // Quarter
	  Q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'QQ':
	        return (0, _index7.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function (date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	
	      case 'qq':
	        return (0, _index7.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function (date, token, localize) {
	    var month = date.getUTCMonth();
	
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	
	      case 'LL':
	        return (0, _index7.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function (date, token, localize, options) {
	    var week = (0, _index5.default)(date, options);
	
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index7.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function (date, token, localize) {
	    var isoWeek = (0, _index3.default)(date);
	
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	
	    return (0, _index7.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function (date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	
	    return _index.default.d(date, token);
	  },
	  // Day of year
	  D: function (date, token, localize) {
	    var dayOfYear = (0, _index2.default)(date);
	
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	
	    return (0, _index7.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'ee':
	        return (0, _index7.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function (date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	
	      case 'cc':
	        return (0, _index7.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function (date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	
	      case 'ii':
	        return (0, _index7.default)(isoDayOfWeek, token.length);
	      // 2nd
	
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	
	    switch (token) {
	      case 'b':
	      case 'bb':
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return _index.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function (date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	
	    return _index.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function (date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index7.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function (date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	
	    return (0, _index7.default)(hours, token.length);
	  },
	  // Minute
	  m: function (date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	
	    return _index.default.m(date, token);
	  },
	  // Second
	  s: function (date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	
	    return _index.default.s(date, token);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    return _index.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index7.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function (date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index7.default)(timestamp, token.length);
	  }
	};
	
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index7.default)(minutes, 2);
	}
	
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index7.default)(Math.abs(offset) / 60, 2);
	  }
	
	  return formatTimezone(offset, dirtyDelimiter);
	}
	
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index7.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index7.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 6634 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	var formatters = {
	  // Year
	  y: function (date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
	
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function (date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function (date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function (date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	
	    switch (token) {
	      case 'a':
	      case 'aa':
	      case 'aaa':
	        return dayPeriodEnumValue.toUpperCase();
	
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function (date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function (date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function (date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function (date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function (date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 6635 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6636 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6637 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 6638 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6639 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var year = date.getUTCFullYear();
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	
	module.exports = exports.default;

/***/ }),
/* 6640 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
	  (0, _index3.default)(2, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6641 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index3.default)(2, arguments);
	  var day = (0, _index.default)(dirtyDay);
	
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	
	  var weekStartsOn = 1;
	  var date = (0, _index2.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6642 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6643 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6644 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6645 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6646 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index2.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6647 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
	  (0, _index4.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
	  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
	  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate);
	  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, dirtyOptions);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6648 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_DAY = 86400000;
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * var result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6649 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * var result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6650 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarWeeks;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MILLISECONDS_IN_WEEK = 604800000;
	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * var result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
	  (0, _index3.default)(2, arguments);
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, dirtyOptions);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, dirtyOptions);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight); // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6651 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * var result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ }),
/* 6652 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6653 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6654 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6655 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * var result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6656 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * var result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	
	module.exports = exports.default;

/***/ }),
/* 6657 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * var result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6658 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6659 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * var result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6660 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * var result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6661 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6662 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6663 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * var result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6664 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 6665 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 6666 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * var result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * var result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * var result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * var result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	
	module.exports = exports.default;

/***/ }),
/* 6667 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 6668 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day?
	 *
	 * @description
	 * Are the given dates in the same day?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 6669 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month?
	 *
	 * @description
	 * Are the given dates in the same month?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	
	module.exports = exports.default;

/***/ }),
/* 6670 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same year quarter?
	 *
	 * @description
	 * Are the given dates in the same year quarter?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	
	module.exports = exports.default;

/***/ }),
/* 6671 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	
	module.exports = exports.default;

/***/ }),
/* 6672 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - Now `isValid` doesn't throw an exception
	 *   if the first argument is not an instance of Date.
	 *   Instead, argument is converted beforehand using `toDate`.
	 *
	 *   Examples:
	 *
	 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
	 *   |---------------------------|---------------|---------------|
	 *   | `new Date()`              | `true`        | `true`        |
	 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
	 *   | `new Date('')`            | `false`       | `false`       |
	 *   | `new Date(1488370835081)` | `true`        | `true`        |
	 *   | `new Date(NaN)`           | `false`       | `false`       |
	 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
	 *   | `''`                      | `TypeError`   | `false`       |
	 *   | `1488370835081`           | `TypeError`   | `true`        |
	 *   | `NaN`                     | `TypeError`   | `false`       |
	 *
	 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
	 *   that try to coerce arguments to the expected type
	 *   (which is also the case with other *date-fns* functions).
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * var result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  return !isNaN(date);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6673 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
	 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
	 *
	 *   ```
	 *   2.1.3
	 *   time interval
	 *   part of the time axis limited by two instants
	 *   ```
	 *
	 *   Also, this function now accepts an object with `start` and `end` properties
	 *   instead of two arguments as an interval.
	 *   This function now throws `RangeError` if the start of the interval is after its end
	 *   or if any date in the interval is `Invalid Date`.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *
	 *   isWithinRange(
	 *     new Date(2014, 0, 3),
	 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
	 *   )
	 *
	 *   // v2.0.0 onward
	 *
	 *   isWithinInterval(
	 *     new Date(2014, 0, 3),
	 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
	 *   )
	 *   ```
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, dirtyInterval) {
	  (0, _index2.default)(2, arguments);
	  var interval = dirtyInterval || {};
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
	
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	
	  return time >= startTime && time <= endTime;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6674 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 6675 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
	  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
	  // Generally, formatted dates should look like they are in the middle of a sentence,
	  // e.g. in Spanish language the weekdays and months should be in the lowercase.
	
	};
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	
	function ordinalNumber(dirtyNumber, _dirtyOptions) {
	  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'
	
	  var rem100 = number % 100;
	
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	
	      case 2:
	        return number + 'nd';
	
	      case 3:
	        return number + 'rd';
	    }
	  }
	
	  return number + 'th';
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function (quarter) {
	      return Number(quarter) - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 6676 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function (value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index2.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index2.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function (index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index2.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index2.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index2.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 6677 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	var _index5 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_4__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0
	    /* Sunday */
	    ,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),
/* 6678 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `max` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   var date1 = new Date(1989, 6, 10)
	 *   var date2 = new Date(1987, 1, 11)
	 *   var maxDate = max(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   var maxDate = max(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * var result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result < currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6679 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Return the earliest of the given dates.
	 *
	 * @description
	 * Return the earliest of the given dates.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * - `min` function now accepts an array of dates rather than spread arguments.
	 *
	 *   ```javascript
	 *   // Before v2.0.0
	 *   var date1 = new Date(1989, 6, 10)
	 *   var date2 = new Date(1987, 1, 11)
	 *   var minDate = min(date1, date2)
	 *
	 *   // v2.0.0 onward:
	 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
	 *   var minDate = min(dates)
	 *   ```
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * var result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	
	    if (result === undefined || result > currentDate || isNaN(currentDate)) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6680 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6681 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6682 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * var result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth); // Set the last day of the new month
	  // if the original date was the last day of the longer month
	
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6683 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _index4 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * var result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	
	module.exports = exports.default;

/***/ }),
/* 6684 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6685 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * var result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	
	  if (isNaN(date)) {
	    return new Date(NaN);
	  }
	
	  date.setFullYear(year);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6686 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6687 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6688 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6689 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _index3 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, dirtyOptions) {
	  (0, _index3.default)(1, arguments);
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index2.default)(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index2.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6690 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	
	var _index = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _index2 = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * ### v2.0.0 breaking changes:
	 *
	 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	
	module.exports = exports.default;

/***/ }),
/* 6691 */,
/* 6692 */,
/* 6693 */,
/* 6694 */,
/* 6695 */,
/* 6696 */,
/* 6697 */,
/* 6698 */,
/* 6699 */,
/* 6700 */,
/* 6701 */,
/* 6702 */,
/* 6703 */,
/* 6704 */,
/* 6705 */,
/* 6706 */,
/* 6707 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 6708 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseEach = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ }),
/* 6709 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 6710 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var arrayAggregator = __webpack_require__(__webpack_module_template_argument_0__),
	    baseAggregator = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ }),
/* 6711 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var castSlice = __webpack_require__(__webpack_module_template_argument_0__),
	    hasUnicode = __webpack_require__(__webpack_module_template_argument_1__),
	    stringToArray = __webpack_require__(__webpack_module_template_argument_2__),
	    toString = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ }),
/* 6712 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var SetCache = __webpack_require__(__webpack_module_template_argument_0__),
	    arraySome = __webpack_require__(__webpack_module_template_argument_1__),
	    cacheHas = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 6713 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getAllKeys = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 6714 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(140)(module)))

/***/ }),
/* 6715 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var memoizeCapped = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 6716 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseHas = __webpack_require__(__webpack_module_template_argument_0__),
	    hasPath = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ }),
/* 6717 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseIsEqual = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 6718 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 6719 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var arrayReduce = __webpack_require__(__webpack_module_template_argument_0__),
	    baseEach = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__),
	    baseReduce = __webpack_require__(__webpack_module_template_argument_3__),
	    isArray = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ }),
/* 6720 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(71);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm A fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `ENTERING`
	 *  - `ENTERED`
	 *  - `EXITING`
	 *  - `EXITED`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state= { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEventListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ }),
/* 6721 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disabled appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disabled enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disabled exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ```jsx
	 * import TransitionGroup from 'react-transition-group/TransitionGroup';
	 *
	 * class TodoList extends React.Component {
	 *   constructor(props) {
	 *     super(props)
	 *     this.state = {items: ['hello', 'world', 'click', 'me']}
	 *   }
	 *   handleAdd() {
	 *     const newItems = this.state.items.concat([
	 *       prompt('Enter some text')
	 *     ]);
	 *     this.setState({ items: newItems });
	 *   }
	 *   handleRemove(i) {
	 *     let newItems = this.state.items.slice();
	 *     newItems.splice(i, 1);
	 *     this.setState({items: newItems});
	 *   }
	 *   render() {
	 *     return (
	 *       <div>
	 *         <button onClick={() => this.handleAdd()}>Add Item</button>
	 *         <TransitionGroup>
	 *           {this.state.items.map((item, i) => (
	 *             <FadeTransition key={item}>
	 *               <div>
	 *                 {item}{' '}
	 *                 <button onClick={() => this.handleRemove(i)}>
	 *                   remove
	 *                 </button>
	 *               </div>
	 *             </FadeTransition>
	 *           ))}
	 *         </TransitionGroup>
	 *       </div>
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleExited = function (key, node, originalHandler) {
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (key in currentChildMapping) return;
	
	      if (originalHandler) originalHandler(node);
	
	      _this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[key];
	        return { children: children };
	      });
	    };
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        var onExited = function onExited(node) {
	          _this.handleExited(child.key, node, child.props.onExited);
	        };
	
	        return (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var onExited = function onExited(node) {
	        _this2.handleExited(child.key, node, child.props.onExited);
	      };
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: onExited,
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: onExited,
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = this.state.children;
	
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    return _react2.default.createElement(
	      Component,
	      props,
	      values(children).map(childFactory)
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 6722 */,
/* 6723 */,
/* 6724 */,
/* 6725 */,
/* 6726 */,
/* 6727 */,
/* 6728 */,
/* 6729 */,
/* 6730 */,
/* 6731 */,
/* 6732 */,
/* 6733 */,
/* 6734 */,
/* 6735 */,
/* 6736 */,
/* 6737 */,
/* 6738 */,
/* 6739 */,
/* 6740 */,
/* 6741 */,
/* 6742 */,
/* 6743 */,
/* 6744 */,
/* 6745 */,
/* 6746 */,
/* 6747 */,
/* 6748 */,
/* 6749 */,
/* 6750 */,
/* 6751 */,
/* 6752 */,
/* 6753 */,
/* 6754 */,
/* 6755 */,
/* 6756 */,
/* 6757 */,
/* 6758 */,
/* 6759 */,
/* 6760 */,
/* 6761 */,
/* 6762 */,
/* 6763 */,
/* 6764 */,
/* 6765 */,
/* 6766 */,
/* 6767 */,
/* 6768 */,
/* 6769 */,
/* 6770 */,
/* 6771 */,
/* 6772 */,
/* 6773 */,
/* 6774 */,
/* 6775 */,
/* 6776 */,
/* 6777 */,
/* 6778 */,
/* 6779 */,
/* 6780 */,
/* 6781 */,
/* 6782 */,
/* 6783 */,
/* 6784 */,
/* 6785 */,
/* 6786 */,
/* 6787 */,
/* 6788 */,
/* 6789 */,
/* 6790 */,
/* 6791 */,
/* 6792 */,
/* 6793 */,
/* 6794 */,
/* 6795 */,
/* 6796 */,
/* 6797 */,
/* 6798 */,
/* 6799 */,
/* 6800 */,
/* 6801 */,
/* 6802 */,
/* 6803 */,
/* 6804 */,
/* 6805 */,
/* 6806 */,
/* 6807 */,
/* 6808 */,
/* 6809 */,
/* 6810 */,
/* 6811 */,
/* 6812 */,
/* 6813 */,
/* 6814 */,
/* 6815 */,
/* 6816 */,
/* 6817 */,
/* 6818 */,
/* 6819 */,
/* 6820 */,
/* 6821 */,
/* 6822 */,
/* 6823 */,
/* 6824 */,
/* 6825 */,
/* 6826 */,
/* 6827 */,
/* 6828 */,
/* 6829 */,
/* 6830 */,
/* 6831 */,
/* 6832 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(__webpack_module_template_argument_0__);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 6833 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(71);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 6834 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ }),
/* 6835 */,
/* 6836 */,
/* 6837 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.modes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _Transition = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	var _leaveRenders, _enterRenders;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function areChildrenDifferent(oldChildren, newChildren) {
	  if (oldChildren === newChildren) return false;
	
	  if (_react.default.isValidElement(oldChildren) && _react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Enum of modes for SwitchTransition component
	 * @enum { string }
	 */
	
	
	var modes = {
	  out: 'out-in',
	  in: 'in-out'
	};
	exports.modes = modes;
	
	var callHook = function callHook(element, name, cb) {
	  return function () {
	    var _element$props;
	
	    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
	    cb();
	  };
	};
	
	var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
	  var current = _ref.current,
	      changeState = _ref.changeState;
	  return _react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERING, null);
	    })
	  });
	}, _leaveRenders[modes.in] = function (_ref2) {
	  var current = _ref2.current,
	      changeState = _ref2.changeState,
	      children = _ref2.children;
	  return [current, _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERING);
	    })
	  })];
	}, _leaveRenders);
	var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
	  var children = _ref3.children,
	      changeState = _ref3.changeState;
	  return _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  });
	}, _enterRenders[modes.in] = function (_ref4) {
	  var current = _ref4.current,
	      children = _ref4.children,
	      changeState = _ref4.changeState;
	  return [_react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  }), _react.default.cloneElement(children, {
	    in: true
	  })];
	}, _enterRenders);
	/**
	 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
	 * You can use it when you want to control the render between state transitions.
	 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
	 *
	 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
	 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child
	 *
	 * ```jsx
	 *
	 * function App() {
	 *  const [state, setState] = useState(false);
	 *  return (
	 *    <SwitchTransition>
	 *      <FadeTransition key={state ? "Goodbye, world!" : "Hello, world!"}
	 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
	 *        classNames='fade' >
	 *        <button onClick={() => setState(state => !state)}>
	 *          {state ? "Goodbye, world!" : "Hello, world!"}
	 *        </button>
	 *      </FadeTransition>
	 *    </SwitchTransition>
	 *  )
	 * }
	 * ```
	 */
	
	var SwitchTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(SwitchTransition, _React$Component);
	
	  function SwitchTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      status: _Transition.ENTERED,
	      current: null
	    };
	    _this.appeared = false;
	
	    _this.changeState = function (status, current) {
	      if (current === void 0) {
	        current = _this.state.current;
	      }
	
	      _this.setState({
	        status: status,
	        current: current
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = SwitchTransition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.children == null) {
	      return {
	        current: null
	      };
	    }
	
	    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
	      return {
	        status: _Transition.ENTERING
	      };
	    }
	
	    if (state.current && areChildrenDifferent(state.current, props.children)) {
	      return {
	        status: _Transition.EXITING
	      };
	    }
	
	    return {
	      current: _react.default.cloneElement(props.children, {
	        in: true
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        mode = _this$props.mode,
	        _this$state = this.state,
	        status = _this$state.status,
	        current = _this$state.current;
	    var data = {
	      children: children,
	      current: current,
	      changeState: this.changeState,
	      status: status
	    };
	    var component;
	
	    switch (status) {
	      case _Transition.ENTERING:
	        component = enterRenders[mode](data);
	        break;
	
	      case _Transition.EXITING:
	        component = leaveRenders[mode](data);
	        break;
	
	      case _Transition.ENTERED:
	        component = current;
	    }
	
	    return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: {
	        isMounting: !this.appeared
	      }
	    }, component);
	  };
	
	  return SwitchTransition;
	}(_react.default.Component);
	
	SwitchTransition.propTypes =  false ? {
	  /**
	   * Transition modes.
	   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
	   * `in-out: New element transitions in first, then when complete, the current element transitions out.`
	   *
	   * @type {'out-in'|'in-out'}
	   */
	  mode: _propTypes.default.oneOf([modes.in, modes.out]),
	
	  /**
	   * Any `Transition` or `CSSTransition` component
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
	} : {};
	SwitchTransition.defaultProps = {
	  mode: modes.out
	};
	var _default = SwitchTransition;
	exports.default = _default;

/***/ }),
/* 6838 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	var _ChildMapping = __webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, _react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 6839 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	"use strict";
	
	exports.__esModule = true;
	exports.config = exports.Transition = exports.TransitionGroup = exports.SwitchTransition = exports.ReplaceTransition = exports.CSSTransition = void 0;
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	
	exports.CSSTransition = _CSSTransition.default;
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_1__));
	
	exports.ReplaceTransition = _ReplaceTransition.default;
	
	var _SwitchTransition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_2__));
	
	exports.SwitchTransition = _SwitchTransition.default;
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_3__));
	
	exports.TransitionGroup = _TransitionGroup.default;
	
	var _Transition = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_4__));
	
	exports.Transition = _Transition.default;
	
	var _config = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_5__));
	
	exports.config = _config.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.bundle.faf311cd.js